(function(e, a) { for(var i in a) e[i] = a[i]; }(window, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/accessible-scala-web/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

// This is CodeMirror (http://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.CodeMirror = factory());
}(this, (function () { 'use strict';

// Kludges for bugs and behavior differences that can't be feature
// detected are enabled based on userAgent etc sniffing.
var userAgent = navigator.userAgent;
var platform = navigator.platform;

var gecko = /gecko\/\d/i.test(userAgent);
var ie_upto10 = /MSIE \d/.test(userAgent);
var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
var edge = /Edge\/(\d+)/.exec(userAgent);
var ie = ie_upto10 || ie_11up || edge;
var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
var webkit = !edge && /WebKit\//.test(userAgent);
var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
var chrome = !edge && /Chrome\//.test(userAgent);
var presto = /Opera\//.test(userAgent);
var safari = /Apple Computer/.test(navigator.vendor);
var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
var phantom = /PhantomJS/.test(userAgent);

var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
var android = /Android/.test(userAgent);
// This is woefully incomplete. Suggestions for alternative methods welcome.
var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
var mac = ios || /Mac/.test(platform);
var chromeOS = /\bCrOS\b/.test(userAgent);
var windows = /win/i.test(platform);

var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
if (presto_version) { presto_version = Number(presto_version[1]); }
if (presto_version && presto_version >= 15) { presto = false; webkit = true; }
// Some browsers use the wrong event properties to signal cmd/ctrl on OS X
var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
var captureRightClick = gecko || (ie && ie_version >= 9);

function classTest(cls) { return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*") }

var rmClass = function(node, cls) {
  var current = node.className;
  var match = classTest(cls).exec(current);
  if (match) {
    var after = current.slice(match.index + match[0].length);
    node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
  }
};

function removeChildren(e) {
  for (var count = e.childNodes.length; count > 0; --count)
    { e.removeChild(e.firstChild); }
  return e
}

function removeChildrenAndAdd(parent, e) {
  return removeChildren(parent).appendChild(e)
}

function elt(tag, content, className, style) {
  var e = document.createElement(tag);
  if (className) { e.className = className; }
  if (style) { e.style.cssText = style; }
  if (typeof content == "string") { e.appendChild(document.createTextNode(content)); }
  else if (content) { for (var i = 0; i < content.length; ++i) { e.appendChild(content[i]); } }
  return e
}
// wrapper for elt, which removes the elt from the accessibility tree
function eltP(tag, content, className, style) {
  var e = elt(tag, content, className, style);
  e.setAttribute("role", "presentation");
  return e
}

var range;
if (document.createRange) { range = function(node, start, end, endNode) {
  var r = document.createRange();
  r.setEnd(endNode || node, end);
  r.setStart(node, start);
  return r
}; }
else { range = function(node, start, end) {
  var r = document.body.createTextRange();
  try { r.moveToElementText(node.parentNode); }
  catch(e) { return r }
  r.collapse(true);
  r.moveEnd("character", end);
  r.moveStart("character", start);
  return r
}; }

function contains(parent, child) {
  if (child.nodeType == 3) // Android browser always returns false when child is a textnode
    { child = child.parentNode; }
  if (parent.contains)
    { return parent.contains(child) }
  do {
    if (child.nodeType == 11) { child = child.host; }
    if (child == parent) { return true }
  } while (child = child.parentNode)
}

function activeElt() {
  // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
  // IE < 10 will throw when accessed while the page is loading or in an iframe.
  // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
  var activeElement;
  try {
    activeElement = document.activeElement;
  } catch(e) {
    activeElement = document.body || null;
  }
  while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)
    { activeElement = activeElement.shadowRoot.activeElement; }
  return activeElement
}

function addClass(node, cls) {
  var current = node.className;
  if (!classTest(cls).test(current)) { node.className += (current ? " " : "") + cls; }
}
function joinClasses(a, b) {
  var as = a.split(" ");
  for (var i = 0; i < as.length; i++)
    { if (as[i] && !classTest(as[i]).test(b)) { b += " " + as[i]; } }
  return b
}

var selectInput = function(node) { node.select(); };
if (ios) // Mobile Safari apparently has a bug where select() is broken.
  { selectInput = function(node) { node.selectionStart = 0; node.selectionEnd = node.value.length; }; }
else if (ie) // Suppress mysterious IE10 errors
  { selectInput = function(node) { try { node.select(); } catch(_e) {} }; }

function bind(f) {
  var args = Array.prototype.slice.call(arguments, 1);
  return function(){return f.apply(null, args)}
}

function copyObj(obj, target, overwrite) {
  if (!target) { target = {}; }
  for (var prop in obj)
    { if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop)))
      { target[prop] = obj[prop]; } }
  return target
}

// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function countColumn(string, end, tabSize, startIndex, startValue) {
  if (end == null) {
    end = string.search(/[^\s\u00a0]/);
    if (end == -1) { end = string.length; }
  }
  for (var i = startIndex || 0, n = startValue || 0;;) {
    var nextTab = string.indexOf("\t", i);
    if (nextTab < 0 || nextTab >= end)
      { return n + (end - i) }
    n += nextTab - i;
    n += tabSize - (n % tabSize);
    i = nextTab + 1;
  }
}

var Delayed = function() {this.id = null;};
Delayed.prototype.set = function (ms, f) {
  clearTimeout(this.id);
  this.id = setTimeout(f, ms);
};

function indexOf(array, elt) {
  for (var i = 0; i < array.length; ++i)
    { if (array[i] == elt) { return i } }
  return -1
}

// Number of pixels added to scroller and sizer to hide scrollbar
var scrollerGap = 30;

// Returned or thrown by various protocols to signal 'I'm not
// handling this'.
var Pass = {toString: function(){return "CodeMirror.Pass"}};

// Reused option objects for setSelection & friends
var sel_dontScroll = {scroll: false};
var sel_mouse = {origin: "*mouse"};
var sel_move = {origin: "+move"};

// The inverse of countColumn -- find the offset that corresponds to
// a particular column.
function findColumn(string, goal, tabSize) {
  for (var pos = 0, col = 0;;) {
    var nextTab = string.indexOf("\t", pos);
    if (nextTab == -1) { nextTab = string.length; }
    var skipped = nextTab - pos;
    if (nextTab == string.length || col + skipped >= goal)
      { return pos + Math.min(skipped, goal - col) }
    col += nextTab - pos;
    col += tabSize - (col % tabSize);
    pos = nextTab + 1;
    if (col >= goal) { return pos }
  }
}

var spaceStrs = [""];
function spaceStr(n) {
  while (spaceStrs.length <= n)
    { spaceStrs.push(lst(spaceStrs) + " "); }
  return spaceStrs[n]
}

function lst(arr) { return arr[arr.length-1] }

function map(array, f) {
  var out = [];
  for (var i = 0; i < array.length; i++) { out[i] = f(array[i], i); }
  return out
}

function insertSorted(array, value, score) {
  var pos = 0, priority = score(value);
  while (pos < array.length && score(array[pos]) <= priority) { pos++; }
  array.splice(pos, 0, value);
}

function nothing() {}

function createObj(base, props) {
  var inst;
  if (Object.create) {
    inst = Object.create(base);
  } else {
    nothing.prototype = base;
    inst = new nothing();
  }
  if (props) { copyObj(props, inst); }
  return inst
}

var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
function isWordCharBasic(ch) {
  return /\w/.test(ch) || ch > "\x80" &&
    (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch))
}
function isWordChar(ch, helper) {
  if (!helper) { return isWordCharBasic(ch) }
  if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) { return true }
  return helper.test(ch)
}

function isEmpty(obj) {
  for (var n in obj) { if (obj.hasOwnProperty(n) && obj[n]) { return false } }
  return true
}

// Extending unicode characters. A series of a non-extending char +
// any number of extending chars is treated as a single unit as far
// as editing and measuring is concerned. This is not fully correct,
// since some scripts/fonts/browsers also treat other configurations
// of code points as a group.
var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
function isExtendingChar(ch) { return ch.charCodeAt(0) >= 768 && extendingChars.test(ch) }

// Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
function skipExtendingChars(str, pos, dir) {
  while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) { pos += dir; }
  return pos
}

// Returns the value from the range [`from`; `to`] that satisfies
// `pred` and is closest to `from`. Assumes that at least `to`
// satisfies `pred`. Supports `from` being greater than `to`.
function findFirst(pred, from, to) {
  // At any point we are certain `to` satisfies `pred`, don't know
  // whether `from` does.
  var dir = from > to ? -1 : 1;
  for (;;) {
    if (from == to) { return from }
    var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
    if (mid == from) { return pred(mid) ? from : to }
    if (pred(mid)) { to = mid; }
    else { from = mid + dir; }
  }
}

// The display handles the DOM integration, both for input reading
// and content drawing. It holds references to DOM nodes and
// display-related state.

function Display(place, doc, input) {
  var d = this;
  this.input = input;

  // Covers bottom-right square when both scrollbars are present.
  d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
  d.scrollbarFiller.setAttribute("cm-not-content", "true");
  // Covers bottom of gutter when coverGutterNextToScrollbar is on
  // and h scrollbar is present.
  d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
  d.gutterFiller.setAttribute("cm-not-content", "true");
  // Will contain the actual code, positioned to cover the viewport.
  d.lineDiv = eltP("div", null, "CodeMirror-code");
  // Elements are added to these to represent selection and cursors.
  d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
  d.cursorDiv = elt("div", null, "CodeMirror-cursors");
  // A visibility: hidden element used to find the size of things.
  d.measure = elt("div", null, "CodeMirror-measure");
  // When lines outside of the viewport are measured, they are drawn in this.
  d.lineMeasure = elt("div", null, "CodeMirror-measure");
  // Wraps everything that needs to exist inside the vertically-padded coordinate system
  d.lineSpace = eltP("div", [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
                    null, "position: relative; outline: none");
  var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
  // Moved around its parent to cover visible view.
  d.mover = elt("div", [lines], null, "position: relative");
  // Set to the height of the document, allowing scrolling.
  d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
  d.sizerWidth = null;
  // Behavior of elts with overflow: auto and padding is
  // inconsistent across browsers. This is used to ensure the
  // scrollable area is big enough.
  d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
  // Will contain the gutters, if any.
  d.gutters = elt("div", null, "CodeMirror-gutters");
  d.lineGutter = null;
  // Actual scrollable element.
  d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
  d.scroller.setAttribute("tabIndex", "-1");
  // The element in which the editor lives.
  d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");

  // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
  if (ie && ie_version < 8) { d.gutters.style.zIndex = -1; d.scroller.style.paddingRight = 0; }
  if (!webkit && !(gecko && mobile)) { d.scroller.draggable = true; }

  if (place) {
    if (place.appendChild) { place.appendChild(d.wrapper); }
    else { place(d.wrapper); }
  }

  // Current rendered range (may be bigger than the view window).
  d.viewFrom = d.viewTo = doc.first;
  d.reportedViewFrom = d.reportedViewTo = doc.first;
  // Information about the rendered lines.
  d.view = [];
  d.renderedView = null;
  // Holds info about a single rendered line when it was rendered
  // for measurement, while not in view.
  d.externalMeasured = null;
  // Empty space (in pixels) above the view
  d.viewOffset = 0;
  d.lastWrapHeight = d.lastWrapWidth = 0;
  d.updateLineNumbers = null;

  d.nativeBarWidth = d.barHeight = d.barWidth = 0;
  d.scrollbarsClipped = false;

  // Used to only resize the line number gutter when necessary (when
  // the amount of lines crosses a boundary that makes its width change)
  d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
  // Set to true when a non-horizontal-scrolling line widget is
  // added. As an optimization, line widget aligning is skipped when
  // this is false.
  d.alignWidgets = false;

  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;

  // Tracks the maximum line length so that the horizontal scrollbar
  // can be kept static when scrolling.
  d.maxLine = null;
  d.maxLineLength = 0;
  d.maxLineChanged = false;

  // Used for measuring wheel scrolling granularity
  d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;

  // True when shift is held down.
  d.shift = false;

  // Used to track whether anything happened since the context menu
  // was opened.
  d.selForContextMenu = null;

  d.activeTouch = null;

  input.init(d);
}

// Find the line object corresponding to the given line number.
function getLine(doc, n) {
  n -= doc.first;
  if (n < 0 || n >= doc.size) { throw new Error("There is no line " + (n + doc.first) + " in the document.") }
  var chunk = doc;
  while (!chunk.lines) {
    for (var i = 0;; ++i) {
      var child = chunk.children[i], sz = child.chunkSize();
      if (n < sz) { chunk = child; break }
      n -= sz;
    }
  }
  return chunk.lines[n]
}

// Get the part of a document between two positions, as an array of
// strings.
function getBetween(doc, start, end) {
  var out = [], n = start.line;
  doc.iter(start.line, end.line + 1, function (line) {
    var text = line.text;
    if (n == end.line) { text = text.slice(0, end.ch); }
    if (n == start.line) { text = text.slice(start.ch); }
    out.push(text);
    ++n;
  });
  return out
}
// Get the lines between from and to, as array of strings.
function getLines(doc, from, to) {
  var out = [];
  doc.iter(from, to, function (line) { out.push(line.text); }); // iter aborts when callback returns truthy value
  return out
}

// Update the height of a line, propagating the height change
// upwards to parent nodes.
function updateLineHeight(line, height) {
  var diff = height - line.height;
  if (diff) { for (var n = line; n; n = n.parent) { n.height += diff; } }
}

// Given a line object, find its line number by walking up through
// its parent links.
function lineNo(line) {
  if (line.parent == null) { return null }
  var cur = line.parent, no = indexOf(cur.lines, line);
  for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
    for (var i = 0;; ++i) {
      if (chunk.children[i] == cur) { break }
      no += chunk.children[i].chunkSize();
    }
  }
  return no + cur.first
}

// Find the line at the given vertical position, using the height
// information in the document tree.
function lineAtHeight(chunk, h) {
  var n = chunk.first;
  outer: do {
    for (var i$1 = 0; i$1 < chunk.children.length; ++i$1) {
      var child = chunk.children[i$1], ch = child.height;
      if (h < ch) { chunk = child; continue outer }
      h -= ch;
      n += child.chunkSize();
    }
    return n
  } while (!chunk.lines)
  var i = 0;
  for (; i < chunk.lines.length; ++i) {
    var line = chunk.lines[i], lh = line.height;
    if (h < lh) { break }
    h -= lh;
  }
  return n + i
}

function isLine(doc, l) {return l >= doc.first && l < doc.first + doc.size}

function lineNumberFor(options, i) {
  return String(options.lineNumberFormatter(i + options.firstLineNumber))
}

// A Pos instance represents a position within the text.
function Pos(line, ch, sticky) {
  if ( sticky === void 0 ) sticky = null;

  if (!(this instanceof Pos)) { return new Pos(line, ch, sticky) }
  this.line = line;
  this.ch = ch;
  this.sticky = sticky;
}

// Compare two positions, return 0 if they are the same, a negative
// number when a is less, and a positive number otherwise.
function cmp(a, b) { return a.line - b.line || a.ch - b.ch }

function equalCursorPos(a, b) { return a.sticky == b.sticky && cmp(a, b) == 0 }

function copyPos(x) {return Pos(x.line, x.ch)}
function maxPos(a, b) { return cmp(a, b) < 0 ? b : a }
function minPos(a, b) { return cmp(a, b) < 0 ? a : b }

// Most of the external API clips given positions to make sure they
// actually exist within the document.
function clipLine(doc, n) {return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1))}
function clipPos(doc, pos) {
  if (pos.line < doc.first) { return Pos(doc.first, 0) }
  var last = doc.first + doc.size - 1;
  if (pos.line > last) { return Pos(last, getLine(doc, last).text.length) }
  return clipToLen(pos, getLine(doc, pos.line).text.length)
}
function clipToLen(pos, linelen) {
  var ch = pos.ch;
  if (ch == null || ch > linelen) { return Pos(pos.line, linelen) }
  else if (ch < 0) { return Pos(pos.line, 0) }
  else { return pos }
}
function clipPosArray(doc, array) {
  var out = [];
  for (var i = 0; i < array.length; i++) { out[i] = clipPos(doc, array[i]); }
  return out
}

// Optimize some code when these features are not used.
var sawReadOnlySpans = false;
var sawCollapsedSpans = false;

function seeReadOnlySpans() {
  sawReadOnlySpans = true;
}

function seeCollapsedSpans() {
  sawCollapsedSpans = true;
}

// TEXTMARKER SPANS

function MarkedSpan(marker, from, to) {
  this.marker = marker;
  this.from = from; this.to = to;
}

// Search an array of spans for a span matching the given marker.
function getMarkedSpanFor(spans, marker) {
  if (spans) { for (var i = 0; i < spans.length; ++i) {
    var span = spans[i];
    if (span.marker == marker) { return span }
  } }
}
// Remove a span from an array, returning undefined if no spans are
// left (we don't store arrays for lines without spans).
function removeMarkedSpan(spans, span) {
  var r;
  for (var i = 0; i < spans.length; ++i)
    { if (spans[i] != span) { (r || (r = [])).push(spans[i]); } }
  return r
}
// Add a span to a line.
function addMarkedSpan(line, span) {
  line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
  span.marker.attachLine(line);
}

// Used for the algorithm that adjusts markers for a change in the
// document. These functions cut an array of spans at a given
// character position, returning an array of remaining chunks (or
// undefined if nothing remains).
function markedSpansBefore(old, startCh, isInsert) {
  var nw;
  if (old) { for (var i = 0; i < old.length; ++i) {
    var span = old[i], marker = span.marker;
    var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
    if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
      var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);(nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
    }
  } }
  return nw
}
function markedSpansAfter(old, endCh, isInsert) {
  var nw;
  if (old) { for (var i = 0; i < old.length; ++i) {
    var span = old[i], marker = span.marker;
    var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
    if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
      var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);(nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh,
                                            span.to == null ? null : span.to - endCh));
    }
  } }
  return nw
}

// Given a change object, compute the new set of marker spans that
// cover the line in which the change took place. Removes spans
// entirely within the change, reconnects spans belonging to the
// same marker that appear on both sides of the change, and cuts off
// spans partially within the change. Returns an array of span
// arrays with one element for each line in (after) the change.
function stretchSpansOverChange(doc, change) {
  if (change.full) { return null }
  var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
  var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
  if (!oldFirst && !oldLast) { return null }

  var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
  // Get the spans that 'stick out' on both sides
  var first = markedSpansBefore(oldFirst, startCh, isInsert);
  var last = markedSpansAfter(oldLast, endCh, isInsert);

  // Next, merge those two ends
  var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
  if (first) {
    // Fix up .to properties of first
    for (var i = 0; i < first.length; ++i) {
      var span = first[i];
      if (span.to == null) {
        var found = getMarkedSpanFor(last, span.marker);
        if (!found) { span.to = startCh; }
        else if (sameLine) { span.to = found.to == null ? null : found.to + offset; }
      }
    }
  }
  if (last) {
    // Fix up .from in last (or move them into first in case of sameLine)
    for (var i$1 = 0; i$1 < last.length; ++i$1) {
      var span$1 = last[i$1];
      if (span$1.to != null) { span$1.to += offset; }
      if (span$1.from == null) {
        var found$1 = getMarkedSpanFor(first, span$1.marker);
        if (!found$1) {
          span$1.from = offset;
          if (sameLine) { (first || (first = [])).push(span$1); }
        }
      } else {
        span$1.from += offset;
        if (sameLine) { (first || (first = [])).push(span$1); }
      }
    }
  }
  // Make sure we didn't create any zero-length spans
  if (first) { first = clearEmptySpans(first); }
  if (last && last != first) { last = clearEmptySpans(last); }

  var newMarkers = [first];
  if (!sameLine) {
    // Fill gap with whole-line-spans
    var gap = change.text.length - 2, gapMarkers;
    if (gap > 0 && first)
      { for (var i$2 = 0; i$2 < first.length; ++i$2)
        { if (first[i$2].to == null)
          { (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null)); } } }
    for (var i$3 = 0; i$3 < gap; ++i$3)
      { newMarkers.push(gapMarkers); }
    newMarkers.push(last);
  }
  return newMarkers
}

// Remove spans that are empty and don't have a clearWhenEmpty
// option of false.
function clearEmptySpans(spans) {
  for (var i = 0; i < spans.length; ++i) {
    var span = spans[i];
    if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false)
      { spans.splice(i--, 1); }
  }
  if (!spans.length) { return null }
  return spans
}

// Used to 'clip' out readOnly ranges when making a change.
function removeReadOnlyRanges(doc, from, to) {
  var markers = null;
  doc.iter(from.line, to.line + 1, function (line) {
    if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
      var mark = line.markedSpans[i].marker;
      if (mark.readOnly && (!markers || indexOf(markers, mark) == -1))
        { (markers || (markers = [])).push(mark); }
    } }
  });
  if (!markers) { return null }
  var parts = [{from: from, to: to}];
  for (var i = 0; i < markers.length; ++i) {
    var mk = markers[i], m = mk.find(0);
    for (var j = 0; j < parts.length; ++j) {
      var p = parts[j];
      if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) { continue }
      var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
      if (dfrom < 0 || !mk.inclusiveLeft && !dfrom)
        { newParts.push({from: p.from, to: m.from}); }
      if (dto > 0 || !mk.inclusiveRight && !dto)
        { newParts.push({from: m.to, to: p.to}); }
      parts.splice.apply(parts, newParts);
      j += newParts.length - 3;
    }
  }
  return parts
}

// Connect or disconnect spans from a line.
function detachMarkedSpans(line) {
  var spans = line.markedSpans;
  if (!spans) { return }
  for (var i = 0; i < spans.length; ++i)
    { spans[i].marker.detachLine(line); }
  line.markedSpans = null;
}
function attachMarkedSpans(line, spans) {
  if (!spans) { return }
  for (var i = 0; i < spans.length; ++i)
    { spans[i].marker.attachLine(line); }
  line.markedSpans = spans;
}

// Helpers used when computing which overlapping collapsed span
// counts as the larger one.
function extraLeft(marker) { return marker.inclusiveLeft ? -1 : 0 }
function extraRight(marker) { return marker.inclusiveRight ? 1 : 0 }

// Returns a number indicating which of two overlapping collapsed
// spans is larger (and thus includes the other). Falls back to
// comparing ids when the spans cover exactly the same range.
function compareCollapsedMarkers(a, b) {
  var lenDiff = a.lines.length - b.lines.length;
  if (lenDiff != 0) { return lenDiff }
  var aPos = a.find(), bPos = b.find();
  var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
  if (fromCmp) { return -fromCmp }
  var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
  if (toCmp) { return toCmp }
  return b.id - a.id
}

// Find out whether a line ends or starts in a collapsed span. If
// so, return the marker for that span.
function collapsedSpanAtSide(line, start) {
  var sps = sawCollapsedSpans && line.markedSpans, found;
  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
    sp = sps[i];
    if (sp.marker.collapsed && (start ? sp.from : sp.to) == null &&
        (!found || compareCollapsedMarkers(found, sp.marker) < 0))
      { found = sp.marker; }
  } }
  return found
}
function collapsedSpanAtStart(line) { return collapsedSpanAtSide(line, true) }
function collapsedSpanAtEnd(line) { return collapsedSpanAtSide(line, false) }

// Test whether there exists a collapsed span that partially
// overlaps (covers the start or end, but not both) of a new span.
// Such overlap is not allowed.
function conflictingCollapsedRange(doc, lineNo$$1, from, to, marker) {
  var line = getLine(doc, lineNo$$1);
  var sps = sawCollapsedSpans && line.markedSpans;
  if (sps) { for (var i = 0; i < sps.length; ++i) {
    var sp = sps[i];
    if (!sp.marker.collapsed) { continue }
    var found = sp.marker.find(0);
    var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
    var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
    if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) { continue }
    if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) ||
        fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0))
      { return true }
  } }
}

// A visual line is a line as drawn on the screen. Folding, for
// example, can cause multiple logical lines to appear on the same
// visual line. This finds the start of the visual line that the
// given line is part of (usually that is the line itself).
function visualLine(line) {
  var merged;
  while (merged = collapsedSpanAtStart(line))
    { line = merged.find(-1, true).line; }
  return line
}

function visualLineEnd(line) {
  var merged;
  while (merged = collapsedSpanAtEnd(line))
    { line = merged.find(1, true).line; }
  return line
}

// Returns an array of logical lines that continue the visual line
// started by the argument, or undefined if there are no such lines.
function visualLineContinued(line) {
  var merged, lines;
  while (merged = collapsedSpanAtEnd(line)) {
    line = merged.find(1, true).line
    ;(lines || (lines = [])).push(line);
  }
  return lines
}

// Get the line number of the start of the visual line that the
// given line number is part of.
function visualLineNo(doc, lineN) {
  var line = getLine(doc, lineN), vis = visualLine(line);
  if (line == vis) { return lineN }
  return lineNo(vis)
}

// Get the line number of the start of the next visual line after
// the given line.
function visualLineEndNo(doc, lineN) {
  if (lineN > doc.lastLine()) { return lineN }
  var line = getLine(doc, lineN), merged;
  if (!lineIsHidden(doc, line)) { return lineN }
  while (merged = collapsedSpanAtEnd(line))
    { line = merged.find(1, true).line; }
  return lineNo(line) + 1
}

// Compute whether a line is hidden. Lines count as hidden when they
// are part of a visual line that starts with another line, or when
// they are entirely covered by collapsed, non-widget span.
function lineIsHidden(doc, line) {
  var sps = sawCollapsedSpans && line.markedSpans;
  if (sps) { for (var sp = (void 0), i = 0; i < sps.length; ++i) {
    sp = sps[i];
    if (!sp.marker.collapsed) { continue }
    if (sp.from == null) { return true }
    if (sp.marker.widgetNode) { continue }
    if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp))
      { return true }
  } }
}
function lineIsHiddenInner(doc, line, span) {
  if (span.to == null) {
    var end = span.marker.find(1, true);
    return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker))
  }
  if (span.marker.inclusiveRight && span.to == line.text.length)
    { return true }
  for (var sp = (void 0), i = 0; i < line.markedSpans.length; ++i) {
    sp = line.markedSpans[i];
    if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to &&
        (sp.to == null || sp.to != span.from) &&
        (sp.marker.inclusiveLeft || span.marker.inclusiveRight) &&
        lineIsHiddenInner(doc, line, sp)) { return true }
  }
}

// Find the height above the given line.
function heightAtLine(lineObj) {
  lineObj = visualLine(lineObj);

  var h = 0, chunk = lineObj.parent;
  for (var i = 0; i < chunk.lines.length; ++i) {
    var line = chunk.lines[i];
    if (line == lineObj) { break }
    else { h += line.height; }
  }
  for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
    for (var i$1 = 0; i$1 < p.children.length; ++i$1) {
      var cur = p.children[i$1];
      if (cur == chunk) { break }
      else { h += cur.height; }
    }
  }
  return h
}

// Compute the character length of a line, taking into account
// collapsed ranges (see markText) that might hide parts, and join
// other lines onto it.
function lineLength(line) {
  if (line.height == 0) { return 0 }
  var len = line.text.length, merged, cur = line;
  while (merged = collapsedSpanAtStart(cur)) {
    var found = merged.find(0, true);
    cur = found.from.line;
    len += found.from.ch - found.to.ch;
  }
  cur = line;
  while (merged = collapsedSpanAtEnd(cur)) {
    var found$1 = merged.find(0, true);
    len -= cur.text.length - found$1.from.ch;
    cur = found$1.to.line;
    len += cur.text.length - found$1.to.ch;
  }
  return len
}

// Find the longest line in the document.
function findMaxLine(cm) {
  var d = cm.display, doc = cm.doc;
  d.maxLine = getLine(doc, doc.first);
  d.maxLineLength = lineLength(d.maxLine);
  d.maxLineChanged = true;
  doc.iter(function (line) {
    var len = lineLength(line);
    if (len > d.maxLineLength) {
      d.maxLineLength = len;
      d.maxLine = line;
    }
  });
}

// BIDI HELPERS

function iterateBidiSections(order, from, to, f) {
  if (!order) { return f(from, to, "ltr", 0) }
  var found = false;
  for (var i = 0; i < order.length; ++i) {
    var part = order[i];
    if (part.from < to && part.to > from || from == to && part.to == from) {
      f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
      found = true;
    }
  }
  if (!found) { f(from, to, "ltr"); }
}

var bidiOther = null;
function getBidiPartAt(order, ch, sticky) {
  var found;
  bidiOther = null;
  for (var i = 0; i < order.length; ++i) {
    var cur = order[i];
    if (cur.from < ch && cur.to > ch) { return i }
    if (cur.to == ch) {
      if (cur.from != cur.to && sticky == "before") { found = i; }
      else { bidiOther = i; }
    }
    if (cur.from == ch) {
      if (cur.from != cur.to && sticky != "before") { found = i; }
      else { bidiOther = i; }
    }
  }
  return found != null ? found : bidiOther
}

// Bidirectional ordering algorithm
// See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
// that this (partially) implements.

// One-char codes used for character types:
// L (L):   Left-to-Right
// R (R):   Right-to-Left
// r (AL):  Right-to-Left Arabic
// 1 (EN):  European Number
// + (ES):  European Number Separator
// % (ET):  European Number Terminator
// n (AN):  Arabic Number
// , (CS):  Common Number Separator
// m (NSM): Non-Spacing Mark
// b (BN):  Boundary Neutral
// s (B):   Paragraph Separator
// t (S):   Segment Separator
// w (WS):  Whitespace
// N (ON):  Other Neutrals

// Returns null if characters are ordered as they appear
// (left-to-right), or an array of sections ({from, to, level}
// objects) in the order in which they occur visually.
var bidiOrdering = (function() {
  // Character types for codepoints 0 to 0xff
  var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
  // Character types for codepoints 0x600 to 0x6f9
  var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
  function charType(code) {
    if (code <= 0xf7) { return lowTypes.charAt(code) }
    else if (0x590 <= code && code <= 0x5f4) { return "R" }
    else if (0x600 <= code && code <= 0x6f9) { return arabicTypes.charAt(code - 0x600) }
    else if (0x6ee <= code && code <= 0x8ac) { return "r" }
    else if (0x2000 <= code && code <= 0x200b) { return "w" }
    else if (code == 0x200c) { return "b" }
    else { return "L" }
  }

  var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
  var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;

  function BidiSpan(level, from, to) {
    this.level = level;
    this.from = from; this.to = to;
  }

  return function(str, direction) {
    var outerType = direction == "ltr" ? "L" : "R";

    if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) { return false }
    var len = str.length, types = [];
    for (var i = 0; i < len; ++i)
      { types.push(charType(str.charCodeAt(i))); }

    // W1. Examine each non-spacing mark (NSM) in the level run, and
    // change the type of the NSM to the type of the previous
    // character. If the NSM is at the start of the level run, it will
    // get the type of sor.
    for (var i$1 = 0, prev = outerType; i$1 < len; ++i$1) {
      var type = types[i$1];
      if (type == "m") { types[i$1] = prev; }
      else { prev = type; }
    }

    // W2. Search backwards from each instance of a European number
    // until the first strong type (R, L, AL, or sor) is found. If an
    // AL is found, change the type of the European number to Arabic
    // number.
    // W3. Change all ALs to R.
    for (var i$2 = 0, cur = outerType; i$2 < len; ++i$2) {
      var type$1 = types[i$2];
      if (type$1 == "1" && cur == "r") { types[i$2] = "n"; }
      else if (isStrong.test(type$1)) { cur = type$1; if (type$1 == "r") { types[i$2] = "R"; } }
    }

    // W4. A single European separator between two European numbers
    // changes to a European number. A single common separator between
    // two numbers of the same type changes to that type.
    for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
      var type$2 = types[i$3];
      if (type$2 == "+" && prev$1 == "1" && types[i$3+1] == "1") { types[i$3] = "1"; }
      else if (type$2 == "," && prev$1 == types[i$3+1] &&
               (prev$1 == "1" || prev$1 == "n")) { types[i$3] = prev$1; }
      prev$1 = type$2;
    }

    // W5. A sequence of European terminators adjacent to European
    // numbers changes to all European numbers.
    // W6. Otherwise, separators and terminators change to Other
    // Neutral.
    for (var i$4 = 0; i$4 < len; ++i$4) {
      var type$3 = types[i$4];
      if (type$3 == ",") { types[i$4] = "N"; }
      else if (type$3 == "%") {
        var end = (void 0);
        for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {}
        var replace = (i$4 && types[i$4-1] == "!") || (end < len && types[end] == "1") ? "1" : "N";
        for (var j = i$4; j < end; ++j) { types[j] = replace; }
        i$4 = end - 1;
      }
    }

    // W7. Search backwards from each instance of a European number
    // until the first strong type (R, L, or sor) is found. If an L is
    // found, then change the type of the European number to L.
    for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
      var type$4 = types[i$5];
      if (cur$1 == "L" && type$4 == "1") { types[i$5] = "L"; }
      else if (isStrong.test(type$4)) { cur$1 = type$4; }
    }

    // N1. A sequence of neutrals takes the direction of the
    // surrounding strong text if the text on both sides has the same
    // direction. European and Arabic numbers act as if they were R in
    // terms of their influence on neutrals. Start-of-level-run (sor)
    // and end-of-level-run (eor) are used at level run boundaries.
    // N2. Any remaining neutrals take the embedding direction.
    for (var i$6 = 0; i$6 < len; ++i$6) {
      if (isNeutral.test(types[i$6])) {
        var end$1 = (void 0);
        for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {}
        var before = (i$6 ? types[i$6-1] : outerType) == "L";
        var after = (end$1 < len ? types[end$1] : outerType) == "L";
        var replace$1 = before == after ? (before ? "L" : "R") : outerType;
        for (var j$1 = i$6; j$1 < end$1; ++j$1) { types[j$1] = replace$1; }
        i$6 = end$1 - 1;
      }
    }

    // Here we depart from the documented algorithm, in order to avoid
    // building up an actual levels array. Since there are only three
    // levels (0, 1, 2) in an implementation that doesn't take
    // explicit embedding into account, we can build up the order on
    // the fly, without following the level-based algorithm.
    var order = [], m;
    for (var i$7 = 0; i$7 < len;) {
      if (countsAsLeft.test(types[i$7])) {
        var start = i$7;
        for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {}
        order.push(new BidiSpan(0, start, i$7));
      } else {
        var pos = i$7, at = order.length;
        for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {}
        for (var j$2 = pos; j$2 < i$7;) {
          if (countsAsNum.test(types[j$2])) {
            if (pos < j$2) { order.splice(at, 0, new BidiSpan(1, pos, j$2)); }
            var nstart = j$2;
            for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {}
            order.splice(at, 0, new BidiSpan(2, nstart, j$2));
            pos = j$2;
          } else { ++j$2; }
        }
        if (pos < i$7) { order.splice(at, 0, new BidiSpan(1, pos, i$7)); }
      }
    }
    if (direction == "ltr") {
      if (order[0].level == 1 && (m = str.match(/^\s+/))) {
        order[0].from = m[0].length;
        order.unshift(new BidiSpan(0, 0, m[0].length));
      }
      if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
        lst(order).to -= m[0].length;
        order.push(new BidiSpan(0, len - m[0].length, len));
      }
    }

    return direction == "rtl" ? order.reverse() : order
  }
})();

// Get the bidi ordering for the given line (and cache it). Returns
// false for lines that are fully left-to-right, and an array of
// BidiSpan objects otherwise.
function getOrder(line, direction) {
  var order = line.order;
  if (order == null) { order = line.order = bidiOrdering(line.text, direction); }
  return order
}

// EVENT HANDLING

// Lightweight event framework. on/off also work on DOM nodes,
// registering native DOM handlers.

var noHandlers = [];

var on = function(emitter, type, f) {
  if (emitter.addEventListener) {
    emitter.addEventListener(type, f, false);
  } else if (emitter.attachEvent) {
    emitter.attachEvent("on" + type, f);
  } else {
    var map$$1 = emitter._handlers || (emitter._handlers = {});
    map$$1[type] = (map$$1[type] || noHandlers).concat(f);
  }
};

function getHandlers(emitter, type) {
  return emitter._handlers && emitter._handlers[type] || noHandlers
}

function off(emitter, type, f) {
  if (emitter.removeEventListener) {
    emitter.removeEventListener(type, f, false);
  } else if (emitter.detachEvent) {
    emitter.detachEvent("on" + type, f);
  } else {
    var map$$1 = emitter._handlers, arr = map$$1 && map$$1[type];
    if (arr) {
      var index = indexOf(arr, f);
      if (index > -1)
        { map$$1[type] = arr.slice(0, index).concat(arr.slice(index + 1)); }
    }
  }
}

function signal(emitter, type /*, values...*/) {
  var handlers = getHandlers(emitter, type);
  if (!handlers.length) { return }
  var args = Array.prototype.slice.call(arguments, 2);
  for (var i = 0; i < handlers.length; ++i) { handlers[i].apply(null, args); }
}

// The DOM events that CodeMirror handles can be overridden by
// registering a (non-DOM) handler on the editor for the event name,
// and preventDefault-ing the event in that handler.
function signalDOMEvent(cm, e, override) {
  if (typeof e == "string")
    { e = {type: e, preventDefault: function() { this.defaultPrevented = true; }}; }
  signal(cm, override || e.type, cm, e);
  return e_defaultPrevented(e) || e.codemirrorIgnore
}

function signalCursorActivity(cm) {
  var arr = cm._handlers && cm._handlers.cursorActivity;
  if (!arr) { return }
  var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
  for (var i = 0; i < arr.length; ++i) { if (indexOf(set, arr[i]) == -1)
    { set.push(arr[i]); } }
}

function hasHandler(emitter, type) {
  return getHandlers(emitter, type).length > 0
}

// Add on and off methods to a constructor's prototype, to make
// registering events on such objects more convenient.
function eventMixin(ctor) {
  ctor.prototype.on = function(type, f) {on(this, type, f);};
  ctor.prototype.off = function(type, f) {off(this, type, f);};
}

// Due to the fact that we still support jurassic IE versions, some
// compatibility wrappers are needed.

function e_preventDefault(e) {
  if (e.preventDefault) { e.preventDefault(); }
  else { e.returnValue = false; }
}
function e_stopPropagation(e) {
  if (e.stopPropagation) { e.stopPropagation(); }
  else { e.cancelBubble = true; }
}
function e_defaultPrevented(e) {
  return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false
}
function e_stop(e) {e_preventDefault(e); e_stopPropagation(e);}

function e_target(e) {return e.target || e.srcElement}
function e_button(e) {
  var b = e.which;
  if (b == null) {
    if (e.button & 1) { b = 1; }
    else if (e.button & 2) { b = 3; }
    else if (e.button & 4) { b = 2; }
  }
  if (mac && e.ctrlKey && b == 1) { b = 3; }
  return b
}

// Detect drag-and-drop
var dragAndDrop = function() {
  // There is *some* kind of drag-and-drop support in IE6-8, but I
  // couldn't get it to work yet.
  if (ie && ie_version < 9) { return false }
  var div = elt('div');
  return "draggable" in div || "dragDrop" in div
}();

var zwspSupported;
function zeroWidthElement(measure) {
  if (zwspSupported == null) {
    var test = elt("span", "\u200b");
    removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
    if (measure.firstChild.offsetHeight != 0)
      { zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8); }
  }
  var node = zwspSupported ? elt("span", "\u200b") :
    elt("span", "\u00a0", null, "display: inline-block; width: 1px; margin-right: -1px");
  node.setAttribute("cm-text", "");
  return node
}

// Feature-detect IE's crummy client rect reporting for bidi text
var badBidiRects;
function hasBadBidiRects(measure) {
  if (badBidiRects != null) { return badBidiRects }
  var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062eA"));
  var r0 = range(txt, 0, 1).getBoundingClientRect();
  var r1 = range(txt, 1, 2).getBoundingClientRect();
  removeChildren(measure);
  if (!r0 || r0.left == r0.right) { return false } // Safari returns null in some cases (#2780)
  return badBidiRects = (r1.right - r0.right < 3)
}

// See if "".split is the broken IE version, if so, provide an
// alternative way to split lines.
var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function (string) {
  var pos = 0, result = [], l = string.length;
  while (pos <= l) {
    var nl = string.indexOf("\n", pos);
    if (nl == -1) { nl = string.length; }
    var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
    var rt = line.indexOf("\r");
    if (rt != -1) {
      result.push(line.slice(0, rt));
      pos += rt + 1;
    } else {
      result.push(line);
      pos = nl + 1;
    }
  }
  return result
} : function (string) { return string.split(/\r\n?|\n/); };

var hasSelection = window.getSelection ? function (te) {
  try { return te.selectionStart != te.selectionEnd }
  catch(e) { return false }
} : function (te) {
  var range$$1;
  try {range$$1 = te.ownerDocument.selection.createRange();}
  catch(e) {}
  if (!range$$1 || range$$1.parentElement() != te) { return false }
  return range$$1.compareEndPoints("StartToEnd", range$$1) != 0
};

var hasCopyEvent = (function () {
  var e = elt("div");
  if ("oncopy" in e) { return true }
  e.setAttribute("oncopy", "return;");
  return typeof e.oncopy == "function"
})();

var badZoomedRects = null;
function hasBadZoomedRects(measure) {
  if (badZoomedRects != null) { return badZoomedRects }
  var node = removeChildrenAndAdd(measure, elt("span", "x"));
  var normal = node.getBoundingClientRect();
  var fromRange = range(node, 0, 1).getBoundingClientRect();
  return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1
}

// Known modes, by name and by MIME
var modes = {};
var mimeModes = {};

// Extra arguments are stored as the mode's dependencies, which is
// used by (legacy) mechanisms like loadmode.js to automatically
// load a mode. (Preferred mechanism is the require/define calls.)
function defineMode(name, mode) {
  if (arguments.length > 2)
    { mode.dependencies = Array.prototype.slice.call(arguments, 2); }
  modes[name] = mode;
}

function defineMIME(mime, spec) {
  mimeModes[mime] = spec;
}

// Given a MIME type, a {name, ...options} config object, or a name
// string, return a mode config object.
function resolveMode(spec) {
  if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
    spec = mimeModes[spec];
  } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
    var found = mimeModes[spec.name];
    if (typeof found == "string") { found = {name: found}; }
    spec = createObj(found, spec);
    spec.name = found.name;
  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
    return resolveMode("application/xml")
  } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
    return resolveMode("application/json")
  }
  if (typeof spec == "string") { return {name: spec} }
  else { return spec || {name: "null"} }
}

// Given a mode spec (anything that resolveMode accepts), find and
// initialize an actual mode object.
function getMode(options, spec) {
  spec = resolveMode(spec);
  var mfactory = modes[spec.name];
  if (!mfactory) { return getMode(options, "text/plain") }
  var modeObj = mfactory(options, spec);
  if (modeExtensions.hasOwnProperty(spec.name)) {
    var exts = modeExtensions[spec.name];
    for (var prop in exts) {
      if (!exts.hasOwnProperty(prop)) { continue }
      if (modeObj.hasOwnProperty(prop)) { modeObj["_" + prop] = modeObj[prop]; }
      modeObj[prop] = exts[prop];
    }
  }
  modeObj.name = spec.name;
  if (spec.helperType) { modeObj.helperType = spec.helperType; }
  if (spec.modeProps) { for (var prop$1 in spec.modeProps)
    { modeObj[prop$1] = spec.modeProps[prop$1]; } }

  return modeObj
}

// This can be used to attach properties to mode objects from
// outside the actual mode definition.
var modeExtensions = {};
function extendMode(mode, properties) {
  var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : (modeExtensions[mode] = {});
  copyObj(properties, exts);
}

function copyState(mode, state) {
  if (state === true) { return state }
  if (mode.copyState) { return mode.copyState(state) }
  var nstate = {};
  for (var n in state) {
    var val = state[n];
    if (val instanceof Array) { val = val.concat([]); }
    nstate[n] = val;
  }
  return nstate
}

// Given a mode and a state (for that mode), find the inner mode and
// state at the position that the state refers to.
function innerMode(mode, state) {
  var info;
  while (mode.innerMode) {
    info = mode.innerMode(state);
    if (!info || info.mode == mode) { break }
    state = info.state;
    mode = info.mode;
  }
  return info || {mode: mode, state: state}
}

function startState(mode, a1, a2) {
  return mode.startState ? mode.startState(a1, a2) : true
}

// STRING STREAM

// Fed to the mode parsers, provides helper functions to make
// parsers more succinct.

var StringStream = function(string, tabSize, lineOracle) {
  this.pos = this.start = 0;
  this.string = string;
  this.tabSize = tabSize || 8;
  this.lastColumnPos = this.lastColumnValue = 0;
  this.lineStart = 0;
  this.lineOracle = lineOracle;
};

StringStream.prototype.eol = function () {return this.pos >= this.string.length};
StringStream.prototype.sol = function () {return this.pos == this.lineStart};
StringStream.prototype.peek = function () {return this.string.charAt(this.pos) || undefined};
StringStream.prototype.next = function () {
  if (this.pos < this.string.length)
    { return this.string.charAt(this.pos++) }
};
StringStream.prototype.eat = function (match) {
  var ch = this.string.charAt(this.pos);
  var ok;
  if (typeof match == "string") { ok = ch == match; }
  else { ok = ch && (match.test ? match.test(ch) : match(ch)); }
  if (ok) {++this.pos; return ch}
};
StringStream.prototype.eatWhile = function (match) {
  var start = this.pos;
  while (this.eat(match)){}
  return this.pos > start
};
StringStream.prototype.eatSpace = function () {
    var this$1 = this;

  var start = this.pos;
  while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) { ++this$1.pos; }
  return this.pos > start
};
StringStream.prototype.skipToEnd = function () {this.pos = this.string.length;};
StringStream.prototype.skipTo = function (ch) {
  var found = this.string.indexOf(ch, this.pos);
  if (found > -1) {this.pos = found; return true}
};
StringStream.prototype.backUp = function (n) {this.pos -= n;};
StringStream.prototype.column = function () {
  if (this.lastColumnPos < this.start) {
    this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
    this.lastColumnPos = this.start;
  }
  return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
};
StringStream.prototype.indentation = function () {
  return countColumn(this.string, null, this.tabSize) -
    (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0)
};
StringStream.prototype.match = function (pattern, consume, caseInsensitive) {
  if (typeof pattern == "string") {
    var cased = function (str) { return caseInsensitive ? str.toLowerCase() : str; };
    var substr = this.string.substr(this.pos, pattern.length);
    if (cased(substr) == cased(pattern)) {
      if (consume !== false) { this.pos += pattern.length; }
      return true
    }
  } else {
    var match = this.string.slice(this.pos).match(pattern);
    if (match && match.index > 0) { return null }
    if (match && consume !== false) { this.pos += match[0].length; }
    return match
  }
};
StringStream.prototype.current = function (){return this.string.slice(this.start, this.pos)};
StringStream.prototype.hideFirstChars = function (n, inner) {
  this.lineStart += n;
  try { return inner() }
  finally { this.lineStart -= n; }
};
StringStream.prototype.lookAhead = function (n) {
  var oracle = this.lineOracle;
  return oracle && oracle.lookAhead(n)
};
StringStream.prototype.baseToken = function () {
  var oracle = this.lineOracle;
  return oracle && oracle.baseToken(this.pos)
};

var SavedContext = function(state, lookAhead) {
  this.state = state;
  this.lookAhead = lookAhead;
};

var Context = function(doc, state, line, lookAhead) {
  this.state = state;
  this.doc = doc;
  this.line = line;
  this.maxLookAhead = lookAhead || 0;
  this.baseTokens = null;
  this.baseTokenPos = 1;
};

Context.prototype.lookAhead = function (n) {
  var line = this.doc.getLine(this.line + n);
  if (line != null && n > this.maxLookAhead) { this.maxLookAhead = n; }
  return line
};

Context.prototype.baseToken = function (n) {
    var this$1 = this;

  if (!this.baseTokens) { return null }
  while (this.baseTokens[this.baseTokenPos] <= n)
    { this$1.baseTokenPos += 2; }
  var type = this.baseTokens[this.baseTokenPos + 1];
  return {type: type && type.replace(/( |^)overlay .*/, ""),
          size: this.baseTokens[this.baseTokenPos] - n}
};

Context.prototype.nextLine = function () {
  this.line++;
  if (this.maxLookAhead > 0) { this.maxLookAhead--; }
};

Context.fromSaved = function (doc, saved, line) {
  if (saved instanceof SavedContext)
    { return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead) }
  else
    { return new Context(doc, copyState(doc.mode, saved), line) }
};

Context.prototype.save = function (copy) {
  var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
  return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state
};


// Compute a style array (an array starting with a mode generation
// -- for invalidation -- followed by pairs of end positions and
// style strings), which is used to highlight the tokens on the
// line.
function highlightLine(cm, line, context, forceToEnd) {
  // A styles array always starts with a number identifying the
  // mode/overlays that it is based on (for easy invalidation).
  var st = [cm.state.modeGen], lineClasses = {};
  // Compute the base array of styles
  runMode(cm, line.text, cm.doc.mode, context, function (end, style) { return st.push(end, style); },
          lineClasses, forceToEnd);
  var state = context.state;

  // Run overlays, adjust style array.
  var loop = function ( o ) {
    context.baseTokens = st;
    var overlay = cm.state.overlays[o], i = 1, at = 0;
    context.state = true;
    runMode(cm, line.text, overlay.mode, context, function (end, style) {
      var start = i;
      // Ensure there's a token end at the current position, and that i points at it
      while (at < end) {
        var i_end = st[i];
        if (i_end > end)
          { st.splice(i, 1, end, st[i+1], i_end); }
        i += 2;
        at = Math.min(end, i_end);
      }
      if (!style) { return }
      if (overlay.opaque) {
        st.splice(start, i - start, end, "overlay " + style);
        i = start + 2;
      } else {
        for (; start < i; start += 2) {
          var cur = st[start+1];
          st[start+1] = (cur ? cur + " " : "") + "overlay " + style;
        }
      }
    }, lineClasses);
    context.state = state;
    context.baseTokens = null;
    context.baseTokenPos = 1;
  };

  for (var o = 0; o < cm.state.overlays.length; ++o) loop( o );

  return {styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null}
}

function getLineStyles(cm, line, updateFrontier) {
  if (!line.styles || line.styles[0] != cm.state.modeGen) {
    var context = getContextBefore(cm, lineNo(line));
    var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
    var result = highlightLine(cm, line, context);
    if (resetState) { context.state = resetState; }
    line.stateAfter = context.save(!resetState);
    line.styles = result.styles;
    if (result.classes) { line.styleClasses = result.classes; }
    else if (line.styleClasses) { line.styleClasses = null; }
    if (updateFrontier === cm.doc.highlightFrontier)
      { cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier); }
  }
  return line.styles
}

function getContextBefore(cm, n, precise) {
  var doc = cm.doc, display = cm.display;
  if (!doc.mode.startState) { return new Context(doc, true, n) }
  var start = findStartLine(cm, n, precise);
  var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
  var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);

  doc.iter(start, n, function (line) {
    processLine(cm, line.text, context);
    var pos = context.line;
    line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
    context.nextLine();
  });
  if (precise) { doc.modeFrontier = context.line; }
  return context
}

// Lightweight form of highlight -- proceed over this line and
// update state, but don't save a style array. Used for lines that
// aren't currently visible.
function processLine(cm, text, context, startAt) {
  var mode = cm.doc.mode;
  var stream = new StringStream(text, cm.options.tabSize, context);
  stream.start = stream.pos = startAt || 0;
  if (text == "") { callBlankLine(mode, context.state); }
  while (!stream.eol()) {
    readToken(mode, stream, context.state);
    stream.start = stream.pos;
  }
}

function callBlankLine(mode, state) {
  if (mode.blankLine) { return mode.blankLine(state) }
  if (!mode.innerMode) { return }
  var inner = innerMode(mode, state);
  if (inner.mode.blankLine) { return inner.mode.blankLine(inner.state) }
}

function readToken(mode, stream, state, inner) {
  for (var i = 0; i < 10; i++) {
    if (inner) { inner[0] = innerMode(mode, state).mode; }
    var style = mode.token(stream, state);
    if (stream.pos > stream.start) { return style }
  }
  throw new Error("Mode " + mode.name + " failed to advance stream.")
}

var Token = function(stream, type, state) {
  this.start = stream.start; this.end = stream.pos;
  this.string = stream.current();
  this.type = type || null;
  this.state = state;
};

// Utility for getTokenAt and getLineTokens
function takeToken(cm, pos, precise, asArray) {
  var doc = cm.doc, mode = doc.mode, style;
  pos = clipPos(doc, pos);
  var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
  var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
  if (asArray) { tokens = []; }
  while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
    stream.start = stream.pos;
    style = readToken(mode, stream, context.state);
    if (asArray) { tokens.push(new Token(stream, style, copyState(doc.mode, context.state))); }
  }
  return asArray ? tokens : new Token(stream, style, context.state)
}

function extractLineClasses(type, output) {
  if (type) { for (;;) {
    var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
    if (!lineClass) { break }
    type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
    var prop = lineClass[1] ? "bgClass" : "textClass";
    if (output[prop] == null)
      { output[prop] = lineClass[2]; }
    else if (!(new RegExp("(?:^|\s)" + lineClass[2] + "(?:$|\s)")).test(output[prop]))
      { output[prop] += " " + lineClass[2]; }
  } }
  return type
}

// Run the given mode's parser over a line, calling f for each token.
function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
  var flattenSpans = mode.flattenSpans;
  if (flattenSpans == null) { flattenSpans = cm.options.flattenSpans; }
  var curStart = 0, curStyle = null;
  var stream = new StringStream(text, cm.options.tabSize, context), style;
  var inner = cm.options.addModeClass && [null];
  if (text == "") { extractLineClasses(callBlankLine(mode, context.state), lineClasses); }
  while (!stream.eol()) {
    if (stream.pos > cm.options.maxHighlightLength) {
      flattenSpans = false;
      if (forceToEnd) { processLine(cm, text, context, stream.pos); }
      stream.pos = text.length;
      style = null;
    } else {
      style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
    }
    if (inner) {
      var mName = inner[0].name;
      if (mName) { style = "m-" + (style ? mName + " " + style : mName); }
    }
    if (!flattenSpans || curStyle != style) {
      while (curStart < stream.start) {
        curStart = Math.min(stream.start, curStart + 5000);
        f(curStart, curStyle);
      }
      curStyle = style;
    }
    stream.start = stream.pos;
  }
  while (curStart < stream.pos) {
    // Webkit seems to refuse to render text nodes longer than 57444
    // characters, and returns inaccurate measurements in nodes
    // starting around 5000 chars.
    var pos = Math.min(stream.pos, curStart + 5000);
    f(pos, curStyle);
    curStart = pos;
  }
}

// Finds the line to start with when starting a parse. Tries to
// find a line with a stateAfter, so that it can start with a
// valid state. If that fails, it returns the line with the
// smallest indentation, which tends to need the least context to
// parse correctly.
function findStartLine(cm, n, precise) {
  var minindent, minline, doc = cm.doc;
  var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
  for (var search = n; search > lim; --search) {
    if (search <= doc.first) { return doc.first }
    var line = getLine(doc, search - 1), after = line.stateAfter;
    if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier))
      { return search }
    var indented = countColumn(line.text, null, cm.options.tabSize);
    if (minline == null || minindent > indented) {
      minline = search - 1;
      minindent = indented;
    }
  }
  return minline
}

function retreatFrontier(doc, n) {
  doc.modeFrontier = Math.min(doc.modeFrontier, n);
  if (doc.highlightFrontier < n - 10) { return }
  var start = doc.first;
  for (var line = n - 1; line > start; line--) {
    var saved = getLine(doc, line).stateAfter;
    // change is on 3
    // state on line 1 looked ahead 2 -- so saw 3
    // test 1 + 2 < 3 should cover this
    if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
      start = line + 1;
      break
    }
  }
  doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
}

// LINE DATA STRUCTURE

// Line objects. These hold state related to a line, including
// highlighting info (the styles array).
var Line = function(text, markedSpans, estimateHeight) {
  this.text = text;
  attachMarkedSpans(this, markedSpans);
  this.height = estimateHeight ? estimateHeight(this) : 1;
};

Line.prototype.lineNo = function () { return lineNo(this) };
eventMixin(Line);

// Change the content (text, markers) of a line. Automatically
// invalidates cached information and tries to re-estimate the
// line's height.
function updateLine(line, text, markedSpans, estimateHeight) {
  line.text = text;
  if (line.stateAfter) { line.stateAfter = null; }
  if (line.styles) { line.styles = null; }
  if (line.order != null) { line.order = null; }
  detachMarkedSpans(line);
  attachMarkedSpans(line, markedSpans);
  var estHeight = estimateHeight ? estimateHeight(line) : 1;
  if (estHeight != line.height) { updateLineHeight(line, estHeight); }
}

// Detach a line from the document tree and its markers.
function cleanUpLine(line) {
  line.parent = null;
  detachMarkedSpans(line);
}

// Convert a style as returned by a mode (either null, or a string
// containing one or more styles) to a CSS style. This is cached,
// and also looks for line-wide styles.
var styleToClassCache = {};
var styleToClassCacheWithMode = {};
function interpretTokenStyle(style, options) {
  if (!style || /^\s*$/.test(style)) { return null }
  var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
  return cache[style] ||
    (cache[style] = style.replace(/\S+/g, "cm-$&"))
}

// Render the DOM representation of the text of a line. Also builds
// up a 'line map', which points at the DOM nodes that represent
// specific stretches of text, and is used by the measuring code.
// The returned object contains the DOM node, this map, and
// information about line-wide styles that were set by the mode.
function buildLineContent(cm, lineView) {
  // The padding-right forces the element to have a 'border', which
  // is needed on Webkit to be able to get line-level bounding
  // rectangles for it (in measureChar).
  var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
  var builder = {pre: eltP("pre", [content], "CodeMirror-line"), content: content,
                 col: 0, pos: 0, cm: cm,
                 trailingSpace: false,
                 splitSpaces: (ie || webkit) && cm.getOption("lineWrapping")};
  lineView.measure = {};

  // Iterate over the logical lines that make up this visual line.
  for (var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++) {
    var line = i ? lineView.rest[i - 1] : lineView.line, order = (void 0);
    builder.pos = 0;
    builder.addToken = buildToken;
    // Optionally wire in some hacks into the token-rendering
    // algorithm, to deal with browser quirks.
    if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction)))
      { builder.addToken = buildTokenBadBidi(builder.addToken, order); }
    builder.map = [];
    var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
    insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
    if (line.styleClasses) {
      if (line.styleClasses.bgClass)
        { builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || ""); }
      if (line.styleClasses.textClass)
        { builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || ""); }
    }

    // Ensure at least a single node is present, for measuring.
    if (builder.map.length == 0)
      { builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure))); }

    // Store the map and a cache object for the current logical line
    if (i == 0) {
      lineView.measure.map = builder.map;
      lineView.measure.cache = {};
    } else {
      (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map)
      ;(lineView.measure.caches || (lineView.measure.caches = [])).push({});
    }
  }

  // See issue #2901
  if (webkit) {
    var last = builder.content.lastChild;
    if (/\bcm-tab\b/.test(last.className) || (last.querySelector && last.querySelector(".cm-tab")))
      { builder.content.className = "cm-tab-wrap-hack"; }
  }

  signal(cm, "renderLine", cm, lineView.line, builder.pre);
  if (builder.pre.className)
    { builder.textClass = joinClasses(builder.pre.className, builder.textClass || ""); }

  return builder
}

function defaultSpecialCharPlaceholder(ch) {
  var token = elt("span", "\u2022", "cm-invalidchar");
  token.title = "\\u" + ch.charCodeAt(0).toString(16);
  token.setAttribute("aria-label", token.title);
  return token
}

// Build up the DOM representation for a single token, and add it to
// the line map. Takes care to render special characters separately.
function buildToken(builder, text, style, startStyle, endStyle, title, css) {
  if (!text) { return }
  var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
  var special = builder.cm.state.specialChars, mustWrap = false;
  var content;
  if (!special.test(text)) {
    builder.col += text.length;
    content = document.createTextNode(displayText);
    builder.map.push(builder.pos, builder.pos + text.length, content);
    if (ie && ie_version < 9) { mustWrap = true; }
    builder.pos += text.length;
  } else {
    content = document.createDocumentFragment();
    var pos = 0;
    while (true) {
      special.lastIndex = pos;
      var m = special.exec(text);
      var skipped = m ? m.index - pos : text.length - pos;
      if (skipped) {
        var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt])); }
        else { content.appendChild(txt); }
        builder.map.push(builder.pos, builder.pos + skipped, txt);
        builder.col += skipped;
        builder.pos += skipped;
      }
      if (!m) { break }
      pos += skipped + 1;
      var txt$1 = (void 0);
      if (m[0] == "\t") {
        var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
        txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
        txt$1.setAttribute("role", "presentation");
        txt$1.setAttribute("cm-text", "\t");
        builder.col += tabWidth;
      } else if (m[0] == "\r" || m[0] == "\n") {
        txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240d" : "\u2424", "cm-invalidchar"));
        txt$1.setAttribute("cm-text", m[0]);
        builder.col += 1;
      } else {
        txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
        txt$1.setAttribute("cm-text", m[0]);
        if (ie && ie_version < 9) { content.appendChild(elt("span", [txt$1])); }
        else { content.appendChild(txt$1); }
        builder.col += 1;
      }
      builder.map.push(builder.pos, builder.pos + 1, txt$1);
      builder.pos++;
    }
  }
  builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
  if (style || startStyle || endStyle || mustWrap || css) {
    var fullStyle = style || "";
    if (startStyle) { fullStyle += startStyle; }
    if (endStyle) { fullStyle += endStyle; }
    var token = elt("span", [content], fullStyle, css);
    if (title) { token.title = title; }
    return builder.content.appendChild(token)
  }
  builder.content.appendChild(content);
}

function splitSpaces(text, trailingBefore) {
  if (text.length > 1 && !/  /.test(text)) { return text }
  var spaceBefore = trailingBefore, result = "";
  for (var i = 0; i < text.length; i++) {
    var ch = text.charAt(i);
    if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32))
      { ch = "\u00a0"; }
    result += ch;
    spaceBefore = ch == " ";
  }
  return result
}

// Work around nonsense dimensions being reported for stretches of
// right-to-left text.
function buildTokenBadBidi(inner, order) {
  return function (builder, text, style, startStyle, endStyle, title, css) {
    style = style ? style + " cm-force-border" : "cm-force-border";
    var start = builder.pos, end = start + text.length;
    for (;;) {
      // Find the part that overlaps with the start of this text
      var part = (void 0);
      for (var i = 0; i < order.length; i++) {
        part = order[i];
        if (part.to > start && part.from <= start) { break }
      }
      if (part.to >= end) { return inner(builder, text, style, startStyle, endStyle, title, css) }
      inner(builder, text.slice(0, part.to - start), style, startStyle, null, title, css);
      startStyle = null;
      text = text.slice(part.to - start);
      start = part.to;
    }
  }
}

function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
  var widget = !ignoreWidget && marker.widgetNode;
  if (widget) { builder.map.push(builder.pos, builder.pos + size, widget); }
  if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
    if (!widget)
      { widget = builder.content.appendChild(document.createElement("span")); }
    widget.setAttribute("cm-marker", marker.id);
  }
  if (widget) {
    builder.cm.display.input.setUneditable(widget);
    builder.content.appendChild(widget);
  }
  builder.pos += size;
  builder.trailingSpace = false;
}

// Outputs a number of spans to make up a line, taking highlighting
// and marked text into account.
function insertLineContent(line, builder, styles) {
  var spans = line.markedSpans, allText = line.text, at = 0;
  if (!spans) {
    for (var i$1 = 1; i$1 < styles.length; i$1+=2)
      { builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1+1], builder.cm.options)); }
    return
  }

  var len = allText.length, pos = 0, i = 1, text = "", style, css;
  var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, title, collapsed;
  for (;;) {
    if (nextChange == pos) { // Update current marker set
      spanStyle = spanEndStyle = spanStartStyle = title = css = "";
      collapsed = null; nextChange = Infinity;
      var foundBookmarks = [], endStyles = (void 0);
      for (var j = 0; j < spans.length; ++j) {
        var sp = spans[j], m = sp.marker;
        if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
          foundBookmarks.push(m);
        } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
          if (sp.to != null && sp.to != pos && nextChange > sp.to) {
            nextChange = sp.to;
            spanEndStyle = "";
          }
          if (m.className) { spanStyle += " " + m.className; }
          if (m.css) { css = (css ? css + ";" : "") + m.css; }
          if (m.startStyle && sp.from == pos) { spanStartStyle += " " + m.startStyle; }
          if (m.endStyle && sp.to == nextChange) { (endStyles || (endStyles = [])).push(m.endStyle, sp.to); }
          if (m.title && !title) { title = m.title; }
          if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0))
            { collapsed = sp; }
        } else if (sp.from > pos && nextChange > sp.from) {
          nextChange = sp.from;
        }
      }
      if (endStyles) { for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2)
        { if (endStyles[j$1 + 1] == nextChange) { spanEndStyle += " " + endStyles[j$1]; } } }

      if (!collapsed || collapsed.from == pos) { for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)
        { buildCollapsedSpan(builder, 0, foundBookmarks[j$2]); } }
      if (collapsed && (collapsed.from || 0) == pos) {
        buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos,
                           collapsed.marker, collapsed.from == null);
        if (collapsed.to == null) { return }
        if (collapsed.to == pos) { collapsed = false; }
      }
    }
    if (pos >= len) { break }

    var upto = Math.min(len, nextChange);
    while (true) {
      if (text) {
        var end = pos + text.length;
        if (!collapsed) {
          var tokenText = end > upto ? text.slice(0, upto - pos) : text;
          builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle,
                           spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", title, css);
        }
        if (end >= upto) {text = text.slice(upto - pos); pos = upto; break}
        pos = end;
        spanStartStyle = "";
      }
      text = allText.slice(at, at = styles[i++]);
      style = interpretTokenStyle(styles[i++], builder.cm.options);
    }
  }
}


// These objects are used to represent the visible (currently drawn)
// part of the document. A LineView may correspond to multiple
// logical lines, if those are connected by collapsed ranges.
function LineView(doc, line, lineN) {
  // The starting line
  this.line = line;
  // Continuing lines, if any
  this.rest = visualLineContinued(line);
  // Number of logical lines in this visual line
  this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
  this.node = this.text = null;
  this.hidden = lineIsHidden(doc, line);
}

// Create a range of LineView objects for the given lines.
function buildViewArray(cm, from, to) {
  var array = [], nextPos;
  for (var pos = from; pos < to; pos = nextPos) {
    var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
    nextPos = pos + view.size;
    array.push(view);
  }
  return array
}

var operationGroup = null;

function pushOperation(op) {
  if (operationGroup) {
    operationGroup.ops.push(op);
  } else {
    op.ownsGroup = operationGroup = {
      ops: [op],
      delayedCallbacks: []
    };
  }
}

function fireCallbacksForOps(group) {
  // Calls delayed callbacks and cursorActivity handlers until no
  // new ones appear
  var callbacks = group.delayedCallbacks, i = 0;
  do {
    for (; i < callbacks.length; i++)
      { callbacks[i].call(null); }
    for (var j = 0; j < group.ops.length; j++) {
      var op = group.ops[j];
      if (op.cursorActivityHandlers)
        { while (op.cursorActivityCalled < op.cursorActivityHandlers.length)
          { op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm); } }
    }
  } while (i < callbacks.length)
}

function finishOperation(op, endCb) {
  var group = op.ownsGroup;
  if (!group) { return }

  try { fireCallbacksForOps(group); }
  finally {
    operationGroup = null;
    endCb(group);
  }
}

var orphanDelayedCallbacks = null;

// Often, we want to signal events at a point where we are in the
// middle of some work, but don't want the handler to start calling
// other methods on the editor, which might be in an inconsistent
// state or simply not expect any other events to happen.
// signalLater looks whether there are any handlers, and schedules
// them to be executed when the last operation ends, or, if no
// operation is active, when a timeout fires.
function signalLater(emitter, type /*, values...*/) {
  var arr = getHandlers(emitter, type);
  if (!arr.length) { return }
  var args = Array.prototype.slice.call(arguments, 2), list;
  if (operationGroup) {
    list = operationGroup.delayedCallbacks;
  } else if (orphanDelayedCallbacks) {
    list = orphanDelayedCallbacks;
  } else {
    list = orphanDelayedCallbacks = [];
    setTimeout(fireOrphanDelayed, 0);
  }
  var loop = function ( i ) {
    list.push(function () { return arr[i].apply(null, args); });
  };

  for (var i = 0; i < arr.length; ++i)
    loop( i );
}

function fireOrphanDelayed() {
  var delayed = orphanDelayedCallbacks;
  orphanDelayedCallbacks = null;
  for (var i = 0; i < delayed.length; ++i) { delayed[i](); }
}

// When an aspect of a line changes, a string is added to
// lineView.changes. This updates the relevant part of the line's
// DOM structure.
function updateLineForChanges(cm, lineView, lineN, dims) {
  for (var j = 0; j < lineView.changes.length; j++) {
    var type = lineView.changes[j];
    if (type == "text") { updateLineText(cm, lineView); }
    else if (type == "gutter") { updateLineGutter(cm, lineView, lineN, dims); }
    else if (type == "class") { updateLineClasses(cm, lineView); }
    else if (type == "widget") { updateLineWidgets(cm, lineView, dims); }
  }
  lineView.changes = null;
}

// Lines with gutter elements, widgets or a background class need to
// be wrapped, and have the extra elements added to the wrapper div
function ensureLineWrapped(lineView) {
  if (lineView.node == lineView.text) {
    lineView.node = elt("div", null, null, "position: relative");
    if (lineView.text.parentNode)
      { lineView.text.parentNode.replaceChild(lineView.node, lineView.text); }
    lineView.node.appendChild(lineView.text);
    if (ie && ie_version < 8) { lineView.node.style.zIndex = 2; }
  }
  return lineView.node
}

function updateLineBackground(cm, lineView) {
  var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
  if (cls) { cls += " CodeMirror-linebackground"; }
  if (lineView.background) {
    if (cls) { lineView.background.className = cls; }
    else { lineView.background.parentNode.removeChild(lineView.background); lineView.background = null; }
  } else if (cls) {
    var wrap = ensureLineWrapped(lineView);
    lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
    cm.display.input.setUneditable(lineView.background);
  }
}

// Wrapper around buildLineContent which will reuse the structure
// in display.externalMeasured when possible.
function getLineContent(cm, lineView) {
  var ext = cm.display.externalMeasured;
  if (ext && ext.line == lineView.line) {
    cm.display.externalMeasured = null;
    lineView.measure = ext.measure;
    return ext.built
  }
  return buildLineContent(cm, lineView)
}

// Redraw the line's text. Interacts with the background and text
// classes because the mode may output tokens that influence these
// classes.
function updateLineText(cm, lineView) {
  var cls = lineView.text.className;
  var built = getLineContent(cm, lineView);
  if (lineView.text == lineView.node) { lineView.node = built.pre; }
  lineView.text.parentNode.replaceChild(built.pre, lineView.text);
  lineView.text = built.pre;
  if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
    lineView.bgClass = built.bgClass;
    lineView.textClass = built.textClass;
    updateLineClasses(cm, lineView);
  } else if (cls) {
    lineView.text.className = cls;
  }
}

function updateLineClasses(cm, lineView) {
  updateLineBackground(cm, lineView);
  if (lineView.line.wrapClass)
    { ensureLineWrapped(lineView).className = lineView.line.wrapClass; }
  else if (lineView.node != lineView.text)
    { lineView.node.className = ""; }
  var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
  lineView.text.className = textClass || "";
}

function updateLineGutter(cm, lineView, lineN, dims) {
  if (lineView.gutter) {
    lineView.node.removeChild(lineView.gutter);
    lineView.gutter = null;
  }
  if (lineView.gutterBackground) {
    lineView.node.removeChild(lineView.gutterBackground);
    lineView.gutterBackground = null;
  }
  if (lineView.line.gutterClass) {
    var wrap = ensureLineWrapped(lineView);
    lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass,
                                    ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + (dims.gutterTotalWidth) + "px"));
    cm.display.input.setUneditable(lineView.gutterBackground);
    wrap.insertBefore(lineView.gutterBackground, lineView.text);
  }
  var markers = lineView.line.gutterMarkers;
  if (cm.options.lineNumbers || markers) {
    var wrap$1 = ensureLineWrapped(lineView);
    var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", ("left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px"));
    cm.display.input.setUneditable(gutterWrap);
    wrap$1.insertBefore(gutterWrap, lineView.text);
    if (lineView.line.gutterClass)
      { gutterWrap.className += " " + lineView.line.gutterClass; }
    if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"]))
      { lineView.lineNumber = gutterWrap.appendChild(
        elt("div", lineNumberFor(cm.options, lineN),
            "CodeMirror-linenumber CodeMirror-gutter-elt",
            ("left: " + (dims.gutterLeft["CodeMirror-linenumbers"]) + "px; width: " + (cm.display.lineNumInnerWidth) + "px"))); }
    if (markers) { for (var k = 0; k < cm.options.gutters.length; ++k) {
      var id = cm.options.gutters[k], found = markers.hasOwnProperty(id) && markers[id];
      if (found)
        { gutterWrap.appendChild(elt("div", [found], "CodeMirror-gutter-elt",
                                   ("left: " + (dims.gutterLeft[id]) + "px; width: " + (dims.gutterWidth[id]) + "px"))); }
    } }
  }
}

function updateLineWidgets(cm, lineView, dims) {
  if (lineView.alignable) { lineView.alignable = null; }
  for (var node = lineView.node.firstChild, next = (void 0); node; node = next) {
    next = node.nextSibling;
    if (node.className == "CodeMirror-linewidget")
      { lineView.node.removeChild(node); }
  }
  insertLineWidgets(cm, lineView, dims);
}

// Build a line's DOM representation from scratch
function buildLineElement(cm, lineView, lineN, dims) {
  var built = getLineContent(cm, lineView);
  lineView.text = lineView.node = built.pre;
  if (built.bgClass) { lineView.bgClass = built.bgClass; }
  if (built.textClass) { lineView.textClass = built.textClass; }

  updateLineClasses(cm, lineView);
  updateLineGutter(cm, lineView, lineN, dims);
  insertLineWidgets(cm, lineView, dims);
  return lineView.node
}

// A lineView may contain multiple logical lines (when merged by
// collapsed spans). The widgets for all of them need to be drawn.
function insertLineWidgets(cm, lineView, dims) {
  insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
  if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
    { insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false); } }
}

function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
  if (!line.widgets) { return }
  var wrap = ensureLineWrapped(lineView);
  for (var i = 0, ws = line.widgets; i < ws.length; ++i) {
    var widget = ws[i], node = elt("div", [widget.node], "CodeMirror-linewidget");
    if (!widget.handleMouseEvents) { node.setAttribute("cm-ignore-events", "true"); }
    positionLineWidget(widget, node, lineView, dims);
    cm.display.input.setUneditable(node);
    if (allowAbove && widget.above)
      { wrap.insertBefore(node, lineView.gutter || lineView.text); }
    else
      { wrap.appendChild(node); }
    signalLater(widget, "redraw");
  }
}

function positionLineWidget(widget, node, lineView, dims) {
  if (widget.noHScroll) {
    (lineView.alignable || (lineView.alignable = [])).push(node);
    var width = dims.wrapperWidth;
    node.style.left = dims.fixedPos + "px";
    if (!widget.coverGutter) {
      width -= dims.gutterTotalWidth;
      node.style.paddingLeft = dims.gutterTotalWidth + "px";
    }
    node.style.width = width + "px";
  }
  if (widget.coverGutter) {
    node.style.zIndex = 5;
    node.style.position = "relative";
    if (!widget.noHScroll) { node.style.marginLeft = -dims.gutterTotalWidth + "px"; }
  }
}

function widgetHeight(widget) {
  if (widget.height != null) { return widget.height }
  var cm = widget.doc.cm;
  if (!cm) { return 0 }
  if (!contains(document.body, widget.node)) {
    var parentStyle = "position: relative;";
    if (widget.coverGutter)
      { parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;"; }
    if (widget.noHScroll)
      { parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;"; }
    removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
  }
  return widget.height = widget.node.parentNode.offsetHeight
}

// Return true when the given mouse event happened in a widget
function eventInWidget(display, e) {
  for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
    if (!n || (n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true") ||
        (n.parentNode == display.sizer && n != display.mover))
      { return true }
  }
}

// POSITION MEASUREMENT

function paddingTop(display) {return display.lineSpace.offsetTop}
function paddingVert(display) {return display.mover.offsetHeight - display.lineSpace.offsetHeight}
function paddingH(display) {
  if (display.cachedPaddingH) { return display.cachedPaddingH }
  var e = removeChildrenAndAdd(display.measure, elt("pre", "x"));
  var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
  var data = {left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight)};
  if (!isNaN(data.left) && !isNaN(data.right)) { display.cachedPaddingH = data; }
  return data
}

function scrollGap(cm) { return scrollerGap - cm.display.nativeBarWidth }
function displayWidth(cm) {
  return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth
}
function displayHeight(cm) {
  return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight
}

// Ensure the lineView.wrapping.heights array is populated. This is
// an array of bottom offsets for the lines that make up a drawn
// line. When lineWrapping is on, there might be more than one
// height.
function ensureLineHeights(cm, lineView, rect) {
  var wrapping = cm.options.lineWrapping;
  var curWidth = wrapping && displayWidth(cm);
  if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
    var heights = lineView.measure.heights = [];
    if (wrapping) {
      lineView.measure.width = curWidth;
      var rects = lineView.text.firstChild.getClientRects();
      for (var i = 0; i < rects.length - 1; i++) {
        var cur = rects[i], next = rects[i + 1];
        if (Math.abs(cur.bottom - next.bottom) > 2)
          { heights.push((cur.bottom + next.top) / 2 - rect.top); }
      }
    }
    heights.push(rect.bottom - rect.top);
  }
}

// Find a line map (mapping character offsets to text nodes) and a
// measurement cache for the given line number. (A line view might
// contain multiple lines when collapsed ranges are present.)
function mapFromLineView(lineView, line, lineN) {
  if (lineView.line == line)
    { return {map: lineView.measure.map, cache: lineView.measure.cache} }
  for (var i = 0; i < lineView.rest.length; i++)
    { if (lineView.rest[i] == line)
      { return {map: lineView.measure.maps[i], cache: lineView.measure.caches[i]} } }
  for (var i$1 = 0; i$1 < lineView.rest.length; i$1++)
    { if (lineNo(lineView.rest[i$1]) > lineN)
      { return {map: lineView.measure.maps[i$1], cache: lineView.measure.caches[i$1], before: true} } }
}

// Render a line into the hidden node display.externalMeasured. Used
// when measurement is needed for a line that's not in the viewport.
function updateExternalMeasurement(cm, line) {
  line = visualLine(line);
  var lineN = lineNo(line);
  var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
  view.lineN = lineN;
  var built = view.built = buildLineContent(cm, view);
  view.text = built.pre;
  removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
  return view
}

// Get a {top, bottom, left, right} box (in line-local coordinates)
// for a given character.
function measureChar(cm, line, ch, bias) {
  return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias)
}

// Find a line view that corresponds to the given line number.
function findViewForLine(cm, lineN) {
  if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo)
    { return cm.display.view[findViewIndex(cm, lineN)] }
  var ext = cm.display.externalMeasured;
  if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size)
    { return ext }
}

// Measurement can be split in two steps, the set-up work that
// applies to the whole line, and the measurement of the actual
// character. Functions like coordsChar, that need to do a lot of
// measurements in a row, can thus ensure that the set-up work is
// only done once.
function prepareMeasureForLine(cm, line) {
  var lineN = lineNo(line);
  var view = findViewForLine(cm, lineN);
  if (view && !view.text) {
    view = null;
  } else if (view && view.changes) {
    updateLineForChanges(cm, view, lineN, getDimensions(cm));
    cm.curOp.forceUpdate = true;
  }
  if (!view)
    { view = updateExternalMeasurement(cm, line); }

  var info = mapFromLineView(view, line, lineN);
  return {
    line: line, view: view, rect: null,
    map: info.map, cache: info.cache, before: info.before,
    hasHeights: false
  }
}

// Given a prepared measurement object, measures the position of an
// actual character (or fetches it from the cache).
function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
  if (prepared.before) { ch = -1; }
  var key = ch + (bias || ""), found;
  if (prepared.cache.hasOwnProperty(key)) {
    found = prepared.cache[key];
  } else {
    if (!prepared.rect)
      { prepared.rect = prepared.view.text.getBoundingClientRect(); }
    if (!prepared.hasHeights) {
      ensureLineHeights(cm, prepared.view, prepared.rect);
      prepared.hasHeights = true;
    }
    found = measureCharInner(cm, prepared, ch, bias);
    if (!found.bogus) { prepared.cache[key] = found; }
  }
  return {left: found.left, right: found.right,
          top: varHeight ? found.rtop : found.top,
          bottom: varHeight ? found.rbottom : found.bottom}
}

var nullRect = {left: 0, right: 0, top: 0, bottom: 0};

function nodeAndOffsetInLineMap(map$$1, ch, bias) {
  var node, start, end, collapse, mStart, mEnd;
  // First, search the line map for the text node corresponding to,
  // or closest to, the target character.
  for (var i = 0; i < map$$1.length; i += 3) {
    mStart = map$$1[i];
    mEnd = map$$1[i + 1];
    if (ch < mStart) {
      start = 0; end = 1;
      collapse = "left";
    } else if (ch < mEnd) {
      start = ch - mStart;
      end = start + 1;
    } else if (i == map$$1.length - 3 || ch == mEnd && map$$1[i + 3] > ch) {
      end = mEnd - mStart;
      start = end - 1;
      if (ch >= mEnd) { collapse = "right"; }
    }
    if (start != null) {
      node = map$$1[i + 2];
      if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right"))
        { collapse = bias; }
      if (bias == "left" && start == 0)
        { while (i && map$$1[i - 2] == map$$1[i - 3] && map$$1[i - 1].insertLeft) {
          node = map$$1[(i -= 3) + 2];
          collapse = "left";
        } }
      if (bias == "right" && start == mEnd - mStart)
        { while (i < map$$1.length - 3 && map$$1[i + 3] == map$$1[i + 4] && !map$$1[i + 5].insertLeft) {
          node = map$$1[(i += 3) + 2];
          collapse = "right";
        } }
      break
    }
  }
  return {node: node, start: start, end: end, collapse: collapse, coverStart: mStart, coverEnd: mEnd}
}

function getUsefulRect(rects, bias) {
  var rect = nullRect;
  if (bias == "left") { for (var i = 0; i < rects.length; i++) {
    if ((rect = rects[i]).left != rect.right) { break }
  } } else { for (var i$1 = rects.length - 1; i$1 >= 0; i$1--) {
    if ((rect = rects[i$1]).left != rect.right) { break }
  } }
  return rect
}

function measureCharInner(cm, prepared, ch, bias) {
  var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
  var node = place.node, start = place.start, end = place.end, collapse = place.collapse;

  var rect;
  if (node.nodeType == 3) { // If it is a text node, use a range to retrieve the coordinates.
    for (var i$1 = 0; i$1 < 4; i$1++) { // Retry a maximum of 4 times when nonsense rectangles are returned
      while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) { --start; }
      while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) { ++end; }
      if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart)
        { rect = node.parentNode.getBoundingClientRect(); }
      else
        { rect = getUsefulRect(range(node, start, end).getClientRects(), bias); }
      if (rect.left || rect.right || start == 0) { break }
      end = start;
      start = start - 1;
      collapse = "right";
    }
    if (ie && ie_version < 11) { rect = maybeUpdateRectForZooming(cm.display.measure, rect); }
  } else { // If it is a widget, simply get the box for the whole widget.
    if (start > 0) { collapse = bias = "right"; }
    var rects;
    if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1)
      { rect = rects[bias == "right" ? rects.length - 1 : 0]; }
    else
      { rect = node.getBoundingClientRect(); }
  }
  if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
    var rSpan = node.parentNode.getClientRects()[0];
    if (rSpan)
      { rect = {left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom}; }
    else
      { rect = nullRect; }
  }

  var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
  var mid = (rtop + rbot) / 2;
  var heights = prepared.view.measure.heights;
  var i = 0;
  for (; i < heights.length - 1; i++)
    { if (mid < heights[i]) { break } }
  var top = i ? heights[i - 1] : 0, bot = heights[i];
  var result = {left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
                right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
                top: top, bottom: bot};
  if (!rect.left && !rect.right) { result.bogus = true; }
  if (!cm.options.singleCursorHeightPerLine) { result.rtop = rtop; result.rbottom = rbot; }

  return result
}

// Work around problem with bounding client rects on ranges being
// returned incorrectly when zoomed on IE10 and below.
function maybeUpdateRectForZooming(measure, rect) {
  if (!window.screen || screen.logicalXDPI == null ||
      screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure))
    { return rect }
  var scaleX = screen.logicalXDPI / screen.deviceXDPI;
  var scaleY = screen.logicalYDPI / screen.deviceYDPI;
  return {left: rect.left * scaleX, right: rect.right * scaleX,
          top: rect.top * scaleY, bottom: rect.bottom * scaleY}
}

function clearLineMeasurementCacheFor(lineView) {
  if (lineView.measure) {
    lineView.measure.cache = {};
    lineView.measure.heights = null;
    if (lineView.rest) { for (var i = 0; i < lineView.rest.length; i++)
      { lineView.measure.caches[i] = {}; } }
  }
}

function clearLineMeasurementCache(cm) {
  cm.display.externalMeasure = null;
  removeChildren(cm.display.lineMeasure);
  for (var i = 0; i < cm.display.view.length; i++)
    { clearLineMeasurementCacheFor(cm.display.view[i]); }
}

function clearCaches(cm) {
  clearLineMeasurementCache(cm);
  cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
  if (!cm.options.lineWrapping) { cm.display.maxLineChanged = true; }
  cm.display.lineNumChars = null;
}

function pageScrollX() {
  // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
  // which causes page_Offset and bounding client rects to use
  // different reference viewports and invalidate our calculations.
  if (chrome && android) { return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) }
  return window.pageXOffset || (document.documentElement || document.body).scrollLeft
}
function pageScrollY() {
  if (chrome && android) { return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) }
  return window.pageYOffset || (document.documentElement || document.body).scrollTop
}

function widgetTopHeight(lineObj) {
  var height = 0;
  if (lineObj.widgets) { for (var i = 0; i < lineObj.widgets.length; ++i) { if (lineObj.widgets[i].above)
    { height += widgetHeight(lineObj.widgets[i]); } } }
  return height
}

// Converts a {top, bottom, left, right} box from line-local
// coordinates into another coordinate system. Context may be one of
// "line", "div" (display.lineDiv), "local"./null (editor), "window",
// or "page".
function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
  if (!includeWidgets) {
    var height = widgetTopHeight(lineObj);
    rect.top += height; rect.bottom += height;
  }
  if (context == "line") { return rect }
  if (!context) { context = "local"; }
  var yOff = heightAtLine(lineObj);
  if (context == "local") { yOff += paddingTop(cm.display); }
  else { yOff -= cm.display.viewOffset; }
  if (context == "page" || context == "window") {
    var lOff = cm.display.lineSpace.getBoundingClientRect();
    yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
    var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
    rect.left += xOff; rect.right += xOff;
  }
  rect.top += yOff; rect.bottom += yOff;
  return rect
}

// Coverts a box from "div" coords to another coordinate system.
// Context may be "window", "page", "div", or "local"./null.
function fromCoordSystem(cm, coords, context) {
  if (context == "div") { return coords }
  var left = coords.left, top = coords.top;
  // First move into "page" coordinate system
  if (context == "page") {
    left -= pageScrollX();
    top -= pageScrollY();
  } else if (context == "local" || !context) {
    var localBox = cm.display.sizer.getBoundingClientRect();
    left += localBox.left;
    top += localBox.top;
  }

  var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
  return {left: left - lineSpaceBox.left, top: top - lineSpaceBox.top}
}

function charCoords(cm, pos, context, lineObj, bias) {
  if (!lineObj) { lineObj = getLine(cm.doc, pos.line); }
  return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context)
}

// Returns a box for a given cursor position, which may have an
// 'other' property containing the position of the secondary cursor
// on a bidi boundary.
// A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
// and after `char - 1` in writing order of `char - 1`
// A cursor Pos(line, char, "after") is on the same visual line as `char`
// and before `char` in writing order of `char`
// Examples (upper-case letters are RTL, lower-case are LTR):
//     Pos(0, 1, ...)
//     before   after
// ab     a|b     a|b
// aB     a|B     aB|
// Ab     |Ab     A|b
// AB     B|A     B|A
// Every position after the last character on a line is considered to stick
// to the last character on the line.
function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
  lineObj = lineObj || getLine(cm.doc, pos.line);
  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
  function get(ch, right) {
    var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
    if (right) { m.left = m.right; } else { m.right = m.left; }
    return intoCoordSystem(cm, lineObj, m, context)
  }
  var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
  if (ch >= lineObj.text.length) {
    ch = lineObj.text.length;
    sticky = "before";
  } else if (ch <= 0) {
    ch = 0;
    sticky = "after";
  }
  if (!order) { return get(sticky == "before" ? ch - 1 : ch, sticky == "before") }

  function getBidi(ch, partPos, invert) {
    var part = order[partPos], right = part.level == 1;
    return get(invert ? ch - 1 : ch, right != invert)
  }
  var partPos = getBidiPartAt(order, ch, sticky);
  var other = bidiOther;
  var val = getBidi(ch, partPos, sticky == "before");
  if (other != null) { val.other = getBidi(ch, other, sticky != "before"); }
  return val
}

// Used to cheaply estimate the coordinates for a position. Used for
// intermediate scroll updates.
function estimateCoords(cm, pos) {
  var left = 0;
  pos = clipPos(cm.doc, pos);
  if (!cm.options.lineWrapping) { left = charWidth(cm.display) * pos.ch; }
  var lineObj = getLine(cm.doc, pos.line);
  var top = heightAtLine(lineObj) + paddingTop(cm.display);
  return {left: left, right: left, top: top, bottom: top + lineObj.height}
}

// Positions returned by coordsChar contain some extra information.
// xRel is the relative x position of the input coordinates compared
// to the found position (so xRel > 0 means the coordinates are to
// the right of the character position, for example). When outside
// is true, that means the coordinates lie outside the line's
// vertical range.
function PosWithInfo(line, ch, sticky, outside, xRel) {
  var pos = Pos(line, ch, sticky);
  pos.xRel = xRel;
  if (outside) { pos.outside = true; }
  return pos
}

// Compute the character position closest to the given coordinates.
// Input must be lineSpace-local ("div" coordinate system).
function coordsChar(cm, x, y) {
  var doc = cm.doc;
  y += cm.display.viewOffset;
  if (y < 0) { return PosWithInfo(doc.first, 0, null, true, -1) }
  var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
  if (lineN > last)
    { return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, true, 1) }
  if (x < 0) { x = 0; }

  var lineObj = getLine(doc, lineN);
  for (;;) {
    var found = coordsCharInner(cm, lineObj, lineN, x, y);
    var merged = collapsedSpanAtEnd(lineObj);
    var mergedPos = merged && merged.find(0, true);
    if (merged && (found.ch > mergedPos.from.ch || found.ch == mergedPos.from.ch && found.xRel > 0))
      { lineN = lineNo(lineObj = mergedPos.to.line); }
    else
      { return found }
  }
}

function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
  y -= widgetTopHeight(lineObj);
  var end = lineObj.text.length;
  var begin = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y; }, end, 0);
  end = findFirst(function (ch) { return measureCharPrepared(cm, preparedMeasure, ch).top > y; }, begin, end);
  return {begin: begin, end: end}
}

function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
  if (!preparedMeasure) { preparedMeasure = prepareMeasureForLine(cm, lineObj); }
  var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
  return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop)
}

// Returns true if the given side of a box is after the given
// coordinates, in top-to-bottom, left-to-right order.
function boxIsAfter(box, x, y, left) {
  return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x
}

function coordsCharInner(cm, lineObj, lineNo$$1, x, y) {
  // Move y into line-local coordinate space
  y -= heightAtLine(lineObj);
  var preparedMeasure = prepareMeasureForLine(cm, lineObj);
  // When directly calling `measureCharPrepared`, we have to adjust
  // for the widgets at this line.
  var widgetHeight$$1 = widgetTopHeight(lineObj);
  var begin = 0, end = lineObj.text.length, ltr = true;

  var order = getOrder(lineObj, cm.doc.direction);
  // If the line isn't plain left-to-right text, first figure out
  // which bidi section the coordinates fall into.
  if (order) {
    var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)
                 (cm, lineObj, lineNo$$1, preparedMeasure, order, x, y);
    ltr = part.level != 1;
    // The awkward -1 offsets are needed because findFirst (called
    // on these below) will treat its first bound as inclusive,
    // second as exclusive, but we want to actually address the
    // characters in the part's range
    begin = ltr ? part.from : part.to - 1;
    end = ltr ? part.to : part.from - 1;
  }

  // A binary search to find the first character whose bounding box
  // starts after the coordinates. If we run across any whose box wrap
  // the coordinates, store that.
  var chAround = null, boxAround = null;
  var ch = findFirst(function (ch) {
    var box = measureCharPrepared(cm, preparedMeasure, ch);
    box.top += widgetHeight$$1; box.bottom += widgetHeight$$1;
    if (!boxIsAfter(box, x, y, false)) { return false }
    if (box.top <= y && box.left <= x) {
      chAround = ch;
      boxAround = box;
    }
    return true
  }, begin, end);

  var baseX, sticky, outside = false;
  // If a box around the coordinates was found, use that
  if (boxAround) {
    // Distinguish coordinates nearer to the left or right side of the box
    var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
    ch = chAround + (atStart ? 0 : 1);
    sticky = atStart ? "after" : "before";
    baseX = atLeft ? boxAround.left : boxAround.right;
  } else {
    // (Adjust for extended bound, if necessary.)
    if (!ltr && (ch == end || ch == begin)) { ch++; }
    // To determine which side to associate with, get the box to the
    // left of the character and compare it's vertical position to the
    // coordinates
    sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" :
      (measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight$$1 <= y) == ltr ?
      "after" : "before";
    // Now get accurate coordinates for this place, in order to get a
    // base X position
    var coords = cursorCoords(cm, Pos(lineNo$$1, ch, sticky), "line", lineObj, preparedMeasure);
    baseX = coords.left;
    outside = y < coords.top || y >= coords.bottom;
  }

  ch = skipExtendingChars(lineObj.text, ch, 1);
  return PosWithInfo(lineNo$$1, ch, sticky, outside, x - baseX)
}

function coordsBidiPart(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y) {
  // Bidi parts are sorted left-to-right, and in a non-line-wrapping
  // situation, we can take this ordering to correspond to the visual
  // ordering. This finds the first part whose end is after the given
  // coordinates.
  var index = findFirst(function (i) {
    var part = order[i], ltr = part.level != 1;
    return boxIsAfter(cursorCoords(cm, Pos(lineNo$$1, ltr ? part.to : part.from, ltr ? "before" : "after"),
                                   "line", lineObj, preparedMeasure), x, y, true)
  }, 0, order.length - 1);
  var part = order[index];
  // If this isn't the first part, the part's start is also after
  // the coordinates, and the coordinates aren't on the same line as
  // that start, move one part back.
  if (index > 0) {
    var ltr = part.level != 1;
    var start = cursorCoords(cm, Pos(lineNo$$1, ltr ? part.from : part.to, ltr ? "after" : "before"),
                             "line", lineObj, preparedMeasure);
    if (boxIsAfter(start, x, y, true) && start.top > y)
      { part = order[index - 1]; }
  }
  return part
}

function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
  // In a wrapped line, rtl text on wrapping boundaries can do things
  // that don't correspond to the ordering in our `order` array at
  // all, so a binary search doesn't work, and we want to return a
  // part that only spans one line so that the binary search in
  // coordsCharInner is safe. As such, we first find the extent of the
  // wrapped line, and then do a flat search in which we discard any
  // spans that aren't on the line.
  var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
  var begin = ref.begin;
  var end = ref.end;
  if (/\s/.test(lineObj.text.charAt(end - 1))) { end--; }
  var part = null, closestDist = null;
  for (var i = 0; i < order.length; i++) {
    var p = order[i];
    if (p.from >= end || p.to <= begin) { continue }
    var ltr = p.level != 1;
    var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
    // Weigh against spans ending before this, so that they are only
    // picked if nothing ends after
    var dist = endX < x ? x - endX + 1e9 : endX - x;
    if (!part || closestDist > dist) {
      part = p;
      closestDist = dist;
    }
  }
  if (!part) { part = order[order.length - 1]; }
  // Clip the part to the wrapped line.
  if (part.from < begin) { part = {from: begin, to: part.to, level: part.level}; }
  if (part.to > end) { part = {from: part.from, to: end, level: part.level}; }
  return part
}

var measureText;
// Compute the default text height.
function textHeight(display) {
  if (display.cachedTextHeight != null) { return display.cachedTextHeight }
  if (measureText == null) {
    measureText = elt("pre");
    // Measure a bunch of lines, for browsers that compute
    // fractional heights.
    for (var i = 0; i < 49; ++i) {
      measureText.appendChild(document.createTextNode("x"));
      measureText.appendChild(elt("br"));
    }
    measureText.appendChild(document.createTextNode("x"));
  }
  removeChildrenAndAdd(display.measure, measureText);
  var height = measureText.offsetHeight / 50;
  if (height > 3) { display.cachedTextHeight = height; }
  removeChildren(display.measure);
  return height || 1
}

// Compute the default character width.
function charWidth(display) {
  if (display.cachedCharWidth != null) { return display.cachedCharWidth }
  var anchor = elt("span", "xxxxxxxxxx");
  var pre = elt("pre", [anchor]);
  removeChildrenAndAdd(display.measure, pre);
  var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
  if (width > 2) { display.cachedCharWidth = width; }
  return width || 10
}

// Do a bulk-read of the DOM positions and sizes needed to draw the
// view, so that we don't interleave reading and writing to the DOM.
function getDimensions(cm) {
  var d = cm.display, left = {}, width = {};
  var gutterLeft = d.gutters.clientLeft;
  for (var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i) {
    left[cm.options.gutters[i]] = n.offsetLeft + n.clientLeft + gutterLeft;
    width[cm.options.gutters[i]] = n.clientWidth;
  }
  return {fixedPos: compensateForHScroll(d),
          gutterTotalWidth: d.gutters.offsetWidth,
          gutterLeft: left,
          gutterWidth: width,
          wrapperWidth: d.wrapper.clientWidth}
}

// Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
// but using getBoundingClientRect to get a sub-pixel-accurate
// result.
function compensateForHScroll(display) {
  return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left
}

// Returns a function that estimates the height of a line, to use as
// first approximation until the line becomes visible (and is thus
// properly measurable).
function estimateHeight(cm) {
  var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
  var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
  return function (line) {
    if (lineIsHidden(cm.doc, line)) { return 0 }

    var widgetsHeight = 0;
    if (line.widgets) { for (var i = 0; i < line.widgets.length; i++) {
      if (line.widgets[i].height) { widgetsHeight += line.widgets[i].height; }
    } }

    if (wrapping)
      { return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th }
    else
      { return widgetsHeight + th }
  }
}

function estimateLineHeights(cm) {
  var doc = cm.doc, est = estimateHeight(cm);
  doc.iter(function (line) {
    var estHeight = est(line);
    if (estHeight != line.height) { updateLineHeight(line, estHeight); }
  });
}

// Given a mouse event, find the corresponding position. If liberal
// is false, it checks whether a gutter or scrollbar was clicked,
// and returns null if it was. forRect is used by rectangular
// selections, and tries to estimate a character position even for
// coordinates beyond the right of the text.
function posFromMouse(cm, e, liberal, forRect) {
  var display = cm.display;
  if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") { return null }

  var x, y, space = display.lineSpace.getBoundingClientRect();
  // Fails unpredictably on IE[67] when mouse is dragged around quickly.
  try { x = e.clientX - space.left; y = e.clientY - space.top; }
  catch (e) { return null }
  var coords = coordsChar(cm, x, y), line;
  if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
    var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
    coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
  }
  return coords
}

// Find the view element corresponding to a given line. Return null
// when the line isn't visible.
function findViewIndex(cm, n) {
  if (n >= cm.display.viewTo) { return null }
  n -= cm.display.viewFrom;
  if (n < 0) { return null }
  var view = cm.display.view;
  for (var i = 0; i < view.length; i++) {
    n -= view[i].size;
    if (n < 0) { return i }
  }
}

function updateSelection(cm) {
  cm.display.input.showSelection(cm.display.input.prepareSelection());
}

function prepareSelection(cm, primary) {
  if ( primary === void 0 ) primary = true;

  var doc = cm.doc, result = {};
  var curFragment = result.cursors = document.createDocumentFragment();
  var selFragment = result.selection = document.createDocumentFragment();

  for (var i = 0; i < doc.sel.ranges.length; i++) {
    if (!primary && i == doc.sel.primIndex) { continue }
    var range$$1 = doc.sel.ranges[i];
    if (range$$1.from().line >= cm.display.viewTo || range$$1.to().line < cm.display.viewFrom) { continue }
    var collapsed = range$$1.empty();
    if (collapsed || cm.options.showCursorWhenSelecting)
      { drawSelectionCursor(cm, range$$1.head, curFragment); }
    if (!collapsed)
      { drawSelectionRange(cm, range$$1, selFragment); }
  }
  return result
}

// Draws a cursor for the given range
function drawSelectionCursor(cm, head, output) {
  var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);

  var cursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor"));
  cursor.style.left = pos.left + "px";
  cursor.style.top = pos.top + "px";
  cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";

  if (pos.other) {
    // Secondary cursor, shown when on a 'jump' in bi-directional text
    var otherCursor = output.appendChild(elt("div", "\u00a0", "CodeMirror-cursor CodeMirror-secondarycursor"));
    otherCursor.style.display = "";
    otherCursor.style.left = pos.other.left + "px";
    otherCursor.style.top = pos.other.top + "px";
    otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
  }
}

function cmpCoords(a, b) { return a.top - b.top || a.left - b.left }

// Draws the given range as a highlighted selection
function drawSelectionRange(cm, range$$1, output) {
  var display = cm.display, doc = cm.doc;
  var fragment = document.createDocumentFragment();
  var padding = paddingH(cm.display), leftSide = padding.left;
  var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
  var docLTR = doc.direction == "ltr";

  function add(left, top, width, bottom) {
    if (top < 0) { top = 0; }
    top = Math.round(top);
    bottom = Math.round(bottom);
    fragment.appendChild(elt("div", null, "CodeMirror-selected", ("position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px")));
  }

  function drawForLine(line, fromArg, toArg) {
    var lineObj = getLine(doc, line);
    var lineLen = lineObj.text.length;
    var start, end;
    function coords(ch, bias) {
      return charCoords(cm, Pos(line, ch), "div", lineObj, bias)
    }

    function wrapX(pos, dir, side) {
      var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
      var prop = (dir == "ltr") == (side == "after") ? "left" : "right";
      var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
      return coords(ch, prop)[prop]
    }

    var order = getOrder(lineObj, doc.direction);
    iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function (from, to, dir, i) {
      var ltr = dir == "ltr";
      var fromPos = coords(from, ltr ? "left" : "right");
      var toPos = coords(to - 1, ltr ? "right" : "left");

      var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
      var first = i == 0, last = !order || i == order.length - 1;
      if (toPos.top - fromPos.top <= 3) { // Single line
        var openLeft = (docLTR ? openStart : openEnd) && first;
        var openRight = (docLTR ? openEnd : openStart) && last;
        var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
        var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
        add(left, fromPos.top, right - left, fromPos.bottom);
      } else { // Multiple lines
        var topLeft, topRight, botLeft, botRight;
        if (ltr) {
          topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
          topRight = docLTR ? rightSide : wrapX(from, dir, "before");
          botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
          botRight = docLTR && openEnd && last ? rightSide : toPos.right;
        } else {
          topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
          topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
          botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
          botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
        }
        add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
        if (fromPos.bottom < toPos.top) { add(leftSide, fromPos.bottom, null, toPos.top); }
        add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
      }

      if (!start || cmpCoords(fromPos, start) < 0) { start = fromPos; }
      if (cmpCoords(toPos, start) < 0) { start = toPos; }
      if (!end || cmpCoords(fromPos, end) < 0) { end = fromPos; }
      if (cmpCoords(toPos, end) < 0) { end = toPos; }
    });
    return {start: start, end: end}
  }

  var sFrom = range$$1.from(), sTo = range$$1.to();
  if (sFrom.line == sTo.line) {
    drawForLine(sFrom.line, sFrom.ch, sTo.ch);
  } else {
    var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
    var singleVLine = visualLine(fromLine) == visualLine(toLine);
    var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
    var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
    if (singleVLine) {
      if (leftEnd.top < rightStart.top - 2) {
        add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
        add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
      } else {
        add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
      }
    }
    if (leftEnd.bottom < rightStart.top)
      { add(leftSide, leftEnd.bottom, null, rightStart.top); }
  }

  output.appendChild(fragment);
}

// Cursor-blinking
function restartBlink(cm) {
  if (!cm.state.focused) { return }
  var display = cm.display;
  clearInterval(display.blinker);
  var on = true;
  display.cursorDiv.style.visibility = "";
  if (cm.options.cursorBlinkRate > 0)
    { display.blinker = setInterval(function () { return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden"; },
      cm.options.cursorBlinkRate); }
  else if (cm.options.cursorBlinkRate < 0)
    { display.cursorDiv.style.visibility = "hidden"; }
}

function ensureFocus(cm) {
  if (!cm.state.focused) { cm.display.input.focus(); onFocus(cm); }
}

function delayBlurEvent(cm) {
  cm.state.delayingBlurEvent = true;
  setTimeout(function () { if (cm.state.delayingBlurEvent) {
    cm.state.delayingBlurEvent = false;
    onBlur(cm);
  } }, 100);
}

function onFocus(cm, e) {
  if (cm.state.delayingBlurEvent) { cm.state.delayingBlurEvent = false; }

  if (cm.options.readOnly == "nocursor") { return }
  if (!cm.state.focused) {
    signal(cm, "focus", cm, e);
    cm.state.focused = true;
    addClass(cm.display.wrapper, "CodeMirror-focused");
    // This test prevents this from firing when a context
    // menu is closed (since the input reset would kill the
    // select-all detection hack)
    if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
      cm.display.input.reset();
      if (webkit) { setTimeout(function () { return cm.display.input.reset(true); }, 20); } // Issue #1730
    }
    cm.display.input.receivedFocus();
  }
  restartBlink(cm);
}
function onBlur(cm, e) {
  if (cm.state.delayingBlurEvent) { return }

  if (cm.state.focused) {
    signal(cm, "blur", cm, e);
    cm.state.focused = false;
    rmClass(cm.display.wrapper, "CodeMirror-focused");
  }
  clearInterval(cm.display.blinker);
  setTimeout(function () { if (!cm.state.focused) { cm.display.shift = false; } }, 150);
}

// Read the actual heights of the rendered lines, and update their
// stored heights to match.
function updateHeightsInViewport(cm) {
  var display = cm.display;
  var prevBottom = display.lineDiv.offsetTop;
  for (var i = 0; i < display.view.length; i++) {
    var cur = display.view[i], height = (void 0);
    if (cur.hidden) { continue }
    if (ie && ie_version < 8) {
      var bot = cur.node.offsetTop + cur.node.offsetHeight;
      height = bot - prevBottom;
      prevBottom = bot;
    } else {
      var box = cur.node.getBoundingClientRect();
      height = box.bottom - box.top;
    }
    var diff = cur.line.height - height;
    if (height < 2) { height = textHeight(display); }
    if (diff > .005 || diff < -.005) {
      updateLineHeight(cur.line, height);
      updateWidgetHeight(cur.line);
      if (cur.rest) { for (var j = 0; j < cur.rest.length; j++)
        { updateWidgetHeight(cur.rest[j]); } }
    }
  }
}

// Read and store the height of line widgets associated with the
// given line.
function updateWidgetHeight(line) {
  if (line.widgets) { for (var i = 0; i < line.widgets.length; ++i) {
    var w = line.widgets[i], parent = w.node.parentNode;
    if (parent) { w.height = parent.offsetHeight; }
  } }
}

// Compute the lines that are visible in a given viewport (defaults
// the the current scroll position). viewport may contain top,
// height, and ensure (see op.scrollToPos) properties.
function visibleLines(display, doc, viewport) {
  var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
  top = Math.floor(top - paddingTop(display));
  var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;

  var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
  // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
  // forces those lines into the viewport (if possible).
  if (viewport && viewport.ensure) {
    var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
    if (ensureFrom < from) {
      from = ensureFrom;
      to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
    } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
      from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
      to = ensureTo;
    }
  }
  return {from: from, to: Math.max(to, from + 1)}
}

// Re-align line numbers and gutter marks to compensate for
// horizontal scrolling.
function alignHorizontally(cm) {
  var display = cm.display, view = display.view;
  if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) { return }
  var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
  var gutterW = display.gutters.offsetWidth, left = comp + "px";
  for (var i = 0; i < view.length; i++) { if (!view[i].hidden) {
    if (cm.options.fixedGutter) {
      if (view[i].gutter)
        { view[i].gutter.style.left = left; }
      if (view[i].gutterBackground)
        { view[i].gutterBackground.style.left = left; }
    }
    var align = view[i].alignable;
    if (align) { for (var j = 0; j < align.length; j++)
      { align[j].style.left = left; } }
  } }
  if (cm.options.fixedGutter)
    { display.gutters.style.left = (comp + gutterW) + "px"; }
}

// Used to ensure that the line number gutter is still the right
// size for the current document size. Returns true when an update
// is needed.
function maybeUpdateLineNumberWidth(cm) {
  if (!cm.options.lineNumbers) { return false }
  var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
  if (last.length != display.lineNumChars) {
    var test = display.measure.appendChild(elt("div", [elt("div", last)],
                                               "CodeMirror-linenumber CodeMirror-gutter-elt"));
    var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
    display.lineGutter.style.width = "";
    display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
    display.lineNumWidth = display.lineNumInnerWidth + padding;
    display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
    display.lineGutter.style.width = display.lineNumWidth + "px";
    updateGutterSpace(cm);
    return true
  }
  return false
}

// SCROLLING THINGS INTO VIEW

// If an editor sits on the top or bottom of the window, partially
// scrolled out of view, this ensures that the cursor is visible.
function maybeScrollWindow(cm, rect) {
  if (signalDOMEvent(cm, "scrollCursorIntoView")) { return }

  var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
  if (rect.top + box.top < 0) { doScroll = true; }
  else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) { doScroll = false; }
  if (doScroll != null && !phantom) {
    var scrollNode = elt("div", "\u200b", null, ("position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + (rect.left) + "px; width: " + (Math.max(2, rect.right - rect.left)) + "px;"));
    cm.display.lineSpace.appendChild(scrollNode);
    scrollNode.scrollIntoView(doScroll);
    cm.display.lineSpace.removeChild(scrollNode);
  }
}

// Scroll a given position into view (immediately), verifying that
// it actually became visible (as line heights are accurately
// measured, the position of something may 'drift' during drawing).
function scrollPosIntoView(cm, pos, end, margin) {
  if (margin == null) { margin = 0; }
  var rect;
  if (!cm.options.lineWrapping && pos == end) {
    // Set pos and end to the cursor positions around the character pos sticks to
    // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
    // If pos == Pos(_, 0, "before"), pos and end are unchanged
    pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
    end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
  }
  for (var limit = 0; limit < 5; limit++) {
    var changed = false;
    var coords = cursorCoords(cm, pos);
    var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
    rect = {left: Math.min(coords.left, endCoords.left),
            top: Math.min(coords.top, endCoords.top) - margin,
            right: Math.max(coords.left, endCoords.left),
            bottom: Math.max(coords.bottom, endCoords.bottom) + margin};
    var scrollPos = calculateScrollPos(cm, rect);
    var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
    if (scrollPos.scrollTop != null) {
      updateScrollTop(cm, scrollPos.scrollTop);
      if (Math.abs(cm.doc.scrollTop - startTop) > 1) { changed = true; }
    }
    if (scrollPos.scrollLeft != null) {
      setScrollLeft(cm, scrollPos.scrollLeft);
      if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) { changed = true; }
    }
    if (!changed) { break }
  }
  return rect
}

// Scroll a given set of coordinates into view (immediately).
function scrollIntoView(cm, rect) {
  var scrollPos = calculateScrollPos(cm, rect);
  if (scrollPos.scrollTop != null) { updateScrollTop(cm, scrollPos.scrollTop); }
  if (scrollPos.scrollLeft != null) { setScrollLeft(cm, scrollPos.scrollLeft); }
}

// Calculate a new scroll position needed to scroll the given
// rectangle into view. Returns an object with scrollTop and
// scrollLeft properties. When these are undefined, the
// vertical/horizontal position does not need to be adjusted.
function calculateScrollPos(cm, rect) {
  var display = cm.display, snapMargin = textHeight(cm.display);
  if (rect.top < 0) { rect.top = 0; }
  var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
  var screen = displayHeight(cm), result = {};
  if (rect.bottom - rect.top > screen) { rect.bottom = rect.top + screen; }
  var docBottom = cm.doc.height + paddingVert(display);
  var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
  if (rect.top < screentop) {
    result.scrollTop = atTop ? 0 : rect.top;
  } else if (rect.bottom > screentop + screen) {
    var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen);
    if (newTop != screentop) { result.scrollTop = newTop; }
  }

  var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
  var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
  var tooWide = rect.right - rect.left > screenw;
  if (tooWide) { rect.right = rect.left + screenw; }
  if (rect.left < 10)
    { result.scrollLeft = 0; }
  else if (rect.left < screenleft)
    { result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10)); }
  else if (rect.right > screenw + screenleft - 3)
    { result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw; }
  return result
}

// Store a relative adjustment to the scroll position in the current
// operation (to be applied when the operation finishes).
function addToScrollTop(cm, top) {
  if (top == null) { return }
  resolveScrollToPos(cm);
  cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
}

// Make sure that at the end of the operation the current cursor is
// shown.
function ensureCursorVisible(cm) {
  resolveScrollToPos(cm);
  var cur = cm.getCursor();
  cm.curOp.scrollToPos = {from: cur, to: cur, margin: cm.options.cursorScrollMargin};
}

function scrollToCoords(cm, x, y) {
  if (x != null || y != null) { resolveScrollToPos(cm); }
  if (x != null) { cm.curOp.scrollLeft = x; }
  if (y != null) { cm.curOp.scrollTop = y; }
}

function scrollToRange(cm, range$$1) {
  resolveScrollToPos(cm);
  cm.curOp.scrollToPos = range$$1;
}

// When an operation has its scrollToPos property set, and another
// scroll action is applied before the end of the operation, this
// 'simulates' scrolling that position into view in a cheap way, so
// that the effect of intermediate scroll commands is not ignored.
function resolveScrollToPos(cm) {
  var range$$1 = cm.curOp.scrollToPos;
  if (range$$1) {
    cm.curOp.scrollToPos = null;
    var from = estimateCoords(cm, range$$1.from), to = estimateCoords(cm, range$$1.to);
    scrollToCoordsRange(cm, from, to, range$$1.margin);
  }
}

function scrollToCoordsRange(cm, from, to, margin) {
  var sPos = calculateScrollPos(cm, {
    left: Math.min(from.left, to.left),
    top: Math.min(from.top, to.top) - margin,
    right: Math.max(from.right, to.right),
    bottom: Math.max(from.bottom, to.bottom) + margin
  });
  scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
}

// Sync the scrollable area and scrollbars, ensure the viewport
// covers the visible area.
function updateScrollTop(cm, val) {
  if (Math.abs(cm.doc.scrollTop - val) < 2) { return }
  if (!gecko) { updateDisplaySimple(cm, {top: val}); }
  setScrollTop(cm, val, true);
  if (gecko) { updateDisplaySimple(cm); }
  startWorker(cm, 100);
}

function setScrollTop(cm, val, forceScroll) {
  val = Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val);
  if (cm.display.scroller.scrollTop == val && !forceScroll) { return }
  cm.doc.scrollTop = val;
  cm.display.scrollbars.setScrollTop(val);
  if (cm.display.scroller.scrollTop != val) { cm.display.scroller.scrollTop = val; }
}

// Sync scroller and scrollbar, ensure the gutter elements are
// aligned.
function setScrollLeft(cm, val, isScroller, forceScroll) {
  val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
  if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) { return }
  cm.doc.scrollLeft = val;
  alignHorizontally(cm);
  if (cm.display.scroller.scrollLeft != val) { cm.display.scroller.scrollLeft = val; }
  cm.display.scrollbars.setScrollLeft(val);
}

// SCROLLBARS

// Prepare DOM reads needed to update the scrollbars. Done in one
// shot to minimize update/measure roundtrips.
function measureForScrollbars(cm) {
  var d = cm.display, gutterW = d.gutters.offsetWidth;
  var docH = Math.round(cm.doc.height + paddingVert(cm.display));
  return {
    clientHeight: d.scroller.clientHeight,
    viewHeight: d.wrapper.clientHeight,
    scrollWidth: d.scroller.scrollWidth, clientWidth: d.scroller.clientWidth,
    viewWidth: d.wrapper.clientWidth,
    barLeft: cm.options.fixedGutter ? gutterW : 0,
    docHeight: docH,
    scrollHeight: docH + scrollGap(cm) + d.barHeight,
    nativeBarWidth: d.nativeBarWidth,
    gutterWidth: gutterW
  }
}

var NativeScrollbars = function(place, scroll, cm) {
  this.cm = cm;
  var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
  var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
  place(vert); place(horiz);

  on(vert, "scroll", function () {
    if (vert.clientHeight) { scroll(vert.scrollTop, "vertical"); }
  });
  on(horiz, "scroll", function () {
    if (horiz.clientWidth) { scroll(horiz.scrollLeft, "horizontal"); }
  });

  this.checkedZeroWidth = false;
  // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
  if (ie && ie_version < 8) { this.horiz.style.minHeight = this.vert.style.minWidth = "18px"; }
};

NativeScrollbars.prototype.update = function (measure) {
  var needsH = measure.scrollWidth > measure.clientWidth + 1;
  var needsV = measure.scrollHeight > measure.clientHeight + 1;
  var sWidth = measure.nativeBarWidth;

  if (needsV) {
    this.vert.style.display = "block";
    this.vert.style.bottom = needsH ? sWidth + "px" : "0";
    var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
    // A bug in IE8 can cause this value to be negative, so guard it.
    this.vert.firstChild.style.height =
      Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
  } else {
    this.vert.style.display = "";
    this.vert.firstChild.style.height = "0";
  }

  if (needsH) {
    this.horiz.style.display = "block";
    this.horiz.style.right = needsV ? sWidth + "px" : "0";
    this.horiz.style.left = measure.barLeft + "px";
    var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
    this.horiz.firstChild.style.width =
      Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
  } else {
    this.horiz.style.display = "";
    this.horiz.firstChild.style.width = "0";
  }

  if (!this.checkedZeroWidth && measure.clientHeight > 0) {
    if (sWidth == 0) { this.zeroWidthHack(); }
    this.checkedZeroWidth = true;
  }

  return {right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0}
};

NativeScrollbars.prototype.setScrollLeft = function (pos) {
  if (this.horiz.scrollLeft != pos) { this.horiz.scrollLeft = pos; }
  if (this.disableHoriz) { this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz"); }
};

NativeScrollbars.prototype.setScrollTop = function (pos) {
  if (this.vert.scrollTop != pos) { this.vert.scrollTop = pos; }
  if (this.disableVert) { this.enableZeroWidthBar(this.vert, this.disableVert, "vert"); }
};

NativeScrollbars.prototype.zeroWidthHack = function () {
  var w = mac && !mac_geMountainLion ? "12px" : "18px";
  this.horiz.style.height = this.vert.style.width = w;
  this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
  this.disableHoriz = new Delayed;
  this.disableVert = new Delayed;
};

NativeScrollbars.prototype.enableZeroWidthBar = function (bar, delay, type) {
  bar.style.pointerEvents = "auto";
  function maybeDisable() {
    // To find out whether the scrollbar is still visible, we
    // check whether the element under the pixel in the bottom
    // right corner of the scrollbar box is the scrollbar box
    // itself (when the bar is still visible) or its filler child
    // (when the bar is hidden). If it is still visible, we keep
    // it enabled, if it's hidden, we disable pointer events.
    var box = bar.getBoundingClientRect();
    var elt$$1 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2)
        : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
    if (elt$$1 != bar) { bar.style.pointerEvents = "none"; }
    else { delay.set(1000, maybeDisable); }
  }
  delay.set(1000, maybeDisable);
};

NativeScrollbars.prototype.clear = function () {
  var parent = this.horiz.parentNode;
  parent.removeChild(this.horiz);
  parent.removeChild(this.vert);
};

var NullScrollbars = function () {};

NullScrollbars.prototype.update = function () { return {bottom: 0, right: 0} };
NullScrollbars.prototype.setScrollLeft = function () {};
NullScrollbars.prototype.setScrollTop = function () {};
NullScrollbars.prototype.clear = function () {};

function updateScrollbars(cm, measure) {
  if (!measure) { measure = measureForScrollbars(cm); }
  var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
  updateScrollbarsInner(cm, measure);
  for (var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++) {
    if (startWidth != cm.display.barWidth && cm.options.lineWrapping)
      { updateHeightsInViewport(cm); }
    updateScrollbarsInner(cm, measureForScrollbars(cm));
    startWidth = cm.display.barWidth; startHeight = cm.display.barHeight;
  }
}

// Re-synchronize the fake scrollbars with the actual size of the
// content.
function updateScrollbarsInner(cm, measure) {
  var d = cm.display;
  var sizes = d.scrollbars.update(measure);

  d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
  d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
  d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";

  if (sizes.right && sizes.bottom) {
    d.scrollbarFiller.style.display = "block";
    d.scrollbarFiller.style.height = sizes.bottom + "px";
    d.scrollbarFiller.style.width = sizes.right + "px";
  } else { d.scrollbarFiller.style.display = ""; }
  if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
    d.gutterFiller.style.display = "block";
    d.gutterFiller.style.height = sizes.bottom + "px";
    d.gutterFiller.style.width = measure.gutterWidth + "px";
  } else { d.gutterFiller.style.display = ""; }
}

var scrollbarModel = {"native": NativeScrollbars, "null": NullScrollbars};

function initScrollbars(cm) {
  if (cm.display.scrollbars) {
    cm.display.scrollbars.clear();
    if (cm.display.scrollbars.addClass)
      { rmClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
  }

  cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function (node) {
    cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
    // Prevent clicks in the scrollbars from killing focus
    on(node, "mousedown", function () {
      if (cm.state.focused) { setTimeout(function () { return cm.display.input.focus(); }, 0); }
    });
    node.setAttribute("cm-not-content", "true");
  }, function (pos, axis) {
    if (axis == "horizontal") { setScrollLeft(cm, pos); }
    else { updateScrollTop(cm, pos); }
  }, cm);
  if (cm.display.scrollbars.addClass)
    { addClass(cm.display.wrapper, cm.display.scrollbars.addClass); }
}

// Operations are used to wrap a series of changes to the editor
// state in such a way that each change won't have to update the
// cursor and display (which would be awkward, slow, and
// error-prone). Instead, display updates are batched and then all
// combined and executed at once.

var nextOpId = 0;
// Start a new operation.
function startOperation(cm) {
  cm.curOp = {
    cm: cm,
    viewChanged: false,      // Flag that indicates that lines might need to be redrawn
    startHeight: cm.doc.height, // Used to detect need to update scrollbar
    forceUpdate: false,      // Used to force a redraw
    updateInput: null,       // Whether to reset the input textarea
    typing: false,           // Whether this reset should be careful to leave existing text (for compositing)
    changeObjs: null,        // Accumulated changes, for firing change events
    cursorActivityHandlers: null, // Set of handlers to fire cursorActivity on
    cursorActivityCalled: 0, // Tracks which cursorActivity handlers have been called already
    selectionChanged: false, // Whether the selection needs to be redrawn
    updateMaxLine: false,    // Set when the widest line needs to be determined anew
    scrollLeft: null, scrollTop: null, // Intermediate scroll position, not pushed to DOM yet
    scrollToPos: null,       // Used to scroll to a specific position
    focus: false,
    id: ++nextOpId           // Unique ID
  };
  pushOperation(cm.curOp);
}

// Finish an operation, updating the display and signalling delayed events
function endOperation(cm) {
  var op = cm.curOp;
  finishOperation(op, function (group) {
    for (var i = 0; i < group.ops.length; i++)
      { group.ops[i].cm.curOp = null; }
    endOperations(group);
  });
}

// The DOM updates done when an operation finishes are batched so
// that the minimum number of relayouts are required.
function endOperations(group) {
  var ops = group.ops;
  for (var i = 0; i < ops.length; i++) // Read DOM
    { endOperation_R1(ops[i]); }
  for (var i$1 = 0; i$1 < ops.length; i$1++) // Write DOM (maybe)
    { endOperation_W1(ops[i$1]); }
  for (var i$2 = 0; i$2 < ops.length; i$2++) // Read DOM
    { endOperation_R2(ops[i$2]); }
  for (var i$3 = 0; i$3 < ops.length; i$3++) // Write DOM (maybe)
    { endOperation_W2(ops[i$3]); }
  for (var i$4 = 0; i$4 < ops.length; i$4++) // Read DOM
    { endOperation_finish(ops[i$4]); }
}

function endOperation_R1(op) {
  var cm = op.cm, display = cm.display;
  maybeClipScrollbars(cm);
  if (op.updateMaxLine) { findMaxLine(cm); }

  op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null ||
    op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom ||
                       op.scrollToPos.to.line >= display.viewTo) ||
    display.maxLineChanged && cm.options.lineWrapping;
  op.update = op.mustUpdate &&
    new DisplayUpdate(cm, op.mustUpdate && {top: op.scrollTop, ensure: op.scrollToPos}, op.forceUpdate);
}

function endOperation_W1(op) {
  op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
}

function endOperation_R2(op) {
  var cm = op.cm, display = cm.display;
  if (op.updatedDisplay) { updateHeightsInViewport(cm); }

  op.barMeasure = measureForScrollbars(cm);

  // If the max line changed since it was last measured, measure it,
  // and ensure the document's width matches it.
  // updateDisplay_W2 will use these properties to do the actual resizing
  if (display.maxLineChanged && !cm.options.lineWrapping) {
    op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
    cm.display.sizerWidth = op.adjustWidthTo;
    op.barMeasure.scrollWidth =
      Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
    op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
  }

  if (op.updatedDisplay || op.selectionChanged)
    { op.preparedSelection = display.input.prepareSelection(); }
}

function endOperation_W2(op) {
  var cm = op.cm;

  if (op.adjustWidthTo != null) {
    cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
    if (op.maxScrollLeft < cm.doc.scrollLeft)
      { setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true); }
    cm.display.maxLineChanged = false;
  }

  var takeFocus = op.focus && op.focus == activeElt();
  if (op.preparedSelection)
    { cm.display.input.showSelection(op.preparedSelection, takeFocus); }
  if (op.updatedDisplay || op.startHeight != cm.doc.height)
    { updateScrollbars(cm, op.barMeasure); }
  if (op.updatedDisplay)
    { setDocumentHeight(cm, op.barMeasure); }

  if (op.selectionChanged) { restartBlink(cm); }

  if (cm.state.focused && op.updateInput)
    { cm.display.input.reset(op.typing); }
  if (takeFocus) { ensureFocus(op.cm); }
}

function endOperation_finish(op) {
  var cm = op.cm, display = cm.display, doc = cm.doc;

  if (op.updatedDisplay) { postUpdateDisplay(cm, op.update); }

  // Abort mouse wheel delta measurement, when scrolling explicitly
  if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos))
    { display.wheelStartX = display.wheelStartY = null; }

  // Propagate the scroll position to the actual DOM scroller
  if (op.scrollTop != null) { setScrollTop(cm, op.scrollTop, op.forceScroll); }

  if (op.scrollLeft != null) { setScrollLeft(cm, op.scrollLeft, true, true); }
  // If we need to scroll a specific position into view, do so.
  if (op.scrollToPos) {
    var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from),
                                 clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
    maybeScrollWindow(cm, rect);
  }

  // Fire events for markers that are hidden/unidden by editing or
  // undoing
  var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
  if (hidden) { for (var i = 0; i < hidden.length; ++i)
    { if (!hidden[i].lines.length) { signal(hidden[i], "hide"); } } }
  if (unhidden) { for (var i$1 = 0; i$1 < unhidden.length; ++i$1)
    { if (unhidden[i$1].lines.length) { signal(unhidden[i$1], "unhide"); } } }

  if (display.wrapper.offsetHeight)
    { doc.scrollTop = cm.display.scroller.scrollTop; }

  // Fire change events, and delayed event handlers
  if (op.changeObjs)
    { signal(cm, "changes", cm, op.changeObjs); }
  if (op.update)
    { op.update.finish(); }
}

// Run the given function in an operation
function runInOp(cm, f) {
  if (cm.curOp) { return f() }
  startOperation(cm);
  try { return f() }
  finally { endOperation(cm); }
}
// Wraps a function in an operation. Returns the wrapped function.
function operation(cm, f) {
  return function() {
    if (cm.curOp) { return f.apply(cm, arguments) }
    startOperation(cm);
    try { return f.apply(cm, arguments) }
    finally { endOperation(cm); }
  }
}
// Used to add methods to editor and doc instances, wrapping them in
// operations.
function methodOp(f) {
  return function() {
    if (this.curOp) { return f.apply(this, arguments) }
    startOperation(this);
    try { return f.apply(this, arguments) }
    finally { endOperation(this); }
  }
}
function docMethodOp(f) {
  return function() {
    var cm = this.cm;
    if (!cm || cm.curOp) { return f.apply(this, arguments) }
    startOperation(cm);
    try { return f.apply(this, arguments) }
    finally { endOperation(cm); }
  }
}

// Updates the display.view data structure for a given change to the
// document. From and to are in pre-change coordinates. Lendiff is
// the amount of lines added or subtracted by the change. This is
// used for changes that span multiple lines, or change the way
// lines are divided into visual lines. regLineChange (below)
// registers single-line changes.
function regChange(cm, from, to, lendiff) {
  if (from == null) { from = cm.doc.first; }
  if (to == null) { to = cm.doc.first + cm.doc.size; }
  if (!lendiff) { lendiff = 0; }

  var display = cm.display;
  if (lendiff && to < display.viewTo &&
      (display.updateLineNumbers == null || display.updateLineNumbers > from))
    { display.updateLineNumbers = from; }

  cm.curOp.viewChanged = true;

  if (from >= display.viewTo) { // Change after
    if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo)
      { resetView(cm); }
  } else if (to <= display.viewFrom) { // Change before
    if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
      resetView(cm);
    } else {
      display.viewFrom += lendiff;
      display.viewTo += lendiff;
    }
  } else if (from <= display.viewFrom && to >= display.viewTo) { // Full overlap
    resetView(cm);
  } else if (from <= display.viewFrom) { // Top overlap
    var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
    if (cut) {
      display.view = display.view.slice(cut.index);
      display.viewFrom = cut.lineN;
      display.viewTo += lendiff;
    } else {
      resetView(cm);
    }
  } else if (to >= display.viewTo) { // Bottom overlap
    var cut$1 = viewCuttingPoint(cm, from, from, -1);
    if (cut$1) {
      display.view = display.view.slice(0, cut$1.index);
      display.viewTo = cut$1.lineN;
    } else {
      resetView(cm);
    }
  } else { // Gap in the middle
    var cutTop = viewCuttingPoint(cm, from, from, -1);
    var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
    if (cutTop && cutBot) {
      display.view = display.view.slice(0, cutTop.index)
        .concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN))
        .concat(display.view.slice(cutBot.index));
      display.viewTo += lendiff;
    } else {
      resetView(cm);
    }
  }

  var ext = display.externalMeasured;
  if (ext) {
    if (to < ext.lineN)
      { ext.lineN += lendiff; }
    else if (from < ext.lineN + ext.size)
      { display.externalMeasured = null; }
  }
}

// Register a change to a single line. Type must be one of "text",
// "gutter", "class", "widget"
function regLineChange(cm, line, type) {
  cm.curOp.viewChanged = true;
  var display = cm.display, ext = cm.display.externalMeasured;
  if (ext && line >= ext.lineN && line < ext.lineN + ext.size)
    { display.externalMeasured = null; }

  if (line < display.viewFrom || line >= display.viewTo) { return }
  var lineView = display.view[findViewIndex(cm, line)];
  if (lineView.node == null) { return }
  var arr = lineView.changes || (lineView.changes = []);
  if (indexOf(arr, type) == -1) { arr.push(type); }
}

// Clear the view.
function resetView(cm) {
  cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
  cm.display.view = [];
  cm.display.viewOffset = 0;
}

function viewCuttingPoint(cm, oldN, newN, dir) {
  var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
  if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size)
    { return {index: index, lineN: newN} }
  var n = cm.display.viewFrom;
  for (var i = 0; i < index; i++)
    { n += view[i].size; }
  if (n != oldN) {
    if (dir > 0) {
      if (index == view.length - 1) { return null }
      diff = (n + view[index].size) - oldN;
      index++;
    } else {
      diff = n - oldN;
    }
    oldN += diff; newN += diff;
  }
  while (visualLineNo(cm.doc, newN) != newN) {
    if (index == (dir < 0 ? 0 : view.length - 1)) { return null }
    newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
    index += dir;
  }
  return {index: index, lineN: newN}
}

// Force the view to cover a given range, adding empty view element
// or clipping off existing ones as needed.
function adjustView(cm, from, to) {
  var display = cm.display, view = display.view;
  if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
    display.view = buildViewArray(cm, from, to);
    display.viewFrom = from;
  } else {
    if (display.viewFrom > from)
      { display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view); }
    else if (display.viewFrom < from)
      { display.view = display.view.slice(findViewIndex(cm, from)); }
    display.viewFrom = from;
    if (display.viewTo < to)
      { display.view = display.view.concat(buildViewArray(cm, display.viewTo, to)); }
    else if (display.viewTo > to)
      { display.view = display.view.slice(0, findViewIndex(cm, to)); }
  }
  display.viewTo = to;
}

// Count the number of lines in the view whose DOM representation is
// out of date (or nonexistent).
function countDirtyView(cm) {
  var view = cm.display.view, dirty = 0;
  for (var i = 0; i < view.length; i++) {
    var lineView = view[i];
    if (!lineView.hidden && (!lineView.node || lineView.changes)) { ++dirty; }
  }
  return dirty
}

// HIGHLIGHT WORKER

function startWorker(cm, time) {
  if (cm.doc.highlightFrontier < cm.display.viewTo)
    { cm.state.highlight.set(time, bind(highlightWorker, cm)); }
}

function highlightWorker(cm) {
  var doc = cm.doc;
  if (doc.highlightFrontier >= cm.display.viewTo) { return }
  var end = +new Date + cm.options.workTime;
  var context = getContextBefore(cm, doc.highlightFrontier);
  var changedLines = [];

  doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function (line) {
    if (context.line >= cm.display.viewFrom) { // Visible
      var oldStyles = line.styles;
      var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
      var highlighted = highlightLine(cm, line, context, true);
      if (resetState) { context.state = resetState; }
      line.styles = highlighted.styles;
      var oldCls = line.styleClasses, newCls = highlighted.classes;
      if (newCls) { line.styleClasses = newCls; }
      else if (oldCls) { line.styleClasses = null; }
      var ischange = !oldStyles || oldStyles.length != line.styles.length ||
        oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
      for (var i = 0; !ischange && i < oldStyles.length; ++i) { ischange = oldStyles[i] != line.styles[i]; }
      if (ischange) { changedLines.push(context.line); }
      line.stateAfter = context.save();
      context.nextLine();
    } else {
      if (line.text.length <= cm.options.maxHighlightLength)
        { processLine(cm, line.text, context); }
      line.stateAfter = context.line % 5 == 0 ? context.save() : null;
      context.nextLine();
    }
    if (+new Date > end) {
      startWorker(cm, cm.options.workDelay);
      return true
    }
  });
  doc.highlightFrontier = context.line;
  doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
  if (changedLines.length) { runInOp(cm, function () {
    for (var i = 0; i < changedLines.length; i++)
      { regLineChange(cm, changedLines[i], "text"); }
  }); }
}

// DISPLAY DRAWING

var DisplayUpdate = function(cm, viewport, force) {
  var display = cm.display;

  this.viewport = viewport;
  // Store some values that we'll need later (but don't want to force a relayout for)
  this.visible = visibleLines(display, cm.doc, viewport);
  this.editorIsHidden = !display.wrapper.offsetWidth;
  this.wrapperHeight = display.wrapper.clientHeight;
  this.wrapperWidth = display.wrapper.clientWidth;
  this.oldDisplayWidth = displayWidth(cm);
  this.force = force;
  this.dims = getDimensions(cm);
  this.events = [];
};

DisplayUpdate.prototype.signal = function (emitter, type) {
  if (hasHandler(emitter, type))
    { this.events.push(arguments); }
};
DisplayUpdate.prototype.finish = function () {
    var this$1 = this;

  for (var i = 0; i < this.events.length; i++)
    { signal.apply(null, this$1.events[i]); }
};

function maybeClipScrollbars(cm) {
  var display = cm.display;
  if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
    display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
    display.heightForcer.style.height = scrollGap(cm) + "px";
    display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
    display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
    display.scrollbarsClipped = true;
  }
}

function selectionSnapshot(cm) {
  if (cm.hasFocus()) { return null }
  var active = activeElt();
  if (!active || !contains(cm.display.lineDiv, active)) { return null }
  var result = {activeElt: active};
  if (window.getSelection) {
    var sel = window.getSelection();
    if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
      result.anchorNode = sel.anchorNode;
      result.anchorOffset = sel.anchorOffset;
      result.focusNode = sel.focusNode;
      result.focusOffset = sel.focusOffset;
    }
  }
  return result
}

function restoreSelection(snapshot) {
  if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) { return }
  snapshot.activeElt.focus();
  if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
    var sel = window.getSelection(), range$$1 = document.createRange();
    range$$1.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
    range$$1.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range$$1);
    sel.extend(snapshot.focusNode, snapshot.focusOffset);
  }
}

// Does the actual updating of the line display. Bails out
// (returning false) when there is nothing to be done and forced is
// false.
function updateDisplayIfNeeded(cm, update) {
  var display = cm.display, doc = cm.doc;

  if (update.editorIsHidden) {
    resetView(cm);
    return false
  }

  // Bail out if the visible area is already rendered and nothing changed.
  if (!update.force &&
      update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo &&
      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) &&
      display.renderedView == display.view && countDirtyView(cm) == 0)
    { return false }

  if (maybeUpdateLineNumberWidth(cm)) {
    resetView(cm);
    update.dims = getDimensions(cm);
  }

  // Compute a suitable new viewport (from & to)
  var end = doc.first + doc.size;
  var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
  var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
  if (display.viewFrom < from && from - display.viewFrom < 20) { from = Math.max(doc.first, display.viewFrom); }
  if (display.viewTo > to && display.viewTo - to < 20) { to = Math.min(end, display.viewTo); }
  if (sawCollapsedSpans) {
    from = visualLineNo(cm.doc, from);
    to = visualLineEndNo(cm.doc, to);
  }

  var different = from != display.viewFrom || to != display.viewTo ||
    display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
  adjustView(cm, from, to);

  display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
  // Position the mover div to align with the current scroll position
  cm.display.mover.style.top = display.viewOffset + "px";

  var toUpdate = countDirtyView(cm);
  if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view &&
      (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo))
    { return false }

  // For big changes, we hide the enclosing element during the
  // update, since that speeds up the operations on most browsers.
  var selSnapshot = selectionSnapshot(cm);
  if (toUpdate > 4) { display.lineDiv.style.display = "none"; }
  patchDisplay(cm, display.updateLineNumbers, update.dims);
  if (toUpdate > 4) { display.lineDiv.style.display = ""; }
  display.renderedView = display.view;
  // There might have been a widget with a focused element that got
  // hidden or updated, if so re-focus it.
  restoreSelection(selSnapshot);

  // Prevent selection and cursors from interfering with the scroll
  // width and height.
  removeChildren(display.cursorDiv);
  removeChildren(display.selectionDiv);
  display.gutters.style.height = display.sizer.style.minHeight = 0;

  if (different) {
    display.lastWrapHeight = update.wrapperHeight;
    display.lastWrapWidth = update.wrapperWidth;
    startWorker(cm, 400);
  }

  display.updateLineNumbers = null;

  return true
}

function postUpdateDisplay(cm, update) {
  var viewport = update.viewport;

  for (var first = true;; first = false) {
    if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
      // Clip forced viewport to actual scrollable area.
      if (viewport && viewport.top != null)
        { viewport = {top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)}; }
      // Updated line heights might result in the drawn area not
      // actually covering the viewport. Keep looping until it does.
      update.visible = visibleLines(cm.display, cm.doc, viewport);
      if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo)
        { break }
    }
    if (!updateDisplayIfNeeded(cm, update)) { break }
    updateHeightsInViewport(cm);
    var barMeasure = measureForScrollbars(cm);
    updateSelection(cm);
    updateScrollbars(cm, barMeasure);
    setDocumentHeight(cm, barMeasure);
    update.force = false;
  }

  update.signal(cm, "update", cm);
  if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
    update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
    cm.display.reportedViewFrom = cm.display.viewFrom; cm.display.reportedViewTo = cm.display.viewTo;
  }
}

function updateDisplaySimple(cm, viewport) {
  var update = new DisplayUpdate(cm, viewport);
  if (updateDisplayIfNeeded(cm, update)) {
    updateHeightsInViewport(cm);
    postUpdateDisplay(cm, update);
    var barMeasure = measureForScrollbars(cm);
    updateSelection(cm);
    updateScrollbars(cm, barMeasure);
    setDocumentHeight(cm, barMeasure);
    update.finish();
  }
}

// Sync the actual display DOM structure with display.view, removing
// nodes for lines that are no longer in view, and creating the ones
// that are not there yet, and updating the ones that are out of
// date.
function patchDisplay(cm, updateNumbersFrom, dims) {
  var display = cm.display, lineNumbers = cm.options.lineNumbers;
  var container = display.lineDiv, cur = container.firstChild;

  function rm(node) {
    var next = node.nextSibling;
    // Works around a throw-scroll bug in OS X Webkit
    if (webkit && mac && cm.display.currentWheelTarget == node)
      { node.style.display = "none"; }
    else
      { node.parentNode.removeChild(node); }
    return next
  }

  var view = display.view, lineN = display.viewFrom;
  // Loop over the elements in the view, syncing cur (the DOM nodes
  // in display.lineDiv) with the view as we go.
  for (var i = 0; i < view.length; i++) {
    var lineView = view[i];
    if (lineView.hidden) {
    } else if (!lineView.node || lineView.node.parentNode != container) { // Not drawn yet
      var node = buildLineElement(cm, lineView, lineN, dims);
      container.insertBefore(node, cur);
    } else { // Already drawn
      while (cur != lineView.node) { cur = rm(cur); }
      var updateNumber = lineNumbers && updateNumbersFrom != null &&
        updateNumbersFrom <= lineN && lineView.lineNumber;
      if (lineView.changes) {
        if (indexOf(lineView.changes, "gutter") > -1) { updateNumber = false; }
        updateLineForChanges(cm, lineView, lineN, dims);
      }
      if (updateNumber) {
        removeChildren(lineView.lineNumber);
        lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
      }
      cur = lineView.node.nextSibling;
    }
    lineN += lineView.size;
  }
  while (cur) { cur = rm(cur); }
}

function updateGutterSpace(cm) {
  var width = cm.display.gutters.offsetWidth;
  cm.display.sizer.style.marginLeft = width + "px";
}

function setDocumentHeight(cm, measure) {
  cm.display.sizer.style.minHeight = measure.docHeight + "px";
  cm.display.heightForcer.style.top = measure.docHeight + "px";
  cm.display.gutters.style.height = (measure.docHeight + cm.display.barHeight + scrollGap(cm)) + "px";
}

// Rebuild the gutter elements, ensure the margin to the left of the
// code matches their width.
function updateGutters(cm) {
  var gutters = cm.display.gutters, specs = cm.options.gutters;
  removeChildren(gutters);
  var i = 0;
  for (; i < specs.length; ++i) {
    var gutterClass = specs[i];
    var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + gutterClass));
    if (gutterClass == "CodeMirror-linenumbers") {
      cm.display.lineGutter = gElt;
      gElt.style.width = (cm.display.lineNumWidth || 1) + "px";
    }
  }
  gutters.style.display = i ? "" : "none";
  updateGutterSpace(cm);
}

// Make sure the gutters options contains the element
// "CodeMirror-linenumbers" when the lineNumbers option is true.
function setGuttersForLineNumbers(options) {
  var found = indexOf(options.gutters, "CodeMirror-linenumbers");
  if (found == -1 && options.lineNumbers) {
    options.gutters = options.gutters.concat(["CodeMirror-linenumbers"]);
  } else if (found > -1 && !options.lineNumbers) {
    options.gutters = options.gutters.slice(0);
    options.gutters.splice(found, 1);
  }
}

// Since the delta values reported on mouse wheel events are
// unstandardized between browsers and even browser versions, and
// generally horribly unpredictable, this code starts by measuring
// the scroll effect that the first few mouse wheel events have,
// and, from that, detects the way it can convert deltas to pixel
// offsets afterwards.
//
// The reason we want to know the amount a wheel event will scroll
// is that it gives us a chance to update the display before the
// actual scrolling happens, reducing flickering.

var wheelSamples = 0;
var wheelPixelsPerUnit = null;
// Fill in a browser-detected starting value on browsers where we
// know one. These don't have to be accurate -- the result of them
// being wrong would just be a slight flicker on the first wheel
// scroll (if it is large enough).
if (ie) { wheelPixelsPerUnit = -.53; }
else if (gecko) { wheelPixelsPerUnit = 15; }
else if (chrome) { wheelPixelsPerUnit = -.7; }
else if (safari) { wheelPixelsPerUnit = -1/3; }

function wheelEventDelta(e) {
  var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
  if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) { dx = e.detail; }
  if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) { dy = e.detail; }
  else if (dy == null) { dy = e.wheelDelta; }
  return {x: dx, y: dy}
}
function wheelEventPixels(e) {
  var delta = wheelEventDelta(e);
  delta.x *= wheelPixelsPerUnit;
  delta.y *= wheelPixelsPerUnit;
  return delta
}

function onScrollWheel(cm, e) {
  var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;

  var display = cm.display, scroll = display.scroller;
  // Quit if there's nothing to scroll here
  var canScrollX = scroll.scrollWidth > scroll.clientWidth;
  var canScrollY = scroll.scrollHeight > scroll.clientHeight;
  if (!(dx && canScrollX || dy && canScrollY)) { return }

  // Webkit browsers on OS X abort momentum scrolls when the target
  // of the scroll event is removed from the scrollable element.
  // This hack (see related code in patchDisplay) makes sure the
  // element is kept around.
  if (dy && mac && webkit) {
    outer: for (var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode) {
      for (var i = 0; i < view.length; i++) {
        if (view[i].node == cur) {
          cm.display.currentWheelTarget = cur;
          break outer
        }
      }
    }
  }

  // On some browsers, horizontal scrolling will cause redraws to
  // happen before the gutter has been realigned, causing it to
  // wriggle around in a most unseemly way. When we have an
  // estimated pixels/delta value, we just handle horizontal
  // scrolling entirely here. It'll be slightly off from native, but
  // better than glitching out.
  if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
    if (dy && canScrollY)
      { updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit)); }
    setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
    // Only prevent default scrolling if vertical scrolling is
    // actually possible. Otherwise, it causes vertical scroll
    // jitter on OSX trackpads when deltaX is small and deltaY
    // is large (issue #3579)
    if (!dy || (dy && canScrollY))
      { e_preventDefault(e); }
    display.wheelStartX = null; // Abort measurement, if in progress
    return
  }

  // 'Project' the visible viewport to cover the area that is being
  // scrolled into view (if we know enough to estimate it).
  if (dy && wheelPixelsPerUnit != null) {
    var pixels = dy * wheelPixelsPerUnit;
    var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
    if (pixels < 0) { top = Math.max(0, top + pixels - 50); }
    else { bot = Math.min(cm.doc.height, bot + pixels + 50); }
    updateDisplaySimple(cm, {top: top, bottom: bot});
  }

  if (wheelSamples < 20) {
    if (display.wheelStartX == null) {
      display.wheelStartX = scroll.scrollLeft; display.wheelStartY = scroll.scrollTop;
      display.wheelDX = dx; display.wheelDY = dy;
      setTimeout(function () {
        if (display.wheelStartX == null) { return }
        var movedX = scroll.scrollLeft - display.wheelStartX;
        var movedY = scroll.scrollTop - display.wheelStartY;
        var sample = (movedY && display.wheelDY && movedY / display.wheelDY) ||
          (movedX && display.wheelDX && movedX / display.wheelDX);
        display.wheelStartX = display.wheelStartY = null;
        if (!sample) { return }
        wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
        ++wheelSamples;
      }, 200);
    } else {
      display.wheelDX += dx; display.wheelDY += dy;
    }
  }
}

// Selection objects are immutable. A new one is created every time
// the selection changes. A selection is one or more non-overlapping
// (and non-touching) ranges, sorted, and an integer that indicates
// which one is the primary selection (the one that's scrolled into
// view, that getCursor returns, etc).
var Selection = function(ranges, primIndex) {
  this.ranges = ranges;
  this.primIndex = primIndex;
};

Selection.prototype.primary = function () { return this.ranges[this.primIndex] };

Selection.prototype.equals = function (other) {
    var this$1 = this;

  if (other == this) { return true }
  if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) { return false }
  for (var i = 0; i < this.ranges.length; i++) {
    var here = this$1.ranges[i], there = other.ranges[i];
    if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) { return false }
  }
  return true
};

Selection.prototype.deepCopy = function () {
    var this$1 = this;

  var out = [];
  for (var i = 0; i < this.ranges.length; i++)
    { out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head)); }
  return new Selection(out, this.primIndex)
};

Selection.prototype.somethingSelected = function () {
    var this$1 = this;

  for (var i = 0; i < this.ranges.length; i++)
    { if (!this$1.ranges[i].empty()) { return true } }
  return false
};

Selection.prototype.contains = function (pos, end) {
    var this$1 = this;

  if (!end) { end = pos; }
  for (var i = 0; i < this.ranges.length; i++) {
    var range = this$1.ranges[i];
    if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0)
      { return i }
  }
  return -1
};

var Range = function(anchor, head) {
  this.anchor = anchor; this.head = head;
};

Range.prototype.from = function () { return minPos(this.anchor, this.head) };
Range.prototype.to = function () { return maxPos(this.anchor, this.head) };
Range.prototype.empty = function () { return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch };

// Take an unsorted, potentially overlapping set of ranges, and
// build a selection out of it. 'Consumes' ranges array (modifying
// it).
function normalizeSelection(ranges, primIndex) {
  var prim = ranges[primIndex];
  ranges.sort(function (a, b) { return cmp(a.from(), b.from()); });
  primIndex = indexOf(ranges, prim);
  for (var i = 1; i < ranges.length; i++) {
    var cur = ranges[i], prev = ranges[i - 1];
    if (cmp(prev.to(), cur.from()) >= 0) {
      var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
      var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
      if (i <= primIndex) { --primIndex; }
      ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
    }
  }
  return new Selection(ranges, primIndex)
}

function simpleSelection(anchor, head) {
  return new Selection([new Range(anchor, head || anchor)], 0)
}

// Compute the position of the end of a change (its 'to' property
// refers to the pre-change end).
function changeEnd(change) {
  if (!change.text) { return change.to }
  return Pos(change.from.line + change.text.length - 1,
             lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0))
}

// Adjust a position to refer to the post-change position of the
// same text, or the end of the change if the change covers it.
function adjustForChange(pos, change) {
  if (cmp(pos, change.from) < 0) { return pos }
  if (cmp(pos, change.to) <= 0) { return changeEnd(change) }

  var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
  if (pos.line == change.to.line) { ch += changeEnd(change).ch - change.to.ch; }
  return Pos(line, ch)
}

function computeSelAfterChange(doc, change) {
  var out = [];
  for (var i = 0; i < doc.sel.ranges.length; i++) {
    var range = doc.sel.ranges[i];
    out.push(new Range(adjustForChange(range.anchor, change),
                       adjustForChange(range.head, change)));
  }
  return normalizeSelection(out, doc.sel.primIndex)
}

function offsetPos(pos, old, nw) {
  if (pos.line == old.line)
    { return Pos(nw.line, pos.ch - old.ch + nw.ch) }
  else
    { return Pos(nw.line + (pos.line - old.line), pos.ch) }
}

// Used by replaceSelections to allow moving the selection to the
// start or around the replaced test. Hint may be "start" or "around".
function computeReplacedSel(doc, changes, hint) {
  var out = [];
  var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
  for (var i = 0; i < changes.length; i++) {
    var change = changes[i];
    var from = offsetPos(change.from, oldPrev, newPrev);
    var to = offsetPos(changeEnd(change), oldPrev, newPrev);
    oldPrev = change.to;
    newPrev = to;
    if (hint == "around") {
      var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
      out[i] = new Range(inv ? to : from, inv ? from : to);
    } else {
      out[i] = new Range(from, from);
    }
  }
  return new Selection(out, doc.sel.primIndex)
}

// Used to get the editor into a consistent state again when options change.

function loadMode(cm) {
  cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
  resetModeState(cm);
}

function resetModeState(cm) {
  cm.doc.iter(function (line) {
    if (line.stateAfter) { line.stateAfter = null; }
    if (line.styles) { line.styles = null; }
  });
  cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
  startWorker(cm, 100);
  cm.state.modeGen++;
  if (cm.curOp) { regChange(cm); }
}

// DOCUMENT DATA STRUCTURE

// By default, updates that start and end at the beginning of a line
// are treated specially, in order to make the association of line
// widgets and marker elements with the text behave more intuitive.
function isWholeLineUpdate(doc, change) {
  return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" &&
    (!doc.cm || doc.cm.options.wholeLineUpdateBefore)
}

// Perform a change on the document data structure.
function updateDoc(doc, change, markedSpans, estimateHeight$$1) {
  function spansFor(n) {return markedSpans ? markedSpans[n] : null}
  function update(line, text, spans) {
    updateLine(line, text, spans, estimateHeight$$1);
    signalLater(line, "change", line, change);
  }
  function linesFor(start, end) {
    var result = [];
    for (var i = start; i < end; ++i)
      { result.push(new Line(text[i], spansFor(i), estimateHeight$$1)); }
    return result
  }

  var from = change.from, to = change.to, text = change.text;
  var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
  var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;

  // Adjust the line structure
  if (change.full) {
    doc.insert(0, linesFor(0, text.length));
    doc.remove(text.length, doc.size - text.length);
  } else if (isWholeLineUpdate(doc, change)) {
    // This is a whole-line replace. Treated specially to make
    // sure line objects move the way they are supposed to.
    var added = linesFor(0, text.length - 1);
    update(lastLine, lastLine.text, lastSpans);
    if (nlines) { doc.remove(from.line, nlines); }
    if (added.length) { doc.insert(from.line, added); }
  } else if (firstLine == lastLine) {
    if (text.length == 1) {
      update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
    } else {
      var added$1 = linesFor(1, text.length - 1);
      added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight$$1));
      update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
      doc.insert(from.line + 1, added$1);
    }
  } else if (text.length == 1) {
    update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
    doc.remove(from.line + 1, nlines);
  } else {
    update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
    update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
    var added$2 = linesFor(1, text.length - 1);
    if (nlines > 1) { doc.remove(from.line + 1, nlines - 1); }
    doc.insert(from.line + 1, added$2);
  }

  signalLater(doc, "change", doc, change);
}

// Call f for all linked documents.
function linkedDocs(doc, f, sharedHistOnly) {
  function propagate(doc, skip, sharedHist) {
    if (doc.linked) { for (var i = 0; i < doc.linked.length; ++i) {
      var rel = doc.linked[i];
      if (rel.doc == skip) { continue }
      var shared = sharedHist && rel.sharedHist;
      if (sharedHistOnly && !shared) { continue }
      f(rel.doc, shared);
      propagate(rel.doc, doc, shared);
    } }
  }
  propagate(doc, null, true);
}

// Attach a document to an editor.
function attachDoc(cm, doc) {
  if (doc.cm) { throw new Error("This document is already in use.") }
  cm.doc = doc;
  doc.cm = cm;
  estimateLineHeights(cm);
  loadMode(cm);
  setDirectionClass(cm);
  if (!cm.options.lineWrapping) { findMaxLine(cm); }
  cm.options.mode = doc.modeOption;
  regChange(cm);
}

function setDirectionClass(cm) {
  (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
}

function directionChanged(cm) {
  runInOp(cm, function () {
    setDirectionClass(cm);
    regChange(cm);
  });
}

function History(startGen) {
  // Arrays of change events and selections. Doing something adds an
  // event to done and clears undo. Undoing moves events from done
  // to undone, redoing moves them in the other direction.
  this.done = []; this.undone = [];
  this.undoDepth = Infinity;
  // Used to track when changes can be merged into a single undo
  // event
  this.lastModTime = this.lastSelTime = 0;
  this.lastOp = this.lastSelOp = null;
  this.lastOrigin = this.lastSelOrigin = null;
  // Used by the isClean() method
  this.generation = this.maxGeneration = startGen || 1;
}

// Create a history change event from an updateDoc-style change
// object.
function historyChangeFromChange(doc, change) {
  var histChange = {from: copyPos(change.from), to: changeEnd(change), text: getBetween(doc, change.from, change.to)};
  attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
  linkedDocs(doc, function (doc) { return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1); }, true);
  return histChange
}

// Pop all selection events off the end of a history array. Stop at
// a change event.
function clearSelectionEvents(array) {
  while (array.length) {
    var last = lst(array);
    if (last.ranges) { array.pop(); }
    else { break }
  }
}

// Find the top change event in the history. Pop off selection
// events that are in the way.
function lastChangeEvent(hist, force) {
  if (force) {
    clearSelectionEvents(hist.done);
    return lst(hist.done)
  } else if (hist.done.length && !lst(hist.done).ranges) {
    return lst(hist.done)
  } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
    hist.done.pop();
    return lst(hist.done)
  }
}

// Register a change in the history. Merges changes that are within
// a single operation, or are close together with an origin that
// allows merging (starting with "+") into a single event.
function addChangeToHistory(doc, change, selAfter, opId) {
  var hist = doc.history;
  hist.undone.length = 0;
  var time = +new Date, cur;
  var last;

  if ((hist.lastOp == opId ||
       hist.lastOrigin == change.origin && change.origin &&
       ((change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500)) ||
        change.origin.charAt(0) == "*")) &&
      (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
    // Merge this change into the last event
    last = lst(cur.changes);
    if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) {
      // Optimized case for simple insertion -- don't want to add
      // new changesets for every character typed
      last.to = changeEnd(change);
    } else {
      // Add new sub-event
      cur.changes.push(historyChangeFromChange(doc, change));
    }
  } else {
    // Can not be merged, start a new event.
    var before = lst(hist.done);
    if (!before || !before.ranges)
      { pushSelectionToHistory(doc.sel, hist.done); }
    cur = {changes: [historyChangeFromChange(doc, change)],
           generation: hist.generation};
    hist.done.push(cur);
    while (hist.done.length > hist.undoDepth) {
      hist.done.shift();
      if (!hist.done[0].ranges) { hist.done.shift(); }
    }
  }
  hist.done.push(selAfter);
  hist.generation = ++hist.maxGeneration;
  hist.lastModTime = hist.lastSelTime = time;
  hist.lastOp = hist.lastSelOp = opId;
  hist.lastOrigin = hist.lastSelOrigin = change.origin;

  if (!last) { signal(doc, "historyAdded"); }
}

function selectionEventCanBeMerged(doc, origin, prev, sel) {
  var ch = origin.charAt(0);
  return ch == "*" ||
    ch == "+" &&
    prev.ranges.length == sel.ranges.length &&
    prev.somethingSelected() == sel.somethingSelected() &&
    new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500)
}

// Called whenever the selection changes, sets the new selection as
// the pending selection in the history, and pushes the old pending
// selection into the 'done' array when it was significantly
// different (in number of selected ranges, emptiness, or time).
function addSelectionToHistory(doc, sel, opId, options) {
  var hist = doc.history, origin = options && options.origin;

  // A new event is started when the previous origin does not match
  // the current, or the origins don't allow matching. Origins
  // starting with * are always merged, those starting with + are
  // merged when similar and close together in time.
  if (opId == hist.lastSelOp ||
      (origin && hist.lastSelOrigin == origin &&
       (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin ||
        selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))))
    { hist.done[hist.done.length - 1] = sel; }
  else
    { pushSelectionToHistory(sel, hist.done); }

  hist.lastSelTime = +new Date;
  hist.lastSelOrigin = origin;
  hist.lastSelOp = opId;
  if (options && options.clearRedo !== false)
    { clearSelectionEvents(hist.undone); }
}

function pushSelectionToHistory(sel, dest) {
  var top = lst(dest);
  if (!(top && top.ranges && top.equals(sel)))
    { dest.push(sel); }
}

// Used to store marked span information in the history.
function attachLocalSpans(doc, change, from, to) {
  var existing = change["spans_" + doc.id], n = 0;
  doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function (line) {
    if (line.markedSpans)
      { (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans; }
    ++n;
  });
}

// When un/re-doing restores text containing marked spans, those
// that have been explicitly cleared should not be restored.
function removeClearedSpans(spans) {
  if (!spans) { return null }
  var out;
  for (var i = 0; i < spans.length; ++i) {
    if (spans[i].marker.explicitlyCleared) { if (!out) { out = spans.slice(0, i); } }
    else if (out) { out.push(spans[i]); }
  }
  return !out ? spans : out.length ? out : null
}

// Retrieve and filter the old marked spans stored in a change event.
function getOldSpans(doc, change) {
  var found = change["spans_" + doc.id];
  if (!found) { return null }
  var nw = [];
  for (var i = 0; i < change.text.length; ++i)
    { nw.push(removeClearedSpans(found[i])); }
  return nw
}

// Used for un/re-doing changes from the history. Combines the
// result of computing the existing spans with the set of spans that
// existed in the history (so that deleting around a span and then
// undoing brings back the span).
function mergeOldSpans(doc, change) {
  var old = getOldSpans(doc, change);
  var stretched = stretchSpansOverChange(doc, change);
  if (!old) { return stretched }
  if (!stretched) { return old }

  for (var i = 0; i < old.length; ++i) {
    var oldCur = old[i], stretchCur = stretched[i];
    if (oldCur && stretchCur) {
      spans: for (var j = 0; j < stretchCur.length; ++j) {
        var span = stretchCur[j];
        for (var k = 0; k < oldCur.length; ++k)
          { if (oldCur[k].marker == span.marker) { continue spans } }
        oldCur.push(span);
      }
    } else if (stretchCur) {
      old[i] = stretchCur;
    }
  }
  return old
}

// Used both to provide a JSON-safe object in .getHistory, and, when
// detaching a document, to split the history in two
function copyHistoryArray(events, newGroup, instantiateSel) {
  var copy = [];
  for (var i = 0; i < events.length; ++i) {
    var event = events[i];
    if (event.ranges) {
      copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
      continue
    }
    var changes = event.changes, newChanges = [];
    copy.push({changes: newChanges});
    for (var j = 0; j < changes.length; ++j) {
      var change = changes[j], m = (void 0);
      newChanges.push({from: change.from, to: change.to, text: change.text});
      if (newGroup) { for (var prop in change) { if (m = prop.match(/^spans_(\d+)$/)) {
        if (indexOf(newGroup, Number(m[1])) > -1) {
          lst(newChanges)[prop] = change[prop];
          delete change[prop];
        }
      } } }
    }
  }
  return copy
}

// The 'scroll' parameter given to many of these indicated whether
// the new cursor position should be scrolled into view after
// modifying the selection.

// If shift is held or the extend flag is set, extends a range to
// include a given position (and optionally a second position).
// Otherwise, simply returns the range between the given positions.
// Used for cursor motion and such.
function extendRange(range, head, other, extend) {
  if (extend) {
    var anchor = range.anchor;
    if (other) {
      var posBefore = cmp(head, anchor) < 0;
      if (posBefore != (cmp(other, anchor) < 0)) {
        anchor = head;
        head = other;
      } else if (posBefore != (cmp(head, other) < 0)) {
        head = other;
      }
    }
    return new Range(anchor, head)
  } else {
    return new Range(other || head, head)
  }
}

// Extend the primary selection range, discard the rest.
function extendSelection(doc, head, other, options, extend) {
  if (extend == null) { extend = doc.cm && (doc.cm.display.shift || doc.extend); }
  setSelection(doc, new Selection([extendRange(doc.sel.primary(), head, other, extend)], 0), options);
}

// Extend all selections (pos is an array of selections with length
// equal the number of selections)
function extendSelections(doc, heads, options) {
  var out = [];
  var extend = doc.cm && (doc.cm.display.shift || doc.extend);
  for (var i = 0; i < doc.sel.ranges.length; i++)
    { out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend); }
  var newSel = normalizeSelection(out, doc.sel.primIndex);
  setSelection(doc, newSel, options);
}

// Updates a single range in the selection.
function replaceOneSelection(doc, i, range, options) {
  var ranges = doc.sel.ranges.slice(0);
  ranges[i] = range;
  setSelection(doc, normalizeSelection(ranges, doc.sel.primIndex), options);
}

// Reset the selection to a single range.
function setSimpleSelection(doc, anchor, head, options) {
  setSelection(doc, simpleSelection(anchor, head), options);
}

// Give beforeSelectionChange handlers a change to influence a
// selection update.
function filterSelectionChange(doc, sel, options) {
  var obj = {
    ranges: sel.ranges,
    update: function(ranges) {
      var this$1 = this;

      this.ranges = [];
      for (var i = 0; i < ranges.length; i++)
        { this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor),
                                   clipPos(doc, ranges[i].head)); }
    },
    origin: options && options.origin
  };
  signal(doc, "beforeSelectionChange", doc, obj);
  if (doc.cm) { signal(doc.cm, "beforeSelectionChange", doc.cm, obj); }
  if (obj.ranges != sel.ranges) { return normalizeSelection(obj.ranges, obj.ranges.length - 1) }
  else { return sel }
}

function setSelectionReplaceHistory(doc, sel, options) {
  var done = doc.history.done, last = lst(done);
  if (last && last.ranges) {
    done[done.length - 1] = sel;
    setSelectionNoUndo(doc, sel, options);
  } else {
    setSelection(doc, sel, options);
  }
}

// Set a new selection.
function setSelection(doc, sel, options) {
  setSelectionNoUndo(doc, sel, options);
  addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
}

function setSelectionNoUndo(doc, sel, options) {
  if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange"))
    { sel = filterSelectionChange(doc, sel, options); }

  var bias = options && options.bias ||
    (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
  setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));

  if (!(options && options.scroll === false) && doc.cm)
    { ensureCursorVisible(doc.cm); }
}

function setSelectionInner(doc, sel) {
  if (sel.equals(doc.sel)) { return }

  doc.sel = sel;

  if (doc.cm) {
    doc.cm.curOp.updateInput = doc.cm.curOp.selectionChanged = true;
    signalCursorActivity(doc.cm);
  }
  signalLater(doc, "cursorActivity", doc);
}

// Verify that the selection does not partially select any atomic
// marked ranges.
function reCheckSelection(doc) {
  setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
}

// Return a selection that does not partially select any atomic
// ranges.
function skipAtomicInSelection(doc, sel, bias, mayClear) {
  var out;
  for (var i = 0; i < sel.ranges.length; i++) {
    var range = sel.ranges[i];
    var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
    var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
    var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
    if (out || newAnchor != range.anchor || newHead != range.head) {
      if (!out) { out = sel.ranges.slice(0, i); }
      out[i] = new Range(newAnchor, newHead);
    }
  }
  return out ? normalizeSelection(out, sel.primIndex) : sel
}

function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
  var line = getLine(doc, pos.line);
  if (line.markedSpans) { for (var i = 0; i < line.markedSpans.length; ++i) {
    var sp = line.markedSpans[i], m = sp.marker;
    if ((sp.from == null || (m.inclusiveLeft ? sp.from <= pos.ch : sp.from < pos.ch)) &&
        (sp.to == null || (m.inclusiveRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
      if (mayClear) {
        signal(m, "beforeCursorEnter");
        if (m.explicitlyCleared) {
          if (!line.markedSpans) { break }
          else {--i; continue}
        }
      }
      if (!m.atomic) { continue }

      if (oldPos) {
        var near = m.find(dir < 0 ? 1 : -1), diff = (void 0);
        if (dir < 0 ? m.inclusiveRight : m.inclusiveLeft)
          { near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null); }
        if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0))
          { return skipAtomicInner(doc, near, pos, dir, mayClear) }
      }

      var far = m.find(dir < 0 ? -1 : 1);
      if (dir < 0 ? m.inclusiveLeft : m.inclusiveRight)
        { far = movePos(doc, far, dir, far.line == pos.line ? line : null); }
      return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null
    }
  } }
  return pos
}

// Ensure a given position is not inside an atomic range.
function skipAtomic(doc, pos, oldPos, bias, mayClear) {
  var dir = bias || 1;
  var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) ||
      (!mayClear && skipAtomicInner(doc, pos, oldPos, dir, true)) ||
      skipAtomicInner(doc, pos, oldPos, -dir, mayClear) ||
      (!mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true));
  if (!found) {
    doc.cantEdit = true;
    return Pos(doc.first, 0)
  }
  return found
}

function movePos(doc, pos, dir, line) {
  if (dir < 0 && pos.ch == 0) {
    if (pos.line > doc.first) { return clipPos(doc, Pos(pos.line - 1)) }
    else { return null }
  } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
    if (pos.line < doc.first + doc.size - 1) { return Pos(pos.line + 1, 0) }
    else { return null }
  } else {
    return new Pos(pos.line, pos.ch + dir)
  }
}

function selectAll(cm) {
  cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
}

// UPDATING

// Allow "beforeChange" event handlers to influence a change
function filterChange(doc, change, update) {
  var obj = {
    canceled: false,
    from: change.from,
    to: change.to,
    text: change.text,
    origin: change.origin,
    cancel: function () { return obj.canceled = true; }
  };
  if (update) { obj.update = function (from, to, text, origin) {
    if (from) { obj.from = clipPos(doc, from); }
    if (to) { obj.to = clipPos(doc, to); }
    if (text) { obj.text = text; }
    if (origin !== undefined) { obj.origin = origin; }
  }; }
  signal(doc, "beforeChange", doc, obj);
  if (doc.cm) { signal(doc.cm, "beforeChange", doc.cm, obj); }

  if (obj.canceled) { return null }
  return {from: obj.from, to: obj.to, text: obj.text, origin: obj.origin}
}

// Apply a change to a document, and add it to the document's
// history, and propagating it to all linked documents.
function makeChange(doc, change, ignoreReadOnly) {
  if (doc.cm) {
    if (!doc.cm.curOp) { return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly) }
    if (doc.cm.state.suppressEdits) { return }
  }

  if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
    change = filterChange(doc, change, true);
    if (!change) { return }
  }

  // Possibly split or suppress the update based on the presence
  // of read-only spans in its range.
  var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
  if (split) {
    for (var i = split.length - 1; i >= 0; --i)
      { makeChangeInner(doc, {from: split[i].from, to: split[i].to, text: i ? [""] : change.text, origin: change.origin}); }
  } else {
    makeChangeInner(doc, change);
  }
}

function makeChangeInner(doc, change) {
  if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) { return }
  var selAfter = computeSelAfterChange(doc, change);
  addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);

  makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
  var rebased = [];

  linkedDocs(doc, function (doc, sharedHist) {
    if (!sharedHist && indexOf(rebased, doc.history) == -1) {
      rebaseHist(doc.history, change);
      rebased.push(doc.history);
    }
    makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
  });
}

// Revert a change stored in a document's history.
function makeChangeFromHistory(doc, type, allowSelectionOnly) {
  var suppress = doc.cm && doc.cm.state.suppressEdits;
  if (suppress && !allowSelectionOnly) { return }

  var hist = doc.history, event, selAfter = doc.sel;
  var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;

  // Verify that there is a useable event (so that ctrl-z won't
  // needlessly clear selection events)
  var i = 0;
  for (; i < source.length; i++) {
    event = source[i];
    if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges)
      { break }
  }
  if (i == source.length) { return }
  hist.lastOrigin = hist.lastSelOrigin = null;

  for (;;) {
    event = source.pop();
    if (event.ranges) {
      pushSelectionToHistory(event, dest);
      if (allowSelectionOnly && !event.equals(doc.sel)) {
        setSelection(doc, event, {clearRedo: false});
        return
      }
      selAfter = event;
    } else if (suppress) {
      source.push(event);
      return
    } else { break }
  }

  // Build up a reverse change object to add to the opposite history
  // stack (redo when undoing, and vice versa).
  var antiChanges = [];
  pushSelectionToHistory(selAfter, dest);
  dest.push({changes: antiChanges, generation: hist.generation});
  hist.generation = event.generation || ++hist.maxGeneration;

  var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");

  var loop = function ( i ) {
    var change = event.changes[i];
    change.origin = type;
    if (filter && !filterChange(doc, change, false)) {
      source.length = 0;
      return {}
    }

    antiChanges.push(historyChangeFromChange(doc, change));

    var after = i ? computeSelAfterChange(doc, change) : lst(source);
    makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
    if (!i && doc.cm) { doc.cm.scrollIntoView({from: change.from, to: changeEnd(change)}); }
    var rebased = [];

    // Propagate to the linked documents
    linkedDocs(doc, function (doc, sharedHist) {
      if (!sharedHist && indexOf(rebased, doc.history) == -1) {
        rebaseHist(doc.history, change);
        rebased.push(doc.history);
      }
      makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
    });
  };

  for (var i$1 = event.changes.length - 1; i$1 >= 0; --i$1) {
    var returned = loop( i$1 );

    if ( returned ) return returned.v;
  }
}

// Sub-views need their line numbers shifted when text is added
// above or below them in the parent document.
function shiftDoc(doc, distance) {
  if (distance == 0) { return }
  doc.first += distance;
  doc.sel = new Selection(map(doc.sel.ranges, function (range) { return new Range(
    Pos(range.anchor.line + distance, range.anchor.ch),
    Pos(range.head.line + distance, range.head.ch)
  ); }), doc.sel.primIndex);
  if (doc.cm) {
    regChange(doc.cm, doc.first, doc.first - distance, distance);
    for (var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)
      { regLineChange(doc.cm, l, "gutter"); }
  }
}

// More lower-level change function, handling only a single document
// (not linked ones).
function makeChangeSingleDoc(doc, change, selAfter, spans) {
  if (doc.cm && !doc.cm.curOp)
    { return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans) }

  if (change.to.line < doc.first) {
    shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
    return
  }
  if (change.from.line > doc.lastLine()) { return }

  // Clip the change to the size of this doc
  if (change.from.line < doc.first) {
    var shift = change.text.length - 1 - (doc.first - change.from.line);
    shiftDoc(doc, shift);
    change = {from: Pos(doc.first, 0), to: Pos(change.to.line + shift, change.to.ch),
              text: [lst(change.text)], origin: change.origin};
  }
  var last = doc.lastLine();
  if (change.to.line > last) {
    change = {from: change.from, to: Pos(last, getLine(doc, last).text.length),
              text: [change.text[0]], origin: change.origin};
  }

  change.removed = getBetween(doc, change.from, change.to);

  if (!selAfter) { selAfter = computeSelAfterChange(doc, change); }
  if (doc.cm) { makeChangeSingleDocInEditor(doc.cm, change, spans); }
  else { updateDoc(doc, change, spans); }
  setSelectionNoUndo(doc, selAfter, sel_dontScroll);
}

// Handle the interaction of a change to a document with the editor
// that this document is part of.
function makeChangeSingleDocInEditor(cm, change, spans) {
  var doc = cm.doc, display = cm.display, from = change.from, to = change.to;

  var recomputeMaxLength = false, checkWidthStart = from.line;
  if (!cm.options.lineWrapping) {
    checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
    doc.iter(checkWidthStart, to.line + 1, function (line) {
      if (line == display.maxLine) {
        recomputeMaxLength = true;
        return true
      }
    });
  }

  if (doc.sel.contains(change.from, change.to) > -1)
    { signalCursorActivity(cm); }

  updateDoc(doc, change, spans, estimateHeight(cm));

  if (!cm.options.lineWrapping) {
    doc.iter(checkWidthStart, from.line + change.text.length, function (line) {
      var len = lineLength(line);
      if (len > display.maxLineLength) {
        display.maxLine = line;
        display.maxLineLength = len;
        display.maxLineChanged = true;
        recomputeMaxLength = false;
      }
    });
    if (recomputeMaxLength) { cm.curOp.updateMaxLine = true; }
  }

  retreatFrontier(doc, from.line);
  startWorker(cm, 400);

  var lendiff = change.text.length - (to.line - from.line) - 1;
  // Remember that these lines changed, for updating the display
  if (change.full)
    { regChange(cm); }
  else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change))
    { regLineChange(cm, from.line, "text"); }
  else
    { regChange(cm, from.line, to.line + 1, lendiff); }

  var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
  if (changeHandler || changesHandler) {
    var obj = {
      from: from, to: to,
      text: change.text,
      removed: change.removed,
      origin: change.origin
    };
    if (changeHandler) { signalLater(cm, "change", cm, obj); }
    if (changesHandler) { (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj); }
  }
  cm.display.selForContextMenu = null;
}

function replaceRange(doc, code, from, to, origin) {
  if (!to) { to = from; }
  if (cmp(to, from) < 0) { var assign;
    (assign = [to, from], from = assign[0], to = assign[1]); }
  if (typeof code == "string") { code = doc.splitLines(code); }
  makeChange(doc, {from: from, to: to, text: code, origin: origin});
}

// Rebasing/resetting history to deal with externally-sourced changes

function rebaseHistSelSingle(pos, from, to, diff) {
  if (to < pos.line) {
    pos.line += diff;
  } else if (from < pos.line) {
    pos.line = from;
    pos.ch = 0;
  }
}

// Tries to rebase an array of history events given a change in the
// document. If the change touches the same lines as the event, the
// event, and everything 'behind' it, is discarded. If the change is
// before the event, the event's positions are updated. Uses a
// copy-on-write scheme for the positions, to avoid having to
// reallocate them all on every rebase, but also avoid problems with
// shared position objects being unsafely updated.
function rebaseHistArray(array, from, to, diff) {
  for (var i = 0; i < array.length; ++i) {
    var sub = array[i], ok = true;
    if (sub.ranges) {
      if (!sub.copied) { sub = array[i] = sub.deepCopy(); sub.copied = true; }
      for (var j = 0; j < sub.ranges.length; j++) {
        rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
        rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
      }
      continue
    }
    for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
      var cur = sub.changes[j$1];
      if (to < cur.from.line) {
        cur.from = Pos(cur.from.line + diff, cur.from.ch);
        cur.to = Pos(cur.to.line + diff, cur.to.ch);
      } else if (from <= cur.to.line) {
        ok = false;
        break
      }
    }
    if (!ok) {
      array.splice(0, i + 1);
      i = 0;
    }
  }
}

function rebaseHist(hist, change) {
  var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
  rebaseHistArray(hist.done, from, to, diff);
  rebaseHistArray(hist.undone, from, to, diff);
}

// Utility for applying a change to a line by handle or number,
// returning the number and optionally registering the line as
// changed.
function changeLine(doc, handle, changeType, op) {
  var no = handle, line = handle;
  if (typeof handle == "number") { line = getLine(doc, clipLine(doc, handle)); }
  else { no = lineNo(handle); }
  if (no == null) { return null }
  if (op(line, no) && doc.cm) { regLineChange(doc.cm, no, changeType); }
  return line
}

// The document is represented as a BTree consisting of leaves, with
// chunk of lines in them, and branches, with up to ten leaves or
// other branch nodes below them. The top node is always a branch
// node, and is the document object itself (meaning it has
// additional methods and properties).
//
// All nodes have parent links. The tree is used both to go from
// line numbers to line objects, and to go from objects to numbers.
// It also indexes by height, and is used to convert between height
// and line object, and to find the total height of the document.
//
// See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html

function LeafChunk(lines) {
  var this$1 = this;

  this.lines = lines;
  this.parent = null;
  var height = 0;
  for (var i = 0; i < lines.length; ++i) {
    lines[i].parent = this$1;
    height += lines[i].height;
  }
  this.height = height;
}

LeafChunk.prototype = {
  chunkSize: function() { return this.lines.length },

  // Remove the n lines at offset 'at'.
  removeInner: function(at, n) {
    var this$1 = this;

    for (var i = at, e = at + n; i < e; ++i) {
      var line = this$1.lines[i];
      this$1.height -= line.height;
      cleanUpLine(line);
      signalLater(line, "delete");
    }
    this.lines.splice(at, n);
  },

  // Helper used to collapse a small branch into a single leaf.
  collapse: function(lines) {
    lines.push.apply(lines, this.lines);
  },

  // Insert the given array of lines at offset 'at', count them as
  // having the given height.
  insertInner: function(at, lines, height) {
    var this$1 = this;

    this.height += height;
    this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
    for (var i = 0; i < lines.length; ++i) { lines[i].parent = this$1; }
  },

  // Used to iterate over a part of the tree.
  iterN: function(at, n, op) {
    var this$1 = this;

    for (var e = at + n; at < e; ++at)
      { if (op(this$1.lines[at])) { return true } }
  }
};

function BranchChunk(children) {
  var this$1 = this;

  this.children = children;
  var size = 0, height = 0;
  for (var i = 0; i < children.length; ++i) {
    var ch = children[i];
    size += ch.chunkSize(); height += ch.height;
    ch.parent = this$1;
  }
  this.size = size;
  this.height = height;
  this.parent = null;
}

BranchChunk.prototype = {
  chunkSize: function() { return this.size },

  removeInner: function(at, n) {
    var this$1 = this;

    this.size -= n;
    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at < sz) {
        var rm = Math.min(n, sz - at), oldHeight = child.height;
        child.removeInner(at, rm);
        this$1.height -= oldHeight - child.height;
        if (sz == rm) { this$1.children.splice(i--, 1); child.parent = null; }
        if ((n -= rm) == 0) { break }
        at = 0;
      } else { at -= sz; }
    }
    // If the result is smaller than 25 lines, ensure that it is a
    // single leaf node.
    if (this.size - n < 25 &&
        (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
      var lines = [];
      this.collapse(lines);
      this.children = [new LeafChunk(lines)];
      this.children[0].parent = this;
    }
  },

  collapse: function(lines) {
    var this$1 = this;

    for (var i = 0; i < this.children.length; ++i) { this$1.children[i].collapse(lines); }
  },

  insertInner: function(at, lines, height) {
    var this$1 = this;

    this.size += lines.length;
    this.height += height;
    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at <= sz) {
        child.insertInner(at, lines, height);
        if (child.lines && child.lines.length > 50) {
          // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
          // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
          var remaining = child.lines.length % 25 + 25;
          for (var pos = remaining; pos < child.lines.length;) {
            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
            child.height -= leaf.height;
            this$1.children.splice(++i, 0, leaf);
            leaf.parent = this$1;
          }
          child.lines = child.lines.slice(0, remaining);
          this$1.maybeSpill();
        }
        break
      }
      at -= sz;
    }
  },

  // When a node has grown, check whether it should be split.
  maybeSpill: function() {
    if (this.children.length <= 10) { return }
    var me = this;
    do {
      var spilled = me.children.splice(me.children.length - 5, 5);
      var sibling = new BranchChunk(spilled);
      if (!me.parent) { // Become the parent node
        var copy = new BranchChunk(me.children);
        copy.parent = me;
        me.children = [copy, sibling];
        me = copy;
     } else {
        me.size -= sibling.size;
        me.height -= sibling.height;
        var myIndex = indexOf(me.parent.children, me);
        me.parent.children.splice(myIndex + 1, 0, sibling);
      }
      sibling.parent = me.parent;
    } while (me.children.length > 10)
    me.parent.maybeSpill();
  },

  iterN: function(at, n, op) {
    var this$1 = this;

    for (var i = 0; i < this.children.length; ++i) {
      var child = this$1.children[i], sz = child.chunkSize();
      if (at < sz) {
        var used = Math.min(n, sz - at);
        if (child.iterN(at, used, op)) { return true }
        if ((n -= used) == 0) { break }
        at = 0;
      } else { at -= sz; }
    }
  }
};

// Line widgets are block elements displayed above or below a line.

var LineWidget = function(doc, node, options) {
  var this$1 = this;

  if (options) { for (var opt in options) { if (options.hasOwnProperty(opt))
    { this$1[opt] = options[opt]; } } }
  this.doc = doc;
  this.node = node;
};

LineWidget.prototype.clear = function () {
    var this$1 = this;

  var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
  if (no == null || !ws) { return }
  for (var i = 0; i < ws.length; ++i) { if (ws[i] == this$1) { ws.splice(i--, 1); } }
  if (!ws.length) { line.widgets = null; }
  var height = widgetHeight(this);
  updateLineHeight(line, Math.max(0, line.height - height));
  if (cm) {
    runInOp(cm, function () {
      adjustScrollWhenAboveVisible(cm, line, -height);
      regLineChange(cm, no, "widget");
    });
    signalLater(cm, "lineWidgetCleared", cm, this, no);
  }
};

LineWidget.prototype.changed = function () {
    var this$1 = this;

  var oldH = this.height, cm = this.doc.cm, line = this.line;
  this.height = null;
  var diff = widgetHeight(this) - oldH;
  if (!diff) { return }
  updateLineHeight(line, line.height + diff);
  if (cm) {
    runInOp(cm, function () {
      cm.curOp.forceUpdate = true;
      adjustScrollWhenAboveVisible(cm, line, diff);
      signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
    });
  }
};
eventMixin(LineWidget);

function adjustScrollWhenAboveVisible(cm, line, diff) {
  if (heightAtLine(line) < ((cm.curOp && cm.curOp.scrollTop) || cm.doc.scrollTop))
    { addToScrollTop(cm, diff); }
}

function addLineWidget(doc, handle, node, options) {
  var widget = new LineWidget(doc, node, options);
  var cm = doc.cm;
  if (cm && widget.noHScroll) { cm.display.alignWidgets = true; }
  changeLine(doc, handle, "widget", function (line) {
    var widgets = line.widgets || (line.widgets = []);
    if (widget.insertAt == null) { widgets.push(widget); }
    else { widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget); }
    widget.line = line;
    if (cm && !lineIsHidden(doc, line)) {
      var aboveVisible = heightAtLine(line) < doc.scrollTop;
      updateLineHeight(line, line.height + widgetHeight(widget));
      if (aboveVisible) { addToScrollTop(cm, widget.height); }
      cm.curOp.forceUpdate = true;
    }
    return true
  });
  if (cm) { signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle)); }
  return widget
}

// TEXTMARKERS

// Created with markText and setBookmark methods. A TextMarker is a
// handle that can be used to clear or find a marked position in the
// document. Line objects hold arrays (markedSpans) containing
// {from, to, marker} object pointing to such marker objects, and
// indicating that such a marker is present on that line. Multiple
// lines may point to the same marker when it spans across lines.
// The spans will have null for their from/to properties when the
// marker continues beyond the start/end of the line. Markers have
// links back to the lines they currently touch.

// Collapsed markers have unique ids, in order to be able to order
// them, which is needed for uniquely determining an outer marker
// when they overlap (they may nest, but not partially overlap).
var nextMarkerId = 0;

var TextMarker = function(doc, type) {
  this.lines = [];
  this.type = type;
  this.doc = doc;
  this.id = ++nextMarkerId;
};

// Clear the marker.
TextMarker.prototype.clear = function () {
    var this$1 = this;

  if (this.explicitlyCleared) { return }
  var cm = this.doc.cm, withOp = cm && !cm.curOp;
  if (withOp) { startOperation(cm); }
  if (hasHandler(this, "clear")) {
    var found = this.find();
    if (found) { signalLater(this, "clear", found.from, found.to); }
  }
  var min = null, max = null;
  for (var i = 0; i < this.lines.length; ++i) {
    var line = this$1.lines[i];
    var span = getMarkedSpanFor(line.markedSpans, this$1);
    if (cm && !this$1.collapsed) { regLineChange(cm, lineNo(line), "text"); }
    else if (cm) {
      if (span.to != null) { max = lineNo(line); }
      if (span.from != null) { min = lineNo(line); }
    }
    line.markedSpans = removeMarkedSpan(line.markedSpans, span);
    if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm)
      { updateLineHeight(line, textHeight(cm.display)); }
  }
  if (cm && this.collapsed && !cm.options.lineWrapping) { for (var i$1 = 0; i$1 < this.lines.length; ++i$1) {
    var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual);
    if (len > cm.display.maxLineLength) {
      cm.display.maxLine = visual;
      cm.display.maxLineLength = len;
      cm.display.maxLineChanged = true;
    }
  } }

  if (min != null && cm && this.collapsed) { regChange(cm, min, max + 1); }
  this.lines.length = 0;
  this.explicitlyCleared = true;
  if (this.atomic && this.doc.cantEdit) {
    this.doc.cantEdit = false;
    if (cm) { reCheckSelection(cm.doc); }
  }
  if (cm) { signalLater(cm, "markerCleared", cm, this, min, max); }
  if (withOp) { endOperation(cm); }
  if (this.parent) { this.parent.clear(); }
};

// Find the position of the marker in the document. Returns a {from,
// to} object by default. Side can be passed to get a specific side
// -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
// Pos objects returned contain a line object, rather than a line
// number (used to prevent looking up the same line twice).
TextMarker.prototype.find = function (side, lineObj) {
    var this$1 = this;

  if (side == null && this.type == "bookmark") { side = 1; }
  var from, to;
  for (var i = 0; i < this.lines.length; ++i) {
    var line = this$1.lines[i];
    var span = getMarkedSpanFor(line.markedSpans, this$1);
    if (span.from != null) {
      from = Pos(lineObj ? line : lineNo(line), span.from);
      if (side == -1) { return from }
    }
    if (span.to != null) {
      to = Pos(lineObj ? line : lineNo(line), span.to);
      if (side == 1) { return to }
    }
  }
  return from && {from: from, to: to}
};

// Signals that the marker's widget changed, and surrounding layout
// should be recomputed.
TextMarker.prototype.changed = function () {
    var this$1 = this;

  var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
  if (!pos || !cm) { return }
  runInOp(cm, function () {
    var line = pos.line, lineN = lineNo(pos.line);
    var view = findViewForLine(cm, lineN);
    if (view) {
      clearLineMeasurementCacheFor(view);
      cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
    }
    cm.curOp.updateMaxLine = true;
    if (!lineIsHidden(widget.doc, line) && widget.height != null) {
      var oldHeight = widget.height;
      widget.height = null;
      var dHeight = widgetHeight(widget) - oldHeight;
      if (dHeight)
        { updateLineHeight(line, line.height + dHeight); }
    }
    signalLater(cm, "markerChanged", cm, this$1);
  });
};

TextMarker.prototype.attachLine = function (line) {
  if (!this.lines.length && this.doc.cm) {
    var op = this.doc.cm.curOp;
    if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1)
      { (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this); }
  }
  this.lines.push(line);
};

TextMarker.prototype.detachLine = function (line) {
  this.lines.splice(indexOf(this.lines, line), 1);
  if (!this.lines.length && this.doc.cm) {
    var op = this.doc.cm.curOp;(op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
  }
};
eventMixin(TextMarker);

// Create a marker, wire it up to the right lines, and
function markText(doc, from, to, options, type) {
  // Shared markers (across linked documents) are handled separately
  // (markTextShared will call out to this again, once per
  // document).
  if (options && options.shared) { return markTextShared(doc, from, to, options, type) }
  // Ensure we are in an operation.
  if (doc.cm && !doc.cm.curOp) { return operation(doc.cm, markText)(doc, from, to, options, type) }

  var marker = new TextMarker(doc, type), diff = cmp(from, to);
  if (options) { copyObj(options, marker, false); }
  // Don't connect empty markers unless clearWhenEmpty is false
  if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false)
    { return marker }
  if (marker.replacedWith) {
    // Showing up as a widget implies collapsed (widget replaces text)
    marker.collapsed = true;
    marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
    if (!options.handleMouseEvents) { marker.widgetNode.setAttribute("cm-ignore-events", "true"); }
    if (options.insertLeft) { marker.widgetNode.insertLeft = true; }
  }
  if (marker.collapsed) {
    if (conflictingCollapsedRange(doc, from.line, from, to, marker) ||
        from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker))
      { throw new Error("Inserting collapsed marker partially overlapping an existing one") }
    seeCollapsedSpans();
  }

  if (marker.addToHistory)
    { addChangeToHistory(doc, {from: from, to: to, origin: "markText"}, doc.sel, NaN); }

  var curLine = from.line, cm = doc.cm, updateMaxLine;
  doc.iter(curLine, to.line + 1, function (line) {
    if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine)
      { updateMaxLine = true; }
    if (marker.collapsed && curLine != from.line) { updateLineHeight(line, 0); }
    addMarkedSpan(line, new MarkedSpan(marker,
                                       curLine == from.line ? from.ch : null,
                                       curLine == to.line ? to.ch : null));
    ++curLine;
  });
  // lineIsHidden depends on the presence of the spans, so needs a second pass
  if (marker.collapsed) { doc.iter(from.line, to.line + 1, function (line) {
    if (lineIsHidden(doc, line)) { updateLineHeight(line, 0); }
  }); }

  if (marker.clearOnEnter) { on(marker, "beforeCursorEnter", function () { return marker.clear(); }); }

  if (marker.readOnly) {
    seeReadOnlySpans();
    if (doc.history.done.length || doc.history.undone.length)
      { doc.clearHistory(); }
  }
  if (marker.collapsed) {
    marker.id = ++nextMarkerId;
    marker.atomic = true;
  }
  if (cm) {
    // Sync editor state
    if (updateMaxLine) { cm.curOp.updateMaxLine = true; }
    if (marker.collapsed)
      { regChange(cm, from.line, to.line + 1); }
    else if (marker.className || marker.title || marker.startStyle || marker.endStyle || marker.css)
      { for (var i = from.line; i <= to.line; i++) { regLineChange(cm, i, "text"); } }
    if (marker.atomic) { reCheckSelection(cm.doc); }
    signalLater(cm, "markerAdded", cm, marker);
  }
  return marker
}

// SHARED TEXTMARKERS

// A shared marker spans multiple linked documents. It is
// implemented as a meta-marker-object controlling multiple normal
// markers.
var SharedTextMarker = function(markers, primary) {
  var this$1 = this;

  this.markers = markers;
  this.primary = primary;
  for (var i = 0; i < markers.length; ++i)
    { markers[i].parent = this$1; }
};

SharedTextMarker.prototype.clear = function () {
    var this$1 = this;

  if (this.explicitlyCleared) { return }
  this.explicitlyCleared = true;
  for (var i = 0; i < this.markers.length; ++i)
    { this$1.markers[i].clear(); }
  signalLater(this, "clear");
};

SharedTextMarker.prototype.find = function (side, lineObj) {
  return this.primary.find(side, lineObj)
};
eventMixin(SharedTextMarker);

function markTextShared(doc, from, to, options, type) {
  options = copyObj(options);
  options.shared = false;
  var markers = [markText(doc, from, to, options, type)], primary = markers[0];
  var widget = options.widgetNode;
  linkedDocs(doc, function (doc) {
    if (widget) { options.widgetNode = widget.cloneNode(true); }
    markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
    for (var i = 0; i < doc.linked.length; ++i)
      { if (doc.linked[i].isParent) { return } }
    primary = lst(markers);
  });
  return new SharedTextMarker(markers, primary)
}

function findSharedMarkers(doc) {
  return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function (m) { return m.parent; })
}

function copySharedMarkers(doc, markers) {
  for (var i = 0; i < markers.length; i++) {
    var marker = markers[i], pos = marker.find();
    var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
    if (cmp(mFrom, mTo)) {
      var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
      marker.markers.push(subMark);
      subMark.parent = marker;
    }
  }
}

function detachSharedMarkers(markers) {
  var loop = function ( i ) {
    var marker = markers[i], linked = [marker.primary.doc];
    linkedDocs(marker.primary.doc, function (d) { return linked.push(d); });
    for (var j = 0; j < marker.markers.length; j++) {
      var subMarker = marker.markers[j];
      if (indexOf(linked, subMarker.doc) == -1) {
        subMarker.parent = null;
        marker.markers.splice(j--, 1);
      }
    }
  };

  for (var i = 0; i < markers.length; i++) loop( i );
}

var nextDocId = 0;
var Doc = function(text, mode, firstLine, lineSep, direction) {
  if (!(this instanceof Doc)) { return new Doc(text, mode, firstLine, lineSep, direction) }
  if (firstLine == null) { firstLine = 0; }

  BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
  this.first = firstLine;
  this.scrollTop = this.scrollLeft = 0;
  this.cantEdit = false;
  this.cleanGeneration = 1;
  this.modeFrontier = this.highlightFrontier = firstLine;
  var start = Pos(firstLine, 0);
  this.sel = simpleSelection(start);
  this.history = new History(null);
  this.id = ++nextDocId;
  this.modeOption = mode;
  this.lineSep = lineSep;
  this.direction = (direction == "rtl") ? "rtl" : "ltr";
  this.extend = false;

  if (typeof text == "string") { text = this.splitLines(text); }
  updateDoc(this, {from: start, to: start, text: text});
  setSelection(this, simpleSelection(start), sel_dontScroll);
};

Doc.prototype = createObj(BranchChunk.prototype, {
  constructor: Doc,
  // Iterate over the document. Supports two forms -- with only one
  // argument, it calls that for each line in the document. With
  // three, it iterates over the range given by the first two (with
  // the second being non-inclusive).
  iter: function(from, to, op) {
    if (op) { this.iterN(from - this.first, to - from, op); }
    else { this.iterN(this.first, this.first + this.size, from); }
  },

  // Non-public interface for adding and removing lines.
  insert: function(at, lines) {
    var height = 0;
    for (var i = 0; i < lines.length; ++i) { height += lines[i].height; }
    this.insertInner(at - this.first, lines, height);
  },
  remove: function(at, n) { this.removeInner(at - this.first, n); },

  // From here, the methods are part of the public interface. Most
  // are also available from CodeMirror (editor) instances.

  getValue: function(lineSep) {
    var lines = getLines(this, this.first, this.first + this.size);
    if (lineSep === false) { return lines }
    return lines.join(lineSep || this.lineSeparator())
  },
  setValue: docMethodOp(function(code) {
    var top = Pos(this.first, 0), last = this.first + this.size - 1;
    makeChange(this, {from: top, to: Pos(last, getLine(this, last).text.length),
                      text: this.splitLines(code), origin: "setValue", full: true}, true);
    if (this.cm) { scrollToCoords(this.cm, 0, 0); }
    setSelection(this, simpleSelection(top), sel_dontScroll);
  }),
  replaceRange: function(code, from, to, origin) {
    from = clipPos(this, from);
    to = to ? clipPos(this, to) : from;
    replaceRange(this, code, from, to, origin);
  },
  getRange: function(from, to, lineSep) {
    var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
    if (lineSep === false) { return lines }
    return lines.join(lineSep || this.lineSeparator())
  },

  getLine: function(line) {var l = this.getLineHandle(line); return l && l.text},

  getLineHandle: function(line) {if (isLine(this, line)) { return getLine(this, line) }},
  getLineNumber: function(line) {return lineNo(line)},

  getLineHandleVisualStart: function(line) {
    if (typeof line == "number") { line = getLine(this, line); }
    return visualLine(line)
  },

  lineCount: function() {return this.size},
  firstLine: function() {return this.first},
  lastLine: function() {return this.first + this.size - 1},

  clipPos: function(pos) {return clipPos(this, pos)},

  getCursor: function(start) {
    var range$$1 = this.sel.primary(), pos;
    if (start == null || start == "head") { pos = range$$1.head; }
    else if (start == "anchor") { pos = range$$1.anchor; }
    else if (start == "end" || start == "to" || start === false) { pos = range$$1.to(); }
    else { pos = range$$1.from(); }
    return pos
  },
  listSelections: function() { return this.sel.ranges },
  somethingSelected: function() {return this.sel.somethingSelected()},

  setCursor: docMethodOp(function(line, ch, options) {
    setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
  }),
  setSelection: docMethodOp(function(anchor, head, options) {
    setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
  }),
  extendSelection: docMethodOp(function(head, other, options) {
    extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
  }),
  extendSelections: docMethodOp(function(heads, options) {
    extendSelections(this, clipPosArray(this, heads), options);
  }),
  extendSelectionsBy: docMethodOp(function(f, options) {
    var heads = map(this.sel.ranges, f);
    extendSelections(this, clipPosArray(this, heads), options);
  }),
  setSelections: docMethodOp(function(ranges, primary, options) {
    var this$1 = this;

    if (!ranges.length) { return }
    var out = [];
    for (var i = 0; i < ranges.length; i++)
      { out[i] = new Range(clipPos(this$1, ranges[i].anchor),
                         clipPos(this$1, ranges[i].head)); }
    if (primary == null) { primary = Math.min(ranges.length - 1, this.sel.primIndex); }
    setSelection(this, normalizeSelection(out, primary), options);
  }),
  addSelection: docMethodOp(function(anchor, head, options) {
    var ranges = this.sel.ranges.slice(0);
    ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
    setSelection(this, normalizeSelection(ranges, ranges.length - 1), options);
  }),

  getSelection: function(lineSep) {
    var this$1 = this;

    var ranges = this.sel.ranges, lines;
    for (var i = 0; i < ranges.length; i++) {
      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
      lines = lines ? lines.concat(sel) : sel;
    }
    if (lineSep === false) { return lines }
    else { return lines.join(lineSep || this.lineSeparator()) }
  },
  getSelections: function(lineSep) {
    var this$1 = this;

    var parts = [], ranges = this.sel.ranges;
    for (var i = 0; i < ranges.length; i++) {
      var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
      if (lineSep !== false) { sel = sel.join(lineSep || this$1.lineSeparator()); }
      parts[i] = sel;
    }
    return parts
  },
  replaceSelection: function(code, collapse, origin) {
    var dup = [];
    for (var i = 0; i < this.sel.ranges.length; i++)
      { dup[i] = code; }
    this.replaceSelections(dup, collapse, origin || "+input");
  },
  replaceSelections: docMethodOp(function(code, collapse, origin) {
    var this$1 = this;

    var changes = [], sel = this.sel;
    for (var i = 0; i < sel.ranges.length; i++) {
      var range$$1 = sel.ranges[i];
      changes[i] = {from: range$$1.from(), to: range$$1.to(), text: this$1.splitLines(code[i]), origin: origin};
    }
    var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
    for (var i$1 = changes.length - 1; i$1 >= 0; i$1--)
      { makeChange(this$1, changes[i$1]); }
    if (newSel) { setSelectionReplaceHistory(this, newSel); }
    else if (this.cm) { ensureCursorVisible(this.cm); }
  }),
  undo: docMethodOp(function() {makeChangeFromHistory(this, "undo");}),
  redo: docMethodOp(function() {makeChangeFromHistory(this, "redo");}),
  undoSelection: docMethodOp(function() {makeChangeFromHistory(this, "undo", true);}),
  redoSelection: docMethodOp(function() {makeChangeFromHistory(this, "redo", true);}),

  setExtending: function(val) {this.extend = val;},
  getExtending: function() {return this.extend},

  historySize: function() {
    var hist = this.history, done = 0, undone = 0;
    for (var i = 0; i < hist.done.length; i++) { if (!hist.done[i].ranges) { ++done; } }
    for (var i$1 = 0; i$1 < hist.undone.length; i$1++) { if (!hist.undone[i$1].ranges) { ++undone; } }
    return {undo: done, redo: undone}
  },
  clearHistory: function() {this.history = new History(this.history.maxGeneration);},

  markClean: function() {
    this.cleanGeneration = this.changeGeneration(true);
  },
  changeGeneration: function(forceSplit) {
    if (forceSplit)
      { this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null; }
    return this.history.generation
  },
  isClean: function (gen) {
    return this.history.generation == (gen || this.cleanGeneration)
  },

  getHistory: function() {
    return {done: copyHistoryArray(this.history.done),
            undone: copyHistoryArray(this.history.undone)}
  },
  setHistory: function(histData) {
    var hist = this.history = new History(this.history.maxGeneration);
    hist.done = copyHistoryArray(histData.done.slice(0), null, true);
    hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
  },

  setGutterMarker: docMethodOp(function(line, gutterID, value) {
    return changeLine(this, line, "gutter", function (line) {
      var markers = line.gutterMarkers || (line.gutterMarkers = {});
      markers[gutterID] = value;
      if (!value && isEmpty(markers)) { line.gutterMarkers = null; }
      return true
    })
  }),

  clearGutter: docMethodOp(function(gutterID) {
    var this$1 = this;

    this.iter(function (line) {
      if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
        changeLine(this$1, line, "gutter", function () {
          line.gutterMarkers[gutterID] = null;
          if (isEmpty(line.gutterMarkers)) { line.gutterMarkers = null; }
          return true
        });
      }
    });
  }),

  lineInfo: function(line) {
    var n;
    if (typeof line == "number") {
      if (!isLine(this, line)) { return null }
      n = line;
      line = getLine(this, line);
      if (!line) { return null }
    } else {
      n = lineNo(line);
      if (n == null) { return null }
    }
    return {line: n, handle: line, text: line.text, gutterMarkers: line.gutterMarkers,
            textClass: line.textClass, bgClass: line.bgClass, wrapClass: line.wrapClass,
            widgets: line.widgets}
  },

  addLineClass: docMethodOp(function(handle, where, cls) {
    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
      var prop = where == "text" ? "textClass"
               : where == "background" ? "bgClass"
               : where == "gutter" ? "gutterClass" : "wrapClass";
      if (!line[prop]) { line[prop] = cls; }
      else if (classTest(cls).test(line[prop])) { return false }
      else { line[prop] += " " + cls; }
      return true
    })
  }),
  removeLineClass: docMethodOp(function(handle, where, cls) {
    return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function (line) {
      var prop = where == "text" ? "textClass"
               : where == "background" ? "bgClass"
               : where == "gutter" ? "gutterClass" : "wrapClass";
      var cur = line[prop];
      if (!cur) { return false }
      else if (cls == null) { line[prop] = null; }
      else {
        var found = cur.match(classTest(cls));
        if (!found) { return false }
        var end = found.index + found[0].length;
        line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
      }
      return true
    })
  }),

  addLineWidget: docMethodOp(function(handle, node, options) {
    return addLineWidget(this, handle, node, options)
  }),
  removeLineWidget: function(widget) { widget.clear(); },

  markText: function(from, to, options) {
    return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range")
  },
  setBookmark: function(pos, options) {
    var realOpts = {replacedWith: options && (options.nodeType == null ? options.widget : options),
                    insertLeft: options && options.insertLeft,
                    clearWhenEmpty: false, shared: options && options.shared,
                    handleMouseEvents: options && options.handleMouseEvents};
    pos = clipPos(this, pos);
    return markText(this, pos, pos, realOpts, "bookmark")
  },
  findMarksAt: function(pos) {
    pos = clipPos(this, pos);
    var markers = [], spans = getLine(this, pos.line).markedSpans;
    if (spans) { for (var i = 0; i < spans.length; ++i) {
      var span = spans[i];
      if ((span.from == null || span.from <= pos.ch) &&
          (span.to == null || span.to >= pos.ch))
        { markers.push(span.marker.parent || span.marker); }
    } }
    return markers
  },
  findMarks: function(from, to, filter) {
    from = clipPos(this, from); to = clipPos(this, to);
    var found = [], lineNo$$1 = from.line;
    this.iter(from.line, to.line + 1, function (line) {
      var spans = line.markedSpans;
      if (spans) { for (var i = 0; i < spans.length; i++) {
        var span = spans[i];
        if (!(span.to != null && lineNo$$1 == from.line && from.ch >= span.to ||
              span.from == null && lineNo$$1 != from.line ||
              span.from != null && lineNo$$1 == to.line && span.from >= to.ch) &&
            (!filter || filter(span.marker)))
          { found.push(span.marker.parent || span.marker); }
      } }
      ++lineNo$$1;
    });
    return found
  },
  getAllMarks: function() {
    var markers = [];
    this.iter(function (line) {
      var sps = line.markedSpans;
      if (sps) { for (var i = 0; i < sps.length; ++i)
        { if (sps[i].from != null) { markers.push(sps[i].marker); } } }
    });
    return markers
  },

  posFromIndex: function(off) {
    var ch, lineNo$$1 = this.first, sepSize = this.lineSeparator().length;
    this.iter(function (line) {
      var sz = line.text.length + sepSize;
      if (sz > off) { ch = off; return true }
      off -= sz;
      ++lineNo$$1;
    });
    return clipPos(this, Pos(lineNo$$1, ch))
  },
  indexFromPos: function (coords) {
    coords = clipPos(this, coords);
    var index = coords.ch;
    if (coords.line < this.first || coords.ch < 0) { return 0 }
    var sepSize = this.lineSeparator().length;
    this.iter(this.first, coords.line, function (line) { // iter aborts when callback returns a truthy value
      index += line.text.length + sepSize;
    });
    return index
  },

  copy: function(copyHistory) {
    var doc = new Doc(getLines(this, this.first, this.first + this.size),
                      this.modeOption, this.first, this.lineSep, this.direction);
    doc.scrollTop = this.scrollTop; doc.scrollLeft = this.scrollLeft;
    doc.sel = this.sel;
    doc.extend = false;
    if (copyHistory) {
      doc.history.undoDepth = this.history.undoDepth;
      doc.setHistory(this.getHistory());
    }
    return doc
  },

  linkedDoc: function(options) {
    if (!options) { options = {}; }
    var from = this.first, to = this.first + this.size;
    if (options.from != null && options.from > from) { from = options.from; }
    if (options.to != null && options.to < to) { to = options.to; }
    var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
    if (options.sharedHist) { copy.history = this.history
    ; }(this.linked || (this.linked = [])).push({doc: copy, sharedHist: options.sharedHist});
    copy.linked = [{doc: this, isParent: true, sharedHist: options.sharedHist}];
    copySharedMarkers(copy, findSharedMarkers(this));
    return copy
  },
  unlinkDoc: function(other) {
    var this$1 = this;

    if (other instanceof CodeMirror$1) { other = other.doc; }
    if (this.linked) { for (var i = 0; i < this.linked.length; ++i) {
      var link = this$1.linked[i];
      if (link.doc != other) { continue }
      this$1.linked.splice(i, 1);
      other.unlinkDoc(this$1);
      detachSharedMarkers(findSharedMarkers(this$1));
      break
    } }
    // If the histories were shared, split them again
    if (other.history == this.history) {
      var splitIds = [other.id];
      linkedDocs(other, function (doc) { return splitIds.push(doc.id); }, true);
      other.history = new History(null);
      other.history.done = copyHistoryArray(this.history.done, splitIds);
      other.history.undone = copyHistoryArray(this.history.undone, splitIds);
    }
  },
  iterLinkedDocs: function(f) {linkedDocs(this, f);},

  getMode: function() {return this.mode},
  getEditor: function() {return this.cm},

  splitLines: function(str) {
    if (this.lineSep) { return str.split(this.lineSep) }
    return splitLinesAuto(str)
  },
  lineSeparator: function() { return this.lineSep || "\n" },

  setDirection: docMethodOp(function (dir) {
    if (dir != "rtl") { dir = "ltr"; }
    if (dir == this.direction) { return }
    this.direction = dir;
    this.iter(function (line) { return line.order = null; });
    if (this.cm) { directionChanged(this.cm); }
  })
});

// Public alias.
Doc.prototype.eachLine = Doc.prototype.iter;

// Kludge to work around strange IE behavior where it'll sometimes
// re-fire a series of drag-related events right after the drop (#1551)
var lastDrop = 0;

function onDrop(e) {
  var cm = this;
  clearDragCursor(cm);
  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e))
    { return }
  e_preventDefault(e);
  if (ie) { lastDrop = +new Date; }
  var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
  if (!pos || cm.isReadOnly()) { return }
  // Might be a file drop, in which case we simply extract the text
  // and insert it.
  if (files && files.length && window.FileReader && window.File) {
    var n = files.length, text = Array(n), read = 0;
    var loadFile = function (file, i) {
      if (cm.options.allowDropFileTypes &&
          indexOf(cm.options.allowDropFileTypes, file.type) == -1)
        { return }

      var reader = new FileReader;
      reader.onload = operation(cm, function () {
        var content = reader.result;
        if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) { content = ""; }
        text[i] = content;
        if (++read == n) {
          pos = clipPos(cm.doc, pos);
          var change = {from: pos, to: pos,
                        text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
                        origin: "paste"};
          makeChange(cm.doc, change);
          setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
        }
      });
      reader.readAsText(file);
    };
    for (var i = 0; i < n; ++i) { loadFile(files[i], i); }
  } else { // Normal drop
    // Don't do a replace if the drop happened inside of the selected text.
    if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
      cm.state.draggingText(e);
      // Ensure the editor is re-focused
      setTimeout(function () { return cm.display.input.focus(); }, 20);
      return
    }
    try {
      var text$1 = e.dataTransfer.getData("Text");
      if (text$1) {
        var selected;
        if (cm.state.draggingText && !cm.state.draggingText.copy)
          { selected = cm.listSelections(); }
        setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
        if (selected) { for (var i$1 = 0; i$1 < selected.length; ++i$1)
          { replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag"); } }
        cm.replaceSelection(text$1, "around", "paste");
        cm.display.input.focus();
      }
    }
    catch(e){}
  }
}

function onDragStart(cm, e) {
  if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) { e_stop(e); return }
  if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) { return }

  e.dataTransfer.setData("Text", cm.getSelection());
  e.dataTransfer.effectAllowed = "copyMove";

  // Use dummy image instead of default browsers image.
  // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
  if (e.dataTransfer.setDragImage && !safari) {
    var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
    img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
    if (presto) {
      img.width = img.height = 1;
      cm.display.wrapper.appendChild(img);
      // Force a relayout, or Opera won't use our image for some obscure reason
      img._top = img.offsetTop;
    }
    e.dataTransfer.setDragImage(img, 0, 0);
    if (presto) { img.parentNode.removeChild(img); }
  }
}

function onDragOver(cm, e) {
  var pos = posFromMouse(cm, e);
  if (!pos) { return }
  var frag = document.createDocumentFragment();
  drawSelectionCursor(cm, pos, frag);
  if (!cm.display.dragCursor) {
    cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
    cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
  }
  removeChildrenAndAdd(cm.display.dragCursor, frag);
}

function clearDragCursor(cm) {
  if (cm.display.dragCursor) {
    cm.display.lineSpace.removeChild(cm.display.dragCursor);
    cm.display.dragCursor = null;
  }
}

// These must be handled carefully, because naively registering a
// handler for each editor will cause the editors to never be
// garbage collected.

function forEachCodeMirror(f) {
  if (!document.getElementsByClassName) { return }
  var byClass = document.getElementsByClassName("CodeMirror");
  for (var i = 0; i < byClass.length; i++) {
    var cm = byClass[i].CodeMirror;
    if (cm) { f(cm); }
  }
}

var globalsRegistered = false;
function ensureGlobalHandlers() {
  if (globalsRegistered) { return }
  registerGlobalHandlers();
  globalsRegistered = true;
}
function registerGlobalHandlers() {
  // When the window resizes, we need to refresh active editors.
  var resizeTimer;
  on(window, "resize", function () {
    if (resizeTimer == null) { resizeTimer = setTimeout(function () {
      resizeTimer = null;
      forEachCodeMirror(onResize);
    }, 100); }
  });
  // When the window loses focus, we want to show the editor as blurred
  on(window, "blur", function () { return forEachCodeMirror(onBlur); });
}
// Called when the window resizes
function onResize(cm) {
  var d = cm.display;
  if (d.lastWrapHeight == d.wrapper.clientHeight && d.lastWrapWidth == d.wrapper.clientWidth)
    { return }
  // Might be a text scaling operation, clear size caches.
  d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
  d.scrollbarsClipped = false;
  cm.setSize();
}

var keyNames = {
  3: "Pause", 8: "Backspace", 9: "Tab", 13: "Enter", 16: "Shift", 17: "Ctrl", 18: "Alt",
  19: "Pause", 20: "CapsLock", 27: "Esc", 32: "Space", 33: "PageUp", 34: "PageDown", 35: "End",
  36: "Home", 37: "Left", 38: "Up", 39: "Right", 40: "Down", 44: "PrintScrn", 45: "Insert",
  46: "Delete", 59: ";", 61: "=", 91: "Mod", 92: "Mod", 93: "Mod",
  106: "*", 107: "=", 109: "-", 110: ".", 111: "/", 127: "Delete", 145: "ScrollLock",
  173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\",
  221: "]", 222: "'", 63232: "Up", 63233: "Down", 63234: "Left", 63235: "Right", 63272: "Delete",
  63273: "Home", 63275: "End", 63276: "PageUp", 63277: "PageDown", 63302: "Insert"
};

// Number keys
for (var i = 0; i < 10; i++) { keyNames[i + 48] = keyNames[i + 96] = String(i); }
// Alphabetic keys
for (var i$1 = 65; i$1 <= 90; i$1++) { keyNames[i$1] = String.fromCharCode(i$1); }
// Function keys
for (var i$2 = 1; i$2 <= 12; i$2++) { keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2; }

var keyMap = {};

keyMap.basic = {
  "Left": "goCharLeft", "Right": "goCharRight", "Up": "goLineUp", "Down": "goLineDown",
  "End": "goLineEnd", "Home": "goLineStartSmart", "PageUp": "goPageUp", "PageDown": "goPageDown",
  "Delete": "delCharAfter", "Backspace": "delCharBefore", "Shift-Backspace": "delCharBefore",
  "Tab": "defaultTab", "Shift-Tab": "indentAuto",
  "Enter": "newlineAndIndent", "Insert": "toggleOverwrite",
  "Esc": "singleSelection"
};
// Note that the save and find-related commands aren't defined by
// default. User code or addons can define them. Unknown commands
// are simply ignored.
keyMap.pcDefault = {
  "Ctrl-A": "selectAll", "Ctrl-D": "deleteLine", "Ctrl-Z": "undo", "Shift-Ctrl-Z": "redo", "Ctrl-Y": "redo",
  "Ctrl-Home": "goDocStart", "Ctrl-End": "goDocEnd", "Ctrl-Up": "goLineUp", "Ctrl-Down": "goLineDown",
  "Ctrl-Left": "goGroupLeft", "Ctrl-Right": "goGroupRight", "Alt-Left": "goLineStart", "Alt-Right": "goLineEnd",
  "Ctrl-Backspace": "delGroupBefore", "Ctrl-Delete": "delGroupAfter", "Ctrl-S": "save", "Ctrl-F": "find",
  "Ctrl-G": "findNext", "Shift-Ctrl-G": "findPrev", "Shift-Ctrl-F": "replace", "Shift-Ctrl-R": "replaceAll",
  "Ctrl-[": "indentLess", "Ctrl-]": "indentMore",
  "Ctrl-U": "undoSelection", "Shift-Ctrl-U": "redoSelection", "Alt-U": "redoSelection",
  fallthrough: "basic"
};
// Very basic readline/emacs-style bindings, which are standard on Mac.
keyMap.emacsy = {
  "Ctrl-F": "goCharRight", "Ctrl-B": "goCharLeft", "Ctrl-P": "goLineUp", "Ctrl-N": "goLineDown",
  "Alt-F": "goWordRight", "Alt-B": "goWordLeft", "Ctrl-A": "goLineStart", "Ctrl-E": "goLineEnd",
  "Ctrl-V": "goPageDown", "Shift-Ctrl-V": "goPageUp", "Ctrl-D": "delCharAfter", "Ctrl-H": "delCharBefore",
  "Alt-D": "delWordAfter", "Alt-Backspace": "delWordBefore", "Ctrl-K": "killLine", "Ctrl-T": "transposeChars",
  "Ctrl-O": "openLine"
};
keyMap.macDefault = {
  "Cmd-A": "selectAll", "Cmd-D": "deleteLine", "Cmd-Z": "undo", "Shift-Cmd-Z": "redo", "Cmd-Y": "redo",
  "Cmd-Home": "goDocStart", "Cmd-Up": "goDocStart", "Cmd-End": "goDocEnd", "Cmd-Down": "goDocEnd", "Alt-Left": "goGroupLeft",
  "Alt-Right": "goGroupRight", "Cmd-Left": "goLineLeft", "Cmd-Right": "goLineRight", "Alt-Backspace": "delGroupBefore",
  "Ctrl-Alt-Backspace": "delGroupAfter", "Alt-Delete": "delGroupAfter", "Cmd-S": "save", "Cmd-F": "find",
  "Cmd-G": "findNext", "Shift-Cmd-G": "findPrev", "Cmd-Alt-F": "replace", "Shift-Cmd-Alt-F": "replaceAll",
  "Cmd-[": "indentLess", "Cmd-]": "indentMore", "Cmd-Backspace": "delWrappedLineLeft", "Cmd-Delete": "delWrappedLineRight",
  "Cmd-U": "undoSelection", "Shift-Cmd-U": "redoSelection", "Ctrl-Up": "goDocStart", "Ctrl-Down": "goDocEnd",
  fallthrough: ["basic", "emacsy"]
};
keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;

// KEYMAP DISPATCH

function normalizeKeyName(name) {
  var parts = name.split(/-(?!$)/);
  name = parts[parts.length - 1];
  var alt, ctrl, shift, cmd;
  for (var i = 0; i < parts.length - 1; i++) {
    var mod = parts[i];
    if (/^(cmd|meta|m)$/i.test(mod)) { cmd = true; }
    else if (/^a(lt)?$/i.test(mod)) { alt = true; }
    else if (/^(c|ctrl|control)$/i.test(mod)) { ctrl = true; }
    else if (/^s(hift)?$/i.test(mod)) { shift = true; }
    else { throw new Error("Unrecognized modifier name: " + mod) }
  }
  if (alt) { name = "Alt-" + name; }
  if (ctrl) { name = "Ctrl-" + name; }
  if (cmd) { name = "Cmd-" + name; }
  if (shift) { name = "Shift-" + name; }
  return name
}

// This is a kludge to keep keymaps mostly working as raw objects
// (backwards compatibility) while at the same time support features
// like normalization and multi-stroke key bindings. It compiles a
// new normalized keymap, and then updates the old object to reflect
// this.
function normalizeKeyMap(keymap) {
  var copy = {};
  for (var keyname in keymap) { if (keymap.hasOwnProperty(keyname)) {
    var value = keymap[keyname];
    if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) { continue }
    if (value == "...") { delete keymap[keyname]; continue }

    var keys = map(keyname.split(" "), normalizeKeyName);
    for (var i = 0; i < keys.length; i++) {
      var val = (void 0), name = (void 0);
      if (i == keys.length - 1) {
        name = keys.join(" ");
        val = value;
      } else {
        name = keys.slice(0, i + 1).join(" ");
        val = "...";
      }
      var prev = copy[name];
      if (!prev) { copy[name] = val; }
      else if (prev != val) { throw new Error("Inconsistent bindings for " + name) }
    }
    delete keymap[keyname];
  } }
  for (var prop in copy) { keymap[prop] = copy[prop]; }
  return keymap
}

function lookupKey(key, map$$1, handle, context) {
  map$$1 = getKeyMap(map$$1);
  var found = map$$1.call ? map$$1.call(key, context) : map$$1[key];
  if (found === false) { return "nothing" }
  if (found === "...") { return "multi" }
  if (found != null && handle(found)) { return "handled" }

  if (map$$1.fallthrough) {
    if (Object.prototype.toString.call(map$$1.fallthrough) != "[object Array]")
      { return lookupKey(key, map$$1.fallthrough, handle, context) }
    for (var i = 0; i < map$$1.fallthrough.length; i++) {
      var result = lookupKey(key, map$$1.fallthrough[i], handle, context);
      if (result) { return result }
    }
  }
}

// Modifier key presses don't count as 'real' key presses for the
// purpose of keymap fallthrough.
function isModifierKey(value) {
  var name = typeof value == "string" ? value : keyNames[value.keyCode];
  return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod"
}

function addModifierNames(name, event, noShift) {
  var base = name;
  if (event.altKey && base != "Alt") { name = "Alt-" + name; }
  if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") { name = "Ctrl-" + name; }
  if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") { name = "Cmd-" + name; }
  if (!noShift && event.shiftKey && base != "Shift") { name = "Shift-" + name; }
  return name
}

// Look up the name of a key as indicated by an event object.
function keyName(event, noShift) {
  if (presto && event.keyCode == 34 && event["char"]) { return false }
  var name = keyNames[event.keyCode];
  if (name == null || event.altGraphKey) { return false }
  // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
  // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
  if (event.keyCode == 3 && event.code) { name = event.code; }
  return addModifierNames(name, event, noShift)
}

function getKeyMap(val) {
  return typeof val == "string" ? keyMap[val] : val
}

// Helper for deleting text near the selection(s), used to implement
// backspace, delete, and similar functionality.
function deleteNearSelection(cm, compute) {
  var ranges = cm.doc.sel.ranges, kill = [];
  // Build up a set of ranges to kill first, merging overlapping
  // ranges.
  for (var i = 0; i < ranges.length; i++) {
    var toKill = compute(ranges[i]);
    while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
      var replaced = kill.pop();
      if (cmp(replaced.from, toKill.from) < 0) {
        toKill.from = replaced.from;
        break
      }
    }
    kill.push(toKill);
  }
  // Next, remove those actual ranges.
  runInOp(cm, function () {
    for (var i = kill.length - 1; i >= 0; i--)
      { replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete"); }
    ensureCursorVisible(cm);
  });
}

function moveCharLogically(line, ch, dir) {
  var target = skipExtendingChars(line.text, ch + dir, dir);
  return target < 0 || target > line.text.length ? null : target
}

function moveLogically(line, start, dir) {
  var ch = moveCharLogically(line, start.ch, dir);
  return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before")
}

function endOfLine(visually, cm, lineObj, lineNo, dir) {
  if (visually) {
    var order = getOrder(lineObj, cm.doc.direction);
    if (order) {
      var part = dir < 0 ? lst(order) : order[0];
      var moveInStorageOrder = (dir < 0) == (part.level == 1);
      var sticky = moveInStorageOrder ? "after" : "before";
      var ch;
      // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
      // it could be that the last bidi part is not on the last visual line,
      // since visual lines contain content order-consecutive chunks.
      // Thus, in rtl, we are looking for the first (content-order) character
      // in the rtl chunk that is on the last line (that is, the same line
      // as the last (content-order) character).
      if (part.level > 0 || cm.doc.direction == "rtl") {
        var prep = prepareMeasureForLine(cm, lineObj);
        ch = dir < 0 ? lineObj.text.length - 1 : 0;
        var targetTop = measureCharPrepared(cm, prep, ch).top;
        ch = findFirst(function (ch) { return measureCharPrepared(cm, prep, ch).top == targetTop; }, (dir < 0) == (part.level == 1) ? part.from : part.to - 1, ch);
        if (sticky == "before") { ch = moveCharLogically(lineObj, ch, 1); }
      } else { ch = dir < 0 ? part.to : part.from; }
      return new Pos(lineNo, ch, sticky)
    }
  }
  return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after")
}

function moveVisually(cm, line, start, dir) {
  var bidi = getOrder(line, cm.doc.direction);
  if (!bidi) { return moveLogically(line, start, dir) }
  if (start.ch >= line.text.length) {
    start.ch = line.text.length;
    start.sticky = "before";
  } else if (start.ch <= 0) {
    start.ch = 0;
    start.sticky = "after";
  }
  var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
  if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
    // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
    // nothing interesting happens.
    return moveLogically(line, start, dir)
  }

  var mv = function (pos, dir) { return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir); };
  var prep;
  var getWrappedLineExtent = function (ch) {
    if (!cm.options.lineWrapping) { return {begin: 0, end: line.text.length} }
    prep = prep || prepareMeasureForLine(cm, line);
    return wrappedLineExtentChar(cm, line, prep, ch)
  };
  var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);

  if (cm.doc.direction == "rtl" || part.level == 1) {
    var moveInStorageOrder = (part.level == 1) == (dir < 0);
    var ch = mv(start, moveInStorageOrder ? 1 : -1);
    if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
      // Case 2: We move within an rtl part or in an rtl editor on the same visual line
      var sticky = moveInStorageOrder ? "before" : "after";
      return new Pos(start.line, ch, sticky)
    }
  }

  // Case 3: Could not move within this bidi part in this visual line, so leave
  // the current bidi part

  var searchInVisualLine = function (partPos, dir, wrappedLineExtent) {
    var getRes = function (ch, moveInStorageOrder) { return moveInStorageOrder
      ? new Pos(start.line, mv(ch, 1), "before")
      : new Pos(start.line, ch, "after"); };

    for (; partPos >= 0 && partPos < bidi.length; partPos += dir) {
      var part = bidi[partPos];
      var moveInStorageOrder = (dir > 0) == (part.level != 1);
      var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
      if (part.from <= ch && ch < part.to) { return getRes(ch, moveInStorageOrder) }
      ch = moveInStorageOrder ? part.from : mv(part.to, -1);
      if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) { return getRes(ch, moveInStorageOrder) }
    }
  };

  // Case 3a: Look for other bidi parts on the same visual line
  var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
  if (res) { return res }

  // Case 3b: Look for other bidi parts on the next visual line
  var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
  if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
    res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
    if (res) { return res }
  }

  // Case 4: Nowhere to move
  return null
}

// Commands are parameter-less actions that can be performed on an
// editor, mostly used for keybindings.
var commands = {
  selectAll: selectAll,
  singleSelection: function (cm) { return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll); },
  killLine: function (cm) { return deleteNearSelection(cm, function (range) {
    if (range.empty()) {
      var len = getLine(cm.doc, range.head.line).text.length;
      if (range.head.ch == len && range.head.line < cm.lastLine())
        { return {from: range.head, to: Pos(range.head.line + 1, 0)} }
      else
        { return {from: range.head, to: Pos(range.head.line, len)} }
    } else {
      return {from: range.from(), to: range.to()}
    }
  }); },
  deleteLine: function (cm) { return deleteNearSelection(cm, function (range) { return ({
    from: Pos(range.from().line, 0),
    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
  }); }); },
  delLineLeft: function (cm) { return deleteNearSelection(cm, function (range) { return ({
    from: Pos(range.from().line, 0), to: range.from()
  }); }); },
  delWrappedLineLeft: function (cm) { return deleteNearSelection(cm, function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var leftPos = cm.coordsChar({left: 0, top: top}, "div");
    return {from: leftPos, to: range.from()}
  }); },
  delWrappedLineRight: function (cm) { return deleteNearSelection(cm, function (range) {
    var top = cm.charCoords(range.head, "div").top + 5;
    var rightPos = cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div");
    return {from: range.from(), to: rightPos }
  }); },
  undo: function (cm) { return cm.undo(); },
  redo: function (cm) { return cm.redo(); },
  undoSelection: function (cm) { return cm.undoSelection(); },
  redoSelection: function (cm) { return cm.redoSelection(); },
  goDocStart: function (cm) { return cm.extendSelection(Pos(cm.firstLine(), 0)); },
  goDocEnd: function (cm) { return cm.extendSelection(Pos(cm.lastLine())); },
  goLineStart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStart(cm, range.head.line); },
    {origin: "+move", bias: 1}
  ); },
  goLineStartSmart: function (cm) { return cm.extendSelectionsBy(function (range) { return lineStartSmart(cm, range.head); },
    {origin: "+move", bias: 1}
  ); },
  goLineEnd: function (cm) { return cm.extendSelectionsBy(function (range) { return lineEnd(cm, range.head.line); },
    {origin: "+move", bias: -1}
  ); },
  goLineRight: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.cursorCoords(range.head, "div").top + 5;
    return cm.coordsChar({left: cm.display.lineDiv.offsetWidth + 100, top: top}, "div")
  }, sel_move); },
  goLineLeft: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.cursorCoords(range.head, "div").top + 5;
    return cm.coordsChar({left: 0, top: top}, "div")
  }, sel_move); },
  goLineLeftSmart: function (cm) { return cm.extendSelectionsBy(function (range) {
    var top = cm.cursorCoords(range.head, "div").top + 5;
    var pos = cm.coordsChar({left: 0, top: top}, "div");
    if (pos.ch < cm.getLine(pos.line).search(/\S/)) { return lineStartSmart(cm, range.head) }
    return pos
  }, sel_move); },
  goLineUp: function (cm) { return cm.moveV(-1, "line"); },
  goLineDown: function (cm) { return cm.moveV(1, "line"); },
  goPageUp: function (cm) { return cm.moveV(-1, "page"); },
  goPageDown: function (cm) { return cm.moveV(1, "page"); },
  goCharLeft: function (cm) { return cm.moveH(-1, "char"); },
  goCharRight: function (cm) { return cm.moveH(1, "char"); },
  goColumnLeft: function (cm) { return cm.moveH(-1, "column"); },
  goColumnRight: function (cm) { return cm.moveH(1, "column"); },
  goWordLeft: function (cm) { return cm.moveH(-1, "word"); },
  goGroupRight: function (cm) { return cm.moveH(1, "group"); },
  goGroupLeft: function (cm) { return cm.moveH(-1, "group"); },
  goWordRight: function (cm) { return cm.moveH(1, "word"); },
  delCharBefore: function (cm) { return cm.deleteH(-1, "char"); },
  delCharAfter: function (cm) { return cm.deleteH(1, "char"); },
  delWordBefore: function (cm) { return cm.deleteH(-1, "word"); },
  delWordAfter: function (cm) { return cm.deleteH(1, "word"); },
  delGroupBefore: function (cm) { return cm.deleteH(-1, "group"); },
  delGroupAfter: function (cm) { return cm.deleteH(1, "group"); },
  indentAuto: function (cm) { return cm.indentSelection("smart"); },
  indentMore: function (cm) { return cm.indentSelection("add"); },
  indentLess: function (cm) { return cm.indentSelection("subtract"); },
  insertTab: function (cm) { return cm.replaceSelection("\t"); },
  insertSoftTab: function (cm) {
    var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
    for (var i = 0; i < ranges.length; i++) {
      var pos = ranges[i].from();
      var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
      spaces.push(spaceStr(tabSize - col % tabSize));
    }
    cm.replaceSelections(spaces);
  },
  defaultTab: function (cm) {
    if (cm.somethingSelected()) { cm.indentSelection("add"); }
    else { cm.execCommand("insertTab"); }
  },
  // Swap the two chars left and right of each selection's head.
  // Move cursor behind the two swapped characters afterwards.
  //
  // Doesn't consider line feeds a character.
  // Doesn't scan more than one line above to find a character.
  // Doesn't do anything on an empty line.
  // Doesn't do anything with non-empty selections.
  transposeChars: function (cm) { return runInOp(cm, function () {
    var ranges = cm.listSelections(), newSel = [];
    for (var i = 0; i < ranges.length; i++) {
      if (!ranges[i].empty()) { continue }
      var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
      if (line) {
        if (cur.ch == line.length) { cur = new Pos(cur.line, cur.ch - 1); }
        if (cur.ch > 0) {
          cur = new Pos(cur.line, cur.ch + 1);
          cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                          Pos(cur.line, cur.ch - 2), cur, "+transpose");
        } else if (cur.line > cm.doc.first) {
          var prev = getLine(cm.doc, cur.line - 1).text;
          if (prev) {
            cur = new Pos(cur.line, 1);
            cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() +
                            prev.charAt(prev.length - 1),
                            Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
          }
        }
      }
      newSel.push(new Range(cur, cur));
    }
    cm.setSelections(newSel);
  }); },
  newlineAndIndent: function (cm) { return runInOp(cm, function () {
    var sels = cm.listSelections();
    for (var i = sels.length - 1; i >= 0; i--)
      { cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input"); }
    sels = cm.listSelections();
    for (var i$1 = 0; i$1 < sels.length; i$1++)
      { cm.indentLine(sels[i$1].from().line, null, true); }
    ensureCursorVisible(cm);
  }); },
  openLine: function (cm) { return cm.replaceSelection("\n", "start"); },
  toggleOverwrite: function (cm) { return cm.toggleOverwrite(); }
};


function lineStart(cm, lineN) {
  var line = getLine(cm.doc, lineN);
  var visual = visualLine(line);
  if (visual != line) { lineN = lineNo(visual); }
  return endOfLine(true, cm, visual, lineN, 1)
}
function lineEnd(cm, lineN) {
  var line = getLine(cm.doc, lineN);
  var visual = visualLineEnd(line);
  if (visual != line) { lineN = lineNo(visual); }
  return endOfLine(true, cm, line, lineN, -1)
}
function lineStartSmart(cm, pos) {
  var start = lineStart(cm, pos.line);
  var line = getLine(cm.doc, start.line);
  var order = getOrder(line, cm.doc.direction);
  if (!order || order[0].level == 0) {
    var firstNonWS = Math.max(0, line.text.search(/\S/));
    var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
    return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky)
  }
  return start
}

// Run a handler that was bound to a key.
function doHandleBinding(cm, bound, dropShift) {
  if (typeof bound == "string") {
    bound = commands[bound];
    if (!bound) { return false }
  }
  // Ensure previous input has been read, so that the handler sees a
  // consistent view of the document
  cm.display.input.ensurePolled();
  var prevShift = cm.display.shift, done = false;
  try {
    if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
    if (dropShift) { cm.display.shift = false; }
    done = bound(cm) != Pass;
  } finally {
    cm.display.shift = prevShift;
    cm.state.suppressEdits = false;
  }
  return done
}

function lookupKeyForEditor(cm, name, handle) {
  for (var i = 0; i < cm.state.keyMaps.length; i++) {
    var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
    if (result) { return result }
  }
  return (cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm))
    || lookupKey(name, cm.options.keyMap, handle, cm)
}

// Note that, despite the name, this function is also used to check
// for bound mouse clicks.

var stopSeq = new Delayed;

function dispatchKey(cm, name, e, handle) {
  var seq = cm.state.keySeq;
  if (seq) {
    if (isModifierKey(name)) { return "handled" }
    if (/\'$/.test(name))
      { cm.state.keySeq = null; }
    else
      { stopSeq.set(50, function () {
        if (cm.state.keySeq == seq) {
          cm.state.keySeq = null;
          cm.display.input.reset();
        }
      }); }
    if (dispatchKeyInner(cm, seq + " " + name, e, handle)) { return true }
  }
  return dispatchKeyInner(cm, name, e, handle)
}

function dispatchKeyInner(cm, name, e, handle) {
  var result = lookupKeyForEditor(cm, name, handle);

  if (result == "multi")
    { cm.state.keySeq = name; }
  if (result == "handled")
    { signalLater(cm, "keyHandled", cm, name, e); }

  if (result == "handled" || result == "multi") {
    e_preventDefault(e);
    restartBlink(cm);
  }

  return !!result
}

// Handle a key from the keydown event.
function handleKeyBinding(cm, e) {
  var name = keyName(e, true);
  if (!name) { return false }

  if (e.shiftKey && !cm.state.keySeq) {
    // First try to resolve full name (including 'Shift-'). Failing
    // that, see if there is a cursor-motion command (starting with
    // 'go') bound to the keyname without 'Shift-'.
    return dispatchKey(cm, "Shift-" + name, e, function (b) { return doHandleBinding(cm, b, true); })
        || dispatchKey(cm, name, e, function (b) {
             if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion)
               { return doHandleBinding(cm, b) }
           })
  } else {
    return dispatchKey(cm, name, e, function (b) { return doHandleBinding(cm, b); })
  }
}

// Handle a key from the keypress event
function handleCharBinding(cm, e, ch) {
  return dispatchKey(cm, "'" + ch + "'", e, function (b) { return doHandleBinding(cm, b, true); })
}

var lastStoppedKey = null;
function onKeyDown(e) {
  var cm = this;
  cm.curOp.focus = activeElt();
  if (signalDOMEvent(cm, e)) { return }
  // IE does strange things with escape.
  if (ie && ie_version < 11 && e.keyCode == 27) { e.returnValue = false; }
  var code = e.keyCode;
  cm.display.shift = code == 16 || e.shiftKey;
  var handled = handleKeyBinding(cm, e);
  if (presto) {
    lastStoppedKey = handled ? code : null;
    // Opera has no cut event... we try to at least catch the key combo
    if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey))
      { cm.replaceSelection("", null, "cut"); }
  }

  // Turn mouse into crosshair when Alt is held on Mac.
  if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className))
    { showCrossHair(cm); }
}

function showCrossHair(cm) {
  var lineDiv = cm.display.lineDiv;
  addClass(lineDiv, "CodeMirror-crosshair");

  function up(e) {
    if (e.keyCode == 18 || !e.altKey) {
      rmClass(lineDiv, "CodeMirror-crosshair");
      off(document, "keyup", up);
      off(document, "mouseover", up);
    }
  }
  on(document, "keyup", up);
  on(document, "mouseover", up);
}

function onKeyUp(e) {
  if (e.keyCode == 16) { this.doc.sel.shift = false; }
  signalDOMEvent(this, e);
}

function onKeyPress(e) {
  var cm = this;
  if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) { return }
  var keyCode = e.keyCode, charCode = e.charCode;
  if (presto && keyCode == lastStoppedKey) {lastStoppedKey = null; e_preventDefault(e); return}
  if ((presto && (!e.which || e.which < 10)) && handleKeyBinding(cm, e)) { return }
  var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
  // Some browsers fire keypress events for backspace
  if (ch == "\x08") { return }
  if (handleCharBinding(cm, e, ch)) { return }
  cm.display.input.onKeyPress(e);
}

var DOUBLECLICK_DELAY = 400;

var PastClick = function(time, pos, button) {
  this.time = time;
  this.pos = pos;
  this.button = button;
};

PastClick.prototype.compare = function (time, pos, button) {
  return this.time + DOUBLECLICK_DELAY > time &&
    cmp(pos, this.pos) == 0 && button == this.button
};

var lastClick;
var lastDoubleClick;
function clickRepeat(pos, button) {
  var now = +new Date;
  if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
    lastClick = lastDoubleClick = null;
    return "triple"
  } else if (lastClick && lastClick.compare(now, pos, button)) {
    lastDoubleClick = new PastClick(now, pos, button);
    lastClick = null;
    return "double"
  } else {
    lastClick = new PastClick(now, pos, button);
    lastDoubleClick = null;
    return "single"
  }
}

// A mouse down can be a single click, double click, triple click,
// start of selection drag, start of text drag, new cursor
// (ctrl-click), rectangle drag (alt-drag), or xwin
// middle-click-paste. Or it might be a click on something we should
// not interfere with, such as a scrollbar or widget.
function onMouseDown(e) {
  var cm = this, display = cm.display;
  if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) { return }
  display.input.ensurePolled();
  display.shift = e.shiftKey;

  if (eventInWidget(display, e)) {
    if (!webkit) {
      // Briefly turn off draggability, to allow widgets to do
      // normal dragging things.
      display.scroller.draggable = false;
      setTimeout(function () { return display.scroller.draggable = true; }, 100);
    }
    return
  }
  if (clickInGutter(cm, e)) { return }
  var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
  window.focus();

  // #3261: make sure, that we're not starting a second selection
  if (button == 1 && cm.state.selectingText)
    { cm.state.selectingText(e); }

  if (pos && handleMappedButton(cm, button, pos, repeat, e)) { return }

  if (button == 1) {
    if (pos) { leftButtonDown(cm, pos, repeat, e); }
    else if (e_target(e) == display.scroller) { e_preventDefault(e); }
  } else if (button == 2) {
    if (pos) { extendSelection(cm.doc, pos); }
    setTimeout(function () { return display.input.focus(); }, 20);
  } else if (button == 3) {
    if (captureRightClick) { onContextMenu(cm, e); }
    else { delayBlurEvent(cm); }
  }
}

function handleMappedButton(cm, button, pos, repeat, event) {
  var name = "Click";
  if (repeat == "double") { name = "Double" + name; }
  else if (repeat == "triple") { name = "Triple" + name; }
  name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;

  return dispatchKey(cm,  addModifierNames(name, event), event, function (bound) {
    if (typeof bound == "string") { bound = commands[bound]; }
    if (!bound) { return false }
    var done = false;
    try {
      if (cm.isReadOnly()) { cm.state.suppressEdits = true; }
      done = bound(cm, pos) != Pass;
    } finally {
      cm.state.suppressEdits = false;
    }
    return done
  })
}

function configureMouse(cm, repeat, event) {
  var option = cm.getOption("configureMouse");
  var value = option ? option(cm, repeat, event) : {};
  if (value.unit == null) {
    var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
    value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
  }
  if (value.extend == null || cm.doc.extend) { value.extend = cm.doc.extend || event.shiftKey; }
  if (value.addNew == null) { value.addNew = mac ? event.metaKey : event.ctrlKey; }
  if (value.moveOnDrag == null) { value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey); }
  return value
}

function leftButtonDown(cm, pos, repeat, event) {
  if (ie) { setTimeout(bind(ensureFocus, cm), 0); }
  else { cm.curOp.focus = activeElt(); }

  var behavior = configureMouse(cm, repeat, event);

  var sel = cm.doc.sel, contained;
  if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() &&
      repeat == "single" && (contained = sel.contains(pos)) > -1 &&
      (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) &&
      (cmp(contained.to(), pos) > 0 || pos.xRel < 0))
    { leftButtonStartDrag(cm, event, pos, behavior); }
  else
    { leftButtonSelect(cm, event, pos, behavior); }
}

// Start a text drag. When it ends, see if any dragging actually
// happen, and treat as a click if it didn't.
function leftButtonStartDrag(cm, event, pos, behavior) {
  var display = cm.display, moved = false;
  var dragEnd = operation(cm, function (e) {
    if (webkit) { display.scroller.draggable = false; }
    cm.state.draggingText = false;
    off(display.wrapper.ownerDocument, "mouseup", dragEnd);
    off(display.wrapper.ownerDocument, "mousemove", mouseMove);
    off(display.scroller, "dragstart", dragStart);
    off(display.scroller, "drop", dragEnd);
    if (!moved) {
      e_preventDefault(e);
      if (!behavior.addNew)
        { extendSelection(cm.doc, pos, null, null, behavior.extend); }
      // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
      if (webkit || ie && ie_version == 9)
        { setTimeout(function () {display.wrapper.ownerDocument.body.focus(); display.input.focus();}, 20); }
      else
        { display.input.focus(); }
    }
  });
  var mouseMove = function(e2) {
    moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
  };
  var dragStart = function () { return moved = true; };
  // Let the drag handler handle this.
  if (webkit) { display.scroller.draggable = true; }
  cm.state.draggingText = dragEnd;
  dragEnd.copy = !behavior.moveOnDrag;
  // IE's approach to draggable
  if (display.scroller.dragDrop) { display.scroller.dragDrop(); }
  on(display.wrapper.ownerDocument, "mouseup", dragEnd);
  on(display.wrapper.ownerDocument, "mousemove", mouseMove);
  on(display.scroller, "dragstart", dragStart);
  on(display.scroller, "drop", dragEnd);

  delayBlurEvent(cm);
  setTimeout(function () { return display.input.focus(); }, 20);
}

function rangeForUnit(cm, pos, unit) {
  if (unit == "char") { return new Range(pos, pos) }
  if (unit == "word") { return cm.findWordAt(pos) }
  if (unit == "line") { return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))) }
  var result = unit(cm, pos);
  return new Range(result.from, result.to)
}

// Normal selection, as opposed to text dragging.
function leftButtonSelect(cm, event, start, behavior) {
  var display = cm.display, doc = cm.doc;
  e_preventDefault(event);

  var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
  if (behavior.addNew && !behavior.extend) {
    ourIndex = doc.sel.contains(start);
    if (ourIndex > -1)
      { ourRange = ranges[ourIndex]; }
    else
      { ourRange = new Range(start, start); }
  } else {
    ourRange = doc.sel.primary();
    ourIndex = doc.sel.primIndex;
  }

  if (behavior.unit == "rectangle") {
    if (!behavior.addNew) { ourRange = new Range(start, start); }
    start = posFromMouse(cm, event, true, true);
    ourIndex = -1;
  } else {
    var range$$1 = rangeForUnit(cm, start, behavior.unit);
    if (behavior.extend)
      { ourRange = extendRange(ourRange, range$$1.anchor, range$$1.head, behavior.extend); }
    else
      { ourRange = range$$1; }
  }

  if (!behavior.addNew) {
    ourIndex = 0;
    setSelection(doc, new Selection([ourRange], 0), sel_mouse);
    startSel = doc.sel;
  } else if (ourIndex == -1) {
    ourIndex = ranges.length;
    setSelection(doc, normalizeSelection(ranges.concat([ourRange]), ourIndex),
                 {scroll: false, origin: "*mouse"});
  } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
    setSelection(doc, normalizeSelection(ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
                 {scroll: false, origin: "*mouse"});
    startSel = doc.sel;
  } else {
    replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
  }

  var lastPos = start;
  function extendTo(pos) {
    if (cmp(lastPos, pos) == 0) { return }
    lastPos = pos;

    if (behavior.unit == "rectangle") {
      var ranges = [], tabSize = cm.options.tabSize;
      var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
      var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
      var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
      for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line));
           line <= end; line++) {
        var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
        if (left == right)
          { ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos))); }
        else if (text.length > leftPos)
          { ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize)))); }
      }
      if (!ranges.length) { ranges.push(new Range(start, start)); }
      setSelection(doc, normalizeSelection(startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex),
                   {origin: "*mouse", scroll: false});
      cm.scrollIntoView(pos);
    } else {
      var oldRange = ourRange;
      var range$$1 = rangeForUnit(cm, pos, behavior.unit);
      var anchor = oldRange.anchor, head;
      if (cmp(range$$1.anchor, anchor) > 0) {
        head = range$$1.head;
        anchor = minPos(oldRange.from(), range$$1.anchor);
      } else {
        head = range$$1.anchor;
        anchor = maxPos(oldRange.to(), range$$1.head);
      }
      var ranges$1 = startSel.ranges.slice(0);
      ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
      setSelection(doc, normalizeSelection(ranges$1, ourIndex), sel_mouse);
    }
  }

  var editorSize = display.wrapper.getBoundingClientRect();
  // Used to ensure timeout re-tries don't fire when another extend
  // happened in the meantime (clearTimeout isn't reliable -- at
  // least on Chrome, the timeouts still happen even when cleared,
  // if the clear happens after their scheduled firing time).
  var counter = 0;

  function extend(e) {
    var curCount = ++counter;
    var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
    if (!cur) { return }
    if (cmp(cur, lastPos) != 0) {
      cm.curOp.focus = activeElt();
      extendTo(cur);
      var visible = visibleLines(display, doc);
      if (cur.line >= visible.to || cur.line < visible.from)
        { setTimeout(operation(cm, function () {if (counter == curCount) { extend(e); }}), 150); }
    } else {
      var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
      if (outside) { setTimeout(operation(cm, function () {
        if (counter != curCount) { return }
        display.scroller.scrollTop += outside;
        extend(e);
      }), 50); }
    }
  }

  function done(e) {
    cm.state.selectingText = false;
    counter = Infinity;
    e_preventDefault(e);
    display.input.focus();
    off(display.wrapper.ownerDocument, "mousemove", move);
    off(display.wrapper.ownerDocument, "mouseup", up);
    doc.history.lastSelOrigin = null;
  }

  var move = operation(cm, function (e) {
    if (!e_button(e)) { done(e); }
    else { extend(e); }
  });
  var up = operation(cm, done);
  cm.state.selectingText = up;
  on(display.wrapper.ownerDocument, "mousemove", move);
  on(display.wrapper.ownerDocument, "mouseup", up);
}

// Used when mouse-selecting to adjust the anchor to the proper side
// of a bidi jump depending on the visual position of the head.
function bidiSimplify(cm, range$$1) {
  var anchor = range$$1.anchor;
  var head = range$$1.head;
  var anchorLine = getLine(cm.doc, anchor.line);
  if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) { return range$$1 }
  var order = getOrder(anchorLine);
  if (!order) { return range$$1 }
  var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
  if (part.from != anchor.ch && part.to != anchor.ch) { return range$$1 }
  var boundary = index + ((part.from == anchor.ch) == (part.level != 1) ? 0 : 1);
  if (boundary == 0 || boundary == order.length) { return range$$1 }

  // Compute the relative visual position of the head compared to the
  // anchor (<0 is to the left, >0 to the right)
  var leftSide;
  if (head.line != anchor.line) {
    leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
  } else {
    var headIndex = getBidiPartAt(order, head.ch, head.sticky);
    var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
    if (headIndex == boundary - 1 || headIndex == boundary)
      { leftSide = dir < 0; }
    else
      { leftSide = dir > 0; }
  }

  var usePart = order[boundary + (leftSide ? -1 : 0)];
  var from = leftSide == (usePart.level == 1);
  var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
  return anchor.ch == ch && anchor.sticky == sticky ? range$$1 : new Range(new Pos(anchor.line, ch, sticky), head)
}


// Determines whether an event happened in the gutter, and fires the
// handlers for the corresponding event.
function gutterEvent(cm, e, type, prevent) {
  var mX, mY;
  if (e.touches) {
    mX = e.touches[0].clientX;
    mY = e.touches[0].clientY;
  } else {
    try { mX = e.clientX; mY = e.clientY; }
    catch(e) { return false }
  }
  if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) { return false }
  if (prevent) { e_preventDefault(e); }

  var display = cm.display;
  var lineBox = display.lineDiv.getBoundingClientRect();

  if (mY > lineBox.bottom || !hasHandler(cm, type)) { return e_defaultPrevented(e) }
  mY -= lineBox.top - display.viewOffset;

  for (var i = 0; i < cm.options.gutters.length; ++i) {
    var g = display.gutters.childNodes[i];
    if (g && g.getBoundingClientRect().right >= mX) {
      var line = lineAtHeight(cm.doc, mY);
      var gutter = cm.options.gutters[i];
      signal(cm, type, cm, line, gutter, e);
      return e_defaultPrevented(e)
    }
  }
}

function clickInGutter(cm, e) {
  return gutterEvent(cm, e, "gutterClick", true)
}

// CONTEXT MENU HANDLING

// To make the context menu work, we need to briefly unhide the
// textarea (making it as unobtrusive as possible) to let the
// right-click take effect on it.
function onContextMenu(cm, e) {
  if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) { return }
  if (signalDOMEvent(cm, e, "contextmenu")) { return }
  cm.display.input.onContextMenu(e);
}

function contextMenuInGutter(cm, e) {
  if (!hasHandler(cm, "gutterContextMenu")) { return false }
  return gutterEvent(cm, e, "gutterContextMenu", false)
}

function themeChanged(cm) {
  cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") +
    cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
  clearCaches(cm);
}

var Init = {toString: function(){return "CodeMirror.Init"}};

var defaults = {};
var optionHandlers = {};

function defineOptions(CodeMirror) {
  var optionHandlers = CodeMirror.optionHandlers;

  function option(name, deflt, handle, notOnInit) {
    CodeMirror.defaults[name] = deflt;
    if (handle) { optionHandlers[name] =
      notOnInit ? function (cm, val, old) {if (old != Init) { handle(cm, val, old); }} : handle; }
  }

  CodeMirror.defineOption = option;

  // Passed to option handlers when there is no old value.
  CodeMirror.Init = Init;

  // These two are, on init, called from the constructor because they
  // have to be initialized before the editor can start at all.
  option("value", "", function (cm, val) { return cm.setValue(val); }, true);
  option("mode", null, function (cm, val) {
    cm.doc.modeOption = val;
    loadMode(cm);
  }, true);

  option("indentUnit", 2, loadMode, true);
  option("indentWithTabs", false);
  option("smartIndent", true);
  option("tabSize", 4, function (cm) {
    resetModeState(cm);
    clearCaches(cm);
    regChange(cm);
  }, true);

  option("lineSeparator", null, function (cm, val) {
    cm.doc.lineSep = val;
    if (!val) { return }
    var newBreaks = [], lineNo = cm.doc.first;
    cm.doc.iter(function (line) {
      for (var pos = 0;;) {
        var found = line.text.indexOf(val, pos);
        if (found == -1) { break }
        pos = found + val.length;
        newBreaks.push(Pos(lineNo, found));
      }
      lineNo++;
    });
    for (var i = newBreaks.length - 1; i >= 0; i--)
      { replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length)); }
  });
  option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff]/g, function (cm, val, old) {
    cm.state.specialChars = new RegExp(val.source + (val.test("\t") ? "" : "|\t"), "g");
    if (old != Init) { cm.refresh(); }
  });
  option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function (cm) { return cm.refresh(); }, true);
  option("electricChars", true);
  option("inputStyle", mobile ? "contenteditable" : "textarea", function () {
    throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
  }, true);
  option("spellcheck", false, function (cm, val) { return cm.getInputField().spellcheck = val; }, true);
  option("rtlMoveVisually", !windows);
  option("wholeLineUpdateBefore", true);

  option("theme", "default", function (cm) {
    themeChanged(cm);
    guttersChanged(cm);
  }, true);
  option("keyMap", "default", function (cm, val, old) {
    var next = getKeyMap(val);
    var prev = old != Init && getKeyMap(old);
    if (prev && prev.detach) { prev.detach(cm, next); }
    if (next.attach) { next.attach(cm, prev || null); }
  });
  option("extraKeys", null);
  option("configureMouse", null);

  option("lineWrapping", false, wrappingChanged, true);
  option("gutters", [], function (cm) {
    setGuttersForLineNumbers(cm.options);
    guttersChanged(cm);
  }, true);
  option("fixedGutter", true, function (cm, val) {
    cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
    cm.refresh();
  }, true);
  option("coverGutterNextToScrollbar", false, function (cm) { return updateScrollbars(cm); }, true);
  option("scrollbarStyle", "native", function (cm) {
    initScrollbars(cm);
    updateScrollbars(cm);
    cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
    cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
  }, true);
  option("lineNumbers", false, function (cm) {
    setGuttersForLineNumbers(cm.options);
    guttersChanged(cm);
  }, true);
  option("firstLineNumber", 1, guttersChanged, true);
  option("lineNumberFormatter", function (integer) { return integer; }, guttersChanged, true);
  option("showCursorWhenSelecting", false, updateSelection, true);

  option("resetSelectionOnContextMenu", true);
  option("lineWiseCopyCut", true);
  option("pasteLinesPerSelection", true);

  option("readOnly", false, function (cm, val) {
    if (val == "nocursor") {
      onBlur(cm);
      cm.display.input.blur();
    }
    cm.display.input.readOnlyChanged(val);
  });
  option("disableInput", false, function (cm, val) {if (!val) { cm.display.input.reset(); }}, true);
  option("dragDrop", true, dragDropChanged);
  option("allowDropFileTypes", null);

  option("cursorBlinkRate", 530);
  option("cursorScrollMargin", 0);
  option("cursorHeight", 1, updateSelection, true);
  option("singleCursorHeightPerLine", true, updateSelection, true);
  option("workTime", 100);
  option("workDelay", 100);
  option("flattenSpans", true, resetModeState, true);
  option("addModeClass", false, resetModeState, true);
  option("pollInterval", 100);
  option("undoDepth", 200, function (cm, val) { return cm.doc.history.undoDepth = val; });
  option("historyEventDelay", 1250);
  option("viewportMargin", 10, function (cm) { return cm.refresh(); }, true);
  option("maxHighlightLength", 10000, resetModeState, true);
  option("moveInputWithCursor", true, function (cm, val) {
    if (!val) { cm.display.input.resetPosition(); }
  });

  option("tabindex", null, function (cm, val) { return cm.display.input.getField().tabIndex = val || ""; });
  option("autofocus", null);
  option("direction", "ltr", function (cm, val) { return cm.doc.setDirection(val); }, true);
}

function guttersChanged(cm) {
  updateGutters(cm);
  regChange(cm);
  alignHorizontally(cm);
}

function dragDropChanged(cm, value, old) {
  var wasOn = old && old != Init;
  if (!value != !wasOn) {
    var funcs = cm.display.dragFunctions;
    var toggle = value ? on : off;
    toggle(cm.display.scroller, "dragstart", funcs.start);
    toggle(cm.display.scroller, "dragenter", funcs.enter);
    toggle(cm.display.scroller, "dragover", funcs.over);
    toggle(cm.display.scroller, "dragleave", funcs.leave);
    toggle(cm.display.scroller, "drop", funcs.drop);
  }
}

function wrappingChanged(cm) {
  if (cm.options.lineWrapping) {
    addClass(cm.display.wrapper, "CodeMirror-wrap");
    cm.display.sizer.style.minWidth = "";
    cm.display.sizerWidth = null;
  } else {
    rmClass(cm.display.wrapper, "CodeMirror-wrap");
    findMaxLine(cm);
  }
  estimateLineHeights(cm);
  regChange(cm);
  clearCaches(cm);
  setTimeout(function () { return updateScrollbars(cm); }, 100);
}

// A CodeMirror instance represents an editor. This is the object
// that user code is usually dealing with.

function CodeMirror$1(place, options) {
  var this$1 = this;

  if (!(this instanceof CodeMirror$1)) { return new CodeMirror$1(place, options) }

  this.options = options = options ? copyObj(options) : {};
  // Determine effective options based on given values and defaults.
  copyObj(defaults, options, false);
  setGuttersForLineNumbers(options);

  var doc = options.value;
  if (typeof doc == "string") { doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction); }
  this.doc = doc;

  var input = new CodeMirror$1.inputStyles[options.inputStyle](this);
  var display = this.display = new Display(place, doc, input);
  display.wrapper.CodeMirror = this;
  updateGutters(this);
  themeChanged(this);
  if (options.lineWrapping)
    { this.display.wrapper.className += " CodeMirror-wrap"; }
  initScrollbars(this);

  this.state = {
    keyMaps: [],  // stores maps added by addKeyMap
    overlays: [], // highlighting overlays, as added by addOverlay
    modeGen: 0,   // bumped when mode/overlay changes, used to invalidate highlighting info
    overwrite: false,
    delayingBlurEvent: false,
    focused: false,
    suppressEdits: false, // used to disable editing during key handlers when in readOnly mode
    pasteIncoming: false, cutIncoming: false, // help recognize paste/cut edits in input.poll
    selectingText: false,
    draggingText: false,
    highlight: new Delayed(), // stores highlight worker timeout
    keySeq: null,  // Unfinished key sequence
    specialChars: null
  };

  if (options.autofocus && !mobile) { display.input.focus(); }

  // Override magic textarea content restore that IE sometimes does
  // on our hidden textarea on reload
  if (ie && ie_version < 11) { setTimeout(function () { return this$1.display.input.reset(true); }, 20); }

  registerEventHandlers(this);
  ensureGlobalHandlers();

  startOperation(this);
  this.curOp.forceUpdate = true;
  attachDoc(this, doc);

  if ((options.autofocus && !mobile) || this.hasFocus())
    { setTimeout(bind(onFocus, this), 20); }
  else
    { onBlur(this); }

  for (var opt in optionHandlers) { if (optionHandlers.hasOwnProperty(opt))
    { optionHandlers[opt](this$1, options[opt], Init); } }
  maybeUpdateLineNumberWidth(this);
  if (options.finishInit) { options.finishInit(this); }
  for (var i = 0; i < initHooks.length; ++i) { initHooks[i](this$1); }
  endOperation(this);
  // Suppress optimizelegibility in Webkit, since it breaks text
  // measuring on line wrapping boundaries.
  if (webkit && options.lineWrapping &&
      getComputedStyle(display.lineDiv).textRendering == "optimizelegibility")
    { display.lineDiv.style.textRendering = "auto"; }
}

// The default configuration options.
CodeMirror$1.defaults = defaults;
// Functions to run when options are changed.
CodeMirror$1.optionHandlers = optionHandlers;

// Attach the necessary event handlers when initializing the editor
function registerEventHandlers(cm) {
  var d = cm.display;
  on(d.scroller, "mousedown", operation(cm, onMouseDown));
  // Older IE's will not fire a second mousedown for a double click
  if (ie && ie_version < 11)
    { on(d.scroller, "dblclick", operation(cm, function (e) {
      if (signalDOMEvent(cm, e)) { return }
      var pos = posFromMouse(cm, e);
      if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) { return }
      e_preventDefault(e);
      var word = cm.findWordAt(pos);
      extendSelection(cm.doc, word.anchor, word.head);
    })); }
  else
    { on(d.scroller, "dblclick", function (e) { return signalDOMEvent(cm, e) || e_preventDefault(e); }); }
  // Some browsers fire contextmenu *after* opening the menu, at
  // which point we can't mess with it anymore. Context menu is
  // handled in onMouseDown for these browsers.
  if (!captureRightClick) { on(d.scroller, "contextmenu", function (e) { return onContextMenu(cm, e); }); }

  // Used to suppress mouse event handling when a touch happens
  var touchFinished, prevTouch = {end: 0};
  function finishTouch() {
    if (d.activeTouch) {
      touchFinished = setTimeout(function () { return d.activeTouch = null; }, 1000);
      prevTouch = d.activeTouch;
      prevTouch.end = +new Date;
    }
  }
  function isMouseLikeTouchEvent(e) {
    if (e.touches.length != 1) { return false }
    var touch = e.touches[0];
    return touch.radiusX <= 1 && touch.radiusY <= 1
  }
  function farAway(touch, other) {
    if (other.left == null) { return true }
    var dx = other.left - touch.left, dy = other.top - touch.top;
    return dx * dx + dy * dy > 20 * 20
  }
  on(d.scroller, "touchstart", function (e) {
    if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
      d.input.ensurePolled();
      clearTimeout(touchFinished);
      var now = +new Date;
      d.activeTouch = {start: now, moved: false,
                       prev: now - prevTouch.end <= 300 ? prevTouch : null};
      if (e.touches.length == 1) {
        d.activeTouch.left = e.touches[0].pageX;
        d.activeTouch.top = e.touches[0].pageY;
      }
    }
  });
  on(d.scroller, "touchmove", function () {
    if (d.activeTouch) { d.activeTouch.moved = true; }
  });
  on(d.scroller, "touchend", function (e) {
    var touch = d.activeTouch;
    if (touch && !eventInWidget(d, e) && touch.left != null &&
        !touch.moved && new Date - touch.start < 300) {
      var pos = cm.coordsChar(d.activeTouch, "page"), range;
      if (!touch.prev || farAway(touch, touch.prev)) // Single tap
        { range = new Range(pos, pos); }
      else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) // Double tap
        { range = cm.findWordAt(pos); }
      else // Triple tap
        { range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0))); }
      cm.setSelection(range.anchor, range.head);
      cm.focus();
      e_preventDefault(e);
    }
    finishTouch();
  });
  on(d.scroller, "touchcancel", finishTouch);

  // Sync scrolling between fake scrollbars and real scrollable
  // area, ensure viewport is updated when scrolling.
  on(d.scroller, "scroll", function () {
    if (d.scroller.clientHeight) {
      updateScrollTop(cm, d.scroller.scrollTop);
      setScrollLeft(cm, d.scroller.scrollLeft, true);
      signal(cm, "scroll", cm);
    }
  });

  // Listen to wheel events in order to try and update the viewport on time.
  on(d.scroller, "mousewheel", function (e) { return onScrollWheel(cm, e); });
  on(d.scroller, "DOMMouseScroll", function (e) { return onScrollWheel(cm, e); });

  // Prevent wrapper from ever scrolling
  on(d.wrapper, "scroll", function () { return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0; });

  d.dragFunctions = {
    enter: function (e) {if (!signalDOMEvent(cm, e)) { e_stop(e); }},
    over: function (e) {if (!signalDOMEvent(cm, e)) { onDragOver(cm, e); e_stop(e); }},
    start: function (e) { return onDragStart(cm, e); },
    drop: operation(cm, onDrop),
    leave: function (e) {if (!signalDOMEvent(cm, e)) { clearDragCursor(cm); }}
  };

  var inp = d.input.getField();
  on(inp, "keyup", function (e) { return onKeyUp.call(cm, e); });
  on(inp, "keydown", operation(cm, onKeyDown));
  on(inp, "keypress", operation(cm, onKeyPress));
  on(inp, "focus", function (e) { return onFocus(cm, e); });
  on(inp, "blur", function (e) { return onBlur(cm, e); });
}

var initHooks = [];
CodeMirror$1.defineInitHook = function (f) { return initHooks.push(f); };

// Indent the given line. The how parameter can be "smart",
// "add"/null, "subtract", or "prev". When aggressive is false
// (typically set to true for forced single-line indents), empty
// lines are not indented, and places where the mode returns Pass
// are left alone.
function indentLine(cm, n, how, aggressive) {
  var doc = cm.doc, state;
  if (how == null) { how = "add"; }
  if (how == "smart") {
    // Fall back to "prev" when the mode doesn't have an indentation
    // method.
    if (!doc.mode.indent) { how = "prev"; }
    else { state = getContextBefore(cm, n).state; }
  }

  var tabSize = cm.options.tabSize;
  var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
  if (line.stateAfter) { line.stateAfter = null; }
  var curSpaceString = line.text.match(/^\s*/)[0], indentation;
  if (!aggressive && !/\S/.test(line.text)) {
    indentation = 0;
    how = "not";
  } else if (how == "smart") {
    indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
    if (indentation == Pass || indentation > 150) {
      if (!aggressive) { return }
      how = "prev";
    }
  }
  if (how == "prev") {
    if (n > doc.first) { indentation = countColumn(getLine(doc, n-1).text, null, tabSize); }
    else { indentation = 0; }
  } else if (how == "add") {
    indentation = curSpace + cm.options.indentUnit;
  } else if (how == "subtract") {
    indentation = curSpace - cm.options.indentUnit;
  } else if (typeof how == "number") {
    indentation = curSpace + how;
  }
  indentation = Math.max(0, indentation);

  var indentString = "", pos = 0;
  if (cm.options.indentWithTabs)
    { for (var i = Math.floor(indentation / tabSize); i; --i) {pos += tabSize; indentString += "\t";} }
  if (pos < indentation) { indentString += spaceStr(indentation - pos); }

  if (indentString != curSpaceString) {
    replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
    line.stateAfter = null;
    return true
  } else {
    // Ensure that, if the cursor was in the whitespace at the start
    // of the line, it is moved to the end of that space.
    for (var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++) {
      var range = doc.sel.ranges[i$1];
      if (range.head.line == n && range.head.ch < curSpaceString.length) {
        var pos$1 = Pos(n, curSpaceString.length);
        replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
        break
      }
    }
  }
}

// This will be set to a {lineWise: bool, text: [string]} object, so
// that, when pasting, we know what kind of selections the copied
// text was made out of.
var lastCopied = null;

function setLastCopied(newLastCopied) {
  lastCopied = newLastCopied;
}

function applyTextInput(cm, inserted, deleted, sel, origin) {
  var doc = cm.doc;
  cm.display.shift = false;
  if (!sel) { sel = doc.sel; }

  var paste = cm.state.pasteIncoming || origin == "paste";
  var textLines = splitLinesAuto(inserted), multiPaste = null;
  // When pasting N lines into N selections, insert one line per selection
  if (paste && sel.ranges.length > 1) {
    if (lastCopied && lastCopied.text.join("\n") == inserted) {
      if (sel.ranges.length % lastCopied.text.length == 0) {
        multiPaste = [];
        for (var i = 0; i < lastCopied.text.length; i++)
          { multiPaste.push(doc.splitLines(lastCopied.text[i])); }
      }
    } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
      multiPaste = map(textLines, function (l) { return [l]; });
    }
  }

  var updateInput;
  // Normal behavior is to insert the new text into every selection
  for (var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--) {
    var range$$1 = sel.ranges[i$1];
    var from = range$$1.from(), to = range$$1.to();
    if (range$$1.empty()) {
      if (deleted && deleted > 0) // Handle deletion
        { from = Pos(from.line, from.ch - deleted); }
      else if (cm.state.overwrite && !paste) // Handle overwrite
        { to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length)); }
      else if (lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted)
        { from = to = Pos(from.line, 0); }
    }
    updateInput = cm.curOp.updateInput;
    var changeEvent = {from: from, to: to, text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                       origin: origin || (paste ? "paste" : cm.state.cutIncoming ? "cut" : "+input")};
    makeChange(cm.doc, changeEvent);
    signalLater(cm, "inputRead", cm, changeEvent);
  }
  if (inserted && !paste)
    { triggerElectric(cm, inserted); }

  ensureCursorVisible(cm);
  cm.curOp.updateInput = updateInput;
  cm.curOp.typing = true;
  cm.state.pasteIncoming = cm.state.cutIncoming = false;
}

function handlePaste(e, cm) {
  var pasted = e.clipboardData && e.clipboardData.getData("Text");
  if (pasted) {
    e.preventDefault();
    if (!cm.isReadOnly() && !cm.options.disableInput)
      { runInOp(cm, function () { return applyTextInput(cm, pasted, 0, null, "paste"); }); }
    return true
  }
}

function triggerElectric(cm, inserted) {
  // When an 'electric' character is inserted, immediately trigger a reindent
  if (!cm.options.electricChars || !cm.options.smartIndent) { return }
  var sel = cm.doc.sel;

  for (var i = sel.ranges.length - 1; i >= 0; i--) {
    var range$$1 = sel.ranges[i];
    if (range$$1.head.ch > 100 || (i && sel.ranges[i - 1].head.line == range$$1.head.line)) { continue }
    var mode = cm.getModeAt(range$$1.head);
    var indented = false;
    if (mode.electricChars) {
      for (var j = 0; j < mode.electricChars.length; j++)
        { if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
          indented = indentLine(cm, range$$1.head.line, "smart");
          break
        } }
    } else if (mode.electricInput) {
      if (mode.electricInput.test(getLine(cm.doc, range$$1.head.line).text.slice(0, range$$1.head.ch)))
        { indented = indentLine(cm, range$$1.head.line, "smart"); }
    }
    if (indented) { signalLater(cm, "electricInput", cm, range$$1.head.line); }
  }
}

function copyableRanges(cm) {
  var text = [], ranges = [];
  for (var i = 0; i < cm.doc.sel.ranges.length; i++) {
    var line = cm.doc.sel.ranges[i].head.line;
    var lineRange = {anchor: Pos(line, 0), head: Pos(line + 1, 0)};
    ranges.push(lineRange);
    text.push(cm.getRange(lineRange.anchor, lineRange.head));
  }
  return {text: text, ranges: ranges}
}

function disableBrowserMagic(field, spellcheck) {
  field.setAttribute("autocorrect", "off");
  field.setAttribute("autocapitalize", "off");
  field.setAttribute("spellcheck", !!spellcheck);
}

function hiddenTextarea() {
  var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
  var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
  // The textarea is kept positioned near the cursor to prevent the
  // fact that it'll be scrolled into view on input from scrolling
  // our fake cursor out of view. On webkit, when wrap=off, paste is
  // very slow. So make the area wide instead.
  if (webkit) { te.style.width = "1000px"; }
  else { te.setAttribute("wrap", "off"); }
  // If border: 0; -- iOS fails to open keyboard (issue #1287)
  if (ios) { te.style.border = "1px solid black"; }
  disableBrowserMagic(te);
  return div
}

// The publicly visible API. Note that methodOp(f) means
// 'wrap f in an operation, performed on its `this` parameter'.

// This is not the complete set of editor methods. Most of the
// methods defined on the Doc type are also injected into
// CodeMirror.prototype, for backwards compatibility and
// convenience.

var addEditorMethods = function(CodeMirror) {
  var optionHandlers = CodeMirror.optionHandlers;

  var helpers = CodeMirror.helpers = {};

  CodeMirror.prototype = {
    constructor: CodeMirror,
    focus: function(){window.focus(); this.display.input.focus();},

    setOption: function(option, value) {
      var options = this.options, old = options[option];
      if (options[option] == value && option != "mode") { return }
      options[option] = value;
      if (optionHandlers.hasOwnProperty(option))
        { operation(this, optionHandlers[option])(this, value, old); }
      signal(this, "optionChange", this, option);
    },

    getOption: function(option) {return this.options[option]},
    getDoc: function() {return this.doc},

    addKeyMap: function(map$$1, bottom) {
      this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map$$1));
    },
    removeKeyMap: function(map$$1) {
      var maps = this.state.keyMaps;
      for (var i = 0; i < maps.length; ++i)
        { if (maps[i] == map$$1 || maps[i].name == map$$1) {
          maps.splice(i, 1);
          return true
        } }
    },

    addOverlay: methodOp(function(spec, options) {
      var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
      if (mode.startState) { throw new Error("Overlays may not be stateful.") }
      insertSorted(this.state.overlays,
                   {mode: mode, modeSpec: spec, opaque: options && options.opaque,
                    priority: (options && options.priority) || 0},
                   function (overlay) { return overlay.priority; });
      this.state.modeGen++;
      regChange(this);
    }),
    removeOverlay: methodOp(function(spec) {
      var this$1 = this;

      var overlays = this.state.overlays;
      for (var i = 0; i < overlays.length; ++i) {
        var cur = overlays[i].modeSpec;
        if (cur == spec || typeof spec == "string" && cur.name == spec) {
          overlays.splice(i, 1);
          this$1.state.modeGen++;
          regChange(this$1);
          return
        }
      }
    }),

    indentLine: methodOp(function(n, dir, aggressive) {
      if (typeof dir != "string" && typeof dir != "number") {
        if (dir == null) { dir = this.options.smartIndent ? "smart" : "prev"; }
        else { dir = dir ? "add" : "subtract"; }
      }
      if (isLine(this.doc, n)) { indentLine(this, n, dir, aggressive); }
    }),
    indentSelection: methodOp(function(how) {
      var this$1 = this;

      var ranges = this.doc.sel.ranges, end = -1;
      for (var i = 0; i < ranges.length; i++) {
        var range$$1 = ranges[i];
        if (!range$$1.empty()) {
          var from = range$$1.from(), to = range$$1.to();
          var start = Math.max(end, from.line);
          end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
          for (var j = start; j < end; ++j)
            { indentLine(this$1, j, how); }
          var newRanges = this$1.doc.sel.ranges;
          if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0)
            { replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll); }
        } else if (range$$1.head.line > end) {
          indentLine(this$1, range$$1.head.line, how, true);
          end = range$$1.head.line;
          if (i == this$1.doc.sel.primIndex) { ensureCursorVisible(this$1); }
        }
      }
    }),

    // Fetch the parser token for a given character. Useful for hacks
    // that want to inspect the mode state (say, for completion).
    getTokenAt: function(pos, precise) {
      return takeToken(this, pos, precise)
    },

    getLineTokens: function(line, precise) {
      return takeToken(this, Pos(line), precise, true)
    },

    getTokenTypeAt: function(pos) {
      pos = clipPos(this.doc, pos);
      var styles = getLineStyles(this, getLine(this.doc, pos.line));
      var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
      var type;
      if (ch == 0) { type = styles[2]; }
      else { for (;;) {
        var mid = (before + after) >> 1;
        if ((mid ? styles[mid * 2 - 1] : 0) >= ch) { after = mid; }
        else if (styles[mid * 2 + 1] < ch) { before = mid + 1; }
        else { type = styles[mid * 2 + 2]; break }
      } }
      var cut = type ? type.indexOf("overlay ") : -1;
      return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1)
    },

    getModeAt: function(pos) {
      var mode = this.doc.mode;
      if (!mode.innerMode) { return mode }
      return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode
    },

    getHelper: function(pos, type) {
      return this.getHelpers(pos, type)[0]
    },

    getHelpers: function(pos, type) {
      var this$1 = this;

      var found = [];
      if (!helpers.hasOwnProperty(type)) { return found }
      var help = helpers[type], mode = this.getModeAt(pos);
      if (typeof mode[type] == "string") {
        if (help[mode[type]]) { found.push(help[mode[type]]); }
      } else if (mode[type]) {
        for (var i = 0; i < mode[type].length; i++) {
          var val = help[mode[type][i]];
          if (val) { found.push(val); }
        }
      } else if (mode.helperType && help[mode.helperType]) {
        found.push(help[mode.helperType]);
      } else if (help[mode.name]) {
        found.push(help[mode.name]);
      }
      for (var i$1 = 0; i$1 < help._global.length; i$1++) {
        var cur = help._global[i$1];
        if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1)
          { found.push(cur.val); }
      }
      return found
    },

    getStateAfter: function(line, precise) {
      var doc = this.doc;
      line = clipLine(doc, line == null ? doc.first + doc.size - 1: line);
      return getContextBefore(this, line + 1, precise).state
    },

    cursorCoords: function(start, mode) {
      var pos, range$$1 = this.doc.sel.primary();
      if (start == null) { pos = range$$1.head; }
      else if (typeof start == "object") { pos = clipPos(this.doc, start); }
      else { pos = start ? range$$1.from() : range$$1.to(); }
      return cursorCoords(this, pos, mode || "page")
    },

    charCoords: function(pos, mode) {
      return charCoords(this, clipPos(this.doc, pos), mode || "page")
    },

    coordsChar: function(coords, mode) {
      coords = fromCoordSystem(this, coords, mode || "page");
      return coordsChar(this, coords.left, coords.top)
    },

    lineAtHeight: function(height, mode) {
      height = fromCoordSystem(this, {top: height, left: 0}, mode || "page").top;
      return lineAtHeight(this.doc, height + this.display.viewOffset)
    },
    heightAtLine: function(line, mode, includeWidgets) {
      var end = false, lineObj;
      if (typeof line == "number") {
        var last = this.doc.first + this.doc.size - 1;
        if (line < this.doc.first) { line = this.doc.first; }
        else if (line > last) { line = last; end = true; }
        lineObj = getLine(this.doc, line);
      } else {
        lineObj = line;
      }
      return intoCoordSystem(this, lineObj, {top: 0, left: 0}, mode || "page", includeWidgets || end).top +
        (end ? this.doc.height - heightAtLine(lineObj) : 0)
    },

    defaultTextHeight: function() { return textHeight(this.display) },
    defaultCharWidth: function() { return charWidth(this.display) },

    getViewport: function() { return {from: this.display.viewFrom, to: this.display.viewTo}},

    addWidget: function(pos, node, scroll, vert, horiz) {
      var display = this.display;
      pos = cursorCoords(this, clipPos(this.doc, pos));
      var top = pos.bottom, left = pos.left;
      node.style.position = "absolute";
      node.setAttribute("cm-ignore-events", "true");
      this.display.input.setUneditable(node);
      display.sizer.appendChild(node);
      if (vert == "over") {
        top = pos.top;
      } else if (vert == "above" || vert == "near") {
        var vspace = Math.max(display.wrapper.clientHeight, this.doc.height),
        hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
        // Default to positioning above (if specified and possible); otherwise default to positioning below
        if ((vert == 'above' || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight)
          { top = pos.top - node.offsetHeight; }
        else if (pos.bottom + node.offsetHeight <= vspace)
          { top = pos.bottom; }
        if (left + node.offsetWidth > hspace)
          { left = hspace - node.offsetWidth; }
      }
      node.style.top = top + "px";
      node.style.left = node.style.right = "";
      if (horiz == "right") {
        left = display.sizer.clientWidth - node.offsetWidth;
        node.style.right = "0px";
      } else {
        if (horiz == "left") { left = 0; }
        else if (horiz == "middle") { left = (display.sizer.clientWidth - node.offsetWidth) / 2; }
        node.style.left = left + "px";
      }
      if (scroll)
        { scrollIntoView(this, {left: left, top: top, right: left + node.offsetWidth, bottom: top + node.offsetHeight}); }
    },

    triggerOnKeyDown: methodOp(onKeyDown),
    triggerOnKeyPress: methodOp(onKeyPress),
    triggerOnKeyUp: onKeyUp,
    triggerOnMouseDown: methodOp(onMouseDown),

    execCommand: function(cmd) {
      if (commands.hasOwnProperty(cmd))
        { return commands[cmd].call(null, this) }
    },

    triggerElectric: methodOp(function(text) { triggerElectric(this, text); }),

    findPosH: function(from, amount, unit, visually) {
      var this$1 = this;

      var dir = 1;
      if (amount < 0) { dir = -1; amount = -amount; }
      var cur = clipPos(this.doc, from);
      for (var i = 0; i < amount; ++i) {
        cur = findPosH(this$1.doc, cur, dir, unit, visually);
        if (cur.hitSide) { break }
      }
      return cur
    },

    moveH: methodOp(function(dir, unit) {
      var this$1 = this;

      this.extendSelectionsBy(function (range$$1) {
        if (this$1.display.shift || this$1.doc.extend || range$$1.empty())
          { return findPosH(this$1.doc, range$$1.head, dir, unit, this$1.options.rtlMoveVisually) }
        else
          { return dir < 0 ? range$$1.from() : range$$1.to() }
      }, sel_move);
    }),

    deleteH: methodOp(function(dir, unit) {
      var sel = this.doc.sel, doc = this.doc;
      if (sel.somethingSelected())
        { doc.replaceSelection("", null, "+delete"); }
      else
        { deleteNearSelection(this, function (range$$1) {
          var other = findPosH(doc, range$$1.head, dir, unit, false);
          return dir < 0 ? {from: other, to: range$$1.head} : {from: range$$1.head, to: other}
        }); }
    }),

    findPosV: function(from, amount, unit, goalColumn) {
      var this$1 = this;

      var dir = 1, x = goalColumn;
      if (amount < 0) { dir = -1; amount = -amount; }
      var cur = clipPos(this.doc, from);
      for (var i = 0; i < amount; ++i) {
        var coords = cursorCoords(this$1, cur, "div");
        if (x == null) { x = coords.left; }
        else { coords.left = x; }
        cur = findPosV(this$1, coords, dir, unit);
        if (cur.hitSide) { break }
      }
      return cur
    },

    moveV: methodOp(function(dir, unit) {
      var this$1 = this;

      var doc = this.doc, goals = [];
      var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
      doc.extendSelectionsBy(function (range$$1) {
        if (collapse)
          { return dir < 0 ? range$$1.from() : range$$1.to() }
        var headPos = cursorCoords(this$1, range$$1.head, "div");
        if (range$$1.goalColumn != null) { headPos.left = range$$1.goalColumn; }
        goals.push(headPos.left);
        var pos = findPosV(this$1, headPos, dir, unit);
        if (unit == "page" && range$$1 == doc.sel.primary())
          { addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top); }
        return pos
      }, sel_move);
      if (goals.length) { for (var i = 0; i < doc.sel.ranges.length; i++)
        { doc.sel.ranges[i].goalColumn = goals[i]; } }
    }),

    // Find the word at the given position (as returned by coordsChar).
    findWordAt: function(pos) {
      var doc = this.doc, line = getLine(doc, pos.line).text;
      var start = pos.ch, end = pos.ch;
      if (line) {
        var helper = this.getHelper(pos, "wordChars");
        if ((pos.sticky == "before" || end == line.length) && start) { --start; } else { ++end; }
        var startChar = line.charAt(start);
        var check = isWordChar(startChar, helper)
          ? function (ch) { return isWordChar(ch, helper); }
          : /\s/.test(startChar) ? function (ch) { return /\s/.test(ch); }
          : function (ch) { return (!/\s/.test(ch) && !isWordChar(ch)); };
        while (start > 0 && check(line.charAt(start - 1))) { --start; }
        while (end < line.length && check(line.charAt(end))) { ++end; }
      }
      return new Range(Pos(pos.line, start), Pos(pos.line, end))
    },

    toggleOverwrite: function(value) {
      if (value != null && value == this.state.overwrite) { return }
      if (this.state.overwrite = !this.state.overwrite)
        { addClass(this.display.cursorDiv, "CodeMirror-overwrite"); }
      else
        { rmClass(this.display.cursorDiv, "CodeMirror-overwrite"); }

      signal(this, "overwriteToggle", this, this.state.overwrite);
    },
    hasFocus: function() { return this.display.input.getField() == activeElt() },
    isReadOnly: function() { return !!(this.options.readOnly || this.doc.cantEdit) },

    scrollTo: methodOp(function (x, y) { scrollToCoords(this, x, y); }),
    getScrollInfo: function() {
      var scroller = this.display.scroller;
      return {left: scroller.scrollLeft, top: scroller.scrollTop,
              height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
              width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
              clientHeight: displayHeight(this), clientWidth: displayWidth(this)}
    },

    scrollIntoView: methodOp(function(range$$1, margin) {
      if (range$$1 == null) {
        range$$1 = {from: this.doc.sel.primary().head, to: null};
        if (margin == null) { margin = this.options.cursorScrollMargin; }
      } else if (typeof range$$1 == "number") {
        range$$1 = {from: Pos(range$$1, 0), to: null};
      } else if (range$$1.from == null) {
        range$$1 = {from: range$$1, to: null};
      }
      if (!range$$1.to) { range$$1.to = range$$1.from; }
      range$$1.margin = margin || 0;

      if (range$$1.from.line != null) {
        scrollToRange(this, range$$1);
      } else {
        scrollToCoordsRange(this, range$$1.from, range$$1.to, range$$1.margin);
      }
    }),

    setSize: methodOp(function(width, height) {
      var this$1 = this;

      var interpret = function (val) { return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val; };
      if (width != null) { this.display.wrapper.style.width = interpret(width); }
      if (height != null) { this.display.wrapper.style.height = interpret(height); }
      if (this.options.lineWrapping) { clearLineMeasurementCache(this); }
      var lineNo$$1 = this.display.viewFrom;
      this.doc.iter(lineNo$$1, this.display.viewTo, function (line) {
        if (line.widgets) { for (var i = 0; i < line.widgets.length; i++)
          { if (line.widgets[i].noHScroll) { regLineChange(this$1, lineNo$$1, "widget"); break } } }
        ++lineNo$$1;
      });
      this.curOp.forceUpdate = true;
      signal(this, "refresh", this);
    }),

    operation: function(f){return runInOp(this, f)},
    startOperation: function(){return startOperation(this)},
    endOperation: function(){return endOperation(this)},

    refresh: methodOp(function() {
      var oldHeight = this.display.cachedTextHeight;
      regChange(this);
      this.curOp.forceUpdate = true;
      clearCaches(this);
      scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
      updateGutterSpace(this);
      if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5)
        { estimateLineHeights(this); }
      signal(this, "refresh", this);
    }),

    swapDoc: methodOp(function(doc) {
      var old = this.doc;
      old.cm = null;
      attachDoc(this, doc);
      clearCaches(this);
      this.display.input.reset();
      scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
      this.curOp.forceScroll = true;
      signalLater(this, "swapDoc", this, old);
      return old
    }),

    getInputField: function(){return this.display.input.getField()},
    getWrapperElement: function(){return this.display.wrapper},
    getScrollerElement: function(){return this.display.scroller},
    getGutterElement: function(){return this.display.gutters}
  };
  eventMixin(CodeMirror);

  CodeMirror.registerHelper = function(type, name, value) {
    if (!helpers.hasOwnProperty(type)) { helpers[type] = CodeMirror[type] = {_global: []}; }
    helpers[type][name] = value;
  };
  CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
    CodeMirror.registerHelper(type, name, value);
    helpers[type]._global.push({pred: predicate, val: value});
  };
};

// Used for horizontal relative motion. Dir is -1 or 1 (left or
// right), unit can be "char", "column" (like char, but doesn't
// cross line boundaries), "word" (across next word), or "group" (to
// the start of next group of word or non-word-non-whitespace
// chars). The visually param controls whether, in right-to-left
// text, direction 1 means to move towards the next index in the
// string, or towards the character to the right of the current
// position. The resulting position will have a hitSide=true
// property if it reached the end of the document.
function findPosH(doc, pos, dir, unit, visually) {
  var oldPos = pos;
  var origDir = dir;
  var lineObj = getLine(doc, pos.line);
  function findNextLine() {
    var l = pos.line + dir;
    if (l < doc.first || l >= doc.first + doc.size) { return false }
    pos = new Pos(l, pos.ch, pos.sticky);
    return lineObj = getLine(doc, l)
  }
  function moveOnce(boundToLine) {
    var next;
    if (visually) {
      next = moveVisually(doc.cm, lineObj, pos, dir);
    } else {
      next = moveLogically(lineObj, pos, dir);
    }
    if (next == null) {
      if (!boundToLine && findNextLine())
        { pos = endOfLine(visually, doc.cm, lineObj, pos.line, dir); }
      else
        { return false }
    } else {
      pos = next;
    }
    return true
  }

  if (unit == "char") {
    moveOnce();
  } else if (unit == "column") {
    moveOnce(true);
  } else if (unit == "word" || unit == "group") {
    var sawType = null, group = unit == "group";
    var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
    for (var first = true;; first = false) {
      if (dir < 0 && !moveOnce(!first)) { break }
      var cur = lineObj.text.charAt(pos.ch) || "\n";
      var type = isWordChar(cur, helper) ? "w"
        : group && cur == "\n" ? "n"
        : !group || /\s/.test(cur) ? null
        : "p";
      if (group && !first && !type) { type = "s"; }
      if (sawType && sawType != type) {
        if (dir < 0) {dir = 1; moveOnce(); pos.sticky = "after";}
        break
      }

      if (type) { sawType = type; }
      if (dir > 0 && !moveOnce(!first)) { break }
    }
  }
  var result = skipAtomic(doc, pos, oldPos, origDir, true);
  if (equalCursorPos(oldPos, result)) { result.hitSide = true; }
  return result
}

// For relative vertical movement. Dir may be -1 or 1. Unit can be
// "page" or "line". The resulting position will have a hitSide=true
// property if it reached the end of the document.
function findPosV(cm, pos, dir, unit) {
  var doc = cm.doc, x = pos.left, y;
  if (unit == "page") {
    var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
    var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
    y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;

  } else if (unit == "line") {
    y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
  }
  var target;
  for (;;) {
    target = coordsChar(cm, x, y);
    if (!target.outside) { break }
    if (dir < 0 ? y <= 0 : y >= doc.height) { target.hitSide = true; break }
    y += dir * 5;
  }
  return target
}

// CONTENTEDITABLE INPUT STYLE

var ContentEditableInput = function(cm) {
  this.cm = cm;
  this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
  this.polling = new Delayed();
  this.composing = null;
  this.gracePeriod = false;
  this.readDOMTimeout = null;
};

ContentEditableInput.prototype.init = function (display) {
    var this$1 = this;

  var input = this, cm = input.cm;
  var div = input.div = display.lineDiv;
  disableBrowserMagic(div, cm.options.spellcheck);

  on(div, "paste", function (e) {
    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }
    // IE doesn't fire input events, so we schedule a read for the pasted content in this way
    if (ie_version <= 11) { setTimeout(operation(cm, function () { return this$1.updateFromDOM(); }), 20); }
  });

  on(div, "compositionstart", function (e) {
    this$1.composing = {data: e.data, done: false};
  });
  on(div, "compositionupdate", function (e) {
    if (!this$1.composing) { this$1.composing = {data: e.data, done: false}; }
  });
  on(div, "compositionend", function (e) {
    if (this$1.composing) {
      if (e.data != this$1.composing.data) { this$1.readFromDOMSoon(); }
      this$1.composing.done = true;
    }
  });

  on(div, "touchstart", function () { return input.forceCompositionEnd(); });

  on(div, "input", function () {
    if (!this$1.composing) { this$1.readFromDOMSoon(); }
  });

  function onCopyCut(e) {
    if (signalDOMEvent(cm, e)) { return }
    if (cm.somethingSelected()) {
      setLastCopied({lineWise: false, text: cm.getSelections()});
      if (e.type == "cut") { cm.replaceSelection("", null, "cut"); }
    } else if (!cm.options.lineWiseCopyCut) {
      return
    } else {
      var ranges = copyableRanges(cm);
      setLastCopied({lineWise: true, text: ranges.text});
      if (e.type == "cut") {
        cm.operation(function () {
          cm.setSelections(ranges.ranges, 0, sel_dontScroll);
          cm.replaceSelection("", null, "cut");
        });
      }
    }
    if (e.clipboardData) {
      e.clipboardData.clearData();
      var content = lastCopied.text.join("\n");
      // iOS exposes the clipboard API, but seems to discard content inserted into it
      e.clipboardData.setData("Text", content);
      if (e.clipboardData.getData("Text") == content) {
        e.preventDefault();
        return
      }
    }
    // Old-fashioned briefly-focus-a-textarea hack
    var kludge = hiddenTextarea(), te = kludge.firstChild;
    cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
    te.value = lastCopied.text.join("\n");
    var hadFocus = document.activeElement;
    selectInput(te);
    setTimeout(function () {
      cm.display.lineSpace.removeChild(kludge);
      hadFocus.focus();
      if (hadFocus == div) { input.showPrimarySelection(); }
    }, 50);
  }
  on(div, "copy", onCopyCut);
  on(div, "cut", onCopyCut);
};

ContentEditableInput.prototype.prepareSelection = function () {
  var result = prepareSelection(this.cm, false);
  result.focus = this.cm.state.focused;
  return result
};

ContentEditableInput.prototype.showSelection = function (info, takeFocus) {
  if (!info || !this.cm.display.view.length) { return }
  if (info.focus || takeFocus) { this.showPrimarySelection(); }
  this.showMultipleSelections(info);
};

ContentEditableInput.prototype.showPrimarySelection = function () {
  var sel = window.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
  var from = prim.from(), to = prim.to();

  if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
    sel.removeAllRanges();
    return
  }

  var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
  var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
  if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad &&
      cmp(minPos(curAnchor, curFocus), from) == 0 &&
      cmp(maxPos(curAnchor, curFocus), to) == 0)
    { return }

  var view = cm.display.view;
  var start = (from.line >= cm.display.viewFrom && posToDOM(cm, from)) ||
      {node: view[0].measure.map[2], offset: 0};
  var end = to.line < cm.display.viewTo && posToDOM(cm, to);
  if (!end) {
    var measure = view[view.length - 1].measure;
    var map$$1 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
    end = {node: map$$1[map$$1.length - 1], offset: map$$1[map$$1.length - 2] - map$$1[map$$1.length - 3]};
  }

  if (!start || !end) {
    sel.removeAllRanges();
    return
  }

  var old = sel.rangeCount && sel.getRangeAt(0), rng;
  try { rng = range(start.node, start.offset, end.offset, end.node); }
  catch(e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
  if (rng) {
    if (!gecko && cm.state.focused) {
      sel.collapse(start.node, start.offset);
      if (!rng.collapsed) {
        sel.removeAllRanges();
        sel.addRange(rng);
      }
    } else {
      sel.removeAllRanges();
      sel.addRange(rng);
    }
    if (old && sel.anchorNode == null) { sel.addRange(old); }
    else if (gecko) { this.startGracePeriod(); }
  }
  this.rememberSelection();
};

ContentEditableInput.prototype.startGracePeriod = function () {
    var this$1 = this;

  clearTimeout(this.gracePeriod);
  this.gracePeriod = setTimeout(function () {
    this$1.gracePeriod = false;
    if (this$1.selectionChanged())
      { this$1.cm.operation(function () { return this$1.cm.curOp.selectionChanged = true; }); }
  }, 20);
};

ContentEditableInput.prototype.showMultipleSelections = function (info) {
  removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
  removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
};

ContentEditableInput.prototype.rememberSelection = function () {
  var sel = window.getSelection();
  this.lastAnchorNode = sel.anchorNode; this.lastAnchorOffset = sel.anchorOffset;
  this.lastFocusNode = sel.focusNode; this.lastFocusOffset = sel.focusOffset;
};

ContentEditableInput.prototype.selectionInEditor = function () {
  var sel = window.getSelection();
  if (!sel.rangeCount) { return false }
  var node = sel.getRangeAt(0).commonAncestorContainer;
  return contains(this.div, node)
};

ContentEditableInput.prototype.focus = function () {
  if (this.cm.options.readOnly != "nocursor") {
    if (!this.selectionInEditor())
      { this.showSelection(this.prepareSelection(), true); }
    this.div.focus();
  }
};
ContentEditableInput.prototype.blur = function () { this.div.blur(); };
ContentEditableInput.prototype.getField = function () { return this.div };

ContentEditableInput.prototype.supportsTouch = function () { return true };

ContentEditableInput.prototype.receivedFocus = function () {
  var input = this;
  if (this.selectionInEditor())
    { this.pollSelection(); }
  else
    { runInOp(this.cm, function () { return input.cm.curOp.selectionChanged = true; }); }

  function poll() {
    if (input.cm.state.focused) {
      input.pollSelection();
      input.polling.set(input.cm.options.pollInterval, poll);
    }
  }
  this.polling.set(this.cm.options.pollInterval, poll);
};

ContentEditableInput.prototype.selectionChanged = function () {
  var sel = window.getSelection();
  return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset ||
    sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset
};

ContentEditableInput.prototype.pollSelection = function () {
  if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) { return }
  var sel = window.getSelection(), cm = this.cm;
  // On Android Chrome (version 56, at least), backspacing into an
  // uneditable block element will put the cursor in that element,
  // and then, because it's not editable, hide the virtual keyboard.
  // Because Android doesn't allow us to actually detect backspace
  // presses in a sane way, this code checks for when that happens
  // and simulates a backspace press in this case.
  if (android && chrome && this.cm.options.gutters.length && isInGutter(sel.anchorNode)) {
    this.cm.triggerOnKeyDown({type: "keydown", keyCode: 8, preventDefault: Math.abs});
    this.blur();
    this.focus();
    return
  }
  if (this.composing) { return }
  this.rememberSelection();
  var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
  var head = domToPos(cm, sel.focusNode, sel.focusOffset);
  if (anchor && head) { runInOp(cm, function () {
    setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
    if (anchor.bad || head.bad) { cm.curOp.selectionChanged = true; }
  }); }
};

ContentEditableInput.prototype.pollContent = function () {
  if (this.readDOMTimeout != null) {
    clearTimeout(this.readDOMTimeout);
    this.readDOMTimeout = null;
  }

  var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
  var from = sel.from(), to = sel.to();
  if (from.ch == 0 && from.line > cm.firstLine())
    { from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length); }
  if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine())
    { to = Pos(to.line + 1, 0); }
  if (from.line < display.viewFrom || to.line > display.viewTo - 1) { return false }

  var fromIndex, fromLine, fromNode;
  if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
    fromLine = lineNo(display.view[0].line);
    fromNode = display.view[0].node;
  } else {
    fromLine = lineNo(display.view[fromIndex].line);
    fromNode = display.view[fromIndex - 1].node.nextSibling;
  }
  var toIndex = findViewIndex(cm, to.line);
  var toLine, toNode;
  if (toIndex == display.view.length - 1) {
    toLine = display.viewTo - 1;
    toNode = display.lineDiv.lastChild;
  } else {
    toLine = lineNo(display.view[toIndex + 1].line) - 1;
    toNode = display.view[toIndex + 1].node.previousSibling;
  }

  if (!fromNode) { return false }
  var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
  var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
  while (newText.length > 1 && oldText.length > 1) {
    if (lst(newText) == lst(oldText)) { newText.pop(); oldText.pop(); toLine--; }
    else if (newText[0] == oldText[0]) { newText.shift(); oldText.shift(); fromLine++; }
    else { break }
  }

  var cutFront = 0, cutEnd = 0;
  var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
  while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))
    { ++cutFront; }
  var newBot = lst(newText), oldBot = lst(oldText);
  var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0),
                           oldBot.length - (oldText.length == 1 ? cutFront : 0));
  while (cutEnd < maxCutEnd &&
         newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))
    { ++cutEnd; }
  // Try to move start of change to start of selection if ambiguous
  if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
    while (cutFront && cutFront > from.ch &&
           newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
      cutFront--;
      cutEnd++;
    }
  }

  newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
  newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");

  var chFrom = Pos(fromLine, cutFront);
  var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
  if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
    replaceRange(cm.doc, newText, chFrom, chTo, "+input");
    return true
  }
};

ContentEditableInput.prototype.ensurePolled = function () {
  this.forceCompositionEnd();
};
ContentEditableInput.prototype.reset = function () {
  this.forceCompositionEnd();
};
ContentEditableInput.prototype.forceCompositionEnd = function () {
  if (!this.composing) { return }
  clearTimeout(this.readDOMTimeout);
  this.composing = null;
  this.updateFromDOM();
  this.div.blur();
  this.div.focus();
};
ContentEditableInput.prototype.readFromDOMSoon = function () {
    var this$1 = this;

  if (this.readDOMTimeout != null) { return }
  this.readDOMTimeout = setTimeout(function () {
    this$1.readDOMTimeout = null;
    if (this$1.composing) {
      if (this$1.composing.done) { this$1.composing = null; }
      else { return }
    }
    this$1.updateFromDOM();
  }, 80);
};

ContentEditableInput.prototype.updateFromDOM = function () {
    var this$1 = this;

  if (this.cm.isReadOnly() || !this.pollContent())
    { runInOp(this.cm, function () { return regChange(this$1.cm); }); }
};

ContentEditableInput.prototype.setUneditable = function (node) {
  node.contentEditable = "false";
};

ContentEditableInput.prototype.onKeyPress = function (e) {
  if (e.charCode == 0 || this.composing) { return }
  e.preventDefault();
  if (!this.cm.isReadOnly())
    { operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0); }
};

ContentEditableInput.prototype.readOnlyChanged = function (val) {
  this.div.contentEditable = String(val != "nocursor");
};

ContentEditableInput.prototype.onContextMenu = function () {};
ContentEditableInput.prototype.resetPosition = function () {};

ContentEditableInput.prototype.needsContentAttribute = true;

function posToDOM(cm, pos) {
  var view = findViewForLine(cm, pos.line);
  if (!view || view.hidden) { return null }
  var line = getLine(cm.doc, pos.line);
  var info = mapFromLineView(view, line, pos.line);

  var order = getOrder(line, cm.doc.direction), side = "left";
  if (order) {
    var partPos = getBidiPartAt(order, pos.ch);
    side = partPos % 2 ? "right" : "left";
  }
  var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
  result.offset = result.collapse == "right" ? result.end : result.start;
  return result
}

function isInGutter(node) {
  for (var scan = node; scan; scan = scan.parentNode)
    { if (/CodeMirror-gutter-wrapper/.test(scan.className)) { return true } }
  return false
}

function badPos(pos, bad) { if (bad) { pos.bad = true; } return pos }

function domTextBetween(cm, from, to, fromLine, toLine) {
  var text = "", closing = false, lineSep = cm.doc.lineSeparator();
  function recognizeMarker(id) { return function (marker) { return marker.id == id; } }
  function close() {
    if (closing) {
      text += lineSep;
      closing = false;
    }
  }
  function addText(str) {
    if (str) {
      close();
      text += str;
    }
  }
  function walk(node) {
    if (node.nodeType == 1) {
      var cmText = node.getAttribute("cm-text");
      if (cmText != null) {
        addText(cmText || node.textContent.replace(/\u200b/g, ""));
        return
      }
      var markerID = node.getAttribute("cm-marker"), range$$1;
      if (markerID) {
        var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
        if (found.length && (range$$1 = found[0].find(0)))
          { addText(getBetween(cm.doc, range$$1.from, range$$1.to).join(lineSep)); }
        return
      }
      if (node.getAttribute("contenteditable") == "false") { return }
      var isBlock = /^(pre|div|p)$/i.test(node.nodeName);
      if (isBlock) { close(); }
      for (var i = 0; i < node.childNodes.length; i++)
        { walk(node.childNodes[i]); }
      if (isBlock) { closing = true; }
    } else if (node.nodeType == 3) {
      addText(node.nodeValue);
    }
  }
  for (;;) {
    walk(from);
    if (from == to) { break }
    from = from.nextSibling;
  }
  return text
}

function domToPos(cm, node, offset) {
  var lineNode;
  if (node == cm.display.lineDiv) {
    lineNode = cm.display.lineDiv.childNodes[offset];
    if (!lineNode) { return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true) }
    node = null; offset = 0;
  } else {
    for (lineNode = node;; lineNode = lineNode.parentNode) {
      if (!lineNode || lineNode == cm.display.lineDiv) { return null }
      if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) { break }
    }
  }
  for (var i = 0; i < cm.display.view.length; i++) {
    var lineView = cm.display.view[i];
    if (lineView.node == lineNode)
      { return locateNodeInLineView(lineView, node, offset) }
  }
}

function locateNodeInLineView(lineView, node, offset) {
  var wrapper = lineView.text.firstChild, bad = false;
  if (!node || !contains(wrapper, node)) { return badPos(Pos(lineNo(lineView.line), 0), true) }
  if (node == wrapper) {
    bad = true;
    node = wrapper.childNodes[offset];
    offset = 0;
    if (!node) {
      var line = lineView.rest ? lst(lineView.rest) : lineView.line;
      return badPos(Pos(lineNo(line), line.text.length), bad)
    }
  }

  var textNode = node.nodeType == 3 ? node : null, topNode = node;
  if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
    textNode = node.firstChild;
    if (offset) { offset = textNode.nodeValue.length; }
  }
  while (topNode.parentNode != wrapper) { topNode = topNode.parentNode; }
  var measure = lineView.measure, maps = measure.maps;

  function find(textNode, topNode, offset) {
    for (var i = -1; i < (maps ? maps.length : 0); i++) {
      var map$$1 = i < 0 ? measure.map : maps[i];
      for (var j = 0; j < map$$1.length; j += 3) {
        var curNode = map$$1[j + 2];
        if (curNode == textNode || curNode == topNode) {
          var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
          var ch = map$$1[j] + offset;
          if (offset < 0 || curNode != textNode) { ch = map$$1[j + (offset ? 1 : 0)]; }
          return Pos(line, ch)
        }
      }
    }
  }
  var found = find(textNode, topNode, offset);
  if (found) { return badPos(found, bad) }

  // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
  for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
    found = find(after, after.firstChild, 0);
    if (found)
      { return badPos(Pos(found.line, found.ch - dist), bad) }
    else
      { dist += after.textContent.length; }
  }
  for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
    found = find(before, before.firstChild, -1);
    if (found)
      { return badPos(Pos(found.line, found.ch + dist$1), bad) }
    else
      { dist$1 += before.textContent.length; }
  }
}

// TEXTAREA INPUT STYLE

var TextareaInput = function(cm) {
  this.cm = cm;
  // See input.poll and input.reset
  this.prevInput = "";

  // Flag that indicates whether we expect input to appear real soon
  // now (after some event like 'keypress' or 'input') and are
  // polling intensively.
  this.pollingFast = false;
  // Self-resetting timeout for the poller
  this.polling = new Delayed();
  // Used to work around IE issue with selection being forgotten when focus moves away from textarea
  this.hasSelection = false;
  this.composing = null;
};

TextareaInput.prototype.init = function (display) {
    var this$1 = this;

  var input = this, cm = this.cm;
  this.createField(display);
  var te = this.textarea;

  display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);

  // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
  if (ios) { te.style.width = "0px"; }

  on(te, "input", function () {
    if (ie && ie_version >= 9 && this$1.hasSelection) { this$1.hasSelection = null; }
    input.poll();
  });

  on(te, "paste", function (e) {
    if (signalDOMEvent(cm, e) || handlePaste(e, cm)) { return }

    cm.state.pasteIncoming = true;
    input.fastPoll();
  });

  function prepareCopyCut(e) {
    if (signalDOMEvent(cm, e)) { return }
    if (cm.somethingSelected()) {
      setLastCopied({lineWise: false, text: cm.getSelections()});
    } else if (!cm.options.lineWiseCopyCut) {
      return
    } else {
      var ranges = copyableRanges(cm);
      setLastCopied({lineWise: true, text: ranges.text});
      if (e.type == "cut") {
        cm.setSelections(ranges.ranges, null, sel_dontScroll);
      } else {
        input.prevInput = "";
        te.value = ranges.text.join("\n");
        selectInput(te);
      }
    }
    if (e.type == "cut") { cm.state.cutIncoming = true; }
  }
  on(te, "cut", prepareCopyCut);
  on(te, "copy", prepareCopyCut);

  on(display.scroller, "paste", function (e) {
    if (eventInWidget(display, e) || signalDOMEvent(cm, e)) { return }
    cm.state.pasteIncoming = true;
    input.focus();
  });

  // Prevent normal selection in the editor (we handle our own)
  on(display.lineSpace, "selectstart", function (e) {
    if (!eventInWidget(display, e)) { e_preventDefault(e); }
  });

  on(te, "compositionstart", function () {
    var start = cm.getCursor("from");
    if (input.composing) { input.composing.range.clear(); }
    input.composing = {
      start: start,
      range: cm.markText(start, cm.getCursor("to"), {className: "CodeMirror-composing"})
    };
  });
  on(te, "compositionend", function () {
    if (input.composing) {
      input.poll();
      input.composing.range.clear();
      input.composing = null;
    }
  });
};

TextareaInput.prototype.createField = function (_display) {
  // Wraps and hides input textarea
  this.wrapper = hiddenTextarea();
  // The semihidden textarea that is focused when the editor is
  // focused, and receives input.
  this.textarea = this.wrapper.firstChild;
};

TextareaInput.prototype.prepareSelection = function () {
  // Redraw the selection and/or cursor
  var cm = this.cm, display = cm.display, doc = cm.doc;
  var result = prepareSelection(cm);

  // Move the hidden textarea near the cursor to prevent scrolling artifacts
  if (cm.options.moveInputWithCursor) {
    var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
    var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
    result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10,
                                        headPos.top + lineOff.top - wrapOff.top));
    result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10,
                                         headPos.left + lineOff.left - wrapOff.left));
  }

  return result
};

TextareaInput.prototype.showSelection = function (drawn) {
  var cm = this.cm, display = cm.display;
  removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
  removeChildrenAndAdd(display.selectionDiv, drawn.selection);
  if (drawn.teTop != null) {
    this.wrapper.style.top = drawn.teTop + "px";
    this.wrapper.style.left = drawn.teLeft + "px";
  }
};

// Reset the input to correspond to the selection (or to be empty,
// when not typing and nothing is selected)
TextareaInput.prototype.reset = function (typing) {
  if (this.contextMenuPending || this.composing) { return }
  var cm = this.cm;
  if (cm.somethingSelected()) {
    this.prevInput = "";
    var content = cm.getSelection();
    this.textarea.value = content;
    if (cm.state.focused) { selectInput(this.textarea); }
    if (ie && ie_version >= 9) { this.hasSelection = content; }
  } else if (!typing) {
    this.prevInput = this.textarea.value = "";
    if (ie && ie_version >= 9) { this.hasSelection = null; }
  }
};

TextareaInput.prototype.getField = function () { return this.textarea };

TextareaInput.prototype.supportsTouch = function () { return false };

TextareaInput.prototype.focus = function () {
  if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) {
    try { this.textarea.focus(); }
    catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
  }
};

TextareaInput.prototype.blur = function () { this.textarea.blur(); };

TextareaInput.prototype.resetPosition = function () {
  this.wrapper.style.top = this.wrapper.style.left = 0;
};

TextareaInput.prototype.receivedFocus = function () { this.slowPoll(); };

// Poll for input changes, using the normal rate of polling. This
// runs as long as the editor is focused.
TextareaInput.prototype.slowPoll = function () {
    var this$1 = this;

  if (this.pollingFast) { return }
  this.polling.set(this.cm.options.pollInterval, function () {
    this$1.poll();
    if (this$1.cm.state.focused) { this$1.slowPoll(); }
  });
};

// When an event has just come in that is likely to add or change
// something in the input textarea, we poll faster, to ensure that
// the change appears on the screen quickly.
TextareaInput.prototype.fastPoll = function () {
  var missed = false, input = this;
  input.pollingFast = true;
  function p() {
    var changed = input.poll();
    if (!changed && !missed) {missed = true; input.polling.set(60, p);}
    else {input.pollingFast = false; input.slowPoll();}
  }
  input.polling.set(20, p);
};

// Read input from the textarea, and update the document to match.
// When something is selected, it is present in the textarea, and
// selected (unless it is huge, in which case a placeholder is
// used). When nothing is selected, the cursor sits after previously
// seen text (can be empty), which is stored in prevInput (we must
// not reset the textarea when typing, because that breaks IME).
TextareaInput.prototype.poll = function () {
    var this$1 = this;

  var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
  // Since this is called a *lot*, try to bail out as cheaply as
  // possible when it is clear that nothing happened. hasSelection
  // will be the case when there is a lot of text in the textarea,
  // in which case reading its value would be expensive.
  if (this.contextMenuPending || !cm.state.focused ||
      (hasSelection(input) && !prevInput && !this.composing) ||
      cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq)
    { return false }

  var text = input.value;
  // If nothing changed, bail.
  if (text == prevInput && !cm.somethingSelected()) { return false }
  // Work around nonsensical selection resetting in IE9/10, and
  // inexplicable appearance of private area unicode characters on
  // some key combos in Mac (#2689).
  if (ie && ie_version >= 9 && this.hasSelection === text ||
      mac && /[\uf700-\uf7ff]/.test(text)) {
    cm.display.input.reset();
    return false
  }

  if (cm.doc.sel == cm.display.selForContextMenu) {
    var first = text.charCodeAt(0);
    if (first == 0x200b && !prevInput) { prevInput = "\u200b"; }
    if (first == 0x21da) { this.reset(); return this.cm.execCommand("undo") }
  }
  // Find the part of the input that is actually new
  var same = 0, l = Math.min(prevInput.length, text.length);
  while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) { ++same; }

  runInOp(cm, function () {
    applyTextInput(cm, text.slice(same), prevInput.length - same,
                   null, this$1.composing ? "*compose" : null);

    // Don't leave long text in the textarea, since it makes further polling slow
    if (text.length > 1000 || text.indexOf("\n") > -1) { input.value = this$1.prevInput = ""; }
    else { this$1.prevInput = text; }

    if (this$1.composing) {
      this$1.composing.range.clear();
      this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"),
                                         {className: "CodeMirror-composing"});
    }
  });
  return true
};

TextareaInput.prototype.ensurePolled = function () {
  if (this.pollingFast && this.poll()) { this.pollingFast = false; }
};

TextareaInput.prototype.onKeyPress = function () {
  if (ie && ie_version >= 9) { this.hasSelection = null; }
  this.fastPoll();
};

TextareaInput.prototype.onContextMenu = function (e) {
  var input = this, cm = input.cm, display = cm.display, te = input.textarea;
  var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
  if (!pos || presto) { return } // Opera is difficult.

  // Reset the current text selection only if the click is done outside of the selection
  // and 'resetSelectionOnContextMenu' option is true.
  var reset = cm.options.resetSelectionOnContextMenu;
  if (reset && cm.doc.sel.contains(pos) == -1)
    { operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll); }

  var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
  input.wrapper.style.cssText = "position: absolute";
  var wrapperBox = input.wrapper.getBoundingClientRect();
  te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
  var oldScrollY;
  if (webkit) { oldScrollY = window.scrollY; } // Work around Chrome issue (#2712)
  display.input.focus();
  if (webkit) { window.scrollTo(null, oldScrollY); }
  display.input.reset();
  // Adds "Select all" to context menu in FF
  if (!cm.somethingSelected()) { te.value = input.prevInput = " "; }
  input.contextMenuPending = true;
  display.selForContextMenu = cm.doc.sel;
  clearTimeout(display.detectingSelectAll);

  // Select-all will be greyed out if there's nothing to select, so
  // this adds a zero-width space so that we can later check whether
  // it got selected.
  function prepareSelectAllHack() {
    if (te.selectionStart != null) {
      var selected = cm.somethingSelected();
      var extval = "\u200b" + (selected ? te.value : "");
      te.value = "\u21da"; // Used to catch context-menu undo
      te.value = extval;
      input.prevInput = selected ? "" : "\u200b";
      te.selectionStart = 1; te.selectionEnd = extval.length;
      // Re-set this, in case some other handler touched the
      // selection in the meantime.
      display.selForContextMenu = cm.doc.sel;
    }
  }
  function rehide() {
    input.contextMenuPending = false;
    input.wrapper.style.cssText = oldWrapperCSS;
    te.style.cssText = oldCSS;
    if (ie && ie_version < 9) { display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos); }

    // Try to detect the user choosing select-all
    if (te.selectionStart != null) {
      if (!ie || (ie && ie_version < 9)) { prepareSelectAllHack(); }
      var i = 0, poll = function () {
        if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 &&
            te.selectionEnd > 0 && input.prevInput == "\u200b") {
          operation(cm, selectAll)(cm);
        } else if (i++ < 10) {
          display.detectingSelectAll = setTimeout(poll, 500);
        } else {
          display.selForContextMenu = null;
          display.input.reset();
        }
      };
      display.detectingSelectAll = setTimeout(poll, 200);
    }
  }

  if (ie && ie_version >= 9) { prepareSelectAllHack(); }
  if (captureRightClick) {
    e_stop(e);
    var mouseup = function () {
      off(window, "mouseup", mouseup);
      setTimeout(rehide, 20);
    };
    on(window, "mouseup", mouseup);
  } else {
    setTimeout(rehide, 50);
  }
};

TextareaInput.prototype.readOnlyChanged = function (val) {
  if (!val) { this.reset(); }
  this.textarea.disabled = val == "nocursor";
};

TextareaInput.prototype.setUneditable = function () {};

TextareaInput.prototype.needsContentAttribute = false;

function fromTextArea(textarea, options) {
  options = options ? copyObj(options) : {};
  options.value = textarea.value;
  if (!options.tabindex && textarea.tabIndex)
    { options.tabindex = textarea.tabIndex; }
  if (!options.placeholder && textarea.placeholder)
    { options.placeholder = textarea.placeholder; }
  // Set autofocus to true if this textarea is focused, or if it has
  // autofocus and no other element is focused.
  if (options.autofocus == null) {
    var hasFocus = activeElt();
    options.autofocus = hasFocus == textarea ||
      textarea.getAttribute("autofocus") != null && hasFocus == document.body;
  }

  function save() {textarea.value = cm.getValue();}

  var realSubmit;
  if (textarea.form) {
    on(textarea.form, "submit", save);
    // Deplorable hack to make the submit method do the right thing.
    if (!options.leaveSubmitMethodAlone) {
      var form = textarea.form;
      realSubmit = form.submit;
      try {
        var wrappedSubmit = form.submit = function () {
          save();
          form.submit = realSubmit;
          form.submit();
          form.submit = wrappedSubmit;
        };
      } catch(e) {}
    }
  }

  options.finishInit = function (cm) {
    cm.save = save;
    cm.getTextArea = function () { return textarea; };
    cm.toTextArea = function () {
      cm.toTextArea = isNaN; // Prevent this from being ran twice
      save();
      textarea.parentNode.removeChild(cm.getWrapperElement());
      textarea.style.display = "";
      if (textarea.form) {
        off(textarea.form, "submit", save);
        if (typeof textarea.form.submit == "function")
          { textarea.form.submit = realSubmit; }
      }
    };
  };

  textarea.style.display = "none";
  var cm = CodeMirror$1(function (node) { return textarea.parentNode.insertBefore(node, textarea.nextSibling); },
    options);
  return cm
}

function addLegacyProps(CodeMirror) {
  CodeMirror.off = off;
  CodeMirror.on = on;
  CodeMirror.wheelEventPixels = wheelEventPixels;
  CodeMirror.Doc = Doc;
  CodeMirror.splitLines = splitLinesAuto;
  CodeMirror.countColumn = countColumn;
  CodeMirror.findColumn = findColumn;
  CodeMirror.isWordChar = isWordCharBasic;
  CodeMirror.Pass = Pass;
  CodeMirror.signal = signal;
  CodeMirror.Line = Line;
  CodeMirror.changeEnd = changeEnd;
  CodeMirror.scrollbarModel = scrollbarModel;
  CodeMirror.Pos = Pos;
  CodeMirror.cmpPos = cmp;
  CodeMirror.modes = modes;
  CodeMirror.mimeModes = mimeModes;
  CodeMirror.resolveMode = resolveMode;
  CodeMirror.getMode = getMode;
  CodeMirror.modeExtensions = modeExtensions;
  CodeMirror.extendMode = extendMode;
  CodeMirror.copyState = copyState;
  CodeMirror.startState = startState;
  CodeMirror.innerMode = innerMode;
  CodeMirror.commands = commands;
  CodeMirror.keyMap = keyMap;
  CodeMirror.keyName = keyName;
  CodeMirror.isModifierKey = isModifierKey;
  CodeMirror.lookupKey = lookupKey;
  CodeMirror.normalizeKeyMap = normalizeKeyMap;
  CodeMirror.StringStream = StringStream;
  CodeMirror.SharedTextMarker = SharedTextMarker;
  CodeMirror.TextMarker = TextMarker;
  CodeMirror.LineWidget = LineWidget;
  CodeMirror.e_preventDefault = e_preventDefault;
  CodeMirror.e_stopPropagation = e_stopPropagation;
  CodeMirror.e_stop = e_stop;
  CodeMirror.addClass = addClass;
  CodeMirror.contains = contains;
  CodeMirror.rmClass = rmClass;
  CodeMirror.keyNames = keyNames;
}

// EDITOR CONSTRUCTOR

defineOptions(CodeMirror$1);

addEditorMethods(CodeMirror$1);

// Set up methods on CodeMirror's prototype to redirect to the editor's document.
var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
for (var prop in Doc.prototype) { if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0)
  { CodeMirror$1.prototype[prop] = (function(method) {
    return function() {return method.apply(this.doc, arguments)}
  })(Doc.prototype[prop]); } }

eventMixin(Doc);

// INPUT HANDLING

CodeMirror$1.inputStyles = {"textarea": TextareaInput, "contenteditable": ContentEditableInput};

// MODE DEFINITION AND QUERYING

// Extra arguments are stored as the mode's dependencies, which is
// used by (legacy) mechanisms like loadmode.js to automatically
// load a mode. (Preferred mechanism is the require/define calls.)
CodeMirror$1.defineMode = function(name/*, mode, …*/) {
  if (!CodeMirror$1.defaults.mode && name != "null") { CodeMirror$1.defaults.mode = name; }
  defineMode.apply(this, arguments);
};

CodeMirror$1.defineMIME = defineMIME;

// Minimal default mode.
CodeMirror$1.defineMode("null", function () { return ({token: function (stream) { return stream.skipToEnd(); }}); });
CodeMirror$1.defineMIME("text/plain", "null");

// EXTENSIONS

CodeMirror$1.defineExtension = function (name, func) {
  CodeMirror$1.prototype[name] = func;
};
CodeMirror$1.defineDocExtension = function (name, func) {
  Doc.prototype[name] = func;
};

CodeMirror$1.fromTextArea = fromTextArea;

addLegacyProps(CodeMirror$1);

CodeMirror$1.version = "5.37.0";

return CodeMirror$1;

})));


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
__webpack_require__(4)

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var e,aa="object"===typeof __ScalaJSEnv&&__ScalaJSEnv?__ScalaJSEnv:{},ca="object"===typeof aa.global&&aa.global?aa.global:"object"===typeof global&&global&&global.Object===Object?global:this;aa.global=ca;var da=exports;aa.exportsNamespace=da;ca.Object.freeze(aa);var aaa={envInfo:aa,semantics:{asInstanceOfs:2,arrayIndexOutOfBounds:2,moduleInit:2,strictFloats:!1,productionMode:!0},assumingES6:!1,linkerVersion:"0.6.22",globalThis:this};ca.Object.freeze(aaa);ca.Object.freeze(aaa.semantics);
var fa=ca.Math.imul||function(a,b){var c=a&65535,d=b&65535;return c*d+((a>>>16&65535)*d+c*(b>>>16&65535)<<16>>>0)|0},ga=ca.Math.fround||function(a){return+a},ha=ca.Math.clz32||function(a){if(0===a)return 32;var b=1;0===(a&4294901760)&&(a<<=16,b+=16);0===(a&4278190080)&&(a<<=8,b+=8);0===(a&4026531840)&&(a<<=4,b+=4);0===(a&3221225472)&&(a<<=2,b+=2);return b+(a>>31)},ia=0,ja=ca.WeakMap?new ca.WeakMap:null;
function ka(a){return function(b,c){return!(!b||!b.$classData||b.$classData.Nn!==c||b.$classData.Mn!==a)}}function baa(a){for(var b in a)return b}function na(a,b){return new a.av(b)}function oa(a,b){return caa(a,b,0)}function caa(a,b,c){var d=new a.av(b[c]);if(c<b.length-1){a=a.Ep;c+=1;for(var f=d.i,g=0;g<f.length;g++)f[g]=caa(a,b,c)}return d}function pa(a){return void 0===a?"undefined":a.toString()}
function ra(a){switch(typeof a){case "string":return k(sa);case "number":var b=a|0;return b===a?ta(b)?k(daa):ua(b)?k(eaa):k(faa):wa(a)?k(gaa):k(haa);case "boolean":return k(iaa);case "undefined":return k(xa);default:return null===a?a.G5():ya(a)?k(jaa):a&&a.$classData?k(a.$classData):null}}function Aa(a,b){return a&&a.$classData||null===a?a.w(b):"number"===typeof a?"number"===typeof b&&(a===b?0!==a||1/a===1/b:a!==a&&b!==b):a===b}
function Ca(a){switch(typeof a){case "string":return Da(Ga(),a);case "number":return kaa(Ha(),a);case "boolean":return a?1231:1237;case "undefined":return 0;default:return a&&a.$classData||null===a?a.A():null===ja?42:Ia(a)}}function laa(a){return"string"===typeof a?a.length|0:a.Fa()}function Ja(a,b){return"string"===typeof a?a.charCodeAt(b)&65535:a.Vj(b)}function Oa(a,b,c){return"string"===typeof a?a.substring(b,c):a.Lo(b,c)}
function Sa(a){return 2147483647<a?2147483647:-2147483648>a?-2147483648:a|0}function maa(a,b){var c=ca.Object.getPrototypeOf,d=ca.Object.getOwnPropertyDescriptor;for(a=c(a);null!==a;){var f=d(a,b);if(void 0!==f)return f;a=c(a)}}function naa(a,b,c){a=maa(a,c);if(void 0!==a)return c=a.get,void 0!==c?c.call(b):a.value}function oaa(a,b,c,d){a=maa(a,c);if(void 0!==a&&(a=a.set,void 0!==a)){a.call(b,d);return}throw new ca.TypeError("super has no setter '"+c+"'.");}
function Ta(a,b,c,d,f){a=a.i;c=c.i;if(a!==c||d<b||(b+f|0)<d)for(var g=0;g<f;g=g+1|0)c[d+g|0]=a[b+g|0];else for(g=f-1|0;0<=g;g=g-1|0)c[d+g|0]=a[b+g|0]}
var Ia=null!==ja?function(a){switch(typeof a){case "string":case "number":case "boolean":case "undefined":return Ca(a);default:if(null===a)return 0;var b=ja.get(a);void 0===b&&(ia=b=ia+1|0,ja.set(a,b));return b}}:function(a){if(a&&a.$classData){var b=a.$idHashCode$0;if(void 0!==b)return b;if(ca.Object.isSealed(a))return 42;ia=b=ia+1|0;return a.$idHashCode$0=b}return null===a?0:Ca(a)};function ta(a){return"number"===typeof a&&a<<24>>24===a&&1/a!==1/-0}
function ua(a){return"number"===typeof a&&a<<16>>16===a&&1/a!==1/-0}function Wa(a){return"number"===typeof a&&(a|0)===a&&1/a!==1/-0}function wa(a){return"number"===typeof a}function Ya(a){return null===a?ab().Uj:a}function qb(){this.gt=this.av=void 0;this.Mn=this.Ep=this.H=null;this.Nn=0;this.Ut=null;this.Cs="";this.rj=this.ys=this.zs=void 0;this.name="";this.isRawJSType=this.isArrayClass=this.isInterface=this.isPrimitive=!1;this.isInstance=void 0}
function rb(a,b,c){var d=new qb;d.H={};d.Ep=null;d.Ut=a;d.Cs=b;d.rj=function(){return!1};d.name=c;d.isPrimitive=!0;d.isInstance=function(){return!1};return d}function l(a,b,c,d,f,g,h,n){var u=new qb,w=baa(a);h=h||function(a){return!!(a&&a.$classData&&a.$classData.H[w])};n=n||function(a,b){return!!(a&&a.$classData&&a.$classData.Nn===b&&a.$classData.Mn.H[w])};u.gt=g;u.H=d;u.Cs="L"+c+";";u.rj=n;u.name=c;u.isInterface=b;u.isRawJSType=!!f;u.isInstance=h;return u}
function paa(a){function b(a){if("number"===typeof a){this.i=Array(a);for(var b=0;b<a;b++)this.i[b]=f}else this.i=a}var c=new qb,d=a.Ut,f="longZero"==d?ab().Uj:d;b.prototype=new m;b.prototype.constructor=b;b.prototype.HI=function(){return this.i instanceof Array?new b(this.i.slice(0)):new b(new this.i.constructor(this.i))};b.prototype.$classData=c;var d="["+a.Cs,g=a.Mn||a,h=a.Nn+1;c.av=b;c.gt=Ab;c.H={f:1,Mf:1,k:1};c.Ep=a;c.Mn=g;c.Nn=h;c.Ut=null;c.Cs=d;c.zs=void 0;c.ys=void 0;c.rj=void 0;c.name=d;
c.isPrimitive=!1;c.isInterface=!1;c.isArrayClass=!0;c.isInstance=function(a){return g.rj(a,h)};return c}function k(a){if(!a.zs){var b=new Hb;b.Ei=a;a.zs=b}return a.zs}function bc(a){a.ys||(a.ys=paa(a));return a.ys}qb.prototype.getFakeInstance=function(){return this===sa?"some string":this===iaa?!1:this===daa||this===eaa||this===faa||this===gaa||this===haa?0:this===jaa?ab().Uj:this===xa?void 0:{$classData:this}};qb.prototype.getSuperclass=function(){return this.gt?k(this.gt):null};
qb.prototype.getComponentType=function(){return this.Ep?k(this.Ep):null};qb.prototype.newArrayOfThisClass=function(a){for(var b=this,c=0;c<a.length;c++)b=bc(b);return oa(b,a)};var cc=rb(void 0,"V","void"),ic=rb(!1,"Z","boolean"),jc=rb(0,"C","char"),rc=rb(0,"B","byte"),vc=rb(0,"S","short"),yc=rb(0,"I","int"),zc=rb("longZero","J","long"),Gc=rb(0,"F","float"),Ic=rb(0,"D","double"),Kc=ka(ic);ic.rj=Kc;var Nc=ka(jc);jc.rj=Nc;var Oc=ka(rc);rc.rj=Oc;var Pc=ka(vc);vc.rj=Pc;var Sc=ka(yc);yc.rj=Sc;var Uc=ka(zc);
zc.rj=Uc;var Vc=ka(Gc);Gc.rj=Vc;var Wc=ka(Ic);Ic.rj=Wc;var Xc=__webpack_require__(5),qaa=__webpack_require__(11),raa=__webpack_require__(0),saa=__webpack_require__(12),taa=__webpack_require__(15),uaa=__webpack_require__(16);function vaa(a){a=a.fa();a=Yc(a);return(new ad).K(a.ab(),a.wa())}function waa(a){a=xaa(a,a,"  ",10);if(null===a)throw(new p).e(a);return a.p()}
var xaa=function yaa(b,c,d,f){if(c&&c.$classData&&c.$classData.H.uu)return(new q).a(0,c.Xc.U());if(bd(c)){var g=c.Xc;c=yaa(b,c.Ag,d,f);if(null===c)throw(new p).e(c);b=c.p();c=1+c.Xa()|0;d=(new cd).j(d);d=dd(d,c);return(new q).a(c,""+b+(new ed).db(f)+d+g.U()+" "+(new fd).K(Yc(g).ab(),Yc(g).wa()))}throw(new p).e(c);};function gd(a,b,c){return-1!==a?b.fm(c):id()}
function jd(a,b,c,d,f){b.va=c;b.id=f;b.Fi.Ds();if(-1!==b.lf&&b.lf>=c)if(b.lf===c){if(null===d)if(c=[a],0===(c.length|0))c=id();else{d=kd(new ld,id());f=0;for(var g=c.length|0;f<g;)md(d,c[f]),f=1+f|0;c=d.t}else c=d;b.nd=c}else b.nd=id();b.zg=a;return b}function qd(a,b,c,d,f,g){-1!==b.lf&&c>=b.lf&&null!==f&&(b.nd=f);(-1!==b.lf||0<d)&&b.Fi.Yt(zaa(c,a));b.id=!!(b.id|g);return b}function sd(a,b,c,d,f){a.pa=b;a.va=c;a.id=f;a.nd=d;return a}
function Aaa(a,b){var c=a.od();a=a.Pl();if(!(0<=b&&b<=c.i.length))throw b=td((new yd).X((new r).d([""," is not a valid offset, allowed [0..","]"])),(new r).d([b,c.i.length])),(new t).j(b);if(b===c.i.length&&0<c.i.length&&10===c.i[-1+b|0])return-1+a.i.length|0;for(var c=0,d=-1+a.i.length|0;1<(d-c|0);){var f=(d+c|0)/2|0;if(b<a.i[f])d=f;else{if(a.i[f]===b)return f;c=f}}return c}
function Ad(a,b){if(!(0<=b&&b<=(-1+a.Pl().i.length|0)))throw a=td((new yd).X((new r).d([""," is not a valid line number, allowed [0..","]"])),(new r).d([b,-1+a.Pl().i.length|0])),(new t).j(a);return a.Pl().i[b]}function Dd(a){var b=a.od();a=(new Fd).c();Gd(a,0);for(var c=0;c<b.i.length;)10===b.i[c]&&Gd(a,1+c|0),c=1+c|0;(Hd(a)|0)!==b.i.length&&Gd(a,b.i.length);b=a.kd;b=oa(bc(yc),[b]);Id(a,b,0);return b}function Jd(){}function m(){}m.prototype=Jd.prototype;Jd.prototype.c=function(){return this};
Jd.prototype.w=function(a){return this===a};Jd.prototype.v=function(){var a=Md(ra(this)),b=(+(this.A()>>>0)).toString(16);return a+"@"+b};Jd.prototype.A=function(){return Ia(this)};Jd.prototype.toString=function(){return this.v()};function Nd(a,b){if(a=a&&a.$classData){var c=a.Nn||0;return!(c<b)&&(c>b||!a.Mn.isPrimitive)}return!1}var Ab=l({f:0},!1,"java.lang.Object",{f:1},void 0,void 0,function(a){return null!==a},Nd);Jd.prototype.$classData=Ab;
function Baa(a,b){if(Od(b))return b=null===b?0:b.pa,a.Sv()&&a.oh()===b;if(ta(b))return b|=0,a.Rv()&&a.Ap()===b;if(ua(b))return b|=0,a.Tv()&&a.Qq()===b;if(Wa(b))return b|=0,a.Ts()&&a.oh()===b;if(ya(b)){var c=Ya(b);b=c.Ra;c=c.Ya;a=a.bi();var d=a.Ya;return a.Ra===b&&d===c}return wa(b)?(b=+b,a.Fm()===b):"number"===typeof b?(b=+b,a.oj()===b):!1}function Pd(a,b){throw(new Qd).Hm(b,a);}function Rd(a){var b=a.r;Sd(b,(new Td).z(b));a=Caa(a);Sd(b,(new Ud).z(b));return a}
function Caa(a){var b=a.r,c=function(a){return function(){return Vd(a)}}(a),d=(new Wd).Cd(a),f=(new Xd).z(b),g=(new ae).c(),h=v(),n=x(b.h);if(y(z(h,n),be())){var u=ce(b),w=ce(b),D=u.$a(),N=x(b.h);if(!de(N)){for(var Q=he(),ea=[(new q).a("ScalametaParser.this.token",x(b.h))],ba=A(new B,C()),ma=0,La=ea.length|0;ma<La;)E(ba,ea[ma]),ma=1+ma|0;ie(Q,ba.t)}if(!ke(b.P)){le(b);var Pa=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([b.P])),Qa=N.ja();Pd(Pa,Qa)}if(1!==N.Hb){le(b);var Ka=oe(pe(),
N.Hb,1),Ba=N.ja();Pd(Ka,Ba)}b.h.ia();var va=x(b.h);if(ue(va)){Sd(b,(new ve).z(b));var za=we(b,!0,d);Sd(b,(new Ae).z(b));var qa=za}else if(Be(va)){Sd(b,(new Ee).z(b));var la=we(b,!0,d);Sd(b,(new Ie).z(b));qa=la}else if(Je(va))qa=we(b,!0,d);else{le(b);var Ma=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(b.h).oa()])),Ea=x(b.h).ja();Pd(Ma,Ea)}if(Ke(qa)){if(Le((Oe(),d).G(),qa.uc()))var tb=(new q).a(!0,F());else{G();var Za=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
eb=G().b,tb=(new q).a(!1,H(Za,eb))}if(null===tb||!0!==I(tb)){if(null!==tb){var kb=tb.p();if(!1===I(tb)){for(var Pb=J(),Na=(new q).a("ellipsis",N),sb=(new q).a("result",qa),yb=(new q).a("evidence$4",d),sc=(new q).a("quasi",qa),Ra=Se(),wc=Te().Hc(),Wb=[Na,sb,yb,sc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Ra,qa,wc)))],Rb=A(new B,C()),ub=0,fb=Wb.length|0;ub<fb;)E(Rb,Wb[ub]),ub=1+ub|0;K(Pb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
kb,Rb.t)}}throw(new p).e(tb);}var Xb=We(new Ze,b,qa),lb=We(new Ze,b,qa),Eb=Xb.eb,xc=qa.ca,gb=qa.fa(),dc=bf(cf(),xc,gb),Fc=lb.Fb;Fc<Eb&&(Fc=-1+Eb|0);var Qb=(new L).K(Eb,1+Fc|0),Bb=M(),Ib=O(P(Bb,dc),R(b.ea,b.P,Qb))}else Ib=qa;var mb=bf(cf(),1,Ib),Cb=w.Ga();Cb<D&&(Cb=-1+D|0);var Tb=(new L).K(D,1+Cb|0),mc=M(),Ac=O(P(mc,mb),R(b.ea,b.P,Tb))}else Ac=c();for(ff(g,Ac);;){var Dc=v(),Db=x(b.h);if(y(z(Dc,Db),f))var Va=!0;else var ec=v(),$a=x(b.h),Va=y(z(ec,$a),be());if(Va){var vb=v(),fc=x(b.h);y(z(vb,fc),f)&&
b.h.ia();var Bc=v(),Ub=x(b.h);if(y(z(Bc,Ub),be())){var Vb=ce(b),wb=ce(b),xb=Vb.$a(),Xa=x(b.h);if(!de(Xa)){for(var tc=he(),ib=[(new q).a("ScalametaParser.this.token",x(b.h))],zb=A(new B,C()),nb=0,Jb=ib.length|0;nb<Jb;)E(zb,ib[nb]),nb=1+nb|0;ie(tc,zb.t)}var jb=Xa;if(!ke(b.P)){le(b);var ob=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([b.P])),gc=jb.ja();Pd(ob,gc)}if(1!==jb.Hb){le(b);var cb=oe(pe(),jb.Hb,1),Ua=jb.ja();Pd(cb,Ua)}b.h.ia();var Yb=x(b.h);if(ue(Yb)){Sd(b,(new ve).z(b));
var Kb=we(b,!0,d);Sd(b,(new Ae).z(b));var pb=Kb}else if(Be(Yb)){Sd(b,(new Ee).z(b));var hb=we(b,!0,d);Sd(b,(new Ie).z(b));pb=hb}else if(Je(Yb))pb=we(b,!0,d);else{le(b);var Lb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(b.h).oa()])),Fa=x(b.h).ja();Pd(Lb,Fa)}if(Ke(pb)){if(Le((Oe(),d).G(),pb.uc()))var bb=(new q).a(!0,F());else{G();var nc=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),db=G().b,bb=(new q).a(!1,
H(nc,db))}if(null===bb||!0!==I(bb)){if(null!==bb){var uc=bb.p();if(!1===I(bb)){for(var Fb=J(),hc=(new q).a("ellipsis",jb),$b=(new q).a("result",pb),kc=(new q).a("evidence$4",d),lc=(new q).a("quasi",pb),Mb=Se(),Nb=Te().Hc(),Gb=[hc,$b,kc,lc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Mb,pb,Nb)))],Sb=A(new B,C()),Cc=0,Ob=Gb.length|0;Cc<Ob;)E(Sb,Gb[Cc]),Cc=1+Cc|0;K(Fb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
uc,Sb.t)}}throw(new p).e(bb);}var Zb=We(new Ze,b,pb),Ec=We(new Ze,b,pb),oc=Zb.eb,pc=pb.ca,qc=pb.fa(),Jc=bf(cf(),pc,qc),Hc=Ec.Fb;Hc<oc&&(Hc=-1+oc|0);var ac=(new L).K(oc,1+Hc|0),Lc=M(),$c=O(P(Lc,Jc),R(b.ea,b.P,ac))}else $c=pb;var Tc=bf(cf(),1,$c),Rc=wb.Ga();Rc<xb&&(Rc=-1+xb|0);var Mc=(new L).K(xb,1+Rc|0),hd=M(),Qc=O(P(hd,Tc),R(b.ea,b.P,Mc))}else Qc=c();ff(g,Qc)}else break}return g.lb()}
function gf(a){var b=a.r,c=ce(b),d=ce(b),c=c.$a(),f=x(a.r.h);if(ue(f)){var f=a.r,g=ce(f),h=ce(f),g=g.$a(),n=a.r,u=a.r;Sd(u,(new ve).z(u));var w=Caa(a);Sd(u,(new Ae).z(u));n=Daa(n,w);h=h.Ga();h<g&&(h=-1+g|0);h=(new L).K(g,1+h|0);g=M();h=O(P(g,n),R(f.ea,f.P,h))}else if(nf(f))a.r.h.ia(),h=f=a.r,g=qf(a.r.h),h=(new rf).Ia(h,g),g=ce(a.r),n=h.va,Eaa(),h=sf(a.r),h=Faa(0,h),g=g.Ga(),g<n&&(g=-1+n|0),g=(new L).K(n,1+g|0),n=M(),h=O(P(n,h),R(f.ea,f.P,g));else if(tf(a.r).Gc(f))a.r.P.Bh||(le(a.r),f=td((new yd).X((new r).d(["",
" doesn't support literal types"])),(new r).d([a.r.P])),h=uf(a.r,!0),h=Yc(h),Pd(f,h)),h=vf(a.r,!1);else if(f=uf(a.r,!0),f=Ke(f)?f.nb((new wf).Cd(a)):f,g=v(),n=x(a.r.h),xf(z(g,n),Bf()))a:if(g=!1,n=null,Ke(f))h=f.nb((new Cf).Cd(a));else{if(Df(f)&&(g=!0,u=n=f,w=null===u?S():(new T).e((new q).a(Ef(u),u.yb())),!w.g()&&(u=w.q().qa(),w=w.q().p(),Ff(u)&&Gf(w)))){g=u.nb((new Hf).Cd(a));n=w.nb((new Kf).Cd(a));h=a.r;u=We(new Ze,a.r,f);f=We(new Ze,a.r,f);u=u.eb;g=Gaa(Haa(),g,n);f=f.Fb;f<u&&(f=-1+u|0);f=(new L).K(u,
1+f|0);n=M();h=O(P(n,g),R(h.ea,h.P,f));break a}if(g&&(g=n,n=null===g?S():(new T).e((new q).a(Ef(g),g.yb())),!n.g()&&(g=n.q().qa(),w=n.q().p(),Lf(g)))){Ke(w)?n=w.nb((new Mf).Cd(a)):(h=a.r,u=We(new Ze,a.r,w),n=We(new Ze,a.r,w),u=u.eb,Nf(),w=w.ec(),w=Of(0,w),n=n.Fb,n<u&&(n=-1+u|0),n=(new L).K(u,1+n|0),u=M(),n=O(P(u,w),R(h.ea,h.P,n)));h=a.r;u=We(new Ze,a.r,f);f=We(new Ze,a.r,f);u=u.eb;g=Gaa(Haa(),g,n);f=f.Fb;f<u&&(f=-1+u|0);f=(new L).K(u,1+f|0);n=M();h=O(P(n,g),R(h.ea,h.P,f));break a}Pf(f)?(h=a.r,n=We(new Ze,
a.r,f),g=We(new Ze,a.r,f),n=n.eb,Nf(),f=f.ec(),f=Of(0,f),g=g.Fb,g<n&&(g=-1+n|0),g=(new L).K(n,1+g|0),n=M(),h=O(P(n,f),R(h.ea,h.P,g))):(le(a.r),f=Yc(f),Pd("identifier expected",f))}else a.r.h.ia(),Sd(a.r,(new Qf).Cd(a)),h=Iaa(Jaa(),f);d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();b=O(P(c,h),R(b.ea,b.P,d));return Kaa(a,b)}
function Laa(a){var b=a.r,c=ce(b),d=ce(b),f=c.$a(),g=v(),h=x(a.r.h);if(y(z(g,h),Rf()))var n=(new q).a(!0,F());else{G();var u=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).is[scala.meta.tokens.Token.LeftParen](Token.this.LeftParen.classifier[scala.meta.tokens.Token]) is false"]),w=G().b,n=(new q).a(!1,H(u,w))}if(null===n||!0!==I(n)){if(null!==n){var D=n.p();if(!1===
I(n)){for(var N=J(),Q=(new q).a("ScalametaParser",a.r),ea=(new q).a("Token",Sf()),ba=[Q,ea,(new q).a("ScalametaParser.this.token",x(a.r.h))],ma=A(new B,C()),La=0,Pa=ba.length|0;La<Pa;)E(ma,ba[La]),La=1+La|0;K(N,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).is[scala.meta.tokens.Token.LeftParen](Token.this.LeftParen.classifier[scala.meta.tokens.Token]).\x26\x26(org.scalameta.`package`.debug(ScalametaParser.this.token))",
D,ma.t)}}throw(new p).e(n);}for(var Qa=Tf(a.r.h),Ka=!1,Ba=Ka=!1,va=Ba=!1,va=!1,za=0,qa=za=-1,la=(new ae).c();;){if(va||Ba)tb=!1;else var Ma=v(),Ea=x(a.r.h),tb=y(z(Ma,Ea),Rf());if(tb){Qa!==Tf(a.r.h)&&0===za&&(za=Tf(a.r.h));Sd(a.r,(new Uf).Cd(a));var Za=(new ae).c(),eb=v(),kb=x(a.r.h);if(!y(z(eb,kb),Vf())){var Pb;a:for(;;){var Na=x(a.r.h);if(de(Na)){var sb=Na,yb=Yf(Zf(),sb);if(!yb.g()){var sc=yb.q()|0,Ra=a.r,wc=(new $f).Cd(a),Wb=ce(Ra),Rb=ce(Ra),ub=Wb.$a(),fb=x(Ra.h);if(!de(fb)){for(var Xb=he(),lb=
[(new q).a("ScalametaParser.this.token",x(Ra.h))],Eb=A(new B,C()),xc=0,gb=lb.length|0;xc<gb;)E(Eb,lb[xc]),xc=1+xc|0;ie(Xb,Eb.t)}var dc=fb;if(!ke(Ra.P)){le(Ra);var Fc=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([Ra.P])),Qb=dc.ja();Pd(Fc,Qb)}if(dc.Hb!==sc){le(Ra);var Bb=oe(pe(),dc.Hb,sc),Ib=dc.ja();Pd(Bb,Ib)}Ra.h.ia();var mb=x(Ra.h);if(ue(mb)){Sd(Ra,(new ve).z(Ra));var Cb=we(Ra,!0,wc);Sd(Ra,(new Ae).z(Ra));var Tb=Cb}else if(Be(mb)){Sd(Ra,(new Ee).z(Ra));var mc=we(Ra,!0,wc);
Sd(Ra,(new Ie).z(Ra));Tb=mc}else if(Je(mb))Tb=we(Ra,!0,wc);else{le(Ra);var Ac=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(Ra.h).oa()])),Dc=x(Ra.h).ja();Pd(Ac,Dc)}if(Ke(Tb)){if(Le((Oe(),wc).G(),Tb.uc()))var Db=(new q).a(!0,F());else{G();var Va=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),ec=G().b,Db=(new q).a(!1,H(Va,ec))}if(null===Db||!0!==I(Db)){if(null!==Db){var $a=Db.p();if(!1===I(Db)){for(var vb=
J(),fc=(new q).a("ellipsis",dc),Bc=(new q).a("result",Tb),Ub=(new q).a("evidence$4",wc),Vb=(new q).a("quasi",Tb),wb=Se(),xb=Te().Hc(),Xa=[fc,Bc,Ub,Vb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(wb,Tb,xb)))],tc=A(new B,C()),ib=0,zb=Xa.length|0;ib<zb;)E(tc,Xa[ib]),ib=1+ib|0;K(vb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
$a,tc.t)}}throw(new p).e(Db);}var nb=We(new Ze,Ra,Tb),Jb=We(new Ze,Ra,Tb),jb=nb.eb,ob=Tb.ca,gc=Tb.fa(),cb=ag(bg(),ob,gc),Ua=Jb.Fb;Ua<jb&&(Ua=-1+jb|0);var Yb=(new L).K(jb,1+Ua|0),Kb=M(),pb=O(P(Kb,cb),R(Ra.ea,Ra.P,Yb))}else pb=Tb;var hb=ag(bg(),sc,pb),Lb=Rb.Ga();Lb<ub&&(Lb=-1+ub|0);var Fa=(new L).K(ub,1+Lb|0),bb=M();Pb=O(P(bb,hb),R(Ra.ea,Ra.P,Fa));break}}if(Je(Na)){Pb=we(a.r,!0,(new fg).Cd(a));break}if(gg(Na)&&!Ba){a.r.h.ia();Ba=!0;continue a}if(hg(Na)){var nc=Na;if(ig(jg(),nc).g())kc=!1;else{var db=
a.r,uc=db.h,Fb=(new kg).Ia(uc.r,uc.Dc);db.h.ia();try{var hc=v(),$b=x(a.r.h),kc=y(z(hc,$b),lg())}finally{db.h=Fb}}if(kc){if(va){le(a.r);var lc=x(a.r.h).ja();Pd("can't mix function type and method type syntaxes",lc)}Ka=!0;Pb=mg(a.r,!1,!1,Ba);break}}if(Ka){le(a.r);var Mb=x(a.r.h).ja();Pd("can't mix function type and method type syntaxes",Mb)}va=!0;Pb=ng(a.r);break}for(ff(Za,Pb);;){var Nb=v(),Gb=x(a.r.h);if(y(z(Nb,Gb),og()))var Sb=!0;else var Cc=v(),Ob=x(a.r.h),Sb=y(z(Cc,Ob),be());if(Sb){var Zb=v(),Ec=
x(a.r.h);y(z(Zb,Ec),og())&&a.r.h.ia();var oc;a:for(;;){var pc=x(a.r.h);if(de(pc)){var qc=pc,Jc=Yf(Zf(),qc);if(!Jc.g()){var Hc=Jc.q()|0,ac=a.r,Lc=(new $f).Cd(a),$c=ce(ac),Tc=ce(ac),Rc=$c.$a(),Mc=x(ac.h);if(!de(Mc)){for(var hd=he(),Qc=[(new q).a("ScalametaParser.this.token",x(ac.h))],rd=A(new B,C()),od=0,Zc=Qc.length|0;od<Zc;)E(rd,Qc[od]),od=1+od|0;ie(hd,rd.t)}var nd=Mc;if(!ke(ac.P)){le(ac);var zd=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([ac.P])),ud=nd.ja();Pd(zd,ud)}if(nd.Hb!==
Hc){le(ac);var wd=oe(pe(),nd.Hb,Hc),Bd=nd.ja();Pd(wd,Bd)}ac.h.ia();var Ed=x(ac.h);if(ue(Ed)){Sd(ac,(new ve).z(ac));var pd=we(ac,!0,Lc);Sd(ac,(new Ae).z(ac));var vd=pd}else if(Be(Ed)){Sd(ac,(new Ee).z(ac));var xd=we(ac,!0,Lc);Sd(ac,(new Ie).z(ac));vd=xd}else if(Je(Ed))vd=we(ac,!0,Lc);else{le(ac);var ee=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(ac.h).oa()])),Ld=x(ac.h).ja();Pd(ee,Ld)}if(Ke(vd)){if(Le((Oe(),Lc).G(),vd.uc()))var me=(new q).a(!0,F());else{G();var fe=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
Yd=G().b,me=(new q).a(!1,H(fe,Yd))}if(null===me||!0!==I(me)){if(null!==me){var Zd=me.p();if(!1===I(me)){for(var qe=J(),re=(new q).a("ellipsis",nd),Kd=(new q).a("result",vd),yf=(new q).a("evidence$4",Lc),Cd=(new q).a("quasi",vd),Fe=Se(),je=Te().Hc(),xe=[re,Kd,yf,Cd,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Fe,vd,je)))],ge=A(new B,C()),ye=0,ne=xe.length|0;ye<ne;)E(ge,xe[ye]),ye=1+ye|0;K(qe,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Zd,ge.t)}}throw(new p).e(me);}var Ce=We(new Ze,ac,vd),hf=We(new Ze,ac,vd),Pe=Ce.eb,jf=vd.ca,ze=vd.fa(),Me=ag(bg(),jf,ze),$e=hf.Fb;$e<Pe&&($e=-1+Pe|0);var kf=(new L).K(Pe,1+$e|0),Ne=M(),Ge=O(P(Ne,Me),R(ac.ea,ac.P,kf))}else Ge=vd;var se=ag(bg(),Hc,Ge),lf=Tc.Ga();lf<Rc&&(lf=-1+Rc|0);var te=(new L).K(Rc,1+lf|0),De=M();oc=O(P(De,se),R(ac.ea,ac.P,te));break}}if(Je(pc)){oc=we(a.r,!0,(new fg).Cd(a));break}if(gg(pc)&&!Ba){a.r.h.ia();Ba=!0;continue a}if(hg(pc)){var Qe=pc;if(ig(jg(),Qe).g())Xe=!1;else{var af=
a.r,of=af.h,df=(new kg).Ia(of.r,of.Dc);af.h.ia();try{var mf=v(),Re=x(a.r.h),Xe=y(z(mf,Re),lg())}finally{af.h=df}}if(Xe){if(va){le(a.r);var zf=x(a.r.h).ja();Pd("can't mix function type and method type syntaxes",zf)}Ka=!0;oc=mg(a.r,!1,!1,Ba);break}}if(Ka){le(a.r);var ef=x(a.r.h).ja();Pd("can't mix function type and method type syntaxes",ef)}va=!0;oc=ng(a.r);break}ff(Za,oc)}else break}}qa=Tf(a.r.h);Sd(a.r,(new pg).Cd(a));ff(la,Za.lb())}else break}var $d=la.lb();if(Ka)var pf=v(),He=x(a.r.h),If=!y(z(pf,
He),lg());else If=!1;if(If){le(a.r);var ug=x(a.r.h).ja();Pd("can't mix function type and method type syntaxes",ug)}if(va)var Af=v(),vg=x(a.r.h),Wf=y(z(Af,vg),lg());else Wf=!1;Wf&&Sd(a.r,(new qg).Cd(a));var Mh=v(),Yg=x(a.r.h);if(y(z(Mh,Yg),lg())&&a.r.P.gh){a.r.h.ia();var Og=Maa();if(va){G();for(var Pg=(new r).d(["false is false"]),Jf=G().b,Zg=H(Pg,Jf),ji=J(),jh=[(new q).a("hasParams",Ka),(new q).a("hasImplicits",Ba),(new q).a("hasTypes",va)],$g=A(new B,C()),Qg=0,ij=jh.length|0;Qg<ij;)E($g,jh[Qg]),
Qg=1+Qg|0;K(ji,"false.\x26\x26(org.scalameta.`package`.debug(hasParams, hasImplicits, hasTypes))",Zg,$g.t)}var ki=function(a){return function(b){var c=function(a){return function(b){if(Ke(b))return b.nb((new rg).Cd(a));if(sg(b))return b;var c=he(),d=Se(),f=a.r.kh,f=tg().If(f),d=(new q).a("scala.meta.prettyprinters.`package`.XtensionSyntax[scala.meta.Tree](other)(meta.this.Tree.showSyntax[scala.meta.Tree](ScalametaParser.this.currentDialect)).syntax",yg(d,b,f).be()),f=Se(),g=Te().Hc();b=[d,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.Tree](other)(meta.this.Tree.showStructure[scala.meta.Tree]).structure",
Ue(Ve(f,b,g)))];d=A(new B,C());f=0;for(g=b.length|0;f<g;)E(d,b[f]),f=1+f|0;ie(c,d.t)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(a),lh=G().b;if(lh===G().b)if($d===F())var Nh=F();else{for(var xk=$d.n(),Kj=U(new V,ki(xk),F()),jj=Kj,Di=$d.o();Di!==F();)var Lj=Di.n(),bh=U(new V,ki(Lj),F()),jj=jj.ga=bh,Di=Di.o();Nh=Kj}else{for(var Oh=
zg($d,lh),Ph=$d;!Ph.g();){var Mj=Ph.n();Oh.ba(ki(Mj));Ph=Ph.o()}Nh=Oh.da()}var fl=Vd(a),cg=Naa(Og,Nh,fl)}else{var Qh=v(),Wl=x(a.r.h);if(y(z(Qh,Wl),Ag())){a.r.h.ia();var Nj=Bg();if(Ka){G();for(var Ei=(new r).d(["false is false"]),Xl=G().b,Oj=H(Ei,Xl),Pj=J(),Qj=[(new q).a("hasParams",Ka),(new q).a("hasImplicits",Ba),(new q).a("hasTypes",va)],yk=A(new B,C()),li=0,mi=Qj.length|0;li<mi;)E(yk,Qj[li]),li=1+li|0;K(Pj,"false.\x26\x26(org.scalameta.`package`.debug(hasParams, hasImplicits, hasTypes))",Oj,yk.t)}if(1!==
Cg($d)){le(a.r);var Zm=Dg(Eg(a.r),za).ja();Pd("can't have multiple parameter lists in function types",Zm)}var wg=$d.n(),mh=function(a){return function(b){if(Ke(b))return b.nb((new Fg).Cd(a));if(Gg(b))return b;var c=he(),d=Se(),f=a.r.kh,f=tg().If(f),d=(new q).a("scala.meta.prettyprinters.`package`.XtensionSyntax[scala.meta.Tree](other)(meta.this.Tree.showSyntax[scala.meta.Tree](ScalametaParser.this.currentDialect)).syntax",yg(d,b,f).be()),f=Se(),g=Te().Hc();b=[d,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.Tree](other)(meta.this.Tree.showStructure[scala.meta.Tree]).structure",
Ue(Ve(f,b,g)))];d=A(new B,C());f=0;for(g=b.length|0;f<g;)E(d,b[f]),f=1+f|0;ie(c,d.t)}}(a),Fi=G().b;if(Fi===G().b)if(wg===F())var gl=F();else{for(var zk=wg.n(),Ye=U(new V,mh(zk),F()),hl=Ye,Rj=wg.o();Rj!==F();)var Rh=Rj.n(),$m=U(new V,mh(Rh),F()),hl=hl.ga=$m,Rj=Rj.o();gl=Ye}else{for(var il=zg(wg,Fi),Gi=wg;!Gi.g();){var dg=Gi.n();il.ba(mh(dg));Gi=Gi.o()}gl=il.da()}var Hi=Vd(a),cg=Hg(Nj,gl,Hi)}else{var ni=a.r,jl=(new rf).Ia(a.r,Qa),nh=(new rf).Ia(a.r,qa),Ak=jl.va,oh=a.r;if(Ka){G();for(var Yl=(new r).d(["false is false"]),
Sj=G().b,Bk=H(Yl,Sj),Zl=J(),xg=[(new q).a("hasParams",Ka),(new q).a("hasImplicits",Ba),(new q).a("hasTypes",va)],Tj=A(new B,C()),Uj=0,Ii=xg.length|0;Uj<Ii;)E(Tj,xg[Uj]),Uj=1+Uj|0;K(Zl,"false.\x26\x26(org.scalameta.`package`.debug(hasParams, hasImplicits, hasTypes))",Bk,Tj.t)}if(1!==Cg($d)){le(a.r);var Vj=Dg(Eg(a.r),za).ja();Pd("can't have multiple parameter lists in function types",Vj)}var Rg=$d.n(),kj=function(a){return function(b){if(Ke(b))return b.nb((new Fg).Cd(a));if(Gg(b))return b;var c=he(),
d=Se(),f=a.r.kh,f=tg().If(f),d=(new q).a("scala.meta.prettyprinters.`package`.XtensionSyntax[scala.meta.Tree](other)(meta.this.Tree.showSyntax[scala.meta.Tree](ScalametaParser.this.currentDialect)).syntax",yg(d,b,f).be()),f=Se(),g=Te().Hc();b=[d,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.Tree](other)(meta.this.Tree.showStructure[scala.meta.Tree]).structure",Ue(Ve(f,b,g)))];d=A(new B,C());f=0;for(g=b.length|0;f<g;)E(d,b[f]),f=1+f|0;ie(c,d.t)}}(a),Ji=G().b;if(Ji===G().b)if(Rg===
F())var ph=F();else{for(var lj=Rg.n(),Xf=U(new V,kj(lj),F()),Sh=Xf,Th=Rg.o();Th!==F();)var mj=Th.n(),qh=U(new V,kj(mj),F()),Sh=Sh.ga=qh,Th=Th.o();ph=Xf}else{for(var oi=zg(Rg,Ji),eg=Rg;!eg.g();){var rh=eg.n();oi.ba(kj(rh));eg=eg.o()}ph=oi.da()}var Wj=function(a){return function(b){if(Ig(b))le(a.r),b=Yc(b),Pd("by name type not allowed here",b);else if(Jg(b))le(a.r),b=Yc(b),Pd("repeated type not allowed here",b);else{if(null!==b)return b;throw(new p).e(b);}}}(a),Uh=G().b;if(Uh===G().b)if(ph===F())var Vh=
F();else{for(var Ck=ph.n(),Wh=U(new V,Wj(Ck),F()),nj=Wh,sh=ph.o();sh!==F();)var oj=sh.n(),Dk=U(new V,Wj(oj),F()),nj=nj.ga=Dk,sh=sh.o();Vh=Wh}else{for(var kl=zg(ph,Uh),Xh=ph;!Xh.g();){var Ki=Xh.n();kl.ba(Wj(Ki));Xh=Xh.o()}Vh=kl.da()}var an=Daa(oh,Vh),ll=nh.va;ll<Ak&&(ll=-1+Ak|0);var bn=(new L).K(Ak,1+ll|0),$l=M(),Xj=O(P($l,an),R(ni.ea,ni.P,bn)),pi=Kaa(a,Xj),am=(new T).e(Kg(a,pi)),Yj=Oaa(a,am),cn=Lg().In,cg=Mg(a,Yj,cn)}}var Ek=d.Ga();Ek<f&&(Ek=-1+f|0);var wo=(new L).K(f,1+Ek|0),pj=M();return O(P(pj,
cg),R(b.ea,b.P,wo))}
var Mg=function Ng(b,c,d){var f=b.r,g=We(new Ze,b.r,c),h=ce(b.r),n=g.eb,u;a:{var w=x(b.r.h);if(hg(w)){var D=ig(jg(),w);if(!D.g()){var N=D.q(),Q=(new cd).j(N),ea=Sg(Q,"`"),ba=(new cd).j(ea);Tg(ba,"`");u=!0;break a}}u=!1}if(u)var ma=!0;else var La=v(),Pa=x(b.r.h),ma=y(z(La,Pa),Ug());if(ma){if(Vg(b.r,"*")){var Qa=b.r,Ka=Qa.h,Ba=(new kg).Ia(Ka.r,Ka.Dc);Qa.h.ia();try{var va=v(),za=x(b.r.h);if(y(z(va,za),Vf()))var qa=!0;else var la=v(),Ma=x(b.r.h),qa=y(z(la,Ma),og());if(qa)var Ea=!0;else var tb=v(),Za=
x(b.r.h),Ea=y(z(tb,Za),Wg());if(Ea)var eb=!0;else var kb=v(),Pb=x(b.r.h),eb=y(z(kb,Pb),Xg());if(eb)var Na=!0;else var sb=v(),yb=x(b.r.h),Na=y(z(sb,yb),ah())}finally{Qa.h=Ba}}else Na=!1;if(Na)var sc=c;else{var Ra=ch(b.r,!1),wc=dh(eh(Ra)),Wb=Lg().In;if(null===d?null!==Wb:!d.w(Wb)){var Rb=b.r,ub=Lg().Ln;Paa(Rb,Ra,null===d?null===ub:d.w(ub))}if(Vg(b.r,"\x26")&&b.r.P.Ig){b.r.h.ia();var fb=b.r,Xb=v(),lb=x(fb.h);if(y(z(Xb,lb),fh())){var Eb=fb.h,xc=(new kg).Ia(Eb.r,Eb.Dc);fb.h.ia();try{var gb=x(fb.h),dc=
v(),Fc=z(dc,gb),Qb=gh(b.r),Bb=y(Fc,hh(Qb))}finally{fb.h=xc}}else Bb=!1;Bb&&ih(fb);var Ib=th(b),mb=b.r,Cb=We(new Ze,b.r,c),Tb=We(new Ze,b.r,Ib),mc=Cb.eb,Ac=uh(vh(),c,Ib),Dc=Tb.Fb;Dc<mc&&(Dc=-1+mc|0);var Db=(new L).K(mc,1+Dc|0),Va=M(),ec=O(P(Va,Ac),R(mb.ea,mb.P,Db)),$a=Lg().Ln,sc=Ng(b,ec,$a)}else if(Vg(b.r,"|")&&b.r.P.Kg){b.r.h.ia();var vb=b.r,fc=v(),Bc=x(vb.h);if(y(z(fc,Bc),fh())){var Ub=vb.h,Vb=(new kg).Ia(Ub.r,Ub.Dc);vb.h.ia();try{var wb=x(vb.h),xb=v(),Xa=z(xb,wb),tc=gh(b.r),ib=y(Xa,hh(tc))}finally{vb.h=
Vb}}else ib=!1;ib&&ih(vb);var zb=th(b),nb=b.r,Jb=We(new Ze,b.r,c),jb=We(new Ze,b.r,zb),ob=Jb.eb,gc=Qaa(Raa(),c,zb),cb=jb.Fb;cb<ob&&(cb=-1+ob|0);var Ua=(new L).K(ob,1+cb|0),Yb=M(),Kb=O(P(Yb,gc),R(nb.ea,nb.P,Ua)),pb=Lg().Ln,sc=Ng(b,Kb,pb)}else{var hb=wh(b.r),Lb=b.r,Fa=v(),bb=x(Lb.h);if(y(z(Fa,bb),fh())){var nc=Lb.h,db=(new kg).Ia(nc.r,nc.Dc);Lb.h.ia();try{var uc=x(Lb.h),Fb=v(),hc=z(Fb,uc),$b=gh(b.r),kc=y(hc,hh($b))}finally{Lb.h=db}}else kc=!1;kc&&ih(Lb);if(wc)var lc=th(b),Mb=Saa(b,lc,c,hb),Nb=Lg().Ln,
sc=Ng(b,Mb,Nb);else var Gb=Lg().Fz,Sb=th(b),Cc=Ng(b,Sb,Gb),sc=Saa(b,Cc,c,hb)}}}else sc=c;var Ob=h.Ga();Ob<n&&(Ob=-1+n|0);var Zb=(new L).K(n,1+Ob|0),Ec=M();return O(P(Ec,sc),R(f.ea,f.P,Zb))};function Kg(a,b){var c=a.r,d=We(new Ze,a.r,b),f=ce(a.r),d=d.eb;a=xh(a.r,!1,!0);b=a.g()?b:Taa(Uaa(),b,a);f=f.Ga();f<d&&(f=-1+d|0);f=(new L).K(d,1+f|0);d=M();return O(P(d,b),R(c.ea,c.P,f))}
function Oaa(a,b){var c=a.r,d=yh(a.r,b),f=ce(a.r),d=d.$a();if(zh(b)){for(b=b.Y;;){var g=v(),h=x(a.r.h);if(y(z(g,h),Ah())){a.r.h.ia();var g=gf(a),n=Kg(a,g),g=a.r,u=We(new Ze,a.r,b),h=We(new Ze,a.r,n),u=u.eb;b=a.r.P.Mg?Vaa(Waa(),b,n):uh(vh(),b,n);h=h.Fb;h<u&&(h=-1+u|0);h=(new L).K(u,1+h|0);u=M();b=O(P(u,b),R(g.ea,g.P,h))}else break}Bh(a.r,(new Ch).Cd(a));g=v();h=x(a.r.h);y(z(g,h),Dh())?(g=Eh(),b=(new T).e(b),a=Fh(a.r),a=Gh(g,b,a)):a=b}else{if(S()!==b)throw(new p).e(b);b=Eh();g=S();a=Fh(a.r);a=Gh(b,
g,a)}f=f.Ga();f<d&&(f=-1+d|0);f=(new L).K(d,1+f|0);d=M();return O(P(d,a),R(c.ea,c.P,f))}
function Xaa(a){var b=a.r,c=ce(b),d=ce(b),c=c.$a(),f=v(),g=x(a.r.h);if(y(z(f,g),lg())&&a.r.P.gh)a.r.h.ia(),f=Maa(),g=F(),a=Vd(a),a=Naa(f,g,a);else{f=v();g=x(a.r.h);if(y(z(f,g),Rf()))g=Laa(a);else if(f=v(),g=x(a.r.h),y(z(f,g),Hh())&&a.r.P.Eh){f=Ih(a.r,!0,!1);Sd(a.r,(new Jh).Cd(a));var g=Vd(a),h=Yaa;Kh||(Kh=(new Lh).c());g=h(Kh,f,g)}else f=Lg().In,g=th(a),g=Mg(a,g,f);f=x(a.r.h);Yh(f)?(a.r.h.ia(),f=Bg(),G(),g=(new r).d([g]),h=G().b,g=H(g,h),a=Vd(a),a=Hg(f,g,a)):Zh(f)?(a.r.h.ia(),f=$h(),a=Zaa(a.r),a=
ai(f,g,a)):a=g}d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,a),R(b.ea,b.P,d))}function Saa(a,b,c,d){var f=a.r,g=We(new Ze,a.r,c);a=We(new Ze,a.r,b);g=g.eb;b=bi(ci(),c,d,b);c=a.Fb;c<g&&(c=-1+g|0);c=(new L).K(g,1+c|0);d=M();return O(P(d,b),R(f.ea,f.P,c))}
function di(a,b,c){if(b){b=v();var d=x(a.r.h);b=y(z(b,d),Rf())?Laa(a):th(a);d=x(a.r.h);if(Zh(d)){a.r.h.ia();var d=a.r,f=We(new Ze,a.r,b),g=We(new Ze,a.r,b),f=f.eb,h=$h(),n=Zaa(a.r);b=ai(h,b,n);g=g.Fb;g<f&&(g=-1+f|0);g=(new L).K(f,1+g|0);f=M();b=O(P(f,b),R(d.ea,d.P,g))}else d=Je(d)?!0:hg(d)&&!ig(jg(),d).g()?!0:!1,d&&!Vg(a.r,"|")&&(h=th(a),d=a.r,f=We(new Ze,a.r,b),g=We(new Ze,a.r,h),f=f.eb,ci(),n=wh(a.r),b=bi(0,b,n,h),g=g.Fb,g<f&&(g=-1+f|0),g=(new L).K(f,1+g|0),f=M(),b=O(P(f,b),R(d.ea,d.P,g)),d=Lg().Ln,
b=Mg(a,b,d))}else b=th(a);return $aa(a,b,c)}var Kaa=function aba(b,c){var d=x(b.r.h);if(ei(d)){b.r.h.ia();var d=b.r,f=We(new Ze,b.r,c),g=ce(b.r),f=f.eb;bba();var h=wh(b.r);c=cba(0,c,h);g=g.Ga();g<f&&(g=-1+f|0);g=(new L).K(f,1+g|0);f=M();c=O(P(f,c),R(d.ea,d.P,g));return aba(b,c)}if(fi(d)){var d=b.r,f=We(new Ze,b.r,c),g=ce(b.r),f=f.eb,h=dba(),n=Rd(b);c=eba(h,c,n);g=g.Ga();g<f&&(g=-1+f|0);g=(new L).K(f,1+g|0);f=M();c=O(P(f,c),R(d.ea,d.P,g));return aba(b,c)}return c};
function th(a){var b=v(),c=x(a.r.h);y(z(b,c),Dh())?b=S():(b=gf(a),b=(new T).e(Kg(a,b)));return Oaa(a,b)}
var $aa=function gi(b,c,d){var f=!1,g=null,g=null;if(Ke(c))return c;if(hi(c)){var f=!0,h=g=c,n=null===h?S():(new T).e(h.ec());if(!n.g()){var u=n.q();if(d)var w=65535&(u.charCodeAt(0)|0),D=ii(qi(),w);else D=!1;if(D){var N=b.r,Q=We(new Ze,b.r,g),ea=We(new Ze,b.r,g),ba=Q.eb;fba||(fba=(new ri).c());var ma=gba(g),La=ea.Fb;La<ba&&(La=-1+ba|0);var Pa=(new L).K(ba,1+La|0),Qa=M();return O(P(Qa,ma),R(N.ea,N.P,Pa))}}}if(f)return g;if(si(c))return c;if(ti(c)){var Ka=null===c?S():(new T).e((new q).a(ui(c),c.nc()));
if(!Ka.g()){var Ba=Ka.q().qa(),va=Ka.q().p(),za=gi(b,Ba,!1),qa=b.r,la=We(new Ze,b.r,c),Ma=We(new Ze,b.r,c),Ea=la.eb,tb=cba(bba(),za,va),Za=Ma.Fb;Za<Ea&&(Za=-1+Ea|0);var eb=(new L).K(Ea,1+Za|0),kb=M();return O(P(kb,tb),R(qa.ea,qa.P,eb))}}if(vi(c))return c;if(wi(c)){var Pb=null===c?S():(new T).e((new q).a(c.Db(),c.pb()));if(!Pb.g()){var Na=Pb.q().qa(),sb=Pb.q().p(),yb=gi(b,Na,!1),sc=function(b){return function(c){return gi(b,c,!0)}}(b),Ra=G().b;if(Ra===G().b)if(sb===F())var wc=F();else{for(var Wb=sb.n(),
Rb=U(new V,sc(Wb),F()),ub=Rb,fb=sb.o();fb!==F();)var Xb=fb.n(),lb=U(new V,sc(Xb),F()),ub=ub.ga=lb,fb=fb.o();wc=Rb}else{for(var Eb=zg(sb,Ra),xc=sb;!xc.g();){var gb=xc.n();Eb.ba(sc(gb));xc=xc.o()}wc=Eb.da()}var dc=b.r,Fc=We(new Ze,b.r,c),Qb=We(new Ze,b.r,c),Bb=Fc.eb,Ib=eba(dba(),yb,wc),mb=Qb.Fb;mb<Bb&&(mb=-1+Bb|0);var Cb=(new L).K(Bb,1+mb|0),Tb=M();return O(P(Tb,Ib),R(dc.ea,dc.P,Cb))}}if(xi(c)){var mc=null===c?S():(new T).e((new yi).sd(c.Kd(),zi(c),c.cd()));if(!mc.g()){var Ac=mc.q().Bb,Dc=mc.q().qb,
Db=mc.q().Eb,Va=gi(b,Ac,!1),ec=gi(b,Db,!1),$a=b.r,vb=We(new Ze,b.r,c),fc=We(new Ze,b.r,c),Bc=vb.eb,Ub=bi(ci(),Va,Dc,ec),Vb=fc.Fb;Vb<Bc&&(Vb=-1+Bc|0);var wb=(new L).K(Bc,1+Vb|0),xb=M();return O(P(xb,Ub),R($a.ea,$a.P,wb))}}if(Ai(c)){var Xa=null===c?S():(new T).e((new q).a(c.me(),c.Kh()));if(!Xa.g()){var tc=Xa.q().qa(),ib=Xa.q().p(),zb=function(b){return function(c){return gi(b,c,!0)}}(b),nb=G().b;if(nb===G().b)if(tc===F())var Jb=F();else{for(var jb=tc.n(),ob=U(new V,zb(jb),F()),gc=ob,cb=tc.o();cb!==
F();)var Ua=cb.n(),Yb=U(new V,zb(Ua),F()),gc=gc.ga=Yb,cb=cb.o();Jb=ob}else{for(var Kb=zg(tc,nb),pb=tc;!pb.g();){var hb=pb.n();Kb.ba(zb(hb));pb=pb.o()}Jb=Kb.da()}var Lb=gi(b,ib,!1),Fa=b.r,bb=We(new Ze,b.r,c),nc=We(new Ze,b.r,c),db=bb.eb,uc=Hg(Bg(),Jb,Lb),Fb=nc.Fb;Fb<db&&(Fb=-1+db|0);var hc=(new L).K(db,1+Fb|0),$b=M();return O(P($b,uc),R(Fa.ea,Fa.P,hc))}}if(Bi(c)){var kc=null===c?S():(new T).e(c.pb());if(!kc.g()){var lc=kc.q(),Mb=function(b){return function(c){return gi(b,c,!0)}}(b),Nb=G().b;if(Nb===
G().b)if(lc===F())var Gb=F();else{for(var Sb=lc.n(),Cc=U(new V,Mb(Sb),F()),Ob=Cc,Zb=lc.o();Zb!==F();)var Ec=Zb.n(),oc=U(new V,Mb(Ec),F()),Ob=Ob.ga=oc,Zb=Zb.o();Gb=Cc}else{for(var pc=zg(lc,Nb),qc=lc;!qc.g();){var Jc=qc.n();pc.ba(Mb(Jc));qc=qc.o()}Gb=pc.da()}var Hc=b.r,ac=We(new Ze,b.r,c),Lc=We(new Ze,b.r,c),$c=ac.eb,Tc=Ci(Li(),Gb),Rc=Lc.Fb;Rc<$c&&(Rc=-1+$c|0);var Mc=(new L).K($c,1+Rc|0),hd=M();return O(P(hd,Tc),R(Hc.ea,Hc.P,Mc))}}if(Mi(c)){var Qc=null===c?S():(new T).e((new q).a(c.Kd(),c.cd()));if(!Qc.g()){var rd=
Qc.q().qa(),od=Qc.q().p(),Zc=gi(b,rd,!1),nd=gi(b,od,!1),zd=b.r,ud=We(new Ze,b.r,c),wd=We(new Ze,b.r,c),Bd=ud.eb,Ed=Vaa(Waa(),Zc,nd),pd=wd.Fb;pd<Bd&&(pd=-1+Bd|0);var vd=(new L).K(Bd,1+pd|0),xd=M();return O(P(xd,Ed),R(zd.ea,zd.P,vd))}}if(Ni(c)){var ee=null===c?S():(new T).e((new q).a(c.Kd(),c.cd()));if(!ee.g()){var Ld=ee.q().qa(),me=ee.q().p(),fe=gi(b,Ld,!1),Yd=gi(b,me,!1),Zd=b.r,qe=We(new Ze,b.r,c),re=We(new Ze,b.r,c),Kd=qe.eb,yf=uh(vh(),fe,Yd),Cd=re.Fb;Cd<Kd&&(Cd=-1+Kd|0);var Fe=(new L).K(Kd,1+Cd|
0),je=M();return O(P(je,yf),R(Zd.ea,Zd.P,Fe))}}if(Oi(c)){var xe=null===c?S():(new T).e((new q).a(c.Kd(),c.cd()));if(!xe.g()){var ge=xe.q().qa(),ye=xe.q().p(),ne=gi(b,ge,!1),Ce=gi(b,ye,!1),hf=b.r,Pe=We(new Ze,b.r,c),jf=We(new Ze,b.r,c),ze=Pe.eb,Me=Qaa(Raa(),ne,Ce),$e=jf.Fb;$e<ze&&($e=-1+ze|0);var kf=(new L).K(ze,1+$e|0),Ne=M();return O(P(Ne,Me),R(hf.ea,hf.P,kf))}}if(Pi(c)){var Ge=null===c?S():(new T).e((new q).a(Qi(c),c.ub()));if(!Ge.g()){var se=Ge.q().qa(),lf=Ge.q().p();if(se.g())var te=S();else var De=
se.q(),te=(new T).e(gi(b,De,!1));var Qe=b.r,af=yh(b.r,se),of=yh(b.r,se),df=af.$a(),mf=Gh(Eh(),te,lf),Re=of.Ga();Re<df&&(Re=-1+df|0);var Xe=(new L).K(df,1+Re|0),zf=M();return O(P(zf,mf),R(Qe.ea,Qe.P,Xe))}}if(Ri(c)){var ef=null===c?S():(new T).e((new q).a(c.Db(),c.ub()));if(!ef.g()){var $d=ef.q().qa(),pf=ef.q().p(),He=gi(b,$d,!1),If=b.r,ug=We(new Ze,b.r,c),Af=We(new Ze,b.r,c),vg=ug.eb,Wf=ai($h(),He,pf),Mh=Af.Fb;Mh<vg&&(Mh=-1+vg|0);var Yg=(new L).K(vg,1+Mh|0),Og=M();return O(P(Og,Wf),R(If.ea,If.P,Yg))}}if(Si(c)){var Pg=
null===c?S():(new T).e((new q).a(c.Db(),c.Di()));if(!Pg.g()){var Jf=Pg.q().qa(),Zg=Pg.q().p(),ji=gi(b,Jf,!1),jh=b.r,$g=We(new Ze,b.r,c),Qg=We(new Ze,b.r,c),ij=$g.eb,ki=Taa(Uaa(),ji,Zg),lh=Qg.Fb;lh<ij&&(lh=-1+ij|0);var Nh=(new L).K(ij,1+lh|0),xk=M();return O(P(xk,ki),R(jh.ea,jh.P,Nh))}}if(Ti(c)){var Kj=null===c?S():(new T).e(c.Gh());if(!Kj.g()){var jj=Kj.q(),Di=b.r,Lj=We(new Ze,b.r,c),bh=We(new Ze,b.r,c),Oh=Lj.eb,Ph=Faa(Eaa(),jj),Mj=bh.Fb;Mj<Oh&&(Mj=-1+Oh|0);var fl=(new L).K(Oh,1+Mj|0),cg=M();return O(P(cg,
Ph),R(Di.ea,Di.P,fl))}}if(Ui(c))return c;throw(new p).e(c);};function Vd(a){var b=a.r,c=ce(b),d=ce(b),c=c.$a(),f=v(),g=x(a.r.h);if(y(z(f,g),Vi())&&a.r.P.fh){a.r.h.ia();g=Xaa(a);a:{var h;if(Ai(g)&&(f=null===g?S():(new T).e((new q).a(g.me(),g.Kh())),!f.g())){h=f.q().qa();a=f.q().p();f=hba;Wi||(Wi=(new Xi).c());h=f(Wi,h,a);break a}le(a.r);a=Yc(g);Pd("function type expected",a)}}else h=Xaa(a);d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,h),R(b.ea,b.P,d))}
function iba(a){var b=a.r;Sd(b,(new Td).z(b));var c=a.r,d=function(a){return function(){return di(a,!0,!0)}}(a),f=(new Yi).Cd(a),g=(new Xd).z(c),h=(new ae).c(),n=v(),u=x(c.h);if(y(z(n,u),be())){var w=ce(c),D=ce(c),N=w.$a(),Q=x(c.h);if(!de(Q)){for(var ea=he(),ba=[(new q).a("ScalametaParser.this.token",x(c.h))],ma=A(new B,C()),La=0,Pa=ba.length|0;La<Pa;)E(ma,ba[La]),La=1+La|0;ie(ea,ma.t)}if(!ke(c.P)){le(c);var Qa=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([c.P])),Ka=Q.ja();
Pd(Qa,Ka)}if(1!==Q.Hb){le(c);var Ba=oe(pe(),Q.Hb,1),va=Q.ja();Pd(Ba,va)}c.h.ia();var za=x(c.h);if(ue(za)){Sd(c,(new ve).z(c));var qa=we(c,!0,f);Sd(c,(new Ae).z(c));var la=qa}else if(Be(za)){Sd(c,(new Ee).z(c));var Ma=we(c,!0,f);Sd(c,(new Ie).z(c));la=Ma}else if(Je(za))la=we(c,!0,f);else{le(c);var Ea=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(c.h).oa()])),tb=x(c.h).ja();Pd(Ea,tb)}if(Ke(la)){if(Le((Oe(),f).G(),la.uc()))var Za=(new q).a(!0,F());else{G();var eb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
kb=G().b,Za=(new q).a(!1,H(eb,kb))}if(null===Za||!0!==I(Za)){if(null!==Za){var Pb=Za.p();if(!1===I(Za)){for(var Na=J(),sb=(new q).a("ellipsis",Q),yb=(new q).a("result",la),sc=(new q).a("evidence$4",f),Ra=(new q).a("quasi",la),wc=Se(),Wb=Te().Hc(),Rb=[sb,yb,sc,Ra,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(wc,la,Wb)))],ub=A(new B,C()),fb=0,Xb=Rb.length|0;fb<Xb;)E(ub,Rb[fb]),fb=1+fb|0;K(Na,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Pb,ub.t)}}throw(new p).e(Za);}var lb=We(new Ze,c,la),Eb=We(new Ze,c,la),xc=lb.eb,gb=la.ca,dc=la.fa(),Fc=bf(cf(),gb,dc),Qb=Eb.Fb;Qb<xc&&(Qb=-1+xc|0);var Bb=(new L).K(xc,1+Qb|0),Ib=M(),mb=O(P(Ib,Fc),R(c.ea,c.P,Bb))}else mb=la;var Cb=bf(cf(),1,mb),Tb=D.Ga();Tb<N&&(Tb=-1+N|0);var mc=(new L).K(N,1+Tb|0),Ac=M(),Dc=O(P(Ac,Cb),R(c.ea,c.P,mc))}else Dc=d();for(ff(h,Dc);;){var Db=v(),Va=x(c.h);if(y(z(Db,Va),g))var ec=!0;else var $a=v(),vb=x(c.h),ec=y(z($a,vb),be());if(ec){var fc=v(),Bc=x(c.h);y(z(fc,Bc),g)&&
c.h.ia();var Ub=v(),Vb=x(c.h);if(y(z(Ub,Vb),be())){var wb=ce(c),xb=ce(c),Xa=wb.$a(),tc=x(c.h);if(!de(tc)){for(var ib=he(),zb=[(new q).a("ScalametaParser.this.token",x(c.h))],nb=A(new B,C()),Jb=0,jb=zb.length|0;Jb<jb;)E(nb,zb[Jb]),Jb=1+Jb|0;ie(ib,nb.t)}var ob=tc;if(!ke(c.P)){le(c);var gc=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([c.P])),cb=ob.ja();Pd(gc,cb)}if(1!==ob.Hb){le(c);var Ua=oe(pe(),ob.Hb,1),Yb=ob.ja();Pd(Ua,Yb)}c.h.ia();var Kb=x(c.h);if(ue(Kb)){Sd(c,(new ve).z(c));
var pb=we(c,!0,f);Sd(c,(new Ae).z(c));var hb=pb}else if(Be(Kb)){Sd(c,(new Ee).z(c));var Lb=we(c,!0,f);Sd(c,(new Ie).z(c));hb=Lb}else if(Je(Kb))hb=we(c,!0,f);else{le(c);var Fa=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(c.h).oa()])),bb=x(c.h).ja();Pd(Fa,bb)}if(Ke(hb)){if(Le((Oe(),f).G(),hb.uc()))var nc=(new q).a(!0,F());else{G();var db=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),uc=G().b,nc=(new q).a(!1,
H(db,uc))}if(null===nc||!0!==I(nc)){if(null!==nc){var Fb=nc.p();if(!1===I(nc)){for(var hc=J(),$b=(new q).a("ellipsis",ob),kc=(new q).a("result",hb),lc=(new q).a("evidence$4",f),Mb=(new q).a("quasi",hb),Nb=Se(),Gb=Te().Hc(),Sb=[$b,kc,lc,Mb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Nb,hb,Gb)))],Cc=A(new B,C()),Ob=0,Zb=Sb.length|0;Ob<Zb;)E(Cc,Sb[Ob]),Ob=1+Ob|0;K(hc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Fb,Cc.t)}}throw(new p).e(nc);}var Ec=We(new Ze,c,hb),oc=We(new Ze,c,hb),pc=Ec.eb,qc=hb.ca,Jc=hb.fa(),Hc=bf(cf(),qc,Jc),ac=oc.Fb;ac<pc&&(ac=-1+pc|0);var Lc=(new L).K(pc,1+ac|0),$c=M(),Tc=O(P($c,Hc),R(c.ea,c.P,Lc))}else Tc=hb;var Rc=bf(cf(),1,Tc),Mc=xb.Ga();Mc<Xa&&(Mc=-1+Xa|0);var hd=(new L).K(Xa,1+Mc|0),Qc=M(),rd=O(P(Qc,Rc),R(c.ea,c.P,hd))}else rd=d();ff(h,rd)}else break}var od=h.lb();Sd(b,(new Ud).z(b));return od}function jba(a){return a===Zi(a.r)||a===$i(a.r)}
function kba(a,b){a.El(b.jb());a.Rc(b.Pb);a.ck(b.La);a.Ll(b.Zi);a.ri(b.Ic);a.cn(b.oa());a.Cj(b.Hd);a.uk(b.He);return a}
function lba(a){var b;var c=mba(Ga(),a.Hd,46);c===(-1+(a.Hd.length|0)|0)?b=!0:0<=c&&(1+c|0)<(a.Hd.length|0)?(b=qi(),c=65535&(a.Hd.charCodeAt(1+c|0)|0),b=!aj(b,c)):b=!1;if(b){var d=a.xo();bj(d,"floating point number is missing digit after dot",a.La)}else{G();b=(new r).d([(new ed).db(100),(new ed).db(68),(new ed).db(102),(new ed).db(70)]);c=G().b;b=H(b,c);c=(new cd).j(a.Hd);if(cj(c))a:{for(c=(new cd).j(a.Hd),c=Hd(c);!b.g();){if(dj(ej(),b.n(),c)){b=!0;break a}b=b.o()}b=!1}else b=!1;b?(b=(new cd).j(a.Hd),
b=b.Eg(0,b.Fa()-1|0)):b=a.Hd;try{d=fj();0===(1&d.ra)&&0===(1&d.ra)&&(d.by=gj(),d.ra|=1);var f=d.by,g=(new hj).j(b),h;if(qj(g)<=f.xk.Hk)h=f.xk;else{var n=new rj,u=qj(g),w=sj().kp;n.Hk=u;n.Rl=w;h=n}return tj(new uj,g,h)}catch(D){if((d=vj(wj(),D))&&d.$classData&&d.$classData.H.ae)d=a.xo(),bj(d,"malformed floating point number",a.La);else throw D;}}}
function xj(a){return td((new yd).X((new r).d("{token \x3d ;, position \x3d ;..;, lastOffset \x3d ;, name \x3d ;, strVal \x3d ;, base \x3d ;}".split(";"))),(new r).d([a.Pb,a.La,a.Ic,a.Zi,a.oa(),a.Hd,a.He]))}function yj(a){a.El(null);a.Rc(-3);a.ck(0);a.Ll(0);a.ri(0);a.cn(null);a.Cj(null);a.uk(0)}
function nba(a){var b=a.Hd,c=b;0<=(c.length|0)&&"0x"===c.substring(0,2)?c=!0:(c=b,c=0<=(c.length|0)&&"0X"===c.substring(0,2));c&&(b=b.substring(2));if(zj(Ga(),b,"l")||zj(Ga(),b,"L"))b=b.substring(0,-1+(b.length|0)|0);for(var d=Aj(Bj(),0),c=0,f=b.length|0;c<f;){var g=Cj(Dj(),65535&(b.charCodeAt(c)|0),a.He);if(0>g){var h=a.xo();bj(h,"malformed integer number",a.La)}h=Bj();d=Ej(d,Aj(h,a.He));h=Bj();d=Fj(d,Aj(h,g));c=1+c|0}return d}
var oba=l({Hq:0},!0,"scala.meta.internal.tokenizers.LegacyTokenData",{Hq:1});function Gj(a,b,c){a=Hj(Ij(a,c));throw(new Jj).Hm(a,b);}function bj(a,b,c){a=Hj(Ij(a,c));throw(new Jj).Hm(a,b);}function Zj(a,b,c){a=Hj(Ij(a,c));throw(new Jj).Hm(a,b);}function ak(a){var b=oa(bc(Ab),[a.i.length]);Ta(a,0,b,0,a.i.length);return b}
function pba(a,b,c){if(32>c)return a.ye().i[31&b];if(1024>c)return a.Ob().i[31&(b>>>5|0)].i[31&b];if(32768>c)return a.hc().i[31&(b>>>10|0)].i[31&(b>>>5|0)].i[31&b];if(1048576>c)return a.Sc().i[31&(b>>>15|0)].i[31&(b>>>10|0)].i[31&(b>>>5|0)].i[31&b];if(33554432>c)return a.Od().i[31&(b>>>20|0)].i[31&(b>>>15|0)].i[31&(b>>>10|0)].i[31&(b>>>5|0)].i[31&b];if(1073741824>c)return a.Hh().i[31&(b>>>25|0)].i[31&(b>>>20|0)].i[31&(b>>>15|0)].i[31&(b>>>10|0)].i[31&(b>>>5|0)].i[31&b];throw(new t).c();}
function qba(a,b,c,d){if(32<=d)if(1024>d)1===a.sf()&&(a.Wc(oa(bc(Ab),[32])),a.Ob().i[31&(b>>>5|0)]=a.ye(),a.Qi(1+a.sf()|0)),a.pd(oa(bc(Ab),[32]));else if(32768>d)2===a.sf()&&(a.ud(oa(bc(Ab),[32])),a.hc().i[31&(b>>>10|0)]=a.Ob(),a.Qi(1+a.sf()|0)),a.Wc(a.hc().i[31&(c>>>10|0)]),null===a.Ob()&&a.Wc(oa(bc(Ab),[32])),a.pd(oa(bc(Ab),[32]));else if(1048576>d)3===a.sf()&&(a.ze(oa(bc(Ab),[32])),a.Sc().i[31&(b>>>15|0)]=a.hc(),a.Qi(1+a.sf()|0)),a.ud(a.Sc().i[31&(c>>>15|0)]),null===a.hc()&&a.ud(oa(bc(Ab),[32])),
a.Wc(a.hc().i[31&(c>>>10|0)]),null===a.Ob()&&a.Wc(oa(bc(Ab),[32])),a.pd(oa(bc(Ab),[32]));else if(33554432>d)4===a.sf()&&(a.lh(oa(bc(Ab),[32])),a.Od().i[31&(b>>>20|0)]=a.Sc(),a.Qi(1+a.sf()|0)),a.ze(a.Od().i[31&(c>>>20|0)]),null===a.Sc()&&a.ze(oa(bc(Ab),[32])),a.ud(a.Sc().i[31&(c>>>15|0)]),null===a.hc()&&a.ud(oa(bc(Ab),[32])),a.Wc(a.hc().i[31&(c>>>10|0)]),null===a.Ob()&&a.Wc(oa(bc(Ab),[32])),a.pd(oa(bc(Ab),[32]));else if(1073741824>d)5===a.sf()&&(a.xl(oa(bc(Ab),[32])),a.Hh().i[31&(b>>>25|0)]=a.Od(),
a.Qi(1+a.sf()|0)),a.lh(a.Hh().i[31&(c>>>25|0)]),null===a.Od()&&a.lh(oa(bc(Ab),[32])),a.ze(a.Od().i[31&(c>>>20|0)]),null===a.Sc()&&a.ze(oa(bc(Ab),[32])),a.ud(a.Sc().i[31&(c>>>15|0)]),null===a.hc()&&a.ud(oa(bc(Ab),[32])),a.Wc(a.hc().i[31&(c>>>10|0)]),null===a.Ob()&&a.Wc(oa(bc(Ab),[32])),a.pd(oa(bc(Ab),[32]));else throw(new t).c();}function bk(a,b,c){var d=oa(bc(Ab),[32]);Ta(a,b,d,c,32-(c>b?c:b)|0);return d}
function rba(a,b,c){if(32<=c)if(1024>c)a.pd(a.Ob().i[31&(b>>>5|0)]);else if(32768>c)a.Wc(a.hc().i[31&(b>>>10|0)]),a.pd(a.Ob().i[31&(b>>>5|0)]);else if(1048576>c)a.ud(a.Sc().i[31&(b>>>15|0)]),a.Wc(a.hc().i[31&(b>>>10|0)]),a.pd(a.Ob().i[31&(b>>>5|0)]);else if(33554432>c)a.ze(a.Od().i[31&(b>>>20|0)]),a.ud(a.Sc().i[31&(b>>>15|0)]),a.Wc(a.hc().i[31&(b>>>10|0)]),a.pd(a.Ob().i[31&(b>>>5|0)]);else if(1073741824>c)a.lh(a.Hh().i[31&(b>>>25|0)]),a.ze(a.Od().i[31&(b>>>20|0)]),a.ud(a.Sc().i[31&(b>>>15|0)]),a.Wc(a.hc().i[31&
(b>>>10|0)]),a.pd(a.Ob().i[31&(b>>>5|0)]);else throw(new t).c();}
function sba(a,b){var c=-1+a.sf()|0;switch(c){case 5:a.xl(ak(a.Hh()));a.lh(ak(a.Od()));a.ze(ak(a.Sc()));a.ud(ak(a.hc()));a.Wc(ak(a.Ob()));a.Hh().i[31&(b>>>25|0)]=a.Od();a.Od().i[31&(b>>>20|0)]=a.Sc();a.Sc().i[31&(b>>>15|0)]=a.hc();a.hc().i[31&(b>>>10|0)]=a.Ob();a.Ob().i[31&(b>>>5|0)]=a.ye();break;case 4:a.lh(ak(a.Od()));a.ze(ak(a.Sc()));a.ud(ak(a.hc()));a.Wc(ak(a.Ob()));a.Od().i[31&(b>>>20|0)]=a.Sc();a.Sc().i[31&(b>>>15|0)]=a.hc();a.hc().i[31&(b>>>10|0)]=a.Ob();a.Ob().i[31&(b>>>5|0)]=a.ye();break;
case 3:a.ze(ak(a.Sc()));a.ud(ak(a.hc()));a.Wc(ak(a.Ob()));a.Sc().i[31&(b>>>15|0)]=a.hc();a.hc().i[31&(b>>>10|0)]=a.Ob();a.Ob().i[31&(b>>>5|0)]=a.ye();break;case 2:a.ud(ak(a.hc()));a.Wc(ak(a.Ob()));a.hc().i[31&(b>>>10|0)]=a.Ob();a.Ob().i[31&(b>>>5|0)]=a.ye();break;case 1:a.Wc(ak(a.Ob()));a.Ob().i[31&(b>>>5|0)]=a.ye();break;case 0:break;default:throw(new p).e(c);}}function ck(a,b){var c=a.i[b];a.i[b]=null;return ak(c)}
function dk(a,b,c){a.Qi(c);c=-1+c|0;switch(c){case -1:break;case 0:a.pd(b.ye());break;case 1:a.Wc(b.Ob());a.pd(b.ye());break;case 2:a.ud(b.hc());a.Wc(b.Ob());a.pd(b.ye());break;case 3:a.ze(b.Sc());a.ud(b.hc());a.Wc(b.Ob());a.pd(b.ye());break;case 4:a.lh(b.Od());a.ze(b.Sc());a.ud(b.hc());a.Wc(b.Ob());a.pd(b.ye());break;case 5:a.xl(b.Hh());a.lh(b.Od());a.ze(b.Sc());a.ud(b.hc());a.Wc(b.Ob());a.pd(b.ye());break;default:throw(new p).e(c);}}function tba(a){return null===a?uba():a}
function vba(a){return a===uba()?null:a}var wba=l({nx:0},!0,"scala.collection.mutable.HashEntry",{nx:1});function ek(){}ek.prototype=new m;ek.prototype.constructor=ek;ek.prototype.c=function(){return this};function xba(a,b,c){if(null===c)throw(new fk).c();if(c.Hg)a=c.Ab;else{var d=new gk;d.hn=a;d.iG=b;a=hk(c,d)}return a}
ek.prototype.wp=function(a,b){var c=(new ik).c();G();var d=(new ae).c();(c.Hg?c.Ab:xba(b,d,c)).Sa(a);b=d.lb();a=function(){return function(a){return jk(kk(),a)}}(this);c=G().b;if(c===G().b)if(b===F())a=F();else{c=b.n();d=c=U(new V,a(c),F());for(b=b.o();b!==F();){var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f;b=b.o()}a=c}else{for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();a=c.da()}return a.vg(lk(function(){return function(a){if(null===a)throw(new fk).c();return""===a}}(this))).Pd(" ")};
ek.prototype.$classData=l({oG:0},!1,"ch.epfl.scala.accessible.Breadcrumbs$",{oG:1,f:1});var mk=void 0;function nk(){}nk.prototype=new m;nk.prototype.constructor=nk;nk.prototype.c=function(){return this};function yba(a,b,c){return zba(Aba(b),lk(function(a,b){return function(a){return Yc(a).ab()<=b.E&&b.Ca<=Yc(a).wa()}}(a,c)))}
function pk(a,b,c,d){a=qk().Yq(b);if(!a.g()&&(a=a.q(),c))return Bba(a);if(d){c=b.Ma();a:{if(rk(c)&&(d=c.ed,b=c.ga,sk||(sk=(new tk).c()),d=sk.Yq(d),!d.g())){c=d.q();b=U(new V,c,b);break a}b=c}uk();c=vk().$d;return H(b,c)}c=b.Ma();G();for(b=(new ae).c();!c.g();){a=d=c.n();var f=wk().mb;a=Fk(a,f);!1!==cj(a)&&ff(b,d);c=c.o()}b=b.lb();uk();c=vk().$d;return H(b,c)}
function Cba(a,b,c){if(Gk(c)){a=fj().tk;b=[c.Nb()];if(0===(b.length|0))return a.Ci;c=(new Hk).c();a=0;for(var d=b.length|0;a<d;)Ik(c,b[a]),a=1+a|0;return Jk(c)}if(Kk(c)){a=fj().tk;b=[c.Nb()];if(0===(b.length|0))return a.Ci;c=(new Hk).c();a=0;for(d=b.length|0;a<d;)Ik(c,b[a]),a=1+a|0;return Jk(c)}if(Lk(c)||Mk(c))return b=c.Qc().ub(),uk(),c=vk().$d,H(b,c);if(Nk(c)){a=fj().tk;b=[c.Ld()];if(0===(b.length|0))return a.Ci;c=(new Hk).c();a=0;for(d=b.length|0;a<d;)Ik(c,b[a]),a=1+a|0;return Jk(c)}if(hi(b)&&
Ok(c)||Pk(c))return b=c.Qc().ub(),uk(),c=vk().$d,H(b,c);if(Qk(c)){a=fj().tk;b=[Rk(c)];if(0===(b.length|0))return a.Ci;c=(new Hk).c();a=0;for(d=b.length|0;a<d;)Ik(c,b[a]),a=1+a|0;return Jk(c)}if(Sk(c)){c=Tk(c);if(c.g())c=S();else{c=c.q();a=fj().tk;c=[c];if(0===(c.length|0))c=a.Ci;else{a=(new Hk).c();for(var d=0,f=c.length|0;d<f;)Ik(a,c[d]),d=1+d|0;c=Jk(a)}c=(new T).e(c)}return c.g()?pk(0,b,!0,!1):c.q()}return pk(0,b,!0,!1)}
function Bba(a){a:for(;;){var b=a,c=qk().Yq(b);if(!c.g()){a=c.q();continue a}if(Df(b)&&(b=null===b?S():(new T).e((new q).a(Ef(b),b.yb())),!b.g()&&(b=b.q().qa(),Pf(b)))){a=b;b=fj().tk;a=[a];if(0===(a.length|0))return b.Ci;for(var b=(new Hk).c(),c=0,d=a.length|0;c<d;)Ik(b,a[c]),c=1+c|0;return Jk(b)}b=fj().tk;a=[a];if(0===(a.length|0))return b.Ci;b=(new Hk).c();c=0;for(d=a.length|0;c<d;)Ik(b,a[c]),c=1+c|0;return Jk(b)}}
function zba(a,b){var c=(new ik).c(),d=(new Uk).e(a);(c.Hg?c.Ab:Dba(a,b,d,c)).Sa(a.fa());return d.cb}function Dba(a,b,c,d){if(null===d)throw(new fk).c();if(d.Hg)a=d.Ab;else{var f=new Vk;f.mC=a;f.kG=b;f.bv=c;a=hk(d,f)}return a}nk.prototype.$classData=l({rG:0},!1,"ch.epfl.scala.accessible.Cursor$",{rG:1,f:1});var Wk=void 0;function Xk(){Wk||(Wk=(new nk).c());return Wk}function Yk(){}Yk.prototype=new m;Yk.prototype.constructor=Yk;Yk.prototype.c=function(){return this};
Yk.prototype.Yq=function(a){var b=!1,c=null;if(Df(a)){var b=!0,d=c=a,d=null===d?S():(new T).e((new q).a(Ef(d),d.yb()));if(!d.g()&&(d=d.q().qa(),Df(d)&&(d=null===d?S():(new T).e((new q).a(Ef(d),d.yb())),!d.g())))return a=d.q().qa(),(new T).e(a)}return b&&(b=c,b=null===b?S():(new T).e((new q).a(Ef(b),b.yb())),!b.g()&&(b=b.q().qa(),Zk(b)&&(b=null===b?S():(new T).e((new q).a(b.Ae(),b.pb())),!b.g())))||Zk(a)&&(b=null===a?S():(new T).e((new q).a(a.Ae(),a.pb())),!b.g()&&(b=b.q().qa(),Df(b)&&(b=null===b?
S():(new T).e((new q).a(Ef(b),b.yb())),!b.g())))?(a=b.q().qa(),(new T).e(a)):$k(a)&&(a=null===a?S():(new T).e((new al).yd(a.mg(),a.Qd(),a.$g(),a.pb())),!a.g()&&(a=a.q().Bb,$k(a)&&(a=null===a?S():(new T).e((new al).yd(a.mg(),a.Qd(),a.$g(),a.pb())),!a.g())))?(a=a.q().Bb,(new T).e(a)):S()};Yk.prototype.$classData=l({sG:0},!1,"ch.epfl.scala.accessible.Cursor$Recursive$",{sG:1,f:1});var bl=void 0;function qk(){bl||(bl=(new Yk).c());return bl}function tk(){}tk.prototype=new m;tk.prototype.constructor=tk;
tk.prototype.c=function(){return this};
tk.prototype.Yq=function(a){var b=!1,c=null,d=!1,f=null;if(Df(a)){var b=!0,g=c=a,g=null===g?S():(new T).e((new q).a(Ef(g),g.yb()));if(!g.g()&&(g=g.q().qa(),Df(g)&&(g=null===g?S():(new T).e((new q).a(Ef(g),g.yb())),!g.g())))return d=g.q().p(),(new T).e(d)}if(b&&(g=c,g=null===g?S():(new T).e((new q).a(Ef(g),g.yb())),!g.g()&&(g=g.q().qa(),Zk(g)&&(g=null===g?S():(new T).e((new q).a(g.Ae(),g.pb())),!g.g()))))return d=g.q().qa(),f=g.q().p(),cj(f)?(new T).e(cl(f)):(new T).e(d);if(Zk(a)&&(g=null===a?S():
(new T).e((new q).a(a.Ae(),a.pb())),!g.g())){var h=g.q().qa(),g=g.q().p();if(Df(h)&&(h=null===h?S():(new T).e((new q).a(Ef(h),h.yb())),!h.g()))return d=h.q().p(),cj(g)?(new T).e(cl(g)):(new T).e(d)}return $k(a)&&(d=!0,a=f=a,a=null===a?S():(new T).e((new al).yd(a.mg(),a.Qd(),a.$g(),a.pb())),!a.g()&&(a=a.q().Bb,$k(a)&&(a=null===a?S():(new T).e((new al).yd(a.mg(),a.Qd(),a.$g(),a.pb())),!a.g())))?(d=a.q().hd,(new T).e(cl(d))):b&&(b=c,b=null===b?S():(new T).e((new q).a(Ef(b),b.yb())),!b.g())?(d=b.q().p(),
(new T).e(d)):d&&(d=f,d=null===d?S():(new T).e((new al).yd(d.mg(),d.Qd(),d.$g(),d.pb())),!d.g())?(d=d.q().hd,(new T).e(cl(d))):S()};tk.prototype.$classData=l({tG:0},!1,"ch.epfl.scala.accessible.Cursor$RecursiveReverse$",{tG:1,f:1});var sk=void 0;function dl(){}dl.prototype=new m;dl.prototype.constructor=dl;dl.prototype.c=function(){return this};
function Eba(a,b){if(Ni(b)){var c=null===b?S():(new T).e((new q).a(b.Kd(),b.cd()));if(!c.g())return b=c.q().qa(),c=c.q().p(),el(a,b)+" and "+el(a,c)}if(Si(b)&&(c=null===b?S():(new T).e((new q).a(b.Db(),b.Di())),!c.g()))return b=c.q().qa(),c=c.q().p(),el(a,b)+" annotated with: "+ml(a,c);if(wi(b)&&(c=null===b?S():(new T).e((new q).a(b.Db(),b.pb())),!c.g())){b=c.q().qa();c=c.q().p();a:{for(var d=c;!d.g();){var f=d.n();b:{if(Ti(f)&&(f=null===f?S():(new T).e(f.Gh()),!f.g())){var f=f.q(),g=null===f?S():
(new T).e((new q).a(nl(f),ol(f)));if(!g.g()&&(f=g.q().qa(),g=g.q().p(),S()===f&&S()===g)){f=!0;break b}}f=!1}if(!f){d=!1;break a}d=d.o()}d=!0}if(d)return el(a,b)+" taking "+Cg(c)+" parameters";d=1===Cg(c)?"of":"applied to";b=[el(a,b),d,ml(a,c)];pl();a=[];c=0;for(d=b.length|0;c<d;)f=b[c],g=(new cd).j(f),!1!==cj(g)&&a.push(f),c=1+c|0;b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");return b.Qb.ac}if(xi(b)&&(c=null===b?S():(new T).e((new yi).sd(b.Kd(),
zi(b),b.cd())),!c.g()))return b=c.q().Bb,d=c.q().qb,c=c.q().Eb,el(a,b)+" "+el(a,d)+" "+el(a,c);if(Ig(b)&&(c=null===b?S():(new T).e(b.Db()),!c.g()))return b=c.q(),"by name: "+el(a,b);if(Ri(b)&&(c=null===b?S():(new T).e((new q).a(b.Db(),b.ub())),!c.g()))return b=c.q().qa(),c=c.q().p(),"existential "+el(a,b)+" for some "+ml(a,c);if(Ai(b)&&(c=null===b?S():(new T).e((new q).a(b.me(),b.Kh())),!c.g()))return b=c.q().qa(),c=c.q().p(),Fba(a,b,c);if(tl(b)&&(c=null===b?S():(new T).e((new q).a(b.me(),b.Kh())),
!c.g()))return b=c.q().qa(),c=c.q().p(),"implicit "+Fba(a,b,c);if(ul(b)&&(c=null===b?S():(new T).e((new q).a(b.lc(),b.Db())),!c.g()))return b=c.q().qa(),c=c.q().p(),"lambda "+ml(a,b)+" to "+el(a,c);if(hi(b)&&(c=null===b?S():(new T).e(b.ec()),!c.g()))return c.q();if(Oi(b)&&(c=null===b?S():(new T).e((new q).a(b.Kd(),b.cd())),!c.g()))return b=c.q().qa(),c=c.q().p(),el(a,b)+" or "+el(a,c);if(Ti(b)&&(c=null===b?S():(new T).e(b.Gh()),!c.g()))return b=c.q(),"placeholder "+Gba(a,b);if(ti(b)&&(c=null===b?
S():(new T).e((new q).a(ui(b),b.nc())),!c.g()))return b=c.q().qa(),c=c.q().p(),"project "+el(a,b)+" "+el(a,c);if(Pi(b)&&(c=null===b?S():(new T).e((new q).a(Qi(b),b.ub())),!c.g())){b=c.q().qa();c=c.q().p();b=["type refinements:",vl(b),ml(a,c)];pl();a=[];c=0;for(d=b.length|0;c<d;)f=b[c],g=(new cd).j(f),!1!==cj(g)&&a.push(f),c=1+c|0;b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");return b.Qb.ac}if(Jg(b)&&(c=null===b?S():(new T).e(b.Db()),
!c.g()))return b=c.q(),"repeated: "+el(a,b);if(si(b)&&(c=null===b?S():(new T).e((new q).a(wl(b),b.nc())),!c.g())){b=c.q().qa();c=c.q().p();b=["select",el(a,b),el(a,c)];pl();a=[];c=0;for(d=b.length|0;c<d;)f=b[c],g=(new cd).j(f),!1!==cj(g)&&a.push(f),c=1+c|0;b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");return b.Qb.ac}if(vi(b)&&(c=null===b?S():(new T).e(b.ve()),!c.g()))return b=c.q(),"singleton "+el(a,b);if(Bi(b)&&(c=null===b?S():
(new T).e(b.pb()),!c.g()))return b=c.q(),xl(a,b);if(Mi(b)&&(c=null===b?S():(new T).e((new q).a(b.Kd(),b.cd())),!c.g()))return b=c.q().qa(),c=c.q().p(),el(a,b)+" with "+el(a,c);throw(new p).e(b);}function Fba(a,b,c){return"function "+(cj(b)?ml(a,b):"Unit")+" to "+el(a,c)}
function Hba(a){yl(a)&&((null===a?S():(new T).e(a.ff())).g()||zl((new Al).mc(388),(new Bl).j("ch.epfl.scala.accessible.Describe.describeMod")));if(Cl(a))return"co-variant";if(Dl(a))return"contra-variant";if(El(a)){var b=null===a?S():(new T).e(a.gg());if(!b.g())return a=b.q(),Iba("private",a)}if(Hl(a)&&(b=null===a?S():(new T).e(a.gg()),!b.g()))return a=b.q(),Iba("protected",a);var b=Il(),c=wk().mb,c=tg().If(c);return yg(b,a,c).be()}
dl.prototype.wp=function(a,b){a=Jba(Kba(),a,b);if(zh(a))return el(this,a.Y);if(S()===a)return"cannot find tree";throw(new p).e(a);};
function Lba(a,b,c,d,f,g,h){if(cj(f)){var n=function(a){return function(b){var c=function(){return function(a){return el(Jl(),a)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(a);if(G().b===G().b)if(f===F())n=F();else{for(var u=f,w=(new Kl).qj(!1),D=(new Uk).e(null),N=(new Uk).e(null);u!==F();){var Q=u.n();n(Q).dc().Cb(lk(function(a,
b,c,d){return function(a){b.cb?(a=U(new V,a,F()),d.cb.ga=a,d.cb=a):(c.cb=U(new V,a,F()),d.cb=c.cb,b.cb=!0)}}(f,w,D,N)));u=u.o()}n=w.cb?D.cb:F()}else{G();for(u=(new ae).c();!f.g();)w=f.n(),w=n(w).dc(),Ll(u,w),f=f.o();n=u.lb()}n=n.Pd(", ")}else n="";b=ml(a,b);c=el(a,c);a=Ml(a,d);g.g()?g=S():(g=g.q(),d=Jl(),g=(new T).e("returns: "+el(d,g)));g=g.g()?"":g.q();h.g()?h=S():(h=h.q(),d=Jl(),h=(new T).e("body: "+el(d,h)));g=[b,"def",c,a,n,g,h.g()?"":h.q()];pl();h=[];a=0;for(d=g.length|0;a<d;)c=g[a],b=(new cd).j(c),
!1!==cj(b)&&h.push(c),a=1+a|0;g=(new ql).c();a=!1;a=!0;rl(g,"");d=0;for(c=h.length|0;d<c;)b=h[d],a?(sl(g,b),a=!1):(rl(g," "),sl(g,b)),d=1+d|0;rl(g,"");return g.Qb.ac}function ml(a,b){a=function(){return function(a){return el(Jl(),a)}}(a);var c=G().b;if(c===G().b)if(b===F())a=F();else{var c=b.n(),d=c=U(new V,a(c),F());for(b=b.o();b!==F();){var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f;b=b.o()}a=c}else{for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();a=c.da()}return a.Pd(", ")}
function vl(a){if(a.g())a=S();else{a=a.q();var b=Jl();a=(new T).e(el(b,a))}return a.g()?"":a.q()}
function Gba(a,b){var c=!1,d=null;if(Nl(b)){var f=null===b?S():(new T).e((new yi).sd(b.Re(),b.zm(),b.Nb()));if(!f.g()){var g=f.q().Bb,h=f.q().qb,n=f.q().Eb,u=Mba(a,g);if(h.g())var w=S();else var D=h.q(),N=Jl(),w=(new T).e("if "+el(N,D));var Q=["case",u,w.g()?"":w.q(),"then",el(a,n)];pl();for(var ea=[],ba=0,ma=Q.length|0;ba<ma;){var La=Q[ba],Pa=(new cd).j(La);!1!==cj(Pa)&&ea.push(La);ba=1+ba|0}var Qa=(new ql).c(),Ka=!1,Ka=!0;rl(Qa,"");for(var Ba=0,va=ea.length|0;Ba<va;){var za=ea[Ba];Ka?(sl(Qa,za),
Ka=!1):(rl(Qa," "),sl(Qa,za));Ba=1+Ba|0}rl(Qa,"");return Qa.Qb.ac}}if(Ol(b)){var qa=null===b?S():(new T).e((new yi).sd(b.Db(),b.xb(),b.tl()));if(!qa.g()){var la=qa.q().Bb,Ma=qa.q().qb,Ea=qa.q().Eb;if(Pl(Ma)){if(cj(Ea)){var tb=function(a){return function(b){var c=function(){return function(a){return el(Jl(),a)}}(a),d=G().b;if(d===G().b)if(b===F())c=F();else{var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g;b=b.o()}c=d}else{for(d=zg(b,d);!b.g();)f=b.n(),
d.ba(c(f)),b=b.o();c=d.da()}return c.Pd(", ")}}(a),Za=G().b;if(Za===G().b)if(Ea===F())var eb=F();else{for(var kb=Ea.n(),Pb=U(new V,tb(kb),F()),Na=Pb,sb=Ea.o();sb!==F();)var yb=sb.n(),sc=U(new V,tb(yb),F()),Na=Na.ga=sc,sb=sb.o();eb=Pb}else{for(var Ra=zg(Ea,Za),wc=Ea;!wc.g();){var Wb=wc.n();Ra.ba(tb(Wb));wc=wc.o()}eb=Ra.da()}var Rb="applied to "+eb.Pd(" then ")}else Rb="";var ub=[el(a,la),Rb];pl();for(var fb=[],Xb=0,lb=ub.length|0;Xb<lb;){var Eb=ub[Xb],xc=(new cd).j(Eb);!1!==cj(xc)&&fb.push(Eb);Xb=
1+Xb|0}var gb=(new ql).c(),dc=!1,dc=!0;rl(gb,"");for(var Fc=0,Qb=fb.length|0;Fc<Qb;){var Bb=fb[Fc];dc?(sl(gb,Bb),dc=!1):(rl(gb," "),sl(gb,Bb));Fc=1+Fc|0}rl(gb,"");return gb.Qb.ac}}}Ql(b)&&((null===b?S():(new T).e((new q).a(b.ve(),b.ub()))).g()||zl((new Al).mc(448),(new Bl).j("ch.epfl.scala.accessible.Describe.describeMisc")));Mk(b)&&((null===b?S():(new T).e((new yi).sd(b.Qa(),b.yb(),b.Qc()))).g()||zl((new Al).mc(449),(new Bl).j("ch.epfl.scala.accessible.Describe.describeMisc")));if(Rl(b)){var c=!0,
Ib=d=b,mb=null===Ib?S():(new T).e((new q).a(Ib.xb(),Ib.sc()));if(!mb.g()){var Cb=mb.q().qa(),Tb=mb.q().p();if(Pl(Cb)&&S()===Tb)return""}}if(c){var mc=d,Ac=null===mc?S():(new T).e((new q).a(mc.xb(),mc.sc()));if(!Ac.g()){var Dc=Ac.q().qa(),Db=Ac.q().p(),Va=el(a,Dc);if(Db.g())var ec=S();else var $a=Db.q(),vb=Jl(),ec=(new T).e("typed as: "+el(vb,$a));var fc=["self type",Va,ec.g()?"":ec.q()];pl();for(var Bc=[],Ub=0,Vb=fc.length|0;Ub<Vb;){var wb=fc[Ub],xb=(new cd).j(wb);!1!==cj(xb)&&Bc.push(wb);Ub=1+Ub|
0}var Xa=(new ql).c(),tc=!1,tc=!0;rl(Xa,"");for(var ib=0,zb=Bc.length|0;ib<zb;){var nb=Bc[ib];tc?(sl(Xa,nb),tc=!1):(rl(Xa," "),sl(Xa,nb));ib=1+ib|0}rl(Xa,"");return Xa.Qb.ac}}Sl(b)&&((null===b?S():(new T).e(b.ub())).g()||zl((new Al).mc(459),(new Bl).j("ch.epfl.scala.accessible.Describe.describeMisc")));if(Tl(b)){var Jb=null===b?S():(new T).e((new al).yd(b.Si(),b.Xi(),b.Zg(),b.ub()));if(!Jb.g()){var jb=Jb.q().Bb,ob=Jb.q().qb,gc=Jb.q().Eb,cb=Jb.q().hd,Ua=[cj(jb)?"early initialization: "+ml(a,jb):"",
ml(a,ob),el(a,gc),ml(a,cb)];pl();for(var Yb=[],Kb=0,pb=Ua.length|0;Kb<pb;){var hb=Ua[Kb],Lb=(new cd).j(hb);!1!==cj(Lb)&&Yb.push(hb);Kb=1+Kb|0}var Fa=(new ql).c(),bb=!1,bb=!0;rl(Fa,"");for(var nc=0,db=Yb.length|0;nc<db;){var uc=Yb[nc];bb?(sl(Fa,uc),bb=!1):(rl(Fa," "),sl(Fa,uc));nc=1+nc|0}rl(Fa,"");return Fa.Qb.ac}}if(sg(b)){var Fb=null===b?S():(new T).e((new al).yd(b.Qa(),b.xb(),b.sc(),b.Bi()));if(!Fb.g()){var hc=Fb.q().Bb,$b=Fb.q().qb,kc=Fb.q().Eb,lc=Fb.q().hd,Mb=[ml(a,hc),el(a,$b),vl(kc),vl(lc)];
pl();for(var Nb=[],Gb=0,Sb=Mb.length|0;Gb<Sb;){var Cc=Mb[Gb],Ob=(new cd).j(Cc);!1!==cj(Ob)&&Nb.push(Cc);Gb=1+Gb|0}var Zb=(new ql).c(),Ec=!1,Ec=!0;rl(Zb,"");for(var oc=0,pc=Nb.length|0;oc<pc;){var qc=Nb[oc];Ec?(sl(Zb,qc),Ec=!1):(rl(Zb," "),sl(Zb,qc));oc=1+oc|0}rl(Zb,"");return Zb.Qb.ac}}if(Ul(b)){var Jc=null===b?S():(new T).e((new q).a(nl(b),ol(b)));if(!Jc.g()){var Hc=Jc.q().qa(),ac=Jc.q().p();if(Hc.g())var Lc=S();else var $c=Hc.q(),Tc=Jl(),Lc=(new T).e("super-type of: "+el(Tc,$c));var Rc=Lc.g()?"":
Lc.q();if(ac.g())var Mc=S();else var hd=ac.q(),Qc=Jl(),Mc=(new T).e("sub-type of: "+el(Qc,hd));var rd=[Rc,Mc.g()?"":Mc.q()];pl();for(var od=[],Zc=0,nd=rd.length|0;Zc<nd;){var zd=rd[Zc],ud=(new cd).j(zd);!1!==cj(ud)&&od.push(zd);Zc=1+Zc|0}var wd=(new ql).c(),Bd=!1,Bd=!0;rl(wd,"");for(var Ed=0,pd=od.length|0;Ed<pd;){var vd=od[Ed];Bd?(sl(wd,vd),Bd=!1):(rl(wd," "),sl(wd,vd));Ed=1+Ed|0}rl(wd,"");return wd.Qb.ac}}if(Vl(b)){var xd=null===b?S():(new T).e((new bm).ti(b.Qa(),b.xb(),b.lc(),b.am(),b.im(),b.ym()));
if(!xd.g()){var ee=xd.q().Bb,Ld=xd.q().qb,me=xd.q().Eb,fe=xd.q().hd,Yd=xd.q().Yf,Zd=xd.q().rk;if(cj(Yd)){var qe=function(){return function(a){return el(Jl(),a)}}(a),re=G().b;if(re===G().b)if(Yd===F())var Kd=F();else{for(var yf=Yd.n(),Cd=U(new V,qe(yf),F()),Fe=Cd,je=Yd.o();je!==F();)var xe=je.n(),ge=U(new V,qe(xe),F()),Fe=Fe.ga=ge,je=je.o();Kd=Cd}else{for(var ye=zg(Yd,re),ne=Yd;!ne.g();){var Ce=ne.n();ye.ba(qe(Ce));ne=ne.o()}Kd=ye.da()}var hf=Kd.le("view bounded by: ",", ",".")}else hf="";if(cj(Zd)){var Pe=
function(){return function(a){return el(Jl(),a)}}(a),jf=G().b;if(jf===G().b)if(Zd===F())var ze=F();else{for(var Me=Zd.n(),$e=U(new V,Pe(Me),F()),kf=$e,Ne=Zd.o();Ne!==F();)var Ge=Ne.n(),se=U(new V,Pe(Ge),F()),kf=kf.ga=se,Ne=Ne.o();ze=$e}else{for(var lf=zg(Zd,jf),te=Zd;!te.g();){var De=te.n();lf.ba(Pe(De));te=te.o()}ze=lf.da()}var Qe=ze.le("context bounded by: ",", ",".")}else Qe="";var af=Il(),of=y(z(af,Ld),cm())?"a parameter":el(a,Ld),df=[ml(a,ee),of,Ml(a,me),el(a,fe),hf,Qe];pl();for(var mf=[],Re=
0,Xe=df.length|0;Re<Xe;){var zf=df[Re],ef=(new cd).j(zf);!1!==cj(ef)&&mf.push(zf);Re=1+Re|0}var $d=(new ql).c(),pf=!1,pf=!0;rl($d,"");for(var He=0,If=mf.length|0;He<If;){var ug=mf[He];pf?(sl($d,ug),pf=!1):(rl($d," "),sl($d,ug));He=1+He|0}rl($d,"");return $d.Qb.ac}}if(dm(b)){var Af=null===b?S():(new T).e(b.Ab);if(!Af.g())return Af.q()}if(Pl(b))return"";throw(new p).e(b);}
function Nba(a,b){em(b)&&((null===b?S():(new T).e((new q).a(b.ob(),b.Di()))).g()||zl((new Al).mc(53),(new Bl).j("ch.epfl.scala.accessible.Describe.describeTerm")));if(Zk(b)){var c=null===b?S():(new T).e((new q).a(b.Ae(),b.pb()));if(!c.g()){var d=c.q().qa(),f=c.q().p();return el(a,d)+" applied to "+ml(a,f)}}if($k(b)){var g=null===b?S():(new T).e((new al).yd(b.mg(),b.Qd(),b.$g(),b.pb()));if(!g.g()){var h=g.q().Bb,n=g.q().qb,u=g.q().Eb,w=g.q().hd,D=cj(u)?"parameterized with "+ml(a,u)+" applied to":"",
N=cj(w)?ml(a,w):"empty arguments",Q=[el(a,h),el(a,n),D,N];pl();for(var ea=[],ba=0,ma=Q.length|0;ba<ma;){var La=Q[ba],Pa=(new cd).j(La);!1!==cj(Pa)&&ea.push(La);ba=1+ba|0}var Qa=(new ql).c(),Ka=!1,Ka=!0;rl(Qa,"");for(var Ba=0,va=ea.length|0;Ba<va;){var za=ea[Ba];Ka?(sl(Qa,za),Ka=!1):(rl(Qa," "),sl(Qa,za));Ba=1+Ba|0}rl(Qa,"");return Qa.Qb.ac}}if(fm(b)){var qa=null===b?S():(new T).e((new q).a(b.Ae(),b.$g()));if(!qa.g()){var la=qa.q().qa(),Ma=qa.q().p(),Ea=1<Cg(Ma)?"types":"type",tb=[el(a,la),"applied to",
Ea,ml(a,Ma)];pl();for(var Za=[],eb=0,kb=tb.length|0;eb<kb;){var Pb=tb[eb],Na=(new cd).j(Pb);!1!==cj(Na)&&Za.push(Pb);eb=1+eb|0}var sb=(new ql).c(),yb=!1,yb=!0;rl(sb,"");for(var sc=0,Ra=Za.length|0;sc<Ra;){var wc=Za[sc];yb?(sl(sb,wc),yb=!1):(rl(sb," "),sl(sb,wc));sc=1+sc|0}rl(sb,"");return sb.Qb.ac}}if(gm(b)){var Wb=null===b?S():(new T).e((new q).a(b.Qd(),hm(b)));if(!Wb.g()){var Rb=Wb.q().qa(),ub=Wb.q().p();return el(a,Rb)+" "+el(a,ub)}}if(im(b)){var fb=null===b?S():(new T).e((new q).a(b.ob(),b.Db()));
if(!fb.g()){var Xb=fb.q().qa(),lb=fb.q().p();return el(a,Xb)+" typed as "+el(a,lb)}}if(jm(b)){var Eb=null===b?S():(new T).e((new q).a(b.mg(),b.Ld()));if(!Eb.g()){var xc=Eb.q().qa(),gb=Eb.q().p();return el(a,xc)+" assigned to "+el(a,gb)}}km(b)&&((null===b?S():(new T).e(b.ub())).g()||zl((new Al).mc(97),(new Bl).j("ch.epfl.scala.accessible.Describe.describeTerm")));if(lm(b)){var dc=null===b?S():(new T).e((new q).a(b.Nb(),b.ob()));if(!dc.g()){var Fc=dc.q().qa(),Qb=dc.q().p();return"do "+el(a,Fc)+" while "+
el(a,Qb)}}if(mm(b)){var Bb=null===b?S():(new T).e(b.ob());if(!Bb.g()){var Ib=Bb.q();return"\u03b7-conversion of "+el(a,Ib)}}pm(b)&&((null===b?S():(new T).e((new q).a(b.Ui(),b.Nb()))).g()||zl((new Al).mc(104),(new Bl).j("ch.epfl.scala.accessible.Describe.describeTerm")));qm(b)&&((null===b?S():(new T).e((new q).a(b.Ui(),b.Nb()))).g()||zl((new Al).mc(105),(new Bl).j("ch.epfl.scala.accessible.Describe.describeTerm")));if(rm(b)){var mb=null===b?S():(new T).e((new q).a(b.me(),b.Nb()));if(!mb.g()){var Cb=
mb.q().qa(),Tb=mb.q().p();return"function "+(cj(Cb)?ml(a,Cb):"unit")+" to "+el(a,Tb)}}if(sm(b)){var mc=null===b?S():(new T).e((new yi).sd(b.oi(),tm(b),um(b)));if(!mc.g()){var Ac=mc.q().Bb,Dc=mc.q().qb,Db=mc.q().Eb,Va=Il(),ec=z(Va,Db);vm||(vm=(new wm).c());if(y(ec,vm))var $a=wk().mb,vb=Fk(Db,$a),fc=xm(vb);else fc=!1;var Bc=fc?"":"else "+el(a,Db),Ub=["if "+el(a,Ac)+" then "+el(a,Dc),Bc];pl();for(var Vb=[],wb=0,xb=Ub.length|0;wb<xb;){var Xa=Ub[wb],tc=(new cd).j(Xa);!1!==cj(tc)&&Vb.push(Xa);wb=1+wb|0}var ib=
(new ql).c(),zb=!1,zb=!0;rl(ib,"");for(var nb=0,Jb=Vb.length|0;nb<Jb;){var jb=Vb[nb];zb?(sl(ib,jb),zb=!1):(rl(ib," "),sl(ib,jb));nb=1+nb|0}rl(ib,"");return ib.Qb.ac}}if(ym(b)){var ob=null===b?S():(new T).e((new yi).sd(b.yi(),b.Qe(),b.pb()));if(!ob.g()){var gc=ob.q().Bb,cb=ob.q().qb,Ua=ob.q().Eb,Yb=el(a,gc);return zm(a,Yb,"insert",cb,Ua,!0)}}if(Am(b)){var Kb=null===b?S():(new T).e((new q).a(b.ob(),b.ni()));if(!Kb.g()){var pb=Kb.q().qa(),hb=Kb.q().p(),Lb=[el(a,pb),"match",ml(a,hb)];pl();for(var Fa=
[],bb=0,nc=Lb.length|0;bb<nc;){var db=Lb[bb],uc=(new cd).j(db);!1!==cj(uc)&&Fa.push(db);bb=1+bb|0}var Fb=(new ql).c(),hc=!1,hc=!0;rl(Fb,"");for(var $b=0,kc=Fa.length|0;$b<kc;){var lc=Fa[$b];hc?(sl(Fb,lc),hc=!1):(rl(Fb," "),sl(Fb,lc));$b=1+$b|0}rl(Fb,"");return Fb.Qb.ac}}if(Pf(b)){var Mb=null===b?S():(new T).e(b.ec());if(!Mb.g())return Mb.q()}if(Bm(b)){var Nb=null===b?S():(new T).e(b.ff());if(!Nb.g()){var Gb=Nb.q();return"new "+el(a,Gb)}}if(Cm(b)){var Sb=null===b?S():(new T).e(b.Qc());if(!Sb.g()){var Cc=
Sb.q();return"new anonymous "+el(a,Cc)}}if(Dm(b)){var Ob=null===b?S():(new T).e(b.ni());if(!Ob.g()){var Zb=Ob.q();return"partial function "+ml(a,Zb)}}Em(b)&&zl((new Al).mc(138),(new Bl).j("ch.epfl.scala.accessible.Describe.describeTerm"));if(Fm(b)){var Ec=null===b?S():(new T).e(b.ob());if(!Ec.g()){var oc=Ec.q();return"repeated "+el(a,oc)}}if(Gm(b)){var pc=null===b?S():(new T).e(b.ob());if(!pc.g()){var qc=pc.q();return"returns "+el(a,qc)}}if(Df(b)){var Jc=null===b?S():(new T).e((new q).a(Ef(b),b.yb()));
if(!Jc.g()){var Hc=Jc.q().qa(),ac=Jc.q().p();return el(a,Hc)+" dot "+el(a,ac)}}if(Hm(b)){var Lc=null===b?S():(new T).e((new q).a(Im(b),Jm(b)));if(!Lc.g()){var $c=Lc.q().qa(),Tc=Lc.q().p(),Rc=[el(a,$c),"super",el(a,Tc)];pl();for(var Mc=[],hd=0,Qc=Rc.length|0;hd<Qc;){var rd=Rc[hd],od=(new cd).j(rd);!1!==cj(od)&&Mc.push(rd);hd=1+hd|0}var Zc=(new ql).c(),nd=!1,nd=!0;rl(Zc,"");for(var zd=0,ud=Mc.length|0;zd<ud;){var wd=Mc[zd];nd?(sl(Zc,wd),nd=!1):(rl(Zc," "),sl(Zc,wd));zd=1+zd|0}rl(Zc,"");return Zc.Qb.ac}}if(Km(b)){var Bd=
null===b?S():(new T).e(Lm(b));if(!Bd.g()){var Ed=Bd.q(),pd=["this",Pl(Ed)?"":"within "+(new T).e(Ed.ec()).Y];pl();for(var vd=[],xd=0,ee=pd.length|0;xd<ee;){var Ld=pd[xd],me=(new cd).j(Ld);!1!==cj(me)&&vd.push(Ld);xd=1+xd|0}var fe=(new ql).c(),Yd=!1,Yd=!0;rl(fe,"");for(var Zd=0,qe=vd.length|0;Zd<qe;){var re=vd[Zd];Yd?(sl(fe,re),Yd=!1):(rl(fe," "),sl(fe,re));Zd=1+Zd|0}rl(fe,"");return fe.Qb.ac}}if(Mm(b)){var Kd=null===b?S():(new T).e(b.ob());if(!Kd.g()){var yf=Kd.q();return"throw "+el(a,yf)}}if(Nm(b)){var Cd=
null===b?S():(new T).e((new yi).sd(b.ob(),Om(b),b.Vi()));if(!Cd.g()){var Fe=Cd.q().Bb,je=Cd.q().qb,xe=Cd.q().Eb,ge=cj(je)?"catch "+ml(a,je):"",ye=el(a,Fe);if(xe.g())var ne=S();else var Ce=xe.q(),hf=Jl(),ne=(new T).e("finally "+el(hf,Ce));var Pe=["try",ye,ge,ne.g()?"":ne.q()];pl();for(var jf=[],ze=0,Me=Pe.length|0;ze<Me;){var $e=Pe[ze],kf=(new cd).j($e);!1!==cj(kf)&&jf.push($e);ze=1+ze|0}var Ne=(new ql).c(),Ge=!1,Ge=!0;rl(Ne,"");for(var se=0,lf=jf.length|0;se<lf;){var te=jf[se];Ge?(sl(Ne,te),Ge=!1):
(rl(Ne," "),sl(Ne,te));se=1+se|0}rl(Ne,"");return Ne.Qb.ac}}if(Pm(b)){var De=null===b?S():(new T).e((new yi).sd(b.ob(),Qm(b),b.Vi()));if(!De.g()){var Qe=De.q().Bb,af=De.q().qb,of=De.q().Eb,df=el(a,Qe),mf=el(a,af);if(of.g())var Re=S();else var Xe=of.q(),zf=Jl(),Re=(new T).e("finally "+el(zf,Xe));var ef=["try",df,"catch",mf,Re.g()?"":Re.q()];pl();for(var $d=[],pf=0,He=ef.length|0;pf<He;){var If=ef[pf],ug=(new cd).j(If);!1!==cj(ug)&&$d.push(If);pf=1+pf|0}var Af=(new ql).c(),vg=!1,vg=!0;rl(Af,"");for(var Wf=
0,Mh=$d.length|0;Wf<Mh;){var Yg=$d[Wf];vg?(sl(Af,Yg),vg=!1):(rl(Af," "),sl(Af,Yg));Wf=1+Wf|0}rl(Af,"");return Af.Qb.ac}}if(Rm(b)){var Og=null===b?S():(new T).e(b.pb());if(!Og.g()){var Pg=Og.q();return xl(a,Pg)}}if(Sm(b)){var Jf=null===b?S():(new T).e((new q).a(b.ob(),b.Nb()));if(!Jf.g()){var Zg=Jf.q().qa(),ji=Jf.q().p();return"while "+el(a,Zg)+" do "+el(a,ji)}}if(Tm(b)){var jh=null===b?S():(new T).e((new q).a(b.Qe(),b.pb()));if(!jh.g()){var $g=jh.q().qa(),Qg=jh.q().p();return zm(a,"xml literal","scala expression",
$g,Qg,!1)}}throw(new p).e(b);}function Iba(a,b){if(Pl(b))b="";else if(Um(b))b="within "+(new T).e(b.ec()).Y;else if(Km(b)&&!(null===b?S():(new T).e(Lm(b))).g())b="this";else throw(new p).e(b);b=[a,b];pl();a=[];for(var c=0,d=b.length|0;c<d;){var f=b[c],g=(new cd).j(f);!1!==cj(g)&&a.push(f);c=1+c|0}b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");return b.Qb.ac}
function zm(a,b,c,d,f,g){b=g?b+" interpolation":b;g=d.o();var h=G().b;f=Vm(f,g,h);d=d.n();a=f.se(el(a,d),Wm(function(a,b){return function(a,c){c=(new q).a(a,c);a=c.Nk;var d=c.Ok;if(null!==d){c=d.qa();var d=d.p(),d=el(Jl(),d),f=zj(Ga(),a," ")?"":" ";if(0<=(d.length|0)&&" "===d.substring(0,1))var g=",";else{if(null===d)throw(new fk).c();g=""===d?"":", "}var h=Jl();return a+f+b+" "+el(h,c)+g+d}throw(new p).e(c);}}(a,c)));return b+" "+a}
function Mba(a,b){if(Xm(b)){var c=null===b?S():(new T).e((new q).a(b.Vd(),b.ci()));if(!c.g())return b=c.q().qa(),c=c.q().p(),el(a,b)+" or "+el(a,c)}if(Ym(b)&&(c=null===b?S():(new T).e((new q).a(b.Vd(),b.ci())),!c.g()))return b=c.q().qa(),c=c.q().p(),el(a,b)+" bound to "+el(a,c);if(dn(b)&&(c=null===b?S():(new T).e((new q).a(b.Ae(),b.pb())),!c.g()))return b=c.q().qa(),c=c.q().p(),el(a,b)+" extracts "+ml(a,c);if(en(b)&&(c=null===b?S():(new T).e((new yi).sd(b.Vd(),b.Qd(),fn(b))),!c.g())){b=c.q().Bb;var d=
c.q().qb,c=c.q().Eb;return el(a,b)+" "+el(a,d)+" "+ml(a,c)}if(gn(b)&&(c=null===b?S():(new T).e((new yi).sd(b.yi(),b.Qe(),b.pb())),!c.g()))return d=c.q().Bb,b=c.q().qb,c=c.q().Eb,d=el(a,d),zm(a,d,"extracts",b,c,!0);if(hn(b))return"multiple placeholders";if(jn(b)&&(c=null===b?S():(new T).e(b.pb()),!c.g()))return b=c.q(),xl(a,b);if(kn(b)&&(c=null===b?S():(new T).e((new q).a(b.Vd(),b.cd())),!c.g()))return b=c.q().qa(),c=c.q().p(),el(a,b)+" typed as "+el(a,c);if(ln(b)&&(c=null===b?S():(new T).e(b.yb()),
!c.g()))return b=c.q(),el(a,b);if(mn(b))return"placeholder";if(nn(b)&&(c=null===b?S():(new T).e((new q).a(b.Qe(),b.pb())),!c.g()))return b=c.q().qa(),c=c.q().p(),zm(a,"xml","extracts",b,c,!0);if(Pf(b)&&(a=null===b?S():(new T).e(b.ec()),!a.g()))return"exactly "+a.q();throw(new p).e(b);}
function Ml(a,b){if(cj(b)){a=function(){return function(a){return el(Jl(),a)}}(a);var c=G().b;if(c===G().b)if(b===F())a=F();else{var c=b.n(),d=c=U(new V,a(c),F());for(b=b.o();b!==F();){var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f;b=b.o()}a=c}else{for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();a=c.da()}return a.le("parameterized with: ",", ","")}return""}function xl(a,b){return"tuple "+Cg(b)+" of "+ml(a,b)}
function el(a,b){if(Ui(b))if(on(b))a="unit";else{a=Il();var c=wk().mb,c=tg().If(c);a=yg(a,b,c).be()}else if(pn(b))a=Nba(a,b);else if(Gg(b))a=Eba(a,b);else if(b&&b.$classData&&b.$classData.H.he)a=Mba(a,b);else if(qn(b))a:{if(rn(b)&&(c=null===b?S():(new T).e(sn(new tn,b.Qa(),b.yb(),b.lc(),b.bd(),b.df())),!c.g())){b=c.q().Bb;var d=c.q().qb,f=c.q().Eb,g=c.q().hd,c=c.q().Yf;a=Lba(a,b,d,f,g,(new T).e(c),S());break a}if(un(b)&&(f=null===b?S():(new T).e((new al).yd(b.Qa(),b.nc(),b.lc(),b.Gh())),!f.g())){b=
f.q().Bb;c=f.q().qb;d=f.q().Eb;f=f.q().hd;g=cj(d)?".":"";b=[ml(a,b),"type",el(a,c),Ml(a,d)+g,el(a,f)];pl();a=[];c=0;for(d=b.length|0;c<d;)f=b[c],g=(new cd).j(f),!1!==cj(g)&&a.push(f),c=1+c|0;b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");a=b.Qb.ac;break a}if(vn(b)&&(c=null===b?S():(new T).e((new yi).sd(b.Qa(),b.Xd(),b.df())),!c.g())){b=c.q().Bb;d=c.q().qb;c=c.q().Eb;b=[ml(a,b),"val",ml(a,d),el(a,c)];pl();a=[];c=0;for(d=b.length|
0;c<d;)f=b[c],g=(new cd).j(f),!1!==cj(g)&&a.push(f),c=1+c|0;b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");a=b.Qb.ac;break a}wn(b)&&((null===b?S():(new T).e((new yi).sd(b.Qa(),b.Xd(),b.df()))).g()||zl((new Al).mc(334),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDecl")));throw(new p).e(b);}else if(yn(b))a:{if(Ok(b)&&(c=null===b?S():(new T).e(sn(new tn,b.Qa(),b.nc(),b.lc(),b.jh(),b.Qc())),!c.g())){b=c.q().Bb;d=c.q().qb;f=
c.q().Eb;g=c.q().hd;c=c.q().Yf;b=[ml(a,b),"class",Eba(a,d),Ml(a,f),el(a,g),el(a,c)];pl();a=[];c=0;for(d=b.length|0;c<d;)f=b[c],g=(new cd).j(f),!1!==cj(g)&&a.push(f),c=1+c|0;b=(new ql).c();c=!0;rl(b,"");d=0;for(f=a.length|0;d<f;)g=a[d],c?(sl(b,g),c=!1):(rl(b," "),sl(b,g)),d=1+d|0;rl(b,"");a=b.Qb.ac;break a}if(Gk(b)&&(c=null===b?S():(new T).e((new bm).ti(b.Qa(),b.yb(),b.lc(),b.bd(),b.sc(),b.Nb())),!c.g())){b=c.q().Bb;var d=c.q().qb,f=c.q().Eb,g=c.q().hd,h=c.q().Yf,c=c.q().rk;a=Lba(a,b,d,f,g,h,(new T).e(c));
break a}Kk(b)&&((null===b?S():(new T).e((new bm).ti(b.Qa(),b.yb(),b.lc(),b.bd(),b.sc(),b.Nb()))).g()||zl((new Al).mc(356),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDefn")));Lk(b)&&((null===b?S():(new T).e((new yi).sd(b.Qa(),b.yb(),b.Qc()))).g()||zl((new Al).mc(357),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDefn")));Pk(b)&&((null===b?S():(new T).e(sn(new tn,b.Qa(),b.nc(),b.lc(),b.jh(),b.Qc()))).g()||zl((new Al).mc(358),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDefn")));
Qk(b)&&((null===b?S():(new T).e((new al).yd(b.Qa(),b.nc(),b.lc(),Rk(b)))).g()||zl((new Al).mc(359),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDefn")));Nk(b)&&((null===b?S():(new T).e((new al).yd(b.Qa(),b.Xd(),b.sc(),b.Ld()))).g()||zl((new Al).mc(360),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDefn")));Sk(b)&&((null===b?S():(new T).e((new al).yd(b.Qa(),b.Xd(),b.sc(),Tk(b)))).g()||zl((new Al).mc(369),(new Bl).j("ch.epfl.scala.accessible.Describe.describeDefn")));throw(new p).e(b);
}else if(b&&b.$classData&&b.$classData.H.Ce)a=Hba(b);else{if(b&&b.$classData&&b.$classData.H.zo)throw Dn(b)&&((null===b?S():(new T).e((new q).a(b.Re(),b.Ld()))).g()||zl((new Al).mc(401),(new Bl).j("ch.epfl.scala.accessible.Describe.describeEnum"))),En(b)&&((null===b?S():(new T).e(b.oi())).g()||zl((new Al).mc(402),(new Bl).j("ch.epfl.scala.accessible.Describe.describeEnum"))),Fn(b)&&((null===b?S():(new T).e((new q).a(b.Re(),b.Ld()))).g()||zl((new Al).mc(403),(new Bl).j("ch.epfl.scala.accessible.Describe.describeEnum"))),
(new p).e(b);if(b&&b.$classData&&b.$classData.H.vw)if(Gn(b)&&!(null===b?S():(new T).e((new yi).sd(b.Qa(),b.xb(),b.bd()))).g())a="";else throw Hn(b)&&((null===b?S():(new T).e(sn(new tn,b.Qa(),b.xb(),b.bd(),b.ff(),b.ub()))).g()||zl((new Al).mc(414),(new Bl).j("ch.epfl.scala.accessible.Describe.describeCtor"))),(new p).e(b);else{if(In(b)||Jn(b)||b&&b.$classData&&b.$classData.H.rn)throw In(b)&&((null===b?S():(new T).e(Kn(b))).g()||zl((new Al).mc(419),(new Bl).j("ch.epfl.scala.accessible.Describe.describeImports"))),
Ln(b)&&((null===b?S():(new T).e(b.xb())).g()||zl((new Al).mc(420),(new Bl).j("ch.epfl.scala.accessible.Describe.describeImports"))),Mn(b)&&((null===b?S():(new T).e((new q).a(b.xb(),Nn(b)))).g()||zl((new Al).mc(421),(new Bl).j("ch.epfl.scala.accessible.Describe.describeImports"))),On(b)&&((null===b?S():(new T).e(b.xb())).g()||zl((new Al).mc(422),(new Bl).j("ch.epfl.scala.accessible.Describe.describeImports"))),Pn(b)&&zl((new Al).mc(423),(new Bl).j("ch.epfl.scala.accessible.Describe.describeImports")),
Jn(b)&&((null===b?S():(new T).e((new q).a(b.ve(),b.Tk()))).g()||zl((new Al).mc(424),(new Bl).j("ch.epfl.scala.accessible.Describe.describeImports"))),(new p).e(b);a=Gba(a,b)}}return a}function zl(a,b){var c=new Qn;c.OB=a;c.Jh=b;Rn.prototype.fd.call(c,null,null);throw c;}dl.prototype.$classData=l({vG:0},!1,"ch.epfl.scala.accessible.Describe$",{vG:1,f:1});var Sn=void 0;function Jl(){Sn||(Sn=(new dl).c());return Sn}function Tn(){}Tn.prototype=new m;Tn.prototype.constructor=Tn;
function Un(a,b,c,d){if(d.cb||b)Xc.stop(),a=(new cd).j(a),a=Vn(Wn(),a.ka,0,100),b={punct:null,speed:250},b.punct=c,Xc.speak(a,b)}Tn.prototype.c=function(){return this};function Xn(a){return function(a){return function(c){a.Ea(c)}}(a)}
function Yn(a,b){return function(a,b){return function(f){Oba();var g=f.getDoc(),h=f.getDoc(),n=h.getValue(),u=Il(),n=Zn($n(u,n));a:{if(ao(n)&&(u=bo(co().qp,n),!u.g())){n=u.q();u=h.listSelections();if(1<=(u.length|0))var w=eo((new fo).d(u)),u=h.indexFromPos(w.anchor)|0,h=h.indexFromPos(w.head)|0,h=(new ad).K(u,h);else u=h.getCursor(),h=h.indexFromPos(u)|0,h=(new ad).K(h,h);try{var D=yba(Xk(),n,h),N=b.Ea(D);go(f,vaa(N));var Q=Jl(),ea=N.fa(),ba=el(Q,ea),ma=(new cd).j(ba);if(cj(ma))Un(ba,!1,!1,a);else{var La=
vaa(N),Pa=g.posFromIndex(La.E),Qa=g.posFromIndex(La.Ca),Ka=g.getRange(Pa,Qa);Un(Ka,!1,!0,a)}break a}catch(Ba){if(f=vj(wj(),Ba),null!==f){g=ho(io(),f);if(g.g())throw jo(wj(),f);ko(g.q());break a}else throw Ba;}}if(lo(n)&&(g=mo(co().jp,n),!g.g())){D=g.q().Bb;g=g.q().qb;D=(new ad).K(D.ab(),D.wa());Un(g,!1,!0,a);go(f,D);break a}throw(new p).e(n);}}}(b,a)}
function go(a,b){var c=a.getDoc(),d=c.posFromIndex(b.E);b=c.posFromIndex(b.Ca);c.setSelection(d,b,{scroll:!1,origin:"meta"});a.scrollIntoView(d,10)}Tn.prototype.$classData=l({xG:0},!1,"ch.epfl.scala.accessible.Main$",{xG:1,f:1});var no=void 0;function Oba(){no||(no=(new Tn).c());return no}function oo(){this.fn=null}oo.prototype=new m;oo.prototype.constructor=oo;oo.prototype.c=function(){this.fn="\n";return this};function Pba(a){return(new cd).j(a).ka.split(".").join(" ")}
oo.prototype.wp=function(a,b){a:{b=(new T).e(b);if(zh(b)){b=b.Y;a=Jba(Kba(),a,b);if(zh(a)){a=Qba(this,a.Y);break a}if(S()===a){a="cannot find tree";break a}throw(new p).e(a);}if(S()===b)a=po(this,a);else throw(new p).e(b);}return a};
function jk(a,b){return Nk(b)&&(a=null===b?S():(new T).e((new al).yd(b.Qa(),b.Xd(),b.sc(),b.Ld())),!a.g()&&(a=a.q().qb,G(),a=(new T).e(a),null!==a.Y&&0===qo(a.Y,1)&&(a=ro(a.Y,0),ln(a)&&(a=null===a?S():(new T).e(a.yb()),!a.g()))))||Sk(b)&&(a=null===b?S():(new T).e((new al).yd(b.Qa(),b.Xd(),b.sc(),Tk(b))),!a.g()&&(a=a.q().qb,G(),a=(new T).e(a),null!==a.Y&&0===qo(a.Y,1)&&(a=ro(a.Y,0),ln(a)&&(a=null===a?S():(new T).e(a.yb()),!a.g()))))?"val "+a.q():Gk(b)?"def "+b.yb():Kk(b)?"macro "+b.yb():Qk(b)?"type "+
b.nc():Ok(b)?"class "+b.nc():Pk(b)?"trait "+b.nc():Lk(b)?"object "+b.yb():Mk(b)?"package object "+b.yb():Ql(b)?"package "+b.ve():vn(b)&&(a=null===b?S():(new T).e((new yi).sd(b.Qa(),b.Xd(),b.df())),!a.g()&&(a=a.q().qb,G(),a=(new T).e(a),null!==a.Y&&0===qo(a.Y,1)&&(a=ro(a.Y,0),ln(a)&&(a=null===a?S():(new T).e(a.yb()),!a.g()))))?"val "+a.q():wn(b)&&(a=null===b?S():(new T).e((new yi).sd(b.Qa(),b.Xd(),b.df())),!a.g()&&(a=a.q().qb,G(),a=(new T).e(a),null!==a.Y&&0===qo(a.Y,1)&&(a=ro(a.Y,0),ln(a)&&(a=null===
a?S():(new T).e(a.yb()),!a.g()))))?"var "+a.q():rn(b)?"def "+b.yb():un(b)?"type "+b.nc():""}function Qba(a,b){if(Lk(b))return so(a,"object",b.yb().ec(),b.Qc().ub());if(Ok(b))return so(a,"class",b.nc().ec(),b.Qc().ub());if(Ql(b)){var c=b.ve();return so(a,"package",Pba(to(uo(),c)),b.ub())}return Mk(b)?so(a,"package object",b.yb().ec(),b.Qc().ub()):Tl(b)?Rba(a,b.ub()):jk(0,b)}
function po(a,b){if(Sl(b)){var c=null===b?S():(new T).e(b.ub());if(!c.g()){c=c.q();b=function(){return function(a){return po(kk(),a)}}(a);var d=G().b;if(d===G().b)if(c===F())b=F();else{for(var d=c.n(),f=d=U(new V,b(d),F()),c=c.o();c!==F();)var g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();b=d}else{for(d=zg(c,d);!c.g();)f=c.n(),d.ba(b(f)),c=c.o();b=d.da()}return b.mh(lk(function(){return function(a){a=(new cd).j(a);return cj(a)}}(a))).le("",","+a.fn,".")}}if(Ql(b)&&(c=null===b?S():(new T).e((new q).a(b.ve(),
b.ub())),!c.g())){b=c.q().qa();f=c.q().p();b=Pba(to(uo(),b));c=a.fn;d=function(){return function(a){return po(kk(),a)}}(a);g=G().b;if(g===G().b)if(f===F())d=F();else{for(var g=f.n(),h=g=U(new V,d(g),F()),f=f.o();f!==F();)var n=f.n(),n=U(new V,d(n),F()),h=h.ga=n,f=f.o();d=g}else{for(g=zg(f,g);!f.g();)h=f.n(),g.ba(d(h)),f=f.o();d=g.da()}return"package "+b+"."+c+d.mh(lk(function(){return function(a){a=(new cd).j(a);return cj(a)}}(a))).le("",","+a.fn,"")}if(Mk(b))return"package object "+b.yb();if(Lk(b))return"object "+
b.yb();if(Ok(b))return"class "+b.nc();if(Pk(b))return"trait "+b.nc();if(In(b))return"";a="** Missing: "+ra(b).v()+" **";xo||(xo=(new yo).c());zo(xo.XB.Qo,a+"\n");return""}
function Rba(a,b){var c=function(){return function(a){return jk(kk(),a)}}(a),d=G().b;if(d===G().b)if(b===F())c=F();else{var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g;b=b.o()}c=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();c=d.da()}c=c.mh(lk(function(){return function(a){a=(new cd).j(a);return cj(a)}}(a))).le("",","+a.fn,".");return""+(-1!==(c.indexOf(a.fn)|0)?a.fn:" ")+c}function so(a,b,c,d){return b+" "+c+":"+Rba(a,d)}
oo.prototype.$classData=l({yG:0},!1,"ch.epfl.scala.accessible.Summary$",{yG:1,f:1});var Ao=void 0;function kk(){Ao||(Ao=(new oo).c());return Ao}function Bo(){}Bo.prototype=new m;Bo.prototype.constructor=Bo;Bo.prototype.c=function(){return this};function Sba(a,b,c){b.on("change",function(a){return function(b,c){return a.ug(b,c)}}(c))}function Tba(a,b,c){b.on("beforeSelectionChange",function(a){return function(b,c){return a.ug(b,c)}}(c))}
function Uba(a,b,c){b.on("keydown",function(a){return function(b,c){return a.ug(b,c)}}(c))}Bo.prototype.$classData=l({BG:0},!1,"codemirror.CodeMirrorExtensions$EditorEventHandler$",{BG:1,f:1});var Co=void 0;function Do(){Co||(Co=(new Bo).c());return Co}function Eo(){}Eo.prototype=new m;Eo.prototype.constructor=Eo;Eo.prototype.c=function(){return this};function Vba(a,b,c){return(b.line|0)<=(c.line|0)&&(b.ch|0)<(c.ch|0)}
Eo.prototype.$classData=l({CG:0},!1,"codemirror.CodeMirrorExtensions$PositionExtensions$",{CG:1,f:1});var Fo=void 0;function Wba(){Fo||(Fo=(new Eo).c());return Fo}function Go(){}Go.prototype=new m;Go.prototype.constructor=Go;Go.prototype.c=function(){return this};function Xba(a){if(null===a)throw(new p).e(a);var b=a.qa();a=a.p();return Vba(Wba(),b,a)?(new q).a(b,a):(new q).a(a,b)}Go.prototype.$classData=l({DG:0},!1,"codemirror.CodeMirrorExtensions$PositionTupleExtensions$",{DG:1,f:1});var Yba=void 0;
function Ho(){this.yy=this.Ba=this.op=null}Ho.prototype=new m;Ho.prototype.constructor=Ho;function Zba(){}Zba.prototype=Ho.prototype;function Io(){this.r=null}Io.prototype=new m;Io.prototype.constructor=Io;function $ba(){}$ba.prototype=Io.prototype;Io.prototype.wv=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};function Jo(){this.r=null}Jo.prototype=new m;Jo.prototype.constructor=Jo;function aca(){}aca.prototype=Jo.prototype;
Jo.prototype.wv=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};function Ko(){this.ra=0}Ko.prototype=new m;Ko.prototype.constructor=Ko;Ko.prototype.c=function(){return this};Ko.prototype.$classData=l({EG:0},!1,"fastparse.CharPredicates$",{EG:1,f:1});var bca=void 0;function Lo(){this.ka=null}Lo.prototype=new m;Lo.prototype.constructor=Lo;function cca(){}cca.prototype=Lo.prototype;Lo.prototype.Ne=function(a){this.ka=a;return this};
function Mo(){this.mp=this.Ez=this.um=this.Rx=this.Vt=0}Mo.prototype=new m;Mo.prototype.constructor=Mo;Mo.prototype.c=function(){this.Vt=1;this.Rx=6;this.um=9;this.Ez=10;this.mp=11;return this};function No(a,b,c){return b.Fk()>=c?b.v():"("+b+")"}Mo.prototype.$classData=l({UG:0},!1,"fastparse.core.Precedence$",{UG:1,f:1});var Oo=void 0;function Po(){Oo||(Oo=(new Mo).c());return Oo}function Qo(){}Qo.prototype=new m;Qo.prototype.constructor=Qo;Qo.prototype.c=function(){return this};
function dca(a,b){b=b.Jb();b=Ro(new So,b,lk(function(){return function(a){return a.Jb()}}(a)));a=To().OF;b=(new Uo).Lv(b).eG.ah();a=(new Vo).Lv(Ro(new So,b,a));return eca(new Wo,fca(a))}function gca(a,b,c,d){var f=(new yd).X((new r).d(["","(",")"]));a=lk(function(){return function(a){return a.Of()}}(a,d));d=Xo();c=c.yf(a,d.b).Of();return td(f,(new r).d([b,Yo(c)]))}Qo.prototype.$classData=l({ZG:0},!1,"fastparse.parsers.Intrinsics$",{ZG:1,f:1});var Zo=void 0;
function $o(){Zo||(Zo=(new Qo).c());return Zo}function ap(){}ap.prototype=new m;ap.prototype.constructor=ap;ap.prototype.c=function(){return this};ap.prototype.$classData=l({aH:0},!1,"fastparse.parsers.Terminals$",{aH:1,f:1});var hca=void 0;function bp(){}bp.prototype=new m;bp.prototype.constructor=bp;function ica(){}ica.prototype=bp.prototype;function cp(){}cp.prototype=new m;cp.prototype.constructor=cp;function jca(){}jca.prototype=cp.prototype;function dp(){}dp.prototype=new m;
dp.prototype.constructor=dp;function kca(){}kca.prototype=dp.prototype;function ep(){}ep.prototype=new m;ep.prototype.constructor=ep;ep.prototype.c=function(){return this};ep.prototype.$classData=l({iH:0},!1,"fastparse.utils.Utils$",{iH:1,f:1});var lca=void 0;function fp(){}fp.prototype=new m;fp.prototype.constructor=fp;fp.prototype.c=function(){return this};fp.prototype.$classData=l({kH:0},!1,"fastparse.utils.Utils$BitSet$",{kH:1,f:1});var mca=void 0;function gp(){}gp.prototype=new m;
gp.prototype.constructor=gp;gp.prototype.c=function(){return this};function nca(){oca||(oca=(new gp).c());var a=pca();void 0!==a.sw&&void 0!==a.sw.cwd()?(a=pca(),0===(4&a.ra)&&0===(4&a.ra)&&(0===(1&a.ra)&&0===(1&a.ra)&&(a.TB=ca,a.ra|=1),a.bl=a.TB.require("path"),a.ra|=4),a=a.bl.sep):a="/";return a}gp.prototype.$classData=l({mH:0},!1,"java.io.File$",{mH:1,f:1});var oca=void 0;function hp(){this.lt=this.kt=null}hp.prototype=new m;hp.prototype.constructor=hp;
function ip(a,b,c){a.kt=b;a.lt=c;return a}hp.prototype.$classData=l({rH:0},!1,"java.math.BigInteger$QuotAndRem",{rH:1,f:1});function jp(){}jp.prototype=new m;jp.prototype.constructor=jp;jp.prototype.c=function(){return this};function qca(a,b,c,d){a=0;var f=-1+d|0;if(!(0>=d))for(var g=0;;){var h=g,n=c.i[h];b.i[h]=n<<1|a;a=n>>>31|0;if(g===f)break;g=1+g|0}0!==a&&(b.i[d]=a)}
function rca(a,b,c){a=c>>5;c&=31;var d=(b.Jc+a|0)+(0===c?0:1)|0,f=oa(bc(yc),[d]);kp(0,f,b.Sb,a,c);b=lp(new mp,b.oc,d,f);np(b);return b}function sca(a,b,c){a=c>>5;var d=31&c;if(a>=b.Jc)return 0>b.oc?vp().Lr:vp().Tj;c=b.Jc-a|0;var f=oa(bc(yc),[1+c|0]);tca(0,f,c,b.Sb,a,d);if(0>b.oc){for(var g=0;g<a&&0===b.Sb.i[g];)g=1+g|0;var h=0!==b.Sb.i[g]<<(32-d|0);if(g<a||0<d&&h){for(g=0;g<c&&-1===f.i[g];)f.i[g]=0,g=1+g|0;g===c&&(c=1+c|0);a=g;f.i[a]=1+f.i[a]|0}}b=lp(new mp,b.oc,c,f);np(b);return b}
function wp(a,b){if(0===b.oc)return 0;a=b.Jc<<5;var c=b.Sb.i[-1+b.Jc|0];0>b.oc&&xp(b)===(-1+b.Jc|0)&&(c=-1+c|0);return a=a-ha(c)|0}function tca(a,b,c,d,f,g){for(a=0;a<f;)a=1+a|0;if(0===g)Ta(d,f,b,0,c);else{var h=32-g|0;for(a=0;a<(-1+c|0);)b.i[a]=d.i[a+f|0]>>>g|0|d.i[1+(a+f|0)|0]<<h,a=1+a|0;b.i[a]=d.i[a+f|0]>>>g|0}}
function kp(a,b,c,d,f){if(0===f)Ta(c,0,b,d,b.i.length-d|0);else{a=32-f|0;b.i[-1+b.i.length|0]=0;for(var g=-1+b.i.length|0;g>d;){var h=g;b.i[h]=b.i[h]|c.i[-1+(g-d|0)|0]>>>a|0;b.i[-1+g|0]=c.i[-1+(g-d|0)|0]<<f;g=-1+g|0}}c=-1+d|0;if(!(0>=d))for(d=0;;){b.i[d]=0;if(d===c)break;d=1+d|0}}jp.prototype.$classData=l({sH:0},!1,"java.math.BitLevel$",{sH:1,f:1});var yp=void 0;function zp(){yp||(yp=(new jp).c());return yp}function Ap(){this.ey=this.ty=null}Ap.prototype=new m;Ap.prototype.constructor=Ap;
Ap.prototype.c=function(){Bp=this;var a=(new r).d([-1,-1,31,19,15,13,11,11,10,9,9,8,8,8,8,7,7,7,7,7,7,7,6,6,6,6,6,6,6,6,6,6,6,6,6,6,5]),b=a.Da.length|0,b=oa(bc(yc),[b]),c;c=0;for(a=Cp(new Dp,a,a.Da.length|0);a.fb();){var d=a.bb();b.i[c]=d|0;c=1+c|0}this.ty=b;a=(new r).d([-2147483648,1162261467,1073741824,1220703125,362797056,1977326743,1073741824,387420489,1E9,214358881,429981696,815730721,1475789056,170859375,268435456,410338673,612220032,893871739,128E7,1801088541,113379904,148035889,191102976,
244140625,308915776,387420489,481890304,594823321,729E6,887503681,1073741824,1291467969,1544804416,1838265625,60466176]);b=a.Da.length|0;b=oa(bc(yc),[b]);c=0;for(a=Cp(new Dp,a,a.Da.length|0);a.fb();)d=a.bb(),b.i[c]=d|0,c=1+c|0;this.ey=b;return this};
function uca(a,b,c){if(0===b.Ra&&0===b.Ya)switch(c){case 0:return"0";case 1:return"0.0";case 2:return"0.00";case 3:return"0.000";case 4:return"0.0000";case 5:return"0.00000";case 6:return"0.000000";default:return(0>c?"0E+":"0E")+(-2147483648===c?"2147483648":""+(-c|0))}else{a=0>b.Ya;var d;d="";var f=18;if(a){var g=b.Ra;b=b.Ya;b=(new Ep).K(-g|0,0!==g?~b:-b|0)}for(var g=b.Ra,h=b.Ya;;){b=g;var n=h,h=ab(),g=Fp(h,g,n,10,0),h=h.dd,f=-1+f|0,n=h,u=g,w=u>>>16|0,u=fa(10,65535&u),w=fa(10,w),w=u+(w<<16)|0;fa(10,
n);d=""+(new ed).db(65535&(48+(b-w|0)|0))+d;b=h;if(0===g&&0===b)break}b=-1+((18-f|0)-c|0)|0;if(0<c&&-6<=b)if(c=1+b|0,0<c)d=d.substring(0,c)+"."+d.substring(c);else{f=-c|0;c=-1+f|0;if(!(0>=f))for(f=0;;){d=""+(new ed).db(48)+d;if(f===c)break;f=1+f|0}d="0."+d}else 0!==c&&(c=""+b,0<b&&(c=""+(new ed).db(43)+c),c=""+(new ed).db(69)+c,1<(18-f|0)?(f=65535&(d.charCodeAt(0)|0),d=(new ed).db(f)+"."+d.substring(1)+c):d=""+d+c);return a?""+(new ed).db(45)+d:d}}
function Gp(a,b){a=b.oc;var c=b.Jc,d=b.Sb;if(0===a)return"0";if(1===c)return b=(+(d.i[0]>>>0)).toString(10),0>a?"-"+b:b;b="";var f=oa(bc(yc),[c]);Ta(d,0,f,0,c);do{for(var g=0,d=-1+c|0;0<=d;){var h=g,g=f.i[d],n=Hp(ab(),g,h,1E9,0);f.i[d]=n;var h=n>>31,u=65535&n,n=n>>>16|0,w=fa(51712,u),u=fa(15258,u),D=fa(51712,n),w=w+((u+D|0)<<16)|0;fa(1E9,h);fa(15258,n);g=g-w|0;d=-1+d|0}d=""+g;for(b="000000000".substring(d.length|0)+d+b;0!==c&&0===f.i[-1+c|0];)c=-1+c|0}while(0!==c);f=0;for(c=b.length|0;;)if(f<c&&48===
(65535&(b.charCodeAt(f)|0)))f=1+f|0;else break;b=b.substring(f);return 0>a?""+(new ed).db(45)+b:b}Ap.prototype.$classData=l({tH:0},!1,"java.math.Conversion$",{tH:1,f:1});var Bp=void 0;function Ip(){Bp||(Bp=(new Ap).c());return Bp}function Jp(){}Jp.prototype=new m;Jp.prototype.constructor=Jp;Jp.prototype.c=function(){return this};
function vca(a,b,c,d,f,g,h){a=oa(bc(yc),[1+f|0]);var n=oa(bc(yc),[1+h|0]),u=ha(g.i[-1+h|0]);0!==u?(kp(zp(),n,g,0,u),kp(zp(),a,d,0,u)):(Ta(d,0,a,0,f),Ta(g,0,n,0,h));d=n.i[-1+h|0];for(c=-1+c|0;0<=c;){if(a.i[f]===d)g=-1;else{var w=a.i[f],D=a.i[-1+f|0];g=ab();var N=Hp(g,D,w,d,0),w=g.dd;g=N;var Q=65535&N,N=N>>>16|0,ea=65535&d,ba=d>>>16|0,ma=fa(Q,ea),ea=fa(N,ea),Q=fa(Q,ba),Q=ma+((ea+Q|0)<<16)|0;fa(w,d);fa(N,ba);D=D-Q|0;if(0!==g)a:for(g=1+g|0;;){N=g=-1+g|0;ba=n.i[-2+h|0];w=65535&N;N=N>>>16|0;ma=65535&ba;
ba=ba>>>16|0;Q=fa(w,ma);ma=fa(N,ma);ea=fa(w,ba);w=Q+((ma+ea|0)<<16)|0;Q=(Q>>>16|0)+ea|0;Q=(fa(N,ba)+(Q>>>16|0)|0)+(((65535&Q)+ma|0)>>>16|0)|0;ba=D;N=a.i[-2+f|0];ma=D+d|0;if(0===((-2147483648^ma)<(-2147483648^D)?1:0)&&(D=ma,Q^=-2147483648,ba^=-2147483648,Q===ba?(-2147483648^w)>(-2147483648^N):Q>ba))continue a;break}}if(D=0!==g){Kp();var D=a,w=f-h|0,ba=n,N=h,Q=g,La;La=0;var Pa;Pa=0;ma=-1+N|0;if(!(0>=N))for(ea=0;;){var Qa=ea;Lp();var Ka=ba.i[Qa],Ba=65535&Ka,Ka=Ka>>>16|0,va=65535&Q,za=Q>>>16|0,qa=fa(Ba,
va),va=fa(Ka,va),la=fa(Ba,za),Ba=qa+((va+la|0)<<16)|0,qa=(qa>>>16|0)+la|0,za=(fa(Ka,za)+(qa>>>16|0)|0)+(((65535&qa)+va|0)>>>16|0)|0,Ka=Ba+La|0;La=(-2147483648^Ka)<(-2147483648^Ba)?1+za|0:za;za=D.i[w+Qa|0];Ka=za-Ka|0;za=(-2147483648^Ka)>(-2147483648^za)?-1:0;Ba=Pa;Pa=Ba>>31;Ba=Ka+Ba|0;Pa=(-2147483648^Ba)<(-2147483648^Ka)?1+(za+Pa|0)|0:za+Pa|0;D.i[w+Qa|0]=Ba;if(ea===ma)break;ea=1+ea|0}Q=D.i[w+N|0];ba=Q-La|0;Q=(-2147483648^ba)>(-2147483648^Q)?-1:0;ea=Pa;ma=ea>>31;ea=ba+ea|0;D.i[w+N|0]=ea;D=0!==((-2147483648^
ea)<(-2147483648^ba)?1+(Q+ma|0)|0:Q+ma|0)}if(D&&(g=-1+g|0,ea=ma=0,D=-1+h|0,!(0>=h)))for(w=0;;){N=w;Q=a.i[(f-h|0)+N|0];ba=Q+n.i[N]|0;Q=(-2147483648^ba)<(-2147483648^Q)?1:0;ba=ma+ba|0;Q=(-2147483648^ba)<(-2147483648^ma)?1+(ea+Q|0)|0:ea+Q|0;ma=ba;ea=Q;a.i[(f-h|0)+N|0]=ma;ma=ea;ea=0;if(w===D)break;w=1+w|0}null!==b&&(b.i[c]=g);f=-1+f|0;c=-1+c|0}return 0!==u?(tca(zp(),n,h,a,0,u),n):(Ta(a,0,n,0,h),a)}
function wca(a,b,c,d,f){a=0;for(d=-1+d|0;0<=d;){var g=a;a=c.i[d];var h=ab(),g=Hp(h,a,g,f,0),h=h.dd,n=65535&g,u=g>>>16|0,w=65535&f,D=f>>>16|0,N=fa(n,w),w=fa(u,w),n=fa(n,D),N=N+((w+n|0)<<16)|0;fa(h,f);fa(u,D);a=a-N|0;b.i[d]=g;d=-1+d|0}return a}Jp.prototype.$classData=l({uH:0},!1,"java.math.Division$",{uH:1,f:1});var Mp=void 0;function Kp(){Mp||(Mp=(new Jp).c());return Mp}function Np(){}Np.prototype=new m;Np.prototype.constructor=Np;Np.prototype.c=function(){return this};
function Op(a,b,c,d){for(var f=oa(bc(yc),[b]),g=0,h=0;g<d;){var n=a.i[g],u=n-c.i[g]|0,n=(-2147483648^u)>(-2147483648^n)?-1:0,w=h,h=w>>31,w=u+w|0,u=(-2147483648^w)<(-2147483648^u)?1+(n+h|0)|0:n+h|0;f.i[g]=w;h=u;g=1+g|0}for(;g<b;)c=a.i[g],u=h,d=u>>31,u=c+u|0,c=(-2147483648^u)<(-2147483648^c)?1+d|0:d,f.i[g]=u,h=c,g=1+g|0;return f}function Pp(a,b,c,d){for(a=-1+d|0;0<=a&&b.i[a]===c.i[a];)a=-1+a|0;return 0>a?0:(-2147483648^b.i[a])<(-2147483648^c.i[a])?-1:1}
function Qp(a,b,c,d){var f=oa(bc(yc),[1+b|0]),g=1,h=a.i[0],n=h+c.i[0]|0;f.i[0]=n;h=(-2147483648^n)<(-2147483648^h)?1:0;if(b>=d){for(;g<d;){var u=a.i[g],n=u+c.i[g]|0,u=(-2147483648^n)<(-2147483648^u)?1:0,h=n+h|0,n=(-2147483648^h)<(-2147483648^n)?1+u|0:u;f.i[g]=h;h=n;g=1+g|0}for(;g<b;)c=a.i[g],d=c+h|0,c=(-2147483648^d)<(-2147483648^c)?1:0,f.i[g]=d,h=c,g=1+g|0}else{for(;g<b;)u=a.i[g],n=u+c.i[g]|0,u=(-2147483648^n)<(-2147483648^u)?1:0,h=n+h|0,n=(-2147483648^h)<(-2147483648^n)?1+u|0:u,f.i[g]=h,h=n,g=1+
g|0;for(;g<d;)a=c.i[g],b=a+h|0,a=(-2147483648^b)<(-2147483648^a)?1:0,f.i[g]=b,h=a,g=1+g|0}0!==h&&(f.i[g]=h);return f}
function Rp(a,b,c){a=b.oc;var d=c.oc,f=b.Jc,g=c.Jc;if(0===a)return c;if(0===d)return b;if(2===(f+g|0)){b=b.Sb.i[0];c=c.Sb.i[0];if(a===d)return d=b+c|0,c=(-2147483648^d)<(-2147483648^b)?1:0,0===c?(new mp).K(a,d):lp(new mp,a,2,Sp(Tp(),d,(new r).d([c])));d=vp();0>a?(a=b=c-b|0,c=(-2147483648^b)>(-2147483648^c)?-1:0):(a=c=b-c|0,c=(-2147483648^c)>(-2147483648^b)?-1:0);return Up(d,(new Ep).K(a,c))}if(a===d)d=f>=g?Qp(b.Sb,f,c.Sb,g):Qp(c.Sb,g,b.Sb,f);else{var h=f!==g?f>g?1:-1:Pp(0,b.Sb,c.Sb,f);if(0===h)return vp().Tj;
1===h?d=Op(b.Sb,f,c.Sb,g):(c=Op(c.Sb,g,b.Sb,f),a=d,d=c)}a=lp(new mp,a|0,d.i.length,d);np(a);return a}
function Vp(a,b,c){var d=b.oc;a=c.oc;var f=b.Jc,g=c.Jc;if(0===a)return b;if(0===d)return Wp(c);if(2===(f+g|0))return b=b.Sb.i[0],f=0,c=c.Sb.i[0],g=0,0>d&&(d=b,b=-d|0,f=0!==d?~f:-f|0),0>a&&(a=c,d=g,c=-a|0,g=0!==a?~d:-d|0),a=vp(),d=b,b=f,f=g,c=d-c|0,Up(a,(new Ep).K(c,(-2147483648^c)>(-2147483648^d)?-1+(b-f|0)|0:b-f|0));var h=f!==g?f>g?1:-1:Pp(Xp(),b.Sb,c.Sb,f);if(d===a&&0===h)return vp().Tj;-1===h?(c=d===a?Op(c.Sb,g,b.Sb,f):Qp(c.Sb,g,b.Sb,f),a=-a|0):(c=d===a?Op(b.Sb,f,c.Sb,g):Qp(b.Sb,f,c.Sb,g),a=d);
a=lp(new mp,a|0,c.i.length,c);np(a);return a}Np.prototype.$classData=l({vH:0},!1,"java.math.Elementary$",{vH:1,f:1});var Yp=void 0;function Xp(){Yp||(Yp=(new Np).c());return Yp}function rj(){this.Hk=0;this.Rl=null}rj.prototype=new m;rj.prototype.constructor=rj;rj.prototype.w=function(a){return a&&a.$classData&&a.$classData.H.hz?this.Hk===a.Hk?this.Rl===a.Rl:!1:!1};rj.prototype.v=function(){return"precision\x3d"+this.Hk+" roundingMode\x3d"+this.Rl};rj.prototype.A=function(){return this.Hk<<3|this.Rl.Yx};
rj.prototype.$classData=l({hz:0},!1,"java.math.MathContext",{hz:1,f:1});function Zp(){this.sy=null}Zp.prototype=new m;Zp.prototype.constructor=Zp;Zp.prototype.c=function(){$p=this;aq();var a=sj().kp,b=new rj;b.Hk=34;b.Rl=a;this.sy=b;aq();sj();aq();sj();aq();sj();return this};Zp.prototype.$classData=l({wH:0},!1,"java.math.MathContext$",{wH:1,f:1});var $p=void 0;function aq(){$p||($p=(new Zp).c());return $p}function bq(){this.ol=this.pl=null}bq.prototype=new m;bq.prototype.constructor=bq;
bq.prototype.c=function(){cq=this;xca(10,10);xca(14,5);this.pl=oa(bc(dq),[32]);this.ol=oa(bc(dq),[32]);var a,b;a=1;for(var c=b=0;;){var d=c;if(18>=d){Lp().ol.i[d]=Up(vp(),(new Ep).K(a,b));var f=Lp().pl,g=vp(),h=a,n=b;f.i[d]=Up(g,(new Ep).K(0===(32&d)?h<<d:0,0===(32&d)?(h>>>1|0)>>>(31-d|0)|0|n<<d:h<<d));d=a;a=d>>>16|0;d=fa(5,65535&d);f=fa(5,a);a=d+(f<<16)|0;d=(d>>>16|0)+f|0;b=fa(5,b)+(d>>>16|0)|0}else Lp().ol.i[d]=eq(Lp().ol.i[-1+d|0],Lp().ol.i[1]),Lp().pl.i[d]=eq(Lp().pl.i[-1+d|0],vp().xm);if(31===
c)break;c=1+c|0}return this};
function yca(a,b,c){var d,f=-1+b|0;if(!(0>=b))for(var g=0;;){var h=g;d=0;var n=1+h|0,u=-1+b|0;if(!(n>=b))for(;;){var w=n;Lp();var D=a.i[h],N=a.i[w],Q=c.i[h+w|0],ea=65535&D,D=D>>>16|0,ba=65535&N,N=N>>>16|0,ma=fa(ea,ba),ba=fa(D,ba),La=fa(ea,N),ea=ma+((ba+La|0)<<16)|0,ma=(ma>>>16|0)+La|0,D=(fa(D,N)+(ma>>>16|0)|0)+(((65535&ma)+ba|0)>>>16|0)|0,Q=ea+Q|0,D=(-2147483648^Q)<(-2147483648^ea)?1+D|0:D;d=Q+d|0;Q=(-2147483648^d)<(-2147483648^Q)?1+D|0:D;c.i[h+w|0]=d;d=Q;if(n===u)break;n=1+n|0}c.i[h+b|0]=d;if(g===
f)break;g=1+g|0}qca(zp(),c,c,b<<1);for(g=f=d=0;f<b;)n=a.i[f],w=a.i[f],u=c.i[g],h=d,d=65535&n,n=n>>>16|0,D=65535&w,w=w>>>16|0,Q=fa(d,D),D=fa(n,D),N=fa(d,w),d=Q+((D+N|0)<<16)|0,Q=(Q>>>16|0)+N|0,n=(fa(n,w)+(Q>>>16|0)|0)+(((65535&Q)+D|0)>>>16|0)|0,u=d+u|0,n=(-2147483648^u)<(-2147483648^d)?1+n|0:n,h=u+h|0,u=(-2147483648^h)<(-2147483648^u)?1+n|0:n,c.i[g]=h,g=1+g|0,h=u+c.i[g]|0,u=(-2147483648^h)<(-2147483648^u)?1:0,c.i[g]=h,d=u,f=1+f|0,g=1+g|0;return c}
function xca(a,b){var c=oa(bc(yc),[-1+a|0]);a=[];var d,f=d=1;a.push(null===f?0:f);f=0;for(c=c.i.length;f<c;){var g=d=fa(d|0,b);a.push(null===g?0:g);f=1+f|0}na(bc(yc),a)}
function fq(a,b,c){if(c.Jc>b.Jc)var d=c;else d=b,b=c;c=d;var f=b;if(63>f.Jc){var g=c.Jc,d=f.Jc;b=g+d|0;a=c.oc!==f.oc?-1:1;if(2===b){d=c.Sb.i[0];b=f.Sb.i[0];c=65535&d;var d=d>>>16|0,h=65535&b;b=b>>>16|0;var f=fa(c,h),h=fa(d,h),n=fa(c,b);c=f+((h+n|0)<<16)|0;f=(f>>>16|0)+n|0;d=(fa(d,b)+(f>>>16|0)|0)+(((65535&f)+h|0)>>>16|0)|0;a=0===d?(new mp).K(a,c):lp(new mp,a,2,Sp(Tp(),c,(new r).d([d])))}else{c=c.Sb;f=f.Sb;h=oa(bc(yc),[b]);if(0!==g&&0!==d)if(1===g)h.i[d]=gq(0,h,f,d,c.i[0]);else if(1===d)h.i[g]=gq(0,
h,c,g,f.i[0]);else if(c===f&&g===d)yca(c,g,h);else if(n=-1+g|0,!(0>=g))for(g=0;;){var u=g,w;w=0;var D=c.i[u],N=-1+d|0;if(!(0>=d))for(var Q=0;;){var ea=Q;Lp();var ba=f.i[ea],ma=h.i[u+ea|0],La=65535&D,Pa=D>>>16|0,Qa=65535&ba,ba=ba>>>16|0,Ka=fa(La,Qa),Qa=fa(Pa,Qa),Ba=fa(La,ba),La=Ka+((Qa+Ba|0)<<16)|0,Ka=(Ka>>>16|0)+Ba|0,Pa=(fa(Pa,ba)+(Ka>>>16|0)|0)+(((65535&Ka)+Qa|0)>>>16|0)|0,ma=La+ma|0,Pa=(-2147483648^ma)<(-2147483648^La)?1+Pa|0:Pa;w=ma+w|0;ma=(-2147483648^w)<(-2147483648^ma)?1+Pa|0:Pa;h.i[u+ea|0]=
w;w=ma;if(Q===N)break;Q=1+Q|0}h.i[u+d|0]=w;if(g===n)break;g=1+g|0}a=lp(new mp,a,b,h);np(a)}return a}d=(-2&c.Jc)<<4;h=hq(c,d);n=hq(f,d);b=iq(h,d);g=Vp(Xp(),c,b);b=iq(n,d);f=Vp(Xp(),f,b);c=fq(a,h,n);b=fq(a,g,f);a=fq(a,Vp(Xp(),h,g),Vp(Xp(),f,n));f=c;a=Rp(Xp(),a,f);a=Rp(Xp(),a,b);a=iq(a,d);d=c=iq(c,d<<1);a=Rp(Xp(),d,a);return Rp(Xp(),a,b)}
function gq(a,b,c,d,f){var g;g=0;a=-1+d|0;if(!(0>=d))for(d=0;;){var h=d;Lp();var n=c.i[h],u=65535&n,n=n>>>16|0,w=65535&f,D=f>>>16|0,N=fa(u,w),w=fa(n,w),Q=fa(u,D),u=N+((w+Q|0)<<16)|0,N=(N>>>16|0)+Q|0,n=(fa(n,D)+(N>>>16|0)|0)+(((65535&N)+w|0)>>>16|0)|0;g=u+g|0;n=(-2147483648^g)<(-2147483648^u)?1+n|0:n;b.i[h]=g;g=n;if(d===a)break;d=1+d|0}return g}
function jq(a,b){var c=a.pl.i.length,d=c>>31,f=b.Ya;if(f===d?(-2147483648^b.Ra)<(-2147483648^c):f<d)return a.pl.i[b.Ra];c=b.Ya;if(0===c?-2147483598>=(-2147483648^b.Ra):0>c)return kq(vp().xm,b.Ra);c=b.Ya;if(0===c?-1>=(-2147483648^b.Ra):0>c)return iq(kq(a.ol.i[1],b.Ra),b.Ra);for(var g=kq(a.ol.i[1],2147483647),c=g,f=b.Ya,h=-2147483647+b.Ra|0,d=h,h=1>(-2147483648^h)?f:-1+f|0,f=lq(ab(),b.Ra,b.Ya,2147483647,0);;){var n=d,u=h;if(0===u?-1<(-2147483648^n):0<u)c=eq(c,g),d=-2147483647+d|0,h=1>(-2147483648^d)?
h:-1+h|0;else break}c=eq(c,kq(a.ol.i[1],f));c=iq(c,2147483647);a=b.Ya;d=b=-2147483647+b.Ra|0;for(h=1>(-2147483648^b)?a:-1+a|0;;)if(b=d,a=h,0===a?-1<(-2147483648^b):0<a)c=iq(c,2147483647),b=h,a=-2147483647+d|0,b=1>(-2147483648^a)?b:-1+b|0,d=a,h=b;else break;return iq(c,f)}bq.prototype.$classData=l({xH:0},!1,"java.math.Multiplication$",{xH:1,f:1});var cq=void 0;function Lp(){cq||(cq=(new bq).c());return cq}function mq(){this.ml=this.kb=this.jc=this.Jj=0}mq.prototype=new m;mq.prototype.constructor=mq;
function nq(){}e=nq.prototype=mq.prototype;e.Pc=function(a){if(0>a||a>this.jc)throw(new t).c();this.kb=a;this.ml>a&&(this.ml=-1);return this};e.v=function(){return td((new yd).X((new r).d(["","[pos\x3d"," lim\x3d"," cap\x3d","]"])),(new r).d([Md(ra(this)),this.kb,this.jc,this.Jj]))};e.Un=function(){this.ml=-1;this.jc=this.kb;this.kb=0;return this};e.eA=function(){this.ml=-1;this.kb=0;this.jc=this.Jj;return this};
e.ct=function(a){if(0>a||a>this.Jj)throw(new t).c();this.jc=a;this.kb>a&&(this.kb=a,this.ml>a&&(this.ml=-1));return this};e.mc=function(a){this.jc=this.Jj=a;this.kb=0;this.ml=-1;return this};function oq(){}oq.prototype=new m;oq.prototype.constructor=oq;oq.prototype.c=function(){return this};
function pq(a,b){a=oa(bc(rc),[b]);var c=a.i.length;zca||(zca=(new qq).c());b=a.i.length;if(0>b||(0+b|0)>a.i.length)throw(new W).c();var d=0+c|0;if(0>c||d>b)throw(new W).c();c=new rq;c.Ph=!1;sq.prototype.II.call(c,b,a,0);mq.prototype.Pc.call(c,0);mq.prototype.ct.call(c,d);return c}oq.prototype.$classData=l({DH:0},!1,"java.nio.ByteBuffer$",{DH:1,f:1});var tq=void 0;function uq(){tq||(tq=(new oq).c());return tq}function vq(){}vq.prototype=new m;vq.prototype.constructor=vq;vq.prototype.c=function(){return this};
function wq(a,b,c){Aca||(Aca=(new xq).c());a=laa(b);c=c-0|0;if(0>a||(0+a|0)>laa(b))throw(new W).c();var d=0+c|0;if(0>c||d>a)throw(new W).c();return Bca(a,b,0,0,d)}vq.prototype.$classData=l({EH:0},!1,"java.nio.CharBuffer$",{EH:1,f:1});var yq=void 0;function zq(){yq||(yq=(new vq).c());return yq}function qq(){}qq.prototype=new m;qq.prototype.constructor=qq;qq.prototype.c=function(){return this};qq.prototype.$classData=l({GH:0},!1,"java.nio.HeapByteBuffer$",{GH:1,f:1});var zca=void 0;function xq(){}
xq.prototype=new m;xq.prototype.constructor=xq;xq.prototype.c=function(){return this};xq.prototype.$classData=l({KH:0},!1,"java.nio.StringCharBuffer$",{KH:1,f:1});var Aca=void 0;function Aq(){this.sm=this.pm=this.qm=null;this.lj=0}Aq.prototype=new m;Aq.prototype.constructor=Aq;function Cca(){}Cca.prototype=Aq.prototype;
function Bq(a,b,c,d){if(4===a.lj||!d&&3===a.lj)throw(new Cq).c();a.lj=d?3:2;for(;;){try{var f=Dca(b,c)}catch(n){if(n&&n.$classData&&n.$classData.H.Du)throw Dq(n);if(n&&n.$classData&&n.$classData.H.Eu)throw Dq(n);throw n;}if(0===f.xi){var g=b.jc-b.kb|0;if(d&&0<g){var h=Eq();switch(g){case 1:g=h.wi;break;case 2:g=h.Xk;break;case 3:g=h.Vm;break;case 4:g=h.dq;break;default:g=Eca(h,g)}}else g=f}else g=f;if(0===g.xi||1===g.xi)break;h=3===g.xi?a.sm:a.pm;if(Fq().vm===h){if((c.jc-c.kb|0)<(a.qm.length|0)){Eq();
break}Fca(c,a.qm);h=b.kb;g=g.Um;if(0>g)throw(new Gq).c();mq.prototype.Pc.call(b,h+g|0)}else{if(Fq().wm===h)break;if(Fq().tu===h){h=b.kb;g=g.Um;if(0>g)throw(new Gq).c();mq.prototype.Pc.call(b,h+g|0)}else throw(new p).e(h);}}}Aq.prototype.zv=function(){this.qm="\ufffd";this.pm=Fq().wm;this.sm=Fq().wm;this.lj=1;return this};function Hq(){this.Xx=0;this.sm=this.pm=this.qm=null;this.lj=0}Hq.prototype=new m;Hq.prototype.constructor=Hq;function Gca(){}Gca.prototype=Hq.prototype;
function Hca(a){if(0===a.Jj)return pq(uq(),1);var b=pq(uq(),a.Jj<<1);mq.prototype.Un.call(a);if(a===b)throw(new t).c();if(b.Ph)throw(new Iq).c();var c=a.jc,d=a.kb,f=c-d|0,g=b.kb,h=g+f|0;if(h>b.jc)throw(new Jq).c();b.kb=h;mq.prototype.Pc.call(a,c);h=a.Nd;if(null!==h)Ta(h,a.ne+d|0,b.Nd,b.ne+g|0,f);else for(;d!==c;)b.Nd.i[b.ne+g|0]=a.Nd.i[a.ne+d|0]|0,d=1+d|0,g=1+g|0;return b}Hq.prototype.zv=function(a,b){Hq.prototype.LI.call(this,0,b,0,Ica());return this};
Hq.prototype.LI=function(a,b,c,d){this.Xx=b;this.qm=d;this.pm=Fq().wm;this.sm=Fq().wm;this.lj=0;return this};function Kq(){this.Um=this.xi=0}Kq.prototype=new m;Kq.prototype.constructor=Kq;Kq.prototype.K=function(a,b){this.xi=a;this.Um=b;return this};function Jca(a){var b=a.xi;switch(b){case 1:throw(new Jq).c();case 0:throw(new Lq).c();case 2:throw(new Mq).mc(a.Um);case 3:throw(new Nq).mc(a.Um);default:throw(new p).e(b);}}Kq.prototype.$classData=l({OH:0},!1,"java.nio.charset.CoderResult",{OH:1,f:1});
function Oq(){this.hG=this.dq=this.Vm=this.Xk=this.wi=this.Qk=this.Qh=null}Oq.prototype=new m;Oq.prototype.constructor=Oq;Oq.prototype.c=function(){Pq=this;this.Qh=(new Kq).K(1,-1);this.Qk=(new Kq).K(0,-1);this.wi=(new Kq).K(2,1);this.Xk=(new Kq).K(2,2);this.Vm=(new Kq).K(2,3);this.dq=(new Kq).K(2,4);this.hG=(new Qq).c();(new Kq).K(3,1);(new Kq).K(3,2);(new Kq).K(3,3);(new Kq).K(3,4);(new Qq).c();return this};
function Eca(a,b){return a.hG.VA(b,Rq(function(a,b){return function(){return(new Kq).K(2,b)}}(a,b)))}Oq.prototype.$classData=l({PH:0},!1,"java.nio.charset.CoderResult$",{PH:1,f:1});var Pq=void 0;function Eq(){Pq||(Pq=(new Oq).c());return Pq}function Sq(){this.gd=null}Sq.prototype=new m;Sq.prototype.constructor=Sq;Sq.prototype.v=function(){return this.gd};Sq.prototype.j=function(a){this.gd=a;return this};Sq.prototype.$classData=l({QH:0},!1,"java.nio.charset.CodingErrorAction",{QH:1,f:1});
function Tq(){this.wm=this.vm=this.tu=null}Tq.prototype=new m;Tq.prototype.constructor=Tq;Tq.prototype.c=function(){Uq=this;this.tu=(new Sq).j("IGNORE");this.vm=(new Sq).j("REPLACE");this.wm=(new Sq).j("REPORT");return this};Tq.prototype.$classData=l({RH:0},!1,"java.nio.charset.CodingErrorAction$",{RH:1,f:1});var Uq=void 0;function Fq(){Uq||(Uq=(new Tq).c());return Uq}function Vq(){this.Or=null}Vq.prototype=new m;Vq.prototype.constructor=Vq;
Vq.prototype.Av=function(){this.Or=Wq();Kca||(Kca=(new Xq).c());Lca||(Lca=(new Yq).c());Mca||(Mca=(new Zq).c());Nca||(Nca=(new $q).c());Oca||(Oca=(new ar).c());Pca||(Pca=(new br).c());Qca||(Qca=(new cr).c());return this};Vq.prototype.$classData=l({VH:0},!1,"org.langmeta.inputs.Aliases$Input$",{VH:1,f:1});function gr(){this.Or=null}gr.prototype=new m;gr.prototype.constructor=gr;gr.prototype.Av=function(){this.Or=Rca();Sca||(Sca=(new hr).c());return this};
gr.prototype.$classData=l({WH:0},!1,"org.langmeta.inputs.Aliases$Position$",{WH:1,f:1});function ir(){this.u=null}ir.prototype=new m;ir.prototype.constructor=ir;ir.prototype.be=function(){var a=this.u;return Wq()===a?"\x3cnone\x3e":a&&a.$classData&&a.$classData.H.v5?a.S5().v():a&&a.$classData&&a.$classData.H.Hu?a.bl:a&&a.$classData&&a.$classData.H.Fu?a.Dj.be():"\x3cinput\x3e"};ir.prototype.Gm=function(a){this.u=a;return this};
ir.prototype.$classData=l({kI:0},!1,"org.langmeta.internal.inputs.package$XtensionInputSyntaxStructure",{kI:1,f:1});function jr(){this.cg=null}jr.prototype=new m;jr.prototype.constructor=jr;jr.prototype.Sp=function(a){this.cg=a;return this};
function Tca(a,b){var c=a.cg,d=Rca();if(null!==c&&c.w(d))return td((new yd).X((new r).d(["",": ",""])),(new r).d(["error",b]));c=a.cg.jb();b=td((new yd).X((new r).d(["",":",": ",": ",""])),(new r).d([(new ir).Gm(c).be(),1+a.cg.Rq()|0,"error",b]));d=a.cg.Rq();d=Ad(c,d);if(d<c.od().i.length)var f=1+a.cg.Rq()|0,f=Ad(c,f);else f=d;c=kr(Ga(),c.od(),d,f-d|0);d=(new cd).j(c);f=d.v().length|0;if(0===f)c=d.v();else{var g=d.sl(-1+f|0);10===g||12===g?(c=d.v(),d=10===g&&2<=f&&13===d.sl(-2+f|0)?-2+f|0:-1+f|0,
c=c.substring(0,d)):c=d.v()}d=(new cd).j(" ");a=a.cg.Bx();a=dd(d,a)+"^";return""+b+lr().hg+c+lr().hg+a}jr.prototype.$classData=l({lI:0},!1,"org.langmeta.internal.inputs.package$XtensionPositionFormatMessage",{lI:1,f:1});function mr(){this.sw=this.bl=this.TB=null;this.ra=0}mr.prototype=new m;mr.prototype.constructor=mr;mr.prototype.c=function(){nr=this;this.sw=ca.process;return this};mr.prototype.$classData=l({mI:0},!1,"org.langmeta.internal.io.JSIO$",{mI:1,f:1});var nr=void 0;
function pca(){nr||(nr=(new mr).c());return nr}function or(){}or.prototype=new m;or.prototype.constructor=or;or.prototype.c=function(){return this};or.prototype.$classData=l({nI:0},!1,"org.langmeta.internal.io.PathIO$",{nI:1,f:1});var Uca=void 0;function pr(){}pr.prototype=new m;pr.prototype.constructor=pr;pr.prototype.c=function(){return this};pr.prototype.$classData=l({vI:0},!1,"org.langmeta.semanticdb.Severity$",{vI:1,f:1});var Vca=void 0;function qr(){this.DA=this.jG=null;this.ra=0}
qr.prototype=new m;qr.prototype.constructor=qr;qr.prototype.c=function(){return this};function Wca(){var a=rr();0===(268435456&a.ra)&&0===(268435456&a.ra)&&(a.DA=sr(a).document,a.ra|=268435456);return a.DA}function sr(a){0===(134217728&a.ra)&&0===(134217728&a.ra)&&(a.jG=ca.window,a.ra|=134217728);return a.jG}qr.prototype.$classData=l({xI:0},!1,"org.scalajs.dom.package$",{xI:1,f:1});var tr=void 0;function rr(){tr||(tr=(new qr).c());return tr}function ur(){this.gw=!1}ur.prototype=new m;
ur.prototype.constructor=ur;function vr(a,b){return!a.gw||b}ur.prototype.qj=function(a){this.gw=a;return this};ur.prototype.$classData=l({CI:0},!1,"org.scalameta.invariants.package$XtensionImplication",{CI:1,f:1});function wr(){}wr.prototype=new m;wr.prototype.constructor=wr;wr.prototype.c=function(){return this};wr.prototype.$classData=l({DI:0},!1,"org.scalameta.overload.Hack2$",{DI:1,f:1});var Xca=void 0;function xr(){}xr.prototype=new m;xr.prototype.constructor=xr;function yr(){}yr.prototype=xr.prototype;
function Hb(){this.Ei=null}Hb.prototype=new m;Hb.prototype.constructor=Hb;function Md(a){return a.Ei.name}function zr(a){return a.Ei.getComponentType()}Hb.prototype.v=function(){return(this.Ei.isInterface?"interface ":this.Ei.isPrimitive?"":"class ")+Md(this)};
function Le(a,b){return a.Ei.isPrimitive||b.Ei.isPrimitive?a===b||(a===k(vc)?b===k(rc):a===k(yc)?b===k(rc)||b===k(vc):a===k(Gc)?b===k(rc)||b===k(vc)||b===k(yc):a===k(Ic)&&(b===k(rc)||b===k(vc)||b===k(yc)||b===k(Gc))):Ar(a,b.Ei.getFakeInstance())}function Ar(a,b){return!!a.Ei.isInstance(b)}Hb.prototype.$classData=l({ZI:0},!1,"java.lang.Class",{ZI:1,f:1});function Br(){this.dA=0;this.hC=ab().Uj;this.YB=ab().Uj}Br.prototype=new m;Br.prototype.constructor=Br;
Br.prototype.$classData=l({jJ:0},!1,"java.lang.Long$StringRadixInfo",{jJ:1,f:1});function Cr(){this.h=this.kv=this.WB=null}Cr.prototype=new m;Cr.prototype.constructor=Cr;Cr.prototype.c=function(){Dr=this;this.WB=Yca(!1);this.kv=Yca(!0);this.h=null;return this};Cr.prototype.$classData=l({rJ:0},!1,"java.lang.System$",{rJ:1,f:1});var Dr=void 0;function Er(){Dr||(Dr=(new Cr).c());return Dr}function Fr(){}Fr.prototype=new m;Fr.prototype.constructor=Fr;Fr.prototype.c=function(){return this};
function Gr(a,b,c){return b.Ei.newArrayOfThisClass([c])}Fr.prototype.$classData=l({sJ:0},!1,"java.lang.reflect.Array$",{sJ:1,f:1});var Hr=void 0;function Ir(){Hr||(Hr=(new Fr).c());return Hr}function Jr(){}Jr.prototype=new m;Jr.prototype.constructor=Jr;Jr.prototype.c=function(){return this};function Zca(a,b){a=null===b.bg?0:Ca(b.bg);b=null===b.pa?0:Ca(b.pa);return a^b}Jr.prototype.$classData=l({tJ:0},!1,"java.util.AbstractMap$",{tJ:1,f:1});var Kr=void 0;
function Lr(){Kr||(Kr=(new Jr).c());return Kr}function Mr(){}Mr.prototype=new m;Mr.prototype.constructor=Mr;Mr.prototype.c=function(){return this};function $ca(a,b,c,d){c=c-b|0;if(2<=c){if(0<d.Ie(a.i[b],a.i[1+b|0])){var f=a.i[b];a.i[b]=a.i[1+b|0];a.i[1+b|0]=f}for(f=2;f<c;){var g=a.i[b+f|0];if(0>d.Ie(g,a.i[-1+(b+f|0)|0])){for(var h=b,n=-1+(b+f|0)|0;1<(n-h|0);){var u=(h+n|0)>>>1|0;0>d.Ie(g,a.i[u])?n=u:h=u}h=h+(0>d.Ie(g,a.i[h])?0:1)|0;for(n=b+f|0;n>h;)a.i[n]=a.i[-1+n|0],n=-1+n|0;a.i[h]=g}f=1+f|0}}}
function ada(a,b){a=b.i.length;for(var c=0;c!==a;)b.i[c]=0,c=1+c|0}function bda(a,b,c){var d=new Nr;d.gA=c;c=b.i.length;16<c?Or(a,b,oa(bc(Ab),[b.i.length]),0,c,d):$ca(b,0,c,d)}function Or(a,b,c,d,f,g){var h=f-d|0;if(16<h){var n=d+(h/2|0)|0;Or(a,b,c,d,n,g);Or(a,b,c,n,f,g);for(var u=a=d,w=n;a<f;)u<n&&(w>=f||0>=g.Ie(b.i[u],b.i[w]))?(c.i[a]=b.i[u],u=1+u|0):(c.i[a]=b.i[w],w=1+w|0),a=1+a|0;Ta(c,d,b,d,h)}else $ca(b,d,f,g)}Mr.prototype.$classData=l({uJ:0},!1,"java.util.Arrays$",{uJ:1,f:1});var Pr=void 0;
function Qr(){Pr||(Pr=(new Mr).c());return Pr}function Rr(){this.sB=this.rB=this.qB=this.tB=null}Rr.prototype=new m;Rr.prototype.constructor=Rr;Rr.prototype.c=function(){Sr=this;this.tB=Tr(new Ur,new ca.RegExp("^[^\\x25]+"));this.qB=Tr(new Ur,new ca.RegExp("^\\x25{2}"));this.rB=Tr(new Ur,new ca.RegExp("^\\x25n"));this.sB=Tr(new Ur,new ca.RegExp("^\\x25(?:([1-9]\\d*)\\$)?([-#+ 0,\\(\x3c]*)(\\d*)(?:\\.(\\d+))?([A-Za-z])"));return this};
Rr.prototype.$classData=l({yJ:0},!1,"java.util.Formatter$",{yJ:1,f:1});var Sr=void 0;function Vr(){Sr||(Sr=(new Rr).c());return Sr}function Ur(){this.vo=null}Ur.prototype=new m;Ur.prototype.constructor=Ur;function Wr(a,b){return Xr().up(a.vo.exec(b))}function Tr(a,b){a.vo=b;return a}Ur.prototype.$classData=l({zJ:0},!1,"java.util.Formatter$RegExpExtractor",{zJ:1,f:1});function Yr(){}Yr.prototype=new m;Yr.prototype.constructor=Yr;function cda(){}cda.prototype=Yr.prototype;function Zr(){}
Zr.prototype=new m;Zr.prototype.constructor=Zr;function dda(){}dda.prototype=Zr.prototype;function $r(){this.vl=null}$r.prototype=new m;$r.prototype.constructor=$r;function eda(){}eda.prototype=$r.prototype;$r.prototype.c=function(){this.vl={};return this};$r.prototype.Tu=function(a){var b=this.vl,c=as().dk.call(b,a)?(new T).e(b[a]):S();if(zh(c))return c.Y;if(S()===c)return c=(new bs).j(a),b[a]=c;throw(new p).e(c);};function cs(){}cs.prototype=new m;cs.prototype.constructor=cs;function fda(){}
fda.prototype=cs.prototype;function gda(a,b){return null!==b?(new ds).j(b):null}function es(a,b){return lk(function(a,b){return function(f){f=a.Vh(f,fs().Do);return fs().Do!==f&&(b.Ea(f),!0)}}(a,b))}function gs(a,b,c){return a.vf(b)?a.Ea(b):c.Ea(b)}function hs(){this.JA=this.HE=this.Do=null}hs.prototype=new m;hs.prototype.constructor=hs;hs.prototype.c=function(){is=this;this.Do=(new js).c();this.HE=lk(function(){return function(){return!1}}(this));this.JA=(new ks).c();return this};
hs.prototype.$classData=l({cK:0},!1,"scala.PartialFunction$",{cK:1,f:1});var is=void 0;function fs(){is||(is=(new hs).c());return is}function ls(){}ls.prototype=new m;ls.prototype.constructor=ls;ls.prototype.c=function(){return this};ls.prototype.$classData=l({lK:0},!1,"scala.Predef$any2stringadd$",{lK:1,f:1});var ms=void 0;function ns(a){return!!(a&&a.$classData&&a.$classData.H.R)}function os(){this.hg=null}os.prototype=new m;os.prototype.constructor=os;os.prototype.c=function(){this.hg="\n";return this};
os.prototype.$classData=l({tK:0},!1,"scala.compat.Platform$",{tK:1,f:1});var ps=void 0;function lr(){ps||(ps=(new os).c());return ps}function qs(){this.r=this.$i=null}qs.prototype=new m;qs.prototype.constructor=qs;function hda(){}hda.prototype=qs.prototype;qs.prototype.RI=function(a,b){this.$i=b;if(null===a)throw jo(wj(),null);this.r=a;return this};function rs(){}rs.prototype=new m;rs.prototype.constructor=rs;rs.prototype.c=function(){return this};
rs.prototype.$classData=l({GK:0},!1,"scala.math.Ordered$",{GK:1,f:1});var ida=void 0;function ss(){this.r=this.jm=null}ss.prototype=new m;ss.prototype.constructor=ss;function xf(a,b){return!y(a,b)}function z(a,b){var c=new ss;c.jm=b;if(null===a)throw jo(wj(),null);c.r=a;return c}function y(a,b){return b.la(a.jm)}ss.prototype.$classData=l({MT:0},!1,"scala.meta.classifiers.Api$XtensionClassifiable",{MT:1,f:1});function ts(){}ts.prototype=new m;ts.prototype.constructor=ts;ts.prototype.c=function(){return this};
function us(){vs||(vs=(new ts).c());return(new ws).te(lk(function(){return function(a){return a}}(vs)))}ts.prototype.$classData=l({OT:0},!1,"scala.meta.common.Convert$",{OT:1,f:1});var vs=void 0;function Gs(){this.uy=this.Cz=this.Az=this.nf=this.Jz=this.Iz=this.Hz=this.mb=this.Bz=this.zz=this.mf=this.Rb=this.cc=null}Gs.prototype=new m;Gs.prototype.constructor=Gs;
Gs.prototype.c=function(){Hs=this;this.cc=Is(!1,!0,!0,!1,!1,!1,!1,!0,!1,!1,!1,!0,!1,!1,!1,!1,!1,!1,!1,!1,!0,!0,!0,"");this.Rb=Is(this.cc.Ig,this.cc.rg,!1,this.cc.kg,this.cc.Jg,this.cc.eh,this.cc.fh,this.cc.Rh,this.cc.Sh,this.cc.Bh,this.cc.gh,this.cc.Th,this.cc.Kg,this.cc.Ch,!0,this.cc.Uh,this.cc.hh,this.cc.Dh,this.cc.sg,this.cc.Eh,this.cc.tg,this.cc.Mg,this.cc.cf,this.cc.th);this.mf=Is(this.Rb.Ig,this.Rb.rg,this.Rb.dh,this.Rb.kg,this.Rb.Jg,this.Rb.eh,this.Rb.fh,this.Rb.Rh,this.Rb.Sh,!0,this.Rb.gh,
this.Rb.Th,this.Rb.Kg,this.Rb.Ch,this.Rb.Lg,this.Rb.Uh,this.Rb.hh,this.Rb.Dh,this.Rb.sg,this.Rb.Eh,this.Rb.tg,this.Rb.Mg,this.Rb.cf,this.Rb.th);this.zz=Is(this.Rb.Ig,this.Rb.rg,this.Rb.dh,this.Rb.kg,this.Rb.Jg,this.Rb.eh,this.Rb.fh,!0,!0,this.Rb.Bh,this.Rb.gh,this.Rb.Th,this.Rb.Kg,this.Rb.Ch,this.Rb.Lg,this.Rb.Uh,this.Rb.hh,this.Rb.Dh,this.Rb.sg,this.Rb.Eh,this.Rb.tg,this.Rb.Mg,this.Rb.cf,this.Rb.th);this.Bz=Is(this.mf.Ig,this.mf.rg,this.mf.dh,this.mf.kg,this.mf.Jg,this.mf.eh,this.mf.fh,!0,!0,this.mf.Bh,
this.mf.gh,this.mf.Th,this.mf.Kg,this.mf.Ch,this.mf.Lg,this.mf.Uh,this.mf.hh,this.mf.Dh,this.mf.sg,this.mf.Eh,this.mf.tg,this.mf.Mg,this.mf.cf,this.mf.th);this.mb=Is(this.Rb.Ig,this.Rb.rg,this.Rb.dh,this.Rb.kg,this.Rb.Jg,this.Rb.eh,this.Rb.fh,this.Rb.Rh,this.Rb.Sh,!1,this.Rb.gh,this.Rb.Th,this.Rb.Kg,this.Rb.Ch,this.Rb.Lg,this.Rb.Uh,this.Rb.hh,!0,this.Rb.sg,this.Rb.Eh,this.Rb.tg,this.Rb.Mg,this.Rb.cf,this.Rb.th);var a=lr().hg;this.Hz=Is(this.cc.Ig,this.cc.rg,this.cc.dh,this.cc.kg,this.cc.Jg,this.cc.eh,
this.cc.fh,this.cc.Rh,this.cc.Sh,this.cc.Bh,this.cc.gh,this.cc.Th,this.cc.Kg,this.cc.Ch,this.cc.Lg,this.cc.Uh,!0,this.cc.Dh,this.cc.sg,this.cc.Eh,this.cc.tg,this.cc.Mg,this.cc.cf,a);this.Iz=Is(this.cc.Ig,this.cc.rg,this.cc.dh,this.cc.kg,this.cc.Jg,this.cc.eh,this.cc.fh,this.cc.Rh,this.cc.Sh,this.cc.Bh,this.cc.gh,this.cc.Th,this.cc.Kg,this.cc.Ch,this.cc.Lg,this.cc.Uh,!0,this.cc.Dh,this.cc.sg,this.cc.Eh,this.cc.tg,this.cc.Mg,this.cc.cf,"");this.Jz=Is(this.mb.Ig,this.mb.rg,this.mb.dh,this.mb.kg,this.mb.Jg,
this.mb.eh,this.mb.fh,this.mb.Rh,this.mb.Sh,this.mb.Bh,this.mb.gh,this.mb.Th,this.mb.Kg,this.mb.Ch,this.mb.Lg,this.mb.Uh,!0,this.mb.Dh,this.mb.sg,this.mb.Eh,this.mb.tg,this.mb.Mg,this.mb.cf,"");this.nf=Is(this.mb.Ig,this.mb.rg,this.mb.dh,this.mb.kg,this.mb.Jg,this.mb.eh,this.mb.fh,this.mb.Rh,this.mb.Sh,!0,this.mb.gh,this.mb.Th,this.mb.Kg,this.mb.Ch,this.mb.Lg,this.mb.Uh,this.mb.hh,this.mb.Dh,this.mb.sg,this.mb.Eh,this.mb.tg,this.mb.Mg,this.mb.cf,this.mb.th);this.Az=Is(this.mb.Ig,this.mb.rg,this.mb.dh,
this.mb.kg,this.mb.Jg,this.mb.eh,this.mb.fh,!0,!0,this.mb.Bh,this.mb.gh,this.mb.Th,this.mb.Kg,this.mb.Ch,this.mb.Lg,this.mb.Uh,this.mb.hh,this.mb.Dh,this.mb.sg,this.mb.Eh,this.mb.tg,this.mb.Mg,this.mb.cf,this.mb.th);this.Cz=Is(this.nf.Ig,this.nf.rg,this.nf.dh,this.nf.kg,this.nf.Jg,this.nf.eh,this.nf.fh,!0,!0,this.nf.Bh,this.nf.gh,this.nf.Th,this.nf.Kg,this.nf.Ch,this.nf.Lg,this.nf.Uh,this.nf.hh,this.nf.Dh,this.nf.sg,this.nf.Eh,this.nf.tg,this.nf.Mg,this.nf.cf,this.nf.th);this.uy=Is(!0,!1,this.mb.dh,
!0,!0,!0,!0,!1,!0,!0,!1,this.mb.Th,!0,this.mb.Ch,this.mb.Lg,this.mb.Uh,this.mb.hh,!1,!0,!0,!1,!1,!1,this.mb.th);return this};Gs.prototype.$classData=l({RT:0},!1,"scala.meta.dialects.package$",{RT:1,f:1});var Hs=void 0;function wk(){Hs||(Hs=(new Gs).c());return Hs}function Js(){this.lv=null}Js.prototype=new m;Js.prototype.constructor=Js;Js.prototype.Dv=function(a){this.lv=a;return this};Js.prototype.$classData=l({VT:0},!1,"scala.meta.internal.parsers.Absolutize$XtensionExceptionAbsolutize",{VT:1,f:1});
function Ks(){this.cg=null}Ks.prototype=new m;Ks.prototype.constructor=Ks;Ks.prototype.Sp=function(a){this.cg=a;return this};function jda(a){var b=a.cg;if(b&&b.$classData&&b.$classData.H.Iu){var c=b.u,d=b.E;a=b.Ca;if(c&&c.$classData&&c.$classData.H.Gu)return b=c.u,c=c.E,d=c+d|0,a=c+a|0,Ls(),(new Ms).ib(b,d,a)}return b}Ks.prototype.$classData=l({WT:0},!1,"scala.meta.internal.parsers.Absolutize$XtensionPositionAbsolutize",{WT:1,f:1});function Ns(){this.os=this.Hn=this.pe=0}Ns.prototype=new m;
Ns.prototype.constructor=Ns;Ns.prototype.c=function(){this.pe=0;this.Hn=1;this.os=2;return this};Ns.prototype.$classData=l({YT:0},!1,"scala.meta.internal.parsers.Location$",{YT:1,f:1});var Os=void 0;function Ps(){Os||(Os=(new Ns).c());return Os}function Qs(){this.Dy=this.Ey=this.Jn=this.By=this.Cy=this.Ay=this.Kn=null}Qs.prototype=new m;Qs.prototype.constructor=Qs;
Qs.prototype.c=function(){this.Kn="`sealed' modifier can be used only for classes";this.Ay="`implicit' modifier can be used only for values, variables, methods and classes";this.Cy="traits cannot be implicit";this.By="classes cannot be implicit";this.Jn="`abstract' modifier can be used only for classes";this.Ey="`override' modifier not allowed for classes";this.Dy="classes cannot be lazy";return this};
function oe(a,b,c){a=(new cd).j(".");b=dd(a,1+b|0)+"$";c=1+c|0;var d=0>c;Rs();uk();a=(new Hk).c();if(!d)for(d=0;;){var f=d;1!==f!==!1&&Ik(a,f);if(d===c)break;d=1+d|0}a=Jk(a);Rs();c=vk().$d;c=zg(a,c);for(a=Ss(a);a.om;)d=a.bb()|0,f=(new cd).j("."),c.ba(dd(f,d)+"$");c=c.da().Pd(" or ");b=td((new yd).X((new r).d(["rank mismatch when unquoting;"," found   : ",""," required: ",""])),(new r).d([lr().hg,b,lr().hg,c]));c=(new cd).j("");cj(c)&&(b=""+b+lr().hg+"");return b}
Qs.prototype.$classData=l({ZT:0},!1,"scala.meta.internal.parsers.Messages$",{ZT:1,f:1});var Ts=void 0;function pe(){Ts||(Ts=(new Qs).c());return Ts}
function Us(){this.h=this.ME=this.kh=this.P=this.ea=this.rs=this.Hr=this.vs=this.Qr=this.Pk=this.js=this.kr=this.lr=this.mr=this.ks=this.Ir=this.Pr=this.Mr=this.rr=this.ns=this.sr=this.nr=this.wr=this.us=this.qr=this.Tr=this.Sr=this.Rr=this.Ur=this.Tt=this.dt=this.Jt=this.ft=this.ht=this.Ot=this.fr=this.Gr=this.Fr=this.Er=this.Dr=this.Cr=this.Tc=this.jr=this.qs=this.Ku=this.$B=this.aC=this.mG=this.QE=null;this.Jq=!1;this.Gp=null;this.ra=0}Us.prototype=new m;Us.prototype.constructor=Us;
function Vs(a){null===a.Pr&&null===a.Pr&&(a.Pr=(new Ws).z(a));return a.Pr}
function vf(a,b){var c=ce(a),d=ce(a),f=c.$a(),g=x(a.h);a:{var h;if(Xs(g)){var n=Ys(Zs(),g);if(!n.g()){var u=n.q(),w=b?(new $s).$j(Wp(u.Td)):u;if(at(a))var D=Aj(bt(),-2147483648),N=Bj(),Q=Ej(D,Aj(N,2)),ea=Bj(),ba=Fj(Q,Aj(ea,1));else ba=Aj(bt(),-2147483648);if(at(a))var ma=Aj(bt(),2147483647),La=Bj(),Pa=Ej(ma,Aj(La,2)),Qa=Bj(),Ka=Fj(Pa,Aj(Qa,1));else Ka=Aj(bt(),2147483647);if(0<w.qf(Ka)){le(a);var Ba=x(a.h).ja();Pd("integer number too large",Ba)}else if(0>w.qf(ba)){le(a);var va=x(a.h).ja();Pd("integer number too small",
va)}kda||(kda=(new ct).c());var za=w.Td.oh();h=lda(null,null,null,za);break a}}if(dt(g)){var qa=et(ft(),g);if(!qa.g()){var la=qa.q(),Ma=b?(new $s).$j(Wp(la.Td)):la;if(at(a))var Ea=gt(bt(),(new Ep).K(0,-2147483648)),tb=Bj(),Za=Ej(Ea,Aj(tb,2)),eb=Bj(),kb=Fj(Za,Aj(eb,1));else kb=gt(bt(),(new Ep).K(0,-2147483648));if(at(a))var Pb=gt(bt(),(new Ep).K(-1,2147483647)),Na=Bj(),sb=Ej(Pb,Aj(Na,2)),yb=Bj(),sc=Fj(sb,Aj(yb,1));else sc=gt(bt(),(new Ep).K(-1,2147483647));if(0<Ma.qf(sc)){le(a);var Ra=x(a.h).ja();
Pd("integer number too large",Ra)}else if(0>Ma.qf(kb)){le(a);var wc=x(a.h).ja();Pd("integer number too small",wc)}mda||(mda=(new ht).c());var Wb=Ma.Td.bi(),Rb=(new Ep).K(Wb.Ra,Wb.Ya),ub=new it;ub.m=null;ub.aa=null;ub.s=null;ub.Ab=Rb;h=ub;break a}}if(jt(g)){var fb=kt(lt(),g);if(!fb.g()){var Xb=fb.q(),lb=b?nda(Xb):Xb,Eb=gj(),xc=mt(3.4028234663852886E38,Eb.xk);if(0<lb.qf(xc)){le(a);var gb=x(a.h).ja();Pd("floating point number too large",gb)}else{var dc=gj();nt||(nt=(new ot).c());var Fc=mt(nt.np,dc.xk);
if(0>lb.qf(Fc)){le(a);var Qb=x(a.h).ja();Pd("floating point number too small",Qb)}}oda||(oda=(new pt).c());var Bb=lb.Jd.v();if(null!==Bb)var Ib=(new q).a(!0,F());else{G();var mb=(new r).d(["format is equal to null"]),Cb=G().b,Ib=(new q).a(!1,H(mb,Cb))}if(null===Ib||!0!==I(Ib)){if(null!==Ib){var Tb=Ib.p();if(!1===I(Ib)){for(var mc=J(),Ac=[(new q).a("format",Bb)],Dc=A(new B,C()),Db=0,Va=Ac.length|0;Db<Va;)E(Dc,Ac[Db]),Db=1+Db|0;K(mc,"format.!\x3d(null)",Tb,Dc.t)}}throw(new p).e(Ib);}h=pda(null,null,
null,Bb);break a}}if(qt(g)){var ec=rt(st(),g);if(!ec.g()){var $a=ec.q(),vb=b?nda($a):$a,fc=gj(),Bc=mt(1.7976931348623157E308,fc.xk);if(0<vb.qf(Bc)){le(a);var Ub=x(a.h).ja();Pd("floating point number too large",Ub)}else{var Vb=gj();tt||(tt=(new ut).c());var wb=mt(tt.np,Vb.xk);if(0>vb.qf(wb)){le(a);var xb=x(a.h).ja();Pd("floating point number too small",xb)}}qda||(qda=(new vt).c());var Xa=vb.Jd.v();if(null!==Xa)var tc=(new q).a(!0,F());else{G();var ib=(new r).d(["format is equal to null"]),zb=G().b,
tc=(new q).a(!1,H(ib,zb))}if(null===tc||!0!==I(tc)){if(null!==tc){var nb=tc.p();if(!1===I(tc)){for(var Jb=J(),jb=[(new q).a("format",Xa)],ob=A(new B,C()),gc=0,cb=jb.length|0;gc<cb;)E(ob,jb[gc]),gc=1+gc|0;K(Jb,"format.!\x3d(null)",nb,ob.t)}}throw(new p).e(tc);}h=rda(null,null,null,Xa);break a}}if(wt(g)){var Ua=xt(yt(),g);if(!Ua.g()){var Yb=Ua.q(),Kb=null===Yb?0:Yb.pa;sda||(sda=(new zt).c());h=tda(null,null,null,Kb);break a}}if(At(g)){var pb=Bt(Ct(),g);if(!pb.g()){var hb=pb.q();h=Dt(Et(),hb);break a}}if(Ft(g)){var Lb=
Gt(Ht(),g);if(!Lb.g()){var Fa=Lb.q();uda||(uda=(new It).c());if(null!==Fa)var bb=(new q).a(!0,F());else{G();var nc=(new r).d(["value is equal to null"]),db=G().b,bb=(new q).a(!1,H(nc,db))}if(null===bb||!0!==I(bb)){if(null!==bb){var uc=bb.p();if(!1===I(bb)){for(var Fb=J(),hc=[(new q).a("value",Fa)],$b=A(new B,C()),kc=0,lc=hc.length|0;kc<lc;)E($b,hc[kc]),kc=1+kc|0;K(Fb,"value.!\x3d(null)",uc,$b.t)}}throw(new p).e(bb);}h=vda(null,null,null,Fa);break a}}if(Jt(g))h=wda(!0);else if(Kt(g))h=wda(!1);else if(Lt(g))xda||
(xda=(new Mt).c()),h=yda(null,null,null);else{for(var Mb=he(),Nb=[(new q).a("ScalametaParser.this.token",x(a.h))],Gb=A(new B,C()),Sb=0,Cc=Nb.length|0;Sb<Cc;)E(Gb,Nb[Sb]),Sb=1+Sb|0;ie(Mb,Gb.t)}}a.h.ia();var Ob=d.Ga();Ob<f&&(Ob=-1+f|0);var Zb=(new L).K(f,1+Ob|0),Ec=M();return O(P(Ec,h),R(a.ea,a.P,Zb))}function Nt(a){null===a.nr&&null===a.nr&&(a.nr=(new Ot).z(a));return a.nr}
function St(a){var b=ce(a),c=ce(a),d=b.$a();Sd(a,(new Tt).z(a));var f;Ut||(Ut=(new Vt).c());f=Ut;var g=function(a){return function(){var b=ce(a),c=ce(a),b=b.$a(),d=uf(a,!1);a:{var f;if(Ke(d))f=d.nb((new Wt).z(a));else{if(Df(d)&&(f=null===d?S():(new T).e((new q).a(Ef(d),d.yb())),!f.g())){var g=f.q().qa();f=f.q().p();if(Ke(g)){var h=We(new Ze,a,d),d=We(new Ze,a,d),h=h.eb;Xt();g=g.nb((new Yt).z(a));g=Zt(0,g,f);f=d.Fb;f<h&&(f=-1+h|0);f=(new L).K(h,1+f|0);d=M();f=O(P(d,g),R(a.ea,a.P,f));break a}}f=d}}a:{if(Df(f)&&
(g=f,d=null===g?S():(new T).e((new q).a(Ef(g),g.yb())),!d.g())){var g=d.q().qa(),n=d.q().p();if(Lf(g)&&null!==n&&$t(au(g))){d=v();h=x(a.h);if(y(z(d,h),Bf()))g=zda(a,f);else{f=Ada();h=We(new Ze,a,n);d=We(new Ze,a,n);h=h.eb;bu();var u=We(new Ze,a,n),w=We(new Ze,a,n),u=u.eb;cu();n=n.ec();n=du(n);w=w.Fb;w<u&&(w=-1+u|0);w=(new L).K(u,1+w|0);u=M();n=O(P(u,n),R(a.ea,a.P,w));n=Bda(n);d=d.Fb;d<h&&(d=-1+h|0);d=(new L).K(h,1+d|0);h=M();d=O(P(h,n),R(a.ea,a.P,d));h=F();g=Cda(f,g,U(new V,d,h))}break a}}g=zda(a,
f)}c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,g),R(a.ea,a.P,c))}}(a),h=(new eu).z(a),n=(new Xd).z(a),u=(new ae).c(),w=v(),D=x(a.h);if(y(z(w,D),be())){var N=ce(a),Q=ce(a),ea=N.$a(),ba=x(a.h);if(!de(ba)){for(var ma=he(),La=[(new q).a("ScalametaParser.this.token",x(a.h))],Pa=A(new B,C()),Qa=0,Ka=La.length|0;Qa<Ka;)E(Pa,La[Qa]),Qa=1+Qa|0;ie(ma,Pa.t)}if(!ke(a.P)){le(a);var Ba=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),va=ba.ja();Pd(Ba,va)}if(1!==
ba.Hb){le(a);var za=oe(pe(),ba.Hb,1),qa=ba.ja();Pd(za,qa)}a.h.ia();var la=x(a.h);if(ue(la)){Sd(a,(new ve).z(a));var Ma=we(a,!0,h);Sd(a,(new Ae).z(a));var Ea=Ma}else if(Be(la)){Sd(a,(new Ee).z(a));var tb=we(a,!0,h);Sd(a,(new Ie).z(a));Ea=tb}else if(Je(la))Ea=we(a,!0,h);else{le(a);var Za=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),eb=x(a.h).ja();Pd(Za,eb)}if(Ke(Ea)){if(Le((Oe(),h).G(),Ea.uc()))var kb=(new q).a(!0,F());else{G();var Pb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
Na=G().b,kb=(new q).a(!1,H(Pb,Na))}if(null===kb||!0!==I(kb)){if(null!==kb){var sb=kb.p();if(!1===I(kb)){for(var yb=J(),sc=(new q).a("ellipsis",ba),Ra=(new q).a("result",Ea),wc=(new q).a("evidence$4",h),Wb=(new q).a("quasi",Ea),Rb=Se(),ub=Te().Hc(),fb=[sc,Ra,wc,Wb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Rb,Ea,ub)))],Xb=A(new B,C()),lb=0,Eb=fb.length|0;lb<Eb;)E(Xb,fb[lb]),lb=1+lb|0;K(yb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
sb,Xb.t)}}throw(new p).e(kb);}var xc=We(new Ze,a,Ea),gb=We(new Ze,a,Ea),dc=xc.eb,Fc=Ea.ca,Qb=Ea.fa(),Bb=fu(gu(),Fc,Qb),Ib=gb.Fb;Ib<dc&&(Ib=-1+dc|0);var mb=(new L).K(dc,1+Ib|0),Cb=M(),Tb=O(P(Cb,Bb),R(a.ea,a.P,mb))}else Tb=Ea;var mc=fu(gu(),1,Tb),Ac=Q.Ga();Ac<ea&&(Ac=-1+ea|0);var Dc=(new L).K(ea,1+Ac|0),Db=M(),Va=O(P(Db,mc),R(a.ea,a.P,Dc))}else Va=g();for(ff(u,Va);;){var ec=v(),$a=x(a.h);if(y(z(ec,$a),n))var vb=!0;else var fc=v(),Bc=x(a.h),vb=y(z(fc,Bc),be());if(vb){var Ub=v(),Vb=x(a.h);y(z(Ub,Vb),
n)&&a.h.ia();var wb=v(),xb=x(a.h);if(y(z(wb,xb),be())){var Xa=ce(a),tc=ce(a),ib=Xa.$a(),zb=x(a.h);if(!de(zb)){for(var nb=he(),Jb=[(new q).a("ScalametaParser.this.token",x(a.h))],jb=A(new B,C()),ob=0,gc=Jb.length|0;ob<gc;)E(jb,Jb[ob]),ob=1+ob|0;ie(nb,jb.t)}var cb=zb;if(!ke(a.P)){le(a);var Ua=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),Yb=cb.ja();Pd(Ua,Yb)}if(1!==cb.Hb){le(a);var Kb=oe(pe(),cb.Hb,1),pb=cb.ja();Pd(Kb,pb)}a.h.ia();var hb=x(a.h);if(ue(hb)){Sd(a,(new ve).z(a));
var Lb=we(a,!0,h);Sd(a,(new Ae).z(a));var Fa=Lb}else if(Be(hb)){Sd(a,(new Ee).z(a));var bb=we(a,!0,h);Sd(a,(new Ie).z(a));Fa=bb}else if(Je(hb))Fa=we(a,!0,h);else{le(a);var nc=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),db=x(a.h).ja();Pd(nc,db)}if(Ke(Fa)){if(Le((Oe(),h).G(),Fa.uc()))var uc=(new q).a(!0,F());else{G();var Fb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),hc=G().b,uc=(new q).a(!1,
H(Fb,hc))}if(null===uc||!0!==I(uc)){if(null!==uc){var $b=uc.p();if(!1===I(uc)){for(var kc=J(),lc=(new q).a("ellipsis",cb),Mb=(new q).a("result",Fa),Nb=(new q).a("evidence$4",h),Gb=(new q).a("quasi",Fa),Sb=Se(),Cc=Te().Hc(),Ob=[lc,Mb,Nb,Gb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Sb,Fa,Cc)))],Zb=A(new B,C()),Ec=0,oc=Ob.length|0;Ec<oc;)E(Zb,Ob[Ec]),Ec=1+Ec|0;K(kc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
$b,Zb.t)}}throw(new p).e(uc);}var pc=We(new Ze,a,Fa),qc=We(new Ze,a,Fa),Jc=pc.eb,Hc=Fa.ca,ac=Fa.fa(),Lc=fu(gu(),Hc,ac),$c=qc.Fb;$c<Jc&&($c=-1+Jc|0);var Tc=(new L).K(Jc,1+$c|0),Rc=M(),Mc=O(P(Rc,Lc),R(a.ea,a.P,Tc))}else Mc=Fa;var hd=fu(gu(),1,Mc),Qc=tc.Ga();Qc<ib&&(Qc=-1+ib|0);var rd=(new L).K(ib,1+Qc|0),od=M(),Zc=O(P(od,hd),R(a.ea,a.P,rd))}else Zc=g();ff(u,Zc)}else break}var nd=u.lb(),zd=Dda(f,nd),ud=c.Ga();ud<d&&(ud=-1+d|0);var wd=(new L).K(d,1+ud|0),Bd=M();return O(P(Bd,zd),R(a.ea,a.P,wd))}
function Eda(a){var b=v(),c=x(a.h);if(y(z(b,c),hu()))return!0;b=v();a=x(a.h);return y(z(b,a),og())}
function xh(a,b,c){for(var d=(new ae).c();;){var f=v(),g=x(a.h);if(y(z(f,g),iu()))var h=!0;else{var n=v(),u=x(a.h);if(y(z(n,u),be())){var w=a.h,D=(new kg).Ia(w.r,w.Dc);a.h.ia();try{var N=v(),Q=x(a.h),h=y(z(N,Q),iu())}finally{a.h=D}}else h=!1}if(h){var ea=v(),ba=x(a.h);if(y(z(ea,ba),be())){(new ju).z(a);var ma=(new ku).z(a),La=ce(a),Pa=ce(a),Qa=La.$a(),Ka=x(a.h);if(!de(Ka)){for(var Ba=he(),va=[(new q).a("ScalametaParser.this.token",x(a.h))],za=A(new B,C()),qa=0,la=va.length|0;qa<la;)E(za,va[qa]),qa=
1+qa|0;ie(Ba,za.t)}var Ma=Ka;if(!ke(a.P)){le(a);var Ea=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),tb=Ma.ja();Pd(Ea,tb)}if(1!==Ma.Hb){le(a);var Za=oe(pe(),Ma.Hb,1),eb=Ma.ja();Pd(Za,eb)}a.h.ia();Sd(a,(new lu).z(a));var kb=x(a.h);if(ue(kb)){Sd(a,(new ve).z(a));var Pb=we(a,!0,ma);Sd(a,(new Ae).z(a));var Na=Pb}else if(Be(kb)){Sd(a,(new Ee).z(a));var sb=we(a,!0,ma);Sd(a,(new Ie).z(a));Na=sb}else if(Je(kb))Na=we(a,!0,ma);else{le(a);var yb=td((new yd).X((new r).d(["$, ( or { expected but ",
" found"])),(new r).d([x(a.h).oa()])),sc=x(a.h).ja();Pd(yb,sc)}if(Ke(Na)){if(Le((Oe(),ma).G(),Na.uc()))var Ra=(new q).a(!0,F());else{G();var wc=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Wb=G().b,Ra=(new q).a(!1,H(wc,Wb))}if(null===Ra||!0!==I(Ra)){if(null!==Ra){var Rb=Ra.p();if(!1===I(Ra)){for(var ub=J(),fb=(new q).a("ellipsis",Ma),Xb=(new q).a("result",Na),lb=(new q).a("evidence$4",ma),Eb=(new q).a("quasi",Na),xc=Se(),gb=Te().Hc(),
dc=[fb,Xb,lb,Eb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(xc,Na,gb)))],Fc=A(new B,C()),Qb=0,Bb=dc.length|0;Qb<Bb;)E(Fc,dc[Qb]),Qb=1+Qb|0;K(ub,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",Rb,Fc.t)}}throw(new p).e(Ra);
}var Ib=We(new Ze,a,Na),mb=We(new Ze,a,Na),Cb=Ib.eb,Tb=Na.ca,mc=Na.fa(),Ac=mu(nu(),Tb,mc),Dc=mb.Fb;Dc<Cb&&(Dc=-1+Cb|0);var Db=(new L).K(Cb,1+Dc|0),Va=M(),ec=O(P(Va,Ac),R(a.ea,a.P,Db))}else ec=Na;var $a=mu(nu(),1,ec),vb=Pa.Ga();vb<Qa&&(vb=-1+Qa|0);var fc=(new L).K(Qa,1+vb|0),Bc=M(),Ub=P(Bc,$a);ff(d,O(Ub,R(a.ea,a.P,fc)))}else{a.h.ia();var Vb=v(),wb=x(a.h);if(y(z(Vb,wb),Ug())){var xb=(new ou).z(a);ff(d,we(a,!0,xb))}else{var Xa=qf(a.h),tc=(new rf).Ia(a,Xa),ib=ce(a),zb=tc.va;Fda||(Fda=(new pu).c());var nb=
a,Jb=c,jb=ce(nb),ob=ce(nb),gc=jb.$a(),cb=x(nb.h);a:{var Ua=void 0;if(Je(cb)){var Yb=nb.h,Kb=(new kg).Ia(Yb.r,Yb.Dc);nb.h.ia();try{var pb=qu(nb,!1)}finally{nb.h=Kb}if(!pb){var hb=(new ru).z(nb),Ua=we(nb,!0,hb);break a}}var Lb=su(nb),Fa=gf(Lb),bb=ce(nb),nc=ce(nb),db=bb.$a(),uc=tu(),Fb=nc.Ga();Fb<db&&(Fb=-1+db|0);for(var hc=(new L).K(db,1+Fb|0),$b=M(),kc=O(P($b,uc),R(nb.ea,nb.P,hc)),lc=uu(vu(),F()),Mb=!1;qu(nb,!1)&&!Mb;)ff(lc,wu(nb)),Jb||(Mb=!0);var Nb=xu(),Gb=lc.lb(),Ua=yu(Nb,Fa,kc,Gb)}var Sb=ob.Ga();
Sb<gc&&(Sb=-1+gc|0);var Cc=(new L).K(gc,1+Sb|0),Ob=M(),Zb,Ec=O(P(Ob,Ua),R(nb.ea,nb.P,Cc));if(null!==Ec)var oc=(new q).a(!0,F());else{G();var pc=(new r).d(["init is equal to null"]),qc=G().b,oc=(new q).a(!1,H(pc,qc))}if(null===oc||!0!==I(oc)){if(null!==oc){var Jc=oc.p();if(!1===I(oc)){for(var Hc=J(),ac=[(new q).a("init",Ec)],Lc=A(new B,C()),$c=0,Tc=ac.length|0;$c<Tc;)E(Lc,ac[$c]),$c=1+$c|0;K(Hc,"init.!\x3d(null)",Jc,Lc.t)}}throw(new p).e(oc);}var Rc=Gda(null,null,null);Rc.xh=Ec.y(Ec,Rc,"init",Ec.s);
Zb=Rc;var Mc=ib.Ga();Mc<zb&&(Mc=-1+zb|0);var hd=(new L).K(zb,1+Mc|0),Qc=M(),rd=P(Qc,Zb);ff(d,O(rd,R(a.ea,a.P,hd)))}}b&&ih(a)}else break}return d.lb()}function zu(a,b,c,d,f,g,h,n){pe();d=td((new yd).X((new r).d(["illegal combination of modifiers: "," and ",""])),(new r).d([d.PB,d.QB]));var u=(new cd).j(c);c=cj(u)?td((new yd).X((new r).d([" for: ",""])),(new r).d([c])):"";c=""+d+c;b=Au(b);f=Bu(b,g,f);h=Bu(b,n,h);n=G().b;for(h=Vm(f,h,n);!h.g();)n=h.n(),le(a),n=Yc(n.qa()),Pd(c,n)}e=Us.prototype;
e.Ss=function(){var a=x(this.h);return hg(a)&&(a=ig(jg(),a),!a.g()&&(a=a.q(),a=(new cd).j(a),a=Sg(a,"`"),a=(new cd).j(a),a=Tg(a,"`"),a=Cu(Du(),a),eh(a).Ss()))?!0:!1};
function Daa(a,b){G();var c=(new T).e(b);if(null!==c.Y&&0===qo(c.Y,1)&&(c=ro(c.Y,0),Eu(c))){var d=null===c?S():(new T).e((new q).a(c.ca,c.fa()));if(!d.g()&&1===d.q().Xa())return d=We(new Ze,a,c),c=We(new Ze,a,c),d=d.eb,b=Ci(Li(),b),c=c.Fb,c<d&&(c=-1+d|0),c=(new L).K(d,1+c|0),d=M(),O(P(d,b),R(a.ea,a.P,c))}a=function(){return function(a){return Ci(Li(),a)}}(a);F().w(b)&&ie(he(),Fu());return rk(b)&&(c=b.ed,d=b.ga,F().w(d))?Ke(c)&&1===c.ca?a(b):c:a(b)}
function Gu(a){for(var b=(new ae).c();;){var c=v(),d=x(a.h),f=z(c,d),g=Hu(a);if(y(f,Iu(g)))D=!1;else var h=v(),n=x(a.h),u=z(h,n),w=Ju(a),D=!y(u,Hda(w));if(D){var N=v(),Q=x(a.h),ea=z(N,Q);Ku||(Ku=(new Lu).c());if(y(ea,Ku))ff(b,St(a)),Mu(a);else{var ba=v(),ma=x(a.h),La=z(ba,ma),Pa=Nu(a);if(y(La,Ou(Pa)))var Qa=v(),Ka=x(a.h),Ba=z(Qa,Ka),va=Vs(a),za=!y(Ba,Ida(va));else za=!1;if(za){var qa=v(),la=x(a.h);if(y(z(qa,la),Vi())){var Ma=Tf(a.h);a.h.ia();var Ea=v(),tb=x(a.h);if(y(z(Ea,tb),Pu()))ff(b,Jda(a,Ps().Hn));
else{var Za=(new rf).Ia(a,Ma),eb=(new rf).Ia(a,Ma),kb=Za.va,Pb=Qu(),Na=eb.va;Na<kb&&(Na=-1+kb|0);var sb=(new L).K(kb,1+Na|0),yb=M(),sc=P(yb,Pb);ff(b,Kda(a,(new T).e(O(sc,R(a.ea,a.P,sb)))))}}else ff(b,Kda(a,S()));Mu(a)}else{var Ra=v(),wc=x(a.h),Wb=z(Ra,wc),Rb=Ru(a);if(y(Wb,Su(Rb))){var ub=Tu(a,Ps().Hn,!1);ff(b,Ke(ub)?ub.nb((new Uu).z(a)):ub);var fb=v(),Xb=x(a.h),lb=z(fb,Xb),Eb=Ju(a);y(lb,Hda(Eb))||Vu(a)}else{var xc=v(),gb=x(a.h),dc=z(xc,gb),Fc=Wu(a);if(y(dc,Xu(Fc)))a.h.ia();else{var Qb=v(),Bb=x(a.h);
if(y(z(Qb,Bb),be())){(new Yu).z(a);var Ib=(new Zu).z(a),mb=ce(a),Cb=ce(a),Tb=mb.$a(),mc=x(a.h);if(!de(mc)){for(var Ac=he(),Dc=[(new q).a("ScalametaParser.this.token",x(a.h))],Db=A(new B,C()),Va=0,ec=Dc.length|0;Va<ec;)E(Db,Dc[Va]),Va=1+Va|0;ie(Ac,Db.t)}var $a=mc;if(!ke(a.P)){le(a);var vb=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),fc=$a.ja();Pd(vb,fc)}if(1!==$a.Hb){le(a);var Bc=oe(pe(),$a.Hb,1),Ub=$a.ja();Pd(Bc,Ub)}a.h.ia();var Vb=x(a.h);if(ue(Vb)){Sd(a,(new ve).z(a));
var wb=we(a,!0,Ib);Sd(a,(new Ae).z(a));var xb=wb}else if(Be(Vb)){Sd(a,(new Ee).z(a));var Xa=we(a,!0,Ib);Sd(a,(new Ie).z(a));xb=Xa}else if(Je(Vb))xb=we(a,!0,Ib);else{le(a);var tc=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),ib=x(a.h).ja();Pd(tc,ib)}if(Ke(xb)){if(Le((Oe(),Ib).G(),xb.uc()))var zb=(new q).a(!0,F());else{G();var nb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Jb=G().b,zb=(new q).a(!1,
H(nb,Jb))}if(null===zb||!0!==I(zb)){if(null!==zb){var jb=zb.p();if(!1===I(zb)){for(var ob=J(),gc=(new q).a("ellipsis",$a),cb=(new q).a("result",xb),Ua=(new q).a("evidence$4",Ib),Yb=(new q).a("quasi",xb),Kb=Se(),pb=Te().Hc(),hb=[gc,cb,Ua,Yb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Kb,xb,pb)))],Lb=A(new B,C()),Fa=0,bb=hb.length|0;Fa<bb;)E(Lb,hb[Fa]),Fa=1+Fa|0;K(ob,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
jb,Lb.t)}}throw(new p).e(zb);}var nc=We(new Ze,a,xb),db=We(new Ze,a,xb),uc=nc.eb,Fb=xb.ca,hc=xb.fa(),$b=$u(av(),Fb,hc),kc=db.Fb;kc<uc&&(kc=-1+uc|0);var lc=(new L).K(uc,1+kc|0),Mb=M(),Nb=O(P(Mb,$b),R(a.ea,a.P,lc))}else Nb=xb;var Gb=$u(av(),1,Nb),Sb=Cb.Ga();Sb<Tb&&(Sb=-1+Tb|0);var Cc=(new L).K(Tb,1+Sb|0),Ob=M(),Zb=P(Ob,Gb);ff(b,O(Zb,R(a.ea,a.P,Cc)))}else{le(a);var Ec=x(a.h).ja();Pd("illegal start of statement",Ec)}}}}}}else break}return b.lb()}
function Lda(a){null===a.kr&&null===a.kr&&(a.kr=(new bv).z(a));return a.kr}
function Fh(a){Sd(a,(new Ee).z(a));for(var b,c=(new ae).c();;){var d=v(),f=x(a.h),d=z(d,f),f=Hu(a);if(y(d,Iu(f)))break;else{a:{var d=a,f=v(),g=x(d.h);if(y(z(f,g),be())){(new cv).z(d);var h=(new dv).z(d),g=ce(d),f=ce(d),g=g.$a(),n=x(d.h);if(!de(n)){for(var u=he(),w=[(new q).a("ScalametaParser.this.token",x(d.h))],D=A(new B,C()),N=0,Q=w.length|0;N<Q;)E(D,w[N]),N=1+N|0;ie(u,D.t)}ke(d.P)||(le(d),u=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([d.P])),w=n.ja(),Pd(u,w));1!==n.Hb&&
(le(d),u=oe(pe(),n.Hb,1),w=n.ja(),Pd(u,w));d.h.ia();u=x(d.h);ue(u)?(Sd(d,(new ve).z(d)),b=we(d,!0,h),Sd(d,(new Ae).z(d))):Be(u)?(Sd(d,(new Ee).z(d)),b=we(d,!0,h),Sd(d,(new Ie).z(d))):Je(u)?b=we(d,!0,h):(le(d),u=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(d.h).oa()])),w=x(d.h).ja(),Pd(u,w));if(Ke(b)){Le((Oe(),h).G(),b.uc())?u=(new q).a(!0,F()):(G(),u=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),w=G().b,
u=(new q).a(!1,H(u,w)));if(null===u||!0!==I(u)){if(null!==u&&(a=u.p(),!1===I(u))){c=J();d=(new q).a("ellipsis",n);f=(new q).a("result",b);g=(new q).a("evidence$4",h);h=(new q).a("quasi",b);n=Se();w=Te().Hc();b=[d,f,g,h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(n,b,w)))];d=A(new B,C());f=0;for(g=b.length|0;f<g;)E(d,b[f]),f=1+f|0;K(c,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
a,d.t)}throw(new p).e(u);}n=We(new Ze,d,b);h=We(new Ze,d,b);n=n.eb;u=b.ca;w=b.fa();u=$u(av(),u,w);h=h.Fb;h<n&&(h=-1+n|0);h=(new L).K(n,1+h|0);n=M();h=O(P(n,u),R(d.ea,d.P,h))}else h=b;h=$u(av(),1,h);f=f.Ga();f<g&&(f=-1+g|0);f=(new L).K(g,1+f|0);g=M();g=P(g,h);d=(new T).e(O(g,R(d.ea,d.P,f)))}else{f=v();g=x(d.h);f=z(f,g);g=ev(d);if(y(f,fv(g))){f=gv(d,F());if(Mda(hv(f))){d=(new T).e(f);break a}le(d);d=Yc(f);Pd("is not a valid refinement declaration",d)}else{f=v();g=x(d.h);f=z(f,g);g=Wu(d);if(y(f,Xu(g))){d=
S();break a}le(d);f="illegal start of declaration"+(d.Jq?" (possible cause: missing `\x3d' in front of current method body)":"");d=x(d.h).ja();Pd(f,d)}d=void 0}}Ll(c,d.lb());d=v();f=x(a.h);xf(z(d,f),Xg())&&Vu(a)}}b=c.lb();Sd(a,(new Ie).z(a));return b}
function Nda(a,b){var c=iv(a,b),d=ce(a),f=c.$a(),g=v(),h=x(a.h),n=y(z(g,h),jv());kv(a,b,pe().Kn,lv(),(new mv).Ud(k(nv)));ov(Au(b),pv())||kv(a,b,pe().Jn,qv(),(new mv).Ud(k(rv)));a.h.ia();var u=function(a){return function(){var b=sv(a);return Oda(b)}}(a),w=(new tv).z(a),D=(new Xd).z(a),N=(new ae).c(),Q=v(),ea=x(a.h);if(y(z(Q,ea),be())){var ba=ce(a),ma=ce(a),La=ba.$a(),Pa=x(a.h);if(!de(Pa)){for(var Qa=he(),Ka=[(new q).a("ScalametaParser.this.token",x(a.h))],Ba=A(new B,C()),va=0,za=Ka.length|0;va<za;)E(Ba,
Ka[va]),va=1+va|0;ie(Qa,Ba.t)}if(!ke(a.P)){le(a);var qa=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),la=Pa.ja();Pd(qa,la)}if(1!==Pa.Hb){le(a);var Ma=oe(pe(),Pa.Hb,1),Ea=Pa.ja();Pd(Ma,Ea)}a.h.ia();var tb=x(a.h);if(ue(tb)){Sd(a,(new ve).z(a));var Za=we(a,!0,w);Sd(a,(new Ae).z(a));var eb=Za}else if(Be(tb)){Sd(a,(new Ee).z(a));var kb=we(a,!0,w);Sd(a,(new Ie).z(a));eb=kb}else if(Je(tb))eb=we(a,!0,w);else{le(a);var Pb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),
(new r).d([x(a.h).oa()])),Na=x(a.h).ja();Pd(Pb,Na)}if(Ke(eb)){if(Le((Oe(),w).G(),eb.uc()))var sb=(new q).a(!0,F());else{G();var yb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),sc=G().b,sb=(new q).a(!1,H(yb,sc))}if(null===sb||!0!==I(sb)){if(null!==sb){var Ra=sb.p();if(!1===I(sb)){for(var wc=J(),Wb=(new q).a("ellipsis",Pa),Rb=(new q).a("result",eb),ub=(new q).a("evidence$4",w),fb=(new q).a("quasi",eb),Xb=Se(),lb=Te().Hc(),Eb=[Wb,Rb,
ub,fb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Xb,eb,lb)))],xc=A(new B,C()),gb=0,dc=Eb.length|0;gb<dc;)E(xc,Eb[gb]),gb=1+gb|0;K(wc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",Ra,xc.t)}}throw(new p).e(sb);
}var Fc=We(new Ze,a,eb),Qb=We(new Ze,a,eb),Bb=Fc.eb,Ib=eb.ca,mb=eb.fa(),Cb=uv(vv(),Ib,mb),Tb=Qb.Fb;Tb<Bb&&(Tb=-1+Bb|0);var mc=(new L).K(Bb,1+Tb|0),Ac=M(),Dc=O(P(Ac,Cb),R(a.ea,a.P,mc))}else Dc=eb;var Db=uv(vv(),1,Dc),Va=ma.Ga();Va<La&&(Va=-1+La|0);var ec=(new L).K(La,1+Va|0),$a=M(),vb=O(P($a,Db),R(a.ea,a.P,ec))}else vb=u();for(ff(N,vb);;){var fc=v(),Bc=x(a.h);if(y(z(fc,Bc),D))var Ub=!0;else var Vb=v(),wb=x(a.h),Ub=y(z(Vb,wb),be());if(Ub){var xb=v(),Xa=x(a.h);y(z(xb,Xa),D)&&a.h.ia();var tc=v(),ib=x(a.h);
if(y(z(tc,ib),be())){var zb=ce(a),nb=ce(a),Jb=zb.$a(),jb=x(a.h);if(!de(jb)){for(var ob=he(),gc=[(new q).a("ScalametaParser.this.token",x(a.h))],cb=A(new B,C()),Ua=0,Yb=gc.length|0;Ua<Yb;)E(cb,gc[Ua]),Ua=1+Ua|0;ie(ob,cb.t)}var Kb=jb;if(!ke(a.P)){le(a);var pb=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),hb=Kb.ja();Pd(pb,hb)}if(1!==Kb.Hb){le(a);var Lb=oe(pe(),Kb.Hb,1),Fa=Kb.ja();Pd(Lb,Fa)}a.h.ia();var bb=x(a.h);if(ue(bb)){Sd(a,(new ve).z(a));var nc=we(a,!0,w);Sd(a,(new Ae).z(a));
var db=nc}else if(Be(bb)){Sd(a,(new Ee).z(a));var uc=we(a,!0,w);Sd(a,(new Ie).z(a));db=uc}else if(Je(bb))db=we(a,!0,w);else{le(a);var Fb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),hc=x(a.h).ja();Pd(Fb,hc)}if(Ke(db)){if(Le((Oe(),w).G(),db.uc()))var $b=(new q).a(!0,F());else{G();var kc=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),lc=G().b,$b=(new q).a(!1,H(kc,lc))}if(null===$b||!0!==I($b)){if(null!==
$b){var Mb=$b.p();if(!1===I($b)){for(var Nb=J(),Gb=(new q).a("ellipsis",Kb),Sb=(new q).a("result",db),Cc=(new q).a("evidence$4",w),Ob=(new q).a("quasi",db),Zb=Se(),Ec=Te().Hc(),oc=[Gb,Sb,Cc,Ob,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Zb,db,Ec)))],pc=A(new B,C()),qc=0,Jc=oc.length|0;qc<Jc;)E(pc,oc[qc]),qc=1+qc|0;K(Nb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Mb,pc.t)}}throw(new p).e($b);}var Hc=We(new Ze,a,db),ac=We(new Ze,a,db),Lc=Hc.eb,$c=db.ca,Tc=db.fa(),Rc=uv(vv(),$c,Tc),Mc=ac.Fb;Mc<Lc&&(Mc=-1+Lc|0);var hd=(new L).K(Lc,1+Mc|0),Qc=M(),rd=O(P(Qc,Rc),R(a.ea,a.P,hd))}else rd=db;var od=uv(vv(),1,rd),Zc=nb.Ga();Zc<Jb&&(Zc=-1+Jb|0);var nd=(new L).K(Jb,1+Zc|0),zd=M(),ud=O(P(zd,od),R(a.ea,a.P,nd))}else ud=u();ff(N,ud)}else break}var wd=N.lb(),Bd=function(a){return function(b){if(Pf(b)){var c=We(new Ze,a,b),d=We(new Ze,a,b),c=c.eb;b=wv(xv(),b);d=d.Fb;d<c&&
(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,b),R(a.ea,a.P,d))}return b}}(a),Ed=G().b;if(Ed===G().b)if(wd===F())var pd=F();else{for(var vd=wd.n(),xd=U(new V,Bd(vd),F()),ee=xd,Ld=wd.o();Ld!==F();)var me=Ld.n(),fe=U(new V,Bd(me),F()),ee=ee.ga=fe,Ld=Ld.o();pd=xd}else{for(var Yd=zg(wd,Ed),Zd=wd;!Zd.g();){var qe=Zd.n();Yd.ba(Bd(qe));Zd=Zd.o()}pd=Yd.da()}var re=Pda(a);if(re.g())var Kd=!0;else var yf=v(),Cd=x(a.h),Kd=y(z(yf,Cd),Wg());if(Kd){Sd(a,(new yv).z(a));var Fe=Tu(a,Ps().pe,!1),je=v(),xe=z(je,
Fe);zv||(zv=(new Av).c());if(y(xe,zv)){if(!re.g()&&n)a:{for(var ge=pd;!ge.g();){var ye=ge.n(),ne=v();if(!y(z(ne,ye),Bv())){var Ce=!1;break a}ge=ge.o()}Ce=!0}else Ce=!1;if(!Ce){le(a);var hf=x(a.h).ja();Pd("unbound placeholder parameter",hf)}var Pe=S()}else Pe=(new T).e(Fe);if(n){var jf=Qda;Cv||(Cv=(new Dv).c());var ze=jf(Cv,b,pd,re,Pe)}else{var Me;Ev||(Ev=(new Fv).c());Me=Ev;var $e=Pe.q(),ze=Rda(Me,b,pd,re,$e)}}else{n||kv(a,b,"lazy values may not be abstract",Gv(),(new mv).Ud(k(Hv)));var kf=function(a){return function(b){if(Ke(b)||
ln(b))return b;le(a);b=Yc(b);Pd("pattern definition may not be abstract",b)}}(a),Ne=G().b;if(Ne===G().b)if(pd===F())var Ge=F();else{for(var se=pd.n(),lf=U(new V,kf(se),F()),te=lf,De=pd.o();De!==F();)var Qe=De.n(),af=U(new V,kf(Qe),F()),te=te.ga=af,De=De.o();Ge=lf}else{for(var of=zg(pd,Ne),df=pd;!df.g();){var mf=df.n();of.ba(kf(mf));df=df.o()}Ge=of.da()}if(n){var Re;Iv||(Iv=(new Jv).c());Re=Iv;var Xe=re.q(),ze=Sda(Re,b,Ge,Xe)}else{var zf;Kv||(Kv=(new Lv).c());zf=Kv;var ef=re.q(),ze=Tda(zf,b,Ge,ef)}}var $d=
d.Ga();$d<f&&($d=-1+f|0);var pf=(new L).K(f,1+$d|0),He=M();return O(P(He,ze),R(a.ea,a.P,pf))}
function Uda(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);a:{var f;if(Mv(d))f=Cu(Du(),"xml");else{if(Nv(d)&&(d=Ov(Pv(),d),!d.g())){f=d.q();f=Cu(Du(),f);break a}for(var d=he(),g=[(new q).a("ScalametaParser.this.token",x(a.h))],h=A(new B,C()),n=0,u=g.length|0;n<u;)E(h,g[n]),n=1+n|0;ie(d,h.t)}}d=Tf(a.h);d=(new rf).Ia(a,d);g=Tf(a.h);g=(new rf).Ia(a,g);d=d.va;g=g.va;g<d&&(g=-1+d|0);d=(new L).K(d,1+g|0);g=M();O(P(g,f),R(a.ea,a.P,d));f=v();d=x(a.h);y(z(f,d),Qv())&&a.h.ia();d=(new ae).c();f=(new ae).c();a:for(;;){g=
x(a.h);if(Rv(g)||Mv(g)){a.h.ia();continue a}if(Sv(g)&&(h=g,h=Tv(Uv(),h),!h.g())){g=h.q();h=Tf(a.h);n=(new rf).Ia(a,h);h=Tf(a.h);h=(new rf).Ia(a,h);n=n.va;g=Dt(Et(),g);h=h.va;h<n&&(h=-1+n|0);h=(new L).K(n,1+h|0);n=M();g=P(n,g);ff(d,O(g,R(a.ea,a.P,h)));a.h.ia();continue a}if(Vv(g)&&(h=g,h=Wv(Xv(),h),!h.g())){g=h.q();h=Tf(a.h);n=(new rf).Ia(a,h);h=Tf(a.h);h=(new rf).Ia(a,h);n=n.va;g=Dt(Et(),g);h=h.va;h<n&&(h=-1+n|0);h=(new L).K(n,1+h|0);n=M();g=P(n,g);ff(d,O(g,R(a.ea,a.P,h)));a.h.ia();continue a}if(Yv(g)||
Zv(g)){a.h.ia();ff(f,$v(a));continue a}if(aw(g)||bw(g)){a.h.ia();continue a}if(cw(g)||dw(g))a.h.ia();else{for(var g=he(),h=(new q).a("ScalametaParser.this.token",x(a.h)),n=Se(),u=x(a.h),w=ew().Hc(),h=[h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",Ue(Ve(n,u,w)))],n=A(new B,C()),u=0,w=h.length|0;u<w;)E(n,h[u]),u=1+u|0;ie(g,n.t)}break}d=d.lb();f=f.lb();
g=Vda;fw||(fw=(new gw).c());f=g(fw,d,f);c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}function ev(a){null===a.rr&&null===a.rr&&(a.rr=(new hw).z(a));return a.rr}function Mu(a){var b=v(),c=x(a.h),b=z(b,c),c=Hu(a);y(b,Iu(c))||Vu(a)}
function Wda(a){var b=ce(a),c=ce(a),b=b.$a();Sd(a,(new Ee).z(a));var d=v(),f=x(a.h),d=z(d,f),f=Nt(a);if(y(d,iw(f)))var g=!0;else if(d=v(),f=x(a.h),y(z(d,f),be())){d=a.h;d=(new kg).Ia(d.r,d.Dc);a.h.ia();try{var h=v(),n=x(a.h),g=y(z(h,n),jw())}finally{a.h=d}}else g=!1;g?(kw||(kw=(new lw).c()),g=kw,h=mw(a),g=Xda(g,h)):g=nw(a);Sd(a,(new Ie).z(a));c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,g),R(a.ea,a.P,c))}
function ow(a){var b=v(),c=x(a.h);y(z(b,c),fh())?b=!0:(b=v(),c=x(a.h),b=y(z(b,c),pw()));b&&a.h.ia()}
function Yda(a,b){var c=ce(a),d=ce(a),c=c.$a();if(jba(b)||b===qw(b.r)&&a.P.sg){var f=xh(a,!1,!1),g;var h=x(a.h);if(Je(h))g=(new rw).z(a),g=(new T).e(we(a,!0,g));else if(de(h)&&!Yf(Zf(),h).g()){(new sw).z(a);var n=(new tw).z(a),u=ce(a),h=ce(a),u=u.$a(),w=x(a.h);if(!de(w)){for(var D=he(),N=[(new q).a("ScalametaParser.this.token",x(a.h))],Q=A(new B,C()),ea=0,ba=N.length|0;ea<ba;)E(Q,N[ea]),ea=1+ea|0;ie(D,Q.t)}ke(a.P)||(le(a),D=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),
N=w.ja(),Pd(D,N));1!==w.Hb&&(le(a),D=oe(pe(),w.Hb,1),N=w.ja(),Pd(D,N));a.h.ia();D=x(a.h);ue(D)?(Sd(a,(new ve).z(a)),g=we(a,!0,n),Sd(a,(new Ae).z(a))):Be(D)?(Sd(a,(new Ee).z(a)),g=we(a,!0,n),Sd(a,(new Ie).z(a))):Je(D)?g=we(a,!0,n):(le(a),D=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),N=x(a.h).ja(),Pd(D,N));if(Ke(g)){Le((Oe(),n).G(),g.uc())?D=(new q).a(!0,F()):(G(),D=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
N=G().b,D=(new q).a(!1,H(D,N)));if(null===D||!0!==I(D)){if(null!==D&&(a=D.p(),!1===I(D))){d=J();c=(new q).a("ellipsis",w);b=(new q).a("result",g);f=(new q).a("evidence$4",n);h=(new q).a("quasi",g);u=Se();n=Te().Hc();c=[c,b,f,h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(u,g,n)))];b=A(new B,C());f=0;for(g=c.length|0;f<g;)E(b,c[f]),f=1+f|0;K(d,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
a,b.t)}throw(new p).e(D);}w=We(new Ze,a,g);n=We(new Ze,a,g);w=w.eb;D=g.ca;g=g.fa();g=uw(vw(),D,g);n=n.Fb;n<w&&(n=-1+w|0);n=(new L).K(w,1+n|0);w=M();g=O(P(w,g),R(a.ea,a.P,n))}g=uw(vw(),1,g);h=h.Ga();h<u&&(h=-1+u|0);h=(new L).K(u,1+h|0);u=M();g=P(u,g);g=(new T).e(O(g,R(a.ea,a.P,h)))}else g=ww(h)||xw(h)?(new T).e(yw(a)):S();g=g.lb();h=G();f=f.ma(g,h.b);g=ce(a);h=ce(a);u=g.$a();g=tu();h=h.Ga();h<u&&(h=-1+u|0);h=(new L).K(u,1+h|0);u=M();g=O(P(u,g),R(a.ea,a.P,h));h=Zi(a);b=zw(a,!0,b===h);b=Zda($da(),f,
g,b)}else{if(b!==qw(b.r)){f=he();b=[(new q).a("owner",b)];g=A(new B,C());h=0;for(u=b.length|0;h<u;)E(g,b[h]),h=1+h|0;ie(f,g.t)}b=$da();f=F();g=Tf(a.h);g=(new rf).Ia(a,g);h=Tf(a.h);h=(new rf).Ia(a,h);u=g.va;g=tu();h=h.va;h<u&&(h=-1+u|0);h=(new L).K(u,1+h|0);u=M();g=O(P(u,g),R(a.ea,a.P,h));h=F();b=Zda(b,f,g,h)}d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,b),R(a.ea,a.P,d))}
function aea(a){var b=xh(a,!0,!0),c=Aw(a,!1),d=G(),b=b.ma(c,d.b),b=gv(a,b);if(bea(hv(b)))return b;le(a);a=Yc(b);Pd("is not a valid template statement",a)}
function Bw(a,b){kv(a,b,pe().Dy,Gv(),(new mv).Ud(k(Hv)));var c=!1,d=x(a.h);if(Cw(d)){var f=iv(a,b),g=ce(a),f=f.$a(),c=Tf(a.h),h=(new rf).Ia(a,c),c=(new rf).Ia(a,c),d=h.va,h=Dw(Ew()),c=c.va;c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();h=O(P(d,h),R(a.ea,a.P,c));c=G().b;c=Fw(b,h,c);Sd(a,(new Gw).z(a));kv(a,b,pe().Cy,Hw(),(new mv).Ud(k(Iw)));h=wh(a);d=td((new yd).X((new r).d(["trait ",""])),(new r).d([h]));null===a.Cr&&null===a.Cr&&(a.Cr=(new Jw).z(a));zu(a,c,d,a.Cr,cea(),(new mv).Ud(k(dea)),qv(),(new mv).Ud(k(rv)));
d=td((new yd).X((new r).d(["trait ",""])),(new r).d([h]));null===a.Er&&null===a.Er&&(a.Er=(new Kw).z(a));zu(a,c,d,a.Er,pv(),(new mv).Ud(k(eea)),qv(),(new mv).Ud(k(rv)));Lw||(Lw=(new Mw).c());var c=Lw,d=Ih(a,!0,!1),n=Yda(a,qw(a)),u=Nw(a,qw(a));b=fea(c,b,h,d,n,u);g=g.Ga();g<f&&(g=-1+f|0);g=(new L).K(f,1+g|0);f=M();return O(P(f,b),R(a.ea,a.P,g))}if(Ow(d))return gea(a,b);if(Pw(d)){var c=!0,w=a.h,w=(new kg).Ia(w.r,w.Dc);a.h.ia();try{var n=v(),u=x(a.h),D=y(z(n,u),Qw())}finally{a.h=w}if(D)return f=Tf(a.h),
a.h.ia(),g=(new rf).Ia(a,f),f=(new rf).Ia(a,f),h=g.va,g=hea(),f=f.va,f<h&&(f=-1+h|0),f=(new L).K(h,1+f|0),h=M(),g=O(P(h,g),R(a.ea,a.P,f)),f=G().b,gea(a,Fw(b,g,f))}if(Rw(d))return iea(a,b);if(c){c=a.h;c=(new kg).Ia(c.r,c.Dc);a.h.ia();try{g=v(),f=x(a.h),h=y(z(g,f),Sw())}finally{a.h=c}}else h=!1;if(h)return f=Tf(a.h),a.h.ia(),g=(new rf).Ia(a,f),f=(new rf).Ia(a,f),h=g.va,g=hea(),f=f.va,f<h&&(f=-1+h|0),f=(new L).K(h,1+f|0),h=M(),g=O(P(h,g),R(a.ea,a.P,f)),f=G().b,iea(a,Fw(b,g,f));le(a);b=td((new yd).X((new r).d(["expected start of definition"])),
F());a=x(a.h).ja();Pd(b,a)}function Tw(a){Sd(a,(new Uw).z(a));var b=Tu(a,Ps().pe,!1);Sd(a,(new Vw).z(a));return b}
function jea(a,b){var c=ce(a),d=ce(a),f=c.$a(),g=!0,h=x(a.h);var n;if(tf(a).Gc(h))n=vf(a,!1);else if(Nv(h)&&!Ov(Pv(),h).g())n=kea(a);else if(Mv(h))n=Uda(a);else{var u;u=hg(h)&&!ig(jg(),h).g()?!0:Ww(h)?!0:Xw(h)?!0:Je(h)?!0:!1;if(u){var w=uf(a,!0);n=Ke(w)?w.nb((new Yw).z(a)):w}else if(nf(h)){a.h.ia();var D=qf(a.h),N=(new rf).Ia(a,D),Q=qf(a.h),ea=(new rf).Ia(a,Q),ba=N.va,ma;lea||(lea=(new Zw).c());ma=mea(null,null,null);var La=ea.va;La<ba&&(La=-1+ba|0);var Pa=(new L).K(ba,1+La|0),Qa=M();n=O(P(Qa,ma),
R(a.ea,a.P,Pa))}else if(ue(h)){var Ka=ce(a),Ba=ce(a),va=Ka.$a();Sd(a,(new ve).z(a));var za=v(),qa=x(a.h);if(y(z(za,qa),Vf()))var la=F();else{var Ma=function(a,b){return function(){return Tu(a,Ps().pe,b)}}(a,b),Ea=(new $w).z(a),tb=(new Xd).z(a),Za=(new ae).c(),eb=v(),kb=x(a.h);if(y(z(eb,kb),be())){var Pb=ce(a),Na=ce(a),sb=Pb.$a(),yb=x(a.h);if(!de(yb)){for(var sc=he(),Ra=[(new q).a("ScalametaParser.this.token",x(a.h))],wc=A(new B,C()),Wb=0,Rb=Ra.length|0;Wb<Rb;)E(wc,Ra[Wb]),Wb=1+Wb|0;ie(sc,wc.t)}if(!ke(a.P)){le(a);
var ub=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),fb=yb.ja();Pd(ub,fb)}if(1!==yb.Hb){le(a);var Xb=oe(pe(),yb.Hb,1),lb=yb.ja();Pd(Xb,lb)}a.h.ia();var Eb=x(a.h);if(ue(Eb)){Sd(a,(new ve).z(a));var xc=we(a,!0,Ea);Sd(a,(new Ae).z(a));var gb=xc}else if(Be(Eb)){Sd(a,(new Ee).z(a));var dc=we(a,!0,Ea);Sd(a,(new Ie).z(a));gb=dc}else if(Je(Eb))gb=we(a,!0,Ea);else{le(a);var Fc=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),Qb=x(a.h).ja();
Pd(Fc,Qb)}if(Ke(gb)){if(Le((Oe(),Ea).G(),gb.uc()))var Bb=(new q).a(!0,F());else{G();var Ib=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),mb=G().b,Bb=(new q).a(!1,H(Ib,mb))}if(null===Bb||!0!==I(Bb)){if(null!==Bb){var Cb=Bb.p();if(!1===I(Bb)){for(var Tb=J(),mc=(new q).a("ellipsis",yb),Ac=(new q).a("result",gb),Dc=(new q).a("evidence$4",Ea),Db=(new q).a("quasi",gb),Va=Se(),ec=Te().Hc(),$a=[mc,Ac,Dc,Db,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",
Ue(Ve(Va,gb,ec)))],vb=A(new B,C()),fc=0,Bc=$a.length|0;fc<Bc;)E(vb,$a[fc]),fc=1+fc|0;K(Tb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",Cb,vb.t)}}throw(new p).e(Bb);}var Ub=We(new Ze,a,gb),Vb=We(new Ze,a,gb),wb=Ub.eb,xb=gb.ca,Xa=gb.fa(),tc=ax(bx(),xb,Xa),ib=Vb.Fb;ib<wb&&(ib=-1+wb|0);var zb=
(new L).K(wb,1+ib|0),nb=M(),Jb=O(P(nb,tc),R(a.ea,a.P,zb))}else Jb=gb;var jb=ax(bx(),1,Jb),ob=Na.Ga();ob<sb&&(ob=-1+sb|0);var gc=(new L).K(sb,1+ob|0),cb=M(),Ua=O(P(cb,jb),R(a.ea,a.P,gc))}else Ua=Ma();for(ff(Za,Ua);;){var Yb=v(),Kb=x(a.h);if(y(z(Yb,Kb),tb))var pb=!0;else var hb=v(),Lb=x(a.h),pb=y(z(hb,Lb),be());if(pb){var Fa=v(),bb=x(a.h);y(z(Fa,bb),tb)&&a.h.ia();var nc=v(),db=x(a.h);if(y(z(nc,db),be())){var uc=ce(a),Fb=ce(a),hc=uc.$a(),$b=x(a.h);if(!de($b)){for(var kc=he(),lc=[(new q).a("ScalametaParser.this.token",
x(a.h))],Mb=A(new B,C()),Nb=0,Gb=lc.length|0;Nb<Gb;)E(Mb,lc[Nb]),Nb=1+Nb|0;ie(kc,Mb.t)}var Sb=$b;if(!ke(a.P)){le(a);var Cc=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),Ob=Sb.ja();Pd(Cc,Ob)}if(1!==Sb.Hb){le(a);var Zb=oe(pe(),Sb.Hb,1),Ec=Sb.ja();Pd(Zb,Ec)}a.h.ia();var oc=x(a.h);if(ue(oc)){Sd(a,(new ve).z(a));var pc=we(a,!0,Ea);Sd(a,(new Ae).z(a));var qc=pc}else if(Be(oc)){Sd(a,(new Ee).z(a));var Jc=we(a,!0,Ea);Sd(a,(new Ie).z(a));qc=Jc}else if(Je(oc))qc=we(a,!0,Ea);else{le(a);
var Hc=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),ac=x(a.h).ja();Pd(Hc,ac)}if(Ke(qc)){if(Le((Oe(),Ea).G(),qc.uc()))var Lc=(new q).a(!0,F());else{G();var $c=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Tc=G().b,Lc=(new q).a(!1,H($c,Tc))}if(null===Lc||!0!==I(Lc)){if(null!==Lc){var Rc=Lc.p();if(!1===I(Lc)){for(var Mc=J(),hd=(new q).a("ellipsis",Sb),Qc=(new q).a("result",qc),rd=(new q).a("evidence$4",
Ea),od=(new q).a("quasi",qc),Zc=Se(),nd=Te().Hc(),zd=[hd,Qc,rd,od,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Zc,qc,nd)))],ud=A(new B,C()),wd=0,Bd=zd.length|0;wd<Bd;)E(ud,zd[wd]),wd=1+wd|0;K(Mc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Rc,ud.t)}}throw(new p).e(Lc);}var Ed=We(new Ze,a,qc),pd=We(new Ze,a,qc),vd=Ed.eb,xd=qc.ca,ee=qc.fa(),Ld=ax(bx(),xd,ee),me=pd.Fb;me<vd&&(me=-1+vd|0);var fe=(new L).K(vd,1+me|0),Yd=M(),Zd=O(P(Yd,Ld),R(a.ea,a.P,fe))}else Zd=qc;var qe=ax(bx(),1,Zd),re=Fb.Ga();re<hc&&(re=-1+hc|0);var Kd=(new L).K(hc,1+re|0),yf=M(),Cd=O(P(yf,qe),R(a.ea,a.P,Kd))}else Cd=Ma();ff(Za,Cd)}else break}la=Za.lb()}Sd(a,(new Ae).z(a));b:{var Fe;G();var je=(new T).e(la);if(null!==je.Y&&0===qo(je.Y,1)){var xe=ro(je.Y,0);if(Ff(xe)){var ge=
null===xe?S():(new T).e((new q).a(xe.ca,xe.fa()));if(!ge.g()&&1===ge.q().Xa()){Fe=cx(a,la);break b}}}G();var ye=(new T).e(la);if(null!==ye.Y&&0===qo(ye.Y,1))Fe=ro(ye.Y,0);else{for(var ne=(new dx).z(a),Ce=G(),hf=ex(la,ne,Ce.b);!hf.g();){var Pe=hf.n();le(a);var jf=Fk(Pe,a.kh),ze=Hd(jf),Me=fx((new gx).xg(a,ze)).ja();Pd("repeated argument not allowed here",Me)}Fe=cx(a,la)}}var $e=Ba.Ga();$e<va&&($e=-1+va|0);var kf=(new L).K(va,1+$e|0),Ne=M();n=O(P(Ne,Fe),R(a.ea,a.P,kf))}else if(Be(h))g=!1,n=Wda(a);else if(hx(h)){g=
!1;a.h.ia();var Ge=qf(a.h),se=(new rf).Ia(a,Ge),lf=ce(a),te=se.va,De=nea(a);b:{var Qe,af=null===De?S():(new T).e((new al).yd(De.Si(),De.Xi(),De.Zg(),De.ub()));if(!af.g()){var of=af.q().Bb,df=af.q().qb,mf=af.q().Eb,Re=af.q().hd;if(F().w(of)){G();var Xe=(new T).e(df);if(null!==Xe.Y&&0===qo(Xe.Y,1)){var zf=ro(Xe.Y,0),ef=null===mf?S():(new T).e((new q).a(mf.xb(),mf.sc()));if(!ef.g()){var $d=ef.q().qa(),pf=ef.q().p();if(Pl($d)&&S()===pf&&F().w(Re)){var He=v(),If=x(a.h),ug=fx((new gx).xg(a,If)),Af;y(z(He,
ug),Xg())?Af=oea(pea(),De):(qea||(qea=(new ix).c()),Af=rea(zf));Qe=Af;break b}}}}}Qe=oea(pea(),De)}var vg=lf.Ga();vg<te&&(vg=-1+te|0);var Wf=(new L).K(te,1+vg|0),Mh=M();n=O(P(Mh,Qe),R(a.ea,a.P,Wf))}else{le(a);var Yg=td((new yd).X((new r).d(["illegal start of simple expression"])),F()),Og=x(a.h).ja();Pd(Yg,Og)}}var Pg=jx(a,n,g),Jf=d.Ga();Jf<f&&(Jf=-1+f|0);var Zg=(new L).K(f,1+Jf|0),ji=M();return O(P(ji,Pg),R(a.ea,a.P,Zg))}
function Aw(a,b){var c=F();a:for(;;){var d=x(a.h);if(Je(d)){var f;b:{var d=a,g=d.h,g=(new kg).Ia(g.r,g.Dc);d.h.ia();try{var h=v(),n=x(d.h);if(y(z(h,n),lg()))var u=!0;else var w=v(),D=x(d.h),u=y(z(w,D),Wg());if(u)var N=!0;else var Q=v(),ea=x(d.h),N=y(z(Q,ea),ah());if(N)var ba=!0;else var ma=v(),La=x(d.h),ba=y(z(ma,La),Hh());if(ba)var Pa=!0;else var Qa=v(),Ka=x(d.h),Pa=y(z(Qa,Ka),kx());if(Pa)var Ba=!0;else var va=v(),za=x(d.h),Ba=y(z(va,za),sea());if(Ba){f=!0;break b}var qa=v(),la=x(d.h);f=y(z(qa,la),
lx());break b}finally{d.h=g}f=void 0}if(f)return c;c=mx(a,c,nx(a),b);continue a}if(de(d)&&(g=d,!Yf(Zf(),g).g())){c=mx(a,c,nx(a),b);continue a}if(ox(a).Gc(d)){c=mx(a,c,nx(a),b);continue a}if(px(d)&&!b){a.h.ia();continue a}return c}}function nw(a){var b=ce(a),c=ce(a),b=b.$a(),d=qx(),f=Gu(a),d=rx(d,f),c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,d),R(a.ea,a.P,c))}
function tea(a,b){le(a);td((new yd).X((new r).d(["Procedure syntax is deprecated. Convert procedure `","` to method by adding `: Unit`."])),(new r).d([b]));Yc(b)}function sx(a){null===a.ns&&null===a.ns&&(a.ns=(new tx).z(a));return a.ns}function uea(a){var b=uu(vu(),F());for(vea(a,b);;){var c=v(),d=x(a.h);if(y(z(c,d),Ah()))a.h.ia(),vea(a,b);else break}return b.lb()}function sv(a){null===a.dt&&null===a.dt&&(a.dt=(new ux).z(a));return a.dt}
function gv(a,b){var c=Gv(),d=(new mv).Ud(k(Hv)),f=(new vx).z(a),g=v(),h=x(a.h);if(xf(z(g,h),f))for(var n=Bu(Au(b),d,c);!n.g();){var u=n.n();le(a);var w=Yc(u);Pd("lazy not allowed here. Only vals can be lazy",w)}var D=x(a.h),N;if(wx(D)||xx(D))N=Nda(a,b);else{var Q;if(yx(D)){var ea=a.h,ba=(new kg).Ia(ea.r,ea.Dc);a.h.ia();try{var ma=v(),La=x(a.h),Pa=xf(z(ma,La),zx())}finally{a.h=ba}var Qa;if(Pa){var Ka=iv(a,b),Ba=ce(a),va=Ka.$a();Sd(a,(new Ax).z(a));kv(a,b,pe().Kn,lv(),(new mv).Ud(k(nv)));ov(Au(b),
pv())||kv(a,b,pe().Jn,qv(),(new mv).Ud(k(rv)));var za=ch(a,!0),qa=Ih(a,!1,!0),la=zw(a,!1,!1),Ma=null!==la?ra(la):null;if(null!==Ma)var Ea=!0,tb=F();else{G();var Za=(new r).d(["tempClass is equal to null"]),eb=G().b,kb=H(Za,eb),Ea=!1,tb=kb}var Pb=tb;if(Ea)if((Oe(),null!==la&&(Ar(k(Bx),la)||ta(la)&&Le(k(Bx),k(rc))||ua(la)&&Le(k(Bx),k(vc))||Od(la)&&Le(k(Bx),k(jc))||Wa(la)&&Le(k(Bx),k(yc))||ya(la)&&Le(k(Bx),k(zc))||wa(la)&&Le(k(Bx),k(Gc))||"number"===typeof la&&Le(k(Bx),k(Ic))||"boolean"===typeof la&&
Le(k(Bx),k(ic))||void 0===la&&Le(k(Bx),k(cc)))?(new T).e(la):S()).g()){G();var Na=(new r).d(["scala.reflect.`package`.classTag[List[List[scala.meta.Term.Param]]](((ClassTag.apply[List[List[scala.meta.Term.Param]]](classOf[scala.collection.immutable.List])): scala.reflect.ClassTag[List[List[scala.meta.Term.Param]]])).unapply(temp).isDefined is false"]),sb=G().b,yb=(new q).a(!1,H(Na,sb))}else yb=(new q).a(!0,F());else var yb=(new q).a(!1,Pb);if(null===yb||!0!==I(yb)){if(null!==yb){var sc=yb.p();if(!1===
I(yb)){for(var Ra=J(),wc=[(new q).a("tempClass",Ma),(new q).a("temp",la)],Wb=A(new B,C()),Rb=0,ub=wc.length|0;Rb<ub;)E(Wb,wc[Rb]),Rb=1+Rb|0;K(Ra,"tempClass.!\x3d(null).\x26\x26(scala.reflect.`package`.classTag[List[List[scala.meta.Term.Param]]](((ClassTag.apply[List[List[scala.meta.Term.Param]]](classOf[scala.collection.immutable.List])): scala.reflect.ClassTag[List[List[scala.meta.Term.Param]]])).unapply(temp).isDefined)",sc,Wb.t)}}throw(new p).e(yb);}Bh(a,(new Cx).z(a));var fb=a.Jq;a.Jq=!0;try{var Xb=
Pda(a)}finally{a.Jq=fb}var lb=v(),Eb=x(a.h),xc=z(lb,Eb),gb=Wu(a);if(y(xc,Xu(gb)))var dc=!0;else var Fc=v(),Qb=x(a.h),dc=y(z(Fc,Qb),Xg());if(dc)if(Xb.g()){tea(a,za);var Bb=wea(),Ib=Tf(a.h),mb=(new rf).Ia(a,Ib),Cb=qf(a.h),Tb=(new rf).Ia(a,Cb),mc=mb.va,Ac=Of(Nf(),"Unit"),Dc=Tb.va;Dc<mc&&(Dc=-1+mc|0);var Db=(new L).K(mc,1+Dc|0),Va=M(),ec=O(P(Va,Ac),R(a.ea,a.P,Db)),$a=xea(Bb,b,za,qa,la,ec)}else var vb=wea(),fc=Xb.q(),$a=xea(vb,b,za,qa,la,fc);else{if(Xb.g())var Bc=v(),Ub=x(a.h),Vb=y(z(Bc,Ub),Dh());else Vb=
!1;if(Vb){tea(a,za);var wb=yea(),xb=Tf(a.h),Xa=(new rf).Ia(a,xb),tc=qf(a.h),ib=(new rf).Ia(a,tc),zb=Xa.va,nb=Of(Nf(),"Unit"),Jb=ib.va;Jb<zb&&(Jb=-1+zb|0);var jb=(new L).K(zb,1+Jb|0),ob=M(),gc=P(ob,nb),cb=(new T).e(O(gc,R(a.ea,a.P,jb))),Ua=Tu(a,Ps().pe,!1),$a=zea(wb,b,za,qa,la,cb,Ua)}else{var Yb=!1,Kb=v(),pb=x(a.h);if(y(z(Kb,pb),Wg())){a.h.ia();var hb=v(),Lb=x(a.h),Fa=z(hb,Lb);Dx||(Dx=(new Ex).c());(Yb=y(Fa,Dx))&&a.h.ia()}else Sd(a,(new Fx).z(a));var bb=Tu(a,Ps().pe,!1),nc;if(Yb){var db=Aea;Gx||(Gx=
(new Hx).c());nc=db(Gx,b,za,qa,la,Xb,bb)}else nc=zea(yea(),b,za,qa,la,Xb,bb);$a=nc}}var uc=Ba.Ga();uc<va&&(uc=-1+va|0);var Fb=(new L).K(va,1+uc|0),hc=M();Qa=O(P(hc,$a),R(a.ea,a.P,Fb))}else{var $b=iv(a,b),kc=ce(a),lc=$b.$a();Sd(a,(new Ix).z(a));kv(a,b,pe().Kn,lv(),(new mv).Ud(k(nv)));var Mb=Tf(a.h),Nb=(new rf).Ia(a,Mb),Gb=Tf(a.h),Sb=(new rf).Ia(a,Gb),Cc=Nb.va,Ob=tu(),Zb=Sb.va;Zb<Cc&&(Zb=-1+Cc|0);var Ec=(new L).K(Cc,1+Zb|0),oc=M(),pc=O(P(oc,Ob),R(a.ea,a.P,Ec));Sd(a,(new Jx).z(a));var qc,Jc=zw(a,!0,
!1);Bh(a,(new Kx).z(a));var Hc=x(a.h),ac;if(Be(Hc))ac=Bea(a);else{Sd(a,(new Lx).z(a));var Lc=v(),$c=x(a.h);ac=y(z(Lc,$c),Dh())?Bea(a):(new q).a(Cea(a),F())}var Tc=ac;if(null===Tc)throw(new p).e(Tc);var Rc=Tc.qa(),Mc=Tc.p(),hd=Dea;Mx||(Mx=(new Nx).c());qc=hd(Mx,b,pc,Jc,Rc,Mc);var Qc=kc.Ga();Qc<lc&&(Qc=-1+lc|0);var rd=(new L).K(lc,1+Qc|0),od=M();Qa=O(P(od,qc),R(a.ea,a.P,rd))}Q=Qa}else{var Zc;if(Ox(D)){var nd=iv(a,b),zd=ce(a),ud=nd.$a();Sd(a,(new Px).z(a));kv(a,b,pe().Kn,lv(),(new mv).Ud(k(nv)));kv(a,
b,pe().Ay,Hw(),(new mv).Ud(k(Iw)));ov(Au(b),pv())||kv(a,b,pe().Jn,qv(),(new mv).Ud(k(rv)));ow(a);var wd=wh(a),Bd=Ih(a,!0,!1),Ed=x(a.h);if(Qx(Ed)){a.h.ia();var pd;Rx||(Rx=(new Sx).c());pd=Rx;var vd=su(a),xd=Vd(vd),ee=Eea(pd,b,wd,Bd,xd)}else if(Tx(Ed)||Ux(Ed)||Vx(Ed)||Wx(Ed))var Ld=Fea(),me=sf(a),ee=Gea(Ld,b,wd,Bd,me);else if(Wu(a).Gc(Ed))var fe=Fea(),Yd=sf(a),ee=Gea(fe,b,wd,Bd,Yd);else{le(a);var Zd=x(a.h).ja();Pd("`\x3d', `\x3e:', or `\x3c:' expected",Zd)}var qe=zd.Ga();qe<ud&&(qe=-1+ud|0);var re=
(new L).K(ud,1+qe|0),Kd=M();Zc=O(P(Kd,ee),R(a.ea,a.P,re))}else Zc=Bw(a,b);Q=Zc}N=Q}return N}
function Hea(a){var b=ce(a),c=ce(a),b=b.$a(),d=v(),f=x(a.h);y(z(d,f),Xx())?d=(new q).a(!0,F()):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).is[scala.meta.tokens.Token.KwPackage](Token.this.KwPackage.classifier[scala.meta.tokens.Token]) is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){b=J();a=[(new q).a("ScalametaParser",
a),(new q).a("Token",Sf()),(new q).a("ScalametaParser.this.token",x(a.h))];for(var g=A(new B,C()),h=0,n=a.length|0;h<n;)E(g,a[h]),h=1+h|0;K(b,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).is[scala.meta.tokens.Token.KwPackage](Token.this.KwPackage.classifier[scala.meta.tokens.Token]).\x26\x26(org.scalameta.`package`.debug(ScalametaParser.this.token))",c,g.t)}throw(new p).e(d);
}d=a.h;d=(new kg).Ia(d.r,d.Dc);a.h.ia();try{g=v(),h=x(a.h),n=y(z(g,h),Sw())}finally{a.h=d}if(n){h=ce(a);g=ce(a);h=h.$a();Sd(a,(new Yx).z(a));Sd(a,(new Zx).z(a));$x||($x=(new ay).c());var n=$x,d=F(),f=ch(a,!0),u=Nw(a,Iea(a)),n=Jea(n,d,f,u)}else{h=ce(a);g=ce(a);h=h.$a();Sd(a,(new by).z(a));var n=cy(),d=dy(a),f=F(),u=v(),w=x(a.h);y(z(u,w),Dh())?(Sd(a,(new Ee).z(a)),f=ey(a),Sd(a,(new Ie).z(a))):Sd(a,(new fy).z(a));n=gy(n,d,f)}g=g.Ga();g<h&&(g=-1+h|0);g=(new L).K(h,1+g|0);h=M();g=O(P(h,n),R(a.ea,a.P,g));
c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,g),R(a.ea,a.P,c))}function Vu(a){var b=x(a.h);px(b)||hy(b)?a.h.ia():Sd(a,(new iy).z(a))}function jy(a,b){b=Kea(a,b);var c=v(),d=x(a.h);if(y(z(c,d),Bf())){c=a.h;c=(new kg).Ia(c.r,c.Dc);a.h.ia();try{var f=v(),g=x(a.h),h=y(z(f,g),Pu())}finally{a.h=c}}else h=!1;return h?(a.h.ia(),jy(a,b)):b}function ky(a,b){le(a);b=td((new yd).X((new r).d([""," expected but "," found"])),(new r).d([b.oa(),x(a.h).oa()]));a=x(a.h).ja();Pd(b,a)}
function Lea(a){null===a.ht&&null===a.ht&&(a.ht=(new ly).z(a));return a.ht}
function nx(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);a:{var f;if(Je(d)){var g=(new my).z(a);f=we(a,!0,g)}else if(de(d)&&!Yf(Zf(),d).g()){(new ny).z(a);var h=(new oy).z(a),d=ce(a);f=ce(a);var d=d.$a(),n=x(a.h);if(!de(n)){for(var u=he(),w=[(new q).a("ScalametaParser.this.token",x(a.h))],D=A(new B,C()),N=0,Q=w.length|0;N<Q;)E(D,w[N]),N=1+N|0;ie(u,D.t)}ke(a.P)||(le(a),u=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),w=n.ja(),Pd(u,w));1!==n.Hb&&(le(a),u=oe(pe(),n.Hb,1),w=
n.ja(),Pd(u,w));a.h.ia();u=x(a.h);ue(u)?(Sd(a,(new ve).z(a)),g=we(a,!0,h),Sd(a,(new Ae).z(a))):Be(u)?(Sd(a,(new Ee).z(a)),g=we(a,!0,h),Sd(a,(new Ie).z(a))):Je(u)?g=we(a,!0,h):(le(a),u=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),w=x(a.h).ja(),Pd(u,w));if(Ke(g)){Le((Oe(),h).G(),g.uc())?u=(new q).a(!0,F()):(G(),u=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),w=G().b,u=(new q).a(!1,H(u,w)));
if(null===u||!0!==I(u)){if(null!==u&&(a=u.p(),!1===I(u))){c=J();b=(new q).a("ellipsis",n);f=(new q).a("result",g);d=(new q).a("evidence$4",h);h=(new q).a("quasi",g);n=Se();w=Te().Hc();b=[b,f,d,h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(n,g,w)))];g=A(new B,C());f=0;for(d=b.length|0;f<d;)E(g,b[f]),f=1+f|0;K(c,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
a,g.t)}throw(new p).e(u);}n=We(new Ze,a,g);h=We(new Ze,a,g);n=n.eb;u=g.ca;g=g.fa();g=uw(vw(),u,g);h=h.Fb;h<n&&(h=-1+n|0);h=(new L).K(n,1+h|0);n=M();g=O(P(n,g),R(a.ea,a.P,h))}g=uw(vw(),1,g);f=f.Ga();f<d&&(f=-1+d|0);f=(new L).K(d,1+f|0);d=M();f=O(P(d,g),R(a.ea,a.P,f))}else if(py(d))a.h.ia(),f=Dw(Ew());else if(qy(d))a.h.ia(),f=ry();else if(sy(d))a.h.ia(),ty||(ty=(new uy).c()),f=vy(null,null,null);else if(gg(d))a.h.ia(),f=Qu();else if(wy(d))a.h.ia(),Mea||(Mea=(new xy).c()),f=Nea(null,null,null);else if(yy(d))a.h.ia(),
f=Oea();else if(ww(d))f=yw(a);else if(xw(d))f=yw(a);else{if(hg(d)&&(g=ig(jg(),d),!g.g()&&"inline"===g.q()&&a.P.Sh)){a.h.ia();Pea||(Pea=(new zy).c());f=Qea(null,null,null);break a}le(a);g=td((new yd).X((new r).d(["modifier expected but "," found"])),(new r).d([x(a.h).oa()]));d=x(a.h).ja();Pd(g,d)}}c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}
function Rea(a){Sd(a,(new Ee).z(a));var b,c=ce(a);b=ce(a);c=c.$a();Ay();var d=ce(a),f=ce(a),g=d.$a(),d=tu(),f=f.Ga();f<g&&(f=-1+g|0);f=(new L).K(g,1+f|0);g=M();d=O(P(g,d),R(a.ea,a.P,f));f=S();d=By(0,d,f);b=b.Ga();b<c&&(b=-1+c|0);b=(new L).K(c,1+b|0);c=M();c=O(P(c,d),R(a.ea,a.P,b));d=S();b=S();f=v();g=x(a.h);f=z(f,g);g=Ru(a);if(y(f,Su(g))){var f=a.h,f=(new kg).Ia(f.r,f.Dc),g=Tu(a,Ps().os,!1),h=a.h,h=(new kg).Ia(h.r,h.Dc),n=v(),u=x(a.h);if(y(z(n,u),Ag()))try{a.h=f,d=(new T).e(a.Zg()),a.h.ia()}catch(w){if(Cy(w))a.h=
h,ie(he(),Fu());else throw w;}else b=(new T).e(Ke(g)?g.nb((new Uu).z(a)):g),Mu(a)}c=d.g()?c:d.q();d=b;b=Dy(a,(new Hy).z(a),"illegal start of definition",(new Iy).z(a));d=d.lb();f=G().b;b=(new q).a(c,Sea(b,d,f));Sd(a,(new Ie).z(a));return b}function Ju(a){null===a.mr&&null===a.mr&&(a.mr=(new Jy).z(a));return a.mr}
function Tu(a,b,c){var d=ce(a),f=ce(a),g=d.$a(),h=x(a.h);if(Ky(h)){a.h.ia();var n=Tw(a);ow(a);var u=Tu(a,Ps().pe,!1),w=v(),D=x(a.h);if(y(z(w,D),Ly())){a.h.ia();My();var N=Tu(a,Ps().pe,!1),Q=Ny(n,u,N)}else{var ea=v(),ba=x(a.h);if(y(z(ea,ba),Oy())){var ma=a.h,La=(new kg).Ia(ma.r,ma.Dc);a.h.ia();try{var Pa=v(),Qa=x(a.h),Ka=y(z(Pa,Qa),Ly())}finally{a.h=La}}else Ka=!1;if(Ka){a.h.ia();a.h.ia();My();var Ba=Tu(a,Ps().pe,!1),Q=Ny(n,u,Ba)}else{My();var va=Tf(a.h),za=(new rf).Ia(a,va),qa=qf(a.h),la=(new rf).Ia(a,
qa),Ma=za.va,Ea=Py(),tb=la.va;tb<Ma&&(tb=-1+Ma|0);var Za=(new L).K(Ma,1+tb|0),eb=M(),kb=O(P(eb,Ea),R(a.ea,a.P,Za)),Q=Ny(n,u,kb)}}}else if(Qy(h)){a.h.ia();var Pb=x(a.h);if(Be(Pb)){var Na=ce(a),sb=ce(a),yb=Na.$a(),sc=Py(),Ra=v(),wc=x(a.h);if(y(z(Ra,wc),Dh())){Sd(a,(new Ee).z(a));var Wb=nw(a);Sd(a,(new Ie).z(a));var Rb=Wb}else Sd(a,(new fy).z(a)),Rb=sc;var ub=sb.Ga();ub<yb&&(ub=-1+yb|0);var fb=(new L).K(yb,1+ub|0),Xb=M(),lb=O(P(Xb,Rb),R(a.ea,a.P,fb))}else if(ue(Pb)){var Eb=Py(),xc=v(),gb=x(a.h);if(y(z(xc,
gb),Rf())){Sd(a,(new ve).z(a));var dc=Tu(a,Ps().pe,!1);Sd(a,(new Ae).z(a));lb=dc}else Sd(a,(new Ry).z(a)),lb=Eb}else lb=Tu(a,Ps().pe,!1);var Fc=v(),Qb=x(a.h);if(xf(z(Fc,Qb),Tea()))var Bb=S();else{a.h.ia();var Ib=v(),mb=x(a.h);if(xf(z(Ib,mb),Dh()))Bb=(new T).e(Tu(a,Ps().pe,!1));else{Sd(a,(new Ee).z(a));var Cb=v(),Tb=x(a.h),mc=z(Cb,Tb),Ac=Nt(a);if(y(mc,iw(Ac)))var Dc=!0;else var Db=v(),Va=x(a.h),Dc=y(z(Db,Va),be());var ec=Dc?(new T).e(mw(a)):(new T).e(Tu(a,Ps().pe,!1));Sd(a,(new Ie).z(a));Bb=ec}}var $a=
x(a.h);if(Sy($a)){a.h.ia();var vb=(new T).e(Tu(a,Ps().pe,!1))}else vb=S();var fc=!1,Bc=null;a:if(S()===Bb)var Ub=Uea(),Vb=F(),Q=Vea(Ub,lb,Vb,vb);else{if(zh(Bb)){var fc=!0,Bc=Bb,wb=Bc.Y;if(Ty(wb)){var xb=Uea(),Xa=null!==wb?ra(wb):null;if(null!==Xa)var tc=!0,ib=F();else{G();var zb=(new r).d(["tempClass is equal to null"]),nb=G().b,Jb=H(zb,nb),tc=!1,ib=Jb}var jb=ib;if(tc)if((Oe(),null!==wb&&(Ar(k(Bx),wb)||ta(wb)&&Le(k(Bx),k(rc))||ua(wb)&&Le(k(Bx),k(vc))||Od(wb)&&Le(k(Bx),k(jc))||Wa(wb)&&Le(k(Bx),k(yc))||
ya(wb)&&Le(k(Bx),k(zc))||wa(wb)&&Le(k(Bx),k(Gc))||"number"===typeof wb&&Le(k(Bx),k(Ic))||"boolean"===typeof wb&&Le(k(Bx),k(ic))||void 0===wb&&Le(k(Bx),k(cc)))?(new T).e(wb):S()).g()){G();var ob=(new r).d(["scala.reflect.`package`.classTag[List[scala.meta.Case]](((ClassTag.apply[List[scala.meta.Case]](classOf[scala.collection.immutable.List])): scala.reflect.ClassTag[List[scala.meta.Case]])).unapply(temp).isDefined is false"]),gc=G().b,cb=(new q).a(!1,H(ob,gc))}else cb=(new q).a(!0,F());else var cb=
(new q).a(!1,jb);if(null===cb||!0!==I(cb)){if(null!==cb){var Ua=cb.p();if(!1===I(cb)){for(var Yb=J(),Kb=[(new q).a("tempClass",Xa),(new q).a("temp",wb)],pb=A(new B,C()),hb=0,Lb=Kb.length|0;hb<Lb;)E(pb,Kb[hb]),hb=1+hb|0;K(Yb,"tempClass.!\x3d(null).\x26\x26(scala.reflect.`package`.classTag[List[scala.meta.Case]](((ClassTag.apply[List[scala.meta.Case]](classOf[scala.collection.immutable.List])): scala.reflect.ClassTag[List[scala.meta.Case]])).unapply(temp).isDefined)",Ua,pb.t)}}throw(new p).e(cb);}Q=
Vea(xb,lb,wb,vb);break a}}if(fc){var Fa=Bc.Y;if(pn(Fa)){Wea||(Wea=(new Uy).c());var bb=lb,nc=vb;if(null!==bb)var db=(new q).a(!0,F());else{G();var uc=(new r).d(["expr is equal to null"]),Fb=G().b,db=(new q).a(!1,H(uc,Fb))}if(null===db||!0!==I(db)){if(null!==db){var hc=db.p();if(!1===I(db)){for(var $b=J(),kc=[(new q).a("expr",bb)],lc=A(new B,C()),Mb=0,Nb=kc.length|0;Mb<Nb;)E(lc,kc[Mb]),Mb=1+Mb|0;K($b,"expr.!\x3d(null)",hc,lc.t)}}throw(new p).e(db);}if(null!==Fa)var Gb=(new q).a(!0,F());else{G();var Sb=
(new r).d(["catchp is equal to null"]),Cc=G().b,Gb=(new q).a(!1,H(Sb,Cc))}if(null===Gb||!0!==I(Gb)){if(null!==Gb){var Ob=Gb.p();if(!1===I(Gb)){for(var Zb=J(),Ec=[(new q).a("catchp",Fa)],oc=A(new B,C()),pc=0,qc=Ec.length|0;pc<qc;)E(oc,Ec[pc]),pc=1+pc|0;K(Zb,"catchp.!\x3d(null)",Ob,oc.t)}}throw(new p).e(Gb);}if(null!==nc)var Jc=(new q).a(!0,F());else{G();var Hc=(new r).d(["finallyp is equal to null"]),ac=G().b,Jc=(new q).a(!1,H(Hc,ac))}if(null===Jc||!0!==I(Jc)){if(null!==Jc){var Lc=Jc.p();if(!1===I(Jc)){for(var $c=
J(),Tc=[(new q).a("finallyp",nc)],Rc=A(new B,C()),Mc=0,hd=Tc.length|0;Mc<hd;)E(Rc,Tc[Mc]),Mc=1+Mc|0;K($c,"finallyp.!\x3d(null)",Lc,Rc.t)}}throw(new p).e(Jc);}var Qc=Xea(null,null,null);Qc.gc=bb.y(bb,Qc,"expr",bb.s);Qc.Lj=Fa.y(Fa,Qc,"catchp",Fa.s);if(nc.g())var rd=S();else var od=nc.q(),rd=(new T).e(od.y(od,Qc,"finallyp",od.s));Qc.Oj=rd;Q=Qc;break a}}for(var Zc=he(),nd=[(new q).a("catchopt",Bb)],zd=A(new B,C()),ud=0,wd=nd.length|0;ud<wd;)E(zd,nd[ud]),ud=1+ud|0;ie(Zc,zd.t)}}else if(Vy(h)){a.h.ia();
var Bd=Tw(a);ow(a);var Ed=Tu(a,Ps().pe,!1);Yea||(Yea=(new Wy).c());if(null!==Bd)var pd=(new q).a(!0,F());else{G();var vd=(new r).d(["expr is equal to null"]),xd=G().b,pd=(new q).a(!1,H(vd,xd))}if(null===pd||!0!==I(pd)){if(null!==pd){var ee=pd.p();if(!1===I(pd)){for(var Ld=J(),me=[(new q).a("expr",Bd)],fe=A(new B,C()),Yd=0,Zd=me.length|0;Yd<Zd;)E(fe,me[Yd]),Yd=1+Yd|0;K(Ld,"expr.!\x3d(null)",ee,fe.t)}}throw(new p).e(pd);}if(null!==Ed)var qe=(new q).a(!0,F());else{G();var re=(new r).d(["body is equal to null"]),
Kd=G().b,qe=(new q).a(!1,H(re,Kd))}if(null===qe||!0!==I(qe)){if(null!==qe){var yf=qe.p();if(!1===I(qe)){for(var Cd=J(),Fe=[(new q).a("body",Ed)],je=A(new B,C()),xe=0,ge=Fe.length|0;xe<ge;)E(je,Fe[xe]),xe=1+xe|0;K(Cd,"body.!\x3d(null)",yf,je.t)}}throw(new p).e(qe);}var ye=Zea(null,null,null);ye.gc=Bd.y(Bd,ye,"expr",Bd.s);ye.Kc=Ed.y(Ed,ye,"body",Ed.s);Q=ye}else if(Xy(h)){a.h.ia();for(var ne=Tu(a,Ps().pe,!1);;){var Ce=v(),hf=x(a.h),Pe=z(Ce,hf),jf=Wu(a);if(y(Pe,Xu(jf)))a.h.ia();else break}Sd(a,(new Yy).z(a));
var ze=Tw(a);$ea||($ea=(new Zy).c());if(null!==ne)var Me=(new q).a(!0,F());else{G();var $e=(new r).d(["body is equal to null"]),kf=G().b,Me=(new q).a(!1,H($e,kf))}if(null===Me||!0!==I(Me)){if(null!==Me){var Ne=Me.p();if(!1===I(Me)){for(var Ge=J(),se=[(new q).a("body",ne)],lf=A(new B,C()),te=0,De=se.length|0;te<De;)E(lf,se[te]),te=1+te|0;K(Ge,"body.!\x3d(null)",Ne,lf.t)}}throw(new p).e(Me);}if(null!==ze)var Qe=(new q).a(!0,F());else{G();var af=(new r).d(["expr is equal to null"]),of=G().b,Qe=(new q).a(!1,
H(af,of))}if(null===Qe||!0!==I(Qe)){if(null!==Qe){var df=Qe.p();if(!1===I(Qe)){for(var mf=J(),Re=[(new q).a("expr",ze)],Xe=A(new B,C()),zf=0,ef=Re.length|0;zf<ef;)E(Xe,Re[zf]),zf=1+zf|0;K(mf,"expr.!\x3d(null)",df,Xe.t)}}throw(new p).e(Qe);}var $d=afa(null,null,null);$d.Kc=ne.y(ne,$d,"body",ne.s);$d.gc=ze.y(ze,$d,"expr",ze.s);Q=$d}else if($y(h)){a.h.ia();var pf=v(),He=x(a.h);if(y(z(pf,He),Dh())){var If=F(),ug=v(),Af=x(a.h);if(y(z(ug,Af),Dh())){Sd(a,(new Ee).z(a));var vg=bfa(a);Sd(a,(new Ie).z(a));
var Wf=vg}else Sd(a,(new fy).z(a)),Wf=If}else{var Mh=F(),Yg=v(),Og=x(a.h);if(y(z(Yg,Og),Rf())){Sd(a,(new ve).z(a));var Pg=bfa(a);Sd(a,(new Ae).z(a));Wf=Pg}else Sd(a,(new Ry).z(a)),Wf=Mh}ow(a);var Jf=v(),Zg=x(a.h);if(y(z(Jf,Zg),cfa())){a.h.ia();var ji;az||(az=(new bz).c());ji=az;var jh=Tu(a,Ps().pe,!1),Q=dfa(ji,Wf,jh)}else{var $g;cz||(cz=(new dz).c());$g=cz;var Qg=Tu(a,Ps().pe,!1),Q=efa($g,Wf,Qg)}}else if(ez(h)){a.h.ia();var ij=v(),ki=x(a.h),lh=z(ij,ki),Nh=Ru(a);if(y(lh,Su(Nh))){fz||(fz=(new gz).c());
var xk=Tu(a,Ps().pe,!1),Q=ffa(xk)}else{fz||(fz=(new gz).c());var Kj=Tf(a.h),jj=(new rf).Ia(a,Kj),Di=ce(a),Lj=jj.va,bh=Py(),Oh=Di.Ga();Oh<Lj&&(Oh=-1+Lj|0);var Ph=(new L).K(Lj,1+Oh|0),Mj=M(),fl=O(P(Mj,bh),R(a.ea,a.P,Ph)),Q=ffa(fl)}}else if(hz(h)){a.h.ia();gfa||(gfa=(new iz).c());var cg=Tu(a,Ps().pe,!1);if(null!==cg)var Qh=(new q).a(!0,F());else{G();var Wl=(new r).d(["expr is equal to null"]),Nj=G().b,Qh=(new q).a(!1,H(Wl,Nj))}if(null===Qh||!0!==I(Qh)){if(null!==Qh){var Ei=Qh.p();if(!1===I(Qh)){for(var Xl=
J(),Oj=[(new q).a("expr",cg)],Pj=A(new B,C()),Qj=0,yk=Oj.length|0;Qj<yk;)E(Pj,Oj[Qj]),Qj=1+Qj|0;K(Xl,"expr.!\x3d(null)",Ei,Pj.t)}}throw(new p).e(Qh);}var li=hfa(null,null,null);li.gc=cg.y(cg,li,"expr",cg.s);Q=li}else if(gg(h))a.h.ia(),Q=Jda(a,b);else{var mi=ce(a),Zm=ce(a),wg=mi.$a(),mh=ifa(a,c),Fi=Zm.Ga();Fi<wg&&(Fi=-1+wg|0);var gl=(new L).K(wg,1+Fi|0),zk=M(),Ye=null,Ye=O(P(zk,mh),R(a.ea,a.P,gl)),hl=v(),Rj=x(a.h);if(y(z(hl,Rj),Wg())){var Rh=Ye;if(Lf(Rh)||Zk(Rh)||Ke(Rh)){a.h.ia();var $m=We(new Ze,
a,Ye),il=ce(a),Gi=$m.eb;jfa||(jfa=(new jz).c());var dg=Ye,Hi=Tu(a,Ps().pe,!0);if(null!==dg)var ni=(new q).a(!0,F());else{G();var jl=(new r).d(["lhs is equal to null"]),nh=G().b,ni=(new q).a(!1,H(jl,nh))}if(null===ni||!0!==I(ni)){if(null!==ni){var Ak=ni.p();if(!1===I(ni)){for(var oh=J(),Yl=[(new q).a("lhs",dg)],Sj=A(new B,C()),Bk=0,Zl=Yl.length|0;Bk<Zl;)E(Sj,Yl[Bk]),Bk=1+Bk|0;K(oh,"lhs.!\x3d(null)",Ak,Sj.t)}}throw(new p).e(ni);}if(null!==Hi)var xg=(new q).a(!0,F());else{G();var Tj=(new r).d(["rhs is equal to null"]),
Uj=G().b,xg=(new q).a(!1,H(Tj,Uj))}if(null===xg||!0!==I(xg)){if(null!==xg){var Ii=xg.p();if(!1===I(xg)){for(var Vj=J(),Rg=[(new q).a("rhs",Hi)],kj=A(new B,C()),Ji=0,ph=Rg.length|0;Ji<ph;)E(kj,Rg[Ji]),Ji=1+Ji|0;K(Vj,"rhs.!\x3d(null)",Ii,kj.t)}}throw(new p).e(xg);}var lj=v();if(y(z(lj,dg),kfa()))var Xf=!0,Sh=F();else{G();var Th=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](lhs)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Quasi](Term.this.Quasi.ClassifierClass[scala.meta.Term]) is false"]),
mj=G().b,qh=H(Th,mj),Xf=!1,Sh=qh}var oi=Sh;if(Xf)var eg=(new q).a(!0,F());else{var rh=v(),Wj=z(rh,dg);kz||(kz=(new lz).c());if(y(Wj,kz))var Uh=!0,Vh=F();else{G();var Ck=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](lhs)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Ref](Term.this.Ref.ClassifierClass[scala.meta.Term]) is false"]),Wh=G().b,nj=H(Ck,Wh),Uh=!1,Vh=nj}var sh=Vh;if(Uh)var oj=!0,Dk=F();else{var kl=v();if(y(z(kl,dg),lfa()))var Xh=!0,Ki=F();else{G();
var an=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](lhs)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Apply](Term.this.Apply.ClassifierClass[scala.meta.Term]) is false"]),ll=G().b,bn=H(an,ll),Xh=!1,Ki=bn}var $l=Ki;if(Xh)var Xj=F(),oj=!0,Dk=Xj;else var pi=G(),am=sh.ma($l,pi.b),oj=!1,Dk=am}var Yj=Dk;if(oj)eg=(new q).a(!0,F());else var cn=G(),eg=(new q).a(!1,oi.ma(Yj,cn.b))}if(null===eg||!0!==I(eg)){if(null!==eg){var Ek=eg.p();if(!1===I(eg)){for(var wo=
J(),pj=[(new q).a("lhs",dg),(new q).a("Term",mz())],Ey=A(new B,C()),vo=0,Gy=pj.length|0;vo<Gy;)E(Ey,pj[vo]),vo=1+vo|0;K(wo,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](lhs)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Quasi](Term.this.Quasi.ClassifierClass[scala.meta.Term]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](lhs)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Ref](Term.this.Ref.ClassifierClass[scala.meta.Term])).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](lhs)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Apply](Term.this.Apply.ClassifierClass[scala.meta.Term]))",
Ek,Ey.t)}}throw(new p).e(eg);}var kh=mfa(null,null,null);kh.pc=dg.y(dg,kh,"lhs",dg.s);kh.Kb=Hi.y(Hi,kh,"rhs",Hi.s);var fr=il.Ga();fr<Gi&&(fr=-1+Gi|0);var hJ=(new L).K(Gi,1+fr|0),cJ=M(),Ye=O(P(cJ,kh),R(a.ea,a.P,hJ))}}else{var dJ=v(),gJ=x(a.h);if(y(z(dJ,gJ),lg())){a.h.ia();var Fy=v(),dr=x(a.h);if(y(z(Fy,dr),iu()))var er=!0;else{var hB=v(),Fl=x(a.h);if(y(z(hB,Fl),be())){var xs=a.h,RL=(new kg).Ia(xs.r,xs.Dc);a.h.ia();try{var SL=v(),iB=x(a.h),er=y(z(SL,iB),iu())}finally{a.h=RL}}else er=!1}if(er){var TL=
We(new Ze,a,Ye),jB=ce(a),ys=TL.eb,op;nz||(nz=(new oz).c());op=nz;var zs=Ye,As=xh(a,!1,!0),UL=nfa(op,zs,As),Bs=jB.Ga();Bs<ys&&(Bs=-1+ys|0);var Cs=(new L).K(ys,1+Bs|0),VL=M(),Ye=O(P(VL,UL),R(a.ea,a.P,Cs))}else{var xn=v(),pp=x(a.h);if(y(z(xn,pp),pz())){var Ds=a.h,WL=(new kg).Ia(Ds.r,Ds.Dc);a.h.ia();try{var OY=Vg(a,"*")}finally{a.h=WL}}else OY=!1;if(OY)if(c){var PY=We(new Ze,a,Ye),QY=ce(a),qp=PY.eb;a.h.ia();a.h.ia();ofa||(ofa=(new qz).c());var Es=Ye;if(null!==Es)var zn=(new q).a(!0,F());else{G();var RY=
(new r).d(["expr is equal to null"]),mB=G().b,zn=(new q).a(!1,H(RY,mB))}if(null===zn||!0!==I(zn)){if(null!==zn){var B5=zn.p();if(!1===I(zn)){for(var C5=J(),SY=[(new q).a("expr",Es)],TY=A(new B,C()),nB=0,D5=SY.length|0;nB<D5;)E(TY,SY[nB]),nB=1+nB|0;K(C5,"expr.!\x3d(null)",B5,TY.t)}}throw(new p).e(zn);}var XL=pfa(null,null,null);XL.gc=Es.y(Es,XL,"expr",Es.s);var YL=QY.Ga();YL<qp&&(YL=-1+qp|0);var ZL=(new L).K(qp,1+YL|0),$L=M(),Ye=O(P($L,XL),R(a.ea,a.P,ZL))}else{le(a);var aM=x(a.h).ja();Pd("repeated argument not allowed here",
aM)}else{var bM=We(new Ze,a,Ye),E5=ce(a),cM=bM.eb;qfa||(qfa=(new rz).c());var An=Ye,Fs=rfa(a,b);if(null!==An)var Bn=(new q).a(!0,F());else{G();var F5=(new r).d(["expr is equal to null"]),rp=G().b,Bn=(new q).a(!1,H(F5,rp))}if(null===Bn||!0!==I(Bn)){if(null!==Bn){var G5=Bn.p();if(!1===I(Bn)){for(var dM=J(),pB=[(new q).a("expr",An)],eM=A(new B,C()),qB=0,H5=pB.length|0;qB<H5;)E(eM,pB[qB]),qB=1+qB|0;K(dM,"expr.!\x3d(null)",G5,eM.t)}}throw(new p).e(Bn);}if(null!==Fs)var Cn=(new q).a(!0,F());else{G();var UY=
(new r).d(["tpe is equal to null"]),I5=G().b,Cn=(new q).a(!1,H(UY,I5))}if(null===Cn||!0!==I(Cn)){if(null!==Cn){var J5=Cn.p();if(!1===I(Cn)){for(var fM=J(),gM=[(new q).a("tpe",Fs)],rB=A(new B,C()),sB=0,VY=gM.length|0;sB<VY;)E(rB,gM[sB]),sB=1+sB|0;K(fM,"tpe.!\x3d(null)",J5,rB.t)}}throw(new p).e(Cn);}var sp=sfa(null,null,null);sp.gc=An.y(An,sp,"expr",An.s);sp.qc=Fs.y(Fs,sp,"tpe",Fs.s);var tp=E5.Ga();tp<cM&&(tp=-1+cM|0);var K5=(new L).K(cM,1+tp|0),L5=M(),Ye=O(P(L5,sp),R(a.ea,a.P,K5))}}}else{var WY=v(),
tB=x(a.h);if(y(z(WY,tB),tfa())){a.h.ia();var M5=We(new Ze,a,Ye),N5=ce(a),hM=M5.eb,XY;sz||(sz=(new tz).c());XY=sz;var P5=Ye,Q5=F(),R5=v(),S5=x(a.h);if(y(z(R5,S5),Dh())){Sd(a,(new Ee).z(a));var T5=mw(a);Sd(a,(new Ie).z(a));var YY=T5}else Sd(a,(new fy).z(a)),YY=Q5;var U5=ufa(XY,P5,YY),iM=N5.Ga();iM<hM&&(iM=-1+hM|0);var V5=(new L).K(hM,1+iM|0),W5=M(),Ye=O(P(W5,U5),R(a.ea,a.P,V5))}}}var X5=v(),Y5=x(a.h);if(y(z(X5,Y5),Ag())){var vB=(new ik).c(),nm=(new ik).c(),Z5=Fk(Ye,a.kh);if(cj(Z5))var $5=v(),a6=Fk(Ye,
a.kh),b6=eo(a6),ZY=y(z($5,b6),Rf());else ZY=!1;if(ZY)var c6=v(),$Y=Fk(Ye,a.kh),jM=Hd($Y),aZ=y(z(c6,jM),Vf());else aZ=!1;var up=Ye;a:{var om;if(on(up))om=!0;else if(uz(a,vB).Dn(up))om=b!==Ps().os;else if((nm.Hg?nm.Ab:vz(a,vB,nm)).Dn(up))om=aZ||b===Ps().Hn;else{if(Rm(up)){var wB=null===up?S():(new T).e(up.pb());if(!wB.g()){for(var xB=wB.q();!xB.g();){var f6=xB.n();if(!(nm.Hg?nm.Ab:vz(a,vB,nm)).Dn(f6)){om=!1;break a}xB=xB.o()}om=!0;break a}}om=!1}}if(om){a.h.ia();var bZ=We(new Ze,a,Ye),yB=ce(a),zB=bZ.eb,
cZ=vfa(a,Ye),g6=wfa(b!==Ps().Hn?Tu(a,Ps().pe,!1):nw(a)),h6=xfa(yfa(),cZ,g6),AB=yB.Ga();AB<zB&&(AB=-1+zB|0);var kM=(new L).K(zB,1+AB|0),i6=M(),Ye=O(P(i6,h6),R(a.ea,a.P,kM))}}Q=Ye}var Gl=f.Ga();Gl<g&&(Gl=-1+g|0);var j6=(new L).K(g,1+Gl|0),k6=M();return O(P(k6,Q),R(a.ea,a.P,j6))}function uz(a,b){if(b.Hg)a=b.Ab;else{if(null===b)throw(new fk).c();a=b.Hg?b.Ab:hk(b,(new wz).z(a))}return a}function Zi(a){null===a.Rr&&null===a.Rr&&(a.Rr=(new xz).z(a));return a.Rr}
function Ih(a,b,c){Bh(a,(new yz).z(a));var d=v(),f=x(a.h);if(xf(z(d,f),Hh()))return F();Sd(a,(new Td).z(a));var g=function(a,b,c){return function(){var d=ce(a),f=ce(a),g=d.$a(),h=xh(a,!1,!0);if(b)var n=h,u=zfa(a).lb(),w=G(),h=n.ma(u,w.b);var D=zz(h);a:{var N;if(zh(D)){var Q=D.Y;if(Az(Q)&&Eda(a)){N=Q.nb((new Bz).z(a));break a}}var ba=v(),ea=x(a.h);if(y(z(ba,ea),Pu()))var za=wh(a);else{var qa=v(),la=x(a.h);if(y(z(qa,la),Ug()))var ma=(new Cz).z(a),za=we(a,!0,ma);else{var Ba=v(),va=x(a.h);if(!y(z(Ba,
va),pz())){le(a);var Ma=x(a.h).ja();Pd("identifier or `_' expected",Ma)}a.h.ia();var La=qf(a.h),Ka=(new rf).Ia(a,La),Ea=qf(a.h),Pa=(new rf).Ia(a,Ea),Fa=Ka.va,Qa=tu(),Na=Pa.va;Na<Fa&&(Na=-1+Fa|0);var Ua=(new L).K(Fa,1+Na|0),Ra=M(),za=O(P(Ra,Qa),R(a.ea,a.P,Ua))}}if(Ke(za)&&Eda(a))N=za.nb((new Dz).z(a));else{var Va=Ih(a,!0,!1),bb=sf(a),Za=(new ae).c(),$a=(new ae).c();if(c){for(;;){var cb=v(),db=x(a.h);if(y(z(cb,db),lx())){if(!a.P.tg){le(a);var eb=td((new yd).X((new r).d(["View bounds are not supported. ",
""])),(new r).d(["Use an implicit parameter instead.\nExample: Instead of `def f[A \x3c% Int](a: A)` use `def f[A](a: A)(implicit ev: A \x3d\x3e Int)`."])),fb=x(a.h).ja();Pd(eb,fb)}a.h.ia();var hb=v(),ib=x(a.h);if(y(z(hb,ib),be())){(new Ez).z(a);var Xa=(new Fz).z(a),pb=ce(a),ob=ce(a),kb=pb.$a(),nb=x(a.h);if(!de(nb)){for(var wb=he(),jb=[(new q).a("ScalametaParser.this.token",x(a.h))],tb=A(new B,C()),sb=0,ub=jb.length|0;sb<ub;)E(tb,jb[sb]),sb=1+sb|0;ie(wb,tb.t)}var lb=nb;if(!ke(a.P)){le(a);var xb=td((new yd).X((new r).d(["",
" doesn't support ellipses"])),(new r).d([a.P])),zb=lb.ja();Pd(xb,zb)}if(1!==lb.Hb){le(a);var oc=oe(pe(),lb.Hb,1),mb=lb.ja();Pd(oc,mb)}a.h.ia();var yb=x(a.h);if(ue(yb)){Sd(a,(new ve).z(a));var pc=we(a,!0,Xa);Sd(a,(new Ae).z(a));var gb=pc}else if(Be(yb)){Sd(a,(new Ee).z(a));var Bb=we(a,!0,Xa);Sd(a,(new Ie).z(a));gb=Bb}else if(Je(yb))gb=we(a,!0,Xa);else{le(a);var Cb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),Db=x(a.h).ja();Pd(Cb,Db)}if(Ke(gb)){if(Le((Oe(),
Xa).G(),gb.uc()))var vb=(new q).a(!0,F());else{G();var Fb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Ib=G().b,vb=(new q).a(!1,H(Fb,Ib))}if(null===vb||!0!==I(vb)){if(null!==vb){var Lb=vb.p();if(!1===I(vb)){for(var Mb=J(),Qb=(new q).a("ellipsis",lb),Kb=(new q).a("result",gb),Nb=(new q).a("evidence$4",Xa),Sb=(new q).a("quasi",gb),Zb=Se(),Vb=Te().Hc(),Gb=[Qb,Kb,Nb,Sb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",
Ue(Ve(Zb,gb,Vb)))],Ob=A(new B,C()),Pb=0,Xb=Gb.length|0;Pb<Xb;)E(Ob,Gb[Pb]),Pb=1+Pb|0;K(Mb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",Lb,Ob.t)}}throw(new p).e(vb);}var Ub=We(new Ze,a,gb),Rb=We(new Ze,a,gb),Tb=Ub.eb,$b=gb.ca,Eb=gb.fa(),Jb=bf(cf(),$b,Eb),Wb=Rb.Fb;Wb<Tb&&(Wb=-1+Tb|0);var dc=
(new L).K(Tb,1+Wb|0),ec=M(),fc=O(P(ec,Jb),R(a.ea,a.P,dc))}else fc=gb;var gc=bf(cf(),1,fc),Ec=ob.Ga();Ec<kb&&(Ec=-1+kb|0);var ac=(new L).K(kb,1+Ec|0),mc=M(),nc=P(mc,gc);ff(Za,O(nc,R(a.ea,a.P,ac)))}else{var kc=su(a);ff(Za,Vd(kc))}}else break}for(;;){var lc=v(),qc=x(a.h);if(y(z(lc,qc),lg())){a.h.ia();var sc=v(),uc=x(a.h);if(y(z(sc,uc),be())){(new Gz).z(a);var hc=(new Hz).z(a),xc=ce(a),Ac=ce(a),tc=xc.$a(),Rc=x(a.h);if(!de(Rc)){for(var Dc=he(),Bc=[(new q).a("ScalametaParser.this.token",x(a.h))],Cc=A(new B,
C()),wc=0,Fc=Bc.length|0;wc<Fc;)E(Cc,Bc[wc]),wc=1+wc|0;ie(Dc,Cc.t)}var Yb=Rc;if(!ke(a.P)){le(a);var Lc=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),od=Yb.ja();Pd(Lc,od)}if(1!==Yb.Hb){le(a);var Jc=oe(pe(),Yb.Hb,1),Qc=Yb.ja();Pd(Jc,Qc)}a.h.ia();var Mc=x(a.h);if(ue(Mc)){Sd(a,(new ve).z(a));var Tc=we(a,!0,hc);Sd(a,(new Ae).z(a));var Hc=Tc}else if(Be(Mc)){Sd(a,(new Ee).z(a));var Zc=we(a,!0,hc);Sd(a,(new Ie).z(a));Hc=Zc}else if(Je(Mc))Hc=we(a,!0,hc);else{le(a);var $c=td((new yd).X((new r).d(["$, ( or { expected but ",
" found"])),(new r).d([x(a.h).oa()])),rd=x(a.h).ja();Pd($c,rd)}if(Ke(Hc)){if(Le((Oe(),hc).G(),Hc.uc()))var nd=(new q).a(!0,F());else{G();var hd=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Vj=G().b,nd=(new q).a(!1,H(hd,Vj))}if(null===nd||!0!==I(nd)){if(null!==nd){var Rg=nd.p();if(!1===I(nd)){for(var kj=J(),Ji=(new q).a("ellipsis",Yb),ph=(new q).a("result",Hc),lj=(new q).a("evidence$4",hc),Xf=(new q).a("quasi",Hc),Sh=Se(),Th=Te().Hc(),
mj=[Ji,ph,lj,Xf,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Sh,Hc,Th)))],qh=A(new B,C()),oi=0,eg=mj.length|0;oi<eg;)E(qh,mj[oi]),oi=1+oi|0;K(kj,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",Rg,qh.t)}}throw(new p).e(nd);
}var rh=We(new Ze,a,Hc),Wj=We(new Ze,a,Hc),Uh=rh.eb,Vh=Hc.ca,Ck=Hc.fa(),Wh=bf(cf(),Vh,Ck),nj=Wj.Fb;nj<Uh&&(nj=-1+Uh|0);var sh=(new L).K(Uh,1+nj|0),oj=M(),Dk=O(P(oj,Wh),R(a.ea,a.P,sh))}else Dk=Hc;var kl=bf(cf(),1,Dk),Xh=Ac.Ga();Xh<tc&&(Xh=-1+tc|0);var Ki=(new L).K(tc,1+Xh|0),an=M(),ll=P(an,kl);ff($a,O(ll,R(a.ea,a.P,Ki)))}else{var bn=su(a);ff($a,Vd(bn))}}else break}}var $l;Iz||(Iz=(new Jz).c());$l=Iz;var Xj=h,pi=Za.lb(),am=$a.lb();N=Afa($l,Xj,za,Va,bb,pi,am)}}var Yj=f.Ga();Yj<g&&(Yj=-1+g|0);var cn=
(new L).K(g,1+Yj|0),Ek=M();return O(P(Ek,N),R(a.ea,a.P,cn))}}(a,b,c),h=(new Kz).z(a),n=(new Xd).z(a),u=(new ae).c(),w=v(),D=x(a.h);if(y(z(w,D),be())){var N=ce(a),Q=ce(a),ea=N.$a(),ba=x(a.h);if(!de(ba)){for(var ma=he(),La=[(new q).a("ScalametaParser.this.token",x(a.h))],Pa=A(new B,C()),Qa=0,Ka=La.length|0;Qa<Ka;)E(Pa,La[Qa]),Qa=1+Qa|0;ie(ma,Pa.t)}if(!ke(a.P)){le(a);var Ba=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),va=ba.ja();Pd(Ba,va)}if(1!==ba.Hb){le(a);var za=oe(pe(),
ba.Hb,1),qa=ba.ja();Pd(za,qa)}a.h.ia();var la=x(a.h);if(ue(la)){Sd(a,(new ve).z(a));var Ma=we(a,!0,h);Sd(a,(new Ae).z(a));var Ea=Ma}else if(Be(la)){Sd(a,(new Ee).z(a));var tb=we(a,!0,h);Sd(a,(new Ie).z(a));Ea=tb}else if(Je(la))Ea=we(a,!0,h);else{le(a);var Za=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),eb=x(a.h).ja();Pd(Za,eb)}if(Ke(Ea)){if(Le((Oe(),h).G(),Ea.uc()))var kb=(new q).a(!0,F());else{G();var Pb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
Na=G().b,kb=(new q).a(!1,H(Pb,Na))}if(null===kb||!0!==I(kb)){if(null!==kb){var sb=kb.p();if(!1===I(kb)){for(var yb=J(),sc=(new q).a("ellipsis",ba),Ra=(new q).a("result",Ea),wc=(new q).a("evidence$4",h),Wb=(new q).a("quasi",Ea),Rb=Se(),ub=Te().Hc(),fb=[sc,Ra,wc,Wb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Rb,Ea,ub)))],Xb=A(new B,C()),lb=0,Eb=fb.length|0;lb<Eb;)E(Xb,fb[lb]),lb=1+lb|0;K(yb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
sb,Xb.t)}}throw(new p).e(kb);}var xc=We(new Ze,a,Ea),gb=We(new Ze,a,Ea),dc=xc.eb,Fc=Ea.ca,Qb=Ea.fa(),Bb=Lz(Mz(),Fc,Qb),Ib=gb.Fb;Ib<dc&&(Ib=-1+dc|0);var mb=(new L).K(dc,1+Ib|0),Cb=M(),Tb=O(P(Cb,Bb),R(a.ea,a.P,mb))}else Tb=Ea;var mc=Lz(Mz(),1,Tb),Ac=Q.Ga();Ac<ea&&(Ac=-1+ea|0);var Dc=(new L).K(ea,1+Ac|0),Db=M(),Va=O(P(Db,mc),R(a.ea,a.P,Dc))}else Va=g();for(ff(u,Va);;){var ec=v(),$a=x(a.h);if(y(z(ec,$a),n))var vb=!0;else var fc=v(),Bc=x(a.h),vb=y(z(fc,Bc),be());if(vb){var Ub=v(),Vb=x(a.h);y(z(Ub,Vb),
n)&&a.h.ia();var wb=v(),xb=x(a.h);if(y(z(wb,xb),be())){var Xa=ce(a),tc=ce(a),ib=Xa.$a(),zb=x(a.h);if(!de(zb)){for(var nb=he(),Jb=[(new q).a("ScalametaParser.this.token",x(a.h))],jb=A(new B,C()),ob=0,gc=Jb.length|0;ob<gc;)E(jb,Jb[ob]),ob=1+ob|0;ie(nb,jb.t)}var cb=zb;if(!ke(a.P)){le(a);var Ua=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),Yb=cb.ja();Pd(Ua,Yb)}if(1!==cb.Hb){le(a);var Kb=oe(pe(),cb.Hb,1),pb=cb.ja();Pd(Kb,pb)}a.h.ia();var hb=x(a.h);if(ue(hb)){Sd(a,(new ve).z(a));
var Lb=we(a,!0,h);Sd(a,(new Ae).z(a));var Fa=Lb}else if(Be(hb)){Sd(a,(new Ee).z(a));var bb=we(a,!0,h);Sd(a,(new Ie).z(a));Fa=bb}else if(Je(hb))Fa=we(a,!0,h);else{le(a);var nc=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),db=x(a.h).ja();Pd(nc,db)}if(Ke(Fa)){if(Le((Oe(),h).G(),Fa.uc()))var uc=(new q).a(!0,F());else{G();var Fb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),hc=G().b,uc=(new q).a(!1,
H(Fb,hc))}if(null===uc||!0!==I(uc)){if(null!==uc){var $b=uc.p();if(!1===I(uc)){for(var kc=J(),lc=(new q).a("ellipsis",cb),Mb=(new q).a("result",Fa),Nb=(new q).a("evidence$4",h),Gb=(new q).a("quasi",Fa),Sb=Se(),Cc=Te().Hc(),Ob=[lc,Mb,Nb,Gb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Sb,Fa,Cc)))],Zb=A(new B,C()),Ec=0,oc=Ob.length|0;Ec<oc;)E(Zb,Ob[Ec]),Ec=1+Ec|0;K(kc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
$b,Zb.t)}}throw(new p).e(uc);}var pc=We(new Ze,a,Fa),qc=We(new Ze,a,Fa),Jc=pc.eb,Hc=Fa.ca,ac=Fa.fa(),Lc=Lz(Mz(),Hc,ac),$c=qc.Fb;$c<Jc&&($c=-1+Jc|0);var Tc=(new L).K(Jc,1+$c|0),Rc=M(),Mc=O(P(Rc,Lc),R(a.ea,a.P,Tc))}else Mc=Fa;var hd=Lz(Mz(),1,Mc),Qc=tc.Ga();Qc<ib&&(Qc=-1+ib|0);var rd=(new L).K(ib,1+Qc|0),od=M(),Zc=O(P(od,hd),R(a.ea,a.P,rd))}else Zc=g();ff(u,Zc)}else break}var nd=u.lb();Sd(a,(new Ud).z(a));return nd}
function Bfa(a,b){var c=v(),d=x(a.h);return y(z(c,d),b)?(a.h.ia(),a=su(a),(new T).e(Vd(a))):S()}function Cfa(a){a.h.ia();a.h.ia();a.h.ia()}
function Dfa(a,b,c,d,f){var g=x(a.h);if(Nz(g))return F();if(de(g)&&2===g.Hb){G();(new Oz).z(a);var h=(new Pz).z(a),n=ce(a),u=ce(a),w=n.$a(),D=x(a.h);if(!de(D)){for(var N=he(),Q=[(new q).a("ScalametaParser.this.token",x(a.h))],ea=A(new B,C()),ba=0,ma=Q.length|0;ba<ma;)E(ea,Q[ba]),ba=1+ba|0;ie(N,ea.t)}if(!ke(a.P)){le(a);var La=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),Pa=D.ja();Pd(La,Pa)}if(2!==D.Hb){le(a);var Qa=oe(pe(),D.Hb,2),Ka=D.ja();Pd(Qa,Ka)}a.h.ia();var Ba=
x(a.h);if(ue(Ba)){Sd(a,(new ve).z(a));var va=we(a,!0,h);Sd(a,(new Ae).z(a));var za=va}else if(Be(Ba)){Sd(a,(new Ee).z(a));var qa=we(a,!0,h);Sd(a,(new Ie).z(a));za=qa}else if(Je(Ba))za=we(a,!0,h);else{le(a);var la=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),Ma=x(a.h).ja();Pd(la,Ma)}if(Ke(za)){if(Le((Oe(),h).G(),za.uc()))var Ea=(new q).a(!0,F());else{G();var tb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
Za=G().b,Ea=(new q).a(!1,H(tb,Za))}if(null===Ea||!0!==I(Ea)){if(null!==Ea){var eb=Ea.p();if(!1===I(Ea)){for(var kb=J(),Pb=(new q).a("ellipsis",D),Na=(new q).a("result",za),sb=(new q).a("evidence$4",h),yb=(new q).a("quasi",za),sc=Se(),Ra=Te().Hc(),wc=[Pb,Na,sb,yb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(sc,za,Ra)))],Wb=A(new B,C()),Rb=0,ub=wc.length|0;Rb<ub;)E(Wb,wc[Rb]),Rb=1+Rb|0;K(kb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
eb,Wb.t)}}throw(new p).e(Ea);}var fb=We(new Ze,a,za),Xb=We(new Ze,a,za),lb=fb.eb,Eb=za.ca,xc=za.fa(),gb=Qz(Rz(),Eb,xc),dc=Xb.Fb;dc<lb&&(dc=-1+lb|0);var Fc=(new L).K(lb,1+dc|0),Qb=M(),Bb=O(P(Qb,gb),R(a.ea,a.P,Fc))}else Bb=za;var Ib=Qz(Rz(),2,Bb),mb=u.Ga();mb<w&&(mb=-1+w|0);var Cb=(new L).K(w,1+mb|0),Tb=M(),mc=P(Tb,Ib),Ac=(new r).d([O(mc,R(a.ea,a.P,Cb))]),Dc=G().b;return H(Ac,Dc)}var Db=v(),Va=x(a.h);y(z(Db,Va),Vi())&&(a.h.ia(),f.cb=!0);var ec=function(a,b,c,d,f){return function(){return mg(a,c&&f,
b,d.cb)}}(a,c,d,f,b),$a=(new Sz).z(a),vb=(new Xd).z(a),fc=(new ae).c(),Bc=v(),Ub=x(a.h);if(y(z(Bc,Ub),be())){var Vb=ce(a),wb=ce(a),xb=Vb.$a(),Xa=x(a.h);if(!de(Xa)){for(var tc=he(),ib=[(new q).a("ScalametaParser.this.token",x(a.h))],zb=A(new B,C()),nb=0,Jb=ib.length|0;nb<Jb;)E(zb,ib[nb]),nb=1+nb|0;ie(tc,zb.t)}if(!ke(a.P)){le(a);var jb=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),ob=Xa.ja();Pd(jb,ob)}if(1!==Xa.Hb){le(a);var gc=oe(pe(),Xa.Hb,1),cb=Xa.ja();Pd(gc,cb)}a.h.ia();
var Ua=x(a.h);if(ue(Ua)){Sd(a,(new ve).z(a));var Yb=we(a,!0,$a);Sd(a,(new Ae).z(a));var Kb=Yb}else if(Be(Ua)){Sd(a,(new Ee).z(a));var pb=we(a,!0,$a);Sd(a,(new Ie).z(a));Kb=pb}else if(Je(Ua))Kb=we(a,!0,$a);else{le(a);var hb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),Lb=x(a.h).ja();Pd(hb,Lb)}if(Ke(Kb)){if(Le((Oe(),$a).G(),Kb.uc()))var Fa=(new q).a(!0,F());else{G();var bb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
nc=G().b,Fa=(new q).a(!1,H(bb,nc))}if(null===Fa||!0!==I(Fa)){if(null!==Fa){var db=Fa.p();if(!1===I(Fa)){for(var uc=J(),Fb=(new q).a("ellipsis",Xa),hc=(new q).a("result",Kb),$b=(new q).a("evidence$4",$a),kc=(new q).a("quasi",Kb),lc=Se(),Mb=Te().Hc(),Nb=[Fb,hc,$b,kc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(lc,Kb,Mb)))],Gb=A(new B,C()),Sb=0,Cc=Nb.length|0;Sb<Cc;)E(Gb,Nb[Sb]),Sb=1+Sb|0;K(uc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
db,Gb.t)}}throw(new p).e(Fa);}var Ob=We(new Ze,a,Kb),Zb=We(new Ze,a,Kb),Ec=Ob.eb,oc=Kb.ca,pc=Kb.fa(),qc=Qz(Rz(),oc,pc),Jc=Zb.Fb;Jc<Ec&&(Jc=-1+Ec|0);var Hc=(new L).K(Ec,1+Jc|0),ac=M(),Lc=O(P(ac,qc),R(a.ea,a.P,Hc))}else Lc=Kb;var $c=Qz(Rz(),1,Lc),Tc=wb.Ga();Tc<xb&&(Tc=-1+xb|0);var Rc=(new L).K(xb,1+Tc|0),Mc=M(),hd=O(P(Mc,$c),R(a.ea,a.P,Rc))}else hd=ec();for(ff(fc,hd);;){var Qc=v(),rd=x(a.h);if(y(z(Qc,rd),vb))var od=!0;else var Zc=v(),nd=x(a.h),od=y(z(Zc,nd),be());if(od){var zd=v(),ud=x(a.h);y(z(zd,
ud),vb)&&a.h.ia();var wd=v(),Bd=x(a.h);if(y(z(wd,Bd),be())){var Ed=ce(a),pd=ce(a),vd=Ed.$a(),xd=x(a.h);if(!de(xd)){for(var ee=he(),Ld=[(new q).a("ScalametaParser.this.token",x(a.h))],me=A(new B,C()),fe=0,Yd=Ld.length|0;fe<Yd;)E(me,Ld[fe]),fe=1+fe|0;ie(ee,me.t)}var Zd=xd;if(!ke(a.P)){le(a);var qe=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),re=Zd.ja();Pd(qe,re)}if(1!==Zd.Hb){le(a);var Kd=oe(pe(),Zd.Hb,1),yf=Zd.ja();Pd(Kd,yf)}a.h.ia();var Cd=x(a.h);if(ue(Cd)){Sd(a,(new ve).z(a));
var Fe=we(a,!0,$a);Sd(a,(new Ae).z(a));var je=Fe}else if(Be(Cd)){Sd(a,(new Ee).z(a));var xe=we(a,!0,$a);Sd(a,(new Ie).z(a));je=xe}else if(Je(Cd))je=we(a,!0,$a);else{le(a);var ge=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),ye=x(a.h).ja();Pd(ge,ye)}if(Ke(je)){if(Le((Oe(),$a).G(),je.uc()))var ne=(new q).a(!0,F());else{G();var Ce=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),hf=G().b,ne=(new q).a(!1,
H(Ce,hf))}if(null===ne||!0!==I(ne)){if(null!==ne){var Pe=ne.p();if(!1===I(ne)){for(var jf=J(),ze=(new q).a("ellipsis",Zd),Me=(new q).a("result",je),$e=(new q).a("evidence$4",$a),kf=(new q).a("quasi",je),Ne=Se(),Ge=Te().Hc(),se=[ze,Me,$e,kf,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Ne,je,Ge)))],lf=A(new B,C()),te=0,De=se.length|0;te<De;)E(lf,se[te]),te=1+te|0;K(jf,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Pe,lf.t)}}throw(new p).e(ne);}var Qe=We(new Ze,a,je),af=We(new Ze,a,je),of=Qe.eb,df=je.ca,mf=je.fa(),Re=Qz(Rz(),df,mf),Xe=af.Fb;Xe<of&&(Xe=-1+of|0);var zf=(new L).K(of,1+Xe|0),ef=M(),$d=O(P(ef,Re),R(a.ea,a.P,zf))}else $d=je;var pf=Qz(Rz(),1,$d),He=pd.Ga();He<vd&&(He=-1+vd|0);var If=(new L).K(vd,1+He|0),ug=M(),Af=O(P(ug,pf),R(a.ea,a.P,If))}else Af=ec();ff(fc,Af)}else break}return fc.lb()}
function Tz(a,b,c){le(a);a=td((new yd).X((new r).d([""," parameters may not be call-by-name"])),(new r).d([b]));c=Yc(c);Pd(a,c)}function Wu(a){null===a.js&&null===a.js&&(a.js=(new Uz).z(a));return a.js}
function Eg(a){if(0===(1&a.ra)&&0===(1&a.ra)){var b=Vz(),c=new Wz;c.aq=a.ea;if(null===b)throw jo(wj(),null);c.r=b;var d=us();(new Xz).c();b=c.r;c=(new q).a(a.kh,d.Ea(c.aq));c=Yz(Zz(b,c));a:{if($z(c)&&(b=Efa(Ffa(),c),!b.g())){c=b.q();break a}if(aA(c)&&(Gfa||(Gfa=(new bA).c()),a=null===c?S():(new T).e((new yi).sd(c.cg,c.$m,c.yk)),!a.g()))throw a=a.q().Eb,jo(wj(),a);throw(new p).e(c);}a.QE=c;a.ra|=1}return a.QE}
function vea(a,b){var c=x(a.h);if(de(c)&&!Yf(Zf(),c).g()){(new cA).z(a);var d=(new dA).z(a),f=ce(a),c=ce(a),f=f.$a(),g=x(a.h);if(!de(g)){for(var h=he(),n=[(new q).a("ScalametaParser.this.token",x(a.h))],u=A(new B,C()),w=0,D=n.length|0;w<D;)E(u,n[w]),w=1+w|0;ie(h,u.t)}ke(a.P)||(le(a),h=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),n=g.ja(),Pd(h,n));1!==g.Hb&&(le(a),h=oe(pe(),g.Hb,1),n=g.ja(),Pd(h,n));a.h.ia();h=x(a.h);if(ue(h)){Sd(a,(new ve).z(a));var N=we(a,!0,d);Sd(a,
(new Ae).z(a))}else Be(h)?(Sd(a,(new Ee).z(a)),N=we(a,!0,d),Sd(a,(new Ie).z(a))):Je(h)?N=we(a,!0,d):(le(a),h=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),n=x(a.h).ja(),Pd(h,n));if(Ke(N)){Le((Oe(),d).G(),N.uc())?h=(new q).a(!0,F()):(G(),h=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(b=h.p(),!1===I(h))){a=J();c=(new q).a("ellipsis",
g);f=(new q).a("result",N);d=(new q).a("evidence$4",d);g=(new q).a("quasi",N);n=Se();u=Te().Hc();N=[c,f,d,g,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(n,N,u)))];c=A(new B,C());f=0;for(d=N.length|0;f<d;)E(c,N[f]),f=1+f|0;K(a,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
b,c.t)}throw(new p).e(h);}g=We(new Ze,a,N);d=We(new Ze,a,N);g=g.eb;h=N.ca;N=N.fa();N=eA(fA(),h,N);d=d.Fb;d<g&&(d=-1+g|0);d=(new L).K(g,1+d|0);g=M();N=O(P(g,N),R(a.ea,a.P,d))}N=eA(fA(),1,N);c=c.Ga();c<f&&(c=-1+f|0);c=(new L).K(f,1+c|0);f=M();N=P(f,N);ff(b,O(N,R(a.ea,a.P,c)))}else{c=ce(a);N=ce(a);c=c.$a();d=x(a.h);a:{if(Je(d)){d=a.h;d=(new kg).Ia(d.r,d.Dc);a.h.ia();try{f=qu(a,!1)}finally{a.h=d}if(!f){f=(new ru).z(a);f=we(a,!0,f);break a}}f=su(a);d=gf(f);f=Kg(f,d);d=ce(a);g=ce(a);h=d.$a();d=tu();g=g.Ga();
g<h&&(g=-1+h|0);g=(new L).K(h,1+g|0);h=M();d=O(P(h,d),R(a.ea,a.P,g));for(h=uu(vu(),F());qu(a,!1);)ff(h,wu(a));g=xu();h=h.lb();f=yu(g,f,d,h)}N=N.Ga();N<c&&(N=-1+c|0);N=(new L).K(c,1+N|0);c=M();a=O(P(c,f),R(a.ea,a.P,N));ff(b,a)}}
function Hfa(a,b){var c=!1,d=null;if(F().w(b))return F();if(rk(b)){var c=!0,d=b,f=d.ed;jm(f)&&(f=null===f?S():(new T).e((new q).a(f.mg(),f.Ld())),f.g()||(f=f.q().p(),Fm(f)&&(le(a),f=Yc(f),Pd("repeated argument not allowed here",f))))}c&&(f=d.ed,Fm(f)&&(le(a),f=Yc(f),Pd("repeated argument not allowed here",f)));if(c&&(c=d.ed,d=d.ga,null!==c))return b=Hfa(a,d),U(new V,c,b);a=he();b=[(new q).a("args",b)];d=A(new B,C());c=0;for(f=b.length|0;c<f;)E(d,b[c]),c=1+c|0;ie(a,d.t)}
function sf(a){var b=ce(a),c=ce(a),b=b.$a();Ifa||(Ifa=(new gA).c());var d=Bfa(a,(new hA).z(a)),f=Bfa(a,(new iA).z(a));if(null!==d)var g=(new q).a(!0,F());else{G();var g=(new r).d(["lo is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){c=J();b=[(new q).a("lo",d)];f=A(new B,C());d=0;for(h=b.length|0;d<h;)E(f,b[d]),d=1+d|0;K(c,"lo.!\x3d(null)",a,f.t)}throw(new p).e(g);}null!==f?g=(new q).a(!0,F()):(G(),g=(new r).d(["hi is equal to null"]),h=G().b,
g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){c=J();b=[(new q).a("hi",f)];f=A(new B,C());d=0;for(h=b.length|0;d<h;)E(f,b[d]),d=1+d|0;K(c,"hi.!\x3d(null)",a,f.t)}throw(new p).e(g);}g=jA(null,null,null);d.g()?d=S():(d=d.q(),d=(new T).e(d.y(d,g,"lo",d.s)));g.bp=d;f.g()?f=S():(f=f.q(),f=(new T).e(f.y(f,g,"hi",f.s)));g.Yo=f;c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,g),R(a.ea,a.P,c))}
function le(a){0===(16&a.ra)&&0===(16&a.ra)&&(a.Tc=(new kA).c(),a.ra|=16)}function gh(a){null===a.us&&null===a.us&&(a.us=(new lA).z(a));return a.us}function iea(a,b){var c=iv(a,b),d=ce(a),c=c.$a();Sd(a,(new mA).z(a));kv(a,b,pe().Kn,lv(),(new mv).Ud(k(nv)));ov(Au(b),pv())||kv(a,b,pe().Jn,qv(),(new mv).Ud(k(rv)));var f;nA||(nA=(new oA).c());f=nA;var g=ch(a,!0),h=Nw(a,Iea(a));b=Jfa(f,b,g,h);d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,b),R(a.ea,a.P,d))}
function at(a){var b=Se(),c=x(a.h),d=a.kh,d=pA().If(d),b=yg(b,c,d).be();if(0<=(b.length|0)&&"0x"===b.substring(0,2))return!0;b=Se();c=x(a.h);a=a.kh;a=pA().If(a);a=yg(b,c,a).be();return 0<=(a.length|0)&&"0X"===a.substring(0,2)}function qA(a){null===a.rs&&null===a.rs&&(a.rs=(new rA).z(a));return a.rs}
function gea(a,b){var c=iv(a,b),d=ce(a),c=c.$a();Sd(a,(new sA).z(a));kv(a,b,pe().Ey,pv(),(new mv).Ud(k(eea)));ov(Au(b),tA())&&kv(a,b,pe().By,Hw(),(new mv).Ud(k(Iw)));var f=wh(a),g=td((new yd).X((new r).d(["class ",""])),(new r).d([f]));null===a.Dr&&null===a.Dr&&(a.Dr=(new uA).z(a));zu(a,b,g,a.Dr,cea(),(new mv).Ud(k(dea)),lv(),(new mv).Ud(k(nv)));var g=Ih(a,!0,!0),h=Yda(a,ov(Au(b),tA())?Zi(a):$i(a));if(!a.P.dh&&ov(Au(b),tA())&&h.bd().g()){le(a);var n=td((new yd).X((new r).d(["case classes must have a parameter list; try 'case class ",
"()' or 'case object ","'"])),(new r).d([f,f])),u=x(a.h).ja();Pd(n,u)}vA||(vA=(new wA).c());n=vA;u=Nw(a,$i(a));b=Kfa(n,b,f,g,h,u);d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,b),R(a.ea,a.P,d))}
function cx(a,b){G();var c=(new T).e(b);if(null!==c.Y&&0===qo(c.Y,1)&&(c=ro(c.Y,0),Ff(c))){var d=null===c?S():(new T).e((new q).a(c.ca,c.fa()));if(!d.g()&&1===d.q().Xa())return d=We(new Ze,a,c),c=We(new Ze,a,c),d=d.eb,b=Lfa(Mfa(),b),c=c.Fb,c<d&&(c=-1+d|0),c=(new L).K(d,1+c|0),d=M(),O(P(d,b),R(a.ea,a.P,c))}a=function(){return function(a){return Lfa(Mfa(),a)}}(a);return F().w(b)?Py():rk(b)&&(c=b.ed,d=b.ga,F().w(d))?Ke(c)&&1===c.ca?a(b):c:a(b)}
function yw(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);if(ww(d))var f=function(){return function(a){return xA(yA(),a)}}(a);else if(xw(d))f=function(){return function(a){return zA(AA(),a)}}(a);else{for(var g=he(),h=(new q).a("other",d),n=Se(),u=ew().Hc(),d=[h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](other)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",Ue(Ve(n,d,u)))],h=A(new B,C()),n=0,u=d.length|0;n<u;)E(h,d[n]),n=1+n|0;ie(g,
h.t)}a.h.ia();g=v();d=x(a.h);xf(z(g,d),Hh())?(g=ce(a),d=ce(a),h=g.$a(),g=tu(),d=d.Ga(),d<h&&(d=-1+h|0),d=(new L).K(h,1+d|0),h=M(),g=O(P(h,g),R(a.ea,a.P,d)),f=f(g)):(Sd(a,(new BA).z(a)),g=v(),d=x(a.h),y(z(g,d),zx())?(g=Tf(a.h),g=(new rf).Ia(a,g),d=qf(a.h),d=(new rf).Ia(a,d),h=g.va,g=tu(),d=d.va,d<h&&(d=-1+h|0),d=(new L).K(h,1+d|0),h=M(),g=O(P(h,g),R(a.ea,a.P,d)),a.h.ia(),d=qf(a.h),h=(new rf).Ia(a,d),d=ce(a),h=h.va,g=CA(DA(),g),d=d.Ga(),d<h&&(d=-1+h|0),d=(new L).K(h,1+d|0),h=M(),g=O(P(h,g),R(a.ea,a.P,
d))):(h=ch(a,!0),Ke(h)?g=h.nb((new EA).z(a)):(d=We(new Ze,a,h),g=We(new Ze,a,h),d=d.eb,cu(),h=h.ec(),h=du(h),g=g.Fb,g<d&&(g=-1+d|0),g=(new L).K(d,1+g|0),d=M(),g=O(P(d,h),R(a.ea,a.P,g)))),f=f(g),Sd(a,(new FA).z(a)));c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}function Ru(a){null===a.wr&&null===a.wr&&(a.wr=(new GA).z(a));return a.wr}function yh(a,b){var c=Nfa(a);b.g()?c=S():(b=b.q(),c=(new T).e(We(new Ze,c.Lb,b)));return c.g()?ce(a):c.q()}
function Ofa(a){a=x(a.h);return hg(a)&&(a=ig(jg(),a),!a.g()&&(a=a.q(),a=(new cd).j(a),a=Sg(a,"`"),a=(new cd).j(a),"|"!==Tg(a,"`")))?!0:!1}function Pfa(a){Sd(a,(new ve).z(a));var b=v(),c=x(a.h);y(z(b,c),Vf())?b=F():(null===a.Jt&&null===a.Jt&&(a.Jt=(new HA).z(a)),b=IA(a.Jt));Sd(a,(new Ae).z(a));return b}function Bh(a,b){var c=v(),d=x(a.h);if(y(z(c,d),fh())){c=a.h;c=(new kg).Ia(c.r,c.Dc);a.h.ia();try{var f=v(),g=x(a.h),h=y(z(f,g),b)}finally{a.h=c}}else h=!1;h&&ih(a)}
function Qfa(a){var b=v(),c=x(a.h);if(xf(z(b,c),JA()))return F();var b=ce(a),c=ce(a),d=b.$a();KA||(KA=(new LA).c());b=MA(a).q();b=Rfa(b);c=c.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();b=O(P(d,b),R(a.ea,a.P,c));a=Qfa(a);return U(new V,b,a)}
function Sfa(a){var b=ce(a),c=ce(a),b=b.$a(),d;if(a.P.hh){var f=ce(a);d=ce(a);f=f.$a();if(""===a.P.th)var g=NA(),h=Dy(a,a.Gp,"illegal start of definition",(new OA).z(a));else{a.P.th===lr().hg?g=(new q).a(!0,F()):(G(),g=(new r).d(["ScalametaParser.this.dialect.toplevelSeparator is not equal to scala.compat.Platform.EOL"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(c=g.p(),!1===I(g))){b=J();a=[(new q).a("ScalametaParser",a)];d=A(new B,C());f=0;for(h=a.length|0;f<h;)E(d,a[f]),
f=1+f|0;K(b,"ScalametaParser.this.dialect.toplevelSeparator.\x3d\x3d(scala.compat.Platform.EOL)",c,d.t)}throw(new p).e(g);}g=NA();h=Dy(a,a.Gp,"illegal start of definition",(new PA).z(a))}}else{f=ce(a);d=ce(a);f=f.$a();a:{var n=v(),u=x(a.h);if(y(z(n,u),Xx())){n=a.h;n=(new kg).Ia(n.r,n.Dc);a.h.ia();try{var w=v(),D=x(a.h),N=y(z(w,D),Sw())}finally{a.h=n}w=!N}else w=!1;if(w){w=a.h;w=(new kg).Ia(w.r,w.Dc);a.h.ia();try{dy(a);var h=v(),Q=x(a.h),g=xf(z(h,Q),Dh());break a}finally{a.h=w}g=void 0}else g=!1}g?
(h=Tf(a.h),Sd(a,(new QA).z(a)),g=NA(),G(),Q=(new rf).Ia(a,h),h=ce(a),Q=Q.va,w=cy(),D=dy(a),N=RA(a),w=gy(w,D,N),h=h.Ga(),h<Q&&(h=-1+Q|0),h=(new L).K(Q,1+h|0),Q=M(),Q=P(Q,w),h=(new r).d([O(Q,R(a.ea,a.P,h))]),Q=G().b,h=H(h,Q)):(g=NA(),h=ey(a))}g=Tfa(g,h);d=d.Ga();d<f&&(d=-1+f|0);d=(new L).K(f,1+d|0);f=M();d=O(P(f,g),R(a.ea,a.P,d));c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,d),R(a.ea,a.P,c))}
function Ufa(a){var b=v(),c=x(a.h);if(y(z(b,c),Vf()))return!0;b=v();a=x(a.h);return y(z(b,a),og())}
function RA(a){for(;;){var b=v(),c=x(a.h);if(y(z(b,c),ah()))return F();b=v();c=x(a.h);b=z(b,c);c=Wu(a);if(y(b,Xu(c)))a.h.ia();else{b=v();c=x(a.h);if(y(z(b,c),Xx())){b=a.h;b=(new kg).Ia(b.r,b.Dc);a.h.ia();try{var d=v(),f=x(a.h),g=y(z(d,f),Sw())}finally{a.h=b}d=!g}else d=!1;if(d){f=Tf(a.h);Sd(a,(new SA).z(a));d=dy(a);g=v();b=x(a.h);if(y(z(g,b),Dh()))return g=(new rf).Ia(a,f),f=ce(a),g=g.va,b=cy(),Sd(a,(new Ee).z(a)),c=ey(a),Sd(a,(new Ie).z(a)),d=gy(b,d,c),f=f.Ga(),f<g&&(f=-1+g|0),f=(new L).K(g,1+f|
0),g=M(),d=O(P(g,d),R(a.ea,a.P,f)),Mu(a),a=RA(a),f=G(),a.Xt(d,f.b);G();g=(new rf).Ia(a,f);f=ce(a);g=g.va;b=cy();c=RA(a);d=gy(b,d,c);f=f.Ga();f<g&&(f=-1+g|0);f=(new L).K(g,1+f|0);g=M();d=P(g,d);a=(new r).d([O(d,R(a.ea,a.P,f))]);d=G().b;return H(a,d)}d=v();f=x(a.h);return y(z(d,f),Dh())?(Sd(a,(new Ee).z(a)),d=ey(a),Sd(a,(new Ie).z(a)),d):ey(a)}}}function su(a){null===a.ft&&null===a.ft&&(a.ft=(new TA).z(a));return a.ft}function Hu(a){null===a.ks&&null===a.ks&&(a.ks=(new UA).z(a));return a.ks}
function VA(a){null===a.Qr&&null===a.Qr&&(a.Qr=(new WA).z(a));return a.Qr}function Vfa(a){null===a.fr&&null===a.fr&&(a.fr=(new XA).z(a));return a.fr}function rfa(a,b){if(b===Ps().pe)return a=su(a),Vd(a);a=su(a);b=Lg().In;var c=th(a);return Mg(a,c,b)}
function Wfa(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);a:{var f;if(Mv(d))f=Cu(Du(),"xml");else{if(Nv(d)&&(d=Ov(Pv(),d),!d.g())){f=d.q();f=Cu(Du(),f);break a}for(var d=he(),g=[(new q).a("ScalametaParser.this.token",x(a.h))],h=A(new B,C()),n=0,u=g.length|0;n<u;)E(h,g[n]),n=1+n|0;ie(d,h.t)}}d=Tf(a.h);d=(new rf).Ia(a,d);g=Tf(a.h);g=(new rf).Ia(a,g);d=d.va;g=g.va;g<d&&(g=-1+d|0);d=(new L).K(d,1+g|0);g=M();f=O(P(g,f),R(a.ea,a.P,d));d=v();g=x(a.h);y(z(d,g),Qv())&&a.h.ia();g=(new ae).c();d=(new ae).c();a:for(;;){h=
x(a.h);if(Rv(h)||Mv(h)){a.h.ia();continue a}if(Sv(h)&&(n=h,n=Tv(Uv(),n),!n.g())){h=n.q();n=Tf(a.h);u=(new rf).Ia(a,n);n=Tf(a.h);n=(new rf).Ia(a,n);u=u.va;h=Dt(Et(),h);n=n.va;n<u&&(n=-1+u|0);n=(new L).K(u,1+n|0);u=M();h=P(u,h);ff(g,O(h,R(a.ea,a.P,n)));a.h.ia();continue a}if(Vv(h)&&(n=h,n=Wv(Xv(),n),!n.g())){h=n.q();n=Tf(a.h);u=(new rf).Ia(a,n);n=Tf(a.h);n=(new rf).Ia(a,n);u=u.va;h=Dt(Et(),h);n=n.va;n<u&&(n=-1+u|0);n=(new L).K(u,1+n|0);u=M();h=P(u,h);ff(g,O(h,R(a.ea,a.P,n)));a.h.ia();continue a}if(Yv(h)||
Zv(h)){a.h.ia();h=sv(a);ff(d,Xfa(h));continue a}if(aw(h)||bw(h)){a.h.ia();continue a}if(cw(h)||dw(h))a.h.ia();else{for(var h=he(),n=(new q).a("ScalametaParser.this.token",x(a.h)),u=Se(),w=x(a.h),D=ew().Hc(),n=[n,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",Ue(Ve(u,w,D)))],u=A(new B,C()),w=0,D=n.length|0;w<D;)E(u,n[w]),w=1+w|0;ie(h,u.t)}break}g=g.lb();
d=d.lb();h=Yfa;YA||(YA=(new ZA).c());f=h(YA,f,g,d);c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}
function mg(a,b,c,d){var f=ce(a),g=ce(a),f=f.$a(),h=xh(a,!1,!0);if(d){var n=h;G();var u=Tf(a.h),u=(new rf).Ia(a,u),h=qf(a.h),h=(new rf).Ia(a,h),w=u.va,u=Qu(),h=h.va;h<w&&(h=-1+w|0);h=(new L).K(w,1+h|0);w=M();u=P(w,u);u=(new r).d([O(u,R(a.ea,a.P,h))]);h=G().b;u=H(u,h);h=G();h=n.ma(u,h.b)}c&&(n=h,u=Aw(a,!1),h=G(),h=n.ma(u,h.b),kv(a,h,"lazy modifier not allowed here. Use call-by-name parameters instead.",Gv(),(new mv).Ud(k(Hv))),kv(a,h,"`sealed' modifier can be used only for classes",lv(),(new mv).Ud(k(nv))),
ov(Au(h),pv())||kv(a,h,pe().Jn,qv(),(new mv).Ud(k(rv))));c?(n=v(),u=x(a.h),n=y(z(n,u),$A())):n=!1;c?(u=v(),w=x(a.h),u=y(z(u,w),jv())):u=!1;if(n){var w=Tf(a.h),w=(new rf).Ia(a,w),D=Tf(a.h),D=(new rf).Ia(a,D),N=w.va;Zfa||(Zfa=(new aB).c());w=$fa(null,null,null);D=D.va;D<N&&(D=-1+N|0);D=(new L).K(N,1+D|0);N=M();w=O(P(N,w),R(a.ea,a.P,D));D=G().b;h=Fw(h,w,D);a.h.ia()}u&&(w=Tf(a.h),w=(new rf).Ia(a,w),D=Tf(a.h),D=(new rf).Ia(a,D),N=w.va,aga||(aga=(new bB).c()),w=bga(null,null,null),D=D.va,D<N&&(D=-1+N|0),
D=(new L).K(N,1+D|0),N=M(),w=O(P(N,w),R(a.ea,a.P,D)),D=G().b,h=Fw(h,w,D),a.h.ia());w=zz(h);a:{if(zh(w)&&(w=w.Y,Az(w)&&Ufa(a))){b=w.nb((new cB).z(a));break a}w=ch(a,!0);w=Ke(w)?w.nb((new dB).z(a)):w;if(Ke(w)&&Ufa(a))b=w.nb((new eB).z(a));else{D=v();N=x(a.h);xf(z(D,N),lg())?(D=v(),D=y(z(D,w),fB())):D=!1;if(D)b=S();else{Sd(a,(new gB).z(a));D=ng(a);N=v();if(y(z(N,D),cga())){b:{for(N=h;!N.g();){var Q=N.n();c:{if(El(Q)&&(Q=null===Q?S():(new T).e(Q.gg()),!Q.g()&&Km(Q.q()))){Q=!0;break c}Q=!1}if(Q){N=!0;
break b}N=N.o()}N=!1}!c||(b?N:N||!n&&!u)?d&&!a.P.eh&&Tz(a,"implicit",w):u?Tz(a,"`var'",w):Tz(a,"`val'",w)}b=(new T).e(D)}c=v();d=x(a.h);xf(z(c,d),Wg())?c=S():(a.h.ia(),c=(new T).e(Tu(a,Ps().pe,!1)));b=kB(lB(),h,w,b,c)}}g=g.Ga();g<f&&(g=-1+f|0);g=(new L).K(f,1+g|0);f=M();return O(P(f,b),R(a.ea,a.P,g))}
function kea(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);a:{var f;if(Mv(d))f=Cu(Du(),"xml");else{if(Nv(d)&&(d=Ov(Pv(),d),!d.g())){f=d.q();f=Cu(Du(),f);break a}for(var d=he(),g=[(new q).a("ScalametaParser.this.token",x(a.h))],h=A(new B,C()),n=0,u=g.length|0;n<u;)E(h,g[n]),n=1+n|0;ie(d,h.t)}}d=Tf(a.h);d=(new rf).Ia(a,d);g=Tf(a.h);g=(new rf).Ia(a,g);d=d.va;g=g.va;g<d&&(g=-1+d|0);d=(new L).K(d,1+g|0);g=M();f=O(P(g,f),R(a.ea,a.P,d));d=v();g=x(a.h);y(z(d,g),Qv())&&a.h.ia();g=(new ae).c();d=(new ae).c();a:for(;;){h=
x(a.h);if(Rv(h)||Mv(h)){a.h.ia();continue a}if(Sv(h)&&(n=h,n=Tv(Uv(),n),!n.g())){h=n.q();n=Tf(a.h);u=(new rf).Ia(a,n);n=Tf(a.h);n=(new rf).Ia(a,n);u=u.va;h=Dt(Et(),h);n=n.va;n<u&&(n=-1+u|0);n=(new L).K(u,1+n|0);u=M();h=P(u,h);ff(g,O(h,R(a.ea,a.P,n)));a.h.ia();continue a}if(Vv(h)&&(n=h,n=Wv(Xv(),n),!n.g())){h=n.q();n=Tf(a.h);u=(new rf).Ia(a,n);n=Tf(a.h);n=(new rf).Ia(a,n);u=u.va;h=Dt(Et(),h);n=n.va;n<u&&(n=-1+u|0);n=(new L).K(u,1+n|0);u=M();h=P(u,h);ff(g,O(h,R(a.ea,a.P,n)));a.h.ia();continue a}if(Yv(h)||
Zv(h)){a.h.ia();ff(d,$v(a));continue a}if(aw(h)||bw(h)){a.h.ia();continue a}if(cw(h)||dw(h))a.h.ia();else{for(var h=he(),n=(new q).a("ScalametaParser.this.token",x(a.h)),u=Se(),w=x(a.h),D=ew().Hc(),n=[n,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",Ue(Ve(u,w,D)))],u=A(new B,C()),w=0,D=n.length|0;w<D;)E(u,n[w]),w=1+w|0;ie(h,u.t)}break}g=g.lb();d=d.lb();
h=dga;oB||(oB=(new uB).c());f=h(oB,f,g,d);c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}
function Jda(a,b){var c=v(),d=x(a.h);xf(z(c,d),Vi())?c=(new q).a(!0,F()):(G(),c=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).isNot[scala.meta.tokens.Token.KwImplicit](Token.this.KwImplicit.classifier[scala.meta.tokens.Token]) is false"]),d=G().b,c=(new q).a(!1,H(c,d)));if(null===c||!0!==I(c)){if(null!==c&&(b=c.p(),!1===I(c))){d=J();a=[(new q).a("ScalametaParser",
a),(new q).a("Token",Sf()),(new q).a("ScalametaParser.this.token",x(a.h))];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).isNot[scala.meta.tokens.Token.KwImplicit](Token.this.KwImplicit.classifier[scala.meta.tokens.Token]).\x26\x26(org.scalameta.`package`.debug(ScalametaParser.this.token))",b,f.t)}throw(new p).e(c);
}c=qf(a.h);d=ch(a,!0);f=v();g=x(a.h);y(z(f,g),lg())?(a.h.ia(),h=(new T).e(rfa(a,b))):h=S();var g=(new rf).Ia(a,c),f=ce(a),g=g.va,n=lB();G();var u=(new rf).Ia(a,c),w=(new rf).Ia(a,c),D=u.va,u=Qu(),w=w.va;w<D&&(w=-1+D|0);w=(new L).K(D,1+w|0);D=M();u=P(D,u);u=(new r).d([O(u,R(a.ea,a.P,w))]);w=G().b;u=H(u,w);w=S();d=kB(n,u,d,h,w);f=f.Ga();f<g&&(f=-1+g|0);f=(new L).K(g,1+f|0);g=M();g=O(P(g,d),R(a.ea,a.P,f));Sd(a,(new BB).z(a));d=(new rf).Ia(a,c);c=ce(a);d=d.va;f=yfa();G();g=(new r).d([g]);h=G().b;g=H(g,
h);b=b!==Ps().Hn?Tu(a,Ps().pe,!1):nw(a);b=xfa(f,g,b);c=c.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();return O(P(d,b),R(a.ea,a.P,c))}function Pda(a){var b=v(),c=x(a.h);return y(z(b,c),lg())?(a.h.ia(),a=su(a),(new T).e(Vd(a))):S()}function Nfa(a){null===a.qs&&null===a.qs&&(a.qs=(new CB).z(a));return a.qs}function Paa(a,b,c){dh(eh(b))!==c&&(le(a),a=Yc(b),Pd("left- and right-associative operators with same precedence may not be mixed",a))}
function Nu(a){null===a.sr&&null===a.sr&&(a.sr=(new DB).z(a));return a.sr}function ih(a){var b=v(),c=x(a.h);y(z(b,c),fh())&&a.h.ia()}e.Bu=function(){null===this.Pk&&(this.Pk=(new EB).z(this))};function FB(a){null===a.Hr&&null===a.Hr&&(a.Hr=(new GB).z(a));return a.Hr}
function mw(a){for(var b=(new ae).c();;){var c=v(),d=x(a.h),f=z(c,d),g=Nt(a);if(y(f,iw(g)))var h=!0;else var n=v(),u=x(a.h),h=y(z(n,u),be());if(h){var w=v(),D=x(a.h);if(y(z(w,D),be())){(new HB).z(a);var N=(new IB).z(a),Q=ce(a),ea=ce(a),ba=Q.$a(),ma=x(a.h);if(!de(ma)){for(var La=he(),Pa=[(new q).a("ScalametaParser.this.token",x(a.h))],Qa=A(new B,C()),Ka=0,Ba=Pa.length|0;Ka<Ba;)E(Qa,Pa[Ka]),Ka=1+Ka|0;ie(La,Qa.t)}var va=ma;if(!ke(a.P)){le(a);var za=td((new yd).X((new r).d([""," doesn't support ellipses"])),
(new r).d([a.P])),qa=va.ja();Pd(za,qa)}if(1!==va.Hb){le(a);var la=oe(pe(),va.Hb,1),Ma=va.ja();Pd(la,Ma)}a.h.ia();Sd(a,(new JB).z(a));var Ea=x(a.h);if(ue(Ea)){Sd(a,(new ve).z(a));var tb=we(a,!0,N);Sd(a,(new Ae).z(a));var Za=tb}else if(Be(Ea)){Sd(a,(new Ee).z(a));var eb=we(a,!0,N);Sd(a,(new Ie).z(a));Za=eb}else if(Je(Ea))Za=we(a,!0,N);else{le(a);var kb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),Pb=x(a.h).ja();Pd(kb,Pb)}if(Ke(Za)){if(Le((Oe(),N).G(),Za.uc()))var Na=
(new q).a(!0,F());else{G();var sb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),yb=G().b,Na=(new q).a(!1,H(sb,yb))}if(null===Na||!0!==I(Na)){if(null!==Na){var sc=Na.p();if(!1===I(Na)){for(var Ra=J(),wc=(new q).a("ellipsis",va),Wb=(new q).a("result",Za),Rb=(new q).a("evidence$4",N),ub=(new q).a("quasi",Za),fb=Se(),Xb=Te().Hc(),lb=[wc,Wb,Rb,ub,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",
Ue(Ve(fb,Za,Xb)))],Eb=A(new B,C()),xc=0,gb=lb.length|0;xc<gb;)E(Eb,lb[xc]),xc=1+xc|0;K(Ra,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",sc,Eb.t)}}throw(new p).e(Na);}var dc=We(new Ze,a,Za),Fc=We(new Ze,a,Za),Qb=dc.eb,Bb=Za.ca,Ib=Za.fa(),mb=KB(LB(),Bb,Ib),Cb=Fc.Fb;Cb<Qb&&(Cb=-1+Qb|0);var Tb=
(new L).K(Qb,1+Cb|0),mc=M(),Ac=O(P(mc,mb),R(a.ea,a.P,Tb))}else Ac=Za;var Dc=KB(LB(),1,Ac),Db=ea.Ga();Db<ba&&(Db=-1+ba|0);var Va=(new L).K(ba,1+Db|0),ec=M(),$a=P(ec,Dc);for(ff(b,O($a,R(a.ea,a.P,Va)));;){var vb=v(),fc=x(a.h),Bc=z(vb,fc),Ub=Wu(a);if(y(Bc,Xu(Ub)))a.h.ia();else break}}else{var Vb=v(),wb=x(a.h);if(y(z(Vb,wb),jw())){var xb=a.h,Xa=(new kg).Ia(xb.r,xb.Dc);a.h.ia();try{var tc=v(),ib=x(a.h),zb=y(z(tc,ib),Ug())}finally{a.h=Xa}}else zb=!1;if(zb){a.h.ia();var nb=(new MB).z(a);for(ff(b,we(a,!0,
nb));;){var Jb=v(),jb=x(a.h),ob=z(Jb,jb),gc=Wu(a);if(y(ob,Xu(gc)))a.h.ia();else break}}else{a.h.ia();var cb,Ua=a,Yb=qf(Ua.h),Kb=(new rf).Ia(Ua,Yb),pb=ce(Ua),hb=Kb.va,Lb=v(),Fa=x(Ua.h);if(xf(z(Lb,Fa),jw()))var bb=(new q).a(!0,F());else{G();var nc=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).isNot[scala.meta.tokens.Token.KwCase](Token.this.KwCase.classifier[scala.meta.tokens.Token]) is false"]),
db=G().b,bb=(new q).a(!1,H(nc,db))}if(null===bb||!0!==I(bb)){if(null!==bb){var uc=bb.p();if(!1===I(bb)){for(var Fb=J(),hc=[(new q).a("ScalametaParser",Ua),(new q).a("Token",Sf()),(new q).a("ScalametaParser.this.token",x(Ua.h))],$b=A(new B,C()),kc=0,lc=hc.length|0;kc<lc;)E($b,hc[kc]),kc=1+kc|0;K(Fb,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.classifiable[scala.meta.tokens.Token]).isNot[scala.meta.tokens.Token.KwCase](Token.this.KwCase.classifier[scala.meta.tokens.Token]).\x26\x26(org.scalameta.`package`.debug(ScalametaParser.this.token))",
uc,$b.t)}}throw(new p).e(bb);}ega||(ega=(new NB).c());var Mb=sv(Ua),Nb=OB(Mb),Gb=PB(Mb,Nb),Sb=MA(Ua);Sd(Ua,(new QB).z(Ua));var Cc=Tf(Ua.h),Ob=Gu(Ua);a:{var Zb=void 0;G();var Ec=(new T).e(Ob);if(null!==Ec.Y&&0===qo(Ec.Y,1)){var oc=ro(Ec.Y,0);if(Ke(oc)){Zb=oc.nb((new RB).z(Ua));break a}}G();var pc=(new T).e(Ob);if(null!==pc.Y&&0===qo(pc.Y,1)){var qc=ro(pc.Y,0);if(pn(qc)){Zb=qc;break a}}var Jc=(new rf).Ia(Ua,Cc),Hc=qf(Ua.h),ac=(new rf).Ia(Ua,Hc),Lc=Jc.va,$c=rx(qx(),Ob),Tc=ac.va;Tc<Lc&&(Tc=-1+Lc|0);var Rc=
(new L).K(Lc,1+Tc|0),Mc=M(),Zb=O(P(Mc,$c),R(Ua.ea,Ua.P,Rc))}var hd,Qc=Gb,rd=Sb,od=Zb;if(null!==Qc)var Zc=(new q).a(!0,F());else{G();var nd=(new r).d(["pat is equal to null"]),zd=G().b,Zc=(new q).a(!1,H(nd,zd))}if(null===Zc||!0!==I(Zc)){if(null!==Zc){var ud=Zc.p();if(!1===I(Zc)){for(var wd=J(),Bd=[(new q).a("pat",Qc)],Ed=A(new B,C()),pd=0,vd=Bd.length|0;pd<vd;)E(Ed,Bd[pd]),pd=1+pd|0;K(wd,"pat.!\x3d(null)",ud,Ed.t)}}throw(new p).e(Zc);}if(null!==rd)var xd=(new q).a(!0,F());else{G();var ee=(new r).d(["cond is equal to null"]),
Ld=G().b,xd=(new q).a(!1,H(ee,Ld))}if(null===xd||!0!==I(xd)){if(null!==xd){var me=xd.p();if(!1===I(xd)){for(var fe=J(),Yd=[(new q).a("cond",rd)],Zd=A(new B,C()),qe=0,re=Yd.length|0;qe<re;)E(Zd,Yd[qe]),qe=1+qe|0;K(fe,"cond.!\x3d(null)",me,Zd.t)}}throw(new p).e(xd);}if(null!==od)var Kd=(new q).a(!0,F());else{G();var yf=(new r).d(["body is equal to null"]),Cd=G().b,Kd=(new q).a(!1,H(yf,Cd))}if(null===Kd||!0!==I(Kd)){if(null!==Kd){var Fe=Kd.p();if(!1===I(Kd)){for(var je=J(),xe=[(new q).a("body",od)],
ge=A(new B,C()),ye=0,ne=xe.length|0;ye<ne;)E(ge,xe[ye]),ye=1+ye|0;K(je,"body.!\x3d(null)",Fe,ge.t)}}throw(new p).e(Kd);}var Ce=fga(null,null,null);Ce.zh=Qc.y(Qc,Ce,"pat",Qc.s);if(rd.g())var hf=S();else var Pe=rd.q(),hf=(new T).e(Pe.y(Pe,Ce,"cond",Pe.s));Ce.uh=hf;Ce.Kc=od.y(od,Ce,"body",od.s);hd=Ce;var jf=pb.Ga();jf<hb&&(jf=-1+hb|0);var ze=(new L).K(hb,1+jf|0),Me=M();cb=O(P(Me,hd),R(Ua.ea,Ua.P,ze));ff(b,cb)}}}else break}b.g()&&Sd(a,(new SB).z(a));return b.lb()}
function $i(a){null===a.Sr&&null===a.Sr&&(a.Sr=(new TB).z(a));return a.Sr}
function UB(a){var b=ce(a),c=ce(a),b=b.$a(),d=v(),f=x(a.h);if(y(z(d,f),pz()))a.h.ia(),gga||(gga=(new VB).c()),d=hga(null,null,null);else{d=v();f=x(a.h);if(y(z(d,f),Ug()))bu(),d=(new WB).z(a),d=we(a,!0,d);else{var g=ch(a,!0);bu();f=We(new Ze,a,g);d=We(new Ze,a,g);f=f.eb;cu();g=g.ec();g=du(g);d=d.Fb;d<f&&(d=-1+f|0);d=(new L).K(f,1+d|0);f=M();d=O(P(f,g),R(a.ea,a.P,d))}d=Bda(d)}c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,d),R(a.ea,a.P,c))}
function ey(a){return Dy(a,(new XB).z(a),"expected class or object definition",(new YB).z(a))}
function Dy(a,b,c){for(var d=(new ae).c();;){var f=v(),g=x(a.h),f=z(f,g),g=Hu(a);if(y(f,Iu(g)))break;else{if(b.vf(x(a.h)))var h=!0;else if(f=v(),g=x(a.h),y(z(f,g),be())){f=a.h;f=(new kg).Ia(f.r,f.Dc);a.h.ia();try{var g=a,n=b,u=v(),w=x(g.h);if(y(z(u,w),Rf()))var D=!0;else var N=v(),Q=x(g.h),D=y(z(N,Q),Dh());D&&g.h.ia();h=n.vf(x(g.h))}finally{a.h=f}}else h=!1;h?ff(d,b.Ea(x(a.h))):(f=v(),g=x(a.h),f=z(f,g),g=Wu(a),y(f,Xu(g))||(le(a),f=x(a.h).ja(),Pd(c,f)));Mu(a)}}return d.lb()}
function zw(a,b,c){var d=(new Kl).qj(!1),f=!0,g=(new ae).c();for(Bh(a,(new ZB).z(a));;){if(d.cb)h=!1;else var h=v(),n=x(a.h),h=y(z(h,n),Rf());if(h)a.h.ia(),ff(g,Dfa(a,f,b,c,d)),Sd(a,(new $B).z(a)),Bh(a,(new aC).z(a)),f=!1;else break}return g.lb()}function Vg(a,b){a=x(a.h);return hg(a)&&(a=ig(jg(),a),!a.g()&&(a=a.q(),a=(new cd).j(a),a=Sg(a,"`"),a=(new cd).j(a),Tg(a,"`")===b))?!0:!1}
function wu(a){var b=x(a.h);if(Be(b)){G();var c=(new r).d([Wda(a)]),d=G().b;return H(c,d)}if(ue(b)){Sd(a,(new ve).z(a));var f=x(a.h);var g;if(Nz(f))g=F();else if(de(f)&&2===f.Hb){G();(new bC).z(a);var h=(new cC).z(a),n=ce(a),u=ce(a),w=n.$a(),D=x(a.h);if(!de(D)){for(var N=he(),Q=[(new q).a("ScalametaParser.this.token",x(a.h))],ea=A(new B,C()),ba=0,ma=Q.length|0;ba<ma;)E(ea,Q[ba]),ba=1+ba|0;ie(N,ea.t)}if(!ke(a.P)){le(a);var La=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),
Pa=D.ja();Pd(La,Pa)}if(2!==D.Hb){le(a);var Qa=oe(pe(),D.Hb,2),Ka=D.ja();Pd(Qa,Ka)}a.h.ia();var Ba=x(a.h);if(ue(Ba)){Sd(a,(new ve).z(a));var va=we(a,!0,h);Sd(a,(new Ae).z(a));var za=va}else if(Be(Ba)){Sd(a,(new Ee).z(a));var qa=we(a,!0,h);Sd(a,(new Ie).z(a));za=qa}else if(Je(Ba))za=we(a,!0,h);else{le(a);var la=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),Ma=x(a.h).ja();Pd(la,Ma)}if(Ke(za)){if(Le((Oe(),h).G(),za.uc()))var Ea=(new q).a(!0,F());else{G();var tb=
(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Za=G().b,Ea=(new q).a(!1,H(tb,Za))}if(null===Ea||!0!==I(Ea)){if(null!==Ea){var eb=Ea.p();if(!1===I(Ea)){for(var kb=J(),Pb=(new q).a("ellipsis",D),Na=(new q).a("result",za),sb=(new q).a("evidence$4",h),yb=(new q).a("quasi",za),sc=Se(),Ra=Te().Hc(),wc=[Pb,Na,sb,yb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(sc,
za,Ra)))],Wb=A(new B,C()),Rb=0,ub=wc.length|0;Rb<ub;)E(Wb,wc[Rb]),Rb=1+Rb|0;K(kb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",eb,Wb.t)}}throw(new p).e(Ea);}var fb=We(new Ze,a,za),Xb=We(new Ze,a,za),lb=fb.eb,Eb=za.ca,xc=za.fa(),gb=ax(bx(),Eb,xc),dc=Xb.Fb;dc<lb&&(dc=-1+lb|0);var Fc=(new L).K(lb,
1+dc|0),Qb=M(),Bb=O(P(Qb,gb),R(a.ea,a.P,Fc))}else Bb=za;var Ib=ax(bx(),2,Bb),mb=u.Ga();mb<w&&(mb=-1+w|0);var Cb=(new L).K(w,1+mb|0),Tb=M(),mc=P(Tb,Ib),Ac=(new r).d([O(mc,R(a.ea,a.P,Cb))]),Dc=G().b;g=H(Ac,Dc)}else{var Db=function(a){return function(){return Tu(a,Ps().pe,!0)}}(a),Va=(new dC).z(a),ec=(new Xd).z(a),$a=(new ae).c(),vb=v(),fc=x(a.h);if(y(z(vb,fc),be())){var Bc=ce(a),Ub=ce(a),Vb=Bc.$a(),wb=x(a.h);if(!de(wb)){for(var xb=he(),Xa=[(new q).a("ScalametaParser.this.token",x(a.h))],tc=A(new B,
C()),ib=0,zb=Xa.length|0;ib<zb;)E(tc,Xa[ib]),ib=1+ib|0;ie(xb,tc.t)}if(!ke(a.P)){le(a);var nb=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),Jb=wb.ja();Pd(nb,Jb)}if(1!==wb.Hb){le(a);var jb=oe(pe(),wb.Hb,1),ob=wb.ja();Pd(jb,ob)}a.h.ia();var gc=x(a.h);if(ue(gc)){Sd(a,(new ve).z(a));var cb=we(a,!0,Va);Sd(a,(new Ae).z(a));var Ua=cb}else if(Be(gc)){Sd(a,(new Ee).z(a));var Yb=we(a,!0,Va);Sd(a,(new Ie).z(a));Ua=Yb}else if(Je(gc))Ua=we(a,!0,Va);else{le(a);var Kb=td((new yd).X((new r).d(["$, ( or { expected but ",
" found"])),(new r).d([x(a.h).oa()])),pb=x(a.h).ja();Pd(Kb,pb)}if(Ke(Ua)){if(Le((Oe(),Va).G(),Ua.uc()))var hb=(new q).a(!0,F());else{G();var Lb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Fa=G().b,hb=(new q).a(!1,H(Lb,Fa))}if(null===hb||!0!==I(hb)){if(null!==hb){var bb=hb.p();if(!1===I(hb)){for(var nc=J(),db=(new q).a("ellipsis",wb),uc=(new q).a("result",Ua),Fb=(new q).a("evidence$4",Va),hc=(new q).a("quasi",Ua),$b=Se(),kc=Te().Hc(),
lc=[db,uc,Fb,hc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve($b,Ua,kc)))],Mb=A(new B,C()),Nb=0,Gb=lc.length|0;Nb<Gb;)E(Mb,lc[Nb]),Nb=1+Nb|0;K(nc,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",bb,Mb.t)}}throw(new p).e(hb);
}var Sb=We(new Ze,a,Ua),Cc=We(new Ze,a,Ua),Ob=Sb.eb,Zb=Ua.ca,Ec=Ua.fa(),oc=ax(bx(),Zb,Ec),pc=Cc.Fb;pc<Ob&&(pc=-1+Ob|0);var qc=(new L).K(Ob,1+pc|0),Jc=M(),Hc=O(P(Jc,oc),R(a.ea,a.P,qc))}else Hc=Ua;var ac=ax(bx(),1,Hc),Lc=Ub.Ga();Lc<Vb&&(Lc=-1+Vb|0);var $c=(new L).K(Vb,1+Lc|0),Tc=M(),Rc=O(P(Tc,ac),R(a.ea,a.P,$c))}else Rc=Db();for(ff($a,Rc);;){var Mc=v(),hd=x(a.h);if(y(z(Mc,hd),ec))var Qc=!0;else var rd=v(),od=x(a.h),Qc=y(z(rd,od),be());if(Qc){var Zc=v(),nd=x(a.h);y(z(Zc,nd),ec)&&a.h.ia();var zd=v(),
ud=x(a.h);if(y(z(zd,ud),be())){var wd=ce(a),Bd=ce(a),Ed=wd.$a(),pd=x(a.h);if(!de(pd)){for(var vd=he(),xd=[(new q).a("ScalametaParser.this.token",x(a.h))],ee=A(new B,C()),Ld=0,me=xd.length|0;Ld<me;)E(ee,xd[Ld]),Ld=1+Ld|0;ie(vd,ee.t)}var fe=pd;if(!ke(a.P)){le(a);var Yd=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),Zd=fe.ja();Pd(Yd,Zd)}if(1!==fe.Hb){le(a);var qe=oe(pe(),fe.Hb,1),re=fe.ja();Pd(qe,re)}a.h.ia();var Kd=x(a.h);if(ue(Kd)){Sd(a,(new ve).z(a));var yf=we(a,!0,Va);
Sd(a,(new Ae).z(a));var Cd=yf}else if(Be(Kd)){Sd(a,(new Ee).z(a));var Fe=we(a,!0,Va);Sd(a,(new Ie).z(a));Cd=Fe}else if(Je(Kd))Cd=we(a,!0,Va);else{le(a);var je=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),xe=x(a.h).ja();Pd(je,xe)}if(Ke(Cd)){if(Le((Oe(),Va).G(),Cd.uc()))var ge=(new q).a(!0,F());else{G();var ye=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),ne=G().b,ge=(new q).a(!1,H(ye,ne))}if(null===
ge||!0!==I(ge)){if(null!==ge){var Ce=ge.p();if(!1===I(ge)){for(var hf=J(),Pe=(new q).a("ellipsis",fe),jf=(new q).a("result",Cd),ze=(new q).a("evidence$4",Va),Me=(new q).a("quasi",Cd),$e=Se(),kf=Te().Hc(),Ne=[Pe,jf,ze,Me,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve($e,Cd,kf)))],Ge=A(new B,C()),se=0,lf=Ne.length|0;se<lf;)E(Ge,Ne[se]),se=1+se|0;K(hf,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Ce,Ge.t)}}throw(new p).e(ge);}var te=We(new Ze,a,Cd),De=We(new Ze,a,Cd),Qe=te.eb,af=Cd.ca,of=Cd.fa(),df=ax(bx(),af,of),mf=De.Fb;mf<Qe&&(mf=-1+Qe|0);var Re=(new L).K(Qe,1+mf|0),Xe=M(),zf=O(P(Xe,df),R(a.ea,a.P,Re))}else zf=Cd;var ef=ax(bx(),1,zf),$d=Bd.Ga();$d<Ed&&($d=-1+Ed|0);var pf=(new L).K(Ed,1+$d|0),He=M(),If=O(P(He,ef),R(a.ea,a.P,pf))}else If=Db();ff($a,If)}else break}g=$a.lb()}Sd(a,(new Ae).z(a));return g}return F()}
function iv(a,b){var c=zz(b);b=Nfa(a);c.g()?b=S():(c=c.q(),b=(new T).e(We(new Ze,b.Lb,c)));return b.g()?ce(a):b.q()}
function jx(a,b,c){var d=We(new Ze,a,b),f=ce(a),d=d.eb;c&&Bh(a,(new eC).z(a));var g=x(a.h);if(fC(g))a.h.ia(),b=jx(a,Kea(a,b),!0);else if(fi(g)){if(Ke(b)||Pf(b)||Df(b)||Zk(b)||$k(b)||gm(b)||Bm(b)||Em(b)){var h;for(h=b;;)if(c=v(),g=x(a.h),y(z(c,g),Hh())){g=We(new Ze,a,b);c=ce(a);var g=g.eb,n=gC(),u=su(a),u=Rd(u);h=hC(n,h,u);c=c.Ga();c<g&&(c=-1+g|0);c=(new L).K(g,1+c|0);g=M();h=O(P(g,h),R(a.ea,a.P,c))}else break;b=jx(a,h,!0)}}else if((ue(g)||Be(g))&&c)g=We(new Ze,a,b),c=ce(a),g=g.eb,iC||(iC=(new jC).c()),
h=iC,n=wu(a),b=iga(h,b,n),c=c.Ga(),c<g&&(c=-1+g|0),c=(new L).K(g,1+c|0),g=M(),b=P(g,b),b=jx(a,O(b,R(a.ea,a.P,c)),!0);else if(nf(g)){a.h.ia();jga||(jga=(new kC).c());null!==b?c=(new q).a(!0,F()):(G(),c=(new r).d(["expr is equal to null"]),g=G().b,c=(new q).a(!1,H(c,g)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){f=J();d=[(new q).a("expr",b)];b=A(new B,C());g=0;for(h=d.length|0;g<h;)E(b,d[g]),g=1+g|0;K(f,"expr.!\x3d(null)",a,b.t)}throw(new p).e(c);}c=kga(null,null,null);c.gc=b.y(b,c,
"expr",b.s);b=c}f=f.Ga();f<d&&(f=-1+d|0);f=(new L).K(d,1+f|0);d=M();return O(P(d,b),R(a.ea,a.P,f))}function lga(a){var b=Se(),c=x(a.h),d=a.kh,d=pA().If(d),b=yg(b,c,d).be();return 0<=(b.length|0)&&"`"===b.substring(0,1)?(Ga(),b=Se(),c=x(a.h),a=a.kh,a=pA().If(a),zj(0,yg(b,c,a).be(),"`")):!1}function mga(a){0===(8&a.ra)&&0===(8&a.ra)&&(a.$B=nga(a).p(),a.ra|=8);return a.$B}function lC(a){a.h.ia();a.h.ia()}
function oga(a,b){if(a.Ss()){b=ch(a,!0);if("-"===b.ec())var c=v(),d=x(a.h),c=z(c,d),d=VA(a),c=y(c,mC(d));else c=!1;if(c)return b=We(new Ze,a,b),c=ce(a),d=b.eb,b=vf(a,!0),c=c.Ga(),c<d&&(c=-1+d|0),c=(new L).K(d,1+c|0),d=M(),b=P(d,b),jx(a,O(b,R(a.ea,a.P,c)),!0);var c=We(new Ze,a,b),d=ce(a),f=c.eb;pga||(pga=(new nC).c());c=jea(a,!0);if(null!==b)var g=(new q).a(!0,F());else{G();var g=(new r).d(["op is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){c=
J();b=[(new q).a("op",b)];d=A(new B,C());f=0;for(h=b.length|0;f<h;)E(d,b[f]),f=1+f|0;K(c,"op.!\x3d(null)",a,d.t)}throw(new p).e(g);}null!==c?g=(new q).a(!0,F()):(G(),g=(new r).d(["arg is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("arg",c)];d=A(new B,C());f=0;for(h=c.length|0;f<h;)E(d,c[f]),f=1+f|0;K(b,"arg.!\x3d(null)",a,d.t)}throw(new p).e(g);}eh(b).Ss()?g=(new q).a(!0,F()):(G(),g=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesTermName(op).isUnaryOp is false"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){c=J();b=[(new q).a("op",b)];d=A(new B,C());f=0;for(h=b.length|0;f<h;)E(d,b[f]),f=1+f|0;K(c,"scala.meta.internal.trees.`package`.XtensionTreesTermName(op).isUnaryOp",a,d.t)}throw(new p).e(g);}g=qga(null,null,null);g.Ef=b.y(b,g,"op",b.s);g.So=c.y(c,g,"arg",c.s);b=d.Ga();b<f&&(b=-1+f|0);b=(new L).K(f,1+b|0);c=M();return O(P(c,g),R(a.ea,a.P,b))}return jea(a,b)}
function rga(a,b){b.g()?b=S():(b=b.q(),b=(new T).e(", "+b));b=b.g()?"":b.q();le(a);b="these statements can't be mixed together"+b;a=oC(a);a=eo(a).ja();Pd(b,a)}
function we(a,b,c){var d=ce(a),f=ce(a),d=d.$a(),g=x(a.h);if(!Je(g)){for(var h=he(),n=[(new q).a("ScalametaParser.this.token",x(a.h))],u=A(new B,C()),w=0,D=n.length|0;w<D;)E(u,n[w]),w=1+w|0;ie(h,u.t)}36!==g.u.od().i[1+g.E|0]?h=(new q).a(!0,F()):(G(),h=(new r).d(["unquote.input.chars.apply(unquote.start.+(1)) is equal to '$'"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(a=h.p(),!1===I(h))){var N=J();c=[(new q).a("unquote",g)];f=A(new B,C());d=0;for(b=c.length|0;d<b;)E(f,c[d]),
d=1+d|0;K(N,"unquote.input.chars.apply(unquote.start.+(1)).!\x3d('$')",a,f.t)}throw(new p).e(h);}ke(a.P)||(le(a),h=td((new yd).X((new r).d([""," doesn't support unquotes"])),(new r).d([a.P])),n=g.ja(),Pd(h,n));try{pC();var Q=(new qC).ib(a.ea,1+g.E|0,g.Ca),ea=Is(a.P.Ig,a.P.rg,a.P.dh,a.P.kg,a.P.Jg,a.P.eh,a.P.fh,a.P.Rh,a.P.Sh,a.P.Bh,a.P.gh,!0,a.P.Kg,!1,a.P.Lg,!1,a.P.hh,a.P.Dh,a.P.sg,a.P.Eh,a.P.tg,a.P.Mg,a.P.cf,a.P.th),ba=(new Us).pj(Q,ea),ma;if(a.P.Uh){Sd(ba,(new rC).z(ba));var La=$v(ba),Pa=Tf(ba.h);
Sd(ba,(new sC).z(ba));var Qa=(new rf).Ia(ba,0),Ka=(new rf).Ia(ba,Pa),Ba=Qa.va,va=Ka.va;va<Ba&&(va=-1+Ba|0);var za=(new L).K(Ba,1+va|0),qa=M();ma=O(P(qa,La),R(ba.ea,ba.P,za))}else{var la;if(a.P.Ch){Sd(ba,(new rC).z(ba));var Ma=sv(ba),Ea=Xfa(Ma),tb=Tf(ba.h);Sd(ba,(new sC).z(ba));var Za=(new rf).Ia(ba,0),eb=(new rf).Ia(ba,tb),kb=Za.va,Pb=eb.va;Pb<kb&&(Pb=-1+kb|0);var Na=(new L).K(kb,1+Pb|0),sb=M();la=O(P(sb,Ea),R(ba.ea,ba.P,Na))}else la=ie(he(),Fu());ma=la}g=ma}catch(yb){if((a=vj(wj(),yb))&&a.$classData&&
a.$classData.H.ae){wj();a=(new Js).Dv(a);N=a.lv;a:{if(tC(N)&&(c=uC(vC(),N),!c.g())){N=c.q().qa();c=c.q().p();N=jda((new Ks).Sp(N));N=(new Jj).Hm(N,c);break a}if(Cy(N)&&(c=sga(tga(),N),!c.g())){N=c.q().qa();c=c.q().p();N=jda((new Ks).Sp(N));N=(new Qd).Hm(N,c);break a}throw(new p).e(N);}c=N;a=wC(a.lv);for(f=0;f<a.i.length;){if(null===a.i[f])throw(new fk).c();f=1+f|0}c.zn=a.HI();throw jo(0,N);}throw yb;}if(b)a.h.ia(),N=c.Ja(0,g);else{b=a.h;b=(new kg).Ia(b.r,b.Dc);a.h.ia();try{N=c.Ja(0,g)}finally{a.h=
b}}c=f.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);f=M();return O(P(f,N),R(a.ea,a.P,c))}
function ifa(a,b){var c;null===a.Ot&&null===a.Ot&&(a.Ot=(new xC).z(a));c=a.Ot;var d=c.Pi;b=yC(oga(a,b));var f=b.n(),f=We(new Ze,a,f),g=b.n(),h;a:{var n=b,g=We(new Ze,a,g);for(;;){b=v();var u=x(a.h);y(z(b,u),Pu())?b=!1:(b=v(),u=x(a.h),b=!y(z(b,u),Ug()));if(b){h=n;break a}b=ch(a,!0);var u=v(),w=x(a.h);y(z(u,w),Hh())?(u=su(a),u=Rd(u)):u=F();var w=v(),D=x(a.h);if(y(z(w,D),fh())){w=a.h;w=(new kg).Ia(w.r,w.Dc);a.h.ia();try{var N=x(a.h),Q=v(),ea=z(Q,N),ba=Ru(a),ma=y(ea,Su(ba))}finally{a.h=w}}else ma=!1;
ma&&ih(a);w=v();D=x(a.h);w=z(w,D);D=Ru(a);if(y(w,Su(D)))n=zC(c,d,n,g,(new T).e(b)),f=f.$a(),w=n.n(),w=We(new Ze,a,w).eb,uga(c,(new rf).Ia(a,f<w?f:w),n,g,b,u),u=x(a.h),f=(new rf).Ia(a,Tf(a.h)),b=vga(a),g=(new rf).Ia(a,qf(a.h)),n=v(),xf(z(n,u),Dh())?(n=v(),u=xf(z(n,u),Rf())):u=!1,u&&(f=We(new Ze,a,b.n()),g=We(new Ze,a,b.n())),n=b;else{Q=zC(c,d,n,g,(new T).e(b));G();N=(new T).e(Q);if(null!==N.Y&&0===qo(N.Y,1))h=ro(N.Y,0);else{N=he();Q=[(new q).a("lhsQual",Q)];ea=A(new B,C());ba=0;for(ma=Q.length|0;ba<
ma;)E(ea,Q[ba]),ba=1+ba|0;ie(N,ea.t)}cj(u)&&(le(a),N=x(a.h).ja(),Pd("type application is not allowed for postfix operators",N));Q=We(new Ze,a,h);N=We(new Ze,a,b);Q=Q.eb;h=Zt(Xt(),h,b);N=N.Fb;N<Q&&(N=-1+Q|0);N=(new L).K(Q,1+N|0);Q=M();h=P(Q,h);h=yC(O(h,R(a.ea,a.P,N)));break a}}}N=qf(a.h);c=zC(c,d,h,(new rf).Ia(a,N),S());G();a=(new T).e(c);if(null!==a.Y&&0===qo(a.Y,1))return ro(a.Y,0);a=he();c=[(new q).a("lhsResult",c)];d=A(new B,C());h=0;for(N=c.length|0;h<N;)E(d,c[h]),h=1+h|0;ie(a,d.t)}
function $v(a){var b=x(a.h);if(hg(b)&&!ig(jg(),b).g())return ch(a,!0);if(Be(b))return wfa(Tu(a,Ps().pe,!0));if(Ww(b)){var b=Tf(a.h),b=(new rf).Ia(a,b),c=qf(a.h),c=(new rf).Ia(a,c),d=b.va,b=tu(),c=c.va;c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();b=O(P(d,b),R(a.ea,a.P,c));a.h.ia();c=qf(a.h);d=(new rf).Ia(a,c);c=ce(a);d=d.va;b=CA(DA(),b);c=c.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();return O(P(d,b),R(a.ea,a.P,c))}le(a);a=x(a.h).ja();Pd("error in interpolated string: identifier, `this' or block expected",
a)}
e.pj=function(a,b){this.ea=a;this.P=b;var c=["",lr().hg];if(0===(c.length|0))c=id();else{for(var d=kd(new ld,id()),f=0,g=c.length|0;f<g;)md(d,c[f]),f=1+f|0;c=d.t}c.Ac(b.th)?c=(new q).a(!0,F()):(G(),c=(new r).d(['scala.collection.immutable.Set.apply[String]("", scala.compat.Platform.EOL).contains(ScalametaParser.this.dialect.toplevelSeparator) is false']),d=G().b,c=(new q).a(!1,H(c,d)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){b=J();for(var d=[(new q).a("ScalametaParser",this)],f=
A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,'scala.collection.immutable.Set.apply[String]("", scala.compat.Platform.EOL).contains(ScalametaParser.this.dialect.toplevelSeparator)',a,f.t)}throw(new p).e(c);}this.kh=b;a=oa(bc(yc),[a.od().i.length]);for(b=0;b<Eg(this).Fa();){c=Dg(Eg(this),b);for(d=c.ab();d<c.wa();)a.i[d]=b,d=1+d|0;b=1+b|0}this.ME=a;this.h=(new kg).Ia(this,(wga(this),-1));this.Jq=!1;this.Gp=(new AC).z(this);return this};
function BC(a){var b=v(),c=x(a.h);if(xf(z(b,c),Bf()))return!0;b=a.h;b=(new kg).Ia(b.r,b.Dc);a.h.ia();try{var d=v(),f=x(a.h);if(xf(z(d,f),zx()))var g=v(),h=x(a.h),n=xf(z(g,h),CC());else n=!1;if(n)var u=v(),w=x(a.h),D=xf(z(u,w),Pu());else D=!1;if(D){var N=v(),Q=x(a.h);return xf(z(N,Q),Ug())}return!1}finally{a.h=b}}function dy(a){var b=ch(a,!0),b=Ke(b)?b.nb((new DC).z(a)):b,c=v(),d=x(a.h);if(xf(z(c,d),Bf()))return b;a.h.ia();return jy(a,b)}
function wfa(a){if(km(a)){var b=null===a?S():(new T).e(a.ub());if(!b.g()){var c=b.q();if(rk(c)&&(b=c.ed,c=c.ga,pn(b)&&F().w(c)))return b}}return a}function zda(a,b){Sd(a,(new EC).z(a));var c=Ada();a=a.Tk();return Cda(c,b,a)}function xga(a){null===a.lr&&null===a.lr&&(a.lr=(new FC).z(a));return a.lr}function yga(a){null===a.Ir&&null===a.Ir&&(a.Ir=(new GC).z(a));return a.Ir}function oC(a){0===(4&a.ra)&&0===(4&a.ra)&&(a.aC=nga(a).qa(),a.ra|=4);return a.aC}
function ce(a){null===a.jr&&null===a.jr&&(a.jr=(new HC).z(a));return a.jr}
function zga(a,b){var c=!1,d=null;if(Ke(b))return(new T).e(b.nb((new IC).z(a)));if(Pf(b)){var c=We(new Ze,a,b),f=We(new Ze,a,b),c=c.eb,d=lB(),g=F(),h=S(),n=S();b=kB(d,g,b,h,n);f=f.Fb;f<c&&(f=-1+c|0);f=(new L).K(c,1+f|0);c=M();b=P(c,b);return(new T).e(O(b,R(a.ea,a.P,f)))}if(Em(b))return c=We(new Ze,a,b),f=We(new Ze,a,b),c=c.eb,d=lB(),g=F(),n=We(new Ze,a,b),h=We(new Ze,a,b),n=n.eb,b=tu(),h=h.Fb,h<n&&(h=-1+n|0),h=(new L).K(n,1+h|0),n=M(),b=O(P(n,b),R(a.ea,a.P,h)),h=S(),n=S(),b=kB(d,g,b,h,n),f=f.Fb,f<
c&&(f=-1+c|0),f=(new L).K(c,1+f|0),c=M(),b=P(c,b),(new T).e(O(b,R(a.ea,a.P,f)));if(im(b)&&(c=!0,f=d=b,f=null===f?S():(new T).e((new q).a(f.ob(),f.Db())),!f.g()&&(g=f.q().qa(),f=f.q().p(),Ff(g))))return c=g.nb((new JC).z(a)),d=We(new Ze,a,b),b=We(new Ze,a,b),d=d.eb,g=lB(),h=F(),f=(new T).e(f),n=S(),f=kB(g,h,c,f,n),b=b.Fb,b<d&&(b=-1+d|0),b=(new L).K(d,1+b|0),c=M(),f=P(c,f),(new T).e(O(f,R(a.ea,a.P,b)));if(c&&(f=d,g=null===f?S():(new T).e((new q).a(f.ob(),f.Db())),!g.g()&&(f=g.q().qa(),g=g.q().p(),Pf(f))))return c=
We(new Ze,a,b),b=We(new Ze,a,b),c=c.eb,d=lB(),h=F(),g=(new T).e(g),n=S(),f=kB(d,h,f,g,n),b=b.Fb,b<c&&(b=-1+c|0),b=(new L).K(c,1+b|0),c=M(),f=P(c,f),(new T).e(O(f,R(a.ea,a.P,b)));if(c&&(f=d,f=null===f?S():(new T).e((new q).a(f.ob(),f.Db())),!f.g()&&(h=f.q().qa(),c=f.q().p(),Em(h)))){f=We(new Ze,a,b);b=We(new Ze,a,b);var f=f.eb,d=lB(),g=F(),u=We(new Ze,a,h),n=We(new Ze,a,h),u=u.eb,h=tu(),n=n.Fb;n<u&&(n=-1+u|0);n=(new L).K(u,1+n|0);u=M();h=O(P(u,h),R(a.ea,a.P,n));c=(new T).e(c);n=S();c=kB(d,g,h,c,n);
b=b.Fb;b<f&&(b=-1+f|0);b=(new L).K(f,1+b|0);f=M();f=P(f,c);return(new T).e(O(f,R(a.ea,a.P,b)))}if(on(b))return S();le(a);a=td((new yd).X((new r).d(["not a legal formal parameter"])),F());b=Yc(b);Pd(a,b)}
function mx(a,b,c,d){if(d){d=v();var f=Fk(c,a.kh),f=eo(f);d=z(d,f);var f=yga(a),g=new KC;if(null===f)throw jo(wj(),null);g.r=f;d=!y(d,g)}else d=!1;d&&(le(a),d=Yc(c),Pd("illegal modifier for a local definition",d));d=v();d=z(d,c);LC||(LC=(new MC).c());if(!y(d,LC)){a:{for(d=b;!d.g();){if(d.n().U()===c.U()){d=!0;break a}d=d.o()}d=!1}d&&(le(a),d=Yc(c),Pd("repeated modifier",d));a:{for(d=b;!d.g();){f=d.n();if(Aga(NC(f))){d=!0;break a}d=d.o()}d=!1}d&&Aga(NC(c))&&(d=v(),y(z(d,c),OC())&&(d=G().b,d=Fw(b,c,
d),null===a.Fr&&null===a.Fr&&(a.Fr=(new PC).z(a)),zu(a,d,"",a.Fr,QC(),(new mv).Ud(k(Bga)),OC(),(new mv).Ud(k(Cga)))),d=v(),y(z(d,c),QC())&&(d=G().b,d=Fw(b,c,d),null===a.Gr&&null===a.Gr&&(a.Gr=(new RC).z(a)),zu(a,d,"",a.Gr,OC(),(new mv).Ud(k(Cga)),QC(),(new mv).Ud(k(Bga)))));a:{for(d=b;!d.g();){f=d.n();if(Dga(NC(f))){d=!0;break a}d=d.o()}d=!1}d&&Dga(NC(c))&&(le(a),a=Yc(c),Pd("duplicate private/protected qualifier",a))}a=G().b;return Fw(b,c,a)}
function SC(a,b){for(var c=(new TC).z(a),d=G(),c=ex(b,c,d.b);!c.g();){var f=c.n();le(a);d=oe(pe(),f.ca,1);f=Yc(f);Pd(d,f)}return b}function Kea(a,b){var c=We(new Ze,a,b),d=ce(a),c=c.eb;Xt();var f=ch(a,!0);b=Zt(0,b,f);d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,b),R(a.ea,a.P,d))}
e.Zg=function(){var a=(new Jd).c();try{var b=ce(this),c=ce(this),d=b.$a(),f=x(this.h);var g;if(hg(f)&&!ig(jg(),f).g())g=ch(this,!0);else if(nf(f)||Ww(f)){var h=ce(this),n=ce(this),u=h.$a();this.h.ia();var w=tu(),D=n.Ga();D<u&&(D=-1+u|0);var N=(new L).K(u,1+D|0),Q=M();g=O(P(Q,w),R(this.ea,this.P,N))}else if(Je(f)){var ea=this.h,ba=(new kg).Ia(ea.r,ea.Dc);this.h.ia();try{var ma=v(),La=x(this.h),Pa=y(z(ma,La),lg())}finally{this.h=ba}if(!Pa){var Qa=(new UC).z(this);throw(new VC).a(a,we(this,!0,Qa));}var Ka=
(new WC).z(this);g=we(this,!0,Ka)}else{le(this);var Ba=x(this.h).ja();Pd("expected identifier, `this' or unquote",Ba)}var va=x(this.h);if(XC(va)){this.h.ia();var za=su(this),qa=Lg().In,la=th(za),Ma=(new T).e(Mg(za,la,qa))}else Ma=S();var Ea=By(Ay(),g,Ma),tb=c.Ga();tb<d&&(tb=-1+d|0);var Za=(new L).K(d,1+tb|0),eb=M();return O(P(eb,Ea),R(this.ea,this.P,Za))}catch(kb){if(YC(kb)&&kb.Ys===a)return kb.Rt;throw kb;}};function ox(a){null===a.Mr&&null===a.Mr&&(a.Mr=(new ZC).z(a));return a.Mr}
function Ega(a,b){var c=v(),d=x(a.h);if(y(z(c,d),JA())&&!b){var f=ce(a),g=ce(a),h=f.$a();KA||(KA=(new LA).c());var n=MA(a).q(),u=Rfa(n),w=g.Ga();w<h&&(w=-1+h|0);var D=(new L).K(h,1+w|0),N=M(),Q=O(P(N,u),R(a.ea,a.P,D)),ea=F();return U(new V,Q,ea)}var ba=v(),ma=x(a.h);if(y(z(ba,ma),be())){(new $C).z(a);var La=(new aD).z(a),Pa=ce(a),Qa=ce(a),Ka=Pa.$a(),Ba=x(a.h);if(!de(Ba)){for(var va=he(),za=[(new q).a("ScalametaParser.this.token",x(a.h))],qa=A(new B,C()),la=0,Ma=za.length|0;la<Ma;)E(qa,za[la]),la=
1+la|0;ie(va,qa.t)}if(!ke(a.P)){le(a);var Ea=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),tb=Ba.ja();Pd(Ea,tb)}if(1!==Ba.Hb){le(a);var Za=oe(pe(),Ba.Hb,1),eb=Ba.ja();Pd(Za,eb)}a.h.ia();var kb=x(a.h);if(ue(kb)){Sd(a,(new ve).z(a));var Pb=we(a,!0,La);Sd(a,(new Ae).z(a));var Na=Pb}else if(Be(kb)){Sd(a,(new Ee).z(a));var sb=we(a,!0,La);Sd(a,(new Ie).z(a));Na=sb}else if(Je(kb))Na=we(a,!0,La);else{le(a);var yb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),
(new r).d([x(a.h).oa()])),sc=x(a.h).ja();Pd(yb,sc)}if(Ke(Na)){if(Le((Oe(),La).G(),Na.uc()))var Ra=(new q).a(!0,F());else{G();var wc=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Wb=G().b,Ra=(new q).a(!1,H(wc,Wb))}if(null===Ra||!0!==I(Ra)){if(null!==Ra){var Rb=Ra.p();if(!1===I(Ra)){for(var ub=J(),fb=(new q).a("ellipsis",Ba),Xb=(new q).a("result",Na),lb=(new q).a("evidence$4",La),Eb=(new q).a("quasi",Na),xc=Se(),gb=Te().Hc(),dc=[fb,Xb,
lb,Eb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(xc,Na,gb)))],Fc=A(new B,C()),Qb=0,Bb=dc.length|0;Qb<Bb;)E(Fc,dc[Qb]),Qb=1+Qb|0;K(ub,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",Rb,Fc.t)}}throw(new p).e(Ra);
}var Ib=We(new Ze,a,Na),mb=We(new Ze,a,Na),Cb=Ib.eb,Tb=Na.ca,mc=Na.fa(),Ac=bD(cD(),Tb,mc),Dc=mb.Fb;Dc<Cb&&(Dc=-1+Cb|0);var Db=(new L).K(Cb,1+Dc|0),Va=M(),ec=O(P(Va,Ac),R(a.ea,a.P,Db))}else ec=Na;var $a=bD(cD(),1,ec),vb=Qa.Ga();vb<Ka&&(vb=-1+Ka|0);var fc=(new L).K(Ka,1+vb|0),Bc=M(),Ub=O(P(Bc,$a),R(a.ea,a.P,fc)),Vb=F();return U(new V,Ub,Vb)}var wb=v(),xb=x(a.h);if(y(z(wb,xb),Ug())){var Xa=a.h,tc=(new kg).Ia(Xa.r,Xa.Dc);a.h.ia();try{var ib=v(),zb=x(a.h);if(y(z(ib,zb),Wg()))jb=!1;else var nb=v(),Jb=x(a.h),
jb=!y(z(nb,Jb),Fga())}finally{a.h=tc}}else jb=!1;if(jb){var ob=(new dD).z(a),gc=we(a,!0,ob),cb=F();return U(new V,gc,cb)}var Ua=!b,Yb=Tf(a.h),Kb=v(),pb=x(a.h),hb=y(z(Kb,pb),$A());hb&&a.h.ia();var Lb=sv(a),Fa=OB(Lb);x(a.h).ab();var bb=v(),nc=x(a.h),db=y(z(bb,nc),Wg());if(hb)if(db)le(a),x(a.h).ja();else{le(a);var uc=x(a.h).ja();Pd("val in for comprehension must be followed by assignment",uc)}db&&Ua?a.h.ia():Sd(a,(new eD).z(a));var Fb=Tu(a,Ps().pe,!1);if(db){var hc=(new rf).Ia(a,Yb),$b=ce(a),kc=hc.va;
Gga||(Gga=(new fD).c());if(null!==Fa)var lc=(new q).a(!0,F());else{G();var Mb=(new r).d(["pat is equal to null"]),Nb=G().b,lc=(new q).a(!1,H(Mb,Nb))}if(null===lc||!0!==I(lc)){if(null!==lc){var Gb=lc.p();if(!1===I(lc)){for(var Sb=J(),Cc=[(new q).a("pat",Fa)],Ob=A(new B,C()),Zb=0,Ec=Cc.length|0;Zb<Ec;)E(Ob,Cc[Zb]),Zb=1+Zb|0;K(Sb,"pat.!\x3d(null)",Gb,Ob.t)}}throw(new p).e(lc);}if(null!==Fb)var oc=(new q).a(!0,F());else{G();var pc=(new r).d(["rhs is equal to null"]),qc=G().b,oc=(new q).a(!1,H(pc,qc))}if(null===
oc||!0!==I(oc)){if(null!==oc){var Jc=oc.p();if(!1===I(oc)){for(var Hc=J(),ac=[(new q).a("rhs",Fb)],Lc=A(new B,C()),$c=0,Tc=ac.length|0;$c<Tc;)E(Lc,ac[$c]),$c=1+$c|0;K(Hc,"rhs.!\x3d(null)",Jc,Lc.t)}}throw(new p).e(oc);}var Rc=Hga(null,null,null);Rc.zh=Fa.y(Fa,Rc,"pat",Fa.s);Rc.Kb=Fb.y(Fb,Rc,"rhs",Fb.s);var Mc=$b.Ga();Mc<kc&&(Mc=-1+kc|0);var hd=(new L).K(kc,1+Mc|0),Qc=M(),rd=O(P(Qc,Rc),R(a.ea,a.P,hd))}else{var od=(new rf).Ia(a,Yb),Zc=ce(a),nd=od.va;Iga||(Iga=(new gD).c());if(null!==Fa)var zd=(new q).a(!0,
F());else{G();var ud=(new r).d(["pat is equal to null"]),wd=G().b,zd=(new q).a(!1,H(ud,wd))}if(null===zd||!0!==I(zd)){if(null!==zd){var Bd=zd.p();if(!1===I(zd)){for(var Ed=J(),pd=[(new q).a("pat",Fa)],vd=A(new B,C()),xd=0,ee=pd.length|0;xd<ee;)E(vd,pd[xd]),xd=1+xd|0;K(Ed,"pat.!\x3d(null)",Bd,vd.t)}}throw(new p).e(zd);}if(null!==Fb)var Ld=(new q).a(!0,F());else{G();var me=(new r).d(["rhs is equal to null"]),fe=G().b,Ld=(new q).a(!1,H(me,fe))}if(null===Ld||!0!==I(Ld)){if(null!==Ld){var Yd=Ld.p();if(!1===
I(Ld)){for(var Zd=J(),qe=[(new q).a("rhs",Fb)],re=A(new B,C()),Kd=0,yf=qe.length|0;Kd<yf;)E(re,qe[Kd]),Kd=1+Kd|0;K(Zd,"rhs.!\x3d(null)",Yd,re.t)}}throw(new p).e(Ld);}var Cd=Jga(null,null,null);Cd.zh=Fa.y(Fa,Cd,"pat",Fa.s);Cd.Kb=Fb.y(Fb,Cd,"rhs",Fb.s);var Fe=Zc.Ga();Fe<nd&&(Fe=-1+nd|0);var je=(new L).K(nd,1+Fe|0),xe=M(),rd=O(P(xe,Cd),R(a.ea,a.P,je))}var ge=Qfa(a);return U(new V,rd,ge)}
function Zaa(a){var b=Fh(a);a=function(a){return function(b){if(Kga(hv(b)))return b;le(a);b=Yc(b);Pd("not a legal existential clause",b)}}(a);var c=G().b;if(c===G().b){if(b===F())return F();for(var c=b.n(),d=c=U(new V,a(c),F()),b=b.o();b!==F();)var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f,b=b.o();return c}for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();return c.da()}
function vfa(a,b){if(Rm(b)){var c=null===b?S():(new T).e(b.pb());if(!c.g()){b=c.q();a=function(a){return function(b){return zga(a,b).lb()}}(a);if(G().b===G().b){if(b===F())return F();for(var c=b,d=(new Kl).qj(!1),f=(new Uk).e(null),g=(new Uk).e(null);c!==F();){var h=c.n();a(h).dc().Cb(lk(function(a,b,c,d){return function(a){b.cb?(a=U(new V,a,F()),d.cb.ga=a,d.cb=a):(c.cb=U(new V,a,F()),d.cb=c.cb,b.cb=!0)}}(b,d,f,g)));c=c.o()}return d.cb?f.cb:F()}G();for(c=(new ae).c();!b.g();)d=b.n(),d=a(d).dc(),Ll(c,
d),b=b.o();return c.lb()}}G();a=(new r).d([zga(a,b)]);b=G().b;b=H(a,b);G();for(a=(new ae).c();!b.g();)c=b.n().lb(),Ll(a,c),b=b.o();return a.lb()}
e.Tk=function(){var a=v(),b=x(this.h);if(xf(z(a,b),Dh())){G();var c=(new r).d([UB(this)]),d=G().b;return H(c,d)}Sd(this,(new Ee).z(this));var f=function(a){return function(){var b=ce(a),c=ce(a),d=b.$a(),f=UB(a);a:{var g;if(Ln(f)){var h=v(),n=x(a.h);if(y(z(h,n),Ag())){a.h.ia();var u=UB(a);if(Ln(u)){Lga||(Lga=(new hD).c());var w=f.xb(),D=u.xb();if(null!==w)var N=(new q).a(!0,F());else{G();var Q=(new r).d(["name is equal to null"]),ba=G().b,N=(new q).a(!1,H(Q,ba))}if(null===N||!0!==I(N)){if(null!==N){var ea=
N.p();if(!1===I(N)){for(var za=J(),qa=[(new q).a("name",w)],la=A(new B,C()),ma=0,Ba=qa.length|0;ma<Ba;)E(la,qa[ma]),ma=1+ma|0;K(za,"name.!\x3d(null)",ea,la.t)}}throw(new p).e(N);}if(null!==D)var va=(new q).a(!0,F());else{G();var Ma=(new r).d(["rename is equal to null"]),La=G().b,va=(new q).a(!1,H(Ma,La))}if(null===va||!0!==I(va)){if(null!==va){var Ka=va.p();if(!1===I(va)){for(var Ea=J(),Fa=[(new q).a("rename",D)],Pa=A(new B,C()),Qa=0,Na=Fa.length|0;Qa<Na;)E(Pa,Fa[Qa]),Qa=1+Qa|0;K(Ea,"rename.!\x3d(null)",
Ka,Pa.t)}}throw(new p).e(va);}var Ua=v();if(y(z(Ua,w),fB()))var Ra=!0,Va=F();else{G();var Za=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]) is false"]),$a=G().b,bb=H(Za,$a),Ra=!1,Va=bb}var cb=Va;if(Ra)var Xa=(new q).a(!0,F());else{var db=v();if(y(z(db,w),iD()))var eb=!0,fb=F();else{G();var gb=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]) is false"]),
hb=G().b,ib=H(gb,hb),eb=!1,fb=ib}var kb=fb;if(eb)Xa=(new q).a(!0,F());else var lb=G(),Xa=(new q).a(!1,cb.ma(kb,lb.b))}if(null===Xa||!0!==I(Xa)){if(null!==Xa){var pb=Xa.p();if(!1===I(Xa)){for(var sb=J(),nb=[(new q).a("name",w),(new q).a("Name",jD())],ob=A(new B,C()),jb=0,tb=nb.length|0;jb<tb;)E(ob,nb[jb]),jb=1+jb|0;K(sb,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]))",
pb,ob.t)}}throw(new p).e(Xa);}var wb=v();if(y(z(wb,D),fB()))var ub=!0,vb=F();else{G();var xb=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](rename)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]) is false"]),yb=G().b,zb=H(xb,yb),ub=!1,vb=zb}var oc=vb;if(ub)var mb=(new q).a(!0,F());else{var pc=v();if(y(z(pc,D),iD()))var Bb=!0,Cb=F();else{G();var Db=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](rename)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]) is false"]),
Fb=G().b,Ib=H(Db,Fb),Bb=!1,Cb=Ib}var Lb=Cb;if(Bb)mb=(new q).a(!0,F());else var Mb=G(),mb=(new q).a(!1,oc.ma(Lb,Mb.b))}if(null===mb||!0!==I(mb)){if(null!==mb){var Pb=mb.p();if(!1===I(mb)){for(var Qb=J(),Kb=[(new q).a("rename",D),(new q).a("Name",jD())],Nb=A(new B,C()),Gb=0,Sb=Kb.length|0;Gb<Sb;)E(Nb,Kb[Gb]),Gb=1+Gb|0;K(Qb,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](rename)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](rename)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]))",
Pb,Nb.t)}}throw(new p).e(mb);}var Ob=Mga(null,null,null);Ob.Pa=w.y(w,Ob,"name",w.s);Ob.cp=D.y(D,Ob,"rename",D.s);g=Ob}else{if(!Pn(u)){for(var Zb=he(),Tb=(new q).a("other",u),Vb=Se(),Xb=Te().Hc(),Ub=[Tb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.Importee](other)(meta.this.Tree.showStructure[scala.meta.Importee]).structure",Ue(Ve(Vb,u,Xb)))],Wb=A(new B,C()),Rb=0,$b=Ub.length|0;Rb<$b;)E(Wb,Ub[Rb]),Rb=1+Rb|0;ie(Zb,Wb.t)}Nga||(Nga=(new kD).c());var Eb=f.xb();if(null!==
Eb)var Jb=(new q).a(!0,F());else{G();var Ec=(new r).d(["name is equal to null"]),dc=G().b,Jb=(new q).a(!1,H(Ec,dc))}if(null===Jb||!0!==I(Jb)){if(null!==Jb){var fc=Jb.p();if(!1===I(Jb)){for(var hc=J(),ec=[(new q).a("name",Eb)],gc=A(new B,C()),ac=0,mc=ec.length|0;ac<mc;)E(gc,ec[ac]),ac=1+ac|0;K(hc,"name.!\x3d(null)",fc,gc.t)}}throw(new p).e(Jb);}var nc=v();if(y(z(nc,Eb),fB()))var kc=!0,lc=F();else{G();var qc=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]) is false"]),
sc=G().b,tc=H(qc,sc),kc=!1,lc=tc}var uc=lc;if(kc)var Yb=(new q).a(!0,F());else{var Rc=v();if(y(z(Rc,Eb),iD()))var wc=!0,xc=F();else{G();var Ac=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]) is false"]),Bc=G().b,Cc=H(Ac,Bc),wc=!1,xc=Cc}var Dc=xc;if(wc)Yb=(new q).a(!0,F());else var Fc=G(),Yb=(new q).a(!1,uc.ma(Dc,Fc.b))}if(null===
Yb||!0!==I(Yb)){if(null!==Yb){var Hc=Yb.p();if(!1===I(Yb)){for(var Lc=J(),od=[(new q).a("name",Eb),(new q).a("Name",jD())],Mc=A(new B,C()),Jc=0,Qc=od.length|0;Jc<Qc;)E(Mc,od[Jc]),Jc=1+Jc|0;K(Lc,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]))",
Hc,Mc.t)}}throw(new p).e(Yb);}var Tc=Oga(null,null,null);Tc.Pa=Eb.y(Eb,Tc,"name",Eb.s);g=Tc}break a}}if(Pn(f)){var Zc=v(),$c=x(a.h);if(y(z(Zc,$c),Ag())){var nd=a.h,rd=(new kg).Ia(nd.r,nd.Dc);a.h.ia();try{var hd=v(),zd=x(a.h),ud=y(z(hd,zd),pz())}finally{a.h=rd}}else ud=!1;if(ud){lC(a);g=f;break a}}g=f}var wd=c.Ga();wd<d&&(wd=-1+d|0);var Xf=(new L).K(d,1+wd|0),Sh=M();return O(P(Sh,g),R(a.ea,a.P,Xf))}}(this),g=(new lD).z(this),h=(new Xd).z(this),n=(new ae).c(),u=v(),w=x(this.h);if(y(z(u,w),be())){var D=
ce(this),N=ce(this),Q=D.$a(),ea=x(this.h);if(!de(ea)){for(var ba=he(),ma=[(new q).a("ScalametaParser.this.token",x(this.h))],La=A(new B,C()),Pa=0,Qa=ma.length|0;Pa<Qa;)E(La,ma[Pa]),Pa=1+Pa|0;ie(ba,La.t)}if(!ke(this.P)){le(this);var Ka=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([this.P])),Ba=ea.ja();Pd(Ka,Ba)}if(1!==ea.Hb){le(this);var va=oe(pe(),ea.Hb,1),za=ea.ja();Pd(va,za)}this.h.ia();var qa=x(this.h);if(ue(qa)){Sd(this,(new ve).z(this));var la=we(this,!0,g);Sd(this,(new Ae).z(this));
var Ma=la}else if(Be(qa)){Sd(this,(new Ee).z(this));var Ea=we(this,!0,g);Sd(this,(new Ie).z(this));Ma=Ea}else if(Je(qa))Ma=we(this,!0,g);else{le(this);var tb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(this.h).oa()])),Za=x(this.h).ja();Pd(tb,Za)}if(Ke(Ma)){if(Le((Oe(),g).G(),Ma.uc()))var eb=(new q).a(!0,F());else{G();var kb=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),Pb=G().b,eb=(new q).a(!1,H(kb,Pb))}if(null===
eb||!0!==I(eb)){if(null!==eb){var Na=eb.p();if(!1===I(eb)){for(var sb=J(),yb=(new q).a("ellipsis",ea),sc=(new q).a("result",Ma),Ra=(new q).a("evidence$4",g),wc=(new q).a("quasi",Ma),Wb=Se(),Rb=Te().Hc(),ub=[yb,sc,Ra,wc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Wb,Ma,Rb)))],fb=A(new B,C()),Xb=0,lb=ub.length|0;Xb<lb;)E(fb,ub[Xb]),Xb=1+Xb|0;K(sb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
Na,fb.t)}}throw(new p).e(eb);}var Eb=We(new Ze,this,Ma),xc=We(new Ze,this,Ma),gb=Eb.eb,dc=Ma.ca,Fc=Ma.fa(),Qb=mD(nD(),dc,Fc),Bb=xc.Fb;Bb<gb&&(Bb=-1+gb|0);var Ib=(new L).K(gb,1+Bb|0),mb=M(),Cb=O(P(mb,Qb),R(this.ea,this.P,Ib))}else Cb=Ma;var Tb=mD(nD(),1,Cb),mc=N.Ga();mc<Q&&(mc=-1+Q|0);var Ac=(new L).K(Q,1+mc|0),Dc=M(),Db=O(P(Dc,Tb),R(this.ea,this.P,Ac))}else Db=f();for(ff(n,Db);;){var Va=v(),ec=x(this.h);if(y(z(Va,ec),h))var $a=!0;else var vb=v(),fc=x(this.h),$a=y(z(vb,fc),be());if($a){var Bc=v(),
Ub=x(this.h);y(z(Bc,Ub),h)&&this.h.ia();var Vb=v(),wb=x(this.h);if(y(z(Vb,wb),be())){var xb=ce(this),Xa=ce(this),tc=xb.$a(),ib=x(this.h);if(!de(ib)){for(var zb=he(),nb=[(new q).a("ScalametaParser.this.token",x(this.h))],Jb=A(new B,C()),jb=0,ob=nb.length|0;jb<ob;)E(Jb,nb[jb]),jb=1+jb|0;ie(zb,Jb.t)}var gc=ib;if(!ke(this.P)){le(this);var cb=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([this.P])),Ua=gc.ja();Pd(cb,Ua)}if(1!==gc.Hb){le(this);var Yb=oe(pe(),gc.Hb,1),Kb=gc.ja();Pd(Yb,
Kb)}this.h.ia();var pb=x(this.h);if(ue(pb)){Sd(this,(new ve).z(this));var hb=we(this,!0,g);Sd(this,(new Ae).z(this));var Lb=hb}else if(Be(pb)){Sd(this,(new Ee).z(this));var Fa=we(this,!0,g);Sd(this,(new Ie).z(this));Lb=Fa}else if(Je(pb))Lb=we(this,!0,g);else{le(this);var bb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(this.h).oa()])),nc=x(this.h).ja();Pd(bb,nc)}if(Ke(Lb)){if(Le((Oe(),g).G(),Lb.uc()))var db=(new q).a(!0,F());else{G();var uc=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
Fb=G().b,db=(new q).a(!1,H(uc,Fb))}if(null===db||!0!==I(db)){if(null!==db){var hc=db.p();if(!1===I(db)){for(var $b=J(),kc=(new q).a("ellipsis",gc),lc=(new q).a("result",Lb),Mb=(new q).a("evidence$4",g),Nb=(new q).a("quasi",Lb),Gb=Se(),Sb=Te().Hc(),Cc=[kc,lc,Mb,Nb,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Gb,Lb,Sb)))],Ob=A(new B,C()),Zb=0,Ec=Cc.length|0;Zb<Ec;)E(Ob,Cc[Zb]),Zb=1+Zb|0;K($b,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
hc,Ob.t)}}throw(new p).e(db);}var oc=We(new Ze,this,Lb),pc=We(new Ze,this,Lb),qc=oc.eb,Jc=Lb.ca,Hc=Lb.fa(),ac=mD(nD(),Jc,Hc),Lc=pc.Fb;Lc<qc&&(Lc=-1+qc|0);var $c=(new L).K(qc,1+Lc|0),Tc=M(),Rc=O(P(Tc,ac),R(this.ea,this.P,$c))}else Rc=Lb;var Mc=mD(nD(),1,Rc),hd=Xa.Ga();hd<tc&&(hd=-1+tc|0);var Qc=(new L).K(tc,1+hd|0),rd=M(),od=O(P(rd,Mc),R(this.ea,this.P,Qc))}else od=f();ff(n,od)}else break}var Zc=n.lb();Sd(this,(new Ie).z(this));if(cj(Zc))for(var nd=oD(Zc);!nd.g();){var zd=nd.n();if(Pn(zd)){var ud=
zd;le(this);var wd=Yc(ud);Pd("Wildcard import must be in the last position",wd)}nd=nd.o()}return Zc};
function Cea(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);a:{var f;if(Je(d)){d=a.h;d=(new kg).Ia(d.r,d.Dc);a.h.ia();try{f=qu(a,!0)}finally{a.h=d}if(!f){f=(new ru).z(a);f=we(a,!0,f);break a}}d=ce(a);f=ce(a);d=d.$a();Jaa();var g=ce(a),h=ce(a),g=g.$a();DA();var n;n=ce(a);var u=ce(a),w=n.$a();Sd(a,(new pD).z(a));n=tu();u=u.Ga();u<w&&(u=-1+w|0);u=(new L).K(w,1+u|0);w=M();n=O(P(w,n),R(a.ea,a.P,u));n=CA(0,n);h=h.Ga();h<g&&(h=-1+g|0);h=(new L).K(g,1+h|0);g=M();h=O(P(g,n),R(a.ea,a.P,h));h=Iaa(0,h);f=f.Ga();f<
d&&(f=-1+d|0);f=(new L).K(d,1+f|0);d=M();f=O(P(d,h),R(a.ea,a.P,f));d=ce(a);h=ce(a);g=d.$a();d=tu();h=h.Ga();h<g&&(h=-1+g|0);h=(new L).K(g,1+h|0);g=M();d=O(P(g,d),R(a.ea,a.P,h));g=uu(vu(),F());for(Bh(a,(new qD).z(a));qu(a,!0);)ff(g,wu(a)),Bh(a,(new rD).z(a));h=xu();g=g.lb();f=yu(h,f,d,g)}c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}function qw(a){null===a.Ur&&null===a.Ur&&(a.Ur=(new sD).z(a));return a.Ur}
function Bea(a){Sd(a,(new tD).z(a));var b=Cea(a),c=v(),d=x(a.h),c=z(c,d),d=Wu(a);y(c,Xu(d))?(a.h.ia(),c=Gu(a)):c=F();Sd(a,(new uD).z(a));return(new q).a(b,c)}
function Nw(a,b){var c=v(),d=x(a.h);y(z(c,d),Pga())?c=!0:(c=v(),d=x(a.h),c=y(z(c,d),kx())?b===qw(b.r):!1);if(c){a.h.ia();b=v();c=x(a.h);if(y(z(b,c),Ug())){b=a.h;b=(new kg).Ia(b.r,b.Dc);a.h.ia();try{var f=v(),g=x(a.h);if(y(z(f,g),Bf()))u=!1;else var h=v(),n=x(a.h),u=!y(z(h,n),Qga());if(u)var w=v(),D=x(a.h),N=!y(z(w,D),iu());else N=!1;if(N)var Q=v(),ea=x(a.h),ba=!y(z(Q,ea),be());else ba=!1;if(ba)var ma=v(),La=x(a.h),Pa=!y(z(ma,La),Rf());else Pa=!1;if(Pa)var Qa=v(),Ka=x(a.h),Ba=!y(z(Qa,Ka),Hh());else Ba=
!1;if(Ba)var va=v(),za=x(a.h),qa=!y(z(va,za),Dh());else qa=!1;if(qa)var la=v(),Ma=x(a.h),Ea=!y(z(la,Ma),Ah());else Ea=!1}finally{a.h=b}}else Ea=!1;return Ea?(f=(new vD).z(a),we(a,!0,f)):nea(a)}h=Tf(a.h);g=wD(a,!jba(b));if(null===g)throw(new p).e(g);f=g.qa();g=g.p();n=(new rf).Ia(a,h);h=ce(a);n=n.va;u=xD();w=F();D=F();f=yD(u,w,D,f,g);g=h.Ga();g<n&&(g=-1+n|0);g=(new L).K(n,1+g|0);h=M();return O(P(h,f),R(a.ea,a.P,g))}
function MA(a){var b=v(),c=x(a.h);if(y(z(b,c),JA())){a.h.ia();var b=ce(a),c=ce(a),d=b.$a(),b=ifa(a,!1),c=c.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();b=P(d,b);return(new T).e(O(b,R(a.ea,a.P,c)))}return S()}function Rga(a){var b=v();a=x(a.h);return y(z(b,a),ah())}function wga(a){null===a.Ku&&null===a.Ku&&(a.Ku=(new zD).z(a))}
function Kda(a,b){var c=xh(a,!0,!0);b=b.lb();var d=G().b,c=Sea(c,b,d);b=Aw(a,!0);d=G();c=c.ma(b,d.b);a:{for(b=c;!b.g();){d=b.n();if(!(AD(d)||BD(d)||CD(d)||yl(d))){b=!1;break a}b=b.o()}b=!0}c=b?gv(a,c):Bw(a,c);if(DD(hv(c)))return c;le(a);a=Yc(c);Pd("is not a valid block statement",a)}
function zfa(a){var b=v(),c=x(a.h);if(y(z(b,c),Ug())){b=a.h;b=(new kg).Ia(b.r,b.Dc);a.h.ia();try{var d=v(),f=x(a.h);if(y(z(d,f),Pu()))var g=!0;else var h=v(),n=x(a.h),g=y(z(h,n),Ug())}finally{a.h=b}d=!g}else d=!1;if(!d){d=!1;f=null;g=x(a.h);if(Je(g)){var u=(new ED).z(a);return(new T).e(we(a,!0,u))}if(de(g)&&!Yf(Zf(),g).g()){(new FD).z(a);g=(new GD).z(a);f=ce(a);d=ce(a);f=f.$a();h=x(a.h);if(!de(h)){for(var n=he(),b=[(new q).a("ScalametaParser.this.token",x(a.h))],c=A(new B,C()),w=0,D=b.length|0;w<
D;)E(c,b[w]),w=1+w|0;ie(n,c.t)}ke(a.P)||(le(a),n=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),b=h.ja(),Pd(n,b));1!==h.Hb&&(le(a),n=oe(pe(),h.Hb,1),b=h.ja(),Pd(n,b));a.h.ia();n=x(a.h);ue(n)?(Sd(a,(new ve).z(a)),u=we(a,!0,g),Sd(a,(new Ae).z(a))):Be(n)?(Sd(a,(new Ee).z(a)),u=we(a,!0,g),Sd(a,(new Ie).z(a))):Je(n)?u=we(a,!0,g):(le(a),n=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),b=x(a.h).ja(),Pd(n,b));if(Ke(u)){Le((Oe(),g).G(),
u.uc())?n=(new q).a(!0,F()):(G(),n=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),b=G().b,n=(new q).a(!1,H(n,b)));if(null===n||!0!==I(n)){if(null!==n&&(a=n.p(),!1===I(n))){d=J();f=(new q).a("ellipsis",h);h=(new q).a("result",u);g=(new q).a("evidence$4",g);b=(new q).a("quasi",u);c=Se();w=Te().Hc();u=[f,h,g,b,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(c,
u,w)))];f=A(new B,C());g=0;for(h=u.length|0;g<h;)E(f,u[g]),g=1+g|0;K(d,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",a,f.t)}throw(new p).e(n);}h=We(new Ze,a,u);g=We(new Ze,a,u);h=h.eb;n=u.ca;u=u.fa();u=uw(vw(),n,u);g=g.Fb;g<h&&(g=-1+h|0);g=(new L).K(h,1+g|0);h=M();u=O(P(h,u),R(a.ea,a.P,g))}u=
uw(vw(),1,u);d=d.Ga();d<f&&(d=-1+f|0);d=(new L).K(f,1+d|0);f=M();u=P(f,u);return(new T).e(O(u,R(a.ea,a.P,d)))}if(hg(g)&&(d=!0,f=g,u=ig(jg(),f),!u.g()&&"+"===u.q()))return u=ce(a),d=ce(a),f=u.$a(),a.h.ia(),Sga||(Sga=(new HD).c()),u=Tga(null,null,null),d=d.Ga(),d<f&&(d=-1+f|0),d=(new L).K(f,1+d|0),f=M(),u=P(f,u),(new T).e(O(u,R(a.ea,a.P,d)));if(d&&(u=ig(jg(),f),!u.g()&&"-"===u.q()))return u=ce(a),d=ce(a),f=u.$a(),a.h.ia(),Uga||(Uga=(new ID).c()),u=Vga(null,null,null),d=d.Ga(),d<f&&(d=-1+f|0),d=(new L).K(f,
1+d|0),f=M(),u=P(f,u),(new T).e(O(u,R(a.ea,a.P,d)))}return S()}function Wga(a){null===a.qr&&null===a.qr&&(a.qr=(new JD).z(a));return a.qr}
function nea(a){var b=ce(a),c=ce(a),b=b.$a();Bh(a,(new KD).z(a));var d=v(),f=x(a.h);if(y(z(d,f),Dh())){d=Rea(a);if(null===d)throw(new p).e(d);var f=d.qa(),d=d.p(),g=v(),h=x(a.h);y(z(g,h),Ah())?(g=v(),h=f.xb(),g=y(z(g,h),cm())):g=!1;if(g&&f.sc().g()){f=function(a){return function(b){Ke(b)||Nk(b)||Sk(b)||Qk(b)||(le(a),b=Yc(b),Pd("not a valid early definition",b),b=void 0);return b}}(a);g=G().b;if(g===G().b)if(d===F())d=F();else{g=d.n();h=g=U(new V,f(g),F());for(d=d.o();d!==F();)var n=d.n(),n=U(new V,
f(n),F()),h=h.ga=n,d=d.o();d=g}else{for(g=zg(d,g);!d.g();)h=d.n(),g.ba(f(h)),d=d.o();d=g.da()}a.h.ia();f=uea(a);h=wD(a,!1);if(null===h)throw(new p).e(h);g=h.qa();h=h.p();d=yD(xD(),d,f,g,h)}else g=xD(),h=F(),n=F(),d=yD(g,h,n,f,d)}else{d=uea(a);g=wD(a,!1);if(null===g)throw(new p).e(g);f=g.qa();g=g.p();h=xD();n=F();d=yD(h,n,d,f,g)}c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,d),R(a.ea,a.P,c))}
function Xga(a){var b=v(),c=x(a.h);if(y(z(b,c),Hh())){Sd(a,(new Td).z(a));var d=wh(a);Ke(d)?b=d.nb((new LD).z(a)):(c=We(new Ze,a,d),b=We(new Ze,a,d),c=c.eb,cu(),d=d.ec(),d=du(d),b=b.Fb,b<c&&(b=-1+c|0),b=(new L).K(c,1+b|0),c=M(),b=O(P(c,d),R(a.ea,a.P,b)));Sd(a,(new Ud).z(a));return b}b=Tf(a.h);b=(new rf).Ia(a,b);c=qf(a.h);c=(new rf).Ia(a,c);d=b.va;b=tu();c=c.va;c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);d=M();return O(P(d,b),R(a.ea,a.P,c))}
function wD(a,b){Bh(a,(new MD).z(a));var c=v(),d=x(a.h);if(y(z(c,d),Dh()))return Rea(a);c=v();d=x(a.h);y(z(c,d),Rf())&&(b?(b=a.P.sg?"objects":"traits or objects",le(a),b=td((new yd).X((new r).d([""," may not have parameters"])),(new r).d([b])),c=x(a.h).ja(),Pd(b,c)):(le(a),b=x(a.h).ja(),Pd("unexpected opening parenthesis",b)));c=ce(a);b=ce(a);c=c.$a();Ay();var d=ce(a),f=ce(a),g=d.$a(),d=tu(),f=f.Ga();f<g&&(f=-1+g|0);f=(new L).K(g,1+f|0);g=M();d=O(P(g,d),R(a.ea,a.P,f));f=S();d=By(0,d,f);b=b.Ga();b<
c&&(b=-1+c|0);b=(new L).K(c,1+b|0);c=M();c=P(c,d);return(new q).a(O(c,R(a.ea,a.P,b)),F())}function vz(a,b,c){if(null===c)throw(new fk).c();if(c.Hg)a=c.Ab;else{var d=new ND;if(null===a)throw jo(wj(),null);d.r=a;d.Nr=b;d.Dz=c;a=hk(c,d)}return a}function kv(a,b,c,d,f){for(b=Bu(Au(b),f,d);!b.g();)d=b.n(),le(a),d=Yc(d),Pd(c,d)}function qu(a,b){var c=v(),d=x(a.h);if(y(z(c,d),Rf()))return!0;c=v();a=x(a.h);return y(z(c,a),Dh())?b:!1}
function wh(a){var b=Vfa(a);null===b.iu&&null===b.iu&&(b.iu=(new OD).Hv(b));var b=(new PD).z(a),c=!1,d=null,f=x(a.h);if(hg(f)){var c=!0,d=f,g=ig(jg(),d);if(!g.g()&&"inline"===g.q()&&!a.P.Rh){le(a);var g="`inline` identifiers are not supported by "+a.P,h=x(a.h).ja();Pd(g,h)}}if(c&&(c=ig(jg(),d),!c.g()))return b=c.q(),b=(new cd).j(b),b=Sg(b,"`"),b=(new cd).j(b),b=Tg(b,"`"),f=Tf(a.h),c=(new rf).Ia(a,f),f=Tf(a.h),f=(new rf).Ia(a,f),c=c.va,b=Of(Nf(),b),f=f.va,f<c&&(f=-1+c|0),f=(new L).K(c,1+f|0),c=M(),
b=O(P(c,b),R(a.ea,a.P,f)),a.h.ia(),b;if(Je(f))return we(a,!0,b);ky(a,(new QD).z(a))}
function nga(a){if(0===(2&a.ra)&&0===(2&a.ra)){var b;b=[];var c;c=[];var d=-1,f=0,g=F();for(;!(f>=Eg(a).Fa());){for(var h=0<=d?Dg(Eg(a),d):null,n=Dg(Eg(a),f),u=1+f|0;;){if(u<Eg(a).Fa())var w=v(),D=Dg(Eg(a),u),N=z(w,D),Q=qA(a),ea=y(N,Yga(Q));else ea=!1;if(ea)u=1+u|0;else break}u===Eg(a).Fa()&&(u=-1);var ba=u,ma=-1!==ba?Dg(Eg(a),ba):null,La=v(),Pa=z(La,n),Qa=qA(a),Ka;if(Ka=xf(Pa,Yga(Qa))){var Ba;var va=a,za=f,qa=n,la=ma;if(va.P.Dh)var Ma=v(),Ea=y(z(Ma,qa),og());else Ea=!1;if(Ea){var tb=v(),Za=z(tb,
la),eb=Wga(va),kb=new RD;if(null===eb)throw jo(wj(),null);kb.r=eb;var Pb=y(Za,kb)}else Pb=!1;if(Pb){var Na=void 0,Na=(1+za|0)<Eg(va).Fa()?(new T).e(Dg(Eg(va),1+za|0)):S();if(Na.g())Ba=!1;else{var sb=Na.q(),yb=v(),sc=z(yb,sb),Ra=FB(va);Ba=y(sc,Zga(Ra))}}else Ba=!1;Ka=!Ba}if(Ka){b.push(null===n?null:n);c.push(f);var wc=v();if(y(z(wc,n),Rf()))var Wb=g,Rb=(new ed).db(41),ub=U(new V,Rb,Wb);else{var fb=v();if(y(z(fb,n),Hh()))var Xb=g,lb=(new ed).db(93),ub=U(new V,lb,Xb);else{var Eb=v();if(y(z(Eb,n),Dh()))var xc=
g,gb=(new ed).db(125),ub=U(new V,gb,xc);else{var dc=v(),Fc=z(dc,n),Qb=Nt(a);if(y(Fc,iw(Qb)))var Bb=g,Ib=(new ed).db(8658),ub=U(new V,Ib,Bb);else{var mb=v();if(y(z(mb,n),Xg())){for(var Cb=g;;){if(Cb.g())mc=!1;else var Tb=Cb.n(),mc=125!==(null===Tb?0:Tb.pa);if(mc)Cb=Cb.o();else break}Cb.g()||(Cb=Cb.o());ub=Cb}else{var Ac=v();if(y(z(Ac,n),hu())){if(g.g())Db=!1;else var Dc=g.n(),Db=93===(null===Dc?0:Dc.pa);ub=Db?g.o():g}else{var Va=v();if(y(z(Va,n),Vf())){if(g.g())$a=!1;else var ec=g.n(),$a=41===(null===
ec?0:ec.pa);ub=$a?g.o():g}else{var vb=v();if(y(z(vb,n),Ag())){if(g.g())Bc=!1;else var fc=g.n(),Bc=8658===(null===fc?0:fc.pa);ub=Bc?g.o():g}else ub=g}}}}}}}var Ub=1+f|0,d=f,f=Ub,g=ub}else{for(var Vb=1+d|0,wb=-1,xb=!1,Xa=!1;Vb<ba;){var tc=v(),ib=Dg(Eg(a),Vb);if(y(z(tc,ib),fh()))var zb=!0;else var nb=v(),Jb=Dg(Eg(a),Vb),zb=y(z(nb,Jb),$ga());zb&&(wb=Vb,xb&&(Xa=!0),xb=!0);var jb=xb,ob=v(),gc=Dg(Eg(a),Vb),cb=z(ob,gc),Ua=SD(a),xb=!!(jb&y(cb,TD(Ua))),Vb=1+Vb|0}if(-1!==wb&&null!==h){var Yb=v(),Kb=z(Yb,h),
pb=Lda(a),hb=Kb,Lb=pb,Fa=new UD;if(null===Lb)throw jo(wj(),null);Fa.r=Lb;var bb=y(hb,Fa)}else bb=!1;if(bb&&null!==ma){var nc=v(),db=z(nc,ma),uc=xga(a),Fb=db,hc=uc,$b=new VD;if(null===hc)throw jo(wj(),null);$b.r=hc;var kc=!y(Fb,$b)}else kc=!1;if(kc)if(g.g())var lc=!0;else var Mb=g.n(),lc=125===(null===Mb?0:Mb.pa);else lc=!1;if(lc){var Nb=Dg(Eg(a),wb);if(Xa)var Gb=Nb.jb(),Sb=Nb.Q,Cc=Nb.ab(),Ob=Nb.wa(),Nb=(new WD).Lf(Gb,Sb,Cc,Ob);var Zb=Nb;b.push(null===Zb?null:Zb);c.push(wb);var Ec=1+f|0,d=wb,f=Ec}else f=
ba}}var oc=na(bc(XD),b);YD();var pc=ZD(oc,0,oc.i.length),qc=na(bc(yc),c);a.mG=(new q).a(pc,qc);a.ra|=2}return a.mG}
function ch(a,b){var c=Vfa(a);null===c.hu&&null===c.hu&&(c.hu=(new $D).Hv(c));var c=(new aE).z(a),d=!1,f=null,g=x(a.h);if(hg(g)){var d=!0,f=g,h=ig(jg(),f);if(!h.g()&&"inline"===h.q()&&!a.P.Rh){le(a);var h="`inline` identifiers are not supported by "+a.P,n=x(a.h).ja();Pd(h,n)}}if(d&&(d=ig(jg(),f),!d.g()))return c=d.q(),c=(new cd).j(c),c=Sg(c,"`"),c=(new cd).j(c),c=Tg(c,"`"),g=Tf(a.h),d=(new rf).Ia(a,g),g=Tf(a.h),g=(new rf).Ia(a,g),d=d.va,c=Cu(Du(),c),g=g.va,g<d&&(g=-1+d|0),g=(new L).K(d,1+g|0),d=M(),
c=O(P(d,c),R(a.ea,a.P,g)),b&&a.h.ia(),c;if(Je(g))return we(a,b,c);ky(a,(new QD).z(a))}function Sd(a,b){var c=v(),d=x(a.h);y(z(c,d),b)?(b=v(),c=x(a.h),xf(z(b,c),ah())&&a.h.ia()):ky(a,b)}function tf(a){null===a.Pk&&a.Bu();return a.Pk}function Iea(a){null===a.Tr&&null===a.Tr&&(a.Tr=(new bE).z(a));return a.Tr}function bfa(a){var b=(new ae).c();for(Ll(b,Ega(a,!0));;){var c=v(),d=x(a.h),c=z(c,d),d=Wu(a);if(y(c,Xu(d)))a.h.ia(),Ll(b,Ega(a,!1));else break}return b.lb()}
function SD(a){null===a.vs&&null===a.vs&&(a.vs=(new cE).z(a));return a.vs}
function uf(a,b){var c=v(),d=x(a.h),f=fx((new gx).xg(a,d)),g=z(c,f);dE||(dE=(new eE).c());var h=y(g,dE),n=v(),u=x(a.h);if(y(z(n,u),zx())){var w=Tf(a.h),D=(new rf).Ia(a,w),N=qf(a.h),Q=(new rf).Ia(a,N),ea=D.va,ba=tu(),ma=Q.va;ma<ea&&(ma=-1+ea|0);var La=(new L).K(ea,1+ma|0),Pa=M(),Qa=O(P(Pa,ba),R(a.ea,a.P,La));a.h.ia();var Ka=qf(a.h),Ba=(new rf).Ia(a,Ka),va=ce(a),za=Ba.va,qa=CA(DA(),Qa),la=va.Ga();la<za&&(la=-1+za|0);var Ma=(new L).K(za,1+la|0),Ea=M(),tb=O(P(Ea,qa),R(a.ea,a.P,Ma));return BC(a)&&b?tb:
(Sd(a,(new fE).z(a)),jy(a,tb))}var Za=v(),eb=x(a.h);if(y(z(Za,eb),CC())){var kb=Tf(a.h),Pb=(new rf).Ia(a,kb),Na=qf(a.h),sb=(new rf).Ia(a,Na),yb=Pb.va,sc=tu(),Ra=sb.va;Ra<yb&&(Ra=-1+yb|0);var wc=(new L).K(yb,1+Ra|0),Wb=M(),Rb=O(P(Wb,sc),R(a.ea,a.P,wc));a.h.ia();var ub=qf(a.h),fb=(new rf).Ia(a,ub),Xb=ce(a),lb=fb.va;gE||(gE=(new hE).c());var Eb=Xga(a),xc=aha(Rb,Eb),gb=Xb.Ga();gb<lb&&(gb=-1+lb|0);var dc=(new L).K(lb,1+gb|0),Fc=M(),Qb=O(P(Fc,xc),R(a.ea,a.P,dc));if(h&&Rga(a)&&ke(a.P))return Qb;Sd(a,(new iE).z(a));
var Bb=We(new Ze,a,Qb),Ib=ce(a),mb=Bb.eb;Xt();var Cb=ch(a,!0),Tb=Zt(0,Qb,Cb),mc=Ib.Ga();mc<mb&&(mc=-1+mb|0);var Ac=(new L).K(mb,1+mc|0),Dc=M(),Db=O(P(Dc,Tb),R(a.ea,a.P,Ac));if(BC(a))return Db;a.h.ia();return jy(a,Db)}var Va=ch(a,!0);if(BC(a))return Va;a.h.ia();var ec=v(),$a=x(a.h);if(y(z(ec,$a),zx())){a.h.ia();if(Ke(Va))var vb=Va.nb((new jE).z(a));else{var fc=We(new Ze,a,Va),Bc=We(new Ze,a,Va),Ub=fc.eb;cu();var Vb=Va.ec(),wb=du(Vb),xb=Bc.Fb;xb<Ub&&(xb=-1+Ub|0);var Xa=(new L).K(Ub,1+xb|0),tc=M(),vb=
O(P(tc,wb),R(a.ea,a.P,Xa))}var ib=We(new Ze,a,Va),zb=ce(a),nb=ib.eb,Jb=CA(DA(),vb),jb=zb.Ga();jb<nb&&(jb=-1+nb|0);var ob=(new L).K(nb,1+jb|0),gc=M(),cb=O(P(gc,Jb),R(a.ea,a.P,ob));return BC(a)&&b?cb:(Sd(a,(new kE).z(a)),jy(a,cb))}var Ua=v(),Yb=x(a.h);if(y(z(Ua,Yb),CC())){a.h.ia();if(Ke(Va))var Kb=Va.nb((new lE).z(a));else{var pb=We(new Ze,a,Va),hb=We(new Ze,a,Va),Lb=pb.eb;cu();var Fa=Va.ec(),bb=du(Fa),nc=hb.Fb;nc<Lb&&(nc=-1+Lb|0);var db=(new L).K(Lb,1+nc|0),uc=M(),Kb=O(P(uc,bb),R(a.ea,a.P,db))}var Fb=
We(new Ze,a,Va),hc=ce(a),$b=Fb.eb;gE||(gE=(new hE).c());var kc=Xga(a),lc=aha(Kb,kc),Mb=hc.Ga();Mb<$b&&(Mb=-1+$b|0);var Nb=(new L).K($b,1+Mb|0),Gb=M(),Sb=O(P(Gb,lc),R(a.ea,a.P,Nb));if(h&&Rga(a)&&ke(a.P))return Sb;Sd(a,(new mE).z(a));var Cc=We(new Ze,a,Sb),Ob=ce(a),Zb=Cc.eb;Xt();var Ec=ch(a,!0),oc=Zt(0,Sb,Ec),pc=Ob.Ga();pc<Zb&&(pc=-1+Zb|0);var qc=(new L).K(Zb,1+pc|0),Jc=M(),Hc=O(P(Jc,oc),R(a.ea,a.P,qc));if(BC(a))return Hc;a.h.ia();return jy(a,Hc)}return jy(a,Ke(Va)?Va.nb((new nE).z(a)):Va)}
function ng(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);if(Yh(d)){a.h.ia();bha||(bha=(new oE).c());var d=su(a),f=Vd(d);if(null!==f)d=(new q).a(!0,F());else{G();var d=(new r).d(["tpe is equal to null"]),g=G().b,d=(new q).a(!1,H(d,g))}if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){for(var c=J(),b=[(new q).a("tpe",f)],f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(c,"tpe.!\x3d(null)",a,f.t)}throw(new p).e(d);}d=cha(null,null,null);d.qc=f.y(f,d,"tpe",f.s)}else if(d=su(a),f=Vd(d),Vg(a,
"*")){a.h.ia();dha||(dha=(new pE).c());null!==f?d=(new q).a(!0,F()):(G(),d=(new r).d(["tpe is equal to null"]),g=G().b,d=(new q).a(!1,H(d,g)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){c=J();b=[(new q).a("tpe",f)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(c,"tpe.!\x3d(null)",a,f.t)}throw(new p).e(d);}d=eha(null,null,null);d.qc=f.y(f,d,"tpe",f.s)}else d=f;c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,d),R(a.ea,a.P,c))}
function vga(a){var b=v(),c=x(a.h);xf(z(b,c),Dh())?(b=v(),c=x(a.h),b=xf(z(b,c),Rf())):b=!1;if(b)return a=oga(a,!1),b=F(),U(new V,a,b);var d=Tf(a.h),c=wu(a),f=qf(a.h),b=x(a.h);if(fC(b)||fi(b)||ue(b)||Be(b)||nf(b))return b=jx,d=(new rf).Ia(a,d),f=(new rf).Ia(a,f),d=d.va,c=cx(a,Hfa(a,c)),f=f.va,f<d&&(f=-1+d|0),f=(new L).K(d,1+f|0),d=M(),c=O(P(d,c),R(a.ea,a.P,f)),a=b(a,c,!0),b=F(),U(new V,a,b);if(rk(c)){var b=c.ed,g=c.ga;if(F().w(g))return c=(new rf).Ia(a,d),f=(new rf).Ia(a,f),c=c.va,f=f.va,f<c&&(f=-1+
c|0),c=(new L).K(c,1+f|0),f=M(),a=O(P(f,b),R(a.ea,a.P,c)),b=F(),U(new V,a,b)}return c}
function fha(a){var b=ce(a),c=ce(a),b=b.$a(),d=x(a.h);a:{var f;if(Mv(d))f=Cu(Du(),"xml");else{if(Nv(d)&&(d=Ov(Pv(),d),!d.g())){f=d.q();f=Cu(Du(),f);break a}for(var d=he(),g=[(new q).a("ScalametaParser.this.token",x(a.h))],h=A(new B,C()),n=0,u=g.length|0;n<u;)E(h,g[n]),n=1+n|0;ie(d,h.t)}}d=Tf(a.h);d=(new rf).Ia(a,d);g=Tf(a.h);g=(new rf).Ia(a,g);d=d.va;g=g.va;g<d&&(g=-1+d|0);d=(new L).K(d,1+g|0);g=M();O(P(g,f),R(a.ea,a.P,d));f=v();d=x(a.h);y(z(f,d),Qv())&&a.h.ia();d=(new ae).c();f=(new ae).c();a:for(;;){g=
x(a.h);if(Rv(g)||Mv(g)){a.h.ia();continue a}if(Sv(g)&&(h=g,h=Tv(Uv(),h),!h.g())){g=h.q();h=Tf(a.h);n=(new rf).Ia(a,h);h=Tf(a.h);h=(new rf).Ia(a,h);n=n.va;g=Dt(Et(),g);h=h.va;h<n&&(h=-1+n|0);h=(new L).K(n,1+h|0);n=M();g=P(n,g);ff(d,O(g,R(a.ea,a.P,h)));a.h.ia();continue a}if(Vv(g)&&(h=g,h=Wv(Xv(),h),!h.g())){g=h.q();h=Tf(a.h);n=(new rf).Ia(a,h);h=Tf(a.h);h=(new rf).Ia(a,h);n=n.va;g=Dt(Et(),g);h=h.va;h<n&&(h=-1+n|0);h=(new L).K(n,1+h|0);n=M();g=P(n,g);ff(d,O(g,R(a.ea,a.P,h)));a.h.ia();continue a}if(Yv(g)||
Zv(g)){a.h.ia();g=a;null===g.Tt&&null===g.Tt&&(g.Tt=(new qE).z(g));ff(f,gha(g.Tt));continue a}if(aw(g)||bw(g)){a.h.ia();continue a}if(cw(g)||dw(g))a.h.ia();else{for(var g=he(),h=(new q).a("ScalametaParser.this.token",x(a.h)),n=Se(),u=x(a.h),w=ew().Hc(),h=[h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",Ue(Ve(n,u,w)))],n=A(new B,C()),u=0,w=h.length|0;u<
w;)E(n,h[u]),u=1+u|0;ie(g,n.t)}break}d=d.lb();f=f.lb();g=hha;rE||(rE=(new sE).c());f=g(rE,d,f);c=c.Ga();c<b&&(c=-1+b|0);c=(new L).K(b,1+c|0);b=M();return O(P(b,f),R(a.ea,a.P,c))}e.$classData=l({aU:0},!1,"scala.meta.internal.parsers.ScalametaParser",{aU:1,f:1});function XA(){this.iu=this.hu=null}XA.prototype=new m;XA.prototype.constructor=XA;XA.prototype.z=function(){return this};XA.prototype.$classData=l({PW:0},!1,"scala.meta.internal.parsers.ScalametaParser$AllowedName$",{PW:1,f:1});
function bv(){this.r=null}bv.prototype=new m;bv.prototype.constructor=bv;
bv.prototype.Gc=function(a){var b=v();if(y(z(b,a),Pu()))b=!0;else var b=v(),b=z(b,a),c=tf(this.r),b=y(b,tE(c));b?b=!0:(b=v(),b=z(b,a),uE||(uE=(new vE).c()),b=y(b,uE));b?b=!0:(b=v(),b=z(b,a),wE||(wE=(new xE).c()),b=y(b,wE));b?b=!0:(b=v(),b=y(z(b,a),iha()));b?b=!0:(b=v(),b=y(z(b,a),zx()));b?b=!0:(b=v(),b=y(z(b,a),jha()));b?b=!0:(b=v(),b=y(z(b,a),Vf()));b?b=!0:(b=v(),b=y(z(b,a),hu()));b?b=!0:(b=v(),b=y(z(b,a),Xg()));b?b=!0:(b=v(),b=y(z(b,a),pz()));b?b=!0:(b=v(),b=y(z(b,a),be()));if(b)return!0;b=v();
return y(z(b,a),Ug())};bv.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};bv.prototype.$classData=l({TW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CanEndStat$",{TW:1,f:1});function FC(){this.r=null}FC.prototype=new m;FC.prototype.constructor=FC;
FC.prototype.Gc=function(a){var b=v();y(z(b,a),Tea())?b=!0:(b=v(),b=y(z(b,a),Ly()));b?b=!0:(b=v(),b=y(z(b,a),Pga()));b?b=!0:(b=v(),b=z(b,a),yE||(yE=(new zE).c()),b=y(b,yE));b?b=!0:(b=v(),b=z(b,a),AE||(AE=(new BE).c()),b=y(b,AE));b?b=!0:(b=v(),b=y(z(b,a),tfa()));b?b=!0:(b=v(),b=y(z(b,a),Ah()));b?b=!0:(b=v(),b=y(z(b,a),cfa()));b?b=!0:(b=v(),b=y(z(b,a),Vf()));b?b=!0:(b=v(),b=y(z(b,a),Hh()));b?b=!0:(b=v(),b=y(z(b,a),hu()));b?b=!0:(b=v(),b=y(z(b,a),Xg()));b?b=!0:(b=v(),b=y(z(b,a),og()));b?b=!0:(b=v(),
b=y(z(b,a),lg()));b?b=!0:(b=v(),b=y(z(b,a),Bf()));b?b=!0:(b=v(),b=y(z(b,a),Wg()));b?b=!0:(b=v(),b=y(z(b,a),Oy()));b?b=!0:(b=v(),b=y(z(b,a),Qga()));b?b=!0:(b=v(),b=y(z(b,a),Ag()));b?b=!0:(b=v(),b=y(z(b,a),Fga()));b?b=!0:(b=v(),b=y(z(b,a),kx()));b?b=!0:(b=v(),b=y(z(b,a),sea()));b?b=!0:(b=v(),b=y(z(b,a),lx()));b?b=!0:(b=v(),b=y(z(b,a),fh()));b?b=!0:(b=v(),b=y(z(b,a),pw()));if(b)return!0;b=v();return y(z(b,a),ah())};FC.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
FC.prototype.$classData=l({VW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CantStartStat$",{VW:1,f:1});function Jy(){this.r=null}Jy.prototype=new m;Jy.prototype.constructor=Jy;Jy.prototype.Gc=function(a){var b=v();y(z(b,a),Xg())?b=!0:(b=v(),b=y(z(b,a),ah()));b?b=!0:(b=v(),b=y(z(b,a),jw())?!CE((new DE).xg(this.r,a)):!1);if(b)return!0;b=v();return y(z(b,a),be())?(b=v(),a=(new gx).xg(this.r,a).ia(),y(z(b,a),jw())):!1};Jy.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
Jy.prototype.$classData=l({XW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CaseDefEnd$",{XW:1,f:1});function Ot(){this.r=null}Ot.prototype=new m;Ot.prototype.constructor=Ot;Ot.prototype.Gc=function(a){var b=v();return y(z(b,a),jw())?!CE((new DE).xg(this.r,a)):!1};Ot.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};Ot.prototype.$classData=l({ZW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CaseIntro$",{ZW:1,f:1});function JD(){this.r=null}JD.prototype=new m;
JD.prototype.constructor=JD;JD.prototype.Gc=function(a){var b=v();y(z(b,a),Xg())?b=!0:(b=v(),b=y(z(b,a),hu()));if(b)return!0;b=v();return y(z(b,a),Vf())};JD.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};JD.prototype.$classData=l({aX:0},!1,"scala.meta.internal.parsers.ScalametaParser$CloseDelim$",{aX:1,f:1});function hw(){this.r=null}hw.prototype=new m;hw.prototype.constructor=hw;
hw.prototype.Gc=function(a){var b=v(),b=z(b,a);EE||(EE=(new FE).c());y(b,EE)?b=!0:(b=v(),b=y(z(b,a),jha()));b?b=!0:(b=v(),b=y(z(b,a),$A()));b?b=!0:(b=v(),b=y(z(b,a),jv()));if(b)return!0;b=v();return y(z(b,a),Ug())?(b=v(),a=(new gx).xg(this.r,a).ia(),y(z(b,a),fv(this))):!1};hw.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};hw.prototype.$classData=l({cX:0},!1,"scala.meta.internal.parsers.ScalametaParser$DclIntro$",{cX:1,f:1});function DB(){this.r=null}DB.prototype=new m;
DB.prototype.constructor=DB;DB.prototype.Gc=function(a){var b=v(),b=z(b,a),c=ox(this.r);y(b,GE(c))?b=!0:(b=v(),b=y(z(b,a),iu()));b?b=!0:(b=v(),b=z(b,a),c=sx(this.r),b=y(b,kha(c)));b?b=!0:(b=v(),b=z(b,a),c=ev(this.r),b=y(b,fv(c)));b?b=!0:(b=v(),y(z(b,a),Ug())?(b=v(),c=(new gx).xg(this.r,a).ia(),b=y(z(b,c),Ou(this))):b=!1);b?b=!0:(b=v(),y(z(b,a),be())?(b=v(),c=(new gx).xg(this.r,a).ia(),b=y(z(b,c),Ou(this))):b=!1);if(b)return!0;b=v();return y(z(b,a),jw())?CE((new DE).xg(this.r,a)):!1};
DB.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};DB.prototype.$classData=l({eX:0},!1,"scala.meta.internal.parsers.ScalametaParser$DefIntro$",{eX:1,f:1});function GA(){this.r=null}GA.prototype=new m;GA.prototype.constructor=GA;
GA.prototype.Gc=function(a){var b=v();if(y(z(b,a),Pu()))var b=Se(),c=this.r.kh,c=pA().If(c),b=!("inline"===yg(b,a,c).be()&&!this.r.P.Rh);else b=!1;b?b=!0:(b=v(),b=z(b,a),c=tf(this.r),b=y(b,tE(c)));b?b=!0:(b=v(),b=y(z(b,a),Qv()));b?b=!0:(b=v(),b=z(b,a),HE||(HE=(new IE).c()),b=y(b,HE));b?b=!0:(b=v(),b=z(b,a),JE||(JE=(new KE).c()),b=y(b,JE));b?b=!0:(b=v(),b=z(b,a),LE||(LE=(new ME).c()),b=y(b,LE));b?b=!0:(b=v(),b=y(z(b,a),JA()));b?b=!0:(b=v(),b=z(b,a),NE||(NE=(new OE).c()),b=y(b,NE));b?b=!0:(b=v(),b=
y(z(b,a),iha()));b?b=!0:(b=v(),b=y(z(b,a),CC()));b?b=!0:(b=v(),b=y(z(b,a),zx()));b?b=!0:(b=v(),b=z(b,a),PE||(PE=(new QE).c()),b=y(b,PE));b?b=!0:(b=v(),b=z(b,a),RE||(RE=(new SE).c()),b=y(b,RE));b?b=!0:(b=v(),b=z(b,a),TE||(TE=(new UE).c()),b=y(b,TE));b?b=!0:(b=v(),b=y(z(b,a),Rf()));b?b=!0:(b=v(),b=y(z(b,a),Dh()));b?b=!0:(b=v(),b=y(z(b,a),pz()));if(b)return!0;b=v();return y(z(b,a),Ug())};GA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
GA.prototype.$classData=l({gX:0},!1,"scala.meta.internal.parsers.ScalametaParser$ExprIntro$",{gX:1,f:1});function VE(){this.r=this.Pi=null}VE.prototype=new m;VE.prototype.constructor=VE;function WE(){}WE.prototype=VE.prototype;function uga(a,b,c,d,f,g){var h=a.Pi,n=new XE;n.mo=b;n.$i=c;n.gq=d;n.Wd=f;n.Bn=g;if(null===a)throw jo(wj(),null);n.r=a;a.Pi=U(new V,n,h)}
function zC(a,b,c,d,f){if(f.g())var g=S();else g=f.q(),g=(new T).e(eh(g).cl());g=(g.g()?0:g.q())|0;f.g()?f=S():(f=f.q(),f=(new T).e(dh(eh(f))));f=!(!f.g()&&!f.q());lha(a,b,g)&&Paa(a.r,a.Pi.n().Wd,f);a:for(;;){var h=a,n=b,u=g,w=f;if(!mha(h,n)&&u<h.Pi.n().cl()||w&&lha(h,n,u)){var D;c:{h=a;try{D=h.Pi.n();break c}finally{h.Pi=h.Pi.o()}D=void 0}c=a.RA(D,c,d);c=a.dG(c)}else{a=a.cG(c);break a}}return a}function mha(a,b){a=a.Pi;return null===a?null===b:a.w(b)}
function lha(a,b,c){return!mha(a,b)&&c===a.Pi.n().cl()}VE.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;this.Pi=F();return this};function YE(){this.r=this.QB=this.PB=null}YE.prototype=new m;YE.prototype.constructor=YE;function ZE(){}ZE.prototype=YE.prototype;YE.prototype.Wp=function(a,b,c){this.PB=b;this.QB=c;if(null===a)throw jo(wj(),null);this.r=a;return this};function GB(){this.r=null}GB.prototype=new m;GB.prototype.constructor=GB;
GB.prototype.Gc=function(a){var b=v();y(z(b,a),fh())?b=!0:(b=v(),b=y(z(b,a),pw()));if(b)return!0;b=v();a=z(b,a);$E||($E=(new aF).c());return y(a,$E)};GB.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};GB.prototype.$classData=l({oX:0},!1,"scala.meta.internal.parsers.ScalametaParser$LineEnd$",{oX:1,f:1});function EB(){this.r=null}EB.prototype=new m;EB.prototype.constructor=EB;
EB.prototype.Gc=function(a){return Xs(a)&&!Ys(Zs(),a).g()||dt(a)&&!et(ft(),a).g()||jt(a)&&!kt(lt(),a).g()||qt(a)&&!rt(st(),a).g()||wt(a)&&!xt(yt(),a).g()||Ft(a)&&!Gt(Ht(),a).g()||At(a)&&!Bt(Ct(),a).g()||Jt(a)||Kt(a)||Lt(a)?!0:!1};EB.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};EB.prototype.$classData=l({qX:0},!1,"scala.meta.internal.parsers.ScalametaParser$Literal$",{qX:1,f:1});function GC(){this.r=null}GC.prototype=new m;GC.prototype.constructor=GC;
GC.prototype.Gc=function(a){var b=v(),b=z(b,a),c=ox(this.r);return y(b,GE(c))?(b=v(),a=z(b,a),b=Vs(this.r),!y(a,Ida(b))):!1};GC.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};GC.prototype.$classData=l({sX:0},!1,"scala.meta.internal.parsers.ScalametaParser$LocalModifier$",{sX:1,f:1});function ZC(){this.r=null}ZC.prototype=new m;ZC.prototype.constructor=ZC;
ZC.prototype.Gc=function(a){var b=v(),b=z(b,a);bF||(bF=(new cF).c());y(b,bF)?b=!0:(b=v(),b=z(b,a),dF||(dF=(new eF).c()),b=y(b,dF));b?b=!0:(b=v(),b=z(b,a),fF||(fF=(new gF).c()),b=y(b,fF));b?b=!0:(b=v(),b=y(z(b,a),Vi()));b?b=!0:(b=v(),b=z(b,a),hF||(hF=(new iF).c()),b=y(b,hF));b?b=!0:(b=v(),b=y(z(b,a),nha()));b?b=!0:(b=v(),b=y(z(b,a),oha()));b?b=!0:(b=v(),b=y(z(b,a),pha()));if(b)return!0;b=v();if(y(z(b,a),Pu())){var b=Se(),c=this.r.kh,c=pA().If(c);a="inline"===yg(b,a,c).be()}else a=!1;return a?this.r.P.Sh:
!1};ZC.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};ZC.prototype.$classData=l({uX:0},!1,"scala.meta.internal.parsers.ScalametaParser$Modifier$",{uX:1,f:1});function wz(){}wz.prototype=new m;wz.prototype.constructor=wz;wz.prototype.Dn=function(a){if(Ff(a)){var b=null===a?S():(new T).e((new q).a(a.ca,a.fa()));if(!b.g()&&0===b.q().Xa())return!0}return Pf(a)||Em(a)?!0:!1};wz.prototype.z=function(){return this};
wz.prototype.$classData=l({wX:0},!1,"scala.meta.internal.parsers.ScalametaParser$NameLike$2$",{wX:1,f:1});function Ws(){this.r=null}Ws.prototype=new m;Ws.prototype.constructor=Ws;Ws.prototype.Gc=function(a){var b=v();y(z(b,a),nha())?b=!0:(b=v(),b=y(z(b,a),oha()));if(b)return!0;b=v();return y(z(b,a),pha())};Ws.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};Ws.prototype.$classData=l({xX:0},!1,"scala.meta.internal.parsers.ScalametaParser$NonlocalModifier$",{xX:1,f:1});
function WA(){this.r=null}WA.prototype=new m;WA.prototype.constructor=WA;WA.prototype.Gc=function(a){return Xs(a)&&!Ys(Zs(),a).g()||dt(a)&&!et(ft(),a).g()||jt(a)&&!kt(lt(),a).g()||qt(a)&&!rt(st(),a).g()?!0:!1};WA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};WA.prototype.$classData=l({zX:0},!1,"scala.meta.internal.parsers.ScalametaParser$NumericLiteral$",{zX:1,f:1});function ND(){this.Dz=this.Nr=this.r=null}ND.prototype=new m;ND.prototype.constructor=ND;
ND.prototype.Dn=function(a){var b=!1,c=null,d=!1,f=null;if(Ff(a)){var b=!0,g=c=a,g=null===g?S():(new T).e((new q).a(g.ca,g.fa()));if(!g.g()&&0===g.q().Xa())return!0}if(b&&(b=c,b=null===b?S():(new T).e((new q).a(b.ca,b.fa())),!b.g())){c=b.q().Xa();b=b.q().p();if(c=1===c)c=this.Dz,c=(c.Hg?c.Ab:vz(this.r,this.Nr,c)).Dn(b);if(c)return!0}return uz(this.r,this.Nr).Dn(a)||im(a)&&(d=!0,a=f=a,a=null===a?S():(new T).e((new q).a(a.ob(),a.Db())),!a.g()&&(a=a.q().qa(),Ff(a)&&(a=null===a?S():(new T).e((new q).a(a.ca,
a.fa())),!a.g()&&0===a.q().Xa())))||d&&(d=f,d=null===d?S():(new T).e((new q).a(d.ob(),d.Db())),!d.g()&&(d=d.q().qa(),uz(this.r,this.Nr).Dn(d)))?!0:!1};ND.prototype.$classData=l({FX:0},!1,"scala.meta.internal.parsers.ScalametaParser$ParamLike$2$",{FX:1,f:1});
function IA(a){var b=a.r,c=function(a){return function(){var b=OB(a);return PB(a,b)}}(a),d=(new jF).Im(a),f=(new Xd).z(b),g=(new ae).c(),h=v(),n=x(b.h);if(y(z(h,n),be())){var u=ce(b),w=ce(b),D=u.$a(),N=x(b.h);if(!de(N)){for(var Q=he(),ea=[(new q).a("ScalametaParser.this.token",x(b.h))],ba=A(new B,C()),ma=0,La=ea.length|0;ma<La;)E(ba,ea[ma]),ma=1+ma|0;ie(Q,ba.t)}if(!ke(b.P)){le(b);var Pa=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([b.P])),Qa=N.ja();Pd(Pa,Qa)}if(1!==N.Hb){le(b);
var Ka=oe(pe(),N.Hb,1),Ba=N.ja();Pd(Ka,Ba)}b.h.ia();var va=x(b.h);if(ue(va)){Sd(b,(new ve).z(b));var za=we(b,!0,d);Sd(b,(new Ae).z(b));var qa=za}else if(Be(va)){Sd(b,(new Ee).z(b));var la=we(b,!0,d);Sd(b,(new Ie).z(b));qa=la}else if(Je(va))qa=we(b,!0,d);else{le(b);var Ma=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(b.h).oa()])),Ea=x(b.h).ja();Pd(Ma,Ea)}if(Ke(qa)){if(Le((Oe(),d).G(),qa.uc()))var tb=(new q).a(!0,F());else{G();var Za=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
eb=G().b,tb=(new q).a(!1,H(Za,eb))}if(null===tb||!0!==I(tb)){if(null!==tb){var kb=tb.p();if(!1===I(tb)){for(var Pb=J(),Na=(new q).a("ellipsis",N),sb=(new q).a("result",qa),yb=(new q).a("evidence$4",d),sc=(new q).a("quasi",qa),Ra=Se(),wc=Te().Hc(),Wb=[Na,sb,yb,sc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Ra,qa,wc)))],Rb=A(new B,C()),ub=0,fb=Wb.length|0;ub<fb;)E(Rb,Wb[ub]),ub=1+ub|0;K(Pb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
kb,Rb.t)}}throw(new p).e(tb);}var Xb=We(new Ze,b,qa),lb=We(new Ze,b,qa),Eb=Xb.eb,xc=qa.ca,gb=qa.fa(),dc=uv(vv(),xc,gb),Fc=lb.Fb;Fc<Eb&&(Fc=-1+Eb|0);var Qb=(new L).K(Eb,1+Fc|0),Bb=M(),Ib=O(P(Bb,dc),R(b.ea,b.P,Qb))}else Ib=qa;var mb=uv(vv(),1,Ib),Cb=w.Ga();Cb<D&&(Cb=-1+D|0);var Tb=(new L).K(D,1+Cb|0),mc=M(),Ac=O(P(mc,mb),R(b.ea,b.P,Tb))}else Ac=c();for(ff(g,Ac);;){var Dc=v(),Db=x(b.h);if(y(z(Dc,Db),f))var Va=!0;else var ec=v(),$a=x(b.h),Va=y(z(ec,$a),be());if(Va){var vb=v(),fc=x(b.h);y(z(vb,fc),f)&&
b.h.ia();var Bc=v(),Ub=x(b.h);if(y(z(Bc,Ub),be())){var Vb=ce(b),wb=ce(b),xb=Vb.$a(),Xa=x(b.h);if(!de(Xa)){for(var tc=he(),ib=[(new q).a("ScalametaParser.this.token",x(b.h))],zb=A(new B,C()),nb=0,Jb=ib.length|0;nb<Jb;)E(zb,ib[nb]),nb=1+nb|0;ie(tc,zb.t)}var jb=Xa;if(!ke(b.P)){le(b);var ob=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([b.P])),gc=jb.ja();Pd(ob,gc)}if(1!==jb.Hb){le(b);var cb=oe(pe(),jb.Hb,1),Ua=jb.ja();Pd(cb,Ua)}b.h.ia();var Yb=x(b.h);if(ue(Yb)){Sd(b,(new ve).z(b));
var Kb=we(b,!0,d);Sd(b,(new Ae).z(b));var pb=Kb}else if(Be(Yb)){Sd(b,(new Ee).z(b));var hb=we(b,!0,d);Sd(b,(new Ie).z(b));pb=hb}else if(Je(Yb))pb=we(b,!0,d);else{le(b);var Lb=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(b.h).oa()])),Fa=x(b.h).ja();Pd(Lb,Fa)}if(Ke(pb)){if(Le((Oe(),d).G(),pb.uc()))var bb=(new q).a(!0,F());else{G();var nc=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),db=G().b,bb=(new q).a(!1,
H(nc,db))}if(null===bb||!0!==I(bb)){if(null!==bb){var uc=bb.p();if(!1===I(bb)){for(var Fb=J(),hc=(new q).a("ellipsis",jb),$b=(new q).a("result",pb),kc=(new q).a("evidence$4",d),lc=(new q).a("quasi",pb),Mb=Se(),Nb=Te().Hc(),Gb=[hc,$b,kc,lc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(Mb,pb,Nb)))],Sb=A(new B,C()),Cc=0,Ob=Gb.length|0;Cc<Ob;)E(Sb,Gb[Cc]),Cc=1+Cc|0;K(Fb,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
uc,Sb.t)}}throw(new p).e(bb);}var Zb=We(new Ze,b,pb),Ec=We(new Ze,b,pb),oc=Zb.eb,pc=pb.ca,qc=pb.fa(),Jc=uv(vv(),pc,qc),Hc=Ec.Fb;Hc<oc&&(Hc=-1+oc|0);var ac=(new L).K(oc,1+Hc|0),Lc=M(),$c=O(P(Lc,Jc),R(b.ea,b.P,ac))}else $c=pb;var Tc=uv(vv(),1,$c),Rc=wb.Ga();Rc<xb&&(Rc=-1+xb|0);var Mc=(new L).K(xb,1+Rc|0),hd=M(),Qc=O(P(hd,Tc),R(b.ea,b.P,Mc))}else Qc=c();ff(g,Qc)}else break}return g.lb()}
function Xfa(a){var b=a.r;a=function(a){return function(){var b=OB(a);return PB(a,b)}}(a);var c=v(),d=x(b.h);return y(z(c,d),Dh())?(Sd(b,(new Ee).z(b)),a=a(),Sd(b,(new Ie).z(b)),a):a()}
function kF(a){var b;if(b=a.Il)a:{var c=v(),d=x(a.r.h);if(y(z(c,d),pz())){c=a.r;d=c.h;d=(new kg).Ia(d.r,d.Dc);c.h.ia();try{if(Vg(a.r,"*")){var f=a.r,g=f.h,h=(new kg).Ia(g.r,g.Dc);f.h.ia();try{var n=v(),u=x(a.r.h);if(y(z(n,u),Vf()))var w=!0;else var D=v(),N=x(a.r.h),w=y(z(D,N),Xg());if(w)b=!0;else{var Q=v(),ea=x(a.r.h);b=y(z(Q,ea),ah())}break a}finally{f.h=h}}else{b=!1;break a}}finally{c.h=d}b=void 0}else b=!1}return b}
function lF(a){var b=Lea(a.r),c=(new Jd).c();try{var d=a.r,f=ce(d),g=ce(d),h=f.$a(),f=!1,n=x(a.r.h);a:{var u;var w;w=hg(n)&&!ig(jg(),n).g()?!0:Ww(n)?!0:Je(n)?!0:!1;if(w){var D=lga(a.r),N=uf(a.r,!1);b:{var Q;if(!Ke(N)&&Pf(N)){var ea=null===N?S():(new T).e(N.ec());if(!ea.g()){var ba=ea.q();if(D)Q=!1;else{var ma=(new cd).j(ba),La=eo(ma),Pa=null===La?0:La.pa;if(ii(qi(),Pa))var Qa=(new cd).j(ba),Ka=eo(Qa),Ba=null===Ka?0:Ka.pa,va=mF(qi(),Ba);else va=!1;if(va)Q=!0;else{var za=(new cd).j(ba),qa=eo(za);Q=
95===(null===qa?0:qa.pa)}}break b}}Q=!1}var la=v(),Ma=x(a.r.h),Ea=z(la,Ma),tb=VA(a.r);if(y(Ea,mC(tb))&&Pf(N)){var Za=null===N?S():(new T).e(N.ec());if(!Za.g()&&"-"===Za.q()){var eb=a.r,kb=We(new Ze,a.r,N),Pb=ce(a.r),Na=kb.eb,sb=vf(a.r,!0),yb=Pb.Ga();yb<Na&&(yb=-1+Na|0);var sc=(new L).K(Na,1+yb|0),Ra=M(),wc=P(Ra,sb);throw(new VC).a(c,O(wc,R(eb.ea,eb.P,sc)));}}var Wb=x(a.r.h),Rb=fi(Wb)?iba(a):F(),ub=x(a.r.h);if(ue(ub)){var fb=Ke(N)?N.nb((new nF).Im(a)):N;if(cj(Rb)){var Xb=a.r,lb=We(new Ze,a.r,N),Eb=
ce(a.r),xc=lb.eb,gb=hC(gC(),fb,Rb),dc=Eb.Ga();dc<xc&&(dc=-1+xc|0);var Fc=(new L).K(xc,1+dc|0),Qb=M(),Bb=O(P(Qb,gb),R(Xb.ea,Xb.P,Fc))}else Bb=fb;var Ib=qha(),mb=SC(a.r,Pfa(a.r));u=rha(Ib,Bb,mb);break a}if(cj(Rb)){le(a.r);var Cb=x(a.r.h).ja();Pd("pattern must be a value",Cb)}if(Gf(N)){u=N.nb((new oF).Im(a));break a}if(Pf(N)&&Q){u=wv(xv(),N);break a}if(Pf(N)){u=N;break a}if(Df(N)){u=N;break a}var Tb=he(),mc=(new q).a("ScalametaParser.this.token",x(a.r.h)),Ac=Se(),Dc=x(a.r.h),Db=ew().Hc(),Va=(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",
Ue(Ve(Ac,Dc,Db))),ec=(new q).a("sid",N),$a=Se(),vb=Te().Hc(),fc=[mc,Va,ec,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.Term.Ref](sid)(meta.this.Tree.showStructure[scala.meta.Term.Ref]).structure",Ue(Ve($a,N,vb)))],Bc=A(new B,C());w=0;for(var Ub=fc.length|0;w<Ub;)E(Bc,fc[w]),w=1+w|0;ie(Tb,Bc.t)}if(nf(n)&&(f=!0,kF(a))){lC(a.r);u=pF();break a}if(f)a.r.h.ia(),u=sha();else if(tf(a.r).Gc(n))u=vf(a.r,!1);else if(Nv(n)&&!Ov(Pv(),n).g())u=Wfa(a.r);else if(Mv(n))u=fha(a.r);else if(ue(n)){var Vb=
a.r;Sd(Vb,(new ve).z(Vb));var wb=v(),xb=x(a.r.h);if(y(z(wb,xb),Vf()))var Xa=F();else var tc=sv(a.r),Xa=IA(tc);Sd(Vb,(new Ae).z(Vb));var ib=function(){return function(a){return tha(uha(),a)}}(a);if(F().w(Xa))u=Py();else{if(rk(Xa)){var n=Xa,zb=n.ed,nb=n.ga;if(F().w(nb)){if(Ke(zb)&&1===zb.ca){u=ib(Xa);break a}u=zb;break a}}u=ib(Xa)}}else{var Jb=x(a.r.h);vha(a,Jb)}}var jb=g.Ga();jb<h&&(jb=-1+h|0);var ob=(new L).K(h,1+jb|0),gc=M(),cb=O(P(gc,u),R(d.ea,d.P,ob))}catch(Ua){if(YC(Ua))if(Ua.Ys===c)cb=Ua.Rt;
else throw Ua;else throw Ua;}return wha(a,cb,b,b.Pi)}function gha(a){var b=a.r;a=function(a){return function(){var b=OB(a);return PB(a,b)}}(a);var c=v(),d=x(b.h);return y(z(c,d),Dh())?(Sd(b,(new Ee).z(b)),a=a(),Sd(b,(new Ie).z(b)),a):a()}
function Oda(a){var b=a.r,c=ce(b),d=ce(b),c=c.$a(),f=lF(a),g=v(),h=x(a.r.h);if(xf(z(g,h),iu()))a=f;else{var n=!1,g=null,h=!1;a:if(Ke(f))a.r.h.ia(),qF(),a=lF(a),a=rF(0,f,a);else{if(Pf(f)){le(a.r);var u=Yc(f);Pd("Pattern variables must start with a lower-case letter. (SLS 8.1.1.)",u)}if(ln(f)){n=!0;g=f;if(a.r.P.rg){var u=a.r,w=u.h,w=(new kg).Ia(w.r,w.Dc);u.h.ia();try{var D=kF(a)}finally{u.h=w}}else D=!1;if(D){a.r.h.ia();var f=a.r,h=ce(f),N=ce(f),h=h.$a();lC(a.r);a=pF();N=N.Ga();N<h&&(N=-1+h|0);N=(new L).K(h,
1+N|0);h=M();a=O(P(h,a),R(f.ea,f.P,N));a=rF(qF(),g,a);break a}}if(n)a.r.h.ia(),qF(),a=lF(a),a=rF(0,g,a);else{if(mn(f)){h=!0;if(a.r.P.rg){g=a.r;D=g.h;D=(new kg).Ia(D.r,D.Dc);g.h.ia();try{N=kF(a)}finally{g.h=D}}else N=!1;if(N){Cfa(a.r);a=pF();break a}}h?(a.r.h.ia(),a=lF(a)):a=f}}}d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,a),R(b.ea,b.P,d))}
function wha(a,b,c,d){for(;;){if(Ofa(a.r))var f=!0;else var g=v(),h=x(a.r.h),f=y(z(g,h),Ug());var n=f?(new T).e(ch(a.r,!0)):S(),u=zC(c,d,b,We(new Ze,a.r,b),n);if(zh(n)){var w=n.Y,D=v(),N=x(a.r.h);if(y(z(D,N),Hh())){le(a.r);var Q=x(a.r.h).ja();Pd("infix patterns cannot have type arguments",Q)}var ea=We(new Ze,a.r,u);uga(c,ea,u,We(new Ze,a.r,u),w,F());var ba=(new Jd).c();try{var ma=a.r,La=ce(ma),Pa=ce(ma),Qa=La.$a(),Ka=!1,Ba=x(a.r.h);b:{var va;c:{var za;if(hg(Ba)){var qa=Ba;if(!ig(jg(),qa).g()){za=
!0;break c}}za=Ww(Ba)?!0:Je(Ba)?!0:!1}if(za){var la=lga(a.r),Ma=uf(a.r,!1);c:{var Ea;if(!Ke(Ma)&&Pf(Ma)){var tb=Ma,Za=null===tb?S():(new T).e(tb.ec());if(!Za.g()){var eb=Za.q();if(la)Ea=!1;else{var kb=(new cd).j(eb),Pb=eo(kb),Na=null===Pb?0:Pb.pa;if(ii(qi(),Na))var sb=(new cd).j(eb),yb=eo(sb),sc=null===yb?0:yb.pa,Ra=mF(qi(),sc);else Ra=!1;if(Ra)Ea=!0;else{var wc=(new cd).j(eb),Wb=eo(wc);Ea=95===(null===Wb?0:Wb.pa)}}break c}}Ea=!1}var Rb=v(),ub=x(a.r.h),fb=z(Rb,ub),Xb=VA(a.r);if(y(fb,mC(Xb))&&Pf(Ma)){var lb=
Ma,Eb=null===lb?S():(new T).e(lb.ec());if(!Eb.g()&&"-"===Eb.q()){var xc=a.r,gb=We(new Ze,a.r,Ma),dc=ce(a.r),Fc=gb.eb,Qb=vf(a.r,!0),Bb=dc.Ga();Bb<Fc&&(Bb=-1+Fc|0);var Ib=(new L).K(Fc,1+Bb|0),mb=M(),Cb=P(mb,Qb);throw(new VC).a(ba,O(Cb,R(xc.ea,xc.P,Ib)));}}var Tb=x(a.r.h),mc=fi(Tb)?iba(a):F(),Ac=x(a.r.h);if(ue(Ac)){var Dc=Ke(Ma)?Ma.nb((new nF).Im(a)):Ma;if(cj(mc)){var Db=a.r,Va=We(new Ze,a.r,Ma),ec=ce(a.r),$a=Va.eb,vb=hC(gC(),Dc,mc),fc=ec.Ga();fc<$a&&(fc=-1+$a|0);var Bc=(new L).K($a,1+fc|0),Ub=M(),Vb=
O(P(Ub,vb),R(Db.ea,Db.P,Bc))}else Vb=Dc;var wb=qha(),xb=SC(a.r,Pfa(a.r));va=rha(wb,Vb,xb);break b}if(cj(mc)){le(a.r);var Xa=x(a.r.h).ja();Pd("pattern must be a value",Xa)}if(Gf(Ma)){va=Ma.nb((new oF).Im(a));break b}if(Pf(Ma)){var tc=Ma;if(Ea){va=wv(xv(),tc);break b}}if(Pf(Ma)){va=Ma;break b}if(Df(Ma)){va=Ma;break b}for(var ib=he(),zb=(new q).a("ScalametaParser.this.token",x(a.r.h)),nb=Se(),Jb=x(a.r.h),jb=ew().Hc(),ob=(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.tokens.Token](ScalametaParser.this.token)(scala.meta.tokens.Token.showStructure[scala.meta.tokens.Token]).structure",
Ue(Ve(nb,Jb,jb))),gc=(new q).a("sid",Ma),cb=Se(),Ua=Te().Hc(),Yb=[zb,ob,gc,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[scala.meta.Term.Ref](sid)(meta.this.Tree.showStructure[scala.meta.Term.Ref]).structure",Ue(Ve(cb,Ma,Ua)))],Kb=A(new B,C()),pb=0,hb=Yb.length|0;pb<hb;)E(Kb,Yb[pb]),pb=1+pb|0;ie(ib,Kb.t)}if(nf(Ba)&&(Ka=!0,kF(a))){lC(a.r);va=pF();break b}if(Ka)a.r.h.ia(),va=sha();else if(tf(a.r).Gc(Ba))va=vf(a.r,!1);else{if(Nv(Ba)){var Lb=Ba;if(!Ov(Pv(),Lb).g()){va=Wfa(a.r);break b}}if(Mv(Ba))va=
fha(a.r);else if(ue(Ba)){var Fa=a.r;Sd(Fa,(new ve).z(Fa));var bb=v(),nc=x(a.r.h);if(y(z(bb,nc),Vf()))var db=F();else var uc=sv(a.r),db=IA(uc);Sd(Fa,(new Ae).z(Fa));var Fb=function(){return function(a){return tha(uha(),a)}}(a);if(F().w(db))va=Py();else{if(rk(db)){var hc=db,$b=hc.ed,kc=hc.ga;if(F().w(kc)){if(Ke($b)&&1===$b.ca){va=Fb(db);break b}va=$b;break b}}va=Fb(db)}}else{var lc=x(a.r.h);vha(a,lc)}}}var Mb=Pa.Ga();Mb<Qa&&(Mb=-1+Qa|0);var Nb=(new L).K(Qa,1+Mb|0),Gb=M(),Sb=O(P(Gb,va),R(ma.ea,ma.P,
Nb))}catch(Ob){if(YC(Ob)){var Cc=Ob;if(Cc.Ys===ba)Sb=Cc.Rt;else throw Cc;}else throw Ob;}b=Sb}else{if(S()===n)return u;throw(new p).e(n);}}}
var PB=function xha(b,c){if(Vg(b.r,"|")){b.r.h.ia();var d=b.r,f=We(new Ze,b.r,c),g=ce(b.r),f=f.eb;yha||(yha=(new sF).c());var h=OB(b);b=xha(b,h);if(null!==c)h=(new q).a(!0,F());else{G();var h=(new r).d(["lhs is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(d=h.p(),!1===I(h))){g=J();c=[(new q).a("lhs",c)];f=A(new B,C());b=0;for(n=c.length|0;b<n;)E(f,c[b]),b=1+b|0;K(g,"lhs.!\x3d(null)",d,f.t)}throw(new p).e(h);}null!==b?h=(new q).a(!0,F()):(G(),h=(new r).d(["rhs is equal to null"]),
n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(d=h.p(),!1===I(h))){c=J();g=[(new q).a("rhs",b)];f=A(new B,C());b=0;for(n=g.length|0;b<n;)E(f,g[b]),b=1+b|0;K(c,"rhs.!\x3d(null)",d,f.t)}throw(new p).e(h);}h=zha(null,null,null);h.pc=c.y(c,h,"lhs",c.s);h.Kb=b.y(b,h,"rhs",b.s);c=g.Ga();c<f&&(c=-1+f|0);c=(new L).K(f,1+c|0);g=M();return O(P(g,h),R(d.ea,d.P,c))}return c};function tF(a){var b=v();if(y(z(b,a),Vf()))return!0;b=v();return y(z(b,a),Xg())}
function OB(a){var b=a.r,c=ce(b),d=ce(b),c=c.$a(),f=Oda(a),g=v(),h=x(a.r.h);if(xf(z(g,h),lg()))a=f;else{var n=!1,g=null,h=!1,u=null;a:if(Ke(f))a.r.h.ia(),uF(),a=di(a,!1,!1),a=vF(f,a);else{if(ln(f)){n=!0;g=f;if(a.r.P.kg){var w=a.r,D=w.h,D=(new kg).Ia(D.r,D.Dc);w.h.ia();try{var N=kF(a)}finally{w.h=D}}else N=!1;if(N){a.r.h.ia();var f=a.r,h=ce(f),Q=ce(f),h=h.$a();lC(a.r);a=pF();Q=Q.Ga();Q<h&&(Q=-1+h|0);Q=(new L).K(h,1+Q|0);h=M();a=O(P(h,a),R(f.ea,f.P,Q));a=rF(qF(),g,a);break a}}if(N=n)if(N=!a.r.P.kg)b:{var w=
a.r,D=v(),ea=x(w.h);if(y(z(D,ea),lg())){D=w.h;D=(new kg).Ia(D.r,D.Dc);w.h.ia();try{var ba=v(),ma=x(w.h);if(y(z(ba,ma),pz())){var La=w.h,Pa=(new kg).Ia(La.r,La.Dc);w.h.ia();try{N=Vg(w,"*");break b}finally{w.h=Pa}}else{N=!1;break b}}finally{w.h=D}N=void 0}else N=!1}N&&(le(a.r),ba=td((new yd).X((new r).d([""," does not support var: _*"])),(new r).d([a.r.P])),ma=Yc(g),Pd(ba,ma));if(n)a.r.h.ia(),uF(),a=di(a,!1,!1),a=vF(g,a);else{if(mn(f)){h=!0;u=f;if(a.r.P.kg){g=a.r;ba=g.h;ba=(new kg).Ia(ba.r,ba.Dc);g.h.ia();
try{Q=kF(a)}finally{g.h=ba}}else Q=!1;if(Q){Cfa(a.r);a=pF();break a}}h?(a.r.h.ia(),uF(),g=u,a=di(a,!1,!1),a=vF(g,a)):a=f}}}d=d.Ga();d<c&&(d=-1+c|0);d=(new L).K(c,1+d|0);c=M();return O(P(c,a),R(b.ea,b.P,d))}
function vha(a,b){var c=!1,d=null,f=Lea(a.r).Pi;a:{if(rk(f)&&(c=!0,d=f,f=d.ed,null!==f)){var g=f.Wd;if(mn(f.$i)&&(f=null===g?S():(new T).e(g.ec()),!f.g()&&"*"===f.q())){d=c=!0;break a}}if(c&&(c=d.ed,null!==c&&(c=c.Wd,c=null===c?S():(new T).e(c.ec()),!c.g()&&"*"===c.q()))){c=!1;d=!0;break a}d=c=!1}f=a.Il;if(!0===c&&!0===d&&!0===f&&wF(b))f="bad use of _* (a sequence pattern must be the last pattern)";else if(!0===c&&!0===d&&!0===f&&tF(b))f="bad brace or paren after _*";else if(!0===c&&!0===d&&!1===
f&&tF(b))f="bad use of _* (sequence pattern not allowed)";else if(!1===c&&!0===d&&!0===f&&tF(b))f="use _* to match a sequence";else{if(f=!1===c)if(f=!0===d)f=wF(b)||tF(b);f=f?"trailing * is not a valid pattern":null}f=null!==f?td((new yd).X((new r).d([""," ",""])),(new r).d(["bad simple pattern:",f])):"illegal start of simple pattern";(wF(b)||tF(b))&&c&&d&&a.Il&&tF(b);le(a.r);a=b.ja();Pd(f,a)}function wF(a){var b=v();return y(z(b,a),og())}function zD(){}zD.prototype=new m;
zD.prototype.constructor=zD;zD.prototype.z=function(){return this};zD.prototype.$classData=l({aY:0},!1,"scala.meta.internal.parsers.ScalametaParser$SimpleTokenIterator$",{aY:1,f:1});function Uz(){this.r=null}Uz.prototype=new m;Uz.prototype.constructor=Uz;Uz.prototype.Gc=function(a){var b=v();y(z(b,a),Oy())?b=!0:(b=v(),b=y(z(b,a),fh()));b?b=!0:(b=v(),b=y(z(b,a),pw()));if(b)return!0;b=v();return y(z(b,a),ah())};Uz.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
Uz.prototype.$classData=l({bY:0},!1,"scala.meta.internal.parsers.ScalametaParser$StatSep$",{bY:1,f:1});function UA(){this.r=null}UA.prototype=new m;UA.prototype.constructor=UA;UA.prototype.Gc=function(a){var b=v();if(y(z(b,a),Xg()))return!0;b=v();return y(z(b,a),ah())};UA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};UA.prototype.$classData=l({dY:0},!1,"scala.meta.internal.parsers.ScalametaParser$StatSeqEnd$",{dY:1,f:1});function tx(){this.r=null}tx.prototype=new m;
tx.prototype.constructor=tx;tx.prototype.Gc=function(a){var b=v(),b=z(b,a),c=ox(this.r);y(b,GE(c))?b=!0:(b=v(),b=y(z(b,a),iu()));b?b=!0:(b=v(),b=y(z(b,a),Qw()));b?b=!0:(b=v(),b=y(z(b,a),Sw()));b?b=!0:(b=v(),b=z(b,a),xF||(xF=(new yF).c()),b=y(b,xF));b?b=!0:(b=v(),y(z(b,a),Ug())?(b=v(),c=(new gx).xg(this.r,a).ia(),b=y(z(b,c),kha(this))):b=!1);if(b)return!0;b=v();return y(z(b,a),jw())?CE((new DE).xg(this.r,a)):!1};tx.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
tx.prototype.$classData=l({fY:0},!1,"scala.meta.internal.parsers.ScalametaParser$TemplateIntro$",{fY:1,f:1});function rA(){this.r=null}rA.prototype=new m;rA.prototype.constructor=rA;rA.prototype.Gc=function(a){var b=v(),b=z(b,a),c=SD(this.r);if(y(b,TD(c)))return!0;b=v();return y(z(b,a),zF())};rA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};rA.prototype.$classData=l({iY:0},!1,"scala.meta.internal.parsers.ScalametaParser$Trivia$",{iY:1,f:1});
function lA(){this.r=null}lA.prototype=new m;lA.prototype.constructor=lA;lA.prototype.Gc=function(a){var b=v();y(z(b,a),Pu())?b=!0:(b=v(),b=y(z(b,a),CC()));b?b=!0:(b=v(),b=y(z(b,a),zx()));b?b=!0:(b=v(),b=y(z(b,a),Rf()));b?b=!0:(b=v(),b=y(z(b,a),iu()));b?b=!0:(b=v(),b=y(z(b,a),pz()));b?b=!0:(b=v(),b=y(z(b,a),Ug()));if(b)return!0;b=v();a=z(b,a);b=tf(this.r);return y(a,tE(b))?this.r.P.Bh:!1};lA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
lA.prototype.$classData=l({kY:0},!1,"scala.meta.internal.parsers.ScalametaParser$TypeIntro$",{kY:1,f:1});function cE(){this.r=null}cE.prototype=new m;cE.prototype.constructor=cE;cE.prototype.Gc=function(a){var b=v(),b=z(b,a);AF||(AF=(new BF).c());y(b,AF)?b=!0:(b=v(),b=z(b,a),CF||(CF=(new DF).c()),b=y(b,CF));if(b)b=!0;else var b=v(),b=z(b,a),c=FB(this.r),b=y(b,Zga(c));if(b)return!0;b=v();return y(z(b,a),$ga())};cE.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
cE.prototype.$classData=l({mY:0},!1,"scala.meta.internal.parsers.ScalametaParser$Whitespace$",{mY:1,f:1});function DE(){this.r=this.Pb=null}DE.prototype=new m;DE.prototype.constructor=DE;DE.prototype.xg=function(a,b){this.Pb=b;if(null===a)throw jo(wj(),null);this.r=a;return this};function CE(a){var b=v();if(y(z(b,a.Pb),jw())){var b=v(),c=(new gx).xg(a.r,a.Pb).ia();if(y(z(b,c),Qw()))return!0;b=v();a=(new gx).xg(a.r,a.Pb).ia();return y(z(b,a),Sw())}return!1}
DE.prototype.$classData=l({oY:0},!1,"scala.meta.internal.parsers.ScalametaParser$XtensionTokenClass",{oY:1,f:1});function gx(){this.r=this.Pb=null}gx.prototype=new m;gx.prototype.constructor=gx;gx.prototype.xg=function(a,b){this.Pb=b;if(null===a)throw jo(wj(),null);this.r=a;return this};
gx.prototype.ia=function(){var a=Eg(this.r),b=1+Aha((new gx).xg(this.r,this.Pb))|0,c=-1+Eg(this.r).Fa()|0,a=Dg(a,b<c?b:c),b=v(),b=z(b,a),c=SD(this.r);y(b,TD(c))?b=!0:(b=v(),b=y(z(b,a),zF()));return b?(new gx).xg(this.r,a).ia():a};function fx(a){var b=Eg(a.r),c=-1+Aha((new gx).xg(a.r,a.Pb))|0,b=Dg(b,0<c?c:0),c=v(),c=z(c,b),d=SD(a.r);y(c,TD(d))?c=!0:(c=v(),c=y(z(c,b),zF()));return c?fx((new gx).xg(a.r,b)):b}
function Aha(a){if(a.Pb.ab()===a.r.ea.od().i.length)a=-1+Eg(a.r).Fa()|0;else a:{var b=a.r.ME.i[a.Pb.ab()];for(;;){if(0<=b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["roughIndex.\x3e\x3d(0) is false"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(d=c.p(),!1===I(c))){var f=J();a=[(new q).a("roughIndex",b),(new q).a("XtensionTokenIndex",a),(new q).a("XtensionTokenIndex.this.token",a.Pb)];for(var b=A(new B,C()),g=0,h=a.length|0;g<h;)E(b,a[g]),g=1+g|0;K(f,"roughIndex.\x3e\x3d(0).\x26\x26(org.scalameta.`package`.debug(XtensionTokenIndex.this.token))",
d,b.t)}throw(new p).e(c);}d=Dg(Eg(a.r),b);(c=d===a.Pb)||(c=a,f=v(),c=y(z(f,c.Pb),pw())&&d.ab()===c.Pb.ab()?d.wa()===c.Pb.wa():!1);if(c){a=b;break a}b=-1+b|0}}return a}gx.prototype.$classData=l({pY:0},!1,"scala.meta.internal.parsers.ScalametaParser$XtensionTokenIndex",{pY:1,f:1});function EF(){}EF.prototype=new m;EF.prototype.constructor=EF;EF.prototype.c=function(){return this};
EF.prototype.Hc=function(){return(new FF).te(lk(function(){return function(a){var b=a.Q;if(GF(a))var c="\\t";else HF(a)?c="\\r":px(a)?c="\\n":IF(a)?c="\\f":hy(a)?c="\\n\\n":JF(a)?c="BOF":KF(a)?c="EOF":(c=Se(),b=pA().If(b),c=yg(c,a,b).be());var c=X().N(c),b=X().N(" ["),d=X(),f=a.ab(),d=d.N(""+f),f=X().N(".."),g=X();a=a.wa();return(new LF).X((new r).d([c,b,d,f,g.N(""+a),X().N(")")]))}}(this)))};EF.prototype.$classData=l({yY:0},!1,"scala.meta.internal.prettyprinters.TokenStructure$",{yY:1,f:1});
var MF=void 0;function ew(){MF||(MF=(new EF).c());return MF}function NF(){}NF.prototype=new m;NF.prototype.constructor=NF;NF.prototype.c=function(){return this};function OF(a){throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support xml literals"])),(new r).d([a])));}
NF.prototype.If=function(a){return(new PF).te(lk(function(a,c){return function(a){Mv(a)&&(c.cf||OF(c));Vv(a)&&(Wv(Xv(),a).g()||c.cf||OF(c));Zv(a)&&(c.cf||OF(c));bw(a)&&(c.cf||OF(c));dw(a)&&(c.cf||OF(c));Je(a)&&(ke(c)||Bha(c));de(a)&&(Yf(Zf(),a).g()||ke(c)||Bha(c));if(QF(a)&&!c.tg)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support view bounds"])),(new r).d([c])));return X().N(a.ja().Kx())}}(this,a)))};
function Bha(a){throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support unquoting"])),(new r).d([a])));}NF.prototype.$classData=l({zY:0},!1,"scala.meta.internal.prettyprinters.TokenSyntax$",{zY:1,f:1});var RF=void 0;function pA(){RF||(RF=(new NF).c());return RF}function SF(){}SF.prototype=new m;SF.prototype.constructor=SF;SF.prototype.c=function(){return this};function TF(a){Cha||(Cha=(new SF).c());return pA().If(a.Q).N(a).v()}
SF.prototype.$classData=l({AY:0},!1,"scala.meta.internal.prettyprinters.TokenToString$",{AY:1,f:1});var Cha=void 0;function UF(){}UF.prototype=new m;UF.prototype.constructor=UF;UF.prototype.c=function(){return this};
UF.prototype.If=function(a){return(new PF).te(lk(function(a,c){return function(d){var f=VF(),g=G().b,g=H(d,g);d=function(a,b){return function(a){return pA().If(b).N(a)}}(a,c);var h=G().b;if(h===G().b)if(g===F())d=F();else{for(var h=g.n(),n=h=U(new V,d(h),F()),g=g.o();g!==F();)var u=g.n(),u=U(new V,d(u),F()),n=n.ga=u,g=g.o();d=h}else{for(h=zg(g,h);!g.g();)n=g.n(),h.ba(d(n)),g=g.o();d=h.da()}return WF(f,d,"",XF())}}(this,a)))};
UF.prototype.$classData=l({BY:0},!1,"scala.meta.internal.prettyprinters.TokensSyntax$",{BY:1,f:1});var YF=void 0;function Dha(){YF||(YF=(new UF).c());return YF}function ZF(){}ZF.prototype=new m;ZF.prototype.constructor=ZF;ZF.prototype.c=function(){return this};function $F(a,b){if(aG(b))return bG(cG(),b,dG());if(eG(b)){a=Se();var c=Te().Hc();return Ue(Ve(a,b,c))}return Ty(b)?Eha(a,b):b===S()?"None":zh(b)?"Some("+$F(a,b.Y)+")":pa(b)}
function Eha(a,b){if(b===F())return"Nil";G();var c=(new T).e(b);if(null!==c.Y&&0===qo(c.Y,1)&&(c=ro(c.Y,0),Ty(c)&&(G(),c=(new T).e(c),null!==c.Y&&0===qo(c.Y,0))))return"List(List())";a=function(a){return function(b){return $F(a,b)}}(a);c=G().b;if(c===G().b)if(b===F())a=F();else{var c=b.n(),d=c=U(new V,a(c),F());for(b=b.o();b!==F();){var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f;b=b.o()}a=c}else{for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();a=c.da()}return"List("+a.Pd(", ")+")"}
ZF.prototype.Hc=function(){return(new FF).te(lk(function(a){return function(b){if(Pl(b))return X().N('Name("")');if(dm(b)){var c=null===b?S():(new T).e(b.Ab);if(!c.g())return c=c.q(),(new LF).X((new r).d([X().N("Name("),X().N(bG(cG(),c,dG())),X().N(")")]))}var c=X().N(b.U()),d=X().N("("),f=!1,g=null;a:if(Ke(b))b=Fha(a,b);else{if(Ui(b)){var f=!0,g=b,h=(new T).e(g.Xf()).Y;if(aG(h)){b=X().N(bG(cG(),h,dG()));break a}}if(f&&void 0===(new T).e(g.Xf()).Y)b=X().N("()");else if(fG(b)&&!(null===b?S():(new T).e(b.li)).g())g=
X(),f=wk().mb,b=Fk(b,f),b=g.N(gG(b,"","",""));else if(hG(b)&&!(null===b?S():(new T).e(b.li)).g())g=X(),f=wk().mb,b=Fk(b,f),b=g.N(gG(b,"","",""));else if(f){(new T).e(g.Xf());b=X();f=wk().mb;g=Fk(g,f);Rs();uk();for(var f=(new Hk).c(),h=0,n=g.Fa();h<n;){var u=Dg(g,h),w;b:if(w=u,Xs(w)&&!Ys(Zs(),w).g()||dt(w)&&!et(ft(),w).g()||wt(w)&&!xt(yt(),w).g()||Ft(w)&&!Gt(Ht(),w).g()||At(w)&&!Bt(Ct(),w).g()||Jt(w)||Kt(w)||Lt(w))w=!0;else{if(hg(w)&&(w=ig(jg(),w),!w.g()&&"-"===w.q())){w=!0;break b}w=!1}!1!==w&&Ik(f,
u);h=1+h|0}f=Jk(f);Rs();g=vk().$d;g=zg(f,g);for(f=Ss(f);f.om;)h=f.bb(),g.ba(Gha(h));b=b.N(g.da().Of())}else{if(dm(b)&&(g=null===b?S():(new T).e(b.Ab),!g.g())){b=g.q();b=X().N(bG(cG(),b,dG()));break a}b=Pl(b)?X().N(bG(cG(),"",dG())):Fha(a,b)}}return(new LF).X((new r).d([c,d,b,X().N(")")]))}}(this)))};function Gha(a){if(dt(a)){var b=et(ft(),a);if(!b.g())return a=b.q().Td,(new iG).j(Gp(Ip(),a)+"L")}var b=Se(),c=wk().mb,c=pA().If(c);return yg(b,a,c).be()}
function Fha(a,b){var c=VF();b=b.L();a=Ro(new So,b,lk(function(a){return function(b){return $F(a,b)}}(a)));b=G().b;return WF(c,jG(a,b),", ",X())}ZF.prototype.$classData=l({CY:0},!1,"scala.meta.internal.prettyprinters.TreeStructure$",{CY:1,f:1});var kG=void 0;function Te(){kG||(kG=(new ZF).c());return kG}function lG(){}lG.prototype=new m;lG.prototype.constructor=lG;lG.prototype.c=function(){return this};
lG.prototype.If=function(a){var b=(new ik).c();return(new PF).te(lk(function(a,b,f){return function(a){var c=mG(a);return nG(c)&&(c=oG(pG(),c),!c.g()&&(c=c.q().qb,null===b?null===c:b.w(c)))?X().N(Yc(a).Kx()):qG(f.Hg?f.Ab:Hha(b,f)).N(a)}}(this,a,b)))};function Hha(a,b){if(null===b)throw(new fk).c();return b.Hg?b.Ab:hk(b,(new rG).Ev(a))}lG.prototype.$classData=l({DY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$",{DY:1,f:1});var sG=void 0;function tg(){sG||(sG=(new lG).c());return sG}
function rG(){this.Zc=this.ls=null}rG.prototype=new m;rG.prototype.constructor=rG;function Iha(a){a=a.ob();return!on(a)||!1}
function Jha(a){return(new PF).te(lk(function(a){return function(c){var d=!1,f=null;if(rk(c)){var d=!0,f=c,g=f.ed,h=f.ga;if(Ln(g)&&F().w(h))return qG(a).N(g)}return d&&(g=f.ed,h=f.ga,Pn(g)&&F().w(h))?qG(a).N(g):d&&(d=f.ed,f=f.ga,Mn(d)&&F().w(f))?(new LF).X((new r).d([X().N("{"),qG(a).N(d),X().N("}")])):(new LF).X((new r).d([X().N("{ "),WF(VF(),c,", ",qG(a)),X().N(" }")]))}}(a)))}
function tG(a){var b=Kha(a).ub();if(F().w(b))return!0;if(rk(b)&&(a=b.ed,b=b.ga,F().w(b))){b=v();b=z(b,a);uG||(uG=(new vG).c());if(y(b,uG))return!0;b=v();return y(z(b,a),wG())}return!1}function Lha(a){return(new PF).te(lk(function(a){return function(c){return cj(c)?WF(VF(),c," ",qG(a)):xG()}}(a)))}function yG(a){return(new PF).te(lk(function(a){return function(c){c.g()?c=S():(c=c.q(),c=(new T).e((new LF).X((new r).d([zG(a,":"),X().N(" "),qG(a).N(c)]))));return c.g()?xG():c.q()}}(a)))}
function Mha(a){a=um(a);return!on(a)||!1}
function AG(a,b,c,d,f){if(d!==f)var g=(new q).a(!0,F());else{G();var g=(new r).d(["left is equal to right"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(b=g.p(),!1===I(g))){c=J();d=[(new q).a("left",d),(new q).a("right",f)];a=A(new B,C());f=0;for(h=d.length|0;f<h;)E(a,d[f]),f=1+f|0;K(c,"left.!\x3d(right)",b,a.t)}throw(new p).e(g);}g=Nha(BG(a,c));f=Nha(BG(b,c));if(g!==f)return!0;f=!g;a=BG(a,c).cl();b=BG(b,c).cl();return a<b?f:a>b?g:g!==d}
function Oha(a){return(new PF).te(lk(function(a){return function(c){return c.g()?xG():(new LF).X((new r).d([X().N("["),WF(VF(),c,", ",qG(a)),X().N("]")]))}}(a)))}function Pha(a){return(new PF).te(lk(function(a){return function(c){return(new LF).X((new r).d([X().N("("),WF(VF(),c,", ",qG(a)),X().N(")")]))}}(a)))}
function CG(a,b){if(b.Si().g()&&b.Xi().g())var c=v(),d=b.Zg().xb(),c=y(z(c,d),cm());else c=!1;if(c&&b.Zg().sc().g()&&b.ub().g())return xG();c=b.Xi();cj(c)?c=!0:(c=b.Si(),c=cj(c));return c?(new LF).X((new r).d([X().N(" extends "),qG(a).N(b)])):(new LF).X((new r).d([X().N(" "),qG(a).N(b)]))}function Qha(a){return(new PF).te(lk(function(a){return function(c){return WF(VF(),c,"",DG(a))}}(a)))}
function EG(a){return(new PF).te(lk(function(a){return function(c){return cj(c)?(new LF).X((new r).d([X().N("["),WF(VF(),c,", ",qG(a)),X().N("]")])):xG()}}(a)))}
function FG(a){var b=GG(a);if(Pf(a)&&zh(b)&&(b=b.Y,null!==b)){var c=a.ec(),c=(new cd).j(c),c=eo(c),c=null===c?0:c.pa;ii(qi(),c)?(c=a.ec(),c=(new cd).j(c),c=eo(c),c=null===c?0:c.pa,c=mF(qi(),c)):c=!1;Pf(b)&&ie(he(),Fu());if(Df(b))b=!1;else if(mn(b)&&ie(he(),Fu()),ln(b))b=!1;else if(Ym(b)&&ie(he(),Fu()),Xm(b))b=!0;else if(jn(b))b=!0;else if(dn(b))a:{for(b=b.pb();!b.g();){if(b.n()===a){b=!0;break a}b=b.o()}b=!1}else if(en(b))if(b.Vd()===a)b=!0;else a:{for(b=fn(b);!b.g();){if(b.n()===a){b=!0;break a}b=
b.o()}b=!1}else if(gn(b))a:{for(b=b.pb();!b.g();){if(b.n()===a){b=!0;break a}b=b.o()}b=!1}else if(kn(b)&&ie(he(),Fu()),b&&b.$classData&&b.$classData.H.he&&ie(he(),Fu()),Nl(b))b=b.Re()===a;else if(Nk(b))a:{for(b=b.Xd();!b.g();){if(b.n()===a){b=!0;break a}b=b.o()}b=!1}else if(Sk(b))a:{for(b=b.Xd();!b.g();){if(b.n()===a){b=!0;break a}b=b.o()}b=!1}else b=Dn(b)?b.Re()===a:Fn(b)?b.Re()===a:!1;return c&&b||Rha(a)}return Rha(a)}
function qG(a){return(new PF).te(lk(function(a){return function(c){var d=!1,f=null,g=!1,h=null,n=!1,u=null;if(Ke(c)){if(!ke(a.Zc))throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support unquoting"])),(new r).d([a.Zc])));if(0<c.ca){var w=X(),D=(new cd).j("."),N=w.N(dd(D,1+c.ca|0)),Q=VF(),ea=c.fa(),ba=v(),ma=c.fa();return(new LF).X((new r).d([N,HG(Q,"{",ea,"}",!y(z(ba,ma),Sha()),qG(a))]))}var La=v(),Pa=c.fa();if(y(z(La,Pa),wG()))var Qa=!0;else var Ka=v(),Ba=c.fa(),Qa=y(z(Ka,Ba),Bv());if(Qa)var va=
!0;else var za=v(),qa=c.fa(),va=y(z(za,qa),IG());if(va)var la=!0;else var Ma=v(),Ea=c.fa(),la=y(z(Ma,Ea),Tha());Is(a.Zc.Ig,a.Zc.rg,a.Zc.dh,a.Zc.kg,a.Zc.Jg,a.Zc.eh,a.Zc.fh,a.Zc.Rh,a.Zc.Sh,a.Zc.Bh,a.Zc.gh,!0,a.Zc.Kg,!1,a.Zc.Lg,!1,a.Zc.hh,a.Zc.Dh,a.Zc.sg,a.Zc.Eh,a.Zc.tg,a.Zc.Mg,a.Zc.cf,a.Zc.th);var tb=X().N("$"),Za=VF(),eb=Se(),kb=c.fa(),Pb=qG(a);return(new LF).X((new r).d([tb,HG(Za,"{",yg(eb,kb,Pb).be(),"}",!la,X())]))}if(Pl(c))return X().N("_");if(dm(c)){if(FG(c)){var Na=X().N("`"),sb=X();return(new LF).X((new r).d([Na,
sb.N(c.Ab),X().N("`")]))}return X().N(c.Ab)}if(Km(c)){var yb=v(),sc=Lm(c),Ra=y(z(yb,sc),cm())?xG():(new LF).X((new r).d([qG(a).N(Lm(c)),X().N(".")]));return JG(new KG,LG(MG(a)),(new LF).X((new r).d([Ra,zG(a,"this")])))}if(Hm(c)){var wc=v(),Wb=Im(c),Rb=y(z(wc,Wb),cm())?xG():(new LF).X((new r).d([qG(a).N(Im(c)),X().N(".")])),ub=v(),fb=Jm(c),Xb=y(z(ub,fb),cm())?xG():(new LF).X((new r).d([X().N("["),qG(a).N(Jm(c)),X().N("]")]));return JG(new KG,LG(MG(a)),(new LF).X((new r).d([Rb,zG(a,"super"),Xb])))}if(Pf(c))return JG(new KG,
LG(MG(a)),FG(c)?(new LF).X((new r).d([X().N("`"),X().N(c.ec()),X().N("`")])):X().N(c.ec()));if(Df(c))return JG(new KG,LG(MG(a)),(new LF).X((new r).d([NG(a,OG(PG(MG(a))),Ef(c),!1,!1),X().N("."),qG(a).N(c.yb())])));if(ym(c)){var lb=c.Qe(),Eb=function(){return function(a){var b=(new T).e(a.Xf()).Y;if(aG(b))return b;throw(new p).e(a);}}(a),xc=G().b;if(xc===G().b)if(lb===F())var gb=F();else{for(var dc=lb.n(),Fc=U(new V,Eb(dc),F()),Qb=Fc,Bb=lb.o();Bb!==F();)var Ib=Bb.n(),mb=U(new V,Eb(Ib),F()),Qb=Qb.ga=
mb,Bb=Bb.o();gb=Fc}else{for(var Cb=zg(lb,xc),Tb=lb;!Tb.g();){var mc=Tb.n();Cb.ba(Eb(mc));Tb=Tb.o()}gb=Cb.da()}var Ac=c.pb(),Dc=G().b,Db=Vm(gb,Ac,Dc),Va=function(a){return function(b){if(null!==b){var c=b.qa(),d=b.p();if(Um(d)&&!FG(d))return(new LF).X((new r).d([X().N(c),X().N("$"),X().N(d.ec())]))}if(null!==b)return c=b.qa(),b=b.p(),(new LF).X((new r).d([X().N(c),X().N("${"),NG(a,QG(PG(MG(a))),b,!1,!1),X().N("}")]));throw(new p).e(b);}}(a),ec=G().b;if(ec===G().b)if(Db===F())var $a=F();else{for(var vb=
Db.n(),fc=U(new V,Va(vb),F()),Bc=fc,Ub=Db.o();Ub!==F();)var Vb=Ub.n(),wb=U(new V,Va(Vb),F()),Bc=Bc.ga=wb,Ub=Ub.o();$a=fc}else{for(var xb=zg(Db,ec),Xa=Db;!Xa.g();){var tc=Xa.n();xb.ba(Va(tc));Xa=Xa.o()}$a=xb.da()}a:{for(var ib=gb;!ib.g();){var zb=ib.n();if(-1!==(zb.indexOf("\n")|0)||-1!==(zb.indexOf('"')|0)){var nb=!0;break a}ib=ib.o()}nb=!1}var Jb=nb?'"""':'"';return JG(new KG,RG(PG(MG(a))),(new LF).X((new r).d([qG(a).N(c.yi()),X().N(Jb),WF(VF(),$a,"",XF()),X().N(cl(gb)),X().N(Jb)])))}if(Tm(c)){if(!a.Zc.cf)throw(new Gq).j(td((new yd).X((new r).d(["",
" doesn't support xml literals"])),(new r).d([a.Zc])));var jb=c.Qe(),ob=function(){return function(a){var b=(new T).e(a.Xf()).Y;if(aG(b))return b;throw(new p).e(a);}}(a),gc=G().b;if(gc===G().b)if(jb===F())var cb=F();else{for(var Ua=jb.n(),Yb=U(new V,ob(Ua),F()),Kb=Yb,pb=jb.o();pb!==F();)var hb=pb.n(),Lb=U(new V,ob(hb),F()),Kb=Kb.ga=Lb,pb=pb.o();cb=Yb}else{for(var Fa=zg(jb,gc),bb=jb;!bb.g();){var nc=bb.n();Fa.ba(ob(nc));bb=bb.o()}cb=Fa.da()}var db=c.pb(),uc=G().b,Fb=Vm(cb,db,uc),hc=function(a){return function(b){if(null!==
b){var c=b.qa();b=b.p();return(new LF).X((new r).d([X().N(c),X().N("{"),NG(a,QG(PG(MG(a))),b,!1,!1),X().N("}")]))}throw(new p).e(b);}}(a),$b=G().b;if($b===G().b)if(Fb===F())var kc=F();else{for(var lc=Fb.n(),Mb=U(new V,hc(lc),F()),Nb=Mb,Gb=Fb.o();Gb!==F();)var Sb=Gb.n(),Cc=U(new V,hc(Sb),F()),Nb=Nb.ga=Cc,Gb=Gb.o();kc=Mb}else{for(var Ob=zg(Fb,$b),Zb=Fb;!Zb.g();){var Ec=Zb.n();Ob.ba(hc(Ec));Zb=Zb.o()}kc=Ob.da()}return JG(new KG,RG(PG(MG(a))),(new LF).X((new r).d([WF(VF(),kc,"",XF()),X().N(cl(cb))])))}if(Zk(c))return JG(new KG,
RG(PG(MG(a))),(new LF).X((new r).d([NG(a,RG(PG(MG(a))),c.Ae(),!1,!1),DG(a).N(c.pb())])));if(fm(c))return JG(new KG,RG(PG(MG(a))),(new LF).X((new r).d([NG(a,OG(PG(MG(a))),c.Ae(),!1,!1),Oha(a).N(c.$g())])));if($k(c)){var oc=!1,pc=null,qc=c.pb();a:{var Jc;if(rk(qc)){var oc=!0,pc=qc,Hc=pc.ga;if(on(pc.ed)&&F().w(Hc)){Jc=X().N("(())");break a}}if(oc){var ac=pc.ed,Lc=pc.ga;if(null!==ac&&F().w(Lc)){var $c=SG(TG(PG(MG(a))),c.Qd().ec());Jc=NG(a,$c,ac,!1,!0);break a}}Jc=DG(a).N(qc)}return JG(new KG,SG(TG(PG(MG(a))),
c.Qd().ec()),(new LF).X((new r).d([NG(a,SG(TG(PG(MG(a))),c.Qd().ec()),c.mg(),!0,!1),X().N(" "),qG(a).N(c.Qd()),Oha(a).N(c.$g()),X().N(" "),Jc])))}if(gm(c))return JG(new KG,Uha(PG(MG(a))),(new LF).X((new r).d([qG(a).N(c.Qd()),NG(a,OG(PG(MG(a))),hm(c),!1,!1)])));if(jm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([NG(a,RG(PG(MG(a))),c.mg(),!1,!1),X().N(" "),zG(a,"\x3d"),X().N(" "),NG(a,QG(PG(MG(a))),c.Ld(),!1,!1)])));if(Gm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"return"),
Iha(c)?(new LF).X((new r).d([X().N(" "),NG(a,QG(PG(MG(a))),c.ob(),!1,!1)])):xG()])));if(Mm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"throw"),X().N(" "),NG(a,QG(PG(MG(a))),c.ob(),!1,!1)])));if(im(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([NG(a,VG(PG(MG(a))),c.ob(),!1,!1),zG(a,":"),X().N(" "),qG(a).N(c.Db())])));if(em(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([NG(a,VG(PG(MG(a))),c.ob(),!1,!1),zG(a,":"),X().N(" "),Lha(a).N(c.Di())])));if(Rm(c))return JG(new KG,
RG(PG(MG(a))),(new LF).X((new r).d([X().N("("),WF(VF(),c.pb(),", ",qG(a)),X().N(")")])));if(km(c)){var Tc=null===c?S():(new T).e(c.ub());if(!Tc.g()){var Rc=Tc.q();if(rk(Rc)){var Mc=Rc.ed,hd=Rc.ga;if(rm(Mc)){var Qc=null===Mc?S():(new T).e((new q).a(Mc.me(),Mc.Nb()));if(!Qc.g()){var rd=Qc.q().qa(),od=Qc.q().p();if(rk(rd)){var Zc=rd.ed,nd=rd.ga,zd=null===Zc?S():(new T).e((new al).yd(Zc.Qa(),Zc.xb(),Zc.sc(),Zc.Bi()));if(!zd.g()){var ud=zd.q().Bb,wd=zd.q().qb,Bd=zd.q().Eb;if(Pf(wd)&&F().w(nd)&&km(od)){var Ed=
null===od?S():(new T).e(od.ub());if(!Ed.g()){var pd=Ed.q();if(F().w(hd))a:{for(var vd=ud;!vd.g();){var xd=vd.n(),ee=v();if(y(z(ee,xd),Hw())){var Ld=!0;break a}vd=vd.o()}Ld=!1}else Ld=!1;if(Ld){var me=OG(PG(MG(a))),fe=X().N("{ "),Yd=zG(a,"implicit"),Zd=X().N(" "),qe=qG(a).N(wd);if(Bd.g())var re=S();else var Kd=Bd.q(),re=(new T).e((new LF).X((new r).d([zG(a,":"),X().N(" "),qG(a).N(Kd)])));return JG(new KG,me,(new LF).X((new r).d([fe,Yd,Zd,qe,re.g()?xG():re.q(),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),
WG(a,pd),XG(VF(),"}",X())])))}}}}}}}}}var yf=null===c?S():(new T).e(c.ub());if(!yf.g()){var Cd=yf.q();if(rk(Cd)){var Fe=Cd.ed,je=Cd.ga;if(rm(Fe)){var xe=null===Fe?S():(new T).e((new q).a(Fe.me(),Fe.Nb()));if(!xe.g()){var ge=xe.q().qa(),ye=xe.q().p();if(rk(ge)){var ne=ge.ed,Ce=ge.ga,hf=null===ne?S():(new T).e((new al).yd(ne.Qa(),ne.xb(),ne.sc(),ne.Bi()));if(!hf.g()){var Pe=hf.q().qb,jf=hf.q().Eb;if(Pf(Pe)&&S()===jf&&F().w(Ce)&&km(ye)){var ze=null===ye?S():(new T).e(ye.ub());if(!ze.g()){var Me=ze.q();
if(F().w(je))return JG(new KG,OG(PG(MG(a))),(new LF).X((new r).d([X().N("{ "),qG(a).N(Pe),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),WG(a,Me),XG(VF(),"}",X())])))}}}}}}}}var $e=null===c?S():(new T).e(c.ub());if(!$e.g()){var kf=$e.q();if(rk(kf)){var Ne=kf.ed,Ge=kf.ga;if(rm(Ne)){var se=null===Ne?S():(new T).e((new q).a(Ne.me(),Ne.Nb()));if(!se.g()){var lf=se.q().qa(),te=se.q().p();if(rk(lf)){var De=lf.ed,Qe=lf.ga,af=null===De?S():(new T).e((new al).yd(De.Qa(),De.xb(),De.sc(),De.Bi()));if(af.g()?0:Pl(af.q().qb)&&
F().w(Qe)&&km(te)){var of=null===te?S():(new T).e(te.ub());if(!of.g()){var df=of.q();if(F().w(Ge))return JG(new KG,OG(PG(MG(a))),(new LF).X((new r).d([X().N("{ "),zG(a,"_"),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),WG(a,df),XG(VF(),"}",X())])))}}}}}}}var mf=null===c?S():(new T).e(c.ub());if(!mf.g()){var Re=mf.q();if(rk(Re)){var Xe=Re.ed,zf=Re.ga;if(rm(Xe)){var ef=null===Xe?S():(new T).e((new q).a(Xe.me(),Xe.Nb()));if(!ef.g()){var $d=ef.q().qa(),pf=ef.q().p();if(km(pf)){var He=null===pf?S():(new T).e(pf.ub());
if(!He.g()){var If=He.q();if(F().w(zf))return JG(new KG,OG(PG(MG(a))),(new LF).X((new r).d([X().N("{ ("),WF(VF(),$d,", ",qG(a)),X().N(") \x3d\x3e "),WG(a,If),XG(VF(),"}",X())])))}}}}}}return JG(new KG,OG(PG(MG(a))),c.ub().g()?X().N("{}"):(new LF).X((new r).d([X().N("{"),WG(a,c.ub()),XG(VF(),"}",X())])))}if(sm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"if"),X().N(" ("),qG(a).N(c.oi()),X().N(") "),NG(a,QG(PG(MG(a))),tm(c),!1,!1),Mha(c)?(new LF).X((new r).d([X().N(" "),zG(a,"else"),
X().N(" "),NG(a,QG(PG(MG(a))),um(c),!1,!1)])):xG()])));if(Am(c)){var ug=UG(PG(MG(a))),Af=NG(a,VG(PG(MG(a))),c.ob(),!1,!1),vg=X().N(" "),Wf=zG(a,"match"),Mh=X().N(" {"),Yg=VF(),Og=c.ni(),Pg=function(a){return function(b){return YG(VF(),b,qG(a))}}(a),Jf=G().b;if(Jf===G().b)if(Og===F())var Zg=F();else{for(var ji=Og.n(),jh=U(new V,Pg(ji),F()),$g=jh,Qg=Og.o();Qg!==F();)var ij=Qg.n(),ki=U(new V,Pg(ij),F()),$g=$g.ga=ki,Qg=Qg.o();Zg=jh}else{for(var lh=zg(Og,Jf),Nh=Og;!Nh.g();){var xk=Nh.n();lh.ba(Pg(xk));
Nh=Nh.o()}Zg=lh.da()}return JG(new KG,ug,(new LF).X((new r).d([Af,vg,Wf,Mh,WF(Yg,Zg,"",XF()),XG(VF(),"}",X())])))}if(Nm(c)){var Kj=UG(PG(MG(a))),jj=zG(a,"try"),Di=X().N(" "),Lj=NG(a,QG(PG(MG(a))),c.ob(),!1,!1),bh=Om(c);if(cj(bh)){var Oh=X().N(" "),Ph=zG(a,"catch"),Mj=X().N(" {"),fl=VF(),cg=Om(c),Qh=function(a){return function(b){return YG(VF(),b,qG(a))}}(a),Wl=G().b;if(Wl===G().b)if(cg===F())var Nj=F();else{for(var Ei=cg.n(),Xl=U(new V,Qh(Ei),F()),Oj=Xl,Pj=cg.o();Pj!==F();)var Qj=Pj.n(),yk=U(new V,
Qh(Qj),F()),Oj=Oj.ga=yk,Pj=Pj.o();Nj=Xl}else{for(var li=zg(cg,Wl),mi=cg;!mi.g();){var Zm=mi.n();li.ba(Qh(Zm));mi=mi.o()}Nj=li.da()}var wg=(new LF).X((new r).d([Oh,Ph,Mj,WF(fl,Nj,"",XF()),XG(VF(),"}",X())]))}else wg=X().N("");var mh=c.Vi();if(mh.g())var Fi=S();else var gl=mh.q(),Fi=(new T).e((new LF).X((new r).d([X().N(" "),zG(a,"finally"),X().N(" "),qG(a).N(gl)])));return JG(new KG,Kj,(new LF).X((new r).d([jj,Di,Lj,wg,Fi.g()?xG():Fi.q()])))}if(Pm(c)){var zk=UG(PG(MG(a))),Ye=zG(a,"try"),hl=X().N(" "),
Rj=NG(a,QG(PG(MG(a))),c.ob(),!1,!1),Rh=X().N(" "),$m=zG(a,"catch"),il=X().N(" "),Gi=qG(a).N(Qm(c)),dg=c.Vi();if(dg.g())var Hi=S();else var ni=dg.q(),Hi=(new T).e((new LF).X((new r).d([X().N(" "),zG(a,"finally"),X().N(" "),qG(a).N(ni)])));return JG(new KG,zk,(new LF).X((new r).d([Ye,hl,Rj,Rh,$m,il,Gi,Hi.g()?xG():Hi.q()])))}if(rm(c)){var jl=null===c?S():(new T).e((new q).a(c.me(),c.Nb()));if(!jl.g()){var nh=jl.q().qa(),Ak=jl.q().p();if(rk(nh)){var oh=nh.ed,Yl=nh.ga,Sj=null===oh?S():(new T).e((new al).yd(oh.Qa(),
oh.xb(),oh.sc(),oh.Bi()));if(!Sj.g()){var Bk=Sj.q().Bb,Zl=Sj.q().qb,xg=Sj.q().Eb;if(Pf(Zl)){if(F().w(Yl))a:{for(var Tj=Bk;!Tj.g();){var Uj=Tj.n(),Ii=v();if(y(z(Ii,Uj),Hw())){var Vj=!0;break a}Tj=Tj.o()}Vj=!1}else Vj=!1;if(Vj){var Rg=QG(PG(MG(a))),kj=zG(a,"implicit"),Ji=X().N(" "),ph=qG(a).N(Zl);if(xg.g())var lj=S();else var Xf=xg.q(),lj=(new T).e((new LF).X((new r).d([zG(a,":"),X().N(" "),qG(a).N(Xf)])));return JG(new KG,Rg,(new LF).X((new r).d([kj,Ji,ph,lj.g()?xG():lj.q(),X().N(" "),zG(a,"\x3d\x3e"),
X().N(" "),NG(a,QG(PG(MG(a))),Ak,!1,!1)])))}}}}}var Sh=null===c?S():(new T).e((new q).a(c.me(),c.Nb()));if(!Sh.g()){var Th=Sh.q().qa(),mj=Sh.q().p();if(rk(Th)){var qh=Th.ed,oi=Th.ga,eg=null===qh?S():(new T).e((new al).yd(qh.Qa(),qh.xb(),qh.sc(),qh.Bi()));if(!eg.g()){var rh=eg.q().qb,Wj=eg.q().Eb;if(Pf(rh)&&S()===Wj&&F().w(oi))return JG(new KG,QG(PG(MG(a))),(new LF).X((new r).d([qG(a).N(rh),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),NG(a,QG(PG(MG(a))),mj,!1,!1)])))}}}var Uh=null===c?S():(new T).e((new q).a(c.me(),
c.Nb()));if(!Uh.g()){var Vh=Uh.q().qa(),Ck=Uh.q().p();if(rk(Vh)){var Wh=Vh.ed,nj=Vh.ga,sh=null===Wh?S():(new T).e((new al).yd(Wh.Qa(),Wh.xb(),Wh.sc(),Wh.Bi()));if(!sh.g()){var oj=sh.q().Eb;if(Pl(sh.q().qb)&&F().w(nj)){if(zh(oj))var Dk=oj.Y,kl=(new LF).X((new r).d([zG(a,"("),zG(a,"_"),zG(a,":"),qG(a).N(Dk),zG(a,")")]));else{if(S()!==oj)throw(new p).e(oj);kl=zG(a,"_")}return JG(new KG,QG(PG(MG(a))),(new LF).X((new r).d([kl,X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),NG(a,QG(PG(MG(a))),Ck,!1,!1)])))}}}}var Xh=
null===c?S():(new T).e((new q).a(c.me(),c.Nb()));if(!Xh.g()){var Ki=Xh.q().qa(),an=Xh.q().p();return JG(new KG,QG(PG(MG(a))),(new LF).X((new r).d([X().N("("),WF(VF(),Ki,", ",qG(a)),X().N(") "),zG(a,"\x3d\x3e"),X().N(" "),NG(a,QG(PG(MG(a))),an,!1,!1)])))}throw(new p).e(c);}if(Dm(c)){var ll=OG(PG(MG(a))),bn=X().N("{"),$l=VF(),Xj=c.ni(),pi=function(a){return function(b){return YG(VF(),b,qG(a))}}(a),am=G().b;if(am===G().b)if(Xj===F())var Yj=F();else{for(var cn=Xj.n(),Ek=U(new V,pi(cn),F()),wo=Ek,pj=Xj.o();pj!==
F();)var Ey=pj.n(),vo=U(new V,pi(Ey),F()),wo=wo.ga=vo,pj=pj.o();Yj=Ek}else{for(var Gy=zg(Xj,am),kh=Xj;!kh.g();){var fr=kh.n();Gy.ba(pi(fr));kh=kh.o()}Yj=Gy.da()}return JG(new KG,ll,(new LF).X((new r).d([bn,WF($l,Yj,"",XF()),XG(VF(),"}",X())])))}if(Sm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"while"),X().N(" ("),qG(a).N(c.ob()),X().N(") "),NG(a,QG(PG(MG(a))),c.Nb(),!1,!1)])));if(lm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"do"),X().N(" "),NG(a,QG(PG(MG(a))),
c.Nb(),!1,!1),X().N(" "),zG(a,"while"),X().N(" ("),qG(a).N(c.ob()),X().N(")")])));if(pm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"for"),X().N(" ("),WF(VF(),c.Ui(),"; ",qG(a)),X().N(") "),qG(a).N(c.Nb())])));if(qm(c))return JG(new KG,UG(PG(MG(a))),(new LF).X((new r).d([zG(a,"for"),X().N(" ("),WF(VF(),c.Ui(),"; ",qG(a)),X().N(") "),zG(a,"yield"),X().N(" "),qG(a).N(c.Nb())])));if(Bm(c))return JG(new KG,OG(PG(MG(a))),(new LF).X((new r).d([zG(a,"new"),X().N(" "),qG(a).N(c.ff())])));
if(Cm(c)){var hJ=v(),cJ=c.Qc().Zg().xb(),dJ=y(z(hJ,cJ),cm())?c.Qc().Zg().sc().g():!1;if(c.Qc().Si().g())var gJ=c.Qc().Xi(),Fy=2>Cg(gJ);else Fy=!1;var dr=Fy&&dJ?c.Qc().ub().g():!1;return JG(new KG,OG(PG(MG(a))),(new LF).X((new r).d([(new LF).X((new r).d([zG(a,"new"),X().N(" "),qG(a).N(c.Qc())])),HG(VF()," {","","}",dr,X())])))}if(Em(c))return JG(new KG,RG(PG(MG(a))),zG(a,"_"));if(mm(c))return JG(new KG,OG(PG(MG(a))),(new LF).X((new r).d([NG(a,RG(PG(MG(a))),c.ob(),!1,!1),X().N(" "),zG(a,"_")])));if(Fm(c))return(new LF).X((new r).d([NG(a,
VG(PG(MG(a))),c.ob(),!1,!1),zG(a,":"),X().N(" "),zG(a,"_*")]));if(sg(c)){var er=c.Qa();G();for(var hB=(new ae).c(),Fl=er;!Fl.g();){var xs=Fl.n(),RL=xs,SL=v();!1!==!y(z(SL,RL),Hw())&&ff(hB,xs);Fl=Fl.o()}var iB=hB.lb(),TL=ZG(VF(),iB,$G(a)),jB=qG(a).N(c.xb()),ys=yG(a).N(c.sc()),op=c.Bi();if(op.g())var zs=S();else var As=op.q(),zs=(new T).e((new LF).X((new r).d([X().N(" "),zG(a,"\x3d"),X().N(" "),qG(a).N(As)])));return(new LF).X((new r).d([TL,jB,ys,zs.g()?xG():zs.q()]))}if(hi(c))return JG(new KG,LG(MG(a)),
FG(c)?(new LF).X((new r).d([X().N("`"),X().N(c.ec()),X().N("`")])):X().N(c.ec()));if(si(c))return JG(new KG,aH(bH(MG(a))),(new LF).X((new r).d([qG(a).N(wl(c)),zG(a,"."),qG(a).N(c.nc())])));if(ti(c))return JG(new KG,aH(bH(MG(a))),(new LF).X((new r).d([NG(a,aH(bH(MG(a))),ui(c),!1,!1),zG(a,"#"),qG(a).N(c.nc())])));if(vi(c))return JG(new KG,aH(bH(MG(a))),(new LF).X((new r).d([NG(a,RG(PG(MG(a))),c.ve(),!1,!1),X().N("."),zG(a,"type")])));if(wi(c)){var UL=aH(bH(MG(a))),Bs=NG(a,aH(bH(MG(a))),c.Db(),!1,!1),
Cs=zG(a,"["),VL=VF(),xn=c.pb(),pp=function(a){return function(b){return NG(a,cH(bH(MG(a))),b,!1,!1)}}(a),Ds=G().b;if(Ds===G().b)if(xn===F())var WL=F();else{for(var OY=xn.n(),PY=U(new V,pp(OY),F()),QY=PY,qp=xn.o();qp!==F();)var Es=qp.n(),zn=U(new V,pp(Es),F()),QY=QY.ga=zn,qp=qp.o();WL=PY}else{for(var RY=zg(xn,Ds),mB=xn;!mB.g();){var B5=mB.n();RY.ba(pp(B5));mB=mB.o()}WL=RY.da()}return JG(new KG,UL,(new LF).X((new r).d([Bs,Cs,WF(VL,WL,", ",XF()),zG(a,"]")])))}if(xi(c)){var C5=dH(eH(bH(MG(a))),zi(c).ec()),
SY=NG(a,dH(eH(bH(MG(a))),zi(c).ec()),c.Kd(),!0,!1),TY=X().N(" "),nB=qG(a).N(zi(c)),D5=X().N(" "),XL=dH(eH(bH(MG(a))),zi(c).ec()),YL=c.cd();return JG(new KG,C5,(new LF).X((new r).d([SY,TY,nB,D5,NG(a,XL,YL,!1,!0)])))}if(Ai(c)||tl(c)){a:{var ZL,$L,aM;if(Ai(c)){var bM=null===c?S():(new T).e((new q).a(c.me(),c.Kh()));if(!bM.g()){var E5=bM.q().qa(),cM=bM.q().p();ZL=xG();$L=E5;aM=cM;break a}}if(tl(c)){var An=null===c?S():(new T).e((new q).a(c.me(),c.Kh()));if(!An.g()){var Fs=An.q().qa(),Bn=An.q().p();ZL=
(new LF).X((new r).d([zG(a,"implicit"),X().N(" ")]));$L=Fs;aM=Bn;break a}}throw(new p).e(c);}var F5=ZL,rp=$L,G5=aM;a:{var dM,pB=fj().Vx.Nx(rp);if(!pB.g()){var eM=pB.q().qa(),qB=pB.q().p();if(F().w(qB)){var H5=v(),Cn=z(H5,eM);fH||(fH=(new gH).c());var UY=!y(Cn,fH)}else UY=!1;if(UY){dM=NG(a,Vha(bH(MG(a))),eM,!1,!1);break a}}var I5=X().N("("),J5=VF(),fM=function(a){return function(b){return NG(a,hH(bH(MG(a))),b,!1,!1)}}(a),gM=G().b;if(gM===G().b)if(rp===F())var rB=F();else{for(var sB=rp.n(),VY=U(new V,
fM(sB),F()),sp=VY,tp=rp.o();tp!==F();)var K5=tp.n(),L5=U(new V,fM(K5),F()),sp=sp.ga=L5,tp=tp.o();rB=VY}else{for(var WY=zg(rp,gM),tB=rp;!tB.g();){var M5=tB.n();WY.ba(fM(M5));tB=tB.o()}rB=WY.da()}dM=(new LF).X((new r).d([I5,WF(J5,rB,", ",XF()),X().N(")")]))}return JG(new KG,cH(bH(MG(a))),(new LF).X((new r).d([F5,dM,X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),NG(a,cH(bH(MG(a))),G5,!1,!1)])))}if(Bi(c))return JG(new KG,aH(bH(MG(a))),(new LF).X((new r).d([X().N("("),WF(VF(),c.pb(),", ",qG(a)),X().N(")")])));
if(Mi(c)){if(!a.Zc.Mg)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support with types"])),(new r).d([a.Zc])));return JG(new KG,iH(bH(MG(a))),(new LF).X((new r).d([NG(a,iH(bH(MG(a))),c.Kd(),!1,!1),X().N(" with "),NG(a,iH(bH(MG(a))),c.cd(),!1,!1)])))}if(Ni(c)){if(!a.Zc.Ig)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support and types"])),(new r).d([a.Zc])));var N5=dH(eH(bH(MG(a))),"\x26"),hM=NG(a,dH(eH(bH(MG(a))),"\x26"),c.Kd(),!0,!1),XY=X().N(" "),P5=X().N("\x26"),Q5=X().N(" "),R5=
dH(eH(bH(MG(a))),"\x26"),S5=c.cd();return JG(new KG,N5,(new LF).X((new r).d([hM,XY,P5,Q5,NG(a,R5,S5,!1,!0)])))}if(Oi(c)){if(!a.Zc.Kg)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support or types"])),(new r).d([a.Zc])));var T5=dH(eH(bH(MG(a))),"|"),YY=NG(a,dH(eH(bH(MG(a))),"|"),c.Kd(),!0,!1),U5=X().N(" "),iM=X().N("|"),V5=X().N(" "),W5=dH(eH(bH(MG(a))),"|"),X5=c.cd();return JG(new KG,T5,(new LF).X((new r).d([YY,U5,iM,V5,NG(a,W5,X5,!1,!0)])))}if(Pi(c)){var Y5=Wha(bH(MG(a))),vB=Qi(c);if(vB.g())var nm=
S();else var Z5=vB.q(),nm=(new T).e((new LF).X((new r).d([NG(a,iH(bH(MG(a))),Z5,!1,!1),X().N(" ")])));var $5=nm.g()?X().N(""):nm.q(),a6=X().N("{"),b6=VF(),ZY=WF(VF(),c.ub(),"; ",qG(a)),c6=c.ub();return JG(new KG,Y5,(new LF).X((new r).d([$5,a6,HG(b6," ",ZY," ",cj(c6),XF()),X().N("}")])))}if(Ri(c))return JG(new KG,cH(bH(MG(a))),(new LF).X((new r).d([NG(a,Vha(bH(MG(a))),c.Db(),!1,!1),X().N(" "),zG(a,"forSome"),X().N(" { "),WF(VF(),c.ub(),"; ",qG(a)),X().N(" }")])));if(Si(c))return JG(new KG,Xha(bH(MG(a))),
(new LF).X((new r).d([NG(a,aH(bH(MG(a))),c.Db(),!1,!1),X().N(" "),Lha(a).N(c.Di())])));if(ul(c))return JG(new KG,cH(bH(MG(a))),(new LF).X((new r).d([EG(a).N(c.lc()),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),NG(a,cH(bH(MG(a))),c.Db(),!1,!1)])));if(c&&c.$classData&&c.$classData.H.GC)return JG(new KG,cH(bH(MG(a))),(new LF).X((new r).d([jH(a).N(c.bd()),zG(a,":"),X().N(" "),NG(a,cH(bH(MG(a))),c.Db(),!1,!1)])));if(Ti(c))return JG(new KG,aH(bH(MG(a))),(new LF).X((new r).d([zG(a,"_"),qG(a).N(c.Gh())])));if(Ul(c)){var $Y=
nl(c);if($Y.g())var jM=S();else var aZ=$Y.q(),jM=(new T).e((new LF).X((new r).d([X().N(" "),zG(a,"\x3e:"),X().N(" "),NG(a,cH(bH(MG(a))),aZ,!1,!1)])));var up=jM.g()?xG():jM.q(),om=ol(c);if(om.g())var wB=S();else var xB=om.q(),wB=(new T).e((new LF).X((new r).d([X().N(" "),zG(a,"\x3c:"),X().N(" "),NG(a,cH(bH(MG(a))),xB,!1,!1)])));return(new LF).X((new r).d([up,wB.g()?xG():wB.q()]))}if(Jg(c))return JG(new KG,hH(bH(MG(a))),(new LF).X((new r).d([NG(a,cH(bH(MG(a))),c.Db(),!1,!1),zG(a,"*")])));if(Ig(c))return JG(new KG,
hH(bH(MG(a))),(new LF).X((new r).d([zG(a,"\x3d\x3e"),X().N(" "),NG(a,cH(bH(MG(a))),c.Db(),!1,!1)])));if(kH(c))return JG(new KG,aH(bH(MG(a))),X().N(c.nc().ec()));if(Vl(c)){var f6=c.Qa();G();for(var bZ=(new ae).c(),yB=f6;!yB.g();){var zB=yB.n(),cZ=zB,g6=v();if(y(z(g6,cZ),Yha()))AB=!1;else var h6=v(),AB=!y(z(h6,cZ),Zha());!1!==AB&&ff(bZ,zB);yB=yB.o()}var kM=bZ.lb(),i6=c.Qa();if(1>=(Cg(i6)-Cg(kM)|0))var Gl=(new q).a(!0,F());else{G();var j6=(new r).d(["t.mods.length.-(mods.length).\x3c\x3d(1) is false"]),
k6=G().b,Gl=(new q).a(!1,H(j6,k6))}if(null===Gl||!0!==I(Gl)){if(null!==Gl){var Ixa=Gl.p();if(!1===I(Gl)){for(var Jxa=J(),Dma=[(new q).a("t",c),(new q).a("mods",kM)],Ema=A(new B,C()),LZ=0,Kxa=Dma.length|0;LZ<Kxa;)E(Ema,Dma[LZ]),LZ=1+LZ|0;K(Jxa,"t.mods.length.-(mods.length).\x3c\x3d(1)",Ixa,Ema.t)}}throw(new p).e(Gl);}for(var MZ="",NZ=c.Qa();!NZ.g();){var Lxa=MZ,Mxa=NZ.n(),Nxa=Lxa,Fma=Mxa,Oxa=v();if(y(z(Oxa,Fma),Yha()))MZ="+";else var Pxa=v(),MZ=y(z(Pxa,Fma),Zha())?"-":Nxa;NZ=NZ.o()}var Qxa=MZ,Rxa=
qG(a).N(c.am()),Sxa=c.im();if(cj(Sxa)&&!a.Zc.tg)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support view bounds"])),(new r).d([a.Zc])));var Txa=VF(),pO=c.im(),R7=function(a){return function(b){return(new LF).X((new r).d([X().N(" "),zG(a,"\x3c%"),X().N(" "),qG(a).N(b)]))}}(a),Gma=G().b;if(Gma===G().b)if(pO===F())var S7=F();else{for(var Uxa=pO.n(),Hma=U(new V,R7(Uxa),F()),Ima=Hma,OZ=pO.o();OZ!==F();)var Vxa=OZ.n(),Wxa=U(new V,R7(Vxa),F()),Ima=Ima.ga=Wxa,OZ=OZ.o();S7=Hma}else{for(var Jma=zg(pO,
Gma),PZ=pO;!PZ.g();){var Xxa=PZ.n();Jma.ba(R7(Xxa));PZ=PZ.o()}S7=Jma.da()}var Yxa=WF(Txa,S7,"",XF()),Zxa=VF(),qO=c.ym(),T7=function(a){return function(b){return(new LF).X((new r).d([zG(a,":"),X().N(" "),qG(a).N(b)]))}}(a),Kma=G().b;if(Kma===G().b)if(qO===F())var U7=F();else{for(var $xa=qO.n(),Lma=U(new V,T7($xa),F()),Mma=Lma,QZ=qO.o();QZ!==F();)var aya=QZ.n(),bya=U(new V,T7(aya),F()),Mma=Mma.ga=bya,QZ=QZ.o();U7=Lma}else{for(var Nma=zg(qO,Kma),RZ=qO;!RZ.g();){var cya=RZ.n();Nma.ba(T7(cya));RZ=RZ.o()}U7=
Nma.da()}var dya=WF(Zxa,U7,"",XF());return(new LF).X((new r).d([ZG(VF(),kM,$G(a)),X().N(Qxa),qG(a).N(c.xb()),EG(a).N(c.lc()),Rxa,Yxa,dya]))}if(ln(c))return JG(new KG,lH(mH(MG(a))),X().N(FG(c.yb())?td((new yd).X((new r).d(["`","`"])),(new r).d([c.yb().ec()])):c.yb().ec()));if(mn(c))return JG(new KG,lH(mH(MG(a))),zG(a,"_"));if(hn(c))return JG(new KG,lH(mH(MG(a))),zG(a,"_*"));if(Ym(c)){var eya=c.ci();if(hn(eya))if(a.Zc.rg)var V7=(new LF).X((new r).d([X().N(" "),zG(a,"@")]));else{if(!a.Zc.kg)throw(new Gq).j(td((new yd).X((new r).d(["",
" doesn't support extractor varargs"])),(new r).d([a.Zc])));V7=zG(a,":")}else V7=(new LF).X((new r).d([X().N(" "),zG(a,"@")]));return JG(new KG,$ha(mH(MG(a))),(new LF).X((new r).d([NG(a,lH(mH(MG(a))),c.Vd(),!1,!1),V7,X().N(" "),NG(a,aia(mH(MG(a))),c.ci(),!1,!1)])))}if(Xm(c))return JG(new KG,nH(mH(MG(a))),(new LF).X((new r).d([NG(a,nH(mH(MG(a))),c.Vd(),!1,!1),X().N(" "),zG(a,"|"),X().N(" "),NG(a,nH(mH(MG(a))),c.ci(),!1,!1)])));if(jn(c))return JG(new KG,lH(mH(MG(a))),(new LF).X((new r).d([X().N("("),
WF(VF(),c.pb(),", ",qG(a)),X().N(")")])));if(dn(c))return JG(new KG,lH(mH(MG(a))),(new LF).X((new r).d([qG(a).N(c.Ae()),Pha(a).N(c.pb())])));if(en(c)){var hya=oH(pH(mH(MG(a))),c.Qd().ec()),iya=NG(a,oH(pH(mH(MG(a))),c.Qd().ec()),c.Vd(),!0,!1),jya=X().N(" "),kya=qG(a).N(c.Qd()),lya=X().N(" "),TZ=fn(c);a:{var X7;if(rk(TZ)){var mya=TZ.ed,nya=TZ.ga;if(F().w(nya)){var oya=oH(pH(mH(MG(a))),c.Qd().ec());X7=NG(a,oya,mya,!1,!0);break a}}X7=Pha(a).N(TZ)}return JG(new KG,hya,(new LF).X((new r).d([iya,jya,kya,
lya,X7])))}if(gn(c)){var sO=c.Qe(),Y7=function(){return function(a){var b=(new T).e(a.Xf()).Y;if(aG(b))return b;throw(new p).e(a);}}(a),Oma=G().b;if(Oma===G().b)if(sO===F())var UZ=F();else{for(var pya=sO.n(),Pma=U(new V,Y7(pya),F()),Qma=Pma,VZ=sO.o();VZ!==F();)var qya=VZ.n(),rya=U(new V,Y7(qya),F()),Qma=Qma.ga=rya,VZ=VZ.o();UZ=Pma}else{for(var Rma=zg(sO,Oma),WZ=sO;!WZ.g();){var sya=WZ.n();Rma.ba(Y7(sya));WZ=WZ.o()}UZ=Rma.da()}var tya=c.pb(),uya=G().b,tO=Vm(UZ,tya,uya),Z7=function(a){return function(b){if(null!==
b){var c=b.qa(),d=b.p();if(Um(d)&&!FG(d))return(new LF).X((new r).d([X().N(c),X().N("$"),X().N(d.ec())]))}if(null!==b)return c=b.qa(),b=b.p(),(new LF).X((new r).d([X().N(c),X().N("${"),qG(a).N(b),X().N("}")]));throw(new p).e(b);}}(a),Sma=G().b;if(Sma===G().b)if(tO===F())var $7=F();else{for(var vya=tO.n(),Tma=U(new V,Z7(vya),F()),Uma=Tma,XZ=tO.o();XZ!==F();)var wya=XZ.n(),xya=U(new V,Z7(wya),F()),Uma=Uma.ga=xya,XZ=XZ.o();$7=Tma}else{for(var Vma=zg(tO,Sma),YZ=tO;!YZ.g();){var yya=YZ.n();Vma.ba(Z7(yya));
YZ=YZ.o()}$7=Vma.da()}return JG(new KG,lH(mH(MG(a))),(new LF).X((new r).d([qG(a).N(c.yi()),X().N('"'),WF(VF(),$7,"",XF()),X().N(cl(UZ)),X().N('"')])))}if(nn(c)){if(!a.Zc.cf)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support xml literals"])),(new r).d([a.Zc])));var uO=c.Qe(),a8=function(){return function(a){var b=(new T).e(a.Xf()).Y;if(aG(b))return b;throw(new p).e(a);}}(a),Wma=G().b;if(Wma===G().b)if(uO===F())var ZZ=F();else{for(var zya=uO.n(),Xma=U(new V,a8(zya),F()),Yma=Xma,$Z=uO.o();$Z!==
F();)var Aya=$Z.n(),Bya=U(new V,a8(Aya),F()),Yma=Yma.ga=Bya,$Z=$Z.o();ZZ=Xma}else{for(var Zma=zg(uO,Wma),a_=uO;!a_.g();){var Cya=a_.n();Zma.ba(a8(Cya));a_=a_.o()}ZZ=Zma.da()}var Dya=c.pb(),Eya=G().b,vO=Vm(ZZ,Dya,Eya),b8=function(a){return function(b){if(null!==b){var c=b.qa();b=b.p();return(new LF).X((new r).d([X().N(c),X().N("{"),qG(a).N(b),X().N("}")]))}throw(new p).e(b);}}(a),$ma=G().b;if($ma===G().b)if(vO===F())var c8=F();else{for(var Fya=vO.n(),ana=U(new V,b8(Fya),F()),bna=ana,b_=vO.o();b_!==
F();)var Gya=b_.n(),Hya=U(new V,b8(Gya),F()),bna=bna.ga=Hya,b_=b_.o();c8=ana}else{for(var cna=zg(vO,$ma),c_=vO;!c_.g();){var Iya=c_.n();cna.ba(b8(Iya));c_=c_.o()}c8=cna.da()}return JG(new KG,lH(mH(MG(a))),(new LF).X((new r).d([WF(VF(),c8,"",XF()),X().N(cl(ZZ))])))}if(kn(c)){var d=!0,d8=f=c,e8=null===d8?S():(new T).e((new q).a(d8.Vd(),d8.cd()));if(!e8.g()){var Jya=e8.q().qa(),dna=e8.q().p();if(Ui(dna)){if(a.Zc.Bh)return JG(new KG,qH(mH(MG(a))),(new LF).X((new r).d([NG(a,lH(mH(MG(a))),Jya,!1,!1),zG(a,
":"),X().N(" "),NG(a,rH(MG(a)),dna,!1,!1)])));throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support literal types"])),(new r).d([a.Zc])));}}}if(d)return JG(new KG,qH(mH(MG(a))),(new LF).X((new r).d([NG(a,lH(mH(MG(a))),f.Vd(),!1,!1),zG(a,":"),X().N(" "),NG(a,Wha(bH(MG(a))),f.cd(),!1,!1)])));if(c&&c.$classData&&c.$classData.H.yC){var ena=null===c?S():(new T).e(c.Ab);if(!ena.g()){var Kya=!!ena.q();return JG(new KG,rH(MG(a)),X().N(""+Kya))}}if(c&&c.$classData&&c.$classData.H.OM){var fna=null===
c?S():(new T).e(c.V4());if(!fna.g()){var e_=fna.q()|0;return JG(new KG,rH(MG(a)),(new LF).X((new r).d([X().N("ByteLiterals."),X().N(0===e_?"Zero":0<e_?"Plus"+e_:"Minus"+e_)])))}}if(c&&c.$classData&&c.$classData.H.eN){var gna=null===c?S():(new T).e(c.W4());if(!gna.g()){var f_=gna.q()|0;return JG(new KG,rH(MG(a)),(new LF).X((new r).d([X().N("ShortLiterals."),X().N(0===f_?"Zero":0<f_?"Plus"+f_:"Minus"+f_)])))}}if(c&&c.$classData&&c.$classData.H.zC){var hna=null===c?S():(new T).e(c.Ab);if(!hna.g()){var Lya=
hna.q()|0;return JG(new KG,rH(MG(a)),X().N(""+Lya))}}if(sH(c)){var ina=null===c?S():(new T).e(c.Ab);if(!ina.g()){var jna=Ya(ina.q()),Mya=jna.Ra,Nya=jna.Ya;return JG(new KG,rH(MG(a)),X().N(tH(ab(),Mya,Nya)+"L"))}}if(hG(c)){var kna=null===c?S():(new T).e(c.li);if(!kna.g()){var lna=kna.q(),Oya=(new cd).j(lna).ka,g_=ga(uH(vH(),Oya));return g_!==g_?X().N("Float.NaN"):Infinity===g_?X().N("Float.PositiveInfinity"):-Infinity===g_?X().N("Float.NegativeInfinity"):(new LF).X((new r).d([X().N(lna),X().N("f")]))}}if(fG(c)){var mna=
null===c?S():(new T).e(c.li);if(!mna.g()){var nna=mna.q(),Pya=(new cd).j(nna),h_=uH(vH(),Pya.ka);return h_!==h_?X().N("Double.NaN"):Infinity===h_?X().N("Double.PositiveInfinity"):-Infinity===h_?X().N("Double.NegativeInfinity"):(new LF).X((new r).d([X().N(nna),X().N("d")]))}}if(wH(c)){var ona=null===c?S():(new T).e((new ed).db(c.Ab));if(!ona.g()){var pna=ona.q(),Qya=null===pna?0:pna.pa;return JG(new KG,rH(MG(a)),X().N(bG(cG(),ca.String.fromCharCode(Qya),bia())))}}if(c&&c.$classData&&c.$classData.H.BC){var rna=
null===c?S():(new T).e(c.Ab);if(!rna.g()){var sna=rna.q();return JG(new KG,rH(MG(a)),X().N(bG(cG(),sna,-1!==(sna.indexOf("\n")|0)?cia():dG())))}}if(xH(c)){var una=null===c?S():(new T).e(c.Ab);if(!una.g()){var Rya=una.q();return JG(new KG,rH(MG(a)),(new LF).X((new r).d([X().N("'"),X().N(Rya.gd)])))}}if(c&&c.$classData&&c.$classData.H.AC)return JG(new KG,rH(MG(a)),zG(a,"null"));if(on(c))return JG(new KG,rH(MG(a)),X().N("()"));if(vn(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"val"),X().N(" "),
WF(VF(),c.Xd(),", ",qG(a)),zG(a,":"),X().N(" "),qG(a).N(c.df())]));if(wn(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"var"),X().N(" "),WF(VF(),c.Xd(),", ",qG(a)),zG(a,":"),X().N(" "),qG(a).N(c.df())]));if(un(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"type"),X().N(" "),qG(a).N(c.nc()),EG(a).N(c.lc()),qG(a).N(c.Gh())]));if(rn(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"def"),X().N(" "),qG(a).N(c.yb()),EG(a).N(c.lc()),jH(a).N(c.bd()),zG(a,":"),X().N(" "),
qG(a).N(c.df())]));if(Nk(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"val"),X().N(" "),WF(VF(),c.Xd(),", ",qG(a)),yG(a).N(c.sc()),X().N(" "),zG(a,"\x3d"),X().N(" "),qG(a).N(c.Ld())]));if(Sk(c)){var Sya=ZG(VF(),c.Qa(),$G(a)),Tya=zG(a,"var"),Uya=X().N(" "),Vya=WF(VF(),c.Xd(),", ",qG(a)),Wya=yG(a).N(c.sc()),Xya=X().N(" "),Yya=zG(a,"\x3d"),Zya=X().N(" "),vna=Tk(c);if(vna.g())var j8=S();else var $ya=vna.q(),j8=(new T).e(qG(a).N($ya));return(new LF).X((new r).d([Sya,Tya,Uya,Vya,Wya,Xya,Yya,
Zya,j8.g()?zG(a,"_"):j8.q()]))}if(Qk(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"type"),X().N(" "),qG(a).N(c.nc()),EG(a).N(c.lc()),X().N(" "),zG(a,"\x3d"),X().N(" "),qG(a).N(Rk(c))]));if(Ok(c)){var aza=ZG(VF(),c.Qa(),$G(a)),bza=zG(a,"class"),cza=X().N(" "),dza=qG(a).N(c.nc()),eza=EG(a).N(c.lc()),fza=VF(),gza=c.jh(),hza=c.jh().Qa();return(new LF).X((new r).d([aza,bza,cza,dza,eza,yH(fza," ",gza,cj(hza),qG(a)),CG(a,c.Qc())]))}if(Pk(c)){if(a.Zc.sg||c.jh().Qa().g()){var iza=ZG(VF(),c.Qa(),
$G(a)),jza=zG(a,"trait"),kza=X().N(" "),lza=qG(a).N(c.nc()),mza=EG(a).N(c.lc()),nza=VF(),oza=c.jh(),pza=c.jh().Qa();return(new LF).X((new r).d([iza,jza,kza,lza,mza,yH(nza," ",oza,cj(pza),qG(a)),CG(a,c.Qc())]))}throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support trait parameters"])),(new r).d([a.Zc])));}if(Lk(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"object"),X().N(" "),qG(a).N(c.yb()),CG(a,c.Qc())]));if(Gk(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"def"),
X().N(" "),qG(a).N(c.yb()),EG(a).N(c.lc()),jH(a).N(c.bd()),yG(a).N(c.sc()),X().N(" \x3d "),qG(a).N(c.Nb())]));if(Kk(c))return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"def"),X().N(" "),qG(a).N(c.yb()),EG(a).N(c.lc()),jH(a).N(c.bd()),yG(a).N(c.sc()),X().N(" "),zG(a,"\x3d"),X().N(" "),zG(a,"macro"),X().N(" "),qG(a).N(c.Nb())]));if(Ql(c)){if(!dia(a,c)){var qza=zG(a,"package"),rza=X().N(" "),sza=qG(a).N(c.ve()),tza=X().N(" {"),uza=VF(),wO=c.ub(),l8=function(a){return function(b){return YG(VF(),
b,qG(a))}}(a),xna=G().b;if(xna===G().b)if(wO===F())var m8=F();else{for(var vza=wO.n(),yna=U(new V,l8(vza),F()),zna=yna,i_=wO.o();i_!==F();)var wza=i_.n(),xza=U(new V,l8(wza),F()),zna=zna.ga=xza,i_=i_.o();m8=yna}else{for(var Ana=zg(wO,xna),j_=wO;!j_.g();){var yza=j_.n();Ana.ba(l8(yza));j_=j_.o()}m8=Ana.da()}return(new LF).X((new r).d([qza,rza,sza,tza,WF(uza,m8,"",XF()),XG(VF(),"}",X())]))}var zza=zG(a,"package"),Aza=X().N(" "),Bza=qG(a).N(c.ve()),Cza=VF(),xO=c.ub(),n8=function(a){return function(b){return XG(VF(),
b,qG(a))}}(a),Bna=G().b;if(Bna===G().b)if(xO===F())var o8=F();else{for(var Dza=xO.n(),Cna=U(new V,n8(Dza),F()),Dna=Cna,k_=xO.o();k_!==F();)var Eza=k_.n(),Fza=U(new V,n8(Eza),F()),Dna=Dna.ga=Fza,k_=k_.o();o8=Cna}else{for(var Ena=zg(xO,Bna),l_=xO;!l_.g();){var Gza=l_.n();Ena.ba(n8(Gza));l_=l_.o()}o8=Ena.da()}return(new LF).X((new r).d([zza,Aza,Bza,WF(Cza,o8,"",XF())]))}if(Mk(c))return(new LF).X((new r).d([zG(a,"package"),X().N(" "),ZG(VF(),c.Qa(),$G(a)),zG(a,"object"),X().N(" "),qG(a).N(c.yb()),CG(a,
c.Qc())]));if(Gn(c)){var Hza=VF(),Iza=c.Qa(),Jza=c.Qa();if(cj(Jza))var Kza=c.bd(),Fna=cj(Kza);else Fna=!1;return(new LF).X((new r).d([eia(Hza,Iza,Fna,$G(a)),jH(a).N(c.bd())]))}if(Hn(c)){if(c.ub().g())return(new LF).X((new r).d([ZG(VF(),c.Qa(),$G(a)),zG(a,"def"),X().N(" "),zG(a,"this"),jH(a).N(c.bd()),X().N(" \x3d "),qG(a).N(c.ff())]));var Lza=ZG(VF(),c.Qa(),$G(a)),Mza=zG(a,"def"),Nza=X().N(" "),Oza=zG(a,"this"),Pza=jH(a).N(c.bd()),Qza=X().N(" {"),Rza=YG(VF(),c.ff(),qG(a)),Sza=X().N(""),Tza=VF(),yO=
c.ub(),p8=function(a){return function(b){return YG(VF(),b,qG(a))}}(a),Hna=G().b;if(Hna===G().b)if(yO===F())var q8=F();else{for(var Uza=yO.n(),Ina=U(new V,p8(Uza),F()),Jna=Ina,m_=yO.o();m_!==F();)var Vza=m_.n(),Wza=U(new V,p8(Vza),F()),Jna=Jna.ga=Wza,m_=m_.o();q8=Ina}else{for(var Kna=zg(yO,Hna),n_=yO;!n_.g();){var Xza=n_.n();Kna.ba(p8(Xza));n_=n_.o()}q8=Kna.da()}return(new LF).X((new r).d([Lza,Mza,Nza,Oza,Pza,Qza,Rza,Sza,WF(Tza,q8,"",XF()),XG(VF(),"}",X())]))}if(Ol(c)){var Yza=v(),Zza=c.Db();return(new LF).X((new r).d([y(z(Yza,
Zza),fia())?zG(a,"this"):NG(a,Xha(bH(MG(a))),c.Db(),!1,!1),Qha(a).N(c.tl())]))}if(Rl(c))return(new LF).X((new r).d([qG(a).N(c.xb()),yG(a).N(c.sc())]));if(Tl(c)){var $za=v(),aAa=c.Zg().xb(),Mna=y(z($za,aAa),cm())?c.Zg().sc().g():!1,bAa=!Mna,Nna=Mna&&c.ub().g();if(c.Si().g()&&c.Xi().g()&&Nna)return xG();var cAa=c.Si().g()?xG():(new LF).X((new r).d([X().N("{ "),WF(VF(),c.Si(),"; ",qG(a)),X().N(" } with ")])),dAa=eia(VF(),WF(VF(),c.Xi()," with ",qG(a)),!c.Xi().g()&&!Nna,XF()),eAa=c.ub();if(0===Cg(eAa))var o_=
!0;else{var fAa=c.ub();if(1===Cg(fAa))var gAa=qG(a).N(c.ub().n()).v(),hAa=lr().hg,o_=-1===(gAa.indexOf(hAa)|0);else o_=!1}var ok=(new q).a(bAa,c.ub());a:{var Pt,iAa=ok.Ok;if(!1===!!ok.Nk&&F().w(iAa))Pt=xG();else{var jAa=ok.Ok;if(!1===!!ok.Nk){G();var r8=(new T).e(jAa);if(null!==r8.Y&&0===qo(r8.Y,1)){var kAa=ro(r8.Y,0);if(o_){Pt=(new LF).X((new r).d([X().N("{ "),qG(a).N(kAa),X().N(" }")]));break a}}}var zO=ok.Ok;if(!1===!!ok.Nk){var lAa=X().N("{"),mAa=VF(),s8=function(a){return function(b){return YG(VF(),
b,qG(a))}}(a),Ona=G().b;if(Ona===G().b)if(zO===F())var t8=F();else{for(var nAa=zO.n(),Pna=U(new V,s8(nAa),F()),Qna=Pna,p_=zO.o();p_!==F();)var oAa=p_.n(),pAa=U(new V,s8(oAa),F()),Qna=Qna.ga=pAa,p_=p_.o();t8=Pna}else{for(var Rna=zg(zO,Ona),q_=zO;!q_.g();){var qAa=q_.n();Rna.ba(s8(qAa));q_=q_.o()}t8=Rna.da()}Pt=(new LF).X((new r).d([lAa,WF(mAa,t8,"",XF()),XG(VF(),"}",X())]))}else{var rAa=ok.Ok;if(!0===!!ok.Nk&&F().w(rAa))Pt=(new LF).X((new r).d([X().N("{ "),qG(a).N(c.Zg()),X().N(" \x3d\x3e }")]));else{var sAa=
ok.Ok;if(!0===!!ok.Nk){G();var u8=(new T).e(sAa);if(null!==u8.Y&&0===qo(u8.Y,1)){var tAa=ro(u8.Y,0);if(o_){Pt=(new LF).X((new r).d([X().N("{ "),qG(a).N(c.Zg()),X().N(" \x3d\x3e "),qG(a).N(tAa),X().N(" }")]));break a}}}var AO=ok.Ok;if(!0===!!ok.Nk){var uAa=X().N("{ "),vAa=qG(a).N(c.Zg()),wAa=X().N(" \x3d\x3e"),xAa=VF(),v8=function(a){return function(b){return YG(VF(),b,qG(a))}}(a),Sna=G().b;if(Sna===G().b)if(AO===F())var w8=F();else{for(var yAa=AO.n(),Tna=U(new V,v8(yAa),F()),Una=Tna,r_=AO.o();r_!==
F();)var zAa=r_.n(),AAa=U(new V,v8(zAa),F()),Una=Una.ga=AAa,r_=r_.o();w8=Tna}else{for(var Vna=zg(AO,Sna),s_=AO;!s_.g();){var BAa=s_.n();Vna.ba(v8(BAa));s_=s_.o()}w8=Vna.da()}Pt=(new LF).X((new r).d([uAa,vAa,wAa,WF(xAa,w8,"",XF()),XG(VF(),"}",X())]))}else throw(new p).e(ok);}}}}return(new LF).X((new r).d([cAa,dAa,Pt]))}if(yl(c)){var Wna=null===c?S():(new T).e(c.ff());if(!Wna.g()){var Xna=Wna.q();return(new LF).X((new r).d([zG(a,"@"),NG(a,aH(bH(MG(a))),Xna.Db(),!1,!1),Qha(a).N(Xna.tl())]))}}if(El(c)){var g=
!0,Yna=h=c,Zna=null===Yna?S():(new T).e(Yna.gg());if(!Zna.g()){var CAa=Zna.q();if(Pl(CAa))return zG(a,"private")}}if(g){var $na=h,aoa=null===$na?S():(new T).e($na.gg());if(!aoa.g()){var DAa=aoa.q();return(new LF).X((new r).d([zG(a,"private"),zG(a,"["),qG(a).N(DAa),zG(a,"]")]))}}if(Hl(c)){var n=!0,boa=u=c,coa=null===boa?S():(new T).e(boa.gg());if(!coa.g()){var EAa=coa.q();if(Pl(EAa))return zG(a,"protected")}}if(n){var doa=u,eoa=null===doa?S():(new T).e(doa.gg());if(!eoa.g()){var FAa=eoa.q();return(new LF).X((new r).d([zG(a,
"protected"),zG(a,"["),qG(a).N(FAa),zG(a,"]")]))}}if(AD(c))return zG(a,"implicit");if(zH(c))return zG(a,"final");if(AH(c))return zG(a,"sealed");if(BH(c))return zG(a,"override");if(CH(c))return zG(a,"case");if(DH(c))return zG(a,"abstract");if(Cl(c))return zG(a,"+");if(Dl(c))return zG(a,"-");if(BD(c))return zG(a,"lazy");if(c&&c.$classData&&c.$classData.H.EC)return zG(a,"val");if(c&&c.$classData&&c.$classData.H.FC)return zG(a,"var");if(CD(c)){if(!a.Zc.Sh)throw(new Gq).j(td((new yd).X((new r).d([""," doesn't support inline modifiers"])),
(new r).d([a.Zc])));return zG(a,"inline")}if(Fn(c))return(new LF).X((new r).d([NG(a,qH(mH(MG(a))),c.Re(),!1,!1),X().N(" \x3d "),NG(a,QG(PG(MG(a))),c.Ld(),!1,!1)]));if(Dn(c))return(new LF).X((new r).d([NG(a,qH(mH(MG(a))),c.Re(),!1,!1),X().N(" \x3c- "),NG(a,QG(PG(MG(a))),c.Ld(),!1,!1)]));if(En(c))return(new LF).X((new r).d([zG(a,"if"),X().N(" "),NG(a,VG(PG(MG(a))),c.oi(),!1,!1)]));if(Ln(c))return qG(a).N(c.xb());if(Mn(c))return(new LF).X((new r).d([qG(a).N(c.xb()),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),
qG(a).N(Nn(c))]));if(On(c))return(new LF).X((new r).d([qG(a).N(c.xb()),X().N(" "),zG(a,"\x3d\x3e"),X().N(" "),zG(a,"_")]));if(Pn(c))return zG(a,"_");if(Jn(c))return(new LF).X((new r).d([qG(a).N(c.ve()),X().N("."),Jha(a).N(c.Tk())]));if(In(c))return(new LF).X((new r).d([zG(a,"import"),X().N(" "),WF(VF(),Kn(c),", ",qG(a))]));if(Nl(c)){var GAa=NG(a,nH(mH(MG(a))),c.Re(),!1,!1),foa=c.zm();if(foa.g())var C8=S();else var HAa=foa.q(),C8=(new T).e((new LF).X((new r).d([X().N(" "),zG(a,"if"),X().N(" "),NG(a,
VG(PG(MG(a))),HAa,!1,!1)])));var IAa=C8.g()?xG():C8.q(),goa=!1,D8=null,hoa=GG(c);a:{var Qt;if(zh(hoa)){var goa=!0,D8=hoa,t_=D8.Y;if(Am(t_)){var ioa=null===t_?S():(new T).e((new q).a(t_.ob(),t_.ni()));if(!ioa.g()){for(var u_=ioa.q().p();!u_.g();){var JAa=u_.n();if(!tG(JAa)){Qt=!1;break a}u_=u_.o()}Qt=!0;break a}}}if(goa){var E8=D8.Y;if(Dm(E8)){var joa=null===E8?S():(new T).e(E8.ni());if(!joa.g()){for(var v_=joa.q();!v_.g();){var KAa=v_.n();if(!tG(KAa)){Qt=!1;break a}v_=v_.o()}Qt=!0;break a}}}Qt=tG(c)}var Rt=
Kha(c).ub();a:{var w_;if(F().w(Rt)&&!0===Qt)w_=X().N("");else{G();var F8=(new T).e(Rt);if(null!==F8.Y&&0===qo(F8.Y,1)){var LAa=ro(F8.Y,0);if(!0===Qt){w_=(new LF).X((new r).d([X().N(" "),qG(a).N(LAa)]));break a}}var MAa=VF(),G8=function(a){return function(b){return YG(VF(),b,qG(a))}}(a),koa=G().b;if(koa===G().b)if(Rt===F())var H8=F();else{for(var NAa=Rt.n(),loa=U(new V,G8(NAa),F()),moa=loa,x_=Rt.o();x_!==F();)var OAa=x_.n(),PAa=U(new V,G8(OAa),F()),moa=moa.ga=PAa,x_=x_.o();H8=loa}else{for(var noa=
zg(Rt,koa),y_=Rt;!y_.g();){var QAa=y_.n();noa.ba(G8(QAa));y_=y_.o()}H8=noa.da()}w_=WF(MAa,H8,"",XF())}}return(new LF).X((new r).d([X().N("case "),GAa,IAa,X().N(" "),zG(a,"\x3d\x3e"),w_]))}if(Sl(c))return WF(VF(),c.ub(),lr().hg,qG(a));throw(new p).e(c);}}(a)))}
function MG(a){if(null===a.ls&&null===a.ls){var b=new EH;if((rH(b),6)===(RG(PG(b)),6))var c=!0,d=F();else G(),c=(new r).d(["SyntacticGroup.this.Literal.precedence is not equal to SyntacticGroup.this.Term.SimpleExpr1.precedence"]),d=G().b,d=H(c,d),c=!1;c?(rH(b),6)===(lH(mH(b)),6)?c=(new q).a(!0,F()):(G(),c=(new r).d(["SyntacticGroup.this.Literal.precedence is not equal to SyntacticGroup.this.Pat.SimplePattern.precedence"]),d=G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==
c&&(a=c.p(),!1===I(c))){for(var d=J(),b=[(new q).a("SyntacticGroup",b)],f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"SyntacticGroup.this.Literal.precedence.\x3d\x3d(SyntacticGroup.this.Term.SimpleExpr1.precedence).\x26\x26(SyntacticGroup.this.Literal.precedence.\x3d\x3d(SyntacticGroup.this.Pat.SimplePattern.precedence))",a,f.t)}throw(new p).e(c);}(LG(b),6)===(aH(bH(b)),6)?(c=!0,d=F()):(G(),c=(new r).d(["SyntacticGroup.this.Path.precedence is not equal to SyntacticGroup.this.Type.SimpleTyp.precedence"]),
d=G().b,d=H(c,d),c=!1);c?((LG(b),6)===(RG(PG(b)),6)?(c=!0,d=F()):(G(),c=(new r).d(["SyntacticGroup.this.Path.precedence is not equal to SyntacticGroup.this.Term.SimpleExpr1.precedence"]),d=G().b,d=H(c,d),c=!1),c?(LG(b),6)===(lH(mH(b)),6)?c=(new q).a(!0,F()):(G(),c=(new r).d(["SyntacticGroup.this.Path.precedence is not equal to SyntacticGroup.this.Pat.SimplePattern.precedence"]),d=G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d)):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===
I(c))){d=J();b=[(new q).a("SyntacticGroup",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"SyntacticGroup.this.Path.precedence.\x3d\x3d(SyntacticGroup.this.Type.SimpleTyp.precedence).\x26\x26(SyntacticGroup.this.Path.precedence.\x3d\x3d(SyntacticGroup.this.Term.SimpleExpr1.precedence)).\x26\x26(SyntacticGroup.this.Path.precedence.\x3d\x3d(SyntacticGroup.this.Pat.SimplePattern.precedence))",a,f.t)}throw(new p).e(c);}a.ls=b}return a.ls}
function dia(a,b){var c=!1,d=null;b=GG(b);if(zh(b)){var c=!0,d=b,f=d.Y;if(Ql(f))return dia(a,f)?(a=f.ub(),1===Cg(a)):!1}if(c&&(a=d.Y,Sl(a)))return a=a.ub(),1===Cg(a);if(S()===b)return!0;ie(he(),Fu())}
function jH(a){return(new PF).te(lk(function(a){return function(c){var d=VF(),f=function(a){return function(b){var c=X().N("("),d=VF(),f=WF(VF(),b,", ",qG(a));a:{for(;!b.g();){b:{for(var g=b.n().Qa();!g.g();){var h=g.n(),n=v();if(y(z(n,h),Hw())){g=!0;break b}g=g.o()}g=!1}if(g){b=!0;break a}b=b.o()}b=!1}return(new LF).X((new r).d([c,yH(d,"implicit ",f,b,XF()),X().N(")")]))}}(a),g=G().b;if(g===G().b)if(c===F())f=F();else{var g=c.n(),h=g=U(new V,f(g),F());for(c=c.o();c!==F();){var n=c.n(),n=U(new V,
f(n),F()),h=h.ga=n;c=c.o()}f=g}else{for(g=zg(c,g);!c.g();)h=c.n(),g.ba(f(h)),c=c.o();f=g.da()}return WF(d,f,"",XF())}}(a)))}rG.prototype.Ev=function(a){this.Zc=a;return this};
function WG(a,b){var c=VF();a=function(a){return function(b){return YG(VF(),b,qG(a))}}(a);var d=G().b;if(d===G().b)if(b===F())a=F();else{var d=b.n(),f=d=U(new V,a(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,a(g),F()),f=f.ga=g;b=b.o()}a=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();a=d.da()}return WF(c,a,"",XF())}
function DG(a){return(new PF).te(lk(function(a){return function(c){var d=!1,f=null;if(rk(c)){var d=!0,f=c,g=f.ed,h=f.ga;if(km(g)&&F().w(h))return(new LF).X((new r).d([X().N(" "),qG(a).N(g)]))}if(d&&(d=f.ed,f=f.ga,rm(d)&&(g=null===d?S():(new T).e((new q).a(d.me(),d.Nb())),!g.g()))){g=g.q().qa();if(F().w(f)){a:{for(f=g;!f.g();){if(f.n().sc().g()){f=!0;break a}f=f.o()}f=!1}f=!f}else f=!1;if(f)return(new LF).X((new r).d([X().N(" { "),qG(a).N(d),X().N(" }")]))}return(new LF).X((new r).d([X().N("("),WF(VF(),
c,", ",qG(a)),X().N(")")]))}}(a)))}function zG(a,b){return(new FH).te(lk(function(a,b){return function(a){if(1<a.Qb.Fa())var c=-2+a.Qb.Fa()|0,c=a.Qb.Vj(c);else c=32;if(0<a.Qb.Fa())var h=-1+a.Qb.Fa()|0,h=a.Qb.Vj(h);else h=32;var n=0<(b.length|0)?65535&(b.charCodeAt(0)|0):32;a=GH(Dj(),h)&&GH(Dj(),n);c=HH(Dj(),c)&&95===h&&GH(Dj(),n);return a||c?X().N(" "+b):X().N(b)}}(a,b)))}
function NG(a,b,c,d,f){c=qG(a).N(c);if(IH(c)){var g=c.Ve,h=c.Bf,n;if(n=!!(g&&g.$classData&&g.$classData.H.Pf)){n=b.pf();var u=g.pf();gia(n,u).Tg()?n=(new q).a(!0,F()):(G(),n=(new r).d(["og.categories.intersect[String](ig.categories).nonEmpty is false"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(d=n.p(),!1===I(n))){f=J();c=[(new q).a("og",b),(new q).a("ig",g)];h=A(new B,C());b=0;for(g=c.length|0;b<g;)E(h,c[b]),b=1+b|0;K(f,"og.categories.intersect[String](ig.categories).nonEmpty",
d,h.t)}throw(new p).e(n);}a:{if(JH(b)&&(n=hia(TG(PG(MG(a))),b),!n.g()&&(n=n.q(),JH(g)&&(u=hia(TG(PG(MG(a))),g),!u.g())))){b=u.q();d=AG(n,b,!0,d,f);break a}if(KH(b)&&(n=iia(eH(bH(MG(a))),b),!n.g()&&(n=n.q(),KH(g)&&(u=iia(eH(bH(MG(a))),g),!u.g())))){b=u.q();d=AG(n,b,!1,d,f);break a}if(LH(b)&&(n=jia(pH(mH(MG(a))),b),!n.g()&&(n=n.q(),LH(g)&&(a=jia(pH(mH(MG(a))),g),!a.g())))){b=a.q();d=AG(n,b,!0,d,f);break a}d=b.zf()>g.zf()}n=d}if(n)return(new LF).X((new r).d([X().N("("),h,X().N(")")]))}return c}
function Rha(a){"this"!==a.ec()?(MH||(MH=(new NH).c()),a=MH.KB.Ac(a.ec())?!0:-1!==(a.ec().indexOf(" ")|0)):a=!1;return a}function $G(a){return(new PF).te(lk(function(a){return function(c){return cj(c)?WF(VF(),c," ",qG(a)):xG()}}(a)))}rG.prototype.$classData=l({EY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$",{EY:1,f:1});function OH(){this.gd=null;this.oA=this.nA=!1}OH.prototype=new m;OH.prototype.constructor=OH;
function Nha(a){return a.nA?(a=(new cd).j(a.gd),a=Hd(a),58!==(null===a?0:a.pa)):!0}function BG(a,b){var c=new OH;c.gd=a;c.nA=!0;c.oA=b;return c}OH.prototype.cl=function(){if(this.oA){var a=Cu(Du(),this.gd);return eh(a).cl()}return 0};OH.prototype.$classData=l({fZ:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$XtensionMySyntacticInfo$2",{fZ:1,f:1});function PH(){}PH.prototype=new m;PH.prototype.constructor=PH;PH.prototype.c=function(){return this};
function to(a,b){a=!1;var c=mG(b);a:{if(nG(c)){var d=oG(pG(),c);if(!d.g()){a=d.q().qb;break a}}if(kia()===c&&(a=!0,Ke(b))){wk();d=wk().Rb;ke(d)?(G(),a=(new r).d(["underlying.allowUnquotes.`unary_!` is true"]),c=G().b,a=(new q).a(!1,H(a,c))):a=(new q).a(!0,F());if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){for(var c=J(),d=[(new q).a("underlying",d)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"underlying.allowUnquotes.`unary_!`",b,f.t)}throw(new p).e(a);}a=Is(d.Ig,d.rg,d.dh,
d.kg,d.Jg,d.eh,d.fh,d.Rh,d.Sh,d.Bh,!0,!0,d.Kg,d.Ch,d.Lg,!0,d.hh,d.Dh,d.sg,!0,d.tg,d.Mg,d.cf,d.th);break a}if(a)a=wk().Rb;else throw(new p).e(c);}a=tg().If(a).N(b).v();return Ke(b)?a:Gn(b)&&!(null===b?S():(new T).e((new yi).sd(b.Qa(),b.xb(),b.bd()))).g()?td((new yd).X((new r).d(["def this",""])),(new r).d([a])):a}PH.prototype.$classData=l({gZ:0},!1,"scala.meta.internal.prettyprinters.TreeToString$",{gZ:1,f:1});var QH=void 0;function uo(){QH||(QH=(new PH).c());return QH}function RH(){}
RH.prototype=new m;RH.prototype.constructor=RH;RH.prototype.c=function(){return this};
function bG(a,b,c){a=(new ql).j(c.v());var d=cia();if(null!==c&&c===d)rl(a,b);else{b=(new cd).j(b);for(var d=0,f=b.ka.length|0;d<f;){var g=b.rc(d),g=null===g?0:g.pa;a:{switch(g){case 9:rl(a,"\\t");break a;case 8:rl(a,"\\b");break a;case 10:rl(a,"\\n");break a;case 13:rl(a,"\\r");break a;case 12:rl(a,"\\f");break a;case 92:rl(a,"\\\\");break a;case 34:if(c===dG()){rl(a,'\\"');break a}break;case 39:if(c===bia()){rl(a,"\\'");break a}}SH(a,g)}d=1+d|0}}rl(a,c.v());return a.Qb.ac}
RH.prototype.$classData=l({iZ:0},!1,"scala.meta.internal.prettyprinters.enquote$",{iZ:1,f:1});var TH=void 0;function cG(){TH||(TH=(new RH).c());return TH}function UH(){this.bt=this.et=null}UH.prototype=new m;UH.prototype.constructor=UH;
UH.prototype.c=function(){VH=this;var a=(new r).d([(new ed).db(92),(new ed).db(117),(new ed).db(0),(new ed).db(0),(new ed).db(0),(new ed).db(0)]),b=a.Da.length|0,b=oa(bc(jc),[b]),c;c=0;for(a=Cp(new Dp,a,a.Da.length|0);a.fb();){var d=a.bb();b.i[c]=null===d?0:d.pa;c=1+c|0}b=[(new ed).db(36),(new ed).db(95)];if(0===(b.length|0))b=id();else{c=kd(new ld,id());a=0;for(d=b.length|0;a<d;)md(c,b[a]),a=1+a|0;b=c.t}this.et=b;b=[2,1,5,3,10];if(0===(b.length|0))b=id();else{c=kd(new ld,id());a=0;for(d=b.length|
0;a<d;)md(c,b[a]),a=1+a|0;b=c.t}this.bt=b;return this};UH.prototype.Rs=function(a){switch(WH(qi(),a)<<24>>24){case 2:case 1:case 5:case 3:case 10:return!0;default:return 95===a}};function Cj(a,b,c){a=57>=b?-48+b|0:97<=b&&122>=b?-87+b|0:65<=b&&90>=b?-55+b|0:-1;return 0<=a&&a<c?a:-1}function GH(a,b){switch(b){case 126:case 33:case 64:case 35:case 37:case 94:case 42:case 43:case 45:case 60:case 62:case 63:case 58:case 61:case 38:case 124:case 47:case 92:return!0;default:return XH(0,b)}}
function HH(a,b){return 36===b?!0:YH(qi(),b)}function XH(a,b){a=WH(qi(),b);return 25===a||28===a}function lia(a,b){return 95===b||36===b?!0:ZH(qi(),b)}UH.prototype.$classData=l({lZ:0},!1,"scala.meta.internal.tokenizers.Chars$",{lZ:1,f:1});var VH=void 0;function Dj(){VH||(VH=(new UH).c());return VH}function $H(){this.ha=this.gC=this.ue=this.Ta=this.Tc=this.Q=this.u=null;this.jn=0;this.En=this.jd=this.Nc=null}$H.prototype=new m;$H.prototype.constructor=$H;
function mia(a){switch(a.ha.Ha){case 101:case 69:case 102:case 70:case 100:case 68:return!0;default:return!1}}function nia(a){if(!a.En.Ac(a.Ta.La))throw(new t).j("requirement failed: must be at the start of an xml literal part");var b=a.En.Ea(a.Ta.La);if(null===b)throw(new p).e(b);var c=b.Wx();oia(a,1E3,-1+b.Xa()|0);c&&a.ue.Rc(1001);a.En.lC(a.Ta.La)}
function pia(a){a:for(;;){b:{switch(a.ha.Ha){case 47:var b=a;aI(b.ha);42===b.ha.Ha&&(aI(b.ha),b.jn=1+b.jn|0);continue a;case 42:if(b=a,aI(b.ha),47===b.ha.Ha?(aI(b.ha),b.jn=-1+b.jn|0,b=0===b.jn):b=!1,b)break b;else continue a;case 26:Gj(a.Tc,"unclosed comment",a.Ta.La);break;case 36:bI(a)||bj(a.Tc,"can't unquote into multi-line comments",-1+a.ha.kc|0)}aI(a.ha);continue a}break}}
function cI(a,b){a:for(;;){if(34===a.ha.Ha)if(b)if(dI(a.ha),qia(a))eI(a),a.Ta.Rc(6);else continue a;else aI(a.ha),eI(a),a.Ta.Rc(6);else if(36===a.ha.Ha)if(bI(a))if(dI(a.ha),36===a.ha.Ha){SH(a.Nc,a.ha.Ha);dI(a.ha);continue a}else if(123===a.ha.Ha)fI(a),a.Ta.ri(-3+a.ha.kc|0),dI(a.ha),a.ue.Rc(104);else if(95===a.ha.Ha&&a.Q.Lg)fI(a),a.Ta.ri(-3+a.ha.kc|0),dI(a.ha),a.ue.Rc(131);else if(ZH(qi(),a.ha.Ha)){fI(a);for(a.Ta.ri(-3+a.ha.kc|0);SH(a.Nc,a.ha.Ha),dI(a.ha),26!==a.ha.Ha&&YH(qi(),a.ha.Ha););a.ue.Rc(10);
a.ue.cn(a.Nc.Qb.ac);gI(a.Nc.Qb);hI().eq.Ac(a.ue.oa())&&(a.ue.Rc(hI().eq.Ea(a.ue.oa())|0),75!==a.ue.Pb||a.Q.Jg||a.ue.Rc(10),10!==a.ue.Pb&&21!==a.ue.Pb&&bj(a.Tc,"invalid unquote: `$'ident, `$'BlockExpr, `$'this or `$'_ expected",a.Ta.La))}else{G();b=(new r).d(["`$$'","`$'ident","`$'this","`$'BlockExpr"]);var c=G().b;b=H(b,c);a.Q.Lg&&(c=G().b,b=Fw(b,"`$'_",c));b=""+oD(b).Pd(", ")+cl(b);bj(a.Tc,b,a.Ta.La)}else bj(a.Tc,"can't unquote into string interpolations",-1+a.ha.kc|0);else if(ria(a.ha)||26!==a.ha.Ha&&
(b||13!==a.ha.Ha&&10!==a.ha.Ha)){SH(a.Nc,a.ha.Ha);dI(a.ha);continue a}else b?Gj(a.Tc,"unclosed multi-line string interpolation",a.Ta.La):bj(a.Tc,"unclosed string interpolation",a.Ta.La);break}}
function iI(a){a:for(;;){switch(a.ha.Ha){case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 36:case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:case 105:case 106:case 107:case 108:case 109:case 110:case 111:case 112:case 113:case 114:case 115:case 116:case 117:case 118:case 119:case 120:case 121:case 122:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:if(36===a.ha.Ha&&
!bI(a)){jI(a,10);return}SH(a.Nc,a.ha.Ha);aI(a.ha);continue a;case 95:SH(a.Nc,a.ha.Ha);aI(a.ha);if(HH(Dj(),a.ha.Ha))iI(a);else switch(a.ha.Ha){case 126:case 33:case 64:case 35:case 37:case 94:case 42:case 43:case 45:case 60:case 62:case 63:case 58:case 61:case 38:case 124:case 92:case 47:kI(a);break;default:XH(Dj(),a.ha.Ha)?kI(a):jI(a,10)}break;case 26:jI(a,10);break;default:if(YH(qi(),a.ha.Ha)){SH(a.Nc,a.ha.Ha);aI(a.ha);continue a}else jI(a,10)}break}}
function lI(a){HH(Dj(),a.ha.Ha)&&32<=a.ha.Ha&&bj(a.Tc,"Invalid literal number",a.Ta.La)}function jI(a,b){a.Ta.cn(a.Nc.Qb.ac);gI(a.Nc.Qb);a.Ta.Rc(b);10===b&&hI().eq.Ac(a.Ta.oa())&&(a.Ta.Rc(hI().eq.Ea(a.Ta.oa())|0),10===a.Ta.Pb&&(b=a.Tc,td((new yd).X((new r).d([""," is now a reserved word; usage as an identifier is deprecated"])),(new r).d([a.Ta.oa()])),Hj(Ij(b,a.Ta.Pb))),75!==a.Ta.Pb||a.Q.Jg||a.Ta.Rc(10))}$H.prototype.v=function(){return""+this.Ta.Pb};
function mI(a){return nI(a)&&a.jd.o().Tg()&&7===(a.jd.o().n()|0)}
function oI(a){var b=a.Ta.Pb;switch(b){case 100:a.jd=U(new V,101,a.jd);break;case 102:a.jd=U(new V,103,a.jd);break;case 104:a.jd=U(new V,105,a.jd);break;case 96:a.jd=U(new V,132,a.jd);break;case 105:for(;!a.jd.g()&&105!==(a.jd.n()|0);)a.jd=a.jd.o();a.jd.g()||(a.jd=a.jd.o());break;case 103:case 101:a.jd.g()||(a.jd.n()|0)!==b||(a.jd=a.jd.o());break;case 132:a.jd.g()||(a.jd.n()|0)!==b||(a.jd=a.jd.o());break;case 6:mI(a)?a.jd=a.jd.o().o():nI(a)&&(a.jd=a.jd.o())}if(-3===a.ue.Pb){a.Ta.Ll(-1+a.ha.kc|0);
0<a.Ta.Zi&&10===a.ha.Jf.i[a.Ta.Zi]&&13===a.ha.Jf.i[-1+a.Ta.Zi|0]&&a.Ta.Ll(-1+a.Ta.Zi|0);a.Ta.ck(-1+a.ha.kc|0);if(nI(a))cI(a,mI(a));else if(a.En.Ac(a.Ta.La))nia(a);else switch(a.ha.Ha){case 32:case 9:case 13:case 10:case 12:a.Ta.Rc(201);a.Ta.Cj(ca.String.fromCharCode(a.ha.Ha));aI(a.ha);break;case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 36:case 95:case 97:case 98:case 99:case 100:case 101:case 102:case 103:case 104:case 105:case 106:case 107:case 108:case 109:case 110:case 111:case 112:case 113:case 114:case 115:case 116:case 117:case 118:case 119:case 120:case 121:case 122:if(36!==
a.ha.Ha||bI(a))SH(a.Nc,a.ha.Ha),aI(a.ha),iI(a),34===a.ha.Ha&&10===a.Ta.Pb&&a.Ta.Rc(9);else{pI(To(),36===a.ha.Ha);b=a.ha.kc;pC();var c=a.u,d=a.u.od().i.length,c=(new qC).ib(c,b,d),d=Is(a.Q.Ig,a.Q.rg,a.Q.dh,a.Q.kg,a.Q.Jg,a.Q.eh,a.Q.fh,a.Q.Rh,a.Q.Sh,a.Q.Bh,a.Q.gh,!0,a.Q.Kg,!1,a.Q.Lg,!1,a.Q.hh,a.Q.Dh,a.Q.sg,a.Q.Eh,a.Q.tg,a.Q.Mg,a.Q.cf,a.Q.th),c=(new $H).pj(c,d);aI(c.ha);oI(c);switch(c.Ta.Pb){case 104:try{a:for(d=1;;){oI(c);switch(c.Ta.Pb){case 104:d=1+d|0;continue a;case 105:if(1!==d){d=-1+d|0;continue a}break;
default:continue a}break}}catch(N){c=vj(wj(),N);if(null!==c){if(tC(c)){var f=uC(vC(),c);f.g()||(d=f.q().qa(),f=f.q().p(),a=a.Tc,f=td((new yd).X((new r).d(["invalid unquote: ",""])),(new r).d([f])),b=b+d.ab()|0,bj(a,f,b))}throw jo(wj(),c);}throw N;}break;case 10:case 21:case 131:break;default:bj(a.Tc,"invalid unquote: `$'ident, `$'BlockExpr, `$'this or `$'_ expected",b)}oia(a,400,b+c.Ta.Ic|0)}break;case 60:b=2<=a.ha.kc?a.ha.Jf.i[-2+a.ha.kc|0]:32;aI(a.ha);a:{switch(b){case 32:case 9:case 10:case 123:case 40:case 62:if(Dj().Rs(a.ha.Ha)||
33===a.ha.Ha||63===a.ha.Ha){if(a.Q.cf){d=a.Ta.La;b=(new qI).Ev(a.Q);c=sia(b).Vz;f=a.u;Ga();f=f.od();f=kr(0,f,0,f.i.length);c=c.Dd(tia(new rI,(new sI).Tp(f,c.Af),-1,c,d,null),d).Lx();if(!(c&&c.$classData&&c.$classData.H.wu))throw c&&c.$classData&&c.$classData.H.vu&&(b=c.va,a=a.Tc,d=(new yd).X((new r).d(["malformed xml literal, expected: ",""])),f=c.zl,f=f.ra?f.Mx:uia(f),d=td(d,(new r).d([via(f).v()])),bj(a,d,b)),(new p).e(c);c=c.va;for(b=b.fu.da();!b.g();)f=b.n(),a.En.gm(d,wia(-1+f.Vn|0,!1)),d=1+f.No|
0,b=b.o();a.En.gm(d,wia(c,!0));nia(a)}else bj(a.Tc,"xml literals are not supported",a.Ta.La);break a}}SH(a.Nc,60);kI(a)}break;case 126:case 33:case 64:case 35:case 37:case 94:case 42:case 43:case 45:case 62:case 63:case 58:case 61:case 38:case 124:case 92:SH(a.Nc,a.ha.Ha);aI(a.ha);kI(a);break;case 47:aI(a.ha);a:switch(a.ha.Ha){case 47:case 42:b=47===a.ha.Ha;aI(a.ha);if(b)b:for(;;){c:{switch(a.ha.Ha){case 26:case 13:case 10:break c;case 36:bI(a)||bj(a.Tc,"can't unquote into single-line comments",-1+
a.ha.kc|0)}aI(a.ha);continue b}break}else a.jn=1,42!==a.ha.Ha||(aI(a.ha),0)?pia(a):47===a.ha.Ha?aI(a.ha):pia(a);b=!0;break a;default:b=!1}b?a.Ta.Rc(300):(SH(a.Nc,47),kI(a));break;case 48:SH(a.Nc,a.ha.Ha);aI(a.ha);120===a.ha.Ha||88===a.ha.Ha?(SH(a.Nc,a.ha.Ha),aI(a.ha),a.Ta.uk(16)):a.Ta.uk(8);xia(a);break;case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:a.Ta.uk(10);xia(a);break;case 96:aI(a.ha);yia(a,96);96===a.ha.Ha?(aI(a.ha),jI(a,11),0===(a.Ta.oa().length|0)&&bj(a.Tc,"empty quoted identifier",
a.Ta.La)):36===a.ha.Ha?bj(a.Tc,"can't unquote into quoted identifiers",-1+a.ha.kc|0):bj(a.Tc,"unclosed quoted identifier",a.Ta.La);break;case 34:if(9===a.Ta.Pb)dI(a.ha),34===a.ha.Ha?(b=tI(a.ha),aI(b),34===b.Ha?(dI(a.ha),a.Ta.ck(3+a.Ta.La|0),dI(a.ha),cI(a,!0),a.jd=U(new V,7,a.jd),a.jd=U(new V,6,a.jd)):(aI(a.ha),a.Ta.Rc(6),a.Ta.Cj(""))):(a.Ta.ck(1+a.Ta.La|0),cI(a,!1),a.jd=U(new V,6,a.jd));else if(aI(a.ha),34===a.ha.Ha)if(aI(a.ha),34===a.ha.Ha)a:for(dI(a.ha);;){if(34===a.ha.Ha)if(dI(a.ha),qia(a))eI(a),
a.Ta.Rc(6);else continue a;else if(26===a.ha.Ha)Gj(a.Tc,"unclosed multi-line string literal",a.Ta.La);else if(36!==a.ha.Ha||bI(a)){SH(a.Nc,a.ha.Ha);dI(a.ha);continue a}else bj(a.Tc,"can't unquote into string literals",-1+a.ha.kc|0);break}else a.Ta.Rc(6),a.Ta.Cj("");else yia(a,34),34===a.ha.Ha?(eI(a),aI(a.ha),a.Ta.Rc(6)):36===a.ha.Ha?bj(a.Tc,"can't unquote into string literals",-1+a.ha.kc|0):bj(a.Tc,"unclosed string literal",a.Ta.La);break;case 39:aI(a.ha);36!==a.ha.Ha||bI(a)?lia(Dj(),a.ha.Ha)?(SH(a.Nc,
a.ha.Ha),aI(a.ha),39===a.ha.Ha?(aI(a.ha),a.Ta.Rc(1),eI(a)):(iI(a),a.Ta.Rc(8),a.Ta.Cj(a.Ta.oa()))):GH(Dj(),a.ha.Ha)&&92!==a.ha.Ha?(SH(a.Nc,a.ha.Ha),aI(a.ha),39===a.ha.Ha?(aI(a.ha),a.Ta.Rc(1),eI(a)):(kI(a),a.Ta.Rc(8),a.Ta.Cj(a.Ta.oa()))):(zia(a),39===a.ha.Ha?(aI(a.ha),a.Ta.Rc(1),eI(a)):bj(a.Tc,"unclosed character literal",a.Ta.La)):bj(a.Tc,"can't unquote into character literals",-1+a.ha.kc|0);break;case 46:aI(a.ha);if(48<=a.ha.Ha&&57>=a.ha.Ha)SH(a.Nc,46),uI(a);else if(ke(a.Q)&&46===a.ha.Ha){for(a.Ta.uk(0);46===
a.ha.Ha;)a.Ta.uk(1+a.Ta.He|0),aI(a.ha);a.Ta.Rc(401)}else a.Ta.Rc(122);break;case 59:aI(a.ha);a.Ta.Rc(121);break;case 44:aI(a.ha);a.Ta.Rc(120);break;case 40:aI(a.ha);a.Ta.Rc(100);break;case 123:aI(a.ha);a.Ta.Rc(104);break;case 41:aI(a.ha);a.Ta.Rc(101);break;case 125:b=1+a.ha.kc|0;aI(a.ha);a.Ta.Rc(105);b<a.ha.Jf.i.length&&(a.ha.kc=b);break;case 91:aI(a.ha);a.Ta.Rc(102);break;case 93:aI(a.ha);a.Ta.Rc(103);break;case 26:a.ha.kc>=a.ha.Jf.i.length?(a.Ta.ck(a.u.od().i.length),a.Ta.Rc(0)):bj(a.Tc,"illegal character",
a.Ta.La);break;default:if(8658===a.ha.Ha)aI(a.ha),a.Ta.Rc(132);else if(8592===a.ha.Ha)aI(a.ha),a.Ta.Rc(133);else if(ZH(qi(),a.ha.Ha))SH(a.Nc,a.ha.Ha),aI(a.ha),iI(a);else if(XH(Dj(),a.ha.Ha))SH(a.Nc,a.ha.Ha),aI(a.ha),kI(a);else{var b=a.Tc,c=(new ed).db(92),d=(new ed).db(117),f=(new cd).j("%04x"),g=[a.ha.Ha];Ga();f=f.ka;Xo();pl();for(var h=[],n=0,u=g.length|0;n<u;)h.push(vI(g[n])),n=1+n|0;wI();for(var g=h.length|0,g=oa(bc(Ab),[g]),w=g.i.length,u=n=0,D=h.length|0,w=D<w?D:w,D=g.i.length,w=w<D?w:D;n<w;)g.i[u]=
h[n],n=1+n|0,u=1+u|0;c="illegal character '"+(""+c+d)+xI(f,g)+"'";bj(b,c,a.Ta.La)}}-1===a.Ta.Pb&&(mI(a)?a.jd=a.jd.o().o():nI(a)&&(a.jd=a.jd.o()))}else kba(a.Ta,a.ue),a.ue.Rc(-3);7!==a.Ta.Pb&&(a.Ta.ri(-2+a.ha.kc|0),a.ha.kc>=a.ha.Jf.i.length&&26===a.ha.Ha&&a.Ta.ri(-1+a.ha.Jf.i.length|0))}
function zia(a){if(92===a.ha.Ha)if(aI(a.ha),48<=a.ha.Ha&&55>=a.ha.Ha){var b=-2+a.ha.kc|0,c=a.ha.Ha,d=Cj(Dj(),a.ha.Ha,8);aI(a.ha);48<=a.ha.Ha&&55>=a.ha.Ha&&(d=(d<<3)+Cj(Dj(),a.ha.Ha,8)|0,aI(a.ha),51>=c&&48<=a.ha.Ha&&55>=a.ha.Ha&&(d=(d<<3)+Cj(Dj(),a.ha.Ha,8)|0,aI(a.ha)));if(10===d)c="\\n";else{var c=(new cd).j("\\u%04x"),f=[d];Ga();c=c.ka;Xo();pl();for(var g=[],h=0,n=f.length|0;h<n;)g.push(vI(f[h])),h=1+h|0;wI();for(var f=g.length|0,f=oa(bc(Ab),[f]),u=f.i.length,n=h=0,w=g.length|0,u=w<u?w:u,w=f.i.length,
u=u<w?u:w;h<u;)f.i[n]=g[h],h=1+h|0,n=1+n|0;c=xI(c,f)}g=a.Tc;td((new yd).X((new r).d(["Octal escape literals are ",", use "," instead."])),(new r).d(["deprecated",c]));Hj(Ij(g,b));SH(a.Nc,65535&d)}else{switch(a.ha.Ha){case 98:SH(a.Nc,8);break;case 116:SH(a.Nc,9);break;case 110:SH(a.Nc,10);break;case 102:SH(a.Nc,12);break;case 114:SH(a.Nc,13);break;case 34:SH(a.Nc,34);break;case 39:SH(a.Nc,39);break;case 92:SH(a.Nc,92);break;default:bj(a.Tc,"invalid escape character",-1+a.ha.kc|0)}aI(a.ha)}else if(36!==
a.ha.Ha||bI(a))SH(a.Nc,a.ha.Ha),aI(a.ha)}function yia(a,b){for(;!(a.ha.kc>=a.ha.Jf.i.length||a.ha.Ha===b||(26===a.ha.Ha||13===a.ha.Ha||10===a.ha.Ha)&&!ria(a.ha)||36===a.ha.Ha&&!bI(a));)zia(a)}function fI(a){eI(a);a.Ta.Rc(7);a.ue.Ll(-1+a.ha.kc|0);a.ue.ck(-1+a.ha.kc|0)}function eI(a){a.Ta.Cj(a.Nc.Qb.ac);gI(a.Nc.Qb)}
function xia(a){var b=10>a.Ta.He?10:a.Ta.He,c;for(c=!1;0<=Cj(Dj(),a.ha.Ha,b);)SH(a.Nc,a.ha.Ha),aI(a.ha),c=!0;a.Ta.Rc(2);if(10<a.Ta.He||46!==a.ha.Ha)10>=a.Ta.He&&mia(a)?uI(a):(8===a.Ta.He&&c&&bj(a.Tc,"Non-zero integral values may not have a leading zero.",a.Ta.La),Aia(a)?(SH(a.Nc,a.ha.Ha),eI(a),aI(a.ha),a.Ta.Rc(3)):(eI(a),lI(a)));else{var b=tI(a.ha),d=yI(b);if(aj(qi(),d)){switch(d){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:b=!0;break;case 96:eI(a);return;case 100:case 68:case 102:case 70:b=
!HH(Dj(),yI(b));break;case 101:case 69:b=yI(b);b=HH(Dj(),b)?aj(qi(),b)||43===b?!0:45===b:!0;break;default:b=!lia(Dj(),d)}b?(SH(a.Nc,a.ha.Ha),aI(a.ha),uI(a)):10>=a.Ta.He&&mia(a)?uI(a):(8===a.Ta.He&&c&&bj(a.Tc,"Non-zero integral values may not have a leading zero.",a.Ta.La),Aia(a)?(SH(a.Nc,a.ha.Ha),eI(a),aI(a.ha),a.Ta.Rc(3)):(eI(a),lI(a)))}else eI(a)}}function bI(a){if(ke(a.Q)){var b=tI(a.ha);aI(b);if(36===b.Ha)aI(a.ha);else return!1}return!0}
function qia(a){if(34===a.ha.Ha){dI(a.ha);if(34===a.ha.Ha){for(aI(a.ha);34===a.ha.Ha;)SH(a.Nc,34),aI(a.ha);return!0}SH(a.Nc,34);SH(a.Nc,34);return!1}SH(a.Nc,34);return!1}$H.prototype.pj=function(a,b){this.u=a;this.Q=b;this.Tc=(new zI).Gm(a);this.Ta=(new AI).Xp(this);this.ue=(new BI).Xp(this);this.gC=(new CI).Xp(this);this.ha=(new DI).bB(a,b,this.Tc);this.Ta.El(a);this.ue.El(a);this.gC.El(a);this.jn=0;this.Nc=(new ql).c();this.jd=F();this.En=(new Qq).c();return this};
function uI(a){for(a.Ta.Rc(5);48<=a.ha.Ha&&57>=a.ha.Ha;)SH(a.Nc,a.ha.Ha),aI(a.ha);if(101===a.ha.Ha||69===a.ha.Ha){var b=tI(a.ha);aI(b);43!==b.Ha&&45!==b.Ha||aI(b);if(48<=b.Ha&&57>=b.Ha){SH(a.Nc,a.ha.Ha);aI(a.ha);if(43===a.ha.Ha||45===a.ha.Ha)SH(a.Nc,a.ha.Ha),aI(a.ha);for(;48<=a.ha.Ha&&57>=a.ha.Ha;)SH(a.Nc,a.ha.Ha),aI(a.ha)}a.Ta.Rc(5)}if(100===a.ha.Ha||68===a.ha.Ha)SH(a.Nc,a.ha.Ha),aI(a.ha),a.Ta.Rc(5);else if(102===a.ha.Ha||70===a.ha.Ha)SH(a.Nc,a.ha.Ha),aI(a.ha),a.Ta.Rc(4);lI(a);eI(a)}
function nI(a){return cj(a.jd)?6===(a.jd.n()|0):!1}function oia(a,b,c){var d=a.Ta.La;a.Ta.Rc(b);a.Ta.Cj(kr(Ga(),a.u.od(),d,1+(c-d|0)|0));a.Ta.ri(c);a.ha.kc=1+c|0;aI(a.ha)}
function kI(a){a:for(;;){switch(a.ha.Ha){case 126:case 33:case 64:case 35:case 37:case 94:case 42:case 43:case 45:case 60:case 62:case 63:case 58:case 61:case 38:case 124:case 92:SH(a.Nc,a.ha.Ha);aI(a.ha);continue a;case 47:var b=tI(a.ha);aI(b);if(47===b.Ha||42===b.Ha)jI(a,10);else{SH(a.Nc,47);aI(a.ha);continue a}break;default:if(XH(Dj(),a.ha.Ha)){SH(a.Nc,a.ha.Ha);aI(a.ha);continue a}else jI(a,10)}break}}function Aia(a){switch(a.ha.Ha){case 108:case 76:return!0;default:return!1}}
$H.prototype.$classData=l({mZ:0},!1,"scala.meta.internal.tokenizers.LegacyScanner",{mZ:1,f:1});function EI(){this.eq=null}EI.prototype=new m;EI.prototype.constructor=EI;
EI.prototype.c=function(){FI=this;for(var a=[(new q).a("abstract",46),(new q).a("case",96),(new q).a("catch",92),(new q).a("class",62),(new q).a("def",72),(new q).a("do",84),(new q).a("else",82),(new q).a("extends",68),(new q).a("false",26),(new q).a("final",49),(new q).a("finally",93),(new q).a("for",85),(new q).a("forSome",71),(new q).a("if",80),(new q).a("implicit",40),(new q).a("import",61),(new q).a("lazy",55),(new q).a("match",95),(new q).a("new",20),(new q).a("null",24),(new q).a("object",
64),(new q).a("override",41),(new q).a("package",60),(new q).a("private",44),(new q).a("protected",43),(new q).a("return",97),(new q).a("sealed",45),(new q).a("super",23),(new q).a("this",21),(new q).a("throw",90),(new q).a("trait",66),(new q).a("true",25),(new q).a("try",91),(new q).a("type",70),(new q).a("val",73),(new q).a("var",74),(new q).a("while",83),(new q).a("with",69),(new q).a("yield",86),(new q).a(".",122),(new q).a("_",131),(new q).a(":",123),(new q).a("\x3d",124),(new q).a("\x3d\x3e",
132),(new q).a("\x3c-",133),(new q).a("\x3c:",134),(new q).a("\x3c%",136),(new q).a("\x3e:",135),(new q).a("#",130),(new q).a("@",125),(new q).a("macro",57),(new q).a("then",10),(new q).a("enum",75)],b=A(new B,C()),c=0,d=a.length|0;c<d;)E(b,a[c]),c=1+c|0;this.eq=b.t;return this};EI.prototype.$classData=l({qZ:0},!1,"scala.meta.internal.tokenizers.LegacyToken$",{qZ:1,f:1});var FI=void 0;function hI(){FI||(FI=(new EI).c());return FI}function GI(){this.lw=this.kq=null}GI.prototype=new m;
GI.prototype.constructor=GI;GI.prototype.c=function(){HI=this;this.kq=(new II).c();this.lw=(new Jd).c();return this};GI.prototype.$classData=l({rZ:0},!1,"scala.meta.internal.tokenizers.PlatformTokenizerCache$",{rZ:1,f:1});var HI=void 0;function JI(){HI||(HI=(new GI).c());return HI}function KI(){this.La=0;this.r=null}KI.prototype=new m;KI.prototype.constructor=KI;function Hj(a){Ls();return(new Ms).ib(a.r.jA,a.La,a.La)}
function Ij(a,b){var c=new KI;c.La=b;if(null===a)throw jo(wj(),null);c.r=a;return c}KI.prototype.$classData=l({tZ:0},!1,"scala.meta.internal.tokenizers.Reporter$XtensionOffsetPosition",{tZ:1,f:1});function LI(){this.Q=this.u=null}LI.prototype=new m;LI.prototype.constructor=LI;function MI(a,b,c,d){c.ba((new NI).Lf(a.u,a.Q,b,b+d|0))}function OI(a,b,c,d){c.ba((new PI).Lf(a.u,a.Q,b,b+d|0))}function QI(a,b,c){c.ba((new RI).Lf(a.u,a.Q,b,b))}function SI(a,b,c){c.ba((new TI).Lf(a.u,a.Q,b,1+b|0))}
function UI(a,b){var c=b.Pb;switch(c){case 10:return(new VI).Rg(a.u,a.Q,b.La,1+b.Ic|0,b.oa());case 11:return(new VI).Rg(a.u,a.Q,b.La,1+b.Ic|0,b.oa());case 2:var d=a.u,f=a.Q,g=b.La,h=1+b.Ic|0,n=nba(b);return(new WI).Cv(d,f,g,h,n);case 3:var u=a.u,w=a.Q,D=b.La,N=1+b.Ic|0,Q=nba(b);return(new XI).Cv(u,w,D,N,Q);case 4:var ea=a.u,ba=a.Q,ma=b.La,La=1+b.Ic|0,Pa=lba(b);return(new YI).Bv(ea,ba,ma,La,Pa);case 5:var Qa=a.u,Ka=a.Q,Ba=b.La,va=1+b.Ic|0,za=lba(b);return(new ZI).Bv(Qa,Ka,Ba,va,za);case 1:var qa=a.u,
la=a.Q,Ma=b.La,Ea=1+b.Ic|0,tb=0<(b.Hd.length|0)?65535&(b.Hd.charCodeAt(0)|0):0,Za=new $I;Za.u=qa;Za.Q=la;Za.E=Ma;Za.Ca=Ea;Za.pa=tb;if(null!==qa)var eb=(new q).a(!0,F());else{G();var kb=(new r).d(["this.input is equal to null"]),Pb=G().b,eb=(new q).a(!1,H(kb,Pb))}if(null===eb||!0!==I(eb)){if(null!==eb){var Na=eb.p();if(!1===I(eb)){for(var sb=J(),yb=[(new q).a("Char",Za)],sc=A(new B,C()),Ra=0,wc=yb.length|0;Ra<wc;)E(sc,yb[Ra]),Ra=1+Ra|0;K(sb,"this.input.!\x3d(null)",Na,sc.t)}}throw(new p).e(eb);}if(null!==
la)var Wb=(new q).a(!0,F());else{G();var Rb=(new r).d(["this.dialect is equal to null"]),ub=G().b,Wb=(new q).a(!1,H(Rb,ub))}if(null===Wb||!0!==I(Wb)){if(null!==Wb){var fb=Wb.p();if(!1===I(Wb)){for(var Xb=J(),lb=[(new q).a("Char",Za)],Eb=A(new B,C()),xc=0,gb=lb.length|0;xc<gb;)E(Eb,lb[xc]),xc=1+xc|0;K(Xb,"this.dialect.!\x3d(null)",fb,Eb.t)}}throw(new p).e(Wb);}return Za;case 8:var dc=a.u,Fc=a.Q,Qb=b.La,Bb=1+b.Ic|0;aJ||(aJ=(new bJ).c());var Ib=$r.prototype.Tu.call(aJ,b.Hd),mb=new eJ;mb.u=dc;mb.Q=Fc;
mb.E=Qb;mb.Ca=Bb;mb.pa=Ib;if(null!==dc)var Cb=(new q).a(!0,F());else{G();var Tb=(new r).d(["this.input is equal to null"]),mc=G().b,Cb=(new q).a(!1,H(Tb,mc))}if(null===Cb||!0!==I(Cb)){if(null!==Cb){var Ac=Cb.p();if(!1===I(Cb)){for(var Dc=J(),Db=[(new q).a("Symbol",mb)],Va=A(new B,C()),ec=0,$a=Db.length|0;ec<$a;)E(Va,Db[ec]),ec=1+ec|0;K(Dc,"this.input.!\x3d(null)",Ac,Va.t)}}throw(new p).e(Cb);}if(null!==Fc)var vb=(new q).a(!0,F());else{G();var fc=(new r).d(["this.dialect is equal to null"]),Bc=G().b,
vb=(new q).a(!1,H(fc,Bc))}if(null===vb||!0!==I(vb)){if(null!==vb){var Ub=vb.p();if(!1===I(vb)){for(var Vb=J(),wb=[(new q).a("Symbol",mb)],xb=A(new B,C()),Xa=0,tc=wb.length|0;Xa<tc;)E(xb,wb[Xa]),Xa=1+Xa|0;K(Vb,"this.dialect.!\x3d(null)",Ub,xb.t)}}throw(new p).e(vb);}if(null!==Ib)var ib=(new q).a(!0,F());else{G();var zb=(new r).d(["this.value is equal to null"]),nb=G().b,ib=(new q).a(!1,H(zb,nb))}if(null===ib||!0!==I(ib)){if(null!==ib){var Jb=ib.p();if(!1===I(ib)){for(var jb=J(),ob=[(new q).a("Symbol",
mb)],gc=A(new B,C()),cb=0,Ua=ob.length|0;cb<Ua;)E(gc,ob[cb]),cb=1+cb|0;K(jb,"this.value.!\x3d(null)",Jb,gc.t)}}throw(new p).e(ib);}return mb;case 6:return(new fJ).Rg(a.u,a.Q,b.La,1+b.Ic|0,b.Hd);case 7:ie(he(),Fu());break;case 25:return(new iJ).Va(a.u,a.Q,b.La);case 26:return(new jJ).Va(a.u,a.Q,b.La);case 24:return(new kJ).Va(a.u,a.Q,b.La);case 9:return(new lJ).Rg(a.u,a.Q,b.La,1+b.Ic|0,b.oa());case 1E3:return(new mJ).Lf(a.u,a.Q,b.La,b.La);case 1001:ie(he(),Fu());break;case 20:return(new nJ).Va(a.u,
a.Q,b.La);case 21:return(new oJ).Va(a.u,a.Q,b.La);case 23:return(new pJ).Va(a.u,a.Q,b.La);case 40:return(new qJ).Va(a.u,a.Q,b.La);case 41:return(new rJ).Va(a.u,a.Q,b.La);case 43:return(new sJ).Va(a.u,a.Q,b.La);case 44:return(new tJ).Va(a.u,a.Q,b.La);case 46:return(new uJ).Va(a.u,a.Q,b.La);case 49:return(new vJ).Va(a.u,a.Q,b.La);case 45:return(new wJ).Va(a.u,a.Q,b.La);case 55:return(new xJ).Va(a.u,a.Q,b.La);case 57:return(new yJ).Va(a.u,a.Q,b.La);case 60:return(new zJ).Va(a.u,a.Q,b.La);case 61:return(new AJ).Va(a.u,
a.Q,b.La);case 62:return(new BJ).Va(a.u,a.Q,b.La);case 63:ie(he(),Fu());break;case 64:return(new CJ).Va(a.u,a.Q,b.La);case 65:ie(he(),Fu());break;case 66:return(new DJ).Va(a.u,a.Q,b.La);case 68:return(new EJ).Va(a.u,a.Q,b.La);case 69:return(new FJ).Va(a.u,a.Q,b.La);case 70:return(new GJ).Va(a.u,a.Q,b.La);case 71:return(new HJ).Va(a.u,a.Q,b.La);case 72:return(new IJ).Va(a.u,a.Q,b.La);case 73:return(new JJ).Va(a.u,a.Q,b.La);case 74:return(new KJ).Va(a.u,a.Q,b.La);case 75:return(new LJ).Va(a.u,a.Q,b.La);
case 80:return(new MJ).Va(a.u,a.Q,b.La);case 81:ie(he(),Fu());break;case 82:return(new NJ).Va(a.u,a.Q,b.La);case 83:return(new OJ).Va(a.u,a.Q,b.La);case 84:return(new PJ).Va(a.u,a.Q,b.La);case 85:return(new QJ).Va(a.u,a.Q,b.La);case 86:return(new RJ).Va(a.u,a.Q,b.La);case 90:return(new SJ).Va(a.u,a.Q,b.La);case 91:return(new TJ).Va(a.u,a.Q,b.La);case 92:return(new UJ).Va(a.u,a.Q,b.La);case 93:return(new VJ).Va(a.u,a.Q,b.La);case 96:return(new WJ).Va(a.u,a.Q,b.La);case 97:return(new XJ).Va(a.u,a.Q,
b.La);case 95:return(new YJ).Va(a.u,a.Q,b.La);case 100:return(new ZJ).Va(a.u,a.Q,b.La);case 101:return(new $J).Va(a.u,a.Q,b.La);case 102:return(new aK).Va(a.u,a.Q,b.La);case 103:return(new bK).Va(a.u,a.Q,b.La);case 104:return(new cK).Va(a.u,a.Q,b.La);case 105:return(new dK).Va(a.u,a.Q,b.La);case 120:return(new eK).Va(a.u,a.Q,b.La);case 121:return(new fK).Va(a.u,a.Q,b.La);case 122:return(new gK).Va(a.u,a.Q,b.La);case 123:return(new hK).Va(a.u,a.Q,b.La);case 124:return(new iK).Va(a.u,a.Q,b.La);case 125:return(new jK).Va(a.u,
a.Q,b.La);case 130:return(new kK).Va(a.u,a.Q,b.La);case 131:return(new lK).Va(a.u,a.Q,b.La);case 132:return(new mK).Lf(a.u,a.Q,b.La,1+b.Ic|0);case 133:return(new nK).Lf(a.u,a.Q,b.La,1+b.Ic|0);case 134:return(new oK).Va(a.u,a.Q,b.La);case 135:return(new pK).Va(a.u,a.Q,b.La);case 136:return(new qK).Va(a.u,a.Q,b.La);case 201:if(" "===b.Hd)return(new rK).Va(a.u,a.Q,b.La);if("\t"===b.Hd)return(new sK).Va(a.u,a.Q,b.La);if("\r"===b.Hd)return(new tK).Va(a.u,a.Q,b.La);if("\n"===b.Hd)return(new uK).Va(a.u,
a.Q,b.La);if("\f"===b.Hd)return(new vK).Va(a.u,a.Q,b.La);for(var Yb=he(),Kb=[(new q).a("curr.strVal",b.Hd)],pb=A(new B,C()),hb=0,Lb=Kb.length|0;hb<Lb;)E(pb,Kb[hb]),hb=1+hb|0;ie(Yb,pb.t);break;case 300:var Fa=kr(Ga(),a.u.od(),b.La,1+(b.Ic-b.La|0)|0),bb=Fa;if(0<=(bb.length|0)&&"//"===bb.substring(0,2))var nc=(new cd).j(Fa),Fa=Sg(nc,"//");var db=Fa;if(0<=(db.length|0)&&"/*"===db.substring(0,2))var uc=(new cd).j(Fa),Fb=Sg(uc,"/*"),hc=(new cd).j(Fb),Fa=Tg(hc,"*/");return(new wK).Rg(a.u,a.Q,b.La,1+b.Ic|
0,Fa);case 401:var $b=a.u,kc=a.Q,lc=b.La,Mb=1+b.Ic|0,Nb=b.He,Gb=new xK;Gb.u=$b;Gb.Q=kc;Gb.E=lc;Gb.Ca=Mb;Gb.Hb=Nb;if(null!==$b)var Sb=(new q).a(!0,F());else{G();var Cc=(new r).d(["this.input is equal to null"]),Ob=G().b,Sb=(new q).a(!1,H(Cc,Ob))}if(null===Sb||!0!==I(Sb)){if(null!==Sb){var Zb=Sb.p();if(!1===I(Sb)){for(var Ec=J(),oc=[(new q).a("Ellipsis",Gb)],pc=A(new B,C()),qc=0,Jc=oc.length|0;qc<Jc;)E(pc,oc[qc]),qc=1+qc|0;K(Ec,"this.input.!\x3d(null)",Zb,pc.t)}}throw(new p).e(Sb);}if(null!==kc)var Hc=
(new q).a(!0,F());else{G();var ac=(new r).d(["this.dialect is equal to null"]),Lc=G().b,Hc=(new q).a(!1,H(ac,Lc))}if(null===Hc||!0!==I(Hc)){if(null!==Hc){var $c=Hc.p();if(!1===I(Hc)){for(var Tc=J(),Rc=[(new q).a("Ellipsis",Gb)],Mc=A(new B,C()),hd=0,Qc=Rc.length|0;hd<Qc;)E(Mc,Rc[hd]),hd=1+hd|0;K(Tc,"this.dialect.!\x3d(null)",$c,Mc.t)}}throw(new p).e(Hc);}return Gb;case 400:return(new yK).Lf(a.u,a.Q,b.La,1+b.Ic|0);case 0:return(new zK).pj(a.u,a.Q);case -3:ie(he(),Fu());break;case -2:ie(he(),Fu());break;
case -1:ie(he(),Fu());break;default:throw(new p).e(c);}}LI.prototype.pj=function(a,b){this.u=a;this.Q=b;return this};
function AK(a,b,c,d,f){var g=0;for(;;){var h=0,h=b;if(h>=d.i.length)return h;f.ba(UI(a,d.i[h]));var h=1+h|0,n=g;104===d.i[-1+h|0].Pb&&(n=1+n|0);105===d.i[-1+h|0].Pb&&(n=-1+n|0);if(0===n&&c)return h;if(9===d.i[-1+h|0].Pb){for(var u=1+d.i[-1+h|0].Ic|0;u<a.u.od().i.length&&34===a.u.od().i[u];)u=1+u|0;var w=-1+(u-d.i[-1+h|0].Ic|0)|0,D=2>=w?1:3;if(1===w){MI(a,-1+d.i[h].La|0,f,D);b:for(;;){if(7===d.i[h].Pb)var N=!0,Q=F();else{G();var ea=(new r).d(["curr.token is not equal to 7"]),ba=G().b,ma=H(ea,ba),N=
!1,Q=ma}var La=Q;if(N)var Pa=(new q).a(!0,F());else{if(6===d.i[h].Pb)var Qa=!0,Ka=F();else{G();var Ba=(new r).d(["curr.token is not equal to 6"]),va=G().b,za=H(Ba,va),Qa=!1,Ka=za}var qa=Ka;if(Qa)Pa=(new q).a(!0,F());else var la=G(),Pa=(new q).a(!1,La.ma(qa,la.b))}if(null===Pa||!0!==I(Pa)){if(null!==Pa){var Ma=Pa.p();!1===I(Pa)&&K(J(),"curr.token.\x3d\x3d(7).||(curr.token.\x3d\x3d(6))",Ma,Fu())}throw(new p).e(Pa);}if(7===d.i[h].Pb){f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(36===
a.u.od().i[1+d.i[h].Ic|0])var Ea=(new q).a(!0,F());else{G();var tb=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '$'"]),Za=G().b,Ea=(new q).a(!1,H(tb,Za))}if(null===Ea||!0!==I(Ea)){if(null!==Ea){var eb=Ea.p();if(!1===I(Ea)){for(var kb=J(),Pb=[(new q).a("ScalametaTokenizer",a)],Na=A(new B,C()),sb=0,yb=Pb.length|0;sb<yb;)E(Na,Pb[sb]),sb=1+sb|0;K(kb,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('$')",eb,Na.t)}}throw(new p).e(Ea);
}var sc=1+d.i[h].Ic|0;if(123===a.u.od().i[1+sc|0])SI(a,sc,f),h=1+h|0,h=AK(a,h,!0,d,f);else{if(95===a.u.od().i[1+sc|0]){SI(a,sc,f);h=1+h|0;if(131===d.i[h].Pb)var Ra=(new q).a(!0,F());else{G();var wc=(new r).d(["curr.token is not equal to expected"]),Wb=G().b,Ra=(new q).a(!1,H(wc,Wb))}if(null===Ra||!0!==I(Ra)){if(null!==Ra){var Rb=Ra.p();if(!1===I(Ra)){for(var ub=J(),fb=[(new q).a("expected",131)],Xb=A(new B,C()),lb=0,Eb=fb.length|0;lb<Eb;)E(Xb,fb[lb]),lb=1+lb|0;K(ub,"curr.token.\x3d\x3d(expected)",
Rb,Xb.t)}}throw(new p).e(Ra);}}else{SI(a,sc,f);h=1+h|0;if(10===d.i[h].Pb)var xc=!0,gb=F();else{G();var dc=(new r).d(["curr.token is not equal to 10"]),Fc=G().b,Qb=H(dc,Fc),xc=!1,gb=Qb}var Bb=gb;if(xc)var Ib=(new q).a(!0,F());else{if(21===d.i[h].Pb)var mb=!0,Cb=F();else{G();var Tb=(new r).d(["curr.token is not equal to 21"]),mc=G().b,Ac=H(Tb,mc),mb=!1,Cb=Ac}var Dc=Cb;if(mb)Ib=(new q).a(!0,F());else var Db=G(),Ib=(new q).a(!1,Bb.ma(Dc,Db.b))}if(null===Ib||!0!==I(Ib)){if(null!==Ib){var Va=Ib.p();!1===
I(Ib)&&K(J(),"curr.token.\x3d\x3d(10).||(curr.token.\x3d\x3d(21))",Va,Fu())}throw(new p).e(Ib);}}f.ba(UI(a,d.i[h]));h=1+h|0}QI(a,d.i[h].La,f);continue b}else{var ec=d.i[h];ec.ri(ec.Ic-D|0);f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(34===a.u.od().i[1+d.i[h].Ic|0])var $a=(new q).a(!0,F());else{G();var vb=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '\\\"'"]),fc=G().b,$a=(new q).a(!1,H(vb,fc))}if(null===$a||!0!==I($a)){if(null!==$a){var Bc=
$a.p();if(!1===I($a)){for(var Ub=J(),Vb=[(new q).a("ScalametaTokenizer",a)],wb=A(new B,C()),xb=0,Xa=Vb.length|0;xb<Xa;)E(wb,Vb[xb]),xb=1+xb|0;K(Ub,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('\\\"')",Bc,wb.t)}}throw(new p).e($a);}h=1+h|0}break}OI(a,-1+d.i[h].La|0,f,D)}else if(2===w){MI(a,d.i[h].La,f,D);var tc=d.i[h];tc.ck(1+tc.La|0);b:for(;;){if(7===d.i[h].Pb)var ib=!0,zb=F();else{G();var nb=(new r).d(["curr.token is not equal to 7"]),Jb=G().b,jb=H(nb,Jb),ib=!1,zb=jb}var ob=
zb;if(ib)var gc=(new q).a(!0,F());else{if(6===d.i[h].Pb)var cb=!0,Ua=F();else{G();var Yb=(new r).d(["curr.token is not equal to 6"]),Kb=G().b,pb=H(Yb,Kb),cb=!1,Ua=pb}var hb=Ua;if(cb)gc=(new q).a(!0,F());else var Lb=G(),gc=(new q).a(!1,ob.ma(hb,Lb.b))}if(null===gc||!0!==I(gc)){if(null!==gc){var Fa=gc.p();!1===I(gc)&&K(J(),"curr.token.\x3d\x3d(7).||(curr.token.\x3d\x3d(6))",Fa,Fu())}throw(new p).e(gc);}if(7===d.i[h].Pb){f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(36===a.u.od().i[1+
d.i[h].Ic|0])var bb=(new q).a(!0,F());else{G();var nc=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '$'"]),db=G().b,bb=(new q).a(!1,H(nc,db))}if(null===bb||!0!==I(bb)){if(null!==bb){var uc=bb.p();if(!1===I(bb)){for(var Fb=J(),hc=[(new q).a("ScalametaTokenizer",a)],$b=A(new B,C()),kc=0,lc=hc.length|0;kc<lc;)E($b,hc[kc]),kc=1+kc|0;K(Fb,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('$')",uc,$b.t)}}throw(new p).e(bb);}var Mb=1+d.i[h].Ic|
0;if(123===a.u.od().i[1+Mb|0])SI(a,Mb,f),h=1+h|0,h=AK(a,h,!0,d,f);else{if(95===a.u.od().i[1+Mb|0]){SI(a,Mb,f);h=1+h|0;if(131===d.i[h].Pb)var Nb=(new q).a(!0,F());else{G();var Gb=(new r).d(["curr.token is not equal to expected"]),Sb=G().b,Nb=(new q).a(!1,H(Gb,Sb))}if(null===Nb||!0!==I(Nb)){if(null!==Nb){var Cc=Nb.p();if(!1===I(Nb)){for(var Ob=J(),Zb=[(new q).a("expected",131)],Ec=A(new B,C()),oc=0,pc=Zb.length|0;oc<pc;)E(Ec,Zb[oc]),oc=1+oc|0;K(Ob,"curr.token.\x3d\x3d(expected)",Cc,Ec.t)}}throw(new p).e(Nb);
}}else{SI(a,Mb,f);h=1+h|0;if(10===d.i[h].Pb)var qc=!0,Jc=F();else{G();var Hc=(new r).d(["curr.token is not equal to 10"]),ac=G().b,Lc=H(Hc,ac),qc=!1,Jc=Lc}var $c=Jc;if(qc)var Tc=(new q).a(!0,F());else{if(21===d.i[h].Pb)var Rc=!0,Mc=F();else{G();var hd=(new r).d(["curr.token is not equal to 21"]),Qc=G().b,rd=H(hd,Qc),Rc=!1,Mc=rd}var od=Mc;if(Rc)Tc=(new q).a(!0,F());else var Zc=G(),Tc=(new q).a(!1,$c.ma(od,Zc.b))}if(null===Tc||!0!==I(Tc)){if(null!==Tc){var nd=Tc.p();!1===I(Tc)&&K(J(),"curr.token.\x3d\x3d(10).||(curr.token.\x3d\x3d(21))",
nd,Fu())}throw(new p).e(Tc);}}f.ba(UI(a,d.i[h]));h=1+h|0}QI(a,d.i[h].La,f);continue b}else{var zd=d.i[h];zd.ri(zd.Ic-D|0);f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(34===a.u.od().i[1+d.i[h].Ic|0])var ud=(new q).a(!0,F());else{G();var wd=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '\\\"'"]),Bd=G().b,ud=(new q).a(!1,H(wd,Bd))}if(null===ud||!0!==I(ud)){if(null!==ud){var Ed=ud.p();if(!1===I(ud)){for(var pd=J(),vd=[(new q).a("ScalametaTokenizer",
a)],xd=A(new B,C()),ee=0,Ld=vd.length|0;ee<Ld;)E(xd,vd[ee]),ee=1+ee|0;K(pd,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('\\\"')",Ed,xd.t)}}throw(new p).e(ud);}h=1+h|0}break}OI(a,-1+d.i[h].La|0,f,D)}else if(3<=w&&6>w){MI(a,-3+d.i[h].La|0,f,D);b:for(;;){if(7===d.i[h].Pb)var me=!0,fe=F();else{G();var Yd=(new r).d(["curr.token is not equal to 7"]),Zd=G().b,qe=H(Yd,Zd),me=!1,fe=qe}var re=fe;if(me)var Kd=(new q).a(!0,F());else{if(6===d.i[h].Pb)var yf=!0,Cd=F();else{G();var Fe=
(new r).d(["curr.token is not equal to 6"]),je=G().b,xe=H(Fe,je),yf=!1,Cd=xe}var ge=Cd;if(yf)Kd=(new q).a(!0,F());else var ye=G(),Kd=(new q).a(!1,re.ma(ge,ye.b))}if(null===Kd||!0!==I(Kd)){if(null!==Kd){var ne=Kd.p();!1===I(Kd)&&K(J(),"curr.token.\x3d\x3d(7).||(curr.token.\x3d\x3d(6))",ne,Fu())}throw(new p).e(Kd);}if(7===d.i[h].Pb){f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(36===a.u.od().i[1+d.i[h].Ic|0])var Ce=(new q).a(!0,F());else{G();var hf=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '$'"]),
Pe=G().b,Ce=(new q).a(!1,H(hf,Pe))}if(null===Ce||!0!==I(Ce)){if(null!==Ce){var jf=Ce.p();if(!1===I(Ce)){for(var ze=J(),Me=[(new q).a("ScalametaTokenizer",a)],$e=A(new B,C()),kf=0,Ne=Me.length|0;kf<Ne;)E($e,Me[kf]),kf=1+kf|0;K(ze,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('$')",jf,$e.t)}}throw(new p).e(Ce);}var Ge=1+d.i[h].Ic|0;if(123===a.u.od().i[1+Ge|0])SI(a,Ge,f),h=1+h|0,h=AK(a,h,!0,d,f);else{if(95===a.u.od().i[1+Ge|0]){SI(a,Ge,f);h=1+h|0;if(131===d.i[h].Pb)var se=
(new q).a(!0,F());else{G();var lf=(new r).d(["curr.token is not equal to expected"]),te=G().b,se=(new q).a(!1,H(lf,te))}if(null===se||!0!==I(se)){if(null!==se){var De=se.p();if(!1===I(se)){for(var Qe=J(),af=[(new q).a("expected",131)],of=A(new B,C()),df=0,mf=af.length|0;df<mf;)E(of,af[df]),df=1+df|0;K(Qe,"curr.token.\x3d\x3d(expected)",De,of.t)}}throw(new p).e(se);}}else{SI(a,Ge,f);h=1+h|0;if(10===d.i[h].Pb)var Re=!0,Xe=F();else{G();var zf=(new r).d(["curr.token is not equal to 10"]),ef=G().b,$d=
H(zf,ef),Re=!1,Xe=$d}var pf=Xe;if(Re)var He=(new q).a(!0,F());else{if(21===d.i[h].Pb)var If=!0,ug=F();else{G();var Af=(new r).d(["curr.token is not equal to 21"]),vg=G().b,Wf=H(Af,vg),If=!1,ug=Wf}var Mh=ug;if(If)He=(new q).a(!0,F());else var Yg=G(),He=(new q).a(!1,pf.ma(Mh,Yg.b))}if(null===He||!0!==I(He)){if(null!==He){var Og=He.p();!1===I(He)&&K(J(),"curr.token.\x3d\x3d(10).||(curr.token.\x3d\x3d(21))",Og,Fu())}throw(new p).e(He);}}f.ba(UI(a,d.i[h]));h=1+h|0}QI(a,d.i[h].La,f);continue b}else{var Pg=
d.i[h];Pg.ri(Pg.Ic-D|0);f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(34===a.u.od().i[1+d.i[h].Ic|0])var Jf=(new q).a(!0,F());else{G();var Zg=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '\\\"'"]),ji=G().b,Jf=(new q).a(!1,H(Zg,ji))}if(null===Jf||!0!==I(Jf)){if(null!==Jf){var jh=Jf.p();if(!1===I(Jf)){for(var $g=J(),Qg=[(new q).a("ScalametaTokenizer",a)],ij=A(new B,C()),ki=0,lh=Qg.length|0;ki<lh;)E(ij,Qg[ki]),ki=1+ki|0;K($g,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('\\\"')",
jh,ij.t)}}throw(new p).e(Jf);}h=1+h|0}break}OI(a,-3+d.i[h].La|0,f,D)}else if(6===w){MI(a,-3+d.i[h].La|0,f,D);b:for(;;){if(7===d.i[h].Pb)var Nh=!0,xk=F();else{G();var Kj=(new r).d(["curr.token is not equal to 7"]),jj=G().b,Di=H(Kj,jj),Nh=!1,xk=Di}var Lj=xk;if(Nh)var bh=(new q).a(!0,F());else{if(6===d.i[h].Pb)var Oh=!0,Ph=F();else{G();var Mj=(new r).d(["curr.token is not equal to 6"]),fl=G().b,cg=H(Mj,fl),Oh=!1,Ph=cg}var Qh=Ph;if(Oh)bh=(new q).a(!0,F());else var Wl=G(),bh=(new q).a(!1,Lj.ma(Qh,Wl.b))}if(null===
bh||!0!==I(bh)){if(null!==bh){var Nj=bh.p();!1===I(bh)&&K(J(),"curr.token.\x3d\x3d(7).||(curr.token.\x3d\x3d(6))",Nj,Fu())}throw(new p).e(bh);}if(7===d.i[h].Pb){f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(36===a.u.od().i[1+d.i[h].Ic|0])var Ei=(new q).a(!0,F());else{G();var Xl=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '$'"]),Oj=G().b,Ei=(new q).a(!1,H(Xl,Oj))}if(null===Ei||!0!==I(Ei)){if(null!==Ei){var Pj=Ei.p();if(!1===I(Ei)){for(var Qj=
J(),yk=[(new q).a("ScalametaTokenizer",a)],li=A(new B,C()),mi=0,Zm=yk.length|0;mi<Zm;)E(li,yk[mi]),mi=1+mi|0;K(Qj,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('$')",Pj,li.t)}}throw(new p).e(Ei);}var wg=1+d.i[h].Ic|0;if(123===a.u.od().i[1+wg|0])SI(a,wg,f),h=1+h|0,h=AK(a,h,!0,d,f);else{if(95===a.u.od().i[1+wg|0]){SI(a,wg,f);h=1+h|0;if(131===d.i[h].Pb)var mh=(new q).a(!0,F());else{G();var Fi=(new r).d(["curr.token is not equal to expected"]),gl=G().b,mh=(new q).a(!1,H(Fi,
gl))}if(null===mh||!0!==I(mh)){if(null!==mh){var zk=mh.p();if(!1===I(mh)){for(var Ye=J(),hl=[(new q).a("expected",131)],Rj=A(new B,C()),Rh=0,$m=hl.length|0;Rh<$m;)E(Rj,hl[Rh]),Rh=1+Rh|0;K(Ye,"curr.token.\x3d\x3d(expected)",zk,Rj.t)}}throw(new p).e(mh);}}else{SI(a,wg,f);h=1+h|0;if(10===d.i[h].Pb)var il=!0,Gi=F();else{G();var dg=(new r).d(["curr.token is not equal to 10"]),Hi=G().b,ni=H(dg,Hi),il=!1,Gi=ni}var jl=Gi;if(il)var nh=(new q).a(!0,F());else{if(21===d.i[h].Pb)var Ak=!0,oh=F();else{G();var Yl=
(new r).d(["curr.token is not equal to 21"]),Sj=G().b,Bk=H(Yl,Sj),Ak=!1,oh=Bk}var Zl=oh;if(Ak)nh=(new q).a(!0,F());else var xg=G(),nh=(new q).a(!1,jl.ma(Zl,xg.b))}if(null===nh||!0!==I(nh)){if(null!==nh){var Tj=nh.p();!1===I(nh)&&K(J(),"curr.token.\x3d\x3d(10).||(curr.token.\x3d\x3d(21))",Tj,Fu())}throw(new p).e(nh);}}f.ba(UI(a,d.i[h]));h=1+h|0}QI(a,d.i[h].La,f);continue b}else{var Uj=d.i[h];Uj.ri(Uj.Ic-D|0);f.ba((new BK).Rg(a.u,a.Q,d.i[h].La,1+d.i[h].Ic|0,d.i[h].Hd));if(34===a.u.od().i[1+d.i[h].Ic|
0])var Ii=(new q).a(!0,F());else{G();var Vj=(new r).d(["ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)) is not equal to '\\\"'"]),Rg=G().b,Ii=(new q).a(!1,H(Vj,Rg))}if(null===Ii||!0!==I(Ii)){if(null!==Ii){var kj=Ii.p();if(!1===I(Ii)){for(var Ji=J(),ph=[(new q).a("ScalametaTokenizer",a)],lj=A(new B,C()),Xf=0,Sh=ph.length|0;Xf<Sh;)E(lj,ph[Xf]),Xf=1+Xf|0;K(Ji,"ScalametaTokenizer.this.input.chars.apply(curr.endOffset.+(1)).\x3d\x3d('\\\"')",kj,lj.t)}}throw(new p).e(Ii);}h=1+h|0}break}OI(a,
-3+d.i[h].La|0,f,D)}else throw(new p).e(w);}if(1E3===d.i[-1+h|0].Pb){h=-1+h|0;b:for(;;){var Th=d.i[h].Pb;switch(Th){case 1E3:var mj=a,qh=d.i[h].La,oi=1+d.i[h].Ic|0,eg=f,rh=mj.u,Wj=mj.Q,Uh=kr(Ga(),mj.u.od(),qh,oi-qh|0);eg.ba((new CK).Rg(rh,Wj,qh,oi,Uh));h=1+h|0;continue b;case 104:var Vh=d.i[h].La;f.ba((new DK).Lf(a.u,a.Q,Vh,Vh));var h=AK(a,h,!0,d,f),Ck=d.i[h].La;f.ba((new EK).Lf(a.u,a.Q,Ck,Ck));continue b;case 1001:h=1+h|0;break;default:throw(new p).e(Th);}break}FK(To(),1001===d.i[-1+h|0].Pb);var Wh=
1+d.i[-1+h|0].Ic|0;f.ba((new GK).Lf(a.u,a.Q,Wh,Wh))}var nj=n;b=h;g=nj}}LI.prototype.$classData=l({vZ:0},!1,"scala.meta.internal.tokenizers.ScalametaTokenizer",{vZ:1,f:1});function HK(){this.Vz=this.fk=this.PE=this.OE=this.xs=null}HK.prototype=new m;HK.prototype.constructor=HK;
function sia(a){var b=new HK,c=IK().yy;b.OE=a;b.PE=c;a=IK();c=gda(To(),"\t\n\r ");IK();b.fk=Bia(a,c);a=IK();var c=Rq(function(a){return function(){var b=IK(),c=Cia(a).Pu,b=(new JK).Wa(c,b.Ba),c=IK(),c=KK((new JK).Wa(a.fk,c.Ba));return Dia(b,c)}}(b)),d=(new LK).j("XmlExpr");b.Vz=MK(d.Y,c,a.Ba);IK();Rq(function(a){return function(){return Cia(a).ou}}(b));(new LK).j("XmlPattern");return b}function Cia(a){null===a.xs&&null===a.xs&&(a.xs=Eia(a));return a.xs}
HK.prototype.$classData=l({yZ:0},!1,"scala.meta.internal.tokenizers.XmlParser",{yZ:1,f:1});function NK(){this.r=this.ly=this.Kz=this.ry=this.Rz=this.ou=this.uz=this.vz=this.tm=this.ky=this.jy=this.my=this.or=this.ql=this.pr=this.zy=this.wz=this.ny=this.wy=this.ds=this.yz=this.xz=this.oy=this.py=this.fy=this.iy=this.hy=this.gy=this.Sz=this.Ou=this.Tz=this.Uz=this.Ju=this.Pu=this.qy=this.ay=this.xy=this.ju=this.nu=this.Qz=this.vy=null}NK.prototype=new m;NK.prototype.constructor=NK;
function Eia(a){var b=new NK;if(null===a)throw jo(wj(),null);b.r=a;var c=IK(),d=Rq(function(a){return function(){var b=IK(),b=(new JK).Wa(a.Qz,b.Ba),c=IK(),c=(new JK).Wa(OK("/\x3e"),c.Ba),d=IK(),f=IK(),f=PK((new JK).Wa(OK("\x3e"),f.Ba),a.qy);return PK(b,QK(c,PK((new JK).Wa(f,d.Ba),a.nu)))}}(b)),f=(new LK).j("Element");b.vy=MK(f.Y,d,c.Ba);var g=IK(),h=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=RK((new JK).Wa(OK("\x3c"),d.Ba),a.tm),c=(new JK).Wa(d,c.Ba),d=IK(),f=IK(),f=RK((new JK).Wa(a.r.fk,
f.Ba),a.ju),c=PK(c,SK((new JK).Wa(f,d.Ba))),b=(new JK).Wa(c,b.Ba),c=IK();return RK(b,KK((new JK).Wa(a.r.fk,c.Ba)))}}(b)),n=(new LK).j("TagHeader");b.Qz=MK(n.Y,h,g.Ba);var u=IK(),w=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=RK((new JK).Wa(OK("\x3c/"),d.Ba),a.tm),c=(new JK).Wa(d,c.Ba),d=IK(),c=RK(c,KK((new JK).Wa(a.r.fk,d.Ba)));return RK((new JK).Wa(c,b.Ba),OK("\x3e"))}}(b)),D=(new LK).j("ETag");b.nu=MK(D.Y,w,u.Ba);var N=IK(),Q=Rq(function(a){return function(){var b=IK(),c=IK(),c=PK((new JK).Wa(a.tm,
c.Ba),a.xy);return PK((new JK).Wa(c,b.Ba),a.ay)}}(b)),ea=(new LK).j("Attribute");b.ju=MK(ea.Y,Q,N.Ba);var ba=IK(),ma=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=KK((new JK).Wa(a.r.fk,d.Ba)),c=RK((new JK).Wa(d,c.Ba),OK("\x3d")),b=(new JK).Wa(c,b.Ba),c=IK();return RK(b,KK((new JK).Wa(a.r.fk,c.Ba)))}}(b)),La=(new LK).j("Eq");b.xy=MK(La.Y,ma,ba.Ba);var Pa=IK(),Qa=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),f=IK(),f=(new JK).Wa(OK('"'),f.Ba),g=IK(),h=IK(),h=QK((new JK).Wa(a.my,
h.Ba),a.ds),f=PK(f,SK((new JK).Wa(h,g.Ba))),d=RK((new JK).Wa(f,d.Ba),OK('"')),c=(new JK).Wa(d,c.Ba),d=IK(),f=IK(),f=(new JK).Wa(OK("'"),f.Ba),g=IK(),h=IK(),h=QK((new JK).Wa(a.jy,h.Ba),a.ds),f=PK(f,SK((new JK).Wa(h,g.Ba))),c=QK(c,RK((new JK).Wa(f,d.Ba),OK("'")));return QK((new JK).Wa(c,b.Ba),a.Ju)}}(b)),Ka=(new LK).j("AttValue");b.ay=MK(Ka.Y,Qa,Pa.Ba);var Ba=IK(),va=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),f=IK(),f=QK((new JK).Wa(a.pr,f.Ba),a.ds),d=QK((new JK).Wa(f,d.Ba),a.Ju),c=QK((new JK).Wa(d,
c.Ba),a.Pu);return SK((new JK).Wa(c,b.Ba))}}(b)),za=(new LK).j("Content");b.qy=MK(za.Y,va,Ba.Ba);var qa=IK(),la=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),f=IK(),f=QK((new JK).Wa(a.Uz,f.Ba),a.gy),d=QK((new JK).Wa(f,d.Ba),a.xz),c=QK((new JK).Wa(d,c.Ba),a.py);return QK((new JK).Wa(c,b.Ba),a.vy)}}(b)),Ma=(new LK).j("XmlContent");b.Pu=MK(Ma.Y,la,qa.Ba);var Ea=IK(),tb=Rq(function(a){return function(){var b=IK(),c=IK(),c=RK((new JK).Wa(OK("{"),c.Ba),a.r.OE);return RK((new JK).Wa(c,b.Ba),
OK("}"))}}(b)),Za=(new LK).j("ScalaExpr");b.Ju=MK(Za.Y,tb,Ea.Ba);var eb=IK(),kb=Rq(function(a){return function(){var b=IK(),c=IK(),c=PK((new JK).Wa(a.Tz,c.Ba),a.Sz);return RK((new JK).Wa(c,b.Ba),a.Ou)}}(b)),Pb=(new LK).j("Unparsed");b.Uz=MK(Pb.Y,kb,eb.Ba);var Na=IK(),sb=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=(new JK).Wa(OK("\x3cxml:unparsed"),d.Ba),f=IK(),g=IK(),g=RK((new JK).Wa(a.r.fk,g.Ba),a.ju),d=PK(d,SK((new JK).Wa(g,f.Ba))),c=(new JK).Wa(d,c.Ba),d=IK(),c=RK(c,KK((new JK).Wa(a.r.fk,
d.Ba)));return RK((new JK).Wa(c,b.Ba),OK("\x3e"))}}(b)),yb=(new LK).j("UnpStart");b.Tz=MK(yb.Y,sb,Na.Ba);var sc=IK(),Ra=Rq(function(){return function(){return OK("\x3c/xml:unparsed\x3e")}}(b)),wc=(new LK).j("UnpEnd");b.Ou=MK(wc.Y,Ra,sc.Ba);var Wb=IK(),Rb=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=TK((new JK).Wa(a.Ou,d.Ba)),c=RK((new JK).Wa(d,c.Ba),a.ql);return SK((new JK).Wa(c,b.Ba))}}(b)),ub=(new LK).j("UnpData");b.Sz=MK(ub.Y,Rb,Wb.Ba);var fb=IK(),Xb=Rq(function(a){return function(){var b=
IK(),c=IK(),c=PK((new JK).Wa(a.hy,c.Ba),a.iy);return RK((new JK).Wa(c,b.Ba),a.fy)}}(b)),lb=(new LK).j("CDSect");b.gy=MK(lb.Y,Xb,fb.Ba);var Eb=IK(),xc=Rq(function(){return function(){return OK("\x3c![CDATA[")}}(b)),gb=(new LK).j("CDStart");b.hy=MK(gb.Y,xc,Eb.Ba);var dc=IK(),Fc=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=TK((new JK).Wa(OK("]]\x3e"),d.Ba)),c=RK((new JK).Wa(d,c.Ba),a.ql);return SK((new JK).Wa(c,b.Ba))}}(b)),Qb=(new LK).j("CData");b.iy=MK(Qb.Y,Fc,dc.Ba);var Bb=IK(),Ib=
Rq(function(){return function(){return OK("]]\x3e")}}(b)),mb=(new LK).j("CDEnd");b.fy=MK(mb.Y,Ib,Bb.Ba);var Cb=IK(),Tb=Rq(function(a){return function(){var b=IK(),c=IK(),c=PK((new JK).Wa(OK("\x3c!--"),c.Ba),a.oy);return RK((new JK).Wa(c,b.Ba),OK("--\x3e"))}}(b)),mc=(new LK).j("Comment");b.py=MK(mc.Y,Tb,Cb.Ba);var Ac=IK(),Dc=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=TK((new JK).Wa(OK("--\x3e"),d.Ba)),c=RK((new JK).Wa(d,c.Ba),a.ql);return SK((new JK).Wa(c,b.Ba))}}(b)),Db=(new LK).j("ComText");
b.oy=MK(Db.Y,Dc,Ac.Ba);var Va=IK(),ec=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),f=IK(),f=RK((new JK).Wa(OK("\x3c?"),f.Ba),a.tm),d=(new JK).Wa(f,d.Ba),f=IK(),d=RK(d,KK((new JK).Wa(a.r.fk,f.Ba))),c=RK((new JK).Wa(d,c.Ba),a.yz);return RK((new JK).Wa(c,b.Ba),OK("?\x3e"))}}(b)),$a=(new LK).j("PI");b.xz=MK($a.Y,ec,Va.Ba);var vb=IK(),fc=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=TK((new JK).Wa(OK("?\x3e"),d.Ba)),c=RK((new JK).Wa(d,c.Ba),a.ql);return SK((new JK).Wa(c,b.Ba))}}(b)),
Bc=(new LK).j("PIProcText");b.yz=MK(Bc.Y,fc,vb.Ba);var Ub=IK(),Vb=Rq(function(a){return function(){var b=IK();return QK((new JK).Wa(a.wy,b.Ba),a.ny)}}(b)),wb=(new LK).j("Reference");b.ds=MK(wb.Y,Vb,Ub.Ba);var xb=IK(),Xa=Rq(function(a){return function(){var b=IK(),c=IK(),c=RK((new JK).Wa(OK("\x26"),c.Ba),a.tm);return PK((new JK).Wa(c,b.Ba),OK(";"))}}(b)),tc=(new LK).j("EntityRef");b.wy=MK(tc.Y,Xa,xb.Ba);var ib=IK(),zb=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=RK((new JK).Wa(OK("\x26#"),
d.Ba),a.wz),c=RK((new JK).Wa(d,c.Ba),OK(";")),b=(new JK).Wa(c,b.Ba),c=IK(),d=IK(),d=RK((new JK).Wa(OK("\x26#x"),d.Ba),a.zy);return QK(b,RK((new JK).Wa(d,c.Ba),OK(";")))}}(b)),nb=(new LK).j("CharRef");b.ny=MK(nb.Y,zb,ib.Ba);var Jb=IK(),jb=Rq(function(){return function(){var a=IK(),b=IK(),c=(new UK).db(48),d=(new ed).db(57),c=[VK(c,d)];Xo();pl();for(var d=(new r).c(),f=0,g=c.length|0;f<g;){var h=c[f].cm();d.Da.push(h);f=1+f|0}b=Fia(d,b.Ba);return SK((new JK).Wa(b,a.Ba))}}(b)),ob=(new LK).j("Num");b.wz=
MK(ob.Y,jb,Jb.Ba);var gc=IK(),cb=Rq(function(){return function(){var a=IK(),b=IK(),c=(new UK).db(48),d=(new ed).db(57),c=VK(c,d),d=(new UK).db(97),f=(new ed).db(102),d=VK(d,f),f=(new UK).db(65),g=(new ed).db(70),c=[c,d,VK(f,g)];Xo();pl();d=(new r).c();f=0;for(g=c.length|0;f<g;){var h=c[f].cm();d.Da.push(h);f=1+f|0}b=Fia(d,b.Ba);return SK((new JK).Wa(b,a.Ba))}}(b)),Ua=(new LK).j("HexNum");b.zy=MK(Ua.Y,cb,gc.Ba);var Yb=IK(),Kb=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=QK((new JK).Wa(a.ky,
d.Ba),OK("{{")),c=QK((new JK).Wa(d,c.Ba),OK("}}")),b=(new JK).Wa(c,b.Ba);return Dia(b,(new WK).Ne(b.qh))}}(b)),pb=(new LK).j("CharData");b.pr=MK(pb.Y,Kb,Yb.Ba);var hb=IK(),Lb=Rq(function(){return function(){return IK().$x}}(b)),Fa=(new LK).j("Char");b.ql=MK(Fa.Y,Lb,hb.Ba);var bb=IK(),nc=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=QK((new JK).Wa(OK("\x3c"),d.Ba),OK("\x26")),c=TK((new JK).Wa(d,c.Ba));return RK((new JK).Wa(c,b.Ba),a.ql)}}(b)),db=(new LK).j("Char1");b.or=MK(db.Y,nc,bb.Ba);
var uc=IK(),Fb=Rq(function(a){return function(){var b=IK(),c=IK(),c=TK((new JK).Wa(OK('"'),c.Ba));return RK((new JK).Wa(c,b.Ba),a.or)}}(b)),hc=(new LK).j("CharQ");b.my=MK(hc.Y,Fb,uc.Ba);var $b=IK(),kc=Rq(function(a){return function(){var b=IK(),c=IK(),c=TK((new JK).Wa(OK("'"),c.Ba));return RK((new JK).Wa(c,b.Ba),a.or)}}(b)),lc=(new LK).j("CharA");b.jy=MK(lc.Y,kc,$b.Ba);var Mb=IK(),Nb=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=QK((new JK).Wa(OK("{"),d.Ba),OK("}")),c=TK((new JK).Wa(d,
c.Ba));return RK((new JK).Wa(c,b.Ba),a.or)}}(b)),Gb=(new LK).j("CharB");b.ky=MK(Gb.Y,Nb,Mb.Ba);var Sb=IK(),Cc=IK(),Ob=IK(),Zb=IK(),Ec=IK(),oc=Rq(function(a){return function(){var b=IK(),b=(new JK).Wa(a.vz,b.Ba),c=IK();return RK(b,SK((new JK).Wa(a.uz,c.Ba)))}}(b)),pc=(new LK).j("Name"),qc=Gia((new JK).Wa(MK(pc.Y,oc,Ec.Ba),Zb.Ba)),Jc=Hia((new JK).Wa(qc,Ob.Ba),lk(function(){return function(a){a=(new cd).j(a);a=Hd(a);return 58!==(null===a?0:a.pa)}}(b))),Hc=Iia((new JK).Wa(Jc,Cc.Ba));b.tm=Jia((new JK).Wa(Hc,
Sb.Ba),lk(function(){return function(){}}(b)));var ac=IK(),Lc=Rq(function(a){return function(){return Kia(IK().lu,lk(function(a){return function(b){return a.Rs(null===b?0:b.pa)}}(a)))}}(b)),$c=(new LK).j("NameStart");b.vz=MK($c.Y,Lc,ac.Ba);var Tc=IK(),Rc=Rq(function(a){return function(){return Kia(IK().lu,lk(function(a){return function(b){a:{var c=null===b?0:b.pa;if(a.Rs(c))b=!0;else switch(WH(qi(),c)<<24>>24){case 8:case 7:case 6:case 4:case 9:b=!0;break a;default:b=(new cd).j(".-:"),c=(new ed).db(c),
b=Lia(b,c)}}return b}}(a)))}}(b)),Mc=(new LK).j("NameChar");b.uz=MK(Mc.Y,Rc,Tc.Ba);var hd=IK(),Qc=Rq(function(a){return function(){var b=IK(),b=(new JK).Wa(a.Rz,b.Ba),c=IK(),c=(new JK).Wa(OK("/\x3e"),c.Ba),d=IK(),f=IK(),f=PK((new JK).Wa(OK("\x3e"),f.Ba),a.ry);return PK(b,QK(c,PK((new JK).Wa(f,d.Ba),a.nu)))}}(b)),rd=(new LK).j("ElemPattern");b.ou=MK(rd.Y,Qc,hd.Ba);var od=IK(),Zc=Rq(function(a){return function(){var b=IK(),c=IK(),c=RK((new JK).Wa(OK("\x3c"),c.Ba),a.tm),b=(new JK).Wa(c,b.Ba),c=IK();
return RK(b,KK((new JK).Wa(a.r.fk,c.Ba)))}}(b)),nd=(new LK).j("TagPHeader");b.Rz=MK(nd.Y,Zc,od.Ba);var zd=IK(),ud=Rq(function(a){return function(){var b=IK(),c=IK(),d=IK(),d=QK((new JK).Wa(a.ly,d.Ba),a.Kz),c=QK((new JK).Wa(d,c.Ba),a.ou);return SK((new JK).Wa(c,b.Ba))}}(b)),wd=(new LK).j("ContentP");b.ry=MK(wd.Y,ud,zd.Ba);var Bd=IK(),Ed=Rq(function(a){return function(){var b=IK(),c=IK(),c=RK((new JK).Wa(OK("{"),c.Ba),a.r.PE);return RK((new JK).Wa(c,b.Ba),OK("}"))}}(b)),pd=(new LK).j("ScalaPatterns");
b.Kz=MK(pd.Y,Ed,Bd.Ba);var vd=IK(),xd=Rq(function(a){return function(){var b=IK(),c=IK(),c=(new JK).Wa(OK("\x26"),c.Ba),d=IK(),c=RK(c,KK((new JK).Wa(a.pr,d.Ba)));return QK((new JK).Wa(c,b.Ba),a.pr)}}(b)),ee=(new LK).j("CharDataP");b.ly=MK(ee.Y,xd,vd.Ba);return b}NK.prototype.Rs=function(a){switch(WH(qi(),a)<<24>>24){case 2:case 1:case 5:case 3:case 10:return!0;default:return 95===a}};NK.prototype.$classData=l({zZ:0},!1,"scala.meta.internal.tokenizers.XmlParser$Xml$",{zZ:1,f:1});
function NH(){this.KB=null}NH.prototype=new m;NH.prototype.constructor=NH;
NH.prototype.c=function(){MH=this;var a="abstract case do else finally for import lazy object override return sealed trait try var while catch class extends false forSome if match new package private super this true type with yield def final implicit null protected throw val _ : \x3d \x3d\x3e \x3c- \x3c: \x3c% \x3e: # @ \u21d2 \u2190".split(" ");if(0===(a.length|0))a=id();else{for(var b=kd(new ld,id()),c=0,d=a.length|0;c<d;)md(b,a[c]),c=1+c|0;a=b.t}this.KB=a;return this};
NH.prototype.$classData=l({AZ:0},!1,"scala.meta.internal.tokenizers.package$",{AZ:1,f:1});var MH=void 0;function XK(){this.r=this.Xc=null}XK.prototype=new m;XK.prototype.constructor=XK;function P(a,b){var c=new XK;c.Xc=b;if(null===a)throw jo(wj(),null);c.r=a;return c}function O(a,b){a=a.Xc;return a.y(a.Na(),a.aa,null,b)}XK.prototype.$classData=l({BZ:0},!1,"scala.meta.internal.trees.InternalTreeXtensions$XtensionOriginTree",{BZ:1,f:1});function YK(){}YK.prototype=new m;YK.prototype.constructor=YK;
YK.prototype.c=function(){return this};function Mia(a,b,c){a=v();(a=y(z(a,b),lfa())?"args"===c:!1)||(a=v(),a=z(a,b),ZK||(ZK=(new $K).c()),a=y(a,ZK)?"args"===c:!1);a||(a=v(),a=z(a,b),aL||(aL=(new bL).c()),a=y(a,aL)?"arg"===c:!1);a||(a=v(),a=y(z(a,b),Nia())?"rhs"===c:!1);a||(a=v(),a=y(z(a,b),Oia())?"args"===c:!1);a||(a=v(),a=y(z(a,b),Oia())?"args"===c:!1);a||(a=v(),a=y(z(a,b),Pia())?"argss"===c:!1);a||(a=v(),a=y(z(a,b),Nia())?"rhs"===c:!1);return a}
function Qia(a){a:for(;;){var b=!1,c=null;if(zh(a)){var b=!0,c=a,d=c.Y;if(Gg(d)){a=GG(d);continue a}}if(b&&kn(c.Y))return!0;if(b&&(c=c.Y,fm(c)))return b=GG(c),b.g()?b=S():(b=b.q(),c=v(),b=(new T).e(y(z(c,b),Ria()))),!(!b.g()&&!b.q());if(b)return!1;if(S()===a)return!0;throw(new p).e(a);}}function Sia(a,b,c){a=v();(a=y(z(a,b),Tia())?"decltpe"===c:!1)||(a=v(),a=z(a,b),cL||(cL=(new dL).c()),a=y(a,cL)?"params"===c:!1);a||(a=v(),a=y(z(a,b),cga())?"tpe"===c:!1);return a}
YK.prototype.$classData=l({FZ:0},!1,"scala.meta.internal.trees.ParentChecks$",{FZ:1,f:1});var eL=void 0;function fL(){eL||(eL=(new YK).c());return eL}function gL(){}gL.prototype=new m;gL.prototype.constructor=gL;gL.prototype.c=function(){return this};function hL(a,b,c){for(;;){pI(To(),0<=c);if(0===c)return b;null!==b&&b===k(cc)?b=k(bc(xa)):(b=Gr(Ir(),b,0),b=ra(b));c=-1+c|0}}gL.prototype.$classData=l({HZ:0},!1,"scala.meta.internal.trees.package$",{HZ:1,f:1});var iL=void 0;
function jL(){iL||(iL=(new gL).c());return iL}function kL(){this.mw=null}kL.prototype=new m;kL.prototype.constructor=kL;
function Uia(a){var b=!1,c=null,d=!1,f=null;a=a.mw;if(El(a)){var b=!0,g=c=a,g=null===g?S():(new T).e(g.gg());if(!g.g()&&(g=g.q(),Pl(g)))return S()}return Hl(a)&&(d=!0,a=f=a,a=null===a?S():(new T).e(a.gg()),!a.g()&&(a=a.q(),Pl(a)))?S():b&&(b=c,b=null===b?S():(new T).e(b.gg()),!b.g())?(d=b.q(),(new T).e(d)):d&&(d=f,d=null===d?S():(new T).e(d.gg()),!d.g())?(d=d.q(),(new T).e(d)):S()}function Aga(a){return Via(a)&&Uia(a).g()}function Via(a){a=a.mw;return El(a)||Hl(a)}
function Dga(a){return Via(a)?!Uia(a).g():!1}function NC(a){var b=new kL;b.mw=a;return b}kL.prototype.$classData=l({IZ:0},!1,"scala.meta.internal.trees.package$XtensionHelpersMod",{IZ:1,f:1});function lL(){this.Xc=null}lL.prototype=new m;lL.prototype.constructor=lL;function Kha(a){var b=new lL;b.Xc=a;return b}lL.prototype.ub=function(){var a=this.Xc.Nb();if(km(a)){var b=null===a?S():(new T).e(a.ub());if(!b.g())return b.q()}G();a=(new r).d([a]);b=G().b;return H(a,b)};
lL.prototype.$classData=l({JZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesCase",{JZ:1,f:1});function mL(){this.nw=null}mL.prototype=new m;mL.prototype.constructor=mL;function ov(a,b){for(a=a.nw;!a.g();){var c=a.n();if(b.la(c))return!0;a=a.o()}return!1}function Au(a){var b=new mL;b.nw=a;return b}function Bu(a,b,c){a=a.nw;var d=new nL;d.Hx=b;d.Zu=c;b=G();return ex(a,d,b.b)}mL.prototype.$classData=l({KZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesMods",{KZ:1,f:1});
function oL(){this.iC=null}oL.prototype=new m;oL.prototype.constructor=oL;function Wia(a){var b=new oL;b.iC=a;return b}function Xia(a){a=a.iC;return pL(a)||Um(a)||Km(a)&&(a=null===a?S():(new T).e(Lm(a)),!a.g()&&(a=a.q(),Pl(a)))?!0:!1}oL.prototype.$classData=l({MZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesRef",{MZ:1,f:1});function qL(){this.An=null}qL.prototype=new m;qL.prototype.constructor=qL;function bea(a){a=a.An;return rL(a)||In(a)||pn(a)||qn(a)||yn(a)||Hn(a)}
function Yia(a){a=a.An;return rL(a)||Nk(a)||Sk(a)||Qk(a)}function hv(a){var b=new qL;b.An=a;return b}function DD(a){a=a.An;return rL(a)||In(a)||pn(a)||yn(a)}function Kga(a){a=a.An;return rL(a)||vn(a)||un(a)}function Mda(a){a=a.An;return rL(a)||qn(a)||Qk(a)}function Zia(a){a=a.An;return rL(a)||In(a)||Ql(a)||Ok(a)||Pk(a)||Lk(a)||Mk(a)}qL.prototype.$classData=l({NZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesStat",{NZ:1,f:1});function sL(){this.Xc=null}sL.prototype=new m;
sL.prototype.constructor=sL;function $ia(a){var b=new sL;b.Xc=a;return b}function aja(a){a=a.Xc;return Ff(a)?!0:Lf(a)?$t(au(a)):fm(a)&&(a=null===a?S():(new T).e((new q).a(a.Ae(),a.$g())),!a.g())?(a=a.q().qa(),aja($ia(a))):!1}sL.prototype.$classData=l({OZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesTerm",{OZ:1,f:1});function tL(){this.bt=this.et=this.gd=null}tL.prototype=new m;tL.prototype.constructor=tL;
function eh(a){var b=new tL;b.gd=a;a=[(new ed).db(36),(new ed).db(95)];if(0===(a.length|0))a=id();else{for(var c=kd(new ld,id()),d=0,f=a.length|0;d<f;)md(c,a[d]),d=1+d|0;a=c.t}b.et=a;a=[2,1,5,3,10];if(0===(a.length|0))a=id();else{c=kd(new ld,id());d=0;for(f=a.length|0;d<f;)md(c,a[d]),d=1+d|0;a=c.t}b.bt=a;return b}tL.prototype.Ss=function(){var a=["-","+","~","!"];if(0===(a.length|0))a=id();else{for(var b=kd(new ld,id()),c=0,d=a.length|0;c<d;)md(b,a[c]),c=1+c|0;a=b.t}return a.Ac(this.gd.ec())};
function dh(a){var b=v();if(y(z(b,a.gd),bja()))return!0;a=a.gd.ec();a=(new cd).j(a);a=Hd(a);return 58!==(null===a?0:a.pa)}
tL.prototype.cl=function(){var a=v();if(y(z(a,this.gd),bja()))return 1;a:{a=this.gd.ec();if("!\x3d"!==a&&"\x3c\x3d"!==a&&"\x3e\x3d"!==a&&""!==a&&(a=this.gd.ec(),a=(new cd).j(a),a=Hd(a),61===(null===a?0:a.pa)?(a=this.gd.ec(),a=(new cd).j(a),a=eo(a),a=61!==(null===a?0:a.pa)):a=!1,a)){a=this.gd.ec();a=(new cd).j(a);a=eo(a);b:switch(a=null===a?0:a.pa,a){case 126:case 33:case 64:case 35:case 37:case 94:case 42:case 43:case 45:case 60:case 62:case 63:case 58:case 61:case 38:case 124:case 47:case 92:a=!0;
break b;default:a=WH(qi(),a),a=25===a||28===a}break a}a=!1}if(a)return 0;a=this.gd.ec();a=(new cd).j(a);a=eo(a);var a=null===a?0:a.pa,b=this.bt,c=WH(qi(),a)<<24>>24;b.Ac(c)?a=!0:(b=this.et,a=(new ed).db(a),a=b.Ac(a));if(a)return 1;a=this.gd.ec();a=(new cd).j(a);a=eo(a);switch(null===a?0:a.pa){case 124:return 2;case 94:return 3;case 38:return 4;case 61:case 33:return 5;case 60:case 62:return 6;case 58:return 7;case 43:case 45:return 8;case 42:case 47:case 37:return 9;default:return 10}};
tL.prototype.$classData=l({PZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesTermName",{PZ:1,f:1});function uL(){this.Xc=null}uL.prototype=new m;uL.prototype.constructor=uL;
function $t(a){var b=!1,c=null;a=a.Xc;if(vL(a))return!0;a:{var d;if(Pf(a))d=!0;else{if(Df(a)&&(d=null===a?S():(new T).e((new q).a(Ef(a),a.yb())),!d.g()&&Hm(d.q().qa()))){d=!0;break a}d=!1}}return d||Df(a)&&(b=!0,a=c=a,a=null===a?S():(new T).e((new q).a(Ef(a),a.yb())),!a.g()&&(a=a.q().qa(),Ff(a)))?!0:b&&(b=c,b=null===b?S():(new T).e((new q).a(Ef(b),b.yb())),!b.g()&&(b=b.q().qa(),Lf(b)))?wL(au(b)):!1}
function cja(a){a=a.Xc;return vL(a)||Pf(a)?!0:Df(a)&&(a=null===a?S():(new T).e((new q).a(Ef(a),a.yb())),!a.g()&&(a=a.q().qa(),Lf(a)))?cja(au(a)):!1}function wL(a){if($t(au(a.Xc)))return!0;var b=v();return y(z(b,a.Xc),IG())}function au(a){var b=new uL;b.Xc=a;return b}uL.prototype.$classData=l({QZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesTermRef",{QZ:1,f:1});function xL(){this.Xc=null}xL.prototype=new m;xL.prototype.constructor=xL;
function dja(a){a=a.Xc;return Eu(a)||hi(a)||si(a)||ti(a)||Ai(a)||Si(a)||wi(a)||xi(a)||vi(a)&&(a=null===a?S():(new T).e(a.ve()),!a.g()&&(a=a.q(),Km(a)&&(a=null===a?S():(new T).e(Lm(a)),!a.g()&&(a=a.q(),Pl(a)))))?!0:!1}function eja(a){var b=new xL;b.Xc=a;return b}xL.prototype.$classData=l({RZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesType",{RZ:1,f:1});function yL(){this.jp=this.qp=null}yL.prototype=new m;yL.prototype.constructor=yL;
yL.prototype.$classData=l({TZ:0},!1,"scala.meta.parsers.Aliases$Parsed$",{TZ:1,f:1});function zL(){this.r=this.Lp=null}zL.prototype=new m;zL.prototype.constructor=zL;
function fja(a,b){a=a.Lp;if(null===a)throw(new p).e(a);var c;a:try{var d=(new Us).pj(a.p(),a.qa()),f=b.SA.Ea(d);c=(new AL).e(f)}catch(g){b=vj(wj(),g);if(null!==b){if(tC(b)&&(d=uC(vC(),b),!d.g())){c=d.q().qa();d=d.q().p();c=(new BL).Os(c,d,b);break a}if(Cy(b)&&(d=sga(tga(),b),!d.g())){c=d.q().qa();d=d.q().p();c=(new BL).Os(c,d,b);break a}throw jo(wj(),b);}throw g;}return c}function gja(a,b){var c=new zL;c.Lp=b;if(null===a)throw jo(wj(),null);c.r=a;return c}
zL.prototype.$classData=l({VZ:0},!1,"scala.meta.parsers.Api$XtensionParseDialectInput",{VZ:1,f:1});function CL(){this.r=this.aq=null}CL.prototype=new m;CL.prototype.constructor=CL;function Zn(a){var b=Il().Sq,c=DL(),d=wk().mb,f=a.r;a=(new q).a(d,b.Ea(a.aq));return fja(gja(f,a),c)}function $n(a,b){var c=new CL;c.aq=b;if(null===a)throw jo(wj(),null);c.r=a;return c}CL.prototype.$classData=l({WZ:0},!1,"scala.meta.parsers.Api$XtensionParseInputLike",{WZ:1,f:1});function EL(){this.r=this.Q=null}
EL.prototype=new m;EL.prototype.constructor=EL;EL.prototype.vp=function(a,b){return(new q).a(this.Q,b.Ea(a))};EL.prototype.$classData=l({XZ:0},!1,"scala.meta.parsers.Api$XtensionParsersDialectInput",{XZ:1,f:1});function FL(){this.Gs=null}FL.prototype=new m;FL.prototype.constructor=FL;FL.prototype.c=function(){this.Gs=void 0;return this};
function GL(a,b,c,d){a:{c=void 0===c?S():(new T).e(c);c.g()?c=S():(c=c.q(),c=as().dk.call(c,"dialect")?(new T).e(c.dialect):S());if(zh(c)){c=c.Y;var f=hja().wg(c);if(zh(f)){c=f.Y;fj();c=(new HL).e(c);break a}if(S()===f){fj();c=td((new yd).X((new r).d(["'","' is not a valid dialect."])),(new r).d([c]));c=(new IL).e(c);break a}throw(new p).e(f);}if(S()===c)fj(),c=wk().Rb,c=(new HL).e(c);else throw(new p).e(c);}if(JL(c))return a=c.Y,KL(LL(),(new r).d([(new q).a("error",a)]));if(ML(c)){f=c.Y;c=ija();
var g=ija(),h=new EL;h.Q=f;if(null===g)throw jo(wj(),null);h.r=g;b=h.vp(b,NL().Sq);d=fja(gja(c,b),d);if(ao(d)&&(b=bo(jja(),d),!b.g()))return d=b.q(),kja(a,d);if(lo(d)&&(b=mo(lja(),d),!b.g()))return a=b.q().Bb,b=b.q().qb,d=LL(),b=(new q).a("error",b),c=mja(a),c=(new q).a("pos",c),f=a.Rq(),f=(new q).a("lineNumber",f),a=a.Bx(),KL(d,(new r).d([b,c,f,(new q).a("columnNumber",a)]));throw(new p).e(d);}throw(new p).e(c);}
function OL(a,b){if(eG(b))return kja(a,b);if(Ty(b)){var c;PL||(PL=(new QL).c());c=PL;a=function(){return function(a){return OL(lM(),a)}}(a);var d=G().b;if(d===G().b)if(b===F())a=F();else{var d=b.n(),f=d=U(new V,a(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,a(g),F()),f=f.ga=g;b=b.o()}a=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();a=d.da()}return nja(c,a)}if(b&&b.$classData&&b.$classData.H.nC)return b.g()?c=S():(c=b.q(),c=(new T).e(OL(lM(),c))),c=c.g()?void 0:c.q(),void 0===c?void 0:
c}function mja(a){var b=a.ab();a=a.wa();return{start:b,end:a}}
function kja(a,b){var c={type:b.U(),pos:mja(Yc(b))},d=LL(),f=b.Oa(),g=b.L().lb(),h=G().b,f=Vm(f,g,h),g=(new mM).c(),h=G(),d=KL(d,ex(f,g,h.b));a:{if(wH(b)&&(f=null===b?S():(new T).e((new ed).db(b.Ab)),!f.g())){f=f.q();f={value:ca.String.fromCharCode(null===f?0:f.pa)};break a}if(sH(b)&&(f=null===b?S():(new T).e(b.Ab),!f.g())){g=Ya(f.q());f=g.Ra;g=g.Ya;oja||(oja=(new nM).c());f={value:pja((new Ep).K(f,g))};break a}if(xH(b)&&(f=null===b?S():(new T).e(b.Ab),!f.g())){f={value:f.q().gd};break a}f=Ui(b)?
{value:(new T).e(b.Xf()).Y}:Um(b)?{value:(new T).e(b.ec()).Y}:{}}Ui(b)?(g=Se(),h=wk().mb,h=tg().If(h),b={syntax:yg(g,b,h).be()}):b={};c=[c,d,f,b];b={};d=0;for(f=c.length|0;d<f;)g=(new oM).Jm(c[d]),pM(new qM,g,lk(function(){return function(a){return null!==a}}(a))).Cb(lk(function(a,b){return function(a){if(null!==a)b[a.qa()]=a.p();else throw(new p).e(a);}}(a,b))),d=1+d|0;return b}FL.prototype.$classData=l({YZ:0},!1,"scala.meta.parsers.JSFacade$",{YZ:1,f:1});var rM=void 0;
function lM(){rM||(rM=(new FL).c());return rM}function nM(){}nM.prototype=new m;nM.prototype.constructor=nM;nM.prototype.c=function(){return this};function pja(a){if(0<=a.Ya){var b=a.Ra;a=2097151&a.Ya;return sM(ab(),b,a)}var b=a.Ra,c=a.Ya;a=-b|0;b=2097151&(0!==b?~c:-c|0);return-sM(ab(),a,b)}nM.prototype.$classData=l({$Z:0},!1,"scala.meta.parsers.JSFacade$LongJSOps$",{$Z:1,f:1});var oja=void 0;function tM(){this.qw=this.rw=null;this.ra=0}tM.prototype=new m;tM.prototype.constructor=tM;
tM.prototype.c=function(){return this};
function qja(a){0===(1&a.ra)&&(a.rw=(new uM).te(lk(function(){return function(a){if(ke(a.P)){Sd(a,(new rC).z(a));var c;b:{var d=!1,f=null;c=Dy(a,a.Gp,"illegal start of definition",(new vM).z(a));if(F().w(c)){le(a);var g=x(a.h).ja();Pd("unexpected end of input",g)}if(rk(c)){var d=!0,f=c,g=f.ed,h=f.ga;if(rL(g)){var n=null===g?S():(new T).e((new q).a(g.ca,g.fa()));if(!n.g()&&1===n.q().Xa()&&F().w(h)){c=qx();G();f=(new r).d([g]);d=G().b;f=H(f,d);c=rx(c,f);break b}}}if(d&&(d=f.ed,f=f.ga,F().w(f))){c=d;
break b}c:{for(f=c;!f.g();){d=f.n();if(!DD(hv(d))){f=!1;break c}f=f.o()}f=!0}if(f)c=rx(qx(),c);else{c:{for(;!c.g();){f=c.n();if(!Zia(hv(f))){c=!1;break c}c=c.o()}c=!0}c&&rga(a,(new T).e('try source"..." instead'));rga(a,S());c=void 0}}}else for(Sd(a,(new rC).z(a)),c=a.Gp.hq().Ea(x(a.h)),c.g()&&(le(a),f=x(a.h).ja(),Pd("unexpected start of statement",f)),c=c.q();;){f=v();d=x(a.h);if(y(z(f,d),ah()))break;f=v();d=x(a.h);f=z(f,d);d=Wu(a);y(f,Xu(d))||Sd(a,(new wM).z(a));a.h.ia()}d=Tf(a.h);Sd(a,(new sC).z(a));
f=(new rf).Ia(a,0);d=(new rf).Ia(a,d);f=f.va;d=d.va;d<f&&(d=-1+f|0);f=(new L).K(f,1+d|0);d=M();a=O(P(d,c),R(a.ea,a.P,f));return a}}(a))),a.ra|=1);return a.rw}function DL(){var a=rja();return 0===(32768&a.ra)?sja(a):a.qw}
function sja(a){0===(32768&a.ra)&&(a.qw=(new uM).te(lk(function(){return function(a){if(ke(a.P)){Sd(a,(new rC).z(a));var c=Sfa(a),d=Tf(a.h);Sd(a,(new sC).z(a));var f=(new rf).Ia(a,0)}else Sd(a,(new rC).z(a)),c=Sfa(a),d=Tf(a.h),Sd(a,(new sC).z(a)),f=(new rf).Ia(a,0);d=(new rf).Ia(a,d);f=f.va;d=d.va;d<f&&(d=-1+f|0);f=(new L).K(f,1+d|0);d=M();a=O(P(d,c),R(a.ea,a.P,f));return a}}(a))),a.ra|=32768);return a.qw}tM.prototype.$classData=l({a_:0},!1,"scala.meta.parsers.Parse$",{a_:1,f:1});var xM=void 0;
function rja(){xM||(xM=(new tM).c());return xM}function yM(){this.r=this.Uq=this.jm=null}yM.prototype=new m;yM.prototype.constructor=yM;function Ue(a){return a.Uq.N(a.jm).v()}function Ve(a,b,c){var d=new yM;d.jm=b;d.Uq=c;if(null===a)throw jo(wj(),null);d.r=a;return d}yM.prototype.$classData=l({h_:0},!1,"scala.meta.prettyprinters.Api$XtensionStructure",{h_:1,f:1});function zM(){this.r=this.Uq=this.jm=null}zM.prototype=new m;zM.prototype.constructor=zM;zM.prototype.be=function(){return this.Uq.N(this.jm).v()};
function yg(a,b,c){var d=new zM;d.jm=b;d.Uq=c;if(null===a)throw jo(wj(),null);d.r=a;return d}zM.prototype.$classData=l({i_:0},!1,"scala.meta.prettyprinters.Api$XtensionSyntax",{i_:1,f:1});function AM(){}AM.prototype=new m;AM.prototype.constructor=AM;AM.prototype.c=function(){return this};function ZG(a,b,c){return BM(new CM,"",c.N(b)," ",lk(function(){return function(a){a=(new cd).j(a);return cj(a)}}(a)))}
function WF(a,b,c,d){a=function(a,b){return function(a){return b.N(a)}}(a,d);d=G().b;if(d===G().b)if(b===F())a=F();else{d=b.n();var f=d=U(new V,a(d),F());for(b=b.o();b!==F();){var g=b.n(),g=U(new V,a(g),F()),f=f.ga=g;b=b.o()}a=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();a=d.da()}return tja(a,c)}function eia(a,b,c,d){return BM(new CM,"",d.N(b)," ",lk(function(a,b){return function(){return b}}(a,c)))}function YG(a,b,c){return(new DM).Iv(c.N(b))}
function yH(a,b,c,d,f){return BM(new CM,b,f.N(c),"",lk(function(a,b){return function(){return b}}(a,d)))}function HG(a,b,c,d,f,g){return BM(new CM,b,g.N(c),d,lk(function(a,b){return function(){return b}}(a,f)))}function XF(){var a=VF();return(new EM).te(lk(function(){return function(a){return a}}(a)))}function XG(a,b,c){return(new FM).Iv(c.N(b))}function X(){var a=VF();return(new EM).te(lk(function(){return function(a){return(new iG).j(a)}}(a)))}
AM.prototype.$classData=l({j_:0},!1,"scala.meta.prettyprinters.Show$",{j_:1,f:1});var GM=void 0;function VF(){GM||(GM=(new AM).c());return GM}function HM(){}HM.prototype=new m;HM.prototype.constructor=HM;function IM(){}IM.prototype=HM.prototype;HM.prototype.v=function(){var a=(new ql).c(),b=(new JM).mc(0);KM(this,this,a,b);return a.Qb.ac};
function KM(a,b,c,d){a:for(;;){var f=!1,g=null;b:if(xG()!==b)if(b&&b.$classData&&b.$classData.H.Nw)rl(c,b.Y);else if(b&&b.$classData&&b.$classData.H.Mw)b.Gj.Cb(lk(function(a,b,c){return function(d){KM(a,d,b,c)}}(a,c,d)));else{if(b&&b.$classData&&b.$classData.H.Lw){var f=!0,g=b,h=g.Gj;if(F().w(h))break b}if(f&&(f=g.Gj,g=g.Mq,f=fj().Sx.Nx(f),!f.g())){h=f.q().qa();b=f.q().p();for(f=h;!f.g();)h=f.n(),KM(a,h,c,d),rl(c,g),f=f.o();continue a}if(b&&b.$classData&&b.$classData.H.Jw)g=b.Bf,d.cb=1+d.cb|0,uja(a,
g,c,d),d.cb=-1+d.cb|0;else if(b&&b.$classData&&b.$classData.H.Kw)uja(a,b.Bf,c,d);else{if(IH(b)){b=b.Bf;continue a}if(b&&b.$classData&&b.$classData.H.Ow)a=b.uq,d=b.Wq,g=b.Fp,b=b.Bf.v(),g.Ea(b)&&rl(c,a),rl(c,b),g.Ea(b)&&rl(c,d),void 0;else if(b&&b.$classData&&b.$classData.H.Iw)sl(c,b.Rp.Ea(c));else throw(new p).e(b);}}break}}function uja(a,b,c,d){rl(c,lr().hg);var f=(new cd).j("  ");rl(c,dd(f,d.cb));KM(a,b,c,d)}function LM(){this.r=this.Lp=null}LM.prototype=new m;LM.prototype.constructor=LM;
function Yz(a){a=a.Lp;if(null===a)throw(new p).e(a);var b;a:try{var c;var d=(new LI).pj(a.p(),a.qa()),f=MM(JI().kq,d.Q);if(null===f){JI();var g=(new Qq).c(),h,n=JI(),u=d.Q,w;if(n.kq.Kl.Ac((new NM).e(u)))w=MM(n.kq,u);else{var D=n.kq.Kl.jt((new NM).e(u),g);w=D.g()?null:D.q()}h=w;f=null!==h?h:g}if(null===JI().lw)throw(new fk).c();var N=f.wg(d.u);if(zh(N))c=N.Y;else if(S()===N){var Q,ea=(new $H).pj(d.u,d.Q),ba;ba=[];aI(ea.ha);do{oI(ea);var ma=ea.Ta,La=new OM;yj(La);var Pa=kba(La,ma);ba.push(null===Pa?
null:Pa)}while(0!==ea.Ta.Pb);var Qa=na(bc(oba),ba),Ka=(new PM).Ud(k(XD)),Ba=(new QM).pj(d.u,d.Q);RM(Ka,Ba);AK(d,0,!1,Qa,Ka);var va=Ka.da();YD();Q=ZD(va,0,va.i.length);if(null===JI().lw)throw(new fk).c();f.gm(d.u,Q);c=Q}else throw(new p).e(N);var za=new SM;za.jl=c;if(null!==c)var qa=(new q).a(!0,F());else{G();var la=(new r).d(["this.tokens is equal to null"]),Ma=G().b,qa=(new q).a(!1,H(la,Ma))}if(null===qa||!0!==I(qa)){if(null!==qa){var Ea=qa.p();if(!1===I(qa)){var tb=J(),Za=[(new q).a("Success",za)],
eb=A(new B,C());b=0;for(var kb=Za.length|0;b<kb;)E(eb,Za[b]),b=1+b|0;K(tb,"this.tokens.!\x3d(null)",Ea,eb.t)}}throw(new p).e(qa);}b=za}catch(Pb){qa=vj(wj(),Pb);if(null!==qa){if(tC(qa)&&(tb=uC(vC(),qa),!tb.g())){Ea=tb.q().qa();tb=tb.q().p();b=(new TM).Os(Ea,tb,qa);break a}throw jo(wj(),qa);}throw Pb;}return b}function Zz(a,b){var c=new LM;c.Lp=b;if(null===a)throw jo(wj(),null);c.r=a;return c}LM.prototype.$classData=l({q_:0},!1,"scala.meta.tokenizers.Api$XtensionTokenizeDialectInput",{q_:1,f:1});
function Wz(){this.r=this.aq=null}Wz.prototype=new m;Wz.prototype.constructor=Wz;Wz.prototype.$classData=l({r_:0},!1,"scala.meta.tokenizers.Api$XtensionTokenizeInputLike",{r_:1,f:1});function UM(){this.r=this.Q=null}UM.prototype=new m;UM.prototype.constructor=UM;function VM(a,b){var c=new UM;c.Q=b;if(null===a)throw jo(wj(),null);c.r=a;return c}UM.prototype.vp=function(a,b){return(new q).a(this.Q,b.Ea(a))};
UM.prototype.$classData=l({t_:0},!1,"scala.meta.tokenizers.Api$XtensionTokenizersDialectApply",{t_:1,f:1});function WM(){}WM.prototype=new m;WM.prototype.constructor=WM;function XM(){}XM.prototype=WM.prototype;function YM(a,b){for(b=ZM(b);b.fb();)a.Sa(b.bb())}function $M(a,b){if(zh(b))a.Sa(b.Y);else if(S()!==b)throw(new p).e(b);}
WM.prototype.Sa=function(a){a:if(!Pf(a)||(null===a?S():(new T).e(a.ec())).g()){if(Zk(a)){var b=null===a?S():(new T).e((new q).a(a.Ae(),a.pb()));if(!b.g()){var c=b.q().qa(),d=b.q().p();this.Sa(c);YM(this,d);break a}}if(!hi(a)||(null===a?S():(new T).e(a.ec())).g()){if(sg(a)){var f=null===a?S():(new T).e((new al).yd(a.Qa(),a.xb(),a.sc(),a.Bi()));if(!f.g()){var g=f.q().Bb,h=f.q().qb,n=f.q().Eb,u=f.q().hd;YM(this,g);this.Sa(h);$M(this,n);$M(this,u);break a}}if(wi(a)){var w=null===a?S():(new T).e((new q).a(a.Db(),
a.pb()));if(!w.g()){var D=w.q().qa(),N=w.q().p();this.Sa(D);YM(this,N);break a}}if($k(a)){var Q=null===a?S():(new T).e((new al).yd(a.mg(),a.Qd(),a.$g(),a.pb()));if(!Q.g()){var ea=Q.q().Bb,ba=Q.q().qb,ma=Q.q().Eb,La=Q.q().hd;this.Sa(ea);this.Sa(ba);YM(this,ma);YM(this,La);break a}}if(Ul(a)){var Pa=null===a?S():(new T).e((new q).a(nl(a),ol(a)));if(!Pa.g()){var Qa=Pa.q().qa(),Ka=Pa.q().p();$M(this,Qa);$M(this,Ka);break a}}if(Tl(a)){var Ba=null===a?S():(new T).e((new al).yd(a.Si(),a.Xi(),a.Zg(),a.ub()));
if(!Ba.g()){var va=Ba.q().Bb,za=Ba.q().qb,qa=Ba.q().Eb,la=Ba.q().hd;YM(this,va);YM(this,za);this.Sa(qa);YM(this,la);break a}}if(Jn(a)){var Ma=null===a?S():(new T).e((new q).a(a.ve(),a.Tk()));if(!Ma.g()){var Ea=Ma.q().qa(),tb=Ma.q().p();this.Sa(Ea);YM(this,tb);break a}}if(Nl(a)){var Za=null===a?S():(new T).e((new yi).sd(a.Re(),a.zm(),a.Nb()));if(!Za.g()){var eb=Za.q().Bb,kb=Za.q().qb,Pb=Za.q().Eb;this.Sa(eb);$M(this,kb);this.Sa(Pb);break a}}if(Sl(a)){var Na=null===a?S():(new T).e(a.ub());if(!Na.g()){var sb=
Na.q();YM(this,sb);break a}}if(Ol(a)){var yb=null===a?S():(new T).e((new yi).sd(a.Db(),a.xb(),a.tl()));if(!yb.g()){var sc=yb.q().Bb,Ra=yb.q().qb,wc=yb.q().Eb;this.Sa(sc);this.Sa(Ra);aN(this,wc);break a}}if(!Pl(a)&&(!dm(a)||(null===a?S():(new T).e(a.Ab)).g())){if(Km(a)){var Wb=null===a?S():(new T).e(Lm(a));if(!Wb.g()){var Rb=Wb.q();this.Sa(Rb);break a}}if(Hm(a)){var ub=null===a?S():(new T).e((new q).a(Im(a),Jm(a)));if(!ub.g()){var fb=ub.q().qa(),Xb=ub.q().p();this.Sa(fb);this.Sa(Xb);break a}}if(Df(a)){var lb=
null===a?S():(new T).e((new q).a(Ef(a),a.yb()));if(!lb.g()){var Eb=lb.q().qa(),xc=lb.q().p();this.Sa(Eb);this.Sa(xc);break a}}if(gm(a)){var gb=null===a?S():(new T).e((new q).a(a.Qd(),hm(a)));if(!gb.g()){var dc=gb.q().qa(),Fc=gb.q().p();this.Sa(dc);this.Sa(Fc);break a}}if(si(a)){var Qb=null===a?S():(new T).e((new q).a(wl(a),a.nc()));if(!Qb.g()){var Bb=Qb.q().qa(),Ib=Qb.q().p();this.Sa(Bb);this.Sa(Ib);break a}}if(ti(a)){var mb=null===a?S():(new T).e((new q).a(ui(a),a.nc()));if(!mb.g()){var Cb=mb.q().qa(),
Tb=mb.q().p();this.Sa(Cb);this.Sa(Tb);break a}}if(vi(a)){var mc=null===a?S():(new T).e(a.ve());if(!mc.g()){var Ac=mc.q();this.Sa(Ac);break a}}if(!Pn(a)){if(Ln(a)){var Dc=null===a?S():(new T).e(a.xb());if(!Dc.g()){var Db=Dc.q();this.Sa(Db);break a}}if(Mn(a)){var Va=null===a?S():(new T).e((new q).a(a.xb(),Nn(a)));if(!Va.g()){var ec=Va.q().qa(),$a=Va.q().p();this.Sa(ec);this.Sa($a);break a}}if(On(a)){var vb=null===a?S():(new T).e(a.xb());if(!vb.g()){var fc=vb.q();this.Sa(fc);break a}}if(xi(a)){var Bc=
null===a?S():(new T).e((new yi).sd(a.Kd(),zi(a),a.cd()));if(!Bc.g()){var Ub=Bc.q().Bb,Vb=Bc.q().qb,wb=Bc.q().Eb;this.Sa(Ub);this.Sa(Vb);this.Sa(wb);break a}}if(Ai(a)){var xb=null===a?S():(new T).e((new q).a(a.me(),a.Kh()));if(!xb.g()){var Xa=xb.q().qa(),tc=xb.q().p();YM(this,Xa);this.Sa(tc);break a}}if(tl(a)){var ib=null===a?S():(new T).e((new q).a(a.me(),a.Kh()));if(!ib.g()){var zb=ib.q().qa(),nb=ib.q().p();YM(this,zb);this.Sa(nb);break a}}if(Bi(a)){var Jb=null===a?S():(new T).e(a.pb());if(!Jb.g()){var jb=
Jb.q();YM(this,jb);break a}}if(Mi(a)){var ob=null===a?S():(new T).e((new q).a(a.Kd(),a.cd()));if(!ob.g()){var gc=ob.q().qa(),cb=ob.q().p();this.Sa(gc);this.Sa(cb);break a}}if(Ni(a)){var Ua=null===a?S():(new T).e((new q).a(a.Kd(),a.cd()));if(!Ua.g()){var Yb=Ua.q().qa(),Kb=Ua.q().p();this.Sa(Yb);this.Sa(Kb);break a}}if(Oi(a)){var pb=null===a?S():(new T).e((new q).a(a.Kd(),a.cd()));if(!pb.g()){var hb=pb.q().qa(),Lb=pb.q().p();this.Sa(hb);this.Sa(Lb);break a}}if(Pi(a)){var Fa=null===a?S():(new T).e((new q).a(Qi(a),
a.ub()));if(!Fa.g()){var bb=Fa.q().qa(),nc=Fa.q().p();$M(this,bb);YM(this,nc);break a}}if(Ri(a)){var db=null===a?S():(new T).e((new q).a(a.Db(),a.ub()));if(!db.g()){var uc=db.q().qa(),Fb=db.q().p();this.Sa(uc);YM(this,Fb);break a}}if(Si(a)){var hc=null===a?S():(new T).e((new q).a(a.Db(),a.Di()));if(!hc.g()){var $b=hc.q().qa(),kc=hc.q().p();this.Sa($b);YM(this,kc);break a}}if(ul(a)){var lc=null===a?S():(new T).e((new q).a(a.lc(),a.Db()));if(!lc.g()){var Mb=lc.q().qa(),Nb=lc.q().p();YM(this,Mb);this.Sa(Nb);
break a}}if(a&&a.$classData&&a.$classData.H.GC){var Gb=null===a?S():(new T).e((new q).a(a.bd(),a.Db()));if(!Gb.g()){var Sb=Gb.q().qa(),Cc=Gb.q().p();aN(this,Sb);this.Sa(Cc);break a}}if(Ti(a)){var Ob=null===a?S():(new T).e(a.Gh());if(!Ob.g()){var Zb=Ob.q();this.Sa(Zb);break a}}if(Ig(a)){var Ec=null===a?S():(new T).e(a.Db());if(!Ec.g()){var oc=Ec.q();this.Sa(oc);break a}}if(Jg(a)){var pc=null===a?S():(new T).e(a.Db());if(!pc.g()){var qc=pc.q();this.Sa(qc);break a}}if(kH(a)){var Jc=null===a?S():(new T).e(a.nc());
if(!Jc.g()){var Hc=Jc.q();this.Sa(Hc);break a}}if(!(a&&a.$classData&&a.$classData.H.AC||a&&a.$classData&&a.$classData.H.zC&&!(null===a?S():(new T).e(a.Ab)).g()||fG(a)&&!(null===a?S():(new T).e(a.li)).g()||hG(a)&&!(null===a?S():(new T).e(a.li)).g()||a&&a.$classData&&a.$classData.H.OM&&!(null===a?S():(new T).e(a.V4())).g()||a&&a.$classData&&a.$classData.H.eN&&!(null===a?S():(new T).e(a.W4())).g()||wH(a)&&!(null===a?S():(new T).e((new ed).db(a.Ab))).g()||sH(a)&&!(null===a?S():(new T).e(a.Ab)).g()||a&&
a.$classData&&a.$classData.H.yC&&!(null===a?S():(new T).e(a.Ab)).g()||on(a)||a&&a.$classData&&a.$classData.H.BC&&!(null===a?S():(new T).e(a.Ab)).g()||xH(a)&&!(null===a?S():(new T).e(a.Ab)).g())){if(ln(a)){var ac=null===a?S():(new T).e(a.yb());if(!ac.g()){var Lc=ac.q();this.Sa(Lc);break a}}if(!mn(a)&&!hn(a)){if(Ym(a)){var $c=null===a?S():(new T).e((new q).a(a.Vd(),a.ci()));if(!$c.g()){var Tc=$c.q().qa(),Rc=$c.q().p();this.Sa(Tc);this.Sa(Rc);break a}}if(Xm(a)){var Mc=null===a?S():(new T).e((new q).a(a.Vd(),
a.ci()));if(!Mc.g()){var hd=Mc.q().qa(),Qc=Mc.q().p();this.Sa(hd);this.Sa(Qc);break a}}if(jn(a)){var rd=null===a?S():(new T).e(a.pb());if(!rd.g()){var od=rd.q();YM(this,od);break a}}if(dn(a)){var Zc=null===a?S():(new T).e((new q).a(a.Ae(),a.pb()));if(!Zc.g()){var nd=Zc.q().qa(),zd=Zc.q().p();this.Sa(nd);YM(this,zd);break a}}if(en(a)){var ud=null===a?S():(new T).e((new yi).sd(a.Vd(),a.Qd(),fn(a)));if(!ud.g()){var wd=ud.q().Bb,Bd=ud.q().qb,Ed=ud.q().Eb;this.Sa(wd);this.Sa(Bd);YM(this,Ed);break a}}if(gn(a)){var pd=
null===a?S():(new T).e((new yi).sd(a.yi(),a.Qe(),a.pb()));if(!pd.g()){var vd=pd.q().Bb,xd=pd.q().qb,ee=pd.q().Eb;this.Sa(vd);YM(this,xd);YM(this,ee);break a}}if(nn(a)){var Ld=null===a?S():(new T).e((new q).a(a.Qe(),a.pb()));if(!Ld.g()){var me=Ld.q().qa(),fe=Ld.q().p();YM(this,me);YM(this,fe);break a}}if(kn(a)){var Yd=null===a?S():(new T).e((new q).a(a.Vd(),a.cd()));if(!Yd.g()){var Zd=Yd.q().qa(),qe=Yd.q().p();this.Sa(Zd);this.Sa(qe);break a}}if(Ql(a)){var re=null===a?S():(new T).e((new q).a(a.ve(),
a.ub()));if(!re.g()){var Kd=re.q().qa(),yf=re.q().p();this.Sa(Kd);YM(this,yf);break a}}if(Mk(a)){var Cd=null===a?S():(new T).e((new yi).sd(a.Qa(),a.yb(),a.Qc()));if(!Cd.g()){var Fe=Cd.q().Bb,je=Cd.q().qb,xe=Cd.q().Eb;YM(this,Fe);this.Sa(je);this.Sa(xe);break a}}if(Hn(a)){var ge=null===a?S():(new T).e(sn(new tn,a.Qa(),a.xb(),a.bd(),a.ff(),a.ub()));if(!ge.g()){var ye=ge.q().Bb,ne=ge.q().qb,Ce=ge.q().Eb,hf=ge.q().hd,Pe=ge.q().Yf;YM(this,ye);this.Sa(ne);aN(this,Ce);this.Sa(hf);YM(this,Pe);break a}}if(In(a)){var jf=
null===a?S():(new T).e(Kn(a));if(!jf.g()){var ze=jf.q();YM(this,ze);break a}}if(ym(a)){var Me=null===a?S():(new T).e((new yi).sd(a.yi(),a.Qe(),a.pb()));if(!Me.g()){var $e=Me.q().Bb,kf=Me.q().qb,Ne=Me.q().Eb;this.Sa($e);YM(this,kf);YM(this,Ne);break a}}if(Tm(a)){var Ge=null===a?S():(new T).e((new q).a(a.Qe(),a.pb()));if(!Ge.g()){var se=Ge.q().qa(),lf=Ge.q().p();YM(this,se);YM(this,lf);break a}}if(fm(a)){var te=null===a?S():(new T).e((new q).a(a.Ae(),a.$g()));if(!te.g()){var De=te.q().qa(),Qe=te.q().p();
this.Sa(De);YM(this,Qe);break a}}if(jm(a)){var af=null===a?S():(new T).e((new q).a(a.mg(),a.Ld()));if(!af.g()){var of=af.q().qa(),df=af.q().p();this.Sa(of);this.Sa(df);break a}}if(Gm(a)){var mf=null===a?S():(new T).e(a.ob());if(!mf.g()){var Re=mf.q();this.Sa(Re);break a}}if(Mm(a)){var Xe=null===a?S():(new T).e(a.ob());if(!Xe.g()){var zf=Xe.q();this.Sa(zf);break a}}if(im(a)){var ef=null===a?S():(new T).e((new q).a(a.ob(),a.Db()));if(!ef.g()){var $d=ef.q().qa(),pf=ef.q().p();this.Sa($d);this.Sa(pf);
break a}}if(em(a)){var He=null===a?S():(new T).e((new q).a(a.ob(),a.Di()));if(!He.g()){var If=He.q().qa(),ug=He.q().p();this.Sa(If);YM(this,ug);break a}}if(Rm(a)){var Af=null===a?S():(new T).e(a.pb());if(!Af.g()){var vg=Af.q();YM(this,vg);break a}}if(km(a)){var Wf=null===a?S():(new T).e(a.ub());if(!Wf.g()){var Mh=Wf.q();YM(this,Mh);break a}}if(sm(a)){var Yg=null===a?S():(new T).e((new yi).sd(a.oi(),tm(a),um(a)));if(!Yg.g()){var Og=Yg.q().Bb,Pg=Yg.q().qb,Jf=Yg.q().Eb;this.Sa(Og);this.Sa(Pg);this.Sa(Jf);
break a}}if(Am(a)){var Zg=null===a?S():(new T).e((new q).a(a.ob(),a.ni()));if(!Zg.g()){var ji=Zg.q().qa(),jh=Zg.q().p();this.Sa(ji);YM(this,jh);break a}}if(Nm(a)){var $g=null===a?S():(new T).e((new yi).sd(a.ob(),Om(a),a.Vi()));if(!$g.g()){var Qg=$g.q().Bb,ij=$g.q().qb,ki=$g.q().Eb;this.Sa(Qg);YM(this,ij);$M(this,ki);break a}}if(Pm(a)){var lh=null===a?S():(new T).e((new yi).sd(a.ob(),Qm(a),a.Vi()));if(!lh.g()){var Nh=lh.q().Bb,xk=lh.q().qb,Kj=lh.q().Eb;this.Sa(Nh);this.Sa(xk);$M(this,Kj);break a}}if(rm(a)){var jj=
null===a?S():(new T).e((new q).a(a.me(),a.Nb()));if(!jj.g()){var Di=jj.q().qa(),Lj=jj.q().p();YM(this,Di);this.Sa(Lj);break a}}if(Dm(a)){var bh=null===a?S():(new T).e(a.ni());if(!bh.g()){var Oh=bh.q();YM(this,Oh);break a}}if(Sm(a)){var Ph=null===a?S():(new T).e((new q).a(a.ob(),a.Nb()));if(!Ph.g()){var Mj=Ph.q().qa(),fl=Ph.q().p();this.Sa(Mj);this.Sa(fl);break a}}if(lm(a)){var cg=null===a?S():(new T).e((new q).a(a.Nb(),a.ob()));if(!cg.g()){var Qh=cg.q().qa(),Wl=cg.q().p();this.Sa(Qh);this.Sa(Wl);
break a}}if(pm(a)){var Nj=null===a?S():(new T).e((new q).a(a.Ui(),a.Nb()));if(!Nj.g()){var Ei=Nj.q().qa(),Xl=Nj.q().p();YM(this,Ei);this.Sa(Xl);break a}}if(qm(a)){var Oj=null===a?S():(new T).e((new q).a(a.Ui(),a.Nb()));if(!Oj.g()){var Pj=Oj.q().qa(),Qj=Oj.q().p();YM(this,Pj);this.Sa(Qj);break a}}if(Bm(a)){var yk=null===a?S():(new T).e(a.ff());if(!yk.g()){var li=yk.q();this.Sa(li);break a}}if(Cm(a)){var mi=null===a?S():(new T).e(a.Qc());if(!mi.g()){var Zm=mi.q();this.Sa(Zm);break a}}if(!Em(a)){if(mm(a)){var wg=
null===a?S():(new T).e(a.ob());if(!wg.g()){var mh=wg.q();this.Sa(mh);break a}}if(Fm(a)){var Fi=null===a?S():(new T).e(a.ob());if(!Fi.g()){var gl=Fi.q();this.Sa(gl);break a}}if(vn(a)){var zk=null===a?S():(new T).e((new yi).sd(a.Qa(),a.Xd(),a.df()));if(!zk.g()){var Ye=zk.q().Bb,hl=zk.q().qb,Rj=zk.q().Eb;YM(this,Ye);YM(this,hl);this.Sa(Rj);break a}}if(wn(a)){var Rh=null===a?S():(new T).e((new yi).sd(a.Qa(),a.Xd(),a.df()));if(!Rh.g()){var $m=Rh.q().Bb,il=Rh.q().qb,Gi=Rh.q().Eb;YM(this,$m);YM(this,il);
this.Sa(Gi);break a}}if(rn(a)){var dg=null===a?S():(new T).e(sn(new tn,a.Qa(),a.yb(),a.lc(),a.bd(),a.df()));if(!dg.g()){var Hi=dg.q().Bb,ni=dg.q().qb,jl=dg.q().Eb,nh=dg.q().hd,Ak=dg.q().Yf;YM(this,Hi);this.Sa(ni);YM(this,jl);aN(this,nh);this.Sa(Ak);break a}}if(un(a)){var oh=null===a?S():(new T).e((new al).yd(a.Qa(),a.nc(),a.lc(),a.Gh()));if(!oh.g()){var Yl=oh.q().Bb,Sj=oh.q().qb,Bk=oh.q().Eb,Zl=oh.q().hd;YM(this,Yl);this.Sa(Sj);YM(this,Bk);this.Sa(Zl);break a}}if(Nk(a)){var xg=null===a?S():(new T).e((new al).yd(a.Qa(),
a.Xd(),a.sc(),a.Ld()));if(!xg.g()){var Tj=xg.q().Bb,Uj=xg.q().qb,Ii=xg.q().Eb,Vj=xg.q().hd;YM(this,Tj);YM(this,Uj);$M(this,Ii);this.Sa(Vj);break a}}if(Sk(a)){var Rg=null===a?S():(new T).e((new al).yd(a.Qa(),a.Xd(),a.sc(),Tk(a)));if(!Rg.g()){var kj=Rg.q().Bb,Ji=Rg.q().qb,ph=Rg.q().Eb,lj=Rg.q().hd;YM(this,kj);YM(this,Ji);$M(this,ph);$M(this,lj);break a}}if(Gk(a)){var Xf=null===a?S():(new T).e((new bm).ti(a.Qa(),a.yb(),a.lc(),a.bd(),a.sc(),a.Nb()));if(!Xf.g()){var Sh=Xf.q().Bb,Th=Xf.q().qb,mj=Xf.q().Eb,
qh=Xf.q().hd,oi=Xf.q().Yf,eg=Xf.q().rk;YM(this,Sh);this.Sa(Th);YM(this,mj);aN(this,qh);$M(this,oi);this.Sa(eg);break a}}if(Kk(a)){var rh=null===a?S():(new T).e((new bm).ti(a.Qa(),a.yb(),a.lc(),a.bd(),a.sc(),a.Nb()));if(!rh.g()){var Wj=rh.q().Bb,Uh=rh.q().qb,Vh=rh.q().Eb,Ck=rh.q().hd,Wh=rh.q().Yf,nj=rh.q().rk;YM(this,Wj);this.Sa(Uh);YM(this,Vh);aN(this,Ck);$M(this,Wh);this.Sa(nj);break a}}if(Qk(a)){var sh=null===a?S():(new T).e((new al).yd(a.Qa(),a.nc(),a.lc(),Rk(a)));if(!sh.g()){var oj=sh.q().Bb,
Dk=sh.q().qb,kl=sh.q().Eb,Xh=sh.q().hd;YM(this,oj);this.Sa(Dk);YM(this,kl);this.Sa(Xh);break a}}if(Ok(a)){var Ki=null===a?S():(new T).e(sn(new tn,a.Qa(),a.nc(),a.lc(),a.jh(),a.Qc()));if(!Ki.g()){var an=Ki.q().Bb,ll=Ki.q().qb,bn=Ki.q().Eb,$l=Ki.q().hd,Xj=Ki.q().Yf;YM(this,an);this.Sa(ll);YM(this,bn);this.Sa($l);this.Sa(Xj);break a}}if(Pk(a)){var pi=null===a?S():(new T).e(sn(new tn,a.Qa(),a.nc(),a.lc(),a.jh(),a.Qc()));if(!pi.g()){var am=pi.q().Bb,Yj=pi.q().qb,cn=pi.q().Eb,Ek=pi.q().hd,wo=pi.q().Yf;
YM(this,am);this.Sa(Yj);YM(this,cn);this.Sa(Ek);this.Sa(wo);break a}}if(Lk(a)){var pj=null===a?S():(new T).e((new yi).sd(a.Qa(),a.yb(),a.Qc()));if(!pj.g()){var Ey=pj.q().Bb,vo=pj.q().qb,Gy=pj.q().Eb;YM(this,Ey);this.Sa(vo);this.Sa(Gy);break a}}if(Vl(a)){var kh=null===a?S():(new T).e((new bm).ti(a.Qa(),a.xb(),a.lc(),a.am(),a.im(),a.ym()));if(!kh.g()){var fr=kh.q().Bb,hJ=kh.q().qb,cJ=kh.q().Eb,dJ=kh.q().hd,gJ=kh.q().Yf,Fy=kh.q().rk;YM(this,fr);this.Sa(hJ);YM(this,cJ);this.Sa(dJ);YM(this,gJ);YM(this,
Fy);break a}}if(Rl(a)){var dr=null===a?S():(new T).e((new q).a(a.xb(),a.sc()));if(!dr.g()){var er=dr.q().qa(),hB=dr.q().p();this.Sa(er);$M(this,hB);break a}}if(Gn(a)){var Fl=null===a?S():(new T).e((new yi).sd(a.Qa(),a.xb(),a.bd()));if(!Fl.g()){var xs=Fl.q().Bb,RL=Fl.q().qb,SL=Fl.q().Eb;YM(this,xs);this.Sa(RL);aN(this,SL);break a}}if(yl(a)){var iB=null===a?S():(new T).e(a.ff());if(!iB.g()){var TL=iB.q();this.Sa(TL);break a}}if(El(a)){var jB=null===a?S():(new T).e(a.gg());if(!jB.g()){var ys=jB.q();
this.Sa(ys);break a}}if(Hl(a)){var op=null===a?S():(new T).e(a.gg());if(!op.g()){var zs=op.q();this.Sa(zs);break a}}if(!(AD(a)||zH(a)||AH(a)||BH(a)||CH(a)||DH(a)||Cl(a)||Dl(a)||BD(a)||a&&a.$classData&&a.$classData.H.EC||a&&a.$classData&&a.$classData.H.FC||CD(a))){if(Dn(a)){var As=null===a?S():(new T).e((new q).a(a.Re(),a.Ld()));if(!As.g()){var UL=As.q().qa(),Bs=As.q().p();this.Sa(UL);this.Sa(Bs);break a}}if(Fn(a)){var Cs=null===a?S():(new T).e((new q).a(a.Re(),a.Ld()));if(!Cs.g()){var VL=Cs.q().qa(),
xn=Cs.q().p();this.Sa(VL);this.Sa(xn);break a}}if(En(a)){var pp=null===a?S():(new T).e(a.oi());if(!pp.g()){var Ds=pp.q();this.Sa(Ds);break a}}throw(new p).e(a);}}}}}}}}};function aN(a,b){Xca||(Xca=(new wr).c());for(b=ZM(b);b.fb();)YM(a,b.bb())}function bN(){this.tk=this.Sx=this.Vx=this.cy=this.by=null;this.ra=0}bN.prototype=new m;bN.prototype.constructor=bN;
bN.prototype.c=function(){cN=this;(new dN).c();eN||(eN=(new fN).c());vja||(vja=(new gN).c());Xo();vk();hN();G();F();wja||(wja=(new iN).c());jN||(jN=(new kN).c());this.Vx=jN;lN||(lN=(new mN).c());this.Sx=lN;nN();xja||(xja=(new oN).c());this.tk=uk();yja||(yja=(new pN).c());qN();zja||(zja=(new rN).c());Aja||(Aja=(new sN).c());Bja||(Bja=(new tN).c());Cja||(Cja=(new uN).c());ida||(ida=(new rs).c());Dja||(Dja=(new vN).c());Eja||(Eja=(new wN).c());Fja||(Fja=(new xN).c());Gja||(Gja=(new yN).c());return this};
function bt(){var a=fj();0===(2&a.ra)&&0===(2&a.ra)&&(a.cy=Bj(),a.ra|=2);return a.cy}bN.prototype.$classData=l({f1:0},!1,"scala.package$",{f1:1,f:1});var cN=void 0;function fj(){cN||(cN=(new bN).c());return cN}function zN(){this.ql=null}zN.prototype=new m;zN.prototype.constructor=zN;zN.prototype.c=function(){AN=this;BN();CN();this.ql=DN();EN();FN();GN();HN();IN();JN();Hja||(Hja=(new KN).c());wI();Ija||(Ija=(new LN).c());Jja();Kja();return this};
zN.prototype.$classData=l({h1:0},!1,"scala.reflect.ClassManifestFactory$",{h1:1,f:1});var AN=void 0;function MN(){}MN.prototype=new m;MN.prototype.constructor=MN;MN.prototype.c=function(){return this};MN.prototype.$classData=l({k1:0},!1,"scala.reflect.ManifestFactory$",{k1:1,f:1});var Lja=void 0;function NN(){}NN.prototype=new m;NN.prototype.constructor=NN;NN.prototype.c=function(){ON=this;AN||(AN=(new zN).c());Lja||(Lja=(new MN).c());return this};
NN.prototype.$classData=l({A1:0},!1,"scala.reflect.package$",{A1:1,f:1});var ON=void 0;function Oe(){ON||(ON=(new NN).c())}function PN(){}PN.prototype=new m;PN.prototype.constructor=PN;PN.prototype.c=function(){return this};PN.prototype.$classData=l({B1:0},!1,"scala.sys.package$",{B1:1,f:1});var Mja=void 0;function QN(){this.Qo=null}QN.prototype=new m;QN.prototype.constructor=QN;QN.prototype.v=function(){return"DynamicVariable("+this.Qo+")"};QN.prototype.e=function(a){this.Qo=a;return this};
QN.prototype.$classData=l({C1:0},!1,"scala.util.DynamicVariable",{C1:1,f:1});function RN(){}RN.prototype=new m;RN.prototype.constructor=RN;RN.prototype.c=function(){(new SN).c();return this};RN.prototype.$classData=l({I1:0},!1,"scala.util.control.Breaks",{I1:1,f:1});function TN(){}TN.prototype=new m;TN.prototype.constructor=TN;TN.prototype.c=function(){return this};
function ho(a,b){return b&&b.$classData&&b.$classData.H.L5||b&&b.$classData&&b.$classData.H.K5||b&&b.$classData&&b.$classData.H.I5||b&&b.$classData&&b.$classData.H.J5||b&&b.$classData&&b.$classData.H.CE?S():(new T).e(b)}TN.prototype.$classData=l({K1:0},!1,"scala.util.control.NonFatal$",{K1:1,f:1});var UN=void 0;function io(){UN||(UN=(new TN).c());return UN}function VN(){}VN.prototype=new m;VN.prototype.constructor=VN;function Nja(){}Nja.prototype=VN.prototype;
VN.prototype.bn=function(a,b){b=fa(-862048943,b);b=fa(461845907,b<<15|b>>>17|0);return a^b};VN.prototype.Gb=function(a,b){a=this.bn(a,b);return-430675100+fa(5,a<<13|a>>>19|0)|0};function WN(a){var b=XN(),c=a.M();if(0===c)return a=a.U(),Da(Ga(),a);for(var d=-889275714,f=0;f<c;)d=b.Gb(d,YN(Y(),a.W(f))),f=1+f|0;return b.xd(d,c)}
function ZN(a,b,c){var d=(new JM).mc(0),f=(new JM).mc(0),g=(new JM).mc(0),h=(new JM).mc(1);b.Cb(lk(function(a,b,c,d,f){return function(a){a=YN(Y(),a);b.cb=b.cb+a|0;c.cb^=a;0!==a&&(f.cb=fa(f.cb,a));d.cb=1+d.cb|0}}(a,d,f,g,h)));b=a.Gb(c,d.cb);b=a.Gb(b,f.cb);b=a.bn(b,h.cb);return a.xd(b,g.cb)}VN.prototype.xd=function(a,b){a^=b;a=fa(-2048144789,a^(a>>>16|0));a=fa(-1028477387,a^(a>>>13|0));return a^(a>>>16|0)};
function Oja(a,b,c){var d=(new JM).mc(0);c=(new JM).mc(c);b.Cb(lk(function(a,b,c){return function(d){c.cb=a.Gb(c.cb,YN(Y(),d));b.cb=1+b.cb|0}}(a,d,c)));return a.xd(c.cb,d.cb)}function $N(){}$N.prototype=new m;$N.prototype.constructor=$N;$N.prototype.c=function(){return this};function Pja(a,b){a=fa(-1640532531,b);aO();return fa(-1640532531,a<<24|16711680&a<<8|65280&(a>>>8|0)|a>>>24|0)}$N.prototype.$classData=l({M1:0},!1,"scala.util.hashing.package$",{M1:1,f:1});var bO=void 0;
function Qja(){bO||(bO=(new $N).c());return bO}function mN(){}mN.prototype=new m;mN.prototype.constructor=mN;mN.prototype.c=function(){return this};mN.prototype.Nx=function(a){if(a.g())return S();var b=a.ag();a=a.Ze();return(new T).e((new q).a(b,a))};mN.prototype.$classData=l({N1:0},!1,"scala.collection.$colon$plus$",{N1:1,f:1});var lN=void 0;function kN(){}kN.prototype=new m;kN.prototype.constructor=kN;kN.prototype.c=function(){return this};
kN.prototype.Nx=function(a){if(a.g())return S();var b=a.n();a=a.o();return(new T).e((new q).a(b,a))};kN.prototype.$classData=l({O1:0},!1,"scala.collection.$plus$colon$",{O1:1,f:1});var jN=void 0;function cO(){this.Pg=null}cO.prototype=new m;cO.prototype.constructor=cO;cO.prototype.c=function(){dO=this;this.Pg=(new eO).c();return this};cO.prototype.$classData=l({T1:0},!1,"scala.collection.Iterator$",{T1:1,f:1});var dO=void 0;function hN(){dO||(dO=(new cO).c());return dO}
function Id(a,b,c){a.rf(b,c,fO(gO(),b)-c|0)}function jG(a,b){b=b.mj();b.$c(a.dc());return b.da()}function gG(a,b,c,d){return a.qg((new ql).c(),b,c,d).Qb.ac}function hO(a,b,c){b=(new Uk).e(b);a.Cb(lk(function(a,b,c){return function(a){c.cb=b.ug(c.cb,a)}}(a,c,b)));return b.cb}function iO(a){var b=(new JM).mc(0);a.Cb(lk(function(a,b){return function(){b.cb=1+b.cb|0}}(a,b)));return b.cb}
function Rja(a,b){if(a.g())throw(new Gq).j("empty.min");return a.$e(Wm(function(a,b){return function(a,c){return 0>=b.Ie(a,c)?a:c}}(a,b)))}function jO(a,b,c,d,f){var g=(new Kl).qj(!0);rl(b,c);a.Cb(lk(function(a,b,c,d){return function(a){if(d.cb)sl(b,a),d.cb=!1;else return rl(b,c),sl(b,a)}}(a,b,d,g)));rl(b,f);return b}function Sja(a,b){if(a.g())throw(new Gq).j("empty.max");return a.$e(Wm(function(a,b){return function(a,c){return 0<=b.Ie(a,c)?a:c}}(a,b)))}
function kO(a,b){return a.ph()?(b=b.xa(a.Za()),a.ih(b,0),b):a.we().Cn(b)}function cj(a){return!a.g()}function lO(a,b){if(a.g())throw(new Gq).j("empty.reduceLeft");var c=(new Kl).qj(!0),d=(new Uk).e(0);a.Cb(lk(function(a,b,c,d){return function(a){c.cb?(d.cb=a,c.cb=!1):d.cb=b.ug(d.cb,a)}}(a,b,c,d)));return d.cb}function Vo(){this.IE=null}Vo.prototype=new m;Vo.prototype.constructor=Vo;Vo.prototype.Lv=function(a){this.IE=a;return this};
Vo.prototype.$classData=l({d2:0},!1,"scala.collection.TraversableOnce$FlattenOps",{d2:1,f:1});function Uo(){this.eG=null}Uo.prototype=new m;Uo.prototype.constructor=Uo;Uo.prototype.Lv=function(a){this.eG=a;return this};Uo.prototype.$classData=l({f2:0},!1,"scala.collection.TraversableOnce$MonadOps",{f2:1,f:1});function Tja(a,b){return(new mO).Ms(Rq(function(a,b){return function(){return null===b?null:b&&b.$classData&&b.$classData.H.b7&&b.c7()===nO()?b.t7():oO(new rO,nO(),b)}}(a,b)))}
function BO(a,b){return(new mO).Ms(Rq(function(a,b){return function(){return null===b?null:b&&b.$classData&&b.$classData.H.j2&&b.m2()===nO()?b.U4():Uja(new CO,nO(),b)}}(a,b)))}function mO(){this.Wd=null}mO.prototype=new m;mO.prototype.constructor=mO;mO.prototype.Ms=function(a){this.Wd=a;return this};mO.prototype.$classData=l({g2:0},!1,"scala.collection.convert.Decorators$AsScala",{g2:1,f:1});function DO(){}DO.prototype=new m;DO.prototype.constructor=DO;function Vja(){}Vja.prototype=DO.prototype;
function Fu(){var a=Wja(),b=F();return a.ic().$c(b).da()}DO.prototype.ic=function(){return A(new B,this.KA())};function EO(){}EO.prototype=new m;EO.prototype.constructor=EO;function FO(){}FO.prototype=EO.prototype;function uu(a,b){if(b.g())return a.Yj();a=a.ic();a.$c(b);return a.da()}EO.prototype.Yj=function(){return this.ic().da()};function Xja(a,b){var c=a.qe().ic();a.dc().Cb(lk(function(a,b,c){return function(a){return c.$c(b.Ea(a).dc())}}(a,b,c)));return c.da()}
function Yja(a,b){a:for(;;){if(cj(b)){a.ee(b.n());b=b.o();continue a}break}}function GO(a,b){b&&b.$classData&&b.$classData.H.Co?Yja(a,b):b.Cb(lk(function(a){return function(b){return a.ee(b)}}(a)));return a}function HO(){}HO.prototype=new m;HO.prototype.constructor=HO;function IO(){}IO.prototype=HO.prototype;function oN(){}oN.prototype=new m;oN.prototype.constructor=oN;oN.prototype.c=function(){return this};
oN.prototype.$classData=l({i3:0},!1,"scala.collection.immutable.Stream$$hash$colon$colon$",{i3:1,f:1});var xja=void 0;function JO(){this.aG=null}JO.prototype=new m;JO.prototype.constructor=JO;JO.prototype.Ms=function(a){this.aG=a;return this};function Zja(a,b){return KO(b,a.aG)}JO.prototype.$classData=l({j3:0},!1,"scala.collection.immutable.Stream$ConsWrapper",{j3:1,f:1});function LO(){this.Ax=this.Qo=null;this.ra=!1;this.r=null}LO.prototype=new m;LO.prototype.constructor=LO;
function MO(a,b,c){a.Ax=c;if(null===b)throw jo(wj(),null);a.r=b;return a}function NO(a){a.ra||(a.ra||(a.Qo=OO(a.Ax),a.ra=!0),a.Ax=null);return a.Qo}LO.prototype.$classData=l({o3:0},!1,"scala.collection.immutable.StreamIterator$LazyCell",{o3:1,f:1});function PO(){}PO.prototype=new m;PO.prototype.constructor=PO;PO.prototype.c=function(){return this};function Vn(a,b,c,d){a=0>c?0:c;return d<=a||a>=(b.length|0)?"":b.substring(a,d>(b.length|0)?b.length|0:d)}
PO.prototype.$classData=l({q3:0},!1,"scala.collection.immutable.StringOps$",{q3:1,f:1});var QO=void 0;function Wn(){QO||(QO=(new PO).c());return QO}function RO(){}RO.prototype=new m;RO.prototype.constructor=RO;RO.prototype.c=function(){return this};RO.prototype.ic=function(){var a=(new ql).c();return $ja(new SO,a,lk(function(){return function(a){return(new ds).j(a)}}(this)))};RO.prototype.$classData=l({y3:0},!1,"scala.collection.immutable.WrappedString$",{y3:1,f:1});var TO=void 0;function UO(){}
UO.prototype=new m;UO.prototype.constructor=UO;UO.prototype.c=function(){return this};UO.prototype.$classData=l({C3:0},!1,"scala.collection.mutable.ArrayOps$ofBoolean$",{C3:1,f:1});var aka=void 0;function VO(){}VO.prototype=new m;VO.prototype.constructor=VO;VO.prototype.c=function(){return this};VO.prototype.$classData=l({D3:0},!1,"scala.collection.mutable.ArrayOps$ofByte$",{D3:1,f:1});var bka=void 0;function WO(){}WO.prototype=new m;WO.prototype.constructor=WO;WO.prototype.c=function(){return this};
WO.prototype.$classData=l({E3:0},!1,"scala.collection.mutable.ArrayOps$ofChar$",{E3:1,f:1});var cka=void 0;function XO(){}XO.prototype=new m;XO.prototype.constructor=XO;XO.prototype.c=function(){return this};XO.prototype.$classData=l({F3:0},!1,"scala.collection.mutable.ArrayOps$ofDouble$",{F3:1,f:1});var dka=void 0;function YO(){}YO.prototype=new m;YO.prototype.constructor=YO;YO.prototype.c=function(){return this};
YO.prototype.$classData=l({G3:0},!1,"scala.collection.mutable.ArrayOps$ofFloat$",{G3:1,f:1});var eka=void 0;function ZO(){}ZO.prototype=new m;ZO.prototype.constructor=ZO;ZO.prototype.c=function(){return this};ZO.prototype.$classData=l({H3:0},!1,"scala.collection.mutable.ArrayOps$ofInt$",{H3:1,f:1});var fka=void 0;function $O(){}$O.prototype=new m;$O.prototype.constructor=$O;$O.prototype.c=function(){return this};
$O.prototype.$classData=l({I3:0},!1,"scala.collection.mutable.ArrayOps$ofLong$",{I3:1,f:1});var gka=void 0;function aP(){}aP.prototype=new m;aP.prototype.constructor=aP;aP.prototype.c=function(){return this};aP.prototype.$classData=l({J3:0},!1,"scala.collection.mutable.ArrayOps$ofRef$",{J3:1,f:1});var hka=void 0;function bP(){}bP.prototype=new m;bP.prototype.constructor=bP;bP.prototype.c=function(){return this};
bP.prototype.$classData=l({K3:0},!1,"scala.collection.mutable.ArrayOps$ofShort$",{K3:1,f:1});var ika=void 0;function cP(){}cP.prototype=new m;cP.prototype.constructor=cP;cP.prototype.c=function(){return this};cP.prototype.$classData=l({L3:0},!1,"scala.collection.mutable.ArrayOps$ofUnit$",{L3:1,f:1});var jka=void 0;function kka(a){return dP(aO(),-1+a.Vc.i.length|0)}function lka(a,b){b=tba(b);return mka(a,b)}
function nka(a,b){var c=a.nk;b=Pja(Qja(),b);a=-1+a.Vc.i.length|0;return((b>>>c|0|b<<(-c|0))>>>(32-dP(aO(),a)|0)|0)&a}
function mka(a,b){for(var c=Ca(b),c=nka(a,c),d=a.Vc.i[c];null!==d;){if(dj(ej(),d,b))return!1;c=(1+c|0)%a.Vc.i.length|0;d=a.Vc.i[c]}a.Vc.i[c]=b;a.fg=1+a.fg|0;null!==a.og&&(b=c>>5,c=a.og,c.i[b]=1+c.i[b]|0);if(a.fg>=a.Ej)for(b=a.Vc,a.Vc=oa(bc(Ab),[a.Vc.i.length<<1]),a.fg=0,null!==a.og&&(c=1+(a.Vc.i.length>>5)|0,a.og.i.length!==c?a.og=oa(bc(yc),[c]):ada(Qr(),a.og)),a.nk=kka(a),a.Ej=oka().oq(a.sk,a.Vc.i.length),c=0;c<b.i.length;)d=b.i[c],null!==d&&mka(a,d),c=1+c|0;return!0}
function pka(a,b){b=tba(b);for(var c=Ca(b),c=nka(a,c),d=a.Vc.i[c];null!==d&&!dj(ej(),d,b);)c=(1+c|0)%a.Vc.i.length|0,d=a.Vc.i[c];return d}function eP(){}eP.prototype=new m;eP.prototype.constructor=eP;eP.prototype.c=function(){return this};
eP.prototype.oq=function(a,b){if(!(500>a))throw(new fP).e("assertion failed: loadFactor too large; must be \x3c 0.5");var c=b>>31,d=a>>31,f=65535&b,g=b>>>16|0,h=65535&a,n=a>>>16|0,u=fa(f,h),h=fa(g,h),w=fa(f,n),f=u+((h+w|0)<<16)|0,u=(u>>>16|0)+w|0;a=(((fa(b,d)+fa(c,a)|0)+fa(g,n)|0)+(u>>>16|0)|0)+(((65535&u)+h|0)>>>16|0)|0;return Fp(ab(),f,a,1E3,0)};eP.prototype.$classData=l({P3:0},!1,"scala.collection.mutable.FlatHashTable$",{P3:1,f:1});var gP=void 0;
function oka(){gP||(gP=(new eP).c());return gP}function hP(){}hP.prototype=new m;hP.prototype.constructor=hP;hP.prototype.c=function(){return this};hP.prototype.v=function(){return"NullSentinel"};hP.prototype.A=function(){return 0};hP.prototype.$classData=l({R3:0},!1,"scala.collection.mutable.FlatHashTable$NullSentinel$",{R3:1,f:1});var iP=void 0;function uba(){iP||(iP=(new hP).c());return iP}function qka(a){return dP(aO(),-1+a.Vc.i.length|0)}
function rka(a,b,c){for(a=a.Vc.i[c];;)if(null!==a?(c=a.Gi(),c=!dj(ej(),c,b)):c=!1,c)a=a.bb();else break;return a}function jP(a,b){var c=-1+a.Vc.i.length|0,d=ha(c);a=a.nk;b=Pja(Qja(),b);return((b>>>a|0|b<<(-a|0))>>>d|0)&c}function ska(a){a.du(750);kP();a.Nt(oa(bc(wba),[lP(0,16)]));a.Mo(0);var b=a.sk,c=kP();kP();a.Pt(c.oq(b,lP(0,16)));a.Kt(null);a.xx(qka(a))}
function tka(a,b){var c=YN(Y(),b),c=jP(a,c),d=a.Vc.i[c];if(null!==d){var f=d.Gi();if(dj(ej(),f,b))return a.Vc.i[c]=d.bb(),a.Mo(-1+a.fg|0),uka(a,c),d.qo(null),d;for(f=d.bb();;){if(null!==f)var g=f.Gi(),g=!dj(ej(),g,b);else g=!1;if(g)d=f,f=f.bb();else break}if(null!==f)return d.qo(f.bb()),a.Mo(-1+a.fg|0),uka(a,c),f.qo(null),f}return null}function mP(a){for(var b=-1+a.Vc.i.length|0;null===a.Vc.i[b]&&0<b;)b=-1+b|0;return b}
function nP(a,b,c){var d=YN(Y(),b),d=jP(a,d),f=rka(a,b,d);if(null!==f)return f;b=a.mA(b,c);vka(a,b,d);return null}function oP(a,b){var c=YN(Y(),b),c=jP(a,c);return rka(a,b,c)}
function vka(a,b,c){b.qo(a.Vc.i[c]);a.Vc.i[c]=b;a.Mo(1+a.fg|0);pP(a,c);if(a.fg>a.Ej){b=a.Vc.i.length<<1;c=a.Vc;a.Nt(oa(bc(wba),[b]));if(null!==a.og){var d=1+(a.Vc.i.length>>5)|0;a.og.i.length!==d?a.Kt(oa(bc(yc),[d])):ada(Qr(),a.og)}for(d=-1+c.i.length|0;0<=d;){for(var f=c.i[d];null!==f;){var g=f.Gi(),g=YN(Y(),g),g=jP(a,g),h=f.bb();f.qo(a.Vc.i[g]);a.Vc.i[g]=f;f=h;pP(a,g)}d=-1+d|0}a.Pt(kP().oq(a.sk,b))}}function uka(a,b){null!==a.og&&(a=a.og,b>>=5,a.i[b]=-1+a.i[b]|0)}
function pP(a,b){null!==a.og&&(a=a.og,b>>=5,a.i[b]=1+a.i[b]|0)}function qP(){}qP.prototype=new m;qP.prototype.constructor=qP;qP.prototype.c=function(){return this};function lP(a,b){return 1<<(-ha(-1+b|0)|0)}qP.prototype.oq=function(a,b){var c=b>>31,d=a>>31,f=65535&b,g=b>>>16|0,h=65535&a,n=a>>>16|0,u=fa(f,h),h=fa(g,h),w=fa(f,n),f=u+((h+w|0)<<16)|0,u=(u>>>16|0)+w|0;a=(((fa(b,d)+fa(c,a)|0)+fa(g,n)|0)+(u>>>16|0)|0)+(((65535&u)+h|0)>>>16|0)|0;return Fp(ab(),f,a,1E3,0)};
qP.prototype.$classData=l({X3:0},!1,"scala.collection.mutable.HashTable$",{X3:1,f:1});var rP=void 0;function kP(){rP||(rP=(new qP).c());return rP}function sP(){}sP.prototype=new m;sP.prototype.constructor=sP;sP.prototype.c=function(){return this};sP.prototype.$classData=l({m4:0},!1,"scala.scalajs.js.ArrayOps$",{m4:1,f:1});var wka=void 0;function tP(){}tP.prototype=new m;tP.prototype.constructor=tP;tP.prototype.c=function(){return this};
function KL(a,b){var c={};b.St(lk(function(){return function(a){return null!==a}}(a))).Cb(lk(function(a,b){return function(a){if(null!==a)b[a.qa()]=a.p();else throw(new p).e(a);}}(a,c)));return c}tP.prototype.$classData=l({n4:0},!1,"scala.scalajs.js.Dictionary$",{n4:1,f:1});var uP=void 0;function LL(){uP||(uP=(new tP).c());return uP}function QL(){}QL.prototype=new m;QL.prototype.constructor=QL;QL.prototype.c=function(){return this};
function nja(a,b){if(b&&b.$classData&&b.$classData.H.PF)return b.Rf;if(b&&b.$classData&&b.$classData.H.RF)return b.Da;var c=[];b.Cb(lk(function(a,b){return function(a){return b.push(a)|0}}(a,c)));return c}QL.prototype.$classData=l({o4:0},!1,"scala.scalajs.js.JSConverters$JSRichGenTraversableOnce$",{o4:1,f:1});var PL=void 0;function vP(){this.dk=null}vP.prototype=new m;vP.prototype.constructor=vP;vP.prototype.c=function(){wP=this;this.dk=ca.Object.prototype.hasOwnProperty;return this};
vP.prototype.$classData=l({r4:0},!1,"scala.scalajs.js.WrappedDictionary$Cache$",{r4:1,f:1});var wP=void 0;function as(){wP||(wP=(new vP).c());return wP}function xP(){this.Zl=!1;this.rv=this.ho=this.xp=null;this.Uu=!1;this.jw=this.sv=0}xP.prototype=new m;xP.prototype.constructor=xP;
xP.prototype.c=function(){yP=this;this.xp=(this.Zl=!!(ca.ArrayBuffer&&ca.Int32Array&&ca.Float32Array&&ca.Float64Array))?new ca.ArrayBuffer(8):null;this.ho=this.Zl?new ca.Int32Array(this.xp,0,2):null;this.Zl&&new ca.Float32Array(this.xp,0,2);this.rv=this.Zl?new ca.Float64Array(this.xp,0,1):null;if(this.Zl)this.ho[0]=16909060,a=1===((new ca.Int8Array(this.xp,0,8))[0]|0);else var a=!0;this.sv=(this.Uu=a)?0:1;this.jw=this.Uu?1:0;return this};
function kaa(a,b){var c=b|0;if(c===b&&-Infinity!==1/b)return c;if(a.Zl)a.rv[0]=b,a=(new Ep).K(a.ho[a.jw]|0,a.ho[a.sv]|0);else{if(b!==b)a=!1,b=2047,c=+ca.Math.pow(2,51);else if(Infinity===b||-Infinity===b)a=0>b,b=2047,c=0;else if(0===b)a=-Infinity===1/b,c=b=0;else{var d=(a=0>b)?-b:b;if(d>=+ca.Math.pow(2,-1022)){b=+ca.Math.pow(2,52);var c=+ca.Math.log(d)/.6931471805599453,c=+ca.Math.floor(c)|0,c=1023>c?c:1023,f=+ca.Math.pow(2,c);f>d&&(c=-1+c|0,f/=2);f=d/f*b;d=+ca.Math.floor(f);f-=d;d=.5>f?d:.5<f?1+
d:0!==d%2?1+d:d;2<=d/b&&(c=1+c|0,d=1);1023<c?(c=2047,d=0):(c=1023+c|0,d-=b);b=c;c=d}else b=d/+ca.Math.pow(2,-1074),c=+ca.Math.floor(b),d=b-c,b=0,c=.5>d?c:.5<d?1+c:0!==c%2?1+c:c}c=+c;a=(new Ep).K(c|0,(a?-2147483648:0)|(b|0)<<20|c/4294967296|0)}return a.Ra^a.Ya}
function xka(a){var b=a.Ya,c=0>b,d=2047&b>>20;a=4294967296*(1048575&b)+ +(a.Ra>>>0);return 2047===d?0!==a?NaN:c?-Infinity:Infinity:0<d?(d=+ca.Math.pow(2,-1023+d|0)*(1+a/+ca.Math.pow(2,52)),c?-d:d):0!==a?(d=+ca.Math.pow(2,-1022)*(a/+ca.Math.pow(2,52)),c?-d:d):c?-0:0}xP.prototype.$classData=l({A4:0},!1,"scala.scalajs.runtime.Bits$",{A4:1,f:1});var yP=void 0;function Ha(){yP||(yP=(new xP).c());return yP}function zP(){this.ra=!1}zP.prototype=new m;zP.prototype.constructor=zP;
function zj(a,b,c){return b.substring((b.length|0)-(c.length|0)|0)===c}zP.prototype.c=function(){return this};
function yka(a,b,c,d){if(null===b)throw(new fk).c();a=AP().vB.exec(c);if(null!==a){a=a[1];if(void 0===a)throw(new BP).j("undefined.get");a=(new T).e((new q).a(zka(a),0))}else a=S();if(a.g()){var f=AP().uB.exec(c);if(null!==f){a=f[0];if(void 0===a)throw(new BP).j("undefined.get");a=c.substring(a.length|0);var g=f[1];if(void 0===g)var h=0;else{var g=(new cd).j(g),h=g.ka.length|0,n=0,u=0;a:for(;;){if(n!==h){var w=1+n|0,n=g.rc(n),n=null===n?0:n.pa,u=u|0|Aka(AP(),n),n=w;continue a}break}h=u|0}f=f[2];if(void 0===
f)f=h;else{f=(new cd).j(f);g=f.ka.length|0;w=0;n=h;a:for(;;){if(w!==g){h=1+w|0;w=f.rc(w);w=null===w?0:w.pa;n=(n|0)&~Aka(AP(),w);w=h;continue a}break}f=n|0}a=(new T).e((new q).a(a,f))}else a=S()}a=a.g()?(new q).a(c,0):a.q();if(null===a)throw(new p).e(a);f=a.bu();a=new ca.RegExp(a.qa(),"g"+(0!==(2&f)?"i":"")+(0!==(8&f)?"m":""));f=new CP;f.Xm=a;f.Zx=c;b=pa(b);if(""===b)for(c=(new r).d([""]),d=c.Da.length|0,d=oa(bc(sa),[d]),b=0,c=Cp(new Dp,c,c.Da.length|0);c.fb();)a=c.bb(),d.i[b]=a,b=1+b|0;else{c=0<d?
d:2147483647;g=b.length|0;a=new DP;a.cC=f;a.gB=b;a.kC=0;a.jC=g;f=a.cC;g=new ca.RegExp(f.Xm);f=g!==f.Xm?g:new ca.RegExp(f.Xm.source,(f.Xm.global?"g":"")+(f.Xm.ignoreCase?"i":"")+(f.Xm.multiline?"m":""));a.vo=f;a.hB=pa(Oa(a.gB,a.kC,a.jC));a.Ym=null;a.Yu=!0;S();f=[];for(g=h=0;g<(-1+c|0)&&Bka(a);)0!==a.wa()&&(w=a.ab(),h=b.substring(h,w),f.push(null===h?null:h),g=1+g|0),h=a.wa();b=b.substring(h);f.push(null===b?null:b);b=na(bc(sa),f);if(0!==d)d=b;else{for(d=b.i.length;0!==d&&""===b.i[-1+d|0];)d=-1+d|0;
d===b.i.length?d=b:(c=oa(bc(sa),[d]),Ta(b,0,c,0,d),d=c)}}return d}function EP(a,b){a=b.length|0;for(var c=oa(bc(jc),[a]),d=0;d<a;)c.i[d]=65535&(b.charCodeAt(d)|0),d=1+d|0;return c}function mba(a,b,c){a=Cka(c);return b.indexOf(a)|0}function kr(a,b,c,d){a=c+d|0;if(0>c||a<c||a>b.i.length)throw(new FP).c();for(d="";c!==a;)d=""+d+ca.String.fromCharCode(b.i[c]),c=1+c|0;return d}function GP(a,b,c){a=b.toLowerCase();c=c.toLowerCase();return a===c?0:a<c?-1:1}
function Cka(a){if(0===(-65536&a))return ca.String.fromCharCode(a);if(0>a||1114111<a)throw(new t).c();a=-65536+a|0;return ca.String.fromCharCode(55296|a>>10,56320|1023&a)}function Da(a,b){a=0;for(var c=1,d=-1+(b.length|0)|0;0<=d;)a=a+fa(65535&(b.charCodeAt(d)|0),c)|0,c=fa(31,c),d=-1+d|0;return a}function xI(a,b){var c=(new HP).c();a=Dka(Eka(c,a,b)).v();c.Es();return a}zP.prototype.$classData=l({C4:0},!1,"scala.scalajs.runtime.RuntimeString$",{C4:1,f:1});var IP=void 0;
function Ga(){IP||(IP=(new zP).c());return IP}function JP(){this.lB=!1;this.hA=this.qA=this.pA=null;this.ra=0}JP.prototype=new m;JP.prototype.constructor=JP;JP.prototype.c=function(){return this};
function Fka(a){return(a.stack+"\n").replace(KP("^[\\s\\S]+?\\s+at\\s+")," at ").replace(LP("^\\s+(at eval )?at\\s+","gm"),"").replace(LP("^([^\\(]+?)([\\n])","gm"),"{anonymous}() ($1)$2").replace(LP("^Object.\x3canonymous\x3e\\s*\\(([^\\)]+)\\)","gm"),"{anonymous}() ($1)").replace(LP("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$","gm"),"$1@$2").split("\n").slice(0,-1)}function Gka(a){0===(8&a.ra)&&0===(8&a.ra)&&(a.hA=ca.Object.keys(Hka(a)),a.ra|=8);return a.hA}
function Ika(a){if(0===(2&a.ra)&&0===(2&a.ra)){for(var b={O:"java_lang_Object",T:"java_lang_String",V:"scala_Unit",Z:"scala_Boolean",C:"scala_Char",B:"scala_Byte",S:"scala_Short",I:"scala_Int",J:"scala_Long",F:"scala_Float",D:"scala_Double"},c=0;22>=c;)2<=c&&(b["T"+c]="scala_Tuple"+c),b["F"+c]="scala_Function"+c,c=1+c|0;a.pA=b;a.ra|=2}return a.pA}
function Jka(a,b){var c=KP("^(?:Object\\.|\\[object Object\\]\\.)?(?:ScalaJS\\.c\\.|\\$c_)([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$"),d=KP("^(?:Object\\.|\\[object Object\\]\\.)?(?:ScalaJS\\.(?:s|f)\\.|\\$(?:s|f)_)((?:_[^_]|[^_])+)__([^\\.]+)$"),f=KP("^(?:Object\\.|\\[object Object\\]\\.)?(?:ScalaJS\\.m\\.|\\$m_)([^\\.]+)$"),g=!1,c=c.exec(b);null===c&&(c=d.exec(b),null===c&&(c=f.exec(b),g=!0));if(null!==c){b=c[1];if(void 0===b)throw(new BP).j("undefined.get");b=36===(65535&(b.charCodeAt(0)|0))?b.substring(1):
b;d=Ika(a);if(as().dk.call(d,b)){a=Ika(a);if(!as().dk.call(a,b))throw(new BP).j("key not found: "+b);a=a[b]}else a:for(f=0;;)if(f<(Gka(a).length|0)){d=Gka(a)[f];if(0<=(b.length|0)&&b.substring(0,d.length|0)===d){a=Hka(a);if(!as().dk.call(a,d))throw(new BP).j("key not found: "+d);a=""+a[d]+b.substring(d.length|0);break a}f=1+f|0}else{a=0<=(b.length|0)&&"L"===b.substring(0,1)?b.substring(1):b;break a}a=a.split("_").join(".").split("$und").join("_");if(g)g="\x3cclinit\x3e";else{g=c[2];if(void 0===g)throw(new BP).j("undefined.get");
0<=(g.length|0)&&"init___"===g.substring(0,7)?g="\x3cinit\x3e":(c=g.indexOf("__")|0,g=0>c?g:g.substring(0,c))}return(new q).a(a,g)}return(new q).a("\x3cjscode\x3e",b)}function Kka(a){var b=LP("Line (\\d+).*script (?:in )?(\\S+)","i");a=a.message.split("\n");for(var c=[],d=2,f=a.length|0;d<f;){var g=b.exec(a[d]);if(null!==g){var h=g[2];if(void 0===h)throw(new BP).j("undefined.get");g=g[1];if(void 0===g)throw(new BP).j("undefined.get");c.push("{anonymous}()@"+h+":"+g)}d=2+d|0}return c}
function Hka(a){0===(4&a.ra)&&0===(4&a.ra)&&(a.qA={sjsr_:"scala_scalajs_runtime_",sjs_:"scala_scalajs_",sci_:"scala_collection_immutable_",scm_:"scala_collection_mutable_",scg_:"scala_collection_generic_",sc_:"scala_collection_",sr_:"scala_runtime_",s_:"scala_",jl_:"java_lang_",ju_:"java_util_"},a.ra|=4);return a.qA}JP.prototype.$classData=l({D4:0},!1,"scala.scalajs.runtime.StackTrace$",{D4:1,f:1});var MP=void 0;function NP(){}NP.prototype=new m;NP.prototype.constructor=NP;NP.prototype.c=function(){return this};
function LP(a,b){OP||(OP=(new NP).c());return new ca.RegExp(a,b)}function KP(a){OP||(OP=(new NP).c());return new ca.RegExp(a)}NP.prototype.$classData=l({E4:0},!1,"scala.scalajs.runtime.StackTrace$StringRE$",{E4:1,f:1});var OP=void 0;function PP(){}PP.prototype=new m;PP.prototype.constructor=PP;PP.prototype.c=function(){return this};function jo(a,b){return QP(b)?b.yl:b}function vj(a,b){return b&&b.$classData&&b.$classData.H.vd?b:(new RP).e(b)}
PP.prototype.$classData=l({F4:0},!1,"scala.scalajs.runtime.package$",{F4:1,f:1});var SP=void 0;function wj(){SP||(SP=(new PP).c());return SP}function TP(){}TP.prototype=new m;TP.prototype.constructor=TP;TP.prototype.c=function(){return this};function Lka(a,b){if(Od(b))return a.pa===b.pa;if(UP(b)){if("number"===typeof b)return+b===a.pa;if(ya(b)){b=Ya(b);var c=b.Ya;a=a.pa;return b.Ra===a&&c===a>>31}return null===b?null===a:Aa(b,a)}return null===a&&null===b}
function dj(a,b,c){if(b===c)c=!0;else if(UP(b))a:if(UP(c))c=Mka(0,b,c);else{if(Od(c)){if("number"===typeof b){c=+b===c.pa;break a}if(ya(b)){a=Ya(b);b=a.Ya;c=c.pa;c=a.Ra===c&&b===c>>31;break a}}c=null===b?null===c:Aa(b,c)}else c=Od(b)?Lka(b,c):null===b?null===c:Aa(b,c);return c}
function Mka(a,b,c){if("number"===typeof b)return a=+b,"number"===typeof c?a===+c:ya(c)?(b=Ya(c),c=b.Ra,b=b.Ya,a===sM(ab(),c,b)):VP(c)?c.w(a):!1;if(ya(b)){b=Ya(b);a=b.Ra;b=b.Ya;if(ya(c)){c=Ya(c);var d=c.Ya;return a===c.Ra&&b===d}return"number"===typeof c?(c=+c,sM(ab(),a,b)===c):VP(c)?c.w((new Ep).K(a,b)):!1}return null===b?null===c:Aa(b,c)}TP.prototype.$classData=l({J4:0},!1,"scala.runtime.BoxesRunTime$",{J4:1,f:1});var WP=void 0;function ej(){WP||(WP=(new TP).c());return WP}
var XP=l({N4:0},!1,"scala.runtime.Null$",{N4:1,f:1});function YP(){}YP.prototype=new m;YP.prototype.constructor=YP;YP.prototype.c=function(){return this};YP.prototype.$classData=l({P4:0},!1,"scala.runtime.RichChar$",{P4:1,f:1});var Nka=void 0;function ZP(){Nka||(Nka=(new YP).c())}function $P(){}$P.prototype=new m;$P.prototype.constructor=$P;$P.prototype.c=function(){return this};
function fO(a,b){if(Nd(b,1)||Sc(b,1)||Wc(b,1)||Uc(b,1)||Vc(b,1)||Nc(b,1)||Oc(b,1)||Pc(b,1)||Kc(b,1)||aQ(b))return b.i.length;if(null===b)throw(new fk).c();throw(new p).e(b);}
function bQ(a,b,c,d){if(Nd(b,1))b.i[c]=d;else if(Sc(b,1))b.i[c]=d|0;else if(Wc(b,1))b.i[c]=+d;else if(Uc(b,1))b.i[c]=Ya(d);else if(Vc(b,1))b.i[c]=+d;else if(Nc(b,1))b.i[c]=null===d?0:d.pa;else if(Oc(b,1))b.i[c]=d|0;else if(Pc(b,1))b.i[c]=d|0;else if(Kc(b,1))b.i[c]=!!d;else if(aQ(b))b.i[c]=void 0;else{if(null===b)throw(new fk).c();throw(new p).e(b);}}function cQ(a){gO();var b=a.L();return gG(b,a.U()+"(",",",")")}
function Oka(a,b,c){if(Nd(b,1)||Sc(b,1)||Wc(b,1)||Uc(b,1)||Vc(b,1))return b.i[c];if(Nc(b,1))return(new ed).db(b.i[c]);if(Oc(b,1)||Pc(b,1)||Kc(b,1)||aQ(b))return b.i[c];if(null===b)throw(new fk).c();throw(new p).e(b);}$P.prototype.$classData=l({Q4:0},!1,"scala.runtime.ScalaRunTime$",{Q4:1,f:1});var dQ=void 0;function gO(){dQ||(dQ=(new $P).c());return dQ}function eQ(){}eQ.prototype=new m;eQ.prototype.constructor=eQ;e=eQ.prototype;e.c=function(){return this};
e.bn=function(a,b){b=fa(-862048943,b);b=fa(461845907,b<<15|b>>>17|0);return a^b};function fQ(a,b){a=Sa(b);if(a===b)return a;var c=ab();a=gQ(c,b);c=c.dd;return sM(ab(),a,c)===b?a^c:kaa(Ha(),b)}function YN(a,b){return null===b?0:"number"===typeof b?fQ(0,+b):ya(b)?(a=Ya(b),hQ(0,(new Ep).K(a.Ra,a.Ya))):Ca(b)}e.Gb=function(a,b){a=this.bn(a,b);return-430675100+fa(5,a<<13|a>>>19|0)|0};function hQ(a,b){a=b.Ra;b=b.Ya;return b===a>>31?a:a^b}
e.xd=function(a,b){a^=b;a=fa(-2048144789,a^(a>>>16|0));a=fa(-1028477387,a^(a>>>13|0));return a^(a>>>16|0)};e.$classData=l({S4:0},!1,"scala.runtime.Statics$",{S4:1,f:1});var iQ=void 0;function Y(){iQ||(iQ=(new eQ).c());return iQ}function gk(){this.iG=this.hn=null}gk.prototype=new XM;gk.prototype.constructor=gk;gk.prototype.Sa=function(a){Yc(a).ab()<=this.hn.pa&&this.hn.pa<=Yc(a).wa()&&(this.iG.ba(a),WM.prototype.Sa.call(this,a))};
gk.prototype.$classData=l({pG:0},!1,"ch.epfl.scala.accessible.Breadcrumbs$visit$2$",{pG:1,zE:1,f:1});function Vk(){this.bv=this.kG=this.mC=null}Vk.prototype=new XM;Vk.prototype.constructor=Vk;Vk.prototype.Sa=function(a){if(this.kG.Ea(a)){var b=this.mC.fa();if(null===a?null!==b:a!==b)this.bv.cb=jQ(a,this.bv.cb);WM.prototype.Sa.call(this,a)}};Vk.prototype.$classData=l({uG:0},!1,"ch.epfl.scala.accessible.Cursor$navigate$2$",{uG:1,zE:1,f:1});function kQ(){}kQ.prototype=new m;
kQ.prototype.constructor=kQ;kQ.prototype.c=function(){return this};function Pka(a,b,c){if(null===c)throw(new fk).c();if(c.Hg)a=c.Ab;else{var d=new lQ;d.hn=a;d.TA=b;a=hk(c,d)}return a}function Jba(a,b,c){a=(new ik).c();var d=S(),d=(new Uk).e(d);(a.Hg?a.Ab:Pka(c,d,a)).Sa(b);return d.cb}kQ.prototype.$classData=l({zG:0},!1,"ch.epfl.scala.accessible.package$",{zG:1,f:1,Z4:1});var mQ=void 0;function Kba(){mQ||(mQ=(new kQ).c());return mQ}function lQ(){this.TA=this.hn=null}lQ.prototype=new XM;
lQ.prototype.constructor=lQ;lQ.prototype.Sa=function(a){Yc(a).ab()<=this.hn.pa&&this.hn.pa<=Yc(a).wa()&&(this.TA.cb=(new T).e(a),WM.prototype.Sa.call(this,a))};lQ.prototype.$classData=l({AG:0},!1,"ch.epfl.scala.accessible.package$findPos$3$",{AG:1,zE:1,f:1});function nQ(){Ho.call(this);this.lu=this.$x=this.pu=this.tr=null}nQ.prototype=new Zba;nQ.prototype.constructor=nQ;function Qka(){}Qka.prototype=nQ.prototype;
nQ.prototype.c=function(){DN();oQ();var a;pQ||(pQ=(new qQ).c());a=pQ;rQ();this.Ba=a;this.yy=(new sQ).Ne(this.Ba);Rka||(Rka=(new tQ).c());Ska||(Ska=(new uQ).c());a=this.Ba;var b=new vQ;b.Jh="AnyChar";wQ.prototype.Ne.call(b,a);b.Fg="AnyChar";this.$x=b;null===this.pu&&null===this.pu&&(this.pu=(new xQ).xv(this));null===this.tr&&null===this.tr&&(this.tr=(new yQ).xv(this));this.lu=this.tr;bca||(bca=(new Ko).c());Tka||(Tka=(new zQ).c());return this};
function Bia(a,b){var c=new AQ;b=uu(Xo(),(new r).d([b]));oQ();a=a.Ba;c.po="CharsWhileIn";c.Ko=b;c.oo=1;fj();b=dca($o(),b);BQ.prototype.Kv.call(c,(new IL).e(b),0,a);return c}function OK(a){var b=IK();return 1===(a.length|0)?(a=65535&(a.charCodeAt(0)|0),(new CQ).Tp((new ed).db(a),b.Ba)):(new DQ).Tp(a,b.Ba)}function yQ(){this.r=null}yQ.prototype=new $ba;yQ.prototype.constructor=yQ;
function Kia(a,b){var c=new EQ;oQ();a=a.r.Ba;c.tj="CharPred";c.uo=b;c.tq=!1;$o();fj();b=(new HL).e(b);BQ.prototype.Kv.call(c,b,0,a);return c}yQ.prototype.xv=function(a){Io.prototype.wv.call(this,a);return this};yQ.prototype.$classData=l({FG:0},!1,"fastparse.StringApi$ElemPred$",{FG:1,a5:1,f:1});function xQ(){this.r=null}xQ.prototype=new aca;xQ.prototype.constructor=xQ;xQ.prototype.xv=function(a){Jo.prototype.wv.call(this,a);return this};
xQ.prototype.$classData=l({GG:0},!1,"fastparse.StringApi$ElemsWhile$",{GG:1,b5:1,f:1});function qQ(){}qQ.prototype=new kca;qQ.prototype.constructor=qQ;qQ.prototype.c=function(){return this};
function Yo(a){lca||(lca=(new ep).c());a=gda(To(),a);var b=(new ql).c();SH(b,34);for(var c=0,d=a.Fa();c<d;){var f=a.rc(c),g=null===f?0:f.pa;switch(g){case 34:rl(b,'\\"');break;case 92:rl(b,"\\\\");break;case 8:rl(b,"\\b");break;case 12:rl(b,"\\f");break;case 10:rl(b,"\\n");break;case 13:rl(b,"\\r");break;case 9:rl(b,"\\t");break;default:if(32>g||126<g){var f=(new cd).j("\\u%04x"),h=[g];Ga();f=f.ka;Xo();pl();for(var g=[],n=0,u=h.length|0;n<u;)g.push(vI(h[n])),n=1+n|0;wI();for(var h=g.length|0,h=oa(bc(Ab),
[h]),w=h.i.length,u=n=0,D=g.length|0,w=D<w?D:w,D=h.i.length,w=w<D?w:D;n<w;)h.i[u]=g[n],n=1+n|0,u=1+u|0;rl(b,xI(f,h))}else SH(b,g)}c=1+c|0}SH(b,34);return b.Qb.ac}function FQ(a,b,c){return Vn(Wn(),a,b,c)}function Uka(a,b){if(a&&a.$classData&&a.$classData.H.Au){a=a.Ve;for(var c=1,d=1,f=0;f<b;)10===(65535&(a.charCodeAt(f)|0))?(d=1,c=1+c|0):d=1+d|0,f=1+f|0;return td((new yd).X((new r).d(["",":",""])),(new r).d([c,d]))}return""+b}
qQ.prototype.$classData=l({HG:0},!1,"fastparse.StringReprOps$",{HG:1,p5:1,f:1});var pQ=void 0;function GQ(){}GQ.prototype=new m;GQ.prototype.constructor=GQ;GQ.prototype.c=function(){return this};GQ.prototype.$classData=l({JG:0},!1,"fastparse.core.Implicits$Optioner$UnitOptioner$",{JG:1,f:1,f5:1});var HQ=void 0;function IQ(){}IQ.prototype=new m;IQ.prototype.constructor=IQ;IQ.prototype.c=function(){return this};
IQ.prototype.$classData=l({KG:0},!1,"fastparse.core.Implicits$Repeater$UnitRepeater$",{KG:1,f:1,g5:1});var JQ=void 0;function Vka(){JQ||(JQ=(new IQ).c());return JQ}function KQ(){this.lg=null}KQ.prototype=new m;KQ.prototype.constructor=KQ;KQ.prototype.vv=function(a){this.lg=a;return this};KQ.prototype.ug=function(a,b){return this.lg.ug(a,b)};KQ.prototype.$classData=l({MG:0},!1,"fastparse.core.Implicits$Sequencer$$anon$1",{MG:1,f:1,h5:1});
function LQ(){this.Cx=this.u=this.Mx=null;this.XF=0;this.zg=null;this.va=0;this.ra=!1}LQ.prototype=new m;LQ.prototype.constructor=LQ;LQ.prototype.v=function(){var a=(20>(this.u.Ve.length|0)&&(this.u.Ve.length|0)===(this.u.Ve.length|0)?"":"...")+FQ(this.u.Ve,-20+(this.u.Ve.length|0)|0,this.u.Ve.length|0);return td((new yd).X((new r).d(["Extra(",", [traced - not evaluated])"])),(new r).d([a]))};
function uia(a){if(!a.ra){MQ||(MQ=(new NQ).c());var b=a.u,c=a.va,d=a.zg,f=a.XF,g=a.Cx,f=g.Dd(tia(new rI,b,c,g,f,Wka(function(){return function(){}}(MQ))),f),g=f.Fi;uk();var h=vk().$d,g=H(g,h);a.Mx=Xka(new OQ,b,c,Yka(g),f.nd.ki(d));a.ra=!0}a.Cx=null;a.zg=null;return a.Mx}LQ.prototype.$classData=l({QG:0},!1,"fastparse.core.Parsed$Failure$Extra$Impl",{QG:1,f:1,j5:1});function PQ(){this.r=null}PQ.prototype=new m;PQ.prototype.constructor=PQ;
PQ.prototype.v=function(){var a=this.r.nd,b=lk(function(a){return function(b){return No(Po(),b,a.Fk())}}(this)),c=QQ(),c=RQ(c);return SQ(a,b,c).Pd(" | ")};PQ.prototype.Fk=function(){return 1===this.r.nd.Za()?this.r.nd.n().Fk():Po().Vt};PQ.prototype.$classData=l({SG:0},!1,"fastparse.core.Parsed$TracedFailure$$anon$1",{SG:1,f:1,jg:1});function JK(){this.qh=this.Bj=this.ka=null}JK.prototype=new cca;JK.prototype.constructor=JK;function Dia(a,b){var c=Vka();return Zka(a.Bj,1,b,c,a.qh)}
function SK(a){var b=Vka();return Zka(a.Bj,0,(new WK).Ne(a.qh),b,a.qh)}
function QK(a,b){$ka||($ka=(new TQ).c());var c=fj().tk;b=[a.Bj,b];if(0===(b.length|0))c=c.Ci;else{for(var c=(new Hk).c(),d=0,f=b.length|0;d<f;)Ik(c,b[d]),d=1+d|0;c=Jk(c)}b=new UQ;d=c;uk();vk();uk();c=(new Hk).c();for(d=Ss(d);d.om;){if((f=d.bb())&&f.$classData&&f.$classData.H.xu)f=f.Bg;else{var g=fj().tk,f=[f];if(0===(f.length|0))f=g.Ci;else{for(var g=(new Hk).c(),h=0,n=f.length|0;h<n;)Ik(g,f[h]),h=1+h|0;f=Jk(g)}}f=f.dc();GO(c,f)}c=Jk(c);a=a.qh;b.Bg=c;wQ.prototype.Ne.call(b,a);b.it=c.Cn((new mv).Ud(k(ala)));
b.pw=b.it.i.length;return b}JK.prototype.Wa=function(a,b){this.Bj=a;this.qh=b;Lo.prototype.Ne.call(this,b);return this};function Hia(a,b){return(new VQ).yv(a.Bj,b,a.qh)}function KK(a){HQ||(HQ=(new GQ).c());var b=HQ,c=a.qh,d=new WQ;d.Fc=a.Bj;d.Dm=b;wQ.prototype.Ne.call(d,c);return d}function Jia(a,b){return(new XQ).yv(a.Bj,b,a.qh)}function RK(a,b){var c=bla();return YQ(cla(),dla(a.Bj,b,!1,c,a.qh),a.qh)}function Iia(a){var b=a.qh,c=new ZQ;c.Fc=a.Bj;c.mq="Name";wQ.prototype.Ne.call(c,b);return c}
function Gia(a){return(new $Q).Wa(a.Bj,a.qh)}function PK(a,b){var c=bla();return YQ(cla(),dla(a.Bj,b,!0,c,a.qh),a.qh)}function TK(a){return(new aR).Wa(a.Bj,a.qh)}JK.prototype.$classData=l({TG:0},!1,"fastparse.core.ParserApiImpl",{TG:1,k5:1,f:1});function bR(){}bR.prototype=new m;bR.prototype.constructor=bR;bR.prototype.c=function(){return this};bR.prototype.$classData=l({cH:0},!1,"fastparse.utils.ElemSetHelper$CharBitSetHelper$",{cH:1,f:1,n5:1});var ela=void 0;
function oQ(){ela||(ela=(new bR).c())}function Wo(){this.mB=null}Wo.prototype=new ica;Wo.prototype.constructor=Wo;Wo.prototype.FI=function(a){for(var b=this.mB;b.fb();){var c=b.bb();a.GI(c)}};function eca(a,b){a.mB=b;return a}Wo.prototype.$classData=l({fH:0},!1,"fastparse.utils.Generator$Iter",{fH:1,dH:1,f:1});l({gH:0},!1,"fastparse.utils.Generator$Pred",{gH:1,dH:1,f:1});l({hH:0},!1,"fastparse.utils.Generator$PredCallback",{hH:1,eH:1,f:1});function cR(){}cR.prototype=new m;
cR.prototype.constructor=cR;function fla(){}fla.prototype=cR.prototype;function dR(){this.Wz=null;this.lo=this.ov=0}dR.prototype=new m;dR.prototype.constructor=dR;dR.prototype.Ea=function(a){return this.la(a)};dR.prototype.v=function(){return"\x3cfunction1\x3e"};dR.prototype.la=function(a){a=null===a?0:a.pa;if(a>this.lo||a<this.ov)return!1;a=a-this.ov|0;return 0!==(this.Wz.i[a>>5]&1<<(31&a))};dR.prototype.$classData=l({jH:0},!1,"fastparse.utils.Utils$BitSet",{jH:1,f:1,Mb:1});
function eR(){this.Yz=null}eR.prototype=new jca;eR.prototype.constructor=eR;function gla(a){var b=new eR;b.Yz=a;return b}eR.prototype.GI=function(a){this.Yz.$c((new r).d([a]))};eR.prototype.$classData=l({lH:0},!1,"fastparse.utils.Utils$BitSet$BitsetComputeCallback",{lH:1,eH:1,f:1});function fR(){this.Bp=this.$z=null;this.ra=0}fR.prototype=new m;fR.prototype.constructor=fR;function hla(){}hla.prototype=fR.prototype;fR.prototype.MI=function(a){this.Bp=a;return this};
fR.prototype.w=function(a){return a&&a.$classData&&a.$classData.H.MH?this.Bp===a.Bp:!1};fR.prototype.v=function(){return this.Bp};fR.prototype.A=function(){return YN(Y(),this.Bp)};function gR(){}gR.prototype=new m;gR.prototype.constructor=gR;function hR(){}hR.prototype=gR.prototype;function UP(a){return!!(a&&a.$classData&&a.$classData.H.bk||"number"===typeof a)}function iR(){this.Pp=this.lq=this.Pn=null;this.Dp=this.iq=0}iR.prototype=new m;iR.prototype.constructor=iR;
iR.prototype.w=function(a){return a&&a.$classData&&a.$classData.H.CB?this.Pp===a.Pp&&this.iq===a.iq&&this.Pn===a.Pn&&this.lq===a.lq:!1};
iR.prototype.v=function(){var a="";"\x3cjscode\x3e"!==this.Pn&&(a=""+a+this.Pn+".");a=""+a+this.lq;null===this.Pp?a+="(Unknown Source)":(a=""+a+td((new yd).X((new r).d(["(",""])),(new r).d([this.Pp])),0<=this.iq&&(a=""+a+td((new yd).X((new r).d([":",""])),(new r).d([this.iq])),0<=this.Dp&&(a=""+a+td((new yd).X((new r).d([":",""])),(new r).d([this.Dp])))),a+=")");return a};iR.prototype.A=function(){var a=this.Pn,a=Da(Ga(),a),b=this.lq;return a^Da(Ga(),b)};
iR.prototype.setColumnNumber=function(a){this.Dp=a|0};iR.prototype.getColumnNumber=function(){return this.Dp};var ila=l({CB:0},!1,"java.lang.StackTraceElement",{CB:1,f:1,k:1});iR.prototype.$classData=ila;function Rn(){this.zn=this.Hs=this.Sl=null}Rn.prototype=new m;Rn.prototype.constructor=Rn;function jR(){}jR.prototype=Rn.prototype;
Rn.prototype.Em=function(){if(void 0===ca.Error.captureStackTrace){try{var a={}.undef()}catch(b){if(a=vj(wj(),b),null!==a)if(QP(a))a=a.yl;else throw jo(wj(),a);else throw b;}this.stackdata=a}else ca.Error.captureStackTrace(this),this.stackdata=this;return this};Rn.prototype.Ak=function(){return this.Sl};Rn.prototype.v=function(){var a=Md(ra(this)),b=this.Ak();return null===b?a:a+": "+b};
function wC(a){if(null===a.zn){MP||(MP=(new JP).c());var b=MP,c=a.stackdata,d;if(c){if(0===(1&b.ra)&&0===(1&b.ra)){a:try{ca.Packages.org.mozilla.javascript.JavaScriptException,d=!0}catch(Q){d=vj(wj(),Q);if(null!==d){if(QP(d)){d=!1;break a}throw jo(wj(),d);}throw Q;}b.lB=d;b.ra|=1}if(b.lB)d=c.stack,d=(void 0===d?"":d).replace(LP("^\\s+at\\s+","gm"),"").replace(LP("^(.+?)(?: \\((.+)\\))?$","gm"),"$2@$1").replace(LP("\\r\\n?","gm"),"\n").split("\n");else if(c.arguments&&c.stack)d=Fka(c);else if(c.stack&&
c.sourceURL)d=c.stack.replace(LP("\\[native code\\]\\n","m"),"").replace(LP("^(?\x3d\\w+Error\\:).*$\\n","m"),"").replace(LP("^@","gm"),"{anonymous}()@").split("\n");else if(c.stack&&c.number)d=c.stack.replace(LP("^\\s*at\\s+(.*)$","gm"),"$1").replace(LP("^Anonymous function\\s+","gm"),"{anonymous}() ").replace(LP("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$","gm"),"$1@$2").split("\n").slice(1);else if(c.stack&&c.fileName)d=c.stack.replace(LP("(?:\\n@:0)?\\s+$","m"),"").replace(LP("^(?:\\((\\S*)\\))?@",
"gm"),"{anonymous}($1)@").split("\n");else if(c.message&&c["opera#sourceloc"])if(c.stacktrace)if(-1<c.message.indexOf("\n")&&c.message.split("\n").length>c.stacktrace.split("\n").length)d=Kka(c);else{d=LP("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$","i");for(var c=c.stacktrace.split("\n"),f=[],g=0,h=c.length|0;g<h;){var n=d.exec(c[g]);if(null!==n){var u=n[3],u=void 0===u?"{anonymous}":u,w=n[2];if(void 0===w)throw(new BP).j("undefined.get");n=n[1];if(void 0===n)throw(new BP).j("undefined.get");
f.push(u+"()@"+w+":"+n)}g=2+g|0}d=f}else d=Kka(c);else if(c.message&&c.stack&&c.stacktrace){if(0>c.stacktrace.indexOf("called from line"))for(d=KP("^(.*)@(.+):(\\d+)$"),c=c.stacktrace.split("\n"),f=[],g=0,h=c.length|0;g<h;){n=d.exec(c[g]);if(null!==n){u=n[1];u=void 0===u?"global code":u+"()";w=n[2];if(void 0===w)throw(new BP).j("undefined.get");n=n[3];if(void 0===n)throw(new BP).j("undefined.get");f.push(u+"@"+w+":"+n)}g=1+g|0}else for(d=KP("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$"),
c=c.stacktrace.split("\n"),f=[],g=0,h=c.length|0;g<h;){n=d.exec(c[g]);if(null!==n){u=n[4];if(void 0===u)throw(new BP).j("undefined.get");w=n[1];if(void 0===w)throw(new BP).j("undefined.get");var D=n[2];if(void 0===D)throw(new BP).j("undefined.get");u=u+":"+w+":"+D;n=n[2];n=(void 0===n?"global code":n).replace(KP("\x3canonymous function: (\\S+)\x3e"),"$1").replace(KP("\x3canonymous function\x3e"),"{anonymous}");f.push(n+"@"+u)|0}g=2+g|0}d=f}else d=c.stack&&!c.fileName?Fka(c):[]}else d=[];f=d;g=KP("^([^\\@]*)\\@(.*):([0-9]+)$");
h=KP("^([^\\@]*)\\@(.*):([0-9]+):([0-9]+)$");c=[];for(d=0;d<(f.length|0);){n=f[d];if(null===n)throw(new fk).c();if(""!==n)if(u=h.exec(n),null!==u){n=u[1];if(void 0===n)throw(new BP).j("undefined.get");w=Jka(b,n);if(null===w)throw(new p).e(w);n=w.qa();w=w.p();D=u[2];if(void 0===D)throw(new BP).j("undefined.get");var N=u[3];if(void 0===N)throw(new BP).j("undefined.get");N=(new cd).j(N);N=kR(aO(),N.ka,10);u=u[4];if(void 0===u)throw(new BP).j("undefined.get");u=(new cd).j(u);u=kR(aO(),u.ka,10);c.push({declaringClass:n,
methodName:w,fileName:D,lineNumber:N,columnNumber:void 0===u?void 0:u})}else if(u=g.exec(n),null!==u){n=u[1];if(void 0===n)throw(new BP).j("undefined.get");w=Jka(b,n);if(null===w)throw(new p).e(w);n=w.qa();w=w.p();D=u[2];if(void 0===D)throw(new BP).j("undefined.get");u=u[3];if(void 0===u)throw(new BP).j("undefined.get");u=(new cd).j(u);u=kR(aO(),u.ka,10);c.push({declaringClass:n,methodName:w,fileName:D,lineNumber:u,columnNumber:void 0})}else c.push({declaringClass:"\x3cjscode\x3e",methodName:n,fileName:null,
lineNumber:-1,columnNumber:void 0})|0;d=1+d|0}b=aa.sourceMapper;b=void 0===b?c:b(c);c=oa(bc(ila),[b.length|0]);for(d=0;d<(b.length|0);)f=b[d],g=f.methodName,h=f.fileName,n=f.lineNumber|0,u=new iR,u.Pn=f.declaringClass,u.lq=g,u.Pp=h,u.iq=n,u.Dp=-1,g=u,f=f.columnNumber,void 0!==f&&g.setColumnNumber(f|0),c.i[d]=g,d=1+d|0;a.zn=c}return a.zn}
function ko(a){var b=Er().kv,b=function(a,b){return function(a){zo(b,null===a?"null":a);zo(b,"\n")}}(a,b);wC(a);var c=a.v();b(c);if(0!==a.zn.i.length)for(c=0;c<a.zn.i.length;)b("  at "+a.zn.i[c]),c=1+c|0;else b("  \x3cno stack trace available\x3e");for(;;)if(a!==a.Hs&&null!==a.Hs){var d=wC(a);a=a.Hs;var c=wC(a),f=c.i.length,g=d.i.length,h="Caused by: "+a.v();b(h);if(0!==f){for(h=0;;){if(h<f&&h<g)var n=c.i[-1+(f-h|0)|0],u=d.i[-1+(g-h|0)|0],n=null===n?null===u:n.w(u);else n=!1;if(n)h=1+h|0;else break}0<
h&&(h=-1+h|0);d=f-h|0;for(f=0;f<d;)b("  at "+c.i[f]),f=1+f|0;0<h&&b("  ... "+h+" more")}else b("  \x3cno stack trace available\x3e")}else break}Rn.prototype.fd=function(a,b){this.Sl=a;this.Hs=b;this.Em();return this};function lR(){}lR.prototype=new m;lR.prototype.constructor=lR;function jla(){}jla.prototype=lR.prototype;
lR.prototype.w=function(a){if(a===this)return!0;if(a&&a.$classData&&a.$classData.H.JJ&&this.Za()===a.Za()){var b=mR(),c=(new nR).Vp(this);return OO(Tja(b,c).Wd).Le(lk(function(a,b){return function(a){var c=MM(b,a.bg);a=a.pa;return null===c?null===a:Aa(c,a)}}(this,a)))}return!1};
lR.prototype.v=function(){var a=mR(),b=(new nR).Vp(this),b=kla(b),a=OO(BO(a,b).Wd),a=Ro(new So,a,lk(function(){return function(a){return td((new yd).X((new r).d(["","\x3d",""])),(new r).d([a.bg,a.pa]))}}(this)));return gG(a,"{",", ","}")};lR.prototype.A=function(){var a=mR(),b=(new nR).Vp(this);return OO(Tja(a,b).Wd).se(0,Wm(function(){return function(a,b){a|=0;return Zca(Lr(),b)+a|0}}(this)))|0};function oR(){this.r=this.ew=this.Ov=null}oR.prototype=new m;oR.prototype.constructor=oR;
function lla(){}lla.prototype=oR.prototype;oR.prototype.bb=function(){this.ew=(new T).e(this.Ov.bb());var a=this.ew.q(),b=new pR;if(null===this)throw jo(wj(),null);b.Lb=this;qR.prototype.a.call(b,a.Dl,this.Lb.dr.Kl.Ea(a));return b};oR.prototype.fb=function(){return this.Ov.fb()};oR.prototype.Vp=function(a){if(null===a)throw jo(wj(),null);this.r=a;this.Ov=a.Kl.JB().Jb();this.ew=S();return this};function rR(){this.r=this.lo=this.Uv=null}rR.prototype=new m;rR.prototype.constructor=rR;
rR.prototype.bb=function(){this.lo=(new T).e(this.Uv.bb().Dl);return this.lo.q()};rR.prototype.fb=function(){return this.Uv.fb()};rR.prototype.$classData=l({FJ:0},!1,"java.util.HashSet$$anon$1",{FJ:1,f:1,HJ:1});function DP(){this.gB=this.cC=null;this.jC=this.kC=0;this.Ym=this.hB=this.vo=null;this.Yu=!1}DP.prototype=new m;DP.prototype.constructor=DP;
function Bka(a){if(a.Yu){a.Ym=a.vo.exec(a.hB);if(null!==a.Ym){var b=a.Ym[0];if(void 0===b)throw(new BP).j("undefined.get");if(null===b)throw(new fk).c();""===b&&(b=a.vo,b.lastIndex=1+(b.lastIndex|0)|0)}else a.Yu=!1;S();return null!==a.Ym}return!1}function mla(a){if(null===a.Ym)throw(new Cq).j("No match available");return a.Ym}DP.prototype.wa=function(){var a=this.ab(),b=mla(this)[0];if(void 0===b)throw(new BP).j("undefined.get");return a+(b.length|0)|0};
DP.prototype.ab=function(){return mla(this).index|0};DP.prototype.$classData=l({OJ:0},!1,"java.util.regex.Matcher",{OJ:1,f:1,R5:1});function sR(){}sR.prototype=new m;sR.prototype.constructor=sR;sR.prototype.mj=function(){Rs();uk();return(new Hk).c()};sR.prototype.mi=function(){Rs();uk();return(new Hk).c()};sR.prototype.$classData=l({ZJ:0},!1,"scala.LowPriorityImplicits$$anon$4",{ZJ:1,f:1,Go:1});function tR(){}tR.prototype=new m;tR.prototype.constructor=tR;tR.prototype.c=function(){return this};
tR.prototype.mj=function(){return(new ql).c()};tR.prototype.mi=function(){return(new ql).c()};tR.prototype.$classData=l({jK:0},!1,"scala.Predef$$anon$3",{jK:1,f:1,Go:1});function uR(){this.mm=null}uR.prototype=new m;uR.prototype.constructor=uR;e=uR.prototype;e.Lo=function(a,b){return(new vR).Bl(this.mm,a,b)};e.v=function(){var a=this.mm,b=(new ql).c(),c;c=!0;rl(b,"");for(var d=0,f=a.i.length;d<f;){var g=(new ed).db(a.i[d]);c?(sl(b,g),c=!1):(rl(b,""),sl(b,g));d=1+d|0}rl(b,"");return b.Qb.ac};
e.Uk=function(a){this.mm=a;return this};e.Fa=function(){return this.mm.i.length};e.Vj=function(a){return this.mm.i[a]};e.$classData=l({kK:0},!1,"scala.Predef$ArrayCharSequence",{kK:1,f:1,ko:1});function nla(a,b){switch(b){case 0:return a.Bb;case 1:return a.qb;case 2:return a.Eb;case 3:return a.hd;default:throw(new W).j(""+b);}}function ola(a,b){switch(b){case 0:return a.Bb;case 1:return a.qb;case 2:return a.Eb;case 3:return a.hd;case 4:return a.Yf;default:throw(new W).j(""+b);}}
function pla(a,b){switch(b){case 0:return a.Bb;case 1:return a.qb;case 2:return a.Eb;case 3:return a.hd;case 4:return a.Yf;case 5:return a.rk;default:throw(new W).j(""+b);}}function wR(){qs.call(this)}wR.prototype=new hda;wR.prototype.constructor=wR;function xR(a,b){var c=new wR;qs.prototype.RI.call(c,a,b);return c}wR.prototype.$classData=l({zK:0},!1,"scala.math.Integral$IntegralOps",{zK:1,o6:1,f:1});function yR(){}yR.prototype=new m;yR.prototype.constructor=yR;yR.prototype.c=function(){return this};
yR.prototype.la=function(a){return Gn(a)};yR.prototype.$classData=l({bL:0},!1,"scala.meta.Ctor$Primary$sharedClassifier$",{bL:1,f:1,na:1});var zR=void 0;function AR(){}AR.prototype=new m;AR.prototype.constructor=AR;AR.prototype.c=function(){return this};AR.prototype.la=function(a){return Hn(a)};AR.prototype.$classData=l({fL:0},!1,"scala.meta.Ctor$Secondary$sharedClassifier$",{fL:1,f:1,na:1});var BR=void 0;function qla(){BR||(BR=(new AR).c());return BR}function CR(){}CR.prototype=new m;
CR.prototype.constructor=CR;CR.prototype.c=function(){return this};CR.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.vw)};CR.prototype.$classData=l({gL:0},!1,"scala.meta.Ctor$sharedClassifier$",{gL:1,f:1,na:1});var DR=void 0;function ER(){DR||(DR=(new CR).c());return DR}function FR(){}FR.prototype=new m;FR.prototype.constructor=FR;FR.prototype.c=function(){return this};FR.prototype.la=function(a){return vn(a)};
FR.prototype.$classData=l({qL:0},!1,"scala.meta.Decl$Val$sharedClassifier$",{qL:1,f:1,na:1});var GR=void 0;function HR(){}HR.prototype=new m;HR.prototype.constructor=HR;HR.prototype.c=function(){return this};HR.prototype.la=function(a){return wn(a)};HR.prototype.$classData=l({uL:0},!1,"scala.meta.Decl$Var$sharedClassifier$",{uL:1,f:1,na:1});var IR=void 0;function JR(){}JR.prototype=new m;JR.prototype.constructor=JR;JR.prototype.c=function(){return this};JR.prototype.la=function(a){return Nk(a)};
JR.prototype.$classData=l({QL:0},!1,"scala.meta.Defn$Val$sharedClassifier$",{QL:1,f:1,na:1});var KR=void 0;function LR(){}LR.prototype=new m;LR.prototype.constructor=LR;LR.prototype.c=function(){return this};LR.prototype.la=function(a){return Sk(a)};LR.prototype.$classData=l({UL:0},!1,"scala.meta.Defn$Var$sharedClassifier$",{UL:1,f:1,na:1});var MR=void 0;function NR(){}NR.prototype=new m;NR.prototype.constructor=NR;NR.prototype.c=function(){return this};NR.prototype.la=function(a){return Dn(a)};
NR.prototype.$classData=l({aM:0},!1,"scala.meta.Enumerator$Generator$sharedClassifier$",{aM:1,f:1,na:1});var OR=void 0;function rla(){OR||(OR=(new NR).c());return OR}function PR(){}PR.prototype=new m;PR.prototype.constructor=PR;PR.prototype.c=function(){return this};PR.prototype.la=function(a){return QR(a)};PR.prototype.$classData=l({hM:0},!1,"scala.meta.Enumerator$Quasi$sharedClassifier$",{hM:1,f:1,na:1});var RR=void 0;function SR(){}SR.prototype=new m;SR.prototype.constructor=SR;
SR.prototype.c=function(){return this};SR.prototype.la=function(a){return Fn(a)};SR.prototype.$classData=l({lM:0},!1,"scala.meta.Enumerator$Val$sharedClassifier$",{lM:1,f:1,na:1});var TR=void 0;function UR(){}UR.prototype=new m;UR.prototype.constructor=UR;UR.prototype.c=function(){return this};UR.prototype.la=function(a){return Ol(a)};UR.prototype.$classData=l({LM:0},!1,"scala.meta.Init$sharedClassifier$",{LM:1,f:1,na:1});var VR=void 0;function Pia(){VR||(VR=(new UR).c());return VR}
function wm(){}wm.prototype=new m;wm.prototype.constructor=wm;wm.prototype.c=function(){return this};wm.prototype.la=function(a){return on(a)};wm.prototype.$classData=l({nN:0},!1,"scala.meta.Lit$Unit$sharedClassifier$",{nN:1,f:1,na:1});var vm=void 0;function vG(){}vG.prototype=new m;vG.prototype.constructor=vG;vG.prototype.c=function(){return this};vG.prototype.la=function(a){return Ui(a)};vG.prototype.$classData=l({oN:0},!1,"scala.meta.Lit$sharedClassifier$",{oN:1,f:1,na:1});var uG=void 0;
function WR(){}WR.prototype=new m;WR.prototype.constructor=WR;WR.prototype.c=function(){return this};WR.prototype.la=function(a){return DH(a)};WR.prototype.$classData=l({sN:0},!1,"scala.meta.Mod$Abstract$sharedClassifier$",{sN:1,f:1,na:1});var XR=void 0;function qv(){XR||(XR=(new WR).c());return XR}function YR(){}YR.prototype=new m;YR.prototype.constructor=YR;YR.prototype.c=function(){return this};YR.prototype.la=function(a){return CH(a)};
YR.prototype.$classData=l({AN:0},!1,"scala.meta.Mod$Case$sharedClassifier$",{AN:1,f:1,na:1});var ZR=void 0;function tA(){ZR||(ZR=(new YR).c());return ZR}function $R(){}$R.prototype=new m;$R.prototype.constructor=$R;$R.prototype.c=function(){return this};$R.prototype.la=function(a){return Dl(a)};$R.prototype.$classData=l({EN:0},!1,"scala.meta.Mod$Contravariant$sharedClassifier$",{EN:1,f:1,na:1});var aS=void 0;function Zha(){aS||(aS=(new $R).c());return aS}function bS(){}bS.prototype=new m;
bS.prototype.constructor=bS;bS.prototype.c=function(){return this};bS.prototype.la=function(a){return Cl(a)};bS.prototype.$classData=l({IN:0},!1,"scala.meta.Mod$Covariant$sharedClassifier$",{IN:1,f:1,na:1});var cS=void 0;function Yha(){cS||(cS=(new bS).c());return cS}function dS(){}dS.prototype=new m;dS.prototype.constructor=dS;dS.prototype.c=function(){return this};dS.prototype.la=function(a){return zH(a)};dS.prototype.$classData=l({LN:0},!1,"scala.meta.Mod$Final$sharedClassifier$",{LN:1,f:1,na:1});
var eS=void 0;function cea(){eS||(eS=(new dS).c());return eS}function fS(){}fS.prototype=new m;fS.prototype.constructor=fS;fS.prototype.c=function(){return this};fS.prototype.la=function(a){return AD(a)};fS.prototype.$classData=l({ON:0},!1,"scala.meta.Mod$Implicit$sharedClassifier$",{ON:1,f:1,na:1});var gS=void 0;function Hw(){gS||(gS=(new fS).c());return gS}function hS(){}hS.prototype=new m;hS.prototype.constructor=hS;hS.prototype.c=function(){return this};hS.prototype.la=function(a){return BD(a)};
hS.prototype.$classData=l({UN:0},!1,"scala.meta.Mod$Lazy$sharedClassifier$",{UN:1,f:1,na:1});var iS=void 0;function Gv(){iS||(iS=(new hS).c());return iS}function jS(){}jS.prototype=new m;jS.prototype.constructor=jS;jS.prototype.c=function(){return this};jS.prototype.la=function(a){return BH(a)};jS.prototype.$classData=l({XN:0},!1,"scala.meta.Mod$Override$sharedClassifier$",{XN:1,f:1,na:1});var kS=void 0;function pv(){kS||(kS=(new jS).c());return kS}function lS(){}lS.prototype=new m;
lS.prototype.constructor=lS;lS.prototype.c=function(){return this};lS.prototype.la=function(a){return El(a)};lS.prototype.$classData=l({$N:0},!1,"scala.meta.Mod$Private$sharedClassifier$",{$N:1,f:1,na:1});var mS=void 0;function QC(){mS||(mS=(new lS).c());return mS}function nS(){}nS.prototype=new m;nS.prototype.constructor=nS;nS.prototype.c=function(){return this};nS.prototype.la=function(a){return Hl(a)};nS.prototype.$classData=l({cO:0},!1,"scala.meta.Mod$Protected$sharedClassifier$",{cO:1,f:1,na:1});
var oS=void 0;function OC(){oS||(oS=(new nS).c());return oS}function MC(){}MC.prototype=new m;MC.prototype.constructor=MC;MC.prototype.c=function(){return this};MC.prototype.la=function(a){return Az(a)};MC.prototype.$classData=l({fO:0},!1,"scala.meta.Mod$Quasi$sharedClassifier$",{fO:1,f:1,na:1});var LC=void 0;function pS(){}pS.prototype=new m;pS.prototype.constructor=pS;pS.prototype.c=function(){return this};pS.prototype.la=function(a){return AH(a)};
pS.prototype.$classData=l({iO:0},!1,"scala.meta.Mod$Sealed$sharedClassifier$",{iO:1,f:1,na:1});var qS=void 0;function lv(){qS||(qS=(new pS).c());return qS}function rS(){}rS.prototype=new m;rS.prototype.constructor=rS;rS.prototype.c=function(){return this};rS.prototype.la=function(a){return Pl(a)};rS.prototype.$classData=l({rO:0},!1,"scala.meta.Name$Anonymous$sharedClassifier$",{rO:1,f:1,na:1});var sS=void 0;function cm(){sS||(sS=(new rS).c());return sS}function tS(){}tS.prototype=new m;
tS.prototype.constructor=tS;tS.prototype.c=function(){return this};tS.prototype.la=function(a){return dm(a)};tS.prototype.$classData=l({vO:0},!1,"scala.meta.Name$Indeterminate$sharedClassifier$",{vO:1,f:1,na:1});var uS=void 0;function iD(){uS||(uS=(new tS).c());return uS}function vS(){}vS.prototype=new m;vS.prototype.constructor=vS;vS.prototype.c=function(){return this};vS.prototype.la=function(a){return wS(a)};
vS.prototype.$classData=l({yO:0},!1,"scala.meta.Name$Quasi$sharedClassifier$",{yO:1,f:1,na:1});var xS=void 0;function fB(){xS||(xS=(new vS).c());return xS}function yS(){}yS.prototype=new m;yS.prototype.constructor=yS;yS.prototype.c=function(){return this};yS.prototype.la=function(a){return Ym(a)};yS.prototype.$classData=l({GO:0},!1,"scala.meta.Pat$Bind$sharedClassifier$",{GO:1,f:1,na:1});var zS=void 0;function AS(){}AS.prototype=new m;AS.prototype.constructor=AS;AS.prototype.c=function(){return this};
AS.prototype.la=function(a){return dn(a)};AS.prototype.$classData=l({KO:0},!1,"scala.meta.Pat$Extract$sharedClassifier$",{KO:1,f:1,na:1});var BS=void 0;function Ria(){BS||(BS=(new AS).c());return BS}function CS(){}CS.prototype=new m;CS.prototype.constructor=CS;CS.prototype.c=function(){return this};CS.prototype.la=function(a){return en(a)};CS.prototype.$classData=l({OO:0},!1,"scala.meta.Pat$ExtractInfix$sharedClassifier$",{OO:1,f:1,na:1});var DS=void 0;function ES(){}ES.prototype=new m;
ES.prototype.constructor=ES;ES.prototype.c=function(){return this};ES.prototype.la=function(a){return gn(a)};ES.prototype.$classData=l({SO:0},!1,"scala.meta.Pat$Interpolate$sharedClassifier$",{SO:1,f:1,na:1});var FS=void 0;function GS(){}GS.prototype=new m;GS.prototype.constructor=GS;GS.prototype.c=function(){return this};GS.prototype.la=function(a){return HS(a)};GS.prototype.$classData=l({VO:0},!1,"scala.meta.Pat$Quasi$sharedClassifier$",{VO:1,f:1,na:1});var IS=void 0;
function JS(){IS||(IS=(new GS).c());return IS}function KS(){}KS.prototype=new m;KS.prototype.constructor=KS;KS.prototype.c=function(){return this};KS.prototype.la=function(a){return ln(a)};KS.prototype.$classData=l({hP:0},!1,"scala.meta.Pat$Var$sharedClassifier$",{hP:1,f:1,na:1});var LS=void 0;function Bv(){LS||(LS=(new KS).c());return LS}function MS(){}MS.prototype=new m;MS.prototype.constructor=MS;MS.prototype.c=function(){return this};MS.prototype.la=function(a){return mn(a)};
MS.prototype.$classData=l({lP:0},!1,"scala.meta.Pat$Wildcard$sharedClassifier$",{lP:1,f:1,na:1});var NS=void 0;function Tha(){NS||(NS=(new MS).c());return NS}function OS(){}OS.prototype=new m;OS.prototype.constructor=OS;OS.prototype.c=function(){return this};OS.prototype.la=function(a){return nn(a)};OS.prototype.$classData=l({pP:0},!1,"scala.meta.Pat$Xml$sharedClassifier$",{pP:1,f:1,na:1});var PS=void 0;function QS(){}QS.prototype=new m;QS.prototype.constructor=QS;QS.prototype.c=function(){return this};
QS.prototype.la=function(a){return Rl(a)};QS.prototype.$classData=l({CP:0},!1,"scala.meta.Self$sharedClassifier$",{CP:1,f:1,na:1});var RS=void 0;function SS(){}SS.prototype=new m;SS.prototype.constructor=SS;SS.prototype.c=function(){return this};SS.prototype.la=function(a){return TS(a)};SS.prototype.$classData=l({MP:0},!1,"scala.meta.Template$Quasi$sharedClassifier$",{MP:1,f:1,na:1});var US=void 0;function VS(){US||(US=(new SS).c());return US}function WS(){}WS.prototype=new m;
WS.prototype.constructor=WS;WS.prototype.c=function(){return this};WS.prototype.la=function(a){return Zk(a)};WS.prototype.$classData=l({VP:0},!1,"scala.meta.Term$Apply$sharedClassifier$",{VP:1,f:1,na:1});var sla=void 0;function lfa(){sla||(sla=(new WS).c());return sla}function $K(){}$K.prototype=new m;$K.prototype.constructor=$K;$K.prototype.c=function(){return this};$K.prototype.la=function(a){return $k(a)};
$K.prototype.$classData=l({ZP:0},!1,"scala.meta.Term$ApplyInfix$sharedClassifier$",{ZP:1,f:1,na:1});var ZK=void 0;function bL(){}bL.prototype=new m;bL.prototype.constructor=bL;bL.prototype.c=function(){return this};bL.prototype.la=function(a){return gm(a)};bL.prototype.$classData=l({fQ:0},!1,"scala.meta.Term$ApplyUnary$sharedClassifier$",{fQ:1,f:1,na:1});var aL=void 0;function XS(){}XS.prototype=new m;XS.prototype.constructor=XS;XS.prototype.c=function(){return this};XS.prototype.la=function(a){return jm(a)};
XS.prototype.$classData=l({mQ:0},!1,"scala.meta.Term$Assign$sharedClassifier$",{mQ:1,f:1,na:1});var tla=void 0;function Nia(){tla||(tla=(new XS).c());return tla}function YS(){}YS.prototype=new m;YS.prototype.constructor=YS;YS.prototype.c=function(){return this};YS.prototype.la=function(a){return ym(a)};YS.prototype.$classData=l({LQ:0},!1,"scala.meta.Term$Interpolate$sharedClassifier$",{LQ:1,f:1,na:1});var ula=void 0;function Oia(){ula||(ula=(new YS).c());return ula}function ZS(){}ZS.prototype=new m;
ZS.prototype.constructor=ZS;ZS.prototype.c=function(){return this};ZS.prototype.la=function(a){return Gf(a)};ZS.prototype.$classData=l({SQ:0},!1,"scala.meta.Term$Name$Quasi$sharedClassifier$",{SQ:1,f:1,na:1});var vla=void 0;function bja(){vla||(vla=(new ZS).c());return vla}function $S(){}$S.prototype=new m;$S.prototype.constructor=$S;$S.prototype.c=function(){return this};$S.prototype.la=function(a){return Pf(a)};
$S.prototype.$classData=l({UQ:0},!1,"scala.meta.Term$Name$sharedClassifier$",{UQ:1,f:1,na:1});var wla=void 0;function wG(){wla||(wla=(new $S).c());return wla}function aT(){}aT.prototype=new m;aT.prototype.constructor=aT;aT.prototype.c=function(){return this};aT.prototype.la=function(a){return xla(a)};aT.prototype.$classData=l({dR:0},!1,"scala.meta.Term$Param$Quasi$sharedClassifier$",{dR:1,f:1,na:1});var yla=void 0;function zla(){yla||(yla=(new aT).c());return yla}function bT(){}bT.prototype=new m;
bT.prototype.constructor=bT;bT.prototype.c=function(){return this};bT.prototype.la=function(a){return sg(a)};bT.prototype.$classData=l({fR:0},!1,"scala.meta.Term$Param$sharedClassifier$",{fR:1,f:1,na:1});var Ala=void 0;function Tia(){Ala||(Ala=(new bT).c());return Ala}function Av(){}Av.prototype=new m;Av.prototype.constructor=Av;Av.prototype.c=function(){return this};Av.prototype.la=function(a){return Em(a)};
Av.prototype.$classData=l({mR:0},!1,"scala.meta.Term$Placeholder$sharedClassifier$",{mR:1,f:1,na:1});var zv=void 0;function cT(){}cT.prototype=new m;cT.prototype.constructor=cT;cT.prototype.c=function(){return this};cT.prototype.la=function(a){return Ff(a)};cT.prototype.$classData=l({pR:0},!1,"scala.meta.Term$Quasi$sharedClassifier$",{pR:1,f:1,na:1});var Bla=void 0;function kfa(){Bla||(Bla=(new cT).c());return Bla}function dT(){}dT.prototype=new m;dT.prototype.constructor=dT;dT.prototype.c=function(){return this};
dT.prototype.la=function(a){return vL(a)};dT.prototype.$classData=l({tR:0},!1,"scala.meta.Term$Ref$Quasi$sharedClassifier$",{tR:1,f:1,na:1});var Cla=void 0;function lz(){}lz.prototype=new m;lz.prototype.constructor=lz;lz.prototype.c=function(){return this};lz.prototype.la=function(a){return Lf(a)};lz.prototype.$classData=l({uR:0},!1,"scala.meta.Term$Ref$sharedClassifier$",{uR:1,f:1,na:1});var kz=void 0;function eT(){}eT.prototype=new m;eT.prototype.constructor=eT;eT.prototype.c=function(){return this};
eT.prototype.la=function(a){return Fm(a)};eT.prototype.$classData=l({yR:0},!1,"scala.meta.Term$Repeated$sharedClassifier$",{yR:1,f:1,na:1});var Dla=void 0;function Ela(){Dla||(Dla=(new eT).c());return Dla}function fT(){}fT.prototype=new m;fT.prototype.constructor=fT;fT.prototype.c=function(){return this};fT.prototype.la=function(a){return Hm(a)};fT.prototype.$classData=l({IR:0},!1,"scala.meta.Term$Super$sharedClassifier$",{IR:1,f:1,na:1});var Fla=void 0;
function Gla(){Fla||(Fla=(new fT).c());return Fla}function gT(){}gT.prototype=new m;gT.prototype.constructor=gT;gT.prototype.c=function(){return this};gT.prototype.la=function(a){return Km(a)};gT.prototype.$classData=l({MR:0},!1,"scala.meta.Term$This$sharedClassifier$",{MR:1,f:1,na:1});var Hla=void 0;function IG(){Hla||(Hla=(new gT).c());return Hla}function hT(){}hT.prototype=new m;hT.prototype.constructor=hT;hT.prototype.c=function(){return this};hT.prototype.la=function(a){return Ig(a)};
hT.prototype.$classData=l({AS:0},!1,"scala.meta.Type$ByName$sharedClassifier$",{AS:1,f:1,na:1});var Ila=void 0;function cga(){Ila||(Ila=(new hT).c());return Ila}function dL(){}dL.prototype=new m;dL.prototype.constructor=dL;dL.prototype.c=function(){return this};dL.prototype.la=function(a){return Ai(a)};dL.prototype.$classData=l({HS:0},!1,"scala.meta.Type$Function$sharedClassifier$",{HS:1,f:1,na:1});var cL=void 0;function iT(){}iT.prototype=new m;iT.prototype.constructor=iT;iT.prototype.c=function(){return this};
iT.prototype.la=function(a){return Vl(a)};iT.prototype.$classData=l({aT:0},!1,"scala.meta.Type$Param$sharedClassifier$",{aT:1,f:1,na:1});var Jla=void 0;function jT(){}jT.prototype=new m;jT.prototype.constructor=jT;jT.prototype.c=function(){return this};jT.prototype.la=function(a){return Ti(a)};jT.prototype.$classData=l({eT:0},!1,"scala.meta.Type$Placeholder$sharedClassifier$",{eT:1,f:1,na:1});var Kla=void 0;function kT(){}kT.prototype=new m;kT.prototype.constructor=kT;kT.prototype.c=function(){return this};
kT.prototype.la=function(a){return Eu(a)};kT.prototype.$classData=l({kT:0},!1,"scala.meta.Type$Quasi$sharedClassifier$",{kT:1,f:1,na:1});var Lla=void 0;function lT(){}lT.prototype=new m;lT.prototype.constructor=lT;lT.prototype.c=function(){return this};lT.prototype.la=function(a){return vi(a)};lT.prototype.$classData=l({yT:0},!1,"scala.meta.Type$Singleton$sharedClassifier$",{yT:1,f:1,na:1});var Mla=void 0;function fia(){Mla||(Mla=(new lT).c());return Mla}function gH(){}gH.prototype=new m;
gH.prototype.constructor=gH;gH.prototype.c=function(){return this};gH.prototype.la=function(a){return Bi(a)};gH.prototype.$classData=l({CT:0},!1,"scala.meta.Type$Tuple$sharedClassifier$",{CT:1,f:1,na:1});var fH=void 0;function mT(){}mT.prototype=new m;mT.prototype.constructor=mT;mT.prototype.c=function(){return this};mT.prototype.la=function(a){return kH(a)};mT.prototype.$classData=l({GT:0},!1,"scala.meta.Type$Var$sharedClassifier$",{GT:1,f:1,na:1});var Nla=void 0;function nT(){}nT.prototype=new m;
nT.prototype.constructor=nT;nT.prototype.c=function(){return this};nT.prototype.la=function(a){return Gg(a)};nT.prototype.$classData=l({KT:0},!1,"scala.meta.Type$sharedClassifier$",{KT:1,f:1,na:1});var Ola=void 0;function Pla(){Ola||(Ola=(new nT).c());return Ola}function oT(){}oT.prototype=new m;oT.prototype.constructor=oT;oT.prototype.c=function(){return this};oT.prototype.$classData=l({NT:0},!1,"scala.meta.classifiers.package$",{NT:1,f:1,LT:1});var Qla=void 0;
function v(){Qla||(Qla=(new oT).c());return Qla}function ws(){this.lg=null}ws.prototype=new m;ws.prototype.constructor=ws;ws.prototype.Ea=function(a){return this.lg.Ea(a)};ws.prototype.te=function(a){this.lg=a;return this};ws.prototype.$classData=l({PT:0},!1,"scala.meta.common.Convert$$anon$1",{PT:1,f:1,s6:1});
function Rla(a){a.KE((new ws).te(lk(function(){return function(a){pC();a=kr(Ga(),a,0,a.i.length);return(new pT).j(a)}}(a))));a.LE((new ws).te(lk(function(){return function(a){pC();return(new pT).j(a)}}(a))))}function kA(){}kA.prototype=new m;kA.prototype.constructor=kA;kA.prototype.c=function(){return this};kA.prototype.$classData=l({$T:0},!1,"scala.meta.internal.parsers.Reporter$$anon$1",{$T:1,f:1,w6:1});function uM(){this.SA=null}uM.prototype=new m;uM.prototype.constructor=uM;
uM.prototype.te=function(a){this.SA=a;return this};uM.prototype.$classData=l({kV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$189",{kV:1,f:1,D6:1});function $D(){}$D.prototype=new m;$D.prototype.constructor=$D;$D.prototype.Hv=function(){return this};$D.prototype.$classData=l({QW:0},!1,"scala.meta.internal.parsers.ScalametaParser$AllowedName$AllowedTermName$",{QW:1,f:1,OW:1});function OD(){}OD.prototype=new m;OD.prototype.constructor=OD;OD.prototype.Hv=function(){return this};
OD.prototype.$classData=l({RW:0},!1,"scala.meta.internal.parsers.ScalametaParser$AllowedName$AllowedTypeName$",{RW:1,f:1,OW:1});function UD(){this.r=null}UD.prototype=new m;UD.prototype.constructor=UD;UD.prototype.la=function(a){return this.qd(a)};UD.prototype.qd=function(a){return Lda(this.r.r).Gc(a)};UD.prototype.$classData=l({UW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CanEndStat$$anon$182",{UW:1,f:1,na:1});function VD(){this.r=null}VD.prototype=new m;VD.prototype.constructor=VD;
VD.prototype.la=function(a){return this.qd(a)};VD.prototype.qd=function(a){return xga(this.r.r).Gc(a)};VD.prototype.$classData=l({WW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CantStartStat$$anon$181",{WW:1,f:1,na:1});function qT(){this.r=null}qT.prototype=new m;qT.prototype.constructor=qT;qT.prototype.la=function(a){return this.qd(a)};qT.prototype.qd=function(a){return Ju(this.r.r).Gc(a)};function Hda(a){var b=new qT;if(null===a)throw jo(wj(),null);b.r=a;return b}
qT.prototype.$classData=l({YW:0},!1,"scala.meta.internal.parsers.ScalametaParser$CaseDefEnd$$anon$180",{YW:1,f:1,na:1});function rT(){this.r=null}rT.prototype=new m;rT.prototype.constructor=rT;function iw(a){var b=new rT;if(null===a)throw jo(wj(),null);b.r=a;return b}rT.prototype.la=function(a){return this.qd(a)};rT.prototype.qd=function(a){return Nt(this.r.r).Gc(a)};rT.prototype.$classData=l({$W:0},!1,"scala.meta.internal.parsers.ScalametaParser$CaseIntro$$anon$172",{$W:1,f:1,na:1});
function RD(){this.r=null}RD.prototype=new m;RD.prototype.constructor=RD;RD.prototype.la=function(a){return this.qd(a)};RD.prototype.qd=function(a){return Wga(this.r.r).Gc(a)};RD.prototype.$classData=l({bX:0},!1,"scala.meta.internal.parsers.ScalametaParser$CloseDelim$$anon$169",{bX:1,f:1,na:1});function sT(){this.r=null}sT.prototype=new m;sT.prototype.constructor=sT;function fv(a){var b=new sT;if(null===a)throw jo(wj(),null);b.r=a;return b}sT.prototype.la=function(a){return this.qd(a)};
sT.prototype.qd=function(a){return ev(this.r.r).Gc(a)};sT.prototype.$classData=l({dX:0},!1,"scala.meta.internal.parsers.ScalametaParser$DclIntro$$anon$175",{dX:1,f:1,na:1});function tT(){this.r=null}tT.prototype=new m;tT.prototype.constructor=tT;tT.prototype.la=function(a){return this.qd(a)};tT.prototype.qd=function(a){return Nu(this.r.r).Gc(a)};function Ou(a){var b=new tT;if(null===a)throw jo(wj(),null);b.r=a;return b}
tT.prototype.$classData=l({fX:0},!1,"scala.meta.internal.parsers.ScalametaParser$DefIntro$$anon$173",{fX:1,f:1,na:1});function uT(){this.r=null}uT.prototype=new m;uT.prototype.constructor=uT;uT.prototype.la=function(a){return this.qd(a)};uT.prototype.qd=function(a){return Ru(this.r.r).Gc(a)};function Su(a){var b=new uT;if(null===a)throw jo(wj(),null);b.r=a;return b}uT.prototype.$classData=l({hX:0},!1,"scala.meta.internal.parsers.ScalametaParser$ExprIntro$$anon$171",{hX:1,f:1,na:1});
function Jw(){YE.call(this)}Jw.prototype=new ZE;Jw.prototype.constructor=Jw;Jw.prototype.z=function(a){var b=ry();Ew();YE.prototype.Wp.call(this,a,b,Dw());return this};Jw.prototype.$classData=l({jX:0},!1,"scala.meta.internal.parsers.ScalametaParser$InvalidFinalAbstract$",{jX:1,At:1,f:1});function uA(){YE.call(this)}uA.prototype=new ZE;uA.prototype.constructor=uA;uA.prototype.z=function(a){var b=ry();ty||(ty=(new uy).c());YE.prototype.Wp.call(this,a,b,vy(null,null,null));return this};
uA.prototype.$classData=l({kX:0},!1,"scala.meta.internal.parsers.ScalametaParser$InvalidFinalSealed$",{kX:1,At:1,f:1});function Kw(){YE.call(this)}Kw.prototype=new ZE;Kw.prototype.constructor=Kw;Kw.prototype.z=function(a){var b=Oea();Ew();YE.prototype.Wp.call(this,a,b,Dw());return this};Kw.prototype.$classData=l({lX:0},!1,"scala.meta.internal.parsers.ScalametaParser$InvalidOverrideAbstract$",{lX:1,At:1,f:1});function PC(){YE.call(this)}PC.prototype=new ZE;PC.prototype.constructor=PC;
PC.prototype.z=function(a){yA();var b=tu(),b=xA(0,b);AA();var c=tu();YE.prototype.Wp.call(this,a,b,zA(0,c));return this};PC.prototype.$classData=l({mX:0},!1,"scala.meta.internal.parsers.ScalametaParser$InvalidPrivateProtected$",{mX:1,At:1,f:1});function RC(){YE.call(this)}RC.prototype=new ZE;RC.prototype.constructor=RC;RC.prototype.z=function(a){AA();var b=tu(),b=zA(0,b);yA();var c=tu();YE.prototype.Wp.call(this,a,b,xA(0,c));return this};
RC.prototype.$classData=l({nX:0},!1,"scala.meta.internal.parsers.ScalametaParser$InvalidProtectedPrivate$",{nX:1,At:1,f:1});function vT(){this.r=null}vT.prototype=new m;vT.prototype.constructor=vT;function Zga(a){var b=new vT;if(null===a)throw jo(wj(),null);b.r=a;return b}vT.prototype.la=function(a){return this.qd(a)};vT.prototype.qd=function(a){return FB(this.r.r).Gc(a)};vT.prototype.$classData=l({pX:0},!1,"scala.meta.internal.parsers.ScalametaParser$LineEnd$$anon$187",{pX:1,f:1,na:1});
function wT(){this.r=null}wT.prototype=new m;wT.prototype.constructor=wT;function tE(a){var b=new wT;if(null===a)throw jo(wj(),null);b.r=a;return b}wT.prototype.la=function(a){return this.qd(a)};wT.prototype.qd=function(a){return tf(this.r.r).Gc(a)};wT.prototype.$classData=l({rX:0},!1,"scala.meta.internal.parsers.ScalametaParser$Literal$$anon$184",{rX:1,f:1,na:1});function KC(){this.r=null}KC.prototype=new m;KC.prototype.constructor=KC;KC.prototype.la=function(a){return this.qd(a)};
KC.prototype.qd=function(a){return yga(this.r.r).Gc(a)};KC.prototype.$classData=l({tX:0},!1,"scala.meta.internal.parsers.ScalametaParser$LocalModifier$$anon$178",{tX:1,f:1,na:1});function xT(){this.r=null}xT.prototype=new m;xT.prototype.constructor=xT;function GE(a){var b=new xT;if(null===a)throw jo(wj(),null);b.r=a;return b}xT.prototype.la=function(a){return this.qd(a)};xT.prototype.qd=function(a){return ox(this.r.r).Gc(a)};
xT.prototype.$classData=l({vX:0},!1,"scala.meta.internal.parsers.ScalametaParser$Modifier$$anon$176",{vX:1,f:1,na:1});function yT(){this.r=null}yT.prototype=new m;yT.prototype.constructor=yT;yT.prototype.la=function(a){return this.qd(a)};yT.prototype.qd=function(a){return Vs(this.r.r).Gc(a)};function Ida(a){var b=new yT;if(null===a)throw jo(wj(),null);b.r=a;return b}yT.prototype.$classData=l({yX:0},!1,"scala.meta.internal.parsers.ScalametaParser$NonlocalModifier$$anon$177",{yX:1,f:1,na:1});
function zT(){this.r=null}zT.prototype=new m;zT.prototype.constructor=zT;zT.prototype.la=function(a){return this.qd(a)};zT.prototype.qd=function(a){return VA(this.r.r).Gc(a)};function mC(a){var b=new zT;if(null===a)throw jo(wj(),null);b.r=a;return b}zT.prototype.$classData=l({AX:0},!1,"scala.meta.internal.parsers.ScalametaParser$NumericLiteral$$anon$185",{AX:1,f:1,na:1});function xz(){this.r=null}xz.prototype=new m;xz.prototype.constructor=xz;
xz.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};xz.prototype.$classData=l({BX:0},!1,"scala.meta.internal.parsers.ScalametaParser$OwnedByCaseClass$",{BX:1,f:1,Hw:1});function TB(){this.r=null}TB.prototype=new m;TB.prototype.constructor=TB;TB.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};TB.prototype.$classData=l({CX:0},!1,"scala.meta.internal.parsers.ScalametaParser$OwnedByClass$",{CX:1,f:1,Hw:1});function bE(){this.r=null}
bE.prototype=new m;bE.prototype.constructor=bE;bE.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};bE.prototype.$classData=l({DX:0},!1,"scala.meta.internal.parsers.ScalametaParser$OwnedByObject$",{DX:1,f:1,Hw:1});function sD(){this.r=null}sD.prototype=new m;sD.prototype.constructor=sD;sD.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
sD.prototype.$classData=l({EX:0},!1,"scala.meta.internal.parsers.ScalametaParser$OwnedByTrait$",{EX:1,f:1,Hw:1});function AT(){this.r=null}AT.prototype=new m;AT.prototype.constructor=AT;AT.prototype.la=function(a){return this.qd(a)};AT.prototype.qd=function(a){return Wu(this.r.r).Gc(a)};function Xu(a){var b=new AT;if(null===a)throw jo(wj(),null);b.r=a;return b}AT.prototype.$classData=l({cY:0},!1,"scala.meta.internal.parsers.ScalametaParser$StatSep$$anon$183",{cY:1,f:1,na:1});
function BT(){this.r=null}BT.prototype=new m;BT.prototype.constructor=BT;function Iu(a){var b=new BT;if(null===a)throw jo(wj(),null);b.r=a;return b}BT.prototype.la=function(a){return this.qd(a)};BT.prototype.qd=function(a){return Hu(this.r.r).Gc(a)};BT.prototype.$classData=l({eY:0},!1,"scala.meta.internal.parsers.ScalametaParser$StatSeqEnd$$anon$179",{eY:1,f:1,na:1});function CT(){this.r=null}CT.prototype=new m;CT.prototype.constructor=CT;
function kha(a){var b=new CT;if(null===a)throw jo(wj(),null);b.r=a;return b}CT.prototype.la=function(a){return this.qd(a)};CT.prototype.qd=function(a){return sx(this.r.r).Gc(a)};CT.prototype.$classData=l({gY:0},!1,"scala.meta.internal.parsers.ScalametaParser$TemplateIntro$$anon$174",{gY:1,f:1,na:1});function DT(){this.r=null}DT.prototype=new m;DT.prototype.constructor=DT;DT.prototype.la=function(a){return this.qd(a)};DT.prototype.qd=function(a){return qA(this.r.r).Gc(a)};
function Yga(a){var b=new DT;if(null===a)throw jo(wj(),null);b.r=a;return b}DT.prototype.$classData=l({jY:0},!1,"scala.meta.internal.parsers.ScalametaParser$Trivia$$anon$188",{jY:1,f:1,na:1});function ET(){this.r=null}ET.prototype=new m;ET.prototype.constructor=ET;ET.prototype.la=function(a){return this.qd(a)};ET.prototype.qd=function(a){return gh(this.r.r).Gc(a)};function hh(a){var b=new ET;if(null===a)throw jo(wj(),null);b.r=a;return b}
ET.prototype.$classData=l({lY:0},!1,"scala.meta.internal.parsers.ScalametaParser$TypeIntro$$anon$170",{lY:1,f:1,na:1});function FT(){this.r=null}FT.prototype=new m;FT.prototype.constructor=FT;FT.prototype.la=function(a){return this.qd(a)};FT.prototype.qd=function(a){return SD(this.r.r).Gc(a)};function TD(a){var b=new FT;if(null===a)throw jo(wj(),null);b.r=a;return b}FT.prototype.$classData=l({nY:0},!1,"scala.meta.internal.parsers.ScalametaParser$Whitespace$$anon$186",{nY:1,f:1,na:1});
function TA(){this.r=null}TA.prototype=new m;TA.prototype.constructor=TA;TA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};TA.prototype.$classData=l({rY:0},!1,"scala.meta.internal.parsers.ScalametaParser$outPattern$",{rY:1,f:1,Gw:1});function ly(){VE.call(this)}ly.prototype=new WE;ly.prototype.constructor=ly;e=ly.prototype;e.dG=function(a){return a};
e.RA=function(a,b,c){if(null===a)throw(new p).e(a);var d=a.mo,f=a.$i;a=a.Wd;a:{var g;if(jn(b)&&(g=null===b?S():(new T).e(b.pb()),!g.g())){g=g.q();break a}on(b)?g=F():(G(),b=(new r).d([b]),g=G().b,g=H(b,g))}b=this.r;var d=d.$a(),h;Sla||(Sla=(new GT).c());h=Sla;g=SC(this.r,g);f=Tla(h,f,a,g);c=c.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);a=M();return O(P(a,f),R(b.ea,b.P,c))};e.cG=function(a){return a};e.z=function(a){VE.prototype.z.call(this,a);return this};
e.$classData=l({sY:0},!1,"scala.meta.internal.parsers.ScalametaParser$patInfixContext$",{sY:1,iX:1,f:1});function xC(){VE.call(this)}xC.prototype=new WE;xC.prototype.constructor=xC;e=xC.prototype;e.dG=function(a){return yC(a)};
e.RA=function(a,b,c){if(null===a)throw(new p).e(a);var d=a.mo,f=a.$i,g=a.gq,h=a.Wd;a=a.Bn;var n=this.r,u=d.$a(),f=cx(this.r,f),g=g.Ga();g<u&&(g=-1+u|0);g=(new L).K(u,1+g|0);u=M();n=O(P(u,f),R(n.ea,n.P,g));f=v();y(z(f,n),Ela())&&(le(this.r),f=this.r,g=Fk(n,this.r.kh),g=Hd(g),f=fx((new gx).xg(f,g)).ja(),Pd("repeated argument not allowed here",f));f=this.r;d=d.$a();Ula||(Ula=(new HT).c());g=Ula;b=SC(this.r,b);h=Vla(g,n,h,a,b);c=c.Ga();c<d&&(c=-1+d|0);c=(new L).K(d,1+c|0);b=M();return O(P(b,h),R(f.ea,
f.P,c))};e.cG=function(a){return a};function yC(a){G();a=(new r).d([a]);var b=G().b;return H(a,b)}e.z=function(a){VE.prototype.z.call(this,a);return this};e.$classData=l({uY:0},!1,"scala.meta.internal.parsers.ScalametaParser$termInfixContext$",{uY:1,iX:1,f:1});function DI(){this.Jf=this.Fo=this.Gt=this.NE=null;this.fw=this.MB=this.iw=this.kc=this.Ha=0}DI.prototype=new m;DI.prototype.constructor=DI;function Wla(){}Wla.prototype=DI.prototype;
function IT(a){var b;if(b=a.kc<a.Jf.i.length&&117===a.Jf.i[a.kc]){for(b=-2+a.kc|0;0<=b&&92===a.Jf.i[b];)b=-1+b|0;b=0===((a.kc-b|0)%2|0)}if(b){do a.kc=1+a.kc|0;while(a.kc<a.Jf.i.length&&117===a.Jf.i[a.kc]);b=JT(a)<<12|JT(a)<<8|JT(a)<<4|JT(a);a.fw=a.kc;a.Ha=65535&b}}function dI(a){if(a.kc>=a.Jf.i.length)a.Ha=26;else{var b=a.Jf.i[a.kc];a.Ha=b;a.kc=1+a.kc|0;92===b&&IT(a)}}DI.prototype.bB=function(a,b,c){this.NE=a;this.Gt=b;this.Fo=c;this.MB=this.iw=this.kc=0;this.fw=-1;this.Jf=a.od();return this};
function aI(a){if(a.kc>=a.Jf.i.length)a.Ha=26;else{var b=a.Jf.i[a.kc];a.Ha=b;a.kc=1+a.kc|0;92===b&&IT(a);if(32>a.Ha){if(13===a.Ha&&a.kc<a.Jf.i.length)switch(a.Jf.i[a.kc]){case 10:a.kc=1+a.kc|0;a.Ha=10;break;case 92:b=tI(a),pI(To(),92===b.Jf.i[b.kc]),b.Ha=92,b.kc=1+b.kc|0,IT(b.Lb),10===b.Ha&&IT(a)}if(10===a.Ha||12===a.Ha)a.Gt.Th||Zj(a.Fo,"line breaks are not allowed in single-line quasiquotes",-1+a.kc|0),a.MB=a.iw,a.iw=a.kc}34!==a.Ha||a.Gt.Th||Zj(a.Fo,"double quotes are not allowed in single-line quasiquotes",
-1+a.kc|0)}}function ria(a){return a.kc===a.fw}function JT(a){if(a.kc>=a.Jf.i.length)Zj(a.Fo,"incomplete unicode escape",-1+a.kc|0);else{var b=Cj(Dj(),a.Jf.i[a.kc],16);0<=b?a.kc=1+a.kc|0:Zj(a.Fo,"error in unicode escape",a.kc);return b}}DI.prototype.$classData=l({QC:0},!1,"scala.meta.internal.tokenizers.CharArrayReader",{QC:1,f:1,kZ:1});function AI(){this.u=null;this.Ic=this.Zi=this.La=this.Pb=0;this.Hd=this.gd=null;this.He=0;this.Tc=null;this.ra=!1}AI.prototype=new m;AI.prototype.constructor=AI;
e=AI.prototype;e.cn=function(a){this.gd=a};e.ri=function(a){this.Ic=a};e.El=function(a){this.u=a};e.v=function(){return xj(this)};e.Cj=function(a){this.Hd=a};e.Xp=function(){yj(this);return this};e.oa=function(){return this.gd};e.ck=function(a){this.La=a};e.jb=function(){return this.u};e.uk=function(a){this.He=a};e.xo=function(){return this.ra?this.Tc:this.nn()};e.Rc=function(a){this.Pb=a};e.Ll=function(a){this.Zi=a};e.nn=function(){this.ra||(this.Tc=(new zI).Gm(this.u),this.ra=!0);return this.Tc};
e.$classData=l({nZ:0},!1,"scala.meta.internal.tokenizers.LegacyScanner$$anon$1",{nZ:1,f:1,Hq:1});function BI(){this.u=null;this.Ic=this.Zi=this.La=this.Pb=0;this.Hd=this.gd=null;this.He=0;this.Tc=null;this.ra=!1}BI.prototype=new m;BI.prototype.constructor=BI;e=BI.prototype;e.cn=function(a){this.gd=a};e.ri=function(a){this.Ic=a};e.El=function(a){this.u=a};e.v=function(){return xj(this)};e.Cj=function(a){this.Hd=a};e.Xp=function(){yj(this);return this};e.oa=function(){return this.gd};
e.ck=function(a){this.La=a};e.jb=function(){return this.u};e.uk=function(a){this.He=a};e.xo=function(){return this.ra?this.Tc:this.nn()};e.Rc=function(a){this.Pb=a};e.Ll=function(a){this.Zi=a};e.nn=function(){this.ra||(this.Tc=(new zI).Gm(this.u),this.ra=!0);return this.Tc};e.$classData=l({oZ:0},!1,"scala.meta.internal.tokenizers.LegacyScanner$$anon$2",{oZ:1,f:1,Hq:1});function CI(){this.u=null;this.Ic=this.Zi=this.La=this.Pb=0;this.Hd=this.gd=null;this.He=0;this.Tc=null;this.ra=!1}CI.prototype=new m;
CI.prototype.constructor=CI;e=CI.prototype;e.cn=function(a){this.gd=a};e.ri=function(a){this.Ic=a};e.El=function(a){this.u=a};e.v=function(){return xj(this)};e.Cj=function(a){this.Hd=a};e.Xp=function(){yj(this);return this};e.oa=function(){return this.gd};e.ck=function(a){this.La=a};e.jb=function(){return this.u};e.uk=function(a){this.He=a};e.xo=function(){return this.ra?this.Tc:this.nn()};e.Rc=function(a){this.Pb=a};e.Ll=function(a){this.Zi=a};
e.nn=function(){this.ra||(this.Tc=(new zI).Gm(this.u),this.ra=!0);return this.Tc};e.$classData=l({pZ:0},!1,"scala.meta.internal.tokenizers.LegacyScanner$$anon$3",{pZ:1,f:1,Hq:1});function zI(){this.jA=null}zI.prototype=new m;zI.prototype.constructor=zI;zI.prototype.Gm=function(a){this.jA=a;return this};zI.prototype.$classData=l({sZ:0},!1,"scala.meta.internal.tokenizers.Reporter$$anon$1",{sZ:1,f:1,y6:1});
function OM(){this.u=null;this.Ic=this.Zi=this.La=this.Pb=0;this.Hd=this.gd=null;this.He=0;this.Tc=null;this.ra=!1}OM.prototype=new m;OM.prototype.constructor=OM;e=OM.prototype;e.cn=function(a){this.gd=a};e.ri=function(a){this.Ic=a};e.El=function(a){this.u=a};e.v=function(){return xj(this)};e.Cj=function(a){this.Hd=a};e.oa=function(){return this.gd};e.ck=function(a){this.La=a};e.jb=function(){return this.u};e.uk=function(a){this.He=a};e.xo=function(){return this.ra?this.Tc:this.nn()};
e.Rc=function(a){this.Pb=a};e.Ll=function(a){this.Zi=a};e.nn=function(){this.ra||(this.Tc=(new zI).Gm(this.u),this.ra=!0);return this.Tc};e.$classData=l({wZ:0},!1,"scala.meta.internal.tokenizers.ScalametaTokenizer$$anon$1",{wZ:1,f:1,Hq:1});function Xz(){}Xz.prototype=new m;Xz.prototype.constructor=Xz;Xz.prototype.c=function(){return this};Xz.prototype.$classData=l({xZ:0},!1,"scala.meta.internal.tokenizers.ScalametaTokenizer$$anon$2",{xZ:1,f:1,M6:1});
function Yc(a){a=mG(a);if(nG(a)){var b=oG(pG(),a);if(!b.g()){a=b.q().Bb;var c=b.q().qb,b=b.q().Eb,d=Vz(),f=Vz(),c=VM(f,c).vp(a,us()),c=Yz(Zz(d,c),(new Xz).c()),d=Xla(c),c=Dg(d,b.E),b=Dg(d,-1+b.Ca|0);Ls();c=c.ab();b=b.wa();return(new Ms).ib(a,c,b)}}return Ls().Or}
function Fk(a,b){var c=mG(a);if(nG(c)){var d=oG(pG(),c);if(!d.g()){c=d.q().Bb;b=d.q().qb;a=d.q().Eb;var d=Vz(),f=Vz(),c=VM(f,b).vp(c,us()),c=Yz(Zz(d,c),(new Xz).c());return Yla(Xla(c),a.E,a.Ca)}}c=Vz();d=Vz();d=VM(d,b);pC();f=Se();b=tg().If(b);a=yg(f,a,b).be();a=d.vp((new KT).Ps("\x3cInternalTrees.tokens\x3e",a),us());a=Yz(Zz(c,a),(new Xz).c());return Xla(a)}function GG(a){return null!==a.aa?(new T).e(a.aa):S()}function mG(a){return null!==a.s?a.s:kia()}function LT(){}LT.prototype=new m;
LT.prototype.constructor=LT;LT.prototype.c=function(){return this};LT.prototype.la=function(a){return Ke(a)};LT.prototype.$classData=l({GZ:0},!1,"scala.meta.internal.trees.Quasi$sharedClassifier$",{GZ:1,f:1,na:1});var Zla=void 0;function Sha(){Zla||(Zla=(new LT).c());return Zla}function MT(){}MT.prototype=new m;MT.prototype.constructor=MT;MT.prototype.c=function(){return this};MT.prototype.$classData=l({f_:0},!1,"scala.meta.parsers.package$",{f_:1,f:1,UZ:1});var $la=void 0;
function ija(){$la||($la=(new MT).c());return $la}function EM(){this.lg=null}EM.prototype=new m;EM.prototype.constructor=EM;EM.prototype.N=function(a){return this.lg.Ea(a)};EM.prototype.te=function(a){this.lg=a;return this};EM.prototype.$classData=l({k_:0},!1,"scala.meta.prettyprinters.Show$$anon$1",{k_:1,f:1,XC:1});function NT(){}NT.prototype=new m;NT.prototype.constructor=NT;NT.prototype.c=function(){return this};
NT.prototype.$classData=l({o_:0},!1,"scala.meta.prettyprinters.package$",{o_:1,f:1,g_:1});var ama=void 0;function Se(){ama||(ama=(new NT).c());return ama}function OT(){}OT.prototype=new m;OT.prototype.constructor=OT;OT.prototype.c=function(){return this};OT.prototype.$classData=l({y_:0},!1,"scala.meta.tokenizers.package$",{y_:1,f:1,p_:1});var bma=void 0;function Vz(){bma||(bma=(new OT).c());return bma}function PT(){}PT.prototype=new m;PT.prototype.constructor=PT;PT.prototype.c=function(){return this};
PT.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Pw)};PT.prototype.$classData=l({A_:0},!1,"scala.meta.tokens.Token$At$sharedClassifier$",{A_:1,f:1,na:1});var cma=void 0;function iu(){cma||(cma=(new PT).c());return cma}function eE(){}eE.prototype=new m;eE.prototype.constructor=eE;eE.prototype.c=function(){return this};eE.prototype.la=function(a){return JF(a)};eE.prototype.$classData=l({B_:0},!1,"scala.meta.tokens.Token$BOF$sharedClassifier$",{B_:1,f:1,na:1});var dE=void 0;
function aF(){}aF.prototype=new m;aF.prototype.constructor=aF;aF.prototype.c=function(){return this};aF.prototype.la=function(a){return HF(a)};aF.prototype.$classData=l({C_:0},!1,"scala.meta.tokens.Token$CR$sharedClassifier$",{C_:1,f:1,na:1});var $E=void 0;function QT(){}QT.prototype=new m;QT.prototype.constructor=QT;QT.prototype.c=function(){return this};QT.prototype.la=function(a){return XC(a)};QT.prototype.$classData=l({D_:0},!1,"scala.meta.tokens.Token$Colon$sharedClassifier$",{D_:1,f:1,na:1});
var dma=void 0;function lg(){dma||(dma=(new QT).c());return dma}function RT(){}RT.prototype=new m;RT.prototype.constructor=RT;RT.prototype.c=function(){return this};RT.prototype.la=function(a){return Vx(a)};RT.prototype.$classData=l({E_:0},!1,"scala.meta.tokens.Token$Comma$sharedClassifier$",{E_:1,f:1,na:1});var ema=void 0;function og(){ema||(ema=(new RT).c());return ema}function ST(){}ST.prototype=new m;ST.prototype.constructor=ST;ST.prototype.c=function(){return this};
ST.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Qw)};ST.prototype.$classData=l({F_:0},!1,"scala.meta.tokens.Token$Comment$sharedClassifier$",{F_:1,f:1,na:1});var fma=void 0;function zF(){fma||(fma=(new ST).c());return fma}function TT(){}TT.prototype=new m;TT.prototype.constructor=TT;TT.prototype.c=function(){return this};TT.prototype.la=function(a){return fC(a)};TT.prototype.$classData=l({N_:0},!1,"scala.meta.tokens.Token$Dot$sharedClassifier$",{N_:1,f:1,na:1});var gma=void 0;
function Bf(){gma||(gma=(new TT).c());return gma}function UT(){}UT.prototype=new m;UT.prototype.constructor=UT;UT.prototype.c=function(){return this};UT.prototype.la=function(a){return KF(a)};UT.prototype.$classData=l({O_:0},!1,"scala.meta.tokens.Token$EOF$sharedClassifier$",{O_:1,f:1,na:1});var hma=void 0;function ah(){hma||(hma=(new UT).c());return hma}function VT(){}VT.prototype=new m;VT.prototype.constructor=VT;VT.prototype.c=function(){return this};VT.prototype.la=function(a){return de(a)};
VT.prototype.$classData=l({Q_:0},!1,"scala.meta.tokens.Token$Ellipsis$sharedClassifier$",{Q_:1,f:1,na:1});var ima=void 0;function be(){ima||(ima=(new VT).c());return ima}function WT(){}WT.prototype=new m;WT.prototype.constructor=WT;WT.prototype.c=function(){return this};WT.prototype.la=function(a){return Qx(a)};WT.prototype.$classData=l({R_:0},!1,"scala.meta.tokens.Token$Equals$sharedClassifier$",{R_:1,f:1,na:1});var jma=void 0;function Wg(){jma||(jma=(new WT).c());return jma}function XT(){}
XT.prototype=new m;XT.prototype.constructor=XT;XT.prototype.c=function(){return this};XT.prototype.la=function(a){return IF(a)};XT.prototype.$classData=l({S_:0},!1,"scala.meta.tokens.Token$FF$sharedClassifier$",{S_:1,f:1,na:1});var kma=void 0;function $ga(){kma||(kma=(new XT).c());return kma}function YT(){}YT.prototype=new m;YT.prototype.constructor=YT;YT.prototype.c=function(){return this};YT.prototype.la=function(a){return ei(a)};
YT.prototype.$classData=l({T_:0},!1,"scala.meta.tokens.Token$Hash$sharedClassifier$",{T_:1,f:1,na:1});var lma=void 0;function Qga(){lma||(lma=(new YT).c());return lma}function ZT(){}ZT.prototype=new m;ZT.prototype.constructor=ZT;ZT.prototype.c=function(){return this};ZT.prototype.la=function(a){return hg(a)};ZT.prototype.$classData=l({V_:0},!1,"scala.meta.tokens.Token$Ident$sharedClassifier$",{V_:1,f:1,na:1});var mma=void 0;function Pu(){mma||(mma=(new ZT).c());return mma}function vE(){}
vE.prototype=new m;vE.prototype.constructor=vE;vE.prototype.c=function(){return this};vE.prototype.la=function(a){return cw(a)};vE.prototype.$classData=l({W_:0},!1,"scala.meta.tokens.Token$Interpolation$End$sharedClassifier$",{W_:1,f:1,na:1});var uE=void 0;function $T(){}$T.prototype=new m;$T.prototype.constructor=$T;$T.prototype.c=function(){return this};$T.prototype.la=function(a){return Nv(a)};
$T.prototype.$classData=l({Y_:0},!1,"scala.meta.tokens.Token$Interpolation$Id$sharedClassifier$",{Y_:1,f:1,na:1});var nma=void 0;function Qv(){nma||(nma=(new $T).c());return nma}function cF(){}cF.prototype=new m;cF.prototype.constructor=cF;cF.prototype.c=function(){return this};cF.prototype.la=function(a){return py(a)};cF.prototype.$classData=l({$_:0},!1,"scala.meta.tokens.Token$KwAbstract$sharedClassifier$",{$_:1,f:1,na:1});var bF=void 0;function aU(){}aU.prototype=new m;
aU.prototype.constructor=aU;aU.prototype.c=function(){return this};aU.prototype.la=function(a){return Pw(a)};aU.prototype.$classData=l({a0:0},!1,"scala.meta.tokens.Token$KwCase$sharedClassifier$",{a0:1,f:1,na:1});var oma=void 0;function jw(){oma||(oma=(new aU).c());return oma}function bU(){}bU.prototype=new m;bU.prototype.constructor=bU;bU.prototype.c=function(){return this};bU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Rw)};
bU.prototype.$classData=l({b0:0},!1,"scala.meta.tokens.Token$KwCatch$sharedClassifier$",{b0:1,f:1,na:1});var pma=void 0;function Tea(){pma||(pma=(new bU).c());return pma}function cU(){}cU.prototype=new m;cU.prototype.constructor=cU;cU.prototype.c=function(){return this};cU.prototype.la=function(a){return Ow(a)};cU.prototype.$classData=l({c0:0},!1,"scala.meta.tokens.Token$KwClass$sharedClassifier$",{c0:1,f:1,na:1});var qma=void 0;function Qw(){qma||(qma=(new cU).c());return qma}function FE(){}
FE.prototype=new m;FE.prototype.constructor=FE;FE.prototype.c=function(){return this};FE.prototype.la=function(a){return yx(a)};FE.prototype.$classData=l({d0:0},!1,"scala.meta.tokens.Token$KwDef$sharedClassifier$",{d0:1,f:1,na:1});var EE=void 0;function KE(){}KE.prototype=new m;KE.prototype.constructor=KE;KE.prototype.c=function(){return this};KE.prototype.la=function(a){return Xy(a)};KE.prototype.$classData=l({e0:0},!1,"scala.meta.tokens.Token$KwDo$sharedClassifier$",{e0:1,f:1,na:1});var JE=void 0;
function dU(){}dU.prototype=new m;dU.prototype.constructor=dU;dU.prototype.c=function(){return this};dU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Sw)};dU.prototype.$classData=l({f0:0},!1,"scala.meta.tokens.Token$KwElse$sharedClassifier$",{f0:1,f:1,na:1});var rma=void 0;function Ly(){rma||(rma=(new dU).c());return rma}function eU(){}eU.prototype=new m;eU.prototype.constructor=eU;eU.prototype.c=function(){return this};eU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Tw)};
eU.prototype.$classData=l({g0:0},!1,"scala.meta.tokens.Token$KwExtends$sharedClassifier$",{g0:1,f:1,na:1});var sma=void 0;function Pga(){sma||(sma=(new eU).c());return sma}function eF(){}eF.prototype=new m;eF.prototype.constructor=eF;eF.prototype.c=function(){return this};eF.prototype.la=function(a){return qy(a)};eF.prototype.$classData=l({h0:0},!1,"scala.meta.tokens.Token$KwFinal$sharedClassifier$",{h0:1,f:1,na:1});var dF=void 0;function zE(){}zE.prototype=new m;zE.prototype.constructor=zE;
zE.prototype.c=function(){return this};zE.prototype.la=function(a){return Sy(a)};zE.prototype.$classData=l({i0:0},!1,"scala.meta.tokens.Token$KwFinally$sharedClassifier$",{i0:1,f:1,na:1});var yE=void 0;function ME(){}ME.prototype=new m;ME.prototype.constructor=ME;ME.prototype.c=function(){return this};ME.prototype.la=function(a){return $y(a)};ME.prototype.$classData=l({j0:0},!1,"scala.meta.tokens.Token$KwFor$sharedClassifier$",{j0:1,f:1,na:1});var LE=void 0;function BE(){}BE.prototype=new m;
BE.prototype.constructor=BE;BE.prototype.c=function(){return this};BE.prototype.la=function(a){return Zh(a)};BE.prototype.$classData=l({k0:0},!1,"scala.meta.tokens.Token$KwForsome$sharedClassifier$",{k0:1,f:1,na:1});var AE=void 0;function fU(){}fU.prototype=new m;fU.prototype.constructor=fU;fU.prototype.c=function(){return this};fU.prototype.la=function(a){return Ky(a)};fU.prototype.$classData=l({l0:0},!1,"scala.meta.tokens.Token$KwIf$sharedClassifier$",{l0:1,f:1,na:1});var tma=void 0;
function JA(){tma||(tma=(new fU).c());return tma}function gU(){}gU.prototype=new m;gU.prototype.constructor=gU;gU.prototype.c=function(){return this};gU.prototype.la=function(a){return gg(a)};gU.prototype.$classData=l({m0:0},!1,"scala.meta.tokens.Token$KwImplicit$sharedClassifier$",{m0:1,f:1,na:1});var uma=void 0;function Vi(){uma||(uma=(new gU).c());return uma}function Lu(){}Lu.prototype=new m;Lu.prototype.constructor=Lu;Lu.prototype.c=function(){return this};Lu.prototype.la=function(a){return hU(a)};
Lu.prototype.$classData=l({n0:0},!1,"scala.meta.tokens.Token$KwImport$sharedClassifier$",{n0:1,f:1,na:1});var Ku=void 0;function iF(){}iF.prototype=new m;iF.prototype.constructor=iF;iF.prototype.c=function(){return this};iF.prototype.la=function(a){return wy(a)};iF.prototype.$classData=l({o0:0},!1,"scala.meta.tokens.Token$KwLazy$sharedClassifier$",{o0:1,f:1,na:1});var hF=void 0;function Ex(){}Ex.prototype=new m;Ex.prototype.constructor=Ex;Ex.prototype.c=function(){return this};
Ex.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Uw)};Ex.prototype.$classData=l({p0:0},!1,"scala.meta.tokens.Token$KwMacro$sharedClassifier$",{p0:1,f:1,na:1});var Dx=void 0;function iU(){}iU.prototype=new m;iU.prototype.constructor=iU;iU.prototype.c=function(){return this};iU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Vw)};iU.prototype.$classData=l({q0:0},!1,"scala.meta.tokens.Token$KwMatch$sharedClassifier$",{q0:1,f:1,na:1});var vma=void 0;
function tfa(){vma||(vma=(new iU).c());return vma}function OE(){}OE.prototype=new m;OE.prototype.constructor=OE;OE.prototype.c=function(){return this};OE.prototype.la=function(a){return hx(a)};OE.prototype.$classData=l({r0:0},!1,"scala.meta.tokens.Token$KwNew$sharedClassifier$",{r0:1,f:1,na:1});var NE=void 0;function jU(){}jU.prototype=new m;jU.prototype.constructor=jU;jU.prototype.c=function(){return this};jU.prototype.la=function(a){return Rw(a)};
jU.prototype.$classData=l({s0:0},!1,"scala.meta.tokens.Token$KwObject$sharedClassifier$",{s0:1,f:1,na:1});var wma=void 0;function Sw(){wma||(wma=(new jU).c());return wma}function kU(){}kU.prototype=new m;kU.prototype.constructor=kU;kU.prototype.c=function(){return this};kU.prototype.la=function(a){return yy(a)};kU.prototype.$classData=l({t0:0},!1,"scala.meta.tokens.Token$KwOverride$sharedClassifier$",{t0:1,f:1,na:1});var xma=void 0;function pha(){xma||(xma=(new kU).c());return xma}
function lU(){}lU.prototype=new m;lU.prototype.constructor=lU;lU.prototype.c=function(){return this};lU.prototype.la=function(a){return mU(a)};lU.prototype.$classData=l({u0:0},!1,"scala.meta.tokens.Token$KwPackage$sharedClassifier$",{u0:1,f:1,na:1});var yma=void 0;function Xx(){yma||(yma=(new lU).c());return yma}function nU(){}nU.prototype=new m;nU.prototype.constructor=nU;nU.prototype.c=function(){return this};nU.prototype.la=function(a){return ww(a)};
nU.prototype.$classData=l({v0:0},!1,"scala.meta.tokens.Token$KwPrivate$sharedClassifier$",{v0:1,f:1,na:1});var zma=void 0;function nha(){zma||(zma=(new nU).c());return zma}function oU(){}oU.prototype=new m;oU.prototype.constructor=oU;oU.prototype.c=function(){return this};oU.prototype.la=function(a){return xw(a)};oU.prototype.$classData=l({w0:0},!1,"scala.meta.tokens.Token$KwProtected$sharedClassifier$",{w0:1,f:1,na:1});var Ama=void 0;function oha(){Ama||(Ama=(new oU).c());return Ama}
function pU(){}pU.prototype=new m;pU.prototype.constructor=pU;pU.prototype.c=function(){return this};pU.prototype.la=function(a){return ez(a)};pU.prototype.$classData=l({x0:0},!1,"scala.meta.tokens.Token$KwReturn$sharedClassifier$",{x0:1,f:1,na:1});var Bma=void 0;function iha(){Bma||(Bma=(new pU).c());return Bma}function gF(){}gF.prototype=new m;gF.prototype.constructor=gF;gF.prototype.c=function(){return this};gF.prototype.la=function(a){return sy(a)};
gF.prototype.$classData=l({y0:0},!1,"scala.meta.tokens.Token$KwSealed$sharedClassifier$",{y0:1,f:1,na:1});var fF=void 0;function qU(){}qU.prototype=new m;qU.prototype.constructor=qU;qU.prototype.c=function(){return this};qU.prototype.la=function(a){return Xw(a)};qU.prototype.$classData=l({z0:0},!1,"scala.meta.tokens.Token$KwSuper$sharedClassifier$",{z0:1,f:1,na:1});var Cma=void 0;function CC(){Cma||(Cma=(new qU).c());return Cma}function rU(){}rU.prototype=new m;rU.prototype.constructor=rU;
rU.prototype.c=function(){return this};rU.prototype.la=function(a){return Ww(a)};rU.prototype.$classData=l({A0:0},!1,"scala.meta.tokens.Token$KwThis$sharedClassifier$",{A0:1,f:1,na:1});var qna=void 0;function zx(){qna||(qna=(new rU).c());return qna}function QE(){}QE.prototype=new m;QE.prototype.constructor=QE;QE.prototype.c=function(){return this};QE.prototype.la=function(a){return hz(a)};QE.prototype.$classData=l({B0:0},!1,"scala.meta.tokens.Token$KwThrow$sharedClassifier$",{B0:1,f:1,na:1});
var PE=void 0;function yF(){}yF.prototype=new m;yF.prototype.constructor=yF;yF.prototype.c=function(){return this};yF.prototype.la=function(a){return Cw(a)};yF.prototype.$classData=l({C0:0},!1,"scala.meta.tokens.Token$KwTrait$sharedClassifier$",{C0:1,f:1,na:1});var xF=void 0;function SE(){}SE.prototype=new m;SE.prototype.constructor=SE;SE.prototype.c=function(){return this};SE.prototype.la=function(a){return Qy(a)};
SE.prototype.$classData=l({D0:0},!1,"scala.meta.tokens.Token$KwTry$sharedClassifier$",{D0:1,f:1,na:1});var RE=void 0;function sU(){}sU.prototype=new m;sU.prototype.constructor=sU;sU.prototype.c=function(){return this};sU.prototype.la=function(a){return Ox(a)};sU.prototype.$classData=l({E0:0},!1,"scala.meta.tokens.Token$KwType$sharedClassifier$",{E0:1,f:1,na:1});var tna=void 0;function jha(){tna||(tna=(new sU).c());return tna}function tU(){}tU.prototype=new m;tU.prototype.constructor=tU;
tU.prototype.c=function(){return this};tU.prototype.la=function(a){return wx(a)};tU.prototype.$classData=l({F0:0},!1,"scala.meta.tokens.Token$KwVal$sharedClassifier$",{F0:1,f:1,na:1});var wna=void 0;function $A(){wna||(wna=(new tU).c());return wna}function uU(){}uU.prototype=new m;uU.prototype.constructor=uU;uU.prototype.c=function(){return this};uU.prototype.la=function(a){return xx(a)};uU.prototype.$classData=l({G0:0},!1,"scala.meta.tokens.Token$KwVar$sharedClassifier$",{G0:1,f:1,na:1});
var Gna=void 0;function jv(){Gna||(Gna=(new uU).c());return Gna}function UE(){}UE.prototype=new m;UE.prototype.constructor=UE;UE.prototype.c=function(){return this};UE.prototype.la=function(a){return Vy(a)};UE.prototype.$classData=l({H0:0},!1,"scala.meta.tokens.Token$KwWhile$sharedClassifier$",{H0:1,f:1,na:1});var TE=void 0;function vU(){}vU.prototype=new m;vU.prototype.constructor=vU;vU.prototype.c=function(){return this};vU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Ww)};
vU.prototype.$classData=l({I0:0},!1,"scala.meta.tokens.Token$KwWith$sharedClassifier$",{I0:1,f:1,na:1});var Lna=void 0;function Ah(){Lna||(Lna=(new vU).c());return Lna}function wU(){}wU.prototype=new m;wU.prototype.constructor=wU;wU.prototype.c=function(){return this};wU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Xw)};wU.prototype.$classData=l({J0:0},!1,"scala.meta.tokens.Token$KwYield$sharedClassifier$",{J0:1,f:1,na:1});var ooa=void 0;
function cfa(){ooa||(ooa=(new wU).c());return ooa}function xU(){}xU.prototype=new m;xU.prototype.constructor=xU;xU.prototype.c=function(){return this};xU.prototype.la=function(a){return px(a)};xU.prototype.$classData=l({K0:0},!1,"scala.meta.tokens.Token$LF$sharedClassifier$",{K0:1,f:1,na:1});var poa=void 0;function fh(){poa||(poa=(new xU).c());return poa}function yU(){}yU.prototype=new m;yU.prototype.constructor=yU;yU.prototype.c=function(){return this};yU.prototype.la=function(a){return hy(a)};
yU.prototype.$classData=l({L0:0},!1,"scala.meta.tokens.Token$LFLF$sharedClassifier$",{L0:1,f:1,na:1});var qoa=void 0;function pw(){qoa||(qoa=(new yU).c());return qoa}function zU(){}zU.prototype=new m;zU.prototype.constructor=zU;zU.prototype.c=function(){return this};zU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Yw)};zU.prototype.$classData=l({M0:0},!1,"scala.meta.tokens.Token$LeftArrow$sharedClassifier$",{M0:1,f:1,na:1});var roa=void 0;
function Fga(){roa||(roa=(new zU).c());return roa}function AU(){}AU.prototype=new m;AU.prototype.constructor=AU;AU.prototype.c=function(){return this};AU.prototype.la=function(a){return Be(a)};AU.prototype.$classData=l({N0:0},!1,"scala.meta.tokens.Token$LeftBrace$sharedClassifier$",{N0:1,f:1,na:1});var soa=void 0;function Dh(){soa||(soa=(new AU).c());return soa}function BU(){}BU.prototype=new m;BU.prototype.constructor=BU;BU.prototype.c=function(){return this};BU.prototype.la=function(a){return fi(a)};
BU.prototype.$classData=l({O0:0},!1,"scala.meta.tokens.Token$LeftBracket$sharedClassifier$",{O0:1,f:1,na:1});var toa=void 0;function Hh(){toa||(toa=(new BU).c());return toa}function CU(){}CU.prototype=new m;CU.prototype.constructor=CU;CU.prototype.c=function(){return this};CU.prototype.la=function(a){return ue(a)};CU.prototype.$classData=l({P0:0},!1,"scala.meta.tokens.Token$LeftParen$sharedClassifier$",{P0:1,f:1,na:1});var uoa=void 0;function Rf(){uoa||(uoa=(new CU).c());return uoa}
function DU(){}DU.prototype=new m;DU.prototype.constructor=DU;DU.prototype.c=function(){return this};DU.prototype.la=function(a){return Yh(a)};DU.prototype.$classData=l({Q0:0},!1,"scala.meta.tokens.Token$RightArrow$sharedClassifier$",{Q0:1,f:1,na:1});var voa=void 0;function Ag(){voa||(voa=(new DU).c());return voa}function EU(){}EU.prototype=new m;EU.prototype.constructor=EU;EU.prototype.c=function(){return this};EU.prototype.la=function(a){return Wx(a)};
EU.prototype.$classData=l({R0:0},!1,"scala.meta.tokens.Token$RightBrace$sharedClassifier$",{R0:1,f:1,na:1});var woa=void 0;function Xg(){woa||(woa=(new EU).c());return woa}function FU(){}FU.prototype=new m;FU.prototype.constructor=FU;FU.prototype.c=function(){return this};FU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.Zw)};FU.prototype.$classData=l({S0:0},!1,"scala.meta.tokens.Token$RightBracket$sharedClassifier$",{S0:1,f:1,na:1});var xoa=void 0;
function hu(){xoa||(xoa=(new FU).c());return xoa}function GU(){}GU.prototype=new m;GU.prototype.constructor=GU;GU.prototype.c=function(){return this};GU.prototype.la=function(a){return Nz(a)};GU.prototype.$classData=l({T0:0},!1,"scala.meta.tokens.Token$RightParen$sharedClassifier$",{T0:1,f:1,na:1});var yoa=void 0;function Vf(){yoa||(yoa=(new GU).c());return yoa}function HU(){}HU.prototype=new m;HU.prototype.constructor=HU;HU.prototype.c=function(){return this};
HU.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.$w)};HU.prototype.$classData=l({U0:0},!1,"scala.meta.tokens.Token$Semicolon$sharedClassifier$",{U0:1,f:1,na:1});var zoa=void 0;function Oy(){zoa||(zoa=(new HU).c());return zoa}function BF(){}BF.prototype=new m;BF.prototype.constructor=BF;BF.prototype.c=function(){return this};BF.prototype.la=function(a){return!!(a&&a.$classData&&a.$classData.H.ax)};
BF.prototype.$classData=l({V0:0},!1,"scala.meta.tokens.Token$Space$sharedClassifier$",{V0:1,f:1,na:1});var AF=void 0;function IU(){}IU.prototype=new m;IU.prototype.constructor=IU;IU.prototype.c=function(){return this};IU.prototype.la=function(a){return Ux(a)};IU.prototype.$classData=l({W0:0},!1,"scala.meta.tokens.Token$Subtype$sharedClassifier$",{W0:1,f:1,na:1});var Aoa=void 0;function kx(){Aoa||(Aoa=(new IU).c());return Aoa}function JU(){}JU.prototype=new m;JU.prototype.constructor=JU;
JU.prototype.c=function(){return this};JU.prototype.la=function(a){return Tx(a)};JU.prototype.$classData=l({X0:0},!1,"scala.meta.tokens.Token$Supertype$sharedClassifier$",{X0:1,f:1,na:1});var Boa=void 0;function sea(){Boa||(Boa=(new JU).c());return Boa}function DF(){}DF.prototype=new m;DF.prototype.constructor=DF;DF.prototype.c=function(){return this};DF.prototype.la=function(a){return GF(a)};DF.prototype.$classData=l({Y0:0},!1,"scala.meta.tokens.Token$Tab$sharedClassifier$",{Y0:1,f:1,na:1});
var CF=void 0;function KU(){}KU.prototype=new m;KU.prototype.constructor=KU;KU.prototype.c=function(){return this};KU.prototype.la=function(a){return nf(a)};KU.prototype.$classData=l({Z0:0},!1,"scala.meta.tokens.Token$Underscore$sharedClassifier$",{Z0:1,f:1,na:1});var Coa=void 0;function pz(){Coa||(Coa=(new KU).c());return Coa}function LU(){}LU.prototype=new m;LU.prototype.constructor=LU;LU.prototype.c=function(){return this};LU.prototype.la=function(a){return Je(a)};
LU.prototype.$classData=l({$0:0},!1,"scala.meta.tokens.Token$Unquote$sharedClassifier$",{$0:1,f:1,na:1});var Doa=void 0;function Ug(){Doa||(Doa=(new LU).c());return Doa}function MU(){}MU.prototype=new m;MU.prototype.constructor=MU;MU.prototype.c=function(){return this};MU.prototype.la=function(a){return QF(a)};MU.prototype.$classData=l({a1:0},!1,"scala.meta.tokens.Token$Viewbound$sharedClassifier$",{a1:1,f:1,na:1});var Eoa=void 0;function lx(){Eoa||(Eoa=(new MU).c());return Eoa}function xE(){}
xE.prototype=new m;xE.prototype.constructor=xE;xE.prototype.c=function(){return this};xE.prototype.la=function(a){return dw(a)};xE.prototype.$classData=l({b1:0},!1,"scala.meta.tokens.Token$Xml$End$sharedClassifier$",{b1:1,f:1,na:1});var wE=void 0;function IE(){}IE.prototype=new m;IE.prototype.constructor=IE;IE.prototype.c=function(){return this};IE.prototype.la=function(a){return Mv(a)};IE.prototype.$classData=l({d1:0},!1,"scala.meta.tokens.Token$Xml$Start$sharedClassifier$",{d1:1,f:1,na:1});
var HE=void 0;function dN(){}dN.prototype=new m;dN.prototype.constructor=dN;dN.prototype.c=function(){return this};dN.prototype.v=function(){return"object AnyRef"};dN.prototype.$classData=l({g1:0},!1,"scala.package$$anon$1",{g1:1,f:1,qC:1});function NU(){this.yx=this.RB=this.jj=0}NU.prototype=new Nja;NU.prototype.constructor=NU;NU.prototype.c=function(){OU=this;this.jj=Da(Ga(),"Seq");this.RB=Da(Ga(),"Map");this.yx=Da(Ga(),"Set");return this};
function PU(a,b){if(Ty(b)){for(var c=0,d=a.jj,f=b;!f.g();)b=f.n(),f=f.o(),d=a.Gb(d,YN(Y(),b)),c=1+c|0;a=a.xd(d,c)}else a=Oja(a,b,a.jj);return a}NU.prototype.$classData=l({L1:0},!1,"scala.util.hashing.MurmurHash3$",{L1:1,T6:1,f:1});var OU=void 0;function XN(){OU||(OU=(new NU).c());return OU}function Foa(a){return(a.fb()?"non-empty":"empty")+" iterator"}function Goa(a,b){for(var c=!0;c&&a.fb();)c=!!b.Ea(a.bb());return c}function QU(a,b){for(;a.fb();)b.Ea(a.bb())}
function RU(a,b){for(;a.fb()&&b.fb();)if(!dj(ej(),a.bb(),b.bb()))return!1;return!a.fb()&&!b.fb()}function SU(a){if(a.fb()){var b=a.bb();return TU(new UU,b,Rq(function(a){return function(){return a.ce()}}(a)))}nN();return VU()}function Hoa(a){for(var b=0;0>b&&a.fb();)a.bb(),b=1+b|0;return a}function Ioa(a,b,c,d){var f=c,g=fO(gO(),b)-c|0;for(c=c+(d<g?d:g)|0;f<c&&a.fb();)bQ(gO(),b,f,a.bb()),f=1+f|0}function qM(){this.r=this.Hi=null}qM.prototype=new m;qM.prototype.constructor=qM;
qM.prototype.Cb=function(a){this.r.Cb(lk(function(a,c){return function(d){return a.Hi.Ea(d)?c.Ea(d):void 0}}(this,a)))};qM.prototype.yf=function(a,b){b=b.mi(this.r.Se());this.r.Cb(lk(function(a,b,f){return function(g){return a.Hi.Ea(g)?f.ba(b.Ea(g)):void 0}}(this,a,b)));return b.da()};function pM(a,b,c){a.Hi=c;if(null===b)throw jo(wj(),null);a.r=b;return a}qM.prototype.$classData=l({c2:0},!1,"scala.collection.TraversableLike$WithFilter",{c2:1,f:1,Tb:1});function WU(){this.Vu=null}WU.prototype=new m;
WU.prototype.constructor=WU;WU.prototype.mj=function(){return this.Vu.mj()};WU.prototype.mi=function(){return this.Vu.mj()};function Joa(a){var b=new WU;b.Vu=a;return b}WU.prototype.$classData=l({l2:0},!1,"scala.collection.package$$anon$1",{l2:1,f:1,Go:1});function XU(){}XU.prototype=new FO;XU.prototype.constructor=XU;function Koa(){}Koa.prototype=XU.prototype;function YU(){this.r=null}YU.prototype=new m;YU.prototype.constructor=YU;YU.prototype.mj=function(){return this.r.ic()};
YU.prototype.mi=function(a){return a&&a.$classData&&a.$classData.H.Mh?a.qe().ic():this.r.ic()};function RQ(a){var b=new YU;if(null===a)throw jo(wj(),null);b.r=a;return b}YU.prototype.$classData=l({o2:0},!1,"scala.collection.generic.GenSetFactory$$anon$1",{o2:1,f:1,Go:1});function ZU(){this.b=null}ZU.prototype=new FO;ZU.prototype.constructor=ZU;function $U(){}$U.prototype=ZU.prototype;ZU.prototype.c=function(){this.b=(new aV).Yp(this);return this};function bV(){this.r=null}bV.prototype=new m;
bV.prototype.constructor=bV;function cV(){}cV.prototype=bV.prototype;bV.prototype.mj=function(){return this.r.ic()};bV.prototype.mi=function(a){return a.qe().ic()};bV.prototype.Yp=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};function dV(){}dV.prototype=new Vja;dV.prototype.constructor=dV;function Loa(){}Loa.prototype=dV.prototype;function eV(){this.kw=null}eV.prototype=new IO;eV.prototype.constructor=eV;
eV.prototype.vv=function(a){this.kw=a;a=new fV;if(null===this)throw jo(wj(),null);a.Lb=this;return this};eV.prototype.Su=function(a,b){return this.kw.ug(a,b)};eV.prototype.$classData=l({u2:0},!1,"scala.collection.immutable.HashMap$$anon$2",{u2:1,z2:1,f:1});function fV(){this.Lb=null}fV.prototype=new IO;fV.prototype.constructor=fV;fV.prototype.Su=function(a,b){return this.Lb.kw.ug(b,a)};fV.prototype.$classData=l({v2:0},!1,"scala.collection.immutable.HashMap$$anon$2$$anon$3",{v2:1,z2:1,f:1});
function gV(){}gV.prototype=new m;gV.prototype.constructor=gV;gV.prototype.c=function(){return this};gV.prototype.Ea=function(){return this};gV.prototype.v=function(){return"\x3cfunction1\x3e"};gV.prototype.$classData=l({G2:0},!1,"scala.collection.immutable.List$$anon$1",{G2:1,f:1,Mb:1});function hV(){this.Sl=this.Hi=this.Js=null;this.ra=!1}hV.prototype=new m;hV.prototype.constructor=hV;hV.prototype.Cb=function(a){(this.ra?this.Js:Moa(this)).Cb(a)};function Noa(a,b,c){a.Hi=c;a.Sl=OO(b);return a}
hV.prototype.yf=function(a,b){return(this.ra?this.Js:Moa(this)).yf(a,b)};function Moa(a){if(!a.ra){var b=Ooa(a.Sl,a.Hi,!1);a.Sl=null;a.Js=b;a.ra=!0}return a.Js}hV.prototype.$classData=l({m3:0},!1,"scala.collection.immutable.Stream$StreamWithFilter",{m3:1,f:1,Tb:1});function Poa(a,b){b=b.Df();switch(b){case -1:break;default:a.je(b)}}function Qoa(a,b,c){b=b.Df();switch(b){case -1:break;default:a.je(b+c|0)}}function iV(a,b,c){c=c.Df();switch(c){case -1:break;default:a.je(b<c?b:c)}}
function jV(){Aq.call(this)}jV.prototype=new Cca;jV.prototype.constructor=jV;jV.prototype.c=function(){Aq.prototype.zv.call(this,kV(),1,1);return this};
function Dca(a,b){if(null===a.Nd||a.Ph||null===b.Nd||b.Hl())for(;;){if(a.kb===a.jc)return Eq().Qk;var c=lV(a);if(0<=c){if(b.kb===b.jc){var d=Eq().Qh;mq.prototype.Pc.call(a,-1+a.kb|0);return d}b.ln(65535&c)}else{var f=kV().ix.i[127&c];if(-1===f)return d=Eq().wi,mq.prototype.Pc.call(a,-1+a.kb|0),d;d=1;if(2===f)if(a.kb!==a.jc?(d=1+d|0,f=lV(a)):f=0,128!==(192&f))var c=Eq().wi,g=f=0;else c=(31&c)<<6|63&f,128>c?(c=Eq().Xk,f=0):(f=65535&c,c=null),g=0;else if(3===f)a.kb!==a.jc?(d=1+d|0,f=lV(a)):f=0,a.kb!==
a.jc?(d=1+d|0,g=lV(a)):g=0,128!==(192&f)?(c=Eq().wi,f=0):128!==(192&g)?(c=Eq().Xk,f=0):(c=(15&c)<<12|(63&f)<<6|63&g,2048>c||55296<=c&&57343>=c?(c=Eq().Vm,f=0):(f=65535&c,c=null)),g=0;else{a.kb!==a.jc?(d=1+d|0,f=lV(a)):f=0;a.kb!==a.jc?(d=1+d|0,g=lV(a)):g=0;if(a.kb!==a.jc)var d=1+d|0,h=lV(a);else h=0;128!==(192&f)?(c=Eq().wi,g=f=0):128!==(192&g)?(c=Eq().Xk,g=f=0):128!==(192&h)?(c=Eq().Vm,g=f=0):(c=(7&c)<<18|(63&f)<<12|(63&g)<<6|63&h,65536>c||1114111<c?(c=Eq().dq,g=f=0):(c=-65536+c|0,f=65535&(55296|
c>>10),g=65535&(56320|1023&c),c=null))}if(null!==c)return b=c,mq.prototype.Pc.call(a,a.kb-d|0),b;if(0===g){if(b.kb===b.jc)return b=Eq().Qh,mq.prototype.Pc.call(a,a.kb-d|0),b;b.ln(f)}else{if(2>(b.jc-b.kb|0))return b=Eq().Qh,mq.prototype.Pc.call(a,a.kb-d|0),b;b.ln(f);b.ln(g)}}}else return Roa(a,b)}
function Roa(a,b){var c=a.Nd;if(null===c)throw(new Gq).c();if(a.Ph)throw(new Iq).c();var d=a.ne;if(-1===d)throw(new Gq).c();if(a.Ph)throw(new Iq).c();var f=a.kb+d|0,g=a.jc+d|0,h=b.Nd;if(null===h)throw(new Gq).c();if(b.Hl())throw(new Iq).c();var n=b.ne;if(-1===n)throw(new Gq).c();if(b.Hl())throw(new Iq).c();var u=b.jc+n|0,w=b.kb+n|0;for(;;){if(f===g)return c=Eq().Qk,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;var D=c.i[f];if(0<=D){if(w===u)return c=Eq().Qh,mq.prototype.Pc.call(a,
f-d|0),mq.prototype.Pc.call(b,w-n|0),c;h.i[w]=65535&D;w=1+w|0;f=1+f|0}else{var N=kV().ix.i[127&D];if(-1===N)return c=Eq().wi,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;var Q=f,Q=(1+Q|0)<g?c.i[1+Q|0]:0;if(2===N)if(128!==(192&Q))var D=Eq().wi,ea=Q=0;else D=(31&D)<<6|63&Q,128>D?(D=Eq().Xk,Q=0):(Q=65535&D,D=null),ea=0;else if(3===N)ea=f,ea=(2+ea|0)<g?c.i[2+ea|0]:0,128!==(192&Q)?(D=Eq().wi,Q=0):128!==(192&ea)?(D=Eq().Xk,Q=0):(D=(15&D)<<12|(63&Q)<<6|63&ea,2048>D||55296<=D&&57343>=D?(D=
Eq().Vm,Q=0):(Q=65535&D,D=null)),ea=0;else{var ea=f,ea=(2+ea|0)<g?c.i[2+ea|0]:0,ba=f,ba=(3+ba|0)<g?c.i[3+ba|0]:0;128!==(192&Q)?(D=Eq().wi,ea=Q=0):128!==(192&ea)?(D=Eq().Xk,ea=Q=0):128!==(192&ba)?(D=Eq().Vm,ea=Q=0):(D=(7&D)<<18|(63&Q)<<12|(63&ea)<<6|63&ba,65536>D||1114111<D?(D=Eq().dq,ea=Q=0):(D=-65536+D|0,Q=65535&(55296|D>>10),ea=65535&(56320|1023&D),D=null))}if(null!==D)return c=D,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;if(0===ea){if(w===u)return c=Eq().Qh,mq.prototype.Pc.call(a,
f-d|0),mq.prototype.Pc.call(b,w-n|0),c;h.i[w]=Q;w=1+w|0}else{if((2+w|0)>u)return c=Eq().Qh,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;h.i[w]=Q;h.i[1+w|0]=ea;w=2+w|0}f=f+N|0}}}jV.prototype.$classData=l({u4:0},!1,"scala.scalajs.niocharset.UTF_8$Decoder",{u4:1,t5:1,f:1});function mV(){Hq.call(this)}mV.prototype=new Gca;mV.prototype.constructor=mV;mV.prototype.c=function(){Hq.prototype.zv.call(this,kV(),1.100000023841858,4);return this};
function Soa(a,b){if(null===a.Nd||a.Hl()||null===b.Nd||b.Ph)for(;;){if(a.kb===a.jc)return Eq().Qk;var c=a.Xn();if(128>c){if(b.kb===b.jc)return b=Eq().Qh,mq.prototype.Pc.call(a,-1+a.kb|0),b;nV(b,c<<24>>24)}else if(2048>c){if(2>(b.jc-b.kb|0))return b=Eq().Qh,mq.prototype.Pc.call(a,-1+a.kb|0),b;nV(b,(192|c>>6)<<24>>24);nV(b,(128|63&c)<<24>>24)}else if(kV(),55296!==(63488&c)){if(3>(b.jc-b.kb|0))return b=Eq().Qh,mq.prototype.Pc.call(a,-1+a.kb|0),b;nV(b,(224|c>>12)<<24>>24);nV(b,(128|63&c>>6)<<24>>24);
nV(b,(128|63&c)<<24>>24)}else if(55296===(64512&c)){if(a.kb===a.jc)return b=Eq().Qk,mq.prototype.Pc.call(a,-1+a.kb|0),b;var d=a.Xn();if(56320!==(64512&d))return b=Eq().wi,mq.prototype.Pc.call(a,-2+a.kb|0),b;if(4>(b.jc-b.kb|0))return b=Eq().Qh,mq.prototype.Pc.call(a,-2+a.kb|0),b;c=65536+(((1023&c)<<10)+(1023&d)|0)|0;nV(b,(240|c>>18)<<24>>24);nV(b,(128|63&c>>12)<<24>>24);nV(b,(128|63&c>>6)<<24>>24);nV(b,(128|63&c)<<24>>24)}else return b=Eq().wi,mq.prototype.Pc.call(a,-1+a.kb|0),b}else return Toa(a,
b)}
function Toa(a,b){var c=a.Nd;if(null===c)throw(new Gq).c();if(a.Hl())throw(new Iq).c();var d=a.ne;if(-1===d)throw(new Gq).c();if(a.Hl())throw(new Iq).c();var f=a.kb+d|0,g=a.jc+d|0,h=b.Nd;if(null===h)throw(new Gq).c();if(b.Ph)throw(new Iq).c();var n=b.ne;if(-1===n)throw(new Gq).c();if(b.Ph)throw(new Iq).c();var u=b.jc+n|0,w=b.kb+n|0;for(;;){if(f===g)return c=Eq().Qk,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;var D=c.i[f];if(128>D){if(w===u)return c=Eq().Qh,mq.prototype.Pc.call(a,f-
d|0),mq.prototype.Pc.call(b,w-n|0),c;h.i[w]=D<<24>>24;w=1+w|0;f=1+f|0}else if(2048>D){if((2+w|0)>u)return c=Eq().Qh,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;h.i[w]=(192|D>>6)<<24>>24;h.i[1+w|0]=(128|63&D)<<24>>24;w=2+w|0;f=1+f|0}else if(kV(),55296!==(63488&D)){if((3+w|0)>u)return c=Eq().Qh,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;h.i[w]=(224|D>>12)<<24>>24;h.i[1+w|0]=(128|63&D>>6)<<24>>24;h.i[2+w|0]=(128|63&D)<<24>>24;w=3+w|0;f=1+f|0}else if(55296===(64512&
D)){if((1+f|0)===g)return c=Eq().Qk,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;var N=c.i[1+f|0];if(56320!==(64512&N))return c=Eq().wi,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;if((4+w|0)>u)return c=Eq().Qh,mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c;D=65536+(((1023&D)<<10)+(1023&N)|0)|0;h.i[w]=(240|D>>18)<<24>>24;h.i[1+w|0]=(128|63&D>>12)<<24>>24;h.i[2+w|0]=(128|63&D>>6)<<24>>24;h.i[3+w|0]=(128|63&D)<<24>>24;w=4+w|0;f=2+f|0}else return c=Eq().wi,
mq.prototype.Pc.call(a,f-d|0),mq.prototype.Pc.call(b,w-n|0),c}}mV.prototype.$classData=l({v4:0},!1,"scala.scalajs.niocharset.UTF_8$Encoder",{v4:1,u5:1,f:1});function oV(){}oV.prototype=new m;oV.prototype.constructor=oV;function Uoa(){}Uoa.prototype=oV.prototype;oV.prototype.v=function(){return"\x3cfunction0\x3e"};function pV(){}pV.prototype=new m;pV.prototype.constructor=pV;function qV(){}qV.prototype=pV.prototype;pV.prototype.v=function(){return"\x3cfunction1\x3e"};function rV(){}rV.prototype=new m;
rV.prototype.constructor=rV;function sV(){}sV.prototype=rV.prototype;rV.prototype.v=function(){return"\x3cfunction2\x3e"};function tV(){}tV.prototype=new m;tV.prototype.constructor=tV;function uV(){}uV.prototype=tV.prototype;tV.prototype.v=function(){return"\x3cfunction3\x3e"};function vV(){}vV.prototype=new m;vV.prototype.constructor=vV;function Voa(){}Voa.prototype=vV.prototype;vV.prototype.v=function(){return"\x3cfunction4\x3e"};function wV(){}wV.prototype=new m;wV.prototype.constructor=wV;
function Woa(){}Woa.prototype=wV.prototype;function vR(){this.Ro=null;this.Ca=this.E=0}vR.prototype=new m;vR.prototype.constructor=vR;e=vR.prototype;e.Lo=function(a,b){if(0>a)throw(new xV).mc(a);if(b>this.Fa())throw(new xV).mc(b);if(b<=a)return(new vR).Bl(this.Ro,0,0);var c=this.E+a|0;return(new vR).Bl(this.Ro,c,c+(b-a|0)|0)};e.v=function(){var a=this.E,a=0<a?a:0,b=this.Ro.i.length,c=a+this.Fa()|0,b=b<c?b:c;return a>=b?"":kr(Ga(),this.Ro,a,b-a|0)};
e.Fa=function(){var a=this.Ca-this.E|0;return 0>a?0:a};e.Bl=function(a,b,c){this.Ro=a;this.E=b;this.Ca=c;return this};e.Vj=function(a){if(0<=a&&a<this.Fa())return this.Ro.i[this.E+a|0];throw(new xV).mc(a);};e.$classData=l({H4:0},!1,"scala.runtime.ArrayCharSequence",{H4:1,f:1,ko:1});function Kl(){this.cb=!1}Kl.prototype=new m;Kl.prototype.constructor=Kl;Kl.prototype.v=function(){return""+this.cb};Kl.prototype.qj=function(a){this.cb=a;return this};
Kl.prototype.$classData=l({I4:0},!1,"scala.runtime.BooleanRef",{I4:1,f:1,k:1});function aQ(a){return!!(a&&a.$classData&&1===a.$classData.Nn&&a.$classData.Mn.H.TF)}var xa=l({TF:0},!1,"scala.runtime.BoxedUnit",{TF:1,f:1,k:1},void 0,void 0,function(a){return void 0===a});function JM(){this.cb=0}JM.prototype=new m;JM.prototype.constructor=JM;JM.prototype.v=function(){return""+this.cb};JM.prototype.mc=function(a){this.cb=a;return this};
JM.prototype.$classData=l({K4:0},!1,"scala.runtime.IntRef",{K4:1,f:1,k:1});function Uk(){this.cb=null}Uk.prototype=new m;Uk.prototype.constructor=Uk;Uk.prototype.v=function(){return""+this.cb};Uk.prototype.e=function(a){this.cb=a;return this};Uk.prototype.$classData=l({O4:0},!1,"scala.runtime.ObjectRef",{O4:1,f:1,k:1});function yV(){nQ.call(this)}yV.prototype=new Qka;yV.prototype.constructor=yV;yV.prototype.c=function(){nQ.prototype.c.call(this);return this};
yV.prototype.$classData=l({IG:0},!1,"fastparse.all$",{IG:1,c5:1,$4:1,f:1});var Xoa=void 0;function IK(){Xoa||(Xoa=(new yV).c());return Xoa}function zV(){}zV.prototype=new m;zV.prototype.constructor=zV;zV.prototype.c=function(){return this};function Yoa(a,b,c,d){return td((new yd).X((new r).d(["",":",""])),(new r).d([No(Po(),b,Po().Rx),Uka(c,d)]))}
function Zoa(a,b,c,d,f){b=b.St(lk(function(){return function(a){return null!==a}}(a)));a=lk(function(a,b){return function(a){if(null!==a){var c=a.va;a=a.so;return Yoa($oa(),a,b,c)}throw(new p).e(a);}}(a,c));var g=Xo();b=b.yf(a,g.b);a=Xo();f=b.br(f,a.b).Pd(" / ");c=FQ(c.Ve,d,10+d|0);return f+" ..."+Yo(c)}zV.prototype.$classData=l({PG:0},!1,"fastparse.core.Parsed$Failure$",{PG:1,f:1,l:1,k:1});var apa=void 0;function $oa(){apa||(apa=(new zV).c());return apa}function NQ(){}NQ.prototype=new m;
NQ.prototype.constructor=NQ;NQ.prototype.c=function(){return this};NQ.prototype.$classData=l({RG:0},!1,"fastparse.core.Parsed$TracedFailure$",{RG:1,f:1,l:1,k:1});var MQ=void 0;function wQ(){this.Af=null}wQ.prototype=new m;wQ.prototype.constructor=wQ;function AV(){}AV.prototype=wQ.prototype;wQ.prototype.Ne=function(a){this.Af=a;return this};wQ.prototype.Fk=function(){return Po().mp};var ala=l({ig:0},!1,"fastparse.core.Parser",{ig:1,f:1,pg:1,jg:1});wQ.prototype.$classData=ala;function TQ(){}
TQ.prototype=new m;TQ.prototype.constructor=TQ;TQ.prototype.c=function(){return this};TQ.prototype.$classData=l({VG:0},!1,"fastparse.parsers.Combinators$Either$",{VG:1,f:1,l:1,k:1});var $ka=void 0;function uQ(){}uQ.prototype=new m;uQ.prototype.constructor=uQ;uQ.prototype.c=function(){return this};uQ.prototype.v=function(){return"NoCut"};uQ.prototype.$classData=l({WG:0},!1,"fastparse.parsers.Combinators$NoCut$",{WG:1,f:1,l:1,k:1});var Ska=void 0;function tQ(){}tQ.prototype=new m;
tQ.prototype.constructor=tQ;tQ.prototype.c=function(){return this};tQ.prototype.v=function(){return"NoTrace"};tQ.prototype.$classData=l({XG:0},!1,"fastparse.parsers.Combinators$NoTrace$",{XG:1,f:1,l:1,k:1});var Rka=void 0;function BV(){}BV.prototype=new m;BV.prototype.constructor=BV;BV.prototype.c=function(){return this};
function YQ(a,b,c){var d=b.Dm,f=b.al;if(f&&f.$classData&&f.$classData.H.zu)return a=f.Bg,b=bpa(b.Gk,b.Wj,d),d=CV().b,b=Fw(a,b,d),cpa(f.Ql,b,c);if(f&&f.$classData&&f.$classData.H.yu)return f=YQ(a,f,c),a=f.Bg,b=bpa(b.Gk,b.Wj,d),d=CV().b,b=Fw(a,b,d),cpa(f.Ql,b,c);CV();b=[bpa(b.Gk,b.Wj,d)];if(0===(b.length|0))b=(new Fd).c();else{d=(new Fd).c();a=b.length|0;dpa(d,d.kd+a|0);for(var g=d.Da,h=d.kd,n=0,u=h,w=b.length|0,w=w<a?w:a,h=g.i.length-h|0,h=w<h?w:h;n<h;)g.i[u]=b[n],n=1+n|0,u=1+u|0;d.kd=d.kd+a|0;b=d}return cpa(f,
b,c)}BV.prototype.$classData=l({YG:0},!1,"fastparse.parsers.Combinators$Sequence$",{YG:1,f:1,l:1,k:1});var epa=void 0;function cla(){epa||(epa=(new BV).c());return epa}function zQ(){}zQ.prototype=new m;zQ.prototype.constructor=zQ;zQ.prototype.c=function(){return this};zQ.prototype.v=function(){return"IgnoreCase"};zQ.prototype.$classData=l({bH:0},!1,"fastparse.parsers.Terminals$IgnoreCase$",{bH:1,f:1,l:1,k:1});var Tka=void 0;
function DV(){this.oB=this.Qu=this.dy=this.lp=this.Xv=this.xm=this.rl=this.Tj=null}DV.prototype=new m;DV.prototype.constructor=DV;function fpa(a,b,c){0===c?(0<=b.Ya?(c=b.Ya,c=0===c?-2147483637>(-2147483648^b.Ra):0>c):c=!1,a=c?a.dy.i[b.Ra]:gpa(new hj,b,0)):a=0===b.Ra&&0===b.Ya&&0<=c&&c<a.Qu.i.length?a.Qu.i[c]:gpa(new hj,b,c);return a}
DV.prototype.c=function(){EV=this;this.Tj=(new hj).K(0,0);this.rl=(new hj).K(1,0);this.xm=(new hj).K(10,0);this.Xv=hpa(28,5);var a=this.Xv.i.length,b;b=[];for(var c=0;c<a;){var d=c,d=FV(GV(),GV().Xv.i[d]);b.push(d);c=1+c|0}na(bc(yc),b);this.lp=hpa(19,10);a=this.lp.i.length;b=[];for(c=0;c<a;)d=c,d=FV(GV(),GV().lp.i[d]),b.push(d),c=1+c|0;na(bc(yc),b);a=[];for(b=0;11>b;)c=b,c=(new hj).K(c,0),a.push(c),b=1+b|0;this.dy=na(bc(ipa),a);a=[];for(b=0;11>b;)c=b,c=(new hj).K(0,c),a.push(c),b=1+b|0;this.Qu=na(bc(ipa),
a);a=[];for(b=0;100>b;)a.push(48),b=1+b|0;this.oB=na(bc(jc),a);return this};function jpa(a,b,c,d){a=0>c?-c|0:c;var f=0===c?0:0>c?-1:1;if(sj().Nu===d)return f;if(sj().mu===d)return 0;if(sj().ku===d)return 0<f?f:0;if(sj().qu===d)return 0>f?f:0;if(sj().su===d)return 5<=a?f:0;if(sj().ru===d)return 5<a?f:0;if(sj().kp===d)return 5<(a+b|0)?f:0;if(sj().Mu===d){if(0===c)return 0;throw(new HV).j("Rounding necessary");}throw(new p).e(d);}
function IV(a,b){a=b.Ya;(-1===a?0>(-2147483648^b.Ra):-1>a)?a=!0:(a=b.Ya,a=0===a?-1<(-2147483648^b.Ra):0<a);if(a)throw(new HV).j("Out of int range: "+b);return b.Ra}function FV(a,b){b=0>b.Ya?(new Ep).K(~b.Ra,~b.Ya):b;a=b.Ra;b=b.Ya;return 64-(0!==b?ha(b):32+ha(a)|0)|0}
function hpa(a,b){a=oa(bc(zc),[-1+a|0]);var c;c=[];var d,f=d=(new Ep).K(1,0);c.push(null===f?null:f);for(var f=0,g=a.i.length;f<g;){var h=a.i[f],n=h.Ra,u=h.Ya,h=Ya(d);d=h.Ra;h=h.Ya;Ya((new Ep).K(n,u));var n=b>>31,w=65535&d,u=d>>>16|0,D=65535&b,N=b>>>16|0,Q=fa(w,D),D=fa(u,D),ea=fa(w,N),w=Q+((D+ea|0)<<16)|0,Q=(Q>>>16|0)+ea|0;d=(((fa(d,n)+fa(h,b)|0)+fa(u,N)|0)+(Q>>>16|0)|0)+(((65535&Q)+D|0)>>>16|0)|0;h=d=(new Ep).K(w,d);c.push(null===h?null:h);f=1+f|0}return na(bc(zc),c)}
DV.prototype.$classData=l({pH:0},!1,"java.math.BigDecimal$",{pH:1,f:1,l:1,k:1});var EV=void 0;function GV(){EV||(EV=(new DV).c());return EV}function JV(){this.Lu=this.Gz=this.Lr=this.Tj=this.xm=this.rl=null}JV.prototype=new m;JV.prototype.constructor=JV;
JV.prototype.c=function(){KV=this;this.rl=(new mp).K(1,1);this.xm=(new mp).K(1,10);this.Tj=(new mp).K(0,0);this.Lr=(new mp).K(-1,1);var a=(new r).d([this.Tj,this.rl,(new mp).K(1,2),(new mp).K(1,3),(new mp).K(1,4),(new mp).K(1,5),(new mp).K(1,6),(new mp).K(1,7),(new mp).K(1,8),(new mp).K(1,9),this.xm]),b=a.Da.length|0,b=oa(bc(dq),[b]),c;c=0;for(a=Cp(new Dp,a,a.Da.length|0);a.fb();){var d=a.bb();b.i[c]=d;c=1+c|0}this.Gz=b;b=[];for(c=0;32>c;)a=c,a=Up(vp(),(new Ep).K(0===(32&a)?1<<a:0,0===(32&a)?0:1<<
a)),b.push(null===a?null:a),c=1+c|0;this.Lu=na(bc(dq),b);return this};function Up(a,b){if(0>b.Ya)return-1!==b.Ra||-1!==b.Ya?(a=b.Ra,b=b.Ya,kpa(new mp,-1,(new Ep).K(-a|0,0!==a?~b:-b|0))):a.Lr;var c=b.Ya;return(0===c?-2147483638>=(-2147483648^b.Ra):0>c)?a.Gz.i[b.Ra]:kpa(new mp,1,b)}JV.prototype.$classData=l({qH:0},!1,"java.math.BigInteger$",{qH:1,f:1,l:1,k:1});var KV=void 0;function vp(){KV||(KV=(new JV).c());return KV}
function LV(){this.Mu=this.kp=this.ru=this.su=this.qu=this.ku=this.mu=this.Nu=null}LV.prototype=new m;LV.prototype.constructor=LV;
LV.prototype.c=function(){MV=this;this.Nu=(new NV).ui("UP",0);this.mu=(new NV).ui("DOWN",1);this.ku=(new NV).ui("CEILING",2);this.qu=(new NV).ui("FLOOR",3);this.su=(new NV).ui("HALF_UP",4);this.ru=(new NV).ui("HALF_DOWN",5);this.kp=(new NV).ui("HALF_EVEN",6);this.Mu=(new NV).ui("UNNECESSARY",7);var a=(new r).d([this.Nu,this.mu,this.ku,this.qu,this.su,this.ru,this.kp,this.Mu]),b=a.Da.length|0,b=oa(bc(lpa),[b]),c;c=0;for(a=Cp(new Dp,a,a.Da.length|0);a.fb();){var d=a.bb();b.i[c]=d;c=1+c|0}return this};
LV.prototype.$classData=l({zH:0},!1,"java.math.RoundingMode$",{zH:1,f:1,l:1,k:1});var MV=void 0;function sj(){MV||(MV=(new LV).c());return MV}function OV(){this.tv=this.Xz=this.bC=this.vq=this.pB=this.Pv=null}OV.prototype=new m;OV.prototype.constructor=OV;
OV.prototype.c=function(){PV=this;this.Pv="(?:(?:[0-9a-f]{1,4}:){7}[0-9a-f]{1,4}|(?:[0-9a-f]{1,4}:){1,7}:|(?:[0-9a-f]{1,4}:){1,6}(?::[0-9a-f]{1,4})|(?:[0-9a-f]{1,4}:){1,5}(?::[0-9a-f]{1,4}){1,2}|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}){1,3}|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,4}|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,5}|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,6}|:(?:(?::[0-9a-f]{1,4}){1,7}|:)|(?:[0-9a-f]{1,4}:){6}[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|(?:[0-9a-f]{1,4}:){1,5}:[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|(?:[0-9a-f]{1,4}:){1,4}(?::[0-9a-f]{1,4}):[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|(?:[0-9a-f]{1,4}:){1,3}(?::[0-9a-f]{1,4}){1,2}:[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|(?:[0-9a-f]{1,4}:){1,2}(?::[0-9a-f]{1,4}){1,3}:[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|(?:[0-9a-f]{1,4}:)(?::[0-9a-f]{1,4}){1,4}:[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|::(?:[0-9a-f]{1,4}:){1,5}[0-9]{1,3}(?:\\.[0-9]{1,3}){3})(?:%[0-9a-z]+)?";new ca.RegExp("^"+
this.Pv+"$","i");var a="//("+("(?:(?:((?:[a-z0-9-_.!~*'();:\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)@)?"+("((?:(?:[a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])\\.)*(?:[a-z]|[a-z][a-z0-9-]*[a-z0-9])\\.?|[0-9]{1,3}(?:\\.[0-9]{1,3}){3}|"+("\\[(?:"+this.Pv+")\\]")+")(?::([0-9]*))?")+")?|(?:[a-z0-9-_.!~*'()$,;:@\x26\x3d+]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])+")+")(/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?";
this.pB=new ca.RegExp("^(?:"+("([a-z][a-z0-9+-.]*):(?:("+("(?:"+a+"|(/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*))(?:\\?((?:[;/?:@\x26\x3d+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?")+
")|((?:[a-z0-9-_.!~*'();?:@\x26\x3d+$,]|%[a-f0-9]{2})(?:[;/?:@\x26\x3d+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))")+"|"+("((?:"+a+"|(/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)|((?:[a-z0-9-_.!~*'();@\x26\x3d+$,]|%[a-f0-9]{2})*(?:/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*(?:/(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*(?:;(?:[a-z0-9-_.!~*'():@\x26\x3d+$,]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*)*)*)?))(?:\\?((?:[;/?:@\x26\x3d+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?)")+
")(?:#((?:[;/?:@\x26\x3d+$,\\[\\]a-z0-9-_.!~*'()]|%[a-f0-9]{2}|[^\x00-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029])*))?$","i");this.vq=function(a){QV();var c,d=kV();a=wq(zq(),a,a.length|0);if(0===(4&d.ra)&&0===(4&d.ra)){var f=(new mV).c(),g=Fq().vm;if(null===g)throw(new t).j("null CodingErrorAction");f.pm=g;g=Fq().vm;if(null===g)throw(new t).j("null CodingErrorAction");f.sm=g;d.$z=f;d.ra|=4}d=d.$z;if(0===(a.jc-a.kb|0))c=pq(uq(),0);else{d.lj=0;f=Sa(ga(ga(a.jc-a.kb|0)*d.Xx));f=pq(uq(),f);
b:for(;;){c:{var g=d,h=a,n=f;if(3===g.lj)throw(new Cq).c();g.lj=2;for(;;){try{c=Soa(h,n)}catch(ba){if(ba&&ba.$classData&&ba.$classData.H.Du)throw Dq(ba);if(ba&&ba.$classData&&ba.$classData.H.Eu)throw Dq(ba);throw ba;}if(0===c.xi){var u=h.jc-h.kb|0;if(0<u){var w=Eq();switch(u){case 1:u=w.wi;break;case 2:u=w.Xk;break;case 3:u=w.Vm;break;case 4:u=w.dq;break;default:u=Eca(w,u)}}else u=c}else u=c;if(0===u.xi||1===u.xi){g=u;break c}w=3===u.xi?g.sm:g.pm;if(Fq().vm===w){if((n.jc-n.kb|0)<g.qm.i.length){g=
Eq().Qh;break c}var D=g.qm,w=n,N=D,D=D.i.length;if(w.Ph)throw(new Iq).c();if(0>D||0>(N.i.length-D|0))throw(new W).c();var Q=w.kb,ea=Q+D|0;if(ea>w.jc)throw(new Jq).c();w.kb=ea;Ta(N,0,w.Nd,w.ne+Q|0,D);w=h.kb;u=u.Um;if(0>u)throw(new Gq).c();mq.prototype.Pc.call(h,w+u|0)}else{if(Fq().wm===w){g=u;break c}if(Fq().tu===w){w=h.kb;u=u.Um;if(0>u)throw(new Gq).c();mq.prototype.Pc.call(h,w+u|0)}else throw(new p).e(w);}}}if(0!==g.xi){if(1===g.xi){f=Hca(f);continue b}Jca(g);throw(new fP).e("should not get here");
}FK(To(),a.kb===a.jc);c=f;break}b:for(;;){c:switch(a=d,a.lj){case 2:f=Eq().Qk;0===f.xi&&(a.lj=3);a=f;break c;case 3:a=Eq().Qk;break c;default:throw(new Cq).c();}if(0!==a.xi){if(1===a.xi){c=Hca(c);continue b}Jca(a);throw(new fP).e("should not get here");}break}mq.prototype.Un.call(c)}for(d="";c.kb!==c.jc;)a=255&lV(c),f=(+(a>>>0)).toString(16),d=d+(15>=a?"%0":"%")+f.toUpperCase();return d};new ca.RegExp('[\x00- "#/\x3c\x3e?@\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})',
"ig");this.bC=new ca.RegExp('[\x00- "#\x3c\x3e?\\[-\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})',"ig");this.Xz=new ca.RegExp('[\x00- "#/\x3c\x3e?\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})',"ig");this.tv=new ca.RegExp('[\x00- "#\x3c\x3e@\\^`{-}\u007f-\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000\u2028\u2029]|%(?![0-9a-f]{2})',"ig");new ca.RegExp("[^\x00-\u007f]+","g");return this};
function mpa(a,b,c,d,f,g){var h="";null!==b&&(h=""+h+b+":");null!==c&&(h=h+"//"+c.replace(a.Xz,a.vq));null!==d&&(h=""+h+d.replace(a.bC,a.vq));null!==f&&(h=h+"?"+f.replace(a.tv,a.vq));null!==g&&(h=h+"#"+g.replace(a.tv,a.vq));return h}
function npa(a,b){a=0;for(var c="";a<(b.length|0);)if(37===(65535&(b.charCodeAt(a)|0))){if(!((b.length|0)>(2+a|0)))throw(new fP).e("assertion failed: Invalid escape in URI");var d=b.substring(a,3+a|0),c=""+c+d.toUpperCase();a=3+a|0}else c=""+c+b.substring(a,1+a|0),a=1+a|0;return c}
function opa(a,b){a=(new cd).j(b);for(var c=0;;){if(c<(a.ka.length|0))var d=a.rc(c),d=37!==(null===d?0:d.pa)===!0;else d=!1;if(d)c=1+c|0;else break}if(c===(a.ka.length|0))return b;b=wq(zq(),b,b.length|0);zq();a=b.Jj;a=oa(bc(jc),[a]);d=c=a.i.length;if(0>d||d>a.i.length)throw(new W).c();if(0>c||c>d)throw(new W).c();a=ppa(d,a,0,0,c,!1);var c=pq(uq(),64),f;f=!1;var d=(kV(),(new jV).c()),g=Fq().vm;if(null===g)throw(new t).j("null CodingErrorAction");d.pm=g;g=Fq().vm;if(null===g)throw(new t).j("null CodingErrorAction");
for(d.sm=g;b.kb!==b.jc;)switch(g=b.Xn(),g){case 37:if(c.kb===c.jc){mq.prototype.Un.call(c);Bq(d,c,a,!1);f=c;if(f.Ph)throw(new Iq).c();g=f.jc-f.kb|0;Ta(f.Nd,f.ne+f.kb|0,f.Nd,f.ne,g);f.ml=-1;mq.prototype.ct.call(f,f.Jj);mq.prototype.Pc.call(f,g)}f=b.Xn();f=ca.String.fromCharCode(f);g=b.Xn();f=""+f+ca.String.fromCharCode(g);f=kR(aO(),f,16);nV(c,f<<24>>24);f=!0;break;default:f&&(mq.prototype.Un.call(c),Bq(d,c,a,!0),d.lj=1,mq.prototype.eA.call(c),f=!1),a.ln(g)}f&&(mq.prototype.Un.call(c),Bq(d,c,a,!0),
d.lj=1,mq.prototype.eA.call(c));mq.prototype.Un.call(a);return a.v()}OV.prototype.$classData=l({AH:0},!1,"java.net.URI$",{AH:1,f:1,l:1,k:1});var PV=void 0;function QV(){PV||(PV=(new OV).c());return PV}function sq(){mq.call(this);this.Nd=null;this.ne=0}sq.prototype=new nq;sq.prototype.constructor=sq;function qpa(){}qpa.prototype=sq.prototype;
sq.prototype.w=function(a){if(a&&a.$classData&&a.$classData.H.CH){a:if(this===a)a=0;else{for(var b=this.kb,c=this.jc-b|0,d=a.kb,f=a.jc-d|0,g=c<f?c:f,h=0;h!==g;){var n=this.Nd.i[this.ne+(b+h|0)|0]|0,u=a.Nd.i[a.ne+(d+h|0)|0]|0,n=n===u?0:n<u?-1:1;if(0!==n){a=n;break a}h=1+h|0}a=c===f?0:c<f?-1:1}a=0===a}else a=!1;return a};sq.prototype.II=function(a,b,c){this.Nd=b;this.ne=c;mq.prototype.mc.call(this,a);return this};
sq.prototype.A=function(){for(var a=this.kb,b=this.jc,c=-547316498,d=a;d!==b;){var f=XN();Y();c=f.Gb(c,YN(0,this.Nd.i[this.ne+d|0]|0));d=1+d|0}return XN().xd(c,b-a|0)};function Zq(){}Zq.prototype=new m;Zq.prototype.constructor=Zq;Zq.prototype.c=function(){return this};Zq.prototype.$classData=l({ZH:0},!1,"org.langmeta.inputs.Input$File$",{ZH:1,f:1,l:1,k:1});var Mca=void 0;function Yq(){}Yq.prototype=new m;Yq.prototype.constructor=Yq;Yq.prototype.c=function(){return this};
Yq.prototype.$classData=l({bI:0},!1,"org.langmeta.inputs.Input$Stream$",{bI:1,f:1,l:1,k:1});var Lca=void 0;function RV(){}RV.prototype=new m;RV.prototype.constructor=RV;RV.prototype.c=function(){return this};RV.prototype.$classData=l({pI:0},!1,"org.langmeta.semanticdb.Database$",{pI:1,f:1,l:1,k:1});var rpa=void 0;function SV(){}SV.prototype=new m;SV.prototype.constructor=SV;SV.prototype.c=function(){return this};
function spa(a,b){if(b.g())return"";a=function(){return function(a){return"  "+a.be()}}(a);var c=G().b;if(c===G().b)if(b===F())a=F();else{var c=b.n(),d=c=U(new V,a(c),F());for(b=b.o();b!==F();){var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f;b=b.o()}a=c}else{for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();a=c.da()}return a.le(lr().hg,lr().hg,"")}SV.prototype.$classData=l({tI:0},!1,"org.langmeta.semanticdb.ResolvedName$",{tI:1,f:1,l:1,k:1});var tpa=void 0;
function upa(){tpa||(tpa=(new SV).c());return tpa}function TV(){}TV.prototype=new m;TV.prototype.constructor=TV;TV.prototype.c=function(){return this};function ie(a,b){a=cj(b)?""+lr().hg+vpa(a,b):"";throw(new UV).j("this code path should've been unreachable"+a);}
function vpa(a,b){var c=G().b;b=H(b,c);var c=lk(function(){return function(a){return a.qa()}}(a)),d=wpa();b=xpa(b,c,d);a=function(){return function(a){if(null!==a)return td((new yd).X((new r).d(["where "," \x3d ",""])),(new r).d([a.qa(),a.p()]));throw(new p).e(a);}}(a);c=G().b;if(c===G().b)if(b===F())a=F();else{c=b.n();d=c=U(new V,a(c),F());for(b=b.o();b!==F();){var f=b.n(),f=U(new V,a(f),F()),d=d.ga=f;b=b.o()}a=c}else{for(c=zg(b,c);!b.g();)d=b.n(),c.ba(a(d)),b=b.o();a=c.da()}return a.Pd(lr().hg)}
TV.prototype.$classData=l({zI:0},!1,"org.scalameta.UnreachableError$",{zI:1,f:1,l:1,k:1});var ypa=void 0;function he(){ypa||(ypa=(new TV).c());return ypa}function VV(){}VV.prototype=new m;VV.prototype.constructor=VV;VV.prototype.c=function(){return this};
function K(a,b,c,d){b=td((new yd).X((new r).d(["\n      |invariant failed:\n      |when verifying ","\n      |found that ","\n    "])),(new r).d([b,c.n()])).trim();b=(new cd).j(b);b=zpa(b);b=(new cd).j(b);b=WV(b,10);var f=lr().hg,g=(new ql).c(),h=!1,h=!0;rl(g,"");for(var n=0,u=b.i.length;n<u;){var w=b.i[n];h?(sl(g,w),h=!1):(rl(g,f),sl(g,w));n=1+n|0}rl(g,"");b=g.Qb.ac;f=c.o().si();if(f.g())c=S();else{f.q();f=lr().hg;g=c.o();c=function(){return function(a){return"and also "+a}}(a);h=G().b;if(h===G().b)if(g===
F())c=F();else{h=g.n();n=h=U(new V,c(h),F());for(g=g.o();g!==F();)u=g.n(),u=U(new V,c(u),F()),n=n.ga=u,g=g.o();c=h}else{for(h=zg(g,h);!g.g();)n=g.n(),h.ba(c(n)),g=g.o();c=h.da()}c=(new T).e(""+f+c.Pd(lr().hg))}c=c.g()?"":c.q();if(cj(d)){f=lr().hg;g=G().b;d=H(d,g);g=lk(function(){return function(a){return a.qa()}}(a));h=wpa();d=xpa(d,g,h);a=function(){return function(a){if(null!==a)return td((new yd).X((new r).d(["where "," \x3d ",""])),(new r).d([a.qa(),a.p()]));throw(new p).e(a);}}(a);g=G().b;if(g===
G().b)if(d===F())a=F();else{g=d.n();h=g=U(new V,a(g),F());for(d=d.o();d!==F();)n=d.n(),n=U(new V,a(n),F()),h=h.ga=n,d=d.o();a=g}else{for(g=zg(d,g);!d.g();)h=d.n(),g.ba(a(h)),d=d.o();a=g.da()}a=""+f+a.Pd(lr().hg)}else a=void 0;throw(new XV).j(""+b+c+a);}VV.prototype.$classData=l({BI:0},!1,"org.scalameta.invariants.InvariantFailedException$",{BI:1,f:1,l:1,k:1});var Apa=void 0;function J(){Apa||(Apa=(new VV).c());return Apa}
var iaa=l({WI:0},!1,"java.lang.Boolean",{WI:1,f:1,k:1,xf:1},void 0,void 0,function(a){return"boolean"===typeof a});function ed(){this.pa=0}ed.prototype=new m;ed.prototype.constructor=ed;e=ed.prototype;e.w=function(a){return Od(a)?this.pa===a.pa:!1};e.v=function(){return ca.String.fromCharCode(this.pa)};e.db=function(a){this.pa=a;return this};e.A=function(){return this.pa};function Od(a){return!!(a&&a.$classData&&a.$classData.H.yB)}e.$classData=l({yB:0},!1,"java.lang.Character",{yB:1,f:1,k:1,xf:1});
function YV(){this.cA=this.bA=this.nB=null;this.ra=0}YV.prototype=new m;YV.prototype.constructor=YV;YV.prototype.c=function(){return this};function mF(a,b){a=WH(a,b);return 1===a||2===a||3===a||4===a||5===a}function ZH(a,b){a=WH(a,b);return 1===a||2===a||3===a||4===a||5===a||10===a}function WH(a,b){return 0>b?0:256>b?Bpa(a).i[b]:Cpa(a,b)}
function Dpa(a,b,c){return 36<c||2>c?-1:48<=b&&57>=b&&(-48+b|0)<c?-48+b|0:65<=b&&90>=b&&(-65+b|0)<(-10+c|0)?-55+b|0:97<=b&&122>=b&&(-97+b|0)<(-10+c|0)?-87+b|0:65313<=b&&65338>=b&&(-65313+b|0)<(-10+c|0)?-65303+b|0:65345<=b&&65370>=b&&(-65345+b|0)<(-10+c|0)?-65303+b|0:-1}function aj(a,b){return 256>b?48<=b&&57>=b:9===Cpa(a,b)}
function Cpa(a,b){Qr();a:{if(0===(2&a.ra)&&0===(2&a.ra)){var c=(new r).d([257,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,3,2,1,1,1,2,1,3,2,4,1,2,1,3,3,2,1,2,1,1,1,1,1,2,1,1,2,1,1,2,1,3,1,1,1,2,2,1,1,3,4,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,3,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,7,2,1,2,2,1,1,4,1,1,1,1,1,1,1,1,69,1,27,18,4,12,14,5,7,1,1,1,17,112,1,1,1,1,1,1,1,1,2,1,3,1,5,2,1,1,3,1,1,1,2,1,17,1,9,35,1,2,3,3,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,5,1,1,1,1,1,2,2,51,48,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,5,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,
1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,9,38,2,1,6,1,39,1,1,1,4,1,1,45,1,1,1,2,1,2,1,1,8,27,5,3,2,11,5,1,3,2,1,2,2,11,1,2,2,32,1,10,21,10,4,2,1,99,1,1,7,1,1,6,2,2,1,4,2,10,3,2,1,14,1,1,1,1,30,27,2,89,11,1,14,10,33,9,2,1,3,1,5,22,4,1,9,1,3,1,5,2,15,1,25,3,2,1,65,1,1,11,55,27,1,3,1,54,1,1,1,1,3,8,4,1,2,1,7,10,2,2,10,1,1,6,1,7,1,1,2,1,8,2,2,2,22,
1,7,1,1,3,4,2,1,1,3,4,2,2,2,2,1,1,8,1,4,2,1,3,2,2,10,2,2,6,1,1,5,2,1,1,6,4,2,2,22,1,7,1,2,1,2,1,2,2,1,1,3,2,4,2,2,3,3,1,7,4,1,1,7,10,2,3,1,11,2,1,1,9,1,3,1,22,1,7,1,2,1,5,2,1,1,3,5,1,2,1,1,2,1,2,1,15,2,2,2,10,1,1,15,1,2,1,8,2,2,2,22,1,7,1,2,1,5,2,1,1,1,1,1,4,2,2,2,2,1,8,1,1,4,2,1,3,2,2,10,1,1,6,10,1,1,1,6,3,3,1,4,3,2,1,1,1,2,3,2,3,3,3,12,4,2,1,2,3,3,1,3,1,2,1,6,1,14,10,3,6,1,1,6,3,1,8,1,3,1,23,1,10,1,5,3,1,3,4,1,3,1,4,7,2,1,2,6,2,2,2,10,8,7,1,2,2,1,8,1,3,1,23,1,10,1,5,2,1,1,1,1,5,1,1,2,1,2,2,7,2,
7,1,1,2,2,2,10,1,2,15,2,1,8,1,3,1,41,2,1,3,4,1,3,1,3,1,1,8,1,8,2,2,2,10,6,3,1,6,2,2,1,18,3,24,1,9,1,1,2,7,3,1,4,3,3,1,1,1,8,18,2,1,12,48,1,2,7,4,1,6,1,8,1,10,2,37,2,1,1,2,2,1,1,2,1,6,4,1,7,1,3,1,1,1,1,2,2,1,4,1,2,6,1,2,1,2,5,1,1,1,6,2,10,2,4,32,1,3,15,1,1,3,2,6,10,10,1,1,1,1,1,1,1,1,1,1,2,8,1,36,4,14,1,5,1,2,5,11,1,36,1,8,1,6,1,2,5,4,2,37,43,2,4,1,6,1,2,2,2,1,10,6,6,2,2,4,3,1,3,2,7,3,4,13,1,2,2,6,1,1,1,10,3,1,2,38,1,1,5,1,2,43,1,1,332,1,4,2,7,1,1,1,4,2,41,1,4,2,33,1,4,2,7,1,1,1,4,2,15,1,57,1,4,2,
67,2,3,9,20,3,16,10,6,85,11,1,620,2,17,1,26,1,1,3,75,3,3,15,13,1,4,3,11,18,3,2,9,18,2,12,13,1,3,1,2,12,52,2,1,7,8,1,2,11,3,1,3,1,1,1,2,10,6,10,6,6,1,4,3,1,1,10,6,35,1,52,8,41,1,1,5,70,10,29,3,3,4,2,3,4,2,1,6,3,4,1,3,2,10,30,2,5,11,44,4,17,7,2,6,10,1,3,34,23,2,3,2,2,53,1,1,1,7,1,1,1,1,2,8,6,10,2,1,10,6,10,6,7,1,6,82,4,1,47,1,1,5,1,1,5,1,2,7,4,10,7,10,9,9,3,2,1,30,1,4,2,2,1,1,2,2,10,44,1,1,2,3,1,1,3,2,8,4,36,8,8,2,2,3,5,10,3,3,10,30,6,2,64,8,8,3,1,13,1,7,4,1,4,2,1,2,9,44,63,13,1,34,37,39,21,4,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,9,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,9,8,6,2,6,2,8,
8,8,8,6,2,6,2,8,1,1,1,1,1,1,1,1,8,8,14,2,8,8,8,8,8,8,5,1,2,4,1,1,1,3,3,1,2,4,1,3,4,2,2,4,1,3,8,5,3,2,3,1,2,4,1,2,1,11,5,6,2,1,1,1,2,1,1,1,8,1,1,5,1,9,1,1,4,2,3,1,1,1,11,1,1,1,10,1,5,5,6,1,1,2,6,3,1,1,1,10,3,1,1,1,13,3,27,21,13,4,1,3,12,15,2,1,4,1,2,1,3,2,3,1,1,1,2,1,5,6,1,1,1,1,1,1,4,1,1,4,1,4,1,2,2,2,5,1,4,1,1,2,1,1,16,35,1,1,4,1,6,5,5,2,4,1,2,1,2,1,7,1,31,2,2,1,1,1,31,268,8,4,20,2,7,1,1,81,1,30,25,40,6,18,12,39,25,11,21,60,78,22,183,1,9,1,54,8,111,1,144,1,103,1,1,1,1,1,1,1,1,1,1,1,1,1,1,30,44,5,
1,1,31,1,1,1,1,1,1,1,1,1,1,16,256,131,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,63,1,1,1,1,32,1,1,258,48,21,2,6,3,10,166,47,1,47,1,1,1,3,2,1,1,1,1,1,1,4,1,1,2,1,6,2,3,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,6,1,1,1,1,3,1,1,5,4,1,2,38,1,1,5,1,2,56,7,1,1,14,1,23,9,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,32,2,1,1,1,1,3,1,1,1,1,1,9,1,2,1,1,1,1,2,1,1,1,
1,1,1,1,1,1,1,5,1,10,2,68,26,1,89,12,214,26,12,4,1,3,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,2,1,9,4,2,1,5,2,3,1,1,1,2,1,86,2,2,2,2,1,1,90,1,3,1,5,41,3,94,1,2,4,10,27,5,36,12,16,31,1,10,30,8,1,15,32,10,39,15,63,1,256,6582,10,64,20941,51,21,1,1143,3,55,9,40,6,2,268,1,3,16,10,2,20,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,10,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,7,1,70,10,2,6,8,23,9,2,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,1,1,
1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,8,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,12,1,1,1,1,1,1,1,1,1,1,1,77,2,1,7,1,3,1,4,1,23,2,2,1,4,4,6,2,1,1,6,52,4,8,2,50,16,1,9,2,10,6,18,6,3,1,4,10,28,8,2,23,11,2,11,1,29,3,3,1,47,1,2,4,2,1,4,13,1,1,10,4,2,32,41,6,2,2,2,2,9,3,1,8,1,1,2,10,2,4,16,1,6,3,1,1,4,48,1,1,3,2,2,5,2,1,1,1,24,2,1,2,11,1,2,2,2,1,2,1,1,10,6,2,6,2,6,9,7,1,7,145,35,2,1,2,1,2,1,1,1,2,10,6,11172,12,23,
4,49,4,2048,6400,366,2,106,38,7,12,5,5,1,1,10,1,13,1,5,1,1,1,2,1,2,1,108,16,17,363,1,1,16,64,2,54,40,12,1,1,2,16,7,1,1,1,6,7,9,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,4,3,3,1,4,1,1,1,1,1,1,1,3,1,1,3,1,1,1,2,4,5,1,135,2,1,1,3,1,3,1,1,1,1,1,1,2,10,2,3,2,26,1,1,1,1,1,1,26,1,1,1,1,1,1,1,1,1,2,10,1,45,2,31,3,6,2,6,2,6,2,3,3,2,1,1,1,2,1,1,4,2,10,3,2,2,12,1,26,1,19,1,2,1,15,2,14,34,123,5,3,4,45,3,9,53,4,17,1,5,12,52,45,1,130,29,3,49,47,31,1,4,12,17,1,8,1,53,30,1,1,36,4,8,1,5,42,40,40,78,2,10,854,6,2,
1,1,44,1,2,3,1,2,23,1,1,8,160,22,6,3,1,26,5,1,64,56,6,2,64,1,3,1,2,5,4,4,1,3,1,27,4,3,4,1,8,8,9,7,29,2,1,128,54,3,7,22,2,8,19,5,8,128,73,535,31,385,1,1,1,53,15,7,4,20,10,16,2,1,45,3,4,2,2,2,1,4,14,25,7,10,6,3,36,5,1,8,1,10,4,60,2,1,48,3,9,2,4,4,7,10,1190,43,1,1,1,2,6,1,1,8,10,2358,879,145,99,13,4,2956,1071,13265,569,1223,69,11,1,46,16,4,13,16480,2,8190,246,10,39,2,60,2,3,3,6,8,8,2,7,30,4,48,34,66,3,1,186,87,9,18,142,26,26,26,7,1,18,26,26,1,1,2,2,1,2,2,2,4,1,8,4,1,1,1,7,1,11,26,26,2,1,4,2,8,1,7,1,
26,2,1,4,1,5,1,1,3,7,1,26,26,26,26,26,26,26,26,26,26,26,26,28,2,25,1,25,1,6,25,1,25,1,6,25,1,25,1,6,25,1,25,1,6,25,1,25,1,6,1,1,2,50,5632,4,1,27,1,2,1,1,2,1,1,10,1,4,1,1,1,1,6,1,4,1,1,1,1,1,1,3,1,2,1,1,2,1,1,1,1,1,1,1,1,1,1,2,1,1,2,4,1,7,1,4,1,4,1,1,1,10,1,17,5,3,1,5,1,17,52,2,270,44,4,100,12,15,2,14,2,15,1,15,32,11,5,31,1,60,4,43,75,29,13,43,5,9,7,2,174,33,15,6,1,70,3,20,12,37,1,5,21,17,15,63,1,1,1,182,1,4,3,62,2,4,12,24,147,70,4,11,48,70,58,116,2188,42711,41,4149,11,222,16354,542,722403,1,30,96,
128,240,65040,65534,2,65534]),d=c.Da.length|0,d=oa(bc(yc),[d]),f;f=0;for(c=Cp(new Dp,c,c.Da.length|0);c.fb();){var g=c.bb();d.i[f]=g|0;f=1+f|0}c=d.i.length;f=-1+c|0;if(!(1>=c))for(c=1;;){g=c;d.i[g]=d.i[g]+d.i[-1+g|0]|0;if(c===f)break;c=1+c|0}a.bA=d;a.ra|=2}d=a.bA;f=0;c=d.i.length;for(;;){if(f===c){b=-1-f|0;break a}var g=(f+c|0)>>>1|0,h=d.i[g];if(b<h)c=g;else{if(dj(ej(),b,h)){b=g;break a}f=1+g|0}}}b=1+b|0;if(0===(4&a.ra)&&0===(4&a.ra)){c=(new r).d([1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,5,1,2,5,1,3,2,1,3,2,1,3,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,3,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
1,2,1,2,1,2,1,2,1,2,1,2,5,2,4,27,4,27,4,27,4,27,4,27,6,1,2,1,2,4,27,1,2,0,4,2,24,0,27,1,24,1,0,1,0,1,2,1,0,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,25,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,28,6,7,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,0,1,0,4,24,0,2,0,24,20,0,26,0,6,20,6,24,6,24,6,24,6,0,5,0,5,24,0,16,0,25,24,26,24,28,6,24,0,24,5,4,5,6,9,24,5,6,5,24,5,6,16,28,6,4,6,28,6,5,9,5,28,5,24,0,16,5,6,5,6,0,5,6,5,0,9,5,6,4,28,24,4,0,5,6,4,6,4,6,4,6,0,24,0,5,6,0,24,0,5,0,5,0,6,0,6,8,5,6,8,6,5,8,6,8,6,8,5,6,5,6,24,9,24,4,5,0,5,0,6,8,0,5,0,5,0,5,0,5,0,5,0,5,0,6,5,8,6,0,8,0,8,6,5,0,8,0,5,0,5,6,0,9,5,26,11,28,26,0,6,8,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,0,8,6,0,6,0,6,0,6,0,
5,0,5,0,9,6,5,6,0,6,8,0,5,0,5,0,5,0,5,0,5,0,5,0,6,5,8,6,0,6,8,0,8,6,0,5,0,5,6,0,9,24,26,0,6,8,0,5,0,5,0,5,0,5,0,5,0,5,0,6,5,8,6,8,6,0,8,0,8,6,0,6,8,0,5,0,5,6,0,9,28,5,11,0,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,8,6,8,0,8,0,8,6,0,5,0,8,0,9,11,28,26,28,0,8,0,5,0,5,0,5,0,5,0,5,0,5,6,8,0,6,0,6,0,6,0,5,0,5,6,0,9,0,11,28,0,8,0,5,0,5,0,5,0,5,0,5,0,6,5,8,6,8,0,6,8,0,8,6,0,8,0,5,0,5,6,0,9,0,5,0,8,0,5,0,5,0,5,0,5,8,6,0,8,0,8,6,5,0,8,0,5,6,0,9,11,0,28,5,0,8,0,5,0,5,0,5,0,5,0,5,0,6,0,8,6,0,6,0,8,0,8,24,0,
5,6,5,6,0,26,5,4,6,24,9,24,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,6,5,6,0,6,5,0,5,0,4,0,6,0,9,0,5,0,5,28,24,28,24,28,6,28,9,11,28,6,28,6,28,6,21,22,21,22,8,5,0,5,0,6,8,6,24,6,5,6,0,6,0,28,6,28,0,28,24,28,24,0,5,8,6,8,6,8,6,8,6,5,9,24,5,8,6,5,6,5,8,5,8,5,6,5,6,8,6,8,6,5,8,9,8,6,28,1,0,1,0,1,0,5,24,4,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,24,11,0,5,28,0,5,0,20,5,24,5,12,5,21,22,0,5,24,10,0,5,0,5,6,0,5,6,24,0,5,6,0,5,0,5,0,6,0,5,6,8,6,8,6,8,6,24,4,24,26,5,6,0,9,0,
11,0,24,20,24,6,12,0,9,0,5,4,5,0,5,6,5,0,5,0,5,0,6,8,6,8,0,8,6,8,6,0,28,0,24,9,5,0,5,0,5,0,8,5,8,0,9,11,0,28,5,6,8,0,24,5,8,6,8,6,0,6,8,6,8,6,8,6,0,6,9,0,9,0,24,4,24,0,6,8,5,6,8,6,8,6,8,6,8,5,0,9,24,28,6,28,0,6,8,5,8,6,8,6,8,6,8,5,9,5,6,8,6,8,6,8,6,8,0,24,5,8,6,8,6,0,24,9,0,5,9,5,4,24,0,24,0,6,24,6,8,6,5,6,5,8,6,5,0,2,4,2,4,2,4,6,0,6,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,
2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,0,1,0,2,1,2,1,2,0,1,0,2,0,1,0,1,0,1,0,1,2,1,2,0,2,3,2,3,2,3,2,0,2,1,3,27,2,27,2,0,2,1,3,27,2,0,2,1,0,27,2,1,27,0,2,0,2,1,3,27,0,12,16,20,24,29,30,21,29,30,21,29,24,13,
14,16,12,24,29,30,24,23,24,25,21,22,24,25,24,23,24,12,16,0,16,11,4,0,11,25,21,22,4,11,25,21,22,0,4,0,26,0,6,7,6,7,6,0,28,1,28,1,28,2,1,2,1,2,28,1,28,25,1,28,1,28,1,28,1,28,1,28,2,1,2,5,2,28,2,1,25,1,2,28,25,28,2,28,11,10,1,2,10,11,0,25,28,25,28,25,28,25,28,25,28,25,28,25,28,25,28,25,28,25,28,25,28,25,28,21,22,28,25,28,25,28,25,28,0,28,0,28,0,11,28,11,28,25,28,25,28,25,28,25,28,0,28,21,22,21,22,21,22,21,22,21,22,21,22,21,22,11,28,25,21,22,25,21,22,21,22,21,22,21,22,21,22,25,28,25,21,22,21,22,21,22,
21,22,21,22,21,22,21,22,21,22,21,22,21,22,21,22,25,21,22,21,22,25,21,22,25,28,25,28,25,0,28,0,1,0,2,0,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,4,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,28,1,2,1,2,6,1,2,0,24,11,24,2,0,2,0,2,0,5,0,4,24,0,6,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,6,24,29,30,29,30,24,29,30,24,29,30,24,20,24,20,24,29,30,24,29,30,21,22,21,22,
21,22,21,22,24,4,24,20,0,28,0,28,0,28,0,28,0,12,24,28,4,5,10,21,22,21,22,21,22,21,22,21,22,28,21,22,21,22,21,22,21,22,20,21,22,28,10,6,8,20,4,28,10,4,5,24,28,0,5,0,6,27,4,5,20,5,24,4,5,0,5,0,5,0,28,11,28,5,0,28,0,5,28,0,11,28,11,28,11,28,11,28,11,28,0,28,5,0,28,5,0,5,4,5,0,28,0,5,4,24,5,4,24,5,9,5,0,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,5,6,7,24,6,24,4,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,0,6,5,10,6,24,0,27,4,27,1,2,1,2,1,2,1,2,1,2,
1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,4,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,4,27,1,2,1,2,0,1,2,1,2,0,1,2,1,2,1,2,1,2,1,2,1,0,4,2,5,6,5,6,5,6,5,8,6,8,28,0,11,28,26,28,0,5,24,0,8,5,8,6,0,24,9,0,6,5,24,5,0,9,5,6,24,5,6,8,0,24,5,0,6,8,5,6,8,6,8,6,8,24,0,4,9,0,24,0,5,6,8,6,8,6,0,5,6,5,6,8,0,9,0,24,5,4,5,28,5,8,0,5,6,5,6,5,6,5,6,5,6,5,0,5,4,24,5,8,6,8,24,5,4,8,6,0,5,0,5,0,5,0,5,0,5,0,5,8,6,8,6,8,24,8,6,0,9,0,5,0,5,0,
5,0,19,18,5,0,5,0,2,0,2,0,5,6,5,25,5,0,5,0,5,0,5,0,5,0,5,27,0,5,21,22,0,5,0,5,0,5,26,28,0,6,24,21,22,24,0,6,0,24,20,23,21,22,21,22,21,22,21,22,21,22,21,22,21,22,21,22,24,21,22,24,23,24,0,24,20,21,22,21,22,21,22,24,25,20,25,0,24,26,24,0,5,0,5,0,16,0,24,26,24,21,22,24,25,24,20,24,9,24,25,24,1,21,24,22,27,23,27,2,21,25,22,25,21,22,24,21,22,24,5,4,5,4,5,0,5,0,5,0,5,0,5,0,26,25,27,28,26,0,28,25,28,0,16,28,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,24,0,11,0,28,10,11,28,11,0,28,0,28,6,0,5,0,5,0,5,0,11,0,5,10,5,10,0,
5,0,24,5,0,5,24,10,0,1,2,5,0,9,0,5,0,5,0,5,0,5,0,5,0,5,0,24,11,0,5,11,0,24,5,0,24,0,5,0,5,0,5,6,0,6,0,6,5,0,5,0,5,0,6,0,6,11,0,24,0,5,11,24,0,5,0,24,5,0,11,5,0,11,0,5,0,11,0,8,6,8,5,6,24,0,11,9,0,6,8,5,8,6,8,6,24,16,24,0,5,0,9,0,6,5,6,8,6,0,9,24,0,6,8,5,8,6,8,5,24,0,9,0,5,6,8,6,8,6,8,6,0,9,0,5,0,10,0,24,0,5,0,5,0,5,0,5,8,0,6,4,0,5,0,28,0,28,0,28,8,6,28,8,16,6,28,6,28,6,28,0,28,6,28,0,28,0,11,0,1,2,1,2,0,2,1,2,1,0,1,0,1,0,1,0,1,0,1,2,0,2,0,2,0,2,1,2,1,0,1,0,1,0,1,0,2,1,0,1,0,1,0,1,0,1,0,2,1,2,1,2,
1,2,1,2,1,2,1,2,0,1,25,2,25,2,1,25,2,25,2,1,25,2,25,2,1,25,2,25,2,1,25,2,25,2,1,2,0,9,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,5,0,25,0,28,0,28,0,28,0,28,0,28,0,28,0,11,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,28,0,5,0,5,0,5,0,5,0,16,0,16,0,6,0,18,0,18,0]);d=c.Da.length|0;d=oa(bc(rc),[d]);f=0;for(c=Cp(new Dp,c,c.Da.length|0);c.fb();)g=
c.bb(),d.i[f]=g|0,f=1+f|0;a.cA=d;a.ra|=4}return a.cA.i[0>b?-b|0:b]}
function Bpa(a){if(0===(1&a.ra)&&0===(1&a.ra)){var b=(new r).d([15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,12,24,24,24,26,24,24,24,21,22,24,25,24,20,24,24,9,9,9,9,9,9,9,9,9,9,24,24,25,25,25,24,24,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,21,24,22,27,23,27,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,21,25,22,25,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,12,24,26,26,26,26,28,
24,27,28,5,29,25,16,28,27,28,25,11,11,27,2,24,24,27,11,5,30,11,11,11,24,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,25,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,25,2,2,2,2,2,2,2,2]),c=b.Da.length|0,c=oa(bc(rc),[c]),d;d=0;for(b=Cp(new Dp,b,b.Da.length|0);b.fb();){var f=b.bb();c.i[d]=f|0;d=1+d|0}a.nB=c;a.ra|=1}return a.nB}function YH(a,b){a=WH(a,b);return 23===a||9===a||8===a||6===a||1===a||2===a||3===a||4===a||5===a||10===a||0<=b&&8>=b||14<=b&&27>=b||127<=b&&159>=b||16===a}
function ii(a,b){return 256>b?170===b||186===b||2===Bpa(a).i[b]:688<=b&&696>=b||704<=b&&705>=b||736<=b&&740>=b||837===b||890===b||7468<=b&&7530>=b||7544===b||7579<=b&&7615>=b||8305===b||8319===b||8336<=b&&8348>=b||8560<=b&&8575>=b||9424<=b&&9449>=b||11388<=b&&11389>=b||42864===b||43E3<=b&&43001>=b||2===Cpa(a,b)}YV.prototype.$classData=l({YI:0},!1,"java.lang.Character$",{YI:1,f:1,l:1,k:1});var Epa=void 0;function qi(){Epa||(Epa=(new YV).c());return Epa}function ZV(){this.fv=null;this.ra=!1}
ZV.prototype=new m;ZV.prototype.constructor=ZV;ZV.prototype.c=function(){return this};function Fpa(a){a.ra||(a.fv=new ca.RegExp("^[\\x00-\\x20]*[+-]?(NaN|Infinity|(\\d+\\.?\\d*|\\.\\d+)([eE][+-]?\\d+)?)[fFdD]?[\\x00-\\x20]*$"),a.ra=!0);return a.fv}function uH(a,b){if((a.ra?a.fv:Fpa(a)).test(b))return+ca.parseFloat(b);throw(new $V).j(td((new yd).X((new r).d(['For input string: "','"'])),(new r).d([b])));}ZV.prototype.$classData=l({bJ:0},!1,"java.lang.Double$",{bJ:1,f:1,l:1,k:1});var Gpa=void 0;
function vH(){Gpa||(Gpa=(new ZV).c());return Gpa}function aW(){this.Pa=null;this.Yx=0}aW.prototype=new m;aW.prototype.constructor=aW;function Hpa(){}Hpa.prototype=aW.prototype;aW.prototype.w=function(a){return this===a};aW.prototype.v=function(){return this.Pa};aW.prototype.ui=function(a,b){this.Pa=a;this.Yx=b;return this};aW.prototype.A=function(){return Ia(this)};function bW(){Rn.call(this)}bW.prototype=new jR;bW.prototype.constructor=bW;function cW(){}cW.prototype=bW.prototype;
bW.prototype.Dv=function(a){var b=null===a?null:a.v();Rn.prototype.fd.call(this,b,a);return this};function dW(){Rn.call(this)}dW.prototype=new jR;dW.prototype.constructor=dW;function eW(){}eW.prototype=dW.prototype;dW.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};dW.prototype.$classData=l({ae:0},!1,"java.lang.Exception",{ae:1,vd:1,f:1,k:1});function fW(){}fW.prototype=new m;fW.prototype.constructor=fW;fW.prototype.c=function(){return this};
function gW(a){throw(new $V).j(td((new yd).X((new r).d(['For input string: "','"'])),(new r).d([a])));}
function kR(a,b,c){if(null===b||0===((new cd).j(b).ka.length|0)||2>c||36<c)gW(b);else if(a=45===(65535&(b.charCodeAt(0)|0))||43===(65535&(b.charCodeAt(0)|0))?1:0,((new cd).j(b).ka.length|0)<=a)gW(b);else{for(;;){var d=a,f=(new cd).j(b).ka;if(d<(f.length|0))0>Dpa(qi(),65535&(b.charCodeAt(a)|0),c)&&gW(b),a=1+a|0;else break}c=+ca.parseInt(b,c);return c!==c||2147483647<c||-2147483648>c?gW(b):Sa(c)}}
function dP(a,b){a=b-(1431655765&b>>1)|0;a=(858993459&a)+(858993459&a>>2)|0;return fa(16843009,252645135&(a+(a>>4)|0))>>24}fW.prototype.$classData=l({eJ:0},!1,"java.lang.Integer$",{eJ:1,f:1,l:1,k:1});var Ipa=void 0;function aO(){Ipa||(Ipa=(new fW).c());return Ipa}function hW(){this.Lz=null;this.ra=!1}hW.prototype=new m;hW.prototype.constructor=hW;hW.prototype.c=function(){return this};function iW(a){throw(new $V).j(td((new yd).X((new r).d(['For input string: "','"'])),(new r).d([a])));}
hW.prototype.$classData=l({iJ:0},!1,"java.lang.Long$",{iJ:1,f:1,l:1,k:1});var Jpa=void 0;function Kpa(){Jpa||(Jpa=(new hW).c());return Jpa}function jW(){}jW.prototype=new m;jW.prototype.constructor=jW;function Lpa(){}Lpa.prototype=jW.prototype;jW.prototype.iA=function(a){var b=mR();a=a.Jl();b=OO(BO(b,a).Wd);for(a=!0;a&&b.fb();)a=b.bb(),a=this.Ac(a);return a};jW.prototype.v=function(){var a=mR(),b=this.Jl();return OO(BO(a,b).Wd).le("[",",","]")};
jW.prototype.Ac=function(a){for(var b=mR(),c=this.Jl(),b=OO(BO(b,c).Wd),c=!1;!c&&b.fb();)c=b.bb(),c=null===a?null===c:Aa(a,c);return c};jW.prototype.Rk=function(){throw(new Gq).c();};function kW(){oR.call(this);this.Lb=null}kW.prototype=new lla;kW.prototype.constructor=kW;function kla(a){var b=new kW;if(null===a)throw jo(wj(),null);b.Lb=a;oR.prototype.Vp.call(b,a.dr);return b}kW.prototype.$classData=l({DJ:0},!1,"java.util.HashMap$EntrySet$$anon$2",{DJ:1,Q5:1,f:1,HJ:1});
function CP(){this.Zx=this.Xm=null}CP.prototype=new m;CP.prototype.constructor=CP;CP.prototype.v=function(){return this.Zx};CP.prototype.$classData=l({PJ:0},!1,"java.util.regex.Pattern",{PJ:1,f:1,l:1,k:1});function lW(){this.uB=this.vB=null}lW.prototype=new m;lW.prototype.constructor=lW;lW.prototype.c=function(){mW=this;this.vB=new ca.RegExp("^\\\\Q(.|\\n|\\r)\\\\E$");this.uB=new ca.RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");return this};
function zka(a){for(var b="",c=0;c<(a.length|0);){var d=65535&(a.charCodeAt(c)|0);switch(d){case 92:case 46:case 40:case 41:case 91:case 93:case 123:case 125:case 124:case 63:case 42:case 43:case 94:case 36:d="\\"+(new ed).db(d);break;default:d=(new ed).db(d)}b=""+b+d;c=1+c|0}return b}function Aka(a,b){switch(b){case 105:return 2;case 100:return 1;case 109:return 8;case 115:return 32;case 117:return 64;case 120:return 4;case 85:return 256;default:throw(new t).j("bad in-pattern flag");}}
lW.prototype.$classData=l({QJ:0},!1,"java.util.regex.Pattern$",{QJ:1,f:1,l:1,k:1});var mW=void 0;function AP(){mW||(mW=(new lW).c());return mW}function yo(){this.XB=null}yo.prototype=new cda;yo.prototype.constructor=yo;yo.prototype.c=function(){xo=this;this.XB=(new QN).e(Er().WB);(new QN).e(Er().kv);(new QN).e(null);return this};yo.prototype.$classData=l({UJ:0},!1,"scala.Console$",{UJ:1,U5:1,f:1,h6:1});var xo=void 0;function ut(){this.np=0}ut.prototype=new m;ut.prototype.constructor=ut;
ut.prototype.c=function(){this.np=-1.7976931348623157E308;return this};ut.prototype.v=function(){return"object scala.Double"};ut.prototype.$classData=l({VJ:0},!1,"scala.Double$",{VJ:1,f:1,SJ:1,qC:1});var tt=void 0;function nW(){this.fx=null;this.GE=!1;this.en=0;this.Zk=null;this.cx=this.ex=0}nW.prototype=new m;nW.prototype.constructor=nW;function Mpa(){}Mpa.prototype=nW.prototype;
nW.prototype.v=function(){var a=Md(ra(this)),a=(new cd).j(a),a=Tg(a,"$"),a=(new cd).j(a),a=WV(a,46),a=Hd((new oW).Bk(a)),a=(new cd).j(a),a=WV(a,36);return Hd((new oW).Bk(a))};nW.prototype.mc=function(a){this.fx=(new Qq).c();this.GE=!1;(new Qq).c();this.ex=this.en=a;this.cx=0>a?a:0;return this};function ot(){this.np=0}ot.prototype=new m;ot.prototype.constructor=ot;ot.prototype.c=function(){this.np=-3.4028234663852886E38;return this};ot.prototype.v=function(){return"object scala.Float"};
ot.prototype.$classData=l({YJ:0},!1,"scala.Float$",{YJ:1,f:1,SJ:1,qC:1});var nt=void 0;function pW(){}pW.prototype=new m;pW.prototype.constructor=pW;pW.prototype.c=function(){return this};pW.prototype.up=function(a){return null===a?S():(new T).e(a)};pW.prototype.$classData=l({bK:0},!1,"scala.Option$",{bK:1,f:1,l:1,k:1});var Npa=void 0;function Xr(){Npa||(Npa=(new pW).c());return Npa}function qW(){this.OF=null}qW.prototype=new fda;qW.prototype.constructor=qW;
function FK(a,b){if(!b)throw(new fP).e("assertion failed");}qW.prototype.c=function(){rW=this;fj();G();Wja();QQ();Oe();Oe();Opa||(Opa=(new sW).c());(new tR).c();this.OF=(new tW).c();(new uW).c();return this};
function vW(a,b){if(Nd(b,1))return(new oW).Bk(b);if(Kc(b,1))return(new wW).fo(b);if(Oc(b,1))return(new xW).Zn(b);if(Nc(b,1))return(new yW).Uk(b);if(Wc(b,1))return(new zW).$n(b);if(Vc(b,1))return(new AW).ao(b);if(Sc(b,1))return(new BW).bo(b);if(Uc(b,1))return(new CW).co(b);if(Pc(b,1))return(new DW).eo(b);if(aQ(b))return(new EW).go(b);if(null===b)return null;throw(new p).e(b);}function pI(a,b){if(!b)throw(new t).j("requirement failed");}
qW.prototype.$classData=l({gK:0},!1,"scala.Predef$",{gK:1,Z5:1,f:1,V5:1});var rW=void 0;function To(){rW||(rW=(new qW).c());return rW}function FW(){}FW.prototype=new m;FW.prototype.constructor=FW;FW.prototype.c=function(){return this};FW.prototype.$classData=l({nK:0},!1,"scala.StringContext$",{nK:1,f:1,l:1,k:1});var Ppa=void 0;function bs(){this.gd=null}bs.prototype=new m;bs.prototype.constructor=bs;e=bs.prototype;e.w=function(a){return this===a};e.v=function(){return"'"+this.gd};
e.j=function(a){this.gd=a;return this};e.A=function(){var a=this.gd;return Da(Ga(),a)};e.$classData=l({pK:0},!1,"scala.Symbol",{pK:1,f:1,l:1,k:1});function GW(){this.vl=null;this.no=this.an=0;this.xk=null;this.ra=!1}GW.prototype=new m;GW.prototype.constructor=GW;GW.prototype.c=function(){HW=this;this.an=-512;this.no=512;this.xk=aq().sy;return this};
function mt(a,b){var c=new uj,d=new hj;a=""+a;hj.prototype.Bl.call(d,EP(Ga(),a),0,a.length|0);a=b.Hk;var f=qj(d)-a|0;if(!(IW(d)<a||0===a||0>=f))if(64>d.wf){a=GV().lp.i[f];var g=a.Ra,h=a.Ya,n=d.tc,u=n>>31,w=f>>31;a=n-f|0;var n=(-2147483648^a)>(-2147483648^n)?-1+(u-w|0)|0:u-w|0,f=d.Xe,w=f.Ra,D=f.Ya,u=ab(),f=Fp(u,w,D,g,h),u=u.dd,N=ab(),w=lq(N,w,D,g,h),D=N.dd;if(0!==w||0!==D){GV();if(0>D)var N=-w|0,Q=0!==w?~D:-D|0;else N=w,Q=D;N=(new Ep).K(N<<1,N>>>31|0|Q<<1);g=(new Ep).K(g,h);h=N.Ya;Q=g.Ya;(h===Q?(-2147483648^
N.Ra)>(-2147483648^g.Ra):h>Q)?g=1:(h=N.Ya,Q=g.Ya,g=(h===Q?(-2147483648^N.Ra)<(-2147483648^g.Ra):h<Q)?-1:0);g=fa(0>D?-1:0===D&&0===w?0:1,5+g|0);g=jpa(GV(),1&f,g,b.Rl);h=g>>31;g=f+g|0;f=(-2147483648^g)<(-2147483648^f)?1+(u+h|0)|0:u+h|0;0>f?(u=-g|0,h=0!==g?~f:-f|0):(u=g,h=f);u=sM(ab(),u,h);(void 0!==ca.Math.log10?+ca.Math.log10(u):+ca.Math.log(u)/2.302585092994046)>=b.Hk?(a=-1+a|0,n=-1!==a?n:-1+n|0,u=ab(),f=Fp(u,g,f,10,0),u=u.dd,a=(new Ep).K(a,n),f=(new Ep).K(f,u)):(a=(new Ep).K(a,n),f=(new Ep).K(g,
f))}else a=(new Ep).K(a,n),f=(new Ep).K(f,u);n=a;a=n.Ra;n=n.Ya;u=f;f=u.Ra;u=u.Ya;d.tc=IV(GV(),(new Ep).K(a,n));d.nl=b.Hk;d.Xe=(new Ep).K(f,u);d.wf=FV(GV(),(new Ep).K(f,u));d.ll=null}else g=jq(Lp(),(new Ep).K(f,f>>31)),n=Qpa(JW(d),g),u=d.tc,h=u>>31,w=f>>31,f=u-f|0,u=(-2147483648^f)>(-2147483648^u)?-1+(h-w|0)|0:h-w|0,0!==n.i[1].oc&&(h=KW(Rpa(Spa(n.i[1])),g),g=LW(n.i[0],0)?1:0,h=fa(n.i[1].oc,5+h|0),g=jpa(GV(),g,h,b.Rl),0!==g&&(g=Up(vp(),(new Ep).K(g,g>>31)),h=n.i[0],n.i[0]=Rp(Xp(),h,g)),qj((new hj).$j(n.i[0]))>
a&&(n.i[0]=Tpa(n.i[0],vp().xm),f=g=-1+f|0,u=-1!==g?u:-1+u|0)),d.tc=IV(GV(),(new Ep).K(f,u)),d.nl=a,Upa(d,n.i[0]);return tj(c,d,b)}GW.prototype.$classData=l({uK:0},!1,"scala.math.BigDecimal$",{uK:1,f:1,l:1,k:1});var HW=void 0;function gj(){HW||(HW=(new GW).c());return HW}function MW(){this.no=this.an=0;this.JE=this.vl=null}MW.prototype=new m;MW.prototype.constructor=MW;
MW.prototype.c=function(){NW=this;this.an=-1024;this.no=1024;this.vl=oa(bc(Vpa),[1+(this.no-this.an|0)|0]);this.JE=Up(vp(),(new Ep).K(-1,-1));return this};function Aj(a,b){if(a.an<=b&&b<=a.no){var c=b-a.an|0,d=a.vl.i[c];null===d&&(d=vp(),d=(new $s).$j(Up(d,(new Ep).K(b,b>>31))),a.vl.i[c]=d);return d}a=vp();return(new $s).$j(Up(a,(new Ep).K(b,b>>31)))}
function gt(a,b){var c=a.an,d=c>>31,f=b.Ya;(d===f?(-2147483648^c)<=(-2147483648^b.Ra):d<f)?(c=a.no,d=c>>31,f=b.Ya,c=f===d?(-2147483648^b.Ra)<=(-2147483648^c):f<d):c=!1;return c?Aj(a,b.Ra):(new $s).$j(Up(vp(),b))}MW.prototype.$classData=l({vK:0},!1,"scala.math.BigInt$",{vK:1,f:1,l:1,k:1});var NW=void 0;function Bj(){NW||(NW=(new MW).c());return NW}function sN(){}sN.prototype=new m;sN.prototype.constructor=sN;sN.prototype.c=function(){return this};
sN.prototype.$classData=l({xK:0},!1,"scala.math.Fractional$",{xK:1,f:1,l:1,k:1});var Aja=void 0;function tN(){}tN.prototype=new m;tN.prototype.constructor=tN;tN.prototype.c=function(){return this};tN.prototype.$classData=l({yK:0},!1,"scala.math.Integral$",{yK:1,f:1,l:1,k:1});var Bja=void 0;function uN(){}uN.prototype=new m;uN.prototype.constructor=uN;uN.prototype.c=function(){return this};uN.prototype.$classData=l({AK:0},!1,"scala.math.Numeric$",{AK:1,f:1,l:1,k:1});var Cja=void 0;function OW(){}
OW.prototype=new hR;OW.prototype.constructor=OW;function Wpa(){}Wpa.prototype=OW.prototype;function VP(a){return!!(a&&a.$classData&&a.$classData.H.sC)}function NB(){}NB.prototype=new m;NB.prototype.constructor=NB;NB.prototype.c=function(){return this};NB.prototype.$classData=l({VK:0},!1,"scala.meta.Case$",{VK:1,f:1,l:1,k:1});var ega=void 0;function PW(){}PW.prototype=new m;PW.prototype.constructor=PW;PW.prototype.c=function(){return this};
function KB(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Xpa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}PW.prototype.$classData=l({XK:0},!1,"scala.meta.Case$Quasi$",{XK:1,f:1,l:1,k:1});var Ypa=void 0;
function LB(){Ypa||(Ypa=(new PW).c());return Ypa}function QW(){}QW.prototype=new m;QW.prototype.constructor=QW;QW.prototype.c=function(){return this};
function Zda(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["mods is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();a=[(new q).a("mods",b)];b=A(new B,C());for(var g=0,h=a.length|0;g<h;)E(b,a[g]),g=1+g|0;K(c,"mods.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["name is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=
J();c=[(new q).a("name",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"name.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["paramss is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){a=J();d=[(new q).a("paramss",d)];b=A(new B,C());g=0;for(h=d.length|0;g<h;)E(b,d[g]),g=1+g|0;K(a,"paramss.!\x3d(null)",c,b.t)}throw(new p).e(f);}f=RW(null,null,null);g=function(a,b){return function(a){return a.y(a,
b,"mods",a.s)}}(a,f);h=G().b;if(h===G().b)if(b===F())b=F();else{var h=b.n(),n=h=U(new V,g(h),F());for(b=b.o();b!==F();){var u=b.n(),u=U(new V,g(u),F()),n=n.ga=u;b=b.o()}b=h}else{for(h=zg(b,h);!b.g();)n=b.n(),h.ba(g(n)),b=b.o();b=h.da()}f.gb=b;f.Pa=c.y(c,f,"name",c.s);c=function(a,b){return function(c){var d=function(a,b){return function(a){return a.y(a,b,"paramss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,
d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,f);a=G().b;if(a===G().b)if(d===F())d=F();else{a=d.n();b=a=U(new V,c(a),F());for(d=d.o();d!==F();)g=d.n(),g=U(new V,c(g),F()),b=b.ga=g,d=d.o();d=a}else{for(a=zg(d,a);!d.g();)b=d.n(),a.ba(c(b)),d=d.o();d=a.da()}f.Id=d;return f}QW.prototype.$classData=l({$K:0},!1,"scala.meta.Ctor$Primary$",{$K:1,f:1,l:1,k:1});var Zpa=void 0;function $da(){Zpa||(Zpa=(new QW).c());return Zpa}function Nx(){}
Nx.prototype=new m;Nx.prototype.constructor=Nx;Nx.prototype.c=function(){return this};
function Dea(a,b,c,d,f,g){if(null!==b)var h=(new q).a(!0,F());else{G();var n=(new r).d(["mods is equal to null"]),u=G().b,h=(new q).a(!1,H(n,u))}if(null===h||!0!==I(h)){if(null!==h){var w=h.p();if(!1===I(h)){for(var D=J(),N=[(new q).a("mods",b)],Q=A(new B,C()),ea=0,ba=N.length|0;ea<ba;)E(Q,N[ea]),ea=1+ea|0;K(D,"mods.!\x3d(null)",w,Q.t)}}throw(new p).e(h);}if(null!==c)var ma=(new q).a(!0,F());else{G();var La=(new r).d(["name is equal to null"]),Pa=G().b,ma=(new q).a(!1,H(La,Pa))}if(null===ma||!0!==
I(ma)){if(null!==ma){var Qa=ma.p();if(!1===I(ma)){for(var Ka=J(),Ba=[(new q).a("name",c)],va=A(new B,C()),za=0,qa=Ba.length|0;za<qa;)E(va,Ba[za]),za=1+za|0;K(Ka,"name.!\x3d(null)",Qa,va.t)}}throw(new p).e(ma);}if(null!==d)var la=(new q).a(!0,F());else{G();var Ma=(new r).d(["paramss is equal to null"]),Ea=G().b,la=(new q).a(!1,H(Ma,Ea))}if(null===la||!0!==I(la)){if(null!==la){var tb=la.p();if(!1===I(la)){for(var Za=J(),eb=[(new q).a("paramss",d)],kb=A(new B,C()),Pb=0,Na=eb.length|0;Pb<Na;)E(kb,eb[Pb]),
Pb=1+Pb|0;K(Za,"paramss.!\x3d(null)",tb,kb.t)}}throw(new p).e(la);}if(null!==f)var sb=(new q).a(!0,F());else{G();var yb=(new r).d(["init is equal to null"]),sc=G().b,sb=(new q).a(!1,H(yb,sc))}if(null===sb||!0!==I(sb)){if(null!==sb){var Ra=sb.p();if(!1===I(sb)){for(var wc=J(),Wb=[(new q).a("init",f)],Rb=A(new B,C()),ub=0,fb=Wb.length|0;ub<fb;)E(Rb,Wb[ub]),ub=1+ub|0;K(wc,"init.!\x3d(null)",Ra,Rb.t)}}throw(new p).e(sb);}if(null!==g)var Xb=(new q).a(!0,F());else{G();var lb=(new r).d(["stats is equal to null"]),
Eb=G().b,Xb=(new q).a(!1,H(lb,Eb))}if(null===Xb||!0!==I(Xb)){if(null!==Xb){var xc=Xb.p();if(!1===I(Xb)){for(var gb=J(),dc=[(new q).a("stats",g)],Fc=A(new B,C()),Qb=0,Bb=dc.length|0;Qb<Bb;)E(Fc,dc[Qb]),Qb=1+Qb|0;K(gb,"stats.!\x3d(null)",xc,Fc.t)}}throw(new p).e(Xb);}if(null!==d)var Ib=!0,mb=F();else{G();var Cb=(new r).d(["paramss is equal to null"]),Tb=G().b,mc=H(Cb,Tb),Ib=!1,mb=mc}var Ac=mb;if(Ib)if(cj(d))Va=(new q).a(!0,F());else{G();var Dc=(new r).d(["paramss.nonEmpty is false"]),Db=G().b,Va=(new q).a(!1,
H(Dc,Db))}else var Va=(new q).a(!1,Ac);if(null===Va||!0!==I(Va)){if(null!==Va){var ec=Va.p();if(!1===I(Va)){for(var $a=J(),vb=[(new q).a("paramss",d)],fc=A(new B,C()),Bc=0,Ub=vb.length|0;Bc<Ub;)E(fc,vb[Bc]),Bc=1+Bc|0;K($a,"paramss.!\x3d(null).\x26\x26(paramss.nonEmpty)",ec,fc.t)}}throw(new p).e(Va);}a:{for(var Vb=g;!Vb.g();){var wb=Vb.n();if(!DD(hv(wb))){var xb=!1;break a}Vb=Vb.o()}xb=!0}if(xb)var Xa=(new q).a(!0,F());else{G();var tc=(new r).d(["stats.forall(((x$14: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$14).isBlockStat)) is false"]),
ib=G().b,Xa=(new q).a(!1,H(tc,ib))}if(null===Xa||!0!==I(Xa)){if(null!==Xa){var zb=Xa.p();if(!1===I(Xa)){for(var nb=J(),Jb=[(new q).a("stats",g)],jb=A(new B,C()),ob=0,gc=Jb.length|0;ob<gc;)E(jb,Jb[ob]),ob=1+ob|0;K(nb,"stats.forall(((x$14: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$14).isBlockStat))",zb,jb.t)}}throw(new p).e(Xa);}var cb=$pa(null,null,null),Ua=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,cb),Yb=G().b;if(Yb===G().b)if(b===F())var Kb=
F();else{for(var pb=b.n(),hb=U(new V,Ua(pb),F()),Lb=hb,Fa=b.o();Fa!==F();)var bb=Fa.n(),nc=U(new V,Ua(bb),F()),Lb=Lb.ga=nc,Fa=Fa.o();Kb=hb}else{for(var db=zg(b,Yb),uc=b;!uc.g();){var Fb=uc.n();db.ba(Ua(Fb));uc=uc.o()}Kb=db.da()}cb.gb=Kb;cb.Pa=c.y(c,cb,"name",c.s);var hc=function(a,b){return function(c){var d=function(a,b){return function(a){return a.y(a,b,"paramss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,
d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,cb),$b=G().b;if($b===G().b)if(d===F())var kc=F();else{for(var lc=d.n(),Mb=U(new V,hc(lc),F()),Nb=Mb,Gb=d.o();Gb!==F();)var Sb=Gb.n(),Cc=U(new V,hc(Sb),F()),Nb=Nb.ga=Cc,Gb=Gb.o();kc=Mb}else{for(var Ob=zg(d,$b),Zb=d;!Zb.g();){var Ec=Zb.n();Ob.ba(hc(Ec));Zb=Zb.o()}kc=Ob.da()}cb.Id=kc;cb.xh=f.y(f,cb,"init",f.s);var oc=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,cb),pc=G().b;if(pc===
G().b)if(g===F())var qc=F();else{for(var Jc=g.n(),Hc=U(new V,oc(Jc),F()),ac=Hc,Lc=g.o();Lc!==F();)var $c=Lc.n(),Tc=U(new V,oc($c),F()),ac=ac.ga=Tc,Lc=Lc.o();qc=Hc}else{for(var Rc=zg(g,pc),Mc=g;!Mc.g();){var hd=Mc.n();Rc.ba(oc(hd));Mc=Mc.o()}qc=Rc.da()}cb.ld=qc;return cb}Nx.prototype.$classData=l({dL:0},!1,"scala.meta.Ctor$Secondary$",{dL:1,f:1,l:1,k:1});var Mx=void 0;function SW(){}SW.prototype=new m;SW.prototype.constructor=SW;SW.prototype.c=function(){return this};
function xea(a,b,c,d,f,g){if(null!==b)var h=(new q).a(!0,F());else{G();var h=(new r).d(["mods is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(g=h.p(),!1===I(h))){f=J();a=[(new q).a("mods",b)];d=A(new B,C());c=0;for(b=a.length|0;c<b;)E(d,a[c]),c=1+c|0;K(f,"mods.!\x3d(null)",g,d.t)}throw(new p).e(h);}null!==c?h=(new q).a(!0,F()):(G(),h=(new r).d(["name is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(g=h.p(),!1===I(h))){f=
J();a=[(new q).a("name",c)];d=A(new B,C());c=0;for(b=a.length|0;c<b;)E(d,a[c]),c=1+c|0;K(f,"name.!\x3d(null)",g,d.t)}throw(new p).e(h);}null!==d?h=(new q).a(!0,F()):(G(),h=(new r).d(["tparams is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(g=h.p(),!1===I(h))){f=J();a=[(new q).a("tparams",d)];d=A(new B,C());c=0;for(b=a.length|0;c<b;)E(d,a[c]),c=1+c|0;K(f,"tparams.!\x3d(null)",g,d.t)}throw(new p).e(h);}null!==f?h=(new q).a(!0,F()):(G(),h=(new r).d(["paramss is equal to null"]),
n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(g=h.p(),!1===I(h))){a=J();f=[(new q).a("paramss",f)];d=A(new B,C());c=0;for(b=f.length|0;c<b;)E(d,f[c]),c=1+c|0;K(a,"paramss.!\x3d(null)",g,d.t)}throw(new p).e(h);}null!==g?h=(new q).a(!0,F()):(G(),h=(new r).d(["decltpe is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(f=h.p(),!1===I(h))){a=J();g=[(new q).a("decltpe",g)];d=A(new B,C());c=0;for(b=g.length|0;c<b;)E(d,g[c]),c=1+c|0;K(a,"decltpe.!\x3d(null)",
f,d.t)}throw(new p).e(h);}var h=aqa(null,null,null),n=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,h),u=G().b;if(u===G().b)if(b===F())b=F();else{var u=b.n(),w=u=U(new V,n(u),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,n(D),F()),w=w.ga=D;b=b.o()}b=u}else{for(u=zg(b,u);!b.g();)w=b.n(),u.ba(n(w)),b=b.o();b=u.da()}h.gb=b;h.Pa=c.y(c,h,"name",c.s);c=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,h);b=G().b;if(b===G().b)if(d===F())d=F();else{b=d.n();n=b=U(new V,
c(b),F());for(d=d.o();d!==F();)u=d.n(),u=U(new V,c(u),F()),n=n.ga=u,d=d.o();d=b}else{for(b=zg(d,b);!d.g();)n=d.n(),b.ba(c(n)),d=d.o();d=b.da()}h.Mc=d;a=function(a,b){return function(c){var d=function(a,b){return function(a){return a.y(a,b,"paramss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,h);d=G().b;if(d===
G().b)if(f===F())f=F();else{d=f.n();c=d=U(new V,a(d),F());for(f=f.o();f!==F();)b=f.n(),b=U(new V,a(b),F()),c=c.ga=b,f=f.o();f=d}else{for(d=zg(f,d);!f.g();)c=f.n(),d.ba(a(c)),f=f.o();f=d.da()}h.Id=f;h.Lc=g.y(g,h,"decltpe",g.s);return h}SW.prototype.$classData=l({iL:0},!1,"scala.meta.Decl$Def$",{iL:1,f:1,l:1,k:1});var bqa=void 0;function wea(){bqa||(bqa=(new SW).c());return bqa}function TW(){}TW.prototype=new m;TW.prototype.constructor=TW;TW.prototype.c=function(){return this};
function Gea(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var g=(new r).d(["mods is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=J();c=[(new q).a("mods",b)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"mods.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==c?g=(new q).a(!0,F()):(G(),g=(new r).d(["name is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=
J();c=[(new q).a("name",c)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"name.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==d?g=(new q).a(!0,F()):(G(),g=(new r).d(["tparams is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){c=J();d=[(new q).a("tparams",d)];a=A(new B,C());b=0;for(h=d.length|0;b<h;)E(a,d[b]),b=1+b|0;K(c,"tparams.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==f?g=(new q).a(!0,F()):(G(),g=(new r).d(["bounds is equal to null"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(d=g.p(),!1===I(g))){c=J();f=[(new q).a("bounds",f)];a=A(new B,C());b=0;for(h=f.length|0;b<h;)E(a,f[b]),b=1+b|0;K(c,"bounds.!\x3d(null)",d,a.t)}throw(new p).e(g);}var g=cqa(null,null,null),h=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,g),n=G().b;if(n===G().b)if(b===F())b=F();else{var n=b.n(),u=n=U(new V,h(n),F());for(b=b.o();b!==F();){var w=b.n(),w=U(new V,h(w),F()),u=u.ga=w;b=b.o()}b=n}else{for(n=zg(b,n);!b.g();)u=
b.n(),n.ba(h(u)),b=b.o();b=n.da()}g.gb=b;g.Pa=c.y(c,g,"name",c.s);c=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,g);a=G().b;if(a===G().b)if(d===F())d=F();else{a=d.n();b=a=U(new V,c(a),F());for(d=d.o();d!==F();)h=d.n(),h=U(new V,c(h),F()),b=b.ga=h,d=d.o();d=a}else{for(a=zg(d,a);!d.g();)b=d.n(),a.ba(c(b)),d=d.o();d=a.da()}g.Mc=d;g.Ij=jA(f,g,f.s);return g}TW.prototype.$classData=l({lL:0},!1,"scala.meta.Decl$Type$",{lL:1,f:1,l:1,k:1});var dqa=void 0;
function Fea(){dqa||(dqa=(new TW).c());return dqa}function Lv(){}Lv.prototype=new m;Lv.prototype.constructor=Lv;Lv.prototype.c=function(){return this};
function Tda(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["mods is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();a=[(new q).a("mods",b)];b=A(new B,C());for(var g=0,h=a.length|0;g<h;)E(b,a[g]),g=1+g|0;K(c,"mods.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["pats is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=
J();c=[(new q).a("pats",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"pats.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["decltpe is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){a=J();d=[(new q).a("decltpe",d)];b=A(new B,C());g=0;for(h=d.length|0;g<h;)E(b,d[g]),g=1+g|0;K(a,"decltpe.!\x3d(null)",c,b.t)}throw(new p).e(f);}null!==c?(f=!0,g=F()):(G(),f=(new r).d(["pats is equal to null"]),
g=G().b,g=H(f,g),f=!1);f?cj(c)?f=(new q).a(!0,F()):(G(),f=(new r).d(["pats.nonEmpty is false"]),g=G().b,f=(new q).a(!1,H(f,g))):f=(new q).a(!1,g);if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=J();c=[(new q).a("pats",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"pats.!\x3d(null).\x26\x26(pats.nonEmpty)",d,b.t)}throw(new p).e(f);}f=eqa(null,null,null);g=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,f);h=G().b;if(h===G().b)if(b===F())b=F();else{var h=
b.n(),n=h=U(new V,g(h),F());for(b=b.o();b!==F();){var u=b.n(),u=U(new V,g(u),F()),n=n.ga=u;b=b.o()}b=h}else{for(h=zg(b,h);!b.g();)n=b.n(),h.ba(g(n)),b=b.o();b=h.da()}f.gb=b;a=function(a,b){return function(a){return a.y(a,b,"pats",a.s)}}(a,f);b=G().b;if(b===G().b)if(c===F())c=F();else{b=c.n();g=b=U(new V,a(b),F());for(c=c.o();c!==F();)h=c.n(),h=U(new V,a(h),F()),g=g.ga=h,c=c.o();c=b}else{for(b=zg(c,b);!c.g();)g=c.n(),b.ba(a(g)),c=c.o();c=b.da()}f.Gf=c;f.Lc=d.y(d,f,"decltpe",d.s);return f}
Lv.prototype.$classData=l({oL:0},!1,"scala.meta.Decl$Val$",{oL:1,f:1,l:1,k:1});var Kv=void 0;function Jv(){}Jv.prototype=new m;Jv.prototype.constructor=Jv;Jv.prototype.c=function(){return this};
function Sda(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["mods is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();a=[(new q).a("mods",b)];b=A(new B,C());for(var g=0,h=a.length|0;g<h;)E(b,a[g]),g=1+g|0;K(c,"mods.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["pats is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=
J();c=[(new q).a("pats",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"pats.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["decltpe is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){a=J();d=[(new q).a("decltpe",d)];b=A(new B,C());g=0;for(h=d.length|0;g<h;)E(b,d[g]),g=1+g|0;K(a,"decltpe.!\x3d(null)",c,b.t)}throw(new p).e(f);}null!==c?(f=!0,g=F()):(G(),f=(new r).d(["pats is equal to null"]),
g=G().b,g=H(f,g),f=!1);f?cj(c)?f=(new q).a(!0,F()):(G(),f=(new r).d(["pats.nonEmpty is false"]),g=G().b,f=(new q).a(!1,H(f,g))):f=(new q).a(!1,g);if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=J();c=[(new q).a("pats",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"pats.!\x3d(null).\x26\x26(pats.nonEmpty)",d,b.t)}throw(new p).e(f);}f=fqa(null,null,null);g=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,f);h=G().b;if(h===G().b)if(b===F())b=F();else{var h=
b.n(),n=h=U(new V,g(h),F());for(b=b.o();b!==F();){var u=b.n(),u=U(new V,g(u),F()),n=n.ga=u;b=b.o()}b=h}else{for(h=zg(b,h);!b.g();)n=b.n(),h.ba(g(n)),b=b.o();b=h.da()}f.gb=b;a=function(a,b){return function(a){return a.y(a,b,"pats",a.s)}}(a,f);b=G().b;if(b===G().b)if(c===F())c=F();else{b=c.n();g=b=U(new V,a(b),F());for(c=c.o();c!==F();)h=c.n(),h=U(new V,a(h),F()),g=g.ga=h,c=c.o();c=b}else{for(b=zg(c,b);!c.g();)g=c.n(),b.ba(a(g)),c=c.o();c=b.da()}f.Gf=c;f.Lc=d.y(d,f,"decltpe",d.s);return f}
Jv.prototype.$classData=l({sL:0},!1,"scala.meta.Decl$Var$",{sL:1,f:1,l:1,k:1});var Iv=void 0;function wA(){}wA.prototype=new m;wA.prototype.constructor=wA;wA.prototype.c=function(){return this};
function Kfa(a,b,c,d,f,g){if(null!==b)var h=(new q).a(!0,F());else{G();var h=(new r).d(["mods is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(f=h.p(),!1===I(h))){g=J();d=[(new q).a("mods",b)];c=A(new B,C());a=0;for(b=d.length|0;a<b;)E(c,d[a]),a=1+a|0;K(g,"mods.!\x3d(null)",f,c.t)}throw(new p).e(h);}null!==c?h=(new q).a(!0,F()):(G(),h=(new r).d(["name is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(f=h.p(),!1===I(h))){g=
J();d=[(new q).a("name",c)];c=A(new B,C());a=0;for(b=d.length|0;a<b;)E(c,d[a]),a=1+a|0;K(g,"name.!\x3d(null)",f,c.t)}throw(new p).e(h);}null!==d?h=(new q).a(!0,F()):(G(),h=(new r).d(["tparams is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(f=h.p(),!1===I(h))){g=J();d=[(new q).a("tparams",d)];c=A(new B,C());a=0;for(b=d.length|0;a<b;)E(c,d[a]),a=1+a|0;K(g,"tparams.!\x3d(null)",f,c.t)}throw(new p).e(h);}null!==f?h=(new q).a(!0,F()):(G(),h=(new r).d(["ctor is equal to null"]),
n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(g=h.p(),!1===I(h))){d=J();f=[(new q).a("ctor",f)];c=A(new B,C());a=0;for(b=f.length|0;a<b;)E(c,f[a]),a=1+a|0;K(d,"ctor.!\x3d(null)",g,c.t)}throw(new p).e(h);}null!==g?h=(new q).a(!0,F()):(G(),h=(new r).d(["templ is equal to null"]),n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(f=h.p(),!1===I(h))){d=J();g=[(new q).a("templ",g)];c=A(new B,C());a=0;for(b=g.length|0;a<b;)E(c,g[a]),a=1+a|0;K(d,"templ.!\x3d(null)",
f,c.t)}throw(new p).e(h);}var h=gqa(null,null,null),n=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,h),u=G().b;if(u===G().b)if(b===F())b=F();else{var u=b.n(),w=u=U(new V,n(u),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,n(D),F()),w=w.ga=D;b=b.o()}b=u}else{for(u=zg(b,u);!b.g();)w=b.n(),u.ba(n(w)),b=b.o();b=u.da()}h.gb=b;h.Pa=c.y(c,h,"name",c.s);c=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,h);a=G().b;if(a===G().b)if(d===F())d=F();else{a=d.n();b=a=U(new V,
c(a),F());for(d=d.o();d!==F();)n=d.n(),n=U(new V,c(n),F()),b=b.ga=n,d=d.o();d=a}else{for(a=zg(d,a);!d.g();)b=d.n(),a.ba(c(b)),d=d.o();d=a.da()}h.Mc=d;h.Mj=RW(f,h,f.s);h.oe=g.y(g,h,"templ",g.s);return h}wA.prototype.$classData=l({wL:0},!1,"scala.meta.Defn$Class$",{wL:1,f:1,l:1,k:1});var vA=void 0;function UW(){}UW.prototype=new m;UW.prototype.constructor=UW;UW.prototype.c=function(){return this};
function zea(a,b,c,d,f,g,h){if(null!==b)var n=(new q).a(!0,F());else{G();var n=(new r).d(["mods is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u))}if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=J();f=[(new q).a("mods",b)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"mods.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==c?n=(new q).a(!0,F()):(G(),n=(new r).d(["name is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=
J();f=[(new q).a("name",c)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"name.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==d?n=(new q).a(!0,F()):(G(),n=(new r).d(["tparams is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=J();f=[(new q).a("tparams",d)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"tparams.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==f?n=(new q).a(!0,F()):(G(),n=(new r).d(["paramss is equal to null"]),
u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=J();f=[(new q).a("paramss",f)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"paramss.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==g?n=(new q).a(!0,F()):(G(),n=(new r).d(["decltpe is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){f=J();g=[(new q).a("decltpe",g)];a=A(new B,C());d=0;for(c=g.length|0;d<c;)E(a,g[d]),d=1+d|0;K(f,"decltpe.!\x3d(null)",
h,a.t)}throw(new p).e(n);}null!==h?n=(new q).a(!0,F()):(G(),n=(new r).d(["body is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(g=n.p(),!1===I(n))){f=J();h=[(new q).a("body",h)];a=A(new B,C());d=0;for(c=h.length|0;d<c;)E(a,h[d]),d=1+d|0;K(f,"body.!\x3d(null)",g,a.t)}throw(new p).e(n);}var n=hqa(null,null,null),u=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,n),w=G().b;if(w===G().b)if(b===F())b=F();else{var w=b.n(),D=w=U(new V,u(w),F());for(b=
b.o();b!==F();){var N=b.n(),N=U(new V,u(N),F()),D=D.ga=N;b=b.o()}b=w}else{for(w=zg(b,w);!b.g();)D=b.n(),w.ba(u(D)),b=b.o();b=w.da()}n.gb=b;n.Pa=c.y(c,n,"name",c.s);c=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,n);b=G().b;if(b===G().b)if(d===F())d=F();else{b=d.n();u=b=U(new V,c(b),F());for(d=d.o();d!==F();)w=d.n(),w=U(new V,c(w),F()),u=u.ga=w,d=d.o();d=b}else{for(b=zg(d,b);!d.g();)u=d.n(),b.ba(c(u)),d=d.o();d=b.da()}n.Mc=d;a=function(a,b){return function(c){var d=function(a,
b){return function(a){return a.y(a,b,"paramss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,n);d=G().b;if(d===G().b)if(f===F())f=F();else{d=f.n();c=d=U(new V,a(d),F());for(f=f.o();f!==F();)b=f.n(),b=U(new V,a(b),F()),c=c.ga=b,f=f.o();f=d}else{for(d=zg(f,d);!f.g();)c=f.n(),d.ba(a(c)),f=f.o();f=d.da()}n.Id=f;g.g()?
g=S():(g=g.q(),g=(new T).e(g.y(g,n,"decltpe",g.s)));n.Lc=g;n.Kc=h.y(h,n,"body",h.s);return n}UW.prototype.$classData=l({zL:0},!1,"scala.meta.Defn$Def$",{zL:1,f:1,l:1,k:1});var iqa=void 0;function yea(){iqa||(iqa=(new UW).c());return iqa}function Hx(){}Hx.prototype=new m;Hx.prototype.constructor=Hx;Hx.prototype.c=function(){return this};
function Aea(a,b,c,d,f,g,h){if(null!==b)var n=(new q).a(!0,F());else{G();var n=(new r).d(["mods is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u))}if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=J();f=[(new q).a("mods",b)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"mods.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==c?n=(new q).a(!0,F()):(G(),n=(new r).d(["name is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=
J();f=[(new q).a("name",c)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"name.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==d?n=(new q).a(!0,F()):(G(),n=(new r).d(["tparams is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=J();f=[(new q).a("tparams",d)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"tparams.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==f?n=(new q).a(!0,F()):(G(),n=(new r).d(["paramss is equal to null"]),
u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){g=J();f=[(new q).a("paramss",f)];a=A(new B,C());d=0;for(c=f.length|0;d<c;)E(a,f[d]),d=1+d|0;K(g,"paramss.!\x3d(null)",h,a.t)}throw(new p).e(n);}null!==g?n=(new q).a(!0,F()):(G(),n=(new r).d(["decltpe is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(h=n.p(),!1===I(n))){f=J();g=[(new q).a("decltpe",g)];a=A(new B,C());d=0;for(c=g.length|0;d<c;)E(a,g[d]),d=1+d|0;K(f,"decltpe.!\x3d(null)",
h,a.t)}throw(new p).e(n);}null!==h?n=(new q).a(!0,F()):(G(),n=(new r).d(["body is equal to null"]),u=G().b,n=(new q).a(!1,H(n,u)));if(null===n||!0!==I(n)){if(null!==n&&(g=n.p(),!1===I(n))){f=J();h=[(new q).a("body",h)];a=A(new B,C());d=0;for(c=h.length|0;d<c;)E(a,h[d]),d=1+d|0;K(f,"body.!\x3d(null)",g,a.t)}throw(new p).e(n);}var n=jqa(null,null,null),u=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,n),w=G().b;if(w===G().b)if(b===F())b=F();else{var w=b.n(),D=w=U(new V,u(w),F());for(b=
b.o();b!==F();){var N=b.n(),N=U(new V,u(N),F()),D=D.ga=N;b=b.o()}b=w}else{for(w=zg(b,w);!b.g();)D=b.n(),w.ba(u(D)),b=b.o();b=w.da()}n.gb=b;n.Pa=c.y(c,n,"name",c.s);c=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,n);b=G().b;if(b===G().b)if(d===F())d=F();else{b=d.n();u=b=U(new V,c(b),F());for(d=d.o();d!==F();)w=d.n(),w=U(new V,c(w),F()),u=u.ga=w,d=d.o();d=b}else{for(b=zg(d,b);!d.g();)u=d.n(),b.ba(c(u)),d=d.o();d=b.da()}n.Mc=d;a=function(a,b){return function(c){var d=function(a,
b){return function(a){return a.y(a,b,"paramss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,n);d=G().b;if(d===G().b)if(f===F())f=F();else{d=f.n();c=d=U(new V,a(d),F());for(f=f.o();f!==F();)b=f.n(),b=U(new V,a(b),F()),c=c.ga=b,f=f.o();f=d}else{for(d=zg(f,d);!f.g();)c=f.n(),d.ba(a(c)),f=f.o();f=d.da()}n.Id=f;g.g()?
g=S():(g=g.q(),g=(new T).e(g.y(g,n,"decltpe",g.s)));n.Lc=g;n.Kc=h.y(h,n,"body",h.s);return n}Hx.prototype.$classData=l({CL:0},!1,"scala.meta.Defn$Macro$",{CL:1,f:1,l:1,k:1});var Gx=void 0;function oA(){}oA.prototype=new m;oA.prototype.constructor=oA;oA.prototype.c=function(){return this};
function Jfa(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["mods is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();b=[(new q).a("mods",b)];a=A(new B,C());for(var g=0,h=b.length|0;g<h;)E(a,b[g]),g=1+g|0;K(c,"mods.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["name is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){b=
J();c=[(new q).a("name",c)];a=A(new B,C());g=0;for(h=c.length|0;g<h;)E(a,c[g]),g=1+g|0;K(b,"name.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["templ is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){b=J();d=[(new q).a("templ",d)];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(b,"templ.!\x3d(null)",c,a.t)}throw(new p).e(f);}f=v();y(z(f,d),VS())?(g=!0,f=F()):(G(),f=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Template](templ)(scala.meta.Tree.classifiable[scala.meta.Template]).is[Template.Quasi](Template.this.Quasi.ClassifierClass[scala.meta.Template]) is false"]),
g=G().b,f=H(f,g),g=!1);if(g)f=(new q).a(!0,F());else{a:{for(g=d.ub();!g.g();){var h=g.n(),n=v();if(y(z(n,h),ER())){g=!1;break a}g=g.o()}g=!0}g?(g=!0,h=F()):(G(),g=(new r).d(["templ.stats.forall(((x$11: scala.meta.Stat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Stat](x$11)(scala.meta.Tree.classifiable[scala.meta.Stat]).is[Ctor](scala.meta.Ctor.ClassifierClass[scala.meta.Stat]).`unary_!`)) is false"]),h=G().b,h=H(g,h),g=!1);g?f=(new q).a(!0,F()):(g=G(),f=(new q).a(!1,
f.ma(h,g.b)))}if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){b=J();d=[(new q).a("templ",d),(new q).a("Template",xD())];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(b,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Template](templ)(scala.meta.Tree.classifiable[scala.meta.Template]).is[Template.Quasi](Template.this.Quasi.ClassifierClass[scala.meta.Template]).||(templ.stats.forall(((x$11: scala.meta.Stat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Stat](x$11)(scala.meta.Tree.classifiable[scala.meta.Stat]).is[Ctor](scala.meta.Ctor.ClassifierClass[scala.meta.Stat]).`unary_!`)))",
c,a.t)}throw(new p).e(f);}f=kqa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,f);g=G().b;if(g===G().b)if(b===F())b=F();else{g=b.n();h=g=U(new V,a(g),F());for(b=b.o();b!==F();)n=b.n(),n=U(new V,a(n),F()),h=h.ga=n,b=b.o();b=g}else{for(g=zg(b,g);!b.g();)h=b.n(),g.ba(a(h)),b=b.o();b=g.da()}f.gb=b;f.Pa=c.y(c,f,"name",c.s);f.oe=d.y(d,f,"templ",d.s);return f}oA.prototype.$classData=l({FL:0},!1,"scala.meta.Defn$Object$",{FL:1,f:1,l:1,k:1});var nA=void 0;
function Mw(){}Mw.prototype=new m;Mw.prototype.constructor=Mw;Mw.prototype.c=function(){return this};
function fea(a,b,c,d,f,g){if(null!==b)var h=(new q).a(!0,F());else{G();var n=(new r).d(["mods is equal to null"]),u=G().b,h=(new q).a(!1,H(n,u))}if(null===h||!0!==I(h)){if(null!==h){var w=h.p();if(!1===I(h)){for(var D=J(),N=[(new q).a("mods",b)],Q=A(new B,C()),ea=0,ba=N.length|0;ea<ba;)E(Q,N[ea]),ea=1+ea|0;K(D,"mods.!\x3d(null)",w,Q.t)}}throw(new p).e(h);}if(null!==c)var ma=(new q).a(!0,F());else{G();var La=(new r).d(["name is equal to null"]),Pa=G().b,ma=(new q).a(!1,H(La,Pa))}if(null===ma||!0!==
I(ma)){if(null!==ma){var Qa=ma.p();if(!1===I(ma)){for(var Ka=J(),Ba=[(new q).a("name",c)],va=A(new B,C()),za=0,qa=Ba.length|0;za<qa;)E(va,Ba[za]),za=1+za|0;K(Ka,"name.!\x3d(null)",Qa,va.t)}}throw(new p).e(ma);}if(null!==d)var la=(new q).a(!0,F());else{G();var Ma=(new r).d(["tparams is equal to null"]),Ea=G().b,la=(new q).a(!1,H(Ma,Ea))}if(null===la||!0!==I(la)){if(null!==la){var tb=la.p();if(!1===I(la)){for(var Za=J(),eb=[(new q).a("tparams",d)],kb=A(new B,C()),Pb=0,Na=eb.length|0;Pb<Na;)E(kb,eb[Pb]),
Pb=1+Pb|0;K(Za,"tparams.!\x3d(null)",tb,kb.t)}}throw(new p).e(la);}if(null!==f)var sb=(new q).a(!0,F());else{G();var yb=(new r).d(["ctor is equal to null"]),sc=G().b,sb=(new q).a(!1,H(yb,sc))}if(null===sb||!0!==I(sb)){if(null!==sb){var Ra=sb.p();if(!1===I(sb)){for(var wc=J(),Wb=[(new q).a("ctor",f)],Rb=A(new B,C()),ub=0,fb=Wb.length|0;ub<fb;)E(Rb,Wb[ub]),ub=1+ub|0;K(wc,"ctor.!\x3d(null)",Ra,Rb.t)}}throw(new p).e(sb);}if(null!==g)var Xb=(new q).a(!0,F());else{G();var lb=(new r).d(["templ is equal to null"]),
Eb=G().b,Xb=(new q).a(!1,H(lb,Eb))}if(null===Xb||!0!==I(Xb)){if(null!==Xb){var xc=Xb.p();if(!1===I(Xb)){for(var gb=J(),dc=[(new q).a("templ",g)],Fc=A(new B,C()),Qb=0,Bb=dc.length|0;Qb<Bb;)E(Fc,dc[Qb]),Qb=1+Qb|0;K(gb,"templ.!\x3d(null)",xc,Fc.t)}}throw(new p).e(Xb);}var Ib=v();if(y(z(Ib,g),VS()))var mb=!0,Cb=F();else{G();var Tb=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Template](templ)(scala.meta.Tree.classifiable[scala.meta.Template]).is[Template.Quasi](Template.this.Quasi.ClassifierClass[scala.meta.Template]) is false"]),
mc=G().b,Ac=H(Tb,mc),mb=!1,Cb=Ac}var Dc=Cb;if(mb)var Db=(new q).a(!0,F());else{a:{for(var Va=g.ub();!Va.g();){var ec=Va.n(),$a=v();if(y(z($a,ec),ER())){var vb=!1;break a}Va=Va.o()}vb=!0}if(vb)var fc=!0,Bc=F();else{G();var Ub=(new r).d(["templ.stats.forall(((x$10: scala.meta.Stat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Stat](x$10)(scala.meta.Tree.classifiable[scala.meta.Stat]).is[Ctor](scala.meta.Ctor.ClassifierClass[scala.meta.Stat]).`unary_!`)) is false"]),Vb=G().b,
wb=H(Ub,Vb),fc=!1,Bc=wb}var xb=Bc;if(fc)Db=(new q).a(!0,F());else var Xa=G(),Db=(new q).a(!1,Dc.ma(xb,Xa.b))}if(null===Db||!0!==I(Db)){if(null!==Db){var tc=Db.p();if(!1===I(Db)){for(var ib=J(),zb=[(new q).a("templ",g),(new q).a("Template",xD())],nb=A(new B,C()),Jb=0,jb=zb.length|0;Jb<jb;)E(nb,zb[Jb]),Jb=1+Jb|0;K(ib,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Template](templ)(scala.meta.Tree.classifiable[scala.meta.Template]).is[Template.Quasi](Template.this.Quasi.ClassifierClass[scala.meta.Template]).||(templ.stats.forall(((x$10: scala.meta.Stat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Stat](x$10)(scala.meta.Tree.classifiable[scala.meta.Stat]).is[Ctor](scala.meta.Ctor.ClassifierClass[scala.meta.Stat]).`unary_!`)))",
tc,nb.t)}}throw(new p).e(Db);}var ob=lqa(null,null,null),gc=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,ob),cb=G().b;if(cb===G().b)if(b===F())var Ua=F();else{for(var Yb=b.n(),Kb=U(new V,gc(Yb),F()),pb=Kb,hb=b.o();hb!==F();)var Lb=hb.n(),Fa=U(new V,gc(Lb),F()),pb=pb.ga=Fa,hb=hb.o();Ua=Kb}else{for(var bb=zg(b,cb),nc=b;!nc.g();){var db=nc.n();bb.ba(gc(db));nc=nc.o()}Ua=bb.da()}ob.gb=Ua;ob.Pa=c.y(c,ob,"name",c.s);var uc=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,
ob),Fb=G().b;if(Fb===G().b)if(d===F())var hc=F();else{for(var $b=d.n(),kc=U(new V,uc($b),F()),lc=kc,Mb=d.o();Mb!==F();)var Nb=Mb.n(),Gb=U(new V,uc(Nb),F()),lc=lc.ga=Gb,Mb=Mb.o();hc=kc}else{for(var Sb=zg(d,Fb),Cc=d;!Cc.g();){var Ob=Cc.n();Sb.ba(uc(Ob));Cc=Cc.o()}hc=Sb.da()}ob.Mc=hc;ob.Mj=RW(f,ob,f.s);ob.oe=g.y(g,ob,"templ",g.s);return ob}Mw.prototype.$classData=l({IL:0},!1,"scala.meta.Defn$Trait$",{IL:1,f:1,l:1,k:1});var Lw=void 0;function Sx(){}Sx.prototype=new m;Sx.prototype.constructor=Sx;
Sx.prototype.c=function(){return this};
function Eea(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var g=(new r).d(["mods is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=J();c=[(new q).a("mods",b)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"mods.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==c?g=(new q).a(!0,F()):(G(),g=(new r).d(["name is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=
J();c=[(new q).a("name",c)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"name.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==d?g=(new q).a(!0,F()):(G(),g=(new r).d(["tparams is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){c=J();d=[(new q).a("tparams",d)];a=A(new B,C());b=0;for(h=d.length|0;b<h;)E(a,d[b]),b=1+b|0;K(c,"tparams.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==f?g=(new q).a(!0,F()):(G(),g=(new r).d(["body is equal to null"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(d=g.p(),!1===I(g))){c=J();f=[(new q).a("body",f)];a=A(new B,C());b=0;for(h=f.length|0;b<h;)E(a,f[b]),b=1+b|0;K(c,"body.!\x3d(null)",d,a.t)}throw(new p).e(g);}var g=mqa(null,null,null),h=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,g),n=G().b;if(n===G().b)if(b===F())b=F();else{var n=b.n(),u=n=U(new V,h(n),F());for(b=b.o();b!==F();){var w=b.n(),w=U(new V,h(w),F()),u=u.ga=w;b=b.o()}b=n}else{for(n=zg(b,n);!b.g();)u=
b.n(),n.ba(h(u)),b=b.o();b=n.da()}g.gb=b;g.Pa=c.y(c,g,"name",c.s);c=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,g);a=G().b;if(a===G().b)if(d===F())d=F();else{a=d.n();b=a=U(new V,c(a),F());for(d=d.o();d!==F();)h=d.n(),h=U(new V,c(h),F()),b=b.ga=h,d=d.o();d=a}else{for(a=zg(d,a);!d.g();)b=d.n(),a.ba(c(b)),d=d.o();d=a.da()}g.Mc=d;g.Kc=f.y(f,g,"body",f.s);return g}Sx.prototype.$classData=l({LL:0},!1,"scala.meta.Defn$Type$",{LL:1,f:1,l:1,k:1});var Rx=void 0;function Fv(){}
Fv.prototype=new m;Fv.prototype.constructor=Fv;Fv.prototype.c=function(){return this};
function Rda(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var g=(new r).d(["mods is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=J();c=[(new q).a("mods",b)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"mods.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==c?g=(new q).a(!0,F()):(G(),g=(new r).d(["pats is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=
J();c=[(new q).a("pats",c)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"pats.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==d?g=(new q).a(!0,F()):(G(),g=(new r).d(["decltpe is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){c=J();d=[(new q).a("decltpe",d)];a=A(new B,C());b=0;for(h=d.length|0;b<h;)E(a,d[b]),b=1+b|0;K(c,"decltpe.!\x3d(null)",f,a.t)}throw(new p).e(g);}null!==f?g=(new q).a(!0,F()):(G(),g=(new r).d(["rhs is equal to null"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(d=g.p(),!1===I(g))){c=J();f=[(new q).a("rhs",f)];a=A(new B,C());b=0;for(h=f.length|0;b<h;)E(a,f[b]),b=1+b|0;K(c,"rhs.!\x3d(null)",d,a.t)}throw(new p).e(g);}null!==c?(g=!0,h=F()):(G(),g=(new r).d(["pats is equal to null"]),h=G().b,h=H(g,h),g=!1);g?cj(c)?g=(new q).a(!0,F()):(G(),g=(new r).d(["pats.nonEmpty is false"]),h=G().b,g=(new q).a(!1,H(g,h))):g=(new q).a(!1,h);if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=J();
c=[(new q).a("pats",c)];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"pats.!\x3d(null).\x26\x26(pats.nonEmpty)",f,a.t)}throw(new p).e(g);}a:{for(g=c;!g.g();){var h=g.n(),n=v();if(y(z(n,h),wG())){g=!1;break a}g=g.o()}g=!0}g?g=(new q).a(!0,F()):(G(),g=(new r).d(["pats.forall(((x$7: scala.meta.Pat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](x$7)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Term.Name](Term.this.Name.ClassifierClass[scala.meta.Pat]).`unary_!`)) is false"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=J();c=[(new q).a("pats",c),(new q).a("Term",mz())];a=A(new B,C());b=0;for(h=c.length|0;b<h;)E(a,c[b]),b=1+b|0;K(d,"pats.forall(((x$7: scala.meta.Pat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](x$7)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Term.Name](Term.this.Name.ClassifierClass[scala.meta.Pat]).`unary_!`))",f,a.t)}throw(new p).e(g);}g=nqa(null,null,null);h=function(a,
b){return function(a){return a.y(a,b,"mods",a.s)}}(a,g);n=G().b;if(n===G().b)if(b===F())b=F();else{var n=b.n(),u=n=U(new V,h(n),F());for(b=b.o();b!==F();){var w=b.n(),w=U(new V,h(w),F()),u=u.ga=w;b=b.o()}b=n}else{for(n=zg(b,n);!b.g();)u=b.n(),n.ba(h(u)),b=b.o();b=n.da()}g.gb=b;a=function(a,b){return function(a){return a.y(a,b,"pats",a.s)}}(a,g);b=G().b;if(b===G().b)if(c===F())c=F();else{b=c.n();h=b=U(new V,a(b),F());for(c=c.o();c!==F();)n=c.n(),n=U(new V,a(n),F()),h=h.ga=n,c=c.o();c=b}else{for(b=
zg(c,b);!c.g();)h=c.n(),b.ba(a(h)),c=c.o();c=b.da()}g.Gf=c;d.g()?d=S():(d=d.q(),d=(new T).e(d.y(d,g,"decltpe",d.s)));g.Lc=d;g.Kb=f.y(f,g,"rhs",f.s);return g}Fv.prototype.$classData=l({OL:0},!1,"scala.meta.Defn$Val$",{OL:1,f:1,l:1,k:1});var Ev=void 0;function Dv(){}Dv.prototype=new m;Dv.prototype.constructor=Dv;Dv.prototype.c=function(){return this};
function Qda(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var h=(new r).d(["mods is equal to null"]),n=G().b,g=(new q).a(!1,H(h,n))}if(null===g||!0!==I(g)){if(null!==g){var u=g.p();if(!1===I(g)){for(var w=J(),D=[(new q).a("mods",b)],N=A(new B,C()),Q=0,ea=D.length|0;Q<ea;)E(N,D[Q]),Q=1+Q|0;K(w,"mods.!\x3d(null)",u,N.t)}}throw(new p).e(g);}if(null!==c)var ba=(new q).a(!0,F());else{G();var ma=(new r).d(["pats is equal to null"]),La=G().b,ba=(new q).a(!1,H(ma,La))}if(null===ba||!0!==I(ba)){if(null!==
ba){var Pa=ba.p();if(!1===I(ba)){for(var Qa=J(),Ka=[(new q).a("pats",c)],Ba=A(new B,C()),va=0,za=Ka.length|0;va<za;)E(Ba,Ka[va]),va=1+va|0;K(Qa,"pats.!\x3d(null)",Pa,Ba.t)}}throw(new p).e(ba);}if(null!==d)var qa=(new q).a(!0,F());else{G();var la=(new r).d(["decltpe is equal to null"]),Ma=G().b,qa=(new q).a(!1,H(la,Ma))}if(null===qa||!0!==I(qa)){if(null!==qa){var Ea=qa.p();if(!1===I(qa)){for(var tb=J(),Za=[(new q).a("decltpe",d)],eb=A(new B,C()),kb=0,Pb=Za.length|0;kb<Pb;)E(eb,Za[kb]),kb=1+kb|0;K(tb,
"decltpe.!\x3d(null)",Ea,eb.t)}}throw(new p).e(qa);}if(null!==f)var Na=(new q).a(!0,F());else{G();var sb=(new r).d(["rhs is equal to null"]),yb=G().b,Na=(new q).a(!1,H(sb,yb))}if(null===Na||!0!==I(Na)){if(null!==Na){var sc=Na.p();if(!1===I(Na)){for(var Ra=J(),wc=[(new q).a("rhs",f)],Wb=A(new B,C()),Rb=0,ub=wc.length|0;Rb<ub;)E(Wb,wc[Rb]),Rb=1+Rb|0;K(Ra,"rhs.!\x3d(null)",sc,Wb.t)}}throw(new p).e(Na);}if(null!==c)var fb=!0,Xb=F();else{G();var lb=(new r).d(["pats is equal to null"]),Eb=G().b,xc=H(lb,
Eb),fb=!1,Xb=xc}var gb=Xb;if(fb)if(cj(c))Qb=(new q).a(!0,F());else{G();var dc=(new r).d(["pats.nonEmpty is false"]),Fc=G().b,Qb=(new q).a(!1,H(dc,Fc))}else var Qb=(new q).a(!1,gb);if(null===Qb||!0!==I(Qb)){if(null!==Qb){var Bb=Qb.p();if(!1===I(Qb)){for(var Ib=J(),mb=[(new q).a("pats",c)],Cb=A(new B,C()),Tb=0,mc=mb.length|0;Tb<mc;)E(Cb,mb[Tb]),Tb=1+Tb|0;K(Ib,"pats.!\x3d(null).\x26\x26(pats.nonEmpty)",Bb,Cb.t)}}throw(new p).e(Qb);}a:{for(var Ac=c;!Ac.g();){var Dc=Ac.n(),Db=v();if(y(z(Db,Dc),wG())){var Va=
!1;break a}Ac=Ac.o()}Va=!0}if(Va)var ec=(new q).a(!0,F());else{G();var $a=(new r).d(["pats.forall(((x$8: scala.meta.Pat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](x$8)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Term.Name](Term.this.Name.ClassifierClass[scala.meta.Pat]).`unary_!`)) is false"]),vb=G().b,ec=(new q).a(!1,H($a,vb))}if(null===ec||!0!==I(ec)){if(null!==ec){var fc=ec.p();if(!1===I(ec)){for(var Bc=J(),Ub=[(new q).a("pats",c),(new q).a("Term",mz())],
Vb=A(new B,C()),wb=0,xb=Ub.length|0;wb<xb;)E(Vb,Ub[wb]),wb=1+wb|0;K(Bc,"pats.forall(((x$8: scala.meta.Pat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](x$8)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Term.Name](Term.this.Name.ClassifierClass[scala.meta.Pat]).`unary_!`))",fc,Vb.t)}}throw(new p).e(ec);}if(d.g()){G();var Xa=(new r).d(["decltpe.nonEmpty is false"]),tc=G().b,ib=H(Xa,tc),zb=!1,nb=ib}else var zb=!0,nb=F();var Jb=nb;if(zb)var jb=(new q).a(!0,F());else{if(f.g()){G();
var ob=(new r).d(["rhs.nonEmpty is false"]),gc=G().b,cb=H(ob,gc),Ua=!1,Yb=cb}else var Ua=!0,Yb=F();var Kb=Yb;if(Ua)jb=(new q).a(!0,F());else var pb=G(),jb=(new q).a(!1,Jb.ma(Kb,pb.b))}if(null===jb||!0!==I(jb)){if(null!==jb){var hb=jb.p();if(!1===I(jb)){for(var Lb=J(),Fa=[(new q).a("decltpe",d),(new q).a("rhs",f)],bb=A(new B,C()),nc=0,db=Fa.length|0;nc<db;)E(bb,Fa[nc]),nc=1+nc|0;K(Lb,"decltpe.nonEmpty.||(rhs.nonEmpty)",hb,bb.t)}}throw(new p).e(jb);}var uc=f.g(),Fb=(new ur).qj(uc);a:{for(var hc=c;!hc.g();){var $b=
hc.n(),kc=v();if(!y(z(kc,$b),Bv())){var lc=!1;break a}hc=hc.o()}lc=!0}if(!Fb.gw||lc)var Mb=(new q).a(!0,F());else{G();var Nb=(new r).d(["org.scalameta.invariants.`package`.XtensionImplication(rhs.isEmpty).\x3d\x3d\x3e(pats.forall(((x$9: scala.meta.Pat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](x$9)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Var](Pat.this.Var.ClassifierClass[scala.meta.Pat])))) is false"]),Gb=G().b,Mb=(new q).a(!1,H(Nb,Gb))}if(null===
Mb||!0!==I(Mb)){if(null!==Mb){var Sb=Mb.p();if(!1===I(Mb)){for(var Cc=J(),Ob=[(new q).a("rhs",f),(new q).a("pats",c),(new q).a("Pat",VW())],Zb=A(new B,C()),Ec=0,oc=Ob.length|0;Ec<oc;)E(Zb,Ob[Ec]),Ec=1+Ec|0;K(Cc,"org.scalameta.invariants.`package`.XtensionImplication(rhs.isEmpty).\x3d\x3d\x3e(pats.forall(((x$9: scala.meta.Pat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](x$9)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Var](Pat.this.Var.ClassifierClass[scala.meta.Pat]))))",
Sb,Zb.t)}}throw(new p).e(Mb);}var pc=oqa(null,null,null),qc=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,pc),Jc=G().b;if(Jc===G().b)if(b===F())var Hc=F();else{for(var ac=b.n(),Lc=U(new V,qc(ac),F()),$c=Lc,Tc=b.o();Tc!==F();)var Rc=Tc.n(),Mc=U(new V,qc(Rc),F()),$c=$c.ga=Mc,Tc=Tc.o();Hc=Lc}else{for(var hd=zg(b,Jc),Qc=b;!Qc.g();){var rd=Qc.n();hd.ba(qc(rd));Qc=Qc.o()}Hc=hd.da()}pc.gb=Hc;var od=function(a,b){return function(a){return a.y(a,b,"pats",a.s)}}(a,pc),Zc=G().b;if(Zc===G().b)if(c===
F())var nd=F();else{for(var zd=c.n(),ud=U(new V,od(zd),F()),wd=ud,Bd=c.o();Bd!==F();)var Ed=Bd.n(),pd=U(new V,od(Ed),F()),wd=wd.ga=pd,Bd=Bd.o();nd=ud}else{for(var vd=zg(c,Zc),xd=c;!xd.g();){var ee=xd.n();vd.ba(od(ee));xd=xd.o()}nd=vd.da()}pc.Gf=nd;if(d.g())var Ld=S();else var me=d.q(),Ld=(new T).e(me.y(me,pc,"decltpe",me.s));pc.Lc=Ld;if(f.g())var fe=S();else var Yd=f.q(),fe=(new T).e(Yd.y(Yd,pc,"rhs",Yd.s));pc.Kb=fe;return pc}
Dv.prototype.$classData=l({SL:0},!1,"scala.meta.Defn$Var$",{SL:1,f:1,l:1,k:1});var Cv=void 0;function WW(){}WW.prototype=new m;WW.prototype.constructor=WW;WW.prototype.c=function(){return this};WW.prototype.$classData=l({XL:0},!1,"scala.meta.Enumerator$",{XL:1,f:1,l:1,k:1});var pqa=void 0;function qqa(){pqa||(pqa=(new WW).c());return pqa}function gD(){}gD.prototype=new m;gD.prototype.constructor=gD;gD.prototype.c=function(){return this};
gD.prototype.$classData=l({ZL:0},!1,"scala.meta.Enumerator$Generator$",{ZL:1,f:1,l:1,k:1});var Iga=void 0;function LA(){}LA.prototype=new m;LA.prototype.constructor=LA;LA.prototype.c=function(){return this};
function Rfa(a){if(null!==a)var b=(new q).a(!0,F());else{G();var b=(new r).d(["cond is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("cond",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"cond.!\x3d(null)",c,f.t)}throw(new p).e(b);}b=rqa(null,null,null);b.uh=a.y(a,b,"cond",a.s);return b}LA.prototype.$classData=l({cM:0},!1,"scala.meta.Enumerator$Guard$",{cM:1,f:1,l:1,k:1});var KA=void 0;
function XW(){}XW.prototype=new m;XW.prototype.constructor=XW;XW.prototype.c=function(){return this};function bD(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=sqa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
XW.prototype.$classData=l({fM:0},!1,"scala.meta.Enumerator$Quasi$",{fM:1,f:1,l:1,k:1});var tqa=void 0;function cD(){tqa||(tqa=(new XW).c());return tqa}function fD(){}fD.prototype=new m;fD.prototype.constructor=fD;fD.prototype.c=function(){return this};fD.prototype.$classData=l({jM:0},!1,"scala.meta.Enumerator$Val$",{jM:1,f:1,l:1,k:1});var Gga=void 0;function Vt(){}Vt.prototype=new m;Vt.prototype.constructor=Vt;Vt.prototype.c=function(){return this};
function Dda(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["importers is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("importers",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"importers.!\x3d(null)",a,f.t)}throw(new p).e(c);}null!==b?(c=!0,d=F()):(G(),c=(new r).d(["importers is equal to null"]),d=G().b,d=H(c,d),c=!1);c?cj(b)?c=(new q).a(!0,F()):(G(),c=(new r).d(["importers.nonEmpty is false"]),
d=G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("importers",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"importers.!\x3d(null).\x26\x26(importers.nonEmpty)",a,f.t)}throw(new p).e(c);}c=uqa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"importers",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());for(b=b.o();b!==F();)g=b.n(),g=U(new V,a(g),F()),
f=f.ga=g,b=b.o();b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.$o=b;return c}Vt.prototype.$classData=l({nM:0},!1,"scala.meta.Import$",{nM:1,f:1,l:1,k:1});var Ut=void 0;function YW(){}YW.prototype=new m;YW.prototype.constructor=YW;YW.prototype.c=function(){return this};
function Bda(a){if(null!==a)var b=(new q).a(!0,F());else{G();var b=(new r).d(["name is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("name",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"name.!\x3d(null)",c,f.t)}throw(new p).e(b);}b=v();y(z(b,a),fB())?(c=!0,b=F()):(G(),b=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]) is false"]),
c=G().b,b=H(b,c),c=!1);c?b=(new q).a(!0,F()):(c=v(),y(z(c,a),iD())?(c=!0,d=F()):(G(),c=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]) is false"]),d=G().b,d=H(c,d),c=!1),c?b=(new q).a(!0,F()):(c=G(),b=(new q).a(!1,b.ma(d,c.b))));if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){d=J();a=[(new q).a("name",a),(new q).a("Name",
jD())];f=A(new B,C());g=0;for(h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Quasi](Name.this.Quasi.ClassifierClass[scala.meta.Name]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Indeterminate](Name.this.Indeterminate.ClassifierClass[scala.meta.Name]))",c,f.t)}throw(new p).e(b);
}b=vqa(null,null,null);b.Pa=a.y(a,b,"name",a.s);return b}YW.prototype.$classData=l({qM:0},!1,"scala.meta.Importee$Name$",{qM:1,f:1,l:1,k:1});var wqa=void 0;function bu(){wqa||(wqa=(new YW).c())}function ZW(){}ZW.prototype=new m;ZW.prototype.constructor=ZW;ZW.prototype.c=function(){return this};
function mD(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=xqa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}ZW.prototype.$classData=l({sM:0},!1,"scala.meta.Importee$Quasi$",{sM:1,f:1,l:1,k:1});var yqa=void 0;
function nD(){yqa||(yqa=(new ZW).c());return yqa}function hD(){}hD.prototype=new m;hD.prototype.constructor=hD;hD.prototype.c=function(){return this};hD.prototype.$classData=l({vM:0},!1,"scala.meta.Importee$Rename$",{vM:1,f:1,l:1,k:1});var Lga=void 0;function kD(){}kD.prototype=new m;kD.prototype.constructor=kD;kD.prototype.c=function(){return this};kD.prototype.$classData=l({yM:0},!1,"scala.meta.Importee$Unimport$",{yM:1,f:1,l:1,k:1});var Nga=void 0;function VB(){}VB.prototype=new m;
VB.prototype.constructor=VB;VB.prototype.c=function(){return this};VB.prototype.$classData=l({BM:0},!1,"scala.meta.Importee$Wildcard$",{BM:1,f:1,l:1,k:1});var gga=void 0;function $W(){}$W.prototype=new m;$W.prototype.constructor=$W;$W.prototype.c=function(){return this};
function Cda(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["ref is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("ref",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"ref.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["importees is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("importees",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"importees.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["importees is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["importees.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("importees",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,
c[g]),g=1+g|0;K(a,"importees.!\x3d(null).\x26\x26(importees.nonEmpty)",b,f.t)}throw(new p).e(d);}$t(au(b))?d=(new q).a(!0,F()):(G(),d=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesTermRef(ref).isStableId is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("ref",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"scala.meta.internal.trees.`package`.XtensionTreesTermRef(ref).isStableId",c,f.t)}throw(new p).e(d);
}d=zqa(null,null,null);d.Ah=b.y(b,d,"ref",b.s);b=function(a,b){return function(a){return a.y(a,b,"importees",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.Zo=c;return d}$W.prototype.$classData=l({DM:0},!1,"scala.meta.Importer$",{DM:1,f:1,l:1,k:1});var Aqa=void 0;function Ada(){Aqa||(Aqa=(new $W).c());return Aqa}
function aX(){}aX.prototype=new m;aX.prototype.constructor=aX;aX.prototype.c=function(){return this};function fu(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Bqa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
aX.prototype.$classData=l({FM:0},!1,"scala.meta.Importer$Quasi$",{FM:1,f:1,l:1,k:1});var Cqa=void 0;function gu(){Cqa||(Cqa=(new aX).c());return Cqa}function bX(){}bX.prototype=new m;bX.prototype.constructor=bX;bX.prototype.c=function(){return this};
function yu(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["tpe is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();b=[(new q).a("tpe",b)];a=A(new B,C());for(var g=0,h=b.length|0;g<h;)E(a,b[g]),g=1+g|0;K(c,"tpe.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["name is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){b=
J();c=[(new q).a("name",c)];a=A(new B,C());g=0;for(h=c.length|0;g<h;)E(a,c[g]),g=1+g|0;K(b,"name.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["argss is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(b=f.p(),!1===I(f))){c=J();d=[(new q).a("argss",d)];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(c,"argss.!\x3d(null)",b,a.t)}throw(new p).e(f);}dja(eja(b))?f=(new q).a(!0,F()):(G(),f=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesType(tpe).isConstructable is false"]),
g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();b=[(new q).a("tpe",b)];a=A(new B,C());g=0;for(h=b.length|0;g<h;)E(a,b[g]),g=1+g|0;K(c,"scala.meta.internal.trees.`package`.XtensionTreesType(tpe).isConstructable",d,a.t)}throw(new p).e(f);}f=Dqa(null,null,null);f.qc=b.y(b,f,"tpe",b.s);f.Pa=c.y(c,f,"name",c.s);b=function(a,b){return function(c){var d=function(a,b){return function(a){return a.y(a,b,"argss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();
var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,f);c=G().b;if(c===G().b)if(d===F())d=F();else{c=d.n();a=c=U(new V,b(c),F());for(d=d.o();d!==F();)g=d.n(),g=U(new V,b(g),F()),a=a.ga=g,d=d.o();d=c}else{for(c=zg(d,c);!d.g();)a=d.n(),c.ba(b(a)),d=d.o();d=c.da()}f.To=d;return f}bX.prototype.$classData=l({HM:0},!1,"scala.meta.Init$",{HM:1,f:1,l:1,k:1});var Eqa=void 0;
function xu(){Eqa||(Eqa=(new bX).c());return Eqa}function cX(){}cX.prototype=new m;cX.prototype.constructor=cX;cX.prototype.c=function(){return this};
function eA(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Fqa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}cX.prototype.$classData=l({JM:0},!1,"scala.meta.Init$Quasi$",{JM:1,f:1,l:1,k:1});var Gqa=void 0;
function fA(){Gqa||(Gqa=(new cX).c());return Gqa}function dX(){}dX.prototype=new m;dX.prototype.constructor=dX;dX.prototype.c=function(){return this};function wda(a){Hqa||(Hqa=(new dX).c());return Iqa(null,null,null,a)}dX.prototype.$classData=l({MM:0},!1,"scala.meta.Lit$Boolean$",{MM:1,f:1,l:1,k:1});var Hqa=void 0;function zt(){}zt.prototype=new m;zt.prototype.constructor=zt;zt.prototype.c=function(){return this};zt.prototype.$classData=l({QM:0},!1,"scala.meta.Lit$Char$",{QM:1,f:1,l:1,k:1});
var sda=void 0;function vt(){}vt.prototype=new m;vt.prototype.constructor=vt;vt.prototype.c=function(){return this};vt.prototype.$classData=l({TM:0},!1,"scala.meta.Lit$Double$",{TM:1,f:1,l:1,k:1});var qda=void 0;function pt(){}pt.prototype=new m;pt.prototype.constructor=pt;pt.prototype.c=function(){return this};pt.prototype.$classData=l({WM:0},!1,"scala.meta.Lit$Float$",{WM:1,f:1,l:1,k:1});var oda=void 0;function ct(){}ct.prototype=new m;ct.prototype.constructor=ct;ct.prototype.c=function(){return this};
ct.prototype.$classData=l({YM:0},!1,"scala.meta.Lit$Int$",{YM:1,f:1,l:1,k:1});var kda=void 0;function ht(){}ht.prototype=new m;ht.prototype.constructor=ht;ht.prototype.c=function(){return this};ht.prototype.$classData=l({aN:0},!1,"scala.meta.Lit$Long$",{aN:1,f:1,l:1,k:1});var mda=void 0;function Mt(){}Mt.prototype=new m;Mt.prototype.constructor=Mt;Mt.prototype.c=function(){return this};Mt.prototype.$classData=l({cN:0},!1,"scala.meta.Lit$Null$",{cN:1,f:1,l:1,k:1});var xda=void 0;function eX(){}
eX.prototype=new m;eX.prototype.constructor=eX;eX.prototype.c=function(){return this};function Dt(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["value is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("value",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"value.!\x3d(null)",c,f.t)}throw(new p).e(a);}return Jqa(null,null,null,b)}
eX.prototype.$classData=l({fN:0},!1,"scala.meta.Lit$String$",{fN:1,f:1,l:1,k:1});var Kqa=void 0;function Et(){Kqa||(Kqa=(new eX).c());return Kqa}function It(){}It.prototype=new m;It.prototype.constructor=It;It.prototype.c=function(){return this};It.prototype.$classData=l({iN:0},!1,"scala.meta.Lit$Symbol$",{iN:1,f:1,l:1,k:1});var uda=void 0;function fX(){}fX.prototype=new m;fX.prototype.constructor=fX;fX.prototype.c=function(){return this};
function Py(){Lqa||(Lqa=(new fX).c());return Mqa(null,null,null)}fX.prototype.$classData=l({lN:0},!1,"scala.meta.Lit$Unit$",{lN:1,f:1,l:1,k:1});var Lqa=void 0;function gX(){}gX.prototype=new m;gX.prototype.constructor=gX;gX.prototype.c=function(){return this};gX.prototype.$classData=l({pN:0},!1,"scala.meta.Mod$",{pN:1,f:1,l:1,k:1});var Nqa=void 0;function Oqa(){Nqa||(Nqa=(new gX).c());return Nqa}function hX(){}hX.prototype=new m;hX.prototype.constructor=hX;hX.prototype.c=function(){return this};
function Dw(){return Pqa(null,null,null)}hX.prototype.$classData=l({qN:0},!1,"scala.meta.Mod$Abstract$",{qN:1,f:1,l:1,k:1});var Qqa=void 0;function Ew(){Qqa||(Qqa=(new hX).c());return Qqa}function pu(){}pu.prototype=new m;pu.prototype.constructor=pu;pu.prototype.c=function(){return this};pu.prototype.$classData=l({tN:0},!1,"scala.meta.Mod$Annot$",{tN:1,f:1,l:1,k:1});var Fda=void 0;function iX(){}iX.prototype=new m;iX.prototype.constructor=iX;iX.prototype.c=function(){return this};
function mu(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Rqa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}iX.prototype.$classData=l({vN:0},!1,"scala.meta.Mod$Annot$Quasi$",{vN:1,f:1,l:1,k:1});var Sqa=void 0;
function nu(){Sqa||(Sqa=(new iX).c());return Sqa}function jX(){}jX.prototype=new m;jX.prototype.constructor=jX;jX.prototype.c=function(){return this};function hea(){Tqa||(Tqa=(new jX).c());return Uqa(null,null,null)}jX.prototype.$classData=l({yN:0},!1,"scala.meta.Mod$Case$",{yN:1,f:1,l:1,k:1});var Tqa=void 0;function ID(){}ID.prototype=new m;ID.prototype.constructor=ID;ID.prototype.c=function(){return this};ID.prototype.$classData=l({CN:0},!1,"scala.meta.Mod$Contravariant$",{CN:1,f:1,l:1,k:1});
var Uga=void 0;function HD(){}HD.prototype=new m;HD.prototype.constructor=HD;HD.prototype.c=function(){return this};HD.prototype.$classData=l({GN:0},!1,"scala.meta.Mod$Covariant$",{GN:1,f:1,l:1,k:1});var Sga=void 0;function kX(){}kX.prototype=new m;kX.prototype.constructor=kX;kX.prototype.c=function(){return this};function ry(){Vqa||(Vqa=(new kX).c());return Wqa(null,null,null)}kX.prototype.$classData=l({JN:0},!1,"scala.meta.Mod$Final$",{JN:1,f:1,l:1,k:1});var Vqa=void 0;function lX(){}
lX.prototype=new m;lX.prototype.constructor=lX;lX.prototype.c=function(){return this};function Qu(){Xqa||(Xqa=(new lX).c());return Yqa(null,null,null)}lX.prototype.$classData=l({MN:0},!1,"scala.meta.Mod$Implicit$",{MN:1,f:1,l:1,k:1});var Xqa=void 0;function zy(){}zy.prototype=new m;zy.prototype.constructor=zy;zy.prototype.c=function(){return this};zy.prototype.$classData=l({QN:0},!1,"scala.meta.Mod$Inline$",{QN:1,f:1,l:1,k:1});var Pea=void 0;function xy(){}xy.prototype=new m;
xy.prototype.constructor=xy;xy.prototype.c=function(){return this};xy.prototype.$classData=l({SN:0},!1,"scala.meta.Mod$Lazy$",{SN:1,f:1,l:1,k:1});var Mea=void 0;function mX(){}mX.prototype=new m;mX.prototype.constructor=mX;mX.prototype.c=function(){return this};function Oea(){Zqa||(Zqa=(new mX).c());return $qa(null,null,null)}mX.prototype.$classData=l({VN:0},!1,"scala.meta.Mod$Override$",{VN:1,f:1,l:1,k:1});var Zqa=void 0;function nX(){}nX.prototype=new m;nX.prototype.constructor=nX;
nX.prototype.c=function(){return this};
function xA(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["within is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("within",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"within.!\x3d(null)",c,f.t)}throw(new p).e(a);}Xia(Wia(b))?a=(new q).a(!0,F()):(G(),a=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesRef(within).isWithin is false"]),c=G().b,a=(new q).a(!1,H(a,
c)));if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("within",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"scala.meta.internal.trees.`package`.XtensionTreesRef(within).isWithin",c,f.t)}throw(new p).e(a);}a=ara(null,null,null);a.Sj=b.y(b,a,"within",b.s);return a}nX.prototype.$classData=l({YN:0},!1,"scala.meta.Mod$Private$",{YN:1,f:1,l:1,k:1});var bra=void 0;function yA(){bra||(bra=(new nX).c());return bra}function oX(){}oX.prototype=new m;
oX.prototype.constructor=oX;oX.prototype.c=function(){return this};
function zA(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["within is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("within",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"within.!\x3d(null)",c,f.t)}throw(new p).e(a);}Xia(Wia(b))?a=(new q).a(!0,F()):(G(),a=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesRef(within).isWithin is false"]),c=G().b,a=(new q).a(!1,H(a,
c)));if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("within",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"scala.meta.internal.trees.`package`.XtensionTreesRef(within).isWithin",c,f.t)}throw(new p).e(a);}a=cra(null,null,null);a.Sj=b.y(b,a,"within",b.s);return a}oX.prototype.$classData=l({aO:0},!1,"scala.meta.Mod$Protected$",{aO:1,f:1,l:1,k:1});var dra=void 0;function AA(){dra||(dra=(new oX).c());return dra}function pX(){}pX.prototype=new m;
pX.prototype.constructor=pX;pX.prototype.c=function(){return this};function uw(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=era(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
pX.prototype.$classData=l({dO:0},!1,"scala.meta.Mod$Quasi$",{dO:1,f:1,l:1,k:1});var fra=void 0;function vw(){fra||(fra=(new pX).c());return fra}function uy(){}uy.prototype=new m;uy.prototype.constructor=uy;uy.prototype.c=function(){return this};uy.prototype.$classData=l({gO:0},!1,"scala.meta.Mod$Sealed$",{gO:1,f:1,l:1,k:1});var ty=void 0;function aB(){}aB.prototype=new m;aB.prototype.constructor=aB;aB.prototype.c=function(){return this};
aB.prototype.$classData=l({jO:0},!1,"scala.meta.Mod$ValParam$",{jO:1,f:1,l:1,k:1});var Zfa=void 0;function bB(){}bB.prototype=new m;bB.prototype.constructor=bB;bB.prototype.c=function(){return this};bB.prototype.$classData=l({lO:0},!1,"scala.meta.Mod$VarParam$",{lO:1,f:1,l:1,k:1});var aga=void 0;function qX(){}qX.prototype=new m;qX.prototype.constructor=qX;qX.prototype.c=function(){return this};qX.prototype.$classData=l({nO:0},!1,"scala.meta.Name$",{nO:1,f:1,l:1,k:1});var gra=void 0;
function jD(){gra||(gra=(new qX).c());return gra}function rX(){}rX.prototype=new m;rX.prototype.constructor=rX;rX.prototype.c=function(){return this};function tu(){hra||(hra=(new rX).c());return ira(null,null,null)}rX.prototype.$classData=l({pO:0},!1,"scala.meta.Name$Anonymous$",{pO:1,f:1,l:1,k:1});var hra=void 0;function sX(){}sX.prototype=new m;sX.prototype.constructor=sX;sX.prototype.c=function(){return this};
function du(a){if(null!==a)var b=(new q).a(!0,F());else{G();var b=(new r).d(["value is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("value",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"value.!\x3d(null)",c,f.t)}throw(new p).e(b);}null!==a?(b=!0,c=F()):(G(),b=(new r).d(["value is equal to null"]),c=G().b,c=H(b,c),b=!1);b?(b=(new cd).j(a),cj(b)?b=(new q).a(!0,F()):(G(),b=(new r).d(["scala.Predef.augmentString(value).nonEmpty is false"]),
c=G().b,b=(new q).a(!1,H(b,c)))):b=(new q).a(!1,c);if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){d=J();a=[(new q).a("value",a)];f=A(new B,C());g=0;for(h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"value.!\x3d(null).\x26\x26(scala.Predef.augmentString(value).nonEmpty)",c,f.t)}throw(new p).e(b);}return jra(null,null,null,a)}sX.prototype.$classData=l({tO:0},!1,"scala.meta.Name$Indeterminate$",{tO:1,f:1,l:1,k:1});var kra=void 0;function cu(){kra||(kra=(new sX).c())}function tX(){}
tX.prototype=new m;tX.prototype.constructor=tX;tX.prototype.c=function(){return this};function uX(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=lra(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
tX.prototype.$classData=l({wO:0},!1,"scala.meta.Name$Quasi$",{wO:1,f:1,l:1,k:1});var mra=void 0;function vX(){mra||(mra=(new tX).c());return mra}function wX(){}wX.prototype=new m;wX.prototype.constructor=wX;wX.prototype.c=function(){return this};wX.prototype.$classData=l({zO:0},!1,"scala.meta.Pat$",{zO:1,f:1,l:1,k:1});var nra=void 0;function VW(){nra||(nra=(new wX).c());return nra}function sF(){}sF.prototype=new m;sF.prototype.constructor=sF;sF.prototype.c=function(){return this};
sF.prototype.$classData=l({BO:0},!1,"scala.meta.Pat$Alternative$",{BO:1,f:1,l:1,k:1});var yha=void 0;function xX(){}xX.prototype=new m;xX.prototype.constructor=xX;xX.prototype.c=function(){return this};
function rF(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["lhs is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("lhs",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"lhs.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["rhs is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=
[(new q).a("rhs",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"rhs.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=v();y(z(a,b),Bv())?(d=!0,a=F()):(G(),a=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Var](Pat.this.Var.ClassifierClass[scala.meta.Pat]) is false"]),d=G().b,a=H(a,d),d=!1);d?a=(new q).a(!0,F()):(d=v(),y(z(d,b),JS())?(d=!0,f=F()):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Quasi](Pat.this.Quasi.ClassifierClass[scala.meta.Pat]) is false"]),
f=G().b,f=H(d,f),d=!1),d?a=(new q).a(!0,F()):(d=G(),a=(new q).a(!1,a.ma(f,d.b))));if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("lhs",b),(new q).a("Pat",VW())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Var](Pat.this.Var.ClassifierClass[scala.meta.Pat]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Quasi](Pat.this.Quasi.ClassifierClass[scala.meta.Pat]))",
c,f.t)}throw(new p).e(a);}a=ora(null,null,null);a.pc=b.y(b,a,"lhs",b.s);a.Kb=c.y(c,a,"rhs",c.s);return a}xX.prototype.$classData=l({EO:0},!1,"scala.meta.Pat$Bind$",{EO:1,f:1,l:1,k:1});var pra=void 0;function qF(){pra||(pra=(new xX).c());return pra}function yX(){}yX.prototype=new m;yX.prototype.constructor=yX;yX.prototype.c=function(){return this};
function rha(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["fun is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("fun",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"fun.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["args is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("args",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"args.!\x3d(null)",b,f.t)}throw(new p).e(d);}aja($ia(b))?d=(new q).a(!0,F()):(G(),d=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesTerm(fun).isExtractor is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("fun",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"scala.meta.internal.trees.`package`.XtensionTreesTerm(fun).isExtractor",
c,f.t)}throw(new p).e(d);}d=qra(null,null,null);d.vh=b.y(b,d,"fun",b.s);b=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.fc=c;return d}yX.prototype.$classData=l({IO:0},!1,"scala.meta.Pat$Extract$",{IO:1,f:1,l:1,k:1});var rra=void 0;
function qha(){rra||(rra=(new yX).c());return rra}function GT(){}GT.prototype=new m;GT.prototype.constructor=GT;GT.prototype.c=function(){return this};
function Tla(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["lhs is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();b=[(new q).a("lhs",b)];a=A(new B,C());for(var g=0,h=b.length|0;g<h;)E(a,b[g]),g=1+g|0;K(c,"lhs.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["op is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){b=
J();c=[(new q).a("op",c)];a=A(new B,C());g=0;for(h=c.length|0;g<h;)E(a,c[g]),g=1+g|0;K(b,"op.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["rhs is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(b=f.p(),!1===I(f))){c=J();d=[(new q).a("rhs",d)];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(c,"rhs.!\x3d(null)",b,a.t)}throw(new p).e(f);}f=sra(null,null,null);f.pc=b.y(b,f,"lhs",b.s);f.Ef=c.y(c,f,"op",c.s);b=
function(a,b){return function(a){return a.y(a,b,"rhs",a.s)}}(a,f);c=G().b;if(c===G().b)if(d===F())d=F();else{c=d.n();a=c=U(new V,b(c),F());for(d=d.o();d!==F();)g=d.n(),g=U(new V,b(g),F()),a=a.ga=g,d=d.o();d=c}else{for(c=zg(d,c);!d.g();)a=d.n(),c.ba(b(a)),d=d.o();d=c.da()}f.Kb=d;return f}GT.prototype.$classData=l({MO:0},!1,"scala.meta.Pat$ExtractInfix$",{MO:1,f:1,l:1,k:1});var Sla=void 0;function ZA(){}ZA.prototype=new m;ZA.prototype.constructor=ZA;ZA.prototype.c=function(){return this};
function Yfa(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["prefix is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=J();c=[(new q).a("prefix",b)];b=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"prefix.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["parts is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===
I(f))){a=J();c=[(new q).a("parts",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"parts.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["args is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){c=J();d=[(new q).a("args",d)];b=A(new B,C());g=0;for(h=d.length|0;g<h;)E(b,d[g]),g=1+g|0;K(c,"args.!\x3d(null)",a,b.t)}throw(new p).e(f);}null!==c?(f=!0,g=F()):(G(),f=(new r).d(["parts is equal to null"]),
g=G().b,g=H(f,g),f=!1);f?cj(c)?f=(new q).a(!0,F()):(G(),f=(new r).d(["parts.nonEmpty is false"]),g=G().b,f=(new q).a(!1,H(f,g))):f=(new q).a(!1,g);if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=J();c=[(new q).a("parts",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"parts.!\x3d(null).\x26\x26(parts.nonEmpty)",d,b.t)}throw(new p).e(f);}Cg(c)===(1+Cg(d)|0)?f=(new q).a(!0,F()):(G(),f=(new r).d(["parts.length is not equal to args.length.+(1)"]),g=G().b,f=(new q).a(!1,
H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();d=[(new q).a("parts",c),(new q).a("args",d)];c=A(new B,C());g=0;for(h=d.length|0;g<h;)E(c,d[g]),g=1+g|0;K(b,"parts.length.\x3d\x3d(args.length.+(1))",a,c.t)}throw(new p).e(f);}f=tra(null,null,null);f.Pj=b.y(b,f,"prefix",b.s);b=function(a,b){return function(a){return a.y(a,b,"parts",a.s)}}(a,f);g=G().b;if(g===G().b)if(c===F())c=F();else{g=c.n();h=g=U(new V,b(g),F());for(c=c.o();c!==F();){var n=c.n(),n=U(new V,b(n),F()),h=h.ga=
n;c=c.o()}c=g}else{for(g=zg(c,g);!c.g();)h=c.n(),g.ba(b(h)),c=c.o();c=g.da()}f.Ff=c;a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,f);c=G().b;if(c===G().b)if(d===F())d=F();else{c=d.n();b=c=U(new V,a(c),F());for(d=d.o();d!==F();)g=d.n(),g=U(new V,a(g),F()),b=b.ga=g,d=d.o();d=c}else{for(c=zg(d,c);!d.g();)b=d.n(),c.ba(a(b)),d=d.o();d=c.da()}f.fc=d;return f}ZA.prototype.$classData=l({QO:0},!1,"scala.meta.Pat$Interpolate$",{QO:1,f:1,l:1,k:1});var YA=void 0;function zX(){}
zX.prototype=new m;zX.prototype.constructor=zX;zX.prototype.c=function(){return this};function uv(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=ura(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
zX.prototype.$classData=l({TO:0},!1,"scala.meta.Pat$Quasi$",{TO:1,f:1,l:1,k:1});var vra=void 0;function vv(){vra||(vra=(new zX).c());return vra}function AX(){}AX.prototype=new m;AX.prototype.constructor=AX;AX.prototype.c=function(){return this};function pF(){wra||(wra=(new AX).c());return xra(null,null,null)}AX.prototype.$classData=l({XO:0},!1,"scala.meta.Pat$SeqWildcard$",{XO:1,f:1,l:1,k:1});var wra=void 0;function BX(){}BX.prototype=new m;BX.prototype.constructor=BX;BX.prototype.c=function(){return this};
function tha(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["args is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.!\x3d(null)",a,f.t)}throw(new p).e(c);}null!==b?(c=!0,d=F()):(G(),c=(new r).d(["args is equal to null"]),d=G().b,d=H(c,d),c=!1);c?cj(b)?c=(new q).a(!0,F()):(G(),c=(new r).d(["args.nonEmpty is false"]),d=
G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.!\x3d(null).\x26\x26(args.nonEmpty)",a,f.t)}throw(new p).e(c);}1<Cg(b)?(d=!0,c=F()):(G(),c=(new r).d(["args.length.\x3e(1) is false"]),d=G().b,c=H(c,d),d=!1);d?c=(new q).a(!0,F()):(1===Cg(b)?(d=!0,f=F()):(G(),d=(new r).d(["args.length is not equal to 1"]),f=G().b,f=H(d,f),d=!1),d?(d=v(),f=b.n(),
y(z(d,f),JS())?(f=F(),d=!0):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](args.head)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Quasi](Pat.this.Quasi.ClassifierClass[scala.meta.Pat]) is false"]),f=G().b,f=H(d,f),d=!1)):d=!1,d?c=(new q).a(!0,F()):(d=G(),c=(new q).a(!1,c.ma(f,d.b))));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b),(new q).a("Pat",VW())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+
g|0;K(d,"args.length.\x3e(1).||(args.length.\x3d\x3d(1).\x26\x26(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](args.head)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Quasi](Pat.this.Quasi.ClassifierClass[scala.meta.Pat])))",a,f.t)}throw(new p).e(c);}c=yra(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());for(b=b.o();b!==F();)g=b.n(),g=U(new V,a(g),F()),f=f.ga=
g,b=b.o();b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.fc=b;return c}BX.prototype.$classData=l({$O:0},!1,"scala.meta.Pat$Tuple$",{$O:1,f:1,l:1,k:1});var zra=void 0;function uha(){zra||(zra=(new BX).c());return zra}function CX(){}CX.prototype=new m;CX.prototype.constructor=CX;CX.prototype.c=function(){return this};
function vF(a,b){if(null!==a)var c=(new q).a(!0,F());else{G();var c=(new r).d(["lhs is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(b=c.p(),!1===I(c))){d=J();a=[(new q).a("lhs",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"lhs.!\x3d(null)",b,f.t)}throw(new p).e(c);}null!==b?c=(new q).a(!0,F()):(G(),c=(new r).d(["rhs is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();
b=[(new q).a("rhs",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"rhs.!\x3d(null)",a,f.t)}throw(new p).e(c);}c=v();y(z(c,a),Tha())?(d=!0,c=F()):(G(),c=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Wildcard](Pat.this.Wildcard.ClassifierClass[scala.meta.Pat]) is false"]),d=G().b,c=H(c,d),d=!1);d?c=(new q).a(!0,F()):(d=v(),y(z(d,a),Bv())?(f=!0,d=F()):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Var](Pat.this.Var.ClassifierClass[scala.meta.Pat]) is false"]),
f=G().b,d=H(d,f),f=!1),f?(d=!0,f=F()):(f=v(),y(z(f,a),JS())?(f=!0,g=F()):(G(),f=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Quasi](Pat.this.Quasi.ClassifierClass[scala.meta.Pat]) is false"]),g=G().b,g=H(f,g),f=!1),f?(f=F(),d=!0):(f=G(),f=d.ma(g,f.b),d=!1)),d?c=(new q).a(!0,F()):(d=G(),c=(new q).a(!1,c.ma(f,d.b))));if(null===c||!0!==I(c)){if(null!==c&&(b=c.p(),!1===I(c))){d=J();a=[(new q).a("lhs",a),(new q).a("Pat",
VW())];f=A(new B,C());g=0;for(h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Wildcard](Pat.this.Wildcard.ClassifierClass[scala.meta.Pat]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Var](Pat.this.Var.ClassifierClass[scala.meta.Pat])).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Pat](lhs)(scala.meta.Tree.classifiable[scala.meta.Pat]).is[Pat.Quasi](Pat.this.Quasi.ClassifierClass[scala.meta.Pat]))",
b,f.t)}throw(new p).e(c);}c=v();c=z(c,b);Nla||(Nla=(new mT).c());y(c,Nla)?(G(),c=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Type](rhs)(scala.meta.Tree.classifiable[scala.meta.Type]).is[Type.Var](Type.this.Var.ClassifierClass[scala.meta.Type]).`unary_!` is true"]),d=G().b,d=H(c,d),c=!1):(c=!0,d=F());c?(c=v(),c=z(c,b),Kla||(Kla=(new jT).c()),y(c,Kla)?(G(),c=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Type](rhs)(scala.meta.Tree.classifiable[scala.meta.Type]).is[Type.Placeholder](Type.this.Placeholder.ClassifierClass[scala.meta.Type]).`unary_!` is true"]),
d=G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!0,F())):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("rhs",b),(new q).a("Type",Ara())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Type](rhs)(scala.meta.Tree.classifiable[scala.meta.Type]).is[Type.Var](Type.this.Var.ClassifierClass[scala.meta.Type]).`unary_!`.\x26\x26(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Type](rhs)(scala.meta.Tree.classifiable[scala.meta.Type]).is[Type.Placeholder](Type.this.Placeholder.ClassifierClass[scala.meta.Type]).`unary_!`)",
a,f.t)}throw(new p).e(c);}c=Bra(null,null,null);c.pc=a.y(a,c,"lhs",a.s);c.Kb=b.y(b,c,"rhs",b.s);return c}CX.prototype.$classData=l({cP:0},!1,"scala.meta.Pat$Typed$",{cP:1,f:1,l:1,k:1});var Cra=void 0;function uF(){Cra||(Cra=(new CX).c())}function DX(){}DX.prototype=new m;DX.prototype.constructor=DX;DX.prototype.c=function(){return this};
function wv(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["name is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("name",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"name.!\x3d(null)",c,f.t)}throw(new p).e(a);}a=Dra(null,null,null);a.Pa=b.y(b,a,"name",b.s);return a}DX.prototype.$classData=l({fP:0},!1,"scala.meta.Pat$Var$",{fP:1,f:1,l:1,k:1});var Era=void 0;
function xv(){Era||(Era=(new DX).c());return Era}function EX(){}EX.prototype=new m;EX.prototype.constructor=EX;EX.prototype.c=function(){return this};function sha(){Fra||(Fra=(new EX).c());return Gra(null,null,null)}EX.prototype.$classData=l({jP:0},!1,"scala.meta.Pat$Wildcard$",{jP:1,f:1,l:1,k:1});var Fra=void 0;function sE(){}sE.prototype=new m;sE.prototype.constructor=sE;sE.prototype.c=function(){return this};
function hha(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["parts is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("parts",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"parts.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["args is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){b=
J();c=[(new q).a("args",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(b,"args.!\x3d(null)",a,f.t)}throw(new p).e(d);}null!==b?(d=!0,f=F()):(G(),d=(new r).d(["parts is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(b)?d=(new q).a(!0,F()):(G(),d=(new r).d(["parts.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("parts",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,
"parts.!\x3d(null).\x26\x26(parts.nonEmpty)",c,f.t)}throw(new p).e(d);}Cg(b)===(1+Cg(c)|0)?d=(new q).a(!0,F()):(G(),d=(new r).d(["parts.length is not equal to args.length.+(1)"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){f=J();c=[(new q).a("parts",b),(new q).a("args",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(f,"parts.length.\x3d\x3d(args.length.+(1))",a,b.t)}throw(new p).e(d);}d=Hra(null,null,null);f=function(a,b){return function(a){return a.y(a,
b,"parts",a.s)}}(a,d);g=G().b;if(g===G().b)if(b===F())b=F();else{g=b.n();h=g=U(new V,f(g),F());for(b=b.o();b!==F();){var n=b.n(),n=U(new V,f(n),F()),h=h.ga=n;b=b.o()}b=g}else{for(g=zg(b,g);!b.g();)h=b.n(),g.ba(f(h)),b=b.o();b=g.da()}d.Ff=b;a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,d);b=G().b;if(b===G().b)if(c===F())c=F();else{b=c.n();f=b=U(new V,a(b),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,a(g),F()),f=f.ga=g,c=c.o();c=b}else{for(b=zg(c,b);!c.g();)f=c.n(),b.ba(a(f)),c=c.o();
c=b.da()}d.fc=c;return d}sE.prototype.$classData=l({nP:0},!1,"scala.meta.Pat$Xml$",{nP:1,f:1,l:1,k:1});var rE=void 0;function FX(){}FX.prototype=new m;FX.prototype.constructor=FX;FX.prototype.c=function(){return this};
function gy(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["ref is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("ref",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"ref.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("stats",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"stats.!\x3d(null)",b,f.t)}throw(new p).e(d);}cja(au(b))?d=(new q).a(!0,F()):(G(),d=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesTermRef(ref).isQualId is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("ref",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"scala.meta.internal.trees.`package`.XtensionTreesTermRef(ref).isQualId",
c,f.t)}throw(new p).e(d);}a:{for(d=c;!d.g();){f=d.n();if(!Zia(hv(f))){d=!1;break a}d=d.o()}d=!0}d?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats.forall(((x$12: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$12).isTopLevelStat)) is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("stats",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"stats.forall(((x$12: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$12).isTopLevelStat))",
b,f.t)}throw(new p).e(d);}d=Ira(null,null,null);d.Ah=b.y(b,d,"ref",b.s);b=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.ld=c;return d}FX.prototype.$classData=l({rP:0},!1,"scala.meta.Pkg$",{rP:1,f:1,l:1,k:1});var Jra=void 0;
function cy(){Jra||(Jra=(new FX).c());return Jra}function ay(){}ay.prototype=new m;ay.prototype.constructor=ay;ay.prototype.c=function(){return this};
function Jea(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["mods is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();b=[(new q).a("mods",b)];a=A(new B,C());for(var g=0,h=b.length|0;g<h;)E(a,b[g]),g=1+g|0;K(c,"mods.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["name is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){b=
J();c=[(new q).a("name",c)];a=A(new B,C());g=0;for(h=c.length|0;g<h;)E(a,c[g]),g=1+g|0;K(b,"name.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["templ is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){b=J();d=[(new q).a("templ",d)];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(b,"templ.!\x3d(null)",c,a.t)}throw(new p).e(f);}f=v();y(z(f,d),VS())?(g=!0,f=F()):(G(),f=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Template](templ)(scala.meta.Tree.classifiable[scala.meta.Template]).is[Template.Quasi](Template.this.Quasi.ClassifierClass[scala.meta.Template]) is false"]),
g=G().b,f=H(f,g),g=!1);if(g)f=(new q).a(!0,F());else{a:{for(g=d.ub();!g.g();){var h=g.n(),n=v();if(y(z(n,h),ER())){g=!1;break a}g=g.o()}g=!0}g?(g=!0,h=F()):(G(),g=(new r).d(["templ.stats.forall(((x$13: scala.meta.Stat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Stat](x$13)(scala.meta.Tree.classifiable[scala.meta.Stat]).is[Ctor](scala.meta.Ctor.ClassifierClass[scala.meta.Stat]).`unary_!`)) is false"]),h=G().b,h=H(g,h),g=!1);g?f=(new q).a(!0,F()):(g=G(),f=(new q).a(!1,
f.ma(h,g.b)))}if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){b=J();d=[(new q).a("templ",d),(new q).a("Template",xD())];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(b,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Template](templ)(scala.meta.Tree.classifiable[scala.meta.Template]).is[Template.Quasi](Template.this.Quasi.ClassifierClass[scala.meta.Template]).||(templ.stats.forall(((x$13: scala.meta.Stat) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Stat](x$13)(scala.meta.Tree.classifiable[scala.meta.Stat]).is[Ctor](scala.meta.Ctor.ClassifierClass[scala.meta.Stat]).`unary_!`)))",
c,a.t)}throw(new p).e(f);}f=Kra(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,f);g=G().b;if(g===G().b)if(b===F())b=F();else{g=b.n();h=g=U(new V,a(g),F());for(b=b.o();b!==F();)n=b.n(),n=U(new V,a(n),F()),h=h.ga=n,b=b.o();b=g}else{for(g=zg(b,g);!b.g();)h=b.n(),g.ba(a(h)),b=b.o();b=g.da()}f.gb=b;f.Pa=c.y(c,f,"name",c.s);f.oe=d.y(d,f,"templ",d.s);return f}ay.prototype.$classData=l({tP:0},!1,"scala.meta.Pkg$Object$",{tP:1,f:1,l:1,k:1});var $x=void 0;function GX(){}
GX.prototype=new m;GX.prototype.constructor=GX;GX.prototype.c=function(){return this};GX.prototype.$classData=l({wP:0},!1,"scala.meta.Ref$Quasi$",{wP:1,f:1,l:1,k:1});var Lra=void 0;function HX(){}HX.prototype=new m;HX.prototype.constructor=HX;HX.prototype.c=function(){return this};
function By(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["name is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("name",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"name.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["decltpe is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=
J();c=[(new q).a("decltpe",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"decltpe.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Mra(null,null,null);a.Pa=b.y(b,a,"name",b.s);c.g()?b=S():(b=c.q(),b=(new T).e(b.y(b,a,"decltpe",b.s)));a.Lc=b;return a}HX.prototype.$classData=l({yP:0},!1,"scala.meta.Self$",{yP:1,f:1,l:1,k:1});var Nra=void 0;function Ay(){Nra||(Nra=(new HX).c());return Nra}function IX(){}IX.prototype=new m;IX.prototype.constructor=IX;IX.prototype.c=function(){return this};
IX.prototype.$classData=l({zP:0},!1,"scala.meta.Self$Quasi$",{zP:1,f:1,l:1,k:1});var Ora=void 0;function JX(){}JX.prototype=new m;JX.prototype.constructor=JX;JX.prototype.c=function(){return this};
function Tfa(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["stats is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("stats",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"stats.!\x3d(null)",a,f.t)}throw(new p).e(c);}c=Pra(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());
for(b=b.o();b!==F();)g=b.n(),g=U(new V,a(g),F()),f=f.ga=g,b=b.o();b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.ld=b;return c}JX.prototype.$classData=l({EP:0},!1,"scala.meta.Source$",{EP:1,f:1,l:1,k:1});var Qra=void 0;function NA(){Qra||(Qra=(new JX).c());return Qra}function KX(){}KX.prototype=new m;KX.prototype.constructor=KX;KX.prototype.c=function(){return this};
function $u(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Rra(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}KX.prototype.$classData=l({GP:0},!1,"scala.meta.Stat$Quasi$",{GP:1,f:1,l:1,k:1});var Sra=void 0;
function av(){Sra||(Sra=(new KX).c());return Sra}function LX(){}LX.prototype=new m;LX.prototype.constructor=LX;LX.prototype.c=function(){return this};
function yD(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var h=(new r).d(["early is equal to null"]),n=G().b,g=(new q).a(!1,H(h,n))}if(null===g||!0!==I(g)){if(null!==g){var u=g.p();if(!1===I(g)){for(var w=J(),D=[(new q).a("early",b)],N=A(new B,C()),Q=0,ea=D.length|0;Q<ea;)E(N,D[Q]),Q=1+Q|0;K(w,"early.!\x3d(null)",u,N.t)}}throw(new p).e(g);}if(null!==c)var ba=(new q).a(!0,F());else{G();var ma=(new r).d(["inits is equal to null"]),La=G().b,ba=(new q).a(!1,H(ma,La))}if(null===ba||!0!==I(ba)){if(null!==
ba){var Pa=ba.p();if(!1===I(ba)){for(var Qa=J(),Ka=[(new q).a("inits",c)],Ba=A(new B,C()),va=0,za=Ka.length|0;va<za;)E(Ba,Ka[va]),va=1+va|0;K(Qa,"inits.!\x3d(null)",Pa,Ba.t)}}throw(new p).e(ba);}if(null!==d)var qa=(new q).a(!0,F());else{G();var la=(new r).d(["self is equal to null"]),Ma=G().b,qa=(new q).a(!1,H(la,Ma))}if(null===qa||!0!==I(qa)){if(null!==qa){var Ea=qa.p();if(!1===I(qa)){for(var tb=J(),Za=[(new q).a("self",d)],eb=A(new B,C()),kb=0,Pb=Za.length|0;kb<Pb;)E(eb,Za[kb]),kb=1+kb|0;K(tb,"self.!\x3d(null)",
Ea,eb.t)}}throw(new p).e(qa);}if(null!==f)var Na=(new q).a(!0,F());else{G();var sb=(new r).d(["stats is equal to null"]),yb=G().b,Na=(new q).a(!1,H(sb,yb))}if(null===Na||!0!==I(Na)){if(null!==Na){var sc=Na.p();if(!1===I(Na)){for(var Ra=J(),wc=[(new q).a("stats",f)],Wb=A(new B,C()),Rb=0,ub=wc.length|0;Rb<ub;)E(Wb,wc[Rb]),Rb=1+Rb|0;K(Ra,"stats.!\x3d(null)",sc,Wb.t)}}throw(new p).e(Na);}a:{for(var fb=b;!fb.g();){var Xb=fb.n();if(!Yia(hv(Xb))||!cj(c)){var lb=!1;break a}fb=fb.o()}lb=!0}if(lb)var Eb=(new q).a(!0,
F());else{G();var xc=(new r).d(["early.forall(((x$15: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$15).isEarlyStat.\x26\x26(inits.nonEmpty))) is false"]),gb=G().b,Eb=(new q).a(!1,H(xc,gb))}if(null===Eb||!0!==I(Eb)){if(null!==Eb){var dc=Eb.p();if(!1===I(Eb)){for(var Fc=J(),Qb=[(new q).a("early",b),(new q).a("inits",c)],Bb=A(new B,C()),Ib=0,mb=Qb.length|0;Ib<mb;)E(Bb,Qb[Ib]),Ib=1+Ib|0;K(Fc,"early.forall(((x$15: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$15).isEarlyStat.\x26\x26(inits.nonEmpty)))",
dc,Bb.t)}}throw(new p).e(Eb);}a:{for(var Cb=f;!Cb.g();){var Tb=Cb.n();if(!bea(hv(Tb))){var mc=!1;break a}Cb=Cb.o()}mc=!0}if(mc)var Ac=(new q).a(!0,F());else{G();var Dc=(new r).d(["stats.forall(((x$16: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$16).isTemplateStat)) is false"]),Db=G().b,Ac=(new q).a(!1,H(Dc,Db))}if(null===Ac||!0!==I(Ac)){if(null!==Ac){var Va=Ac.p();if(!1===I(Ac)){for(var ec=J(),$a=[(new q).a("stats",f)],vb=A(new B,C()),fc=0,Bc=$a.length|0;fc<Bc;)E(vb,
$a[fc]),fc=1+fc|0;K(ec,"stats.forall(((x$16: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$16).isTemplateStat))",Va,vb.t)}}throw(new p).e(Ac);}var Ub=Tra(null,null,null),Vb=function(a,b){return function(a){return a.y(a,b,"early",a.s)}}(a,Ub),wb=G().b;if(wb===G().b)if(b===F())var xb=F();else{for(var Xa=b.n(),tc=U(new V,Vb(Xa),F()),ib=tc,zb=b.o();zb!==F();)var nb=zb.n(),Jb=U(new V,Vb(nb),F()),ib=ib.ga=Jb,zb=zb.o();xb=tc}else{for(var jb=zg(b,wb),ob=b;!ob.g();){var gc=
ob.n();jb.ba(Vb(gc));ob=ob.o()}xb=jb.da()}Ub.Wo=xb;var cb=function(a,b){return function(a){return a.y(a,b,"inits",a.s)}}(a,Ub),Ua=G().b;if(Ua===G().b)if(c===F())var Yb=F();else{for(var Kb=c.n(),pb=U(new V,cb(Kb),F()),hb=pb,Lb=c.o();Lb!==F();)var Fa=Lb.n(),bb=U(new V,cb(Fa),F()),hb=hb.ga=bb,Lb=Lb.o();Yb=pb}else{for(var nc=zg(c,Ua),db=c;!db.g();){var uc=db.n();nc.ba(cb(uc));db=db.o()}Yb=nc.da()}Ub.ap=Yb;Ub.dp=d.y(d,Ub,"self",d.s);var Fb=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,
Ub),hc=G().b;if(hc===G().b)if(f===F())var $b=F();else{for(var kc=f.n(),lc=U(new V,Fb(kc),F()),Mb=lc,Nb=f.o();Nb!==F();)var Gb=Nb.n(),Sb=U(new V,Fb(Gb),F()),Mb=Mb.ga=Sb,Nb=Nb.o();$b=lc}else{for(var Cc=zg(f,hc),Ob=f;!Ob.g();){var Zb=Ob.n();Cc.ba(Fb(Zb));Ob=Ob.o()}$b=Cc.da()}Ub.ld=$b;return Ub}LX.prototype.$classData=l({IP:0},!1,"scala.meta.Template$",{IP:1,f:1,l:1,k:1});var Ura=void 0;function xD(){Ura||(Ura=(new LX).c());return Ura}function MX(){}MX.prototype=new m;MX.prototype.constructor=MX;
MX.prototype.c=function(){return this};MX.prototype.$classData=l({KP:0},!1,"scala.meta.Template$Quasi$",{KP:1,f:1,l:1,k:1});var Vra=void 0;function NX(){}NX.prototype=new m;NX.prototype.constructor=NX;NX.prototype.c=function(){return this};NX.prototype.$classData=l({OP:0},!1,"scala.meta.Term$",{OP:1,f:1,l:1,k:1});var Wra=void 0;function mz(){Wra||(Wra=(new NX).c());return Wra}function oz(){}oz.prototype=new m;oz.prototype.constructor=oz;oz.prototype.c=function(){return this};
function nfa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["expr is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("expr",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"expr.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["annots is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("annots",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"annots.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["annots is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["annots.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("annots",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+
g|0;K(a,"annots.!\x3d(null).\x26\x26(annots.nonEmpty)",b,f.t)}throw(new p).e(d);}d=Xra(null,null,null);d.gc=b.y(b,d,"expr",b.s);b=function(a,b){return function(a){return a.y(a,b,"annots",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.Hj=c;return d}oz.prototype.$classData=l({QP:0},!1,"scala.meta.Term$Annotate$",{QP:1,f:1,l:1,k:1});
var nz=void 0;function jC(){}jC.prototype=new m;jC.prototype.constructor=jC;jC.prototype.c=function(){return this};
function iga(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["fun is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("fun",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"fun.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["args is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("args",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"args.!\x3d(null)",b,f.t)}throw(new p).e(d);}d=Yra(null,null,null);d.vh=b.y(b,d,"fun",b.s);b=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.fc=c;return d}
jC.prototype.$classData=l({TP:0},!1,"scala.meta.Term$Apply$",{TP:1,f:1,l:1,k:1});var iC=void 0;function HT(){}HT.prototype=new m;HT.prototype.constructor=HT;HT.prototype.c=function(){return this};
function Vla(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var g=(new r).d(["lhs is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){a=J();d=[(new q).a("lhs",b)];b=A(new B,C());c=0;for(h=d.length|0;c<h;)E(b,d[c]),c=1+c|0;K(a,"lhs.!\x3d(null)",f,b.t)}throw(new p).e(g);}null!==c?g=(new q).a(!0,F()):(G(),g=(new r).d(["op is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){a=J();
d=[(new q).a("op",c)];b=A(new B,C());c=0;for(h=d.length|0;c<h;)E(b,d[c]),c=1+c|0;K(a,"op.!\x3d(null)",f,b.t)}throw(new p).e(g);}null!==d?g=(new q).a(!0,F()):(G(),g=(new r).d(["targs is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){a=J();d=[(new q).a("targs",d)];b=A(new B,C());c=0;for(h=d.length|0;c<h;)E(b,d[c]),c=1+c|0;K(a,"targs.!\x3d(null)",f,b.t)}throw(new p).e(g);}null!==f?g=(new q).a(!0,F()):(G(),g=(new r).d(["args is equal to null"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){d=J();f=[(new q).a("args",f)];b=A(new B,C());c=0;for(h=f.length|0;c<h;)E(b,f[c]),c=1+c|0;K(d,"args.!\x3d(null)",a,b.t)}throw(new p).e(g);}g=Zra(null,null,null);g.pc=b.y(b,g,"lhs",b.s);g.Ef=c.y(c,g,"op",c.s);b=function(a,b){return function(a){return a.y(a,b,"targs",a.s)}}(a,g);c=G().b;if(c===G().b)if(d===F())d=F();else{c=d.n();h=c=U(new V,b(c),F());for(d=d.o();d!==F();){var n=d.n(),n=U(new V,b(n),F()),h=h.ga=
n;d=d.o()}d=c}else{for(c=zg(d,c);!d.g();)h=d.n(),c.ba(b(h)),d=d.o();d=c.da()}g.Rj=d;a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,g);d=G().b;if(d===G().b)if(f===F())f=F();else{d=f.n();b=d=U(new V,a(d),F());for(f=f.o();f!==F();)c=f.n(),c=U(new V,a(c),F()),b=b.ga=c,f=f.o();f=d}else{for(d=zg(f,d);!f.g();)b=f.n(),d.ba(a(b)),f=f.o();f=d.da()}g.fc=f;return g}HT.prototype.$classData=l({XP:0},!1,"scala.meta.Term$ApplyInfix$",{XP:1,f:1,l:1,k:1});var Ula=void 0;function OX(){}
OX.prototype=new m;OX.prototype.constructor=OX;OX.prototype.c=function(){return this};
function hC(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["fun is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("fun",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"fun.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["targs is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("targs",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"targs.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["targs is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["targs.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("targs",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,
"targs.!\x3d(null).\x26\x26(targs.nonEmpty)",b,f.t)}throw(new p).e(d);}d=$ra(null,null,null);d.vh=b.y(b,d,"fun",b.s);b=function(a,b){return function(a){return a.y(a,b,"targs",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.Rj=c;return d}OX.prototype.$classData=l({aQ:0},!1,"scala.meta.Term$ApplyType$",{aQ:1,f:1,l:1,k:1});
var asa=void 0;function gC(){asa||(asa=(new OX).c());return asa}function nC(){}nC.prototype=new m;nC.prototype.constructor=nC;nC.prototype.c=function(){return this};nC.prototype.$classData=l({dQ:0},!1,"scala.meta.Term$ApplyUnary$",{dQ:1,f:1,l:1,k:1});var pga=void 0;function rz(){}rz.prototype=new m;rz.prototype.constructor=rz;rz.prototype.c=function(){return this};rz.prototype.$classData=l({hQ:0},!1,"scala.meta.Term$Ascribe$",{hQ:1,f:1,l:1,k:1});var qfa=void 0;function jz(){}jz.prototype=new m;
jz.prototype.constructor=jz;jz.prototype.c=function(){return this};jz.prototype.$classData=l({kQ:0},!1,"scala.meta.Term$Assign$",{kQ:1,f:1,l:1,k:1});var jfa=void 0;function PX(){}PX.prototype=new m;PX.prototype.constructor=PX;PX.prototype.c=function(){return this};
function rx(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["stats is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("stats",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"stats.!\x3d(null)",a,f.t)}throw(new p).e(c);}a:{for(c=b;!c.g();){d=c.n();if(!DD(hv(d))){c=!1;break a}c=c.o()}c=!0}c?c=(new q).a(!0,F()):(G(),c=(new r).d(["stats.forall(((x$1: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$1).isBlockStat)) is false"]),
d=G().b,c=(new q).a(!1,H(c,d)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("stats",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"stats.forall(((x$1: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$1).isBlockStat))",a,f.t)}throw(new p).e(c);}c=bsa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());for(b=
b.o();b!==F();)g=b.n(),g=U(new V,a(g),F()),f=f.ga=g,b=b.o();b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.ld=b;return c}PX.prototype.$classData=l({oQ:0},!1,"scala.meta.Term$Block$",{oQ:1,f:1,l:1,k:1});var csa=void 0;function qx(){csa||(csa=(new PX).c());return csa}function Zy(){}Zy.prototype=new m;Zy.prototype.constructor=Zy;Zy.prototype.c=function(){return this};Zy.prototype.$classData=l({rQ:0},!1,"scala.meta.Term$Do$",{rQ:1,f:1,l:1,k:1});var $ea=void 0;function kC(){}
kC.prototype=new m;kC.prototype.constructor=kC;kC.prototype.c=function(){return this};kC.prototype.$classData=l({uQ:0},!1,"scala.meta.Term$Eta$",{uQ:1,f:1,l:1,k:1});var jga=void 0;function dz(){}dz.prototype=new m;dz.prototype.constructor=dz;dz.prototype.c=function(){return this};
function efa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["enums is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("enums",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"enums.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["body is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("body",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"body.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==b?(d=!0,f=F()):(G(),d=(new r).d(["enums is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(b)?d=(new q).a(!0,F()):(G(),d=(new r).d(["enums.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("enums",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,
"enums.!\x3d(null).\x26\x26(enums.nonEmpty)",c,f.t)}throw(new p).e(d);}d=v();f=b.n();y(z(d,f),rla())?(f=!0,d=F()):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Enumerator](enums.head)(scala.meta.Tree.classifiable[scala.meta.Enumerator]).is[Enumerator.Generator](Enumerator.this.Generator.ClassifierClass[scala.meta.Enumerator]) is false"]),f=G().b,d=H(d,f),f=!1);f?d=(new q).a(!0,F()):(f=v(),g=b.n(),f=z(f,g),RR||(RR=(new PR).c()),y(f,RR)?(f=!0,g=F()):(G(),f=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Enumerator](enums.head)(scala.meta.Tree.classifiable[scala.meta.Enumerator]).is[Enumerator.Quasi](Enumerator.this.Quasi.ClassifierClass[scala.meta.Enumerator]) is false"]),
g=G().b,g=H(f,g),f=!1),f?d=(new q).a(!0,F()):(f=G(),d=(new q).a(!1,d.ma(g,f.b))));if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("enums",b),(new q).a("Enumerator",qqa())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Enumerator](enums.head)(scala.meta.Tree.classifiable[scala.meta.Enumerator]).is[Enumerator.Generator](Enumerator.this.Generator.ClassifierClass[scala.meta.Enumerator]).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Enumerator](enums.head)(scala.meta.Tree.classifiable[scala.meta.Enumerator]).is[Enumerator.Quasi](Enumerator.this.Quasi.ClassifierClass[scala.meta.Enumerator]))",
c,f.t)}throw(new p).e(d);}d=dsa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"enums",a.s)}}(a,d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.Nj=b;d.Kc=c.y(c,d,"body",c.s);return d}dz.prototype.$classData=l({xQ:0},!1,"scala.meta.Term$For$",{xQ:1,f:1,l:1,k:1});var cz=void 0;function bz(){}bz.prototype=new m;
bz.prototype.constructor=bz;bz.prototype.c=function(){return this};
function dfa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["enums is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("enums",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"enums.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["body is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("body",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"body.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==b?(d=!0,f=F()):(G(),d=(new r).d(["enums is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(b)?d=(new q).a(!0,F()):(G(),d=(new r).d(["enums.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("enums",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,
"enums.!\x3d(null).\x26\x26(enums.nonEmpty)",c,f.t)}throw(new p).e(d);}d=esa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"enums",a.s)}}(a,d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.Nj=b;d.Kc=c.y(c,d,"body",c.s);return d}bz.prototype.$classData=l({AQ:0},!1,"scala.meta.Term$ForYield$",{AQ:1,f:1,l:1,k:1});
var az=void 0;function QX(){}QX.prototype=new m;QX.prototype.constructor=QX;QX.prototype.c=function(){return this};
function xfa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["params is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("params",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"params.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["body is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===
I(d))){a=J();c=[(new q).a("body",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"body.!\x3d(null)",b,f.t)}throw(new p).e(d);}a:{for(d=b;!d.g();){f=d.n();g=v();y(z(g,f),zla())?f=!0:(g=v(),h=f.xb(),g=y(z(g,h),cm()),f=vr((new ur).qj(g),f.Bi().g()));if(!f){d=!1;break a}d=d.o()}d=!0}d?d=(new q).a(!0,F()):(G(),d=(new r).d(["params.forall(((param: scala.meta.Term.Param) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Param](param)(scala.meta.Tree.classifiable[scala.meta.Term.Param]).is[Term.Param.Quasi](Param.this.Quasi.ClassifierClass[scala.meta.Term.Param]).||(org.scalameta.invariants.`package`.XtensionImplication(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](param.name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Anonymous](Name.this.Anonymous.ClassifierClass[scala.meta.Name])).\x3d\x3d\x3e(param.default.isEmpty)))) is false"]),
f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("params",b),(new q).a("Param",lB()),(new q).a("Name",jD())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"params.forall(((param: scala.meta.Term.Param) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Param](param)(scala.meta.Tree.classifiable[scala.meta.Term.Param]).is[Term.Param.Quasi](Param.this.Quasi.ClassifierClass[scala.meta.Term.Param]).||(org.scalameta.invariants.`package`.XtensionImplication(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Name](param.name)(scala.meta.Tree.classifiable[scala.meta.Name]).is[scala.meta.Name.Anonymous](Name.this.Anonymous.ClassifierClass[scala.meta.Name])).\x3d\x3d\x3e(param.default.isEmpty))))",
c,f.t)}throw(new p).e(d);}a:{for(d=b;!d.g();){f=d.n();g=v();if(y(z(g,f),zla())){d=!0;break a}d=d.o()}d=!1}d?(f=!0,d=F()):(G(),d=(new r).d(["params.exists(((x$2: scala.meta.Term.Param) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Param](x$2)(scala.meta.Tree.classifiable[scala.meta.Term.Param]).is[Term.Param.Quasi](Param.this.Quasi.ClassifierClass[scala.meta.Term.Param]))) is false"]),f=G().b,d=H(d,f),f=!1);if(f)d=(new q).a(!0,F());else{a:{for(f=b;!f.g();){b:{for(g=
f.n().Qa();!g.g();){var h=g.n(),n=v();if(y(z(n,h),Hw())){g=!0;break b}g=g.o()}g=!1}if(g){f=!0;break a}f=f.o()}f=!1}vr((new ur).qj(f),1===Cg(b))?(f=!0,g=F()):(G(),f=(new r).d(["org.scalameta.invariants.`package`.XtensionImplication(params.exists(((x$3: scala.meta.Term.Param) \x3d\x3e x$3.mods.exists(((x$4: scala.meta.Mod) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Mod](x$4)(scala.meta.Tree.classifiable[scala.meta.Mod]).is[Mod.Implicit](Mod.this.Implicit.ClassifierClass[scala.meta.Mod])))))).\x3d\x3d\x3e(params.length.\x3d\x3d(1)) is false"]),
g=G().b,g=H(f,g),f=!1);f?d=(new q).a(!0,F()):(f=G(),d=(new q).a(!1,d.ma(g,f.b)))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("params",b),(new q).a("Param",lB()),(new q).a("Mod",Oqa())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"params.exists(((x$2: scala.meta.Term.Param) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Param](x$2)(scala.meta.Tree.classifiable[scala.meta.Term.Param]).is[Term.Param.Quasi](Param.this.Quasi.ClassifierClass[scala.meta.Term.Param]))).||(org.scalameta.invariants.`package`.XtensionImplication(params.exists(((x$3: scala.meta.Term.Param) \x3d\x3e x$3.mods.exists(((x$4: scala.meta.Mod) \x3d\x3e scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Mod](x$4)(scala.meta.Tree.classifiable[scala.meta.Mod]).is[Mod.Implicit](Mod.this.Implicit.ClassifierClass[scala.meta.Mod])))))).\x3d\x3d\x3e(params.length.\x3d\x3d(1)))",
c,f.t)}throw(new p).e(d);}d=fsa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"params",a.s)}}(a,d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.yh=b;d.Kc=c.y(c,d,"body",c.s);return d}QX.prototype.$classData=l({DQ:0},!1,"scala.meta.Term$Function$",{DQ:1,f:1,l:1,k:1});var gsa=void 0;
function yfa(){gsa||(gsa=(new QX).c());return gsa}function RX(){}RX.prototype=new m;RX.prototype.constructor=RX;RX.prototype.c=function(){return this};
function Ny(a,b,c){if(null!==a)var d=(new q).a(!0,F());else{G();var d=(new r).d(["cond is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){c=J();a=[(new q).a("cond",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(c,"cond.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==b?d=(new q).a(!0,F()):(G(),d=(new r).d(["thenp is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){c=
J();b=[(new q).a("thenp",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(c,"thenp.!\x3d(null)",a,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["elsep is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){b=J();c=[(new q).a("elsep",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(b,"elsep.!\x3d(null)",a,f.t)}throw(new p).e(d);}d=hsa(null,null,null);d.uh=a.y(a,d,"cond",a.s);d.gp=b.y(b,d,
"thenp",b.s);d.Xo=c.y(c,d,"elsep",c.s);return d}RX.prototype.$classData=l({GQ:0},!1,"scala.meta.Term$If$",{GQ:1,f:1,l:1,k:1});var isa=void 0;function My(){isa||(isa=(new RX).c())}function uB(){}uB.prototype=new m;uB.prototype.constructor=uB;uB.prototype.c=function(){return this};
function dga(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["prefix is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=J();c=[(new q).a("prefix",b)];b=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"prefix.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["parts is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===
I(f))){a=J();c=[(new q).a("parts",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"parts.!\x3d(null)",d,b.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["args is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){c=J();d=[(new q).a("args",d)];b=A(new B,C());g=0;for(h=d.length|0;g<h;)E(b,d[g]),g=1+g|0;K(c,"args.!\x3d(null)",a,b.t)}throw(new p).e(f);}null!==c?(f=!0,g=F()):(G(),f=(new r).d(["parts is equal to null"]),
g=G().b,g=H(f,g),f=!1);f?cj(c)?f=(new q).a(!0,F()):(G(),f=(new r).d(["parts.nonEmpty is false"]),g=G().b,f=(new q).a(!1,H(f,g))):f=(new q).a(!1,g);if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){a=J();c=[(new q).a("parts",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(a,"parts.!\x3d(null).\x26\x26(parts.nonEmpty)",d,b.t)}throw(new p).e(f);}Cg(c)===(1+Cg(d)|0)?f=(new q).a(!0,F()):(G(),f=(new r).d(["parts.length is not equal to args.length.+(1)"]),g=G().b,f=(new q).a(!1,
H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();d=[(new q).a("parts",c),(new q).a("args",d)];c=A(new B,C());g=0;for(h=d.length|0;g<h;)E(c,d[g]),g=1+g|0;K(b,"parts.length.\x3d\x3d(args.length.+(1))",a,c.t)}throw(new p).e(f);}f=jsa(null,null,null);f.Pj=b.y(b,f,"prefix",b.s);b=function(a,b){return function(a){return a.y(a,b,"parts",a.s)}}(a,f);g=G().b;if(g===G().b)if(c===F())c=F();else{g=c.n();h=g=U(new V,b(g),F());for(c=c.o();c!==F();){var n=c.n(),n=U(new V,b(n),F()),h=h.ga=
n;c=c.o()}c=g}else{for(g=zg(c,g);!c.g();)h=c.n(),g.ba(b(h)),c=c.o();c=g.da()}f.Ff=c;a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,f);c=G().b;if(c===G().b)if(d===F())d=F();else{c=d.n();b=c=U(new V,a(c),F());for(d=d.o();d!==F();)g=d.n(),g=U(new V,a(g),F()),b=b.ga=g,d=d.o();d=c}else{for(c=zg(d,c);!d.g();)b=d.n(),c.ba(a(b)),d=d.o();d=c.da()}f.fc=d;return f}uB.prototype.$classData=l({JQ:0},!1,"scala.meta.Term$Interpolate$",{JQ:1,f:1,l:1,k:1});var oB=void 0;function tz(){}
tz.prototype=new m;tz.prototype.constructor=tz;tz.prototype.c=function(){return this};
function ufa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["expr is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("expr",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"expr.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["cases is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("cases",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"cases.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["cases is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["cases.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("cases",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,
"cases.!\x3d(null).\x26\x26(cases.nonEmpty)",b,f.t)}throw(new p).e(d);}d=ksa(null,null,null);d.gc=b.y(b,d,"expr",b.s);b=function(a,b){return function(a){return a.y(a,b,"cases",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.Kj=c;return d}tz.prototype.$classData=l({NQ:0},!1,"scala.meta.Term$Match$",{NQ:1,f:1,l:1,k:1});var sz=void 0;
function SX(){}SX.prototype=new m;SX.prototype.constructor=SX;SX.prototype.c=function(){return this};
function Cu(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["value is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("value",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"value.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==b?(a=!0,c=F()):(G(),a=(new r).d(["value is equal to null"]),c=G().b,c=H(a,c),a=!1);a?(a=(new cd).j(b),cj(a)?a=(new q).a(!0,F()):(G(),a=(new r).d(["scala.Predef.augmentString(value).nonEmpty is false"]),
c=G().b,a=(new q).a(!1,H(a,c)))):a=(new q).a(!1,c);if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("value",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"value.!\x3d(null).\x26\x26(scala.Predef.augmentString(value).nonEmpty)",c,f.t)}throw(new p).e(a);}return lsa(null,null,null,b)}SX.prototype.$classData=l({PQ:0},!1,"scala.meta.Term$Name$",{PQ:1,f:1,l:1,k:1});var msa=void 0;function Du(){msa||(msa=(new SX).c());return msa}function TX(){}
TX.prototype=new m;TX.prototype.constructor=TX;TX.prototype.c=function(){return this};function nsa(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=osa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
TX.prototype.$classData=l({QQ:0},!1,"scala.meta.Term$Name$Quasi$",{QQ:1,f:1,l:1,k:1});var psa=void 0;function qsa(){psa||(psa=(new TX).c());return psa}function ix(){}ix.prototype=new m;ix.prototype.constructor=ix;ix.prototype.c=function(){return this};
function rea(a){if(null!==a)var b=(new q).a(!0,F());else{G();var b=(new r).d(["init is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("init",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"init.!\x3d(null)",c,f.t)}throw(new p).e(b);}b=rsa(null,null,null);b.xh=a.y(a,b,"init",a.s);return b}ix.prototype.$classData=l({WQ:0},!1,"scala.meta.Term$New$",{WQ:1,f:1,l:1,k:1});var qea=void 0;
function UX(){}UX.prototype=new m;UX.prototype.constructor=UX;UX.prototype.c=function(){return this};function oea(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["templ is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("templ",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"templ.!\x3d(null)",c,f.t)}throw(new p).e(a);}a=ssa(null,null,null);a.oe=b.y(b,a,"templ",b.s);return a}
UX.prototype.$classData=l({ZQ:0},!1,"scala.meta.Term$NewAnonymous$",{ZQ:1,f:1,l:1,k:1});var tsa=void 0;function pea(){tsa||(tsa=(new UX).c());return tsa}function VX(){}VX.prototype=new m;VX.prototype.constructor=VX;VX.prototype.c=function(){return this};
function kB(a,b,c,d,f){if(null!==b)var g=(new q).a(!0,F());else{G();var g=(new r).d(["mods is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h))}if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){c=J();d=[(new q).a("mods",b)];b=A(new B,C());a=0;for(h=d.length|0;a<h;)E(b,d[a]),a=1+a|0;K(c,"mods.!\x3d(null)",f,b.t)}throw(new p).e(g);}null!==c?g=(new q).a(!0,F()):(G(),g=(new r).d(["name is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){d=
J();c=[(new q).a("name",c)];b=A(new B,C());a=0;for(h=c.length|0;a<h;)E(b,c[a]),a=1+a|0;K(d,"name.!\x3d(null)",f,b.t)}throw(new p).e(g);}null!==d?g=(new q).a(!0,F()):(G(),g=(new r).d(["decltpe is equal to null"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(f=g.p(),!1===I(g))){c=J();d=[(new q).a("decltpe",d)];b=A(new B,C());a=0;for(h=d.length|0;a<h;)E(b,d[a]),a=1+a|0;K(c,"decltpe.!\x3d(null)",f,b.t)}throw(new p).e(g);}null!==f?g=(new q).a(!0,F()):(G(),g=(new r).d(["default is equal to null"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(c=g.p(),!1===I(g))){d=J();f=[(new q).a("default",f)];b=A(new B,C());a=0;for(h=f.length|0;a<h;)E(b,f[a]),a=1+a|0;K(d,"default.!\x3d(null)",c,b.t)}throw(new p).e(g);}g=usa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,g);h=G().b;if(h===G().b)if(b===F())b=F();else{var h=b.n(),n=h=U(new V,a(h),F());for(b=b.o();b!==F();){var u=b.n(),u=U(new V,a(u),F()),n=n.ga=u;b=b.o()}b=h}else{for(h=zg(b,h);!b.g();)n=
b.n(),h.ba(a(n)),b=b.o();b=h.da()}g.gb=b;g.Pa=c.y(c,g,"name",c.s);d.g()?c=S():(c=d.q(),c=(new T).e(c.y(c,g,"decltpe",c.s)));g.Lc=c;f.g()?f=S():(f=f.q(),f=(new T).e(f.y(f,g,"default",f.s)));g.Vo=f;return g}VX.prototype.$classData=l({aR:0},!1,"scala.meta.Term$Param$",{aR:1,f:1,l:1,k:1});var vsa=void 0;function lB(){vsa||(vsa=(new VX).c());return vsa}function WX(){}WX.prototype=new m;WX.prototype.constructor=WX;WX.prototype.c=function(){return this};
function Qz(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=wsa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}WX.prototype.$classData=l({bR:0},!1,"scala.meta.Term$Param$Quasi$",{bR:1,f:1,l:1,k:1});var xsa=void 0;
function Rz(){xsa||(xsa=(new WX).c());return xsa}function lw(){}lw.prototype=new m;lw.prototype.constructor=lw;lw.prototype.c=function(){return this};
function Xda(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["cases is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("cases",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"cases.!\x3d(null)",a,f.t)}throw(new p).e(c);}null!==b?(c=!0,d=F()):(G(),c=(new r).d(["cases is equal to null"]),d=G().b,d=H(c,d),c=!1);c?cj(b)?c=(new q).a(!0,F()):(G(),c=(new r).d(["cases.nonEmpty is false"]),
d=G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("cases",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"cases.!\x3d(null).\x26\x26(cases.nonEmpty)",a,f.t)}throw(new p).e(c);}c=ysa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"cases",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());for(b=b.o();b!==F();)g=b.n(),g=U(new V,a(g),F()),f=f.ga=g,b=b.o();
b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.Kj=b;return c}lw.prototype.$classData=l({hR:0},!1,"scala.meta.Term$PartialFunction$",{hR:1,f:1,l:1,k:1});var kw=void 0;function Zw(){}Zw.prototype=new m;Zw.prototype.constructor=Zw;Zw.prototype.c=function(){return this};Zw.prototype.$classData=l({kR:0},!1,"scala.meta.Term$Placeholder$",{kR:1,f:1,l:1,k:1});var lea=void 0;function XX(){}XX.prototype=new m;XX.prototype.constructor=XX;XX.prototype.c=function(){return this};
function ax(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=zsa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}XX.prototype.$classData=l({nR:0},!1,"scala.meta.Term$Quasi$",{nR:1,f:1,l:1,k:1});var Asa=void 0;
function bx(){Asa||(Asa=(new XX).c());return Asa}function YX(){}YX.prototype=new m;YX.prototype.constructor=YX;YX.prototype.c=function(){return this};YX.prototype.$classData=l({qR:0},!1,"scala.meta.Term$Ref$",{qR:1,f:1,l:1,k:1});var Bsa=void 0;function Csa(){Bsa||(Bsa=(new YX).c());return Bsa}function ZX(){}ZX.prototype=new m;ZX.prototype.constructor=ZX;ZX.prototype.c=function(){return this};
function $X(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Dsa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}ZX.prototype.$classData=l({rR:0},!1,"scala.meta.Term$Ref$Quasi$",{rR:1,f:1,l:1,k:1});var Esa=void 0;
function aY(){Esa||(Esa=(new ZX).c());return Esa}function qz(){}qz.prototype=new m;qz.prototype.constructor=qz;qz.prototype.c=function(){return this};qz.prototype.$classData=l({wR:0},!1,"scala.meta.Term$Repeated$",{wR:1,f:1,l:1,k:1});var ofa=void 0;function gz(){}gz.prototype=new m;gz.prototype.constructor=gz;gz.prototype.c=function(){return this};
function ffa(a){if(null!==a)var b=(new q).a(!0,F());else{G();var b=(new r).d(["expr is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("expr",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"expr.!\x3d(null)",c,f.t)}throw(new p).e(b);}b=Fsa(null,null,null);b.gc=a.y(a,b,"expr",a.s);return b}gz.prototype.$classData=l({AR:0},!1,"scala.meta.Term$Return$",{AR:1,f:1,l:1,k:1});var fz=void 0;
function bY(){}bY.prototype=new m;bY.prototype.constructor=bY;bY.prototype.c=function(){return this};
function Zt(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["qual is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("qual",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"qual.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["name is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();
c=[(new q).a("name",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"name.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Gsa(null,null,null);a.Hf=b.y(b,a,"qual",b.s);a.Pa=c.y(c,a,"name",c.s);return a}bY.prototype.$classData=l({DR:0},!1,"scala.meta.Term$Select$",{DR:1,f:1,l:1,k:1});var Hsa=void 0;function Xt(){Hsa||(Hsa=(new bY).c());return Hsa}function hE(){}hE.prototype=new m;hE.prototype.constructor=hE;hE.prototype.c=function(){return this};
function aha(a,b){if(null!==a)var c=(new q).a(!0,F());else{G();var c=(new r).d(["thisp is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(b=c.p(),!1===I(c))){d=J();a=[(new q).a("thisp",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"thisp.!\x3d(null)",b,f.t)}throw(new p).e(c);}null!==b?c=(new q).a(!0,F()):(G(),c=(new r).d(["superp is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=
J();b=[(new q).a("superp",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"superp.!\x3d(null)",a,f.t)}throw(new p).e(c);}c=Isa(null,null,null);c.hp=a.y(a,c,"thisp",a.s);c.ep=b.y(b,c,"superp",b.s);return c}hE.prototype.$classData=l({GR:0},!1,"scala.meta.Term$Super$",{GR:1,f:1,l:1,k:1});var gE=void 0;function cY(){}cY.prototype=new m;cY.prototype.constructor=cY;cY.prototype.c=function(){return this};
function CA(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["qual is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("qual",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"qual.!\x3d(null)",c,f.t)}throw(new p).e(a);}a=Jsa(null,null,null);a.Hf=b.y(b,a,"qual",b.s);return a}cY.prototype.$classData=l({KR:0},!1,"scala.meta.Term$This$",{KR:1,f:1,l:1,k:1});var Ksa=void 0;
function DA(){Ksa||(Ksa=(new cY).c());return Ksa}function iz(){}iz.prototype=new m;iz.prototype.constructor=iz;iz.prototype.c=function(){return this};iz.prototype.$classData=l({OR:0},!1,"scala.meta.Term$Throw$",{OR:1,f:1,l:1,k:1});var gfa=void 0;function dY(){}dY.prototype=new m;dY.prototype.constructor=dY;dY.prototype.c=function(){return this};
function Vea(a,b,c,d){if(null!==b)var f=(new q).a(!0,F());else{G();var f=(new r).d(["expr is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g))}if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){c=J();b=[(new q).a("expr",b)];a=A(new B,C());for(var g=0,h=b.length|0;g<h;)E(a,b[g]),g=1+g|0;K(c,"expr.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==c?f=(new q).a(!0,F()):(G(),f=(new r).d(["catchp is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(d=f.p(),!1===I(f))){b=
J();c=[(new q).a("catchp",c)];a=A(new B,C());g=0;for(h=c.length|0;g<h;)E(a,c[g]),g=1+g|0;K(b,"catchp.!\x3d(null)",d,a.t)}throw(new p).e(f);}null!==d?f=(new q).a(!0,F()):(G(),f=(new r).d(["finallyp is equal to null"]),g=G().b,f=(new q).a(!1,H(f,g)));if(null===f||!0!==I(f)){if(null!==f&&(c=f.p(),!1===I(f))){b=J();d=[(new q).a("finallyp",d)];a=A(new B,C());g=0;for(h=d.length|0;g<h;)E(a,d[g]),g=1+g|0;K(b,"finallyp.!\x3d(null)",c,a.t)}throw(new p).e(f);}f=Lsa(null,null,null);f.gc=b.y(b,f,"expr",b.s);b=
function(a,b){return function(a){return a.y(a,b,"catchp",a.s)}}(a,f);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();g=a=U(new V,b(a),F());for(c=c.o();c!==F();)h=c.n(),h=U(new V,b(h),F()),g=g.ga=h,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)g=c.n(),a.ba(b(g)),c=c.o();c=a.da()}f.Lj=c;d.g()?d=S():(d=d.q(),d=(new T).e(d.y(d,f,"finallyp",d.s)));f.Oj=d;return f}dY.prototype.$classData=l({RR:0},!1,"scala.meta.Term$Try$",{RR:1,f:1,l:1,k:1});var Msa=void 0;
function Uea(){Msa||(Msa=(new dY).c());return Msa}function Uy(){}Uy.prototype=new m;Uy.prototype.constructor=Uy;Uy.prototype.c=function(){return this};Uy.prototype.$classData=l({UR:0},!1,"scala.meta.Term$TryWithHandler$",{UR:1,f:1,l:1,k:1});var Wea=void 0;function eY(){}eY.prototype=new m;eY.prototype.constructor=eY;eY.prototype.c=function(){return this};
function Lfa(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["args is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.!\x3d(null)",a,f.t)}throw(new p).e(c);}null!==b?(c=!0,d=F()):(G(),c=(new r).d(["args is equal to null"]),d=G().b,d=H(c,d),c=!1);c?cj(b)?c=(new q).a(!0,F()):(G(),c=(new r).d(["args.nonEmpty is false"]),d=
G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.!\x3d(null).\x26\x26(args.nonEmpty)",a,f.t)}throw(new p).e(c);}1<Cg(b)?(d=!0,c=F()):(G(),c=(new r).d(["args.length.\x3e(1) is false"]),d=G().b,c=H(c,d),d=!1);d?c=(new q).a(!0,F()):(1===Cg(b)?(d=!0,f=F()):(G(),d=(new r).d(["args.length is not equal to 1"]),f=G().b,f=H(d,f),d=!1),d?(d=v(),f=b.n(),
y(z(d,f),kfa())?(f=F(),d=!0):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](args.head)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Quasi](Term.this.Quasi.ClassifierClass[scala.meta.Term]) is false"]),f=G().b,f=H(d,f),d=!1)):d=!1,d?c=(new q).a(!0,F()):(d=G(),c=(new q).a(!1,c.ma(f,d.b))));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b),(new q).a("Term",mz())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),
g=1+g|0;K(d,"args.length.\x3e(1).||(args.length.\x3d\x3d(1).\x26\x26(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term](args.head)(scala.meta.Tree.classifiable[scala.meta.Term]).is[Term.Quasi](Term.this.Quasi.ClassifierClass[scala.meta.Term])))",a,f.t)}throw(new p).e(c);}c=Nsa(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());for(b=b.o();b!==F();)g=b.n(),g=U(new V,a(g),F()),
f=f.ga=g,b=b.o();b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.fc=b;return c}eY.prototype.$classData=l({XR:0},!1,"scala.meta.Term$Tuple$",{XR:1,f:1,l:1,k:1});var Osa=void 0;function Mfa(){Osa||(Osa=(new eY).c());return Osa}function Wy(){}Wy.prototype=new m;Wy.prototype.constructor=Wy;Wy.prototype.c=function(){return this};Wy.prototype.$classData=l({$R:0},!1,"scala.meta.Term$While$",{$R:1,f:1,l:1,k:1});var Yea=void 0;function gw(){}gw.prototype=new m;
gw.prototype.constructor=gw;gw.prototype.c=function(){return this};
function Vda(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["parts is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("parts",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"parts.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["args is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){b=
J();c=[(new q).a("args",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(b,"args.!\x3d(null)",a,f.t)}throw(new p).e(d);}null!==b?(d=!0,f=F()):(G(),d=(new r).d(["parts is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(b)?d=(new q).a(!0,F()):(G(),d=(new r).d(["parts.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("parts",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,
"parts.!\x3d(null).\x26\x26(parts.nonEmpty)",c,f.t)}throw(new p).e(d);}Cg(b)===(1+Cg(c)|0)?d=(new q).a(!0,F()):(G(),d=(new r).d(["parts.length is not equal to args.length.+(1)"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){f=J();c=[(new q).a("parts",b),(new q).a("args",c)];b=A(new B,C());g=0;for(h=c.length|0;g<h;)E(b,c[g]),g=1+g|0;K(f,"parts.length.\x3d\x3d(args.length.+(1))",a,b.t)}throw(new p).e(d);}d=Psa(null,null,null);f=function(a,b){return function(a){return a.y(a,
b,"parts",a.s)}}(a,d);g=G().b;if(g===G().b)if(b===F())b=F();else{g=b.n();h=g=U(new V,f(g),F());for(b=b.o();b!==F();){var n=b.n(),n=U(new V,f(n),F()),h=h.ga=n;b=b.o()}b=g}else{for(g=zg(b,g);!b.g();)h=b.n(),g.ba(f(h)),b=b.o();b=g.da()}d.Ff=b;a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,d);b=G().b;if(b===G().b)if(c===F())c=F();else{b=c.n();f=b=U(new V,a(b),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,a(g),F()),f=f.ga=g,c=c.o();c=b}else{for(b=zg(c,b);!c.g();)f=c.n(),b.ba(a(f)),c=c.o();
c=b.da()}d.fc=c;return d}gw.prototype.$classData=l({cS:0},!1,"scala.meta.Term$Xml$",{cS:1,f:1,l:1,k:1});var fw=void 0;function fY(){}fY.prototype=new m;fY.prototype.constructor=fY;fY.prototype.c=function(){return this};
function ag(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Qsa(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}fY.prototype.$classData=l({fS:0},!1,"scala.meta.Tree$Quasi$",{fS:1,f:1,l:1,k:1});var Rsa=void 0;
function bg(){Rsa||(Rsa=(new fY).c());return Rsa}function gY(){}gY.prototype=new m;gY.prototype.constructor=gY;gY.prototype.c=function(){return this};gY.prototype.$classData=l({hS:0},!1,"scala.meta.Type$",{hS:1,f:1,l:1,k:1});var Ssa=void 0;function Ara(){Ssa||(Ssa=(new gY).c());return Ssa}function hY(){}hY.prototype=new m;hY.prototype.constructor=hY;hY.prototype.c=function(){return this};
function uh(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["lhs is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("lhs",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"lhs.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["rhs is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=
[(new q).a("rhs",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"rhs.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Tsa(null,null,null);a.pc=b.y(b,a,"lhs",b.s);a.Kb=c.y(c,a,"rhs",c.s);return a}hY.prototype.$classData=l({jS:0},!1,"scala.meta.Type$And$",{jS:1,f:1,l:1,k:1});var Usa=void 0;function vh(){Usa||(Usa=(new hY).c());return Usa}function iY(){}iY.prototype=new m;iY.prototype.constructor=iY;iY.prototype.c=function(){return this};
function Taa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["tpe is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("tpe",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"tpe.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["annots is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("annots",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"annots.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["annots is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["annots.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("annots",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+
g|0;K(a,"annots.!\x3d(null).\x26\x26(annots.nonEmpty)",b,f.t)}throw(new p).e(d);}d=Vsa(null,null,null);d.qc=b.y(b,d,"tpe",b.s);b=function(a,b){return function(a){return a.y(a,b,"annots",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.Hj=c;return d}iY.prototype.$classData=l({mS:0},!1,"scala.meta.Type$Annotate$",{mS:1,f:1,l:1,k:1});
var Wsa=void 0;function Uaa(){Wsa||(Wsa=(new iY).c());return Wsa}function jY(){}jY.prototype=new m;jY.prototype.constructor=jY;jY.prototype.c=function(){return this};
function eba(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["tpe is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("tpe",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"tpe.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["args is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("args",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"args.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["args is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["args.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("args",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"args.!\x3d(null).\x26\x26(args.nonEmpty)",
b,f.t)}throw(new p).e(d);}d=Xsa(null,null,null);d.qc=b.y(b,d,"tpe",b.s);b=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.fc=c;return d}jY.prototype.$classData=l({pS:0},!1,"scala.meta.Type$Apply$",{pS:1,f:1,l:1,k:1});var Ysa=void 0;
function dba(){Ysa||(Ysa=(new jY).c());return Ysa}function kY(){}kY.prototype=new m;kY.prototype.constructor=kY;kY.prototype.c=function(){return this};
function bi(a,b,c,d){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["lhs is equal to null"]);var f=G().b;a=(new q).a(!1,H(a,f))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("lhs",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"lhs.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["op is equal to null"]),f=G().b,a=(new q).a(!1,H(a,f)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=
[(new q).a("op",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"op.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==d?a=(new q).a(!0,F()):(G(),a=(new r).d(["rhs is equal to null"]),f=G().b,a=(new q).a(!1,H(a,f)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("rhs",d)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"rhs.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Zsa(null,null,null);a.pc=b.y(b,a,"lhs",b.s);a.Ef=c.y(c,a,"op",c.s);a.Kb=d.y(d,
a,"rhs",d.s);return a}kY.prototype.$classData=l({sS:0},!1,"scala.meta.Type$ApplyInfix$",{sS:1,f:1,l:1,k:1});var $sa=void 0;function ci(){$sa||($sa=(new kY).c());return $sa}function gA(){}gA.prototype=new m;gA.prototype.constructor=gA;gA.prototype.c=function(){return this};gA.prototype.$classData=l({vS:0},!1,"scala.meta.Type$Bounds$",{vS:1,f:1,l:1,k:1});var Ifa=void 0;function oE(){}oE.prototype=new m;oE.prototype.constructor=oE;oE.prototype.c=function(){return this};
oE.prototype.$classData=l({yS:0},!1,"scala.meta.Type$ByName$",{yS:1,f:1,l:1,k:1});var bha=void 0;function lY(){}lY.prototype=new m;lY.prototype.constructor=lY;lY.prototype.c=function(){return this};
function ai(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["tpe is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("tpe",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"tpe.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("stats",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"stats.!\x3d(null)",b,f.t)}throw(new p).e(d);}null!==c?(d=!0,f=F()):(G(),d=(new r).d(["stats is equal to null"]),f=G().b,f=H(d,f),d=!1);d?cj(c)?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats.nonEmpty is false"]),f=G().b,d=(new q).a(!1,H(d,f))):d=(new q).a(!1,f);if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("stats",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,
"stats.!\x3d(null).\x26\x26(stats.nonEmpty)",b,f.t)}throw(new p).e(d);}a:{for(d=c;!d.g();){f=d.n();if(!Kga(hv(f))){d=!1;break a}d=d.o()}d=!0}d?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats.forall(((x$6: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$6).isExistentialStat)) is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=J();c=[(new q).a("stats",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,
"stats.forall(((x$6: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$6).isExistentialStat))",b,f.t)}throw(new p).e(d);}d=ata(null,null,null);d.qc=b.y(b,d,"tpe",b.s);b=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,d);a=G().b;if(a===G().b)if(c===F())c=F();else{a=c.n();f=a=U(new V,b(a),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,b(g),F()),f=f.ga=g,c=c.o();c=a}else{for(a=zg(c,a);!c.g();)f=c.n(),a.ba(b(f)),c=c.o();c=a.da()}d.ld=c;return d}
lY.prototype.$classData=l({CS:0},!1,"scala.meta.Type$Existential$",{CS:1,f:1,l:1,k:1});var bta=void 0;function $h(){bta||(bta=(new lY).c());return bta}function mY(){}mY.prototype=new m;mY.prototype.constructor=mY;mY.prototype.c=function(){return this};
function Hg(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["params is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("params",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"params.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["res is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("res",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"res.!\x3d(null)",b,f.t)}throw(new p).e(d);}d=cta(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"params",a.s)}}(a,d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.yh=b;d.Qj=c.y(c,d,"res",c.s);return d}
mY.prototype.$classData=l({FS:0},!1,"scala.meta.Type$Function$",{FS:1,f:1,l:1,k:1});var dta=void 0;function Bg(){dta||(dta=(new mY).c());return dta}function Xi(){}Xi.prototype=new m;Xi.prototype.constructor=Xi;Xi.prototype.c=function(){return this};
function hba(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["params is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("params",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"params.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["res is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===I(d))){a=
J();c=[(new q).a("res",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"res.!\x3d(null)",b,f.t)}throw(new p).e(d);}d=eta(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"params",a.s)}}(a,d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.yh=b;d.Qj=c.y(c,d,"res",c.s);return d}
Xi.prototype.$classData=l({JS:0},!1,"scala.meta.Type$ImplicitFunction$",{JS:1,f:1,l:1,k:1});var Wi=void 0;function Lh(){}Lh.prototype=new m;Lh.prototype.constructor=Lh;Lh.prototype.c=function(){return this};
function Yaa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["tparams is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("tparams",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"tparams.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["tpe is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===
I(d))){a=J();c=[(new q).a("tpe",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"tpe.!\x3d(null)",b,f.t)}throw(new p).e(d);}d=fta(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.Mc=b;d.qc=c.y(c,d,"tpe",c.s);return d}
Lh.prototype.$classData=l({MS:0},!1,"scala.meta.Type$Lambda$",{MS:1,f:1,l:1,k:1});var Kh=void 0;function nY(){}nY.prototype=new m;nY.prototype.constructor=nY;nY.prototype.c=function(){return this};
function Naa(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["paramss is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("paramss",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"paramss.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["tpe is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(b=d.p(),!1===
I(d))){a=J();c=[(new q).a("tpe",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(a,"tpe.!\x3d(null)",b,f.t)}throw(new p).e(d);}d=gta(null,null,null);a=function(a,b){return function(c){var d=function(a,b){return function(a){return a.y(a,b,"paramss",a.s)}}(a,b),f=G().b;if(f===G().b){if(c===F())return F();var f=c.n(),g=f=U(new V,d(f),F());for(c=c.o();c!==F();){var h=c.n(),h=U(new V,d(h),F()),g=g.ga=h;c=c.o()}return f}for(f=zg(c,f);!c.g();)g=c.n(),f.ba(d(g)),c=c.o();return f.da()}}(a,
d);f=G().b;if(f===G().b)if(b===F())b=F();else{f=b.n();g=f=U(new V,a(f),F());for(b=b.o();b!==F();)h=b.n(),h=U(new V,a(h),F()),g=g.ga=h,b=b.o();b=f}else{for(f=zg(b,f);!b.g();)g=b.n(),f.ba(a(g)),b=b.o();b=f.da()}d.Id=b;d.qc=c.y(c,d,"tpe",c.s);return d}nY.prototype.$classData=l({OS:0},!1,"scala.meta.Type$Method$",{OS:1,f:1,l:1,k:1});var hta=void 0;function Maa(){hta||(hta=(new nY).c());return hta}function oY(){}oY.prototype=new m;oY.prototype.constructor=oY;oY.prototype.c=function(){return this};
function Of(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["value is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("value",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"value.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==b?(a=!0,c=F()):(G(),a=(new r).d(["value is equal to null"]),c=G().b,c=H(a,c),a=!1);a?(a=(new cd).j(b),cj(a)?a=(new q).a(!0,F()):(G(),a=(new r).d(["scala.Predef.augmentString(value).nonEmpty is false"]),
c=G().b,a=(new q).a(!1,H(a,c)))):a=(new q).a(!1,c);if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("value",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"value.!\x3d(null).\x26\x26(scala.Predef.augmentString(value).nonEmpty)",c,f.t)}throw(new p).e(a);}return ita(null,null,null,b)}oY.prototype.$classData=l({QS:0},!1,"scala.meta.Type$Name$",{QS:1,f:1,l:1,k:1});var jta=void 0;function Nf(){jta||(jta=(new oY).c());return jta}function pY(){}
pY.prototype=new m;pY.prototype.constructor=pY;pY.prototype.c=function(){return this};function kta(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=lta(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}
pY.prototype.$classData=l({RS:0},!1,"scala.meta.Type$Name$Quasi$",{RS:1,f:1,l:1,k:1});var mta=void 0;function nta(){mta||(mta=(new pY).c());return mta}function qY(){}qY.prototype=new m;qY.prototype.constructor=qY;qY.prototype.c=function(){return this};
function Qaa(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["lhs is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("lhs",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"lhs.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["rhs is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=
[(new q).a("rhs",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"rhs.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=ota(null,null,null);a.pc=b.y(b,a,"lhs",b.s);a.Kb=c.y(c,a,"rhs",c.s);return a}qY.prototype.$classData=l({VS:0},!1,"scala.meta.Type$Or$",{VS:1,f:1,l:1,k:1});var pta=void 0;function Raa(){pta||(pta=(new qY).c());return pta}function Jz(){}Jz.prototype=new m;Jz.prototype.constructor=Jz;Jz.prototype.c=function(){return this};
function Afa(a,b,c,d,f,g,h){if(null!==b)var n=(new q).a(!0,F());else{G();var u=(new r).d(["mods is equal to null"]),w=G().b,n=(new q).a(!1,H(u,w))}if(null===n||!0!==I(n)){if(null!==n){var D=n.p();if(!1===I(n)){for(var N=J(),Q=[(new q).a("mods",b)],ea=A(new B,C()),ba=0,ma=Q.length|0;ba<ma;)E(ea,Q[ba]),ba=1+ba|0;K(N,"mods.!\x3d(null)",D,ea.t)}}throw(new p).e(n);}if(null!==c)var La=(new q).a(!0,F());else{G();var Pa=(new r).d(["name is equal to null"]),Qa=G().b,La=(new q).a(!1,H(Pa,Qa))}if(null===La||
!0!==I(La)){if(null!==La){var Ka=La.p();if(!1===I(La)){for(var Ba=J(),va=[(new q).a("name",c)],za=A(new B,C()),qa=0,la=va.length|0;qa<la;)E(za,va[qa]),qa=1+qa|0;K(Ba,"name.!\x3d(null)",Ka,za.t)}}throw(new p).e(La);}if(null!==d)var Ma=(new q).a(!0,F());else{G();var Ea=(new r).d(["tparams is equal to null"]),tb=G().b,Ma=(new q).a(!1,H(Ea,tb))}if(null===Ma||!0!==I(Ma)){if(null!==Ma){var Za=Ma.p();if(!1===I(Ma)){for(var eb=J(),kb=[(new q).a("tparams",d)],Pb=A(new B,C()),Na=0,sb=kb.length|0;Na<sb;)E(Pb,
kb[Na]),Na=1+Na|0;K(eb,"tparams.!\x3d(null)",Za,Pb.t)}}throw(new p).e(Ma);}if(null!==f)var yb=(new q).a(!0,F());else{G();var sc=(new r).d(["tbounds is equal to null"]),Ra=G().b,yb=(new q).a(!1,H(sc,Ra))}if(null===yb||!0!==I(yb)){if(null!==yb){var wc=yb.p();if(!1===I(yb)){for(var Wb=J(),Rb=[(new q).a("tbounds",f)],ub=A(new B,C()),fb=0,Xb=Rb.length|0;fb<Xb;)E(ub,Rb[fb]),fb=1+fb|0;K(Wb,"tbounds.!\x3d(null)",wc,ub.t)}}throw(new p).e(yb);}if(null!==g)var lb=(new q).a(!0,F());else{G();var Eb=(new r).d(["vbounds is equal to null"]),
xc=G().b,lb=(new q).a(!1,H(Eb,xc))}if(null===lb||!0!==I(lb)){if(null!==lb){var gb=lb.p();if(!1===I(lb)){for(var dc=J(),Fc=[(new q).a("vbounds",g)],Qb=A(new B,C()),Bb=0,Ib=Fc.length|0;Bb<Ib;)E(Qb,Fc[Bb]),Bb=1+Bb|0;K(dc,"vbounds.!\x3d(null)",gb,Qb.t)}}throw(new p).e(lb);}if(null!==h)var mb=(new q).a(!0,F());else{G();var Cb=(new r).d(["cbounds is equal to null"]),Tb=G().b,mb=(new q).a(!1,H(Cb,Tb))}if(null===mb||!0!==I(mb)){if(null!==mb){var mc=mb.p();if(!1===I(mb)){for(var Ac=J(),Dc=[(new q).a("cbounds",
h)],Db=A(new B,C()),Va=0,ec=Dc.length|0;Va<ec;)E(Db,Dc[Va]),Va=1+Va|0;K(Ac,"cbounds.!\x3d(null)",mc,Db.t)}}throw(new p).e(mb);}var $a=qta(null,null,null),vb=function(a,b){return function(a){return a.y(a,b,"mods",a.s)}}(a,$a),fc=G().b;if(fc===G().b)if(b===F())var Bc=F();else{for(var Ub=b.n(),Vb=U(new V,vb(Ub),F()),wb=Vb,xb=b.o();xb!==F();)var Xa=xb.n(),tc=U(new V,vb(Xa),F()),wb=wb.ga=tc,xb=xb.o();Bc=Vb}else{for(var ib=zg(b,fc),zb=b;!zb.g();){var nb=zb.n();ib.ba(vb(nb));zb=zb.o()}Bc=ib.da()}$a.gb=Bc;
$a.Pa=c.y(c,$a,"name",c.s);var Jb=function(a,b){return function(a){return a.y(a,b,"tparams",a.s)}}(a,$a),jb=G().b;if(jb===G().b)if(d===F())var ob=F();else{for(var gc=d.n(),cb=U(new V,Jb(gc),F()),Ua=cb,Yb=d.o();Yb!==F();)var Kb=Yb.n(),pb=U(new V,Jb(Kb),F()),Ua=Ua.ga=pb,Yb=Yb.o();ob=cb}else{for(var hb=zg(d,jb),Lb=d;!Lb.g();){var Fa=Lb.n();hb.ba(Jb(Fa));Lb=Lb.o()}ob=hb.da()}$a.Mc=ob;$a.fp=jA(f,$a,f.s);var bb=function(a,b){return function(a){return a.y(a,b,"vbounds",a.s)}}(a,$a),nc=G().b;if(nc===G().b)if(g===
F())var db=F();else{for(var uc=g.n(),Fb=U(new V,bb(uc),F()),hc=Fb,$b=g.o();$b!==F();)var kc=$b.n(),lc=U(new V,bb(kc),F()),hc=hc.ga=lc,$b=$b.o();db=Fb}else{for(var Mb=zg(g,nc),Nb=g;!Nb.g();){var Gb=Nb.n();Mb.ba(bb(Gb));Nb=Nb.o()}db=Mb.da()}$a.ip=db;var Sb=function(a,b){return function(a){return a.y(a,b,"cbounds",a.s)}}(a,$a),Cc=G().b;if(Cc===G().b)if(h===F())var Ob=F();else{for(var Zb=h.n(),Ec=U(new V,Sb(Zb),F()),oc=Ec,pc=h.o();pc!==F();)var qc=pc.n(),Jc=U(new V,Sb(qc),F()),oc=oc.ga=Jc,pc=pc.o();Ob=
Ec}else{for(var Hc=zg(h,Cc),ac=h;!ac.g();){var Lc=ac.n();Hc.ba(Sb(Lc));ac=ac.o()}Ob=Hc.da()}$a.Uo=Ob;return $a}Jz.prototype.$classData=l({XS:0},!1,"scala.meta.Type$Param$",{XS:1,f:1,l:1,k:1});var Iz=void 0;function rY(){}rY.prototype=new m;rY.prototype.constructor=rY;rY.prototype.c=function(){return this};
function Lz(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=rta(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}rY.prototype.$classData=l({YS:0},!1,"scala.meta.Type$Param$Quasi$",{YS:1,f:1,l:1,k:1});var sta=void 0;
function Mz(){sta||(sta=(new rY).c());return sta}function sY(){}sY.prototype=new m;sY.prototype.constructor=sY;sY.prototype.c=function(){return this};
function Faa(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["bounds is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("bounds",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"bounds.!\x3d(null)",c,f.t)}throw(new p).e(a);}a=tta(null,null,null);a.Ij=jA(b,a,b.s);return a}sY.prototype.$classData=l({cT:0},!1,"scala.meta.Type$Placeholder$",{cT:1,f:1,l:1,k:1});var uta=void 0;
function Eaa(){uta||(uta=(new sY).c());return uta}function tY(){}tY.prototype=new m;tY.prototype.constructor=tY;tY.prototype.c=function(){return this};
function cba(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["qual is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("qual",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"qual.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["name is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();
c=[(new q).a("name",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"name.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=vta(null,null,null);a.Hf=b.y(b,a,"qual",b.s);a.Pa=c.y(c,a,"name",c.s);return a}tY.prototype.$classData=l({gT:0},!1,"scala.meta.Type$Project$",{gT:1,f:1,l:1,k:1});var wta=void 0;function bba(){wta||(wta=(new tY).c());return wta}function uY(){}uY.prototype=new m;uY.prototype.constructor=uY;uY.prototype.c=function(){return this};
function bf(a,b,c){if(null!==c)a=(new q).a(!0,F());else{G();a=(new r).d(["tree is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=[(new q).a("tree",c)];for(var f=A(new B,C()),g=0,h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"tree.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=xta(null,null,null,b);a.Ua=c.y(c,a,"tree",c.s);return a}uY.prototype.$classData=l({iT:0},!1,"scala.meta.Type$Quasi$",{iT:1,f:1,l:1,k:1});var yta=void 0;
function cf(){yta||(yta=(new uY).c());return yta}function vY(){}vY.prototype=new m;vY.prototype.constructor=vY;vY.prototype.c=function(){return this};
function Gh(a,b,c){if(null!==b)var d=(new q).a(!0,F());else{G();var d=(new r).d(["tpe is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f))}if(null===d||!0!==I(d)){if(null!==d&&(c=d.p(),!1===I(d))){a=J();b=[(new q).a("tpe",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(a,"tpe.!\x3d(null)",c,f.t)}throw(new p).e(d);}null!==c?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats is equal to null"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){b=
J();c=[(new q).a("stats",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(b,"stats.!\x3d(null)",a,f.t)}throw(new p).e(d);}a:{for(d=c;!d.g();){f=d.n();if(!Mda(hv(f))){d=!1;break a}d=d.o()}d=!0}d?d=(new q).a(!0,F()):(G(),d=(new r).d(["stats.forall(((x$5: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$5).isRefineStat)) is false"]),f=G().b,d=(new q).a(!1,H(d,f)));if(null===d||!0!==I(d)){if(null!==d&&(a=d.p(),!1===I(d))){b=J();c=[(new q).a("stats",c)];
f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(b,"stats.forall(((x$5: scala.meta.Stat) \x3d\x3e scala.meta.internal.trees.`package`.XtensionTreesStat(x$5).isRefineStat))",a,f.t)}throw(new p).e(d);}d=zta(null,null,null);b.g()?b=S():(b=b.q(),b=(new T).e(b.y(b,d,"tpe",b.s)));d.qc=b;a=function(a,b){return function(a){return a.y(a,b,"stats",a.s)}}(a,d);b=G().b;if(b===G().b)if(c===F())c=F();else{b=c.n();f=b=U(new V,a(b),F());for(c=c.o();c!==F();)g=c.n(),g=U(new V,a(g),F()),f=f.ga=g,c=c.o();
c=b}else{for(b=zg(c,b);!c.g();)f=c.n(),b.ba(a(f)),c=c.o();c=b.da()}d.ld=c;return d}vY.prototype.$classData=l({nT:0},!1,"scala.meta.Type$Refine$",{nT:1,f:1,l:1,k:1});var Ata=void 0;function Eh(){Ata||(Ata=(new vY).c());return Ata}function pE(){}pE.prototype=new m;pE.prototype.constructor=pE;pE.prototype.c=function(){return this};pE.prototype.$classData=l({qT:0},!1,"scala.meta.Type$Repeated$",{qT:1,f:1,l:1,k:1});var dha=void 0;function wY(){}wY.prototype=new m;wY.prototype.constructor=wY;
wY.prototype.c=function(){return this};
function Gaa(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["qual is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("qual",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"qual.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["name is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();
c=[(new q).a("name",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"name.!\x3d(null)",b,f.t)}throw(new p).e(a);}wL(au(b))?(d=!0,a=F()):(G(),a=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesTermRef(qual).isPath is false"]),d=G().b,a=H(a,d),d=!1);d?a=(new q).a(!0,F()):(d=v(),y(z(d,b),Gla())?(f=!0,d=F()):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Ref](qual)(scala.meta.Tree.classifiable[scala.meta.Term.Ref]).is[Term.Super](Term.this.Super.ClassifierClass[scala.meta.Term.Ref]) is false"]),
f=G().b,d=H(d,f),f=!1),f?(d=!0,f=F()):(f=v(),f=z(f,b),Cla||(Cla=(new dT).c()),y(f,Cla)?(f=!0,g=F()):(G(),f=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Ref](qual)(scala.meta.Tree.classifiable[scala.meta.Term.Ref]).is[Term.Ref.Quasi](Ref.this.Quasi.ClassifierClass[scala.meta.Term.Ref]) is false"]),g=G().b,g=H(f,g),f=!1),f?(f=F(),d=!0):(f=G(),f=d.ma(g,f.b),d=!1)),d?a=(new q).a(!0,F()):(d=G(),a=(new q).a(!1,a.ma(f,d.b))));if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),
!1===I(a))){d=J();b=[(new q).a("qual",b),(new q).a("Term",mz()),(new q).a("Ref",Csa())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"scala.meta.internal.trees.`package`.XtensionTreesTermRef(qual).isPath.||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Ref](qual)(scala.meta.Tree.classifiable[scala.meta.Term.Ref]).is[Term.Super](Term.this.Super.ClassifierClass[scala.meta.Term.Ref])).||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Ref](qual)(scala.meta.Tree.classifiable[scala.meta.Term.Ref]).is[Term.Ref.Quasi](Ref.this.Quasi.ClassifierClass[scala.meta.Term.Ref]))",
c,f.t)}throw(new p).e(a);}a=Bta(null,null,null);a.Hf=b.y(b,a,"qual",b.s);a.Pa=c.y(c,a,"name",c.s);return a}wY.prototype.$classData=l({tT:0},!1,"scala.meta.Type$Select$",{tT:1,f:1,l:1,k:1});var Cta=void 0;function Haa(){Cta||(Cta=(new wY).c());return Cta}function xY(){}xY.prototype=new m;xY.prototype.constructor=xY;xY.prototype.c=function(){return this};
function Iaa(a,b){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["ref is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){var d=J();b=[(new q).a("ref",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"ref.!\x3d(null)",c,f.t)}throw(new p).e(a);}wL(au(b))?(c=!0,a=F()):(G(),a=(new r).d(["scala.meta.internal.trees.`package`.XtensionTreesTermRef(ref).isPath is false"]),c=G().b,a=H(a,c),c=!1);c?a=(new q).a(!0,F()):
(c=v(),y(z(c,b),Gla())?(c=!0,d=F()):(G(),c=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Ref](ref)(scala.meta.Tree.classifiable[scala.meta.Term.Ref]).is[Term.Super](Term.this.Super.ClassifierClass[scala.meta.Term.Ref]) is false"]),d=G().b,d=H(c,d),c=!1),c?a=(new q).a(!0,F()):(c=G(),a=(new q).a(!1,a.ma(d,c.b))));if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("ref",b),(new q).a("Term",mz())];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,
b[g]),g=1+g|0;K(d,"scala.meta.internal.trees.`package`.XtensionTreesTermRef(ref).isPath.||(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Term.Ref](ref)(scala.meta.Tree.classifiable[scala.meta.Term.Ref]).is[Term.Super](Term.this.Super.ClassifierClass[scala.meta.Term.Ref]))",c,f.t)}throw(new p).e(a);}a=Dta(null,null,null);a.Ah=b.y(b,a,"ref",b.s);return a}xY.prototype.$classData=l({wT:0},!1,"scala.meta.Type$Singleton$",{wT:1,f:1,l:1,k:1});var Eta=void 0;
function Jaa(){Eta||(Eta=(new xY).c());return Eta}function yY(){}yY.prototype=new m;yY.prototype.constructor=yY;yY.prototype.c=function(){return this};
function Ci(a,b){if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["args is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.!\x3d(null)",a,f.t)}throw(new p).e(c);}null!==b?(c=!0,d=F()):(G(),c=(new r).d(["args is equal to null"]),d=G().b,d=H(c,d),c=!1);c?cj(b)?c=(new q).a(!0,F()):(G(),c=(new r).d(["args.nonEmpty is false"]),d=G().b,
c=(new q).a(!1,H(c,d))):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b)];f=A(new B,C());g=0;for(h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.!\x3d(null).\x26\x26(args.nonEmpty)",a,f.t)}throw(new p).e(c);}1<Cg(b)?(d=!0,c=F()):(G(),c=(new r).d(["args.length.\x3e(1) is false"]),d=G().b,c=H(c,d),d=!1);d?c=(new q).a(!0,F()):(1===Cg(b)?(d=!0,f=F()):(G(),d=(new r).d(["args.length is not equal to 1"]),f=G().b,f=H(d,f),d=!1),d?(d=v(),f=b.n(),d=z(d,
f),Lla||(Lla=(new kT).c()),y(d,Lla)?(f=F(),d=!0):(G(),d=(new r).d(["scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Type](args.head)(scala.meta.Tree.classifiable[scala.meta.Type]).is[Type.Quasi](Type.this.Quasi.ClassifierClass[scala.meta.Type]) is false"]),f=G().b,f=H(d,f),d=!1)):d=!1,d?c=(new q).a(!0,F()):(d=G(),c=(new q).a(!1,c.ma(f,d.b))));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("args",b),(new q).a("Type",Ara())];f=A(new B,C());g=0;for(h=b.length|
0;g<h;)E(f,b[g]),g=1+g|0;K(d,"args.length.\x3e(1).||(args.length.\x3d\x3d(1).\x26\x26(scala.meta.classifiers.`package`.XtensionClassifiable[scala.meta.Type](args.head)(scala.meta.Tree.classifiable[scala.meta.Type]).is[Type.Quasi](Type.this.Quasi.ClassifierClass[scala.meta.Type])))",a,f.t)}throw(new p).e(c);}c=Fta(null,null,null);a=function(a,b){return function(a){return a.y(a,b,"args",a.s)}}(a,c);d=G().b;if(d===G().b)if(b===F())b=F();else{d=b.n();f=d=U(new V,a(d),F());for(b=b.o();b!==F();)g=b.n(),
g=U(new V,a(g),F()),f=f.ga=g,b=b.o();b=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(a(f)),b=b.o();b=d.da()}c.fc=b;return c}yY.prototype.$classData=l({AT:0},!1,"scala.meta.Type$Tuple$",{AT:1,f:1,l:1,k:1});var Gta=void 0;function Li(){Gta||(Gta=(new yY).c());return Gta}function ri(){}ri.prototype=new m;ri.prototype.constructor=ri;ri.prototype.c=function(){return this};
function gba(a){if(null!==a)var b=(new q).a(!0,F());else{G();var b=(new r).d(["name is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("name",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"name.!\x3d(null)",c,f.t)}throw(new p).e(b);}b=65535&(a.ec().charCodeAt(0)|0);ii(qi(),b)?b=(new q).a(!0,F()):(G(),b=(new r).d(["scala.Predef.charWrapper(scala.Predef.augmentString(name.value).apply(0)).isLower is false"]),
c=G().b,b=(new q).a(!1,H(b,c)));if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){d=J();a=[(new q).a("name",a)];f=A(new B,C());g=0;for(h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"scala.Predef.charWrapper(scala.Predef.augmentString(name.value).apply(0)).isLower",c,f.t)}throw(new p).e(b);}b=Hta(null,null,null);b.Pa=a.y(a,b,"name",a.s);return b}ri.prototype.$classData=l({ET:0},!1,"scala.meta.Type$Var$",{ET:1,f:1,l:1,k:1});var fba=void 0;function zY(){}zY.prototype=new m;
zY.prototype.constructor=zY;zY.prototype.c=function(){return this};
function Vaa(a,b,c){if(null!==b)a=(new q).a(!0,F());else{G();a=(new r).d(["lhs is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){d=J();b=[(new q).a("lhs",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"lhs.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?a=(new q).a(!0,F()):(G(),a=(new r).d(["rhs is equal to null"]),d=G().b,a=(new q).a(!1,H(a,d)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){d=J();c=
[(new q).a("rhs",c)];f=A(new B,C());g=0;for(h=c.length|0;g<h;)E(f,c[g]),g=1+g|0;K(d,"rhs.!\x3d(null)",b,f.t)}throw(new p).e(a);}a=Ita(null,null,null);a.pc=b.y(b,a,"lhs",b.s);a.Kb=c.y(c,a,"rhs",c.s);return a}zY.prototype.$classData=l({IT:0},!1,"scala.meta.Type$With$",{IT:1,f:1,l:1,k:1});var Jta=void 0;function Waa(){Jta||(Jta=(new zY).c());return Jta}function ux(){this.Il=!1;this.r=null}ux.prototype=new m;ux.prototype.constructor=ux;
ux.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;this.Il=!1;return this};ux.prototype.$classData=l({qY:0},!1,"scala.meta.internal.parsers.ScalametaParser$noSeq$",{qY:1,f:1,KC:1,Gw:1});function HA(){this.Il=!1;this.r=null}HA.prototype=new m;HA.prototype.constructor=HA;HA.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;this.Il=!0;return this};HA.prototype.$classData=l({tY:0},!1,"scala.meta.internal.parsers.ScalametaParser$seqOK$",{tY:1,f:1,KC:1,Gw:1});
function qE(){this.Il=!1;this.r=null}qE.prototype=new m;qE.prototype.constructor=qE;qE.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;this.Il=!0;return this};qE.prototype.$classData=l({vY:0},!1,"scala.meta.internal.parsers.ScalametaParser$xmlSeqOK$",{vY:1,f:1,KC:1,Gw:1});function EH(){this.Xr=this.Pk=this.Wr=this.ps=this.ts=null}EH.prototype=new m;EH.prototype.constructor=EH;function bH(a){null===a.ts&&null===a.ts&&(a.ts=(new AY).Vk(a));return a.ts}
function PG(a){null===a.ps&&null===a.ps&&(a.ps=(new BY).Vk(a));return a.ps}function LG(a){null===a.Xr&&null===a.Xr&&(a.Xr=(new CY).Vk(a));return a.Xr}function mH(a){null===a.Wr&&null===a.Wr&&(a.Wr=(new DY).Vk(a));return a.Wr}EH.prototype.Bu=function(){null===this.Pk&&(this.Pk=(new EY).Vk(this))};function rH(a){null===a.Pk&&a.Bu();return a.Pk}EH.prototype.$classData=l({FY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$",{FY:1,f:1,l:1,k:1});
function DY(){this.r=this.hs=this.as=this.ir=this.$r=this.Zr=this.Yr=null}DY.prototype=new m;DY.prototype.constructor=DY;function nH(a){null===a.Yr&&null===a.Yr&&(a.Yr=(new FY).ak(a));return a.Yr}function qH(a){null===a.Zr&&null===a.Zr&&(a.Zr=(new GY).ak(a));return a.Zr}function aia(a){null===a.ir&&null===a.ir&&(a.ir=(new HY).ak(a));return a.ir}DY.prototype.Vk=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
function pH(a){null===a.as&&null===a.as&&(a.as=(new IY).ak(a));return a.as}function lH(a){null===a.hs&&null===a.hs&&(a.hs=(new JY).ak(a));return a.hs}function $ha(a){null===a.$r&&null===a.$r&&(a.$r=(new KY).ak(a));return a.$r}DY.prototype.$classData=l({HY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$",{HY:1,f:1,l:1,k:1});function IY(){this.r=null}IY.prototype=new m;IY.prototype.constructor=IY;
function oH(a,b){var c=a.r;a=new LY;a.Wd=b;if(null===c)throw jo(wj(),null);a.r=c;null!==b?b=(new q).a(!0,F()):(G(),b=(new r).d(["this.op is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c)));if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("Pattern3",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"this.op.!\x3d(null)",c,f.t)}throw(new p).e(b);}return a}IY.prototype.ak=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
function jia(a,b){return null===b?S():(new T).e(b.Wd)}IY.prototype.$classData=l({MY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$Pattern3$",{MY:1,f:1,l:1,k:1});function BY(){this.r=this.gs=this.fs=this.cs=this.zr=this.bs=this.vr=this.ur=null}BY.prototype=new m;BY.prototype.constructor=BY;function VG(a){null===a.bs&&null===a.bs&&(a.bs=(new MY).Wi(a));return a.bs}function QG(a){null===a.ur&&null===a.ur&&(a.ur=(new NY).Wi(a));return a.ur}
function Uha(a){null===a.cs&&null===a.cs&&(a.cs=(new dZ).Wi(a));return a.cs}BY.prototype.Vk=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};function RG(a){null===a.gs&&null===a.gs&&(a.gs=(new eZ).Wi(a));return a.gs}function UG(a){null===a.vr&&null===a.vr&&(a.vr=(new fZ).Wi(a));return a.vr}function TG(a){null===a.zr&&null===a.zr&&(a.zr=(new gZ).Wi(a));return a.zr}function OG(a){null===a.fs&&null===a.fs&&(a.fs=(new hZ).Wi(a));return a.fs}
BY.prototype.$classData=l({PY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$",{PY:1,f:1,l:1,k:1});function gZ(){this.r=null}gZ.prototype=new m;gZ.prototype.constructor=gZ;function hia(a,b){return null===b?S():(new T).e(b.Wd)}gZ.prototype.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
function SG(a,b){var c=a.r;a=new iZ;a.Wd=b;if(null===c)throw jo(wj(),null);a.r=c;null!==b?b=(new q).a(!0,F()):(G(),b=(new r).d(["this.op is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c)));if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("InfixExpr",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"this.op.!\x3d(null)",c,f.t)}throw(new p).e(b);}return a}
gZ.prototype.$classData=l({SY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$InfixExpr$",{SY:1,f:1,l:1,k:1});function AY(){this.r=this.is=this.gr=this.ws=this.es=this.Ar=this.hr=this.ss=this.Vr=null}AY.prototype=new m;AY.prototype.constructor=AY;function hH(a){null===a.Vr&&null===a.Vr&&(a.Vr=(new jZ).vi(a));return a.Vr}function iH(a){null===a.ws&&null===a.ws&&(a.ws=(new kZ).vi(a));return a.ws}
function cH(a){null===a.ss&&null===a.ss&&(a.ss=(new lZ).vi(a));return a.ss}function Vha(a){null===a.hr&&null===a.hr&&(a.hr=(new mZ).vi(a));return a.hr}AY.prototype.Vk=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};function Xha(a){null===a.gr&&null===a.gr&&(a.gr=(new nZ).vi(a));return a.gr}function eH(a){null===a.Ar&&null===a.Ar&&(a.Ar=(new oZ).vi(a));return a.Ar}function aH(a){null===a.is&&null===a.is&&(a.is=(new pZ).vi(a));return a.is}
function Wha(a){null===a.es&&null===a.es&&(a.es=(new qZ).vi(a));return a.es}AY.prototype.$classData=l({XY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$",{XY:1,f:1,l:1,k:1});function oZ(){this.r=null}oZ.prototype=new m;oZ.prototype.constructor=oZ;oZ.prototype.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};function iia(a,b){return null===b?S():(new T).e(b.Wd)}
function dH(a,b){var c=a.r;a=new rZ;a.Wd=b;if(null===c)throw jo(wj(),null);a.r=c;null!==b?b=(new q).a(!0,F()):(G(),b=(new r).d(["this.op is equal to null"]),c=G().b,b=(new q).a(!1,H(b,c)));if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("InfixTyp",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"this.op.!\x3d(null)",c,f.t)}throw(new p).e(b);}return a}
oZ.prototype.$classData=l({$Y:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$InfixTyp$",{$Y:1,f:1,l:1,k:1});function sZ(){DI.call(this);this.Lb=null}sZ.prototype=new Wla;sZ.prototype.constructor=sZ;function tI(a){var b=new sZ;if(null===a)throw jo(wj(),null);b.Lb=a;DI.prototype.bB.call(b,a.NE,a.Gt,a.Fo);b.kc=a.kc;b.Ha=a.Ha;return b}function yI(a){aI(a);return a.Ha}
sZ.prototype.$classData=l({jZ:0},!1,"scala.meta.internal.tokenizers.CharArrayReader$CharArrayLookaheadReader",{jZ:1,QC:1,f:1,kZ:1});function tZ(){}tZ.prototype=new m;tZ.prototype.constructor=tZ;tZ.prototype.c=function(){return this};function oG(a,b){return null===b?S():(new T).e((new yi).sd(b.u,b.Q,b.cg))}tZ.prototype.$classData=l({EZ:0},!1,"scala.meta.internal.trees.Origin$Parsed$",{EZ:1,f:1,l:1,k:1});var Kta=void 0;function pG(){Kta||(Kta=(new tZ).c());return Kta}function uZ(){}uZ.prototype=new m;
uZ.prototype.constructor=uZ;uZ.prototype.c=function(){return this};function sga(a,b){return null===b?S():(new T).e((new q).a(b.kn,b.xn))}uZ.prototype.$classData=l({b_:0},!1,"scala.meta.parsers.ParseException$",{b_:1,f:1,l:1,k:1});var Lta=void 0;function tga(){Lta||(Lta=(new uZ).c());return Lta}function vZ(){}vZ.prototype=new m;vZ.prototype.constructor=vZ;vZ.prototype.c=function(){return this};function mo(a,b){return null===b?S():(new T).e((new yi).sd(b.cg,b.$m,b.yk))}
vZ.prototype.$classData=l({d_:0},!1,"scala.meta.parsers.Parsed$Error$",{d_:1,f:1,l:1,k:1});var Mta=void 0;function lja(){Mta||(Mta=(new vZ).c());return Mta}function wZ(){}wZ.prototype=new m;wZ.prototype.constructor=wZ;wZ.prototype.c=function(){return this};function bo(a,b){return null===b?S():(new T).e(b.Xc)}wZ.prototype.$classData=l({e_:0},!1,"scala.meta.parsers.Parsed$Success$",{e_:1,f:1,l:1,k:1});var Nta=void 0;function jja(){Nta||(Nta=(new wZ).c());return Nta}function FF(){this.lg=null}
FF.prototype=new m;FF.prototype.constructor=FF;FF.prototype.N=function(a){return this.lg.Ea(a)};FF.prototype.te=function(a){this.lg=a;return this};FF.prototype.$classData=l({m_:0},!1,"scala.meta.prettyprinters.Structure$$anon$1",{m_:1,f:1,F6:1,XC:1});function PF(){this.lg=null}PF.prototype=new m;PF.prototype.constructor=PF;PF.prototype.N=function(a){return this.lg.Ea(a)};PF.prototype.te=function(a){this.lg=a;return this};
PF.prototype.$classData=l({n_:0},!1,"scala.meta.prettyprinters.Syntax$$anon$1",{n_:1,f:1,G6:1,XC:1});function xZ(){}xZ.prototype=new m;xZ.prototype.constructor=xZ;xZ.prototype.c=function(){return this};function uC(a,b){return null===b?S():(new T).e((new q).a(b.kn,b.xn))}xZ.prototype.$classData=l({u_:0},!1,"scala.meta.tokenizers.TokenizeException$",{u_:1,f:1,l:1,k:1});var Ota=void 0;function vC(){Ota||(Ota=(new xZ).c());return Ota}function bA(){}bA.prototype=new m;bA.prototype.constructor=bA;
bA.prototype.c=function(){return this};bA.prototype.$classData=l({w_:0},!1,"scala.meta.tokenizers.Tokenized$Error$",{w_:1,f:1,l:1,k:1});var Gfa=void 0;function yZ(){}yZ.prototype=new m;yZ.prototype.constructor=yZ;yZ.prototype.c=function(){return this};function Efa(a,b){return null===b?S():(new T).e(b.jl)}yZ.prototype.$classData=l({x_:0},!1,"scala.meta.tokenizers.Tokenized$Success$",{x_:1,f:1,l:1,k:1});var Pta=void 0;function Ffa(){Pta||(Pta=(new yZ).c());return Pta}function zZ(){}zZ.prototype=new m;
zZ.prototype.constructor=zZ;zZ.prototype.c=function(){return this};zZ.prototype.$classData=l({z_:0},!1,"scala.meta.tokens.Token$",{z_:1,f:1,l:1,k:1});var Qta=void 0;function Sf(){Qta||(Qta=(new zZ).c());return Qta}function AZ(){}AZ.prototype=new m;AZ.prototype.constructor=AZ;AZ.prototype.c=function(){return this};function xt(a,b){return null===b?S():(new T).e((new ed).db(b.pa))}AZ.prototype.$classData=l({G_:0},!1,"scala.meta.tokens.Token$Constant$Char$",{G_:1,f:1,l:1,k:1});var Rta=void 0;
function yt(){Rta||(Rta=(new AZ).c());return Rta}function BZ(){}BZ.prototype=new m;BZ.prototype.constructor=BZ;BZ.prototype.c=function(){return this};function rt(a,b){return null===b?S():(new T).e(b.pa)}BZ.prototype.$classData=l({H_:0},!1,"scala.meta.tokens.Token$Constant$Double$",{H_:1,f:1,l:1,k:1});var Sta=void 0;function st(){Sta||(Sta=(new BZ).c());return Sta}function CZ(){}CZ.prototype=new m;CZ.prototype.constructor=CZ;CZ.prototype.c=function(){return this};
function kt(a,b){return null===b?S():(new T).e(b.pa)}CZ.prototype.$classData=l({I_:0},!1,"scala.meta.tokens.Token$Constant$Float$",{I_:1,f:1,l:1,k:1});var Tta=void 0;function lt(){Tta||(Tta=(new CZ).c());return Tta}function DZ(){}DZ.prototype=new m;DZ.prototype.constructor=DZ;DZ.prototype.c=function(){return this};function Ys(a,b){return null===b?S():(new T).e(b.pa)}DZ.prototype.$classData=l({J_:0},!1,"scala.meta.tokens.Token$Constant$Int$",{J_:1,f:1,l:1,k:1});var Uta=void 0;
function Zs(){Uta||(Uta=(new DZ).c());return Uta}function EZ(){}EZ.prototype=new m;EZ.prototype.constructor=EZ;EZ.prototype.c=function(){return this};function et(a,b){return null===b?S():(new T).e(b.pa)}EZ.prototype.$classData=l({K_:0},!1,"scala.meta.tokens.Token$Constant$Long$",{K_:1,f:1,l:1,k:1});var Vta=void 0;function ft(){Vta||(Vta=(new EZ).c());return Vta}function FZ(){}FZ.prototype=new m;FZ.prototype.constructor=FZ;FZ.prototype.c=function(){return this};
function Bt(a,b){return null===b?S():(new T).e(b.pa)}FZ.prototype.$classData=l({L_:0},!1,"scala.meta.tokens.Token$Constant$String$",{L_:1,f:1,l:1,k:1});var Wta=void 0;function Ct(){Wta||(Wta=(new FZ).c());return Wta}function GZ(){}GZ.prototype=new m;GZ.prototype.constructor=GZ;GZ.prototype.c=function(){return this};function Gt(a,b){return null===b?S():(new T).e(b.pa)}GZ.prototype.$classData=l({M_:0},!1,"scala.meta.tokens.Token$Constant$Symbol$",{M_:1,f:1,l:1,k:1});var Xta=void 0;
function Ht(){Xta||(Xta=(new GZ).c());return Xta}function HZ(){}HZ.prototype=new m;HZ.prototype.constructor=HZ;HZ.prototype.c=function(){return this};function Yf(a,b){return null===b?S():(new T).e(b.Hb)}HZ.prototype.$classData=l({P_:0},!1,"scala.meta.tokens.Token$Ellipsis$",{P_:1,f:1,l:1,k:1});var Yta=void 0;function Zf(){Yta||(Yta=(new HZ).c());return Yta}function IZ(){}IZ.prototype=new m;IZ.prototype.constructor=IZ;IZ.prototype.c=function(){return this};
function ig(a,b){return null===b?S():(new T).e(b.pa)}IZ.prototype.$classData=l({U_:0},!1,"scala.meta.tokens.Token$Ident$",{U_:1,f:1,l:1,k:1});var Zta=void 0;function jg(){Zta||(Zta=(new IZ).c());return Zta}function JZ(){}JZ.prototype=new m;JZ.prototype.constructor=JZ;JZ.prototype.c=function(){return this};function Ov(a,b){return null===b?S():(new T).e(b.pa)}JZ.prototype.$classData=l({X_:0},!1,"scala.meta.tokens.Token$Interpolation$Id$",{X_:1,f:1,l:1,k:1});var $ta=void 0;
function Pv(){$ta||($ta=(new JZ).c());return $ta}function KZ(){}KZ.prototype=new m;KZ.prototype.constructor=KZ;KZ.prototype.c=function(){return this};function Tv(a,b){return null===b?S():(new T).e(b.pa)}KZ.prototype.$classData=l({Z_:0},!1,"scala.meta.tokens.Token$Interpolation$Part$",{Z_:1,f:1,l:1,k:1});var aua=void 0;function Uv(){aua||(aua=(new KZ).c());return aua}function SZ(){}SZ.prototype=new m;SZ.prototype.constructor=SZ;SZ.prototype.c=function(){return this};
function Wv(a,b){return null===b?S():(new T).e(b.pa)}SZ.prototype.$classData=l({c1:0},!1,"scala.meta.tokens.Token$Xml$Part$",{c1:1,f:1,l:1,k:1});var bua=void 0;function Xv(){bua||(bua=(new SZ).c());return bua}function d_(){}d_.prototype=new m;d_.prototype.constructor=d_;
d_.prototype.c=function(){cua=this;lk(function(){return function(a){pC();var b=Se();YD();var c=wk().mb,c=Dha().If(c);a=yg(b,a,c).be();return(new pT).j(a)}}(this));lk(function(){return function(a){pC();var b=Se();YD();var c=Cg(a),c=oa(bc(XD),[c]);Id(a,c,0);a=Cg(a);a=ZD(c,0,a);YD();c=wk().mb;c=Dha().If(c);b=yg(b,a,c).be();return(new pT).j(b)}}(this));return this};d_.prototype.$classData=l({e1:0},!1,"scala.meta.tokens.Tokens$",{e1:1,f:1,l:1,k:1});var cua=void 0;
function YD(){cua||(cua=(new d_).c())}function z_(){}z_.prototype=new m;z_.prototype.constructor=z_;z_.prototype.c=function(){return this};function dua(a,b){return b===k(rc)?BN():b===k(vc)?CN():b===k(jc)?DN():b===k(yc)?EN():b===k(zc)?FN():b===k(Gc)?GN():b===k(Ic)?HN():b===k(ic)?IN():b===k(cc)?JN():b===k(Ab)?wI():b===k(A_)?Jja():b===k(XP)?Kja():(new mv).Ud(b)}z_.prototype.$classData=l({i1:0},!1,"scala.reflect.ClassTag$",{i1:1,f:1,l:1,k:1});var eua=void 0;
function fua(){eua||(eua=(new z_).c());return eua}function wN(){}wN.prototype=new m;wN.prototype.constructor=wN;wN.prototype.c=function(){return this};wN.prototype.$classData=l({E1:0},!1,"scala.util.Either$",{E1:1,f:1,l:1,k:1});var Eja=void 0;function xN(){}xN.prototype=new m;xN.prototype.constructor=xN;xN.prototype.c=function(){return this};xN.prototype.v=function(){return"Left"};xN.prototype.$classData=l({F1:0},!1,"scala.util.Left$",{F1:1,f:1,l:1,k:1});var Fja=void 0;function yN(){}
yN.prototype=new m;yN.prototype.constructor=yN;yN.prototype.c=function(){return this};yN.prototype.v=function(){return"Right"};yN.prototype.$classData=l({G1:0},!1,"scala.util.Right$",{G1:1,f:1,l:1,k:1});var Gja=void 0;function B_(){this.eu=!1}B_.prototype=new m;B_.prototype.constructor=B_;B_.prototype.c=function(){this.eu=!1;return this};B_.prototype.$classData=l({J1:0},!1,"scala.util.control.NoStackTrace$",{J1:1,f:1,l:1,k:1});var gua=void 0;function hua(){gua||(gua=(new B_).c());return gua}
function C_(){this.r=null}C_.prototype=new cV;C_.prototype.constructor=C_;C_.prototype.c=function(){bV.prototype.Yp.call(this,vk());return this};C_.prototype.mj=function(){vk();Rs();uk();return(new Hk).c()};C_.prototype.$classData=l({Q1:0},!1,"scala.collection.IndexedSeq$$anon$1",{Q1:1,jx:1,f:1,Go:1});function D_(){}D_.prototype=new m;D_.prototype.constructor=D_;D_.prototype.c=function(){return this};D_.prototype.$classData=l({h2:0},!1,"scala.collection.convert.WrapAsScala$",{h2:1,f:1,$6:1,Z6:1});
var iua=void 0;function E_(){this.b=null}E_.prototype=new $U;E_.prototype.constructor=E_;function jua(){}jua.prototype=E_.prototype;function aV(){this.Lb=this.r=null}aV.prototype=new cV;aV.prototype.constructor=aV;aV.prototype.mj=function(){return this.Lb.ic()};aV.prototype.Yp=function(a){if(null===a)throw jo(wj(),null);this.Lb=a;bV.prototype.Yp.call(this,a);return this};aV.prototype.$classData=l({p2:0},!1,"scala.collection.generic.GenTraversableFactory$$anon$1",{p2:1,jx:1,f:1,Go:1});
function F_(){}F_.prototype=new Loa;F_.prototype.constructor=F_;function kua(){}kua.prototype=F_.prototype;function iN(){}iN.prototype=new m;iN.prototype.constructor=iN;iN.prototype.c=function(){return this};iN.prototype.v=function(){return"::"};iN.prototype.$classData=l({s2:0},!1,"scala.collection.immutable.$colon$colon$",{s2:1,f:1,l:1,k:1});var wja=void 0;function G_(){}G_.prototype=new m;G_.prototype.constructor=G_;
G_.prototype.c=function(){lua=this;var a;mua||(mua=(new H_).c());a=mua;nua||(nua=(new I_).c());a=(new q).a(a,nua);var b;oua||(oua=(new J_).c());b=oua;pua||(pua=(new K_).c());b=(new q).a(b,pua);var c;qua||(qua=(new L_).c());c=qua;rua||(rua=(new M_).c());c=(new q).a(c,rua);var d=sua(),f=rQ(),d=(new q).a(d,f);tua||(tua=(new N_).c());f=tua;uua||(uua=(new O_).c());a=[a,b,c,d,(new q).a(f,uua)];b=A(new B,C());c=0;for(d=a.length|0;c<d;)E(b,a[c]),c=1+c|0;return this};
function P_(a,b,c){if(0<b.Ie(a,c))throw(new t).j("More than Int.MaxValue elements.");return a}G_.prototype.$classData=l({V2:0},!1,"scala.collection.immutable.NumericRange$",{V2:1,f:1,l:1,k:1});var lua=void 0;function Q_(){lua||(lua=(new G_).c())}function R_(){}R_.prototype=new m;R_.prototype.constructor=R_;R_.prototype.c=function(){return this};function S_(a,b,c,d,f){throw(new t).j(b+(f?" to ":" until ")+c+" by "+d+": seqs cannot contain more than Int.MaxValue elements.");}
R_.prototype.$classData=l({Y2:0},!1,"scala.collection.immutable.Range$",{Y2:1,f:1,l:1,k:1});var vua=void 0;function qN(){vua||(vua=(new R_).c());return vua}function T_(){this.r=null}T_.prototype=new cV;T_.prototype.constructor=T_;T_.prototype.c=function(){bV.prototype.Yp.call(this,nN());return this};T_.prototype.$classData=l({l3:0},!1,"scala.collection.immutable.Stream$StreamCanBuildFrom",{l3:1,jx:1,f:1,Go:1});function pN(){}pN.prototype=new m;pN.prototype.constructor=pN;pN.prototype.c=function(){return this};
pN.prototype.$classData=l({k4:0},!1,"scala.collection.mutable.StringBuilder$",{k4:1,f:1,l:1,k:1});var yja=void 0;function U_(){fR.call(this);this.ix=null}U_.prototype=new hla;U_.prototype.constructor=U_;
U_.prototype.c=function(){var a=(new r).d(["UTF8","unicode-1-1-utf-8"]),b=a.Da.length|0,b=oa(bc(sa),[b]),c;c=0;for(a=Cp(new Dp,a,a.Da.length|0);a.fb();){var d=a.bb();b.i[c]=d;c=1+c|0}fR.prototype.MI.call(this,"UTF-8");V_=this;this.ix=Sp(Tp(),-1,(new r).d([-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,
2,2,2,2,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,-1,-1,-1,-1,-1,-1,-1,-1]));return this};U_.prototype.$classData=l({t4:0},!1,"scala.scalajs.niocharset.UTF_8$",{t4:1,MH:1,f:1,xf:1});var V_=void 0;function kV(){V_||(V_=(new U_).c());return V_}function W_(){this.Ih=null}W_.prototype=new Uoa;W_.prototype.constructor=W_;function OO(a){return(0,a.Ih)()}function Rq(a){var b=new W_;b.Ih=a;return b}W_.prototype.$classData=l({w4:0},!1,"scala.scalajs.runtime.AnonFunction0",{w4:1,l7:1,f:1,X4:1});
function X_(){this.Ih=null}X_.prototype=new qV;X_.prototype.constructor=X_;X_.prototype.Ea=function(a){return(0,this.Ih)(a)};function lk(a){var b=new X_;b.Ih=a;return b}X_.prototype.$classData=l({x4:0},!1,"scala.scalajs.runtime.AnonFunction1",{x4:1,zx:1,f:1,Mb:1});function Y_(){this.Ih=null}Y_.prototype=new sV;Y_.prototype.constructor=Y_;function Wm(a){var b=new Y_;b.Ih=a;return b}Y_.prototype.ug=function(a,b){return(0,this.Ih)(a,b)};
Y_.prototype.$classData=l({y4:0},!1,"scala.scalajs.runtime.AnonFunction2",{y4:1,Lt:1,f:1,xr:1});function Z_(){this.Ih=null}Z_.prototype=new uV;Z_.prototype.constructor=Z_;function Wka(a){var b=new Z_;b.Ih=a;return b}Z_.prototype.tp=function(a,b,c){return(0,this.Ih)(a,b,c)};Z_.prototype.$classData=l({z4:0},!1,"scala.scalajs.runtime.AnonFunction3",{z4:1,Mt:1,f:1,yr:1});function $_(){this.dd=0;this.Uj=null}$_.prototype=new m;$_.prototype.constructor=$_;
$_.prototype.c=function(){a0=this;this.Uj=(new Ep).K(0,0);return this};function wua(a,b,c){return 0===(-2097152&c)?""+(4294967296*c+ +(b>>>0)):xua(a,b,c,1E9,0,2)}
function Fp(a,b,c,d,f){if(0===(d|f))throw(new HV).j("/ by zero");if(c===b>>31){if(f===d>>31){if(-2147483648===b&&-1===d)return a.dd=0,-2147483648;var g=b/d|0;a.dd=g>>31;return g}return-2147483648===b&&-2147483648===d&&0===f?a.dd=-1:a.dd=0}if(g=0>c){var h=-b|0;c=0!==b?~c:-c|0}else h=b;if(b=0>f){var n=-d|0;d=0!==d?~f:-f|0}else n=d,d=f;h=yua(a,h,c,n,d);if(g===b)return h;g=a.dd;a.dd=0!==h?~g:-g|0;return-h|0}
function sM(a,b,c){return 0>c?-(4294967296*+((0!==b?~c:-c|0)>>>0)+ +((-b|0)>>>0)):4294967296*c+ +(b>>>0)}function gQ(a,b){if(-9223372036854775808>b)return a.dd=-2147483648,0;if(0x7fffffffffffffff<=b)return a.dd=2147483647,-1;var c=b|0,d=b/4294967296|0;a.dd=0>b&&0!==c?-1+d|0:d;return c}
function yua(a,b,c,d,f){return 0===(-2097152&c)?0===(-2097152&f)?(c=(4294967296*c+ +(b>>>0))/(4294967296*f+ +(d>>>0)),a.dd=c/4294967296|0,c|0):a.dd=0:0===f&&0===(d&(-1+d|0))?(d=31-ha(d)|0,a.dd=c>>>d|0,b>>>d|0|c<<1<<(31-d|0)):0===d&&0===(f&(-1+f|0))?(b=31-ha(f)|0,a.dd=0,c>>>b|0):xua(a,b,c,d,f,0)|0}function Hp(a,b,c,d,f){if(0===(d|f))throw(new HV).j("/ by zero");return 0===c?0===f?(a.dd=0,+(b>>>0)/+(d>>>0)|0):a.dd=0:yua(a,b,c,d,f)}
function tH(a,b,c){return c===b>>31?""+b:0>c?"-"+wua(a,-b|0,0!==b?~c:-c|0):wua(a,b,c)}
function xua(a,b,c,d,f,g){var h=(0!==f?ha(f):32+ha(d)|0)-(0!==c?ha(c):32+ha(b)|0)|0,n=h,u=0===(32&n)?d<<n:0,w=0===(32&n)?(d>>>1|0)>>>(31-n|0)|0|f<<n:d<<n,n=b,D=c;for(b=c=0;0<=h&&0!==(-2097152&D);){var N=n,Q=D,ea=u,ba=w;if(Q===ba?(-2147483648^N)>=(-2147483648^ea):(-2147483648^Q)>=(-2147483648^ba))N=D,Q=w,D=n-u|0,N=(-2147483648^D)>(-2147483648^n)?-1+(N-Q|0)|0:N-Q|0,n=D,D=N,32>h?c|=1<<h:b|=1<<h;h=-1+h|0;N=w>>>1|0;u=u>>>1|0|w<<31;w=N}h=D;if(h===f?(-2147483648^n)>=(-2147483648^d):(-2147483648^h)>=(-2147483648^
f))h=4294967296*D+ +(n>>>0),d=4294967296*f+ +(d>>>0),1!==g&&(w=h/d,f=w/4294967296|0,u=c,c=w=u+(w|0)|0,b=(-2147483648^w)<(-2147483648^u)?1+(b+f|0)|0:b+f|0),0!==g&&(d=h%d,n=d|0,D=d/4294967296|0);if(0===g)return a.dd=b,c;if(1===g)return a.dd=D,n;a=""+n;return""+(4294967296*b+ +(c>>>0))+"000000000".substring(a.length|0)+a}
function lq(a,b,c,d,f){if(0===(d|f))throw(new HV).j("/ by zero");if(c===b>>31){if(f===d>>31){if(-1!==d){var g=b%d|0;a.dd=g>>31;return g}return a.dd=0}if(-2147483648===b&&-2147483648===d&&0===f)return a.dd=0;a.dd=c;return b}if(g=0>c){var h=-b|0;c=0!==b?~c:-c|0}else h=b;0>f?(b=-d|0,d=0!==d?~f:-f|0):(b=d,d=f);f=c;0===(-2097152&f)?0===(-2097152&d)?(h=(4294967296*f+ +(h>>>0))%(4294967296*d+ +(b>>>0)),a.dd=h/4294967296|0,h|=0):a.dd=f:0===d&&0===(b&(-1+b|0))?(a.dd=0,h&=-1+b|0):0===b&&0===(d&(-1+d|0))?a.dd=
f&(-1+d|0):h=xua(a,h,f,b,d,1)|0;return g?(g=a.dd,a.dd=0!==h?~g:-g|0,-h|0):h}$_.prototype.$classData=l({B4:0},!1,"scala.scalajs.runtime.RuntimeLong$",{B4:1,f:1,l:1,k:1});var a0=void 0;function ab(){a0||(a0=(new $_).c());return a0}function b0(){}b0.prototype=new m;b0.prototype.constructor=b0;function c0(){}c0.prototype=b0.prototype;b0.prototype.Ea=function(a){return this.Vh(a,fs().JA)};b0.prototype.xq=function(a){return es(this,a)};b0.prototype.v=function(){return"\x3cfunction1\x3e"};
b0.prototype.hq=function(){return d0(this)};function ik(){this.Hg=!1;this.Ab=null}ik.prototype=new m;ik.prototype.constructor=ik;ik.prototype.c=function(){return this};ik.prototype.v=function(){return td((new yd).X((new r).d(["LazyRef ",""])),(new r).d([this.Hg?td((new yd).X((new r).d(["of: ",""])),(new r).d([this.Ab])):"thunk"]))};function hk(a,b){a.Ab=b;a.Hg=!0;return b}ik.prototype.$classData=l({L4:0},!1,"scala.runtime.LazyRef",{L4:1,f:1,l:1,k:1});
var A_=l({M4:0},!1,"scala.runtime.Nothing$",{M4:1,vd:1,f:1,k:1});function Qn(){Rn.call(this);this.Jh=this.OB=null}Qn.prototype=new jR;Qn.prototype.constructor=Qn;Qn.prototype.Em=function(){return hua().eu?Rn.prototype.Em.call(this):this};Qn.prototype.Ak=function(){var a=(new cd).j(this.Jh.Y),a=WV(a,46),b=G().b.mj(),c=a.i.length;switch(c){case -1:break;default:b.je(c)}b.$c((new e0).Bk(a));return"\n\n\n  "+zua(Aua(Bua(b.da()),2),1).n()+":"+this.OB.Y+"\n\n"};
Qn.prototype.$classData=l({wG:0},!1,"ch.epfl.scala.accessible.Describe$__TODO__",{wG:1,vd:1,f:1,k:1,DE:1});function BQ(){this.fG=this.Af=null;this.eC=!1;this.fC=null}BQ.prototype=new AV;BQ.prototype.constructor=BQ;function Cua(){}Cua.prototype=BQ.prototype;function Dua(a,b){return a.eC?a.fG.la(b):!!a.fC.Ea(b)}
BQ.prototype.Kv=function(a,b,c){wQ.prototype.Ne.call(this,c);if(JL(a)){c=a.Y;mca||(mca=(new fp).c());CV();b=(new Fd).c();c.FI(gla(b));c=rQ();c=Rja(b,c);c=null===c?0:c.pa;for(var d=rQ(),d=Sja(b,d),d=null===d?0:d.pa,f=d-c|0,f=oa(bc(yc),[1+(f/32|0)|0]),g=0;g<b.kd;){var h=f0(b,g),n=((null===h?0:h.pa)-c|0)>>5;f.i[n]|=1<<(31&((null===h?0:h.pa)-c|0));g=1+g|0}b=(new yi).sd(c,d,f);if(null===b)throw(new p).e(b);c=b.Bb|0;d=b.qb|0;f=new dR;f.Wz=b.Eb;f.ov=c;f.lo=d;b=f}else if(ML(a))b=null;else throw(new p).e(a);
this.fG=b;this.eC=a.kB();if(JL(a))a=null;else if(ML(a))a=a.Y;else throw(new p).e(a);this.fC=a;return this};function g0(){Rn.call(this)}g0.prototype=new eW;g0.prototype.constructor=g0;function Eua(){}Eua.prototype=g0.prototype;function h0(){}h0.prototype=new m;h0.prototype.constructor=h0;function Fua(){}Fua.prototype=h0.prototype;h0.prototype.Es=function(){};function hj(){this.rm=null;this.wh=0;this.ll=null;this.wf=0;this.Xe=ab().Uj;this.nl=this.tc=0}hj.prototype=new hR;hj.prototype.constructor=hj;
e=hj.prototype;e.bi=function(){return-64>=this.tc||this.tc>IW(this)?ab().Uj:i0(this).bi()};e.c=function(){this.rm=null;this.wf=this.wh=0;this.Xe=ab().Uj;this.nl=this.tc=0;return this};function j0(a,b){var c=a.tc,d=c>>31,f=-c|0,c=0!==c?~d:-d|0,g=IW(a),d=g>>31,g=f+g|0,f=(-2147483648^g)<(-2147483648^f)?1+(c+d|0)|0:c+d|0;if(0===f?-2147483629<(-2147483648^g):0<f)throw(new HV).j("Rounding necessary");a=Gua(a);if(wp(zp(),a)<b)return a.bi();throw(new HV).j("Rounding necessary");}
e.w=function(a){if(a&&a.$classData&&a.$classData.H.fz&&a.tc===this.tc){if(64>this.wf){a=a.Xe;var b=a.Ya,c=this.Xe;return a.Ra===c.Ra&&b===c.Ya}return Mka(ej(),this.ll,a.ll)}return!1};function Hua(a){if(0===a.wf){a=a.Xe;var b=a.Ya;return!(-1===a.Ra&&-1===b)}return!1}
function Iua(a){if(Hua(a))return a;var b=-1+Lp().pl.i.length|0,c=1,d=JW(a),f=a=a.tc;a>>=31;a:for(;;){if(!LW(d,0)){var g=Jua(d,Lp().pl.i[c]);if(0===g.lt.oc){var d=g.kt,h=c,g=h>>31,n=a;a=f-h|0;f=(-2147483648^a)>(-2147483648^f)?-1+(n-g|0)|0:n-g|0;c=c<b?1+c|0:c;g=f;f=a;a=g;continue a}if(1!==c){c=1;continue a}}c=f;b=d;c=(new Ep).K(c,a);break}c=Ya(c);d=Ya((new Ep).K(c.Ra,c.Ya));c=d.Ra;d=d.Ya;return(new hj).Ns(b,IV(GV(),(new Ep).K(c,d)))}
e.Ns=function(a,b){hj.prototype.c.call(this);if(null===a)throw(new fk).j("unscaledVal \x3d\x3d null");this.tc=b;Upa(this,a);return this};
e.v=function(){if(null!==this.rm)return this.rm;if(32>this.wf)return this.rm=uca(Ip(),this.Xe,this.tc);var a=JW(this),b=Gp(Ip(),a);if(0===this.tc)return b;var c=0>JW(this).oc?2:1,d=b.length|0,f=this.tc,g=f>>31,a=-f|0,g=0!==f?~g:-g|0,h=d>>31,f=a+d|0,g=(-2147483648^f)<(-2147483648^a)?1+(g+h|0)|0:g+h|0,h=c>>31,a=f-c|0,f=(-2147483648^a)>(-2147483648^f)?-1+(g-h|0)|0:g-h|0;if(0<this.tc&&(-1===f?2147483642<=(-2147483648^a):-1<f))if(0<=f)GV(),a=d-this.tc|0,GV(),a=b.substring(0,a)+"."+b.substring(a);else{GV();
GV();d=-1+c|0;GV();b=b.substring(0,d)+"0."+b.substring(d);c=1+c|0;d=GV().oB;f=(new ql).c();g=!0;rl(f,"");for(var h=0,n=d.i.length;h<n;){var u=(new ed).db(d.i[h]);g?(sl(f,u),g=!1):(rl(f,""),sl(f,u));h=1+h|0}rl(f,"");d=f.Qb.ac;a=-1-a|0;GV();a=d.substring(0,a);a=""+b.substring(0,c)+a+b.substring(c)}else b=(1<=(d-c|0)?(GV(),GV(),b.substring(0,c)+"."+b.substring(c)):b)+"E",a=((0===f?0!==a:0<f)?b+"+":b)+tH(ab(),a,f);return this.rm=a};
function k0(a){if(64>a.wf){if(0>a.Xe.Ya)return-1;var b=a.Xe;a=b.Ra;b=b.Ya;return(0===b?0!==a:0<b)?1:0}return JW(a).oc}e.K=function(a,b){hj.prototype.c.call(this);this.Xe=(new Ep).K(a,a>>31);this.tc=b;GV();this.wf=32-ha(0>a?~a:a)|0;return this};function i0(a){if(0===a.tc||Hua(a))return JW(a);if(0>a.tc){var b=JW(a),c=Lp();a=a.tc;var d=a>>31;return eq(b,jq(c,(new Ep).K(-a|0,0!==a?~d:-d|0)))}b=JW(a);c=Lp();a=a.tc;return Tpa(b,jq(c,(new Ep).K(a,a>>31)))}
function Kua(a,b){var c=a.tc,d=c>>31,f=b>>31;b=c-b|0;c=(-2147483648^b)>(-2147483648^c)?-1+(d-f|0)|0:d-f|0;return 64>a.wf?(d=a.Xe,f=d.Ya,0===d.Ra&&0===f?(a=GV(),b=(new Ep).K(b,c),c=b.Ra,a=b.Ra===c&&b.Ya===c>>31?fpa(a,ab().Uj,b.Ra):0<=b.Ya?(new hj).K(0,2147483647):(new hj).K(0,-2147483648)):a=fpa(GV(),a.Xe,IV(GV(),(new Ep).K(b,c))),a):(new hj).Ns(JW(a),IV(GV(),(new Ep).K(b,c)))}
function qj(a){if(0===a.nl){if(0===a.wf)var b=1;else if(64>a.wf){var c=a.Xe;if(0===c.Ra&&-2147483648===c.Ya)b=19;else{Qr();b=GV().lp;if(0>c.Ya)var d=c.Ra,c=c.Ya,d=(new Ep).K(-d|0,0!==d?~c:-c|0);else d=c;b:{var c=0,f=b.i.length;for(;;){if(c===f){b=-1-c|0;break b}var g=(c+f|0)>>>1|0,h=b.i[g],n=Ya(h),u=n.Ra,n=n.Ya,w=d.Ya;if(w===n?(-2147483648^d.Ra)<(-2147483648^u):w<n)f=g;else{if(dj(ej(),d,h)){b=g;break b}c=1+g|0}}}b=0>b?-1-b|0:1+b|0}}else b=1+Sa(.3010299956639812*(-1+a.wf|0))|0,d=JW(a),c=Lp(),b=0!==
Tpa(d,jq(c,(new Ep).K(b,b>>31))).oc?1+b|0:b;a.nl=b}return a.nl}function Gua(a){if(0===a.tc||Hua(a))return JW(a);if(0>a.tc){var b=JW(a),c=Lp();a=a.tc;var d=a>>31;return eq(b,jq(c,(new Ep).K(-a|0,0!==a?~d:-d|0)))}if(a.tc>IW(a)||a.tc>l0(JW(a)))throw(new HV).j("Rounding necessary");b=JW(a);c=Lp();a=a.tc;a=Qpa(b,jq(c,(new Ep).K(a,a>>31)));if(0!==a.i[1].oc)throw(new HV).j("Rounding necessary");return a.i[0]}function Upa(a,b){a.ll=b;a.wf=wp(zp(),b);64>a.wf&&(a.Xe=b.bi())}
function IW(a){return 0<a.nl?a.nl:1+Sa(.3010299956639812*(-1+a.wf|0))|0}
e.oj=function(){var a=k0(this),b=this.wf,c=b>>31,d=ab(),f=gQ(d,this.tc/.3010299956639812),d=d.dd,f=b-f|0,b=(-2147483648^f)>(-2147483648^b)?-1+(c-d|0)|0:c-d|0;if((-1===b?2147482574>(-2147483648^f):-1>b)||0===a)return 0*a;if(0===b?-2147482623<(-2147483648^f):0<b)return Infinity*a;c=Spa(JW(this));b=1076;if(0>=this.tc)f=Lp(),d=-this.tc|0,d=eq(c,jq(f,(new Ep).K(d,d>>31)));else{var d=Lp(),g=this.tc,d=jq(d,(new Ep).K(g,g>>31)),f=100-f|0;0<f?(b=b-f|0,f=iq(c,f)):f=c;f=Jua(f,d);c=KW(Rpa(f.lt),d);b=-2+b|0;f=
iq(f.kt,2);d=vp();c=1+(fa(c,3+c|0)/2|0)|0;c=Up(d,(new Ep).K(c,c>>31));d=Rp(Xp(),f,c)}var f=l0(d),c=-54+wp(zp(),d)|0,h,n;if(0<c){if(d=hq(d,c).bi(),g=d.Ya,d=d.Ra,h=g,g=d,n=h,1===(1&d)&&f<c||3===(3&d)){var u=2+d|0,d=u;h=-2147483646>(-2147483648^u)?1+h|0:h}}else d=d.bi(),g=d.Ra,n=d.Ya,h=-c|0,d=0===(32&h)?g<<h:0,h=0===(32&h)?(g>>>1|0)>>>(31-h|0)|0|n<<h:g<<h,g=d,n=h,3===(3&d)&&(d=u=2+d|0,h=-2147483646>(-2147483648^u)?1+h|0:h);0===(4194304&h)?(d=d>>>1|0|h<<31,h>>=1,b=b+c|0):(d=d>>>2|0|h<<30,h>>=2,b=b+(1+
c|0)|0);if(2046<b)return Infinity*a;if(-53>b)return 0*a;if(0>=b){d=g>>>1|0|n<<31;h=n>>1;n=63+b|0;g=d&(0===(32&n)?-1>>>n|0|-2<<(31-n|0):-1>>>n|0);n=h&(0===(32&n)?-1>>>n|0:0);b=-b|0;d=0===(32&b)?d>>>b|0|h<<1<<(31-b|0):h>>b;h=0===(32&b)?h>>b:h>>31;if(3===(3&d)||(1!==(1&d)||0===g&&0===n?0:f<c))b=h,d=f=1+d|0,h=0===f?1+b|0:b;b=0;f=h;d=d>>>1|0|f<<31;h=f>>1}f=d;b=-2147483648&a>>31|b<<20|1048575&h;a=Ha();b=(new Ep).K(f,b);a.Zl?(a.ho[a.sv]=b.Ya,a.ho[a.jw]=b.Ra,a=+a.rv[0]):a=xka(b);return a};
function gpa(a,b,c){hj.prototype.c.call(a);a.Xe=b;a.tc=c;a.wf=FV(GV(),b);return a}e.A=function(){if(0===this.wh)if(64>this.wf){this.wh=this.Xe.Ra;var a=this.Xe.Ya;this.wh=fa(33,this.wh)+a|0;this.wh=fa(17,this.wh)+this.tc|0}else this.wh=fa(17,this.ll.A())+this.tc|0;return this.wh};e.j=function(a){hj.prototype.Bl.call(this,EP(Ga(),a),0,a.length|0);return this};e.oh=function(){return-32>=this.tc||this.tc>IW(this)?0:i0(this).oh()};e.$j=function(a){hj.prototype.Ns.call(this,a,0);return this};
e.Fm=function(){var a=this.wf,b=a>>31,c=ab(),d=gQ(c,this.tc/.3010299956639812),c=c.dd,d=a-d|0,a=(-2147483648^d)>(-2147483648^a)?-1+(b-c|0)|0:b-c|0,b=ga(k0(this));return(-1===a?2147483499>(-2147483648^d):-1>a)||0===b?ga(0*b):(0===a?-2147483519<(-2147483648^d):0<a)?ga(Infinity*b):ga(this.oj())};
e.Bl=function(a,b,c){hj.prototype.c.call(this);var d=-1+(b+c|0)|0;if(null===a)throw(new fk).j("in \x3d\x3d null");if(d>=a.i.length||0>b||0>=c||0>d)throw(new $V).j(td((new yd).X((new r).d(["Bad offset/length: offset\x3d"," len\x3d"," in.length\x3d",""])),(new r).d([b,c,a.i.length])));var f=b;if(b<=d&&43===a.i[b]){f=1+f|0;if(f<d){GV();for(var g=a.i[f],h=[(new ed).db(43),(new ed).db(45)],n=(new ed).db(g),u=0;;){if(u<(h.length|0))var w=h[u],D=!1===dj(ej(),w,n);else D=!1;if(D)u=1+u|0;else break}var N=
u!==(h.length|0)}else N=!1;if(N)throw(new $V).j("For input string: "+a.v());}else{var Q=f<=d&&45===a.i[f];if((1+f|0)<d){GV();for(var ea=a.i[1+f|0],ba=[(new ed).db(43),(new ed).db(45)],ma=(new ed).db(ea),La=0;;){if(La<(ba.length|0))var Pa=ba[La],Qa=!1===dj(ej(),Pa,ma);else Qa=!1;if(Qa)La=1+La|0;else break}var Ka=La!==(ba.length|0)}else Ka=!1;if(Q&&Ka)throw(new $V).j("For input string: "+a.v());}for(var Ba=f,va=!1;;){if(f<=d){GV();for(var za=a.i[f],qa=[(new ed).db(46),(new ed).db(101),(new ed).db(69)],
la=(new ed).db(za),Ma=0;;){if(Ma<(qa.length|0))var Ea=qa[Ma],tb=!1===dj(ej(),Ea,la);else tb=!1;if(tb)Ma=1+Ma|0;else break}var Za=Ma===(qa.length|0)}else Za=!1;if(Za)va||48===a.i[f]||(va=!0),f=1+f|0;else break}var eb=(new vR).Bl((new uR).Uk(a).mm,Ba,f).v(),kb=f-Ba|0;if(f<=d&&46===a.i[f]){for(var Pb=f=1+f|0;;){if(f<=d){GV();for(var Na=a.i[f],sb=[(new ed).db(101),(new ed).db(69)],yb=(new ed).db(Na),sc=0;;){if(sc<(sb.length|0))var Ra=sb[sc],wc=!1===dj(ej(),Ra,yb);else wc=!1;if(wc)sc=1+sc|0;else break}var Wb=
sc===(sb.length|0)}else Wb=!1;if(Wb)va||48===a.i[f]||(va=!0),f=1+f|0;else break}this.tc=f-Pb|0;var Rb=""+eb+(new vR).Bl((new uR).Uk(a).mm,Pb,Pb+this.tc|0).v(),ub=kb+this.tc|0}else this.tc=0,Rb=eb,ub=kb;var fb=Rb,Xb=ub|0;if(f<=d){GV();for(var lb=a.i[f],Eb=[(new ed).db(101),(new ed).db(69)],xc=(new ed).db(lb),gb=0;;){if(gb<(Eb.length|0))var dc=Eb[gb],Fc=!1===dj(ej(),dc,xc);else Fc=!1;if(Fc)gb=1+gb|0;else break}var Qb=gb!==(Eb.length|0)}else Qb=!1;if(Qb){var f=1+f|0,Bb=(1+f|0)<=d&&45!==a.i[1+f|0],Ib=
f<=d&&43===a.i[f]&&Bb?1+f|0:f,mb=kr(Ga(),a,Ib,(1+d|0)-Ib|0),Cb=this.tc,Tb=Cb>>31,mc=kR(aO(),mb,10),Ac=mc>>31,Dc=Cb-mc|0,Db=this.tc=Dc;if(Dc!==Db||((-2147483648^Dc)>(-2147483648^Cb)?-1+(Tb-Ac|0)|0:Tb-Ac|0)!==Db>>31)throw(new $V).j("Scale out of range");}if(19>Xb){var Va;var ec=Kpa();""===fb&&iW(fb);var $a=0,vb=!1;switch(65535&(fb.charCodeAt(0)|0)){case 43:$a=1;break;case 45:$a=1,vb=!0}var fc;var Bc=$a,Ub=fb.length|0;if(Bc>=Ub)iW(fb),fc=void 0;else{if(!ec.ra&&!ec.ra){for(var Vb=[],wb=0;;){Vb.push(null);
if(1===wb)break;wb=1+wb|0}for(var xb=2;;){for(var Xa=xb,tc=2147483647/Xa|0,ib=Xa,zb=1;ib<=tc;)ib=fa(ib,Xa),zb=1+zb|0;var nb=ib,Jb=nb>>31,jb=ab(),ob=Hp(jb,-1,-1,nb,Jb),gc=jb.dd,cb=new Br,Ua=(new Ep).K(nb,Jb),Yb=(new Ep).K(ob,gc);cb.dA=zb;cb.hC=Ua;cb.YB=Yb;Vb.push(cb);if(36===xb)break;xb=1+xb|0}ec.Lz=Vb;ec.ra=!0}for(var Kb=ec.Lz[10],pb=Kb.dA,hb=Bc;;)if(hb<Ub&&48===(65535&(fb.charCodeAt(hb)|0)))hb=1+hb|0;else break;(Ub-hb|0)>fa(3,pb)&&iW(fb);for(var Lb=hb;Lb<Ub;)0>Dpa(qi(),65535&(fb.charCodeAt(Lb)|0),
10)&&iW(fb),Lb=1+Lb|0;var Fa=hb+(1+((-1+(Ub-hb|0)|0)%pb|0)|0)|0,bb=fb.substring(hb,Fa),nc=+ca.parseInt(bb,10),db=Sa(nc);if(Fa===Ub)fc=(new Ep).K(db,0);else{var uc=Kb.hC,Fb=uc.Ra,hc=uc.Ya,$b=Fa+pb|0,kc=65535&db,lc=db>>>16|0,Mb=65535&Fb,Nb=Fb>>>16|0,Gb=fa(kc,Mb),Sb=fa(lc,Mb),Cc=fa(kc,Nb),Ob=Gb+((Sb+Cc|0)<<16)|0,Zb=(Gb>>>16|0)+Cc|0,Ec=((fa(db,hc)+fa(lc,Nb)|0)+(Zb>>>16|0)|0)+(((65535&Zb)+Sb|0)>>>16|0)|0,oc=fb.substring(Fa,$b),pc=+ca.parseInt(oc,10),qc=Ob+Sa(pc)|0,Jc=(-2147483648^qc)<(-2147483648^Ob)?
1+Ec|0:Ec;if($b===Ub)fc=(new Ep).K(qc,Jc);else{FK(To(),($b+pb|0)===Ub);var Hc=Kb.YB,ac=Hc.Ra,Lc=Hc.Ya,$c=fb.substring($b,Ub),Tc=+ca.parseInt($c,10),Rc=Sa(Tc);(Jc===Lc?(-2147483648^qc)>(-2147483648^ac):Jc>Lc)&&iW(fb);var Mc=65535&qc,hd=qc>>>16|0,Qc=65535&Fb,rd=Fb>>>16|0,od=fa(Mc,Qc),Zc=fa(hd,Qc),nd=fa(Mc,rd),zd=od+((Zc+nd|0)<<16)|0,ud=(od>>>16|0)+nd|0,wd=(((fa(qc,hc)+fa(Jc,Fb)|0)+fa(hd,rd)|0)+(ud>>>16|0)|0)+(((65535&ud)+Zc|0)>>>16|0)|0,Bd=zd+Rc|0,Ed=(-2147483648^Bd)<(-2147483648^zd)?1+wd|0:wd;-2147483648===
(-2147483648^Ed)&&(-2147483648^Bd)<(-2147483648^Rc)&&iW(fb);fc=(new Ep).K(Bd,Ed)}}}var pd=fc.Ra,vd=fc.Ya;if(vb){var xd=-pd|0,ee=0!==pd?~vd:-vd|0;(0===ee?0!==xd:0<ee)&&iW(fb);Va=(new Ep).K(xd,ee)}else 0>vd&&iW(fb),Va=(new Ep).K(pd,vd);this.Xe=Va;this.wf=FV(GV(),this.Xe)}else Upa(this,(new mp).j(fb));return this};function JW(a){null===a.ll&&(a.ll=Up(vp(),a.Xe));return a.ll}
function Lua(a,b){var c=k0(a),d=k0(b);if(c===d){if(a.tc===b.tc&&64>a.wf&&64>b.wf){var c=a.Xe,d=c.Ra,c=c.Ya,f=b.Xe,g=f.Ya;if(c===g?(-2147483648^d)<(-2147483648^f.Ra):c<g)return-1;d=a.Xe;a=d.Ra;d=d.Ya;b=b.Xe;c=b.Ya;return(d===c?(-2147483648^a)>(-2147483648^b.Ra):d>c)?1:0}var f=a.tc,g=f>>31,d=b.tc,h=d>>31,d=f-d|0,f=(-2147483648^d)>(-2147483648^f)?-1+(g-h|0)|0:g-h|0,g=IW(a)-IW(b)|0,h=g>>31,n=1+d|0,u=0===n?1+f|0:f;if(h===u?(-2147483648^g)>(-2147483648^n):h>u)return c;h=g>>31;n=-1+d|0;u=-1!==n?f:-1+f|0;
if(h===u?(-2147483648^g)<(-2147483648^n):h<u)return-c|0;a=JW(a);b=JW(b);if(0>f)c=Lp(),a=eq(a,jq(c,(new Ep).K(-d|0,0!==d?~f:-f|0)));else if(0===f?0!==d:0<f)b=eq(b,jq(Lp(),(new Ep).K(d,f)));return KW(a,b)}return c<d?-1:1}var ipa=l({fz:0},!1,"java.math.BigDecimal",{fz:1,bk:1,f:1,k:1,xf:1});hj.prototype.$classData=ipa;function mp(){this.Sb=null;this.wh=this.Ws=this.oc=this.Jc=0}mp.prototype=new hR;mp.prototype.constructor=mp;
function kq(a,b){if(0>b)throw(new HV).j("Negative exponent");if(0===b)return vp().rl;if(1===b||a.w(vp().rl)||a.w(vp().Tj))return a;if(LW(a,0)){a:{Lp();var c=vp().rl,d=a;for(;;)if(1<b)a=0!==(1&b)?eq(c,d):c,1===d.Jc?d=eq(d,d):(c=oa(bc(yc),[d.Jc<<1]),c=yca(d.Sb,d.Jc,c),d=new mp,mp.prototype.c.call(d),0===c.i.length?(d.oc=0,d.Jc=1,d.Sb=Sp(Tp(),0,(new r).d([]))):(d.oc=1,d.Jc=c.i.length,d.Sb=c,np(d))),b>>=1,c=a;else{a=eq(c,d);break a}}return a}for(c=1;!LW(a,c);)c=1+c|0;var d=vp(),f=fa(c,b);if(f<d.Lu.i.length)d=
d.Lu.i[f];else{var d=f>>5,f=31&f,g=oa(bc(yc),[1+d|0]);g.i[d]=1<<f;d=lp(new mp,1,1+d|0,g)}return eq(d,kq(hq(a,c),b))}e=mp.prototype;e.bi=function(){if(1<this.Jc)var a=this.Sb.i[0],b=this.Sb.i[1];else a=this.Sb.i[0],b=0;var c=this.oc,d=c>>31,f=65535&c,g=c>>>16|0,h=65535&a,n=a>>>16|0,u=fa(f,h),h=fa(g,h),w=fa(f,n),f=u+((h+w|0)<<16)|0,u=(u>>>16|0)+w|0,b=(((fa(c,b)+fa(d,a)|0)+fa(g,n)|0)+(u>>>16|0)|0)+(((65535&u)+h|0)>>>16|0)|0;return(new Ep).K(f,b)};e.c=function(){this.Ws=-2;this.wh=0;return this};
function Tpa(a,b){if(0===b.oc)throw(new HV).j("BigInteger divide by zero");var c=b.oc;if(1===b.Jc&&1===b.Sb.i[0])return 0<b.oc?a:Wp(a);var d=a.oc,f=a.Jc,g=b.Jc;if(2===(f+g|0))return a=a.Sb.i[0],b=b.Sb.i[0],f=ab(),b=Fp(f,a,0,b,0),a=f.dd,d!==c&&(c=b,d=a,b=-c|0,a=0!==c?~d:-d|0),Up(vp(),(new Ep).K(b,a));var h=f!==g?f>g?1:-1:Pp(Xp(),a.Sb,b.Sb,f);if(0===h)return d===c?vp().rl:vp().Lr;if(-1===h)return vp().Tj;var h=1+(f-g|0)|0,n=oa(bc(yc),[h]),c=d===c?1:-1;1===g?wca(Kp(),n,a.Sb,f,b.Sb.i[0]):vca(Kp(),n,h,
a.Sb,f,b.Sb,g);c=lp(new mp,c,h,n);np(c);return c}e.w=function(a){if(a&&a.$classData&&a.$classData.H.gz){var b;if(b=this.oc===a.oc&&this.Jc===a.Jc){a=a.Sb;b=(new m0).Be(0,this.Jc,1);b=Cp(new Dp,b,b.Fa());for(var c=!0;c&&b.fb();)c=b.bb()|0,c=this.Sb.i[c]===a.i[c];b=c}a=b}else a=!1;return a};e.v=function(){return Gp(Ip(),this)};e.K=function(a,b){mp.prototype.c.call(this);this.oc=a;this.Jc=1;this.Sb=Sp(Tp(),b,(new r).d([]));return this};
function xp(a){if(-2===a.Ws){if(0===a.oc)var b=-1;else for(b=0;0===a.Sb.i[b];)b=1+b|0;a.Ws=b}return a.Ws}function Spa(a){return 0>a.oc?lp(new mp,1,a.Jc,a.Sb):a}
function Jua(a,b){var c=b.oc;if(0===c)throw(new HV).j("BigInteger divide by zero");var d=b.Jc;b=b.Sb;if(1===d){Kp();b=b.i[0];var f=a.Sb,g=a.Jc,d=a.oc;1===g?(f=f.i[0],a=+(f>>>0)/+(b>>>0)|0,g=0,b=+(f>>>0)%+(b>>>0)|0,f=0,d!==c&&(c=a,a=-c|0,g=0!==c?~g:-g|0),0>d&&(c=b,d=f,b=-c|0,f=0!==c?~d:-d|0),c=ip(new hp,Up(vp(),(new Ep).K(a,g)),Up(vp(),(new Ep).K(b,f)))):(c=d===c?1:-1,a=oa(bc(yc),[g]),b=wca(0,a,f,g,b),b=Sp(Tp(),b,(new r).d([])),c=lp(new mp,c,g,a),d=lp(new mp,d,1,b),np(c),np(d),c=ip(new hp,c,d));return c}g=
a.Sb;f=a.Jc;if(0>(f!==d?f>d?1:-1:Pp(Xp(),g,b,f)))return ip(new hp,vp().Tj,a);a=a.oc;var h=1+(f-d|0)|0,c=a===c?1:-1,n=oa(bc(yc),[h]);b=vca(Kp(),n,h,g,f,b,d);c=lp(new mp,c,h,n);d=lp(new mp,a,d,b);np(c);np(d);return ip(new hp,c,d)}function np(a){a:for(;;){if(0<a.Jc&&(a.Jc=-1+a.Jc|0,0===a.Sb.i[a.Jc]))continue a;break}0===a.Sb.i[a.Jc]&&(a.oc=0);a.Jc=1+a.Jc|0}
function LW(a,b){var c=b>>5;if(0===b)return 0!==(1&a.Sb.i[0]);if(0>b)throw(new HV).j("Negative bit address");if(c>=a.Jc)return 0>a.oc;if(0>a.oc&&c<xp(a))return!1;var d=a.Sb.i[c];0>a.oc&&(d=xp(a)===c?-d|0:~d);return 0!==(d&1<<(31&b))}function l0(a){if(0===a.oc)return-1;var b=xp(a);a=a.Sb.i[b];return(b<<5)+(0===a?32:31-ha(a&(-a|0))|0)|0}function Wp(a){return 0===a.oc?a:lp(new mp,-a.oc|0,a.Jc,a.Sb)}function lp(a,b,c,d){mp.prototype.c.call(a);a.oc=b;a.Jc=c;a.Sb=d;return a}
function Rpa(a){if(0!==a.oc){zp();var b=a.Jc,c=1+b|0,d=oa(bc(yc),[c]);qca(0,d,a.Sb,b);a=lp(new mp,a.oc,c,d);np(a)}return a}e.oj=function(){return uH(vH(),Gp(Ip(),this))};
e.ui=function(a,b){mp.prototype.c.call(this);vp();if(null===a)throw(new fk).c();if(2>b||36<b)throw(new $V).j("Radix out of range");if(null===a)throw(new fk).c();if(""===a)throw(new $V).j("Zero length BigInteger");if(""===a||"+"===a||"-"===a)throw(new $V).j("Zero length BigInteger");var c=a.length|0;if(45===(65535&(a.charCodeAt(0)|0)))var d=-1,f=1,g=-1+c|0;else 43===(65535&(a.charCodeAt(0)|0))?(f=d=1,g=-1+c|0):(d=1,f=0,g=c);var d=d|0,h=f|0,f=g|0,g=-1+c|0;if(!(h>=c))for(var n=h;;){var u=65535&(a.charCodeAt(n)|
0);if(43===u||45===u)throw(new $V).j("Illegal embedded sign character");if(n===g)break;n=1+n|0}var g=Ip().ty.i[b],n=f/g|0,w=f%g|0;0!==w&&(n=1+n|0);f=oa(bc(yc),[n]);n=Ip().ey.i[-2+b|0];u=0;for(w=h+(0===w?g:w)|0;h<c;){var D=kR(aO(),a.substring(h,w),b),h=gq(Lp(),f,f,u,n);Xp();for(var N=f,Q=u,ea=D,D=0;0!==ea&&D<Q;){var ba=ea,ea=ba+N.i[D]|0,ba=(-2147483648^ea)<(-2147483648^ba)?1:0;N.i[D]=ea;ea=ba;D=1+D|0}h=h+ea|0;f.i[u]=h;u=1+u|0;h=w;w=h+g|0}this.oc=d;this.Jc=u;this.Sb=f;np(this);return this};
e.A=function(){if(0===this.wh){var a=this.Jc,b=-1+a|0;if(!(0>=a))for(a=0;;){var c=a;this.wh=fa(33,this.wh)+this.Sb.i[c]|0;if(a===b)break;a=1+a|0}this.wh=fa(this.wh,this.oc)}return this.wh};function Qpa(a,b){a=Jua(a,b);var c=(new r).d([a.kt,a.lt]);a=c.Da.length|0;a=oa(bc(dq),[a]);b=0;for(c=Cp(new Dp,c,c.Da.length|0);c.fb();){var d=c.bb();a.i[b]=d;b=1+b|0}return a}e.j=function(a){mp.prototype.ui.call(this,a,10);return this};
function iq(a,b){return 0===b||0===a.oc?a:0<b?rca(zp(),a,b):sca(zp(),a,-b|0)}e.oh=function(){return fa(this.oc,this.Sb.i[0])};function eq(a,b){return 0===b.oc||0===a.oc?vp().Tj:fq(Lp(),a,b)}function kpa(a,b,c){mp.prototype.c.call(a);a.oc=b;b=c.Ya;0===b?(a.Jc=1,a.Sb=Sp(Tp(),c.Ra,(new r).d([]))):(a.Jc=2,a.Sb=Sp(Tp(),c.Ra,(new r).d([b])));return a}function hq(a,b){return 0===b||0===a.oc?a:0<b?sca(zp(),a,b):rca(zp(),a,-b|0)}
function KW(a,b){return a.oc>b.oc?1:a.oc<b.oc?-1:a.Jc>b.Jc?a.oc:a.Jc<b.Jc?-b.oc|0:fa(a.oc,Pp(Xp(),a.Sb,b.Sb,a.Jc))}var dq=l({gz:0},!1,"java.math.BigInteger",{gz:1,bk:1,f:1,k:1,xf:1});mp.prototype.$classData=dq;function NV(){aW.call(this)}NV.prototype=new Hpa;NV.prototype.constructor=NV;NV.prototype.ui=function(a,b){aW.prototype.ui.call(this,a,b);return this};var lpa=l({yH:0},!1,"java.math.RoundingMode",{yH:1,H5:1,f:1,xf:1,k:1});NV.prototype.$classData=lpa;
function n0(){this.Ye=this.rq=null;this.Om=this.Ck=!1;this.cq=this.Yv=this.io=this.Xs=this.Rm=null;this.Qm=0;this.Nm=this.jo=this.Pm=null}n0.prototype=new m;n0.prototype.constructor=n0;e=n0.prototype;
e.w=function(a){if(a&&a.$classData&&a.$classData.H.iz){var b=function(){return function(a,b){a:{QV();var c=0;for(;;){if(c>=(a.length|0)||c>=(b.length|0)){a=(a.length|0)-(b.length|0)|0;break a}var d=(65535&(a.charCodeAt(c)|0))-(65535&(b.charCodeAt(c)|0))|0;if(0!==d){a=d;break a}if(37===(65535&(a.charCodeAt(c)|0))){if(!((a.length|0)>(2+c|0)))throw(new fP).e("assertion failed: Invalid escape in URI");if(!((b.length|0)>(2+c|0)))throw(new fP).e("assertion failed: Invalid escape in URI");Ga();d=a.substring(1+
c|0,3+c|0);d=GP(0,d,b.substring(1+c|0,3+c|0));if(0!==d){a=d;break a}c=3+c|0}else c=1+c|0}}return a}}(this);if(dj(ej(),this.Rm,a.Rm))if(this.Om!==a.Om)a=this.Om?1:-1;else if(this.Om){var c=b(this.Xs,a.Xs)|0;0!==c?a=c:(c=this.Nm,a=a.Nm,a=dj(ej(),c,a)?0:void 0===c?-1:void 0===a?1:b(c,a)|0)}else if(dj(ej(),this.io,a.io))dj(ej(),this.Pm,a.Pm)?dj(ej(),this.jo,a.jo)?(c=this.Nm,a=a.Nm):(c=this.jo,a=a.jo):(c=this.Pm,a=a.Pm),a=dj(ej(),c,a)?0:void 0===c?-1:void 0===a?1:b(c,a)|0;else if(void 0!==this.cq&&void 0!==
a.cq){var c=this.Yv,d=a.Yv,b=dj(ej(),c,d)?0:void 0===c?-1:void 0===d?1:b(c,d)|0;if(0!==b)a=b;else{Ga();b=this.cq;if(void 0===b)throw(new BP).j("undefined.get");c=a.cq;if(void 0===c)throw(new BP).j("undefined.get");b=GP(0,b,c);a=0!==b?b:this.Qm===a.Qm?0:-1===this.Qm?-1:-1===a.Qm?1:this.Qm-a.Qm|0}}else c=this.io,a=a.io,a=dj(ej(),c,a)?0:void 0===c?-1:void 0===a?1:b(c,a)|0;else b=this.Rm,void 0===b?a=-1:(a=a.Rm,a=void 0===a?1:GP(Ga(),b,a));return 0===a}return!1};e.v=function(){return this.rq};
function Mua(a){if(cj(a))var b=a.n(),b=!(null!==b&&Aa(b,".."));else b=!1;return b?(a=a.n(),!(null!==a&&Aa(a,""))):!1}e.A=function(){var a=53722356,a=XN().Gb(a,YN(Y(),this.Rm)),a=XN().Gb(a,YN(Y(),npa(QV(),this.Xs))),b=XN();Y();var c=this.Nm,c=void 0===c?void 0:npa(QV(),c),a=b.bn(a,YN(0,c));return XN().xd(a,3)};
e.j=function(a){this.rq=a;a=Xr().up(QV().pB.exec(a));if(a.g())throw(new o0).Ps(this.rq,"Malformed URI");this.Ye=a=a.q();this.Ck=void 0!==this.Ye[1];this.Om=void 0!==this.Ye[10];this.Rm=this.Ye[1];a=this.Ck?this.Om?this.Ye[10]:this.Ye[2]:this.Ye[11];if(void 0===a)throw(new BP).j("undefined.get");this.Xs=a;a=this.Ck?this.Ye[3]:this.Ye[12];this.io=void 0===a||""!==a?a:void 0;this.Yv=this.Ck?this.Ye[4]:this.Ye[13];this.cq=this.Ck?this.Ye[5]:this.Ye[14];a=this.Ck?this.Ye[6]:this.Ye[15];void 0===a?a=-1:
(a=(new cd).j(a),a=kR(aO(),a.ka,10));this.Qm=a;void 0!==(this.Ck?this.Ye[3]:this.Ye[12])?(a=this.Ck?this.Ye[7]:this.Ye[16],a=void 0===a?"":a):this.Ck?a=this.Ye[8]:(a=this.Ye[17],a=void 0===a?this.Ye[18]:a);this.Pm=a;this.jo=this.Ck?this.Ye[9]:this.Ye[19];this.Nm=this.Ye[20];this.Ye=null;return this};
function Nua(a){if(a.Om||void 0===a.Pm)return a;var b=a.Pm;if(void 0===b)throw(new BP).j("undefined.get");var c=yka(Ga(),b,"/",-1),d=G().b.mj(),f=c.i.length;switch(f){case -1:break;default:d.je(f)}d.$c((new e0).Bk(c));d=d.da();cj(d)?(c=d.n(),c=null!==c&&Aa(c,"")):c=!1;a:{var g=c?d.o():d,d=F();b:for(;;){var h=!1,f=null;if(rk(g)){var h=!0,f=g,n=f.ga;if("."===f.ed&&F().w(n)){f=F();d=U(new V,"",d);g=f;continue b}}if(h&&(n=f.ga,".."===f.ed&&F().w(n)&&Mua(d))){f=F();d=d.o();d=U(new V,"",d);g=f;continue b}if(h&&
(n=f.ga,"."===f.ed)){g=n;continue b}if(h&&(n=f.ga,""===f.ed&&cj(n))){g=n;continue b}if(h&&(n=f.ga,".."===f.ed&&Mua(d))){d=d.o();g=n;continue b}if(h){d=U(new V,f.ed,d);g=f.ga;continue b}if(F().w(g)){d=Bua(d);break a}throw(new p).e(g);}}c?c=U(new V,"",d):(cj(d)?(c=d.n(),c=(new cd).j(c),f=(new ed).db(58),c=Lia(c,f)):c=!1,c=c?U(new V,".",d):d);c=gG(c,"","/","");c!==b&&(b=new n0,d=a.Rm,d=void 0===d?null:d,f=a.io,f=void 0===f?null:f,h=a.jo,h=void 0===h?void 0:opa(QV(),h),h=void 0===h?null:h,a=a.Nm,a=void 0===
a?void 0:opa(QV(),a),a=void 0===a?null:a,n0.prototype.j.call(b,mpa(QV(),d,f,c,h,a)),a=b);return a}e.$classData=l({iz:0},!1,"java.net.URI",{iz:1,f:1,l:1,k:1,xf:1});function o0(){Rn.call(this)}o0.prototype=new eW;o0.prototype.constructor=o0;o0.prototype.Ps=function(a,b){o0.prototype.NI.call(this,a,b,-1);return this};o0.prototype.NI=function(a,b,c){a=td((new yd).X((new r).d([""," in "," at ",""])),(new r).d([b,a,c]));Rn.prototype.fd.call(this,a,null);return this};
o0.prototype.$classData=l({BH:0},!1,"java.net.URISyntaxException",{BH:1,ae:1,vd:1,f:1,k:1});function rq(){sq.call(this);this.Ph=!1}rq.prototype=new qpa;rq.prototype.constructor=rq;function lV(a){var b=a.kb;if(b===a.jc)throw(new Lq).c();a.kb=1+b|0;return a.Nd.i[a.ne+b|0]|0}function nV(a,b){if(a.Ph)throw(new Iq).c();var c=a.kb;if(c===a.jc)throw(new Jq).c();a.kb=1+c|0;a.Nd.i[a.ne+c|0]=b|0}rq.prototype.$classData=l({FH:0},!1,"java.nio.HeapByteBuffer",{FH:1,CH:1,jz:1,f:1,xf:1});
function p0(){Rn.call(this)}p0.prototype=new cW;p0.prototype.constructor=p0;function Dq(a){var b=new p0;bW.prototype.Dv.call(b,a);return b}p0.prototype.$classData=l({NH:0},!1,"java.nio.charset.CoderMalfunctionError",{NH:1,zB:1,vd:1,f:1,k:1});function UV(){Rn.call(this)}UV.prototype=new cW;UV.prototype.constructor=UV;UV.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};UV.prototype.$classData=l({yI:0},!1,"org.scalameta.UnreachableError",{yI:1,zB:1,vd:1,f:1,k:1});
function XV(){Rn.call(this)}XV.prototype=new eW;XV.prototype.constructor=XV;XV.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};XV.prototype.$classData=l({AI:0},!1,"org.scalameta.invariants.InvariantFailedException",{AI:1,ae:1,vd:1,f:1,k:1});function aG(a){return"string"===typeof a}var sa=l({EI:0},!1,"java.lang.String",{EI:1,f:1,k:1,ko:1,xf:1},void 0,void 0,aG);function fP(){Rn.call(this)}fP.prototype=new cW;fP.prototype.constructor=fP;
fP.prototype.e=function(a){Rn.prototype.fd.call(this,""+a,a&&a.$classData&&a.$classData.H.vd?a:null);return this};fP.prototype.$classData=l({VI:0},!1,"java.lang.AssertionError",{VI:1,zB:1,vd:1,f:1,k:1});
var daa=l({XI:0},!1,"java.lang.Byte",{XI:1,bk:1,f:1,k:1,xf:1},void 0,void 0,function(a){return ta(a)}),haa=l({aJ:0},!1,"java.lang.Double",{aJ:1,bk:1,f:1,k:1,xf:1},void 0,void 0,function(a){return"number"===typeof a}),gaa=l({cJ:0},!1,"java.lang.Float",{cJ:1,bk:1,f:1,k:1,xf:1},void 0,void 0,function(a){return wa(a)}),faa=l({dJ:0},!1,"java.lang.Integer",{dJ:1,bk:1,f:1,k:1,xf:1},void 0,void 0,function(a){return Wa(a)}),jaa=l({hJ:0},!1,"java.lang.Long",{hJ:1,bk:1,f:1,k:1,xf:1},void 0,void 0,function(a){return ya(a)});
function q0(){Rn.call(this)}q0.prototype=new eW;q0.prototype.constructor=q0;function r0(){}r0.prototype=q0.prototype;q0.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};q0.prototype.$classData=l({Nf:0},!1,"java.lang.RuntimeException",{Nf:1,ae:1,vd:1,f:1,k:1});var eaa=l({oJ:0},!1,"java.lang.Short",{oJ:1,bk:1,f:1,k:1,xf:1},void 0,void 0,function(a){return ua(a)});function s0(){this.ac=null}s0.prototype=new m;s0.prototype.constructor=s0;
function gI(a){var b=a.ac,c=0-(b.length|0)|0;if(0>c)b=b.substring(0,0);else for(var d=0;d!==c;)b+="\x00",d=1+d|0;a.ac=b}e=s0.prototype;e.c=function(){this.ac="";return this};e.Lo=function(a,b){return this.ac.substring(a,b)};e.v=function(){return this.ac};e.Bs=function(a){this.ac=""+this.ac+a;return this};e.mc=function(a){s0.prototype.c.call(this);if(0>a)throw(new t0).c();return this};e.Fa=function(){return this.ac.length|0};function Oua(a,b){b=ca.String.fromCharCode(b);a.ac=""+a.ac+b;return a}
e.j=function(a){s0.prototype.c.call(this);if(null===a)throw(new fk).c();this.ac=a;return this};e.As=function(a){return Oua(this,a)};e.Vj=function(a){return 65535&(this.ac.charCodeAt(a)|0)};e.$classData=l({pJ:0},!1,"java.lang.StringBuilder",{pJ:1,f:1,ko:1,Zv:1,k:1});function qR(){this.pa=this.bg=null}qR.prototype=new m;qR.prototype.constructor=qR;function Pua(){}Pua.prototype=qR.prototype;
qR.prototype.w=function(a){a:{Lr();if(a&&a.$classData&&a.$classData.H.KJ){var b=this.bg,c=a.bg;if(null===b?null===c:Aa(b,c)){b=this.pa;a=a.pa;a=null===b?null===a:Aa(b,a);break a}}a=!1}return a};qR.prototype.a=function(a,b){this.bg=a;this.pa=b;return this};qR.prototype.v=function(){ms||(ms=(new ls).c());return""+(""+this.bg+"\x3d")+this.pa};qR.prototype.A=function(){return Zca(Lr(),this)};function HP(){this.Am=null;this.Cp=!1}HP.prototype=new m;HP.prototype.constructor=HP;e=HP.prototype;
e.c=function(){HP.prototype.OI.call(this,(new s0).c());return this};function u0(a,b,c,d,f,g,h){var n=(b.length|0)+(c.length|0)|0;if(g<=n)b=""+c+b;else{var u=v0("-",f);d=v0("0",f)&&!d;var w="";for(g=g-n|0;0<g;)w=""+w+(d?"0":" "),g=-1+g|0;g=w;if(d&&u)throw(new w0).j(f);b=u?""+c+b+g:d?""+c+g+b:""+g+c+b}h=90>=h?b.toUpperCase():b;a.Am.Bs(h)}e.v=function(){return Dka(this).v()};e.OI=function(a){this.Am=a;this.Cp=!1;return this};
function Qua(a,b,c,d,f,g){var h=65535&(b.charCodeAt(0)|0);43===h||45===h?u0(a,b.substring(1),""+(new ed).db(h)+c,!1,d,f,g):u0(a,b,c,!1,d,f,g)}function v0(a,b){return 0<=(b.indexOf(a)|0)}function Dka(a){if(a.Cp)throw(new x0).c();return a.Am}
function Eka(a,b,c){if(a.Cp)throw(new x0).c();for(var d=b,f=0,g=0;;){var h=d;if(null===h)throw(new fk).c();if(""!==h){h=d;var n=Wr(Vr().tB,h);if(n.g())if(Wr(Vr().qB,h).g())if(Wr(Vr().rB,h).g()){n=Wr(Vr().sB,h);if(n.g())throw(new p).e(h);var u=n.q(),h=u[0];if(void 0===h)throw(new BP).j("undefined.get");d=d.substring(h.length|0);h=u[2];if(void 0===h)throw(new BP).j("undefined.get");n=u[1];n=void 0===n?"":n;if(null===n)throw(new fk).c();n=""!==n?kR(aO(),n,10):v0("\x3c",h)?g:f=1+f|0;g=n;if(0>=n||n>c.i.length){a=
u[5];if(void 0===a)throw(new BP).j("undefined.get");throw(new y0).j(a);}var w=c.i[-1+n|0],n=u[3],n=void 0===n?"":n;if(null===n)throw(new fk).c();var D=""!==n;if(D)n=kR(aO(),n,10);else{if(v0("-",h))throw(new z0).j(b);n=0}var N=u[4],Q=void 0===N?"":N;if(null===Q)throw(new fk).c();Q=(N=""!==Q)?kR(aO(),Q,10):0;u=u[5];if(void 0===u)throw(new BP).j("undefined.get");u=65535&(u.charCodeAt(0)|0);switch(u){case 98:case 66:u0(a,null===w?"false":"boolean"===typeof w?""+w:"true","",!1,h,n,u);break;case 104:case 72:w=
null===w?"null":(+(Ca(w)>>>0)).toString(16);u0(a,w,"",!1,h,n,u);break;case 115:case 83:if(w&&w.$classData&&w.$classData.H.O5)h=(v0("-",h)?1:0)|(v0("#",h)?4:0)|(90>=u?2:0),w.F5(a,h,D?n:-1,N?Q:-1);else{if(v0("#",h))throw a=new A0,A0.prototype.db.call(a,115),a.mv="#",a;u0(a,""+w,"",!1,h,n,u)}break;case 99:case 67:if(Wa(w))w|=0;else if(Od(w))w=null===w?0:w.pa;else throw(new p).e(w);u0(a,ca.String.fromCharCode(65535&w),"",!1,h,n,u);break;case 100:w=B0(w);C0(a,""+w,!1,h,n,u);break;case 111:if(Wa(w))w=(+((w|
0)>>>0)).toString(8);else{if(!ya(w))throw(new p).e(w);D=Ya(w);w=D.Ra;D=D.Ya;Kpa();w=(new Ep).K(w,D);D=w.Ra;Q=w.Ya;w=1073741823&D;N=1073741823&((D>>>30|0)+(Q<<2)|0);D=Q>>>28|0;0!==D?(D=(+(D>>>0)).toString(8),N=(+(N>>>0)).toString(8),Q="0000000000".substring(N.length|0),w=(+(w>>>0)).toString(8),w=D+(""+Q+N)+(""+"0000000000".substring(w.length|0)+w)):0!==N?(D=(+(N>>>0)).toString(8),w=(+(w>>>0)).toString(8),w=D+(""+"0000000000".substring(w.length|0)+w)):w=(+(w>>>0)).toString(8)}Qua(a,w,v0("#",h)?"0":
"",h,n,u);break;case 120:case 88:if(Wa(w))w=(+((w|0)>>>0)).toString(16);else{if(!ya(w))throw(new p).e(w);D=Ya(w);w=D.Ra;D=D.Ya;Kpa();D=(new Ep).K(w,D);w=D.Ra;D=D.Ya;0!==D?(D=(+(D>>>0)).toString(16),w=(+(w>>>0)).toString(16),w=D+(""+"00000000".substring(w.length|0)+w)):w=(+(w>>>0)).toString(16)}Qua(a,w,v0("#",h)?"0x":"",h,n,u);break;case 101:case 69:Rua(a,N?Q:6,h,w,n,u);break;case 103:case 71:D=B0(w);D=+ca.Math.abs(D);N=N?0===Q?1:Q:6;1E-4<=D&&D<+ca.Math.pow(10,N)?(Q=void 0!==ca.Math.log10?+ca.Math.log10(D):
+ca.Math.log(D)/2.302585092994046,Q=Sa(+ca.Math.ceil(Q)),D=+ca.Math.pow(10,Q)<=D?1+Q|0:Q,w=B0(w),D=N-D|0,w=w.toFixed(0<D?D:0),C0(a,w,!1,h,n,u)):Rua(a,-1+N|0,h,w,n,u);break;case 102:D=B0(w).toFixed(N?Q:6);N=B0(w);N!==N?w=!0:(w=B0(w),w=Infinity===w||-Infinity===w);C0(a,D,w,h,n,u);break;default:throw(new p).e((new ed).db(u));}}else d=d.substring(2),a.Am.As(10);else d=d.substring(2),a.Am.As(37);else{h=n.q();n=h[0];if(void 0===n)throw(new BP).j("undefined.get");d=d.substring(n.length|0);n=a.Am;h=h[0];
if(void 0===h)throw(new BP).j("undefined.get");n.Bs(h)}}else break}return a}function Rua(a,b,c,d,f,g){var h=B0(d).toExponential(b);101===(65535&(h.charCodeAt(-3+(h.length|0)|0)|0))?(b=h.substring(0,-1+(h.length|0)|0),h=65535&(h.charCodeAt(-1+(h.length|0)|0)|0),b=b+"0"+(new ed).db(h)):b=h;h=B0(d);h!==h?d=!0:(d=B0(d),d=Infinity===d||-Infinity===d);C0(a,b,d,c,f,g)}e.Es=function(){if(!this.Cp){var a=this.Am;a&&a.$classData&&a.$classData.H.Cu&&a.Es()}this.Cp=!0};
function C0(a,b,c,d,f,g){45!==(65535&(b.charCodeAt(0)|0))?v0("+",d)?u0(a,b,"+",c,d,f,g):v0(" ",d)?u0(a,b," ",c,d,f,g):u0(a,b,"",c,d,f,g):v0("(",d)?u0(a,b.substring(1)+")","(",c,d,f,g):u0(a,b.substring(1),"-",c,d,f,g)}function B0(a){if(UP(a))return"number"===typeof a?a:a.oj();if(Od(a))return null===a?0:a.pa;throw(new p).e(a);}e.$classData=l({xJ:0},!1,"java.util.Formatter",{xJ:1,f:1,Cu:1,xB:1,ez:1});function D0(){}D0.prototype=new dda;D0.prototype.constructor=D0;D0.prototype.c=function(){return this};
function Sp(a,b,c){a=oa(bc(yc),[1+c.Fa()|0]);a.i[0]=b;b=1;for(c=c.Jb();c.fb();){var d=c.bb()|0;a.i[b]=d;b=1+b|0}return a}function E0(a,b,c,d,f,g){a=ra(b);if(a.Ei.isArrayClass&&Le(ra(d),a))Ta(b,c,d,f,g);else for(a=c,c=c+g|0;a<c;)bQ(gO(),d,f,Oka(gO(),b,a)),a=1+a|0,f=1+f|0}function Ica(){Tp();var a=(new r).d([]),b=oa(bc(rc),[1+a.Fa()|0]);b.i[0]=63;var c;c=1;for(a=a.Jb();a.fb();){var d=a.bb()|0;b.i[c]=d;c=1+c|0}return b}D0.prototype.$classData=l({TJ:0},!1,"scala.Array$",{TJ:1,X5:1,f:1,l:1,k:1});
var Sua=void 0;function Tp(){Sua||(Sua=(new D0).c());return Sua}function F0(){}F0.prototype=new m;F0.prototype.constructor=F0;function Tua(){}Tua.prototype=F0.prototype;F0.prototype.v=function(){return"\x3cfunction1\x3e"};function G0(){}G0.prototype=new m;G0.prototype.constructor=G0;function Uua(){}Uua.prototype=G0.prototype;G0.prototype.v=function(){return"\x3cfunction1\x3e"};function bJ(){this.vl=null}bJ.prototype=new eda;bJ.prototype.constructor=bJ;
bJ.prototype.c=function(){$r.prototype.c.call(this);return this};bJ.prototype.$classData=l({qK:0},!1,"scala.Symbol$",{qK:1,Y5:1,f:1,l:1,k:1});var aJ=void 0;function rN(){}rN.prototype=new m;rN.prototype.constructor=rN;rN.prototype.c=function(){return this};rN.prototype.$classData=l({wK:0},!1,"scala.math.Equiv$",{wK:1,f:1,i6:1,l:1,k:1});var zja=void 0;function vN(){}vN.prototype=new m;vN.prototype.constructor=vN;vN.prototype.c=function(){return this};
vN.prototype.$classData=l({HK:0},!1,"scala.math.Ordering$",{HK:1,f:1,j6:1,l:1,k:1});var Dja=void 0;function H0(){this.WF=null;this.ra=!1}H0.prototype=new m;H0.prototype.constructor=H0;H0.prototype.c=function(){return this};
function hja(){var a;Vua||(Vua=(new H0).c());a=Vua;if(!a.ra&&!a.ra){for(var b=wk().uy,b=(new q).a("Dotty",b),c=wk().zz,c=(new q).a("Paradise211",c),d=wk().Az,d=(new q).a("Paradise212",d),f=wk().Bz,f=(new q).a("ParadiseTypelevel211",f),g=wk().Cz,g=(new q).a("ParadiseTypelevel212",g),h=wk().Hz,h=(new q).a("Sbt0136",h),n=wk().Iz,n=(new q).a("Sbt0137",n),u=wk().Jz,u=(new q).a("Sbt1",u),w=wk().cc,w=(new q).a("Scala210",w),D=wk().Rb,D=(new q).a("Scala211",D),N=wk().mb,N=(new q).a("Scala212",N),Q=wk().mf,
Q=(new q).a("Typelevel211",Q),ea=wk().nf,b=[b,c,d,f,g,h,n,u,w,D,N,Q,(new q).a("Typelevel212",ea)],c=A(new B,C()),d=0,f=b.length|0;d<f;)E(c,b[d]),d=1+d|0;a.WF=c.t;a.ra=!0}return a.WF}H0.prototype.$classData=l({WL:0},!1,"scala.meta.Dialect$",{WL:1,f:1,v6:1,l:1,k:1});var Vua=void 0;function I0(){}I0.prototype=new m;I0.prototype.constructor=I0;I0.prototype.c=function(){return this};I0.prototype.$classData=l({eS:0},!1,"scala.meta.Tree$",{eS:1,f:1,z6:1,l:1,k:1});var Wua=void 0;
function M(){Wua||(Wua=(new I0).c());return Wua}function J0(){nW.call(this);this.Fz=this.Ln=this.In=null}J0.prototype=new Mpa;J0.prototype.constructor=J0;J0.prototype.c=function(){nW.prototype.mc.call(this,0);K0=this;var a=null!==this.Zk&&this.Zk.fb()?this.Zk.bb():"FirstOp";this.In=Xua(this,this.en,a);a=null!==this.Zk&&this.Zk.fb()?this.Zk.bb():"LeftOp";this.Ln=Xua(this,this.en,a);a=null!==this.Zk&&this.Zk.fb()?this.Zk.bb():"RightOp";this.Fz=Xua(this,this.en,a);return this};
J0.prototype.$classData=l({XT:0},!1,"scala.meta.internal.parsers.InfixMode$",{XT:1,W5:1,f:1,l:1,k:1});var K0=void 0;function Lg(){K0||(K0=(new J0).c());return K0}function qI(){this.fu=this.rA=this.Af=null}qI.prototype=new AV;qI.prototype.constructor=qI;qI.prototype.Ev=function(a){this.rA=a;wQ.prototype.Ne.call(this,IK().Ba);this.fu=(G(),(new ae).c());return this};
qI.prototype.Dd=function(a,b){var c=1,d=a.u;pC();d=FQ(d.Ve,b,d.Ve.length|0);d=(new $H).pj((new pT).j(d),this.rA);for(aI(d.ha);0<c;)switch(oI(d),d.Ta.Pb){case 104:c=1+c|0;break;case 105:c=-1+c|0;break;case 0:return jd(this,a.Zj,b+d.Ta.La|0,null,!1)}c=b+d.Ta.La|0;this.fu.ba(Yua(this,b,c));a=a.ji;b=id();return sd(a,void 0,c,b,!1)};qI.prototype.$classData=l({uZ:0},!1,"scala.meta.internal.tokenizers.ScalaExprPositionParser",{uZ:1,ig:1,f:1,pg:1,jg:1});function sW(){}sW.prototype=new m;
sW.prototype.constructor=sW;sW.prototype.c=function(){return this};sW.prototype.v=function(){return"\x3c?\x3e"};sW.prototype.$classData=l({z1:0},!1,"scala.reflect.NoManifest$",{z1:1,f:1,za:1,l:1,k:1});var Opa=void 0;function L0(){}L0.prototype=new m;L0.prototype.constructor=L0;function M0(){}e=M0.prototype=L0.prototype;e.dc=function(){return this};e.ih=function(a,b){Id(this,a,b)};e.ah=function(){return this};e.g=function(){return!this.fb()};e.lb=function(){var a=G().b;return jG(this,a)};
e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.v=function(){return Foa(this)};e.Cb=function(a){QU(this,a)};e.se=function(a,b){return hO(this,a,b)};e.sh=function(){uk();var a=vk().$d;return jG(this,a)};e.Za=function(){return iO(this)};e.we=function(){var a=CV().b;return jG(this,a)};e.Of=function(){return gG(this,"","","")};e.ce=function(){return SU(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Gg=function(a,b){return hO(this,a,b)};
e.rf=function(a,b,c){Ioa(this,a,b,c)};e.ph=function(){return!1};e.Tg=function(){return cj(this)};e.$e=function(a){return lO(this,a)};function N0(){}N0.prototype=new m;N0.prototype.constructor=N0;N0.prototype.c=function(){return this};N0.prototype.$classData=l({i2:0},!1,"scala.collection.convert.Wrappers$",{i2:1,f:1,a7:1,l:1,k:1});var Zua=void 0;function nO(){Zua||(Zua=(new N0).c());return Zua}function O0(){}O0.prototype=new Koa;O0.prototype.constructor=O0;function P0(){}P0.prototype=O0.prototype;
function Q0(){}Q0.prototype=new kua;Q0.prototype.constructor=Q0;Q0.prototype.c=function(){return this};Q0.prototype.KA=function(){return C()};Q0.prototype.$classData=l({O2:0},!1,"scala.collection.immutable.Map$",{O2:1,q2:1,r2:1,n2:1,f:1});var $ua=void 0;function Wja(){$ua||($ua=(new Q0).c());return $ua}function R0(){this.ue=this.pa=this.bg=null}R0.prototype=new m;R0.prototype.constructor=R0;e=R0.prototype;e.bb=function(){return this.ue};
function ava(a){return"(kv: "+a.bg+", "+a.pa+")"+(null!==a.ue?" -\x3e "+ava(a.ue):"")}e.a=function(a,b){this.bg=a;this.pa=b;return this};e.v=function(){return ava(this)};e.Gi=function(){return this.bg};e.qo=function(a){this.ue=a};e.$classData=l({O3:0},!1,"scala.collection.mutable.DefaultEntry",{O3:1,f:1,nx:1,l:1,k:1});function S0(){this.t=this.Pg=null}S0.prototype=new m;S0.prototype.constructor=S0;function bva(a,b){a.Pg=b;a.t=b;return a}e=S0.prototype;e.ee=function(a){this.t.ee(a);return this};
e.da=function(){return this.t};e.ii=function(a,b){iV(this,a,b)};e.ba=function(a){this.t.ee(a);return this};e.je=function(){};e.$c=function(a){return GO(this,a)};e.$classData=l({S3:0},!1,"scala.collection.mutable.GrowingBuilder",{S3:1,f:1,Fe:1,Ee:1,De:1});function T0(){this.ue=this.at=this.GA=this.bg=null}T0.prototype=new m;T0.prototype.constructor=T0;e=T0.prototype;e.bb=function(){return this.ue};e.e=function(a){this.bg=a;this.at=this.GA=null;return this};e.Gi=function(){return this.bg};
e.qo=function(a){this.ue=a};e.$classData=l({d4:0},!1,"scala.collection.mutable.LinkedHashSet$Entry",{d4:1,f:1,nx:1,l:1,k:1});function U0(){this.cw=this.sA=null;this.va=0}U0.prototype=new m;U0.prototype.constructor=U0;e=U0.prototype;e.bb=function(){var a=this.cw[this.va];this.va=1+this.va|0;var b=this.sA;if(as().dk.call(b,a))b=b[a];else throw(new BP).j("key not found: "+a);return(new q).a(a,b)};e.dc=function(){return this};e.ih=function(a,b){Id(this,a,b)};e.ah=function(){return this};e.g=function(){return!this.fb()};
e.lb=function(){var a=G().b;return jG(this,a)};e.Jm=function(a){this.sA=a;this.cw=ca.Object.keys(a);this.va=0;return this};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.v=function(){return Foa(this)};e.Cb=function(a){QU(this,a)};e.se=function(a,b){return hO(this,a,b)};e.sh=function(){uk();var a=vk().$d;return jG(this,a)};e.Za=function(){return iO(this)};e.we=function(){var a=CV().b;return jG(this,a)};e.fb=function(){return this.va<(this.cw.length|0)};
e.Of=function(){return gG(this,"","","")};e.ce=function(){return SU(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Gg=function(a,b){return hO(this,a,b)};e.rf=function(a,b,c){Ioa(this,a,b,c)};e.ph=function(){return!1};e.Tg=function(){return cj(this)};e.$e=function(a){return lO(this,a)};e.$classData=l({s4:0},!1,"scala.scalajs.js.WrappedDictionary$DictionaryIterator",{s4:1,f:1,Dg:1,tb:1,sb:1});function Ep(){this.Ya=this.Ra=0}Ep.prototype=new hR;Ep.prototype.constructor=Ep;e=Ep.prototype;
e.bi=function(){return Ya(this)};e.Ap=function(){return this.Ra<<24>>24};e.w=function(a){return ya(a)?this.Ra===a.Ra&&this.Ya===a.Ya:!1};e.Be=function(a,b,c){Ep.prototype.K.call(this,a|b<<22,b>>10|c<<12);return this};e.v=function(){return tH(ab(),this.Ra,this.Ya)};e.K=function(a,b){this.Ra=a;this.Ya=b;return this};e.mc=function(a){Ep.prototype.K.call(this,a,a>>31);return this};e.Qq=function(){return this.Ra<<16>>16};e.oj=function(){return sM(ab(),this.Ra,this.Ya)};e.A=function(){return this.Ra^this.Ya};
e.oh=function(){return this.Ra};e.Fm=function(){return ga(sM(ab(),this.Ra,this.Ya))};function ya(a){return!!(a&&a.$classData&&a.$classData.H.SF)}e.$classData=l({SF:0},!1,"scala.scalajs.runtime.RuntimeLong",{SF:1,bk:1,f:1,k:1,xf:1});function V0(){this.pa=0}V0.prototype=new m;V0.prototype.constructor=V0;e=V0.prototype;e.U=function(){return"Offset"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Gy?this.pa===a.pa:!1};
e.W=function(a){switch(a){case 0:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.mc=function(a){this.pa=a;return this};e.A=function(){var a=-889275714,a=Y().Gb(a,this.pa);return Y().xd(a,1)};e.L=function(){return Z(this)};e.$classData=l({Gy:0},!1,"ch.epfl.scala.accessible.Offset",{Gy:1,f:1,R:1,x:1,l:1,k:1});function ad(){this.Ca=this.E=0}ad.prototype=new m;ad.prototype.constructor=ad;e=ad.prototype;e.U=function(){return"Range"};e.M=function(){return 2};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Hy?this.E===a.E&&this.Ca===a.Ca:!1};e.W=function(a){switch(a){case 0:return this.E;case 1:return this.Ca;default:throw(new W).j(""+a);}};e.K=function(a,b){this.E=a;this.Ca=b;return this};e.v=function(){return cQ(this)};e.A=function(){var a=-889275714,a=Y().Gb(a,this.E),a=Y().Gb(a,this.Ca);return Y().xd(a,2)};e.L=function(){return Z(this)};e.$classData=l({Hy:0},!1,"ch.epfl.scala.accessible.Range",{Hy:1,f:1,R:1,x:1,l:1,k:1});
function W0(){this.va=0;this.so=null}W0.prototype=new m;W0.prototype.constructor=W0;e=W0.prototype;e.U=function(){return"Frame"};e.M=function(){return 2};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Iy&&this.va===a.va){var b=this.so;a=a.so;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.va;case 1:return this.so;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};function zaa(a,b){var c=new W0;c.va=a;c.so=b;return c}
e.A=function(){var a=-889275714,a=Y().Gb(a,this.va),a=Y().Gb(a,YN(Y(),this.so));return Y().xd(a,2)};e.L=function(){return Z(this)};e.$classData=l({Iy:0},!1,"fastparse.core.Frame",{Iy:1,f:1,R:1,x:1,l:1,k:1});function X0(){}X0.prototype=new m;X0.prototype.constructor=X0;X0.prototype.c=function(){return this};function bla(){cva||(cva=(new X0).c());return(new KQ).vv(Wm(function(){return function(a,b){return b}}(cva)))}
X0.prototype.$classData=l({LG:0},!1,"fastparse.core.Implicits$Sequencer$",{LG:1,f:1,d5:1,e5:1,l5:1,i5:1});var cva=void 0;function rI(){this.u=null;this.lf=this.Sg=0;this.vj=null;this.uj=0;this.Km=null;this.Gl=this.Fl=this.Zh=!1;this.ji=this.Zj=null}rI.prototype=new m;rI.prototype.constructor=rI;e=rI.prototype;e.U=function(){return"ParseCtx"};e.M=function(){return 9};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Ly){var b=this.u,c=a.u;(null===b?null===c:b.w(c))&&this.Sg===a.Sg&&this.lf===a.lf?(b=this.vj,c=a.vj,b=null===b?null===c:b.w(c)):b=!1;return b&&this.uj===a.uj&&this.Km===a.Km&&this.Zh===a.Zh&&this.Fl===a.Fl?this.Gl===a.Gl:!1}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Sg;case 2:return this.lf;case 3:return this.vj;case 4:return this.uj;case 5:return this.Km;case 6:return this.Zh;case 7:return this.Fl;case 8:return this.Gl;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};
function tia(a,b,c,d,f,g){a.u=b;a.Sg=0;a.lf=c;a.vj=d;a.uj=f;a.Km=g;a.Zh=!1;a.Fl=!1;a.Gl=!1;if(!(-1<=a.Sg))throw(new t).j("requirement failed: logDepth can only be -1 (for no logs) or \x3e\x3d 0");if(!(-1<=c))throw(new t).j("requirement failed: traceIndex can only be -1 (for no tracing) or an index 0");g=new Y0;dva||(dva=(new Z0).c());var h=uu(dva,F()),n=id();g.u=b;g.Fi=h;g.va=0;g.zg=null;g.vj=d;g.uj=f;g.lf=c;g.nd=n;g.id=!1;a.Zj=g;b=new $0;c=id();b.pa=null;b.va=0;b.nd=c;b.id=!1;a.ji=b;return a}
e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.u)),a=Y().Gb(a,this.Sg),a=Y().Gb(a,this.lf),a=Y().Gb(a,YN(Y(),this.vj)),a=Y().Gb(a,this.uj),a=Y().Gb(a,YN(Y(),this.Km)),a=Y().Gb(a,this.Zh?1231:1237),a=Y().Gb(a,this.Fl?1231:1237),a=Y().Gb(a,this.Gl?1231:1237);return Y().xd(a,9)};e.L=function(){return Z(this)};e.$classData=l({Ly:0},!1,"fastparse.core.ParseCtx",{Ly:1,f:1,R:1,x:1,l:1,k:1});function OQ(){this.u=this.Pi=this.OA=null;this.va=0;this.nd=this.Fi=null;this.ra=0}OQ.prototype=new m;
OQ.prototype.constructor=OQ;e=OQ.prototype;e.U=function(){return"TracedFailure"};e.M=function(){return 4};function via(a){if(0===(1&a.ra)&&0===(1&a.ra)){var b=new PQ;if(null===a)throw jo(wj(),null);b.r=a;a.OA=b;a.ra|=1}return a.OA}e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.My){var b=this.u,c=a.u;(null===b?null===c:b.w(c))&&this.va===a.va?(b=this.Fi,c=a.Fi,b=null===b?null===c:a1(b,c)):b=!1;if(b)return b=this.nd,a=a.nd,null===b?null===a:b1(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.va;case 2:return this.Fi;case 3:return this.nd;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};function Xka(a,b,c,d,f){a.u=b;a.va=c;a.Fi=d;a.nd=f;return a}e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.u)),a=Y().Gb(a,this.va),a=Y().Gb(a,YN(Y(),this.Fi)),a=Y().Gb(a,YN(Y(),this.nd));return Y().xd(a,4)};e.L=function(){return Z(this)};
e.$classData=l({My:0},!1,"fastparse.core.Parsed$TracedFailure",{My:1,f:1,R:1,x:1,l:1,k:1});function c1(){this.Hi=null;this.id=!1;this.MA=null}c1.prototype=new m;c1.prototype.constructor=c1;e=c1.prototype;e.U=function(){return"Chain"};e.M=function(){return 2};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Ty){var b=this.Hi,c=a.Hi;return(null===b?null===c:b.w(c))?this.id===a.id:!1}return!1};
e.W=function(a){switch(a){case 0:return this.Hi;case 1:return this.id;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};function bpa(a,b,c){var d=new c1;d.Hi=a;d.id=b;d.MA=c;return d}e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.Hi)),a=Y().Gb(a,this.id?1231:1237);return Y().xd(a,2)};e.L=function(){return Z(this)};e.$classData=l({Ty:0},!1,"fastparse.parsers.Combinators$Sequence$Chain",{Ty:1,f:1,R:1,x:1,l:1,k:1});function d1(){BQ.call(this)}d1.prototype=new Cua;
d1.prototype.constructor=d1;function eva(){}eva.prototype=d1.prototype;d1.prototype.Dd=function(a,b){var c=a.u;return e1(c,b)&&(c=65535&(c.Ve.charCodeAt(b)|0),Dua(this,(new ed).db(c)))?(a=a.ji,b=1+b|0,c=id(),sd(a,void 0,b,c,!1)):jd(this,a.Zj,b,null,!1)};function f1(){}f1.prototype=new Fua;f1.prototype.constructor=f1;function fva(){}fva.prototype=f1.prototype;f1.prototype.JI=function(){return this};function Jq(){Rn.call(this)}Jq.prototype=new r0;Jq.prototype.constructor=Jq;
Jq.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};Jq.prototype.$classData=l({Du:0},!1,"java.nio.BufferOverflowException",{Du:1,Nf:1,ae:1,vd:1,f:1,k:1});function Lq(){Rn.call(this)}Lq.prototype=new r0;Lq.prototype.constructor=Lq;Lq.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};Lq.prototype.$classData=l({Eu:0},!1,"java.nio.BufferUnderflowException",{Eu:1,Nf:1,ae:1,vd:1,f:1,k:1});function g1(){Rn.call(this)}g1.prototype=new Eua;
g1.prototype.constructor=g1;function gva(){}gva.prototype=g1.prototype;function br(){}br.prototype=new sV;br.prototype.constructor=br;br.prototype.c=function(){return this};br.prototype.v=function(){return"Denotation"};br.prototype.ug=function(a,b){var c=new h1;c.pa=a;c.Dj=b;return c};br.prototype.$classData=l({YH:0},!1,"org.langmeta.inputs.Input$Denotation$",{YH:1,Lt:1,f:1,xr:1,l:1,k:1});var Pca=void 0;function cr(){}cr.prototype=new uV;cr.prototype.constructor=cr;cr.prototype.c=function(){return this};
cr.prototype.v=function(){return"Slice"};cr.prototype.tp=function(a,b,c){return(new qC).ib(a,b|0,c|0)};cr.prototype.$classData=l({aI:0},!1,"org.langmeta.inputs.Input$Slice$",{aI:1,Mt:1,f:1,yr:1,l:1,k:1});var Qca=void 0;function Xq(){}Xq.prototype=new qV;Xq.prototype.constructor=Xq;Xq.prototype.c=function(){return this};Xq.prototype.Ea=function(a){return(new pT).j(a)};Xq.prototype.v=function(){return"String"};
Xq.prototype.$classData=l({cI:0},!1,"org.langmeta.inputs.Input$String$",{cI:1,zx:1,f:1,Mb:1,l:1,k:1});var Kca=void 0;function ar(){}ar.prototype=new Voa;ar.prototype.constructor=ar;ar.prototype.c=function(){return this};ar.prototype.v=function(){return"Synthetic"};ar.prototype.$classData=l({dI:0},!1,"org.langmeta.inputs.Input$Synthetic$",{dI:1,G4:1,f:1,nG:1,l:1,k:1});var Oca=void 0;function $q(){}$q.prototype=new sV;$q.prototype.constructor=$q;$q.prototype.c=function(){return this};
$q.prototype.v=function(){return"VirtualFile"};$q.prototype.ug=function(a,b){return(new KT).Ps(a,b)};$q.prototype.$classData=l({eI:0},!1,"org.langmeta.inputs.Input$VirtualFile$",{eI:1,Lt:1,f:1,xr:1,l:1,k:1});var Nca=void 0;function hr(){}hr.prototype=new uV;hr.prototype.constructor=hr;hr.prototype.c=function(){return this};hr.prototype.v=function(){return"Range"};hr.prototype.tp=function(a,b,c){return(new Ms).ib(a,b|0,c|0)};
hr.prototype.$classData=l({hI:0},!1,"org.langmeta.inputs.Position$Range$",{hI:1,Mt:1,f:1,yr:1,l:1,k:1});var Sca=void 0;function i1(){this.gd=this.He=null}i1.prototype=new m;i1.prototype.constructor=i1;e=i1.prototype;e.U=function(){return"Fragment"};e.M=function(){return 2};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.mz){var b=this.He,c=a.He;if(null===b?null===c:b.w(c))return b=this.gd,a=a.gd,null===b?null===a:b.w(a)}return!1};
e.W=function(a){switch(a){case 0:return this.He;case 1:return this.gd;default:throw(new W).j(""+a);}};e.v=function(){var a;a=Nua(this.He.T4());if(zj(Ga(),a.rq,".jar")){Uca||(Uca=(new or).c());var b;b=this.gd.v();if(47!==(65535&(nca().charCodeAt(0)|0))){var c=65535&(nca().charCodeAt(0)|0),c=ca.String.fromCharCode(c),d=ca.String.fromCharCode(47);b=b.split(c).join(d)}a=(new n0).j(td((new yd).X((new r).d(["jar:","!/",""])),(new r).d([a,b])))}else a=Nua(this.He.T5(this.gd).T4());return a.rq};e.A=function(){return WN(this)};
e.L=function(){return Z(this)};e.$classData=l({mz:0},!1,"org.langmeta.io.Fragment",{mz:1,f:1,R:1,x:1,l:1,k:1});function j1(){}j1.prototype=new sV;j1.prototype.constructor=j1;j1.prototype.c=function(){return this};j1.prototype.v=function(){return"Fragment"};j1.prototype.ug=function(a,b){var c=new i1;c.He=a;c.gd=b;return c};j1.prototype.$classData=l({oI:0},!1,"org.langmeta.io.Fragment$",{oI:1,Lt:1,f:1,xr:1,l:1,k:1});var hva=void 0;function k1(){}k1.prototype=new Voa;k1.prototype.constructor=k1;
k1.prototype.c=function(){return this};k1.prototype.$classData=l({qI:0},!1,"org.langmeta.semanticdb.Denotation$",{qI:1,G4:1,f:1,nG:1,l:1,k:1});var iva=void 0;function l1(){}l1.prototype=new Woa;l1.prototype.constructor=l1;l1.prototype.c=function(){return this};l1.prototype.v=function(){return"Document"};l1.prototype.$classData=l({rI:0},!1,"org.langmeta.semanticdb.Document$",{rI:1,m7:1,f:1,Y4:1,l:1,k:1});var jva=void 0;function m1(){this.ok=this.Pq=this.bj=null}m1.prototype=new m;
m1.prototype.constructor=m1;e=m1.prototype;e.U=function(){return"Message"};e.be=function(){return td((new yd).X((new r).d(["[","..","): "," ",""])),(new r).d([this.bj.ab(),this.bj.wa(),this.Pq.be(),this.ok]))};e.M=function(){return 3};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.nz){var b=this.bj,c=a.bj;(null===b?null===c:b.w(c))?(b=this.Pq,c=a.Pq,b=null===b?null===c:b.w(c)):b=!1;return b?this.ok===a.ok:!1}return!1};
e.W=function(a){switch(a){case 0:return this.bj;case 1:return this.Pq;case 2:return this.ok;default:throw(new W).j(""+a);}};e.v=function(){return this.be()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({nz:0},!1,"org.langmeta.semanticdb.Message",{nz:1,f:1,R:1,x:1,l:1,k:1});function n1(){}n1.prototype=new uV;n1.prototype.constructor=n1;n1.prototype.c=function(){return this};n1.prototype.v=function(){return"Message"};
n1.prototype.tp=function(a,b,c){var d=new m1;d.bj=a;d.Pq=b;d.ok=c;return d};n1.prototype.$classData=l({sI:0},!1,"org.langmeta.semanticdb.Message$",{sI:1,Mt:1,f:1,yr:1,l:1,k:1});var kva=void 0;function o1(){this.Jp=this.Dj=null}o1.prototype=new m;o1.prototype.constructor=o1;e=o1.prototype;e.U=function(){return"ResolvedSymbol"};e.be=function(){return td((new yd).X((new r).d([""," \x3d\x3e ",""])),(new r).d([this.Dj.be(),this.Jp.be()]))};e.M=function(){return 2};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.oz){var b=this.Dj,c=a.Dj;if(null===b?null===c:b.w(c))return b=this.Jp,a=a.Jp,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Dj;case 1:return this.Jp;default:throw(new W).j(""+a);}};e.v=function(){return this.be()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({oz:0},!1,"org.langmeta.semanticdb.ResolvedSymbol",{oz:1,f:1,R:1,x:1,l:1,k:1});function p1(){}
p1.prototype=new sV;p1.prototype.constructor=p1;p1.prototype.c=function(){return this};p1.prototype.v=function(){return"ResolvedSymbol"};p1.prototype.ug=function(a,b){var c=new o1;c.Dj=a;c.Jp=b;return c};p1.prototype.$classData=l({uI:0},!1,"org.langmeta.semanticdb.ResolvedSymbol$",{uI:1,Lt:1,f:1,xr:1,l:1,k:1});var lva=void 0;function q1(){this.nq=this.ok=this.bj=null}q1.prototype=new m;q1.prototype.constructor=q1;e=q1.prototype;e.U=function(){return"Synthetic"};
e.be=function(){var a=spa(upa(),this.nq);return td((new yd).X((new r).d(["[","..","): ","",""])),(new r).d([this.bj.ab(),this.bj.wa(),this.ok,a]))};e.M=function(){return 3};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.pz){var b=this.bj,c=a.bj;if((null===b?null===c:b.w(c))&&this.ok===a.ok)return b=this.nq,a=a.nq,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.bj;case 1:return this.ok;case 2:return this.nq;default:throw(new W).j(""+a);}};
e.v=function(){return this.be()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({pz:0},!1,"org.langmeta.semanticdb.Synthetic",{pz:1,f:1,R:1,x:1,l:1,k:1});function r1(){}r1.prototype=new uV;r1.prototype.constructor=r1;r1.prototype.c=function(){return this};r1.prototype.v=function(){return"Synthetic"};r1.prototype.tp=function(a,b,c){var d=new q1;d.bj=a;d.ok=b;d.nq=c;return d};
r1.prototype.$classData=l({wI:0},!1,"org.langmeta.semanticdb.Synthetic$",{wI:1,Mt:1,f:1,yr:1,l:1,k:1});var mva=void 0;function HV(){Rn.call(this)}HV.prototype=new r0;HV.prototype.constructor=HV;HV.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};function s1(a){return!!(a&&a.$classData&&a.$classData.H.wB)}HV.prototype.$classData=l({wB:0},!1,"java.lang.ArithmeticException",{wB:1,Nf:1,ae:1,vd:1,f:1,k:1});function t(){Rn.call(this)}t.prototype=new r0;t.prototype.constructor=t;
function t1(){}t1.prototype=t.prototype;t.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};t.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};t.prototype.$classData=l({Wm:0},!1,"java.lang.IllegalArgumentException",{Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function Cq(){Rn.call(this)}Cq.prototype=new r0;Cq.prototype.constructor=Cq;function nva(){}nva.prototype=Cq.prototype;Cq.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};
Cq.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};Cq.prototype.$classData=l({AB:0},!1,"java.lang.IllegalStateException",{AB:1,Nf:1,ae:1,vd:1,f:1,k:1});function W(){Rn.call(this)}W.prototype=new r0;W.prototype.constructor=W;function ova(){}ova.prototype=W.prototype;W.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};W.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};
W.prototype.$classData=l({$v:0},!1,"java.lang.IndexOutOfBoundsException",{$v:1,Nf:1,ae:1,vd:1,f:1,k:1});function u1(){}u1.prototype=new Fua;u1.prototype.constructor=u1;u1.prototype.c=function(){return this};u1.prototype.$classData=l({gJ:0},!1,"java.lang.JSConsoleBasedPrintStream$DummyOutputStream",{gJ:1,oH:1,f:1,Cu:1,xB:1,ez:1});function t0(){Rn.call(this)}t0.prototype=new r0;t0.prototype.constructor=t0;t0.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};
t0.prototype.$classData=l({kJ:0},!1,"java.lang.NegativeArraySizeException",{kJ:1,Nf:1,ae:1,vd:1,f:1,k:1});function fk(){Rn.call(this)}fk.prototype=new r0;fk.prototype.constructor=fk;fk.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};fk.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};fk.prototype.$classData=l({lJ:0},!1,"java.lang.NullPointerException",{lJ:1,Nf:1,ae:1,vd:1,f:1,k:1});function Gq(){Rn.call(this)}Gq.prototype=new r0;
Gq.prototype.constructor=Gq;function pva(){}pva.prototype=Gq.prototype;Gq.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};Gq.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};Gq.prototype.$classData=l({DB:0},!1,"java.lang.UnsupportedOperationException",{DB:1,Nf:1,ae:1,vd:1,f:1,k:1});function v1(){}v1.prototype=new Lpa;v1.prototype.constructor=v1;function qva(){}qva.prototype=v1.prototype;
v1.prototype.w=function(a){return a===this?!0:a&&a.$classData&&a.$classData.H.aw?a.Za()===this.Za()&&this.iA(a):!1};v1.prototype.A=function(){var a=mR(),b=this.Jl();return OO(BO(a,b).Wd).se(0,Wm(function(){return function(a,b){a|=0;return Ca(b)+a|0}}(this)))|0};function pR(){qR.call(this);this.Lb=null}pR.prototype=new Pua;pR.prototype.constructor=pR;pR.prototype.$classData=l({EJ:0},!1,"java.util.HashMap$EntrySet$$anon$2$$anon$1",{EJ:1,N5:1,f:1,KJ:1,l:1,k:1});function BP(){Rn.call(this)}
BP.prototype=new r0;BP.prototype.constructor=BP;BP.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};BP.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};BP.prototype.$classData=l({NJ:0},!1,"java.util.NoSuchElementException",{NJ:1,Nf:1,ae:1,vd:1,f:1,k:1});function NM(){this.Dl=null}NM.prototype=new m;NM.prototype.constructor=NM;e=NM.prototype;e.U=function(){return"Box"};e.M=function(){return 1};
e.w=function(a){if(a&&a.$classData&&a.$classData.H.IB){var b=this.Dl;a=a.Dl;return null===b?null===a:Aa(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.Dl;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.e=function(a){this.Dl=a;return this};e.A=function(){return null===this.Dl?0:Ca(this.Dl)};e.L=function(){return Z(this)};e.$classData=l({IB:0},!1,"java.util.package$Box",{IB:1,f:1,R:1,x:1,l:1,k:1});function w1(){this.r=this.dx=null}w1.prototype=new m;
w1.prototype.constructor=w1;function rva(){}rva.prototype=w1.prototype;w1.prototype.w=function(a){return a&&a.$classData&&a.$classData.H.XJ?this.dx===a.dx&&this.Me===a.Me:!1};w1.prototype.qf=function(a){return this.Me<a.Me?-1:this.Me===a.Me?0:1};w1.prototype.QI=function(a){if(null===a)throw jo(wj(),null);this.dx=this.r=a;return this};w1.prototype.A=function(){return this.Me};function p(){Rn.call(this);this.qq=this.VB=null;this.Wh=!1}p.prototype=new r0;p.prototype.constructor=p;
p.prototype.Ak=function(){if(!this.Wh&&!this.Wh){var a;if(null===this.qq)a="null";else try{a=pa(this.qq)+" ("+("of class "+Md(ra(this.qq)))+")"}catch(b){if(null!==vj(wj(),b))a="an instance of class "+Md(ra(this.qq));else throw b;}this.VB=a;this.Wh=!0}return this.VB};p.prototype.e=function(a){this.qq=a;Rn.prototype.fd.call(this,null,null);return this};p.prototype.$classData=l({$J:0},!1,"scala.MatchError",{$J:1,Nf:1,ae:1,vd:1,f:1,k:1});function x1(){}x1.prototype=new m;x1.prototype.constructor=x1;
function sva(){}sva.prototype=x1.prototype;x1.prototype.lb=function(){return this.g()?F():U(new V,this.q(),F())};function ks(){this.NB=null}ks.prototype=new m;ks.prototype.constructor=ks;e=ks.prototype;e.c=function(){this.NB=lk(function(){return function(){return S()}}(this));return this};e.Ea=function(a){this.Ru(a)};e.xq=function(){return fs().HE};e.v=function(){return"\x3cfunction1\x3e"};e.vf=function(){return!1};e.Vh=function(a,b){return gs(this,a,b)};e.Ru=function(a){throw(new p).e(a);};
e.hq=function(){return this.NB};e.$classData=l({dK:0},!1,"scala.PartialFunction$$anon$1",{dK:1,f:1,Uc:1,Mb:1,l:1,k:1});function y1(){this.dC=null}y1.prototype=new qV;y1.prototype.constructor=y1;y1.prototype.Ea=function(a){return this.up(a)};function d0(a){var b=new y1;b.dC=a;return b}y1.prototype.up=function(a){a=this.dC.Vh(a,fs().Do);return fs().Do===a?S():(new T).e(a)};y1.prototype.$classData=l({fK:0},!1,"scala.PartialFunction$Lifted",{fK:1,zx:1,f:1,Mb:1,l:1,k:1});function tW(){}tW.prototype=new Uua;
tW.prototype.constructor=tW;tW.prototype.c=function(){return this};tW.prototype.Ea=function(a){return a};tW.prototype.$classData=l({hK:0},!1,"scala.Predef$$anon$1",{hK:1,a6:1,f:1,Mb:1,l:1,k:1});function uW(){}uW.prototype=new Tua;uW.prototype.constructor=uW;uW.prototype.c=function(){return this};uW.prototype.Ea=function(a){return a};uW.prototype.$classData=l({iK:0},!1,"scala.Predef$$anon$2",{iK:1,$5:1,f:1,Mb:1,l:1,k:1});function yd(){this.aj=null}yd.prototype=new m;yd.prototype.constructor=yd;e=yd.prototype;
e.U=function(){return"StringContext"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.rC){var b=this.aj;a=a.aj;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.aj;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};function tva(a,b){if(a.aj.Fa()!==(1+b.Fa()|0))throw(new t).j("wrong number of arguments ("+b.Fa()+") for interpolated string with "+a.aj.Fa()+" parts");}
function td(a,b){var c=function(){return function(a){Ppa||(Ppa=(new FW).c());var b;a:{var c=a.length|0,d=mba(Ga(),a,92);switch(d){case -1:b=a;break a;default:b=(new s0).c();b:{var f=d,d=0;for(;;)if(0<=f){if(f>d){var D=b,d=Oa(null===a?"null":a,d,f);D.ac=""+D.ac+d}d=1+f|0;if(d>=c)throw(new z1).ui(a,f);D=65535&(a.charCodeAt(d)|0);switch(D){case 98:f=8;break;case 116:f=9;break;case 110:f=10;break;case 102:f=12;break;case 114:f=13;break;case 34:f=34;break;case 39:f=39;break;case 92:f=92;break;default:if(48<=
D&&55>=D)f=65535&(a.charCodeAt(d)|0),D=-48+f|0,d=1+d|0,d<c&&48<=(65535&(a.charCodeAt(d)|0))&&55>=(65535&(a.charCodeAt(d)|0))&&(D=-48+((D<<3)+(65535&(a.charCodeAt(d)|0))|0)|0,d=1+d|0,d<c&&51>=f&&48<=(65535&(a.charCodeAt(d)|0))&&55>=(65535&(a.charCodeAt(d)|0))&&(D=-48+((D<<3)+(65535&(a.charCodeAt(d)|0))|0)|0,d=1+d|0)),d=-1+d|0,f=65535&D;else throw(new z1).ui(a,f);}d=1+d|0;Oua(b,f);f=d;Ga();var D=a,N=Cka(92),D=D.indexOf(N,d)|0,d=f,f=D}else{d<c&&(f=b,a=Oa(null===a?"null":a,d,c),f.ac=""+f.ac+a);b=b.ac;
break b}}}}return b}}(a);tva(a,b);a=a.aj.Jb();b=b.Jb();for(var d=a.bb(),d=(new s0).j(c(d));b.fb();){var f=b.bb();d.ac=""+d.ac+f;f=a.bb();f=c(f);d.ac=""+d.ac+f}return d.ac}e.X=function(a){this.aj=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({rC:0},!1,"scala.StringContext",{rC:1,f:1,R:1,x:1,l:1,k:1});
function A1(){this.cf=this.Mg=this.tg=this.Eh=this.sg=this.Dh=this.hh=this.Uh=this.Lg=this.Ch=this.Kg=this.Th=this.gh=this.Bh=this.Sh=this.Rh=this.fh=this.eh=this.Jg=this.kg=this.dh=this.rg=this.Ig=!1;this.th=null}A1.prototype=new m;A1.prototype.constructor=A1;e=A1.prototype;e.U=function(){return"Dialect"};e.M=function(){return 24};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Ig;case 1:return this.rg;case 2:return this.dh;case 3:return this.kg;case 4:return this.Jg;case 5:return this.eh;case 6:return this.fh;case 7:return this.Rh;case 8:return this.Sh;case 9:return this.Bh;case 10:return this.gh;case 11:return this.Th;case 12:return this.Kg;case 13:return this.Ch;case 14:return this.Lg;case 15:return this.Uh;case 16:return this.hh;case 17:return this.Dh;case 18:return this.sg;case 19:return this.Eh;case 20:return this.tg;case 21:return this.Mg;
case 22:return this.cf;case 23:return this.th;default:throw(new W).j(""+a);}};e.v=function(){var a=hja().Jb();a:{for(;a.fb();){var b=a.bb(),c=b.p();if(null!==c&&Aa(c,this)){a=(new T).e(b);break a}}a=S()}if(zh(a)&&(b=a.Y,null!==b))return b.qa();if(S()===a)return a=(new yd).X((new r).d(["Dialect(",")"])),b=Ro(new So,Z(this),lk(function(){return function(a){return pa(a)}}(this))),td(a,(new r).d([gG(b,"",", ","")]));throw(new p).e(a);};
function Is(a,b,c,d,f,g,h,n,u,w,D,N,Q,ea,ba,ma,La,Pa,Qa,Ka,Ba,va,za,qa){var la=new A1;la.Ig=a;la.rg=b;la.dh=c;la.kg=d;la.Jg=f;la.eh=g;la.fh=h;la.Rh=n;la.Sh=u;la.Bh=w;la.gh=D;la.Th=N;la.Kg=Q;la.Ch=ea;la.Lg=ba;la.Uh=ma;la.hh=La;la.Dh=Pa;la.sg=Qa;la.Eh=Ka;la.tg=Ba;la.Mg=va;la.cf=za;la.th=qa;null!==qa?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.toplevelSeparator is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();la=[(new q).a("Dialect",
la)];d=A(new B,C());f=0;for(g=la.length|0;f<g;)E(d,la[f]),f=1+f|0;K(c,"this.toplevelSeparator.!\x3d(null)",b,d.t)}throw(new p).e(a);}return la}function ke(a){return a.Uh||a.Ch}e.A=function(){return Ia(this)};e.L=function(){return Z(this)};e.$classData=l({VL:0},!1,"scala.meta.Dialect",{VL:1,f:1,R:1,x:1,l:1,k:1});function XE(){this.r=this.Bn=this.Wd=this.gq=this.$i=this.mo=null}XE.prototype=new m;XE.prototype.constructor=XE;e=XE.prototype;e.U=function(){return"UnfinishedInfix"};e.M=function(){return 5};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.IC&&a.r===this.r){var b=this.mo,c=a.mo;(null===b?null===c:b.w(c))&&dj(ej(),this.$i,a.$i)?(b=this.gq,c=a.gq,b=null===b?null===c:b.w(c)):b=!1;b?(b=this.Wd,c=a.Wd,b=null===b?null===c:b===c):b=!1;if(b)return b=this.Bn,a=a.Bn,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.mo;case 1:return this.$i;case 2:return this.gq;case 3:return this.Wd;case 4:return this.Bn;default:throw(new W).j(""+a);}};
e.v=function(){var a=!1,b=null,c=this.$i;a:if(eG(c))a=to(uo(),c);else{if(Ty(c)){a=!0;b=c;G();var d=(new T).e(b);if(null!==d.Y&&0===qo(d.Y,1)){a=ro(d.Y,0);a=pa(a);break a}}if(a)G(),a=(new T).e(b).Y,a="("+gG(a,"",", ","")+")";else throw(new p).e(c);}b=cj(this.Bn)?"["+gG(this.Bn,"",", ","")+"]":"";return td((new yd).X((new r).d(["["," ","","]"])),(new r).d([a,this.Wd,b]))};e.cl=function(){return eh(this.Wd).cl()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.$classData=l({IC:0},!1,"scala.meta.internal.parsers.ScalametaParser$InfixContext$UnfinishedInfix",{IC:1,f:1,R:1,x:1,l:1,k:1});function kg(){this.Dc=0;this.r=null}kg.prototype=new m;kg.prototype.constructor=kg;e=kg.prototype;e.ih=function(a,b){Id(this,a,b)};e.dc=function(){return this};e.bb=function(){return this.ia()};e.ah=function(){return this};e.lb=function(){var a=G().b;return jG(this,a)};e.g=function(){return!this.fb()};e.le=function(a,b,c){return gG(this,a,b,c)};
e.Pd=function(a){return gG(this,"",a,"")};e.v=function(){return Foa(this)};e.Cb=function(a){QU(this,a)};e.se=function(a,b){return hO(this,a,b)};function x(a){return Dg(oC(a.r),a.Dc)}e.sh=function(){uk();var a=vk().$d;return jG(this,a)};function qf(a){if(0<a.Dc){var b=mga(a.r),c=a.Dc;a=-1+oC(a.r).Fa()|0;return b.i[-1+(c<a?c:a)|0]}return-1}e.we=function(){var a=CV().b;return jG(this,a)};e.Za=function(){return iO(this)};
e.ia=function(){if(!this.fb())throw(new BP).c();this.Dc=1+this.Dc|0;return Dg(oC(this.r),this.Dc)};e.fb=function(){return this.Dc<(-1+oC(this.r).Fa()|0)};e.Of=function(){return gG(this,"","","")};e.ce=function(){return SU(this)};
e.Ia=function(a,b){this.Dc=b;if(null===a)throw jo(wj(),null);this.r=a;b=oC(a);if(cj(b))b=(new q).a(!0,F());else{G();b=(new r).d(["ScalametaParser.this.parserTokens.nonEmpty is false"]);var c=G().b;b=(new q).a(!1,H(b,c))}if(null===b||!0!==I(b)){if(null!==b&&(c=b.p(),!1===I(b))){var d=J();a=[(new q).a("ScalametaParser",a)];for(var f=A(new B,C()),g=0,h=a.length|0;g<h;)E(f,a[g]),g=1+g|0;K(d,"ScalametaParser.this.parserTokens.nonEmpty",c,f.t)}throw(new p).e(b);}-1===this.Dc&&this.ia();return this};
e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};function Tf(a){if(-1<a.Dc){var b=mga(a.r),c=a.Dc;a=-1+oC(a.r).Fa()|0;return b.i[c<a?c:a]}return-1}e.Gg=function(a,b){return hO(this,a,b)};e.rf=function(a,b,c){Ioa(this,a,b,c)};e.ph=function(){return!1};e.Tg=function(){return cj(this)};e.$e=function(a){return lO(this,a)};e.$classData=l({$X:0},!1,"scala.meta.internal.parsers.ScalametaParser$SimpleTokenIterator",{$X:1,f:1,x6:1,Dg:1,tb:1,sb:1});function CB(){this.Lb=null}CB.prototype=new qV;
CB.prototype.constructor=CB;CB.prototype.Ea=function(a){return We(new Ze,this.Lb,a)};CB.prototype.v=function(){return"TreePos"};CB.prototype.z=function(a){if(null===a)throw jo(wj(),null);this.Lb=a;return this};CB.prototype.$classData=l({hY:0},!1,"scala.meta.internal.parsers.ScalametaParser$TreePos$",{hY:1,zx:1,f:1,Mb:1,l:1,k:1});function B1(){this.No=this.Vn=0;this.r=null}B1.prototype=new m;B1.prototype.constructor=B1;e=B1.prototype;e.U=function(){return"XmlTokenRange"};e.M=function(){return 2};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.RC&&a.r===this.r?this.Vn===a.Vn&&this.No===a.No:!1};e.W=function(a){switch(a){case 0:return this.Vn;case 1:return this.No;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.A=function(){var a=-889275714,a=Y().Gb(a,this.Vn),a=Y().Gb(a,this.No);return Y().xd(a,2)};e.L=function(){return Z(this)};function Yua(a,b,c){var d=new B1;d.Vn=b;d.No=c;if(null===a)throw jo(wj(),null);d.r=a;return d}
e.$classData=l({RC:0},!1,"scala.meta.internal.tokenizers.ScalaExprPositionParser$XmlTokenRange",{RC:1,f:1,R:1,x:1,l:1,k:1});function L(){this.Ca=this.E=0}L.prototype=new m;L.prototype.constructor=L;e=L.prototype;e.U=function(){return"TokenStreamPosition"};e.M=function(){return 2};e.w=function(a){if(a&&a.$classData&&a.$classData.H.SC&&ns(a)&&2===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.E;case 1:return this.Ca;default:throw(new W).j(""+a);}};
e.K=function(a,b){this.E=a;this.Ca=b;return this};e.v=function(){return cQ(this)};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({SC:0},!1,"scala.meta.internal.tokens.TokenStreamPosition",{SC:1,f:1,R:1,x:1,l:1,k:1});function Xla(a){if($z(a)){var b=Efa(Ffa(),a);if(!b.g())return b.q()}if(aA(a))throw jo(wj(),a.yk);throw(new p).e(a);}
function C1(a,b){var c=a.G();return c===k(rc)?oa(bc(rc),[b]):c===k(vc)?oa(bc(vc),[b]):c===k(jc)?oa(bc(jc),[b]):c===k(yc)?oa(bc(yc),[b]):c===k(zc)?oa(bc(zc),[b]):c===k(Gc)?oa(bc(Gc),[b]):c===k(Ic)?oa(bc(Ic),[b]):c===k(ic)?oa(bc(ic),[b]):c===k(cc)?oa(bc(xa),[b]):Gr(Ir(),a.G(),b)}function D1(a,b){return b&&b.$classData&&b.$classData.H.ya?(a=a.G(),b=b.G(),a===b):!1}var E1=function uva(b,c){if(c.Ei.isArrayClass){var d=(new yd).X((new r).d(["Array[","]"]));c=zr(c);return td(d,(new r).d([uva(b,c)]))}return Md(c)};
function F1(){}F1.prototype=new m;F1.prototype.constructor=F1;function vva(){}vva.prototype=F1.prototype;function SN(){Rn.call(this)}SN.prototype=new jR;SN.prototype.constructor=SN;SN.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};SN.prototype.Em=function(){return hua().eu?Rn.prototype.Em.call(this):this};SN.prototype.$classData=l({H1:0},!1,"scala.util.control.BreakControl",{H1:1,vd:1,f:1,k:1,CE:1,DE:1});
function a1(a,b){return b&&b.$classData&&b.$classData.H.Te?b.aA(a)&&a.Qf(b):!1}function G1(a,b){return 0<=b&&b<a.Fa()}function gN(){this.b=null}gN.prototype=new $U;gN.prototype.constructor=gN;gN.prototype.c=function(){ZU.prototype.c.call(this);return this};gN.prototype.ic=function(){wva();return(new ae).c()};gN.prototype.$classData=l({S1:0},!1,"scala.collection.Iterable$",{S1:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var vja=void 0;function So(){this.PA=this.Lb=null}So.prototype=new M0;
So.prototype.constructor=So;So.prototype.bb=function(){return this.PA.Ea(this.Lb.bb())};function Ro(a,b,c){if(null===b)throw jo(wj(),null);a.Lb=b;a.PA=c;return a}So.prototype.fb=function(){return this.Lb.fb()};So.prototype.$classData=l({U1:0},!1,"scala.collection.Iterator$$anon$10",{U1:1,rh:1,f:1,Dg:1,tb:1,sb:1});function eO(){}eO.prototype=new M0;eO.prototype.constructor=eO;eO.prototype.c=function(){return this};eO.prototype.bb=function(){throw(new BP).j("next on empty iterator");};
eO.prototype.fb=function(){return!1};eO.prototype.$classData=l({V1:0},!1,"scala.collection.Iterator$$anon$2",{V1:1,rh:1,f:1,Dg:1,tb:1,sb:1});function H1(){}H1.prototype=new m;H1.prototype.constructor=H1;H1.prototype.c=function(){return this};H1.prototype.$classData=l({W1:0},!1,"scala.collection.JavaConverters$",{W1:1,f:1,X6:1,V6:1,Y6:1,W6:1});var xva=void 0;function mR(){xva||(xva=(new H1).c());return xva}function I1(){this.Ai=null}I1.prototype=new M0;I1.prototype.constructor=I1;
I1.prototype.bb=function(){if(this.fb()){var a=this.Ai.n();this.Ai=this.Ai.o();return a}return hN().Pg.bb()};function ZM(a){var b=new I1;b.Ai=a;return b}I1.prototype.lb=function(){var a=this.Ai.lb();this.Ai=this.Ai.$F(0);return a};I1.prototype.fb=function(){return!this.Ai.g()};I1.prototype.$classData=l({X1:0},!1,"scala.collection.LinearSeqLike$$anon$1",{X1:1,rh:1,f:1,Dg:1,tb:1,sb:1});function J1(){this.Mm=null}J1.prototype=new M0;J1.prototype.constructor=J1;J1.prototype.bb=function(){return this.Mm.bb().qa()};
J1.prototype.fb=function(){return this.Mm.fb()};J1.prototype.Qs=function(a){this.Mm=a.Jb();return this};J1.prototype.$classData=l({Y1:0},!1,"scala.collection.MapLike$$anon$1",{Y1:1,rh:1,f:1,Dg:1,tb:1,sb:1});function K1(){}K1.prototype=new P0;K1.prototype.constructor=K1;K1.prototype.c=function(){return this};K1.prototype.Yj=function(){return id()};K1.prototype.ic=function(){return kd(new ld,id())};K1.prototype.$classData=l({a2:0},!1,"scala.collection.Set$",{a2:1,Io:1,Ho:1,Sf:1,f:1,Tf:1});var yva=void 0;
function zva(){yva||(yva=(new K1).c());return yva}function fN(){this.b=null}fN.prototype=new $U;fN.prototype.constructor=fN;fN.prototype.c=function(){ZU.prototype.c.call(this);eN=this;(new RN).c();return this};fN.prototype.ic=function(){Ava||(Ava=(new L1).c());return(new ae).c()};fN.prototype.$classData=l({b2:0},!1,"scala.collection.Traversable$",{b2:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var eN=void 0;function M1(){this.Vs=this.Wv=null}M1.prototype=new M0;M1.prototype.constructor=M1;
M1.prototype.bb=function(){return this.fb()?this.Vs.bb():hN().Pg.bb()};M1.prototype.fb=function(){for(;;){if(this.Vs.fb())return!0;if(this.Wv.fb())this.Vs=this.Wv.bb().ah();else return!1}};function fca(a){var b=new M1;b.Wv=a.IE.ah();b.Vs=hN().Pg;return b}M1.prototype.$classData=l({e2:0},!1,"scala.collection.TraversableOnce$FlattenOps$$anon$1",{e2:1,rh:1,f:1,Dg:1,tb:1,sb:1});function N1(){}N1.prototype=new P0;N1.prototype.constructor=N1;function O1(){}O1.prototype=N1.prototype;N1.prototype.Yj=function(){return this.Is()};
N1.prototype.ic=function(){return kd(new ld,this.Is())};function P1(){}P1.prototype=new P0;P1.prototype.constructor=P1;function Q1(){}Q1.prototype=P1.prototype;P1.prototype.ic=function(){return bva(new S0,this.Yj())};function R1(){this.b=null}R1.prototype=new $U;R1.prototype.constructor=R1;R1.prototype.c=function(){ZU.prototype.c.call(this);return this};R1.prototype.ic=function(){return(new ae).c()};
R1.prototype.$classData=l({E2:0},!1,"scala.collection.immutable.Iterable$",{E2:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var Bva=void 0;function wva(){Bva||(Bva=(new R1).c());return Bva}function S1(){this.Ai=null}S1.prototype=new M0;S1.prototype.constructor=S1;e=S1.prototype;e.bb=function(){if(!this.fb())return hN().Pg.bb();var a=NO(this.Ai),b=a.n();this.Ai=MO(new LO,this,Rq(function(a,b){return function(){return b.o()}}(this,a)));return b};e.lb=function(){var a=this.ce(),b=G().b;return H(a,b)};
function Cva(a){var b=new S1;b.Ai=MO(new LO,b,Rq(function(a,b){return function(){return b}}(b,a)));return b}e.fb=function(){var a=NO(this.Ai);return cj(a)};e.ce=function(){var a=NO(this.Ai);this.Ai=MO(new LO,this,Rq(function(){return function(){nN();return VU()}}(this)));return a};e.$classData=l({n3:0},!1,"scala.collection.immutable.StreamIterator",{n3:1,rh:1,f:1,Dg:1,tb:1,sb:1});function T1(){this.Dx=null;this.nh=this.fq=0;this.Lb=null}T1.prototype=new M0;T1.prototype.constructor=T1;
T1.prototype.bb=function(){return Dva(this)};function Dva(a){if(a.nh>=a.fq)throw(new BP).j("next on empty iterator");for(var b=a.nh;;){if(a.nh<a.fq)var c=a.Lb.sl(a.nh),c=!(10===c||12===c);else c=!1;if(c)a.nh=1+a.nh|0;else break}a.nh=1+a.nh|0;var c=a.nh,d=a.fq;return a.Dx.substring(b,c<d?c:d)}T1.prototype.fb=function(){return this.nh<this.fq};T1.prototype.$classData=l({p3:0},!1,"scala.collection.immutable.StringLike$$anon$1",{p3:1,rh:1,f:1,Dg:1,tb:1,sb:1});function L1(){this.b=null}L1.prototype=new $U;
L1.prototype.constructor=L1;L1.prototype.c=function(){ZU.prototype.c.call(this);return this};L1.prototype.ic=function(){return(new ae).c()};L1.prototype.$classData=l({r3:0},!1,"scala.collection.immutable.Traversable$",{r3:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var Ava=void 0;function U1(){this.Ib=null;this.fj=0;this.Eo=this.hx=this.Ft=null;this.Yl=0;this.vn=null}U1.prototype=new M0;U1.prototype.constructor=U1;function Eva(){}Eva.prototype=U1.prototype;
U1.prototype.bb=function(){if(null!==this.vn){var a=this.vn.bb();this.vn.fb()||(this.vn=null);return a}a:{var a=this.Eo,b=this.Yl;for(;;){b===(-1+a.i.length|0)?(this.fj=-1+this.fj|0,0<=this.fj?(this.Eo=this.Ft.i[this.fj],this.Yl=this.hx.i[this.fj],this.Ft.i[this.fj]=null):(this.Eo=null,this.Yl=0)):this.Yl=1+this.Yl|0;if((a=a.i[b])&&a.$classData&&a.$classData.H.VE||Fva(a)){a=this.UA(a);break a}if(V1(a)||W1(a))0<=this.fj&&(this.Ft.i[this.fj]=this.Eo,this.hx.i[this.fj]=this.Yl),this.fj=1+this.fj|0,this.Eo=
Gva(a),this.Yl=0,a=Gva(a),b=0;else{this.vn=a.Jb();a=this.bb();break a}}}return a};U1.prototype.fb=function(){return null!==this.vn||0<=this.fj};function Gva(a){if(V1(a))return a.re;if(!W1(a))throw(new p).e(a);return a.rd}U1.prototype.ZA=function(a){this.Ib=a;this.fj=0;this.Ft=oa(bc(bc(Hva)),[6]);this.hx=oa(bc(yc),[6]);this.Eo=this.Ib;this.Yl=0;this.vn=null;return this};function X1(){this.Me=0;this.Lb=null}X1.prototype=new M0;X1.prototype.constructor=X1;
X1.prototype.bb=function(){return 0<this.Me?(this.Me=-1+this.Me|0,this.Lb.rc(this.Me)):hN().Pg.bb()};X1.prototype.fb=function(){return 0<this.Me};function Iva(a){var b=new X1;if(null===a)throw jo(wj(),null);b.Lb=a;b.Me=a.Fa();return b}X1.prototype.$classData=l({u3:0},!1,"scala.collection.immutable.Vector$$anon$1",{u3:1,rh:1,f:1,Dg:1,tb:1,sb:1});function SO(){this.lg=this.Vf=null}SO.prototype=new m;SO.prototype.constructor=SO;function $ja(a,b,c){a.lg=c;a.Vf=b;return a}e=SO.prototype;
e.w=function(a){return null!==a&&(a===this||a===this.Lq()||Aa(a,this.Lq()))};e.ee=function(a){this.Vf.ba(a);return this};e.v=function(){return""+this.Lq()};e.da=function(){return this.lg.Ea(this.Vf.da())};e.Lq=function(){return this.Vf};e.ii=function(a,b){this.Vf.ii(a,b)};e.ba=function(a){this.Vf.ba(a);return this};e.A=function(){return this.Vf.A()};e.je=function(a){this.Vf.je(a)};e.$c=function(a){this.Vf.$c(a);return this};
e.$classData=l({N3:0},!1,"scala.collection.mutable.Builder$$anon$1",{N3:1,f:1,Fe:1,Ee:1,De:1,mK:1});function Y1(){this.Me=0;this.Lb=null}Y1.prototype=new M0;Y1.prototype.constructor=Y1;Y1.prototype.bb=function(){return this.fb()?(this.Me=1+this.Me|0,vba(this.Lb.Vc.i[-1+this.Me|0])):hN().Pg.bb()};Y1.prototype.fb=function(){for(;this.Me<this.Lb.Vc.i.length&&null===this.Lb.Vc.i[this.Me];)this.Me=1+this.Me|0;return this.Me<this.Lb.Vc.i.length};
Y1.prototype.$classData=l({Q3:0},!1,"scala.collection.mutable.FlatHashTable$$anon$1",{Q3:1,rh:1,f:1,Dg:1,tb:1,sb:1});function Z1(){this.Mm=null}Z1.prototype=new M0;Z1.prototype.constructor=Z1;Z1.prototype.bb=function(){return this.Mm.bb().bg};Z1.prototype.Mv=function(a){this.Mm=Jva(a);return this};Z1.prototype.fb=function(){return this.Mm.fb()};Z1.prototype.$classData=l({U3:0},!1,"scala.collection.mutable.HashMap$$anon$3",{U3:1,rh:1,f:1,Dg:1,tb:1,sb:1});
function $1(){this.Vv=null;this.Yn=0;this.Cm=null}$1.prototype=new M0;$1.prototype.constructor=$1;$1.prototype.bb=function(){var a=this.Cm;for(this.Cm=this.Cm.bb();null===this.Cm&&0<this.Yn;)this.Yn=-1+this.Yn|0,this.Cm=this.Vv.i[this.Yn];return a};function Jva(a){var b=new $1;b.Vv=a.Vc;b.Yn=mP(a);b.Cm=b.Vv.i[b.Yn];return b}$1.prototype.fb=function(){return null!==this.Cm};$1.prototype.$classData=l({Y3:0},!1,"scala.collection.mutable.HashTable$$anon$1",{Y3:1,rh:1,f:1,Dg:1,tb:1,sb:1});
function a2(){this.b=null}a2.prototype=new $U;a2.prototype.constructor=a2;a2.prototype.c=function(){ZU.prototype.c.call(this);return this};a2.prototype.ic=function(){return(new Fd).c()};a2.prototype.$classData=l({$3:0},!1,"scala.collection.mutable.Iterable$",{$3:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var Kva=void 0;function b2(){this.aj=null}b2.prototype=new m;b2.prototype.constructor=b2;function Lva(){}e=Lva.prototype=b2.prototype;e.c=function(){this.aj=(new ae).c();return this};
e.ee=function(a){return Mva(this,a)};function Mva(a,b){var c=a.aj;G();b=(new r).d([b]);var d=G().b;ff(c,H(b,d));return a}e.ii=function(a,b){iV(this,a,b)};e.ba=function(a){return Mva(this,a)};e.je=function(){};e.$c=function(a){ff(this.aj,a);return this};function c2(){this.Hp=null}c2.prototype=new M0;c2.prototype.constructor=c2;c2.prototype.bb=function(){if(this.fb()){var a=this.Hp.bg;this.Hp=this.Hp.at;return a}return hN().Pg.bb()};c2.prototype.fb=function(){return null!==this.Hp};
c2.prototype.$classData=l({c4:0},!1,"scala.collection.mutable.LinkedHashSet$$anon$1",{c4:1,rh:1,f:1,Dg:1,tb:1,sb:1});function d2(){this.Ip=null}d2.prototype=new M0;d2.prototype.constructor=d2;d2.prototype.bb=function(){if(this.fb()){var a=this.Ip.n();this.Ip=this.Ip.o();return a}throw(new BP).j("next on empty Iterator");};d2.prototype.fb=function(){return this.Ip!==F()};d2.prototype.$classData=l({f4:0},!1,"scala.collection.mutable.ListBuffer$$anon$1",{f4:1,rh:1,f:1,Dg:1,tb:1,sb:1});
function B(){this.t=this.Pg=null}B.prototype=new m;B.prototype.constructor=B;function E(a,b){a.t=a.t.qk(b);return a}e=B.prototype;e.ee=function(a){return E(this,a)};e.da=function(){return this.t};e.ii=function(a,b){iV(this,a,b)};function A(a,b){a.Pg=b;a.t=b;return a}e.ba=function(a){return E(this,a)};e.je=function(){};e.$c=function(a){return GO(this,a)};e.$classData=l({g4:0},!1,"scala.collection.mutable.MapBuilder",{g4:1,f:1,Nh:1,Fe:1,Ee:1,De:1});function ld(){this.t=this.Pg=null}ld.prototype=new m;
ld.prototype.constructor=ld;e=ld.prototype;e.ee=function(a){return md(this,a)};e.da=function(){return this.t};e.ii=function(a,b){iV(this,a,b)};function md(a,b){a.t=a.t.ki(b);return a}function kd(a,b){a.Pg=b;a.t=b;return a}e.ba=function(a){return md(this,a)};e.je=function(){};e.$c=function(a){return GO(this,a)};e.$classData=l({i4:0},!1,"scala.collection.mutable.SetBuilder",{i4:1,f:1,Nh:1,Fe:1,Ee:1,De:1});function e2(){this.t=this.Gx=null;this.hl=this.vk=0}e2.prototype=new m;
e2.prototype.constructor=e2;e=e2.prototype;e.Jv=function(a){this.Gx=a;this.hl=this.vk=0;return this};e.ee=function(a){return Nva(this,a)};function Nva(a,b){var c=1+a.hl|0;if(a.vk<c){for(var d=0===a.vk?16:a.vk<<1;d<c;)d<<=1;c=d;a.t=Ova(a,c);a.vk=c}a.t.Kk(a.hl,b);a.hl=1+a.hl|0;return a}
function Ova(a,b){var c=a.Gx.G();b=c===k(rc)?(new f2).Zn(oa(bc(rc),[b])):c===k(vc)?(new g2).eo(oa(bc(vc),[b])):c===k(jc)?(new h2).Uk(oa(bc(jc),[b])):c===k(yc)?(new i2).bo(oa(bc(yc),[b])):c===k(zc)?(new j2).co(oa(bc(zc),[b])):c===k(Gc)?(new k2).ao(oa(bc(Gc),[b])):c===k(Ic)?(new l2).$n(oa(bc(Ic),[b])):c===k(ic)?(new m2).fo(oa(bc(ic),[b])):c===k(cc)?(new n2).go(oa(bc(xa),[b])):(new e0).Bk(a.Gx.xa(b));0<a.hl&&E0(Tp(),a.t.Da,0,b.Da,0,a.hl);return b}
e.da=function(){var a;0!==this.vk&&this.vk===this.hl?(this.vk=0,a=this.t):a=Ova(this,this.hl);return a};e.ii=function(a,b){iV(this,a,b)};e.ba=function(a){return Nva(this,a)};e.je=function(a){this.vk<a&&(this.t=Ova(this,a),this.vk=a)};e.$c=function(a){return GO(this,a)};e.$classData=l({l4:0},!1,"scala.collection.mutable.WrappedArrayBuilder",{l4:1,f:1,Nh:1,Fe:1,Ee:1,De:1});function VC(){Rn.call(this);this.Rt=this.Ys=null}VC.prototype=new jR;VC.prototype.constructor=VC;VC.prototype.Em=function(){return this};
VC.prototype.a=function(a,b){this.Ys=a;this.Rt=b;Rn.prototype.fd.call(this,null,null);return this};function YC(a){return!!(a&&a.$classData&&a.$classData.H.UF)}VC.prototype.$classData=l({UF:0},!1,"scala.runtime.NonLocalReturnControl",{UF:1,vd:1,f:1,k:1,CE:1,DE:1});function o2(){this.fA=this.nj=0;this.lG=null}o2.prototype=new M0;o2.prototype.constructor=o2;o2.prototype.bb=function(){var a=this.lG.W(this.nj);this.nj=1+this.nj|0;return a};function Z(a){var b=new o2;b.lG=a;b.nj=0;b.fA=a.M();return b}
o2.prototype.fb=function(){return this.nj<this.fA};o2.prototype.$classData=l({R4:0},!1,"scala.runtime.ScalaRunTime$$anon$1",{R4:1,rh:1,f:1,Dg:1,tb:1,sb:1});function p2(){this.Ag=this.Xc=null}p2.prototype=new m;p2.prototype.constructor=p2;e=p2.prototype;e.Ox=function(){var a=this.Xc,b=wk().mb,a=Fk(a,b).Fa(),b=this.Ag.fa(),c=wk().mb,b=Fk(b,c);return a===b.Fa()?this.Ag.Ox():this.Ag};e.U=function(){return"Child"};e.M=function(){return 2};
e.w=function(a){if(this===a)return!0;if(bd(a)){var b=this.Xc,c=a.Xc;if(null===b?null===c:b===c)return b=this.Ag,a=a.Ag,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Xc;case 1:return this.Ag;default:throw(new W).j(""+a);}};e.v=function(){return waa(this)};e.EA=function(){var a=Cba(Xk(),this.Xc,this.Ag.fa());return cj(a)?(a=a.n(),jQ(a,this)):this};function jQ(a,b){var c=new p2;c.Xc=a;c.Ag=b;return c}
e.mt=function(){var a=pk(Xk(),this.Ag.fa(),!1,!1);a:{for(var b=0,c=Ss(a),c=Hoa(c);c.fb();){var d=c.bb(),f=this.Xc;if(null===d?null===f:d===f)break a;else b=1+b|0}b=-1}if(b<(-1+a.Fa()|0))return a=a.rc(1+b|0),jQ(a,this.Ag);a=this.Xc;b=wk().mb;a=Fk(a,b).Fa();b=this.Ag.fa();c=wk().mb;b=Fk(b,c);if(a===b.Fa())return this.Ag.mt();a=this.Ag;return bd(a)&&(a=a.Ag,Xk(),a=a.fa(),!qk().Yq(a).g())?this.Ag.mt():this};e.fa=function(){return this.Xc};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.hw=function(){var a=pk(Xk(),this.Ag.fa(),!1,!0);a:{for(var b=0,c=Ss(a),c=Hoa(c);c.fb();){var d=c.bb(),f=this.Xc;if(null===d?null===f:d===f)break a;else b=1+b|0}b=-1}if(0<b)return a=a.rc(-1+b|0),jQ(a,this.Ag);a=this.Xc;b=wk().mb;a=Fk(a,b).Fa();b=this.Ag.fa();c=wk().mb;b=Fk(b,c);return a===b.Fa()?this.Ag.hw():this};function bd(a){return!!(a&&a.$classData&&a.$classData.H.Fy)}e.$classData=l({Fy:0},!1,"ch.epfl.scala.accessible.Child",{Fy:1,f:1,qG:1,R:1,x:1,l:1,k:1});function q2(){this.Xc=null}
q2.prototype=new m;q2.prototype.constructor=q2;e=q2.prototype;e.Ox=function(){return this};e.U=function(){return"Root"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.uu){var b=this.Xc;a=a.Xc;return null===b?null===a:b===a}return!1};e.W=function(a){switch(a){case 0:return this.Xc;default:throw(new W).j(""+a);}};e.v=function(){return waa(this)};function Aba(a){var b=new q2;b.Xc=a;return b}
e.EA=function(){var a=pk(Xk(),this.Xc,!0,!1);return cj(a)?(a=a.n(),jQ(a,this)):this};e.mt=function(){return this};e.fa=function(){return this.Xc};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.hw=function(){return this};e.$classData=l({uu:0},!1,"ch.epfl.scala.accessible.Root",{uu:1,f:1,qG:1,R:1,x:1,l:1,k:1});function Y0(){this.Fi=this.u=null;this.va=0;this.vj=this.zg=null;this.lf=this.uj=0;this.nd=null;this.id=!1}Y0.prototype=new m;Y0.prototype.constructor=Y0;e=Y0.prototype;
e.U=function(){return"Failure"};e.M=function(){return 9};e.w=function(a){if(this===a)return!0;if(r2(a)){var b=this.u,c=a.u;(null===b?null===c:b.w(c))?(b=this.Fi,c=a.Fi,b=null===b?null===c:b.w(c)):b=!1;b&&this.va===a.va?(b=this.zg,c=a.zg,b=null===b?null===c:b.w(c)):b=!1;b?(b=this.vj,c=a.vj,b=null===b?null===c:b.w(c)):b=!1;b&&this.uj===a.uj&&this.lf===a.lf?(b=this.nd,c=a.nd,b=null===b?null===c:b1(b,c)):b=!1;return b?this.id===a.id:!1}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Fi;case 2:return this.va;case 3:return this.zg;case 4:return this.vj;case 5:return this.uj;case 6:return this.lf;case 7:return this.nd;case 8:return this.id;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};
e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.u)),a=Y().Gb(a,YN(Y(),this.Fi)),a=Y().Gb(a,this.va),a=Y().Gb(a,YN(Y(),this.zg)),a=Y().Gb(a,YN(Y(),this.vj)),a=Y().Gb(a,this.uj),a=Y().Gb(a,this.lf),a=Y().Gb(a,YN(Y(),this.nd)),a=Y().Gb(a,this.id?1231:1237);return Y().xd(a,9)};e.L=function(){return Z(this)};e.Lx=function(){var a=new s2,b=this.zg,c=this.va,d=this.vj,f=this.uj,g=this.zg,h=this.va,n=new LQ;n.u=this.u;n.Cx=d;n.XF=f;n.zg=g;n.va=h;a.zg=b;a.va=c;a.zl=n;return a};
function r2(a){return!!(a&&a.$classData&&a.$classData.H.Jy)}e.$classData=l({Jy:0},!1,"fastparse.core.Mutable$Failure",{Jy:1,f:1,NG:1,R:1,x:1,l:1,k:1});function $0(){this.pa=null;this.va=0;this.nd=null;this.id=!1}$0.prototype=new m;$0.prototype.constructor=$0;e=$0.prototype;e.U=function(){return"Success"};e.M=function(){return 4};
e.w=function(a){if(this===a)return!0;if(t2(a)){if(dj(ej(),this.pa,a.pa)&&this.va===a.va)var b=this.nd,c=a.nd,b=null===b?null===c:b1(b,c);else b=!1;return b?this.id===a.id:!1}return!1};e.W=function(a){switch(a){case 0:return this.pa;case 1:return this.va;case 2:return this.nd;case 3:return this.id;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(["Success(",", ",")"])),(new r).d([this.pa,this.va]))};
e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.pa)),a=Y().Gb(a,this.va),a=Y().Gb(a,YN(Y(),this.nd)),a=Y().Gb(a,this.id?1231:1237);return Y().xd(a,4)};e.L=function(){return Z(this)};e.Lx=function(){return(new u2).Cl(this.pa,this.va)};function t2(a){return!!(a&&a.$classData&&a.$classData.H.Ky)}e.$classData=l({Ky:0},!1,"fastparse.core.Mutable$Success",{Ky:1,f:1,NG:1,R:1,x:1,l:1,k:1});function s2(){this.zg=null;this.va=0;this.zl=null}s2.prototype=new m;s2.prototype.constructor=s2;e=s2.prototype;
e.U=function(){return"Failure"};e.M=function(){return 3};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.vu){var b=this.zg,c=a.zg;return(null===b?null===c:b.w(c))&&this.va===a.va?this.zl===a.zl:!1}return!1};e.W=function(a){switch(a){case 0:return this.zg;case 1:return this.va;case 2:return this.zl;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(["Failure(",")"])),(new r).d([Zoa($oa(),F(),this.zl.u,this.va,Yoa($oa(),this.zg,this.zl.u,this.va))]))};
e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.zg)),a=Y().Gb(a,this.va),a=Y().Gb(a,YN(Y(),this.zl));return Y().xd(a,3)};e.L=function(){return Z(this)};e.$classData=l({vu:0},!1,"fastparse.core.Parsed$Failure",{vu:1,f:1,OG:1,R:1,x:1,l:1,k:1});function u2(){this.pa=null;this.va=0}u2.prototype=new m;u2.prototype.constructor=u2;e=u2.prototype;e.U=function(){return"Success"};e.M=function(){return 2};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.wu?dj(ej(),this.pa,a.pa)&&this.va===a.va:!1};e.W=function(a){switch(a){case 0:return this.pa;case 1:return this.va;default:throw(new W).j(""+a);}};e.Cl=function(a,b){this.pa=a;this.va=b;return this};e.v=function(){return cQ(this)};e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.pa)),a=Y().Gb(a,this.va);return Y().xd(a,2)};e.L=function(){return Z(this)};
e.$classData=l({wu:0},!1,"fastparse.core.Parsed$Success",{wu:1,f:1,OG:1,R:1,x:1,l:1,k:1});function v2(){mq.call(this);this.Nd=null;this.ne=0}v2.prototype=new nq;v2.prototype.constructor=v2;function Pva(){}e=Pva.prototype=v2.prototype;e.w=function(a){if(a&&a.$classData&&a.$classData.H.kz){a:if(this===a)a=0;else{for(var b=this.kb,c=this.jc-b|0,d=a.kb,f=a.jc-d|0,g=c<f?c:f,h=0;h!==g;){var n=this.jq(b+h|0),u=a.jq(d+h|0),n=n-u|0;if(0!==n){a=n;break a}h=1+h|0}a=c===f?0:c<f?-1:1}a=0===a}else a=!1;return a};
e.v=function(){if(null!==this.Nd)return kr(Ga(),this.Nd,this.kb+this.ne|0,this.jc-this.kb|0);var a=oa(bc(jc),[this.jc-this.kb|0]),b=this.kb;this.WA(a,0,a.i.length);mq.prototype.Pc.call(this,b);return kr(Ga(),a,0,a.i.length)};e.Bs=function(a){return Fca(this,pa(a))};
function Fca(a,b){var c=b.length|0;b=wq(zq(),b,c);if(b===a)throw(new t).c();if(a.Hl())throw(new Iq).c();var c=b.jc,d=b.kb,f=c-d|0,g=a.kb,h=g+f|0;if(h>a.jc)throw(new Jq).c();a.kb=h;mq.prototype.Pc.call(b,c);h=b.Nd;if(null!==h)a.YF(g,h,b.ne+d|0,f);else for(;d!==c;)f=g,h=b.jq(d),a.ZF(f,h),d=1+d|0,g=1+g|0;return a}e.Fa=function(){return this.jc-this.kb|0};e.$A=function(a,b,c){this.Nd=b;this.ne=c;mq.prototype.mc.call(this,a);return this};
e.A=function(){for(var a=this.kb,b=this.jc,c=-182887236,d=a;d!==b;){var f=XN();Y();var g=this.jq(d),c=f.Gb(c,YN(0,(new ed).db(g))),d=1+d|0}return XN().xd(c,b-a|0)};e.As=function(a){return this.ln(a)};e.Vj=function(a){return this.XA(this.kb+a|0)};function Iq(){Rn.call(this)}Iq.prototype=new pva;Iq.prototype.constructor=Iq;Iq.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};Iq.prototype.$classData=l({IH:0},!1,"java.nio.ReadOnlyBufferException",{IH:1,DB:1,Nf:1,ae:1,vd:1,f:1,k:1});
function Mq(){Rn.call(this);this.$p=0}Mq.prototype=new gva;Mq.prototype.constructor=Mq;Mq.prototype.Ak=function(){return"Input length \x3d "+this.$p};Mq.prototype.mc=function(a){this.$p=a;Rn.prototype.fd.call(this,null,null);return this};Mq.prototype.$classData=l({SH:0},!1,"java.nio.charset.MalformedInputException",{SH:1,LH:1,nH:1,ae:1,vd:1,f:1,k:1});function Nq(){Rn.call(this);this.$p=0}Nq.prototype=new gva;Nq.prototype.constructor=Nq;Nq.prototype.Ak=function(){return"Input length \x3d "+this.$p};
Nq.prototype.mc=function(a){this.$p=a;Rn.prototype.fd.call(this,null,null);return this};Nq.prototype.$classData=l({TH:0},!1,"java.nio.charset.UnmappableCharacterException",{TH:1,LH:1,nH:1,ae:1,vd:1,f:1,k:1});function w2(){}w2.prototype=new m;w2.prototype.constructor=w2;e=w2.prototype;e.c=function(){return this};e.U=function(){return"None"};e.M=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.Rq=function(){return-1};e.v=function(){return"Position.None"};e.wa=function(){return-1};
e.jb=function(){return Wq()};e.Kx=function(){return""};e.Bx=function(){return-1};e.ab=function(){return-1};e.A=function(){return 2433880};e.L=function(){return Z(this)};e.$classData=l({gI:0},!1,"org.langmeta.inputs.Position$None$",{gI:1,f:1,fI:1,R:1,x:1,l:1,k:1});var Qva=void 0;function Rca(){Qva||(Qva=(new w2).c());return Qva}function Ms(){this.u=null;this.Ca=this.E=0}Ms.prototype=new m;Ms.prototype.constructor=Ms;e=Ms.prototype;e.U=function(){return"Range"};e.M=function(){return 3};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Iu){var b=this.u,c=a.u;return(null===b?null===c:b.w(c))&&this.E===a.E?this.Ca===a.Ca:!1}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.E;case 2:return this.Ca;default:throw(new W).j(""+a);}};e.Rq=function(){return Aaa(this.u,this.E)};e.v=function(){return td((new yd).X((new r).d(["[","..",") in ",""])),(new r).d([this.E,this.Ca,this.u]))};e.wa=function(){return this.Ca};e.jb=function(){return this.u};
e.Kx=function(){return kr(Ga(),this.u.od(),this.E,this.Ca-this.E|0)};e.ib=function(a,b,c){this.u=a;this.E=b;this.Ca=c;return this};e.Bx=function(){var a=this.E,b=this.u,c=Aaa(this.u,this.E);return a-Ad(b,c)|0};e.ab=function(){return this.E};e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.u)),a=Y().Gb(a,this.E),a=Y().Gb(a,this.Ca);return Y().xd(a,3)};e.L=function(){return Z(this)};e.$classData=l({Iu:0},!1,"org.langmeta.inputs.Position$Range",{Iu:1,f:1,fI:1,R:1,x:1,l:1,k:1});
function Bl(){this.Y=null}Bl.prototype=new yr;Bl.prototype.constructor=Bl;e=Bl.prototype;e.U=function(){return"FullName"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.qz?this.Y===a.Y:!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.j=function(a){this.Y=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.$classData=l({qz:0},!1,"sourcecode.FullName",{qz:1,tz:1,f:1,R:1,x:1,l:1,k:1});function Al(){this.Y=0}Al.prototype=new yr;Al.prototype.constructor=Al;e=Al.prototype;e.U=function(){return"Line"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.rz?this.Y===a.Y:!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.mc=function(a){this.Y=a;return this};
e.A=function(){var a=-889275714,a=Y().Gb(a,this.Y);return Y().xd(a,1)};e.L=function(){return Z(this)};e.$classData=l({rz:0},!1,"sourcecode.Line",{rz:1,tz:1,f:1,R:1,x:1,l:1,k:1});function LK(){this.Y=null}LK.prototype=new yr;LK.prototype.constructor=LK;e=LK.prototype;e.U=function(){return"Name"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.sz?this.Y===a.Y:!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};
e.j=function(a){this.Y=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({sz:0},!1,"sourcecode.Name",{sz:1,tz:1,f:1,R:1,x:1,l:1,k:1});function q(){this.Ok=this.Nk=null}q.prototype=new m;q.prototype.constructor=q;function Rva(){}e=Rva.prototype=q.prototype;e.U=function(){return"Tuple2"};e.Xa=function(){return this.qa()|0};e.M=function(){return 2};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.ms?dj(ej(),this.qa(),a.qa())&&dj(ej(),this.p(),a.p()):!1};e.W=function(a){a:switch(a){case 0:a=this.qa();break a;case 1:a=this.p();break a;default:throw(new W).j(""+a);}return a};e.a=function(a,b){this.Nk=a;this.Ok=b;return this};e.v=function(){return"("+this.qa()+","+this.p()+")"};e.p=function(){return this.Ok};function I(a){return!!a.qa()}e.bu=function(){return this.p()|0};e.Wx=function(){return!!this.p()};e.A=function(){return WN(this)};
e.qa=function(){return this.Nk};e.L=function(){return Z(this)};e.$classData=l({ms:0},!1,"scala.Tuple2",{ms:1,f:1,oC:1,R:1,x:1,l:1,k:1});function yi(){this.Eb=this.qb=this.Bb=null}yi.prototype=new m;yi.prototype.constructor=yi;e=yi.prototype;e.U=function(){return"Tuple3"};e.M=function(){return 3};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Mz?dj(ej(),this.Bb,a.Bb)&&dj(ej(),this.qb,a.qb)&&dj(ej(),this.Eb,a.Eb):!1};
e.W=function(a){a:switch(a){case 0:a=this.Bb;break a;case 1:a=this.qb;break a;case 2:a=this.Eb;break a;default:throw(new W).j(""+a);}return a};e.v=function(){return"("+this.Bb+","+this.qb+","+this.Eb+")"};e.sd=function(a,b,c){this.Bb=a;this.qb=b;this.Eb=c;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Mz:0},!1,"scala.Tuple3",{Mz:1,f:1,c6:1,R:1,x:1,l:1,k:1});function al(){this.hd=this.Eb=this.qb=this.Bb=null}al.prototype=new m;al.prototype.constructor=al;
e=al.prototype;e.U=function(){return"Tuple4"};e.M=function(){return 4};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Nz?dj(ej(),this.Bb,a.Bb)&&dj(ej(),this.qb,a.qb)&&dj(ej(),this.Eb,a.Eb)&&dj(ej(),this.hd,a.hd):!1};e.W=function(a){return nla(this,a)};e.v=function(){return"("+this.Bb+","+this.qb+","+this.Eb+","+this.hd+")"};e.yd=function(a,b,c,d){this.Bb=a;this.qb=b;this.Eb=c;this.hd=d;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.$classData=l({Nz:0},!1,"scala.Tuple4",{Nz:1,f:1,d6:1,R:1,x:1,l:1,k:1});function tn(){this.Yf=this.hd=this.Eb=this.qb=this.Bb=null}tn.prototype=new m;tn.prototype.constructor=tn;e=tn.prototype;e.U=function(){return"Tuple5"};e.M=function(){return 5};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Oz?dj(ej(),this.Bb,a.Bb)&&dj(ej(),this.qb,a.qb)&&dj(ej(),this.Eb,a.Eb)&&dj(ej(),this.hd,a.hd)&&dj(ej(),this.Yf,a.Yf):!1};e.W=function(a){return ola(this,a)};
e.v=function(){return"("+this.Bb+","+this.qb+","+this.Eb+","+this.hd+","+this.Yf+")"};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function sn(a,b,c,d,f,g){a.Bb=b;a.qb=c;a.Eb=d;a.hd=f;a.Yf=g;return a}e.$classData=l({Oz:0},!1,"scala.Tuple5",{Oz:1,f:1,e6:1,R:1,x:1,l:1,k:1});function bm(){this.rk=this.Yf=this.hd=this.Eb=this.qb=this.Bb=null}bm.prototype=new m;bm.prototype.constructor=bm;e=bm.prototype;e.U=function(){return"Tuple6"};e.M=function(){return 6};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Pz?dj(ej(),this.Bb,a.Bb)&&dj(ej(),this.qb,a.qb)&&dj(ej(),this.Eb,a.Eb)&&dj(ej(),this.hd,a.hd)&&dj(ej(),this.Yf,a.Yf)&&dj(ej(),this.rk,a.rk):!1};e.W=function(a){return pla(this,a)};e.v=function(){return"("+this.Bb+","+this.qb+","+this.Eb+","+this.hd+","+this.Yf+","+this.rk+")"};e.ti=function(a,b,c,d,f,g){this.Bb=a;this.qb=b;this.Eb=c;this.hd=d;this.Yf=f;this.rk=g;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.$classData=l({Pz:0},!1,"scala.Tuple6",{Pz:1,f:1,f6:1,R:1,x:1,l:1,k:1});function xV(){Rn.call(this)}xV.prototype=new ova;xV.prototype.constructor=xV;xV.prototype.mc=function(a){Rn.prototype.fd.call(this,"Array index out of range: "+a,null);return this};xV.prototype.$classData=l({UI:0},!1,"java.lang.ArrayIndexOutOfBoundsException",{UI:1,$v:1,Nf:1,ae:1,vd:1,f:1,k:1});function $V(){Rn.call(this)}$V.prototype=new t1;$V.prototype.constructor=$V;
$V.prototype.j=function(a){Rn.prototype.fd.call(this,a,null);return this};$V.prototype.$classData=l({mJ:0},!1,"java.lang.NumberFormatException",{mJ:1,Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function FP(){Rn.call(this)}FP.prototype=new ova;FP.prototype.constructor=FP;FP.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};FP.prototype.mc=function(a){Rn.prototype.fd.call(this,"String index out of range: "+a,null);return this};
FP.prototype.$classData=l({qJ:0},!1,"java.lang.StringIndexOutOfBoundsException",{qJ:1,$v:1,Nf:1,ae:1,vd:1,f:1,k:1});function x0(){Rn.call(this)}x0.prototype=new nva;x0.prototype.constructor=x0;x0.prototype.c=function(){Rn.prototype.fd.call(this,null,null);return this};x0.prototype.$classData=l({AJ:0},!1,"java.util.FormatterClosedException",{AJ:1,AB:1,Nf:1,ae:1,vd:1,f:1,k:1});function x2(){Rn.call(this)}x2.prototype=new t1;x2.prototype.constructor=x2;function y2(){}y2.prototype=x2.prototype;
function z2(){w1.call(this);this.Me=0;this.Jh=null}z2.prototype=new rva;z2.prototype.constructor=z2;z2.prototype.v=function(){return null!==this.Jh?this.Jh:td((new yd).X((new r).d(["\x3cUnknown name for enum field #"," of class ","\x3e"])),(new r).d([this.Me,ra(this)]))};function Xua(a,b,c){var d=new z2;d.Me=b;d.Jh=c;w1.prototype.QI.call(d,a);if(a.fx.Ac(b))throw(new fP).e("assertion failed: Duplicate id: "+d.Me);a.fx.gm(b,d);a.GE=!1;a.en=1+b|0;a.en>a.ex&&(a.ex=a.en);b<a.cx&&(a.cx=b);return d}
z2.prototype.$classData=l({WJ:0},!1,"scala.Enumeration$Val",{WJ:1,XJ:1,f:1,yo:1,xf:1,l:1,k:1});function A2(){}A2.prototype=new sva;A2.prototype.constructor=A2;e=A2.prototype;e.c=function(){return this};e.U=function(){return"None"};e.M=function(){return 0};e.g=function(){return!0};e.q=function(){throw(new BP).j("None.get");};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"None"};e.A=function(){return 2433880};e.L=function(){return Z(this)};
e.$classData=l({aK:0},!1,"scala.None$",{aK:1,nC:1,f:1,R:1,x:1,l:1,k:1});var Sva=void 0;function S(){Sva||(Sva=(new A2).c());return Sva}function js(){}js.prototype=new c0;js.prototype.constructor=js;js.prototype.c=function(){return this};js.prototype.vf=function(){return!0};js.prototype.Vh=function(){return fs().Do};js.prototype.$classData=l({eK:0},!1,"scala.PartialFunction$$anonfun$1",{eK:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function T(){this.Y=null}T.prototype=new sva;T.prototype.constructor=T;e=T.prototype;
e.U=function(){return"Some"};e.M=function(){return 1};e.w=function(a){return this===a?!0:zh(a)?dj(ej(),this.Y,a.Y):!1};e.g=function(){return!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.q=function(){return this.Y};e.v=function(){return cQ(this)};e.e=function(a){this.Y=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function zh(a){return!!(a&&a.$classData&&a.$classData.H.pC)}
e.$classData=l({pC:0},!1,"scala.Some",{pC:1,nC:1,f:1,R:1,x:1,l:1,k:1});function z1(){Rn.call(this)}z1.prototype=new t1;z1.prototype.constructor=z1;
z1.prototype.ui=function(a,b){var c=(new yd).X((new r).d(["invalid escape "," index ",' in "','". Use \\\\\\\\ for literal \\\\.']));pI(To(),0<=b&&b<(a.length|0));if(b===(-1+(a.length|0)|0))var d="at terminal";else var d=(new yd).X((new r).d(["'\\\\","' not one of "," at"])),f=65535&(a.charCodeAt(1+b|0)|0),d=td(d,(new r).d([(new ed).db(f),"[\\b, \\t, \\n, \\f, \\r, \\\\, \\\", \\']"]));a=td(c,(new r).d([d,b,a]));Rn.prototype.fd.call(this,a,null);return this};
z1.prototype.$classData=l({oK:0},!1,"scala.StringContext$InvalidEscapeException",{oK:1,Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function Tva(a,b){var c=a.Yh(0);if(0>a.Ie(b,c))return-1;c=a.Yh(0);return 0<a.Ie(b,c)?1:0}function dx(){}dx.prototype=new c0;dx.prototype.constructor=dx;dx.prototype.vf=function(a){return Fm(a)};dx.prototype.Vh=function(a,b){return Fm(a)?a:b.Ea(a)};dx.prototype.z=function(){return this};
dx.prototype.$classData=l({EW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$1",{EW:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function TC(){}TC.prototype=new c0;TC.prototype.constructor=TC;TC.prototype.vf=function(a){return Ke(a)&&2===a.ca?!0:!1};TC.prototype.Vh=function(a,b){return Ke(a)&&2===a.ca?a:b.Ea(a)};TC.prototype.z=function(){return this};TC.prototype.$classData=l({FW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$2",{FW:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});
function AC(){this.Lb=null}AC.prototype=new c0;AC.prototype.constructor=AC;e=AC.prototype;
e.sp=function(a,b){if(hU(a))return St(this.Lb);if(mU(a)&&!this.Lb.P.hh)return Hea(this.Lb);if(Nu(this.Lb).Gc(a))return aea(this.Lb);if(Ru(this.Lb).Gc(a)){a=this.Lb;var c=Tu(this.Lb,Ps().pe,!0);return Ke(c)?c.nb((new Uu).z(a)):c}if(de(a)&&!Yf(Zf(),a).g()){a=this.Lb;var d;d=new B2;var f=ce(a);b=ce(a);var f=f.$a(),g=x(a.h);if(!de(g)){for(var h=he(),n=[(new q).a("ScalametaParser.this.token",x(a.h))],u=A(new B,C()),w=0,D=n.length|0;w<D;)E(u,n[w]),w=1+w|0;ie(h,u.t)}ke(a.P)||(le(a),h=td((new yd).X((new r).d(["",
" doesn't support ellipses"])),(new r).d([a.P])),n=g.ja(),Pd(h,n));1!==g.Hb&&(le(a),h=oe(pe(),g.Hb,1),n=g.ja(),Pd(h,n));a.h.ia();h=x(a.h);ue(h)?(Sd(a,(new ve).z(a)),c=we(a,!0,d),Sd(a,(new Ae).z(a))):Be(h)?(Sd(a,(new Ee).z(a)),c=we(a,!0,d),Sd(a,(new Ie).z(a))):Je(h)?c=we(a,!0,d):(le(a),h=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),n=x(a.h).ja(),Pd(h,n));if(Ke(c)){Le((Oe(),d).G(),c.uc())?h=(new q).a(!0,F()):(G(),h=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
n=G().b,h=(new q).a(!1,H(h,n)));if(null===h||!0!==I(h)){if(null!==h&&(a=h.p(),!1===I(h))){b=J();f=(new q).a("ellipsis",g);g=(new q).a("result",c);d=(new q).a("evidence$4",d);n=(new q).a("quasi",c);u=Se();w=Te().Hc();c=[f,g,d,n,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(u,c,w)))];f=A(new B,C());d=0;for(g=c.length|0;d<g;)E(f,c[d]),d=1+d|0;K(b,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
a,f.t)}throw(new p).e(h);}g=We(new Ze,a,c);d=We(new Ze,a,c);g=g.eb;h=c.ca;c=c.fa();c=$u(av(),h,c);d=d.Fb;d<g&&(d=-1+g|0);d=(new L).K(g,1+d|0);g=M();c=O(P(g,c),R(a.ea,a.P,d))}c=$u(av(),1,c);b=b.Ga();b<f&&(b=-1+f|0);b=(new L).K(f,1+b|0);f=M();return O(P(f,c),R(a.ea,a.P,b))}return b.Ea(a)};e.bq=function(a){return hU(a)||mU(a)&&!this.Lb.P.hh||Nu(this.Lb).Gc(a)||Ru(this.Lb).Gc(a)||de(a)&&!Yf(Zf(),a).g()?!0:!1};e.vf=function(a){return this.bq(a)};e.Vh=function(a,b){return this.sp(a,b)};
e.z=function(a){if(null===a)throw jo(wj(),null);this.Lb=a;return this};e.$classData=l({GW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$3",{GW:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function Hy(){this.Lb=null}Hy.prototype=new c0;Hy.prototype.constructor=Hy;e=Hy.prototype;
e.sp=function(a,b){if(hU(a))return St(this.Lb);if(Nu(this.Lb).Gc(a))return aea(this.Lb);if(Je(a))return we(this.Lb,!0,(new C2).Fv(this));if(de(a)&&!Yf(Zf(),a).g()){a=this.Lb;var c=(new D2).Fv(this),d=ce(a);b=ce(a);var d=d.$a(),f=x(a.h);if(!de(f)){for(var g=he(),h=[(new q).a("ScalametaParser.this.token",x(a.h))],n=A(new B,C()),u=0,w=h.length|0;u<w;)E(n,h[u]),u=1+u|0;ie(g,n.t)}ke(a.P)||(le(a),g=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),h=f.ja(),Pd(g,h));1!==f.Hb&&
(le(a),g=oe(pe(),f.Hb,1),h=f.ja(),Pd(g,h));a.h.ia();g=x(a.h);if(ue(g)){Sd(a,(new ve).z(a));var D=we(a,!0,c);Sd(a,(new Ae).z(a))}else Be(g)?(Sd(a,(new Ee).z(a)),D=we(a,!0,c),Sd(a,(new Ie).z(a))):Je(g)?D=we(a,!0,c):(le(a),g=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),h=x(a.h).ja(),Pd(g,h));if(Ke(D)){Le((Oe(),c).G(),D.uc())?g=(new q).a(!0,F()):(G(),g=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),
h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();d=(new q).a("ellipsis",f);f=(new q).a("result",D);c=(new q).a("evidence$4",c);h=(new q).a("quasi",D);n=Se();u=Te().Hc();D=[d,f,c,h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(n,D,u)))];d=A(new B,C());c=0;for(f=D.length|0;c<f;)E(d,D[c]),c=1+c|0;K(b,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
a,d.t)}throw(new p).e(g);}f=We(new Ze,a,D);c=We(new Ze,a,D);f=f.eb;g=D.ca;D=D.fa();D=$u(av(),g,D);c=c.Fb;c<f&&(c=-1+f|0);c=(new L).K(f,1+c|0);f=M();D=O(P(f,D),R(a.ea,a.P,c))}D=$u(av(),1,D);b=b.Ga();b<d&&(b=-1+d|0);b=(new L).K(d,1+b|0);d=M();return O(P(d,D),R(a.ea,a.P,b))}return Ru(this.Lb).Gc(a)?Tu(this.Lb,Ps().os,!1):b.Ea(a)};e.bq=function(a){return hU(a)||Nu(this.Lb).Gc(a)||Je(a)||de(a)&&!Yf(Zf(),a).g()||Ru(this.Lb).Gc(a)?!0:!1};e.vf=function(a){return this.bq(a)};
e.Vh=function(a,b){return this.sp(a,b)};e.z=function(a){if(null===a)throw jo(wj(),null);this.Lb=a;return this};e.$classData=l({IW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$templateStat$1",{IW:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function XB(){this.Lb=null}XB.prototype=new c0;XB.prototype.constructor=XB;e=XB.prototype;
e.sp=function(a,b){if(de(a)&&!Yf(Zf(),a).g()){a=this.Lb;var c=(new E2).Gv(this),d=ce(a);b=ce(a);var d=d.$a(),f=x(a.h);if(!de(f)){for(var g=he(),h=[(new q).a("ScalametaParser.this.token",x(a.h))],n=A(new B,C()),u=0,w=h.length|0;u<w;)E(n,h[u]),u=1+u|0;ie(g,n.t)}ke(a.P)||(le(a),g=td((new yd).X((new r).d([""," doesn't support ellipses"])),(new r).d([a.P])),h=f.ja(),Pd(g,h));1!==f.Hb&&(le(a),g=oe(pe(),f.Hb,1),h=f.ja(),Pd(g,h));a.h.ia();g=x(a.h);if(ue(g)){Sd(a,(new ve).z(a));var D=we(a,!0,c);Sd(a,(new Ae).z(a))}else Be(g)?
(Sd(a,(new Ee).z(a)),D=we(a,!0,c),Sd(a,(new Ie).z(a))):Je(g)?D=we(a,!0,c):(le(a),g=td((new yd).X((new r).d(["$, ( or { expected but "," found"])),(new r).d([x(a.h).oa()])),h=x(a.h).ja(),Pd(g,h));if(Ke(D)){Le((Oe(),c).G(),D.uc())?g=(new q).a(!0,F()):(G(),g=(new r).d(["scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt) is false"]),h=G().b,g=(new q).a(!1,H(g,h)));if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();d=(new q).a("ellipsis",f);f=(new q).a("result",
D);c=(new q).a("evidence$4",c);h=(new q).a("quasi",D);n=Se();u=Te().Hc();D=[d,f,c,h,(new q).a("scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(meta.this.Tree.showStructure[T]).structure",Ue(Ve(n,D,u)))];d=A(new B,C());c=0;for(f=D.length|0;c<f;)E(d,D[c]),c=1+c|0;K(b,"scala.reflect.`package`.classTag[T](evidence$4).runtimeClass.isAssignableFrom(quasi.pt).\x26\x26(org.scalameta.`package`.debug(ellipsis, result, scala.meta.prettyprinters.`package`.XtensionStructure[T](result)(scala.meta.Tree.showStructure[T]).structure))",
a,d.t)}throw(new p).e(g);}f=We(new Ze,a,D);c=We(new Ze,a,D);f=f.eb;g=D.ca;D=D.fa();D=$u(av(),g,D);c=c.Fb;c<f&&(c=-1+f|0);c=(new L).K(f,1+c|0);f=M();D=O(P(f,D),R(a.ea,a.P,c))}D=$u(av(),1,D);b=b.Ga();b<d&&(b=-1+d|0);b=(new L).K(d,1+b|0);d=M();return O(P(d,D),R(a.ea,a.P,b))}Je(a)?a=we(this.Lb,!0,(new F2).Gv(this)):mU(a)?a=Hea(this.Lb):hU(a)?a=St(this.Lb):sx(this.Lb).Gc(a)?(a=this.Lb,D=xh(a,!0,!0),b=Aw(a,!1),d=G(),a=Bw(a,D.ma(b,d.b))):a=b.Ea(a);return a};
e.bq=function(a){return de(a)&&!Yf(Zf(),a).g()||Je(a)||mU(a)||hU(a)||sx(this.Lb).Gc(a)?!0:!1};e.vf=function(a){return this.bq(a)};e.Vh=function(a,b){return this.sp(a,b)};e.z=function(a){if(null===a)throw jo(wj(),null);this.Lb=a;return this};e.$classData=l({LW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$topStat$1",{LW:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function HC(){this.r=null}HC.prototype=new m;HC.prototype.constructor=HC;e=HC.prototype;e.U=function(){return"AutoPos"};e.M=function(){return 0};
e.W=function(a){throw(new W).j(""+a);};e.Ga=function(){return qf(this.r.h)};e.v=function(){return"AutoPos"};e.$a=function(){return Tf(this.r.h)};e.A=function(){return 1018323461};e.L=function(){return Z(this)};e.z=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.$classData=l({SW:0},!1,"scala.meta.internal.parsers.ScalametaParser$AutoPos$",{SW:1,f:1,JC:1,R:1,x:1,l:1,k:1});function rf(){this.va=0;this.r=null}rf.prototype=new m;rf.prototype.constructor=rf;e=rf.prototype;e.U=function(){return"IndexPos"};
e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.HC&&a.r===this.r?this.va===a.va:!1};e.W=function(a){switch(a){case 0:return this.va;default:throw(new W).j(""+a);}};e.Ga=function(){return this.va};e.v=function(){return cQ(this)};e.$a=function(){return this.va};e.Ia=function(a,b){this.va=b;if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){var a=-889275714,a=Y().Gb(a,this.va);return Y().xd(a,1)};e.L=function(){return Z(this)};
e.$classData=l({HC:0},!1,"scala.meta.internal.parsers.ScalametaParser$IndexPos",{HC:1,f:1,JC:1,R:1,x:1,l:1,k:1});function Ze(){this.Qx=this.Xc=null;this.Fb=this.eb=0;this.r=null}Ze.prototype=new m;Ze.prototype.constructor=Ze;e=Ze.prototype;e.U=function(){return"TreePos"};e.M=function(){return 1};
function We(a,b,c){a.Xc=c;if(null===b)throw jo(wj(),null);a.r=b;var d=mG(c);a:{if(nG(d)&&(d=oG(pG(),d),!d.g())){b=d.q().Eb;c=-1+b.Ca|0;b=b.E;break a}Mja||(Mja=(new PN).c());a=(new yd).X((new r).d(["internal error: unpositioned prototype ",": ",""]));d=Se();b=b.kh;b=tg().If(b);b=yg(d,c,b).be();var d=Se(),f=Te().Hc();c=td(a,(new r).d([b,Ue(Ve(d,c,f))]));throw jo(wj(),(new q0).j(c));}a.Qx=(new fd).K(b,c);a.eb=a.Qx.Xa();a.Fb=a.Qx.bu();return a}
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.LC&&a.r===this.r){var b=this.Xc;a=a.Xc;return null===b?null===a:b===a}return!1};e.W=function(a){switch(a){case 0:return this.Xc;default:throw(new W).j(""+a);}};e.Ga=function(){return this.Fb};e.v=function(){return cQ(this)};e.$a=function(){return this.eb};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({LC:0},!1,"scala.meta.internal.parsers.ScalametaParser$TreePos",{LC:1,f:1,JC:1,R:1,x:1,l:1,k:1});
function G2(){}G2.prototype=new m;G2.prototype.constructor=G2;e=G2.prototype;e.c=function(){return this};e.U=function(){return"DoubleQuotes"};e.M=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return'"'};e.A=function(){return 1154378952};e.L=function(){return Z(this)};e.$classData=l({wY:0},!1,"scala.meta.internal.prettyprinters.DoubleQuotes$",{wY:1,f:1,MC:1,R:1,x:1,l:1,k:1});var Uva=void 0;function dG(){Uva||(Uva=(new G2).c());return Uva}function H2(){}H2.prototype=new m;
H2.prototype.constructor=H2;e=H2.prototype;e.c=function(){return this};e.U=function(){return"SingleQuotes"};e.M=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"'"};e.A=function(){return 1915682815};e.L=function(){return Z(this)};e.$classData=l({xY:0},!1,"scala.meta.internal.prettyprinters.SingleQuotes$",{xY:1,f:1,MC:1,R:1,x:1,l:1,k:1});var Vva=void 0;function bia(){Vva||(Vva=(new H2).c());return Vva}
function I2(){G();var a=(new r).d(["Pat"]),b=G().b;return H(a,b)}function J2(){G();var a=(new r).d(["Term"]),b=G().b;return H(a,b)}function K2(){G();var a=(new r).d(["Type"]),b=G().b;return H(a,b)}function L2(){}L2.prototype=new m;L2.prototype.constructor=L2;e=L2.prototype;e.c=function(){return this};e.U=function(){return"TripleQuotes"};e.M=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return'"""'};e.A=function(){return 652451733};e.L=function(){return Z(this)};
e.$classData=l({hZ:0},!1,"scala.meta.internal.prettyprinters.TripleQuotes$",{hZ:1,f:1,MC:1,R:1,x:1,l:1,k:1});var Wva=void 0;function cia(){Wva||(Wva=(new L2).c());return Wva}function nL(){this.Zu=this.Hx=null}nL.prototype=new c0;nL.prototype.constructor=nL;nL.prototype.vf=function(a){return this.Zu.la(a)};
nL.prototype.Vh=function(a,b){if(this.Zu.la(a)){b=null!==a?ra(a):null;if(null!==b)var c=!0,d=F();else G(),c=(new r).d(["tempClass is equal to null"]),d=G().b,d=H(c,d),c=!1;c?(Oe(),c=this.Hx,(null!==a&&(Ar(c.G(),a)||ta(a)&&Le(c.G(),k(rc))||ua(a)&&Le(c.G(),k(vc))||Od(a)&&Le(c.G(),k(jc))||Wa(a)&&Le(c.G(),k(yc))||ya(a)&&Le(c.G(),k(zc))||wa(a)&&Le(c.G(),k(Gc))||"number"===typeof a&&Le(c.G(),k(Ic))||"boolean"===typeof a&&Le(c.G(),k(ic))||void 0===a&&Le(c.G(),k(cc)))?(new T).e(a):S()).g()?(G(),c=(new r).d(["scala.reflect.`package`.classTag[T](tag).unapply(temp).isDefined is false"]),
d=G().b,c=(new q).a(!1,H(c,d))):c=(new q).a(!0,F())):c=(new q).a(!1,d);if(null===c||!0!==I(c)){if(null!==c&&(d=c.p(),!1===I(c))){var f=J();a=[(new q).a("tempClass",b),(new q).a("tag",this.Hx),(new q).a("temp",a)];b=A(new B,C());for(var g=0,h=a.length|0;g<h;)E(b,a[g]),g=1+g|0;K(f,"tempClass.!\x3d(null).\x26\x26(scala.reflect.`package`.classTag[T](tag).unapply(temp).isDefined)",d,b.t)}throw(new p).e(c);}}else a=b.Ea(a);return a};
nL.prototype.$classData=l({LZ:0},!1,"scala.meta.internal.trees.package$XtensionTreesMods$$anonfun$getAll$1",{LZ:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function mM(){}mM.prototype=new c0;mM.prototype.constructor=mM;mM.prototype.c=function(){return this};mM.prototype.vf=function(a){return null!==a};mM.prototype.Vh=function(a,b){null!==a?(b=a.qa(),a=a.p(),a=OL(lM(),a),b=(new q).a(b,a)):b=b.Ea(a);return b};
mM.prototype.$classData=l({ZZ:0},!1,"scala.meta.parsers.JSFacade$$anonfun$1",{ZZ:1,yn:1,f:1,Mb:1,Uc:1,l:1,k:1});function FH(){this.Rp=null}FH.prototype=new IM;FH.prototype.constructor=FH;e=FH.prototype;e.U=function(){return"Function"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Iw){var b=this.Rp;a=a.Rp;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Rp;default:throw(new W).j(""+a);}};
e.te=function(a){this.Rp=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Iw:0},!1,"scala.meta.prettyprinters.Show$Function",{Iw:1,Wl:1,f:1,R:1,x:1,l:1,k:1});function DM(){this.Bf=null}DM.prototype=new IM;DM.prototype.constructor=DM;e=DM.prototype;e.U=function(){return"Indent"};e.Iv=function(a){this.Bf=a;return this};e.M=function(){return 1};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Jw){var b=this.Bf;a=a.Bf;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Bf;default:throw(new W).j(""+a);}};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Jw:0},!1,"scala.meta.prettyprinters.Show$Indent",{Jw:1,Wl:1,f:1,R:1,x:1,l:1,k:1});function KG(){this.Bf=this.Ve=null}KG.prototype=new IM;KG.prototype.constructor=KG;e=KG.prototype;e.U=function(){return"Meta"};
e.M=function(){return 2};e.w=function(a){if(this===a)return!0;if(IH(a)&&dj(ej(),this.Ve,a.Ve)){var b=this.Bf;a=a.Bf;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Ve;case 1:return this.Bf;default:throw(new W).j(""+a);}};function JG(a,b,c){a.Ve=b;a.Bf=c;return a}e.A=function(){return WN(this)};e.L=function(){return Z(this)};function IH(a){return!!(a&&a.$classData&&a.$classData.H.YC)}
e.$classData=l({YC:0},!1,"scala.meta.prettyprinters.Show$Meta",{YC:1,Wl:1,f:1,R:1,x:1,l:1,k:1});function FM(){this.Bf=null}FM.prototype=new IM;FM.prototype.constructor=FM;e=FM.prototype;e.U=function(){return"Newline"};e.Iv=function(a){this.Bf=a;return this};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Kw){var b=this.Bf;a=a.Bf;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Bf;default:throw(new W).j(""+a);}};
e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Kw:0},!1,"scala.meta.prettyprinters.Show$Newline",{Kw:1,Wl:1,f:1,R:1,x:1,l:1,k:1});function M2(){}M2.prototype=new IM;M2.prototype.constructor=M2;e=M2.prototype;e.c=function(){return this};e.U=function(){return"None"};e.M=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.A=function(){return 2433880};e.L=function(){return Z(this)};
e.$classData=l({l_:0},!1,"scala.meta.prettyprinters.Show$None$",{l_:1,Wl:1,f:1,R:1,x:1,l:1,k:1});var Xva=void 0;function xG(){Xva||(Xva=(new M2).c());return Xva}function N2(){this.Mq=this.Gj=null}N2.prototype=new IM;N2.prototype.constructor=N2;e=N2.prototype;e.U=function(){return"Repeat"};e.M=function(){return 2};function tja(a,b){var c=new N2;c.Gj=a;c.Mq=b;return c}
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Lw){var b=this.Gj,c=a.Gj;return(null===b?null===c:b.w(c))?this.Mq===a.Mq:!1}return!1};e.W=function(a){switch(a){case 0:return this.Gj;case 1:return this.Mq;default:throw(new W).j(""+a);}};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Lw:0},!1,"scala.meta.prettyprinters.Show$Repeat",{Lw:1,Wl:1,f:1,R:1,x:1,l:1,k:1});function LF(){this.Gj=null}LF.prototype=new IM;LF.prototype.constructor=LF;e=LF.prototype;
e.U=function(){return"Sequence"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Mw){var b=this.Gj;a=a.Gj;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Gj;default:throw(new W).j(""+a);}};e.X=function(a){this.Gj=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Mw:0},!1,"scala.meta.prettyprinters.Show$Sequence",{Mw:1,Wl:1,f:1,R:1,x:1,l:1,k:1});
function iG(){this.Y=null}iG.prototype=new IM;iG.prototype.constructor=iG;e=iG.prototype;e.U=function(){return"Str"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Nw?this.Y===a.Y:!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.j=function(a){this.Y=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Nw:0},!1,"scala.meta.prettyprinters.Show$Str",{Nw:1,Wl:1,f:1,R:1,x:1,l:1,k:1});
function CM(){this.Fp=this.Wq=this.Bf=this.uq=null}CM.prototype=new IM;CM.prototype.constructor=CM;e=CM.prototype;e.U=function(){return"Wrap"};e.M=function(){return 4};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Ow){if(this.uq===a.uq)var b=this.Bf,c=a.Bf,b=null===b?null===c:b.w(c);else b=!1;if(b&&this.Wq===a.Wq)return b=this.Fp,a=a.Fp,null===b?null===a:b.w(a)}return!1};
e.W=function(a){switch(a){case 0:return this.uq;case 1:return this.Bf;case 2:return this.Wq;case 3:return this.Fp;default:throw(new W).j(""+a);}};function BM(a,b,c,d,f){a.uq=b;a.Bf=c;a.Wq=d;a.Fp=f;return a}e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Ow:0},!1,"scala.meta.prettyprinters.Show$Wrap",{Ow:1,Wl:1,f:1,R:1,x:1,l:1,k:1});function IL(){this.Y=null}IL.prototype=new vva;IL.prototype.constructor=IL;e=IL.prototype;e.U=function(){return"Left"};e.M=function(){return 1};
e.w=function(a){return this===a?!0:JL(a)?dj(ej(),this.Y,a.Y):!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.e=function(a){this.Y=a;return this};e.kB=function(){return!0};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function JL(a){return!!(a&&a.$classData&&a.$classData.H.AE)}e.$classData=l({AE:0},!1,"scala.util.Left",{AE:1,D1:1,f:1,R:1,x:1,l:1,k:1});function HL(){this.Y=null}HL.prototype=new vva;
HL.prototype.constructor=HL;e=HL.prototype;e.U=function(){return"Right"};e.M=function(){return 1};e.w=function(a){return this===a?!0:ML(a)?dj(ej(),this.Y,a.Y):!1};e.W=function(a){switch(a){case 0:return this.Y;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.e=function(a){this.Y=a;return this};e.kB=function(){return!1};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function ML(a){return!!(a&&a.$classData&&a.$classData.H.BE)}
e.$classData=l({BE:0},!1,"scala.util.Right",{BE:1,D1:1,f:1,R:1,x:1,l:1,k:1});function b1(a,b){if(b&&b.$classData&&b.$classData.H.Lh){var c;if(!(c=a===b)&&(c=a.Za()===b.Za()))try{c=a.Fx(b)}catch(d){if(d&&d.$classData&&d.$classData.H.$I)c=!1;else throw d;}a=c}else a=!1;return a}function Yva(a,b,c){c=c.mi(a.Se());a.Cb(lk(function(a,b,c){return function(a){return c.$c(b.Ea(a).dc())}}(a,b,c)));return c.da()}function H(a,b){b=b.mj();Poa(b,a);b.$c(a.md());return b.da()}
function oD(a){if(a.g())throw(new Gq).j("empty.init");var b=a.n(),b=(new Uk).e(b),c=(new Kl).qj(!1),d=a.ic();Qoa(d,a,-1);a.Cb(lk(function(a,b,c,d){return function(a){c.cb?d.ba(b.cb):c.cb=!0;b.cb=a}}(a,b,c,d)));return d.da()}function O2(a){return a.le(a.jf()+"(",", ",")")}function Sea(a,b,c){return b.ma(a.dc(),Joa(c))}function zz(a){return a.g()?S():(new T).e(a.n())}
function P2(a,b,c){var d=a.ic();a.Cb(lk(function(a,b,c,d){return function(a){return!!b.Ea(a)!==c?d.ba(a):void 0}}(a,b,c,d)));return d.da()}function Q2(a,b,c){c=c.mi(a.Se());if(b&&b.$classData&&b.$classData.H.Zd){var d=b.dc().Za();Qoa(c,a,d)}c.$c(a.md());c.$c(b.dc());return c.da()}function Zva(a){var b=a.n(),b=(new Uk).e(b);a.Cb(lk(function(a,b){return function(a){b.cb=a}}(a,b)));return b.cb}function $va(a){if(a.g())throw(new Gq).j("empty.tail");return a.tf(1)}
function SQ(a,b,c){c=zg(a,c);a.Cb(lk(function(a,b,c){return function(a){return c.ba(b.Ea(a))}}(a,b,c)));return c.da()}function zg(a,b){b=b.mi(a.Se());Poa(b,a);return b}function awa(a,b,c){c=c.mi(a.Se());a.Cb(b.xq(lk(function(a,b){return function(a){return b.ba(a)}}(a,c))));return c.da()}
function R2(a){a=Md(ra(a.Se()));for(var b=-1+(a.length|0)|0;;)if(-1!==b&&36===(65535&(a.charCodeAt(b)|0)))b=-1+b|0;else break;if(-1===b||46===(65535&(a.charCodeAt(b)|0)))return"";for(var c="";;){for(var d=1+b|0;;)if(-1!==b&&57>=(65535&(a.charCodeAt(b)|0))&&48<=(65535&(a.charCodeAt(b)|0)))b=-1+b|0;else break;for(var f=b;;)if(-1!==b&&36!==(65535&(a.charCodeAt(b)|0))&&46!==(65535&(a.charCodeAt(b)|0)))b=-1+b|0;else break;var g=1+b|0;if(b===f&&d!==(a.length|0))return c;for(;;)if(-1!==b&&36===(65535&(a.charCodeAt(b)|
0)))b=-1+b|0;else break;var f=-1===b?!0:46===(65535&(a.charCodeAt(b)|0)),h;(h=f)||(h=65535&(a.charCodeAt(g)|0),h=!(90<h&&127>h||65>h));if(h){d=a.substring(g,d);g=c;if(null===g)throw(new fk).c();c=""===g?d:""+d+(new ed).db(46)+c;if(f)return c}}}function S2(){this.b=null}S2.prototype=new jua;S2.prototype.constructor=S2;function T2(){}T2.prototype=S2.prototype;function U2(){U1.call(this)}U2.prototype=new Eva;U2.prototype.constructor=U2;U2.prototype.UA=function(a){return V2(a)};
U2.prototype.$classData=l({y2:0},!1,"scala.collection.immutable.HashMap$HashTrieMap$$anon$1",{y2:1,s3:1,rh:1,f:1,Dg:1,tb:1,sb:1});function W2(){U1.call(this)}W2.prototype=new Eva;W2.prototype.constructor=W2;W2.prototype.UA=function(a){return a.Oe};W2.prototype.$classData=l({C2:0},!1,"scala.collection.immutable.HashSet$HashTrieSet$$anon$1",{C2:1,s3:1,rh:1,f:1,Dg:1,tb:1,sb:1});function X2(){}X2.prototype=new O1;X2.prototype.constructor=X2;X2.prototype.c=function(){return this};X2.prototype.Is=function(){return id()};
X2.prototype.$classData=l({a3:0},!1,"scala.collection.immutable.Set$",{a3:1,RE:1,Io:1,Ho:1,Sf:1,f:1,Tf:1});var bwa=void 0;function QQ(){bwa||(bwa=(new X2).c());return bwa}function Y2(){this.aj=null}Y2.prototype=new Lva;Y2.prototype.constructor=Y2;Y2.prototype.c=function(){b2.prototype.c.call(this);return this};Y2.prototype.da=function(){return cwa(this)};function cwa(a){return dwa(a.aj.ie.ce(),lk(function(){return function(a){return a.ce()}}(a)))}
function ewa(a){return!!(a&&a.$classData&&a.$classData.H.aF)}Y2.prototype.$classData=l({aF:0},!1,"scala.collection.immutable.Stream$StreamBuilder",{aF:1,j7:1,f:1,Nh:1,Fe:1,Ee:1,De:1});function Hk(){this.Kp=this.Zm=this.yp=0;this.BA=this.zA=this.xA=this.vA=this.tA=this.Mp=null}Hk.prototype=new m;Hk.prototype.constructor=Hk;e=Hk.prototype;e.Sc=function(){return this.xA};e.c=function(){this.Mp=oa(bc(Ab),[32]);this.Kp=1;this.Zm=this.yp=0;return this};e.sf=function(){return this.Kp};
e.ee=function(a){return Ik(this,a)};e.xl=function(a){this.BA=a};e.ye=function(){return this.Mp};e.ud=function(a){this.vA=a};e.Od=function(){return this.zA};
function Ik(a,b){if(a.Zm>=a.Mp.i.length){var c=32+a.yp|0,d=a.yp^c;if(1024>d)1===a.sf()&&(a.Wc(oa(bc(Ab),[32])),a.Ob().i[0]=a.ye(),a.Qi(1+a.sf()|0)),a.pd(oa(bc(Ab),[32])),a.Ob().i[31&(c>>>5|0)]=a.ye();else if(32768>d)2===a.sf()&&(a.ud(oa(bc(Ab),[32])),a.hc().i[0]=a.Ob(),a.Qi(1+a.sf()|0)),a.pd(oa(bc(Ab),[32])),a.Wc(oa(bc(Ab),[32])),a.Ob().i[31&(c>>>5|0)]=a.ye(),a.hc().i[31&(c>>>10|0)]=a.Ob();else if(1048576>d)3===a.sf()&&(a.ze(oa(bc(Ab),[32])),a.Sc().i[0]=a.hc(),a.Qi(1+a.sf()|0)),a.pd(oa(bc(Ab),[32])),
a.Wc(oa(bc(Ab),[32])),a.ud(oa(bc(Ab),[32])),a.Ob().i[31&(c>>>5|0)]=a.ye(),a.hc().i[31&(c>>>10|0)]=a.Ob(),a.Sc().i[31&(c>>>15|0)]=a.hc();else if(33554432>d)4===a.sf()&&(a.lh(oa(bc(Ab),[32])),a.Od().i[0]=a.Sc(),a.Qi(1+a.sf()|0)),a.pd(oa(bc(Ab),[32])),a.Wc(oa(bc(Ab),[32])),a.ud(oa(bc(Ab),[32])),a.ze(oa(bc(Ab),[32])),a.Ob().i[31&(c>>>5|0)]=a.ye(),a.hc().i[31&(c>>>10|0)]=a.Ob(),a.Sc().i[31&(c>>>15|0)]=a.hc(),a.Od().i[31&(c>>>20|0)]=a.Sc();else if(1073741824>d)5===a.sf()&&(a.xl(oa(bc(Ab),[32])),a.Hh().i[0]=
a.Od(),a.Qi(1+a.sf()|0)),a.pd(oa(bc(Ab),[32])),a.Wc(oa(bc(Ab),[32])),a.ud(oa(bc(Ab),[32])),a.ze(oa(bc(Ab),[32])),a.lh(oa(bc(Ab),[32])),a.Ob().i[31&(c>>>5|0)]=a.ye(),a.hc().i[31&(c>>>10|0)]=a.Ob(),a.Sc().i[31&(c>>>15|0)]=a.hc(),a.Od().i[31&(c>>>20|0)]=a.Sc(),a.Hh().i[31&(c>>>25|0)]=a.Od();else throw(new t).c();a.yp=c;a.Zm=0}a.Mp.i[a.Zm]=b;a.Zm=1+a.Zm|0;return a}e.da=function(){return Jk(this)};e.ii=function(a,b){iV(this,a,b)};e.Wc=function(a){this.tA=a};e.lh=function(a){this.zA=a};e.Ob=function(){return this.tA};
e.Hh=function(){return this.BA};function Jk(a){var b=a.yp+a.Zm|0;if(0===b)return uk().Ci;var c=(new Z2).Be(0,b,0);dk(c,a,a.Kp);1<a.Kp&&rba(c,0,-1+b|0);return c}e.ba=function(a){return Ik(this,a)};e.je=function(){};e.Qi=function(a){this.Kp=a};e.hc=function(){return this.vA};e.pd=function(a){this.Mp=a};e.$c=function(a){return GO(this,a)};e.ze=function(a){this.xA=a};e.$classData=l({v3:0},!1,"scala.collection.immutable.VectorBuilder",{v3:1,f:1,Nh:1,Fe:1,Ee:1,De:1,eF:1});
function $2(){this.jv=this.Ra=this.ul=this.iv=0;this.om=!1;this.dv=0;this.CA=this.AA=this.yA=this.wA=this.uA=this.ev=null}$2.prototype=new M0;$2.prototype.constructor=$2;e=$2.prototype;
e.bb=function(){if(!this.om)throw(new BP).j("reached iterator end");var a=this.ev.i[this.Ra];this.Ra=1+this.Ra|0;if(this.Ra===this.jv)if((this.ul+this.Ra|0)<this.iv){var b=32+this.ul|0,c=this.ul^b;if(1024>c)this.pd(this.Ob().i[31&(b>>>5|0)]);else if(32768>c)this.Wc(this.hc().i[31&(b>>>10|0)]),this.pd(this.Ob().i[0]);else if(1048576>c)this.ud(this.Sc().i[31&(b>>>15|0)]),this.Wc(this.hc().i[0]),this.pd(this.Ob().i[0]);else if(33554432>c)this.ze(this.Od().i[31&(b>>>20|0)]),this.ud(this.Sc().i[0]),this.Wc(this.hc().i[0]),
this.pd(this.Ob().i[0]);else if(1073741824>c)this.lh(this.Hh().i[31&(b>>>25|0)]),this.ze(this.Od().i[0]),this.ud(this.Sc().i[0]),this.Wc(this.hc().i[0]),this.pd(this.Ob().i[0]);else throw(new t).c();this.ul=b;b=this.iv-this.ul|0;this.jv=32>b?b:32;this.Ra=0}else this.om=!1;return a};e.Sc=function(){return this.yA};e.sf=function(){return this.dv};e.xl=function(a){this.CA=a};e.K=function(a,b){this.iv=b;this.ul=-32&a;this.Ra=31&a;a=b-this.ul|0;this.jv=32>a?a:32;this.om=(this.ul+this.Ra|0)<b;return this};
e.ye=function(){return this.ev};e.ud=function(a){this.wA=a};e.Od=function(){return this.AA};e.Wc=function(a){this.uA=a};e.fb=function(){return this.om};e.lh=function(a){this.AA=a};e.Ob=function(){return this.uA};e.Hh=function(){return this.CA};e.Qi=function(a){this.dv=a};e.hc=function(){return this.wA};e.pd=function(a){this.ev=a};e.ze=function(a){this.yA=a};e.$classData=l({w3:0},!1,"scala.collection.immutable.VectorIterator",{w3:1,rh:1,f:1,Dg:1,tb:1,sb:1,eF:1});function a3(){}a3.prototype=new Q1;
a3.prototype.constructor=a3;a3.prototype.c=function(){return this};a3.prototype.Yj=function(){return(new b3).c()};a3.prototype.$classData=l({h4:0},!1,"scala.collection.mutable.Set$",{h4:1,TE:1,Io:1,Ho:1,Sf:1,f:1,Tf:1});var fwa=void 0;function sI(){this.qh=this.Ve=null}sI.prototype=new fla;sI.prototype.constructor=sI;e=sI.prototype;e.U=function(){return"IndexedParserInput"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Au?dj(ej(),this.Ve,a.Ve):!1};
e.W=function(a){switch(a){case 0:return this.Ve;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};function e1(a,b){return b<(a.Ve.length|0)}e.Tp=function(a,b){this.Ve=a;this.qh=b;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Au:0},!1,"fastparse.utils.IndexedParserInput",{Au:1,o5:1,f:1,q5:1,R:1,x:1,l:1,k:1});function c3(){}c3.prototype=new fva;c3.prototype.constructor=c3;function gwa(){}gwa.prototype=c3.prototype;
c3.prototype.Bs=function(a){a=null===a?"null":pa(a);zo(this,null===a?"null":a);return this};c3.prototype.KI=function(){f1.prototype.JI.call(this);return this};c3.prototype.As=function(a){Ga();a=ca.String.fromCharCode(a);zo(this,a);return this};function d3(){v2.call(this);this.Ph=!1}d3.prototype=new Pva;d3.prototype.constructor=d3;e=d3.prototype;e.ln=function(a){if(this.Ph)throw(new Iq).c();var b=this.kb;if(b===this.jc)throw(new Jq).c();this.kb=1+b|0;this.Nd.i[this.ne+b|0]=a;return this};
e.Lo=function(a,b){return this.Ex(a,b)};e.Xn=function(){var a=this.kb;if(a===this.jc)throw(new Lq).c();this.kb=1+a|0;return this.Nd.i[this.ne+a|0]};function ppa(a,b,c,d,f,g){var h=new d3;h.Ph=g;v2.prototype.$A.call(h,a,b,c);mq.prototype.Pc.call(h,d);mq.prototype.ct.call(h,f);return h}e.Ex=function(a,b){if(0>a||b<a||b>(this.jc-this.kb|0))throw(new W).c();return ppa(this.Jj,this.Nd,this.ne,this.kb+a|0,this.kb+b|0,this.Ph)};
e.WA=function(a,b,c){if(0>b||0>c||b>(a.i.length-c|0))throw(new W).c();var d=this.kb,f=d+c|0;if(f>this.jc)throw(new Lq).c();this.kb=f;Ta(this.Nd,this.ne+d|0,a,b,c);return this};e.XA=function(a){if(0>a||a>=this.jc)throw(new W).c();return this.Nd.i[this.ne+a|0]};e.ZF=function(a,b){this.Nd.i[this.ne+a|0]=b};e.jq=function(a){return this.Nd.i[this.ne+a|0]};e.YF=function(a,b,c,d){Ta(b,c,this.Nd,this.ne+a|0,d)};e.Hl=function(){return this.Ph};
e.$classData=l({HH:0},!1,"java.nio.HeapCharBuffer",{HH:1,kz:1,jz:1,f:1,xf:1,ko:1,Zv:1,nJ:1});function e3(){v2.call(this);this.Sm=null;this.Tm=0}e3.prototype=new Pva;e3.prototype.constructor=e3;e=e3.prototype;e.ln=function(){throw(new Iq).c();};e.Lo=function(a,b){return this.Ex(a,b)};e.Xn=function(){var a=this.kb;if(a===this.jc)throw(new Lq).c();this.kb=1+a|0;return Ja(this.Sm,this.Tm+a|0)};e.v=function(){var a=this.Tm;return pa(Oa(this.Sm,this.kb+a|0,this.jc+a|0))};
function Bca(a,b,c,d,f){var g=new e3;g.Sm=b;g.Tm=c;v2.prototype.$A.call(g,a,null,-1);mq.prototype.Pc.call(g,d);mq.prototype.ct.call(g,f);return g}e.Ex=function(a,b){if(0>a||b<a||b>(this.jc-this.kb|0))throw(new W).c();return Bca(this.Jj,this.Sm,this.Tm,this.kb+a|0,this.kb+b|0)};e.WA=function(a,b,c){if(0>b||0>c||b>(a.i.length-c|0))throw(new W).c();var d=this.kb,f=d+c|0;if(f>this.jc)throw(new Lq).c();this.kb=f;for(c=d+c|0;d!==c;){var f=b,g=Ja(this.Sm,this.Tm+d|0);a.i[f]=g;d=1+d|0;b=1+b|0}return this};
e.XA=function(a){if(0>a||a>=this.jc)throw(new W).c();return Ja(this.Sm,this.Tm+a|0)};e.ZF=function(){throw(new Iq).c();};e.jq=function(a){return Ja(this.Sm,this.Tm+a|0)};e.YF=function(){throw(new Iq).c();};e.Hl=function(){return!0};e.$classData=l({JH:0},!1,"java.nio.StringCharBuffer",{JH:1,kz:1,jz:1,f:1,xf:1,ko:1,Zv:1,nJ:1});function h1(){this.Ug=this.Dj=this.pa=this.Ng=null;this.ra=0}h1.prototype=new m;h1.prototype.constructor=h1;e=h1.prototype;e.U=function(){return"Denotation"};e.M=function(){return 2};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Fu&&this.pa===a.pa){var b=this.Dj;a=a.Dj;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.pa;case 1:return this.Dj;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(['Input.Denotation("','", "','")'])),(new r).d([this.pa,this.Dj]))};e.od=function(){return 0===(1&this.ra)?this.Sk():this.Ng};e.$k=function(){0===(2&this.ra)&&(this.Ug=Dd(this),this.ra|=2);return this.Ug};
e.Pl=function(){return 0===(2&this.ra)?this.$k():this.Ug};e.A=function(){return WN(this)};e.Sk=function(){0===(1&this.ra)&&(this.Ng=EP(Ga(),this.pa),this.ra|=1);return this.Ng};e.L=function(){return Z(this)};e.$classData=l({Fu:0},!1,"org.langmeta.inputs.Input$Denotation",{Fu:1,f:1,Jr:1,R:1,x:1,l:1,k:1,Kr:1});function f3(){this.Ug=this.Ng=null;this.ra=0}f3.prototype=new m;f3.prototype.constructor=f3;e=f3.prototype;e.c=function(){return this};e.U=function(){return"None"};e.M=function(){return 0};
e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Input.None"};e.od=function(){return 0===(1&this.ra)?this.Sk():this.Ng};e.$k=function(){0===(2&this.ra)&&(this.Ug=Dd(this),this.ra|=2);return this.Ug};e.Pl=function(){return 0===(2&this.ra)?this.$k():this.Ug};e.A=function(){return 2433880};e.Sk=function(){0===(1&this.ra)&&(this.Ng=oa(bc(jc),[0]),this.ra|=1);return this.Ng};e.L=function(){return Z(this)};
e.$classData=l({$H:0},!1,"org.langmeta.inputs.Input$None$",{$H:1,f:1,Jr:1,R:1,x:1,l:1,k:1,Kr:1});var hwa=void 0;function Wq(){hwa||(hwa=(new f3).c());return hwa}function qC(){this.u=this.Ng=null;this.Ca=this.E=0;this.Ug=null;this.ra=0}qC.prototype=new m;qC.prototype.constructor=qC;e=qC.prototype;e.U=function(){return"Slice"};e.M=function(){return 3};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Gu){var b=this.u,c=a.u;return(null===b?null===c:b.w(c))&&this.E===a.E?this.Ca===a.Ca:!1}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.E;case 2:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(["Input.Slice(",", ",", ",")"])),(new r).d([this.u,this.E,this.Ca]))};e.od=function(){return 0===(1&this.ra)?this.Sk():this.Ng};
e.$k=function(){0===(2&this.ra)&&(this.Ug=Dd(this),this.ra|=2);return this.Ug};e.Pl=function(){return 0===(2&this.ra)?this.$k():this.Ug};e.ib=function(a,b,c){this.u=a;this.E=b;this.Ca=c;return this};e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.u)),a=Y().Gb(a,this.E),a=Y().Gb(a,this.Ca);return Y().xd(a,3)};
e.Sk=function(){if(0===(1&this.ra)){var a=this.u.od(),b=this.E,c=this.Ca,b=0<b?b:0,c=0<c?c:0,d=a.i.length,c=(c<d?c:d)-b|0,c=0<c?c:0,d=Gr(Ir(),zr(ra(a)),c);0<c&&E0(Tp(),a,b,d,0,c);this.Ng=d;this.ra|=1}return this.Ng};e.L=function(){return Z(this)};e.$classData=l({Gu:0},!1,"org.langmeta.inputs.Input$Slice",{Gu:1,f:1,Jr:1,R:1,x:1,l:1,k:1,Kr:1});function pT(){this.Ug=this.pa=this.Ng=null;this.ra=0}pT.prototype=new m;pT.prototype.constructor=pT;e=pT.prototype;e.U=function(){return"String"};e.M=function(){return 1};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.lz?this.pa===a.pa:!1};e.W=function(a){switch(a){case 0:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(['Input.String("','")'])),(new r).d([this.pa]))};e.od=function(){return 0===(1&this.ra)?this.Sk():this.Ng};e.$k=function(){0===(2&this.ra)&&(this.Ug=Dd(this),this.ra|=2);return this.Ug};e.Pl=function(){return 0===(2&this.ra)?this.$k():this.Ug};e.j=function(a){this.pa=a;return this};
e.A=function(){return WN(this)};e.Sk=function(){if(0===(1&this.ra)){var a=(new cd).j(this.pa);this.Ng=EP(Ga(),a.ka);this.ra|=1}return this.Ng};e.L=function(){return Z(this)};e.$classData=l({lz:0},!1,"org.langmeta.inputs.Input$String",{lz:1,f:1,Jr:1,R:1,x:1,l:1,k:1,Kr:1});function KT(){this.Ug=this.pa=this.bl=this.Ng=null;this.ra=0}KT.prototype=new m;KT.prototype.constructor=KT;e=KT.prototype;e.Ps=function(a,b){this.bl=a;this.pa=b;return this};e.U=function(){return"VirtualFile"};e.M=function(){return 2};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Hu?this.bl===a.bl&&this.pa===a.pa:!1};e.W=function(a){switch(a){case 0:return this.bl;case 1:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(['Input.VirtualFile("','", "','")'])),(new r).d([this.bl,this.pa]))};e.od=function(){return 0===(1&this.ra)?this.Sk():this.Ng};e.$k=function(){0===(2&this.ra)&&(this.Ug=Dd(this),this.ra|=2);return this.Ug};
e.Pl=function(){return 0===(2&this.ra)?this.$k():this.Ug};e.A=function(){return WN(this)};e.Sk=function(){if(0===(1&this.ra)){var a=(new cd).j(this.pa);this.Ng=EP(Ga(),a.ka);this.ra|=1}return this.Ng};e.L=function(){return Z(this)};e.$classData=l({Hu:0},!1,"org.langmeta.inputs.Input$VirtualFile",{Hu:1,f:1,Jr:1,R:1,x:1,l:1,k:1,Kr:1});function Nr(){this.gA=null}Nr.prototype=new m;Nr.prototype.constructor=Nr;Nr.prototype.Ie=function(a,b){return this.gA.Ie(a,b)};
Nr.prototype.$classData=l({vJ:0},!1,"java.util.Arrays$$anon$3",{vJ:1,f:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});function A0(){Rn.call(this);this.Zz=0;this.mv=null}A0.prototype=new y2;A0.prototype.constructor=A0;A0.prototype.Ak=function(){return"Conversion \x3d "+(new ed).db(this.Zz)+", Flags \x3d "+this.mv};A0.prototype.db=function(a){this.Zz=a;Rn.prototype.fd.call(this,null,null);this.mv=null;return this};
A0.prototype.$classData=l({wJ:0},!1,"java.util.FormatFlagsConversionMismatchException",{wJ:1,bw:1,Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function II(){this.Kl=null}II.prototype=new jla;II.prototype.constructor=II;II.prototype.c=function(){II.prototype.TI.call(this,(new Qq).c());return this};II.prototype.TI=function(a){this.Kl=a;return this};function MM(a,b){a=a.Kl.wg((new NM).e(b));return a.g()?null:a.q()}II.prototype.Za=function(){return this.Kl.Za()};
II.prototype.$classData=l({BJ:0},!1,"java.util.HashMap",{BJ:1,M5:1,f:1,JJ:1,l:1,k:1,dg:1,Mf:1});function nR(){this.dr=null}nR.prototype=new qva;nR.prototype.constructor=nR;nR.prototype.Za=function(){return this.dr.Kl.Za()};nR.prototype.Vp=function(a){if(null===a)throw jo(wj(),null);this.dr=a;return this};nR.prototype.Jl=function(){return kla(this)};nR.prototype.$classData=l({CJ:0},!1,"java.util.HashMap$EntrySet",{CJ:1,FB:1,EB:1,f:1,aw:1,BB:1,HB:1,P5:1});function w0(){Rn.call(this);this.pv=null}
w0.prototype=new y2;w0.prototype.constructor=w0;w0.prototype.c=function(){Rn.prototype.fd.call(this,null,null);this.pv=null;return this};w0.prototype.Ak=function(){return"Flags \x3d '"+this.pv+"'"};w0.prototype.j=function(a){w0.prototype.c.call(this);if(null===a)throw(new fk).c();this.pv=a;return this};w0.prototype.$classData=l({GJ:0},!1,"java.util.IllegalFormatFlagsException",{GJ:1,bw:1,Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function y0(){Rn.call(this);this.qn=null}y0.prototype=new y2;
y0.prototype.constructor=y0;y0.prototype.c=function(){Rn.prototype.fd.call(this,null,null);this.qn=null;return this};y0.prototype.Ak=function(){return"Format specifier '"+this.qn+"'"};y0.prototype.j=function(a){y0.prototype.c.call(this);if(null===a)throw(new fk).c();this.qn=a;return this};y0.prototype.$classData=l({LJ:0},!1,"java.util.MissingFormatArgumentException",{LJ:1,bw:1,Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function z0(){Rn.call(this);this.qn=null}z0.prototype=new y2;z0.prototype.constructor=z0;
z0.prototype.c=function(){Rn.prototype.fd.call(this,null,null);this.qn=null;return this};z0.prototype.Ak=function(){return this.qn};z0.prototype.j=function(a){z0.prototype.c.call(this);if(null===a)throw(new fk).c();this.qn=a;return this};z0.prototype.$classData=l({MJ:0},!1,"java.util.MissingFormatWidthException",{MJ:1,bw:1,Wm:1,Nf:1,ae:1,vd:1,f:1,k:1});function g3(){q.call(this);this.nm=0;this.cu=!1}g3.prototype=new Rva;g3.prototype.constructor=g3;e=g3.prototype;e.Xa=function(){return this.nm};
e.p=function(){return this.cu};e.Wx=function(){return this.cu};function wia(a,b){var c=new g3;c.nm=a;c.cu=b;q.prototype.a.call(c,null,null);return c}e.qa=function(){return this.nm};e.$classData=l({sK:0},!1,"scala.Tuple2$mcIZ$sp",{sK:1,ms:1,f:1,oC:1,R:1,x:1,l:1,k:1});function h3(){this.lg=this.r=null}h3.prototype=new m;h3.prototype.constructor=h3;h3.prototype.Ie=function(a,b){return this.r.Ie(this.lg.Ea(a),this.lg.Ea(b))};
h3.prototype.$classData=l({IK:0},!1,"scala.math.Ordering$$anon$5",{IK:1,f:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});function eG(a){return!!(a&&a.$classData&&a.$classData.H.sa)}var iwa=l({sa:0},!0,"scala.meta.Tree",{sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function i3(){this.Sq=this.pp=this.Br=null;this.ra=0}i3.prototype=new m;i3.prototype.constructor=i3;i3.prototype.c=function(){j3=this;Rla(this);return this};function pC(){var a=NL();null===NL().Br&&null===NL().Br&&(NL().Br=(new Vq).Av(a));NL()}
i3.prototype.LE=function(a){this.Sq=a};i3.prototype.KE=function(){};function Ls(){var a=NL();null===NL().pp&&null===NL().pp&&(NL().pp=(new gr).Av(a));return NL().pp}i3.prototype.$classData=l({UT:0},!1,"scala.meta.inputs.package$",{UT:1,f:1,TT:1,jI:1,XH:1,ST:1,iI:1,UH:1});var j3=void 0;function NL(){j3||(j3=(new i3).c());return j3}function k3(a,b){return null!==b&&Le(a.G(),ra(b))}function Qd(){Rn.call(this);this.xn=this.kn=null}Qd.prototype=new eW;Qd.prototype.constructor=Qd;e=Qd.prototype;e.U=function(){return"ParseException"};
e.M=function(){return 2};
e.Hm=function(a,b){this.kn=a;this.xn=b;var c=Tca((new jr).Sp(a),b);Rn.prototype.fd.call(this,c,null);null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.pos is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){for(var c=J(),d=[(new q).a("ParseException",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.pos.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.shortMessage is equal to null"]),b=
G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("ParseException",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.shortMessage.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.w=function(a){if(Cy(a)&&ns(a)&&2===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.kn;case 1:return this.xn;default:throw(new W).j(""+a);}};e.v=function(){return this.Sl};e.A=function(){return WN(this)};
e.L=function(){return Z(this)};function Cy(a){return!!(a&&a.$classData&&a.$classData.H.UC)}e.$classData=l({UC:0},!1,"scala.meta.parsers.ParseException",{UC:1,ae:1,vd:1,f:1,k:1,R:1,x:1,l:1});function BL(){this.yk=this.$m=this.cg=null}BL.prototype=new m;BL.prototype.constructor=BL;e=BL.prototype;e.U=function(){return"Error"};e.M=function(){return 3};e.w=function(a){if(lo(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.cg;case 1:return this.$m;case 2:return this.yk;default:throw(new W).j(""+a);}};e.v=function(){return this.yk.v()};e.A=function(){return WN(this)};
e.Os=function(a,b,c){this.cg=a;this.$m=b;this.yk=c;if(null!==a)a=(new q).a(!0,F());else{G();a=(new r).d(["this.pos is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){b=J();for(var d=[(new q).a("Error",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.pos.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.message is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){b=J();d=[(new q).a("Error",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.message.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?c=(new q).a(!0,F()):(G(),c=(new r).d(["this.details is equal to null"]),a=G().b,c=(new q).a(!1,H(c,a)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){b=J();d=[(new q).a("Error",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.details.!\x3d(null)",a,f.t)}throw(new p).e(c);
}return this};e.L=function(){return Z(this)};function lo(a){return!!(a&&a.$classData&&a.$classData.H.VC)}e.$classData=l({VC:0},!1,"scala.meta.parsers.Parsed$Error",{VC:1,f:1,c_:1,$:1,R:1,x:1,l:1,k:1});function AL(){this.Xc=null}AL.prototype=new m;AL.prototype.constructor=AL;e=AL.prototype;e.U=function(){return"Success"};e.M=function(){return 1};e.w=function(a){if(ao(a)&&ns(a)&&1===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.Xc;default:throw(new W).j(""+a);}};e.v=function(){return pa(this.Xc)};e.e=function(a){this.Xc=a;return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function ao(a){return!!(a&&a.$classData&&a.$classData.H.WC)}e.$classData=l({WC:0},!1,"scala.meta.parsers.Parsed$Success",{WC:1,f:1,c_:1,$:1,R:1,x:1,l:1,k:1});function Jj(){Rn.call(this);this.xn=this.kn=null}Jj.prototype=new eW;Jj.prototype.constructor=Jj;e=Jj.prototype;e.U=function(){return"TokenizeException"};
e.M=function(){return 2};
e.Hm=function(a,b){this.kn=a;this.xn=b;var c=Tca((new jr).Sp(a),b);Rn.prototype.fd.call(this,c,null);null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.pos is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){for(var c=J(),d=[(new q).a("TokenizeException",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.pos.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.shortMessage is equal to null"]),b=
G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("TokenizeException",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.shortMessage.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.w=function(a){if(tC(a)&&ns(a)&&2===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.kn;case 1:return this.xn;default:throw(new W).j(""+a);}};e.v=function(){return this.Sl};e.A=function(){return WN(this)};
e.L=function(){return Z(this)};function tC(a){return!!(a&&a.$classData&&a.$classData.H.ZC)}e.$classData=l({ZC:0},!1,"scala.meta.tokenizers.TokenizeException",{ZC:1,ae:1,vd:1,f:1,k:1,R:1,x:1,l:1});function TM(){this.yk=this.$m=this.cg=null}TM.prototype=new m;TM.prototype.constructor=TM;e=TM.prototype;e.U=function(){return"Error"};e.M=function(){return 3};e.w=function(a){if(aA(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.cg;case 1:return this.$m;case 2:return this.yk;default:throw(new W).j(""+a);}};e.v=function(){return this.yk.v()};e.A=function(){return WN(this)};
e.Os=function(a,b,c){this.cg=a;this.$m=b;this.yk=c;if(null!==a)a=(new q).a(!0,F());else{G();a=(new r).d(["this.pos is equal to null"]);var d=G().b;a=(new q).a(!1,H(a,d))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){b=J();for(var d=[(new q).a("Error",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.pos.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.message is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){b=J();d=[(new q).a("Error",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.message.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?c=(new q).a(!0,F()):(G(),c=(new r).d(["this.details is equal to null"]),a=G().b,c=(new q).a(!1,H(c,a)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){b=J();d=[(new q).a("Error",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.details.!\x3d(null)",a,f.t)}throw(new p).e(c);
}return this};e.L=function(){return Z(this)};function aA(a){return!!(a&&a.$classData&&a.$classData.H.$C)}e.$classData=l({$C:0},!1,"scala.meta.tokenizers.Tokenized$Error",{$C:1,f:1,v_:1,$:1,R:1,x:1,l:1,k:1});function SM(){this.jl=null}SM.prototype=new m;SM.prototype.constructor=SM;e=SM.prototype;e.U=function(){return"Success"};e.M=function(){return 1};e.w=function(a){if($z(a)&&ns(a)&&1===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.jl;default:throw(new W).j(""+a);}};e.v=function(){return gG(this.jl,"","","")};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function $z(a){return!!(a&&a.$classData&&a.$classData.H.aD)}e.$classData=l({aD:0},!1,"scala.meta.tokenizers.Tokenized$Success",{aD:1,f:1,v_:1,$:1,R:1,x:1,l:1,k:1});var XD=l({rb:0},!0,"scala.meta.tokens.Token",{rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function mv(){this.nt=null}mv.prototype=new m;
mv.prototype.constructor=mv;e=mv.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){return E1(this,this.nt)};e.G=function(){return this.nt};e.Ud=function(a){this.nt=a;return this};e.A=function(){return YN(Y(),this.nt)};e.$classData=l({j1:0},!1,"scala.reflect.ClassTag$GenericClassTag",{j1:1,f:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function l3(){this.b=null}l3.prototype=new T2;l3.prototype.constructor=l3;l3.prototype.c=function(){ZU.prototype.c.call(this);return this};
l3.prototype.ic=function(){m3();return(new ae).c()};l3.prototype.$classData=l({Z1:0},!1,"scala.collection.Seq$",{Z1:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var jwa=void 0;function Xo(){jwa||(jwa=(new l3).c());return jwa}function n3(){this.b=null}n3.prototype=new T2;n3.prototype.constructor=n3;function o3(){}o3.prototype=n3.prototype;function p3(){}p3.prototype=new kua;p3.prototype.constructor=p3;p3.prototype.c=function(){q3=this;(new eV).vv(Wm(function(){return function(a){return a}}(this)));return this};
function kwa(a,b,c,d,f,g,h){var n=31&(b>>>g|0),u=31&(d>>>g|0);if(n!==u)return a=1<<n|1<<u,b=oa(bc(r3),[2]),n<u?(b.i[0]=c,b.i[1]=f):(b.i[0]=f,b.i[1]=c),s3(new t3,a,b,h);u=oa(bc(r3),[1]);n=1<<n;u.i[0]=kwa(a,b,c,d,f,5+g|0,h);return s3(new t3,n,u,h)}p3.prototype.KA=function(){return u3()};p3.prototype.$classData=l({t2:0},!1,"scala.collection.immutable.HashMap$",{t2:1,q2:1,r2:1,n2:1,f:1,d7:1,l:1,k:1});var q3=void 0;function v3(){q3||(q3=(new p3).c());return q3}function w3(){this.b=null}w3.prototype=new T2;
w3.prototype.constructor=w3;w3.prototype.c=function(){ZU.prototype.c.call(this);return this};w3.prototype.ic=function(){return(new ae).c()};w3.prototype.$classData=l({$2:0},!1,"scala.collection.immutable.Seq$",{$2:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var lwa=void 0;function m3(){lwa||(lwa=(new w3).c());return lwa}function x3(){}x3.prototype=new m;x3.prototype.constructor=x3;function y3(){}y3.prototype=x3.prototype;x3.prototype.ii=function(a,b){iV(this,a,b)};x3.prototype.je=function(){};
x3.prototype.$c=function(a){return GO(this,a)};function Z0(){this.b=null}Z0.prototype=new T2;Z0.prototype.constructor=Z0;Z0.prototype.c=function(){ZU.prototype.c.call(this);return this};Z0.prototype.ic=function(){return(new r).c()};Z0.prototype.$classData=l({M3:0},!1,"scala.collection.mutable.Buffer$",{M3:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var dva=void 0;function z3(){this.b=null}z3.prototype=new T2;z3.prototype.constructor=z3;z3.prototype.c=function(){ZU.prototype.c.call(this);return this};
z3.prototype.ic=function(){return(new Fd).c()};z3.prototype.$classData=l({Z3:0},!1,"scala.collection.mutable.IndexedSeq$",{Z3:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var mwa=void 0;function nwa(){mwa||(mwa=(new z3).c());return mwa}function A3(){this.b=null}A3.prototype=new T2;A3.prototype.constructor=A3;A3.prototype.c=function(){ZU.prototype.c.call(this);return this};A3.prototype.ic=function(){return(new r).c()};
A3.prototype.$classData=l({p4:0},!1,"scala.scalajs.js.WrappedArray$",{p4:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var owa=void 0;function pl(){owa||(owa=(new A3).c());return owa}function $Q(){this.Fc=this.Af=null}$Q.prototype=new AV;$Q.prototype.constructor=$Q;e=$Q.prototype;e.U=function(){return"Capturing"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Ny){var b=this.Fc;a=a.Fc;return null===b?null===a:b.w(a)}return!1};
e.W=function(a){switch(a){case 0:return this.Fc;default:throw(new W).j(""+a);}};e.v=function(){return this.Fc.v()};e.Wa=function(a,b){this.Fc=a;wQ.prototype.Ne.call(this,b);return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.Dd=function(a,b){var c=a.Fl;a.Fl=!0;var d=this.Fc.Dd(a,b);a.Fl=c;if(t2(d)){var c=d.va,f=d.nd,d=d.id,g=a.ji;a=FQ(a.u.Ve,b,c);return sd(g,a,c,f,d)}if(r2(d))return d;throw(new p).e(d);};
e.$classData=l({Ny:0},!1,"fastparse.parsers.Combinators$Capturing",{Ny:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function UQ(){this.it=this.Bg=this.Af=null;this.pw=0}UQ.prototype=new AV;UQ.prototype.constructor=UQ;e=UQ.prototype;e.U=function(){return"Either"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.xu){var b=this.Bg;a=a.Bg;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Bg;default:throw(new W).j(""+a);}};
e.v=function(){var a=this.Bg,b=lk(function(a){return function(b){return No(Po(),b,a.Fk())}}(this)),c=Xo();return a.yf(b,c.b).Pd(" | ")};e.A=function(){return WN(this)};
e.Dd=function(a,b){a:{var c=id(),d=0;b:for(;;){if(d>=this.pw){a=jd(this,a.Zj,b,null,!1);break a}var f;if(d===(-1+this.pw|0))f=this.it.i[d].Dd(a,b);else{var g=a.Zh;a.Zh=!0;f=this.it.i[d].Dd(a,b);a.Zh=g}var h=!1,g=null;if(t2(f)){b=f;b.nd=gd(a.lf,b.nd,c);a=b;break a}if(r2(f)&&(h=!0,g=f,g.id)){a=qd(this,g,b,a.Sg,null,!1);break a}if(h){d=1+d|0;c=gd(a.lf,g.nd,c);continue b}throw(new p).e(f);}}return a};e.L=function(){return Z(this)};e.Fk=function(){return 1===this.Bg.Fa()?this.Bg.rc(0).Fk():Po().Vt};
e.$classData=l({xu:0},!1,"fastparse.parsers.Combinators$Either",{xu:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function aR(){this.Fc=this.Af=null}aR.prototype=new AV;aR.prototype.constructor=aR;e=aR.prototype;e.U=function(){return"Not"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Oy){var b=this.Fc;a=a.Fc;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Fc;default:throw(new W).j(""+a);}};
e.v=function(){return td((new yd).X((new r).d(["!(",")"])),(new r).d([this.Fc]))};e.Wa=function(a,b){this.Fc=a;wQ.prototype.Ne.call(this,b);return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.Dd=function(a,b){var c=a.Gl;a.Gl=!0;var d=this.Fc.Dd(a,b);a.Gl=c;if(t2(d))b=jd(this,a.Zj,d.va,null,!1);else{if(!r2(d))throw(new p).e(d);a=a.ji;c=id();b=sd(a,void 0,b,c,!1)}return b};e.Fk=function(){return Po().Ez};
e.$classData=l({Oy:0},!1,"fastparse.parsers.Combinators$Not",{Oy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function ZQ(){this.mq=this.Fc=this.Af=null}ZQ.prototype=new AV;ZQ.prototype.constructor=ZQ;e=ZQ.prototype;e.U=function(){return"Opaque"};e.M=function(){return 2};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Py){var b=this.Fc,c=a.Fc;return(null===b?null===c:b.w(c))?this.mq===a.mq:!1}return!1};
e.W=function(a){switch(a){case 0:return this.Fc;case 1:return this.mq;default:throw(new W).j(""+a);}};e.v=function(){return this.mq};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.Dd=function(a,b){var c=this.Fc.Dd(a,b);if(t2(c)){if(-1!==a.lf){a=[this];if(0===(a.length|0))a=id();else{b=kd(new ld,id());for(var d=0,f=a.length|0;d<f;)md(b,a[d]),d=1+d|0;a=b.t}c.nd=a}return c}if(r2(c)){c.va=b;c.zg=this;if(-1!==a.lf){a=[this];if(0===(a.length|0))a=id();else{b=kd(new ld,id());d=0;for(f=a.length|0;d<f;)md(b,a[d]),d=1+d|0;a=b.t}c.nd=a}return c}throw(new p).e(c);};e.$classData=l({Py:0},!1,"fastparse.parsers.Combinators$Opaque",{Py:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});
function WQ(){this.Dm=this.Fc=this.Af=null}WQ.prototype=new AV;WQ.prototype.constructor=WQ;e=WQ.prototype;e.U=function(){return"Optional"};e.M=function(){return 1};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Qy){var b=this.Fc;a=a.Fc;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Fc;default:throw(new W).j(""+a);}};e.v=function(){var a=this.Fc;return td((new yd).X((new r).d(["",".?"])),(new r).d([No(Po(),a,Po().mp)]))};e.A=function(){return WN(this)};
e.L=function(){return Z(this)};e.Dd=function(a,b){var c=a.Zh;a.Zh=!0;var d=this.Fc.Dd(a,b);a.Zh=c;if(t2(d))return sd(a.ji,void 0,d.va,d.nd,d.id);if(r2(d)&&d.id)return qd(this,d,b,a.Sg,null,!1);a=a.ji;c=id();return sd(a,void 0,b,c,!1)};e.$classData=l({Qy:0},!1,"fastparse.parsers.Combinators$Optional",{Qy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function B3(){this.Fc=this.Af=null;this.Yk=this.Ml=0;this.Dm=this.wl=null}B3.prototype=new AV;B3.prototype.constructor=B3;e=B3.prototype;e.U=function(){return"Repeat"};
e.M=function(){return 4};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Ry){var b=this.Fc,c=a.Fc;if((null===b?null===c:b.w(c))&&this.Ml===a.Ml&&this.Yk===a.Yk)return b=this.wl,a=a.wl,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Fc;case 1:return this.Ml;case 2:return this.Yk;case 3:return this.wl;default:throw(new W).j(""+a);}};
e.v=function(){var a=Xo(),b=0===this.Ml?S():(new T).e(this.Ml),c=this.wl,d=(new WK).Ne(this.Af),a=uu(a,(new r).d([b,null!==c&&c.w(d)?S():(new T).e("sep \x3d "+this.wl),2147483647===this.Yk?S():(new T).e("max \x3d "+this.Yk)])).qv(lk(function(){return function(a){return a.lb()}}(this))).Pd(", ");if(null===a)throw(new fk).c();if(""===a)return a=this.Fc,No(Po(),a,Po().mp)+".rep";b=this.Fc;return td((new yd).X((new r).d(["",".rep(",")"])),(new r).d([No(Po(),b,Po().mp),a]))};
function Zka(a,b,c,d,f){var g=new B3;g.Fc=a;g.Ml=b;g.Yk=2147483647;g.wl=c;g.Dm=d;wQ.prototype.Ne.call(g,f);return g}function pwa(a,b,c,d,f,g,h){return a.Ml<=f?(a=null===c?id():c.nd,sd(g.ji,void 0,d,a,b)):qd(a,c,h,g.Sg,null,b)}e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.Fc)),a=Y().Gb(a,this.Ml),a=Y().Gb(a,this.Yk),a=Y().Gb(a,YN(Y(),this.wl));return Y().xd(a,4)};
e.Dd=function(a,b){if(0===this.Yk){a=a.ji;var c=id();return sd(a,void 0,b,c,!1)}a:{var c=b,d=(new WK).Ne(this.Af),f=!1,g=0;for(;;){var h=a.Zh;a.Zh=!0;d=d.Dd(a,c);a.Zh=h;if(r2(d)){b=d.id?qd(this,d,c,a.Sg,null,!0):pwa(this,f,d,c,g,a,b);break a}if(t2(d)){var n=d.va,d=d.id;a.Zh=!0;var u=this.Fc.Dd(a,n);a.Zh=h;if(r2(u)){h=u;b=h.id|d?qd(this,h,n,a.Sg,null,!0):pwa(this,!!(f|d),h,c,g,a,b);break a}if(t2(u))if(f=u,c=f.va,h=f.id,g=1+g|0,g<this.Yk)f=this.wl,h=!!(d|h),d=f,f=h;else{b=pwa(this,!!(d|h),null,c,g,
a,b);break a}else throw(new p).e(u);}else throw(new p).e(d);}}return b};e.L=function(){return Z(this)};e.$classData=l({Ry:0},!1,"fastparse.parsers.Combinators$Repeat",{Ry:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function C3(){this.Fc=this.Jh=this.ZB=this.Af=null;this.Wu=!1}C3.prototype=new AV;C3.prototype.constructor=C3;e=C3.prototype;e.U=function(){return"Rule"};e.M=function(){return 2};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Sy?this.Jh===a.Jh?this.Fc===a.Fc:!1:!1};
e.W=function(a){switch(a){case 0:return this.Jh;case 1:return this.Fc;default:throw(new W).j(""+a);}};e.v=function(){return this.Jh};function qwa(a,b,c,d){if(null===d)throw(new fk).c();if(d.Hg)return d.Ab;var f=rwa(a).Dd(b,c);if(r2(f))a=qd(a,f,c,b.Sg,null,!1);else{if(!t2(f))throw(new p).e(f);a=f}return hk(d,a)}function MK(a,b,c){var d=new C3;d.Jh=a;d.Fc=b;wQ.prototype.Ne.call(d,c);return d}function rwa(a){a.Wu||a.Wu||(a.ZB=OO(a.Fc),a.Wu=!0);return a.ZB}e.A=function(){return WN(this)};
e.Dd=function(a,b){if(null===a.Km){var c=rwa(this).Dd(a,b);if(r2(c))return qd(this,c,b,a.Sg,null,!1);if(t2(c))return c;throw(new p).e(c);}c=(new ik).c();a.Km.tp(this,b,Rq(function(a,b,c,h){return function(){return(h.Hg?h.Ab:qwa(a,b,c,h)).Lx()}}(this,a,b,c)));return c.Hg?c.Ab:qwa(this,a,b,c)};e.L=function(){return Z(this)};e.$classData=l({Sy:0},!1,"fastparse.parsers.Combinators$Rule",{Sy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function D3(){this.Gk=this.al=this.Af=null;this.Wj=!1;this.Dm=null}
D3.prototype=new AV;D3.prototype.constructor=D3;e=D3.prototype;e.U=function(){return"Sequence"};e.M=function(){return 3};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.yu){var b=this.al,c=a.al;(null===b?null===c:b.w(c))?(b=this.Gk,c=a.Gk,b=null===b?null===c:b.w(c)):b=!1;return b?this.Wj===a.Wj:!1}return!1};e.W=function(a){switch(a){case 0:return this.al;case 1:return this.Gk;case 2:return this.Wj;default:throw(new W).j(""+a);}};
e.v=function(){var a=this.Wj?"~/":"~",b=this.al,b=No(Po(),b,Po().um),c=this.Gk;return b+" "+a+" "+No(Po(),c,Po().um)};function dla(a,b,c,d,f){var g=new D3;g.al=a;g.Gk=b;g.Wj=c;g.Dm=d;wQ.prototype.Ne.call(g,f);return g}e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.al)),a=Y().Gb(a,YN(Y(),this.Gk)),a=Y().Gb(a,this.Wj?1231:1237);return Y().xd(a,3)};
e.Dd=function(a,b){var c=this.al.Dd(a,b);if(r2(c)){var d=a.Sg;a=a.lf;var f=[this.al];if(0===(f.length|0))f=id();else{for(var g=kd(new ld,id()),h=0,n=f.length|0;h<n;)md(g,f[h]),h=1+h|0;f=g.t}g=id();a=gd(a,f,g);return qd(this,c,b,d,a,c.id)}if(t2(c)){g=c.pa;f=c.nd;d=c.id;c=this.Gk.Dd(a,c.va);if(r2(c))return g=a.Sg,a=gd(a.lf,f,c.nd),qd(this,c,b,g,a,!!(!!(this.Wj|c.id)|d));if(t2(c)){b=c.va;var u=c.nd,h=c.id,n=a.ji,c=this.Dm.ug(g,c.pa);a=gd(a.lf,u,f);return sd(n,c,b,a,!!(!!(h|d)|this.Wj))}}throw(new p).e(c);
};e.L=function(){return Z(this)};e.Fk=function(){return Po().um};e.$classData=l({yu:0},!1,"fastparse.parsers.Combinators$Sequence",{yu:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function E3(){this.Bg=this.Ql=this.Af=null}E3.prototype=new AV;E3.prototype.constructor=E3;e=E3.prototype;e.U=function(){return"Flat"};e.M=function(){return 2};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.zu){var b=this.Ql,c=a.Ql;if(null===b?null===c:b.w(c))return b=this.Bg,a=a.Bg,null===b?null===a:a1(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.Ql;case 1:return this.Bg;default:throw(new W).j(""+a);}};function cpa(a,b,c){var d=new E3;d.Ql=a;d.Bg=b;wQ.prototype.Ne.call(d,c);return d}
e.v=function(){for(var a=this.Bg,b=CV().b,b=zg(a,b),c=0,d=a.kd;c<d;){var f=a.Da.i[c],g=f.Hi;b.ba(" ~"+(f.id?"/":"")+" "+No(Po(),g,Po().um));c=1+c|0}a=b.da();b=this.Ql;return td((new yd).X((new r).d(["","",""])),(new r).d([No(Po(),b,Po().um),gG(a,"","","")]))};e.A=function(){return WN(this)};
e.Dd=function(a,b){var c=this.Ql.Dd(a,b);if(r2(c))return qd(this,c,b,a.Sg,null,c.id);if(t2(c)){a:{var d=c.pa,f=c.va;b=c.id;var c=c.nd,g=0;for(;;){g<this.Bg.kd&&f0(this.Bg,g);if(g>=this.Bg.kd){a=sd(a.ji,d,f,c,b);break a}var h=f0(this.Bg,g),n=h.Hi.Dd(a,f);if(r2(n)){d=n;g=f;f=a.Sg;a=gd(a.lf,d.nd,c);a=qd(this,d,g,f,a,!!(!!(h.id|d.id)|b));break a}if(t2(n)){var u=n,f=u.va,n=u.nd,w=u.id,d=h.MA.ug(d,u.pa);b=!!(!!(h.id|w)|b);h=1+g|0;c=n.fm(c);g=h}else throw(new p).e(n);}}return a}throw(new p).e(c);};e.L=function(){return Z(this)};
e.Fk=function(){return Po().um};e.$classData=l({zu:0},!1,"fastparse.parsers.Combinators$Sequence$Flat",{zu:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function vQ(){this.Fg=this.Jh=this.Af=null}vQ.prototype=new AV;vQ.prototype.constructor=vQ;e=vQ.prototype;e.U=function(){return"AnyElem"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Yy?this.Jh===a.Jh:!1};e.W=function(a){switch(a){case 0:return this.Jh;default:throw(new W).j(""+a);}};e.v=function(){return this.Fg};
e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.Dd=function(a,b){if(e1(a.u,b)){a=a.ji;b=1+b|0;var c=id();return sd(a,void 0,b,c,!1)}return jd(this,a.Zj,b,null,!1)};e.$classData=l({Yy:0},!1,"fastparse.parsers.Terminals$AnyElem",{Yy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function CQ(){this.nj=this.Af=null}CQ.prototype=new AV;CQ.prototype.constructor=CQ;e=CQ.prototype;e.U=function(){return"ElemLiteral"};e.M=function(){return 1};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.Zy?dj(ej(),this.nj,a.nj):!1};e.W=function(a){switch(a){case 0:return this.nj;default:throw(new W).j(""+a);}};e.v=function(){var a=this.nj,a=ca.String.fromCharCode(null===a?0:a.pa);return Yo(a)};e.Tp=function(a,b){this.nj=a;wQ.prototype.Ne.call(this,b);return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.Dd=function(a,b){var c=a.u;return e1(c,b)&&(ej(),c=65535&(c.Ve.charCodeAt(b)|0),dj(0,(new ed).db(c),this.nj))?(a=a.ji,b=1+b|0,c=id(),sd(a,void 0,b,c,!1)):jd(this,a.Zj,b,null,!1)};e.$classData=l({Zy:0},!1,"fastparse.parsers.Terminals$ElemLiteral",{Zy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function sQ(){this.Fg=this.Af=null}sQ.prototype=new AV;sQ.prototype.constructor=sQ;e=sQ.prototype;e.U=function(){return"Fail"};e.M=function(){return 0};
e.w=function(a){return!!(a&&a.$classData&&a.$classData.H.$y)&&!0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return this.Fg};e.Ne=function(a){wQ.prototype.Ne.call(this,a);this.Fg="Fail";return this};e.A=function(){return WN(this)};e.Dd=function(a,b){return jd(this,a.Zj,b,null,!1)};e.L=function(){return Z(this)};e.$classData=l({$y:0},!1,"fastparse.parsers.Terminals$Fail",{$y:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function DQ(){this.pn=this.Af=null}DQ.prototype=new AV;
DQ.prototype.constructor=DQ;e=DQ.prototype;e.U=function(){return"Literal"};e.M=function(){return 1};e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.az?dj(ej(),this.pn,a.pn):!1};e.W=function(a){switch(a){case 0:return this.pn;default:throw(new W).j(""+a);}};e.v=function(){return Yo(this.pn)};e.Tp=function(a,b){this.pn=a;wQ.prototype.Ne.call(this,b);return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.Dd=function(a,b){hca||(hca=(new ap).c());var c;a:{c=a.u;var d=this.pn,f=0;for(;;){if(f>=(d.length|0)){c=!0;break a}if(e1(c,f+b|0)){ej();var g=65535&(c.Ve.charCodeAt(f+b|0)|0),g=(new ed).db(g),h=65535&(d.charCodeAt(f)|0);if(dj(0,g,(new ed).db(h)))f=1+f|0;else{c=!1;break a}}else{c=!1;break a}}}return c?(a=a.ji,b=b+(this.pn.length|0)|0,c=id(),sd(a,void 0,b,c,!1)):jd(this,a.Zj,b,null,!1)};e.$classData=l({az:0},!1,"fastparse.parsers.Terminals$Literal",{az:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});
function WK(){this.Fg=this.Af=null}WK.prototype=new AV;WK.prototype.constructor=WK;e=WK.prototype;e.U=function(){return"Pass"};e.M=function(){return 0};e.w=function(a){return!!(a&&a.$classData&&a.$classData.H.bz)&&!0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return this.Fg};e.Ne=function(a){wQ.prototype.Ne.call(this,a);this.Fg="Pass";return this};e.A=function(){return WN(this)};e.Dd=function(a,b){a=a.ji;var c=id();return sd(a,void 0,b,c,!1)};e.L=function(){return Z(this)};
e.$classData=l({bz:0},!1,"fastparse.parsers.Terminals$Pass",{bz:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function VQ(){this.to=this.Fc=this.Af=null}VQ.prototype=new AV;VQ.prototype.constructor=VQ;e=VQ.prototype;e.U=function(){return"Filtered"};e.yv=function(a,b,c){this.Fc=a;this.to=b;wQ.prototype.Ne.call(this,c);return this};e.M=function(){return 2};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.cz){var b=this.Fc,c=a.Fc;if(null===b?null===c:b.w(c))return b=this.to,a=a.to,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Fc;case 1:return this.to;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(["",".filter(",")"])),(new r).d([this.Fc,this.to]))};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.Dd=function(a,b){var c=this.Fc.Dd(a,b);if(r2(c))return qd(this,c,b,a.Sg,null,!1);if(t2(c))return this.to.Ea(c.pa)?c:jd(this,a.Zj,b,c.nd,c.id);throw(new p).e(c);};e.$classData=l({cz:0},!1,"fastparse.parsers.Transformers$Filtered",{cz:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function XQ(){this.Ih=this.Fc=this.Af=null}XQ.prototype=new AV;XQ.prototype.constructor=XQ;e=XQ.prototype;e.U=function(){return"Mapper"};e.yv=function(a,b,c){this.Fc=a;this.Ih=b;wQ.prototype.Ne.call(this,c);return this};e.M=function(){return 2};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.dz){var b=this.Fc,c=a.Fc;if(null===b?null===c:b.w(c))return b=this.Ih,a=a.Ih,null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.Fc;case 1:return this.Ih;default:throw(new W).j(""+a);}};e.v=function(){return this.Fc.v()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
e.Dd=function(a,b){var c=this.Fc.Dd(a,b);if(t2(c))return a=this.Ih.Ea(c.pa),sd(c,a,c.va,c.nd,c.id);if(r2(c))return qd(this,c,b,a.Sg,null,!1);throw(new p).e(c);};e.$classData=l({dz:0},!1,"fastparse.parsers.Transformers$Mapper",{dz:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function F3(){this.zp=this.jB=null}F3.prototype=new gwa;F3.prototype.constructor=F3;function Yca(a){var b=new F3;b.jB=a;(new u1).c();c3.prototype.KI.call(b);b.zp="";return b}
function zo(a,b){for(;""!==b;){var c=b.indexOf("\n")|0;if(0>c)a.zp=""+a.zp+b,b="";else{var d=""+a.zp+b.substring(0,c);ca.console&&(a.jB&&ca.console.error?ca.console.error(d):ca.console.log(d));a.zp="";b=b.substring(1+c|0)}}}F3.prototype.Es=function(){};F3.prototype.$classData=l({fJ:0},!1,"java.lang.JSConsoleBasedPrintStream",{fJ:1,s5:1,r5:1,oH:1,f:1,Cu:1,xB:1,ez:1,Zv:1});function fd(){q.call(this);this.au=this.nm=0}fd.prototype=new Rva;fd.prototype.constructor=fd;e=fd.prototype;e.Xa=function(){return this.nm};
e.K=function(a,b){this.nm=a;this.au=b;q.prototype.a.call(this,null,null);return this};e.p=function(){return this.au};e.bu=function(){return this.au};e.qa=function(){return this.nm};e.$classData=l({rK:0},!1,"scala.Tuple2$mcII$sp",{rK:1,ms:1,f:1,oC:1,R:1,x:1,l:1,k:1,b6:1});function M_(){}M_.prototype=new m;M_.prototype.constructor=M_;M_.prototype.c=function(){return this};M_.prototype.Ie=function(a,b){return(a|0)-(b|0)|0};
M_.prototype.$classData=l({JK:0},!1,"scala.math.Ordering$Byte$",{JK:1,f:1,KK:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});var rua=void 0;function G3(){}G3.prototype=new m;G3.prototype.constructor=G3;G3.prototype.c=function(){return this};G3.prototype.Ie=function(a,b){return(null===a?0:a.pa)-(null===b?0:b.pa)|0};G3.prototype.$classData=l({LK:0},!1,"scala.math.Ordering$Char$",{LK:1,f:1,MK:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});var swa=void 0;function rQ(){swa||(swa=(new G3).c());return swa}function I_(){}
I_.prototype=new m;I_.prototype.constructor=I_;I_.prototype.c=function(){return this};I_.prototype.Ie=function(a,b){a|=0;b|=0;return a===b?0:a<b?-1:1};I_.prototype.$classData=l({NK:0},!1,"scala.math.Ordering$Int$",{NK:1,f:1,OK:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});var nua=void 0;function O_(){}O_.prototype=new m;O_.prototype.constructor=O_;O_.prototype.c=function(){return this};
O_.prototype.Ie=function(a,b){var c=Ya(a);a=c.Ra;var c=c.Ya,d=Ya(b);b=d.Ra;d=d.Ya;ab();return c===d?a===b?0:(-2147483648^a)<(-2147483648^b)?-1:1:c<d?-1:1};O_.prototype.$classData=l({PK:0},!1,"scala.math.Ordering$Long$",{PK:1,f:1,QK:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});var uua=void 0;function K_(){}K_.prototype=new m;K_.prototype.constructor=K_;K_.prototype.c=function(){return this};K_.prototype.Ie=function(a,b){return(a|0)-(b|0)|0};
K_.prototype.$classData=l({RK:0},!1,"scala.math.Ordering$Short$",{RK:1,f:1,SK:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});var pua=void 0;function H3(){}H3.prototype=new m;H3.prototype.constructor=H3;H3.prototype.c=function(){return this};H3.prototype.Ie=function(a,b){return a===b?0:a<b?-1:1};H3.prototype.$classData=l({TK:0},!1,"scala.math.Ordering$String$",{TK:1,f:1,q6:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1});var twa=void 0;function wpa(){twa||(twa=(new H3).c());return twa}
function Nl(a){return!!(a&&a.$classData&&a.$classData.H.qt)}var I3=l({qt:0},!0,"scala.meta.Case",{qt:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1}),J3=l({zo:0},!0,"scala.meta.Enumerator",{zo:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Jn(a){return!!(a&&a.$classData&&a.$classData.H.st)}
var uwa=l({st:0},!0,"scala.meta.Importer",{st:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1}),K3=l({Ce:0},!0,"scala.meta.Mod",{Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1}),vwa=l({he:0},!0,"scala.meta.Pat",{he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1}),wwa=l({Md:0},!0,"scala.meta.Ref",{Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Sl(a){return!!(a&&a.$classData&&a.$classData.H.DP)}var L3=l({Ub:0},!0,"scala.meta.Stat",{Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function Tl(a){return!!(a&&a.$classData&&a.$classData.H.xt)}var xwa=l({xt:0},!0,"scala.meta.Template",{xt:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Gg(a){return!!(a&&a.$classData&&a.$classData.H.wd)}var M3=l({wd:0},!0,"scala.meta.Type",{wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Ul(a){return!!(a&&a.$classData&&a.$classData.H.uS)}function dC(){}dC.prototype=new m;dC.prototype.constructor=dC;e=dC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(N3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({dU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$100",{dU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function RB(){}RB.prototype=new m;RB.prototype.constructor=RB;e=RB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(O3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({eU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$101",{eU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function HB(){}HB.prototype=new m;HB.prototype.constructor=HB;e=HB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(I3)};e.Ja=function(a,b){return KB(LB(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({fU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$102",{fU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function IB(){}IB.prototype=new m;IB.prototype.constructor=IB;e=IB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(I3)};e.Ja=function(a,b){return KB(LB(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({gU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$103",{gU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function MB(){}MB.prototype=new m;MB.prototype.constructor=MB;e=MB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(I3)};e.Ja=function(a,b){return KB(LB(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({hU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$104",{hU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function $C(){}$C.prototype=new m;$C.prototype.constructor=$C;e=$C.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(J3)};e.Ja=function(a,b){return bD(cD(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({iU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$105",{iU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function aD(){}aD.prototype=new m;aD.prototype.constructor=aD;e=aD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(J3)};e.Ja=function(a,b){return bD(cD(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({jU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$106",{jU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function dD(){}dD.prototype=new m;dD.prototype.constructor=dD;e=dD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(J3)};e.Ja=function(a,b){return bD(cD(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({kU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$107",{kU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function EA(){}EA.prototype=new m;EA.prototype.constructor=EA;e=EA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};
e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(ywa)};e.Ja=function(a,b){Lra||(Lra=(new GX).c());if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["tree is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("tree",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"tree.!\x3d(null)",a,f.t)}throw(new p).e(c);}c=zwa(null,null,null,a);c.Ua=b.y(b,c,"tree",b.s);return c};
e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};e.$classData=l({mU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$111",{mU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function my(){}my.prototype=new m;my.prototype.constructor=my;e=my.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};
e.z=function(){return this};e.$classData=l({nU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$112",{nU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function ny(){}ny.prototype=new m;ny.prototype.constructor=ny;e=ny.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({oU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$113",{oU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function oy(){}oy.prototype=new m;oy.prototype.constructor=oy;e=oy.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({pU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$114",{pU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function rw(){}rw.prototype=new m;rw.prototype.constructor=rw;e=rw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({qU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$116",{qU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function sw(){}sw.prototype=new m;sw.prototype.constructor=sw;e=sw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({rU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$117",{rU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function tw(){}tw.prototype=new m;tw.prototype.constructor=tw;e=tw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({sU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$118",{sU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function ED(){}ED.prototype=new m;ED.prototype.constructor=ED;e=ED.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({tU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$119",{tU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function FD(){}FD.prototype=new m;FD.prototype.constructor=FD;e=FD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({vU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$120",{vU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function GD(){}GD.prototype=new m;GD.prototype.constructor=GD;e=GD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(K3)};e.Ja=function(a,b){return uw(vw(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({wU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$121",{wU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function ju(){}ju.prototype=new m;ju.prototype.constructor=ju;e=ju.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(P3)};e.Ja=function(a,b){return mu(nu(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({xU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$122",{xU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function ku(){}ku.prototype=new m;ku.prototype.constructor=ku;e=ku.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(P3)};e.Ja=function(a,b){return mu(nu(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({yU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$123",{yU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function ou(){}ou.prototype=new m;ou.prototype.constructor=ou;e=ou.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(P3)};e.Ja=function(a,b){return mu(nu(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({zU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$124",{zU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Oz(){}Oz.prototype=new m;Oz.prototype.constructor=Oz;e=Oz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Q3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({AU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$125",{AU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Pz(){}Pz.prototype=new m;Pz.prototype.constructor=Pz;e=Pz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Q3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({BU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$126",{BU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Sz(){}Sz.prototype=new m;Sz.prototype.constructor=Sz;e=Sz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Q3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({CU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$127",{CU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function cB(){}cB.prototype=new m;cB.prototype.constructor=cB;e=cB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(R3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({DU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$128",{DU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function dB(){}dB.prototype=new m;dB.prototype.constructor=dB;e=dB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(S3)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({EU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$129",{EU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function eB(){}eB.prototype=new m;eB.prototype.constructor=eB;e=eB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(R3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({FU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$130",{FU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Kz(){}Kz.prototype=new m;Kz.prototype.constructor=Kz;e=Kz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Awa)};e.Ja=function(a,b){return Lz(Mz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({GU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$131",{GU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Bz(){}Bz.prototype=new m;Bz.prototype.constructor=Bz;e=Bz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Bwa)};e.Ja=function(a,b){return Lz(Mz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({HU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$132",{HU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Cz(){}Cz.prototype=new m;Cz.prototype.constructor=Cz;e=Cz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Cwa)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({IU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$133",{IU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Dz(){}Dz.prototype=new m;Dz.prototype.constructor=Dz;e=Dz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Bwa)};e.Ja=function(a,b){return Lz(Mz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({JU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$134",{JU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Ez(){}Ez.prototype=new m;Ez.prototype.constructor=Ez;e=Ez.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(M3)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({KU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$135",{KU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Fz(){}Fz.prototype=new m;Fz.prototype.constructor=Fz;e=Fz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(M3)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({LU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$136",{LU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Gz(){}Gz.prototype=new m;Gz.prototype.constructor=Gz;e=Gz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(M3)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({MU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$137",{MU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Hz(){}Hz.prototype=new m;Hz.prototype.constructor=Hz;e=Hz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(M3)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({NU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$138",{NU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function eu(){}eu.prototype=new m;eu.prototype.constructor=eu;e=eu.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(uwa)};e.Ja=function(a,b){return fu(gu(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({OU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$139",{OU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Wt(){}Wt.prototype=new m;Wt.prototype.constructor=Wt;e=Wt.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(T3)};e.Ja=function(a,b){return $X(aY(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({PU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$140",{PU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Yt(){}Yt.prototype=new m;Yt.prototype.constructor=Yt;e=Yt.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(T3)};e.Ja=function(a,b){return $X(aY(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({QU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$141",{QU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function lD(){}lD.prototype=new m;lD.prototype.constructor=lD;e=lD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Dwa)};e.Ja=function(a,b){return mD(nD(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({RU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$142",{RU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function WB(){}WB.prototype=new m;WB.prototype.constructor=WB;e=WB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(S3)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({SU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$143",{SU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function tv(){}tv.prototype=new m;tv.prototype.constructor=tv;e=tv.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(vwa)};e.Ja=function(a,b){return uv(vv(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({TU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$144",{TU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function ru(){}ru.prototype=new m;ru.prototype.constructor=ru;e=ru.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(U3)};e.Ja=function(a,b){return eA(fA(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({UU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$145",{UU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function WC(){}WC.prototype=new m;WC.prototype.constructor=WC;e=WC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(S3)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({VU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$146",{VU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function UC(){}UC.prototype=new m;UC.prototype.constructor=UC;e=UC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Ewa)};
e.Ja=function(a,b){Ora||(Ora=(new IX).c());if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["tree is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("tree",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"tree.!\x3d(null)",a,f.t)}throw(new p).e(c);}c=Fwa(null,null,null,a);c.Ua=b.y(b,c,"tree",b.s);return c};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({WU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$147",{WU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function cA(){}cA.prototype=new m;cA.prototype.constructor=cA;e=cA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(U3)};e.Ja=function(a,b){return eA(fA(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({XU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$148",{XU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function dA(){}dA.prototype=new m;dA.prototype.constructor=dA;e=dA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(U3)};e.Ja=function(a,b){return eA(fA(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({YU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$149",{YU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function vD(){}vD.prototype=new m;vD.prototype.constructor=vD;e=vD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(xwa)};
e.Ja=function(a,b){Vra||(Vra=(new MX).c());if(null!==b)var c=(new q).a(!0,F());else{G();var c=(new r).d(["tree is equal to null"]),d=G().b,c=(new q).a(!1,H(c,d))}if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){d=J();b=[(new q).a("tree",b)];for(var f=A(new B,C()),g=0,h=b.length|0;g<h;)E(f,b[g]),g=1+g|0;K(d,"tree.!\x3d(null)",a,f.t)}throw(new p).e(c);}c=Gwa(null,null,null,a);c.Ua=b.y(b,c,"tree",b.s);return c};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({ZU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$150",{ZU:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function vM(){}vM.prototype=new m;vM.prototype.constructor=vM;e=vM.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({$U:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$153",{$U:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Uu(){}Uu.prototype=new m;Uu.prototype.constructor=Uu;e=Uu.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Hwa)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({aV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$154",{aV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function YB(){}YB.prototype=new m;YB.prototype.constructor=YB;e=YB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({bV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$155",{bV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Iy(){}Iy.prototype=new m;Iy.prototype.constructor=Iy;e=Iy.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({cV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$159",{cV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function cv(){}cv.prototype=new m;cv.prototype.constructor=cv;e=cv.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({dV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$163",{dV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function dv(){}dv.prototype=new m;dv.prototype.constructor=dv;e=dv.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({eV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$164",{eV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Yu(){}Yu.prototype=new m;Yu.prototype.constructor=Yu;e=Yu.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({fV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$165",{fV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Zu(){}Zu.prototype=new m;Zu.prototype.constructor=Zu;e=Zu.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({gV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$166",{gV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function OA(){}OA.prototype=new m;OA.prototype.constructor=OA;e=OA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({hV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$167",{hV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function PA(){}PA.prototype=new m;PA.prototype.constructor=PA;e=PA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({iV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$168",{iV:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function aE(){}aE.prototype=new m;aE.prototype.constructor=aE;e=aE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Iwa)};e.Ja=function(a,b){return nsa(qsa(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({qW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$87",{qW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function PD(){}PD.prototype=new m;PD.prototype.constructor=PD;e=PD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Jwa)};e.Ja=function(a,b){return kta(nta(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({rW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$88",{rW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function jE(){}jE.prototype=new m;jE.prototype.constructor=jE;e=jE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(S3)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({sW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$89",{sW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function lE(){}lE.prototype=new m;lE.prototype.constructor=lE;e=lE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(S3)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({uW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$90",{uW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function nE(){}nE.prototype=new m;nE.prototype.constructor=nE;e=nE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(O3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({vW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$91",{vW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function LD(){}LD.prototype=new m;LD.prototype.constructor=LD;e=LD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(S3)};e.Ja=function(a,b){return uX(vX(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({wW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$92",{wW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function DC(){}DC.prototype=new m;DC.prototype.constructor=DC;e=DC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(T3)};e.Ja=function(a,b){return $X(aY(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({xW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$93",{xW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function IC(){}IC.prototype=new m;IC.prototype.constructor=IC;e=IC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(R3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({yW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$94",{yW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function JC(){}JC.prototype=new m;JC.prototype.constructor=JC;e=JC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Kwa)};e.Ja=function(a,b){return nsa(qsa(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({zW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$95",{zW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Yw(){}Yw.prototype=new m;Yw.prototype.constructor=Yw;e=Yw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(O3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({AW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$96",{AW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function $w(){}$w.prototype=new m;$w.prototype.constructor=$w;e=$w.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(N3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({BW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$97",{BW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function bC(){}bC.prototype=new m;bC.prototype.constructor=bC;e=bC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(N3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({CW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$98",{CW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function cC(){}cC.prototype=new m;cC.prototype.constructor=cC;e=cC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(N3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({DW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$99",{DW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function B2(){}B2.prototype=new m;B2.prototype.constructor=B2;e=B2.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};
e.$classData=l({HW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$3$$anon$152",{HW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function C2(){}C2.prototype=new m;C2.prototype.constructor=C2;e=C2.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Fv=function(){return this};
e.$classData=l({JW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$templateStat$1$$anon$160",{JW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function D2(){}D2.prototype=new m;D2.prototype.constructor=D2;e=D2.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Fv=function(){return this};
e.$classData=l({KW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$templateStat$1$$anon$162",{KW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function E2(){}E2.prototype=new m;E2.prototype.constructor=E2;e=E2.prototype;e.Gv=function(){return this};e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};
e.$classData=l({MW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$topStat$1$$anon$157",{MW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function F2(){}F2.prototype=new m;F2.prototype.constructor=F2;e=F2.prototype;e.Gv=function(){return this};e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(L3)};e.Ja=function(a,b){return $u(av(),a,b)};e.A=function(){return YN(Y(),this.G())};
e.$classData=l({NW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anonfun$topStat$1$$anon$158",{NW:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function $f(){}$f.prototype=new m;$f.prototype.constructor=$f;e=$f.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(iwa)};e.Ja=function(a,b){return ag(bg(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({MX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$76",{MX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function fg(){}fg.prototype=new m;fg.prototype.constructor=fg;e=fg.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(iwa)};e.Ja=function(a,b){return ag(bg(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({NX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$77",{NX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Fg(){}Fg.prototype=new m;Fg.prototype.constructor=Fg;e=Fg.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Lwa)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({OX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$78",{OX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function rg(){}rg.prototype=new m;rg.prototype.constructor=rg;e=rg.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(R3)};e.Ja=function(a,b){return Qz(Rz(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({PX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$79",{PX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function wf(){}wf.prototype=new m;wf.prototype.constructor=wf;e=wf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(T3)};e.Ja=function(a,b){return $X(aY(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({QX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$80",{QX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Cf(){}Cf.prototype=new m;Cf.prototype.constructor=Cf;e=Cf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Lwa)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({RX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$81",{RX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Hf(){}Hf.prototype=new m;Hf.prototype.constructor=Hf;e=Hf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(T3)};e.Ja=function(a,b){return $X(aY(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({SX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$82",{SX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Kf(){}Kf.prototype=new m;Kf.prototype.constructor=Kf;e=Kf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Mwa)};e.Ja=function(a,b){return kta(nta(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({TX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$83",{TX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Mf(){}Mf.prototype=new m;Mf.prototype.constructor=Mf;e=Mf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Mwa)};e.Ja=function(a,b){return kta(nta(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({UX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$84",{UX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Wd(){}Wd.prototype=new m;Wd.prototype.constructor=Wd;e=Wd.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(M3)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({VX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$85",{VX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function Yi(){}Yi.prototype=new m;Yi.prototype.constructor=Yi;e=Yi.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(M3)};e.Ja=function(a,b){return bf(cf(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({WX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$86",{WX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function jF(){}jF.prototype=new m;jF.prototype.constructor=jF;e=jF.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(vwa)};e.Ja=function(a,b){return uv(vv(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Im=function(){return this};
e.$classData=l({XX:0},!1,"scala.meta.internal.parsers.ScalametaParser$SeqContextSensitive$$anon$108",{XX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function nF(){}nF.prototype=new m;nF.prototype.constructor=nF;e=nF.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(O3)};e.Ja=function(a,b){return ax(bx(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Im=function(){return this};
e.$classData=l({YX:0},!1,"scala.meta.internal.parsers.ScalametaParser$SeqContextSensitive$$anon$109",{YX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function oF(){}oF.prototype=new m;oF.prototype.constructor=oF;e=oF.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.G=function(){return k(Nwa)};e.Ja=function(a,b){return uv(vv(),a,b)};e.A=function(){return YN(Y(),this.G())};e.Im=function(){return this};
e.$classData=l({ZX:0},!1,"scala.meta.internal.parsers.ScalametaParser$SeqContextSensitive$$anon$110",{ZX:1,f:1,zb:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});function HY(){this.r=null}HY.prototype=new m;HY.prototype.constructor=HY;e=HY.prototype;e.U=function(){return"AnyPattern3"};e.M=function(){return 0};e.zf=function(){return 2.5};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"AnyPattern3"};e.pf=function(){return I2()};e.ak=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
e.A=function(){return 672620687};e.L=function(){return Z(this)};e.$classData=l({IY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$AnyPattern3$",{IY:1,f:1,un:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function FY(){this.r=null}FY.prototype=new m;FY.prototype.constructor=FY;e=FY.prototype;e.U=function(){return"Pattern"};e.M=function(){return 0};e.zf=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Pattern"};e.pf=function(){return I2()};
e.ak=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 873562992};e.L=function(){return Z(this)};e.$classData=l({JY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$Pattern$",{JY:1,f:1,un:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function GY(){this.r=null}GY.prototype=new m;GY.prototype.constructor=GY;e=GY.prototype;e.U=function(){return"Pattern1"};e.M=function(){return 0};e.zf=function(){return 1};
e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Pattern1"};e.pf=function(){return I2()};e.ak=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 1310649025};e.L=function(){return Z(this)};e.$classData=l({KY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$Pattern1$",{KY:1,f:1,un:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function KY(){this.r=null}KY.prototype=new m;KY.prototype.constructor=KY;e=KY.prototype;e.U=function(){return"Pattern2"};
e.M=function(){return 0};e.zf=function(){return 2};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Pattern2"};e.pf=function(){return I2()};e.ak=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 1310649026};e.L=function(){return Z(this)};e.$classData=l({LY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$Pattern2$",{LY:1,f:1,un:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function LY(){this.r=this.Wd=null}LY.prototype=new m;
LY.prototype.constructor=LY;e=LY.prototype;e.U=function(){return"Pattern3"};e.M=function(){return 1};e.zf=function(){return 3};e.w=function(a){if(LH(a)&&ns(a)&&1===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.Wd;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.pf=function(){return I2()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function LH(a){return!!(a&&a.$classData&&a.$classData.H.NC)}
e.$classData=l({NC:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$Pattern3",{NC:1,f:1,un:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function JY(){this.r=null}JY.prototype=new m;JY.prototype.constructor=JY;e=JY.prototype;e.U=function(){return"SimplePattern"};e.M=function(){return 0};e.zf=function(){return 6};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"SimplePattern"};e.pf=function(){return I2()};
e.ak=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 2124453214};e.L=function(){return Z(this)};e.$classData=l({NY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Pat$SimplePattern$",{NY:1,f:1,un:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function NY(){this.r=null}NY.prototype=new m;NY.prototype.constructor=NY;e=NY.prototype;e.U=function(){return"Expr"};e.M=function(){return 0};e.zf=function(){return 0};
e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Expr"};e.pf=function(){return J2()};e.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 2174485};e.L=function(){return Z(this)};e.$classData=l({QY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$Expr$",{QY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function fZ(){this.r=null}fZ.prototype=new m;fZ.prototype.constructor=fZ;e=fZ.prototype;e.U=function(){return"Expr1"};
e.M=function(){return 0};e.zf=function(){return 1};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Expr1"};e.pf=function(){return J2()};e.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 67409084};e.L=function(){return Z(this)};e.$classData=l({RY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$Expr1$",{RY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function iZ(){this.r=this.Wd=null}iZ.prototype=new m;
iZ.prototype.constructor=iZ;e=iZ.prototype;e.U=function(){return"InfixExpr"};e.M=function(){return 1};e.zf=function(){return 3};e.w=function(a){if(JH(a)&&ns(a)&&1===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.Wd;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.pf=function(){return J2()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function JH(a){return!!(a&&a.$classData&&a.$classData.H.OC)}
e.$classData=l({OC:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$InfixExpr",{OC:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function MY(){this.r=null}MY.prototype=new m;MY.prototype.constructor=MY;e=MY.prototype;e.U=function(){return"PostfixExpr"};e.M=function(){return 0};e.zf=function(){return 2};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"PostfixExpr"};e.pf=function(){return J2()};e.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
e.A=function(){return-306527510};e.L=function(){return Z(this)};e.$classData=l({TY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$PostfixExpr$",{TY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function dZ(){this.r=null}dZ.prototype=new m;dZ.prototype.constructor=dZ;e=dZ.prototype;e.U=function(){return"PrefixExpr"};e.M=function(){return 0};e.zf=function(){return 4};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"PrefixExpr"};e.pf=function(){return J2()};
e.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 652747719};e.L=function(){return Z(this)};e.$classData=l({UY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$PrefixExpr$",{UY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function hZ(){this.r=null}hZ.prototype=new m;hZ.prototype.constructor=hZ;e=hZ.prototype;e.U=function(){return"SimpleExpr"};e.M=function(){return 0};e.zf=function(){return 5};
e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"SimpleExpr"};e.pf=function(){return J2()};e.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 561451751};e.L=function(){return Z(this)};e.$classData=l({VY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$SimpleExpr$",{VY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function eZ(){this.r=null}eZ.prototype=new m;eZ.prototype.constructor=eZ;e=eZ.prototype;e.U=function(){return"SimpleExpr1"};
e.M=function(){return 0};e.zf=function(){return 6};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"SimpleExpr1"};e.pf=function(){return J2()};e.Wi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.A=function(){return 225135146};e.L=function(){return Z(this)};e.$classData=l({WY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Term$SimpleExpr1$",{WY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function nZ(){this.r=null}nZ.prototype=new m;
nZ.prototype.constructor=nZ;e=nZ.prototype;e.U=function(){return"AnnotTyp"};e.M=function(){return 0};e.zf=function(){return 4};e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"AnnotTyp"};e.pf=function(){return K2()};e.A=function(){return-585030331};e.L=function(){return Z(this)};
e.$classData=l({YY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$AnnotTyp$",{YY:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function mZ(){this.r=null}mZ.prototype=new m;mZ.prototype.constructor=mZ;e=mZ.prototype;e.U=function(){return"AnyInfixTyp"};e.M=function(){return 0};e.zf=function(){return 1.5};e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"AnyInfixTyp"};e.pf=function(){return K2()};
e.A=function(){return-399933049};e.L=function(){return Z(this)};e.$classData=l({ZY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$AnyInfixTyp$",{ZY:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function rZ(){this.r=this.Wd=null}rZ.prototype=new m;rZ.prototype.constructor=rZ;e=rZ.prototype;e.U=function(){return"InfixTyp"};e.M=function(){return 1};e.zf=function(){return 2};e.w=function(a){if(KH(a)&&ns(a)&&1===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.Wd;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.pf=function(){return K2()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function KH(a){return!!(a&&a.$classData&&a.$classData.H.PC)}e.$classData=l({PC:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$InfixTyp",{PC:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function jZ(){this.r=null}jZ.prototype=new m;jZ.prototype.constructor=jZ;
e=jZ.prototype;e.U=function(){return"ParamTyp"};e.M=function(){return 0};e.zf=function(){return 0};e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"ParamTyp"};e.pf=function(){return K2()};e.A=function(){return 1236053726};e.L=function(){return Z(this)};e.$classData=l({aZ:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$ParamTyp$",{aZ:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});
function qZ(){this.r=null}qZ.prototype=new m;qZ.prototype.constructor=qZ;e=qZ.prototype;e.U=function(){return"RefineTyp"};e.M=function(){return 0};e.zf=function(){return 3};e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"RefineTyp"};e.pf=function(){return K2()};e.A=function(){return 1189610686};e.L=function(){return Z(this)};
e.$classData=l({bZ:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$RefineTyp$",{bZ:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function pZ(){this.r=null}pZ.prototype=new m;pZ.prototype.constructor=pZ;e=pZ.prototype;e.U=function(){return"SimpleTyp"};e.M=function(){return 0};e.zf=function(){return 6};e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"SimpleTyp"};e.pf=function(){return K2()};
e.A=function(){return-120421543};e.L=function(){return Z(this)};e.$classData=l({cZ:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$SimpleTyp$",{cZ:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function lZ(){this.r=null}lZ.prototype=new m;lZ.prototype.constructor=lZ;e=lZ.prototype;e.U=function(){return"Typ"};e.M=function(){return 0};e.zf=function(){return 1};e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Typ"};e.pf=function(){return K2()};e.A=function(){return 84587};e.L=function(){return Z(this)};e.$classData=l({dZ:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$Typ$",{dZ:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function kZ(){this.r=null}kZ.prototype=new m;kZ.prototype.constructor=kZ;e=kZ.prototype;e.U=function(){return"WithTyp"};e.M=function(){return 0};e.zf=function(){return 3.5};
e.vi=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"WithTyp"};e.pf=function(){return K2()};e.A=function(){return-1275186235};e.L=function(){return Z(this)};e.$classData=l({eZ:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Type$WithTyp$",{eZ:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1});function V3(){}V3.prototype=new m;V3.prototype.constructor=V3;e=V3.prototype;e.c=function(){return this};
e.U=function(){return"None"};e.M=function(){return 0};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"None"};e.A=function(){return 2433880};e.L=function(){return Z(this)};e.$classData=l({DZ:0},!1,"scala.meta.internal.trees.Origin$None$",{DZ:1,f:1,CZ:1,QT:1,$:1,R:1,x:1,l:1,k:1});var Owa=void 0;function kia(){Owa||(Owa=(new V3).c());return Owa}function W3(){this.cg=this.Q=this.u=null}W3.prototype=new m;W3.prototype.constructor=W3;e=W3.prototype;e.U=function(){return"Parsed"};e.M=function(){return 3};
e.w=function(a){if(nG(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.cg;default:throw(new W).j(""+a);}};e.v=function(){return cQ(this)};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
function R(a,b,c){var d=new W3;d.u=a;d.Q=b;d.cg=c;if(null!==a)a=(new q).a(!0,F());else{G();a=(new r).d(["this.input is equal to null"]);var f=G().b;a=(new q).a(!1,H(a,f))}if(null===a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){b=J();for(var d=[(new q).a("Parsed",d)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(c=a.p(),!1===I(a))){b=J();d=[(new q).a("Parsed",d)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",c,f.t)}throw(new p).e(a);}null!==c?c=(new q).a(!0,F()):(G(),c=(new r).d(["this.pos is equal to null"]),a=G().b,c=(new q).a(!1,H(c,a)));if(null===c||!0!==I(c)){if(null!==c&&(a=c.p(),!1===I(c))){b=J();d=[(new q).a("Parsed",d)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(b,"this.pos.!\x3d(null)",a,f.t)}throw(new p).e(c);
}return d}function nG(a){return!!(a&&a.$classData&&a.$classData.H.TC)}e.$classData=l({TC:0},!1,"scala.meta.internal.trees.Origin$Parsed",{TC:1,f:1,CZ:1,QT:1,$:1,R:1,x:1,l:1,k:1});function Ke(a){return!!(a&&a.$classData&&a.$classData.H.Yd)}function X3(){this.bh=null}X3.prototype=new m;X3.prototype.constructor=X3;function Y3(){}Y3.prototype=X3.prototype;X3.prototype.w=function(a){return this===a};X3.prototype.v=function(){return this.bh};X3.prototype.A=function(){return Ia(this)};function Z3(){}
Z3.prototype=new m;Z3.prototype.constructor=Z3;function Pwa(){}Pwa.prototype=Z3.prototype;function $3(){this.$d=this.b=null}$3.prototype=new o3;$3.prototype.constructor=$3;$3.prototype.c=function(){ZU.prototype.c.call(this);a4=this;this.$d=(new C_).c();return this};$3.prototype.ic=function(){Rs();uk();return(new Hk).c()};$3.prototype.$classData=l({P1:0},!1,"scala.collection.IndexedSeq$",{P1:1,SE:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var a4=void 0;function vk(){a4||(a4=(new $3).c());return a4}
function Dp(){this.nh=this.hv=0;this.Lb=null}Dp.prototype=new M0;Dp.prototype.constructor=Dp;Dp.prototype.bb=function(){this.nh>=this.hv&&hN().Pg.bb();var a=this.Lb.rc(this.nh);this.nh=1+this.nh|0;return a};function Cp(a,b,c){a.hv=c;if(null===b)throw jo(wj(),null);a.Lb=b;a.nh=0;return a}Dp.prototype.fb=function(){return this.nh<this.hv};Dp.prototype.$classData=l({R1:0},!1,"scala.collection.IndexedSeqLike$Elements",{R1:1,rh:1,f:1,Dg:1,tb:1,sb:1,U6:1,l:1,k:1});function b4(){}b4.prototype=new O1;
b4.prototype.constructor=b4;b4.prototype.c=function(){return this};function c4(a,b,c,d,f,g){var h=31&(b>>>g|0),n=31&(d>>>g|0);if(h!==n)return a=1<<h|1<<n,b=oa(bc(d4),[2]),h<n?(b.i[0]=c,b.i[1]=f):(b.i[0]=f,b.i[1]=c),e4(new f4,a,b,c.Za()+f.Za()|0);n=oa(bc(d4),[1]);h=1<<h;c=c4(a,b,c,d,f,5+g|0);n.i[0]=c;return e4(new f4,h,n,c.Oi)}b4.prototype.Is=function(){return g4()};b4.prototype.$classData=l({A2:0},!1,"scala.collection.immutable.HashSet$",{A2:1,RE:1,Io:1,Ho:1,Sf:1,f:1,Tf:1,l:1,k:1});var Qwa=void 0;
function h4(){Qwa||(Qwa=(new b4).c());return Qwa}function i4(){this.b=null}i4.prototype=new o3;i4.prototype.constructor=i4;i4.prototype.c=function(){ZU.prototype.c.call(this);return this};i4.prototype.ic=function(){uk();return(new Hk).c()};i4.prototype.$classData=l({D2:0},!1,"scala.collection.immutable.IndexedSeq$",{D2:1,SE:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1});var Rwa=void 0;function Rs(){Rwa||(Rwa=(new i4).c());return Rwa}function j4(){}j4.prototype=new O1;j4.prototype.constructor=j4;
j4.prototype.c=function(){return this};j4.prototype.Is=function(){return k4()};j4.prototype.$classData=l({L2:0},!1,"scala.collection.immutable.ListSet$",{L2:1,RE:1,Io:1,Ho:1,Sf:1,f:1,Tf:1,l:1,k:1});var Swa=void 0;function PM(){this.Qn=null;this.iB=!1;this.Ib=null}PM.prototype=new y3;PM.prototype.constructor=PM;e=PM.prototype;e.ee=function(a){return RM(this,a)};e.v=function(){return"ArrayBuilder.generic"};function RM(a,b){a.Ib.push(a.iB?null===b?0:b.pa:null===b?a.Qn.Ei.Ut:b);return a}
e.da=function(){var a=this.Qn===k(cc)?k(xa):this.Qn===k(XP)||this.Qn===k(A_)?k(Ab):this.Qn;return na(bc(a.Ei),this.Ib)};e.Ud=function(a){this.Qn=a;this.iB=a===k(jc);this.Ib=[];return this};e.ba=function(a){return RM(this,a)};e.$classData=l({B3:0},!1,"scala.collection.mutable.ArrayBuilder$generic",{B3:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function l4(){this.Ib=null;this.Ka=this.hb=0}l4.prototype=new y3;l4.prototype.constructor=l4;e=l4.prototype;e.c=function(){this.Ka=this.hb=0;return this};
function Twa(a,b){b=oa(bc(ic),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.w=function(a){return a&&a.$classData&&a.$classData.H.jF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return Uwa(this,!!a)};e.v=function(){return"ArrayBuilder.ofBoolean"};e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=Twa(this,this.Ka);return a};e.af=function(a){this.Ib=Twa(this,a);this.hb=a};e.ba=function(a){return Uwa(this,!!a)};e.je=function(a){this.hb<a&&this.af(a)};
e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};function Uwa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.$c=function(a){a&&a.$classData&&a.$classData.H.ox?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};e.$classData=l({jF:0},!1,"scala.collection.mutable.ArrayBuilder$ofBoolean",{jF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});
function m4(){this.Ib=null;this.Ka=this.hb=0}m4.prototype=new y3;m4.prototype.constructor=m4;e=m4.prototype;e.c=function(){this.Ka=this.hb=0;return this};e.w=function(a){return a&&a.$classData&&a.$classData.H.kF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return Vwa(this,a|0)};function Wwa(a,b){b=oa(bc(rc),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.v=function(){return"ArrayBuilder.ofByte"};
e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=Wwa(this,this.Ka);return a};e.af=function(a){this.Ib=Wwa(this,a);this.hb=a};e.ba=function(a){return Vwa(this,a|0)};function Vwa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.je=function(a){this.hb<a&&this.af(a)};e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};
e.$c=function(a){a&&a.$classData&&a.$classData.H.px?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};e.$classData=l({kF:0},!1,"scala.collection.mutable.ArrayBuilder$ofByte",{kF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function n4(){this.Ib=null;this.Ka=this.hb=0}n4.prototype=new y3;n4.prototype.constructor=n4;e=n4.prototype;e.c=function(){this.Ka=this.hb=0;return this};
e.w=function(a){return a&&a.$classData&&a.$classData.H.lF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return Xwa(this,null===a?0:a.pa)};e.v=function(){return"ArrayBuilder.ofChar"};e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=Ywa(this,this.Ka);return a};e.af=function(a){this.Ib=Ywa(this,a);this.hb=a};e.ba=function(a){return Xwa(this,null===a?0:a.pa)};e.je=function(a){this.hb<a&&this.af(a)};
function Ywa(a,b){b=oa(bc(jc),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};function Xwa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.$c=function(a){a&&a.$classData&&a.$classData.H.qx?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};
e.$classData=l({lF:0},!1,"scala.collection.mutable.ArrayBuilder$ofChar",{lF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function o4(){this.Ib=null;this.Ka=this.hb=0}o4.prototype=new y3;o4.prototype.constructor=o4;e=o4.prototype;e.c=function(){this.Ka=this.hb=0;return this};e.w=function(a){return a&&a.$classData&&a.$classData.H.mF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return Zwa(this,+a)};e.v=function(){return"ArrayBuilder.ofDouble"};
e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=$wa(this,this.Ka);return a};function $wa(a,b){b=oa(bc(Ic),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.af=function(a){this.Ib=$wa(this,a);this.hb=a};e.ba=function(a){return Zwa(this,+a)};e.je=function(a){this.hb<a&&this.af(a)};function Zwa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};
e.$c=function(a){a&&a.$classData&&a.$classData.H.rx?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};e.$classData=l({mF:0},!1,"scala.collection.mutable.ArrayBuilder$ofDouble",{mF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function p4(){this.Ib=null;this.Ka=this.hb=0}p4.prototype=new y3;p4.prototype.constructor=p4;e=p4.prototype;e.c=function(){this.Ka=this.hb=0;return this};
e.w=function(a){return a&&a.$classData&&a.$classData.H.nF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return axa(this,+a)};e.v=function(){return"ArrayBuilder.ofFloat"};e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=bxa(this,this.Ka);return a};e.af=function(a){this.Ib=bxa(this,a);this.hb=a};function axa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.ba=function(a){return axa(this,+a)};e.je=function(a){this.hb<a&&this.af(a)};
function bxa(a,b){b=oa(bc(Gc),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};e.$c=function(a){a&&a.$classData&&a.$classData.H.sx?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};e.$classData=l({nF:0},!1,"scala.collection.mutable.ArrayBuilder$ofFloat",{nF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});
function q4(){this.Ib=null;this.Ka=this.hb=0}q4.prototype=new y3;q4.prototype.constructor=q4;e=q4.prototype;e.c=function(){this.Ka=this.hb=0;return this};e.w=function(a){return a&&a.$classData&&a.$classData.H.oF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return cxa(this,a|0)};e.v=function(){return"ArrayBuilder.ofInt"};e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=dxa(this,this.Ka);return a};e.af=function(a){this.Ib=dxa(this,a);this.hb=a};
function cxa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.ba=function(a){return cxa(this,a|0)};function dxa(a,b){b=oa(bc(yc),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.je=function(a){this.hb<a&&this.af(a)};e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};e.$c=function(a){a&&a.$classData&&a.$classData.H.tx?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};
e.$classData=l({oF:0},!1,"scala.collection.mutable.ArrayBuilder$ofInt",{oF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function r4(){this.Ib=null;this.Ka=this.hb=0}r4.prototype=new y3;r4.prototype.constructor=r4;e=r4.prototype;e.c=function(){this.Ka=this.hb=0;return this};function exa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.w=function(a){return a&&a.$classData&&a.$classData.H.pF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return exa(this,Ya(a))};e.v=function(){return"ArrayBuilder.ofLong"};
e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=fxa(this,this.Ka);return a};e.af=function(a){this.Ib=fxa(this,a);this.hb=a};function fxa(a,b){b=oa(bc(zc),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.ba=function(a){return exa(this,Ya(a))};e.je=function(a){this.hb<a&&this.af(a)};e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};
e.$c=function(a){a&&a.$classData&&a.$classData.H.ux?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};e.$classData=l({pF:0},!1,"scala.collection.mutable.ArrayBuilder$ofLong",{pF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function s4(){this.Ib=this.NA=null;this.Ka=this.hb=0}s4.prototype=new y3;s4.prototype.constructor=s4;e=s4.prototype;e.Jv=function(a){this.NA=a;this.Ka=this.hb=0;return this};
e.w=function(a){return a&&a.$classData&&a.$classData.H.qF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};e.ee=function(a){return gxa(this,a)};e.v=function(){return"ArrayBuilder.ofRef"};e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=hxa(this,this.Ka);return a};e.af=function(a){this.Ib=hxa(this,a);this.hb=a};function gxa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.ba=function(a){return gxa(this,a)};e.je=function(a){this.hb<a&&this.af(a)};
e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};function hxa(a,b){b=a.NA.xa(b);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.$c=function(a){a&&a.$classData&&a.$classData.H.vx?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};e.$classData=l({qF:0},!1,"scala.collection.mutable.ArrayBuilder$ofRef",{qF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});
function t4(){this.Ib=null;this.Ka=this.hb=0}t4.prototype=new y3;t4.prototype.constructor=t4;e=t4.prototype;e.c=function(){this.Ka=this.hb=0;return this};e.w=function(a){return a&&a.$classData&&a.$classData.H.rF?this.Ka===a.Ka&&this.Ib===a.Ib:!1};function ixa(a,b){a.We(1+a.Ka|0);a.Ib.i[a.Ka]=b;a.Ka=1+a.Ka|0;return a}e.ee=function(a){return ixa(this,a|0)};e.v=function(){return"ArrayBuilder.ofShort"};e.da=function(){var a;0!==this.hb&&this.hb===this.Ka?(this.hb=0,a=this.Ib):a=jxa(this,this.Ka);return a};
e.af=function(a){this.Ib=jxa(this,a);this.hb=a};function jxa(a,b){b=oa(bc(vc),[b]);0<a.Ka&&E0(Tp(),a.Ib,0,b,0,a.Ka);return b}e.ba=function(a){return ixa(this,a|0)};e.je=function(a){this.hb<a&&this.af(a)};e.We=function(a){if(this.hb<a||0===this.hb){for(var b=0===this.hb?16:this.hb<<1;b<a;)b<<=1;this.af(b)}};e.$c=function(a){a&&a.$classData&&a.$classData.H.wx?(this.We(this.Ka+a.Fa()|0),E0(Tp(),a.Da,0,this.Ib,this.Ka,a.Fa()),this.Ka=this.Ka+a.Fa()|0,a=this):a=GO(this,a);return a};
e.$classData=l({rF:0},!1,"scala.collection.mutable.ArrayBuilder$ofShort",{rF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function u4(){this.Ka=0}u4.prototype=new y3;u4.prototype.constructor=u4;e=u4.prototype;e.c=function(){this.Ka=0;return this};e.w=function(a){return a&&a.$classData&&a.$classData.H.sF?this.Ka===a.Ka:!1};e.ee=function(){return kxa(this)};e.v=function(){return"ArrayBuilder.ofUnit"};function kxa(a){a.Ka=1+a.Ka|0;return a}
e.da=function(){for(var a=oa(bc(xa),[this.Ka]),b=0;b<this.Ka;)a.i[b]=void 0,b=1+b|0;return a};e.ba=function(){return kxa(this)};e.$c=function(a){this.Ka=this.Ka+a.Za()|0;return this};e.$classData=l({sF:0},!1,"scala.collection.mutable.ArrayBuilder$ofUnit",{sF:1,Jk:1,f:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function v4(){}v4.prototype=new Q1;v4.prototype.constructor=v4;v4.prototype.c=function(){return this};v4.prototype.Yj=function(){return(new b3).c()};
v4.prototype.$classData=l({W3:0},!1,"scala.collection.mutable.HashSet$",{W3:1,TE:1,Io:1,Ho:1,Sf:1,f:1,Tf:1,l:1,k:1});var lxa=void 0;function w4(){}w4.prototype=new Q1;w4.prototype.constructor=w4;w4.prototype.c=function(){return this};w4.prototype.Yj=function(){return(new x4).c()};w4.prototype.$classData=l({b4:0},!1,"scala.collection.mutable.LinkedHashSet$",{b4:1,TE:1,Io:1,Ho:1,Sf:1,f:1,Tf:1,l:1,k:1});var mxa=void 0;function RP(){Rn.call(this);this.yl=null}RP.prototype=new r0;
RP.prototype.constructor=RP;e=RP.prototype;e.U=function(){return"JavaScriptException"};e.M=function(){return 1};e.Em=function(){this.stackdata=this.yl;return this};e.w=function(a){return this===a?!0:QP(a)?dj(ej(),this.yl,a.yl):!1};e.W=function(a){switch(a){case 0:return this.yl;default:throw(new W).j(""+a);}};e.Ak=function(){return pa(this.yl)};e.e=function(a){this.yl=a;Rn.prototype.fd.call(this,null,null);return this};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
function QP(a){return!!(a&&a.$classData&&a.$classData.H.QF)}e.$classData=l({QF:0},!1,"scala.scalajs.js.JavaScriptException",{QF:1,Nf:1,ae:1,vd:1,f:1,k:1,R:1,x:1,l:1});function uj(){this.SB=this.Jd=null;this.Fs=0}uj.prototype=new Wpa;uj.prototype.constructor=uj;e=uj.prototype;e.Ts=function(){try{return j0(this.Jd,32),!0}catch(a){if(s1(a))return!1;throw a;}};e.bi=function(){return this.Jd.bi()};
function tj(a,b,c){a.Jd=b;a.SB=c;if(null===b)throw(new t).j("null value for BigDecimal");if(null===c)throw(new t).j("null MathContext for BigDecimal");a.Fs=1565550863;return a}e.Tv=function(){try{return j0(this.Jd,16),!0}catch(a){if(s1(a))return!1;throw a;}};e.Ap=function(){return this.Jd.oh()<<24>>24};
e.w=function(a){if(a&&a.$classData&&a.$classData.H.tw)return y4(this,a);if(a&&a.$classData&&a.$classData.H.uw){var b=a.Td,b=wp(zp(),b),c=qj(this.Jd);if(b>3.3219280948873626*(-2+(c-this.Jd.tc|0)|0)){var d;if(this.Lm())try{d=(new T).e((new $s).$j(Gua(this.Jd)))}catch(f){if(s1(f))d=S();else throw f;}else d=S();if(d.g())return!1;d=d.q();return 0===KW(a.Td,d.Td)}return!1}return"number"===typeof a?(d=+a,Infinity!==d&&-Infinity!==d&&(a=this.Jd.oj(),Infinity!==a&&-Infinity!==a&&a===d)?(d=gj(),y4(this,mt(a,
d.xk))):!1):wa(a)?(d=+a,Infinity!==d&&-Infinity!==d&&(a=this.Jd.Fm(),Infinity!==a&&-Infinity!==a&&a===d)?(d=gj(),y4(this,mt(a,d.xk))):!1):this.Us()&&Baa(this,a)};e.Lm=function(){return 0>=this.Jd.tc?!0:0>=Iua(this.Jd).tc};e.Sv=function(){return this.Ts()&&0<=j0(this.Jd,32).Ra&&65535>=j0(this.Jd,32).Ra};e.v=function(){return this.Jd.v()};e.Rv=function(){try{return j0(this.Jd,8),!0}catch(a){if(s1(a))return!1;throw a;}};e.qf=function(a){return Lua(this.Jd,a.Jd)};e.gG=function(){return this.Jd};
e.Qq=function(){return this.Jd.oh()<<16>>16};e.oj=function(){return this.Jd.oj()};e.A=function(){if(1565550863===this.Fs){if(this.Lm()&&4934>(qj(this.Jd)-this.Jd.tc|0))var a=(new $s).$j(i0(this.Jd)).A();else{a=this.Jd.oj();if(Infinity!==a&&-Infinity!==a)var b=gj(),a=y4(this,mt(a,b.xk));else a=!1;a?a=fQ(Y(),this.Jd.oj()):(a=Iua(this.Jd),a=XN().bn(i0(Kua(a,a.tc)).A(),a.tc))}this.Fs=a}return this.Fs};e.oh=function(){return this.Jd.oh()};
function nda(a){var b=new uj,c;c=a.Jd;if(63>c.wf)var d=!0;else if(63===c.wf)var d=c.Xe,f=d.Ya,d=!(0===d.Ra&&-2147483648===f);else d=!1;if(d){var d=GV(),g=c.Xe,f=g.Ra,g=g.Ya;c=fpa(d,(new Ep).K(-f|0,0!==f?~g:-g|0),c.tc)}else c=(new hj).Ns(Wp(JW(c)),c.tc);return tj(b,c,a.SB)}e.Us=function(){try{return j0(this.Jd,64),!0}catch(a){if(s1(a))return!1;throw a;}};e.Fm=function(){return this.Jd.Fm()};function y4(a,b){return 0===Lua(a.Jd,b.Jd)}
e.$classData=l({tw:0},!1,"scala.math.BigDecimal",{tw:1,sC:1,bk:1,f:1,k:1,UK:1,tC:1,l:1,yo:1,xf:1});function $s(){this.Td=null}$s.prototype=new Wpa;$s.prototype.constructor=$s;e=$s.prototype;e.Ts=function(){var a=Aj(Bj(),-2147483648);return 0<=this.qf(a)?(a=Aj(Bj(),2147483647),0>=this.qf(a)):!1};e.bi=function(){return this.Td.bi()};e.Tv=function(){var a=Aj(Bj(),-32768);return 0<=this.qf(a)?(a=Aj(Bj(),32767),0>=this.qf(a)):!1};e.Ap=function(){return this.Td.oh()<<24>>24};
e.w=function(a){if(a&&a.$classData&&a.$classData.H.uw)return 0===KW(this.Td,a.Td);if(a&&a.$classData&&a.$classData.H.tw)return a.w(this);if("number"===typeof a){a=+a;var b=this.Td,b=wp(zp(),b);if(53>=b)b=!0;else var c=l0(this.Td),b=1024>=b&&c>=(-53+b|0)&&1024>c;return b&&!nxa(this)?(b=this.Td,uH(vH(),Gp(Ip(),b))===a):!1}return wa(a)?(a=+a,b=this.Td,b=wp(zp(),b),24>=b?b=!0:(c=l0(this.Td),b=128>=b&&c>=(-24+b|0)&&128>c),b&&!nxa(this)?(b=this.Td,b=Gp(Ip(),b),ga(uH(vH(),b))===a):!1):this.Us()&&Baa(this,
a)};function nxa(a){a=hq(a.Td,2147483647);return 0!==a.oc&&!a.w(Bj().JE)}e.Lm=function(){return!0};e.Sv=function(){var a=Aj(Bj(),0);return 0<=this.qf(a)?(a=Aj(Bj(),65535),0>=this.qf(a)):!1};e.v=function(){var a=this.Td;return Gp(Ip(),a)};e.Rv=function(){var a=Aj(Bj(),-128);return 0<=this.qf(a)?(a=Aj(Bj(),127),0>=this.qf(a)):!1};e.qf=function(a){return KW(this.Td,a.Td)};e.gG=function(){return this.Td};function Ej(a,b){return(new $s).$j(eq(a.Td,b.Td))}
function Fj(a,b){a=a.Td;b=b.Td;return(new $s).$j(Rp(Xp(),a,b))}e.Qq=function(){return this.Td.oh()<<16>>16};e.oj=function(){var a=this.Td;return uH(vH(),Gp(Ip(),a))};e.A=function(){var a;if(this.Us()){var b=this.bi();a=b.Ra;b=b.Ya;a=(-1===b?0<=(-2147483648^a):-1<b)&&(0===b?-1>=(-2147483648^a):0>b)?a:hQ(Y(),(new Ep).K(a,b))}else a=YN(Y(),this.Td);return a};e.oh=function(){return this.Td.oh()};e.$j=function(a){this.Td=a;return this};
e.Us=function(){var a=gt(Bj(),(new Ep).K(0,-2147483648));return 0<=this.qf(a)?(a=gt(Bj(),(new Ep).K(-1,2147483647)),0>=this.qf(a)):!1};e.Fm=function(){var a=this.Td,a=Gp(Ip(),a);return ga(uH(vH(),a))};var Vpa=l({uw:0},!1,"scala.math.BigInt",{uw:1,sC:1,bk:1,f:1,k:1,UK:1,tC:1,l:1,yo:1,xf:1});$s.prototype.$classData=Vpa;function qn(a){return!!(a&&a.$classData&&a.$classData.H.rt)}function yn(a){return!!(a&&a.$classData&&a.$classData.H.Tl)}function Dn(a){return!!(a&&a.$classData&&a.$classData.H.YL)}
function En(a){return!!(a&&a.$classData&&a.$classData.H.bM)}function Fn(a){return!!(a&&a.$classData&&a.$classData.H.iM)}function In(a){return!!(a&&a.$classData&&a.$classData.H.mM)}var Dwa=l({rn:0},!0,"scala.meta.Importee",{rn:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function Ol(a){return!!(a&&a.$classData&&a.$classData.H.tt)}var U3=l({tt:0},!0,"scala.meta.Init",{tt:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function DH(a){return!!(a&&a.$classData&&a.$classData.H.ww)}
var rv=l({ww:0},!0,"scala.meta.Mod$Abstract",{ww:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function yl(a){return!!(a&&a.$classData&&a.$classData.H.vt)}var P3=l({vt:0},!0,"scala.meta.Mod$Annot",{vt:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function CH(a){return!!(a&&a.$classData&&a.$classData.H.xN)}function Dl(a){return!!(a&&a.$classData&&a.$classData.H.BN)}function Cl(a){return!!(a&&a.$classData&&a.$classData.H.FN)}function zH(a){return!!(a&&a.$classData&&a.$classData.H.xw)}
var dea=l({xw:0},!0,"scala.meta.Mod$Final",{xw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function AD(a){return!!(a&&a.$classData&&a.$classData.H.yw)}var Iw=l({yw:0},!0,"scala.meta.Mod$Implicit",{yw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function CD(a){return!!(a&&a.$classData&&a.$classData.H.PN)}function BD(a){return!!(a&&a.$classData&&a.$classData.H.zw)}var Hv=l({zw:0},!0,"scala.meta.Mod$Lazy",{zw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function BH(a){return!!(a&&a.$classData&&a.$classData.H.Aw)}var eea=l({Aw:0},!0,"scala.meta.Mod$Override",{Aw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function El(a){return!!(a&&a.$classData&&a.$classData.H.Bw)}var Bga=l({Bw:0},!0,"scala.meta.Mod$Private",{Bw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Hl(a){return!!(a&&a.$classData&&a.$classData.H.Cw)}var Cga=l({Cw:0},!0,"scala.meta.Mod$Protected",{Cw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function AH(a){return!!(a&&a.$classData&&a.$classData.H.Dw)}var nv=l({Dw:0},!0,"scala.meta.Mod$Sealed",{Dw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Um(a){return!!(a&&a.$classData&&a.$classData.H.Ji)}var Cwa=l({Ji:0},!0,"scala.meta.Name",{Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Xm(a){return!!(a&&a.$classData&&a.$classData.H.AO)}function Ym(a){return!!(a&&a.$classData&&a.$classData.H.DO)}function dn(a){return!!(a&&a.$classData&&a.$classData.H.HO)}
function en(a){return!!(a&&a.$classData&&a.$classData.H.LO)}function gn(a){return!!(a&&a.$classData&&a.$classData.H.PO)}function hn(a){return!!(a&&a.$classData&&a.$classData.H.WO)}function jn(a){return!!(a&&a.$classData&&a.$classData.H.ZO)}function kn(a){return!!(a&&a.$classData&&a.$classData.H.bP)}function mn(a){return!!(a&&a.$classData&&a.$classData.H.iP)}function nn(a){return!!(a&&a.$classData&&a.$classData.H.mP)}function Rl(a){return!!(a&&a.$classData&&a.$classData.H.Aq)}
var oxa=l({Aq:0},!0,"scala.meta.Self",{Aq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function pn(a){return!!(a&&a.$classData&&a.$classData.H.Oc)}var N3=l({Oc:0},!0,"scala.meta.Term",{Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function sg(a){return!!(a&&a.$classData&&a.$classData.H.Cq)}var Q3=l({Cq:0},!0,"scala.meta.Term$Param",{Cq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Ni(a){return!!(a&&a.$classData&&a.$classData.H.iS)}
function Si(a){return!!(a&&a.$classData&&a.$classData.H.lS)}function wi(a){return!!(a&&a.$classData&&a.$classData.H.oS)}function xi(a){return!!(a&&a.$classData&&a.$classData.H.rS)}function Ig(a){return!!(a&&a.$classData&&a.$classData.H.xS)}function Ri(a){return!!(a&&a.$classData&&a.$classData.H.BS)}function Ai(a){return!!(a&&a.$classData&&a.$classData.H.ES)}function tl(a){return!!(a&&a.$classData&&a.$classData.H.IS)}function ul(a){return!!(a&&a.$classData&&a.$classData.H.LS)}
function Oi(a){return!!(a&&a.$classData&&a.$classData.H.US)}function Vl(a){return!!(a&&a.$classData&&a.$classData.H.Fq)}var Awa=l({Fq:0},!0,"scala.meta.Type$Param",{Fq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Ti(a){return!!(a&&a.$classData&&a.$classData.H.bT)}function Pi(a){return!!(a&&a.$classData&&a.$classData.H.mT)}function Jg(a){return!!(a&&a.$classData&&a.$classData.H.pT)}function Bi(a){return!!(a&&a.$classData&&a.$classData.H.zT)}
function Mi(a){return!!(a&&a.$classData&&a.$classData.H.HT)}function rC(){}rC.prototype=new m;rC.prototype.constructor=rC;e=rC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(pxa)};e.oa=function(){return"beginning of file"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({bU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$1",{bU:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ud(){}Ud.prototype=new m;Ud.prototype.constructor=Ud;e=Ud.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(qxa)};e.oa=function(){return"]"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({cU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$10",{cU:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function iy(){}iy.prototype=new m;iy.prototype.constructor=iy;e=iy.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(rxa)};e.oa=function(){return";"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({lU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$11",{lU:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Xd(){}Xd.prototype=new m;Xd.prototype.constructor=Xd;e=Xd.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(sxa)};e.oa=function(){return","};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({uU:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$12",{uU:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function hA(){}hA.prototype=new m;hA.prototype.constructor=hA;e=hA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(txa)};e.oa=function(){return"\x3e:"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({jV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$18",{jV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function iA(){}iA.prototype=new m;iA.prototype.constructor=iA;e=iA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(uxa)};e.oa=function(){return"\x3c:"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({lV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$19",{lV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function sC(){}sC.prototype=new m;sC.prototype.constructor=sC;e=sC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(vxa)};e.oa=function(){return"end of file"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({mV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$2",{mV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function QD(){}QD.prototype=new m;QD.prototype.constructor=QD;e=QD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(wxa)};e.oa=function(){return"identifier"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({nV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$21",{nV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function fE(){}fE.prototype=new m;fE.prototype.constructor=fE;e=fE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(z4)};e.oa=function(){return"."};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({oV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$22",{oV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function iE(){}iE.prototype=new m;iE.prototype.constructor=iE;e=iE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(z4)};e.oa=function(){return"."};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({pV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$23",{pV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function kE(){}kE.prototype=new m;kE.prototype.constructor=kE;e=kE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(z4)};e.oa=function(){return"."};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({qV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$24",{qV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function mE(){}mE.prototype=new m;mE.prototype.constructor=mE;e=mE.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(z4)};e.oa=function(){return"."};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({rV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$25",{rV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Uw(){}Uw.prototype=new m;Uw.prototype.constructor=Uw;e=Uw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(A4)};e.oa=function(){return"("};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({sV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$26",{sV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Vw(){}Vw.prototype=new m;Vw.prototype.constructor=Vw;e=Vw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(B4)};e.oa=function(){return")"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({tV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$27",{tV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Yy(){}Yy.prototype=new m;Yy.prototype.constructor=Yy;e=Yy.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(xxa)};e.oa=function(){return"while"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({uV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$28",{uV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function BB(){}BB.prototype=new m;BB.prototype.constructor=BB;e=BB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(C4)};e.oa=function(){return"\x3d\x3e"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({vV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$29",{vV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function ve(){}ve.prototype=new m;ve.prototype.constructor=ve;e=ve.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(A4)};e.oa=function(){return"("};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({wV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$3",{wV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function eC(){}eC.prototype=new m;eC.prototype.constructor=eC;e=eC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({xV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$30",{xV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function QB(){}QB.prototype=new m;QB.prototype.constructor=QB;e=QB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(C4)};e.oa=function(){return"\x3d\x3e"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({yV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$31",{yV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function JB(){}JB.prototype=new m;JB.prototype.constructor=JB;e=JB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(yxa)};e.oa=function(){return"case"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({zV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$33",{zV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function SB(){}SB.prototype=new m;SB.prototype.constructor=SB;e=SB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(yxa)};e.oa=function(){return"case"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({AV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$34",{AV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function eD(){}eD.prototype=new m;eD.prototype.constructor=eD;e=eD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(zxa)};e.oa=function(){return"\x3c-"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({BV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$35",{BV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function BA(){}BA.prototype=new m;BA.prototype.constructor=BA;e=BA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(E4)};e.oa=function(){return"["};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({CV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$36",{CV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function FA(){}FA.prototype=new m;FA.prototype.constructor=FA;e=FA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(qxa)};e.oa=function(){return"]"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({DV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$37",{DV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function lu(){}lu.prototype=new m;lu.prototype.constructor=lu;e=lu.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Axa)};e.oa=function(){return"@"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({EV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$38",{EV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function ZB(){}ZB.prototype=new m;ZB.prototype.constructor=ZB;e=ZB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(A4)};e.oa=function(){return"("};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({FV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$39",{FV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ae(){}Ae.prototype=new m;Ae.prototype.constructor=Ae;e=Ae.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(B4)};e.oa=function(){return")"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({GV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$4",{GV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function $B(){}$B.prototype=new m;$B.prototype.constructor=$B;e=$B.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(B4)};e.oa=function(){return")"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({HV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$40",{HV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function aC(){}aC.prototype=new m;aC.prototype.constructor=aC;e=aC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(A4)};e.oa=function(){return"("};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({IV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$41",{IV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function gB(){}gB.prototype=new m;gB.prototype.constructor=gB;e=gB.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Bxa)};e.oa=function(){return":"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({JV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$42",{JV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function yz(){}yz.prototype=new m;yz.prototype.constructor=yz;e=yz.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(E4)};e.oa=function(){return"["};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({KV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$43",{KV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Tt(){}Tt.prototype=new m;Tt.prototype.constructor=Tt;e=Tt.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Cxa)};e.oa=function(){return"import"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({LV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$44",{LV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function EC(){}EC.prototype=new m;EC.prototype.constructor=EC;e=EC.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(z4)};e.oa=function(){return"."};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({MV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$45",{MV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function vx(){}vx.prototype=new m;vx.prototype.constructor=vx;e=vx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Dxa)};e.oa=function(){return"val"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({NV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$46",{NV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function yv(){}yv.prototype=new m;yv.prototype.constructor=yv;e=yv.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(F4)};e.oa=function(){return"\x3d"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({OV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$47",{OV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ax(){}Ax.prototype=new m;Ax.prototype.constructor=Ax;e=Ax.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Exa)};e.oa=function(){return"def"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({PV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$48",{PV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Cx(){}Cx.prototype=new m;Cx.prototype.constructor=Cx;e=Cx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({QV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$49",{QV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ry(){}Ry.prototype=new m;Ry.prototype.constructor=Ry;e=Ry.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(A4)};e.oa=function(){return"("};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({RV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$5",{RV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Fx(){}Fx.prototype=new m;Fx.prototype.constructor=Fx;e=Fx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(F4)};e.oa=function(){return"\x3d"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({SV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$50",{SV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Px(){}Px.prototype=new m;Px.prototype.constructor=Px;e=Px.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Fxa)};e.oa=function(){return"type"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({TV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$51",{TV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Gw(){}Gw.prototype=new m;Gw.prototype.constructor=Gw;e=Gw.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Gxa)};e.oa=function(){return"trait"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({UV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$52",{UV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function sA(){}sA.prototype=new m;sA.prototype.constructor=sA;e=sA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Hxa)};e.oa=function(){return"class"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({VV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$53",{VV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function mA(){}mA.prototype=new m;mA.prototype.constructor=mA;e=mA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(fya)};e.oa=function(){return"object"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({WV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$54",{WV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ix(){}Ix.prototype=new m;Ix.prototype.constructor=Ix;e=Ix.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Exa)};e.oa=function(){return"def"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({XV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$55",{XV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Jx(){}Jx.prototype=new m;Jx.prototype.constructor=Jx;e=Jx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(gya)};e.oa=function(){return"this"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({YV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$56",{YV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ee(){}Ee.prototype=new m;Ee.prototype.constructor=Ee;e=Ee.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({ZV:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$6",{ZV:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Kx(){}Kx.prototype=new m;Kx.prototype.constructor=Kx;e=Kx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({$V:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$60",{$V:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Lx(){}Lx.prototype=new m;Lx.prototype.constructor=Lx;e=Lx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(F4)};e.oa=function(){return"\x3d"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({aW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$61",{aW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function tD(){}tD.prototype=new m;tD.prototype.constructor=tD;e=tD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({bW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$62",{bW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function uD(){}uD.prototype=new m;uD.prototype.constructor=uD;e=uD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(RAa)};e.oa=function(){return"}"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({cW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$63",{cW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function pD(){}pD.prototype=new m;pD.prototype.constructor=pD;e=pD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(gya)};e.oa=function(){return"this"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({dW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$64",{dW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function qD(){}qD.prototype=new m;qD.prototype.constructor=qD;e=qD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({eW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$65",{eW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function rD(){}rD.prototype=new m;rD.prototype.constructor=rD;e=rD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({fW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$66",{fW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function KD(){}KD.prototype=new m;KD.prototype.constructor=KD;e=KD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({gW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$67",{gW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function MD(){}MD.prototype=new m;MD.prototype.constructor=MD;e=MD.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({hW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$68",{hW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function wM(){}wM.prototype=new m;wM.prototype.constructor=wM;e=wM.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(vxa)};e.oa=function(){return"end of file"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({iW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$69",{iW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ie(){}Ie.prototype=new m;Ie.prototype.constructor=Ie;e=Ie.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(RAa)};e.oa=function(){return"}"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({jW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$7",{jW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function by(){}by.prototype=new m;by.prototype.constructor=by;e=by.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(G4)};e.oa=function(){return"package"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({kW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$70",{kW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Yx(){}Yx.prototype=new m;Yx.prototype.constructor=Yx;e=Yx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(G4)};e.oa=function(){return"package"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({lW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$71",{lW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Zx(){}Zx.prototype=new m;Zx.prototype.constructor=Zx;e=Zx.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(fya)};e.oa=function(){return"object"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({mW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$72",{mW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function SA(){}SA.prototype=new m;SA.prototype.constructor=SA;e=SA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(G4)};e.oa=function(){return"package"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({nW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$73",{nW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function QA(){}QA.prototype=new m;QA.prototype.constructor=QA;e=QA.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(G4)};e.oa=function(){return"package"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({oW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$74",{oW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function fy(){}fy.prototype=new m;fy.prototype.constructor=fy;e=fy.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({pW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$8",{pW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Td(){}Td.prototype=new m;Td.prototype.constructor=Td;e=Td.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(E4)};e.oa=function(){return"["};e.A=function(){return YN(Y(),this.G())};e.z=function(){return this};
e.$classData=l({tW:0},!1,"scala.meta.internal.parsers.ScalametaParser$$anon$9",{tW:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Uf(){}Uf.prototype=new m;Uf.prototype.constructor=Uf;e=Uf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(A4)};e.oa=function(){return"("};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({GX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$13",{GX:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function pg(){}pg.prototype=new m;pg.prototype.constructor=pg;e=pg.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(B4)};e.oa=function(){return")"};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({HX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$14",{HX:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function qg(){}qg.prototype=new m;qg.prototype.constructor=qg;e=qg.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(C4)};e.oa=function(){return"\x3d\x3e"};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({IX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$15",{IX:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Jh(){}Jh.prototype=new m;Jh.prototype.constructor=Jh;e=Jh.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(C4)};e.oa=function(){return"\x3d\x3e"};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({JX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$16",{JX:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Ch(){}Ch.prototype=new m;Ch.prototype.constructor=Ch;e=Ch.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(D4)};e.oa=function(){return"{"};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({KX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$17",{KX:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function Qf(){}Qf.prototype=new m;Qf.prototype.constructor=Qf;e=Qf.prototype;e.xa=function(a){return C1(this,a)};e.w=function(a){return D1(this,a)};e.v=function(){var a=this.G();return E1(this,a)};e.la=function(a){return k3(this,a)};e.G=function(){return k(Fxa)};e.oa=function(){return"type"};e.A=function(){return YN(Y(),this.G())};e.Cd=function(){return this};
e.$classData=l({LX:0},!1,"scala.meta.internal.parsers.ScalametaParser$PatternContextSensitive$$anon$20",{LX:1,f:1,bc:1,ya:1,Aa:1,za:1,l:1,k:1,x:1,na:1});function EY(){this.r=null}EY.prototype=new m;EY.prototype.constructor=EY;e=EY.prototype;e.U=function(){return"Literal"};e.M=function(){return 0};e.zf=function(){return 6};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Literal"};e.Vk=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
e.pf=function(){G();var a=(new r).d(["Term","Pat"]),b=G().b;return H(a,b)};e.A=function(){return 1847113871};e.L=function(){return Z(this)};e.$classData=l({GY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Literal$",{GY:1,f:1,Ul:1,Pf:1,$:1,R:1,x:1,l:1,k:1,un:1});function jK(){this.Q=this.u=null;this.E=0}jK.prototype=new m;jK.prototype.constructor=jK;e=jK.prototype;e.U=function(){return"At"};e.M=function(){return 3};
e.w=function(a){if(a&&a.$classData&&a.$classData.H.Pw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"@"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("At",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("At",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};var Axa=l({Pw:0},!1,"scala.meta.tokens.Token$At",{Pw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});jK.prototype.$classData=Axa;
function QM(){this.Q=this.u=null}QM.prototype=new m;QM.prototype.constructor=QM;e=QM.prototype;e.U=function(){return"BOF"};e.M=function(){return 2};e.w=function(a){if(JF(a)&&ns(a)&&2===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 0};e.oa=function(){return"beginning of file"};e.jb=function(){return this.u};
e.pj=function(a,b){this.u=a;this.Q=b;if(null!==a)a=(new q).a(!0,F());else{G();a=(new r).d(["this.input is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){for(var c=J(),d=[(new q).a("BOF",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("BOF",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,0,0)};e.ab=function(){return 0};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function JF(a){return!!(a&&a.$classData&&a.$classData.H.bD)}var pxa=l({bD:0},!1,"scala.meta.tokens.Token$BOF",{bD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
QM.prototype.$classData=pxa;function tK(){this.Q=this.u=null;this.E=0}tK.prototype=new m;tK.prototype.constructor=tK;e=tK.prototype;e.U=function(){return"CR"};e.M=function(){return 3};e.w=function(a){if(HF(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"\\r"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("CR",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("CR",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function HF(a){return!!(a&&a.$classData&&a.$classData.H.cD)}
e.$classData=l({cD:0},!1,"scala.meta.tokens.Token$CR",{cD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function hK(){this.Q=this.u=null;this.E=0}hK.prototype=new m;hK.prototype.constructor=hK;e=hK.prototype;e.U=function(){return"Colon"};e.M=function(){return 3};e.w=function(a){if(XC(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 1+this.E|0};e.oa=function(){return":"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Colon",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Colon",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function XC(a){return!!(a&&a.$classData&&a.$classData.H.dD)}
var Bxa=l({dD:0},!1,"scala.meta.tokens.Token$Colon",{dD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});hK.prototype.$classData=Bxa;function eK(){this.Q=this.u=null;this.E=0}eK.prototype=new m;eK.prototype.constructor=eK;e=eK.prototype;e.U=function(){return"Comma"};e.M=function(){return 3};e.w=function(a){if(Vx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return","};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Comma",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Comma",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Vx(a){return!!(a&&a.$classData&&a.$classData.H.eD)}
var sxa=l({eD:0},!1,"scala.meta.tokens.Token$Comma",{eD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});eK.prototype.$classData=sxa;function wK(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}wK.prototype=new m;wK.prototype.constructor=wK;e=wK.prototype;e.U=function(){return"Comment"};e.M=function(){return 5};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Qw&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"comment"};e.jb=function(){return this.u};
e.Rg=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Comment",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,
b)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Comment",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Comment",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",
a,d.t)}throw(new p).e(f);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Qw:0},!1,"scala.meta.tokens.Token$Comment",{Qw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function $I(){this.Q=this.u=null;this.pa=this.Ca=this.E=0}$I.prototype=new m;$I.prototype.constructor=$I;e=$I.prototype;e.U=function(){return"Char"};e.M=function(){return 5};
e.w=function(a){if(wt(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return(new ed).db(this.pa);default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"character constant"};e.jb=function(){return this.u};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};
e.A=function(){return WN(this)};e.L=function(){return Z(this)};function wt(a){return!!(a&&a.$classData&&a.$classData.H.fD)}e.$classData=l({fD:0},!1,"scala.meta.tokens.Token$Constant$Char",{fD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function ZI(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}ZI.prototype=new m;ZI.prototype.constructor=ZI;e=ZI.prototype;e.U=function(){return"Double"};e.M=function(){return 5};e.w=function(a){if(qt(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"double constant"};e.jb=function(){return this.u};
e.Bv=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Double",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,
b)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Double",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Double",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",
a,d.t)}throw(new p).e(f);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function qt(a){return!!(a&&a.$classData&&a.$classData.H.gD)}e.$classData=l({gD:0},!1,"scala.meta.tokens.Token$Constant$Double",{gD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function YI(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}YI.prototype=new m;YI.prototype.constructor=YI;e=YI.prototype;e.U=function(){return"Float"};
e.M=function(){return 5};e.w=function(a){if(jt(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"float constant"};e.jb=function(){return this.u};
e.Bv=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Float",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,
b)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Float",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Float",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",
a,d.t)}throw(new p).e(f);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function jt(a){return!!(a&&a.$classData&&a.$classData.H.hD)}e.$classData=l({hD:0},!1,"scala.meta.tokens.Token$Constant$Float",{hD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function WI(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}WI.prototype=new m;WI.prototype.constructor=WI;e=WI.prototype;e.U=function(){return"Int"};
e.Cv=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Int",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));
if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Int",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Int",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",a,d.t)}throw(new p).e(f);
}return this};e.M=function(){return 5};e.w=function(a){if(Xs(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"integer constant"};e.jb=function(){return this.u};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};
e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Xs(a){return!!(a&&a.$classData&&a.$classData.H.iD)}e.$classData=l({iD:0},!1,"scala.meta.tokens.Token$Constant$Int",{iD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function XI(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}XI.prototype=new m;XI.prototype.constructor=XI;e=XI.prototype;e.U=function(){return"Long"};
e.Cv=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Long",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));
if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Long",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Long",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",a,d.t)}throw(new p).e(f);
}return this};e.M=function(){return 5};e.w=function(a){if(dt(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"long constant"};e.jb=function(){return this.u};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};
e.A=function(){return WN(this)};e.L=function(){return Z(this)};function dt(a){return!!(a&&a.$classData&&a.$classData.H.jD)}e.$classData=l({jD:0},!1,"scala.meta.tokens.Token$Constant$Long",{jD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function fJ(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}fJ.prototype=new m;fJ.prototype.constructor=fJ;e=fJ.prototype;e.U=function(){return"String"};e.M=function(){return 5};e.w=function(a){if(At(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"string constant"};e.jb=function(){return this.u};
e.Rg=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("String",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,
b)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("String",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("String",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",
a,d.t)}throw(new p).e(f);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function At(a){return!!(a&&a.$classData&&a.$classData.H.kD)}e.$classData=l({kD:0},!1,"scala.meta.tokens.Token$Constant$String",{kD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function eJ(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}eJ.prototype=new m;eJ.prototype.constructor=eJ;e=eJ.prototype;e.U=function(){return"Symbol"};
e.M=function(){return 5};e.w=function(a){if(Ft(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"symbol constant"};e.jb=function(){return this.u};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};
e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Ft(a){return!!(a&&a.$classData&&a.$classData.H.lD)}e.$classData=l({lD:0},!1,"scala.meta.tokens.Token$Constant$Symbol",{lD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function gK(){this.Q=this.u=null;this.E=0}gK.prototype=new m;gK.prototype.constructor=gK;e=gK.prototype;e.U=function(){return"Dot"};e.M=function(){return 3};e.w=function(a){if(fC(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"."};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Dot",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Dot",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function fC(a){return!!(a&&a.$classData&&a.$classData.H.mD)}
var z4=l({mD:0},!1,"scala.meta.tokens.Token$Dot",{mD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});gK.prototype.$classData=z4;function zK(){this.Q=this.u=null}zK.prototype=new m;zK.prototype.constructor=zK;e=zK.prototype;e.U=function(){return"EOF"};e.M=function(){return 2};e.w=function(a){if(KF(a)&&ns(a)&&2===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.u.od().i.length};
e.oa=function(){return"end of file"};e.jb=function(){return this.u};
e.pj=function(a,b){this.u=a;this.Q=b;if(null!==a)a=(new q).a(!0,F());else{G();a=(new r).d(["this.input is equal to null"]);var c=G().b;a=(new q).a(!1,H(a,c))}if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){for(var c=J(),d=[(new q).a("EOF",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("EOF",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.ab(),c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.u.od().i.length};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function KF(a){return!!(a&&a.$classData&&a.$classData.H.nD)}
var vxa=l({nD:0},!1,"scala.meta.tokens.Token$EOF",{nD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});zK.prototype.$classData=vxa;function xK(){this.Q=this.u=null;this.Hb=this.Ca=this.E=0}xK.prototype=new m;xK.prototype.constructor=xK;e=xK.prototype;e.U=function(){return"Ellipsis"};e.M=function(){return 5};e.w=function(a){if(de(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.Hb;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"ellipsis"};e.jb=function(){return this.u};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};
function de(a){return!!(a&&a.$classData&&a.$classData.H.oD)}e.$classData=l({oD:0},!1,"scala.meta.tokens.Token$Ellipsis",{oD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function iK(){this.Q=this.u=null;this.E=0}iK.prototype=new m;iK.prototype.constructor=iK;e=iK.prototype;e.U=function(){return"Equals"};e.M=function(){return 3};e.w=function(a){if(Qx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"\x3d"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Equals",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Equals",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Qx(a){return!!(a&&a.$classData&&a.$classData.H.pD)}
var F4=l({pD:0},!1,"scala.meta.tokens.Token$Equals",{pD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});iK.prototype.$classData=F4;function vK(){this.Q=this.u=null;this.E=0}vK.prototype=new m;vK.prototype.constructor=vK;e=vK.prototype;e.U=function(){return"FF"};e.M=function(){return 3};e.w=function(a){if(IF(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 1+this.E|0};e.oa=function(){return"\\f"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("FF",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("FF",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function IF(a){return!!(a&&a.$classData&&a.$classData.H.qD)}
e.$classData=l({qD:0},!1,"scala.meta.tokens.Token$FF",{qD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function kK(){this.Q=this.u=null;this.E=0}kK.prototype=new m;kK.prototype.constructor=kK;e=kK.prototype;e.U=function(){return"Hash"};e.M=function(){return 3};e.w=function(a){if(ei(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 1+this.E|0};e.oa=function(){return"#"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Hash",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Hash",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function ei(a){return!!(a&&a.$classData&&a.$classData.H.rD)}
e.$classData=l({rD:0},!1,"scala.meta.tokens.Token$Hash",{rD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function VI(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}VI.prototype=new m;VI.prototype.constructor=VI;e=VI.prototype;e.U=function(){return"Ident"};e.M=function(){return 5};e.w=function(a){if(hg(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"identifier"};e.jb=function(){return this.u};
e.Rg=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Ident",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,
b)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Ident",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Ident",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",
a,d.t)}throw(new p).e(f);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function hg(a){return!!(a&&a.$classData&&a.$classData.H.sD)}var wxa=l({sD:0},!1,"scala.meta.tokens.Token$Ident",{sD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});VI.prototype.$classData=wxa;function PI(){this.Q=this.u=null;this.Ca=this.E=0}PI.prototype=new m;PI.prototype.constructor=PI;e=PI.prototype;e.U=function(){return"End"};
e.M=function(){return 4};e.w=function(a){if(cw(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"interpolation end"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("End",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("End",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function cw(a){return!!(a&&a.$classData&&a.$classData.H.tD)}
e.$classData=l({tD:0},!1,"scala.meta.tokens.Token$Interpolation$End",{tD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function lJ(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}lJ.prototype=new m;lJ.prototype.constructor=lJ;e=lJ.prototype;e.U=function(){return"Id"};e.M=function(){return 5};e.w=function(a){if(Nv(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"interpolation id"};e.jb=function(){return this.u};
e.Rg=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Id",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));
if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Id",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Id",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",a,d.t)}throw(new p).e(f);
}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Nv(a){return!!(a&&a.$classData&&a.$classData.H.uD)}e.$classData=l({uD:0},!1,"scala.meta.tokens.Token$Interpolation$Id",{uD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function BK(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}BK.prototype=new m;BK.prototype.constructor=BK;e=BK.prototype;e.U=function(){return"Part"};
e.M=function(){return 5};e.w=function(a){if(Sv(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"interpolation part"};e.jb=function(){return this.u};
e.Rg=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Part",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));
if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Part",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Part",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",a,d.t)}throw(new p).e(f);
}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Sv(a){return!!(a&&a.$classData&&a.$classData.H.vD)}e.$classData=l({vD:0},!1,"scala.meta.tokens.Token$Interpolation$Part",{vD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function RI(){this.Q=this.u=null;this.Ca=this.E=0}RI.prototype=new m;RI.prototype.constructor=RI;e=RI.prototype;e.U=function(){return"SpliceEnd"};e.M=function(){return 4};
e.w=function(a){if(aw(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"splice end"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceEnd",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceEnd",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function aw(a){return!!(a&&a.$classData&&a.$classData.H.wD)}
e.$classData=l({wD:0},!1,"scala.meta.tokens.Token$Interpolation$SpliceEnd",{wD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function TI(){this.Q=this.u=null;this.Ca=this.E=0}TI.prototype=new m;TI.prototype.constructor=TI;e=TI.prototype;e.U=function(){return"SpliceStart"};e.M=function(){return 4};e.w=function(a){if(Yv(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"splice start"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceStart",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceStart",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Yv(a){return!!(a&&a.$classData&&a.$classData.H.xD)}
e.$classData=l({xD:0},!1,"scala.meta.tokens.Token$Interpolation$SpliceStart",{xD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function NI(){this.Q=this.u=null;this.Ca=this.E=0}NI.prototype=new m;NI.prototype.constructor=NI;e=NI.prototype;e.U=function(){return"Start"};e.M=function(){return 4};e.w=function(a){if(Rv(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"interpolation start"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Start",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Start",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Rv(a){return!!(a&&a.$classData&&a.$classData.H.yD)}
e.$classData=l({yD:0},!1,"scala.meta.tokens.Token$Interpolation$Start",{yD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function uJ(){this.Q=this.u=null;this.E=0}uJ.prototype=new m;uJ.prototype.constructor=uJ;e=uJ.prototype;e.U=function(){return"KwAbstract"};e.M=function(){return 3};e.w=function(a){if(py(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 8+this.E|0};e.oa=function(){return"abstract"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwAbstract",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwAbstract",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function py(a){return!!(a&&a.$classData&&a.$classData.H.zD)}
e.$classData=l({zD:0},!1,"scala.meta.tokens.Token$KwAbstract",{zD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function WJ(){this.Q=this.u=null;this.E=0}WJ.prototype=new m;WJ.prototype.constructor=WJ;e=WJ.prototype;e.U=function(){return"KwCase"};e.M=function(){return 3};e.w=function(a){if(Pw(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 4+this.E|0};e.oa=function(){return"case"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwCase",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwCase",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Pw(a){return!!(a&&a.$classData&&a.$classData.H.AD)}
var yxa=l({AD:0},!1,"scala.meta.tokens.Token$KwCase",{AD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});WJ.prototype.$classData=yxa;function UJ(){this.Q=this.u=null;this.E=0}UJ.prototype=new m;UJ.prototype.constructor=UJ;e=UJ.prototype;e.U=function(){return"KwCatch"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Rw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"catch"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwCatch",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwCatch",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Rw:0},!1,"scala.meta.tokens.Token$KwCatch",{Rw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function BJ(){this.Q=this.u=null;this.E=0}BJ.prototype=new m;BJ.prototype.constructor=BJ;e=BJ.prototype;e.U=function(){return"KwClass"};e.M=function(){return 3};e.w=function(a){if(Ow(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"class"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwClass",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwClass",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Ow(a){return!!(a&&a.$classData&&a.$classData.H.BD)}
var Hxa=l({BD:0},!1,"scala.meta.tokens.Token$KwClass",{BD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});BJ.prototype.$classData=Hxa;function IJ(){this.Q=this.u=null;this.E=0}IJ.prototype=new m;IJ.prototype.constructor=IJ;e=IJ.prototype;e.U=function(){return"KwDef"};e.M=function(){return 3};e.w=function(a){if(yx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 3+this.E|0};e.oa=function(){return"def"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwDef",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwDef",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function yx(a){return!!(a&&a.$classData&&a.$classData.H.CD)}
var Exa=l({CD:0},!1,"scala.meta.tokens.Token$KwDef",{CD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});IJ.prototype.$classData=Exa;function PJ(){this.Q=this.u=null;this.E=0}PJ.prototype=new m;PJ.prototype.constructor=PJ;e=PJ.prototype;e.U=function(){return"KwDo"};e.M=function(){return 3};e.w=function(a){if(Xy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 2+this.E|0};e.oa=function(){return"do"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwDo",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwDo",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Xy(a){return!!(a&&a.$classData&&a.$classData.H.DD)}
e.$classData=l({DD:0},!1,"scala.meta.tokens.Token$KwDo",{DD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function NJ(){this.Q=this.u=null;this.E=0}NJ.prototype=new m;NJ.prototype.constructor=NJ;e=NJ.prototype;e.U=function(){return"KwElse"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Sw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 4+this.E|0};e.oa=function(){return"else"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwElse",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwElse",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Sw:0},!1,"scala.meta.tokens.Token$KwElse",{Sw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function LJ(){this.Q=this.u=null;this.E=0}LJ.prototype=new m;LJ.prototype.constructor=LJ;e=LJ.prototype;e.U=function(){return"KwEnum"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.ED&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 4+this.E|0};e.oa=function(){return"enum"};
e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwEnum",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwEnum",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({ED:0},!1,"scala.meta.tokens.Token$KwEnum",{ED:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function EJ(){this.Q=this.u=null;this.E=0}EJ.prototype=new m;EJ.prototype.constructor=EJ;e=EJ.prototype;e.U=function(){return"KwExtends"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Tw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 7+this.E|0};e.oa=function(){return"extends"};
e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwExtends",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwExtends",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Tw:0},!1,"scala.meta.tokens.Token$KwExtends",{Tw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function jJ(){this.Q=this.u=null;this.E=0}jJ.prototype=new m;jJ.prototype.constructor=jJ;e=jJ.prototype;e.U=function(){return"KwFalse"};e.M=function(){return 3};e.w=function(a){if(Kt(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"false"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwFalse",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwFalse",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Kt(a){return!!(a&&a.$classData&&a.$classData.H.FD)}
e.$classData=l({FD:0},!1,"scala.meta.tokens.Token$KwFalse",{FD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function vJ(){this.Q=this.u=null;this.E=0}vJ.prototype=new m;vJ.prototype.constructor=vJ;e=vJ.prototype;e.U=function(){return"KwFinal"};e.M=function(){return 3};e.w=function(a){if(qy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 5+this.E|0};e.oa=function(){return"final"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwFinal",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwFinal",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function qy(a){return!!(a&&a.$classData&&a.$classData.H.GD)}
e.$classData=l({GD:0},!1,"scala.meta.tokens.Token$KwFinal",{GD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function VJ(){this.Q=this.u=null;this.E=0}VJ.prototype=new m;VJ.prototype.constructor=VJ;e=VJ.prototype;e.U=function(){return"KwFinally"};e.M=function(){return 3};e.w=function(a){if(Sy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 7+this.E|0};e.oa=function(){return"finally"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwFinally",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwFinally",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Sy(a){return!!(a&&a.$classData&&a.$classData.H.HD)}
e.$classData=l({HD:0},!1,"scala.meta.tokens.Token$KwFinally",{HD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function QJ(){this.Q=this.u=null;this.E=0}QJ.prototype=new m;QJ.prototype.constructor=QJ;e=QJ.prototype;e.U=function(){return"KwFor"};e.M=function(){return 3};e.w=function(a){if($y(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 3+this.E|0};e.oa=function(){return"for"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwFor",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwFor",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function $y(a){return!!(a&&a.$classData&&a.$classData.H.ID)}
e.$classData=l({ID:0},!1,"scala.meta.tokens.Token$KwFor",{ID:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function HJ(){this.Q=this.u=null;this.E=0}HJ.prototype=new m;HJ.prototype.constructor=HJ;e=HJ.prototype;e.U=function(){return"KwForsome"};e.M=function(){return 3};e.w=function(a){if(Zh(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 7+this.E|0};e.oa=function(){return"forSome"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwForsome",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwForsome",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Zh(a){return!!(a&&a.$classData&&a.$classData.H.JD)}
e.$classData=l({JD:0},!1,"scala.meta.tokens.Token$KwForsome",{JD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function MJ(){this.Q=this.u=null;this.E=0}MJ.prototype=new m;MJ.prototype.constructor=MJ;e=MJ.prototype;e.U=function(){return"KwIf"};e.M=function(){return 3};e.w=function(a){if(Ky(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 2+this.E|0};e.oa=function(){return"if"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwIf",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwIf",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Ky(a){return!!(a&&a.$classData&&a.$classData.H.KD)}
e.$classData=l({KD:0},!1,"scala.meta.tokens.Token$KwIf",{KD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function qJ(){this.Q=this.u=null;this.E=0}qJ.prototype=new m;qJ.prototype.constructor=qJ;e=qJ.prototype;e.U=function(){return"KwImplicit"};e.M=function(){return 3};e.w=function(a){if(gg(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 8+this.E|0};e.oa=function(){return"implicit"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwImplicit",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwImplicit",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function gg(a){return!!(a&&a.$classData&&a.$classData.H.LD)}
e.$classData=l({LD:0},!1,"scala.meta.tokens.Token$KwImplicit",{LD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function AJ(){this.Q=this.u=null;this.E=0}AJ.prototype=new m;AJ.prototype.constructor=AJ;e=AJ.prototype;e.U=function(){return"KwImport"};e.M=function(){return 3};e.w=function(a){if(hU(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 6+this.E|0};e.oa=function(){return"import"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwImport",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwImport",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function hU(a){return!!(a&&a.$classData&&a.$classData.H.MD)}
var Cxa=l({MD:0},!1,"scala.meta.tokens.Token$KwImport",{MD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});AJ.prototype.$classData=Cxa;function xJ(){this.Q=this.u=null;this.E=0}xJ.prototype=new m;xJ.prototype.constructor=xJ;e=xJ.prototype;e.U=function(){return"KwLazy"};e.M=function(){return 3};e.w=function(a){if(wy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 4+this.E|0};e.oa=function(){return"lazy"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwLazy",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwLazy",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function wy(a){return!!(a&&a.$classData&&a.$classData.H.ND)}
e.$classData=l({ND:0},!1,"scala.meta.tokens.Token$KwLazy",{ND:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function yJ(){this.Q=this.u=null;this.E=0}yJ.prototype=new m;yJ.prototype.constructor=yJ;e=yJ.prototype;e.U=function(){return"KwMacro"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Uw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"macro"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwMacro",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwMacro",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Uw:0},!1,"scala.meta.tokens.Token$KwMacro",{Uw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function YJ(){this.Q=this.u=null;this.E=0}YJ.prototype=new m;YJ.prototype.constructor=YJ;e=YJ.prototype;e.U=function(){return"KwMatch"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Vw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"match"};
e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwMatch",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwMatch",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Vw:0},!1,"scala.meta.tokens.Token$KwMatch",{Vw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function nJ(){this.Q=this.u=null;this.E=0}nJ.prototype=new m;nJ.prototype.constructor=nJ;e=nJ.prototype;e.U=function(){return"KwNew"};e.M=function(){return 3};e.w=function(a){if(hx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 3+this.E|0};e.oa=function(){return"new"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwNew",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwNew",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function hx(a){return!!(a&&a.$classData&&a.$classData.H.OD)}
e.$classData=l({OD:0},!1,"scala.meta.tokens.Token$KwNew",{OD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function kJ(){this.Q=this.u=null;this.E=0}kJ.prototype=new m;kJ.prototype.constructor=kJ;e=kJ.prototype;e.U=function(){return"KwNull"};e.M=function(){return 3};e.w=function(a){if(Lt(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 4+this.E|0};e.oa=function(){return"null"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwNull",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwNull",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Lt(a){return!!(a&&a.$classData&&a.$classData.H.PD)}
e.$classData=l({PD:0},!1,"scala.meta.tokens.Token$KwNull",{PD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function CJ(){this.Q=this.u=null;this.E=0}CJ.prototype=new m;CJ.prototype.constructor=CJ;e=CJ.prototype;e.U=function(){return"KwObject"};e.M=function(){return 3};e.w=function(a){if(Rw(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 6+this.E|0};e.oa=function(){return"object"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwObject",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwObject",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Rw(a){return!!(a&&a.$classData&&a.$classData.H.QD)}
var fya=l({QD:0},!1,"scala.meta.tokens.Token$KwObject",{QD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});CJ.prototype.$classData=fya;function rJ(){this.Q=this.u=null;this.E=0}rJ.prototype=new m;rJ.prototype.constructor=rJ;e=rJ.prototype;e.U=function(){return"KwOverride"};e.M=function(){return 3};e.w=function(a){if(yy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 8+this.E|0};e.oa=function(){return"override"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwOverride",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwOverride",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function yy(a){return!!(a&&a.$classData&&a.$classData.H.RD)}
e.$classData=l({RD:0},!1,"scala.meta.tokens.Token$KwOverride",{RD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function zJ(){this.Q=this.u=null;this.E=0}zJ.prototype=new m;zJ.prototype.constructor=zJ;e=zJ.prototype;e.U=function(){return"KwPackage"};e.M=function(){return 3};e.w=function(a){if(mU(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 7+this.E|0};e.oa=function(){return"package"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwPackage",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwPackage",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function mU(a){return!!(a&&a.$classData&&a.$classData.H.SD)}
var G4=l({SD:0},!1,"scala.meta.tokens.Token$KwPackage",{SD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});zJ.prototype.$classData=G4;function tJ(){this.Q=this.u=null;this.E=0}tJ.prototype=new m;tJ.prototype.constructor=tJ;e=tJ.prototype;e.U=function(){return"KwPrivate"};e.M=function(){return 3};e.w=function(a){if(ww(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 7+this.E|0};e.oa=function(){return"private"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwPrivate",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwPrivate",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function ww(a){return!!(a&&a.$classData&&a.$classData.H.TD)}
e.$classData=l({TD:0},!1,"scala.meta.tokens.Token$KwPrivate",{TD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function sJ(){this.Q=this.u=null;this.E=0}sJ.prototype=new m;sJ.prototype.constructor=sJ;e=sJ.prototype;e.U=function(){return"KwProtected"};e.M=function(){return 3};e.w=function(a){if(xw(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 9+this.E|0};e.oa=function(){return"protected"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwProtected",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||
!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwProtected",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function xw(a){return!!(a&&a.$classData&&a.$classData.H.UD)}
e.$classData=l({UD:0},!1,"scala.meta.tokens.Token$KwProtected",{UD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function XJ(){this.Q=this.u=null;this.E=0}XJ.prototype=new m;XJ.prototype.constructor=XJ;e=XJ.prototype;e.U=function(){return"KwReturn"};e.M=function(){return 3};e.w=function(a){if(ez(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 6+this.E|0};e.oa=function(){return"return"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwReturn",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwReturn",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function ez(a){return!!(a&&a.$classData&&a.$classData.H.VD)}
e.$classData=l({VD:0},!1,"scala.meta.tokens.Token$KwReturn",{VD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function wJ(){this.Q=this.u=null;this.E=0}wJ.prototype=new m;wJ.prototype.constructor=wJ;e=wJ.prototype;e.U=function(){return"KwSealed"};e.M=function(){return 3};e.w=function(a){if(sy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 6+this.E|0};e.oa=function(){return"sealed"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwSealed",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwSealed",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function sy(a){return!!(a&&a.$classData&&a.$classData.H.WD)}
e.$classData=l({WD:0},!1,"scala.meta.tokens.Token$KwSealed",{WD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function pJ(){this.Q=this.u=null;this.E=0}pJ.prototype=new m;pJ.prototype.constructor=pJ;e=pJ.prototype;e.U=function(){return"KwSuper"};e.M=function(){return 3};e.w=function(a){if(Xw(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 5+this.E|0};e.oa=function(){return"super"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwSuper",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwSuper",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Xw(a){return!!(a&&a.$classData&&a.$classData.H.XD)}
e.$classData=l({XD:0},!1,"scala.meta.tokens.Token$KwSuper",{XD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function oJ(){this.Q=this.u=null;this.E=0}oJ.prototype=new m;oJ.prototype.constructor=oJ;e=oJ.prototype;e.U=function(){return"KwThis"};e.M=function(){return 3};e.w=function(a){if(Ww(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 4+this.E|0};e.oa=function(){return"this"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwThis",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwThis",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Ww(a){return!!(a&&a.$classData&&a.$classData.H.YD)}
var gya=l({YD:0},!1,"scala.meta.tokens.Token$KwThis",{YD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});oJ.prototype.$classData=gya;function SJ(){this.Q=this.u=null;this.E=0}SJ.prototype=new m;SJ.prototype.constructor=SJ;e=SJ.prototype;e.U=function(){return"KwThrow"};e.M=function(){return 3};e.w=function(a){if(hz(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"throw"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwThrow",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwThrow",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function hz(a){return!!(a&&a.$classData&&a.$classData.H.ZD)}
e.$classData=l({ZD:0},!1,"scala.meta.tokens.Token$KwThrow",{ZD:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function DJ(){this.Q=this.u=null;this.E=0}DJ.prototype=new m;DJ.prototype.constructor=DJ;e=DJ.prototype;e.U=function(){return"KwTrait"};e.M=function(){return 3};e.w=function(a){if(Cw(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 5+this.E|0};e.oa=function(){return"trait"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwTrait",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwTrait",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Cw(a){return!!(a&&a.$classData&&a.$classData.H.$D)}
var Gxa=l({$D:0},!1,"scala.meta.tokens.Token$KwTrait",{$D:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});DJ.prototype.$classData=Gxa;function iJ(){this.Q=this.u=null;this.E=0}iJ.prototype=new m;iJ.prototype.constructor=iJ;e=iJ.prototype;e.U=function(){return"KwTrue"};e.M=function(){return 3};e.w=function(a){if(Jt(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 4+this.E|0};e.oa=function(){return"true"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwTrue",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwTrue",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Jt(a){return!!(a&&a.$classData&&a.$classData.H.aE)}
e.$classData=l({aE:0},!1,"scala.meta.tokens.Token$KwTrue",{aE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function TJ(){this.Q=this.u=null;this.E=0}TJ.prototype=new m;TJ.prototype.constructor=TJ;e=TJ.prototype;e.U=function(){return"KwTry"};e.M=function(){return 3};e.w=function(a){if(Qy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 3+this.E|0};e.oa=function(){return"try"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwTry",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwTry",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Qy(a){return!!(a&&a.$classData&&a.$classData.H.bE)}
e.$classData=l({bE:0},!1,"scala.meta.tokens.Token$KwTry",{bE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function GJ(){this.Q=this.u=null;this.E=0}GJ.prototype=new m;GJ.prototype.constructor=GJ;e=GJ.prototype;e.U=function(){return"KwType"};e.M=function(){return 3};e.w=function(a){if(Ox(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 4+this.E|0};e.oa=function(){return"type"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwType",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwType",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Ox(a){return!!(a&&a.$classData&&a.$classData.H.cE)}
var Fxa=l({cE:0},!1,"scala.meta.tokens.Token$KwType",{cE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});GJ.prototype.$classData=Fxa;function JJ(){this.Q=this.u=null;this.E=0}JJ.prototype=new m;JJ.prototype.constructor=JJ;e=JJ.prototype;e.U=function(){return"KwVal"};e.M=function(){return 3};e.w=function(a){if(wx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 3+this.E|0};e.oa=function(){return"val"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwVal",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwVal",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function wx(a){return!!(a&&a.$classData&&a.$classData.H.dE)}
var Dxa=l({dE:0},!1,"scala.meta.tokens.Token$KwVal",{dE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});JJ.prototype.$classData=Dxa;function KJ(){this.Q=this.u=null;this.E=0}KJ.prototype=new m;KJ.prototype.constructor=KJ;e=KJ.prototype;e.U=function(){return"KwVar"};e.M=function(){return 3};e.w=function(a){if(xx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 3+this.E|0};e.oa=function(){return"var"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwVar",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwVar",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function xx(a){return!!(a&&a.$classData&&a.$classData.H.eE)}
e.$classData=l({eE:0},!1,"scala.meta.tokens.Token$KwVar",{eE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function OJ(){this.Q=this.u=null;this.E=0}OJ.prototype=new m;OJ.prototype.constructor=OJ;e=OJ.prototype;e.U=function(){return"KwWhile"};e.M=function(){return 3};e.w=function(a){if(Vy(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 5+this.E|0};e.oa=function(){return"while"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwWhile",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwWhile",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Vy(a){return!!(a&&a.$classData&&a.$classData.H.fE)}
var xxa=l({fE:0},!1,"scala.meta.tokens.Token$KwWhile",{fE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});OJ.prototype.$classData=xxa;function FJ(){this.Q=this.u=null;this.E=0}FJ.prototype=new m;FJ.prototype.constructor=FJ;e=FJ.prototype;e.U=function(){return"KwWith"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Ww&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 4+this.E|0};e.oa=function(){return"with"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwWith",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwWith",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Ww:0},!1,"scala.meta.tokens.Token$KwWith",{Ww:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function RJ(){this.Q=this.u=null;this.E=0}RJ.prototype=new m;RJ.prototype.constructor=RJ;e=RJ.prototype;e.U=function(){return"KwYield"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Xw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 5+this.E|0};e.oa=function(){return"yield"};
e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("KwYield",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("KwYield",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Xw:0},!1,"scala.meta.tokens.Token$KwYield",{Xw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function uK(){this.Q=this.u=null;this.E=0}uK.prototype=new m;uK.prototype.constructor=uK;e=uK.prototype;e.U=function(){return"LF"};e.M=function(){return 3};e.w=function(a){if(px(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"\\n"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("LF",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LF",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function px(a){return!!(a&&a.$classData&&a.$classData.H.gE)}
e.$classData=l({gE:0},!1,"scala.meta.tokens.Token$LF",{gE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function WD(){this.Q=this.u=null;this.Ca=this.E=0}WD.prototype=new m;WD.prototype.constructor=WD;e=WD.prototype;e.U=function(){return"LFLF"};e.M=function(){return 4};e.w=function(a){if(hy(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"\\n\\n"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LFLF",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LFLF",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function hy(a){return!!(a&&a.$classData&&a.$classData.H.hE)}
e.$classData=l({hE:0},!1,"scala.meta.tokens.Token$LFLF",{hE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function nK(){this.Q=this.u=null;this.Ca=this.E=0}nK.prototype=new m;nK.prototype.constructor=nK;e=nK.prototype;e.U=function(){return"LeftArrow"};e.M=function(){return 4};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Yw&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"\x3c-"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LeftArrow",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LeftArrow",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};var zxa=l({Yw:0},!1,"scala.meta.tokens.Token$LeftArrow",{Yw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});nK.prototype.$classData=zxa;
function cK(){this.Q=this.u=null;this.E=0}cK.prototype=new m;cK.prototype.constructor=cK;e=cK.prototype;e.U=function(){return"LeftBrace"};e.M=function(){return 3};e.w=function(a){if(Be(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"{"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("LeftBrace",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LeftBrace",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Be(a){return!!(a&&a.$classData&&a.$classData.H.iE)}
var D4=l({iE:0},!1,"scala.meta.tokens.Token$LeftBrace",{iE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});cK.prototype.$classData=D4;function aK(){this.Q=this.u=null;this.E=0}aK.prototype=new m;aK.prototype.constructor=aK;e=aK.prototype;e.U=function(){return"LeftBracket"};e.M=function(){return 3};e.w=function(a){if(fi(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"["};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("LeftBracket",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||
!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LeftBracket",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function fi(a){return!!(a&&a.$classData&&a.$classData.H.jE)}
var E4=l({jE:0},!1,"scala.meta.tokens.Token$LeftBracket",{jE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});aK.prototype.$classData=E4;function ZJ(){this.Q=this.u=null;this.E=0}ZJ.prototype=new m;ZJ.prototype.constructor=ZJ;e=ZJ.prototype;e.U=function(){return"LeftParen"};e.M=function(){return 3};e.w=function(a){if(ue(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"("};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("LeftParen",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("LeftParen",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function ue(a){return!!(a&&a.$classData&&a.$classData.H.kE)}
var A4=l({kE:0},!1,"scala.meta.tokens.Token$LeftParen",{kE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});ZJ.prototype.$classData=A4;function mK(){this.Q=this.u=null;this.Ca=this.E=0}mK.prototype=new m;mK.prototype.constructor=mK;e=mK.prototype;e.U=function(){return"RightArrow"};e.M=function(){return 4};e.w=function(a){if(Yh(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"\x3d\x3e"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("RightArrow",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("RightArrow",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Yh(a){return!!(a&&a.$classData&&a.$classData.H.lE)}
var C4=l({lE:0},!1,"scala.meta.tokens.Token$RightArrow",{lE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});mK.prototype.$classData=C4;function dK(){this.Q=this.u=null;this.E=0}dK.prototype=new m;dK.prototype.constructor=dK;e=dK.prototype;e.U=function(){return"RightBrace"};e.M=function(){return 3};e.w=function(a){if(Wx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"}"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("RightBrace",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("RightBrace",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Wx(a){return!!(a&&a.$classData&&a.$classData.H.mE)}
var RAa=l({mE:0},!1,"scala.meta.tokens.Token$RightBrace",{mE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});dK.prototype.$classData=RAa;function bK(){this.Q=this.u=null;this.E=0}bK.prototype=new m;bK.prototype.constructor=bK;e=bK.prototype;e.U=function(){return"RightBracket"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.Zw&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"]"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("RightBracket",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||
!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("RightBracket",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};var qxa=l({Zw:0},!1,"scala.meta.tokens.Token$RightBracket",{Zw:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
bK.prototype.$classData=qxa;function $J(){this.Q=this.u=null;this.E=0}$J.prototype=new m;$J.prototype.constructor=$J;e=$J.prototype;e.U=function(){return"RightParen"};e.M=function(){return 3};e.w=function(a){if(Nz(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return")"};
e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("RightParen",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("RightParen",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Nz(a){return!!(a&&a.$classData&&a.$classData.H.nE)}
var B4=l({nE:0},!1,"scala.meta.tokens.Token$RightParen",{nE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});$J.prototype.$classData=B4;function fK(){this.Q=this.u=null;this.E=0}fK.prototype=new m;fK.prototype.constructor=fK;e=fK.prototype;e.U=function(){return"Semicolon"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.$w&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return";"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Semicolon",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Semicolon",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};var rxa=l({$w:0},!1,"scala.meta.tokens.Token$Semicolon",{$w:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
fK.prototype.$classData=rxa;function rK(){this.Q=this.u=null;this.E=0}rK.prototype=new m;rK.prototype.constructor=rK;e=rK.prototype;e.U=function(){return"Space"};e.M=function(){return 3};e.w=function(a){if(a&&a.$classData&&a.$classData.H.ax&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return" "};
e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Space",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Space",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({ax:0},!1,"scala.meta.tokens.Token$Space",{ax:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});
function oK(){this.Q=this.u=null;this.E=0}oK.prototype=new m;oK.prototype.constructor=oK;e=oK.prototype;e.U=function(){return"Subtype"};e.M=function(){return 3};e.w=function(a){if(Ux(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 2+this.E|0};e.oa=function(){return"\x3c:"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Subtype",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Subtype",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Ux(a){return!!(a&&a.$classData&&a.$classData.H.oE)}
var uxa=l({oE:0},!1,"scala.meta.tokens.Token$Subtype",{oE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});oK.prototype.$classData=uxa;function pK(){this.Q=this.u=null;this.E=0}pK.prototype=new m;pK.prototype.constructor=pK;e=pK.prototype;e.U=function(){return"Supertype"};e.M=function(){return 3};e.w=function(a){if(Tx(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return 2+this.E|0};e.oa=function(){return"\x3e:"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Supertype",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Supertype",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Tx(a){return!!(a&&a.$classData&&a.$classData.H.pE)}
var txa=l({pE:0},!1,"scala.meta.tokens.Token$Supertype",{pE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});pK.prototype.$classData=txa;function sK(){this.Q=this.u=null;this.E=0}sK.prototype=new m;sK.prototype.constructor=sK;e=sK.prototype;e.U=function(){return"Tab"};e.M=function(){return 3};e.w=function(a){if(GF(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};
e.v=function(){return TF(this)};e.wa=function(){return 1+this.E|0};e.oa=function(){return"\\t"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Tab",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==
a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Tab",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function GF(a){return!!(a&&a.$classData&&a.$classData.H.qE)}
e.$classData=l({qE:0},!1,"scala.meta.tokens.Token$Tab",{qE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function lK(){this.Q=this.u=null;this.E=0}lK.prototype=new m;lK.prototype.constructor=lK;e=lK.prototype;e.U=function(){return"Underscore"};e.M=function(){return 3};e.w=function(a){if(nf(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 1+this.E|0};e.oa=function(){return"_"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Underscore",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Underscore",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function nf(a){return!!(a&&a.$classData&&a.$classData.H.rE)}
e.$classData=l({rE:0},!1,"scala.meta.tokens.Token$Underscore",{rE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function yK(){this.Q=this.u=null;this.Ca=this.E=0}yK.prototype=new m;yK.prototype.constructor=yK;e=yK.prototype;e.U=function(){return"Unquote"};e.M=function(){return 4};e.w=function(a){if(Je(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"unquote"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Unquote",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Unquote",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Je(a){return!!(a&&a.$classData&&a.$classData.H.sE)}
e.$classData=l({sE:0},!1,"scala.meta.tokens.Token$Unquote",{sE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function qK(){this.Q=this.u=null;this.E=0}qK.prototype=new m;qK.prototype.constructor=qK;e=qK.prototype;e.U=function(){return"Viewbound"};e.M=function(){return 3};e.w=function(a){if(QF(a)&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};
e.wa=function(){return 2+this.E|0};e.oa=function(){return"\x3c%"};e.jb=function(){return this.u};
e.Va=function(a,b,c){this.u=a;this.Q=b;this.E=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Viewbound",this)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==
I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Viewbound",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();var a=this.u,b=this.E,c=this.wa();return(new Ms).ib(a,b,c)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function QF(a){return!!(a&&a.$classData&&a.$classData.H.tE)}
e.$classData=l({tE:0},!1,"scala.meta.tokens.Token$Viewbound",{tE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function GK(){this.Q=this.u=null;this.Ca=this.E=0}GK.prototype=new m;GK.prototype.constructor=GK;e=GK.prototype;e.U=function(){return"End"};e.M=function(){return 4};e.w=function(a){if(dw(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"xml end"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("End",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("End",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function dw(a){return!!(a&&a.$classData&&a.$classData.H.uE)}
e.$classData=l({uE:0},!1,"scala.meta.tokens.Token$Xml$End",{uE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function CK(){this.Q=this.u=null;this.Ca=this.E=0;this.pa=null}CK.prototype=new m;CK.prototype.constructor=CK;e=CK.prototype;e.U=function(){return"Part"};e.M=function(){return 5};e.w=function(a){if(Vv(a)&&ns(a)&&5===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;case 4:return this.pa;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"xml part"};e.jb=function(){return this.u};
e.Rg=function(a,b,c,d,f){this.u=a;this.Q=b;this.E=c;this.Ca=d;this.pa=f;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Part",this)];d=A(new B,C());for(var g=0,h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.input.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));
if(null===a||!0!==I(a)){if(null!==a&&(f=a.p(),!1===I(a))){b=J();c=[(new q).a("Part",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.dialect.!\x3d(null)",f,d.t)}throw(new p).e(a);}null!==f?f=(new q).a(!0,F()):(G(),f=(new r).d(["this.value is equal to null"]),a=G().b,f=(new q).a(!1,H(f,a)));if(null===f||!0!==I(f)){if(null!==f&&(a=f.p(),!1===I(f))){b=J();c=[(new q).a("Part",this)];d=A(new B,C());g=0;for(h=c.length|0;g<h;)E(d,c[g]),g=1+g|0;K(b,"this.value.!\x3d(null)",a,d.t)}throw(new p).e(f);
}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Vv(a){return!!(a&&a.$classData&&a.$classData.H.vE)}e.$classData=l({vE:0},!1,"scala.meta.tokens.Token$Xml$Part",{vE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function EK(){this.Q=this.u=null;this.Ca=this.E=0}EK.prototype=new m;EK.prototype.constructor=EK;e=EK.prototype;e.U=function(){return"SpliceEnd"};e.M=function(){return 4};
e.w=function(a){if(bw(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"xml splice end"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceEnd",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceEnd",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function bw(a){return!!(a&&a.$classData&&a.$classData.H.wE)}
e.$classData=l({wE:0},!1,"scala.meta.tokens.Token$Xml$SpliceEnd",{wE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function DK(){this.Q=this.u=null;this.Ca=this.E=0}DK.prototype=new m;DK.prototype.constructor=DK;e=DK.prototype;e.U=function(){return"SpliceStart"};e.M=function(){return 4};e.w=function(a){if(Zv(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"xml splice start"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceStart",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("SpliceStart",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Zv(a){return!!(a&&a.$classData&&a.$classData.H.xE)}
e.$classData=l({xE:0},!1,"scala.meta.tokens.Token$Xml$SpliceStart",{xE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function mJ(){this.Q=this.u=null;this.Ca=this.E=0}mJ.prototype=new m;mJ.prototype.constructor=mJ;e=mJ.prototype;e.U=function(){return"Start"};e.M=function(){return 4};e.w=function(a){if(Mv(a)&&ns(a)&&4===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};
e.W=function(a){switch(a){case 0:return this.u;case 1:return this.Q;case 2:return this.E;case 3:return this.Ca;default:throw(new W).j(""+a);}};e.v=function(){return TF(this)};e.wa=function(){return this.Ca};e.oa=function(){return"xml start"};e.jb=function(){return this.u};
e.Lf=function(a,b,c,d){this.u=a;this.Q=b;this.E=c;this.Ca=d;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.input is equal to null"]),c=G().b,a=(new q).a(!1,H(a,c)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Start",this)];for(var f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.input.!\x3d(null)",b,f.t)}throw(new p).e(a);}null!==b?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.dialect is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===
a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();d=[(new q).a("Start",this)];f=A(new B,C());g=0;for(h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.dialect.!\x3d(null)",b,f.t)}throw(new p).e(a);}return this};e.ja=function(){Ls();return(new Ms).ib(this.u,this.E,this.Ca)};e.ab=function(){return this.E};e.A=function(){return WN(this)};e.L=function(){return Z(this)};function Mv(a){return!!(a&&a.$classData&&a.$classData.H.yE)}
e.$classData=l({yE:0},!1,"scala.meta.tokens.Token$Xml$Start",{yE:1,f:1,rb:1,vb:1,wb:1,$:1,R:1,x:1,l:1,k:1});function H4(){this.bh=null}H4.prototype=new Y3;H4.prototype.constructor=H4;H4.prototype.c=function(){this.bh="Boolean";return this};H4.prototype.xa=function(a){return oa(bc(ic),[a])};H4.prototype.G=function(){return k(ic)};H4.prototype.$classData=l({n1:0},!1,"scala.reflect.ManifestFactory$BooleanManifest$",{n1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var SAa=void 0;
function IN(){SAa||(SAa=(new H4).c());return SAa}function I4(){this.bh=null}I4.prototype=new Y3;I4.prototype.constructor=I4;I4.prototype.c=function(){this.bh="Byte";return this};I4.prototype.xa=function(a){return oa(bc(rc),[a])};I4.prototype.G=function(){return k(rc)};I4.prototype.$classData=l({o1:0},!1,"scala.reflect.ManifestFactory$ByteManifest$",{o1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var TAa=void 0;function BN(){TAa||(TAa=(new I4).c());return TAa}function J4(){this.bh=null}
J4.prototype=new Y3;J4.prototype.constructor=J4;J4.prototype.c=function(){this.bh="Char";return this};J4.prototype.xa=function(a){return oa(bc(jc),[a])};J4.prototype.G=function(){return k(jc)};J4.prototype.$classData=l({p1:0},!1,"scala.reflect.ManifestFactory$CharManifest$",{p1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var UAa=void 0;function DN(){UAa||(UAa=(new J4).c());return UAa}function K4(){this.bh=null}K4.prototype=new Y3;K4.prototype.constructor=K4;
K4.prototype.c=function(){this.bh="Double";return this};K4.prototype.xa=function(a){return oa(bc(Ic),[a])};K4.prototype.G=function(){return k(Ic)};K4.prototype.$classData=l({q1:0},!1,"scala.reflect.ManifestFactory$DoubleManifest$",{q1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var VAa=void 0;function HN(){VAa||(VAa=(new K4).c());return VAa}function L4(){this.bh=null}L4.prototype=new Y3;L4.prototype.constructor=L4;L4.prototype.c=function(){this.bh="Float";return this};
L4.prototype.xa=function(a){return oa(bc(Gc),[a])};L4.prototype.G=function(){return k(Gc)};L4.prototype.$classData=l({r1:0},!1,"scala.reflect.ManifestFactory$FloatManifest$",{r1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var WAa=void 0;function GN(){WAa||(WAa=(new L4).c());return WAa}function M4(){this.bh=null}M4.prototype=new Y3;M4.prototype.constructor=M4;M4.prototype.c=function(){this.bh="Int";return this};M4.prototype.xa=function(a){return oa(bc(yc),[a])};M4.prototype.G=function(){return k(yc)};
M4.prototype.$classData=l({s1:0},!1,"scala.reflect.ManifestFactory$IntManifest$",{s1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var XAa=void 0;function EN(){XAa||(XAa=(new M4).c());return XAa}function N4(){this.bh=null}N4.prototype=new Y3;N4.prototype.constructor=N4;N4.prototype.c=function(){this.bh="Long";return this};N4.prototype.xa=function(a){return oa(bc(zc),[a])};N4.prototype.G=function(){return k(zc)};
N4.prototype.$classData=l({t1:0},!1,"scala.reflect.ManifestFactory$LongManifest$",{t1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var YAa=void 0;function FN(){YAa||(YAa=(new N4).c());return YAa}function O4(){this.Fg=null}O4.prototype=new Pwa;O4.prototype.constructor=O4;function P4(){}P4.prototype=O4.prototype;O4.prototype.w=function(a){return this===a};O4.prototype.v=function(){return this.Fg};O4.prototype.A=function(){return Ia(this)};function Q4(){this.bh=null}Q4.prototype=new Y3;
Q4.prototype.constructor=Q4;Q4.prototype.c=function(){this.bh="Short";return this};Q4.prototype.xa=function(a){return oa(bc(vc),[a])};Q4.prototype.G=function(){return k(vc)};Q4.prototype.$classData=l({x1:0},!1,"scala.reflect.ManifestFactory$ShortManifest$",{x1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var ZAa=void 0;function CN(){ZAa||(ZAa=(new Q4).c());return ZAa}function R4(){this.bh=null}R4.prototype=new Y3;R4.prototype.constructor=R4;R4.prototype.c=function(){this.bh="Unit";return this};
R4.prototype.xa=function(a){return oa(bc(xa),[a])};R4.prototype.G=function(){return k(cc)};R4.prototype.$classData=l({y1:0},!1,"scala.reflect.ManifestFactory$UnitManifest$",{y1:1,Xl:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var $Aa=void 0;function JN(){$Aa||($Aa=(new R4).c());return $Aa}function aBa(a,b){a=a.Jb();for(b=b.Jb();a.fb()&&b.fb();)if(!dj(ej(),a.bb(),b.bb()))return!1;return!a.fb()&&!b.fb()}
function bBa(a,b,c,d){var f=c;c=c+d|0;d=fO(gO(),b);c=c<d?c:d;for(a=a.Jb();f<c&&a.fb();)bQ(gO(),b,f,a.bb()),f=1+f|0}function Vm(a,b,c){c=c.mi(a.Se());a=a.Jb();for(b=b.Jb();a.fb()&&b.fb();)c.ba((new q).a(a.bb(),b.bb()));return c.da()}function CO(){this.Lb=this.Oo=null}CO.prototype=new M0;CO.prototype.constructor=CO;e=CO.prototype;e.bb=function(){return this.Oo.bb()};e.U=function(){return"JIteratorWrapper"};e.M=function(){return 1};
e.w=function(a){return this===a?!0:a&&a.$classData&&a.$classData.H.FE&&a.Lb===this.Lb?this.Oo===a.Oo:!1};e.W=function(a){switch(a){case 0:return this.Oo;default:throw(new W).j(""+a);}};function Uja(a,b,c){a.Oo=c;if(null===b)throw jo(wj(),null);a.Lb=b;return a}e.fb=function(){return this.Oo.fb()};e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({FE:0},!1,"scala.collection.convert.Wrappers$JIteratorWrapper",{FE:1,rh:1,f:1,Dg:1,tb:1,sb:1,R:1,x:1,l:1,k:1});
function S4(){this.sq=this.b=null}S4.prototype=new T2;S4.prototype.constructor=S4;S4.prototype.c=function(){ZU.prototype.c.call(this);T4=this;this.sq=(new gV).c();return this};S4.prototype.Yj=function(){return F()};S4.prototype.ic=function(){return(new ae).c()};S4.prototype.$classData=l({F2:0},!1,"scala.collection.immutable.List$",{F2:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1,l:1,k:1});var T4=void 0;function G(){T4||(T4=(new S4).c());return T4}function U4(){this.b=null}U4.prototype=new T2;
U4.prototype.constructor=U4;U4.prototype.c=function(){ZU.prototype.c.call(this);return this};function cBa(a,b,c,d){var f=b.n();return TU(new UU,f,Rq(function(a,b,c,d){return function(){return Ooa(b.o(),c,d)}}(a,b,c,d)))}U4.prototype.Yj=function(){return VU()};U4.prototype.ic=function(){return(new Y2).c()};U4.prototype.$classData=l({h3:0},!1,"scala.collection.immutable.Stream$",{h3:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1,l:1,k:1});var dBa=void 0;function nN(){dBa||(dBa=(new U4).c());return dBa}
function V4(){this.b=null}V4.prototype=new T2;V4.prototype.constructor=V4;V4.prototype.c=function(){ZU.prototype.c.call(this);return this};V4.prototype.ic=function(){return(new Fd).c()};V4.prototype.$classData=l({A3:0},!1,"scala.collection.mutable.ArrayBuffer$",{A3:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1,l:1,k:1});var eBa=void 0;function CV(){eBa||(eBa=(new V4).c());return eBa}function W4(){this.b=null}W4.prototype=new T2;W4.prototype.constructor=W4;
W4.prototype.c=function(){ZU.prototype.c.call(this);return this};W4.prototype.ic=function(){return bva(new S0,(new ae).c())};W4.prototype.$classData=l({e4:0},!1,"scala.collection.mutable.ListBuffer$",{e4:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1,l:1,k:1});var fBa=void 0;function vu(){fBa||(fBa=(new W4).c());return fBa}function VK(a,b){Q_();a=(new ed).db(a.Vf);sua();var c=(new ed).db(1),d=sua();return(new X4).Up(a,b,c,d)}function Y4(){BQ.call(this);this.Tq=this.tj=null}Y4.prototype=new eva;
Y4.prototype.constructor=Y4;e=Y4.prototype;e.U=function(){return"ElemIn"};e.M=function(){return 2};e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Uy&&this.tj===a.tj){var b=this.Tq;a=a.Tq;return null===b?null===a:b.w(a)}return!1};e.W=function(a){switch(a){case 0:return this.tj;case 1:return this.Tq;default:throw(new W).j(""+a);}};e.v=function(){return gca($o(),this.tj,this.Tq,this.Af)};
function Fia(a,b){var c=new Y4;oQ();c.tj="CharIn";c.Tq=a;fj();a=dca($o(),a);a=(new IL).e(a);BQ.prototype.Kv.call(c,a,0,b);return c}e.A=function(){return WN(this)};e.L=function(){return Z(this)};e.$classData=l({Uy:0},!1,"fastparse.parsers.Intrinsics$ElemIn",{Uy:1,$G:1,Xy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function EQ(){BQ.call(this);this.uo=this.tj=null;this.tq=!1}EQ.prototype=new eva;EQ.prototype.constructor=EQ;e=EQ.prototype;e.U=function(){return"ElemPred"};e.M=function(){return 3};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Vy){if(this.tj===a.tj)var b=this.uo,c=a.uo,b=null===b?null===c:b.w(c);else b=!1;return b?this.tq===a.tq:!1}return!1};e.W=function(a){switch(a){case 0:return this.tj;case 1:return this.uo;case 2:return this.tq;default:throw(new W).j(""+a);}};e.v=function(){return td((new yd).X((new r).d(["","(",")"])),(new r).d([this.tj,this.uo]))};
e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.tj)),a=Y().Gb(a,YN(Y(),this.uo)),a=Y().Gb(a,this.tq?1231:1237);return Y().xd(a,3)};e.L=function(){return Z(this)};e.$classData=l({Vy:0},!1,"fastparse.parsers.Intrinsics$ElemPred",{Vy:1,$G:1,Xy:1,ig:1,f:1,pg:1,jg:1,R:1,x:1,l:1,k:1});function AQ(){BQ.call(this);this.Ko=this.po=null;this.oo=0}AQ.prototype=new Cua;AQ.prototype.constructor=AQ;e=AQ.prototype;e.U=function(){return"ElemsWhileIn"};e.M=function(){return 3};
e.w=function(a){if(this===a)return!0;if(a&&a.$classData&&a.$classData.H.Wy){if(this.po===a.po)var b=this.Ko,c=a.Ko,b=null===b?null===c:b.w(c);else b=!1;return b?this.oo===a.oo:!1}return!1};e.W=function(a){switch(a){case 0:return this.po;case 1:return this.Ko;case 2:return this.oo;default:throw(new W).j(""+a);}};e.v=function(){return gca($o(),this.po,this.Ko,this.Af)};e.A=function(){var a=-889275714,a=Y().Gb(a,YN(Y(),this.po)),a=Y().Gb(a,YN(Y(),this.Ko)),a=Y().Gb(a,this.oo);return Y().xd(a,3)};
e.Dd=function(a,b){var c;c=b;for(var d=a.u;;){if(e1(d,c))var f=65535&(d.Ve.charCodeAt(c)|0),f=Dua(this,(new ed).db(f));else f=!1;if(f)c=1+c|0;else break}(c-b|0)<this.oo?c=jd(this,a.Zj,c,null,!1):(a=a.ji,b=id(),c=sd(a,void 0,c,b,!1));return c};e.L=function(){return Z(this)};e.$classData=l({Wy:0},!1,"fastparse.parsers.Intrinsics$ElemsWhileIn",{Wy:1,Xy:1,ig:1,f:1,pg:1,jg:1,m5:1,R:1,x:1,l:1,k:1});function Z4(){this.Nv=null}Z4.prototype=new qva;Z4.prototype.constructor=Z4;function gBa(){}
e=gBa.prototype=Z4.prototype;e.c=function(){this.Nv=(new b3).c();return this};e.iA=function(a){var b=mR();a=a.Jl();b=OO(BO(b,a).Wd);for(a=!0;a&&b.fb();)a=b.bb(),a=this.Ac(a);return a};e.Za=function(){return this.Zp().Za()};e.Ac=function(a){return this.Zp().Ac((new NM).e(a))};e.Zp=function(){return this.Nv};e.Rk=function(a){return this.Zp().Rk((new NM).e(a))};e.Jl=function(){var a=new rR;if(null===this)throw jo(wj(),null);a.r=this;a.Uv=this.Zp().$u().Jb();a.lo=S();return a};
e.$classData=l({GB:0},!1,"java.util.HashSet",{GB:1,FB:1,EB:1,f:1,aw:1,BB:1,HB:1,dg:1,Mf:1,l:1,k:1});function $4(){this.Kc=this.uh=this.zh=this.s=this.aa=this.m=null}$4.prototype=new m;$4.prototype.constructor=$4;e=$4.prototype;e.Oa=function(){G();var a=(new r).d(["pat","cond","body"]),b=G().b;return H(a,b)};e.U=function(){return"Case"};e.Na=function(){return this};e.M=function(){return 3};function fga(a,b,c){var d=new $4;d.m=a;d.aa=b;d.s=c;d.zh=null;d.uh=null;d.Kc=null;return d}
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Re();case 1:return this.zm();case 2:return this.Nb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return fga(a,b,d)};e.v=function(){return to(uo(),this)};e.zm=function(){if(null===this.uh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CaseImpl.cond");var a=this.m.zm();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.uh=a}return this.uh};
e.Re=function(){if(null===this.zh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CaseImpl.pat");var a=this.m.Re(),b=this.m.Re();this.zh=a.y(b,this,null,a.s)}return this.zh};e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CaseImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Re()]),b=G().b,a=H(a,b),b=this.zm().lb(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Nb()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({WK:0},!1,"scala.meta.Case$CaseImpl",{WK:1,f:1,qt:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Gn(a){return!!(a&&a.$classData&&a.$classData.H.ZK)}function vn(a){return!!(a&&a.$classData&&a.$classData.H.nL)}function wn(a){return!!(a&&a.$classData&&a.$classData.H.rL)}
function Nk(a){return!!(a&&a.$classData&&a.$classData.H.NL)}function Sk(a){return!!(a&&a.$classData&&a.$classData.H.RL)}function Ln(a){return!!(a&&a.$classData&&a.$classData.H.pM)}function Mn(a){return!!(a&&a.$classData&&a.$classData.H.uM)}function On(a){return!!(a&&a.$classData&&a.$classData.H.xM)}function Pn(a){return!!(a&&a.$classData&&a.$classData.H.AM)}function a5(){this.Zo=this.Ah=this.s=this.aa=this.m=null}a5.prototype=new m;a5.prototype.constructor=a5;e=a5.prototype;
e.Oa=function(){G();var a=(new r).d(["ref","importees"]),b=G().b;return H(a,b)};e.U=function(){return"Importer"};e.Na=function(){return this};e.M=function(){return 2};function zqa(a,b,c){var d=new a5;d.m=a;d.aa=b;d.s=c;d.Ah=null;d.Zo=null;return d}e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ve();case 1:return this.Tk();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return zqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.ve=function(){if(null===this.Ah){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporterImpl.ref");var a=this.m.ve(),b=this.m.ve();this.Ah=a.y(b,this,null,a.s)}return this.Ah};e.A=function(){return Ia(this)};
e.Tk=function(){if(null===this.Zo){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporterImpl.importees");var a=this.m.Tk(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Zo=b}return this.Zo};
e.Ma=function(){G();var a=(new r).d([this.ve()]),b=G().b,a=H(a,b),b=this.Tk(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({EM:0},!1,"scala.meta.Importer$ImporterImpl",{EM:1,f:1,st:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Pl(a){return!!(a&&a.$classData&&a.$classData.H.oO)}function dm(a){return!!(a&&a.$classData&&a.$classData.H.sO)}function b5(){this.ld=this.s=this.aa=this.m=null}b5.prototype=new m;b5.prototype.constructor=b5;e=b5.prototype;
e.U=function(){return"Source"};e.Oa=function(){G();var a=(new r).d(["stats"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Pra(a,b,d)};e.W=function(a){switch(a){case 0:return this.ub();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function Pra(a,b,c){var d=new b5;d.m=a;d.aa=b;d.s=c;d.ld=null;return d}e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.ub(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing SourceImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({FP:0},!1,"scala.meta.Source$SourceImpl",{FP:1,f:1,DP:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function c5(){this.ld=this.dp=this.ap=this.Wo=this.s=this.aa=this.m=null}c5.prototype=new m;c5.prototype.constructor=c5;e=c5.prototype;e.Oa=function(){G();var a=(new r).d(["early","inits","self","stats"]),b=G().b;return H(a,b)};e.U=function(){return"Template"};e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Si();case 1:return this.Xi();case 2:return this.Zg();case 3:return this.ub();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Tra(a,b,d)};
e.Si=function(){if(null===this.Wo){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TemplateImpl.early");var a=this.m.Si(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Wo=b}return this.Wo};e.v=function(){return to(uo(),this)};
e.Xi=function(){if(null===this.ap){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TemplateImpl.inits");var a=this.m.Xi(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ap=b}return this.ap};
function Tra(a,b,c){var d=new c5;d.m=a;d.aa=b;d.s=c;d.Wo=null;d.ap=null;d.dp=null;d.ld=null;return d}e.Zg=function(){if(null===this.dp){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TemplateImpl.self");var a=this.m.Zg(),b=this.m.Zg();this.dp=a.y(b,this,null,a.s)}return this.dp};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Si(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.Xi(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Zg()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.ub();c=G();a=a.ma(b,c.b);b=F();c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TemplateImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({NP:0},!1,"scala.meta.Template$TemplateImpl",{NP:1,f:1,xt:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function em(a){return!!(a&&a.$classData&&a.$classData.H.PP)}function Zk(a){return!!(a&&a.$classData&&a.$classData.H.SP)}function $k(a){return!!(a&&a.$classData&&a.$classData.H.WP)}function fm(a){return!!(a&&a.$classData&&a.$classData.H.$P)}function im(a){return!!(a&&a.$classData&&a.$classData.H.gQ)}function jm(a){return!!(a&&a.$classData&&a.$classData.H.jQ)}
function km(a){return!!(a&&a.$classData&&a.$classData.H.nQ)}function lm(a){return!!(a&&a.$classData&&a.$classData.H.qQ)}function mm(a){return!!(a&&a.$classData&&a.$classData.H.tQ)}function pm(a){return!!(a&&a.$classData&&a.$classData.H.wQ)}function qm(a){return!!(a&&a.$classData&&a.$classData.H.zQ)}function rm(a){return!!(a&&a.$classData&&a.$classData.H.CQ)}function sm(a){return!!(a&&a.$classData&&a.$classData.H.FQ)}function ym(a){return!!(a&&a.$classData&&a.$classData.H.IQ)}
function Am(a){return!!(a&&a.$classData&&a.$classData.H.MQ)}function Bm(a){return!!(a&&a.$classData&&a.$classData.H.VQ)}function Cm(a){return!!(a&&a.$classData&&a.$classData.H.YQ)}function Dm(a){return!!(a&&a.$classData&&a.$classData.H.gR)}function Em(a){return!!(a&&a.$classData&&a.$classData.H.jR)}function Fm(a){return!!(a&&a.$classData&&a.$classData.H.vR)}function Gm(a){return!!(a&&a.$classData&&a.$classData.H.zR)}function Mm(a){return!!(a&&a.$classData&&a.$classData.H.NR)}
function Nm(a){return!!(a&&a.$classData&&a.$classData.H.QR)}function Pm(a){return!!(a&&a.$classData&&a.$classData.H.TR)}function Rm(a){return!!(a&&a.$classData&&a.$classData.H.WR)}function Sm(a){return!!(a&&a.$classData&&a.$classData.H.ZR)}function Tm(a){return!!(a&&a.$classData&&a.$classData.H.bS)}function d5(){this.Yo=this.bp=this.s=this.aa=this.m=null}d5.prototype=new m;d5.prototype.constructor=d5;e=d5.prototype;e.Oa=function(){G();var a=(new r).d(["lo","hi"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Bounds"};
e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return nl(this);case 1:return ol(this);default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return jA(a,b,d)};e.v=function(){return to(uo(),this)};function nl(a){if(null===a.bp){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TypeBoundsImpl.lo");var b=nl(a.m);b.g()?b=S():(b=b.q(),b=(new T).e(b.y(b,a,null,b.s)));a.bp=b}return a.bp}
function jA(a,b,c){var d=new d5;d.m=a;d.aa=b;d.s=c;d.bp=null;d.Yo=null;return d}e.A=function(){return Ia(this)};function ol(a){if(null===a.Yo){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TypeBoundsImpl.hi");var b=ol(a.m);b.g()?b=S():(b=b.q(),b=(new T).e(b.y(b,a,null,b.s)));a.Yo=b}return a.Yo}e.Ma=function(){var a=F(),b=nl(this).lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=ol(this).lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.$classData=l({wS:0},!1,"scala.meta.Type$Bounds$TypeBoundsImpl",{wS:1,f:1,uS:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function CY(){this.r=null}CY.prototype=new m;CY.prototype.constructor=CY;e=CY.prototype;e.U=function(){return"Path"};e.M=function(){return 0};e.zf=function(){return 6};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return"Path"};e.Vk=function(a){if(null===a)throw jo(wj(),null);this.r=a;return this};
e.pf=function(){G();var a=(new r).d(["Type","Term","Pat"]),b=G().b;return H(a,b)};e.A=function(){return 2480197};e.L=function(){return Z(this)};e.$classData=l({OY:0},!1,"scala.meta.internal.prettyprinters.TreeSyntax$syntaxInstances$2$SyntacticGroup$Path$",{OY:1,f:1,Vl:1,Pf:1,$:1,R:1,x:1,l:1,k:1,Ul:1,un:1});function KN(){this.Fg=null}KN.prototype=new P4;KN.prototype.constructor=KN;KN.prototype.c=function(){this.Fg="Any";S();F();k(Ab);return this};KN.prototype.xa=function(a){return oa(bc(Ab),[a])};
KN.prototype.G=function(){return k(Ab)};KN.prototype.$classData=l({l1:0},!1,"scala.reflect.ManifestFactory$AnyManifest$",{l1:1,Ct:1,Bt:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var Hja=void 0;function LN(){this.Fg=null}LN.prototype=new P4;LN.prototype.constructor=LN;LN.prototype.c=function(){this.Fg="AnyVal";S();F();k(Ab);return this};LN.prototype.xa=function(a){return oa(bc(Ab),[a])};LN.prototype.G=function(){return k(Ab)};
LN.prototype.$classData=l({m1:0},!1,"scala.reflect.ManifestFactory$AnyValManifest$",{m1:1,Ct:1,Bt:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var Ija=void 0;function e5(){this.Fg=null}e5.prototype=new P4;e5.prototype.constructor=e5;e5.prototype.c=function(){this.Fg="Nothing";S();F();k(A_);return this};e5.prototype.xa=function(a){return oa(bc(Ab),[a])};e5.prototype.G=function(){return k(A_)};
e5.prototype.$classData=l({u1:0},!1,"scala.reflect.ManifestFactory$NothingManifest$",{u1:1,Ct:1,Bt:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var hBa=void 0;function Jja(){hBa||(hBa=(new e5).c());return hBa}function f5(){this.Fg=null}f5.prototype=new P4;f5.prototype.constructor=f5;f5.prototype.c=function(){this.Fg="Null";S();F();k(XP);return this};f5.prototype.xa=function(a){return oa(bc(Ab),[a])};f5.prototype.G=function(){return k(XP)};
f5.prototype.$classData=l({v1:0},!1,"scala.reflect.ManifestFactory$NullManifest$",{v1:1,Ct:1,Bt:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var iBa=void 0;function Kja(){iBa||(iBa=(new f5).c());return iBa}function g5(){this.Fg=null}g5.prototype=new P4;g5.prototype.constructor=g5;g5.prototype.c=function(){this.Fg="Object";S();F();k(Ab);return this};g5.prototype.xa=function(a){return oa(bc(Ab),[a])};g5.prototype.G=function(){return k(Ab)};
g5.prototype.$classData=l({w1:0},!1,"scala.reflect.ManifestFactory$ObjectManifest$",{w1:1,Ct:1,Bt:1,f:1,dj:1,ya:1,Aa:1,za:1,l:1,k:1,x:1});var jBa=void 0;function wI(){jBa||(jBa=(new g5).c());return jBa}function h5(){this.Ci=this.b=null}h5.prototype=new o3;h5.prototype.constructor=h5;h5.prototype.c=function(){ZU.prototype.c.call(this);i5=this;this.Ci=(new Z2).Be(0,0,0);return this};h5.prototype.Yj=function(){return this.Ci};h5.prototype.ic=function(){return(new Hk).c()};
h5.prototype.$classData=l({t3:0},!1,"scala.collection.immutable.Vector$",{t3:1,SE:1,hk:1,gk:1,fi:1,Sf:1,f:1,hi:1,Tf:1,l:1,k:1});var i5=void 0;function uk(){i5||(i5=(new h5).c());return i5}function j5(){this.fB=this.Nv=null}j5.prototype=new gBa;j5.prototype.constructor=j5;j5.prototype.c=function(){Z4.prototype.c.call(this);this.fB=(new x4).c();return this};j5.prototype.Zp=function(){return this.fB};
j5.prototype.$classData=l({IJ:0},!1,"java.util.LinkedHashSet",{IJ:1,GB:1,FB:1,EB:1,f:1,aw:1,BB:1,HB:1,dg:1,Mf:1,l:1,k:1});function L_(){}L_.prototype=new m;L_.prototype.constructor=L_;e=L_.prototype;e.c=function(){return this};e.Nl=function(a,b){return((a|0)-(b|0)|0)<<24>>24};e.Ii=function(a,b){return((a|0)+(b|0)|0)<<24>>24};e.bm=function(a,b){return fa(a|0,b|0)<<24>>24};e.mn=function(a,b){return((a|0)/(b|0)|0)<<24>>24};e.Ie=function(a,b){return(a|0)-(b|0)|0};e.dm=function(a){return a|0};
e.Yh=function(a){return a<<24>>24};e.$classData=l({BK:0},!1,"scala.math.Numeric$ByteIsIntegral$",{BK:1,f:1,k6:1,ot:1,pt:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1,KK:1});var qua=void 0;function k5(){}k5.prototype=new m;k5.prototype.constructor=k5;e=k5.prototype;e.c=function(){return this};e.Nl=function(a,b){return(new ed).db(65535&((null===a?0:a.pa)-(null===b?0:b.pa)|0))};e.Ii=function(a,b){return(new ed).db(65535&((null===a?0:a.pa)+(null===b?0:b.pa)|0))};
e.bm=function(a,b){a=65535&fa(null===a?0:a.pa,null===b?0:b.pa);return(new ed).db(a)};e.mn=function(a,b){return(new ed).db(65535&((null===a?0:a.pa)/(null===b?0:b.pa)|0))};e.Ie=function(a,b){return(null===a?0:a.pa)-(null===b?0:b.pa)|0};e.dm=function(a){return null===a?0:a.pa};e.Yh=function(a){return(new ed).db(65535&a)};e.$classData=l({CK:0},!1,"scala.math.Numeric$CharIsIntegral$",{CK:1,f:1,l6:1,ot:1,pt:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1,MK:1});var kBa=void 0;
function sua(){kBa||(kBa=(new k5).c());return kBa}function H_(){}H_.prototype=new m;H_.prototype.constructor=H_;e=H_.prototype;e.c=function(){return this};e.Nl=function(a,b){return(a|0)-(b|0)|0};e.Ii=function(a,b){return(a|0)+(b|0)|0};e.bm=function(a,b){return fa(a|0,b|0)};e.mn=function(a,b){return(a|0)/(b|0)|0};e.Ie=function(a,b){a|=0;b|=0;return a===b?0:a<b?-1:1};e.dm=function(a){return a|0};e.Yh=function(a){return a};
e.$classData=l({DK:0},!1,"scala.math.Numeric$IntIsIntegral$",{DK:1,f:1,m6:1,ot:1,pt:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1,OK:1});var mua=void 0;function N_(){}N_.prototype=new m;N_.prototype.constructor=N_;e=N_.prototype;e.c=function(){return this};e.Nl=function(a,b){var c=Ya(a);a=c.Ra;var c=c.Ya,d=Ya(b);b=d.Ra;d=d.Ya;c=(new Ep).K(a,c);b=(new Ep).K(b,d);a=c.Ra;c=c.Ya;d=b.Ya;b=a-b.Ra|0;return(new Ep).K(b,(-2147483648^b)>(-2147483648^a)?-1+(c-d|0)|0:c-d|0)};
e.Ii=function(a,b){var c=Ya(a);a=c.Ra;var c=c.Ya,d=Ya(b);b=d.Ra;d=d.Ya;c=(new Ep).K(a,c);b=(new Ep).K(b,d);a=c.Ra;c=c.Ya;d=b.Ya;b=a+b.Ra|0;return(new Ep).K(b,(-2147483648^b)<(-2147483648^a)?1+(c+d|0)|0:c+d|0)};
e.bm=function(a,b){var c=Ya(a);a=c.Ra;var c=c.Ya,d=Ya(b);b=d.Ra;d=d.Ya;a=(new Ep).K(a,c);c=(new Ep).K(b,d);b=a.Ra;var d=c.Ra,f=65535&b,g=b>>>16|0,h=65535&d,n=d>>>16|0,u=fa(f,h),h=fa(g,h),w=fa(f,n),f=u+((h+w|0)<<16)|0,u=(u>>>16|0)+w|0;a=(((fa(b,c.Ya)+fa(a.Ya,d)|0)+fa(g,n)|0)+(u>>>16|0)|0)+(((65535&u)+h|0)>>>16|0)|0;return(new Ep).K(f,a)};e.mn=function(a,b){var c=Ya(a);a=c.Ra;var c=c.Ya,d=Ya(b);b=d.Ra;d=d.Ya;a=(new Ep).K(a,c);b=(new Ep).K(b,d);c=ab();a=Fp(c,a.Ra,a.Ya,b.Ra,b.Ya);return(new Ep).K(a,c.dd)};
e.Ie=function(a,b){var c=Ya(a);a=c.Ra;var c=c.Ya,d=Ya(b);b=d.Ra;d=d.Ya;ab();return c===d?a===b?0:(-2147483648^a)<(-2147483648^b)?-1:1:c<d?-1:1};e.dm=function(a){a=Ya(a);return(new Ep).K(a.Ra,a.Ya).Ra};e.Yh=function(a){return(new Ep).K(a,a>>31)};e.$classData=l({EK:0},!1,"scala.math.Numeric$LongIsIntegral$",{EK:1,f:1,n6:1,ot:1,pt:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1,QK:1});var tua=void 0;function J_(){}J_.prototype=new m;J_.prototype.constructor=J_;e=J_.prototype;e.c=function(){return this};
e.Nl=function(a,b){return((a|0)-(b|0)|0)<<16>>16};e.Ii=function(a,b){return((a|0)+(b|0)|0)<<16>>16};e.bm=function(a,b){return fa(a|0,b|0)<<16>>16};e.mn=function(a,b){return((a|0)/(b|0)|0)<<16>>16};e.Ie=function(a,b){return(a|0)-(b|0)|0};e.dm=function(a){return a|0};e.Yh=function(a){return a<<16>>16};e.$classData=l({FK:0},!1,"scala.math.Numeric$ShortIsIntegral$",{FK:1,f:1,p6:1,ot:1,pt:1,xj:1,sj:1,yj:1,wj:1,l:1,k:1,SK:1});var oua=void 0;function Hn(a){return!!(a&&a.$classData&&a.$classData.H.cL)}
function l5(){this.Kb=this.zh=this.s=this.aa=this.m=null}l5.prototype=new m;l5.prototype.constructor=l5;e=l5.prototype;e.Oa=function(){G();var a=(new r).d(["pat","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Enumerator.Generator"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Re();case 1:return this.Ld();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Jga(a,b,d)};
e.v=function(){return to(uo(),this)};function Jga(a,b,c){var d=new l5;d.m=a;d.aa=b;d.s=c;d.zh=null;d.Kb=null;return d}e.Re=function(){if(null===this.zh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing EnumeratorGeneratorImpl.pat");var a=this.m.Re(),b=this.m.Re();this.zh=a.y(b,this,null,a.s)}return this.zh};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Re(),this.Ld()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.Ld=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing EnumeratorGeneratorImpl.rhs");var a=this.m.Ld(),b=this.m.Ld();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.$classData=l({$L:0},!1,"scala.meta.Enumerator$Generator$EnumeratorGeneratorImpl",{$L:1,f:1,YL:1,zo:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function m5(){this.uh=this.s=this.aa=this.m=null}m5.prototype=new m;m5.prototype.constructor=m5;e=m5.prototype;e.U=function(){return"Enumerator.Guard"};
e.Oa=function(){G();var a=(new r).d(["cond"]),b=G().b;return H(a,b)};e.Na=function(){return this};function rqa(a,b,c){var d=new m5;d.m=a;d.aa=b;d.s=c;d.uh=null;return d}e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return rqa(a,b,d)};e.W=function(a){switch(a){case 0:return this.oi();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.oi=function(){if(null===this.uh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing EnumeratorGuardImpl.cond");var a=this.m.oi(),b=this.m.oi();this.uh=a.y(b,this,null,a.s)}return this.uh};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.oi()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({dM:0},!1,"scala.meta.Enumerator$Guard$EnumeratorGuardImpl",{dM:1,f:1,bM:1,zo:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function QR(a){return!!(a&&a.$classData&&a.$classData.H.eM)}function n5(){this.Kb=this.zh=this.s=this.aa=this.m=null}n5.prototype=new m;n5.prototype.constructor=n5;e=n5.prototype;e.Oa=function(){G();var a=(new r).d(["pat","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Enumerator.Val"};e.Na=function(){return this};function Hga(a,b,c){var d=new n5;d.m=a;d.aa=b;d.s=c;d.zh=null;d.Kb=null;return d}e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Re();case 1:return this.Ld();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Hga(a,b,d)};e.v=function(){return to(uo(),this)};e.Re=function(){if(null===this.zh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing EnumeratorValImpl.pat");var a=this.m.Re(),b=this.m.Re();this.zh=a.y(b,this,null,a.s)}return this.zh};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Re(),this.Ld()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.Ld=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing EnumeratorValImpl.rhs");var a=this.m.Ld(),b=this.m.Ld();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.$classData=l({kM:0},!1,"scala.meta.Enumerator$Val$EnumeratorValImpl",{kM:1,f:1,iM:1,zo:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function o5(){this.$o=this.s=this.aa=this.m=null}o5.prototype=new m;o5.prototype.constructor=o5;e=o5.prototype;e.U=function(){return"Import"};e.Oa=function(){G();var a=(new r).d(["importers"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return uqa(a,b,d)};e.W=function(a){switch(a){case 0:return Kn(this);default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
function uqa(a,b,c){var d=new o5;d.m=a;d.aa=b;d.s=c;d.$o=null;return d}
function Kn(a){if(null===a.$o){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing ImportImpl.importers");var b=Kn(a.m),c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b)if(b===F())c=F();else{for(var d=b.n(),f=d=U(new V,c(d),F()),b=b.o();b!==F();)var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g,b=b.o();c=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();c=d.da()}a.$o=c}return a.$o}e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=Kn(this),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({oM:0},!1,"scala.meta.Import$ImportImpl",{oM:1,f:1,mM:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function p5(){this.To=this.Pa=this.qc=this.s=this.aa=this.m=null}p5.prototype=new m;p5.prototype.constructor=p5;e=p5.prototype;e.Oa=function(){G();var a=(new r).d(["tpe","name","argss"]),b=G().b;return H(a,b)};e.U=function(){return"Init"};e.Na=function(){return this};
e.M=function(){return 3};function Dqa(a,b,c){var d=new p5;d.m=a;d.aa=b;d.s=c;d.qc=null;d.Pa=null;d.To=null;return d}e.w=function(a){return this===a};e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing InitImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};e.W=function(a){switch(a){case 0:return this.Db();case 1:return this.xb();case 2:return this.tl();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){if(null!==c){var f;fL();var g=v();f=this.Db();g=y(z(g,f),fia());g=(new ur).qj(g);f=v();f=vr(g,y(z(f,b),qla())&&"init"===c);if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();var g=(new r).d(["parentCheckOk is false"]),n=G().b,g=(new q).a(!1,H(g,n))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",h),(new q).a("InitImpl",this),(new q).a("destination",c)];d=A(new B,C());f=0;for(h=c.length|
0;f<h;)E(d,c[f]),f=1+f|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",a,d.t)}throw(new p).e(g);}}}return Dqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.tl=function(){if(null===this.To){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing InitImpl.argss");var a=this.m.tl(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;if(c===G().b)if(a===
F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.To=b}return this.To};e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing InitImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Db(),this.xb()]),b=G().b,a=H(a,b),c=this.tl();G();for(b=(new ae).c();!c.g();){var d=c.n().dc();Ll(b,d);c=c.o()}b=b.lb();c=G();a=a.ma(b,c.b);b=F();c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({IM:0},!1,"scala.meta.Init$InitImpl",{IM:1,f:1,tt:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function q5(){this.s=this.aa=this.m=null}q5.prototype=new m;q5.prototype.constructor=q5;e=q5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Abstract"};
e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Pqa(a,b,d)};e.v=function(){return to(uo(),this)};function Pqa(a,b,c){var d=new q5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({rN:0},!1,"scala.meta.Mod$Abstract$ModAbstractImpl",{rN:1,f:1,ww:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function r5(){this.xh=this.s=this.aa=this.m=null}r5.prototype=new m;r5.prototype.constructor=r5;e=r5.prototype;e.U=function(){return"Mod.Annot"};e.Oa=function(){G();var a=(new r).d(["init"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Gda(a,b,d)};e.W=function(a){switch(a){case 0:return this.ff();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
function Gda(a,b,c){var d=new r5;d.m=a;d.aa=b;d.s=c;d.xh=null;return d}e.ff=function(){if(null===this.xh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ModAnnotImpl.init");var a=this.m.ff(),b=this.m.ff();this.xh=a.y(b,this,null,a.s)}return this.xh};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ff()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({uN:0},!1,"scala.meta.Mod$Annot$ModAnnotImpl",{uN:1,f:1,vt:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function s5(){this.s=this.aa=this.m=null}s5.prototype=new m;s5.prototype.constructor=s5;e=s5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Case"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Uqa(a,b,d)};e.v=function(){return to(uo(),this)};
function Uqa(a,b,c){var d=new s5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({zN:0},!1,"scala.meta.Mod$Case$ModCaseImpl",{zN:1,f:1,xN:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function t5(){this.s=this.aa=this.m=null}t5.prototype=new m;t5.prototype.constructor=t5;e=t5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Contravariant"};e.Na=function(){return this};e.M=function(){return 0};
e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Vga(a,b,d)};e.v=function(){return to(uo(),this)};function Vga(a,b,c){var d=new t5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({DN:0},!1,"scala.meta.Mod$Contravariant$ModContravariantImpl",{DN:1,f:1,BN:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function u5(){this.s=this.aa=this.m=null}u5.prototype=new m;
u5.prototype.constructor=u5;e=u5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Covariant"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Tga(a,b,d)};e.v=function(){return to(uo(),this)};function Tga(a,b,c){var d=new u5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
e.$classData=l({HN:0},!1,"scala.meta.Mod$Covariant$ModCovariantImpl",{HN:1,f:1,FN:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function v5(){this.s=this.aa=this.m=null}v5.prototype=new m;v5.prototype.constructor=v5;e=v5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Final"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Wqa(a,b,d)};e.v=function(){return to(uo(),this)};
function Wqa(a,b,c){var d=new v5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({KN:0},!1,"scala.meta.Mod$Final$ModFinalImpl",{KN:1,f:1,xw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function w5(){this.s=this.aa=this.m=null}w5.prototype=new m;w5.prototype.constructor=w5;e=w5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Implicit"};e.Na=function(){return this};e.M=function(){return 0};
e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Yqa(a,b,d)};e.v=function(){return to(uo(),this)};function Yqa(a,b,c){var d=new w5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({NN:0},!1,"scala.meta.Mod$Implicit$ModImplicitImpl",{NN:1,f:1,yw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function x5(){this.s=this.aa=this.m=null}x5.prototype=new m;
x5.prototype.constructor=x5;e=x5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Inline"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Qea(a,b,d)};e.v=function(){return to(uo(),this)};function Qea(a,b,c){var d=new x5;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
e.$classData=l({RN:0},!1,"scala.meta.Mod$Inline$ModInlineImpl",{RN:1,f:1,PN:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function y5(){this.s=this.aa=this.m=null}y5.prototype=new m;y5.prototype.constructor=y5;e=y5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Lazy"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Nea(a,b,d)};
function Nea(a,b,c){var d=new y5;d.m=a;d.aa=b;d.s=c;return d}e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({TN:0},!1,"scala.meta.Mod$Lazy$ModLazyImpl",{TN:1,f:1,zw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function z5(){this.s=this.aa=this.m=null}z5.prototype=new m;z5.prototype.constructor=z5;e=z5.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Override"};e.Na=function(){return this};
e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return $qa(a,b,d)};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};function $qa(a,b,c){var d=new z5;d.m=a;d.aa=b;d.s=c;return d}e.$classData=l({WN:0},!1,"scala.meta.Mod$Override$ModOverrideImpl",{WN:1,f:1,Aw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function A5(){this.Sj=this.s=this.aa=this.m=null}
A5.prototype=new m;A5.prototype.constructor=A5;e=A5.prototype;e.U=function(){return"Mod.Private"};e.Oa=function(){G();var a=(new r).d(["within"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return ara(a,b,d)};e.W=function(a){switch(a){case 0:return this.gg();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};
e.gg=function(){if(null===this.Sj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ModPrivateImpl.within");var a=this.m.gg(),b=this.m.gg();this.Sj=a.y(b,this,null,a.s)}return this.Sj};e.Ma=function(){G();var a=(new r).d([this.gg()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};function ara(a,b,c){var d=new A5;d.m=a;d.aa=b;d.s=c;d.Sj=null;return d}
e.$classData=l({ZN:0},!1,"scala.meta.Mod$Private$ModPrivateImpl",{ZN:1,f:1,Bw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function O5(){this.Sj=this.s=this.aa=this.m=null}O5.prototype=new m;O5.prototype.constructor=O5;e=O5.prototype;e.U=function(){return"Mod.Protected"};e.Oa=function(){G();var a=(new r).d(["within"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return cra(a,b,d)};
e.W=function(a){switch(a){case 0:return this.gg();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function cra(a,b,c){var d=new O5;d.m=a;d.aa=b;d.s=c;d.Sj=null;return d}e.A=function(){return Ia(this)};e.gg=function(){if(null===this.Sj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ModProtectedImpl.within");var a=this.m.gg(),b=this.m.gg();this.Sj=a.y(b,this,null,a.s)}return this.Sj};
e.Ma=function(){G();var a=(new r).d([this.gg()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({bO:0},!1,"scala.meta.Mod$Protected$ModProtectedImpl",{bO:1,f:1,Cw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Az(a){return!!(a&&a.$classData&&a.$classData.H.DC)}function d6(){this.s=this.aa=this.m=null}d6.prototype=new m;d6.prototype.constructor=d6;e=d6.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.Sealed"};e.Na=function(){return this};e.M=function(){return 0};
e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return vy(a,b,d)};e.v=function(){return to(uo(),this)};function vy(a,b,c){var d=new d6;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({hO:0},!1,"scala.meta.Mod$Sealed$ModSealedImpl",{hO:1,f:1,Dw:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function e6(){this.s=this.aa=this.m=null}e6.prototype=new m;
e6.prototype.constructor=e6;function $fa(a,b,c){var d=new e6;d.m=a;d.aa=b;d.s=c;return d}e=e6.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.ValParam"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return $fa(a,b,d)};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
e.$classData=l({kO:0},!1,"scala.meta.Mod$ValParam$ModValParamImpl",{kO:1,f:1,EC:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function l6(){this.s=this.aa=this.m=null}l6.prototype=new m;l6.prototype.constructor=l6;e=l6.prototype;e.Oa=function(){return F()};e.U=function(){return"Mod.VarParam"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return bga(a,b,d)};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};
e.Ma=function(){return F()};e.L=function(){return Z(this)};function bga(a,b,c){var d=new l6;d.m=a;d.aa=b;d.s=c;return d}e.$classData=l({mO:0},!1,"scala.meta.Mod$VarParam$ModVarParamImpl",{mO:1,f:1,FC:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function m6(){this.Kb=this.pc=this.s=this.aa=this.m=null}m6.prototype=new m;m6.prototype.constructor=m6;e=m6.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.Alternative"};e.Na=function(){return this};
e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Vd();case 1:return this.ci();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return zha(a,b,d)};e.v=function(){return to(uo(),this)};e.ci=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatAlternativeImpl.rhs");var a=this.m.ci(),b=this.m.ci();this.Kb=a.y(b,this,null,a.s)}return this.Kb};
e.Vd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatAlternativeImpl.lhs");var a=this.m.Vd(),b=this.m.Vd();this.pc=a.y(b,this,null,a.s)}return this.pc};function zha(a,b,c){var d=new m6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Vd(),this.ci()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({CO:0},!1,"scala.meta.Pat$Alternative$PatAlternativeImpl",{CO:1,f:1,AO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function n6(){this.Kb=this.pc=this.s=this.aa=this.m=null}n6.prototype=new m;n6.prototype.constructor=n6;e=n6.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.Bind"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Vd();case 1:return this.ci();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return ora(a,b,d)};e.v=function(){return to(uo(),this)};e.ci=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatBindImpl.rhs");var a=this.m.ci(),b=this.m.ci();this.Kb=a.y(b,this,null,a.s)}return this.Kb};
e.Vd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatBindImpl.lhs");var a=this.m.Vd(),b=this.m.Vd();this.pc=a.y(b,this,null,a.s)}return this.pc};function ora(a,b,c){var d=new n6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Vd(),this.ci()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({FO:0},!1,"scala.meta.Pat$Bind$PatBindImpl",{FO:1,f:1,DO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function o6(){this.fc=this.vh=this.s=this.aa=this.m=null}o6.prototype=new m;o6.prototype.constructor=o6;e=o6.prototype;e.Oa=function(){G();var a=(new r).d(["fun","args"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.Extract"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.Ae=function(){if(null===this.vh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatExtractImpl.fun");var a=this.m.Ae(),b=this.m.Ae();this.vh=a.y(b,this,null,a.s)}return this.vh};e.W=function(a){switch(a){case 0:return this.Ae();case 1:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return qra(a,b,d)};e.v=function(){return to(uo(),this)};function qra(a,b,c){var d=new o6;d.m=a;d.aa=b;d.s=c;d.vh=null;d.fc=null;return d}
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatExtractImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Ae()]),b=G().b,a=H(a,b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({JO:0},!1,"scala.meta.Pat$Extract$PatExtractImpl",{JO:1,f:1,HO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function p6(){this.Kb=this.Ef=this.pc=this.s=this.aa=this.m=null}p6.prototype=new m;p6.prototype.constructor=p6;e=p6.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","op","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.ExtractInfix"};
e.Na=function(){return this};function fn(a){if(null===a.Kb){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing PatExtractInfixImpl.rhs");var b=fn(a.m),c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b)if(b===F())c=F();else{for(var d=b.n(),f=d=U(new V,c(d),F()),b=b.o();b!==F();)var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g,b=b.o();c=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();c=d.da()}a.Kb=c}return a.Kb}
function sra(a,b,c){var d=new p6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Ef=null;d.Kb=null;return d}e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Vd();case 1:return this.Qd();case 2:return fn(this);default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return sra(a,b,d)};e.v=function(){return to(uo(),this)};
e.Vd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatExtractInfixImpl.lhs");var a=this.m.Vd(),b=this.m.Vd();this.pc=a.y(b,this,null,a.s)}return this.pc};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Vd(),this.Qd()]),b=G().b,a=H(a,b),b=fn(this),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qd=function(){if(null===this.Ef){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatExtractInfixImpl.op");var a=this.m.Qd(),b=this.m.Qd();this.Ef=a.y(b,this,null,a.s)}return this.Ef};e.$classData=l({NO:0},!1,"scala.meta.Pat$ExtractInfix$PatExtractInfixImpl",{NO:1,f:1,LO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function q6(){this.fc=this.Ff=this.Pj=this.s=this.aa=this.m=null}q6.prototype=new m;q6.prototype.constructor=q6;e=q6.prototype;
e.Oa=function(){G();var a=(new r).d(["prefix","parts","args"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.Interpolate"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.yi();case 1:return this.Qe();case 2:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return tra(a,b,d)};
e.yi=function(){if(null===this.Pj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatInterpolateImpl.prefix");var a=this.m.yi(),b=this.m.yi();this.Pj=a.y(b,this,null,a.s)}return this.Pj};e.v=function(){return to(uo(),this)};
e.Qe=function(){if(null===this.Ff){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatInterpolateImpl.parts");var a=this.m.Qe(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Ff=b}return this.Ff};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatInterpolateImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.yi()]),b=G().b,a=H(a,b),b=this.Qe(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function tra(a,b,c){var d=new q6;d.m=a;d.aa=b;d.s=c;d.Pj=null;d.Ff=null;d.fc=null;return d}e.$classData=l({RO:0},!1,"scala.meta.Pat$Interpolate$PatInterpolateImpl",{RO:1,f:1,PO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function HS(a){return!!(a&&a.$classData&&a.$classData.H.zq)}
var Nwa=l({zq:0},!0,"scala.meta.Pat$Quasi",{zq:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function r6(){this.s=this.aa=this.m=null}r6.prototype=new m;r6.prototype.constructor=r6;e=r6.prototype;e.Oa=function(){return F()};e.U=function(){return"Pat.SeqWildcard"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};
e.y=function(a,b,c,d){if(null!==c){var f;fL();var g=v(),g=z(g,b);zS||(zS=(new yS).c());(g=y(g,zS)?"rhs"===c:!1)||(g=v(),g=y(z(g,b),Ria())?"args"===c:!1);g||(g=v(),g=z(g,b),DS||(DS=(new CS).c()),g=y(g,DS)?"args"===c:!1);g||(g=v(),g=z(g,b),FS||(FS=(new ES).c()),g=y(g,FS)?"args"===c:!1);g||(g=v(),g=z(g,b),PS||(PS=(new OS).c()),g=y(g,PS)?"args"===c:!1);f=g;if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();var g=(new r).d(["parentCheckOk is false"]),n=G().b,g=(new q).a(!1,H(g,n))}if(null===g||!0!==
I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",h),(new q).a("destination",c),(new q).a("PatSeqWildcardImpl",this)];d=A(new B,C());f=0;for(h=c.length|0;f<h;)E(d,c[f]),f=1+f|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",a,d.t)}throw(new p).e(g);}}}return xra(a,b,d)};e.v=function(){return to(uo(),this)};function xra(a,b,c){var d=new r6;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};
e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({YO:0},!1,"scala.meta.Pat$SeqWildcard$PatSeqWildcardImpl",{YO:1,f:1,WO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function s6(){this.fc=this.s=this.aa=this.m=null}s6.prototype=new m;s6.prototype.constructor=s6;e=s6.prototype;e.U=function(){return"Pat.Tuple"};e.Oa=function(){G();var a=(new r).d(["args"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};
e.y=function(a,b,c,d){return yra(a,b,d)};e.W=function(a){switch(a){case 0:return this.pb();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatTupleImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function yra(a,b,c){var d=new s6;d.m=a;d.aa=b;d.s=c;d.fc=null;return d}e.$classData=l({aP:0},!1,"scala.meta.Pat$Tuple$PatTupleImpl",{aP:1,f:1,ZO:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function t6(){this.Kb=this.pc=this.s=this.aa=this.m=null}t6.prototype=new m;t6.prototype.constructor=t6;e=t6.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};
e.U=function(){return"Pat.Typed"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Vd();case 1:return this.cd();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Bra(a,b,d)};e.v=function(){return to(uo(),this)};function Bra(a,b,c){var d=new t6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}
e.cd=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatTypedImpl.rhs");var a=this.m.cd(),b=this.m.cd();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.Vd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatTypedImpl.lhs");var a=this.m.Vd(),b=this.m.Vd();this.pc=a.y(b,this,null,a.s)}return this.pc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Vd(),this.cd()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({dP:0},!1,"scala.meta.Pat$Typed$PatTypedImpl",{dP:1,f:1,bP:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function ln(a){return!!(a&&a.$classData&&a.$classData.H.eP)}function u6(){this.s=this.aa=this.m=null}u6.prototype=new m;u6.prototype.constructor=u6;e=u6.prototype;e.Oa=function(){return F()};e.U=function(){return"Pat.Wildcard"};e.Na=function(){return this};e.M=function(){return 0};
e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Gra(a,b,d)};e.v=function(){return to(uo(),this)};function Gra(a,b,c){var d=new u6;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({kP:0},!1,"scala.meta.Pat$Wildcard$PatWildcardImpl",{kP:1,f:1,iP:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function v6(){this.fc=this.Ff=this.s=this.aa=this.m=null}v6.prototype=new m;
v6.prototype.constructor=v6;e=v6.prototype;e.Oa=function(){G();var a=(new r).d(["parts","args"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.Xml"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qe();case 1:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Hra(a,b,d)};e.v=function(){return to(uo(),this)};
e.Qe=function(){if(null===this.Ff){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatXmlImpl.parts");var a=this.m.Qe(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Ff=b}return this.Ff};
function Hra(a,b,c){var d=new v6;d.m=a;d.aa=b;d.s=c;d.Ff=null;d.fc=null;return d}
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatXmlImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qe(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({oP:0},!1,"scala.meta.Pat$Xml$PatXmlImpl",{oP:1,f:1,mP:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Ql(a){return!!(a&&a.$classData&&a.$classData.H.qP)}function Mk(a){return!!(a&&a.$classData&&a.$classData.H.sP)}function pL(a){return!!(a&&a.$classData&&a.$classData.H.cj)}
var ywa=l({cj:0},!0,"scala.meta.Ref$Quasi",{cj:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function w6(){this.Lc=this.Pa=this.s=this.aa=this.m=null}w6.prototype=new m;w6.prototype.constructor=w6;e=w6.prototype;e.Oa=function(){G();var a=(new r).d(["name","decltpe"]),b=G().b;return H(a,b)};e.U=function(){return"Self"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.xb();case 1:return this.sc();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Mra(a,b,d)};e.v=function(){return to(uo(),this)};function Mra(a,b,c){var d=new w6;d.m=a;d.aa=b;d.s=c;d.Pa=null;d.Lc=null;return d}e.sc=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing SelfImpl.decltpe");var a=this.m.sc();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Lc=a}return this.Lc};
e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing SelfImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.xb()]),b=G().b,a=H(a,b),b=this.sc().lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.$classData=l({BP:0},!1,"scala.meta.Self$SelfImpl",{BP:1,f:1,Aq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function rL(a){return!!(a&&a.$classData&&a.$classData.H.dl)}var Hwa=l({dl:0},!0,"scala.meta.Stat$Quasi",{dl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function TS(a){return!!(a&&a.$classData&&a.$classData.H.JP)}function x6(){this.Vo=this.Lc=this.Pa=this.gb=this.s=this.aa=this.m=null}x6.prototype=new m;x6.prototype.constructor=x6;e=x6.prototype;
e.Oa=function(){G();var a=(new r).d(["mods","name","decltpe","default"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Param"};e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};function usa(a,b,c){var d=new x6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Lc=null;d.Vo=null;return d}e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.xb();case 2:return this.sc();case 3:return this.Bi();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){return usa(a,b,d)};e.v=function(){return to(uo(),this)};e.sc=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermParamImpl.decltpe");var a=this.m.sc();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Lc=a}return this.Lc};
e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermParamImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.xb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.sc().lb();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);b=this.Bi().lb();c=G();a=a.ma(b,c.b);b=F();c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermParamImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Bi=function(){if(null===this.Vo){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermParamImpl.default");var a=this.m.Bi();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Vo=a}return this.Vo};e.$classData=l({eR:0},!1,"scala.meta.Term$Param$TermParamImpl",{eR:1,f:1,Cq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Lf(a){return!!(a&&a.$classData&&a.$classData.H.zj)}
var lBa=l({zj:0},!0,"scala.meta.Term$Ref",{zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function y6(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}y6.prototype=new m;y6.prototype.constructor=y6;e=y6.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Tree.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Qsa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.Rd&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.Rd&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TreeQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(iwa),this.ca)};
function Qsa(a,b,c,d){var f=new y6;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({gS:0},!1,"scala.meta.Tree$Quasi$TreeQuasiImpl",{gS:1,f:1,Rd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1});function z6(){this.Kb=this.pc=this.s=this.aa=this.m=null}z6.prototype=new m;z6.prototype.constructor=z6;e=z6.prototype;
e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Type.And"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Kd();case 1:return this.cd();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Tsa(a,b,d)};e.v=function(){return to(uo(),this)};
e.Kd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeAndImpl.lhs");var a=this.m.Kd(),b=this.m.Kd();this.pc=a.y(b,this,null,a.s)}return this.pc};function Tsa(a,b,c){var d=new z6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}e.cd=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeAndImpl.rhs");var a=this.m.cd(),b=this.m.cd();this.Kb=a.y(b,this,null,a.s)}return this.Kb};
e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Kd(),this.cd()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({kS:0},!1,"scala.meta.Type$And$TypeAndImpl",{kS:1,f:1,iS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function A6(){this.Hj=this.qc=this.s=this.aa=this.m=null}A6.prototype=new m;A6.prototype.constructor=A6;e=A6.prototype;e.Oa=function(){G();var a=(new r).d(["tpe","annots"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Annotate"};e.Na=function(){return this};
e.M=function(){return 2};e.w=function(a){return this===a};e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeAnnotateImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};e.W=function(a){switch(a){case 0:return this.Db();case 1:return this.Di();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Vsa(a,b,d)};e.v=function(){return to(uo(),this)};
function Vsa(a,b,c){var d=new A6;d.m=a;d.aa=b;d.s=c;d.qc=null;d.Hj=null;return d}
e.Di=function(){if(null===this.Hj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeAnnotateImpl.annots");var a=this.m.Di(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Hj=b}return this.Hj};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Db()]),b=G().b,a=H(a,b),b=this.Di(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({nS:0},!1,"scala.meta.Type$Annotate$TypeAnnotateImpl",{nS:1,f:1,lS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function B6(){this.fc=this.qc=this.s=this.aa=this.m=null}B6.prototype=new m;B6.prototype.constructor=B6;e=B6.prototype;e.Oa=function(){G();var a=(new r).d(["tpe","args"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Apply"};
e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeApplyImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};e.W=function(a){switch(a){case 0:return this.Db();case 1:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Xsa(a,b,d)};e.v=function(){return to(uo(),this)};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeApplyImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Db()]),b=G().b,a=H(a,b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function Xsa(a,b,c){var d=new B6;d.m=a;d.aa=b;d.s=c;d.qc=null;d.fc=null;return d}e.$classData=l({qS:0},!1,"scala.meta.Type$Apply$TypeApplyImpl",{qS:1,f:1,oS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function C6(){this.Kb=this.Ef=this.pc=this.s=this.aa=this.m=null}C6.prototype=new m;C6.prototype.constructor=C6;e=C6.prototype;
e.Oa=function(){G();var a=(new r).d(["lhs","op","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Type.ApplyInfix"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Kd();case 1:return zi(this);case 2:return this.cd();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Zsa(a,b,d)};function Zsa(a,b,c){var d=new C6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Ef=null;d.Kb=null;return d}e.v=function(){return to(uo(),this)};
function zi(a){if(null===a.Ef){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TypeApplyInfixImpl.op");var b=zi(a.m),c=zi(a.m);a.Ef=b.y(c,a,null,b.s)}return a.Ef}e.Kd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeApplyInfixImpl.lhs");var a=this.m.Kd(),b=this.m.Kd();this.pc=a.y(b,this,null,a.s)}return this.pc};
e.cd=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeApplyInfixImpl.rhs");var a=this.m.cd(),b=this.m.cd();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Kd(),zi(this),this.cd()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({tS:0},!1,"scala.meta.Type$ApplyInfix$TypeApplyInfixImpl",{tS:1,f:1,rS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function D6(){this.qc=this.s=this.aa=this.m=null}D6.prototype=new m;D6.prototype.constructor=D6;e=D6.prototype;e.U=function(){return"Type.ByName"};e.Oa=function(){G();var a=(new r).d(["tpe"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};
e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeByNameImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};
e.y=function(a,b,c,d){if(null!==c){var f=Sia(fL(),b,c);if(!f){var g=b.U();if(f)var h=(new q).a(!0,F());else{G();var h=(new r).d(["parentCheckOk is false"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(a=h.p(),!1===I(h))){b=J();c=[(new q).a("TypeByNameImpl",this),(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",g),(new q).a("destination",c)];f=A(new B,C());g=0;for(d=c.length|0;g<d;)E(f,c[g]),g=1+g|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,f.t)}throw(new p).e(h);}}}return cha(a,b,d)};e.W=function(a){switch(a){case 0:return this.Db();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function cha(a,b,c){var d=new D6;d.m=a;d.aa=b;d.s=c;d.qc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Db()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({zS:0},!1,"scala.meta.Type$ByName$TypeByNameImpl",{zS:1,f:1,xS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function E6(){this.ld=this.qc=this.s=this.aa=this.m=null}E6.prototype=new m;E6.prototype.constructor=E6;e=E6.prototype;e.Oa=function(){G();var a=(new r).d(["tpe","stats"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Existential"};e.Na=function(){return this};e.M=function(){return 2};function ata(a,b,c){var d=new E6;d.m=a;d.aa=b;d.s=c;d.qc=null;d.ld=null;return d}e.w=function(a){return this===a};
e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeExistentialImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};e.W=function(a){switch(a){case 0:return this.Db();case 1:return this.ub();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return ata(a,b,d)};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Db()]),b=G().b,a=H(a,b),b=this.ub(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeExistentialImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({DS:0},!1,"scala.meta.Type$Existential$TypeExistentialImpl",{DS:1,f:1,BS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function F6(){this.Qj=this.yh=this.s=this.aa=this.m=null}F6.prototype=new m;F6.prototype.constructor=F6;e=F6.prototype;e.Oa=function(){G();var a=(new r).d(["params","res"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Function"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.me();case 1:return this.Kh();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return cta(a,b,d)};e.v=function(){return to(uo(),this)};
e.me=function(){if(null===this.yh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeFunctionImpl.params");var a=this.m.me(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.yh=b}return this.yh};
e.Kh=function(){if(null===this.Qj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeFunctionImpl.res");var a=this.m.Kh(),b=this.m.Kh();this.Qj=a.y(b,this,null,a.s)}return this.Qj};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.me(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Kh()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function cta(a,b,c){var d=new F6;d.m=a;d.aa=b;d.s=c;d.yh=null;d.Qj=null;return d}
e.$classData=l({GS:0},!1,"scala.meta.Type$Function$TypeFunctionImpl",{GS:1,f:1,ES:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function G6(){this.Qj=this.yh=this.s=this.aa=this.m=null}G6.prototype=new m;G6.prototype.constructor=G6;function eta(a,b,c){var d=new G6;d.m=a;d.aa=b;d.s=c;d.yh=null;d.Qj=null;return d}e=G6.prototype;e.Oa=function(){G();var a=(new r).d(["params","res"]),b=G().b;return H(a,b)};e.U=function(){return"Type.ImplicitFunction"};e.Na=function(){return this};e.M=function(){return 2};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.me();case 1:return this.Kh();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return eta(a,b,d)};e.v=function(){return to(uo(),this)};
e.me=function(){if(null===this.yh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeImplicitFunctionImpl.params");var a=this.m.me(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.yh=b}return this.yh};
e.Kh=function(){if(null===this.Qj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeImplicitFunctionImpl.res");var a=this.m.Kh(),b=this.m.Kh();this.Qj=a.y(b,this,null,a.s)}return this.Qj};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.me(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Kh()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.$classData=l({KS:0},!1,"scala.meta.Type$ImplicitFunction$TypeImplicitFunctionImpl",{KS:1,f:1,IS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function H6(){this.qc=this.Mc=this.s=this.aa=this.m=null}H6.prototype=new m;H6.prototype.constructor=H6;e=H6.prototype;e.Oa=function(){G();var a=(new r).d(["tparams","tpe"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Lambda"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeLambdaImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};e.W=function(a){switch(a){case 0:return this.lc();case 1:return this.Db();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){if(null!==c){var f;fL();var g=v();f=y(z(g,b),Pla());if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();var g=(new r).d(["parentCheckOk is false"]),n=G().b,g=(new q).a(!1,H(g,n))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",h),(new q).a("TypeLambdaImpl",this),(new q).a("destination",c)];f=A(new B,C());h=0;for(d=c.length|0;h<d;)E(f,c[h]),h=1+h|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,f.t)}throw(new p).e(g);}}}return fta(a,b,d)};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeLambdaImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
function fta(a,b,c){var d=new H6;d.m=a;d.aa=b;d.s=c;d.Mc=null;d.qc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.lc(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Db()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({NS:0},!1,"scala.meta.Type$Lambda$TypeLambdaImpl",{NS:1,f:1,LS:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function I6(){this.qc=this.Id=this.s=this.aa=this.m=null}I6.prototype=new m;I6.prototype.constructor=I6;
e=I6.prototype;e.Oa=function(){G();var a=(new r).d(["paramss","tpe"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Method"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeMethodImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};
e.W=function(a){switch(a){case 0:return this.bd();case 1:return this.Db();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){if(null!==c){var f;fL();var g=v();f=y(z(g,b),Pla());if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();var g=(new r).d(["parentCheckOk is false"]),n=G().b,g=(new q).a(!1,H(g,n))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",h),(new q).a("TypeMethodImpl",this),(new q).a("destination",c)];f=A(new B,C());h=0;for(d=c.length|0;h<d;)E(f,c[h]),h=1+h|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,f.t)}throw(new p).e(g);}}}return gta(a,b,d)};e.v=function(){return to(uo(),this)};
e.bd=function(){if(null===this.Id){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeMethodImpl.paramss");var a=this.m.bd(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;
if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Id=b}return this.Id};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.bd();G();for(var c=(new ae).c();!b.g();){var d=b.n().dc();Ll(c,d);b=b.o()}c=c.lb();b=G();a=a.ma(c,b.b);G();c=(new r).d([this.Db()]);b=G().b;c=H(c,b);b=G();return a.ma(c,b.b)};
function gta(a,b,c){var d=new I6;d.m=a;d.aa=b;d.s=c;d.Id=null;d.qc=null;return d}e.L=function(){return Z(this)};e.$classData=l({PS:0},!1,"scala.meta.Type$Method$TypeMethodImpl",{PS:1,f:1,GC:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function J6(){this.Kb=this.pc=this.s=this.aa=this.m=null}J6.prototype=new m;J6.prototype.constructor=J6;e=J6.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Or"};e.Na=function(){return this};e.M=function(){return 2};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Kd();case 1:return this.cd();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return ota(a,b,d)};e.v=function(){return to(uo(),this)};e.Kd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeOrImpl.lhs");var a=this.m.Kd(),b=this.m.Kd();this.pc=a.y(b,this,null,a.s)}return this.pc};
e.cd=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeOrImpl.rhs");var a=this.m.cd(),b=this.m.cd();this.Kb=a.y(b,this,null,a.s)}return this.Kb};function ota(a,b,c){var d=new J6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Kd(),this.cd()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({WS:0},!1,"scala.meta.Type$Or$TypeOrImpl",{WS:1,f:1,US:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function K6(){this.Uo=this.ip=this.fp=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}K6.prototype=new m;K6.prototype.constructor=K6;e=K6.prototype;e.U=function(){return"Type.Param"};e.Oa=function(){G();var a=(new r).d("mods name tparams tbounds vbounds cbounds".split(" ")),b=G().b;return H(a,b)};e.Na=function(){return this};
e.am=function(){if(null===this.fp){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamImpl.tbounds");var a=this.m.am(),b=this.m.am();this.fp=jA(b,this,a.s)}return this.fp};e.M=function(){return 6};e.w=function(a){return this===a};e.y=function(a,b,c,d){return qta(a,b,d)};
e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.xb();case 2:return this.lc();case 3:return this.am();case 4:return this.im();case 5:return this.ym();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
e.ym=function(){if(null===this.Uo){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamImpl.cbounds");var a=this.m.ym(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Uo=b}return this.Uo};
e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.xb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.am()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.im();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);b=this.ym();c=G();a=a.ma(b,c.b);b=F();c=G();return a.ma(b,c.b)};function qta(a,b,c){var d=new K6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.fp=null;d.ip=null;d.Uo=null;return d}e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.im=function(){if(null===this.ip){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamImpl.vbounds");var a=this.m.im(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ip=b}return this.ip};
e.$classData=l({$S:0},!1,"scala.meta.Type$Param$TypeParamImpl",{$S:1,f:1,Fq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function L6(){this.Ij=this.s=this.aa=this.m=null}L6.prototype=new m;L6.prototype.constructor=L6;e=L6.prototype;e.U=function(){return"Type.Placeholder"};e.Oa=function(){G();var a=(new r).d(["bounds"]),b=G().b;return H(a,b)};e.Na=function(){return this};function tta(a,b,c){var d=new L6;d.m=a;d.aa=b;d.s=c;d.Ij=null;return d}e.M=function(){return 1};e.w=function(a){return this===a};
e.y=function(a,b,c,d){return tta(a,b,d)};e.W=function(a){switch(a){case 0:return this.Gh();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Gh=function(){if(null===this.Ij){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypePlaceholderImpl.bounds");var a=this.m.Gh(),b=this.m.Gh();this.Ij=jA(b,this,a.s)}return this.Ij};e.Ma=function(){G();var a=(new r).d([this.Gh()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({dT:0},!1,"scala.meta.Type$Placeholder$TypePlaceholderImpl",{dT:1,f:1,bT:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function ti(a){return!!(a&&a.$classData&&a.$classData.H.fT)}function Eu(a){return!!(a&&a.$classData&&a.$classData.H.Gq)}var Lwa=l({Gq:0},!0,"scala.meta.Type$Quasi",{Gq:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function M6(){this.ld=this.qc=this.s=this.aa=this.m=null}M6.prototype=new m;M6.prototype.constructor=M6;e=M6.prototype;
e.Oa=function(){G();var a=(new r).d(["tpe","stats"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Refine"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return Qi(this);case 1:return this.ub();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return zta(a,b,d)};e.v=function(){return to(uo(),this)};
function Qi(a){if(null===a.qc){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TypeRefineImpl.tpe");var b=Qi(a.m);b.g()?b=S():(b=b.q(),b=(new T).e(b.y(b,a,null,b.s)));a.qc=b}return a.qc}function zta(a,b,c){var d=new M6;d.m=a;d.aa=b;d.s=c;d.qc=null;d.ld=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=Qi(this).lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.ub(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeRefineImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({oT:0},!1,"scala.meta.Type$Refine$TypeRefineImpl",{oT:1,f:1,mT:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function N6(){this.qc=this.s=this.aa=this.m=null}N6.prototype=new m;N6.prototype.constructor=N6;e=N6.prototype;e.U=function(){return"Type.Repeated"};e.Oa=function(){G();var a=(new r).d(["tpe"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};
e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeRepeatedImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};
e.y=function(a,b,c,d){if(null!==c){var f=Sia(fL(),b,c);if(!f){var g=b.U();if(f)var h=(new q).a(!0,F());else{G();var h=(new r).d(["parentCheckOk is false"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(a=h.p(),!1===I(h))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",g),(new q).a("TypeRepeatedImpl",this),(new q).a("destination",c)];f=A(new B,C());g=0;for(d=c.length|0;g<d;)E(f,c[g]),g=1+g|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,f.t)}throw(new p).e(h);}}}return eha(a,b,d)};e.W=function(a){switch(a){case 0:return this.Db();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function eha(a,b,c){var d=new N6;d.m=a;d.aa=b;d.s=c;d.qc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Db()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({rT:0},!1,"scala.meta.Type$Repeated$TypeRepeatedImpl",{rT:1,f:1,pT:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function si(a){return!!(a&&a.$classData&&a.$classData.H.sT)}function vi(a){return!!(a&&a.$classData&&a.$classData.H.vT)}function O6(){this.fc=this.s=this.aa=this.m=null}O6.prototype=new m;O6.prototype.constructor=O6;e=O6.prototype;e.U=function(){return"Type.Tuple"};e.Oa=function(){G();var a=(new r).d(["args"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Fta(a,b,d)};
e.W=function(a){switch(a){case 0:return this.pb();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function Fta(a,b,c){var d=new O6;d.m=a;d.aa=b;d.s=c;d.fc=null;return d}
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeTupleImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({BT:0},!1,"scala.meta.Type$Tuple$TypeTupleImpl",{BT:1,f:1,zT:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function kH(a){return!!(a&&a.$classData&&a.$classData.H.DT)}function P6(){this.Kb=this.pc=this.s=this.aa=this.m=null}P6.prototype=new m;P6.prototype.constructor=P6;e=P6.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Type.With"};
e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Kd();case 1:return this.cd();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Ita(a,b,d)};e.v=function(){return to(uo(),this)};function Ita(a,b,c){var d=new P6;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}
e.Kd=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeWithImpl.lhs");var a=this.m.Kd(),b=this.m.Kd();this.pc=a.y(b,this,null,a.s)}return this.pc};e.cd=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeWithImpl.rhs");var a=this.m.cd(),b=this.m.cd();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Kd(),this.cd()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({JT:0},!1,"scala.meta.Type$With$TypeWithImpl",{JT:1,f:1,HT:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Q6(){}Q6.prototype=new m;Q6.prototype.constructor=Q6;function mBa(){}e=mBa.prototype=Q6.prototype;e.ih=function(a,b){Id(this,a,b)};e.qv=function(a){return Xja(this,a)};e.lb=function(){var a=G().b;return H(this,a)};e.Pd=function(a){return this.le("",a,"")};
e.le=function(a,b,c){return gG(this,a,b,c)};e.St=function(a){return pM(new qM,this,a)};e.ag=function(){return oD(this)};e.se=function(a,b){return hO(this,a,b)};e.si=function(){return zz(this)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.cm=function(){To();return H(this,new sR)};e.mh=function(a){return this.nv(a,!1)};e.we=function(){var a=CV().b;return H(this,a)};e.nv=function(a,b){return P2(this,a,b)};e.Za=function(){return iO(this)};e.Of=function(){return this.Pd("")};
e.vg=function(a){return this.nv(a,!0)};e.ma=function(a,b){return Q2(this,a,b)};e.Df=function(){return-1};e.o=function(){return $va(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this};e.Gg=function(a,b){return this.se(a,b)};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Cn=function(a){return kO(this,a)};e.Tg=function(){return cj(this)};e.$e=function(a){return lO(this,a)};e.ic=function(){return this.qe().ic()};e.jf=function(){return R2(this)};
function R6(a){a=a.Fa();return(new m0).Be(0,a,1)}function Fw(a,b,c){c=c.mi(a.Se());c.$c(a.kf());c.ba(b);return c.da()}function nBa(a,b){var c=a.Fa(),d=a.ic();if(1===c)d.$c(a);else if(1<c){d.je(c);var c=oa(bc(Ab),[c]),f=(new JM).mc(0);a.Cb(lk(function(a,b,c){return function(a){b.i[c.cb]=a;c.cb=1+c.cb|0}}(a,c,f)));bda(Qr(),c,b);for(f.cb=0;f.cb<c.i.length;)d.ba(c.i[f.cb]),f.cb=1+f.cb|0}return d.da()}
function gia(a,b){b=oBa(a,b.kj());var c=a.ic();a.Cb(lk(function(a,b,c){return function(a){var d=b.Ea(a)|0;0<d&&(c.ba(a),b.gm(a,-1+d|0))}}(a,b,c)));return c.da()}function Yka(a){var b=F(),c=(new Uk).e(b);a.Cb(lk(function(a,b){return function(a){b.cb=U(new V,a,b.cb)}}(a,c)));b=a.ic();Poa(b,a);for(a=c.cb;!a.g();)c=a.n(),b.ba(c),a=a.o();return b.da()}function pBa(a,b,c){c=c.mi(a.Se());c.ba(b);c.$c(a.kf());return c.da()}
function Lia(a,b){return a.$f(lk(function(a,b){return function(a){return dj(ej(),a,b)}}(a,b)))}function oBa(a,b){var c=qBa();b.Cb(lk(function(a,b){return function(a){var c=1+(b.Ea(a)|0)|0;b.jt(a,c)}}(a,c)));return c}function xpa(a,b,c){var d=new h3;if(null===c)throw jo(wj(),null);d.r=c;d.lg=b;return nBa(a,d)}function UK(){this.Vf=0}UK.prototype=new m;UK.prototype.constructor=UK;e=UK.prototype;
e.Ts=function(){var a;if(this.Lm()){var b=this.bi();a=b.Ra;var b=b.Ya,c=this.oh();a=a===c&&b===c>>31}else a=!1;return a};e.bi=function(){ZP();var a=this.Vf;return(new Ep).K(a,a>>31)};e.Tv=function(){return this.Lm()&&this.oh()===this.Qq()};e.Ap=function(){ZP();return this.Vf<<24>>24};e.w=function(a){ZP();return a&&a.$classData&&a.$classData.H.VF?this.Vf===a.Vf:!1};e.Lm=function(){return!0};e.Sv=function(){return!0};e.v=function(){return""+this.Lq()};e.Rv=function(){return this.Lm()&&this.oh()===this.Ap()};
e.qf=function(a){return this.Vf-(null===a?0:a.pa)|0};e.Lq=function(){return(new ed).db(this.Vf)};e.db=function(a){this.Vf=a;return this};e.Qq=function(){ZP();return this.Vf<<16>>16};e.oj=function(){return this.Vf};e.A=function(){ZP();return this.Vf};e.oh=function(){return this.Vf};e.Fm=function(){ZP();return ga(this.Vf)};e.$classData=l({VF:0},!1,"scala.runtime.RichChar",{VF:1,f:1,n7:1,r7:1,q7:1,tC:1,g6:1,mK:1,o7:1,yo:1,xf:1,p7:1});function S6(){this.Id=this.Pa=this.gb=this.s=this.aa=this.m=null}
S6.prototype=new m;S6.prototype.constructor=S6;e=S6.prototype;e.Oa=function(){G();var a=(new r).d(["mods","name","paramss"]),b=G().b;return H(a,b)};e.U=function(){return"Ctor.Primary"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.xb();case 2:return this.bd();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return RW(a,b,d)};e.v=function(){return to(uo(),this)};
e.bd=function(){if(null===this.Id){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorPrimaryImpl.paramss");var a=this.m.bd(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;
if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Id=b}return this.Id};e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorPrimaryImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.xb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);c=this.bd();G();for(b=(new ae).c();!c.g();){var d=c.n().dc();Ll(b,d);c=c.o()}b=b.lb();c=G();a=a.ma(b,c.b);b=F();c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function RW(a,b,c){var d=new S6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Id=null;return d}
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorPrimaryImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.$classData=l({aL:0},!1,"scala.meta.Ctor$Primary$CtorPrimaryImpl",{aL:1,f:1,ZK:1,vw:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,gf:1});function rn(a){return!!(a&&a.$classData&&a.$classData.H.hL)}function un(a){return!!(a&&a.$classData&&a.$classData.H.kL)}function T6(){this.Lc=this.Gf=this.gb=this.s=this.aa=this.m=null}T6.prototype=new m;T6.prototype.constructor=T6;e=T6.prototype;e.Oa=function(){G();var a=(new r).d(["mods","pats","decltpe"]),b=G().b;return H(a,b)};e.U=function(){return"Decl.Val"};e.Na=function(){return this};
e.M=function(){return 3};e.w=function(a){return this===a};e.df=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclValImpl.decltpe");var a=this.m.df(),b=this.m.df();this.Lc=a.y(b,this,null,a.s)}return this.Lc};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.Xd();case 2:return this.df();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return eqa(a,b,d)};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.Xd(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.df()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};function eqa(a,b,c){var d=new T6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Gf=null;d.Lc=null;return d}e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclValImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Xd=function(){if(null===this.Gf){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclValImpl.pats");var a=this.m.Xd(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Gf=b}return this.Gf};
e.$classData=l({pL:0},!1,"scala.meta.Decl$Val$DeclValImpl",{pL:1,f:1,nL:1,rt:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function U6(){this.Lc=this.Gf=this.gb=this.s=this.aa=this.m=null}U6.prototype=new m;U6.prototype.constructor=U6;e=U6.prototype;e.Oa=function(){G();var a=(new r).d(["mods","pats","decltpe"]),b=G().b;return H(a,b)};e.U=function(){return"Decl.Var"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};
e.df=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclVarImpl.decltpe");var a=this.m.df(),b=this.m.df();this.Lc=a.y(b,this,null,a.s)}return this.Lc};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.Xd();case 2:return this.df();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return fqa(a,b,d)};e.v=function(){return to(uo(),this)};
function fqa(a,b,c){var d=new U6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Gf=null;d.Lc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.Xd(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.df()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclVarImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Xd=function(){if(null===this.Gf){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclVarImpl.pats");var a=this.m.Xd(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Gf=b}return this.Gf};
e.$classData=l({tL:0},!1,"scala.meta.Decl$Var$DeclVarImpl",{tL:1,f:1,rL:1,rt:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Ok(a){return!!(a&&a.$classData&&a.$classData.H.vL)}function Gk(a){return!!(a&&a.$classData&&a.$classData.H.yL)}function Kk(a){return!!(a&&a.$classData&&a.$classData.H.BL)}function Lk(a){return!!(a&&a.$classData&&a.$classData.H.EL)}function Pk(a){return!!(a&&a.$classData&&a.$classData.H.HL)}function Qk(a){return!!(a&&a.$classData&&a.$classData.H.KL)}
function V6(){this.Kb=this.Lc=this.Gf=this.gb=this.s=this.aa=this.m=null}V6.prototype=new m;V6.prototype.constructor=V6;e=V6.prototype;e.Oa=function(){G();var a=(new r).d(["mods","pats","decltpe","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Defn.Val"};e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.Xd();case 2:return this.sc();case 3:return this.Ld();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){return nqa(a,b,d)};e.v=function(){return to(uo(),this)};function nqa(a,b,c){var d=new V6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Gf=null;d.Lc=null;d.Kb=null;return d}e.sc=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnValImpl.decltpe");var a=this.m.sc();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Lc=a}return this.Lc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.Xd(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.sc().lb(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Ld()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnValImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Xd=function(){if(null===this.Gf){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnValImpl.pats");var a=this.m.Xd(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Gf=b}return this.Gf};
e.Ld=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnValImpl.rhs");var a=this.m.Ld(),b=this.m.Ld();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.$classData=l({PL:0},!1,"scala.meta.Defn$Val$DefnValImpl",{PL:1,f:1,NL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function W6(){this.Kb=this.Lc=this.Gf=this.gb=this.s=this.aa=this.m=null}W6.prototype=new m;W6.prototype.constructor=W6;e=W6.prototype;
e.Oa=function(){G();var a=(new r).d(["mods","pats","decltpe","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Defn.Var"};e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.Xd();case 2:return this.sc();case 3:return Tk(this);default:throw(new W).j(""+a);}};
function Tk(a){if(null===a.Kb){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing DefnVarImpl.rhs");var b=Tk(a.m);b.g()?b=S():(b=b.q(),b=(new T).e(b.y(b,a,null,b.s)));a.Kb=b}return a.Kb}e.y=function(a,b,c,d){return oqa(a,b,d)};e.v=function(){return to(uo(),this)};function oqa(a,b,c){var d=new W6;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Gf=null;d.Lc=null;d.Kb=null;return d}
e.sc=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnVarImpl.decltpe");var a=this.m.sc();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Lc=a}return this.Lc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.Xd(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.sc().lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=Tk(this).lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnVarImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Xd=function(){if(null===this.Gf){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnVarImpl.pats");var a=this.m.Xd(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Gf=b}return this.Gf};
e.$classData=l({TL:0},!1,"scala.meta.Defn$Var$DefnVarImpl",{TL:1,f:1,RL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function X6(){this.Pa=this.s=this.aa=this.m=null}X6.prototype=new m;X6.prototype.constructor=X6;e=X6.prototype;e.U=function(){return"Importee.Name"};e.Oa=function(){G();var a=(new r).d(["name"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};function vqa(a,b,c){var d=new X6;d.m=a;d.aa=b;d.s=c;d.Pa=null;return d}e.w=function(a){return this===a};
e.y=function(a,b,c,d){return vqa(a,b,d)};e.W=function(a){switch(a){case 0:return this.xb();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporteeNameImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.xb()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({rM:0},!1,"scala.meta.Importee$Name$ImporteeNameImpl",{rM:1,f:1,pM:1,rn:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function Y6(){this.cp=this.Pa=this.s=this.aa=this.m=null}Y6.prototype=new m;Y6.prototype.constructor=Y6;e=Y6.prototype;e.Oa=function(){G();var a=(new r).d(["name","rename"]),b=G().b;return H(a,b)};e.U=function(){return"Importee.Rename"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.xb();case 1:return Nn(this);default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Mga(a,b,d)};e.v=function(){return to(uo(),this)};function Nn(a){if(null===a.cp){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing ImporteeRenameImpl.rename");var b=Nn(a.m),c=Nn(a.m);a.cp=b.y(c,a,null,b.s)}return a.cp}function Mga(a,b,c){var d=new Y6;d.m=a;d.aa=b;d.s=c;d.Pa=null;d.cp=null;return d}
e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporteeRenameImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.xb(),Nn(this)]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({wM:0},!1,"scala.meta.Importee$Rename$ImporteeRenameImpl",{wM:1,f:1,uM:1,rn:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});
function Z6(){this.Pa=this.s=this.aa=this.m=null}Z6.prototype=new m;Z6.prototype.constructor=Z6;e=Z6.prototype;e.U=function(){return"Importee.Unimport"};e.Oa=function(){G();var a=(new r).d(["name"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Oga(a,b,d)};e.W=function(a){switch(a){case 0:return this.xb();default:throw(new W).j(""+a);}};
function Oga(a,b,c){var d=new Z6;d.m=a;d.aa=b;d.s=c;d.Pa=null;return d}e.v=function(){return to(uo(),this)};e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporteeUnimportImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.xb()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({zM:0},!1,"scala.meta.Importee$Unimport$ImporteeUnimportImpl",{zM:1,f:1,xM:1,rn:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function $6(){this.s=this.aa=this.m=null}$6.prototype=new m;$6.prototype.constructor=$6;e=$6.prototype;e.Oa=function(){return F()};e.U=function(){return"Importee.Wildcard"};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return hga(a,b,d)};
e.v=function(){return to(uo(),this)};function hga(a,b,c){var d=new $6;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({CM:0},!1,"scala.meta.Importee$Wildcard$ImporteeWildcardImpl",{CM:1,f:1,AM:1,rn:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function Ui(a){return!!(a&&a.$classData&&a.$classData.H.Ik)}function a7(){this.s=this.aa=this.m=null}a7.prototype=new m;a7.prototype.constructor=a7;e=a7.prototype;e.U=function(){return"Name.Anonymous"};
e.Oa=function(){return F()};e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};
e.y=function(a,b,c,d){if(null!==c){var f;fL();var g;g=v();g=z(g,b);zR||(zR=(new yR).c());(g=y(g,zR)?"name"===c:!1)||(g=v(),g=y(z(g,b),qla())?"name"===c:!1);g||(g=v(),g=y(z(g,b),Tia())?"name"===c:!1);g||(g=v(),g=z(g,b),Jla||(Jla=(new iT).c()),g=y(g,Jla)?"name"===c:!1);g||(g=v(),g=y(z(g,b),Pia())?"name"===c:!1);g||(g=v(),g=z(g,b),RS||(RS=(new QS).c()),g=y(g,RS)?"name"===c:!1);g||(g=v(),g=y(z(g,b),QC())?"within"===c:!1);g||(g=v(),g=y(z(g,b),OC())?"within"===c:!1);g||(g=v(),g=y(z(g,b),IG()));g||(g=v(),
g=y(z(g,b),Gla()));f=g;if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();g=(new r).d(["parentCheckOk is false"]);var n=G().b;g=(new q).a(!1,H(g,n))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",h),(new q).a("NameAnonymousImpl",this),(new q).a("destination",c)];d=A(new B,C());f=0;for(h=c.length|0;f<h;)E(d,c[f]),f=1+f|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,d.t)}throw(new p).e(g);}}}return ira(a,b,d)};e.W=function(a){throw(new W).j(""+a);};e.v=function(){return to(uo(),this)};e.ec=function(){return""};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};function ira(a,b,c){var d=new a7;d.m=a;d.aa=b;d.s=c;return d}e.$classData=l({qO:0},!1,"scala.meta.Name$Anonymous$NameAnonymousImpl",{qO:1,f:1,oO:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function b7(){this.Ab=this.s=this.aa=this.m=null}b7.prototype=new m;
b7.prototype.constructor=b7;e=b7.prototype;e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.U=function(){return"Name.Indeterminate"};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return jra(a,b,d,this.Ab)};e.v=function(){return to(uo(),this)};e.ec=function(){return this.Ab};
function jra(a,b,c,d){var f=new b7;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({uO:0},!1,"scala.meta.Name$Indeterminate$NameIndeterminateImpl",{uO:1,f:1,sO:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function c7(){this.Hj=this.gc=this.s=this.aa=this.m=null}c7.prototype=new m;c7.prototype.constructor=c7;e=c7.prototype;e.Oa=function(){G();var a=(new r).d(["expr","annots"]),b=G().b;return H(a,b)};
e.U=function(){return"Term.Annotate"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ob();case 1:return this.Di();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Xra(a,b,d)};e.v=function(){return to(uo(),this)};function Xra(a,b,c){var d=new c7;d.m=a;d.aa=b;d.s=c;d.gc=null;d.Hj=null;return d}
e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermAnnotateImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};
e.Di=function(){if(null===this.Hj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermAnnotateImpl.annots");var a=this.m.Di(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Hj=b}return this.Hj};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b,a=H(a,b),b=this.Di(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({RP:0},!1,"scala.meta.Term$Annotate$TermAnnotateImpl",{RP:1,f:1,PP:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function d7(){this.fc=this.vh=this.s=this.aa=this.m=null}d7.prototype=new m;d7.prototype.constructor=d7;e=d7.prototype;e.Oa=function(){G();var a=(new r).d(["fun","args"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Apply"};
e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.Ae=function(){if(null===this.vh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyImpl.fun");var a=this.m.Ae(),b=this.m.Ae();this.vh=a.y(b,this,null,a.s)}return this.vh};e.W=function(a){switch(a){case 0:return this.Ae();case 1:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Yra(a,b,d)};e.v=function(){return to(uo(),this)};
function Yra(a,b,c){var d=new d7;d.m=a;d.aa=b;d.s=c;d.vh=null;d.fc=null;return d}
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.Ae()]),b=G().b,a=H(a,b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({UP:0},!1,"scala.meta.Term$Apply$TermApplyImpl",{UP:1,f:1,SP:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function e7(){this.fc=this.Rj=this.Ef=this.pc=this.s=this.aa=this.m=null}e7.prototype=new m;e7.prototype.constructor=e7;e=e7.prototype;
e.Oa=function(){G();var a=(new r).d(["lhs","op","targs","args"]),b=G().b;return H(a,b)};e.U=function(){return"Term.ApplyInfix"};e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};
e.$g=function(){if(null===this.Rj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyInfixImpl.targs");var a=this.m.$g(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Rj=b}return this.Rj};
e.W=function(a){switch(a){case 0:return this.mg();case 1:return this.Qd();case 2:return this.$g();case 3:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Zra(a,b,d)};e.v=function(){return to(uo(),this)};e.mg=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyInfixImpl.lhs");var a=this.m.mg(),b=this.m.mg();this.pc=a.y(b,this,null,a.s)}return this.pc};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyInfixImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};
function Zra(a,b,c){var d=new e7;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Ef=null;d.Rj=null;d.fc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.mg(),this.Qd()]),b=G().b,a=H(a,b),b=this.$g(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qd=function(){if(null===this.Ef){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyInfixImpl.op");var a=this.m.Qd(),b=this.m.Qd();this.Ef=a.y(b,this,null,a.s)}return this.Ef};e.$classData=l({YP:0},!1,"scala.meta.Term$ApplyInfix$TermApplyInfixImpl",{YP:1,f:1,WP:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function f7(){this.Rj=this.vh=this.s=this.aa=this.m=null}f7.prototype=new m;f7.prototype.constructor=f7;e=f7.prototype;
e.Oa=function(){G();var a=(new r).d(["fun","targs"]),b=G().b;return H(a,b)};e.U=function(){return"Term.ApplyType"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.Ae=function(){if(null===this.vh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyTypeImpl.fun");var a=this.m.Ae(),b=this.m.Ae();this.vh=a.y(b,this,null,a.s)}return this.vh};
e.$g=function(){if(null===this.Rj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyTypeImpl.targs");var a=this.m.$g(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Rj=b}return this.Rj};
e.W=function(a){switch(a){case 0:return this.Ae();case 1:return this.$g();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return $ra(a,b,d)};function $ra(a,b,c){var d=new f7;d.m=a;d.aa=b;d.s=c;d.vh=null;d.Rj=null;return d}e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Ae()]),b=G().b,a=H(a,b),b=this.$g(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.$classData=l({bQ:0},!1,"scala.meta.Term$ApplyType$TermApplyTypeImpl",{bQ:1,f:1,$P:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function gm(a){return!!(a&&a.$classData&&a.$classData.H.cQ)}function g7(){this.qc=this.gc=this.s=this.aa=this.m=null}g7.prototype=new m;g7.prototype.constructor=g7;e=g7.prototype;e.Oa=function(){G();var a=(new r).d(["expr","tpe"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Ascribe"};e.Na=function(){return this};e.M=function(){return 2};
e.w=function(a){return this===a};e.Db=function(){if(null===this.qc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermAscribeImpl.tpe");var a=this.m.Db(),b=this.m.Db();this.qc=a.y(b,this,null,a.s)}return this.qc};e.W=function(a){switch(a){case 0:return this.ob();case 1:return this.Db();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return sfa(a,b,d)};e.v=function(){return to(uo(),this)};
e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermAscribeImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};function sfa(a,b,c){var d=new g7;d.m=a;d.aa=b;d.s=c;d.gc=null;d.qc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ob(),this.Db()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({iQ:0},!1,"scala.meta.Term$Ascribe$TermAscribeImpl",{iQ:1,f:1,gQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function h7(){this.Kb=this.pc=this.s=this.aa=this.m=null}h7.prototype=new m;h7.prototype.constructor=h7;e=h7.prototype;e.Oa=function(){G();var a=(new r).d(["lhs","rhs"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Assign"};e.Na=function(){return this};function mfa(a,b,c){var d=new h7;d.m=a;d.aa=b;d.s=c;d.pc=null;d.Kb=null;return d}e.M=function(){return 2};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.mg();case 1:return this.Ld();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){if(null!==c){var f;fL();var g=v();f=this.Ld();f=!y(z(g,f),Ela())||Mia(0,b,c);if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();var g=(new r).d(["parentCheckOk is false"]),n=G().b,g=(new q).a(!1,H(g,n))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("TermAssignImpl",this),(new q).a("parentPrefix",h),(new q).a("destination",c)];d=A(new B,C());f=0;for(h=c.length|0;f<h;)E(d,c[f]),f=1+f|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,d.t)}throw(new p).e(g);}}}return mfa(a,b,d)};e.v=function(){return to(uo(),this)};e.mg=function(){if(null===this.pc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermAssignImpl.lhs");var a=this.m.mg(),b=this.m.mg();this.pc=a.y(b,this,null,a.s)}return this.pc};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.mg(),this.Ld()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.Ld=function(){if(null===this.Kb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermAssignImpl.rhs");var a=this.m.Ld(),b=this.m.Ld();this.Kb=a.y(b,this,null,a.s)}return this.Kb};e.$classData=l({lQ:0},!1,"scala.meta.Term$Assign$TermAssignImpl",{lQ:1,f:1,jQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function i7(){this.ld=this.s=this.aa=this.m=null}i7.prototype=new m;i7.prototype.constructor=i7;e=i7.prototype;e.U=function(){return"Term.Block"};
e.Oa=function(){G();var a=(new r).d(["stats"]),b=G().b;return H(a,b)};e.Na=function(){return this};function bsa(a,b,c){var d=new i7;d.m=a;d.aa=b;d.s=c;d.ld=null;return d}e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return bsa(a,b,d)};e.W=function(a){switch(a){case 0:return this.ub();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.ub(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermBlockImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({pQ:0},!1,"scala.meta.Term$Block$TermBlockImpl",{pQ:1,f:1,nQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function j7(){this.gc=this.Kc=this.s=this.aa=this.m=null}j7.prototype=new m;j7.prototype.constructor=j7;e=j7.prototype;e.Oa=function(){G();var a=(new r).d(["body","expr"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Do"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Nb();case 1:return this.ob();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return afa(a,b,d)};e.v=function(){return to(uo(),this)};e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermDoImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};
e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermDoImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Nb(),this.ob()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};function afa(a,b,c){var d=new j7;d.m=a;d.aa=b;d.s=c;d.Kc=null;d.gc=null;return d}
e.$classData=l({sQ:0},!1,"scala.meta.Term$Do$TermDoImpl",{sQ:1,f:1,qQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function k7(){this.gc=this.s=this.aa=this.m=null}k7.prototype=new m;k7.prototype.constructor=k7;e=k7.prototype;e.U=function(){return"Term.Eta"};e.Oa=function(){G();var a=(new r).d(["expr"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return kga(a,b,d)};
e.W=function(a){switch(a){case 0:return this.ob();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function kga(a,b,c){var d=new k7;d.m=a;d.aa=b;d.s=c;d.gc=null;return d}e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermEtaImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({vQ:0},!1,"scala.meta.Term$Eta$TermEtaImpl",{vQ:1,f:1,tQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function l7(){this.Kc=this.Nj=this.s=this.aa=this.m=null}l7.prototype=new m;l7.prototype.constructor=l7;e=l7.prototype;e.Oa=function(){G();var a=(new r).d(["enums","body"]),b=G().b;return H(a,b)};e.U=function(){return"Term.For"};e.Na=function(){return this};e.M=function(){return 2};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Ui();case 1:return this.Nb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return dsa(a,b,d)};function dsa(a,b,c){var d=new l7;d.m=a;d.aa=b;d.s=c;d.Nj=null;d.Kc=null;return d}e.v=function(){return to(uo(),this)};e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermForImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};
e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.Ui(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Nb()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};
e.Ui=function(){if(null===this.Nj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermForImpl.enums");var a=this.m.Ui(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Nj=b}return this.Nj};e.L=function(){return Z(this)};
e.$classData=l({yQ:0},!1,"scala.meta.Term$For$TermForImpl",{yQ:1,f:1,wQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function m7(){this.Kc=this.Nj=this.s=this.aa=this.m=null}m7.prototype=new m;m7.prototype.constructor=m7;e=m7.prototype;e.Oa=function(){G();var a=(new r).d(["enums","body"]),b=G().b;return H(a,b)};e.U=function(){return"Term.ForYield"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Ui();case 1:return this.Nb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return esa(a,b,d)};e.v=function(){return to(uo(),this)};function esa(a,b,c){var d=new m7;d.m=a;d.aa=b;d.s=c;d.Nj=null;d.Kc=null;return d}e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermForYieldImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Ui(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Nb()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};
e.Ui=function(){if(null===this.Nj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermForYieldImpl.enums");var a=this.m.Ui(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Nj=b}return this.Nj};e.L=function(){return Z(this)};
e.$classData=l({BQ:0},!1,"scala.meta.Term$ForYield$TermForYieldImpl",{BQ:1,f:1,zQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function n7(){this.Kc=this.yh=this.s=this.aa=this.m=null}n7.prototype=new m;n7.prototype.constructor=n7;e=n7.prototype;e.Oa=function(){G();var a=(new r).d(["params","body"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Function"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.me();case 1:return this.Nb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return fsa(a,b,d)};e.v=function(){return to(uo(),this)};
e.me=function(){if(null===this.yh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermFunctionImpl.params");var a=this.m.me(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.yh=b}return this.yh};
e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermFunctionImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.me(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.Nb()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function fsa(a,b,c){var d=new n7;d.m=a;d.aa=b;d.s=c;d.yh=null;d.Kc=null;return d}
e.$classData=l({EQ:0},!1,"scala.meta.Term$Function$TermFunctionImpl",{EQ:1,f:1,CQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function o7(){this.Xo=this.gp=this.uh=this.s=this.aa=this.m=null}o7.prototype=new m;o7.prototype.constructor=o7;e=o7.prototype;e.Oa=function(){G();var a=(new r).d(["cond","thenp","elsep"]),b=G().b;return H(a,b)};e.U=function(){return"Term.If"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.oi();case 1:return tm(this);case 2:return um(this);default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return hsa(a,b,d)};e.v=function(){return to(uo(),this)};function tm(a){if(null===a.gp){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermIfImpl.thenp");var b=tm(a.m),c=tm(a.m);a.gp=b.y(c,a,null,b.s)}return a.gp}
e.oi=function(){if(null===this.uh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermIfImpl.cond");var a=this.m.oi(),b=this.m.oi();this.uh=a.y(b,this,null,a.s)}return this.uh};function hsa(a,b,c){var d=new o7;d.m=a;d.aa=b;d.s=c;d.uh=null;d.gp=null;d.Xo=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.oi(),tm(this),um(this)]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
function um(a){if(null===a.Xo){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermIfImpl.elsep");var b=um(a.m),c=um(a.m);a.Xo=b.y(c,a,null,b.s)}return a.Xo}e.$classData=l({HQ:0},!1,"scala.meta.Term$If$TermIfImpl",{HQ:1,f:1,FQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function p7(){this.fc=this.Ff=this.Pj=this.s=this.aa=this.m=null}p7.prototype=new m;p7.prototype.constructor=p7;e=p7.prototype;
e.Oa=function(){G();var a=(new r).d(["prefix","parts","args"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Interpolate"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.yi();case 1:return this.Qe();case 2:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return jsa(a,b,d)};
e.yi=function(){if(null===this.Pj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermInterpolateImpl.prefix");var a=this.m.yi(),b=this.m.yi();this.Pj=a.y(b,this,null,a.s)}return this.Pj};e.v=function(){return to(uo(),this)};
e.Qe=function(){if(null===this.Ff){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermInterpolateImpl.parts");var a=this.m.Qe(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Ff=b}return this.Ff};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermInterpolateImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.yi()]),b=G().b,a=H(a,b),b=this.Qe(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};function jsa(a,b,c){var d=new p7;d.m=a;d.aa=b;d.s=c;d.Pj=null;d.Ff=null;d.fc=null;return d}e.L=function(){return Z(this)};e.$classData=l({KQ:0},!1,"scala.meta.Term$Interpolate$TermInterpolateImpl",{KQ:1,f:1,IQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function q7(){this.Kj=this.gc=this.s=this.aa=this.m=null}q7.prototype=new m;q7.prototype.constructor=q7;e=q7.prototype;e.Oa=function(){G();var a=(new r).d(["expr","cases"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Match"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ob();case 1:return this.ni();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return ksa(a,b,d)};e.v=function(){return to(uo(),this)};
function ksa(a,b,c){var d=new q7;d.m=a;d.aa=b;d.s=c;d.gc=null;d.Kj=null;return d}e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermMatchImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};
e.ni=function(){if(null===this.Kj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermMatchImpl.cases");var a=this.m.ni(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Kj=b}return this.Kj};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b,a=H(a,b),b=this.ni(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({OQ:0},!1,"scala.meta.Term$Match$TermMatchImpl",{OQ:1,f:1,MQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function r7(){this.xh=this.s=this.aa=this.m=null}r7.prototype=new m;r7.prototype.constructor=r7;e=r7.prototype;e.U=function(){return"Term.New"};e.Oa=function(){G();var a=(new r).d(["init"]),b=G().b;return H(a,b)};
e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return rsa(a,b,d)};e.W=function(a){switch(a){case 0:return this.ff();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function rsa(a,b,c){var d=new r7;d.m=a;d.aa=b;d.s=c;d.xh=null;return d}
e.ff=function(){if(null===this.xh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermNewImpl.init");var a=this.m.ff(),b=this.m.ff();this.xh=a.y(b,this,null,a.s)}return this.xh};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ff()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({XQ:0},!1,"scala.meta.Term$New$TermNewImpl",{XQ:1,f:1,VQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function s7(){this.oe=this.s=this.aa=this.m=null}s7.prototype=new m;s7.prototype.constructor=s7;e=s7.prototype;e.U=function(){return"Term.NewAnonymous"};e.Oa=function(){G();var a=(new r).d(["templ"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return ssa(a,b,d)};e.W=function(a){switch(a){case 0:return this.Qc();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};
function ssa(a,b,c){var d=new s7;d.m=a;d.aa=b;d.s=c;d.oe=null;return d}e.Ma=function(){G();var a=(new r).d([this.Qc()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.Qc=function(){if(null===this.oe){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermNewAnonymousImpl.templ");var a=this.m.Qc(),b=this.m.Qc();this.oe=a.y(b,this,null,a.s)}return this.oe};
e.$classData=l({$Q:0},!1,"scala.meta.Term$NewAnonymous$TermNewAnonymousImpl",{$Q:1,f:1,YQ:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function t7(){this.Kj=this.s=this.aa=this.m=null}t7.prototype=new m;t7.prototype.constructor=t7;e=t7.prototype;e.U=function(){return"Term.PartialFunction"};e.Oa=function(){G();var a=(new r).d(["cases"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return ysa(a,b,d)};
e.W=function(a){switch(a){case 0:return this.ni();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.ni=function(){if(null===this.Kj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermPartialFunctionImpl.cases");var a=this.m.ni(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Kj=b}return this.Kj};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.ni(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};function ysa(a,b,c){var d=new t7;d.m=a;d.aa=b;d.s=c;d.Kj=null;return d}e.L=function(){return Z(this)};e.$classData=l({iR:0},!1,"scala.meta.Term$PartialFunction$TermPartialFunctionImpl",{iR:1,f:1,gR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function u7(){this.s=this.aa=this.m=null}u7.prototype=new m;u7.prototype.constructor=u7;e=u7.prototype;e.Oa=function(){return F()};e.U=function(){return"Term.Placeholder"};
e.Na=function(){return this};e.M=function(){return 0};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return mea(a,b,d)};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};function mea(a,b,c){var d=new u7;d.m=a;d.aa=b;d.s=c;return d}e.$classData=l({lR:0},!1,"scala.meta.Term$Placeholder$TermPlaceholderImpl",{lR:1,f:1,jR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});
function v7(){this.gc=this.s=this.aa=this.m=null}v7.prototype=new m;v7.prototype.constructor=v7;e=v7.prototype;e.U=function(){return"Term.Repeated"};e.Oa=function(){G();var a=(new r).d(["expr"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};
e.y=function(a,b,c,d){if(null!==c){var f=Mia(fL(),b,c);if(!f){var g=b.U();if(f)var h=(new q).a(!0,F());else{G();var h=(new r).d(["parentCheckOk is false"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(a=h.p(),!1===I(h))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("parentPrefix",g),(new q).a("destination",c),(new q).a("TermRepeatedImpl",this)];f=A(new B,C());g=0;for(d=c.length|0;g<d;)E(f,c[g]),g=1+g|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,f.t)}throw(new p).e(h);}}}return pfa(a,b,d)};e.W=function(a){switch(a){case 0:return this.ob();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermRepeatedImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};function pfa(a,b,c){var d=new v7;d.m=a;d.aa=b;d.s=c;d.gc=null;return d}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({xR:0},!1,"scala.meta.Term$Repeated$TermRepeatedImpl",{xR:1,f:1,vR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function w7(){this.gc=this.s=this.aa=this.m=null}w7.prototype=new m;w7.prototype.constructor=w7;e=w7.prototype;e.U=function(){return"Term.Return"};e.Oa=function(){G();var a=(new r).d(["expr"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};
e.w=function(a){return this===a};e.y=function(a,b,c,d){return Fsa(a,b,d)};e.W=function(a){switch(a){case 0:return this.ob();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermReturnImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};function Fsa(a,b,c){var d=new w7;d.m=a;d.aa=b;d.s=c;d.gc=null;return d}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({BR:0},!1,"scala.meta.Term$Return$TermReturnImpl",{BR:1,f:1,zR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function Hm(a){return!!(a&&a.$classData&&a.$classData.H.FR)}function Km(a){return!!(a&&a.$classData&&a.$classData.H.JR)}function x7(){this.gc=this.s=this.aa=this.m=null}x7.prototype=new m;x7.prototype.constructor=x7;e=x7.prototype;e.U=function(){return"Term.Throw"};
e.Oa=function(){G();var a=(new r).d(["expr"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return hfa(a,b,d)};e.W=function(a){switch(a){case 0:return this.ob();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermThrowImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};function hfa(a,b,c){var d=new x7;d.m=a;d.aa=b;d.s=c;d.gc=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({PR:0},!1,"scala.meta.Term$Throw$TermThrowImpl",{PR:1,f:1,NR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function y7(){this.Oj=this.Lj=this.gc=this.s=this.aa=this.m=null}y7.prototype=new m;y7.prototype.constructor=y7;
function Om(a){if(null===a.Lj){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermTryImpl.catchp");var b=Om(a.m),c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b)if(b===F())c=F();else{for(var d=b.n(),f=d=U(new V,c(d),F()),b=b.o();b!==F();)var g=b.n(),g=U(new V,c(g),F()),f=f.ga=g,b=b.o();c=d}else{for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();c=d.da()}a.Lj=c}return a.Lj}e=y7.prototype;
e.Oa=function(){G();var a=(new r).d(["expr","catchp","finallyp"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Try"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ob();case 1:return Om(this);case 2:return this.Vi();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Lsa(a,b,d)};e.v=function(){return to(uo(),this)};
function Lsa(a,b,c){var d=new y7;d.m=a;d.aa=b;d.s=c;d.gc=null;d.Lj=null;d.Oj=null;return d}e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermTryImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};
e.Vi=function(){if(null===this.Oj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermTryImpl.finallyp");var a=this.m.Vi();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Oj=a}return this.Oj};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ob()]),b=G().b,a=H(a,b),b=Om(this),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.Vi().lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.$classData=l({SR:0},!1,"scala.meta.Term$Try$TermTryImpl",{SR:1,f:1,QR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function z7(){this.Oj=this.Lj=this.gc=this.s=this.aa=this.m=null}z7.prototype=new m;z7.prototype.constructor=z7;e=z7.prototype;e.Oa=function(){G();var a=(new r).d(["expr","catchp","finallyp"]),b=G().b;return H(a,b)};e.U=function(){return"Term.TryWithHandler"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ob();case 1:return Qm(this);case 2:return this.Vi();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Xea(a,b,d)};e.v=function(){return to(uo(),this)};e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermTryWithHandlerImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};
function Qm(a){if(null===a.Lj){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermTryWithHandlerImpl.catchp");var b=Qm(a.m),c=Qm(a.m);a.Lj=b.y(c,a,null,b.s)}return a.Lj}e.Vi=function(){if(null===this.Oj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermTryWithHandlerImpl.finallyp");var a=this.m.Vi();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Oj=a}return this.Oj};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.ob(),Qm(this)]),b=G().b,a=H(a,b),b=this.Vi().lb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};function Xea(a,b,c){var d=new z7;d.m=a;d.aa=b;d.s=c;d.gc=null;d.Lj=null;d.Oj=null;return d}e.$classData=l({VR:0},!1,"scala.meta.Term$TryWithHandler$TermTryWithHandlerImpl",{VR:1,f:1,TR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function A7(){this.fc=this.s=this.aa=this.m=null}A7.prototype=new m;
A7.prototype.constructor=A7;e=A7.prototype;e.U=function(){return"Term.Tuple"};e.Oa=function(){G();var a=(new r).d(["args"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};function Nsa(a,b,c){var d=new A7;d.m=a;d.aa=b;d.s=c;d.fc=null;return d}e.w=function(a){return this===a};e.y=function(a,b,c,d){return Nsa(a,b,d)};e.W=function(a){switch(a){case 0:return this.pb();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermTupleImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({YR:0},!1,"scala.meta.Term$Tuple$TermTupleImpl",{YR:1,f:1,WR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function B7(){this.Kc=this.gc=this.s=this.aa=this.m=null}B7.prototype=new m;B7.prototype.constructor=B7;e=B7.prototype;e.Oa=function(){G();var a=(new r).d(["expr","body"]),b=G().b;return H(a,b)};e.U=function(){return"Term.While"};e.Na=function(){return this};
e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ob();case 1:return this.Nb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Zea(a,b,d)};e.v=function(){return to(uo(),this)};e.ob=function(){if(null===this.gc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermWhileImpl.expr");var a=this.m.ob(),b=this.m.ob();this.gc=a.y(b,this,null,a.s)}return this.gc};
e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermWhileImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ob(),this.Nb()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};function Zea(a,b,c){var d=new B7;d.m=a;d.aa=b;d.s=c;d.gc=null;d.Kc=null;return d}
e.$classData=l({aS:0},!1,"scala.meta.Term$While$TermWhileImpl",{aS:1,f:1,ZR:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function C7(){this.fc=this.Ff=this.s=this.aa=this.m=null}C7.prototype=new m;C7.prototype.constructor=C7;e=C7.prototype;e.Oa=function(){G();var a=(new r).d(["parts","args"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Xml"};e.Na=function(){return this};e.M=function(){return 2};function Psa(a,b,c){var d=new C7;d.m=a;d.aa=b;d.s=c;d.Ff=null;d.fc=null;return d}
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qe();case 1:return this.pb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Psa(a,b,d)};e.v=function(){return to(uo(),this)};
e.Qe=function(){if(null===this.Ff){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermXmlImpl.parts");var a=this.m.Qe(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Ff=b}return this.Ff};
e.pb=function(){if(null===this.fc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermXmlImpl.args");var a=this.m.pb(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.fc=b}return this.fc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qe(),c=G(),a=a.ma(b,c.b),b=F(),c=G(),a=a.ma(b,c.b),b=this.pb(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};e.$classData=l({dS:0},!1,"scala.meta.Term$Xml$TermXmlImpl",{dS:1,f:1,bS:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1});function hi(a){return!!(a&&a.$classData&&a.$classData.H.Eq)}var Jwa=l({Eq:0},!0,"scala.meta.Type$Name",{Eq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Bo:1,wd:1});
function D7(a){var b=(new Fd).mc(a.Za());a=a.dc();rBa(b,a);return b}function E7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}E7.prototype=new m;E7.prototype.constructor=E7;e=E7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Case.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){return Xpa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.uC&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.uC&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.zm=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.v=function(){return to(uo(),this)};e.Re=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CaseQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(I3),this.ca)};e.Nb=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};function Xpa(a,b,c,d){var f=new E7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({YK:0},!1,"scala.meta.Case$Quasi$CaseQuasiImpl",{YK:1,f:1,uC:1,qt:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function F7(){this.ld=this.xh=this.Id=this.Pa=this.gb=this.s=this.aa=this.m=null}F7.prototype=new m;F7.prototype.constructor=F7;function $pa(a,b,c){var d=new F7;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Id=null;d.xh=null;d.ld=null;return d}e=F7.prototype;
e.Oa=function(){G();var a=(new r).d(["mods","name","paramss","init","stats"]),b=G().b;return H(a,b)};e.U=function(){return"Ctor.Secondary"};e.Na=function(){return this};e.M=function(){return 5};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.xb();case 2:return this.bd();case 3:return this.ff();case 4:return this.ub();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return $pa(a,b,d)};e.v=function(){return to(uo(),this)};
e.bd=function(){if(null===this.Id){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorSecondaryImpl.paramss");var a=this.m.bd(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;
if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Id=b}return this.Id};e.ff=function(){if(null===this.xh){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorSecondaryImpl.init");var a=this.m.ff(),b=this.m.ff();this.xh=a.y(b,this,null,a.s)}return this.xh};
e.xb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorSecondaryImpl.name");var a=this.m.xb(),b=this.m.xb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.xb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);c=this.bd();G();for(b=(new ae).c();!c.g();){var d=c.n().dc();Ll(b,d);c=c.o()}b=b.lb();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.ff()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.ub();c=G();a=a.ma(b,c.b);b=F();c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorSecondaryImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing CtorSecondaryImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({eL:0},!1,"scala.meta.Ctor$Secondary$CtorSecondaryImpl",{eL:1,f:1,cL:1,vw:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,gf:1,Ub:1});function G7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}G7.prototype=new m;G7.prototype.constructor=G7;e=G7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Enumerator.Quasi"};e.Na=function(){return this};function sqa(a,b,c,d){var f=new G7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.M=function(){return 2};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return sqa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&QR(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&QR(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing EnumeratorQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(J3),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({gM:0},!1,"scala.meta.Enumerator$Quasi$EnumeratorQuasiImpl",{gM:1,f:1,eM:1,zo:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function H7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}H7.prototype=new m;H7.prototype.constructor=H7;e=H7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Importer.Quasi"};e.Na=function(){return this};
e.M=function(){return 2};function Bqa(a,b,c,d){var f=new H7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Bqa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.wC&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.wC&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporterQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(uwa),this.ca)};
e.ve=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.A=function(){return Ia(this)};e.Tk=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({GM:0},!1,"scala.meta.Importer$Quasi$ImporterQuasiImpl",{GM:1,f:1,wC:1,st:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});
function wH(a){return!!(a&&a.$classData&&a.$classData.H.PM)}function fG(a){return!!(a&&a.$classData&&a.$classData.H.SM)}function hG(a){return!!(a&&a.$classData&&a.$classData.H.VM)}function sH(a){return!!(a&&a.$classData&&a.$classData.H.$M)}function xH(a){return!!(a&&a.$classData&&a.$classData.H.hN)}function on(a){return!!(a&&a.$classData&&a.$classData.H.kN)}function I7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}I7.prototype=new m;I7.prototype.constructor=I7;e=I7.prototype;
e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Mod.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return era(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&Az(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&Az(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};function era(a,b,c,d){var f=new I7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ModQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(K3),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({eO:0},!1,"scala.meta.Mod$Quasi$ModQuasiImpl",{eO:1,f:1,DC:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function wS(a){return!!(a&&a.$classData&&a.$classData.H.sn)}var S3=l({sn:0},!0,"scala.meta.Name$Quasi",{sn:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,cj:1,Rd:1});function J7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}J7.prototype=new m;
J7.prototype.constructor=J7;e=J7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Pat.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return ura(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&HS(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&HS(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};function ura(a,b,c,d){var f=new J7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(vwa),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({UO:0},!1,"scala.meta.Pat$Quasi$PatQuasiImpl",{UO:1,f:1,zq:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function K7(){this.Pa=this.s=this.aa=this.m=null}K7.prototype=new m;K7.prototype.constructor=K7;e=K7.prototype;e.U=function(){return"Pat.Var"};e.Oa=function(){G();var a=(new r).d(["name"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};
e.w=function(a){return this===a};
e.y=function(a,b,c,d){if(null!==c){var f;fL();a:{var g;g=null===this?S():(new T).e(this.yb());if(!g.g()&&(g=g.q(),g=null===g?S():(new T).e(g.ec()),!g.g())){g=g.q();break a}throw(new p).e(this);}f=(new cd).j(g);cj(f)?(g=65535&(g.charCodeAt(0)|0),f=qi(),g=8544<=g&&8559>=g||9398<=g&&9423>=g||1===WH(f,g)):g=!1;(g=!g)||(g=v(),g=z(g,b),GR||(GR=(new FR).c()),g=y(g,GR)?"pats"===c:!1);g||(g=v(),g=z(g,b),IR||(IR=(new HR).c()),g=y(g,IR)?"pats"===c:!1);g||(g=v(),g=z(g,b),KR||(KR=(new JR).c()),g=y(g,KR)?"pats"===
c:!1);g||(g=v(),g=z(g,b),MR||(MR=(new LR).c()),g=y(g,MR)?"pats"===c:!1);g||(g=v(),g=y(z(g,b),rla())?"pat"===c:!1);g||(g=v(),g=z(g,b),TR||(TR=(new SR).c()),g=y(g,TR)?"pat"===c:!1);f=g;if(!f){var h=b.U();if(f)g=(new q).a(!0,F());else{G();g=(new r).d(["parentCheckOk is false"]);var n=G().b;g=(new q).a(!1,H(g,n))}if(null===g||!0!==I(g)){if(null!==g&&(a=g.p(),!1===I(g))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("PatVarImpl",this),(new q).a("parentPrefix",h),(new q).a("destination",
c)];d=A(new B,C());f=0;for(h=c.length|0;f<h;)E(d,c[f]),f=1+f|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",a,d.t)}throw(new p).e(g);}}}return Dra(a,b,d)};e.W=function(a){switch(a){case 0:return this.yb();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function Dra(a,b,c){var d=new K7;d.m=a;d.aa=b;d.s=c;d.Pa=null;return d}
e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PatVarImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.yb()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({gP:0},!1,"scala.meta.Pat$Var$PatVarImpl",{gP:1,f:1,eP:1,he:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ao:1,gf:1});
function L7(){this.oe=this.Pa=this.gb=this.s=this.aa=this.m=null}L7.prototype=new m;L7.prototype.constructor=L7;e=L7.prototype;e.Oa=function(){G();var a=(new r).d(["mods","name","templ"]),b=G().b;return H(a,b)};e.U=function(){return"Pkg.Object"};e.Na=function(){return this};e.M=function(){return 3};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.yb();case 2:return this.Qc();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Kra(a,b,d)};
e.v=function(){return to(uo(),this)};e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PkgObjectImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.yb(),this.Qc()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};
function Kra(a,b,c){var d=new L7;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.oe=null;return d}e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PkgObjectImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Qc=function(){if(null===this.oe){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PkgObjectImpl.templ");var a=this.m.Qc(),b=this.m.Qc();this.oe=a.y(b,this,null,a.s)}return this.oe};e.$classData=l({uP:0},!1,"scala.meta.Pkg$Object$PkgObjectImpl",{uP:1,f:1,sP:1,Ao:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ub:1});function M7(){this.ld=this.Ah=this.s=this.aa=this.m=null}M7.prototype=new m;M7.prototype.constructor=M7;e=M7.prototype;
e.Oa=function(){G();var a=(new r).d(["ref","stats"]),b=G().b;return H(a,b)};e.U=function(){return"Pkg"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ve();case 1:return this.ub();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Ira(a,b,d)};e.v=function(){return to(uo(),this)};function Ira(a,b,c){var d=new M7;d.m=a;d.aa=b;d.s=c;d.Ah=null;d.ld=null;return d}
e.ve=function(){if(null===this.Ah){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PkgImpl.ref");var a=this.m.ve(),b=this.m.ve();this.Ah=a.y(b,this,null,a.s)}return this.Ah};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ve()]),b=G().b,a=H(a,b),b=this.ub(),c=G(),a=a.ma(b,c.b),b=F(),c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.ub=function(){if(null===this.ld){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing PkgImpl.stats");var a=this.m.ub(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.ld=b}return this.ld};
e.$classData=l({vP:0},!1,"scala.meta.Pkg$PkgImpl",{vP:1,f:1,qP:1,Ao:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ub:1});function N7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}N7.prototype=new m;N7.prototype.constructor=N7;e=N7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Ref.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return zwa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&pL(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&pL(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};function zwa(a,b,c,d){var f=new N7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing RefQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(wwa),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({xP:0},!1,"scala.meta.Ref$Quasi$RefQuasiImpl",{xP:1,f:1,cj:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});var Ewa=l({wt:0},!0,"scala.meta.Self$Quasi",{wt:1,Aq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,yq:1,Rd:1});function O7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}O7.prototype=new m;O7.prototype.constructor=O7;e=O7.prototype;
e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Stat.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Rra(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&rL(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&rL(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing StatQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(L3),this.ca)};function Rra(a,b,c,d){var f=new O7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({HP:0},!1,"scala.meta.Stat$Quasi$StatQuasiImpl",{HP:1,f:1,dl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function P7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}P7.prototype=new m;P7.prototype.constructor=P7;e=P7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Template.Quasi"};e.Na=function(){return this};
e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Gwa(a,b,d,this.ca)};e.Si=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&TS(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&TS(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.Xi=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TemplateQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};
e.uc=function(){return hL(jL(),k(xwa),this.ca)};function Gwa(a,b,c,d){var f=new P7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.Zg=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.ub=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.$classData=l({LP:0},!1,"scala.meta.Template$Quasi$TemplateQuasiImpl",{LP:1,f:1,JP:1,xt:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function xla(a){return!!(a&&a.$classData&&a.$classData.H.Fw)}var R3=l({Fw:0},!0,"scala.meta.Term$Param$Quasi",{Fw:1,Cq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,yq:1,Rd:1});function Ff(a){return!!(a&&a.$classData&&a.$classData.H.tn)}var O3=l({tn:0},!0,"scala.meta.Term$Quasi",{tn:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,dl:1,Rd:1});
function Df(a){return!!(a&&a.$classData&&a.$classData.H.CR)}var Bwa=l({zt:0},!0,"scala.meta.Type$Param$Quasi",{zt:1,Fq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,yq:1,Rd:1});function Q7(){this.Pa=this.Hf=this.s=this.aa=this.m=null}Q7.prototype=new m;Q7.prototype.constructor=Q7;e=Q7.prototype;e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeProjectImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};
e.Oa=function(){G();var a=(new r).d(["qual","name"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Project"};e.Na=function(){return this};e.M=function(){return 2};function ui(a){if(null===a.Hf){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TypeProjectImpl.qual");var b=ui(a.m),c=ui(a.m);a.Hf=b.y(c,a,null,b.s)}return a.Hf}e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return ui(this);case 1:return this.nc();default:throw(new W).j(""+a);}};
e.y=function(a,b,c,d){return vta(a,b,d)};e.v=function(){return to(uo(),this)};function vta(a,b,c){var d=new Q7;d.m=a;d.aa=b;d.s=c;d.Hf=null;d.Pa=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([ui(this),this.nc()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({hT:0},!1,"scala.meta.Type$Project$TypeProjectImpl",{hT:1,f:1,fT:1,Bo:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});
function W7(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}W7.prototype=new m;W7.prototype.constructor=W7;e=W7.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return xta(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&Eu(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&Eu(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(M3),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};function xta(a,b,c,d){var f=new W7;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.$classData=l({jT:0},!1,"scala.meta.Type$Quasi$TypeQuasiImpl",{jT:1,f:1,Gq:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,Rd:1});function f8(){this.Pa=this.Hf=this.s=this.aa=this.m=null}f8.prototype=new m;f8.prototype.constructor=f8;e=f8.prototype;
e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeSelectImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.Oa=function(){G();var a=(new r).d(["qual","name"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Select"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return wl(this);case 1:return this.nc();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Bta(a,b,d)};e.v=function(){return to(uo(),this)};function Bta(a,b,c){var d=new f8;d.m=a;d.aa=b;d.s=c;d.Hf=null;d.Pa=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([wl(this),this.nc()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
function wl(a){if(null===a.Hf){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TypeSelectImpl.qual");var b=wl(a.m),c=wl(a.m);a.Hf=b.y(c,a,null,b.s)}return a.Hf}e.$classData=l({uT:0},!1,"scala.meta.Type$Select$TypeSelectImpl",{uT:1,f:1,sT:1,Bo:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function g8(){this.Ah=this.s=this.aa=this.m=null}g8.prototype=new m;g8.prototype.constructor=g8;function Dta(a,b,c){var d=new g8;d.m=a;d.aa=b;d.s=c;d.Ah=null;return d}e=g8.prototype;
e.U=function(){return"Type.Singleton"};e.Oa=function(){G();var a=(new r).d(["ref"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Dta(a,b,d)};e.W=function(a){switch(a){case 0:return this.ve();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.ve=function(){if(null===this.Ah){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeSingletonImpl.ref");var a=this.m.ve(),b=this.m.ve();this.Ah=a.y(b,this,null,a.s)}return this.Ah};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.ve()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({xT:0},!1,"scala.meta.Type$Singleton$TypeSingletonImpl",{xT:1,f:1,vT:1,Bo:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});
function h8(){this.Pa=this.s=this.aa=this.m=null}h8.prototype=new m;h8.prototype.constructor=h8;e=h8.prototype;e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeVarImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.U=function(){return"Type.Var"};e.Oa=function(){G();var a=(new r).d(["name"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};
e.w=function(a){return this===a};
e.y=function(a,b,c,d){if(null!==c){var f;fL();f=Qia((new T).e(this));if(!f){var g=b.U();if(f)var h=(new q).a(!0,F());else{G();var h=(new r).d(["parentCheckOk is false"]),n=G().b,h=(new q).a(!1,H(h,n))}if(null===h||!0!==I(h)){if(null!==h&&(a=h.p(),!1===I(h))){b=J();c=[(new q).a("this",this),(new q).a("parentCheckOk",f),(new q).a("TypeVarImpl",this),(new q).a("parentPrefix",g),(new q).a("destination",c)];f=A(new B,C());g=0;for(d=c.length|0;g<d;)E(f,c[g]),g=1+g|0;K(b,"parentCheckOk.\x26\x26(org.scalameta.`package`.debug(this, parentPrefix, destination))",
a,f.t)}throw(new p).e(h);}}}return Hta(a,b,d)};e.W=function(a){switch(a){case 0:return this.nc();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function Hta(a,b,c){var d=new h8;d.m=a;d.aa=b;d.s=c;d.Pa=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.nc()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({FT:0},!1,"scala.meta.Type$Var$TypeVarImpl",{FT:1,f:1,DT:1,wd:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,ut:1,gf:1});
function eo(a){return xm(a)?Cp(new Dp,a,a.Fa()).bb():a.rc(0)}function i8(a,b){return a.Fa()-b|0}function k8(a,b){if(b&&b.$classData&&b.$classData.H.Cg){var c=a.Fa();if(c===b.Fa()){for(var d=0;d<c&&dj(ej(),a.rc(d),b.rc(d));)d=1+d|0;return d===c}return!1}return aBa(a,b)}function x8(a,b){return sBa(a,b,!1)!==a.Fa()}function xm(a){return 0===a.Fa()}function sBa(a,b,c){for(var d=0;d<a.Fa()&&!!b.Ea(a.rc(d))===c;)d=1+d|0;return d}function y8(a,b){return sBa(a,b,!0)===a.Fa()}
function z8(a){return 0<a.Fa()?a.Eg(0,-1+a.Fa()|0):oD(a)}function A8(a,b){for(var c=0,d=a.Fa();c<d;)b.Ea(a.rc(c)),c=1+c|0}function B8(a,b,c){b=0<b?b:0;c=0<c?c:0;var d=a.Fa();c=c<d?c:d;var d=c-b|0,f=0<d?d:0,d=a.ic();for(d.je(f);b<c;)d.ba(a.rc(b)),b=1+b|0;return d.da()}function Hd(a){return 0<a.Fa()?a.rc(-1+a.Fa()|0):Zva(a)}function I8(a){return xm(a)?$va(a):a.Eg(1,a.Fa())}function J8(a,b,c,d,f){for(;;){if(b===c)return d;var g=1+b|0;d=f.ug(d,a.rc(b));b=g}}
function K8(a,b,c,d){var f=0,g=c,h=a.Fa();d=h<d?h:d;c=fO(gO(),b)-c|0;for(c=d<c?d:c;f<c;)bQ(gO(),b,g,a.rc(f)),f=1+f|0,g=1+g|0}function L8(a,b){if(0<a.Fa()){var c=a.Fa(),d=a.rc(0);return J8(a,1,c,d,b)}return lO(a,b)}function ro(a,b){a=a.FA(b);if(0>b||a.g())throw(new W).j(""+b);return a.n()}function qo(a,b){if(0>b)b=1;else a:{var c=0;for(;;){if(c===b){b=a.g()?0:1;break a}if(a.g()){b=-1;break a}c=1+c|0;a=a.o()}}return b}function tBa(a,b){for(;!a.g();){if(b.Ea(a.n()))return!0;a=a.o()}return!1}
function M8(a,b){if(b&&b.$classData&&b.$classData.H.Co){if(a===b)return!0;for(;!a.g()&&!b.g()&&dj(ej(),a.n(),b.n());)a=a.o(),b=b.o();return a.g()&&b.g()}return aBa(a,b)}function uBa(a,b){for(;!a.g();){if(!b.Ea(a.n()))return!1;a=a.o()}return!0}function vBa(a,b,c){for(;!a.g();)b=c.ug(b,a.n()),a=a.o();return b}function Cg(a){for(var b=0;!a.g();)b=1+b|0,a=a.o();return b}function cl(a){if(a.g())throw(new BP).c();for(var b=a.o();!b.g();)a=b,b=b.o();return a.n()}
function wBa(a,b){return 0<=b&&0<qo(a,b)}function xBa(a,b){if(a.g())throw(new Gq).j("empty.reduceLeft");return a.o().se(a.n(),b)}function yBa(a){var b=(new Fd).mc(a.Za());a.Cb(lk(function(a,b){return function(a){return Gd(b,a)}}(a,b)));return b}function N8(a,b){return b.dc().Gg(a,Wm(function(){return function(a,b){return a.ki(b)}}(a)))}function O8(){this.Lc=this.Id=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}O8.prototype=new m;O8.prototype.constructor=O8;e=O8.prototype;
e.Oa=function(){G();var a=(new r).d(["mods","name","tparams","paramss","decltpe"]),b=G().b;return H(a,b)};e.U=function(){return"Decl.Def"};e.Na=function(){return this};e.M=function(){return 5};e.df=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclDefImpl.decltpe");var a=this.m.df(),b=this.m.df();this.Lc=a.y(b,this,null,a.s)}return this.Lc};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.yb();case 2:return this.lc();case 3:return this.bd();case 4:return this.df();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return aqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclDefImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
function aqa(a,b,c){var d=new O8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Id=null;d.Lc=null;return d}
e.bd=function(){if(null===this.Id){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclDefImpl.paramss");var a=this.m.bd(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;if(c===
G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Id=b}return this.Id};e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclDefImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.yb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);c=this.bd();G();for(b=(new ae).c();!c.g();){var d=c.n().dc();Ll(b,d);c=c.o()}b=b.lb();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.df()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclDefImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.$classData=l({jL:0},!1,"scala.meta.Decl$Def$DeclDefImpl",{jL:1,f:1,hL:1,rt:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ao:1,gf:1});function P8(){this.Ij=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}P8.prototype=new m;P8.prototype.constructor=P8;e=P8.prototype;e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclTypeImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};
e.Oa=function(){G();var a=(new r).d(["mods","name","tparams","bounds"]),b=G().b;return H(a,b)};e.U=function(){return"Decl.Type"};e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.nc();case 2:return this.lc();case 3:return this.Gh();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return cqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclTypeImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
function cqa(a,b,c){var d=new P8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Ij=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.nc()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.Gh()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};
e.Gh=function(){if(null===this.Ij){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclTypeImpl.bounds");var a=this.m.Gh(),b=this.m.Gh();this.Ij=jA(b,this,a.s)}return this.Ij};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DeclTypeImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.$classData=l({mL:0},!1,"scala.meta.Decl$Type$DeclTypeImpl",{mL:1,f:1,kL:1,rt:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,ut:1,gf:1});function Q8(){this.oe=this.Mj=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}Q8.prototype=new m;Q8.prototype.constructor=Q8;e=Q8.prototype;e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnClassImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};
e.Oa=function(){G();var a=(new r).d(["mods","name","tparams","ctor","templ"]),b=G().b;return H(a,b)};e.U=function(){return"Defn.Class"};e.Na=function(){return this};e.M=function(){return 5};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.nc();case 2:return this.lc();case 3:return this.jh();case 4:return this.Qc();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return gqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnClassImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
e.jh=function(){if(null===this.Mj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnClassImpl.ctor");var a=this.m.jh(),b=this.m.jh();this.Mj=RW(b,this,a.s)}return this.Mj};function gqa(a,b,c){var d=new Q8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Mj=null;d.oe=null;return d}e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.nc()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.jh(),this.Qc()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnClassImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Qc=function(){if(null===this.oe){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnClassImpl.templ");var a=this.m.Qc(),b=this.m.Qc();this.oe=a.y(b,this,null,a.s)}return this.oe};e.$classData=l({xL:0},!1,"scala.meta.Defn$Class$DefnClassImpl",{xL:1,f:1,vL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,ut:1,gf:1});function R8(){this.Kc=this.Lc=this.Id=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}R8.prototype=new m;R8.prototype.constructor=R8;e=R8.prototype;
e.U=function(){return"Defn.Def"};e.Oa=function(){G();var a=(new r).d("mods name tparams paramss decltpe body".split(" ")),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 6};e.w=function(a){return this===a};e.y=function(a,b,c,d){return hqa(a,b,d)};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.yb();case 2:return this.lc();case 3:return this.bd();case 4:return this.sc();case 5:return this.Nb();default:throw(new W).j(""+a);}};
e.v=function(){return to(uo(),this)};e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnDefImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
e.bd=function(){if(null===this.Id){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnDefImpl.paramss");var a=this.m.bd(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;if(c===
G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Id=b}return this.Id};e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnDefImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};
e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnDefImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.sc=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnDefImpl.decltpe");var a=this.m.sc();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Lc=a}return this.Lc};
function hqa(a,b,c){var d=new R8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Id=null;d.Lc=null;d.Kc=null;return d}e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.yb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);c=this.bd();G();for(b=(new ae).c();!c.g();){var d=c.n().dc();Ll(b,d);c=c.o()}b=b.lb();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);b=this.sc().lb();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.Nb()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnDefImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.$classData=l({AL:0},!1,"scala.meta.Defn$Def$DefnDefImpl",{AL:1,f:1,yL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ao:1,gf:1});function S8(){this.Kc=this.Lc=this.Id=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}S8.prototype=new m;S8.prototype.constructor=S8;e=S8.prototype;e.U=function(){return"Defn.Macro"};e.Oa=function(){G();var a=(new r).d("mods name tparams paramss decltpe body".split(" ")),b=G().b;return H(a,b)};e.Na=function(){return this};
function jqa(a,b,c){var d=new S8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Id=null;d.Lc=null;d.Kc=null;return d}e.M=function(){return 6};e.w=function(a){return this===a};e.y=function(a,b,c,d){return jqa(a,b,d)};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.yb();case 2:return this.lc();case 3:return this.bd();case 4:return this.sc();case 5:return this.Nb();default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnMacroImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
e.bd=function(){if(null===this.Id){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnMacroImpl.paramss");var a=this.m.bd(),b=function(a){return function(b){var c=function(a){return function(b){return b.y(b,a,null,b.s)}}(a),d=G().b;if(d===G().b){if(b===F())return F();var d=b.n(),f=d=U(new V,c(d),F());for(b=b.o();b!==F();){var D=b.n(),D=U(new V,c(D),F()),f=f.ga=D;b=b.o()}return d}for(d=zg(b,d);!b.g();)f=b.n(),d.ba(c(f)),b=b.o();return d.da()}}(this),c=G().b;if(c===
G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Id=b}return this.Id};e.Nb=function(){if(null===this.Kc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnMacroImpl.body");var a=this.m.Nb(),b=this.m.Nb();this.Kc=a.y(b,this,null,a.s)}return this.Kc};
e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnMacroImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.sc=function(){if(null===this.Lc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnMacroImpl.decltpe");var a=this.m.sc();a.g()?a=S():(a=a.q(),a=(new T).e(a.y(a,this,null,a.s)));this.Lc=a}return this.Lc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.yb()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);c=this.bd();G();for(b=(new ae).c();!c.g();){var d=c.n().dc();Ll(b,d);c=c.o()}b=b.lb();c=G();a=a.ma(b,c.b);b=F();c=G();a=a.ma(b,c.b);b=this.sc().lb();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.Nb()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnMacroImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.$classData=l({DL:0},!1,"scala.meta.Defn$Macro$DefnMacroImpl",{DL:1,f:1,BL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ao:1,gf:1});function T8(){this.oe=this.Pa=this.gb=this.s=this.aa=this.m=null}T8.prototype=new m;T8.prototype.constructor=T8;e=T8.prototype;e.Oa=function(){G();var a=(new r).d(["mods","name","templ"]),b=G().b;return H(a,b)};e.U=function(){return"Defn.Object"};e.Na=function(){return this};e.M=function(){return 3};
function kqa(a,b,c){var d=new T8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.oe=null;return d}e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.yb();case 2:return this.Qc();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return kqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnObjectImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.yb(),this.Qc()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnObjectImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.Qc=function(){if(null===this.oe){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnObjectImpl.templ");var a=this.m.Qc(),b=this.m.Qc();this.oe=a.y(b,this,null,a.s)}return this.oe};e.$classData=l({GL:0},!1,"scala.meta.Defn$Object$DefnObjectImpl",{GL:1,f:1,EL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Ao:1,gf:1});function U8(){this.oe=this.Mj=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}U8.prototype=new m;U8.prototype.constructor=U8;e=U8.prototype;
e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTraitImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.Oa=function(){G();var a=(new r).d(["mods","name","tparams","ctor","templ"]),b=G().b;return H(a,b)};e.U=function(){return"Defn.Trait"};e.Na=function(){return this};e.M=function(){return 5};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.nc();case 2:return this.lc();case 3:return this.jh();case 4:return this.Qc();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return lqa(a,b,d)};e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTraitImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};
e.jh=function(){if(null===this.Mj){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTraitImpl.ctor");var a=this.m.jh(),b=this.m.jh();this.Mj=RW(b,this,a.s)}return this.Mj};e.A=function(){return Ia(this)};e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.nc()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);G();b=(new r).d([this.jh(),this.Qc()]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTraitImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
function lqa(a,b,c){var d=new U8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Mj=null;d.oe=null;return d}e.Qc=function(){if(null===this.oe){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTraitImpl.templ");var a=this.m.Qc(),b=this.m.Qc();this.oe=a.y(b,this,null,a.s)}return this.oe};e.$classData=l({JL:0},!1,"scala.meta.Defn$Trait$DefnTraitImpl",{JL:1,f:1,HL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,ut:1,gf:1});
function V8(){this.Kc=this.Mc=this.Pa=this.gb=this.s=this.aa=this.m=null}V8.prototype=new m;V8.prototype.constructor=V8;e=V8.prototype;e.nc=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTypeImpl.name");var a=this.m.nc(),b=this.m.nc();this.Pa=a.y(b,this,null,a.s)}return this.Pa};e.Oa=function(){G();var a=(new r).d(["mods","name","tparams","body"]),b=G().b;return H(a,b)};e.U=function(){return"Defn.Type"};
function Rk(a){if(null===a.Kc){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing DefnTypeImpl.body");var b=Rk(a.m),c=Rk(a.m);a.Kc=b.y(c,a,null,b.s)}return a.Kc}e.Na=function(){return this};e.M=function(){return 4};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Qa();case 1:return this.nc();case 2:return this.lc();case 3:return Rk(this);default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return mqa(a,b,d)};
function mqa(a,b,c){var d=new V8;d.m=a;d.aa=b;d.s=c;d.gb=null;d.Pa=null;d.Mc=null;d.Kc=null;return d}e.v=function(){return to(uo(),this)};
e.lc=function(){if(null===this.Mc){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTypeImpl.tparams");var a=this.m.lc(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.Mc=b}return this.Mc};e.A=function(){return Ia(this)};
e.Ma=function(){var a=F(),b=this.Qa(),c=G(),a=a.ma(b,c.b);G();b=(new r).d([this.nc()]);c=G().b;b=H(b,c);c=G();a=a.ma(b,c.b);b=this.lc();c=G();a=a.ma(b,c.b);G();b=(new r).d([Rk(this)]);c=G().b;b=H(b,c);c=G();return a.ma(b,c.b)};e.L=function(){return Z(this)};
e.Qa=function(){if(null===this.gb){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing DefnTypeImpl.mods");var a=this.m.Qa(),b=function(a){return function(b){return b.y(b,a,null,b.s)}}(this),c=G().b;if(c===G().b)if(a===F())b=F();else{for(var c=a.n(),d=c=U(new V,b(c),F()),a=a.o();a!==F();)var f=a.n(),f=U(new V,b(f),F()),d=d.ga=f,a=a.o();b=c}else{for(c=zg(a,c);!a.g();)d=a.n(),c.ba(b(d)),a=a.o();b=c.da()}this.gb=b}return this.gb};
e.$classData=l({ML:0},!1,"scala.meta.Defn$Type$DefnTypeImpl",{ML:1,f:1,KL:1,Tl:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,ut:1,gf:1});function W8(){this.So=this.Ef=this.s=this.aa=this.m=null}W8.prototype=new m;W8.prototype.constructor=W8;e=W8.prototype;e.Oa=function(){G();var a=(new r).d(["op","arg"]),b=G().b;return H(a,b)};e.U=function(){return"Term.ApplyUnary"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.Qd();case 1:return hm(this);default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return qga(a,b,d)};e.v=function(){return to(uo(),this)};function qga(a,b,c){var d=new W8;d.m=a;d.aa=b;d.s=c;d.Ef=null;d.So=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.Qd(),hm(this)]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.Qd=function(){if(null===this.Ef){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermApplyUnaryImpl.op");var a=this.m.Qd(),b=this.m.Qd();this.Ef=a.y(b,this,null,a.s)}return this.Ef};function hm(a){if(null===a.So){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermApplyUnaryImpl.arg");var b=hm(a.m),c=hm(a.m);a.So=b.y(c,a,null,b.s)}return a.So}
e.$classData=l({eQ:0},!1,"scala.meta.Term$ApplyUnary$TermApplyUnaryImpl",{eQ:1,f:1,cQ:1,zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function Pf(a){return!!(a&&a.$classData&&a.$classData.H.Bq)}var Iwa=l({Bq:0},!0,"scala.meta.Term$Name",{Bq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,zj:1,Oc:1,Ub:1,he:1});function X8(){this.ep=this.hp=this.s=this.aa=this.m=null}X8.prototype=new m;X8.prototype.constructor=X8;e=X8.prototype;
e.Oa=function(){G();var a=(new r).d(["thisp","superp"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Super"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return Im(this);case 1:return Jm(this);default:throw(new W).j(""+a);}};function Im(a){if(null===a.hp){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermSuperImpl.thisp");var b=Im(a.m),c=Im(a.m);a.hp=b.y(c,a,null,b.s)}return a.hp}
e.y=function(a,b,c,d){return Isa(a,b,d)};e.v=function(){return to(uo(),this)};function Jm(a){if(null===a.ep){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermSuperImpl.superp");var b=Jm(a.m),c=Jm(a.m);a.ep=b.y(c,a,null,b.s)}return a.ep}function Isa(a,b,c){var d=new X8;d.m=a;d.aa=b;d.s=c;d.hp=null;d.ep=null;return d}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([Im(this),Jm(this)]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({HR:0},!1,"scala.meta.Term$Super$TermSuperImpl",{HR:1,f:1,FR:1,zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function Y8(){this.Hf=this.s=this.aa=this.m=null}Y8.prototype=new m;Y8.prototype.constructor=Y8;e=Y8.prototype;e.U=function(){return"Term.This"};e.Oa=function(){G();var a=(new r).d(["qual"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Jsa(a,b,d)};
e.W=function(a){switch(a){case 0:return Lm(this);default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function Lm(a){if(null===a.Hf){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermThisImpl.qual");var b=Lm(a.m),c=Lm(a.m);a.Hf=b.y(c,a,null,b.s)}return a.Hf}e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([Lm(this)]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
function Jsa(a,b,c){var d=new Y8;d.m=a;d.aa=b;d.s=c;d.Hf=null;return d}e.$classData=l({LR:0},!1,"scala.meta.Term$This$TermThisImpl",{LR:1,f:1,JR:1,zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1});function Z8(){this.Ab=this.s=this.aa=this.m=null}Z8.prototype=new m;Z8.prototype.constructor=Z8;e=Z8.prototype;e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Name"};e.Na=function(){return this};e.M=function(){return 1};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return ita(a,b,d,this.Ab)};function ita(a,b,c,d){var f=new Z8;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.v=function(){return to(uo(),this)};e.ec=function(){return this.Ab};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
e.$classData=l({TS:0},!1,"scala.meta.Type$Name$TypeNameImpl",{TS:1,f:1,Eq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Bo:1,wd:1});function zBa(a){var b=(new Fd).mc(a.Za());a.Cb(lk(function(a,b){return function(a){return Gd(b,a)}}(a,b)));return b}function ABa(a,b,c,d,f){var g=a.Jb();a=Ro(new So,g,lk(function(){return function(a){if(null!==a){var b=a.qa();a=a.p();ms||(ms=(new ls).c());return""+(""+b+" -\x3e ")+a}throw(new p).e(a);}}(a)));return jO(a,b,c,d,f)}
function $8(a,b){var c=(new Uk).e(a);a.Cb(lk(function(a,b,c){return function(a){b.Ea(a)&&(c.cb=c.cb.pk(a.qa()))}}(a,b,c)));return c.cb}function a9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}a9.prototype=new m;a9.prototype.constructor=a9;e=a9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Importee.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return xqa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.vC&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.vC&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};function xqa(a,b,c,d){var f=new a9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ImporteeQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};
e.uc=function(){return hL(jL(),k(Dwa),this.ca)};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({tM:0},!1,"scala.meta.Importee$Quasi$ImporteeQuasiImpl",{tM:1,f:1,vC:1,rn:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1,Yd:1,Rd:1,cj:1});function b9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}b9.prototype=new m;b9.prototype.constructor=b9;e=b9.prototype;
e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Init.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.Db=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Fqa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.xC&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.xC&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};function Fqa(a,b,c,d){var f=new b9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.v=function(){return to(uo(),this)};e.dn=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing InitQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(U3),this.ca)};e.tl=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.xb=function(){this.dn()};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({KM:0},!1,"scala.meta.Init$Quasi$InitQuasiImpl",{KM:1,f:1,xC:1,tt:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,cj:1,Rd:1});function c9(){this.s=this.aa=this.m=null;this.Ab=!1}c9.prototype=new m;c9.prototype.constructor=c9;e=c9.prototype;e.U=function(){return"Lit.Boolean"};e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};
e.Xf=function(){return this.Ab};e.w=function(a){return this===a};e.y=function(a,b,c,d){return Iqa(a,b,d,this.Ab)};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};function Iqa(a,b,c,d){var f=new c9;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
e.$classData=l({NM:0},!1,"scala.meta.Lit$Boolean$LitBooleanImpl",{NM:1,f:1,yC:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function d9(){this.s=this.aa=this.m=null;this.Ab=0}d9.prototype=new m;d9.prototype.constructor=d9;e=d9.prototype;e.U=function(){return"Lit.Char"};e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return(new ed).db(this.Ab)};e.w=function(a){return this===a};
e.y=function(a,b,c,d){return tda(a,b,d,this.Ab)};e.W=function(a){switch(a){case 0:return(new ed).db(this.Ab);default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};function tda(a,b,c,d){var f=new d9;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.$classData=l({RM:0},!1,"scala.meta.Lit$Char$LitCharImpl",{RM:1,f:1,PM:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});
function e9(){this.li=this.s=this.aa=this.m=null;this.pa=0}e9.prototype=new m;e9.prototype.constructor=e9;e=e9.prototype;e.U=function(){return"Lit.Double"};e.Oa=function(){G();var a=(new r).d(["format"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return this.pa};e.w=function(a){return this===a};e.y=function(a,b,c,d){return rda(a,b,d,this.li)};e.W=function(a){switch(a){case 0:return this.li;default:throw(new W).j(""+a);}};
e.v=function(){return to(uo(),this)};function rda(a,b,c,d){var f=new e9;f.m=a;f.aa=b;f.s=c;f.li=d;a=(new cd).j(f.li);f.pa=uH(vH(),a.ka);return f}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({UM:0},!1,"scala.meta.Lit$Double$LitDoubleImpl",{UM:1,f:1,SM:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function f9(){this.li=this.s=this.aa=this.m=null;this.pa=0}f9.prototype=new m;f9.prototype.constructor=f9;e=f9.prototype;
e.U=function(){return"Lit.Float"};e.Oa=function(){G();var a=(new r).d(["format"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return this.pa};e.w=function(a){return this===a};e.y=function(a,b,c,d){return pda(a,b,d,this.li)};e.W=function(a){switch(a){case 0:return this.li;default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
function pda(a,b,c,d){var f=new f9;f.m=a;f.aa=b;f.s=c;f.li=d;a=(new cd).j(f.li).ka;f.pa=ga(uH(vH(),a));return f}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({XM:0},!1,"scala.meta.Lit$Float$LitFloatImpl",{XM:1,f:1,VM:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function g9(){this.s=this.aa=this.m=null;this.Ab=0}g9.prototype=new m;g9.prototype.constructor=g9;e=g9.prototype;e.U=function(){return"Lit.Int"};
e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return this.Ab};e.w=function(a){return this===a};e.y=function(a,b,c,d){return lda(a,b,d,this.Ab)};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
function lda(a,b,c,d){var f=new g9;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.$classData=l({ZM:0},!1,"scala.meta.Lit$Int$LitIntImpl",{ZM:1,f:1,zC:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function it(){this.s=this.aa=this.m=null;this.Ab=ab().Uj}it.prototype=new m;it.prototype.constructor=it;e=it.prototype;e.U=function(){return"Lit.Long"};e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return this.Ab};
e.w=function(a){return this===a};e.y=function(a,b,c,d){c=new it;var f=this.Ab;c.m=a;c.aa=b;c.s=d;c.Ab=f;return c};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({bN:0},!1,"scala.meta.Lit$Long$LitLongImpl",{bN:1,f:1,$M:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function h9(){this.s=this.aa=this.m=null}
h9.prototype=new m;h9.prototype.constructor=h9;e=h9.prototype;e.Oa=function(){return F()};e.U=function(){return"Lit.Null"};e.Na=function(){return this};e.M=function(){return 0};e.Xf=function(){return null};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return yda(a,b,d)};e.v=function(){return to(uo(),this)};function yda(a,b,c){var d=new h9;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};
e.$classData=l({dN:0},!1,"scala.meta.Lit$Null$LitNullImpl",{dN:1,f:1,AC:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function i9(){this.Ab=this.s=this.aa=this.m=null}i9.prototype=new m;i9.prototype.constructor=i9;e=i9.prototype;e.U=function(){return"Lit.String"};e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return this.Ab};e.w=function(a){return this===a};
e.y=function(a,b,c,d){return Jqa(a,b,d,this.Ab)};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};e.A=function(){return Ia(this)};e.Ma=function(){return F()};function Jqa(a,b,c,d){var f=new i9;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.L=function(){return Z(this)};e.$classData=l({gN:0},!1,"scala.meta.Lit$String$LitStringImpl",{gN:1,f:1,BC:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});
function j9(){this.Ab=this.s=this.aa=this.m=null}j9.prototype=new m;j9.prototype.constructor=j9;e=j9.prototype;e.U=function(){return"Lit.Symbol"};e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.Na=function(){return this};e.M=function(){return 1};e.Xf=function(){return this.Ab};e.w=function(a){return this===a};e.y=function(a,b,c,d){return vda(a,b,d,this.Ab)};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.v=function(){return to(uo(),this)};
function vda(a,b,c,d){var f=new j9;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({jN:0},!1,"scala.meta.Lit$Symbol$LitSymbolImpl",{jN:1,f:1,hN:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});function k9(){this.s=this.aa=this.m=null}k9.prototype=new m;k9.prototype.constructor=k9;e=k9.prototype;e.Oa=function(){return F()};e.U=function(){return"Lit.Unit"};e.Na=function(){return this};e.M=function(){return 0};
e.Xf=function(){};e.w=function(a){return this===a};e.W=function(a){throw(new W).j(""+a);};e.y=function(a,b,c,d){return Mqa(a,b,d)};e.v=function(){return to(uo(),this)};function Mqa(a,b,c){var d=new k9;d.m=a;d.aa=b;d.s=c;return d}e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({mN:0},!1,"scala.meta.Lit$Unit$LitUnitImpl",{mN:1,f:1,kN:1,Ik:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,he:1,wd:1});
function l9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}l9.prototype=new m;l9.prototype.constructor=l9;function Rqa(a,b,c,d){var f=new l9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e=l9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Mod.Annot.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Rqa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.CC&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.CC&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing ModAnnotQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(P3),this.ca)};
e.ff=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({wN:0},!1,"scala.meta.Mod$Annot$Quasi$ModAnnotQuasiImpl",{wN:1,f:1,CC:1,vt:1,Ce:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,DC:1,Rd:1});function m9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}m9.prototype=new m;
m9.prototype.constructor=m9;function lra(a,b,c,d){var f=new m9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e=m9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Name.Quasi"};e.Na=function(){return this};e.ar=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return lra(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&wS(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&wS(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.ec=function(){this.ar()};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing NameQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(Cwa),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({xO:0},!1,"scala.meta.Name$Quasi$NameQuasiImpl",{xO:1,f:1,sn:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,cj:1,Rd:1});function n9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}n9.prototype=new m;n9.prototype.constructor=n9;e=n9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Self.Quasi"};e.Na=function(){return this};
e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.cv=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.y=function(a,b,c,d){return Fwa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.wt&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.wt&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};function Fwa(a,b,c,d){var f=new n9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.dn=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing SelfQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(oxa),this.ca)};e.sc=function(){this.cv()};e.xb=function(){this.dn()};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};
e.$classData=l({AP:0},!1,"scala.meta.Self$Quasi$SelfQuasiImpl",{AP:1,f:1,wt:1,Aq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,yq:1,Rd:1});function o9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}o9.prototype=new m;o9.prototype.constructor=o9;e=o9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Param.Quasi"};function wsa(a,b,c,d){var f=new o9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.Na=function(){return this};e.M=function(){return 2};
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.cv=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.y=function(a,b,c,d){return wsa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&xla(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&xla(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.ow=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.dn=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermParamQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(Q3),this.ca)};e.sc=function(){this.cv()};e.xb=function(){this.dn()};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.Qa=function(){this.ow()};
e.Bi=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.$classData=l({cR:0},!1,"scala.meta.Term$Param$Quasi$TermParamQuasiImpl",{cR:1,f:1,Fw:1,Cq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,yq:1,Rd:1});function p9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}p9.prototype=new m;p9.prototype.constructor=p9;e=p9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Quasi"};
e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return zsa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&Ff(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&Ff(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(N3),this.ca)};function zsa(a,b,c,d){var f=new p9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({oR:0},!1,"scala.meta.Term$Quasi$TermQuasiImpl",{oR:1,f:1,tn:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,dl:1,Rd:1});function q9(){this.Pa=this.Hf=this.s=this.aa=this.m=null}q9.prototype=new m;q9.prototype.constructor=q9;e=q9.prototype;e.Oa=function(){G();var a=(new r).d(["qual","name"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Select"};e.Na=function(){return this};
e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return Ef(this);case 1:return this.yb();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Gsa(a,b,d)};e.v=function(){return to(uo(),this)};function Gsa(a,b,c){var d=new q9;d.m=a;d.aa=b;d.s=c;d.Hf=null;d.Pa=null;return d}
e.yb=function(){if(null===this.Pa){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermSelectImpl.name");var a=this.m.yb(),b=this.m.yb();this.Pa=a.y(b,this,null,a.s)}return this.Pa};function Ef(a){if(null===a.Hf){if(null===a.m)throw(new t).j("requirement failed: internal error when initializing TermSelectImpl.qual");var b=Ef(a.m),c=Ef(a.m);a.Hf=b.y(c,a,null,b.s)}return a.Hf}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([Ef(this),this.yb()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({ER:0},!1,"scala.meta.Term$Select$TermSelectImpl",{ER:1,f:1,CR:1,zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1,he:1});function r9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}r9.prototype=new m;r9.prototype.constructor=r9;e=r9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Param.Quasi"};
e.am=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return rta(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.zt&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.zt&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.lc=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};function rta(a,b,c,d){var f=new r9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.ow=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.dn=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeParamQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(Awa),this.ca)};e.ym=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};
e.xb=function(){this.dn()};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.Qa=function(){this.ow()};e.im=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.$classData=l({ZS:0},!1,"scala.meta.Type$Param$Quasi$TypeParamQuasiImpl",{ZS:1,f:1,zt:1,Fq:1,gf:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Yd:1,yq:1,Rd:1});
function s9(){this.Ab=this.s=this.aa=this.m=null}s9.prototype=new m;s9.prototype.constructor=s9;e=s9.prototype;e.Oa=function(){G();var a=(new r).d(["value"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Name"};e.Na=function(){return this};e.M=function(){return 1};e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.Ab;default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return lsa(a,b,d,this.Ab)};e.v=function(){return to(uo(),this)};
function lsa(a,b,c,d){var f=new s9;f.m=a;f.aa=b;f.s=c;f.Ab=d;return f}e.ec=function(){return this.Ab};e.A=function(){return Ia(this)};e.Ma=function(){return F()};e.L=function(){return Z(this)};e.$classData=l({TQ:0},!1,"scala.meta.Term$Name$TermNameImpl",{TQ:1,f:1,Bq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,zj:1,Oc:1,Ub:1,he:1});function vI(a){return VP(a)?a.gG():a}
function BBa(a,b,c){b=0<b?b:0;var d=a.Fa(),d=c<d?c:d;if(b>=d)return a.ic().da();c=a.ic();a=a.v().substring(b,d);return c.$c((new cd).j(a)).da()}function WV(a,b){a=a.v();b=97<=b&&122>=b||65<=b&&90>=b||48<=b&&57>=b?ca.String.fromCharCode(b):"\\"+(new ed).db(b);return yka(Ga(),a,b,0)}function dd(a,b){var c=(new ql).c(),d=-1+b|0;if(!(0>=b))for(b=0;;){rl(c,a.v());if(b===d)break;b=1+b|0}return c.Qb.ac}
function Sg(a,b){var c=a.v();return 0<=(c.length|0)&&c.substring(0,b.length|0)===b?a.v().substring(b.length|0):a.v()}function Tg(a,b){if(zj(Ga(),a.v(),b)){var c=a.v();a=(a.v().length|0)-(b.length|0)|0;return c.substring(0,a)}return a.v()}
function zpa(a){var b=(new ql).c(),c=new T1;if(null===a)throw jo(wj(),null);c.Lb=a;c.Dx=a.v();c.fq=c.Dx.length|0;for(c.nh=0;c.fb();){a=Dva(c);for(var d=a.length|0,f=0;;)if(f<d&&32>=(65535&(a.charCodeAt(f)|0)))f=1+f|0;else break;a=f<d&&124===(65535&(a.charCodeAt(f)|0))?a.substring(1+f|0):a;rl(b,a)}return b.Qb.ac}function vL(a){return!!(a&&a.$classData&&a.$classData.H.Dq)}
var T3=l({Dq:0},!0,"scala.meta.Term$Ref$Quasi",{Dq:1,zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1,Yd:1,tn:1,dl:1,Rd:1,cj:1});function t9(){}t9.prototype=new mBa;t9.prototype.constructor=t9;function u9(){}e=u9.prototype=t9.prototype;e.n=function(){return this.Jb().bb()};e.ah=function(){return this.Jb()};e.$f=function(a){for(var b=this.Jb(),c=!1;!c&&b.fb();)c=!!a.Ea(b.bb());return c};e.Qf=function(a){return aBa(this,a)};e.Le=function(a){var b=this.Jb();return Goa(b,a)};
e.Cb=function(a){var b=this.Jb();QU(b,a)};e.aA=function(){return!0};e.tf=function(a){var b=this.ic();Qoa(b,this,-(0>a?0:a)|0);for(var c=0,d=this.Jb();c<a&&d.fb();)d.bb(),c=1+c|0;return b.$c(d).da()};e.ce=function(){return this.Jb().ce()};e.rf=function(a,b,c){bBa(this,a,b,c)};var Hva=l({Bd:0},!0,"scala.collection.immutable.Iterable",{Bd:1,Gd:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,Ed:1,xc:1,vc:1,Vb:1,Xb:1,x:1});function cd(){this.ka=null}cd.prototype=new m;cd.prototype.constructor=cd;
e=cd.prototype;e.dc=function(){return(new ds).j(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){a=65535&(this.ka.charCodeAt(a)|0);return(new ed).db(a)};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.length|0)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.lb=function(){var a=G().b;return H(this,a)};e.g=function(){return xm(this)};e.md=function(){return(new ds).j(this.ka)};
e.w=function(a){Wn();return a&&a.$classData&&a.$classData.H.cF?this.ka===(null===a?null:a.ka):!1};e.sl=function(a){return 65535&(this.ka.charCodeAt(a)|0)};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return this.ka};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.length|0,a,b)};e.qf=function(a){var b=this.ka;return b===a?0:b<a?-1:1};e.si=function(){return zz(this)};
e.Eg=function(a,b){return Vn(Wn(),this.ka,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.Za=function(){return this.ka.length|0};e.we=function(){return D7(this)};e.Jb=function(){return Cp(new Dp,this,this.ka.length|0)};e.Of=function(){return this.ka};e.Fa=function(){return this.ka.length|0};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.length|0};e.ce=function(){var a=Cp(new Dp,this,this.ka.length|0);return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){var b=this.ka.length|0;return Vn(Wn(),this.ka,a,b)};e.o=function(){return I8(this)};e.kf=function(){return(new ds).j(this.ka)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.length|0,a,b)};e.rf=function(a,b,c){K8(this,a,b,c)};e.ph=function(){return!0};e.A=function(){var a=this.ka;return Da(Ga(),a)};e.j=function(a){this.ka=a;return this};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};
e.$e=function(a){return L8(this,a)};e.ic=function(){return(new ql).c()};e.jf=function(){return R2(this)};e.$classData=l({cF:0},!1,"scala.collection.immutable.StringOps",{cF:1,f:1,bF:1,bf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,yo:1,xf:1});function v9(a,b,c){b=0<b?b:0;c=0<c?c:0;var d=fO(gO(),a.Se());c=(c<d?c:d)-b|0;c=0<c?c:0;d=Gr(Ir(),zr(ra(a.Se())),c);0<c&&E0(Tp(),a.Se(),b,d,0,c);return d}
function w9(a,b,c,d){var f=fO(gO(),a.Se());d=d<f?d:f;f=fO(gO(),b)-c|0;d=d<f?d:f;0<d&&E0(Tp(),a.Se(),0,b,c,d)}function x9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}x9.prototype=new m;x9.prototype.constructor=x9;e=x9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Ref.Quasi"};e.Na=function(){return this};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return Dsa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&vL(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&vL(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermRefQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(lBa),this.ca)};function Dsa(a,b,c,d){var f=new x9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({sR:0},!1,"scala.meta.Term$Ref$Quasi$TermRefQuasiImpl",{sR:1,f:1,Dq:1,zj:1,Oc:1,Ub:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Md:1,Yd:1,tn:1,dl:1,Rd:1,cj:1});var Mwa=l({yt:0},!0,"scala.meta.Type$Name$Quasi",{yt:1,Eq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Bo:1,wd:1,Yd:1,sn:1,cj:1,Rd:1,lT:1,Gq:1});function wW(){this.ka=null}wW.prototype=new m;wW.prototype.constructor=wW;e=wW.prototype;
e.dc=function(){return(new m2).fo(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new m2).fo(this.ka)};
e.w=function(a){aka||(aka=(new UO).c());return a&&a.$classData&&a.$classData.H.tF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};
e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new m2).fo(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.fo=function(a){this.ka=a;return this};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};
e.$e=function(a){return L8(this,a)};e.ic=function(){return(new l4).c()};e.jf=function(){return R2(this)};e.$classData=l({tF:0},!1,"scala.collection.mutable.ArrayOps$ofBoolean",{tF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function xW(){this.ka=null}xW.prototype=new m;xW.prototype.constructor=xW;e=xW.prototype;e.dc=function(){return(new f2).Zn(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};
e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new f2).Zn(this.ka)};e.w=function(a){bka||(bka=(new VO).c());return a&&a.$classData&&a.$classData.H.uF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};
e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};
e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new f2).Zn(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};
e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.Zn=function(a){this.ka=a;return this};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new m4).c()};e.jf=function(){return R2(this)};e.$classData=l({uF:0},!1,"scala.collection.mutable.ArrayOps$ofByte",{uF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});
function yW(){this.ka=null}yW.prototype=new m;yW.prototype.constructor=yW;e=yW.prototype;e.dc=function(){return(new h2).Uk(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return(new ed).db(this.ka.i[a])};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new h2).Uk(this.ka)};
e.w=function(a){cka||(cka=(new WO).c());return a&&a.$classData&&a.$classData.H.vF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};
e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.Uk=function(a){this.ka=a;return this};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new h2).Uk(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new n4).c()};
e.jf=function(){return R2(this)};e.$classData=l({vF:0},!1,"scala.collection.mutable.ArrayOps$ofChar",{vF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function zW(){this.ka=null}zW.prototype=new m;zW.prototype.constructor=zW;e=zW.prototype;e.dc=function(){return(new l2).$n(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};
e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new l2).$n(this.ka)};e.w=function(a){dka||(dka=(new XO).c());return a&&a.$classData&&a.$classData.H.wF?this.ka===(null===a?null:a.ka):!1};e.$n=function(a){this.ka=a;return this};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};
e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};
e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new l2).$n(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};
e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new o4).c()};e.jf=function(){return R2(this)};e.$classData=l({wF:0},!1,"scala.collection.mutable.ArrayOps$ofDouble",{wF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function AW(){this.ka=null}AW.prototype=new m;
AW.prototype.constructor=AW;e=AW.prototype;e.dc=function(){return(new k2).ao(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new k2).ao(this.ka)};
e.w=function(a){eka||(eka=(new YO).c());return a&&a.$classData&&a.$classData.H.xF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};
e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.ao=function(a){this.ka=a;return this};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new k2).ao(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new p4).c()};
e.jf=function(){return R2(this)};e.$classData=l({xF:0},!1,"scala.collection.mutable.ArrayOps$ofFloat",{xF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function BW(){this.ka=null}BW.prototype=new m;BW.prototype.constructor=BW;e=BW.prototype;e.dc=function(){return(new i2).bo(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};
e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new i2).bo(this.ka)};e.w=function(a){fka||(fka=(new ZO).c());return a&&a.$classData&&a.$classData.H.yF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};
e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.bo=function(a){this.ka=a;return this};e.Fa=function(){return this.ka.i.length};
e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new i2).bo(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};
e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new q4).c()};e.jf=function(){return R2(this)};e.$classData=l({yF:0},!1,"scala.collection.mutable.ArrayOps$ofInt",{yF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function CW(){this.ka=null}CW.prototype=new m;
CW.prototype.constructor=CW;e=CW.prototype;e.dc=function(){return(new j2).co(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.co=function(a){this.ka=a;return this};e.md=function(){return(new j2).co(this.ka)};
e.w=function(a){gka||(gka=(new $O).c());return a&&a.$classData&&a.$classData.H.zF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};
e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new j2).co(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new r4).c()};
e.jf=function(){return R2(this)};e.$classData=l({zF:0},!1,"scala.collection.mutable.ArrayOps$ofLong",{zF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function oW(){this.ka=null}oW.prototype=new m;oW.prototype.constructor=oW;e=oW.prototype;e.dc=function(){return(new e0).Bk(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};
e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new e0).Bk(this.ka)};e.w=function(a){hka||(hka=(new aP).c());return a&&a.$classData&&a.$classData.H.AF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};
e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Bk=function(a){this.ka=a;return this};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};
e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new e0).Bk(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};
e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){var a=this.ka;return(new s4).Jv(dua(fua(),zr(ra(a))))};e.jf=function(){return R2(this)};e.$classData=l({AF:0},!1,"scala.collection.mutable.ArrayOps$ofRef",{AF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});
function DW(){this.ka=null}DW.prototype=new m;DW.prototype.constructor=DW;e=DW.prototype;e.dc=function(){return(new g2).eo(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(a){return this.ka.i[a]};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};
e.eo=function(a){this.ka=a;return this};e.md=function(){return(new g2).eo(this.ka)};e.w=function(a){ika||(ika=(new bP).c());return a&&a.$classData&&a.$classData.H.BF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};
e.Eg=function(a,b){return v9(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};e.Of=function(){return gG(this,"","","")};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){return v9(this,a,this.ka.i.length)};e.kf=function(){return(new g2).eo(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new t4).c()};
e.jf=function(){return R2(this)};e.$classData=l({BF:0},!1,"scala.collection.mutable.ArrayOps$ofShort",{BF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});function EW(){this.ka=null}EW.prototype=new m;EW.prototype.constructor=EW;e=EW.prototype;e.dc=function(){return(new n2).go(this.ka)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.rc=function(){};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.ka.i.length)};
e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.lb=function(){var a=G().b;return H(this,a)};e.md=function(){return(new n2).go(this.ka)};e.w=function(a){jka||(jka=(new cP).c());return a&&a.$classData&&a.$classData.H.CF?this.ka===(null===a?null:a.ka):!1};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};
e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.ka.i.length,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return v9(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.we=function(){return D7(this)};e.Za=function(){return this.ka.i.length};e.Jb=function(){return Cp(new Dp,this,this.ka.i.length)};e.Fa=function(){return this.ka.i.length};e.Of=function(){return gG(this,"","","")};
e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.ka.i.length};e.ce=function(){var a=Cp(new Dp,this,this.ka.i.length);return SU(a)};e.Ze=function(){return Hd(this)};e.tf=function(a){return v9(this,a,this.ka.i.length)};e.go=function(a){this.ka=a;return this};e.kf=function(){return(new n2).go(this.ka)};e.o=function(){return I8(this)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.ka};e.Gg=function(a,b){return J8(this,0,this.ka.i.length,a,b)};
e.rf=function(a,b,c){w9(this,a,b,c)};e.A=function(){return this.ka.A()};e.ph=function(){return!0};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new u4).c()};e.jf=function(){return R2(this)};e.$classData=l({CF:0},!1,"scala.collection.mutable.ArrayOps$ofUnit",{CF:1,f:1,el:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fd:1});
function y9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}y9.prototype=new m;y9.prototype.constructor=y9;e=y9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Type.Name.Quasi"};e.Na=function(){return this};e.ar=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.M=function(){return 2};e.w=function(a){return this===a};
e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return lta(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.yt&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&c&&c.$classData&&c.$classData.H.yt&&(b=null===c?S():(new T).e((new q).a(c.ca,
c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.ec=function(){this.ar()};function lta(a,b,c,d){var f=new y9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TypeNameQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};
e.uc=function(){return hL(jL(),k(Jwa),this.ca)};e.A=function(){return Ia(this)};e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({SS:0},!1,"scala.meta.Type$Name$Quasi$TypeNameQuasiImpl",{SS:1,f:1,yt:1,Eq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,Bo:1,wd:1,Yd:1,sn:1,cj:1,Rd:1,lT:1,Gq:1});function z9(){}z9.prototype=new u9;z9.prototype.constructor=z9;function CBa(){}CBa.prototype=z9.prototype;function fo(){this.Rf=null}
fo.prototype=new m;fo.prototype.constructor=fo;e=fo.prototype;e.dc=function(){return(new r).d(this.Rf)};e.ih=function(a,b){Id(this,a,b)};e.n=function(){return eo(this)};e.c=function(){fo.prototype.d.call(this,[]);return this};e.rc=function(a){return this.Rf[a]};e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.Rf.length|0)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.lb=function(){var a=G().b;return H(this,a)};e.g=function(){return xm(this)};
e.md=function(){return(new r).d(this.Rf)};e.w=function(a){return a1(this,a)};e.Pd=function(a){return gG(this,"",a,"")};e.le=function(a,b,c){return gG(this,a,b,c)};e.ee=function(a){this.Rf.push(a);return this};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.v=function(){return O2(this)};e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.Rf.length|0,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return B8(this,a,b)};
e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.Za=function(){return this.Rf.length|0};e.we=function(){return D7(this)};e.da=function(){return this.Rf};e.Jb=function(){return Cp(new Dp,this,this.Rf.length|0)};e.ii=function(a,b){iV(this,a,b)};e.Of=function(){return gG(this,"","","")};e.Fa=function(){return this.Rf.length|0};e.vg=function(a){return P2(this,a,!0)};e.Df=function(){return this.Rf.length|0};
e.ce=function(){var a=Cp(new Dp,this,this.Rf.length|0);return SU(a)};e.Ze=function(){return Hd(this)};e.tf=function(a){return B8(this,a,this.Rf.length|0)};e.o=function(){return I8(this)};e.kf=function(){return(new r).d(this.Rf)};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.Se=function(){return this.Rf};e.Gg=function(a,b){return J8(this,0,this.Rf.length|0,a,b)};e.ba=function(a){this.Rf.push(a);return this};e.je=function(){};e.rf=function(a,b,c){K8(this,a,b,c)};e.ph=function(){return!0};
e.A=function(){return PU(XN(),(new r).d(this.Rf))};e.yf=function(a,b){return SQ(this,a,b)};e.Tg=function(){return cj(this)};e.d=function(a){this.Rf=a;return this};e.$e=function(a){var b=this.Rf.length|0;if(0>=b)throw wka||(wka=(new sP).c()),(new Gq).j("empty.reduceLeft");var c=1,d=this.Rf[0];for(;;){if(c===b)return d;var f=1+c|0,d=a.ug(d,this.Rf[c]),c=f}};e.ic=function(){return(new fo).c()};e.$c=function(a){return GO(this,a)};e.jf=function(){return R2(this)};
e.$classData=l({PF:0},!1,"scala.scalajs.js.ArrayOps",{PF:1,f:1,ng:1,eg:1,Uf:1,Zd:1,Ad:1,Xb:1,x:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,Vb:1,zd:1,bf:1,Fe:1,Ee:1,De:1});function Gf(a){return!!(a&&a.$classData&&a.$classData.H.Ew)}var Kwa=l({Ew:0},!0,"scala.meta.Term$Name$Quasi",{Ew:1,Bq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,zj:1,Oc:1,Ub:1,he:1,Yd:1,sn:1,cj:1,Rd:1,Dq:1,tn:1,dl:1,zq:1});function A9(){}A9.prototype=new u9;A9.prototype.constructor=A9;function B9(){}e=B9.prototype=A9.prototype;
e.Pe=function(a){a:if(0>a)a=1;else{for(var b=0,c=this.Jb();c.fb();){if(b===a){a=c.fb()?1:0;break a}c.bb();b=1+b|0}a=b-a|0}return a};e.xq=function(a){return es(this,a)};e.g=function(){return 0===this.Pe(0)};e.w=function(a){return a1(this,a)};e.br=function(a,b){return Fw(this,a,b)};e.v=function(){return O2(this)};e.Za=function(){return this.Fa()};e.kf=function(){return this};e.Vh=function(a,b){return gs(this,a,b)};e.A=function(){return PU(XN(),this.kj())};e.hq=function(){return d0(this)};
function C9(){this.s=this.aa=this.m=null;this.ca=0;this.Ua=null}C9.prototype=new m;C9.prototype.constructor=C9;e=C9.prototype;e.Oa=function(){G();var a=(new r).d(["rank","tree"]),b=G().b;return H(a,b)};e.U=function(){return"Term.Name.Quasi"};e.Na=function(){return this};e.ar=function(){throw(new Gq).j(0===this.ca?"unsupported unquoting position":"unsupported splicing position");};e.M=function(){return 2};function osa(a,b,c,d){var f=new C9;f.m=a;f.aa=b;f.s=c;f.ca=d;f.Ua=null;return f}
e.w=function(a){return this===a};e.W=function(a){switch(a){case 0:return this.ca;case 1:return this.fa();default:throw(new W).j(""+a);}};e.y=function(a,b,c,d){return osa(a,b,d,this.ca)};
e.nb=function(a){var b=(new T).e((new q).a(this.ca,this.fa())),c=b.Y.p();if(0===b.Y.Xa())return b=M(),a=a.Ja(0,c),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(1===b.Y.Xa()&&Gf(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(1,c.nb(a)),O(P(b,a),mG(this));b=(new T).e((new q).a(this.ca,this.fa()));c=b.Y.p();if(2===b.Y.Xa()&&Gf(c)&&(b=null===c?S():(new T).e((new q).a(c.ca,c.fa())),!b.g()&&0===b.q().Xa()))return b=M(),a=a.Ja(2,
c.nb(a)),O(P(b,a),mG(this));throw jo(wj(),(new dW).j("complex ellipses are not supported yet"));};e.v=function(){return to(uo(),this)};e.ec=function(){this.ar()};e.fa=function(){if(null===this.Ua){if(null===this.m)throw(new t).j("requirement failed: internal error when initializing TermNameQuasiImpl.tree");var a=this.m.fa(),b=this.m.fa();this.Ua=a.y(b,this,null,a.s)}return this.Ua};e.uc=function(){return hL(jL(),k(Iwa),this.ca)};e.A=function(){return Ia(this)};
e.Ma=function(){G();var a=(new r).d([this.fa()]),b=G().b;return H(a,b)};e.L=function(){return Z(this)};e.$classData=l({RQ:0},!1,"scala.meta.Term$Name$Quasi$TermNameQuasiImpl",{RQ:1,f:1,Ew:1,Bq:1,Ji:1,Md:1,sa:1,ta:1,R:1,x:1,ua:1,$:1,l:1,k:1,zj:1,Oc:1,Ub:1,he:1,Yd:1,sn:1,cj:1,Rd:1,Dq:1,tn:1,dl:1,zq:1});function D9(){}D9.prototype=new u9;D9.prototype.constructor=D9;function DBa(){}e=DBa.prototype=D9.prototype;
e.Ea=function(a){var b=this.wg(a);if(S()===b)a=this.gu(a);else if(zh(b))a=b.Y;else throw(new p).e(b);return a};e.xq=function(a){return es(this,a)};e.g=function(){return 0===this.Za()};
e.w=function(a){if(a&&a.$classData&&a.$classData.H.zi){var b;if(!(b=this===a)&&(b=this.Za()===a.Za()))try{for(var c=this.Jb(),d=!0;d&&c.fb();){var f=c.bb();if(null===f)throw(new p).e(f);var g=f.p(),h=a.wg(f.qa());b:{if(zh(h)){var n=h.Y;if(dj(ej(),g,n)){d=!0;break b}}d=!1}}b=d}catch(u){if(u&&u.$classData&&u.$classData.H.$I)b=!1;else throw u;}a=b}else a=!1;return a};e.v=function(){return O2(this)};e.dw=function(){return(new J1).Qs(this)};e.we=function(){return zBa(this)};
e.gu=function(a){throw(new BP).j("key not found: "+a);};e.Ac=function(a){return!this.wg(a).g()};e.qg=function(a,b,c,d){return ABa(this,a,b,c,d)};e.vf=function(a){return this.Ac(a)};e.QA=function(a){return $8(this,a)};e.JB=function(){return(new E9).Qs(this)};e.A=function(){var a=XN();return ZN(a,this.Nq(),a.RB)};e.Vh=function(a,b){var c=this.wg(a);if(zh(c))a=c.Y;else if(S()===c)a=b.Ea(a);else throw(new p).e(c);return a};e.hq=function(){return d0(this)};e.jf=function(){return"Map"};
e.ic=function(){return A(new B,this.Rn())};function F9(){}F9.prototype=new u9;F9.prototype.constructor=F9;function G9(){}e=G9.prototype=F9.prototype;e.dc=function(){return this.gl()};e.Ea=function(a){return this.Ac(a)};e.md=function(){return this};e.g=function(){return 0===this.Za()};e.w=function(a){return b1(this,a)};e.qe=function(){return zva()};e.v=function(){return O2(this)};e.Fx=function(a){return this.Le(a)};e.we=function(){return yBa(this)};e.qi=function(){return this.LA()};e.gl=function(){return this};
e.LA=function(){return this.qe().Yj()};e.A=function(){var a=XN();return ZN(a,this.gl(),a.yx)};e.yf=function(a,b){return SQ(this,a,b)};e.kl=function(a){return N8(this,a)};e.ic=function(){return kd(new ld,this.qi())};e.jf=function(){return"Set"};function E9(){this.Gn=null}E9.prototype=new G9;E9.prototype.constructor=E9;function EBa(){}e=EBa.prototype=E9.prototype;e.Cb=function(a){var b=this.Gn.dw();QU(b,a)};e.Za=function(){return this.Gn.Za()};e.Jb=function(){return this.Gn.dw()};
e.Qs=function(a){if(null===a)throw jo(wj(),null);this.Gn=a;return this};e.Ac=function(a){return this.Gn.Ac(a)};e.ki=function(a){return uu(zva(),F()).kl(this).ki(a)};e.$classData=l({EE:0},!1,"scala.collection.MapLike$DefaultKeySet",{EE:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,l:1,k:1});function H9(){this.Lk=this.Gn=null}H9.prototype=new EBa;H9.prototype.constructor=H9;
H9.prototype.Cb=function(a){for(var b=this.Lk,c=b.Vc,b=mP(b),d=c.i[b];null!==d;){var f=d.bb();a.Ea(d.bg);for(d=f;null===d&&0<b;)b=-1+b|0,d=c.i[b]}};H9.prototype.Mv=function(a){if(null===a)throw jo(wj(),null);this.Lk=a;E9.prototype.Qs.call(this,a);return this};H9.prototype.$classData=l({T3:0},!1,"scala.collection.mutable.HashMap$$anon$1",{T3:1,EE:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,l:1,k:1});
function I9(){}I9.prototype=new DBa;I9.prototype.constructor=I9;function J9(){}e=J9.prototype=I9.prototype;e.dc=function(){return this};e.md=function(){return this};e.qe=function(){return wva()};e.Rn=function(){return this.gv()};e.gv=function(){return C()};e.Nq=function(){return this};e.vg=function(a){return this.QA(a)};function K9(){}K9.prototype=new G9;K9.prototype.constructor=K9;function FBa(){}e=FBa.prototype=K9.prototype;e.dc=function(){return this};
e.ro=function(){throw(new BP).j("next of empty set");};e.Ea=function(a){return this.Ac(a)};e.g=function(){return!0};e.md=function(){return this};e.qe=function(){Swa||(Swa=(new j4).c());return Swa};e.Mk=function(a){return L9(new M9,this,a)};e.Za=function(){return 0};e.Jb=function(){var a=N9(this);return ZM(a)};e.qi=function(){return k4()};function N9(a){for(var b=F();!a.g();){var c=a.Np(),b=U(new V,c,b);a=a.ro()}return b}e.gl=function(){return this};e.Ac=function(){return!1};
e.Np=function(){throw(new BP).j("elem of empty set");};function GBa(a,b){return b.g()?a:b.Gg(a,Wm(function(){return function(a,b){return a.Mk(b)}}(a)))}e.Tx=function(){return this};e.fm=function(a){return GBa(this,a)};e.ki=function(a){return this.Mk(a)};e.kl=function(a){return GBa(this,a)};e.jf=function(){return"ListSet"};function O9(){}O9.prototype=new G9;O9.prototype.constructor=O9;e=O9.prototype;e.dc=function(){return this};e.c=function(){return this};e.Ea=function(){return!1};e.md=function(){return this};
e.qe=function(){return QQ()};e.Cb=function(){};e.Za=function(){return 0};e.Jb=function(){return hN().Pg};e.qi=function(){return id()};e.gl=function(){return this};e.Ac=function(){return!1};e.fm=function(a){return N8(this,a)};e.ki=function(a){return(new P9).e(a)};e.$classData=l({b3:0},!1,"scala.collection.immutable.Set$EmptySet$",{b3:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});
var HBa=void 0;function id(){HBa||(HBa=(new O9).c());return HBa}function P9(){this.fe=null}P9.prototype=new G9;P9.prototype.constructor=P9;e=P9.prototype;e.dc=function(){return this};e.n=function(){return this.fe};e.Ea=function(a){return this.Ac(a)};e.md=function(){return this};e.Le=function(a){return!!a.Ea(this.fe)};e.qe=function(){return QQ()};e.Cb=function(a){a.Ea(this.fe)};e.Za=function(){return 1};e.Jb=function(){hN();var a=(new r).d([this.fe]);return Cp(new Dp,a,a.Da.length|0)};
e.e=function(a){this.fe=a;return this};e.qi=function(){return id()};e.lm=function(a){return this.Ac(a)?this:(new Q9).a(this.fe,a)};e.gl=function(){return this};e.Ac=function(a){return dj(ej(),a,this.fe)};e.o=function(){return id()};e.fm=function(a){return N8(this,a)};e.ki=function(a){return this.lm(a)};
e.$classData=l({c3:0},!1,"scala.collection.immutable.Set$Set1",{c3:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});function Q9(){this.Kf=this.fe=null}Q9.prototype=new G9;Q9.prototype.constructor=Q9;e=Q9.prototype;e.dc=function(){return this};e.n=function(){return this.fe};e.Ea=function(a){return this.Ac(a)};e.Xq=function(){return(new P9).e(this.Kf)};e.md=function(){return this};
e.a=function(a,b){this.fe=a;this.Kf=b;return this};e.Le=function(a){return!!a.Ea(this.fe)&&!!a.Ea(this.Kf)};e.qe=function(){return QQ()};e.Cb=function(a){a.Ea(this.fe);a.Ea(this.Kf)};e.Za=function(){return 2};e.Jb=function(){hN();var a=(new r).d([this.fe,this.Kf]);return Cp(new Dp,a,a.Da.length|0)};e.qi=function(){return id()};e.lm=function(a){return this.Ac(a)?this:(new R9).sd(this.fe,this.Kf,a)};e.gl=function(){return this};e.Ac=function(a){return dj(ej(),a,this.fe)||dj(ej(),a,this.Kf)};e.o=function(){return this.Xq()};
e.fm=function(a){return N8(this,a)};e.ki=function(a){return this.lm(a)};e.$classData=l({d3:0},!1,"scala.collection.immutable.Set$Set2",{d3:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});function R9(){this.pi=this.Kf=this.fe=null}R9.prototype=new G9;R9.prototype.constructor=R9;e=R9.prototype;e.dc=function(){return this};e.n=function(){return this.fe};e.Ea=function(a){return this.Ac(a)};
e.Xq=function(){return(new Q9).a(this.Kf,this.pi)};e.md=function(){return this};e.Le=function(a){return!!a.Ea(this.fe)&&!!a.Ea(this.Kf)&&!!a.Ea(this.pi)};e.qe=function(){return QQ()};e.Cb=function(a){a.Ea(this.fe);a.Ea(this.Kf);a.Ea(this.pi)};e.Za=function(){return 3};e.sd=function(a,b,c){this.fe=a;this.Kf=b;this.pi=c;return this};e.Jb=function(){hN();var a=(new r).d([this.fe,this.Kf,this.pi]);return Cp(new Dp,a,a.Da.length|0)};e.qi=function(){return id()};
e.lm=function(a){return this.Ac(a)?this:(new S9).yd(this.fe,this.Kf,this.pi,a)};e.gl=function(){return this};e.Ac=function(a){return dj(ej(),a,this.fe)||dj(ej(),a,this.Kf)||dj(ej(),a,this.pi)};e.o=function(){return this.Xq()};e.fm=function(a){return N8(this,a)};e.ki=function(a){return this.lm(a)};
e.$classData=l({e3:0},!1,"scala.collection.immutable.Set$Set3",{e3:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});function S9(){this.Bm=this.pi=this.Kf=this.fe=null}S9.prototype=new G9;S9.prototype.constructor=S9;e=S9.prototype;e.dc=function(){return this};e.n=function(){return this.fe};e.Ea=function(a){return this.Ac(a)};e.Xq=function(){return(new R9).sd(this.Kf,this.pi,this.Bm)};
e.md=function(){return this};e.Le=function(a){return!!a.Ea(this.fe)&&!!a.Ea(this.Kf)&&!!a.Ea(this.pi)&&!!a.Ea(this.Bm)};e.qe=function(){return QQ()};e.Cb=function(a){a.Ea(this.fe);a.Ea(this.Kf);a.Ea(this.pi);a.Ea(this.Bm)};e.Za=function(){return 4};e.Jb=function(){hN();var a=(new r).d([this.fe,this.Kf,this.pi,this.Bm]);return Cp(new Dp,a,a.Da.length|0)};e.qi=function(){return id()};e.lm=function(a){return this.Ac(a)?this:T9(T9(T9(T9(T9((new U9).c(),this.fe),this.Kf),this.pi),this.Bm),a)};e.gl=function(){return this};
e.Ac=function(a){return dj(ej(),a,this.fe)||dj(ej(),a,this.Kf)||dj(ej(),a,this.pi)||dj(ej(),a,this.Bm)};e.o=function(){return this.Xq()};e.yd=function(a,b,c,d){this.fe=a;this.Kf=b;this.pi=c;this.Bm=d;return this};e.fm=function(a){return N8(this,a)};e.ki=function(a){return this.lm(a)};
e.$classData=l({f3:0},!1,"scala.collection.immutable.Set$Set4",{f3:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});function V9(){this.jl=null;this.Ca=this.E=0}V9.prototype=new m;V9.prototype.constructor=V9;e=V9.prototype;e.dc=function(){return this};e.ih=function(a,b){Id(this,a,b)};e.U=function(){return"Tokens"};e.n=function(){return eo(this)};e.rc=function(a){return Dg(this,a)};
e.Pe=function(a){return i8(this,a)};e.ah=function(){return Cp(new Dp,this,this.Fa())};e.Qf=function(a){return k8(this,a)};e.M=function(){return 3};e.Ea=function(a){return Dg(this,a|0)};e.qv=function(a){return Xja(this,a)};e.$f=function(a){return x8(this,a)};e.lb=function(){var a=G().b;return H(this,a)};e.g=function(){return xm(this)};e.xq=function(a){return es(this,a)};e.md=function(){return this};
e.w=function(a){if(a&&a.$classData&&a.$classData.H.bx&&ns(a)&&3===a.M()){var b=Z(this);a=a.L();return RU(b,a)}return!1};e.W=function(a){switch(a){case 0:return this.jl;case 1:return this.E;case 2:return this.Ca;default:throw(new W).j(""+a);}};e.Pd=function(a){return gG(this,"",a,"")};function Dg(a,b){return a.jl.i[a.E+b|0]}e.le=function(a,b,c){return gG(this,a,b,c)};e.St=function(a){return pM(new qM,this,a)};e.Le=function(a){return y8(this,a)};e.br=function(a,b){return Fw(this,a,b)};e.ag=function(){return z8(this)};
e.qe=function(){return Rs()};e.v=function(){return gG(this,"","","")};e.Cb=function(a){A8(this,a)};e.se=function(a,b){var c=this.Fa();return J8(this,0,c,a,b)};e.si=function(){return zz(this)};e.Eg=function(a,b){return Yla(this,a,b)};e.sh=function(){uk();var a=vk().$d;return H(this,a)};e.mh=function(a){return P2(this,a,!1)};e.cm=function(){return this};e.Za=function(){return this.Fa()};e.we=function(){return D7(this)};e.aA=function(a){return!!(a&&a.$classData&&a.$classData.H.bx)};
e.Jb=function(){return Cp(new Dp,this,this.Fa())};e.Of=function(){return gG(this,"","","")};e.ma=function(a,b){return Q2(this,a,b)};e.Fa=function(){return this.Ca-this.E|0};function Yla(a,b,c){var d=a.E;b=0<b?b:0;var f=a.Fa(),d=d+(b<f?b:f)|0;b=a.E;f=a.Fa();c=b+(c<f?c:f)|0;c=d>c?d:c;YD();return ZD(a.jl,d,c)}e.vg=function(a){return P2(this,a,!0)};e.kj=function(){return this};e.Df=function(){return this.Fa()};e.ce=function(){var a=Cp(new Dp,this,this.Fa());return SU(a)};e.Ze=function(){return Hd(this)};
e.tf=function(a){return Yla(this,a,this.Fa())};e.o=function(){return I8(this)};e.kf=function(){return this};e.qg=function(a,b,c,d){return jO(this,a,b,c,d)};e.vf=function(a){return G1(this,a|0)};e.Se=function(){return this};e.Gg=function(a,b){var c=this.Fa();return J8(this,0,c,a,b)};
function ZD(a,b,c){var d=new V9;d.jl=a;d.E=b;d.Ca=c;null!==a?a=(new q).a(!0,F()):(G(),a=(new r).d(["this.tokens is equal to null"]),b=G().b,a=(new q).a(!1,H(a,b)));if(null===a||!0!==I(a)){if(null!==a&&(b=a.p(),!1===I(a))){c=J();for(var d=[(new q).a("Tokens",d)],f=A(new B,C()),g=0,h=d.length|0;g<h;)E(f,d[g]),g=1+g|0;K(c,"this.tokens.!\x3d(null)",b,f.t)}throw(new p).e(a);}return d}e.Vh=function(a,b){return gs(this,a,b)};e.rf=function(a,b,c){K8(this,a,b,c)};e.ph=function(){return!0};e.A=function(){return WN(this)};
e.yf=function(a,b){return SQ(this,a,b)};e.Cn=function(a){return kO(this,a)};e.L=function(){return Z(this)};e.Tg=function(){return cj(this)};e.hq=function(){return d0(this)};e.$e=function(a){return L8(this,a)};e.ic=function(){Rs();uk();return(new Hk).c()};e.jf=function(){return R2(this)};
e.$classData=l({bx:0},!1,"scala.meta.tokens.Tokens",{bx:1,f:1,Jo:1,lk:1,Bd:1,Gd:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,Ed:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Cg:1,Zd:1,bf:1,R:1,l:1,k:1});function U9(){}U9.prototype=new G9;U9.prototype.constructor=U9;function W9(){}e=W9.prototype=U9.prototype;e.$q=function(a,b){return(new X9).Cl(a,b)};e.dc=function(){return this};e.wk=function(a){return this.uv(YN(Y(),a))};e.c=function(){return this};e.Ea=function(a){return this.Ac(a)};
function T9(a,b){return a.$q(b,a.wk(b),0)}e.md=function(){return this};e.Zq=function(a){return a};e.qe=function(){return h4()};e.Cb=function(){};e.Fx=function(a){if(a&&a.$classData&&a.$classData.H.wn)return this.Vq(a,0);var b=this.Jb();return Goa(b,a)};e.em=function(a){return a};e.mh=function(a){var b=6+this.Za()|0,b=oa(bc(d4),[224>b?b:224]);a=this.Tn(a,!1,0,b,0);return null===a?g4():a};e.Za=function(){return 0};e.Jb=function(){return hN().Pg};e.wq=function(){return this};e.qi=function(){return g4()};
e.vg=function(a){var b=6+this.Za()|0,b=oa(bc(d4),[224>b?b:224]);a=this.Tn(a,!0,0,b,0);return null===a?g4():a};e.uv=function(a){a=a+~(a<<9)|0;a^=a>>>14|0;a=a+(a<<4)|0;return a^(a>>>10|0)};e.gl=function(){return this};e.Ac=function(a){return this.Al(a,this.wk(a),0)};e.o=function(){return this.Jx()};e.Jx=function(){var a=this.n(),a=this.wq(a,this.wk(a),0);return null===a?g4():a};e.LA=function(){return g4()};
e.fm=function(a){if(a&&a.$classData&&a.$classData.H.wn){var b=6+(this.Za()+a.Za()|0)|0,b=oa(bc(d4),[224>b?b:224]);a=this.Zq(a,0,b,0);a=null===a?g4():a}else a=N8(this,a);return a};e.Tn=function(){return null};e.Al=function(){return!1};e.ki=function(a){return T9(this,a)};e.Vq=function(){return!0};
var d4=l({wn:0},!1,"scala.collection.immutable.HashSet",{wn:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,Fd:1,l:1,k:1});U9.prototype.$classData=d4;function Y9(){}Y9.prototype=new FBa;Y9.prototype.constructor=Y9;Y9.prototype.c=function(){return this};
Y9.prototype.$classData=l({M2:0},!1,"scala.collection.immutable.ListSet$EmptyListSet$",{M2:1,K2:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});var IBa=void 0;function k4(){IBa||(IBa=(new Y9).c());return IBa}function M9(){this.Lk=this.HA=null}M9.prototype=new FBa;M9.prototype.constructor=M9;e=M9.prototype;e.ro=function(){return this.Lk};e.g=function(){return!1};
e.Mk=function(a){return JBa(this,a)?this:L9(new M9,this,a)};e.Za=function(){a:{var a=this,b=0;for(;;){if(a.g())break a;a=a.ro();b=1+b|0}}return b};function L9(a,b,c){a.HA=c;if(null===b)throw jo(wj(),null);a.Lk=b;return a}e.Ac=function(a){return JBa(this,a)};e.Np=function(){return this.HA};e.Tx=function(a){a:{var b=this,c=F();for(;;){if(b.g()){a=cl(c);break a}if(dj(ej(),a,b.Np())){b=b.ro();for(a=c;!a.g();)c=a.n(),b=L9(new M9,b,c.Np()),a=a.o();a=b;break a}var d=b.ro(),c=U(new V,b,c),b=d}}return a};
function JBa(a,b){for(;;){if(a.g())return!1;if(dj(ej(),a.Np(),b))return!0;a=a.ro()}}e.ki=function(a){return this.Mk(a)};e.$classData=l({N2:0},!1,"scala.collection.immutable.ListSet$Node",{N2:1,K2:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,l:1,k:1});function Z9(){}Z9.prototype=new B9;Z9.prototype.constructor=Z9;function $9(){}$9.prototype=Z9.prototype;Z9.prototype.dc=function(){return this.Oq()};
Z9.prototype.Oq=function(){return this};function a$(){}a$.prototype=new W9;a$.prototype.constructor=a$;e=a$.prototype;e.c=function(){return this};e.n=function(){throw(new BP).j("Empty Set");};e.o=function(){return this.Jx()};e.Jx=function(){throw(new BP).j("Empty Set");};
e.$classData=l({B2:0},!1,"scala.collection.immutable.HashSet$EmptyHashSet$",{B2:1,wn:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,Fd:1,l:1,k:1});var KBa=void 0;function g4(){KBa||(KBa=(new a$).c());return KBa}function f4(){this.of=0;this.rd=null;this.Oi=0}f4.prototype=new W9;f4.prototype.constructor=f4;e=f4.prototype;
e.$q=function(a,b,c){var d=1<<(31&(b>>>c|0)),f=dP(aO(),this.of&(-1+d|0));if(0!==(this.of&d)){d=this.rd.i[f];a=d.$q(a,b,5+c|0);if(d===a)return this;b=oa(bc(d4),[this.rd.i.length]);E0(Tp(),this.rd,0,b,0,this.rd.i.length);b.i[f]=a;return e4(new f4,this.of,b,this.Oi+(a.Za()-d.Za()|0)|0)}c=oa(bc(d4),[1+this.rd.i.length|0]);E0(Tp(),this.rd,0,c,0,f);c.i[f]=(new X9).Cl(a,b);E0(Tp(),this.rd,f,c,1+f|0,this.rd.i.length-f|0);return e4(new f4,this.of|d,c,1+this.Oi|0)};
e.Zq=function(a,b,c,d){if(a===this)return this;if(a&&a.$classData&&a.$classData.H.lx)return this.em(a,b);if(W1(a)){for(var f=this.rd,g=this.of,h=0,n=a.rd,u=a.of,w=0,D=d,N=0;0!==(g|u);){var Q=g^g&(-1+g|0),ea=u^u&(-1+u|0);if(Q===ea){var ba=f.i[h].Zq(n.i[w],5+b|0,c,D),N=N+ba.Za()|0;c.i[D]=ba;D=1+D|0;g&=~Q;h=1+h|0;u&=~ea;w=1+w|0}else{var ba=-1+Q|0,ma=-1+ea|0;ba<ma!==0>ba!==0>ma?(ea=f.i[h],N=N+ea.Za()|0,c.i[D]=ea,D=1+D|0,g&=~Q,h=1+h|0):(Q=n.i[w],N=N+Q.Za()|0,c.i[D]=Q,D=1+D|0,u&=~ea,w=1+w|0)}}if(N===this.Oi)return this;
if(N===a.Oi)return a;b=D-d|0;f=oa(bc(d4),[b]);Ta(c,d,f,0,b);return e4(new f4,this.of|a.of,f,N)}return this};e.Cb=function(a){for(var b=0;b<this.rd.i.length;)this.rd.i[b].Cb(a),b=1+b|0};
e.em=function(a,b){var c=1<<(31&(a.Yc>>>b|0)),d=dP(aO(),this.of&(-1+c|0));if(0!==(this.of&c)){c=this.rd.i[d];a=c.em(a,5+b|0);if(c===a)return this;b=oa(bc(d4),[this.rd.i.length]);E0(Tp(),this.rd,0,b,0,this.rd.i.length);b.i[d]=a;return e4(new f4,this.of,b,this.Oi+(a.Za()-c.Za()|0)|0)}b=oa(bc(d4),[1+this.rd.i.length|0]);E0(Tp(),this.rd,0,b,0,d);b.i[d]=a;E0(Tp(),this.rd,d,b,1+d|0,this.rd.i.length-d|0);return e4(new f4,this.of|c,b,this.Oi+a.Za()|0)};e.Za=function(){return this.Oi};
e.Jb=function(){var a=new W2;U1.prototype.ZA.call(a,this.rd);return a};
e.wq=function(a,b,c){var d=1<<(31&(b>>>c|0)),f=dP(aO(),this.of&(-1+d|0));if(0!==(this.of&d)){var g=this.rd.i[f];a=g.wq(a,b,5+c|0);return g===a?this:null===a?(d^=this.of,0!==d?(a=oa(bc(d4),[-1+this.rd.i.length|0]),E0(Tp(),this.rd,0,a,0,f),E0(Tp(),this.rd,1+f|0,a,f,-1+(this.rd.i.length-f|0)|0),f=this.Oi-g.Za()|0,1!==a.i.length||W1(a.i[0])?e4(new f4,d,a,f):a.i[0]):null):1!==this.rd.i.length||W1(a)?(d=oa(bc(d4),[this.rd.i.length]),E0(Tp(),this.rd,0,d,0,this.rd.i.length),d.i[f]=a,f=this.Oi+(a.Za()-g.Za()|
0)|0,e4(new f4,this.of,d,f)):a}return this};function e4(a,b,c,d){a.of=b;a.rd=c;a.Oi=d;FK(To(),dP(aO(),b)===c.i.length);return a}
e.Tn=function(a,b,c,d,f){for(var g=f,h=0,n=0,u=0;u<this.rd.i.length;){var w=this.rd.i[u].Tn(a,b,5+c|0,d,g);null!==w&&(d.i[g]=w,g=1+g|0,h=h+w.Za()|0,n|=1<<u);u=1+u|0}if(g===f)return null;if(h===this.Oi)return this;if(g!==(1+f|0)||W1(d.i[f])){b=g-f|0;a=oa(bc(d4),[b]);Ta(d,f,a,0,b);if(b===this.rd.i.length)n=this.of;else{h4();d=0;for(f=this.of;0!==n;)b=f^f&(-1+f|0),0!==(1&n)&&(d|=b),f&=~b,n=n>>>1|0;n=d}return e4(new f4,n,a,h)}return d.i[f]};
e.Al=function(a,b,c){var d=31&(b>>>c|0),f=1<<d;return-1===this.of?this.rd.i[31&d].Al(a,b,5+c|0):0!==(this.of&f)?(d=dP(aO(),this.of&(-1+f|0)),this.rd.i[d].Al(a,b,5+c|0)):!1};e.Vq=function(a,b){if(a===this)return!0;if(W1(a)&&this.Oi<=a.Oi){var c=this.of,d=this.rd,f=0,g=a.rd;a=a.of;var h=0;if((c&a)===c){for(;0!==c;){var n=c^c&(-1+c|0),u=a^a&(-1+a|0);if(n===u){if(!d.i[f].Vq(g.i[h],5+b|0))return!1;c&=~n;f=1+f|0}a&=~u;h=1+h|0}return!0}}return!1};
function W1(a){return!!(a&&a.$classData&&a.$classData.H.YE)}e.$classData=l({YE:0},!1,"scala.collection.immutable.HashSet$HashTrieSet",{YE:1,wn:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,Fd:1,l:1,k:1});function b$(){}b$.prototype=new W9;b$.prototype.constructor=b$;function LBa(){}LBa.prototype=b$.prototype;function c$(){}c$.prototype=new J9;c$.prototype.constructor=c$;function MBa(){}
e=MBa.prototype=c$.prototype;e.Xf=function(){throw(new BP).j("value of empty map");};e.g=function(){return!0};e.md=function(){return this};e.Rn=function(){return NBa()};e.pk=function(a){return this.Wt(a)};e.gv=function(){return NBa()};e.Nq=function(){return this};e.Za=function(){return 0};e.er=function(a){return d$(new e$,this,a.qa(),a.p())};e.Jb=function(){var a=f$(this);return ZM(a)};e.Gi=function(){throw(new BP).j("key of empty map");};e.Px=function(a,b){return d$(new e$,this,a,b)};
e.vg=function(a){return $8(this,a)};e.Wt=function(){return this};e.wg=function(){return S()};function f$(a){for(var b=F();!a.g();){var c=(new q).a(a.Gi(),a.Xf()),b=U(new V,c,b);a=a.Ol()}return b}e.Ol=function(){throw(new BP).j("next of empty map");};e.qk=function(a){return this.er(a)};e.jf=function(){return"ListMap"};function g$(){}g$.prototype=new J9;g$.prototype.constructor=g$;e=g$.prototype;e.c=function(){return this};e.Ea=function(a){this.Ru(a)};e.pk=function(){return this};e.Za=function(){return 0};
e.Jb=function(){return hN().Pg};e.wg=function(){return S()};e.Ac=function(){return!1};e.Ru=function(a){throw(new BP).j("key not found: "+a);};e.qk=function(a){return(new h$).a(a.qa(),a.p())};e.$classData=l({P2:0},!1,"scala.collection.immutable.Map$EmptyMap$",{P2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});var OBa=void 0;function C(){OBa||(OBa=(new g$).c());return OBa}
function h$(){this.td=this.Ec=null}h$.prototype=new J9;h$.prototype.constructor=h$;e=h$.prototype;e.Ea=function(a){if(dj(ej(),a,this.Ec))return this.td;throw(new BP).j("key not found: "+a);};e.a=function(a,b){this.Ec=a;this.td=b;return this};e.Cb=function(a){a.Ea((new q).a(this.Ec,this.td))};e.pk=function(a){return this.km(a)};e.Za=function(){return 1};e.Jb=function(){hN();var a=(new r).d([(new q).a(this.Ec,this.td)]);return Cp(new Dp,a,a.Da.length|0)};
e.Fn=function(a,b){return dj(ej(),a,this.Ec)?(new h$).a(this.Ec,b):(new i$).yd(this.Ec,this.td,a,b)};e.wg=function(a){return dj(ej(),a,this.Ec)?(new T).e(this.td):S()};e.Ac=function(a){return dj(ej(),a,this.Ec)};e.km=function(a){return dj(ej(),a,this.Ec)?C():this};e.qk=function(a){return this.Fn(a.qa(),a.p())};
e.$classData=l({Q2:0},!1,"scala.collection.immutable.Map$Map1",{Q2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});function i$(){this.de=this.ad=this.td=this.Ec=null}i$.prototype=new J9;i$.prototype.constructor=i$;e=i$.prototype;e.Ea=function(a){if(dj(ej(),a,this.Ec))return this.td;if(dj(ej(),a,this.ad))return this.de;throw(new BP).j("key not found: "+a);};
e.Cb=function(a){a.Ea((new q).a(this.Ec,this.td));a.Ea((new q).a(this.ad,this.de))};e.pk=function(a){return this.km(a)};e.Za=function(){return 2};e.Jb=function(){hN();var a=(new r).d([(new q).a(this.Ec,this.td),(new q).a(this.ad,this.de)]);return Cp(new Dp,a,a.Da.length|0)};e.Fn=function(a,b){return dj(ej(),a,this.Ec)?(new i$).yd(this.Ec,b,this.ad,this.de):dj(ej(),a,this.ad)?(new i$).yd(this.Ec,this.td,this.ad,b):(new j$).ti(this.Ec,this.td,this.ad,this.de,a,b)};
e.wg=function(a){return dj(ej(),a,this.Ec)?(new T).e(this.td):dj(ej(),a,this.ad)?(new T).e(this.de):S()};e.Ac=function(a){return dj(ej(),a,this.Ec)||dj(ej(),a,this.ad)};e.yd=function(a,b,c,d){this.Ec=a;this.td=b;this.ad=c;this.de=d;return this};e.km=function(a){return dj(ej(),a,this.Ec)?(new h$).a(this.ad,this.de):dj(ej(),a,this.ad)?(new h$).a(this.Ec,this.td):this};e.qk=function(a){return this.Fn(a.qa(),a.p())};
e.$classData=l({R2:0},!1,"scala.collection.immutable.Map$Map2",{R2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});function j$(){this.Wf=this.ge=this.de=this.ad=this.td=this.Ec=null}j$.prototype=new J9;j$.prototype.constructor=j$;e=j$.prototype;
e.Ea=function(a){if(dj(ej(),a,this.Ec))return this.td;if(dj(ej(),a,this.ad))return this.de;if(dj(ej(),a,this.ge))return this.Wf;throw(new BP).j("key not found: "+a);};e.Cb=function(a){a.Ea((new q).a(this.Ec,this.td));a.Ea((new q).a(this.ad,this.de));a.Ea((new q).a(this.ge,this.Wf))};e.pk=function(a){return this.km(a)};e.ti=function(a,b,c,d,f,g){this.Ec=a;this.td=b;this.ad=c;this.de=d;this.ge=f;this.Wf=g;return this};e.Za=function(){return 3};
e.Jb=function(){hN();var a=(new r).d([(new q).a(this.Ec,this.td),(new q).a(this.ad,this.de),(new q).a(this.ge,this.Wf)]);return Cp(new Dp,a,a.Da.length|0)};e.Fn=function(a,b){return dj(ej(),a,this.Ec)?(new j$).ti(this.Ec,b,this.ad,this.de,this.ge,this.Wf):dj(ej(),a,this.ad)?(new j$).ti(this.Ec,this.td,this.ad,b,this.ge,this.Wf):dj(ej(),a,this.ge)?(new j$).ti(this.Ec,this.td,this.ad,this.de,this.ge,b):k$(this.Ec,this.td,this.ad,this.de,this.ge,this.Wf,a,b)};
e.wg=function(a){return dj(ej(),a,this.Ec)?(new T).e(this.td):dj(ej(),a,this.ad)?(new T).e(this.de):dj(ej(),a,this.ge)?(new T).e(this.Wf):S()};e.Ac=function(a){return dj(ej(),a,this.Ec)||dj(ej(),a,this.ad)||dj(ej(),a,this.ge)};e.km=function(a){return dj(ej(),a,this.Ec)?(new i$).yd(this.ad,this.de,this.ge,this.Wf):dj(ej(),a,this.ad)?(new i$).yd(this.Ec,this.td,this.ge,this.Wf):dj(ej(),a,this.ge)?(new i$).yd(this.Ec,this.td,this.ad,this.de):this};e.qk=function(a){return this.Fn(a.qa(),a.p())};
e.$classData=l({S2:0},!1,"scala.collection.immutable.Map$Map3",{S2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});function l$(){this.Fj=this.$h=this.Wf=this.ge=this.de=this.ad=this.td=this.Ec=null}l$.prototype=new J9;l$.prototype.constructor=l$;e=l$.prototype;
e.Ea=function(a){if(dj(ej(),a,this.Ec))return this.td;if(dj(ej(),a,this.ad))return this.de;if(dj(ej(),a,this.ge))return this.Wf;if(dj(ej(),a,this.$h))return this.Fj;throw(new BP).j("key not found: "+a);};e.Cb=function(a){a.Ea((new q).a(this.Ec,this.td));a.Ea((new q).a(this.ad,this.de));a.Ea((new q).a(this.ge,this.Wf));a.Ea((new q).a(this.$h,this.Fj))};e.pk=function(a){return this.km(a)};e.Za=function(){return 4};
e.Jb=function(){hN();var a=(new r).d([(new q).a(this.Ec,this.td),(new q).a(this.ad,this.de),(new q).a(this.ge,this.Wf),(new q).a(this.$h,this.Fj)]);return Cp(new Dp,a,a.Da.length|0)};function k$(a,b,c,d,f,g,h,n){var u=new l$;u.Ec=a;u.td=b;u.ad=c;u.de=d;u.ge=f;u.Wf=g;u.$h=h;u.Fj=n;return u}
e.Fn=function(a,b){return dj(ej(),a,this.Ec)?k$(this.Ec,b,this.ad,this.de,this.ge,this.Wf,this.$h,this.Fj):dj(ej(),a,this.ad)?k$(this.Ec,this.td,this.ad,b,this.ge,this.Wf,this.$h,this.Fj):dj(ej(),a,this.ge)?k$(this.Ec,this.td,this.ad,this.de,this.ge,b,this.$h,this.Fj):dj(ej(),a,this.$h)?k$(this.Ec,this.td,this.ad,this.de,this.ge,this.Wf,this.$h,b):m$(m$(m$(m$(m$((new n$).c(),this.Ec,this.td),this.ad,this.de),this.ge,this.Wf),this.$h,this.Fj),a,b)};
e.wg=function(a){return dj(ej(),a,this.Ec)?(new T).e(this.td):dj(ej(),a,this.ad)?(new T).e(this.de):dj(ej(),a,this.ge)?(new T).e(this.Wf):dj(ej(),a,this.$h)?(new T).e(this.Fj):S()};e.Ac=function(a){return dj(ej(),a,this.Ec)||dj(ej(),a,this.ad)||dj(ej(),a,this.ge)||dj(ej(),a,this.$h)};
e.km=function(a){return dj(ej(),a,this.Ec)?(new j$).ti(this.ad,this.de,this.ge,this.Wf,this.$h,this.Fj):dj(ej(),a,this.ad)?(new j$).ti(this.Ec,this.td,this.ge,this.Wf,this.$h,this.Fj):dj(ej(),a,this.ge)?(new j$).ti(this.Ec,this.td,this.ad,this.de,this.$h,this.Fj):dj(ej(),a,this.$h)?(new j$).ti(this.Ec,this.td,this.ad,this.de,this.ge,this.Wf):this};e.qk=function(a){return this.Fn(a.qa(),a.p())};
e.$classData=l({T2:0},!1,"scala.collection.immutable.Map$Map4",{T2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});function o$(){this.UB=0;this.LB=null;this.YA=0;this.ke=this.Ti=this.Ue=null;this.Qv=!1;this.gn=null;this.Wh=0}o$.prototype=new B9;o$.prototype.constructor=o$;function PBa(){}e=PBa.prototype=o$.prototype;e.dc=function(){return this};
function QBa(a,b){var c=xR(a.gn,a.Ue),d;d=xR(a.gn,a.ke);a=a.gn.Yh(b);d=d.r.bm(d.$i,a);return c.r.Ii(c.$i,d)}e.rc=function(a){if(0>a||a>=p$(this))throw(new W).j(""+a);return QBa(this,a)};e.Ea=function(a){return this.rc(a|0)};e.g=function(){return 0===p$(this)};e.md=function(){return this};e.w=function(a){return a&&a.$classData&&a.$classData.H.ZE?p$(this)===p$(a)&&(0===p$(this)||dj(ej(),this.Ue,a.Ue)&&dj(ej(),this.Ze(),a.Ze())):a1(this,a)};
e.v=function(){var a=this.g()?"empty ":"",b=this.Qv?"to":"until",c=dj(ej(),this.ke,1)?"":td((new yd).X((new r).d([" by ",""])),(new r).d([this.ke]));return td((new yd).X((new r).d(";NumericRange ; ; ;;".split(";"))),(new r).d([a,this.Ue,b,this.Ti,c]))};e.qe=function(){return Rs()};e.Cb=function(a){for(var b=0,c=this.Ue;b<p$(this);)a.Ea(c),c=xR(this.gn,c),c=c.r.Ii(c.$i,this.ke),b=1+b|0};e.cm=function(){return this};e.we=function(){return D7(this)};
function p$(a){if(0===(1&a.Wh)&&0===(1&a.Wh)){var b;a:{Q_();var c=a.Ue,d=a.Ti,f=a.ke,g=a.Qv,h=a.gn,n=h.Yh(0),u=0>h.Ie(c,d),w=0<h.Ie(f,n);if(dj(ej(),f,n))throw(new t).j("step cannot be 0.");if(dj(ej(),c,d))b=g?1:0;else if(u!==w)b=0;else{b=h.dm(c);if(dj(ej(),c,h.Yh(b))){var D=h.dm(d);if(dj(ej(),d,h.Yh(D))){var N=h.dm(f);if(dj(ej(),f,h.Yh(N))){if(g){h=b>D&&0<N||b<D&&0>N;if(0===N)throw(new t).j("step cannot be 0.");h?h=0:(g=D>>31,n=b>>31,h=D-b|0,n=(-2147483648^h)>(-2147483648^D)?-1+(g-n|0)|0:g-n|0,f=
N>>31,g=ab(),h=Fp(g,h,n,N,f),g=g.dd,h=1+h|0,g=0===h?1+g|0:g,h=(0===g?-1<(-2147483648^h):0<g)?-1:h);switch(N){case 1:break;case -1:break;default:n=D>>31,f=b>>31,g=D-b|0,n=(-2147483648^g)>(-2147483648^D)?-1+(n-f|0)|0:n-f|0,f=N>>31,lq(ab(),g,n,N,f)}b=0>h?S_(qN(),b,D,N,!0):h;break a}h=b>D&&0<N||b<D&&0>N||b===D;if(0===N)throw(new t).j("step cannot be 0.");h?h=0:(g=D>>31,n=b>>31,h=D-b|0,n=(-2147483648^h)>(-2147483648^D)?-1+(g-n|0)|0:g-n|0,f=N>>31,g=ab(),h=Fp(g,h,n,N,f),g=g.dd,f=D>>31,d=b>>31,n=D-b|0,d=
(-2147483648^n)>(-2147483648^D)?-1+(f-d|0)|0:f-d|0,u=N>>31,f=ab(),n=lq(f,n,d,N,u),f=f.dd,f=0!==n||0!==f?1:0,n=f>>31,f=h+f|0,h=(-2147483648^f)<(-2147483648^h)?1+(g+n|0)|0:g+n|0,h=(0===h?-1<(-2147483648^f):0<h)?-1:f);switch(N){case 1:break;case -1:break;default:n=D>>31,f=b>>31,g=D-b|0,n=(-2147483648^g)>(-2147483648^D)?-1+(n-f|0)|0:n-f|0,f=N>>31,lq(ab(),g,n,N,f)}b=0>h?S_(qN(),b,D,N,!1):h;break a}}}D=h.Yh(1);b=h.Yh(2147483647);var N=Tva(h,c),Q=Tva(h,d);0<=fa(N,Q)?(d=h.Nl(d,c),N=P_(h.mn(d,f),h,b),f=h.Nl(d,
h.bm(N,f)),b=!g&&dj(ej(),n,f)?N:P_(h.Ii(N,D),h,b)):(N=h.Yh(-1),N=h.Nl(w?N:D,c),N=P_(h.mn(N,f),h,b),c=dj(ej(),N,n)?c:h.Ii(c,h.bm(N,f)),c=h.Ii(c,f),0>h.Ie(c,d)!==u?D=g&&dj(ej(),c,d)?h.Ii(N,h.Yh(2)):h.Ii(N,D):(u=h.Nl(d,c),u=P_(h.mn(u,f),h,b),n=dj(ej(),u,n)?c:h.Ii(c,h.bm(u,f)),D=h.Ii(N,h.Ii(u,!g&&dj(ej(),n,d)?D:h.Yh(2)))),b=P_(D,h,b));b=h.dm(b)}}a.UB=b;a.Wh|=1}return a.UB}e.Jb=function(){return Cp(new Dp,this,p$(this))};e.kj=function(){return this};e.Fa=function(){return p$(this)};e.Df=function(){return p$(this)};
e.tf=function(a){0>=a||0===p$(this)?a=this:a>=p$(this)?(a=this.Ti,Q_(),a=(new q$).Up(a,a,this.ke,this.gn)):a=this.lA(QBa(this,a),this.Ti,this.ke);return a};e.Ze=function(){if(0===(2&this.Wh)&&0===(2&this.Wh)){if(0===p$(this))var a=F(),a=cl(a);else a=QBa(this,-1+p$(this)|0);this.LB=a;this.Wh|=2}return this.LB};e.cB=function(a,b,c,d,f){this.Ue=a;this.Ti=b;this.ke=c;this.Qv=d;this.gn=f;return this};e.kf=function(){return this};e.vf=function(a){return G1(this,a|0)};
e.A=function(){0===(4&this.Wh)&&0===(4&this.Wh)&&(this.YA=PU(XN(),this),this.Wh|=4);return this.YA};function n$(){}n$.prototype=new J9;n$.prototype.constructor=n$;function r$(){}e=r$.prototype=n$.prototype;e.dc=function(){return this};e.wk=function(a){return this.uv(YN(Y(),a))};e.c=function(){return this};e.md=function(){return this};e.Po=function(a,b,c,d,f){return s$(a,b,d,f)};e.Wn=function(){return S()};e.Cb=function(){};
function RBa(a,b){v3();var c=6+a.Za()|0,c=oa(bc(r3),[224>c?c:224]);v3();a=a.Sn(b,!0,0,c,0);return null===a?u3():a}function m$(a,b,c){return a.Po(b,a.wk(b),0,c,null,null)}e.pk=function(a){return this.wo(a,this.wk(a),0)};e.Rn=function(){v3();return u3()};e.wo=function(){return this};e.Sn=function(){return null};e.mh=function(a){v3();var b=6+this.Za()|0,b=oa(bc(r3),[224>b?b:224]);v3();a=this.Sn(a,!1,0,b,0);return null===a?u3():a};e.gv=function(){v3();return u3()};e.Za=function(){return 0};e.Nq=function(){return this};
e.Jb=function(){return hN().Pg};e.Ix=function(){var a=this.n().qa();return this.wo(a,this.wk(a),0)};e.vg=function(a){return RBa(this,a)};e.uv=function(a){a=a+~(a<<9)|0;a^=a>>>14|0;a=a+(a<<4)|0;return a^(a>>>10|0)};e.wg=function(a){return this.Wn(a,this.wk(a),0)};e.On=function(){return!1};e.Ac=function(a){return this.On(a,this.wk(a),0)};e.o=function(){return this.Ix()};e.QA=function(a){return RBa(this,a)};e.qk=function(a){return this.Po(a.qa(),this.wk(a.qa()),0,a.p(),a,null)};
var r3=l({Kq:0},!1,"scala.collection.immutable.HashMap",{Kq:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1,Fd:1});n$.prototype.$classData=r3;function X9(){this.Oe=null;this.Yc=0}X9.prototype=new LBa;X9.prototype.constructor=X9;e=X9.prototype;
e.$q=function(a,b,c){if(b===this.Yc&&dj(ej(),a,this.Oe))return this;if(b!==this.Yc)return c4(h4(),this.Yc,this,b,(new X9).Cl(a,b),c);c=k4();return t$(new u$,b,L9(new M9,c,this.Oe).Mk(a))};e.Zq=function(a,b){return a.em(this,b)};e.Cb=function(a){a.Ea(this.Oe)};e.Cl=function(a,b){this.Oe=a;this.Yc=b;return this};
e.em=function(a,b){if(a.Yc!==this.Yc)return c4(h4(),this.Yc,this,a.Yc,a,b);if(Fva(a)){if(dj(ej(),this.Oe,a.Oe))return this;b=this.Yc;var c=k4();return t$(new u$,b,L9(new M9,c,this.Oe).Mk(a.Oe))}if(a&&a.$classData&&a.$classData.H.kx)return b=a.yg.Mk(this.Oe),b.Za()===a.yg.Za()?a:t$(new u$,this.Yc,b);throw(new p).e(a);};e.Za=function(){return 1};e.Jb=function(){hN();var a=(new r).d([this.Oe]);return Cp(new Dp,a,a.Da.length|0)};e.wq=function(a,b){return b===this.Yc&&dj(ej(),a,this.Oe)?null:this};
e.Tn=function(a,b){return b!==!!a.Ea(this.Oe)?this:null};e.Al=function(a,b){return b===this.Yc&&dj(ej(),a,this.Oe)};e.Vq=function(a,b){return a.Al(this.Oe,this.Yc,b)};function Fva(a){return!!(a&&a.$classData&&a.$classData.H.XE)}e.$classData=l({XE:0},!1,"scala.collection.immutable.HashSet$HashSet1",{XE:1,lx:1,wn:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,Fd:1,l:1,k:1});
function u$(){this.Yc=0;this.yg=null}u$.prototype=new LBa;u$.prototype.constructor=u$;e=u$.prototype;e.$q=function(a,b,c){return b===this.Yc?t$(new u$,b,this.yg.Mk(a)):c4(h4(),this.Yc,this,b,(new X9).Cl(a,b),c)};e.Zq=function(a,b){return a&&a.$classData&&a.$classData.H.lx?this.em(a,b):W1(a)?a.em(this,b):this};e.Cb=function(a){var b=N9(this.yg);QU(ZM(b),a)};
e.em=function(a,b){if(a.Yc!==this.Yc)return c4(h4(),this.Yc,this,a.Yc,a,b);if(Fva(a))return a=this.yg.Mk(a.Oe),a.Za()===this.yg.Za()?this:t$(new u$,this.Yc,a);if(a&&a.$classData&&a.$classData.H.kx){b=GBa(this.yg,a.yg);var c=b.Za();return c===this.yg.Za()?this:c===a.yg.Za()?a:t$(new u$,this.Yc,b)}throw(new p).e(a);};e.Za=function(){return this.yg.Za()};e.Jb=function(){var a=N9(this.yg);return ZM(a)};
e.wq=function(a,b){if(b===this.Yc){a=this.yg.Tx(a);var c=a.Za();switch(c){case 0:return null;case 1:return a=N9(a),(new X9).Cl(ZM(a).bb(),b);default:return c===this.yg.Za()?this:t$(new u$,b,a)}}else return this};function t$(a,b,c){a.Yc=b;a.yg=c;return a}e.Tn=function(a,b){a=b?P2(this.yg,a,!0):P2(this.yg,a,!1);b=a.Za();switch(b){case 0:return null;case 1:return a=N9(a),(new X9).Cl(ZM(a).bb(),this.Yc);default:return b===this.yg.Za()?this:t$(new u$,this.Yc,a)}};
e.Al=function(a,b){return b===this.Yc&&this.yg.Ac(a)};e.Vq=function(a,b){for(var c=N9(this.yg),c=ZM(c),d=!0;d&&c.fb();)d=c.bb(),d=a.Al(d,this.Yc,b);return d};e.$classData=l({kx:0},!1,"scala.collection.immutable.HashSet$HashSetCollision1",{kx:1,lx:1,wn:1,ej:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,mk:1,Bd:1,Gd:1,Ed:1,Fd:1,l:1,k:1});function v$(){}v$.prototype=new MBa;v$.prototype.constructor=v$;v$.prototype.c=function(){return this};
v$.prototype.$classData=l({I2:0},!1,"scala.collection.immutable.ListMap$EmptyListMap$",{I2:1,H2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});var SBa=void 0;function NBa(){SBa||(SBa=(new v$).c());return SBa}function e$(){this.Ux=this.hm=this.Oe=null}e$.prototype=new MBa;e$.prototype.constructor=e$;
function w$(a,b){var c=F();for(;;){if(b.g())return cl(c);if(dj(ej(),a,b.Gi())){b=b.Ol();for(a=c;!a.g();)c=a.n(),b=d$(new e$,b,c.Gi(),c.Xf()),a=a.o();return b}var d=b.Ol(),c=U(new V,b,c);b=d}}e=e$.prototype;e.Ea=function(a){a:{var b=this;for(;;){if(b.g())throw(new BP).j("key not found: "+a);if(dj(ej(),a,b.Gi())){a=b.Xf();break a}b=b.Ol()}}return a};e.Xf=function(){return this.hm};e.g=function(){return!1};e.pk=function(a){return w$(a,this)};
e.Za=function(){a:{var a=this,b=0;for(;;){if(a.g())break a;a=a.Ol();b=1+b|0}}return b};e.Gi=function(){return this.Oe};e.er=function(a){var b=w$(a.qa(),this);return d$(new e$,b,a.qa(),a.p())};e.Px=function(a,b){var c=w$(a,this);return d$(new e$,c,a,b)};e.Wt=function(a){return w$(a,this)};e.wg=function(a){a:{var b=this;for(;;){if(b.g()){a=S();break a}if(dj(ej(),a,b.Gi())){a=(new T).e(b.Xf());break a}b=b.Ol()}}return a};
e.Ac=function(a){a:{var b=this;for(;;){if(b.g()){a=!1;break a}if(dj(ej(),a,b.Gi())){a=!0;break a}b=b.Ol()}}return a};function d$(a,b,c,d){a.Oe=c;a.hm=d;if(null===b)throw jo(wj(),null);a.Ux=b;return a}e.Ol=function(){return this.Ux};e.qk=function(a){return this.er(a)};
e.$classData=l({J2:0},!1,"scala.collection.immutable.ListMap$Node",{J2:1,H2:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1});function q$(){o$.call(this);this.pq=null}q$.prototype=new PBa;q$.prototype.constructor=q$;q$.prototype.Up=function(a,b,c,d){this.pq=d;o$.prototype.cB.call(this,a,b,c,!1,d);return this};q$.prototype.lA=function(a,b,c){Q_();return(new q$).Up(a,b,c,this.pq)};
q$.prototype.$classData=l({W2:0},!1,"scala.collection.immutable.NumericRange$Exclusive",{W2:1,ZE:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Jo:1,lk:1,Bd:1,Gd:1,Ed:1,Cg:1,Zd:1,l:1,k:1});function X4(){o$.call(this);this.pq=null}X4.prototype=new PBa;X4.prototype.constructor=X4;X4.prototype.Up=function(a,b,c,d){this.pq=d;o$.prototype.cB.call(this,a,b,c,!0,d);return this};
X4.prototype.lA=function(a,b,c){Q_();return(new X4).Up(a,b,c,this.pq)};X4.prototype.$classData=l({X2:0},!1,"scala.collection.immutable.NumericRange$Inclusive",{X2:1,ZE:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Jo:1,lk:1,Bd:1,Gd:1,Ed:1,Cg:1,Zd:1,l:1,k:1});function m0(){this.ke=this.Ti=this.Ue=0;this.Yi=!1;this.gx=this.ek=0}m0.prototype=new B9;m0.prototype.constructor=m0;function TBa(){}e=TBa.prototype=m0.prototype;
e.dc=function(){return this};e.Wk=function(){return!1};e.n=function(){return this.Yi?F().Ls():this.Ue};e.rc=function(a){return this.rp(a)};e.Ea=function(a){return this.rp(a|0)};e.g=function(){return this.Yi};e.md=function(){return this};e.w=function(a){if(a&&a.$classData&&a.$classData.H.mx){if(this.Yi)return a.Yi;if(cj(a)&&this.Ue===a.Ue){var b=x$(this);return b===x$(a)&&(this.Ue===b||this.ke===a.ke)}return!1}return a1(this,a)};
e.rp=function(a){0>this.ek&&S_(qN(),this.Ue,this.Ti,this.ke,this.Wk());if(0>a||a>=this.ek)throw(new W).j(""+a);return this.Ue+fa(this.ke,a)|0};
e.Be=function(a,b,c){this.Ue=a;this.Ti=b;this.ke=c;this.Yi=a>b&&0<c||a<b&&0>c||a===b&&!this.Wk();if(0===c)throw(new t).j("step cannot be 0.");if(this.Yi)a=0;else{var d;d=UBa(this);a=d.Ra;var f=d.Ya,g=this.ke,h=g>>31;d=ab();a=Fp(d,a,f,g,h);d=d.dd;g=this.Wk()||!VBa(this)?1:0;f=g>>31;g=a+g|0;d=(new Ep).K(g,(-2147483648^g)<(-2147483648^a)?1+(d+f|0)|0:d+f|0);a=d.Ra;d=d.Ya;a=(0===d?-1<(-2147483648^a):0<d)?-1:a}this.ek=a;switch(c){case 1:b=this.Wk()?b:-1+b|0;break;case -1:b=this.Wk()?b:1+b|0;break;default:d=
UBa(this),a=d.Ra,d=d.Ya,f=c>>31,a=lq(ab(),a,d,c,f),b=0!==a?b-a|0:this.Wk()?b:b-c|0}this.gx=b;return this};e.ag=function(){if(this.Yi){var a=F();oD(a)}0<=this.ek?(a=this.ek-1|0,0>=a||this.Yi?(a=this.Ue,a=(new m0).Be(a,a,this.ke)):a=a>=this.ek&&0<=this.ek?this:(new y$).Be(this.Ue,this.Ue+fa(this.ke,-1+a|0)|0,this.ke)):(a=x$(this)-fa(this.ke,1)|0,0<this.ke&&a<this.Ue||0>this.ke&&a>this.Ue?(a=this.Ue,a=(new m0).Be(a,a,this.ke)):a=(new y$).Be(this.Ue,a,this.ke));return a};e.qe=function(){return Rs()};
e.v=function(){var a=this.Wk()?"to":"until",b=1===this.ke?"":td((new yd).X((new r).d([" by ",""])),(new r).d([this.ke])),c=this.Yi?"empty ":VBa(this)?"":"inexact ";return td((new yd).X((new r).d(";Range ; ; ;;".split(";"))),(new r).d([c,this.Ue,a,this.Ti,b]))};e.Cb=function(a){if(!this.Yi)for(var b=this.Ue;;){a.Ea(b);if(b===this.gx)break;b=b+this.ke|0}};e.kA=function(a,b,c){return(new m0).Be(a,b,c)};e.cm=function(){return this};e.Za=function(){return this.Fa()};e.we=function(){return D7(this)};
e.Jb=function(){return Cp(new Dp,this,this.Fa())};e.Fa=function(){return 0>this.ek?S_(qN(),this.Ue,this.Ti,this.ke,this.Wk()):this.ek};e.kj=function(){return this};e.Df=function(){return this.Fa()};function WBa(a,b){return 0>=b||a.Yi?a:b>=a.ek&&0<=a.ek?(b=a.Ti,(new m0).Be(b,b,a.ke)):a.kA(a.Ue+fa(a.ke,b)|0,a.Ti,a.ke)}function VBa(a){var b=UBa(a),c=b.Ra,b=b.Ya,d=a.ke,f=d>>31;a=ab();c=lq(a,c,b,d,f);b=a.dd;return 0===c&&0===b}e.Ze=function(){return x$(this)};e.tf=function(a){return WBa(this,a)};
e.kf=function(){return this};e.o=function(){this.Yi&&XBa(F());return WBa(this,1)};function x$(a){return a.Yi?(a=F(),cl(a)|0):a.gx}e.vf=function(a){return G1(this,a|0)};e.A=function(){return PU(XN(),this)};function UBa(a){var b=a.Ti,c=b>>31,d=a.Ue;a=d>>31;d=b-d|0;return(new Ep).K(d,(-2147483648^d)>(-2147483648^b)?-1+(c-a|0)|0:c-a|0)}
e.$classData=l({mx:0},!1,"scala.collection.immutable.Range",{mx:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Jo:1,lk:1,Bd:1,Gd:1,Ed:1,Cg:1,Zd:1,Fd:1,l:1,k:1});function z$(){}z$.prototype=new B9;z$.prototype.constructor=z$;function YBa(){}e=YBa.prototype=z$.prototype;e.dc=function(){return this};e.rc=function(a){return ro(this,a)};e.Pe=function(a){return qo(this,a)};e.Qf=function(a){return M8(this,a)};
e.Ea=function(a){return ro(this,a|0)};e.$f=function(a){return tBa(this,a)};e.qv=function(a){return ZBa(this,a)};e.md=function(){return this};function dwa(a,b){var c=(nN(),(new T_).c());if(ewa(c.mi(a))){if(a.g())a=VU();else{for(var c=(new Uk).e(a),d=b.Ea(c.cb.n()).ce();!c.cb.g()&&d.g();)c.cb=c.cb.o(),c.cb.g()||(d=b.Ea(c.cb.n()).ce());a=c.cb.g()?(nN(),VU()):KO(d,Rq(function(a,b,c){return function(){return dwa(c.cb.o(),b)}}(a,b,c)))}return a}return Yva(a,b,c)}
e.w=function(a){return this===a||a1(this,a)};function Ooa(a,b,c){for(;!a.g()&&!!b.Ea(a.n())===c;)a=a.o();return cj(a)?cBa(nN(),a,b,c):VU()}e.FA=function(a){return $Ba(this,a)};e.Pd=function(a){return this.le("",a,"")};e.le=function(a,b,c){var d=this,f=this;for(d.g()||(d=d.o());f!==d&&!d.g();){d=d.o();if(d.g())break;d=d.o();if(d===f)break;f=f.o()}return gG(this,a,b,c)};e.Le=function(a){return uBa(this,a)};e.St=function(a){return Noa(new hV,Rq(function(a){return function(){return a}}(this)),a)};
e.ag=function(){return aCa(this)};e.qe=function(){return nN()};e.v=function(){return gG(this,"Stream(",", ",")")};e.Cb=function(a){var b=this;a:for(;;){if(!b.g()){a.Ea(b.n());b=b.o();continue a}break}};e.se=function(a,b){var c=this;for(;;){if(c.g())return a;var d=c.o();a=b.ug(a,c.n());c=d}};e.nv=function(a,b){return Ooa(this,a,b)};e.Jb=function(){return Cva(this)};
e.ma=function(a,b){return ewa(b.mi(this))?(this.g()?a=a.ce():(b=this.n(),a=TU(new UU,b,Rq(function(a,b){return function(){return a.o().ma(b,(nN(),(new T_).c()))}}(this,a)))),a):Q2(this,a,b)};e.Fa=function(){for(var a=0,b=this;!b.g();)a=1+a|0,b=b.o();return a};e.Of=function(){return this.le("","","")};e.kj=function(){return this};e.$F=function(a){return bCa(this,a)};e.ce=function(){return this};e.Ze=function(){return cl(this)};
function ZBa(a,b){for(var c=(new Uk).e(a);;)if(cj(c.cb)){var d=b.Ea(c.cb.n());if(d.g())c.cb=c.cb.o();else return d=d.ce(),nN(),Zja((new JO).Ms(Rq(function(a,b,c){return function(){return ZBa(c.cb.o(),b)}}(a,b,c))),d)}else break;nN();return VU()}e.tf=function(a){return $Ba(this,a)};function $Ba(a,b){for(;;){if(0>=b||a.g())return a;a=a.o();b=-1+b|0}}e.kf=function(){return this};
e.qg=function(a,b,c,d){rl(a,b);if(!this.g()){sl(a,this.n());b=this;if(b.il()){var f=this.o();if(f.g())return rl(a,d),a;if(b!==f&&(b=f,f.il()))for(f=f.o();b!==f&&f.il();)sl(rl(a,c),b.n()),b=b.o(),f=f.o(),f.il()&&(f=f.o());if(f.il()){for(var g=this,h=0;g!==f;)g=g.o(),f=f.o(),h=1+h|0;b===f&&0<h&&(sl(rl(a,c),b.n()),b=b.o());for(;b!==f;)sl(rl(a,c),b.n()),b=b.o()}else{for(;b!==f;)sl(rl(a,c),b.n()),b=b.o();cj(b)&&sl(rl(a,c),b.n())}}b.g()||(b.il()?rl(rl(a,c),"..."):rl(rl(a,c),"?"))}rl(a,d);return a};
e.vf=function(a){return wBa(this,a|0)};e.A=function(){return PU(XN(),this)};function aCa(a){if(a.g())return oD(a);if(a.o().g())return VU();var b=a.n();return TU(new UU,b,Rq(function(a){return function(){return aCa(a.o())}}(a)))}e.yf=function(a,b){return ewa(b.mi(this))?(this.g()?a=VU():(b=a.Ea(this.n()),a=TU(new UU,b,Rq(function(a,b){return function(){return a.o().yf(b,(nN(),(new T_).c()))}}(this,a)))),a):SQ(this,a,b)};
function bCa(a,b){if(0>=b||a.g())return nN(),VU();if(1===b)return b=a.n(),TU(new UU,b,Rq(function(){return function(){nN();return VU()}}(a)));var c=a.n();return TU(new UU,c,Rq(function(a,b){return function(){return bCa(a.o(),-1+b|0)}}(a,b)))}e.$e=function(a){if(this.g())throw(new Gq).j("empty.reduceLeft");for(var b=this.n(),c=this.o();!c.g();)b=a.ug(b,c.n()),c=c.o();return b};
function KO(a,b){if(a.g())return OO(b).ce();var c=a.n();return TU(new UU,c,Rq(function(a,b){return function(){return KO(a.o(),b)}}(a,b)))}e.jf=function(){return"Stream"};function f0(a,b){if(b>=a.kd)throw(new W).j(""+b);return a.Da.i[b]}
function dpa(a,b){var c=a.Da.i.length,d=c>>31,f=b>>31;if(f===d?(-2147483648^b)>(-2147483648^c):f>d){f=c<<1;for(c=c>>>31|0|d<<1;;){var d=b>>31,g=f,h=c;if(d===h?(-2147483648^b)>(-2147483648^g):d>h)c=f>>>31|0|c<<1,f<<=1;else break}b=c;if(0===b?-1<(-2147483648^f):0<b)f=2147483647;b=f;b=oa(bc(Ab),[b]);Ta(a.Da,0,b,0,a.kd);a.Da=b}}function A$(){}A$.prototype=new r$;A$.prototype.constructor=A$;e=A$.prototype;e.c=function(){return this};e.n=function(){throw(new BP).j("Empty Map");};
e.Ix=function(){throw(new BP).j("Empty Map");};e.o=function(){return this.Ix()};e.$classData=l({w2:0},!1,"scala.collection.immutable.HashMap$EmptyHashMap$",{w2:1,Kq:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1,Fd:1});var cCa=void 0;function u3(){cCa||(cCa=(new A$).c());return cCa}function B$(){this.Oe=null;this.Yc=0;this.Zs=this.hm=null}B$.prototype=new r$;
B$.prototype.constructor=B$;function V2(a){null===a.Zs&&(a.Zs=(new q).a(a.Oe,a.hm));return a.Zs}function s$(a,b,c,d){var f=new B$;f.Oe=a;f.Yc=b;f.hm=c;f.Zs=d;return f}e=B$.prototype;e.Po=function(a,b,c,d,f,g){if(b===this.Yc&&dj(ej(),a,this.Oe)){if(null===g)return this.hm===d?this:s$(a,b,d,f);a=g.Su(V2(this),null!==f?f:(new q).a(a,d));return s$(a.qa(),b,a.p(),a)}if(b!==this.Yc)return a=s$(a,b,d,f),kwa(v3(),this.Yc,this,b,a,c,2);c=NBa();return C$(new D$,b,d$(new e$,c,this.Oe,this.hm).Px(a,d))};
e.Wn=function(a,b){return b===this.Yc&&dj(ej(),a,this.Oe)?(new T).e(this.hm):S()};e.Cb=function(a){a.Ea(V2(this))};e.wo=function(a,b){return b===this.Yc&&dj(ej(),a,this.Oe)?(v3(),u3()):this};e.Sn=function(a,b){return b!==!!a.Ea(V2(this))?this:null};e.Za=function(){return 1};e.Jb=function(){hN();var a=(new r).d([V2(this)]);return Cp(new Dp,a,a.Da.length|0)};e.On=function(a,b){return b===this.Yc&&dj(ej(),a,this.Oe)};
e.$classData=l({VE:0},!1,"scala.collection.immutable.HashMap$HashMap1",{VE:1,Kq:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1,Fd:1});function D$(){this.Yc=0;this.ai=null}D$.prototype=new r$;D$.prototype.constructor=D$;e=D$.prototype;
e.Po=function(a,b,c,d,f,g){if(b===this.Yc)return null!==g&&this.ai.Ac(a)?C$(new D$,b,this.ai.er(g.Su((new q).a(a,this.ai.Ea(a)),f))):C$(new D$,b,this.ai.Px(a,d));a=s$(a,b,d,f);return kwa(v3(),this.Yc,this,b,a,c,1+this.ai.Za()|0)};e.Wn=function(a,b){return b===this.Yc?this.ai.wg(a):S()};e.Cb=function(a){var b=f$(this.ai);QU(ZM(b),a)};
e.wo=function(a,b){if(b===this.Yc){a=this.ai.Wt(a);var c=a.Za();switch(c){case 0:return v3(),u3();case 1:return a=f$(a),a=ZM(a).bb(),s$(a.qa(),b,a.p(),a);default:return c===this.ai.Za()?this:C$(new D$,b,a)}}else return this};e.Sn=function(a,b){a=b?$8(this.ai,a):P2(this.ai,a,!1);b=a.Za();switch(b){case 0:return null;case 1:a=f$(a);a=ZM(a).bb();if(null===a)throw(new p).e(a);return s$(a.qa(),this.Yc,a.p(),a);default:return b===this.ai.Za()?this:C$(new D$,this.Yc,a)}};
e.Jb=function(){var a=f$(this.ai);return ZM(a)};e.Za=function(){return this.ai.Za()};function C$(a,b,c){a.Yc=b;a.ai=c;return a}e.On=function(a,b){return b===this.Yc&&this.ai.Ac(a)};e.$classData=l({x2:0},!1,"scala.collection.immutable.HashMap$HashMapCollision1",{x2:1,Kq:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1,Fd:1});function t3(){this.Fh=0;this.re=null;this.kd=0}
t3.prototype=new r$;t3.prototype.constructor=t3;e=t3.prototype;
e.Po=function(a,b,c,d,f,g){var h=1<<(31&(b>>>c|0)),n=dP(aO(),this.Fh&(-1+h|0));if(0!==(this.Fh&h)){h=this.re.i[n];a=h.Po(a,b,5+c|0,d,f,g);if(a===h)return this;b=oa(bc(r3),[this.re.i.length]);E0(Tp(),this.re,0,b,0,this.re.i.length);b.i[n]=a;return s3(new t3,this.Fh,b,this.kd+(a.Za()-h.Za()|0)|0)}c=oa(bc(r3),[1+this.re.i.length|0]);E0(Tp(),this.re,0,c,0,n);c.i[n]=s$(a,b,d,f);E0(Tp(),this.re,n,c,1+n|0,this.re.i.length-n|0);return s3(new t3,this.Fh|h,c,1+this.kd|0)};
e.Wn=function(a,b,c){var d=31&(b>>>c|0);if(-1===this.Fh)return this.re.i[d].Wn(a,b,5+c|0);d=1<<d;return 0!==(this.Fh&d)?(d=dP(aO(),this.Fh&(-1+d|0)),this.re.i[d].Wn(a,b,5+c|0)):S()};e.Cb=function(a){for(var b=0;b<this.re.i.length;)this.re.i[b].Cb(a),b=1+b|0};
e.wo=function(a,b,c){var d=1<<(31&(b>>>c|0)),f=dP(aO(),this.Fh&(-1+d|0));if(0!==(this.Fh&d)){var g=this.re.i[f];a=g.wo(a,b,5+c|0);if(a===g)return this;if(0===a.Za()){d^=this.Fh;if(0!==d)return a=oa(bc(r3),[-1+this.re.i.length|0]),E0(Tp(),this.re,0,a,0,f),E0(Tp(),this.re,1+f|0,a,f,-1+(this.re.i.length-f|0)|0),f=this.kd-g.Za()|0,1!==a.i.length||V1(a.i[0])?s3(new t3,d,a,f):a.i[0];v3();return u3()}return 1!==this.re.i.length||V1(a)?(d=oa(bc(r3),[this.re.i.length]),E0(Tp(),this.re,0,d,0,this.re.i.length),
d.i[f]=a,f=this.kd+(a.Za()-g.Za()|0)|0,s3(new t3,this.Fh,d,f)):a}return this};
e.Sn=function(a,b,c,d,f){for(var g=f,h=0,n=0,u=0;u<this.re.i.length;){var w=this.re.i[u].Sn(a,b,5+c|0,d,g);null!==w&&(d.i[g]=w,g=1+g|0,h=h+w.Za()|0,n|=1<<u);u=1+u|0}if(g===f)return null;if(h===this.kd)return this;if(g!==(1+f|0)||V1(d.i[f])){b=g-f|0;a=oa(bc(r3),[b]);Ta(d,f,a,0,b);if(b===this.re.i.length)n=this.Fh;else{v3();d=0;for(f=this.Fh;0!==n;)b=f^f&(-1+f|0),0!==(1&n)&&(d|=b),f&=~b,n=n>>>1|0;n=d}return s3(new t3,n,a,h)}return d.i[f]};
e.Jb=function(){var a=new U2;U1.prototype.ZA.call(a,this.re);return a};e.Za=function(){return this.kd};function s3(a,b,c,d){a.Fh=b;a.re=c;a.kd=d;return a}e.On=function(a,b,c){var d=31&(b>>>c|0);if(-1===this.Fh)return this.re.i[d].On(a,b,5+c|0);d=1<<d;return 0!==(this.Fh&d)?(d=dP(aO(),this.Fh&(-1+d|0)),this.re.i[d].On(a,b,5+c|0)):!1};function V1(a){return!!(a&&a.$classData&&a.$classData.H.WE)}
e.$classData=l({WE:0},!1,"scala.collection.immutable.HashMap$HashTrieMap",{WE:1,Kq:1,ik:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,jk:1,Bd:1,Gd:1,Ed:1,kk:1,l:1,k:1,Fd:1});function E$(){}E$.prototype=new B9;E$.prototype.constructor=E$;function dCa(){}e=dCa.prototype=E$.prototype;e.dc=function(){return this};e.rc=function(a){return ro(this,a)};e.Pe=function(a){return qo(this,a)};
e.Ea=function(a){return ro(this,a|0)};e.Qf=function(a){return M8(this,a)};e.$f=function(a){return tBa(this,a)};e.lb=function(){return this};e.md=function(){return this};e.FA=function(a){return zua(this,a)};function Aua(a,b){if(a.g()||0>=b)return F();for(var c=U(new V,a.n(),F()),d=c,f=a.o(),g=1;;){if(f.g())return a;if(g<b)var g=1+g|0,h=U(new V,f.n(),F()),d=d.ga=h,f=f.o();else break}return c}e.Le=function(a){return uBa(this,a)};e.qe=function(){return G()};
e.Cb=function(a){for(var b=this;!b.g();)a.Ea(b.n()),b=b.o()};e.se=function(a,b){return vBa(this,a,b)};e.Xt=function(a,b){return b&&b.$classData&&b.$classData.H.jx?U(new V,a,this):pBa(this,a,b)};e.Jb=function(){return ZM(this)};function zua(a,b){for(;!a.g()&&0<b;)a=a.o(),b=-1+b|0;return a}e.kj=function(){return this};e.Fa=function(){return Cg(this)};
e.ma=function(a,b){b===G().b?(a=a.dc().lb(),a.g()?a=this:this.g()||(b=Ll((new ae).c(),this),b.g()||(b.Op&&eCa(b),b.Dk.ga=a,a=b.lb()))):a=Q2(this,a,b);return a};e.$F=function(a){return Aua(this,a)};e.ce=function(){return this.g()?VU():TU(new UU,this.n(),Rq(function(a){return function(){return a.o().ce()}}(this)))};e.tf=function(a){return zua(this,a)};e.Ze=function(){return cl(this)};e.kf=function(){return this};e.vf=function(a){return wBa(this,a|0)};e.A=function(){return PU(XN(),this)};
e.yf=function(a,b){if(b===G().b){if(this===F())return F();for(var c=b=U(new V,a.Ea(this.n()),F()),d=this.o();d!==F();)var f=U(new V,a.Ea(d.n()),F()),c=c.ga=f,d=d.o();return b}return SQ(this,a,b)};function ex(a,b,c){if(c===G().b){if(a===F())return F();c=null;do{var d=b.Vh(a.n(),G().sq);d!==G().sq&&(c=U(new V,d,F()));a=a.o();if(a===F())return null===c?F():c}while(null===c);d=c;do{var f=b.Vh(a.n(),G().sq);f!==G().sq&&(f=U(new V,f,F()),d=d.ga=f);a=a.o()}while(a!==F());return c}return awa(a,b,c)}
e.$e=function(a){return xBa(this,a)};function Bua(a){for(var b=F();!a.g();){var c=a.n(),b=U(new V,c,b);a=a.o()}return b}e.jf=function(){return"List"};function Ty(a){return!!(a&&a.$classData&&a.$classData.H.It)}var Bx=l({It:0},!1,"scala.collection.immutable.List",{It:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Ht:1,lk:1,Bd:1,Gd:1,Ed:1,Co:1,Dt:1,R:1,Et:1,l:1,k:1});E$.prototype.$classData=Bx;
function y$(){m0.call(this)}y$.prototype=new TBa;y$.prototype.constructor=y$;y$.prototype.Wk=function(){return!0};y$.prototype.Be=function(a,b,c){m0.prototype.Be.call(this,a,b,c);return this};y$.prototype.kA=function(a,b,c){return(new y$).Be(a,b,c)};
y$.prototype.$classData=l({Z2:0},!1,"scala.collection.immutable.Range$Inclusive",{Z2:1,mx:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Jo:1,lk:1,Bd:1,Gd:1,Ed:1,Cg:1,Zd:1,Fd:1,l:1,k:1});function UU(){this.Qt=this.bG=this.Ks=null}UU.prototype=new YBa;UU.prototype.constructor=UU;e=UU.prototype;e.n=function(){return this.Ks};function F$(a){a.il()||a.il()||(a.bG=OO(a.Qt),a.Qt=null);return a.bG}
e.Qf=function(a){return fCa(a)?gCa(this,a):M8(this,a)};e.il=function(){return null===this.Qt};e.g=function(){return!1};function gCa(a,b){for(;;)if(dj(ej(),a.Ks,b.Ks))if(a=F$(a),fCa(a))if(b=F$(b),fCa(b)){if(a===b)return!0}else return!1;else return F$(b).g();else return!1}e.o=function(){return F$(this)};function TU(a,b,c){a.Ks=b;a.Qt=c;return a}function fCa(a){return!!(a&&a.$classData&&a.$classData.H.$E)}
e.$classData=l({$E:0},!1,"scala.collection.immutable.Stream$Cons",{$E:1,g3:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Ht:1,lk:1,Bd:1,Gd:1,Ed:1,Co:1,Dt:1,Et:1,l:1,k:1});function G$(){}G$.prototype=new YBa;G$.prototype.constructor=G$;e=G$.prototype;e.c=function(){return this};e.n=function(){this.Ls()};e.il=function(){return!1};e.g=function(){return!0};e.Ls=function(){throw(new BP).j("head of empty stream");};
e.o=function(){throw(new Gq).j("tail of empty stream");};e.$classData=l({k3:0},!1,"scala.collection.immutable.Stream$Empty$",{k3:1,g3:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Ht:1,lk:1,Bd:1,Gd:1,Ed:1,Co:1,Dt:1,Et:1,l:1,k:1});var hCa=void 0;function VU(){hCa||(hCa=(new G$).c());return hCa}function Z2(){this.Qg=this.uf=this.Ge=0;this.xe=!1;this.Je=0;this.Ri=this.Xh=this.Og=this.Zf=this.ef=this.Ke=null}Z2.prototype=new B9;
Z2.prototype.constructor=Z2;e=Z2.prototype;e.dc=function(){return this};e.Sc=function(){return this.Og};
function H$(a,b,c,d){if(a.xe)if(32>d)a.pd(ak(a.ye()));else if(1024>d)a.Wc(ak(a.Ob())),a.Ob().i[31&(b>>>5|0)]=a.ye(),a.pd(ck(a.Ob(),31&(c>>>5|0)));else if(32768>d)a.Wc(ak(a.Ob())),a.ud(ak(a.hc())),a.Ob().i[31&(b>>>5|0)]=a.ye(),a.hc().i[31&(b>>>10|0)]=a.Ob(),a.Wc(ck(a.hc(),31&(c>>>10|0))),a.pd(ck(a.Ob(),31&(c>>>5|0)));else if(1048576>d)a.Wc(ak(a.Ob())),a.ud(ak(a.hc())),a.ze(ak(a.Sc())),a.Ob().i[31&(b>>>5|0)]=a.ye(),a.hc().i[31&(b>>>10|0)]=a.Ob(),a.Sc().i[31&(b>>>15|0)]=a.hc(),a.ud(ck(a.Sc(),31&(c>>>
15|0))),a.Wc(ck(a.hc(),31&(c>>>10|0))),a.pd(ck(a.Ob(),31&(c>>>5|0)));else if(33554432>d)a.Wc(ak(a.Ob())),a.ud(ak(a.hc())),a.ze(ak(a.Sc())),a.lh(ak(a.Od())),a.Ob().i[31&(b>>>5|0)]=a.ye(),a.hc().i[31&(b>>>10|0)]=a.Ob(),a.Sc().i[31&(b>>>15|0)]=a.hc(),a.Od().i[31&(b>>>20|0)]=a.Sc(),a.ze(ck(a.Od(),31&(c>>>20|0))),a.ud(ck(a.Sc(),31&(c>>>15|0))),a.Wc(ck(a.hc(),31&(c>>>10|0))),a.pd(ck(a.Ob(),31&(c>>>5|0)));else if(1073741824>d)a.Wc(ak(a.Ob())),a.ud(ak(a.hc())),a.ze(ak(a.Sc())),a.lh(ak(a.Od())),a.xl(ak(a.Hh())),
a.Ob().i[31&(b>>>5|0)]=a.ye(),a.hc().i[31&(b>>>10|0)]=a.Ob(),a.Sc().i[31&(b>>>15|0)]=a.hc(),a.Od().i[31&(b>>>20|0)]=a.Sc(),a.Hh().i[31&(b>>>25|0)]=a.Od(),a.lh(ck(a.Hh(),31&(c>>>25|0))),a.ze(ck(a.Od(),31&(c>>>20|0))),a.ud(ck(a.Sc(),31&(c>>>15|0))),a.Wc(ck(a.hc(),31&(c>>>10|0))),a.pd(ck(a.Ob(),31&(c>>>5|0)));else throw(new t).c();else{b=-1+a.sf()|0;switch(b){case 5:a.xl(ak(a.Hh()));a.lh(ck(a.Hh(),31&(c>>>25|0)));a.ze(ck(a.Od(),31&(c>>>20|0)));a.ud(ck(a.Sc(),31&(c>>>15|0)));a.Wc(ck(a.hc(),31&(c>>>10|
0)));a.pd(ck(a.Ob(),31&(c>>>5|0)));break;case 4:a.lh(ak(a.Od()));a.ze(ck(a.Od(),31&(c>>>20|0)));a.ud(ck(a.Sc(),31&(c>>>15|0)));a.Wc(ck(a.hc(),31&(c>>>10|0)));a.pd(ck(a.Ob(),31&(c>>>5|0)));break;case 3:a.ze(ak(a.Sc()));a.ud(ck(a.Sc(),31&(c>>>15|0)));a.Wc(ck(a.hc(),31&(c>>>10|0)));a.pd(ck(a.Ob(),31&(c>>>5|0)));break;case 2:a.ud(ak(a.hc()));a.Wc(ck(a.hc(),31&(c>>>10|0)));a.pd(ck(a.Ob(),31&(c>>>5|0)));break;case 1:a.Wc(ak(a.Ob()));a.pd(ck(a.Ob(),31&(c>>>5|0)));break;case 0:a.pd(ak(a.ye()));break;default:throw(new p).e(b);
}a.xe=!0}}e.n=function(){if(0===this.Pe(0))throw(new Gq).j("empty.head");return this.rc(0)};e.rc=function(a){var b=a+this.Ge|0;if(0<=a&&b<this.uf)a=b;else throw(new W).j(""+a);return pba(this,a,a^this.Qg)};e.Pe=function(a){return this.Fa()-a|0};e.sf=function(){return this.Je};e.Ea=function(a){return this.rc(a|0)};e.md=function(){return this};e.Be=function(a,b,c){this.Ge=a;this.uf=b;this.Qg=c;this.xe=!1;return this};e.xl=function(a){this.Ri=a};
e.br=function(a,b){return b===(Rs(),vk().$d)||b===m3().b||b===Xo().b?iCa(this,a):Fw(this,a,b)};
e.ag=function(){if(0===this.Pe(0))throw(new Gq).j("empty.init");var a;if((this.uf-1|0)>this.Ge){var b=this.uf-1|0,c=-32&(-1+b|0),d=jCa(this.Ge^(-1+b|0)),f=this.Ge&~(-1+(1<<fa(5,d))|0);a=(new Z2).Be(this.Ge-f|0,b-f|0,c-f|0);dk(a,this,this.Je);a.xe=this.xe;H$(a,this.Qg,c,this.Qg^c);kCa(a,d);b=b-f|0;if(32>=b)I$(a.Ke,b);else if(1024>=b)I$(a.Ke,1+(31&(-1+b|0))|0),a.ef=J$(a.ef,b>>>5|0);else if(32768>=b)I$(a.Ke,1+(31&(-1+b|0))|0),a.ef=J$(a.ef,1+(31&((-1+b|0)>>>5|0))|0),a.Zf=J$(a.Zf,b>>>10|0);else if(1048576>=
b)I$(a.Ke,1+(31&(-1+b|0))|0),a.ef=J$(a.ef,1+(31&((-1+b|0)>>>5|0))|0),a.Zf=J$(a.Zf,1+(31&((-1+b|0)>>>10|0))|0),a.Og=J$(a.Og,b>>>15|0);else if(33554432>=b)I$(a.Ke,1+(31&(-1+b|0))|0),a.ef=J$(a.ef,1+(31&((-1+b|0)>>>5|0))|0),a.Zf=J$(a.Zf,1+(31&((-1+b|0)>>>10|0))|0),a.Og=J$(a.Og,1+(31&((-1+b|0)>>>15|0))|0),a.Xh=J$(a.Xh,b>>>20|0);else if(1073741824>=b)I$(a.Ke,1+(31&(-1+b|0))|0),a.ef=J$(a.ef,1+(31&((-1+b|0)>>>5|0))|0),a.Zf=J$(a.Zf,1+(31&((-1+b|0)>>>10|0))|0),a.Og=J$(a.Og,1+(31&((-1+b|0)>>>15|0))|0),a.Xh=
J$(a.Xh,1+(31&((-1+b|0)>>>20|0))|0),a.Ri=J$(a.Ri,b>>>25|0);else throw(new t).c();}else a=uk().Ci;return a};e.qe=function(){return uk()};e.ye=function(){return this.Ke};e.Od=function(){return this.Xh};e.ud=function(a){this.Zf=a};function K$(a,b,c){var d=-1+a.Je|0;switch(d){case 0:a.Ke=bk(a.Ke,b,c);break;case 1:a.ef=bk(a.ef,b,c);break;case 2:a.Zf=bk(a.Zf,b,c);break;case 3:a.Og=bk(a.Og,b,c);break;case 4:a.Xh=bk(a.Xh,b,c);break;case 5:a.Ri=bk(a.Ri,b,c);break;default:throw(new p).e(d);}}e.sh=function(){return this};
function iCa(a,b){if(a.uf!==a.Ge){var c=-32&a.uf,d=31&a.uf;if(a.uf!==c){var f=(new Z2).Be(a.Ge,1+a.uf|0,c);dk(f,a,a.Je);f.xe=a.xe;H$(f,a.Qg,c,a.Qg^c);f.Ke.i[d]=b;return f}var g=a.Ge&~(-1+(1<<fa(5,-1+a.Je|0))|0),f=a.Ge>>>fa(5,-1+a.Je|0)|0;if(0!==g){if(1<a.Je){var c=c-g|0,h=a.Qg-g|0,g=(new Z2).Be(a.Ge-g|0,(1+a.uf|0)-g|0,c);dk(g,a,a.Je);g.xe=a.xe;K$(g,f,0);L$(g,h,c,h^c);g.Ke.i[d]=b;return g}d=-32+c|0;c=a.Qg;h=(new Z2).Be(a.Ge-g|0,(1+a.uf|0)-g|0,d);dk(h,a,a.Je);h.xe=a.xe;K$(h,f,0);H$(h,c,d,c^d);h.Ke.i[32-
g|0]=b;return h}f=a.Qg;g=(new Z2).Be(a.Ge,1+a.uf|0,c);dk(g,a,a.Je);g.xe=a.xe;L$(g,f,c,f^c);g.Ke.i[d]=b;return g}a=oa(bc(Ab),[32]);a.i[0]=b;b=(new Z2).Be(0,1,0);b.Je=1;b.Ke=a;return b}e.cm=function(){return this};e.we=function(){return D7(this)};
function kCa(a,b){a.Je=b;b=-1+b|0;switch(b){case 0:a.ef=null;a.Zf=null;a.Og=null;a.Xh=null;a.Ri=null;break;case 1:a.Zf=null;a.Og=null;a.Xh=null;a.Ri=null;break;case 2:a.Og=null;a.Xh=null;a.Ri=null;break;case 3:a.Xh=null;a.Ri=null;break;case 4:a.Ri=null;break;case 5:break;default:throw(new p).e(b);}}e.Xt=function(a,b){return b===(Rs(),vk().$d)||b===m3().b||b===Xo().b?lCa(this,a):pBa(this,a,b)};e.Jb=function(){return Ss(this)};e.Wc=function(a){this.ef=a};
function I$(a,b){for(;b<a.i.length;)a.i[b]=null,b=1+b|0}e.Fa=function(){return this.uf-this.Ge|0};
e.ma=function(a,b){if(b===(Rs(),vk().$d)||b===m3().b||b===Xo().b){if(a.g())return this;a=a.ph()?a.dc():a.sh();var c=a.Za();if(2>=c||c<(this.Fa()>>>5|0))return b=(new Uk).e(this),a.Cb(lk(function(a,b){return function(a){b.cb=b.cb.br(a,(uk(),vk().$d))}}(this,b))),b.cb;if(this.Fa()<(c>>>5|0)&&a&&a.$classData&&a.$classData.H.dF){b=a;for(a=Iva(this);a.fb();)c=a.bb(),b=b.Xt(c,(uk(),vk().$d));return b}return Q2(this,a,b)}return Q2(this,a.dc(),b)};e.lh=function(a){this.Xh=a};e.kj=function(){return this};
function L$(a,b,c,d){a.xe?(sba(a,b),qba(a,b,c,d)):(qba(a,b,c,d),a.xe=!0)}e.Df=function(){return this.Fa()};e.Ob=function(){return this.ef};e.Ze=function(){if(0===this.Pe(0))throw(new Gq).j("empty.last");return this.rc(-1+this.Fa()|0)};e.Hh=function(){return this.Ri};e.tf=function(a){return mCa(this,a)};e.kf=function(){return this};e.o=function(){if(0===this.Pe(0))throw(new Gq).j("empty.tail");return mCa(this,1)};
function Ss(a){var b=(new $2).K(a.Ge,a.uf);dk(b,a,a.Je);a.xe&&sba(b,a.Qg);1<b.dv&&rba(b,a.Ge,a.Ge^a.Qg);return b}function jCa(a){if(32>a)return 1;if(1024>a)return 2;if(32768>a)return 3;if(1048576>a)return 4;if(33554432>a)return 5;if(1073741824>a)return 6;throw(new t).c();}e.vf=function(a){return G1(this,a|0)};function M$(a,b){for(var c=0;c<b;)a.i[c]=null,c=1+c|0}e.A=function(){return PU(XN(),this)};e.Qi=function(a){this.Je=a};e.hc=function(){return this.Zf};e.pd=function(a){this.Ke=a};
function mCa(a,b){if(!(0>=b))if(a.Ge<(a.uf-b|0)){var c=a.Ge+b|0,d=-32&c,f=jCa(c^(-1+a.uf|0)),g=c&~(-1+(1<<fa(5,f))|0);b=(new Z2).Be(c-g|0,a.uf-g|0,d-g|0);dk(b,a,a.Je);b.xe=a.xe;H$(b,a.Qg,d,a.Qg^d);kCa(b,f);a=c-g|0;if(32>a)M$(b.Ke,a);else if(1024>a)M$(b.Ke,31&a),b.ef=N$(b.ef,a>>>5|0);else if(32768>a)M$(b.Ke,31&a),b.ef=N$(b.ef,31&(a>>>5|0)),b.Zf=N$(b.Zf,a>>>10|0);else if(1048576>a)M$(b.Ke,31&a),b.ef=N$(b.ef,31&(a>>>5|0)),b.Zf=N$(b.Zf,31&(a>>>10|0)),b.Og=N$(b.Og,a>>>15|0);else if(33554432>a)M$(b.Ke,
31&a),b.ef=N$(b.ef,31&(a>>>5|0)),b.Zf=N$(b.Zf,31&(a>>>10|0)),b.Og=N$(b.Og,31&(a>>>15|0)),b.Xh=N$(b.Xh,a>>>20|0);else if(1073741824>a)M$(b.Ke,31&a),b.ef=N$(b.ef,31&(a>>>5|0)),b.Zf=N$(b.Zf,31&(a>>>10|0)),b.Og=N$(b.Og,31&(a>>>15|0)),b.Xh=N$(b.Xh,31&(a>>>20|0)),b.Ri=N$(b.Ri,a>>>25|0);else throw(new t).c();a=b}else a=uk().Ci;return a}
function lCa(a,b){if(a.uf!==a.Ge){var c=-32&(-1+a.Ge|0),d=31&(-1+a.Ge|0);if(a.Ge!==(32+c|0)){var f=(new Z2).Be(-1+a.Ge|0,a.uf,c);dk(f,a,a.Je);f.xe=a.xe;H$(f,a.Qg,c,a.Qg^c);f.Ke.i[d]=b;return f}var g=(1<<fa(5,a.Je))-a.uf|0,f=g&~(-1+(1<<fa(5,-1+a.Je|0))|0),g=g>>>fa(5,-1+a.Je|0)|0;if(0!==f){if(1<a.Je){var c=c+f|0,h=a.Qg+f|0,f=(new Z2).Be((-1+a.Ge|0)+f|0,a.uf+f|0,c);dk(f,a,a.Je);f.xe=a.xe;K$(f,0,g);L$(f,h,c,h^c);f.Ke.i[d]=b;return f}d=32+c|0;c=a.Qg;h=(new Z2).Be((-1+a.Ge|0)+f|0,a.uf+f|0,d);dk(h,a,a.Je);
h.xe=a.xe;K$(h,0,g);H$(h,c,d,c^d);h.Ke.i[-1+f|0]=b;return h}if(0>c)return f=(1<<fa(5,1+a.Je|0))-(1<<fa(5,a.Je))|0,g=c+f|0,c=a.Qg+f|0,f=(new Z2).Be((-1+a.Ge|0)+f|0,a.uf+f|0,g),dk(f,a,a.Je),f.xe=a.xe,L$(f,c,g,c^g),f.Ke.i[d]=b,f;f=a.Qg;g=(new Z2).Be(-1+a.Ge|0,a.uf,c);dk(g,a,a.Je);g.xe=a.xe;L$(g,f,c,f^c);g.Ke.i[d]=b;return g}a=oa(bc(Ab),[32]);a.i[31]=b;b=(new Z2).Be(31,32,0);b.Je=1;b.Ke=a;return b}function J$(a,b){var c=oa(bc(Ab),[a.i.length]);Ta(a,0,c,0,b);return c}
function N$(a,b){var c=oa(bc(Ab),[a.i.length]);Ta(a,b,c,b,c.i.length-b|0);return c}e.ze=function(a){this.Og=a};e.$classData=l({dF:0},!1,"scala.collection.immutable.Vector",{dF:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Jo:1,lk:1,Bd:1,Gd:1,Ed:1,Cg:1,Zd:1,eF:1,l:1,k:1,Fd:1});function ds(){this.Oh=null}ds.prototype=new B9;ds.prototype.constructor=ds;e=ds.prototype;e.dc=function(){return this};e.n=function(){return eo(this)};
e.rc=function(a){a=65535&(this.Oh.charCodeAt(a)|0);return(new ed).db(a)};e.Pe=function(a){return i8(this,a)};e.Qf=function(a){return k8(this,a)};e.Ea=function(a){a=65535&(this.Oh.charCodeAt(a|0)|0);return(new ed).db(a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.md=function(){return this};e.sl=function(a){return 65535&(this.Oh.charCodeAt(a)|0)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.qe=function(){return Rs()};e.v=function(){return this.Oh};
e.Cb=function(a){A8(this,a)};e.se=function(a,b){return J8(this,0,this.Oh.length|0,a,b)};e.qf=function(a){var b=this.Oh;return b===a?0:b<a?-1:1};e.Eg=function(a,b){return nCa(this,a,b)};e.cm=function(){return this};e.we=function(){return D7(this)};e.Jb=function(){return Cp(new Dp,this,this.Oh.length|0)};e.Of=function(){return this.Oh};e.Fa=function(){return this.Oh.length|0};e.kj=function(){return this};e.Df=function(){return this.Oh.length|0};e.Ze=function(){return Hd(this)};
e.tf=function(a){return nCa(this,a,this.Oh.length|0)};e.kf=function(){return this};e.o=function(){return I8(this)};e.vf=function(a){return G1(this,a|0)};e.rf=function(a,b,c){K8(this,a,b,c)};e.A=function(){return PU(XN(),this)};e.j=function(a){this.Oh=a;return this};e.Cn=function(){return EP(Ga(),this.Oh)};function nCa(a,b,c){b=0>b?0:b;if(c<=b||b>=(a.Oh.length|0))return(new ds).j("");c=c>(a.Oh.length|0)?a.Oh.length|0:c;To();return(new ds).j((null!==a?a.Oh:null).substring(b,c))}
e.$e=function(a){return L8(this,a)};e.ic=function(){TO||(TO=(new RO).c());return TO.ic()};e.$classData=l({x3:0},!1,"scala.collection.immutable.WrappedString",{x3:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Jo:1,lk:1,Bd:1,Gd:1,Ed:1,Cg:1,Zd:1,bF:1,bf:1,yo:1,xf:1});function V(){this.ga=this.ed=null}V.prototype=new dCa;V.prototype.constructor=V;e=V.prototype;e.U=function(){return"::"};e.n=function(){return this.ed};e.M=function(){return 2};
e.g=function(){return!1};e.W=function(a){switch(a){case 0:return this.ed;case 1:return this.ga;default:throw(new W).j(""+a);}};e.o=function(){return this.ga};function U(a,b,c){a.ed=b;a.ga=c;return a}e.L=function(){return Z(this)};function rk(a){return!!(a&&a.$classData&&a.$classData.H.UE)}
e.$classData=l({UE:0},!1,"scala.collection.immutable.$colon$colon",{UE:1,It:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Ht:1,lk:1,Bd:1,Gd:1,Ed:1,Co:1,Dt:1,R:1,Et:1,l:1,k:1});function O$(){}O$.prototype=new dCa;O$.prototype.constructor=O$;e=O$.prototype;e.c=function(){return this};e.n=function(){this.Ls()};e.U=function(){return"Nil"};e.M=function(){return 0};function XBa(){throw(new Gq).j("tail of empty list");}e.g=function(){return!0};
e.w=function(a){return a&&a.$classData&&a.$classData.H.Te?a.g():!1};e.W=function(a){throw(new W).j(""+a);};e.Ls=function(){throw(new BP).j("head of empty list");};e.o=function(){return XBa()};e.L=function(){return Z(this)};e.$classData=l({U2:0},!1,"scala.collection.immutable.Nil$",{U2:1,It:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,Ht:1,lk:1,Bd:1,Gd:1,Ed:1,Co:1,Dt:1,R:1,Et:1,l:1,k:1});var oCa=void 0;
function F(){oCa||(oCa=(new O$).c());return oCa}function P$(){ab();this.op=this.Sq=this.pp=this.Br=null;this.ra=0}P$.prototype=new m;P$.prototype.constructor=P$;
P$.prototype.c=function(){Q$=this;hva||(hva=(new j1).c());Rla(this);(new Ep).K(1,0);(new Ep).K(2,0);(new Ep).K(4,0);(new Ep).K(8,0);(new Ep).K(16,0);(new Ep).K(32,0);(new Ep).K(64,0);(new Ep).K(128,0);(new Ep).K(256,0);(new Ep).K(512,0);(new Ep).K(1024,0);(new Ep).K(2048,0);(new Ep).K(4096,0);(new Ep).K(8192,0);(new Ep).K(16384,0);(new Ep).K(32768,0);(new Ep).K(65536,0);(new Ep).K(131072,0);(new Ep).K(262144,0);(new Ep).K(524288,0);(new Ep).K(1048576,0);(new Ep).K(2097152,0);(new Ep).K(4194304,0);
(new Ep).K(8388608,0);(new Ep).K(16777216,0);(new Ep).K(33554432,0);(new Ep).K(67108864,0);(new Ep).K(134217728,0);(new Ep).K(268435456,0);(new Ep).K(536870912,0);(new Ep).K(1073741824,0);(new Ep).K(-2147483648,0);(new Ep).K(0,1);(new Ep).K(0,2);(new Ep).K(0,4);(new Ep).K(0,8);rpa||(rpa=(new RV).c());jva||(jva=(new l1).c());mva||(mva=(new r1).c());kva||(kva=(new n1).c());Vca||(Vca=(new pr).c());iva||(iva=(new k1).c());upa();lva||(lva=(new p1).c());return this};
P$.prototype.LE=function(a){this.Sq=a};function co(){Il();if(null===Il().op&&null===Il().op){var a=Il(),b=new yL;b.qp=jja();b.jp=lja();a.op=b}return Il().op}P$.prototype.KE=function(){};P$.prototype.$classData=l({SZ:0},!1,"scala.meta.package$",{SZ:1,f:1,LT:1,r6:1,u6:1,t6:1,UZ:1,C6:1,g_:1,E6:1,I6:1,H6:1,B6:1,x5:1,B5:1,A6:1,w5:1,A5:1,TT:1,jI:1,XH:1,ST:1,iI:1,UH:1,K6:1,z5:1,D5:1,E5:1,J6:1,y5:1,C5:1,p_:1,L6:1,O6:1,N6:1,Q6:1,P6:1,S6:1,R6:1});var Q$=void 0;
function Il(){Q$||(Q$=(new P$).c());return Q$}function R$(){}R$.prototype=new DBa;R$.prototype.constructor=R$;function pCa(){}e=pCa.prototype=R$.prototype;e.dc=function(){return this};e.jt=function(a,b){var c=this.wg(a);this.gm(a,b);return c};e.lC=function(a){var b=this.wg(a);this.cr(a);return b};e.qe=function(){Kva||(Kva=(new a2).c());return Kva};e.ii=function(a,b){iV(this,a,b)};e.VA=function(a,b){var c=this.wg(a);if(zh(c))a=c.Y;else if(S()===c)b=OO(b),this.gm(a,b),a=b;else throw(new p).e(c);return a};
e.je=function(){};e.$c=function(a){return GO(this,a)};e.ic=function(){return this.Rn()};function S$(){}S$.prototype=new CBa;S$.prototype.constructor=S$;function T$(){}e=T$.prototype=S$.prototype;e.dc=function(){return this};e.g=function(){return 0===this.Za()};e.w=function(a){return b1(this,a)};e.qe=function(){fwa||(fwa=(new a3).c());return fwa};e.v=function(){return O2(this)};e.Fx=function(a){var b=this.Jb();return Goa(b,a)};e.we=function(){return yBa(this)};e.ii=function(a,b){iV(this,a,b)};
e.$u=function(){return this.qi().$c(this)};e.je=function(){};e.A=function(){var a=XN();return ZN(a,this,a.yx)};e.yf=function(a,b){return SQ(this,a,b)};e.$c=function(a){return GO(this,a)};e.ic=function(){return this.qi()};e.jf=function(){return"Set"};function oM(){this.Xj=null}oM.prototype=new pCa;oM.prototype.constructor=oM;e=oM.prototype;e.cr=function(a){return qCa(this,a)};e.Ea=function(a){return this.Tu(a)};e.md=function(){return this};e.Jm=function(a){this.Xj=a;return this};
e.ee=function(a){return rCa(this,a)};e.Rn=function(){return(new oM).Jm({})};e.pk=function(a){var b=(new oM).Jm({});return GO(b,this).cr(a)};e.gm=function(a,b){this.Xj[a]=b};e.Nq=function(){return this};e.da=function(){return this};e.Jb=function(){return(new U0).Jm(this.Xj)};e.vg=function(a){return $8(this,a)};function qCa(a,b){var c=a.Xj;as().dk.call(c,b)&&delete a.Xj[b];return a}e.Tu=function(a){var b=this.Xj;if(as().dk.call(b,a))return this.Xj[a];throw(new BP).j("key not found: "+a);};
e.wg=function(a){var b=this.Xj;return as().dk.call(b,a)?(new T).e(this.Xj[a]):S()};function rCa(a,b){a.Xj[b.qa()]=b.p();return a}e.$t=function(a){return rCa(this,a)};e.Ac=function(a){var b=this.Xj;return!!as().dk.call(b,a)};e.ba=function(a){return rCa(this,a)};e.qk=function(a){var b=(new oM).Jm({});return GO(b,this).$t(a)};
e.$classData=l({q4:0},!1,"scala.scalajs.js.WrappedDictionary",{q4:1,hF:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,JF:1,Xg:1,Yg:1,Vg:1,KF:1,Fe:1,Ee:1,De:1,$l:1,Wg:1,dg:1,Mf:1});function U$(){}U$.prototype=new $9;U$.prototype.constructor=U$;function V$(){}V$.prototype=U$.prototype;U$.prototype.$c=function(a){return GO(this,a)};function W$(){}W$.prototype=new $9;W$.prototype.constructor=W$;function X$(){}
e=X$.prototype=W$.prototype;e.dc=function(){return this};e.n=function(){return eo(this)};e.Pe=function(a){return i8(this,a)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.md=function(){return this};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.qe=function(){return nwa()};e.Cb=function(a){A8(this,a)};e.se=function(a,b){var c=this.Fa();return J8(this,0,c,a,b)};e.Eg=function(a,b){return B8(this,a,b)};e.we=function(){return D7(this)};
e.Oq=function(){return this};e.Jb=function(){return Cp(new Dp,this,this.Fa())};e.kj=function(){return this};e.Df=function(){return this.Fa()};e.Ze=function(){return Hd(this)};e.tf=function(a){var b=this.Fa();return B8(this,a,b)};e.kf=function(){return this};e.o=function(){return I8(this)};e.vf=function(a){return G1(this,a|0)};e.rf=function(a,b,c){K8(this,a,b,c)};e.Cn=function(a){var b=a.G();return zr(ra(this.Da))===b?this.Da:kO(this,a)};e.$e=function(a){return L8(this,a)};e.ic=function(){return(new e2).Jv(this.zk())};
e.jf=function(){return"WrappedArray"};function rO(){this.Lk=this.Qb=null}rO.prototype=new T$;rO.prototype.constructor=rO;e=rO.prototype;e.U=function(){return"JSetWrapper"};e.Ea=function(a){return this.Qb.Ac(a)};e.M=function(){return 1};e.md=function(){return this};function Y$(a,b){a.Qb.Rk(b);return a}e.W=function(a){switch(a){case 0:return this.Qb;default:throw(new W).j(""+a);}};e.ee=function(a){return Y$(this,a)};e.Zt=function(a){return Y$(this,a)};e.Za=function(){return this.Qb.Za()};e.da=function(){return this};
e.Jb=function(){iua||(iua=(new D_).c());var a=this.Qb.Jl();return null===a?null:a&&a.$classData&&a.$classData.H.j2&&a.m2()===nO()?a.U4():Uja(new CO,nO(),a)};e.qi=function(){return oO(new rO,this.Lk,(new Z4).c())};e.$u=function(){return sCa(this)};function oO(a,b,c){a.Qb=c;if(null===b)throw jo(wj(),null);a.Lk=b;return a}e.Ac=function(a){return this.Qb.Ac(a)};e.ba=function(a){return Y$(this,a)};e.L=function(){return Z(this)};e.Rk=function(a){return this.Qb.Rk(a)};
e.ki=function(a){return Y$(sCa(this),a)};e.kl=function(a){var b=sCa(this);a=a.dc();return GO(b,a)};function sCa(a){var b=new rO,c=a.Lk,d=a.Qb;a=new j5;j5.prototype.c.call(a);for(var d=d.Jl(),f=!1;d.fb();)f=a.Rk(d.bb())||f;return oO(b,c,a)}
e.$classData=l({k2:0},!1,"scala.collection.convert.Wrappers$JSetWrapper",{k2:1,iF:1,gF:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Xg:1,Yg:1,Vg:1,LF:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,MF:1,Iq:1,Fe:1,Ee:1,De:1,$l:1,Wg:1,dg:1,Mf:1,R:1,l:1,k:1});function Qq(){this.sk=0;this.Vc=null;this.Ej=this.fg=0;this.og=null;this.nk=0}Qq.prototype=new pCa;Qq.prototype.constructor=Qq;function tCa(){}e=tCa.prototype=Qq.prototype;e.dc=function(){return this};
e.jt=function(a,b){a=nP(this,a,b);if(null===a)return S();var c=a.pa;a.pa=b;return(new T).e(c)};e.c=function(){Qq.prototype.dB.call(this,null);return this};e.cr=function(a){tka(this,a);return this};e.xx=function(a){this.nk=a};e.Ea=function(a){var b=oP(this,a);return null===b?this.gu(a):b.pa};e.md=function(){return this};e.lC=function(a){a=tka(this,a);return null!==a?(new T).e(a.pa):S()};function uCa(a,b){var c=nP(a,b.qa(),b.p());null!==c&&(c.pa=b.p());return a}e.ee=function(a){return uCa(this,a)};
e.Cb=function(a){for(var b=this.Vc,c=mP(this),d=b.i[c];null!==d;){var f=d.bb();a.Ea((new q).a(d.bg,d.pa));for(d=f;null===d&&0<c;)c=-1+c|0,d=b.i[c]}};e.dw=function(){return(new Z1).Mv(this)};e.pk=function(a){var b=(new Qq).c();return GO(b,this).cr(a)};e.Rn=function(){return(new Qq).c()};e.gm=function(a,b){this.jt(a,b)};e.Za=function(){return this.fg};e.Nq=function(){return this};e.da=function(){return this};
e.Jb=function(){return Ro(new So,Jva(this),lk(function(){return function(a){return(new q).a(a.bg,a.pa)}}(this)))};e.dB=function(a){ska(this);null!==a&&(this.du(a.RJ()),this.Nt(a.Vc),this.Mo(a.fg),this.Pt(a.Ej),this.xx(a.nk),this.Kt(a.og));return this};function vCa(a,b){return null!==b?(b=b.bg,!dj(ej(),b,a)):!1}e.vg=function(a){return $8(this,a)};
e.VA=function(a,b){var c=YN(Y(),a),d=jP(this,c),f;for(f=this.Vc.i[d];vCa(a,f);)f=f.ue;if(null!==f)return f.pa;f=this.Vc;b=OO(b);c=f===this.Vc?d:jP(this,c);a=(new R0).a(a,b);this.fg>=this.Ej?(c=a.Gi(),c=YN(Y(),c),c=jP(this,c),vka(this,a,c)):(a.ue=this.Vc.i[c],this.Vc.i[c]=a,this.fg=1+this.fg|0,pP(this,c));return a.pa};e.mA=function(a,b){return(new R0).a(a,b)};e.wg=function(a){a=oP(this,a);return null===a?S():(new T).e(a.pa)};e.$t=function(a){return uCa(this,a)};e.Kt=function(a){this.og=a};
e.Ac=function(a){return null!==oP(this,a)};e.Nt=function(a){this.Vc=a};e.JB=function(){return(new H9).Mv(this)};e.ba=function(a){return uCa(this,a)};e.du=function(a){this.sk=a};e.Pt=function(a){this.Ej=a};e.qk=function(a){var b=(new Qq).c();return GO(b,this).$t(a)};e.Mo=function(a){this.fg=a};
e.$classData=l({FF:0},!1,"scala.collection.mutable.HashMap",{FF:1,hF:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,JF:1,Xg:1,Yg:1,Vg:1,KF:1,Fe:1,Ee:1,De:1,$l:1,Wg:1,dg:1,Mf:1,GF:1,HF:1,Fd:1,l:1,k:1});function x4(){this.$s=this.Qp=null;this.sk=0;this.Vc=null;this.Ej=this.fg=0;this.og=null;this.nk=0}x4.prototype=new T$;x4.prototype.constructor=x4;e=x4.prototype;e.c=function(){ska(this);this.$s=this.Qp=null;return this};
e.xx=function(a){this.nk=a};e.Ea=function(a){return this.Ac(a)};e.md=function(){return this};e.ee=function(a){return wCa(this,a)};e.qe=function(){mxa||(mxa=(new w4).c());return mxa};e.Cb=function(a){for(var b=this.Qp;null!==b;)a.Ea(b.bg),b=b.at};function wCa(a,b){a.Rk(b);return a}e.Zt=function(a){return wCa(this,a)};e.Za=function(){return this.fg};e.da=function(){return this};e.Jb=function(){var a=new c2;a.Hp=this.Qp;return a};e.qi=function(){return(new x4).c()};
e.mA=function(a){a=(new T0).e(a);null===this.Qp?this.Qp=a:(this.$s.at=a,a.GA=this.$s);return this.$s=a};e.Kt=function(a){this.og=a};e.Ac=function(a){return null!==oP(this,a)};e.Nt=function(a){this.Vc=a};e.ba=function(a){return wCa(this,a)};e.Rk=function(a){return null===nP(this,a,null)};e.ki=function(a){return this.qi().$c(this).Zt(a)};e.kl=function(a){var b=this.qi().$c(this);a=a.dc();return GO(b,a)};e.du=function(a){this.sk=a};e.Pt=function(a){this.Ej=a};e.Mo=function(a){this.fg=a};
e.$classData=l({a4:0},!1,"scala.collection.mutable.LinkedHashSet",{a4:1,iF:1,gF:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Xg:1,Yg:1,Vg:1,LF:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,MF:1,Iq:1,Fe:1,Ee:1,De:1,$l:1,Wg:1,dg:1,Mf:1,GF:1,HF:1,l:1,k:1});function Z$(){Qq.call(this)}Z$.prototype=new tCa;Z$.prototype.constructor=Z$;Z$.prototype.gu=function(){return 0};function qBa(){var a=new Z$;Qq.prototype.dB.call(a,null);return a}
Z$.prototype.$classData=l({$1:0},!1,"scala.collection.SeqLike$$anon$1",{$1:1,FF:1,hF:1,Ki:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Mi:1,zi:1,Li:1,Ni:1,Uc:1,Mb:1,Sd:1,JF:1,Xg:1,Yg:1,Vg:1,KF:1,Fe:1,Ee:1,De:1,$l:1,Wg:1,dg:1,Mf:1,GF:1,HF:1,Fd:1,l:1,k:1});function b3(){this.sk=0;this.Vc=null;this.Ej=this.fg=0;this.og=null;this.nk=0}b3.prototype=new T$;b3.prototype.constructor=b3;e=b3.prototype;e.dc=function(){return this};
e.c=function(){b3.prototype.SI.call(this,null);return this};e.Ea=function(a){return null!==pka(this,a)};e.md=function(){return this};e.ee=function(a){return $$(this,a)};e.qe=function(){lxa||(lxa=(new v4).c());return lxa};e.Cb=function(a){for(var b=0,c=this.Vc.i.length;b<c;){var d=this.Vc.i[b];null!==d&&a.Ea(vba(d));b=1+b|0}};e.Zt=function(a){return $$(this,a)};e.Za=function(){return this.fg};e.da=function(){return this};
e.Jb=function(){var a=new Y1;if(null===this)throw jo(wj(),null);a.Lb=this;a.Me=0;return a};e.qi=function(){return(new b3).c()};e.$u=function(){var a=(new b3).c();return GO(a,this)};e.SI=function(a){this.sk=450;this.Vc=oa(bc(Ab),[lP(kP(),32)]);this.fg=0;this.Ej=oka().oq(this.sk,lP(kP(),32));this.og=null;this.nk=kka(this);null!==a&&(this.sk=a.RJ(),this.Vc=a.s7(),this.fg=a.fg,this.Ej=a.Ej,this.nk=a.nk,this.og=a.og);return this};e.Ac=function(a){return null!==pka(this,a)};
e.ba=function(a){return $$(this,a)};e.Rk=function(a){return lka(this,a)};e.ki=function(a){var b=(new b3).c();return $$(GO(b,this),a)};e.kl=function(a){var b=(new b3).c(),b=GO(b,this);a=a.dc();return GO(b,a)};function $$(a,b){lka(a,b);return a}
e.$classData=l({V3:0},!1,"scala.collection.mutable.HashSet",{V3:1,iF:1,gF:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,Xg:1,Yg:1,Vg:1,LF:1,Mh:1,Mb:1,Lh:1,di:1,gi:1,ei:1,Sd:1,MF:1,Iq:1,Fe:1,Ee:1,De:1,$l:1,Wg:1,dg:1,Mf:1,h7:1,i7:1,Fd:1,l:1,k:1});function m2(){this.Da=null}m2.prototype=new X$;m2.prototype.constructor=m2;e=m2.prototype;e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.Da.i[a|0]};e.Kk=function(a,b){this.Da.i[a]=!!b};
e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.ox)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.Fa=function(){return this.Da.i.length};e.zk=function(){return IN()};e.fo=function(a){this.Da=a;return this};
e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,b.i[d]?1231:1237),d=1+d|0;return a.xd(c,b.i.length)};e.$classData=l({ox:0},!1,"scala.collection.mutable.WrappedArray$ofBoolean",{ox:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function f2(){this.Da=null}f2.prototype=new X$;
f2.prototype.constructor=f2;e=f2.prototype;e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.Da.i[a|0]};e.Kk=function(a,b){this.Da.i[a]=b|0};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.px)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.Fa=function(){return this.Da.i.length};e.zk=function(){return BN()};
e.A=function(){for(var a=XN(),b=this.Da,c=b.i.length,d=a.jj,f=0;4<=c;)var g=255&b.i[f],g=g|(255&b.i[1+f|0])<<8,g=g|(255&b.i[2+f|0])<<16,g=g|(255&b.i[3+f|0])<<24,d=a.Gb(d,g),f=4+f|0,c=-4+c|0;g=0;3===c&&(g^=(255&b.i[2+f|0])<<16);2<=c&&(g^=(255&b.i[1+f|0])<<8);1<=c&&(g^=255&b.i[f],d=a.bn(d,g));return a.xd(d,b.i.length)};e.Zn=function(a){this.Da=a;return this};
e.$classData=l({px:0},!1,"scala.collection.mutable.WrappedArray$ofByte",{px:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function h2(){this.Da=null}h2.prototype=new X$;h2.prototype.constructor=h2;e=h2.prototype;e.rc=function(a){a=this.sl(a);return(new ed).db(a)};e.Ea=function(a){a=this.sl(a|0);return(new ed).db(a)};
e.Kk=function(a,b){this.Da.i[a]=null===b?0:b.pa};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.qx)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),(new ed).db(b.i[d]),(new ed).db(a.i[d]));b=d}else b=!1;else b=a1(this,a);return b};e.sl=function(a){return this.Da.i[a]};e.Fa=function(){return this.Da.i.length};e.Uk=function(a){this.Da=a;return this};e.zk=function(){return DN()};
e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,b.i[d]),d=1+d|0;return a.xd(c,b.i.length)};e.$classData=l({qx:0},!1,"scala.collection.mutable.WrappedArray$ofChar",{qx:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function l2(){this.Da=null}l2.prototype=new X$;l2.prototype.constructor=l2;e=l2.prototype;
e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.Da.i[a|0]};e.Kk=function(a,b){this.Da.i[a]=+b};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.rx)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.$n=function(a){this.Da=a;return this};e.Fa=function(){return this.Da.i.length};e.zk=function(){return HN()};
e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,fQ(Y(),b.i[d])),d=1+d|0;return a.xd(c,b.i.length)};e.$classData=l({rx:0},!1,"scala.collection.mutable.WrappedArray$ofDouble",{rx:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function k2(){this.Da=null}k2.prototype=new X$;k2.prototype.constructor=k2;
e=k2.prototype;e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.Da.i[a|0]};e.Kk=function(a,b){this.Da.i[a]=+b};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.sx)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.ao=function(a){this.Da=a;return this};e.Fa=function(){return this.Da.i.length};
e.zk=function(){return GN()};e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)Y(),c=a.Gb(c,fQ(0,b.i[d])),d=1+d|0;return a.xd(c,b.i.length)};e.$classData=l({sx:0},!1,"scala.collection.mutable.WrappedArray$ofFloat",{sx:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function i2(){this.Da=null}i2.prototype=new X$;
i2.prototype.constructor=i2;e=i2.prototype;e.rc=function(a){return this.rp(a)};e.Ea=function(a){return this.rp(a|0)};e.Kk=function(a,b){this.Da.i[a]=b|0};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.tx)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.rp=function(a){return this.Da.i[a]};
e.bo=function(a){this.Da=a;return this};e.Fa=function(){return this.Da.i.length};e.zk=function(){return EN()};e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,b.i[d]),d=1+d|0;return a.xd(c,b.i.length)};
e.$classData=l({tx:0},!1,"scala.collection.mutable.WrappedArray$ofInt",{tx:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function j2(){this.Da=null}j2.prototype=new X$;j2.prototype.constructor=j2;e=j2.prototype;e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.Da.i[a|0]};e.co=function(a){this.Da=a;return this};
e.Kk=function(a,b){b=Ya(b);this.Da.i[a]=b};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.ux)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.Fa=function(){return this.Da.i.length};e.zk=function(){return FN()};
e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,hQ(Y(),b.i[d])),d=1+d|0;return a.xd(c,b.i.length)};e.$classData=l({ux:0},!1,"scala.collection.mutable.WrappedArray$ofLong",{ux:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function e0(){this.Da=this.IA=null;this.Xu=!1}e0.prototype=new X$;
e0.prototype.constructor=e0;e=e0.prototype;e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.rc(a|0)};e.Kk=function(a,b){this.Da.i[a]=b};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.vx)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.Bk=function(a){this.Da=a;return this};e.Fa=function(){return this.Da.i.length};
e.zk=function(){this.Xu||this.Xu||(this.IA=dua(fua(),zr(ra(this.Da))),this.Xu=!0);return this.IA};e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<fO(gO(),b);)c=a.Gb(c,YN(Y(),Oka(gO(),b,d))),d=1+d|0;return a.xd(c,fO(gO(),b))};
e.$classData=l({vx:0},!1,"scala.collection.mutable.WrappedArray$ofRef",{vx:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function g2(){this.Da=null}g2.prototype=new X$;g2.prototype.constructor=g2;e=g2.prototype;e.rc=function(a){return this.Da.i[a]};e.Ea=function(a){return this.Da.i[a|0]};e.eo=function(a){this.Da=a;return this};
e.Kk=function(a,b){this.Da.i[a]=b|0};e.w=function(a){var b;if(a&&a.$classData&&a.$classData.H.wx)if(Qr(),b=this.Da,a=a.Da,b===a)b=!0;else if(null!==b&&null!==a&&b.i.length===a.i.length){for(var c=vW(To(),b),c=R6(c),c=Cp(new Dp,c,c.Fa()),d=!0;d&&c.fb();)d=c.bb()|0,d=dj(ej(),b.i[d],a.i[d]);b=d}else b=!1;else b=a1(this,a);return b};e.Fa=function(){return this.Da.i.length};e.zk=function(){return CN()};
e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,b.i[d]),d=1+d|0;return a.xd(c,b.i.length)};e.$classData=l({wx:0},!1,"scala.collection.mutable.WrappedArray$ofShort",{wx:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function n2(){this.Da=null}n2.prototype=new X$;n2.prototype.constructor=n2;e=n2.prototype;
e.rc=function(a){this.Da.i[a]};e.Ea=function(a){this.Da.i[a|0]};e.Kk=function(a,b){this.Da.i[a]=b};e.w=function(a){return a&&a.$classData&&a.$classData.H.NF?this.Da.i.length===a.Da.i.length:a1(this,a)};e.Fa=function(){return this.Da.i.length};e.zk=function(){return JN()};e.go=function(a){this.Da=a;return this};e.A=function(){for(var a=XN(),b=this.Da,c=a.jj,d=0;d<b.i.length;)c=a.Gb(c,0),d=1+d|0;return a.xd(c,b.i.length)};
e.$classData=l({NF:0},!1,"scala.collection.mutable.WrappedArray$ofUnit",{NF:1,fl:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fd:1,l:1,k:1});function ae(){this.Dk=this.ie=null;this.Op=!1;this.Ek=0}ae.prototype=new V$;ae.prototype.constructor=ae;function eCa(a){if(!a.g()){var b=a.ie,c=a.Dk.ga;for(a.Ds();b!==c;)ff(a,b.n()),b=b.o()}}e=ae.prototype;
e.ih=function(a,b){Id(this.ie,a,b)};e.c=function(){this.ie=F();this.Op=!1;this.Ek=0;return this};e.n=function(){return this.ie.n()};e.rc=function(a){if(0>a||a>=this.Ek)throw(new W).j(""+a);return ro(this.ie,a)};e.Pe=function(a){return qo(this.ie,a)};e.Ea=function(a){return this.rc(a|0)};e.Qf=function(a){return M8(this.ie,a)};e.$f=function(a){return tBa(this.ie,a)};e.g=function(){return 0===this.Ek};e.lb=function(){this.Op=!this.g();return this.ie};e.md=function(){return this};
e.w=function(a){return a&&a.$classData&&a.$classData.H.IF?this.ie.w(a.ie):a1(this,a)};e.Pd=function(a){return gG(this.ie,"",a,"")};e.le=function(a,b,c){return gG(this.ie,a,b,c)};e.ee=function(a){return ff(this,a)};e.Le=function(a){return uBa(this.ie,a)};e.qe=function(){return vu()};e.Cb=function(a){for(var b=this.ie;!b.g();)a.Ea(b.n()),b=b.o()};e.se=function(a,b){return vBa(this.ie,a,b)};e.Yt=function(a){return ff(this,a)};e.si=function(){return zz(this.ie)};
e.cm=function(){var a=this.ie;To();return H(a,new sR)};e.we=function(){var a=this.ie,b=CV().b;return H(a,b)};e.Za=function(){return this.Ek};e.da=function(){return this.lb()};e.Jb=function(){var a=new d2;a.Ip=this.g()?F():this.ie;return a};e.ii=function(a,b){iV(this,a,b)};e.Of=function(){return gG(this.ie,"","","")};e.Fa=function(){return this.Ek};e.kj=function(){return this};e.ce=function(){return this.ie.ce()};e.Ze=function(){if(null===this.Dk)throw(new BP).j("last of empty ListBuffer");return this.Dk.ed};
e.qg=function(a,b,c,d){return jO(this.ie,a,b,c,d)};function ff(a,b){a.Op&&eCa(a);if(a.g())a.Dk=U(new V,b,F()),a.ie=a.Dk;else{var c=a.Dk;a.Dk=U(new V,b,F());c.ga=a.Dk}a.Ek=1+a.Ek|0;return a}e.vf=function(a){return wBa(this.ie,a|0)};e.Gg=function(a,b){return vBa(this.ie,a,b)};e.ba=function(a){return ff(this,a)};e.je=function(){};e.rf=function(a,b,c){bBa(this.ie,a,b,c)};e.Ds=function(){this.ie=F();this.Dk=null;this.Op=!1;this.Ek=0};e.Cn=function(a){return kO(this.ie,a)};e.Tg=function(){return 0<this.Ek};
function Ll(a,b){a:for(;;){var c=b;if(null!==c&&c===a){var d=a;b=a.Ek;c=d.ic();if(!(0>=b)){c.ii(b,d);for(var f=0,d=d.Jb();f<b&&d.fb();)c.ba(d.bb()),f=1+f|0}b=c.da();continue a}return GO(a,b)}}e.$e=function(a){return xBa(this.ie,a)};e.$c=function(a){return Ll(this,a)};e.jf=function(){return"ListBuffer"};
e.$classData=l({IF:0},!1,"scala.collection.mutable.ListBuffer",{IF:1,fF:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,DF:1,EF:1,Ee:1,De:1,$l:1,Iq:1,Sd:1,Nh:1,Fe:1,f7:1,e7:1,g7:1,l:1,k:1});function ql(){this.Qb=null}ql.prototype=new $9;ql.prototype.constructor=ql;e=ql.prototype;e.dc=function(){return this};e.n=function(){return eo(this)};
e.c=function(){ql.prototype.aB.call(this,16,"");return this};e.rc=function(a){a=this.Qb.Vj(a);return(new ed).db(a)};e.Pe=function(a){return i8(this,a)};e.Qf=function(a){return k8(this,a)};e.Ea=function(a){a=this.Qb.Vj(a|0);return(new ed).db(a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.md=function(){return this};e.Lo=function(a,b){return this.Qb.ac.substring(a,b)};e.sl=function(a){return this.Qb.Vj(a)};e.ee=function(a){SH(this,null===a?0:a.pa);return this};
e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.qe=function(){return nwa()};e.v=function(){return this.Qb.ac};e.Cb=function(a){A8(this,a)};e.se=function(a,b){var c=this.Qb.Fa();return J8(this,0,c,a,b)};e.qf=function(a){var b=this.Qb.ac;return b===a?0:b<a?-1:1};e.Eg=function(a,b){return BBa(this,a,b)};e.we=function(){return D7(this)};e.da=function(){return this.Qb.ac};function rl(a,b){var c=a.Qb;c.ac=""+c.ac+b;return a}e.Jb=function(){return Cp(new Dp,this,this.Qb.Fa())};
e.Oq=function(){return this};e.ii=function(a,b){iV(this,a,b)};e.aB=function(a,b){a=(new s0).mc((b.length|0)+a|0);a.ac=""+a.ac+b;ql.prototype.PI.call(this,a);return this};e.Of=function(){return this.Qb.ac};e.Fa=function(){return this.Qb.Fa()};e.kj=function(){return this};e.Df=function(){return this.Qb.Fa()};e.Ze=function(){return Hd(this)};e.tf=function(a){var b=this.Qb.Fa();return BBa(this,a,b)};e.o=function(){return I8(this)};e.kf=function(){return this};e.PI=function(a){this.Qb=a;return this};
function sl(a,b){var c=a.Qb;c.ac+=""+b;return a}e.vf=function(a){return G1(this,a|0)};e.ba=function(a){SH(this,null===a?0:a.pa);return this};e.je=function(){};e.rf=function(a,b,c){K8(this,a,b,c)};e.A=function(){return PU(XN(),this)};e.j=function(a){ql.prototype.aB.call(this,16,a);return this};e.Cn=function(){return EP(Ga(),this.Qb.ac)};function SH(a,b){Oua(a.Qb,b)}e.Vj=function(a){return this.Qb.Vj(a)};e.$e=function(a){return L8(this,a)};e.ic=function(){return bva(new S0,(new ql).c())};
e.$c=function(a){return GO(this,a)};e.$classData=l({j4:0},!1,"scala.collection.mutable.StringBuilder",{j4:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,ko:1,Aj:1,Cg:1,Zd:1,Uf:1,bF:1,bf:1,yo:1,xf:1,Nh:1,Fe:1,Ee:1,De:1,l:1,k:1});function r(){this.Da=null}r.prototype=new V$;r.prototype.constructor=r;e=r.prototype;e.dc=function(){return this};
e.c=function(){r.prototype.d.call(this,[]);return this};e.n=function(){return eo(this)};e.rc=function(a){return this.Da[a]};e.Pe=function(a){return i8(this,a)};e.Ea=function(a){return this.Da[a|0]};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.md=function(){return this};e.ee=function(a){this.Da.push(a);return this};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};e.qe=function(){return pl()};e.Cb=function(a){A8(this,a)};
e.se=function(a,b){return J8(this,0,this.Da.length|0,a,b)};e.Yt=function(a){this.Da.push(a);return this};e.Eg=function(a,b){return B8(this,a,b)};e.we=function(){return D7(this)};e.da=function(){return this};e.Jb=function(){return Cp(new Dp,this,this.Da.length|0)};e.Oq=function(){return this};e.ii=function(a,b){iV(this,a,b)};e.Fa=function(){return this.Da.length|0};e.kj=function(){return this};e.Df=function(){return this.Da.length|0};e.Ze=function(){return Hd(this)};
e.tf=function(a){return B8(this,a,this.Da.length|0)};e.o=function(){return I8(this)};e.kf=function(){return this};e.vf=function(a){return G1(this,a|0)};e.ba=function(a){this.Da.push(a);return this};e.rf=function(a,b,c){K8(this,a,b,c)};e.je=function(){};e.A=function(){return PU(XN(),this)};e.Ds=function(){this.Da.length=0};e.d=function(a){this.Da=a;return this};e.$e=function(a){return L8(this,a)};e.jf=function(){return"WrappedArray"};
e.$classData=l({RF:0},!1,"scala.scalajs.js.WrappedArray",{RF:1,fF:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,DF:1,EF:1,Ee:1,De:1,$l:1,Iq:1,Sd:1,Aj:1,Cg:1,Zd:1,Uf:1,ng:1,eg:1,bf:1,Fe:1});function Fd(){this.eB=0;this.Da=null;this.kd=0}Fd.prototype=new V$;Fd.prototype.constructor=Fd;e=Fd.prototype;e.dc=function(){return this};
function Gd(a,b){dpa(a,1+a.kd|0);a.Da.i[a.kd]=b;a.kd=1+a.kd|0;return a}e.c=function(){Fd.prototype.mc.call(this,16);return this};e.n=function(){return eo(this)};e.rc=function(a){return f0(this,a)};e.Pe=function(a){return i8(this,a)};e.Ea=function(a){return f0(this,a|0)};e.Qf=function(a){return k8(this,a)};e.$f=function(a){return x8(this,a)};e.g=function(){return xm(this)};e.md=function(){return this};e.ee=function(a){return Gd(this,a)};e.Le=function(a){return y8(this,a)};e.ag=function(){return z8(this)};
e.qe=function(){return CV()};e.Cb=function(a){for(var b=0,c=this.kd;b<c;)a.Ea(this.Da.i[b]),b=1+b|0};e.se=function(a,b){return J8(this,0,this.kd,a,b)};e.Yt=function(a){return Gd(this,a)};e.Eg=function(a,b){return B8(this,a,b)};e.we=function(){return D7(this)};e.da=function(){return this};e.Oq=function(){return this};e.Jb=function(){return Cp(new Dp,this,this.kd)};e.ii=function(a,b){iV(this,a,b)};e.mc=function(a){a=this.eB=a;this.Da=oa(bc(Ab),[1<a?a:1]);this.kd=0;return this};e.Fa=function(){return this.kd};
e.kj=function(){return this};e.Df=function(){return this.kd};e.Ze=function(){return Hd(this)};e.tf=function(a){return B8(this,a,this.kd)};e.kf=function(){return this};e.o=function(){return I8(this)};function rBa(a,b){if(b&&b.$classData&&b.$classData.H.Zd){var c=b.Fa();dpa(a,a.kd+c|0);b.rf(a.Da,a.kd,c);a.kd=a.kd+c|0;return a}return GO(a,b)}e.vf=function(a){return G1(this,a|0)};e.ba=function(a){return Gd(this,a)};
e.rf=function(a,b,c){var d=fO(gO(),a)-b|0;c=c<d?c:d;d=this.kd;c=c<d?c:d;0<c&&E0(Tp(),this.Da,0,a,b,c)};e.je=function(a){a>this.kd&&1<=a&&(a=oa(bc(Ab),[a]),Ta(this.Da,0,a,0,this.kd),this.Da=a)};e.A=function(){return PU(XN(),this)};e.Ds=function(){for(pI(To(),0<=this.kd);0<this.kd;)this.kd=-1+this.kd|0,this.Da.i[this.kd]=null};e.$e=function(a){return L8(this,a)};e.$c=function(a){return rBa(this,a)};e.jf=function(){return"ArrayBuffer"};
e.$classData=l({z3:0},!1,"scala.collection.mutable.ArrayBuffer",{z3:1,fF:1,gj:1,Cf:1,Bc:1,Cc:1,f:1,yc:1,Zb:1,$b:1,Tb:1,tb:1,sb:1,Wb:1,Yb:1,wc:1,zc:1,xc:1,vc:1,Vb:1,Xb:1,x:1,hf:1,Uc:1,Mb:1,Te:1,zd:1,Ad:1,hj:1,Xg:1,Yg:1,Vg:1,ij:1,Wg:1,dg:1,Mf:1,DF:1,EF:1,Ee:1,De:1,$l:1,Iq:1,Sd:1,eg:1,Uf:1,Zd:1,bf:1,Fe:1,k7:1,Aj:1,Cg:1,Fd:1,l:1,k:1});da.parseSource=function(a){for(var b=arguments.length|0,c=1,d=[];c<b;)d.push(arguments[c]),c=c+1|0;b=void 0===d[0]?this.Gs:d[0];c=lM();return GL(c,a,b,DL())};
da["default"]=function(a){for(var b=arguments.length|0,c=1,d=[];c<b;)d.push(arguments[c]),c=c+1|0;b=void 0===d[0]?this.Gs:d[0];c=lM();return GL(c,a,b,DL())};da.parseStat=function(a){for(var b=arguments.length|0,c=1,d=[];c<b;)d.push(arguments[c]),c=c+1|0;b=void 0===d[0]?this.Gs:d[0];c=lM();d=rja();d=0===(1&d.ra)?qja(d):d.rw;return GL(c,a,b,d)};
(function(){var a=Oba();na(bc(sa),[]);Xc.loadConfig(taa);Xc.loadVoice(uaa);var b=(new Kl).qj(!0);Xc.speak("Welcome to accessible-scaa-laa demo!",{speed:300});qaa;saa;var c=-1!==(sr(rr()).navigator.userAgent.indexOf("Mac")|0)?"Cmd":"Ctrl";qCa((new oM).Jm(raa.keyMap.sublime),c+"-L");var d=LL(),f=(new q).a("autofocus",!0),g=(new q).a("mode","text/x-scala"),h=(new q).a("theme","solarized light"),n=(new q).a("keyMap","sublime"),u=LL(),w=(new q).a("scrollPastEnd",!1),D=(new q).a("Tab","defaultTab"),N=(new q).a("F2",
Xn(lk(function(a,b,c){return function(a){var d=a.getOption("theme")===b?c:b;a.setOption("theme",d)}}(a,"solarized dark","solarized light")))),Q=(new q).a("F3",Xn(lk(function(a,b){return function(){b.cb=!b.cb;Un("speech "+(b.cb?"on":"off"),!0,!0,b)}}(a,b)))),ea=(new q).a("Alt-Right",Yn(lk(function(){return function(a){return a.mt()}}(a)),b)),ba=(new q).a("Alt-Left",Yn(lk(function(){return function(a){return a.hw()}}(a)),b)),ma=(new q).a("Alt-Up",Yn(lk(function(){return function(a){return a.Ox()}}(a)),
b)),La=(new q).a("Alt-Down",Yn(lk(function(){return function(a){return a.EA()}}(a)),b)),Pa=(new q).a(c+"-D",Xn(lk(function(a,b){return function(a){var c=a.getDoc(),d=c.getValue(),f=Il(),d=Zn($n(f,d));a:{if(ao(d)&&(f=bo(co().qp,d),!f.g())){a=f.q();d=c.listSelections();1<=(d.length|0)?(f=eo((new fo).d(d)),d=c.indexFromPos(f.anchor)|0,c=c.indexFromPos(f.head)|0,c=(new ad).K(d,c)):(d=c.getCursor(),c=c.indexFromPos(d)|0,c=(new ad).K(c,c));try{var g=Jl().wp(a,(new V0).mc(c.E));Un(g,!1,!0,b);break a}catch(h){if(g=
vj(wj(),h),null!==g){c=ho(io(),g);if(c.g())throw jo(wj(),g);ko(c.q());break a}else throw h;}}if(lo(d)&&(g=mo(co().jp,d),!g.g())){c=g.q().Bb;g=g.q().qb;c=(new ad).K(c.ab(),c.wa());Un(g,!1,!0,b);go(a,c);break a}throw(new p).e(d);}}}(a,b)))),Qa=(new q).a(c+"-S",Xn(lk(function(a,b){return function(a){var c=a.getDoc(),d=c.getValue(),f=Il(),d=Zn($n(f,d));a:{if(ao(d)&&(f=bo(co().qp,d),!f.g())){a=f.q();d=c.listSelections();1<=(d.length|0)?(f=eo((new fo).d(d)),d=c.indexFromPos(f.anchor)|0,c=c.indexFromPos(f.head)|
0,c=(new ad).K(d,c)):(d=c.getCursor(),c=c.indexFromPos(d)|0,c=(new ad).K(c,c));try{var g=kk().wp(a,(new V0).mc(c.E));Un(g,!1,!0,b);break a}catch(h){if(g=vj(wj(),h),null!==g){c=ho(io(),g);if(c.g())throw jo(wj(),g);ko(c.q());break a}else throw h;}}if(lo(d)&&(g=mo(co().jp,d),!g.g())){c=g.q().Bb;g=g.q().qb;c=(new ad).K(c.ab(),c.wa());Un(g,!1,!0,b);go(a,c);break a}throw(new p).e(d);}}}(a,b)))),c=KL(u,(new r).d([w,D,N,Q,ea,ba,ma,La,Pa,Qa,(new q).a(c+"-B",Xn(lk(function(a,b){return function(a){var c=a.getDoc(),
d=c.getValue(),f=Il(),d=Zn($n(f,d));a:{if(ao(d)&&(f=bo(co().qp,d),!f.g())){a=f.q();d=c.listSelections();1<=(d.length|0)?(f=eo((new fo).d(d)),d=c.indexFromPos(f.anchor)|0,c=c.indexFromPos(f.head)|0,c=(new ad).K(d,c)):(d=c.getCursor(),c=c.indexFromPos(d)|0,c=(new ad).K(c,c));try{mk||(mk=(new ek).c());var g=mk.wp(a,(new V0).mc(c.E));Un(g,!1,!0,b);break a}catch(h){if(g=vj(wj(),h),null!==g){c=ho(io(),g);if(c.g())throw jo(wj(),g);ko(c.q());break a}else throw h;}}if(lo(d)&&(g=mo(co().jp,d),!g.g())){c=g.q().Bb;
g=g.q().qb;c=(new ad).K(c.ab(),c.wa());Un(g,!1,!0,b);go(a,c);break a}throw(new p).e(d);}}}(a,b))))])),d=KL(d,(new r).d([f,g,h,n,(new q).a("extraKeys",c)])),f=Wca().createElement("textarea");Wca().body.appendChild(f);d=raa.fromTextArea(f,d);Tba(Do(),d,Wm(function(a,b){return function(c,d){var f=d.origin,f=void 0===f?S():(new T).e(f),g=lk(function(){return function(a){return"+move"===a}}(a)),f=f.g()?S():(new T).e(g.Ea(f.q())),g=Rq(function(){return function(){return!1}}(a));if(f.g()?OO(g):f.q())if(c=
c.getDoc(),d=eo((new fo).d(d.ranges)).head,f=c.getCursor(),(f.line|0)===(d.line|0)){Yba||(Yba=(new Go).c());d=(new q).a(f,d);d=Xba(d);if(null!==d)d=(new q).a(d.qa(),d.p());else throw(new p).e(d);d=c.getRange(d.qa(),d.p());c=(new cd).j(d);cj(c)&&Un(d.trim(),!1,!0,b)}}}(a,b)));f=(new UK).db(97);g=(new ed).db(122);f=VK(f,g);g=QQ();g=RQ(g);f=H(f,g);g=(new UK).db(65);h=(new ed).db(90);g=VK(g,h);h=QQ();h=RQ(h);f=f.kl(H(g,h));g=(new UK).db(49);h=(new ed).db(57);g=VK(g,h);h=QQ();h=RQ(h);f=f.kl(H(g,h));g=
(new cd).j("[]{}()+-*/_");h=QQ();h=RQ(h);f=f.kl(H(g,h));g=lk(function(){return function(a){a=(new ed).db(null===a?0:a.pa).pa;return ca.String.fromCharCode(a)}}(a));h=QQ();h=RQ(h);f=SQ(f,g,h);Uba(Do(),d,Wm(function(a,b,c){return function(a,d){var f=d.key;d=!!d.altKey||!!d.ctrlKey||!!d.metaKey;if(c.Ac(f)&&!d)Un(f,!1,!0,b);else if(" "===f){f=a.getDoc();d=f.getCursor();var g=a.findPosH(d,-1,"word");Vba(Wba(),g,d)?a=g:(a=d,d=g);a=f.getRange(a,d);Un(a,!1,!0,b)}else if("Up"===f||"Down"===f)a=a.getDoc(),
Un(a.getLine(a.getCursor().line|0),!1,!0,b)}}(a,b,f)));b=(new cd).j("|/*\n         |Keyboard Shortcuts:\n         |  Navigate and Describe  Alt-Down, Alt-Right, Alt-Left, Alt-Up\n         |  Describe               Ctrl-D\n         |  Summarize              Ctrl-S\n         |  Breadcrumbs            Ctrl-B\n         |\n         |*/\n         |class A {\n         |  val a \x3d 1\n         |  val b \x3d 2\n         |}\n         |\n         |class B\n         |\n         |class D[T1, T2] extends B with C {\n         |\n         |}");
f=zpa(b);b=Xr().up(sr(rr()).localStorage.getItem("code"));f=Rq(function(a,b){return function(){return b}}(a,f));b=b.g()?OO(f):b.q();d.getDoc().setValue(b);Sba(Do(),d,Wm(function(a,b,c){return function(){var a=sr(rr()).localStorage,d=b.getDoc();a.setItem(c,d.getValue())}}(a,d,"code")))})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	meSpeak  v.1.9.6
	based on speak.js, https://github.com/kripken/speak.js
	eSpeak and other code here are under the GNU GPL.
	meSpeak (Modular eSpeak) is a mod of 'speak.js' by N.Landsteiner (2011-2014), www.masswerk.at
	adding support for Webkit/Safari and external voice-modules
	v.1.1 and later default to play via the Web Audio API and uses the HTMLAudioElement as a second option.
	official project page: http://www.masswerk.at/mespeak
*/


var ESpeak = __webpack_require__(10)

/* meScript.js essential changes start here */

var eSpeakDir = '/espeak',
	eSpeakDataDir = '/espeak/espeak-data',
	eSpeakVoicesDir = '/espeak/espeak-data/voices',
	eSpeak = new ESpeak(),
	fileRegistry = [],
	fsErrorDetected = false,
	configDataLoaded = false,
	unloading = false,
	speakQueue = [],
	voicesLoaded = {},
	defaultVoice = '',
	AudioAPI = null,
	canPlay = false,
	playbackVolume = 1,
	masterGain = null,
	audioContext = null,
	audioPool = {},
	webSoundPool = {},
	isChrome = ((typeof navigator !== 'undefined') && navigator.userAgent && navigator.userAgent.indexOf('Chrome') !== -1),
	chromeVersion = (isChrome) ? parseInt(navigator.userAgent.replace(/^.*?\bChrome\/([0-9]+).*$/, '$1'), 10) : 0;

function fsCreateDataFile(path, fname, data, doNotRegister) {
	if (!eSpeak.FS.findObject(path)) eSpeak.FS.createPath('/', path.substring(1), true, true);
	eSpeak.FS.createDataFile(path, fname, data, true, false);
	if (!doNotRegister) fileRegistry.push({
		path: path,
		fname: fname
	});
}

// work around a emscripten FS-bug causing the engine to stop at some iteration (80th call)
// simply create a new instance and reload any files
function recoverFromFSError(message) {
	console.log('meSpeak -- recovering from error:', message);
	// save any loaded files from broken instance
	var files = [],
		f, i, l = fileRegistry.length;
	for (i = 0; i < l; i++) {
		f = fileRegistry[i];
		files.push(eSpeak.FS.findObject(f.path + '/' + f.fname).contents);
	}
	// reboot to a new instance and insert any loaded files
	eSpeak = new ESpeak();
	setUpVFS();
	for (i = 0; i < l; i++) {
		f = fileRegistry[i];
		fsCreateDataFile(f.path, f.fname, files[i], true);
	}
	fsErrorDetected = true;
}

// basic FS setup, for config data see setConfigData(), for voices see setVoiceData()
function setUpVFS() {
	var optionFiles = {
		'croak': 'language variant\nname croak\ngender male 70\npitch 85 117\nflutter 20\nformant 0 100 80 110\n',
		'f1': 'language variant\nname female1\ngender female 70\npitch 140 200\nflutter 8\nroughness 4\nformant 0 115 80 150\nformant 1 120 80 180\nformant 2 100 70 150 150\nformant 3 115 70 150\nformant 4 110 80 150\nformant 5 110 90 150\nformant 6 105 80 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAdd -10 -10 -20 -20 0 0 40 60\n',
		'f2': 'language variant\nname female2\ngender female\npitch 142 220\nroughness 3\nformant 0 105 80 150\nformant 1 110 80 160\nformant 2 110 70 150\nformant 3 110 70 150\nformant 4 115 80 150\nformant 5 115 80 150\nformant 6 110 70 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAdd 0 0 -10 -10 0 0 10 40\nbreath 0 2 3 3 3 3 3 2\necho 140 10\nconsonants 125 125\n',
		'f3': 'language variant\nname female3\ngender female\npitch 140 240\nformant 0 105 80 150\nformant 1 120 75 150 -50\nformant 2 135 70 150 -250\nformant 3 125 80 150\nformant 4 125 80 150\nformant 5 125 80 150\nformant 6 120 70 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAmp 18 18 20 20 20 20 20 20\n//breath 0 2 4 4 4 4 4 4\nbreath 0 2 3 3 3 3 3 2\necho 120 10\nroughness 4\n',
		'f4': 'language variant\nname female4\ngender female\necho 130 15\npitch 142 200\nformant 0 120 80 150\nformant 1 115 80 160 -20\nformant 2 130 75 150 -200\nformant 3 123 75 150\nformant 4 125 80 150\nformant 5 125 80 150\nformant 6 110 80 150\nformant 7 110 75 150\nformant 8 110 75 150\nstressAdd -20 -20 -20 -20 0 0 20 120\nstressAmp 18 16 20 20 20 20 20 20\n',
		'f5': 'language variant\nname female5\ngender female\npitch 160 228\nroughness 0\nformant 0 105 80 150\nformant 1 110 80 160\nformant 2 110 70 150\nformant 3 110 70 150\nformant 4 115 80 200\nformant 5 115 80 100\nformant 6 110 70 150\nformant 7 110 70 100\nformant 8 110 70 150\nstressAdd 0 0 -10 -10 0 0 10 40\nbreath 0 4 6   6 6   6 0 10\necho 140 10\nvoicing 75\nconsonants 150 150\nbreathw 150 150 200 200 400 400\n',
		'klatt': 'language variant\nname klatt\nklatt 1\n',
		'klatt2': 'language variant\nname klatt2\nklatt 2\n',
		'klatt3': 'language variant\nname klatt3\nklatt 3\n',
		'm1': 'language variant\nname male1\ngender male 70\npitch 75 109\nflutter 5\nroughness 4\nconsonants 80 100\nformant 0 98 100 100\nformant 1 97 100 100\nformant 2 97 95 100\nformant 3 97 95 100\nformant 4 97 85 100\nformant 5 105 80 100\nformant 6 95 80 100\nformant 7 100 100 100\nformant 8 100 100 100\n//stressAdd -10 -10 -20 -20 0 0 40 70\n',
		'm2': 'language variant\nname male2\ngender male\npitch 88 115\necho 130 15\nformant 0 100 80 120\nformant 1 90 85 120\nformant 2 110 85 120\nformant 3 105 90 120\nformant 4 100 90 120\nformant 5 100 90 120\nformant 6 100 90 120\nformant 7 100 90 120\nformant 8 100 90 120\n',
		'm3': 'language variant\nname male3\ngender male\npitch 80 122\nformant 0 100 100 100\nformant 1 96 97 100\nformant 2 96 97 100\nformant 3 96 103 100\nformant 4 95 103 100\nformant 5 95 103 100\nformant 6 100 100 100\nformant 7 100 100 100\nformant 8 100 100 100\nstressAdd 10 10 0 0 0 0 -30 -30\n',
		'm4': 'language variant\nname male4\ngender male\npitch 70 110\nformant 0 103 100 100\nformant 1 103 100 100\nformant 2 103 100 100\nformant 3 103 100 100\nformant 4 106 100 100\nformant 5 106 100 100\nformant 6 106 100 100\nformant 7 103 100 100\nformant 8 103 100 100\nstressAdd -10 -10 -30 -30 0 0 60 90\n',
		'm5': 'language variant\nname male5\ngender male\nformant 0 100 85 130\nformant 1 90 85 130 40\nformant 2 80 85 130 310\nformant 3 105 85 130\nformant 4 105 85 130\nformant 5 105 85 130\nformant 6 105 85 150\nformant 7 105 85 150\nformant 8 105 85 150\nintonation 2\n',
		'm6': 'language variant\nname male6\ngender male\npitch 82 117\nformant 0 100 90 120\nformant 1 100 90 140\nformant 2 100 70 140\nformant 3 100 75 140\nformant 4 100 80 140\nformant 5 100 80 140\n',
		'm7': 'language variant\nname male7\npitch 75 125\nformant 0 100 125 100\nformant 1 100 90 80\nformant 2 100 70 90\nformant 3 100 60 90\nformant 4 100 60 90\nformant 5 75 50 90\nformant 6 90 50 100\nformant 7 100 50 100\nformant 8 100 50 100\nvoicing 155\n',
		'whisper': 'language variant\nname whisper\npitch 75 125\nformant 0 100 125 100\nformant 1 100 90 80\nformant 2 100 70 90\nformant 3 100 60 90\nformant 4 100 60 90\nformant 5 75 50 90\nformant 6 90 50 100\nformant 7 100 50 100\nformant 8 100 50 100\nvoicing 155\n',
		'whisperf': 'language variant\nname female whisper\ngender female\npitch 160 220\nroughness 3\nformant 0 105 0 150\nformant 1 110 40 160\nformant 2 110 70 150\nformant 3 110 70 150\nformant 4 115 80 150\nformant 5 115 80 150\nformant 6 110 70 150\nformant 7 110 70 150\nformant 8 110 70 150\nstressAdd 0 0 -10 -10 0 0 10 40\n// whisper\nvoicing 20\nbreath 75 75 50 40 15 10\nbreathw 150 150 200 200 400 400\n'
	};
	var dir = eSpeakVoicesDir + '/!v';
	eSpeak.FS.createPath('/', dir.substring(1), true, true);
	eSpeak.FS.root.write = true;
	for (var fn in optionFiles) {
		eSpeak.FS.createDataFile(dir, fn, decodeStringToArray(optionFiles[fn]), true, true);
	}
}
if (eSpeak && eSpeak.FS) setUpVFS();

function setConfigData(data) {
	[
		['config', decodeBase64ToArray(data.config)],
		['phontab', decodeBase64ToArray(data.phontab)],
		['phonindex', decodeBase64ToArray(data.phonindex)],
		['phondata', decodeBase64ToArray(data.phondata)],
		['intonations', decodeBase64ToArray(data.intonations)]
	].forEach(function(pair) {
		var id = pair[0];
		var data = pair[1];
		fsCreateDataFile(eSpeakDataDir, id, data);
	});
	configDataLoaded = true;
	// inspect data for an optional default-voice
	var voice = data.voice;
	if (typeof voice == 'object' && typeof voice.voice_id == 'string' && typeof voice.dict_id == 'string' && typeof voice.dict == 'string' && typeof voice.voice == 'string') {
		setVoiceData(voice);
	}
	executeQueuedCalls();
}

function setVoiceData(data) {
	var parts, path, fname, f;
	if (!voicesLoaded[data.voice_id]) {
		if (data.dict_id && !eSpeak.FS.findObject(eSpeakDataDir + '/' + data.dict_id)) fsCreateDataFile(eSpeakDataDir, data.dict_id, decodeBase64ToArray(data.dict));
		parts = data.voice_id.split('/');
		path = eSpeakVoicesDir;
		if (parts.length > 1) {
			path += '/' + parts.slice(0, parts.length - 1).join('/');
		}
		fname = parts[parts.length - 1];
		if (data.voice_encoding == 'text') {
			fsCreateDataFile(path, fname, decodeStringToArray(data.voice));
		} else {
			fsCreateDataFile(path, fname, decodeBase64ToArray(data.voice));
		}
		if (data.files && Array.isArray(data.files)) {
			for (var i = 0, l = data.files.length; i < l; i++) {
				f = data.files[i];
				if (typeof f == 'object' && typeof f.path == 'string' && f.path.length && typeof f.data == 'string' && f.data.length) {
					parts = f.path.split('/');
					if (parts.length > 1) {
						path = eSpeakDataDir + '/' + parts.slice(0, parts.length - 1).join('/');
					} else {
						path = eSpeakDataDir;
					}
					fname = parts[parts.length - 1];
					if (f.encoding == 'text') {
						fsCreateDataFile(path, fname, decodeStringToArray(f.data));
					} else {
						fsCreateDataFile(path, fname, decodeBase64ToArray(f.data));
					}
				}
			}
		}
		voicesLoaded[data.voice_id] = true;
	}
	setDefaultVoice(data.voice_id);
	executeQueuedCalls();
}

function decodeBase64ToArray(str) {
	function f(c) {
		if (c == 43) {
			return 62; // "+"
		} else if (c == 47) {
			return 63; // "/"
		} else if (c == 61) {
			return 64; // "="
		} else if (c <= 57) {
			return c + 4; // "0".."9"
		} else if (c <= 90) {
			return c - 65; // "A".."Z"
		} else {
			return c - 71; // "a".."z"
		}
	}
	var h1, h2, h3, h4, out = [],
		i = 0,
		l = str.length;
	while (i < l) {
		h1 = f(str.charCodeAt(i++));
		h2 = f(str.charCodeAt(i++));
		h3 = f(str.charCodeAt(i++));
		h4 = f(str.charCodeAt(i++));
		out.push((h1 << 2) | (h2 >> 4));
		if (h3 != 64) out.push(((h2 & 15) << 4) | (h3 >> 2));
		if (h4 != 64) out.push(((h3 & 3) << 6) | h4);
	}
	return out;
}

function encode64(data) {
	var BASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	var PAD = '=';
	var ret = '';
	var leftchar = 0;
	var leftbits = 0;
	for (var i = 0, l = data.length; i < l; i++) {
		leftchar = (leftchar << 8) | data[i];
		leftbits += 8;
		while (leftbits >= 6) {
			var curr = (leftchar >> (leftbits - 6)) & 0x3f;
			leftbits -= 6;
			ret += BASE[curr];
		}
	}
	if (leftbits == 2) {
		ret += BASE[(leftchar & 3) << 4];
		ret += PAD + PAD;
	} else if (leftbits == 4) {
		ret += BASE[(leftchar & 0xf) << 2];
		ret += PAD;
	}
	return ret;
}

function decodeStringToArray(str) {
	var out = [],
		l = str.length,
		i;
	for (i = 0; i < l; i++) out.push(str.charCodeAt(i));
	return out;
}

function executeQueuedCalls() {
	// execute any defered calls to speak()
	if (configDataLoaded && defaultVoice) {
		for (var i = 0, l = speakQueue.length; i < l; i++) {
			var args = speakQueue[i];
			if (args[3].multipart) {
				speakMultipart(args[0], args[1], args[2], args[3]);
			} else {
				speak(args[0], args[1], args[2], args[3]);
			}
		}
		speakQueue.length = 0;
	}
}

function resetQueue() {
	// public
	speakQueue.length = 0;
}

function speak(text, args, callback, _id) {
	// public
	// returns:
	// with option "rawdata": stream-object in specified format (or null on failure)
	// default: returns numeric 32bit id (or 0 on failure)
	if (typeof args !== 'object') args = {};
	if (!canPlay && !args.rawdata) {
		console.warn('meSpeak: Can\'t play; No audio support.');
		return 0;
	}
	if (!_id || !isValidJobId(_id)) _id = getJobId();
	if (!configDataLoaded || !defaultVoice) {
		console.warn(((!configDataLoaded) ? 'No config-data loaded' : 'No voice module loaded') + ', deferring call.');
		if (args.rawdata) {
			return null;
		} else {
			speakQueue.push([text, args, callback, _id]);
			return _id.number;
		}
	}
	if (args && args.voice && !voicesLoaded[args.voice]) {
		console.warn('Voice ' + args.voice + ' not available. Using default voice: ' + defaultVoice);
	}
	var varg = (args.voice) ? String(args.voice) : (args.v) ? String(args.v) : defaultVoice;
	if (varg.indexOf('mb/mb-') == 0) varg = varg.substring(3);
	if (args.variant) varg += '+' + String(args.variant).replace(/\+/g, '');
	var argstack = [
		'-w', 'wav.wav',
		'-a', args.amplitude !== undefined ? String(args.amplitude) : args.a !== undefined ? String(args.a) : '100',
		'-g', args.wordgap !== undefined ? String(args.wordgap) : args.g !== undefined ? String(args.g) : '0',
		'-p', args.pitch !== undefined ? String(args.pitch) : args.p !== undefined ? String(args.p) : '50',
		'-s', args.speed !== undefined ? String(args.speed) : args.s !== undefined ? String(args.s) : '175',
		'-b', args.utf16 ? '4' : args.b !== undefined ? String(args.b) : '1',
		'-v', varg
	];
	var a = args.linebreak || args.l;
	if (a) argstack.push('-l', String(a));
	a = args.capitals || args.k;
	if (a) argstack.push('-k', String(a));
	a = args.nostop || args.z;
	if (a) argstack.push('-z');
	if (args.punct !== undefined) {
		if (typeof args.punct == 'string') {
			if (args.punct.length) {
				argstack.push('--punct="' + String(args.punct).replace(/([\\"'])/g, '\\$1') + '"');
			} else {
				argstack.push('--punct');
			}
		} else if (args.punct) {
			argstack.push('--punct');
		}
	}
	a = args.ssml || args.m || args.markup;
	if (a) argstack.push('-m');
	argstack.push('--path=' + eSpeakDir, String(text));
	if (args.log && self.console) console.log('executing espeak ' + argstack.join(' '));
	eSpeak.Module.arguments = argstack;

	if (typeof callback != 'function') callback = undefined;
	if (!callback && typeof args.callback == 'function') callback = args.callback;

	fsErrorDetected = false;
	eSpeak.run();
	if (fsErrorDetected) {
		// eSpeak breaks sometimes on flushing streams, approx. every 80th call
		fsErrorDetected = false;
		eSpeak.Module.arguments = argstack;
		eSpeak.run();
	}

	var outfile = eSpeak.FS.root.contents['wav.wav'].contents,
		wav = unsignedStream(outfile);
	outfile.length = 0;
	argstack = null;

	return (args.rawdata) ? exportStream(wav, args.rawdata) : playSound(wav, args.volume, callback, _id);
}

function exportStream(stream, format) {
	// private
	switch (String(format).toLowerCase()) {
		case 'array':
			return stream;
		case 'base64':
			return encode64(stream);
		case 'buffer':
			return new Buffer(stream);
		case 'data-url':
		case 'data-uri':
		case 'dataurl':
		case 'datauri':
		case 'mime':
			return 'data:audio/x-wav;base64,' + encode64(stream);
		default:
			var buffer = new ArrayBuffer(stream.length);
			new Uint8Array(buffer).set(stream);
			return buffer;
	}
}

function speakMultipart(parts, args, callback, _id) {
	// public
	// returns:
	// with option "rawdata": stream-object in specified format (or null on failure)
	// default: returns numeric 32bit id (or 0 on failure)
	if (typeof args !== 'object') args = {};
	if (!canPlay && !args.rawdata) {
		console.warn('meSpeak: Can\'t play; No audio support.');
		return 0;
	}
	var failed = false;
	if (typeof callback != 'function') callback = undefined;
	if (!callback && typeof args.callback == 'function') callback = args.callback;
	if (Object.prototype.toString.call(parts) != '[object Array]' || !parts.length) {
		console.warn('meSpeak.speakMultipart: First argument must be an array of objects.');
		failed = true;
	}
	if (!failed) {
		for (var i = 0, l = parts.length; i < l; i++) {
			if (typeof parts[i] != 'object') {
				console.warn('meSpeak.speakMultipart: First argument must be an array of objects (part #' + i + ').');
				failed = true;
				break;
			}
		}
	}
	if (failed) {
		if (args.rawdata) {
			return null;
		} else {
			if (callback) callback(false);
			return 0;
		}
	}
	if (!_id || !isValidJobId(_id)) _id = getJobId();
	if (!configDataLoaded || !defaultVoice) {
		console.warn(((!configDataLoaded) ? 'No config-data loaded' : 'No voice module loaded') + ', deferring call.');
		if (args.rawdata) {
			return null;
		} else {
			_id.multipart = true;
			speakQueue.push([parts, args, callback, _id]);
			return _id.number;
		}
	}
	// everything ok, now actually do it
	var wav, sampleLength;
	// loop over the parts
	for (var i = 0, l = parts.length; i < l; i++) {
		var n, part = parts[i],
			opts = {};
		for (n in args) opts[n] = args[n];
		for (n in part) opts[n] = part[n];
		opts.rawdata = 'array';
		opts.callback = undefined;
		var buffer = meSpeak.speak(part.text, opts);
		if (!buffer) {
			if (args.rawdata) {
				return null;
			} else {
				if (callback) callback(false);
				return 0;
			}
		}
		if (i == 0) {
			// first: store it and extract the sample length
			wav = buffer;
			sampleLength = readBytes(buffer, 40, 4);
		} else {
			// extract the sample length and add it
			sampleLength += readBytes(buffer, 40, 4);
			// strip header and append samples
			wav = wav.concat(buffer.slice(44));
		}
		buffer = null;
	}
	// fix up the sample length (pos 4 and pos 40 in header)
	writeBytes(wav, 4, 4, sampleLength);
	writeBytes(wav, 40, 4, sampleLength);
	// export/play it
	return (args.rawdata) ? exportStream(wav, args.rawdata) : playSound(wav, args.volume, callback, _id);
}

function writeBytes(f, p, n, value) {
	// private: write bytes to a file, least significant first
	while (n) {
		f[p++] = value & 0xff;
		value = value >> 8;
		n--;
	}
}

function readBytes(f, p, n) {
	// private: read bytes from a file, least significant first
	var value = 0,
		shft = 0;
	while (n) {
		value |= f[p++] << shft;
		shft += 8;
		n--;
	}
	return value;
}

function unsignedStream(wav) {
	// private
	var i, l = wav.length,
		v, out = new Array(l);
	for (i = 0; i < l; i++) {
		v = wav[i];
		out[i] = (v >= 0) ? v : 256 + v;
	}
	return out;
}

function getJobId() {
	// private
	var n, s;
	while (!n || audioPool[s] || webSoundPool[s]) {
		n = Math.floor(Math.random() * Math.pow(2, 32));
		s = n.toString(16);
	}
	return {
		number: n,
		string: s
	}
}

function isValidJobId(id) {
	// private
	return !(Object.prototype.toString.call(id) !== '[object Object]' || Object.prototype.toString.call(id.number) !== '[object Number]' || Object.prototype.toString.call(id.string) !== '[object String]' || !id.number || id.string !== id.number.toString(16));
}

function playSound(stream, relVolume, callback, _id) {
	// public (play): play a wav-stream or an ArrayBuffer generated using option 'rawdata'
	// returns numeric 32bit id (or 0 on failure)
	if (callback && (typeof callback != 'function')) callback = undefined;
	if (!_id || !isValidJobId(_id)) _id = getJobId();
	var streamType = Object.prototype.toString.call(stream);
	if (!(streamType == '[object Array]' || streamType == '[object ArrayBuffer]' || streamType == '[object String]')) {
		console.warn('meSpeak: Can\'t play, not an Array, or ArrayBuffer, or base64-String: ' + streamType);
		if (callback) callback(false);
		return 0;
	}
	if (relVolume !== undefined) {
		relVolume = parseFloat(relVolume);
		if (isNaN(relVolume) || relVolume < 0 || relVolume > 1) relVolume = undefined;
	}
	if (AudioAPI) {
		if (streamType == '[object String]') {
			if (stream.indexOf('data:audio/x-wav;base64,', 0) == 0) stream = stream.substring(24);
			stream = stream.replace(/=+$/, '');
			if (stream.match(/[^A-Za-z0-9\+\/]/)) {
				console.warn('meSpeak: Can\'t play, not a proper base64-String.');
				if (callback) callback(false);
				return 0;
			}
			stream = decodeBase64ToArray(stream);
			if (!stream.length) {
				console.warn('meSpeak: Can\'t play, empty sound data.');
				if (callback) callback(false);
				return 0;
			}
			streamType = '[object Array]';
		}
		var buffer;
		if (streamType == '[object Array]') {
			var buffer = new ArrayBuffer(stream.length);
			new Uint8Array(buffer).set(stream);
		} else {
			buffer = stream;
		}
		return playWebSound(buffer, relVolume, callback, _id);
	} else if (canPlay) {
		var isDataUrl = false;
		if (streamType == '[object String]') {
			if (stream.indexOf('data:audio/x-wav;base64,', 0) < 0) {
				if (stream.match(/[^A-Za-z0-9\+\/]/)) {
					console.warn('meSpeak: Can\'t play, not a proper base64-String.');
					if (callback) callback(false);
					return 0;
				}
				stream = 'data:audio/x-wav;base64,' + stream;
			}
			isDataUrl = true;
		} else if (streamType == '[object ArrayBuffer]') {
			stream = new Uint8Array(stream);
		}
		return (new AudioPlayback(stream, relVolume, isDataUrl, callback, _id).started) ? _id.number : 0;
	} else {
		console.warn('meSpeak: Can\'t play; No audio support.');
		if (callback) callback(false);
		return 0;
	}
}

// public meSpeak.stop()
// takes IDs returned by meSpeak.speak() and/or meSpeak.play as arguments
// if called whitout an argument, all sounds will be stopped.
// returns the number of sounds stopped
function stopSound() {
	var id, i, k, kl, l, item, n, stopped = 0;
	if (arguments.length > 0) {
		// stop specific sounds (by numeric 32bit id)
		for (i = 0, l = arguments.length; i < l; i++) {
			n = parseInt(arguments[i]);
			if (n && !isNaN(n)) {
				id = n.toString(16);
				if (audioPool[id]) {
					audioPool[id].stop();
					stopped++;
				} else if (webSoundPool[id]) {
					stopWebSound(webSoundPool[id]);
					stopped++;
				} else {
					for (k = 0, kl = speakQueue.length; k < kl; k++) {
						item = speakQueue[i];
						if (item[3].string === id) {
							if (!unloading && typeof item[2] == 'function') item[2](false);
							speakQueue.splice(k, 1);
							stopped++;
							break;
						}
					}
				}
			}
		}
	} else {
		// stop all sounds
		for (id in audioPool) {
			audioPool[id].stop();
			stopped++;
		}
		for (id in webSoundPool) {
			stopWebSound(webSoundPool[id]);
			stopped++;
		}
		for (i = 0, l = speakQueue.length; i < l; i++) {
			item = speakQueue[i];
			if (!unloading && typeof item[2] == 'function') item[2](false);
			stopped++;
		}
		speakQueue.length = 0;
	}
	return stopped;
}

function setVolume(vol) {
	// public, sets master volume (no arguments) or rel volume for provided ids
	var id, i, l, n, v;
	v = parseFloat(vol);
	if (!isNaN(v) && v >= 0 && v <= 1 && v != playbackVolume) {
		if (arguments.length == 1) playbackVolume = v;
		if (AudioAPI) {
			if (arguments.length > 1) {
				for (i = 0, l = arguments.length; i < l; i++) {
					n = parseInt(arguments[i]);
					if (n && !isNaN(n)) {
						id = n.toString(16);
						if (webSoundPool[id]) setWebSoundVolume(webSoundPool[id], v);
					}
				}
			} else if (masterGain) {
				masterGain.gain.value = playbackVolume;
			}
		} else if (canPlay) {
			if (arguments.length > 1) {
				for (i = 0, l = arguments.length; i < l; i++) {
					n = parseInt(arguments[i]);
					if (n && !isNaN(n)) {
						id = n.toString(16);
						if (audioPool[id]) audioPool[id].setVolume(v);
					}
				}
			} else {
				for (id in audioPool) audioPool[id].adjustVolume();
			}
		}
	}
	return vol;
}

function getVolume() {
	// public, getter for master volume (no argument) or rel volume for first id provided
	if (arguments.length) {
		var n = parseInt(arguments[0]);
		if (n && !isNaN(n)) {
			var id = n.toString(16);
			if (webSoundPool[id]) return webSoundPool[id].relVolume;
			if (audioPool[id]) return audioPool[id].relVolume;
		}
		return undefined;
	} else {
		return playbackVolume;
	}
}

function resolveAudioApi() {
	if (typeof window !== 'undefined' && self.AudioContext) {
		AudioAPI = self.AudioContext;
		canPlay = true;
		return;
	} else {
		if (typeof window !== 'undefined') {
			var vendors = ['webkit', 'moz', 'o', 'ms'];
			for (var i = 0; i < vendors.length; i++) {
				var api = window[vendors[i] + 'AudioContext'];
				if (api) {
					AudioAPI = api;
					canPlay = true;
					return;
				}
			}
		}
	}
	if (!AudioAPI) {
		if (typeof window === 'undefined') {
			canPlay = true;
			console.warn('meSpeak: Not in browser Only able to do raw');
			return;
		}
		var audioElement = document.createElement('audio');
		if (audioElement && audioElement.canPlayType && (audioElement.canPlayType('audio/wav') || audioElement.canPlayType('audio/x-wav'))) {
			canPlay = true;
		} else {
			canPlay = false;
			console.warn('meSpeak: Muted. No support for HTMLAudioElement with MIME "audio/x-wav" dected.');
		}
	}
}
resolveAudioApi();

function canPlaybackWav() {
	// public (canPlay)
	return canPlay;
}

// Controller for HTMLAudioElements (collected in pool to provide access to volume of playing instances)
// (external dependencies: var playbackVolume; input: stream Array (uint8), relVolume: Number 0..1, callback: function)
// provides external method adjustVolume()
function AudioPlayback(stream, relVolume, isDataUrl, callback, id) {
	this.relVolume = relVolume;
	this.audio = null;
	this.id = id.string;
	this.callback = (typeof callback == 'function') ? callback : undefined;
	this.playing = false;
	this.started = false;
	this.play(stream, isDataUrl);
}
AudioPlayback.prototype = {
	play: function(stream, isDataUrl) {
		try {
			audioPool[this.id] = this;
			this.audio = document.createElement('audio');
			this.adjustVolume();
			var that = this;
			this.audio.addEventListener('ended', function() {
				that.remove();
			}, false);
			this.audio.addEventListener('canplaythrough', function() {
				that.audio.play();
				that.playing = true;
			}, false);
			if (isDataUrl) {
				this.audio.src = stream;
			} else {
				this.audio.src = 'data:audio/x-wav;base64,' + encode64(stream);
			}
			this.audio.load();
			this.started = true;
		} catch (e) {
			console.warn('meSpeak: HTMLAudioElement Exception: ' + e.message);
			this.started = false;
			this.remove();
		}
	},
	adjustVolume: function() {
		this.audio.volume = (this.relVolume !== undefined) ? this.relVolume * playbackVolume : playbackVolume;
	},
	setVolume: function(v) {
		this.relVolume = v;
		this.adjustVolume();
	},
	remove: function(stopped) {
		if (this.id) delete audioPool[this.id];
		if (this.callback) {
			var f = this.callback;
			this.callback = undefined;
			if (!unloading) f(!stopped);
		}
	},
	stop: function() {
		try {
			if (this.playing) this.audio.pause();
		} catch (e) {}
		this.remove(true);
	}
};

// play a sound via Web Audio API
// (external dependencies: vars masterGain, playbackVolume; input: stream ArrayBuffer (Uint8Array), relVolume: Number 0..1, callback: function)
function playWebSound(stream, volume, callback, id) {
	try {
		var source, gainNode, timer, relVolume;
		if (!audioContext) audioContext = new AudioAPI();
		if (!masterGain) {
			masterGain = (audioContext.createGain) ? audioContext.createGain() : audioContext.createGainNode();
			masterGain.connect(audioContext.destination);
			masterGain.gain.value = playbackVolume;
		}
		source = audioContext.createBufferSource();
		relVolume = parseFloat(volume);
		if (relVolume === undefined || isNaN(relVolume) || relVolume < 0 || relVolume > 1) relVolume = 1;
		gainNode = (audioContext.createGain) ? audioContext.createGain() : audioContext.createGainNode();
		gainNode.connect(masterGain);
		gainNode.gain.value = relVolume;
		source.connect(gainNode);
		audioContext.decodeAudioData(stream, function(audioData) {
				var f = function() {
					webSoundEndHandler(source, gainNode, callback, true, id.string);
				};
				if (!isChrome && source.onended !== undefined) {
					source.onended = f;
				} else {
					var duration = audioData.duration;
					setTimeout(f, duration ? Math.ceil(duration * 1000) : 10);
				}
				source.buffer = audioData;
				if (chromeVersion >= 32 && source.start) source.start(0);
			},
			function(err) {
				console.log('meSpeak: Web Audio Decoding Error: ' + ((typeof err == 'object') ? err.message : err));
				if (timer) clearTimeout(timer);
				if (source) source.disconnect();
				if (gainNode) gainNode.disconnect();
				if (webSoundPool[id.string]) delete webSoundPool[id.string];
				if (!unloading && typeof callback == 'function') callback(false);
				return 0;
			});
		webSoundPool[id.string] = {
			'source': source,
			'gainNode': gainNode,
			'callback': callback,
			'id': id.string,
			'relVolume': relVolume
		};
		if (chromeVersion < 32) {
			if (source.start) {
				source.start(0);
			} else {
				source.noteOn(0);
			}
		}
		return id.number;
	} catch (e) {
		console.warn('meSpeak: Web Audio Exception: ' + e.message);
		if (timer) clearTimeout(timer);
		webSoundEndHandler(source, gainNode, callback, false, id.string);
		return 0;
	}
}

function webSoundEndHandler(source, gainNode, callback, success, id) {
	if (!unloading && typeof callback == 'function') callback(success);
	// finnaly clean up with a bit of delay (work around a Chrome duration bug/issue)
	var f = function() {
		if (source) {
			if (source.onended !== undefined) source.onended = undefined;
			source.disconnect();
		}
		if (gainNode) gainNode.disconnect();
		if (id && webSoundPool[id]) delete webSoundPool[id];
	};
	if (!success) {
		f();
	} else {
		setTimeout(f, 500);
	}
}

function stopWebSound(obj) {
	// private
	try {
		if (obj.source.stop) {
			obj.source.stop(0);
		} else {
			obj.sourcesource.noteOff(0);
		}
	} catch (e) {}
	webSoundEndHandler(obj.source, obj.gainNode, obj.callback, false, obj.id);
}

function setWebSoundVolume(obj, v) {
	// private
	obj.gainNode.gain.value = v;
	obj.relVolume = v;
}

function setDefaultVoice(voice) {
	// public
	if (voice && voicesLoaded[voice]) defaultVoice = voice;
}

function getDefaultVoice() {
	// public
	return defaultVoice;
}

function loadVoice(url, callback) {
	// public
	if (typeof url !== 'string') {
		setVoiceData(url);
		if (callback) callback(false, url.voice_id);
	} else if (url) new HttpRequest(url, voiceRequestCallback, callback);
}

function loadConfig(url) {
	// public
	if (typeof url === 'object') setConfigData(url);
	else if (url) new HttpRequest(url, configDataRequestCallback, null);
}

function isVoiceLoaded(voice) {
	// public
	return (voicesLoaded[voice]) ? true : false;
}

function isConfigLoaded() {
	// public
	return (configDataLoaded) ? true : false;
}

var HttpRequest
if (typeof window === "undefined") {
	HttpRequest = function(url, loadCallback, userCallback) {
		var error = new Error("meSpeak: URLs not supported in Node.js");
		if(userCallback)userCallback(error,null);
		else throw error;
	}
} else {
	HttpRequest = function(url, loadCallback, userCallback) {
		// userCallback is an optional callback-handler.
		var req = this.request = new XMLHttpRequest();
		this.handler = loadCallback;
		this.url = url;
		this.localmode = Boolean(window.location.href.search(/^file:/i) == 0);
		this.userCallback = userCallback;
		var objref = this;
		try {
			req.open('GET', url);
			req.onreadystatechange = function() {
				objref.handler();
			};
			req.send('');
		} catch (e) {
			if (window.console) console.warn('Failed to load resource from ' + url + ': Network error.');
			if (typeof userCallback == 'function') userCallback(false, 'network error');
			this.request = this.handler = this.userCallback = null;
		}
	}
}

function voiceRequestCallback() {
	var req = this.request;
	if (req.readyState == 4) {
		if (this.localmode || req.status == 200) {
			var data = JSON.parse(req.responseText);
			if (typeof data == 'object' && typeof data.voice_id == 'string' && typeof data.voice == 'string' && (
				((!data.dict_id && !data.dict_id) || (typeof data.dict_id == 'string' && typeof data.dict == 'string')) || (!data.files || (typeof data.files == 'object' && Array.isArray(data.files)))
			)) {
				setVoiceData(data);
				if (typeof this.userCallback == 'function') this.userCallback(true, data.voice_id);
			} else {
				console.warn('Failed to load voice from ' + this.url + ': Not a voice module.');
				if (typeof this.userCallback == 'function') this.userCallback(false, 'data error');
			}
		} else {
			console.warn('Failed to load voice from ' + this.url + ': Received status ' + req.status + '.');
			if (typeof this.userCallback == 'function') this.userCallback(false, 'file error');
		}
		this.request = this.handler = this.userCallback = null;
	}
}

function configDataRequestCallback() {
	var req = this.request;
	if (req.readyState == 4) {
		if (this.localmode || req.status == 200) {
			var data = JSON.parse(req.responseText);
			if (typeof data == 'object' && typeof data.config == 'string' && typeof data.phontab == 'string' && typeof data.phonindex == 'string' && typeof data.phondata == 'string' && typeof data.intonations == 'string') {
				setConfigData(data);
			} else {
				console.warn('Failed to load config-data from ' + this.url + ': No valid data.');
			}
		} else {
			console.warn('Failed to load config-data from ' + this.url + ': Received status ' + req.status + '.');
		}
		this.request = this.handler = this.userCallback = null;
	}
}

function unloadHandler(event) {
	unloading = true;
	stopSound();
	audioPool = {};
	webSoundPool = {};
}

if (typeof window !== 'undefined') window.addEventListener('unload', unloadHandler, false);

// public interface
module.exports = {
	speak: speak,
	speakMultipart: speakMultipart,
	loadConfig: loadConfig,
	loadVoice: loadVoice,
	setDefaultVoice: setDefaultVoice,
	getDefaultVoice: getDefaultVoice,
	setVolume: setVolume,
	getVolume: getVolume,
	play: playSound,
	isConfigLoaded: isConfigLoaded,
	isVoiceLoaded: isVoiceLoaded,
	resetQueue: resetQueue,
	canPlay: canPlaybackWav,
	stop: stopSound
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6).Buffer))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(7)
var ieee754 = __webpack_require__(8)
var isArray = __webpack_require__(9)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function ESpeak() {
// emscripten implementation

var vprint = console.warn


var Module = {
	noInitialRun: true
};

// WARNING: .ll contains i64 or double values. These 64-bit values are dangerous in USE_TYPED_ARRAYS == 2.
//          We store i64 as i32, and double as float. This can cause serious problems!
"use strict";

/*
// Capture the output of this into a variable, if you want
(function(Module, args) {
  Module = Module || {};
  Module.arguments = args || [];
*/

///*
// Runs much faster, for some reason
if (!this.Module) {
  this.Module = {};
}
if (!Module.arguments) {
  try {
    Module.arguments = scriptArgs;
  } catch(e) {
    try {
      Module.arguments = arguments;
    } catch(e) {
      Module.arguments = [];
    }
  }
}
//*/

  
// === Auto-generated preamble library stuff ===

//========================================
// Runtime code shared with compiler
//========================================

var Runtime = {
  stackSave: function () {
    return STACKTOP;
  },
  stackRestore: function (stackTop) {
    STACKTOP = stackTop;
  },
  forceAlign: function (target, quantum) {
    quantum = quantum || 4;
    if (isNumber(target) && isNumber(quantum)) {
      return Math.ceil(target/quantum)*quantum;
    } else {
      return 'Math.ceil((' + target + ')/' + quantum + ')*' + quantum;
    }
  },
  isNumberType: function (type) {
    return type in Runtime.INT_TYPES || type in Runtime.FLOAT_TYPES;
  },
  isPointerType: function isPointerType(type) {
  return pointingLevels(type) > 0;
},
  isStructType: function isStructType(type) {
  if (isPointerType(type)) return false;
  if (new RegExp(/^\[\d+\ x\ (.*)\]/g).test(type)) return true; // [15 x ?] blocks. Like structs
  if (new RegExp(/<?{ [^}]* }>?/g).test(type)) return true; // { i32, i8 } etc. - anonymous struct types
  // See comment in isStructPointerType()
  return !Runtime.isNumberType(type) && type[0] == '%';
},
  INT_TYPES: {"i1":0,"i8":0,"i16":0,"i32":0,"i64":0},
  FLOAT_TYPES: {"float":0,"double":0},
  or64: function (x, y) {
    var l = (x | 0) | (y | 0);
    var h = (Math.round(x / 4294967296) | Math.round(y / 4294967296)) * 4294967296;
    return l + h;
  },
  and64: function (x, y) {
    var l = (x | 0) & (y | 0);
    var h = (Math.round(x / 4294967296) & Math.round(y / 4294967296)) * 4294967296;
    return l + h;
  },
  xor64: function (x, y) {
    var l = (x | 0) ^ (y | 0);
    var h = (Math.round(x / 4294967296) ^ Math.round(y / 4294967296)) * 4294967296;
    return l + h;
  },
  getNativeFieldSize: function getNativeFieldSize(type) {
  return Math.max(Runtime.getNativeTypeSize(type), 4);
},
  getNativeTypeSize: function getNativeTypeSize(type) {
  if (false) return 1;
  var size = {
    '_i1': 1,
    '_i8': 1,
    '_i16': 2,
    '_i32': 4,
    '_i64': 8,
    "_float": 4,
    "_double": 8
  }['_'+type]; // add '_' since float&double confuse Closure compiler as keys.
  if (!size && type[type.length-1] == '*') {
    size = 4; // A pointer
  }
  return size;
},
  dedup: function dedup(items, ident) {
  var seen = {};
  if (ident) {
    return items.filter(function(item) {
      if (seen[item[ident]]) return false;
      seen[item[ident]] = true;
      return true;
    });
  } else {
    return items.filter(function(item) {
      if (seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }
},
  set: function set() {
  var args = typeof arguments[0] === 'object' ? arguments[0] : arguments;
  var ret = {};
  for (var i = 0; i < args.length; i++) {
    ret[args[i]] = 0;
  }
  return ret;
},
  calculateStructAlignment: function calculateStructAlignment(type) {
    type.flatSize = 0;
    type.alignSize = 0;
    var diffs = [];
    var prev = -1;
    type.flatIndexes = type.fields.map(function(field) {
      var size, alignSize;
      if (Runtime.isNumberType(field) || Runtime.isPointerType(field)) {
        size = Runtime.getNativeTypeSize(field); // pack char; char; in structs, also char[X]s.
        alignSize = size;
      } else if (Runtime.isStructType(field)) {
        size = Types.types[field].flatSize;
        alignSize = Types.types[field].alignSize;
      } else {
        dprint('Unclear type in struct: ' + field + ', in ' + type.name_ + ' :: ' + dump(Types.types[type.name_]));
        assert(0);
      }
      alignSize = type.packed ? 1 : Math.min(alignSize, 4);
      type.alignSize = Math.max(type.alignSize, alignSize);
      var curr = Runtime.alignMemory(type.flatSize, alignSize); // if necessary, place this on aligned memory
      type.flatSize = curr + size;
      if (prev >= 0) {
        diffs.push(curr-prev);
      }
      prev = curr;
      return curr;
    });
    type.flatSize = Runtime.alignMemory(type.flatSize, type.alignSize);
    if (diffs.length == 0) {
      type.flatFactor = type.flatSize;
    } else if (Runtime.dedup(diffs).length == 1) {
      type.flatFactor = diffs[0];
    }
    type.needsFlattening = (type.flatFactor != 1);
    return type.flatIndexes;
  },
  generateStructInfo: function (struct, typeName, offset) {
    var type, alignment;
    if (typeName) {
      offset = offset || 0;
      type = (typeof Types === 'undefined' ? Runtime.typeInfo : Types.types)[typeName];
      if (!type) return null;
      if (!struct) struct = (typeof Types === 'undefined' ? Runtime : Types).structMetadata[typeName.replace(/.*\./, '')];
      if (!struct) return null;
      assert(type.fields.length === struct.length, 'Number of named fields must match the type for ' + typeName + '. Perhaps due to inheritance, which is not supported yet?');
      alignment = type.flatIndexes;
    } else {
      var type = { fields: struct.map(function(item) { return item[0] }) };
      alignment = Runtime.calculateStructAlignment(type);
    }
    var ret = {
      __size__: type.flatSize
    };
    if (typeName) {
      struct.forEach(function(item, i) {
        if (typeof item === 'string') {
          ret[item] = alignment[i] + offset;
        } else {
          // embedded struct
          var key;
          for (var k in item) key = k;
          ret[key] = Runtime.generateStructInfo(item[key], type.fields[i], alignment[i]);
        }
      });
    } else {
      struct.forEach(function(item, i) {
        ret[item[1]] = alignment[i];
      });
    }
    return ret;
  },
  stackAlloc: function stackAlloc(size) { var ret = STACKTOP; _memset(STACKTOP, 0, size); STACKTOP += size;STACKTOP = Math.ceil((STACKTOP)/4)*4;; return ret; },
  staticAlloc: function staticAlloc(size) { var ret = STATICTOP; STATICTOP += size;STATICTOP = Math.ceil((STATICTOP)/4)*4;; return ret; },
  alignMemory: function alignMemory(size,quantum) { var ret = size = Math.ceil((size)/(quantum ? quantum : 4))*(quantum ? quantum : 4);; return ret; },
  __dummy__: 0
}



var CorrectionsMonitor = {
  MAX_ALLOWED: 0, // XXX
  corrections: 0,
  sigs: {},

  note: function(type, succeed, sig) {
    if (!succeed) {
      this.corrections++;
      if (this.corrections >= this.MAX_ALLOWED) abort('\n\nToo many corrections!');
    }
  },

  vprint: function() {
    var items = [];
    for (var sig in this.sigs) {
      items.push({
        sig: sig,
        fails: this.sigs[sig][0],
        succeeds: this.sigs[sig][1],
        total: this.sigs[sig][0] + this.sigs[sig][1]
      });
    }
    items.sort(function(x, y) { return y.total - x.total; });
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      vprint(item.sig + ' : ' + item.total + ' hits, %' + (Math.ceil(100*item.fails/item.total)) + ' failures');
    }
  }
};

function cRound(x) {
  return x >= 0 ? Math.floor(x) : Math.ceil(x);
}


//========================================
// Runtime essentials
//========================================

var __globalConstructor__ = function globalConstructor() {
};

var __THREW__ = false; // Used in checking for thrown exceptions.

var __ATEXIT__ = [];

var ABORT = false;

var undef = 0;
var tempValue, tempInt, tempBigInt;

function abort(text) {
  vprint(text + ':\n' + (new Error).stack);
  ABORT = true;
  throw "Assertion: " + text;
}

function assert(condition, text) {
  if (!condition) {
    abort('Assertion failed: ' + text);
  }
}

// Sets a value in memory in a dynamic way at run-time. Uses the
// type data. This is the same as makeSetValue, except that
// makeSetValue is done at compile-time and generates the needed
// code then, whereas this function picks the right code at
// run-time.

function setValue(ptr, value, type) {
  if (type[type.length-1] === '*') type = 'i32'; // pointers are 32-bit
  switch(type) {
    case 'i1': HEAP8[(ptr)]=value;; break;
    case 'i8': HEAP8[(ptr)]=value;; break;
    case 'i16': HEAP16[((ptr)>>1)]=value;; break;
    case 'i32': HEAP32[((ptr)>>2)]=value;; break;
    case 'i64': HEAP32[((ptr)>>2)]=value;; break;
    case 'float': HEAPF32[((ptr)>>2)]=value;; break;
    case 'double': HEAPF32[((ptr)>>2)]=value;; break;
    default: abort('invalid type for setValue: ' + type);
  }
}
Module.setValue = setValue;

// Parallel to setValue.

function getValue(ptr, type) {
  if (type[type.length-1] === '*') type = 'i32'; // pointers are 32-bit
  switch(type) {
    case 'i1': return HEAP8[(ptr)];
    case 'i8': return HEAP8[(ptr)];
    case 'i16': return HEAP16[((ptr)>>1)];
    case 'i32': return HEAP32[((ptr)>>2)];
    case 'i64': return HEAP32[((ptr)>>2)];
    case 'float': return HEAPF32[((ptr)>>2)];
    case 'double': return HEAPF32[((ptr)>>2)];
    default: abort('invalid type for setValue: ' + type);
  }
  return null;
}
Module.getValue = getValue;

// Allocates memory for some data and initializes it properly.

var ALLOC_NORMAL = 0; // Tries to use _malloc()
var ALLOC_STACK = 1; // Lives for the duration of the current function call
var ALLOC_STATIC = 2; // Cannot be freed
Module.ALLOC_NORMAL = ALLOC_NORMAL;
Module.ALLOC_STACK = ALLOC_STACK;
Module.ALLOC_STATIC = ALLOC_STATIC;

function allocate(slab, types, allocator) {
  var zeroinit, size;
  if (typeof slab === 'number') {
    zeroinit = true;
    size = slab;
  } else {
    zeroinit = false;
    size = slab.length;
  }

  var ret = [_malloc, Runtime.stackAlloc, Runtime.staticAlloc][allocator === undefined ? ALLOC_STATIC : allocator](Math.max(size, 1));

  var singleType = typeof types === 'string' ? types : null;

  var i = 0, type;
  while (i < size) {
    var curr = zeroinit ? 0 : slab[i];

    if (typeof curr === 'function') {
      curr = Runtime.getFunctionIndex(curr);
    }

    type = singleType || types[i];
    if (type === 0) {
      i++;
      continue;
    }

    setValue(ret+i, curr, type);
    i += Runtime.getNativeTypeSize(type);
  }

  return ret;
}
Module.allocate = allocate;

function Pointer_stringify(ptr) {
  var ret = "";
  var i = 0;
  var t;
  var nullByte = String.fromCharCode(0);
  while (1) {
    t = String.fromCharCode(HEAPU8[(ptr+i)]);
    if (t == nullByte) { break; } else {}
    ret += t;
    i += 1;
  }
  return ret;
}
Module.Pointer_stringify = Pointer_stringify;

function Array_stringify(array) {
  var ret = "";
  for (var i = 0; i < array.length; i++) {
    ret += String.fromCharCode(array[i]);
  }
  return ret;
}
Module.Array_stringify = Array_stringify;

// Memory management

var FUNCTION_TABLE; // XXX: In theory the indexes here can be equal to pointers to stacked or malloced memory. Such comparisons should
                    //      be false, but can turn out true. We should probably set the top bit to prevent such issues.

var PAGE_SIZE = 4096;
function alignMemoryPage(x) {
  return Math.ceil(x/PAGE_SIZE)*PAGE_SIZE;
}

var HEAP;
var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32;

var STACK_ROOT, STACKTOP, STACK_MAX;
var STATICTOP;

var HAS_TYPED_ARRAYS = false;
var TOTAL_MEMORY = Module.TOTAL_MEMORY || 52428800;
var FAST_MEMORY = Module.FAST_MEMORY || 2097152;

// Initialize the runtime's memory
HAS_TYPED_ARRAYS = false;
try {
  HAS_TYPED_ARRAYS = !!Int32Array && !!Float32Array && !!(new Int32Array(1).subarray); // check for full engine support (use string 'subarray' to avoid closure compiler confusion)
} catch(e) {}

if (HAS_TYPED_ARRAYS) {
  var buffer = new ArrayBuffer(TOTAL_MEMORY);
  HEAP8 = new Int8Array(buffer);
  HEAP16 = new Int16Array(buffer);
  HEAP32 = new Int32Array(buffer);
  HEAPU8 = new Uint8Array(buffer);
  HEAPU16 = new Uint16Array(buffer);
  HEAPU32 = new Uint32Array(buffer);
  HEAPF32 = new Float32Array(buffer);

  // Endianness check (note: assumes compiler arch was little-endian)
  HEAP32[0] = 255;
  assert(HEAPU8[0] === 255 && HEAPU8[3] === 0, 'Typed arrays 2 must be run on a little-endian system');
} else
{
  // Make sure that our HEAP is implemented as a flat array.
  HEAP = new Array(TOTAL_MEMORY);
  for (var i = 0; i < FAST_MEMORY; i++) {
    HEAP[i] = 0; // XXX We do *not* use {{| makeSetValue(0, 'i', 0, 'null') |}} here, since this is done just to optimize runtime speed
  }
  abort('Cannot fallback to non-typed array case in USE_TYPED_ARRAYS == 2: Code is too specialized');
}

var base = intArrayFromString('(null)'); // So printing %s of NULL gives '(null)'
                                         // Also this ensures we leave 0 as an invalid address, 'NULL'
for (var i = 0; i < base.length; i++) {
  HEAP8[(i)]=base[i];
}

Module.HEAP = HEAP;
Module.HEAP8 = HEAP8;
Module.HEAP16 = HEAP16;
Module.HEAP32 = HEAP32;
Module.HEAPU8 = HEAPU8;
Module.HEAPU16 = HEAPU16;
Module.HEAPU32 = HEAPU32;
Module.HEAPF32 = HEAPF32;

STACK_ROOT = STACKTOP = alignMemoryPage(10);
var TOTAL_STACK = 1024*1024; // XXX: Changing this value can lead to bad perf on v8!
STACK_MAX = STACK_ROOT + TOTAL_STACK;

STATICTOP = alignMemoryPage(STACK_MAX);

function __shutdownRuntime__() {
  while(__ATEXIT__.length > 0) {
    var atexit = __ATEXIT__.pop();
    var func = atexit.func;
    if (typeof func === 'number') {
      func = FUNCTION_TABLE[func];
    }
    func(atexit.arg === undefined ? null : atexit.arg);
  }

  // allow browser to GC, set heaps to null?

  // Print summary of correction activity
  CorrectionsMonitor.vprint();
}


// Copies a list of num items on the HEAP into a
// a normal JavaScript array of numbers
function Array_copy(ptr, num) {
  // TODO: In the SAFE_HEAP case, do some reading here, for debugging purposes - currently this is an 'unnoticed read'.
  if (HAS_TYPED_ARRAYS) {
    return Array.prototype.slice.call(HEAP8.subarray(ptr, ptr+num)); // Make a normal array out of the typed 'view'
                                                                     // Consider making a typed array here, for speed?
  } else {
    return HEAP8.slice(ptr, ptr+num);
  }
  return HEAP.slice(ptr, ptr+num);
}
Module.Array_copy = Array_copy;

function String_len(ptr) {
  var i = 0;
  while (HEAP8[(ptr+i)]) i++; // Note: should be |!= 0|, technically. But this helps catch bugs with undefineds
  return i;
}
Module.String_len = String_len;

// Copies a C-style string, terminated by a zero, from the HEAP into
// a normal JavaScript array of numbers
function String_copy(ptr, addZero) {
  var len = String_len(ptr);
  if (addZero) len++;
  var ret = Array_copy(ptr, len);
  if (addZero) ret[len-1] = 0;
  return ret;
}
Module.String_copy = String_copy;

// Tools

this.vprint = function(x) {console.warn(x)}

// This processes a JS string into a C-line array of numbers, 0-terminated.
// For LLVM-originating strings, see parser.js:parseLLVMString function
function intArrayFromString(stringy, dontAddNull) {
  var ret = [];
  var t;
  var i = 0;
  while (i < stringy.length) {
    var chr = stringy.charCodeAt(i);
    if (chr > 0xFF) {
      chr &= 0xFF;
    }
    ret.push(chr);
    i = i + 1;
  }
  if (!dontAddNull) {
    ret.push(0);
  }
  return ret;
}
Module.intArrayFromString = intArrayFromString;

function intArrayToString(array) {
  var ret = [];
  for (var i = 0; i < array.length; i++) {
    var chr = array[i];
    if (chr > 0xFF) {
      chr &= 0xFF;
    }
    ret.push(String.fromCharCode(chr));
  }
  return ret.join('');
}
Module.intArrayToString = intArrayToString;

function unSign(value, bits, ignore, sig) {
  if (value >= 0) {
    return value;
  }
  return bits <= 32 ? 2*Math.abs(1 << (bits-1)) + value // Need some trickery, since if bits == 32, we are right at the limit of the bits JS uses in bitshifts
                    : Math.pow(2, bits)         + value;
  // TODO: clean up previous line
}
function reSign(value, bits, ignore, sig) {
  if (value <= 0) {
    return value;
  }
  var half = bits <= 32 ? Math.abs(1 << (bits-1)) // abs is needed if bits == 32
                        : Math.pow(2, bits-1);
  if (value >= half && (bits <= 32 || value > half)) { // for huge values, we can hit the precision limit and always get true here. so don't do that
    value = -2*half + value; // Cannot bitshift half, as it may be at the limit of the bits JS uses in bitshifts
  }
  return value;
}

// === Body ===



Runtime.QUANTUM_SIZE = 4
var $struct___sFILE___SIZE = 104; // %struct.__sFILE
  var $struct___sFILE___FLATTENER = [0,4,8,12,14,16,24,28,32,36,40,44,48,56,60,64,67,68,76,80,84,88,92,100];
var $struct___sbuf___SIZE = 8; // %struct.__sbuf
  
var $struct__reent___SIZE = 1060; // %struct._reent
  var $struct__reent___FLATTENER = [0,4,8,12,16,20,48,52,56,60,64,68,72,76,80,84,88,328,332,732,736,748];
var $struct__Bigint___SIZE = 24; // %struct._Bigint
  
var $union_anon_0___SIZE = 240; // %union.anon.0
  
var $struct_anon_1___SIZE = 240; // %struct.anon.1
  
var $struct__atexit___SIZE = 400; // %struct._atexit
  var $struct__atexit___FLATTENER = [0,4,8,136];
var $struct__on_exit_args___SIZE = 264; // %struct._on_exit_args
  var $struct__on_exit_args___FLATTENER = [0,128,256,260];
var $struct__glue___SIZE = 12; // %struct._glue
  
var $struct__mbstate_t___SIZE = 8; // %struct._mbstate_t
  
var $union_anon___SIZE = 4; // %union.anon
  
var $struct_option___SIZE = 16; // %struct.option
  
var $struct_MNEM_TAB___SIZE = 8; // %struct.MNEM_TAB
  
var $struct_MatchRecord___SIZE = 16; // %struct.MatchRecord
  
var $struct_TUNE___SIZE = 68; // %struct.TUNE
  var $struct_TUNE___FLATTENER = [0,12,16,24,25,26,27,28,29,30,31,32,33,34,35,36,39,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,64];
var $struct_SYLLABLE___SIZE = 6; // %struct.SYLLABLE
  
var $struct_TONE_HEAD___SIZE = 16; // %struct.TONE_HEAD
  var $struct_TONE_HEAD___FLATTENER = [0,1,2,3,4,8,9,10,12];
var $struct_SSML_STACK___SIZE = 76; // %struct.SSML_STACK
  var $struct_SSML_STACK___FLATTENER = [0,4,8,12,16,56];
var $struct_PARAM_STACK_45___SIZE = 64; // %struct.PARAM_STACK.45
  
var $struct_ACCENTS___SIZE = 8; // %struct.ACCENTS
  
var $struct_MBROLA_TAB___SIZE = 24; // %struct.MBROLA_TAB
  
var $struct_PHONEME_TAB___SIZE = 16; // %struct.PHONEME_TAB
  var $struct_PHONEME_TAB___FLATTENER = [0,4,8,10,11,12,13,14,15];
var $struct_PHONEME_TAB_LIST_106___SIZE = 48; // %struct.PHONEME_TAB_LIST.106
  var $struct_PHONEME_TAB_LIST_106___FLATTENER = [0,32,36,40,44];
var $struct_frameref_t___SIZE = 8; // %struct.frameref_t
  
var $struct_frame_t___SIZE = 64; // %struct.frame_t
  var $struct_frame_t___FLATTENER = [0,2,16,17,18,26,32,35,39,44,49,56,63];
var $struct_PHONEME_DATA___SIZE = 152; // %struct.PHONEME_DATA
  var $struct_PHONEME_DATA___FLATTENER = [0,4,68,88,108,124,128,132];
var $struct_PHONEME_LIST___SIZE = 24; // %struct.PHONEME_LIST
  var $struct_PHONEME_LIST___FLATTENER = [0,1,2,3,4,6,8,12,14,15,16,17,18,19,20,21];
var $struct_SPEED_FACTORS___SIZE = 64; // %struct.SPEED_FACTORS
  
var $struct_voice_t___SIZE = 1344; // %struct.voice_t
  var $struct_voice_t___FLATTENER = [0,40,44,48,52,56,60,64,68,72,76,80,84,88,92,96,100,104,108,112,144,162,180,198,216,234,252,272,308,344];
var $struct_SOUND_ICON___SIZE = 16; // %struct.SOUND_ICON
  
var $struct_Translator___SIZE = 8328; // %struct.Translator
  var $struct_Translator___FLATTENER = [0,280,284,288,292,332,632,652,656,660,668,676,692,696,700,704,708,964,968,1000,1048,1052,1056,5152,5256,6280,6792,7272,7752,7756,8012,8268,8272,8276,8280,8284,8288,8292,8296,8300,8304,8308,8312,8316,8320,8324];
var $struct_LANGUAGE_OPTIONS___SIZE = 280; // %struct.LANGUAGE_OPTIONS
  var $struct_LANGUAGE_OPTIONS___FLATTENER = [0,4,8,12,16,20,24,100,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,240,244,248,249,250,251,252,256,260,264,268,272,276];
var $struct_PHONEME_LIST2___SIZE = 8; // %struct.PHONEME_LIST2
  var $struct_PHONEME_LIST2___FLATTENER = [0,1,2,3,4,6];
var $struct_REPLACE_PHONEMES___SIZE = 3; // %struct.REPLACE_PHONEMES
  
var $struct_datablock___SIZE = 16; // %struct.datablock
  
var $struct_espeak_VOICE___SIZE = 24; // %struct.espeak_VOICE
  var $struct_espeak_VOICE___FLATTENER = [0,4,8,12,13,14,15,16,20];
var $struct_wavegen_peaks_t___SIZE = 80; // %struct.wavegen_peaks_t
  var $struct_wavegen_peaks_t___FLATTENER = [0,4,8,12,16,24,32,40,48,56,64,72];
var $struct_RESONATOR___SIZE = 40; // %struct.RESONATOR
  
var $struct_WGEN_DATA___SIZE = 64; // %struct.WGEN_DATA
  
var $struct_sonicStreamStruct___SIZE = 88; // %struct.sonicStreamStruct
  
var $struct_klatt_frame_t___SIZE = 288; // %struct.klatt_frame_t
  var $struct_klatt_frame_t___FLATTENER = [0,4,8,48,88,128,168,172,176,180,184,188,192,196,200,204,208,248];
var $struct_klatt_global_t___SIZE = 2748; // %struct.klatt_global_t
  var $struct_klatt_global_t___FLATTENER = [0,4,8,12,16,20,24,28,32,36,40,44,48,52,56,64,72,80,88,96,104,112,120,128,136,144,152,160,164,172,176,180,184,188,1468];
var $struct_resonator_t___SIZE = 64; // %struct.resonator_t
  
var $struct_klatt_peaks_t___SIZE = 80; // %struct.klatt_peaks_t
  var $struct_klatt_peaks_t___FLATTENER = [0,4,8,12,16,24,32,40,48,56,64,72];
var $struct_frame_t_199___SIZE = 64; // %struct.frame_t.199
  var $struct_frame_t_199___FLATTENER = [0,2,16,17,18,26,32,35,39,44,49,56,63];
var $struct_stat___SIZE = 80; // %struct.stat
  var $struct_stat___FLATTENER = [0,8,12,16,20,24,28,36,40,44,48,52,56,60,64,68,72];
var $struct_PARAM_STACK___SIZE = 64; // %struct.PARAM_STACK
  
var $struct_PHONEME_TAB_LIST___SIZE = 48; // %struct.PHONEME_TAB_LIST
  var $struct_PHONEME_TAB_LIST___FLATTENER = [0,32,36,40,44];
var $struct_PHONEME_TAB_11___SIZE = 16; // %struct.PHONEME_TAB.11
  var $struct_PHONEME_TAB_11___FLATTENER = [0,4,8,10,11,12,13,14,15];
var $struct_RGROUP___SIZE = 28; // %struct.RGROUP
  var $struct_RGROUP___FLATTENER = [0,16,20,24];
var $struct_WORD_TAB___SIZE = 12; // %struct.WORD_TAB
  var $struct_WORD_TAB___FLATTENER = [0,4,6,8,9,10];
var $struct_PHONEME_TAB_LIST_25___SIZE = 48; // %struct.PHONEME_TAB_LIST.25
  var $struct_PHONEME_TAB_LIST_25___FLATTENER = [0,32,36,40,44];
var $struct_WORD_TAB_29___SIZE = 12; // %struct.WORD_TAB.29
  var $struct_WORD_TAB_29___FLATTENER = [0,4,6,8,9,10];
var $struct_Translator_33___SIZE = 8328; // %struct.Translator.33
  var $struct_Translator_33___FLATTENER = [0,280,284,288,292,332,632,652,656,660,668,676,692,696,700,704,708,964,968,1000,1048,1052,1056,5152,5256,6280,6792,7272,7752,7756,8012,8268,8272,8276,8280,8284,8288,8292,8296,8300,8304,8308,8312,8316,8320,8324];
var $struct_LANGUAGE_OPTIONS_32___SIZE = 280; // %struct.LANGUAGE_OPTIONS.32
  var $struct_LANGUAGE_OPTIONS_32___FLATTENER = [0,4,8,12,16,20,24,100,176,180,184,188,192,196,200,204,208,212,216,220,224,228,232,240,244,248,249,250,251,252,256,260,264,268,272,276];
var $struct_TONE_NUCLEUS___SIZE = 16; // %struct.TONE_NUCLEUS
  var $struct_TONE_NUCLEUS___FLATTENER = [0,1,2,3,4,5,8,12,13,14];
var $struct_PARAM_STACK_54___SIZE = 64; // %struct.PARAM_STACK.54
  
var $struct_FMT_PARAMS___SIZE = 48; // %struct.FMT_PARAMS
  
var $struct_FMT_PARAMS_111___SIZE = 48; // %struct.FMT_PARAMS.111
  
var $struct_SPECT_SEQ___SIZE = 1104; // %struct.SPECT_SEQ
  var $struct_SPECT_SEQ___FLATTENER = [0,2,3,4];
var $struct_frame_t2___SIZE = 44; // %struct.frame_t2
  var $struct_frame_t2___FLATTENER = [0,2,16,17,18,26,32,35,39];
var $struct_SPECT_SEQK___SIZE = 1604; // %struct.SPECT_SEQK
  var $struct_SPECT_SEQK___FLATTENER = [0,2,3,4];
var $struct_pollfd___SIZE = 8; // %struct.pollfd
  var $struct_pollfd___FLATTENER = [0,4,6];
var $struct_dirent___SIZE = 1040; // %struct.dirent
  var $struct_dirent___FLATTENER = [0,4,1028,1032,1036];
var $struct_getopt_data___SIZE = 20; // %struct.getopt_data
  
var _path_home;
var _filetype;
var _wavefile;
var _uri_callback;
var _phoneme_callback;
var _f_wave;
var _quiet;
var _samples_total;
var _samples_split;
var _wavefile_count;
var _end_of_sentence;
var _voice_pcnt;
var __impure_ptr;
var __ZZ13DisplayVoicesP7__sFILEPcE7genders;
var __str1;
var __str3;
var __str4;
var __str5;
var __ZZ4mainE12long_options;
var __str6;
var __str7;
var __str8;
var __str9;
var __str10;
var __str11;
var __str12;
var __str13;
var __str14;
var __str15;
var __str16;
var __str17;
var __str18;
var __str19;
var __str21;
var __str23;
var __str25;
var __str27;
var __str28;
var __str29;
var __str30;
var __ZZL12OpenWaveFilePKciE8wave_hdr;
var __str32;
var __str33;
var __str35;
var __str36;
var __str37;
var __str38;
var __str39;
var __str40;
var __str41;
var __ZL5f_log;
var __str42;
var __str143;
var __str244;
var __str345;
var __str446;
var __str547;
var __str648;
var _mnem_rules;
var __str749;
var __str850;
var __str951;
var __str1052;
var __str1153;
var __str1254;
var __str1355;
var __str1456;
var __str1557;
var __str1658;
var __str1759;
var __str1860;
var __str1961;
var __str2062;
var __str2163;
var __str2264;
var __str2365;
var __str2466;
var __str2567;
var __str2668;
var __str2769;
var __str2870;
var __str2971;
var __str3072;
var __str3173;
var __str3274;
var __str3375;
var __str3476;
var __str3577;
var __str3678;
var __str3779;
var __str3880;
var __str3981;
var __str4082;
var __str4183;
var __str4284;
var __str43;
var __str44;
var __str45;
var __str46;
var __str47;
var __str48;
var __str49;
var __str50;
var __str51;
var __str52;
var __str53;
var __str54;
var __str55;
var __str56;
var __str57;
var _mnem_flags;
var __ZZ22print_dictionary_flagsPjE3buf;
var __str59;
var __ZZ10DecodeRulePKciPciE6output;
var __ZZ10DecodeRulePKciPciE7symbols;
var __ZZ10DecodeRulePKciPciE10symbols_lg;
var __str60;
var __str61;
var __str62;
var __str64;
var __str65;
var __ZL11error_count;
var __ZL21error_need_dictionary;
var __ZL19letterGroupsDefined;
var __ZL10debug_flag;
var __str66;
var __str67;
var __str69;
var __str71;
var __str72;
var __str73;
var __str74;
var __str75;
var __str76;
var __str77;
var __str78;
var __ZL7linenum;
var __ZL10group_name;
var __str79;
var __ZL9group3_ix;
var __str81;
var __str82;
var __str83;
var __str84;
var __str85;
var __str89;
var __ZL9rule_cond;
var __ZL8rule_pre;
var __ZL9rule_post;
var __ZL10rule_match;
var __ZL13rule_phonemes;
var __str90;
var __str91;
var __str92;
var __str93;
var __str94;
var __str95;
var __ZZL16copy_rule_stringPcRiE6outbuf;
var __ZZL16copy_rule_stringPcRiE10next_state;
var __ZZL16copy_rule_stringPcRiE16lettergp_letters;
var __str97;
var __str98;
var __str99;
var __str100;
var __str101;
var __str102;
var __str103;
var __ZL11hash_chains;
var __ZL11hash_counts;
var __ZL9text_mode_b;
var __str104;
var __str106;
var __str107;
var __ZZL12compile_linePcS_PiE10nullstring;
var __str108;
var __str109;
var __str110;
var __str111;
var __str112;
var __str113;
var __str114;
var __str115;
var _dictionary_skipwords;
var _dictionary_name;
var __ZL13remove_accent;
var __str116;
var __str2118;
var __str3119;
var __str4120;
var __str5121;
var __str7123;
var _ipa1;
var __str8124;
var __str9125;
var __ZL15stress_phonemes;
var __ZZ13SetWordStressP10TranslatorPcPjiiE15consonant_types;
var __ZZ13SetWordStressP10TranslatorPcPjiiE8guess_ru;
var __ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_v;
var __ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_t;
var __ZZ14TranslateRulesP10TranslatorPcS1_iS1_iPjE9str_pause;
var __str10126;
var __str11127;
var __ZL13diereses_list;
var __ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement;
var __str15131;
var __str16132;
var __ZZ11LookupFlagsP10TranslatorPKcE5flags;
var __ZZ12RemoveEndingP10TranslatorPciS1_E6ending;
var __ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions;
var __str17133;
var __ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions;
var __str18134;
var __str19135;
var __str20136;
var __str21137;
var __str22138;
var __str23139;
var __str24140;
var __str25141;
var __str27143;
var __str28144;
var __str29145;
var __str30146;
var __str31147;
var __ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best;
var __str32148;
var __str34150;
var _env_fall;
var _env_rise;
var _env_frise;
var __ZL11env_r_frise;
var __ZL10env_frise2;
var __ZL12env_r_frise2;
var __ZL12env_risefall;
var __ZL13env_fallrise3;
var __ZL13env_fallrise4;
var __ZL9env_fall2;
var __ZL9env_rise2;
var __ZL16env_risefallrise;
var _envelope_data;
var __ZL18tone_nucleus_table;
var _punctuation_to_tone;
var _n_tunes;
var _tunes;
var __ZL12syllable_tab;
var __ZL8no_tonic_b;
var __ZL15tone_head_table;
var __ZL10number_pre;
var __ZL10tone_posn2;
var __ZL9tone_posn;
var __ZL11number_tail;
var __ZL14tone_pitch_env;
var __ZZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSiiE12continue_tab;
var __ZL8min_drop;
var __ZL7drops_0;
var __ZL5oflow;
var __ZL9oflow_emf;
var __ZL10oflow_less;
var __ZL12last_primary;
var _namedata;
var __ZL7f_input;
var _p_textinput;
var _p_wchar_input;
var __ZL10ungot_word;
var _count_characters;
var __ZL10ssml_stack;
var __ZL16current_voice_id;
var _param_stack;
var _param_defaults;
var _walpha_tab;
var __ZL10ungot_char;
var __ZL12end_of_input_b;
var __str167;
var __str1168;
var __str2169;
var __str3170;
var __str4171;
var __str5172;
var __str6173;
var __str7174;
var __str8175;
var __str9176;
var __str10177;
var __str11178;
var __str12179;
var __str13180;
var __str14181;
var __str15182;
var __str16183;
var __str17184;
var __str18185;
var __str19186;
var __str20187;
var __str21188;
var __str22189;
var __str23190;
var __str24191;
var __str25192;
var __str26193;
var __str27194;
var __str28195;
var __str29196;
var __str30197;
var __str31198;
var __ZL8ssmltags;
var __ZL10n_namedata;
var __ZL11namedata_ix;
var __str32199;
var __str33200;
var __str34201;
var __str35202;
var __str36203;
var __str37204;
var __ZL18xml_char_mnemonics;
var __ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string;
var __ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix;
var __ZL19clear_skipping_text_b;
var __ZL11ungot_char2;
var __ZL19ssml_ignore_l_angle;
var __str38205;
var __ZL10sayas_mode;
var __ZL11ignore_text_b;
var __ZL11punct_chars;
var __ZL16punct_attributes;
var __str41208;
var __ZL12chars_ignore;
var __str42209;
var __ZL10audio_text_b;
var __ZL17speech_parameters;
var __ZL12n_ssml_stack;
var __ZL13n_param_stack;
var __ZL7xmlbase;
var __ZZL14LookupCharNameP10TranslatoriiE3buf;
var __str47214;
var __str48215;
var __str49216;
var __ZZL13WordToString2jE3buf;
var __str50217;
var __str51218;
var __str52219;
var __str53220;
var __str54221;
var __str55222;
var __str57224;
var __str58225;
var __str59226;
var __str60227;
var __ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct;
var __str61228;
var __str62229;
var __str63230;
var __ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals;
var __str64231;
var __str65232;
var __str66233;
var __ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as;
var __str68235;
var __str69236;
var __str70237;
var __str71238;
var __str72239;
var __ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format;
var __str73240;
var __ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break;
var __str74241;
var __str75242;
var __str76243;
var __str77244;
var __ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis;
var __str78245;
var __str79246;
var __ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr;
var __str80247;
var __str81248;
var __str82249;
var __ZL22ignore_if_self_closing;
var __str83250;
var __str84251;
var __str85252;
var __str86253;
var __str87254;
var __ZZL14ProcessSsmlTagPwPcRiiiE23emphasis_to_pitch_range;
var __ZZL14ProcessSsmlTagPwPcRiiiE18emphasis_to_volume;
var __str88255;
var __str89256;
var __str90257;
var __str91258;
var __ZL11sayas_start;
var __str92259;
var __str94261;
var __str95262;
var __str96263;
var __str97264;
var __str98265;
var __str99266;
var __ZZL14ProcessSsmlTagPwPcRiiiE11break_value;
var __str100267;
var __str101268;
var __str102269;
var __ZZL18GetVoiceAttributesPwiE11mnem_gender;
var __str105272;
var __str106273;
var __str108275;
var __ZZL14LoadSoundFile2PKcE4slot;
var __str111278;
var __str112279;
var __str113280;
var __str114281;
var __ZZL14ReplaceKeyNamePciRiE8keynames;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume;
var __str115282;
var __str116283;
var __str117;
var __str118;
var __str119;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate;
var __str120;
var __str121;
var __str122;
var __str123;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch;
var __str124;
var __str125;
var __str126;
var __str127;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range;
var __ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs;
var __ZZL17ProcessParamStackPcRiE10cmd_letter;
var __str128;
var __ZZL16GetSsmlAttributePwPKcE5empty;
var __ZZL4GetCvE6ungot2;
var __ZZL4GetCvE5mask2;
var __ZL6speed1;
var __ZL6speed2;
var __ZL6speed3;
var __ZL12speed_lookup;
var __ZL14wav_factor_350;
var __ZL16pause_factor_350;
var __ZZ11CalcLengthsP10TranslatorE14more_syllables;
var __str294;
var __ZL18letter_accents_0e0;
var __ZL18letter_accents_250;
var __ZL13non_ascii_tab;
var __ZL11accents_tab;
var __str297;
var __str1298;
var __str2299;
var __ZZ12LookupLetterP10TranslatorjiPciE13single_letter;
var __str5302;
var __str6303;
var __str7304;
var __str8305;
var __str9306;
var __str10307;
var __str11308;
var __str12309;
var __ZZ14TranslateRomanP10TranslatorPcS1_P8WORD_TABE12roman_values;
var __str13310;
var __str14311;
var __ZZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABiE9str_pause;
var __ZL14n_digit_lookup;
var __ZL12digit_lookup;
var __ZL14number_control;
var __ZL23speak_missing_thousands;
var __ZL11ph_ordinal2;
var __str15312;
var __str16313;
var __str17314;
var __str18315;
var __str19316;
var __str20317;
var __str21318;
var __str22319;
var __str23320;
var __str24321;
var __str25322;
var __str26323;
var __str27324;
var __str28325;
var __str29326;
var __str30327;
var __str31328;
var __str32329;
var __str33330;
var __str35332;
var __str36333;
var __str37334;
var __str39336;
var __str40337;
var __str41338;
var __str42339;
var __str43340;
var __str44341;
var __str45342;
var __str46343;
var __str47344;
var __str48345;
var __str49346;
var __str50347;
var __str51348;
var __str52349;
var __str53350;
var __str54351;
var __str55352;
var __str56353;
var __str57354;
var __str58355;
var __str59356;
var __str60357;
var __str61358;
var __str62359;
var __str63360;
var __str64361;
var __str65362;
var __str66363;
var __str67364;
var __str68365;
var __str69366;
var __str70367;
var __str71368;
var __str72369;
var __str73370;
var __str74371;
var __str75372;
var __str76373;
var __str77374;
var __str78375;
var _option_mbrola_phonemes;
var __ZL10mbrola_tab;
var __ZL15mbr_name_prefix;
var __str382;
var __str1383;
var __str2384;
var __str3385;
var __str4386;
var __ZL14mbrola_control;
var __ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix;
var __ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix;
var __ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count;
var __str6388;
var __str8390;
var __str9391;
var __str10392;
var __str11393;
var __str12394;
var __ZZ10MbrolaFilliiE9n_samples;
var __ZZL10WritePitchiiiiiE6output;
var __str13395;
var __str14396;
var __str15397;
var __str16398;
var __ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem;
var __str399;
var _version_string;
var _version_phdata;
var _option_device_number;
var _f_logespeak;
var _logging_type;
var _n_phoneme_tab;
var _current_phoneme_table;
var _phoneme_tab;
var _phoneme_tab_flags;
var _phoneme_index;
var _phondata_ptr;
var _wavefile_data;
var __ZL16phoneme_tab_data;
var _n_phoneme_tables;
var _phoneme_tab_list;
var _phoneme_tab_number;
var _wavefile_ix;
var _wavefile_amp;
var _wavefile_ix2;
var _wavefile_amp2;
var _seq_len_adjust;
var _vowel_transition;
var _vowel_transition0;
var _vowel_transition1;
var __str1412;
var __str2413;
var __str3414;
var __str4415;
var __ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf;
var __str5416;
var __str7418;
var __str9420;
var __str10421;
var __str11422;
var __str13424;
var __str15426;
var __str16427;
var _this_ph_data;
var __ZZL13NumInstnWordsPtE7n_words;
var __ZZL18InterpretConditionP10TranslatoriP12PHONEME_LISTiE11ph_position;
var __ZZL15StressConditionP10TranslatorP12PHONEME_LISTiiE15condition_level;
var __str17428;
var __str18429;
var __str19430;
var _n_phoneme_list;
var _phoneme_list;
var _mbrola_delay;
var _mbrola_name;
var _speed;
var __ZL9new_voice;
var _n_soundicon_tab;
var _soundicon_tab;
var __ZZ12WordToStringjE3buf;
var __ZL14last_pitch_cmd;
var __ZL12last_amp_cmd;
var __ZL10last_frame;
var __ZL15syllable_centre;
var __ZZ18FormantTransition2P10frameref_tRijjP11PHONEME_TABiE10vcolouring;
var __ZL10modn_flags;
var __ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b;
var __ZL13fmt_amplitude;
var __ZL10last_wcmdq;
var __ZL12pitch_length;
var __ZL10amp_length;
var __ZZ8GenerateP12PHONEME_LISTPiiE2ix;
var __ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix;
var __ZZ8GenerateP12PHONEME_LISTPiiE10word_count;
var __ZZ8GenerateP12PHONEME_LISTPiiE8sourceix;
var __ZL14syllable_start;
var __ZL12syllable_end;
var __ZL8timer_on_b;
var __ZL6paused_b;
var __ZZ15SpeakNextClauseP7__sFILEPKviE6f_text;
var __ZZ15SpeakNextClauseP7__sFILEPKviE6p_text;
var __str459;
var __str1460;
var __ZZL13set_frame_rmsP7frame_tiE8sqrt_tab;
var __ZZL10AllocFramevE2ix;
var __ZZL10AllocFramevE10frame_pool;
var _translator;
var _translator2;
var __ZL20translator2_language;
var _f_trans;
var _option_tone2;
var _option_tone_flags;
var _option_phonemes;
var _option_phoneme_events;
var _option_quiet;
var _option_endpause;
var _option_capitals;
var _option_punctuation;
var _option_sayas;
var _option_ssml;
var _option_phoneme_input;
var _option_phoneme_variants;
var _option_wordgap;
var _skip_sentences;
var _skip_words;
var _skip_characters;
var _skip_marker;
var _skipping_text;
var _end_character_position;
var _count_sentences;
var _count_words;
var _clause_start_char;
var _clause_start_word;
var _new_sentence;
var _pre_pause;
var _word_phonemes;
var _n_ph_list2;
var _ph_list2;
var _option_punctlist;
var _ctrl_embedded;
var _option_multibyte;
var _option_linelength;
var _embedded_list;
var _n_replace_phonemes;
var _replace_phonemes;
var __ZL10ISO_8859_1;
var __ZL10ISO_8859_2;
var __ZL10ISO_8859_3;
var __ZL10ISO_8859_4;
var __ZL10ISO_8859_5;
var __ZL10ISO_8859_7;
var __ZL10ISO_8859_9;
var __ZL11ISO_8859_14;
var __ZL6KOI8_R;
var __ZL5ISCII;
var _charsets;
var __ZL15length_mod_tabs;
var __ZZ7IsAlphajE18extra_indic_alphas;
var __ZL8brackets;
var __ZZ8utf8_outjPcE4code;
var __ZZ8utf8_in2PiPKciE4mask;
var __str543;
var __str1544;
var __ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_zz;
var __ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_iz;
var __ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_ss;
var __str2545;
var __str4547;
var __str5548;
var __str6549;
var __ZL18any_stressed_words_b;
var __ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name;
var __ZL11embedded_ix;
var __ZL13embedded_read;
var __ZL6source;
var __str7550;
var __str8551;
var __ZL16max_clause_pause;
var __ZL13option_sayas2;
var __ZL18count_sayas_digits;
var __ZL6breaks;
var __ZL13word_emphasis_b;
var __ZL15option_emphasis;
var __ZL13embedded_flag_b;
var __str9552;
var __str10553;
var __str11554;
var __ZZL13TranslateCharP10TranslatorPcijjPiE20hangul_compatibility;
var __ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b;
var __str12555;
var __ZL14length_mods_en;
var __ZL15length_mods_en0;
var __ZL17length_mods_equal;
var __str580;
var __str1581;
var __str2582;
var __str3583;
var __str4584;
var __ZL14mbr_samplerate;
var __ZL14mbr_voice_path;
var __ZL10mbr_volume;
var __ZL9mbr_state;
var __ZL7mbr_pid;
var __ZL10mbr_cmd_fd;
var __str5585;
var __ZL12mbr_audio_fd;
var __ZL12mbr_errorbuf;
var __ZL12mbr_error_fd;
var __str7587;
var __str8588;
var __str9589;
var __str10590;
var __str11591;
var __str12592;
var __str13593;
var __str14594;
var __str15595;
var __str16596;
var __str17597;
var __ZL21mbr_pending_data_head;
var __ZL21mbr_pending_data_tail;
var __str18598;
var __str19599;
var __str20600;
var __str21601;
var __ZL13mbr_proc_stat;
var __str22602;
var __str23603;
var __str24604;
var __str25605;
var __str27607;
var __str28608;
var __str30610;
var __str31611;
var __str32612;
var __str33613;
var __str34614;
var __str35615;
var __ZZ15SetIndicLettersP10TranslatorE15dev_consonants2;
var __ZZ16SelectTranslatorPKcE17stress_lengths_fr;
var __ZZ16SelectTranslatorPKcE14stress_amps_fr;
var __ZZ16SelectTranslatorPKcE14stress_amps_sk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_ta;
var __ZZ16SelectTranslatorPKcE14stress_amps_ta;
var __ZZ16SelectTranslatorPKcE17stress_lengths_af;
var __ZZ16SelectTranslatorPKcE17stress_lengths_bn;
var __ZZ16SelectTranslatorPKcE14stress_amps_bn;
var __ZZ16SelectTranslatorPKcE17stress_lengths_cy;
var __ZZ16SelectTranslatorPKcE14stress_amps_cy;
var __ZZ16SelectTranslatorPKcE17stress_lengths_da;
var __ZZ16SelectTranslatorPKcE17stress_lengths_de;
var __ZZ16SelectTranslatorPKcE14stress_amps_de;
var __ZZ16SelectTranslatorPKcE17stress_lengths_en;
var __str630;
var __ZZ16SelectTranslatorPKcE17stress_lengths_el;
var __ZZ16SelectTranslatorPKcE14stress_amps_el;
var __ZZ16SelectTranslatorPKcE9el_vowels;
var __ZZ16SelectTranslatorPKcE10el_fvowels;
var __ZZ16SelectTranslatorPKcE12el_voiceless;
var __ZZ16SelectTranslatorPKcE13el_consonants;
var __ZZ16SelectTranslatorPKcE18el_char_apostrophe;
var __ZZ16SelectTranslatorPKcE17stress_lengths_eo;
var __ZZ16SelectTranslatorPKcE14stress_amps_eo;
var __ZZ16SelectTranslatorPKcE18eo_char_apostrophe;
var __ZZ16SelectTranslatorPKcE17stress_lengths_es;
var __ZZ16SelectTranslatorPKcE14stress_amps_es;
var __ZZ16SelectTranslatorPKcE20ca_punct_within_word;
var __ZZ16SelectTranslatorPKcE17stress_lengths_eu;
var __ZZ16SelectTranslatorPKcE14stress_amps_eu;
var __ZZ16SelectTranslatorPKcE14stress_amps_fi;
var __ZZ16SelectTranslatorPKcE17stress_lengths_fi;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hi;
var __ZZ16SelectTranslatorPKcE14stress_amps_hi;
var __ZZ16SelectTranslatorPKcE14stress_amps_hr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sr;
var __ZL22replace_cyrillic_latin;
var __ZZ16SelectTranslatorPKcE14stress_amps_hu;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hu;
var __ZZ16SelectTranslatorPKcE17stress_lengths_hy;
var __ZZ16SelectTranslatorPKcE9hy_vowels;
var __ZZ16SelectTranslatorPKcE13hy_consonants;
var __ZZ16SelectTranslatorPKcE17stress_lengths_id;
var __ZZ16SelectTranslatorPKcE14stress_amps_id;
var __ZZ16SelectTranslatorPKcE17stress_lengths_is;
var __ZZ16SelectTranslatorPKcE16is_lettergroup_B;
var __str1631;
var __str2632;
var __ZZ16SelectTranslatorPKcE17stress_lengths_it;
var __ZZ16SelectTranslatorPKcE14stress_amps_it;
var __ZZ16SelectTranslatorPKcE18stress_lengths_jbo;
var __ZZ16SelectTranslatorPKcE21jbo_punct_within_word;
var __ZZ16SelectTranslatorPKcE9ka_vowels;
var __ZZ16SelectTranslatorPKcE13ka_consonants;
var __ZZ16SelectTranslatorPKcE10ko_ivowels;
var __ZZ16SelectTranslatorPKcE9ko_voiced;
var __ZZ16SelectTranslatorPKcE14stress_amps_ku;
var __ZZ16SelectTranslatorPKcE17stress_lengths_ku;
var __ZZ16SelectTranslatorPKcE14stress_amps_lv;
var __ZZ16SelectTranslatorPKcE17stress_lengths_lv;
var __ZZ16SelectTranslatorPKcE15vowels_cyrillic;
var __ZZ16SelectTranslatorPKcE14stress_amps_mk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_mk;
var __ZZ16SelectTranslatorPKcE17stress_lengths_nl;
var __str3633;
var __ZZ16SelectTranslatorPKcE17stress_lengths_no;
var __ZZ16SelectTranslatorPKcE14stress_amps_om;
var __ZZ16SelectTranslatorPKcE17stress_lengths_om;
var __ZZ16SelectTranslatorPKcE17stress_lengths_pl;
var __ZZ16SelectTranslatorPKcE14stress_amps_pl;
var __ZZ16SelectTranslatorPKcE17stress_lengths_pt;
var __ZZ16SelectTranslatorPKcE14stress_amps_pt;
var __str4634;
var __ZZ16SelectTranslatorPKcE17stress_lengths_ro;
var __ZZ16SelectTranslatorPKcE14stress_amps_ro;
var __str5635;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sq;
var __ZZ16SelectTranslatorPKcE14stress_amps_sq;
var __ZZ16SelectTranslatorPKcE14stress_amps_sv;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sv;
var __ZZ16SelectTranslatorPKcE17stress_lengths_sw;
var __ZZ16SelectTranslatorPKcE14stress_amps_sw;
var __ZZ16SelectTranslatorPKcE14stress_amps_tr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_tr;
var __ZZ16SelectTranslatorPKcE17stress_lengths_vi;
var __ZZ16SelectTranslatorPKcE14stress_amps_vi;
var __ZZ16SelectTranslatorPKcE9vowels_vi;
var __ZZ16SelectTranslatorPKcE17stress_lengths_zh;
var __ZZ16SelectTranslatorPKcE14stress_amps_zh;
var __ZZL18Translator_RussianP10TranslatorE14stress_amps_ru;
var __ZZL18Translator_RussianP10TranslatorE17stress_lengths_ru;
var __ZZL18Translator_RussianP10TranslatorE11ru_ivowels2;
var __ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels;
var __ZZL18SetCyrillicLettersP10TranslatorE13ru_consonants;
var __ZZL18SetCyrillicLettersP10TranslatorE7ru_soft;
var __ZZL18SetCyrillicLettersP10TranslatorE7ru_hard;
var __ZZL18SetCyrillicLettersP10TranslatorE10ru_nothard;
var __ZZL18SetCyrillicLettersP10TranslatorE9ru_voiced;
var __ZZL18SetCyrillicLettersP10TranslatorE10ru_ivowels;
var __ZL8pairs_ru;
var __ZZL13NewTranslatorvE12stress_amps2;
var __ZZL13NewTranslatorvE15stress_lengths2;
var __ZZL13NewTranslatorvE13empty_wstring;
var __ZZL13NewTranslatorvE13punct_in_word;
var __ZZL13NewTranslatorvE13default_tunes;
var __str6636;
var __str7637;
var __str8638;
var __str9639;
var __str10640;
var __str11641;
var __str12642;
var __str13643;
var __str646;
var __str1647;
var __str2648;
var _genders;
var _tone_points;
var _formant_rate;
var _voice_selected;
var __str3653;
var __str4654;
var __ZL11options_tab;
var __str5655;
var __str6656;
var __str7657;
var __str8658;
var __str9659;
var __str10660;
var __str11661;
var __str12662;
var __str13663;
var __str14664;
var __str15665;
var __str16666;
var __str17667;
var __str18668;
var __str19669;
var __str20670;
var __str21671;
var __str22672;
var __str23673;
var __str24674;
var __str25675;
var __str26676;
var __str27677;
var __str28678;
var __str29679;
var __str30680;
var __str31681;
var __str32682;
var __str33683;
var __str34684;
var __str35685;
var __str36686;
var __str37687;
var __str38688;
var __str39689;
var __str40690;
var __str41691;
var __str42692;
var __str43693;
var __ZL11keyword_tab;
var __ZL15variants_either;
var __ZL13variants_male;
var __ZL15variants_female;
var _variant_lists;
var __ZL9voicedata;
var _voice;
var __str44696;
var __ZZ10VoiceResetiE15default_heights;
var __ZZ10VoiceResetiE14default_widths;
var __ZZ10VoiceResetiE13breath_widths;
var __ZL18formant_rate_22050;
var __ZZ9LoadVoicePKciE16voice_identifier;
var __ZZ9LoadVoicePKciE10voice_name;
var __ZZ9LoadVoicePKciE15voice_languages;
var __str45697;
var __str46698;
var __str47699;
var __str48700;
var __str49701;
var __str50702;
var __str51703;
var __str52704;
var __str53705;
var __str54706;
var __str55707;
var __str56708;
var __str57709;
var __str58710;
var __str59711;
var __str60712;
var __str61713;
var __str62714;
var __str63715;
var __str64716;
var __str65717;
var __str66718;
var __str67719;
var __str68720;
var __str69721;
var __ZL13n_voices_list;
var __ZL11voices_list;
var __str70722;
var __ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants;
var __ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id;
var __ZZ11SelectVoiceP12espeak_VOICEPiE3buf;
var __str71723;
var __ZZ14SetVoiceByNamePKcE3buf;
var __ZZ17espeak_ListVoicesE6voices;
var __str72724;
var __ZL15len_path_voices;
var __str73725;
var __str74726;
var __str75727;
var __ZZL23ExtractVoiceVariantNamePciE12variant_name;
var __str76728;
var __str77729;
var __str78730;
var __str79731;
var __str80732;
var __str81733;
var __str82734;
var _sin_tab;
var _wvoice;
var _f_log;
var _option_waveout;
var _option_log_frames;
var _embedded_value;
var _samplerate;
var _samplerate_native;
var __ZL5peaks;
var _echo_head;
var _echo_tail;
var _echo_amp;
var _echo_buf;
var __ZL7rbreath;
var _wdata;
var __ZL13amplitude_env;
var _out_ptr;
var _out_start;
var _out_end;
var _outbuf_size;
var _wcmdq;
var _wcmdq_head;
var _wcmdq_tail;
var _embedded_default;
var _current_source_index;
var __ZL18sonicSpeedupStream;
var _sonicSpeed;
var _pitch_adjust_tab;
var _pk_shape1;
var __ZL16PHASE_INC_FACTOR;
var __ZL11Flutter_inc;
var __ZL11samplecount;
var __ZL8nsamples;
var __ZL9wavephase;
var __ZL12wavemult_max;
var __ZL15wavemult_offset;
var __ZL8wavemult;
var __ZL9pk_shape2;
var __ZL8pk_shape;
var __ZZ12GetAmplitudevE12amp_emphasis;
var __ZL17general_amplitude;
var __ZL11peak_height;
var __ZL13peak_harmonic;
var __ZL16option_harmonic1_b;
var __ZL9harmspect;
var __ZL8harm_inc;
var __ZL10minus_pi_t;
var __ZL8two_pi_t;
var __ZZ7WavegenvE4maxh;
var __ZZ7WavegenvE5maxh2;
var __ZZ7WavegenvE3agc;
var __ZZ7WavegenvE13h_switch_sign;
var __ZZ7WavegenvE11cycle_count;
var __ZZ7WavegenvE10amplitude2;
var __ZL8end_wave_b;
var __ZL7hswitch;
var __ZL6hspect;
var __ZL8phaseinc;
var __ZL13cycle_samples;
var __ZL9hf_factor;
var __ZL6cbytes;
var __ZL12glottal_flag;
var __ZL14glottal_reduce;
var __ZL6amp_ix;
var __ZL15modulation_type;
var __ZL14modulation_tab;
var __ZL7voicing;
var __ZL12embedded_max;
var __ZZ15WavegenSetVoiceP7voice_tE2v2;
var __ZL13consonant_amp;
var __ZL11flutter_amp;
var __ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab1;
var __ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab2;
var __ZL17samplecount_start;
var __ZZ12WavegenFill2iE6resume;
var __ZZ12WavegenFill2iE13echo_complete;
var __ZL11echo_length;
var __ZL7amp_inc;
var __ZZL8PlayWaveiiPhiiE9n_samples;
var __ZZL8PlayWaveiiPhiiE2ix;
var __ZZL11PlaySilenceiiE9n_samples;
var __ZZL17AdvanceParametersvE10Flutter_ix;
var __ZL11Flutter_tab;
var _pause_phonemes;
var __ZZ15MakePhonemeListP10TranslatoriiE12types_double;
var __ZL8kt_frame;
var __ZL10kt_globals;
var __ZL5peaks801;
var __ZL12sample_count;
var __ZL8nsamples802;
var __ZL6klattp;
var __ZL10klattp_inc;
var __ZL7klattp1;
var __ZL8end_wave803;
var __ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr;
var __ZL13scale_wav_tab;
var __ZZ9KlattInitvE15natural_samples;
var __ZZ9KlattInitvE10formant_hz;
var __ZZ9KlattInitvE9bandwidth;
var __ZZ9KlattInitvE12parallel_amp;
var __ZZ9KlattInitvE11parallel_bw;
var __ZZL7parwaveP13klatt_frame_tE5noise;
var __ZZL7parwaveP13klatt_frame_tE5voice;
var __ZZL7parwaveP13klatt_frame_tE5vlast;
var __ZZL7parwaveP13klatt_frame_tE8glotlast;
var __ZZL7parwaveP13klatt_frame_tE5sourc;
var __ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew;
var __ZZL21pitch_synch_par_resetP13klatt_frame_tE2B0;
var __ZZL7DBtoLINlE8amptable;
var __ZZL14natural_sourcevE5vwave;
var __ZZL16impulsive_sourcevE7doublet;
var __ZZL16impulsive_sourcevE5vwave;
var __ZZL9gen_noisedE5nlast;
var __ZZL7flutterP13klatt_frame_tE10time_count;
var __ZZL10frame_initP13klatt_frame_tE14amp_par_factor;
var __str810;
var __str1811;
var _optarg;
var _optind;
var _opterr;
var _optopt;
var __ZL8optwhere;
var __str831;
var __str1832;
var __str2833;
var __str3834;
var __str4835;
var __str5836;
var __str6837;
var _llvm_dbg_declare; // stub for _llvm_dbg_declare

  
  
  var ERRNO_CODES={E2BIG: 7, EACCES: 13, EADDRINUSE: 98, EADDRNOTAVAIL: 99, EAFNOSUPPORT: 97, EAGAIN: 11, EALREADY: 114, EBADF: 9, EBADMSG: 74, EBUSY: 16, ECANCELED: 125, ECHILD: 10, ECONNABORTED: 103, ECONNREFUSED: 111, ECONNRESET: 104, EDEADLK: 35, EDESTADDRREQ: 89, EDOM: 33, EDQUOT: 122, EEXIST: 17, EFAULT: 14, EFBIG: 27, EHOSTUNREACH: 113, EIDRM: 43, EILSEQ: 84, EINPROGRESS: 115, EINTR: 4, EINVAL: 22, EIO: 5, EISCONN: 106, EISDIR: 21, ELOOP: 40, EMFILE: 24, EMLINK: 31, EMSGSIZE: 90, EMULTIHOP: 72, ENAMETOOLONG: 36, ENETDOWN: 100, ENETRESET: 102, ENETUNREACH: 101, ENFILE: 23, ENOBUFS: 105, ENODATA: 61, ENODEV: 19, ENOENT: 2, ENOEXEC: 8, ENOLCK: 37, ENOLINK: 67, ENOMEM: 12, ENOMSG: 42, ENOPROTOOPT: 92, ENOSPC: 28, ENOSR: 63, ENOSTR: 60, ENOSYS: 38, ENOTCONN: 107, ENOTDIR: 20, ENOTEMPTY: 39, ENOTRECOVERABLE: 131, ENOTSOCK: 88, ENOTSUP: 95, ENOTTY: 25, ENXIO: 6, EOVERFLOW: 75, EOWNERDEAD: 130, EPERM: 1, EPIPE: 32, EPROTO: 71, EPROTONOSUPPORT: 93, EPROTOTYPE: 91, ERANGE: 34, EROFS: 30, ESPIPE: 29, ESRCH: 3, ESTALE: 116, ETIME: 62, ETIMEDOUT: 110, ETXTBSY: 26, EWOULDBLOCK: 11, EXDEV: 18 };
  
  function ___setErrNo(value) {
      // For convenient setting and returning of errno.
      if (!___setErrNo.ret) ___setErrNo.ret = allocate([0], 'i32', ALLOC_STATIC);
      HEAP32[((___setErrNo.ret)>>2)]=value;
      return value;
    }
  
  var _stdin=0;
  
  var _stdout=0;
  
  var _stderr=0;
  
  var __impure_ptr=0;
  var FS={currentPath: "/", nextInode: 2, streams: [null], ignorePermissions: true, absolutePath: function (relative, base) {
        if (typeof relative !== 'string') return null;
        if (base === undefined) base = FS.currentPath;
        if (relative && relative[0] == '/') base = '';
        var full = base + '/' + relative;
        var parts = full.split('/').reverse();
        var absolute = [''];
        while (parts.length) {
          var part = parts.pop();
          if (part == '' || part == '.') {
            // Nothing.
          } else if (part == '..') {
            if (absolute.length > 1) absolute.pop();
          } else {
            absolute.push(part);
          }
        }
        return absolute.length == 1 ? '/' : absolute.join('/');
      }, analyzePath: function (path, dontResolveLastLink, linksVisited) {
        var ret = {
          isRoot: false,
          exists: false,
          error: 0,
          name: null,
          path: null,
          object: null,
          parentExists: false,
          parentPath: null,
          parentObject: null
        };
        path = FS.absolutePath(path);
        if (path == '/') {
          ret.isRoot = true;
          ret.exists = ret.parentExists = true;
          ret.name = '/';
          ret.path = ret.parentPath = '/';
          ret.object = ret.parentObject = FS.root;
        } else if (path !== null) {
          linksVisited = linksVisited || 0;
          path = path.slice(1).split('/');
          var current = FS.root;
          var traversed = [''];
          while (path.length) {
            if (path.length == 1 && current.isFolder) {
              ret.parentExists = true;
              ret.parentPath = traversed.length == 1 ? '/' : traversed.join('/');
              ret.parentObject = current;
              ret.name = path[0];
            }
            var target = path.shift();
            if (!current.isFolder) {
              ret.error = ERRNO_CODES.ENOTDIR;
              break;
            } else if (!current.read) {
              ret.error = ERRNO_CODES.EACCES;
              break;
            } else if (!current.contents.hasOwnProperty(target)) {
              ret.error = ERRNO_CODES.ENOENT;
              break;
            }
            current = current.contents[target];
            if (current.link && !(dontResolveLastLink && path.length == 0)) {
              if (linksVisited > 40) { // Usual Linux SYMLOOP_MAX.
                ret.error = ERRNO_CODES.ELOOP;
                break;
              }
              var link = FS.absolutePath(current.link, traversed.join('/'));
              return FS.analyzePath([link].concat(path).join('/'),
                                    dontResolveLastLink, linksVisited + 1);
            }
            traversed.push(target);
            if (path.length == 0) {
              ret.exists = true;
              ret.path = traversed.join('/');
              ret.object = current;
            }
          }
          return ret;
        }
        return ret;
      }, findObject: function (path, dontResolveLastLink) {
        FS.ensureRoot();
        var ret = FS.analyzePath(path, dontResolveLastLink);
        if (ret.exists) {
          return ret.object;
        } else {
          ___setErrNo(ret.error);
          return null;
        }
      }, createObject: function (parent, name, properties, canRead, canWrite) {
        if (!parent) parent = '/';
        if (typeof parent === 'string') parent = FS.findObject(parent);
  
        if (!parent) {
          ___setErrNo(ERRNO_CODES.EACCES);
          throw new Error('Parent path must exist.');
        }
        if (!parent.isFolder) {
          ___setErrNo(ERRNO_CODES.ENOTDIR);
          throw new Error('Parent must be a folder.');
        }
        if (!parent.write && !FS.ignorePermissions) {
          ___setErrNo(ERRNO_CODES.EACCES);
          throw new Error('Parent folder must be writeable.');
        }
        if (!name || name == '.' || name == '..') {
          ___setErrNo(ERRNO_CODES.ENOENT);
          throw new Error('Name must not be empty.');
        }
        if (parent.contents.hasOwnProperty(name)) {
          ___setErrNo(ERRNO_CODES.EEXIST);
          throw new Error("Can't overwrite object.");
        }
  
        parent.contents[name] = {
          read: canRead === undefined ? true : canRead,
          write: canWrite === undefined ? false : canWrite,
          timestamp: Date.now(),
          inodeNumber: FS.nextInode++
        };
        for (var key in properties) {
          if (properties.hasOwnProperty(key)) {
            parent.contents[name][key] = properties[key];
          }
        }
  
        return parent.contents[name];
      }, createFolder: function (parent, name, canRead, canWrite) {
        var properties = {isFolder: true, isDevice: false, contents: {}};
        return FS.createObject(parent, name, properties, canRead, canWrite);
      }, createPath: function (parent, path, canRead, canWrite) {
        var current = FS.findObject(parent);
        if (current === null) throw new Error('Invalid parent.');
        path = path.split('/').reverse();
        while (path.length) {
          var part = path.pop();
          if (!part) continue;
          if (!current.contents.hasOwnProperty(part)) {
            FS.createFolder(current, part, canRead, canWrite);
          }
          current = current.contents[part];
        }
        return current;
      }, createFile: function (parent, name, properties, canRead, canWrite) {
        properties.isFolder = false;
        return FS.createObject(parent, name, properties, canRead, canWrite);
      }, createDataFile: function (parent, name, data, canRead, canWrite) {
        if (typeof data === 'string') {
          var dataArray = [];
          for (var i = 0; i < data.length; i++) dataArray.push(data.charCodeAt(i));
          data = dataArray;
        }
        var properties = {isDevice: false, contents: data};
        return FS.createFile(parent, name, properties, canRead, canWrite);
      }, createLazyFile: function (parent, name, url, canRead, canWrite) {
        var properties = {isDevice: false, url: url};
        return FS.createFile(parent, name, properties, canRead, canWrite);
      }, createLink: function (parent, name, target, canRead, canWrite) {
        var properties = {isDevice: false, link: target};
        return FS.createFile(parent, name, properties, canRead, canWrite);
      }, createDevice: function (parent, name, input, output) {
        if (!(input || output)) {
          throw new Error('A device must have at least one callback defined.');
        }
        var ops = {isDevice: true, input: input, output: output};
        return FS.createFile(parent, name, ops, Boolean(input), Boolean(output));
      }, forceLoadFile: function (obj) {
        if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
        var success = true;
        if (typeof XMLHttpRequest !== 'undefined') {
          // Browser.
          // TODO: Use mozResponseArrayBuffer, responseStream, etc. if available.
          var xhr = new XMLHttpRequest();
          xhr.open('GET', obj.url, false);
  
          // Some hints to the browser that we want binary data.
          if (typeof Uint8Array != 'undefined') xhr.responseType = 'arraybuffer';
          if (xhr.overrideMimeType) {
            xhr.overrideMimeType('text/plain; charset=x-user-defined');
          }
  
          xhr.send(null);
          if (xhr.status != 200 && xhr.status != 0) success = false;
          if (xhr.response !== undefined) {
            obj.contents = new Uint8Array(xhr.response || []);
          } else {
            obj.contents = intArrayFromString(xhr.responseText || '', true);
          }
        } else if (typeof read !== 'undefined') {
          // Command-line.
          try {
            // WARNING: Can't read binary files in V8's d8 or tracemonkey's js, as
            //          read() will try to parse UTF8.
            obj.contents = intArrayFromString(read(obj.url), true);
          } catch (e) {
            success = false;
          }
        } else {
          throw new Error('Cannot load without read() or XMLHttpRequest.');
        }
        if (!success) ___setErrNo(ERRNO_CODES.EIO);
        return success;
      }, ensureRoot: function () {
        if (FS.root) return;
        // The main file system tree. All the contents are inside this.
        FS.root = {
          read: true,
          write: false,
          isFolder: true,
          isDevice: false,
          timestamp: Date.now(),
          inodeNumber: 1,
          contents: {}
        };
      }, init: function (input, output, error) {
        // Make sure we initialize only once.
        if (FS.init.initialized) return;
        FS.init.initialized = true;
  
        FS.ensureRoot();
  
        // Default handlers.
        if (!input) input = function() {
          if (!input.cache || !input.cache.length) {
            var result;
            if (typeof window != 'undefined' &&
                typeof window.prompt == 'function') {
              // Browser.
              result = window.prompt('Input: ');
            } else if (typeof readline == 'function') {
              // Command line.
              result = readline();
            }
            if (!result) result = '';
            input.cache = intArrayFromString(result + '\n', true);
          }
          return input.cache.shift();
        };
        if (!output) output = function(val) {
          if (val === null || val === '\n'.charCodeAt(0)) {
            output.printer(output.buffer.join(''));
            output.buffer = [];
          } else {
            output.buffer.push(String.fromCharCode(val));
          }
        };
        if (!output.printer) output.printer = vprint;
        if (!output.buffer) output.buffer = [];
        if (!error) error = output;
  
        // Create the temporary folder.
        FS.createFolder('/', 'tmp', true, true);
  
        // Create the I/O devices.
        var devFolder = FS.createFolder('/', 'dev', true, false);
        var stdin = FS.createDevice(devFolder, 'stdin', input);
        var stdout = FS.createDevice(devFolder, 'stdout', null, output);
        var stderr = FS.createDevice(devFolder, 'stderr', null, error);
        FS.createDevice(devFolder, 'tty', input, output);
  
        // Create default streams.
        FS.streams[1] = {
          path: '/dev/stdin',
          object: stdin,
          position: 0,
          isRead: true,
          isWrite: false,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: []
        };
        FS.streams[2] = {
          path: '/dev/stdout',
          object: stdout,
          position: 0,
          isRead: false,
          isWrite: true,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: []
        };
        FS.streams[3] = {
          path: '/dev/stderr',
          object: stderr,
          position: 0,
          isRead: false,
          isWrite: true,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: []
        };
        _stdin = allocate([1], 'void*', ALLOC_STATIC);
        _stdout = allocate([2], 'void*', ALLOC_STATIC);
        _stderr = allocate([3], 'void*', ALLOC_STATIC);
  
        // Newlib initialization
        FS.streams[_stdin] = FS.streams[1];
        FS.streams[_stdout] = FS.streams[2];
        FS.streams[_stderr] = FS.streams[3];
        __impure_ptr = allocate([ allocate(
          [0, 0, 0, 0, _stdin, 0, 0, 0, _stdout, 0, 0, 0, _stderr, 0, 0, 0],
          'void*', ALLOC_STATIC) ], 'void*', ALLOC_STATIC);
  
        // Once initialized, permissions start having effect.
        FS.ignorePermissions = false;
      }, quit: function () {
        // Flush any partially-printed lines in stdout and stderr
        if (FS.streams[2].object.output.buffer.length > 0) FS.streams[2].object.output('\n'.charCodeAt(0));
        if (FS.streams[3].object.output.buffer.length > 0) FS.streams[3].object.output('\n'.charCodeAt(0));
      } };
  
  var ___stat_struct_layout={__size__: 80, st_dev: 0, st_ino: 8, st_mode: 12, st_nlink: 16, st_uid: 20, st_gid: 24, st_rdev: 28, st_size: 36, st_atime: 40, st_spare1: 44, st_mtime: 48, st_spare2: 52, st_ctime: 56, st_spare3: 60, st_blksize: 64, st_blocks: 68, st_spare4: 72 };function _stat(path, buf, dontResolveLastLink) {
      // http://pubs.opengroup.org/onlinepubs/7908799/xsh/stat.html
      // int stat(const char *path, struct stat *buf);
      // NOTE: dontResolveLastLink is a shortcut for lstat(). It should never be
      //       used in client code.
      var obj = FS.findObject(Pointer_stringify(path), dontResolveLastLink);
      if (obj === null || !FS.forceLoadFile(obj)) return -1;
  
      var offsets = ___stat_struct_layout;
  
      // Constants.
      HEAP32[((buf+offsets.st_nlink)>>2)]=1;
      HEAP32[((buf+offsets.st_uid)>>2)]=0;
      HEAP32[((buf+offsets.st_gid)>>2)]=0;
      HEAP32[((buf+offsets.st_blksize)>>2)]=4096;
  
      // Variables.
      HEAP32[((buf+offsets.st_ino)>>2)]=obj.inodeNumber;
      var time = Math.floor(obj.timestamp / 1000);
      if (offsets.st_atime === undefined) {
        offsets.st_atime = offsets.st_atim.tv_sec;
        offsets.st_mtime = offsets.st_mtim.tv_sec;
        offsets.st_ctime = offsets.st_ctim.tv_sec;
        var nanosec = (obj.timestamp % 1000) * 1000;
        HEAP32[((buf+offsets.st_atim.tv_nsec)>>2)]=nanosec;
        HEAP32[((buf+offsets.st_mtim.tv_nsec)>>2)]=nanosec;
        HEAP32[((buf+offsets.st_ctim.tv_nsec)>>2)]=nanosec;
      }
      HEAP32[((buf+offsets.st_atime)>>2)]=time;
      HEAP32[((buf+offsets.st_mtime)>>2)]=time;
      HEAP32[((buf+offsets.st_ctime)>>2)]=time;
      var mode = 0;
      var size = 0;
      var blocks = 0;
      var dev = 0;
      var rdev = 0;
      if (obj.isDevice) {
        //  Device numbers reuse inode numbers.
        dev = rdev = obj.inodeNumber;
        size = blocks = 0;
        mode = 0x2000;  // S_IFCHR.
      } else {
        dev = 1;
        rdev = 0;
        // NOTE: In our implementation, st_blocks = Math.ceil(st_size/st_blksize),
        //       but this is not required by the standard.
        if (obj.isFolder) {
          size = 4096;
          blocks = 1;
          mode = 0x4000;  // S_IFDIR.
        } else {
          var data = obj.contents || obj.link;
          size = data.length;
          blocks = Math.ceil(data.length / 4096);
          mode = obj.link === undefined ? 0x8000 : 0xA000;  // S_IFREG, S_IFLNK.
        }
      }
      HEAP32[((buf+offsets.st_dev)>>2)]=dev;
      HEAP32[((buf+offsets.st_rdev)>>2)]=rdev;
      // NOTE: These two may be i64, depending on compilation options.
      HEAP32[((buf+offsets.st_size)>>2)]=size;
      HEAP32[((buf+offsets.st_blocks)>>2)]=blocks;
      if (obj.read) mode |= 0x16D;  // S_IRUSR | S_IXUSR | S_IRGRP | S_IXGRP | S_IROTH | S_IXOTH.
      if (obj.write) mode |= 0x92;  // S_IWUSR | S_IWGRP | S_IWOTH.
      HEAP32[((buf+offsets.st_mode)>>2)]=mode;
  
      return 0;
    }

  function _malloc(size) { var ret = STATICTOP; STATICTOP += size;STATICTOP = Math.ceil((STATICTOP)/4)*4;; return ret; }

  
  
  
  
  
  
  
  
  
  function _pwrite(fildes, buf, nbyte, offset) {
      // ssize_t pwrite(int fildes, const void *buf, size_t nbyte, off_t offset);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/write.html
      var stream = FS.streams[fildes];
      if (!stream || stream.object.isDevice) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isWrite) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (stream.object.isFolder) {
        ___setErrNo(ERRNO_CODES.EISDIR);
        return -1;
      } else if (nbyte < 0 || offset < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        var contents = stream.object.contents;
        while (contents.length < offset) contents.push(0);
        for (var i = 0; i < nbyte; i++) {
          contents[offset + i] = HEAP8[(buf+i)];
        }
        stream.object.timestamp = Date.now();
        return i;
      }
    }function _write(fildes, buf, nbyte) {
      // ssize_t write(int fildes, const void *buf, size_t nbyte);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/write.html
      var stream = FS.streams[fildes];
      if (!stream) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isWrite) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (nbyte < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        if (stream.object.isDevice) {
          if (stream.object.output) {
            for (var i = 0; i < nbyte; i++) {
              try {
                stream.object.output(HEAP8[(buf+i)]);
              } catch (e) {
                ___setErrNo(ERRNO_CODES.EIO);
                return -1;
              }
            }
            stream.object.timestamp = Date.now();
            return i;
          } else {
            ___setErrNo(ERRNO_CODES.ENXIO);
            return -1;
          }
        } else {
          var bytesWritten = _pwrite(fildes, buf, nbyte, stream.position);
          if (bytesWritten != -1) stream.position += bytesWritten;
          return bytesWritten;
        }
      }
    }function _fwrite(ptr, size, nitems, stream) {
      // size_t fwrite(const void *restrict ptr, size_t size, size_t nitems, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fwrite.html
      var bytesToWrite = nitems * size;
      if (bytesToWrite == 0) return 0;
      var bytesWritten = _write(stream, ptr, bytesToWrite);
      if (bytesWritten == -1) {
        if (FS.streams[stream]) FS.streams[stream].error = true;
        return -1;
      } else {
        return Math.floor(bytesWritten / size);
      }
    }
  
  function __formatString(format, varargs) {
      var textIndex = format;
      var argIndex = 0;
      var getNextArg = function(type) {
        // NOTE: Explicitly ignoring type safety. Otherwise this fails:
        //       int x = 4; printf("%c\n", (char)x);
        var ret;
        if (type === 'float' || type === 'double') {
          ret = HEAPF32[((varargs+argIndex)>>2)];
        } else {
          ret = HEAP32[((varargs+argIndex)>>2)];
        }
        argIndex += Runtime.getNativeFieldSize(type);
        return Number(ret);
      };
  
      var ret = [];
      var curr, next, currArg;
      while(1) {
        var startTextIndex = textIndex;
        curr = HEAP8[(textIndex)];
        if (curr === 0) break;
        next = HEAP8[(textIndex+1)];
        if (curr == '%'.charCodeAt(0)) {
          // Handle flags.
          var flagAlwaysSigned = false;
          var flagLeftAlign = false;
          var flagAlternative = false;
          var flagZeroPad = false;
          flagsLoop: while (1) {
            switch (next) {
              case '+'.charCodeAt(0):
                flagAlwaysSigned = true;
                break;
              case '-'.charCodeAt(0):
                flagLeftAlign = true;
                break;
              case '#'.charCodeAt(0):
                flagAlternative = true;
                break;
              case '0'.charCodeAt(0):
                if (flagZeroPad) {
                  break flagsLoop;
                } else {
                  flagZeroPad = true;
                  break;
                }
              default:
                break flagsLoop;
            }
            textIndex++;
            next = HEAP8[(textIndex+1)];
          }
  
          // Handle width.
          var width = 0;
          if (next == '*'.charCodeAt(0)) {
            width = getNextArg('i32');
            textIndex++;
            next = HEAP8[(textIndex+1)];
          } else {
            while (next >= '0'.charCodeAt(0) && next <= '9'.charCodeAt(0)) {
              width = width * 10 + (next - '0'.charCodeAt(0));
              textIndex++;
              next = HEAP8[(textIndex+1)];
            }
          }
  
          // Handle precision.
          var precisionSet = false;
          if (next == '.'.charCodeAt(0)) {
            var precision = 0;
            precisionSet = true;
            textIndex++;
            next = HEAP8[(textIndex+1)];
            if (next == '*'.charCodeAt(0)) {
              precision = getNextArg('i32');
              textIndex++;
            } else {
              while(1) {
                var precisionChr = HEAP8[(textIndex+1)];
                if (precisionChr < '0'.charCodeAt(0) ||
                    precisionChr > '9'.charCodeAt(0)) break;
                precision = precision * 10 + (precisionChr - '0'.charCodeAt(0));
                textIndex++;
              }
            }
            next = HEAP8[(textIndex+1)];
          } else {
            var precision = 6; // Standard default.
          }
  
          // Handle integer sizes. WARNING: These assume a 32-bit architecture!
          var argSize;
          switch (String.fromCharCode(next)) {
            case 'h':
              var nextNext = HEAP8[(textIndex+2)];
              if (nextNext == 'h'.charCodeAt(0)) {
                textIndex++;
                argSize = 1; // char
              } else {
                argSize = 2; // short
              }
              break;
            case 'l':
              var nextNext = HEAP8[(textIndex+2)];
              if (nextNext == 'l'.charCodeAt(0)) {
                textIndex++;
                argSize = 8; // long long
              } else {
                argSize = 4; // long
              }
              break;
            case 'L': // long long
            case 'q': // int64_t
            case 'j': // intmax_t
              argSize = 8;
              break;
            case 'z': // size_t
            case 't': // ptrdiff_t
            case 'I': // signed ptrdiff_t or unsigned size_t
              argSize = 4;
              break;
            default:
              argSize = undefined;
          }
          if (argSize !== undefined) textIndex++;
          next = HEAP8[(textIndex+1)];
  
          // Handle type specifier.
          if (['d', 'i', 'u', 'o', 'x', 'X', 'p'].indexOf(String.fromCharCode(next)) != -1) {
            // Integer.
            var signed = next == 'd'.charCodeAt(0) || next == 'i'.charCodeAt(0);
            argSize = argSize || 4;
            var currArg = getNextArg('i' + (argSize * 8));
            // Truncate to requested size.
            if (argSize <= 4) {
              var limit = Math.pow(256, argSize) - 1;
              currArg = (signed ? reSign : unSign)(currArg & limit, argSize * 8);
            }
            // Format the number.
            var currAbsArg = Math.abs(currArg);
            var argText;
            var prefix = '';
            if (next == 'd'.charCodeAt(0) || next == 'i'.charCodeAt(0)) {
              argText = reSign(currArg, 8 * argSize, 1).toString(10);
            } else if (next == 'u'.charCodeAt(0)) {
              argText = unSign(currArg, 8 * argSize, 1).toString(10);
              currArg = Math.abs(currArg);
            } else if (next == 'o'.charCodeAt(0)) {
              argText = (flagAlternative ? '0' : '') + currAbsArg.toString(8);
            } else if (next == 'x'.charCodeAt(0) || next == 'X'.charCodeAt(0)) {
              prefix = flagAlternative ? '0x' : '';
              if (currArg < 0) {
                // Represent negative numbers in hex as 2's complement.
                currArg = -currArg;
                argText = (currAbsArg - 1).toString(16);
                var buffer = [];
                for (var i = 0; i < argText.length; i++) {
                  buffer.push((0xF - parseInt(argText[i], 16)).toString(16));
                }
                argText = buffer.join('');
                while (argText.length < argSize * 2) argText = 'f' + argText;
              } else {
                argText = currAbsArg.toString(16);
              }
              if (next == 'X'.charCodeAt(0)) {
                prefix = prefix.toUpperCase();
                argText = argText.toUpperCase();
              }
            } else if (next == 'p'.charCodeAt(0)) {
              if (currAbsArg === 0) {
                argText = '(nil)';
              } else {
                prefix = '0x';
                argText = currAbsArg.toString(16);
              }
            }
            if (precisionSet) {
              while (argText.length < precision) {
                argText = '0' + argText;
              }
            }
  
            // Add sign if needed
            if (flagAlwaysSigned) {
              if (currArg < 0) {
                prefix = '-' + prefix;
              } else {
                prefix = '+' + prefix;
              }
            }
  
            // Add padding.
            while (prefix.length + argText.length < width) {
              if (flagLeftAlign) {
                argText += ' ';
              } else {
                if (flagZeroPad) {
                  argText = '0' + argText;
                } else {
                  prefix = ' ' + prefix;
                }
              }
            }
  
            // Insert the result into the buffer.
            argText = prefix + argText;
            argText.split('').forEach(function(chr) {
              ret.push(chr.charCodeAt(0));
            });
          } else if (['f', 'F', 'e', 'E', 'g', 'G'].indexOf(String.fromCharCode(next)) != -1) {
            // Float.
            var currArg = getNextArg(argSize === 4 ? 'float' : 'double');
            var argText;
  
            if (isNaN(currArg)) {
              argText = 'nan';
              flagZeroPad = false;
            } else if (!isFinite(currArg)) {
              argText = (currArg < 0 ? '-' : '') + 'inf';
              flagZeroPad = false;
            } else {
              var isGeneral = false;
              var effectivePrecision = Math.min(precision, 20);
  
              // Convert g/G to f/F or e/E, as per:
              // http://pubs.opengroup.org/onlinepubs/9699919799/functions/printf.html
              if (next == 'g'.charCodeAt(0) || next == 'G'.charCodeAt(0)) {
                isGeneral = true;
                precision = precision || 1;
                var exponent = parseInt(currArg.toExponential(effectivePrecision).split('e')[1], 10);
                if (precision > exponent && exponent >= -4) {
                  next = ((next == 'g'.charCodeAt(0)) ? 'f' : 'F').charCodeAt(0);
                  precision -= exponent + 1;
                } else {
                  next = ((next == 'g'.charCodeAt(0)) ? 'e' : 'E').charCodeAt(0);
                  precision--;
                }
                effectivePrecision = Math.min(precision, 20);
              }
  
              if (next == 'e'.charCodeAt(0) || next == 'E'.charCodeAt(0)) {
                argText = currArg.toExponential(effectivePrecision);
                // Make sure the exponent has at least 2 digits.
                if (/[eE][-+]\d$/.test(argText)) {
                  argText = argText.slice(0, -1) + '0' + argText.slice(-1);
                }
              } else if (next == 'f'.charCodeAt(0) || next == 'F'.charCodeAt(0)) {
                argText = currArg.toFixed(effectivePrecision);
              }
  
              var parts = argText.split('e');
              if (isGeneral && !flagAlternative) {
                // Discard trailing zeros and periods.
                while (parts[0].length > 1 && parts[0].indexOf('.') != -1 &&
                       (parts[0].slice(-1) == '0' || parts[0].slice(-1) == '.')) {
                  parts[0] = parts[0].slice(0, -1);
                }
              } else {
                // Make sure we have a period in alternative mode.
                if (flagAlternative && argText.indexOf('.') == -1) parts[0] += '.';
                // Zero pad until required precision.
                while (precision > effectivePrecision++) parts[0] += '0';
              }
              argText = parts[0] + (parts.length > 1 ? 'e' + parts[1] : '');
  
              // Capitalize 'E' if needed.
              if (next == 'E'.charCodeAt(0)) argText = argText.toUpperCase();
  
              // Add sign.
              if (flagAlwaysSigned && currArg >= 0) {
                argText = '+' + argText;
              }
            }
  
            // Add padding.
            while (argText.length < width) {
              if (flagLeftAlign) {
                argText += ' ';
              } else {
                if (flagZeroPad && (argText[0] == '-' || argText[0] == '+')) {
                  argText = argText[0] + '0' + argText.slice(1);
                } else {
                  argText = (flagZeroPad ? '0' : ' ') + argText;
                }
              }
            }
  
            // Adjust case.
            if (next < 'a'.charCodeAt(0)) argText = argText.toUpperCase();
  
            // Insert the result into the buffer.
            argText.split('').forEach(function(chr) {
              ret.push(chr.charCodeAt(0));
            });
          } else if (next == 's'.charCodeAt(0)) {
            // String.
            var arg = getNextArg('i8*');
            var copiedString;
            if (arg) {
              copiedString = String_copy(arg);
              if (precisionSet && copiedString.length > precision) {
                copiedString = copiedString.slice(0, precision);
              }
            } else {
              copiedString = intArrayFromString('(null)', true);
            }
            if (!flagLeftAlign) {
              while (copiedString.length < width--) {
                ret.push(' '.charCodeAt(0));
              }
            }
            ret = ret.concat(copiedString);
            if (flagLeftAlign) {
              while (copiedString.length < width--) {
                ret.push(' '.charCodeAt(0));
              }
            }
          } else if (next == 'c'.charCodeAt(0)) {
            // Character.
            if (flagLeftAlign) ret.push(getNextArg('i8'));
            while (--width > 0) {
              ret.push(' '.charCodeAt(0));
            }
            if (!flagLeftAlign) ret.push(getNextArg('i8'));
          } else if (next == 'n'.charCodeAt(0)) {
            // Write the length written so far to the next parameter.
            var ptr = getNextArg('i32*');
            HEAP32[((ptr)>>2)]=ret.length;
          } else if (next == '%'.charCodeAt(0)) {
            // Literal percent sign.
            ret.push(curr);
          } else {
            // Unknown specifiers remain untouched.
            for (var i = startTextIndex; i < textIndex + 2; i++) {
              ret.push(HEAP8[(i)]);
            }
          }
          textIndex += 2;
          // TODO: Support a/A (hex float) and m (last error) specifiers.
          // TODO: Support %1${specifier} for arg selection.
        } else {
          ret.push(curr);
          textIndex += 1;
        }
      }
      return ret;
    }function _fprintf(stream, format, varargs) {
      // int fprintf(FILE *restrict stream, const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      var result = __formatString(format, varargs);
      var stack = Runtime.stackSave();
      var ret = _fwrite(allocate(result, 'i8', ALLOC_STACK), 1, result.length, stream);
      Runtime.stackRestore(stack);
      return ret;
    }

  function _free(){}

  function _strlen(ptr) {
      return String_len(ptr);
    }

  function _strcpy(pdest, psrc) {
      var i = 0;
      do {
        var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = psrc+i;
  $dest$ = pdest+i;
  $stop$ = $src$ + 1;
  if (($dest$%4) == ($src$%4) && 1 > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  }
        i ++;
      } while (HEAP8[(psrc+i-1)] != 0);
      return pdest;
    }

  
  function _snprintf(s, n, format, varargs) {
      // int snprintf(char *restrict s, size_t n, const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      var result = __formatString(format, varargs);
      var limit = (n === undefined) ? result.length
                                    : Math.min(result.length, n - 1);
      for (var i = 0; i < limit; i++) {
        HEAP8[(s+i)]=result[i];;
      }
      HEAP8[(s+i)]=0;;
      return result.length;
    }function _sprintf(s, format, varargs) {
      // int sprintf(char *restrict s, const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      return _snprintf(s, undefined, format, varargs);
    }

  
  function _fputc(c, stream) {
      // int fputc(int c, FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fputc.html
      var chr = unSign(c & 0xFF);
      HEAP8[(_fputc.ret)]=chr;
      var ret = _write(stream, _fputc.ret, 1);
      if (ret == -1) {
        if (stream in FS.streams) FS.streams[stream].error = true;
        return -1;
      } else {
        return chr;
      }
    }

  
  function __scanString(format, get, unget, varargs) {
      // Supports %x, %4x, %d.%d, %s.
      // TODO: Support all format specifiers.
      format = Pointer_stringify(format);
      var formatIndex = 0;
      var argsi = 0;
      var fields = 0;
      var argIndex = 0;
      for (var formatIndex = 0; formatIndex < format.length; formatIndex++) {
        if (next <= 0) return fields;
        var next = get();
        if (next <= 0) return fields;  // End of input.
        if (format[formatIndex] === '%') {
          formatIndex++;
          var maxSpecifierStart = formatIndex;
          while (format[formatIndex].charCodeAt(0) >= '0'.charCodeAt(0) &&
                 format[formatIndex].charCodeAt(0) <= '9'.charCodeAt(0)) {
            formatIndex++;
          }
          var max_;
          if (formatIndex != maxSpecifierStart) {
            max_ = parseInt(format.slice(maxSpecifierStart, formatIndex), 10);
          }
          // TODO: Handle type size modifier.
          var type = format[formatIndex];
          formatIndex++;
          var curr = 0;
          var buffer = [];
          while ((curr < max_ || isNaN(max_)) && next > 0) {
            if ((type === 'd' && next >= '0'.charCodeAt(0) && next <= '9'.charCodeAt(0)) ||
                (type === 'x' && (next >= '0'.charCodeAt(0) && next <= '9'.charCodeAt(0) ||
                                  next >= 'a'.charCodeAt(0) && next <= 'f'.charCodeAt(0) ||
                                  next >= 'A'.charCodeAt(0) && next <= 'F'.charCodeAt(0))) ||
                (type === 's') &&
                (formatIndex >= format.length || next !== format[formatIndex].charCodeAt(0))) { // Stop when we read something that is coming up
              buffer.push(String.fromCharCode(next));
              next = get();
              curr++;
            } else {
              break;
            }
          }
          if (buffer.length === 0) return 0;  // Failure.
          var text = buffer.join('');
          var argPtr = HEAP32[((varargs+argIndex)>>2)];
          argIndex += Runtime.getNativeFieldSize('void*');
          switch (type) {
            case 'd':
              HEAP32[((argPtr)>>2)]=parseInt(text, 10);
              break;
            case 'x':
              HEAP32[((argPtr)>>2)]=parseInt(text, 16);
              break;
            case 's':
              var array = intArrayFromString(text);
              for (var j = 0; j < array.length; j++) {
                HEAP8[(argPtr+j)]=array[j];
              }
              break;
          }
          fields++;
        } else {
          // Not a specifier.
          if (format[formatIndex].charCodeAt(0) !== next) {
            unget(next);
            return fields;
          }
        }
      }
      return fields;
    }function _sscanf(s, format, varargs) {
      // int sscanf(const char *restrict s, const char *restrict format, ... );
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/scanf.html
      var index = 0;
      var get = function() { return HEAP8[(s+index++)]; };
      var unget = function() { index--; };
      return __scanString(format, get, unget, varargs);
    }

  function _printf(format, varargs) {
      // int printf(const char *restrict format, ...);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/printf.html
      var stdout = HEAP32[((_stdout)>>2)];
      return _fprintf(stdout, format, varargs);
    }

  
  function __exit(status) {
      // void _exit(int status);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/exit.html
      __shutdownRuntime__();
      ABORT = true;
      throw 'exit(' + status + ') called, at ' + new Error().stack;
    }function _exit(status) {
      __exit(status);
    }

  
  function _isspace(chr) {
      return chr in { 32: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0 };
    }
  
  function _isdigit(chr) {
      return chr >= '0'.charCodeAt(0) && chr <= '9'.charCodeAt(0);
    }function _atoi(s) {
      var c;
      while ((c = HEAP8[(s)]) && _isspace(c)) s++;
      if (!c || !_isdigit(c)) return 0;
      var e = s;
      while ((c = HEAP8[(e)]) && _isdigit(c)) e++;
      return Math.floor(Number(Pointer_stringify(s).substr(0, e-s)));
    }

  
  
  
  
  
  
  
  
  var ___dirent_struct_layout={__size__: 1040, d_ino: 0, d_name: 4, d_off: 1028, d_reclen: 1032, d_type: 1036 };function _open(path, oflag, varargs) {
      // int open(const char *path, int oflag, ...);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/open.html
      // NOTE: This implementation tries to mimic glibc rather that strictly
      // following the POSIX standard.
  
      var mode = HEAP32[((varargs)>>2)];
  
      // Simplify flags.
      var accessMode = oflag & 3;
      var isWrite = accessMode != 0;
      var isRead = accessMode != 1;
      var isCreate = Boolean(oflag & 512);
      var isExistCheck = Boolean(oflag & 2048);
      var isTruncate = Boolean(oflag & 1024);
      var isAppend = Boolean(oflag & 8);
  
      // Verify path.
      var origPath = path;
      path = FS.analyzePath(Pointer_stringify(path));
      if (!path.parentExists) {
        ___setErrNo(path.error);
        return -1;
      }
      var target = path.object || null;
      var finalPath;
  
      // Verify the file exists, create if needed and allowed.
      if (target) {
        if (isCreate && isExistCheck) {
          ___setErrNo(ERRNO_CODES.EEXIST);
          return -1;
        }
        if ((isWrite || isCreate || isTruncate) && target.isFolder) {
          ___setErrNo(ERRNO_CODES.EISDIR);
          return -1;
        }
        if (isRead && !target.read || isWrite && !target.write) {
          ___setErrNo(ERRNO_CODES.EACCES);
          return -1;
        }
        if (isTruncate && !target.isDevice) {
          target.contents = [];
        } else {
          if (!FS.forceLoadFile(target)) {
            ___setErrNo(ERRNO_CODES.EIO);
            return -1;
          }
        }
        finalPath = path.path;
      } else {
        if (!isCreate) {
          ___setErrNo(ERRNO_CODES.ENOENT);
          return -1;
        }
        if (!path.parentObject.write) {
          ___setErrNo(ERRNO_CODES.EACCES);
          return -1;
        }
        target = FS.createDataFile(path.parentObject, path.name, [],
                                   mode & 0x100, mode & 0x80);  // S_IRUSR, S_IWUSR.
        finalPath = path.parentPath + '/' + path.name;
      }
      // Actually create an open stream.
      var id = FS.streams.length;
      if (target.isFolder) {
        var entryBuffer = 0;
        if (___dirent_struct_layout) {
          entryBuffer = _malloc(___dirent_struct_layout.__size__);
        }
        var contents = [];
        for (var key in target.contents) contents.push(key);
        FS.streams[id] = {
          path: finalPath,
          object: target,
          // An index into contents. Special values: -2 is ".", -1 is "..".
          position: -2,
          isRead: true,
          isWrite: false,
          isAppend: false,
          error: false,
          eof: false,
          ungotten: [],
          // Folder-specific properties:
          // Remember the contents at the time of opening in an array, so we can
          // seek between them relying on a single order.
          contents: contents,
          // Each stream has its own area for readdir() returns.
          currentEntry: entryBuffer
        };
      } else {
        FS.streams[id] = {
          path: finalPath,
          object: target,
          position: 0,
          isRead: isRead,
          isWrite: isWrite,
          isAppend: isAppend,
          error: false,
          eof: false,
          ungotten: []
        };
      }
      return id;
    }function _fopen(filename, mode) {
      // FILE *fopen(const char *restrict filename, const char *restrict mode);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fopen.html
      var flags;
      mode = Pointer_stringify(mode);
      if (mode[0] == 'r') {
        if (mode.indexOf('+') != -1) {
          flags = 2;
        } else {
          flags = 0;
        }
      } else if (mode[0] == 'w') {
        if (mode.indexOf('+') != -1) {
          flags = 2;
        } else {
          flags = 1;
        }
        flags |= 512;
        flags |= 1024;
      } else if (mode[0] == 'a') {
        if (mode.indexOf('+') != -1) {
          flags = 2;
        } else {
          flags = 1;
        }
        flags |= 512;
        flags |= 8;
      } else {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return 0;
      }
      var ret = _open(filename, flags, allocate([0x1FF, 0, 0, 0], 'i32', ALLOC_STACK));  // All creation permissions.
      return (ret == -1) ? 0 : ret;
    }

  
  function _memset(ptr, value, num) {
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
  $dest$ = ptr;
  $stop$ = $dest$ + num;
  $value4$ = value;
  if ($value4$ < 0) $value4$ += 256;
  $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
  while ($dest$%4 !== 0 && $dest$ < $stop$) {
    ;; HEAP8[$dest$++] = value;
  }
  $dest$ >>= 2;
  $stop4$ = $stop$ >> 2;
  while ($dest$ < $stop4$) {
  ;;;;;;;  HEAP32[$dest$++] = $value4$;
  }
  $dest$ <<= 2;
  while ($dest$ < $stop$) {
    ;; HEAP8[$dest$++] = value;
  }
    }var _llvm_memset_p0i8_i32=_memset;

  function _strrchr(ptr, chr) {
      var ptr2 = ptr + _strlen(ptr);
      do {
        if (HEAP8[(ptr2)] == chr) return ptr2;
        ptr2--;
      } while (ptr2 >= ptr);
      return 0;
    }

  
  
  
  function _close(fildes) {
      // int close(int fildes);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/close.html
      if (FS.streams[fildes]) {
        if (FS.streams[fildes].currentEntry) {
          _free(FS.streams[fildes].currentEntry);
        }
        delete FS.streams[fildes];
        return 0;
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }
  
  
  
  function _fsync(fildes) {
      // int fsync(int fildes);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fsync.html
      if (FS.streams[fildes]) {
        // We write directly to the file system, so there's nothing to do here.
        return 0;
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }function _fclose(stream) {
      // int fclose(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fclose.html
      _fsync(stream);
      return _close(stream);
    }

  
  
  function _fflush(stream) {
      // int fflush(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fflush.html
      var flush = function(filedes) {
        // Right now we write all data directly, except for output devices.
        if (filedes in FS.streams && FS.streams[filedes].object.output) {
          FS.streams[filedes].object.output(null);
        }
      };
      try {
        if (stream === 0) {
          for (var i in FS.streams) flush(i);
        } else {
          flush(stream);
        }
        return 0;
      } catch (e) {
        ___setErrNo(ERRNO_CODES.EIO);
        return -1;
      }
    }

  
  
  function _ftell(stream) {
      // long ftell(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/ftell.html
      if (stream in FS.streams) {
        stream = FS.streams[stream];
        if (stream.object.isDevice) {
          ___setErrNo(ERRNO_CODES.ESPIPE);
          return -1;
        } else {
          return stream.position;
        }
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }

  
  
  
  
  function _lseek(fildes, offset, whence) {
      // off_t lseek(int fildes, off_t offset, int whence);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/lseek.html
      if (FS.streams[fildes] && !FS.streams[fildes].isDevice) {
        var stream = FS.streams[fildes];
        var position = offset;
        if (whence === 1) {  // SEEK_CUR.
          position += stream.position;
        } else if (whence === 2) {  // SEEK_END.
          position += stream.object.contents.length;
        }
        if (position < 0) {
          ___setErrNo(ERRNO_CODES.EINVAL);
          return -1;
        } else {
          stream.ungotten = [];
          stream.position = position;
          return position;
        }
      } else {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
    }function _fseek(stream, offset, whence) {
      // int fseek(FILE *stream, long offset, int whence);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fseek.html
      var ret = _lseek(stream, offset, whence);
      if (ret == -1) {
        return -1;
      } else {
        FS.streams[stream].eof = false;
        return 0;
      }
    }


  
  function _strncmp(px, py, n) {
      var i = 0;
      while (i < n) {
        var x = HEAP8[(px+i)];
        var y = HEAP8[(py+i)];
        if (x == y && x == 0) return 0;
        if (x == 0) return -1;
        if (y == 0) return 1;
        if (x == y) {
          i ++;
          continue;
        } else {
          return x > y ? 1 : -1;
        }
      }
      return 0;
    }function _strcmp(px, py) {
      return _strncmp(px, py, TOTAL_MEMORY);
    }

  function _setlocale(category, locale) {
      if (!_setlocale.ret) _setlocale.ret = allocate([0], 'i8', ALLOC_NORMAL);
      return _setlocale.ret;
    }

  
  
  
  var _environ=null;
  
  var ___environ=null;function ___buildEnvironment(env) {
      // WARNING: Arbitrary limit!
      var MAX_ENV_VALUES = 64;
      var TOTAL_ENV_SIZE = 1024;
  
      // Statically allocate memory for the environment.
      var poolPtr;
      var envPtr;
      if (_environ === null) {
        // Set default values. Use string keys for Closure Compiler compatibility.
        ENV.USER = 'root';
        ENV.PATH = '/';
        ENV.PWD = '/';
        ENV.HOME = '/';
        ENV.LANG = 'en_US.UTF-8';
        ENV._ = './this.program';
        // Allocate memory.
        poolPtr = allocate(TOTAL_ENV_SIZE, 'i8', ALLOC_STATIC);
        envPtr = allocate(MAX_ENV_VALUES * 4,
                          'i8*', ALLOC_STATIC);
        HEAP32[((envPtr)>>2)]=poolPtr;
        _environ = allocate([envPtr], 'i8**', ALLOC_STATIC);
        // Set up global variable alias.
        ___environ = _environ;
      } else {
        envPtr = HEAP32[((_environ)>>2)];
        poolPtr = HEAP32[((envPtr)>>2)];
      }
  
      // Collect key=value lines.
      var strings = [];
      var totalSize = 0;
      for (var key in env) {
        if (typeof env[key] === 'string') {
          var line = key + '=' + env[key];
          strings.push(line);
          totalSize += line.length;
        }
      }
      if (totalSize > TOTAL_ENV_SIZE) {
        throw new Error('Environment size exceeded TOTAL_ENV_SIZE!');
      }
  
      // Make new.
      var ptrSize = 4;
      for (var i = 0; i < strings.length; i++) {
        var line = strings[i];
        for (var j = 0; j < line.length; j++) {
          HEAP8[(poolPtr+j)]=line.charCodeAt(j);
        }
        HEAP8[(poolPtr+j)]=0;
        HEAP32[((envPtr+i * ptrSize)>>2)]=poolPtr;
        poolPtr += line.length + 1;
      }
      HEAP32[((envPtr+strings.length * ptrSize)>>2)]=0;
    }var ENV={ };function _getenv(name) {
      // char *getenv(const char *name);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/getenv.html
      if (name === 0) return 0;
      name = Pointer_stringify(name);
      if (!ENV.hasOwnProperty(name)) return 0;
  
      if (_getenv.ret) _free(_getenv.ret);
      _getenv.ret = allocate(intArrayFromString(ENV[name]), 'i8', ALLOC_NORMAL);
      return _getenv.ret;
    }


  
  
  function _access(path, amode) {
      // int access(const char *path, int amode);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/access.html
      path = Pointer_stringify(path);
      var target = FS.findObject(path);
      if (target === null) return -1;
      if ((amode & 2 && !target.write) ||  // W_OK.
          ((amode & 1 || amode & 4) && !target.read)) {  // X_OK, R_OK.
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else {
        return 0;
      }
    }

  function _strcat(pdest, psrc) {
      var len = _strlen(pdest);
      var i = 0;
      do {
        var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = psrc+i;
  $dest$ = pdest+len+i;
  $stop$ = $src$ + 1;
  if (($dest$%4) == ($src$%4) && 1 > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  }
        i ++;
      } while (HEAP8[(psrc+i-1)] != 0);
      return pdest;
    }

  
  
  
  
  
  
  
  
  
  function _pread(fildes, buf, nbyte, offset) {
      // ssize_t pread(int fildes, void *buf, size_t nbyte, off_t offset);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/read.html
      var stream = FS.streams[fildes];
      if (!stream || stream.object.isDevice) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isRead) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (stream.object.isFolder) {
        ___setErrNo(ERRNO_CODES.EISDIR);
        return -1;
      } else if (nbyte < 0 || offset < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        var bytesRead = 0;
        while (stream.ungotten.length && nbyte > 0) {
          HEAP8[(buf++)]=stream.ungotten.pop();
          nbyte--;
          bytesRead++;
        }
        var contents = stream.object.contents;
        var size = Math.min(contents.length - offset, nbyte);
        for (var i = 0; i < size; i++) {
          HEAP8[(buf+i)]=contents[offset + i];
          bytesRead++;
        }
        return bytesRead;
      }
    }function _read(fildes, buf, nbyte) {
      // ssize_t read(int fildes, void *buf, size_t nbyte);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/read.html
      var stream = FS.streams[fildes];
      if (!stream) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (!stream.isRead) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (nbyte < 0) {
        ___setErrNo(ERRNO_CODES.EINVAL);
        return -1;
      } else {
        var bytesRead;
        if (stream.object.isDevice) {
          if (stream.object.input) {
            bytesRead = 0;
            while (stream.ungotten.length && nbyte > 0) {
              HEAP8[(buf++)]=stream.ungotten.pop();
              nbyte--;
              bytesRead++;
            }
            for (var i = 0; i < nbyte; i++) {
              try {
                var result = stream.object.input();
              } catch (e) {
                ___setErrNo(ERRNO_CODES.EIO);
                return -1;
              }
              if (result === null || result === undefined) break;
              bytesRead++;
              HEAP8[(buf+i)]=result;
            }
            return bytesRead;
          } else {
            ___setErrNo(ERRNO_CODES.ENXIO);
            return -1;
          }
        } else {
          var ungotSize = stream.ungotten.length;
          bytesRead = _pread(fildes, buf, nbyte, stream.position);
          if (bytesRead != -1) {
            stream.position += (stream.ungotten.length - ungotSize) + bytesRead;
          }
          return bytesRead;
        }
      }
    }function _fgetc(stream) {
      // int fgetc(FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fgetc.html
      if (!(stream in FS.streams)) return -1;
      var streamObj = FS.streams[stream];
      if (streamObj.eof || streamObj.error) return -1;
      var ret = _read(stream, _fgetc.ret, 1);
      if (ret == 0) {
        streamObj.eof = true;
        return -1;
      } else if (ret == -1) {
        streamObj.error = true;
        return -1;
      } else {
        return HEAP8[(_fgetc.ret)];
      }
    }function _fgets(s, n, stream) {
      // char *fgets(char *restrict s, int n, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fgets.html
      if (!(stream in FS.streams)) return 0;
      var streamObj = FS.streams[stream];
      if (streamObj.error || streamObj.eof) return 0;
      var byte_;
      for (var i = 0; i < n - 1 && byte_ != '\n'.charCodeAt(0); i++) {
        byte_ = _fgetc(stream);
        if (byte_ == -1) {
          if (streamObj.error) return 0;
          else if (streamObj.eof) break;
        }
        HEAP8[(s+i)]=byte_;
      }
      HEAP8[(s+i)]=0;
      return s;
    }

  function _strstr(ptr1, ptr2) {
      var str1 = Pointer_stringify(ptr1);
      var str2 = Pointer_stringify(ptr2);
      var ret = str1.search(str2);
      return ret >= 0 ? ptr1 + ret : 0;
    }

  function _memcmp(p1, p2, num) {
      for (var i = 0; i < num; i++) {
        var v1 = HEAP8[(p1+i)];
        var v2 = HEAP8[(p2+i)];
        if (v1 != v2) return v1 > v2 ? 1 : -1;
      }
      return 0;
    }

  
  function _memcpy(dest, src, num, idunno) {
      var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = src;
  $dest$ = dest;
  $stop$ = $src$ + num;
  if (($dest$%4) == ($src$%4) && num > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  };
    }function _qsort(base, num, size, comparator) {
      if (num == 0 || size == 0) return;
      // forward calls to the JavaScript sort method
      // first, sort the items logically
      comparator = FUNCTION_TABLE[comparator];
      var keys = [];
      for (var i = 0; i < num; i++) keys.push(i);
      keys.sort(function(a, b) {
        return comparator(base+a*size, base+b*size);
      });
      // apply the sort
      var temp = _malloc(num*size);
      _memcpy(temp, base, num*size);
      for (var i = 0; i < num; i++) {
        if (keys[i] == i) continue; // already in place
        _memcpy(base+i*size, temp+keys[i]*size, size);
      }
      _free(temp);
    }


  
  
  
  function _unlink(path) {
      // int unlink(const char *path);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/unlink.html
      path = FS.analyzePath(Pointer_stringify(path));
      if (!path.parentExists || !path.exists) {
        ___setErrNo(path.error);
        return -1;
      } else if (path.object.isFolder) {
        ___setErrNo(ERRNO_CODES.EISDIR);
        return -1;
      } else if (!path.object.write) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else {
        delete path.parentObject.contents[path.name];
        return 0;
      }
    }
  
  
  
  function _rmdir(path) {
      // int rmdir(const char *path);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/rmdir.html
      path = FS.analyzePath(Pointer_stringify(path));
      if (!path.parentExists || !path.exists) {
        ___setErrNo(path.error);
        return -1;
      } else if (!path.object.write || path.isRoot) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return -1;
      } else if (!path.object.isFolder) {
        ___setErrNo(ERRNO_CODES.ENOTDIR);
        return -1;
      } else {
        for (var i in path.object.contents) {
          ___setErrNo(ERRNO_CODES.ENOTEMPTY);
          return -1;
        }
        if (path.path == FS.currentPath) {
          ___setErrNo(ERRNO_CODES.EBUSY);
          return -1;
        } else {
          delete path.parentObject.contents[path.name];
          return 0;
        }
      }
    }function _remove(path) {
      // int remove(const char *path);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/remove.html
      var ret = _unlink(path);
      if (ret == -1) ret = _rmdir(path);
      return ret;
    }

  var _llvm_memcpy_p0i8_p0i8_i32=_memcpy;

  function _isalnum(chr) {
      return (chr >= '0'.charCodeAt(0) && chr <= '9'.charCodeAt(0)) ||
             (chr >= 'a'.charCodeAt(0) && chr <= 'z'.charCodeAt(0)) ||
             (chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0));
    }

// added support for unicode basic latin + latin-1 supplement; mass:werk, N.L. 2014
  function _isalnum(chr) {
      return (chr >= 48 && chr <= 57) ||       // 0 .. 9
             (chr >= 97 && chr <= 122) ||      // a .. z
             (chr >= 65 && chr <= 90) ||       // A .. Z
             (chr >= 0xC0 && chr <= 0xD6) ||   // � .. �
             (chr >= 0xDF && chr <= 0xF6) ||   // � .. �
             (chr >= 0xD8 && chr <= 0xDE) ||   // � .. �
             (chr >= 0xF8 && chr <= 0xFF);     // � .. �
    }
// end of batch

  function _strchr(ptr, chr) {
      ptr--;
      do {
        ptr++;
        var val = HEAP8[(ptr)];
        if (val == chr) return ptr;
      } while (val);
      return 0;
    }

  function _strncpy(pdest, psrc, num) {
      var padding = false, curr;
      for (var i = 0; i < num; i++) {
        curr = padding ? 0 : HEAP8[(psrc+i)];
        HEAP8[(pdest+i)]=curr;
        padding = padding || HEAP8[(psrc+i)] == 0;
      }
      return pdest;
    }

  
  function _fread(ptr, size, nitems, stream) {
      // size_t fread(void *restrict ptr, size_t size, size_t nitems, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fread.html
      var bytesToRead = nitems * size;
      if (bytesToRead == 0) return 0;
      var bytesRead = _read(stream, ptr, bytesToRead);
      var streamObj = FS.streams[stream];
      if (bytesRead == -1) {
        if (streamObj) streamObj.error = true;
        return -1;
      } else {
        if (bytesRead < bytesToRead) streamObj.eof = true;
        return Math.floor(bytesRead / size);
      }
    }


  function _tolower(chr) {
      if (chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0)) {
        return chr - 'A'.charCodeAt(0) + 'a'.charCodeAt(0);
      } else {
        return chr;
      }
    }

  function _isalpha(chr) {
      return (chr >= 'a'.charCodeAt(0) && chr <= 'z'.charCodeAt(0)) ||
             (chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0));
    }

  function _isupper(chr) {
      return chr >= 'A'.charCodeAt(0) && chr <= 'Z'.charCodeAt(0);
    }

  function _islower(chr) {
      return chr >= 'a'.charCodeAt(0) && chr <= 'z'.charCodeAt(0);
    }

  function _ispunct(chr) {
      return (chr >= '!'.charCodeAt(0) && chr <= '/'.charCodeAt(0)) ||
             (chr >= ':'.charCodeAt(0) && chr <= '@'.charCodeAt(0)) ||
             (chr >= '['.charCodeAt(0) && chr <= '`'.charCodeAt(0)) ||
             (chr >= '{'.charCodeAt(0) && chr <= '~'.charCodeAt(0));
    }

// added support for unicode basic latin + latin-1 supplement; mass:werk, N.L. 2014
  function _tolower(chr) {
      if ((chr >= 65 && chr <90) ||
          (chr >= 0xC0 && chr <= 0xD6) ||
          (chr >= 0xD8 && chr <= 0xDE)) return chr - 65 + 97;
      return chr;
    }

  function _isalpha(chr) {
      return (chr >= 97 && chr <= 122) ||      // a .. z
             (chr >= 65 && chr <= 90) ||       // A .. Z
             (chr >= 0xC0 && chr <= 0xD6) ||   // � .. �
             (chr >= 0xDF && chr <= 0xF6) ||   // � .. �
             (chr >= 0xD8 && chr <= 0xDE) ||   // � .. �
             (chr >= 0xF8 && chr <= 0xFF);     // � .. �
    }

  function _isupper(chr) {
      return (chr >= 65 && chr <= 90) ||       // A .. Z
             (chr >= 0xC0 && chr <= 0xD6) ||   // � .. �
             (chr >= 0xD8 && chr <= 0xDE);     // � .. �
    }

  function _islower(chr) {
      return (chr >= 97 && chr <= 122) ||      // a .. z
             (chr >= 0xDF && chr <= 0xF6) ||   // � .. �
             (chr >= 0xF8 && chr <= 0xFF);     // � .. �
    }

  function _ispunct(chr) {
      return (chr >= 33 && chr <= 47) ||       // ! .. /
             (chr >= 58 && chr <= 64) ||       // : .. @
             (chr >= 91 && chr <= 96) ||       // [ .. `
             (chr >= 123 && chr <= 126);       // { .. ~
    }
// end of batch

var _atof; // stub for _atof

  function _realloc(ptr, size) {
      // Very simple, inefficient implementation - if you use a real malloc, best to use
      // a real realloc with it
      if (!size) {
        if (ptr) _free(ptr);
        return 0;
      }
      var ret = _malloc(size);
      if (ptr) {
        _memcpy(ret, ptr, size); // might be some invalid reads
        _free(ptr);
      }
      return ret;
    }
var _mkstemp; // stub for _mkstemp


  
  function _system(command) {
      // int system(const char *command);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/system.html
      // Can't call external programs.
      ___setErrNo(ERRNO_CODES.EAGAIN);
      return -1;
    }

  function _ungetc(c, stream) {
      // int ungetc(int c, FILE *stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/ungetc.html
      if (stream in FS.streams) {
        c = unSign(c & 0xFF);
        FS.streams[stream].ungotten.push(c);
        return c;
      } else {
        return -1;
      }
    }

  function _strdup(ptr) {
      var len = String_len(ptr);
      var newStr = _malloc(len + 1);
      var $src$, $dest$, $stop$, $stop4$, $fast$;
  $src$ = ptr;
  $dest$ = newStr;
  $stop$ = $src$ + len;
  if (($dest$%4) == ($src$%4) && len > 8) {
    while ($src$%4 !== 0 && $src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }
    $src$ >>= 2;
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($src$ < $stop4$) {
  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
    }
    $src$ <<= 2;
    $dest$ <<= 2;
  }while ($src$ < $stop$) {
    ; HEAP8[$dest$++] = HEAP8[$src$++];
  };
      HEAP8[(newStr+len)]=0;;
      return newStr;
    }

  
  function _kill(pid, sig) {
      // int kill(pid_t pid, int sig);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/kill.html
      // Makes no sense in a single-process environment.
      ___setErrNo(ERRNO_CODES.EPERM);
      return -1;
    }



  
  function ___errno_location() {
      return ___setErrNo.ret;
    }
  var ___errno=___errno_location;

  
  
  
  var ERRNO_MESSAGES={1: "Operation not permitted", 2: "No such file or directory", 3: "No such process", 4: "Interrupted system call", 5: "Input/output error", 6: "No such device or address", 8: "Exec format error", 9: "Bad file descriptor", 10: "No child processes", 11: "Resource temporarily unavailable", 12: "Cannot allocate memory", 13: "Permission denied", 14: "Bad address", 16: "Device or resource busy", 17: "File exists", 18: "Invalid cross-device link", 19: "No such device", 20: "Not a directory", 21: "Is a directory", 22: "Invalid argument", 23: "Too many open files in system", 24: "Too many open files", 25: "Inappropriate ioctl for device", 26: "Text file busy", 27: "File too large", 28: "No space left on device", 29: "Illegal seek", 30: "Read-only file system", 31: "Too many links", 32: "Broken pipe", 33: "Numerical argument out of domain", 34: "Numerical result out of range", 35: "Resource deadlock avoided", 36: "File name too long", 37: "No locks available", 38: "Function not implemented", 39: "Directory not empty", 40: "Too many levels of symbolic links", 42: "No message of desired type", 43: "Identifier removed", 60: "Device not a stream", 61: "No data available", 62: "Timer expired", 63: "Out of streams resources", 67: "Link has been severed", 71: "Protocol error", 72: "Multihop attempted", 74: "Bad message", 75: "Value too large for defined data type", 84: "Invalid or incomplete multibyte or wide character", 88: "Socket operation on non-socket", 89: "Destination address required", 90: "Message too long", 91: "Protocol wrong type for socket", 92: "Protocol not available", 93: "Protocol not supported", 95: "Operation not supported", 97: "Address family not supported by protocol", 98: "Address already in use", 99: "Cannot assign requested address", 100: "Network is down", 101: "Network is unreachable", 102: "Network dropped connection on reset", 103: "Software caused connection abort", 104: "Connection reset by peer", 105: "No buffer space available", 106: "Transport endpoint is already connected", 107: "Transport endpoint is not connected", 110: "Connection timed out", 111: "Connection refused", 113: "No route to host", 114: "Operation already in progress", 115: "Operation now in progress", 116: "Stale NFS file handle", 122: "Disk quota exceeded", 125: "Operation canceled", 130: "Owner died", 131: "State not recoverable" };
  function _strerror_r(errnum, strerrbuf, buflen) {
      if (errnum in ERRNO_MESSAGES) {
        if (ERRNO_MESSAGES[errnum].length > buflen - 1) {
          return ___setErrNo(ERRNO_CODES.ERANGE);
        } else {
          var msg = ERRNO_MESSAGES[errnum];
          for (var i = 0; i < msg.length; i++) {
            HEAP8[(strerrbuf+i)]=msg.charCodeAt(i);
          }
          HEAP8[(strerrbuf+i)]=0;
          return 0;
        }
      } else {
        return ___setErrNo(ERRNO_CODES.EINVAL);
      }
    }function _strerror(errnum) {
      if (!_strerror.buffer) _strerror.buffer = _malloc(256);
      _strerror_r(errnum, _strerror.buffer, 256);
      return _strerror.buffer;
    }


  
  function _memmove(dest, src, num, idunno) {
      // not optimized!
      if (num === 0) return; // will confuse malloc if 0
      var tmp = _malloc(num);
      _memcpy(tmp, src, num);
      _memcpy(dest, tmp, num);
      _free(tmp);
    }
  var _llvm_memmove_p0i8_p0i8_i32=_memmove;
var _llvm_va_start; // stub for _llvm_va_start

  
  
  var _vfprintf=_fprintf;

  function _llvm_va_end() {}

  
  
  function _wait(stat_loc) {
      // pid_t wait(int *stat_loc);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/wait.html
      // Makes no sense in a single-process environment.
      ___setErrNo(ERRNO_CODES.ECHILD);
      return -1;
    }
  
  var _waitpid=_wait;

  
  var _vsnprintf=_snprintf;

  
  
  var ___pollfd_struct_layout=null;function _poll(fds, nfds, timeout) {
      // int poll(struct pollfd fds[], nfds_t nfds, int timeout);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/poll.html
      // NOTE: This is pretty much a no-op mimicing glibc.
      var offsets = ___pollfd_struct_layout;
      var nonzero = 0;
      for (var i = 0; i < nfds; i++) {
        var pollfd = fds + ___pollfd_struct_layout.__size__ * i;
        var fd = HEAP32[((pollfd+offsets.fd)>>2)];
        var events = HEAP16[((pollfd+offsets.events)>>1)];
        var revents = 0;
        if (fd in FS.streams) {
          var stream = FS.streams[fd];
          if (events & 1) revents |= 1;
          if (events & 2) revents |= 2;
        } else {
          if (events & 4) revents |= 4;
        }
        if (revents) nonzero++;
        HEAP16[((pollfd+offsets.revents)>>1)]=revents;
      }
      return nonzero;
    }


  function _memchr(ptr, chr, num) {
      chr = unSign(chr);
      for (var i = 0; i < num; i++) {
        if (HEAP8[(ptr)] == chr) return ptr;
        ptr++;
      }
      return 0;
    }

  
  function _fork() {
      // pid_t fork(void);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fork.html
      // We don't support multiple processes.
      ___setErrNo(ERRNO_CODES.EAGAIN);
      return -1;
    }

  
  
  
  
  
  
  
  
  var ___flock_struct_layout=null;function _fcntl(fildes, cmd, varargs) {
      // int fcntl(int fildes, int cmd, ...);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/fcntl.html
      if (!(fildes in FS.streams)) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      }
      var stream = FS.streams[fildes];
      switch (cmd) {
        case 0:
          var arg = HEAP32[((varargs)>>2)];
          if (arg < 0) {
            ___setErrNo(ERRNO_CODES.EINVAL);
            return -1;
          }
          var newStream = {};
          for (var member in stream) {
            newStream[member] = stream[member];
          }
          if (arg in FS.streams) arg = FS.streams.length;
          FS.streams[arg] = newStream;
          return arg;
        case 1:
        case 2:
          return 0;  // FD_CLOEXEC makes no sense for a single process.
        case 3:
          var flags = 0;
          if (stream.isRead && stream.isWrite) flags = 2;
          else if (!stream.isRead && stream.isWrite) flags = 1;
          else if (stream.isRead && !stream.isWrite) flags = 0;
          if (stream.isAppend) flags |= 8;
          // Synchronization and blocking flags are irrelevant to us.
          return flags;
        case 4:
          var arg = HEAP32[((varargs)>>2)];
          stream.isAppend = Boolean(arg | 8);
          // Synchronization and blocking flags are irrelevant to us.
          return 0;
        case 7:
        case 20:
          var arg = HEAP32[((varargs)>>2)];
          var offset = ___flock_struct_layout.l_type;
          // We're always unlocked.
          HEAP16[((arg+offset)>>1)]=3;
          return 0;
        case 8:
        case 9:
        case 21:
        case 22:
          // Pretend that the locking is successful.
          return 0;
        case 6:
        case 5:
          // These are for sockets. We don't have them implemented (yet?).
          ___setErrNo(ERRNO_CODES.EINVAL);
          return -1;
        default:
          ___setErrNo(ERRNO_CODES.EINVAL);
          return -1;
      }
      // Should never be reached. Only to silence strict warnings.
      return -1;
    }
  function _dup2(fildes, fildes2) {
      // int dup2(int fildes, int fildes2);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/dup.html
      if (fildes2 < 0) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return -1;
      } else if (fildes === fildes2 && FS.streams[fildes]) {
        return fildes;
      } else {
        _close(fildes2);
        return _fcntl(fildes, 0, allocate([fildes2, 0, 0, 0], 'i32', ALLOC_STACK));  // F_DUPFD.
      }
    }


  function _signal(sig, func) {
      // TODO
      return 0;
    }

  
  
  function _execl(/* ... */) {
      // int execl(const char *path, const char *arg0, ... /*, (char *)0 */);
      // http://pubs.opengroup.org/onlinepubs/009695399/functions/exec.html
      // We don't support executing external code.
      ___setErrNo(ERRNO_CODES.ENOEXEC);
      return -1;
    }
  
  var _execlp=_execl;



  
  function _pipe(fildes) {
      // int pipe(int fildes[2]);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/pipe.html
      // It is possible to implement this using two device streams, but pipes make
      // little sense in a single-threaded environment, so we do not support them.
      ___setErrNo(ERRNO_CODES.ENOSYS);
      return -1;
    }

  
  
  
  function _opendir(dirname) {
      // DIR *opendir(const char *dirname);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/opendir.html
      // NOTE: Calculating absolute path redundantly since we need to associate it
      //       with the opened stream.
      var path = FS.absolutePath(Pointer_stringify(dirname));
      if (path === null) {
        ___setErrNo(ERRNO_CODES.ENOENT);
        return 0;
      }
      var target = FS.findObject(path);
      if (target === null) return 0;
      if (!target.isFolder) {
        ___setErrNo(ERRNO_CODES.ENOTDIR);
        return 0;
      } else if (!target.read) {
        ___setErrNo(ERRNO_CODES.EACCES);
        return 0;
      }
      var id = FS.streams.length;
      var contents = [];
      for (var key in target.contents) contents.push(key);
      FS.streams[id] = {
        path: path,
        object: target,
        // An index into contents. Special values: -2 is ".", -1 is "..".
        position: -2,
        isRead: true,
        isWrite: false,
        isAppend: false,
        error: false,
        eof: false,
        ungotten: [],
        // Folder-specific properties:
        // Remember the contents at the time of opening in an array, so we can
        // seek between them relying on a single order.
        contents: contents,
        // Each stream has its own area for readdir() returns.
        currentEntry: _malloc(___dirent_struct_layout.__size__)
      };
      return id;
    }

  
  
  
  
  function _readdir_r(dirp, entry, result) {
      // int readdir_r(DIR *dirp, struct dirent *entry, struct dirent **result);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/readdir_r.html
      if (!FS.streams[dirp] || !FS.streams[dirp].object.isFolder) {
        return ___setErrNo(ERRNO_CODES.EBADF);
      }
      var stream = FS.streams[dirp];
      var loc = stream.position;
      var entries = 0;
      for (var key in stream.contents) entries++;
      if (loc < -2 || loc >= entries) {
        HEAP32[((result)>>2)]=0;
      } else {
        var name, inode;
        if (loc === -2) {
          name = '.';
          inode = 1;  // Really undefined.
        } else if (loc === -1) {
          name = '..';
          inode = 1;  // Really undefined.
        } else {
          name = stream.contents[loc];
          inode = stream.object.contents[name].inodeNumber;
        }
        stream.position++;
        var offsets = ___dirent_struct_layout;
        HEAP32[((entry+offsets.d_ino)>>2)]=inode;
        HEAP32[((entry+offsets.d_off)>>2)]=stream.position;
        HEAP32[((entry+offsets.d_reclen)>>2)]=name.length + 1;
        for (var i = 0; i < name.length; i++) {
          HEAP8[(entry + offsets.d_name+i)]=name.charCodeAt(i);
        }
        HEAP8[(entry + offsets.d_name+i)]=0;
        var type = stream.object.isDevice ? 2 // DT_CHR, character device.
                 : stream.object.isFolder ? 4 // DT_DIR, directory.
                 : stream.object.link !== undefined ? 10 // DT_LNK, symbolic link.
                 : 8; // DT_REG, regular file.
        HEAP8[(entry+offsets.d_type)]=type;
        HEAP32[((result)>>2)]=entry;
      }
      return 0;
    }
  
  function _readdir(dirp) {
      // struct dirent *readdir(DIR *dirp);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/readdir_r.html
      if (!FS.streams[dirp] || !FS.streams[dirp].object.isFolder) {
        ___setErrNo(ERRNO_CODES.EBADF);
        return 0;
      } else {
        if (!_readdir.result) _readdir.result = _malloc(4);
        _readdir_r(dirp, FS.streams[dirp].currentEntry, _readdir.result);
        if (HEAP32[((_readdir.result)>>2)] === 0) {
          return 0;
        } else {
          return FS.streams[dirp].currentEntry;
        }
      }
    }

  
  
  function _closedir(dirp) {
      // int closedir(DIR *dirp);
      // http://pubs.opengroup.org/onlinepubs/007908799/xsh/closedir.html
      if (!FS.streams[dirp] || !FS.streams[dirp].object.isFolder) {
        return ___setErrNo(ERRNO_CODES.EBADF);
      } else {
        _free(FS.streams[dirp].currentEntry);
        delete FS.streams[dirp];
        return 0;
      }
    }

  function _calloc(n, s) {
      var ret = _malloc(n*s);
      _memset(ret, 0, n*s);
      return ret;
    }

  var _cos=Math.cos;

  
  var ___rand_state=42;function _rand() {
      // int rand(void);
      ___rand_state = (1103515245 * ___rand_state + 12345) % 0x100000000;
      return ___rand_state & 0x7FFFFFFF;
    }

  var _exp=Math.exp;

  var _sin=Math.sin;

  
  var _vsprintf=_sprintf;

  
  function _fputs(s, stream) {
      // int fputs(const char *restrict s, FILE *restrict stream);
      // http://pubs.opengroup.org/onlinepubs/000095399/functions/fputs.html
      return _write(stream, s, _strlen(s));
    }

  function _exp2(x) {
      return Math.pow(2, x);
    }




  function __Z13GetFileLengthPKc($filename) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
  
    var $retval;
    var $filename_addr;
    var $statbuf=__stackBase__;
    $filename_addr=$filename;
    var $0=$filename_addr; //@line 130 "speak.cpp"
    var $call=_stat($0, $statbuf); //@line 130 "speak.cpp"
    var $cmp=((($call))|0)!=0; //@line 130 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 130 "speak.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 131 "speak.cpp"
      ; //@line 131 "speak.cpp"
    }
    else if (__label__ == 2) {
  
      var $st_mode=(($statbuf+12)&4294967295); //@line 133 "speak.cpp"
      var $1=HEAP32[(($st_mode)>>2)]; //@line 133 "speak.cpp"
      var $and=($1) & 61440; //@line 133 "speak.cpp"
      var $cmp1=((($and))|0)==16384; //@line 133 "speak.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 133 "speak.cpp"
      if (__label__ == 3) {
  
        $retval=-2; //@line 135 "speak.cpp"
        ; //@line 135 "speak.cpp"
      }
      else if (__label__ == 4) {
  
        var $st_size=(($statbuf+36)&4294967295); //@line 137 "speak.cpp"
        var $2=HEAP32[(($st_size)>>2)]; //@line 137 "speak.cpp"
        $retval=$2; //@line 137 "speak.cpp"
        ; //@line 137 "speak.cpp"
      }
    }
  
    var $3=$retval; //@line 138 "speak.cpp"
    STACKTOP = __stackBase__;
    return $3; //@line 138 "speak.cpp"
    return null;
  }
  

  function __Z5Alloci($size) {
    ;
    var __label__;
  
    var $size_addr;
    var $p;
    $size_addr=$size;
    var $0=$size_addr; //@line 144 "speak.cpp"
    var $call=_malloc($0); //@line 144 "speak.cpp"
    $p=$call; //@line 144 "speak.cpp"
    var $cmp=((($call))|0)==0; //@line 144 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 144 "speak.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 145 "speak.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 145 "speak.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 145 "speak.cpp"
      var $3=_fwrite(((__str106)&4294967295), 22, 1, $2); //@line 145 "speak.cpp"
      ; //@line 145 "speak.cpp"
    }
  
    var $4=$p; //@line 146 "speak.cpp"
    ;
    return $4; //@line 146 "speak.cpp"
    return null;
  }
  

  function __Z4FreePv($ptr) {
    ;
    var __label__;
  
    var $ptr_addr;
    $ptr_addr=$ptr;
    var $0=$ptr_addr; //@line 151 "speak.cpp"
    var $cmp=((($0))|0)!=0; //@line 151 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 151 "speak.cpp"
    if (__label__ == 1) {
  
      var $1=$ptr_addr; //@line 152 "speak.cpp"
      ; //@line 152 "speak.cpp"
      ; //@line 152 "speak.cpp"
    }
  
    ;
    return; //@line 153 "speak.cpp"
    return;
  }
  

  function __Z13DisplayVoicesP7__sFILEPc($f_out, $language) {
    var __stackBase__  = STACKTOP; STACKTOP += 36; _memset(__stackBase__, 0, 36);
    var __label__;
  
    var $f_out_addr;
    var $language_addr;
    var $ix;
    var $p;
    var $len;
    var $count;
    var $scores;
    var $v;
    var $lang_name;
    var $age_buf=__stackBase__;
    var $voices;
    var $voice_select=__stackBase__+12;
    $f_out_addr=$f_out;
    $language_addr=$language;
    $scores=0; //@line 162 "speak.cpp"
    var $0=$language_addr; //@line 171 "speak.cpp"
    var $cmp=((($0))|0)!=0; //@line 171 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 171 "speak.cpp"
    $land_lhs_true$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $1=$language_addr; //@line 171 "speak.cpp"
        var $arrayidx=(($1)&4294967295); //@line 171 "speak.cpp"
        var $2=HEAP8[($arrayidx)]; //@line 171 "speak.cpp"
        var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 171 "speak.cpp"
        var $cmp1=((($conv))|0)!=0; //@line 171 "speak.cpp"
        if (!($cmp1)) { __label__ = 3;break $land_lhs_true$$if_else$2; } //@line 171 "speak.cpp"
  
        var $3=$language_addr; //@line 174 "speak.cpp"
        var $languages=(($voice_select+4)&4294967295); //@line 174 "speak.cpp"
        HEAP32[(($languages)>>2)]=$3; //@line 174 "speak.cpp"
        var $age=(($voice_select+13)&4294967295); //@line 175 "speak.cpp"
        HEAP8[($age)]=0; //@line 175 "speak.cpp"
        var $gender=(($voice_select+12)&4294967295); //@line 176 "speak.cpp"
        HEAP8[($gender)]=0; //@line 176 "speak.cpp"
        var $name=(($voice_select)&4294967295); //@line 177 "speak.cpp"
        HEAP32[(($name)>>2)]=0; //@line 177 "speak.cpp"
        var $call=_espeak_ListVoices($voice_select); //@line 178 "speak.cpp"
        $voices=((__ZZ17espeak_ListVoicesE6voices)&4294967295); //@line 178 "speak.cpp"
        $scores=1; //@line 179 "speak.cpp"
        __label__ = 4;break $land_lhs_true$$if_else$2; //@line 180 "speak.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $call2=_espeak_ListVoices(0); //@line 183 "speak.cpp"
      $voices=((__ZZ17espeak_ListVoicesE6voices)&4294967295); //@line 183 "speak.cpp"
      ;
    }
  
    var $4=$f_out_addr; //@line 186 "speak.cpp"
    var $5=_fwrite(((__str1)&4294967295), 64, 1, $4); //@line 186 "speak.cpp"
    $ix=0; //@line 188 "speak.cpp"
    var $6=$ix; //@line 188 "speak.cpp"
    var $7=$voices; //@line 188 "speak.cpp"
    var $arrayidx43=(($7+4*$6)&4294967295); //@line 188 "speak.cpp"
    var $8=HEAP32[(($arrayidx43)>>2)]; //@line 188 "speak.cpp"
    $v=$8; //@line 188 "speak.cpp"
    var $cmp54=((($8))|0)!=0; //@line 188 "speak.cpp"
    if ($cmp54) { __label__ = 5;; } else { __label__ = 15;; } //@line 188 "speak.cpp"
    $for_body_lr_ph$$for_end$8: do { 
      if (__label__ == 5) {
  
        var $arraydecay=(($age_buf)&4294967295); //@line 198 "speak.cpp"
        var $arraydecay26=(($age_buf)&4294967295); //@line 204 "speak.cpp"
        ; //@line 188 "speak.cpp"
        $for_body$10: while(1) { 
  
          $count=0; //@line 190 "speak.cpp"
          var $9=$v; //@line 191 "speak.cpp"
          var $languages6=(($9+4)&4294967295); //@line 191 "speak.cpp"
          var $10=HEAP32[(($languages6)>>2)]; //@line 191 "speak.cpp"
          $p=$10; //@line 191 "speak.cpp"
          var $11=$p; //@line 192 "speak.cpp"
          var $12=HEAP8[($11)]; //@line 192 "speak.cpp"
          var $conv71=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 192 "speak.cpp"
          var $cmp82=((($conv71))|0)!=0; //@line 192 "speak.cpp"
          if ($cmp82) { __label__ = 7;; } else { __label__ = 14;; } //@line 192 "speak.cpp"
          $while_body$$while_end$12: do { 
            if (__label__ == 7) {
              while(1) { 
  
                var $13=$p; //@line 194 "speak.cpp"
                var $add_ptr=(($13+1)&4294967295); //@line 194 "speak.cpp"
                var $call9=_strlen($add_ptr); //@line 194 "speak.cpp"
                $len=$call9; //@line 194 "speak.cpp"
                var $14=$p; //@line 195 "speak.cpp"
                var $add_ptr10=(($14+1)&4294967295); //@line 195 "speak.cpp"
                $lang_name=$add_ptr10; //@line 195 "speak.cpp"
                var $15=$v; //@line 197 "speak.cpp"
                var $age11=(($15+13)&4294967295); //@line 197 "speak.cpp"
                var $16=HEAPU8[($age11)]; //@line 197 "speak.cpp"
                var $conv12=((($16))&255); //@line 197 "speak.cpp"
                var $cmp13=((($conv12))|0)==0; //@line 197 "speak.cpp"
                if ($cmp13) { __label__ = 8;; } else { __label__ = 9;; } //@line 197 "speak.cpp"
                if (__label__ == 8) {
  
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = ((__str41208)&4294967295);
                  $dest$ = $arraydecay;
                  $stop$ = $src$ + 4;
                  if (($dest$%4) == ($src$%4) && 4 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 198 "speak.cpp"
                  ; //@line 198 "speak.cpp"
                }
                else if (__label__ == 9) {
  
                  var $17=$v; //@line 200 "speak.cpp"
                  var $age18=(($17+13)&4294967295); //@line 200 "speak.cpp"
                  var $18=HEAPU8[($age18)]; //@line 200 "speak.cpp"
                  var $conv19=((($18))&255); //@line 200 "speak.cpp"
                  var $call20=_sprintf($arraydecay, ((__str3)&4294967295), allocate([$conv19,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 200 "speak.cpp"
                  ;
                }
  
                var $19=$count; //@line 202 "speak.cpp"
                var $cmp22=((($19))|0)==0; //@line 202 "speak.cpp"
                var $20=$f_out_addr; //@line 204 "speak.cpp"
                if ($cmp22) { __label__ = 11;; } else { __label__ = 12;; } //@line 202 "speak.cpp"
                if (__label__ == 11) {
  
                  var $21=$p; //@line 204 "speak.cpp"
                  var $arrayidx24=(($21)&4294967295); //@line 204 "speak.cpp"
                  var $22=HEAP8[($arrayidx24)]; //@line 204 "speak.cpp"
                  var $conv25=(tempInt=(($22)),(tempInt>=128?tempInt-256:tempInt)); //@line 204 "speak.cpp"
                  var $23=$lang_name; //@line 204 "speak.cpp"
                  var $24=$v; //@line 204 "speak.cpp"
                  var $gender27=(($24+12)&4294967295); //@line 204 "speak.cpp"
                  var $25=HEAPU8[($gender27)]; //@line 204 "speak.cpp"
                  var $idxprom=((($25))&255); //@line 204 "speak.cpp"
                  var $arrayidx28=((__ZZ13DisplayVoicesP7__sFILEPcE7genders+$idxprom)&4294967295); //@line 204 "speak.cpp"
                  var $26=HEAP8[($arrayidx28)]; //@line 204 "speak.cpp"
                  var $conv29=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 204 "speak.cpp"
                  var $27=$v; //@line 204 "speak.cpp"
                  var $name30=(($27)&4294967295); //@line 204 "speak.cpp"
                  var $28=HEAP32[(($name30)>>2)]; //@line 204 "speak.cpp"
                  var $29=$v; //@line 204 "speak.cpp"
                  var $identifier=(($29+8)&4294967295); //@line 204 "speak.cpp"
                  var $30=HEAP32[(($identifier)>>2)]; //@line 204 "speak.cpp"
                  var $call31=_fprintf($20, ((__str4)&4294967295), allocate([$conv25,0,0,0,$23,0,0,0,$arraydecay26,0,0,0,$conv29,0,0,0,$28,0,0,0,$30,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 204 "speak.cpp"
                  ; //@line 206 "speak.cpp"
                }
                else if (__label__ == 12) {
  
                  var $31=$lang_name; //@line 209 "speak.cpp"
                  var $32=$p; //@line 209 "speak.cpp"
                  var $arrayidx33=(($32)&4294967295); //@line 209 "speak.cpp"
                  var $33=HEAP8[($arrayidx33)]; //@line 209 "speak.cpp"
                  var $conv34=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 209 "speak.cpp"
                  var $call35=_fprintf($20, ((__str5)&4294967295), allocate([$31,0,0,0,$conv34,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 209 "speak.cpp"
                  ;
                }
  
                var $34=$count; //@line 211 "speak.cpp"
                var $inc=((($34)+1)&4294967295); //@line 211 "speak.cpp"
                $count=$inc; //@line 211 "speak.cpp"
                var $35=$len; //@line 212 "speak.cpp"
                var $add=((($35)+2)&4294967295); //@line 212 "speak.cpp"
                var $36=$p; //@line 212 "speak.cpp"
                var $add_ptr37=(($36+$add)&4294967295); //@line 212 "speak.cpp"
                $p=$add_ptr37; //@line 212 "speak.cpp"
                var $37=$p; //@line 192 "speak.cpp"
                var $38=HEAP8[($37)]; //@line 192 "speak.cpp"
                var $conv7=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 192 "speak.cpp"
                var $cmp8=((($conv7))|0)!=0; //@line 192 "speak.cpp"
                if ($cmp8) { __label__ = 7;continue ; } else { __label__ = 14;break $while_body$$while_end$12; } //@line 192 "speak.cpp"
              }
            }
          } while(0);
  
          var $39=$f_out_addr; //@line 216 "speak.cpp"
          var $call38=_fputc(10, $39); //@line 216 "speak.cpp"
          var $40=$ix; //@line 188 "speak.cpp"
          var $inc39=((($40)+1)&4294967295); //@line 188 "speak.cpp"
          $ix=$inc39; //@line 188 "speak.cpp"
          var $41=$ix; //@line 188 "speak.cpp"
          var $42=$voices; //@line 188 "speak.cpp"
          var $arrayidx4=(($42+4*$41)&4294967295); //@line 188 "speak.cpp"
          var $43=HEAP32[(($arrayidx4)>>2)]; //@line 188 "speak.cpp"
          $v=$43; //@line 188 "speak.cpp"
          var $cmp5=((($43))|0)!=0; //@line 188 "speak.cpp"
          if ($cmp5) { __label__ = 6;continue $for_body$10; } else { __label__ = 15;break $for_body_lr_ph$$for_end$8; } //@line 188 "speak.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 218 "speak.cpp"
    return;
  }
  

  function __Z13WVoiceChangedP7voice_t($wvoice) {
    ;
    var __label__;
  
    ;
    return; //@line 223 "speak.cpp"
    return;
  }
  

  function __Z11MarkerEventijiPh($type, $char_position, $value, $out_ptr) {
    ;
    var __label__;
  
    var $type_addr;
    var $char_position_addr;
    var $value_addr;
    var $out_ptr_addr;
    $type_addr=$type;
    $char_position_addr=$char_position;
    $value_addr=$value;
    $out_ptr_addr=$out_ptr;
    var $0=$type_addr; //@line 292 "speak.cpp"
    var $cmp=((($0))|0)==2; //@line 292 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 292 "speak.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_end_of_sentence)>>2)]=1; //@line 293 "speak.cpp"
      ; //@line 293 "speak.cpp"
    }
  
    ;
    return; //@line 294 "speak.cpp"
    return;
  }
  

  function _main($argc, $argv) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $_ZL9help_text;
    $_ZL9help_text=((__str37)&4294967295);
    var $_ZZ4mainE8err_load;
    $_ZZ4mainE8err_load=((__str18)&4294967295);
    var $retval;
    var $argc_addr;
    var $argv_addr;
    var $f_text;
    var $p_text;
    var $data_path;
    var $option_index=STACKTOP; _memset(STACKTOP, 0, 4); STACKTOP += 4;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $c;
    var $value=STACKTOP; _memset(STACKTOP, 0, 4); STACKTOP += 4;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $speed;
    var $ix;
    var $optarg2;
    var $amp;
    var $wordgap;
    var $speaking;
    var $flag_stdin;
    var $flag_compile;
    var $pitch_adjustment;
    var $voice_select=STACKTOP; _memset(STACKTOP, 0, 24); STACKTOP += 24;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $filename=STACKTOP; _memset(STACKTOP, 0, 200); STACKTOP += 200;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $voicename=STACKTOP; _memset(STACKTOP, 0, 40); STACKTOP += 40;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $dictname=STACKTOP; _memset(STACKTOP, 0, 40); STACKTOP += 40;STACKTOP = Math.ceil((STACKTOP)/4)*4;;
    var $extn;
    $retval=0;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $f_text=0; //@line 495 "speak.cpp"
    $p_text=0; //@line 496 "speak.cpp"
    $data_path=0; //@line 497 "speak.cpp"
    HEAP32[(($option_index)>>2)]=0; //@line 499 "speak.cpp"
    $speed=175; //@line 502 "speak.cpp"
    $amp=100; //@line 505 "speak.cpp"
    $wordgap=0; //@line 506 "speak.cpp"
    $speaking=0; //@line 507 "speak.cpp"
    $flag_stdin=0; //@line 508 "speak.cpp"
    $flag_compile=0; //@line 509 "speak.cpp"
    $pitch_adjustment=50; //@line 510 "speak.cpp"
    var $arrayidx=(($voicename)&4294967295); //@line 516 "speak.cpp"
    HEAP8[($arrayidx)]=0; //@line 516 "speak.cpp"
    HEAP8[(((_mbrola_name)&4294967295))]=0; //@line 517 "speak.cpp"
    var $arrayidx1=(($dictname)&4294967295); //@line 518 "speak.cpp"
    HEAP8[($arrayidx1)]=0; //@line 518 "speak.cpp"
    HEAP8[(((_wavefile)&4294967295))]=0; //@line 519 "speak.cpp"
    var $arrayidx2=(($filename)&4294967295); //@line 520 "speak.cpp"
    HEAP8[($arrayidx2)]=0; //@line 520 "speak.cpp"
    HEAP32[((_option_linelength)>>2)]=0; //@line 521 "speak.cpp"
    HEAP32[((_option_phonemes)>>2)]=0; //@line 522 "speak.cpp"
    HEAP32[((_option_waveout)>>2)]=0; //@line 523 "speak.cpp"
    HEAP32[((_option_wordgap)>>2)]=0; //@line 524 "speak.cpp"
    HEAP32[((_option_endpause)>>2)]=1; //@line 525 "speak.cpp"
    HEAP32[((_option_phoneme_input)>>2)]=1; //@line 526 "speak.cpp"
    HEAP32[((_option_multibyte)>>2)]=0; //@line 527 "speak.cpp"
    var $0=HEAP32[((__impure_ptr)>>2)]; //@line 528 "speak.cpp"
    var $_stdout=(($0+8)&4294967295); //@line 528 "speak.cpp"
    var $1=HEAP32[(($_stdout)>>2)]; //@line 528 "speak.cpp"
    HEAP32[((_f_trans)>>2)]=$1; //@line 528 "speak.cpp"
    var $2=$argc_addr; //@line 588 "speak.cpp"
    var $3=$argv_addr; //@line 588 "speak.cpp"
    var $call6=_getopt_long($2, $3, ((__str19)&4294967295), ((__ZZ4mainE12long_options)&4294967295), $option_index); //@line 588 "speak.cpp"
    $c=$call6; //@line 588 "speak.cpp"
    var $cmp7=((($call6))|0)==-1; //@line 592 "speak.cpp"
    if ($cmp7) { __label__ = 43;; } else { __label__ = 1;; } //@line 592 "speak.cpp"
    $while_end71$$if_end_lr_ph$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay=(($filename)&4294967295); //@line 638 "speak.cpp"
        var $arraydecay32=(($voicename)&4294967295); //@line 660 "speak.cpp"
        var $arraydecay41=(($voicename)&4294967295); //@line 684 "speak.cpp"
        var $_pr8=$c; //@line 597 "speak.cpp"
        __lastLabel__ = 1; ; //@line 592 "speak.cpp"
        $if_end$4: while(1) { 
  
          var $4=__lastLabel__ == 1 ? $_pr8 : ($call); //@line 597 "speak.cpp"
          var $5=HEAP32[((_optarg)>>2)]; //@line 594 "speak.cpp"
          $optarg2=$5; //@line 594 "speak.cpp"
          if ($4 == 98) {
            __lastLabel__ = 2; __label__ = 3;;
          }
          else if ($4 == 104) {
            __lastLabel__ = 2; __label__ = 5;;
          }
          else if ($4 == 107) {
            __lastLabel__ = 2; __label__ = 6;;
          }
          else if ($4 == 120) {
            __lastLabel__ = 2; __label__ = 7;;
          }
          else if ($4 == 88) {
            __lastLabel__ = 2; __label__ = 8;;
          }
          else if ($4 == 109) {
            __lastLabel__ = 2; __label__ = 9;;
          }
          else if ($4 == 112) {
            __lastLabel__ = 2; __label__ = 10;;
          }
          else if ($4 == 113) {
            __lastLabel__ = 2; __label__ = 12;;
          }
          else if ($4 == 102) {
            __lastLabel__ = 2; __label__ = 13;;
          }
          else if ($4 == 108) {
            __lastLabel__ = 2; __label__ = 14;;
          }
          else if ($4 == 97) {
            __lastLabel__ = 2; __label__ = 15;;
          }
          else if ($4 == 115) {
            __lastLabel__ = 2; __label__ = 16;;
          }
          else if ($4 == 103) {
            __lastLabel__ = 2; __label__ = 17;;
          }
          else if ($4 == 118) {
            __lastLabel__ = 2; __label__ = 18;;
          }
          else if ($4 == 119) {
            __lastLabel__ = 2; __label__ = 19;;
          }
          else if ($4 == 122) {
            __lastLabel__ = 2; __label__ = 20;;
          }
          else if ($4 == 256) {
            __lastLabel__ = 2; __label__ = 21;;
          }
          else if ($4 == 261) {
            __lastLabel__ = 2; __label__ = 22;;
          }
          else if ($4 == 257) {
            __lastLabel__ = 2; __label__ = 23;;
          }
          else if ($4 == 258) {
            __lastLabel__ = 2; __label__ = 23;;
          }
          else if ($4 == 259) {
            __lastLabel__ = 2; __label__ = 26;;
          }
          else if ($4 == 260) {
            __lastLabel__ = 2; __label__ = 32;;
          }
          else if ($4 == 262) {
            __lastLabel__ = 2; __label__ = 33;;
          }
          else if ($4 == 263) {
            __lastLabel__ = 2; __label__ = 36;;
          }
          else if ($4 == 264) {
            __lastLabel__ = 2; __label__ = 37;;
          }
          else if ($4 == 265) {
            __lastLabel__ = 2; __label__ = 40;;
          }
          else if ($4 == 266) {
            __lastLabel__ = 2; __label__ = 41;;
          }
          else {
          __lastLabel__ = 2; __label__ = 42;;
          }
          
          $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6: do { 
            if (__label__ == 42) {
  
              _exit(0); //@line 732 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 733 "speak.cpp"
            }
            else if (__label__ == 3) {
  
              HEAP32[((_option_multibyte)>>2)]=2; //@line 601 "speak.cpp"
              var $6=$optarg2; //@line 602 "speak.cpp"
              var $call3=_sscanf($6, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 602 "speak.cpp"
              var $cmp4=((($call3))|0)==1; //@line 602 "speak.cpp"
              var $7=HEAP32[(($value)>>2)]; //@line 602 "speak.cpp"
              var $cmp5=((($7))|0) <= 4; //@line 602 "speak.cpp"
              var $or_cond=($cmp4) & ($cmp5); //@line 602 "speak.cpp"
              if (!($or_cond)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 602 "speak.cpp"
  
              var $8=HEAP32[(($value)>>2)]; //@line 603 "speak.cpp"
              HEAP32[((_option_multibyte)>>2)]=$8; //@line 603 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 603 "speak.cpp"
            }
            else if (__label__ == 5) {
  
              var $9=$argv_addr; //@line 607 "speak.cpp"
              var $arrayidx9=(($9)&4294967295); //@line 607 "speak.cpp"
              var $10=HEAP32[(($arrayidx9)>>2)]; //@line 607 "speak.cpp"
              var $11=$data_path; //@line 607 "speak.cpp"
              __ZL9init_pathPcS_($10, $11); //@line 607 "speak.cpp"
              var $12=HEAP32[((_version_string)>>2)]; //@line 608 "speak.cpp"
              var $13=$_ZL9help_text; //@line 608 "speak.cpp"
              var $call10=_printf(((__str21)&4294967295), allocate([$12,0,0,0,((_path_home)&4294967295),0,0,0,$13,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 608 "speak.cpp"
              _exit(0); //@line 609 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 610 "speak.cpp"
            }
            else if (__label__ == 6) {
  
              var $14=$optarg2; //@line 613 "speak.cpp"
              var $call12=_atoi($14); //@line 613 "speak.cpp"
              HEAP32[((_option_capitals)>>2)]=$call12; //@line 613 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 614 "speak.cpp"
            }
            else if (__label__ == 7) {
  
              HEAP32[((_option_phonemes)>>2)]=1; //@line 617 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 618 "speak.cpp"
            }
            else if (__label__ == 8) {
  
              HEAP32[((_option_phonemes)>>2)]=2; //@line 621 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 622 "speak.cpp"
            }
            else if (__label__ == 9) {
  
              HEAP32[((_option_ssml)>>2)]=1; //@line 625 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 626 "speak.cpp"
            }
            else if (__label__ == 10) {
  
              var $15=$optarg2; //@line 629 "speak.cpp"
              var $call17=_atoi($15); //@line 629 "speak.cpp"
              $pitch_adjustment=$call17; //@line 629 "speak.cpp"
              var $16=$pitch_adjustment; //@line 630 "speak.cpp"
              var $cmp18=((($16))|0) > 99; //@line 630 "speak.cpp"
              if (!($cmp18)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 630 "speak.cpp"
  
              $pitch_adjustment=99; //@line 630 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 630 "speak.cpp"
            }
            else if (__label__ == 12) {
  
              HEAP32[((_quiet)>>2)]=1; //@line 634 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 635 "speak.cpp"
            }
            else if (__label__ == 13) {
  
              var $17=$optarg2; //@line 638 "speak.cpp"
              __Z8strncpy0PcPKci($arraydecay, $17, 200); //@line 638 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 639 "speak.cpp"
            }
            else if (__label__ == 14) {
  
              HEAP32[(($value)>>2)]=0; //@line 642 "speak.cpp"
              var $18=$optarg2; //@line 643 "speak.cpp"
              var $call24=_atoi($18); //@line 643 "speak.cpp"
              HEAP32[(($value)>>2)]=$call24; //@line 643 "speak.cpp"
              var $19=HEAP32[(($value)>>2)]; //@line 644 "speak.cpp"
              HEAP32[((_option_linelength)>>2)]=$19; //@line 644 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 645 "speak.cpp"
            }
            else if (__label__ == 15) {
  
              var $20=$optarg2; //@line 648 "speak.cpp"
              var $call26=_atoi($20); //@line 648 "speak.cpp"
              $amp=$call26; //@line 648 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 649 "speak.cpp"
            }
            else if (__label__ == 16) {
  
              var $21=$optarg2; //@line 652 "speak.cpp"
              var $call28=_atoi($21); //@line 652 "speak.cpp"
              $speed=$call28; //@line 652 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 653 "speak.cpp"
            }
            else if (__label__ == 17) {
  
              var $22=$optarg2; //@line 656 "speak.cpp"
              var $call30=_atoi($22); //@line 656 "speak.cpp"
              $wordgap=$call30; //@line 656 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 657 "speak.cpp"
            }
            else if (__label__ == 18) {
  
              var $23=$optarg2; //@line 660 "speak.cpp"
              __Z8strncpy0PcPKci($arraydecay32, $23, 40); //@line 660 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 661 "speak.cpp"
            }
            else if (__label__ == 19) {
  
              HEAP32[((_option_waveout)>>2)]=1; //@line 664 "speak.cpp"
              var $24=$optarg2; //@line 665 "speak.cpp"
              __Z8strncpy0PcPKci(((_wavefile)&4294967295), $24, 200); //@line 665 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 666 "speak.cpp"
            }
            else if (__label__ == 20) {
  
              HEAP32[((_option_endpause)>>2)]=0; //@line 669 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 670 "speak.cpp"
            }
            else if (__label__ == 21) {
  
              $flag_stdin=1; //@line 673 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 674 "speak.cpp"
            }
            else if (__label__ == 22) {
  
              HEAP32[((_option_waveout)>>2)]=1; //@line 677 "speak.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = ((__str12)&4294967295);
              $dest$ = ((_wavefile)&4294967295);
              $stop$ = $src$ + 7;
              if (($dest$%4) == ($src$%4) && 7 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 678 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 679 "speak.cpp"
            }
            else if (__label__ == 23) {
  
              var $cmp39=((($5))|0)!=0; //@line 683 "speak.cpp"
              if ($cmp39) { __label__ = 24;; } else { __label__ = 25;; } //@line 683 "speak.cpp"
              if (__label__ == 24) {
  
                var $25=$optarg2; //@line 684 "speak.cpp"
                __Z8strncpy0PcPKci($arraydecay41, $25, 40); //@line 684 "speak.cpp"
                ; //@line 684 "speak.cpp"
              }
  
              var $26=$c; //@line 685 "speak.cpp"
              $flag_compile=$26; //@line 685 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 686 "speak.cpp"
            }
            else if (__label__ == 26) {
  
              HEAP32[((_option_punctuation)>>2)]=1; //@line 689 "speak.cpp"
              var $27=$optarg2; //@line 690 "speak.cpp"
              var $cmp44=((($27))|0)!=0; //@line 690 "speak.cpp"
              if (!($cmp44)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 690 "speak.cpp"
  
              $ix=0; //@line 692 "speak.cpp"
              __lastLabel__ = 27; ; //@line 693 "speak.cpp"
              while(1) { 
  
                var $28=__lastLabel__ == 30 ? $inc : (0); //@line 693 "speak.cpp"
                var $cmp47=((($28))|0) < 60; //@line 693 "speak.cpp"
                if (!($cmp47)) { __label__ = 31;break ; } //@line 693 "speak.cpp"
  
                var $29=$ix; //@line 693 "speak.cpp"
                var $30=$optarg2; //@line 693 "speak.cpp"
                var $arrayidx48=(($30+$29)&4294967295); //@line 693 "speak.cpp"
                var $31=HEAP8[($arrayidx48)]; //@line 693 "speak.cpp"
                var $conv=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 693 "speak.cpp"
                var $32=$ix; //@line 693 "speak.cpp"
                var $arrayidx49=((_option_punctlist+$32*4)&4294967295); //@line 693 "speak.cpp"
                HEAP32[(($arrayidx49)>>2)]=$conv; //@line 693 "speak.cpp"
                var $cmp50=((($conv))|0)!=0; //@line 693 "speak.cpp"
                if (!($cmp50)) { __label__ = 31;break ; }
  
                var $33=$ix; //@line 693 "speak.cpp"
                var $inc=((($33)+1)&4294967295); //@line 693 "speak.cpp"
                $ix=$inc; //@line 693 "speak.cpp"
                __lastLabel__ = 30; __label__ = 28;continue ; //@line 693 "speak.cpp"
              }
  
              HEAP32[((((_option_punctlist+236)&4294967295))>>2)]=0; //@line 694 "speak.cpp"
              HEAP32[((_option_punctuation)>>2)]=2; //@line 695 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 696 "speak.cpp"
            }
            else if (__label__ == 32) {
  
              var $34=$argv_addr; //@line 700 "speak.cpp"
              var $arrayidx54=(($34)&4294967295); //@line 700 "speak.cpp"
              var $35=HEAP32[(($arrayidx54)>>2)]; //@line 700 "speak.cpp"
              var $36=$data_path; //@line 700 "speak.cpp"
              __ZL9init_pathPcS_($35, $36); //@line 700 "speak.cpp"
              var $37=HEAP32[((__impure_ptr)>>2)]; //@line 701 "speak.cpp"
              var $_stdout55=(($37+8)&4294967295); //@line 701 "speak.cpp"
              var $38=HEAP32[(($_stdout55)>>2)]; //@line 701 "speak.cpp"
              var $39=$optarg2; //@line 701 "speak.cpp"
              __Z13DisplayVoicesP7__sFILEPc($38, $39); //@line 701 "speak.cpp"
              _exit(0); //@line 702 "speak.cpp"
              var $_pr=$optarg2; //@line 705 "speak.cpp"
              __lastLabel__ = 32; __label__ = 33;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 702 "speak.cpp"
            }
            else if (__label__ == 36) {
  
              var $42=$optarg2; //@line 712 "speak.cpp"
              $data_path=$42; //@line 712 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 713 "speak.cpp"
            }
            else if (__label__ == 37) {
  
              var $43=$optarg2; //@line 716 "speak.cpp"
              var $call63=_fopen($43, ((__str11422)&4294967295)); //@line 716 "speak.cpp"
              HEAP32[((_f_trans)>>2)]=$call63; //@line 716 "speak.cpp"
              var $cmp64=((($call63))|0)==0; //@line 716 "speak.cpp"
              if (!($cmp64)) { __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; } //@line 716 "speak.cpp"
  
              var $46=HEAP32[((__impure_ptr)>>2)]; //@line 718 "speak.cpp"
              var $_stderr=(($46+12)&4294967295); //@line 718 "speak.cpp"
              var $47=HEAP32[(($_stderr)>>2)]; //@line 718 "speak.cpp"
              var $48=$optarg2; //@line 718 "speak.cpp"
              var $call66=_fprintf($47, ((__str23)&4294967295), allocate([$48,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 718 "speak.cpp"
              var $49=HEAP32[((__impure_ptr)>>2)]; //@line 719 "speak.cpp"
              var $_stderr67=(($49+12)&4294967295); //@line 719 "speak.cpp"
              var $50=HEAP32[(($_stderr67)>>2)]; //@line 719 "speak.cpp"
              HEAP32[((_f_trans)>>2)]=$50; //@line 719 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 720 "speak.cpp"
            }
            else if (__label__ == 40) {
  
              HEAP32[((_option_mbrola_phonemes)>>2)]=16; //@line 724 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 725 "speak.cpp"
            }
            else if (__label__ == 41) {
  
              HEAP32[((_option_phonemes)>>2)]=3; //@line 728 "speak.cpp"
              __label__ = 38;break $sw_default$$sw_bb$$sw_bb8$$sw_bb11$$sw_bb13$$sw_bb14$$sw_bb15$$sw_bb16$$sw_bb21$$sw_bb22$$sw_bb23$$sw_bb25$$sw_bb27$$sw_bb29$$sw_bb31$$sw_bb33$$sw_bb34$$sw_bb35$$sw_bb36$$sw_bb38$$sw_bb43$$sw_bb53$$sw_bb56$$sw_bb61$$sw_bb62$$sw_bb69$$sw_bb70$6; //@line 729 "speak.cpp"
            }
          } while(0);
          if (__label__ == 33) {
  
            var $40=__lastLabel__ == 32 ? $_pr : ($5); //@line 705 "speak.cpp"
            var $cmp57=((($40))|0)==0; //@line 705 "speak.cpp"
            if ($cmp57) { __label__ = 34;; } else { __label__ = 35;; } //@line 705 "speak.cpp"
            if (__label__ == 34) {
  
              HEAP32[((_samples_split)>>2)]=30; //@line 706 "speak.cpp"
              ; //@line 706 "speak.cpp"
            }
            else if (__label__ == 35) {
  
              var $41=$optarg2; //@line 708 "speak.cpp"
              var $call59=_atoi($41); //@line 708 "speak.cpp"
              HEAP32[((_samples_split)>>2)]=$call59; //@line 708 "speak.cpp"
              ;
            }
          }
  
          var $44=$argc_addr; //@line 588 "speak.cpp"
          var $45=$argv_addr; //@line 588 "speak.cpp"
          var $call=_getopt_long($44, $45, ((__str19)&4294967295), ((__ZZ4mainE12long_options)&4294967295), $option_index); //@line 588 "speak.cpp"
          $c=$call; //@line 588 "speak.cpp"
          var $cmp=((($call))|0)==-1; //@line 592 "speak.cpp"
          if ($cmp) { __lastLabel__ = 38; __label__ = 43;break $while_end71$$if_end_lr_ph$2; } else { __lastLabel__ = 38; __label__ = 2;continue $if_end$4; } //@line 592 "speak.cpp"
        }
      }
    } while(0);
  
    var $51=$argv_addr; //@line 736 "speak.cpp"
    var $arrayidx72=(($51)&4294967295); //@line 736 "speak.cpp"
    var $52=HEAP32[(($arrayidx72)>>2)]; //@line 736 "speak.cpp"
    var $53=$data_path; //@line 736 "speak.cpp"
    __ZL9init_pathPcS_($52, $53); //@line 736 "speak.cpp"
    __ZL10initialisev(); //@line 737 "speak.cpp"
    var $54=$flag_compile; //@line 740 "speak.cpp"
    var $tobool=((($54))|0)!=0; //@line 740 "speak.cpp"
    if ($tobool) { __label__ = 44;; } else { __label__ = 45;; } //@line 740 "speak.cpp"
    if (__label__ == 44) {
  
      var $arraydecay75=(($voicename)&4294967295); //@line 742 "speak.cpp"
      var $call76=__Z9LoadVoicePKci($arraydecay75, 5); //@line 742 "speak.cpp"
      var $55=$flag_compile; //@line 758 "speak.cpp"
      var $and=($55) & 1; //@line 758 "speak.cpp"
      var $call77=__Z17CompileDictionaryPKcS0_P7__sFILEPci(0, ((_dictionary_name)&4294967295), 0, 0, $and); //@line 758 "speak.cpp"
      _exit(0); //@line 761 "speak.cpp"
      ; //@line 762 "speak.cpp"
    }
  
    var $arrayidx79=(($voicename)&4294967295); //@line 765 "speak.cpp"
    var $56=HEAP8[($arrayidx79)]; //@line 765 "speak.cpp"
    var $conv80=(tempInt=(($56)),(tempInt>=128?tempInt-256:tempInt)); //@line 765 "speak.cpp"
    var $cmp81=((($conv80))|0)==0; //@line 765 "speak.cpp"
    if ($cmp81) { __label__ = 46;; } else { __label__ = 47;; } //@line 765 "speak.cpp"
    if (__label__ == 46) {
  
      var $arraydecay83=(($voicename)&4294967295); //@line 766 "speak.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((__str45697)&4294967295);
      $dest$ = $arraydecay83;
      $stop$ = $src$ + 8;
      if (($dest$%4) == ($src$%4) && 8 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 766 "speak.cpp"
      ; //@line 766 "speak.cpp"
    }
  
    var $arraydecay86=(($voicename)&4294967295); //@line 768 "speak.cpp"
    var $call87=__Z14SetVoiceByNamePKc($arraydecay86); //@line 768 "speak.cpp"
    var $cmp88=((($call87))|0)!=0; //@line 768 "speak.cpp"
    if ($cmp88) { __label__ = 48;; } else { __label__ = 50;; } //@line 768 "speak.cpp"
    $if_then89$$if_end98$58: do { 
      if (__label__ == 48) {
  
        var $57=$voice_select; //@line 770 "speak.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $57;
        $stop$ = $dest$ + 24;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 770 "speak.cpp"
        var $arraydecay90=(($voicename)&4294967295); //@line 771 "speak.cpp"
        var $languages=(($voice_select+4)&4294967295); //@line 771 "speak.cpp"
        HEAP32[(($languages)>>2)]=$arraydecay90; //@line 771 "speak.cpp"
        var $call91=__Z20SetVoiceByPropertiesP12espeak_VOICE($voice_select); //@line 772 "speak.cpp"
        var $cmp92=((($call91))|0)!=0; //@line 772 "speak.cpp"
        if (!($cmp92)) { __label__ = 50;break $if_then89$$if_end98$58; } //@line 772 "speak.cpp"
  
        var $58=HEAP32[((__impure_ptr)>>2)]; //@line 774 "speak.cpp"
        var $_stderr94=(($58+12)&4294967295); //@line 774 "speak.cpp"
        var $59=HEAP32[(($_stderr94)>>2)]; //@line 774 "speak.cpp"
        var $60=$_ZZ4mainE8err_load; //@line 774 "speak.cpp"
        var $arraydecay95=(($voicename)&4294967295); //@line 774 "speak.cpp"
        var $call96=_fprintf($59, ((__str25)&4294967295), allocate([$60,0,0,0,$arraydecay95,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 774 "speak.cpp"
        _exit(2); //@line 775 "speak.cpp"
        ; //@line 776 "speak.cpp"
      }
    } while(0);
  
    var $61=$speed; //@line 779 "speak.cpp"
    __Z12SetParameteriii(1, $61, 0); //@line 779 "speak.cpp"
    var $62=$amp; //@line 780 "speak.cpp"
    __Z12SetParameteriii(2, $62, 0); //@line 780 "speak.cpp"
    var $63=HEAP32[((_option_capitals)>>2)]; //@line 781 "speak.cpp"
    __Z12SetParameteriii(6, $63, 0); //@line 781 "speak.cpp"
    var $64=HEAP32[((_option_punctuation)>>2)]; //@line 782 "speak.cpp"
    __Z12SetParameteriii(5, $64, 0); //@line 782 "speak.cpp"
    var $65=$wordgap; //@line 783 "speak.cpp"
    __Z12SetParameteriii(7, $65, 0); //@line 783 "speak.cpp"
    var $66=$pitch_adjustment; //@line 785 "speak.cpp"
    var $cmp99=((($66))|0)!=50; //@line 785 "speak.cpp"
    if ($cmp99) { __label__ = 51;; } else { __label__ = 52;; } //@line 785 "speak.cpp"
    if (__label__ == 51) {
  
      var $67=$pitch_adjustment; //@line 787 "speak.cpp"
      __Z12SetParameteriii(3, $67, 0); //@line 787 "speak.cpp"
      ; //@line 788 "speak.cpp"
    }
  
    var $68=HEAP32[((_voice)>>2)]; //@line 789 "speak.cpp"
    __Z13DoVoiceChangeP7voice_t($68); //@line 789 "speak.cpp"
    var $arrayidx102=(($filename)&4294967295); //@line 791 "speak.cpp"
    var $69=HEAP8[($arrayidx102)]; //@line 791 "speak.cpp"
    var $conv103=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 791 "speak.cpp"
    var $cmp104=((($conv103))|0)==0; //@line 791 "speak.cpp"
    if ($cmp104) { __label__ = 53;; } else { __label__ = 59;; } //@line 791 "speak.cpp"
    $if_then105$$if_else116$65: do { 
      if (__label__ == 53) {
  
        var $70=HEAP32[((_optind)>>2)]; //@line 793 "speak.cpp"
        var $71=$argc_addr; //@line 793 "speak.cpp"
        var $cmp106=((($70))|0) < ((($71))|0); //@line 793 "speak.cpp"
        var $72=$flag_stdin; //@line 793 "speak.cpp"
        if ($cmp106) { __label__ = 54;; } else { __label__ = 57;; } //@line 793 "speak.cpp"
        if (__label__ == 54) {
  
          var $cmp108=((($72))|0)==0; //@line 793 "speak.cpp"
          if ($cmp108) { __label__ = 56;; } else { __label__ = 55;; } //@line 793 "speak.cpp"
          if (__label__ == 56) {
  
            var $75=HEAP32[((_optind)>>2)]; //@line 797 "speak.cpp"
            var $76=$argv_addr; //@line 797 "speak.cpp"
            var $arrayidx110=(($76+4*$75)&4294967295); //@line 797 "speak.cpp"
            var $77=HEAP32[(($arrayidx110)>>2)]; //@line 797 "speak.cpp"
            $p_text=$77; //@line 797 "speak.cpp"
            ; //@line 798 "speak.cpp"
          }
          else if (__label__ == 55) {
  
            var $73=HEAP32[((__impure_ptr)>>2)]; //@line 801 "speak.cpp"
            var $_stdin3=(($73+4)&4294967295); //@line 801 "speak.cpp"
            var $74=HEAP32[(($_stdin3)>>2)]; //@line 801 "speak.cpp"
            $f_text=$74; //@line 801 "speak.cpp"
            __lastLabel__ = 55; __label__ = 61;break $if_then105$$if_else116$65; //@line 802 "speak.cpp"
          }
        }
        else if (__label__ == 57) {
  
          var $78=HEAP32[((__impure_ptr)>>2)]; //@line 801 "speak.cpp"
          var $_stdin=(($78+4)&4294967295); //@line 801 "speak.cpp"
          var $79=HEAP32[(($_stdin)>>2)]; //@line 801 "speak.cpp"
          $f_text=$79; //@line 801 "speak.cpp"
          var $cmp112=((($72))|0)==0; //@line 802 "speak.cpp"
          if ($cmp112) { __lastLabel__ = 57; ; } else { __lastLabel__ = 57; __label__ = 61;break $if_then105$$if_else116$65; } //@line 802 "speak.cpp"
  
          HEAP32[((_option_linelength)>>2)]=-1; //@line 803 "speak.cpp"
          ; //@line 803 "speak.cpp"
        }
  
        var $_pr5=$f_text; //@line 811 "speak.cpp"
        __lastLabel__ = 60; ;
      }
      else if (__label__ == 59) {
  
        var $arraydecay117=(($filename)&4294967295); //@line 808 "speak.cpp"
        var $call118=_fopen($arraydecay117, ((__str51703)&4294967295)); //@line 808 "speak.cpp"
        $f_text=$call118; //@line 808 "speak.cpp"
        __lastLabel__ = 59; ;
      }
    } while(0);
  
    var $80=__lastLabel__ == 60 ? $_pr5 : (__lastLabel__ == 55 ? $74 : (__lastLabel__ == 57 ? $79 : ($call118))); //@line 811 "speak.cpp"
    var $cmp120=((($80))|0)==0; //@line 811 "speak.cpp"
    if ($cmp120) { __label__ = 62;; } else { __label__ = 64;; } //@line 811 "speak.cpp"
    $land_lhs_true121$$if_end127$77: do { 
      if (__label__ == 62) {
  
        var $81=$p_text; //@line 811 "speak.cpp"
        var $cmp122=((($81))|0)==0; //@line 811 "speak.cpp"
        if (!($cmp122)) { __label__ = 64;break $land_lhs_true121$$if_end127$77; } //@line 811 "speak.cpp"
  
        var $82=HEAP32[((__impure_ptr)>>2)]; //@line 813 "speak.cpp"
        var $_stderr124=(($82+12)&4294967295); //@line 813 "speak.cpp"
        var $83=HEAP32[(($_stderr124)>>2)]; //@line 813 "speak.cpp"
        var $84=$_ZZ4mainE8err_load; //@line 813 "speak.cpp"
        var $arraydecay125=(($filename)&4294967295); //@line 813 "speak.cpp"
        var $call126=_fprintf($83, ((__str27)&4294967295), allocate([$84,0,0,0,$arraydecay125,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 813 "speak.cpp"
        _exit(1); //@line 814 "speak.cpp"
        ; //@line 815 "speak.cpp"
      }
    } while(0);
  
    var $85=HEAP32[((_option_waveout)>>2)]; //@line 817 "speak.cpp"
    var $tobool128=((($85))|0)!=0; //@line 817 "speak.cpp"
    var $86=HEAP32[((_quiet)>>2)]; //@line 817 "speak.cpp"
    var $tobool129=((($86))|0)!=0; //@line 817 "speak.cpp"
    var $or_cond1=($tobool128) | ($tobool129); //@line 817 "speak.cpp"
    if ($or_cond1) { __label__ = 65;; } else { __label__ = 79;; } //@line 817 "speak.cpp"
    $if_then130$$if_else168$81: do { 
      if (__label__ == 65) {
  
        var $87=HEAP32[((_quiet)>>2)]; //@line 819 "speak.cpp"
        var $tobool131=((($87))|0)!=0; //@line 819 "speak.cpp"
        var $88=HEAP32[((_samplerate)>>2)]; //@line 822 "speak.cpp"
        if ($tobool131) { __label__ = 66;; } else { __label__ = 67;; } //@line 819 "speak.cpp"
        $if_then132$$if_else134$83: do { 
          if (__label__ == 66) {
  
            var $call133=__ZL12OpenWaveFilePKci(0, $88); //@line 822 "speak.cpp"
            HEAP32[((_option_waveout)>>2)]=1; //@line 823 "speak.cpp"
            ; //@line 824 "speak.cpp"
          }
          else if (__label__ == 67) {
  
            var $89=HEAP32[((_samples_split)>>2)]; //@line 828 "speak.cpp"
            var $mul=((($88)*60)&4294967295); //@line 828 "speak.cpp"
            var $mul135=((($mul)*($89))&4294967295); //@line 828 "speak.cpp"
            HEAP32[((_samples_split)>>2)]=$mul135; //@line 828 "speak.cpp"
            var $90=HEAP32[((_samples_split)>>2)]; //@line 830 "speak.cpp"
            var $tobool136=((($90))|0)!=0; //@line 830 "speak.cpp"
            if ($tobool136) { __label__ = 68;; } else { __label__ = 71;; } //@line 830 "speak.cpp"
            if (__label__ == 68) {
  
              var $call138=_strrchr(((_wavefile)&4294967295), 46); //@line 834 "speak.cpp"
              $extn=$call138; //@line 834 "speak.cpp"
              var $91=$extn; //@line 835 "speak.cpp"
              var $cmp139=((($91))|0)!=0; //@line 835 "speak.cpp"
              if (!($cmp139)) { __label__ = 73;break $if_then132$$if_else134$83; } //@line 835 "speak.cpp"
  
              var $call141=_strlen(((_wavefile)&4294967295)); //@line 835 "speak.cpp"
              var $add_ptr=((((_wavefile)&4294967295)+$call141)&4294967295); //@line 835 "speak.cpp"
              var $92=$extn; //@line 835 "speak.cpp"
              var $sub_ptr_lhs_cast=($add_ptr); //@line 835 "speak.cpp"
              var $sub_ptr_rhs_cast=($92); //@line 835 "speak.cpp"
              var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 835 "speak.cpp"
              var $cmp142=((($sub_ptr_sub))|0) <= 4; //@line 835 "speak.cpp"
              if (!($cmp142)) { __label__ = 73;break $if_then132$$if_else134$83; } //@line 835 "speak.cpp"
  
              var $93=$extn; //@line 837 "speak.cpp"
              var $call144=_strcpy(((_filetype)&4294967295), $93); //@line 837 "speak.cpp"
              var $94=$extn; //@line 838 "speak.cpp"
              HEAP8[($94)]=0; //@line 838 "speak.cpp"
              ; //@line 839 "speak.cpp"
            }
            else if (__label__ == 71) {
  
              var $95=HEAP32[((_samplerate)>>2)]; //@line 842 "speak.cpp"
              var $call147=__ZL12OpenWaveFilePKci(((_wavefile)&4294967295), $95); //@line 842 "speak.cpp"
              var $cmp148=((($call147))|0)!=0; //@line 842 "speak.cpp"
              if (!($cmp148)) { __label__ = 73;break $if_then132$$if_else134$83; } //@line 842 "speak.cpp"
  
              var $96=HEAP32[((__impure_ptr)>>2)]; //@line 844 "speak.cpp"
              var $_stderr150=(($96+12)&4294967295); //@line 844 "speak.cpp"
              var $97=HEAP32[(($_stderr150)>>2)]; //@line 844 "speak.cpp"
              var $call151=_fprintf($97, ((__str28)&4294967295), allocate([((_wavefile)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 844 "speak.cpp"
              _exit(3); //@line 845 "speak.cpp"
              ; //@line 846 "speak.cpp"
            }
          }
        } while(0);
  
        __Z8InitTexti(0); //@line 849 "speak.cpp"
        var $98=$f_text; //@line 850 "speak.cpp"
        var $99=$p_text; //@line 850 "speak.cpp"
        var $call155=__Z15SpeakNextClauseP7__sFILEPKvi($98, $99, 0); //@line 850 "speak.cpp"
        $ix=1; //@line 852 "speak.cpp"
        ; //@line 853 "speak.cpp"
        while(1) { 
  
          var $call156=__ZL11WavegenFilev(); //@line 855 "speak.cpp"
          var $cmp157=((($call156))|0)!=0; //@line 855 "speak.cpp"
          if ($cmp157) { __label__ = 75;; } else { __label__ = 76;; } //@line 855 "speak.cpp"
          if (__label__ == 75) {
  
            var $100=$ix; //@line 857 "speak.cpp"
            var $cmp159=((($100))|0)==0; //@line 857 "speak.cpp"
            if ($cmp159) { __label__ = 78;break ; } //@line 857 "speak.cpp"
          }
  
          var $call163=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 1); //@line 861 "speak.cpp"
          var $cmp164=((($call163))|0)==0; //@line 861 "speak.cpp"
          if (!($cmp164)) { __label__ = 74;continue ; } //@line 861 "speak.cpp"
  
          var $call166=__Z15SpeakNextClauseP7__sFILEPKvi(0, 0, 1); //@line 863 "speak.cpp"
          $ix=$call166; //@line 863 "speak.cpp"
          __label__ = 74;continue ; //@line 864 "speak.cpp"
        }
  
        __ZL13CloseWaveFilev(); //@line 867 "speak.cpp"
        __label__ = 83;break $if_then130$$if_else168$81; //@line 868 "speak.cpp"
      }
      else if (__label__ == 79) {
  
        __Z8InitTexti(0); //@line 877 "speak.cpp"
        var $101=$f_text; //@line 878 "speak.cpp"
        var $102=$p_text; //@line 878 "speak.cpp"
        var $call170=__Z15SpeakNextClauseP7__sFILEPKvi($101, $102, 0); //@line 878 "speak.cpp"
        var $103=HEAP32[((_option_quiet)>>2)]; //@line 880 "speak.cpp"
        var $tobool171=((($103))|0)!=0; //@line 880 "speak.cpp"
        if ($tobool171) { __label__ = 80;; } else { __label__ = 82;; } //@line 880 "speak.cpp"
        if (__label__ == 80) {
          while(1) { 
  
            var $call173=__Z15SpeakNextClauseP7__sFILEPKvi(0, 0, 1); //@line 882 "speak.cpp"
            var $cmp174=((($call173))|0)!=0; //@line 882 "speak.cpp"
            if ($cmp174) { __label__ = 80;continue ; } else { __label__ = 81;break ; } //@line 882 "speak.cpp"
          }
  
          $retval=0; //@line 883 "speak.cpp"
          __label__ = 87;break $if_then130$$if_else168$81; //@line 883 "speak.cpp"
        }
        else if (__label__ == 82) {
  
          var $104=HEAP32[((__impure_ptr)>>2)]; //@line 909 "speak.cpp"
          var $_stderr178=(($104+12)&4294967295); //@line 909 "speak.cpp"
          var $105=HEAP32[(($_stderr178)>>2)]; //@line 909 "speak.cpp"
          var $106=_fwrite(((__str29)&4294967295), 79, 1, $105); //@line 909 "speak.cpp"
          __label__ = 83;break $if_then130$$if_else168$81;
        }
      }
    } while(0);
    if (__label__ == 83) {
  
      var $107=HEAP32[((_f_trans)>>2)]; //@line 913 "speak.cpp"
      var $108=HEAP32[((__impure_ptr)>>2)]; //@line 913 "speak.cpp"
      var $_stdout181=(($108+8)&4294967295); //@line 913 "speak.cpp"
      var $109=HEAP32[(($_stdout181)>>2)]; //@line 913 "speak.cpp"
      var $cmp182=((($107))|0)!=((($109))|0); //@line 913 "speak.cpp"
      if ($cmp182) { __label__ = 84;; } else { __label__ = 86;; } //@line 913 "speak.cpp"
      $land_lhs_true183$$if_end188$108: do { 
        if (__label__ == 84) {
  
          var $110=HEAP32[((_f_trans)>>2)]; //@line 913 "speak.cpp"
          var $111=HEAP32[((__impure_ptr)>>2)]; //@line 913 "speak.cpp"
          var $_stderr184=(($111+12)&4294967295); //@line 913 "speak.cpp"
          var $112=HEAP32[(($_stderr184)>>2)]; //@line 913 "speak.cpp"
          var $cmp185=((($110))|0)!=((($112))|0); //@line 913 "speak.cpp"
          if (!($cmp185)) { __label__ = 86;break $land_lhs_true183$$if_end188$108; } //@line 913 "speak.cpp"
  
          var $113=HEAP32[((_f_trans)>>2)]; //@line 914 "speak.cpp"
          var $call187=_fclose($113); //@line 914 "speak.cpp"
          ; //@line 914 "speak.cpp"
        }
      } while(0);
  
      $retval=0; //@line 915 "speak.cpp"
      ; //@line 915 "speak.cpp"
    }
  
    var $114=$retval; //@line 916 "speak.cpp"
    ;
    return $114; //@line 916 "speak.cpp"
    return null;
  }
  Module["_main"] = _main;

  function __ZL9init_pathPcS_($argv0, $path_specified) {
    ;
    var __label__;
  
    var $argv0_addr;
    var $path_specified_addr;
    var $env;
    $argv0_addr=$argv0;
    $path_specified_addr=$path_specified;
    var $0=$path_specified_addr; //@line 341 "speak.cpp"
    var $tobool=((($0))|0)!=0; //@line 341 "speak.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 341 "speak.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$path_specified_addr; //@line 343 "speak.cpp"
        var $call=_sprintf(((_path_home)&4294967295), ((__str38)&4294967295), allocate([$1,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 343 "speak.cpp"
        ; //@line 344 "speak.cpp"
      }
      else if (__label__ == 2) {
  
        var $call1=_getenv(((__str39)&4294967295)); //@line 383 "speak.cpp"
        $env=$call1; //@line 383 "speak.cpp"
        var $cmp=((($call1))|0)!=0; //@line 383 "speak.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 383 "speak.cpp"
        if (__label__ == 3) {
  
          var $2=$env; //@line 385 "speak.cpp"
          var $call3=_snprintf(((_path_home)&4294967295), 150, ((__str38)&4294967295), allocate([$2,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 385 "speak.cpp"
          var $call4=__Z13GetFileLengthPKc(((_path_home)&4294967295)); //@line 386 "speak.cpp"
          var $cmp5=((($call4))|0)==-2; //@line 386 "speak.cpp"
          if ($cmp5) { __label__ = 6;break $if_then$$if_end$2; } //@line 386 "speak.cpp"
        }
  
        var $call9=_getenv(((__str40)&4294967295)); //@line 390 "speak.cpp"
        var $call10=_snprintf(((_path_home)&4294967295), 150, ((__str38)&4294967295), allocate([$call9,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 390 "speak.cpp"
        var $call11=_access(((_path_home)&4294967295), 4); //@line 391 "speak.cpp"
        var $cmp12=((($call11))|0)!=0; //@line 391 "speak.cpp"
        if (!($cmp12)) { __label__ = 6;break $if_then$$if_end$2; } //@line 391 "speak.cpp"
  
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = ((__str41)&4294967295);
        $dest$ = ((_path_home)&4294967295);
        $stop$ = $src$ + 23;
        if (($dest$%4) == ($src$%4) && 23 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 393 "speak.cpp"
        ; //@line 394 "speak.cpp"
      }
    } while(0);
  
    ;
    return; //@line 397 "speak.cpp"
    return;
  }
  

  function __ZL10initialisev() {
    ;
    var __label__;
  
    var $param;
    var $result;
    var $call=_setlocale(2, ((__str32)&4294967295)); //@line 411 "speak.cpp"
    var $cmp=((($call))|0)==0; //@line 411 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 411 "speak.cpp"
    $if_then$$if_end5$2: do { 
      if (__label__ == 1) {
  
        var $call1=_setlocale(2, ((__str33)&4294967295)); //@line 413 "speak.cpp"
        var $cmp2=((($call1))|0)==0; //@line 413 "speak.cpp"
        if (!($cmp2)) { __label__ = 3;break $if_then$$if_end5$2; } //@line 413 "speak.cpp"
  
        var $call4=_setlocale(2, ((__str13643)&4294967295)); //@line 414 "speak.cpp"
        ; //@line 414 "speak.cpp"
      }
    } while(0);
  
    __Z11WavegenInitii(22050, 0); //@line 419 "speak.cpp"
    var $call6=__Z10LoadPhDatav(); //@line 420 "speak.cpp"
    $result=$call6; //@line 420 "speak.cpp"
    var $cmp7=((($call6))|0)!=1; //@line 420 "speak.cpp"
    if ($cmp7) { __label__ = 4;; } else { __label__ = 7;; } //@line 420 "speak.cpp"
    if (__label__ == 4) {
  
      var $0=$result; //@line 422 "speak.cpp"
      var $cmp9=((($0))|0)==-1; //@line 422 "speak.cpp"
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 424 "speak.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 424 "speak.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 424 "speak.cpp"
      if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 422 "speak.cpp"
      if (__label__ == 5) {
  
        var $3=_fwrite(((__str35)&4294967295), 27, 1, $2); //@line 424 "speak.cpp"
        _exit(1); //@line 425 "speak.cpp"
        ; //@line 426 "speak.cpp"
      }
      else if (__label__ == 6) {
  
        var $4=$result; //@line 428 "speak.cpp"
        var $call13=_fprintf($2, ((__str36)&4294967295), allocate([$4,0,0,0,83200,0,0,0,((_path_home)&4294967295),0,0,0], ["i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 428 "speak.cpp"
        ;
      }
    }
  
    __Z10LoadConfigv(); //@line 430 "speak.cpp"
    __Z13SetVoiceStackP12espeak_VOICE(0); //@line 431 "speak.cpp"
    __Z14SynthesizeInitv(); //@line 432 "speak.cpp"
    $param=0; //@line 434 "speak.cpp"
    ; //@line 434 "speak.cpp"
    while(1) { 
  
      var $5=$param; //@line 435 "speak.cpp"
      var $arrayidx=((_param_defaults+$5*4)&4294967295); //@line 435 "speak.cpp"
      var $6=HEAP32[(($arrayidx)>>2)]; //@line 435 "speak.cpp"
      var $7=$param; //@line 435 "speak.cpp"
      var $arrayidx17=((((_param_stack+4)&4294967295)+$7*4)&4294967295); //@line 435 "speak.cpp"
      HEAP32[(($arrayidx17)>>2)]=$6; //@line 435 "speak.cpp"
      var $8=$param; //@line 434 "speak.cpp"
      var $inc=((($8)+1)&4294967295); //@line 434 "speak.cpp"
      $param=$inc; //@line 434 "speak.cpp"
      var $cmp16=((($inc))|0) < 15; //@line 434 "speak.cpp"
      if ($cmp16) { __label__ = 8;continue ; } else { __label__ = 9;break ; } //@line 434 "speak.cpp"
    }
  
    ;
    return;
    return;
  }
  

  function __ZL12OpenWaveFilePKci($path, $rate) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $path_addr;
    var $rate_addr;
    $path_addr=$path;
    $rate_addr=$rate;
    var $0=$path_addr; //@line 235 "speak.cpp"
    var $cmp=((($0))|0)==0; //@line 235 "speak.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 235 "speak.cpp"
    if (__label__ == 1) {
  
      $retval=2; //@line 236 "speak.cpp"
      ; //@line 236 "speak.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$path_addr; //@line 238 "speak.cpp"
      var $call=_strcmp($1, ((__str12)&4294967295)); //@line 238 "speak.cpp"
      var $cmp1=((($call))|0)==0; //@line 238 "speak.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 238 "speak.cpp"
      if (__label__ == 3) {
  
        var $2=HEAP32[((__impure_ptr)>>2)]; //@line 244 "speak.cpp"
        var $_stdout=(($2+8)&4294967295); //@line 244 "speak.cpp"
        var $3=HEAP32[(($_stdout)>>2)]; //@line 244 "speak.cpp"
        HEAP32[((_f_wave)>>2)]=$3; //@line 244 "speak.cpp"
        __lastLabel__ = 3; ; //@line 245 "speak.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$path_addr; //@line 247 "speak.cpp"
        var $call3=_fopen($4, ((__str79)&4294967295)); //@line 247 "speak.cpp"
        HEAP32[((_f_wave)>>2)]=$call3; //@line 247 "speak.cpp"
        __lastLabel__ = 4; ;
      }
  
      var $5=__lastLabel__ == 4 ? $call3 : ($3); //@line 249 "speak.cpp"
      var $cmp5=((($5))|0)!=0; //@line 249 "speak.cpp"
      if ($cmp5) { __label__ = 6;; } else { __label__ = 7;; } //@line 249 "speak.cpp"
      if (__label__ == 6) {
  
        var $6=HEAP32[((_f_wave)>>2)]; //@line 251 "speak.cpp"
        var $call7=_fwrite(((__ZZL12OpenWaveFilePKciE8wave_hdr)&4294967295), 1, 24, $6); //@line 251 "speak.cpp"
        var $7=HEAP32[((_f_wave)>>2)]; //@line 252 "speak.cpp"
        var $8=$rate_addr; //@line 252 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($7, $8); //@line 252 "speak.cpp"
        var $9=HEAP32[((_f_wave)>>2)]; //@line 253 "speak.cpp"
        var $10=$rate_addr; //@line 253 "speak.cpp"
        var $mul=((($10)*2)&4294967295); //@line 253 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($9, $mul); //@line 253 "speak.cpp"
        var $11=HEAP32[((_f_wave)>>2)]; //@line 254 "speak.cpp"
        var $call8=_fwrite(((__ZZL12OpenWaveFilePKciE8wave_hdr+32)&4294967295), 1, 12, $11); //@line 254 "speak.cpp"
        $retval=0; //@line 255 "speak.cpp"
        ; //@line 255 "speak.cpp"
      }
      else if (__label__ == 7) {
  
        $retval=1; //@line 257 "speak.cpp"
        ; //@line 257 "speak.cpp"
      }
    }
  
    var $12=$retval; //@line 258 "speak.cpp"
    ;
    return $12; //@line 258 "speak.cpp"
    return null;
  }
  

  function __ZL11WavegenFilev() {
    var __stackBase__  = STACKTOP; STACKTOP += 1236; _memset(__stackBase__, 0, 1236);
    var __label__;
  
    var $retval;
    var $finished;
    var $wav_outbuf=__stackBase__;
    var $fname=__stackBase__+1024;
    var $arraydecay=(($wav_outbuf)&4294967295); //@line 303 "speak.cpp"
    HEAP32[((_out_start)>>2)]=$arraydecay; //@line 303 "speak.cpp"
    HEAP32[((_out_ptr)>>2)]=$arraydecay; //@line 303 "speak.cpp"
    var $arraydecay1=(($wav_outbuf)&4294967295); //@line 304 "speak.cpp"
    var $add_ptr=(($arraydecay1+1024)&4294967295); //@line 304 "speak.cpp"
    HEAP32[((_out_end)>>2)]=$add_ptr; //@line 304 "speak.cpp"
    var $call=__Z11WavegenFilli(0); //@line 306 "speak.cpp"
    $finished=$call; //@line 306 "speak.cpp"
    var $0=HEAP32[((_quiet)>>2)]; //@line 308 "speak.cpp"
    var $tobool=((($0))|0)!=0; //@line 308 "speak.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 308 "speak.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$finished; //@line 309 "speak.cpp"
        $retval=$1; //@line 309 "speak.cpp"
        ; //@line 309 "speak.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=HEAP32[((_f_wave)>>2)]; //@line 311 "speak.cpp"
        var $cmp=((($2))|0)==0; //@line 311 "speak.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 5;; } //@line 311 "speak.cpp"
        $if_then2$$if_end10$5: do { 
          if (__label__ == 3) {
  
            var $arraydecay3=(($fname)&4294967295); //@line 313 "speak.cpp"
            var $3=HEAP32[((_wavefile_count)>>2)]; //@line 313 "speak.cpp"
            var $inc=((($3)+1)&4294967295); //@line 313 "speak.cpp"
            HEAP32[((_wavefile_count)>>2)]=$inc; //@line 313 "speak.cpp"
            var $call4=_sprintf($arraydecay3, ((__str30)&4294967295), allocate([((_wavefile)&4294967295),0,0,0,$inc,0,0,0,((_filetype)&4294967295),0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 313 "speak.cpp"
            var $arraydecay5=(($fname)&4294967295); //@line 314 "speak.cpp"
            var $4=HEAP32[((_samplerate)>>2)]; //@line 314 "speak.cpp"
            var $call6=__ZL12OpenWaveFilePKci($arraydecay5, $4); //@line 314 "speak.cpp"
            var $cmp7=((($call6))|0)!=0; //@line 314 "speak.cpp"
            if (!($cmp7)) { __label__ = 5;break $if_then2$$if_end10$5; } //@line 314 "speak.cpp"
  
            $retval=1; //@line 315 "speak.cpp"
            __label__ = 12;break $if_then$$if_end$2; //@line 315 "speak.cpp"
          }
        } while(0);
  
        var $5=HEAP32[((_end_of_sentence)>>2)]; //@line 318 "speak.cpp"
        var $tobool11=((($5))|0)!=0; //@line 318 "speak.cpp"
        if ($tobool11) { __label__ = 6;; } else { __label__ = 9;; } //@line 318 "speak.cpp"
        $if_then12$$if_end17$9: do { 
          if (__label__ == 6) {
  
            HEAP32[((_end_of_sentence)>>2)]=0; //@line 320 "speak.cpp"
            var $6=HEAPU32[((_samples_split)>>2)]; //@line 321 "speak.cpp"
            var $cmp13=((($6))>>>0) > 0; //@line 321 "speak.cpp"
            if (!($cmp13)) { __label__ = 9;break $if_then12$$if_end17$9; } //@line 321 "speak.cpp"
  
            var $7=HEAPU32[((_samples_total)>>2)]; //@line 321 "speak.cpp"
            var $8=HEAPU32[((_samples_split)>>2)]; //@line 321 "speak.cpp"
            var $cmp14=((($7))>>>0) > ((($8))>>>0); //@line 321 "speak.cpp"
            if (!($cmp14)) { __label__ = 9;break $if_then12$$if_end17$9; } //@line 321 "speak.cpp"
  
            __ZL13CloseWaveFilev(); //@line 323 "speak.cpp"
            HEAP32[((_samples_total)>>2)]=0; //@line 324 "speak.cpp"
            ; //@line 325 "speak.cpp"
          }
        } while(0);
  
        var $9=HEAP32[((_f_wave)>>2)]; //@line 328 "speak.cpp"
        var $cmp18=((($9))|0)!=0; //@line 328 "speak.cpp"
        if ($cmp18) { __label__ = 10;; } else { __label__ = 11;; } //@line 328 "speak.cpp"
        if (__label__ == 10) {
  
          var $10=HEAP32[((_out_ptr)>>2)]; //@line 330 "speak.cpp"
          var $arraydecay20=(($wav_outbuf)&4294967295); //@line 330 "speak.cpp"
          var $sub_ptr_lhs_cast=($10); //@line 330 "speak.cpp"
          var $sub_ptr_rhs_cast=($arraydecay20); //@line 330 "speak.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 330 "speak.cpp"
          var $div=((((($sub_ptr_sub))|0)/2)|0); //@line 330 "speak.cpp"
          var $11=HEAP32[((_samples_total)>>2)]; //@line 330 "speak.cpp"
          var $add=((($11)+($div))&4294967295); //@line 330 "speak.cpp"
          HEAP32[((_samples_total)>>2)]=$add; //@line 330 "speak.cpp"
          var $arraydecay21=(($wav_outbuf)&4294967295); //@line 331 "speak.cpp"
          var $12=HEAP32[((_out_ptr)>>2)]; //@line 331 "speak.cpp"
          var $arraydecay22=(($wav_outbuf)&4294967295); //@line 331 "speak.cpp"
          var $sub_ptr_lhs_cast23=($12); //@line 331 "speak.cpp"
          var $sub_ptr_rhs_cast24=($arraydecay22); //@line 331 "speak.cpp"
          var $sub_ptr_sub25=((($sub_ptr_lhs_cast23)-($sub_ptr_rhs_cast24))&4294967295); //@line 331 "speak.cpp"
          var $13=HEAP32[((_f_wave)>>2)]; //@line 331 "speak.cpp"
          var $call26=_fwrite($arraydecay21, 1, $sub_ptr_sub25, $13); //@line 331 "speak.cpp"
          ; //@line 332 "speak.cpp"
        }
  
        var $14=$finished; //@line 333 "speak.cpp"
        $retval=$14; //@line 333 "speak.cpp"
        ; //@line 333 "speak.cpp"
      }
    } while(0);
  
    var $15=$retval; //@line 334 "speak.cpp"
    STACKTOP = __stackBase__;
    return $15; //@line 334 "speak.cpp"
    return null;
  }
  

  function __ZL13CloseWaveFilev() {
    ;
    var __label__;
  
    var $pos;
    var $0=HEAP32[((_f_wave)>>2)]; //@line 268 "speak.cpp"
    var $cmp=((($0))|0)==0; //@line 268 "speak.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 1;; } //@line 268 "speak.cpp"
    $return$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_f_wave)>>2)]; //@line 268 "speak.cpp"
        var $2=HEAP32[((__impure_ptr)>>2)]; //@line 268 "speak.cpp"
        var $_stdout=(($2+8)&4294967295); //@line 268 "speak.cpp"
        var $3=HEAP32[(($_stdout)>>2)]; //@line 268 "speak.cpp"
        var $cmp1=((($1))|0)==((($3))|0); //@line 268 "speak.cpp"
        if ($cmp1) { __label__ = 3;break $return$$lor_lhs_false$2; } //@line 268 "speak.cpp"
  
        var $4=HEAP32[((_f_wave)>>2)]; //@line 271 "speak.cpp"
        var $call=_fflush($4); //@line 271 "speak.cpp"
        var $5=HEAP32[((_f_wave)>>2)]; //@line 272 "speak.cpp"
        var $call2=_ftell($5); //@line 272 "speak.cpp"
        $pos=$call2; //@line 272 "speak.cpp"
        var $6=HEAP32[((_f_wave)>>2)]; //@line 274 "speak.cpp"
        var $call3=_fseek($6, 4, 0); //@line 274 "speak.cpp"
        var $7=HEAP32[((_f_wave)>>2)]; //@line 275 "speak.cpp"
        var $8=$pos; //@line 275 "speak.cpp"
        var $sub=((($8)-8)&4294967295); //@line 275 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($7, $sub); //@line 275 "speak.cpp"
        var $9=HEAP32[((_f_wave)>>2)]; //@line 277 "speak.cpp"
        var $call4=_fseek($9, 40, 0); //@line 277 "speak.cpp"
        var $10=HEAP32[((_f_wave)>>2)]; //@line 278 "speak.cpp"
        var $11=$pos; //@line 278 "speak.cpp"
        var $sub5=((($11)-44)&4294967295); //@line 278 "speak.cpp"
        __Z11Write4BytesP7__sFILEi($10, $sub5); //@line 278 "speak.cpp"
        var $12=HEAP32[((_f_wave)>>2)]; //@line 281 "speak.cpp"
        var $call6=_fclose($12); //@line 281 "speak.cpp"
        HEAP32[((_f_wave)>>2)]=0; //@line 282 "speak.cpp"
        ; //@line 284 "speak.cpp"
      }
    } while(0);
  
    ;
    return; //@line 284 "speak.cpp"
    return;
  }
  

  function __Z8isspace2j($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $c2;
    $c_addr=$c;
    var $0=$c_addr; //@line 150 "compiledict.cpp"
    var $and=($0) & 255; //@line 150 "compiledict.cpp"
    $c2=$and; //@line 150 "compiledict.cpp"
    var $cmp=((($and))|0)==0; //@line 150 "compiledict.cpp"
    var $1=$c_addr; //@line 150 "compiledict.cpp"
    var $cmp1=((($1))>>>0) > 32; //@line 150 "compiledict.cpp"
    var $or_cond=($cmp) | ($cmp1); //@line 150 "compiledict.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 150 "compiledict.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 151 "compiledict.cpp"
      ; //@line 151 "compiledict.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=1; //@line 152 "compiledict.cpp"
      ; //@line 152 "compiledict.cpp"
    }
  
    var $2=$retval; //@line 153 "compiledict.cpp"
    ;
    return $2; //@line 153 "compiledict.cpp"
    return null;
  }
  

  function __Z14LookupMnemNameP8MNEM_TABi($table, $value) {
    ;
    var __label__;
  
    var $retval;
    var $table_addr;
    var $value_addr;
    $table_addr=$table;
    $value_addr=$value;
    ; //@line 175 "compiledict.cpp"
    while(1) { 
  
      var $0=$table_addr; //@line 175 "compiledict.cpp"
      var $mnem=(($0)&4294967295); //@line 175 "compiledict.cpp"
      var $1=HEAP32[(($mnem)>>2)]; //@line 175 "compiledict.cpp"
      var $cmp=((($1))|0)!=0; //@line 175 "compiledict.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 175 "compiledict.cpp"
  
      var $2=$table_addr; //@line 177 "compiledict.cpp"
      var $value1=(($2+4)&4294967295); //@line 177 "compiledict.cpp"
      var $3=HEAP32[(($value1)>>2)]; //@line 177 "compiledict.cpp"
      var $4=$value_addr; //@line 177 "compiledict.cpp"
      var $cmp2=((($3))|0)==((($4))|0); //@line 177 "compiledict.cpp"
      var $5=$table_addr; //@line 178 "compiledict.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 177 "compiledict.cpp"
  
      var $incdec_ptr=(($5+8)&4294967295); //@line 179 "compiledict.cpp"
      $table_addr=$incdec_ptr; //@line 179 "compiledict.cpp"
      __label__ = 1;continue ; //@line 180 "compiledict.cpp"
    }
    if (__label__ == 5) {
  
      $retval=((__str13643)&4294967295); //@line 181 "compiledict.cpp"
      ; //@line 181 "compiledict.cpp"
    }
    else if (__label__ == 3) {
  
      var $mnem3=(($5)&4294967295); //@line 178 "compiledict.cpp"
      var $6=HEAP32[(($mnem3)>>2)]; //@line 178 "compiledict.cpp"
      $retval=$6; //@line 178 "compiledict.cpp"
      ; //@line 178 "compiledict.cpp"
    }
  
    var $7=$retval; //@line 182 "compiledict.cpp"
    ;
    return $7; //@line 182 "compiledict.cpp"
    return null;
  }
  

  function __Z22print_dictionary_flagsPj($flags) {
    ;
    var __label__;
  
    var $flags_addr;
    $flags_addr=$flags;
    var $0=$flags_addr; //@line 189 "compiledict.cpp"
    var $arrayidx=(($0)&4294967295); //@line 189 "compiledict.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 189 "compiledict.cpp"
    var $and=($1) & 15; //@line 189 "compiledict.cpp"
    var $add=((($and)+64)&4294967295); //@line 189 "compiledict.cpp"
    var $call=__Z14LookupMnemNameP8MNEM_TABi(((_mnem_flags)&4294967295), $add); //@line 189 "compiledict.cpp"
    var $2=$flags_addr; //@line 189 "compiledict.cpp"
    var $arrayidx1=(($2)&4294967295); //@line 189 "compiledict.cpp"
    var $3=HEAP32[(($arrayidx1)>>2)]; //@line 189 "compiledict.cpp"
    var $4=$flags_addr; //@line 189 "compiledict.cpp"
    var $arrayidx2=(($4+4)&4294967295); //@line 189 "compiledict.cpp"
    var $5=HEAP32[(($arrayidx2)>>2)]; //@line 189 "compiledict.cpp"
    var $call3=_sprintf(((__ZZ22print_dictionary_flagsPjE3buf)&4294967295), ((__str59)&4294967295), allocate([$call,0,0,0,$3,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 189 "compiledict.cpp"
    ;
    return ((__ZZ22print_dictionary_flagsPjE3buf)&4294967295); //@line 190 "compiledict.cpp"
    return null;
  }
  

  function __Z10DecodeRulePKciPci($group_chars, $group_length, $rule, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 140; _memset(__stackBase__, 0, 140);
    var __label__;
    var __lastLabel__ = null;
  
    var $group_chars_addr;
    var $group_length_addr;
    var $rule_addr;
    var $control_addr;
    var $rb;
    var $c;
    var $p;
    var $ix;
    var $match_type;
    var $finished;
    var $value;
    var $linenum;
    var $flags;
    var $suffix_char;
    var $condition_num;
    var $at_start;
    var $name;
    var $buf=__stackBase__;
    var $buf_pre=__stackBase__+60;
    var $suffix=__stackBase__+120;
    $group_chars_addr=$group_chars;
    $group_length_addr=$group_length;
    $rule_addr=$rule;
    $control_addr=$control;
    $finished=0; //@line 205 "compiledict.cpp"
    $linenum=0; //@line 207 "compiledict.cpp"
    $condition_num=0; //@line 210 "compiledict.cpp"
    $at_start=0; //@line 211 "compiledict.cpp"
    $match_type=0; //@line 223 "compiledict.cpp"
    var $arrayidx=(($buf_pre)&4294967295); //@line 224 "compiledict.cpp"
    HEAP8[($arrayidx)]=0; //@line 224 "compiledict.cpp"
    $ix=0; //@line 226 "compiledict.cpp"
    var $0=$ix; //@line 226 "compiledict.cpp"
    var $1=$group_length_addr; //@line 226 "compiledict.cpp"
    var $cmp9=((($0))|0) < ((($1))|0); //@line 226 "compiledict.cpp"
    var $2=$ix; //@line 228 "compiledict.cpp"
    if ($cmp9) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 226 "compiledict.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $10 : ($2);
          var $4=$group_chars_addr; //@line 228 "compiledict.cpp"
          var $arrayidx1=(($4+$3)&4294967295); //@line 228 "compiledict.cpp"
          var $5=HEAP8[($arrayidx1)]; //@line 228 "compiledict.cpp"
          var $6=$ix; //@line 228 "compiledict.cpp"
          var $arrayidx2=(($buf+$6)&4294967295); //@line 228 "compiledict.cpp"
          HEAP8[($arrayidx2)]=$5; //@line 228 "compiledict.cpp"
          var $7=$ix; //@line 226 "compiledict.cpp"
          var $inc=((($7)+1)&4294967295); //@line 226 "compiledict.cpp"
          $ix=$inc; //@line 226 "compiledict.cpp"
          var $8=$ix; //@line 226 "compiledict.cpp"
          var $9=$group_length_addr; //@line 226 "compiledict.cpp"
          var $cmp=((($8))|0) < ((($9))|0); //@line 226 "compiledict.cpp"
          var $10=$ix; //@line 228 "compiledict.cpp"
          if ($cmp) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $for_body$$for_end$2; } //@line 226 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $_lcssa8=__lastLabel__ == 0 ? $2 : ($10);
    var $arrayidx3=(($buf+$_lcssa8)&4294967295); //@line 230 "compiledict.cpp"
    HEAP8[($arrayidx3)]=0; //@line 230 "compiledict.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 232 "compiledict.cpp"
    var $call=_strlen($arraydecay); //@line 232 "compiledict.cpp"
    var $arrayidx4=(($buf+$call)&4294967295); //@line 232 "compiledict.cpp"
    $p=$arrayidx4; //@line 232 "compiledict.cpp"
    var $11=$finished; //@line 233 "compiledict.cpp"
    var $tobool6=((($11))|0)!=0; //@line 233 "compiledict.cpp"
    var $lnot7=($tobool6) ^ 1; //@line 233 "compiledict.cpp"
    if ($lnot7) { __label__ = 3;; } else { __label__ = 38;; } //@line 233 "compiledict.cpp"
    $while_body_lr_ph$$while_end$6: do { 
      if (__label__ == 3) {
  
        var $arraydecay9=(($buf_pre)&4294967295); //@line 250 "compiledict.cpp"
        var $arraydecay11=(($buf)&4294967295); //@line 255 "compiledict.cpp"
        var $arraydecay13=(($buf)&4294967295); //@line 256 "compiledict.cpp"
        var $arraydecay58=(($suffix)&4294967295); //@line 293 "compiledict.cpp"
        var $arraydecay70=(($suffix)&4294967295); //@line 298 "compiledict.cpp"
        var $arraydecay80=(($suffix)&4294967295); //@line 301 "compiledict.cpp"
        var $arraydecay82=(($suffix)&4294967295); //@line 302 "compiledict.cpp"
        ; //@line 233 "compiledict.cpp"
        $while_body$8: while(1) { 
  
          var $12=$rule_addr; //@line 235 "compiledict.cpp"
          var $incdec_ptr=(($12+1)&4294967295); //@line 235 "compiledict.cpp"
          $rule_addr=$incdec_ptr; //@line 235 "compiledict.cpp"
          var $13=HEAP8[($12)]; //@line 235 "compiledict.cpp"
          $rb=$13; //@line 235 "compiledict.cpp"
          var $14=$rb; //@line 237 "compiledict.cpp"
          var $conv=((($14))&255); //@line 237 "compiledict.cpp"
          var $cmp5=((($conv))|0) <= 9; //@line 237 "compiledict.cpp"
          var $15=$rb; //@line 239 "compiledict.cpp"
          var $conv6=((($15))&255); //@line 239 "compiledict.cpp"
          if ($cmp5) { __label__ = 5;; } else { __label__ = 12;; } //@line 237 "compiledict.cpp"
          $if_then$$if_end$10: do { 
            if (__label__ == 5) {
  
              if ($conv6 == 0) {
                __label__ = 6;;
              }
              else if ($conv6 == 3) {
                __label__ = 6;;
              }
              else if ($conv6 == 8) {
                __label__ = 7;;
              }
              else if ($conv6 == 1) {
                __label__ = 8;;
              }
              else if ($conv6 == 2) {
                __label__ = 9;;
              }
              else if ($conv6 == 9) {
                __label__ = 11;;
              }
              else if ($conv6 == 5) {
                __label__ = 10;;
              }
              else {
              __label__ = 37;break $if_then$$if_end$10;
              }
              
              if (__label__ == 6) {
  
                $finished=1; //@line 243 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 244 "compiledict.cpp"
              }
              else if (__label__ == 7) {
  
                $at_start=1; //@line 246 "compiledict.cpp"
                ; //@line 246 "compiledict.cpp"
              }
              else if (__label__ == 9) {
  
                $match_type=2; //@line 253 "compiledict.cpp"
                var $17=$p; //@line 254 "compiledict.cpp"
                HEAP8[($17)]=0; //@line 254 "compiledict.cpp"
                var $strlen=_strlen($arraydecay11); //@line 255 "compiledict.cpp"
                var $endptr=(($arraydecay11+$strlen)&4294967295); //@line 255 "compiledict.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__str60)&4294967295);
                $dest$ = $endptr;
                $stop$ = $src$ + 3;
                if (($dest$%4) == ($src$%4) && 3 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 255 "compiledict.cpp"
                var $call14=_strlen($arraydecay13); //@line 256 "compiledict.cpp"
                var $arrayidx15=(($buf+$call14)&4294967295); //@line 256 "compiledict.cpp"
                $p=$arrayidx15; //@line 256 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 257 "compiledict.cpp"
              }
              else if (__label__ == 11) {
  
                var $20=$rule_addr; //@line 265 "compiledict.cpp"
                var $arrayidx20=(($20+1)&4294967295); //@line 265 "compiledict.cpp"
                var $21=HEAP8[($arrayidx20)]; //@line 265 "compiledict.cpp"
                var $conv21=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 265 "compiledict.cpp"
                var $and=($conv21) & 255; //@line 265 "compiledict.cpp"
                var $sub=((($and)-1)&4294967295); //@line 265 "compiledict.cpp"
                $value=$sub; //@line 265 "compiledict.cpp"
                var $22=$rule_addr; //@line 266 "compiledict.cpp"
                var $arrayidx22=(($22)&4294967295); //@line 266 "compiledict.cpp"
                var $23=HEAP8[($arrayidx22)]; //@line 266 "compiledict.cpp"
                var $conv23=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 266 "compiledict.cpp"
                var $and24=($conv23) & 255; //@line 266 "compiledict.cpp"
                var $24=$value; //@line 266 "compiledict.cpp"
                var $mul=((($24)*255)&4294967295); //@line 266 "compiledict.cpp"
                var $sub25=((($mul)-1)&4294967295); //@line 266 "compiledict.cpp"
                var $add=((($sub25)+($and24))&4294967295); //@line 266 "compiledict.cpp"
                $linenum=$add; //@line 266 "compiledict.cpp"
                var $25=$rule_addr; //@line 267 "compiledict.cpp"
                var $add_ptr=(($25+2)&4294967295); //@line 267 "compiledict.cpp"
                $rule_addr=$add_ptr; //@line 267 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 268 "compiledict.cpp"
              }
              else if (__label__ == 10) {
  
                var $18=$rule_addr; //@line 262 "compiledict.cpp"
                var $incdec_ptr17=(($18+1)&4294967295); //@line 262 "compiledict.cpp"
                $rule_addr=$incdec_ptr17; //@line 262 "compiledict.cpp"
                var $19=HEAP8[($18)]; //@line 262 "compiledict.cpp"
                var $conv18=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 262 "compiledict.cpp"
                $condition_num=$conv18; //@line 262 "compiledict.cpp"
                __label__ = 37;break $if_then$$if_end$10; //@line 263 "compiledict.cpp"
              }
  
              $match_type=1; //@line 248 "compiledict.cpp"
              var $16=$p; //@line 249 "compiledict.cpp"
              HEAP8[($16)]=0; //@line 249 "compiledict.cpp"
              $p=$arraydecay9; //@line 250 "compiledict.cpp"
              ; //@line 251 "compiledict.cpp"
            }
            else if (__label__ == 12) {
  
              var $cmp27=((($conv6))|0)==28; //@line 273 "compiledict.cpp"
              if ($cmp27) { __label__ = 13;; } else { __label__ = 17;; } //@line 273 "compiledict.cpp"
              if (__label__ == 13) {
  
                var $26=$rule_addr; //@line 275 "compiledict.cpp"
                var $incdec_ptr29=(($26+1)&4294967295); //@line 275 "compiledict.cpp"
                $rule_addr=$incdec_ptr29; //@line 275 "compiledict.cpp"
                var $27=HEAP8[($26)]; //@line 275 "compiledict.cpp"
                var $conv30=(tempInt=(($27)),(tempInt>=128?tempInt-256:tempInt)); //@line 275 "compiledict.cpp"
                var $and31=($conv30) & 255; //@line 275 "compiledict.cpp"
                $value=$and31; //@line 275 "compiledict.cpp"
                var $28=$value; //@line 276 "compiledict.cpp"
                var $cmp32=((($28))|0)!=1; //@line 276 "compiledict.cpp"
                if ($cmp32) { __label__ = 15;; } else { __label__ = 14;; } //@line 276 "compiledict.cpp"
                $if_then35$$lor_lhs_false$22: do { 
                  if (__label__ == 14) {
  
                    var $29=$control_addr; //@line 276 "compiledict.cpp"
                    var $and33=($29) & -2147483648; //@line 276 "compiledict.cpp"
                    var $tobool34=((($and33))|0)!=0; //@line 276 "compiledict.cpp"
                    if ($tobool34) { __label__ = 15;break $if_then35$$lor_lhs_false$22; } else { __label__ = 16;break $if_then35$$lor_lhs_false$22; } //@line 276 "compiledict.cpp"
                  }
                } while(0);
                if (__label__ == 15) {
  
                  var $30=$p; //@line 278 "compiledict.cpp"
                  var $arrayidx36=(($30)&4294967295); //@line 278 "compiledict.cpp"
                  HEAP8[($arrayidx36)]=36; //@line 278 "compiledict.cpp"
                  var $31=$value; //@line 279 "compiledict.cpp"
                  var $call37=__Z14LookupMnemNameP8MNEM_TABi(((_mnem_rules)&4294967295), $31); //@line 279 "compiledict.cpp"
                  $name=$call37; //@line 279 "compiledict.cpp"
                  var $32=$p; //@line 280 "compiledict.cpp"
                  var $arrayidx38=(($32+1)&4294967295); //@line 280 "compiledict.cpp"
                  var $33=$name; //@line 280 "compiledict.cpp"
                  var $call39=_strcpy($arrayidx38, $33); //@line 280 "compiledict.cpp"
                  var $34=$name; //@line 281 "compiledict.cpp"
                  var $call40=_strlen($34); //@line 281 "compiledict.cpp"
                  var $add41=((($call40)+1)&4294967295); //@line 281 "compiledict.cpp"
                  var $35=$p; //@line 281 "compiledict.cpp"
                  var $add_ptr42=(($35+$add41)&4294967295); //@line 281 "compiledict.cpp"
                  $p=$add_ptr42; //@line 281 "compiledict.cpp"
                  ; //@line 282 "compiledict.cpp"
                }
  
                $c=32; //@line 283 "compiledict.cpp"
                ; //@line 284 "compiledict.cpp"
              }
              else if (__label__ == 17) {
  
                var $36=$rb; //@line 286 "compiledict.cpp"
                var $conv44=((($36))&255); //@line 286 "compiledict.cpp"
                var $cmp45=((($conv44))|0)==14; //@line 286 "compiledict.cpp"
                if ($cmp45) { __label__ = 18;; } else { __label__ = 25;; } //@line 286 "compiledict.cpp"
                if (__label__ == 18) {
  
                  var $37=$rule_addr; //@line 289 "compiledict.cpp"
                  var $arrayidx47=(($37)&4294967295); //@line 289 "compiledict.cpp"
                  var $38=HEAP8[($arrayidx47)]; //@line 289 "compiledict.cpp"
                  var $conv48=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 289 "compiledict.cpp"
                  var $and49=($conv48) & 127; //@line 289 "compiledict.cpp"
                  var $shl=((($and49)*256)&4294967295); //@line 289 "compiledict.cpp"
                  var $39=$rule_addr; //@line 289 "compiledict.cpp"
                  var $arrayidx50=(($39+1)&4294967295); //@line 289 "compiledict.cpp"
                  var $40=HEAP8[($arrayidx50)]; //@line 289 "compiledict.cpp"
                  var $conv51=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 289 "compiledict.cpp"
                  var $and52=($conv51) & 127; //@line 289 "compiledict.cpp"
                  var $add53=((($and52)+($shl))&4294967295); //@line 289 "compiledict.cpp"
                  $flags=$add53; //@line 289 "compiledict.cpp"
                  $suffix_char=83; //@line 290 "compiledict.cpp"
                  var $41=$flags; //@line 291 "compiledict.cpp"
                  var $and54=($41) & 4; //@line 291 "compiledict.cpp"
                  var $tobool55=((($and54))|0)!=0; //@line 291 "compiledict.cpp"
                  if ($tobool55) { __label__ = 19;; } else { __label__ = 20;; } //@line 291 "compiledict.cpp"
                  if (__label__ == 19) {
  
                    $suffix_char=80; //@line 292 "compiledict.cpp"
                    ; //@line 292 "compiledict.cpp"
                  }
  
                  var $42=$suffix_char; //@line 293 "compiledict.cpp"
                  var $43=$rule_addr; //@line 293 "compiledict.cpp"
                  var $arrayidx59=(($43+2)&4294967295); //@line 293 "compiledict.cpp"
                  var $44=HEAP8[($arrayidx59)]; //@line 293 "compiledict.cpp"
                  var $conv60=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 293 "compiledict.cpp"
                  var $and61=($conv60) & 127; //@line 293 "compiledict.cpp"
                  var $call62=_sprintf($arraydecay58, ((__str62)&4294967295), allocate([$42,0,0,0,$and61,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 293 "compiledict.cpp"
                  var $45=$rule_addr; //@line 294 "compiledict.cpp"
                  var $add_ptr63=(($45+3)&4294967295); //@line 294 "compiledict.cpp"
                  $rule_addr=$add_ptr63; //@line 294 "compiledict.cpp"
                  $ix=0; //@line 295 "compiledict.cpp"
                  ; //@line 295 "compiledict.cpp"
                  while(1) { 
  
                    var $46=$flags; //@line 297 "compiledict.cpp"
                    var $and67=($46) & 1; //@line 297 "compiledict.cpp"
                    var $tobool68=((($and67))|0)!=0; //@line 297 "compiledict.cpp"
                    if ($tobool68) { __label__ = 22;; } else { __label__ = 23;; } //@line 297 "compiledict.cpp"
                    if (__label__ == 22) {
  
                      var $call71=_strlen($arraydecay70); //@line 298 "compiledict.cpp"
                      var $arrayidx72=(($suffix+$call71)&4294967295); //@line 298 "compiledict.cpp"
                      var $47=$ix; //@line 298 "compiledict.cpp"
                      var $arrayidx73=((((__str61)&4294967295)+$47)&4294967295); //@line 298 "compiledict.cpp"
                      var $48=HEAP8[($arrayidx73)]; //@line 298 "compiledict.cpp"
                      var $conv74=(tempInt=(($48)),(tempInt>=128?tempInt-256:tempInt)); //@line 298 "compiledict.cpp"
                      var $char=((($conv74)) & 255); //@line 298 "compiledict.cpp"
                      HEAP8[($arrayidx72)]=$char; //@line 298 "compiledict.cpp"
                      var $nul=(($arrayidx72+1)&4294967295); //@line 298 "compiledict.cpp"
                      HEAP8[($nul)]=0; //@line 298 "compiledict.cpp"
                      ; //@line 298 "compiledict.cpp"
                    }
  
                    var $49=$flags; //@line 299 "compiledict.cpp"
                    var $shr=($49) >> 1; //@line 299 "compiledict.cpp"
                    $flags=$shr; //@line 299 "compiledict.cpp"
                    var $50=$ix; //@line 295 "compiledict.cpp"
                    var $inc78=((($50)+1)&4294967295); //@line 295 "compiledict.cpp"
                    $ix=$inc78; //@line 295 "compiledict.cpp"
                    var $cmp65=((($inc78))|0) < 9; //@line 295 "compiledict.cpp"
                    if ($cmp65) { __label__ = 21;continue ; } else { __label__ = 24;break ; } //@line 295 "compiledict.cpp"
                  }
  
                  var $51=$p; //@line 301 "compiledict.cpp"
                  var $call81=_strcpy($51, $arraydecay80); //@line 301 "compiledict.cpp"
                  var $call83=_strlen($arraydecay82); //@line 302 "compiledict.cpp"
                  var $52=$p; //@line 302 "compiledict.cpp"
                  var $add_ptr84=(($52+$call83)&4294967295); //@line 302 "compiledict.cpp"
                  $p=$add_ptr84; //@line 302 "compiledict.cpp"
                  $c=32; //@line 303 "compiledict.cpp"
                  ; //@line 304 "compiledict.cpp"
                }
                else if (__label__ == 25) {
  
                  var $53=$rb; //@line 306 "compiledict.cpp"
                  var $conv86=((($53))&255); //@line 306 "compiledict.cpp"
                  var $cmp87=((($conv86))|0)==17; //@line 306 "compiledict.cpp"
                  if ($cmp87) { __label__ = 26;; } else { __label__ = 27;; } //@line 306 "compiledict.cpp"
                  if (__label__ == 26) {
  
                    var $54=$rule_addr; //@line 308 "compiledict.cpp"
                    var $incdec_ptr89=(($54+1)&4294967295); //@line 308 "compiledict.cpp"
                    $rule_addr=$incdec_ptr89; //@line 308 "compiledict.cpp"
                    var $55=HEAP8[($54)]; //@line 308 "compiledict.cpp"
                    var $conv90=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 308 "compiledict.cpp"
                    var $sub91=((($conv90)-65)&4294967295); //@line 308 "compiledict.cpp"
                    var $arrayidx92=((__ZZ10DecodeRulePKciPciE10symbols_lg+$sub91)&4294967295); //@line 308 "compiledict.cpp"
                    var $56=HEAP8[($arrayidx92)]; //@line 308 "compiledict.cpp"
                    $c=$56; //@line 308 "compiledict.cpp"
                    ; //@line 309 "compiledict.cpp"
                  }
                  else if (__label__ == 27) {
  
                    var $57=$rb; //@line 311 "compiledict.cpp"
                    var $conv94=((($57))&255); //@line 311 "compiledict.cpp"
                    var $cmp95=((($conv94))|0)==18; //@line 311 "compiledict.cpp"
                    if ($cmp95) { __label__ = 28;; } else { __label__ = 31;; } //@line 311 "compiledict.cpp"
                    if (__label__ == 28) {
  
                      var $58=$rule_addr; //@line 313 "compiledict.cpp"
                      var $incdec_ptr97=(($58+1)&4294967295); //@line 313 "compiledict.cpp"
                      $rule_addr=$incdec_ptr97; //@line 313 "compiledict.cpp"
                      var $59=HEAP8[($58)]; //@line 313 "compiledict.cpp"
                      var $conv98=(tempInt=(($59)),(tempInt>=128?tempInt-256:tempInt)); //@line 313 "compiledict.cpp"
                      var $sub99=((($conv98)-65)&4294967295); //@line 313 "compiledict.cpp"
                      $value=$sub99; //@line 313 "compiledict.cpp"
                      var $60=$p; //@line 314 "compiledict.cpp"
                      var $arrayidx100=(($60)&4294967295); //@line 314 "compiledict.cpp"
                      HEAP8[($arrayidx100)]=76; //@line 314 "compiledict.cpp"
                      var $61=$value; //@line 315 "compiledict.cpp"
                      var $div=((((($61))|0)/10)|0); //@line 315 "compiledict.cpp"
                      var $add101=((($div)+48)&4294967295); //@line 315 "compiledict.cpp"
                      var $conv102=((($add101)) & 255); //@line 315 "compiledict.cpp"
                      var $62=$p; //@line 315 "compiledict.cpp"
                      var $arrayidx103=(($62+1)&4294967295); //@line 315 "compiledict.cpp"
                      HEAP8[($arrayidx103)]=$conv102; //@line 315 "compiledict.cpp"
                      var $63=$value; //@line 316 "compiledict.cpp"
                      var $rem=((($63))|0)%10; //@line 316 "compiledict.cpp"
                      var $add104=((($rem)+48)&4294967295); //@line 316 "compiledict.cpp"
                      var $conv105=((($add104)) & 255); //@line 316 "compiledict.cpp"
                      $c=$conv105; //@line 316 "compiledict.cpp"
                      var $64=$match_type; //@line 318 "compiledict.cpp"
                      var $cmp106=((($64))|0)==1; //@line 318 "compiledict.cpp"
                      if ($cmp106) { __label__ = 29;; } else { __label__ = 30;; } //@line 318 "compiledict.cpp"
                      if (__label__ == 29) {
  
                        var $65=$c; //@line 320 "compiledict.cpp"
                        var $66=$p; //@line 320 "compiledict.cpp"
                        var $arrayidx108=(($66)&4294967295); //@line 320 "compiledict.cpp"
                        HEAP8[($arrayidx108)]=$65; //@line 320 "compiledict.cpp"
                        $c=76; //@line 321 "compiledict.cpp"
                        ; //@line 322 "compiledict.cpp"
                      }
  
                      var $67=$p; //@line 323 "compiledict.cpp"
                      var $add_ptr110=(($67+2)&4294967295); //@line 323 "compiledict.cpp"
                      $p=$add_ptr110; //@line 323 "compiledict.cpp"
                      ; //@line 324 "compiledict.cpp"
                    }
                    else if (__label__ == 31) {
  
                      var $68=$rb; //@line 326 "compiledict.cpp"
                      var $conv112=((($68))&255); //@line 326 "compiledict.cpp"
                      var $cmp113=((($conv112))|0) <= 31; //@line 326 "compiledict.cpp"
                      var $69=$rb; //@line 327 "compiledict.cpp"
                      var $idxprom=((($69))&255); //@line 327 "compiledict.cpp"
                      if ($cmp113) { __label__ = 32;; } else { __label__ = 33;; } //@line 326 "compiledict.cpp"
                      if (__label__ == 32) {
  
                        var $arrayidx115=((__ZZ10DecodeRulePKciPciE7symbols+$idxprom)&4294967295); //@line 327 "compiledict.cpp"
                        var $70=HEAP8[($arrayidx115)]; //@line 327 "compiledict.cpp"
                        $c=$70; //@line 327 "compiledict.cpp"
                        ; //@line 327 "compiledict.cpp"
                      }
                      else if (__label__ == 33) {
  
                        var $cmp118=((($idxprom))|0)==32; //@line 329 "compiledict.cpp"
                        if ($cmp118) { __label__ = 34;; } else { __label__ = 35;; } //@line 329 "compiledict.cpp"
                        if (__label__ == 34) {
  
                          $c=95; //@line 330 "compiledict.cpp"
                          ; //@line 330 "compiledict.cpp"
                        }
                        else if (__label__ == 35) {
  
                          var $71=$rb; //@line 332 "compiledict.cpp"
                          $c=$71; //@line 332 "compiledict.cpp"
                          ;
                        }
                      }
                    }
                  }
                }
              }
  
              var $72=$c; //@line 333 "compiledict.cpp"
              var $73=$p; //@line 333 "compiledict.cpp"
              var $incdec_ptr127=(($73+1)&4294967295); //@line 333 "compiledict.cpp"
              $p=$incdec_ptr127; //@line 333 "compiledict.cpp"
              HEAP8[($73)]=$72; //@line 333 "compiledict.cpp"
              ; //@line 334 "compiledict.cpp"
            }
          } while(0);
  
          var $74=$finished; //@line 233 "compiledict.cpp"
          var $tobool=((($74))|0)!=0; //@line 233 "compiledict.cpp"
          var $lnot=($tobool) ^ 1; //@line 233 "compiledict.cpp"
          if ($lnot) { __label__ = 4;continue $while_body$8; } else { __label__ = 38;break $while_body_lr_ph$$while_end$6; } //@line 233 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $75=$p; //@line 335 "compiledict.cpp"
    HEAP8[($75)]=0; //@line 335 "compiledict.cpp"
    $p=((__ZZ10DecodeRulePKciPciE6output)&4294967295); //@line 337 "compiledict.cpp"
    var $76=$linenum; //@line 338 "compiledict.cpp"
    var $cmp128=((($76))|0) > 0; //@line 338 "compiledict.cpp"
    if ($cmp128) { __label__ = 39;; } else { __label__ = 40;; } //@line 338 "compiledict.cpp"
    if (__label__ == 39) {
  
      var $77=$p; //@line 340 "compiledict.cpp"
      var $78=$linenum; //@line 340 "compiledict.cpp"
      var $call130=_sprintf($77, ((__str64)&4294967295), allocate([$78,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 340 "compiledict.cpp"
      var $79=$p; //@line 341 "compiledict.cpp"
      var $add_ptr131=(($79+7)&4294967295); //@line 341 "compiledict.cpp"
      $p=$add_ptr131; //@line 341 "compiledict.cpp"
      ; //@line 342 "compiledict.cpp"
    }
  
    var $80=$condition_num; //@line 343 "compiledict.cpp"
    var $cmp133=((($80))|0) > 0; //@line 343 "compiledict.cpp"
    if ($cmp133) { __label__ = 41;; } else { __label__ = 42;; } //@line 343 "compiledict.cpp"
    if (__label__ == 41) {
  
      var $81=$p; //@line 345 "compiledict.cpp"
      var $82=$condition_num; //@line 345 "compiledict.cpp"
      var $call135=_sprintf($81, ((__str65)&4294967295), allocate([$82,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 345 "compiledict.cpp"
      var $83=$p; //@line 346 "compiledict.cpp"
      var $call136=_strlen($83); //@line 346 "compiledict.cpp"
      var $84=$p; //@line 346 "compiledict.cpp"
      var $arrayidx137=(($84+$call136)&4294967295); //@line 346 "compiledict.cpp"
      $p=$arrayidx137; //@line 346 "compiledict.cpp"
      ; //@line 347 "compiledict.cpp"
    }
  
    var $arraydecay139=(($buf_pre)&4294967295); //@line 348 "compiledict.cpp"
    var $call140=_strlen($arraydecay139); //@line 348 "compiledict.cpp"
    $ix=$call140; //@line 348 "compiledict.cpp"
    var $cmp141=((($call140))|0) > 0; //@line 348 "compiledict.cpp"
    var $_pr=$at_start; //@line 350 "compiledict.cpp"
    var $tobool145=((($_pr))|0)!=0; //@line 350 "compiledict.cpp"
    if ($cmp141) { __label__ = 44;; } else { __label__ = 43;; } //@line 348 "compiledict.cpp"
    $if_then144$$lor_lhs_false142$64: do { 
      if (__label__ == 44) {
  
        if ($tobool145) { __label__ = 45;break $if_then144$$lor_lhs_false142$64; } else { __label__ = 46;break $if_then144$$lor_lhs_false142$64; } //@line 350 "compiledict.cpp"
      }
      else if (__label__ == 43) {
  
        if ($tobool145) { __label__ = 45;break $if_then144$$lor_lhs_false142$64; } else { __label__ = 49;break $if_then144$$lor_lhs_false142$64; } //@line 348 "compiledict.cpp"
      }
    } while(0);
    $if_then146$$while_cond149_preheader$$if_end157$67: do { 
      if (__label__ == 45) {
  
        var $85=$p; //@line 351 "compiledict.cpp"
        var $incdec_ptr147=(($85+1)&4294967295); //@line 351 "compiledict.cpp"
        $p=$incdec_ptr147; //@line 351 "compiledict.cpp"
        HEAP8[($85)]=95; //@line 351 "compiledict.cpp"
        __label__ = 46;break $if_then146$$while_cond149_preheader$$if_end157$67; //@line 351 "compiledict.cpp"
      }
    } while(0);
    if (__label__ == 46) {
  
      var $86=$ix; //@line 352 "compiledict.cpp"
      var $dec4=((($86)-1)&4294967295); //@line 352 "compiledict.cpp"
      $ix=$dec4; //@line 352 "compiledict.cpp"
      var $cmp1505=((($dec4))|0) >= 0; //@line 352 "compiledict.cpp"
      if ($cmp1505) { __label__ = 47;; } else { __label__ = 48;; } //@line 352 "compiledict.cpp"
      $while_body151$$while_end154$71: do { 
        if (__label__ == 47) {
          while(1) { 
  
            var $87=$ix; //@line 353 "compiledict.cpp"
            var $arrayidx152=(($buf_pre+$87)&4294967295); //@line 353 "compiledict.cpp"
            var $88=HEAP8[($arrayidx152)]; //@line 353 "compiledict.cpp"
            var $89=$p; //@line 353 "compiledict.cpp"
            var $incdec_ptr153=(($89+1)&4294967295); //@line 353 "compiledict.cpp"
            $p=$incdec_ptr153; //@line 353 "compiledict.cpp"
            HEAP8[($89)]=$88; //@line 353 "compiledict.cpp"
            var $90=$ix; //@line 352 "compiledict.cpp"
            var $dec=((($90)-1)&4294967295); //@line 352 "compiledict.cpp"
            $ix=$dec; //@line 352 "compiledict.cpp"
            var $cmp150=((($dec))|0) >= 0; //@line 352 "compiledict.cpp"
            if ($cmp150) { __label__ = 47;continue ; } else { __label__ = 48;break $while_body151$$while_end154$71; } //@line 352 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $91=$p; //@line 354 "compiledict.cpp"
      var $incdec_ptr155=(($91+1)&4294967295); //@line 354 "compiledict.cpp"
      $p=$incdec_ptr155; //@line 354 "compiledict.cpp"
      HEAP8[($91)]=41; //@line 354 "compiledict.cpp"
      var $92=$p; //@line 355 "compiledict.cpp"
      var $incdec_ptr156=(($92+1)&4294967295); //@line 355 "compiledict.cpp"
      $p=$incdec_ptr156; //@line 355 "compiledict.cpp"
      HEAP8[($92)]=32; //@line 355 "compiledict.cpp"
      ; //@line 356 "compiledict.cpp"
    }
  
    var $93=$p; //@line 357 "compiledict.cpp"
    HEAP8[($93)]=0; //@line 357 "compiledict.cpp"
    var $94=$p; //@line 358 "compiledict.cpp"
    var $arraydecay158=(($buf)&4294967295); //@line 358 "compiledict.cpp"
    var $call159=_strcat($94, $arraydecay158); //@line 358 "compiledict.cpp"
    var $call160=_strlen(((__ZZ10DecodeRulePKciPciE6output)&4294967295)); //@line 359 "compiledict.cpp"
    $ix=$call160; //@line 359 "compiledict.cpp"
    var $cmp1623=((($call160))|0) < 8; //@line 360 "compiledict.cpp"
    var $95=$ix; //@line 361 "compiledict.cpp"
    if ($cmp1623) { __lastLabel__ = 49; __label__ = 50;; } else { __lastLabel__ = 49; __label__ = 51;; } //@line 360 "compiledict.cpp"
    $while_body163$$while_end166$76: do { 
      if (__label__ == 50) {
        while(1) { 
  
          var $96=__lastLabel__ == 50 ? $97 : ($95);
          var $inc164=((($96)+1)&4294967295); //@line 361 "compiledict.cpp"
          $ix=$inc164; //@line 361 "compiledict.cpp"
          var $arrayidx165=((__ZZ10DecodeRulePKciPciE6output+$96)&4294967295); //@line 361 "compiledict.cpp"
          HEAP8[($arrayidx165)]=32; //@line 361 "compiledict.cpp"
          var $_pr2=$ix; //@line 360 "compiledict.cpp"
          var $cmp162=((($_pr2))|0) < 8; //@line 360 "compiledict.cpp"
          var $97=$ix; //@line 361 "compiledict.cpp"
          if ($cmp162) { __lastLabel__ = 50; __label__ = 50;continue ; } else { __lastLabel__ = 50; __label__ = 51;break $while_body163$$while_end166$76; } //@line 360 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 49 ? $95 : ($97);
    var $arrayidx167=((__ZZ10DecodeRulePKciPciE6output+$_lcssa)&4294967295); //@line 362 "compiledict.cpp"
    HEAP8[($arrayidx167)]=0; //@line 362 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return ((__ZZ10DecodeRulePKciPciE6output)&4294967295); //@line 363 "compiledict.cpp"
    return null;
  }
  

  function __Z13string_sorterPPcS0_($a, $b) {
    ;
    var __label__;
  
    var $retval;
    var $a_addr;
    var $b_addr;
    var $pa;
    var $pb;
    var $ix;
    $a_addr=$a;
    $b_addr=$b;
    var $0=$a_addr; //@line 1341 "compiledict.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 1341 "compiledict.cpp"
    $pa=$1; //@line 1341 "compiledict.cpp"
    var $2=$b_addr; //@line 1341 "compiledict.cpp"
    var $3=HEAP32[(($2)>>2)]; //@line 1341 "compiledict.cpp"
    $pb=$3; //@line 1341 "compiledict.cpp"
    var $call=_strcmp($1, $3); //@line 1341 "compiledict.cpp"
    $ix=$call; //@line 1341 "compiledict.cpp"
    var $cmp=((($call))|0)!=0; //@line 1341 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1341 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $4=$ix; //@line 1342 "compiledict.cpp"
      $retval=$4; //@line 1342 "compiledict.cpp"
      ; //@line 1342 "compiledict.cpp"
    }
    else if (__label__ == 2) {
  
      var $5=$pa; //@line 1343 "compiledict.cpp"
      var $call1=_strlen($5); //@line 1343 "compiledict.cpp"
      var $add=((($call1)+1)&4294967295); //@line 1343 "compiledict.cpp"
      var $6=$pa; //@line 1343 "compiledict.cpp"
      var $add_ptr=(($6+$add)&4294967295); //@line 1343 "compiledict.cpp"
      $pa=$add_ptr; //@line 1343 "compiledict.cpp"
      var $7=$pb; //@line 1344 "compiledict.cpp"
      var $call2=_strlen($7); //@line 1344 "compiledict.cpp"
      var $add3=((($call2)+1)&4294967295); //@line 1344 "compiledict.cpp"
      var $8=$pb; //@line 1344 "compiledict.cpp"
      var $add_ptr4=(($8+$add3)&4294967295); //@line 1344 "compiledict.cpp"
      $pb=$add_ptr4; //@line 1344 "compiledict.cpp"
      var $9=$pa; //@line 1345 "compiledict.cpp"
      var $10=$pb; //@line 1345 "compiledict.cpp"
      var $call5=_strcmp($9, $10); //@line 1345 "compiledict.cpp"
      $retval=$call5; //@line 1345 "compiledict.cpp"
      ; //@line 1345 "compiledict.cpp"
    }
  
    var $11=$retval; //@line 1346 "compiledict.cpp"
    ;
    return $11; //@line 1346 "compiledict.cpp"
    return null;
  }
  

  function __Z17CompileDictionaryPKcS0_P7__sFILEPci($dsource, $dict_name, $log, $fname_err, $flags) {
    var __stackBase__  = STACKTOP; STACKTOP += 724; _memset(__stackBase__, 0, 724);
    var __label__;
  
    var $retval;
    var $dsource_addr;
    var $dict_name_addr;
    var $log_addr;
    var $fname_err_addr;
    var $flags_addr;
    var $f_in;
    var $f_out;
    var $offset_rules;
    var $value;
    var $fname_in=__stackBase__;
    var $fname_out=__stackBase__+196;
    var $fname_temp=__stackBase__+364;
    var $path=__stackBase__+532;
    $dsource_addr=$dsource;
    $dict_name_addr=$dict_name;
    $log_addr=$log;
    $fname_err_addr=$fname_err;
    $flags_addr=$flags;
    $offset_rules=0; //@line 1856 "compiledict.cpp"
    HEAP32[((__ZL11error_count)>>2)]=0; //@line 1863 "compiledict.cpp"
    HEAP32[((__ZL21error_need_dictionary)>>2)]=0; //@line 1864 "compiledict.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = ((__ZL19letterGroupsDefined)&4294967295);
    $stop$ = $dest$ + 26;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1865 "compiledict.cpp"
    var $0=$flags_addr; //@line 1867 "compiledict.cpp"
    var $and=($0) & 1; //@line 1867 "compiledict.cpp"
    HEAP32[((__ZL10debug_flag)>>2)]=$and; //@line 1867 "compiledict.cpp"
    var $1=$dsource_addr; //@line 1869 "compiledict.cpp"
    var $cmp=((($1))|0)==0; //@line 1869 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1869 "compiledict.cpp"
    if (__label__ == 1) {
  
      $dsource_addr=((__str13643)&4294967295); //@line 1870 "compiledict.cpp"
      ; //@line 1870 "compiledict.cpp"
    }
  
    var $2=$log_addr; //@line 1872 "compiledict.cpp"
    HEAP32[((__ZL5f_log)>>2)]=$2; //@line 1872 "compiledict.cpp"
    var $cmp1=((($2))|0)==0; //@line 1874 "compiledict.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1874 "compiledict.cpp"
    if (__label__ == 3) {
  
      var $3=HEAP32[((__impure_ptr)>>2)]; //@line 1875 "compiledict.cpp"
      var $_stderr=(($3+12)&4294967295); //@line 1875 "compiledict.cpp"
      var $4=HEAP32[(($_stderr)>>2)]; //@line 1875 "compiledict.cpp"
      HEAP32[((__ZL5f_log)>>2)]=$4; //@line 1875 "compiledict.cpp"
      ; //@line 1875 "compiledict.cpp"
    }
  
    var $arraydecay=(($path)&4294967295); //@line 1878 "compiledict.cpp"
    var $5=$dsource_addr; //@line 1878 "compiledict.cpp"
    var $6=$dict_name_addr; //@line 1878 "compiledict.cpp"
    var $call=_sprintf($arraydecay, ((__str66)&4294967295), allocate([$5,0,0,0,$6,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1878 "compiledict.cpp"
    var $arraydecay4=(($fname_in)&4294967295); //@line 1879 "compiledict.cpp"
    var $arraydecay5=(($path)&4294967295); //@line 1879 "compiledict.cpp"
    var $call6=_sprintf($arraydecay4, ((__str67)&4294967295), allocate([$arraydecay5,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1879 "compiledict.cpp"
    var $arraydecay7=(($fname_in)&4294967295); //@line 1880 "compiledict.cpp"
    var $call8=_fopen($arraydecay7, ((__str51703)&4294967295)); //@line 1880 "compiledict.cpp"
    $f_in=$call8; //@line 1880 "compiledict.cpp"
    var $cmp9=((($call8))|0)==0; //@line 1880 "compiledict.cpp"
    if ($cmp9) { __label__ = 5;; } else { __label__ = 9;; } //@line 1880 "compiledict.cpp"
    $if_then10$$if_end23$8: do { 
      if (__label__ == 5) {
  
        var $arraydecay11=(($fname_in)&4294967295); //@line 1882 "compiledict.cpp"
        var $arraydecay12=(($path)&4294967295); //@line 1882 "compiledict.cpp"
        var $call13=_sprintf($arraydecay11, ((__str69)&4294967295), allocate([$arraydecay12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1882 "compiledict.cpp"
        var $arraydecay14=(($fname_in)&4294967295); //@line 1883 "compiledict.cpp"
        var $call15=__ZL9fopen_logPKcS0_($arraydecay14, ((__str51703)&4294967295)); //@line 1883 "compiledict.cpp"
        $f_in=$call15; //@line 1883 "compiledict.cpp"
        var $cmp16=((($call15))|0)==0; //@line 1883 "compiledict.cpp"
        if (!($cmp16)) { __label__ = 9;break $if_then10$$if_end23$8; } //@line 1883 "compiledict.cpp"
  
        var $7=$fname_err_addr; //@line 1885 "compiledict.cpp"
        var $tobool=((($7))|0)!=0; //@line 1885 "compiledict.cpp"
        if ($tobool) { __label__ = 7;; } else { __label__ = 8;; } //@line 1885 "compiledict.cpp"
        if (__label__ == 7) {
  
          var $8=$fname_err_addr; //@line 1886 "compiledict.cpp"
          var $arraydecay19=(($fname_in)&4294967295); //@line 1886 "compiledict.cpp"
          var $call20=_strcpy($8, $arraydecay19); //@line 1886 "compiledict.cpp"
          ; //@line 1886 "compiledict.cpp"
        }
  
        $retval=-1; //@line 1887 "compiledict.cpp"
        __label__ = 17;break $if_then10$$if_end23$8; //@line 1887 "compiledict.cpp"
      }
    } while(0);
    if (__label__ == 9) {
  
      var $arraydecay24=(($fname_out)&4294967295); //@line 1891 "compiledict.cpp"
      var $9=$dict_name_addr; //@line 1891 "compiledict.cpp"
      var $call25=_sprintf($arraydecay24, ((__str116)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,$9,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1891 "compiledict.cpp"
      var $arraydecay26=(($fname_out)&4294967295); //@line 1892 "compiledict.cpp"
      var $call27=__ZL9fopen_logPKcS0_($arraydecay26, ((__str71)&4294967295)); //@line 1892 "compiledict.cpp"
      $f_out=$call27; //@line 1892 "compiledict.cpp"
      var $cmp28=((($call27))|0)==0; //@line 1892 "compiledict.cpp"
      if ($cmp28) { __label__ = 10;; } else { __label__ = 13;; } //@line 1892 "compiledict.cpp"
      if (__label__ == 10) {
  
        var $10=$fname_err_addr; //@line 1894 "compiledict.cpp"
        var $tobool30=((($10))|0)!=0; //@line 1894 "compiledict.cpp"
        if ($tobool30) { __label__ = 11;; } else { __label__ = 12;; } //@line 1894 "compiledict.cpp"
        if (__label__ == 11) {
  
          var $11=$fname_err_addr; //@line 1895 "compiledict.cpp"
          var $arraydecay32=(($fname_in)&4294967295); //@line 1895 "compiledict.cpp"
          var $call33=_strcpy($11, $arraydecay32); //@line 1895 "compiledict.cpp"
          ; //@line 1895 "compiledict.cpp"
        }
  
        $retval=-1; //@line 1896 "compiledict.cpp"
        ; //@line 1896 "compiledict.cpp"
      }
      else if (__label__ == 13) {
  
        var $arraydecay36=(($fname_temp)&4294967295); //@line 1898 "compiledict.cpp"
        var $call37=_sprintf($arraydecay36, ((__str72)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1898 "compiledict.cpp"
        $value=1024; //@line 1900 "compiledict.cpp"
        var $12=$f_out; //@line 1901 "compiledict.cpp"
        var $13=$value; //@line 1901 "compiledict.cpp"
        __Z11Write4BytesP7__sFILEi($12, $13); //@line 1901 "compiledict.cpp"
        var $14=$f_out; //@line 1902 "compiledict.cpp"
        var $15=$offset_rules; //@line 1902 "compiledict.cpp"
        __Z11Write4BytesP7__sFILEi($14, $15); //@line 1902 "compiledict.cpp"
        __ZL22compile_dictlist_startv(); //@line 1904 "compiledict.cpp"
        var $16=HEAP32[((__ZL5f_log)>>2)]; //@line 1906 "compiledict.cpp"
        var $17=HEAP32[((_phoneme_tab_number)>>2)]; //@line 1906 "compiledict.cpp"
        var $arrayidx=((_phoneme_tab_list+$17*48)&4294967295); //@line 1906 "compiledict.cpp"
        var $name=(($arrayidx)&4294967295); //@line 1906 "compiledict.cpp"
        var $arraydecay38=(($name)&4294967295); //@line 1906 "compiledict.cpp"
        var $call39=_fprintf($16, ((__str73)&4294967295), allocate([$arraydecay38,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1906 "compiledict.cpp"
        var $arraydecay40=(($path)&4294967295); //@line 1907 "compiledict.cpp"
        __ZL21compile_dictlist_filePKcS0_($arraydecay40, ((__str74)&4294967295)); //@line 1907 "compiledict.cpp"
        var $18=HEAP32[((_translator)>>2)]; //@line 1908 "compiledict.cpp"
        var $langopts=(($18)&4294967295); //@line 1908 "compiledict.cpp"
        var $listx=(($langopts+260)&4294967295); //@line 1908 "compiledict.cpp"
        var $19=HEAP32[(($listx)>>2)]; //@line 1908 "compiledict.cpp"
        var $tobool42=((($19))|0)!=0; //@line 1908 "compiledict.cpp"
        var $arraydecay44=(($path)&4294967295); //@line 1910 "compiledict.cpp"
        if ($tobool42) { __label__ = 14;; } else { __label__ = 15;; } //@line 1908 "compiledict.cpp"
        if (__label__ == 14) {
  
          __ZL21compile_dictlist_filePKcS0_($arraydecay44, ((__str75)&4294967295)); //@line 1910 "compiledict.cpp"
          var $arraydecay46=(($path)&4294967295); //@line 1911 "compiledict.cpp"
          __ZL21compile_dictlist_filePKcS0_($arraydecay46, ((__str76)&4294967295)); //@line 1911 "compiledict.cpp"
          ; //@line 1912 "compiledict.cpp"
        }
        else if (__label__ == 15) {
  
          __ZL21compile_dictlist_filePKcS0_($arraydecay44, ((__str76)&4294967295)); //@line 1915 "compiledict.cpp"
          var $arraydecay50=(($path)&4294967295); //@line 1916 "compiledict.cpp"
          __ZL21compile_dictlist_filePKcS0_($arraydecay50, ((__str75)&4294967295)); //@line 1916 "compiledict.cpp"
          ;
        }
  
        var $arraydecay53=(($path)&4294967295); //@line 1918 "compiledict.cpp"
        __ZL21compile_dictlist_filePKcS0_($arraydecay53, ((__str77)&4294967295)); //@line 1918 "compiledict.cpp"
        var $20=$f_out; //@line 1920 "compiledict.cpp"
        __ZL20compile_dictlist_endP7__sFILE($20); //@line 1920 "compiledict.cpp"
        var $21=$f_out; //@line 1921 "compiledict.cpp"
        var $call55=_ftell($21); //@line 1921 "compiledict.cpp"
        $offset_rules=$call55; //@line 1921 "compiledict.cpp"
        var $22=HEAP32[((__ZL5f_log)>>2)]; //@line 1923 "compiledict.cpp"
        var $arraydecay56=(($fname_in)&4294967295); //@line 1923 "compiledict.cpp"
        var $call57=_fprintf($22, ((__str78)&4294967295), allocate([$arraydecay56,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1923 "compiledict.cpp"
        var $23=$f_in; //@line 1925 "compiledict.cpp"
        var $24=$f_out; //@line 1925 "compiledict.cpp"
        var $arraydecay58=(($fname_temp)&4294967295); //@line 1925 "compiledict.cpp"
        __ZL17compile_dictrulesP7__sFILES0_Pc($23, $24, $arraydecay58); //@line 1925 "compiledict.cpp"
        var $25=$f_in; //@line 1926 "compiledict.cpp"
        var $call60=_fclose($25); //@line 1926 "compiledict.cpp"
        var $26=$f_out; //@line 1928 "compiledict.cpp"
        var $call61=_fseek($26, 4, 0); //@line 1928 "compiledict.cpp"
        var $27=$f_out; //@line 1929 "compiledict.cpp"
        var $28=$offset_rules; //@line 1929 "compiledict.cpp"
        __Z11Write4BytesP7__sFILEi($27, $28); //@line 1929 "compiledict.cpp"
        var $29=$f_out; //@line 1930 "compiledict.cpp"
        var $call62=_fclose($29); //@line 1930 "compiledict.cpp"
        var $30=HEAP32[((_translator)>>2)]; //@line 1932 "compiledict.cpp"
        var $31=$dict_name_addr; //@line 1932 "compiledict.cpp"
        var $call63=__Z14LoadDictionaryP10TranslatorPKci($30, $31, 0); //@line 1932 "compiledict.cpp"
        var $32=HEAP32[((__ZL11error_count)>>2)]; //@line 1934 "compiledict.cpp"
        $retval=$32; //@line 1934 "compiledict.cpp"
        ; //@line 1934 "compiledict.cpp"
      }
    }
  
    var $33=$retval; //@line 1935 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return $33; //@line 1935 "compiledict.cpp"
    return null;
  }
  

  function __ZL9fopen_logPKcS0_($fname, $access) {
    ;
    var __label__;
  
    var $fname_addr;
    var $access_addr;
    var $f;
    $fname_addr=$fname;
    $access_addr=$access;
    var $0=$fname_addr; //@line 162 "compiledict.cpp"
    var $1=$access_addr; //@line 162 "compiledict.cpp"
    var $call=_fopen($0, $1); //@line 162 "compiledict.cpp"
    $f=$call; //@line 162 "compiledict.cpp"
    var $cmp=((($call))|0)==0; //@line 162 "compiledict.cpp"
    var $2=HEAP32[((__ZL5f_log)>>2)]; //@line 164 "compiledict.cpp"
    var $cmp1=((($2))|0)!=0; //@line 164 "compiledict.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 162 "compiledict.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 162 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $3=HEAP32[((__ZL5f_log)>>2)]; //@line 165 "compiledict.cpp"
      var $4=$access_addr; //@line 165 "compiledict.cpp"
      var $5=$fname_addr; //@line 165 "compiledict.cpp"
      var $call3=_fprintf($3, ((__str115)&4294967295), allocate([$4,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 165 "compiledict.cpp"
      ; //@line 165 "compiledict.cpp"
    }
  
    var $6=$f; //@line 167 "compiledict.cpp"
    ;
    return $6; //@line 167 "compiledict.cpp"
    return null;
  }
  

  function __ZL22compile_dictlist_startv() {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $ix;
    var $p;
    var $p2=__stackBase__;
    $ix=0; //@line 792 "compiledict.cpp"
    var $0=$p2; //@line 797 "compiledict.cpp"
    ; //@line 792 "compiledict.cpp"
    $for_body$2: while(1) { 
  
      var $1=$ix; //@line 794 "compiledict.cpp"
      var $arrayidx=((__ZL11hash_chains+$1*4)&4294967295); //@line 794 "compiledict.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 794 "compiledict.cpp"
      $p=$2; //@line 794 "compiledict.cpp"
      var $cmp11=((($2))|0)!=0; //@line 795 "compiledict.cpp"
      if ($cmp11) { __label__ = 2;; } else { __label__ = 3;; } //@line 795 "compiledict.cpp"
      $while_body$$while_end$4: do { 
        if (__label__ == 2) {
          while(1) { 
  
            var $3=$p; //@line 797 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $3;
            $dest$ = $0;
            $stop$ = $src$ + 4;
            if (($dest$%4) == ($src$%4) && 4 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 797 "compiledict.cpp"
            var $4=$p; //@line 798 "compiledict.cpp"
            ; //@line 798 "compiledict.cpp"
            var $5=HEAP32[(($p2)>>2)]; //@line 799 "compiledict.cpp"
            $p=$5; //@line 799 "compiledict.cpp"
            var $cmp1=((($5))|0)!=0; //@line 795 "compiledict.cpp"
            if ($cmp1) { __label__ = 2;continue ; } else { __label__ = 3;break $while_body$$while_end$4; } //@line 795 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $6=$ix; //@line 801 "compiledict.cpp"
      var $arrayidx2=((__ZL11hash_chains+$6*4)&4294967295); //@line 801 "compiledict.cpp"
      HEAP32[(($arrayidx2)>>2)]=0; //@line 801 "compiledict.cpp"
      var $7=$ix; //@line 802 "compiledict.cpp"
      var $arrayidx3=((__ZL11hash_counts+$7*4)&4294967295); //@line 802 "compiledict.cpp"
      HEAP32[(($arrayidx3)>>2)]=0; //@line 802 "compiledict.cpp"
      var $8=$ix; //@line 792 "compiledict.cpp"
      var $inc=((($8)+1)&4294967295); //@line 792 "compiledict.cpp"
      $ix=$inc; //@line 792 "compiledict.cpp"
      var $cmp=((($inc))|0) < 1024; //@line 792 "compiledict.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 4;break $for_body$2; } //@line 792 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 804 "compiledict.cpp"
    return;
  }
  

  function __ZL21compile_dictlist_filePKcS0_($path, $filename) {
    var __stackBase__  = STACKTOP; STACKTOP += 528; _memset(__stackBase__, 0, 528);
    var __label__;
  
    var $retval;
    var $path_addr;
    var $filename_addr;
    var $length;
    var $hash=__stackBase__;
    var $p;
    var $count;
    var $f_in;
    var $buf=__stackBase__+4;
    var $fname=__stackBase__+204;
    var $dict_line=__stackBase__+400;
    $path_addr=$path;
    $filename_addr=$filename;
    $count=0; //@line 849 "compiledict.cpp"
    HEAP8[(__ZL9text_mode_b)]=0;
    var $arraydecay=(($fname)&4294967295); //@line 858 "compiledict.cpp"
    var $0=$path_addr; //@line 858 "compiledict.cpp"
    var $1=$filename_addr; //@line 858 "compiledict.cpp"
    var $call=_sprintf($arraydecay, ((__str104)&4294967295), allocate([$0,0,0,0,$1,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 858 "compiledict.cpp"
    var $arraydecay1=(($fname)&4294967295); //@line 859 "compiledict.cpp"
    var $call2=_fopen($arraydecay1, ((__str51703)&4294967295)); //@line 859 "compiledict.cpp"
    $f_in=$call2; //@line 859 "compiledict.cpp"
    var $cmp=((($call2))|0)==0; //@line 859 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 859 "compiledict.cpp"
    $if_then$$if_end9$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay3=(($fname)&4294967295); //@line 861 "compiledict.cpp"
        var $2=$path_addr; //@line 861 "compiledict.cpp"
        var $3=$filename_addr; //@line 861 "compiledict.cpp"
        var $call4=_sprintf($arraydecay3, ((__str47699)&4294967295), allocate([$2,0,0,0,$3,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 861 "compiledict.cpp"
        var $arraydecay5=(($fname)&4294967295); //@line 862 "compiledict.cpp"
        var $call6=_fopen($arraydecay5, ((__str51703)&4294967295)); //@line 862 "compiledict.cpp"
        $f_in=$call6; //@line 862 "compiledict.cpp"
        var $cmp7=((($call6))|0)==0; //@line 862 "compiledict.cpp"
        if (!($cmp7)) { __label__ = 3;break $if_then$$if_end9$2; } //@line 862 "compiledict.cpp"
  
        $retval=-1; //@line 863 "compiledict.cpp"
        __label__ = 11;break $if_then$$if_end9$2; //@line 863 "compiledict.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $4=HEAP32[((__ZL5f_log)>>2)]; //@line 866 "compiledict.cpp"
      var $arraydecay10=(($fname)&4294967295); //@line 866 "compiledict.cpp"
      var $call11=_fprintf($4, ((__str78)&4294967295), allocate([$arraydecay10,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 866 "compiledict.cpp"
      HEAP32[((__ZL7linenum)>>2)]=0; //@line 868 "compiledict.cpp"
      var $arraydecay12=(($buf)&4294967295); //@line 870 "compiledict.cpp"
      var $arraydecay15=(($buf)&4294967295); //@line 874 "compiledict.cpp"
      var $arraydecay16=(($dict_line)&4294967295); //@line 874 "compiledict.cpp"
      var $arraydecay33=(($dict_line)&4294967295); //@line 892 "compiledict.cpp"
      ; //@line 870 "compiledict.cpp"
      $while_cond$7: while(1) { 
  
        var $5=$f_in; //@line 870 "compiledict.cpp"
        var $call13=_fgets($arraydecay12, 200, $5); //@line 870 "compiledict.cpp"
        var $cmp14=((($call13))|0)!=0; //@line 870 "compiledict.cpp"
        if (!($cmp14)) { __label__ = 10;break $while_cond$7; } //@line 870 "compiledict.cpp"
  
        var $6=HEAP32[((__ZL7linenum)>>2)]; //@line 872 "compiledict.cpp"
        var $inc=((($6)+1)&4294967295); //@line 872 "compiledict.cpp"
        HEAP32[((__ZL7linenum)>>2)]=$inc; //@line 872 "compiledict.cpp"
        var $call17=__ZL12compile_linePcS_Pi($arraydecay15, $arraydecay16, $hash); //@line 874 "compiledict.cpp"
        $length=$call17; //@line 874 "compiledict.cpp"
        var $7=$length; //@line 875 "compiledict.cpp"
        var $cmp18=((($7))|0)==0; //@line 875 "compiledict.cpp"
        if ($cmp18) { __label__ = 4;continue $while_cond$7; } //@line 875 "compiledict.cpp"
  
        var $8=HEAP32[(($hash)>>2)]; //@line 877 "compiledict.cpp"
        var $arrayidx=((__ZL11hash_counts+$8*4)&4294967295); //@line 877 "compiledict.cpp"
        var $9=HEAP32[(($arrayidx)>>2)]; //@line 877 "compiledict.cpp"
        var $inc21=((($9)+1)&4294967295); //@line 877 "compiledict.cpp"
        HEAP32[(($arrayidx)>>2)]=$inc21; //@line 877 "compiledict.cpp"
        var $10=$length; //@line 879 "compiledict.cpp"
        var $add=((($10)+4)&4294967295); //@line 879 "compiledict.cpp"
        var $call22=_malloc($add); //@line 879 "compiledict.cpp"
        $p=$call22; //@line 879 "compiledict.cpp"
        var $11=$p; //@line 880 "compiledict.cpp"
        var $cmp23=((($11))|0)==0; //@line 880 "compiledict.cpp"
        if ($cmp23) { __label__ = 7;break $while_cond$7; } //@line 880 "compiledict.cpp"
  
        var $16=$p; //@line 890 "compiledict.cpp"
        var $17=HEAP32[(($hash)>>2)]; //@line 890 "compiledict.cpp"
        var $arrayidx31=((__ZL11hash_chains+$17*4)&4294967295); //@line 890 "compiledict.cpp"
        var $18=$arrayidx31; //@line 890 "compiledict.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $18;
        $dest$ = $16;
        $stop$ = $src$ + 4;
        if (($dest$%4) == ($src$%4) && 4 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 890 "compiledict.cpp"
        var $19=$p; //@line 891 "compiledict.cpp"
        var $20=HEAP32[(($hash)>>2)]; //@line 891 "compiledict.cpp"
        var $arrayidx32=((__ZL11hash_chains+$20*4)&4294967295); //@line 891 "compiledict.cpp"
        HEAP32[(($arrayidx32)>>2)]=$19; //@line 891 "compiledict.cpp"
        var $21=$p; //@line 892 "compiledict.cpp"
        var $add_ptr=(($21+4)&4294967295); //@line 892 "compiledict.cpp"
        var $22=$length; //@line 892 "compiledict.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $arraydecay33;
        $dest$ = $add_ptr;
        $stop$ = $src$ + $22;
        if (($dest$%4) == ($src$%4) && $22 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 892 "compiledict.cpp"
        var $23=$count; //@line 893 "compiledict.cpp"
        var $inc34=((($23)+1)&4294967295); //@line 893 "compiledict.cpp"
        $count=$inc34; //@line 893 "compiledict.cpp"
        __label__ = 4;continue $while_cond$7; //@line 894 "compiledict.cpp"
      }
      $while_end$$if_then24$12: do { 
        if (__label__ == 7) {
  
          var $12=HEAP32[((__ZL5f_log)>>2)]; //@line 882 "compiledict.cpp"
          var $cmp25=((($12))|0)!=0; //@line 882 "compiledict.cpp"
          if (!($cmp25)) { __label__ = 10;break $while_end$$if_then24$12; } //@line 882 "compiledict.cpp"
  
          var $13=HEAP32[((__ZL5f_log)>>2)]; //@line 884 "compiledict.cpp"
          var $14=_fwrite(((__str106)&4294967295), 22, 1, $13); //@line 884 "compiledict.cpp"
          var $15=HEAP32[((__ZL11error_count)>>2)]; //@line 885 "compiledict.cpp"
          var $inc28=((($15)+1)&4294967295); //@line 885 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc28; //@line 885 "compiledict.cpp"
          ; //@line 886 "compiledict.cpp"
        }
      } while(0);
  
      var $24=HEAP32[((__ZL5f_log)>>2)]; //@line 896 "compiledict.cpp"
      var $25=$count; //@line 896 "compiledict.cpp"
      var $call35=_fprintf($24, ((__str107)&4294967295), allocate([$25,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 896 "compiledict.cpp"
      var $26=$f_in; //@line 897 "compiledict.cpp"
      var $call36=_fclose($26); //@line 897 "compiledict.cpp"
      $retval=0; //@line 898 "compiledict.cpp"
      ; //@line 898 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL20compile_dictlist_endP7__sFILE($f_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $f_out_addr;
    var $hash;
    var $length;
    var $p=__stackBase__;
    $f_out_addr=$f_out;
    $hash=0; //@line 827 "compiledict.cpp"
    var $0=$p; //@line 836 "compiledict.cpp"
    ; //@line 827 "compiledict.cpp"
    $for_body$2: while(1) { 
  
      var $1=$hash; //@line 829 "compiledict.cpp"
      var $arrayidx=((__ZL11hash_chains+$1*4)&4294967295); //@line 829 "compiledict.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 829 "compiledict.cpp"
      HEAP32[(($p)>>2)]=$2; //@line 829 "compiledict.cpp"
      var $3=$f_out_addr; //@line 830 "compiledict.cpp"
      var $call=_ftell($3); //@line 830 "compiledict.cpp"
      var $4=$hash; //@line 830 "compiledict.cpp"
      var $arrayidx2=((__ZL11hash_counts+$4*4)&4294967295); //@line 830 "compiledict.cpp"
      HEAP32[(($arrayidx2)>>2)]=$call; //@line 830 "compiledict.cpp"
      var $5=HEAP32[(($p)>>2)]; //@line 832 "compiledict.cpp"
      var $cmp31=((($5))|0)!=0; //@line 832 "compiledict.cpp"
      if ($cmp31) { __label__ = 2;; } else { __label__ = 3;; } //@line 832 "compiledict.cpp"
      $while_body$$while_end$4: do { 
        if (__label__ == 2) {
          while(1) { 
  
            var $6=HEAP32[(($p)>>2)]; //@line 834 "compiledict.cpp"
            var $add_ptr=(($6+4)&4294967295); //@line 834 "compiledict.cpp"
            var $7=HEAP8[($add_ptr)]; //@line 834 "compiledict.cpp"
            var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 834 "compiledict.cpp"
            $length=$conv; //@line 834 "compiledict.cpp"
            var $8=HEAP32[(($p)>>2)]; //@line 835 "compiledict.cpp"
            var $add_ptr4=(($8+4)&4294967295); //@line 835 "compiledict.cpp"
            var $9=$length; //@line 835 "compiledict.cpp"
            var $10=$f_out_addr; //@line 835 "compiledict.cpp"
            var $call5=_fwrite($add_ptr4, $9, 1, $10); //@line 835 "compiledict.cpp"
            var $11=HEAP32[(($p)>>2)]; //@line 836 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $11;
            $dest$ = $0;
            $stop$ = $src$ + 4;
            if (($dest$%4) == ($src$%4) && 4 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 836 "compiledict.cpp"
            var $12=HEAP32[(($p)>>2)]; //@line 832 "compiledict.cpp"
            var $cmp3=((($12))|0)!=0; //@line 832 "compiledict.cpp"
            if ($cmp3) { __label__ = 2;continue ; } else { __label__ = 3;break $while_body$$while_end$4; } //@line 832 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $13=$f_out_addr; //@line 838 "compiledict.cpp"
      var $call6=_fputc(0, $13); //@line 838 "compiledict.cpp"
      var $14=$hash; //@line 827 "compiledict.cpp"
      var $inc=((($14)+1)&4294967295); //@line 827 "compiledict.cpp"
      $hash=$inc; //@line 827 "compiledict.cpp"
      var $cmp1=((($inc))|0) < 1024; //@line 827 "compiledict.cpp"
      if ($cmp1) { __label__ = 1;continue $for_body$2; } else { __label__ = 4;break $for_body$2; } //@line 827 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 840 "compiledict.cpp"
    return;
  }
  

  function __ZL17compile_dictrulesP7__sFILES0_Pc($f_in, $f_out, $fname_temp) {
    var __stackBase__  = STACKTOP; STACKTOP += 11876; _memset(__stackBase__, 0, 11876);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $f_in_addr;
    var $f_out_addr;
    var $fname_temp_addr;
    var $prule;
    var $p;
    var $ix;
    var $c=__stackBase__;
    var $gp;
    var $f_temp;
    var $n_rules=__stackBase__+4;
    var $count;
    var $different;
    var $wc=__stackBase__+8;
    var $prev_rgroup_name;
    var $char_code=__stackBase__+12;
    var $compile_mode;
    var $buf;
    var $buf1=__stackBase__+16;
    var $rules=__stackBase__+516;
    var $n_rgroups;
    var $n_groups3;
    var $rgroup=__stackBase__+8516;
    var $replace1;
    var $replace2;
    var $p123;
    $f_in_addr=$f_in;
    $f_out_addr=$f_out;
    $fname_temp_addr=$fname_temp;
    HEAP32[(($n_rules)>>2)]=0; //@line 1623 "compiledict.cpp"
    $count=0; //@line 1624 "compiledict.cpp"
    $compile_mode=0; //@line 1629 "compiledict.cpp"
    $n_rgroups=0; //@line 1634 "compiledict.cpp"
    $n_groups3=0; //@line 1635 "compiledict.cpp"
    HEAP32[((__ZL7linenum)>>2)]=0; //@line 1638 "compiledict.cpp"
    HEAP8[(((__ZL10group_name)&4294967295))]=0; //@line 1639 "compiledict.cpp"
    var $0=$fname_temp_addr; //@line 1641 "compiledict.cpp"
    var $call=__ZL9fopen_logPKcS0_($0, ((__str79)&4294967295)); //@line 1641 "compiledict.cpp"
    $f_temp=$call; //@line 1641 "compiledict.cpp"
    var $cmp=((($call))|0)==0; //@line 1641 "compiledict.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 1641 "compiledict.cpp"
    if (__label__ == 2) {
  
      $retval=1; //@line 1642 "compiledict.cpp"
      ; //@line 1642 "compiledict.cpp"
    }
    else if (__label__ == 1) {
  
      var $arraydecay=(($buf1)&4294967295); //@line 1647 "compiledict.cpp"
      var $arraydecay25=(($rules)&4294967295); //@line 1665 "compiledict.cpp"
      var $1=$n_rules; //@line 1676 "compiledict.cpp"
      ; //@line 1646 "compiledict.cpp"
      $for_cond$5: while(1) { 
  
        var $2=HEAP32[((__ZL7linenum)>>2)]; //@line 1646 "compiledict.cpp"
        var $inc=((($2)+1)&4294967295); //@line 1646 "compiledict.cpp"
        HEAP32[((__ZL7linenum)>>2)]=$inc; //@line 1646 "compiledict.cpp"
        var $3=$f_in_addr; //@line 1647 "compiledict.cpp"
        var $call1=_fgets($arraydecay, 500, $3); //@line 1647 "compiledict.cpp"
        $buf=$call1; //@line 1647 "compiledict.cpp"
        var $cmp2=((($call1))|0)!=0; //@line 1648 "compiledict.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 10;; } //@line 1648 "compiledict.cpp"
        $if_then3$$if_then16$7: do { 
          if (__label__ == 4) {
  
            var $4=$buf; //@line 1650 "compiledict.cpp"
            var $call4=_strstr($4, ((__str82734)&4294967295)); //@line 1650 "compiledict.cpp"
            $p=$call4; //@line 1650 "compiledict.cpp"
            var $cmp5=((($call4))|0)!=0; //@line 1650 "compiledict.cpp"
            if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1650 "compiledict.cpp"
            if (__label__ == 5) {
  
              var $5=$p; //@line 1651 "compiledict.cpp"
              HEAP8[($5)]=0; //@line 1651 "compiledict.cpp"
              ; //@line 1651 "compiledict.cpp"
            }
  
            var $6=$buf; //@line 1653 "compiledict.cpp"
            var $arrayidx=(($6)&4294967295); //@line 1653 "compiledict.cpp"
            var $7=HEAP8[($arrayidx)]; //@line 1653 "compiledict.cpp"
            var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1653 "compiledict.cpp"
            var $cmp8=((($conv))|0)==13; //@line 1653 "compiledict.cpp"
            if ($cmp8) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 8;; } //@line 1653 "compiledict.cpp"
            if (__label__ == 7) {
  
              var $8=$buf; //@line 1653 "compiledict.cpp"
              var $incdec_ptr=(($8+1)&4294967295); //@line 1653 "compiledict.cpp"
              $buf=$incdec_ptr; //@line 1653 "compiledict.cpp"
              __lastLabel__ = 7; ; //@line 1653 "compiledict.cpp"
            }
  
            var $9=__lastLabel__ == 6 ? $6 : ($incdec_ptr); //@line 1656 "compiledict.cpp"
            var $cmp12=((($9))|0)==0; //@line 1656 "compiledict.cpp"
            if ($cmp12) { __label__ = 10;break $if_then3$$if_then16$7; } //@line 1656 "compiledict.cpp"
  
            var $10=$buf; //@line 1656 "compiledict.cpp"
            var $arrayidx13=(($10)&4294967295); //@line 1656 "compiledict.cpp"
            var $11=HEAP8[($arrayidx13)]; //@line 1656 "compiledict.cpp"
            var $conv14=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1656 "compiledict.cpp"
            var $cmp15=((($conv14))|0)==46; //@line 1656 "compiledict.cpp"
            if ($cmp15) { __label__ = 10;break $if_then3$$if_then16$7; } //@line 1656 "compiledict.cpp"
  
            var $69=$compile_mode; //@line 1750 "compiledict.cpp"
            if ($69 == 1) {
              __label__ = 44;;
            }
            else if ($69 == 2) {
              __label__ = 47;;
            }
            else {
            __label__ = 3;continue $for_cond$5;
            }
            
            if (__label__ == 44) {
  
              var $70=$buf; //@line 1753 "compiledict.cpp"
              var $call114=__ZL12compile_rulePc($70); //@line 1753 "compiledict.cpp"
              $prule=$call114; //@line 1753 "compiledict.cpp"
              var $71=$prule; //@line 1754 "compiledict.cpp"
              var $cmp115=((($71))|0)!=0; //@line 1754 "compiledict.cpp"
              if (!($cmp115)) { __label__ = 3;continue $for_cond$5; } //@line 1754 "compiledict.cpp"
  
              var $72=HEAP32[(($n_rules)>>2)]; //@line 1754 "compiledict.cpp"
              var $cmp117=((($72))|0) < 2000; //@line 1754 "compiledict.cpp"
              if (!($cmp117)) { __label__ = 3;continue $for_cond$5; } //@line 1754 "compiledict.cpp"
  
              var $73=$prule; //@line 1756 "compiledict.cpp"
              var $74=HEAP32[(($n_rules)>>2)]; //@line 1756 "compiledict.cpp"
              var $inc119=((($74)+1)&4294967295); //@line 1756 "compiledict.cpp"
              HEAP32[(($n_rules)>>2)]=$inc119; //@line 1756 "compiledict.cpp"
              var $arrayidx120=(($rules+$74*4)&4294967295); //@line 1756 "compiledict.cpp"
              HEAP32[(($arrayidx120)>>2)]=$73; //@line 1756 "compiledict.cpp"
              __label__ = 3;continue $for_cond$5; //@line 1757 "compiledict.cpp"
            }
            else if (__label__ == 47) {
  
              var $75=$buf; //@line 1766 "compiledict.cpp"
              $p123=$75; //@line 1766 "compiledict.cpp"
              $replace1=0; //@line 1767 "compiledict.cpp"
              $replace2=0; //@line 1768 "compiledict.cpp"
              var $76=$p123; //@line 1769 "compiledict.cpp"
              var $77=HEAP8[($76)]; //@line 1769 "compiledict.cpp"
              var $conv1254=(tempInt=(($77)),(tempInt>=128?tempInt-256:tempInt)); //@line 1769 "compiledict.cpp"
              var $call1265=__Z8isspace2j($conv1254); //@line 1769 "compiledict.cpp"
              var $tobool6=((($call1265))|0)!=0; //@line 1769 "compiledict.cpp"
              if ($tobool6) { __label__ = 48;; } else { __label__ = 49;; } //@line 1769 "compiledict.cpp"
              $while_body127$$while_end129$22: do { 
                if (__label__ == 48) {
                  while(1) { 
  
                    var $78=$p123; //@line 1769 "compiledict.cpp"
                    var $incdec_ptr128=(($78+1)&4294967295); //@line 1769 "compiledict.cpp"
                    $p123=$incdec_ptr128; //@line 1769 "compiledict.cpp"
                    var $79=$p123; //@line 1769 "compiledict.cpp"
                    var $80=HEAP8[($79)]; //@line 1769 "compiledict.cpp"
                    var $conv125=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 1769 "compiledict.cpp"
                    var $call126=__Z8isspace2j($conv125); //@line 1769 "compiledict.cpp"
                    var $tobool=((($call126))|0)!=0; //@line 1769 "compiledict.cpp"
                    if ($tobool) { __label__ = 48;continue ; } else { __label__ = 49;break $while_body127$$while_end129$22; } //@line 1769 "compiledict.cpp"
                  }
                }
              } while(0);
  
              $ix=0; //@line 1770 "compiledict.cpp"
              var $81=$p123; //@line 1771 "compiledict.cpp"
              var $82=HEAPU8[($81)]; //@line 1771 "compiledict.cpp"
              var $conv1317=((($82))&255); //@line 1771 "compiledict.cpp"
              var $cmp1328=((($conv1317))|0) > 32; //@line 1771 "compiledict.cpp"
              if ($cmp1328) { __label__ = 50;; } else { __label__ = 51;; } //@line 1771 "compiledict.cpp"
              $while_body133$$while_cond138_loopexit$26: do { 
                if (__label__ == 50) {
                  while(1) { 
  
                    var $83=$p123; //@line 1773 "compiledict.cpp"
                    var $call134=__Z7utf8_inPiPKc($c, $83); //@line 1773 "compiledict.cpp"
                    var $84=$p123; //@line 1773 "compiledict.cpp"
                    var $add_ptr=(($84+$call134)&4294967295); //@line 1773 "compiledict.cpp"
                    $p123=$add_ptr; //@line 1773 "compiledict.cpp"
                    var $85=HEAP32[(($c)>>2)]; //@line 1774 "compiledict.cpp"
                    var $86=$ix; //@line 1774 "compiledict.cpp"
                    var $shl=($85) << ($86); //@line 1774 "compiledict.cpp"
                    var $87=$replace1; //@line 1774 "compiledict.cpp"
                    var $add135=((($87)+($shl))&4294967295); //@line 1774 "compiledict.cpp"
                    $replace1=$add135; //@line 1774 "compiledict.cpp"
                    var $88=$ix; //@line 1775 "compiledict.cpp"
                    var $add136=((($88)+16)&4294967295); //@line 1775 "compiledict.cpp"
                    $ix=$add136; //@line 1775 "compiledict.cpp"
                    var $89=$p123; //@line 1771 "compiledict.cpp"
                    var $90=HEAPU8[($89)]; //@line 1771 "compiledict.cpp"
                    var $conv131=((($90))&255); //@line 1771 "compiledict.cpp"
                    var $cmp132=((($conv131))|0) > 32; //@line 1771 "compiledict.cpp"
                    if ($cmp132) { __label__ = 50;continue ; } else { __label__ = 51;break $while_body133$$while_cond138_loopexit$26; } //@line 1771 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $91=$p123; //@line 1777 "compiledict.cpp"
              var $92=HEAP8[($91)]; //@line 1777 "compiledict.cpp"
              var $conv1399=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt)); //@line 1777 "compiledict.cpp"
              var $call14010=__Z8isspace2j($conv1399); //@line 1777 "compiledict.cpp"
              var $tobool14111=((($call14010))|0)!=0; //@line 1777 "compiledict.cpp"
              if ($tobool14111) { __label__ = 52;; } else { __label__ = 53;; } //@line 1777 "compiledict.cpp"
              $while_body142$$while_end144$30: do { 
                if (__label__ == 52) {
                  while(1) { 
  
                    var $93=$p123; //@line 1777 "compiledict.cpp"
                    var $incdec_ptr143=(($93+1)&4294967295); //@line 1777 "compiledict.cpp"
                    $p123=$incdec_ptr143; //@line 1777 "compiledict.cpp"
                    var $94=$p123; //@line 1777 "compiledict.cpp"
                    var $95=HEAP8[($94)]; //@line 1777 "compiledict.cpp"
                    var $conv139=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 1777 "compiledict.cpp"
                    var $call140=__Z8isspace2j($conv139); //@line 1777 "compiledict.cpp"
                    var $tobool141=((($call140))|0)!=0; //@line 1777 "compiledict.cpp"
                    if ($tobool141) { __label__ = 52;continue ; } else { __label__ = 53;break $while_body142$$while_end144$30; } //@line 1777 "compiledict.cpp"
                  }
                }
              } while(0);
  
              $ix=0; //@line 1778 "compiledict.cpp"
              var $96=$p123; //@line 1779 "compiledict.cpp"
              var $97=HEAPU8[($96)]; //@line 1779 "compiledict.cpp"
              var $conv14612=((($97))&255); //@line 1779 "compiledict.cpp"
              var $cmp14713=((($conv14612))|0) > 32; //@line 1779 "compiledict.cpp"
              if ($cmp14713) { __label__ = 54;; } else { __label__ = 55;; } //@line 1779 "compiledict.cpp"
              $while_body148$$while_end154$34: do { 
                if (__label__ == 54) {
                  while(1) { 
  
                    var $98=$p123; //@line 1781 "compiledict.cpp"
                    var $call149=__Z7utf8_inPiPKc($c, $98); //@line 1781 "compiledict.cpp"
                    var $99=$p123; //@line 1781 "compiledict.cpp"
                    var $add_ptr150=(($99+$call149)&4294967295); //@line 1781 "compiledict.cpp"
                    $p123=$add_ptr150; //@line 1781 "compiledict.cpp"
                    var $100=HEAP32[(($c)>>2)]; //@line 1782 "compiledict.cpp"
                    var $101=$ix; //@line 1782 "compiledict.cpp"
                    var $shl151=($100) << ($101); //@line 1782 "compiledict.cpp"
                    var $102=$replace2; //@line 1782 "compiledict.cpp"
                    var $add152=((($102)+($shl151))&4294967295); //@line 1782 "compiledict.cpp"
                    $replace2=$add152; //@line 1782 "compiledict.cpp"
                    var $103=$ix; //@line 1783 "compiledict.cpp"
                    var $add153=((($103)+16)&4294967295); //@line 1783 "compiledict.cpp"
                    $ix=$add153; //@line 1783 "compiledict.cpp"
                    var $104=$p123; //@line 1779 "compiledict.cpp"
                    var $105=HEAPU8[($104)]; //@line 1779 "compiledict.cpp"
                    var $conv146=((($105))&255); //@line 1779 "compiledict.cpp"
                    var $cmp147=((($conv146))|0) > 32; //@line 1779 "compiledict.cpp"
                    if ($cmp147) { __label__ = 54;continue ; } else { __label__ = 55;break $while_body148$$while_end154$34; } //@line 1779 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $106=$replace1; //@line 1785 "compiledict.cpp"
              var $cmp155=((($106))|0)!=0; //@line 1785 "compiledict.cpp"
              if (!($cmp155)) { __label__ = 3;continue $for_cond$5; } //@line 1785 "compiledict.cpp"
  
              var $107=$f_out_addr; //@line 1787 "compiledict.cpp"
              var $108=$replace1; //@line 1787 "compiledict.cpp"
              __Z11Write4BytesP7__sFILEi($107, $108); //@line 1787 "compiledict.cpp"
              var $109=$f_out_addr; //@line 1788 "compiledict.cpp"
              var $110=$replace2; //@line 1788 "compiledict.cpp"
              __Z11Write4BytesP7__sFILEi($109, $110); //@line 1788 "compiledict.cpp"
              __label__ = 3;continue $for_cond$5; //@line 1789 "compiledict.cpp"
            }
          }
        } while(0);
  
        var $12=HEAP32[(($n_rules)>>2)]; //@line 1660 "compiledict.cpp"
        var $cmp17=((($12))|0) > 0; //@line 1660 "compiledict.cpp"
        if ($cmp17) { __label__ = 11;; } else { __label__ = 12;; } //@line 1660 "compiledict.cpp"
        if (__label__ == 11) {
  
          var $13=$n_rgroups; //@line 1662 "compiledict.cpp"
          var $arrayidx19=(($rgroup+$13*28)&4294967295); //@line 1662 "compiledict.cpp"
          var $name=(($arrayidx19)&4294967295); //@line 1662 "compiledict.cpp"
          var $arraydecay20=(($name)&4294967295); //@line 1662 "compiledict.cpp"
          var $call21=_strcpy($arraydecay20, ((__ZL10group_name)&4294967295)); //@line 1662 "compiledict.cpp"
          var $14=HEAP32[((__ZL9group3_ix)>>2)]; //@line 1663 "compiledict.cpp"
          var $15=$n_rgroups; //@line 1663 "compiledict.cpp"
          var $arrayidx22=(($rgroup+$15*28)&4294967295); //@line 1663 "compiledict.cpp"
          var $group3_ix=(($arrayidx22+24)&4294967295); //@line 1663 "compiledict.cpp"
          HEAP32[(($group3_ix)>>2)]=$14; //@line 1663 "compiledict.cpp"
          var $16=$f_temp; //@line 1664 "compiledict.cpp"
          var $call23=_ftell($16); //@line 1664 "compiledict.cpp"
          var $17=$n_rgroups; //@line 1664 "compiledict.cpp"
          var $arrayidx24=(($rgroup+$17*28)&4294967295); //@line 1664 "compiledict.cpp"
          var $start=(($arrayidx24+16)&4294967295); //@line 1664 "compiledict.cpp"
          HEAP32[(($start)>>2)]=$call23; //@line 1664 "compiledict.cpp"
          var $18=$f_temp; //@line 1665 "compiledict.cpp"
          var $19=HEAP32[(($n_rules)>>2)]; //@line 1665 "compiledict.cpp"
          __ZL17output_rule_groupP7__sFILEiPPcS1_($18, $19, $arraydecay25); //@line 1665 "compiledict.cpp"
          var $20=$f_temp; //@line 1666 "compiledict.cpp"
          var $call26=_ftell($20); //@line 1666 "compiledict.cpp"
          var $21=$n_rgroups; //@line 1666 "compiledict.cpp"
          var $arrayidx27=(($rgroup+$21*28)&4294967295); //@line 1666 "compiledict.cpp"
          var $start28=(($arrayidx27+16)&4294967295); //@line 1666 "compiledict.cpp"
          var $22=HEAP32[(($start28)>>2)]; //@line 1666 "compiledict.cpp"
          var $sub=((($call26)-($22))&4294967295); //@line 1666 "compiledict.cpp"
          var $23=$n_rgroups; //@line 1666 "compiledict.cpp"
          var $arrayidx29=(($rgroup+$23*28)&4294967295); //@line 1666 "compiledict.cpp"
          var $length=(($arrayidx29+20)&4294967295); //@line 1666 "compiledict.cpp"
          HEAP32[(($length)>>2)]=$sub; //@line 1666 "compiledict.cpp"
          var $24=$n_rgroups; //@line 1667 "compiledict.cpp"
          var $inc30=((($24)+1)&4294967295); //@line 1667 "compiledict.cpp"
          $n_rgroups=$inc30; //@line 1667 "compiledict.cpp"
          var $25=HEAP32[(($n_rules)>>2)]; //@line 1669 "compiledict.cpp"
          var $26=$count; //@line 1669 "compiledict.cpp"
          var $add=((($26)+($25))&4294967295); //@line 1669 "compiledict.cpp"
          $count=$add; //@line 1669 "compiledict.cpp"
          ; //@line 1670 "compiledict.cpp"
        }
  
        HEAP32[(($n_rules)>>2)]=0; //@line 1671 "compiledict.cpp"
        var $27=$compile_mode; //@line 1673 "compiledict.cpp"
        var $cmp32=((($27))|0)==2; //@line 1673 "compiledict.cpp"
        if ($cmp32) { __label__ = 13;; } else { __label__ = 14;; } //@line 1673 "compiledict.cpp"
        if (__label__ == 13) {
  
          var $28=$f_out_addr; //@line 1676 "compiledict.cpp"
          var $call34=_fwrite($1, 1, 4, $28); //@line 1676 "compiledict.cpp"
          $compile_mode=0; //@line 1677 "compiledict.cpp"
          ; //@line 1678 "compiledict.cpp"
        }
  
        var $29=$buf; //@line 1680 "compiledict.cpp"
        var $cmp36=((($29))|0)==0; //@line 1680 "compiledict.cpp"
        if ($cmp36) { __label__ = 57;break $for_cond$5; } //@line 1680 "compiledict.cpp"
  
        var $30=$buf; //@line 1682 "compiledict.cpp"
        var $call39=_memcmp($30, ((__str81)&4294967295), 2); //@line 1682 "compiledict.cpp"
        var $cmp40=((($call39))|0)==0; //@line 1682 "compiledict.cpp"
        var $31=$buf; //@line 1684 "compiledict.cpp"
        if ($cmp40) { __label__ = 16;; } else { __label__ = 17;; } //@line 1682 "compiledict.cpp"
        if (__label__ == 16) {
  
          var $arrayidx42=(($31+2)&4294967295); //@line 1684 "compiledict.cpp"
          var $32=$f_out_addr; //@line 1684 "compiledict.cpp"
          __ZL19compile_lettergroupPcP7__sFILE($arrayidx42, $32); //@line 1684 "compiledict.cpp"
          __label__ = 3;continue $for_cond$5; //@line 1685 "compiledict.cpp"
        }
        else if (__label__ == 17) {
  
          var $call45=_memcmp($31, ((__str82)&4294967295), 8); //@line 1688 "compiledict.cpp"
          var $cmp46=((($call45))|0)==0; //@line 1688 "compiledict.cpp"
          if ($cmp46) { __label__ = 18;; } else { __label__ = 20;; } //@line 1688 "compiledict.cpp"
          $if_then47$$if_end53$50: do { 
            if (__label__ == 18) {
  
              $compile_mode=2; //@line 1690 "compiledict.cpp"
              var $33=$f_out_addr; //@line 1691 "compiledict.cpp"
              var $call48=_fputc(6, $33); //@line 1691 "compiledict.cpp"
              var $34=$f_out_addr; //@line 1692 "compiledict.cpp"
              var $call49=_fputc(20, $34); //@line 1692 "compiledict.cpp"
              var $35=$f_out_addr; //@line 1695 "compiledict.cpp"
              var $call5014=_ftell($35); //@line 1695 "compiledict.cpp"
              var $and15=($call5014) & 3; //@line 1695 "compiledict.cpp"
              var $cmp5116=((($and15))|0)!=0; //@line 1695 "compiledict.cpp"
              if (!($cmp5116)) { __label__ = 20;break $if_then47$$if_end53$50; } //@line 1695 "compiledict.cpp"
              while(1) { 
  
                var $36=$f_out_addr; //@line 1696 "compiledict.cpp"
                var $call52=_fputc(0, $36); //@line 1696 "compiledict.cpp"
                var $37=$f_out_addr; //@line 1695 "compiledict.cpp"
                var $call50=_ftell($37); //@line 1695 "compiledict.cpp"
                var $and=($call50) & 3; //@line 1695 "compiledict.cpp"
                var $cmp51=((($and))|0)!=0; //@line 1695 "compiledict.cpp"
                if ($cmp51) { __label__ = 19;continue ; } else { __label__ = 20;break $if_then47$$if_end53$50; } //@line 1695 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $38=$buf; //@line 1699 "compiledict.cpp"
          var $call54=_memcmp($38, ((__str83)&4294967295), 6); //@line 1699 "compiledict.cpp"
          var $cmp55=((($call54))|0)==0; //@line 1699 "compiledict.cpp"
          if (!($cmp55)) { __label__ = 3;continue $for_cond$5; } //@line 1699 "compiledict.cpp"
  
          $compile_mode=1; //@line 1701 "compiledict.cpp"
          var $39=$buf; //@line 1703 "compiledict.cpp"
          var $arrayidx57=(($39+6)&4294967295); //@line 1703 "compiledict.cpp"
          $p=$arrayidx57; //@line 1703 "compiledict.cpp"
          ; //@line 1704 "compiledict.cpp"
          $while_cond58$56: while(1) { 
  
            var $40=$p; //@line 1704 "compiledict.cpp"
            var $arrayidx59=(($40)&4294967295); //@line 1704 "compiledict.cpp"
            var $41=HEAPU8[($arrayidx59)]; //@line 1704 "compiledict.cpp"
            var $conv60=((($41))&255); //@line 1704 "compiledict.cpp"
            var $cmp61=((($conv60))|0)==32; //@line 1704 "compiledict.cpp"
            if ($cmp61) { __label__ = 24;; } else { __label__ = 23;; } //@line 1704 "compiledict.cpp"
            if (__label__ == 23) {
  
              var $42=$p; //@line 1704 "compiledict.cpp"
              var $arrayidx62=(($42)&4294967295); //@line 1704 "compiledict.cpp"
              var $43=HEAPU8[($arrayidx62)]; //@line 1704 "compiledict.cpp"
              var $conv63=((($43))&255); //@line 1704 "compiledict.cpp"
              var $cmp64=((($conv63))|0)==9; //@line 1704 "compiledict.cpp"
              if (!($cmp64)) { __label__ = 25;break $while_cond58$56; } //@line 1704 "compiledict.cpp"
            }
  
            var $44=$p; //@line 1704 "compiledict.cpp"
            var $incdec_ptr66=(($44+1)&4294967295); //@line 1704 "compiledict.cpp"
            $p=$incdec_ptr66; //@line 1704 "compiledict.cpp"
            __label__ = 22;continue $while_cond58$56; //@line 1704 "compiledict.cpp"
          }
  
          $ix=0; //@line 1705 "compiledict.cpp"
          ; //@line 1706 "compiledict.cpp"
          $while_cond68$62: while(1) { 
  
            var $45=$p; //@line 1706 "compiledict.cpp"
            var $46=HEAPU8[($45)]; //@line 1706 "compiledict.cpp"
            var $conv69=((($46))&255); //@line 1706 "compiledict.cpp"
            var $cmp70=((($conv69))|0) > 32; //@line 1706 "compiledict.cpp"
            if (!($cmp70)) { __label__ = 29;break $while_cond68$62; } //@line 1706 "compiledict.cpp"
  
            var $47=$ix; //@line 1706 "compiledict.cpp"
            var $cmp71=((($47))|0) < 12; //@line 1706 "compiledict.cpp"
            if (!($cmp71)) { __label__ = 29;break $while_cond68$62; }
  
            var $48=$p; //@line 1707 "compiledict.cpp"
            var $incdec_ptr73=(($48+1)&4294967295); //@line 1707 "compiledict.cpp"
            $p=$incdec_ptr73; //@line 1707 "compiledict.cpp"
            var $49=HEAP8[($48)]; //@line 1707 "compiledict.cpp"
            var $50=$ix; //@line 1707 "compiledict.cpp"
            var $inc74=((($50)+1)&4294967295); //@line 1707 "compiledict.cpp"
            $ix=$inc74; //@line 1707 "compiledict.cpp"
            var $arrayidx75=((__ZL10group_name+$50)&4294967295); //@line 1707 "compiledict.cpp"
            HEAP8[($arrayidx75)]=$49; //@line 1707 "compiledict.cpp"
            __label__ = 26;continue $while_cond68$62; //@line 1707 "compiledict.cpp"
          }
  
          var $51=$ix; //@line 1708 "compiledict.cpp"
          var $arrayidx77=((__ZL10group_name+$51)&4294967295); //@line 1708 "compiledict.cpp"
          HEAP8[($arrayidx77)]=0; //@line 1708 "compiledict.cpp"
          HEAP32[((__ZL9group3_ix)>>2)]=0; //@line 1709 "compiledict.cpp"
          var $call78=_sscanf(((__ZL10group_name)&4294967295), ((__str84)&4294967295), allocate([$char_code,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 1711 "compiledict.cpp"
          var $cmp79=((($call78))|0)==1; //@line 1711 "compiledict.cpp"
          if ($cmp79) { __label__ = 30;; } else { __label__ = 33;; } //@line 1711 "compiledict.cpp"
          $if_then80$$if_else$67: do { 
            if (__label__ == 30) {
  
              $p=((__ZL10group_name)&4294967295); //@line 1714 "compiledict.cpp"
              var $52=HEAPU32[(($char_code)>>2)]; //@line 1716 "compiledict.cpp"
              var $cmp81=((($52))>>>0) > 256; //@line 1716 "compiledict.cpp"
              if ($cmp81) { __label__ = 31;; } else { __label__ = 32;; } //@line 1716 "compiledict.cpp"
              if (__label__ == 31) {
  
                var $53=HEAPU32[(($char_code)>>2)]; //@line 1718 "compiledict.cpp"
                var $shr=($53) >>> 8; //@line 1718 "compiledict.cpp"
                var $conv83=((($shr)) & 255); //@line 1718 "compiledict.cpp"
                var $54=$p; //@line 1718 "compiledict.cpp"
                var $incdec_ptr84=(($54+1)&4294967295); //@line 1718 "compiledict.cpp"
                $p=$incdec_ptr84; //@line 1718 "compiledict.cpp"
                HEAP8[($54)]=$conv83; //@line 1718 "compiledict.cpp"
                ; //@line 1719 "compiledict.cpp"
              }
  
              var $55=HEAP32[(($char_code)>>2)]; //@line 1720 "compiledict.cpp"
              var $conv86=((($55)) & 255); //@line 1720 "compiledict.cpp"
              var $56=$p; //@line 1720 "compiledict.cpp"
              var $incdec_ptr87=(($56+1)&4294967295); //@line 1720 "compiledict.cpp"
              $p=$incdec_ptr87; //@line 1720 "compiledict.cpp"
              HEAP8[($56)]=$conv86; //@line 1720 "compiledict.cpp"
              var $57=$p; //@line 1721 "compiledict.cpp"
              HEAP8[($57)]=0; //@line 1721 "compiledict.cpp"
              __label__ = 37;break $if_then80$$if_else$67; //@line 1722 "compiledict.cpp"
            }
            else if (__label__ == 33) {
  
              var $58=HEAP32[((_translator)>>2)]; //@line 1725 "compiledict.cpp"
              var $letter_bits_offset=(($58+964)&4294967295); //@line 1725 "compiledict.cpp"
              var $59=HEAP32[(($letter_bits_offset)>>2)]; //@line 1725 "compiledict.cpp"
              var $cmp88=((($59))|0) > 0; //@line 1725 "compiledict.cpp"
              if (!($cmp88)) { __label__ = 37;break $if_then80$$if_else$67; } //@line 1725 "compiledict.cpp"
  
              var $call90=__Z7utf8_inPiPKc($wc, ((__ZL10group_name)&4294967295)); //@line 1727 "compiledict.cpp"
              var $60=HEAP32[(($wc)>>2)]; //@line 1728 "compiledict.cpp"
              var $61=HEAP32[((_translator)>>2)]; //@line 1728 "compiledict.cpp"
              var $letter_bits_offset91=(($61+964)&4294967295); //@line 1728 "compiledict.cpp"
              var $62=HEAP32[(($letter_bits_offset91)>>2)]; //@line 1728 "compiledict.cpp"
              var $sub92=((($60)-($62))&4294967295); //@line 1728 "compiledict.cpp"
              $ix=$sub92; //@line 1728 "compiledict.cpp"
              var $cmp93=((($sub92))|0) >= 0; //@line 1728 "compiledict.cpp"
              if (!($cmp93)) { __label__ = 37;break $if_then80$$if_else$67; } //@line 1728 "compiledict.cpp"
  
              var $63=$ix; //@line 1728 "compiledict.cpp"
              var $cmp94=((($63))|0) < 128; //@line 1728 "compiledict.cpp"
              if (!($cmp94)) { __label__ = 37;break $if_then80$$if_else$67; } //@line 1728 "compiledict.cpp"
  
              var $64=$ix; //@line 1730 "compiledict.cpp"
              var $add96=((($64)+1)&4294967295); //@line 1730 "compiledict.cpp"
              HEAP32[((__ZL9group3_ix)>>2)]=$add96; //@line 1730 "compiledict.cpp"
              __lastLabel__ = 36; __label__ = 38;break $if_then80$$if_else$67; //@line 1731 "compiledict.cpp"
            }
          } while(0);
          if (__label__ == 37) {
  
            var $_pr=HEAP32[((__ZL9group3_ix)>>2)]; //@line 1735 "compiledict.cpp"
            __lastLabel__ = 37; ;
          }
  
          var $65=__lastLabel__ == 37 ? $_pr : ($add96); //@line 1735 "compiledict.cpp"
          var $cmp100=((($65))|0)==0; //@line 1735 "compiledict.cpp"
          if (!($cmp100)) { __label__ = 3;continue $for_cond$5; } //@line 1735 "compiledict.cpp"
  
          var $call102=_strlen(((__ZL10group_name)&4294967295)); //@line 1735 "compiledict.cpp"
          var $cmp103=((($call102))>>>0) > 2; //@line 1735 "compiledict.cpp"
          if (!($cmp103)) { __label__ = 3;continue $for_cond$5; } //@line 1735 "compiledict.cpp"
  
          var $call105=__Z7utf8_inPiPKc($c, ((__ZL10group_name)&4294967295)); //@line 1737 "compiledict.cpp"
          var $cmp106=((($call105))|0) < 2; //@line 1737 "compiledict.cpp"
          if ($cmp106) { __label__ = 41;; } else { __label__ = 42;; } //@line 1737 "compiledict.cpp"
          if (__label__ == 41) {
  
            var $66=HEAP32[((__ZL5f_log)>>2)]; //@line 1739 "compiledict.cpp"
            var $67=HEAP32[((__ZL7linenum)>>2)]; //@line 1739 "compiledict.cpp"
            var $call108=_fprintf($66, ((__str85)&4294967295), allocate([$67,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1739 "compiledict.cpp"
            var $68=HEAP32[((__ZL11error_count)>>2)]; //@line 1740 "compiledict.cpp"
            var $inc109=((($68)+1)&4294967295); //@line 1740 "compiledict.cpp"
            HEAP32[((__ZL11error_count)>>2)]=$inc109; //@line 1740 "compiledict.cpp"
            ; //@line 1741 "compiledict.cpp"
          }
  
          HEAP8[(((__ZL10group_name+2)&4294967295))]=0; //@line 1743 "compiledict.cpp"
          __label__ = 3;continue $for_cond$5; //@line 1744 "compiledict.cpp"
        }
      }
  
      var $111=$f_temp; //@line 1794 "compiledict.cpp"
      var $call158=_fclose($111); //@line 1794 "compiledict.cpp"
      var $arraydecay159=(($rgroup)&4294967295); //@line 1796 "compiledict.cpp"
      var $112=$arraydecay159; //@line 1796 "compiledict.cpp"
      var $113=$n_rgroups; //@line 1796 "compiledict.cpp"
      _qsort($112, $113, 28, 2); //@line 1796 "compiledict.cpp"
      var $114=$fname_temp_addr; //@line 1798 "compiledict.cpp"
      var $call160=_fopen($114, ((__str18429)&4294967295)); //@line 1798 "compiledict.cpp"
      $f_temp=$call160; //@line 1798 "compiledict.cpp"
      var $cmp161=((($call160))|0)==0; //@line 1798 "compiledict.cpp"
      if ($cmp161) { __label__ = 58;; } else { __label__ = 59;; } //@line 1798 "compiledict.cpp"
      if (__label__ == 58) {
  
        $retval=2; //@line 1799 "compiledict.cpp"
        ; //@line 1799 "compiledict.cpp"
      }
      else if (__label__ == 59) {
  
        $prev_rgroup_name=((__str15397)&4294967295); //@line 1801 "compiledict.cpp"
        $gp=0; //@line 1803 "compiledict.cpp"
        var $115=$gp; //@line 1803 "compiledict.cpp"
        var $116=$n_rgroups; //@line 1803 "compiledict.cpp"
        var $cmp1653=((($115))|0) < ((($116))|0); //@line 1803 "compiledict.cpp"
        if ($cmp1653) { __label__ = 60;; } else { __label__ = 70;; } //@line 1803 "compiledict.cpp"
        $for_body$$for_end210$88: do { 
          if (__label__ == 60) {
            $for_body$89: while(1) { 
  
              var $117=$f_temp; //@line 1805 "compiledict.cpp"
              var $118=$gp; //@line 1805 "compiledict.cpp"
              var $arrayidx166=(($rgroup+$118*28)&4294967295); //@line 1805 "compiledict.cpp"
              var $start167=(($arrayidx166+16)&4294967295); //@line 1805 "compiledict.cpp"
              var $119=HEAP32[(($start167)>>2)]; //@line 1805 "compiledict.cpp"
              var $call168=_fseek($117, $119, 0); //@line 1805 "compiledict.cpp"
              var $120=$gp; //@line 1807 "compiledict.cpp"
              var $arrayidx169=(($rgroup+$120*28)&4294967295); //@line 1807 "compiledict.cpp"
              var $name170=(($arrayidx169)&4294967295); //@line 1807 "compiledict.cpp"
              var $arraydecay171=(($name170)&4294967295); //@line 1807 "compiledict.cpp"
              var $121=$prev_rgroup_name; //@line 1807 "compiledict.cpp"
              var $call172=_strcmp($arraydecay171, $121); //@line 1807 "compiledict.cpp"
              $different=$call172; //@line 1807 "compiledict.cpp"
              var $cmp173=((($call172))|0)!=0; //@line 1807 "compiledict.cpp"
              if ($cmp173) { __label__ = 61;; } else { __label__ = 67;; } //@line 1807 "compiledict.cpp"
              if (__label__ == 61) {
  
                var $122=$gp; //@line 1810 "compiledict.cpp"
                var $cmp175=((($122))|0) > 0; //@line 1810 "compiledict.cpp"
                if ($cmp175) { __label__ = 62;; } else { __label__ = 63;; } //@line 1810 "compiledict.cpp"
                if (__label__ == 62) {
  
                  var $123=$f_out_addr; //@line 1811 "compiledict.cpp"
                  var $call177=_fputc(7, $123); //@line 1811 "compiledict.cpp"
                  ; //@line 1811 "compiledict.cpp"
                }
  
                var $124=$f_out_addr; //@line 1812 "compiledict.cpp"
                var $call179=_fputc(6, $124); //@line 1812 "compiledict.cpp"
                var $125=$gp; //@line 1814 "compiledict.cpp"
                var $arrayidx180=(($rgroup+$125*28)&4294967295); //@line 1814 "compiledict.cpp"
                var $group3_ix181=(($arrayidx180+24)&4294967295); //@line 1814 "compiledict.cpp"
                var $126=HEAP32[(($group3_ix181)>>2)]; //@line 1814 "compiledict.cpp"
                var $cmp182=((($126))|0)!=0; //@line 1814 "compiledict.cpp"
                if ($cmp182) { __label__ = 64;; } else { __label__ = 65;; } //@line 1814 "compiledict.cpp"
                if (__label__ == 64) {
  
                  var $127=$n_groups3; //@line 1816 "compiledict.cpp"
                  var $inc184=((($127)+1)&4294967295); //@line 1816 "compiledict.cpp"
                  $n_groups3=$inc184; //@line 1816 "compiledict.cpp"
                  var $128=$f_out_addr; //@line 1817 "compiledict.cpp"
                  var $call185=_fputc(1, $128); //@line 1817 "compiledict.cpp"
                  var $129=$gp; //@line 1818 "compiledict.cpp"
                  var $arrayidx186=(($rgroup+$129*28)&4294967295); //@line 1818 "compiledict.cpp"
                  var $group3_ix187=(($arrayidx186+24)&4294967295); //@line 1818 "compiledict.cpp"
                  var $130=HEAP32[(($group3_ix187)>>2)]; //@line 1818 "compiledict.cpp"
                  var $131=$f_out_addr; //@line 1818 "compiledict.cpp"
                  var $call188=_fputc($130, $131); //@line 1818 "compiledict.cpp"
                  ; //@line 1819 "compiledict.cpp"
                }
                else if (__label__ == 65) {
  
                  var $132=$f_out_addr; //@line 1822 "compiledict.cpp"
                  var $133=$gp; //@line 1822 "compiledict.cpp"
                  var $arrayidx190=(($rgroup+$133*28)&4294967295); //@line 1822 "compiledict.cpp"
                  var $name191=(($arrayidx190)&4294967295); //@line 1822 "compiledict.cpp"
                  var $arraydecay192=(($name191)&4294967295); //@line 1822 "compiledict.cpp"
                  $prev_rgroup_name=$arraydecay192; //@line 1822 "compiledict.cpp"
                  var $fputs=_fputs($arraydecay192, $132); //@line 1822 "compiledict.cpp"
                  ;
                }
  
                var $134=$f_out_addr; //@line 1824 "compiledict.cpp"
                var $call195=_fputc(0, $134); //@line 1824 "compiledict.cpp"
                ; //@line 1825 "compiledict.cpp"
              }
  
              var $135=$gp; //@line 1827 "compiledict.cpp"
              var $arrayidx197=(($rgroup+$135*28)&4294967295); //@line 1827 "compiledict.cpp"
              var $length198=(($arrayidx197+20)&4294967295); //@line 1827 "compiledict.cpp"
              var $136=HEAP32[(($length198)>>2)]; //@line 1827 "compiledict.cpp"
              $ix=$136; //@line 1827 "compiledict.cpp"
              var $cmp2002=((($136))|0) > 0; //@line 1827 "compiledict.cpp"
              if ($cmp2002) { __label__ = 68;; } else { __label__ = 69;; } //@line 1827 "compiledict.cpp"
              $for_body201$$for_end204$101: do { 
                if (__label__ == 68) {
                  while(1) { 
  
                    var $137=$f_temp; //@line 1829 "compiledict.cpp"
                    var $call202=_fgetc($137); //@line 1829 "compiledict.cpp"
                    HEAP32[(($c)>>2)]=$call202; //@line 1829 "compiledict.cpp"
                    var $138=HEAP32[(($c)>>2)]; //@line 1830 "compiledict.cpp"
                    var $139=$f_out_addr; //@line 1830 "compiledict.cpp"
                    var $call203=_fputc($138, $139); //@line 1830 "compiledict.cpp"
                    var $140=$ix; //@line 1827 "compiledict.cpp"
                    var $dec=((($140)-1)&4294967295); //@line 1827 "compiledict.cpp"
                    $ix=$dec; //@line 1827 "compiledict.cpp"
                    var $cmp200=((($dec))|0) > 0; //@line 1827 "compiledict.cpp"
                    if ($cmp200) { __label__ = 68;continue ; } else { __label__ = 69;break $for_body201$$for_end204$101; } //@line 1827 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $141=$gp; //@line 1803 "compiledict.cpp"
              var $inc209=((($141)+1)&4294967295); //@line 1803 "compiledict.cpp"
              $gp=$inc209; //@line 1803 "compiledict.cpp"
              var $142=$gp; //@line 1803 "compiledict.cpp"
              var $143=$n_rgroups; //@line 1803 "compiledict.cpp"
              var $cmp165=((($142))|0) < ((($143))|0); //@line 1803 "compiledict.cpp"
              if ($cmp165) { __label__ = 60;continue $for_body$89; } else { __label__ = 70;break $for_body$$for_end210$88; } //@line 1803 "compiledict.cpp"
            }
          }
        } while(0);
  
        var $144=$f_out_addr; //@line 1837 "compiledict.cpp"
        var $call211=_fputc(7, $144); //@line 1837 "compiledict.cpp"
        var $145=$f_out_addr; //@line 1838 "compiledict.cpp"
        var $call212=_fputc(0, $145); //@line 1838 "compiledict.cpp"
        var $146=$f_temp; //@line 1840 "compiledict.cpp"
        var $call213=_fclose($146); //@line 1840 "compiledict.cpp"
        var $147=$fname_temp_addr; //@line 1841 "compiledict.cpp"
        var $call214=_remove($147); //@line 1841 "compiledict.cpp"
        var $148=HEAP32[((__ZL5f_log)>>2)]; //@line 1843 "compiledict.cpp"
        var $149=$count; //@line 1843 "compiledict.cpp"
        var $150=$n_rgroups; //@line 1843 "compiledict.cpp"
        var $151=$n_groups3; //@line 1843 "compiledict.cpp"
        var $call215=_fprintf($148, ((__str89)&4294967295), allocate([$149,0,0,0,$150,0,0,0,$151,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1843 "compiledict.cpp"
        $retval=0; //@line 1844 "compiledict.cpp"
        ; //@line 1844 "compiledict.cpp"
      }
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL17output_rule_groupP7__sFILEiPPcS1_($f_out, $n_rules, $rules) {
    var __stackBase__  = STACKTOP; STACKTOP += 512; _memset(__stackBase__, 0, 512);
    var __label__;
  
    var $f_out_addr;
    var $n_rules_addr;
    var $rules_addr;
    var $name_addr;
    var $ix;
    var $len1;
    var $len2;
    var $len_name;
    var $p;
    var $p2;
    var $p3;
    var $common;
    var $nextchar_count=__stackBase__;
    $f_out_addr=$f_out;
    $n_rules_addr=$n_rules;
    $rules_addr=$rules;
    $name_addr=((__ZL10group_name)&4294967295);
    var $arraydecay=(($nextchar_count)&4294967295); //@line 1480 "compiledict.cpp"
    var $0=$arraydecay; //@line 1480 "compiledict.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $0;
    $stop$ = $dest$ + 512;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1480 "compiledict.cpp"
    var $1=$name_addr; //@line 1482 "compiledict.cpp"
    var $call=_strlen($1); //@line 1482 "compiledict.cpp"
    $len_name=$call; //@line 1482 "compiledict.cpp"
    $common=((__str13643)&4294967295); //@line 1489 "compiledict.cpp"
    var $2=$rules_addr; //@line 1490 "compiledict.cpp"
    var $3=$2; //@line 1490 "compiledict.cpp"
    var $4=$n_rules_addr; //@line 1490 "compiledict.cpp"
    _qsort($3, $4, 4, 4); //@line 1490 "compiledict.cpp"
    var $5=$name_addr; //@line 1492 "compiledict.cpp"
    var $call1=_strcmp($5, ((__str103)&4294967295)); //@line 1492 "compiledict.cpp"
    var $cmp=((($call1))|0)==0; //@line 1492 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1492 "compiledict.cpp"
    if (__label__ == 1) {
  
      $len_name=0; //@line 1493 "compiledict.cpp"
      ; //@line 1493 "compiledict.cpp"
    }
  
    $ix=0; //@line 1495 "compiledict.cpp"
    var $6=$ix; //@line 1495 "compiledict.cpp"
    var $7=$n_rules_addr; //@line 1495 "compiledict.cpp"
    var $cmp21=((($6))|0) < ((($7))|0); //@line 1495 "compiledict.cpp"
    if ($cmp21) { __label__ = 3;; } else { __label__ = 11;; } //@line 1495 "compiledict.cpp"
    $for_body$$for_end$5: do { 
      if (__label__ == 3) {
        $for_body$6: while(1) { 
  
          var $8=$ix; //@line 1497 "compiledict.cpp"
          var $9=$rules_addr; //@line 1497 "compiledict.cpp"
          var $arrayidx=(($9+4*$8)&4294967295); //@line 1497 "compiledict.cpp"
          var $10=HEAP32[(($arrayidx)>>2)]; //@line 1497 "compiledict.cpp"
          $p=$10; //@line 1497 "compiledict.cpp"
          var $11=$p; //@line 1498 "compiledict.cpp"
          var $call3=_strlen($11); //@line 1498 "compiledict.cpp"
          var $add=((($call3)+1)&4294967295); //@line 1498 "compiledict.cpp"
          $len1=$add; //@line 1498 "compiledict.cpp"
          var $12=$len1; //@line 1499 "compiledict.cpp"
          var $13=$p; //@line 1499 "compiledict.cpp"
          var $arrayidx4=(($13+$12)&4294967295); //@line 1499 "compiledict.cpp"
          $p3=$arrayidx4; //@line 1499 "compiledict.cpp"
          var $14=$p3; //@line 1500 "compiledict.cpp"
          var $15=$len_name; //@line 1500 "compiledict.cpp"
          var $add_ptr=(($14+$15)&4294967295); //@line 1500 "compiledict.cpp"
          $p2=$add_ptr; //@line 1500 "compiledict.cpp"
          var $16=$p2; //@line 1501 "compiledict.cpp"
          var $call5=_strlen($16); //@line 1501 "compiledict.cpp"
          $len2=$call5; //@line 1501 "compiledict.cpp"
          var $17=$p2; //@line 1503 "compiledict.cpp"
          var $arrayidx6=(($17)&4294967295); //@line 1503 "compiledict.cpp"
          var $18=HEAPU8[($arrayidx6)]; //@line 1503 "compiledict.cpp"
          var $idxprom=((($18))&255); //@line 1503 "compiledict.cpp"
          var $arrayidx7=(($nextchar_count+$idxprom*2)&4294967295); //@line 1503 "compiledict.cpp"
          var $19=HEAP16[(($arrayidx7)>>1)]; //@line 1503 "compiledict.cpp"
          var $inc=((($19)+1)&65535); //@line 1503 "compiledict.cpp"
          HEAP16[(($arrayidx7)>>1)]=$inc; //@line 1503 "compiledict.cpp"
          var $20=$common; //@line 1505 "compiledict.cpp"
          var $arrayidx8=(($20)&4294967295); //@line 1505 "compiledict.cpp"
          var $21=HEAP8[($arrayidx8)]; //@line 1505 "compiledict.cpp"
          var $conv=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 1505 "compiledict.cpp"
          var $cmp9=((($conv))|0)!=0; //@line 1505 "compiledict.cpp"
          if ($cmp9) { __label__ = 4;; } else { __label__ = 6;; } //@line 1505 "compiledict.cpp"
          $land_lhs_true$$if_else$8: do { 
            if (__label__ == 4) {
  
              var $22=$p; //@line 1505 "compiledict.cpp"
              var $23=$common; //@line 1505 "compiledict.cpp"
              var $call10=_strcmp($22, $23); //@line 1505 "compiledict.cpp"
              var $cmp11=((($call10))|0)==0; //@line 1505 "compiledict.cpp"
              if (!($cmp11)) { __label__ = 6;break $land_lhs_true$$if_else$8; } //@line 1505 "compiledict.cpp"
  
              var $24=$p2; //@line 1507 "compiledict.cpp"
              var $25=$len2; //@line 1507 "compiledict.cpp"
              var $26=$f_out_addr; //@line 1507 "compiledict.cpp"
              var $call13=_fwrite($24, $25, 1, $26); //@line 1507 "compiledict.cpp"
              var $27=$f_out_addr; //@line 1508 "compiledict.cpp"
              var $call14=_fputc(0, $27); //@line 1508 "compiledict.cpp"
              __label__ = 10;break $land_lhs_true$$if_else$8; //@line 1509 "compiledict.cpp"
            }
          } while(0);
          if (__label__ == 6) {
  
            var $28=$ix; //@line 1512 "compiledict.cpp"
            var $29=$n_rules_addr; //@line 1512 "compiledict.cpp"
            var $sub=((($29)-1)&4294967295); //@line 1512 "compiledict.cpp"
            var $cmp15=((($28))|0) < ((($sub))|0); //@line 1512 "compiledict.cpp"
            if ($cmp15) { __label__ = 7;; } else { __label__ = 9;; } //@line 1512 "compiledict.cpp"
            $land_lhs_true16$$if_end24$13: do { 
              if (__label__ == 7) {
  
                var $30=$p; //@line 1512 "compiledict.cpp"
                var $31=$ix; //@line 1512 "compiledict.cpp"
                var $add17=((($31)+1)&4294967295); //@line 1512 "compiledict.cpp"
                var $32=$rules_addr; //@line 1512 "compiledict.cpp"
                var $arrayidx18=(($32+4*$add17)&4294967295); //@line 1512 "compiledict.cpp"
                var $33=HEAP32[(($arrayidx18)>>2)]; //@line 1512 "compiledict.cpp"
                var $call19=_strcmp($30, $33); //@line 1512 "compiledict.cpp"
                var $cmp20=((($call19))|0)==0; //@line 1512 "compiledict.cpp"
                if (!($cmp20)) { __label__ = 9;break $land_lhs_true16$$if_end24$13; } //@line 1512 "compiledict.cpp"
  
                var $34=$ix; //@line 1514 "compiledict.cpp"
                var $35=$rules_addr; //@line 1514 "compiledict.cpp"
                var $arrayidx22=(($35+4*$34)&4294967295); //@line 1514 "compiledict.cpp"
                var $36=HEAP32[(($arrayidx22)>>2)]; //@line 1514 "compiledict.cpp"
                $common=$36; //@line 1514 "compiledict.cpp"
                var $37=$f_out_addr; //@line 1515 "compiledict.cpp"
                var $call23=_fputc(4, $37); //@line 1515 "compiledict.cpp"
                ; //@line 1516 "compiledict.cpp"
              }
            } while(0);
  
            var $38=$p2; //@line 1518 "compiledict.cpp"
            var $39=$len2; //@line 1518 "compiledict.cpp"
            var $40=$f_out_addr; //@line 1518 "compiledict.cpp"
            var $call25=_fwrite($38, $39, 1, $40); //@line 1518 "compiledict.cpp"
            var $41=$f_out_addr; //@line 1519 "compiledict.cpp"
            var $call26=_fputc(3, $41); //@line 1519 "compiledict.cpp"
            var $42=$p; //@line 1520 "compiledict.cpp"
            var $43=$len1; //@line 1520 "compiledict.cpp"
            var $44=$f_out_addr; //@line 1520 "compiledict.cpp"
            var $call27=_fwrite($42, $43, 1, $44); //@line 1520 "compiledict.cpp"
            ;
          }
  
          var $45=$ix; //@line 1495 "compiledict.cpp"
          var $inc29=((($45)+1)&4294967295); //@line 1495 "compiledict.cpp"
          $ix=$inc29; //@line 1495 "compiledict.cpp"
          var $46=$ix; //@line 1495 "compiledict.cpp"
          var $47=$n_rules_addr; //@line 1495 "compiledict.cpp"
          var $cmp2=((($46))|0) < ((($47))|0); //@line 1495 "compiledict.cpp"
          if ($cmp2) { __label__ = 3;continue $for_body$6; } else { __label__ = 11;break $for_body$$for_end$5; } //@line 1495 "compiledict.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 1531 "compiledict.cpp"
    return;
  }
  

  function __ZL19compile_lettergroupPcP7__sFILE($input, $f_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 1000; _memset(__stackBase__, 0, 1000);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $input_addr;
    var $f_out_addr;
    var $p;
    var $p_start;
    var $group;
    var $ix;
    var $n_items;
    var $length;
    var $max_length;
    var $items=__stackBase__;
    var $item_length=__stackBase__+800;
    $input_addr=$input;
    $f_out_addr=$f_out;
    $max_length=0; //@line 1543 "compiledict.cpp"
    var $0=$input_addr; //@line 1549 "compiledict.cpp"
    $p=$0; //@line 1549 "compiledict.cpp"
    var $1=$p; //@line 1550 "compiledict.cpp"
    var $arrayidx=(($1)&4294967295); //@line 1550 "compiledict.cpp"
    var $2=HEAP8[($arrayidx)]; //@line 1550 "compiledict.cpp"
    var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 1550 "compiledict.cpp"
    var $isdigittmp=((($conv)-48)&4294967295); //@line 1550 "compiledict.cpp"
    var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1550 "compiledict.cpp"
    var $call=((($isdigit))&1); //@line 1550 "compiledict.cpp"
    var $tobool=((($call))|0)!=0; //@line 1550 "compiledict.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1550 "compiledict.cpp"
    $lor_lhs_false$$if_then$2: do { 
      if (__label__ == 1) {
  
        var $3=$p; //@line 1550 "compiledict.cpp"
        var $arrayidx1=(($3+1)&4294967295); //@line 1550 "compiledict.cpp"
        var $4=HEAP8[($arrayidx1)]; //@line 1550 "compiledict.cpp"
        var $conv2=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1550 "compiledict.cpp"
        var $isdigittmp1=((($conv2)-48)&4294967295); //@line 1550 "compiledict.cpp"
        var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 1550 "compiledict.cpp"
        var $call3=((($isdigit2))&1); //@line 1550 "compiledict.cpp"
        var $tobool4=((($call3))|0)!=0; //@line 1550 "compiledict.cpp"
        if (!($tobool4)) { __label__ = 2;break $lor_lhs_false$$if_then$2; } //@line 1550 "compiledict.cpp"
  
        var $8=$p; //@line 1557 "compiledict.cpp"
        var $arrayidx6=(($8)&4294967295); //@line 1557 "compiledict.cpp"
        var $call7=_atoi($arrayidx6); //@line 1557 "compiledict.cpp"
        $group=$call7; //@line 1557 "compiledict.cpp"
        var $9=$group; //@line 1558 "compiledict.cpp"
        var $cmp=((($9))|0) >= 26; //@line 1558 "compiledict.cpp"
        if ($cmp) { __label__ = 5;; } else { __label__ = 4;; } //@line 1558 "compiledict.cpp"
        if (__label__ == 5) {
  
          var $12=HEAP32[((__ZL5f_log)>>2)]; //@line 1560 "compiledict.cpp"
          var $13=HEAP32[((__ZL7linenum)>>2)]; //@line 1560 "compiledict.cpp"
          var $call9=_fprintf($12, ((__str101)&4294967295), allocate([$13,0,0,0,25,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1560 "compiledict.cpp"
          var $14=HEAP32[((__ZL11error_count)>>2)]; //@line 1561 "compiledict.cpp"
          var $inc10=((($14)+1)&4294967295); //@line 1561 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc10; //@line 1561 "compiledict.cpp"
          $retval=1; //@line 1562 "compiledict.cpp"
          __label__ = 26;break $lor_lhs_false$$if_then$2; //@line 1562 "compiledict.cpp"
        }
        else if (__label__ == 4) {
  
          var $10=$p; //@line 1565 "compiledict.cpp"
          var $11=HEAP8[($10)]; //@line 1565 "compiledict.cpp"
          var $conv1210=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1565 "compiledict.cpp"
          var $call1311=__Z8isspace2j($conv1210); //@line 1565 "compiledict.cpp"
          var $tobool1412=((($call1311))|0)!=0; //@line 1565 "compiledict.cpp"
          var $lnot13=($tobool1412) ^ 1; //@line 1565 "compiledict.cpp"
          if ($lnot13) { __label__ = 6;; } else { __label__ = 7;; } //@line 1565 "compiledict.cpp"
          $while_body$$while_end$8: do { 
            if (__label__ == 6) {
              while(1) { 
  
                var $15=$p; //@line 1565 "compiledict.cpp"
                var $incdec_ptr=(($15+1)&4294967295); //@line 1565 "compiledict.cpp"
                $p=$incdec_ptr; //@line 1565 "compiledict.cpp"
                var $16=$p; //@line 1565 "compiledict.cpp"
                var $17=HEAP8[($16)]; //@line 1565 "compiledict.cpp"
                var $conv12=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1565 "compiledict.cpp"
                var $call13=__Z8isspace2j($conv12); //@line 1565 "compiledict.cpp"
                var $tobool14=((($call13))|0)!=0; //@line 1565 "compiledict.cpp"
                var $lnot=($tobool14) ^ 1; //@line 1565 "compiledict.cpp"
                if ($lnot) { __label__ = 6;continue ; } else { __label__ = 7;break $while_body$$while_end$8; } //@line 1565 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $18=$f_out_addr; //@line 1567 "compiledict.cpp"
          var $call15=_fputc(6, $18); //@line 1567 "compiledict.cpp"
          var $19=$f_out_addr; //@line 1568 "compiledict.cpp"
          var $call16=_fputc(18, $19); //@line 1568 "compiledict.cpp"
          var $20=$group; //@line 1569 "compiledict.cpp"
          var $add=((($20)+65)&4294967295); //@line 1569 "compiledict.cpp"
          var $21=$f_out_addr; //@line 1569 "compiledict.cpp"
          var $call17=_fputc($add, $21); //@line 1569 "compiledict.cpp"
          var $22=$group; //@line 1570 "compiledict.cpp"
          var $arrayidx18=((__ZL19letterGroupsDefined+$22)&4294967295); //@line 1570 "compiledict.cpp"
          var $23=HEAP8[($arrayidx18)]; //@line 1570 "compiledict.cpp"
          var $conv19=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 1570 "compiledict.cpp"
          var $cmp20=((($conv19))|0)!=0; //@line 1570 "compiledict.cpp"
          if ($cmp20) { __label__ = 8;; } else { __label__ = 9;; } //@line 1570 "compiledict.cpp"
          if (__label__ == 8) {
  
            var $24=HEAP32[((__ZL5f_log)>>2)]; //@line 1572 "compiledict.cpp"
            var $25=HEAP32[((__ZL7linenum)>>2)]; //@line 1572 "compiledict.cpp"
            var $26=$group; //@line 1572 "compiledict.cpp"
            var $call22=_fprintf($24, ((__str102)&4294967295), allocate([$25,0,0,0,$26,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1572 "compiledict.cpp"
            var $27=HEAP32[((__ZL11error_count)>>2)]; //@line 1573 "compiledict.cpp"
            var $inc23=((($27)+1)&4294967295); //@line 1573 "compiledict.cpp"
            HEAP32[((__ZL11error_count)>>2)]=$inc23; //@line 1573 "compiledict.cpp"
            ; //@line 1574 "compiledict.cpp"
          }
  
          var $28=$group; //@line 1575 "compiledict.cpp"
          var $arrayidx25=((__ZL19letterGroupsDefined+$28)&4294967295); //@line 1575 "compiledict.cpp"
          HEAP8[($arrayidx25)]=1; //@line 1575 "compiledict.cpp"
          $n_items=0; //@line 1577 "compiledict.cpp"
          __lastLabel__ = 9; ; //@line 1578 "compiledict.cpp"
          $while_cond26$15: while(1) { 
  
            var $29=__lastLabel__ == 18 ? $_pr : (0); //@line 1578 "compiledict.cpp"
            var $cmp27=((($29))|0) < 200; //@line 1578 "compiledict.cpp"
            if (!($cmp27)) { __label__ = 19;break $while_cond26$15; } //@line 1578 "compiledict.cpp"
  
            var $30=$p; //@line 1580 "compiledict.cpp"
            var $31=HEAP8[($30)]; //@line 1580 "compiledict.cpp"
            var $conv306=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 1580 "compiledict.cpp"
            var $call317=__Z8isspace2j($conv306); //@line 1580 "compiledict.cpp"
            var $tobool328=((($call317))|0)!=0; //@line 1580 "compiledict.cpp"
            var $32=$p; //@line 1580 "compiledict.cpp"
            if ($tobool328) { __lastLabel__ = 11; __label__ = 12;; } else { __lastLabel__ = 11; __label__ = 13;; } //@line 1580 "compiledict.cpp"
            $while_body33$$while_end35$18: do { 
              if (__label__ == 12) {
                while(1) { 
  
                  var $33=__lastLabel__ == 12 ? $36 : ($32);
                  var $incdec_ptr34=(($33+1)&4294967295); //@line 1580 "compiledict.cpp"
                  $p=$incdec_ptr34; //@line 1580 "compiledict.cpp"
                  var $34=$p; //@line 1580 "compiledict.cpp"
                  var $35=HEAP8[($34)]; //@line 1580 "compiledict.cpp"
                  var $conv30=(tempInt=(($35)),(tempInt>=128?tempInt-256:tempInt)); //@line 1580 "compiledict.cpp"
                  var $call31=__Z8isspace2j($conv30); //@line 1580 "compiledict.cpp"
                  var $tobool32=((($call31))|0)!=0; //@line 1580 "compiledict.cpp"
                  var $36=$p; //@line 1580 "compiledict.cpp"
                  if ($tobool32) { __lastLabel__ = 12; __label__ = 12;continue ; } else { __lastLabel__ = 12; __label__ = 13;break $while_body33$$while_end35$18; } //@line 1580 "compiledict.cpp"
                }
              }
            } while(0);
  
            var $_lcssa=__lastLabel__ == 11 ? $32 : ($36);
            var $37=HEAP8[($_lcssa)]; //@line 1581 "compiledict.cpp"
            var $conv36=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 1581 "compiledict.cpp"
            var $cmp37=((($conv36))|0)==0; //@line 1581 "compiledict.cpp"
            if ($cmp37) { __label__ = 19;break $while_cond26$15; } //@line 1581 "compiledict.cpp"
  
            var $38=$p; //@line 1584 "compiledict.cpp"
            $p_start=$38; //@line 1584 "compiledict.cpp"
            var $39=$n_items; //@line 1584 "compiledict.cpp"
            var $arrayidx40=(($items+$39*4)&4294967295); //@line 1584 "compiledict.cpp"
            HEAP32[(($arrayidx40)>>2)]=$38; //@line 1584 "compiledict.cpp"
            ; //@line 1585 "compiledict.cpp"
            while(1) { 
  
              var $40=$p; //@line 1585 "compiledict.cpp"
              var $41=HEAP8[($40)]; //@line 1585 "compiledict.cpp"
              var $conv42=(tempInt=(($41)),(tempInt>=128?tempInt-256:tempInt)); //@line 1585 "compiledict.cpp"
              var $and=($conv42) & 255; //@line 1585 "compiledict.cpp"
              var $cmp43=((($and))|0) > 32; //@line 1585 "compiledict.cpp"
              var $42=$p; //@line 1587 "compiledict.cpp"
              var $incdec_ptr45=(($42+1)&4294967295); //@line 1587 "compiledict.cpp"
              $p=$incdec_ptr45; //@line 1587 "compiledict.cpp"
              if ($cmp43) { __label__ = 15;continue ; } else { __label__ = 16;break ; } //@line 1585 "compiledict.cpp"
            }
  
            HEAP8[($42)]=0; //@line 1589 "compiledict.cpp"
            var $43=$p; //@line 1590 "compiledict.cpp"
            var $44=$p_start; //@line 1590 "compiledict.cpp"
            var $sub_ptr_lhs_cast=($43); //@line 1590 "compiledict.cpp"
            var $sub_ptr_rhs_cast=($44); //@line 1590 "compiledict.cpp"
            var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 1590 "compiledict.cpp"
            $length=$sub_ptr_sub; //@line 1590 "compiledict.cpp"
            var $45=$length; //@line 1591 "compiledict.cpp"
            var $46=$max_length; //@line 1591 "compiledict.cpp"
            var $cmp48=((($45))|0) > ((($46))|0); //@line 1591 "compiledict.cpp"
            if ($cmp48) { __label__ = 17;; } else { __label__ = 18;; } //@line 1591 "compiledict.cpp"
            if (__label__ == 17) {
  
              var $47=$length; //@line 1592 "compiledict.cpp"
              $max_length=$47; //@line 1592 "compiledict.cpp"
              ; //@line 1592 "compiledict.cpp"
            }
  
            var $48=$length; //@line 1593 "compiledict.cpp"
            var $conv51=((($48)) & 255); //@line 1593 "compiledict.cpp"
            var $49=$n_items; //@line 1593 "compiledict.cpp"
            var $inc52=((($49)+1)&4294967295); //@line 1593 "compiledict.cpp"
            $n_items=$inc52; //@line 1593 "compiledict.cpp"
            var $arrayidx53=(($item_length+$49)&4294967295); //@line 1593 "compiledict.cpp"
            HEAP8[($arrayidx53)]=$conv51; //@line 1593 "compiledict.cpp"
            var $_pr=$n_items; //@line 1578 "compiledict.cpp"
            __lastLabel__ = 18; __label__ = 10;continue $while_cond26$15; //@line 1594 "compiledict.cpp"
          }
  
          var $_pr3=$max_length; //@line 1597 "compiledict.cpp"
          var $cmp565=((($_pr3))|0) > 1; //@line 1597 "compiledict.cpp"
          if ($cmp565) { __label__ = 20;; } else { __label__ = 25;; } //@line 1597 "compiledict.cpp"
          $while_body57$$while_end67$30: do { 
            if (__label__ == 20) {
              $while_body57$31: while(1) { 
  
                $ix=0; //@line 1599 "compiledict.cpp"
                var $50=$ix; //@line 1599 "compiledict.cpp"
                var $51=$n_items; //@line 1599 "compiledict.cpp"
                var $cmp584=((($50))|0) < ((($51))|0); //@line 1599 "compiledict.cpp"
                if ($cmp584) { __label__ = 21;; } else { __label__ = 24;; } //@line 1599 "compiledict.cpp"
                $for_body$$for_end$33: do { 
                  if (__label__ == 21) {
                    while(1) { 
  
                      var $52=$ix; //@line 1601 "compiledict.cpp"
                      var $arrayidx59=(($item_length+$52)&4294967295); //@line 1601 "compiledict.cpp"
                      var $53=HEAP8[($arrayidx59)]; //@line 1601 "compiledict.cpp"
                      var $conv60=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 1601 "compiledict.cpp"
                      var $54=$max_length; //@line 1601 "compiledict.cpp"
                      var $cmp61=((($conv60))|0)==((($54))|0); //@line 1601 "compiledict.cpp"
                      if ($cmp61) { __label__ = 22;; } else { __label__ = 23;; } //@line 1601 "compiledict.cpp"
                      if (__label__ == 22) {
  
                        var $55=$ix; //@line 1603 "compiledict.cpp"
                        var $arrayidx63=(($items+$55*4)&4294967295); //@line 1603 "compiledict.cpp"
                        var $56=HEAP32[(($arrayidx63)>>2)]; //@line 1603 "compiledict.cpp"
                        var $57=$max_length; //@line 1603 "compiledict.cpp"
                        var $58=$f_out_addr; //@line 1603 "compiledict.cpp"
                        var $call64=_fwrite($56, 1, $57, $58); //@line 1603 "compiledict.cpp"
                        ; //@line 1604 "compiledict.cpp"
                      }
  
                      var $59=$ix; //@line 1599 "compiledict.cpp"
                      var $inc66=((($59)+1)&4294967295); //@line 1599 "compiledict.cpp"
                      $ix=$inc66; //@line 1599 "compiledict.cpp"
                      var $60=$ix; //@line 1599 "compiledict.cpp"
                      var $61=$n_items; //@line 1599 "compiledict.cpp"
                      var $cmp58=((($60))|0) < ((($61))|0); //@line 1599 "compiledict.cpp"
                      if ($cmp58) { __label__ = 21;continue ; } else { __label__ = 24;break $for_body$$for_end$33; } //@line 1599 "compiledict.cpp"
                    }
                  }
                } while(0);
  
                var $62=$max_length; //@line 1606 "compiledict.cpp"
                var $dec=((($62)-1)&4294967295); //@line 1606 "compiledict.cpp"
                $max_length=$dec; //@line 1606 "compiledict.cpp"
                var $cmp56=((($dec))|0) > 1; //@line 1597 "compiledict.cpp"
                if ($cmp56) { __label__ = 20;continue $while_body57$31; } else { __label__ = 25;break $while_body57$$while_end67$30; } //@line 1597 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $63=$f_out_addr; //@line 1609 "compiledict.cpp"
          var $call68=_fputc(7, $63); //@line 1609 "compiledict.cpp"
          $retval=0; //@line 1611 "compiledict.cpp"
          __label__ = 26;break $lor_lhs_false$$if_then$2; //@line 1611 "compiledict.cpp"
        }
      }
    } while(0);
    if (__label__ == 2) {
  
      var $5=HEAP32[((__ZL5f_log)>>2)]; //@line 1552 "compiledict.cpp"
      var $6=HEAP32[((__ZL7linenum)>>2)]; //@line 1552 "compiledict.cpp"
      var $call5=_fprintf($5, ((__str100)&4294967295), allocate([$6,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1552 "compiledict.cpp"
      var $7=HEAP32[((__ZL11error_count)>>2)]; //@line 1553 "compiledict.cpp"
      var $inc=((($7)+1)&4294967295); //@line 1553 "compiledict.cpp"
      HEAP32[((__ZL11error_count)>>2)]=$inc; //@line 1553 "compiledict.cpp"
      $retval=1; //@line 1554 "compiledict.cpp"
      ; //@line 1554 "compiledict.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL12compile_rulePc($input) {
    var __stackBase__  = STACKTOP; STACKTOP += 244; _memset(__stackBase__, 0, 244);
    var __label__;
  
    var $retval;
    var $input_addr;
    var $ix;
    var $c;
    var $wc=__stackBase__;
    var $p;
    var $prule;
    var $len;
    var $len_name;
    var $start;
    var $state=__stackBase__+4;
    var $finish;
    var $pre_bracket;
    var $buf=__stackBase__+8;
    var $output=__stackBase__+88;
    var $bad_phoneme=__stackBase__+240;
    $input_addr=$input;
    HEAP32[(($state)>>2)]=2; //@line 1161 "compiledict.cpp"
    $finish=0; //@line 1162 "compiledict.cpp"
    $pre_bracket=0; //@line 1163 "compiledict.cpp"
    var $arrayidx=(($buf)&4294967295); //@line 1168 "compiledict.cpp"
    HEAP8[($arrayidx)]=0; //@line 1168 "compiledict.cpp"
    HEAP8[(((__ZL9rule_cond)&4294967295))]=0; //@line 1169 "compiledict.cpp"
    HEAP8[(((__ZL8rule_pre)&4294967295))]=0; //@line 1170 "compiledict.cpp"
    HEAP8[(((__ZL9rule_post)&4294967295))]=0; //@line 1171 "compiledict.cpp"
    HEAP8[(((__ZL10rule_match)&4294967295))]=0; //@line 1172 "compiledict.cpp"
    HEAP8[(((__ZL13rule_phonemes)&4294967295))]=0; //@line 1173 "compiledict.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 1175 "compiledict.cpp"
    $p=$arraydecay; //@line 1175 "compiledict.cpp"
    $ix=0; //@line 1177 "compiledict.cpp"
    var $0=$finish; //@line 1177 "compiledict.cpp"
    var $cmp2=((($0))|0)==0; //@line 1177 "compiledict.cpp"
    if ($cmp2) { __label__ = 1;; } else { __label__ = 13;; } //@line 1177 "compiledict.cpp"
    $for_body_lr_ph$$for_end$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay3=(($buf)&4294967295); //@line 1187 "compiledict.cpp"
        var $arraydecay4=(($buf)&4294967295); //@line 1188 "compiledict.cpp"
        var $arraydecay6=(($buf)&4294967295); //@line 1194 "compiledict.cpp"
        var $arraydecay7=(($buf)&4294967295); //@line 1196 "compiledict.cpp"
        var $arraydecay12=(($buf)&4294967295); //@line 1208 "compiledict.cpp"
        var $arraydecay14=(($buf)&4294967295); //@line 1215 "compiledict.cpp"
        var $arraydecay15=(($buf)&4294967295); //@line 1216 "compiledict.cpp"
        ; //@line 1177 "compiledict.cpp"
        $for_body$4: while(1) { 
  
          var $1=$ix; //@line 1179 "compiledict.cpp"
          var $2=$input_addr; //@line 1179 "compiledict.cpp"
          var $arrayidx1=(($2+$1)&4294967295); //@line 1179 "compiledict.cpp"
          var $3=HEAP8[($arrayidx1)]; //@line 1179 "compiledict.cpp"
          $c=$3; //@line 1179 "compiledict.cpp"
          var $4=$ix; //@line 1181 "compiledict.cpp"
          var $5=$input_addr; //@line 1181 "compiledict.cpp"
          var $arrayidx2=(($5+$4)&4294967295); //@line 1181 "compiledict.cpp"
          var $6=HEAPU8[($arrayidx2)]; //@line 1181 "compiledict.cpp"
          $c=$6; //@line 1181 "compiledict.cpp"
          var $conv=((($6))&255); //@line 1181 "compiledict.cpp"
          if ($conv == 41) {
            __label__ = 3;;
          }
          else if ($conv == 40) {
            __label__ = 4;;
          }
          else if ($conv == 10) {
            __label__ = 6;break $for_body$4;
          }
          else if ($conv == 13) {
            __label__ = 6;break $for_body$4;
          }
          else if ($conv == 0) {
            __label__ = 6;break $for_body$4;
          }
          else if ($conv == 9) {
            __label__ = 7;;
          }
          else if ($conv == 32) {
            __label__ = 7;;
          }
          else if ($conv == 63) {
            __label__ = 8;;
          }
          else {
          __label__ = 11;;
          }
          
          $sw_default$$sw_bb$$sw_bb5$$sw_bb13$$sw_bb16$6: do { 
            if (__label__ == 11) {
  
              var $21=$c; //@line 1227 "compiledict.cpp"
              var $22=$p; //@line 1227 "compiledict.cpp"
              var $incdec_ptr20=(($22+1)&4294967295); //@line 1227 "compiledict.cpp"
              $p=$incdec_ptr20; //@line 1227 "compiledict.cpp"
              HEAP8[($22)]=$21; //@line 1227 "compiledict.cpp"
              ; //@line 1228 "compiledict.cpp"
            }
            else if (__label__ == 3) {
  
              var $7=$p; //@line 1184 "compiledict.cpp"
              HEAP8[($7)]=0; //@line 1184 "compiledict.cpp"
              HEAP32[(($state)>>2)]=1; //@line 1185 "compiledict.cpp"
              $pre_bracket=1; //@line 1186 "compiledict.cpp"
              __ZL16copy_rule_stringPcRi($arraydecay3, $state); //@line 1187 "compiledict.cpp"
              $p=$arraydecay4; //@line 1188 "compiledict.cpp"
              ; //@line 1189 "compiledict.cpp"
            }
            else if (__label__ == 4) {
  
              var $8=$p; //@line 1192 "compiledict.cpp"
              HEAP8[($8)]=0; //@line 1192 "compiledict.cpp"
              HEAP32[(($state)>>2)]=2; //@line 1193 "compiledict.cpp"
              __ZL16copy_rule_stringPcRi($arraydecay6, $state); //@line 1194 "compiledict.cpp"
              HEAP32[(($state)>>2)]=3; //@line 1195 "compiledict.cpp"
              $p=$arraydecay7; //@line 1196 "compiledict.cpp"
              var $9=$ix; //@line 1197 "compiledict.cpp"
              var $add=((($9)+1)&4294967295); //@line 1197 "compiledict.cpp"
              var $10=$input_addr; //@line 1197 "compiledict.cpp"
              var $arrayidx8=(($10+$add)&4294967295); //@line 1197 "compiledict.cpp"
              var $11=HEAP8[($arrayidx8)]; //@line 1197 "compiledict.cpp"
              var $conv9=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1197 "compiledict.cpp"
              var $cmp10=((($conv9))|0)==32; //@line 1197 "compiledict.cpp"
              if (!($cmp10)) { __label__ = 12;break $sw_default$$sw_bb$$sw_bb5$$sw_bb13$$sw_bb16$6; } //@line 1197 "compiledict.cpp"
  
              var $12=HEAP32[((__ZL5f_log)>>2)]; //@line 1199 "compiledict.cpp"
              var $13=HEAP32[((__ZL7linenum)>>2)]; //@line 1199 "compiledict.cpp"
              var $call=_fprintf($12, ((__str90)&4294967295), allocate([$13,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1199 "compiledict.cpp"
              var $14=HEAP32[((__ZL11error_count)>>2)]; //@line 1200 "compiledict.cpp"
              var $inc=((($14)+1)&4294967295); //@line 1200 "compiledict.cpp"
              HEAP32[((__ZL11error_count)>>2)]=$inc; //@line 1200 "compiledict.cpp"
              ; //@line 1201 "compiledict.cpp"
            }
            else if (__label__ == 7) {
  
              var $17=$p; //@line 1214 "compiledict.cpp"
              HEAP8[($17)]=0; //@line 1214 "compiledict.cpp"
              __ZL16copy_rule_stringPcRi($arraydecay14, $state); //@line 1215 "compiledict.cpp"
              $p=$arraydecay15; //@line 1216 "compiledict.cpp"
              ; //@line 1217 "compiledict.cpp"
            }
            else if (__label__ == 8) {
  
              var $18=HEAP32[(($state)>>2)]; //@line 1220 "compiledict.cpp"
              var $cmp17=((($18))|0)==2; //@line 1220 "compiledict.cpp"
              if ($cmp17) { __label__ = 9;; } else { __label__ = 10;; } //@line 1220 "compiledict.cpp"
              if (__label__ == 9) {
  
                HEAP32[(($state)>>2)]=0; //@line 1221 "compiledict.cpp"
                ; //@line 1221 "compiledict.cpp"
              }
              else if (__label__ == 10) {
  
                var $19=$c; //@line 1223 "compiledict.cpp"
                var $20=$p; //@line 1223 "compiledict.cpp"
                var $incdec_ptr=(($20+1)&4294967295); //@line 1223 "compiledict.cpp"
                $p=$incdec_ptr; //@line 1223 "compiledict.cpp"
                HEAP8[($20)]=$19; //@line 1223 "compiledict.cpp"
                ;
              }
            }
          } while(0);
  
          var $_pr=$finish; //@line 1177 "compiledict.cpp"
          var $23=$ix; //@line 1177 "compiledict.cpp"
          var $inc21=((($23)+1)&4294967295); //@line 1177 "compiledict.cpp"
          $ix=$inc21; //@line 1177 "compiledict.cpp"
          var $cmp=((($_pr))|0)==0; //@line 1177 "compiledict.cpp"
          if ($cmp) { __label__ = 2;continue $for_body$4; } else { __label__ = 13;break $for_body_lr_ph$$for_end$2; } //@line 1177 "compiledict.cpp"
        }
  
        var $15=$p; //@line 1207 "compiledict.cpp"
        HEAP8[($15)]=0; //@line 1207 "compiledict.cpp"
        __ZL16copy_rule_stringPcRi($arraydecay12, $state); //@line 1208 "compiledict.cpp"
        $finish=1; //@line 1209 "compiledict.cpp"
        var $16=$ix; //@line 1177 "compiledict.cpp"
        var $inc213=((($16)+1)&4294967295); //@line 1177 "compiledict.cpp"
        $ix=$inc213; //@line 1177 "compiledict.cpp"
        ; //@line 1177 "compiledict.cpp"
      }
    } while(0);
  
    var $call22=_strcmp(((__ZL10rule_match)&4294967295), ((__str91)&4294967295)); //@line 1232 "compiledict.cpp"
    var $cmp23=((($call22))|0)==0; //@line 1232 "compiledict.cpp"
    if ($cmp23) { __label__ = 14;; } else { __label__ = 15;; } //@line 1232 "compiledict.cpp"
    if (__label__ == 14) {
  
      var $call25=_strcpy(((__ZL10rule_match)&4294967295), ((__ZL10group_name)&4294967295)); //@line 1233 "compiledict.cpp"
      ; //@line 1233 "compiledict.cpp"
    }
  
    var $24=HEAP8[(((__ZL10rule_match)&4294967295))]; //@line 1235 "compiledict.cpp"
    var $conv27=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 1235 "compiledict.cpp"
    var $cmp28=((($conv27))|0)==0; //@line 1235 "compiledict.cpp"
    if ($cmp28) { __label__ = 16;; } else { __label__ = 19;; } //@line 1235 "compiledict.cpp"
    if (__label__ == 16) {
  
      var $25=HEAP8[(((__ZL9rule_post)&4294967295))]; //@line 1237 "compiledict.cpp"
      var $conv30=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 1237 "compiledict.cpp"
      var $cmp31=((($conv30))|0)!=0; //@line 1237 "compiledict.cpp"
      if ($cmp31) { __label__ = 17;; } else { __label__ = 18;; } //@line 1237 "compiledict.cpp"
      if (__label__ == 17) {
  
        var $26=HEAP32[((__ZL5f_log)>>2)]; //@line 1239 "compiledict.cpp"
        var $27=HEAP32[((__ZL7linenum)>>2)]; //@line 1239 "compiledict.cpp"
        var $call33=_fprintf($26, ((__str92)&4294967295), allocate([$27,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1239 "compiledict.cpp"
        var $28=HEAP32[((__ZL11error_count)>>2)]; //@line 1240 "compiledict.cpp"
        var $inc34=((($28)+1)&4294967295); //@line 1240 "compiledict.cpp"
        HEAP32[((__ZL11error_count)>>2)]=$inc34; //@line 1240 "compiledict.cpp"
        ; //@line 1241 "compiledict.cpp"
      }
  
      $retval=0; //@line 1242 "compiledict.cpp"
      ; //@line 1242 "compiledict.cpp"
    }
    else if (__label__ == 19) {
  
      var $arraydecay37=(($buf)&4294967295); //@line 1245 "compiledict.cpp"
      var $arraydecay38=(($bad_phoneme)&4294967295); //@line 1245 "compiledict.cpp"
      var $call39=__Z14EncodePhonemesPcS_Ph(((__ZL13rule_phonemes)&4294967295), $arraydecay37, $arraydecay38); //@line 1245 "compiledict.cpp"
      var $arrayidx40=(($bad_phoneme)&4294967295); //@line 1246 "compiledict.cpp"
      var $29=HEAPU8[($arrayidx40)]; //@line 1246 "compiledict.cpp"
      var $conv41=((($29))&255); //@line 1246 "compiledict.cpp"
      var $cmp42=((($conv41))|0)!=0; //@line 1246 "compiledict.cpp"
      if ($cmp42) { __label__ = 20;; } else { __label__ = 21;; } //@line 1246 "compiledict.cpp"
      if (__label__ == 20) {
  
        var $30=HEAP32[((__ZL5f_log)>>2)]; //@line 1248 "compiledict.cpp"
        var $31=HEAP32[((__ZL7linenum)>>2)]; //@line 1248 "compiledict.cpp"
        var $arrayidx44=(($bad_phoneme)&4294967295); //@line 1248 "compiledict.cpp"
        var $32=HEAPU8[($arrayidx44)]; //@line 1248 "compiledict.cpp"
        var $conv45=((($32))&255); //@line 1248 "compiledict.cpp"
        var $33=$input_addr; //@line 1248 "compiledict.cpp"
        var $call46=_fprintf($30, ((__str93)&4294967295), allocate([$31,0,0,0,$conv45,0,0,0,$33,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1248 "compiledict.cpp"
        var $34=HEAP32[((__ZL11error_count)>>2)]; //@line 1249 "compiledict.cpp"
        var $inc47=((($34)+1)&4294967295); //@line 1249 "compiledict.cpp"
        HEAP32[((__ZL11error_count)>>2)]=$inc47; //@line 1249 "compiledict.cpp"
        ; //@line 1250 "compiledict.cpp"
      }
  
      var $arraydecay49=(($output)&4294967295); //@line 1251 "compiledict.cpp"
      var $arraydecay50=(($buf)&4294967295); //@line 1251 "compiledict.cpp"
      var $call51=_strcpy($arraydecay49, $arraydecay50); //@line 1251 "compiledict.cpp"
      var $arraydecay52=(($buf)&4294967295); //@line 1252 "compiledict.cpp"
      var $call53=_strlen($arraydecay52); //@line 1252 "compiledict.cpp"
      var $add54=((($call53)+1)&4294967295); //@line 1252 "compiledict.cpp"
      $len=$add54; //@line 1252 "compiledict.cpp"
      var $call55=_strlen(((__ZL10group_name)&4294967295)); //@line 1254 "compiledict.cpp"
      $len_name=$call55; //@line 1254 "compiledict.cpp"
      var $cmp56=((($call55))|0) > 0; //@line 1255 "compiledict.cpp"
      if ($cmp56) { __label__ = 22;; } else { __label__ = 26;; } //@line 1255 "compiledict.cpp"
      $land_lhs_true$$if_end70$31: do { 
        if (__label__ == 22) {
  
          var $35=$len_name; //@line 1255 "compiledict.cpp"
          var $call57=_memcmp(((__ZL10rule_match)&4294967295), ((__ZL10group_name)&4294967295), $35); //@line 1255 "compiledict.cpp"
          var $cmp58=((($call57))|0)!=0; //@line 1255 "compiledict.cpp"
          if (!($cmp58)) { __label__ = 26;break $land_lhs_true$$if_end70$31; } //@line 1255 "compiledict.cpp"
  
          var $call60=__Z7utf8_inPiPKc($wc, ((__ZL10rule_match)&4294967295)); //@line 1257 "compiledict.cpp"
          var $36=HEAP8[(((__ZL10group_name)&4294967295))]; //@line 1258 "compiledict.cpp"
          var $conv61=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 1258 "compiledict.cpp"
          var $cmp62=((($conv61))|0)==57; //@line 1258 "compiledict.cpp"
          if ($cmp62) { __label__ = 24;; } else { __label__ = 25;; } //@line 1258 "compiledict.cpp"
          if (__label__ == 24) {
  
            var $37=HEAP32[(($wc)>>2)]; //@line 1258 "compiledict.cpp"
            var $call64=__Z7IsDigitj($37); //@line 1258 "compiledict.cpp"
            var $tobool=((($call64))|0)!=0; //@line 1258 "compiledict.cpp"
            if ($tobool) { __label__ = 26;break $land_lhs_true$$if_end70$31; } //@line 1258 "compiledict.cpp"
          }
  
          var $38=HEAP32[((__ZL5f_log)>>2)]; //@line 1264 "compiledict.cpp"
          var $39=HEAP32[((__ZL7linenum)>>2)]; //@line 1264 "compiledict.cpp"
          var $call67=_fprintf($38, ((__str94)&4294967295), allocate([$39,0,0,0,((__ZL10rule_match)&4294967295),0,0,0,((__ZL10group_name)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1264 "compiledict.cpp"
          var $40=HEAP32[((__ZL11error_count)>>2)]; //@line 1265 "compiledict.cpp"
          var $inc68=((($40)+1)&4294967295); //@line 1265 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc68; //@line 1265 "compiledict.cpp"
          ;
        }
      } while(0);
  
      var $41=$len; //@line 1268 "compiledict.cpp"
      var $arrayidx71=(($output+$41)&4294967295); //@line 1268 "compiledict.cpp"
      var $call72=_strcpy($arrayidx71, ((__ZL10rule_match)&4294967295)); //@line 1268 "compiledict.cpp"
      var $call73=_strlen(((__ZL10rule_match)&4294967295)); //@line 1269 "compiledict.cpp"
      var $42=$len; //@line 1269 "compiledict.cpp"
      var $add74=((($42)+($call73))&4294967295); //@line 1269 "compiledict.cpp"
      $len=$add74; //@line 1269 "compiledict.cpp"
      var $43=HEAP32[((__ZL10debug_flag)>>2)]; //@line 1271 "compiledict.cpp"
      var $tobool75=((($43))|0)!=0; //@line 1271 "compiledict.cpp"
      if ($tobool75) { __label__ = 27;; } else { __label__ = 28;; } //@line 1271 "compiledict.cpp"
      if (__label__ == 27) {
  
        var $44=$len; //@line 1273 "compiledict.cpp"
        var $arrayidx77=(($output+$44)&4294967295); //@line 1273 "compiledict.cpp"
        HEAP8[($arrayidx77)]=9; //@line 1273 "compiledict.cpp"
        var $45=HEAP32[((__ZL7linenum)>>2)]; //@line 1274 "compiledict.cpp"
        var $rem=((($45))|0)%255; //@line 1274 "compiledict.cpp"
        var $add78=((($rem)+1)&4294967295); //@line 1274 "compiledict.cpp"
        var $conv79=((($add78)) & 255); //@line 1274 "compiledict.cpp"
        var $46=$len; //@line 1274 "compiledict.cpp"
        var $add80=((($46)+1)&4294967295); //@line 1274 "compiledict.cpp"
        var $arrayidx81=(($output+$add80)&4294967295); //@line 1274 "compiledict.cpp"
        HEAP8[($arrayidx81)]=$conv79; //@line 1274 "compiledict.cpp"
        var $47=HEAP32[((__ZL7linenum)>>2)]; //@line 1275 "compiledict.cpp"
        var $div=((((($47))|0)/255)|0); //@line 1275 "compiledict.cpp"
        var $add82=((($div)+1)&4294967295); //@line 1275 "compiledict.cpp"
        var $conv83=((($add82)) & 255); //@line 1275 "compiledict.cpp"
        var $48=$len; //@line 1275 "compiledict.cpp"
        var $add84=((($48)+2)&4294967295); //@line 1275 "compiledict.cpp"
        var $arrayidx85=(($output+$add84)&4294967295); //@line 1275 "compiledict.cpp"
        HEAP8[($arrayidx85)]=$conv83; //@line 1275 "compiledict.cpp"
        var $49=$len; //@line 1276 "compiledict.cpp"
        var $add86=((($49)+3)&4294967295); //@line 1276 "compiledict.cpp"
        $len=$add86; //@line 1276 "compiledict.cpp"
        ; //@line 1277 "compiledict.cpp"
      }
  
      var $50=HEAP8[(((__ZL9rule_cond)&4294967295))]; //@line 1279 "compiledict.cpp"
      var $conv88=(tempInt=(($50)),(tempInt>=128?tempInt-256:tempInt)); //@line 1279 "compiledict.cpp"
      var $cmp89=((($conv88))|0)!=0; //@line 1279 "compiledict.cpp"
      if ($cmp89) { __label__ = 29;; } else { __label__ = 35;; } //@line 1279 "compiledict.cpp"
      if (__label__ == 29) {
  
        $ix=-1; //@line 1281 "compiledict.cpp"
        var $51=HEAP8[(((__ZL9rule_cond)&4294967295))]; //@line 1282 "compiledict.cpp"
        var $conv91=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 1282 "compiledict.cpp"
        var $cmp92=((($conv91))|0)==33; //@line 1282 "compiledict.cpp"
        if ($cmp92) { __label__ = 30;; } else { __label__ = 31;; } //@line 1282 "compiledict.cpp"
        if (__label__ == 30) {
  
          var $call94=_atoi(((__ZL9rule_cond+1)&4294967295)); //@line 1285 "compiledict.cpp"
          var $add95=((($call94)+32)&4294967295); //@line 1285 "compiledict.cpp"
          $ix=$add95; //@line 1285 "compiledict.cpp"
          ; //@line 1286 "compiledict.cpp"
        }
        else if (__label__ == 31) {
  
          var $call97=_atoi(((__ZL9rule_cond)&4294967295)); //@line 1290 "compiledict.cpp"
          $ix=$call97; //@line 1290 "compiledict.cpp"
          ;
        }
  
        var $52=$ix; //@line 1293 "compiledict.cpp"
        var $cmp99=((($52))|0) > 0; //@line 1293 "compiledict.cpp"
        var $53=$ix; //@line 1293 "compiledict.cpp"
        var $cmp101=((($53))|0) < 255; //@line 1293 "compiledict.cpp"
        var $or_cond=($cmp99) & ($cmp101); //@line 1293 "compiledict.cpp"
        if ($or_cond) { __label__ = 33;; } else { __label__ = 34;; } //@line 1293 "compiledict.cpp"
        if (__label__ == 33) {
  
          var $54=$len; //@line 1295 "compiledict.cpp"
          var $inc103=((($54)+1)&4294967295); //@line 1295 "compiledict.cpp"
          $len=$inc103; //@line 1295 "compiledict.cpp"
          var $arrayidx104=(($output+$54)&4294967295); //@line 1295 "compiledict.cpp"
          HEAP8[($arrayidx104)]=5; //@line 1295 "compiledict.cpp"
          var $55=$ix; //@line 1296 "compiledict.cpp"
          var $conv105=((($55)) & 255); //@line 1296 "compiledict.cpp"
          var $56=$len; //@line 1296 "compiledict.cpp"
          var $inc106=((($56)+1)&4294967295); //@line 1296 "compiledict.cpp"
          $len=$inc106; //@line 1296 "compiledict.cpp"
          var $arrayidx107=(($output+$56)&4294967295); //@line 1296 "compiledict.cpp"
          HEAP8[($arrayidx107)]=$conv105; //@line 1296 "compiledict.cpp"
          ; //@line 1297 "compiledict.cpp"
        }
        else if (__label__ == 34) {
  
          var $57=HEAP32[((__ZL5f_log)>>2)]; //@line 1300 "compiledict.cpp"
          var $58=HEAP32[((__ZL7linenum)>>2)]; //@line 1300 "compiledict.cpp"
          var $59=$ix; //@line 1300 "compiledict.cpp"
          var $call109=_fprintf($57, ((__str95)&4294967295), allocate([$58,0,0,0,$59,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1300 "compiledict.cpp"
          var $60=HEAP32[((__ZL11error_count)>>2)]; //@line 1301 "compiledict.cpp"
          var $inc110=((($60)+1)&4294967295); //@line 1301 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc110; //@line 1301 "compiledict.cpp"
          ;
        }
      }
  
      var $61=HEAP8[(((__ZL8rule_pre)&4294967295))]; //@line 1304 "compiledict.cpp"
      var $conv113=(tempInt=(($61)),(tempInt>=128?tempInt-256:tempInt)); //@line 1304 "compiledict.cpp"
      var $cmp114=((($conv113))|0)!=0; //@line 1304 "compiledict.cpp"
      if ($cmp114) { __label__ = 36;; } else { __label__ = 41;; } //@line 1304 "compiledict.cpp"
      $if_then115$$if_end132$51: do { 
        if (__label__ == 36) {
  
          $start=0; //@line 1306 "compiledict.cpp"
          var $62=HEAP8[(((__ZL8rule_pre)&4294967295))]; //@line 1307 "compiledict.cpp"
          var $conv116=(tempInt=(($62)),(tempInt>=128?tempInt-256:tempInt)); //@line 1307 "compiledict.cpp"
          var $cmp117=((($conv116))|0)==32; //@line 1307 "compiledict.cpp"
          if ($cmp117) { __label__ = 37;; } else { __label__ = 38;; } //@line 1307 "compiledict.cpp"
          if (__label__ == 37) {
  
            $c=8; //@line 1310 "compiledict.cpp"
            $start=1; //@line 1311 "compiledict.cpp"
            ; //@line 1312 "compiledict.cpp"
          }
          else if (__label__ == 38) {
  
            $c=1; //@line 1315 "compiledict.cpp"
            ;
          }
  
          var $63=$c; //@line 1317 "compiledict.cpp"
          var $64=$len; //@line 1317 "compiledict.cpp"
          var $inc121=((($64)+1)&4294967295); //@line 1317 "compiledict.cpp"
          $len=$inc121; //@line 1317 "compiledict.cpp"
          var $arrayidx122=(($output+$64)&4294967295); //@line 1317 "compiledict.cpp"
          HEAP8[($arrayidx122)]=$63; //@line 1317 "compiledict.cpp"
          var $call123=_strlen(((__ZL8rule_pre)&4294967295)); //@line 1320 "compiledict.cpp"
          var $sub=((($call123)-1)&4294967295); //@line 1320 "compiledict.cpp"
          $ix=$sub; //@line 1320 "compiledict.cpp"
          var $65=$ix; //@line 1320 "compiledict.cpp"
          var $66=$start; //@line 1320 "compiledict.cpp"
          var $cmp1251=((($65))|0) >= ((($66))|0); //@line 1320 "compiledict.cpp"
          if (!($cmp1251)) { __label__ = 41;break $if_then115$$if_end132$51; } //@line 1320 "compiledict.cpp"
          while(1) { 
  
            var $67=$ix; //@line 1321 "compiledict.cpp"
            var $arrayidx127=((__ZL8rule_pre+$67)&4294967295); //@line 1321 "compiledict.cpp"
            var $68=HEAP8[($arrayidx127)]; //@line 1321 "compiledict.cpp"
            var $69=$len; //@line 1321 "compiledict.cpp"
            var $inc128=((($69)+1)&4294967295); //@line 1321 "compiledict.cpp"
            $len=$inc128; //@line 1321 "compiledict.cpp"
            var $arrayidx129=(($output+$69)&4294967295); //@line 1321 "compiledict.cpp"
            HEAP8[($arrayidx129)]=$68; //@line 1321 "compiledict.cpp"
            var $70=$ix; //@line 1320 "compiledict.cpp"
            var $dec=((($70)-1)&4294967295); //@line 1320 "compiledict.cpp"
            $ix=$dec; //@line 1320 "compiledict.cpp"
            var $71=$ix; //@line 1320 "compiledict.cpp"
            var $72=$start; //@line 1320 "compiledict.cpp"
            var $cmp125=((($71))|0) >= ((($72))|0); //@line 1320 "compiledict.cpp"
            if ($cmp125) { __label__ = 40;continue ; } else { __label__ = 41;break $if_then115$$if_end132$51; } //@line 1320 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $73=HEAP8[(((__ZL9rule_post)&4294967295))]; //@line 1324 "compiledict.cpp"
      var $conv133=(tempInt=(($73)),(tempInt>=128?tempInt-256:tempInt)); //@line 1324 "compiledict.cpp"
      var $cmp134=((($conv133))|0)!=0; //@line 1324 "compiledict.cpp"
      if ($cmp134) { __label__ = 42;; } else { __label__ = 43;; } //@line 1324 "compiledict.cpp"
      if (__label__ == 42) {
  
        var $74=$len; //@line 1326 "compiledict.cpp"
        var $arrayidx136=(($output+$74)&4294967295); //@line 1326 "compiledict.cpp"
        var $call137=_sprintf($arrayidx136, ((__str70722)&4294967295), allocate([2,0,0,0,((__ZL9rule_post)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1326 "compiledict.cpp"
        var $call138=_strlen(((__ZL9rule_post)&4294967295)); //@line 1327 "compiledict.cpp"
        var $75=$len; //@line 1327 "compiledict.cpp"
        var $add139=((($call138)+1)&4294967295); //@line 1327 "compiledict.cpp"
        var $add140=((($add139)+($75))&4294967295); //@line 1327 "compiledict.cpp"
        $len=$add140; //@line 1327 "compiledict.cpp"
        ; //@line 1328 "compiledict.cpp"
      }
  
      var $76=$len; //@line 1329 "compiledict.cpp"
      var $inc142=((($76)+1)&4294967295); //@line 1329 "compiledict.cpp"
      $len=$inc142; //@line 1329 "compiledict.cpp"
      var $arrayidx143=(($output+$76)&4294967295); //@line 1329 "compiledict.cpp"
      HEAP8[($arrayidx143)]=0; //@line 1329 "compiledict.cpp"
      var $77=$len; //@line 1330 "compiledict.cpp"
      var $call144=_malloc($77); //@line 1330 "compiledict.cpp"
      $prule=$call144; //@line 1330 "compiledict.cpp"
      var $78=$prule; //@line 1331 "compiledict.cpp"
      var $arraydecay145=(($output)&4294967295); //@line 1331 "compiledict.cpp"
      var $79=$len; //@line 1331 "compiledict.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $arraydecay145;
      $dest$ = $78;
      $stop$ = $src$ + $79;
      if (($dest$%4) == ($src$%4) && $79 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 1331 "compiledict.cpp"
      var $80=$prule; //@line 1332 "compiledict.cpp"
      $retval=$80; //@line 1332 "compiledict.cpp"
      ; //@line 1332 "compiledict.cpp"
    }
  
    var $81=$retval; //@line 1333 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return $81; //@line 1333 "compiledict.cpp"
    return null;
  }
  

  function __ZL13rgroup_sorterP6RGROUPS0_($a, $b) {
    ;
    var __label__;
  
    var $retval;
    var $a_addr;
    var $b_addr;
    var $ix;
    $a_addr=$a;
    $b_addr=$b;
    var $0=$b_addr; //@line 1353 "compiledict.cpp"
    var $name=(($0)&4294967295); //@line 1353 "compiledict.cpp"
    var $arraydecay=(($name)&4294967295); //@line 1353 "compiledict.cpp"
    var $call=_strlen($arraydecay); //@line 1353 "compiledict.cpp"
    var $1=$a_addr; //@line 1353 "compiledict.cpp"
    var $name1=(($1)&4294967295); //@line 1353 "compiledict.cpp"
    var $arraydecay2=(($name1)&4294967295); //@line 1353 "compiledict.cpp"
    var $call3=_strlen($arraydecay2); //@line 1353 "compiledict.cpp"
    var $sub=((($call)-($call3))&4294967295); //@line 1353 "compiledict.cpp"
    $ix=$sub; //@line 1353 "compiledict.cpp"
    var $2=$ix; //@line 1354 "compiledict.cpp"
    var $cmp=((($2))|0)!=0; //@line 1354 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1354 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $3=$ix; //@line 1354 "compiledict.cpp"
      $retval=$3; //@line 1354 "compiledict.cpp"
      ; //@line 1354 "compiledict.cpp"
    }
    else if (__label__ == 2) {
  
      var $4=$a_addr; //@line 1355 "compiledict.cpp"
      var $name4=(($4)&4294967295); //@line 1355 "compiledict.cpp"
      var $arraydecay5=(($name4)&4294967295); //@line 1355 "compiledict.cpp"
      var $5=$b_addr; //@line 1355 "compiledict.cpp"
      var $name6=(($5)&4294967295); //@line 1355 "compiledict.cpp"
      var $arraydecay7=(($name6)&4294967295); //@line 1355 "compiledict.cpp"
      var $call8=_strcmp($arraydecay5, $arraydecay7); //@line 1355 "compiledict.cpp"
      $ix=$call8; //@line 1355 "compiledict.cpp"
      var $6=$ix; //@line 1356 "compiledict.cpp"
      var $cmp9=((($6))|0)!=0; //@line 1356 "compiledict.cpp"
      if ($cmp9) { __label__ = 3;; } else { __label__ = 4;; } //@line 1356 "compiledict.cpp"
      if (__label__ == 3) {
  
        var $7=$ix; //@line 1356 "compiledict.cpp"
        $retval=$7; //@line 1356 "compiledict.cpp"
        ; //@line 1356 "compiledict.cpp"
      }
      else if (__label__ == 4) {
  
        var $8=$a_addr; //@line 1357 "compiledict.cpp"
        var $start=(($8+16)&4294967295); //@line 1357 "compiledict.cpp"
        var $9=HEAP32[(($start)>>2)]; //@line 1357 "compiledict.cpp"
        var $10=$b_addr; //@line 1357 "compiledict.cpp"
        var $start12=(($10+16)&4294967295); //@line 1357 "compiledict.cpp"
        var $11=HEAP32[(($start12)>>2)]; //@line 1357 "compiledict.cpp"
        var $sub13=((($9)-($11))&4294967295); //@line 1357 "compiledict.cpp"
        $retval=$sub13; //@line 1357 "compiledict.cpp"
        ; //@line 1357 "compiledict.cpp"
      }
    }
  
    var $12=$retval; //@line 1358 "compiledict.cpp"
    ;
    return $12; //@line 1358 "compiledict.cpp"
    return null;
  }
  

  function __ZL16copy_rule_stringPcRi($string, $state) {
    ;
    var __label__;
  
    var $string_addr;
    var $state_addr;
    var $output;
    var $p;
    var $ix;
    var $len;
    var $c;
    var $sxflags;
    var $value;
    var $literal;
    var $mr;
    $string_addr=$string;
    $state_addr=$state;
    var $0=$string_addr; //@line 930 "compiledict.cpp"
    var $arrayidx=(($0)&4294967295); //@line 930 "compiledict.cpp"
    var $1=HEAP8[($arrayidx)]; //@line 930 "compiledict.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 930 "compiledict.cpp"
    var $cmp=((($conv))|0)==0; //@line 930 "compiledict.cpp"
    if ($cmp) { __label__ = 75;; } else { __label__ = 1;; } //@line 930 "compiledict.cpp"
    if (__label__ == 1) {
  
      var $2=$state_addr; //@line 932 "compiledict.cpp"
      var $3=HEAP32[(($2)>>2)]; //@line 932 "compiledict.cpp"
      var $arrayidx1=((__ZZL16copy_rule_stringPcRiE6outbuf+$3*4)&4294967295); //@line 932 "compiledict.cpp"
      var $4=HEAP32[(($arrayidx1)>>2)]; //@line 932 "compiledict.cpp"
      $output=$4; //@line 932 "compiledict.cpp"
      var $5=$state_addr; //@line 933 "compiledict.cpp"
      var $6=HEAP32[(($5)>>2)]; //@line 933 "compiledict.cpp"
      var $cmp2=((($6))|0)==4; //@line 933 "compiledict.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 5;; } //@line 933 "compiledict.cpp"
      if (__label__ == 2) {
  
        var $call=_strlen(((__ZL13rule_phonemes)&4294967295)); //@line 936 "compiledict.cpp"
        $len=$call; //@line 936 "compiledict.cpp"
        var $7=$len; //@line 937 "compiledict.cpp"
        var $cmp4=((($7))|0) > 0; //@line 937 "compiledict.cpp"
        if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 937 "compiledict.cpp"
        if (__label__ == 3) {
  
          var $8=$len; //@line 938 "compiledict.cpp"
          var $inc=((($8)+1)&4294967295); //@line 938 "compiledict.cpp"
          $len=$inc; //@line 938 "compiledict.cpp"
          var $arrayidx6=((__ZL13rule_phonemes+$8)&4294967295); //@line 938 "compiledict.cpp"
          HEAP8[($arrayidx6)]=32; //@line 938 "compiledict.cpp"
          ; //@line 938 "compiledict.cpp"
        }
  
        var $9=$len; //@line 939 "compiledict.cpp"
        var $arrayidx8=((__ZL13rule_phonemes+$9)&4294967295); //@line 939 "compiledict.cpp"
        $output=$arrayidx8; //@line 939 "compiledict.cpp"
        ; //@line 940 "compiledict.cpp"
      }
  
      $sxflags=8421376; //@line 941 "compiledict.cpp"
      var $10=$string_addr; //@line 943 "compiledict.cpp"
      $p=$10; //@line 943 "compiledict.cpp"
      $ix=0; //@line 943 "compiledict.cpp"
      ; //@line 943 "compiledict.cpp"
      $for_cond$10: while(1) { 
  
        $literal=0; //@line 945 "compiledict.cpp"
        var $11=$p; //@line 946 "compiledict.cpp"
        var $incdec_ptr=(($11+1)&4294967295); //@line 946 "compiledict.cpp"
        $p=$incdec_ptr; //@line 946 "compiledict.cpp"
        var $12=HEAP8[($11)]; //@line 946 "compiledict.cpp"
        $c=$12; //@line 946 "compiledict.cpp"
        var $13=$c; //@line 947 "compiledict.cpp"
        var $conv10=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 947 "compiledict.cpp"
        var $cmp11=((($conv10))|0)==92; //@line 947 "compiledict.cpp"
        if ($cmp11) { __label__ = 7;; } else { __label__ = 15;; } //@line 947 "compiledict.cpp"
        if (__label__ == 7) {
  
          var $14=$p; //@line 949 "compiledict.cpp"
          var $incdec_ptr13=(($14+1)&4294967295); //@line 949 "compiledict.cpp"
          $p=$incdec_ptr13; //@line 949 "compiledict.cpp"
          var $15=HEAP8[($14)]; //@line 949 "compiledict.cpp"
          $c=$15; //@line 949 "compiledict.cpp"
          var $16=$c; //@line 950 "compiledict.cpp"
          var $conv14=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
          var $cmp15=((($conv14))|0) >= 48; //@line 950 "compiledict.cpp"
          if ($cmp15) { __label__ = 8;; } else { __label__ = 14;; } //@line 950 "compiledict.cpp"
          $land_lhs_true$$if_end45$14: do { 
            if (__label__ == 8) {
  
              var $17=$c; //@line 950 "compiledict.cpp"
              var $conv16=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp17=((($conv16))|0) <= 51; //@line 950 "compiledict.cpp"
              if (!($cmp17)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $18=$p; //@line 950 "compiledict.cpp"
              var $arrayidx19=(($18)&4294967295); //@line 950 "compiledict.cpp"
              var $19=HEAP8[($arrayidx19)]; //@line 950 "compiledict.cpp"
              var $conv20=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp21=((($conv20))|0) >= 48; //@line 950 "compiledict.cpp"
              if (!($cmp21)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $20=$p; //@line 950 "compiledict.cpp"
              var $arrayidx23=(($20)&4294967295); //@line 950 "compiledict.cpp"
              var $21=HEAP8[($arrayidx23)]; //@line 950 "compiledict.cpp"
              var $conv24=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp25=((($conv24))|0) <= 55; //@line 950 "compiledict.cpp"
              if (!($cmp25)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $22=$p; //@line 950 "compiledict.cpp"
              var $arrayidx27=(($22+1)&4294967295); //@line 950 "compiledict.cpp"
              var $23=HEAP8[($arrayidx27)]; //@line 950 "compiledict.cpp"
              var $conv28=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp29=((($conv28))|0) >= 48; //@line 950 "compiledict.cpp"
              if (!($cmp29)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $24=$p; //@line 950 "compiledict.cpp"
              var $arrayidx31=(($24+1)&4294967295); //@line 950 "compiledict.cpp"
              var $25=HEAP8[($arrayidx31)]; //@line 950 "compiledict.cpp"
              var $conv32=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 950 "compiledict.cpp"
              var $cmp33=((($conv32))|0) <= 55; //@line 950 "compiledict.cpp"
              if (!($cmp33)) { __label__ = 14;break $land_lhs_true$$if_end45$14; } //@line 950 "compiledict.cpp"
  
              var $26=$c; //@line 953 "compiledict.cpp"
              var $conv35=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 953 "compiledict.cpp"
              var $sub=((($conv35)-48)&4294967295); //@line 953 "compiledict.cpp"
              var $mul=((($sub)*64)&4294967295); //@line 953 "compiledict.cpp"
              var $27=$p; //@line 953 "compiledict.cpp"
              var $arrayidx36=(($27)&4294967295); //@line 953 "compiledict.cpp"
              var $28=HEAP8[($arrayidx36)]; //@line 953 "compiledict.cpp"
              var $conv37=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 953 "compiledict.cpp"
              var $sub38=((($conv37)-48)&4294967295); //@line 953 "compiledict.cpp"
              var $mul39=((($sub38)*8)&4294967295); //@line 953 "compiledict.cpp"
              var $29=$p; //@line 953 "compiledict.cpp"
              var $arrayidx40=(($29+1)&4294967295); //@line 953 "compiledict.cpp"
              var $30=HEAP8[($arrayidx40)]; //@line 953 "compiledict.cpp"
              var $conv41=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 953 "compiledict.cpp"
              var $add=((($mul)-48)&4294967295); //@line 953 "compiledict.cpp"
              var $sub42=((($add)+($conv41))&4294967295); //@line 953 "compiledict.cpp"
              var $add43=((($sub42)+($mul39))&4294967295); //@line 953 "compiledict.cpp"
              var $conv44=((($add43)) & 255); //@line 953 "compiledict.cpp"
              $c=$conv44; //@line 953 "compiledict.cpp"
              var $31=$p; //@line 954 "compiledict.cpp"
              var $add_ptr=(($31+2)&4294967295); //@line 954 "compiledict.cpp"
              $p=$add_ptr; //@line 954 "compiledict.cpp"
              ; //@line 955 "compiledict.cpp"
            }
          } while(0);
  
          $literal=1; //@line 956 "compiledict.cpp"
          ; //@line 957 "compiledict.cpp"
        }
  
        var $32=$state_addr; //@line 959 "compiledict.cpp"
        var $33=HEAP32[(($32)>>2)]; //@line 959 "compiledict.cpp"
        var $cmp47=((($33))|0)==1; //@line 959 "compiledict.cpp"
        if ($cmp47) { __label__ = 17;; } else { __label__ = 16;; } //@line 959 "compiledict.cpp"
        $if_then49$$lor_lhs_false$23: do { 
          if (__label__ == 16) {
  
            var $34=$state_addr; //@line 959 "compiledict.cpp"
            var $35=HEAP32[(($34)>>2)]; //@line 959 "compiledict.cpp"
            var $cmp48=((($35))|0)==3; //@line 959 "compiledict.cpp"
            if ($cmp48) { __label__ = 17;break $if_then49$$lor_lhs_false$23; } else { __label__ = 73;break $if_then49$$lor_lhs_false$23; } //@line 959 "compiledict.cpp"
          }
        } while(0);
        $if_then49$$if_end212$25: do { 
          if (__label__ == 17) {
  
            var $36=$literal; //@line 962 "compiledict.cpp"
            var $cmp50=((($36))|0)==0; //@line 962 "compiledict.cpp"
            if (!($cmp50)) { __label__ = 73;break $if_then49$$if_end212$25; } //@line 962 "compiledict.cpp"
  
            var $37=$c; //@line 965 "compiledict.cpp"
            var $conv52=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 965 "compiledict.cpp"
            if ($conv52 == 95) {
              __label__ = 19;;
            }
            else if ($conv52 == 89) {
              __label__ = 20;;
            }
            else if ($conv52 == 65) {
              __label__ = 21;;
            }
            else if ($conv52 == 66) {
              __label__ = 21;;
            }
            else if ($conv52 == 67) {
              __label__ = 21;;
            }
            else if ($conv52 == 72) {
              __label__ = 21;;
            }
            else if ($conv52 == 70) {
              __label__ = 21;;
            }
            else if ($conv52 == 71) {
              __label__ = 21;;
            }
            else if ($conv52 == 68) {
              __label__ = 24;;
            }
            else if ($conv52 == 75) {
              __label__ = 25;;
            }
            else if ($conv52 == 78) {
              __label__ = 26;;
            }
            else if ($conv52 == 86) {
              __label__ = 27;;
            }
            else if ($conv52 == 90) {
              __label__ = 28;;
            }
            else if ($conv52 == 43) {
              __label__ = 29;;
            }
            else if ($conv52 == 64) {
              __label__ = 30;;
            }
            else if ($conv52 == 38) {
              __label__ = 31;;
            }
            else if ($conv52 == 37) {
              __label__ = 32;;
            }
            else if ($conv52 == 35) {
              __label__ = 33;;
            }
            else if ($conv52 == 33) {
              __label__ = 34;;
            }
            else if ($conv52 == 84) {
              __label__ = 35;;
            }
            else if ($conv52 == 87) {
              __label__ = 36;;
            }
            else if ($conv52 == 88) {
              __label__ = 37;;
            }
            else if ($conv52 == 74) {
              __label__ = 38;;
            }
            else if ($conv52 == 76) {
              __label__ = 39;;
            }
            else if ($conv52 == 36) {
              __label__ = 48;;
            }
            else if ($conv52 == 80) {
              __label__ = 55;;
            }
            else if ($conv52 == 83) {
              __label__ = 56;;
            }
            else {
            __label__ = 73;break $if_then49$$if_end212$25;
            }
            
            $sw_bb$$sw_bb53$$sw_bb54$$sw_bb74$$sw_bb75$$sw_bb76$$sw_bb77$$sw_bb78$$sw_bb79$$sw_bb80$$sw_bb81$$sw_bb82$$sw_bb83$$sw_bb84$$sw_bb85$$sw_bb88$$sw_bb89$$sw_bb90$$sw_bb91$$sw_bb137$$sw_bb158$$sw_bb159$28: do { 
              if (__label__ == 19) {
  
                $c=32; //@line 968 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 969 "compiledict.cpp"
              }
              else if (__label__ == 20) {
  
                $c=73; //@line 972 "compiledict.cpp"
                __label__ = 21;break $sw_bb$$sw_bb53$$sw_bb54$$sw_bb74$$sw_bb75$$sw_bb76$$sw_bb77$$sw_bb78$$sw_bb79$$sw_bb80$$sw_bb81$$sw_bb82$$sw_bb83$$sw_bb84$$sw_bb85$$sw_bb88$$sw_bb89$$sw_bb90$$sw_bb91$$sw_bb137$$sw_bb158$$sw_bb159$28; //@line 972 "compiledict.cpp"
              }
              else if (__label__ == 24) {
  
                $c=15; //@line 992 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 993 "compiledict.cpp"
              }
              else if (__label__ == 25) {
  
                $c=25; //@line 995 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 996 "compiledict.cpp"
              }
              else if (__label__ == 26) {
  
                $c=24; //@line 998 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 999 "compiledict.cpp"
              }
              else if (__label__ == 27) {
  
                $c=26; //@line 1001 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1002 "compiledict.cpp"
              }
              else if (__label__ == 28) {
  
                $c=16; //@line 1004 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1005 "compiledict.cpp"
              }
              else if (__label__ == 29) {
  
                $c=12; //@line 1007 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1008 "compiledict.cpp"
              }
              else if (__label__ == 30) {
  
                $c=21; //@line 1010 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1011 "compiledict.cpp"
              }
              else if (__label__ == 31) {
  
                $c=10; //@line 1013 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1014 "compiledict.cpp"
              }
              else if (__label__ == 32) {
  
                $c=11; //@line 1016 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1017 "compiledict.cpp"
              }
              else if (__label__ == 33) {
  
                $c=13; //@line 1019 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1020 "compiledict.cpp"
              }
              else if (__label__ == 34) {
  
                $c=19; //@line 1022 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1023 "compiledict.cpp"
              }
              else if (__label__ == 35) {
  
                var $48=$ix; //@line 1025 "compiledict.cpp"
                var $inc86=((($48)+1)&4294967295); //@line 1025 "compiledict.cpp"
                $ix=$inc86; //@line 1025 "compiledict.cpp"
                var $49=$output; //@line 1025 "compiledict.cpp"
                var $arrayidx87=(($49+$48)&4294967295); //@line 1025 "compiledict.cpp"
                HEAP8[($arrayidx87)]=28; //@line 1025 "compiledict.cpp"
                $c=17; //@line 1026 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1027 "compiledict.cpp"
              }
              else if (__label__ == 36) {
  
                $c=31; //@line 1029 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1030 "compiledict.cpp"
              }
              else if (__label__ == 37) {
  
                $c=29; //@line 1032 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1033 "compiledict.cpp"
              }
              else if (__label__ == 38) {
  
                $c=23; //@line 1035 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1036 "compiledict.cpp"
              }
              else if (__label__ == 39) {
  
                var $50=$p; //@line 1039 "compiledict.cpp"
                var $incdec_ptr92=(($50+1)&4294967295); //@line 1039 "compiledict.cpp"
                $p=$incdec_ptr92; //@line 1039 "compiledict.cpp"
                var $51=HEAP8[($50)]; //@line 1039 "compiledict.cpp"
                var $conv93=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 1039 "compiledict.cpp"
                var $sub94=((($conv93)-48)&4294967295); //@line 1039 "compiledict.cpp"
                var $conv95=((($sub94)) & 255); //@line 1039 "compiledict.cpp"
                $c=$conv95; //@line 1039 "compiledict.cpp"
                var $52=$p; //@line 1040 "compiledict.cpp"
                var $incdec_ptr96=(($52+1)&4294967295); //@line 1040 "compiledict.cpp"
                $p=$incdec_ptr96; //@line 1040 "compiledict.cpp"
                var $53=HEAP8[($52)]; //@line 1040 "compiledict.cpp"
                var $conv97=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 1040 "compiledict.cpp"
                var $sub98=((($conv97)-48)&4294967295); //@line 1040 "compiledict.cpp"
                $value=$sub98; //@line 1040 "compiledict.cpp"
                var $54=$c; //@line 1041 "compiledict.cpp"
                var $conv99=(tempInt=(($54)),(tempInt>=128?tempInt-256:tempInt)); //@line 1041 "compiledict.cpp"
                var $mul100=((($conv99)*10)&4294967295); //@line 1041 "compiledict.cpp"
                var $55=$value; //@line 1041 "compiledict.cpp"
                var $add101=((($mul100)+($55))&4294967295); //@line 1041 "compiledict.cpp"
                var $conv102=((($add101)) & 255); //@line 1041 "compiledict.cpp"
                $c=$conv102; //@line 1041 "compiledict.cpp"
                var $56=$value; //@line 1042 "compiledict.cpp"
                var $cmp103=((($56))|0) < 0; //@line 1042 "compiledict.cpp"
                var $57=$value; //@line 1042 "compiledict.cpp"
                var $cmp105=((($57))|0) > 9; //@line 1042 "compiledict.cpp"
                var $or_cond=($cmp103) | ($cmp105); //@line 1042 "compiledict.cpp"
                if ($or_cond) { __label__ = 40;; } else { __label__ = 41;; } //@line 1042 "compiledict.cpp"
                $if_then106$$if_else109$47: do { 
                  if (__label__ == 40) {
  
                    $c=0; //@line 1044 "compiledict.cpp"
                    var $58=HEAP32[((__ZL5f_log)>>2)]; //@line 1045 "compiledict.cpp"
                    var $59=HEAP32[((__ZL7linenum)>>2)]; //@line 1045 "compiledict.cpp"
                    var $call107=_fprintf($58, ((__str97)&4294967295), allocate([$59,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1045 "compiledict.cpp"
                    var $60=HEAP32[((__ZL11error_count)>>2)]; //@line 1046 "compiledict.cpp"
                    var $inc108=((($60)+1)&4294967295); //@line 1046 "compiledict.cpp"
                    HEAP32[((__ZL11error_count)>>2)]=$inc108; //@line 1046 "compiledict.cpp"
                    ; //@line 1047 "compiledict.cpp"
                  }
                  else if (__label__ == 41) {
  
                    var $61=$c; //@line 1049 "compiledict.cpp"
                    var $conv110=(tempInt=(($61)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                    var $cmp111=((($conv110))|0) <= 0; //@line 1049 "compiledict.cpp"
                    if ($cmp111) { __label__ = 44;; } else { __label__ = 42;; } //@line 1049 "compiledict.cpp"
                    $if_then120$$lor_lhs_false112$50: do { 
                      if (__label__ == 42) {
  
                        var $62=$c; //@line 1049 "compiledict.cpp"
                        var $conv113=(tempInt=(($62)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                        var $cmp114=((($conv113))|0) >= 26; //@line 1049 "compiledict.cpp"
                        if ($cmp114) { __label__ = 44;break $if_then120$$lor_lhs_false112$50; } //@line 1049 "compiledict.cpp"
  
                        var $63=$c; //@line 1049 "compiledict.cpp"
                        var $conv116=(tempInt=(($63)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                        var $arrayidx117=((__ZL19letterGroupsDefined+$conv116)&4294967295); //@line 1049 "compiledict.cpp"
                        var $64=HEAP8[($arrayidx117)]; //@line 1049 "compiledict.cpp"
                        var $conv118=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt)); //@line 1049 "compiledict.cpp"
                        var $cmp119=((($conv118))|0)==0; //@line 1049 "compiledict.cpp"
                        if (!($cmp119)) { __label__ = 45;break $if_then106$$if_else109$47; } //@line 1049 "compiledict.cpp"
                      }
                    } while(0);
  
                    var $65=HEAP32[((__ZL5f_log)>>2)]; //@line 1051 "compiledict.cpp"
                    var $66=HEAP32[((__ZL7linenum)>>2)]; //@line 1051 "compiledict.cpp"
                    var $67=$c; //@line 1051 "compiledict.cpp"
                    var $conv121=(tempInt=(($67)),(tempInt>=128?tempInt-256:tempInt)); //@line 1051 "compiledict.cpp"
                    var $call122=_fprintf($65, ((__str98)&4294967295), allocate([$66,0,0,0,$conv121,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1051 "compiledict.cpp"
                    var $68=HEAP32[((__ZL11error_count)>>2)]; //@line 1052 "compiledict.cpp"
                    var $inc123=((($68)+1)&4294967295); //@line 1052 "compiledict.cpp"
                    HEAP32[((__ZL11error_count)>>2)]=$inc123; //@line 1052 "compiledict.cpp"
                    ; //@line 1053 "compiledict.cpp"
                  }
                } while(0);
  
                var $69=$c; //@line 1054 "compiledict.cpp"
                var $conv126=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 1054 "compiledict.cpp"
                var $add127=((($conv126)+65)&4294967295); //@line 1054 "compiledict.cpp"
                var $conv128=((($add127)) & 255); //@line 1054 "compiledict.cpp"
                $c=$conv128; //@line 1054 "compiledict.cpp"
                var $70=$state_addr; //@line 1055 "compiledict.cpp"
                var $71=HEAP32[(($70)>>2)]; //@line 1055 "compiledict.cpp"
                var $cmp129=((($71))|0)==1; //@line 1055 "compiledict.cpp"
                if ($cmp129) { __label__ = 46;; } else { __label__ = 47;; } //@line 1055 "compiledict.cpp"
                if (__label__ == 46) {
  
                  var $72=$c; //@line 1058 "compiledict.cpp"
                  var $73=$ix; //@line 1058 "compiledict.cpp"
                  var $inc131=((($73)+1)&4294967295); //@line 1058 "compiledict.cpp"
                  $ix=$inc131; //@line 1058 "compiledict.cpp"
                  var $74=$output; //@line 1058 "compiledict.cpp"
                  var $arrayidx132=(($74+$73)&4294967295); //@line 1058 "compiledict.cpp"
                  HEAP8[($arrayidx132)]=$72; //@line 1058 "compiledict.cpp"
                  $c=18; //@line 1059 "compiledict.cpp"
                  __label__ = 73;break $if_then49$$if_end212$25; //@line 1060 "compiledict.cpp"
                }
                else if (__label__ == 47) {
  
                  var $75=$ix; //@line 1063 "compiledict.cpp"
                  var $inc134=((($75)+1)&4294967295); //@line 1063 "compiledict.cpp"
                  $ix=$inc134; //@line 1063 "compiledict.cpp"
                  var $76=$output; //@line 1063 "compiledict.cpp"
                  var $arrayidx135=(($76+$75)&4294967295); //@line 1063 "compiledict.cpp"
                  HEAP8[($arrayidx135)]=18; //@line 1063 "compiledict.cpp"
                  __label__ = 73;break $if_then49$$if_end212$25;
                }
              }
              else if (__label__ == 48) {
  
                var $77=$ix; //@line 1068 "compiledict.cpp"
                var $inc138=((($77)+1)&4294967295); //@line 1068 "compiledict.cpp"
                $ix=$inc138; //@line 1068 "compiledict.cpp"
                var $78=$output; //@line 1068 "compiledict.cpp"
                var $arrayidx139=(($78+$77)&4294967295); //@line 1068 "compiledict.cpp"
                HEAP8[($arrayidx139)]=28; //@line 1068 "compiledict.cpp"
                $c=0; //@line 1069 "compiledict.cpp"
                $mr=((_mnem_rules)&4294967295); //@line 1070 "compiledict.cpp"
                ; //@line 1071 "compiledict.cpp"
                while(1) { 
  
                  var $79=$mr; //@line 1071 "compiledict.cpp"
                  var $mnem=(($79)&4294967295); //@line 1071 "compiledict.cpp"
                  var $80=HEAP32[(($mnem)>>2)]; //@line 1071 "compiledict.cpp"
                  var $cmp140=((($80))|0)!=0; //@line 1071 "compiledict.cpp"
                  if (!($cmp140)) { __label__ = 53;break ; } //@line 1071 "compiledict.cpp"
  
                  var $81=$mr; //@line 1073 "compiledict.cpp"
                  var $mnem141=(($81)&4294967295); //@line 1073 "compiledict.cpp"
                  var $82=HEAP32[(($mnem141)>>2)]; //@line 1073 "compiledict.cpp"
                  var $call142=_strlen($82); //@line 1073 "compiledict.cpp"
                  $len=$call142; //@line 1073 "compiledict.cpp"
                  var $83=$p; //@line 1074 "compiledict.cpp"
                  var $84=$mr; //@line 1074 "compiledict.cpp"
                  var $mnem143=(($84)&4294967295); //@line 1074 "compiledict.cpp"
                  var $85=HEAP32[(($mnem143)>>2)]; //@line 1074 "compiledict.cpp"
                  var $86=$len; //@line 1074 "compiledict.cpp"
                  var $call144=_memcmp($83, $85, $86); //@line 1074 "compiledict.cpp"
                  var $cmp145=((($call144))|0)==0; //@line 1074 "compiledict.cpp"
                  var $87=$mr; //@line 1076 "compiledict.cpp"
                  if ($cmp145) { __label__ = 51;break ; } //@line 1074 "compiledict.cpp"
  
                  var $incdec_ptr151=(($87+8)&4294967295); //@line 1080 "compiledict.cpp"
                  $mr=$incdec_ptr151; //@line 1080 "compiledict.cpp"
                  __label__ = 49;continue ; //@line 1081 "compiledict.cpp"
                }
                if (__label__ == 51) {
  
                  var $value147=(($87+4)&4294967295); //@line 1076 "compiledict.cpp"
                  var $88=HEAP32[(($value147)>>2)]; //@line 1076 "compiledict.cpp"
                  var $conv148=((($88)) & 255); //@line 1076 "compiledict.cpp"
                  $c=$conv148; //@line 1076 "compiledict.cpp"
                  var $89=$len; //@line 1077 "compiledict.cpp"
                  var $90=$p; //@line 1077 "compiledict.cpp"
                  var $add_ptr149=(($90+$89)&4294967295); //@line 1077 "compiledict.cpp"
                  $p=$add_ptr149; //@line 1077 "compiledict.cpp"
                  ; //@line 1078 "compiledict.cpp"
                }
  
                var $91=$c; //@line 1082 "compiledict.cpp"
                var $conv152=(tempInt=(($91)),(tempInt>=128?tempInt-256:tempInt)); //@line 1082 "compiledict.cpp"
                var $cmp153=((($conv152))|0)==0; //@line 1082 "compiledict.cpp"
                if (!($cmp153)) { __label__ = 73;break $if_then49$$if_end212$25; } //@line 1082 "compiledict.cpp"
  
                var $92=HEAP32[((__ZL5f_log)>>2)]; //@line 1084 "compiledict.cpp"
                var $93=HEAP32[((__ZL7linenum)>>2)]; //@line 1084 "compiledict.cpp"
                var $call155=_fprintf($92, ((__str99)&4294967295), allocate([$93,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1084 "compiledict.cpp"
                var $94=HEAP32[((__ZL11error_count)>>2)]; //@line 1085 "compiledict.cpp"
                var $inc156=((($94)+1)&4294967295); //@line 1085 "compiledict.cpp"
                HEAP32[((__ZL11error_count)>>2)]=$inc156; //@line 1085 "compiledict.cpp"
                __label__ = 73;break $if_then49$$if_end212$25; //@line 1086 "compiledict.cpp"
              }
              else if (__label__ == 55) {
  
                var $95=$sxflags; //@line 1090 "compiledict.cpp"
                var $or=($95) | 1024; //@line 1090 "compiledict.cpp"
                $sxflags=$or; //@line 1090 "compiledict.cpp"
                __label__ = 56;break $sw_bb$$sw_bb53$$sw_bb54$$sw_bb74$$sw_bb75$$sw_bb76$$sw_bb77$$sw_bb78$$sw_bb79$$sw_bb80$$sw_bb81$$sw_bb82$$sw_bb83$$sw_bb84$$sw_bb85$$sw_bb88$$sw_bb89$$sw_bb90$$sw_bb91$$sw_bb137$$sw_bb158$$sw_bb159$28; //@line 1090 "compiledict.cpp"
              }
            } while(0);
            if (__label__ == 21) {
  
              var $38=$state_addr; //@line 979 "compiledict.cpp"
              var $39=HEAP32[(($38)>>2)]; //@line 979 "compiledict.cpp"
              var $cmp55=((($39))|0)==1; //@line 979 "compiledict.cpp"
              if ($cmp55) { __label__ = 22;; } else { __label__ = 23;; } //@line 979 "compiledict.cpp"
              if (__label__ == 22) {
  
                var $40=$c; //@line 982 "compiledict.cpp"
                var $conv57=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 982 "compiledict.cpp"
                var $sub58=((($conv57)-65)&4294967295); //@line 982 "compiledict.cpp"
                var $arrayidx59=((__ZZL16copy_rule_stringPcRiE16lettergp_letters+$sub58)&4294967295); //@line 982 "compiledict.cpp"
                var $41=HEAP8[($arrayidx59)]; //@line 982 "compiledict.cpp"
                var $conv60=(tempInt=(($41)),(tempInt>=128?tempInt-256:tempInt)); //@line 982 "compiledict.cpp"
                var $add61=((($conv60)+65)&4294967295); //@line 982 "compiledict.cpp"
                var $conv62=((($add61)) & 255); //@line 982 "compiledict.cpp"
                var $42=$ix; //@line 982 "compiledict.cpp"
                var $inc63=((($42)+1)&4294967295); //@line 982 "compiledict.cpp"
                $ix=$inc63; //@line 982 "compiledict.cpp"
                var $43=$output; //@line 982 "compiledict.cpp"
                var $arrayidx64=(($43+$42)&4294967295); //@line 982 "compiledict.cpp"
                HEAP8[($arrayidx64)]=$conv62; //@line 982 "compiledict.cpp"
                $c=17; //@line 983 "compiledict.cpp"
                ; //@line 984 "compiledict.cpp"
              }
              else if (__label__ == 23) {
  
                var $44=$ix; //@line 987 "compiledict.cpp"
                var $inc65=((($44)+1)&4294967295); //@line 987 "compiledict.cpp"
                $ix=$inc65; //@line 987 "compiledict.cpp"
                var $45=$output; //@line 987 "compiledict.cpp"
                var $arrayidx66=(($45+$44)&4294967295); //@line 987 "compiledict.cpp"
                HEAP8[($arrayidx66)]=17; //@line 987 "compiledict.cpp"
                var $46=$c; //@line 988 "compiledict.cpp"
                var $conv67=(tempInt=(($46)),(tempInt>=128?tempInt-256:tempInt)); //@line 988 "compiledict.cpp"
                var $sub68=((($conv67)-65)&4294967295); //@line 988 "compiledict.cpp"
                var $arrayidx69=((__ZZL16copy_rule_stringPcRiE16lettergp_letters+$sub68)&4294967295); //@line 988 "compiledict.cpp"
                var $47=HEAP8[($arrayidx69)]; //@line 988 "compiledict.cpp"
                var $conv70=(tempInt=(($47)),(tempInt>=128?tempInt-256:tempInt)); //@line 988 "compiledict.cpp"
                var $add71=((($conv70)+65)&4294967295); //@line 988 "compiledict.cpp"
                var $conv72=((($add71)) & 255); //@line 988 "compiledict.cpp"
                $c=$conv72; //@line 988 "compiledict.cpp"
                ;
              }
            }
            else if (__label__ == 56) {
  
              var $96=$ix; //@line 1092 "compiledict.cpp"
              var $inc160=((($96)+1)&4294967295); //@line 1092 "compiledict.cpp"
              $ix=$inc160; //@line 1092 "compiledict.cpp"
              var $97=$output; //@line 1092 "compiledict.cpp"
              var $arrayidx161=(($97+$96)&4294967295); //@line 1092 "compiledict.cpp"
              HEAP8[($arrayidx161)]=14; //@line 1092 "compiledict.cpp"
              $value=0; //@line 1093 "compiledict.cpp"
              ; //@line 1094 "compiledict.cpp"
              while(1) { 
  
                var $98=$p; //@line 1094 "compiledict.cpp"
                var $incdec_ptr163=(($98+1)&4294967295); //@line 1094 "compiledict.cpp"
                $p=$incdec_ptr163; //@line 1094 "compiledict.cpp"
                var $99=HEAP8[($98)]; //@line 1094 "compiledict.cpp"
                $c=$99; //@line 1094 "compiledict.cpp"
                var $conv164=(tempInt=(($99)),(tempInt>=128?tempInt-256:tempInt)); //@line 1094 "compiledict.cpp"
                var $call165=__Z8isspace2j($conv164); //@line 1094 "compiledict.cpp"
                var $tobool=((($call165))|0)!=0; //@line 1094 "compiledict.cpp"
                if ($tobool) { __label__ = 72;break ; } //@line 1094 "compiledict.cpp"
  
                var $100=$c; //@line 1094 "compiledict.cpp"
                var $conv166=(tempInt=(($100)),(tempInt>=128?tempInt-256:tempInt)); //@line 1094 "compiledict.cpp"
                var $cmp167=((($conv166))|0)!=0; //@line 1094 "compiledict.cpp"
                if (!($cmp167)) { __label__ = 72;break ; }
  
                var $101=$c; //@line 1096 "compiledict.cpp"
                var $conv169=(tempInt=(($101)),(tempInt>=128?tempInt-256:tempInt)); //@line 1096 "compiledict.cpp"
                if ($conv169 == 101) {
                  __label__ = 60;;
                }
                else if ($conv169 == 105) {
                  __label__ = 61;;
                }
                else if ($conv169 == 112) {
                  __label__ = 62;;
                }
                else if ($conv169 == 118) {
                  __label__ = 63;;
                }
                else if ($conv169 == 100) {
                  __label__ = 64;;
                }
                else if ($conv169 == 102) {
                  __label__ = 65;;
                }
                else if ($conv169 == 113) {
                  __label__ = 66;;
                }
                else if ($conv169 == 116) {
                  __label__ = 67;;
                }
                else if ($conv169 == 98) {
                  __label__ = 68;;
                }
                else if ($conv169 == 97) {
                  __label__ = 69;;
                }
                else {
                __label__ = 70;;
                }
                
                if (__label__ == 70) {
  
                  var $112=$c; //@line 1129 "compiledict.cpp"
                  var $conv190=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 1129 "compiledict.cpp"
                  var $isdigittmp=((($conv190)-48)&4294967295); //@line 1129 "compiledict.cpp"
                  var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1129 "compiledict.cpp"
                  var $call191=((($isdigit))&1); //@line 1129 "compiledict.cpp"
                  var $tobool192=((($call191))|0)!=0; //@line 1129 "compiledict.cpp"
                  if (!($tobool192)) { __label__ = 57;continue ; } //@line 1129 "compiledict.cpp"
  
                  var $113=$value; //@line 1130 "compiledict.cpp"
                  var $mul194=((($113)*10)&4294967295); //@line 1130 "compiledict.cpp"
                  var $114=$c; //@line 1130 "compiledict.cpp"
                  var $conv195=(tempInt=(($114)),(tempInt>=128?tempInt-256:tempInt)); //@line 1130 "compiledict.cpp"
                  var $sub196=((($mul194)-48)&4294967295); //@line 1130 "compiledict.cpp"
                  var $add197=((($sub196)+($conv195))&4294967295); //@line 1130 "compiledict.cpp"
                  $value=$add197; //@line 1130 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1130 "compiledict.cpp"
                }
                else if (__label__ == 60) {
  
                  var $102=$sxflags; //@line 1099 "compiledict.cpp"
                  var $or171=($102) | 256; //@line 1099 "compiledict.cpp"
                  $sxflags=$or171; //@line 1099 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1100 "compiledict.cpp"
                }
                else if (__label__ == 61) {
  
                  var $103=$sxflags; //@line 1102 "compiledict.cpp"
                  var $or173=($103) | 512; //@line 1102 "compiledict.cpp"
                  $sxflags=$or173; //@line 1102 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1103 "compiledict.cpp"
                }
                else if (__label__ == 62) {
  
                  var $104=$sxflags; //@line 1105 "compiledict.cpp"
                  var $or175=($104) | 1024; //@line 1105 "compiledict.cpp"
                  $sxflags=$or175; //@line 1105 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1106 "compiledict.cpp"
                }
                else if (__label__ == 63) {
  
                  var $105=$sxflags; //@line 1108 "compiledict.cpp"
                  var $or177=($105) | 2048; //@line 1108 "compiledict.cpp"
                  $sxflags=$or177; //@line 1108 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1109 "compiledict.cpp"
                }
                else if (__label__ == 64) {
  
                  var $106=$sxflags; //@line 1111 "compiledict.cpp"
                  var $or179=($106) | 4096; //@line 1111 "compiledict.cpp"
                  $sxflags=$or179; //@line 1111 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1112 "compiledict.cpp"
                }
                else if (__label__ == 65) {
  
                  var $107=$sxflags; //@line 1114 "compiledict.cpp"
                  var $or181=($107) | 8192; //@line 1114 "compiledict.cpp"
                  $sxflags=$or181; //@line 1114 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1115 "compiledict.cpp"
                }
                else if (__label__ == 66) {
  
                  var $108=$sxflags; //@line 1117 "compiledict.cpp"
                  var $or183=($108) | 16384; //@line 1117 "compiledict.cpp"
                  $sxflags=$or183; //@line 1117 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1118 "compiledict.cpp"
                }
                else if (__label__ == 67) {
  
                  var $109=$sxflags; //@line 1120 "compiledict.cpp"
                  var $or185=($109) | 65536; //@line 1120 "compiledict.cpp"
                  $sxflags=$or185; //@line 1120 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1121 "compiledict.cpp"
                }
                else if (__label__ == 68) {
  
                  var $110=$sxflags; //@line 1123 "compiledict.cpp"
                  var $or187=($110) | 131072; //@line 1123 "compiledict.cpp"
                  $sxflags=$or187; //@line 1123 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1124 "compiledict.cpp"
                }
                else if (__label__ == 69) {
  
                  var $111=$sxflags; //@line 1126 "compiledict.cpp"
                  var $or189=($111) | 262144; //@line 1126 "compiledict.cpp"
                  $sxflags=$or189; //@line 1126 "compiledict.cpp"
                  __label__ = 57;continue ; //@line 1127 "compiledict.cpp"
                }
              }
  
              var $115=$p; //@line 1134 "compiledict.cpp"
              var $incdec_ptr200=(($115+-1)&4294967295); //@line 1134 "compiledict.cpp"
              $p=$incdec_ptr200; //@line 1134 "compiledict.cpp"
              var $116=$sxflags; //@line 1135 "compiledict.cpp"
              var $shr=($116) >> 16; //@line 1135 "compiledict.cpp"
              var $conv201=((($shr)) & 255); //@line 1135 "compiledict.cpp"
              var $117=$ix; //@line 1135 "compiledict.cpp"
              var $inc202=((($117)+1)&4294967295); //@line 1135 "compiledict.cpp"
              $ix=$inc202; //@line 1135 "compiledict.cpp"
              var $118=$output; //@line 1135 "compiledict.cpp"
              var $arrayidx203=(($118+$117)&4294967295); //@line 1135 "compiledict.cpp"
              HEAP8[($arrayidx203)]=$conv201; //@line 1135 "compiledict.cpp"
              var $119=$sxflags; //@line 1136 "compiledict.cpp"
              var $shr204=($119) >> 8; //@line 1136 "compiledict.cpp"
              var $conv205=((($shr204)) & 255); //@line 1136 "compiledict.cpp"
              var $120=$ix; //@line 1136 "compiledict.cpp"
              var $inc206=((($120)+1)&4294967295); //@line 1136 "compiledict.cpp"
              $ix=$inc206; //@line 1136 "compiledict.cpp"
              var $121=$output; //@line 1136 "compiledict.cpp"
              var $arrayidx207=(($121+$120)&4294967295); //@line 1136 "compiledict.cpp"
              HEAP8[($arrayidx207)]=$conv205; //@line 1136 "compiledict.cpp"
              var $122=$value; //@line 1137 "compiledict.cpp"
              var $or208=($122) | 128; //@line 1137 "compiledict.cpp"
              var $conv209=((($or208)) & 255); //@line 1137 "compiledict.cpp"
              $c=$conv209; //@line 1137 "compiledict.cpp"
              ; //@line 1138 "compiledict.cpp"
            }
          }
        } while(0);
  
        var $123=$c; //@line 1142 "compiledict.cpp"
        var $124=$ix; //@line 1142 "compiledict.cpp"
        var $inc213=((($124)+1)&4294967295); //@line 1142 "compiledict.cpp"
        $ix=$inc213; //@line 1142 "compiledict.cpp"
        var $125=$output; //@line 1142 "compiledict.cpp"
        var $arrayidx214=(($125+$124)&4294967295); //@line 1142 "compiledict.cpp"
        HEAP8[($arrayidx214)]=$123; //@line 1142 "compiledict.cpp"
        var $126=$c; //@line 1143 "compiledict.cpp"
        var $conv215=(tempInt=(($126)),(tempInt>=128?tempInt-256:tempInt)); //@line 1143 "compiledict.cpp"
        var $cmp216=((($conv215))|0)==0; //@line 1143 "compiledict.cpp"
        if ($cmp216) { __label__ = 74;break $for_cond$10; } else { __label__ = 6;continue $for_cond$10; } //@line 1143 "compiledict.cpp"
      }
  
      var $127=$state_addr; //@line 1146 "compiledict.cpp"
      var $128=HEAP32[(($127)>>2)]; //@line 1146 "compiledict.cpp"
      var $arrayidx219=((__ZZL16copy_rule_stringPcRiE10next_state+$128*4)&4294967295); //@line 1146 "compiledict.cpp"
      var $129=HEAP32[(($arrayidx219)>>2)]; //@line 1146 "compiledict.cpp"
      var $130=$state_addr; //@line 1146 "compiledict.cpp"
      HEAP32[(($130)>>2)]=$129; //@line 1146 "compiledict.cpp"
      ; //@line 1147 "compiledict.cpp"
    }
  
    ;
    return; //@line 1147 "compiledict.cpp"
    return;
  }
  

  function __ZL12compile_linePcS_Pi($linebuf, $dict_line, $hash) {
    var __stackBase__  = STACKTOP; STACKTOP += 312; _memset(__stackBase__, 0, 312);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $linebuf_addr;
    var $dict_line_addr;
    var $hash_addr;
    var $c;
    var $p;
    var $word;
    var $phonetic;
    var $ix;
    var $step;
    var $n_flag_codes;
    var $flag_offset;
    var $length;
    var $multiple_words;
    var $multiple_numeric_hyphen;
    var $multiple_string;
    var $multiple_string_end;
    var $len_word;
    var $len_phonetic;
    var $text_not_phonemes;
    var $wc=__stackBase__;
    var $all_upper_case;
    var $mnemptr;
    var $comment;
    var $flag_codes=__stackBase__+4;
    var $encoded_ph=__stackBase__+104;
    var $bad_phoneme=__stackBase__+304;
    var $c2=__stackBase__+308;
    $linebuf_addr=$linebuf;
    $dict_line_addr=$dict_line;
    $hash_addr=$hash;
    $n_flag_codes=0; //@line 378 "compiledict.cpp"
    $multiple_words=0; //@line 381 "compiledict.cpp"
    $multiple_numeric_hyphen=0; //@line 382 "compiledict.cpp"
    $multiple_string=0; //@line 383 "compiledict.cpp"
    $multiple_string_end=0; //@line 384 "compiledict.cpp"
    $comment=0; //@line 399 "compiledict.cpp"
    $text_not_phonemes=0; //@line 400 "compiledict.cpp"
    $word=((__ZZL12compile_linePcS_PiE10nullstring)&4294967295); //@line 401 "compiledict.cpp"
    $phonetic=((__ZZL12compile_linePcS_PiE10nullstring)&4294967295); //@line 401 "compiledict.cpp"
    var $0=$linebuf_addr; //@line 403 "compiledict.cpp"
    var $call=_memcmp($0, ((__str108)&4294967295), 2); //@line 403 "compiledict.cpp"
    var $cmp=((($call))|0)==0; //@line 403 "compiledict.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 403 "compiledict.cpp"
    if (__label__ == 1) {
  
      $step=1; //@line 405 "compiledict.cpp"
      ; //@line 406 "compiledict.cpp"
    }
  
    var $1=$linebuf_addr; //@line 407 "compiledict.cpp"
    $p=$1; //@line 407 "compiledict.cpp"
    $step=0; //@line 426 "compiledict.cpp"
    $c=0; //@line 428 "compiledict.cpp"
    var $2=$c; //@line 429 "compiledict.cpp"
    var $conv13=((($2))&255); //@line 429 "compiledict.cpp"
    var $cmp114=((($conv13))|0)!=10; //@line 429 "compiledict.cpp"
    if ($cmp114) { __label__ = 3;; } else { __label__ = 55;; } //@line 429 "compiledict.cpp"
    $while_body$$while_end147$5: do { 
      if (__label__ == 3) {
        $while_body$6: while(1) { 
  
          var $3=$p; //@line 431 "compiledict.cpp"
          var $4=HEAP8[($3)]; //@line 431 "compiledict.cpp"
          $c=$4; //@line 431 "compiledict.cpp"
          var $5=$c; //@line 433 "compiledict.cpp"
          var $conv2=((($5))&255); //@line 433 "compiledict.cpp"
          var $cmp3=((($conv2))|0)==63; //@line 433 "compiledict.cpp"
          if ($cmp3) { __label__ = 4;; } else { __label__ = 12;; } //@line 433 "compiledict.cpp"
          $land_lhs_true$$if_end28$8: do { 
            if (__label__ == 4) {
  
              var $6=$step; //@line 433 "compiledict.cpp"
              var $cmp4=((($6))|0)==0; //@line 433 "compiledict.cpp"
              if (!($cmp4)) { __label__ = 12;break $land_lhs_true$$if_end28$8; } //@line 433 "compiledict.cpp"
  
              $flag_offset=100; //@line 436 "compiledict.cpp"
              var $7=$p; //@line 438 "compiledict.cpp"
              var $incdec_ptr=(($7+1)&4294967295); //@line 438 "compiledict.cpp"
              $p=$incdec_ptr; //@line 438 "compiledict.cpp"
              var $8=$p; //@line 439 "compiledict.cpp"
              var $9=HEAP8[($8)]; //@line 439 "compiledict.cpp"
              var $conv6=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 439 "compiledict.cpp"
              var $cmp7=((($conv6))|0)==33; //@line 439 "compiledict.cpp"
              if ($cmp7) { __label__ = 6;; } else { __label__ = 7;; } //@line 439 "compiledict.cpp"
              if (__label__ == 6) {
  
                $flag_offset=132; //@line 442 "compiledict.cpp"
                var $10=$p; //@line 443 "compiledict.cpp"
                var $incdec_ptr9=(($10+1)&4294967295); //@line 443 "compiledict.cpp"
                $p=$incdec_ptr9; //@line 443 "compiledict.cpp"
                ; //@line 444 "compiledict.cpp"
              }
  
              $ix=0; //@line 446 "compiledict.cpp"
              var $11=$p; //@line 447 "compiledict.cpp"
              var $12=HEAP8[($11)]; //@line 447 "compiledict.cpp"
              var $conv11=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 447 "compiledict.cpp"
              var $isdigittmp=((($conv11)-48)&4294967295); //@line 447 "compiledict.cpp"
              var $isdigit=((($isdigittmp))>>>0) < 10; //@line 447 "compiledict.cpp"
              var $call12=((($isdigit))&1); //@line 447 "compiledict.cpp"
              var $tobool=((($call12))|0)!=0; //@line 447 "compiledict.cpp"
              if ($tobool) { __label__ = 8;; } else { __label__ = 9;; } //@line 447 "compiledict.cpp"
              if (__label__ == 8) {
  
                var $13=$p; //@line 449 "compiledict.cpp"
                var $14=HEAP8[($13)]; //@line 449 "compiledict.cpp"
                var $conv14=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 449 "compiledict.cpp"
                var $15=$ix; //@line 449 "compiledict.cpp"
                var $sub=((($15)-48)&4294967295); //@line 449 "compiledict.cpp"
                var $add=((($sub)+($conv14))&4294967295); //@line 449 "compiledict.cpp"
                $ix=$add; //@line 449 "compiledict.cpp"
                var $16=$p; //@line 450 "compiledict.cpp"
                var $incdec_ptr15=(($16+1)&4294967295); //@line 450 "compiledict.cpp"
                $p=$incdec_ptr15; //@line 450 "compiledict.cpp"
                ; //@line 451 "compiledict.cpp"
              }
  
              var $17=$p; //@line 452 "compiledict.cpp"
              var $18=HEAP8[($17)]; //@line 452 "compiledict.cpp"
              var $conv17=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 452 "compiledict.cpp"
              var $isdigittmp1=((($conv17)-48)&4294967295); //@line 452 "compiledict.cpp"
              var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 452 "compiledict.cpp"
              var $call18=((($isdigit2))&1); //@line 452 "compiledict.cpp"
              var $tobool19=((($call18))|0)!=0; //@line 452 "compiledict.cpp"
              if ($tobool19) { __label__ = 10;; } else { __label__ = 11;; } //@line 452 "compiledict.cpp"
              if (__label__ == 10) {
  
                var $19=$ix; //@line 454 "compiledict.cpp"
                var $mul=((($19)*10)&4294967295); //@line 454 "compiledict.cpp"
                var $20=$p; //@line 454 "compiledict.cpp"
                var $21=HEAP8[($20)]; //@line 454 "compiledict.cpp"
                var $conv21=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 454 "compiledict.cpp"
                var $sub22=((($mul)-48)&4294967295); //@line 454 "compiledict.cpp"
                var $add23=((($sub22)+($conv21))&4294967295); //@line 454 "compiledict.cpp"
                $ix=$add23; //@line 454 "compiledict.cpp"
                var $22=$p; //@line 455 "compiledict.cpp"
                var $incdec_ptr24=(($22+1)&4294967295); //@line 455 "compiledict.cpp"
                $p=$incdec_ptr24; //@line 455 "compiledict.cpp"
                ; //@line 456 "compiledict.cpp"
              }
  
              var $23=$ix; //@line 457 "compiledict.cpp"
              var $24=$flag_offset; //@line 457 "compiledict.cpp"
              var $add26=((($24)+($23))&4294967295); //@line 457 "compiledict.cpp"
              var $conv27=((($add26)) & 255); //@line 457 "compiledict.cpp"
              var $25=$n_flag_codes; //@line 457 "compiledict.cpp"
              var $inc=((($25)+1)&4294967295); //@line 457 "compiledict.cpp"
              $n_flag_codes=$inc; //@line 457 "compiledict.cpp"
              var $arrayidx=(($flag_codes+$25)&4294967295); //@line 457 "compiledict.cpp"
              HEAP8[($arrayidx)]=$conv27; //@line 457 "compiledict.cpp"
              var $26=$p; //@line 458 "compiledict.cpp"
              var $27=HEAP8[($26)]; //@line 458 "compiledict.cpp"
              $c=$27; //@line 458 "compiledict.cpp"
              ; //@line 459 "compiledict.cpp"
            }
          } while(0);
  
          var $28=$c; //@line 461 "compiledict.cpp"
          var $conv29=((($28))&255); //@line 461 "compiledict.cpp"
          var $cmp30=((($conv29))|0)==36; //@line 461 "compiledict.cpp"
          if ($cmp30) { __label__ = 13;; } else { __label__ = 25;; } //@line 461 "compiledict.cpp"
          $land_lhs_true31$$if_end64$21: do { 
            if (__label__ == 13) {
  
              var $29=$p; //@line 461 "compiledict.cpp"
              var $arrayidx32=(($29+1)&4294967295); //@line 461 "compiledict.cpp"
              var $30=HEAP8[($arrayidx32)]; //@line 461 "compiledict.cpp"
              var $conv33=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 461 "compiledict.cpp"
              var $call34=_isalnum($conv33); //@line 461 "compiledict.cpp"
              var $tobool35=((($call34))|0)!=0; //@line 461 "compiledict.cpp"
              if (!($tobool35)) { __label__ = 25;break $land_lhs_true31$$if_end64$21; } //@line 461 "compiledict.cpp"
  
              var $31=$p; //@line 464 "compiledict.cpp"
              $mnemptr=$31; //@line 464 "compiledict.cpp"
              var $32=$p; //@line 465 "compiledict.cpp"
              var $33=HEAPU8[($32)]; //@line 465 "compiledict.cpp"
              $c=$33; //@line 465 "compiledict.cpp"
              var $conv389=((($33))&255); //@line 465 "compiledict.cpp"
              var $call3910=__Z8isspace2j($conv389); //@line 465 "compiledict.cpp"
              var $tobool4011=((($call3910))|0)!=0; //@line 465 "compiledict.cpp"
              var $lnot12=($tobool4011) ^ 1; //@line 465 "compiledict.cpp"
              var $34=$p; //@line 465 "compiledict.cpp"
              if ($lnot12) { __lastLabel__ = 14; __label__ = 15;; } else { __lastLabel__ = 14; __label__ = 16;; } //@line 465 "compiledict.cpp"
              $while_body41$$while_end$24: do { 
                if (__label__ == 15) {
                  while(1) { 
  
                    var $35=__lastLabel__ == 15 ? $38 : ($34);
                    var $incdec_ptr42=(($35+1)&4294967295); //@line 465 "compiledict.cpp"
                    $p=$incdec_ptr42; //@line 465 "compiledict.cpp"
                    var $36=$p; //@line 465 "compiledict.cpp"
                    var $37=HEAPU8[($36)]; //@line 465 "compiledict.cpp"
                    $c=$37; //@line 465 "compiledict.cpp"
                    var $conv38=((($37))&255); //@line 465 "compiledict.cpp"
                    var $call39=__Z8isspace2j($conv38); //@line 465 "compiledict.cpp"
                    var $tobool40=((($call39))|0)!=0; //@line 465 "compiledict.cpp"
                    var $lnot=($tobool40) ^ 1; //@line 465 "compiledict.cpp"
                    var $38=$p; //@line 465 "compiledict.cpp"
                    if ($lnot) { __lastLabel__ = 15; __label__ = 15;continue ; } else { __lastLabel__ = 15; __label__ = 16;break $while_body41$$while_end$24; } //@line 465 "compiledict.cpp"
                  }
                }
              } while(0);
  
              var $_lcssa=__lastLabel__ == 14 ? $34 : ($38);
              HEAP8[($_lcssa)]=0; //@line 466 "compiledict.cpp"
              var $39=$mnemptr; //@line 468 "compiledict.cpp"
              var $call43=__Z10LookupMnemP8MNEM_TABPKc(((_mnem_flags)&4294967295), $39); //@line 468 "compiledict.cpp"
              $ix=$call43; //@line 468 "compiledict.cpp"
              var $cmp44=((($call43))>>>0) > 0; //@line 469 "compiledict.cpp"
              if ($cmp44) { __label__ = 17;; } else { __label__ = 24;; } //@line 469 "compiledict.cpp"
              if (__label__ == 17) {
  
                var $40=$ix; //@line 471 "compiledict.cpp"
                var $cmp46=((($40))|0)==200; //@line 471 "compiledict.cpp"
                if ($cmp46) { __label__ = 18;; } else { __label__ = 19;; } //@line 471 "compiledict.cpp"
                if (__label__ == 18) {
  
                  HEAP8[(__ZL9text_mode_b)]=1;
                  ; //@line 474 "compiledict.cpp"
                }
                else if (__label__ == 19) {
  
                  var $41=$ix; //@line 476 "compiledict.cpp"
                  var $cmp48=((($41))|0)==201; //@line 476 "compiledict.cpp"
                  if ($cmp48) { __label__ = 20;; } else { __label__ = 21;; } //@line 476 "compiledict.cpp"
                  if (__label__ == 20) {
  
                    HEAP8[(__ZL9text_mode_b)]=0;
                    ; //@line 479 "compiledict.cpp"
                  }
                  else if (__label__ == 21) {
  
                    var $42=$ix; //@line 481 "compiledict.cpp"
                    var $cmp51=((($42))|0)==29; //@line 481 "compiledict.cpp"
                    if ($cmp51) { __label__ = 22;; } else { __label__ = 23;; } //@line 481 "compiledict.cpp"
                    if (__label__ == 22) {
  
                      $text_not_phonemes=1; //@line 483 "compiledict.cpp"
                      ; //@line 484 "compiledict.cpp"
                    }
                    else if (__label__ == 23) {
  
                      var $43=$ix; //@line 487 "compiledict.cpp"
                      var $conv54=((($43)) & 255); //@line 487 "compiledict.cpp"
                      var $44=$n_flag_codes; //@line 487 "compiledict.cpp"
                      var $inc55=((($44)+1)&4294967295); //@line 487 "compiledict.cpp"
                      $n_flag_codes=$inc55; //@line 487 "compiledict.cpp"
                      var $arrayidx56=(($flag_codes+$44)&4294967295); //@line 487 "compiledict.cpp"
                      HEAP8[($arrayidx56)]=$conv54; //@line 487 "compiledict.cpp"
                      ;
                    }
                  }
                }
              }
              else if (__label__ == 24) {
  
                var $45=HEAP32[((__ZL5f_log)>>2)]; //@line 492 "compiledict.cpp"
                var $46=HEAP32[((__ZL7linenum)>>2)]; //@line 492 "compiledict.cpp"
                var $47=$mnemptr; //@line 492 "compiledict.cpp"
                var $call61=_fprintf($45, ((__str109)&4294967295), allocate([$46,0,0,0,$47,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 492 "compiledict.cpp"
                var $48=HEAP32[((__ZL11error_count)>>2)]; //@line 493 "compiledict.cpp"
                var $inc62=((($48)+1)&4294967295); //@line 493 "compiledict.cpp"
                HEAP32[((__ZL11error_count)>>2)]=$inc62; //@line 493 "compiledict.cpp"
                ;
              }
            }
          } while(0);
  
          var $49=$c; //@line 497 "compiledict.cpp"
          var $conv65=((($49))&255); //@line 497 "compiledict.cpp"
          var $cmp66=((($conv65))|0)==47; //@line 497 "compiledict.cpp"
          if ($cmp66) { __label__ = 26;; } else { __label__ = 29;; } //@line 497 "compiledict.cpp"
          $land_lhs_true67$$if_end74$41: do { 
            if (__label__ == 26) {
  
              var $50=$p; //@line 497 "compiledict.cpp"
              var $arrayidx68=(($50+1)&4294967295); //@line 497 "compiledict.cpp"
              var $51=HEAP8[($arrayidx68)]; //@line 497 "compiledict.cpp"
              var $conv69=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 497 "compiledict.cpp"
              var $cmp70=((($conv69))|0)==47; //@line 497 "compiledict.cpp"
              if (!($cmp70)) { __label__ = 29;break $land_lhs_true67$$if_end74$41; } //@line 497 "compiledict.cpp"
  
              var $52=$multiple_words; //@line 497 "compiledict.cpp"
              var $cmp72=((($52))|0)==0; //@line 497 "compiledict.cpp"
              if (!($cmp72)) { __label__ = 29;break $land_lhs_true67$$if_end74$41; } //@line 497 "compiledict.cpp"
  
              $c=10; //@line 499 "compiledict.cpp"
              var $53=$p; //@line 500 "compiledict.cpp"
              $comment=$53; //@line 500 "compiledict.cpp"
              ; //@line 501 "compiledict.cpp"
            }
          } while(0);
  
          var $54=$step; //@line 503 "compiledict.cpp"
          if ($54 == 0) {
            __label__ = 30;;
          }
          else if ($54 == 1) {
            __label__ = 34;;
          }
          else if ($54 == 2) {
            __label__ = 46;;
          }
          else if ($54 == 3) {
            __label__ = 50;;
          }
          else if ($54 == 4) {
            __label__ = 52;;
          }
          else {
          __label__ = 54;;
          }
          
          $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46: do { 
            if (__label__ == 30) {
  
              var $55=$c; //@line 506 "compiledict.cpp"
              var $conv75=((($55))&255); //@line 506 "compiledict.cpp"
              var $cmp76=((($conv75))|0)==40; //@line 506 "compiledict.cpp"
              if ($cmp76) { __label__ = 31;; } else { __label__ = 32;; } //@line 506 "compiledict.cpp"
              if (__label__ == 31) {
  
                $multiple_words=1; //@line 508 "compiledict.cpp"
                var $56=$p; //@line 509 "compiledict.cpp"
                var $add_ptr=(($56+1)&4294967295); //@line 509 "compiledict.cpp"
                $word=$add_ptr; //@line 509 "compiledict.cpp"
                $step=1; //@line 510 "compiledict.cpp"
                ; //@line 511 "compiledict.cpp"
              }
              else if (__label__ == 32) {
  
                var $57=$c; //@line 513 "compiledict.cpp"
                var $conv79=((($57))&255); //@line 513 "compiledict.cpp"
                var $call80=__Z8isspace2j($conv79); //@line 513 "compiledict.cpp"
                var $tobool81=((($call80))|0)!=0; //@line 513 "compiledict.cpp"
                if ($tobool81) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 513 "compiledict.cpp"
  
                var $58=$p; //@line 515 "compiledict.cpp"
                $word=$58; //@line 515 "compiledict.cpp"
                $step=1; //@line 516 "compiledict.cpp"
                ; //@line 517 "compiledict.cpp"
              }
            }
            else if (__label__ == 34) {
  
              var $59=$c; //@line 521 "compiledict.cpp"
              var $conv86=((($59))&255); //@line 521 "compiledict.cpp"
              var $cmp87=((($conv86))|0)==45; //@line 521 "compiledict.cpp"
              if ($cmp87) { __label__ = 35;; } else { __label__ = 39;; } //@line 521 "compiledict.cpp"
              $land_lhs_true88$$if_end99$53: do { 
                if (__label__ == 35) {
  
                  var $60=$multiple_words; //@line 521 "compiledict.cpp"
                  var $tobool89=((($60))|0)!=0; //@line 521 "compiledict.cpp"
                  if (!($tobool89)) { __label__ = 39;break $land_lhs_true88$$if_end99$53; } //@line 521 "compiledict.cpp"
  
                  var $61=$word; //@line 523 "compiledict.cpp"
                  var $arrayidx91=(($61)&4294967295); //@line 523 "compiledict.cpp"
                  var $62=HEAP8[($arrayidx91)]; //@line 523 "compiledict.cpp"
                  var $conv92=(tempInt=(($62)),(tempInt>=128?tempInt-256:tempInt)); //@line 523 "compiledict.cpp"
                  var $isdigittmp3=((($conv92)-48)&4294967295); //@line 523 "compiledict.cpp"
                  var $isdigit4=((($isdigittmp3))>>>0) < 10; //@line 523 "compiledict.cpp"
                  var $call93=((($isdigit4))&1); //@line 523 "compiledict.cpp"
                  var $tobool94=((($call93))|0)!=0; //@line 523 "compiledict.cpp"
                  if ($tobool94) { __label__ = 37;; } else { __label__ = 38;; } //@line 523 "compiledict.cpp"
                  if (__label__ == 37) {
  
                    $multiple_numeric_hyphen=1; //@line 525 "compiledict.cpp"
                    ; //@line 526 "compiledict.cpp"
                  }
  
                  var $63=$n_flag_codes; //@line 529 "compiledict.cpp"
                  var $inc97=((($63)+1)&4294967295); //@line 529 "compiledict.cpp"
                  $n_flag_codes=$inc97; //@line 529 "compiledict.cpp"
                  var $arrayidx98=(($flag_codes+$63)&4294967295); //@line 529 "compiledict.cpp"
                  HEAP8[($arrayidx98)]=44; //@line 529 "compiledict.cpp"
                  $c=32; //@line 531 "compiledict.cpp"
                  ; //@line 532 "compiledict.cpp"
                }
              } while(0);
  
              var $64=$c; //@line 533 "compiledict.cpp"
              var $conv100=((($64))&255); //@line 533 "compiledict.cpp"
              var $call101=__Z8isspace2j($conv100); //@line 533 "compiledict.cpp"
              var $tobool102=((($call101))|0)!=0; //@line 533 "compiledict.cpp"
              if ($tobool102) { __label__ = 40;; } else { __label__ = 43;; } //@line 533 "compiledict.cpp"
              if (__label__ == 40) {
  
                var $65=$p; //@line 535 "compiledict.cpp"
                var $arrayidx104=(($65)&4294967295); //@line 535 "compiledict.cpp"
                HEAP8[($arrayidx104)]=0; //@line 535 "compiledict.cpp"
                var $66=$multiple_words; //@line 537 "compiledict.cpp"
                var $tobool105=((($66))|0)!=0; //@line 537 "compiledict.cpp"
                if ($tobool105) { __label__ = 41;; } else { __label__ = 42;; } //@line 537 "compiledict.cpp"
                if (__label__ == 41) {
  
                  var $67=$p; //@line 539 "compiledict.cpp"
                  var $add_ptr107=(($67+1)&4294967295); //@line 539 "compiledict.cpp"
                  $multiple_string_end=$add_ptr107; //@line 539 "compiledict.cpp"
                  $multiple_string=$add_ptr107; //@line 539 "compiledict.cpp"
                  $step=2; //@line 540 "compiledict.cpp"
                  ; //@line 541 "compiledict.cpp"
                }
                else if (__label__ == 42) {
  
                  $step=3; //@line 544 "compiledict.cpp"
                  ;
                }
              }
              else if (__label__ == 43) {
  
                var $68=$c; //@line 548 "compiledict.cpp"
                var $conv111=((($68))&255); //@line 548 "compiledict.cpp"
                var $cmp112=((($conv111))|0)==41; //@line 548 "compiledict.cpp"
                if (!($cmp112)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 548 "compiledict.cpp"
  
                var $69=$multiple_words; //@line 548 "compiledict.cpp"
                var $tobool114=((($69))|0)!=0; //@line 548 "compiledict.cpp"
                if (!($tobool114)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 548 "compiledict.cpp"
  
                var $70=$p; //@line 550 "compiledict.cpp"
                var $arrayidx116=(($70)&4294967295); //@line 550 "compiledict.cpp"
                HEAP8[($arrayidx116)]=0; //@line 550 "compiledict.cpp"
                $step=3; //@line 551 "compiledict.cpp"
                $multiple_words=0; //@line 552 "compiledict.cpp"
                ; //@line 553 "compiledict.cpp"
              }
            }
            else if (__label__ == 46) {
  
              var $71=$c; //@line 557 "compiledict.cpp"
              var $conv120=((($71))&255); //@line 557 "compiledict.cpp"
              var $call121=__Z8isspace2j($conv120); //@line 557 "compiledict.cpp"
              var $tobool122=((($call121))|0)!=0; //@line 557 "compiledict.cpp"
              if ($tobool122) { __label__ = 47;; } else { __label__ = 48;; } //@line 557 "compiledict.cpp"
              if (__label__ == 47) {
  
                var $72=$multiple_words; //@line 559 "compiledict.cpp"
                var $inc124=((($72)+1)&4294967295); //@line 559 "compiledict.cpp"
                $multiple_words=$inc124; //@line 559 "compiledict.cpp"
                ; //@line 560 "compiledict.cpp"
              }
              else if (__label__ == 48) {
  
                var $73=$c; //@line 562 "compiledict.cpp"
                var $conv126=((($73))&255); //@line 562 "compiledict.cpp"
                var $cmp127=((($conv126))|0)==41; //@line 562 "compiledict.cpp"
                if (!($cmp127)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 562 "compiledict.cpp"
  
                var $74=$p; //@line 564 "compiledict.cpp"
                var $arrayidx129=(($74)&4294967295); //@line 564 "compiledict.cpp"
                HEAP8[($arrayidx129)]=32; //@line 564 "compiledict.cpp"
                var $75=$p; //@line 565 "compiledict.cpp"
                var $add_ptr130=(($75+1)&4294967295); //@line 565 "compiledict.cpp"
                $multiple_string_end=$add_ptr130; //@line 565 "compiledict.cpp"
                $step=3; //@line 566 "compiledict.cpp"
                ; //@line 567 "compiledict.cpp"
              }
            }
            else if (__label__ == 50) {
  
              var $76=$c; //@line 571 "compiledict.cpp"
              var $conv134=((($76))&255); //@line 571 "compiledict.cpp"
              var $call135=__Z8isspace2j($conv134); //@line 571 "compiledict.cpp"
              var $tobool136=((($call135))|0)!=0; //@line 571 "compiledict.cpp"
              if ($tobool136) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 571 "compiledict.cpp"
  
              var $77=$p; //@line 573 "compiledict.cpp"
              $phonetic=$77; //@line 573 "compiledict.cpp"
              $step=4; //@line 574 "compiledict.cpp"
              ; //@line 575 "compiledict.cpp"
            }
            else if (__label__ == 52) {
  
              var $78=$c; //@line 579 "compiledict.cpp"
              var $conv140=((($78))&255); //@line 579 "compiledict.cpp"
              var $call141=__Z8isspace2j($conv140); //@line 579 "compiledict.cpp"
              var $tobool142=((($call141))|0)!=0; //@line 579 "compiledict.cpp"
              if (!($tobool142)) { __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb85$$sw_bb119$$sw_bb133$$sw_bb139$46; } //@line 579 "compiledict.cpp"
  
              var $79=$p; //@line 581 "compiledict.cpp"
              var $arrayidx144=(($79)&4294967295); //@line 581 "compiledict.cpp"
              HEAP8[($arrayidx144)]=0; //@line 581 "compiledict.cpp"
              $step=5; //@line 582 "compiledict.cpp"
              ; //@line 583 "compiledict.cpp"
            }
          } while(0);
  
          var $80=$p; //@line 589 "compiledict.cpp"
          var $incdec_ptr146=(($80+1)&4294967295); //@line 589 "compiledict.cpp"
          $p=$incdec_ptr146; //@line 589 "compiledict.cpp"
          var $81=$c; //@line 429 "compiledict.cpp"
          var $conv=((($81))&255); //@line 429 "compiledict.cpp"
          var $cmp1=((($conv))|0)!=10; //@line 429 "compiledict.cpp"
          if ($cmp1) { __label__ = 3;continue $while_body$6; } else { __label__ = 55;break $while_body$$while_end147$5; } //@line 429 "compiledict.cpp"
        }
      }
    } while(0);
  
    var $82=$word; //@line 592 "compiledict.cpp"
    var $arrayidx148=(($82)&4294967295); //@line 592 "compiledict.cpp"
    var $83=HEAP8[($arrayidx148)]; //@line 592 "compiledict.cpp"
    var $conv149=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 592 "compiledict.cpp"
    var $cmp150=((($conv149))|0)==0; //@line 592 "compiledict.cpp"
    if ($cmp150) { __label__ = 56;; } else { __label__ = 57;; } //@line 592 "compiledict.cpp"
    if (__label__ == 56) {
  
      $retval=0; //@line 600 "compiledict.cpp"
      ; //@line 600 "compiledict.cpp"
    }
    else if (__label__ == 57) {
  
      var $_b=HEAPU8[(__ZL9text_mode_b)];
      var $84=((($_b))&1);
      var $tobool153=((($84))|0)!=0; //@line 603 "compiledict.cpp"
      if ($tobool153) { __label__ = 58;; } else { __label__ = 59;; } //@line 603 "compiledict.cpp"
      $if_end155_thread$$if_end155$82: do { 
        if (__label__ == 58) {
  
          $text_not_phonemes=1; //@line 604 "compiledict.cpp"
          __label__ = 60;break $if_end155_thread$$if_end155$82; //@line 606 "compiledict.cpp"
        }
        else if (__label__ == 59) {
  
          var $_pr=$text_not_phonemes; //@line 606 "compiledict.cpp"
          var $tobool156=((($_pr))|0)!=0; //@line 606 "compiledict.cpp"
          if ($tobool156) { __label__ = 60;break $if_end155_thread$$if_end155$82; } //@line 606 "compiledict.cpp"
  
          var $96=$phonetic; //@line 639 "compiledict.cpp"
          var $arraydecay176=(($encoded_ph)&4294967295); //@line 639 "compiledict.cpp"
          var $arraydecay177=(($bad_phoneme)&4294967295); //@line 639 "compiledict.cpp"
          var $call178=__Z14EncodePhonemesPcS_Ph($96, $arraydecay176, $arraydecay177); //@line 639 "compiledict.cpp"
          var $arraydecay179=(($encoded_ph)&4294967295); //@line 640 "compiledict.cpp"
          var $call180=_strchr($arraydecay179, 21); //@line 640 "compiledict.cpp"
          var $cmp181=((($call180))|0)!=0; //@line 640 "compiledict.cpp"
          if ($cmp181) { __label__ = 65;; } else { __label__ = 66;; } //@line 640 "compiledict.cpp"
          if (__label__ == 65) {
  
            var $97=$n_flag_codes; //@line 642 "compiledict.cpp"
            var $inc183=((($97)+1)&4294967295); //@line 642 "compiledict.cpp"
            $n_flag_codes=$inc183; //@line 642 "compiledict.cpp"
            var $arrayidx184=(($flag_codes+$97)&4294967295); //@line 642 "compiledict.cpp"
            HEAP8[($arrayidx184)]=10; //@line 642 "compiledict.cpp"
            ; //@line 643 "compiledict.cpp"
          }
  
          var $arrayidx186=(($bad_phoneme)&4294967295); //@line 646 "compiledict.cpp"
          var $98=HEAPU8[($arrayidx186)]; //@line 646 "compiledict.cpp"
          var $conv187=((($98))&255); //@line 646 "compiledict.cpp"
          var $cmp188=((($conv187))|0)!=0; //@line 646 "compiledict.cpp"
          if (!($cmp188)) { __label__ = 68;break $if_end155_thread$$if_end155$82; } //@line 646 "compiledict.cpp"
  
          var $99=HEAP32[((__ZL5f_log)>>2)]; //@line 649 "compiledict.cpp"
          var $100=HEAP32[((__ZL7linenum)>>2)]; //@line 649 "compiledict.cpp"
          var $arrayidx190=(($bad_phoneme)&4294967295); //@line 649 "compiledict.cpp"
          var $101=HEAPU8[($arrayidx190)]; //@line 649 "compiledict.cpp"
          var $conv191=((($101))&255); //@line 649 "compiledict.cpp"
          var $arrayidx192=(($bad_phoneme)&4294967295); //@line 649 "compiledict.cpp"
          var $102=HEAPU8[($arrayidx192)]; //@line 649 "compiledict.cpp"
          var $conv193=((($102))&255); //@line 649 "compiledict.cpp"
          var $103=$word; //@line 649 "compiledict.cpp"
          var $104=$phonetic; //@line 649 "compiledict.cpp"
          var $call194=_fprintf($99, ((__str112)&4294967295), allocate([$100,0,0,0,$conv191,0,0,0,$conv193,0,0,0,$103,0,0,0,$104,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 649 "compiledict.cpp"
          var $105=HEAP32[((__ZL11error_count)>>2)]; //@line 650 "compiledict.cpp"
          var $inc195=((($105)+1)&4294967295); //@line 650 "compiledict.cpp"
          HEAP32[((__ZL11error_count)>>2)]=$inc195; //@line 650 "compiledict.cpp"
          __label__ = 68;break $if_end155_thread$$if_end155$82; //@line 651 "compiledict.cpp"
        }
      } while(0);
      $if_then157$$if_end197$90: do { 
        if (__label__ == 60) {
  
          var $85=$word; //@line 608 "compiledict.cpp"
          var $arrayidx158=(($85)&4294967295); //@line 608 "compiledict.cpp"
          var $86=HEAP8[($arrayidx158)]; //@line 608 "compiledict.cpp"
          var $conv159=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 608 "compiledict.cpp"
          var $cmp160=((($conv159))|0)==95; //@line 608 "compiledict.cpp"
          if ($cmp160) { __label__ = 61;; } else { __label__ = 63;; } //@line 608 "compiledict.cpp"
          if (__label__ == 61) {
  
            var $87=$phonetic; //@line 611 "compiledict.cpp"
            var $strlen=_strlen($87); //@line 611 "compiledict.cpp"
            var $endptr=(($87+$strlen)&4294967295); //@line 611 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = ((__str110)&4294967295);
            $dest$ = $endptr;
            $stop$ = $src$ + 2;
            if (($dest$%4) == ($src$%4) && 2 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 611 "compiledict.cpp"
            var $88=HEAP32[((_translator)>>2)]; //@line 615 "compiledict.cpp"
            var $89=$phonetic; //@line 615 "compiledict.cpp"
            var $call163=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($88, $89, 0, 0); //@line 615 "compiledict.cpp"
            $text_not_phonemes=0; //@line 616 "compiledict.cpp"
            var $arraydecay=(($encoded_ph)&4294967295); //@line 617 "compiledict.cpp"
            __Z8strncpy0PcPKci($arraydecay, ((_word_phonemes)&4294967295), 156); //@line 617 "compiledict.cpp"
            var $90=HEAP8[(((_word_phonemes)&4294967295))]; //@line 619 "compiledict.cpp"
            var $conv164=(tempInt=(($90)),(tempInt>=128?tempInt-256:tempInt)); //@line 619 "compiledict.cpp"
            var $cmp165=((($conv164))|0)==0; //@line 619 "compiledict.cpp"
            var $91=HEAP32[((__ZL21error_need_dictionary)>>2)]; //@line 619 "compiledict.cpp"
            var $cmp167=((($91))|0) < 3; //@line 619 "compiledict.cpp"
            var $or_cond=($cmp165) & ($cmp167); //@line 619 "compiledict.cpp"
            if (!($or_cond)) { __label__ = 68;break $if_then157$$if_end197$90; } //@line 619 "compiledict.cpp"
  
            var $92=HEAP32[((__ZL21error_need_dictionary)>>2)]; //@line 622 "compiledict.cpp"
            var $inc169=((($92)+1)&4294967295); //@line 622 "compiledict.cpp"
            HEAP32[((__ZL21error_need_dictionary)>>2)]=$inc169; //@line 622 "compiledict.cpp"
            var $93=HEAP32[((__ZL5f_log)>>2)]; //@line 623 "compiledict.cpp"
            var $94=HEAP32[((__ZL7linenum)>>2)]; //@line 623 "compiledict.cpp"
            var $call170=_fprintf($93, ((__str111)&4294967295), allocate([$94,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 623 "compiledict.cpp"
            ; //@line 624 "compiledict.cpp"
          }
          else if (__label__ == 63) {
  
            var $arraydecay173=(($encoded_ph)&4294967295); //@line 634 "compiledict.cpp"
            var $95=$phonetic; //@line 634 "compiledict.cpp"
            __Z8strncpy0PcPKci($arraydecay173, $95, 156); //@line 634 "compiledict.cpp"
            ;
          }
        }
      } while(0);
  
      var $106=$text_not_phonemes; //@line 654 "compiledict.cpp"
      var $107=HEAP32[((_translator)>>2)]; //@line 654 "compiledict.cpp"
      var $langopts=(($107)&4294967295); //@line 654 "compiledict.cpp"
      var $textmode=(($langopts+252)&4294967295); //@line 654 "compiledict.cpp"
      var $108=HEAP8[($textmode)]; //@line 654 "compiledict.cpp"
      var $conv198=(tempInt=(($108)),(tempInt>=128?tempInt-256:tempInt)); //@line 654 "compiledict.cpp"
      var $cmp199=((($106))|0)!=((($conv198))|0); //@line 654 "compiledict.cpp"
      if ($cmp199) { __label__ = 69;; } else { __label__ = 70;; } //@line 654 "compiledict.cpp"
      if (__label__ == 69) {
  
        var $109=$n_flag_codes; //@line 656 "compiledict.cpp"
        var $inc201=((($109)+1)&4294967295); //@line 656 "compiledict.cpp"
        $n_flag_codes=$inc201; //@line 656 "compiledict.cpp"
        var $arrayidx202=(($flag_codes+$109)&4294967295); //@line 656 "compiledict.cpp"
        HEAP8[($arrayidx202)]=29; //@line 656 "compiledict.cpp"
        ; //@line 657 "compiledict.cpp"
      }
  
      var $110=$word; //@line 660 "compiledict.cpp"
      var $call204=_sscanf($110, ((__str113)&4294967295), allocate([$wc,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 660 "compiledict.cpp"
      var $cmp205=((($call204))|0)==1; //@line 660 "compiledict.cpp"
      if ($cmp205) { __label__ = 71;; } else { __label__ = 72;; } //@line 660 "compiledict.cpp"
      $if_then206$$if_else209$100: do { 
        if (__label__ == 71) {
  
          var $111=HEAP32[(($wc)>>2)]; //@line 663 "compiledict.cpp"
          var $112=$word; //@line 663 "compiledict.cpp"
          var $call207=__Z8utf8_outjPc($111, $112); //@line 663 "compiledict.cpp"
          $ix=$call207; //@line 663 "compiledict.cpp"
          var $113=$ix; //@line 664 "compiledict.cpp"
          var $114=$word; //@line 664 "compiledict.cpp"
          var $arrayidx208=(($114+$113)&4294967295); //@line 664 "compiledict.cpp"
          HEAP8[($arrayidx208)]=0; //@line 664 "compiledict.cpp"
          ; //@line 665 "compiledict.cpp"
        }
        else if (__label__ == 72) {
  
          var $115=$word; //@line 667 "compiledict.cpp"
          var $arrayidx210=(($115)&4294967295); //@line 667 "compiledict.cpp"
          var $116=HEAP8[($arrayidx210)]; //@line 667 "compiledict.cpp"
          var $conv211=(tempInt=(($116)),(tempInt>=128?tempInt-256:tempInt)); //@line 667 "compiledict.cpp"
          var $cmp212=((($conv211))|0)!=95; //@line 667 "compiledict.cpp"
          if (!($cmp212)) { __label__ = 80;break $if_then206$$if_else209$100; } //@line 667 "compiledict.cpp"
  
          $all_upper_case=1; //@line 672 "compiledict.cpp"
          var $117=$word; //@line 673 "compiledict.cpp"
          $p=$117; //@line 673 "compiledict.cpp"
          var $118=$word; //@line 674 "compiledict.cpp"
          $p=$118; //@line 674 "compiledict.cpp"
          var $119=$p; //@line 678 "compiledict.cpp"
          var $call2146=__Z7utf8_inPiPKc($c2, $119); //@line 678 "compiledict.cpp"
          $ix=$call2146; //@line 678 "compiledict.cpp"
          var $120=HEAP32[(($c2)>>2)]; //@line 679 "compiledict.cpp"
          var $cmp2157=((($120))|0)==0; //@line 679 "compiledict.cpp"
          if ($cmp2157) { __label__ = 78;; } else { __label__ = 74;; } //@line 679 "compiledict.cpp"
          $for_end$$if_end217$104: do { 
            if (__label__ == 74) {
              while(1) { 
  
                var $121=HEAP32[(($c2)>>2)]; //@line 681 "compiledict.cpp"
                var $call218=_iswupper($121); //@line 681 "compiledict.cpp"
                var $tobool219=((($call218))|0)!=0; //@line 681 "compiledict.cpp"
                if ($tobool219) { __label__ = 75;; } else { __label__ = 76;; } //@line 681 "compiledict.cpp"
                if (__label__ == 75) {
  
                  var $122=HEAP32[(($c2)>>2)]; //@line 683 "compiledict.cpp"
                  var $call221=_towlower($122); //@line 683 "compiledict.cpp"
                  var $123=$p; //@line 683 "compiledict.cpp"
                  var $call222=__Z8utf8_outjPc($call221, $123); //@line 683 "compiledict.cpp"
                  ; //@line 684 "compiledict.cpp"
                }
                else if (__label__ == 76) {
  
                  $all_upper_case=0; //@line 687 "compiledict.cpp"
                  ;
                }
  
                var $124=$ix; //@line 689 "compiledict.cpp"
                var $125=$p; //@line 689 "compiledict.cpp"
                var $add_ptr225=(($125+$124)&4294967295); //@line 689 "compiledict.cpp"
                $p=$add_ptr225; //@line 689 "compiledict.cpp"
                var $126=$p; //@line 678 "compiledict.cpp"
                var $call214=__Z7utf8_inPiPKc($c2, $126); //@line 678 "compiledict.cpp"
                $ix=$call214; //@line 678 "compiledict.cpp"
                var $127=HEAP32[(($c2)>>2)]; //@line 679 "compiledict.cpp"
                var $cmp215=((($127))|0)==0; //@line 679 "compiledict.cpp"
                if ($cmp215) { __label__ = 78;break $for_end$$if_end217$104; } else { __label__ = 74;continue ; } //@line 679 "compiledict.cpp"
              }
            }
          } while(0);
  
          var $128=$all_upper_case; //@line 691 "compiledict.cpp"
          var $tobool226=((($128))|0)!=0; //@line 691 "compiledict.cpp"
          if (!($tobool226)) { __label__ = 80;break $if_then206$$if_else209$100; } //@line 691 "compiledict.cpp"
  
          var $129=$n_flag_codes; //@line 693 "compiledict.cpp"
          var $inc228=((($129)+1)&4294967295); //@line 693 "compiledict.cpp"
          $n_flag_codes=$inc228; //@line 693 "compiledict.cpp"
          var $arrayidx229=(($flag_codes+$129)&4294967295); //@line 693 "compiledict.cpp"
          HEAP8[($arrayidx229)]=42; //@line 693 "compiledict.cpp"
          ; //@line 694 "compiledict.cpp"
        }
      } while(0);
  
      var $130=$word; //@line 697 "compiledict.cpp"
      var $call233=_strlen($130); //@line 697 "compiledict.cpp"
      $len_word=$call233; //@line 697 "compiledict.cpp"
      var $131=HEAP32[((_translator)>>2)]; //@line 699 "compiledict.cpp"
      var $transpose_min=(($131+288)&4294967295); //@line 699 "compiledict.cpp"
      var $132=HEAP32[(($transpose_min)>>2)]; //@line 699 "compiledict.cpp"
      var $cmp234=((($132))|0) > 0; //@line 699 "compiledict.cpp"
      if ($cmp234) { __label__ = 81;; } else { __label__ = 82;; } //@line 699 "compiledict.cpp"
      if (__label__ == 81) {
  
        var $133=HEAP32[((_translator)>>2)]; //@line 701 "compiledict.cpp"
        var $134=$word; //@line 701 "compiledict.cpp"
        var $call236=__Z17TransposeAlphabetP10TranslatorPc($133, $134); //@line 701 "compiledict.cpp"
        $len_word=$call236; //@line 701 "compiledict.cpp"
        ; //@line 702 "compiledict.cpp"
      }
  
      var $135=$word; //@line 704 "compiledict.cpp"
      var $call238=__Z14HashDictionaryPKc($135); //@line 704 "compiledict.cpp"
      var $136=$hash_addr; //@line 704 "compiledict.cpp"
      HEAP32[(($136)>>2)]=$call238; //@line 704 "compiledict.cpp"
      var $arraydecay239=(($encoded_ph)&4294967295); //@line 705 "compiledict.cpp"
      var $call240=_strlen($arraydecay239); //@line 705 "compiledict.cpp"
      $len_phonetic=$call240; //@line 705 "compiledict.cpp"
      var $137=$len_word; //@line 707 "compiledict.cpp"
      var $conv241=((($137)) & 255); //@line 707 "compiledict.cpp"
      var $138=$dict_line_addr; //@line 707 "compiledict.cpp"
      var $arrayidx242=(($138+1)&4294967295); //@line 707 "compiledict.cpp"
      HEAP8[($arrayidx242)]=$conv241; //@line 707 "compiledict.cpp"
      var $139=$len_word; //@line 708 "compiledict.cpp"
      var $and=($139) & 63; //@line 708 "compiledict.cpp"
      $len_word=$and; //@line 708 "compiledict.cpp"
      var $140=$dict_line_addr; //@line 710 "compiledict.cpp"
      var $arrayidx243=(($140+2)&4294967295); //@line 710 "compiledict.cpp"
      var $141=$word; //@line 710 "compiledict.cpp"
      var $142=$len_word; //@line 710 "compiledict.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $141;
      $dest$ = $arrayidx243;
      $stop$ = $src$ + $142;
      if (($dest$%4) == ($src$%4) && $142 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 710 "compiledict.cpp"
      var $143=$len_phonetic; //@line 712 "compiledict.cpp"
      var $cmp244=((($143))|0)==0; //@line 712 "compiledict.cpp"
      if ($cmp244) { __label__ = 83;; } else { __label__ = 84;; } //@line 712 "compiledict.cpp"
      if (__label__ == 83) {
  
        var $144=$dict_line_addr; //@line 715 "compiledict.cpp"
        var $arrayidx246=(($144+1)&4294967295); //@line 715 "compiledict.cpp"
        var $145=HEAP8[($arrayidx246)]; //@line 715 "compiledict.cpp"
        var $conv247=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 715 "compiledict.cpp"
        var $or=($conv247) | 128; //@line 715 "compiledict.cpp"
        var $conv248=((($or)) & 255); //@line 715 "compiledict.cpp"
        HEAP8[($arrayidx246)]=$conv248; //@line 715 "compiledict.cpp"
        var $146=$len_word; //@line 716 "compiledict.cpp"
        var $add249=((($146)+2)&4294967295); //@line 716 "compiledict.cpp"
        $length=$add249; //@line 716 "compiledict.cpp"
        ; //@line 717 "compiledict.cpp"
      }
      else if (__label__ == 84) {
  
        var $147=$len_word; //@line 720 "compiledict.cpp"
        var $148=$len_phonetic; //@line 720 "compiledict.cpp"
        var $add251=((($147)+3)&4294967295); //@line 720 "compiledict.cpp"
        var $add252=((($add251)+($148))&4294967295); //@line 720 "compiledict.cpp"
        $length=$add252; //@line 720 "compiledict.cpp"
        var $149=$len_word; //@line 721 "compiledict.cpp"
        var $add253=((($149)+2)&4294967295); //@line 721 "compiledict.cpp"
        var $150=$dict_line_addr; //@line 721 "compiledict.cpp"
        var $arrayidx254=(($150+$add253)&4294967295); //@line 721 "compiledict.cpp"
        var $arraydecay255=(($encoded_ph)&4294967295); //@line 721 "compiledict.cpp"
        var $call256=_strcpy($arrayidx254, $arraydecay255); //@line 721 "compiledict.cpp"
        ;
      }
  
      $ix=0; //@line 724 "compiledict.cpp"
      var $151=$ix; //@line 724 "compiledict.cpp"
      var $152=$n_flag_codes; //@line 724 "compiledict.cpp"
      var $cmp2598=((($151))>>>0) < ((($152))>>>0); //@line 724 "compiledict.cpp"
      if ($cmp2598) { __label__ = 86;; } else { __label__ = 87;; } //@line 724 "compiledict.cpp"
      $for_body$$for_end264$121: do { 
        if (__label__ == 86) {
          while(1) { 
  
            var $153=$ix; //@line 726 "compiledict.cpp"
            var $arrayidx260=(($flag_codes+$153)&4294967295); //@line 726 "compiledict.cpp"
            var $154=HEAP8[($arrayidx260)]; //@line 726 "compiledict.cpp"
            var $155=$ix; //@line 726 "compiledict.cpp"
            var $156=$length; //@line 726 "compiledict.cpp"
            var $add261=((($156)+($155))&4294967295); //@line 726 "compiledict.cpp"
            var $157=$dict_line_addr; //@line 726 "compiledict.cpp"
            var $arrayidx262=(($157+$add261)&4294967295); //@line 726 "compiledict.cpp"
            HEAP8[($arrayidx262)]=$154; //@line 726 "compiledict.cpp"
            var $158=$ix; //@line 724 "compiledict.cpp"
            var $inc263=((($158)+1)&4294967295); //@line 724 "compiledict.cpp"
            $ix=$inc263; //@line 724 "compiledict.cpp"
            var $159=$ix; //@line 724 "compiledict.cpp"
            var $160=$n_flag_codes; //@line 724 "compiledict.cpp"
            var $cmp259=((($159))>>>0) < ((($160))>>>0); //@line 724 "compiledict.cpp"
            if ($cmp259) { __label__ = 86;continue ; } else { __label__ = 87;break $for_body$$for_end264$121; } //@line 724 "compiledict.cpp"
          }
        }
      } while(0);
  
      var $161=$n_flag_codes; //@line 728 "compiledict.cpp"
      var $162=$length; //@line 728 "compiledict.cpp"
      var $add265=((($162)+($161))&4294967295); //@line 728 "compiledict.cpp"
      $length=$add265; //@line 728 "compiledict.cpp"
      var $163=$multiple_string; //@line 730 "compiledict.cpp"
      var $cmp266=((($163))|0)!=0; //@line 730 "compiledict.cpp"
      if ($cmp266) { __label__ = 88;; } else { __label__ = 94;; } //@line 730 "compiledict.cpp"
      $land_lhs_true267$$if_end286$125: do { 
        if (__label__ == 88) {
  
          var $164=$multiple_words; //@line 730 "compiledict.cpp"
          var $cmp268=((($164))|0) > 0; //@line 730 "compiledict.cpp"
          if (!($cmp268)) { __label__ = 94;break $land_lhs_true267$$if_end286$125; } //@line 730 "compiledict.cpp"
  
          var $165=$multiple_words; //@line 732 "compiledict.cpp"
          var $cmp270=((($165))|0) > 10; //@line 732 "compiledict.cpp"
          if ($cmp270) { __label__ = 90;; } else { __label__ = 91;; } //@line 732 "compiledict.cpp"
          if (__label__ == 90) {
  
            var $166=HEAP32[((__ZL5f_log)>>2)]; //@line 734 "compiledict.cpp"
            var $167=HEAP32[((__ZL7linenum)>>2)]; //@line 734 "compiledict.cpp"
            var $168=$multiple_words; //@line 734 "compiledict.cpp"
            var $call272=_fprintf($166, ((__str114)&4294967295), allocate([$167,0,0,0,$168,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 734 "compiledict.cpp"
            ; //@line 735 "compiledict.cpp"
          }
          else if (__label__ == 91) {
  
            var $169=$multiple_words; //@line 738 "compiledict.cpp"
            var $add274=((($169)+80)&4294967295); //@line 738 "compiledict.cpp"
            var $conv275=((($add274)) & 255); //@line 738 "compiledict.cpp"
            var $170=$length; //@line 738 "compiledict.cpp"
            var $inc276=((($170)+1)&4294967295); //@line 738 "compiledict.cpp"
            $length=$inc276; //@line 738 "compiledict.cpp"
            var $171=$dict_line_addr; //@line 738 "compiledict.cpp"
            var $arrayidx277=(($171+$170)&4294967295); //@line 738 "compiledict.cpp"
            HEAP8[($arrayidx277)]=$conv275; //@line 738 "compiledict.cpp"
            var $172=$multiple_string_end; //@line 739 "compiledict.cpp"
            var $173=$multiple_string; //@line 739 "compiledict.cpp"
            var $sub_ptr_lhs_cast=($172); //@line 739 "compiledict.cpp"
            var $sub_ptr_rhs_cast=($173); //@line 739 "compiledict.cpp"
            var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 739 "compiledict.cpp"
            $ix=$sub_ptr_sub; //@line 739 "compiledict.cpp"
            var $174=$multiple_numeric_hyphen; //@line 740 "compiledict.cpp"
            var $tobool278=((($174))|0)!=0; //@line 740 "compiledict.cpp"
            if ($tobool278) { __label__ = 92;; } else { __label__ = 93;; } //@line 740 "compiledict.cpp"
            if (__label__ == 92) {
  
              var $175=$length; //@line 742 "compiledict.cpp"
              var $inc280=((($175)+1)&4294967295); //@line 742 "compiledict.cpp"
              $length=$inc280; //@line 742 "compiledict.cpp"
              var $176=$dict_line_addr; //@line 742 "compiledict.cpp"
              var $arrayidx281=(($176+$175)&4294967295); //@line 742 "compiledict.cpp"
              HEAP8[($arrayidx281)]=32; //@line 742 "compiledict.cpp"
              ; //@line 743 "compiledict.cpp"
            }
  
            var $177=$length; //@line 744 "compiledict.cpp"
            var $178=$dict_line_addr; //@line 744 "compiledict.cpp"
            var $arrayidx283=(($178+$177)&4294967295); //@line 744 "compiledict.cpp"
            var $179=$multiple_string; //@line 744 "compiledict.cpp"
            var $180=$ix; //@line 744 "compiledict.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $179;
            $dest$ = $arrayidx283;
            $stop$ = $src$ + $180;
            if (($dest$%4) == ($src$%4) && $180 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 744 "compiledict.cpp"
            var $181=$ix; //@line 745 "compiledict.cpp"
            var $182=$length; //@line 745 "compiledict.cpp"
            var $add284=((($182)+($181))&4294967295); //@line 745 "compiledict.cpp"
            $length=$add284; //@line 745 "compiledict.cpp"
            ;
          }
        }
      } while(0);
  
      var $183=$length; //@line 748 "compiledict.cpp"
      var $conv287=((($183)) & 255); //@line 748 "compiledict.cpp"
      var $184=$dict_line_addr; //@line 748 "compiledict.cpp"
      var $arrayidx288=(($184)&4294967295); //@line 748 "compiledict.cpp"
      HEAP8[($arrayidx288)]=$conv287; //@line 748 "compiledict.cpp"
      var $185=$length; //@line 780 "compiledict.cpp"
      $retval=$185; //@line 780 "compiledict.cpp"
      ; //@line 780 "compiledict.cpp"
    }
  
    var $186=$retval; //@line 781 "compiledict.cpp"
    STACKTOP = __stackBase__;
    return $186; //@line 781 "compiledict.cpp"
    return null;
  }
  

  function __Z8strncpy0PcPKci($to, $from, $size) {
    ;
    var __label__;
  
    var $to_addr;
    var $from_addr;
    var $size_addr;
    $to_addr=$to;
    $from_addr=$from;
    $size_addr=$size;
    var $0=$to_addr; //@line 87 "dictionary.cpp"
    var $1=$from_addr; //@line 87 "dictionary.cpp"
    var $2=$size_addr; //@line 87 "dictionary.cpp"
    var $call=_strncpy($0, $1, $2); //@line 87 "dictionary.cpp"
    var $3=$size_addr; //@line 88 "dictionary.cpp"
    var $sub=((($3)-1)&4294967295); //@line 88 "dictionary.cpp"
    var $4=$to_addr; //@line 88 "dictionary.cpp"
    var $arrayidx=(($4+$sub)&4294967295); //@line 88 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 88 "dictionary.cpp"
    ;
    return; //@line 89 "dictionary.cpp"
    return;
  }
  

  function __Z13Reverse4Bytesi($word) {
    ;
    var __label__;
  
    var $word_addr;
    $word_addr=$word;
    var $0=$word_addr; //@line 106 "dictionary.cpp"
    ;
    return $0; //@line 106 "dictionary.cpp"
    return null;
  }
  

  function __Z10LookupMnemP8MNEM_TABPKc($table, $string) {
    ;
    var __label__;
  
    var $retval;
    var $table_addr;
    var $string_addr;
    $table_addr=$table;
    $string_addr=$string;
    ; //@line 113 "dictionary.cpp"
    while(1) { 
  
      var $0=$table_addr; //@line 113 "dictionary.cpp"
      var $mnem=(($0)&4294967295); //@line 113 "dictionary.cpp"
      var $1=HEAP32[(($mnem)>>2)]; //@line 113 "dictionary.cpp"
      var $cmp=((($1))|0)!=0; //@line 113 "dictionary.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 113 "dictionary.cpp"
  
      var $2=$string_addr; //@line 115 "dictionary.cpp"
      var $3=$table_addr; //@line 115 "dictionary.cpp"
      var $mnem1=(($3)&4294967295); //@line 115 "dictionary.cpp"
      var $4=HEAP32[(($mnem1)>>2)]; //@line 115 "dictionary.cpp"
      var $call=_strcmp($2, $4); //@line 115 "dictionary.cpp"
      var $cmp2=((($call))|0)==0; //@line 115 "dictionary.cpp"
      var $5=$table_addr; //@line 116 "dictionary.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 115 "dictionary.cpp"
  
      var $incdec_ptr=(($5+8)&4294967295); //@line 117 "dictionary.cpp"
      $table_addr=$incdec_ptr; //@line 117 "dictionary.cpp"
      __label__ = 1;continue ; //@line 118 "dictionary.cpp"
    }
    if (__label__ == 5) {
  
      var $7=$table_addr; //@line 119 "dictionary.cpp"
      var $value3=(($7+4)&4294967295); //@line 119 "dictionary.cpp"
      var $8=HEAP32[(($value3)>>2)]; //@line 119 "dictionary.cpp"
      $retval=$8; //@line 119 "dictionary.cpp"
      ; //@line 119 "dictionary.cpp"
    }
    else if (__label__ == 3) {
  
      var $value=(($5+4)&4294967295); //@line 116 "dictionary.cpp"
      var $6=HEAP32[(($value)>>2)]; //@line 116 "dictionary.cpp"
      $retval=$6; //@line 116 "dictionary.cpp"
      ; //@line 116 "dictionary.cpp"
    }
  
    var $9=$retval; //@line 120 "dictionary.cpp"
    ;
    return $9; //@line 120 "dictionary.cpp"
    return null;
  }
  

  function __Z14LoadDictionaryP10TranslatorPKci($tr, $name, $no_error) {
    var __stackBase__  = STACKTOP; STACKTOP += 172; _memset(__stackBase__, 0, 172);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $name_addr;
    var $no_error_addr;
    var $hash;
    var $p;
    var $pw;
    var $length;
    var $f;
    var $size;
    var $fname=__stackBase__;
    $tr_addr=$tr;
    $name_addr=$name;
    $no_error_addr=$no_error;
    var $0=$name_addr; //@line 250 "dictionary.cpp"
    var $call=_strcpy(((_dictionary_name)&4294967295), $0); //@line 250 "dictionary.cpp"
    var $1=$tr_addr; //@line 251 "dictionary.cpp"
    var $dictionary_name=(($1+292)&4294967295); //@line 251 "dictionary.cpp"
    var $arraydecay=(($dictionary_name)&4294967295); //@line 251 "dictionary.cpp"
    var $2=$name_addr; //@line 251 "dictionary.cpp"
    var $call1=_strcpy($arraydecay, $2); //@line 251 "dictionary.cpp"
    var $arraydecay2=(($fname)&4294967295); //@line 256 "dictionary.cpp"
    var $3=$name_addr; //@line 256 "dictionary.cpp"
    var $call3=_sprintf($arraydecay2, ((__str116)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,$3,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 256 "dictionary.cpp"
    var $arraydecay4=(($fname)&4294967295); //@line 257 "dictionary.cpp"
    var $call5=__Z13GetFileLengthPKc($arraydecay4); //@line 257 "dictionary.cpp"
    $size=$call5; //@line 257 "dictionary.cpp"
    var $4=$tr_addr; //@line 259 "dictionary.cpp"
    var $data_dictlist=(($4+1052)&4294967295); //@line 259 "dictionary.cpp"
    var $5=HEAP32[(($data_dictlist)>>2)]; //@line 259 "dictionary.cpp"
    var $cmp=((($5))|0)!=0; //@line 259 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 259 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $6=$tr_addr; //@line 261 "dictionary.cpp"
      var $data_dictlist6=(($6+1052)&4294967295); //@line 261 "dictionary.cpp"
      var $7=HEAP32[(($data_dictlist6)>>2)]; //@line 261 "dictionary.cpp"
      __Z4FreePv($7); //@line 261 "dictionary.cpp"
      var $8=$tr_addr; //@line 262 "dictionary.cpp"
      var $data_dictlist7=(($8+1052)&4294967295); //@line 262 "dictionary.cpp"
      HEAP32[(($data_dictlist7)>>2)]=0; //@line 262 "dictionary.cpp"
      ; //@line 263 "dictionary.cpp"
    }
  
    var $arraydecay8=(($fname)&4294967295); //@line 265 "dictionary.cpp"
    var $call9=_fopen($arraydecay8, ((__str18429)&4294967295)); //@line 265 "dictionary.cpp"
    $f=$call9; //@line 265 "dictionary.cpp"
    var $cmp10=((($call9))|0)==0; //@line 266 "dictionary.cpp"
    if ($cmp10) { __label__ = 4;; } else { __label__ = 3;; } //@line 266 "dictionary.cpp"
    $if_then12$$lor_lhs_false$5: do { 
      if (__label__ == 3) {
  
        var $9=$size; //@line 266 "dictionary.cpp"
        var $cmp11=((($9))>>>0) <= 0; //@line 266 "dictionary.cpp"
        if ($cmp11) { __label__ = 4;break $if_then12$$lor_lhs_false$5; } //@line 266 "dictionary.cpp"
  
        var $13=$size; //@line 275 "dictionary.cpp"
        var $call19=__Z5Alloci($13); //@line 275 "dictionary.cpp"
        var $14=$tr_addr; //@line 275 "dictionary.cpp"
        var $data_dictlist20=(($14+1052)&4294967295); //@line 275 "dictionary.cpp"
        HEAP32[(($data_dictlist20)>>2)]=$call19; //@line 275 "dictionary.cpp"
        var $15=$tr_addr; //@line 276 "dictionary.cpp"
        var $data_dictlist21=(($15+1052)&4294967295); //@line 276 "dictionary.cpp"
        var $16=HEAP32[(($data_dictlist21)>>2)]; //@line 276 "dictionary.cpp"
        var $17=$size; //@line 276 "dictionary.cpp"
        var $18=$f; //@line 276 "dictionary.cpp"
        var $call22=_fread($16, 1, $17, $18); //@line 276 "dictionary.cpp"
        $size=$call22; //@line 276 "dictionary.cpp"
        var $19=$f; //@line 277 "dictionary.cpp"
        var $call23=_fclose($19); //@line 277 "dictionary.cpp"
        var $20=$tr_addr; //@line 280 "dictionary.cpp"
        var $data_dictlist24=(($20+1052)&4294967295); //@line 280 "dictionary.cpp"
        var $21=HEAP32[(($data_dictlist24)>>2)]; //@line 280 "dictionary.cpp"
        var $22=$21; //@line 280 "dictionary.cpp"
        $pw=$22; //@line 280 "dictionary.cpp"
        var $23=$pw; //@line 281 "dictionary.cpp"
        var $arrayidx=(($23+4)&4294967295); //@line 281 "dictionary.cpp"
        var $24=HEAP32[(($arrayidx)>>2)]; //@line 281 "dictionary.cpp"
        var $call25=__Z13Reverse4Bytesi($24); //@line 281 "dictionary.cpp"
        $length=$call25; //@line 281 "dictionary.cpp"
        var $25=$size; //@line 283 "dictionary.cpp"
        var $cmp26=((($25))>>>0) <= 1032; //@line 283 "dictionary.cpp"
        if ($cmp26) { __label__ = 8;; } else { __label__ = 9;; } //@line 283 "dictionary.cpp"
        if (__label__ == 8) {
  
          var $26=HEAP32[((__impure_ptr)>>2)]; //@line 285 "dictionary.cpp"
          var $_stderr28=(($26+12)&4294967295); //@line 285 "dictionary.cpp"
          var $27=HEAP32[(($_stderr28)>>2)]; //@line 285 "dictionary.cpp"
          var $arraydecay29=(($fname)&4294967295); //@line 285 "dictionary.cpp"
          var $call30=_fprintf($27, ((__str3119)&4294967295), allocate([$arraydecay29,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 285 "dictionary.cpp"
          $retval=2; //@line 286 "dictionary.cpp"
          __label__ = 19;break $if_then12$$lor_lhs_false$5; //@line 286 "dictionary.cpp"
        }
        else if (__label__ == 9) {
  
          var $28=$pw; //@line 289 "dictionary.cpp"
          var $arrayidx32=(($28)&4294967295); //@line 289 "dictionary.cpp"
          var $29=HEAP32[(($arrayidx32)>>2)]; //@line 289 "dictionary.cpp"
          var $call33=__Z13Reverse4Bytesi($29); //@line 289 "dictionary.cpp"
          var $cmp34=((($call33))|0)!=1024; //@line 289 "dictionary.cpp"
          if ($cmp34) { __label__ = 11;; } else { __label__ = 10;; } //@line 289 "dictionary.cpp"
          $if_then39$$lor_lhs_false35$11: do { 
            if (__label__ == 10) {
  
              var $30=$length; //@line 289 "dictionary.cpp"
              var $cmp36=((($30))|0) <= 0; //@line 289 "dictionary.cpp"
              var $31=$length; //@line 289 "dictionary.cpp"
              var $cmp38=((($31))|0) > 134217728; //@line 289 "dictionary.cpp"
              var $or_cond=($cmp36) | ($cmp38); //@line 289 "dictionary.cpp"
              if ($or_cond) { __label__ = 11;break $if_then39$$lor_lhs_false35$11; } //@line 289 "dictionary.cpp"
  
              var $37=$length; //@line 295 "dictionary.cpp"
              var $38=$tr_addr; //@line 295 "dictionary.cpp"
              var $data_dictlist46=(($38+1052)&4294967295); //@line 295 "dictionary.cpp"
              var $39=HEAP32[(($data_dictlist46)>>2)]; //@line 295 "dictionary.cpp"
              var $arrayidx47=(($39+$37)&4294967295); //@line 295 "dictionary.cpp"
              var $40=$tr_addr; //@line 295 "dictionary.cpp"
              var $data_dictrules=(($40+1048)&4294967295); //@line 295 "dictionary.cpp"
              HEAP32[(($data_dictrules)>>2)]=$arrayidx47; //@line 295 "dictionary.cpp"
              var $41=$tr_addr; //@line 298 "dictionary.cpp"
              __ZL10InitGroupsP10Translator($41); //@line 298 "dictionary.cpp"
              var $42=$tr_addr; //@line 299 "dictionary.cpp"
              var $groups1=(($42+5256)&4294967295); //@line 299 "dictionary.cpp"
              var $arrayidx48=(($groups1)&4294967295); //@line 299 "dictionary.cpp"
              var $43=HEAP32[(($arrayidx48)>>2)]; //@line 299 "dictionary.cpp"
              var $cmp49=((($43))|0)==0; //@line 299 "dictionary.cpp"
              if ($cmp49) { __label__ = 13;; } else { __label__ = 14;; } //@line 299 "dictionary.cpp"
              if (__label__ == 13) {
  
                var $44=HEAP32[((__impure_ptr)>>2)]; //@line 301 "dictionary.cpp"
                var $_stderr51=(($44+12)&4294967295); //@line 301 "dictionary.cpp"
                var $45=HEAP32[(($_stderr51)>>2)]; //@line 301 "dictionary.cpp"
                var $46=$name_addr; //@line 301 "dictionary.cpp"
                var $call52=_fprintf($45, ((__str5121)&4294967295), allocate([$46,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 301 "dictionary.cpp"
                ; //@line 302 "dictionary.cpp"
              }
  
              var $47=$tr_addr; //@line 305 "dictionary.cpp"
              var $data_dictlist54=(($47+1052)&4294967295); //@line 305 "dictionary.cpp"
              var $48=HEAP32[(($data_dictlist54)>>2)]; //@line 305 "dictionary.cpp"
              var $arrayidx55=(($48+8)&4294967295); //@line 305 "dictionary.cpp"
              $p=$arrayidx55; //@line 305 "dictionary.cpp"
              $hash=0; //@line 307 "dictionary.cpp"
              ; //@line 307 "dictionary.cpp"
              $for_body$17: while(1) { 
  
                var $49=$p; //@line 309 "dictionary.cpp"
                var $50=$hash; //@line 309 "dictionary.cpp"
                var $51=$tr_addr; //@line 309 "dictionary.cpp"
                var $dict_hashtab=(($51+1056)&4294967295); //@line 309 "dictionary.cpp"
                var $arrayidx57=(($dict_hashtab+$50*4)&4294967295); //@line 309 "dictionary.cpp"
                HEAP32[(($arrayidx57)>>2)]=$49; //@line 309 "dictionary.cpp"
                var $52=$p; //@line 310 "dictionary.cpp"
                var $53=HEAP8[($52)]; //@line 310 "dictionary.cpp"
                var $conv1=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 310 "dictionary.cpp"
                $length=$conv1; //@line 310 "dictionary.cpp"
                var $cmp582=((($conv1))|0)!=0; //@line 310 "dictionary.cpp"
                if ($cmp582) { __label__ = 16;; } else { __label__ = 17;; } //@line 310 "dictionary.cpp"
                $while_body$$while_end$19: do { 
                  if (__label__ == 16) {
                    while(1) { 
  
                      var $54=$length; //@line 312 "dictionary.cpp"
                      var $55=$p; //@line 312 "dictionary.cpp"
                      var $add_ptr=(($55+$54)&4294967295); //@line 312 "dictionary.cpp"
                      $p=$add_ptr; //@line 312 "dictionary.cpp"
                      var $56=$p; //@line 310 "dictionary.cpp"
                      var $57=HEAP8[($56)]; //@line 310 "dictionary.cpp"
                      var $conv=(tempInt=(($57)),(tempInt>=128?tempInt-256:tempInt)); //@line 310 "dictionary.cpp"
                      $length=$conv; //@line 310 "dictionary.cpp"
                      var $cmp58=((($conv))|0)!=0; //@line 310 "dictionary.cpp"
                      if ($cmp58) { __label__ = 16;continue ; } else { __label__ = 17;break $while_body$$while_end$19; } //@line 310 "dictionary.cpp"
                    }
                  }
                } while(0);
  
                var $58=$p; //@line 314 "dictionary.cpp"
                var $incdec_ptr=(($58+1)&4294967295); //@line 314 "dictionary.cpp"
                $p=$incdec_ptr; //@line 314 "dictionary.cpp"
                var $59=$hash; //@line 307 "dictionary.cpp"
                var $inc=((($59)+1)&4294967295); //@line 307 "dictionary.cpp"
                $hash=$inc; //@line 307 "dictionary.cpp"
                var $cmp56=((($inc))|0) < 1024; //@line 307 "dictionary.cpp"
                if ($cmp56) { __label__ = 15;continue $for_body$17; } else { __label__ = 18;break $for_body$17; } //@line 307 "dictionary.cpp"
              }
  
              $retval=0; //@line 317 "dictionary.cpp"
              __label__ = 19;break $if_then12$$lor_lhs_false$5; //@line 317 "dictionary.cpp"
            }
          } while(0);
  
          var $32=HEAP32[((__impure_ptr)>>2)]; //@line 292 "dictionary.cpp"
          var $_stderr40=(($32+12)&4294967295); //@line 292 "dictionary.cpp"
          var $33=HEAP32[(($_stderr40)>>2)]; //@line 292 "dictionary.cpp"
          var $arraydecay41=(($fname)&4294967295); //@line 292 "dictionary.cpp"
          var $34=$pw; //@line 292 "dictionary.cpp"
          var $arrayidx42=(($34)&4294967295); //@line 292 "dictionary.cpp"
          var $35=HEAP32[(($arrayidx42)>>2)]; //@line 292 "dictionary.cpp"
          var $call43=__Z13Reverse4Bytesi($35); //@line 292 "dictionary.cpp"
          var $36=$length; //@line 292 "dictionary.cpp"
          var $call44=_fprintf($33, ((__str4120)&4294967295), allocate([$arraydecay41,0,0,0,$call43,0,0,0,$36,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 292 "dictionary.cpp"
          $retval=2; //@line 293 "dictionary.cpp"
          __label__ = 19;break $if_then12$$lor_lhs_false$5; //@line 293 "dictionary.cpp"
        }
      }
    } while(0);
    if (__label__ == 4) {
  
      var $10=$no_error_addr; //@line 268 "dictionary.cpp"
      var $cmp13=((($10))|0)==0; //@line 268 "dictionary.cpp"
      if ($cmp13) { __label__ = 5;; } else { __label__ = 6;; } //@line 268 "dictionary.cpp"
      if (__label__ == 5) {
  
        var $11=HEAP32[((__impure_ptr)>>2)]; //@line 270 "dictionary.cpp"
        var $_stderr=(($11+12)&4294967295); //@line 270 "dictionary.cpp"
        var $12=HEAP32[(($_stderr)>>2)]; //@line 270 "dictionary.cpp"
        var $arraydecay15=(($fname)&4294967295); //@line 270 "dictionary.cpp"
        var $call16=_fprintf($12, ((__str2118)&4294967295), allocate([$arraydecay15,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 270 "dictionary.cpp"
        ; //@line 271 "dictionary.cpp"
      }
  
      $retval=1; //@line 272 "dictionary.cpp"
      ; //@line 272 "dictionary.cpp"
    }
  
    var $60=$retval; //@line 318 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $60; //@line 318 "dictionary.cpp"
    return null;
  }
  

  function __ZL10InitGroupsP10Translator($tr) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $ix;
    var $p;
    var $p_name;
    var $pw;
    var $c;
    var $c2;
    var $len;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 142 "dictionary.cpp"
    var $n_groups2=(($0+7752)&4294967295); //@line 142 "dictionary.cpp"
    HEAP32[(($n_groups2)>>2)]=0; //@line 142 "dictionary.cpp"
    $ix=0; //@line 143 "dictionary.cpp"
    ; //@line 143 "dictionary.cpp"
    $for_body$2: while(1) { 
  
      var $1=$ix; //@line 145 "dictionary.cpp"
      var $2=$tr_addr; //@line 145 "dictionary.cpp"
      var $groups1=(($2+5256)&4294967295); //@line 145 "dictionary.cpp"
      var $arrayidx=(($groups1+$1*4)&4294967295); //@line 145 "dictionary.cpp"
      HEAP32[(($arrayidx)>>2)]=0; //@line 145 "dictionary.cpp"
      var $3=$ix; //@line 146 "dictionary.cpp"
      var $4=$tr_addr; //@line 146 "dictionary.cpp"
      var $groups2_count=(($4+7756)&4294967295); //@line 146 "dictionary.cpp"
      var $arrayidx1=(($groups2_count+$3)&4294967295); //@line 146 "dictionary.cpp"
      HEAP8[($arrayidx1)]=0; //@line 146 "dictionary.cpp"
      var $5=$ix; //@line 147 "dictionary.cpp"
      var $6=$tr_addr; //@line 147 "dictionary.cpp"
      var $groups2_start=(($6+8012)&4294967295); //@line 147 "dictionary.cpp"
      var $arrayidx2=(($groups2_start+$5)&4294967295); //@line 147 "dictionary.cpp"
      HEAP8[($arrayidx2)]=-1; //@line 147 "dictionary.cpp"
      var $7=$ix; //@line 143 "dictionary.cpp"
      var $inc=((($7)+1)&4294967295); //@line 143 "dictionary.cpp"
      $ix=$inc; //@line 143 "dictionary.cpp"
      var $cmp=((($inc))|0) < 256; //@line 143 "dictionary.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 2;break $for_body$2; } //@line 143 "dictionary.cpp"
    }
  
    var $8=$tr_addr; //@line 149 "dictionary.cpp"
    var $letterGroups=(($8+5152)&4294967295); //@line 149 "dictionary.cpp"
    var $arraydecay=(($letterGroups)&4294967295); //@line 149 "dictionary.cpp"
    var $9=$arraydecay; //@line 149 "dictionary.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $9;
    $stop$ = $dest$ + 104;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 149 "dictionary.cpp"
    var $10=$tr_addr; //@line 150 "dictionary.cpp"
    var $groups3=(($10+6280)&4294967295); //@line 150 "dictionary.cpp"
    var $arraydecay3=(($groups3)&4294967295); //@line 150 "dictionary.cpp"
    var $11=$arraydecay3; //@line 150 "dictionary.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $11;
    $stop$ = $dest$ + 512;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 150 "dictionary.cpp"
    var $12=$tr_addr; //@line 152 "dictionary.cpp"
    var $data_dictrules=(($12+1048)&4294967295); //@line 152 "dictionary.cpp"
    var $13=HEAP32[(($data_dictrules)>>2)]; //@line 152 "dictionary.cpp"
    $p=$13; //@line 152 "dictionary.cpp"
    ; //@line 153 "dictionary.cpp"
    $while_cond$5: while(1) { 
  
      var $14=$p; //@line 153 "dictionary.cpp"
      var $15=HEAP8[($14)]; //@line 153 "dictionary.cpp"
      var $conv=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 153 "dictionary.cpp"
      var $cmp4=((($conv))|0)!=0; //@line 153 "dictionary.cpp"
      if (!($cmp4)) { __label__ = 25;break $while_cond$5; } //@line 153 "dictionary.cpp"
  
      var $16=$p; //@line 155 "dictionary.cpp"
      var $17=HEAP8[($16)]; //@line 155 "dictionary.cpp"
      var $conv5=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 155 "dictionary.cpp"
      var $cmp6=((($conv5))|0)!=6; //@line 155 "dictionary.cpp"
      if ($cmp6) { __label__ = 5;break $while_cond$5; } //@line 155 "dictionary.cpp"
  
      var $23=$p; //@line 160 "dictionary.cpp"
      var $incdec_ptr=(($23+1)&4294967295); //@line 160 "dictionary.cpp"
      $p=$incdec_ptr; //@line 160 "dictionary.cpp"
      var $24=$p; //@line 162 "dictionary.cpp"
      var $arrayidx8=(($24)&4294967295); //@line 162 "dictionary.cpp"
      var $25=HEAP8[($arrayidx8)]; //@line 162 "dictionary.cpp"
      var $conv9=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 162 "dictionary.cpp"
      var $cmp10=((($conv9))|0)==20; //@line 162 "dictionary.cpp"
      var $26=$p; //@line 164 "dictionary.cpp"
      if ($cmp10) { __label__ = 7;; } else { __label__ = 10;; } //@line 162 "dictionary.cpp"
      if (__label__ == 7) {
  
        var $27=($26); //@line 164 "dictionary.cpp"
        var $add=((($27)+4)&4294967295); //@line 164 "dictionary.cpp"
        var $and=($add) & -4; //@line 164 "dictionary.cpp"
        var $28=($and); //@line 164 "dictionary.cpp"
        $pw=$28; //@line 164 "dictionary.cpp"
        var $29=$pw; //@line 165 "dictionary.cpp"
        var $30=$tr_addr; //@line 165 "dictionary.cpp"
        var $langopts=(($30)&4294967295); //@line 165 "dictionary.cpp"
        var $replace_chars=(($langopts+264)&4294967295); //@line 165 "dictionary.cpp"
        HEAP32[(($replace_chars)>>2)]=$29; //@line 165 "dictionary.cpp"
        var $31=$pw; //@line 166 "dictionary.cpp"
        var $arrayidx134=(($31)&4294967295); //@line 166 "dictionary.cpp"
        var $32=HEAP32[(($arrayidx134)>>2)]; //@line 166 "dictionary.cpp"
        var $cmp145=((($32))|0)!=0; //@line 166 "dictionary.cpp"
        var $33=$pw; //@line 168 "dictionary.cpp"
        if ($cmp145) { __lastLabel__ = 7; __label__ = 8;; } else { __lastLabel__ = 7; __label__ = 9;; } //@line 166 "dictionary.cpp"
        $while_body15$$while_end$11: do { 
          if (__label__ == 8) {
            while(1) { 
  
              var $34=__lastLabel__ == 8 ? $37 : ($33);
              var $add_ptr=(($34+8)&4294967295); //@line 168 "dictionary.cpp"
              $pw=$add_ptr; //@line 168 "dictionary.cpp"
              var $35=$pw; //@line 166 "dictionary.cpp"
              var $arrayidx13=(($35)&4294967295); //@line 166 "dictionary.cpp"
              var $36=HEAP32[(($arrayidx13)>>2)]; //@line 166 "dictionary.cpp"
              var $cmp14=((($36))|0)!=0; //@line 166 "dictionary.cpp"
              var $37=$pw; //@line 168 "dictionary.cpp"
              if ($cmp14) { __lastLabel__ = 8; __label__ = 8;continue ; } else { __lastLabel__ = 8; __label__ = 9;break $while_body15$$while_end$11; } //@line 166 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $_lcssa3=__lastLabel__ == 7 ? $33 : ($37);
        var $add_ptr16=(($_lcssa3+4)&4294967295); //@line 170 "dictionary.cpp"
        var $38=$add_ptr16; //@line 170 "dictionary.cpp"
        $p=$38; //@line 170 "dictionary.cpp"
        __label__ = 3;continue $while_cond$5; //@line 182 "dictionary.cpp"
      }
      else if (__label__ == 10) {
  
        var $arrayidx18=(($26)&4294967295); //@line 185 "dictionary.cpp"
        var $39=HEAP8[($arrayidx18)]; //@line 185 "dictionary.cpp"
        var $conv19=(tempInt=(($39)),(tempInt>=128?tempInt-256:tempInt)); //@line 185 "dictionary.cpp"
        var $cmp20=((($conv19))|0)==18; //@line 185 "dictionary.cpp"
        var $40=$p; //@line 187 "dictionary.cpp"
        if ($cmp20) { __label__ = 11;; } else { __label__ = 13;; } //@line 185 "dictionary.cpp"
        $if_then21$$if_else$16: do { 
          if (__label__ == 11) {
  
            var $arrayidx22=(($40+1)&4294967295); //@line 187 "dictionary.cpp"
            var $41=HEAP8[($arrayidx22)]; //@line 187 "dictionary.cpp"
            var $conv23=(tempInt=(($41)),(tempInt>=128?tempInt-256:tempInt)); //@line 187 "dictionary.cpp"
            var $sub=((($conv23)-65)&4294967295); //@line 187 "dictionary.cpp"
            $ix=$sub; //@line 187 "dictionary.cpp"
            var $42=$p; //@line 188 "dictionary.cpp"
            var $add_ptr24=(($42+2)&4294967295); //@line 188 "dictionary.cpp"
            $p=$add_ptr24; //@line 188 "dictionary.cpp"
            var $43=$ix; //@line 189 "dictionary.cpp"
            var $cmp25=((($43))|0) >= 0; //@line 189 "dictionary.cpp"
            var $44=$ix; //@line 189 "dictionary.cpp"
            var $cmp26=((($44))|0) < 26; //@line 189 "dictionary.cpp"
            var $or_cond=($cmp25) & ($cmp26); //@line 189 "dictionary.cpp"
            if (!($or_cond)) { __label__ = 22;break $if_then21$$if_else$16; } //@line 189 "dictionary.cpp"
  
            var $45=$p; //@line 191 "dictionary.cpp"
            var $46=$ix; //@line 191 "dictionary.cpp"
            var $47=$tr_addr; //@line 191 "dictionary.cpp"
            var $letterGroups28=(($47+5152)&4294967295); //@line 191 "dictionary.cpp"
            var $arrayidx29=(($letterGroups28+$46*4)&4294967295); //@line 191 "dictionary.cpp"
            HEAP32[(($arrayidx29)>>2)]=$45; //@line 191 "dictionary.cpp"
            ; //@line 192 "dictionary.cpp"
          }
          else if (__label__ == 13) {
  
            var $call31=_strlen($40); //@line 196 "dictionary.cpp"
            $len=$call31; //@line 196 "dictionary.cpp"
            var $48=$p; //@line 197 "dictionary.cpp"
            $p_name=$48; //@line 197 "dictionary.cpp"
            var $49=$p_name; //@line 198 "dictionary.cpp"
            var $arrayidx32=(($49)&4294967295); //@line 198 "dictionary.cpp"
            var $50=HEAP8[($arrayidx32)]; //@line 198 "dictionary.cpp"
            $c=$50; //@line 198 "dictionary.cpp"
            var $51=$p_name; //@line 199 "dictionary.cpp"
            var $arrayidx33=(($51+1)&4294967295); //@line 199 "dictionary.cpp"
            var $52=HEAP8[($arrayidx33)]; //@line 199 "dictionary.cpp"
            $c2=$52; //@line 199 "dictionary.cpp"
            var $53=$len; //@line 201 "dictionary.cpp"
            var $add34=((($53)+1)&4294967295); //@line 201 "dictionary.cpp"
            var $54=$p; //@line 201 "dictionary.cpp"
            var $add_ptr35=(($54+$add34)&4294967295); //@line 201 "dictionary.cpp"
            $p=$add_ptr35; //@line 201 "dictionary.cpp"
            var $55=$len; //@line 202 "dictionary.cpp"
            var $cmp36=((($55))|0)==1; //@line 202 "dictionary.cpp"
            if ($cmp36) { __label__ = 14;; } else { __label__ = 15;; } //@line 202 "dictionary.cpp"
            if (__label__ == 14) {
  
              var $56=$p; //@line 204 "dictionary.cpp"
              var $57=$c; //@line 204 "dictionary.cpp"
              var $idxprom=((($57))&255); //@line 204 "dictionary.cpp"
              var $58=$tr_addr; //@line 204 "dictionary.cpp"
              var $groups138=(($58+5256)&4294967295); //@line 204 "dictionary.cpp"
              var $arrayidx39=(($groups138+$idxprom*4)&4294967295); //@line 204 "dictionary.cpp"
              HEAP32[(($arrayidx39)>>2)]=$56; //@line 204 "dictionary.cpp"
              ; //@line 205 "dictionary.cpp"
            }
            else if (__label__ == 15) {
  
              var $59=$len; //@line 207 "dictionary.cpp"
              var $cmp41=((($59))|0)==0; //@line 207 "dictionary.cpp"
              if ($cmp41) { __label__ = 16;; } else { __label__ = 17;; } //@line 207 "dictionary.cpp"
              if (__label__ == 16) {
  
                var $60=$p; //@line 209 "dictionary.cpp"
                var $61=$tr_addr; //@line 209 "dictionary.cpp"
                var $groups143=(($61+5256)&4294967295); //@line 209 "dictionary.cpp"
                var $arrayidx44=(($groups143)&4294967295); //@line 209 "dictionary.cpp"
                HEAP32[(($arrayidx44)>>2)]=$60; //@line 209 "dictionary.cpp"
                ; //@line 210 "dictionary.cpp"
              }
              else if (__label__ == 17) {
  
                var $62=$c; //@line 212 "dictionary.cpp"
                var $conv46=((($62))&255); //@line 212 "dictionary.cpp"
                var $cmp47=((($conv46))|0)==1; //@line 212 "dictionary.cpp"
                if ($cmp47) { __label__ = 18;; } else { __label__ = 19;; } //@line 212 "dictionary.cpp"
                if (__label__ == 18) {
  
                  var $63=$p; //@line 215 "dictionary.cpp"
                  var $64=$c2; //@line 215 "dictionary.cpp"
                  var $conv49=((($64))&255); //@line 215 "dictionary.cpp"
                  var $sub50=((($conv49)-1)&4294967295); //@line 215 "dictionary.cpp"
                  var $65=$tr_addr; //@line 215 "dictionary.cpp"
                  var $groups351=(($65+6280)&4294967295); //@line 215 "dictionary.cpp"
                  var $arrayidx52=(($groups351+$sub50*4)&4294967295); //@line 215 "dictionary.cpp"
                  HEAP32[(($arrayidx52)>>2)]=$63; //@line 215 "dictionary.cpp"
                  ; //@line 216 "dictionary.cpp"
                }
                else if (__label__ == 19) {
  
                  var $66=$c; //@line 219 "dictionary.cpp"
                  var $idxprom54=((($66))&255); //@line 219 "dictionary.cpp"
                  var $67=$tr_addr; //@line 219 "dictionary.cpp"
                  var $groups2_start55=(($67+8012)&4294967295); //@line 219 "dictionary.cpp"
                  var $arrayidx56=(($groups2_start55+$idxprom54)&4294967295); //@line 219 "dictionary.cpp"
                  var $68=HEAPU8[($arrayidx56)]; //@line 219 "dictionary.cpp"
                  var $conv57=((($68))&255); //@line 219 "dictionary.cpp"
                  var $cmp58=((($conv57))|0)==255; //@line 219 "dictionary.cpp"
                  if ($cmp58) { __label__ = 20;; } else { __label__ = 21;; } //@line 219 "dictionary.cpp"
                  if (__label__ == 20) {
  
                    var $69=$tr_addr; //@line 220 "dictionary.cpp"
                    var $n_groups260=(($69+7752)&4294967295); //@line 220 "dictionary.cpp"
                    var $70=HEAP32[(($n_groups260)>>2)]; //@line 220 "dictionary.cpp"
                    var $conv61=((($70)) & 255); //@line 220 "dictionary.cpp"
                    var $71=$c; //@line 220 "dictionary.cpp"
                    var $idxprom62=((($71))&255); //@line 220 "dictionary.cpp"
                    var $72=$tr_addr; //@line 220 "dictionary.cpp"
                    var $groups2_start63=(($72+8012)&4294967295); //@line 220 "dictionary.cpp"
                    var $arrayidx64=(($groups2_start63+$idxprom62)&4294967295); //@line 220 "dictionary.cpp"
                    HEAP8[($arrayidx64)]=$conv61; //@line 220 "dictionary.cpp"
                    ; //@line 220 "dictionary.cpp"
                  }
  
                  var $73=$c; //@line 222 "dictionary.cpp"
                  var $idxprom66=((($73))&255); //@line 222 "dictionary.cpp"
                  var $74=$tr_addr; //@line 222 "dictionary.cpp"
                  var $groups2_count67=(($74+7756)&4294967295); //@line 222 "dictionary.cpp"
                  var $arrayidx68=(($groups2_count67+$idxprom66)&4294967295); //@line 222 "dictionary.cpp"
                  var $75=HEAP8[($arrayidx68)]; //@line 222 "dictionary.cpp"
                  var $inc69=((($75)+1)&255); //@line 222 "dictionary.cpp"
                  HEAP8[($arrayidx68)]=$inc69; //@line 222 "dictionary.cpp"
                  var $76=$p; //@line 223 "dictionary.cpp"
                  var $77=$tr_addr; //@line 223 "dictionary.cpp"
                  var $n_groups270=(($77+7752)&4294967295); //@line 223 "dictionary.cpp"
                  var $78=HEAP32[(($n_groups270)>>2)]; //@line 223 "dictionary.cpp"
                  var $79=$tr_addr; //@line 223 "dictionary.cpp"
                  var $groups2=(($79+6792)&4294967295); //@line 223 "dictionary.cpp"
                  var $arrayidx71=(($groups2+$78*4)&4294967295); //@line 223 "dictionary.cpp"
                  HEAP32[(($arrayidx71)>>2)]=$76; //@line 223 "dictionary.cpp"
                  var $80=$c; //@line 224 "dictionary.cpp"
                  var $conv72=((($80))&255); //@line 224 "dictionary.cpp"
                  var $81=$c2; //@line 224 "dictionary.cpp"
                  var $conv73=((($81))&255); //@line 224 "dictionary.cpp"
                  var $shl=((($conv73)*256)&4294967295); //@line 224 "dictionary.cpp"
                  var $add74=((($shl)+($conv72))&4294967295); //@line 224 "dictionary.cpp"
                  var $82=$tr_addr; //@line 224 "dictionary.cpp"
                  var $n_groups275=(($82+7752)&4294967295); //@line 224 "dictionary.cpp"
                  var $83=HEAPU32[(($n_groups275)>>2)]; //@line 224 "dictionary.cpp"
                  var $inc76=((($83)+1)&4294967295); //@line 224 "dictionary.cpp"
                  HEAP32[(($n_groups275)>>2)]=$inc76; //@line 224 "dictionary.cpp"
                  var $84=$tr_addr; //@line 224 "dictionary.cpp"
                  var $groups2_name=(($84+7272)&4294967295); //@line 224 "dictionary.cpp"
                  var $arrayidx77=(($groups2_name+$83*4)&4294967295); //@line 224 "dictionary.cpp"
                  HEAP32[(($arrayidx77)>>2)]=$add74; //@line 224 "dictionary.cpp"
                  ;
                }
              }
            }
          }
        } while(0);
  
        var $85=$p; //@line 229 "dictionary.cpp"
        var $86=HEAP8[($85)]; //@line 229 "dictionary.cpp"
        var $conv831=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 229 "dictionary.cpp"
        var $cmp842=((($conv831))|0)!=7; //@line 229 "dictionary.cpp"
        var $87=$p; //@line 231 "dictionary.cpp"
        if ($cmp842) { __lastLabel__ = 22; __label__ = 23;; } else { __lastLabel__ = 22; __label__ = 24;; } //@line 229 "dictionary.cpp"
        $while_body85$$while_end89$33: do { 
          if (__label__ == 23) {
            while(1) { 
  
              var $88=__lastLabel__ == 23 ? $92 : ($87);
              var $call86=_strlen($88); //@line 231 "dictionary.cpp"
              var $add87=((($call86)+1)&4294967295); //@line 231 "dictionary.cpp"
              var $89=$p; //@line 231 "dictionary.cpp"
              var $add_ptr88=(($89+$add87)&4294967295); //@line 231 "dictionary.cpp"
              $p=$add_ptr88; //@line 231 "dictionary.cpp"
              var $90=$p; //@line 229 "dictionary.cpp"
              var $91=HEAP8[($90)]; //@line 229 "dictionary.cpp"
              var $conv83=(tempInt=(($91)),(tempInt>=128?tempInt-256:tempInt)); //@line 229 "dictionary.cpp"
              var $cmp84=((($conv83))|0)!=7; //@line 229 "dictionary.cpp"
              var $92=$p; //@line 231 "dictionary.cpp"
              if ($cmp84) { __lastLabel__ = 23; __label__ = 23;continue ; } else { __lastLabel__ = 23; __label__ = 24;break $while_body85$$while_end89$33; } //@line 229 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $_lcssa=__lastLabel__ == 22 ? $87 : ($92);
        var $incdec_ptr90=(($_lcssa+1)&4294967295); //@line 233 "dictionary.cpp"
        $p=$incdec_ptr90; //@line 233 "dictionary.cpp"
        __label__ = 3;continue $while_cond$5; //@line 234 "dictionary.cpp"
      }
    }
    if (__label__ == 5) {
  
      var $18=HEAP32[((__impure_ptr)>>2)]; //@line 157 "dictionary.cpp"
      var $_stderr=(($18+12)&4294967295); //@line 157 "dictionary.cpp"
      var $19=HEAP32[(($_stderr)>>2)]; //@line 157 "dictionary.cpp"
      var $20=$p; //@line 157 "dictionary.cpp"
      var $21=$tr_addr; //@line 157 "dictionary.cpp"
      var $data_dictrules7=(($21+1048)&4294967295); //@line 157 "dictionary.cpp"
      var $22=HEAP32[(($data_dictrules7)>>2)]; //@line 157 "dictionary.cpp"
      var $sub_ptr_lhs_cast=($20); //@line 157 "dictionary.cpp"
      var $sub_ptr_rhs_cast=($22); //@line 157 "dictionary.cpp"
      var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 157 "dictionary.cpp"
      var $call=_fprintf($19, ((__str34150)&4294967295), allocate([((_dictionary_name)&4294967295),0,0,0,$sub_ptr_sub,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 157 "dictionary.cpp"
      ; //@line 158 "dictionary.cpp"
    }
  
    ;
    return; //@line 236 "dictionary.cpp"
    return;
  }
  

  function __Z14HashDictionaryPKc($string) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $string_addr;
    var $c;
    var $chars;
    var $hash;
    $string_addr=$string;
    $chars=0; //@line 328 "dictionary.cpp"
    $hash=0; //@line 329 "dictionary.cpp"
    var $0=$string_addr; //@line 331 "dictionary.cpp"
    var $incdec_ptr1=(($0+1)&4294967295); //@line 331 "dictionary.cpp"
    $string_addr=$incdec_ptr1; //@line 331 "dictionary.cpp"
    var $1=HEAP8[($0)]; //@line 331 "dictionary.cpp"
    var $conv2=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 331 "dictionary.cpp"
    var $and4=($conv2) & 255; //@line 331 "dictionary.cpp"
    $c=$and4; //@line 331 "dictionary.cpp"
    var $cmp5=((($and4))|0)!=0; //@line 331 "dictionary.cpp"
    var $2=$hash; //@line 333 "dictionary.cpp"
    if ($cmp5) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 331 "dictionary.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $10 : ($2);
          var $mul=((($3)*8)&4294967295); //@line 333 "dictionary.cpp"
          var $4=$c; //@line 333 "dictionary.cpp"
          var $add=((($4)+($mul))&4294967295); //@line 333 "dictionary.cpp"
          $hash=$add; //@line 333 "dictionary.cpp"
          var $5=$hash; //@line 334 "dictionary.cpp"
          var $and1=($5) & 1023; //@line 334 "dictionary.cpp"
          var $6=$hash; //@line 334 "dictionary.cpp"
          var $shr=($6) >> 8; //@line 334 "dictionary.cpp"
          var $xor=($shr) ^ ($and1); //@line 334 "dictionary.cpp"
          $hash=$xor; //@line 334 "dictionary.cpp"
          var $7=$chars; //@line 335 "dictionary.cpp"
          var $inc=((($7)+1)&4294967295); //@line 335 "dictionary.cpp"
          $chars=$inc; //@line 335 "dictionary.cpp"
          var $8=$string_addr; //@line 331 "dictionary.cpp"
          var $incdec_ptr=(($8+1)&4294967295); //@line 331 "dictionary.cpp"
          $string_addr=$incdec_ptr; //@line 331 "dictionary.cpp"
          var $9=HEAP8[($8)]; //@line 331 "dictionary.cpp"
          var $conv=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 331 "dictionary.cpp"
          var $and=($conv) & 255; //@line 331 "dictionary.cpp"
          $c=$and; //@line 331 "dictionary.cpp"
          var $cmp=((($and))|0)!=0; //@line 331 "dictionary.cpp"
          var $10=$hash; //@line 333 "dictionary.cpp"
          if ($cmp) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $while_body$$while_end$2; } //@line 331 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 0 ? $2 : ($10);
    var $11=$chars; //@line 338 "dictionary.cpp"
    var $add2=((($11)+($_lcssa))&4294967295); //@line 338 "dictionary.cpp"
    var $and3=($add2) & 1023; //@line 338 "dictionary.cpp"
    ;
    return $and3; //@line 338 "dictionary.cpp"
    return null;
  }
  

  function __Z14EncodePhonemesPcS_Ph($p, $outptr, $bad_phoneme) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $p_addr;
    var $outptr_addr;
    var $bad_phoneme_addr;
    var $ix;
    var $c;
    var $count;
    var $max;
    var $max_ph;
    var $consumed;
    var $mnemonic_word;
    var $p_lang;
    $p_addr=$p;
    $outptr_addr=$outptr;
    $bad_phoneme_addr=$bad_phoneme;
    var $0=$bad_phoneme_addr; //@line 367 "dictionary.cpp"
    var $arrayidx=(($0)&4294967295); //@line 367 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 367 "dictionary.cpp"
    var $1=$p_addr; //@line 370 "dictionary.cpp"
    var $2=HEAP8[($1)]; //@line 370 "dictionary.cpp"
    var $conv4=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 370 "dictionary.cpp"
    var $call5=_isspace($conv4); //@line 370 "dictionary.cpp"
    var $tobool6=((($call5))|0)!=0; //@line 370 "dictionary.cpp"
    if ($tobool6) { __label__ = 1;; } else { __label__ = 2;; } //@line 370 "dictionary.cpp"
    $while_body$$while_cond1$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=$p_addr; //@line 372 "dictionary.cpp"
          var $incdec_ptr=(($3+1)&4294967295); //@line 372 "dictionary.cpp"
          $p_addr=$incdec_ptr; //@line 372 "dictionary.cpp"
          var $4=$p_addr; //@line 370 "dictionary.cpp"
          var $5=HEAP8[($4)]; //@line 370 "dictionary.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 370 "dictionary.cpp"
          var $call=_isspace($conv); //@line 370 "dictionary.cpp"
          var $tobool=((($call))|0)!=0; //@line 370 "dictionary.cpp"
          if ($tobool) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_cond1$2; } //@line 370 "dictionary.cpp"
        }
      }
    } while(0);
    $while_cond1$5: while(1) { 
  
      var $6=$p_addr; //@line 375 "dictionary.cpp"
      var $7=HEAPU8[($6)]; //@line 375 "dictionary.cpp"
      $c=$7; //@line 375 "dictionary.cpp"
      var $conv2=((($7))&255); //@line 375 "dictionary.cpp"
      var $cmp=((($conv2))|0)!=0; //@line 375 "dictionary.cpp"
      if (!($cmp)) { __label__ = 34;break $while_cond1$5; } //@line 375 "dictionary.cpp"
  
      var $8=$c; //@line 375 "dictionary.cpp"
      var $conv3=((($8))&255); //@line 375 "dictionary.cpp"
      var $call4=_isspace($conv3); //@line 375 "dictionary.cpp"
      var $tobool5=((($call4))|0)!=0; //@line 375 "dictionary.cpp"
      var $lnot=($tobool5) ^ 1; //@line 375 "dictionary.cpp"
      if (!($lnot)) { __label__ = 34;break $while_cond1$5; }
  
      $consumed=0; //@line 377 "dictionary.cpp"
      var $9=$c; //@line 379 "dictionary.cpp"
      var $conv7=((($9))&255); //@line 379 "dictionary.cpp"
      var $cond=((($conv7))|0)==124; //@line 379 "dictionary.cpp"
      if ($cond) { __label__ = 5;; } else { __label__ = 7;; } //@line 379 "dictionary.cpp"
      $sw_bb$$sw_default$9: do { 
        if (__label__ == 5) {
  
          var $10=$p_addr; //@line 385 "dictionary.cpp"
          var $arrayidx8=(($10+1)&4294967295); //@line 385 "dictionary.cpp"
          var $11=HEAPU8[($arrayidx8)]; //@line 385 "dictionary.cpp"
          $c=$11; //@line 385 "dictionary.cpp"
          var $conv9=((($11))&255); //@line 385 "dictionary.cpp"
          var $cmp10=((($conv9))|0)==124; //@line 385 "dictionary.cpp"
          if ($cmp10) { __label__ = 7;break $sw_bb$$sw_default$9; } //@line 385 "dictionary.cpp"
  
          var $12=$p_addr; //@line 392 "dictionary.cpp"
          var $incdec_ptr11=(($12+1)&4294967295); //@line 392 "dictionary.cpp"
          $p_addr=$incdec_ptr11; //@line 392 "dictionary.cpp"
          __label__ = 2;continue $while_cond1$5; //@line 393 "dictionary.cpp"
        }
      } while(0);
  
      $max=-1; //@line 399 "dictionary.cpp"
      $max_ph=0; //@line 400 "dictionary.cpp"
      $ix=1; //@line 402 "dictionary.cpp"
      var $13=$ix; //@line 402 "dictionary.cpp"
      var $14=HEAP32[((_n_phoneme_tab)>>2)]; //@line 402 "dictionary.cpp"
      var $cmp121=((($13))|0) < ((($14))|0); //@line 402 "dictionary.cpp"
      if (!($cmp121)) { __label__ = 22;break $while_cond1$5; } //@line 402 "dictionary.cpp"
      $for_body$13: while(1) { 
  
        var $15=$ix; //@line 404 "dictionary.cpp"
        var $arrayidx13=((_phoneme_tab+$15*4)&4294967295); //@line 404 "dictionary.cpp"
        var $16=HEAP32[(($arrayidx13)>>2)]; //@line 404 "dictionary.cpp"
        var $cmp14=((($16))|0)==0; //@line 404 "dictionary.cpp"
        if ($cmp14) { __label__ = 20;; } else { __label__ = 9;; } //@line 404 "dictionary.cpp"
        $for_inc$$if_end16$15: do { 
          if (__label__ == 9) {
  
            var $17=$ix; //@line 406 "dictionary.cpp"
            var $arrayidx17=((_phoneme_tab+$17*4)&4294967295); //@line 406 "dictionary.cpp"
            var $18=HEAP32[(($arrayidx17)>>2)]; //@line 406 "dictionary.cpp"
            var $type=(($18+11)&4294967295); //@line 406 "dictionary.cpp"
            var $19=HEAPU8[($type)]; //@line 406 "dictionary.cpp"
            var $conv18=((($19))&255); //@line 406 "dictionary.cpp"
            var $cmp19=((($conv18))|0)==15; //@line 406 "dictionary.cpp"
            if ($cmp19) { __label__ = 20;break $for_inc$$if_end16$15; } //@line 406 "dictionary.cpp"
  
            $count=0; //@line 409 "dictionary.cpp"
            var $20=$ix; //@line 410 "dictionary.cpp"
            var $arrayidx22=((_phoneme_tab+$20*4)&4294967295); //@line 410 "dictionary.cpp"
            var $21=HEAP32[(($arrayidx22)>>2)]; //@line 410 "dictionary.cpp"
            var $mnemonic=(($21)&4294967295); //@line 410 "dictionary.cpp"
            var $22=HEAP32[(($mnemonic)>>2)]; //@line 410 "dictionary.cpp"
            $mnemonic_word=$22; //@line 410 "dictionary.cpp"
            ; //@line 412 "dictionary.cpp"
            while(1) { 
  
              var $23=$count; //@line 412 "dictionary.cpp"
              var $24=$p_addr; //@line 412 "dictionary.cpp"
              var $arrayidx24=(($24+$23)&4294967295); //@line 412 "dictionary.cpp"
              var $25=HEAPU8[($arrayidx24)]; //@line 412 "dictionary.cpp"
              $c=$25; //@line 412 "dictionary.cpp"
              var $conv25=((($25))&255); //@line 412 "dictionary.cpp"
              var $cmp26=((($conv25))|0) > 32; //@line 412 "dictionary.cpp"
              if (!($cmp26)) { __label__ = 13;break ; } //@line 412 "dictionary.cpp"
  
              var $26=$count; //@line 412 "dictionary.cpp"
              var $cmp27=((($26))|0) < 4; //@line 412 "dictionary.cpp"
              if (!($cmp27)) { __label__ = 13;break ; } //@line 412 "dictionary.cpp"
  
              var $28=$c; //@line 412 "dictionary.cpp"
              var $conv29=((($28))&255); //@line 412 "dictionary.cpp"
              var $29=$mnemonic_word; //@line 412 "dictionary.cpp"
              var $30=$count; //@line 412 "dictionary.cpp"
              var $mul=((($30)*8)&4294967295); //@line 412 "dictionary.cpp"
              var $shr=($29) >>> ((($mul))>>>0); //@line 412 "dictionary.cpp"
              var $and=($shr) & 255; //@line 412 "dictionary.cpp"
              var $cmp30=((($conv29))|0)==((($and))|0); //@line 412 "dictionary.cpp"
              var $31=$count; //@line 414 "dictionary.cpp"
              if ($cmp30) { __lastLabel__ = 14; ; } else { __lastLabel__ = 14; __label__ = 16;break ; }
  
              var $inc=((($31)+1)&4294967295); //@line 414 "dictionary.cpp"
              $count=$inc; //@line 414 "dictionary.cpp"
              __label__ = 11;continue ; //@line 414 "dictionary.cpp"
            }
            if (__label__ == 13) {
  
              var $27=$count; //@line 414 "dictionary.cpp"
              __lastLabel__ = 13; ;
            }
  
            var $32=__lastLabel__ == 13 ? $27 : ($31);
            var $33=$max; //@line 416 "dictionary.cpp"
            var $cmp34=((($32))|0) > ((($33))|0); //@line 416 "dictionary.cpp"
            if (!($cmp34)) { __label__ = 20;break $for_inc$$if_end16$15; } //@line 416 "dictionary.cpp"
  
            var $34=$count; //@line 416 "dictionary.cpp"
            var $cmp36=((($34))|0)==4; //@line 416 "dictionary.cpp"
            if ($cmp36) { __label__ = 19;; } else { __label__ = 18;; } //@line 416 "dictionary.cpp"
            if (__label__ == 18) {
  
              var $35=$mnemonic_word; //@line 416 "dictionary.cpp"
              var $36=$count; //@line 416 "dictionary.cpp"
              var $mul37=((($36)*8)&4294967295); //@line 416 "dictionary.cpp"
              var $shr38=($35) >>> ((($mul37))>>>0); //@line 416 "dictionary.cpp"
              var $and39=($shr38) & 255; //@line 416 "dictionary.cpp"
              var $cmp40=((($and39))|0)==0; //@line 416 "dictionary.cpp"
              if (!($cmp40)) { __label__ = 20;break $for_inc$$if_end16$15; } //@line 416 "dictionary.cpp"
            }
  
            var $37=$count; //@line 419 "dictionary.cpp"
            $max=$37; //@line 419 "dictionary.cpp"
            var $38=$ix; //@line 420 "dictionary.cpp"
            var $arrayidx42=((_phoneme_tab+$38*4)&4294967295); //@line 420 "dictionary.cpp"
            var $39=HEAP32[(($arrayidx42)>>2)]; //@line 420 "dictionary.cpp"
            var $code=(($39+10)&4294967295); //@line 420 "dictionary.cpp"
            var $40=HEAPU8[($code)]; //@line 420 "dictionary.cpp"
            var $conv43=((($40))&255); //@line 420 "dictionary.cpp"
            $max_ph=$conv43; //@line 420 "dictionary.cpp"
            ; //@line 421 "dictionary.cpp"
          }
        } while(0);
  
        var $41=$ix; //@line 402 "dictionary.cpp"
        var $inc45=((($41)+1)&4294967295); //@line 402 "dictionary.cpp"
        $ix=$inc45; //@line 402 "dictionary.cpp"
        var $42=$ix; //@line 402 "dictionary.cpp"
        var $43=HEAP32[((_n_phoneme_tab)>>2)]; //@line 402 "dictionary.cpp"
        var $cmp12=((($42))|0) < ((($43))|0); //@line 402 "dictionary.cpp"
        if ($cmp12) { __label__ = 8;continue $for_body$13; } else { __label__ = 21;break $for_body$13; } //@line 402 "dictionary.cpp"
      }
  
      var $_pr=$max_ph; //@line 424 "dictionary.cpp"
      var $cmp46=((($_pr))|0)==0; //@line 424 "dictionary.cpp"
      if ($cmp46) { __label__ = 22;break $while_cond1$5; } //@line 424 "dictionary.cpp"
  
      var $50=$max; //@line 433 "dictionary.cpp"
      var $cmp52=((($50))|0) <= 0; //@line 433 "dictionary.cpp"
      if ($cmp52) { __label__ = 24;; } else { __label__ = 25;; } //@line 433 "dictionary.cpp"
      if (__label__ == 24) {
  
        $max=1; //@line 434 "dictionary.cpp"
        ; //@line 434 "dictionary.cpp"
      }
  
      var $51=$consumed; //@line 435 "dictionary.cpp"
      var $52=$max; //@line 435 "dictionary.cpp"
      var $add=((($52)+($51))&4294967295); //@line 435 "dictionary.cpp"
      var $53=$p_addr; //@line 435 "dictionary.cpp"
      var $add_ptr55=(($53+$add)&4294967295); //@line 435 "dictionary.cpp"
      $p_addr=$add_ptr55; //@line 435 "dictionary.cpp"
      var $54=$max_ph; //@line 436 "dictionary.cpp"
      var $conv56=((($54)) & 255); //@line 436 "dictionary.cpp"
      var $55=$outptr_addr; //@line 436 "dictionary.cpp"
      var $incdec_ptr57=(($55+1)&4294967295); //@line 436 "dictionary.cpp"
      $outptr_addr=$incdec_ptr57; //@line 436 "dictionary.cpp"
      HEAP8[($55)]=$conv56; //@line 436 "dictionary.cpp"
      var $56=$max_ph; //@line 438 "dictionary.cpp"
      var $cmp58=((($56))|0)==21; //@line 438 "dictionary.cpp"
      if (!($cmp58)) { __label__ = 2;continue $while_cond1$5; } //@line 438 "dictionary.cpp"
  
      var $57=$outptr_addr; //@line 441 "dictionary.cpp"
      $p_lang=$57; //@line 441 "dictionary.cpp"
      ; //@line 442 "dictionary.cpp"
      while(1) { 
  
        var $58=$p_addr; //@line 442 "dictionary.cpp"
        var $59=HEAPU8[($58)]; //@line 442 "dictionary.cpp"
        $c=$59; //@line 442 "dictionary.cpp"
        var $conv61=((($59))&255); //@line 442 "dictionary.cpp"
        var $call62=_isspace($conv61); //@line 442 "dictionary.cpp"
        var $tobool63=((($call62))|0)!=0; //@line 442 "dictionary.cpp"
        if ($tobool63) { __label__ = 30;break ; } //@line 442 "dictionary.cpp"
  
        var $60=$c; //@line 442 "dictionary.cpp"
        var $conv65=((($60))&255); //@line 442 "dictionary.cpp"
        var $cmp66=((($conv65))|0)!=0; //@line 442 "dictionary.cpp"
        if (!($cmp66)) { __label__ = 30;break ; }
  
        var $61=$p_addr; //@line 444 "dictionary.cpp"
        var $incdec_ptr69=(($61+1)&4294967295); //@line 444 "dictionary.cpp"
        $p_addr=$incdec_ptr69; //@line 444 "dictionary.cpp"
        var $62=$c; //@line 445 "dictionary.cpp"
        var $conv70=((($62))&255); //@line 445 "dictionary.cpp"
        var $call71=_tolower($conv70); //@line 445 "dictionary.cpp"
        var $conv72=((($call71)) & 255); //@line 445 "dictionary.cpp"
        var $63=$outptr_addr; //@line 445 "dictionary.cpp"
        var $incdec_ptr73=(($63+1)&4294967295); //@line 445 "dictionary.cpp"
        $outptr_addr=$incdec_ptr73; //@line 445 "dictionary.cpp"
        HEAP8[($63)]=$conv72; //@line 445 "dictionary.cpp"
        __label__ = 27;continue ; //@line 446 "dictionary.cpp"
      }
  
      var $64=$outptr_addr; //@line 447 "dictionary.cpp"
      HEAP8[($64)]=0; //@line 447 "dictionary.cpp"
      var $65=$c; //@line 448 "dictionary.cpp"
      var $conv75=((($65))&255); //@line 448 "dictionary.cpp"
      var $cmp76=((($conv75))|0)==0; //@line 448 "dictionary.cpp"
      if ($cmp76) { __label__ = 31;; } else { __label__ = 33;; } //@line 448 "dictionary.cpp"
      if (__label__ == 31) {
  
        var $66=$p_lang; //@line 450 "dictionary.cpp"
        var $call78=_strcmp($66, ((__str52704)&4294967295)); //@line 450 "dictionary.cpp"
        var $cmp79=((($call78))|0)==0; //@line 450 "dictionary.cpp"
        if ($cmp79) { __label__ = 32;break $while_cond1$5; } else { __label__ = 2;continue $while_cond1$5; } //@line 450 "dictionary.cpp"
      }
      else if (__label__ == 33) {
  
        var $69=$outptr_addr; //@line 458 "dictionary.cpp"
        var $incdec_ptr83=(($69+1)&4294967295); //@line 458 "dictionary.cpp"
        $outptr_addr=$incdec_ptr83; //@line 458 "dictionary.cpp"
        HEAP8[($69)]=124; //@line 458 "dictionary.cpp"
        __label__ = 2;continue $while_cond1$5;
      }
    }
    if (__label__ == 34) {
  
      var $70=$outptr_addr; //@line 465 "dictionary.cpp"
      HEAP8[($70)]=0; //@line 465 "dictionary.cpp"
      var $71=$p_addr; //@line 466 "dictionary.cpp"
      $retval=$71; //@line 466 "dictionary.cpp"
      ; //@line 466 "dictionary.cpp"
    }
    else if (__label__ == 22) {
  
      var $44=$p_addr; //@line 427 "dictionary.cpp"
      var $45=HEAP8[($44)]; //@line 427 "dictionary.cpp"
      var $46=$bad_phoneme_addr; //@line 427 "dictionary.cpp"
      var $arrayidx48=(($46)&4294967295); //@line 427 "dictionary.cpp"
      HEAP8[($arrayidx48)]=$45; //@line 427 "dictionary.cpp"
      var $47=$bad_phoneme_addr; //@line 428 "dictionary.cpp"
      var $arrayidx49=(($47+1)&4294967295); //@line 428 "dictionary.cpp"
      HEAP8[($arrayidx49)]=0; //@line 428 "dictionary.cpp"
      var $48=$outptr_addr; //@line 429 "dictionary.cpp"
      var $incdec_ptr50=(($48+1)&4294967295); //@line 429 "dictionary.cpp"
      $outptr_addr=$incdec_ptr50; //@line 429 "dictionary.cpp"
      HEAP8[($48)]=0; //@line 429 "dictionary.cpp"
      var $49=$p_addr; //@line 430 "dictionary.cpp"
      var $add_ptr=(($49+1)&4294967295); //@line 430 "dictionary.cpp"
      $retval=$add_ptr; //@line 430 "dictionary.cpp"
      ; //@line 430 "dictionary.cpp"
    }
    else if (__label__ == 32) {
  
      var $67=$p_lang; //@line 452 "dictionary.cpp"
      HEAP8[($67)]=0; //@line 452 "dictionary.cpp"
      var $68=$p_addr; //@line 453 "dictionary.cpp"
      $retval=$68; //@line 453 "dictionary.cpp"
      ; //@line 453 "dictionary.cpp"
    }
  
    var $72=$retval; //@line 467 "dictionary.cpp"
    ;
    return $72; //@line 467 "dictionary.cpp"
    return null;
  }
  

  function __Z14DecodePhonemesPKcPc($inptr, $outptr) {
    ;
    var __label__;
  
    var $inptr_addr;
    var $outptr_addr;
    var $phcode;
    var $c;
    var $mnem;
    var $ph;
    $inptr_addr=$inptr;
    $outptr_addr=$outptr;
    var $0=$inptr_addr; //@line 481 "dictionary.cpp"
    var $incdec_ptr8=(($0+1)&4294967295); //@line 481 "dictionary.cpp"
    $inptr_addr=$incdec_ptr8; //@line 481 "dictionary.cpp"
    var $1=HEAPU8[($0)]; //@line 481 "dictionary.cpp"
    $phcode=$1; //@line 481 "dictionary.cpp"
    var $conv9=((($1))&255); //@line 481 "dictionary.cpp"
    var $cmp10=((($conv9))|0) > 0; //@line 481 "dictionary.cpp"
    if ($cmp10) { __label__ = 1;; } else { __label__ = 14;; } //@line 481 "dictionary.cpp"
    $while_body$$while_end40$2: do { 
      if (__label__ == 1) {
        $while_body$3: while(1) { 
  
          var $2=$phcode; //@line 483 "dictionary.cpp"
          var $conv1=((($2))&255); //@line 483 "dictionary.cpp"
          var $cmp2=((($conv1))|0)==255; //@line 483 "dictionary.cpp"
          if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 483 "dictionary.cpp"
          $while_cond_backedge$$if_end$5: do { 
            if (__label__ == 3) {
  
              var $5=$phcode; //@line 485 "dictionary.cpp"
              var $idxprom=((($5))&255); //@line 485 "dictionary.cpp"
              var $arrayidx=((_phoneme_tab+$idxprom*4)&4294967295); //@line 485 "dictionary.cpp"
              var $6=HEAPU32[(($arrayidx)>>2)]; //@line 485 "dictionary.cpp"
              $ph=$6; //@line 485 "dictionary.cpp"
              var $cmp3=((($6))|0)==0; //@line 485 "dictionary.cpp"
              if ($cmp3) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 485 "dictionary.cpp"
  
              var $7=$ph; //@line 488 "dictionary.cpp"
              var $type=(($7+11)&4294967295); //@line 488 "dictionary.cpp"
              var $8=HEAPU8[($type)]; //@line 488 "dictionary.cpp"
              var $conv6=((($8))&255); //@line 488 "dictionary.cpp"
              var $cmp7=((($conv6))|0)==1; //@line 488 "dictionary.cpp"
              if ($cmp7) { __label__ = 5;; } else { __label__ = 9;; } //@line 488 "dictionary.cpp"
              $land_lhs_true$$if_else$8: do { 
                if (__label__ == 5) {
  
                  var $9=$ph; //@line 488 "dictionary.cpp"
                  var $std_length=(($9+14)&4294967295); //@line 488 "dictionary.cpp"
                  var $10=HEAPU8[($std_length)]; //@line 488 "dictionary.cpp"
                  var $conv8=((($10))&255); //@line 488 "dictionary.cpp"
                  var $cmp9=((($conv8))|0) <= 4; //@line 488 "dictionary.cpp"
                  if (!($cmp9)) { __label__ = 9;break $land_lhs_true$$if_else$8; } //@line 488 "dictionary.cpp"
  
                  var $11=$ph; //@line 488 "dictionary.cpp"
                  var $program=(($11+8)&4294967295); //@line 488 "dictionary.cpp"
                  var $12=HEAPU16[(($program)>>1)]; //@line 488 "dictionary.cpp"
                  var $conv11=((($12))&65535); //@line 488 "dictionary.cpp"
                  var $cmp12=((($conv11))|0)==0; //@line 488 "dictionary.cpp"
                  if (!($cmp12)) { __label__ = 9;break $land_lhs_true$$if_else$8; } //@line 488 "dictionary.cpp"
  
                  var $13=$ph; //@line 490 "dictionary.cpp"
                  var $std_length14=(($13+14)&4294967295); //@line 490 "dictionary.cpp"
                  var $14=HEAPU8[($std_length14)]; //@line 490 "dictionary.cpp"
                  var $conv15=((($14))&255); //@line 490 "dictionary.cpp"
                  var $cmp16=((($conv15))|0) > 1; //@line 490 "dictionary.cpp"
                  if (!($cmp16)) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 490 "dictionary.cpp"
  
                  var $15=$ph; //@line 491 "dictionary.cpp"
                  var $std_length18=(($15+14)&4294967295); //@line 491 "dictionary.cpp"
                  var $16=HEAPU8[($std_length18)]; //@line 491 "dictionary.cpp"
                  var $idxprom19=((($16))&255); //@line 491 "dictionary.cpp"
                  var $arrayidx20=((((__str7123)&4294967295)+$idxprom19)&4294967295); //@line 491 "dictionary.cpp"
                  var $17=HEAP8[($arrayidx20)]; //@line 491 "dictionary.cpp"
                  var $18=$outptr_addr; //@line 491 "dictionary.cpp"
                  var $incdec_ptr21=(($18+1)&4294967295); //@line 491 "dictionary.cpp"
                  $outptr_addr=$incdec_ptr21; //@line 491 "dictionary.cpp"
                  HEAP8[($18)]=$17; //@line 491 "dictionary.cpp"
                  __label__ = 2;break $while_cond_backedge$$if_end$5; //@line 491 "dictionary.cpp"
                }
              } while(0);
  
              var $19=$ph; //@line 495 "dictionary.cpp"
              var $mnemonic=(($19)&4294967295); //@line 495 "dictionary.cpp"
              var $20=HEAP32[(($mnemonic)>>2)]; //@line 495 "dictionary.cpp"
              $mnem=$20; //@line 495 "dictionary.cpp"
              var $21=$mnem; //@line 497 "dictionary.cpp"
              var $and4=($21) & 255; //@line 497 "dictionary.cpp"
              var $conv245=((($and4)) & 255); //@line 497 "dictionary.cpp"
              $c=$conv245; //@line 497 "dictionary.cpp"
              var $conv256=((($conv245))&255); //@line 497 "dictionary.cpp"
              var $cmp267=((($conv256))|0)!=0; //@line 497 "dictionary.cpp"
              if ($cmp267) { __label__ = 10;; } else { __label__ = 11;; } //@line 497 "dictionary.cpp"
              $while_body27$$while_end$14: do { 
                if (__label__ == 10) {
                  while(1) { 
  
                    var $22=$c; //@line 499 "dictionary.cpp"
                    var $23=$outptr_addr; //@line 499 "dictionary.cpp"
                    var $incdec_ptr28=(($23+1)&4294967295); //@line 499 "dictionary.cpp"
                    $outptr_addr=$incdec_ptr28; //@line 499 "dictionary.cpp"
                    HEAP8[($23)]=$22; //@line 499 "dictionary.cpp"
                    var $24=$mnem; //@line 500 "dictionary.cpp"
                    var $shr=($24) >>> 8; //@line 500 "dictionary.cpp"
                    $mnem=$shr; //@line 500 "dictionary.cpp"
                    var $25=$mnem; //@line 497 "dictionary.cpp"
                    var $and=($25) & 255; //@line 497 "dictionary.cpp"
                    var $conv24=((($and)) & 255); //@line 497 "dictionary.cpp"
                    $c=$conv24; //@line 497 "dictionary.cpp"
                    var $conv25=((($conv24))&255); //@line 497 "dictionary.cpp"
                    var $cmp26=((($conv25))|0)!=0; //@line 497 "dictionary.cpp"
                    if ($cmp26) { __label__ = 10;continue ; } else { __label__ = 11;break $while_body27$$while_end$14; } //@line 497 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $26=$phcode; //@line 502 "dictionary.cpp"
              var $conv29=((($26))&255); //@line 502 "dictionary.cpp"
              var $cmp30=((($conv29))|0)==21; //@line 502 "dictionary.cpp"
              if (!($cmp30)) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 502 "dictionary.cpp"
  
              var $27=$inptr_addr; //@line 504 "dictionary.cpp"
              var $28=HEAP8[($27)]; //@line 504 "dictionary.cpp"
              var $conv331=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 504 "dictionary.cpp"
              var $call2=_isalpha($conv331); //@line 504 "dictionary.cpp"
              var $tobool3=((($call2))|0)!=0; //@line 504 "dictionary.cpp"
              if (!($tobool3)) { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 504 "dictionary.cpp"
              while(1) { 
  
                var $29=$inptr_addr; //@line 506 "dictionary.cpp"
                var $incdec_ptr35=(($29+1)&4294967295); //@line 506 "dictionary.cpp"
                $inptr_addr=$incdec_ptr35; //@line 506 "dictionary.cpp"
                var $30=HEAP8[($29)]; //@line 506 "dictionary.cpp"
                var $31=$outptr_addr; //@line 506 "dictionary.cpp"
                var $incdec_ptr36=(($31+1)&4294967295); //@line 506 "dictionary.cpp"
                $outptr_addr=$incdec_ptr36; //@line 506 "dictionary.cpp"
                HEAP8[($31)]=$30; //@line 506 "dictionary.cpp"
                var $32=$inptr_addr; //@line 504 "dictionary.cpp"
                var $33=HEAP8[($32)]; //@line 504 "dictionary.cpp"
                var $conv33=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 504 "dictionary.cpp"
                var $call=_isalpha($conv33); //@line 504 "dictionary.cpp"
                var $tobool=((($call))|0)!=0; //@line 504 "dictionary.cpp"
                if ($tobool) { __label__ = 13;continue ; } else { __label__ = 2;break $while_cond_backedge$$if_end$5; } //@line 504 "dictionary.cpp"
              }
            }
          } while(0);
  
          var $3=$inptr_addr; //@line 481 "dictionary.cpp"
          var $incdec_ptr=(($3+1)&4294967295); //@line 481 "dictionary.cpp"
          $inptr_addr=$incdec_ptr; //@line 481 "dictionary.cpp"
          var $4=HEAPU8[($3)]; //@line 481 "dictionary.cpp"
          $phcode=$4; //@line 481 "dictionary.cpp"
          var $conv=((($4))&255); //@line 481 "dictionary.cpp"
          var $cmp=((($conv))|0) > 0; //@line 481 "dictionary.cpp"
          if ($cmp) { __label__ = 1;continue $while_body$3; } else { __label__ = 14;break $while_body$$while_end40$2; } //@line 481 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $34=$outptr_addr; //@line 511 "dictionary.cpp"
    HEAP8[($34)]=0; //@line 511 "dictionary.cpp"
    ;
    return; //@line 512 "dictionary.cpp"
    return;
  }
  

  function __Z26GetTranslatedPhonemeStringPci($phon_out, $n_phon_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $phon_out_addr;
    var $n_phon_out_addr;
    var $ix;
    var $phon_out_ix=__stackBase__;
    var $stress;
    var $c;
    var $p;
    var $plist;
    $phon_out_addr=$phon_out;
    $n_phon_out_addr=$n_phon_out;
    HEAP32[(($phon_out_ix)>>2)]=0; //@line 603 "dictionary.cpp"
    var $0=$phon_out_addr; //@line 611 "dictionary.cpp"
    var $cmp=((($0))|0)!=0; //@line 611 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 28;; } //@line 611 "dictionary.cpp"
    if (__label__ == 1) {
  
      $ix=1; //@line 613 "dictionary.cpp"
      ; //@line 613 "dictionary.cpp"
      $for_cond$4: while(1) { 
  
        var $1=$ix; //@line 613 "dictionary.cpp"
        var $2=HEAP32[((_n_phoneme_list)>>2)]; //@line 613 "dictionary.cpp"
        var $sub=((($2)-2)&4294967295); //@line 613 "dictionary.cpp"
        var $cmp1=((($1))|0) < ((($sub))|0); //@line 613 "dictionary.cpp"
        if (!($cmp1)) { __label__ = 25;break $for_cond$4; } //@line 613 "dictionary.cpp"
  
        var $3=HEAP32[(($phon_out_ix)>>2)]; //@line 613 "dictionary.cpp"
        var $4=$n_phon_out_addr; //@line 613 "dictionary.cpp"
        var $sub2=((($4)-6)&4294967295); //@line 613 "dictionary.cpp"
        var $cmp3=((($3))|0) < ((($sub2))|0); //@line 613 "dictionary.cpp"
        if (!($cmp3)) { __label__ = 25;break $for_cond$4; }
  
        var $5=$ix; //@line 615 "dictionary.cpp"
        var $arrayidx=((_phoneme_list+$5*24)&4294967295); //@line 615 "dictionary.cpp"
        $plist=$arrayidx; //@line 615 "dictionary.cpp"
        var $6=$plist; //@line 616 "dictionary.cpp"
        var $newword=(($6+19)&4294967295); //@line 616 "dictionary.cpp"
        var $7=HEAP8[($newword)]; //@line 616 "dictionary.cpp"
        var $tobool=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 616 "dictionary.cpp"
        if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 616 "dictionary.cpp"
        if (__label__ == 5) {
  
          var $8=HEAP32[(($phon_out_ix)>>2)]; //@line 617 "dictionary.cpp"
          var $inc=((($8)+1)&4294967295); //@line 617 "dictionary.cpp"
          HEAP32[(($phon_out_ix)>>2)]=$inc; //@line 617 "dictionary.cpp"
          var $9=$phon_out_addr; //@line 617 "dictionary.cpp"
          var $arrayidx5=(($9+$8)&4294967295); //@line 617 "dictionary.cpp"
          HEAP8[($arrayidx5)]=32; //@line 617 "dictionary.cpp"
          ; //@line 617 "dictionary.cpp"
        }
  
        var $10=$plist; //@line 619 "dictionary.cpp"
        var $synthflags=(($10+4)&4294967295); //@line 619 "dictionary.cpp"
        var $11=HEAPU16[(($synthflags)>>1)]; //@line 619 "dictionary.cpp"
        var $conv=((($11))&65535); //@line 619 "dictionary.cpp"
        var $and=($conv) & 4; //@line 619 "dictionary.cpp"
        var $tobool6=((($and))|0)!=0; //@line 619 "dictionary.cpp"
        if ($tobool6) { __label__ = 7;; } else { __label__ = 15;; } //@line 619 "dictionary.cpp"
        $if_then7$$if_end27$11: do { 
          if (__label__ == 7) {
  
            var $12=$plist; //@line 621 "dictionary.cpp"
            var $stresslevel=(($12+1)&4294967295); //@line 621 "dictionary.cpp"
            var $13=HEAPU8[($stresslevel)]; //@line 621 "dictionary.cpp"
            var $conv8=((($13))&255); //@line 621 "dictionary.cpp"
            $stress=$conv8; //@line 621 "dictionary.cpp"
            var $cmp9=((($conv8))|0) > 1; //@line 621 "dictionary.cpp"
            if (!($cmp9)) { __label__ = 15;break $if_then7$$if_end27$11; } //@line 621 "dictionary.cpp"
  
            $c=0; //@line 623 "dictionary.cpp"
            var $14=$stress; //@line 624 "dictionary.cpp"
            var $cmp11=((($14))|0) > 5; //@line 624 "dictionary.cpp"
            if ($cmp11) { __label__ = 9;; } else { __label__ = 10;; } //@line 624 "dictionary.cpp"
            if (__label__ == 9) {
  
              $stress=5; //@line 624 "dictionary.cpp"
              ; //@line 624 "dictionary.cpp"
            }
  
            var $15=HEAP32[((_option_phonemes)>>2)]; //@line 626 "dictionary.cpp"
            var $cmp14=((($15))|0)==3; //@line 626 "dictionary.cpp"
            if ($cmp14) { __label__ = 11;; } else { __label__ = 13;; } //@line 626 "dictionary.cpp"
            $if_then15$$if_end21$17: do { 
              if (__label__ == 11) {
  
                $c=716; //@line 628 "dictionary.cpp"
                var $16=$stress; //@line 629 "dictionary.cpp"
                var $cmp16=((($16))|0) > 3; //@line 629 "dictionary.cpp"
                if (!($cmp16)) { __label__ = 14;break $if_then15$$if_end21$17; } //@line 629 "dictionary.cpp"
  
                $c=712; //@line 630 "dictionary.cpp"
                ; //@line 630 "dictionary.cpp"
              }
              else if (__label__ == 13) {
  
                var $17=$stress; //@line 634 "dictionary.cpp"
                var $arrayidx19=((((__str8124)&4294967295)+$17)&4294967295); //@line 634 "dictionary.cpp"
                var $18=HEAP8[($arrayidx19)]; //@line 634 "dictionary.cpp"
                var $conv20=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 634 "dictionary.cpp"
                $c=$conv20; //@line 634 "dictionary.cpp"
                var $cmp22=((($conv20))|0)!=0; //@line 637 "dictionary.cpp"
                if (!($cmp22)) { __label__ = 15;break $if_then7$$if_end27$11; } //@line 637 "dictionary.cpp"
              }
            } while(0);
  
            var $19=$c; //@line 639 "dictionary.cpp"
            var $20=HEAP32[(($phon_out_ix)>>2)]; //@line 639 "dictionary.cpp"
            var $21=$phon_out_addr; //@line 639 "dictionary.cpp"
            var $arrayidx24=(($21+$20)&4294967295); //@line 639 "dictionary.cpp"
            var $call=__Z8utf8_outjPc($19, $arrayidx24); //@line 639 "dictionary.cpp"
            var $22=HEAP32[(($phon_out_ix)>>2)]; //@line 639 "dictionary.cpp"
            var $add=((($22)+($call))&4294967295); //@line 639 "dictionary.cpp"
            HEAP32[(($phon_out_ix)>>2)]=$add; //@line 639 "dictionary.cpp"
            ; //@line 640 "dictionary.cpp"
          }
        } while(0);
  
        var $23=$plist; //@line 644 "dictionary.cpp"
        var $ph=(($23+8)&4294967295); //@line 644 "dictionary.cpp"
        var $24=HEAP32[(($ph)>>2)]; //@line 644 "dictionary.cpp"
        var $code=(($24+10)&4294967295); //@line 644 "dictionary.cpp"
        var $25=HEAPU8[($code)]; //@line 644 "dictionary.cpp"
        var $conv28=((($25))&255); //@line 644 "dictionary.cpp"
        var $cmp29=((($conv28))|0)==21; //@line 644 "dictionary.cpp"
        if ($cmp29) { __label__ = 16;; } else { __label__ = 17;; } //@line 644 "dictionary.cpp"
        $if_then30$$if_else37$23: do { 
          if (__label__ == 16) {
  
            var $26=$plist; //@line 647 "dictionary.cpp"
            var $tone_ph=(($26+3)&4294967295); //@line 647 "dictionary.cpp"
            var $27=HEAPU8[($tone_ph)]; //@line 647 "dictionary.cpp"
            var $idxprom=((($27))&255); //@line 647 "dictionary.cpp"
            var $arrayidx31=((_phoneme_tab_list+$idxprom*48)&4294967295); //@line 647 "dictionary.cpp"
            var $name=(($arrayidx31)&4294967295); //@line 647 "dictionary.cpp"
            var $arraydecay=(($name)&4294967295); //@line 647 "dictionary.cpp"
            $p=$arraydecay; //@line 647 "dictionary.cpp"
            var $28=HEAP32[(($phon_out_ix)>>2)]; //@line 649 "dictionary.cpp"
            var $29=$phon_out_addr; //@line 649 "dictionary.cpp"
            var $arrayidx32=(($29+$28)&4294967295); //@line 649 "dictionary.cpp"
            var $30=$p; //@line 649 "dictionary.cpp"
            var $call33=_sprintf($arrayidx32, ((__str9125)&4294967295), allocate([$30,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 649 "dictionary.cpp"
            var $31=$p; //@line 650 "dictionary.cpp"
            var $call34=_strlen($31); //@line 650 "dictionary.cpp"
            var $32=HEAP32[(($phon_out_ix)>>2)]; //@line 650 "dictionary.cpp"
            var $add35=((($call34)+2)&4294967295); //@line 650 "dictionary.cpp"
            var $add36=((($add35)+($32))&4294967295); //@line 650 "dictionary.cpp"
            HEAP32[(($phon_out_ix)>>2)]=$add36; //@line 650 "dictionary.cpp"
            ; //@line 651 "dictionary.cpp"
          }
          else if (__label__ == 17) {
  
            var $33=$phon_out_addr; //@line 654 "dictionary.cpp"
            var $34=$plist; //@line 654 "dictionary.cpp"
            var $ph38=(($34+8)&4294967295); //@line 654 "dictionary.cpp"
            var $35=HEAP32[(($ph38)>>2)]; //@line 654 "dictionary.cpp"
            var $36=$plist; //@line 654 "dictionary.cpp"
            __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($33, $phon_out_ix, $35, $36); //@line 654 "dictionary.cpp"
            var $37=$plist; //@line 656 "dictionary.cpp"
            var $synthflags39=(($37+4)&4294967295); //@line 656 "dictionary.cpp"
            var $38=HEAPU16[(($synthflags39)>>1)]; //@line 656 "dictionary.cpp"
            var $conv40=((($38))&65535); //@line 656 "dictionary.cpp"
            var $and41=($conv40) & 8; //@line 656 "dictionary.cpp"
            var $tobool42=((($and41))|0)!=0; //@line 656 "dictionary.cpp"
            if ($tobool42) { __label__ = 18;; } else { __label__ = 19;; } //@line 656 "dictionary.cpp"
            if (__label__ == 18) {
  
              var $39=$phon_out_addr; //@line 658 "dictionary.cpp"
              var $40=HEAP32[((((_phoneme_tab+48)&4294967295))>>2)]; //@line 658 "dictionary.cpp"
              __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($39, $phon_out_ix, $40, 0); //@line 658 "dictionary.cpp"
              ; //@line 659 "dictionary.cpp"
            }
  
            var $41=$plist; //@line 660 "dictionary.cpp"
            var $synthflags45=(($41+4)&4294967295); //@line 660 "dictionary.cpp"
            var $42=HEAPU16[(($synthflags45)>>1)]; //@line 660 "dictionary.cpp"
            var $conv46=((($42))&65535); //@line 660 "dictionary.cpp"
            var $and47=($conv46) & 4; //@line 660 "dictionary.cpp"
            var $tobool48=((($and47))|0)!=0; //@line 660 "dictionary.cpp"
            if ($tobool48) { __label__ = 20;; } else { __label__ = 22;; } //@line 660 "dictionary.cpp"
            $land_lhs_true$$if_end52$29: do { 
              if (__label__ == 20) {
  
                var $43=$plist; //@line 660 "dictionary.cpp"
                var $type=(($43+15)&4294967295); //@line 660 "dictionary.cpp"
                var $44=HEAPU8[($type)]; //@line 660 "dictionary.cpp"
                var $conv49=((($44))&255); //@line 660 "dictionary.cpp"
                var $cmp50=((($conv49))|0)!=2; //@line 660 "dictionary.cpp"
                if (!($cmp50)) { __label__ = 22;break $land_lhs_true$$if_end52$29; } //@line 660 "dictionary.cpp"
  
                var $45=$phon_out_addr; //@line 663 "dictionary.cpp"
                var $46=HEAP32[((((_phoneme_tab+80)&4294967295))>>2)]; //@line 663 "dictionary.cpp"
                __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($45, $phon_out_ix, $46, 0); //@line 663 "dictionary.cpp"
                ; //@line 664 "dictionary.cpp"
              }
            } while(0);
  
            var $47=$plist; //@line 665 "dictionary.cpp"
            var $tone_ph53=(($47+3)&4294967295); //@line 665 "dictionary.cpp"
            var $48=HEAPU8[($tone_ph53)]; //@line 665 "dictionary.cpp"
            var $conv54=((($48))&255); //@line 665 "dictionary.cpp"
            var $cmp55=((($conv54))|0) > 0; //@line 665 "dictionary.cpp"
            if (!($cmp55)) { __label__ = 24;break $if_then30$$if_else37$23; } //@line 665 "dictionary.cpp"
  
            var $49=$phon_out_addr; //@line 667 "dictionary.cpp"
            var $50=$plist; //@line 667 "dictionary.cpp"
            var $tone_ph57=(($50+3)&4294967295); //@line 667 "dictionary.cpp"
            var $51=HEAPU8[($tone_ph57)]; //@line 667 "dictionary.cpp"
            var $idxprom58=((($51))&255); //@line 667 "dictionary.cpp"
            var $arrayidx59=((_phoneme_tab+$idxprom58*4)&4294967295); //@line 667 "dictionary.cpp"
            var $52=HEAP32[(($arrayidx59)>>2)]; //@line 667 "dictionary.cpp"
            __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($49, $phon_out_ix, $52, 0); //@line 667 "dictionary.cpp"
            ; //@line 668 "dictionary.cpp"
          }
        } while(0);
  
        var $53=$ix; //@line 613 "dictionary.cpp"
        var $inc62=((($53)+1)&4294967295); //@line 613 "dictionary.cpp"
        $ix=$inc62; //@line 613 "dictionary.cpp"
        __label__ = 2;continue $for_cond$4; //@line 613 "dictionary.cpp"
      }
  
      var $54=HEAP32[(($phon_out_ix)>>2)]; //@line 672 "dictionary.cpp"
      var $55=$n_phon_out_addr; //@line 672 "dictionary.cpp"
      var $cmp63=((($54))|0) >= ((($55))|0); //@line 672 "dictionary.cpp"
      if ($cmp63) { __label__ = 26;; } else { __label__ = 27;; } //@line 672 "dictionary.cpp"
      if (__label__ == 26) {
  
        var $56=$n_phon_out_addr; //@line 673 "dictionary.cpp"
        var $sub65=((($56)-1)&4294967295); //@line 673 "dictionary.cpp"
        HEAP32[(($phon_out_ix)>>2)]=$sub65; //@line 673 "dictionary.cpp"
        ; //@line 673 "dictionary.cpp"
      }
  
      var $57=HEAP32[(($phon_out_ix)>>2)]; //@line 674 "dictionary.cpp"
      var $58=$phon_out_addr; //@line 674 "dictionary.cpp"
      var $arrayidx67=(($58+$57)&4294967295); //@line 674 "dictionary.cpp"
      HEAP8[($arrayidx67)]=0; //@line 674 "dictionary.cpp"
      ; //@line 675 "dictionary.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 676 "dictionary.cpp"
    return;
  }
  

  function __ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST($phon_out, $ix, $ph, $plist) {
    var __stackBase__  = STACKTOP; STACKTOP += 152; _memset(__stackBase__, 0, 152);
    var __label__;
    var __lastLabel__ = null;
  
    var $phon_out_addr;
    var $ix_addr;
    var $ph_addr;
    var $plist_addr;
    var $c;
    var $mnem;
    var $len;
    var $first;
    var $ipa_control;
    var $phdata=__stackBase__;
    $phon_out_addr=$phon_out;
    $ix_addr=$ix;
    $ph_addr=$ph;
    $plist_addr=$plist;
    $ipa_control=0; //@line 532 "dictionary.cpp"
    var $0=HEAP32[((_option_phonemes)>>2)]; //@line 535 "dictionary.cpp"
    var $cmp=((($0))|0)==3; //@line 535 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 8;; } //@line 535 "dictionary.cpp"
    $if_then$$if_end20$2: do { 
      if (__label__ == 1) {
  
        var $ipa_string=(($phdata+132)&4294967295); //@line 538 "dictionary.cpp"
        var $arrayidx=(($ipa_string)&4294967295); //@line 538 "dictionary.cpp"
        HEAP8[($arrayidx)]=0; //@line 538 "dictionary.cpp"
        var $1=$plist_addr; //@line 540 "dictionary.cpp"
        var $cmp1=((($1))|0)==0; //@line 540 "dictionary.cpp"
        if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 540 "dictionary.cpp"
        if (__label__ == 2) {
  
          var $2=$ph_addr; //@line 542 "dictionary.cpp"
          var $code=(($2+10)&4294967295); //@line 542 "dictionary.cpp"
          var $3=HEAPU8[($code)]; //@line 542 "dictionary.cpp"
          var $conv=((($3))&255); //@line 542 "dictionary.cpp"
          __Z17InterpretPhoneme2iP12PHONEME_DATA($conv, $phdata); //@line 542 "dictionary.cpp"
          ; //@line 543 "dictionary.cpp"
        }
        else if (__label__ == 3) {
  
          var $4=$plist_addr; //@line 546 "dictionary.cpp"
          __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $4, $phdata); //@line 546 "dictionary.cpp"
          ;
        }
  
        var $ipa_string3=(($phdata+132)&4294967295); //@line 549 "dictionary.cpp"
        var $arraydecay=(($ipa_string3)&4294967295); //@line 549 "dictionary.cpp"
        var $call=_strlen($arraydecay); //@line 549 "dictionary.cpp"
        $len=$call; //@line 549 "dictionary.cpp"
        var $cmp4=((($call))|0) > 0; //@line 550 "dictionary.cpp"
        if (!($cmp4)) { __label__ = 8;break $if_then$$if_end20$2; } //@line 550 "dictionary.cpp"
  
        var $ipa_string6=(($phdata+132)&4294967295); //@line 552 "dictionary.cpp"
        var $arrayidx7=(($ipa_string6)&4294967295); //@line 552 "dictionary.cpp"
        var $5=HEAP8[($arrayidx7)]; //@line 552 "dictionary.cpp"
        var $conv8=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 552 "dictionary.cpp"
        $ipa_control=$conv8; //@line 552 "dictionary.cpp"
        var $cmp9=((($conv8))>>>0) > 32; //@line 552 "dictionary.cpp"
        if ($cmp9) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 7;; } //@line 552 "dictionary.cpp"
        if (__label__ == 6) {
  
          var $6=$ix_addr; //@line 554 "dictionary.cpp"
          var $7=HEAP32[(($6)>>2)]; //@line 554 "dictionary.cpp"
          var $8=$phon_out_addr; //@line 554 "dictionary.cpp"
          var $arrayidx11=(($8+$7)&4294967295); //@line 554 "dictionary.cpp"
          var $ipa_string12=(($phdata+132)&4294967295); //@line 554 "dictionary.cpp"
          var $arraydecay13=(($ipa_string12)&4294967295); //@line 554 "dictionary.cpp"
          var $call14=_strcpy($arrayidx11, $arraydecay13); //@line 554 "dictionary.cpp"
          var $9=$len; //@line 555 "dictionary.cpp"
          var $10=$ix_addr; //@line 555 "dictionary.cpp"
          var $11=HEAP32[(($10)>>2)]; //@line 555 "dictionary.cpp"
          var $add=((($11)+($9))&4294967295); //@line 555 "dictionary.cpp"
          HEAP32[(($10)>>2)]=$add; //@line 555 "dictionary.cpp"
          var $_pr=$ipa_control; //@line 557 "dictionary.cpp"
          __lastLabel__ = 6; ; //@line 556 "dictionary.cpp"
        }
  
        var $12=__lastLabel__ == 6 ? $_pr : ($conv8); //@line 557 "dictionary.cpp"
        var $cmp16=((($12))>>>0) >= 32; //@line 557 "dictionary.cpp"
        if ($cmp16) { __label__ = 23;break $if_then$$if_end20$2; } else { __label__ = 8;break $if_then$$if_end20$2; } //@line 557 "dictionary.cpp"
      }
    } while(0);
    $for_end$$if_end20$12: do { 
      if (__label__ == 8) {
  
        $first=1; //@line 562 "dictionary.cpp"
        var $13=$ph_addr; //@line 563 "dictionary.cpp"
        var $mnemonic=(($13)&4294967295); //@line 563 "dictionary.cpp"
        var $14=HEAP32[(($mnemonic)>>2)]; //@line 563 "dictionary.cpp"
        $mnem=$14; //@line 563 "dictionary.cpp"
        ; //@line 563 "dictionary.cpp"
        $for_cond$14: while(1) { 
  
          var $15=$mnem; //@line 563 "dictionary.cpp"
          var $and=($15) & 255; //@line 563 "dictionary.cpp"
          $c=$and; //@line 563 "dictionary.cpp"
          var $cmp21=((($and))|0)!=0; //@line 563 "dictionary.cpp"
          if (!($cmp21)) { __label__ = 23;break $for_end$$if_end20$12; } //@line 563 "dictionary.cpp"
  
          var $16=$c; //@line 565 "dictionary.cpp"
          var $cmp22=((($16))|0)==47; //@line 565 "dictionary.cpp"
          var $17=HEAP32[((_option_phoneme_variants)>>2)]; //@line 565 "dictionary.cpp"
          var $cmp23=((($17))|0)==0; //@line 565 "dictionary.cpp"
          var $or_cond=($cmp22) & ($cmp23); //@line 565 "dictionary.cpp"
          if ($or_cond) { __label__ = 23;break $for_end$$if_end20$12; } //@line 565 "dictionary.cpp"
  
          var $18=HEAP32[((_option_phonemes)>>2)]; //@line 568 "dictionary.cpp"
          var $cmp26=((($18))|0)==3; //@line 568 "dictionary.cpp"
          if ($cmp26) { __label__ = 12;; } else { __label__ = 20;; } //@line 568 "dictionary.cpp"
          $if_then27$$if_else54$18: do { 
            if (__label__ == 12) {
  
              var $19=$first; //@line 571 "dictionary.cpp"
              var $tobool=((($19))|0)!=0; //@line 571 "dictionary.cpp"
              var $20=$c; //@line 571 "dictionary.cpp"
              var $cmp29=((($20))|0)==95; //@line 571 "dictionary.cpp"
              var $or_cond3=($tobool) & ($cmp29); //@line 571 "dictionary.cpp"
              if ($or_cond3) { __label__ = 23;break $for_end$$if_end20$12; } //@line 571 "dictionary.cpp"
  
              var $cmp32=((($20))|0)==35; //@line 574 "dictionary.cpp"
              if ($cmp32) { __label__ = 14;; } else { __label__ = 15;; } //@line 574 "dictionary.cpp"
              if (__label__ == 14) {
  
                var $21=$ph_addr; //@line 574 "dictionary.cpp"
                var $type=(($21+11)&4294967295); //@line 574 "dictionary.cpp"
                var $22=HEAPU8[($type)]; //@line 574 "dictionary.cpp"
                var $conv34=((($22))&255); //@line 574 "dictionary.cpp"
                var $cmp35=((($conv34))|0)==2; //@line 574 "dictionary.cpp"
                if ($cmp35) { __label__ = 23;break $for_end$$if_end20$12; } //@line 574 "dictionary.cpp"
              }
  
              var $23=$first; //@line 578 "dictionary.cpp"
              var $tobool38=((($23))|0)!=0; //@line 578 "dictionary.cpp"
              if ($tobool38) { __label__ = 17;; } else { __label__ = 16;; } //@line 578 "dictionary.cpp"
              if (__label__ == 16) {
  
                var $24=$c; //@line 578 "dictionary.cpp"
                var $isdigittmp=((($24)-48)&4294967295); //@line 578 "dictionary.cpp"
                var $isdigit=((($isdigittmp))>>>0) < 10; //@line 578 "dictionary.cpp"
                var $call40=((($isdigit))&1); //@line 578 "dictionary.cpp"
                var $tobool41=((($call40))|0)!=0; //@line 578 "dictionary.cpp"
                if ($tobool41) { __label__ = 22;break $if_then27$$if_else54$18; } //@line 578 "dictionary.cpp"
              }
  
              var $25=$c; //@line 581 "dictionary.cpp"
              var $cmp44=((($25))|0) >= 32; //@line 581 "dictionary.cpp"
              var $26=$c; //@line 581 "dictionary.cpp"
              var $cmp46=((($26))|0) < 128; //@line 581 "dictionary.cpp"
              var $or_cond1=($cmp44) & ($cmp46); //@line 581 "dictionary.cpp"
              if ($or_cond1) { __label__ = 18;; } else { __label__ = 19;; } //@line 581 "dictionary.cpp"
              if (__label__ == 18) {
  
                var $27=$c; //@line 582 "dictionary.cpp"
                var $sub=((($27)-32)&4294967295); //@line 582 "dictionary.cpp"
                var $arrayidx48=((_ipa1+$sub*2)&4294967295); //@line 582 "dictionary.cpp"
                var $28=HEAPU16[(($arrayidx48)>>1)]; //@line 582 "dictionary.cpp"
                var $conv49=((($28))&65535); //@line 582 "dictionary.cpp"
                $c=$conv49; //@line 582 "dictionary.cpp"
                ; //@line 582 "dictionary.cpp"
              }
  
              var $29=$c; //@line 584 "dictionary.cpp"
              var $30=$ix_addr; //@line 584 "dictionary.cpp"
              var $31=HEAP32[(($30)>>2)]; //@line 584 "dictionary.cpp"
              var $32=$phon_out_addr; //@line 584 "dictionary.cpp"
              var $arrayidx51=(($32+$31)&4294967295); //@line 584 "dictionary.cpp"
              var $call52=__Z8utf8_outjPc($29, $arrayidx51); //@line 584 "dictionary.cpp"
              var $33=$ix_addr; //@line 584 "dictionary.cpp"
              var $34=HEAP32[(($33)>>2)]; //@line 584 "dictionary.cpp"
              var $add53=((($34)+($call52))&4294967295); //@line 584 "dictionary.cpp"
              HEAP32[(($33)>>2)]=$add53; //@line 584 "dictionary.cpp"
              __label__ = 21;break $if_then27$$if_else54$18; //@line 585 "dictionary.cpp"
            }
            else if (__label__ == 20) {
  
              var $35=$c; //@line 588 "dictionary.cpp"
              var $conv55=((($35)) & 255); //@line 588 "dictionary.cpp"
              var $36=$ix_addr; //@line 588 "dictionary.cpp"
              var $37=HEAP32[(($36)>>2)]; //@line 588 "dictionary.cpp"
              var $inc=((($37)+1)&4294967295); //@line 588 "dictionary.cpp"
              HEAP32[(($36)>>2)]=$inc; //@line 588 "dictionary.cpp"
              var $38=$phon_out_addr; //@line 588 "dictionary.cpp"
              var $arrayidx56=(($38+$37)&4294967295); //@line 588 "dictionary.cpp"
              HEAP8[($arrayidx56)]=$conv55; //@line 588 "dictionary.cpp"
              __label__ = 21;break $if_then27$$if_else54$18;
            }
          } while(0);
          if (__label__ == 21) {
  
            $first=0; //@line 590 "dictionary.cpp"
            ; //@line 591 "dictionary.cpp"
          }
  
          var $39=$mnem; //@line 563 "dictionary.cpp"
          var $shr=($39) >> 8; //@line 563 "dictionary.cpp"
          $mnem=$shr; //@line 563 "dictionary.cpp"
          __label__ = 9;continue $for_cond$14; //@line 563 "dictionary.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 592 "dictionary.cpp"
    return;
  }
  

  function __Z7IsVowelP10Translatori($tr, $letter) {
    ;
    var __label__;
  
    var $tr_addr;
    var $letter_addr;
    $tr_addr=$tr;
    $letter_addr=$letter;
    var $0=$tr_addr; //@line 763 "dictionary.cpp"
    var $1=$letter_addr; //@line 763 "dictionary.cpp"
    var $call=__ZL8IsLetterP10Translatorii($0, $1, 7); //@line 763 "dictionary.cpp"
    ;
    return $call; //@line 763 "dictionary.cpp"
    return null;
  }
  

  function __ZL8IsLetterP10Translatorii($tr, $letter, $group) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $letter_addr;
    var $group_addr;
    var $letter2;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $group_addr=$group;
    var $0=$group_addr; //@line 731 "dictionary.cpp"
    var $1=$tr_addr; //@line 731 "dictionary.cpp"
    var $letter_groups=(($1+968)&4294967295); //@line 731 "dictionary.cpp"
    var $arrayidx=(($letter_groups+$0*4)&4294967295); //@line 731 "dictionary.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 731 "dictionary.cpp"
    var $cmp=((($2))|0)!=0; //@line 731 "dictionary.cpp"
    var $3=$group_addr; //@line 733 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 731 "dictionary.cpp"
    $if_then$$if_end4$2: do { 
      if (__label__ == 1) {
  
        var $4=$tr_addr; //@line 733 "dictionary.cpp"
        var $letter_groups1=(($4+968)&4294967295); //@line 733 "dictionary.cpp"
        var $arrayidx2=(($letter_groups1+$3*4)&4294967295); //@line 733 "dictionary.cpp"
        var $5=HEAP32[(($arrayidx2)>>2)]; //@line 733 "dictionary.cpp"
        var $6=$letter_addr; //@line 733 "dictionary.cpp"
        var $call=_wcschr($5, $6); //@line 733 "dictionary.cpp"
        var $tobool=((($call))|0)!=0; //@line 733 "dictionary.cpp"
        if ($tobool) { __label__ = 2;; } else { __label__ = 3;; } //@line 733 "dictionary.cpp"
        if (__label__ == 2) {
  
          $retval=1; //@line 734 "dictionary.cpp"
          ; //@line 734 "dictionary.cpp"
        }
        else if (__label__ == 3) {
  
          $retval=0; //@line 735 "dictionary.cpp"
          ; //@line 735 "dictionary.cpp"
        }
      }
      else if (__label__ == 4) {
  
        var $cmp5=((($3))|0) > 7; //@line 738 "dictionary.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 738 "dictionary.cpp"
        if (__label__ == 5) {
  
          $retval=0; //@line 739 "dictionary.cpp"
          ; //@line 739 "dictionary.cpp"
        }
        else if (__label__ == 6) {
  
          var $7=$tr_addr; //@line 741 "dictionary.cpp"
          var $letter_bits_offset=(($7+964)&4294967295); //@line 741 "dictionary.cpp"
          var $8=HEAP32[(($letter_bits_offset)>>2)]; //@line 741 "dictionary.cpp"
          var $cmp8=((($8))|0) > 0; //@line 741 "dictionary.cpp"
          var $9=$letter_addr; //@line 743 "dictionary.cpp"
          if ($cmp8) { __label__ = 7;; } else { __label__ = 11;; } //@line 741 "dictionary.cpp"
          $if_then9$$if_else15$11: do { 
            if (__label__ == 7) {
  
              var $10=$tr_addr; //@line 743 "dictionary.cpp"
              var $letter_bits_offset10=(($10+964)&4294967295); //@line 743 "dictionary.cpp"
              var $11=HEAP32[(($letter_bits_offset10)>>2)]; //@line 743 "dictionary.cpp"
              var $sub=((($9)-($11))&4294967295); //@line 743 "dictionary.cpp"
              $letter2=$sub; //@line 743 "dictionary.cpp"
              var $cmp11=((($sub))|0) > 0; //@line 743 "dictionary.cpp"
              if ($cmp11) { __label__ = 8;; } else { __label__ = 10;; } //@line 743 "dictionary.cpp"
              $land_lhs_true$$if_else$13: do { 
                if (__label__ == 8) {
  
                  var $12=$letter2; //@line 743 "dictionary.cpp"
                  var $cmp12=((($12))|0) < 128; //@line 743 "dictionary.cpp"
                  if (!($cmp12)) { __label__ = 10;break $land_lhs_true$$if_else$13; } //@line 743 "dictionary.cpp"
  
                  var $13=$letter2; //@line 744 "dictionary.cpp"
                  $letter_addr=$13; //@line 744 "dictionary.cpp"
                  __label__ = 13;break $if_then9$$if_else15$11; //@line 747 "dictionary.cpp"
                }
              } while(0);
  
              $retval=0; //@line 746 "dictionary.cpp"
              __label__ = 16;break $if_then$$if_end4$2; //@line 746 "dictionary.cpp"
            }
            else if (__label__ == 11) {
  
              var $cmp16=((($9))|0) >= 192; //@line 750 "dictionary.cpp"
              var $14=$letter_addr; //@line 750 "dictionary.cpp"
              var $cmp18=((($14))|0) < 606; //@line 750 "dictionary.cpp"
              var $or_cond=($cmp16) & ($cmp18); //@line 750 "dictionary.cpp"
              if (!($or_cond)) { __label__ = 13;break $if_then9$$if_else15$11; } //@line 750 "dictionary.cpp"
  
              var $15=$letter_addr; //@line 751 "dictionary.cpp"
              var $sub20=((($15)-192)&4294967295); //@line 751 "dictionary.cpp"
              var $arrayidx21=((__ZL13remove_accent+$sub20)&4294967295); //@line 751 "dictionary.cpp"
              var $16=HEAPU8[($arrayidx21)]; //@line 751 "dictionary.cpp"
              var $idxprom=((($16))&255); //@line 751 "dictionary.cpp"
              var $17=$tr_addr; //@line 751 "dictionary.cpp"
              var $letter_bits=(($17+708)&4294967295); //@line 751 "dictionary.cpp"
              var $arrayidx22=(($letter_bits+$idxprom)&4294967295); //@line 751 "dictionary.cpp"
              var $18=HEAPU8[($arrayidx22)]; //@line 751 "dictionary.cpp"
              var $conv=((($18))&255); //@line 751 "dictionary.cpp"
              var $19=$group_addr; //@line 751 "dictionary.cpp"
              var $shl=1 << ($19); //@line 751 "dictionary.cpp"
              var $and=($shl) & ($conv); //@line 751 "dictionary.cpp"
              $retval=$and; //@line 751 "dictionary.cpp"
              __label__ = 16;break $if_then$$if_end4$2; //@line 751 "dictionary.cpp"
            }
          } while(0);
  
          var $20=$letter_addr; //@line 754 "dictionary.cpp"
          var $cmp25=((($20))|0) >= 0; //@line 754 "dictionary.cpp"
          var $21=$letter_addr; //@line 754 "dictionary.cpp"
          var $cmp27=((($21))|0) < 128; //@line 754 "dictionary.cpp"
          var $or_cond1=($cmp25) & ($cmp27); //@line 754 "dictionary.cpp"
          if ($or_cond1) { __label__ = 14;; } else { __label__ = 15;; } //@line 754 "dictionary.cpp"
          if (__label__ == 14) {
  
            var $22=$letter_addr; //@line 755 "dictionary.cpp"
            var $23=$tr_addr; //@line 755 "dictionary.cpp"
            var $letter_bits29=(($23+708)&4294967295); //@line 755 "dictionary.cpp"
            var $arrayidx30=(($letter_bits29+$22)&4294967295); //@line 755 "dictionary.cpp"
            var $24=HEAPU8[($arrayidx30)]; //@line 755 "dictionary.cpp"
            var $conv31=((($24))&255); //@line 755 "dictionary.cpp"
            var $25=$group_addr; //@line 755 "dictionary.cpp"
            var $shl32=1 << ($25); //@line 755 "dictionary.cpp"
            var $and33=($shl32) & ($conv31); //@line 755 "dictionary.cpp"
            $retval=$and33; //@line 755 "dictionary.cpp"
            ; //@line 755 "dictionary.cpp"
          }
          else if (__label__ == 15) {
  
            $retval=0; //@line 757 "dictionary.cpp"
            ; //@line 757 "dictionary.cpp"
          }
        }
      }
    } while(0);
  
    var $26=$retval; //@line 758 "dictionary.cpp"
    ;
    return $26; //@line 758 "dictionary.cpp"
    return null;
  }
  

  function __Z14UnpronouncableP10TranslatorPci($tr, $word, $posn) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $posn_addr;
    var $c=__stackBase__;
    var $c1;
    var $vowel_posn;
    var $index;
    var $count;
    var $apostrophe;
    $tr_addr=$tr;
    $word_addr=$word;
    $posn_addr=$posn;
    $c1=0; //@line 795 "dictionary.cpp"
    $vowel_posn=9; //@line 796 "dictionary.cpp"
    $apostrophe=0; //@line 799 "dictionary.cpp"
    var $0=$word_addr; //@line 801 "dictionary.cpp"
    var $call=__Z7utf8_inPiPKc($c, $0); //@line 801 "dictionary.cpp"
    var $1=$tr_addr; //@line 802 "dictionary.cpp"
    var $letter_bits_offset=(($1+964)&4294967295); //@line 802 "dictionary.cpp"
    var $2=HEAP32[(($letter_bits_offset)>>2)]; //@line 802 "dictionary.cpp"
    var $cmp=((($2))|0) > 0; //@line 802 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 802 "dictionary.cpp"
    $land_lhs_true$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $3=HEAP32[(($c)>>2)]; //@line 802 "dictionary.cpp"
        var $cmp1=((($3))|0) < 577; //@line 802 "dictionary.cpp"
        if (!($cmp1)) { __label__ = 3;break $land_lhs_true$$if_end$2; } //@line 802 "dictionary.cpp"
  
        $retval=0; //@line 805 "dictionary.cpp"
        __label__ = 30;break $land_lhs_true$$if_end$2; //@line 805 "dictionary.cpp"
      }
    } while(0);
    $return$$if_end$5: do { 
      if (__label__ == 3) {
  
        var $4=$tr_addr; //@line 808 "dictionary.cpp"
        var $langopts=(($4)&4294967295); //@line 808 "dictionary.cpp"
        var $param=(($langopts+24)&4294967295); //@line 808 "dictionary.cpp"
        var $arrayidx=(($param+20)&4294967295); //@line 808 "dictionary.cpp"
        var $5=HEAP32[(($arrayidx)>>2)]; //@line 808 "dictionary.cpp"
        var $cmp2=((($5))|0)==1; //@line 808 "dictionary.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 808 "dictionary.cpp"
        if (__label__ == 4) {
  
          $retval=0; //@line 809 "dictionary.cpp"
          ; //@line 809 "dictionary.cpp"
        }
        else if (__label__ == 5) {
  
          var $6=$word_addr; //@line 811 "dictionary.cpp"
          var $7=HEAP8[($6)]; //@line 811 "dictionary.cpp"
          var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 811 "dictionary.cpp"
          HEAP32[(($c)>>2)]=$conv; //@line 811 "dictionary.cpp"
          var $cmp5=((($conv))|0)==32; //@line 811 "dictionary.cpp"
          if ($cmp5) { __label__ = 7;; } else { __label__ = 6;; } //@line 811 "dictionary.cpp"
          $if_then9$$lor_lhs_false$10: do { 
            if (__label__ == 6) {
  
              var $8=HEAP32[(($c)>>2)]; //@line 811 "dictionary.cpp"
              var $cmp6=((($8))|0)==0; //@line 811 "dictionary.cpp"
              var $9=HEAP32[(($c)>>2)]; //@line 811 "dictionary.cpp"
              var $cmp8=((($9))|0)==39; //@line 811 "dictionary.cpp"
              var $or_cond=($cmp6) | ($cmp8); //@line 811 "dictionary.cpp"
              if ($or_cond) { __label__ = 7;break $if_then9$$lor_lhs_false$10; } //@line 811 "dictionary.cpp"
  
              $index=0; //@line 814 "dictionary.cpp"
              $count=0; //@line 815 "dictionary.cpp"
              ; //@line 816 "dictionary.cpp"
              $for_cond$13: while(1) { 
  
                var $10=$index; //@line 818 "dictionary.cpp"
                var $11=$word_addr; //@line 818 "dictionary.cpp"
                var $arrayidx11=(($11+$10)&4294967295); //@line 818 "dictionary.cpp"
                var $call12=__Z7utf8_inPiPKc($c, $arrayidx11); //@line 818 "dictionary.cpp"
                var $12=$index; //@line 818 "dictionary.cpp"
                var $add=((($12)+($call12))&4294967295); //@line 818 "dictionary.cpp"
                $index=$add; //@line 818 "dictionary.cpp"
                var $13=HEAP32[(($c)>>2)]; //@line 819 "dictionary.cpp"
                var $cmp13=((($13))|0)==0; //@line 819 "dictionary.cpp"
                var $14=HEAP32[(($c)>>2)]; //@line 819 "dictionary.cpp"
                var $cmp15=((($14))|0)==32; //@line 819 "dictionary.cpp"
                var $or_cond1=($cmp13) | ($cmp15); //@line 819 "dictionary.cpp"
                if ($or_cond1) { __label__ = 21;break $for_cond$13; } //@line 819 "dictionary.cpp"
  
                var $15=HEAP32[(($c)>>2)]; //@line 822 "dictionary.cpp"
                var $cmp18=((($15))|0)==39; //@line 822 "dictionary.cpp"
                if ($cmp18) { __label__ = 11;; } else { __label__ = 13;; } //@line 822 "dictionary.cpp"
                if (__label__ == 11) {
  
                  var $16=$count; //@line 822 "dictionary.cpp"
                  var $cmp20=((($16))|0) > 1; //@line 822 "dictionary.cpp"
                  if ($cmp20) { __label__ = 21;break $for_cond$13; } //@line 822 "dictionary.cpp"
  
                  var $17=$posn_addr; //@line 822 "dictionary.cpp"
                  var $cmp22=((($17))|0) > 0; //@line 822 "dictionary.cpp"
                  if ($cmp22) { __label__ = 21;break $for_cond$13; } //@line 822 "dictionary.cpp"
                }
  
                var $18=$count; //@line 825 "dictionary.cpp"
                var $cmp25=((($18))|0)==0; //@line 825 "dictionary.cpp"
                if ($cmp25) { __label__ = 14;; } else { __label__ = 15;; } //@line 825 "dictionary.cpp"
                if (__label__ == 14) {
  
                  var $19=HEAP32[(($c)>>2)]; //@line 826 "dictionary.cpp"
                  $c1=$19; //@line 826 "dictionary.cpp"
                  ; //@line 826 "dictionary.cpp"
                }
  
                var $20=$count; //@line 827 "dictionary.cpp"
                var $inc=((($20)+1)&4294967295); //@line 827 "dictionary.cpp"
                $count=$inc; //@line 827 "dictionary.cpp"
                var $21=$tr_addr; //@line 829 "dictionary.cpp"
                var $22=HEAP32[(($c)>>2)]; //@line 829 "dictionary.cpp"
                var $call28=__Z7IsVowelP10Translatori($21, $22); //@line 829 "dictionary.cpp"
                var $tobool=((($call28))|0)!=0; //@line 829 "dictionary.cpp"
                if ($tobool) { __label__ = 16;break $for_cond$13; } //@line 829 "dictionary.cpp"
  
                var $24=HEAP32[(($c)>>2)]; //@line 835 "dictionary.cpp"
                var $cmp31=((($24))|0)==39; //@line 835 "dictionary.cpp"
                if ($cmp31) { __label__ = 18;; } else { __label__ = 19;; } //@line 835 "dictionary.cpp"
                if (__label__ == 18) {
  
                  $apostrophe=1; //@line 836 "dictionary.cpp"
                  __label__ = 9;continue $for_cond$13; //@line 836 "dictionary.cpp"
                }
                else if (__label__ == 19) {
  
                  var $25=HEAP32[(($c)>>2)]; //@line 838 "dictionary.cpp"
                  var $call33=_iswalpha($25); //@line 838 "dictionary.cpp"
                  var $tobool34=((($call33))|0)!=0; //@line 838 "dictionary.cpp"
                  if ($tobool34) { __label__ = 9;continue $for_cond$13; } else { __label__ = 20;break $for_cond$13; } //@line 838 "dictionary.cpp"
                }
              }
              if (__label__ == 21) {
  
                var $_pr=$vowel_posn; //@line 842 "dictionary.cpp"
                __lastLabel__ = 21; ;
              }
              else if (__label__ == 16) {
  
                var $23=$count; //@line 831 "dictionary.cpp"
                $vowel_posn=$23; //@line 831 "dictionary.cpp"
                __lastLabel__ = 16; ; //@line 832 "dictionary.cpp"
              }
              else if (__label__ == 20) {
  
                $retval=0; //@line 839 "dictionary.cpp"
                __label__ = 30;break $return$$if_end$5; //@line 839 "dictionary.cpp"
              }
  
              var $26=__lastLabel__ == 21 ? $_pr : ($23); //@line 842 "dictionary.cpp"
              var $cmp38=((($26))|0) > 2; //@line 842 "dictionary.cpp"
              if ($cmp38) { __label__ = 23;; } else { __label__ = 25;; } //@line 842 "dictionary.cpp"
              $land_lhs_true39$$if_end46$32: do { 
                if (__label__ == 23) {
  
                  var $27=$tr_addr; //@line 842 "dictionary.cpp"
                  var $langopts40=(($27)&4294967295); //@line 842 "dictionary.cpp"
                  var $param41=(($langopts40+24)&4294967295); //@line 842 "dictionary.cpp"
                  var $arrayidx42=(($param41+20)&4294967295); //@line 842 "dictionary.cpp"
                  var $28=HEAP32[(($arrayidx42)>>2)]; //@line 842 "dictionary.cpp"
                  var $cmp43=((($28))|0)==2; //@line 842 "dictionary.cpp"
                  if (!($cmp43)) { __label__ = 25;break $land_lhs_true39$$if_end46$32; } //@line 842 "dictionary.cpp"
  
                  var $29=$tr_addr; //@line 845 "dictionary.cpp"
                  var $30=$word_addr; //@line 845 "dictionary.cpp"
                  var $call45=__ZL15Unpronouncable2P10TranslatorPc($29, $30); //@line 845 "dictionary.cpp"
                  $retval=$call45; //@line 845 "dictionary.cpp"
                  __label__ = 30;break $return$$if_end$5; //@line 845 "dictionary.cpp"
                }
              } while(0);
  
              var $31=$c1; //@line 848 "dictionary.cpp"
              var $32=$tr_addr; //@line 848 "dictionary.cpp"
              var $langopts47=(($32)&4294967295); //@line 848 "dictionary.cpp"
              var $param48=(($langopts47+24)&4294967295); //@line 848 "dictionary.cpp"
              var $arrayidx49=(($param48+20)&4294967295); //@line 848 "dictionary.cpp"
              var $33=HEAP32[(($arrayidx49)>>2)]; //@line 848 "dictionary.cpp"
              var $cmp50=((($31))|0)==((($33))|0); //@line 848 "dictionary.cpp"
              if ($cmp50) { __label__ = 26;; } else { __label__ = 27;; } //@line 848 "dictionary.cpp"
              if (__label__ == 26) {
  
                var $34=$vowel_posn; //@line 849 "dictionary.cpp"
                var $dec=((($34)-1)&4294967295); //@line 849 "dictionary.cpp"
                $vowel_posn=$dec; //@line 849 "dictionary.cpp"
                ; //@line 849 "dictionary.cpp"
              }
  
              var $35=$vowel_posn; //@line 851 "dictionary.cpp"
              var $36=$tr_addr; //@line 851 "dictionary.cpp"
              var $langopts53=(($36)&4294967295); //@line 851 "dictionary.cpp"
              var $max_initial_consonants=(($langopts53+248)&4294967295); //@line 851 "dictionary.cpp"
              var $37=HEAP8[($max_initial_consonants)]; //@line 851 "dictionary.cpp"
              var $conv54=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 851 "dictionary.cpp"
              var $add55=((($conv54)+1)&4294967295); //@line 851 "dictionary.cpp"
              var $cmp56=((($35))|0) > ((($add55))|0); //@line 851 "dictionary.cpp"
              if ($cmp56) { __label__ = 28;; } else { __label__ = 29;; } //@line 851 "dictionary.cpp"
              if (__label__ == 28) {
  
                $retval=1; //@line 852 "dictionary.cpp"
                __label__ = 30;break $return$$if_end$5; //@line 852 "dictionary.cpp"
              }
              else if (__label__ == 29) {
  
                $retval=0; //@line 854 "dictionary.cpp"
                __label__ = 30;break $return$$if_end$5; //@line 854 "dictionary.cpp"
              }
            }
          } while(0);
  
          $retval=0; //@line 812 "dictionary.cpp"
          ; //@line 812 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $38=$retval; //@line 856 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $38; //@line 856 "dictionary.cpp"
    return null;
  }
  

  function __ZL15Unpronouncable2P10TranslatorPc($tr, $word) {
    var __stackBase__  = STACKTOP; STACKTOP += 160; _memset(__stackBase__, 0, 160);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $c;
    var $end_flags;
    var $ph_buf=__stackBase__;
    $tr_addr=$tr;
    $word_addr=$word;
    var $arrayidx=(($ph_buf)&4294967295); //@line 775 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 775 "dictionary.cpp"
    var $0=$word_addr; //@line 776 "dictionary.cpp"
    var $arrayidx1=(($0+-1)&4294967295); //@line 776 "dictionary.cpp"
    var $1=HEAP8[($arrayidx1)]; //@line 776 "dictionary.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 776 "dictionary.cpp"
    $c=$conv; //@line 776 "dictionary.cpp"
    var $2=$word_addr; //@line 777 "dictionary.cpp"
    var $arrayidx2=(($2+-1)&4294967295); //@line 777 "dictionary.cpp"
    HEAP8[($arrayidx2)]=32; //@line 777 "dictionary.cpp"
    var $3=$tr_addr; //@line 778 "dictionary.cpp"
    var $4=$word_addr; //@line 778 "dictionary.cpp"
    var $arraydecay=(($ph_buf)&4294967295); //@line 778 "dictionary.cpp"
    var $call=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($3, $4, $arraydecay, 160, 0, -2147483648, 0); //@line 778 "dictionary.cpp"
    $end_flags=$call; //@line 778 "dictionary.cpp"
    var $5=$c; //@line 779 "dictionary.cpp"
    var $conv3=((($5)) & 255); //@line 779 "dictionary.cpp"
    var $6=$word_addr; //@line 779 "dictionary.cpp"
    var $arrayidx4=(($6+-1)&4294967295); //@line 779 "dictionary.cpp"
    HEAP8[($arrayidx4)]=$conv3; //@line 779 "dictionary.cpp"
    var $7=$end_flags; //@line 780 "dictionary.cpp"
    var $cmp=((($7))|0)==0; //@line 780 "dictionary.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 780 "dictionary.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $8=$end_flags; //@line 780 "dictionary.cpp"
        var $and=($8) & 32768; //@line 780 "dictionary.cpp"
        var $tobool=((($and))|0)!=0; //@line 780 "dictionary.cpp"
        if ($tobool) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 780 "dictionary.cpp"
  
        $retval=0; //@line 782 "dictionary.cpp"
        __label__ = 4;break $if_then$$lor_lhs_false$2; //@line 782 "dictionary.cpp"
      }
    } while(0);
    if (__label__ == 2) {
  
      $retval=1; //@line 781 "dictionary.cpp"
      ; //@line 781 "dictionary.cpp"
    }
  
    var $9=$retval; //@line 783 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $9; //@line 783 "dictionary.cpp"
    return null;
  }
  

  function __Z16ChangeWordStressP10TranslatorPci($tr, $word, $new_stress) {
    var __stackBase__  = STACKTOP; STACKTOP += 248; _memset(__stackBase__, 0, 248);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $new_stress_addr;
    var $ix;
    var $p;
    var $max_stress;
    var $vowel_count=__stackBase__;
    var $stressed_syllable=__stackBase__+4;
    var $phonetic=__stackBase__+8;
    var $vowel_stress=__stackBase__+168;
    $tr_addr=$tr;
    $word_addr=$word;
    $new_stress_addr=$new_stress;
    HEAP32[(($stressed_syllable)>>2)]=0; //@line 1010 "dictionary.cpp"
    var $arraydecay=(($phonetic)&4294967295); //@line 1014 "dictionary.cpp"
    var $0=$word_addr; //@line 1014 "dictionary.cpp"
    var $call=_strcpy($arraydecay, $0); //@line 1014 "dictionary.cpp"
    var $1=$tr_addr; //@line 1015 "dictionary.cpp"
    var $arraydecay1=(($phonetic)&4294967295); //@line 1015 "dictionary.cpp"
    var $arraydecay2=(($vowel_stress)&4294967295); //@line 1015 "dictionary.cpp"
    var $call3=__ZL14GetVowelStressP10TranslatorPhPaRiS3_i($1, $arraydecay1, $arraydecay2, $vowel_count, $stressed_syllable, 0); //@line 1015 "dictionary.cpp"
    $max_stress=$call3; //@line 1015 "dictionary.cpp"
    var $2=$new_stress_addr; //@line 1017 "dictionary.cpp"
    var $cmp=((($2))|0) >= 4; //@line 1017 "dictionary.cpp"
    $ix=1; //@line 1020 "dictionary.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 1017 "dictionary.cpp"
    $for_cond$$for_cond9_preheader$2: do { 
      if (__label__ == 2) {
        while(1) { 
  
          var $5=$ix; //@line 1020 "dictionary.cpp"
          var $6=HEAP32[(($vowel_count)>>2)]; //@line 1020 "dictionary.cpp"
          var $cmp4=((($5))|0) < ((($6))|0); //@line 1020 "dictionary.cpp"
          if (!($cmp4)) { __label__ = 9;break $for_cond$$for_cond9_preheader$2; } //@line 1020 "dictionary.cpp"
  
          var $7=$ix; //@line 1022 "dictionary.cpp"
          var $arrayidx=(($vowel_stress+$7)&4294967295); //@line 1022 "dictionary.cpp"
          var $8=HEAP8[($arrayidx)]; //@line 1022 "dictionary.cpp"
          var $conv=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 1022 "dictionary.cpp"
          var $9=$max_stress; //@line 1022 "dictionary.cpp"
          var $cmp5=((($conv))|0) >= ((($9))|0); //@line 1022 "dictionary.cpp"
          if ($cmp5) { __label__ = 4;break ; } //@line 1022 "dictionary.cpp"
  
          var $12=$ix; //@line 1020 "dictionary.cpp"
          var $inc=((($12)+1)&4294967295); //@line 1020 "dictionary.cpp"
          $ix=$inc; //@line 1020 "dictionary.cpp"
          __label__ = 2;continue ; //@line 1020 "dictionary.cpp"
        }
  
        var $10=$new_stress_addr; //@line 1024 "dictionary.cpp"
        var $conv7=((($10)) & 255); //@line 1024 "dictionary.cpp"
        var $11=$ix; //@line 1024 "dictionary.cpp"
        var $arrayidx8=(($vowel_stress+$11)&4294967295); //@line 1024 "dictionary.cpp"
        HEAP8[($arrayidx8)]=$conv7; //@line 1024 "dictionary.cpp"
        ; //@line 1025 "dictionary.cpp"
      }
      else if (__label__ == 1) {
  
        var $3=$ix; //@line 1032 "dictionary.cpp"
        var $4=HEAP32[(($vowel_count)>>2)]; //@line 1032 "dictionary.cpp"
        var $cmp101=((($3))|0) < ((($4))|0); //@line 1032 "dictionary.cpp"
        if (!($cmp101)) { __label__ = 9;break $for_cond$$for_cond9_preheader$2; } //@line 1032 "dictionary.cpp"
        while(1) { 
  
          var $13=$ix; //@line 1034 "dictionary.cpp"
          var $arrayidx12=(($vowel_stress+$13)&4294967295); //@line 1034 "dictionary.cpp"
          var $14=HEAP8[($arrayidx12)]; //@line 1034 "dictionary.cpp"
          var $conv13=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 1034 "dictionary.cpp"
          var $15=$new_stress_addr; //@line 1034 "dictionary.cpp"
          var $cmp14=((($conv13))|0) > ((($15))|0); //@line 1034 "dictionary.cpp"
          if ($cmp14) { __label__ = 7;; } else { __label__ = 8;; } //@line 1034 "dictionary.cpp"
          if (__label__ == 7) {
  
            var $16=$new_stress_addr; //@line 1035 "dictionary.cpp"
            var $conv16=((($16)) & 255); //@line 1035 "dictionary.cpp"
            var $17=$ix; //@line 1035 "dictionary.cpp"
            var $arrayidx17=(($vowel_stress+$17)&4294967295); //@line 1035 "dictionary.cpp"
            HEAP8[($arrayidx17)]=$conv16; //@line 1035 "dictionary.cpp"
            ; //@line 1035 "dictionary.cpp"
          }
  
          var $18=$ix; //@line 1032 "dictionary.cpp"
          var $inc20=((($18)+1)&4294967295); //@line 1032 "dictionary.cpp"
          $ix=$inc20; //@line 1032 "dictionary.cpp"
          var $19=$ix; //@line 1032 "dictionary.cpp"
          var $20=HEAP32[(($vowel_count)>>2)]; //@line 1032 "dictionary.cpp"
          var $cmp10=((($19))|0) < ((($20))|0); //@line 1032 "dictionary.cpp"
          if ($cmp10) { __label__ = 6;continue ; } else { __label__ = 9;break $for_cond$$for_cond9_preheader$2; } //@line 1032 "dictionary.cpp"
        }
      }
    } while(0);
  
    $ix=1; //@line 1040 "dictionary.cpp"
    var $arraydecay23=(($phonetic)&4294967295); //@line 1041 "dictionary.cpp"
    $p=$arraydecay23; //@line 1041 "dictionary.cpp"
    var $21=$p; //@line 1042 "dictionary.cpp"
    var $22=HEAPU8[($21)]; //@line 1042 "dictionary.cpp"
    var $conv242=((($22))&255); //@line 1042 "dictionary.cpp"
    var $cmp253=((($conv242))|0)!=0; //@line 1042 "dictionary.cpp"
    if ($cmp253) { __label__ = 10;; } else { __label__ = 17;; } //@line 1042 "dictionary.cpp"
    $while_body$$while_end$15: do { 
      if (__label__ == 10) {
        $while_body$16: while(1) { 
  
          var $23=$p; //@line 1044 "dictionary.cpp"
          var $24=HEAPU8[($23)]; //@line 1044 "dictionary.cpp"
          var $idxprom=((($24))&255); //@line 1044 "dictionary.cpp"
          var $arrayidx26=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1044 "dictionary.cpp"
          var $25=HEAP32[(($arrayidx26)>>2)]; //@line 1044 "dictionary.cpp"
          var $type=(($25+11)&4294967295); //@line 1044 "dictionary.cpp"
          var $26=HEAPU8[($type)]; //@line 1044 "dictionary.cpp"
          var $conv27=((($26))&255); //@line 1044 "dictionary.cpp"
          var $cmp28=((($conv27))|0)==2; //@line 1044 "dictionary.cpp"
          if ($cmp28) { __label__ = 11;; } else { __label__ = 16;; } //@line 1044 "dictionary.cpp"
          $land_lhs_true$$if_end44$18: do { 
            if (__label__ == 11) {
  
              var $27=$p; //@line 1044 "dictionary.cpp"
              var $28=HEAPU8[($27)]; //@line 1044 "dictionary.cpp"
              var $idxprom29=((($28))&255); //@line 1044 "dictionary.cpp"
              var $arrayidx30=((_phoneme_tab+$idxprom29*4)&4294967295); //@line 1044 "dictionary.cpp"
              var $29=HEAP32[(($arrayidx30)>>2)]; //@line 1044 "dictionary.cpp"
              var $phflags=(($29+4)&4294967295); //@line 1044 "dictionary.cpp"
              var $30=HEAP32[(($phflags)>>2)]; //@line 1044 "dictionary.cpp"
              var $and=($30) & 1048576; //@line 1044 "dictionary.cpp"
              var $tobool=((($and))|0)!=0; //@line 1044 "dictionary.cpp"
              if ($tobool) { __label__ = 16;break $land_lhs_true$$if_end44$18; } //@line 1044 "dictionary.cpp"
  
              var $31=$ix; //@line 1046 "dictionary.cpp"
              var $arrayidx32=(($vowel_stress+$31)&4294967295); //@line 1046 "dictionary.cpp"
              var $32=HEAP8[($arrayidx32)]; //@line 1046 "dictionary.cpp"
              var $conv33=(tempInt=(($32)),(tempInt>=128?tempInt-256:tempInt)); //@line 1046 "dictionary.cpp"
              var $cmp34=((($conv33))|0)==0; //@line 1046 "dictionary.cpp"
              if ($cmp34) { __label__ = 14;; } else { __label__ = 13;; } //@line 1046 "dictionary.cpp"
              $if_then38$$lor_lhs_false$21: do { 
                if (__label__ == 13) {
  
                  var $33=$ix; //@line 1046 "dictionary.cpp"
                  var $arrayidx35=(($vowel_stress+$33)&4294967295); //@line 1046 "dictionary.cpp"
                  var $34=HEAP8[($arrayidx35)]; //@line 1046 "dictionary.cpp"
                  var $conv36=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt)); //@line 1046 "dictionary.cpp"
                  var $cmp37=((($conv36))|0) > 1; //@line 1046 "dictionary.cpp"
                  if ($cmp37) { __label__ = 14;break $if_then38$$lor_lhs_false$21; } else { __label__ = 15;break $if_then38$$lor_lhs_false$21; } //@line 1046 "dictionary.cpp"
                }
              } while(0);
              if (__label__ == 14) {
  
                var $35=$ix; //@line 1047 "dictionary.cpp"
                var $arrayidx39=(($vowel_stress+$35)&4294967295); //@line 1047 "dictionary.cpp"
                var $36=HEAPU8[($arrayidx39)]; //@line 1047 "dictionary.cpp"
                var $idxprom40=((($36))&255); //@line 1047 "dictionary.cpp"
                var $arrayidx41=((__ZL15stress_phonemes+$idxprom40)&4294967295); //@line 1047 "dictionary.cpp"
                var $37=HEAP8[($arrayidx41)]; //@line 1047 "dictionary.cpp"
                var $38=$word_addr; //@line 1047 "dictionary.cpp"
                var $incdec_ptr=(($38+1)&4294967295); //@line 1047 "dictionary.cpp"
                $word_addr=$incdec_ptr; //@line 1047 "dictionary.cpp"
                HEAP8[($38)]=$37; //@line 1047 "dictionary.cpp"
                ; //@line 1047 "dictionary.cpp"
              }
  
              var $39=$ix; //@line 1049 "dictionary.cpp"
              var $inc43=((($39)+1)&4294967295); //@line 1049 "dictionary.cpp"
              $ix=$inc43; //@line 1049 "dictionary.cpp"
              ; //@line 1050 "dictionary.cpp"
            }
          } while(0);
  
          var $40=$p; //@line 1051 "dictionary.cpp"
          var $incdec_ptr45=(($40+1)&4294967295); //@line 1051 "dictionary.cpp"
          $p=$incdec_ptr45; //@line 1051 "dictionary.cpp"
          var $41=HEAP8[($40)]; //@line 1051 "dictionary.cpp"
          var $42=$word_addr; //@line 1051 "dictionary.cpp"
          var $incdec_ptr46=(($42+1)&4294967295); //@line 1051 "dictionary.cpp"
          $word_addr=$incdec_ptr46; //@line 1051 "dictionary.cpp"
          HEAP8[($42)]=$41; //@line 1051 "dictionary.cpp"
          var $43=$p; //@line 1042 "dictionary.cpp"
          var $44=HEAPU8[($43)]; //@line 1042 "dictionary.cpp"
          var $conv24=((($44))&255); //@line 1042 "dictionary.cpp"
          var $cmp25=((($conv24))|0)!=0; //@line 1042 "dictionary.cpp"
          if ($cmp25) { __label__ = 10;continue $while_body$16; } else { __label__ = 17;break $while_body$$while_end$15; } //@line 1042 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $45=$word_addr; //@line 1053 "dictionary.cpp"
    HEAP8[($45)]=0; //@line 1053 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return; //@line 1054 "dictionary.cpp"
    return;
  }
  

  function __ZL14GetVowelStressP10TranslatorPhPaRiS3_i($tr, $phonemes, $vowel_stress, $vowel_count, $stressed_syllable, $control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $phonemes_addr;
    var $vowel_stress_addr;
    var $vowel_count_addr;
    var $stressed_syllable_addr;
    var $control_addr;
    var $phcode;
    var $ph;
    var $ph_out;
    var $count;
    var $max_stress;
    var $ix;
    var $j;
    var $stress;
    var $primary_posn;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $vowel_stress_addr=$vowel_stress;
    $vowel_count_addr=$vowel_count;
    $stressed_syllable_addr=$stressed_syllable;
    $control_addr=$control;
    var $0=$phonemes_addr; //@line 872 "dictionary.cpp"
    $ph_out=$0; //@line 872 "dictionary.cpp"
    $count=1; //@line 873 "dictionary.cpp"
    $max_stress=-1; //@line 874 "dictionary.cpp"
    $stress=-1; //@line 877 "dictionary.cpp"
    $primary_posn=0; //@line 878 "dictionary.cpp"
    var $1=$vowel_stress_addr; //@line 880 "dictionary.cpp"
    var $arrayidx=(($1)&4294967295); //@line 880 "dictionary.cpp"
    HEAP8[($arrayidx)]=1; //@line 880 "dictionary.cpp"
    ; //@line 881 "dictionary.cpp"
    $while_cond$2: while(1) { 
  
      var $2=$phonemes_addr; //@line 881 "dictionary.cpp"
      var $incdec_ptr=(($2+1)&4294967295); //@line 881 "dictionary.cpp"
      $phonemes_addr=$incdec_ptr; //@line 881 "dictionary.cpp"
      var $3=HEAPU8[($2)]; //@line 881 "dictionary.cpp"
      $phcode=$3; //@line 881 "dictionary.cpp"
      var $conv=((($3))&255); //@line 881 "dictionary.cpp"
      var $cmp=((($conv))|0)!=0; //@line 881 "dictionary.cpp"
      if (!($cmp)) { __label__ = 39;break $while_cond$2; } //@line 881 "dictionary.cpp"
  
      var $4=$count; //@line 881 "dictionary.cpp"
      var $cmp1=((($4))|0) < 79; //@line 881 "dictionary.cpp"
      if (!($cmp1)) { __label__ = 39;break $while_cond$2; }
  
      var $5=$phcode; //@line 883 "dictionary.cpp"
      var $idxprom=((($5))&255); //@line 883 "dictionary.cpp"
      var $arrayidx2=((_phoneme_tab+$idxprom*4)&4294967295); //@line 883 "dictionary.cpp"
      var $6=HEAPU32[(($arrayidx2)>>2)]; //@line 883 "dictionary.cpp"
      $ph=$6; //@line 883 "dictionary.cpp"
      var $cmp3=((($6))|0)==0; //@line 883 "dictionary.cpp"
      if ($cmp3) { __label__ = 1;continue $while_cond$2; } //@line 883 "dictionary.cpp"
  
      var $7=$ph; //@line 886 "dictionary.cpp"
      var $type=(($7+11)&4294967295); //@line 886 "dictionary.cpp"
      var $8=HEAPU8[($type)]; //@line 886 "dictionary.cpp"
      var $conv4=((($8))&255); //@line 886 "dictionary.cpp"
      var $cmp5=((($conv4))|0)==1; //@line 886 "dictionary.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 24;; } //@line 886 "dictionary.cpp"
      $land_lhs_true$$if_end53$7: do { 
        if (__label__ == 5) {
  
          var $9=$ph; //@line 886 "dictionary.cpp"
          var $program=(($9+8)&4294967295); //@line 886 "dictionary.cpp"
          var $10=HEAPU16[(($program)>>1)]; //@line 886 "dictionary.cpp"
          var $conv6=((($10))&65535); //@line 886 "dictionary.cpp"
          var $cmp7=((($conv6))|0)==0; //@line 886 "dictionary.cpp"
          if (!($cmp7)) { __label__ = 24;break $land_lhs_true$$if_end53$7; } //@line 886 "dictionary.cpp"
  
          var $11=$phcode; //@line 890 "dictionary.cpp"
          var $conv9=((($11))&255); //@line 890 "dictionary.cpp"
          var $cmp10=((($conv9))|0)==8; //@line 890 "dictionary.cpp"
          if ($cmp10) { __label__ = 7;; } else { __label__ = 20;; } //@line 890 "dictionary.cpp"
          if (__label__ == 7) {
  
            var $12=$count; //@line 893 "dictionary.cpp"
            var $sub=((($12)-1)&4294967295); //@line 893 "dictionary.cpp"
            $j=$sub; //@line 893 "dictionary.cpp"
            __lastLabel__ = 7; ; //@line 894 "dictionary.cpp"
            $while_cond12$12: while(1) { 
  
              var $13=__lastLabel__ == 19 ? $dec : ($sub); //@line 894 "dictionary.cpp"
              var $cmp13=((($13))|0) > 0; //@line 894 "dictionary.cpp"
              if (!($cmp13)) { __label__ = 1;continue $while_cond$2; } //@line 894 "dictionary.cpp"
  
              var $14=$stressed_syllable_addr; //@line 894 "dictionary.cpp"
              var $15=HEAP32[(($14)>>2)]; //@line 894 "dictionary.cpp"
              var $cmp15=((($15))|0)==0; //@line 894 "dictionary.cpp"
              if (!($cmp15)) { __label__ = 1;continue $while_cond$2; } //@line 894 "dictionary.cpp"
  
              var $16=$j; //@line 894 "dictionary.cpp"
              var $17=$vowel_stress_addr; //@line 894 "dictionary.cpp"
              var $arrayidx17=(($17+$16)&4294967295); //@line 894 "dictionary.cpp"
              var $18=HEAP8[($arrayidx17)]; //@line 894 "dictionary.cpp"
              var $conv18=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 894 "dictionary.cpp"
              var $cmp19=((($conv18))|0) < 4; //@line 894 "dictionary.cpp"
              if (!($cmp19)) { __label__ = 1;continue $while_cond$2; }
  
              var $19=$j; //@line 896 "dictionary.cpp"
              var $20=$vowel_stress_addr; //@line 896 "dictionary.cpp"
              var $arrayidx22=(($20+$19)&4294967295); //@line 896 "dictionary.cpp"
              var $21=HEAP8[($arrayidx22)]; //@line 896 "dictionary.cpp"
              var $conv23=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 896 "dictionary.cpp"
              var $cmp24=((($conv23))|0)!=0; //@line 896 "dictionary.cpp"
              if ($cmp24) { __label__ = 12;; } else { __label__ = 19;; } //@line 896 "dictionary.cpp"
              if (__label__ == 12) {
  
                var $22=$j; //@line 896 "dictionary.cpp"
                var $23=$vowel_stress_addr; //@line 896 "dictionary.cpp"
                var $arrayidx26=(($23+$22)&4294967295); //@line 896 "dictionary.cpp"
                var $24=HEAP8[($arrayidx26)]; //@line 896 "dictionary.cpp"
                var $conv27=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 896 "dictionary.cpp"
                var $cmp28=((($conv27))|0)!=1; //@line 896 "dictionary.cpp"
                if ($cmp28) { __label__ = 13;break $while_cond12$12; } //@line 896 "dictionary.cpp"
              }
  
              var $39=$j; //@line 915 "dictionary.cpp"
              var $dec=((($39)-1)&4294967295); //@line 915 "dictionary.cpp"
              $j=$dec; //@line 915 "dictionary.cpp"
              __lastLabel__ = 19; __label__ = 8;continue $while_cond12$12; //@line 916 "dictionary.cpp"
            }
  
            var $25=$j; //@line 899 "dictionary.cpp"
            var $26=$vowel_stress_addr; //@line 899 "dictionary.cpp"
            var $arrayidx30=(($26+$25)&4294967295); //@line 899 "dictionary.cpp"
            HEAP8[($arrayidx30)]=4; //@line 899 "dictionary.cpp"
            var $27=$max_stress; //@line 901 "dictionary.cpp"
            var $cmp31=((($27))|0) < 4; //@line 901 "dictionary.cpp"
            if ($cmp31) { __label__ = 14;; } else { __label__ = 15;; } //@line 901 "dictionary.cpp"
            if (__label__ == 14) {
  
              $max_stress=4; //@line 903 "dictionary.cpp"
              var $28=$j; //@line 904 "dictionary.cpp"
              $primary_posn=$28; //@line 904 "dictionary.cpp"
              ; //@line 905 "dictionary.cpp"
            }
  
            $ix=1; //@line 908 "dictionary.cpp"
            var $29=$ix; //@line 908 "dictionary.cpp"
            var $30=$j; //@line 908 "dictionary.cpp"
            var $cmp344=((($29))|0) < ((($30))|0); //@line 908 "dictionary.cpp"
            if (!($cmp344)) { __label__ = 1;continue $while_cond$2; } //@line 908 "dictionary.cpp"
            while(1) { 
  
              var $31=$ix; //@line 910 "dictionary.cpp"
              var $32=$vowel_stress_addr; //@line 910 "dictionary.cpp"
              var $arrayidx35=(($32+$31)&4294967295); //@line 910 "dictionary.cpp"
              var $33=HEAP8[($arrayidx35)]; //@line 910 "dictionary.cpp"
              var $conv36=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 910 "dictionary.cpp"
              var $cmp37=((($conv36))|0)==4; //@line 910 "dictionary.cpp"
              if ($cmp37) { __label__ = 17;; } else { __label__ = 18;; } //@line 910 "dictionary.cpp"
              if (__label__ == 17) {
  
                var $34=$ix; //@line 911 "dictionary.cpp"
                var $35=$vowel_stress_addr; //@line 911 "dictionary.cpp"
                var $arrayidx39=(($35+$34)&4294967295); //@line 911 "dictionary.cpp"
                HEAP8[($arrayidx39)]=3; //@line 911 "dictionary.cpp"
                ; //@line 911 "dictionary.cpp"
              }
  
              var $36=$ix; //@line 908 "dictionary.cpp"
              var $inc=((($36)+1)&4294967295); //@line 908 "dictionary.cpp"
              $ix=$inc; //@line 908 "dictionary.cpp"
              var $37=$ix; //@line 908 "dictionary.cpp"
              var $38=$j; //@line 908 "dictionary.cpp"
              var $cmp34=((($37))|0) < ((($38))|0); //@line 908 "dictionary.cpp"
              if ($cmp34) { __label__ = 16;continue ; } else { __label__ = 1;continue $while_cond$2; } //@line 908 "dictionary.cpp"
            }
          }
          else if (__label__ == 20) {
  
            var $40=$ph; //@line 920 "dictionary.cpp"
            var $std_length=(($40+14)&4294967295); //@line 920 "dictionary.cpp"
            var $41=HEAPU8[($std_length)]; //@line 920 "dictionary.cpp"
            var $conv42=((($41))&255); //@line 920 "dictionary.cpp"
            var $cmp43=((($conv42))|0) < 4; //@line 920 "dictionary.cpp"
            if ($cmp43) { __label__ = 22;; } else { __label__ = 21;; } //@line 920 "dictionary.cpp"
            if (__label__ == 21) {
  
              var $42=$stressed_syllable_addr; //@line 920 "dictionary.cpp"
              var $43=HEAP32[(($42)>>2)]; //@line 920 "dictionary.cpp"
              var $cmp44=((($43))|0)==0; //@line 920 "dictionary.cpp"
              if (!($cmp44)) { __label__ = 1;continue $while_cond$2; } //@line 920 "dictionary.cpp"
            }
  
            var $44=$ph; //@line 922 "dictionary.cpp"
            var $std_length46=(($44+14)&4294967295); //@line 922 "dictionary.cpp"
            var $45=HEAPU8[($std_length46)]; //@line 922 "dictionary.cpp"
            var $conv47=((($45))&255); //@line 922 "dictionary.cpp"
            $stress=$conv47; //@line 922 "dictionary.cpp"
            var $46=$stress; //@line 924 "dictionary.cpp"
            var $47=$max_stress; //@line 924 "dictionary.cpp"
            var $cmp48=((($46))|0) > ((($47))|0); //@line 924 "dictionary.cpp"
            if (!($cmp48)) { __label__ = 1;continue $while_cond$2; } //@line 924 "dictionary.cpp"
  
            var $48=$stress; //@line 925 "dictionary.cpp"
            $max_stress=$48; //@line 925 "dictionary.cpp"
            __label__ = 1;continue $while_cond$2; //@line 925 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $49=$ph; //@line 931 "dictionary.cpp"
      var $type54=(($49+11)&4294967295); //@line 931 "dictionary.cpp"
      var $50=HEAPU8[($type54)]; //@line 931 "dictionary.cpp"
      var $conv55=((($50))&255); //@line 931 "dictionary.cpp"
      var $cmp56=((($conv55))|0)==2; //@line 931 "dictionary.cpp"
      if ($cmp56) { __label__ = 25;; } else { __label__ = 34;; } //@line 931 "dictionary.cpp"
      $land_lhs_true57$$if_else78$35: do { 
        if (__label__ == 25) {
  
          var $51=$ph; //@line 931 "dictionary.cpp"
          var $phflags=(($51+4)&4294967295); //@line 931 "dictionary.cpp"
          var $52=HEAP32[(($phflags)>>2)]; //@line 931 "dictionary.cpp"
          var $and=($52) & 1048576; //@line 931 "dictionary.cpp"
          var $tobool=((($and))|0)!=0; //@line 931 "dictionary.cpp"
          if ($tobool) { __label__ = 34;break $land_lhs_true57$$if_else78$35; } //@line 931 "dictionary.cpp"
  
          var $53=$stress; //@line 933 "dictionary.cpp"
          var $conv59=((($53)) & 255); //@line 933 "dictionary.cpp"
          var $54=$count; //@line 933 "dictionary.cpp"
          var $55=$vowel_stress_addr; //@line 933 "dictionary.cpp"
          var $arrayidx60=(($55+$54)&4294967295); //@line 933 "dictionary.cpp"
          HEAP8[($arrayidx60)]=$conv59; //@line 933 "dictionary.cpp"
          var $56=$stress; //@line 934 "dictionary.cpp"
          var $cmp61=((($56))|0) >= 4; //@line 934 "dictionary.cpp"
          if ($cmp61) { __lastLabel__ = 26; __label__ = 27;; } else { __lastLabel__ = 26; __label__ = 29;; } //@line 934 "dictionary.cpp"
          $land_lhs_true62$$if_end65$38: do { 
            if (__label__ == 27) {
  
              var $57=$stress; //@line 934 "dictionary.cpp"
              var $58=$max_stress; //@line 934 "dictionary.cpp"
              var $cmp63=((($57))|0) >= ((($58))|0); //@line 934 "dictionary.cpp"
              if ($cmp63) { __lastLabel__ = 27; ; } else { __lastLabel__ = 27; __label__ = 29;break $land_lhs_true62$$if_end65$38; } //@line 934 "dictionary.cpp"
  
              var $59=$count; //@line 936 "dictionary.cpp"
              $primary_posn=$59; //@line 936 "dictionary.cpp"
              var $60=$stress; //@line 937 "dictionary.cpp"
              $max_stress=$60; //@line 937 "dictionary.cpp"
              __lastLabel__ = 28; ; //@line 938 "dictionary.cpp"
            }
          } while(0);
  
          var $61=__lastLabel__ == 28 ? $60 : (__lastLabel__ == 27 ? $57 : ($56)); //@line 940 "dictionary.cpp"
          var $cmp66=((($61))|0) < 0; //@line 940 "dictionary.cpp"
          if ($cmp66) { __label__ = 30;; } else { __label__ = 33;; } //@line 940 "dictionary.cpp"
          $land_lhs_true67$$if_end76$42: do { 
            if (__label__ == 30) {
  
              var $62=$control_addr; //@line 940 "dictionary.cpp"
              var $and68=($62) & 1; //@line 940 "dictionary.cpp"
              var $tobool69=((($and68))|0)!=0; //@line 940 "dictionary.cpp"
              if (!($tobool69)) { __label__ = 33;break $land_lhs_true67$$if_end76$42; } //@line 940 "dictionary.cpp"
  
              var $63=$ph; //@line 940 "dictionary.cpp"
              var $phflags71=(($63+4)&4294967295); //@line 940 "dictionary.cpp"
              var $64=HEAP32[(($phflags71)>>2)]; //@line 940 "dictionary.cpp"
              var $and72=($64) & 2; //@line 940 "dictionary.cpp"
              var $tobool73=((($and72))|0)!=0; //@line 940 "dictionary.cpp"
              if (!($tobool73)) { __label__ = 33;break $land_lhs_true67$$if_end76$42; } //@line 940 "dictionary.cpp"
  
              var $65=$count; //@line 941 "dictionary.cpp"
              var $66=$vowel_stress_addr; //@line 941 "dictionary.cpp"
              var $arrayidx75=(($66+$65)&4294967295); //@line 941 "dictionary.cpp"
              HEAP8[($arrayidx75)]=1; //@line 941 "dictionary.cpp"
              ; //@line 941 "dictionary.cpp"
            }
          } while(0);
  
          var $67=$count; //@line 943 "dictionary.cpp"
          var $inc77=((($67)+1)&4294967295); //@line 943 "dictionary.cpp"
          $count=$inc77; //@line 943 "dictionary.cpp"
          $stress=-1; //@line 944 "dictionary.cpp"
          __label__ = 38;break $land_lhs_true57$$if_else78$35; //@line 945 "dictionary.cpp"
        }
      } while(0);
      $if_else78$$if_end93$47: do { 
        if (__label__ == 34) {
  
          var $68=$phcode; //@line 947 "dictionary.cpp"
          var $conv79=((($68))&255); //@line 947 "dictionary.cpp"
          var $cmp80=((($conv79))|0)==20; //@line 947 "dictionary.cpp"
          if (!($cmp80)) { __label__ = 38;break $if_else78$$if_end93$47; } //@line 947 "dictionary.cpp"
  
          var $69=$stress; //@line 950 "dictionary.cpp"
          var $conv82=((($69)) & 255); //@line 950 "dictionary.cpp"
          var $70=$count; //@line 950 "dictionary.cpp"
          var $71=$vowel_stress_addr; //@line 950 "dictionary.cpp"
          var $arrayidx83=(($71+$70)&4294967295); //@line 950 "dictionary.cpp"
          HEAP8[($arrayidx83)]=$conv82; //@line 950 "dictionary.cpp"
          var $72=$stress; //@line 951 "dictionary.cpp"
          var $cmp84=((($72))|0)==0; //@line 951 "dictionary.cpp"
          if (!($cmp84)) { __label__ = 38;break $if_else78$$if_end93$47; } //@line 951 "dictionary.cpp"
  
          var $73=$control_addr; //@line 951 "dictionary.cpp"
          var $and86=($73) & 1; //@line 951 "dictionary.cpp"
          var $tobool87=((($and86))|0)!=0; //@line 951 "dictionary.cpp"
          if (!($tobool87)) { __label__ = 38;break $if_else78$$if_end93$47; } //@line 951 "dictionary.cpp"
  
          var $74=$count; //@line 952 "dictionary.cpp"
          var $inc89=((($74)+1)&4294967295); //@line 952 "dictionary.cpp"
          $count=$inc89; //@line 952 "dictionary.cpp"
          var $75=$vowel_stress_addr; //@line 952 "dictionary.cpp"
          var $arrayidx90=(($75+$74)&4294967295); //@line 952 "dictionary.cpp"
          HEAP8[($arrayidx90)]=1; //@line 952 "dictionary.cpp"
          ; //@line 952 "dictionary.cpp"
        }
      } while(0);
  
      var $76=$phcode; //@line 955 "dictionary.cpp"
      var $77=$ph_out; //@line 955 "dictionary.cpp"
      var $incdec_ptr94=(($77+1)&4294967295); //@line 955 "dictionary.cpp"
      $ph_out=$incdec_ptr94; //@line 955 "dictionary.cpp"
      HEAP8[($77)]=$76; //@line 955 "dictionary.cpp"
      __label__ = 1;continue $while_cond$2; //@line 956 "dictionary.cpp"
    }
  
    var $78=$count; //@line 957 "dictionary.cpp"
    var $79=$vowel_stress_addr; //@line 957 "dictionary.cpp"
    var $arrayidx96=(($79+$78)&4294967295); //@line 957 "dictionary.cpp"
    HEAP8[($arrayidx96)]=1; //@line 957 "dictionary.cpp"
    var $80=$ph_out; //@line 958 "dictionary.cpp"
    HEAP8[($80)]=0; //@line 958 "dictionary.cpp"
    var $81=$stressed_syllable_addr; //@line 961 "dictionary.cpp"
    var $82=HEAP32[(($81)>>2)]; //@line 961 "dictionary.cpp"
    var $cmp97=((($82))|0) > 0; //@line 961 "dictionary.cpp"
    if ($cmp97) { __label__ = 40;; } else { __label__ = 43;; } //@line 961 "dictionary.cpp"
    $if_then98$$if_end104$54: do { 
      if (__label__ == 40) {
  
        var $83=$stressed_syllable_addr; //@line 963 "dictionary.cpp"
        var $84=HEAP32[(($83)>>2)]; //@line 963 "dictionary.cpp"
        var $85=$count; //@line 963 "dictionary.cpp"
        var $cmp99=((($84))|0) >= ((($85))|0); //@line 963 "dictionary.cpp"
        if ($cmp99) { __label__ = 41;; } else { __label__ = 42;; } //@line 963 "dictionary.cpp"
        if (__label__ == 41) {
  
          var $86=$count; //@line 964 "dictionary.cpp"
          var $sub101=((($86)-1)&4294967295); //@line 964 "dictionary.cpp"
          var $87=$stressed_syllable_addr; //@line 964 "dictionary.cpp"
          HEAP32[(($87)>>2)]=$sub101; //@line 964 "dictionary.cpp"
          ; //@line 964 "dictionary.cpp"
        }
  
        var $88=$stressed_syllable_addr; //@line 966 "dictionary.cpp"
        var $89=HEAP32[(($88)>>2)]; //@line 966 "dictionary.cpp"
        var $90=$vowel_stress_addr; //@line 966 "dictionary.cpp"
        var $arrayidx103=(($90+$89)&4294967295); //@line 966 "dictionary.cpp"
        HEAP8[($arrayidx103)]=4; //@line 966 "dictionary.cpp"
        $max_stress=4; //@line 967 "dictionary.cpp"
        var $91=$stressed_syllable_addr; //@line 968 "dictionary.cpp"
        var $92=HEAP32[(($91)>>2)]; //@line 968 "dictionary.cpp"
        $primary_posn=$92; //@line 968 "dictionary.cpp"
        ; //@line 971 "dictionary.cpp"
      }
      else if (__label__ == 43) {
  
        var $_pr=$max_stress; //@line 971 "dictionary.cpp"
        var $cmp105=((($_pr))|0)==5; //@line 971 "dictionary.cpp"
        if (!($cmp105)) { __label__ = 53;break $if_then98$$if_end104$54; } //@line 971 "dictionary.cpp"
  
        $ix=1; //@line 974 "dictionary.cpp"
        var $93=$ix; //@line 974 "dictionary.cpp"
        var $94=$count; //@line 974 "dictionary.cpp"
        var $cmp1083=((($93))|0) < ((($94))|0); //@line 974 "dictionary.cpp"
        if ($cmp1083) { __label__ = 45;; } else { __label__ = 52;; } //@line 974 "dictionary.cpp"
        $for_body109$$for_end130$61: do { 
          if (__label__ == 45) {
            while(1) { 
  
              var $95=$ix; //@line 976 "dictionary.cpp"
              var $96=$vowel_stress_addr; //@line 976 "dictionary.cpp"
              var $arrayidx110=(($96+$95)&4294967295); //@line 976 "dictionary.cpp"
              var $97=HEAP8[($arrayidx110)]; //@line 976 "dictionary.cpp"
              var $conv111=(tempInt=(($97)),(tempInt>=128?tempInt-256:tempInt)); //@line 976 "dictionary.cpp"
              var $cmp112=((($conv111))|0)==4; //@line 976 "dictionary.cpp"
              if ($cmp112) { __label__ = 46;; } else { __label__ = 49;; } //@line 976 "dictionary.cpp"
              if (__label__ == 46) {
  
                var $98=$tr_addr; //@line 978 "dictionary.cpp"
                var $langopts=(($98)&4294967295); //@line 978 "dictionary.cpp"
                var $stress_flags=(($langopts+12)&4294967295); //@line 978 "dictionary.cpp"
                var $99=HEAP32[(($stress_flags)>>2)]; //@line 978 "dictionary.cpp"
                var $and114=($99) & 131072; //@line 978 "dictionary.cpp"
                var $tobool115=((($and114))|0)!=0; //@line 978 "dictionary.cpp"
                var $100=$ix; //@line 979 "dictionary.cpp"
                var $101=$vowel_stress_addr; //@line 979 "dictionary.cpp"
                var $arrayidx117=(($101+$100)&4294967295); //@line 979 "dictionary.cpp"
                if ($tobool115) { __label__ = 47;; } else { __label__ = 48;; } //@line 978 "dictionary.cpp"
                if (__label__ == 47) {
  
                  HEAP8[($arrayidx117)]=1; //@line 979 "dictionary.cpp"
                  ; //@line 979 "dictionary.cpp"
                }
                else if (__label__ == 48) {
  
                  HEAP8[($arrayidx117)]=3; //@line 981 "dictionary.cpp"
                  ;
                }
              }
  
              var $102=$ix; //@line 984 "dictionary.cpp"
              var $103=$vowel_stress_addr; //@line 984 "dictionary.cpp"
              var $arrayidx122=(($103+$102)&4294967295); //@line 984 "dictionary.cpp"
              var $104=HEAP8[($arrayidx122)]; //@line 984 "dictionary.cpp"
              var $conv123=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt)); //@line 984 "dictionary.cpp"
              var $cmp124=((($conv123))|0)==5; //@line 984 "dictionary.cpp"
              if ($cmp124) { __label__ = 50;; } else { __label__ = 51;; } //@line 984 "dictionary.cpp"
              if (__label__ == 50) {
  
                var $105=$ix; //@line 986 "dictionary.cpp"
                var $106=$vowel_stress_addr; //@line 986 "dictionary.cpp"
                var $arrayidx126=(($106+$105)&4294967295); //@line 986 "dictionary.cpp"
                HEAP8[($arrayidx126)]=4; //@line 986 "dictionary.cpp"
                var $107=$ix; //@line 987 "dictionary.cpp"
                $primary_posn=$107; //@line 987 "dictionary.cpp"
                ; //@line 988 "dictionary.cpp"
              }
  
              var $108=$ix; //@line 974 "dictionary.cpp"
              var $inc129=((($108)+1)&4294967295); //@line 974 "dictionary.cpp"
              $ix=$inc129; //@line 974 "dictionary.cpp"
              var $109=$ix; //@line 974 "dictionary.cpp"
              var $110=$count; //@line 974 "dictionary.cpp"
              var $cmp108=((($109))|0) < ((($110))|0); //@line 974 "dictionary.cpp"
              if ($cmp108) { __label__ = 45;continue ; } else { __label__ = 52;break $for_body109$$for_end130$61; } //@line 974 "dictionary.cpp"
            }
          }
        } while(0);
  
        $max_stress=4; //@line 990 "dictionary.cpp"
        ; //@line 991 "dictionary.cpp"
      }
    } while(0);
  
    var $111=$primary_posn; //@line 993 "dictionary.cpp"
    var $112=$stressed_syllable_addr; //@line 993 "dictionary.cpp"
    HEAP32[(($112)>>2)]=$111; //@line 993 "dictionary.cpp"
    var $113=$count; //@line 994 "dictionary.cpp"
    var $114=$vowel_count_addr; //@line 994 "dictionary.cpp"
    HEAP32[(($114)>>2)]=$113; //@line 994 "dictionary.cpp"
    var $115=$max_stress; //@line 995 "dictionary.cpp"
    ;
    return $115; //@line 995 "dictionary.cpp"
    return null;
  }
  

  function __Z13SetWordStressP10TranslatorPcPjii($tr, $output, $dictionary_flags, $tonic, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 408; _memset(__stackBase__, 0, 408);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $output_addr;
    var $dictionary_flags_addr;
    var $tonic_addr;
    var $control_addr;
    var $phcode;
    var $p;
    var $ph;
    var $stress;
    var $max_stress;
    var $vowel_count=__stackBase__;
    var $ix;
    var $v;
    var $v_stress;
    var $stressed_syllable=__stackBase__+4;
    var $max_stress_posn;
    var $unstressed_word;
    var $max_output;
    var $final_ph;
    var $final_ph2;
    var $mnem;
    var $mnem2;
    var $post_tonic;
    var $opt_length;
    var $done;
    var $stressflags;
    var $dflags;
    var $first_primary;
    var $vowel_stress=__stackBase__+8;
    var $syllable_weight=__stackBase__+88;
    var $vowel_length=__stackBase__+168;
    var $phonetic=__stackBase__+248;
    var $weight;
    var $lengthened;
    var $wt;
    var $max_weight;
    var $prev_stressed;
    var $shorten;
    $tr_addr=$tr;
    $output_addr=$output;
    $dictionary_flags_addr=$dictionary_flags;
    $tonic_addr=$tonic;
    $control_addr=$control;
    $unstressed_word=0; //@line 1084 "dictionary.cpp"
    $dflags=0; //@line 1094 "dictionary.cpp"
    var $0=$tr_addr; //@line 1112 "dictionary.cpp"
    var $langopts=(($0)&4294967295); //@line 1112 "dictionary.cpp"
    var $stress_flags=(($langopts+12)&4294967295); //@line 1112 "dictionary.cpp"
    var $1=HEAP32[(($stress_flags)>>2)]; //@line 1112 "dictionary.cpp"
    $stressflags=$1; //@line 1112 "dictionary.cpp"
    var $2=$dictionary_flags_addr; //@line 1114 "dictionary.cpp"
    var $cmp=((($2))|0)!=0; //@line 1114 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1114 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $3=$dictionary_flags_addr; //@line 1115 "dictionary.cpp"
      var $arrayidx=(($3)&4294967295); //@line 1115 "dictionary.cpp"
      var $4=HEAP32[(($arrayidx)>>2)]; //@line 1115 "dictionary.cpp"
      $dflags=$4; //@line 1115 "dictionary.cpp"
      ; //@line 1115 "dictionary.cpp"
    }
  
    $ix=0; //@line 1118 "dictionary.cpp"
    __lastLabel__ = 2; ; //@line 1118 "dictionary.cpp"
    $for_cond$5: while(1) { 
  
      var $5=__lastLabel__ == 7 ? $inc : (0); //@line 1118 "dictionary.cpp"
      var $cmp1=((($5))|0) < 160; //@line 1118 "dictionary.cpp"
      var $6=$ix; //@line 1120 "dictionary.cpp"
      if ($cmp1) { __lastLabel__ = 3; ; } else { __lastLabel__ = 3; __label__ = 8;break $for_cond$5; } //@line 1118 "dictionary.cpp"
  
      var $7=$output_addr; //@line 1120 "dictionary.cpp"
      var $arrayidx2=(($7+$6)&4294967295); //@line 1120 "dictionary.cpp"
      var $8=HEAP8[($arrayidx2)]; //@line 1120 "dictionary.cpp"
      var $9=$ix; //@line 1120 "dictionary.cpp"
      var $arrayidx3=(($phonetic+$9)&4294967295); //@line 1120 "dictionary.cpp"
      HEAP8[($arrayidx3)]=$8; //@line 1120 "dictionary.cpp"
      var $10=$ix; //@line 1122 "dictionary.cpp"
      var $arrayidx4=(($phonetic+$10)&4294967295); //@line 1122 "dictionary.cpp"
      var $11=HEAPU8[($arrayidx4)]; //@line 1122 "dictionary.cpp"
      var $conv=((($11))&255); //@line 1122 "dictionary.cpp"
      var $12=HEAP32[((_n_phoneme_tab)>>2)]; //@line 1122 "dictionary.cpp"
      var $cmp5=((($conv))|0) >= ((($12))|0); //@line 1122 "dictionary.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1122 "dictionary.cpp"
      if (__label__ == 5) {
  
        var $13=$ix; //@line 1123 "dictionary.cpp"
        var $arrayidx7=(($phonetic+$13)&4294967295); //@line 1123 "dictionary.cpp"
        HEAP8[($arrayidx7)]=13; //@line 1123 "dictionary.cpp"
        ; //@line 1123 "dictionary.cpp"
      }
  
      var $14=$ix; //@line 1124 "dictionary.cpp"
      var $arrayidx9=(($phonetic+$14)&4294967295); //@line 1124 "dictionary.cpp"
      var $15=HEAPU8[($arrayidx9)]; //@line 1124 "dictionary.cpp"
      var $conv10=((($15))&255); //@line 1124 "dictionary.cpp"
      var $cmp11=((($conv10))|0)==0; //@line 1124 "dictionary.cpp"
      if ($cmp11) { __lastLabel__ = 6; __label__ = 8;break $for_cond$5; } else { __lastLabel__ = 6; ; } //@line 1124 "dictionary.cpp"
  
      var $16=$ix; //@line 1118 "dictionary.cpp"
      var $inc=((($16)+1)&4294967295); //@line 1118 "dictionary.cpp"
      $ix=$inc; //@line 1118 "dictionary.cpp"
      __lastLabel__ = 7; __label__ = 3;continue $for_cond$5; //@line 1118 "dictionary.cpp"
    }
  
    var $17=__lastLabel__ == 6 ? $14 : ($6); //@line 1127 "dictionary.cpp"
    var $cmp14=((($17))|0)==0; //@line 1127 "dictionary.cpp"
    if ($cmp14) { __label__ = 223;; } else { __label__ = 9;; } //@line 1127 "dictionary.cpp"
    if (__label__ == 9) {
  
      var $18=$ix; //@line 1128 "dictionary.cpp"
      var $sub=((($18)-1)&4294967295); //@line 1128 "dictionary.cpp"
      var $arrayidx17=(($phonetic+$sub)&4294967295); //@line 1128 "dictionary.cpp"
      var $19=HEAPU8[($arrayidx17)]; //@line 1128 "dictionary.cpp"
      var $conv18=((($19))&255); //@line 1128 "dictionary.cpp"
      $final_ph=$conv18; //@line 1128 "dictionary.cpp"
      var $20=$ix; //@line 1129 "dictionary.cpp"
      var $sub19=((($20)-2)&4294967295); //@line 1129 "dictionary.cpp"
      var $arrayidx20=(($phonetic+$sub19)&4294967295); //@line 1129 "dictionary.cpp"
      var $21=HEAPU8[($arrayidx20)]; //@line 1129 "dictionary.cpp"
      var $conv21=((($21))&255); //@line 1129 "dictionary.cpp"
      $final_ph2=$conv21; //@line 1129 "dictionary.cpp"
      var $22=$output_addr; //@line 1131 "dictionary.cpp"
      var $add_ptr=(($22+157)&4294967295); //@line 1131 "dictionary.cpp"
      $max_output=$add_ptr; //@line 1131 "dictionary.cpp"
      var $23=$dflags; //@line 1134 "dictionary.cpp"
      var $and=($23) & 7; //@line 1134 "dictionary.cpp"
      HEAP32[(($stressed_syllable)>>2)]=$and; //@line 1134 "dictionary.cpp"
      var $24=$dflags; //@line 1135 "dictionary.cpp"
      var $and22=($24) & 8; //@line 1135 "dictionary.cpp"
      var $tobool=((($and22))|0)!=0; //@line 1135 "dictionary.cpp"
      if ($tobool) { __label__ = 10;; } else { __label__ = 11;; } //@line 1135 "dictionary.cpp"
      if (__label__ == 10) {
  
        var $25=$dflags; //@line 1138 "dictionary.cpp"
        var $and24=($25) & 3; //@line 1138 "dictionary.cpp"
        HEAP32[(($stressed_syllable)>>2)]=$and24; //@line 1138 "dictionary.cpp"
        $unstressed_word=1; //@line 1139 "dictionary.cpp"
        ; //@line 1140 "dictionary.cpp"
      }
  
      var $26=$tr_addr; //@line 1142 "dictionary.cpp"
      var $arraydecay=(($phonetic)&4294967295); //@line 1142 "dictionary.cpp"
      var $arraydecay26=(($vowel_stress)&4294967295); //@line 1142 "dictionary.cpp"
      var $call=__ZL14GetVowelStressP10TranslatorPhPaRiS3_i($26, $arraydecay, $arraydecay26, $vowel_count, $stressed_syllable, 1); //@line 1142 "dictionary.cpp"
      $max_stress=$call; //@line 1142 "dictionary.cpp"
      var $cmp27=((($call))|0) < 0; //@line 1143 "dictionary.cpp"
      if ($cmp27) { __label__ = 12;; } else { __label__ = 17;; } //@line 1143 "dictionary.cpp"
      $land_lhs_true$$if_end40$18: do { 
        if (__label__ == 12) {
  
          var $27=$dictionary_flags_addr; //@line 1143 "dictionary.cpp"
          var $tobool28=((($27))|0)!=0; //@line 1143 "dictionary.cpp"
          if (!($tobool28)) { __label__ = 17;break $land_lhs_true$$if_end40$18; } //@line 1143 "dictionary.cpp"
  
          var $28=$tr_addr; //@line 1145 "dictionary.cpp"
          var $langopts30=(($28)&4294967295); //@line 1145 "dictionary.cpp"
          var $stress_flags31=(($langopts30+12)&4294967295); //@line 1145 "dictionary.cpp"
          var $29=HEAP32[(($stress_flags31)>>2)]; //@line 1145 "dictionary.cpp"
          var $and32=($29) & 1; //@line 1145 "dictionary.cpp"
          var $tobool33=((($and32))|0)!=0; //@line 1145 "dictionary.cpp"
          if ($tobool33) { __label__ = 14;; } else { __label__ = 16;; } //@line 1145 "dictionary.cpp"
          $land_lhs_true34$$if_end39$21: do { 
            if (__label__ == 14) {
  
              var $30=HEAP32[(($vowel_count)>>2)]; //@line 1145 "dictionary.cpp"
              var $cmp35=((($30))|0)==2; //@line 1145 "dictionary.cpp"
              if (!($cmp35)) { __label__ = 16;break $land_lhs_true34$$if_end39$21; } //@line 1145 "dictionary.cpp"
  
              var $arrayidx37=(($vowel_stress+1)&4294967295); //@line 1148 "dictionary.cpp"
              HEAP8[($arrayidx37)]=0; //@line 1148 "dictionary.cpp"
              var $31=$dictionary_flags_addr; //@line 1149 "dictionary.cpp"
              var $arrayidx38=(($31)&4294967295); //@line 1149 "dictionary.cpp"
              var $32=HEAP32[(($arrayidx38)>>2)]; //@line 1149 "dictionary.cpp"
              var $or=($32) | 4096; //@line 1149 "dictionary.cpp"
              HEAP32[(($arrayidx38)>>2)]=$or; //@line 1149 "dictionary.cpp"
              ; //@line 1150 "dictionary.cpp"
            }
          } while(0);
  
          $max_stress=0; //@line 1151 "dictionary.cpp"
          ; //@line 1152 "dictionary.cpp"
        }
      } while(0);
  
      $ix=1; //@line 1155 "dictionary.cpp"
      var $arraydecay41=(($phonetic)&4294967295); //@line 1156 "dictionary.cpp"
      $p=$arraydecay41; //@line 1156 "dictionary.cpp"
      var $33=$p; //@line 1156 "dictionary.cpp"
      var $34=HEAPU8[($33)]; //@line 1156 "dictionary.cpp"
      var $conv4319=((($34))&255); //@line 1156 "dictionary.cpp"
      var $cmp4420=((($conv4319))|0)!=0; //@line 1156 "dictionary.cpp"
      if ($cmp4420) { __label__ = 18;; } else { __label__ = 33;; } //@line 1156 "dictionary.cpp"
      $for_body45$$for_end109$26: do { 
        if (__label__ == 18) {
          $for_body45$27: while(1) { 
  
            var $35=$p; //@line 1158 "dictionary.cpp"
            var $arrayidx46=(($35)&4294967295); //@line 1158 "dictionary.cpp"
            var $36=HEAPU8[($arrayidx46)]; //@line 1158 "dictionary.cpp"
            var $idxprom=((($36))&255); //@line 1158 "dictionary.cpp"
            var $arrayidx47=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1158 "dictionary.cpp"
            var $37=HEAP32[(($arrayidx47)>>2)]; //@line 1158 "dictionary.cpp"
            var $type=(($37+11)&4294967295); //@line 1158 "dictionary.cpp"
            var $38=HEAPU8[($type)]; //@line 1158 "dictionary.cpp"
            var $conv48=((($38))&255); //@line 1158 "dictionary.cpp"
            var $cmp49=((($conv48))|0)==2; //@line 1158 "dictionary.cpp"
            if ($cmp49) { __label__ = 19;; } else { __label__ = 32;; } //@line 1158 "dictionary.cpp"
            $land_lhs_true50$$for_inc107$29: do { 
              if (__label__ == 19) {
  
                var $39=$p; //@line 1158 "dictionary.cpp"
                var $arrayidx51=(($39)&4294967295); //@line 1158 "dictionary.cpp"
                var $40=HEAPU8[($arrayidx51)]; //@line 1158 "dictionary.cpp"
                var $idxprom52=((($40))&255); //@line 1158 "dictionary.cpp"
                var $arrayidx53=((_phoneme_tab+$idxprom52*4)&4294967295); //@line 1158 "dictionary.cpp"
                var $41=HEAP32[(($arrayidx53)>>2)]; //@line 1158 "dictionary.cpp"
                var $phflags=(($41+4)&4294967295); //@line 1158 "dictionary.cpp"
                var $42=HEAP32[(($phflags)>>2)]; //@line 1158 "dictionary.cpp"
                var $and54=($42) & 1048576; //@line 1158 "dictionary.cpp"
                var $tobool55=((($and54))|0)!=0; //@line 1158 "dictionary.cpp"
                if ($tobool55) { __label__ = 32;break $land_lhs_true50$$for_inc107$29; } //@line 1158 "dictionary.cpp"
  
                $weight=0; //@line 1160 "dictionary.cpp"
                $lengthened=0; //@line 1161 "dictionary.cpp"
                var $43=$p; //@line 1163 "dictionary.cpp"
                var $arrayidx57=(($43+1)&4294967295); //@line 1163 "dictionary.cpp"
                var $44=HEAPU8[($arrayidx57)]; //@line 1163 "dictionary.cpp"
                var $idxprom58=((($44))&255); //@line 1163 "dictionary.cpp"
                var $arrayidx59=((_phoneme_tab+$idxprom58*4)&4294967295); //@line 1163 "dictionary.cpp"
                var $45=HEAP32[(($arrayidx59)>>2)]; //@line 1163 "dictionary.cpp"
                var $code=(($45+10)&4294967295); //@line 1163 "dictionary.cpp"
                var $46=HEAPU8[($code)]; //@line 1163 "dictionary.cpp"
                var $conv60=((($46))&255); //@line 1163 "dictionary.cpp"
                var $cmp61=((($conv60))|0)==12; //@line 1163 "dictionary.cpp"
                if ($cmp61) { __label__ = 21;; } else { __label__ = 22;; } //@line 1163 "dictionary.cpp"
                $if_end63_thread$$if_end63$32: do { 
                  if (__label__ == 21) {
  
                    $lengthened=1; //@line 1164 "dictionary.cpp"
                    __label__ = 24;break $if_end63_thread$$if_end63$32; //@line 1166 "dictionary.cpp"
                  }
                  else if (__label__ == 22) {
  
                    var $_pr3=$lengthened; //@line 1166 "dictionary.cpp"
                    var $tobool64=((($_pr3))|0)!=0; //@line 1166 "dictionary.cpp"
                    if ($tobool64) { __label__ = 24;break $if_end63_thread$$if_end63$32; } //@line 1166 "dictionary.cpp"
  
                    var $47=$p; //@line 1166 "dictionary.cpp"
                    var $arrayidx65=(($47)&4294967295); //@line 1166 "dictionary.cpp"
                    var $48=HEAPU8[($arrayidx65)]; //@line 1166 "dictionary.cpp"
                    var $idxprom66=((($48))&255); //@line 1166 "dictionary.cpp"
                    var $arrayidx67=((_phoneme_tab+$idxprom66*4)&4294967295); //@line 1166 "dictionary.cpp"
                    var $49=HEAP32[(($arrayidx67)>>2)]; //@line 1166 "dictionary.cpp"
                    var $phflags68=(($49+4)&4294967295); //@line 1166 "dictionary.cpp"
                    var $50=HEAP32[(($phflags68)>>2)]; //@line 1166 "dictionary.cpp"
                    var $and69=($50) & 2097152; //@line 1166 "dictionary.cpp"
                    var $tobool70=((($and69))|0)!=0; //@line 1166 "dictionary.cpp"
                    if ($tobool70) { __label__ = 24;break $if_end63_thread$$if_end63$32; } else { __label__ = 25;break $if_end63_thread$$if_end63$32; } //@line 1166 "dictionary.cpp"
                  }
                } while(0);
                if (__label__ == 24) {
  
                  var $51=$weight; //@line 1169 "dictionary.cpp"
                  var $inc72=((($51)+1)&4294967295); //@line 1169 "dictionary.cpp"
                  $weight=$inc72; //@line 1169 "dictionary.cpp"
                  ; //@line 1170 "dictionary.cpp"
                }
  
                var $52=$weight; //@line 1171 "dictionary.cpp"
                var $conv74=((($52)) & 255); //@line 1171 "dictionary.cpp"
                var $53=$ix; //@line 1171 "dictionary.cpp"
                var $arrayidx75=(($vowel_length+$53)&4294967295); //@line 1171 "dictionary.cpp"
                HEAP8[($arrayidx75)]=$conv74; //@line 1171 "dictionary.cpp"
                var $54=$lengthened; //@line 1173 "dictionary.cpp"
                var $tobool76=((($54))|0)!=0; //@line 1173 "dictionary.cpp"
                if ($tobool76) { __label__ = 26;; } else { __label__ = 27;; } //@line 1173 "dictionary.cpp"
                if (__label__ == 26) {
  
                  var $55=$p; //@line 1173 "dictionary.cpp"
                  var $incdec_ptr=(($55+1)&4294967295); //@line 1173 "dictionary.cpp"
                  $p=$incdec_ptr; //@line 1173 "dictionary.cpp"
                  ; //@line 1173 "dictionary.cpp"
                }
  
                var $56=$p; //@line 1175 "dictionary.cpp"
                var $arrayidx79=(($56+1)&4294967295); //@line 1175 "dictionary.cpp"
                var $57=HEAPU8[($arrayidx79)]; //@line 1175 "dictionary.cpp"
                var $idxprom80=((($57))&255); //@line 1175 "dictionary.cpp"
                var $arrayidx81=((_phoneme_tab+$idxprom80*4)&4294967295); //@line 1175 "dictionary.cpp"
                var $58=HEAP32[(($arrayidx81)>>2)]; //@line 1175 "dictionary.cpp"
                var $type82=(($58+11)&4294967295); //@line 1175 "dictionary.cpp"
                var $59=HEAPU8[($type82)]; //@line 1175 "dictionary.cpp"
                var $idxprom83=((($59))&255); //@line 1175 "dictionary.cpp"
                var $arrayidx84=((__ZZ13SetWordStressP10TranslatorPcPjiiE15consonant_types+$idxprom83)&4294967295); //@line 1175 "dictionary.cpp"
                var $60=HEAP8[($arrayidx84)]; //@line 1175 "dictionary.cpp"
                var $tobool85=(tempInt=(($60)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1175 "dictionary.cpp"
                if ($tobool85) { __label__ = 28;; } else { __label__ = 31;; } //@line 1175 "dictionary.cpp"
                $land_lhs_true86$$if_end102$42: do { 
                  if (__label__ == 28) {
  
                    var $61=$p; //@line 1175 "dictionary.cpp"
                    var $arrayidx87=(($61+2)&4294967295); //@line 1175 "dictionary.cpp"
                    var $62=HEAPU8[($arrayidx87)]; //@line 1175 "dictionary.cpp"
                    var $idxprom88=((($62))&255); //@line 1175 "dictionary.cpp"
                    var $arrayidx89=((_phoneme_tab+$idxprom88*4)&4294967295); //@line 1175 "dictionary.cpp"
                    var $63=HEAP32[(($arrayidx89)>>2)]; //@line 1175 "dictionary.cpp"
                    var $type90=(($63+11)&4294967295); //@line 1175 "dictionary.cpp"
                    var $64=HEAPU8[($type90)]; //@line 1175 "dictionary.cpp"
                    var $conv91=((($64))&255); //@line 1175 "dictionary.cpp"
                    var $cmp92=((($conv91))|0)!=2; //@line 1175 "dictionary.cpp"
                    if ($cmp92) { __label__ = 30;; } else { __label__ = 29;; } //@line 1175 "dictionary.cpp"
                    if (__label__ == 29) {
  
                      var $65=$p; //@line 1175 "dictionary.cpp"
                      var $arrayidx94=(($65+1)&4294967295); //@line 1175 "dictionary.cpp"
                      var $66=HEAPU8[($arrayidx94)]; //@line 1175 "dictionary.cpp"
                      var $idxprom95=((($66))&255); //@line 1175 "dictionary.cpp"
                      var $arrayidx96=((_phoneme_tab+$idxprom95*4)&4294967295); //@line 1175 "dictionary.cpp"
                      var $67=HEAP32[(($arrayidx96)>>2)]; //@line 1175 "dictionary.cpp"
                      var $phflags97=(($67+4)&4294967295); //@line 1175 "dictionary.cpp"
                      var $68=HEAP32[(($phflags97)>>2)]; //@line 1175 "dictionary.cpp"
                      var $and98=($68) & 2097152; //@line 1175 "dictionary.cpp"
                      var $tobool99=((($and98))|0)!=0; //@line 1175 "dictionary.cpp"
                      if (!($tobool99)) { __label__ = 31;break $land_lhs_true86$$if_end102$42; } //@line 1175 "dictionary.cpp"
                    }
  
                    var $69=$weight; //@line 1178 "dictionary.cpp"
                    var $inc101=((($69)+1)&4294967295); //@line 1178 "dictionary.cpp"
                    $weight=$inc101; //@line 1178 "dictionary.cpp"
                    ; //@line 1179 "dictionary.cpp"
                  }
                } while(0);
  
                var $70=$weight; //@line 1180 "dictionary.cpp"
                var $conv103=((($70)) & 255); //@line 1180 "dictionary.cpp"
                var $71=$ix; //@line 1180 "dictionary.cpp"
                var $arrayidx104=(($syllable_weight+$71)&4294967295); //@line 1180 "dictionary.cpp"
                HEAP8[($arrayidx104)]=$conv103; //@line 1180 "dictionary.cpp"
                var $72=$ix; //@line 1181 "dictionary.cpp"
                var $inc105=((($72)+1)&4294967295); //@line 1181 "dictionary.cpp"
                $ix=$inc105; //@line 1181 "dictionary.cpp"
                ; //@line 1182 "dictionary.cpp"
              }
            } while(0);
  
            var $73=$p; //@line 1156 "dictionary.cpp"
            var $incdec_ptr108=(($73+1)&4294967295); //@line 1156 "dictionary.cpp"
            $p=$incdec_ptr108; //@line 1156 "dictionary.cpp"
            var $74=$p; //@line 1156 "dictionary.cpp"
            var $75=HEAPU8[($74)]; //@line 1156 "dictionary.cpp"
            var $conv43=((($75))&255); //@line 1156 "dictionary.cpp"
            var $cmp44=((($conv43))|0)!=0; //@line 1156 "dictionary.cpp"
            if ($cmp44) { __label__ = 18;continue $for_body45$27; } else { __label__ = 33;break $for_body45$$for_end109$26; } //@line 1156 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $76=$tr_addr; //@line 1185 "dictionary.cpp"
      var $langopts110=(($76)&4294967295); //@line 1185 "dictionary.cpp"
      var $stress_rule=(($langopts110+8)&4294967295); //@line 1185 "dictionary.cpp"
      var $77=HEAP32[(($stress_rule)>>2)]; //@line 1185 "dictionary.cpp"
      if ($77 == 8) {
        __label__ = 34;;
      }
      else if ($77 == 1) {
        __label__ = 36;;
      }
      else if ($77 == 10) {
        __label__ = 41;;
      }
      else if ($77 == 2) {
        __label__ = 44;;
      }
      else if ($77 == 3) {
        __label__ = 68;;
      }
      else if ($77 == 4) {
        __label__ = 75;;
      }
      else if ($77 == 5) {
        __label__ = 81;;
      }
      else if ($77 == 6) {
        __label__ = 89;;
      }
      else if ($77 == 7) {
        __label__ = 101;;
      }
      else if ($77 == 9) {
        __label__ = 108;;
      }
      else {
      __label__ = 112;;
      }
      
      $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50: do { 
        if (__label__ == 34) {
  
          var $arrayidx111=(($syllable_weight+1)&4294967295); //@line 1189 "dictionary.cpp"
          var $78=HEAP8[($arrayidx111)]; //@line 1189 "dictionary.cpp"
          var $conv112=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 1189 "dictionary.cpp"
          var $cmp113=((($conv112))|0) > 0; //@line 1189 "dictionary.cpp"
          if ($cmp113) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1189 "dictionary.cpp"
  
          var $arrayidx115=(($syllable_weight+2)&4294967295); //@line 1189 "dictionary.cpp"
          var $79=HEAP8[($arrayidx115)]; //@line 1189 "dictionary.cpp"
          var $conv116=(tempInt=(($79)),(tempInt>=128?tempInt-256:tempInt)); //@line 1189 "dictionary.cpp"
          var $cmp117=((($conv116))|0)==0; //@line 1189 "dictionary.cpp"
          if ($cmp117) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } else { __label__ = 36;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1189 "dictionary.cpp"
        }
        else if (__label__ == 41) {
  
          var $84=HEAP32[(($stressed_syllable)>>2)]; //@line 1206 "dictionary.cpp"
          var $cmp131=((($84))|0)==0; //@line 1206 "dictionary.cpp"
          if (!($cmp131)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1206 "dictionary.cpp"
  
          var $85=HEAP32[(($vowel_count)>>2)]; //@line 1208 "dictionary.cpp"
          var $cmp133=((($85))|0) < 4; //@line 1208 "dictionary.cpp"
          if (!($cmp133)) { __label__ = 44;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1208 "dictionary.cpp"
  
          var $86=HEAP32[(($vowel_count)>>2)]; //@line 1210 "dictionary.cpp"
          var $sub135=((($86)-1)&4294967295); //@line 1210 "dictionary.cpp"
          var $arrayidx136=(($vowel_stress+$sub135)&4294967295); //@line 1210 "dictionary.cpp"
          HEAP8[($arrayidx136)]=4; //@line 1210 "dictionary.cpp"
          $max_stress=4; //@line 1211 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1212 "dictionary.cpp"
        }
        else if (__label__ == 68) {
  
          var $129=HEAP32[(($stressed_syllable)>>2)]; //@line 1289 "dictionary.cpp"
          var $cmp229=((($129))|0)==0; //@line 1289 "dictionary.cpp"
          if (!($cmp229)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1289 "dictionary.cpp"
  
          var $130=HEAP32[(($vowel_count)>>2)]; //@line 1292 "dictionary.cpp"
          var $sub231=((($130)-1)&4294967295); //@line 1292 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub231; //@line 1292 "dictionary.cpp"
          __lastLabel__ = 69; ; //@line 1294 "dictionary.cpp"
          while(1) { 
  
            var $131=__lastLabel__ == 73 ? $dec239 : ($sub231); //@line 1294 "dictionary.cpp"
            var $cmp232=((($131))|0) > 0; //@line 1294 "dictionary.cpp"
            if (!($cmp232)) { __label__ = 74;break ; } //@line 1294 "dictionary.cpp"
  
            var $132=HEAP32[(($stressed_syllable)>>2)]; //@line 1297 "dictionary.cpp"
            var $arrayidx233=(($vowel_stress+$132)&4294967295); //@line 1297 "dictionary.cpp"
            var $133=HEAP8[($arrayidx233)]; //@line 1297 "dictionary.cpp"
            var $conv234=(tempInt=(($133)),(tempInt>=128?tempInt-256:tempInt)); //@line 1297 "dictionary.cpp"
            var $cmp235=((($conv234))|0) < 0; //@line 1297 "dictionary.cpp"
            var $134=HEAP32[(($stressed_syllable)>>2)]; //@line 1299 "dictionary.cpp"
            if ($cmp235) { __label__ = 72;break ; } //@line 1297 "dictionary.cpp"
  
            var $dec239=((($134)-1)&4294967295); //@line 1303 "dictionary.cpp"
            HEAP32[(($stressed_syllable)>>2)]=$dec239; //@line 1303 "dictionary.cpp"
            __lastLabel__ = 73; __label__ = 70;continue ; //@line 1304 "dictionary.cpp"
          }
          if (__label__ == 72) {
  
            var $arrayidx237=(($vowel_stress+$134)&4294967295); //@line 1299 "dictionary.cpp"
            HEAP8[($arrayidx237)]=4; //@line 1299 "dictionary.cpp"
            ; //@line 1300 "dictionary.cpp"
          }
  
          $max_stress=4; //@line 1305 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1306 "dictionary.cpp"
        }
        else if (__label__ == 75) {
  
          var $135=HEAP32[(($stressed_syllable)>>2)]; //@line 1310 "dictionary.cpp"
          var $cmp243=((($135))|0)==0; //@line 1310 "dictionary.cpp"
          if (!($cmp243)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1310 "dictionary.cpp"
  
          var $136=HEAP32[(($vowel_count)>>2)]; //@line 1312 "dictionary.cpp"
          var $sub245=((($136)-3)&4294967295); //@line 1312 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub245; //@line 1312 "dictionary.cpp"
          var $137=HEAP32[(($stressed_syllable)>>2)]; //@line 1313 "dictionary.cpp"
          var $cmp246=((($137))|0) < 1; //@line 1313 "dictionary.cpp"
          if ($cmp246) { __label__ = 77;; } else { __label__ = 78;; } //@line 1313 "dictionary.cpp"
          if (__label__ == 77) {
  
            HEAP32[(($stressed_syllable)>>2)]=1; //@line 1314 "dictionary.cpp"
            ; //@line 1314 "dictionary.cpp"
          }
  
          var $138=$max_stress; //@line 1316 "dictionary.cpp"
          var $cmp249=((($138))|0)==0; //@line 1316 "dictionary.cpp"
          if ($cmp249) { __label__ = 79;; } else { __label__ = 80;; } //@line 1316 "dictionary.cpp"
          if (__label__ == 79) {
  
            var $139=HEAP32[(($stressed_syllable)>>2)]; //@line 1318 "dictionary.cpp"
            var $arrayidx251=(($vowel_stress+$139)&4294967295); //@line 1318 "dictionary.cpp"
            HEAP8[($arrayidx251)]=4; //@line 1318 "dictionary.cpp"
            ; //@line 1319 "dictionary.cpp"
          }
  
          $max_stress=4; //@line 1320 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1321 "dictionary.cpp"
        }
        else if (__label__ == 81) {
  
          var $140=HEAP32[(($stressed_syllable)>>2)]; //@line 1326 "dictionary.cpp"
          var $cmp255=((($140))|0)==0; //@line 1326 "dictionary.cpp"
          if (!($cmp255)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1326 "dictionary.cpp"
  
          var $141=HEAP32[(($vowel_count)>>2)]; //@line 1333 "dictionary.cpp"
          var $sub257=((($141)-3)&4294967295); //@line 1333 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub257; //@line 1333 "dictionary.cpp"
          var $142=HEAP32[(($vowel_count)>>2)]; //@line 1334 "dictionary.cpp"
          var $cmp258=((($142))|0) < 16; //@line 1334 "dictionary.cpp"
          if ($cmp258) { __label__ = 83;; } else { __label__ = 88;; } //@line 1334 "dictionary.cpp"
          if (__label__ == 83) {
  
            var $143=$final_ph; //@line 1336 "dictionary.cpp"
            var $arrayidx260=((_phoneme_tab+$143*4)&4294967295); //@line 1336 "dictionary.cpp"
            var $144=HEAP32[(($arrayidx260)>>2)]; //@line 1336 "dictionary.cpp"
            var $type261=(($144+11)&4294967295); //@line 1336 "dictionary.cpp"
            var $145=HEAPU8[($type261)]; //@line 1336 "dictionary.cpp"
            var $conv262=((($145))&255); //@line 1336 "dictionary.cpp"
            var $cmp263=((($conv262))|0)==2; //@line 1336 "dictionary.cpp"
            if ($cmp263) { __label__ = 84;; } else { __label__ = 85;; } //@line 1336 "dictionary.cpp"
            if (__label__ == 84) {
  
              var $146=HEAP32[(($vowel_count)>>2)]; //@line 1337 "dictionary.cpp"
              var $arrayidx265=((__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_v+$146)&4294967295); //@line 1337 "dictionary.cpp"
              var $147=HEAP8[($arrayidx265)]; //@line 1337 "dictionary.cpp"
              var $conv266=(tempInt=(($147)),(tempInt>=128?tempInt-256:tempInt)); //@line 1337 "dictionary.cpp"
              HEAP32[(($stressed_syllable)>>2)]=$conv266; //@line 1337 "dictionary.cpp"
              ; //@line 1337 "dictionary.cpp"
            }
            else if (__label__ == 85) {
  
              var $148=$final_ph; //@line 1339 "dictionary.cpp"
              var $arrayidx268=((_phoneme_tab+$148*4)&4294967295); //@line 1339 "dictionary.cpp"
              var $149=HEAP32[(($arrayidx268)>>2)]; //@line 1339 "dictionary.cpp"
              var $type269=(($149+11)&4294967295); //@line 1339 "dictionary.cpp"
              var $150=HEAPU8[($type269)]; //@line 1339 "dictionary.cpp"
              var $conv270=((($150))&255); //@line 1339 "dictionary.cpp"
              var $cmp271=((($conv270))|0)==4; //@line 1339 "dictionary.cpp"
              var $151=HEAP32[(($vowel_count)>>2)]; //@line 1340 "dictionary.cpp"
              if ($cmp271) { __label__ = 86;; } else { __label__ = 87;; } //@line 1339 "dictionary.cpp"
              if (__label__ == 86) {
  
                var $arrayidx273=((__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_t+$151)&4294967295); //@line 1340 "dictionary.cpp"
                var $152=HEAP8[($arrayidx273)]; //@line 1340 "dictionary.cpp"
                var $conv274=(tempInt=(($152)),(tempInt>=128?tempInt-256:tempInt)); //@line 1340 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$conv274; //@line 1340 "dictionary.cpp"
                ; //@line 1340 "dictionary.cpp"
              }
              else if (__label__ == 87) {
  
                var $arrayidx276=((__ZZ13SetWordStressP10TranslatorPcPjiiE8guess_ru+$151)&4294967295); //@line 1342 "dictionary.cpp"
                var $153=HEAP8[($arrayidx276)]; //@line 1342 "dictionary.cpp"
                var $conv277=(tempInt=(($153)),(tempInt>=128?tempInt-256:tempInt)); //@line 1342 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$conv277; //@line 1342 "dictionary.cpp"
                ;
              }
            }
          }
  
          var $154=HEAP32[(($stressed_syllable)>>2)]; //@line 1344 "dictionary.cpp"
          var $arrayidx281=(($vowel_stress+$154)&4294967295); //@line 1344 "dictionary.cpp"
          HEAP8[($arrayidx281)]=4; //@line 1344 "dictionary.cpp"
          $max_stress=4; //@line 1345 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1346 "dictionary.cpp"
        }
        else if (__label__ == 89) {
  
          var $155=HEAP32[(($stressed_syllable)>>2)]; //@line 1350 "dictionary.cpp"
          var $cmp284=((($155))|0)==0; //@line 1350 "dictionary.cpp"
          if (!($cmp284)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1350 "dictionary.cpp"
  
          $max_weight=-1; //@line 1353 "dictionary.cpp"
          $ix=1; //@line 1357 "dictionary.cpp"
          var $156=$ix; //@line 1357 "dictionary.cpp"
          var $157=HEAP32[(($vowel_count)>>2)]; //@line 1357 "dictionary.cpp"
          var $sub28714=((($157)-1)&4294967295); //@line 1357 "dictionary.cpp"
          var $cmp28815=((($156))|0) < ((($sub28714))|0); //@line 1357 "dictionary.cpp"
          if ($cmp28815) { __label__ = 91;; } else { __label__ = 95;; } //@line 1357 "dictionary.cpp"
          $for_body289$$for_end302$86: do { 
            if (__label__ == 91) {
              $for_body289$87: while(1) { 
  
                var $158=$ix; //@line 1359 "dictionary.cpp"
                var $arrayidx290=(($vowel_stress+$158)&4294967295); //@line 1359 "dictionary.cpp"
                var $159=HEAP8[($arrayidx290)]; //@line 1359 "dictionary.cpp"
                var $conv291=(tempInt=(($159)),(tempInt>=128?tempInt-256:tempInt)); //@line 1359 "dictionary.cpp"
                var $cmp292=((($conv291))|0) < 0; //@line 1359 "dictionary.cpp"
                if ($cmp292) { __label__ = 92;; } else { __label__ = 94;; } //@line 1359 "dictionary.cpp"
                $if_then293$$for_inc300$89: do { 
                  if (__label__ == 92) {
  
                    var $160=$ix; //@line 1361 "dictionary.cpp"
                    var $arrayidx294=(($syllable_weight+$160)&4294967295); //@line 1361 "dictionary.cpp"
                    var $161=HEAP8[($arrayidx294)]; //@line 1361 "dictionary.cpp"
                    var $conv295=(tempInt=(($161)),(tempInt>=128?tempInt-256:tempInt)); //@line 1361 "dictionary.cpp"
                    $wt=$conv295; //@line 1361 "dictionary.cpp"
                    var $162=$max_weight; //@line 1361 "dictionary.cpp"
                    var $cmp296=((($conv295))|0) >= ((($162))|0); //@line 1361 "dictionary.cpp"
                    if (!($cmp296)) { __label__ = 94;break $if_then293$$for_inc300$89; } //@line 1361 "dictionary.cpp"
  
                    var $163=$wt; //@line 1363 "dictionary.cpp"
                    $max_weight=$163; //@line 1363 "dictionary.cpp"
                    var $164=HEAP32[(($stressed_syllable)>>2)]; //@line 1364 "dictionary.cpp"
                    $prev_stressed=$164; //@line 1364 "dictionary.cpp"
                    var $165=$ix; //@line 1365 "dictionary.cpp"
                    HEAP32[(($stressed_syllable)>>2)]=$165; //@line 1365 "dictionary.cpp"
                    ; //@line 1366 "dictionary.cpp"
                  }
                } while(0);
  
                var $166=$ix; //@line 1357 "dictionary.cpp"
                var $inc301=((($166)+1)&4294967295); //@line 1357 "dictionary.cpp"
                $ix=$inc301; //@line 1357 "dictionary.cpp"
                var $167=$ix; //@line 1357 "dictionary.cpp"
                var $168=HEAP32[(($vowel_count)>>2)]; //@line 1357 "dictionary.cpp"
                var $sub287=((($168)-1)&4294967295); //@line 1357 "dictionary.cpp"
                var $cmp288=((($167))|0) < ((($sub287))|0); //@line 1357 "dictionary.cpp"
                if ($cmp288) { __label__ = 91;continue $for_body289$87; } else { __label__ = 95;break $for_body289$$for_end302$86; } //@line 1357 "dictionary.cpp"
              }
            }
          } while(0);
  
          var $169=HEAP32[(($vowel_count)>>2)]; //@line 1370 "dictionary.cpp"
          var $sub303=((($169)-1)&4294967295); //@line 1370 "dictionary.cpp"
          var $arrayidx304=(($syllable_weight+$sub303)&4294967295); //@line 1370 "dictionary.cpp"
          var $170=HEAP8[($arrayidx304)]; //@line 1370 "dictionary.cpp"
          var $conv305=(tempInt=(($170)),(tempInt>=128?tempInt-256:tempInt)); //@line 1370 "dictionary.cpp"
          var $cmp306=((($conv305))|0)==2; //@line 1370 "dictionary.cpp"
          var $171=$max_weight; //@line 1370 "dictionary.cpp"
          if ($cmp306) { __label__ = 96;; } else { __label__ = 98;; } //@line 1370 "dictionary.cpp"
          $land_lhs_true307$$if_else311$94: do { 
            if (__label__ == 96) {
  
              var $cmp308=((($171))|0) < 2; //@line 1370 "dictionary.cpp"
              if (!($cmp308)) { __label__ = 100;break $land_lhs_true307$$if_else311$94; } //@line 1370 "dictionary.cpp"
  
              var $172=HEAP32[(($vowel_count)>>2)]; //@line 1373 "dictionary.cpp"
              var $sub310=((($172)-1)&4294967295); //@line 1373 "dictionary.cpp"
              HEAP32[(($stressed_syllable)>>2)]=$sub310; //@line 1373 "dictionary.cpp"
              ; //@line 1374 "dictionary.cpp"
            }
            else if (__label__ == 98) {
  
              var $cmp312=((($171))|0) <= 0; //@line 1376 "dictionary.cpp"
              if (!($cmp312)) { __label__ = 100;break $land_lhs_true307$$if_else311$94; } //@line 1376 "dictionary.cpp"
  
              HEAP32[(($stressed_syllable)>>2)]=1; //@line 1379 "dictionary.cpp"
              ; //@line 1380 "dictionary.cpp"
            }
          } while(0);
  
          var $173=HEAP32[(($stressed_syllable)>>2)]; //@line 1382 "dictionary.cpp"
          var $arrayidx316=(($vowel_stress+$173)&4294967295); //@line 1382 "dictionary.cpp"
          HEAP8[($arrayidx316)]=4; //@line 1382 "dictionary.cpp"
          $max_stress=4; //@line 1383 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1384 "dictionary.cpp"
        }
        else if (__label__ == 101) {
  
          var $174=HEAP32[(($stressed_syllable)>>2)]; //@line 1388 "dictionary.cpp"
          var $cmp319=((($174))|0)==0; //@line 1388 "dictionary.cpp"
          if (!($cmp319)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1388 "dictionary.cpp"
  
          var $175=HEAP32[(($vowel_count)>>2)]; //@line 1390 "dictionary.cpp"
          var $sub321=((($175)-1)&4294967295); //@line 1390 "dictionary.cpp"
          HEAP32[(($stressed_syllable)>>2)]=$sub321; //@line 1390 "dictionary.cpp"
          $ix=1; //@line 1391 "dictionary.cpp"
          ; //@line 1391 "dictionary.cpp"
          while(1) { 
  
            var $176=$ix; //@line 1391 "dictionary.cpp"
            var $177=HEAP32[(($vowel_count)>>2)]; //@line 1391 "dictionary.cpp"
            var $cmp323=((($176))|0) < ((($177))|0); //@line 1391 "dictionary.cpp"
            if (!($cmp323)) { __label__ = 107;break ; } //@line 1391 "dictionary.cpp"
  
            var $178=$ix; //@line 1393 "dictionary.cpp"
            var $arrayidx325=(($vowel_stress+$178)&4294967295); //@line 1393 "dictionary.cpp"
            var $179=HEAP8[($arrayidx325)]; //@line 1393 "dictionary.cpp"
            var $conv326=(tempInt=(($179)),(tempInt>=128?tempInt-256:tempInt)); //@line 1393 "dictionary.cpp"
            var $cmp327=((($conv326))|0)==1; //@line 1393 "dictionary.cpp"
            var $180=$ix; //@line 1395 "dictionary.cpp"
            if ($cmp327) { __label__ = 105;break ; } //@line 1393 "dictionary.cpp"
  
            var $inc332=((($180)+1)&4294967295); //@line 1391 "dictionary.cpp"
            $ix=$inc332; //@line 1391 "dictionary.cpp"
            __label__ = 103;continue ; //@line 1391 "dictionary.cpp"
          }
          if (__label__ == 105) {
  
            var $sub329=((($180)-1)&4294967295); //@line 1395 "dictionary.cpp"
            HEAP32[(($stressed_syllable)>>2)]=$sub329; //@line 1395 "dictionary.cpp"
            ; //@line 1396 "dictionary.cpp"
          }
  
          var $181=HEAP32[(($stressed_syllable)>>2)]; //@line 1399 "dictionary.cpp"
          var $arrayidx334=(($vowel_stress+$181)&4294967295); //@line 1399 "dictionary.cpp"
          HEAP8[($arrayidx334)]=4; //@line 1399 "dictionary.cpp"
          $max_stress=4; //@line 1400 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; //@line 1401 "dictionary.cpp"
        }
        else if (__label__ == 108) {
  
          $ix=1; //@line 1405 "dictionary.cpp"
          var $182=$ix; //@line 1405 "dictionary.cpp"
          var $183=HEAP32[(($vowel_count)>>2)]; //@line 1405 "dictionary.cpp"
          var $cmp33813=((($182))|0) < ((($183))|0); //@line 1405 "dictionary.cpp"
          if (!($cmp33813)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1405 "dictionary.cpp"
          while(1) { 
  
            var $184=$ix; //@line 1407 "dictionary.cpp"
            var $arrayidx340=(($vowel_stress+$184)&4294967295); //@line 1407 "dictionary.cpp"
            var $185=HEAP8[($arrayidx340)]; //@line 1407 "dictionary.cpp"
            var $conv341=(tempInt=(($185)),(tempInt>=128?tempInt-256:tempInt)); //@line 1407 "dictionary.cpp"
            var $cmp342=((($conv341))|0) < 0; //@line 1407 "dictionary.cpp"
            if ($cmp342) { __label__ = 110;; } else { __label__ = 111;; } //@line 1407 "dictionary.cpp"
            if (__label__ == 110) {
  
              var $186=$ix; //@line 1408 "dictionary.cpp"
              var $arrayidx344=(($vowel_stress+$186)&4294967295); //@line 1408 "dictionary.cpp"
              HEAP8[($arrayidx344)]=4; //@line 1408 "dictionary.cpp"
              ; //@line 1408 "dictionary.cpp"
            }
  
            var $187=$ix; //@line 1405 "dictionary.cpp"
            var $inc347=((($187)+1)&4294967295); //@line 1405 "dictionary.cpp"
            $ix=$inc347; //@line 1405 "dictionary.cpp"
            var $188=$ix; //@line 1405 "dictionary.cpp"
            var $189=HEAP32[(($vowel_count)>>2)]; //@line 1405 "dictionary.cpp"
            var $cmp338=((($188))|0) < ((($189))|0); //@line 1405 "dictionary.cpp"
            if ($cmp338) { __label__ = 109;continue ; } else { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb120$$sw_bb130$$sw_bb139$$sw_bb228$$sw_bb242$$sw_bb254$$sw_bb283$$sw_bb318$$sw_bb336$50; } //@line 1405 "dictionary.cpp"
          }
        }
      } while(0);
      $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115: do { 
        if (__label__ == 36) {
  
          var $80=HEAP32[(($stressed_syllable)>>2)]; //@line 1194 "dictionary.cpp"
          var $cmp121=((($80))|0)==0; //@line 1194 "dictionary.cpp"
          if (!($cmp121)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1194 "dictionary.cpp"
  
          var $81=HEAP32[(($vowel_count)>>2)]; //@line 1194 "dictionary.cpp"
          var $cmp123=((($81))|0) > 2; //@line 1194 "dictionary.cpp"
          if (!($cmp123)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1194 "dictionary.cpp"
  
          HEAP32[(($stressed_syllable)>>2)]=2; //@line 1196 "dictionary.cpp"
          var $82=$max_stress; //@line 1197 "dictionary.cpp"
          var $cmp125=((($82))|0)==0; //@line 1197 "dictionary.cpp"
          if ($cmp125) { __label__ = 39;; } else { __label__ = 40;; } //@line 1197 "dictionary.cpp"
          if (__label__ == 39) {
  
            var $83=HEAP32[(($stressed_syllable)>>2)]; //@line 1199 "dictionary.cpp"
            var $arrayidx127=(($vowel_stress+$83)&4294967295); //@line 1199 "dictionary.cpp"
            HEAP8[($arrayidx127)]=4; //@line 1199 "dictionary.cpp"
            ; //@line 1200 "dictionary.cpp"
          }
  
          $max_stress=4; //@line 1201 "dictionary.cpp"
          __label__ = 114;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; //@line 1202 "dictionary.cpp"
        }
        else if (__label__ == 44) {
  
          var $_pr5=HEAP32[(($stressed_syllable)>>2)]; //@line 1219 "dictionary.cpp"
          var $cmp140=((($_pr5))|0)==0; //@line 1219 "dictionary.cpp"
          if (!($cmp140)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1219 "dictionary.cpp"
  
          $max_stress=4; //@line 1222 "dictionary.cpp"
          var $87=HEAP32[(($vowel_count)>>2)]; //@line 1224 "dictionary.cpp"
          var $cmp142=((($87))|0) > 2; //@line 1224 "dictionary.cpp"
          if ($cmp142) { __label__ = 46;; } else { __label__ = 63;; } //@line 1224 "dictionary.cpp"
          $if_then143$$if_else208$124: do { 
            if (__label__ == 46) {
  
              var $88=HEAP32[(($vowel_count)>>2)]; //@line 1226 "dictionary.cpp"
              var $sub144=((($88)-2)&4294967295); //@line 1226 "dictionary.cpp"
              HEAP32[(($stressed_syllable)>>2)]=$sub144; //@line 1226 "dictionary.cpp"
              var $89=$stressflags; //@line 1228 "dictionary.cpp"
              var $and145=($89) & 768; //@line 1228 "dictionary.cpp"
              var $tobool146=((($and145))|0)!=0; //@line 1228 "dictionary.cpp"
              if ($tobool146) { __label__ = 47;; } else { __label__ = 55;; } //@line 1228 "dictionary.cpp"
              $if_then147$$if_end179$126: do { 
                if (__label__ == 47) {
  
                  var $90=$final_ph; //@line 1231 "dictionary.cpp"
                  var $arrayidx148=((_phoneme_tab+$90*4)&4294967295); //@line 1231 "dictionary.cpp"
                  var $91=HEAP32[(($arrayidx148)>>2)]; //@line 1231 "dictionary.cpp"
                  var $type149=(($91+11)&4294967295); //@line 1231 "dictionary.cpp"
                  var $92=HEAPU8[($type149)]; //@line 1231 "dictionary.cpp"
                  var $conv150=((($92))&255); //@line 1231 "dictionary.cpp"
                  var $cmp151=((($conv150))|0)!=2; //@line 1231 "dictionary.cpp"
                  if (!($cmp151)) { __label__ = 55;break $if_then147$$if_end179$126; } //@line 1231 "dictionary.cpp"
  
                  var $93=$stressflags; //@line 1233 "dictionary.cpp"
                  var $and153=($93) & 256; //@line 1233 "dictionary.cpp"
                  var $tobool154=((($and153))|0)!=0; //@line 1233 "dictionary.cpp"
                  if ($tobool154) { __label__ = 49;; } else { __label__ = 50;; } //@line 1233 "dictionary.cpp"
                  if (__label__ == 49) {
  
                    var $94=HEAP32[(($vowel_count)>>2)]; //@line 1235 "dictionary.cpp"
                    var $sub156=((($94)-1)&4294967295); //@line 1235 "dictionary.cpp"
                    HEAP32[(($stressed_syllable)>>2)]=$sub156; //@line 1235 "dictionary.cpp"
                    ; //@line 1236 "dictionary.cpp"
                  }
                  else if (__label__ == 50) {
  
                    var $95=$final_ph; //@line 1239 "dictionary.cpp"
                    var $arrayidx157=((_phoneme_tab+$95*4)&4294967295); //@line 1239 "dictionary.cpp"
                    var $96=HEAP32[(($arrayidx157)>>2)]; //@line 1239 "dictionary.cpp"
                    var $mnemonic=(($96)&4294967295); //@line 1239 "dictionary.cpp"
                    var $97=HEAP32[(($mnemonic)>>2)]; //@line 1239 "dictionary.cpp"
                    $mnem=$97; //@line 1239 "dictionary.cpp"
                    var $98=$final_ph2; //@line 1240 "dictionary.cpp"
                    var $arrayidx158=((_phoneme_tab+$98*4)&4294967295); //@line 1240 "dictionary.cpp"
                    var $99=HEAP32[(($arrayidx158)>>2)]; //@line 1240 "dictionary.cpp"
                    var $mnemonic159=(($99)&4294967295); //@line 1240 "dictionary.cpp"
                    var $100=HEAP32[(($mnemonic159)>>2)]; //@line 1240 "dictionary.cpp"
                    $mnem2=$100; //@line 1240 "dictionary.cpp"
                    var $101=$mnem; //@line 1242 "dictionary.cpp"
                    var $cmp160=((($101))|0)==115; //@line 1242 "dictionary.cpp"
                    if ($cmp160) { __label__ = 51;; } else { __label__ = 52;; } //@line 1242 "dictionary.cpp"
                    if (__label__ == 51) {
  
                      var $102=$mnem2; //@line 1242 "dictionary.cpp"
                      var $cmp162=((($102))|0)==110; //@line 1242 "dictionary.cpp"
                      if ($cmp162) { __label__ = 55;break $if_then147$$if_end179$126; } //@line 1242 "dictionary.cpp"
                    }
  
                    var $103=$mnem; //@line 1247 "dictionary.cpp"
                    var $cmp165=((($103))|0)!=110; //@line 1247 "dictionary.cpp"
                    var $104=$mnem; //@line 1247 "dictionary.cpp"
                    var $cmp167=((($104))|0)!=115; //@line 1247 "dictionary.cpp"
                    var $or_cond=($cmp165) & ($cmp167); //@line 1247 "dictionary.cpp"
                    if ($or_cond) { __label__ = 54;; } else { __label__ = 53;; } //@line 1247 "dictionary.cpp"
                    if (__label__ == 53) {
  
                      var $105=$final_ph2; //@line 1247 "dictionary.cpp"
                      var $arrayidx169=((_phoneme_tab+$105*4)&4294967295); //@line 1247 "dictionary.cpp"
                      var $106=HEAP32[(($arrayidx169)>>2)]; //@line 1247 "dictionary.cpp"
                      var $type170=(($106+11)&4294967295); //@line 1247 "dictionary.cpp"
                      var $107=HEAPU8[($type170)]; //@line 1247 "dictionary.cpp"
                      var $conv171=((($107))&255); //@line 1247 "dictionary.cpp"
                      var $cmp172=((($conv171))|0)!=2; //@line 1247 "dictionary.cpp"
                      if (!($cmp172)) { __label__ = 55;break $if_then147$$if_end179$126; } //@line 1247 "dictionary.cpp"
                    }
  
                    var $108=HEAP32[(($vowel_count)>>2)]; //@line 1249 "dictionary.cpp"
                    var $sub174=((($108)-1)&4294967295); //@line 1249 "dictionary.cpp"
                    HEAP32[(($stressed_syllable)>>2)]=$sub174; //@line 1249 "dictionary.cpp"
                    ; //@line 1250 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $109=$stressflags; //@line 1254 "dictionary.cpp"
              var $and180=($109) & 524288; //@line 1254 "dictionary.cpp"
              var $tobool181=((($and180))|0)!=0; //@line 1254 "dictionary.cpp"
              if ($tobool181) { __label__ = 56;; } else { __label__ = 58;; } //@line 1254 "dictionary.cpp"
              $if_then182$$if_end193$139: do { 
                if (__label__ == 56) {
  
                  var $110=HEAP32[(($vowel_count)>>2)]; //@line 1257 "dictionary.cpp"
                  var $sub183=((($110)-1)&4294967295); //@line 1257 "dictionary.cpp"
                  var $arrayidx184=(($vowel_length+$sub183)&4294967295); //@line 1257 "dictionary.cpp"
                  var $111=HEAP8[($arrayidx184)]; //@line 1257 "dictionary.cpp"
                  var $conv185=(tempInt=(($111)),(tempInt>=128?tempInt-256:tempInt)); //@line 1257 "dictionary.cpp"
                  var $112=HEAP32[(($vowel_count)>>2)]; //@line 1257 "dictionary.cpp"
                  var $sub186=((($112)-2)&4294967295); //@line 1257 "dictionary.cpp"
                  var $arrayidx187=(($vowel_length+$sub186)&4294967295); //@line 1257 "dictionary.cpp"
                  var $113=HEAP8[($arrayidx187)]; //@line 1257 "dictionary.cpp"
                  var $conv188=(tempInt=(($113)),(tempInt>=128?tempInt-256:tempInt)); //@line 1257 "dictionary.cpp"
                  var $cmp189=((($conv185))|0) > ((($conv188))|0); //@line 1257 "dictionary.cpp"
                  if (!($cmp189)) { __label__ = 58;break $if_then182$$if_end193$139; } //@line 1257 "dictionary.cpp"
  
                  var $114=HEAP32[(($vowel_count)>>2)]; //@line 1259 "dictionary.cpp"
                  var $sub191=((($114)-1)&4294967295); //@line 1259 "dictionary.cpp"
                  HEAP32[(($stressed_syllable)>>2)]=$sub191; //@line 1259 "dictionary.cpp"
                  ; //@line 1260 "dictionary.cpp"
                }
              } while(0);
  
              var $115=HEAP32[(($stressed_syllable)>>2)]; //@line 1263 "dictionary.cpp"
              var $arrayidx194=(($vowel_stress+$115)&4294967295); //@line 1263 "dictionary.cpp"
              var $116=HEAP8[($arrayidx194)]; //@line 1263 "dictionary.cpp"
              var $conv195=(tempInt=(($116)),(tempInt>=128?tempInt-256:tempInt)); //@line 1263 "dictionary.cpp"
              var $cmp196=((($conv195))|0)==0; //@line 1263 "dictionary.cpp"
              if ($cmp196) { __lastLabel__ = 58; __label__ = 60;; } else { __lastLabel__ = 58; __label__ = 59;; } //@line 1263 "dictionary.cpp"
              if (__label__ == 59) {
  
                var $117=HEAP32[(($stressed_syllable)>>2)]; //@line 1263 "dictionary.cpp"
                var $arrayidx198=(($vowel_stress+$117)&4294967295); //@line 1263 "dictionary.cpp"
                var $118=HEAP8[($arrayidx198)]; //@line 1263 "dictionary.cpp"
                var $conv199=(tempInt=(($118)),(tempInt>=128?tempInt-256:tempInt)); //@line 1263 "dictionary.cpp"
                var $cmp200=((($conv199))|0)==1; //@line 1263 "dictionary.cpp"
                if ($cmp200) { __lastLabel__ = 59; ; } else { __lastLabel__ = 59; __label__ = 64;break $if_then143$$if_else208$124; } //@line 1263 "dictionary.cpp"
              }
  
              var $119=__lastLabel__ == 59 ? $117 : ($115); //@line 1266 "dictionary.cpp"
              var $cmp202=((($119))|0) > 1; //@line 1266 "dictionary.cpp"
              var $120=HEAP32[(($stressed_syllable)>>2)]; //@line 1267 "dictionary.cpp"
              if ($cmp202) { __label__ = 61;; } else { __label__ = 62;; } //@line 1266 "dictionary.cpp"
              if (__label__ == 61) {
  
                var $dec=((($120)-1)&4294967295); //@line 1267 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$dec; //@line 1267 "dictionary.cpp"
                ; //@line 1267 "dictionary.cpp"
              }
              else if (__label__ == 62) {
  
                var $inc205=((($120)+1)&4294967295); //@line 1269 "dictionary.cpp"
                HEAP32[(($stressed_syllable)>>2)]=$inc205; //@line 1269 "dictionary.cpp"
                ;
              }
            }
            else if (__label__ == 63) {
  
              HEAP32[(($stressed_syllable)>>2)]=1; //@line 1274 "dictionary.cpp"
              ;
            }
          } while(0);
  
          var $121=HEAP32[(($stressed_syllable)>>2)]; //@line 1278 "dictionary.cpp"
          var $arrayidx210=(($vowel_stress+$121)&4294967295); //@line 1278 "dictionary.cpp"
          var $122=HEAP8[($arrayidx210)]; //@line 1278 "dictionary.cpp"
          var $conv211=(tempInt=(($122)),(tempInt>=128?tempInt-256:tempInt)); //@line 1278 "dictionary.cpp"
          var $cmp212=((($conv211))|0) < 0; //@line 1278 "dictionary.cpp"
          if (!($cmp212)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1278 "dictionary.cpp"
  
          var $123=HEAP32[(($stressed_syllable)>>2)]; //@line 1281 "dictionary.cpp"
          var $sub214=((($123)-1)&4294967295); //@line 1281 "dictionary.cpp"
          var $arrayidx215=(($vowel_stress+$sub214)&4294967295); //@line 1281 "dictionary.cpp"
          var $124=HEAP8[($arrayidx215)]; //@line 1281 "dictionary.cpp"
          var $conv216=(tempInt=(($124)),(tempInt>=128?tempInt-256:tempInt)); //@line 1281 "dictionary.cpp"
          var $cmp217=((($conv216))|0) < 4; //@line 1281 "dictionary.cpp"
          if ($cmp217) { __label__ = 67;; } else { __label__ = 66;; } //@line 1281 "dictionary.cpp"
          if (__label__ == 66) {
  
            var $125=HEAP32[(($stressed_syllable)>>2)]; //@line 1281 "dictionary.cpp"
            var $add=((($125)+1)&4294967295); //@line 1281 "dictionary.cpp"
            var $arrayidx219=(($vowel_stress+$add)&4294967295); //@line 1281 "dictionary.cpp"
            var $126=HEAP8[($arrayidx219)]; //@line 1281 "dictionary.cpp"
            var $conv220=(tempInt=(($126)),(tempInt>=128?tempInt-256:tempInt)); //@line 1281 "dictionary.cpp"
            var $cmp221=((($conv220))|0) < 4; //@line 1281 "dictionary.cpp"
            if (!($cmp221)) { __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; } //@line 1281 "dictionary.cpp"
          }
  
          var $127=$max_stress; //@line 1282 "dictionary.cpp"
          var $conv223=((($127)) & 255); //@line 1282 "dictionary.cpp"
          var $128=HEAP32[(($stressed_syllable)>>2)]; //@line 1282 "dictionary.cpp"
          var $arrayidx224=(($vowel_stress+$128)&4294967295); //@line 1282 "dictionary.cpp"
          HEAP8[($arrayidx224)]=$conv223; //@line 1282 "dictionary.cpp"
          __label__ = 112;break $sw_epilog$$sw_bb120$$if_else351$$sw_bb139$115; //@line 1282 "dictionary.cpp"
        }
      } while(0);
      $sw_epilog$$if_else351$155: do { 
        if (__label__ == 112) {
  
          var $_pr9=$max_stress; //@line 1414 "dictionary.cpp"
          var $cmp349=((($_pr9))|0) < 4; //@line 1414 "dictionary.cpp"
          if (!($cmp349)) { __label__ = 114;break $sw_epilog$$if_else351$155; } //@line 1414 "dictionary.cpp"
  
          $stress=4; //@line 1415 "dictionary.cpp"
          __label__ = 115;break $sw_epilog$$if_else351$155; //@line 1415 "dictionary.cpp"
        }
      } while(0);
      if (__label__ == 114) {
  
        $stress=3; //@line 1417 "dictionary.cpp"
        ;
      }
  
      var $190=$stressflags; //@line 1420 "dictionary.cpp"
      var $and353=($190) & 4096; //@line 1420 "dictionary.cpp"
      var $tobool354=((($and353))|0)!=0; //@line 1420 "dictionary.cpp"
      if ($tobool354) { __label__ = 116;; } else { __label__ = 121;; } //@line 1420 "dictionary.cpp"
      $land_lhs_true355$$if_end370$161: do { 
        if (__label__ == 116) {
  
          var $191=HEAP32[(($vowel_count)>>2)]; //@line 1420 "dictionary.cpp"
          var $cmp356=((($191))|0)==2; //@line 1420 "dictionary.cpp"
          if (!($cmp356)) { __label__ = 121;break $land_lhs_true355$$if_end370$161; } //@line 1420 "dictionary.cpp"
  
          var $arrayidx358=(($vowel_stress+1)&4294967295); //@line 1423 "dictionary.cpp"
          var $192=HEAP8[($arrayidx358)]; //@line 1423 "dictionary.cpp"
          var $conv359=(tempInt=(($192)),(tempInt>=128?tempInt-256:tempInt)); //@line 1423 "dictionary.cpp"
          var $cmp360=((($conv359))|0)==4; //@line 1423 "dictionary.cpp"
          if ($cmp360) { __label__ = 118;; } else { __label__ = 119;; } //@line 1423 "dictionary.cpp"
          if (__label__ == 118) {
  
            var $arrayidx362=(($vowel_stress+2)&4294967295); //@line 1424 "dictionary.cpp"
            HEAP8[($arrayidx362)]=3; //@line 1424 "dictionary.cpp"
            ; //@line 1424 "dictionary.cpp"
          }
  
          var $arrayidx364=(($vowel_stress+2)&4294967295); //@line 1425 "dictionary.cpp"
          var $193=HEAP8[($arrayidx364)]; //@line 1425 "dictionary.cpp"
          var $conv365=(tempInt=(($193)),(tempInt>=128?tempInt-256:tempInt)); //@line 1425 "dictionary.cpp"
          var $cmp366=((($conv365))|0)==4; //@line 1425 "dictionary.cpp"
          if (!($cmp366)) { __label__ = 121;break $land_lhs_true355$$if_end370$161; } //@line 1425 "dictionary.cpp"
  
          var $arrayidx368=(($vowel_stress+1)&4294967295); //@line 1426 "dictionary.cpp"
          HEAP8[($arrayidx368)]=3; //@line 1426 "dictionary.cpp"
          ; //@line 1426 "dictionary.cpp"
        }
      } while(0);
  
      var $194=$stressflags; //@line 1429 "dictionary.cpp"
      var $and371=($194) & 8192; //@line 1429 "dictionary.cpp"
      var $tobool372=((($and371))|0)!=0; //@line 1429 "dictionary.cpp"
      if ($tobool372) { __label__ = 122;; } else { __label__ = 126;; } //@line 1429 "dictionary.cpp"
      $land_lhs_true373$$if_end386$169: do { 
        if (__label__ == 122) {
  
          var $arrayidx374=(($vowel_stress+1)&4294967295); //@line 1429 "dictionary.cpp"
          var $195=HEAP8[($arrayidx374)]; //@line 1429 "dictionary.cpp"
          var $conv375=(tempInt=(($195)),(tempInt>=128?tempInt-256:tempInt)); //@line 1429 "dictionary.cpp"
          var $cmp376=((($conv375))|0) < 0; //@line 1429 "dictionary.cpp"
          if (!($cmp376)) { __label__ = 126;break $land_lhs_true373$$if_end386$169; } //@line 1429 "dictionary.cpp"
  
          var $196=HEAP32[(($vowel_count)>>2)]; //@line 1432 "dictionary.cpp"
          var $cmp378=((($196))|0) > 2; //@line 1432 "dictionary.cpp"
          if (!($cmp378)) { __label__ = 126;break $land_lhs_true373$$if_end386$169; } //@line 1432 "dictionary.cpp"
  
          var $arrayidx380=(($vowel_stress+2)&4294967295); //@line 1432 "dictionary.cpp"
          var $197=HEAP8[($arrayidx380)]; //@line 1432 "dictionary.cpp"
          var $conv381=(tempInt=(($197)),(tempInt>=128?tempInt-256:tempInt)); //@line 1432 "dictionary.cpp"
          var $cmp382=((($conv381))|0) >= 4; //@line 1432 "dictionary.cpp"
          if (!($cmp382)) { __label__ = 126;break $land_lhs_true373$$if_end386$169; } //@line 1432 "dictionary.cpp"
  
          var $arrayidx384=(($vowel_stress+1)&4294967295); //@line 1434 "dictionary.cpp"
          HEAP8[($arrayidx384)]=3; //@line 1434 "dictionary.cpp"
          ; //@line 1435 "dictionary.cpp"
        }
      } while(0);
  
      $done=0; //@line 1438 "dictionary.cpp"
      $first_primary=0; //@line 1439 "dictionary.cpp"
      $v=1; //@line 1440 "dictionary.cpp"
      var $198=$v; //@line 1440 "dictionary.cpp"
      var $199=HEAP32[(($vowel_count)>>2)]; //@line 1440 "dictionary.cpp"
      var $cmp38818=((($198))|0) < ((($199))|0); //@line 1440 "dictionary.cpp"
      if ($cmp38818) { __label__ = 127;; } else { __label__ = 151;; } //@line 1440 "dictionary.cpp"
      $for_body389$$for_end471$175: do { 
        if (__label__ == 127) {
          $for_body389$176: while(1) { 
  
            var $200=$v; //@line 1442 "dictionary.cpp"
            var $arrayidx390=(($vowel_stress+$200)&4294967295); //@line 1442 "dictionary.cpp"
            var $201=HEAP8[($arrayidx390)]; //@line 1442 "dictionary.cpp"
            var $conv391=(tempInt=(($201)),(tempInt>=128?tempInt-256:tempInt)); //@line 1442 "dictionary.cpp"
            var $cmp392=((($conv391))|0) < 0; //@line 1442 "dictionary.cpp"
            if ($cmp392) { __label__ = 128;; } else { __label__ = 145;; } //@line 1442 "dictionary.cpp"
            $if_then393$$if_end454$178: do { 
              if (__label__ == 128) {
  
                var $202=$stressflags; //@line 1444 "dictionary.cpp"
                var $and394=($202) & 16; //@line 1444 "dictionary.cpp"
                var $tobool395=((($and394))|0)!=0; //@line 1444 "dictionary.cpp"
                if ($tobool395) { __label__ = 129;; } else { __label__ = 131;; } //@line 1444 "dictionary.cpp"
                $land_lhs_true396$$if_else402$180: do { 
                  if (__label__ == 129) {
  
                    var $203=$stress; //@line 1444 "dictionary.cpp"
                    var $cmp397=((($203))|0) < 4; //@line 1444 "dictionary.cpp"
                    if (!($cmp397)) { __label__ = 131;break $land_lhs_true396$$if_else402$180; } //@line 1444 "dictionary.cpp"
  
                    var $204=$v; //@line 1444 "dictionary.cpp"
                    var $205=HEAP32[(($vowel_count)>>2)]; //@line 1444 "dictionary.cpp"
                    var $sub399=((($205)-1)&4294967295); //@line 1444 "dictionary.cpp"
                    var $cmp400=((($204))|0)==((($sub399))|0); //@line 1444 "dictionary.cpp"
                    if ($cmp400) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1444 "dictionary.cpp"
                  }
                } while(0);
  
                var $206=$stressflags; //@line 1449 "dictionary.cpp"
                var $and403=($206) & 32768; //@line 1449 "dictionary.cpp"
                var $tobool404=((($and403))|0)!=0; //@line 1449 "dictionary.cpp"
                if ($tobool404) { __label__ = 132;; } else { __label__ = 134;; } //@line 1449 "dictionary.cpp"
                $land_lhs_true405$$if_else410$184: do { 
                  if (__label__ == 132) {
  
                    var $207=$done; //@line 1449 "dictionary.cpp"
                    var $cmp406=((($207))|0)==0; //@line 1449 "dictionary.cpp"
                    if (!($cmp406)) { __label__ = 134;break $land_lhs_true405$$if_else410$184; } //@line 1449 "dictionary.cpp"
  
                    var $208=$stress; //@line 1451 "dictionary.cpp"
                    var $conv408=((($208)) & 255); //@line 1451 "dictionary.cpp"
                    var $209=$v; //@line 1451 "dictionary.cpp"
                    var $arrayidx409=(($vowel_stress+$209)&4294967295); //@line 1451 "dictionary.cpp"
                    HEAP8[($arrayidx409)]=$conv408; //@line 1451 "dictionary.cpp"
                    $done=1; //@line 1452 "dictionary.cpp"
                    $stress=3; //@line 1453 "dictionary.cpp"
                    __label__ = 145;break $if_then393$$if_end454$178; //@line 1454 "dictionary.cpp"
                  }
                } while(0);
  
                var $210=$v; //@line 1456 "dictionary.cpp"
                var $sub411=((($210)-1)&4294967295); //@line 1456 "dictionary.cpp"
                var $arrayidx412=(($vowel_stress+$sub411)&4294967295); //@line 1456 "dictionary.cpp"
                var $211=HEAP8[($arrayidx412)]; //@line 1456 "dictionary.cpp"
                var $conv413=(tempInt=(($211)),(tempInt>=128?tempInt-256:tempInt)); //@line 1456 "dictionary.cpp"
                var $cmp414=((($conv413))|0) <= 1; //@line 1456 "dictionary.cpp"
                if (!($cmp414)) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1456 "dictionary.cpp"
  
                var $212=$v; //@line 1456 "dictionary.cpp"
                var $add416=((($212)+1)&4294967295); //@line 1456 "dictionary.cpp"
                var $arrayidx417=(($vowel_stress+$add416)&4294967295); //@line 1456 "dictionary.cpp"
                var $213=HEAP8[($arrayidx417)]; //@line 1456 "dictionary.cpp"
                var $conv418=(tempInt=(($213)),(tempInt>=128?tempInt-256:tempInt)); //@line 1456 "dictionary.cpp"
                var $cmp419=((($conv418))|0) <= 1; //@line 1456 "dictionary.cpp"
                if ($cmp419) { __label__ = 138;; } else { __label__ = 136;; } //@line 1456 "dictionary.cpp"
                if (__label__ == 136) {
  
                  var $214=$stress; //@line 1456 "dictionary.cpp"
                  var $cmp421=((($214))|0)==4; //@line 1456 "dictionary.cpp"
                  if (!($cmp421)) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1456 "dictionary.cpp"
  
                  var $215=$v; //@line 1456 "dictionary.cpp"
                  var $add423=((($215)+1)&4294967295); //@line 1456 "dictionary.cpp"
                  var $arrayidx424=(($vowel_stress+$add423)&4294967295); //@line 1456 "dictionary.cpp"
                  var $216=HEAP8[($arrayidx424)]; //@line 1456 "dictionary.cpp"
                  var $conv425=(tempInt=(($216)),(tempInt>=128?tempInt-256:tempInt)); //@line 1456 "dictionary.cpp"
                  var $cmp426=((($conv425))|0) <= 2; //@line 1456 "dictionary.cpp"
                  if (!($cmp426)) { __label__ = 145;break $if_then393$$if_end454$178; } //@line 1456 "dictionary.cpp"
                }
  
                var $217=$stress; //@line 1460 "dictionary.cpp"
                var $cmp428=((($217))|0)==3; //@line 1460 "dictionary.cpp"
                if ($cmp428) { __label__ = 139;; } else { __label__ = 140;; } //@line 1460 "dictionary.cpp"
                if (__label__ == 139) {
  
                  var $218=$stressflags; //@line 1460 "dictionary.cpp"
                  var $and430=($218) & 32; //@line 1460 "dictionary.cpp"
                  var $tobool431=((($and430))|0)!=0; //@line 1460 "dictionary.cpp"
                  if ($tobool431) { __label__ = 150;break $if_then393$$if_end454$178; } //@line 1460 "dictionary.cpp"
                }
  
                var $219=$v; //@line 1463 "dictionary.cpp"
                var $cmp434=((($219))|0) > 1; //@line 1463 "dictionary.cpp"
                if ($cmp434) { __label__ = 141;; } else { __label__ = 144;; } //@line 1463 "dictionary.cpp"
                $land_lhs_true435$$if_end448$196: do { 
                  if (__label__ == 141) {
  
                    var $220=$stressflags; //@line 1463 "dictionary.cpp"
                    var $and436=($220) & 64; //@line 1463 "dictionary.cpp"
                    var $tobool437=((($and436))|0)!=0; //@line 1463 "dictionary.cpp"
                    if (!($tobool437)) { __label__ = 144;break $land_lhs_true435$$if_end448$196; } //@line 1463 "dictionary.cpp"
  
                    var $221=$v; //@line 1463 "dictionary.cpp"
                    var $arrayidx439=(($syllable_weight+$221)&4294967295); //@line 1463 "dictionary.cpp"
                    var $222=HEAP8[($arrayidx439)]; //@line 1463 "dictionary.cpp"
                    var $conv440=(tempInt=(($222)),(tempInt>=128?tempInt-256:tempInt)); //@line 1463 "dictionary.cpp"
                    var $cmp441=((($conv440))|0)==0; //@line 1463 "dictionary.cpp"
                    if (!($cmp441)) { __label__ = 144;break $land_lhs_true435$$if_end448$196; } //@line 1463 "dictionary.cpp"
  
                    var $223=$v; //@line 1463 "dictionary.cpp"
                    var $add443=((($223)+1)&4294967295); //@line 1463 "dictionary.cpp"
                    var $arrayidx444=(($syllable_weight+$add443)&4294967295); //@line 1463 "dictionary.cpp"
                    var $224=HEAP8[($arrayidx444)]; //@line 1463 "dictionary.cpp"
                    var $conv445=(tempInt=(($224)),(tempInt>=128?tempInt-256:tempInt)); //@line 1463 "dictionary.cpp"
                    var $cmp446=((($conv445))|0) > 0; //@line 1463 "dictionary.cpp"
                    if ($cmp446) { __label__ = 150;break $if_then393$$if_end454$178; } //@line 1463 "dictionary.cpp"
                  }
                } while(0);
  
                var $225=$stress; //@line 1471 "dictionary.cpp"
                var $conv449=((($225)) & 255); //@line 1471 "dictionary.cpp"
                var $226=$v; //@line 1471 "dictionary.cpp"
                var $arrayidx450=(($vowel_stress+$226)&4294967295); //@line 1471 "dictionary.cpp"
                HEAP8[($arrayidx450)]=$conv449; //@line 1471 "dictionary.cpp"
                $done=1; //@line 1472 "dictionary.cpp"
                $stress=3; //@line 1473 "dictionary.cpp"
                __label__ = 145;break $if_then393$$if_end454$178; //@line 1474 "dictionary.cpp"
              }
            } while(0);
            $if_end454$$for_inc469$201: do { 
              if (__label__ == 145) {
  
                var $227=$v; //@line 1477 "dictionary.cpp"
                var $arrayidx455=(($vowel_stress+$227)&4294967295); //@line 1477 "dictionary.cpp"
                var $228=HEAP8[($arrayidx455)]; //@line 1477 "dictionary.cpp"
                var $conv456=(tempInt=(($228)),(tempInt>=128?tempInt-256:tempInt)); //@line 1477 "dictionary.cpp"
                var $cmp457=((($conv456))|0) >= 4; //@line 1477 "dictionary.cpp"
                if (!($cmp457)) { __label__ = 150;break $if_end454$$for_inc469$201; } //@line 1477 "dictionary.cpp"
  
                var $229=$first_primary; //@line 1479 "dictionary.cpp"
                var $cmp459=((($229))|0)==0; //@line 1479 "dictionary.cpp"
                if ($cmp459) { __label__ = 147;; } else { __label__ = 148;; } //@line 1479 "dictionary.cpp"
                if (__label__ == 147) {
  
                  var $230=$v; //@line 1480 "dictionary.cpp"
                  $first_primary=$230; //@line 1480 "dictionary.cpp"
                  ; //@line 1480 "dictionary.cpp"
                }
                else if (__label__ == 148) {
  
                  var $231=$stressflags; //@line 1482 "dictionary.cpp"
                  var $and462=($231) & 128; //@line 1482 "dictionary.cpp"
                  var $tobool463=((($and462))|0)!=0; //@line 1482 "dictionary.cpp"
                  if (!($tobool463)) { __label__ = 150;break $if_end454$$for_inc469$201; } //@line 1482 "dictionary.cpp"
  
                  var $232=$v; //@line 1485 "dictionary.cpp"
                  var $arrayidx465=(($vowel_stress+$232)&4294967295); //@line 1485 "dictionary.cpp"
                  HEAP8[($arrayidx465)]=3; //@line 1485 "dictionary.cpp"
                  ; //@line 1486 "dictionary.cpp"
                }
              }
            } while(0);
  
            var $233=$v; //@line 1440 "dictionary.cpp"
            var $inc470=((($233)+1)&4294967295); //@line 1440 "dictionary.cpp"
            $v=$inc470; //@line 1440 "dictionary.cpp"
            var $234=$v; //@line 1440 "dictionary.cpp"
            var $235=HEAP32[(($vowel_count)>>2)]; //@line 1440 "dictionary.cpp"
            var $cmp388=((($234))|0) < ((($235))|0); //@line 1440 "dictionary.cpp"
            if ($cmp388) { __label__ = 127;continue $for_body389$176; } else { __label__ = 151;break $for_body389$$for_end471$175; } //@line 1440 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $236=$unstressed_word; //@line 1490 "dictionary.cpp"
      var $tobool472=((($236))|0)!=0; //@line 1490 "dictionary.cpp"
      if ($tobool472) { __label__ = 152;; } else { __label__ = 156;; } //@line 1490 "dictionary.cpp"
      $land_lhs_true473$$if_end482$210: do { 
        if (__label__ == 152) {
  
          var $237=$tonic_addr; //@line 1490 "dictionary.cpp"
          var $cmp474=((($237))|0) < 0; //@line 1490 "dictionary.cpp"
          if (!($cmp474)) { __label__ = 156;break $land_lhs_true473$$if_end482$210; } //@line 1490 "dictionary.cpp"
  
          var $238=HEAP32[(($vowel_count)>>2)]; //@line 1492 "dictionary.cpp"
          var $cmp476=((($238))|0) <= 2; //@line 1492 "dictionary.cpp"
          var $239=$tr_addr; //@line 1493 "dictionary.cpp"
          var $langopts478=(($239)&4294967295); //@line 1493 "dictionary.cpp"
          if ($cmp476) { __label__ = 154;; } else { __label__ = 155;; } //@line 1492 "dictionary.cpp"
          if (__label__ == 154) {
  
            var $unstressed_wd1=(($langopts478+16)&4294967295); //@line 1493 "dictionary.cpp"
            var $240=HEAP32[(($unstressed_wd1)>>2)]; //@line 1493 "dictionary.cpp"
            $tonic_addr=$240; //@line 1493 "dictionary.cpp"
            ; //@line 1493 "dictionary.cpp"
          }
          else if (__label__ == 155) {
  
            var $unstressed_wd2=(($langopts478+20)&4294967295); //@line 1495 "dictionary.cpp"
            var $241=HEAP32[(($unstressed_wd2)>>2)]; //@line 1495 "dictionary.cpp"
            $tonic_addr=$241; //@line 1495 "dictionary.cpp"
            ;
          }
        }
      } while(0);
  
      $max_stress=0; //@line 1498 "dictionary.cpp"
      $max_stress_posn=0; //@line 1499 "dictionary.cpp"
      $v=1; //@line 1500 "dictionary.cpp"
      var $242=$v; //@line 1500 "dictionary.cpp"
      var $243=HEAP32[(($vowel_count)>>2)]; //@line 1500 "dictionary.cpp"
      var $cmp48417=((($242))|0) < ((($243))|0); //@line 1500 "dictionary.cpp"
      if ($cmp48417) { __label__ = 157;; } else { __label__ = 160;; } //@line 1500 "dictionary.cpp"
      $for_body485$$for_end495$217: do { 
        if (__label__ == 157) {
          while(1) { 
  
            var $244=$v; //@line 1502 "dictionary.cpp"
            var $arrayidx486=(($vowel_stress+$244)&4294967295); //@line 1502 "dictionary.cpp"
            var $245=HEAP8[($arrayidx486)]; //@line 1502 "dictionary.cpp"
            var $conv487=(tempInt=(($245)),(tempInt>=128?tempInt-256:tempInt)); //@line 1502 "dictionary.cpp"
            var $246=$max_stress; //@line 1502 "dictionary.cpp"
            var $cmp488=((($conv487))|0) >= ((($246))|0); //@line 1502 "dictionary.cpp"
            if ($cmp488) { __label__ = 158;; } else { __label__ = 159;; } //@line 1502 "dictionary.cpp"
            if (__label__ == 158) {
  
              var $247=$v; //@line 1504 "dictionary.cpp"
              var $arrayidx490=(($vowel_stress+$247)&4294967295); //@line 1504 "dictionary.cpp"
              var $248=HEAP8[($arrayidx490)]; //@line 1504 "dictionary.cpp"
              var $conv491=(tempInt=(($248)),(tempInt>=128?tempInt-256:tempInt)); //@line 1504 "dictionary.cpp"
              $max_stress=$conv491; //@line 1504 "dictionary.cpp"
              var $249=$v; //@line 1505 "dictionary.cpp"
              $max_stress_posn=$249; //@line 1505 "dictionary.cpp"
              ; //@line 1506 "dictionary.cpp"
            }
  
            var $250=$v; //@line 1500 "dictionary.cpp"
            var $inc494=((($250)+1)&4294967295); //@line 1500 "dictionary.cpp"
            $v=$inc494; //@line 1500 "dictionary.cpp"
            var $251=$v; //@line 1500 "dictionary.cpp"
            var $252=HEAP32[(($vowel_count)>>2)]; //@line 1500 "dictionary.cpp"
            var $cmp484=((($251))|0) < ((($252))|0); //@line 1500 "dictionary.cpp"
            if ($cmp484) { __label__ = 157;continue ; } else { __label__ = 160;break $for_body485$$for_end495$217; } //@line 1500 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $253=$tonic_addr; //@line 1509 "dictionary.cpp"
      var $cmp496=((($253))|0) >= 0; //@line 1509 "dictionary.cpp"
      if ($cmp496) { __label__ = 161;; } else { __label__ = 164;; } //@line 1509 "dictionary.cpp"
      if (__label__ == 161) {
  
        var $254=$tonic_addr; //@line 1514 "dictionary.cpp"
        var $255=$max_stress; //@line 1514 "dictionary.cpp"
        var $cmp498=((($254))|0) > ((($255))|0); //@line 1514 "dictionary.cpp"
        var $256=$max_stress; //@line 1514 "dictionary.cpp"
        var $cmp500=((($256))|0) <= 4; //@line 1514 "dictionary.cpp"
        var $or_cond1=($cmp498) | ($cmp500); //@line 1514 "dictionary.cpp"
        if ($or_cond1) { __label__ = 162;; } else { __label__ = 163;; } //@line 1514 "dictionary.cpp"
        if (__label__ == 162) {
  
          var $257=$tonic_addr; //@line 1515 "dictionary.cpp"
          var $conv502=((($257)) & 255); //@line 1515 "dictionary.cpp"
          var $258=$max_stress_posn; //@line 1515 "dictionary.cpp"
          var $arrayidx503=(($vowel_stress+$258)&4294967295); //@line 1515 "dictionary.cpp"
          HEAP8[($arrayidx503)]=$conv502; //@line 1515 "dictionary.cpp"
          ; //@line 1515 "dictionary.cpp"
        }
  
        var $259=$tonic_addr; //@line 1516 "dictionary.cpp"
        $max_stress=$259; //@line 1516 "dictionary.cpp"
        ; //@line 1517 "dictionary.cpp"
      }
  
      var $arraydecay506=(($phonetic)&4294967295); //@line 1521 "dictionary.cpp"
      $p=$arraydecay506; //@line 1521 "dictionary.cpp"
      $v=1; //@line 1522 "dictionary.cpp"
      var $260=$control_addr; //@line 1524 "dictionary.cpp"
      var $and507=($260) & 1; //@line 1524 "dictionary.cpp"
      var $tobool508=((($and507))|0)!=0; //@line 1524 "dictionary.cpp"
      if ($tobool508) { __label__ = 174;; } else { __label__ = 165;; } //@line 1524 "dictionary.cpp"
      $if_end544$$land_lhs_true509$230: do { 
        if (__label__ == 165) {
  
          var $261=$p; //@line 1524 "dictionary.cpp"
          var $262=HEAPU8[($261)]; //@line 1524 "dictionary.cpp"
          var $idxprom510=((($262))&255); //@line 1524 "dictionary.cpp"
          var $arrayidx511=((_phoneme_tab+$idxprom510*4)&4294967295); //@line 1524 "dictionary.cpp"
          var $263=HEAPU32[(($arrayidx511)>>2)]; //@line 1524 "dictionary.cpp"
          $ph=$263; //@line 1524 "dictionary.cpp"
          var $cmp512=((($263))|0)!=0; //@line 1524 "dictionary.cpp"
          if (!($cmp512)) { __label__ = 174;break $if_end544$$land_lhs_true509$230; } //@line 1524 "dictionary.cpp"
  
          var $264=$ph; //@line 1527 "dictionary.cpp"
          var $type514=(($264+11)&4294967295); //@line 1527 "dictionary.cpp"
          var $265=HEAPU8[($type514)]; //@line 1527 "dictionary.cpp"
          var $conv515=((($265))&255); //@line 1527 "dictionary.cpp"
          var $cmp516=((($conv515))|0)==1; //@line 1527 "dictionary.cpp"
          if ($cmp516) { __label__ = 167;; } else { __label__ = 168;; } //@line 1527 "dictionary.cpp"
          if (__label__ == 167) {
  
            var $266=$p; //@line 1528 "dictionary.cpp"
            var $arrayidx518=(($266+1)&4294967295); //@line 1528 "dictionary.cpp"
            var $267=HEAPU8[($arrayidx518)]; //@line 1528 "dictionary.cpp"
            var $idxprom519=((($267))&255); //@line 1528 "dictionary.cpp"
            var $arrayidx520=((_phoneme_tab+$idxprom519*4)&4294967295); //@line 1528 "dictionary.cpp"
            var $268=HEAP32[(($arrayidx520)>>2)]; //@line 1528 "dictionary.cpp"
            $ph=$268; //@line 1528 "dictionary.cpp"
            ; //@line 1528 "dictionary.cpp"
          }
  
          var $269=$tr_addr; //@line 1539 "dictionary.cpp"
          var $langopts522=(($269)&4294967295); //@line 1539 "dictionary.cpp"
          var $vowel_pause=(($langopts522+4)&4294967295); //@line 1539 "dictionary.cpp"
          var $270=HEAP32[(($vowel_pause)>>2)]; //@line 1539 "dictionary.cpp"
          var $and523=($270) & 48; //@line 1539 "dictionary.cpp"
          var $tobool524=((($and523))|0)!=0; //@line 1539 "dictionary.cpp"
          if (!($tobool524)) { __label__ = 174;break $if_end544$$land_lhs_true509$230; } //@line 1539 "dictionary.cpp"
  
          var $271=$ph; //@line 1539 "dictionary.cpp"
          var $type526=(($271+11)&4294967295); //@line 1539 "dictionary.cpp"
          var $272=HEAPU8[($type526)]; //@line 1539 "dictionary.cpp"
          var $conv527=((($272))&255); //@line 1539 "dictionary.cpp"
          var $cmp528=((($conv527))|0)==2; //@line 1539 "dictionary.cpp"
          if (!($cmp528)) { __label__ = 174;break $if_end544$$land_lhs_true509$230; } //@line 1539 "dictionary.cpp"
  
          var $273=$tr_addr; //@line 1543 "dictionary.cpp"
          var $langopts530=(($273)&4294967295); //@line 1543 "dictionary.cpp"
          var $vowel_pause531=(($langopts530+4)&4294967295); //@line 1543 "dictionary.cpp"
          var $274=HEAP32[(($vowel_pause531)>>2)]; //@line 1543 "dictionary.cpp"
          var $and532=($274) & 32; //@line 1543 "dictionary.cpp"
          var $tobool533=((($and532))|0)!=0; //@line 1543 "dictionary.cpp"
          if ($tobool533) { __label__ = 171;; } else { __label__ = 173;; } //@line 1543 "dictionary.cpp"
          $land_lhs_true534$$if_else540$238: do { 
            if (__label__ == 171) {
  
              var $arrayidx535=(($vowel_stress+1)&4294967295); //@line 1543 "dictionary.cpp"
              var $275=HEAP8[($arrayidx535)]; //@line 1543 "dictionary.cpp"
              var $conv536=(tempInt=(($275)),(tempInt>=128?tempInt-256:tempInt)); //@line 1543 "dictionary.cpp"
              var $cmp537=((($conv536))|0) >= 4; //@line 1543 "dictionary.cpp"
              if (!($cmp537)) { __label__ = 173;break $land_lhs_true534$$if_else540$238; } //@line 1543 "dictionary.cpp"
  
              var $276=$output_addr; //@line 1545 "dictionary.cpp"
              var $incdec_ptr539=(($276+1)&4294967295); //@line 1545 "dictionary.cpp"
              $output_addr=$incdec_ptr539; //@line 1545 "dictionary.cpp"
              HEAP8[($276)]=11; //@line 1545 "dictionary.cpp"
              __label__ = 174;break $if_end544$$land_lhs_true509$230; //@line 1546 "dictionary.cpp"
            }
          } while(0);
  
          var $277=$output_addr; //@line 1549 "dictionary.cpp"
          var $incdec_ptr541=(($277+1)&4294967295); //@line 1549 "dictionary.cpp"
          $output_addr=$incdec_ptr541; //@line 1549 "dictionary.cpp"
          HEAP8[($277)]=23; //@line 1549 "dictionary.cpp"
          ;
        }
      } while(0);
  
      var $arraydecay545=(($phonetic)&4294967295); //@line 1554 "dictionary.cpp"
      $p=$arraydecay545; //@line 1554 "dictionary.cpp"
      $post_tonic=0; //@line 1555 "dictionary.cpp"
      ; //@line 1556 "dictionary.cpp"
      $while_cond546$243: while(1) { 
  
        var $278=$p; //@line 1556 "dictionary.cpp"
        var $incdec_ptr547=(($278+1)&4294967295); //@line 1556 "dictionary.cpp"
        $p=$incdec_ptr547; //@line 1556 "dictionary.cpp"
        var $279=HEAPU8[($278)]; //@line 1556 "dictionary.cpp"
        $phcode=$279; //@line 1556 "dictionary.cpp"
        var $conv548=((($279))&255); //@line 1556 "dictionary.cpp"
        var $cmp549=((($conv548))|0)!=0; //@line 1556 "dictionary.cpp"
        if (!($cmp549)) { __label__ = 222;break $while_cond546$243; } //@line 1556 "dictionary.cpp"
  
        var $280=$output_addr; //@line 1556 "dictionary.cpp"
        var $281=$max_output; //@line 1556 "dictionary.cpp"
        var $cmp550=((($280))>>>0) < ((($281))>>>0); //@line 1556 "dictionary.cpp"
        if (!($cmp550)) { __label__ = 222;break $while_cond546$243; }
  
        var $282=$phcode; //@line 1558 "dictionary.cpp"
        var $idxprom552=((($282))&255); //@line 1558 "dictionary.cpp"
        var $arrayidx553=((_phoneme_tab+$idxprom552*4)&4294967295); //@line 1558 "dictionary.cpp"
        var $283=HEAPU32[(($arrayidx553)>>2)]; //@line 1558 "dictionary.cpp"
        $ph=$283; //@line 1558 "dictionary.cpp"
        var $cmp554=((($283))|0)==0; //@line 1558 "dictionary.cpp"
        if ($cmp554) { __label__ = 175;continue $while_cond546$243; } //@line 1558 "dictionary.cpp"
  
        var $284=$ph; //@line 1564 "dictionary.cpp"
        var $type557=(($284+11)&4294967295); //@line 1564 "dictionary.cpp"
        var $285=HEAPU8[($type557)]; //@line 1564 "dictionary.cpp"
        var $conv558=((($285))&255); //@line 1564 "dictionary.cpp"
        var $cmp559=((($conv558))|0)==0; //@line 1564 "dictionary.cpp"
        if ($cmp559) { __label__ = 179;; } else { __label__ = 180;; } //@line 1564 "dictionary.cpp"
        $if_then560$$if_else561$248: do { 
          if (__label__ == 179) {
  
            var $286=$tr_addr; //@line 1566 "dictionary.cpp"
            var $prev_last_stress=(($286+8288)&4294967295); //@line 1566 "dictionary.cpp"
            HEAP32[(($prev_last_stress)>>2)]=0; //@line 1566 "dictionary.cpp"
            ; //@line 1567 "dictionary.cpp"
          }
          else if (__label__ == 180) {
  
            var $287=$ph; //@line 1569 "dictionary.cpp"
            var $type562=(($287+11)&4294967295); //@line 1569 "dictionary.cpp"
            var $288=HEAPU8[($type562)]; //@line 1569 "dictionary.cpp"
            var $conv563=((($288))&255); //@line 1569 "dictionary.cpp"
            var $cmp564=((($conv563))|0)==2; //@line 1569 "dictionary.cpp"
            if ($cmp564) { __label__ = 181;; } else { __label__ = 182;; } //@line 1569 "dictionary.cpp"
            $land_lhs_true565$$lor_lhs_false569$251: do { 
              if (__label__ == 181) {
  
                var $289=$ph; //@line 1569 "dictionary.cpp"
                var $phflags566=(($289+4)&4294967295); //@line 1569 "dictionary.cpp"
                var $290=HEAP32[(($phflags566)>>2)]; //@line 1569 "dictionary.cpp"
                var $and567=($290) & 1048576; //@line 1569 "dictionary.cpp"
                var $tobool568=((($and567))|0)!=0; //@line 1569 "dictionary.cpp"
                if ($tobool568) { __label__ = 182;break $land_lhs_true565$$lor_lhs_false569$251; } else { __label__ = 183;break $land_lhs_true565$$lor_lhs_false569$251; } //@line 1569 "dictionary.cpp"
              }
            } while(0);
            if (__label__ == 182) {
  
              var $291=$p; //@line 1569 "dictionary.cpp"
              var $292=HEAPU8[($291)]; //@line 1569 "dictionary.cpp"
              var $conv570=((($292))&255); //@line 1569 "dictionary.cpp"
              var $cmp571=((($conv570))|0)==20; //@line 1569 "dictionary.cpp"
              if (!($cmp571)) { __label__ = 220;break $if_then560$$if_else561$248; } //@line 1569 "dictionary.cpp"
            }
  
            var $293=$v; //@line 1573 "dictionary.cpp"
            var $arrayidx573=(($vowel_stress+$293)&4294967295); //@line 1573 "dictionary.cpp"
            var $294=HEAP8[($arrayidx573)]; //@line 1573 "dictionary.cpp"
            var $conv574=(tempInt=(($294)),(tempInt>=128?tempInt-256:tempInt)); //@line 1573 "dictionary.cpp"
            $v_stress=$conv574; //@line 1573 "dictionary.cpp"
            var $295=$v_stress; //@line 1574 "dictionary.cpp"
            var $296=$tr_addr; //@line 1574 "dictionary.cpp"
            var $prev_last_stress575=(($296+8288)&4294967295); //@line 1574 "dictionary.cpp"
            HEAP32[(($prev_last_stress575)>>2)]=$295; //@line 1574 "dictionary.cpp"
            var $297=$v; //@line 1576 "dictionary.cpp"
            var $sub576=((($297)-1)&4294967295); //@line 1576 "dictionary.cpp"
            var $arrayidx577=(($vowel_stress+$sub576)&4294967295); //@line 1576 "dictionary.cpp"
            var $298=HEAP8[($arrayidx577)]; //@line 1576 "dictionary.cpp"
            var $conv578=(tempInt=(($298)),(tempInt>=128?tempInt-256:tempInt)); //@line 1576 "dictionary.cpp"
            var $299=$max_stress; //@line 1576 "dictionary.cpp"
            var $cmp579=((($conv578))|0) >= ((($299))|0); //@line 1576 "dictionary.cpp"
            if ($cmp579) { __label__ = 184;; } else { __label__ = 185;; } //@line 1576 "dictionary.cpp"
            if (__label__ == 184) {
  
              $post_tonic=1; //@line 1577 "dictionary.cpp"
              ; //@line 1577 "dictionary.cpp"
            }
  
            var $300=$v_stress; //@line 1579 "dictionary.cpp"
            var $cmp582=((($300))|0) <= 1; //@line 1579 "dictionary.cpp"
            if ($cmp582) { __label__ = 186;; } else { __label__ = 201;; } //@line 1579 "dictionary.cpp"
            $if_then583$$if_end627$259: do { 
              if (__label__ == 186) {
  
                var $301=$v; //@line 1581 "dictionary.cpp"
                var $cmp584=((($301))|0) > 1; //@line 1581 "dictionary.cpp"
                if ($cmp584) { __label__ = 187;; } else { __label__ = 191;; } //@line 1581 "dictionary.cpp"
                $land_lhs_true585$$if_else594$261: do { 
                  if (__label__ == 187) {
  
                    var $302=$max_stress; //@line 1581 "dictionary.cpp"
                    var $cmp586=((($302))|0) >= 4; //@line 1581 "dictionary.cpp"
                    if (!($cmp586)) { __label__ = 191;break $land_lhs_true585$$if_else594$261; } //@line 1581 "dictionary.cpp"
  
                    var $303=$stressflags; //@line 1581 "dictionary.cpp"
                    var $and588=($303) & 4; //@line 1581 "dictionary.cpp"
                    var $tobool589=((($and588))|0)!=0; //@line 1581 "dictionary.cpp"
                    if (!($tobool589)) { __label__ = 191;break $land_lhs_true585$$if_else594$261; } //@line 1581 "dictionary.cpp"
  
                    var $304=$v; //@line 1581 "dictionary.cpp"
                    var $305=HEAP32[(($vowel_count)>>2)]; //@line 1581 "dictionary.cpp"
                    var $sub591=((($305)-1)&4294967295); //@line 1581 "dictionary.cpp"
                    var $cmp592=((($304))|0)==((($sub591))|0); //@line 1581 "dictionary.cpp"
                    if (!($cmp592)) { __label__ = 191;break $land_lhs_true585$$if_else594$261; } //@line 1581 "dictionary.cpp"
  
                    $v_stress=0; //@line 1584 "dictionary.cpp"
                    __label__ = 201;break $if_then583$$if_end627$259; //@line 1585 "dictionary.cpp"
                  }
                } while(0);
  
                var $306=$stressflags; //@line 1587 "dictionary.cpp"
                var $and595=($306) & 2; //@line 1587 "dictionary.cpp"
                var $tobool596=((($and595))|0)!=0; //@line 1587 "dictionary.cpp"
                if ($tobool596) { __label__ = 194;; } else { __label__ = 192;; } //@line 1587 "dictionary.cpp"
                $if_then602$$lor_lhs_false597$267: do { 
                  if (__label__ == 192) {
  
                    var $307=$v; //@line 1587 "dictionary.cpp"
                    var $cmp598=((($307))|0)==1; //@line 1587 "dictionary.cpp"
                    if ($cmp598) { __label__ = 194;break $if_then602$$lor_lhs_false597$267; } //@line 1587 "dictionary.cpp"
  
                    var $308=$v; //@line 1587 "dictionary.cpp"
                    var $309=HEAP32[(($vowel_count)>>2)]; //@line 1587 "dictionary.cpp"
                    var $sub600=((($309)-1)&4294967295); //@line 1587 "dictionary.cpp"
                    var $cmp601=((($308))|0)==((($sub600))|0); //@line 1587 "dictionary.cpp"
                    if ($cmp601) { __label__ = 194;break $if_then602$$lor_lhs_false597$267; } //@line 1587 "dictionary.cpp"
  
                    var $310=$v; //@line 1593 "dictionary.cpp"
                    var $311=HEAP32[(($vowel_count)>>2)]; //@line 1593 "dictionary.cpp"
                    var $sub604=((($311)-2)&4294967295); //@line 1593 "dictionary.cpp"
                    var $cmp605=((($310))|0)==((($sub604))|0); //@line 1593 "dictionary.cpp"
                    if ($cmp605) { __label__ = 196;; } else { __label__ = 198;; } //@line 1593 "dictionary.cpp"
                    $land_lhs_true606$$if_else612$271: do { 
                      if (__label__ == 196) {
  
                        var $312=HEAP32[(($vowel_count)>>2)]; //@line 1593 "dictionary.cpp"
                        var $sub607=((($312)-1)&4294967295); //@line 1593 "dictionary.cpp"
                        var $arrayidx608=(($vowel_stress+$sub607)&4294967295); //@line 1593 "dictionary.cpp"
                        var $313=HEAP8[($arrayidx608)]; //@line 1593 "dictionary.cpp"
                        var $conv609=(tempInt=(($313)),(tempInt>=128?tempInt-256:tempInt)); //@line 1593 "dictionary.cpp"
                        var $cmp610=((($conv609))|0) <= 1; //@line 1593 "dictionary.cpp"
                        if (!($cmp610)) { __label__ = 198;break $land_lhs_true606$$if_else612$271; } //@line 1593 "dictionary.cpp"
  
                        $v_stress=1; //@line 1596 "dictionary.cpp"
                        __label__ = 201;break $if_then583$$if_end627$259; //@line 1597 "dictionary.cpp"
                      }
                    } while(0);
  
                    var $314=$v; //@line 1601 "dictionary.cpp"
                    var $sub613=((($314)-1)&4294967295); //@line 1601 "dictionary.cpp"
                    var $arrayidx614=(($vowel_stress+$sub613)&4294967295); //@line 1601 "dictionary.cpp"
                    var $315=HEAP8[($arrayidx614)]; //@line 1601 "dictionary.cpp"
                    var $conv615=(tempInt=(($315)),(tempInt>=128?tempInt-256:tempInt)); //@line 1601 "dictionary.cpp"
                    var $cmp616=((($conv615))|0) < 0; //@line 1601 "dictionary.cpp"
                    if ($cmp616) { __label__ = 200;; } else { __label__ = 199;; } //@line 1601 "dictionary.cpp"
                    if (__label__ == 199) {
  
                      var $316=$stressflags; //@line 1601 "dictionary.cpp"
                      var $and618=($316) & 65536; //@line 1601 "dictionary.cpp"
                      var $cmp619=((($and618))|0)==0; //@line 1601 "dictionary.cpp"
                      if (!($cmp619)) { __label__ = 201;break $if_then583$$if_end627$259; } //@line 1601 "dictionary.cpp"
                    }
  
                    $v_stress=0; //@line 1603 "dictionary.cpp"
                    var $317=$v_stress; //@line 1604 "dictionary.cpp"
                    var $conv621=((($317)) & 255); //@line 1604 "dictionary.cpp"
                    var $318=$v; //@line 1604 "dictionary.cpp"
                    var $arrayidx622=(($vowel_stress+$318)&4294967295); //@line 1604 "dictionary.cpp"
                    HEAP8[($arrayidx622)]=$conv621; //@line 1604 "dictionary.cpp"
                    __label__ = 201;break $if_then583$$if_end627$259; //@line 1605 "dictionary.cpp"
                  }
                } while(0);
  
                $v_stress=1; //@line 1590 "dictionary.cpp"
                ; //@line 1591 "dictionary.cpp"
              }
            } while(0);
  
            var $319=$v_stress; //@line 1609 "dictionary.cpp"
            var $cmp628=((($319))|0)==0; //@line 1609 "dictionary.cpp"
            var $320=$v_stress; //@line 1609 "dictionary.cpp"
            var $cmp630=((($320))|0) > 1; //@line 1609 "dictionary.cpp"
            var $or_cond2=($cmp628) | ($cmp630); //@line 1609 "dictionary.cpp"
            if ($or_cond2) { __label__ = 202;; } else { __label__ = 203;; } //@line 1609 "dictionary.cpp"
            if (__label__ == 202) {
  
              var $321=$v_stress; //@line 1610 "dictionary.cpp"
              var $arrayidx632=((__ZL15stress_phonemes+$321)&4294967295); //@line 1610 "dictionary.cpp"
              var $322=HEAP8[($arrayidx632)]; //@line 1610 "dictionary.cpp"
              var $323=$output_addr; //@line 1610 "dictionary.cpp"
              var $incdec_ptr633=(($323+1)&4294967295); //@line 1610 "dictionary.cpp"
              $output_addr=$incdec_ptr633; //@line 1610 "dictionary.cpp"
              HEAP8[($323)]=$322; //@line 1610 "dictionary.cpp"
              ; //@line 1610 "dictionary.cpp"
            }
  
            var $324=$v; //@line 1613 "dictionary.cpp"
            var $arrayidx635=(($vowel_stress+$324)&4294967295); //@line 1613 "dictionary.cpp"
            var $325=HEAP8[($arrayidx635)]; //@line 1613 "dictionary.cpp"
            var $conv636=(tempInt=(($325)),(tempInt>=128?tempInt-256:tempInt)); //@line 1613 "dictionary.cpp"
            var $326=$max_stress; //@line 1613 "dictionary.cpp"
            var $cmp637=((($conv636))|0) > ((($326))|0); //@line 1613 "dictionary.cpp"
            if ($cmp637) { __label__ = 204;; } else { __label__ = 205;; } //@line 1613 "dictionary.cpp"
            if (__label__ == 204) {
  
              var $327=$v; //@line 1615 "dictionary.cpp"
              var $arrayidx639=(($vowel_stress+$327)&4294967295); //@line 1615 "dictionary.cpp"
              var $328=HEAP8[($arrayidx639)]; //@line 1615 "dictionary.cpp"
              var $conv640=(tempInt=(($328)),(tempInt>=128?tempInt-256:tempInt)); //@line 1615 "dictionary.cpp"
              $max_stress=$conv640; //@line 1615 "dictionary.cpp"
              ; //@line 1616 "dictionary.cpp"
            }
  
            var $329=$p; //@line 1618 "dictionary.cpp"
            var $330=HEAPU8[($329)]; //@line 1618 "dictionary.cpp"
            var $conv642=((($330))&255); //@line 1618 "dictionary.cpp"
            var $cmp643=((($conv642))|0)==12; //@line 1618 "dictionary.cpp"
            if ($cmp643) { __label__ = 206;; } else { __label__ = 214;; } //@line 1618 "dictionary.cpp"
            $land_lhs_true644$$if_end665$286: do { 
              if (__label__ == 206) {
  
                var $331=$tr_addr; //@line 1618 "dictionary.cpp"
                var $langopts645=(($331)&4294967295); //@line 1618 "dictionary.cpp"
                var $param=(($langopts645+24)&4294967295); //@line 1618 "dictionary.cpp"
                var $arrayidx646=(($param+8)&4294967295); //@line 1618 "dictionary.cpp"
                var $332=HEAP32[(($arrayidx646)>>2)]; //@line 1618 "dictionary.cpp"
                $opt_length=$332; //@line 1618 "dictionary.cpp"
                var $and647=($332) & 1; //@line 1618 "dictionary.cpp"
                var $tobool648=((($and647))|0)!=0; //@line 1618 "dictionary.cpp"
                if (!($tobool648)) { __label__ = 214;break $land_lhs_true644$$if_end665$286; } //@line 1618 "dictionary.cpp"
  
                $shorten=0; //@line 1621 "dictionary.cpp"
                var $333=$opt_length; //@line 1623 "dictionary.cpp"
                var $and650=($333) & 16; //@line 1623 "dictionary.cpp"
                var $tobool651=((($and650))|0)!=0; //@line 1623 "dictionary.cpp"
                if ($tobool651) { __label__ = 208;; } else { __label__ = 210;; } //@line 1623 "dictionary.cpp"
                $if_then652$$if_else656$289: do { 
                  if (__label__ == 208) {
  
                    var $334=$v; //@line 1626 "dictionary.cpp"
                    var $335=$max_stress_posn; //@line 1626 "dictionary.cpp"
                    var $cmp653=((($334))|0)!=((($335))|0); //@line 1626 "dictionary.cpp"
                    if (!($cmp653)) { __label__ = 212;break $if_then652$$if_else656$289; } //@line 1626 "dictionary.cpp"
  
                    $shorten=1; //@line 1627 "dictionary.cpp"
                    __label__ = 213;break $if_then652$$if_else656$289; //@line 1627 "dictionary.cpp"
                  }
                  else if (__label__ == 210) {
  
                    var $336=$v_stress; //@line 1630 "dictionary.cpp"
                    var $cmp657=((($336))|0) < 4; //@line 1630 "dictionary.cpp"
                    if (!($cmp657)) { __label__ = 212;break $if_then652$$if_else656$289; } //@line 1630 "dictionary.cpp"
  
                    $shorten=1; //@line 1633 "dictionary.cpp"
                    __label__ = 213;break $if_then652$$if_else656$289; //@line 1634 "dictionary.cpp"
                  }
                } while(0);
                if (__label__ == 212) {
  
                  var $_pr11=$shorten; //@line 1636 "dictionary.cpp"
                  var $tobool661=((($_pr11))|0)!=0; //@line 1636 "dictionary.cpp"
                  if (!($tobool661)) { __label__ = 214;break $land_lhs_true644$$if_end665$286; } //@line 1636 "dictionary.cpp"
                }
  
                var $337=$p; //@line 1637 "dictionary.cpp"
                var $incdec_ptr663=(($337+1)&4294967295); //@line 1637 "dictionary.cpp"
                $p=$incdec_ptr663; //@line 1637 "dictionary.cpp"
                ; //@line 1637 "dictionary.cpp"
              }
            } while(0);
  
            var $338=$v_stress; //@line 1640 "dictionary.cpp"
            var $cmp666=((($338))|0) >= 4; //@line 1640 "dictionary.cpp"
            if ($cmp666) { __label__ = 215;; } else { __label__ = 219;; } //@line 1640 "dictionary.cpp"
            $land_lhs_true667$$if_end682$298: do { 
              if (__label__ == 215) {
  
                var $339=$tr_addr; //@line 1640 "dictionary.cpp"
                var $langopts668=(($339)&4294967295); //@line 1640 "dictionary.cpp"
                var $param669=(($langopts668+24)&4294967295); //@line 1640 "dictionary.cpp"
                var $arrayidx670=(($param669+8)&4294967295); //@line 1640 "dictionary.cpp"
                var $340=HEAP32[(($arrayidx670)>>2)]; //@line 1640 "dictionary.cpp"
                var $cmp671=((($340))|0)==2; //@line 1640 "dictionary.cpp"
                if (!($cmp671)) { __label__ = 219;break $land_lhs_true667$$if_end682$298; } //@line 1640 "dictionary.cpp"
  
                var $341=$v; //@line 1643 "dictionary.cpp"
                var $342=HEAP32[(($vowel_count)>>2)]; //@line 1643 "dictionary.cpp"
                var $sub673=((($342)-2)&4294967295); //@line 1643 "dictionary.cpp"
                var $cmp674=((($341))|0)==((($sub673))|0); //@line 1643 "dictionary.cpp"
                if (!($cmp674)) { __label__ = 219;break $land_lhs_true667$$if_end682$298; } //@line 1643 "dictionary.cpp"
  
                var $343=$v; //@line 1643 "dictionary.cpp"
                var $arrayidx676=(($syllable_weight+$343)&4294967295); //@line 1643 "dictionary.cpp"
                var $344=HEAP8[($arrayidx676)]; //@line 1643 "dictionary.cpp"
                var $conv677=(tempInt=(($344)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "dictionary.cpp"
                var $cmp678=((($conv677))|0)==0; //@line 1643 "dictionary.cpp"
                if (!($cmp678)) { __label__ = 219;break $land_lhs_true667$$if_end682$298; } //@line 1643 "dictionary.cpp"
  
                var $345=$phcode; //@line 1645 "dictionary.cpp"
                var $346=$output_addr; //@line 1645 "dictionary.cpp"
                var $incdec_ptr680=(($346+1)&4294967295); //@line 1645 "dictionary.cpp"
                $output_addr=$incdec_ptr680; //@line 1645 "dictionary.cpp"
                HEAP8[($346)]=$345; //@line 1645 "dictionary.cpp"
                $phcode=12; //@line 1646 "dictionary.cpp"
                ; //@line 1647 "dictionary.cpp"
              }
            } while(0);
  
            var $347=$v; //@line 1650 "dictionary.cpp"
            var $inc683=((($347)+1)&4294967295); //@line 1650 "dictionary.cpp"
            $v=$inc683; //@line 1650 "dictionary.cpp"
            ; //@line 1651 "dictionary.cpp"
          }
        } while(0);
  
        var $348=$phcode; //@line 1653 "dictionary.cpp"
        var $conv686=((($348))&255); //@line 1653 "dictionary.cpp"
        var $cmp687=((($conv686))|0)!=1; //@line 1653 "dictionary.cpp"
        if (!($cmp687)) { __label__ = 175;continue $while_cond546$243; } //@line 1653 "dictionary.cpp"
  
        var $349=$phcode; //@line 1654 "dictionary.cpp"
        var $350=$output_addr; //@line 1654 "dictionary.cpp"
        var $incdec_ptr689=(($350+1)&4294967295); //@line 1654 "dictionary.cpp"
        $output_addr=$incdec_ptr689; //@line 1654 "dictionary.cpp"
        HEAP8[($350)]=$349; //@line 1654 "dictionary.cpp"
        __label__ = 175;continue $while_cond546$243; //@line 1654 "dictionary.cpp"
      }
  
      var $351=$output_addr; //@line 1656 "dictionary.cpp"
      var $incdec_ptr692=(($351+1)&4294967295); //@line 1656 "dictionary.cpp"
      $output_addr=$incdec_ptr692; //@line 1656 "dictionary.cpp"
      HEAP8[($351)]=0; //@line 1656 "dictionary.cpp"
      ; //@line 1658 "dictionary.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1659 "dictionary.cpp"
    return;
  }
  

  function __Z14AppendPhonemesP10TranslatorPciPKc($tr, $string, $size, $ph) {
    ;
    var __label__;
  
    var $tr_addr;
    var $string_addr;
    var $size_addr;
    var $ph_addr;
    var $p;
    var $c;
    var $unstress_mark;
    var $length;
    $tr_addr=$tr;
    $string_addr=$string;
    $size_addr=$size;
    $ph_addr=$ph;
    var $0=$ph_addr; //@line 1683 "dictionary.cpp"
    var $call=_strlen($0); //@line 1683 "dictionary.cpp"
    var $1=$string_addr; //@line 1683 "dictionary.cpp"
    var $call1=_strlen($1); //@line 1683 "dictionary.cpp"
    var $add=((($call1)+($call))&4294967295); //@line 1683 "dictionary.cpp"
    $length=$add; //@line 1683 "dictionary.cpp"
    var $2=$length; //@line 1684 "dictionary.cpp"
    var $3=$size_addr; //@line 1684 "dictionary.cpp"
    var $cmp=((($2))|0) >= ((($3))|0); //@line 1684 "dictionary.cpp"
    if ($cmp) { __label__ = 14;; } else { __label__ = 1;; } //@line 1684 "dictionary.cpp"
    $if_end34$$if_end$2: do { 
      if (__label__ == 1) {
  
        $unstress_mark=0; //@line 1690 "dictionary.cpp"
        var $4=$ph_addr; //@line 1691 "dictionary.cpp"
        $p=$4; //@line 1691 "dictionary.cpp"
        var $5=$p; //@line 1692 "dictionary.cpp"
        var $incdec_ptr1=(($5+1)&4294967295); //@line 1692 "dictionary.cpp"
        $p=$incdec_ptr1; //@line 1692 "dictionary.cpp"
        var $6=HEAPU8[($5)]; //@line 1692 "dictionary.cpp"
        $c=$6; //@line 1692 "dictionary.cpp"
        var $conv2=((($6))&255); //@line 1692 "dictionary.cpp"
        var $cmp23=((($conv2))|0)!=0; //@line 1692 "dictionary.cpp"
        if ($cmp23) { __label__ = 2;; } else { __label__ = 12;; } //@line 1692 "dictionary.cpp"
        $while_body$$while_end$4: do { 
          if (__label__ == 2) {
            $while_body$5: while(1) { 
  
              var $7=$c; //@line 1694 "dictionary.cpp"
              var $conv3=((($7))&255); //@line 1694 "dictionary.cpp"
              var $8=HEAP32[((_n_phoneme_tab)>>2)]; //@line 1694 "dictionary.cpp"
              var $cmp4=((($conv3))|0) >= ((($8))|0); //@line 1694 "dictionary.cpp"
              if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1694 "dictionary.cpp"
              $while_cond_backedge$$if_end6$7: do { 
                if (__label__ == 4) {
  
                  var $11=$c; //@line 1696 "dictionary.cpp"
                  var $idxprom=((($11))&255); //@line 1696 "dictionary.cpp"
                  var $arrayidx=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1696 "dictionary.cpp"
                  var $12=HEAP32[(($arrayidx)>>2)]; //@line 1696 "dictionary.cpp"
                  var $type=(($12+11)&4294967295); //@line 1696 "dictionary.cpp"
                  var $13=HEAPU8[($type)]; //@line 1696 "dictionary.cpp"
                  var $conv7=((($13))&255); //@line 1696 "dictionary.cpp"
                  var $cmp8=((($conv7))|0)==1; //@line 1696 "dictionary.cpp"
                  var $14=$c; //@line 1698 "dictionary.cpp"
                  var $idxprom10=((($14))&255); //@line 1698 "dictionary.cpp"
                  var $arrayidx11=((_phoneme_tab+$idxprom10*4)&4294967295); //@line 1698 "dictionary.cpp"
                  var $15=HEAP32[(($arrayidx11)>>2)]; //@line 1698 "dictionary.cpp"
                  if ($cmp8) { __label__ = 5;; } else { __label__ = 7;; } //@line 1696 "dictionary.cpp"
                  if (__label__ == 5) {
  
                    var $std_length=(($15+14)&4294967295); //@line 1698 "dictionary.cpp"
                    var $16=HEAPU8[($std_length)]; //@line 1698 "dictionary.cpp"
                    var $conv12=((($16))&255); //@line 1698 "dictionary.cpp"
                    var $cmp13=((($conv12))|0) < 4; //@line 1698 "dictionary.cpp"
                    if (!($cmp13)) { __label__ = 3;break $while_cond_backedge$$if_end6$7; } //@line 1698 "dictionary.cpp"
  
                    $unstress_mark=1; //@line 1699 "dictionary.cpp"
                    ; //@line 1699 "dictionary.cpp"
                  }
                  else if (__label__ == 7) {
  
                    var $type18=(($15+11)&4294967295); //@line 1703 "dictionary.cpp"
                    var $17=HEAPU8[($type18)]; //@line 1703 "dictionary.cpp"
                    var $conv19=((($17))&255); //@line 1703 "dictionary.cpp"
                    var $cmp20=((($conv19))|0)==2; //@line 1703 "dictionary.cpp"
                    if (!($cmp20)) { __label__ = 3;break $while_cond_backedge$$if_end6$7; } //@line 1703 "dictionary.cpp"
  
                    var $18=$c; //@line 1705 "dictionary.cpp"
                    var $idxprom22=((($18))&255); //@line 1705 "dictionary.cpp"
                    var $arrayidx23=((_phoneme_tab+$idxprom22*4)&4294967295); //@line 1705 "dictionary.cpp"
                    var $19=HEAP32[(($arrayidx23)>>2)]; //@line 1705 "dictionary.cpp"
                    var $phflags=(($19+4)&4294967295); //@line 1705 "dictionary.cpp"
                    var $20=HEAP32[(($phflags)>>2)]; //@line 1705 "dictionary.cpp"
                    var $and=($20) & 2; //@line 1705 "dictionary.cpp"
                    var $cmp24=((($and))|0)==0; //@line 1705 "dictionary.cpp"
                    if ($cmp24) { __label__ = 9;; } else { __label__ = 11;; } //@line 1705 "dictionary.cpp"
                    $land_lhs_true$$if_end27$14: do { 
                      if (__label__ == 9) {
  
                        var $21=$unstress_mark; //@line 1705 "dictionary.cpp"
                        var $cmp25=((($21))|0)==0; //@line 1705 "dictionary.cpp"
                        if (!($cmp25)) { __label__ = 11;break $land_lhs_true$$if_end27$14; } //@line 1705 "dictionary.cpp"
  
                        var $22=$tr_addr; //@line 1708 "dictionary.cpp"
                        var $word_stressed_count=(($22+8300)&4294967295); //@line 1708 "dictionary.cpp"
                        var $23=HEAP32[(($word_stressed_count)>>2)]; //@line 1708 "dictionary.cpp"
                        var $inc=((($23)+1)&4294967295); //@line 1708 "dictionary.cpp"
                        HEAP32[(($word_stressed_count)>>2)]=$inc; //@line 1708 "dictionary.cpp"
                        ; //@line 1709 "dictionary.cpp"
                      }
                    } while(0);
  
                    $unstress_mark=0; //@line 1710 "dictionary.cpp"
                    var $24=$tr_addr; //@line 1711 "dictionary.cpp"
                    var $word_vowel_count=(($24+8296)&4294967295); //@line 1711 "dictionary.cpp"
                    var $25=HEAP32[(($word_vowel_count)>>2)]; //@line 1711 "dictionary.cpp"
                    var $inc28=((($25)+1)&4294967295); //@line 1711 "dictionary.cpp"
                    HEAP32[(($word_vowel_count)>>2)]=$inc28; //@line 1711 "dictionary.cpp"
                    ; //@line 1712 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $9=$p; //@line 1692 "dictionary.cpp"
              var $incdec_ptr=(($9+1)&4294967295); //@line 1692 "dictionary.cpp"
              $p=$incdec_ptr; //@line 1692 "dictionary.cpp"
              var $10=HEAPU8[($9)]; //@line 1692 "dictionary.cpp"
              $c=$10; //@line 1692 "dictionary.cpp"
              var $conv=((($10))&255); //@line 1692 "dictionary.cpp"
              var $cmp2=((($conv))|0)!=0; //@line 1692 "dictionary.cpp"
              if ($cmp2) { __label__ = 2;continue $while_body$5; } else { __label__ = 12;break $while_body$$while_end$4; } //@line 1692 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $26=$string_addr; //@line 1716 "dictionary.cpp"
        var $cmp31=((($26))|0)!=0; //@line 1716 "dictionary.cpp"
        if (!($cmp31)) { __label__ = 14;break $if_end34$$if_end$2; } //@line 1716 "dictionary.cpp"
  
        var $27=$string_addr; //@line 1717 "dictionary.cpp"
        var $28=$ph_addr; //@line 1717 "dictionary.cpp"
        var $call33=_strcat($27, $28); //@line 1717 "dictionary.cpp"
        ; //@line 1717 "dictionary.cpp"
      }
    } while(0);
  
    ;
    return; //@line 1718 "dictionary.cpp"
    return;
  }
  

  function __Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($tr, $p_start, $phonemes, $ph_size, $end_phonemes, $word_flags, $dict_flags) {
    var __stackBase__  = STACKTOP; STACKTOP += 416; _memset(__stackBase__, 0, 416);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $p_start_addr;
    var $phonemes_addr;
    var $ph_size_addr;
    var $end_phonemes_addr;
    var $word_flags_addr;
    var $dict_flags_addr;
    var $c;
    var $c2;
    var $c12;
    var $c123;
    var $wc=__stackBase__;
    var $wc_prev;
    var $wc_bytes;
    var $p2=__stackBase__+4;
    var $found;
    var $g;
    var $g1;
    var $n;
    var $letter=__stackBase__+8;
    var $any_alpha;
    var $ix;
    var $digit_count;
    var $p=__stackBase__+12;
    var $dict_flags0;
    var $match1=__stackBase__+16;
    var $match2=__stackBase__+32;
    var $ph_buf=__stackBase__+48;
    var $word_copy=__stackBase__+88;
    var $wordbuf=__stackBase__+248;
    var $ix14;
    var $string=__stackBase__+368;
    var $buf=__stackBase__+376;
    $tr_addr=$tr;
    $p_start_addr=$p_start;
    $phonemes_addr=$phonemes;
    $ph_size_addr=$ph_size;
    $end_phonemes_addr=$end_phonemes;
    $word_flags_addr=$word_flags;
    $dict_flags_addr=$dict_flags;
    HEAP32[(($wc)>>2)]=0; //@line 2393 "dictionary.cpp"
    $any_alpha=0; //@line 2402 "dictionary.cpp"
    $digit_count=0; //@line 2404 "dictionary.cpp"
    $dict_flags0=0; //@line 2406 "dictionary.cpp"
    var $0=$tr_addr; //@line 2413 "dictionary.cpp"
    var $data_dictrules=(($0+1048)&4294967295); //@line 2413 "dictionary.cpp"
    var $1=HEAP32[(($data_dictrules)>>2)]; //@line 2413 "dictionary.cpp"
    var $cmp=((($1))|0)==0; //@line 2413 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2413 "dictionary.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=0; //@line 2414 "dictionary.cpp"
        ; //@line 2414 "dictionary.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=$dict_flags_addr; //@line 2416 "dictionary.cpp"
        var $cmp1=((($2))|0)!=0; //@line 2416 "dictionary.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 2416 "dictionary.cpp"
        if (__label__ == 3) {
  
          var $3=$dict_flags_addr; //@line 2417 "dictionary.cpp"
          var $arrayidx=(($3)&4294967295); //@line 2417 "dictionary.cpp"
          var $4=HEAP32[(($arrayidx)>>2)]; //@line 2417 "dictionary.cpp"
          $dict_flags0=$4; //@line 2417 "dictionary.cpp"
          ; //@line 2417 "dictionary.cpp"
        }
  
        $ix=0; //@line 2419 "dictionary.cpp"
        __lastLabel__ = 4; ; //@line 2419 "dictionary.cpp"
        $for_cond$8: while(1) { 
  
          var $5=__lastLabel__ == 5 ? $_pr : (0); //@line 2419 "dictionary.cpp"
          var $cmp4=((($5))|0) < 159; //@line 2419 "dictionary.cpp"
          if (!($cmp4)) { __label__ = 8;break $for_cond$8; } //@line 2419 "dictionary.cpp"
  
          var $6=$ix; //@line 2421 "dictionary.cpp"
          var $7=$p_start_addr; //@line 2421 "dictionary.cpp"
          var $arrayidx5=(($7+$6)&4294967295); //@line 2421 "dictionary.cpp"
          var $8=HEAP8[($arrayidx5)]; //@line 2421 "dictionary.cpp"
          $c=$8; //@line 2421 "dictionary.cpp"
          var $9=$c; //@line 2422 "dictionary.cpp"
          var $10=$ix; //@line 2422 "dictionary.cpp"
          var $inc=((($10)+1)&4294967295); //@line 2422 "dictionary.cpp"
          $ix=$inc; //@line 2422 "dictionary.cpp"
          var $arrayidx6=(($word_copy+$10)&4294967295); //@line 2422 "dictionary.cpp"
          HEAP8[($arrayidx6)]=$9; //@line 2422 "dictionary.cpp"
          var $11=$c; //@line 2423 "dictionary.cpp"
          var $conv=((($11))&255); //@line 2423 "dictionary.cpp"
          var $cmp7=((($conv))|0)==0; //@line 2423 "dictionary.cpp"
          if ($cmp7) { __label__ = 8;break $for_cond$8; } //@line 2423 "dictionary.cpp"
  
          var $_pr=$ix; //@line 2419 "dictionary.cpp"
          __lastLabel__ = 5; __label__ = 6;continue $for_cond$8;
        }
  
        var $12=$ix; //@line 2426 "dictionary.cpp"
        var $arrayidx10=(($word_copy+$12)&4294967295); //@line 2426 "dictionary.cpp"
        HEAP8[($arrayidx10)]=0; //@line 2426 "dictionary.cpp"
        var $13=HEAP32[((_option_phonemes)>>2)]; //@line 2429 "dictionary.cpp"
        var $cmp11=((($13))|0)==2; //@line 2429 "dictionary.cpp"
        if ($cmp11) { __label__ = 9;; } else { __label__ = 17;; } //@line 2429 "dictionary.cpp"
        $land_lhs_true$$if_end31$13: do { 
          if (__label__ == 9) {
  
            var $14=$word_flags_addr; //@line 2429 "dictionary.cpp"
            var $and=($14) & 268435456; //@line 2429 "dictionary.cpp"
            var $cmp12=((($and))|0)==0; //@line 2429 "dictionary.cpp"
            if (!($cmp12)) { __label__ = 17;break $land_lhs_true$$if_end31$13; } //@line 2429 "dictionary.cpp"
  
            $ix14=0; //@line 2434 "dictionary.cpp"
            ; //@line 2434 "dictionary.cpp"
            while(1) { 
  
              var $15=$ix14; //@line 2434 "dictionary.cpp"
              var $16=$p_start_addr; //@line 2434 "dictionary.cpp"
              var $arrayidx16=(($16+$15)&4294967295); //@line 2434 "dictionary.cpp"
              var $17=HEAPU8[($arrayidx16)]; //@line 2434 "dictionary.cpp"
              $c=$17; //@line 2434 "dictionary.cpp"
              var $conv17=((($17))&255); //@line 2434 "dictionary.cpp"
              var $cmp18=((($conv17))|0)!=32; //@line 2434 "dictionary.cpp"
              if (!($cmp18)) { __label__ = 14;break ; } //@line 2434 "dictionary.cpp"
  
              var $18=$c; //@line 2434 "dictionary.cpp"
              var $conv19=((($18))&255); //@line 2434 "dictionary.cpp"
              var $cmp20=((($conv19))|0)!=0; //@line 2434 "dictionary.cpp"
              if (!($cmp20)) { __label__ = 14;break ; }
  
              var $19=$c; //@line 2436 "dictionary.cpp"
              var $20=$ix14; //@line 2436 "dictionary.cpp"
              var $arrayidx22=(($wordbuf+$20)&4294967295); //@line 2436 "dictionary.cpp"
              HEAP8[($arrayidx22)]=$19; //@line 2436 "dictionary.cpp"
              var $21=$ix14; //@line 2434 "dictionary.cpp"
              var $inc23=((($21)+1)&4294967295); //@line 2434 "dictionary.cpp"
              $ix14=$inc23; //@line 2434 "dictionary.cpp"
              __label__ = 11;continue ; //@line 2434 "dictionary.cpp"
            }
  
            var $22=$ix14; //@line 2438 "dictionary.cpp"
            var $arrayidx25=(($wordbuf+$22)&4294967295); //@line 2438 "dictionary.cpp"
            HEAP8[($arrayidx25)]=0; //@line 2438 "dictionary.cpp"
            var $23=$word_flags_addr; //@line 2439 "dictionary.cpp"
            var $and26=($23) & -2147483648; //@line 2439 "dictionary.cpp"
            var $tobool=((($and26))|0)!=0; //@line 2439 "dictionary.cpp"
            var $24=HEAP32[((_f_trans)>>2)]; //@line 2440 "dictionary.cpp"
            var $arraydecay=(($wordbuf)&4294967295); //@line 2440 "dictionary.cpp"
            if ($tobool) { __label__ = 15;; } else { __label__ = 16;; } //@line 2439 "dictionary.cpp"
            if (__label__ == 15) {
  
              var $call=_fprintf($24, ((__str10126)&4294967295), allocate([$arraydecay,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 2440 "dictionary.cpp"
              ; //@line 2440 "dictionary.cpp"
            }
            else if (__label__ == 16) {
  
              var $call29=_fprintf($24, ((__str11127)&4294967295), allocate([$arraydecay,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 2442 "dictionary.cpp"
              ;
            }
          }
        } while(0);
  
        var $25=$p_start_addr; //@line 2445 "dictionary.cpp"
        HEAP32[(($p)>>2)]=$25; //@line 2445 "dictionary.cpp"
        var $26=$tr_addr; //@line 2446 "dictionary.cpp"
        var $word_vowel_count=(($26+8296)&4294967295); //@line 2446 "dictionary.cpp"
        HEAP32[(($word_vowel_count)>>2)]=0; //@line 2446 "dictionary.cpp"
        var $27=$tr_addr; //@line 2447 "dictionary.cpp"
        var $word_stressed_count=(($27+8300)&4294967295); //@line 2447 "dictionary.cpp"
        HEAP32[(($word_stressed_count)>>2)]=0; //@line 2447 "dictionary.cpp"
        var $28=$end_phonemes_addr; //@line 2449 "dictionary.cpp"
        var $cmp32=((($28))|0)!=0; //@line 2449 "dictionary.cpp"
        if ($cmp32) { __label__ = 18;; } else { __label__ = 19;; } //@line 2449 "dictionary.cpp"
        if (__label__ == 18) {
  
          var $29=$end_phonemes_addr; //@line 2450 "dictionary.cpp"
          var $arrayidx34=(($29)&4294967295); //@line 2450 "dictionary.cpp"
          HEAP8[($arrayidx34)]=0; //@line 2450 "dictionary.cpp"
          ; //@line 2450 "dictionary.cpp"
        }
  
        var $arrayidx57=(($string)&4294967295); //@line 2465 "dictionary.cpp"
        var $arrayidx58=(($string+1)&4294967295); //@line 2466 "dictionary.cpp"
        var $arraydecay60=(($string)&4294967295); //@line 2468 "dictionary.cpp"
        var $arraydecay61=(($buf)&4294967295); //@line 2468 "dictionary.cpp"
        var $arraydecay66=(($buf)&4294967295); //@line 2471 "dictionary.cpp"
        var $arraydecay69=(($buf)&4294967295); //@line 2474 "dictionary.cpp"
        var $phonemes282=(($match1+4)&4294967295); //@line 2644 "dictionary.cpp"
        var $phonemes285=(($match1+4)&4294967295); //@line 2645 "dictionary.cpp"
        var $points287=(($match1)&4294967295); //@line 2647 "dictionary.cpp"
        var $phonemes295=(($match1+4)&4294967295); //@line 2652 "dictionary.cpp"
        var $end_type306=(($match1+8)&4294967295); //@line 2659 "dictionary.cpp"
        var $end_type313=(($match1+8)&4294967295); //@line 2664 "dictionary.cpp"
        var $del_fwd=(($match1+12)&4294967295); //@line 2680 "dictionary.cpp"
        var $del_fwd342=(($match1+12)&4294967295); //@line 2681 "dictionary.cpp"
        var $phonemes344=(($match1+4)&4294967295); //@line 2682 "dictionary.cpp"
        var $points=(($match2)&4294967295); //@line 2508 "dictionary.cpp"
        var $points107=(($match2)&4294967295); //@line 2509 "dictionary.cpp"
        var $points112=(($match2)&4294967295); //@line 2514 "dictionary.cpp"
        var $points113=(($match1)&4294967295); //@line 2514 "dictionary.cpp"
        var $30=$match1; //@line 2517 "dictionary.cpp"
        var $31=$match2; //@line 2517 "dictionary.cpp"
        var $points241=(($match1)&4294967295); //@line 2608 "dictionary.cpp"
        var $arraydecay266=(($ph_buf)&4294967295); //@line 2628 "dictionary.cpp"
        var $arrayidx267=(($ph_buf)&4294967295); //@line 2629 "dictionary.cpp"
        var $arraydecay270=(($ph_buf)&4294967295); //@line 2631 "dictionary.cpp"
        var $phonemes271=(($match1+4)&4294967295); //@line 2631 "dictionary.cpp"
        var $points272=(($match1)&4294967295); //@line 2632 "dictionary.cpp"
        var $points135=(($match1)&4294967295); //@line 2534 "dictionary.cpp"
        var $arraydecay230=(($ph_buf)&4294967295); //@line 2600 "dictionary.cpp"
        var $arraydecay232=(($ph_buf)&4294967295); //@line 2601 "dictionary.cpp"
        var $phonemes233=(($match1+4)&4294967295); //@line 2601 "dictionary.cpp"
        var $points234=(($match1)&4294967295); //@line 2602 "dictionary.cpp"
        ; //@line 2452 "dictionary.cpp"
        $while_cond$28: while(1) { 
  
          var $32=HEAP32[(($p)>>2)]; //@line 2452 "dictionary.cpp"
          var $33=HEAPU8[($32)]; //@line 2452 "dictionary.cpp"
          $c=$33; //@line 2452 "dictionary.cpp"
          var $conv36=((($33))&255); //@line 2452 "dictionary.cpp"
          var $cmp37=((($conv36))|0)!=32; //@line 2452 "dictionary.cpp"
          if (!($cmp37)) { __label__ = 104;break $while_cond$28; } //@line 2452 "dictionary.cpp"
  
          var $34=$c; //@line 2452 "dictionary.cpp"
          var $conv39=((($34))&255); //@line 2452 "dictionary.cpp"
          var $cmp40=((($conv39))|0)!=0; //@line 2452 "dictionary.cpp"
          if (!($cmp40)) { __label__ = 104;break $while_cond$28; }
  
          var $35=HEAP32[(($wc)>>2)]; //@line 2454 "dictionary.cpp"
          $wc_prev=$35; //@line 2454 "dictionary.cpp"
          var $36=HEAP32[(($p)>>2)]; //@line 2455 "dictionary.cpp"
          var $call42=__Z7utf8_inPiPKc($wc, $36); //@line 2455 "dictionary.cpp"
          $wc_bytes=$call42; //@line 2455 "dictionary.cpp"
          var $37=HEAP32[(($wc)>>2)]; //@line 2456 "dictionary.cpp"
          var $call43=__Z7IsAlphaj($37); //@line 2456 "dictionary.cpp"
          var $tobool44=((($call43))|0)!=0; //@line 2456 "dictionary.cpp"
          if ($tobool44) { __label__ = 23;; } else { __label__ = 24;; } //@line 2456 "dictionary.cpp"
          if (__label__ == 23) {
  
            var $38=$any_alpha; //@line 2457 "dictionary.cpp"
            var $inc46=((($38)+1)&4294967295); //@line 2457 "dictionary.cpp"
            $any_alpha=$inc46; //@line 2457 "dictionary.cpp"
            ; //@line 2457 "dictionary.cpp"
          }
  
          var $39=$c; //@line 2459 "dictionary.cpp"
          var $idxprom=((($39))&255); //@line 2459 "dictionary.cpp"
          var $40=$tr_addr; //@line 2459 "dictionary.cpp"
          var $groups2_count=(($40+7756)&4294967295); //@line 2459 "dictionary.cpp"
          var $arrayidx48=(($groups2_count+$idxprom)&4294967295); //@line 2459 "dictionary.cpp"
          var $41=HEAPU8[($arrayidx48)]; //@line 2459 "dictionary.cpp"
          var $conv49=((($41))&255); //@line 2459 "dictionary.cpp"
          $n=$conv49; //@line 2459 "dictionary.cpp"
          var $42=HEAP32[(($wc)>>2)]; //@line 2460 "dictionary.cpp"
          var $call50=__Z7IsDigitj($42); //@line 2460 "dictionary.cpp"
          var $tobool51=((($call50))|0)!=0; //@line 2460 "dictionary.cpp"
          if ($tobool51) { __label__ = 25;; } else { __label__ = 30;; } //@line 2460 "dictionary.cpp"
          $land_lhs_true52$$if_else70$35: do { 
            if (__label__ == 25) {
  
              var $43=$tr_addr; //@line 2460 "dictionary.cpp"
              var $langopts=(($43)&4294967295); //@line 2460 "dictionary.cpp"
              var $tone_numbers=(($langopts+250)&4294967295); //@line 2460 "dictionary.cpp"
              var $44=HEAP8[($tone_numbers)]; //@line 2460 "dictionary.cpp"
              var $conv53=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 2460 "dictionary.cpp"
              var $cmp54=((($conv53))|0)==0; //@line 2460 "dictionary.cpp"
              if ($cmp54) { __label__ = 27;; } else { __label__ = 26;; } //@line 2460 "dictionary.cpp"
              if (__label__ == 26) {
  
                var $45=$any_alpha; //@line 2460 "dictionary.cpp"
                var $tobool55=((($45))|0)!=0; //@line 2460 "dictionary.cpp"
                if ($tobool55) { __label__ = 30;break $land_lhs_true52$$if_else70$35; } //@line 2460 "dictionary.cpp"
              }
  
              HEAP8[($arrayidx57)]=95; //@line 2465 "dictionary.cpp"
              var $46=HEAP32[(($p)>>2)]; //@line 2466 "dictionary.cpp"
              var $47=$wc_bytes; //@line 2466 "dictionary.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = $46;
              $dest$ = $arrayidx58;
              $stop$ = $src$ + $47;
              if (($dest$%4) == ($src$%4) && $47 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 2466 "dictionary.cpp"
              var $48=$wc_bytes; //@line 2467 "dictionary.cpp"
              var $add=((($48)+1)&4294967295); //@line 2467 "dictionary.cpp"
              var $arrayidx59=(($string+$add)&4294967295); //@line 2467 "dictionary.cpp"
              HEAP8[($arrayidx59)]=0; //@line 2467 "dictionary.cpp"
              var $49=$tr_addr; //@line 2468 "dictionary.cpp"
              var $call62=__Z6LookupP10TranslatorPKcPc($49, $arraydecay60, $arraydecay61); //@line 2468 "dictionary.cpp"
              var $50=$digit_count; //@line 2469 "dictionary.cpp"
              var $inc63=((($50)+1)&4294967295); //@line 2469 "dictionary.cpp"
              $digit_count=$inc63; //@line 2469 "dictionary.cpp"
              var $cmp64=((($inc63))>>>0) >= 2; //@line 2469 "dictionary.cpp"
              if ($cmp64) { __label__ = 28;; } else { __label__ = 29;; } //@line 2469 "dictionary.cpp"
              if (__label__ == 28) {
  
                var $strlen=_strlen($arraydecay66); //@line 2471 "dictionary.cpp"
                var $endptr=(($arraydecay66+$strlen)&4294967295); //@line 2471 "dictionary.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__ZZ14TranslateRulesP10TranslatorPcS1_iS1_iPjE9str_pause)&4294967295);
                $dest$ = $endptr;
                $stop$ = $src$ + 2;
                if (($dest$%4) == ($src$%4) && 2 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 2471 "dictionary.cpp"
                $digit_count=0; //@line 2472 "dictionary.cpp"
                ; //@line 2473 "dictionary.cpp"
              }
  
              var $51=$tr_addr; //@line 2474 "dictionary.cpp"
              var $52=$phonemes_addr; //@line 2474 "dictionary.cpp"
              var $53=$ph_size_addr; //@line 2474 "dictionary.cpp"
              __Z14AppendPhonemesP10TranslatorPciPKc($51, $52, $53, $arraydecay69); //@line 2474 "dictionary.cpp"
              var $54=$wc_bytes; //@line 2475 "dictionary.cpp"
              var $55=HEAP32[(($p)>>2)]; //@line 2475 "dictionary.cpp"
              var $add_ptr=(($55+$54)&4294967295); //@line 2475 "dictionary.cpp"
              HEAP32[(($p)>>2)]=$add_ptr; //@line 2475 "dictionary.cpp"
              __label__ = 20;continue $while_cond$28; //@line 2476 "dictionary.cpp"
            }
          } while(0);
  
          $digit_count=0; //@line 2480 "dictionary.cpp"
          $found=0; //@line 2481 "dictionary.cpp"
          var $56=HEAP32[(($wc)>>2)]; //@line 2483 "dictionary.cpp"
          var $57=$tr_addr; //@line 2483 "dictionary.cpp"
          var $letter_bits_offset=(($57+964)&4294967295); //@line 2483 "dictionary.cpp"
          var $58=HEAP32[(($letter_bits_offset)>>2)]; //@line 2483 "dictionary.cpp"
          var $sub=((($56)-($58))&4294967295); //@line 2483 "dictionary.cpp"
          $ix=$sub; //@line 2483 "dictionary.cpp"
          var $cmp71=((($sub))|0) >= 0; //@line 2483 "dictionary.cpp"
          if ($cmp71) { __label__ = 31;; } else { __label__ = 34;; } //@line 2483 "dictionary.cpp"
          $land_lhs_true72$$if_end81$44: do { 
            if (__label__ == 31) {
  
              var $59=$ix; //@line 2483 "dictionary.cpp"
              var $cmp73=((($59))|0) < 128; //@line 2483 "dictionary.cpp"
              if (!($cmp73)) { __label__ = 34;break $land_lhs_true72$$if_end81$44; } //@line 2483 "dictionary.cpp"
  
              var $60=$ix; //@line 2485 "dictionary.cpp"
              var $61=$tr_addr; //@line 2485 "dictionary.cpp"
              var $groups3=(($61+6280)&4294967295); //@line 2485 "dictionary.cpp"
              var $arrayidx75=(($groups3+$60*4)&4294967295); //@line 2485 "dictionary.cpp"
              var $62=HEAP32[(($arrayidx75)>>2)]; //@line 2485 "dictionary.cpp"
              var $cmp76=((($62))|0)!=0; //@line 2485 "dictionary.cpp"
              if (!($cmp76)) { __label__ = 34;break $land_lhs_true72$$if_end81$44; } //@line 2485 "dictionary.cpp"
  
              var $63=$tr_addr; //@line 2487 "dictionary.cpp"
              var $64=$p_start_addr; //@line 2487 "dictionary.cpp"
              var $65=$wc_bytes; //@line 2487 "dictionary.cpp"
              var $66=$ix; //@line 2487 "dictionary.cpp"
              var $67=$tr_addr; //@line 2487 "dictionary.cpp"
              var $groups378=(($67+6280)&4294967295); //@line 2487 "dictionary.cpp"
              var $arrayidx79=(($groups378+$66*4)&4294967295); //@line 2487 "dictionary.cpp"
              var $68=HEAP32[(($arrayidx79)>>2)]; //@line 2487 "dictionary.cpp"
              var $69=$word_flags_addr; //@line 2487 "dictionary.cpp"
              var $70=$dict_flags0; //@line 2487 "dictionary.cpp"
              __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($63, $p, $64, $65, $68, $match1, $69, $70); //@line 2487 "dictionary.cpp"
              $found=1; //@line 2488 "dictionary.cpp"
              __label__ = 85;break $land_lhs_true72$$if_end81$44; //@line 2524 "dictionary.cpp"
            }
          } while(0);
          $if_end281$$if_end81$48: do { 
            if (__label__ == 34) {
  
              var $_pr3=$found; //@line 2492 "dictionary.cpp"
              var $tobool82=((($_pr3))|0)!=0; //@line 2492 "dictionary.cpp"
              if ($tobool82) { __label__ = 85;break $if_end281$$if_end81$48; } //@line 2492 "dictionary.cpp"
  
              var $71=$n; //@line 2492 "dictionary.cpp"
              var $cmp84=((($71))|0) > 0; //@line 2492 "dictionary.cpp"
              if ($cmp84) { __label__ = 36;; } else { __label__ = 43;; } //@line 2492 "dictionary.cpp"
              $if_then85$$if_end121$51: do { 
                if (__label__ == 36) {
  
                  var $72=HEAP32[(($p)>>2)]; //@line 2495 "dictionary.cpp"
                  var $arrayidx86=(($72+1)&4294967295); //@line 2495 "dictionary.cpp"
                  var $73=HEAP8[($arrayidx86)]; //@line 2495 "dictionary.cpp"
                  $c2=$73; //@line 2495 "dictionary.cpp"
                  var $74=$c; //@line 2496 "dictionary.cpp"
                  var $conv87=((($74))&255); //@line 2496 "dictionary.cpp"
                  var $75=$c2; //@line 2496 "dictionary.cpp"
                  var $conv88=((($75))&255); //@line 2496 "dictionary.cpp"
                  var $shl=((($conv88)*256)&4294967295); //@line 2496 "dictionary.cpp"
                  var $add89=((($shl)+($conv87))&4294967295); //@line 2496 "dictionary.cpp"
                  $c12=$add89; //@line 2496 "dictionary.cpp"
                  var $76=$c12; //@line 2497 "dictionary.cpp"
                  var $77=HEAP32[(($p)>>2)]; //@line 2497 "dictionary.cpp"
                  var $arrayidx90=(($77+2)&4294967295); //@line 2497 "dictionary.cpp"
                  var $78=HEAP8[($arrayidx90)]; //@line 2497 "dictionary.cpp"
                  var $conv91=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 2497 "dictionary.cpp"
                  var $shl92=((($conv91)*65536)&4294967295); //@line 2497 "dictionary.cpp"
                  var $add93=((($shl92)+($76))&4294967295); //@line 2497 "dictionary.cpp"
                  $c123=$add93; //@line 2497 "dictionary.cpp"
                  var $79=$c; //@line 2499 "dictionary.cpp"
                  var $idxprom94=((($79))&255); //@line 2499 "dictionary.cpp"
                  var $80=$tr_addr; //@line 2499 "dictionary.cpp"
                  var $groups2_start=(($80+8012)&4294967295); //@line 2499 "dictionary.cpp"
                  var $arrayidx95=(($groups2_start+$idxprom94)&4294967295); //@line 2499 "dictionary.cpp"
                  var $81=HEAPU8[($arrayidx95)]; //@line 2499 "dictionary.cpp"
                  var $conv96=((($81))&255); //@line 2499 "dictionary.cpp"
                  $g1=$conv96; //@line 2499 "dictionary.cpp"
                  var $82=$g1; //@line 2500 "dictionary.cpp"
                  $g=$82; //@line 2500 "dictionary.cpp"
                  var $83=$g; //@line 2500 "dictionary.cpp"
                  var $84=$g1; //@line 2500 "dictionary.cpp"
                  var $85=$n; //@line 2500 "dictionary.cpp"
                  var $add989=((($85)+($84))&4294967295); //@line 2500 "dictionary.cpp"
                  var $cmp9910=((($83))|0) < ((($add989))|0); //@line 2500 "dictionary.cpp"
                  if (!($cmp9910)) { __label__ = 43;break $if_then85$$if_end121$51; } //@line 2500 "dictionary.cpp"
                  $for_body100$53: while(1) { 
  
                    var $86=$g; //@line 2502 "dictionary.cpp"
                    var $87=$tr_addr; //@line 2502 "dictionary.cpp"
                    var $groups2_name=(($87+7272)&4294967295); //@line 2502 "dictionary.cpp"
                    var $arrayidx101=(($groups2_name+$86*4)&4294967295); //@line 2502 "dictionary.cpp"
                    var $88=HEAP32[(($arrayidx101)>>2)]; //@line 2502 "dictionary.cpp"
                    var $89=$c12; //@line 2502 "dictionary.cpp"
                    var $cmp102=((($88))|0)==((($89))|0); //@line 2502 "dictionary.cpp"
                    if ($cmp102) { __label__ = 38;; } else { __label__ = 42;; } //@line 2502 "dictionary.cpp"
                    $if_then103$$for_inc118$55: do { 
                      if (__label__ == 38) {
  
                        $found=1; //@line 2504 "dictionary.cpp"
                        var $90=HEAP32[(($p)>>2)]; //@line 2506 "dictionary.cpp"
                        HEAP32[(($p2)>>2)]=$90; //@line 2506 "dictionary.cpp"
                        var $91=$tr_addr; //@line 2507 "dictionary.cpp"
                        var $92=$p_start_addr; //@line 2507 "dictionary.cpp"
                        var $93=$g; //@line 2507 "dictionary.cpp"
                        var $94=$tr_addr; //@line 2507 "dictionary.cpp"
                        var $groups2=(($94+6792)&4294967295); //@line 2507 "dictionary.cpp"
                        var $arrayidx104=(($groups2+$93*4)&4294967295); //@line 2507 "dictionary.cpp"
                        var $95=HEAP32[(($arrayidx104)>>2)]; //@line 2507 "dictionary.cpp"
                        var $96=$word_flags_addr; //@line 2507 "dictionary.cpp"
                        var $97=$dict_flags0; //@line 2507 "dictionary.cpp"
                        __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($91, $p2, $92, 2, $95, $match2, $96, $97); //@line 2507 "dictionary.cpp"
                        var $98=HEAP32[(($points)>>2)]; //@line 2508 "dictionary.cpp"
                        var $cmp105=((($98))|0) > 0; //@line 2508 "dictionary.cpp"
                        if ($cmp105) { __label__ = 39;; } else { __label__ = 40;; } //@line 2508 "dictionary.cpp"
                        if (__label__ == 39) {
  
                          var $99=HEAP32[(($points107)>>2)]; //@line 2509 "dictionary.cpp"
                          var $add108=((($99)+35)&4294967295); //@line 2509 "dictionary.cpp"
                          HEAP32[(($points107)>>2)]=$add108; //@line 2509 "dictionary.cpp"
                          ; //@line 2509 "dictionary.cpp"
                        }
  
                        var $100=$tr_addr; //@line 2512 "dictionary.cpp"
                        var $101=$p_start_addr; //@line 2512 "dictionary.cpp"
                        var $102=$c; //@line 2512 "dictionary.cpp"
                        var $idxprom110=((($102))&255); //@line 2512 "dictionary.cpp"
                        var $103=$tr_addr; //@line 2512 "dictionary.cpp"
                        var $groups1=(($103+5256)&4294967295); //@line 2512 "dictionary.cpp"
                        var $arrayidx111=(($groups1+$idxprom110*4)&4294967295); //@line 2512 "dictionary.cpp"
                        var $104=HEAP32[(($arrayidx111)>>2)]; //@line 2512 "dictionary.cpp"
                        var $105=$word_flags_addr; //@line 2512 "dictionary.cpp"
                        var $106=$dict_flags0; //@line 2512 "dictionary.cpp"
                        __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($100, $p, $101, 1, $104, $match1, $105, $106); //@line 2512 "dictionary.cpp"
                        var $107=HEAP32[(($points112)>>2)]; //@line 2514 "dictionary.cpp"
                        var $108=HEAP32[(($points113)>>2)]; //@line 2514 "dictionary.cpp"
                        var $cmp114=((($107))|0) >= ((($108))|0); //@line 2514 "dictionary.cpp"
                        if (!($cmp114)) { __label__ = 42;break $if_then103$$for_inc118$55; } //@line 2514 "dictionary.cpp"
  
                        var $src$, $dest$, $stop$, $stop4$, $fast$;
                        $src$ = $31;
                        $dest$ = $30;
                        $stop$ = $src$ + 16;
                        if (($dest$%4) == ($src$%4) && 16 > 8) {
                          while ($src$%4 !== 0 && $src$ < $stop$) {
                            ; HEAP8[$dest$++] = HEAP8[$src$++];
                          }
                          $src$ >>= 2;
                          $dest$ >>= 2;
                          $stop4$ = $stop$ >> 2;
                          while ($src$ < $stop4$) {
                        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                          }
                          $src$ <<= 2;
                          $dest$ <<= 2;
                        }while ($src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }; //@line 2517 "dictionary.cpp"
                        var $109=HEAP32[(($p2)>>2)]; //@line 2518 "dictionary.cpp"
                        HEAP32[(($p)>>2)]=$109; //@line 2518 "dictionary.cpp"
                        ; //@line 2519 "dictionary.cpp"
                      }
                    } while(0);
  
                    var $110=$g; //@line 2500 "dictionary.cpp"
                    var $inc119=((($110)+1)&4294967295); //@line 2500 "dictionary.cpp"
                    $g=$inc119; //@line 2500 "dictionary.cpp"
                    var $111=$g; //@line 2500 "dictionary.cpp"
                    var $112=$g1; //@line 2500 "dictionary.cpp"
                    var $113=$n; //@line 2500 "dictionary.cpp"
                    var $add98=((($113)+($112))&4294967295); //@line 2500 "dictionary.cpp"
                    var $cmp99=((($111))|0) < ((($add98))|0); //@line 2500 "dictionary.cpp"
                    if ($cmp99) { __label__ = 37;continue $for_body100$53; } else { __label__ = 43;break $if_then85$$if_end121$51; } //@line 2500 "dictionary.cpp"
                  }
                }
              } while(0);
  
              var $_pr5_pr=$found; //@line 2524 "dictionary.cpp"
              var $tobool122=((($_pr5_pr))|0)!=0; //@line 2524 "dictionary.cpp"
              if ($tobool122) { __label__ = 85;break $if_end281$$if_end81$48; } //@line 2524 "dictionary.cpp"
  
              var $114=$c; //@line 2527 "dictionary.cpp"
              var $idxprom124=((($114))&255); //@line 2527 "dictionary.cpp"
              var $115=$tr_addr; //@line 2527 "dictionary.cpp"
              var $groups1125=(($115+5256)&4294967295); //@line 2527 "dictionary.cpp"
              var $arrayidx126=(($groups1125+$idxprom124*4)&4294967295); //@line 2527 "dictionary.cpp"
              var $116=HEAP32[(($arrayidx126)>>2)]; //@line 2527 "dictionary.cpp"
              var $cmp127=((($116))|0)!=0; //@line 2527 "dictionary.cpp"
              var $117=$tr_addr; //@line 2528 "dictionary.cpp"
              var $118=$p_start_addr; //@line 2528 "dictionary.cpp"
              if ($cmp127) { __label__ = 45;; } else { __label__ = 46;; } //@line 2527 "dictionary.cpp"
              $if_then128$$if_else132$64: do { 
                if (__label__ == 45) {
  
                  var $119=$c; //@line 2528 "dictionary.cpp"
                  var $idxprom129=((($119))&255); //@line 2528 "dictionary.cpp"
                  var $120=$tr_addr; //@line 2528 "dictionary.cpp"
                  var $groups1130=(($120+5256)&4294967295); //@line 2528 "dictionary.cpp"
                  var $arrayidx131=(($groups1130+$idxprom129*4)&4294967295); //@line 2528 "dictionary.cpp"
                  var $121=HEAP32[(($arrayidx131)>>2)]; //@line 2528 "dictionary.cpp"
                  var $122=$word_flags_addr; //@line 2528 "dictionary.cpp"
                  var $123=$dict_flags0; //@line 2528 "dictionary.cpp"
                  __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($117, $p, $118, 1, $121, $match1, $122, $123); //@line 2528 "dictionary.cpp"
                  __label__ = 74;break $if_then128$$if_else132$64; //@line 2528 "dictionary.cpp"
                }
                else if (__label__ == 46) {
  
                  var $124=$tr_addr; //@line 2532 "dictionary.cpp"
                  var $groups1133=(($124+5256)&4294967295); //@line 2532 "dictionary.cpp"
                  var $arrayidx134=(($groups1133)&4294967295); //@line 2532 "dictionary.cpp"
                  var $125=HEAP32[(($arrayidx134)>>2)]; //@line 2532 "dictionary.cpp"
                  var $126=$word_flags_addr; //@line 2532 "dictionary.cpp"
                  var $127=$dict_flags0; //@line 2532 "dictionary.cpp"
                  __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($117, $p, $118, 0, $125, $match1, $126, $127); //@line 2532 "dictionary.cpp"
                  var $128=HEAP32[(($points135)>>2)]; //@line 2534 "dictionary.cpp"
                  var $cmp136=((($128))|0)==0; //@line 2534 "dictionary.cpp"
                  if (!($cmp136)) { __label__ = 84;break $if_then128$$if_else132$64; } //@line 2534 "dictionary.cpp"
  
                  var $129=HEAP32[((_option_sayas)>>2)]; //@line 2534 "dictionary.cpp"
                  var $and138=($129) & 16; //@line 2534 "dictionary.cpp"
                  var $cmp139=((($and138))|0)==0; //@line 2534 "dictionary.cpp"
                  if (!($cmp139)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2534 "dictionary.cpp"
  
                  var $130=HEAP32[(($p)>>2)]; //@line 2536 "dictionary.cpp"
                  var $add_ptr141=(($130+-1)&4294967295); //@line 2536 "dictionary.cpp"
                  var $call142=__Z7utf8_inPiPKc($letter, $add_ptr141); //@line 2536 "dictionary.cpp"
                  var $sub143=((($call142)-1)&4294967295); //@line 2536 "dictionary.cpp"
                  $n=$sub143; //@line 2536 "dictionary.cpp"
                  var $131=$tr_addr; //@line 2538 "dictionary.cpp"
                  var $letter_bits_offset144=(($131+964)&4294967295); //@line 2538 "dictionary.cpp"
                  var $132=HEAP32[(($letter_bits_offset144)>>2)]; //@line 2538 "dictionary.cpp"
                  var $cmp145=((($132))|0) > 0; //@line 2538 "dictionary.cpp"
                  if ($cmp145) { __label__ = 49;; } else { __label__ = 52;; } //@line 2538 "dictionary.cpp"
                  $if_then146$$if_end155thread_pre_split$69: do { 
                    if (__label__ == 49) {
  
                      var $133=HEAP32[(($letter)>>2)]; //@line 2541 "dictionary.cpp"
                      var $cmp147=((($133))|0) <= 577; //@line 2541 "dictionary.cpp"
                      if ($cmp147) { __lastLabel__ = 49; ; } else { __lastLabel__ = 49; __label__ = 53;break $if_then146$$if_end155thread_pre_split$69; } //@line 2541 "dictionary.cpp"
  
                      var $134=HEAP32[(($letter)>>2)]; //@line 2541 "dictionary.cpp"
                      var $call149=_iswalpha($134); //@line 2541 "dictionary.cpp"
                      var $tobool150=((($call149))|0)!=0; //@line 2541 "dictionary.cpp"
                      if ($tobool150) { __label__ = 51;break $while_cond$28; } else { __label__ = 52;break $if_then146$$if_end155thread_pre_split$69; } //@line 2541 "dictionary.cpp"
                    }
                  } while(0);
                  if (__label__ == 52) {
  
                    var $_pr7=HEAP32[(($letter)>>2)]; //@line 2558 "dictionary.cpp"
                    __lastLabel__ = 52; ;
                  }
  
                  var $138=__lastLabel__ == 52 ? $_pr7 : ($133); //@line 2558 "dictionary.cpp"
                  var $cmp156=((($138))|0)==57384; //@line 2558 "dictionary.cpp"
                  if ($cmp156) { __label__ = 54;; } else { __label__ = 56;; } //@line 2558 "dictionary.cpp"
                  $if_then157$$if_end166$75: do { 
                    if (__label__ == 54) {
  
                      var $139=HEAP32[((_pre_pause)>>2)]; //@line 2560 "dictionary.cpp"
                      var $140=$tr_addr; //@line 2560 "dictionary.cpp"
                      var $langopts158=(($140)&4294967295); //@line 2560 "dictionary.cpp"
                      var $param2=(($langopts158+100)&4294967295); //@line 2560 "dictionary.cpp"
                      var $arrayidx159=(($param2+64)&4294967295); //@line 2560 "dictionary.cpp"
                      var $141=HEAP32[(($arrayidx159)>>2)]; //@line 2560 "dictionary.cpp"
                      var $cmp160=((($139))|0) < ((($141))|0); //@line 2560 "dictionary.cpp"
                      if (!($cmp160)) { __label__ = 56;break $if_then157$$if_end166$75; } //@line 2560 "dictionary.cpp"
  
                      var $142=$tr_addr; //@line 2561 "dictionary.cpp"
                      var $langopts162=(($142)&4294967295); //@line 2561 "dictionary.cpp"
                      var $param2163=(($langopts162+100)&4294967295); //@line 2561 "dictionary.cpp"
                      var $arrayidx164=(($param2163+64)&4294967295); //@line 2561 "dictionary.cpp"
                      var $143=HEAP32[(($arrayidx164)>>2)]; //@line 2561 "dictionary.cpp"
                      HEAP32[((_pre_pause)>>2)]=$143; //@line 2561 "dictionary.cpp"
                      ; //@line 2561 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $144=HEAP32[(($letter)>>2)]; //@line 2563 "dictionary.cpp"
                  var $call167=__Z9IsBracketi($144); //@line 2563 "dictionary.cpp"
                  var $tobool168=((($call167))|0)!=0; //@line 2563 "dictionary.cpp"
                  if ($tobool168) { __label__ = 57;; } else { __label__ = 59;; } //@line 2563 "dictionary.cpp"
                  $if_then169$$if_end178$79: do { 
                    if (__label__ == 57) {
  
                      var $145=HEAP32[((_pre_pause)>>2)]; //@line 2565 "dictionary.cpp"
                      var $146=$tr_addr; //@line 2565 "dictionary.cpp"
                      var $langopts170=(($146)&4294967295); //@line 2565 "dictionary.cpp"
                      var $param=(($langopts170+24)&4294967295); //@line 2565 "dictionary.cpp"
                      var $arrayidx171=(($param+64)&4294967295); //@line 2565 "dictionary.cpp"
                      var $147=HEAP32[(($arrayidx171)>>2)]; //@line 2565 "dictionary.cpp"
                      var $cmp172=((($145))|0) < ((($147))|0); //@line 2565 "dictionary.cpp"
                      if (!($cmp172)) { __label__ = 59;break $if_then169$$if_end178$79; } //@line 2565 "dictionary.cpp"
  
                      var $148=$tr_addr; //@line 2566 "dictionary.cpp"
                      var $langopts174=(($148)&4294967295); //@line 2566 "dictionary.cpp"
                      var $param175=(($langopts174+24)&4294967295); //@line 2566 "dictionary.cpp"
                      var $arrayidx176=(($param175+64)&4294967295); //@line 2566 "dictionary.cpp"
                      var $149=HEAP32[(($arrayidx176)>>2)]; //@line 2566 "dictionary.cpp"
                      HEAP32[((_pre_pause)>>2)]=$149; //@line 2566 "dictionary.cpp"
                      ; //@line 2566 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $150=HEAP32[(($letter)>>2)]; //@line 2570 "dictionary.cpp"
                  var $cmp179=((($150))|0) >= 192; //@line 2570 "dictionary.cpp"
                  var $151=HEAP32[(($letter)>>2)]; //@line 2570 "dictionary.cpp"
                  var $cmp181=((($151))|0) < 606; //@line 2570 "dictionary.cpp"
                  var $or_cond=($cmp179) & ($cmp181); //@line 2570 "dictionary.cpp"
                  if ($or_cond) { __label__ = 60;; } else { __label__ = 71;; } //@line 2570 "dictionary.cpp"
                  $land_lhs_true182$$if_else223$83: do { 
                    if (__label__ == 60) {
  
                      var $152=HEAP32[(($letter)>>2)]; //@line 2570 "dictionary.cpp"
                      var $sub183=((($152)-192)&4294967295); //@line 2570 "dictionary.cpp"
                      var $arrayidx184=((__ZL13remove_accent+$sub183)&4294967295); //@line 2570 "dictionary.cpp"
                      var $153=HEAPU8[($arrayidx184)]; //@line 2570 "dictionary.cpp"
                      var $conv185=((($153))&255); //@line 2570 "dictionary.cpp"
                      $ix=$conv185; //@line 2570 "dictionary.cpp"
                      var $cmp186=((($conv185))|0)!=0; //@line 2570 "dictionary.cpp"
                      if (!($cmp186)) { __label__ = 71;break $land_lhs_true182$$if_else223$83; } //@line 2570 "dictionary.cpp"
  
                      var $154=HEAP32[(($p)>>2)]; //@line 2573 "dictionary.cpp"
                      var $arrayidx188=(($154+-2)&4294967295); //@line 2573 "dictionary.cpp"
                      var $155=HEAP8[($arrayidx188)]; //@line 2573 "dictionary.cpp"
                      var $conv189=(tempInt=(($155)),(tempInt>=128?tempInt-256:tempInt)); //@line 2573 "dictionary.cpp"
                      var $cmp190=((($conv189))|0)!=32; //@line 2573 "dictionary.cpp"
                      if ($cmp190) { __label__ = 63;; } else { __label__ = 62;; } //@line 2573 "dictionary.cpp"
                      if (__label__ == 62) {
  
                        var $156=$n; //@line 2573 "dictionary.cpp"
                        var $157=HEAP32[(($p)>>2)]; //@line 2573 "dictionary.cpp"
                        var $arrayidx192=(($157+$156)&4294967295); //@line 2573 "dictionary.cpp"
                        var $158=HEAP8[($arrayidx192)]; //@line 2573 "dictionary.cpp"
                        var $conv193=(tempInt=(($158)),(tempInt>=128?tempInt-256:tempInt)); //@line 2573 "dictionary.cpp"
                        var $cmp194=((($conv193))|0)!=32; //@line 2573 "dictionary.cpp"
                        if (!($cmp194)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2573 "dictionary.cpp"
                      }
  
                      var $159=HEAP32[(($p)>>2)]; //@line 2576 "dictionary.cpp"
                      var $add_ptr196=(($159+-1)&4294967295); //@line 2576 "dictionary.cpp"
                      HEAP32[(($p2)>>2)]=$add_ptr196; //@line 2576 "dictionary.cpp"
                      var $160=$ix; //@line 2577 "dictionary.cpp"
                      var $conv197=((($160)) & 255); //@line 2577 "dictionary.cpp"
                      var $161=HEAP32[(($p)>>2)]; //@line 2577 "dictionary.cpp"
                      var $arrayidx198=(($161+-1)&4294967295); //@line 2577 "dictionary.cpp"
                      HEAP8[($arrayidx198)]=$conv197; //@line 2577 "dictionary.cpp"
                      var $162=$n; //@line 2578 "dictionary.cpp"
                      var $163=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                      var $arrayidx20011=(($163+$162)&4294967295); //@line 2578 "dictionary.cpp"
                      var $164=HEAP8[($arrayidx20011)]; //@line 2578 "dictionary.cpp"
                      var $165=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                      var $arrayidx20112=(($165)&4294967295); //@line 2578 "dictionary.cpp"
                      HEAP8[($arrayidx20112)]=$164; //@line 2578 "dictionary.cpp"
                      var $conv20213=(tempInt=(($164)),(tempInt>=128?tempInt-256:tempInt)); //@line 2578 "dictionary.cpp"
                      var $cmp20314=((($conv20213))|0)!=32; //@line 2578 "dictionary.cpp"
                      if ($cmp20314) { __label__ = 64;; } else { __label__ = 65;; } //@line 2578 "dictionary.cpp"
                      $while_body204$$while_cond205_loopexit$89: do { 
                        if (__label__ == 64) {
                          while(1) { 
  
                            var $166=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                            var $incdec_ptr=(($166+1)&4294967295); //@line 2578 "dictionary.cpp"
                            HEAP32[(($p)>>2)]=$incdec_ptr; //@line 2578 "dictionary.cpp"
                            var $167=$n; //@line 2578 "dictionary.cpp"
                            var $168=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                            var $arrayidx200=(($168+$167)&4294967295); //@line 2578 "dictionary.cpp"
                            var $169=HEAP8[($arrayidx200)]; //@line 2578 "dictionary.cpp"
                            var $170=HEAP32[(($p)>>2)]; //@line 2578 "dictionary.cpp"
                            var $arrayidx201=(($170)&4294967295); //@line 2578 "dictionary.cpp"
                            HEAP8[($arrayidx201)]=$169; //@line 2578 "dictionary.cpp"
                            var $conv202=(tempInt=(($169)),(tempInt>=128?tempInt-256:tempInt)); //@line 2578 "dictionary.cpp"
                            var $cmp203=((($conv202))|0)!=32; //@line 2578 "dictionary.cpp"
                            if ($cmp203) { __label__ = 64;continue ; } else { __label__ = 65;break $while_body204$$while_cond205_loopexit$89; } //@line 2578 "dictionary.cpp"
                          }
                        }
                      } while(0);
  
                      var $171=$n; //@line 2579 "dictionary.cpp"
                      var $dec15=((($171)-1)&4294967295); //@line 2579 "dictionary.cpp"
                      $n=$dec15; //@line 2579 "dictionary.cpp"
                      var $cmp20616=((($171))|0) > 0; //@line 2579 "dictionary.cpp"
                      if ($cmp20616) { __label__ = 66;; } else { __label__ = 67;; } //@line 2579 "dictionary.cpp"
                      $while_body207$$while_end209$93: do { 
                        if (__label__ == 66) {
                          while(1) { 
  
                            var $172=HEAP32[(($p)>>2)]; //@line 2579 "dictionary.cpp"
                            var $incdec_ptr208=(($172+1)&4294967295); //@line 2579 "dictionary.cpp"
                            HEAP32[(($p)>>2)]=$incdec_ptr208; //@line 2579 "dictionary.cpp"
                            HEAP8[($172)]=32; //@line 2579 "dictionary.cpp"
                            var $173=$n; //@line 2579 "dictionary.cpp"
                            var $dec=((($173)-1)&4294967295); //@line 2579 "dictionary.cpp"
                            $n=$dec; //@line 2579 "dictionary.cpp"
                            var $cmp206=((($173))|0) > 0; //@line 2579 "dictionary.cpp"
                            if ($cmp206) { __label__ = 66;continue ; } else { __label__ = 67;break $while_body207$$while_end209$93; } //@line 2579 "dictionary.cpp"
                          }
                        }
                      } while(0);
  
                      var $174=$tr_addr; //@line 2581 "dictionary.cpp"
                      var $langopts210=(($174)&4294967295); //@line 2581 "dictionary.cpp"
                      var $param211=(($langopts210+24)&4294967295); //@line 2581 "dictionary.cpp"
                      var $arrayidx212=(($param211+4)&4294967295); //@line 2581 "dictionary.cpp"
                      var $175=HEAP32[(($arrayidx212)>>2)]; //@line 2581 "dictionary.cpp"
                      var $tobool213=((($175))|0)!=0; //@line 2581 "dictionary.cpp"
                      if ($tobool213) { __label__ = 68;; } else { __label__ = 70;; } //@line 2581 "dictionary.cpp"
                      $land_lhs_true214$$if_end218$97: do { 
                        if (__label__ == 68) {
  
                          var $176=HEAP32[(($letter)>>2)]; //@line 2581 "dictionary.cpp"
                          var $call215=__Z11lookupwcharPKti(((__ZL13diereses_list)&4294967295), $176); //@line 2581 "dictionary.cpp"
                          var $cmp216=((($call215))|0) > 0; //@line 2581 "dictionary.cpp"
                          if (!($cmp216)) { __label__ = 70;break $land_lhs_true214$$if_end218$97; } //@line 2581 "dictionary.cpp"
  
                          var $177=HEAP32[(($p2)>>2)]; //@line 2584 "dictionary.cpp"
                          HEAP32[(($p)>>2)]=$177; //@line 2584 "dictionary.cpp"
                          __label__ = 20;continue $while_cond$28; //@line 2585 "dictionary.cpp"
                        }
                      } while(0);
  
                      var $178=$phonemes_addr; //@line 2588 "dictionary.cpp"
                      var $arrayidx219=(($178)&4294967295); //@line 2588 "dictionary.cpp"
                      HEAP8[($arrayidx219)]=0; //@line 2588 "dictionary.cpp"
                      var $179=$p_start_addr; //@line 2589 "dictionary.cpp"
                      HEAP32[(($p)>>2)]=$179; //@line 2589 "dictionary.cpp"
                      var $180=$tr_addr; //@line 2590 "dictionary.cpp"
                      var $word_vowel_count220=(($180+8296)&4294967295); //@line 2590 "dictionary.cpp"
                      HEAP32[(($word_vowel_count220)>>2)]=0; //@line 2590 "dictionary.cpp"
                      var $181=$tr_addr; //@line 2591 "dictionary.cpp"
                      var $word_stressed_count221=(($181+8300)&4294967295); //@line 2591 "dictionary.cpp"
                      HEAP32[(($word_stressed_count221)>>2)]=0; //@line 2591 "dictionary.cpp"
                      __label__ = 20;continue $while_cond$28; //@line 2592 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $182=HEAP32[(($letter)>>2)]; //@line 2596 "dictionary.cpp"
                  var $cmp224=((($182))|0) >= 12800; //@line 2596 "dictionary.cpp"
                  var $183=HEAP32[(($letter)>>2)]; //@line 2596 "dictionary.cpp"
                  var $cmp226=((($183))|0) < 42752; //@line 2596 "dictionary.cpp"
                  var $or_cond1=($cmp224) & ($cmp226); //@line 2596 "dictionary.cpp"
                  if (!($or_cond1)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2596 "dictionary.cpp"
  
                  var $184=$end_phonemes_addr; //@line 2596 "dictionary.cpp"
                  var $cmp228=((($184))|0)!=0; //@line 2596 "dictionary.cpp"
                  if (!($cmp228)) { __label__ = 74;break $if_then128$$if_else132$64; } //@line 2596 "dictionary.cpp"
  
                  var $185=$tr_addr; //@line 2600 "dictionary.cpp"
                  var $call231=__Z6LookupP10TranslatorPKcPc($185, ((__str9306)&4294967295), $arraydecay230); //@line 2600 "dictionary.cpp"
                  HEAP32[(($phonemes233)>>2)]=$arraydecay232; //@line 2601 "dictionary.cpp"
                  HEAP32[(($points234)>>2)]=1; //@line 2602 "dictionary.cpp"
                  var $186=$wc_bytes; //@line 2603 "dictionary.cpp"
                  var $sub235=((($186)-1)&4294967295); //@line 2603 "dictionary.cpp"
                  var $187=HEAP32[(($p)>>2)]; //@line 2603 "dictionary.cpp"
                  var $add_ptr236=(($187+$sub235)&4294967295); //@line 2603 "dictionary.cpp"
                  HEAP32[(($p)>>2)]=$add_ptr236; //@line 2603 "dictionary.cpp"
                  __label__ = 74;break $if_then128$$if_else132$64; //@line 2604 "dictionary.cpp"
                }
              } while(0);
              $if_end240$$if_else278$104: do { 
                if (__label__ == 74) {
  
                  var $_pr17=HEAP32[(($points241)>>2)]; //@line 2608 "dictionary.cpp"
                  var $cmp242=((($_pr17))|0)==0; //@line 2608 "dictionary.cpp"
                  if (!($cmp242)) { __label__ = 84;break $if_end240$$if_else278$104; } //@line 2608 "dictionary.cpp"
  
                  var $188=HEAP32[(($wc)>>2)]; //@line 2610 "dictionary.cpp"
                  var $cmp244=((($188))|0) >= 768; //@line 2610 "dictionary.cpp"
                  var $189=HEAP32[(($wc)>>2)]; //@line 2610 "dictionary.cpp"
                  var $cmp246=((($189))|0) <= 879; //@line 2610 "dictionary.cpp"
                  var $or_cond2=($cmp244) & ($cmp246); //@line 2610 "dictionary.cpp"
                  if ($or_cond2) { __label__ = 83;; } else { __label__ = 76;; } //@line 2610 "dictionary.cpp"
                  $if_end275$$if_else248$107: do { 
                    if (__label__ == 76) {
  
                      var $190=HEAP32[(($wc)>>2)]; //@line 2615 "dictionary.cpp"
                      var $call249=__Z7IsAlphaj($190); //@line 2615 "dictionary.cpp"
                      var $tobool250=((($call249))|0)!=0; //@line 2615 "dictionary.cpp"
                      if ($tobool250) { __label__ = 77;; } else { __label__ = 81;; } //@line 2615 "dictionary.cpp"
                      if (__label__ == 77) {
  
                        var $191=$any_alpha; //@line 2617 "dictionary.cpp"
                        var $cmp252=((($191))|0) > 1; //@line 2617 "dictionary.cpp"
                        if ($cmp252) { __label__ = 79;break $while_cond$28; } //@line 2617 "dictionary.cpp"
  
                        var $192=$wc_bytes; //@line 2617 "dictionary.cpp"
                        var $sub254=((($192)-1)&4294967295); //@line 2617 "dictionary.cpp"
                        var $193=HEAP32[(($p)>>2)]; //@line 2617 "dictionary.cpp"
                        var $arrayidx255=(($193+$sub254)&4294967295); //@line 2617 "dictionary.cpp"
                        var $194=HEAP8[($arrayidx255)]; //@line 2617 "dictionary.cpp"
                        var $conv256=(tempInt=(($194)),(tempInt>=128?tempInt-256:tempInt)); //@line 2617 "dictionary.cpp"
                        var $cmp257=((($conv256))|0) > 32; //@line 2617 "dictionary.cpp"
                        if ($cmp257) { __label__ = 79;break $while_cond$28; } //@line 2617 "dictionary.cpp"
                      }
                      else if (__label__ == 81) {
  
                        var $199=$tr_addr; //@line 2628 "dictionary.cpp"
                        var $200=HEAP32[(($wc)>>2)]; //@line 2628 "dictionary.cpp"
                        __Z12LookupLetterP10TranslatorjiPci($199, $200, -1, $arraydecay266, 0); //@line 2628 "dictionary.cpp"
                        var $201=HEAP8[($arrayidx267)]; //@line 2629 "dictionary.cpp"
                        var $tobool268=(tempInt=(($201)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2629 "dictionary.cpp"
                        if (!($tobool268)) { __label__ = 83;break $if_end275$$if_else248$107; } //@line 2629 "dictionary.cpp"
  
                        HEAP32[(($phonemes271)>>2)]=$arraydecay270; //@line 2631 "dictionary.cpp"
                        HEAP32[(($points272)>>2)]=1; //@line 2632 "dictionary.cpp"
                        ; //@line 2633 "dictionary.cpp"
                      }
                    }
                  } while(0);
  
                  var $202=$wc_bytes; //@line 2635 "dictionary.cpp"
                  var $sub276=((($202)-1)&4294967295); //@line 2635 "dictionary.cpp"
                  var $203=HEAP32[(($p)>>2)]; //@line 2635 "dictionary.cpp"
                  var $add_ptr277=(($203+$sub276)&4294967295); //@line 2635 "dictionary.cpp"
                  HEAP32[(($p)>>2)]=$add_ptr277; //@line 2635 "dictionary.cpp"
                  __label__ = 85;break $if_end281$$if_end81$48; //@line 2636 "dictionary.cpp"
                }
              } while(0);
  
              var $204=$tr_addr; //@line 2639 "dictionary.cpp"
              var $phonemes_repeat_count=(($204+652)&4294967295); //@line 2639 "dictionary.cpp"
              HEAP32[(($phonemes_repeat_count)>>2)]=0; //@line 2639 "dictionary.cpp"
              ;
            }
          } while(0);
  
          var $205=HEAP32[(($phonemes282)>>2)]; //@line 2644 "dictionary.cpp"
          var $cmp283=((($205))|0)==0; //@line 2644 "dictionary.cpp"
          if ($cmp283) { __label__ = 86;; } else { __label__ = 87;; } //@line 2644 "dictionary.cpp"
          if (__label__ == 86) {
  
            HEAP32[(($phonemes285)>>2)]=((__str13643)&4294967295); //@line 2645 "dictionary.cpp"
            ; //@line 2645 "dictionary.cpp"
          }
  
          var $206=HEAP32[(($points287)>>2)]; //@line 2647 "dictionary.cpp"
          var $cmp288=((($206))|0) > 0; //@line 2647 "dictionary.cpp"
          if (!($cmp288)) { __label__ = 20;continue $while_cond$28; } //@line 2647 "dictionary.cpp"
  
          var $207=$word_flags_addr; //@line 2649 "dictionary.cpp"
          var $and290=($207) & -2147483648; //@line 2649 "dictionary.cpp"
          var $tobool291=((($and290))|0)!=0; //@line 2649 "dictionary.cpp"
          if ($tobool291) { __label__ = 89;break $while_cond$28; } //@line 2649 "dictionary.cpp"
  
          var $209=HEAP32[(($phonemes295)>>2)]; //@line 2652 "dictionary.cpp"
          var $arrayidx296=(($209)&4294967295); //@line 2652 "dictionary.cpp"
          var $210=HEAP8[($arrayidx296)]; //@line 2652 "dictionary.cpp"
          var $conv297=(tempInt=(($210)),(tempInt>=128?tempInt-256:tempInt)); //@line 2652 "dictionary.cpp"
          var $cmp298=((($conv297))|0)==21; //@line 2652 "dictionary.cpp"
          if ($cmp298) { __label__ = 91;; } else { __label__ = 93;; } //@line 2652 "dictionary.cpp"
          if (__label__ == 91) {
  
            var $211=$word_flags_addr; //@line 2652 "dictionary.cpp"
            var $and300=($211) & 4096; //@line 2652 "dictionary.cpp"
            var $cmp301=((($and300))|0)==0; //@line 2652 "dictionary.cpp"
            if ($cmp301) { __label__ = 92;break $while_cond$28; } //@line 2652 "dictionary.cpp"
          }
  
          var $214=HEAP32[(($end_type306)>>2)]; //@line 2659 "dictionary.cpp"
          var $and307=($214) & -32769; //@line 2659 "dictionary.cpp"
          HEAP32[(($end_type306)>>2)]=$and307; //@line 2659 "dictionary.cpp"
          var $cmp309=((($and307))|0)!=0; //@line 2661 "dictionary.cpp"
          if ($cmp309) { __label__ = 94;; } else { __label__ = 101;; } //@line 2661 "dictionary.cpp"
          $land_lhs_true310$$if_end339$125: do { 
            if (__label__ == 94) {
  
              var $215=$end_phonemes_addr; //@line 2661 "dictionary.cpp"
              var $cmp311=((($215))|0)!=0; //@line 2661 "dictionary.cpp"
              if (!($cmp311)) { __label__ = 101;break $land_lhs_true310$$if_end339$125; } //@line 2661 "dictionary.cpp"
  
              var $216=HEAP32[(($end_type313)>>2)]; //@line 2664 "dictionary.cpp"
              var $and314=($216) & 1024; //@line 2664 "dictionary.cpp"
              var $tobool315=((($and314))|0)!=0; //@line 2664 "dictionary.cpp"
              if (!($tobool315)) { __label__ = 97;break $while_cond$28; } //@line 2664 "dictionary.cpp"
  
              var $217=$word_flags_addr; //@line 2664 "dictionary.cpp"
              var $and317=($217) & 536870912; //@line 2664 "dictionary.cpp"
              var $tobool318=((($and317))|0)!=0; //@line 2664 "dictionary.cpp"
              if (!($tobool318)) { __label__ = 97;break $while_cond$28; } //@line 2664 "dictionary.cpp"
            }
          } while(0);
  
          var $227=HEAP32[(($del_fwd)>>2)]; //@line 2680 "dictionary.cpp"
          var $cmp340=((($227))|0)!=0; //@line 2680 "dictionary.cpp"
          if ($cmp340) { __label__ = 102;; } else { __label__ = 103;; } //@line 2680 "dictionary.cpp"
          if (__label__ == 102) {
  
            var $228=HEAP32[(($del_fwd342)>>2)]; //@line 2681 "dictionary.cpp"
            HEAP8[($228)]=69; //@line 2681 "dictionary.cpp"
            ; //@line 2681 "dictionary.cpp"
          }
  
          var $229=$tr_addr; //@line 2682 "dictionary.cpp"
          var $230=$phonemes_addr; //@line 2682 "dictionary.cpp"
          var $231=$ph_size_addr; //@line 2682 "dictionary.cpp"
          var $232=HEAP32[(($phonemes344)>>2)]; //@line 2682 "dictionary.cpp"
          __Z14AppendPhonemesP10TranslatorPciPKc($229, $230, $231, $232); //@line 2682 "dictionary.cpp"
          __label__ = 20;continue $while_cond$28; //@line 2683 "dictionary.cpp"
        }
        $while_end346$$if_then292$$if_then302$$if_else320$$if_then258$$if_then151$133: do { 
          if (__label__ == 89) {
  
            var $end_type=(($match1+8)&4294967295); //@line 2650 "dictionary.cpp"
            var $208=HEAP32[(($end_type)>>2)]; //@line 2650 "dictionary.cpp"
            var $or293=($208) | 1; //@line 2650 "dictionary.cpp"
            $retval=$or293; //@line 2650 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2650 "dictionary.cpp"
          }
          else if (__label__ == 92) {
  
            var $212=$phonemes_addr; //@line 2655 "dictionary.cpp"
            var $phonemes303=(($match1+4)&4294967295); //@line 2655 "dictionary.cpp"
            var $213=HEAP32[(($phonemes303)>>2)]; //@line 2655 "dictionary.cpp"
            var $call304=_strcpy($212, $213); //@line 2655 "dictionary.cpp"
            $retval=0; //@line 2656 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2656 "dictionary.cpp"
          }
          else if (__label__ == 97) {
  
            var $end_type321=(($match1+8)&4294967295); //@line 2670 "dictionary.cpp"
            var $218=HEAP32[(($end_type321)>>2)]; //@line 2670 "dictionary.cpp"
            var $and322=($218) & 1024; //@line 2670 "dictionary.cpp"
            var $tobool323=((($and322))|0)!=0; //@line 2670 "dictionary.cpp"
            if ($tobool323) { __label__ = 98;; } else { __label__ = 100;; } //@line 2670 "dictionary.cpp"
            $land_lhs_true324$$if_end331$137: do { 
              if (__label__ == 98) {
  
                var $end_type325=(($match1+8)&4294967295); //@line 2670 "dictionary.cpp"
                var $219=HEAP32[(($end_type325)>>2)]; //@line 2670 "dictionary.cpp"
                var $and326=($219) & 127; //@line 2670 "dictionary.cpp"
                var $cmp327=((($and326))|0)==0; //@line 2670 "dictionary.cpp"
                if (!($cmp327)) { __label__ = 100;break $land_lhs_true324$$if_end331$137; } //@line 2670 "dictionary.cpp"
  
                var $220=HEAP32[(($p)>>2)]; //@line 2673 "dictionary.cpp"
                var $221=$p_start_addr; //@line 2673 "dictionary.cpp"
                var $sub_ptr_lhs_cast=($220); //@line 2673 "dictionary.cpp"
                var $sub_ptr_rhs_cast=($221); //@line 2673 "dictionary.cpp"
                var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2673 "dictionary.cpp"
                var $end_type329=(($match1+8)&4294967295); //@line 2673 "dictionary.cpp"
                var $222=HEAP32[(($end_type329)>>2)]; //@line 2673 "dictionary.cpp"
                var $or330=($sub_ptr_sub) | ($222); //@line 2673 "dictionary.cpp"
                HEAP32[(($end_type329)>>2)]=$or330; //@line 2673 "dictionary.cpp"
                ; //@line 2674 "dictionary.cpp"
              }
            } while(0);
  
            var $223=$end_phonemes_addr; //@line 2675 "dictionary.cpp"
            var $phonemes332=(($match1+4)&4294967295); //@line 2675 "dictionary.cpp"
            var $224=HEAP32[(($phonemes332)>>2)]; //@line 2675 "dictionary.cpp"
            var $call333=_strcpy($223, $224); //@line 2675 "dictionary.cpp"
            var $225=$p_start_addr; //@line 2676 "dictionary.cpp"
            var $arraydecay334=(($word_copy)&4294967295); //@line 2676 "dictionary.cpp"
            var $arraydecay335=(($word_copy)&4294967295); //@line 2676 "dictionary.cpp"
            var $call336=_strlen($arraydecay335); //@line 2676 "dictionary.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $arraydecay334;
            $dest$ = $225;
            $stop$ = $src$ + $call336;
            if (($dest$%4) == ($src$%4) && $call336 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 2676 "dictionary.cpp"
            var $end_type337=(($match1+8)&4294967295); //@line 2677 "dictionary.cpp"
            var $226=HEAP32[(($end_type337)>>2)]; //@line 2677 "dictionary.cpp"
            $retval=$226; //@line 2677 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2677 "dictionary.cpp"
          }
          else if (__label__ == 79) {
  
            var $195=$phonemes_addr; //@line 2620 "dictionary.cpp"
            var $arrayidx259=(($195)&4294967295); //@line 2620 "dictionary.cpp"
            HEAP8[($arrayidx259)]=0; //@line 2620 "dictionary.cpp"
            var $196=$dict_flags_addr; //@line 2621 "dictionary.cpp"
            var $cmp260=((($196))|0)!=0; //@line 2621 "dictionary.cpp"
            if (!($cmp260)) { __label__ = 104;break $while_end346$$if_then292$$if_then302$$if_else320$$if_then258$$if_then151$133; } //@line 2621 "dictionary.cpp"
  
            var $197=$dict_flags_addr; //@line 2622 "dictionary.cpp"
            var $arrayidx262=(($197)&4294967295); //@line 2622 "dictionary.cpp"
            var $198=HEAP32[(($arrayidx262)>>2)]; //@line 2622 "dictionary.cpp"
            var $or=($198) | 65536; //@line 2622 "dictionary.cpp"
            HEAP32[(($arrayidx262)>>2)]=$or; //@line 2622 "dictionary.cpp"
            ; //@line 2622 "dictionary.cpp"
          }
          else if (__label__ == 51) {
  
            var $135=$phonemes_addr; //@line 2543 "dictionary.cpp"
            var $136=$tr_addr; //@line 2543 "dictionary.cpp"
            var $langopts152=(($136)&4294967295); //@line 2543 "dictionary.cpp"
            var $ascii_language=(($langopts152+268)&4294967295); //@line 2543 "dictionary.cpp"
            var $137=HEAP32[(($ascii_language)>>2)]; //@line 2543 "dictionary.cpp"
            var $call153=_sprintf($135, ((__str70722)&4294967295), allocate([21,0,0,0,$137,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 2543 "dictionary.cpp"
            $retval=0; //@line 2544 "dictionary.cpp"
            __label__ = 105;break $if_then$$if_end$2; //@line 2544 "dictionary.cpp"
          }
        } while(0);
  
        var $233=$tr_addr; //@line 2687 "dictionary.cpp"
        var $234=$phonemes_addr; //@line 2687 "dictionary.cpp"
        var $235=$dict_flags0; //@line 2687 "dictionary.cpp"
        __Z21ApplySpecialAttributeP10TranslatorPci($233, $234, $235); //@line 2687 "dictionary.cpp"
        var $236=$p_start_addr; //@line 2688 "dictionary.cpp"
        var $arraydecay347=(($word_copy)&4294967295); //@line 2688 "dictionary.cpp"
        var $arraydecay348=(($word_copy)&4294967295); //@line 2688 "dictionary.cpp"
        var $call349=_strlen($arraydecay348); //@line 2688 "dictionary.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $arraydecay347;
        $dest$ = $236;
        $stop$ = $src$ + $call349;
        if (($dest$%4) == ($src$%4) && $call349 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 2688 "dictionary.cpp"
        $retval=0; //@line 2690 "dictionary.cpp"
        ; //@line 2690 "dictionary.cpp"
      }
    } while(0);
  
    var $237=$retval; //@line 2691 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $237; //@line 2691 "dictionary.cpp"
    return null;
  }
  

  function __Z6LookupP10TranslatorPKcPc($tr, $word, $ph_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 12; _memset(__stackBase__, 0, 12);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $ph_out_addr;
    var $flags=__stackBase__;
    var $word1=__stackBase__+8;
    $tr_addr=$tr;
    $word_addr=$word;
    $ph_out_addr=$ph_out;
    var $arrayidx=(($flags+4)&4294967295); //@line 3369 "dictionary.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 3369 "dictionary.cpp"
    var $arrayidx1=(($flags)&4294967295); //@line 3369 "dictionary.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 3369 "dictionary.cpp"
    var $0=$word_addr; //@line 3370 "dictionary.cpp"
    HEAP32[(($word1)>>2)]=$0; //@line 3370 "dictionary.cpp"
    var $1=$tr_addr; //@line 3371 "dictionary.cpp"
    var $2=$ph_out_addr; //@line 3371 "dictionary.cpp"
    var $arraydecay=(($flags)&4294967295); //@line 3371 "dictionary.cpp"
    var $call=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($1, $word1, $2, $arraydecay, 0, 0); //@line 3371 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $call; //@line 3371 "dictionary.cpp"
    return null;
  }
  

  function __ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii($tr, $word, $word_start, $group_length, $rule, $match_out, $word_flags, $dict_flags) {
    var __stackBase__  = STACKTOP; STACKTOP += 264; _memset(__stackBase__, 0, 264);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $word_addr;
    var $word_start_addr;
    var $group_length_addr;
    var $rule_addr;
    var $match_out_addr;
    var $word_flags_addr;
    var $dict_flags_addr;
    var $rb;
    var $letter;
    var $letter_w=__stackBase__;
    var $letter_xbytes;
    var $last_letter;
    var $pre_ptr;
    var $post_ptr;
    var $rule_start;
    var $p;
    var $ix;
    var $match_type;
    var $failed;
    var $unpron_ignore;
    var $consumed;
    var $syllable_count;
    var $vowel;
    var $letter_group;
    var $distance_right;
    var $distance_left;
    var $lg_pts;
    var $n_bytes;
    var $add_points;
    var $command;
    var $check_atstart;
    var $match=__stackBase__+4;
    var $total_consumed;
    var $condition_num;
    var $common_phonemes;
    var $group_chars;
    var $word_buf=__stackBase__+20;
    var $p222;
    var $vowel_count;
    var $p252;
    var $p269;
    var $p2;
    var $rule_w=__stackBase__+180;
    var $p419;
    var $pts;
    var $decoded_phonemes=__stackBase__+184;
    $tr_addr=$tr;
    $word_addr=$word;
    $word_start_addr=$word_start;
    $group_length_addr=$group_length;
    $rule_addr=$rule;
    $match_out_addr=$match_out;
    $word_flags_addr=$word_flags;
    $dict_flags_addr=$dict_flags;
    var $0=$word_addr; //@line 1777 "dictionary.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 1777 "dictionary.cpp"
    $group_chars=$1; //@line 1777 "dictionary.cpp"
    var $2=$rule_addr; //@line 1779 "dictionary.cpp"
    var $cmp=((($2))|0)==0; //@line 1779 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1779 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $3=$match_out_addr; //@line 1781 "dictionary.cpp"
      var $points=(($3)&4294967295); //@line 1781 "dictionary.cpp"
      HEAP32[(($points)>>2)]=0; //@line 1781 "dictionary.cpp"
      var $4=$word_addr; //@line 1782 "dictionary.cpp"
      var $5=HEAP32[(($4)>>2)]; //@line 1782 "dictionary.cpp"
      var $incdec_ptr=(($5+1)&4294967295); //@line 1782 "dictionary.cpp"
      HEAP32[(($4)>>2)]=$incdec_ptr; //@line 1782 "dictionary.cpp"
      ; //@line 1783 "dictionary.cpp"
    }
    else if (__label__ == 2) {
  
      $total_consumed=0; //@line 1787 "dictionary.cpp"
      $common_phonemes=0; //@line 1788 "dictionary.cpp"
      $match_type=0; //@line 1789 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best)&4294967295))>>2)]=0; //@line 1791 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+4)&4294967295))>>2)]=((__str13643)&4294967295); //@line 1792 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+8)&4294967295))>>2)]=0; //@line 1793 "dictionary.cpp"
      HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+12)&4294967295))>>2)]=0; //@line 1794 "dictionary.cpp"
      var $6=$rule_addr; //@line 1797 "dictionary.cpp"
      var $7=HEAP8[($6)]; //@line 1797 "dictionary.cpp"
      var $conv22=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1797 "dictionary.cpp"
      var $cmp123=((($conv22))|0)!=7; //@line 1797 "dictionary.cpp"
      if ($cmp123) { __label__ = 3;; } else { __label__ = 198;; } //@line 1797 "dictionary.cpp"
      $while_body_lr_ph$$while_end549$5: do { 
        if (__label__ == 3) {
  
          var $points2=(($match)&4294967295); //@line 1807 "dictionary.cpp"
          var $end_type=(($match+8)&4294967295); //@line 1808 "dictionary.cpp"
          var $del_fwd=(($match+12)&4294967295); //@line 1809 "dictionary.cpp"
          var $points518=(($match)&4294967295); //@line 2340 "dictionary.cpp"
          var $8=$match; //@line 2342 "dictionary.cpp"
          var $points524=(($match)&4294967295); //@line 2346 "dictionary.cpp"
          var $points530=(($match)&4294967295); //@line 2352 "dictionary.cpp"
          var $phonemes535=(($match+4)&4294967295); //@line 2355 "dictionary.cpp"
          var $arraydecay536=(($decoded_phonemes)&4294967295); //@line 2355 "dictionary.cpp"
          var $arraydecay538=(($decoded_phonemes)&4294967295); //@line 2356 "dictionary.cpp"
          var $points515=(($match)&4294967295); //@line 2337 "dictionary.cpp"
          var $phonemes=(($match+4)&4294967295); //@line 1829 "dictionary.cpp"
          var $phonemes13=(($match+4)&4294967295); //@line 1830 "dictionary.cpp"
          var $phonemes23=(($match+4)&4294967295); //@line 1833 "dictionary.cpp"
          var $phonemes29=(($match+4)&4294967295); //@line 1835 "dictionary.cpp"
          var $phonemes32=(($match+4)&4294967295); //@line 1840 "dictionary.cpp"
          var $phonemes43=(($match+4)&4294967295); //@line 1867 "dictionary.cpp"
          var $points66=(($match)&4294967295); //@line 1891 "dictionary.cpp"
          var $points499=(($match)&4294967295); //@line 2328 "dictionary.cpp"
          var $end_type171=(($match+8)&4294967295); //@line 2006 "dictionary.cpp"
          var $arraydecay=(($word_buf)&4294967295); //@line 2023 "dictionary.cpp"
          var $arrayidx195=(($word_buf+1)&4294967295); //@line 2027 "dictionary.cpp"
          var $del_fwd291=(($match+12)&4294967295); //@line 2121 "dictionary.cpp"
          var $end_type307=(($match+8)&4294967295); //@line 2129 "dictionary.cpp"
          ; //@line 1797 "dictionary.cpp"
          $while_body$7: while(1) { 
  
            var $11=$word_flags_addr; //@line 1799 "dictionary.cpp"
            var $and=($11) & -2147483648; //@line 1799 "dictionary.cpp"
            $unpron_ignore=$and; //@line 1799 "dictionary.cpp"
            $match_type=0; //@line 1800 "dictionary.cpp"
            $consumed=0; //@line 1801 "dictionary.cpp"
            $letter=0; //@line 1802 "dictionary.cpp"
            $distance_right=-6; //@line 1803 "dictionary.cpp"
            $distance_left=-2; //@line 1804 "dictionary.cpp"
            $check_atstart=0; //@line 1805 "dictionary.cpp"
            HEAP32[(($points2)>>2)]=1; //@line 1807 "dictionary.cpp"
            HEAP32[(($end_type)>>2)]=0; //@line 1808 "dictionary.cpp"
            HEAP32[(($del_fwd)>>2)]=0; //@line 1809 "dictionary.cpp"
            var $12=$word_addr; //@line 1811 "dictionary.cpp"
            var $13=HEAP32[(($12)>>2)]; //@line 1811 "dictionary.cpp"
            $pre_ptr=$13; //@line 1811 "dictionary.cpp"
            var $14=$word_addr; //@line 1812 "dictionary.cpp"
            var $15=HEAP32[(($14)>>2)]; //@line 1812 "dictionary.cpp"
            var $16=$group_length_addr; //@line 1812 "dictionary.cpp"
            var $add_ptr=(($15+$16)&4294967295); //@line 1812 "dictionary.cpp"
            $post_ptr=$add_ptr; //@line 1812 "dictionary.cpp"
            var $17=$rule_addr; //@line 1815 "dictionary.cpp"
            $rule_start=$17; //@line 1815 "dictionary.cpp"
            $failed=0; //@line 1817 "dictionary.cpp"
            var $18=$failed; //@line 1818 "dictionary.cpp"
            var $tobool20=((($18))|0)!=0; //@line 1818 "dictionary.cpp"
            var $lnot21=($tobool20) ^ 1; //@line 1818 "dictionary.cpp"
            if ($lnot21) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 183;; } //@line 1818 "dictionary.cpp"
            $while_body4$$while_end502$9: do { 
              if (__label__ == 6) {
                $while_body4$10: while(1) { 
  
                  var $19=$rule_addr; //@line 1820 "dictionary.cpp"
                  var $incdec_ptr5=(($19+1)&4294967295); //@line 1820 "dictionary.cpp"
                  $rule_addr=$incdec_ptr5; //@line 1820 "dictionary.cpp"
                  var $20=HEAP8[($19)]; //@line 1820 "dictionary.cpp"
                  $rb=$20; //@line 1820 "dictionary.cpp"
                  var $21=$rb; //@line 1822 "dictionary.cpp"
                  var $conv6=((($21))&255); //@line 1822 "dictionary.cpp"
                  var $cmp7=((($conv6))|0) <= 9; //@line 1822 "dictionary.cpp"
                  if ($cmp7) { __label__ = 7;; } else { __label__ = 33;; } //@line 1822 "dictionary.cpp"
                  $if_then8$$if_end70$12: do { 
                    if (__label__ == 7) {
  
                      var $22=$rb; //@line 1824 "dictionary.cpp"
                      var $conv9=((($22))&255); //@line 1824 "dictionary.cpp"
                      if ($conv9 == 0) {
                        __label__ = 8;;
                      }
                      else if ($conv9 == 8) {
                        __label__ = 18;;
                      }
                      else if ($conv9 == 1) {
                        __label__ = 19;;
                      }
                      else if ($conv9 == 2) {
                        __label__ = 21;;
                      }
                      else if ($conv9 == 3) {
                        __label__ = 22;;
                      }
                      else if ($conv9 == 4) {
                        __label__ = 23;;
                      }
                      else if ($conv9 == 5) {
                        __label__ = 24;;
                      }
                      else if ($conv9 == 9) {
                        __label__ = 32;;
                      }
                      else {
                      __label__ = 30;break $if_then8$$if_end70$12;
                      }
                      
                      if (__label__ == 8) {
  
                        var $23=$common_phonemes; //@line 1827 "dictionary.cpp"
                        var $cmp10=((($23))|0)!=0; //@line 1827 "dictionary.cpp"
                        if ($cmp10) { __label__ = 9;; } else { __label__ = 16;; } //@line 1827 "dictionary.cpp"
                        $if_then11$$if_else$16: do { 
                          if (__label__ == 9) {
  
                            var $24=$common_phonemes; //@line 1829 "dictionary.cpp"
                            HEAP32[(($phonemes)>>2)]=$24; //@line 1829 "dictionary.cpp"
                            ; //@line 1830 "dictionary.cpp"
                            while(1) { 
  
                              var $25=HEAP32[(($phonemes13)>>2)]; //@line 1830 "dictionary.cpp"
                              var $incdec_ptr14=(($25+1)&4294967295); //@line 1830 "dictionary.cpp"
                              HEAP32[(($phonemes13)>>2)]=$incdec_ptr14; //@line 1830 "dictionary.cpp"
                              var $26=HEAPU8[($25)]; //@line 1830 "dictionary.cpp"
                              $rb=$26; //@line 1830 "dictionary.cpp"
                              var $conv15=((($26))&255); //@line 1830 "dictionary.cpp"
                              var $cmp16=((($conv15))|0)!=0; //@line 1830 "dictionary.cpp"
                              if (!($cmp16)) { __label__ = 17;break $if_then11$$if_else$16; } //@line 1830 "dictionary.cpp"
  
                              var $27=$rb; //@line 1830 "dictionary.cpp"
                              var $conv17=((($27))&255); //@line 1830 "dictionary.cpp"
                              var $cmp18=((($conv17))|0)!=3; //@line 1830 "dictionary.cpp"
                              if (!($cmp18)) { __label__ = 17;break $if_then11$$if_else$16; }
  
                              var $28=$rb; //@line 1832 "dictionary.cpp"
                              var $conv20=((($28))&255); //@line 1832 "dictionary.cpp"
                              var $cmp21=((($conv20))|0)==5; //@line 1832 "dictionary.cpp"
                              if ($cmp21) { __label__ = 13;; } else { __label__ = 14;; } //@line 1832 "dictionary.cpp"
                              if (__label__ == 13) {
  
                                var $29=HEAP32[(($phonemes23)>>2)]; //@line 1833 "dictionary.cpp"
                                var $incdec_ptr24=(($29+1)&4294967295); //@line 1833 "dictionary.cpp"
                                HEAP32[(($phonemes23)>>2)]=$incdec_ptr24; //@line 1833 "dictionary.cpp"
                                ; //@line 1833 "dictionary.cpp"
                              }
  
                              var $30=$rb; //@line 1834 "dictionary.cpp"
                              var $conv26=((($30))&255); //@line 1834 "dictionary.cpp"
                              var $cmp27=((($conv26))|0)==9; //@line 1834 "dictionary.cpp"
                              if (!($cmp27)) { __label__ = 10;continue ; } //@line 1834 "dictionary.cpp"
  
                              var $31=HEAP32[(($phonemes29)>>2)]; //@line 1835 "dictionary.cpp"
                              var $add_ptr30=(($31+2)&4294967295); //@line 1835 "dictionary.cpp"
                              HEAP32[(($phonemes29)>>2)]=$add_ptr30; //@line 1835 "dictionary.cpp"
                              __label__ = 10;continue ; //@line 1835 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 16) {
  
                            HEAP32[(($phonemes32)>>2)]=((__str13643)&4294967295); //@line 1840 "dictionary.cpp"
                            ;
                          }
                        } while(0);
  
                        var $32=$rule_addr; //@line 1842 "dictionary.cpp"
                        var $incdec_ptr34=(($32+-1)&4294967295); //@line 1842 "dictionary.cpp"
                        $rule_addr=$incdec_ptr34; //@line 1842 "dictionary.cpp"
                        $failed=2; //@line 1843 "dictionary.cpp"
                        ; //@line 1844 "dictionary.cpp"
                      }
                      else if (__label__ == 18) {
  
                        $check_atstart=1; //@line 1847 "dictionary.cpp"
                        $unpron_ignore=0; //@line 1848 "dictionary.cpp"
                        $match_type=1; //@line 1849 "dictionary.cpp"
                        ; //@line 1850 "dictionary.cpp"
                      }
                      else if (__label__ == 19) {
  
                        $match_type=1; //@line 1853 "dictionary.cpp"
                        var $33=$word_flags_addr; //@line 1854 "dictionary.cpp"
                        var $and37=($33) & -2147483648; //@line 1854 "dictionary.cpp"
                        var $tobool38=((($and37))|0)!=0; //@line 1854 "dictionary.cpp"
                        if (!($tobool38)) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 1854 "dictionary.cpp"
  
                        $failed=1; //@line 1859 "dictionary.cpp"
                        ; //@line 1860 "dictionary.cpp"
                      }
                      else if (__label__ == 21) {
  
                        $match_type=2; //@line 1864 "dictionary.cpp"
                        ; //@line 1865 "dictionary.cpp"
                      }
                      else if (__label__ == 22) {
  
                        var $34=$rule_addr; //@line 1867 "dictionary.cpp"
                        HEAP32[(($phonemes43)>>2)]=$34; //@line 1867 "dictionary.cpp"
                        $failed=2; //@line 1868 "dictionary.cpp"
                        ; //@line 1869 "dictionary.cpp"
                      }
                      else if (__label__ == 23) {
  
                        var $35=$rule_addr; //@line 1871 "dictionary.cpp"
                        $common_phonemes=$35; //@line 1871 "dictionary.cpp"
                        ; //@line 1872 "dictionary.cpp"
                      }
                      else if (__label__ == 24) {
  
                        var $36=$rule_addr; //@line 1875 "dictionary.cpp"
                        var $incdec_ptr46=(($36+1)&4294967295); //@line 1875 "dictionary.cpp"
                        $rule_addr=$incdec_ptr46; //@line 1875 "dictionary.cpp"
                        var $37=HEAP8[($36)]; //@line 1875 "dictionary.cpp"
                        $condition_num=$37; //@line 1875 "dictionary.cpp"
                        var $38=$condition_num; //@line 1877 "dictionary.cpp"
                        var $conv47=((($38))&255); //@line 1877 "dictionary.cpp"
                        var $cmp48=((($conv47))|0) >= 32; //@line 1877 "dictionary.cpp"
                        var $39=$tr_addr; //@line 1880 "dictionary.cpp"
                        var $dict_condition=(($39+692)&4294967295); //@line 1880 "dictionary.cpp"
                        var $40=HEAP32[(($dict_condition)>>2)]; //@line 1880 "dictionary.cpp"
                        var $41=$condition_num; //@line 1880 "dictionary.cpp"
                        var $conv50=((($41))&255); //@line 1880 "dictionary.cpp"
                        if ($cmp48) { __label__ = 25;; } else { __label__ = 27;; } //@line 1877 "dictionary.cpp"
                        $if_then49$$if_else55$35: do { 
                          if (__label__ == 25) {
  
                            var $sub=((($conv50)-32)&4294967295); //@line 1880 "dictionary.cpp"
                            var $shl=1 << ($sub); //@line 1880 "dictionary.cpp"
                            var $and51=($shl) & ($40); //@line 1880 "dictionary.cpp"
                            var $cmp52=((($and51))|0)!=0; //@line 1880 "dictionary.cpp"
                            if (!($cmp52)) { __label__ = 29;break $if_then49$$if_else55$35; } //@line 1880 "dictionary.cpp"
  
                            $failed=1; //@line 1881 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 1881 "dictionary.cpp"
                          }
                          else if (__label__ == 27) {
  
                            var $shl58=1 << ($conv50); //@line 1886 "dictionary.cpp"
                            var $and59=($shl58) & ($40); //@line 1886 "dictionary.cpp"
                            var $cmp60=((($and59))|0)==0; //@line 1886 "dictionary.cpp"
                            if (!($cmp60)) { __label__ = 29;break $if_then49$$if_else55$35; } //@line 1886 "dictionary.cpp"
  
                            $failed=1; //@line 1887 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 1887 "dictionary.cpp"
                          }
                        } while(0);
  
                        var $_pr=$failed; //@line 1890 "dictionary.cpp"
                        var $tobool64=((($_pr))|0)!=0; //@line 1890 "dictionary.cpp"
                        if ($tobool64) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 1890 "dictionary.cpp"
  
                        var $43=HEAP32[(($points66)>>2)]; //@line 1891 "dictionary.cpp"
                        var $inc=((($43)+1)&4294967295); //@line 1891 "dictionary.cpp"
                        HEAP32[(($points66)>>2)]=$inc; //@line 1891 "dictionary.cpp"
                        ; //@line 1891 "dictionary.cpp"
                      }
                      else if (__label__ == 32) {
  
                        var $44=$rule_addr; //@line 1894 "dictionary.cpp"
                        var $add_ptr69=(($44+2)&4294967295); //@line 1894 "dictionary.cpp"
                        $rule_addr=$add_ptr69; //@line 1894 "dictionary.cpp"
                        ; //@line 1895 "dictionary.cpp"
                      }
                    }
                    else if (__label__ == 33) {
  
                      $add_points=0; //@line 1900 "dictionary.cpp"
                      var $45=$match_type; //@line 1902 "dictionary.cpp"
                      if ($45 == 0) {
                        __label__ = 34;;
                      }
                      else if ($45 == 2) {
                        __label__ = 41;;
                      }
                      else if ($45 == 1) {
                        __label__ = 119;;
                      }
                      else {
                      __label__ = 181;;
                      }
                      
                      $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44: do { 
                        if (__label__ == 34) {
  
                          var $46=$letter; //@line 1906 "dictionary.cpp"
                          $last_letter=$46; //@line 1906 "dictionary.cpp"
                          var $47=$post_ptr; //@line 1907 "dictionary.cpp"
                          var $incdec_ptr72=(($47+1)&4294967295); //@line 1907 "dictionary.cpp"
                          $post_ptr=$incdec_ptr72; //@line 1907 "dictionary.cpp"
                          var $48=HEAP8[($47)]; //@line 1907 "dictionary.cpp"
                          $letter=$48; //@line 1907 "dictionary.cpp"
                          var $49=$letter; //@line 1909 "dictionary.cpp"
                          var $conv73=((($49))&255); //@line 1909 "dictionary.cpp"
                          var $50=$rb; //@line 1909 "dictionary.cpp"
                          var $conv74=((($50))&255); //@line 1909 "dictionary.cpp"
                          var $cmp75=((($conv73))|0)==((($conv74))|0); //@line 1909 "dictionary.cpp"
                          if ($cmp75) { __label__ = 37;; } else { __label__ = 35;; } //@line 1909 "dictionary.cpp"
                          $if_then80$$lor_lhs_false$46: do { 
                            if (__label__ == 35) {
  
                              var $51=$letter; //@line 1909 "dictionary.cpp"
                              var $conv76=((($51))&255); //@line 1909 "dictionary.cpp"
                              var $cmp77=((($conv76))|0)==69; //@line 1909 "dictionary.cpp"
                              if ($cmp77) { __label__ = 36;; } else { __label__ = 40;; } //@line 1909 "dictionary.cpp"
                              if (__label__ == 36) {
  
                                var $52=$rb; //@line 1909 "dictionary.cpp"
                                var $conv78=((($52))&255); //@line 1909 "dictionary.cpp"
                                var $cmp79=((($conv78))|0)==101; //@line 1909 "dictionary.cpp"
                                if ($cmp79) { __label__ = 37;break $if_then80$$lor_lhs_false$46; } //@line 1909 "dictionary.cpp"
                              }
  
                              $failed=1; //@line 1916 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          } while(0);
  
                          var $53=$letter; //@line 1911 "dictionary.cpp"
                          var $conv81=((($53))&255); //@line 1911 "dictionary.cpp"
                          var $and82=($conv81) & 192; //@line 1911 "dictionary.cpp"
                          var $cmp83=((($and82))|0)!=128; //@line 1911 "dictionary.cpp"
                          if ($cmp83) { __label__ = 38;; } else { __label__ = 39;; } //@line 1911 "dictionary.cpp"
                          if (__label__ == 38) {
  
                            $add_points=21; //@line 1912 "dictionary.cpp"
                            ; //@line 1912 "dictionary.cpp"
                          }
  
                          var $54=$consumed; //@line 1913 "dictionary.cpp"
                          var $inc86=((($54)+1)&4294967295); //@line 1913 "dictionary.cpp"
                          $consumed=$inc86; //@line 1913 "dictionary.cpp"
                          ; //@line 1914 "dictionary.cpp"
                        }
                        else if (__label__ == 41) {
  
                          var $55=$distance_right; //@line 1922 "dictionary.cpp"
                          var $add=((($55)+6)&4294967295); //@line 1922 "dictionary.cpp"
                          $distance_right=$add; //@line 1922 "dictionary.cpp"
                          var $56=$distance_right; //@line 1923 "dictionary.cpp"
                          var $cmp90=((($56))|0) > 18; //@line 1923 "dictionary.cpp"
                          if ($cmp90) { __label__ = 42;; } else { __label__ = 43;; } //@line 1923 "dictionary.cpp"
                          if (__label__ == 42) {
  
                            $distance_right=19; //@line 1924 "dictionary.cpp"
                            ; //@line 1924 "dictionary.cpp"
                          }
  
                          var $57=$letter; //@line 1925 "dictionary.cpp"
                          $last_letter=$57; //@line 1925 "dictionary.cpp"
                          var $58=$post_ptr; //@line 1926 "dictionary.cpp"
                          var $call=__Z7utf8_inPiPKc($letter_w, $58); //@line 1926 "dictionary.cpp"
                          var $sub93=((($call)-1)&4294967295); //@line 1926 "dictionary.cpp"
                          $letter_xbytes=$sub93; //@line 1926 "dictionary.cpp"
                          var $59=$post_ptr; //@line 1927 "dictionary.cpp"
                          var $incdec_ptr94=(($59+1)&4294967295); //@line 1927 "dictionary.cpp"
                          $post_ptr=$incdec_ptr94; //@line 1927 "dictionary.cpp"
                          var $60=HEAP8[($59)]; //@line 1927 "dictionary.cpp"
                          $letter=$60; //@line 1927 "dictionary.cpp"
                          var $61=$rb; //@line 1929 "dictionary.cpp"
                          var $conv95=((($61))&255); //@line 1929 "dictionary.cpp"
                          if ($conv95 == 17) {
                            __label__ = 44;;
                          }
                          else if ($conv95 == 18) {
                            __label__ = 49;;
                          }
                          else if ($conv95 == 25) {
                            __label__ = 52;;
                          }
                          else if ($conv95 == 15) {
                            __label__ = 57;;
                          }
                          else if ($conv95 == 16) {
                            __label__ = 62;;
                          }
                          else if ($conv95 == 11) {
                            __label__ = 65;;
                          }
                          else if ($conv95 == 28) {
                            __label__ = 68;;
                          }
                          else if ($conv95 == 45) {
                            __label__ = 78;;
                          }
                          else if ($conv95 == 21) {
                            __label__ = 83;;
                          }
                          else if ($conv95 == 29) {
                            __label__ = 94;;
                          }
                          else if ($conv95 == 23) {
                            __label__ = 101;;
                          }
                          else if ($conv95 == 12) {
                            __label__ = 105;;
                          }
                          else if ($conv95 == 13) {
                            __label__ = 106;;
                          }
                          else if ($conv95 == 14) {
                            __label__ = 111;;
                          }
                          else if ($conv95 == 24) {
                            __label__ = 112;;
                          }
                          else {
                          __label__ = 115;;
                          }
                          
                          if (__label__ == 115) {
  
                            var $186=$letter; //@line 2141 "dictionary.cpp"
                            var $conv315=((($186))&255); //@line 2141 "dictionary.cpp"
                            var $187=$rb; //@line 2141 "dictionary.cpp"
                            var $conv316=((($187))&255); //@line 2141 "dictionary.cpp"
                            var $cmp317=((($conv315))|0)==((($conv316))|0); //@line 2141 "dictionary.cpp"
                            if ($cmp317) { __label__ = 116;; } else { __label__ = 118;; } //@line 2141 "dictionary.cpp"
                            if (__label__ == 116) {
  
                              var $188=$letter; //@line 2143 "dictionary.cpp"
                              var $conv319=((($188))&255); //@line 2143 "dictionary.cpp"
                              var $and320=($conv319) & 192; //@line 2143 "dictionary.cpp"
                              var $cmp321=((($and320))|0)!=128; //@line 2143 "dictionary.cpp"
                              if (!($cmp321)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2143 "dictionary.cpp"
  
                              var $189=$distance_right; //@line 2146 "dictionary.cpp"
                              var $sub323=((21-($189))&4294967295); //@line 2146 "dictionary.cpp"
                              $add_points=$sub323; //@line 2146 "dictionary.cpp"
                              ; //@line 2147 "dictionary.cpp"
                            }
                            else if (__label__ == 118) {
  
                              $failed=1; //@line 2150 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 44) {
  
                            var $62=$rule_addr; //@line 1932 "dictionary.cpp"
                            var $incdec_ptr97=(($62+1)&4294967295); //@line 1932 "dictionary.cpp"
                            $rule_addr=$incdec_ptr97; //@line 1932 "dictionary.cpp"
                            var $63=HEAP8[($62)]; //@line 1932 "dictionary.cpp"
                            var $conv98=(tempInt=(($63)),(tempInt>=128?tempInt-256:tempInt)); //@line 1932 "dictionary.cpp"
                            var $sub99=((($conv98)-65)&4294967295); //@line 1932 "dictionary.cpp"
                            $letter_group=$sub99; //@line 1932 "dictionary.cpp"
                            var $64=$tr_addr; //@line 1933 "dictionary.cpp"
                            var $65=HEAP32[(($letter_w)>>2)]; //@line 1933 "dictionary.cpp"
                            var $66=$letter_group; //@line 1933 "dictionary.cpp"
                            var $call100=__ZL8IsLetterP10Translatorii($64, $65, $66); //@line 1933 "dictionary.cpp"
                            var $tobool101=((($call100))|0)!=0; //@line 1933 "dictionary.cpp"
                            if ($tobool101) { __label__ = 45;; } else { __label__ = 48;; } //@line 1933 "dictionary.cpp"
                            if (__label__ == 45) {
  
                              $lg_pts=20; //@line 1935 "dictionary.cpp"
                              var $67=$letter_group; //@line 1936 "dictionary.cpp"
                              var $cmp103=((($67))|0)==2; //@line 1936 "dictionary.cpp"
                              if ($cmp103) { __label__ = 46;; } else { __label__ = 47;; } //@line 1936 "dictionary.cpp"
                              if (__label__ == 46) {
  
                                $lg_pts=19; //@line 1937 "dictionary.cpp"
                                ; //@line 1937 "dictionary.cpp"
                              }
  
                              var $68=$lg_pts; //@line 1938 "dictionary.cpp"
                              var $69=$distance_right; //@line 1938 "dictionary.cpp"
                              var $sub106=((($68)-($69))&4294967295); //@line 1938 "dictionary.cpp"
                              $add_points=$sub106; //@line 1938 "dictionary.cpp"
                              var $70=$letter_xbytes; //@line 1939 "dictionary.cpp"
                              var $71=$post_ptr; //@line 1939 "dictionary.cpp"
                              var $add_ptr107=(($71+$70)&4294967295); //@line 1939 "dictionary.cpp"
                              $post_ptr=$add_ptr107; //@line 1939 "dictionary.cpp"
                              ; //@line 1940 "dictionary.cpp"
                            }
                            else if (__label__ == 48) {
  
                              $failed=1; //@line 1942 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 49) {
  
                            var $72=$rule_addr; //@line 1946 "dictionary.cpp"
                            var $incdec_ptr111=(($72+1)&4294967295); //@line 1946 "dictionary.cpp"
                            $rule_addr=$incdec_ptr111; //@line 1946 "dictionary.cpp"
                            var $73=HEAP8[($72)]; //@line 1946 "dictionary.cpp"
                            var $conv112=(tempInt=(($73)),(tempInt>=128?tempInt-256:tempInt)); //@line 1946 "dictionary.cpp"
                            var $sub113=((($conv112)-65)&4294967295); //@line 1946 "dictionary.cpp"
                            $letter_group=$sub113; //@line 1946 "dictionary.cpp"
                            var $74=$tr_addr; //@line 1947 "dictionary.cpp"
                            var $75=$post_ptr; //@line 1947 "dictionary.cpp"
                            var $add_ptr114=(($75+-1)&4294967295); //@line 1947 "dictionary.cpp"
                            var $76=$letter_group; //@line 1947 "dictionary.cpp"
                            var $call115=__ZL13IsLetterGroupP10TranslatorPcii($74, $add_ptr114, $76, 0); //@line 1947 "dictionary.cpp"
                            $n_bytes=$call115; //@line 1947 "dictionary.cpp"
                            var $cmp116=((($call115))|0) > 0; //@line 1947 "dictionary.cpp"
                            if ($cmp116) { __label__ = 50;; } else { __label__ = 51;; } //@line 1947 "dictionary.cpp"
                            if (__label__ == 50) {
  
                              var $77=$distance_right; //@line 1949 "dictionary.cpp"
                              var $sub118=((20-($77))&4294967295); //@line 1949 "dictionary.cpp"
                              $add_points=$sub118; //@line 1949 "dictionary.cpp"
                              var $78=$n_bytes; //@line 1950 "dictionary.cpp"
                              var $sub119=((($78)-1)&4294967295); //@line 1950 "dictionary.cpp"
                              var $79=$post_ptr; //@line 1950 "dictionary.cpp"
                              var $add_ptr120=(($79+$sub119)&4294967295); //@line 1950 "dictionary.cpp"
                              $post_ptr=$add_ptr120; //@line 1950 "dictionary.cpp"
                              ; //@line 1951 "dictionary.cpp"
                            }
                            else if (__label__ == 51) {
  
                              $failed=1; //@line 1953 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 52) {
  
                            var $80=$tr_addr; //@line 1957 "dictionary.cpp"
                            var $81=HEAP32[(($letter_w)>>2)]; //@line 1957 "dictionary.cpp"
                            var $call124=__ZL8IsLetterP10Translatorii($80, $81, 0); //@line 1957 "dictionary.cpp"
                            var $tobool125=((($call124))|0)!=0; //@line 1957 "dictionary.cpp"
                            if ($tobool125) { __label__ = 55;; } else { __label__ = 53;; } //@line 1957 "dictionary.cpp"
                            $if_then131$$lor_lhs_false126$77: do { 
                              if (__label__ == 53) {
  
                                var $82=HEAP32[(($letter_w)>>2)]; //@line 1957 "dictionary.cpp"
                                var $cmp127=((($82))|0)==32; //@line 1957 "dictionary.cpp"
                                if ($cmp127) { __label__ = 54;; } else { __label__ = 56;; } //@line 1957 "dictionary.cpp"
                                if (__label__ == 54) {
  
                                  var $83=$word_flags_addr; //@line 1957 "dictionary.cpp"
                                  var $and129=($83) & 134217728; //@line 1957 "dictionary.cpp"
                                  var $tobool130=((($and129))|0)!=0; //@line 1957 "dictionary.cpp"
                                  if ($tobool130) { __label__ = 55;break $if_then131$$lor_lhs_false126$77; } //@line 1957 "dictionary.cpp"
                                }
  
                                var $84=$distance_right; //@line 1963 "dictionary.cpp"
                                var $sub133=((20-($84))&4294967295); //@line 1963 "dictionary.cpp"
                                $add_points=$sub133; //@line 1963 "dictionary.cpp"
                                var $85=$letter_xbytes; //@line 1964 "dictionary.cpp"
                                var $86=$post_ptr; //@line 1964 "dictionary.cpp"
                                var $add_ptr134=(($86+$85)&4294967295); //@line 1964 "dictionary.cpp"
                                $post_ptr=$add_ptr134; //@line 1964 "dictionary.cpp"
                                __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44;
                              }
                            } while(0);
  
                            $failed=1; //@line 1959 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 1960 "dictionary.cpp"
                          }
                          else if (__label__ == 57) {
  
                            var $87=HEAP32[(($letter_w)>>2)]; //@line 1969 "dictionary.cpp"
                            var $call137=__Z7IsDigitj($87); //@line 1969 "dictionary.cpp"
                            var $tobool138=((($call137))|0)!=0; //@line 1969 "dictionary.cpp"
                            if ($tobool138) { __label__ = 58;; } else { __label__ = 59;; } //@line 1969 "dictionary.cpp"
                            if (__label__ == 58) {
  
                              var $88=$distance_right; //@line 1971 "dictionary.cpp"
                              var $sub140=((20-($88))&4294967295); //@line 1971 "dictionary.cpp"
                              $add_points=$sub140; //@line 1971 "dictionary.cpp"
                              var $89=$letter_xbytes; //@line 1972 "dictionary.cpp"
                              var $90=$post_ptr; //@line 1972 "dictionary.cpp"
                              var $add_ptr141=(($90+$89)&4294967295); //@line 1972 "dictionary.cpp"
                              $post_ptr=$add_ptr141; //@line 1972 "dictionary.cpp"
                              ; //@line 1973 "dictionary.cpp"
                            }
                            else if (__label__ == 59) {
  
                              var $91=$tr_addr; //@line 1975 "dictionary.cpp"
                              var $langopts=(($91)&4294967295); //@line 1975 "dictionary.cpp"
                              var $tone_numbers=(($langopts+250)&4294967295); //@line 1975 "dictionary.cpp"
                              var $92=HEAP8[($tone_numbers)]; //@line 1975 "dictionary.cpp"
                              var $tobool143=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1975 "dictionary.cpp"
                              if ($tobool143) { __label__ = 60;; } else { __label__ = 61;; } //@line 1975 "dictionary.cpp"
                              if (__label__ == 60) {
  
                                var $93=$distance_right; //@line 1978 "dictionary.cpp"
                                var $sub145=((20-($93))&4294967295); //@line 1978 "dictionary.cpp"
                                $add_points=$sub145; //@line 1978 "dictionary.cpp"
                                var $94=$post_ptr; //@line 1979 "dictionary.cpp"
                                var $incdec_ptr146=(($94+-1)&4294967295); //@line 1979 "dictionary.cpp"
                                $post_ptr=$incdec_ptr146; //@line 1979 "dictionary.cpp"
                                ; //@line 1980 "dictionary.cpp"
                              }
                              else if (__label__ == 61) {
  
                                $failed=1; //@line 1982 "dictionary.cpp"
                                __label__ = 30;break $if_then8$$if_end70$12;
                              }
                            }
                          }
                          else if (__label__ == 62) {
  
                            var $95=HEAP32[(($letter_w)>>2)]; //@line 1986 "dictionary.cpp"
                            var $call151=_iswalpha($95); //@line 1986 "dictionary.cpp"
                            var $tobool152=((($call151))|0)!=0; //@line 1986 "dictionary.cpp"
                            if ($tobool152) { __label__ = 64;; } else { __label__ = 63;; } //@line 1986 "dictionary.cpp"
                            if (__label__ == 64) {
  
                              $failed=1; //@line 1992 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                            else if (__label__ == 63) {
  
                              var $96=$distance_right; //@line 1988 "dictionary.cpp"
                              var $sub154=((21-($96))&4294967295); //@line 1988 "dictionary.cpp"
                              $add_points=$sub154; //@line 1988 "dictionary.cpp"
                              var $97=$letter_xbytes; //@line 1989 "dictionary.cpp"
                              var $98=$post_ptr; //@line 1989 "dictionary.cpp"
                              var $add_ptr155=(($98+$97)&4294967295); //@line 1989 "dictionary.cpp"
                              $post_ptr=$add_ptr155; //@line 1989 "dictionary.cpp"
                              ; //@line 1990 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 65) {
  
                            var $99=$letter; //@line 1996 "dictionary.cpp"
                            var $conv159=((($99))&255); //@line 1996 "dictionary.cpp"
                            var $100=$last_letter; //@line 1996 "dictionary.cpp"
                            var $conv160=((($100))&255); //@line 1996 "dictionary.cpp"
                            var $cmp161=((($conv159))|0)==((($conv160))|0); //@line 1996 "dictionary.cpp"
                            if ($cmp161) { __label__ = 66;; } else { __label__ = 67;; } //@line 1996 "dictionary.cpp"
                            if (__label__ == 66) {
  
                              var $101=$distance_right; //@line 1997 "dictionary.cpp"
                              var $sub163=((21-($101))&4294967295); //@line 1997 "dictionary.cpp"
                              $add_points=$sub163; //@line 1997 "dictionary.cpp"
                              ; //@line 1997 "dictionary.cpp"
                            }
                            else if (__label__ == 67) {
  
                              $failed=1; //@line 1999 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 68) {
  
                            var $102=$rule_addr; //@line 2003 "dictionary.cpp"
                            var $incdec_ptr167=(($102+1)&4294967295); //@line 2003 "dictionary.cpp"
                            $rule_addr=$incdec_ptr167; //@line 2003 "dictionary.cpp"
                            var $103=HEAP8[($102)]; //@line 2003 "dictionary.cpp"
                            var $conv168=(tempInt=(($103)),(tempInt>=128?tempInt-256:tempInt)); //@line 2003 "dictionary.cpp"
                            $command=$conv168; //@line 2003 "dictionary.cpp"
                            var $104=$command; //@line 2004 "dictionary.cpp"
                            var $cmp169=((($104))|0)==1; //@line 2004 "dictionary.cpp"
                            if ($cmp169) { __label__ = 69;; } else { __label__ = 70;; } //@line 2004 "dictionary.cpp"
                            if (__label__ == 69) {
  
                              HEAP32[(($end_type171)>>2)]=32768; //@line 2006 "dictionary.cpp"
                              ; //@line 2007 "dictionary.cpp"
                            }
                            else if (__label__ == 70) {
  
                              var $105=$command; //@line 2009 "dictionary.cpp"
                              var $and173=($105) & 240; //@line 2009 "dictionary.cpp"
                              var $cmp174=((($and173))|0)==16; //@line 2009 "dictionary.cpp"
                              if ($cmp174) { __label__ = 71;; } else { __label__ = 74;; } //@line 2009 "dictionary.cpp"
                              if (__label__ == 71) {
  
                                var $106=$dict_flags_addr; //@line 2012 "dictionary.cpp"
                                var $107=$command; //@line 2012 "dictionary.cpp"
                                var $and176=($107) & 15; //@line 2012 "dictionary.cpp"
                                var $add177=((($and176)+19)&4294967295); //@line 2012 "dictionary.cpp"
                                var $shl178=1 << ($add177); //@line 2012 "dictionary.cpp"
                                var $and179=($shl178) & ($106); //@line 2012 "dictionary.cpp"
                                var $tobool180=((($and179))|0)!=0; //@line 2012 "dictionary.cpp"
                                if ($tobool180) { __label__ = 72;; } else { __label__ = 73;; } //@line 2012 "dictionary.cpp"
                                if (__label__ == 72) {
  
                                  $add_points=23; //@line 2013 "dictionary.cpp"
                                  ; //@line 2013 "dictionary.cpp"
                                }
                                else if (__label__ == 73) {
  
                                  $failed=1; //@line 2015 "dictionary.cpp"
                                  __label__ = 30;break $if_then8$$if_end70$12;
                                }
                              }
                              else if (__label__ == 74) {
  
                                var $108=$command; //@line 2018 "dictionary.cpp"
                                var $and185=($108) & 240; //@line 2018 "dictionary.cpp"
                                var $cmp186=((($and185))|0)==32; //@line 2018 "dictionary.cpp"
                                if (!($cmp186)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2018 "dictionary.cpp"
  
                                var $109=$word_addr; //@line 2022 "dictionary.cpp"
                                var $110=HEAP32[(($109)>>2)]; //@line 2022 "dictionary.cpp"
                                var $111=$word_start_addr; //@line 2022 "dictionary.cpp"
                                var $sub_ptr_lhs_cast=($110); //@line 2022 "dictionary.cpp"
                                var $sub_ptr_rhs_cast=($111); //@line 2022 "dictionary.cpp"
                                var $sub_ptr_rhs_cast_neg=(((-($sub_ptr_rhs_cast)))&4294967295);
                                var $112=$consumed; //@line 2022 "dictionary.cpp"
                                var $113=$group_length_addr; //@line 2022 "dictionary.cpp"
                                var $sub_ptr_sub=((($sub_ptr_lhs_cast)+1)&4294967295); //@line 2022 "dictionary.cpp"
                                var $add188=((($sub_ptr_sub)+($112))&4294967295); //@line 2022 "dictionary.cpp"
                                var $add189=((($add188)+($sub_ptr_rhs_cast_neg))&4294967295); //@line 2022 "dictionary.cpp"
                                var $add190=((($add189)+($113))&4294967295); //@line 2022 "dictionary.cpp"
                                $ix=$add190; //@line 2022 "dictionary.cpp"
                                var $114=$word_start_addr; //@line 2023 "dictionary.cpp"
                                var $add_ptr191=(($114+-1)&4294967295); //@line 2023 "dictionary.cpp"
                                var $115=$ix; //@line 2023 "dictionary.cpp"
                                var $src$, $dest$, $stop$, $stop4$, $fast$;
                                $src$ = $add_ptr191;
                                $dest$ = $arraydecay;
                                $stop$ = $src$ + $115;
                                if (($dest$%4) == ($src$%4) && $115 > 8) {
                                  while ($src$%4 !== 0 && $src$ < $stop$) {
                                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                                  }
                                  $src$ >>= 2;
                                  $dest$ >>= 2;
                                  $stop4$ = $stop$ >> 2;
                                  while ($src$ < $stop4$) {
                                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                                  }
                                  $src$ <<= 2;
                                  $dest$ <<= 2;
                                }while ($src$ < $stop$) {
                                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                                }; //@line 2023 "dictionary.cpp"
                                var $116=$ix; //@line 2024 "dictionary.cpp"
                                var $arrayidx192=(($word_buf+$116)&4294967295); //@line 2024 "dictionary.cpp"
                                HEAP8[($arrayidx192)]=32; //@line 2024 "dictionary.cpp"
                                var $117=$ix; //@line 2025 "dictionary.cpp"
                                var $add193=((($117)+1)&4294967295); //@line 2025 "dictionary.cpp"
                                var $arrayidx194=(($word_buf+$add193)&4294967295); //@line 2025 "dictionary.cpp"
                                HEAP8[($arrayidx194)]=0; //@line 2025 "dictionary.cpp"
                                var $118=$tr_addr; //@line 2027 "dictionary.cpp"
                                var $call196=__Z11LookupFlagsP10TranslatorPKc($118, $arrayidx195); //@line 2027 "dictionary.cpp"
                                var $119=$command; //@line 2027 "dictionary.cpp"
                                var $and197=($119) & 15; //@line 2027 "dictionary.cpp"
                                var $add198=((($and197)+19)&4294967295); //@line 2027 "dictionary.cpp"
                                var $shl199=1 << ($add198); //@line 2027 "dictionary.cpp"
                                var $and200=($shl199) & ($call196); //@line 2027 "dictionary.cpp"
                                var $tobool201=((($and200))|0)!=0; //@line 2027 "dictionary.cpp"
                                if ($tobool201) { __label__ = 76;; } else { __label__ = 77;; } //@line 2027 "dictionary.cpp"
                                if (__label__ == 76) {
  
                                  $add_points=23; //@line 2028 "dictionary.cpp"
                                  ; //@line 2028 "dictionary.cpp"
                                }
                                else if (__label__ == 77) {
  
                                  $failed=1; //@line 2030 "dictionary.cpp"
                                  __label__ = 30;break $if_then8$$if_end70$12;
                                }
                              }
                            }
                          }
                          else if (__label__ == 78) {
  
                            var $120=$letter; //@line 2035 "dictionary.cpp"
                            var $conv209=((($120))&255); //@line 2035 "dictionary.cpp"
                            var $cmp210=((($conv209))|0)==45; //@line 2035 "dictionary.cpp"
                            if ($cmp210) { __label__ = 81;; } else { __label__ = 79;; } //@line 2035 "dictionary.cpp"
                            $if_then217$$lor_lhs_false211$113: do { 
                              if (__label__ == 79) {
  
                                var $121=$letter; //@line 2035 "dictionary.cpp"
                                var $conv212=((($121))&255); //@line 2035 "dictionary.cpp"
                                var $cmp213=((($conv212))|0)==32; //@line 2035 "dictionary.cpp"
                                if ($cmp213) { __label__ = 80;; } else { __label__ = 82;; } //@line 2035 "dictionary.cpp"
                                if (__label__ == 80) {
  
                                  var $122=$word_flags_addr; //@line 2035 "dictionary.cpp"
                                  var $and215=($122) & 16384; //@line 2035 "dictionary.cpp"
                                  var $tobool216=((($and215))|0)!=0; //@line 2035 "dictionary.cpp"
                                  if ($tobool216) { __label__ = 81;break $if_then217$$lor_lhs_false211$113; } //@line 2035 "dictionary.cpp"
                                }
  
                                $failed=1; //@line 2040 "dictionary.cpp"
                                __label__ = 30;break $if_then8$$if_end70$12;
                              }
                            } while(0);
  
                            var $123=$distance_right; //@line 2037 "dictionary.cpp"
                            var $sub218=((22-($123))&4294967295); //@line 2037 "dictionary.cpp"
                            $add_points=$sub218; //@line 2037 "dictionary.cpp"
                            ; //@line 2038 "dictionary.cpp"
                          }
                          else if (__label__ == 83) {
  
                            var $124=$post_ptr; //@line 2046 "dictionary.cpp"
                            var $125=$letter_xbytes; //@line 2046 "dictionary.cpp"
                            var $add_ptr223=(($124+$125)&4294967295); //@line 2046 "dictionary.cpp"
                            $p222=$add_ptr223; //@line 2046 "dictionary.cpp"
                            $vowel_count=0; //@line 2047 "dictionary.cpp"
                            $syllable_count=1; //@line 2049 "dictionary.cpp"
                            var $126=$rule_addr; //@line 2050 "dictionary.cpp"
                            var $127=HEAP8[($126)]; //@line 2050 "dictionary.cpp"
                            var $conv22514=(tempInt=(($127)),(tempInt>=128?tempInt-256:tempInt)); //@line 2050 "dictionary.cpp"
                            var $cmp22615=((($conv22514))|0)==21; //@line 2050 "dictionary.cpp"
                            if ($cmp22615) { __label__ = 84;; } else { __label__ = 85;; } //@line 2050 "dictionary.cpp"
                            $while_body227$$while_end230$120: do { 
                              if (__label__ == 84) {
                                while(1) { 
  
                                  var $128=$rule_addr; //@line 2052 "dictionary.cpp"
                                  var $incdec_ptr228=(($128+1)&4294967295); //@line 2052 "dictionary.cpp"
                                  $rule_addr=$incdec_ptr228; //@line 2052 "dictionary.cpp"
                                  var $129=$syllable_count; //@line 2053 "dictionary.cpp"
                                  var $add229=((($129)+1)&4294967295); //@line 2053 "dictionary.cpp"
                                  $syllable_count=$add229; //@line 2053 "dictionary.cpp"
                                  var $130=$rule_addr; //@line 2050 "dictionary.cpp"
                                  var $131=HEAP8[($130)]; //@line 2050 "dictionary.cpp"
                                  var $conv225=(tempInt=(($131)),(tempInt>=128?tempInt-256:tempInt)); //@line 2050 "dictionary.cpp"
                                  var $cmp226=((($conv225))|0)==21; //@line 2050 "dictionary.cpp"
                                  if ($cmp226) { __label__ = 84;continue ; } else { __label__ = 85;break $while_body227$$while_end230$120; } //@line 2050 "dictionary.cpp"
                                }
                              }
                            } while(0);
  
                            $vowel=0; //@line 2055 "dictionary.cpp"
                            var $132=HEAP32[(($letter_w)>>2)]; //@line 2056 "dictionary.cpp"
                            var $cmp23216=((($132))|0)!=32; //@line 2056 "dictionary.cpp"
                            if ($cmp23216) { __lastLabel__ = 85; __label__ = 87;; } else { __lastLabel__ = 85; __label__ = 91;; } //@line 2056 "dictionary.cpp"
                            $while_body233$$while_end244$124: do { 
                              if (__label__ == 87) {
                                $while_body233$125: while(1) { 
  
                                  var $133=__lastLabel__ == 86 ? $_pr24 : (0); //@line 2058 "dictionary.cpp"
                                  var $cmp234=((($133))|0)==0; //@line 2058 "dictionary.cpp"
                                  if ($cmp234) { __label__ = 88;; } else { __label__ = 90;; } //@line 2058 "dictionary.cpp"
                                  $land_lhs_true235$$if_end240$127: do { 
                                    if (__label__ == 88) {
  
                                      var $134=$tr_addr; //@line 2058 "dictionary.cpp"
                                      var $135=HEAP32[(($letter_w)>>2)]; //@line 2058 "dictionary.cpp"
                                      var $call236=__ZL8IsLetterP10Translatorii($134, $135, 7); //@line 2058 "dictionary.cpp"
                                      var $tobool237=((($call236))|0)!=0; //@line 2058 "dictionary.cpp"
                                      if (!($tobool237)) { __label__ = 90;break $land_lhs_true235$$if_end240$127; } //@line 2058 "dictionary.cpp"
  
                                      var $136=$vowel_count; //@line 2061 "dictionary.cpp"
                                      var $inc239=((($136)+1)&4294967295); //@line 2061 "dictionary.cpp"
                                      $vowel_count=$inc239; //@line 2061 "dictionary.cpp"
                                      ; //@line 2062 "dictionary.cpp"
                                    }
                                  } while(0);
  
                                  var $137=$tr_addr; //@line 2063 "dictionary.cpp"
                                  var $138=HEAP32[(($letter_w)>>2)]; //@line 2063 "dictionary.cpp"
                                  var $call241=__ZL8IsLetterP10Translatorii($137, $138, 7); //@line 2063 "dictionary.cpp"
                                  $vowel=$call241; //@line 2063 "dictionary.cpp"
                                  var $139=$p222; //@line 2064 "dictionary.cpp"
                                  var $call242=__Z7utf8_inPiPKc($letter_w, $139); //@line 2064 "dictionary.cpp"
                                  var $140=$p222; //@line 2064 "dictionary.cpp"
                                  var $add_ptr243=(($140+$call242)&4294967295); //@line 2064 "dictionary.cpp"
                                  $p222=$add_ptr243; //@line 2064 "dictionary.cpp"
                                  var $141=HEAP32[(($letter_w)>>2)]; //@line 2056 "dictionary.cpp"
                                  var $cmp232=((($141))|0)!=32; //@line 2056 "dictionary.cpp"
                                  if (!($cmp232)) { __label__ = 91;break $while_body233$$while_end244$124; } //@line 2056 "dictionary.cpp"
  
                                  var $_pr24=$vowel; //@line 2058 "dictionary.cpp"
                                  __lastLabel__ = 86; __label__ = 87;continue $while_body233$125;
                                }
                              }
                            } while(0);
  
                            var $142=$syllable_count; //@line 2066 "dictionary.cpp"
                            var $143=$vowel_count; //@line 2066 "dictionary.cpp"
                            var $cmp245=((($142))|0) <= ((($143))|0); //@line 2066 "dictionary.cpp"
                            if ($cmp245) { __label__ = 92;; } else { __label__ = 93;; } //@line 2066 "dictionary.cpp"
                            if (__label__ == 92) {
  
                              var $144=$syllable_count; //@line 2067 "dictionary.cpp"
                              var $145=$distance_right; //@line 2067 "dictionary.cpp"
                              var $_neg=(((-($145)))&4294967295);
                              var $add247=((($144)+18)&4294967295); //@line 2067 "dictionary.cpp"
                              var $sub248=((($add247)+($_neg))&4294967295); //@line 2067 "dictionary.cpp"
                              $add_points=$sub248; //@line 2067 "dictionary.cpp"
                              ; //@line 2067 "dictionary.cpp"
                            }
                            else if (__label__ == 93) {
  
                              $failed=1; //@line 2069 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 94) {
  
                            var $146=$post_ptr; //@line 2075 "dictionary.cpp"
                            var $147=$letter_xbytes; //@line 2075 "dictionary.cpp"
                            var $add_ptr253=(($146+$147)&4294967295); //@line 2075 "dictionary.cpp"
                            $p252=$add_ptr253; //@line 2075 "dictionary.cpp"
                            ; //@line 2076 "dictionary.cpp"
                            while(1) { 
  
                              var $148=HEAP32[(($letter_w)>>2)]; //@line 2076 "dictionary.cpp"
                              var $cmp255=((($148))|0)!=32; //@line 2076 "dictionary.cpp"
                              if (!($cmp255)) { __label__ = 99;break ; } //@line 2076 "dictionary.cpp"
  
                              var $149=$tr_addr; //@line 2078 "dictionary.cpp"
                              var $150=HEAP32[(($letter_w)>>2)]; //@line 2078 "dictionary.cpp"
                              var $call257=__ZL8IsLetterP10Translatorii($149, $150, 7); //@line 2078 "dictionary.cpp"
                              var $tobool258=((($call257))|0)!=0; //@line 2078 "dictionary.cpp"
                              if ($tobool258) { __label__ = 97;break ; } //@line 2078 "dictionary.cpp"
  
                              var $151=$p252; //@line 2083 "dictionary.cpp"
                              var $call261=__Z7utf8_inPiPKc($letter_w, $151); //@line 2083 "dictionary.cpp"
                              var $152=$p252; //@line 2083 "dictionary.cpp"
                              var $add_ptr262=(($152+$call261)&4294967295); //@line 2083 "dictionary.cpp"
                              $p252=$add_ptr262; //@line 2083 "dictionary.cpp"
                              __label__ = 95;continue ; //@line 2084 "dictionary.cpp"
                            }
                            if (__label__ == 99) {
  
                              var $_pr2=$failed; //@line 2085 "dictionary.cpp"
                              var $tobool264=((($_pr2))|0)!=0; //@line 2085 "dictionary.cpp"
                              if ($tobool264) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 2085 "dictionary.cpp"
  
                              var $153=$distance_right; //@line 2086 "dictionary.cpp"
                              var $sub266=((19-($153))&4294967295); //@line 2086 "dictionary.cpp"
                              $add_points=$sub266; //@line 2086 "dictionary.cpp"
                              ; //@line 2086 "dictionary.cpp"
                            }
                            else if (__label__ == 97) {
  
                              $failed=1; //@line 2080 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12; //@line 2085 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 101) {
  
                            var $154=$post_ptr; //@line 2095 "dictionary.cpp"
                            var $155=$letter_xbytes; //@line 2095 "dictionary.cpp"
                            var $add_ptr270=(($154+$155)&4294967295); //@line 2095 "dictionary.cpp"
                            $p269=$add_ptr270; //@line 2095 "dictionary.cpp"
                            var $156=$p269; //@line 2096 "dictionary.cpp"
                            $p2=$156; //@line 2096 "dictionary.cpp"
                            var $157=$rule_addr; //@line 2098 "dictionary.cpp"
                            var $call271=__Z7utf8_inPiPKc($rule_w, $157); //@line 2098 "dictionary.cpp"
                            var $158=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                            var $159=HEAP32[(($rule_w)>>2)]; //@line 2099 "dictionary.cpp"
                            var $cmp27317=((($158))|0)!=((($159))|0); //@line 2099 "dictionary.cpp"
                            var $160=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                            var $cmp27518=((($160))|0)!=32; //@line 2099 "dictionary.cpp"
                            var $or_cond19=($cmp27317) & ($cmp27518); //@line 2099 "dictionary.cpp"
                            if ($or_cond19) { __label__ = 102;; } else { __label__ = 103;; } //@line 2099 "dictionary.cpp"
                            $while_body277$$while_end280$146: do { 
                              if (__label__ == 102) {
                                while(1) { 
  
                                  var $161=$p269; //@line 2101 "dictionary.cpp"
                                  $p2=$161; //@line 2101 "dictionary.cpp"
                                  var $162=$p269; //@line 2102 "dictionary.cpp"
                                  var $call278=__Z7utf8_inPiPKc($letter_w, $162); //@line 2102 "dictionary.cpp"
                                  var $163=$p269; //@line 2102 "dictionary.cpp"
                                  var $add_ptr279=(($163+$call278)&4294967295); //@line 2102 "dictionary.cpp"
                                  $p269=$add_ptr279; //@line 2102 "dictionary.cpp"
                                  var $164=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                                  var $165=HEAP32[(($rule_w)>>2)]; //@line 2099 "dictionary.cpp"
                                  var $cmp273=((($164))|0)!=((($165))|0); //@line 2099 "dictionary.cpp"
                                  var $166=HEAP32[(($letter_w)>>2)]; //@line 2099 "dictionary.cpp"
                                  var $cmp275=((($166))|0)!=32; //@line 2099 "dictionary.cpp"
                                  var $or_cond=($cmp273) & ($cmp275); //@line 2099 "dictionary.cpp"
                                  if ($or_cond) { __label__ = 102;continue ; } else { __label__ = 103;break $while_body277$$while_end280$146; } //@line 2099 "dictionary.cpp"
                                }
                              }
                            } while(0);
  
                            var $167=HEAP32[(($letter_w)>>2)]; //@line 2104 "dictionary.cpp"
                            var $168=HEAP32[(($rule_w)>>2)]; //@line 2104 "dictionary.cpp"
                            var $cmp281=((($167))|0)==((($168))|0); //@line 2104 "dictionary.cpp"
                            if (!($cmp281)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2104 "dictionary.cpp"
  
                            var $169=$p2; //@line 2106 "dictionary.cpp"
                            $post_ptr=$169; //@line 2106 "dictionary.cpp"
                            ; //@line 2107 "dictionary.cpp"
                          }
                          else if (__label__ == 105) {
  
                            $add_points=20; //@line 2112 "dictionary.cpp"
                            ; //@line 2113 "dictionary.cpp"
                          }
                          else if (__label__ == 106) {
  
                            var $170=$word_addr; //@line 2117 "dictionary.cpp"
                            var $171=HEAP32[(($170)>>2)]; //@line 2117 "dictionary.cpp"
                            var $172=$group_length_addr; //@line 2117 "dictionary.cpp"
                            var $add_ptr286=(($171+$172)&4294967295); //@line 2117 "dictionary.cpp"
                            $p=$add_ptr286; //@line 2117 "dictionary.cpp"
                            ; //@line 2117 "dictionary.cpp"
                            while(1) { 
  
                              var $173=$p; //@line 2117 "dictionary.cpp"
                              var $174=$post_ptr; //@line 2117 "dictionary.cpp"
                              var $cmp287=((($173))>>>0) < ((($174))>>>0); //@line 2117 "dictionary.cpp"
                              if (!($cmp287)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2117 "dictionary.cpp"
  
                              var $175=$p; //@line 2119 "dictionary.cpp"
                              var $176=HEAP8[($175)]; //@line 2119 "dictionary.cpp"
                              var $conv288=(tempInt=(($176)),(tempInt>=128?tempInt-256:tempInt)); //@line 2119 "dictionary.cpp"
                              var $cmp289=((($conv288))|0)==101; //@line 2119 "dictionary.cpp"
                              var $177=$p; //@line 2121 "dictionary.cpp"
                              if ($cmp289) { __label__ = 109;break ; } //@line 2119 "dictionary.cpp"
  
                              var $incdec_ptr293=(($177+1)&4294967295); //@line 2117 "dictionary.cpp"
                              $p=$incdec_ptr293; //@line 2117 "dictionary.cpp"
                              __label__ = 107;continue ; //@line 2117 "dictionary.cpp"
                            }
  
                            HEAP32[(($del_fwd291)>>2)]=$177; //@line 2121 "dictionary.cpp"
                            ; //@line 2122 "dictionary.cpp"
                          }
                          else if (__label__ == 111) {
  
                            var $178=$rule_addr; //@line 2129 "dictionary.cpp"
                            var $arrayidx295=(($178)&4294967295); //@line 2129 "dictionary.cpp"
                            var $179=HEAP8[($arrayidx295)]; //@line 2129 "dictionary.cpp"
                            var $conv296=(tempInt=(($179)),(tempInt>=128?tempInt-256:tempInt)); //@line 2129 "dictionary.cpp"
                            var $shl297=((($conv296)*65536)&4294967295); //@line 2129 "dictionary.cpp"
                            var $180=$rule_addr; //@line 2129 "dictionary.cpp"
                            var $arrayidx298=(($180+1)&4294967295); //@line 2129 "dictionary.cpp"
                            var $181=HEAP8[($arrayidx298)]; //@line 2129 "dictionary.cpp"
                            var $conv299=(tempInt=(($181)),(tempInt>=128?tempInt-256:tempInt)); //@line 2129 "dictionary.cpp"
                            var $and300=($conv299) & 127; //@line 2129 "dictionary.cpp"
                            var $shl301=((($and300)*256)&4294967295); //@line 2129 "dictionary.cpp"
                            var $182=$rule_addr; //@line 2129 "dictionary.cpp"
                            var $arrayidx303=(($182+2)&4294967295); //@line 2129 "dictionary.cpp"
                            var $183=HEAP8[($arrayidx303)]; //@line 2129 "dictionary.cpp"
                            var $conv304=(tempInt=(($183)),(tempInt>=128?tempInt-256:tempInt)); //@line 2129 "dictionary.cpp"
                            var $and305=($conv304) & 127; //@line 2129 "dictionary.cpp"
                            var $add302=((($shl301)+($shl297))&4294967295); //@line 2129 "dictionary.cpp"
                            var $add306=((($add302)+($and305))&4294967295); //@line 2129 "dictionary.cpp"
                            HEAP32[(($end_type307)>>2)]=$add306; //@line 2129 "dictionary.cpp"
                            var $184=$rule_addr; //@line 2130 "dictionary.cpp"
                            var $add_ptr308=(($184+3)&4294967295); //@line 2130 "dictionary.cpp"
                            $rule_addr=$add_ptr308; //@line 2130 "dictionary.cpp"
                            ; //@line 2131 "dictionary.cpp"
                          }
                          else if (__label__ == 112) {
  
                            var $185=$word_flags_addr; //@line 2134 "dictionary.cpp"
                            var $and310=($185) & 8192; //@line 2134 "dictionary.cpp"
                            var $tobool311=((($and310))|0)!=0; //@line 2134 "dictionary.cpp"
                            if ($tobool311) { __label__ = 113;; } else { __label__ = 114;; } //@line 2134 "dictionary.cpp"
                            if (__label__ == 113) {
  
                              $failed=1; //@line 2135 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12; //@line 2135 "dictionary.cpp"
                            }
                            else if (__label__ == 114) {
  
                              $add_points=1; //@line 2137 "dictionary.cpp"
                              ;
                            }
                          }
                        }
                        else if (__label__ == 119) {
  
                          var $190=$distance_left; //@line 2158 "dictionary.cpp"
                          var $add329=((($190)+2)&4294967295); //@line 2158 "dictionary.cpp"
                          $distance_left=$add329; //@line 2158 "dictionary.cpp"
                          var $191=$distance_left; //@line 2159 "dictionary.cpp"
                          var $cmp330=((($191))|0) > 18; //@line 2159 "dictionary.cpp"
                          if ($cmp330) { __label__ = 120;; } else { __label__ = 121;; } //@line 2159 "dictionary.cpp"
                          if (__label__ == 120) {
  
                            $distance_left=19; //@line 2160 "dictionary.cpp"
                            ; //@line 2160 "dictionary.cpp"
                          }
  
                          var $192=$pre_ptr; //@line 2162 "dictionary.cpp"
                          var $193=HEAP8[($192)]; //@line 2162 "dictionary.cpp"
                          $last_letter=$193; //@line 2162 "dictionary.cpp"
                          var $194=$pre_ptr; //@line 2163 "dictionary.cpp"
                          var $incdec_ptr333=(($194+-1)&4294967295); //@line 2163 "dictionary.cpp"
                          $pre_ptr=$incdec_ptr333; //@line 2163 "dictionary.cpp"
                          var $195=$pre_ptr; //@line 2164 "dictionary.cpp"
                          var $call334=__Z8utf8_in2PiPKci($letter_w, $195, 1); //@line 2164 "dictionary.cpp"
                          var $sub335=((($call334)-1)&4294967295); //@line 2164 "dictionary.cpp"
                          $letter_xbytes=$sub335; //@line 2164 "dictionary.cpp"
                          var $196=$pre_ptr; //@line 2165 "dictionary.cpp"
                          var $197=HEAP8[($196)]; //@line 2165 "dictionary.cpp"
                          $letter=$197; //@line 2165 "dictionary.cpp"
                          var $198=$rb; //@line 2167 "dictionary.cpp"
                          var $conv336=((($198))&255); //@line 2167 "dictionary.cpp"
                          if ($conv336 == 17) {
                            __label__ = 122;;
                          }
                          else if ($conv336 == 18) {
                            __label__ = 127;;
                          }
                          else if ($conv336 == 25) {
                            __label__ = 130;;
                          }
                          else if ($conv336 == 11) {
                            __label__ = 133;;
                          }
                          else if ($conv336 == 15) {
                            __label__ = 136;;
                          }
                          else if ($conv336 == 16) {
                            __label__ = 139;;
                          }
                          else if ($conv336 == 21) {
                            __label__ = 142;;
                          }
                          else if ($conv336 == 10) {
                            __label__ = 147;;
                          }
                          else if ($conv336 == 29) {
                            __label__ = 150;;
                          }
                          else if ($conv336 == 26) {
                            __label__ = 157;;
                          }
                          else if ($conv336 == 19) {
                            __label__ = 160;;
                          }
                          else if ($conv336 == 46) {
                            __label__ = 163;;
                          }
                          else if ($conv336 == 45) {
                            __label__ = 170;;
                          }
                          else {
                          __label__ = 175;;
                          }
                          
                          if (__label__ == 175) {
  
                            var $268=$letter; //@line 2307 "dictionary.cpp"
                            var $conv478=((($268))&255); //@line 2307 "dictionary.cpp"
                            var $269=$rb; //@line 2307 "dictionary.cpp"
                            var $conv479=((($269))&255); //@line 2307 "dictionary.cpp"
                            var $cmp480=((($conv478))|0)==((($conv479))|0); //@line 2307 "dictionary.cpp"
                            if ($cmp480) { __label__ = 176;; } else { __label__ = 180;; } //@line 2307 "dictionary.cpp"
                            if (__label__ == 176) {
  
                              var $270=$letter; //@line 2309 "dictionary.cpp"
                              var $conv482=((($270))&255); //@line 2309 "dictionary.cpp"
                              var $cmp483=((($conv482))|0)==32; //@line 2309 "dictionary.cpp"
                              if ($cmp483) { __label__ = 177;; } else { __label__ = 178;; } //@line 2309 "dictionary.cpp"
                              if (__label__ == 177) {
  
                                $add_points=4; //@line 2310 "dictionary.cpp"
                                ; //@line 2310 "dictionary.cpp"
                              }
                              else if (__label__ == 178) {
  
                                var $271=$letter; //@line 2313 "dictionary.cpp"
                                var $conv486=((($271))&255); //@line 2313 "dictionary.cpp"
                                var $and487=($conv486) & 192; //@line 2313 "dictionary.cpp"
                                var $cmp488=((($and487))|0)!=128; //@line 2313 "dictionary.cpp"
                                if (!($cmp488)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2313 "dictionary.cpp"
  
                                var $272=$distance_left; //@line 2316 "dictionary.cpp"
                                var $sub490=((21-($272))&4294967295); //@line 2316 "dictionary.cpp"
                                $add_points=$sub490; //@line 2316 "dictionary.cpp"
                                ; //@line 2317 "dictionary.cpp"
                              }
                            }
                            else if (__label__ == 180) {
  
                              $failed=1; //@line 2321 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 122) {
  
                            var $199=$rule_addr; //@line 2170 "dictionary.cpp"
                            var $incdec_ptr338=(($199+1)&4294967295); //@line 2170 "dictionary.cpp"
                            $rule_addr=$incdec_ptr338; //@line 2170 "dictionary.cpp"
                            var $200=HEAP8[($199)]; //@line 2170 "dictionary.cpp"
                            var $conv339=(tempInt=(($200)),(tempInt>=128?tempInt-256:tempInt)); //@line 2170 "dictionary.cpp"
                            var $sub340=((($conv339)-65)&4294967295); //@line 2170 "dictionary.cpp"
                            $letter_group=$sub340; //@line 2170 "dictionary.cpp"
                            var $201=$tr_addr; //@line 2171 "dictionary.cpp"
                            var $202=HEAP32[(($letter_w)>>2)]; //@line 2171 "dictionary.cpp"
                            var $203=$letter_group; //@line 2171 "dictionary.cpp"
                            var $call341=__ZL8IsLetterP10Translatorii($201, $202, $203); //@line 2171 "dictionary.cpp"
                            var $tobool342=((($call341))|0)!=0; //@line 2171 "dictionary.cpp"
                            if ($tobool342) { __label__ = 123;; } else { __label__ = 126;; } //@line 2171 "dictionary.cpp"
                            if (__label__ == 123) {
  
                              $lg_pts=20; //@line 2173 "dictionary.cpp"
                              var $204=$letter_group; //@line 2174 "dictionary.cpp"
                              var $cmp344=((($204))|0)==2; //@line 2174 "dictionary.cpp"
                              if ($cmp344) { __label__ = 124;; } else { __label__ = 125;; } //@line 2174 "dictionary.cpp"
                              if (__label__ == 124) {
  
                                $lg_pts=19; //@line 2175 "dictionary.cpp"
                                ; //@line 2175 "dictionary.cpp"
                              }
  
                              var $205=$lg_pts; //@line 2176 "dictionary.cpp"
                              var $206=$distance_left; //@line 2176 "dictionary.cpp"
                              var $sub347=((($205)-($206))&4294967295); //@line 2176 "dictionary.cpp"
                              $add_points=$sub347; //@line 2176 "dictionary.cpp"
                              var $207=$letter_xbytes; //@line 2177 "dictionary.cpp"
                              var $208=$pre_ptr; //@line 2177 "dictionary.cpp"
                              var $idx_neg=(((-($207)))&4294967295); //@line 2177 "dictionary.cpp"
                              var $add_ptr348=(($208+$idx_neg)&4294967295); //@line 2177 "dictionary.cpp"
                              $pre_ptr=$add_ptr348; //@line 2177 "dictionary.cpp"
                              ; //@line 2178 "dictionary.cpp"
                            }
                            else if (__label__ == 126) {
  
                              $failed=1; //@line 2180 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 127) {
  
                            var $209=$rule_addr; //@line 2184 "dictionary.cpp"
                            var $incdec_ptr352=(($209+1)&4294967295); //@line 2184 "dictionary.cpp"
                            $rule_addr=$incdec_ptr352; //@line 2184 "dictionary.cpp"
                            var $210=HEAP8[($209)]; //@line 2184 "dictionary.cpp"
                            var $conv353=(tempInt=(($210)),(tempInt>=128?tempInt-256:tempInt)); //@line 2184 "dictionary.cpp"
                            var $sub354=((($conv353)-65)&4294967295); //@line 2184 "dictionary.cpp"
                            $letter_group=$sub354; //@line 2184 "dictionary.cpp"
                            var $211=$tr_addr; //@line 2185 "dictionary.cpp"
                            var $212=$pre_ptr; //@line 2185 "dictionary.cpp"
                            var $213=$letter_group; //@line 2185 "dictionary.cpp"
                            var $call355=__ZL13IsLetterGroupP10TranslatorPcii($211, $212, $213, 1); //@line 2185 "dictionary.cpp"
                            $n_bytes=$call355; //@line 2185 "dictionary.cpp"
                            var $cmp356=((($call355))|0) > 0; //@line 2185 "dictionary.cpp"
                            if ($cmp356) { __label__ = 128;; } else { __label__ = 129;; } //@line 2185 "dictionary.cpp"
                            if (__label__ == 128) {
  
                              var $214=$distance_right; //@line 2187 "dictionary.cpp"
                              var $sub358=((20-($214))&4294967295); //@line 2187 "dictionary.cpp"
                              $add_points=$sub358; //@line 2187 "dictionary.cpp"
                              var $215=$n_bytes; //@line 2188 "dictionary.cpp"
                              var $sub359=((($215)-1)&4294967295); //@line 2188 "dictionary.cpp"
                              var $216=$pre_ptr; //@line 2188 "dictionary.cpp"
                              var $idx_neg360=(((-($sub359)))&4294967295); //@line 2188 "dictionary.cpp"
                              var $add_ptr361=(($216+$idx_neg360)&4294967295); //@line 2188 "dictionary.cpp"
                              $pre_ptr=$add_ptr361; //@line 2188 "dictionary.cpp"
                              ; //@line 2189 "dictionary.cpp"
                            }
                            else if (__label__ == 129) {
  
                              $failed=1; //@line 2191 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 130) {
  
                            var $217=$tr_addr; //@line 2195 "dictionary.cpp"
                            var $218=HEAP32[(($letter_w)>>2)]; //@line 2195 "dictionary.cpp"
                            var $call365=__ZL8IsLetterP10Translatorii($217, $218, 0); //@line 2195 "dictionary.cpp"
                            var $tobool366=((($call365))|0)!=0; //@line 2195 "dictionary.cpp"
                            if ($tobool366) { __label__ = 132;; } else { __label__ = 131;; } //@line 2195 "dictionary.cpp"
                            if (__label__ == 132) {
  
                              $failed=1; //@line 2201 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                            else if (__label__ == 131) {
  
                              var $219=$distance_left; //@line 2197 "dictionary.cpp"
                              var $sub368=((20-($219))&4294967295); //@line 2197 "dictionary.cpp"
                              $add_points=$sub368; //@line 2197 "dictionary.cpp"
                              var $220=$letter_xbytes; //@line 2198 "dictionary.cpp"
                              var $221=$pre_ptr; //@line 2198 "dictionary.cpp"
                              var $idx_neg369=(((-($220)))&4294967295); //@line 2198 "dictionary.cpp"
                              var $add_ptr370=(($221+$idx_neg369)&4294967295); //@line 2198 "dictionary.cpp"
                              $pre_ptr=$add_ptr370; //@line 2198 "dictionary.cpp"
                              ; //@line 2199 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 133) {
  
                            var $222=$letter; //@line 2205 "dictionary.cpp"
                            var $conv374=((($222))&255); //@line 2205 "dictionary.cpp"
                            var $223=$last_letter; //@line 2205 "dictionary.cpp"
                            var $conv375=((($223))&255); //@line 2205 "dictionary.cpp"
                            var $cmp376=((($conv374))|0)==((($conv375))|0); //@line 2205 "dictionary.cpp"
                            if ($cmp376) { __label__ = 134;; } else { __label__ = 135;; } //@line 2205 "dictionary.cpp"
                            if (__label__ == 134) {
  
                              var $224=$distance_left; //@line 2206 "dictionary.cpp"
                              var $sub378=((21-($224))&4294967295); //@line 2206 "dictionary.cpp"
                              $add_points=$sub378; //@line 2206 "dictionary.cpp"
                              ; //@line 2206 "dictionary.cpp"
                            }
                            else if (__label__ == 135) {
  
                              $failed=1; //@line 2208 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 136) {
  
                            var $225=HEAP32[(($letter_w)>>2)]; //@line 2212 "dictionary.cpp"
                            var $call382=__Z7IsDigitj($225); //@line 2212 "dictionary.cpp"
                            var $tobool383=((($call382))|0)!=0; //@line 2212 "dictionary.cpp"
                            if ($tobool383) { __label__ = 137;; } else { __label__ = 138;; } //@line 2212 "dictionary.cpp"
                            if (__label__ == 137) {
  
                              var $226=$distance_left; //@line 2214 "dictionary.cpp"
                              var $sub385=((21-($226))&4294967295); //@line 2214 "dictionary.cpp"
                              $add_points=$sub385; //@line 2214 "dictionary.cpp"
                              var $227=$letter_xbytes; //@line 2215 "dictionary.cpp"
                              var $228=$pre_ptr; //@line 2215 "dictionary.cpp"
                              var $idx_neg386=(((-($227)))&4294967295); //@line 2215 "dictionary.cpp"
                              var $add_ptr387=(($228+$idx_neg386)&4294967295); //@line 2215 "dictionary.cpp"
                              $pre_ptr=$add_ptr387; //@line 2215 "dictionary.cpp"
                              ; //@line 2216 "dictionary.cpp"
                            }
                            else if (__label__ == 138) {
  
                              $failed=1; //@line 2218 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 139) {
  
                            var $229=HEAP32[(($letter_w)>>2)]; //@line 2222 "dictionary.cpp"
                            var $call391=_iswalpha($229); //@line 2222 "dictionary.cpp"
                            var $tobool392=((($call391))|0)!=0; //@line 2222 "dictionary.cpp"
                            if ($tobool392) { __label__ = 141;; } else { __label__ = 140;; } //@line 2222 "dictionary.cpp"
                            if (__label__ == 141) {
  
                              $failed=1; //@line 2228 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                            else if (__label__ == 140) {
  
                              var $230=$distance_right; //@line 2224 "dictionary.cpp"
                              var $sub394=((21-($230))&4294967295); //@line 2224 "dictionary.cpp"
                              $add_points=$sub394; //@line 2224 "dictionary.cpp"
                              var $231=$letter_xbytes; //@line 2225 "dictionary.cpp"
                              var $232=$pre_ptr; //@line 2225 "dictionary.cpp"
                              var $idx_neg395=(((-($231)))&4294967295); //@line 2225 "dictionary.cpp"
                              var $add_ptr396=(($232+$idx_neg395)&4294967295); //@line 2225 "dictionary.cpp"
                              $pre_ptr=$add_ptr396; //@line 2225 "dictionary.cpp"
                              ; //@line 2226 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 142) {
  
                            $syllable_count=1; //@line 2233 "dictionary.cpp"
                            var $233=$rule_addr; //@line 2234 "dictionary.cpp"
                            var $234=HEAP8[($233)]; //@line 2234 "dictionary.cpp"
                            var $conv40112=(tempInt=(($234)),(tempInt>=128?tempInt-256:tempInt)); //@line 2234 "dictionary.cpp"
                            var $cmp40213=((($conv40112))|0)==21; //@line 2234 "dictionary.cpp"
                            if ($cmp40213) { __label__ = 143;; } else { __label__ = 144;; } //@line 2234 "dictionary.cpp"
                            $while_body403$$while_end406$204: do { 
                              if (__label__ == 143) {
                                while(1) { 
  
                                  var $235=$rule_addr; //@line 2236 "dictionary.cpp"
                                  var $incdec_ptr404=(($235+1)&4294967295); //@line 2236 "dictionary.cpp"
                                  $rule_addr=$incdec_ptr404; //@line 2236 "dictionary.cpp"
                                  var $236=$syllable_count; //@line 2237 "dictionary.cpp"
                                  var $inc405=((($236)+1)&4294967295); //@line 2237 "dictionary.cpp"
                                  $syllable_count=$inc405; //@line 2237 "dictionary.cpp"
                                  var $237=$rule_addr; //@line 2234 "dictionary.cpp"
                                  var $238=HEAP8[($237)]; //@line 2234 "dictionary.cpp"
                                  var $conv401=(tempInt=(($238)),(tempInt>=128?tempInt-256:tempInt)); //@line 2234 "dictionary.cpp"
                                  var $cmp402=((($conv401))|0)==21; //@line 2234 "dictionary.cpp"
                                  if ($cmp402) { __label__ = 143;continue ; } else { __label__ = 144;break $while_body403$$while_end406$204; } //@line 2234 "dictionary.cpp"
                                }
                              }
                            } while(0);
  
                            var $239=$syllable_count; //@line 2239 "dictionary.cpp"
                            var $240=$tr_addr; //@line 2239 "dictionary.cpp"
                            var $word_vowel_count=(($240+8296)&4294967295); //@line 2239 "dictionary.cpp"
                            var $241=HEAP32[(($word_vowel_count)>>2)]; //@line 2239 "dictionary.cpp"
                            var $cmp407=((($239))|0) <= ((($241))|0); //@line 2239 "dictionary.cpp"
                            if ($cmp407) { __label__ = 145;; } else { __label__ = 146;; } //@line 2239 "dictionary.cpp"
                            if (__label__ == 145) {
  
                              var $242=$syllable_count; //@line 2240 "dictionary.cpp"
                              var $243=$distance_left; //@line 2240 "dictionary.cpp"
                              var $_neg11=(((-($243)))&4294967295);
                              var $add409=((($242)+18)&4294967295); //@line 2240 "dictionary.cpp"
                              var $sub410=((($add409)+($_neg11))&4294967295); //@line 2240 "dictionary.cpp"
                              $add_points=$sub410; //@line 2240 "dictionary.cpp"
                              ; //@line 2240 "dictionary.cpp"
                            }
                            else if (__label__ == 146) {
  
                              $failed=1; //@line 2242 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 147) {
  
                            var $244=$tr_addr; //@line 2246 "dictionary.cpp"
                            var $word_stressed_count=(($244+8300)&4294967295); //@line 2246 "dictionary.cpp"
                            var $245=HEAP32[(($word_stressed_count)>>2)]; //@line 2246 "dictionary.cpp"
                            var $cmp414=((($245))|0) > 0; //@line 2246 "dictionary.cpp"
                            if ($cmp414) { __label__ = 148;; } else { __label__ = 149;; } //@line 2246 "dictionary.cpp"
                            if (__label__ == 148) {
  
                              $add_points=19; //@line 2247 "dictionary.cpp"
                              ; //@line 2247 "dictionary.cpp"
                            }
                            else if (__label__ == 149) {
  
                              $failed=1; //@line 2249 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 150) {
  
                            var $246=$pre_ptr; //@line 2254 "dictionary.cpp"
                            var $247=$letter_xbytes; //@line 2254 "dictionary.cpp"
                            var $idx_neg420=(((-($247)))&4294967295); //@line 2254 "dictionary.cpp"
                            var $add_ptr421=(($246+$idx_neg420)&4294967295); //@line 2254 "dictionary.cpp"
                            var $add_ptr422=(($add_ptr421+-1)&4294967295); //@line 2254 "dictionary.cpp"
                            $p419=$add_ptr422; //@line 2254 "dictionary.cpp"
                            ; //@line 2255 "dictionary.cpp"
                            while(1) { 
  
                              var $248=HEAP32[(($letter_w)>>2)]; //@line 2255 "dictionary.cpp"
                              var $cmp424=((($248))|0)!=32; //@line 2255 "dictionary.cpp"
                              if (!($cmp424)) { __label__ = 155;break ; } //@line 2255 "dictionary.cpp"
  
                              var $249=$tr_addr; //@line 2257 "dictionary.cpp"
                              var $250=HEAP32[(($letter_w)>>2)]; //@line 2257 "dictionary.cpp"
                              var $call426=__ZL8IsLetterP10Translatorii($249, $250, 7); //@line 2257 "dictionary.cpp"
                              var $tobool427=((($call426))|0)!=0; //@line 2257 "dictionary.cpp"
                              if ($tobool427) { __label__ = 153;break ; } //@line 2257 "dictionary.cpp"
  
                              var $251=$p419; //@line 2262 "dictionary.cpp"
                              var $call430=__Z8utf8_in2PiPKci($letter_w, $251, 1); //@line 2262 "dictionary.cpp"
                              var $252=$p419; //@line 2262 "dictionary.cpp"
                              var $idx_neg431=(((-($call430)))&4294967295); //@line 2262 "dictionary.cpp"
                              var $add_ptr432=(($252+$idx_neg431)&4294967295); //@line 2262 "dictionary.cpp"
                              $p419=$add_ptr432; //@line 2262 "dictionary.cpp"
                              __label__ = 151;continue ; //@line 2263 "dictionary.cpp"
                            }
                            if (__label__ == 155) {
  
                              var $_pr4=$failed; //@line 2264 "dictionary.cpp"
                              var $tobool434=((($_pr4))|0)!=0; //@line 2264 "dictionary.cpp"
                              if ($tobool434) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 2264 "dictionary.cpp"
  
                              $add_points=3; //@line 2265 "dictionary.cpp"
                              ; //@line 2265 "dictionary.cpp"
                            }
                            else if (__label__ == 153) {
  
                              $failed=1; //@line 2259 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12; //@line 2264 "dictionary.cpp"
                            }
                          }
                          else if (__label__ == 157) {
  
                            var $253=$tr_addr; //@line 2270 "dictionary.cpp"
                            var $expect_verb=(($253+8272)&4294967295); //@line 2270 "dictionary.cpp"
                            var $254=HEAP32[(($expect_verb)>>2)]; //@line 2270 "dictionary.cpp"
                            var $tobool438=((($254))|0)!=0; //@line 2270 "dictionary.cpp"
                            if ($tobool438) { __label__ = 158;; } else { __label__ = 159;; } //@line 2270 "dictionary.cpp"
                            if (__label__ == 158) {
  
                              $add_points=1; //@line 2271 "dictionary.cpp"
                              ; //@line 2271 "dictionary.cpp"
                            }
                            else if (__label__ == 159) {
  
                              $failed=1; //@line 2273 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 160) {
  
                            var $255=$word_flags_addr; //@line 2277 "dictionary.cpp"
                            var $and443=($255) & 2; //@line 2277 "dictionary.cpp"
                            var $tobool444=((($and443))|0)!=0; //@line 2277 "dictionary.cpp"
                            if ($tobool444) { __label__ = 161;; } else { __label__ = 162;; } //@line 2277 "dictionary.cpp"
                            if (__label__ == 161) {
  
                              $add_points=1; //@line 2278 "dictionary.cpp"
                              ; //@line 2278 "dictionary.cpp"
                            }
                            else if (__label__ == 162) {
  
                              $failed=1; //@line 2280 "dictionary.cpp"
                              __label__ = 30;break $if_then8$$if_end70$12;
                            }
                          }
                          else if (__label__ == 163) {
  
                            var $256=$pre_ptr; //@line 2285 "dictionary.cpp"
                            $p=$256; //@line 2285 "dictionary.cpp"
                            ; //@line 2285 "dictionary.cpp"
                            while(1) { 
  
                              var $257=$p; //@line 2285 "dictionary.cpp"
                              var $258=HEAP8[($257)]; //@line 2285 "dictionary.cpp"
                              var $conv450=(tempInt=(($258)),(tempInt>=128?tempInt-256:tempInt)); //@line 2285 "dictionary.cpp"
                              var $cmp451=((($conv450))|0)!=32; //@line 2285 "dictionary.cpp"
                              if (!($cmp451)) { __label__ = 168;break ; } //@line 2285 "dictionary.cpp"
  
                              var $259=$p; //@line 2287 "dictionary.cpp"
                              var $260=HEAP8[($259)]; //@line 2287 "dictionary.cpp"
                              var $conv453=(tempInt=(($260)),(tempInt>=128?tempInt-256:tempInt)); //@line 2287 "dictionary.cpp"
                              var $cmp454=((($conv453))|0)==46; //@line 2287 "dictionary.cpp"
                              if ($cmp454) { __label__ = 166;break ; } //@line 2287 "dictionary.cpp"
  
                              var $261=$p; //@line 2285 "dictionary.cpp"
                              var $incdec_ptr458=(($261+-1)&4294967295); //@line 2285 "dictionary.cpp"
                              $p=$incdec_ptr458; //@line 2285 "dictionary.cpp"
                              __label__ = 164;continue ; //@line 2285 "dictionary.cpp"
                            }
                            if (__label__ == 166) {
  
                              $add_points=50; //@line 2289 "dictionary.cpp"
                              ; //@line 2290 "dictionary.cpp"
                            }
  
                            var $262=$p; //@line 2293 "dictionary.cpp"
                            var $263=HEAP8[($262)]; //@line 2293 "dictionary.cpp"
                            var $conv460=(tempInt=(($263)),(tempInt>=128?tempInt-256:tempInt)); //@line 2293 "dictionary.cpp"
                            var $cmp461=((($conv460))|0)==32; //@line 2293 "dictionary.cpp"
                            if (!($cmp461)) { __label__ = 181;break $sw_epilog496$$sw_bb71$$sw_bb89$$sw_bb328$44; } //@line 2293 "dictionary.cpp"
  
                            $failed=1; //@line 2294 "dictionary.cpp"
                            __label__ = 30;break $if_then8$$if_end70$12; //@line 2294 "dictionary.cpp"
                          }
                          else if (__label__ == 170) {
  
                            var $264=$letter; //@line 2298 "dictionary.cpp"
                            var $conv465=((($264))&255); //@line 2298 "dictionary.cpp"
                            var $cmp466=((($conv465))|0)==45; //@line 2298 "dictionary.cpp"
                            if ($cmp466) { __label__ = 173;; } else { __label__ = 171;; } //@line 2298 "dictionary.cpp"
                            $if_then473$$lor_lhs_false467$242: do { 
                              if (__label__ == 171) {
  
                                var $265=$letter; //@line 2298 "dictionary.cpp"
                                var $conv468=((($265))&255); //@line 2298 "dictionary.cpp"
                                var $cmp469=((($conv468))|0)==32; //@line 2298 "dictionary.cpp"
                                if ($cmp469) { __label__ = 172;; } else { __label__ = 174;; } //@line 2298 "dictionary.cpp"
                                if (__label__ == 172) {
  
                                  var $266=$word_flags_addr; //@line 2298 "dictionary.cpp"
                                  var $and471=($266) & 128; //@line 2298 "dictionary.cpp"
                                  var $tobool472=((($and471))|0)!=0; //@line 2298 "dictionary.cpp"
                                  if ($tobool472) { __label__ = 173;break $if_then473$$lor_lhs_false467$242; } //@line 2298 "dictionary.cpp"
                                }
  
                                $failed=1; //@line 2303 "dictionary.cpp"
                                __label__ = 30;break $if_then8$$if_end70$12;
                              }
                            } while(0);
  
                            var $267=$distance_right; //@line 2300 "dictionary.cpp"
                            var $sub474=((22-($267))&4294967295); //@line 2300 "dictionary.cpp"
                            $add_points=$sub474; //@line 2300 "dictionary.cpp"
                            ; //@line 2301 "dictionary.cpp"
                          }
                        }
                      } while(0);
  
                      var $_pr6_pr=$failed; //@line 2327 "dictionary.cpp"
                      var $cmp497=((($_pr6_pr))|0)==0; //@line 2327 "dictionary.cpp"
                      if (!($cmp497)) { __label__ = 30;break $if_then8$$if_end70$12; } //@line 2327 "dictionary.cpp"
  
                      var $273=$add_points; //@line 2328 "dictionary.cpp"
                      var $274=HEAP32[(($points499)>>2)]; //@line 2328 "dictionary.cpp"
                      var $add500=((($274)+($273))&4294967295); //@line 2328 "dictionary.cpp"
                      HEAP32[(($points499)>>2)]=$add500; //@line 2328 "dictionary.cpp"
                      ; //@line 2328 "dictionary.cpp"
                    }
                  } while(0);
  
                  var $42=$failed; //@line 1818 "dictionary.cpp"
                  var $tobool=((($42))|0)!=0; //@line 1818 "dictionary.cpp"
                  var $lnot=($tobool) ^ 1; //@line 1818 "dictionary.cpp"
                  if ($lnot) { __lastLabel__ = 30; __label__ = 6;continue $while_body4$10; } else { __lastLabel__ = 30; __label__ = 183;break $while_body4$$while_end502$9; } //@line 1818 "dictionary.cpp"
                }
              }
            } while(0);
  
            var $275=__lastLabel__ == 30 ? $42 : ($18); //@line 2331 "dictionary.cpp"
            var $cmp503=((($275))|0)==2; //@line 2331 "dictionary.cpp"
            if ($cmp503) { __label__ = 184;; } else { __label__ = 197;; } //@line 2331 "dictionary.cpp"
            $land_lhs_true504$$while_cond543$252: do { 
              if (__label__ == 184) {
  
                var $276=$unpron_ignore; //@line 2331 "dictionary.cpp"
                var $cmp505=((($276))|0)==0; //@line 2331 "dictionary.cpp"
                if (!($cmp505)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2331 "dictionary.cpp"
  
                var $277=$check_atstart; //@line 2334 "dictionary.cpp"
                var $cmp507=((($277))|0)==0; //@line 2334 "dictionary.cpp"
                if ($cmp507) { __label__ = 189;; } else { __label__ = 186;; } //@line 2334 "dictionary.cpp"
                $if_end517$$lor_lhs_false508$255: do { 
                  if (__label__ == 186) {
  
                    var $278=$pre_ptr; //@line 2334 "dictionary.cpp"
                    var $arrayidx509=(($278+-1)&4294967295); //@line 2334 "dictionary.cpp"
                    var $279=HEAP8[($arrayidx509)]; //@line 2334 "dictionary.cpp"
                    var $conv510=(tempInt=(($279)),(tempInt>=128?tempInt-256:tempInt)); //@line 2334 "dictionary.cpp"
                    var $cmp511=((($conv510))|0)==32; //@line 2334 "dictionary.cpp"
                    if (!($cmp511)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2334 "dictionary.cpp"
  
                    var $_pr8=$check_atstart; //@line 2336 "dictionary.cpp"
                    var $tobool513=((($_pr8))|0)!=0; //@line 2336 "dictionary.cpp"
                    if (!($tobool513)) { __label__ = 189;break $if_end517$$lor_lhs_false508$255; } //@line 2336 "dictionary.cpp"
  
                    var $280=HEAP32[(($points515)>>2)]; //@line 2337 "dictionary.cpp"
                    var $add516=((($280)+4)&4294967295); //@line 2337 "dictionary.cpp"
                    HEAP32[(($points515)>>2)]=$add516; //@line 2337 "dictionary.cpp"
                    ; //@line 2337 "dictionary.cpp"
                  }
                } while(0);
  
                var $281=HEAP32[(($points518)>>2)]; //@line 2340 "dictionary.cpp"
                var $282=HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best)&4294967295))>>2)]; //@line 2340 "dictionary.cpp"
                var $cmp519=((($281))|0) >= ((($282))|0); //@line 2340 "dictionary.cpp"
                if ($cmp519) { __label__ = 190;; } else { __label__ = 191;; } //@line 2340 "dictionary.cpp"
                if (__label__ == 190) {
  
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $8;
                  $dest$ = __ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best;
                  $stop$ = $src$ + 16;
                  if (($dest$%4) == ($src$%4) && 16 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 2342 "dictionary.cpp"
                  var $283=$consumed; //@line 2343 "dictionary.cpp"
                  $total_consumed=$283; //@line 2343 "dictionary.cpp"
                  ; //@line 2344 "dictionary.cpp"
                }
  
                var $284=HEAP32[((_option_phonemes)>>2)]; //@line 2346 "dictionary.cpp"
                var $cmp522=((($284))|0)==2; //@line 2346 "dictionary.cpp"
                if (!($cmp522)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2346 "dictionary.cpp"
  
                var $285=HEAP32[(($points524)>>2)]; //@line 2346 "dictionary.cpp"
                var $cmp525=((($285))|0) > 0; //@line 2346 "dictionary.cpp"
                if (!($cmp525)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2346 "dictionary.cpp"
  
                var $286=$word_flags_addr; //@line 2346 "dictionary.cpp"
                var $and527=($286) & 268435456; //@line 2346 "dictionary.cpp"
                var $cmp528=((($and527))|0)==0; //@line 2346 "dictionary.cpp"
                if (!($cmp528)) { __label__ = 197;break $land_lhs_true504$$while_cond543$252; } //@line 2346 "dictionary.cpp"
  
                var $287=HEAP32[(($points530)>>2)]; //@line 2352 "dictionary.cpp"
                $pts=$287; //@line 2352 "dictionary.cpp"
                var $288=$group_length_addr; //@line 2353 "dictionary.cpp"
                var $cmp531=((($288))|0) > 1; //@line 2353 "dictionary.cpp"
                if ($cmp531) { __label__ = 195;; } else { __label__ = 196;; } //@line 2353 "dictionary.cpp"
                if (__label__ == 195) {
  
                  var $289=$pts; //@line 2354 "dictionary.cpp"
                  var $add533=((($289)+35)&4294967295); //@line 2354 "dictionary.cpp"
                  $pts=$add533; //@line 2354 "dictionary.cpp"
                  ; //@line 2354 "dictionary.cpp"
                }
  
                var $290=HEAP32[(($phonemes535)>>2)]; //@line 2355 "dictionary.cpp"
                __Z14DecodePhonemesPKcPc($290, $arraydecay536); //@line 2355 "dictionary.cpp"
                var $291=HEAP32[((_f_trans)>>2)]; //@line 2356 "dictionary.cpp"
                var $292=$pts; //@line 2356 "dictionary.cpp"
                var $293=$group_chars; //@line 2356 "dictionary.cpp"
                var $294=$group_length_addr; //@line 2356 "dictionary.cpp"
                var $295=$rule_start; //@line 2356 "dictionary.cpp"
                var $296=$word_flags_addr; //@line 2356 "dictionary.cpp"
                var $call537=__Z10DecodeRulePKciPci($293, $294, $295, $296); //@line 2356 "dictionary.cpp"
                var $call539=_fprintf($291, ((__str32148)&4294967295), allocate([$292,0,0,0,((__ZZ10DecodeRulePKciPciE6output)&4294967295),0,0,0,$arraydecay538,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 2356 "dictionary.cpp"
                ; //@line 2357 "dictionary.cpp"
              }
            } while(0);
            while(1) { 
  
              var $297=$rule_addr; //@line 2362 "dictionary.cpp"
              var $incdec_ptr544=(($297+1)&4294967295); //@line 2362 "dictionary.cpp"
              $rule_addr=$incdec_ptr544; //@line 2362 "dictionary.cpp"
              var $298=HEAP8[($297)]; //@line 2362 "dictionary.cpp"
              var $conv545=(tempInt=(($298)),(tempInt>=128?tempInt-256:tempInt)); //@line 2362 "dictionary.cpp"
              var $cmp546=((($conv545))|0)!=0; //@line 2362 "dictionary.cpp"
              if ($cmp546) { __label__ = 197;continue ; } else { __label__ = 4;break ; } //@line 2362 "dictionary.cpp"
            }
  
            var $9=$rule_addr; //@line 1797 "dictionary.cpp"
            var $arrayidx=(($9)&4294967295); //@line 1797 "dictionary.cpp"
            var $10=HEAP8[($arrayidx)]; //@line 1797 "dictionary.cpp"
            var $conv=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1797 "dictionary.cpp"
            var $cmp1=((($conv))|0)!=7; //@line 1797 "dictionary.cpp"
            if ($cmp1) { __label__ = 5;continue $while_body$7; } else { __label__ = 198;break $while_body_lr_ph$$while_end549$5; } //@line 1797 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $299=HEAP32[((_option_phonemes)>>2)]; //@line 2365 "dictionary.cpp"
      var $cmp550=((($299))|0)==2; //@line 2365 "dictionary.cpp"
      if ($cmp550) { __label__ = 199;; } else { __label__ = 202;; } //@line 2365 "dictionary.cpp"
      $land_lhs_true551$$if_end559$273: do { 
        if (__label__ == 199) {
  
          var $300=$word_flags_addr; //@line 2365 "dictionary.cpp"
          var $and552=($300) & 268435456; //@line 2365 "dictionary.cpp"
          var $cmp553=((($and552))|0)==0; //@line 2365 "dictionary.cpp"
          if (!($cmp553)) { __label__ = 202;break $land_lhs_true551$$if_end559$273; } //@line 2365 "dictionary.cpp"
  
          var $301=$group_length_addr; //@line 2367 "dictionary.cpp"
          var $cmp555=((($301))|0) <= 1; //@line 2367 "dictionary.cpp"
          if (!($cmp555)) { __label__ = 202;break $land_lhs_true551$$if_end559$273; } //@line 2367 "dictionary.cpp"
  
          var $302=HEAP32[((_f_trans)>>2)]; //@line 2368 "dictionary.cpp"
          var $fputc=_fputc(10, $302); //@line 2368 "dictionary.cpp"
          ; //@line 2368 "dictionary.cpp"
        }
      } while(0);
  
      var $303=$group_length_addr; //@line 2372 "dictionary.cpp"
      var $304=$total_consumed; //@line 2372 "dictionary.cpp"
      var $add560=((($304)+($303))&4294967295); //@line 2372 "dictionary.cpp"
      $total_consumed=$add560; //@line 2372 "dictionary.cpp"
      var $cmp561=((($add560))|0)==0; //@line 2373 "dictionary.cpp"
      if ($cmp561) { __label__ = 203;; } else { __label__ = 204;; } //@line 2373 "dictionary.cpp"
      if (__label__ == 203) {
  
        $total_consumed=1; //@line 2374 "dictionary.cpp"
        ; //@line 2374 "dictionary.cpp"
      }
  
      var $305=$total_consumed; //@line 2376 "dictionary.cpp"
      var $306=$word_addr; //@line 2376 "dictionary.cpp"
      var $307=HEAP32[(($306)>>2)]; //@line 2376 "dictionary.cpp"
      var $add_ptr564=(($307+$305)&4294967295); //@line 2376 "dictionary.cpp"
      HEAP32[(($306)>>2)]=$add_ptr564; //@line 2376 "dictionary.cpp"
      var $308=HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best)&4294967295))>>2)]; //@line 2378 "dictionary.cpp"
      var $cmp565=((($308))|0)==0; //@line 2378 "dictionary.cpp"
      if ($cmp565) { __label__ = 205;; } else { __label__ = 206;; } //@line 2378 "dictionary.cpp"
      if (__label__ == 205) {
  
        HEAP32[((((__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best+4)&4294967295))>>2)]=((__str13643)&4294967295); //@line 2379 "dictionary.cpp"
        ; //@line 2379 "dictionary.cpp"
      }
  
      var $309=$match_out_addr; //@line 2380 "dictionary.cpp"
      var $310=$309; //@line 2380 "dictionary.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = __ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best;
      $dest$ = $310;
      $stop$ = $src$ + 16;
      if (($dest$%4) == ($src$%4) && 16 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 2380 "dictionary.cpp"
      ; //@line 2381 "dictionary.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 2381 "dictionary.cpp"
    return;
  }
  

  function __Z21ApplySpecialAttributeP10TranslatorPci($tr, $phonemes, $dict_flags) {
    ;
    var __label__;
  
    var $tr_addr;
    var $phonemes_addr;
    var $dict_flags_addr;
    var $len;
    var $p_end;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $dict_flags_addr=$dict_flags;
    var $0=$dict_flags_addr; //@line 2737 "dictionary.cpp"
    var $and=($0) & 3145728; //@line 2737 "dictionary.cpp"
    var $cmp=((($and))|0)==0; //@line 2737 "dictionary.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 1;; } //@line 2737 "dictionary.cpp"
    $sw_epilog$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$phonemes_addr; //@line 2740 "dictionary.cpp"
        var $call=_strlen($1); //@line 2740 "dictionary.cpp"
        $len=$call; //@line 2740 "dictionary.cpp"
        var $2=$len; //@line 2741 "dictionary.cpp"
        var $sub=((($2)-1)&4294967295); //@line 2741 "dictionary.cpp"
        var $3=$phonemes_addr; //@line 2741 "dictionary.cpp"
        var $arrayidx=(($3+$sub)&4294967295); //@line 2741 "dictionary.cpp"
        $p_end=$arrayidx; //@line 2741 "dictionary.cpp"
        var $4=$tr_addr; //@line 2743 "dictionary.cpp"
        var $translator_name=(($4+280)&4294967295); //@line 2743 "dictionary.cpp"
        var $5=HEAP32[(($translator_name)>>2)]; //@line 2743 "dictionary.cpp"
        var $cond=((($5))|0)==29295; //@line 2743 "dictionary.cpp"
        if (!($cond)) { __label__ = 4;break $sw_epilog$$if_end$2; } //@line 2743 "dictionary.cpp"
  
        var $6=$p_end; //@line 2760 "dictionary.cpp"
        var $arrayidx1=(($6)&4294967295); //@line 2760 "dictionary.cpp"
        var $7=HEAP8[($arrayidx1)]; //@line 2760 "dictionary.cpp"
        var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 2760 "dictionary.cpp"
        var $call2=__Z11PhonemeCodej(106); //@line 2760 "dictionary.cpp"
        var $cmp3=((($conv))|0)==((($call2))|0); //@line 2760 "dictionary.cpp"
        if (!($cmp3)) { __label__ = 4;break $sw_epilog$$if_end$2; } //@line 2760 "dictionary.cpp"
  
        var $8=$p_end; //@line 2763 "dictionary.cpp"
        var $arrayidx5=(($8)&4294967295); //@line 2763 "dictionary.cpp"
        HEAP8[($arrayidx5)]=6; //@line 2763 "dictionary.cpp"
        var $call6=__Z11PhonemeCodej(105); //@line 2764 "dictionary.cpp"
        var $conv7=((($call6)) & 255); //@line 2764 "dictionary.cpp"
        var $9=$p_end; //@line 2764 "dictionary.cpp"
        var $arrayidx8=(($9+1)&4294967295); //@line 2764 "dictionary.cpp"
        HEAP8[($arrayidx8)]=$conv7; //@line 2764 "dictionary.cpp"
        var $10=$p_end; //@line 2765 "dictionary.cpp"
        var $arrayidx9=(($10+2)&4294967295); //@line 2765 "dictionary.cpp"
        HEAP8[($arrayidx9)]=0; //@line 2765 "dictionary.cpp"
        ; //@line 2766 "dictionary.cpp"
      }
    } while(0);
  
    ;
    return; //@line 2769 "dictionary.cpp"
    return;
  }
  

  function __Z22ApplySpecialAttribute2P10TranslatorPci($tr, $phonemes, $dict_flags) {
    ;
    var __label__;
  
    var $tr_addr;
    var $phonemes_addr;
    var $dict_flags_addr;
    var $ix;
    var $len;
    var $p;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $dict_flags_addr=$dict_flags;
    var $0=$phonemes_addr; //@line 2701 "dictionary.cpp"
    var $call=_strlen($0); //@line 2701 "dictionary.cpp"
    $len=$call; //@line 2701 "dictionary.cpp"
    var $1=$tr_addr; //@line 2703 "dictionary.cpp"
    var $langopts=(($1)&4294967295); //@line 2703 "dictionary.cpp"
    var $param=(($langopts+24)&4294967295); //@line 2703 "dictionary.cpp"
    var $arrayidx=(($param+60)&4294967295); //@line 2703 "dictionary.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 2703 "dictionary.cpp"
    var $and=($2) & 2; //@line 2703 "dictionary.cpp"
    var $tobool=((($and))|0)!=0; //@line 2703 "dictionary.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 14;; } //@line 2703 "dictionary.cpp"
    $if_then$$if_end37$2: do { 
      if (__label__ == 1) {
  
        $ix=0; //@line 2705 "dictionary.cpp"
        ; //@line 2705 "dictionary.cpp"
        while(1) { 
  
          var $3=$ix; //@line 2705 "dictionary.cpp"
          var $4=$len; //@line 2705 "dictionary.cpp"
          var $sub=((($4)-1)&4294967295); //@line 2705 "dictionary.cpp"
          var $cmp=((($3))|0) < ((($sub))|0); //@line 2705 "dictionary.cpp"
          if (!($cmp)) { __label__ = 14;break $if_then$$if_end37$2; } //@line 2705 "dictionary.cpp"
  
          var $5=$ix; //@line 2707 "dictionary.cpp"
          var $6=$phonemes_addr; //@line 2707 "dictionary.cpp"
          var $arrayidx1=(($6+$5)&4294967295); //@line 2707 "dictionary.cpp"
          var $7=HEAP8[($arrayidx1)]; //@line 2707 "dictionary.cpp"
          var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 2707 "dictionary.cpp"
          var $cmp2=((($conv))|0)==6; //@line 2707 "dictionary.cpp"
          var $8=$ix; //@line 2709 "dictionary.cpp"
          var $add=((($8)+1)&4294967295); //@line 2709 "dictionary.cpp"
          if ($cmp2) { __label__ = 4;break ; } //@line 2707 "dictionary.cpp"
  
          $ix=$add; //@line 2705 "dictionary.cpp"
          __label__ = 2;continue ; //@line 2705 "dictionary.cpp"
        }
  
        var $9=$phonemes_addr; //@line 2709 "dictionary.cpp"
        var $arrayidx4=(($9+$add)&4294967295); //@line 2709 "dictionary.cpp"
        $p=$arrayidx4; //@line 2709 "dictionary.cpp"
        var $10=$dict_flags_addr; //@line 2710 "dictionary.cpp"
        var $and5=($10) & 2097152; //@line 2710 "dictionary.cpp"
        var $cmp6=((($and5))|0)!=0; //@line 2710 "dictionary.cpp"
        var $11=$p; //@line 2712 "dictionary.cpp"
        var $12=HEAP8[($11)]; //@line 2712 "dictionary.cpp"
        var $conv8=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 2712 "dictionary.cpp"
        if ($cmp6) { __label__ = 5;; } else { __label__ = 9;; } //@line 2710 "dictionary.cpp"
        if (__label__ == 5) {
  
          var $call9=__Z11PhonemeCodej(69); //@line 2712 "dictionary.cpp"
          var $cmp10=((($conv8))|0)==((($call9))|0); //@line 2712 "dictionary.cpp"
          if ($cmp10) { __label__ = 6;; } else { __label__ = 7;; } //@line 2712 "dictionary.cpp"
          if (__label__ == 6) {
  
            var $call12=__Z11PhonemeCodej(101); //@line 2713 "dictionary.cpp"
            var $conv13=((($call12)) & 255); //@line 2713 "dictionary.cpp"
            var $13=$p; //@line 2713 "dictionary.cpp"
            HEAP8[($13)]=$conv13; //@line 2713 "dictionary.cpp"
            ; //@line 2713 "dictionary.cpp"
          }
  
          var $14=$p; //@line 2714 "dictionary.cpp"
          var $15=HEAP8[($14)]; //@line 2714 "dictionary.cpp"
          var $conv14=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 2714 "dictionary.cpp"
          var $call15=__Z11PhonemeCodej(79); //@line 2714 "dictionary.cpp"
          var $cmp16=((($conv14))|0)==((($call15))|0); //@line 2714 "dictionary.cpp"
          if (!($cmp16)) { __label__ = 14;break $if_then$$if_end37$2; } //@line 2714 "dictionary.cpp"
  
          var $call18=__Z11PhonemeCodej(111); //@line 2715 "dictionary.cpp"
          var $conv19=((($call18)) & 255); //@line 2715 "dictionary.cpp"
          var $16=$p; //@line 2715 "dictionary.cpp"
          HEAP8[($16)]=$conv19; //@line 2715 "dictionary.cpp"
          ; //@line 2715 "dictionary.cpp"
        }
        else if (__label__ == 9) {
  
          var $call22=__Z11PhonemeCodej(101); //@line 2719 "dictionary.cpp"
          var $cmp23=((($conv8))|0)==((($call22))|0); //@line 2719 "dictionary.cpp"
          if ($cmp23) { __label__ = 10;; } else { __label__ = 11;; } //@line 2719 "dictionary.cpp"
          if (__label__ == 10) {
  
            var $call25=__Z11PhonemeCodej(69); //@line 2720 "dictionary.cpp"
            var $conv26=((($call25)) & 255); //@line 2720 "dictionary.cpp"
            var $17=$p; //@line 2720 "dictionary.cpp"
            HEAP8[($17)]=$conv26; //@line 2720 "dictionary.cpp"
            ; //@line 2720 "dictionary.cpp"
          }
  
          var $18=$p; //@line 2721 "dictionary.cpp"
          var $19=HEAP8[($18)]; //@line 2721 "dictionary.cpp"
          var $conv28=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 2721 "dictionary.cpp"
          var $call29=__Z11PhonemeCodej(111); //@line 2721 "dictionary.cpp"
          var $cmp30=((($conv28))|0)==((($call29))|0); //@line 2721 "dictionary.cpp"
          if (!($cmp30)) { __label__ = 14;break $if_then$$if_end37$2; } //@line 2721 "dictionary.cpp"
  
          var $call32=__Z11PhonemeCodej(79); //@line 2722 "dictionary.cpp"
          var $conv33=((($call32)) & 255); //@line 2722 "dictionary.cpp"
          var $20=$p; //@line 2722 "dictionary.cpp"
          HEAP8[($20)]=$conv33; //@line 2722 "dictionary.cpp"
          ; //@line 2722 "dictionary.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 2728 "dictionary.cpp"
    return;
  }
  

  function __Z17TransposeAlphabetP10TranslatorPc($tr, $text) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $text_addr;
    var $c=__stackBase__;
    var $c2;
    var $ix;
    var $offset;
    var $min;
    var $max;
    var $p;
    var $p2;
    var $all_alpha;
    var $bits;
    var $acc;
    var $pairs_start;
    var $pairs_list;
    $tr_addr=$tr;
    $text_addr=$text;
    var $0=$text_addr; //@line 2790 "dictionary.cpp"
    $p=$0; //@line 2790 "dictionary.cpp"
    var $1=$text_addr; //@line 2791 "dictionary.cpp"
    $p2=$1; //@line 2791 "dictionary.cpp"
    $all_alpha=1; //@line 2792 "dictionary.cpp"
    var $2=$tr_addr; //@line 2798 "dictionary.cpp"
    var $transpose_min=(($2+288)&4294967295); //@line 2798 "dictionary.cpp"
    var $3=HEAP32[(($transpose_min)>>2)]; //@line 2798 "dictionary.cpp"
    var $sub=((($3)-1)&4294967295); //@line 2798 "dictionary.cpp"
    $offset=$sub; //@line 2798 "dictionary.cpp"
    var $4=$tr_addr; //@line 2799 "dictionary.cpp"
    var $transpose_min1=(($4+288)&4294967295); //@line 2799 "dictionary.cpp"
    var $5=HEAP32[(($transpose_min1)>>2)]; //@line 2799 "dictionary.cpp"
    $min=$5; //@line 2799 "dictionary.cpp"
    var $6=$tr_addr; //@line 2800 "dictionary.cpp"
    var $transpose_max=(($6+284)&4294967295); //@line 2800 "dictionary.cpp"
    var $7=HEAP32[(($transpose_max)>>2)]; //@line 2800 "dictionary.cpp"
    $max=$7; //@line 2800 "dictionary.cpp"
    var $8=$max; //@line 2802 "dictionary.cpp"
    var $9=$min; //@line 2802 "dictionary.cpp"
    var $_neg=(((-($9)))&4294967295);
    var $sub2=((($8)+2)&4294967295); //@line 2802 "dictionary.cpp"
    var $add=((($sub2)+($_neg))&4294967295); //@line 2802 "dictionary.cpp"
    $pairs_start=$add; //@line 2802 "dictionary.cpp"
    ; //@line 2804 "dictionary.cpp"
    $do_body$2: while(1) { 
  
      var $10=$p; //@line 2805 "dictionary.cpp"
      var $call=__Z7utf8_inPiPKc($c, $10); //@line 2805 "dictionary.cpp"
      var $11=$p; //@line 2805 "dictionary.cpp"
      var $add_ptr=(($11+$call)&4294967295); //@line 2805 "dictionary.cpp"
      $p=$add_ptr; //@line 2805 "dictionary.cpp"
      var $12=HEAP32[(($c)>>2)]; //@line 2806 "dictionary.cpp"
      var $13=$min; //@line 2806 "dictionary.cpp"
      var $cmp=((($12))|0) >= ((($13))|0); //@line 2806 "dictionary.cpp"
      if ($cmp) { __lastLabel__ = 1; __label__ = 2;; } else { __lastLabel__ = 1; __label__ = 4;; } //@line 2806 "dictionary.cpp"
      $land_lhs_true$$if_else$4: do { 
        if (__label__ == 2) {
  
          var $14=HEAP32[(($c)>>2)]; //@line 2806 "dictionary.cpp"
          var $15=$max; //@line 2806 "dictionary.cpp"
          var $cmp3=((($14))|0) <= ((($15))|0); //@line 2806 "dictionary.cpp"
          if ($cmp3) { __lastLabel__ = 2; ; } else { __lastLabel__ = 2; __label__ = 4;break $land_lhs_true$$if_else$4; } //@line 2806 "dictionary.cpp"
  
          var $16=HEAP32[(($c)>>2)]; //@line 2808 "dictionary.cpp"
          var $17=$offset; //@line 2808 "dictionary.cpp"
          var $sub4=((($16)-($17))&4294967295); //@line 2808 "dictionary.cpp"
          var $conv=((($sub4)) & 255); //@line 2808 "dictionary.cpp"
          var $18=$p2; //@line 2808 "dictionary.cpp"
          var $incdec_ptr=(($18+1)&4294967295); //@line 2808 "dictionary.cpp"
          $p2=$incdec_ptr; //@line 2808 "dictionary.cpp"
          HEAP8[($18)]=$conv; //@line 2808 "dictionary.cpp"
          __label__ = 6;break $land_lhs_true$$if_else$4; //@line 2809 "dictionary.cpp"
        }
      } while(0);
      $do_cond$$if_else$7: do { 
        if (__label__ == 4) {
  
          var $19=__lastLabel__ == 2 ? $14 : ($12); //@line 2811 "dictionary.cpp"
          var $cmp5=((($19))|0)!=0; //@line 2811 "dictionary.cpp"
          if (!($cmp5)) { __label__ = 6;break $do_cond$$if_else$7; } //@line 2811 "dictionary.cpp"
  
          var $20=HEAP32[(($c)>>2)]; //@line 2813 "dictionary.cpp"
          var $21=$p2; //@line 2813 "dictionary.cpp"
          var $call7=__Z8utf8_outjPc($20, $21); //@line 2813 "dictionary.cpp"
          var $22=$p2; //@line 2813 "dictionary.cpp"
          var $add_ptr8=(($22+$call7)&4294967295); //@line 2813 "dictionary.cpp"
          $p2=$add_ptr8; //@line 2813 "dictionary.cpp"
          $all_alpha=0; //@line 2814 "dictionary.cpp"
          ; //@line 2815 "dictionary.cpp"
        }
      } while(0);
  
      var $23=HEAP32[(($c)>>2)]; //@line 2816 "dictionary.cpp"
      var $cmp10=((($23))|0)!=0; //@line 2816 "dictionary.cpp"
      if ($cmp10) { __label__ = 1;continue $do_body$2; } else { __label__ = 7;break $do_body$2; } //@line 2816 "dictionary.cpp"
    }
  
    var $24=$p2; //@line 2817 "dictionary.cpp"
    HEAP8[($24)]=0; //@line 2817 "dictionary.cpp"
    var $25=$all_alpha; //@line 2819 "dictionary.cpp"
    var $tobool=((($25))|0)!=0; //@line 2819 "dictionary.cpp"
    if ($tobool) { __label__ = 8;; } else { __label__ = 21;; } //@line 2819 "dictionary.cpp"
    if (__label__ == 8) {
  
      $acc=0; //@line 2822 "dictionary.cpp"
      $bits=0; //@line 2823 "dictionary.cpp"
      var $26=$text_addr; //@line 2825 "dictionary.cpp"
      $p=$26; //@line 2825 "dictionary.cpp"
      var $27=$text_addr; //@line 2826 "dictionary.cpp"
      $p2=$27; //@line 2826 "dictionary.cpp"
      var $28=$p; //@line 2827 "dictionary.cpp"
      var $incdec_ptr121=(($28+1)&4294967295); //@line 2827 "dictionary.cpp"
      $p=$incdec_ptr121; //@line 2827 "dictionary.cpp"
      var $29=HEAP8[($28)]; //@line 2827 "dictionary.cpp"
      var $conv132=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 2827 "dictionary.cpp"
      HEAP32[(($c)>>2)]=$conv132; //@line 2827 "dictionary.cpp"
      var $cmp143=((($conv132))|0)!=0; //@line 2827 "dictionary.cpp"
      if ($cmp143) { __label__ = 9;; } else { __label__ = 18;; } //@line 2827 "dictionary.cpp"
      $while_body$$while_end$14: do { 
        if (__label__ == 9) {
          $while_body$15: while(1) { 
  
            var $30=$tr_addr; //@line 2829 "dictionary.cpp"
            var $frequent_pairs=(($30+8268)&4294967295); //@line 2829 "dictionary.cpp"
            var $31=HEAP32[(($frequent_pairs)>>2)]; //@line 2829 "dictionary.cpp"
            $pairs_list=$31; //@line 2829 "dictionary.cpp"
            var $cmp15=((($31))|0)!=0; //@line 2829 "dictionary.cpp"
            if ($cmp15) { __label__ = 10;; } else { __label__ = 15;; } //@line 2829 "dictionary.cpp"
            $if_then16$$if_end28$17: do { 
              if (__label__ == 10) {
  
                var $32=HEAP32[(($c)>>2)]; //@line 2831 "dictionary.cpp"
                var $33=$p; //@line 2831 "dictionary.cpp"
                var $34=HEAP8[($33)]; //@line 2831 "dictionary.cpp"
                var $conv17=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt)); //@line 2831 "dictionary.cpp"
                var $shl=((($conv17)*256)&4294967295); //@line 2831 "dictionary.cpp"
                var $add18=((($shl)+($32))&4294967295); //@line 2831 "dictionary.cpp"
                $c2=$add18; //@line 2831 "dictionary.cpp"
                $ix=0; //@line 2832 "dictionary.cpp"
                ; //@line 2832 "dictionary.cpp"
                while(1) { 
  
                  var $35=$c2; //@line 2832 "dictionary.cpp"
                  var $36=$ix; //@line 2832 "dictionary.cpp"
                  var $37=$pairs_list; //@line 2832 "dictionary.cpp"
                  var $arrayidx=(($37+2*$36)&4294967295); //@line 2832 "dictionary.cpp"
                  var $38=HEAP16[(($arrayidx)>>1)]; //@line 2832 "dictionary.cpp"
                  var $conv19=(tempInt=(($38)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2832 "dictionary.cpp"
                  var $cmp20=((($35))|0) >= ((($conv19))|0); //@line 2832 "dictionary.cpp"
                  if (!($cmp20)) { __label__ = 15;break $if_then16$$if_end28$17; } //@line 2832 "dictionary.cpp"
  
                  var $39=$c2; //@line 2834 "dictionary.cpp"
                  var $40=$ix; //@line 2834 "dictionary.cpp"
                  var $41=$pairs_list; //@line 2834 "dictionary.cpp"
                  var $arrayidx21=(($41+2*$40)&4294967295); //@line 2834 "dictionary.cpp"
                  var $42=HEAP16[(($arrayidx21)>>1)]; //@line 2834 "dictionary.cpp"
                  var $conv22=(tempInt=(($42)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2834 "dictionary.cpp"
                  var $cmp23=((($39))|0)==((($conv22))|0); //@line 2834 "dictionary.cpp"
                  var $43=$ix; //@line 2837 "dictionary.cpp"
                  if ($cmp23) { __label__ = 13;break ; } //@line 2834 "dictionary.cpp"
  
                  var $inc=((($43)+1)&4294967295); //@line 2832 "dictionary.cpp"
                  $ix=$inc; //@line 2832 "dictionary.cpp"
                  __label__ = 11;continue ; //@line 2832 "dictionary.cpp"
                }
  
                var $44=$pairs_start; //@line 2837 "dictionary.cpp"
                var $add25=((($44)+($43))&4294967295); //@line 2837 "dictionary.cpp"
                HEAP32[(($c)>>2)]=$add25; //@line 2837 "dictionary.cpp"
                var $45=$p; //@line 2838 "dictionary.cpp"
                var $incdec_ptr26=(($45+1)&4294967295); //@line 2838 "dictionary.cpp"
                $p=$incdec_ptr26; //@line 2838 "dictionary.cpp"
                ; //@line 2839 "dictionary.cpp"
              }
            } while(0);
  
            var $46=$acc; //@line 2843 "dictionary.cpp"
            var $shl29=((($46)*64)&4294967295); //@line 2843 "dictionary.cpp"
            var $47=HEAP32[(($c)>>2)]; //@line 2843 "dictionary.cpp"
            var $and=($47) & 63; //@line 2843 "dictionary.cpp"
            var $add30=((($and)+($shl29))&4294967295); //@line 2843 "dictionary.cpp"
            $acc=$add30; //@line 2843 "dictionary.cpp"
            var $48=$bits; //@line 2844 "dictionary.cpp"
            var $add31=((($48)+6)&4294967295); //@line 2844 "dictionary.cpp"
            $bits=$add31; //@line 2844 "dictionary.cpp"
            var $cmp32=((($add31))|0) >= 8; //@line 2846 "dictionary.cpp"
            if ($cmp32) { __label__ = 16;; } else { __label__ = 17;; } //@line 2846 "dictionary.cpp"
            if (__label__ == 16) {
  
              var $49=$bits; //@line 2848 "dictionary.cpp"
              var $sub34=((($49)-8)&4294967295); //@line 2848 "dictionary.cpp"
              $bits=$sub34; //@line 2848 "dictionary.cpp"
              var $50=$acc; //@line 2849 "dictionary.cpp"
              var $51=$bits; //@line 2849 "dictionary.cpp"
              var $shr=($50) >> ((($51))|0); //@line 2849 "dictionary.cpp"
              var $conv35=((($shr)) & 255); //@line 2849 "dictionary.cpp"
              var $52=$p2; //@line 2849 "dictionary.cpp"
              var $incdec_ptr36=(($52+1)&4294967295); //@line 2849 "dictionary.cpp"
              $p2=$incdec_ptr36; //@line 2849 "dictionary.cpp"
              HEAP8[($52)]=$conv35; //@line 2849 "dictionary.cpp"
              ; //@line 2850 "dictionary.cpp"
            }
  
            var $53=$p; //@line 2827 "dictionary.cpp"
            var $incdec_ptr12=(($53+1)&4294967295); //@line 2827 "dictionary.cpp"
            $p=$incdec_ptr12; //@line 2827 "dictionary.cpp"
            var $54=HEAP8[($53)]; //@line 2827 "dictionary.cpp"
            var $conv13=(tempInt=(($54)),(tempInt>=128?tempInt-256:tempInt)); //@line 2827 "dictionary.cpp"
            HEAP32[(($c)>>2)]=$conv13; //@line 2827 "dictionary.cpp"
            var $cmp14=((($conv13))|0)!=0; //@line 2827 "dictionary.cpp"
            if ($cmp14) { __label__ = 9;continue $while_body$15; } else { __label__ = 18;break $while_body$$while_end$14; } //@line 2827 "dictionary.cpp"
          }
        }
      } while(0);
  
      var $55=$bits; //@line 2852 "dictionary.cpp"
      var $cmp38=((($55))|0) > 0; //@line 2852 "dictionary.cpp"
      if ($cmp38) { __label__ = 19;; } else { __label__ = 20;; } //@line 2852 "dictionary.cpp"
      if (__label__ == 19) {
  
        var $56=$acc; //@line 2854 "dictionary.cpp"
        var $57=$bits; //@line 2854 "dictionary.cpp"
        var $sub40=((8-($57))&4294967295); //@line 2854 "dictionary.cpp"
        var $shl41=($56) << ($sub40); //@line 2854 "dictionary.cpp"
        var $conv42=((($shl41)) & 255); //@line 2854 "dictionary.cpp"
        var $58=$p2; //@line 2854 "dictionary.cpp"
        var $incdec_ptr43=(($58+1)&4294967295); //@line 2854 "dictionary.cpp"
        $p2=$incdec_ptr43; //@line 2854 "dictionary.cpp"
        HEAP8[($58)]=$conv42; //@line 2854 "dictionary.cpp"
        ; //@line 2855 "dictionary.cpp"
      }
  
      var $59=$p2; //@line 2856 "dictionary.cpp"
      HEAP8[($59)]=0; //@line 2856 "dictionary.cpp"
      var $60=$p2; //@line 2857 "dictionary.cpp"
      var $61=$text_addr; //@line 2857 "dictionary.cpp"
      var $sub_ptr_lhs_cast=($60); //@line 2857 "dictionary.cpp"
      var $sub_ptr_rhs_cast=($61); //@line 2857 "dictionary.cpp"
      var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2857 "dictionary.cpp"
      var $or=($sub_ptr_sub) | 64; //@line 2857 "dictionary.cpp"
      $retval=$or; //@line 2857 "dictionary.cpp"
      ; //@line 2857 "dictionary.cpp"
    }
    else if (__label__ == 21) {
  
      var $62=$p2; //@line 2859 "dictionary.cpp"
      var $63=$text_addr; //@line 2859 "dictionary.cpp"
      var $sub_ptr_lhs_cast46=($62); //@line 2859 "dictionary.cpp"
      var $sub_ptr_rhs_cast47=($63); //@line 2859 "dictionary.cpp"
      var $sub_ptr_sub48=((($sub_ptr_lhs_cast46)-($sub_ptr_rhs_cast47))&4294967295); //@line 2859 "dictionary.cpp"
      $retval=$sub_ptr_sub48; //@line 2859 "dictionary.cpp"
      ; //@line 2859 "dictionary.cpp"
    }
  
    var $64=$retval; //@line 2860 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $64; //@line 2860 "dictionary.cpp"
    return null;
  }
  

  function __Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($tr, $wordptr, $ph_out, $flags, $end_flags, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 164; _memset(__stackBase__, 0, 164);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $wordptr_addr;
    var $ph_out_addr;
    var $flags_addr;
    var $end_flags_addr;
    var $wtab_addr;
    var $length;
    var $found;
    var $word1;
    var $word2;
    var $c;
    var $nbytes;
    var $len;
    var $word=__stackBase__;
    var $letter=__stackBase__+160;
    $tr_addr=$tr;
    $wordptr_addr=$wordptr;
    $ph_out_addr=$ph_out;
    $flags_addr=$flags;
    $end_flags_addr=$end_flags;
    $wtab_addr=$wtab;
    $length=0; //@line 3221 "dictionary.cpp"
    var $0=$wordptr_addr; //@line 3222 "dictionary.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 3222 "dictionary.cpp"
    $word1=$1; //@line 3222 "dictionary.cpp"
    $word2=$1; //@line 3222 "dictionary.cpp"
    ; //@line 3224 "dictionary.cpp"
    $while_cond$2: while(1) { 
  
      var $2=$word2; //@line 3224 "dictionary.cpp"
      var $call=__Z11utf8_nbytesPKc($2); //@line 3224 "dictionary.cpp"
      $nbytes=$call; //@line 3224 "dictionary.cpp"
      var $3=$word2; //@line 3224 "dictionary.cpp"
      var $arrayidx=(($3+$call)&4294967295); //@line 3224 "dictionary.cpp"
      var $4=HEAP8[($arrayidx)]; //@line 3224 "dictionary.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 3224 "dictionary.cpp"
      var $cmp=((($conv))|0)==32; //@line 3224 "dictionary.cpp"
      if (!($cmp)) { __label__ = 2;break $while_cond$2; } //@line 3224 "dictionary.cpp"
  
      var $6=$nbytes; //@line 3224 "dictionary.cpp"
      var $add=((($6)+1)&4294967295); //@line 3224 "dictionary.cpp"
      var $7=$word2; //@line 3224 "dictionary.cpp"
      var $arrayidx1=(($7+$add)&4294967295); //@line 3224 "dictionary.cpp"
      var $8=HEAP8[($arrayidx1)]; //@line 3224 "dictionary.cpp"
      var $conv2=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 3224 "dictionary.cpp"
      var $cmp3=((($conv2))|0)==46; //@line 3224 "dictionary.cpp"
      var $9=$length; //@line 3228 "dictionary.cpp"
      if ($cmp3) { __lastLabel__ = 3; ; } else { __lastLabel__ = 3; __label__ = 5;break $while_cond$2; }
  
      var $arrayidx4=(($word+$9)&4294967295); //@line 3228 "dictionary.cpp"
      var $10=$word2; //@line 3228 "dictionary.cpp"
      var $11=$nbytes; //@line 3228 "dictionary.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $10;
      $dest$ = $arrayidx4;
      $stop$ = $src$ + $11;
      if (($dest$%4) == ($src$%4) && $11 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 3228 "dictionary.cpp"
      var $12=$nbytes; //@line 3229 "dictionary.cpp"
      var $13=$length; //@line 3229 "dictionary.cpp"
      var $add5=((($13)+($12))&4294967295); //@line 3229 "dictionary.cpp"
      $length=$add5; //@line 3229 "dictionary.cpp"
      var $14=$length; //@line 3230 "dictionary.cpp"
      var $inc=((($14)+1)&4294967295); //@line 3230 "dictionary.cpp"
      $length=$inc; //@line 3230 "dictionary.cpp"
      var $arrayidx6=(($word+$14)&4294967295); //@line 3230 "dictionary.cpp"
      HEAP8[($arrayidx6)]=46; //@line 3230 "dictionary.cpp"
      var $15=$nbytes; //@line 3231 "dictionary.cpp"
      var $add7=((($15)+3)&4294967295); //@line 3231 "dictionary.cpp"
      var $16=$word2; //@line 3231 "dictionary.cpp"
      var $add_ptr=(($16+$add7)&4294967295); //@line 3231 "dictionary.cpp"
      $word2=$add_ptr; //@line 3231 "dictionary.cpp"
      __label__ = 1;continue $while_cond$2; //@line 3232 "dictionary.cpp"
    }
    if (__label__ == 2) {
  
      var $5=$length; //@line 3228 "dictionary.cpp"
      __lastLabel__ = 2; ;
    }
  
    var $17=__lastLabel__ == 2 ? $5 : ($9);
    var $cmp8=((($17))|0) > 0; //@line 3233 "dictionary.cpp"
    if ($cmp8) { __label__ = 6;; } else { __label__ = 12;; } //@line 3233 "dictionary.cpp"
    $if_then$$if_end26$9: do { 
      if (__label__ == 6) {
  
        $nbytes=0; //@line 3236 "dictionary.cpp"
        ; //@line 3237 "dictionary.cpp"
        while(1) { 
  
          var $18=$nbytes; //@line 3237 "dictionary.cpp"
          var $19=$word2; //@line 3237 "dictionary.cpp"
          var $arrayidx10=(($19+$18)&4294967295); //@line 3237 "dictionary.cpp"
          var $20=HEAPU8[($arrayidx10)]; //@line 3237 "dictionary.cpp"
          $c=$20; //@line 3237 "dictionary.cpp"
          var $conv11=((($20))&255); //@line 3237 "dictionary.cpp"
          var $cmp12=((($conv11))|0)!=0; //@line 3237 "dictionary.cpp"
          if (!($cmp12)) { __label__ = 10;break ; } //@line 3237 "dictionary.cpp"
  
          var $21=$c; //@line 3237 "dictionary.cpp"
          var $conv14=((($21))&255); //@line 3237 "dictionary.cpp"
          var $cmp15=((($conv14))|0)!=32; //@line 3237 "dictionary.cpp"
          if (!($cmp15)) { __label__ = 10;break ; }
  
          var $22=$nbytes; //@line 3239 "dictionary.cpp"
          var $inc18=((($22)+1)&4294967295); //@line 3239 "dictionary.cpp"
          $nbytes=$inc18; //@line 3239 "dictionary.cpp"
          __label__ = 7;continue ; //@line 3240 "dictionary.cpp"
        }
  
        var $23=$length; //@line 3241 "dictionary.cpp"
        var $arrayidx20=(($word+$23)&4294967295); //@line 3241 "dictionary.cpp"
        var $24=$word2; //@line 3241 "dictionary.cpp"
        var $25=$nbytes; //@line 3241 "dictionary.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $24;
        $dest$ = $arrayidx20;
        $stop$ = $src$ + $25;
        if (($dest$%4) == ($src$%4) && $25 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 3241 "dictionary.cpp"
        var $26=$length; //@line 3242 "dictionary.cpp"
        var $27=$nbytes; //@line 3242 "dictionary.cpp"
        var $add21=((($27)+($26))&4294967295); //@line 3242 "dictionary.cpp"
        var $arrayidx22=(($word+$add21)&4294967295); //@line 3242 "dictionary.cpp"
        HEAP8[($arrayidx22)]=0; //@line 3242 "dictionary.cpp"
        var $28=$tr_addr; //@line 3243 "dictionary.cpp"
        var $arraydecay=(($word)&4294967295); //@line 3243 "dictionary.cpp"
        var $29=$word2; //@line 3243 "dictionary.cpp"
        var $30=$ph_out_addr; //@line 3243 "dictionary.cpp"
        var $31=$flags_addr; //@line 3243 "dictionary.cpp"
        var $32=$end_flags_addr; //@line 3243 "dictionary.cpp"
        var $33=$wtab_addr; //@line 3243 "dictionary.cpp"
        var $call23=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($28, $arraydecay, $29, $30, $31, $32, $33); //@line 3243 "dictionary.cpp"
        $found=$call23; //@line 3243 "dictionary.cpp"
        var $tobool=((($call23))|0)!=0; //@line 3244 "dictionary.cpp"
        if (!($tobool)) { __label__ = 12;break $if_then$$if_end26$9; } //@line 3244 "dictionary.cpp"
  
        var $34=$flags_addr; //@line 3247 "dictionary.cpp"
        var $arrayidx25=(($34)&4294967295); //@line 3247 "dictionary.cpp"
        var $35=HEAP32[(($arrayidx25)>>2)]; //@line 3247 "dictionary.cpp"
        var $or=($35) | 128; //@line 3247 "dictionary.cpp"
        HEAP32[(($arrayidx25)>>2)]=$or; //@line 3247 "dictionary.cpp"
        var $36=$length; //@line 3248 "dictionary.cpp"
        HEAP32[((_dictionary_skipwords)>>2)]=$36; //@line 3248 "dictionary.cpp"
        $retval=1; //@line 3249 "dictionary.cpp"
        __label__ = 50;break $if_then$$if_end26$9; //@line 3249 "dictionary.cpp"
      }
    } while(0);
    if (__label__ == 12) {
  
      $length=0; //@line 3253 "dictionary.cpp"
      __lastLabel__ = 12; ; //@line 3253 "dictionary.cpp"
      $for_cond$19: while(1) { 
  
        var $37=__lastLabel__ == 19 ? $inc45 : (0); //@line 3253 "dictionary.cpp"
        var $cmp27=((($37))|0) < 159; //@line 3253 "dictionary.cpp"
        if (!($cmp27)) { __label__ = 20;break $for_cond$19; } //@line 3253 "dictionary.cpp"
  
        var $38=$word1; //@line 3255 "dictionary.cpp"
        var $incdec_ptr=(($38+1)&4294967295); //@line 3255 "dictionary.cpp"
        $word1=$incdec_ptr; //@line 3255 "dictionary.cpp"
        var $39=HEAPU8[($38)]; //@line 3255 "dictionary.cpp"
        $c=$39; //@line 3255 "dictionary.cpp"
        var $conv28=((($39))&255); //@line 3255 "dictionary.cpp"
        var $cmp29=((($conv28))|0)==0; //@line 3255 "dictionary.cpp"
        if ($cmp29) { __label__ = 20;break $for_cond$19; } //@line 3255 "dictionary.cpp"
  
        var $40=$c; //@line 3255 "dictionary.cpp"
        var $conv30=((($40))&255); //@line 3255 "dictionary.cpp"
        var $cmp31=((($conv30))|0)==32; //@line 3255 "dictionary.cpp"
        if ($cmp31) { __label__ = 20;break $for_cond$19; } //@line 3255 "dictionary.cpp"
  
        var $41=$c; //@line 3258 "dictionary.cpp"
        var $conv34=((($41))&255); //@line 3258 "dictionary.cpp"
        var $cmp35=((($conv34))|0)==46; //@line 3258 "dictionary.cpp"
        if ($cmp35) { __label__ = 17;; } else { __label__ = 19;; } //@line 3258 "dictionary.cpp"
        $land_lhs_true$$if_end43$24: do { 
          if (__label__ == 17) {
  
            var $42=$length; //@line 3258 "dictionary.cpp"
            var $cmp36=((($42))|0) > 0; //@line 3258 "dictionary.cpp"
            if (!($cmp36)) { __label__ = 19;break $land_lhs_true$$if_end43$24; } //@line 3258 "dictionary.cpp"
  
            var $43=$length; //@line 3258 "dictionary.cpp"
            var $sub=((($43)-1)&4294967295); //@line 3258 "dictionary.cpp"
            var $arrayidx38=(($word+$sub)&4294967295); //@line 3258 "dictionary.cpp"
            var $44=HEAP8[($arrayidx38)]; //@line 3258 "dictionary.cpp"
            var $conv39=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 3258 "dictionary.cpp"
            var $isdigittmp=((($conv39)-48)&4294967295); //@line 3258 "dictionary.cpp"
            var $isdigit=((($isdigittmp))>>>0) < 10; //@line 3258 "dictionary.cpp"
            var $call40=((($isdigit))&1); //@line 3258 "dictionary.cpp"
            var $tobool41=((($call40))|0)!=0; //@line 3258 "dictionary.cpp"
            if ($tobool41) { __label__ = 20;break $for_cond$19; } //@line 3258 "dictionary.cpp"
          }
        } while(0);
  
        var $45=$c; //@line 3261 "dictionary.cpp"
        var $46=$length; //@line 3261 "dictionary.cpp"
        var $arrayidx44=(($word+$46)&4294967295); //@line 3261 "dictionary.cpp"
        HEAP8[($arrayidx44)]=$45; //@line 3261 "dictionary.cpp"
        var $47=$length; //@line 3253 "dictionary.cpp"
        var $inc45=((($47)+1)&4294967295); //@line 3253 "dictionary.cpp"
        $length=$inc45; //@line 3253 "dictionary.cpp"
        __lastLabel__ = 19; __label__ = 13;continue $for_cond$19; //@line 3253 "dictionary.cpp"
      }
  
      var $48=$length; //@line 3263 "dictionary.cpp"
      var $arrayidx46=(($word+$48)&4294967295); //@line 3263 "dictionary.cpp"
      HEAP8[($arrayidx46)]=0; //@line 3263 "dictionary.cpp"
      var $49=$tr_addr; //@line 3265 "dictionary.cpp"
      var $arraydecay47=(($word)&4294967295); //@line 3265 "dictionary.cpp"
      var $50=$word1; //@line 3265 "dictionary.cpp"
      var $51=$ph_out_addr; //@line 3265 "dictionary.cpp"
      var $52=$flags_addr; //@line 3265 "dictionary.cpp"
      var $53=$end_flags_addr; //@line 3265 "dictionary.cpp"
      var $54=$wtab_addr; //@line 3265 "dictionary.cpp"
      var $call48=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($49, $arraydecay47, $50, $51, $52, $53, $54); //@line 3265 "dictionary.cpp"
      $found=$call48; //@line 3265 "dictionary.cpp"
      var $55=$flags_addr; //@line 3267 "dictionary.cpp"
      var $arrayidx49=(($55)&4294967295); //@line 3267 "dictionary.cpp"
      var $56=HEAP32[(($arrayidx49)>>2)]; //@line 3267 "dictionary.cpp"
      var $and=($56) & 134217728; //@line 3267 "dictionary.cpp"
      var $tobool50=((($and))|0)!=0; //@line 3267 "dictionary.cpp"
      if ($tobool50) { __label__ = 21;; } else { __label__ = 25;; } //@line 3267 "dictionary.cpp"
      $if_then51$$if_else66$29: do { 
        if (__label__ == 21) {
  
          var $57=$ph_out_addr; //@line 3269 "dictionary.cpp"
          var $58=$tr_addr; //@line 3269 "dictionary.cpp"
          var $phonemes_repeat=(($58+632)&4294967295); //@line 3269 "dictionary.cpp"
          var $arraydecay52=(($phonemes_repeat)&4294967295); //@line 3269 "dictionary.cpp"
          var $call53=_strcmp($57, $arraydecay52); //@line 3269 "dictionary.cpp"
          var $cmp54=((($call53))|0)==0; //@line 3269 "dictionary.cpp"
          var $59=$tr_addr; //@line 3271 "dictionary.cpp"
          if ($cmp54) { __label__ = 22;; } else { __label__ = 24;; } //@line 3269 "dictionary.cpp"
          if (__label__ == 22) {
  
            var $phonemes_repeat_count=(($59+652)&4294967295); //@line 3271 "dictionary.cpp"
            var $60=HEAP32[(($phonemes_repeat_count)>>2)]; //@line 3271 "dictionary.cpp"
            var $inc56=((($60)+1)&4294967295); //@line 3271 "dictionary.cpp"
            HEAP32[(($phonemes_repeat_count)>>2)]=$inc56; //@line 3271 "dictionary.cpp"
            var $61=$tr_addr; //@line 3272 "dictionary.cpp"
            var $phonemes_repeat_count57=(($61+652)&4294967295); //@line 3272 "dictionary.cpp"
            var $62=HEAP32[(($phonemes_repeat_count57)>>2)]; //@line 3272 "dictionary.cpp"
            var $cmp58=((($62))|0) > 3; //@line 3272 "dictionary.cpp"
            if (!($cmp58)) { __label__ = 26;break $if_then51$$if_else66$29; } //@line 3272 "dictionary.cpp"
  
            var $63=$ph_out_addr; //@line 3274 "dictionary.cpp"
            var $arrayidx60=(($63)&4294967295); //@line 3274 "dictionary.cpp"
            HEAP8[($arrayidx60)]=0; //@line 3274 "dictionary.cpp"
            ; //@line 3275 "dictionary.cpp"
          }
          else if (__label__ == 24) {
  
            var $phonemes_repeat62=(($59+632)&4294967295); //@line 3279 "dictionary.cpp"
            var $arraydecay63=(($phonemes_repeat62)&4294967295); //@line 3279 "dictionary.cpp"
            var $64=$ph_out_addr; //@line 3279 "dictionary.cpp"
            __Z8strncpy0PcPKci($arraydecay63, $64, 20); //@line 3279 "dictionary.cpp"
            var $65=$tr_addr; //@line 3280 "dictionary.cpp"
            var $phonemes_repeat_count64=(($65+652)&4294967295); //@line 3280 "dictionary.cpp"
            HEAP32[(($phonemes_repeat_count64)>>2)]=1; //@line 3280 "dictionary.cpp"
            ;
          }
        }
        else if (__label__ == 25) {
  
          var $66=$tr_addr; //@line 3285 "dictionary.cpp"
          var $phonemes_repeat_count67=(($66+652)&4294967295); //@line 3285 "dictionary.cpp"
          HEAP32[(($phonemes_repeat_count67)>>2)]=0; //@line 3285 "dictionary.cpp"
          ;
        }
      } while(0);
  
      var $67=$found; //@line 3289 "dictionary.cpp"
      var $cmp69=((($67))|0)==0; //@line 3289 "dictionary.cpp"
      if ($cmp69) { __label__ = 27;; } else { __label__ = 39;; } //@line 3289 "dictionary.cpp"
      $land_lhs_true70$$if_end117thread_pre_split$37: do { 
        if (__label__ == 27) {
  
          var $68=$flags_addr; //@line 3289 "dictionary.cpp"
          var $arrayidx71=(($68+4)&4294967295); //@line 3289 "dictionary.cpp"
          var $69=HEAP32[(($arrayidx71)>>2)]; //@line 3289 "dictionary.cpp"
          var $and72=($69) & 2048; //@line 3289 "dictionary.cpp"
          var $tobool73=((($and72))|0)!=0; //@line 3289 "dictionary.cpp"
          if ($tobool73) { __label__ = 28;; } else { __label__ = 31;; } //@line 3289 "dictionary.cpp"
          if (__label__ == 28) {
  
            var $arraydecay75=(($word)&4294967295); //@line 3292 "dictionary.cpp"
            $word2=$arraydecay75; //@line 3292 "dictionary.cpp"
            var $70=$word2; //@line 3293 "dictionary.cpp"
            var $71=HEAP8[($70)]; //@line 3293 "dictionary.cpp"
            var $conv76=(tempInt=(($71)),(tempInt>=128?tempInt-256:tempInt)); //@line 3293 "dictionary.cpp"
            var $cmp77=((($conv76))|0)==95; //@line 3293 "dictionary.cpp"
            if ($cmp77) { __label__ = 29;; } else { __label__ = 30;; } //@line 3293 "dictionary.cpp"
            if (__label__ == 29) {
  
              var $72=$word2; //@line 3293 "dictionary.cpp"
              var $incdec_ptr79=(($72+1)&4294967295); //@line 3293 "dictionary.cpp"
              $word2=$incdec_ptr79; //@line 3293 "dictionary.cpp"
              ; //@line 3293 "dictionary.cpp"
            }
  
            var $73=$word2; //@line 3294 "dictionary.cpp"
            var $call81=__Z7utf8_inPiPKc($letter, $73); //@line 3294 "dictionary.cpp"
            $len=$call81; //@line 3294 "dictionary.cpp"
            var $74=$tr_addr; //@line 3295 "dictionary.cpp"
            var $75=HEAP32[(($letter)>>2)]; //@line 3295 "dictionary.cpp"
            var $76=$ph_out_addr; //@line 3295 "dictionary.cpp"
            __Z20LookupAccentedLetterP10TranslatorjPc($74, $75, $76); //@line 3295 "dictionary.cpp"
            var $77=$word2; //@line 3296 "dictionary.cpp"
            var $78=$len; //@line 3296 "dictionary.cpp"
            var $add_ptr82=(($77+$78)&4294967295); //@line 3296 "dictionary.cpp"
            $found=$add_ptr82; //@line 3296 "dictionary.cpp"
            __lastLabel__ = 30; ; //@line 3297 "dictionary.cpp"
          }
          else if (__label__ == 31) {
  
            var $_pr=$found; //@line 3299 "dictionary.cpp"
            __lastLabel__ = 31; ;
          }
  
          var $79=__lastLabel__ == 31 ? $_pr : ($add_ptr82); //@line 3299 "dictionary.cpp"
          var $cmp84=((($79))|0)==0; //@line 3299 "dictionary.cpp"
          if (!($cmp84)) { __label__ = 39;break $land_lhs_true70$$if_end117thread_pre_split$37; } //@line 3299 "dictionary.cpp"
  
          var $80=$ph_out_addr; //@line 3301 "dictionary.cpp"
          var $arrayidx86=(($80)&4294967295); //@line 3301 "dictionary.cpp"
          HEAP8[($arrayidx86)]=0; //@line 3301 "dictionary.cpp"
          var $81=$end_flags_addr; //@line 3305 "dictionary.cpp"
          var $and87=($81) & 16; //@line 3305 "dictionary.cpp"
          var $tobool88=((($and87))|0)!=0; //@line 3305 "dictionary.cpp"
          if ($tobool88) { __label__ = 34;; } else { __label__ = 36;; } //@line 3305 "dictionary.cpp"
          $land_lhs_true89$$if_else99$47: do { 
            if (__label__ == 34) {
  
              var $82=$length; //@line 3305 "dictionary.cpp"
              var $sub90=((($82)-1)&4294967295); //@line 3305 "dictionary.cpp"
              var $arrayidx91=(($word+$sub90)&4294967295); //@line 3305 "dictionary.cpp"
              var $83=HEAP8[($arrayidx91)]; //@line 3305 "dictionary.cpp"
              var $conv92=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 3305 "dictionary.cpp"
              var $cmp93=((($conv92))|0)==101; //@line 3305 "dictionary.cpp"
              if (!($cmp93)) { __label__ = 36;break $land_lhs_true89$$if_else99$47; } //@line 3305 "dictionary.cpp"
  
              var $84=$length; //@line 3308 "dictionary.cpp"
              var $sub95=((($84)-1)&4294967295); //@line 3308 "dictionary.cpp"
              var $arrayidx96=(($word+$sub95)&4294967295); //@line 3308 "dictionary.cpp"
              HEAP8[($arrayidx96)]=0; //@line 3308 "dictionary.cpp"
              var $85=$tr_addr; //@line 3309 "dictionary.cpp"
              var $arraydecay97=(($word)&4294967295); //@line 3309 "dictionary.cpp"
              var $86=$word1; //@line 3309 "dictionary.cpp"
              var $87=$ph_out_addr; //@line 3309 "dictionary.cpp"
              var $88=$flags_addr; //@line 3309 "dictionary.cpp"
              var $89=$end_flags_addr; //@line 3309 "dictionary.cpp"
              var $90=$wtab_addr; //@line 3309 "dictionary.cpp"
              var $call98=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($85, $arraydecay97, $86, $87, $88, $89, $90); //@line 3309 "dictionary.cpp"
              $found=$call98; //@line 3309 "dictionary.cpp"
              __lastLabel__ = 35; __label__ = 40;break $land_lhs_true70$$if_end117thread_pre_split$37; //@line 3310 "dictionary.cpp"
            }
          } while(0);
  
          var $91=$end_flags_addr; //@line 3312 "dictionary.cpp"
          var $and100=($91) & 4096; //@line 3312 "dictionary.cpp"
          var $tobool101=((($and100))|0)!=0; //@line 3312 "dictionary.cpp"
          if (!($tobool101)) { __label__ = 39;break $land_lhs_true70$$if_end117thread_pre_split$37; } //@line 3312 "dictionary.cpp"
  
          var $92=$length; //@line 3312 "dictionary.cpp"
          var $sub103=((($92)-1)&4294967295); //@line 3312 "dictionary.cpp"
          var $arrayidx104=(($word+$sub103)&4294967295); //@line 3312 "dictionary.cpp"
          var $93=HEAP8[($arrayidx104)]; //@line 3312 "dictionary.cpp"
          var $conv105=(tempInt=(($93)),(tempInt>=128?tempInt-256:tempInt)); //@line 3312 "dictionary.cpp"
          var $94=$length; //@line 3312 "dictionary.cpp"
          var $sub106=((($94)-2)&4294967295); //@line 3312 "dictionary.cpp"
          var $arrayidx107=(($word+$sub106)&4294967295); //@line 3312 "dictionary.cpp"
          var $95=HEAP8[($arrayidx107)]; //@line 3312 "dictionary.cpp"
          var $conv108=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 3312 "dictionary.cpp"
          var $cmp109=((($conv105))|0)==((($conv108))|0); //@line 3312 "dictionary.cpp"
          if (!($cmp109)) { __label__ = 39;break $land_lhs_true70$$if_end117thread_pre_split$37; } //@line 3312 "dictionary.cpp"
  
          var $96=$length; //@line 3315 "dictionary.cpp"
          var $sub111=((($96)-1)&4294967295); //@line 3315 "dictionary.cpp"
          var $arrayidx112=(($word+$sub111)&4294967295); //@line 3315 "dictionary.cpp"
          HEAP8[($arrayidx112)]=0; //@line 3315 "dictionary.cpp"
          var $97=$tr_addr; //@line 3316 "dictionary.cpp"
          var $arraydecay113=(($word)&4294967295); //@line 3316 "dictionary.cpp"
          var $98=$word1; //@line 3316 "dictionary.cpp"
          var $99=$ph_out_addr; //@line 3316 "dictionary.cpp"
          var $100=$flags_addr; //@line 3316 "dictionary.cpp"
          var $101=$end_flags_addr; //@line 3316 "dictionary.cpp"
          var $102=$wtab_addr; //@line 3316 "dictionary.cpp"
          var $call114=__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($97, $arraydecay113, $98, $99, $100, $101, $102); //@line 3316 "dictionary.cpp"
          $found=$call114; //@line 3316 "dictionary.cpp"
          __lastLabel__ = 38; __label__ = 40;break $land_lhs_true70$$if_end117thread_pre_split$37; //@line 3317 "dictionary.cpp"
        }
      } while(0);
      if (__label__ == 39) {
  
        var $_pr2=$found; //@line 3320 "dictionary.cpp"
        __lastLabel__ = 39; ;
      }
  
      var $103=__lastLabel__ == 39 ? $_pr2 : (__lastLabel__ == 35 ? $call98 : ($call114)); //@line 3320 "dictionary.cpp"
      var $tobool118=((($103))|0)!=0; //@line 3320 "dictionary.cpp"
      if ($tobool118) { __label__ = 41;; } else { __label__ = 49;; } //@line 3320 "dictionary.cpp"
      if (__label__ == 41) {
  
        var $104=$tr_addr; //@line 3323 "dictionary.cpp"
        var $langopts=(($104)&4294967295); //@line 3323 "dictionary.cpp"
        var $textmode=(($langopts+252)&4294967295); //@line 3323 "dictionary.cpp"
        var $105=HEAP8[($textmode)]; //@line 3323 "dictionary.cpp"
        var $tobool120=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 3323 "dictionary.cpp"
        if ($tobool120) { __label__ = 42;; } else { __label__ = 43;; } //@line 3323 "dictionary.cpp"
        if (__label__ == 42) {
  
          var $106=$flags_addr; //@line 3324 "dictionary.cpp"
          var $107=HEAP32[(($106)>>2)]; //@line 3324 "dictionary.cpp"
          var $xor=($107) ^ 536870912; //@line 3324 "dictionary.cpp"
          HEAP32[(($106)>>2)]=$xor; //@line 3324 "dictionary.cpp"
          ; //@line 3324 "dictionary.cpp"
        }
  
        var $108=$flags_addr; //@line 3326 "dictionary.cpp"
        var $109=HEAP32[(($108)>>2)]; //@line 3326 "dictionary.cpp"
        var $and123=($109) & 536870912; //@line 3326 "dictionary.cpp"
        var $tobool124=((($and123))|0)!=0; //@line 3326 "dictionary.cpp"
        if ($tobool124) { __label__ = 44;; } else { __label__ = 48;; } //@line 3326 "dictionary.cpp"
        if (__label__ == 44) {
  
          var $110=$end_flags_addr; //@line 3330 "dictionary.cpp"
          var $and126=($110) & 2; //@line 3330 "dictionary.cpp"
          var $tobool127=((($and126))|0)!=0; //@line 3330 "dictionary.cpp"
          if ($tobool127) { __label__ = 45;; } else { __label__ = 47;; } //@line 3330 "dictionary.cpp"
          $if_then128$$if_end138$63: do { 
            if (__label__ == 45) {
  
              HEAP8[(((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement)&4294967295))]=0; //@line 3333 "dictionary.cpp"
              HEAP8[(((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement+1)&4294967295))]=32; //@line 3334 "dictionary.cpp"
              var $111=$ph_out_addr; //@line 3335 "dictionary.cpp"
              var $call129=_sprintf(((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement+2)&4294967295), ((__str15131)&4294967295), allocate([$111,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 3335 "dictionary.cpp"
              var $112=$wordptr_addr; //@line 3337 "dictionary.cpp"
              var $113=HEAP32[(($112)>>2)]; //@line 3337 "dictionary.cpp"
              $word1=$113; //@line 3337 "dictionary.cpp"
              var $114=$wordptr_addr; //@line 3338 "dictionary.cpp"
              HEAP32[(($114)>>2)]=((__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement+2)&4294967295); //@line 3338 "dictionary.cpp"
              var $115=HEAP32[((_option_phonemes)>>2)]; //@line 3340 "dictionary.cpp"
              var $cmp130=((($115))|0)==2; //@line 3340 "dictionary.cpp"
              if (!($cmp130)) { __label__ = 47;break $if_then128$$if_end138$63; } //@line 3340 "dictionary.cpp"
  
              var $116=$found; //@line 3342 "dictionary.cpp"
              var $117=$word1; //@line 3342 "dictionary.cpp"
              var $sub_ptr_lhs_cast=($116); //@line 3342 "dictionary.cpp"
              var $sub_ptr_rhs_cast=($117); //@line 3342 "dictionary.cpp"
              var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 3342 "dictionary.cpp"
              $len=$sub_ptr_sub; //@line 3342 "dictionary.cpp"
              var $arraydecay132=(($word)&4294967295); //@line 3343 "dictionary.cpp"
              var $118=$word1; //@line 3343 "dictionary.cpp"
              var $119=$len; //@line 3343 "dictionary.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = $118;
              $dest$ = $arraydecay132;
              $stop$ = $src$ + $119;
              if (($dest$%4) == ($src$%4) && $119 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 3343 "dictionary.cpp"
              var $120=$len; //@line 3344 "dictionary.cpp"
              var $arrayidx133=(($word+$120)&4294967295); //@line 3344 "dictionary.cpp"
              HEAP8[($arrayidx133)]=0; //@line 3344 "dictionary.cpp"
              var $121=HEAP32[((_f_trans)>>2)]; //@line 3345 "dictionary.cpp"
              var $arraydecay134=(($word)&4294967295); //@line 3345 "dictionary.cpp"
              var $122=$wordptr_addr; //@line 3345 "dictionary.cpp"
              var $123=HEAP32[(($122)>>2)]; //@line 3345 "dictionary.cpp"
              var $call135=_fprintf($121, ((__str16132)&4294967295), allocate([$arraydecay134,0,0,0,$123,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3345 "dictionary.cpp"
              ; //@line 3346 "dictionary.cpp"
            }
          } while(0);
  
          var $124=$ph_out_addr; //@line 3353 "dictionary.cpp"
          var $arrayidx139=(($124)&4294967295); //@line 3353 "dictionary.cpp"
          HEAP8[($arrayidx139)]=0; //@line 3353 "dictionary.cpp"
          $retval=0; //@line 3354 "dictionary.cpp"
          ; //@line 3354 "dictionary.cpp"
        }
        else if (__label__ == 48) {
  
          $retval=1; //@line 3357 "dictionary.cpp"
          ; //@line 3357 "dictionary.cpp"
        }
      }
      else if (__label__ == 49) {
  
        var $125=$ph_out_addr; //@line 3360 "dictionary.cpp"
        var $arrayidx142=(($125)&4294967295); //@line 3360 "dictionary.cpp"
        HEAP8[($arrayidx142)]=0; //@line 3360 "dictionary.cpp"
        $retval=0; //@line 3361 "dictionary.cpp"
        ; //@line 3361 "dictionary.cpp"
      }
    }
  
    var $126=$retval; //@line 3362 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $126; //@line 3362 "dictionary.cpp"
    return null;
  }
  

  function __ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB($tr, $word, $word2, $phonetic, $flags, $end_flags, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 320; _memset(__stackBase__, 0, 320);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $word2_addr;
    var $phonetic_addr;
    var $flags_addr;
    var $end_flags_addr;
    var $wtab_addr;
    var $p;
    var $next;
    var $hash;
    var $phoneme_len;
    var $wlen;
    var $flag;
    var $dictionary_flags;
    var $dictionary_flags2;
    var $condition_failed;
    var $n_chars;
    var $no_phonemes;
    var $skipwords;
    var $ix;
    var $word_end;
    var $word1;
    var $wflags;
    var $word_buf=__stackBase__;
    var $flags1259;
    var $ph_decoded=__stackBase__+160;
    var $textmode;
    $tr_addr=$tr;
    $word_addr=$word;
    $word2_addr=$word2;
    $phonetic_addr=$phonetic;
    $flags_addr=$flags;
    $end_flags_addr=$end_flags;
    $wtab_addr=$wtab;
    $condition_failed=0; //@line 2887 "dictionary.cpp"
    $wflags=0; //@line 2894 "dictionary.cpp"
    var $0=$wtab_addr; //@line 2897 "dictionary.cpp"
    var $cmp=((($0))|0)!=0; //@line 2897 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2897 "dictionary.cpp"
    if (__label__ == 1) {
  
      var $1=$wtab_addr; //@line 2899 "dictionary.cpp"
      var $flags1=(($1)&4294967295); //@line 2899 "dictionary.cpp"
      var $2=HEAP32[(($flags1)>>2)]; //@line 2899 "dictionary.cpp"
      $wflags=$2; //@line 2899 "dictionary.cpp"
      ; //@line 2900 "dictionary.cpp"
    }
  
    var $3=$word_addr; //@line 2902 "dictionary.cpp"
    $word1=$3; //@line 2902 "dictionary.cpp"
    var $4=$tr_addr; //@line 2903 "dictionary.cpp"
    var $transpose_min=(($4+288)&4294967295); //@line 2903 "dictionary.cpp"
    var $5=HEAP32[(($transpose_min)>>2)]; //@line 2903 "dictionary.cpp"
    var $cmp2=((($5))|0) > 0; //@line 2903 "dictionary.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 2903 "dictionary.cpp"
    if (__label__ == 3) {
  
      var $arraydecay=(($word_buf)&4294967295); //@line 2905 "dictionary.cpp"
      var $6=$word_addr; //@line 2905 "dictionary.cpp"
      var $call=_strcpy($arraydecay, $6); //@line 2905 "dictionary.cpp"
      var $7=$tr_addr; //@line 2906 "dictionary.cpp"
      var $arraydecay4=(($word_buf)&4294967295); //@line 2906 "dictionary.cpp"
      var $call5=__Z17TransposeAlphabetP10TranslatorPc($7, $arraydecay4); //@line 2906 "dictionary.cpp"
      $wlen=$call5; //@line 2906 "dictionary.cpp"
      var $arraydecay6=(($word_buf)&4294967295); //@line 2907 "dictionary.cpp"
      $word_addr=$arraydecay6; //@line 2907 "dictionary.cpp"
      ; //@line 2908 "dictionary.cpp"
    }
    else if (__label__ == 4) {
  
      var $8=$word_addr; //@line 2911 "dictionary.cpp"
      var $call7=_strlen($8); //@line 2911 "dictionary.cpp"
      $wlen=$call7; //@line 2911 "dictionary.cpp"
      ;
    }
  
    var $9=$word_addr; //@line 2914 "dictionary.cpp"
    var $call9=__Z14HashDictionaryPKc($9); //@line 2914 "dictionary.cpp"
    $hash=$call9; //@line 2914 "dictionary.cpp"
    var $10=$hash; //@line 2915 "dictionary.cpp"
    var $11=$tr_addr; //@line 2915 "dictionary.cpp"
    var $dict_hashtab=(($11+1056)&4294967295); //@line 2915 "dictionary.cpp"
    var $arrayidx=(($dict_hashtab+$10*4)&4294967295); //@line 2915 "dictionary.cpp"
    var $12=HEAP32[(($arrayidx)>>2)]; //@line 2915 "dictionary.cpp"
    $p=$12; //@line 2915 "dictionary.cpp"
    var $cmp10=((($12))|0)==0; //@line 2917 "dictionary.cpp"
    if ($cmp10) { __label__ = 6;; } else { __label__ = 9;; } //@line 2917 "dictionary.cpp"
    if (__label__ == 6) {
  
      var $13=$flags_addr; //@line 2919 "dictionary.cpp"
      var $cmp12=((($13))|0)!=0; //@line 2919 "dictionary.cpp"
      if ($cmp12) { __label__ = 7;; } else { __label__ = 8;; } //@line 2919 "dictionary.cpp"
      if (__label__ == 7) {
  
        var $14=$flags_addr; //@line 2920 "dictionary.cpp"
        HEAP32[(($14)>>2)]=0; //@line 2920 "dictionary.cpp"
        ; //@line 2920 "dictionary.cpp"
      }
  
      $retval=0; //@line 2921 "dictionary.cpp"
      ; //@line 2921 "dictionary.cpp"
    }
    else if (__label__ == 9) {
      $while_cond$14: while(1) { 
  
        var $15=$p; //@line 2927 "dictionary.cpp"
        var $16=HEAP8[($15)]; //@line 2927 "dictionary.cpp"
        var $conv=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 2927 "dictionary.cpp"
        var $cmp16=((($conv))|0)!=0; //@line 2927 "dictionary.cpp"
        if (!($cmp16)) { __label__ = 95;break $while_cond$14; } //@line 2927 "dictionary.cpp"
  
        var $17=$p; //@line 2929 "dictionary.cpp"
        var $18=$p; //@line 2929 "dictionary.cpp"
        var $arrayidx17=(($18)&4294967295); //@line 2929 "dictionary.cpp"
        var $19=HEAP8[($arrayidx17)]; //@line 2929 "dictionary.cpp"
        var $conv18=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 2929 "dictionary.cpp"
        var $add_ptr=(($17+$conv18)&4294967295); //@line 2929 "dictionary.cpp"
        $next=$add_ptr; //@line 2929 "dictionary.cpp"
        var $20=$p; //@line 2931 "dictionary.cpp"
        var $arrayidx19=(($20+1)&4294967295); //@line 2931 "dictionary.cpp"
        var $21=HEAP8[($arrayidx19)]; //@line 2931 "dictionary.cpp"
        var $conv20=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 2931 "dictionary.cpp"
        var $and=($conv20) & 127; //@line 2931 "dictionary.cpp"
        var $22=$wlen; //@line 2931 "dictionary.cpp"
        var $cmp21=((($and))|0)!=((($22))|0); //@line 2931 "dictionary.cpp"
        if ($cmp21) { __label__ = 12;; } else { __label__ = 11;; } //@line 2931 "dictionary.cpp"
        $if_then26$$lor_lhs_false$17: do { 
          if (__label__ == 11) {
  
            var $23=$word_addr; //@line 2931 "dictionary.cpp"
            var $24=$p; //@line 2931 "dictionary.cpp"
            var $arrayidx22=(($24+2)&4294967295); //@line 2931 "dictionary.cpp"
            var $25=$wlen; //@line 2931 "dictionary.cpp"
            var $and23=($25) & 63; //@line 2931 "dictionary.cpp"
            var $call24=_memcmp($23, $arrayidx22, $and23); //@line 2931 "dictionary.cpp"
            var $cmp25=((($call24))|0)!=0; //@line 2931 "dictionary.cpp"
            if ($cmp25) { __label__ = 12;break $if_then26$$lor_lhs_false$17; } //@line 2931 "dictionary.cpp"
  
            var $27=$word2_addr; //@line 2939 "dictionary.cpp"
            $word_end=$27; //@line 2939 "dictionary.cpp"
            $dictionary_flags=0; //@line 2941 "dictionary.cpp"
            $dictionary_flags2=0; //@line 2942 "dictionary.cpp"
            var $28=$p; //@line 2943 "dictionary.cpp"
            var $arrayidx28=(($28+1)&4294967295); //@line 2943 "dictionary.cpp"
            var $29=HEAP8[($arrayidx28)]; //@line 2943 "dictionary.cpp"
            var $conv29=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 2943 "dictionary.cpp"
            var $and30=($conv29) & 128; //@line 2943 "dictionary.cpp"
            $no_phonemes=$and30; //@line 2943 "dictionary.cpp"
            var $30=$p; //@line 2945 "dictionary.cpp"
            var $arrayidx31=(($30+1)&4294967295); //@line 2945 "dictionary.cpp"
            var $31=HEAP8[($arrayidx31)]; //@line 2945 "dictionary.cpp"
            var $conv32=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 2945 "dictionary.cpp"
            var $and33=($conv32) & 63; //@line 2945 "dictionary.cpp"
            var $add=((($and33)+2)&4294967295); //@line 2945 "dictionary.cpp"
            var $32=$p; //@line 2945 "dictionary.cpp"
            var $add_ptr34=(($32+$add)&4294967295); //@line 2945 "dictionary.cpp"
            $p=$add_ptr34; //@line 2945 "dictionary.cpp"
            var $33=$no_phonemes; //@line 2947 "dictionary.cpp"
            var $tobool=((($33))|0)!=0; //@line 2947 "dictionary.cpp"
            var $34=$phonetic_addr; //@line 2949 "dictionary.cpp"
            if ($tobool) { __label__ = 14;; } else { __label__ = 15;; } //@line 2947 "dictionary.cpp"
            if (__label__ == 14) {
  
              var $arrayidx36=(($34)&4294967295); //@line 2949 "dictionary.cpp"
              HEAP8[($arrayidx36)]=0; //@line 2949 "dictionary.cpp"
              $phoneme_len=0; //@line 2950 "dictionary.cpp"
              ; //@line 2951 "dictionary.cpp"
            }
            else if (__label__ == 15) {
  
              var $35=$p; //@line 2954 "dictionary.cpp"
              var $call38=_strcpy($34, $35); //@line 2954 "dictionary.cpp"
              var $36=$p; //@line 2955 "dictionary.cpp"
              var $call39=_strlen($36); //@line 2955 "dictionary.cpp"
              $phoneme_len=$call39; //@line 2955 "dictionary.cpp"
              var $37=$phoneme_len; //@line 2956 "dictionary.cpp"
              var $add40=((($37)+1)&4294967295); //@line 2956 "dictionary.cpp"
              var $38=$p; //@line 2956 "dictionary.cpp"
              var $add_ptr41=(($38+$add40)&4294967295); //@line 2956 "dictionary.cpp"
              $p=$add_ptr41; //@line 2956 "dictionary.cpp"
              ;
            }
            $while_cond43$23: while(1) { 
  
              var $39=$p; //@line 2959 "dictionary.cpp"
              var $40=$next; //@line 2959 "dictionary.cpp"
              var $cmp44=((($39))>>>0) < ((($40))>>>0); //@line 2959 "dictionary.cpp"
              if (!($cmp44)) { __label__ = 39;break $while_cond43$23; } //@line 2959 "dictionary.cpp"
  
              var $41=$p; //@line 2963 "dictionary.cpp"
              var $incdec_ptr=(($41+1)&4294967295); //@line 2963 "dictionary.cpp"
              $p=$incdec_ptr; //@line 2963 "dictionary.cpp"
              var $42=HEAP8[($41)]; //@line 2963 "dictionary.cpp"
              $flag=$42; //@line 2963 "dictionary.cpp"
              var $43=$flag; //@line 2964 "dictionary.cpp"
              var $conv46=((($43))&255); //@line 2964 "dictionary.cpp"
              var $cmp47=((($conv46))|0) >= 100; //@line 2964 "dictionary.cpp"
              var $44=$flag; //@line 2967 "dictionary.cpp"
              var $conv49=((($44))&255); //@line 2967 "dictionary.cpp"
              if ($cmp47) { __label__ = 18;; } else { __label__ = 23;; } //@line 2964 "dictionary.cpp"
              if (__label__ == 18) {
  
                var $cmp50=((($conv49))|0) >= 132; //@line 2967 "dictionary.cpp"
                var $45=$tr_addr; //@line 2970 "dictionary.cpp"
                var $dict_condition=(($45+692)&4294967295); //@line 2970 "dictionary.cpp"
                var $46=HEAPU32[(($dict_condition)>>2)]; //@line 2970 "dictionary.cpp"
                var $47=$flag; //@line 2970 "dictionary.cpp"
                var $conv52=((($47))&255); //@line 2970 "dictionary.cpp"
                if ($cmp50) { __label__ = 19;; } else { __label__ = 21;; } //@line 2967 "dictionary.cpp"
                if (__label__ == 19) {
  
                  var $sub=((($conv52)-132)&4294967295); //@line 2970 "dictionary.cpp"
                  var $shl=1 << ($sub); //@line 2970 "dictionary.cpp"
                  var $and53=($shl) & ($46); //@line 2970 "dictionary.cpp"
                  var $cmp54=((($and53))|0)!=0; //@line 2970 "dictionary.cpp"
                  if (!($cmp54)) { __label__ = 16;continue $while_cond43$23; } //@line 2970 "dictionary.cpp"
  
                  $condition_failed=1; //@line 2971 "dictionary.cpp"
                  __label__ = 16;continue $while_cond43$23; //@line 2971 "dictionary.cpp"
                }
                else if (__label__ == 21) {
  
                  var $sub60=((($conv52)-100)&4294967295); //@line 2976 "dictionary.cpp"
                  var $shl61=1 << ($sub60); //@line 2976 "dictionary.cpp"
                  var $and62=($shl61) & ($46); //@line 2976 "dictionary.cpp"
                  var $cmp63=((($and62))|0)==0; //@line 2976 "dictionary.cpp"
                  if (!($cmp63)) { __label__ = 16;continue $while_cond43$23; } //@line 2976 "dictionary.cpp"
  
                  $condition_failed=1; //@line 2977 "dictionary.cpp"
                  __label__ = 16;continue $while_cond43$23; //@line 2977 "dictionary.cpp"
                }
              }
              else if (__label__ == 23) {
  
                var $cmp69=((($conv49))|0) > 80; //@line 2981 "dictionary.cpp"
                if ($cmp69) { __label__ = 24;; } else { __label__ = 33;; } //@line 2981 "dictionary.cpp"
                if (__label__ == 24) {
  
                  var $48=$next; //@line 2985 "dictionary.cpp"
                  var $49=$p; //@line 2985 "dictionary.cpp"
                  var $sub_ptr_lhs_cast=($48); //@line 2985 "dictionary.cpp"
                  var $sub_ptr_rhs_cast=($49); //@line 2985 "dictionary.cpp"
                  var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2985 "dictionary.cpp"
                  $n_chars=$sub_ptr_sub; //@line 2985 "dictionary.cpp"
                  var $50=$flag; //@line 2986 "dictionary.cpp"
                  var $conv71=((($50))&255); //@line 2986 "dictionary.cpp"
                  var $sub72=((($conv71)-80)&4294967295); //@line 2986 "dictionary.cpp"
                  $skipwords=$sub72; //@line 2986 "dictionary.cpp"
                  $ix=0; //@line 2989 "dictionary.cpp"
                  var $51=$ix; //@line 2989 "dictionary.cpp"
                  var $52=$skipwords; //@line 2989 "dictionary.cpp"
                  var $cmp732=((($51))|0) <= ((($52))|0); //@line 2989 "dictionary.cpp"
                  if ($cmp732) { __label__ = 25;; } else { __label__ = 28;; } //@line 2989 "dictionary.cpp"
                  $for_body$$for_end$36: do { 
                    if (__label__ == 25) {
                      while(1) { 
  
                        var $53=$wflags; //@line 2991 "dictionary.cpp"
                        var $and74=($53) & 3072; //@line 2991 "dictionary.cpp"
                        var $tobool75=((($and74))|0)!=0; //@line 2991 "dictionary.cpp"
                        if ($tobool75) { __label__ = 26;; } else { __label__ = 27;; } //@line 2991 "dictionary.cpp"
                        if (__label__ == 26) {
  
                          $condition_failed=1; //@line 2993 "dictionary.cpp"
                          ; //@line 2994 "dictionary.cpp"
                        }
  
                        var $54=$ix; //@line 2989 "dictionary.cpp"
                        var $inc=((($54)+1)&4294967295); //@line 2989 "dictionary.cpp"
                        $ix=$inc; //@line 2989 "dictionary.cpp"
                        var $55=$ix; //@line 2989 "dictionary.cpp"
                        var $56=$skipwords; //@line 2989 "dictionary.cpp"
                        var $cmp73=((($55))|0) <= ((($56))|0); //@line 2989 "dictionary.cpp"
                        if ($cmp73) { __label__ = 25;continue ; } else { __label__ = 28;break $for_body$$for_end$36; } //@line 2989 "dictionary.cpp"
                      }
                    }
                  } while(0);
  
                  var $57=$word2_addr; //@line 2997 "dictionary.cpp"
                  var $58=$p; //@line 2997 "dictionary.cpp"
                  var $59=$n_chars; //@line 2997 "dictionary.cpp"
                  var $call78=_memcmp($57, $58, $59); //@line 2997 "dictionary.cpp"
                  var $cmp79=((($call78))|0)!=0; //@line 2997 "dictionary.cpp"
                  if ($cmp79) { __label__ = 29;break $while_cond43$23; } //@line 2997 "dictionary.cpp"
  
                  var $_pr=$condition_failed; //@line 3000 "dictionary.cpp"
                  var $tobool82=((($_pr))|0)!=0; //@line 3000 "dictionary.cpp"
                  if ($tobool82) { __label__ = 31;break $while_cond43$23; } //@line 3000 "dictionary.cpp"
  
                  var $61=$dictionary_flags; //@line 3006 "dictionary.cpp"
                  var $or=($61) | 128; //@line 3006 "dictionary.cpp"
                  $dictionary_flags=$or; //@line 3006 "dictionary.cpp"
                  var $62=$skipwords; //@line 3007 "dictionary.cpp"
                  HEAP32[((_dictionary_skipwords)>>2)]=$62; //@line 3007 "dictionary.cpp"
                  var $63=$next; //@line 3008 "dictionary.cpp"
                  $p=$63; //@line 3008 "dictionary.cpp"
                  var $64=$word2_addr; //@line 3009 "dictionary.cpp"
                  var $65=$n_chars; //@line 3009 "dictionary.cpp"
                  var $add_ptr85=(($64+$65)&4294967295); //@line 3009 "dictionary.cpp"
                  $word_end=$add_ptr85; //@line 3009 "dictionary.cpp"
                  __label__ = 16;continue $while_cond43$23; //@line 3010 "dictionary.cpp"
                }
                else if (__label__ == 33) {
  
                  var $66=$flag; //@line 3012 "dictionary.cpp"
                  var $conv87=((($66))&255); //@line 3012 "dictionary.cpp"
                  var $cmp88=((($conv87))|0) > 64; //@line 3012 "dictionary.cpp"
                  if ($cmp88) { __label__ = 34;; } else { __label__ = 36;; } //@line 3012 "dictionary.cpp"
                  if (__label__ == 34) {
  
                    var $67=$dictionary_flags; //@line 3015 "dictionary.cpp"
                    var $and90=($67) & -16; //@line 3015 "dictionary.cpp"
                    var $68=$flag; //@line 3015 "dictionary.cpp"
                    var $conv91=((($68))&255); //@line 3015 "dictionary.cpp"
                    var $and92=($conv91) & 15; //@line 3015 "dictionary.cpp"
                    var $or93=($and92) | ($and90); //@line 3015 "dictionary.cpp"
                    $dictionary_flags=$or93; //@line 3015 "dictionary.cpp"
                    var $69=$flag; //@line 3016 "dictionary.cpp"
                    var $conv94=((($69))&255); //@line 3016 "dictionary.cpp"
                    var $and95=($conv94) & 12; //@line 3016 "dictionary.cpp"
                    var $cmp96=((($and95))|0)==12; //@line 3016 "dictionary.cpp"
                    if (!($cmp96)) { __label__ = 16;continue $while_cond43$23; } //@line 3016 "dictionary.cpp"
  
                    var $70=$dictionary_flags; //@line 3017 "dictionary.cpp"
                    var $or98=($70) | 2048; //@line 3017 "dictionary.cpp"
                    $dictionary_flags=$or98; //@line 3017 "dictionary.cpp"
                    __label__ = 16;continue $while_cond43$23; //@line 3017 "dictionary.cpp"
                  }
                  else if (__label__ == 36) {
  
                    var $71=$flag; //@line 3020 "dictionary.cpp"
                    var $conv101=((($71))&255); //@line 3020 "dictionary.cpp"
                    var $cmp102=((($conv101))|0) >= 32; //@line 3020 "dictionary.cpp"
                    var $72=$flag; //@line 3022 "dictionary.cpp"
                    var $conv104=((($72))&255); //@line 3022 "dictionary.cpp"
                    if ($cmp102) { __label__ = 37;; } else { __label__ = 38;; } //@line 3020 "dictionary.cpp"
                    if (__label__ == 37) {
  
                      var $sub105=((($conv104)-32)&4294967295); //@line 3022 "dictionary.cpp"
                      var $shl106=1 << ($sub105); //@line 3022 "dictionary.cpp"
                      var $73=$dictionary_flags2; //@line 3022 "dictionary.cpp"
                      var $or107=($73) | ($shl106); //@line 3022 "dictionary.cpp"
                      $dictionary_flags2=$or107; //@line 3022 "dictionary.cpp"
                      __label__ = 16;continue $while_cond43$23; //@line 3023 "dictionary.cpp"
                    }
                    else if (__label__ == 38) {
  
                      var $shl110=1 << ($conv104); //@line 3026 "dictionary.cpp"
                      var $74=$dictionary_flags; //@line 3026 "dictionary.cpp"
                      var $or111=($74) | ($shl110); //@line 3026 "dictionary.cpp"
                      $dictionary_flags=$or111; //@line 3026 "dictionary.cpp"
                      __label__ = 16;continue $while_cond43$23;
                    }
                  }
                }
              }
            }
            $while_end$$if_end81_thread$$if_then83$53: do { 
              if (__label__ == 29) {
  
                $condition_failed=1; //@line 2998 "dictionary.cpp"
                __label__ = 31;break $while_end$$if_end81_thread$$if_then83$53; //@line 3000 "dictionary.cpp"
              }
            } while(0);
            if (__label__ == 31) {
  
              var $60=$next; //@line 3002 "dictionary.cpp"
              $p=$60; //@line 3002 "dictionary.cpp"
              ; //@line 3003 "dictionary.cpp"
            }
  
            var $75=$condition_failed; //@line 3030 "dictionary.cpp"
            var $tobool116=((($75))|0)!=0; //@line 3030 "dictionary.cpp"
            if ($tobool116) { __label__ = 40;; } else { __label__ = 41;; } //@line 3030 "dictionary.cpp"
            if (__label__ == 40) {
  
              $condition_failed=0; //@line 3032 "dictionary.cpp"
              __label__ = 9;continue $while_cond$14; //@line 3033 "dictionary.cpp"
            }
            else if (__label__ == 41) {
  
              var $76=$end_flags_addr; //@line 3036 "dictionary.cpp"
              var $and119=($76) & 4; //@line 3036 "dictionary.cpp"
              var $cmp120=((($and119))|0)==0; //@line 3036 "dictionary.cpp"
              if ($cmp120) { __label__ = 42;; } else { __label__ = 43;; } //@line 3036 "dictionary.cpp"
              if (__label__ == 42) {
  
                var $77=$dictionary_flags; //@line 3039 "dictionary.cpp"
                var $and122=($77) & 262144; //@line 3039 "dictionary.cpp"
                var $tobool123=((($and122))|0)!=0; //@line 3039 "dictionary.cpp"
                if ($tobool123) { __label__ = 9;continue $while_cond$14; } //@line 3039 "dictionary.cpp"
              }
  
              var $78=$end_flags_addr; //@line 3043 "dictionary.cpp"
              var $and127=($78) & 1024; //@line 3043 "dictionary.cpp"
              var $tobool128=((($and127))|0)!=0; //@line 3043 "dictionary.cpp"
              if ($tobool128) { __label__ = 44;; } else { __label__ = 45;; } //@line 3043 "dictionary.cpp"
              if (__label__ == 44) {
  
                var $79=$dictionary_flags; //@line 3043 "dictionary.cpp"
                var $and129=($79) & 1536; //@line 3043 "dictionary.cpp"
                var $tobool130=((($and129))|0)!=0; //@line 3043 "dictionary.cpp"
                if ($tobool130) { __label__ = 9;continue $while_cond$14; } //@line 3043 "dictionary.cpp"
              }
  
              var $80=$end_flags_addr; //@line 3046 "dictionary.cpp"
              var $and133=($80) & 4; //@line 3046 "dictionary.cpp"
              var $tobool134=((($and133))|0)!=0; //@line 3046 "dictionary.cpp"
              if ($tobool134) { __label__ = 46;; } else { __label__ = 49;; } //@line 3046 "dictionary.cpp"
              $if_then135$$if_end147$67: do { 
                if (__label__ == 46) {
  
                  var $81=$dictionary_flags; //@line 3049 "dictionary.cpp"
                  var $and136=($81) & 512; //@line 3049 "dictionary.cpp"
                  var $tobool137=((($and136))|0)!=0; //@line 3049 "dictionary.cpp"
                  if ($tobool137) { __label__ = 9;continue $while_cond$14; } //@line 3049 "dictionary.cpp"
  
                  var $82=$dictionary_flags; //@line 3052 "dictionary.cpp"
                  var $and140=($82) & 1024; //@line 3052 "dictionary.cpp"
                  var $tobool141=((($and140))|0)!=0; //@line 3052 "dictionary.cpp"
                  if (!($tobool141)) { __label__ = 49;break $if_then135$$if_end147$67; } //@line 3052 "dictionary.cpp"
  
                  var $83=$end_flags_addr; //@line 3052 "dictionary.cpp"
                  var $and143=($83) & 8; //@line 3052 "dictionary.cpp"
                  var $cmp144=((($and143))|0)==0; //@line 3052 "dictionary.cpp"
                  if ($cmp144) { __label__ = 9;continue $while_cond$14; } //@line 3052 "dictionary.cpp"
                }
              } while(0);
  
              var $84=$dictionary_flags2; //@line 3059 "dictionary.cpp"
              var $and148=($84) & 4096; //@line 3059 "dictionary.cpp"
              var $tobool149=((($and148))|0)!=0; //@line 3059 "dictionary.cpp"
              if ($tobool149) { __label__ = 50;; } else { __label__ = 51;; } //@line 3059 "dictionary.cpp"
              if (__label__ == 50) {
  
                var $85=$wflags; //@line 3061 "dictionary.cpp"
                var $and151=($85) & 16384; //@line 3061 "dictionary.cpp"
                var $tobool152=((($and151))|0)!=0; //@line 3061 "dictionary.cpp"
                if (!($tobool152)) { __label__ = 9;continue $while_cond$14; } //@line 3061 "dictionary.cpp"
              }
  
              var $86=$dictionary_flags2; //@line 3066 "dictionary.cpp"
              var $and156=($86) & 512; //@line 3066 "dictionary.cpp"
              var $tobool157=((($and156))|0)!=0; //@line 3066 "dictionary.cpp"
              if ($tobool157) { __label__ = 52;; } else { __label__ = 53;; } //@line 3066 "dictionary.cpp"
              if (__label__ == 52) {
  
                var $87=$wflags; //@line 3068 "dictionary.cpp"
                var $and159=($87) & 2; //@line 3068 "dictionary.cpp"
                var $tobool160=((($and159))|0)!=0; //@line 3068 "dictionary.cpp"
                if (!($tobool160)) { __label__ = 9;continue $while_cond$14; } //@line 3068 "dictionary.cpp"
              }
  
              var $88=$dictionary_flags2; //@line 3073 "dictionary.cpp"
              var $and164=($88) & 1024; //@line 3073 "dictionary.cpp"
              var $tobool165=((($and164))|0)!=0; //@line 3073 "dictionary.cpp"
              if ($tobool165) { __label__ = 54;; } else { __label__ = 55;; } //@line 3073 "dictionary.cpp"
              if (__label__ == 54) {
  
                var $89=$wflags; //@line 3075 "dictionary.cpp"
                var $and167=($89) & 1; //@line 3075 "dictionary.cpp"
                var $tobool168=((($and167))|0)!=0; //@line 3075 "dictionary.cpp"
                if (!($tobool168)) { __label__ = 9;continue $while_cond$14; } //@line 3075 "dictionary.cpp"
              }
  
              var $90=$dictionary_flags; //@line 3080 "dictionary.cpp"
              var $and172=($90) & 33554432; //@line 3080 "dictionary.cpp"
              var $tobool173=((($and172))|0)!=0; //@line 3080 "dictionary.cpp"
              if ($tobool173) { __label__ = 56;; } else { __label__ = 57;; } //@line 3080 "dictionary.cpp"
              if (__label__ == 56) {
  
                var $91=$wflags; //@line 3082 "dictionary.cpp"
                var $and175=($91) & 65536; //@line 3082 "dictionary.cpp"
                var $tobool176=((($and175))|0)!=0; //@line 3082 "dictionary.cpp"
                if (!($tobool176)) { __label__ = 9;continue $while_cond$14; } //@line 3082 "dictionary.cpp"
              }
  
              var $92=$dictionary_flags; //@line 3086 "dictionary.cpp"
              var $and180=($92) & 16384; //@line 3086 "dictionary.cpp"
              var $tobool181=((($and180))|0)!=0; //@line 3086 "dictionary.cpp"
              if ($tobool181) { __label__ = 58;; } else { __label__ = 59;; } //@line 3086 "dictionary.cpp"
              if (__label__ == 58) {
  
                var $93=$word_end; //@line 3086 "dictionary.cpp"
                var $94=$tr_addr; //@line 3086 "dictionary.cpp"
                var $clause_end=(($94+8292)&4294967295); //@line 3086 "dictionary.cpp"
                var $95=HEAPU32[(($clause_end)>>2)]; //@line 3086 "dictionary.cpp"
                var $cmp183=((($93))>>>0) < ((($95))>>>0); //@line 3086 "dictionary.cpp"
                if ($cmp183) { __label__ = 9;continue $while_cond$14; } //@line 3086 "dictionary.cpp"
              }
  
              var $96=$dictionary_flags; //@line 3092 "dictionary.cpp"
              var $and186=($96) & 32768; //@line 3092 "dictionary.cpp"
              var $tobool187=((($and186))|0)!=0; //@line 3092 "dictionary.cpp"
              if ($tobool187) { __label__ = 60;; } else { __label__ = 61;; } //@line 3092 "dictionary.cpp"
              if (__label__ == 60) {
  
                var $97=$wtab_addr; //@line 3092 "dictionary.cpp"
                var $flags189=(($97)&4294967295); //@line 3092 "dictionary.cpp"
                var $98=HEAP32[(($flags189)>>2)]; //@line 3092 "dictionary.cpp"
                var $and190=($98) & 512; //@line 3092 "dictionary.cpp"
                var $tobool191=((($and190))|0)!=0; //@line 3092 "dictionary.cpp"
                if (!($tobool191)) { __label__ = 9;continue $while_cond$14; } //@line 3092 "dictionary.cpp"
              }
  
              var $99=$dictionary_flags2; //@line 3098 "dictionary.cpp"
              var $and194=($99) & 8192; //@line 3098 "dictionary.cpp"
              var $tobool195=((($and194))|0)!=0; //@line 3098 "dictionary.cpp"
              if ($tobool195) { __label__ = 62;; } else { __label__ = 63;; } //@line 3098 "dictionary.cpp"
              if (__label__ == 62) {
  
                var $100=$tr_addr; //@line 3098 "dictionary.cpp"
                var $clause_terminator=(($100+8324)&4294967295); //@line 3098 "dictionary.cpp"
                var $101=HEAP32[(($clause_terminator)>>2)]; //@line 3098 "dictionary.cpp"
                var $and197=($101) & 524288; //@line 3098 "dictionary.cpp"
                var $tobool198=((($and197))|0)!=0; //@line 3098 "dictionary.cpp"
                if (!($tobool198)) { __label__ = 9;continue $while_cond$14; } //@line 3098 "dictionary.cpp"
              }
  
              var $102=$dictionary_flags2; //@line 3104 "dictionary.cpp"
              var $and201=($102) & 16; //@line 3104 "dictionary.cpp"
              var $tobool202=((($and201))|0)!=0; //@line 3104 "dictionary.cpp"
              if ($tobool202) { __label__ = 64;; } else { __label__ = 67;; } //@line 3104 "dictionary.cpp"
              $if_then203$$if_end213$93: do { 
                if (__label__ == 64) {
  
                  var $103=$tr_addr; //@line 3108 "dictionary.cpp"
                  var $expect_verb=(($103+8272)&4294967295); //@line 3108 "dictionary.cpp"
                  var $104=HEAP32[(($expect_verb)>>2)]; //@line 3108 "dictionary.cpp"
                  var $tobool204=((($104))|0)!=0; //@line 3108 "dictionary.cpp"
                  if ($tobool204) { __label__ = 67;break $if_then203$$if_end213$93; } //@line 3108 "dictionary.cpp"
  
                  var $105=$tr_addr; //@line 3108 "dictionary.cpp"
                  var $expect_verb_s=(($105+8280)&4294967295); //@line 3108 "dictionary.cpp"
                  var $106=HEAP32[(($expect_verb_s)>>2)]; //@line 3108 "dictionary.cpp"
                  var $tobool206=((($106))|0)!=0; //@line 3108 "dictionary.cpp"
                  if (!($tobool206)) { __label__ = 9;continue $while_cond$14; } //@line 3108 "dictionary.cpp"
  
                  var $107=$end_flags_addr; //@line 3108 "dictionary.cpp"
                  var $and208=($107) & 8; //@line 3108 "dictionary.cpp"
                  var $tobool209=((($and208))|0)!=0; //@line 3108 "dictionary.cpp"
                  if (!($tobool209)) { __label__ = 9;continue $while_cond$14; } //@line 3108 "dictionary.cpp"
                }
              } while(0);
  
              var $108=$dictionary_flags2; //@line 3119 "dictionary.cpp"
              var $and214=($108) & 64; //@line 3119 "dictionary.cpp"
              var $tobool215=((($and214))|0)!=0; //@line 3119 "dictionary.cpp"
              if ($tobool215) { __label__ = 68;; } else { __label__ = 69;; } //@line 3119 "dictionary.cpp"
              if (__label__ == 68) {
  
                var $109=$tr_addr; //@line 3121 "dictionary.cpp"
                var $expect_past=(($109+8276)&4294967295); //@line 3121 "dictionary.cpp"
                var $110=HEAP32[(($expect_past)>>2)]; //@line 3121 "dictionary.cpp"
                var $tobool217=((($110))|0)!=0; //@line 3121 "dictionary.cpp"
                if (!($tobool217)) { __label__ = 9;continue $while_cond$14; } //@line 3121 "dictionary.cpp"
              }
  
              var $111=$dictionary_flags2; //@line 3128 "dictionary.cpp"
              var $and221=($111) & 32; //@line 3128 "dictionary.cpp"
              var $tobool222=((($and221))|0)!=0; //@line 3128 "dictionary.cpp"
              if ($tobool222) { __label__ = 70;; } else { __label__ = 71;; } //@line 3128 "dictionary.cpp"
              if (__label__ == 70) {
  
                var $112=$tr_addr; //@line 3130 "dictionary.cpp"
                var $expect_noun=(($112+8284)&4294967295); //@line 3130 "dictionary.cpp"
                var $113=HEAP32[(($expect_noun)>>2)]; //@line 3130 "dictionary.cpp"
                var $tobool224=((($113))|0)!=0; //@line 3130 "dictionary.cpp"
                if (!($tobool224)) { __label__ = 9;continue $while_cond$14; } //@line 3130 "dictionary.cpp"
              }
  
              var $114=$dictionary_flags; //@line 3137 "dictionary.cpp"
              var $and228=($114) & 2097152; //@line 3137 "dictionary.cpp"
              var $tobool229=((($and228))|0)!=0; //@line 3137 "dictionary.cpp"
              if (!($tobool229)) { __label__ = 74;break $while_cond$14; } //@line 3137 "dictionary.cpp"
  
              var $115=$tr_addr; //@line 3140 "dictionary.cpp"
              var $translator_name=(($115+280)&4294967295); //@line 3140 "dictionary.cpp"
              var $116=HEAP32[(($translator_name)>>2)]; //@line 3140 "dictionary.cpp"
              var $cmp231=((($116))|0)==26741; //@line 3140 "dictionary.cpp"
              if (!($cmp231)) { __label__ = 74;break $while_cond$14; } //@line 3140 "dictionary.cpp"
  
              var $117=$tr_addr; //@line 3140 "dictionary.cpp"
              var $prev_dict_flags=(($117+8320)&4294967295); //@line 3140 "dictionary.cpp"
              var $118=HEAP32[(($prev_dict_flags)>>2)]; //@line 3140 "dictionary.cpp"
              var $and233=($118) & 1048576; //@line 3140 "dictionary.cpp"
              var $tobool234=((($and233))|0)!=0; //@line 3140 "dictionary.cpp"
              if ($tobool234) { __label__ = 74;break $while_cond$14; } else { __label__ = 9;continue $while_cond$14; } //@line 3140 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $26=$next; //@line 2934 "dictionary.cpp"
        $p=$26; //@line 2934 "dictionary.cpp"
        __label__ = 9;continue $while_cond$14; //@line 2935 "dictionary.cpp"
      }
      if (__label__ == 95) {
  
        $retval=0; //@line 3198 "dictionary.cpp"
        ; //@line 3198 "dictionary.cpp"
      }
      else if (__label__ == 74) {
  
        var $119=$flags_addr; //@line 3144 "dictionary.cpp"
        var $cmp238=((($119))|0)!=0; //@line 3144 "dictionary.cpp"
        if ($cmp238) { __label__ = 75;; } else { __label__ = 76;; } //@line 3144 "dictionary.cpp"
        if (__label__ == 75) {
  
          var $120=$dictionary_flags; //@line 3146 "dictionary.cpp"
          var $or240=($120) | 1073741824; //@line 3146 "dictionary.cpp"
          var $121=$flags_addr; //@line 3146 "dictionary.cpp"
          var $arrayidx241=(($121)&4294967295); //@line 3146 "dictionary.cpp"
          HEAP32[(($arrayidx241)>>2)]=$or240; //@line 3146 "dictionary.cpp"
          var $122=$dictionary_flags2; //@line 3147 "dictionary.cpp"
          var $123=$flags_addr; //@line 3147 "dictionary.cpp"
          var $arrayidx242=(($123+4)&4294967295); //@line 3147 "dictionary.cpp"
          HEAP32[(($arrayidx242)>>2)]=$122; //@line 3147 "dictionary.cpp"
          ; //@line 3148 "dictionary.cpp"
        }
  
        var $124=$phoneme_len; //@line 3150 "dictionary.cpp"
        var $cmp244=((($124))|0)==0; //@line 3150 "dictionary.cpp"
        if ($cmp244) { __label__ = 77;; } else { __label__ = 80;; } //@line 3150 "dictionary.cpp"
        if (__label__ == 77) {
  
          var $125=HEAP32[((_option_phonemes)>>2)]; //@line 3152 "dictionary.cpp"
          var $cmp246=((($125))|0)==2; //@line 3152 "dictionary.cpp"
          if ($cmp246) { __label__ = 78;; } else { __label__ = 79;; } //@line 3152 "dictionary.cpp"
          if (__label__ == 78) {
  
            var $126=HEAP32[((_f_trans)>>2)]; //@line 3154 "dictionary.cpp"
            var $127=$word1; //@line 3154 "dictionary.cpp"
            var $128=$flags_addr; //@line 3154 "dictionary.cpp"
            var $call248=__Z22print_dictionary_flagsPj($128); //@line 3154 "dictionary.cpp"
            var $call249=_fprintf($126, ((__str28144)&4294967295), allocate([$127,0,0,0,((__ZZ22print_dictionary_flagsPjE3buf)&4294967295),0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3154 "dictionary.cpp"
            ; //@line 3155 "dictionary.cpp"
          }
  
          $retval=0; //@line 3156 "dictionary.cpp"
          ; //@line 3156 "dictionary.cpp"
        }
        else if (__label__ == 80) {
  
          var $129=$flags_addr; //@line 3159 "dictionary.cpp"
          var $cmp252=((($129))|0)!=0; //@line 3159 "dictionary.cpp"
          if ($cmp252) { __label__ = 81;; } else { __label__ = 82;; } //@line 3159 "dictionary.cpp"
          if (__label__ == 81) {
  
            var $130=$flags_addr; //@line 3160 "dictionary.cpp"
            var $arrayidx254=(($130)&4294967295); //@line 3160 "dictionary.cpp"
            var $131=HEAP32[(($arrayidx254)>>2)]; //@line 3160 "dictionary.cpp"
            var $or255=($131) | -2147483648; //@line 3160 "dictionary.cpp"
            HEAP32[(($arrayidx254)>>2)]=$or255; //@line 3160 "dictionary.cpp"
            ; //@line 3160 "dictionary.cpp"
          }
  
          var $132=HEAP32[((_option_phonemes)>>2)]; //@line 3162 "dictionary.cpp"
          var $cmp257=((($132))|0)==2; //@line 3162 "dictionary.cpp"
          if ($cmp257) { __label__ = 83;; } else { __label__ = 94;; } //@line 3162 "dictionary.cpp"
          $if_then258$$if_end296$122: do { 
            if (__label__ == 83) {
  
              $flags1259=0; //@line 3164 "dictionary.cpp"
              var $133=$phonetic_addr; //@line 3168 "dictionary.cpp"
              var $arraydecay260=(($ph_decoded)&4294967295); //@line 3168 "dictionary.cpp"
              __Z14DecodePhonemesPKcPc($133, $arraydecay260); //@line 3168 "dictionary.cpp"
              var $134=$flags_addr; //@line 3169 "dictionary.cpp"
              var $cmp261=((($134))|0)!=0; //@line 3169 "dictionary.cpp"
              if ($cmp261) { __label__ = 84;; } else { __label__ = 85;; } //@line 3169 "dictionary.cpp"
              if (__label__ == 84) {
  
                var $135=$flags_addr; //@line 3170 "dictionary.cpp"
                var $arrayidx263=(($135)&4294967295); //@line 3170 "dictionary.cpp"
                var $136=HEAP32[(($arrayidx263)>>2)]; //@line 3170 "dictionary.cpp"
                $flags1259=$136; //@line 3170 "dictionary.cpp"
                ; //@line 3170 "dictionary.cpp"
              }
  
              var $137=$dictionary_flags; //@line 3172 "dictionary.cpp"
              var $and265=($137) & 536870912; //@line 3172 "dictionary.cpp"
              var $cmp266=((($and265))|0)==0; //@line 3172 "dictionary.cpp"
              if ($cmp266) { __label__ = 86;; } else { __label__ = 87;; } //@line 3172 "dictionary.cpp"
              if (__label__ == 86) {
  
                $textmode=0; //@line 3173 "dictionary.cpp"
                ; //@line 3173 "dictionary.cpp"
              }
              else if (__label__ == 87) {
  
                $textmode=1; //@line 3175 "dictionary.cpp"
                ;
              }
  
              var $138=$textmode; //@line 3177 "dictionary.cpp"
              var $139=HEAP32[((_translator)>>2)]; //@line 3177 "dictionary.cpp"
              var $langopts=(($139)&4294967295); //@line 3177 "dictionary.cpp"
              var $textmode270=(($langopts+252)&4294967295); //@line 3177 "dictionary.cpp"
              var $140=HEAP8[($textmode270)]; //@line 3177 "dictionary.cpp"
              var $conv271=(tempInt=(($140)),(tempInt>=128?tempInt-256:tempInt)); //@line 3177 "dictionary.cpp"
              var $cmp272=((($138))|0)==((($conv271))|0); //@line 3177 "dictionary.cpp"
              if (!($cmp272)) { __label__ = 94;break $if_then258$$if_end296$122; } //@line 3177 "dictionary.cpp"
  
              var $141=HEAP32[((_dictionary_skipwords)>>2)]; //@line 3180 "dictionary.cpp"
              var $tobool274=((($141))|0)!=0; //@line 3180 "dictionary.cpp"
              if ($tobool274) { __label__ = 90;; } else { __label__ = 92;; } //@line 3180 "dictionary.cpp"
              $land_lhs_true275$$if_else289$132: do { 
                if (__label__ == 90) {
  
                  var $142=$wtab_addr; //@line 3180 "dictionary.cpp"
                  var $cmp276=((($142))|0)!=0; //@line 3180 "dictionary.cpp"
                  if (!($cmp276)) { __label__ = 92;break $land_lhs_true275$$if_else289$132; } //@line 3180 "dictionary.cpp"
  
                  var $arraydecay278=(($word_buf)&4294967295); //@line 3184 "dictionary.cpp"
                  var $143=$word2_addr; //@line 3184 "dictionary.cpp"
                  var $144=$word_end; //@line 3184 "dictionary.cpp"
                  var $145=$word2_addr; //@line 3184 "dictionary.cpp"
                  var $sub_ptr_lhs_cast279=($144); //@line 3184 "dictionary.cpp"
                  var $sub_ptr_rhs_cast280=($145); //@line 3184 "dictionary.cpp"
                  var $sub_ptr_sub281=((($sub_ptr_lhs_cast279)-($sub_ptr_rhs_cast280))&4294967295); //@line 3184 "dictionary.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $143;
                  $dest$ = $arraydecay278;
                  $stop$ = $src$ + $sub_ptr_sub281;
                  if (($dest$%4) == ($src$%4) && $sub_ptr_sub281 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 3184 "dictionary.cpp"
                  var $146=$word_end; //@line 3185 "dictionary.cpp"
                  var $147=$word2_addr; //@line 3185 "dictionary.cpp"
                  var $sub_ptr_lhs_cast282=($146); //@line 3185 "dictionary.cpp"
                  var $sub_ptr_rhs_cast283=($147); //@line 3185 "dictionary.cpp"
                  var $sub_ptr_rhs_cast283_neg=(((-($sub_ptr_rhs_cast283)))&4294967295);
                  var $sub_ptr_sub284=((($sub_ptr_lhs_cast282)-1)&4294967295); //@line 3185 "dictionary.cpp"
                  var $sub285=((($sub_ptr_sub284)+($sub_ptr_rhs_cast283_neg))&4294967295); //@line 3185 "dictionary.cpp"
                  var $arrayidx286=(($word_buf+$sub285)&4294967295); //@line 3185 "dictionary.cpp"
                  HEAP8[($arrayidx286)]=0; //@line 3185 "dictionary.cpp"
                  var $148=HEAP32[((_f_trans)>>2)]; //@line 3186 "dictionary.cpp"
                  var $149=$word1; //@line 3186 "dictionary.cpp"
                  var $arraydecay287=(($word_buf)&4294967295); //@line 3186 "dictionary.cpp"
                  var $call288=_fprintf($148, ((__str29145)&4294967295), allocate([$149,0,0,0,$arraydecay287,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3186 "dictionary.cpp"
                  __label__ = 93;break $land_lhs_true275$$if_else289$132; //@line 3187 "dictionary.cpp"
                }
              } while(0);
              if (__label__ == 92) {
  
                var $150=HEAP32[((_f_trans)>>2)]; //@line 3190 "dictionary.cpp"
                var $151=$word1; //@line 3190 "dictionary.cpp"
                var $call290=_fprintf($150, ((__str30146)&4294967295), allocate([$151,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 3190 "dictionary.cpp"
                ;
              }
  
              var $152=HEAP32[((_f_trans)>>2)]; //@line 3192 "dictionary.cpp"
              var $arraydecay292=(($ph_decoded)&4294967295); //@line 3192 "dictionary.cpp"
              var $153=$flags_addr; //@line 3192 "dictionary.cpp"
              var $call293=__Z22print_dictionary_flagsPj($153); //@line 3192 "dictionary.cpp"
              var $call294=_fprintf($152, ((__str31147)&4294967295), allocate([$arraydecay292,0,0,0,((__ZZ22print_dictionary_flagsPjE3buf)&4294967295),0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 3192 "dictionary.cpp"
              ; //@line 3193 "dictionary.cpp"
            }
          } while(0);
  
          var $154=$word_end; //@line 3195 "dictionary.cpp"
          $retval=$154; //@line 3195 "dictionary.cpp"
          ; //@line 3195 "dictionary.cpp"
        }
      }
    }
  
    var $155=$retval; //@line 3199 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $155; //@line 3199 "dictionary.cpp"
    return null;
  }
  

  function __Z11LookupFlagsP10TranslatorPKc($tr, $word) {
    var __stackBase__  = STACKTOP; STACKTOP += 104; _memset(__stackBase__, 0, 104);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $buf=__stackBase__;
    var $word1=__stackBase__+100;
    $tr_addr=$tr;
    $word_addr=$word;
    HEAP32[((((__ZZ11LookupFlagsP10TranslatorPKcE5flags+4)&4294967295))>>2)]=0; //@line 3379 "dictionary.cpp"
    HEAP32[((((__ZZ11LookupFlagsP10TranslatorPKcE5flags)&4294967295))>>2)]=0; //@line 3379 "dictionary.cpp"
    var $0=$word_addr; //@line 3380 "dictionary.cpp"
    HEAP32[(($word1)>>2)]=$0; //@line 3380 "dictionary.cpp"
    var $1=$tr_addr; //@line 3381 "dictionary.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 3381 "dictionary.cpp"
    var $call=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($1, $word1, $arraydecay, ((__ZZ11LookupFlagsP10TranslatorPKcE5flags)&4294967295), 0, 0); //@line 3381 "dictionary.cpp"
    var $2=HEAP32[((((__ZZ11LookupFlagsP10TranslatorPKcE5flags)&4294967295))>>2)]; //@line 3382 "dictionary.cpp"
    STACKTOP = __stackBase__;
    return $2; //@line 3382 "dictionary.cpp"
    return null;
  }
  

  function __Z12RemoveEndingP10TranslatorPciS1_($tr, $word, $end_type, $word_copy) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $word_addr;
    var $end_type_addr;
    var $word_copy_addr;
    var $i;
    var $word_end;
    var $len_ending;
    var $end_flags;
    var $p;
    var $len;
    $tr_addr=$tr;
    $word_addr=$word;
    $end_type_addr=$end_type;
    $word_copy_addr=$word_copy;
    var $0=$word_addr; //@line 3414 "dictionary.cpp"
    $word_end=$0; //@line 3414 "dictionary.cpp"
    var $1=$word_end; //@line 3414 "dictionary.cpp"
    var $2=HEAP8[($1)]; //@line 3414 "dictionary.cpp"
    var $conv8=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 3414 "dictionary.cpp"
    var $cmp10=((($conv8))|0)!=32; //@line 3414 "dictionary.cpp"
    var $3=$word_end; //@line 3417 "dictionary.cpp"
    if ($cmp10) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 4;; } //@line 3414 "dictionary.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $4=__lastLabel__ == 3 ? $10 : ($3);
          var $5=HEAP8[($4)]; //@line 3417 "dictionary.cpp"
          var $conv1=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 3417 "dictionary.cpp"
          var $cmp2=((($conv1))|0)==69; //@line 3417 "dictionary.cpp"
          if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 3417 "dictionary.cpp"
          if (__label__ == 2) {
  
            var $6=$word_end; //@line 3418 "dictionary.cpp"
            HEAP8[($6)]=101; //@line 3418 "dictionary.cpp"
            ; //@line 3418 "dictionary.cpp"
          }
  
          var $7=$word_end; //@line 3414 "dictionary.cpp"
          var $incdec_ptr=(($7+1)&4294967295); //@line 3414 "dictionary.cpp"
          $word_end=$incdec_ptr; //@line 3414 "dictionary.cpp"
          var $8=$word_end; //@line 3414 "dictionary.cpp"
          var $9=HEAP8[($8)]; //@line 3414 "dictionary.cpp"
          var $conv=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 3414 "dictionary.cpp"
          var $cmp=((($conv))|0)!=32; //@line 3414 "dictionary.cpp"
          var $10=$word_end; //@line 3417 "dictionary.cpp"
          if ($cmp) { __lastLabel__ = 3; __label__ = 1;continue ; } else { __lastLabel__ = 3; __label__ = 4;break $for_body$$for_end$2; } //@line 3414 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $_lcssa7=__lastLabel__ == 0 ? $3 : ($10);
    var $11=$word_addr; //@line 3420 "dictionary.cpp"
    var $sub_ptr_lhs_cast=($_lcssa7); //@line 3420 "dictionary.cpp"
    var $sub_ptr_rhs_cast=($11); //@line 3420 "dictionary.cpp"
    var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 3420 "dictionary.cpp"
    $i=$sub_ptr_sub; //@line 3420 "dictionary.cpp"
    var $12=$word_copy_addr; //@line 3421 "dictionary.cpp"
    var $13=$word_addr; //@line 3421 "dictionary.cpp"
    var $14=$i; //@line 3421 "dictionary.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $13;
    $dest$ = $12;
    $stop$ = $src$ + $14;
    if (($dest$%4) == ($src$%4) && $14 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 3421 "dictionary.cpp"
    var $15=$i; //@line 3422 "dictionary.cpp"
    var $16=$word_copy_addr; //@line 3422 "dictionary.cpp"
    var $arrayidx=(($16+$15)&4294967295); //@line 3422 "dictionary.cpp"
    HEAP8[($arrayidx)]=0; //@line 3422 "dictionary.cpp"
    var $17=$end_type_addr; //@line 3425 "dictionary.cpp"
    var $and=($17) & 63; //@line 3425 "dictionary.cpp"
    $i=$and; //@line 3425 "dictionary.cpp"
    $len_ending=$and; //@line 3425 "dictionary.cpp"
    var $cmp46=((($and))|0) > 0; //@line 3425 "dictionary.cpp"
    if ($cmp46) { __label__ = 5;; } else { __label__ = 8;; } //@line 3425 "dictionary.cpp"
    $for_body5$$for_end12$9: do { 
      if (__label__ == 5) {
        $for_body5$10: while(1) { 
  
          var $18=$word_end; //@line 3427 "dictionary.cpp"
          var $incdec_ptr6=(($18+-1)&4294967295); //@line 3427 "dictionary.cpp"
          $word_end=$incdec_ptr6; //@line 3427 "dictionary.cpp"
          var $19=$word_end; //@line 3428 "dictionary.cpp"
          var $20=HEAP8[($19)]; //@line 3428 "dictionary.cpp"
          var $conv73=(tempInt=(($20)),(tempInt>=128?tempInt-256:tempInt)); //@line 3428 "dictionary.cpp"
          var $and84=($conv73) & 192; //@line 3428 "dictionary.cpp"
          var $cmp95=((($and84))|0)==128; //@line 3428 "dictionary.cpp"
          if ($cmp95) { __label__ = 6;; } else { __label__ = 7;; } //@line 3428 "dictionary.cpp"
          $while_body$$for_inc11$12: do { 
            if (__label__ == 6) {
              while(1) { 
  
                var $21=$word_end; //@line 3430 "dictionary.cpp"
                var $incdec_ptr10=(($21+-1)&4294967295); //@line 3430 "dictionary.cpp"
                $word_end=$incdec_ptr10; //@line 3430 "dictionary.cpp"
                var $22=$len_ending; //@line 3431 "dictionary.cpp"
                var $inc=((($22)+1)&4294967295); //@line 3431 "dictionary.cpp"
                $len_ending=$inc; //@line 3431 "dictionary.cpp"
                var $23=$word_end; //@line 3428 "dictionary.cpp"
                var $24=HEAP8[($23)]; //@line 3428 "dictionary.cpp"
                var $conv7=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 3428 "dictionary.cpp"
                var $and8=($conv7) & 192; //@line 3428 "dictionary.cpp"
                var $cmp9=((($and8))|0)==128; //@line 3428 "dictionary.cpp"
                if ($cmp9) { __label__ = 6;continue ; } else { __label__ = 7;break $while_body$$for_inc11$12; } //@line 3428 "dictionary.cpp"
              }
            }
          } while(0);
  
          var $25=$i; //@line 3425 "dictionary.cpp"
          var $dec=((($25)-1)&4294967295); //@line 3425 "dictionary.cpp"
          $i=$dec; //@line 3425 "dictionary.cpp"
          var $cmp4=((($dec))|0) > 0; //@line 3425 "dictionary.cpp"
          if ($cmp4) { __label__ = 5;continue $for_body5$10; } else { __label__ = 8;break $for_body5$$for_end12$9; } //@line 3425 "dictionary.cpp"
        }
      }
    } while(0);
  
    $i=0; //@line 3436 "dictionary.cpp"
    var $26=$i; //@line 3436 "dictionary.cpp"
    var $27=$len_ending; //@line 3436 "dictionary.cpp"
    var $cmp142=((($26))|0) < ((($27))|0); //@line 3436 "dictionary.cpp"
    var $28=$i; //@line 3438 "dictionary.cpp"
    if ($cmp142) { __lastLabel__ = 8; __label__ = 9;; } else { __lastLabel__ = 8; __label__ = 10;; } //@line 3436 "dictionary.cpp"
    $for_body15$$for_end21$17: do { 
      if (__label__ == 9) {
        while(1) { 
  
          var $29=__lastLabel__ == 9 ? $38 : ($28);
          var $30=$word_end; //@line 3438 "dictionary.cpp"
          var $arrayidx16=(($30+$29)&4294967295); //@line 3438 "dictionary.cpp"
          var $31=HEAP8[($arrayidx16)]; //@line 3438 "dictionary.cpp"
          var $32=$i; //@line 3438 "dictionary.cpp"
          var $arrayidx17=((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending+$32)&4294967295); //@line 3438 "dictionary.cpp"
          HEAP8[($arrayidx17)]=$31; //@line 3438 "dictionary.cpp"
          var $33=$i; //@line 3439 "dictionary.cpp"
          var $34=$word_end; //@line 3439 "dictionary.cpp"
          var $arrayidx18=(($34+$33)&4294967295); //@line 3439 "dictionary.cpp"
          HEAP8[($arrayidx18)]=32; //@line 3439 "dictionary.cpp"
          var $35=$i; //@line 3436 "dictionary.cpp"
          var $inc20=((($35)+1)&4294967295); //@line 3436 "dictionary.cpp"
          $i=$inc20; //@line 3436 "dictionary.cpp"
          var $36=$i; //@line 3436 "dictionary.cpp"
          var $37=$len_ending; //@line 3436 "dictionary.cpp"
          var $cmp14=((($36))|0) < ((($37))|0); //@line 3436 "dictionary.cpp"
          var $38=$i; //@line 3438 "dictionary.cpp"
          if ($cmp14) { __lastLabel__ = 9; __label__ = 9;continue ; } else { __lastLabel__ = 9; __label__ = 10;break $for_body15$$for_end21$17; } //@line 3436 "dictionary.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 8 ? $28 : ($38);
    var $arrayidx22=((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending+$_lcssa)&4294967295); //@line 3441 "dictionary.cpp"
    HEAP8[($arrayidx22)]=0; //@line 3441 "dictionary.cpp"
    var $39=$word_end; //@line 3442 "dictionary.cpp"
    var $incdec_ptr23=(($39+-1)&4294967295); //@line 3442 "dictionary.cpp"
    $word_end=$incdec_ptr23; //@line 3442 "dictionary.cpp"
    var $40=$end_type_addr; //@line 3444 "dictionary.cpp"
    var $and24=($40) & 65520; //@line 3444 "dictionary.cpp"
    var $or=($and24) | 4; //@line 3444 "dictionary.cpp"
    $end_flags=$or; //@line 3444 "dictionary.cpp"
    var $41=$end_type_addr; //@line 3450 "dictionary.cpp"
    var $and25=($41) & 512; //@line 3450 "dictionary.cpp"
    var $tobool=((($and25))|0)!=0; //@line 3450 "dictionary.cpp"
    if ($tobool) { __label__ = 11;; } else { __label__ = 13;; } //@line 3450 "dictionary.cpp"
    $if_then26$$if_end33$21: do { 
      if (__label__ == 11) {
  
        var $42=$word_end; //@line 3452 "dictionary.cpp"
        var $arrayidx27=(($42)&4294967295); //@line 3452 "dictionary.cpp"
        var $43=HEAP8[($arrayidx27)]; //@line 3452 "dictionary.cpp"
        var $conv28=(tempInt=(($43)),(tempInt>=128?tempInt-256:tempInt)); //@line 3452 "dictionary.cpp"
        var $cmp29=((($conv28))|0)==105; //@line 3452 "dictionary.cpp"
        if (!($cmp29)) { __label__ = 13;break $if_then26$$if_end33$21; } //@line 3452 "dictionary.cpp"
  
        var $44=$word_end; //@line 3453 "dictionary.cpp"
        var $arrayidx31=(($44)&4294967295); //@line 3453 "dictionary.cpp"
        HEAP8[($arrayidx31)]=121; //@line 3453 "dictionary.cpp"
        ; //@line 3453 "dictionary.cpp"
      }
    } while(0);
  
    var $45=$end_type_addr; //@line 3456 "dictionary.cpp"
    var $and34=($45) & 256; //@line 3456 "dictionary.cpp"
    var $tobool35=((($and34))|0)!=0; //@line 3456 "dictionary.cpp"
    if ($tobool35) { __label__ = 14;; } else { __label__ = 33;; } //@line 3456 "dictionary.cpp"
    $if_then36$$if_end98$25: do { 
      if (__label__ == 14) {
  
        var $46=$tr_addr; //@line 3458 "dictionary.cpp"
        var $translator_name=(($46+280)&4294967295); //@line 3458 "dictionary.cpp"
        var $47=HEAP32[(($translator_name)>>2)]; //@line 3458 "dictionary.cpp"
        var $cmp37=((($47))|0)==25966; //@line 3458 "dictionary.cpp"
        var $48=$tr_addr; //@line 3461 "dictionary.cpp"
        if ($cmp37) { __label__ = 15;; } else { __label__ = 28;; } //@line 3458 "dictionary.cpp"
        $if_then38$$if_else80$27: do { 
          if (__label__ == 15) {
  
            var $49=$word_end; //@line 3461 "dictionary.cpp"
            var $arrayidx39=(($49+-1)&4294967295); //@line 3461 "dictionary.cpp"
            var $50=HEAP8[($arrayidx39)]; //@line 3461 "dictionary.cpp"
            var $conv40=(tempInt=(($50)),(tempInt>=128?tempInt-256:tempInt)); //@line 3461 "dictionary.cpp"
            var $call=__ZL8IsLetterP10Translatorii($48, $conv40, 7); //@line 3461 "dictionary.cpp"
            var $tobool41=((($call))|0)!=0; //@line 3461 "dictionary.cpp"
            if ($tobool41) { __label__ = 16;; } else { __label__ = 23;; } //@line 3461 "dictionary.cpp"
            $land_lhs_true$$if_else$29: do { 
              if (__label__ == 16) {
  
                var $51=$tr_addr; //@line 3461 "dictionary.cpp"
                var $52=$word_end; //@line 3461 "dictionary.cpp"
                var $arrayidx42=(($52)&4294967295); //@line 3461 "dictionary.cpp"
                var $53=HEAP8[($arrayidx42)]; //@line 3461 "dictionary.cpp"
                var $conv43=(tempInt=(($53)),(tempInt>=128?tempInt-256:tempInt)); //@line 3461 "dictionary.cpp"
                var $call44=__ZL8IsLetterP10Translatorii($51, $conv43, 1); //@line 3461 "dictionary.cpp"
                var $tobool45=((($call44))|0)!=0; //@line 3461 "dictionary.cpp"
                if (!($tobool45)) { __label__ = 23;break $land_lhs_true$$if_else$29; } //@line 3461 "dictionary.cpp"
  
                $i=0; //@line 3465 "dictionary.cpp"
                ; //@line 3465 "dictionary.cpp"
                while(1) { 
  
                  var $54=$i; //@line 3465 "dictionary.cpp"
                  var $arrayidx48=((__ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions+$54*4)&4294967295); //@line 3465 "dictionary.cpp"
                  var $55=HEAP32[(($arrayidx48)>>2)]; //@line 3465 "dictionary.cpp"
                  $p=$55; //@line 3465 "dictionary.cpp"
                  var $cmp49=((($55))|0)!=0; //@line 3465 "dictionary.cpp"
                  if (!($cmp49)) { __label__ = 22;break ; } //@line 3465 "dictionary.cpp"
  
                  var $56=$p; //@line 3467 "dictionary.cpp"
                  var $call51=_strlen($56); //@line 3467 "dictionary.cpp"
                  $len=$call51; //@line 3467 "dictionary.cpp"
                  var $57=$p; //@line 3468 "dictionary.cpp"
                  var $58=$len; //@line 3468 "dictionary.cpp"
                  var $sub=((1-($58))&4294967295); //@line 3468 "dictionary.cpp"
                  var $59=$word_end; //@line 3468 "dictionary.cpp"
                  var $arrayidx52=(($59+$sub)&4294967295); //@line 3468 "dictionary.cpp"
                  var $60=$len; //@line 3468 "dictionary.cpp"
                  var $call53=_memcmp($57, $arrayidx52, $60); //@line 3468 "dictionary.cpp"
                  var $cmp54=((($call53))|0)==0; //@line 3468 "dictionary.cpp"
                  if ($cmp54) { __label__ = 21;break ; } //@line 3468 "dictionary.cpp"
  
                  var $61=$i; //@line 3465 "dictionary.cpp"
                  var $inc58=((($61)+1)&4294967295); //@line 3465 "dictionary.cpp"
                  $i=$inc58; //@line 3465 "dictionary.cpp"
                  __label__ = 18;continue ; //@line 3465 "dictionary.cpp"
                }
                if (__label__ == 21) {
  
                  var $_pr=$p; //@line 3473 "dictionary.cpp"
                  var $cmp60=((($_pr))|0)==0; //@line 3473 "dictionary.cpp"
                  if (!($cmp60)) { __label__ = 30;break $if_then38$$if_else80$27; } //@line 3473 "dictionary.cpp"
                }
  
                var $62=$end_flags; //@line 3474 "dictionary.cpp"
                var $or62=($62) | 16; //@line 3474 "dictionary.cpp"
                $end_flags=$or62; //@line 3474 "dictionary.cpp"
                __label__ = 30;break $if_then38$$if_else80$27; //@line 3474 "dictionary.cpp"
              }
            } while(0);
  
            $i=0; //@line 3478 "dictionary.cpp"
            ; //@line 3478 "dictionary.cpp"
            while(1) { 
  
              var $63=$i; //@line 3478 "dictionary.cpp"
              var $arrayidx65=((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+$63*4)&4294967295); //@line 3478 "dictionary.cpp"
              var $64=HEAP32[(($arrayidx65)>>2)]; //@line 3478 "dictionary.cpp"
              $p=$64; //@line 3478 "dictionary.cpp"
              var $cmp66=((($64))|0)!=0; //@line 3478 "dictionary.cpp"
              if (!($cmp66)) { __label__ = 30;break $if_then38$$if_else80$27; } //@line 3478 "dictionary.cpp"
  
              var $65=$p; //@line 3480 "dictionary.cpp"
              var $call68=_strlen($65); //@line 3480 "dictionary.cpp"
              $len=$call68; //@line 3480 "dictionary.cpp"
              var $66=$p; //@line 3481 "dictionary.cpp"
              var $67=$len; //@line 3481 "dictionary.cpp"
              var $sub69=((1-($67))&4294967295); //@line 3481 "dictionary.cpp"
              var $68=$word_end; //@line 3481 "dictionary.cpp"
              var $arrayidx70=(($68+$sub69)&4294967295); //@line 3481 "dictionary.cpp"
              var $69=$len; //@line 3481 "dictionary.cpp"
              var $call71=_memcmp($66, $arrayidx70, $69); //@line 3481 "dictionary.cpp"
              var $cmp72=((($call71))|0)==0; //@line 3481 "dictionary.cpp"
              if ($cmp72) { __label__ = 26;break ; } //@line 3481 "dictionary.cpp"
  
              var $71=$i; //@line 3478 "dictionary.cpp"
              var $inc77=((($71)+1)&4294967295); //@line 3478 "dictionary.cpp"
              $i=$inc77; //@line 3478 "dictionary.cpp"
              __label__ = 24;continue ; //@line 3478 "dictionary.cpp"
            }
  
            var $70=$end_flags; //@line 3483 "dictionary.cpp"
            var $or74=($70) | 16; //@line 3483 "dictionary.cpp"
            $end_flags=$or74; //@line 3483 "dictionary.cpp"
            ; //@line 3484 "dictionary.cpp"
          }
          else if (__label__ == 28) {
  
            var $langopts=(($48)&4294967295); //@line 3490 "dictionary.cpp"
            var $suffix_add_e=(($langopts+276)&4294967295); //@line 3490 "dictionary.cpp"
            var $72=HEAP32[(($suffix_add_e)>>2)]; //@line 3490 "dictionary.cpp"
            var $cmp81=((($72))|0)!=0; //@line 3490 "dictionary.cpp"
            if (!($cmp81)) { __label__ = 30;break $if_then38$$if_else80$27; } //@line 3490 "dictionary.cpp"
  
            var $73=$end_flags; //@line 3492 "dictionary.cpp"
            var $or83=($73) | 16; //@line 3492 "dictionary.cpp"
            $end_flags=$or83; //@line 3492 "dictionary.cpp"
            ; //@line 3493 "dictionary.cpp"
          }
        } while(0);
  
        var $74=$end_flags; //@line 3495 "dictionary.cpp"
        var $and86=($74) & 16; //@line 3495 "dictionary.cpp"
        var $tobool87=((($and86))|0)!=0; //@line 3495 "dictionary.cpp"
        if (!($tobool87)) { __label__ = 33;break $if_then36$$if_end98$25; } //@line 3495 "dictionary.cpp"
  
        var $75=$tr_addr; //@line 3497 "dictionary.cpp"
        var $langopts89=(($75)&4294967295); //@line 3497 "dictionary.cpp"
        var $suffix_add_e90=(($langopts89+276)&4294967295); //@line 3497 "dictionary.cpp"
        var $76=HEAP32[(($suffix_add_e90)>>2)]; //@line 3497 "dictionary.cpp"
        var $77=$word_end; //@line 3497 "dictionary.cpp"
        var $arrayidx91=(($77+1)&4294967295); //@line 3497 "dictionary.cpp"
        var $call92=__Z8utf8_outjPc($76, $arrayidx91); //@line 3497 "dictionary.cpp"
        var $78=HEAP32[((_option_phonemes)>>2)]; //@line 3499 "dictionary.cpp"
        var $cmp93=((($78))|0)==2; //@line 3499 "dictionary.cpp"
        if (!($cmp93)) { __label__ = 33;break $if_then36$$if_end98$25; } //@line 3499 "dictionary.cpp"
  
        var $79=HEAP32[((_f_trans)>>2)]; //@line 3501 "dictionary.cpp"
        var $80=_fwrite(((__str25141)&4294967295), 6, 1, $79); //@line 3501 "dictionary.cpp"
        ; //@line 3502 "dictionary.cpp"
      }
    } while(0);
  
    var $81=$end_type_addr; //@line 3506 "dictionary.cpp"
    var $and99=($81) & 2048; //@line 3506 "dictionary.cpp"
    var $tobool100=((($and99))|0)!=0; //@line 3506 "dictionary.cpp"
    if ($tobool100) { __label__ = 34;; } else { __label__ = 36;; } //@line 3506 "dictionary.cpp"
    $land_lhs_true101$$if_end105$51: do { 
      if (__label__ == 34) {
  
        var $82=$tr_addr; //@line 3506 "dictionary.cpp"
        var $expect_verb=(($82+8272)&4294967295); //@line 3506 "dictionary.cpp"
        var $83=HEAP32[(($expect_verb)>>2)]; //@line 3506 "dictionary.cpp"
        var $cmp102=((($83))|0)==0; //@line 3506 "dictionary.cpp"
        if (!($cmp102)) { __label__ = 36;break $land_lhs_true101$$if_end105$51; } //@line 3506 "dictionary.cpp"
  
        var $84=$tr_addr; //@line 3507 "dictionary.cpp"
        var $expect_verb104=(($84+8272)&4294967295); //@line 3507 "dictionary.cpp"
        HEAP32[(($expect_verb104)>>2)]=1; //@line 3507 "dictionary.cpp"
        ; //@line 3507 "dictionary.cpp"
      }
    } while(0);
  
    var $call106=_strcmp(((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending)&4294967295), ((__str5172)&4294967295)); //@line 3510 "dictionary.cpp"
    var $cmp107=((($call106))|0)==0; //@line 3510 "dictionary.cpp"
    if ($cmp107) { __label__ = 38;; } else { __label__ = 37;; } //@line 3510 "dictionary.cpp"
    $if_then110$$lor_lhs_false$55: do { 
      if (__label__ == 37) {
  
        var $call108=_strcmp(((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending)&4294967295), ((__str27143)&4294967295)); //@line 3510 "dictionary.cpp"
        var $cmp109=((($call108))|0)==0; //@line 3510 "dictionary.cpp"
        if ($cmp109) { __label__ = 38;break $if_then110$$lor_lhs_false$55; } else { __label__ = 39;break $if_then110$$lor_lhs_false$55; } //@line 3510 "dictionary.cpp"
      }
    } while(0);
    if (__label__ == 38) {
  
      var $85=$end_flags; //@line 3511 "dictionary.cpp"
      var $or111=($85) | 8; //@line 3511 "dictionary.cpp"
      $end_flags=$or111; //@line 3511 "dictionary.cpp"
      ; //@line 3511 "dictionary.cpp"
    }
  
    var $86=HEAP8[(((__ZZ12RemoveEndingP10TranslatorPciS1_E6ending)&4294967295))]; //@line 3514 "dictionary.cpp"
    var $conv113=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 3514 "dictionary.cpp"
    var $cmp114=((($conv113))|0)==39; //@line 3514 "dictionary.cpp"
    if ($cmp114) { __label__ = 40;; } else { __label__ = 41;; } //@line 3514 "dictionary.cpp"
    if (__label__ == 40) {
  
      var $87=$end_flags; //@line 3515 "dictionary.cpp"
      var $and116=($87) & -5; //@line 3515 "dictionary.cpp"
      $end_flags=$and116; //@line 3515 "dictionary.cpp"
      ; //@line 3515 "dictionary.cpp"
    }
  
    var $88=$end_flags; //@line 3517 "dictionary.cpp"
    ;
    return $88; //@line 3517 "dictionary.cpp"
    return null;
  }
  

  function __ZL13IsLetterGroupP10TranslatorPcii($tr, $word, $group, $pre) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $group_addr;
    var $pre_addr;
    var $p;
    var $w;
    var $len;
    $tr_addr=$tr;
    $word_addr=$word;
    $group_addr=$group;
    $pre_addr=$pre;
    $len=0; //@line 692 "dictionary.cpp"
    var $0=$group_addr; //@line 694 "dictionary.cpp"
    var $1=$tr_addr; //@line 694 "dictionary.cpp"
    var $letterGroups=(($1+5152)&4294967295); //@line 694 "dictionary.cpp"
    var $arrayidx=(($letterGroups+$0*4)&4294967295); //@line 694 "dictionary.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 694 "dictionary.cpp"
    $p=$2; //@line 694 "dictionary.cpp"
    var $3=$p; //@line 695 "dictionary.cpp"
    var $cmp=((($3))|0)==0; //@line 695 "dictionary.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 695 "dictionary.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 696 "dictionary.cpp"
      ; //@line 696 "dictionary.cpp"
    }
    else if (__label__ == 2) {
      $while_cond$4: while(1) { 
  
        var $4=$p; //@line 698 "dictionary.cpp"
        var $5=HEAP8[($4)]; //@line 698 "dictionary.cpp"
        var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 698 "dictionary.cpp"
        var $cmp1=((($conv))|0)!=7; //@line 698 "dictionary.cpp"
        if (!($cmp1)) { __label__ = 13;break $while_cond$4; } //@line 698 "dictionary.cpp"
  
        var $6=$pre_addr; //@line 700 "dictionary.cpp"
        var $tobool=((($6))|0)!=0; //@line 700 "dictionary.cpp"
        if ($tobool) { __label__ = 4;; } else { __label__ = 5;; } //@line 700 "dictionary.cpp"
        if (__label__ == 4) {
  
          var $7=$p; //@line 702 "dictionary.cpp"
          var $call=_strlen($7); //@line 702 "dictionary.cpp"
          $len=$call; //@line 702 "dictionary.cpp"
          var $8=$word_addr; //@line 703 "dictionary.cpp"
          var $9=$len; //@line 703 "dictionary.cpp"
          var $idx_neg=(((-($9)))&4294967295); //@line 703 "dictionary.cpp"
          var $add_ptr=(($8+$idx_neg)&4294967295); //@line 703 "dictionary.cpp"
          var $add_ptr3=(($add_ptr+1)&4294967295); //@line 703 "dictionary.cpp"
          $w=$add_ptr3; //@line 703 "dictionary.cpp"
          ; //@line 704 "dictionary.cpp"
        }
        else if (__label__ == 5) {
  
          var $10=$word_addr; //@line 707 "dictionary.cpp"
          $w=$10; //@line 707 "dictionary.cpp"
          ;
        }
  
        var $11=$p; //@line 709 "dictionary.cpp"
        var $12=HEAP8[($11)]; //@line 709 "dictionary.cpp"
        var $conv61=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
        var $13=$w; //@line 709 "dictionary.cpp"
        var $14=HEAP8[($13)]; //@line 709 "dictionary.cpp"
        var $conv72=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
        var $cmp83=((($conv61))|0)==((($conv72))|0); //@line 709 "dictionary.cpp"
        if ($cmp83) { __label__ = 7;; } else { __label__ = 8;; } //@line 709 "dictionary.cpp"
        $while_body9$$while_end$11: do { 
          if (__label__ == 7) {
            while(1) { 
  
              var $15=$w; //@line 711 "dictionary.cpp"
              var $incdec_ptr=(($15+1)&4294967295); //@line 711 "dictionary.cpp"
              $w=$incdec_ptr; //@line 711 "dictionary.cpp"
              var $16=$p; //@line 712 "dictionary.cpp"
              var $incdec_ptr10=(($16+1)&4294967295); //@line 712 "dictionary.cpp"
              $p=$incdec_ptr10; //@line 712 "dictionary.cpp"
              var $17=$p; //@line 709 "dictionary.cpp"
              var $18=HEAP8[($17)]; //@line 709 "dictionary.cpp"
              var $conv6=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
              var $19=$w; //@line 709 "dictionary.cpp"
              var $20=HEAP8[($19)]; //@line 709 "dictionary.cpp"
              var $conv7=(tempInt=(($20)),(tempInt>=128?tempInt-256:tempInt)); //@line 709 "dictionary.cpp"
              var $cmp8=((($conv6))|0)==((($conv7))|0); //@line 709 "dictionary.cpp"
              if ($cmp8) { __label__ = 7;continue ; } else { __label__ = 8;break $while_body9$$while_end$11; } //@line 709 "dictionary.cpp"
            }
          }
        } while(0);
  
        var $21=$p; //@line 714 "dictionary.cpp"
        var $22=HEAP8[($21)]; //@line 714 "dictionary.cpp"
        var $conv11=(tempInt=(($22)),(tempInt>=128?tempInt-256:tempInt)); //@line 714 "dictionary.cpp"
        var $cmp12=((($conv11))|0)==0; //@line 714 "dictionary.cpp"
        if ($cmp12) { __label__ = 9;break $while_cond$4; } //@line 714 "dictionary.cpp"
        while(1) { 
  
          var $27=$p; //@line 721 "dictionary.cpp"
          var $incdec_ptr19=(($27+1)&4294967295); //@line 721 "dictionary.cpp"
          $p=$incdec_ptr19; //@line 721 "dictionary.cpp"
          var $28=HEAP8[($27)]; //@line 721 "dictionary.cpp"
          var $conv20=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 721 "dictionary.cpp"
          var $cmp21=((($conv20))|0)!=0; //@line 721 "dictionary.cpp"
          if ($cmp21) { __label__ = 12;continue ; } else { __label__ = 2;continue $while_cond$4; } //@line 721 "dictionary.cpp"
        }
      }
      if (__label__ == 13) {
  
        $retval=0; //@line 723 "dictionary.cpp"
        ; //@line 723 "dictionary.cpp"
      }
      else if (__label__ == 9) {
  
        var $23=$pre_addr; //@line 716 "dictionary.cpp"
        var $tobool14=((($23))|0)!=0; //@line 716 "dictionary.cpp"
        if ($tobool14) { __label__ = 10;; } else { __label__ = 11;; } //@line 716 "dictionary.cpp"
        if (__label__ == 10) {
  
          var $24=$len; //@line 717 "dictionary.cpp"
          $retval=$24; //@line 717 "dictionary.cpp"
          ; //@line 717 "dictionary.cpp"
        }
        else if (__label__ == 11) {
  
          var $25=$w; //@line 718 "dictionary.cpp"
          var $26=$word_addr; //@line 718 "dictionary.cpp"
          var $sub_ptr_lhs_cast=($25); //@line 718 "dictionary.cpp"
          var $sub_ptr_rhs_cast=($26); //@line 718 "dictionary.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 718 "dictionary.cpp"
          $retval=$sub_ptr_sub; //@line 718 "dictionary.cpp"
          ; //@line 718 "dictionary.cpp"
        }
      }
    }
  
    var $29=$retval; //@line 724 "dictionary.cpp"
    ;
    return $29; //@line 724 "dictionary.cpp"
    return null;
  }
  

  function __Z11CalcPitchesP10Translatori($tr, $clause_type) {
    var __stackBase__  = STACKTOP; STACKTOP += 6000; _memset(__stackBase__, 0, 6000);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $clause_type_addr;
    var $p;
    var $syl;
    var $ix;
    var $x;
    var $st_ix;
    var $n_st;
    var $option;
    var $group_tone;
    var $group_tone_emph;
    var $group_tone_comma;
    var $ph_start;
    var $st_start;
    var $st_clause_end;
    var $count;
    var $n_primary;
    var $count_primary;
    var $ph;
    var $ph_end;
    var $syllable_tab2=__stackBase__;
    $tr_addr=$tr;
    $clause_type_addr=$clause_type;
    $ph_start=0; //@line 1126 "intonation.cpp"
    var $0=HEAP32[((_n_phoneme_list)>>2)]; //@line 1133 "intonation.cpp"
    $ph_end=$0; //@line 1133 "intonation.cpp"
    var $arraydecay=(($syllable_tab2)&4294967295); //@line 1137 "intonation.cpp"
    HEAP32[((__ZL12syllable_tab)>>2)]=$arraydecay; //@line 1137 "intonation.cpp"
    $n_st=0; //@line 1138 "intonation.cpp"
    $n_primary=0; //@line 1139 "intonation.cpp"
    $ix=0; //@line 1140 "intonation.cpp"
    var $1=$ix; //@line 1140 "intonation.cpp"
    var $2=HEAP32[((_n_phoneme_list)>>2)]; //@line 1140 "intonation.cpp"
    var $sub4=((($2)-1)&4294967295); //@line 1140 "intonation.cpp"
    var $cmp5=((($1))|0) < ((($sub4))|0); //@line 1140 "intonation.cpp"
    if ($cmp5) { __label__ = 1;; } else { __label__ = 8;; } //@line 1140 "intonation.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $3=$ix; //@line 1142 "intonation.cpp"
          var $arrayidx=((_phoneme_list+$3*24)&4294967295); //@line 1142 "intonation.cpp"
          $p=$arrayidx; //@line 1142 "intonation.cpp"
          var $4=$p; //@line 1143 "intonation.cpp"
          var $synthflags=(($4+4)&4294967295); //@line 1143 "intonation.cpp"
          var $5=HEAPU16[(($synthflags)>>1)]; //@line 1143 "intonation.cpp"
          var $conv=((($5))&65535); //@line 1143 "intonation.cpp"
          var $and=($conv) & 4; //@line 1143 "intonation.cpp"
          var $tobool=((($and))|0)!=0; //@line 1143 "intonation.cpp"
          if ($tobool) { __label__ = 2;; } else { __label__ = 4;; } //@line 1143 "intonation.cpp"
          $if_then$$if_else$5: do { 
            if (__label__ == 2) {
  
              var $6=$n_st; //@line 1145 "intonation.cpp"
              var $7=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1145 "intonation.cpp"
              var $arrayidx1=(($7+6*$6)&4294967295); //@line 1145 "intonation.cpp"
              var $flags=(($arrayidx1+2)&4294967295); //@line 1145 "intonation.cpp"
              HEAP8[($flags)]=0; //@line 1145 "intonation.cpp"
              var $8=$n_st; //@line 1146 "intonation.cpp"
              var $9=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1146 "intonation.cpp"
              var $arrayidx2=(($9+6*$8)&4294967295); //@line 1146 "intonation.cpp"
              var $env=(($arrayidx2+1)&4294967295); //@line 1146 "intonation.cpp"
              HEAP8[($env)]=0; //@line 1146 "intonation.cpp"
              var $10=$ix; //@line 1147 "intonation.cpp"
              var $add=((($10)+1)&4294967295); //@line 1147 "intonation.cpp"
              var $arrayidx3=((_phoneme_list+$add*24)&4294967295); //@line 1147 "intonation.cpp"
              var $type=(($arrayidx3+15)&4294967295); //@line 1147 "intonation.cpp"
              var $11=HEAP8[($type)]; //@line 1147 "intonation.cpp"
              var $12=$n_st; //@line 1147 "intonation.cpp"
              var $13=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1147 "intonation.cpp"
              var $arrayidx4=(($13+6*$12)&4294967295); //@line 1147 "intonation.cpp"
              var $nextph_type=(($arrayidx4+3)&4294967295); //@line 1147 "intonation.cpp"
              HEAP8[($nextph_type)]=$11; //@line 1147 "intonation.cpp"
              var $14=$p; //@line 1148 "intonation.cpp"
              var $stresslevel=(($14+1)&4294967295); //@line 1148 "intonation.cpp"
              var $15=HEAP8[($stresslevel)]; //@line 1148 "intonation.cpp"
              var $16=$n_st; //@line 1148 "intonation.cpp"
              var $inc=((($16)+1)&4294967295); //@line 1148 "intonation.cpp"
              $n_st=$inc; //@line 1148 "intonation.cpp"
              var $17=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1148 "intonation.cpp"
              var $arrayidx5=(($17+6*$16)&4294967295); //@line 1148 "intonation.cpp"
              var $stress=(($arrayidx5)&4294967295); //@line 1148 "intonation.cpp"
              HEAP8[($stress)]=$15; //@line 1148 "intonation.cpp"
              var $18=$p; //@line 1150 "intonation.cpp"
              var $stresslevel6=(($18+1)&4294967295); //@line 1150 "intonation.cpp"
              var $19=HEAPU8[($stresslevel6)]; //@line 1150 "intonation.cpp"
              var $conv7=((($19))&255); //@line 1150 "intonation.cpp"
              var $cmp8=((($conv7))|0) >= 4; //@line 1150 "intonation.cpp"
              if (!($cmp8)) { __label__ = 7;break $if_then$$if_else$5; } //@line 1150 "intonation.cpp"
  
              var $20=$n_primary; //@line 1151 "intonation.cpp"
              var $inc10=((($20)+1)&4294967295); //@line 1151 "intonation.cpp"
              $n_primary=$inc10; //@line 1151 "intonation.cpp"
              ; //@line 1151 "intonation.cpp"
            }
            else if (__label__ == 4) {
  
              var $21=$p; //@line 1154 "intonation.cpp"
              var $ph11=(($21+8)&4294967295); //@line 1154 "intonation.cpp"
              var $22=HEAP32[(($ph11)>>2)]; //@line 1154 "intonation.cpp"
              var $code=(($22+10)&4294967295); //@line 1154 "intonation.cpp"
              var $23=HEAPU8[($code)]; //@line 1154 "intonation.cpp"
              var $conv12=((($23))&255); //@line 1154 "intonation.cpp"
              var $cmp13=((($conv12))|0)==27; //@line 1154 "intonation.cpp"
              if (!($cmp13)) { __label__ = 7;break $if_then$$if_else$5; } //@line 1154 "intonation.cpp"
  
              var $24=$n_st; //@line 1154 "intonation.cpp"
              var $cmp14=((($24))|0) > 0; //@line 1154 "intonation.cpp"
              if (!($cmp14)) { __label__ = 7;break $if_then$$if_else$5; } //@line 1154 "intonation.cpp"
  
              var $25=$n_st; //@line 1156 "intonation.cpp"
              var $sub16=((($25)-1)&4294967295); //@line 1156 "intonation.cpp"
              var $26=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1156 "intonation.cpp"
              var $arrayidx17=(($26+6*$sub16)&4294967295); //@line 1156 "intonation.cpp"
              var $flags18=(($arrayidx17+2)&4294967295); //@line 1156 "intonation.cpp"
              var $27=HEAP8[($flags18)]; //@line 1156 "intonation.cpp"
              var $conv19=(tempInt=(($27)),(tempInt>=128?tempInt-256:tempInt)); //@line 1156 "intonation.cpp"
              var $or=($conv19) | 4; //@line 1156 "intonation.cpp"
              var $conv20=((($or)) & 255); //@line 1156 "intonation.cpp"
              HEAP8[($flags18)]=$conv20; //@line 1156 "intonation.cpp"
              ; //@line 1157 "intonation.cpp"
            }
          } while(0);
  
          var $28=$ix; //@line 1140 "intonation.cpp"
          var $inc23=((($28)+1)&4294967295); //@line 1140 "intonation.cpp"
          $ix=$inc23; //@line 1140 "intonation.cpp"
          var $29=$ix; //@line 1140 "intonation.cpp"
          var $30=HEAP32[((_n_phoneme_list)>>2)]; //@line 1140 "intonation.cpp"
          var $sub=((($30)-1)&4294967295); //@line 1140 "intonation.cpp"
          var $cmp=((($29))|0) < ((($sub))|0); //@line 1140 "intonation.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 8;break $for_body$$for_end$2; } //@line 1140 "intonation.cpp"
        }
      }
    } while(0);
  
    var $31=$n_st; //@line 1159 "intonation.cpp"
    var $32=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1159 "intonation.cpp"
    var $arrayidx24=(($32+6*$31)&4294967295); //@line 1159 "intonation.cpp"
    var $stress25=(($arrayidx24)&4294967295); //@line 1159 "intonation.cpp"
    HEAP8[($stress25)]=0; //@line 1159 "intonation.cpp"
    var $33=$n_st; //@line 1161 "intonation.cpp"
    var $cmp26=((($33))|0)==0; //@line 1161 "intonation.cpp"
    if ($cmp26) { __label__ = 70;; } else { __label__ = 9;; } //@line 1161 "intonation.cpp"
    $for_end258$$if_end28$13: do { 
      if (__label__ == 9) {
  
        var $34=$tr_addr; //@line 1166 "intonation.cpp"
        var $langopts=(($34)&4294967295); //@line 1166 "intonation.cpp"
        var $tone_language=(($langopts+224)&4294967295); //@line 1166 "intonation.cpp"
        var $35=HEAP32[(($tone_language)>>2)]; //@line 1166 "intonation.cpp"
        var $cmp29=((($35))|0)==1; //@line 1166 "intonation.cpp"
        var $36=$tr_addr; //@line 1168 "intonation.cpp"
        if ($cmp29) { __label__ = 10;; } else { __label__ = 11;; } //@line 1166 "intonation.cpp"
        if (__label__ == 10) {
  
          var $37=$clause_type_addr; //@line 1168 "intonation.cpp"
          __ZL16CalcPitches_ToneP10Translatori($36, $37); //@line 1168 "intonation.cpp"
          ; //@line 1169 "intonation.cpp"
        }
        else if (__label__ == 11) {
  
          var $langopts32=(($36)&4294967295); //@line 1173 "intonation.cpp"
          var $intonation_group=(($langopts32+228)&4294967295); //@line 1173 "intonation.cpp"
          var $38=HEAP32[(($intonation_group)>>2)]; //@line 1173 "intonation.cpp"
          $option=$38; //@line 1173 "intonation.cpp"
          var $39=$option; //@line 1174 "intonation.cpp"
          var $cmp33=((($39))|0) >= 8; //@line 1174 "intonation.cpp"
          if ($cmp33) { __label__ = 12;; } else { __label__ = 13;; } //@line 1174 "intonation.cpp"
          $if_end35_thread$$if_end35$18: do { 
            if (__label__ == 12) {
  
              $option=1; //@line 1175 "intonation.cpp"
              var $40=$clause_type_addr; //@line 1179 "intonation.cpp"
              __lastLabel__ = 12; __label__ = 15;break $if_end35_thread$$if_end35$18; //@line 1177 "intonation.cpp"
            }
            else if (__label__ == 13) {
  
              var $cmp36=((($39))|0)==0; //@line 1177 "intonation.cpp"
              var $41=$clause_type_addr; //@line 1179 "intonation.cpp"
              if ($cmp36) { __lastLabel__ = 13; ; } else { __lastLabel__ = 13; __label__ = 15;break $if_end35_thread$$if_end35$18; } //@line 1177 "intonation.cpp"
  
              var $42=$tr_addr; //@line 1179 "intonation.cpp"
              var $langopts38=(($42)&4294967295); //@line 1179 "intonation.cpp"
              var $tunes=(($langopts38+232)&4294967295); //@line 1179 "intonation.cpp"
              var $arrayidx39=(($tunes+$41)&4294967295); //@line 1179 "intonation.cpp"
              var $43=HEAPU8[($arrayidx39)]; //@line 1179 "intonation.cpp"
              var $conv40=((($43))&255); //@line 1179 "intonation.cpp"
              $group_tone=$conv40; //@line 1179 "intonation.cpp"
              var $44=$tr_addr; //@line 1180 "intonation.cpp"
              var $langopts41=(($44)&4294967295); //@line 1180 "intonation.cpp"
              var $tunes42=(($langopts41+232)&4294967295); //@line 1180 "intonation.cpp"
              var $arrayidx43=(($tunes42+5)&4294967295); //@line 1180 "intonation.cpp"
              var $45=HEAPU8[($arrayidx43)]; //@line 1180 "intonation.cpp"
              var $conv44=((($45))&255); //@line 1180 "intonation.cpp"
              $group_tone_emph=$conv44; //@line 1180 "intonation.cpp"
              var $46=$tr_addr; //@line 1181 "intonation.cpp"
              var $langopts45=(($46)&4294967295); //@line 1181 "intonation.cpp"
              var $tunes46=(($langopts45+232)&4294967295); //@line 1181 "intonation.cpp"
              var $arrayidx47=(($tunes46+1)&4294967295); //@line 1181 "intonation.cpp"
              var $47=HEAPU8[($arrayidx47)]; //@line 1181 "intonation.cpp"
              var $conv48=((($47))&255); //@line 1181 "intonation.cpp"
              $group_tone_comma=$conv48; //@line 1181 "intonation.cpp"
              __label__ = 16;break $if_end35_thread$$if_end35$18; //@line 1182 "intonation.cpp"
            }
          } while(0);
          if (__label__ == 15) {
  
            var $48=__lastLabel__ == 12 ? $40 : ($41);
            var $49=$option; //@line 1185 "intonation.cpp"
            var $50=$tr_addr; //@line 1185 "intonation.cpp"
            var $punct_to_tone=(($50+1000)&4294967295); //@line 1185 "intonation.cpp"
            var $arrayidx50=(($punct_to_tone+$49*6)&4294967295); //@line 1185 "intonation.cpp"
            var $arrayidx51=(($arrayidx50+$48)&4294967295); //@line 1185 "intonation.cpp"
            var $51=HEAPU8[($arrayidx51)]; //@line 1185 "intonation.cpp"
            var $conv52=((($51))&255); //@line 1185 "intonation.cpp"
            $group_tone=$conv52; //@line 1185 "intonation.cpp"
            var $52=$option; //@line 1186 "intonation.cpp"
            var $53=$tr_addr; //@line 1186 "intonation.cpp"
            var $punct_to_tone53=(($53+1000)&4294967295); //@line 1186 "intonation.cpp"
            var $arrayidx54=(($punct_to_tone53+$52*6)&4294967295); //@line 1186 "intonation.cpp"
            var $arrayidx55=(($arrayidx54+5)&4294967295); //@line 1186 "intonation.cpp"
            var $54=HEAPU8[($arrayidx55)]; //@line 1186 "intonation.cpp"
            var $conv56=((($54))&255); //@line 1186 "intonation.cpp"
            $group_tone_emph=$conv56; //@line 1186 "intonation.cpp"
            var $55=$option; //@line 1187 "intonation.cpp"
            var $56=$tr_addr; //@line 1187 "intonation.cpp"
            var $punct_to_tone57=(($56+1000)&4294967295); //@line 1187 "intonation.cpp"
            var $arrayidx58=(($punct_to_tone57+$55*6)&4294967295); //@line 1187 "intonation.cpp"
            var $arrayidx59=(($arrayidx58+1)&4294967295); //@line 1187 "intonation.cpp"
            var $57=HEAPU8[($arrayidx59)]; //@line 1187 "intonation.cpp"
            var $conv60=((($57))&255); //@line 1187 "intonation.cpp"
            $group_tone_comma=$conv60; //@line 1187 "intonation.cpp"
            ;
          }
  
          var $58=$clause_type_addr; //@line 1190 "intonation.cpp"
          var $cmp62=((($58))|0)==4; //@line 1190 "intonation.cpp"
          if ($cmp62) { __label__ = 17;; } else { __label__ = 18;; } //@line 1190 "intonation.cpp"
          if (__label__ == 17) {
  
            HEAP8[(__ZL8no_tonic_b)]=1;
            ; //@line 1191 "intonation.cpp"
          }
          else if (__label__ == 18) {
  
            HEAP8[(__ZL8no_tonic_b)]=0;
            ;
          }
  
          $st_start=0; //@line 1195 "intonation.cpp"
          $count_primary=0; //@line 1196 "intonation.cpp"
          $st_ix=0; //@line 1197 "intonation.cpp"
          var $59=$st_ix; //@line 1197 "intonation.cpp"
          var $60=$n_st; //@line 1197 "intonation.cpp"
          var $cmp673=((($59))|0) < ((($60))|0); //@line 1197 "intonation.cpp"
          if ($cmp673) { __label__ = 20;; } else { __label__ = 54;; } //@line 1197 "intonation.cpp"
          $for_body68$$for_end177$29: do { 
            if (__label__ == 20) {
              $for_body68$30: while(1) { 
  
                var $61=$st_ix; //@line 1199 "intonation.cpp"
                var $62=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1199 "intonation.cpp"
                var $arrayidx69=(($62+6*$61)&4294967295); //@line 1199 "intonation.cpp"
                $syl=$arrayidx69; //@line 1199 "intonation.cpp"
                var $63=$syl; //@line 1201 "intonation.cpp"
                var $stress70=(($63)&4294967295); //@line 1201 "intonation.cpp"
                var $64=HEAP8[($stress70)]; //@line 1201 "intonation.cpp"
                var $conv71=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt)); //@line 1201 "intonation.cpp"
                var $cmp72=((($conv71))|0) >= 4; //@line 1201 "intonation.cpp"
                if ($cmp72) { __label__ = 21;; } else { __label__ = 22;; } //@line 1201 "intonation.cpp"
                if (__label__ == 21) {
  
                  var $65=$count_primary; //@line 1202 "intonation.cpp"
                  var $inc74=((($65)+1)&4294967295); //@line 1202 "intonation.cpp"
                  $count_primary=$inc74; //@line 1202 "intonation.cpp"
                  ; //@line 1202 "intonation.cpp"
                }
  
                var $66=$syl; //@line 1204 "intonation.cpp"
                var $stress76=(($66)&4294967295); //@line 1204 "intonation.cpp"
                var $67=HEAP8[($stress76)]; //@line 1204 "intonation.cpp"
                var $conv77=(tempInt=(($67)),(tempInt>=128?tempInt-256:tempInt)); //@line 1204 "intonation.cpp"
                var $cmp78=((($conv77))|0)==6; //@line 1204 "intonation.cpp"
                if ($cmp78) { __label__ = 23;; } else { __label__ = 36;; } //@line 1204 "intonation.cpp"
                $if_then79$$if_end124$35: do { 
                  if (__label__ == 23) {
  
                    var $68=$st_ix; //@line 1207 "intonation.cpp"
                    var $sub80=((($68)-1)&4294967295); //@line 1207 "intonation.cpp"
                    $ix=$sub80; //@line 1207 "intonation.cpp"
                    ; //@line 1207 "intonation.cpp"
                    $for_cond81$37: while(1) { 
  
                      var $69=$ix; //@line 1207 "intonation.cpp"
                      var $70=$st_start; //@line 1207 "intonation.cpp"
                      var $cmp82=((($69))|0) >= ((($70))|0); //@line 1207 "intonation.cpp"
                      if (!($cmp82)) { __label__ = 30;break $for_cond81$37; } //@line 1207 "intonation.cpp"
  
                      var $71=$ix; //@line 1207 "intonation.cpp"
                      var $72=$st_ix; //@line 1207 "intonation.cpp"
                      var $sub83=((($72)-3)&4294967295); //@line 1207 "intonation.cpp"
                      var $cmp84=((($71))|0) >= ((($sub83))|0); //@line 1207 "intonation.cpp"
                      if (!($cmp84)) { __label__ = 30;break $for_cond81$37; }
  
                      var $73=$ix; //@line 1209 "intonation.cpp"
                      var $74=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1209 "intonation.cpp"
                      var $arrayidx86=(($74+6*$73)&4294967295); //@line 1209 "intonation.cpp"
                      var $stress87=(($arrayidx86)&4294967295); //@line 1209 "intonation.cpp"
                      var $75=HEAP8[($stress87)]; //@line 1209 "intonation.cpp"
                      var $conv88=(tempInt=(($75)),(tempInt>=128?tempInt-256:tempInt)); //@line 1209 "intonation.cpp"
                      var $cmp89=((($conv88))|0)==6; //@line 1209 "intonation.cpp"
                      if ($cmp89) { __label__ = 30;break $for_cond81$37; } //@line 1209 "intonation.cpp"
  
                      var $76=$ix; //@line 1211 "intonation.cpp"
                      var $77=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1211 "intonation.cpp"
                      var $arrayidx92=(($77+6*$76)&4294967295); //@line 1211 "intonation.cpp"
                      var $stress93=(($arrayidx92)&4294967295); //@line 1211 "intonation.cpp"
                      var $78=HEAP8[($stress93)]; //@line 1211 "intonation.cpp"
                      var $conv94=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 1211 "intonation.cpp"
                      var $cmp95=((($conv94))|0)==4; //@line 1211 "intonation.cpp"
                      var $79=$ix; //@line 1213 "intonation.cpp"
                      if ($cmp95) { __label__ = 28;break $for_cond81$37; } //@line 1211 "intonation.cpp"
  
                      var $dec=((($79)-1)&4294967295); //@line 1207 "intonation.cpp"
                      $ix=$dec; //@line 1207 "intonation.cpp"
                      __label__ = 24;continue $for_cond81$37; //@line 1207 "intonation.cpp"
                    }
                    if (__label__ == 28) {
  
                      var $80=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1213 "intonation.cpp"
                      var $arrayidx97=(($80+6*$79)&4294967295); //@line 1213 "intonation.cpp"
                      var $stress98=(($arrayidx97)&4294967295); //@line 1213 "intonation.cpp"
                      HEAP8[($stress98)]=3; //@line 1213 "intonation.cpp"
                      ; //@line 1214 "intonation.cpp"
                    }
  
                    var $81=$st_ix; //@line 1219 "intonation.cpp"
                    var $add102=((($81)+1)&4294967295); //@line 1219 "intonation.cpp"
                    $ix=$add102; //@line 1219 "intonation.cpp"
                    ; //@line 1219 "intonation.cpp"
                    while(1) { 
  
                      var $82=$ix; //@line 1219 "intonation.cpp"
                      var $83=$n_st; //@line 1219 "intonation.cpp"
                      var $cmp104=((($82))|0) < ((($83))|0); //@line 1219 "intonation.cpp"
                      if (!($cmp104)) { __label__ = 36;break $if_then79$$if_end124$35; } //@line 1219 "intonation.cpp"
  
                      var $84=$ix; //@line 1221 "intonation.cpp"
                      var $85=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1221 "intonation.cpp"
                      var $arrayidx106=(($85+6*$84)&4294967295); //@line 1221 "intonation.cpp"
                      var $stress107=(($arrayidx106)&4294967295); //@line 1221 "intonation.cpp"
                      var $86=HEAP8[($stress107)]; //@line 1221 "intonation.cpp"
                      var $conv108=(tempInt=(($86)),(tempInt>=128?tempInt-256:tempInt)); //@line 1221 "intonation.cpp"
                      var $cmp109=((($conv108))|0)==4; //@line 1221 "intonation.cpp"
                      if ($cmp109) { __label__ = 36;break $if_then79$$if_end124$35; } //@line 1221 "intonation.cpp"
  
                      var $87=$ix; //@line 1223 "intonation.cpp"
                      var $88=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1223 "intonation.cpp"
                      var $arrayidx112=(($88+6*$87)&4294967295); //@line 1223 "intonation.cpp"
                      var $stress113=(($arrayidx112)&4294967295); //@line 1223 "intonation.cpp"
                      var $89=HEAP8[($stress113)]; //@line 1223 "intonation.cpp"
                      var $conv114=(tempInt=(($89)),(tempInt>=128?tempInt-256:tempInt)); //@line 1223 "intonation.cpp"
                      var $cmp115=((($conv114))|0)==6; //@line 1223 "intonation.cpp"
                      if ($cmp115) { __label__ = 34;break ; } //@line 1223 "intonation.cpp"
  
                      var $93=$ix; //@line 1219 "intonation.cpp"
                      var $inc122=((($93)+1)&4294967295); //@line 1219 "intonation.cpp"
                      $ix=$inc122; //@line 1219 "intonation.cpp"
                      __label__ = 31;continue ; //@line 1219 "intonation.cpp"
                    }
  
                    var $90=$st_ix; //@line 1226 "intonation.cpp"
                    var $91=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1226 "intonation.cpp"
                    var $arrayidx117=(($91+6*$90)&4294967295); //@line 1226 "intonation.cpp"
                    var $flags118=(($arrayidx117+2)&4294967295); //@line 1226 "intonation.cpp"
                    HEAP8[($flags118)]=2; //@line 1226 "intonation.cpp"
                    var $92=$syl; //@line 1227 "intonation.cpp"
                    var $stress119=(($92)&4294967295); //@line 1227 "intonation.cpp"
                    HEAP8[($stress119)]=5; //@line 1227 "intonation.cpp"
                    ; //@line 1228 "intonation.cpp"
                  }
                } while(0);
  
                var $94=$syl; //@line 1233 "intonation.cpp"
                var $stress125=(($94)&4294967295); //@line 1233 "intonation.cpp"
                var $95=HEAP8[($stress125)]; //@line 1233 "intonation.cpp"
                var $conv126=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 1233 "intonation.cpp"
                var $cmp127=((($conv126))|0)==6; //@line 1233 "intonation.cpp"
                if ($cmp127) { __label__ = 37;; } else { __label__ = 50;; } //@line 1233 "intonation.cpp"
                if (__label__ == 37) {
  
                  var $96=$st_ix; //@line 1236 "intonation.cpp"
                  var $97=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1236 "intonation.cpp"
                  var $arrayidx129=(($97+6*$96)&4294967295); //@line 1236 "intonation.cpp"
                  var $flags130=(($arrayidx129+2)&4294967295); //@line 1236 "intonation.cpp"
                  HEAP8[($flags130)]=2; //@line 1236 "intonation.cpp"
                  $count=0; //@line 1238 "intonation.cpp"
                  var $98=$n_primary; //@line 1239 "intonation.cpp"
                  var $99=$count_primary; //@line 1239 "intonation.cpp"
                  var $sub131=((($98)-($99))&4294967295); //@line 1239 "intonation.cpp"
                  var $cmp132=((($sub131))|0) > 1; //@line 1239 "intonation.cpp"
                  if ($cmp132) { __label__ = 38;; } else { __label__ = 39;; } //@line 1239 "intonation.cpp"
                  if (__label__ == 38) {
  
                    $count=1; //@line 1240 "intonation.cpp"
                    ; //@line 1240 "intonation.cpp"
                  }
  
                  var $100=$st_ix; //@line 1242 "intonation.cpp"
                  var $add135=((($100)+1)&4294967295); //@line 1242 "intonation.cpp"
                  $ix=$add135; //@line 1242 "intonation.cpp"
                  ; //@line 1242 "intonation.cpp"
                  $for_cond136$58: while(1) { 
  
                    var $101=$ix; //@line 1242 "intonation.cpp"
                    var $102=$n_st; //@line 1242 "intonation.cpp"
                    var $cmp137=((($101))|0) < ((($102))|0); //@line 1242 "intonation.cpp"
                    if (!($cmp137)) { __label__ = 45;break $for_cond136$58; } //@line 1242 "intonation.cpp"
  
                    var $103=$ix; //@line 1244 "intonation.cpp"
                    var $104=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1244 "intonation.cpp"
                    var $arrayidx139=(($104+6*$103)&4294967295); //@line 1244 "intonation.cpp"
                    var $stress140=(($arrayidx139)&4294967295); //@line 1244 "intonation.cpp"
                    var $105=HEAP8[($stress140)]; //@line 1244 "intonation.cpp"
                    var $conv141=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt)); //@line 1244 "intonation.cpp"
                    var $cmp142=((($conv141))|0) > 4; //@line 1244 "intonation.cpp"
                    if ($cmp142) { __label__ = 45;break $for_cond136$58; } //@line 1244 "intonation.cpp"
  
                    var $106=$ix; //@line 1246 "intonation.cpp"
                    var $107=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1246 "intonation.cpp"
                    var $arrayidx145=(($107+6*$106)&4294967295); //@line 1246 "intonation.cpp"
                    var $stress146=(($arrayidx145)&4294967295); //@line 1246 "intonation.cpp"
                    var $108=HEAP8[($stress146)]; //@line 1246 "intonation.cpp"
                    var $conv147=(tempInt=(($108)),(tempInt>=128?tempInt-256:tempInt)); //@line 1246 "intonation.cpp"
                    var $cmp148=((($conv147))|0)==4; //@line 1246 "intonation.cpp"
                    if ($cmp148) { __label__ = 43;; } else { __label__ = 44;; } //@line 1246 "intonation.cpp"
                    if (__label__ == 43) {
  
                      var $109=$count; //@line 1248 "intonation.cpp"
                      var $inc150=((($109)+1)&4294967295); //@line 1248 "intonation.cpp"
                      $count=$inc150; //@line 1248 "intonation.cpp"
                      var $110=$count; //@line 1249 "intonation.cpp"
                      var $cmp151=((($110))|0) > 1; //@line 1249 "intonation.cpp"
                      if ($cmp151) { __label__ = 45;break $for_cond136$58; } //@line 1249 "intonation.cpp"
                    }
  
                    var $111=$ix; //@line 1242 "intonation.cpp"
                    var $inc156=((($111)+1)&4294967295); //@line 1242 "intonation.cpp"
                    $ix=$inc156; //@line 1242 "intonation.cpp"
                    __label__ = 40;continue $for_cond136$58; //@line 1242 "intonation.cpp"
                  }
  
                  var $112=$st_start; //@line 1254 "intonation.cpp"
                  var $113=$ix; //@line 1254 "intonation.cpp"
                  var $114=$n_st; //@line 1254 "intonation.cpp"
                  __ZL18count_pitch_vowelsiii($112, $113, $114); //@line 1254 "intonation.cpp"
                  var $115=$ix; //@line 1255 "intonation.cpp"
                  var $116=$n_st; //@line 1255 "intonation.cpp"
                  var $cmp158=((($115))|0) < ((($116))|0); //@line 1255 "intonation.cpp"
                  if ($cmp158) { __label__ = 47;; } else { __label__ = 46;; } //@line 1255 "intonation.cpp"
                  $if_then160$$lor_lhs_false$66: do { 
                    if (__label__ == 46) {
  
                      var $117=$clause_type_addr; //@line 1255 "intonation.cpp"
                      var $cmp159=((($117))|0)==0; //@line 1255 "intonation.cpp"
                      if ($cmp159) { __label__ = 47;break $if_then160$$lor_lhs_false$66; } //@line 1255 "intonation.cpp"
  
                      var $122=$option; //@line 1258 "intonation.cpp"
                      var $123=$st_start; //@line 1258 "intonation.cpp"
                      var $124=$ix; //@line 1258 "intonation.cpp"
                      var $125=$group_tone; //@line 1258 "intonation.cpp"
                      __ZL12calc_pitchesiiii($122, $123, $124, $125); //@line 1258 "intonation.cpp"
                      __label__ = 49;break $if_then160$$lor_lhs_false$66;
                    }
                  } while(0);
                  if (__label__ == 47) {
  
                    var $118=$option; //@line 1256 "intonation.cpp"
                    var $119=$st_start; //@line 1256 "intonation.cpp"
                    var $120=$ix; //@line 1256 "intonation.cpp"
                    var $121=$group_tone_emph; //@line 1256 "intonation.cpp"
                    __ZL12calc_pitchesiiii($118, $119, $120, $121); //@line 1256 "intonation.cpp"
                    ; //@line 1256 "intonation.cpp"
                  }
  
                  var $126=$ix; //@line 1260 "intonation.cpp"
                  $st_start=$126; //@line 1260 "intonation.cpp"
                  ; //@line 1261 "intonation.cpp"
                }
  
                var $127=$st_start; //@line 1262 "intonation.cpp"
                var $128=$st_ix; //@line 1262 "intonation.cpp"
                var $cmp165=((($127))|0) < ((($128))|0); //@line 1262 "intonation.cpp"
                if ($cmp165) { __label__ = 51;; } else { __label__ = 53;; } //@line 1262 "intonation.cpp"
                $land_lhs_true166$$for_inc175$73: do { 
                  if (__label__ == 51) {
  
                    var $129=$syl; //@line 1262 "intonation.cpp"
                    var $flags167=(($129+2)&4294967295); //@line 1262 "intonation.cpp"
                    var $130=HEAP8[($flags167)]; //@line 1262 "intonation.cpp"
                    var $conv168=(tempInt=(($130)),(tempInt>=128?tempInt-256:tempInt)); //@line 1262 "intonation.cpp"
                    var $and169=($conv168) & 4; //@line 1262 "intonation.cpp"
                    var $tobool170=((($and169))|0)!=0; //@line 1262 "intonation.cpp"
                    if (!($tobool170)) { __label__ = 53;break $land_lhs_true166$$for_inc175$73; } //@line 1262 "intonation.cpp"
  
                    var $131=$st_ix; //@line 1265 "intonation.cpp"
                    var $add172=((($131)+1)&4294967295); //@line 1265 "intonation.cpp"
                    $st_clause_end=$add172; //@line 1265 "intonation.cpp"
                    var $132=$st_start; //@line 1266 "intonation.cpp"
                    var $133=$st_clause_end; //@line 1266 "intonation.cpp"
                    var $134=$st_clause_end; //@line 1266 "intonation.cpp"
                    __ZL18count_pitch_vowelsiii($132, $133, $134); //@line 1266 "intonation.cpp"
                    var $135=$option; //@line 1267 "intonation.cpp"
                    var $136=$st_start; //@line 1267 "intonation.cpp"
                    var $137=$st_clause_end; //@line 1267 "intonation.cpp"
                    var $138=$group_tone_comma; //@line 1267 "intonation.cpp"
                    __ZL12calc_pitchesiiii($135, $136, $137, $138); //@line 1267 "intonation.cpp"
                    var $139=$st_clause_end; //@line 1268 "intonation.cpp"
                    $st_start=$139; //@line 1268 "intonation.cpp"
                    ; //@line 1269 "intonation.cpp"
                  }
                } while(0);
  
                var $140=$st_ix; //@line 1197 "intonation.cpp"
                var $inc176=((($140)+1)&4294967295); //@line 1197 "intonation.cpp"
                $st_ix=$inc176; //@line 1197 "intonation.cpp"
                var $141=$st_ix; //@line 1197 "intonation.cpp"
                var $142=$n_st; //@line 1197 "intonation.cpp"
                var $cmp67=((($141))|0) < ((($142))|0); //@line 1197 "intonation.cpp"
                if ($cmp67) { __label__ = 20;continue $for_body68$30; } else { __label__ = 54;break $for_body68$$for_end177$29; } //@line 1197 "intonation.cpp"
              }
            }
          } while(0);
  
          var $143=$st_start; //@line 1272 "intonation.cpp"
          var $144=$st_ix; //@line 1272 "intonation.cpp"
          var $cmp178=((($143))|0) < ((($144))|0); //@line 1272 "intonation.cpp"
          if ($cmp178) { __label__ = 55;; } else { __label__ = 56;; } //@line 1272 "intonation.cpp"
          if (__label__ == 55) {
  
            var $145=$st_start; //@line 1274 "intonation.cpp"
            var $146=$st_ix; //@line 1274 "intonation.cpp"
            var $147=$n_st; //@line 1274 "intonation.cpp"
            __ZL18count_pitch_vowelsiii($145, $146, $147); //@line 1274 "intonation.cpp"
            var $148=$option; //@line 1275 "intonation.cpp"
            var $149=$st_start; //@line 1275 "intonation.cpp"
            var $150=$st_ix; //@line 1275 "intonation.cpp"
            var $151=$group_tone; //@line 1275 "intonation.cpp"
            __ZL12calc_pitchesiiii($148, $149, $150, $151); //@line 1275 "intonation.cpp"
            ; //@line 1276 "intonation.cpp"
          }
  
          $st_ix=0; //@line 1280 "intonation.cpp"
          var $152=$ph_start; //@line 1281 "intonation.cpp"
          $ix=$152; //@line 1281 "intonation.cpp"
          var $153=$ix; //@line 1281 "intonation.cpp"
          var $154=$ph_end; //@line 1281 "intonation.cpp"
          var $cmp1832=((($153))|0) < ((($154))|0); //@line 1281 "intonation.cpp"
          if (!($cmp1832)) { __label__ = 70;break $for_end258$$if_end28$13; } //@line 1281 "intonation.cpp"
          $for_body184$81: while(1) { 
  
            var $155=$ix; //@line 1283 "intonation.cpp"
            var $arrayidx185=((_phoneme_list+$155*24)&4294967295); //@line 1283 "intonation.cpp"
            $p=$arrayidx185; //@line 1283 "intonation.cpp"
            var $156=$st_ix; //@line 1284 "intonation.cpp"
            var $157=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1284 "intonation.cpp"
            var $arrayidx186=(($157+6*$156)&4294967295); //@line 1284 "intonation.cpp"
            var $stress187=(($arrayidx186)&4294967295); //@line 1284 "intonation.cpp"
            var $158=HEAP8[($stress187)]; //@line 1284 "intonation.cpp"
            var $159=$p; //@line 1284 "intonation.cpp"
            var $stresslevel188=(($159+1)&4294967295); //@line 1284 "intonation.cpp"
            HEAP8[($stresslevel188)]=$158; //@line 1284 "intonation.cpp"
            var $160=$p; //@line 1286 "intonation.cpp"
            var $synthflags189=(($160+4)&4294967295); //@line 1286 "intonation.cpp"
            var $161=HEAPU16[(($synthflags189)>>1)]; //@line 1286 "intonation.cpp"
            var $conv190=((($161))&65535); //@line 1286 "intonation.cpp"
            var $and191=($conv190) & 4; //@line 1286 "intonation.cpp"
            var $tobool192=((($and191))|0)!=0; //@line 1286 "intonation.cpp"
            if ($tobool192) { __label__ = 58;; } else { __label__ = 69;; } //@line 1286 "intonation.cpp"
            if (__label__ == 58) {
  
              var $162=$st_ix; //@line 1288 "intonation.cpp"
              var $163=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 1288 "intonation.cpp"
              var $arrayidx194=(($163+6*$162)&4294967295); //@line 1288 "intonation.cpp"
              $syl=$arrayidx194; //@line 1288 "intonation.cpp"
              var $164=$syl; //@line 1290 "intonation.cpp"
              var $pitch1=(($164+4)&4294967295); //@line 1290 "intonation.cpp"
              var $165=HEAP8[($pitch1)]; //@line 1290 "intonation.cpp"
              var $166=$p; //@line 1290 "intonation.cpp"
              var $pitch1195=(($166+20)&4294967295); //@line 1290 "intonation.cpp"
              HEAP8[($pitch1195)]=$165; //@line 1290 "intonation.cpp"
              var $167=$syl; //@line 1291 "intonation.cpp"
              var $pitch2=(($167+5)&4294967295); //@line 1291 "intonation.cpp"
              var $168=HEAP8[($pitch2)]; //@line 1291 "intonation.cpp"
              var $169=$p; //@line 1291 "intonation.cpp"
              var $pitch2196=(($169+21)&4294967295); //@line 1291 "intonation.cpp"
              HEAP8[($pitch2196)]=$168; //@line 1291 "intonation.cpp"
              var $170=$p; //@line 1293 "intonation.cpp"
              var $env197=(($170+14)&4294967295); //@line 1293 "intonation.cpp"
              HEAP8[($env197)]=0; //@line 1293 "intonation.cpp"
              var $171=$syl; //@line 1294 "intonation.cpp"
              var $flags198=(($171+2)&4294967295); //@line 1294 "intonation.cpp"
              var $172=HEAP8[($flags198)]; //@line 1294 "intonation.cpp"
              var $conv199=(tempInt=(($172)),(tempInt>=128?tempInt-256:tempInt)); //@line 1294 "intonation.cpp"
              var $and200=($conv199) & 1; //@line 1294 "intonation.cpp"
              var $tobool201=((($and200))|0)!=0; //@line 1294 "intonation.cpp"
              var $173=$p; //@line 1296 "intonation.cpp"
              if ($tobool201) { __label__ = 59;; } else { __label__ = 60;; } //@line 1294 "intonation.cpp"
              $if_then202$$if_else204$85: do { 
                if (__label__ == 59) {
  
                  var $env203=(($173+14)&4294967295); //@line 1296 "intonation.cpp"
                  HEAP8[($env203)]=2; //@line 1296 "intonation.cpp"
                  ; //@line 1297 "intonation.cpp"
                }
                else if (__label__ == 60) {
  
                  var $stresslevel205=(($173+1)&4294967295); //@line 1299 "intonation.cpp"
                  var $174=HEAPU8[($stresslevel205)]; //@line 1299 "intonation.cpp"
                  var $conv206=((($174))&255); //@line 1299 "intonation.cpp"
                  var $cmp207=((($conv206))|0) > 5; //@line 1299 "intonation.cpp"
                  if (!($cmp207)) { __label__ = 62;break $if_then202$$if_else204$85; } //@line 1299 "intonation.cpp"
  
                  var $175=$syl; //@line 1300 "intonation.cpp"
                  var $env209=(($175+1)&4294967295); //@line 1300 "intonation.cpp"
                  var $176=HEAP8[($env209)]; //@line 1300 "intonation.cpp"
                  var $177=$p; //@line 1300 "intonation.cpp"
                  var $env210=(($177+14)&4294967295); //@line 1300 "intonation.cpp"
                  HEAP8[($env210)]=$176; //@line 1300 "intonation.cpp"
                  ; //@line 1300 "intonation.cpp"
                }
              } while(0);
  
              var $178=$p; //@line 1302 "intonation.cpp"
              var $pitch1213=(($178+20)&4294967295); //@line 1302 "intonation.cpp"
              var $179=HEAPU8[($pitch1213)]; //@line 1302 "intonation.cpp"
              var $conv214=((($179))&255); //@line 1302 "intonation.cpp"
              var $180=$p; //@line 1302 "intonation.cpp"
              var $pitch2215=(($180+21)&4294967295); //@line 1302 "intonation.cpp"
              var $181=HEAPU8[($pitch2215)]; //@line 1302 "intonation.cpp"
              var $conv216=((($181))&255); //@line 1302 "intonation.cpp"
              var $cmp217=((($conv214))|0) > ((($conv216))|0); //@line 1302 "intonation.cpp"
              if ($cmp217) { __label__ = 63;; } else { __label__ = 64;; } //@line 1302 "intonation.cpp"
              if (__label__ == 63) {
  
                var $182=$p; //@line 1305 "intonation.cpp"
                var $pitch1219=(($182+20)&4294967295); //@line 1305 "intonation.cpp"
                var $183=HEAPU8[($pitch1219)]; //@line 1305 "intonation.cpp"
                var $conv220=((($183))&255); //@line 1305 "intonation.cpp"
                $x=$conv220; //@line 1305 "intonation.cpp"
                var $184=$p; //@line 1306 "intonation.cpp"
                var $pitch2221=(($184+21)&4294967295); //@line 1306 "intonation.cpp"
                var $185=HEAP8[($pitch2221)]; //@line 1306 "intonation.cpp"
                var $186=$p; //@line 1306 "intonation.cpp"
                var $pitch1222=(($186+20)&4294967295); //@line 1306 "intonation.cpp"
                HEAP8[($pitch1222)]=$185; //@line 1306 "intonation.cpp"
                var $187=$x; //@line 1307 "intonation.cpp"
                var $conv223=((($187)) & 255); //@line 1307 "intonation.cpp"
                var $188=$p; //@line 1307 "intonation.cpp"
                var $pitch2224=(($188+21)&4294967295); //@line 1307 "intonation.cpp"
                HEAP8[($pitch2224)]=$conv223; //@line 1307 "intonation.cpp"
                ; //@line 1308 "intonation.cpp"
              }
  
              var $189=$p; //@line 1310 "intonation.cpp"
              var $tone_ph=(($189+3)&4294967295); //@line 1310 "intonation.cpp"
              var $190=HEAP8[($tone_ph)]; //@line 1310 "intonation.cpp"
              var $tobool226=(tempInt=(($190)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1310 "intonation.cpp"
              if ($tobool226) { __label__ = 65;; } else { __label__ = 66;; } //@line 1310 "intonation.cpp"
              if (__label__ == 65) {
  
                var $191=$p; //@line 1312 "intonation.cpp"
                var $tone_ph228=(($191+3)&4294967295); //@line 1312 "intonation.cpp"
                var $192=HEAPU8[($tone_ph228)]; //@line 1312 "intonation.cpp"
                var $idxprom=((($192))&255); //@line 1312 "intonation.cpp"
                var $arrayidx229=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1312 "intonation.cpp"
                var $193=HEAP32[(($arrayidx229)>>2)]; //@line 1312 "intonation.cpp"
                $ph=$193; //@line 1312 "intonation.cpp"
                var $194=$p; //@line 1313 "intonation.cpp"
                var $pitch1230=(($194+20)&4294967295); //@line 1313 "intonation.cpp"
                var $195=HEAPU8[($pitch1230)]; //@line 1313 "intonation.cpp"
                var $conv231=((($195))&255); //@line 1313 "intonation.cpp"
                var $196=$p; //@line 1313 "intonation.cpp"
                var $pitch2232=(($196+21)&4294967295); //@line 1313 "intonation.cpp"
                var $197=HEAPU8[($pitch2232)]; //@line 1313 "intonation.cpp"
                var $conv233=((($197))&255); //@line 1313 "intonation.cpp"
                var $add234=((($conv233)+($conv231))&4294967295); //@line 1313 "intonation.cpp"
                var $div=((((($add234))|0)/2)|0); //@line 1313 "intonation.cpp"
                $x=$div; //@line 1313 "intonation.cpp"
                var $198=$x; //@line 1314 "intonation.cpp"
                var $199=$ph; //@line 1314 "intonation.cpp"
                var $end_type=(($199+13)&4294967295); //@line 1314 "intonation.cpp"
                var $200=HEAPU8[($end_type)]; //@line 1314 "intonation.cpp"
                var $conv235=((($200))&255); //@line 1314 "intonation.cpp"
                var $add236=((($conv235)+($198))&4294967295); //@line 1314 "intonation.cpp"
                var $conv237=((($add236)) & 255); //@line 1314 "intonation.cpp"
                var $201=$p; //@line 1314 "intonation.cpp"
                var $pitch2238=(($201+21)&4294967295); //@line 1314 "intonation.cpp"
                HEAP8[($pitch2238)]=$conv237; //@line 1314 "intonation.cpp"
                var $202=$x; //@line 1315 "intonation.cpp"
                var $203=$ph; //@line 1315 "intonation.cpp"
                var $start_type=(($203+12)&4294967295); //@line 1315 "intonation.cpp"
                var $204=HEAPU8[($start_type)]; //@line 1315 "intonation.cpp"
                var $conv239=((($204))&255); //@line 1315 "intonation.cpp"
                var $add240=((($conv239)+($202))&4294967295); //@line 1315 "intonation.cpp"
                var $conv241=((($add240)) & 255); //@line 1315 "intonation.cpp"
                var $205=$p; //@line 1315 "intonation.cpp"
                var $pitch1242=(($205+20)&4294967295); //@line 1315 "intonation.cpp"
                HEAP8[($pitch1242)]=$conv241; //@line 1315 "intonation.cpp"
                ; //@line 1316 "intonation.cpp"
              }
  
              var $206=$syl; //@line 1318 "intonation.cpp"
              var $flags244=(($206+2)&4294967295); //@line 1318 "intonation.cpp"
              var $207=HEAP8[($flags244)]; //@line 1318 "intonation.cpp"
              var $conv245=(tempInt=(($207)),(tempInt>=128?tempInt-256:tempInt)); //@line 1318 "intonation.cpp"
              var $and246=($conv245) & 2; //@line 1318 "intonation.cpp"
              var $tobool247=((($and246))|0)!=0; //@line 1318 "intonation.cpp"
              if ($tobool247) { __label__ = 67;; } else { __label__ = 68;; } //@line 1318 "intonation.cpp"
              if (__label__ == 67) {
  
                var $208=$p; //@line 1320 "intonation.cpp"
                var $stresslevel249=(($208+1)&4294967295); //@line 1320 "intonation.cpp"
                var $209=HEAPU8[($stresslevel249)]; //@line 1320 "intonation.cpp"
                var $conv250=((($209))&255); //@line 1320 "intonation.cpp"
                var $or251=($conv250) | 8; //@line 1320 "intonation.cpp"
                var $conv252=((($or251)) & 255); //@line 1320 "intonation.cpp"
                HEAP8[($stresslevel249)]=$conv252; //@line 1320 "intonation.cpp"
                ; //@line 1321 "intonation.cpp"
              }
  
              var $210=$st_ix; //@line 1323 "intonation.cpp"
              var $inc254=((($210)+1)&4294967295); //@line 1323 "intonation.cpp"
              $st_ix=$inc254; //@line 1323 "intonation.cpp"
              ; //@line 1324 "intonation.cpp"
            }
  
            var $211=$ix; //@line 1281 "intonation.cpp"
            var $inc257=((($211)+1)&4294967295); //@line 1281 "intonation.cpp"
            $ix=$inc257; //@line 1281 "intonation.cpp"
            var $212=$ix; //@line 1281 "intonation.cpp"
            var $213=$ph_end; //@line 1281 "intonation.cpp"
            var $cmp183=((($212))|0) < ((($213))|0); //@line 1281 "intonation.cpp"
            if ($cmp183) { __label__ = 57;continue $for_body184$81; } else { __label__ = 70;break $for_end258$$if_end28$13; } //@line 1281 "intonation.cpp"
          }
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 1327 "intonation.cpp"
    return;
  }
  

  function __ZL16CalcPitches_ToneP10Translatori($tr, $clause_tone) {
    ;
    var __label__;
  
    var $tr_addr;
    var $clause_tone_addr;
    var $p;
    var $ix;
    var $count_stressed;
    var $final_stressed;
    var $tone_ph;
    var $pause;
    var $tone_promoted;
    var $tph;
    var $prev_tph;
    var $prevw_tph;
    var $prev2_tph;
    var $prev_p;
    var $pitch_adjust;
    var $pitch_decrement;
    var $pitch_low;
    var $pitch_high;
    $tr_addr=$tr;
    $clause_tone_addr=$clause_tone;
    $count_stressed=0; //@line 935 "intonation.cpp"
    $final_stressed=0; //@line 936 "intonation.cpp"
    $pitch_adjust=0; //@line 947 "intonation.cpp"
    $pitch_decrement=0; //@line 948 "intonation.cpp"
    $pitch_low=0; //@line 949 "intonation.cpp"
    $pitch_high=0; //@line 950 "intonation.cpp"
    $p=((_phoneme_list)&4294967295); //@line 955 "intonation.cpp"
    $ix=0; //@line 956 "intonation.cpp"
    var $0=$ix; //@line 956 "intonation.cpp"
    var $1=HEAP32[((_n_phoneme_list)>>2)]; //@line 956 "intonation.cpp"
    var $cmp5=((($0))|0) < ((($1))|0); //@line 956 "intonation.cpp"
    if ($cmp5) { __label__ = 1;; } else { __label__ = 8;; } //@line 956 "intonation.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $2=$p; //@line 958 "intonation.cpp"
          var $type=(($2+15)&4294967295); //@line 958 "intonation.cpp"
          var $3=HEAPU8[($type)]; //@line 958 "intonation.cpp"
          var $conv=((($3))&255); //@line 958 "intonation.cpp"
          var $cmp1=((($conv))|0)==2; //@line 958 "intonation.cpp"
          if ($cmp1) { __label__ = 2;; } else { __label__ = 7;; } //@line 958 "intonation.cpp"
          $land_lhs_true$$for_inc$5: do { 
            if (__label__ == 2) {
  
              var $4=$p; //@line 958 "intonation.cpp"
              var $stresslevel=(($4+1)&4294967295); //@line 958 "intonation.cpp"
              var $5=HEAPU8[($stresslevel)]; //@line 958 "intonation.cpp"
              var $conv2=((($5))&255); //@line 958 "intonation.cpp"
              var $cmp3=((($conv2))|0) >= 4; //@line 958 "intonation.cpp"
              if (!($cmp3)) { __label__ = 7;break $land_lhs_true$$for_inc$5; } //@line 958 "intonation.cpp"
  
              var $6=$count_stressed; //@line 960 "intonation.cpp"
              var $cmp4=((($6))|0)==0; //@line 960 "intonation.cpp"
              if ($cmp4) { __label__ = 4;; } else { __label__ = 5;; } //@line 960 "intonation.cpp"
              if (__label__ == 4) {
  
                var $7=$ix; //@line 961 "intonation.cpp"
                $final_stressed=$7; //@line 961 "intonation.cpp"
                ; //@line 961 "intonation.cpp"
              }
  
              var $8=$p; //@line 963 "intonation.cpp"
              var $stresslevel6=(($8+1)&4294967295); //@line 963 "intonation.cpp"
              var $9=HEAPU8[($stresslevel6)]; //@line 963 "intonation.cpp"
              var $conv7=((($9))&255); //@line 963 "intonation.cpp"
              var $cmp8=((($conv7))|0) >= 4; //@line 963 "intonation.cpp"
              if (!($cmp8)) { __label__ = 7;break $land_lhs_true$$for_inc$5; } //@line 963 "intonation.cpp"
  
              var $10=$ix; //@line 965 "intonation.cpp"
              $final_stressed=$10; //@line 965 "intonation.cpp"
              var $11=$count_stressed; //@line 966 "intonation.cpp"
              var $inc=((($11)+1)&4294967295); //@line 966 "intonation.cpp"
              $count_stressed=$inc; //@line 966 "intonation.cpp"
              ; //@line 967 "intonation.cpp"
            }
          } while(0);
  
          var $12=$ix; //@line 956 "intonation.cpp"
          var $inc12=((($12)+1)&4294967295); //@line 956 "intonation.cpp"
          $ix=$inc12; //@line 956 "intonation.cpp"
          var $13=$p; //@line 956 "intonation.cpp"
          var $incdec_ptr=(($13+24)&4294967295); //@line 956 "intonation.cpp"
          $p=$incdec_ptr; //@line 956 "intonation.cpp"
          var $14=$ix; //@line 956 "intonation.cpp"
          var $15=HEAP32[((_n_phoneme_list)>>2)]; //@line 956 "intonation.cpp"
          var $cmp=((($14))|0) < ((($15))|0); //@line 956 "intonation.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 8;break $for_body$$for_end$2; } //@line 956 "intonation.cpp"
        }
      }
    } while(0);
  
    var $16=$final_stressed; //@line 971 "intonation.cpp"
    var $arrayidx=((_phoneme_list+$16*24)&4294967295); //@line 971 "intonation.cpp"
    var $stresslevel13=(($arrayidx+1)&4294967295); //@line 971 "intonation.cpp"
    HEAP8[($stresslevel13)]=7; //@line 971 "intonation.cpp"
    var $17=$tr_addr; //@line 974 "intonation.cpp"
    var $translator_name=(($17+280)&4294967295); //@line 974 "intonation.cpp"
    var $18=HEAP32[(($translator_name)>>2)]; //@line 974 "intonation.cpp"
    var $cmp14=((($18))|0)==30313; //@line 974 "intonation.cpp"
    if ($cmp14) { __label__ = 9;; } else { __label__ = 11;; } //@line 974 "intonation.cpp"
    $if_then15$$if_end24$14: do { 
      if (__label__ == 9) {
  
        var $19=$final_stressed; //@line 977 "intonation.cpp"
        var $arrayidx16=((_phoneme_list+$19*24)&4294967295); //@line 977 "intonation.cpp"
        $p=$arrayidx16; //@line 977 "intonation.cpp"
        var $20=$p; //@line 978 "intonation.cpp"
        var $tone_ph17=(($20+3)&4294967295); //@line 978 "intonation.cpp"
        var $21=HEAPU8[($tone_ph17)]; //@line 978 "intonation.cpp"
        var $conv18=((($21))&255); //@line 978 "intonation.cpp"
        var $cmp19=((($conv18))|0)==0; //@line 978 "intonation.cpp"
        if (!($cmp19)) { __label__ = 11;break $if_then15$$if_end24$14; } //@line 978 "intonation.cpp"
  
        var $call=__Z11PhonemeCodej(55); //@line 979 "intonation.cpp"
        var $conv21=((($call)) & 255); //@line 979 "intonation.cpp"
        var $22=$p; //@line 979 "intonation.cpp"
        var $tone_ph22=(($22+3)&4294967295); //@line 979 "intonation.cpp"
        HEAP8[($tone_ph22)]=$conv21; //@line 979 "intonation.cpp"
        ; //@line 979 "intonation.cpp"
      }
    } while(0);
  
    $pause=1; //@line 983 "intonation.cpp"
    $tone_promoted=0; //@line 984 "intonation.cpp"
    $p=((_phoneme_list)&4294967295); //@line 986 "intonation.cpp"
    $prev_p=((_phoneme_list)&4294967295); //@line 986 "intonation.cpp"
    var $23=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 987 "intonation.cpp"
    $prevw_tph=$23; //@line 987 "intonation.cpp"
    $prev_tph=$23; //@line 987 "intonation.cpp"
    $ix=0; //@line 990 "intonation.cpp"
    var $24=$ix; //@line 990 "intonation.cpp"
    var $25=HEAP32[((_n_phoneme_list)>>2)]; //@line 990 "intonation.cpp"
    var $cmp262=((($24))|0) < ((($25))|0); //@line 990 "intonation.cpp"
    if ($cmp262) { __label__ = 12;; } else { __label__ = 47;; } //@line 990 "intonation.cpp"
    $for_body27$$for_end127$18: do { 
      if (__label__ == 12) {
        $for_body27$19: while(1) { 
  
          var $26=$p; //@line 992 "intonation.cpp"
          var $type28=(($26+15)&4294967295); //@line 992 "intonation.cpp"
          var $27=HEAPU8[($type28)]; //@line 992 "intonation.cpp"
          var $conv29=((($27))&255); //@line 992 "intonation.cpp"
          var $cmp30=((($conv29))|0)==0; //@line 992 "intonation.cpp"
          if ($cmp30) { __label__ = 13;; } else { __label__ = 15;; } //@line 992 "intonation.cpp"
          $land_lhs_true31$$if_end35$21: do { 
            if (__label__ == 13) {
  
              var $28=$p; //@line 992 "intonation.cpp"
              var $ph=(($28+8)&4294967295); //@line 992 "intonation.cpp"
              var $29=HEAP32[(($ph)>>2)]; //@line 992 "intonation.cpp"
              var $std_length=(($29+14)&4294967295); //@line 992 "intonation.cpp"
              var $30=HEAPU8[($std_length)]; //@line 992 "intonation.cpp"
              var $conv32=((($30))&255); //@line 992 "intonation.cpp"
              var $cmp33=((($conv32))|0) > 50; //@line 992 "intonation.cpp"
              if (!($cmp33)) { __label__ = 15;break $land_lhs_true31$$if_end35$21; } //@line 992 "intonation.cpp"
  
              $pause=1; //@line 994 "intonation.cpp"
              var $31=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 995 "intonation.cpp"
              $prevw_tph=$31; //@line 995 "intonation.cpp"
              ; //@line 996 "intonation.cpp"
            }
          } while(0);
  
          var $32=$p; //@line 998 "intonation.cpp"
          var $newword=(($32+19)&4294967295); //@line 998 "intonation.cpp"
          var $33=HEAP8[($newword)]; //@line 998 "intonation.cpp"
          var $tobool=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 998 "intonation.cpp"
          if ($tobool) { __label__ = 16;; } else { __label__ = 17;; } //@line 998 "intonation.cpp"
          if (__label__ == 16) {
  
            var $34=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 1000 "intonation.cpp"
            $prev_tph=$34; //@line 1000 "intonation.cpp"
            ; //@line 1001 "intonation.cpp"
          }
  
          var $35=$p; //@line 1003 "intonation.cpp"
          var $synthflags=(($35+4)&4294967295); //@line 1003 "intonation.cpp"
          var $36=HEAPU16[(($synthflags)>>1)]; //@line 1003 "intonation.cpp"
          var $conv38=((($36))&65535); //@line 1003 "intonation.cpp"
          var $and=($conv38) & 4; //@line 1003 "intonation.cpp"
          var $tobool39=((($and))|0)!=0; //@line 1003 "intonation.cpp"
          if ($tobool39) { __label__ = 18;; } else { __label__ = 46;; } //@line 1003 "intonation.cpp"
          if (__label__ == 18) {
  
            var $37=$p; //@line 1005 "intonation.cpp"
            var $tone_ph41=(($37+3)&4294967295); //@line 1005 "intonation.cpp"
            var $38=HEAPU8[($tone_ph41)]; //@line 1005 "intonation.cpp"
            var $conv42=((($38))&255); //@line 1005 "intonation.cpp"
            $tone_ph=$conv42; //@line 1005 "intonation.cpp"
            var $39=$tone_ph; //@line 1006 "intonation.cpp"
            var $arrayidx43=((_phoneme_tab+$39*4)&4294967295); //@line 1006 "intonation.cpp"
            var $40=HEAP32[(($arrayidx43)>>2)]; //@line 1006 "intonation.cpp"
            $tph=$40; //@line 1006 "intonation.cpp"
            var $41=$tr_addr; //@line 1009 "intonation.cpp"
            var $translator_name44=(($41+280)&4294967295); //@line 1009 "intonation.cpp"
            var $42=HEAP32[(($translator_name44)>>2)]; //@line 1009 "intonation.cpp"
            var $cmp45=((($42))|0)==31336; //@line 1009 "intonation.cpp"
            if ($cmp45) { __label__ = 19;; } else { __label__ = 45;; } //@line 1009 "intonation.cpp"
            $if_then46$$if_end122$30: do { 
              if (__label__ == 19) {
  
                var $43=$tone_ph; //@line 1011 "intonation.cpp"
                var $cmp47=((($43))|0)==0; //@line 1011 "intonation.cpp"
                if ($cmp47) { __label__ = 20;; } else { __label__ = 25;; } //@line 1011 "intonation.cpp"
                if (__label__ == 20) {
  
                  var $44=$pause; //@line 1013 "intonation.cpp"
                  var $tobool49=((($44))|0)!=0; //@line 1013 "intonation.cpp"
                  if ($tobool49) { __label__ = 22;; } else { __label__ = 21;; } //@line 1013 "intonation.cpp"
                  $if_then51$$lor_lhs_false$34: do { 
                    if (__label__ == 21) {
  
                      var $45=$tone_promoted; //@line 1013 "intonation.cpp"
                      var $tobool50=((($45))|0)!=0; //@line 1013 "intonation.cpp"
                      if ($tobool50) { __label__ = 22;break $if_then51$$lor_lhs_false$34; } //@line 1013 "intonation.cpp"
  
                      var $call53=__Z11PhonemeCodej(12593); //@line 1020 "intonation.cpp"
                      $tone_ph=$call53; //@line 1020 "intonation.cpp"
                      __label__ = 24;break $if_then51$$lor_lhs_false$34;
                    }
                  } while(0);
                  if (__label__ == 22) {
  
                    var $call52=__Z11PhonemeCodej(13621); //@line 1015 "intonation.cpp"
                    $tone_ph=$call52; //@line 1015 "intonation.cpp"
                    $tone_promoted=1; //@line 1016 "intonation.cpp"
                    ; //@line 1017 "intonation.cpp"
                  }
  
                  var $46=$tone_ph; //@line 1023 "intonation.cpp"
                  var $conv55=((($46)) & 255); //@line 1023 "intonation.cpp"
                  var $47=$p; //@line 1023 "intonation.cpp"
                  var $tone_ph56=(($47+3)&4294967295); //@line 1023 "intonation.cpp"
                  HEAP8[($tone_ph56)]=$conv55; //@line 1023 "intonation.cpp"
                  var $48=$tone_ph; //@line 1024 "intonation.cpp"
                  var $arrayidx57=((_phoneme_tab+$48*4)&4294967295); //@line 1024 "intonation.cpp"
                  var $49=HEAP32[(($arrayidx57)>>2)]; //@line 1024 "intonation.cpp"
                  $tph=$49; //@line 1024 "intonation.cpp"
                  ; //@line 1026 "intonation.cpp"
                }
                else if (__label__ == 25) {
  
                  $tone_promoted=0; //@line 1029 "intonation.cpp"
                  ;
                }
  
                var $50=$ix; //@line 1032 "intonation.cpp"
                var $51=$final_stressed; //@line 1032 "intonation.cpp"
                var $cmp60=((($50))|0)==((($51))|0); //@line 1032 "intonation.cpp"
                if ($cmp60) { __label__ = 27;; } else { __label__ = 30;; } //@line 1032 "intonation.cpp"
                $if_then61$$if_end70$42: do { 
                  if (__label__ == 27) {
  
                    var $52=$tph; //@line 1034 "intonation.cpp"
                    var $mnemonic=(($52)&4294967295); //@line 1034 "intonation.cpp"
                    var $53=HEAP32[(($mnemonic)>>2)]; //@line 1034 "intonation.cpp"
                    var $cmp62=((($53))|0)==13621; //@line 1034 "intonation.cpp"
                    if ($cmp62) { __label__ = 29;; } else { __label__ = 28;; } //@line 1034 "intonation.cpp"
                    if (__label__ == 28) {
  
                      var $54=$tph; //@line 1034 "intonation.cpp"
                      var $mnemonic64=(($54)&4294967295); //@line 1034 "intonation.cpp"
                      var $55=HEAP32[(($mnemonic64)>>2)]; //@line 1034 "intonation.cpp"
                      var $cmp65=((($55))|0)==12597; //@line 1034 "intonation.cpp"
                      if (!($cmp65)) { __label__ = 30;break $if_then61$$if_end70$42; } //@line 1034 "intonation.cpp"
                    }
  
                    var $56=$final_stressed; //@line 1037 "intonation.cpp"
                    var $arrayidx67=((_phoneme_list+$56*24)&4294967295); //@line 1037 "intonation.cpp"
                    var $stresslevel68=(($arrayidx67+1)&4294967295); //@line 1037 "intonation.cpp"
                    HEAP8[($stresslevel68)]=6; //@line 1037 "intonation.cpp"
                    ; //@line 1038 "intonation.cpp"
                  }
                } while(0);
  
                var $57=$prevw_tph; //@line 1041 "intonation.cpp"
                var $mnemonic71=(($57)&4294967295); //@line 1041 "intonation.cpp"
                var $58=HEAP32[(($mnemonic71)>>2)]; //@line 1041 "intonation.cpp"
                var $cmp72=((($58))|0)==3420466; //@line 1041 "intonation.cpp"
                if ($cmp72) { __label__ = 31;; } else { __label__ = 34;; } //@line 1041 "intonation.cpp"
                if (__label__ == 31) {
  
                  var $59=$tph; //@line 1043 "intonation.cpp"
                  var $mnemonic74=(($59)&4294967295); //@line 1043 "intonation.cpp"
                  var $60=HEAP32[(($mnemonic74)>>2)]; //@line 1043 "intonation.cpp"
                  var $cmp75=((($60))|0)==3420466; //@line 1043 "intonation.cpp"
                  if ($cmp75) { __label__ = 32;; } else { __label__ = 33;; } //@line 1043 "intonation.cpp"
                  if (__label__ == 32) {
  
                    var $call77=__Z11PhonemeCodej(13619); //@line 1044 "intonation.cpp"
                    var $conv78=((($call77)) & 255); //@line 1044 "intonation.cpp"
                    var $61=$prev_p; //@line 1044 "intonation.cpp"
                    var $tone_ph79=(($61+3)&4294967295); //@line 1044 "intonation.cpp"
                    HEAP8[($tone_ph79)]=$conv78; //@line 1044 "intonation.cpp"
                    ; //@line 1044 "intonation.cpp"
                  }
                  else if (__label__ == 33) {
  
                    var $call81=__Z11PhonemeCodej(12594); //@line 1046 "intonation.cpp"
                    var $conv82=((($call81)) & 255); //@line 1046 "intonation.cpp"
                    var $62=$prev_p; //@line 1046 "intonation.cpp"
                    var $tone_ph83=(($62+3)&4294967295); //@line 1046 "intonation.cpp"
                    HEAP8[($tone_ph83)]=$conv82; //@line 1046 "intonation.cpp"
                    ;
                  }
                }
  
                var $63=$prev_tph; //@line 1048 "intonation.cpp"
                var $mnemonic86=(($63)&4294967295); //@line 1048 "intonation.cpp"
                var $64=HEAP32[(($mnemonic86)>>2)]; //@line 1048 "intonation.cpp"
                var $cmp87=((($64))|0)==12597; //@line 1048 "intonation.cpp"
                if ($cmp87) { __label__ = 35;; } else { __label__ = 37;; } //@line 1048 "intonation.cpp"
                $land_lhs_true88$$if_end95$54: do { 
                  if (__label__ == 35) {
  
                    var $65=$tph; //@line 1048 "intonation.cpp"
                    var $mnemonic89=(($65)&4294967295); //@line 1048 "intonation.cpp"
                    var $66=HEAP32[(($mnemonic89)>>2)]; //@line 1048 "intonation.cpp"
                    var $cmp90=((($66))|0)==12597; //@line 1048 "intonation.cpp"
                    if (!($cmp90)) { __label__ = 37;break $land_lhs_true88$$if_end95$54; } //@line 1048 "intonation.cpp"
  
                    var $call92=__Z11PhonemeCodej(13109); //@line 1050 "intonation.cpp"
                    var $conv93=((($call92)) & 255); //@line 1050 "intonation.cpp"
                    var $67=$prev_p; //@line 1050 "intonation.cpp"
                    var $tone_ph94=(($67+3)&4294967295); //@line 1050 "intonation.cpp"
                    HEAP8[($tone_ph94)]=$conv93; //@line 1050 "intonation.cpp"
                    ; //@line 1051 "intonation.cpp"
                  }
                } while(0);
  
                var $68=$tph; //@line 1053 "intonation.cpp"
                var $mnemonic96=(($68)&4294967295); //@line 1053 "intonation.cpp"
                var $69=HEAP32[(($mnemonic96)>>2)]; //@line 1053 "intonation.cpp"
                var $cmp97=((($69))|0)==12593; //@line 1053 "intonation.cpp"
                if (!($cmp97)) { __label__ = 45;break $if_then46$$if_end122$30; } //@line 1053 "intonation.cpp"
  
                var $70=$prevw_tph; //@line 1056 "intonation.cpp"
                var $mnemonic99=(($70)&4294967295); //@line 1056 "intonation.cpp"
                var $71=HEAP32[(($mnemonic99)>>2)]; //@line 1056 "intonation.cpp"
                var $cmp100=((($71))|0)==13621; //@line 1056 "intonation.cpp"
                if ($cmp100) { __label__ = 39;; } else { __label__ = 40;; } //@line 1056 "intonation.cpp"
                if (__label__ == 39) {
  
                  var $call102=__Z11PhonemeCodej(12850); //@line 1057 "intonation.cpp"
                  var $conv103=((($call102)) & 255); //@line 1057 "intonation.cpp"
                  var $72=$p; //@line 1057 "intonation.cpp"
                  var $tone_ph104=(($72+3)&4294967295); //@line 1057 "intonation.cpp"
                  HEAP8[($tone_ph104)]=$conv103; //@line 1057 "intonation.cpp"
                  ; //@line 1057 "intonation.cpp"
                }
  
                var $73=$prevw_tph; //@line 1058 "intonation.cpp"
                var $mnemonic106=(($73)&4294967295); //@line 1058 "intonation.cpp"
                var $74=HEAP32[(($mnemonic106)>>2)]; //@line 1058 "intonation.cpp"
                var $cmp107=((($74))|0)==13619; //@line 1058 "intonation.cpp"
                if ($cmp107) { __label__ = 41;; } else { __label__ = 42;; } //@line 1058 "intonation.cpp"
                if (__label__ == 41) {
  
                  var $call109=__Z11PhonemeCodej(13107); //@line 1059 "intonation.cpp"
                  var $conv110=((($call109)) & 255); //@line 1059 "intonation.cpp"
                  var $75=$p; //@line 1059 "intonation.cpp"
                  var $tone_ph111=(($75+3)&4294967295); //@line 1059 "intonation.cpp"
                  HEAP8[($tone_ph111)]=$conv110; //@line 1059 "intonation.cpp"
                  ; //@line 1059 "intonation.cpp"
                }
  
                var $76=$prevw_tph; //@line 1060 "intonation.cpp"
                var $mnemonic113=(($76)&4294967295); //@line 1060 "intonation.cpp"
                var $77=HEAP32[(($mnemonic113)>>2)]; //@line 1060 "intonation.cpp"
                var $cmp114=((($77))|0)==3420466; //@line 1060 "intonation.cpp"
                if ($cmp114) { __label__ = 43;; } else { __label__ = 44;; } //@line 1060 "intonation.cpp"
                if (__label__ == 43) {
  
                  var $call116=__Z11PhonemeCodej(13364); //@line 1061 "intonation.cpp"
                  var $conv117=((($call116)) & 255); //@line 1061 "intonation.cpp"
                  var $78=$p; //@line 1061 "intonation.cpp"
                  var $tone_ph118=(($78+3)&4294967295); //@line 1061 "intonation.cpp"
                  HEAP8[($tone_ph118)]=$conv117; //@line 1061 "intonation.cpp"
                  ; //@line 1061 "intonation.cpp"
                }
  
                var $79=$p; //@line 1064 "intonation.cpp"
                var $stresslevel120=(($79+1)&4294967295); //@line 1064 "intonation.cpp"
                HEAP8[($stresslevel120)]=0; //@line 1064 "intonation.cpp"
                ; //@line 1065 "intonation.cpp"
              }
            } while(0);
  
            var $80=$p; //@line 1068 "intonation.cpp"
            $prev_p=$80; //@line 1068 "intonation.cpp"
            var $81=$prevw_tph; //@line 1069 "intonation.cpp"
            $prev2_tph=$81; //@line 1069 "intonation.cpp"
            var $82=$tph; //@line 1070 "intonation.cpp"
            $prev_tph=$82; //@line 1070 "intonation.cpp"
            $prevw_tph=$82; //@line 1070 "intonation.cpp"
            $pause=0; //@line 1071 "intonation.cpp"
            ; //@line 1072 "intonation.cpp"
          }
  
          var $83=$ix; //@line 990 "intonation.cpp"
          var $inc125=((($83)+1)&4294967295); //@line 990 "intonation.cpp"
          $ix=$inc125; //@line 990 "intonation.cpp"
          var $84=$p; //@line 990 "intonation.cpp"
          var $incdec_ptr126=(($84+24)&4294967295); //@line 990 "intonation.cpp"
          $p=$incdec_ptr126; //@line 990 "intonation.cpp"
          var $85=$ix; //@line 990 "intonation.cpp"
          var $86=HEAP32[((_n_phoneme_list)>>2)]; //@line 990 "intonation.cpp"
          var $cmp26=((($85))|0) < ((($86))|0); //@line 990 "intonation.cpp"
          if ($cmp26) { __label__ = 12;continue $for_body27$19; } else { __label__ = 47;break $for_body27$$for_end127$18; } //@line 990 "intonation.cpp"
        }
      }
    } while(0);
  
    $p=((_phoneme_list)&4294967295); //@line 1076 "intonation.cpp"
    $ix=0; //@line 1077 "intonation.cpp"
    var $87=$ix; //@line 1077 "intonation.cpp"
    var $88=HEAP32[((_n_phoneme_list)>>2)]; //@line 1077 "intonation.cpp"
    var $cmp1291=((($87))|0) < ((($88))|0); //@line 1077 "intonation.cpp"
    if ($cmp1291) { __label__ = 48;; } else { __label__ = 58;; } //@line 1077 "intonation.cpp"
    $for_body130$$for_end166$71: do { 
      if (__label__ == 48) {
        $for_body130$72: while(1) { 
  
          var $89=$p; //@line 1079 "intonation.cpp"
          var $synthflags131=(($89+4)&4294967295); //@line 1079 "intonation.cpp"
          var $90=HEAPU16[(($synthflags131)>>1)]; //@line 1079 "intonation.cpp"
          var $conv132=((($90))&65535); //@line 1079 "intonation.cpp"
          var $and133=($conv132) & 4; //@line 1079 "intonation.cpp"
          var $tobool134=((($and133))|0)!=0; //@line 1079 "intonation.cpp"
          if ($tobool134) { __label__ = 49;; } else { __label__ = 57;; } //@line 1079 "intonation.cpp"
          if (__label__ == 49) {
  
            var $91=$p; //@line 1081 "intonation.cpp"
            var $tone_ph136=(($91+3)&4294967295); //@line 1081 "intonation.cpp"
            var $92=HEAPU8[($tone_ph136)]; //@line 1081 "intonation.cpp"
            var $conv137=((($92))&255); //@line 1081 "intonation.cpp"
            $tone_ph=$conv137; //@line 1081 "intonation.cpp"
            var $93=$p; //@line 1083 "intonation.cpp"
            var $stresslevel138=(($93+1)&4294967295); //@line 1083 "intonation.cpp"
            var $94=HEAPU8[($stresslevel138)]; //@line 1083 "intonation.cpp"
            var $conv139=((($94))&255); //@line 1083 "intonation.cpp"
            var $cmp140=((($conv139))|0)!=0; //@line 1083 "intonation.cpp"
            if ($cmp140) { __label__ = 50;; } else { __label__ = 54;; } //@line 1083 "intonation.cpp"
            $if_then141$$if_end149$76: do { 
              if (__label__ == 50) {
  
                var $95=$ix; //@line 1085 "intonation.cpp"
                var $96=$final_stressed; //@line 1085 "intonation.cpp"
                var $cmp142=((($95))|0)==((($96))|0); //@line 1085 "intonation.cpp"
                if ($cmp142) { __label__ = 51;; } else { __label__ = 52;; } //@line 1085 "intonation.cpp"
                if (__label__ == 51) {
  
                  var $97=$pitch_low; //@line 1088 "intonation.cpp"
                  $pitch_adjust=$97; //@line 1088 "intonation.cpp"
                  ; //@line 1089 "intonation.cpp"
                }
                else if (__label__ == 52) {
  
                  var $98=$pitch_decrement; //@line 1092 "intonation.cpp"
                  var $99=$pitch_adjust; //@line 1092 "intonation.cpp"
                  var $sub=((($99)-($98))&4294967295); //@line 1092 "intonation.cpp"
                  $pitch_adjust=$sub; //@line 1092 "intonation.cpp"
                  var $100=$pitch_adjust; //@line 1093 "intonation.cpp"
                  var $101=$pitch_low; //@line 1093 "intonation.cpp"
                  var $cmp145=((($100))|0) <= ((($101))|0); //@line 1093 "intonation.cpp"
                  if (!($cmp145)) { __label__ = 54;break $if_then141$$if_end149$76; } //@line 1093 "intonation.cpp"
  
                  var $102=$pitch_high; //@line 1094 "intonation.cpp"
                  $pitch_adjust=$102; //@line 1094 "intonation.cpp"
                  ; //@line 1094 "intonation.cpp"
                }
              }
            } while(0);
  
            var $103=$tone_ph; //@line 1098 "intonation.cpp"
            var $cmp150=((($103))|0)==0; //@line 1098 "intonation.cpp"
            if ($cmp150) { __label__ = 55;; } else { __label__ = 56;; } //@line 1098 "intonation.cpp"
            if (__label__ == 55) {
  
              $tone_ph=17; //@line 1100 "intonation.cpp"
              var $104=$tone_ph; //@line 1101 "intonation.cpp"
              var $conv152=((($104)) & 255); //@line 1101 "intonation.cpp"
              var $105=$p; //@line 1101 "intonation.cpp"
              var $tone_ph153=(($105+3)&4294967295); //@line 1101 "intonation.cpp"
              HEAP8[($tone_ph153)]=$conv152; //@line 1101 "intonation.cpp"
              ; //@line 1102 "intonation.cpp"
            }
  
            var $106=$pitch_adjust; //@line 1103 "intonation.cpp"
            var $107=$tone_ph; //@line 1103 "intonation.cpp"
            var $arrayidx155=((_phoneme_tab+$107*4)&4294967295); //@line 1103 "intonation.cpp"
            var $108=HEAP32[(($arrayidx155)>>2)]; //@line 1103 "intonation.cpp"
            var $start_type=(($108+12)&4294967295); //@line 1103 "intonation.cpp"
            var $109=HEAPU8[($start_type)]; //@line 1103 "intonation.cpp"
            var $conv156=((($109))&255); //@line 1103 "intonation.cpp"
            var $add=((($conv156)+($106))&4294967295); //@line 1103 "intonation.cpp"
            var $conv157=((($add)) & 255); //@line 1103 "intonation.cpp"
            var $110=$p; //@line 1103 "intonation.cpp"
            var $pitch1=(($110+20)&4294967295); //@line 1103 "intonation.cpp"
            HEAP8[($pitch1)]=$conv157; //@line 1103 "intonation.cpp"
            var $111=$pitch_adjust; //@line 1104 "intonation.cpp"
            var $112=$tone_ph; //@line 1104 "intonation.cpp"
            var $arrayidx158=((_phoneme_tab+$112*4)&4294967295); //@line 1104 "intonation.cpp"
            var $113=HEAP32[(($arrayidx158)>>2)]; //@line 1104 "intonation.cpp"
            var $end_type=(($113+13)&4294967295); //@line 1104 "intonation.cpp"
            var $114=HEAPU8[($end_type)]; //@line 1104 "intonation.cpp"
            var $conv159=((($114))&255); //@line 1104 "intonation.cpp"
            var $add160=((($conv159)+($111))&4294967295); //@line 1104 "intonation.cpp"
            var $conv161=((($add160)) & 255); //@line 1104 "intonation.cpp"
            var $115=$p; //@line 1104 "intonation.cpp"
            var $pitch2=(($115+21)&4294967295); //@line 1104 "intonation.cpp"
            HEAP8[($pitch2)]=$conv161; //@line 1104 "intonation.cpp"
            ; //@line 1105 "intonation.cpp"
          }
  
          var $116=$ix; //@line 1077 "intonation.cpp"
          var $inc164=((($116)+1)&4294967295); //@line 1077 "intonation.cpp"
          $ix=$inc164; //@line 1077 "intonation.cpp"
          var $117=$p; //@line 1077 "intonation.cpp"
          var $incdec_ptr165=(($117+24)&4294967295); //@line 1077 "intonation.cpp"
          $p=$incdec_ptr165; //@line 1077 "intonation.cpp"
          var $118=$ix; //@line 1077 "intonation.cpp"
          var $119=HEAP32[((_n_phoneme_list)>>2)]; //@line 1077 "intonation.cpp"
          var $cmp129=((($118))|0) < ((($119))|0); //@line 1077 "intonation.cpp"
          if ($cmp129) { __label__ = 48;continue $for_body130$72; } else { __label__ = 58;break $for_body130$$for_end166$71; } //@line 1077 "intonation.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1109 "intonation.cpp"
    return;
  }
  

  function __ZL18count_pitch_vowelsiii($start, $end, $clause_end) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $start_addr;
    var $end_addr;
    var $clause_end_addr;
    var $ix;
    var $stress;
    var $max_stress;
    var $max_stress_posn;
    var $max_stress_posn2;
    $start_addr=$start;
    $end_addr=$end;
    $clause_end_addr=$clause_end;
    $max_stress=0; //@line 333 "intonation.cpp"
    $max_stress_posn=0; //@line 334 "intonation.cpp"
    $max_stress_posn2=0; //@line 335 "intonation.cpp"
    HEAP32[((__ZL10number_pre)>>2)]=-1; //@line 337 "intonation.cpp"
    HEAP32[((__ZL11number_tail)>>2)]=0; //@line 339 "intonation.cpp"
    HEAP32[((__ZL12last_primary)>>2)]=-1; //@line 340 "intonation.cpp"
    var $0=$start_addr; //@line 342 "intonation.cpp"
    $ix=$0; //@line 342 "intonation.cpp"
    var $1=$ix; //@line 342 "intonation.cpp"
    var $2=$end_addr; //@line 342 "intonation.cpp"
    var $cmp1=((($1))|0) < ((($2))|0); //@line 342 "intonation.cpp"
    if ($cmp1) { __label__ = 1;; } else { __label__ = 11;; } //@line 342 "intonation.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=$ix; //@line 344 "intonation.cpp"
          var $4=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 344 "intonation.cpp"
          var $arrayidx=(($4+6*$3)&4294967295); //@line 344 "intonation.cpp"
          var $stress1=(($arrayidx)&4294967295); //@line 344 "intonation.cpp"
          var $5=HEAP8[($stress1)]; //@line 344 "intonation.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 344 "intonation.cpp"
          $stress=$conv; //@line 344 "intonation.cpp"
          var $6=$stress; //@line 346 "intonation.cpp"
          var $7=$max_stress; //@line 346 "intonation.cpp"
          var $cmp2=((($6))|0) >= ((($7))|0); //@line 346 "intonation.cpp"
          if ($cmp2) { __lastLabel__ = 1; __label__ = 2;; } else { __lastLabel__ = 1; __label__ = 6;; } //@line 346 "intonation.cpp"
          if (__label__ == 2) {
  
            var $8=$stress; //@line 348 "intonation.cpp"
            var $9=$max_stress; //@line 348 "intonation.cpp"
            var $cmp3=((($8))|0) > ((($9))|0); //@line 348 "intonation.cpp"
            if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 348 "intonation.cpp"
            if (__label__ == 3) {
  
              var $10=$ix; //@line 350 "intonation.cpp"
              $max_stress_posn2=$10; //@line 350 "intonation.cpp"
              ; //@line 351 "intonation.cpp"
            }
            else if (__label__ == 4) {
  
              var $11=$max_stress_posn; //@line 354 "intonation.cpp"
              $max_stress_posn2=$11; //@line 354 "intonation.cpp"
              ;
            }
  
            var $12=$ix; //@line 356 "intonation.cpp"
            $max_stress_posn=$12; //@line 356 "intonation.cpp"
            var $13=$stress; //@line 357 "intonation.cpp"
            $max_stress=$13; //@line 357 "intonation.cpp"
            __lastLabel__ = 5; ; //@line 358 "intonation.cpp"
          }
  
          var $14=__lastLabel__ == 5 ? $13 : ($6); //@line 359 "intonation.cpp"
          var $cmp6=((($14))|0) >= 4; //@line 359 "intonation.cpp"
          if ($cmp6) { __label__ = 7;; } else { __label__ = 10;; } //@line 359 "intonation.cpp"
          if (__label__ == 7) {
  
            var $15=HEAP32[((__ZL10number_pre)>>2)]; //@line 361 "intonation.cpp"
            var $cmp8=((($15))|0) < 0; //@line 361 "intonation.cpp"
            if ($cmp8) { __label__ = 8;; } else { __label__ = 9;; } //@line 361 "intonation.cpp"
            if (__label__ == 8) {
  
              var $16=$ix; //@line 362 "intonation.cpp"
              var $17=$start_addr; //@line 362 "intonation.cpp"
              var $sub=((($16)-($17))&4294967295); //@line 362 "intonation.cpp"
              HEAP32[((__ZL10number_pre)>>2)]=$sub; //@line 362 "intonation.cpp"
              ; //@line 362 "intonation.cpp"
            }
  
            var $18=$ix; //@line 364 "intonation.cpp"
            HEAP32[((__ZL12last_primary)>>2)]=$18; //@line 364 "intonation.cpp"
            ; //@line 365 "intonation.cpp"
          }
  
          var $19=$ix; //@line 342 "intonation.cpp"
          var $inc=((($19)+1)&4294967295); //@line 342 "intonation.cpp"
          $ix=$inc; //@line 342 "intonation.cpp"
          var $20=$ix; //@line 342 "intonation.cpp"
          var $21=$end_addr; //@line 342 "intonation.cpp"
          var $cmp=((($20))|0) < ((($21))|0); //@line 342 "intonation.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 11;break $for_body$$for_end$2; } //@line 342 "intonation.cpp"
        }
      }
    } while(0);
  
    var $22=HEAP32[((__ZL10number_pre)>>2)]; //@line 369 "intonation.cpp"
    var $cmp12=((($22))|0) < 0; //@line 369 "intonation.cpp"
    if ($cmp12) { __label__ = 12;; } else { __label__ = 13;; } //@line 369 "intonation.cpp"
    if (__label__ == 12) {
  
      var $23=$end_addr; //@line 370 "intonation.cpp"
      HEAP32[((__ZL10number_pre)>>2)]=$23; //@line 370 "intonation.cpp"
      ; //@line 370 "intonation.cpp"
    }
  
    var $24=$end_addr; //@line 372 "intonation.cpp"
    var $25=$max_stress_posn; //@line 372 "intonation.cpp"
    var $_neg=(((-($25)))&4294967295);
    var $sub15=((($24)-1)&4294967295); //@line 372 "intonation.cpp"
    var $sub16=((($sub15)+($_neg))&4294967295); //@line 372 "intonation.cpp"
    HEAP32[((__ZL11number_tail)>>2)]=$sub16; //@line 372 "intonation.cpp"
    var $26=$max_stress_posn; //@line 373 "intonation.cpp"
    HEAP32[((__ZL9tone_posn)>>2)]=$26; //@line 373 "intonation.cpp"
    var $27=$max_stress_posn2; //@line 374 "intonation.cpp"
    HEAP32[((__ZL10tone_posn2)>>2)]=$27; //@line 374 "intonation.cpp"
    var $_b=HEAPU8[(__ZL8no_tonic_b)];
    var $28=((($_b))&1);
    var $tobool=((($28))|0)!=0; //@line 376 "intonation.cpp"
    if ($tobool) { __label__ = 14;; } else { __label__ = 15;; } //@line 376 "intonation.cpp"
    $if_then17$$if_else18$22: do { 
      if (__label__ == 14) {
  
        var $29=$end_addr; //@line 378 "intonation.cpp"
        HEAP32[((__ZL10tone_posn2)>>2)]=$29; //@line 378 "intonation.cpp"
        HEAP32[((__ZL9tone_posn)>>2)]=$29; //@line 378 "intonation.cpp"
        ; //@line 379 "intonation.cpp"
      }
      else if (__label__ == 15) {
  
        var $30=HEAP32[((__ZL12last_primary)>>2)]; //@line 381 "intonation.cpp"
        var $cmp19=((($30))|0) >= 0; //@line 381 "intonation.cpp"
        if ($cmp19) { __label__ = 16;; } else { __label__ = 18;; } //@line 381 "intonation.cpp"
        if (__label__ == 16) {
  
          var $31=$end_addr; //@line 383 "intonation.cpp"
          var $32=$clause_end_addr; //@line 383 "intonation.cpp"
          var $cmp21=((($31))|0)==((($32))|0); //@line 383 "intonation.cpp"
          if (!($cmp21)) { __label__ = 19;break $if_then17$$if_else18$22; } //@line 383 "intonation.cpp"
  
          var $33=HEAP32[((__ZL12last_primary)>>2)]; //@line 385 "intonation.cpp"
          var $34=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 385 "intonation.cpp"
          var $arrayidx23=(($34+6*$33)&4294967295); //@line 385 "intonation.cpp"
          var $stress24=(($arrayidx23)&4294967295); //@line 385 "intonation.cpp"
          HEAP8[($stress24)]=7; //@line 385 "intonation.cpp"
          ; //@line 386 "intonation.cpp"
        }
        else if (__label__ == 18) {
  
          var $35=HEAP32[((__ZL9tone_posn)>>2)]; //@line 391 "intonation.cpp"
          var $36=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 391 "intonation.cpp"
          var $arrayidx27=(($36+6*$35)&4294967295); //@line 391 "intonation.cpp"
          var $stress28=(($arrayidx27)&4294967295); //@line 391 "intonation.cpp"
          HEAP8[($stress28)]=7; //@line 391 "intonation.cpp"
          ;
        }
      }
    } while(0);
  
    ;
    return; //@line 393 "intonation.cpp"
    return;
  }
  

  function __ZL12calc_pitchesiiii($control, $start, $end, $tune_number) {
    ;
    var __label__;
  
    var $retval;
    var $control_addr;
    var $start_addr;
    var $end_addr;
    var $tune_number_addr;
    var $ix;
    var $th;
    var $tn;
    var $drop;
    var $continuing;
    $control_addr=$control;
    $start_addr=$start;
    $end_addr=$end;
    $tune_number_addr=$tune_number;
    $continuing=0; //@line 859 "intonation.cpp"
    var $0=$control_addr; //@line 861 "intonation.cpp"
    var $cmp=((($0))|0)==0; //@line 861 "intonation.cpp"
    var $1=$start_addr; //@line 863 "intonation.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 861 "intonation.cpp"
    if (__label__ == 1) {
  
      var $2=$end_addr; //@line 863 "intonation.cpp"
      var $3=$tune_number_addr; //@line 863 "intonation.cpp"
      var $call=__ZL13calc_pitches2iii($1, $2, $3); //@line 863 "intonation.cpp"
      $retval=$call; //@line 863 "intonation.cpp"
      ; //@line 863 "intonation.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp1=((($1))|0) > 0; //@line 866 "intonation.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 866 "intonation.cpp"
      if (__label__ == 3) {
  
        $continuing=1; //@line 867 "intonation.cpp"
        ; //@line 867 "intonation.cpp"
      }
  
      var $4=$tune_number_addr; //@line 869 "intonation.cpp"
      var $arrayidx=((__ZL15tone_head_table+$4*16)&4294967295); //@line 869 "intonation.cpp"
      $th=$arrayidx; //@line 869 "intonation.cpp"
      var $5=$tune_number_addr; //@line 870 "intonation.cpp"
      var $arrayidx4=((__ZL18tone_nucleus_table+$5*16)&4294967295); //@line 870 "intonation.cpp"
      $tn=$arrayidx4; //@line 870 "intonation.cpp"
      var $6=$start_addr; //@line 871 "intonation.cpp"
      $ix=$6; //@line 871 "intonation.cpp"
      var $7=$ix; //@line 876 "intonation.cpp"
      var $8=$ix; //@line 876 "intonation.cpp"
      var $9=HEAP32[((__ZL10number_pre)>>2)]; //@line 876 "intonation.cpp"
      var $add=((($9)+($8))&4294967295); //@line 876 "intonation.cpp"
      var $10=$th; //@line 876 "intonation.cpp"
      var $pre_start=(($10)&4294967295); //@line 876 "intonation.cpp"
      var $11=HEAPU8[($pre_start)]; //@line 876 "intonation.cpp"
      var $conv=((($11))&255); //@line 876 "intonation.cpp"
      var $12=$th; //@line 876 "intonation.cpp"
      var $pre_end=(($12+1)&4294967295); //@line 876 "intonation.cpp"
      var $13=HEAPU8[($pre_end)]; //@line 876 "intonation.cpp"
      var $conv5=((($13))&255); //@line 876 "intonation.cpp"
      __ZL16SetPitchGradientiiii($7, $add, $conv, $conv5); //@line 876 "intonation.cpp"
      var $14=HEAP32[((__ZL10number_pre)>>2)]; //@line 877 "intonation.cpp"
      var $15=$ix; //@line 877 "intonation.cpp"
      var $add6=((($15)+($14))&4294967295); //@line 877 "intonation.cpp"
      $ix=$add6; //@line 877 "intonation.cpp"
      var $16=HEAP32[((_option_tone_flags)>>2)]; //@line 882 "intonation.cpp"
      var $and=($16) & 512; //@line 882 "intonation.cpp"
      var $tobool=((($and))|0)!=0; //@line 882 "intonation.cpp"
      if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 882 "intonation.cpp"
      if (__label__ == 5) {
  
        var $17=HEAP32[((__ZL10tone_posn2)>>2)]; //@line 884 "intonation.cpp"
        HEAP32[((__ZL9tone_posn)>>2)]=$17; //@line 884 "intonation.cpp"
        ; //@line 885 "intonation.cpp"
      }
  
      var $18=$ix; //@line 886 "intonation.cpp"
      var $19=HEAP32[((__ZL9tone_posn)>>2)]; //@line 886 "intonation.cpp"
      var $20=$th; //@line 886 "intonation.cpp"
      var $21=$tn; //@line 886 "intonation.cpp"
      var $22=$continuing; //@line 886 "intonation.cpp"
      var $call9=__ZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSii($18, $19, $20, $21, $22); //@line 886 "intonation.cpp"
      $ix=$call9; //@line 886 "intonation.cpp"
      var $_b=HEAPU8[(__ZL8no_tonic_b)];
      var $23=((($_b))&1);
      var $tobool10=((($23))|0)!=0; //@line 889 "intonation.cpp"
      if ($tobool10) { __label__ = 7;; } else { __label__ = 8;; } //@line 889 "intonation.cpp"
      if (__label__ == 7) {
  
        $retval=0; //@line 890 "intonation.cpp"
        ; //@line 890 "intonation.cpp"
      }
      else if (__label__ == 8) {
  
        var $24=$tn; //@line 895 "intonation.cpp"
        var $flags=(($24+14)&4294967295); //@line 895 "intonation.cpp"
        var $25=HEAPU8[($flags)]; //@line 895 "intonation.cpp"
        var $conv13=((($25))&255); //@line 895 "intonation.cpp"
        var $and14=($conv13) & 1; //@line 895 "intonation.cpp"
        var $tobool15=((($and14))|0)!=0; //@line 895 "intonation.cpp"
        if ($tobool15) { __label__ = 9;; } else { __label__ = 10;; } //@line 895 "intonation.cpp"
        if (__label__ == 9) {
  
          var $26=$ix; //@line 897 "intonation.cpp"
          var $27=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 897 "intonation.cpp"
          var $arrayidx17=(($27+6*$26)&4294967295); //@line 897 "intonation.cpp"
          var $flags18=(($arrayidx17+2)&4294967295); //@line 897 "intonation.cpp"
          var $28=HEAP8[($flags18)]; //@line 897 "intonation.cpp"
          var $conv19=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 897 "intonation.cpp"
          var $or=($conv19) | 2; //@line 897 "intonation.cpp"
          var $conv20=((($or)) & 255); //@line 897 "intonation.cpp"
          HEAP8[($flags18)]=$conv20; //@line 897 "intonation.cpp"
          ; //@line 898 "intonation.cpp"
        }
  
        var $29=HEAP32[((__ZL11number_tail)>>2)]; //@line 900 "intonation.cpp"
        var $cmp22=((($29))|0)==0; //@line 900 "intonation.cpp"
        var $30=$tn; //@line 902 "intonation.cpp"
        if ($cmp22) { __label__ = 11;; } else { __label__ = 12;; } //@line 900 "intonation.cpp"
        if (__label__ == 11) {
  
          var $pitch_env0=(($30)&4294967295); //@line 902 "intonation.cpp"
          var $31=HEAPU8[($pitch_env0)]; //@line 902 "intonation.cpp"
          var $conv24=((($31))&255); //@line 902 "intonation.cpp"
          HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv24; //@line 902 "intonation.cpp"
          var $32=$tn; //@line 903 "intonation.cpp"
          var $tonic_max0=(($32+1)&4294967295); //@line 903 "intonation.cpp"
          var $33=HEAPU8[($tonic_max0)]; //@line 903 "intonation.cpp"
          var $conv25=((($33))&255); //@line 903 "intonation.cpp"
          var $34=$tn; //@line 903 "intonation.cpp"
          var $tonic_min0=(($34+2)&4294967295); //@line 903 "intonation.cpp"
          var $35=HEAPU8[($tonic_min0)]; //@line 903 "intonation.cpp"
          var $conv26=((($35))&255); //@line 903 "intonation.cpp"
          var $sub=((($conv25)-($conv26))&4294967295); //@line 903 "intonation.cpp"
          $drop=$sub; //@line 903 "intonation.cpp"
          var $36=$ix; //@line 904 "intonation.cpp"
          var $inc=((($36)+1)&4294967295); //@line 904 "intonation.cpp"
          $ix=$inc; //@line 904 "intonation.cpp"
          var $37=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 904 "intonation.cpp"
          var $arrayidx27=(($37+6*$36)&4294967295); //@line 904 "intonation.cpp"
          var $38=$tn; //@line 904 "intonation.cpp"
          var $tonic_min028=(($38+2)&4294967295); //@line 904 "intonation.cpp"
          var $39=HEAPU8[($tonic_min028)]; //@line 904 "intonation.cpp"
          var $conv29=((($39))&255); //@line 904 "intonation.cpp"
          var $40=$drop; //@line 904 "intonation.cpp"
          __ZL9set_pitchP8SYLLABLEii($arrayidx27, $conv29, $40); //@line 904 "intonation.cpp"
          ; //@line 905 "intonation.cpp"
        }
        else if (__label__ == 12) {
  
          var $pitch_env1=(($30+3)&4294967295); //@line 908 "intonation.cpp"
          var $41=HEAPU8[($pitch_env1)]; //@line 908 "intonation.cpp"
          var $conv30=((($41))&255); //@line 908 "intonation.cpp"
          HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv30; //@line 908 "intonation.cpp"
          var $42=$tn; //@line 909 "intonation.cpp"
          var $tonic_max1=(($42+4)&4294967295); //@line 909 "intonation.cpp"
          var $43=HEAPU8[($tonic_max1)]; //@line 909 "intonation.cpp"
          var $conv31=((($43))&255); //@line 909 "intonation.cpp"
          var $44=$tn; //@line 909 "intonation.cpp"
          var $tonic_min1=(($44+5)&4294967295); //@line 909 "intonation.cpp"
          var $45=HEAPU8[($tonic_min1)]; //@line 909 "intonation.cpp"
          var $conv32=((($45))&255); //@line 909 "intonation.cpp"
          var $sub33=((($conv31)-($conv32))&4294967295); //@line 909 "intonation.cpp"
          $drop=$sub33; //@line 909 "intonation.cpp"
          var $46=$ix; //@line 910 "intonation.cpp"
          var $inc34=((($46)+1)&4294967295); //@line 910 "intonation.cpp"
          $ix=$inc34; //@line 910 "intonation.cpp"
          var $47=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 910 "intonation.cpp"
          var $arrayidx35=(($47+6*$46)&4294967295); //@line 910 "intonation.cpp"
          var $48=$tn; //@line 910 "intonation.cpp"
          var $tonic_min136=(($48+5)&4294967295); //@line 910 "intonation.cpp"
          var $49=HEAPU8[($tonic_min136)]; //@line 910 "intonation.cpp"
          var $conv37=((($49))&255); //@line 910 "intonation.cpp"
          var $50=$drop; //@line 910 "intonation.cpp"
          __ZL9set_pitchP8SYLLABLEii($arrayidx35, $conv37, $50); //@line 910 "intonation.cpp"
          ;
        }
  
        var $51=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 913 "intonation.cpp"
        var $conv39=((($51)) & 255); //@line 913 "intonation.cpp"
        var $52=HEAP32[((__ZL9tone_posn)>>2)]; //@line 913 "intonation.cpp"
        var $53=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 913 "intonation.cpp"
        var $arrayidx40=(($53+6*$52)&4294967295); //@line 913 "intonation.cpp"
        var $env=(($arrayidx40+1)&4294967295); //@line 913 "intonation.cpp"
        HEAP8[($env)]=$conv39; //@line 913 "intonation.cpp"
        var $54=HEAP32[((__ZL9tone_posn)>>2)]; //@line 914 "intonation.cpp"
        var $55=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 914 "intonation.cpp"
        var $arrayidx41=(($55+6*$54)&4294967295); //@line 914 "intonation.cpp"
        var $stress=(($arrayidx41)&4294967295); //@line 914 "intonation.cpp"
        var $56=HEAP8[($stress)]; //@line 914 "intonation.cpp"
        var $conv42=(tempInt=(($56)),(tempInt>=128?tempInt-256:tempInt)); //@line 914 "intonation.cpp"
        var $cmp43=((($conv42))|0)==4; //@line 914 "intonation.cpp"
        if ($cmp43) { __label__ = 14;; } else { __label__ = 15;; } //@line 914 "intonation.cpp"
        if (__label__ == 14) {
  
          var $57=HEAP32[((__ZL9tone_posn)>>2)]; //@line 915 "intonation.cpp"
          var $58=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 915 "intonation.cpp"
          var $arrayidx45=(($58+6*$57)&4294967295); //@line 915 "intonation.cpp"
          var $stress46=(($arrayidx45)&4294967295); //@line 915 "intonation.cpp"
          HEAP8[($stress46)]=6; //@line 915 "intonation.cpp"
          ; //@line 915 "intonation.cpp"
        }
  
        var $59=$ix; //@line 920 "intonation.cpp"
        var $60=$end_addr; //@line 920 "intonation.cpp"
        var $61=$tn; //@line 920 "intonation.cpp"
        var $tail_start=(($61+12)&4294967295); //@line 920 "intonation.cpp"
        var $62=HEAPU8[($tail_start)]; //@line 920 "intonation.cpp"
        var $conv48=((($62))&255); //@line 920 "intonation.cpp"
        var $63=$tn; //@line 920 "intonation.cpp"
        var $tail_end=(($63+13)&4294967295); //@line 920 "intonation.cpp"
        var $64=HEAPU8[($tail_end)]; //@line 920 "intonation.cpp"
        var $conv49=((($64))&255); //@line 920 "intonation.cpp"
        __ZL16SetPitchGradientiiii($59, $60, $conv48, $conv49); //@line 920 "intonation.cpp"
        var $65=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 922 "intonation.cpp"
        $retval=$65; //@line 922 "intonation.cpp"
        ; //@line 922 "intonation.cpp"
      }
    }
  
    ;
    return;
    return;
  }
  

  function __ZL13calc_pitches2iii($start, $end, $tune_number) {
    ;
    var __label__;
  
    var $retval;
    var $start_addr;
    var $end_addr;
    var $tune_number_addr;
    var $ix;
    var $tune;
    var $drop;
    var $continuing;
    $start_addr=$start;
    $end_addr=$end;
    $tune_number_addr=$tune_number;
    $continuing=0; //@line 790 "intonation.cpp"
    var $0=$start_addr; //@line 792 "intonation.cpp"
    var $cmp=((($0))|0) > 0; //@line 792 "intonation.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 792 "intonation.cpp"
    if (__label__ == 1) {
  
      $continuing=1; //@line 793 "intonation.cpp"
      ; //@line 793 "intonation.cpp"
    }
  
    var $1=$tune_number_addr; //@line 795 "intonation.cpp"
    var $2=HEAP32[((_tunes)>>2)]; //@line 795 "intonation.cpp"
    var $arrayidx=(($2+68*$1)&4294967295); //@line 795 "intonation.cpp"
    $tune=$arrayidx; //@line 795 "intonation.cpp"
    var $3=$start_addr; //@line 796 "intonation.cpp"
    $ix=$3; //@line 796 "intonation.cpp"
    var $4=$ix; //@line 801 "intonation.cpp"
    var $5=$ix; //@line 801 "intonation.cpp"
    var $6=HEAP32[((__ZL10number_pre)>>2)]; //@line 801 "intonation.cpp"
    var $add=((($6)+($5))&4294967295); //@line 801 "intonation.cpp"
    var $7=$tune; //@line 801 "intonation.cpp"
    var $prehead_start=(($7+24)&4294967295); //@line 801 "intonation.cpp"
    var $8=HEAPU8[($prehead_start)]; //@line 801 "intonation.cpp"
    var $conv=((($8))&255); //@line 801 "intonation.cpp"
    var $9=$tune; //@line 801 "intonation.cpp"
    var $prehead_end=(($9+25)&4294967295); //@line 801 "intonation.cpp"
    var $10=HEAPU8[($prehead_end)]; //@line 801 "intonation.cpp"
    var $conv1=((($10))&255); //@line 801 "intonation.cpp"
    __ZL16SetPitchGradientiiii($4, $add, $conv, $conv1); //@line 801 "intonation.cpp"
    var $11=HEAP32[((__ZL10number_pre)>>2)]; //@line 802 "intonation.cpp"
    var $12=$ix; //@line 802 "intonation.cpp"
    var $add2=((($12)+($11))&4294967295); //@line 802 "intonation.cpp"
    $ix=$add2; //@line 802 "intonation.cpp"
    var $13=HEAP32[((_option_tone_flags)>>2)]; //@line 807 "intonation.cpp"
    var $and=($13) & 512; //@line 807 "intonation.cpp"
    var $tobool=((($and))|0)!=0; //@line 807 "intonation.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 807 "intonation.cpp"
    if (__label__ == 3) {
  
      var $14=HEAP32[((__ZL10tone_posn2)>>2)]; //@line 809 "intonation.cpp"
      HEAP32[((__ZL9tone_posn)>>2)]=$14; //@line 809 "intonation.cpp"
      ; //@line 810 "intonation.cpp"
    }
  
    var $15=$tune; //@line 811 "intonation.cpp"
    var $16=$ix; //@line 811 "intonation.cpp"
    var $17=HEAP32[((__ZL9tone_posn)>>2)]; //@line 811 "intonation.cpp"
    var $call=__ZL17SetHeadIntonationP4TUNEiii($15, $16, $17); //@line 811 "intonation.cpp"
    $ix=$call; //@line 811 "intonation.cpp"
    var $_b=HEAPU8[(__ZL8no_tonic_b)];
    var $18=((($_b))&1);
    var $tobool5=((($18))|0)!=0; //@line 813 "intonation.cpp"
    if ($tobool5) { __label__ = 5;; } else { __label__ = 6;; } //@line 813 "intonation.cpp"
    if (__label__ == 5) {
  
      $retval=0; //@line 814 "intonation.cpp"
      ; //@line 814 "intonation.cpp"
    }
    else if (__label__ == 6) {
  
      var $19=HEAP32[((__ZL11number_tail)>>2)]; //@line 824 "intonation.cpp"
      var $cmp8=((($19))|0)==0; //@line 824 "intonation.cpp"
      var $20=$tune; //@line 826 "intonation.cpp"
      if ($cmp8) { __label__ = 7;; } else { __label__ = 8;; } //@line 824 "intonation.cpp"
      if (__label__ == 7) {
  
        var $nucleus0_env=(($20+42)&4294967295); //@line 826 "intonation.cpp"
        var $21=HEAPU8[($nucleus0_env)]; //@line 826 "intonation.cpp"
        var $conv10=((($21))&255); //@line 826 "intonation.cpp"
        HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv10; //@line 826 "intonation.cpp"
        var $22=$tune; //@line 827 "intonation.cpp"
        var $nucleus0_max=(($22+43)&4294967295); //@line 827 "intonation.cpp"
        var $23=HEAPU8[($nucleus0_max)]; //@line 827 "intonation.cpp"
        var $conv11=((($23))&255); //@line 827 "intonation.cpp"
        var $24=$tune; //@line 827 "intonation.cpp"
        var $nucleus0_min=(($24+44)&4294967295); //@line 827 "intonation.cpp"
        var $25=HEAPU8[($nucleus0_min)]; //@line 827 "intonation.cpp"
        var $conv12=((($25))&255); //@line 827 "intonation.cpp"
        var $sub=((($conv11)-($conv12))&4294967295); //@line 827 "intonation.cpp"
        $drop=$sub; //@line 827 "intonation.cpp"
        var $26=$ix; //@line 828 "intonation.cpp"
        var $inc=((($26)+1)&4294967295); //@line 828 "intonation.cpp"
        $ix=$inc; //@line 828 "intonation.cpp"
        var $27=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 828 "intonation.cpp"
        var $arrayidx13=(($27+6*$26)&4294967295); //@line 828 "intonation.cpp"
        var $28=$tune; //@line 828 "intonation.cpp"
        var $nucleus0_min14=(($28+44)&4294967295); //@line 828 "intonation.cpp"
        var $29=HEAPU8[($nucleus0_min14)]; //@line 828 "intonation.cpp"
        var $conv15=((($29))&255); //@line 828 "intonation.cpp"
        var $30=$drop; //@line 828 "intonation.cpp"
        __ZL9set_pitchP8SYLLABLEii($arrayidx13, $conv15, $30); //@line 828 "intonation.cpp"
        ; //@line 829 "intonation.cpp"
      }
      else if (__label__ == 8) {
  
        var $nucleus1_env=(($20+45)&4294967295); //@line 832 "intonation.cpp"
        var $31=HEAPU8[($nucleus1_env)]; //@line 832 "intonation.cpp"
        var $conv16=((($31))&255); //@line 832 "intonation.cpp"
        HEAP32[((__ZL14tone_pitch_env)>>2)]=$conv16; //@line 832 "intonation.cpp"
        var $32=$tune; //@line 833 "intonation.cpp"
        var $nucleus1_max=(($32+46)&4294967295); //@line 833 "intonation.cpp"
        var $33=HEAPU8[($nucleus1_max)]; //@line 833 "intonation.cpp"
        var $conv17=((($33))&255); //@line 833 "intonation.cpp"
        var $34=$tune; //@line 833 "intonation.cpp"
        var $nucleus1_min=(($34+47)&4294967295); //@line 833 "intonation.cpp"
        var $35=HEAPU8[($nucleus1_min)]; //@line 833 "intonation.cpp"
        var $conv18=((($35))&255); //@line 833 "intonation.cpp"
        var $sub19=((($conv17)-($conv18))&4294967295); //@line 833 "intonation.cpp"
        $drop=$sub19; //@line 833 "intonation.cpp"
        var $36=$ix; //@line 834 "intonation.cpp"
        var $inc20=((($36)+1)&4294967295); //@line 834 "intonation.cpp"
        $ix=$inc20; //@line 834 "intonation.cpp"
        var $37=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 834 "intonation.cpp"
        var $arrayidx21=(($37+6*$36)&4294967295); //@line 834 "intonation.cpp"
        var $38=$tune; //@line 834 "intonation.cpp"
        var $nucleus1_min22=(($38+47)&4294967295); //@line 834 "intonation.cpp"
        var $39=HEAPU8[($nucleus1_min22)]; //@line 834 "intonation.cpp"
        var $conv23=((($39))&255); //@line 834 "intonation.cpp"
        var $40=$drop; //@line 834 "intonation.cpp"
        __ZL9set_pitchP8SYLLABLEii($arrayidx21, $conv23, $40); //@line 834 "intonation.cpp"
        ;
      }
  
      var $41=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 837 "intonation.cpp"
      var $conv25=((($41)) & 255); //@line 837 "intonation.cpp"
      var $42=HEAP32[((__ZL9tone_posn)>>2)]; //@line 837 "intonation.cpp"
      var $43=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 837 "intonation.cpp"
      var $arrayidx26=(($43+6*$42)&4294967295); //@line 837 "intonation.cpp"
      var $env=(($arrayidx26+1)&4294967295); //@line 837 "intonation.cpp"
      HEAP8[($env)]=$conv25; //@line 837 "intonation.cpp"
      var $44=HEAP32[((__ZL9tone_posn)>>2)]; //@line 838 "intonation.cpp"
      var $45=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 838 "intonation.cpp"
      var $arrayidx27=(($45+6*$44)&4294967295); //@line 838 "intonation.cpp"
      var $stress=(($arrayidx27)&4294967295); //@line 838 "intonation.cpp"
      var $46=HEAP8[($stress)]; //@line 838 "intonation.cpp"
      var $conv28=(tempInt=(($46)),(tempInt>=128?tempInt-256:tempInt)); //@line 838 "intonation.cpp"
      var $cmp29=((($conv28))|0)==4; //@line 838 "intonation.cpp"
      if ($cmp29) { __label__ = 10;; } else { __label__ = 11;; } //@line 838 "intonation.cpp"
      if (__label__ == 10) {
  
        var $47=HEAP32[((__ZL9tone_posn)>>2)]; //@line 839 "intonation.cpp"
        var $48=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 839 "intonation.cpp"
        var $arrayidx31=(($48+6*$47)&4294967295); //@line 839 "intonation.cpp"
        var $stress32=(($arrayidx31)&4294967295); //@line 839 "intonation.cpp"
        HEAP8[($stress32)]=6; //@line 839 "intonation.cpp"
        ; //@line 839 "intonation.cpp"
      }
  
      var $49=$ix; //@line 844 "intonation.cpp"
      var $50=$end_addr; //@line 844 "intonation.cpp"
      var $51=$tune; //@line 844 "intonation.cpp"
      var $tail_start=(($51+48)&4294967295); //@line 844 "intonation.cpp"
      var $52=HEAPU8[($tail_start)]; //@line 844 "intonation.cpp"
      var $conv34=((($52))&255); //@line 844 "intonation.cpp"
      var $53=$tune; //@line 844 "intonation.cpp"
      var $tail_end=(($53+49)&4294967295); //@line 844 "intonation.cpp"
      var $54=HEAPU8[($tail_end)]; //@line 844 "intonation.cpp"
      var $conv35=((($54))&255); //@line 844 "intonation.cpp"
      __ZL16SetPitchGradientiiii($49, $50, $conv34, $conv35); //@line 844 "intonation.cpp"
      var $55=HEAP32[((__ZL14tone_pitch_env)>>2)]; //@line 846 "intonation.cpp"
      $retval=$55; //@line 846 "intonation.cpp"
      ; //@line 846 "intonation.cpp"
    }
  
    var $56=$retval; //@line 847 "intonation.cpp"
    ;
    return $56; //@line 847 "intonation.cpp"
    return null;
  }
  

  function __ZL16SetPitchGradientiiii($start_ix, $end_ix, $start_pitch, $end_pitch) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $start_ix_addr;
    var $end_ix_addr;
    var $start_pitch_addr;
    var $end_pitch_addr;
    var $ix;
    var $stress;
    var $pitch;
    var $increment;
    var $n_increments;
    var $drop;
    var $syl;
    $start_ix_addr=$start_ix;
    $end_ix_addr=$end_ix;
    $start_pitch_addr=$start_pitch;
    $end_pitch_addr=$end_pitch;
    var $0=$end_pitch_addr; //@line 743 "intonation.cpp"
    var $1=$start_pitch_addr; //@line 743 "intonation.cpp"
    var $sub=((($0)-($1))&4294967295); //@line 743 "intonation.cpp"
    var $shl=($sub) << 8; //@line 743 "intonation.cpp"
    $increment=$shl; //@line 743 "intonation.cpp"
    var $2=$end_ix_addr; //@line 744 "intonation.cpp"
    var $3=$start_ix_addr; //@line 744 "intonation.cpp"
    var $sub1=((($2)-($3))&4294967295); //@line 744 "intonation.cpp"
    $n_increments=$sub1; //@line 744 "intonation.cpp"
    var $4=$n_increments; //@line 746 "intonation.cpp"
    var $cmp=((($4))|0) <= 0; //@line 746 "intonation.cpp"
    if ($cmp) { __label__ = 12;; } else { __label__ = 1;; } //@line 746 "intonation.cpp"
    $for_end$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $5=$n_increments; //@line 749 "intonation.cpp"
        var $cmp2=((($5))|0) > 1; //@line 749 "intonation.cpp"
        if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 749 "intonation.cpp"
        if (__label__ == 2) {
  
          var $6=$increment; //@line 751 "intonation.cpp"
          var $7=$n_increments; //@line 751 "intonation.cpp"
          var $div=((((($6))|0)/((($7))|0))|0); //@line 751 "intonation.cpp"
          $increment=$div; //@line 751 "intonation.cpp"
          ; //@line 752 "intonation.cpp"
        }
  
        var $8=$start_pitch_addr; //@line 754 "intonation.cpp"
        var $shl5=($8) << 8; //@line 754 "intonation.cpp"
        $pitch=$shl5; //@line 754 "intonation.cpp"
        var $9=$start_ix_addr; //@line 756 "intonation.cpp"
        $ix=$9; //@line 756 "intonation.cpp"
        var $10=$ix; //@line 756 "intonation.cpp"
        var $11=$end_ix_addr; //@line 756 "intonation.cpp"
        var $cmp61=((($10))|0) < ((($11))|0); //@line 756 "intonation.cpp"
        if (!($cmp61)) { __label__ = 12;break $for_end$$if_end$2; } //@line 756 "intonation.cpp"
        while(1) { 
  
          var $12=$ix; //@line 758 "intonation.cpp"
          var $13=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 758 "intonation.cpp"
          var $arrayidx=(($13+6*$12)&4294967295); //@line 758 "intonation.cpp"
          $syl=$arrayidx; //@line 758 "intonation.cpp"
          var $14=$syl; //@line 759 "intonation.cpp"
          var $stress7=(($14)&4294967295); //@line 759 "intonation.cpp"
          var $15=HEAP8[($stress7)]; //@line 759 "intonation.cpp"
          var $conv=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 759 "intonation.cpp"
          $stress=$conv; //@line 759 "intonation.cpp"
          var $16=$increment; //@line 761 "intonation.cpp"
          var $cmp8=((($16))|0) > 0; //@line 761 "intonation.cpp"
          if ($cmp8) { __label__ = 5;; } else { __label__ = 6;; } //@line 761 "intonation.cpp"
          if (__label__ == 5) {
  
            var $17=$syl; //@line 763 "intonation.cpp"
            var $18=$pitch; //@line 763 "intonation.cpp"
            var $shr=($18) >> 8; //@line 763 "intonation.cpp"
            var $19=$increment; //@line 763 "intonation.cpp"
            var $shr10=($19) >> 8; //@line 763 "intonation.cpp"
            var $sub11=(((-($shr10)))&4294967295); //@line 763 "intonation.cpp"
            __ZL9set_pitchP8SYLLABLEii($17, $shr, $sub11); //@line 763 "intonation.cpp"
            var $20=$increment; //@line 764 "intonation.cpp"
            var $21=$pitch; //@line 764 "intonation.cpp"
            var $add=((($21)+($20))&4294967295); //@line 764 "intonation.cpp"
            $pitch=$add; //@line 764 "intonation.cpp"
            ; //@line 765 "intonation.cpp"
          }
          else if (__label__ == 6) {
  
            var $22=$increment; //@line 768 "intonation.cpp"
            var $shr12=($22) >> 8; //@line 768 "intonation.cpp"
            var $sub13=(((-($shr12)))&4294967295); //@line 768 "intonation.cpp"
            $drop=$sub13; //@line 768 "intonation.cpp"
            var $23=$drop; //@line 769 "intonation.cpp"
            var $24=$stress; //@line 769 "intonation.cpp"
            var $arrayidx14=((__ZL8min_drop+$24*4)&4294967295); //@line 769 "intonation.cpp"
            var $25=HEAP32[(($arrayidx14)>>2)]; //@line 769 "intonation.cpp"
            var $cmp15=((($23))|0) < ((($25))|0); //@line 769 "intonation.cpp"
            if ($cmp15) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 8;; } //@line 769 "intonation.cpp"
            if (__label__ == 7) {
  
              var $26=$stress; //@line 770 "intonation.cpp"
              var $arrayidx17=((__ZL8min_drop+$26*4)&4294967295); //@line 770 "intonation.cpp"
              var $27=HEAP32[(($arrayidx17)>>2)]; //@line 770 "intonation.cpp"
              $drop=$27; //@line 770 "intonation.cpp"
              __lastLabel__ = 7; ; //@line 770 "intonation.cpp"
            }
  
            var $28=__lastLabel__ == 7 ? $27 : ($23); //@line 774 "intonation.cpp"
            var $29=$increment; //@line 772 "intonation.cpp"
            var $30=$pitch; //@line 772 "intonation.cpp"
            var $add19=((($30)+($29))&4294967295); //@line 772 "intonation.cpp"
            $pitch=$add19; //@line 772 "intonation.cpp"
            var $cmp20=((($28))|0) > 18; //@line 774 "intonation.cpp"
            if ($cmp20) { __label__ = 9;; } else { __label__ = 10;; } //@line 774 "intonation.cpp"
            if (__label__ == 9) {
  
              $drop=18; //@line 775 "intonation.cpp"
              ; //@line 775 "intonation.cpp"
            }
  
            var $31=$syl; //@line 776 "intonation.cpp"
            var $32=$pitch; //@line 776 "intonation.cpp"
            var $shr23=($32) >> 8; //@line 776 "intonation.cpp"
            var $33=$drop; //@line 776 "intonation.cpp"
            __ZL9set_pitchP8SYLLABLEii($31, $shr23, $33); //@line 776 "intonation.cpp"
            ;
          }
  
          var $34=$ix; //@line 756 "intonation.cpp"
          var $inc=((($34)+1)&4294967295); //@line 756 "intonation.cpp"
          $ix=$inc; //@line 756 "intonation.cpp"
          var $35=$ix; //@line 756 "intonation.cpp"
          var $36=$end_ix_addr; //@line 756 "intonation.cpp"
          var $cmp6=((($35))|0) < ((($36))|0); //@line 756 "intonation.cpp"
          if ($cmp6) { __label__ = 4;continue ; } else { __label__ = 12;break $for_end$$if_end$2; } //@line 756 "intonation.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 779 "intonation.cpp"
    return;
  }
  

  function __ZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSii($ix, $end_ix, $th, $tn, $continuing) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $ix_addr;
    var $end_ix_addr;
    var $th_addr;
    var $tn_addr;
    var $min_stress_addr;
    var $continuing_addr;
    var $stress;
    var $pitch;
    var $increment;
    var $n_primary;
    var $n_steps;
    var $initial;
    var $overflow;
    var $n_overflow;
    var $pitch_range;
    var $pitch_range_abs;
    var $drops;
    var $overflow_tab;
    var $syl;
    $ix_addr=$ix;
    $end_ix_addr=$end_ix;
    $th_addr=$th;
    $tn_addr=$tn;
    $min_stress_addr=4;
    $continuing_addr=$continuing;
    $pitch=0; //@line 616 "intonation.cpp"
    $increment=0; //@line 617 "intonation.cpp"
    $n_primary=0; //@line 618 "intonation.cpp"
    $n_steps=0; //@line 619 "intonation.cpp"
    $overflow=0; //@line 621 "intonation.cpp"
    var $0=$th_addr; //@line 631 "intonation.cpp"
    var $body_drops=(($0+4)&4294967295); //@line 631 "intonation.cpp"
    var $1=HEAP32[(($body_drops)>>2)]; //@line 631 "intonation.cpp"
    $drops=$1; //@line 631 "intonation.cpp"
    var $2=$th_addr; //@line 632 "intonation.cpp"
    var $body_end=(($2+3)&4294967295); //@line 632 "intonation.cpp"
    var $3=HEAPU8[($body_end)]; //@line 632 "intonation.cpp"
    var $conv=((($3))&255); //@line 632 "intonation.cpp"
    var $4=$th_addr; //@line 632 "intonation.cpp"
    var $body_start=(($4+2)&4294967295); //@line 632 "intonation.cpp"
    var $5=HEAPU8[($body_start)]; //@line 632 "intonation.cpp"
    var $conv1=((($5))&255); //@line 632 "intonation.cpp"
    var $sub=((($conv)-($conv1))&4294967295); //@line 632 "intonation.cpp"
    var $shl=($sub) << 8; //@line 632 "intonation.cpp"
    $pitch_range=$shl; //@line 632 "intonation.cpp"
    var $6=$pitch_range; //@line 633 "intonation.cpp"
    var $ispos=((($6))|0) > -1; //@line 633 "intonation.cpp"
    var $neg=(((-($6)))&4294967295); //@line 633 "intonation.cpp"
    var $call=($ispos) ? ($6) : ($neg); //@line 633 "intonation.cpp"
    $pitch_range_abs=$call; //@line 633 "intonation.cpp"
    var $7=$continuing_addr; //@line 635 "intonation.cpp"
    var $tobool=((($7))|0)!=0; //@line 635 "intonation.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 635 "intonation.cpp"
    if (__label__ == 1) {
  
      $initial=0; //@line 637 "intonation.cpp"
      $overflow=0; //@line 638 "intonation.cpp"
      $n_overflow=5; //@line 639 "intonation.cpp"
      $overflow_tab=((__ZZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSiiE12continue_tab)&4294967295); //@line 640 "intonation.cpp"
      var $8=$pitch_range; //@line 641 "intonation.cpp"
      var $9=$th_addr; //@line 641 "intonation.cpp"
      var $body_max_steps=(($9+8)&4294967295); //@line 641 "intonation.cpp"
      var $10=HEAPU8[($body_max_steps)]; //@line 641 "intonation.cpp"
      var $conv2=((($10))&255); //@line 641 "intonation.cpp"
      var $sub3=((($conv2)-1)&4294967295); //@line 641 "intonation.cpp"
      var $div=((((($8))|0)/((($sub3))|0))|0); //@line 641 "intonation.cpp"
      $increment=$div; //@line 641 "intonation.cpp"
      ; //@line 642 "intonation.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=$th_addr; //@line 645 "intonation.cpp"
      var $n_overflow4=(($11+10)&4294967295); //@line 645 "intonation.cpp"
      var $12=HEAPU8[($n_overflow4)]; //@line 645 "intonation.cpp"
      var $conv5=((($12))&255); //@line 645 "intonation.cpp"
      $n_overflow=$conv5; //@line 645 "intonation.cpp"
      var $13=$th_addr; //@line 646 "intonation.cpp"
      var $overflow6=(($13+12)&4294967295); //@line 646 "intonation.cpp"
      var $14=HEAP32[(($overflow6)>>2)]; //@line 646 "intonation.cpp"
      $overflow_tab=$14; //@line 646 "intonation.cpp"
      $initial=1; //@line 647 "intonation.cpp"
      ;
    }
  
    var $15=$ix_addr; //@line 650 "intonation.cpp"
    var $16=$end_ix_addr; //@line 650 "intonation.cpp"
    var $cmp4=((($15))|0) < ((($16))|0); //@line 650 "intonation.cpp"
    var $17=$ix_addr; //@line 652 "intonation.cpp"
    if ($cmp4) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 31;; } //@line 650 "intonation.cpp"
    $while_body$$while_end$6: do { 
      if (__label__ == 4) {
        $while_body$7: while(1) { 
  
          var $18=__lastLabel__ == 30 ? $90 : ($17);
          var $19=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 652 "intonation.cpp"
          var $arrayidx=(($19+6*$18)&4294967295); //@line 652 "intonation.cpp"
          $syl=$arrayidx; //@line 652 "intonation.cpp"
          var $20=$syl; //@line 653 "intonation.cpp"
          var $stress7=(($20)&4294967295); //@line 653 "intonation.cpp"
          var $21=HEAP8[($stress7)]; //@line 653 "intonation.cpp"
          var $conv8=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 653 "intonation.cpp"
          $stress=$conv8; //@line 653 "intonation.cpp"
          var $22=$initial; //@line 658 "intonation.cpp"
          var $tobool9=((($22))|0)!=0; //@line 658 "intonation.cpp"
          if ($tobool9) { __label__ = 8;; } else { __label__ = 5;; } //@line 658 "intonation.cpp"
          $if_then15$$lor_lhs_false$9: do { 
            if (__label__ == 5) {
  
              var $23=$stress; //@line 658 "intonation.cpp"
              var $24=$min_stress_addr; //@line 658 "intonation.cpp"
              var $cmp10=((($23))|0) >= ((($24))|0); //@line 658 "intonation.cpp"
              if ($cmp10) { __lastLabel__ = 5; ; } else { __lastLabel__ = 5; __label__ = 23;break $if_then15$$lor_lhs_false$9; } //@line 658 "intonation.cpp"
  
              var $_pr=$initial; //@line 662 "intonation.cpp"
              var $tobool12=((($_pr))|0)!=0; //@line 662 "intonation.cpp"
              if ($tobool12) { __label__ = 8;break $if_then15$$lor_lhs_false$9; } //@line 662 "intonation.cpp"
  
              var $25=$stress; //@line 662 "intonation.cpp"
              var $cmp14=((($25))|0)==5; //@line 662 "intonation.cpp"
              if ($cmp14) { __label__ = 8;break $if_then15$$lor_lhs_false$9; } //@line 662 "intonation.cpp"
  
              var $39=$n_steps; //@line 682 "intonation.cpp"
              var $cmp34=((($39))|0) > 0; //@line 682 "intonation.cpp"
              if ($cmp34) { __label__ = 16;; } else { __label__ = 17;; } //@line 682 "intonation.cpp"
              if (__label__ == 16) {
  
                var $40=$increment; //@line 683 "intonation.cpp"
                var $41=$pitch; //@line 683 "intonation.cpp"
                var $add=((($41)+($40))&4294967295); //@line 683 "intonation.cpp"
                $pitch=$add; //@line 683 "intonation.cpp"
                __label__ = 19;break $if_then15$$lor_lhs_false$9; //@line 683 "intonation.cpp"
              }
              else if (__label__ == 17) {
  
                var $42=$th_addr; //@line 686 "intonation.cpp"
                var $body_end37=(($42+3)&4294967295); //@line 686 "intonation.cpp"
                var $43=HEAPU8[($body_end37)]; //@line 686 "intonation.cpp"
                var $conv38=((($43))&255); //@line 686 "intonation.cpp"
                var $shl39=((($conv38)*256)&4294967295); //@line 686 "intonation.cpp"
                var $44=$pitch_range_abs; //@line 686 "intonation.cpp"
                var $45=$overflow; //@line 686 "intonation.cpp"
                var $inc=((($45)+1)&4294967295); //@line 686 "intonation.cpp"
                $overflow=$inc; //@line 686 "intonation.cpp"
                var $46=$overflow_tab; //@line 686 "intonation.cpp"
                var $arrayidx40=(($46+$45)&4294967295); //@line 686 "intonation.cpp"
                var $47=HEAP8[($arrayidx40)]; //@line 686 "intonation.cpp"
                var $conv41=(tempInt=(($47)),(tempInt>=128?tempInt-256:tempInt)); //@line 686 "intonation.cpp"
                var $mul=((($conv41)*($44))&4294967295); //@line 686 "intonation.cpp"
                var $div42=((((($mul))|0)/64)|0); //@line 686 "intonation.cpp"
                var $add43=((($div42)+($shl39))&4294967295); //@line 686 "intonation.cpp"
                $pitch=$add43; //@line 686 "intonation.cpp"
                var $48=$overflow; //@line 687 "intonation.cpp"
                var $49=$n_overflow; //@line 687 "intonation.cpp"
                var $cmp44=((($48))|0) >= ((($49))|0); //@line 687 "intonation.cpp"
                if (!($cmp44)) { __label__ = 19;break $if_then15$$lor_lhs_false$9; } //@line 687 "intonation.cpp"
  
                $overflow=0; //@line 689 "intonation.cpp"
                var $50=$th_addr; //@line 690 "intonation.cpp"
                var $overflow46=(($50+12)&4294967295); //@line 690 "intonation.cpp"
                var $51=HEAP32[(($overflow46)>>2)]; //@line 690 "intonation.cpp"
                $overflow_tab=$51; //@line 690 "intonation.cpp"
                __label__ = 19;break $if_then15$$lor_lhs_false$9; //@line 691 "intonation.cpp"
              }
            }
          } while(0);
          $if_then15$$if_end49$$if_end59$18: do { 
            if (__label__ == 8) {
  
              $initial=0; //@line 664 "intonation.cpp"
              $overflow=0; //@line 665 "intonation.cpp"
              var $26=$ix_addr; //@line 666 "intonation.cpp"
              var $27=$end_ix_addr; //@line 666 "intonation.cpp"
              var $28=$min_stress_addr; //@line 666 "intonation.cpp"
              var $call16=__ZL16count_incrementsiii($26, $27, $28); //@line 666 "intonation.cpp"
              $n_primary=$call16; //@line 666 "intonation.cpp"
              $n_steps=$call16; //@line 666 "intonation.cpp"
              var $29=$n_steps; //@line 668 "intonation.cpp"
              var $30=$th_addr; //@line 668 "intonation.cpp"
              var $body_max_steps17=(($30+8)&4294967295); //@line 668 "intonation.cpp"
              var $31=HEAPU8[($body_max_steps17)]; //@line 668 "intonation.cpp"
              var $conv18=((($31))&255); //@line 668 "intonation.cpp"
              var $cmp19=((($29))|0) > ((($conv18))|0); //@line 668 "intonation.cpp"
              if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 668 "intonation.cpp"
              if (__label__ == 9) {
  
                var $32=$th_addr; //@line 669 "intonation.cpp"
                var $body_max_steps21=(($32+8)&4294967295); //@line 669 "intonation.cpp"
                var $33=HEAPU8[($body_max_steps21)]; //@line 669 "intonation.cpp"
                var $conv22=((($33))&255); //@line 669 "intonation.cpp"
                $n_steps=$conv22; //@line 669 "intonation.cpp"
                __lastLabel__ = 9; ; //@line 669 "intonation.cpp"
              }
              else if (__label__ == 10) {
  
                var $_pr2=$n_steps; //@line 671 "intonation.cpp"
                __lastLabel__ = 10; ;
              }
  
              var $34=__lastLabel__ == 10 ? $_pr2 : ($conv22); //@line 671 "intonation.cpp"
              var $cmp24=((($34))|0) > 1; //@line 671 "intonation.cpp"
              if ($cmp24) { __label__ = 12;; } else { __label__ = 13;; } //@line 671 "intonation.cpp"
              if (__label__ == 12) {
  
                var $35=$pitch_range; //@line 673 "intonation.cpp"
                var $36=$n_steps; //@line 673 "intonation.cpp"
                var $sub26=((($36)-1)&4294967295); //@line 673 "intonation.cpp"
                var $div27=((((($35))|0)/((($sub26))|0))|0); //@line 673 "intonation.cpp"
                $increment=$div27; //@line 673 "intonation.cpp"
                ; //@line 674 "intonation.cpp"
              }
              else if (__label__ == 13) {
  
                $increment=0; //@line 676 "intonation.cpp"
                ;
              }
  
              var $37=$th_addr; //@line 678 "intonation.cpp"
              var $body_start30=(($37+2)&4294967295); //@line 678 "intonation.cpp"
              var $38=HEAPU8[($body_start30)]; //@line 678 "intonation.cpp"
              var $conv31=((($38))&255); //@line 678 "intonation.cpp"
              var $shl32=($conv31) << 8; //@line 678 "intonation.cpp"
              $pitch=$shl32; //@line 678 "intonation.cpp"
              __label__ = 19;break $if_then15$$if_end49$$if_end59$18; //@line 679 "intonation.cpp"
            }
          } while(0);
          if (__label__ == 19) {
  
            var $52=$n_steps; //@line 695 "intonation.cpp"
            var $dec=((($52)-1)&4294967295); //@line 695 "intonation.cpp"
            $n_steps=$dec; //@line 695 "intonation.cpp"
            var $53=$n_primary; //@line 697 "intonation.cpp"
            var $dec50=((($53)-1)&4294967295); //@line 697 "intonation.cpp"
            $n_primary=$dec50; //@line 697 "intonation.cpp"
            var $54=$tn_addr; //@line 698 "intonation.cpp"
            var $backwards=(($54+8)&4294967295); //@line 698 "intonation.cpp"
            var $55=HEAP32[(($backwards)>>2)]; //@line 698 "intonation.cpp"
            var $tobool51=((($55))|0)!=0; //@line 698 "intonation.cpp"
            if ($tobool51) { __label__ = 20;; } else { __label__ = 22;; } //@line 698 "intonation.cpp"
            $land_lhs_true$$if_end59thread_pre_split$30: do { 
              if (__label__ == 20) {
  
                var $56=$n_primary; //@line 698 "intonation.cpp"
                var $cmp52=((($56))|0) < 2; //@line 698 "intonation.cpp"
                if (!($cmp52)) { __label__ = 22;break $land_lhs_true$$if_end59thread_pre_split$30; } //@line 698 "intonation.cpp"
  
                var $57=$n_primary; //@line 700 "intonation.cpp"
                var $58=$tn_addr; //@line 700 "intonation.cpp"
                var $backwards54=(($58+8)&4294967295); //@line 700 "intonation.cpp"
                var $59=HEAP32[(($backwards54)>>2)]; //@line 700 "intonation.cpp"
                var $arrayidx55=(($59+2*$57)&4294967295); //@line 700 "intonation.cpp"
                var $60=HEAP16[(($arrayidx55)>>1)]; //@line 700 "intonation.cpp"
                var $conv56=(tempInt=(($60)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 700 "intonation.cpp"
                var $shl57=($conv56) << 8; //@line 700 "intonation.cpp"
                $pitch=$shl57; //@line 700 "intonation.cpp"
                ; //@line 701 "intonation.cpp"
              }
            } while(0);
  
            var $_pr3=$stress; //@line 704 "intonation.cpp"
            __lastLabel__ = 22; ;
          }
  
          var $61=__lastLabel__ == 22 ? $_pr3 : ($23); //@line 704 "intonation.cpp"
          var $cmp60=((($61))|0) >= 4; //@line 704 "intonation.cpp"
          if ($cmp60) { __label__ = 24;; } else { __label__ = 25;; } //@line 704 "intonation.cpp"
          if (__label__ == 24) {
  
            var $62=$syl; //@line 706 "intonation.cpp"
            var $stress62=(($62)&4294967295); //@line 706 "intonation.cpp"
            HEAP8[($stress62)]=6; //@line 706 "intonation.cpp"
            var $63=$syl; //@line 707 "intonation.cpp"
            var $64=$pitch; //@line 707 "intonation.cpp"
            var $shr=($64) >> 8; //@line 707 "intonation.cpp"
            var $65=$stress; //@line 707 "intonation.cpp"
            var $66=$drops; //@line 707 "intonation.cpp"
            var $arrayidx63=(($66+4*$65)&4294967295); //@line 707 "intonation.cpp"
            var $67=HEAP32[(($arrayidx63)>>2)]; //@line 707 "intonation.cpp"
            __ZL9set_pitchP8SYLLABLEii($63, $shr, $67); //@line 707 "intonation.cpp"
            ; //@line 708 "intonation.cpp"
          }
          else if (__label__ == 25) {
  
            var $68=$stress; //@line 710 "intonation.cpp"
            var $cmp65=((($68))|0) >= 3; //@line 710 "intonation.cpp"
            if ($cmp65) { __label__ = 26;; } else { __label__ = 27;; } //@line 710 "intonation.cpp"
            if (__label__ == 26) {
  
              var $69=$syl; //@line 712 "intonation.cpp"
              var $70=$pitch; //@line 712 "intonation.cpp"
              var $shr67=($70) >> 8; //@line 712 "intonation.cpp"
              var $71=$stress; //@line 712 "intonation.cpp"
              var $72=$drops; //@line 712 "intonation.cpp"
              var $arrayidx68=(($72+4*$71)&4294967295); //@line 712 "intonation.cpp"
              var $73=HEAP32[(($arrayidx68)>>2)]; //@line 712 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($69, $shr67, $73); //@line 712 "intonation.cpp"
              ; //@line 713 "intonation.cpp"
            }
            else if (__label__ == 27) {
  
              var $74=$ix_addr; //@line 717 "intonation.cpp"
              var $sub70=((($74)-1)&4294967295); //@line 717 "intonation.cpp"
              var $75=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 717 "intonation.cpp"
              var $arrayidx71=(($75+6*$sub70)&4294967295); //@line 717 "intonation.cpp"
              var $stress72=(($arrayidx71)&4294967295); //@line 717 "intonation.cpp"
              var $76=HEAP8[($stress72)]; //@line 717 "intonation.cpp"
              var $conv73=(tempInt=(($76)),(tempInt>=128?tempInt-256:tempInt)); //@line 717 "intonation.cpp"
              var $and=($conv73) & 63; //@line 717 "intonation.cpp"
              var $cmp74=((($and))|0) >= 3; //@line 717 "intonation.cpp"
              var $77=$syl; //@line 718 "intonation.cpp"
              var $78=$pitch; //@line 718 "intonation.cpp"
              var $shr76=($78) >> 8; //@line 718 "intonation.cpp"
              if ($cmp74) { __label__ = 28;; } else { __label__ = 29;; } //@line 717 "intonation.cpp"
              if (__label__ == 28) {
  
                var $79=$th_addr; //@line 718 "intonation.cpp"
                var $body_lower_u=(($79+9)&4294967295); //@line 718 "intonation.cpp"
                var $80=HEAP8[($body_lower_u)]; //@line 718 "intonation.cpp"
                var $conv77=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 718 "intonation.cpp"
                var $sub78=((($shr76)-($conv77))&4294967295); //@line 718 "intonation.cpp"
                var $81=$stress; //@line 718 "intonation.cpp"
                var $82=$drops; //@line 718 "intonation.cpp"
                var $arrayidx79=(($82+4*$81)&4294967295); //@line 718 "intonation.cpp"
                var $83=HEAP32[(($arrayidx79)>>2)]; //@line 718 "intonation.cpp"
                __ZL9set_pitchP8SYLLABLEii($77, $sub78, $83); //@line 718 "intonation.cpp"
                ; //@line 718 "intonation.cpp"
              }
              else if (__label__ == 29) {
  
                var $84=$stress; //@line 720 "intonation.cpp"
                var $85=$drops; //@line 720 "intonation.cpp"
                var $arrayidx82=(($85+4*$84)&4294967295); //@line 720 "intonation.cpp"
                var $86=HEAP32[(($arrayidx82)>>2)]; //@line 720 "intonation.cpp"
                __ZL9set_pitchP8SYLLABLEii($77, $shr76, $86); //@line 720 "intonation.cpp"
                ;
              }
            }
          }
  
          var $87=$ix_addr; //@line 723 "intonation.cpp"
          var $inc86=((($87)+1)&4294967295); //@line 723 "intonation.cpp"
          $ix_addr=$inc86; //@line 723 "intonation.cpp"
          var $88=$ix_addr; //@line 650 "intonation.cpp"
          var $89=$end_ix_addr; //@line 650 "intonation.cpp"
          var $cmp=((($88))|0) < ((($89))|0); //@line 650 "intonation.cpp"
          var $90=$ix_addr; //@line 652 "intonation.cpp"
          if ($cmp) { __lastLabel__ = 30; __label__ = 4;continue $while_body$7; } else { __lastLabel__ = 30; __label__ = 31;break $while_body$$while_end$6; } //@line 650 "intonation.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 3 ? $17 : ($90);
    ;
    return $_lcssa; //@line 725 "intonation.cpp"
    return null;
  }
  

  function __ZL9set_pitchP8SYLLABLEii($syl, $base, $drop) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $syl_addr;
    var $base_addr;
    var $drop_addr;
    var $pitch1;
    var $pitch2;
    var $flags;
    $syl_addr=$syl;
    $base_addr=$base;
    $drop_addr=$drop;
    $flags=0; //@line 425 "intonation.cpp"
    var $0=$base_addr; //@line 427 "intonation.cpp"
    var $cmp=((($0))|0) < 0; //@line 427 "intonation.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 427 "intonation.cpp"
    if (__label__ == 1) {
  
      $base_addr=0; //@line 427 "intonation.cpp"
      var $_pr=$drop_addr; //@line 431 "intonation.cpp"
      __lastLabel__ = 1; ; //@line 427 "intonation.cpp"
    }
  
    var $1=__lastLabel__ == 1 ? $_pr : ($drop); //@line 431 "intonation.cpp"
    var $2=$base_addr; //@line 429 "intonation.cpp"
    $pitch2=$2; //@line 429 "intonation.cpp"
    var $cmp1=((($1))|0) < 0; //@line 431 "intonation.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 431 "intonation.cpp"
    if (__label__ == 3) {
  
      $flags=1; //@line 433 "intonation.cpp"
      var $3=$drop_addr; //@line 434 "intonation.cpp"
      var $sub=(((-($3)))&4294967295); //@line 434 "intonation.cpp"
      $drop_addr=$sub; //@line 434 "intonation.cpp"
      ; //@line 435 "intonation.cpp"
    }
  
    var $4=$pitch2; //@line 437 "intonation.cpp"
    var $5=$drop_addr; //@line 437 "intonation.cpp"
    var $add=((($5)+($4))&4294967295); //@line 437 "intonation.cpp"
    $pitch1=$add; //@line 437 "intonation.cpp"
    var $cmp4=((($add))|0) < 0; //@line 438 "intonation.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 438 "intonation.cpp"
    $if_end6_thread$$if_end6$8: do { 
      if (__label__ == 5) {
  
        $pitch1=0; //@line 439 "intonation.cpp"
        ; //@line 441 "intonation.cpp"
      }
      else if (__label__ == 6) {
  
        var $cmp7=((($add))|0) > 254; //@line 441 "intonation.cpp"
        if (!($cmp7)) { __label__ = 8;break $if_end6_thread$$if_end6$8; } //@line 441 "intonation.cpp"
  
        $pitch1=254; //@line 441 "intonation.cpp"
        ; //@line 441 "intonation.cpp"
      }
    } while(0);
  
    var $6=$pitch2; //@line 442 "intonation.cpp"
    var $cmp10=((($6))|0) > 254; //@line 442 "intonation.cpp"
    if ($cmp10) { __label__ = 9;; } else { __label__ = 10;; } //@line 442 "intonation.cpp"
    if (__label__ == 9) {
  
      $pitch2=254; //@line 442 "intonation.cpp"
      ; //@line 442 "intonation.cpp"
    }
  
    var $7=$pitch1; //@line 444 "intonation.cpp"
    var $conv=((($7)) & 255); //@line 444 "intonation.cpp"
    var $8=$syl_addr; //@line 444 "intonation.cpp"
    var $pitch113=(($8+4)&4294967295); //@line 444 "intonation.cpp"
    HEAP8[($pitch113)]=$conv; //@line 444 "intonation.cpp"
    var $9=$pitch2; //@line 445 "intonation.cpp"
    var $conv14=((($9)) & 255); //@line 445 "intonation.cpp"
    var $10=$syl_addr; //@line 445 "intonation.cpp"
    var $pitch215=(($10+5)&4294967295); //@line 445 "intonation.cpp"
    HEAP8[($pitch215)]=$conv14; //@line 445 "intonation.cpp"
    var $11=$flags; //@line 446 "intonation.cpp"
    var $12=$syl_addr; //@line 446 "intonation.cpp"
    var $flags16=(($12+2)&4294967295); //@line 446 "intonation.cpp"
    var $13=HEAP8[($flags16)]; //@line 446 "intonation.cpp"
    var $conv17=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 446 "intonation.cpp"
    var $or=($conv17) | ($11); //@line 446 "intonation.cpp"
    var $conv18=((($or)) & 255); //@line 446 "intonation.cpp"
    HEAP8[($flags16)]=$conv18; //@line 446 "intonation.cpp"
    ;
    return; //@line 447 "intonation.cpp"
    return;
  }
  

  function __ZL16count_incrementsiii($ix, $end_ix, $min_stress) {
    ;
    var __label__;
  
    var $ix_addr;
    var $end_ix_addr;
    var $min_stress_addr;
    var $count;
    var $stress;
    $ix_addr=$ix;
    $end_ix_addr=$end_ix;
    $min_stress_addr=$min_stress;
    $count=0; //@line 402 "intonation.cpp"
    ; //@line 405 "intonation.cpp"
    while(1) { 
  
      var $0=$ix_addr; //@line 405 "intonation.cpp"
      var $1=$end_ix_addr; //@line 405 "intonation.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 405 "intonation.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 405 "intonation.cpp"
  
      var $2=$ix_addr; //@line 407 "intonation.cpp"
      var $inc=((($2)+1)&4294967295); //@line 407 "intonation.cpp"
      $ix_addr=$inc; //@line 407 "intonation.cpp"
      var $3=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 407 "intonation.cpp"
      var $arrayidx=(($3+6*$2)&4294967295); //@line 407 "intonation.cpp"
      var $stress1=(($arrayidx)&4294967295); //@line 407 "intonation.cpp"
      var $4=HEAP8[($stress1)]; //@line 407 "intonation.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 407 "intonation.cpp"
      $stress=$conv; //@line 407 "intonation.cpp"
      var $5=$stress; //@line 408 "intonation.cpp"
      var $cmp2=((($5))|0) >= 7; //@line 408 "intonation.cpp"
      if ($cmp2) { __label__ = 5;break ; } //@line 408 "intonation.cpp"
  
      var $6=$stress; //@line 411 "intonation.cpp"
      var $7=$min_stress_addr; //@line 411 "intonation.cpp"
      var $cmp3=((($6))|0) >= ((($7))|0); //@line 411 "intonation.cpp"
      if (!($cmp3)) { __label__ = 1;continue ; } //@line 411 "intonation.cpp"
  
      var $8=$count; //@line 412 "intonation.cpp"
      var $inc5=((($8)+1)&4294967295); //@line 412 "intonation.cpp"
      $count=$inc5; //@line 412 "intonation.cpp"
      __label__ = 1;continue ; //@line 412 "intonation.cpp"
    }
  
    var $9=$count; //@line 414 "intonation.cpp"
    ;
    return $9; //@line 414 "intonation.cpp"
    return null;
  }
  

  function __ZL17SetHeadIntonationP4TUNEiii($tune, $syl_ix, $end_ix) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tune_addr;
    var $syl_ix_addr;
    var $end_ix_addr;
    var $control_addr;
    var $stress;
    var $syl;
    var $ix;
    var $pitch;
    var $increment;
    var $n_steps;
    var $stage;
    var $initial;
    var $overflow_ix;
    var $pitch_range;
    var $pitch_range_abs;
    var $drops;
    var $n_unstressed;
    var $unstressed_ix;
    var $unstressed_inc;
    var $used_onset;
    var $head_final;
    var $secondary;
    $tune_addr=$tune;
    $syl_ix_addr=$syl_ix;
    $end_ix_addr=$end_ix;
    $control_addr=0;
    $pitch=0; //@line 467 "intonation.cpp"
    $increment=0; //@line 468 "intonation.cpp"
    $n_steps=0; //@line 469 "intonation.cpp"
    $overflow_ix=0; //@line 472 "intonation.cpp"
    $n_unstressed=0; //@line 476 "intonation.cpp"
    $unstressed_ix=0; //@line 477 "intonation.cpp"
    $used_onset=0; //@line 479 "intonation.cpp"
    var $0=$end_ix_addr; //@line 480 "intonation.cpp"
    $head_final=$0; //@line 480 "intonation.cpp"
    $secondary=2; //@line 481 "intonation.cpp"
    var $1=$tune_addr; //@line 483 "intonation.cpp"
    var $head_end=(($1+32)&4294967295); //@line 483 "intonation.cpp"
    var $2=HEAPU8[($head_end)]; //@line 483 "intonation.cpp"
    var $conv=((($2))&255); //@line 483 "intonation.cpp"
    var $3=$tune_addr; //@line 483 "intonation.cpp"
    var $head_start=(($3+31)&4294967295); //@line 483 "intonation.cpp"
    var $4=HEAPU8[($head_start)]; //@line 483 "intonation.cpp"
    var $conv1=((($4))&255); //@line 483 "intonation.cpp"
    var $sub=((($conv)-($conv1))&4294967295); //@line 483 "intonation.cpp"
    var $shl=($sub) << 8; //@line 483 "intonation.cpp"
    $pitch_range=$shl; //@line 483 "intonation.cpp"
    var $5=$pitch_range; //@line 484 "intonation.cpp"
    var $ispos=((($5))|0) > -1; //@line 484 "intonation.cpp"
    var $neg=(((-($5)))&4294967295); //@line 484 "intonation.cpp"
    var $call=($ispos) ? ($5) : ($neg); //@line 484 "intonation.cpp"
    $pitch_range_abs=$call; //@line 484 "intonation.cpp"
    $drops=((__ZL7drops_0)&4294967295); //@line 485 "intonation.cpp"
    $initial=1; //@line 486 "intonation.cpp"
    $stage=0; //@line 488 "intonation.cpp"
    var $6=$tune_addr; //@line 489 "intonation.cpp"
    var $onset=(($6+30)&4294967295); //@line 489 "intonation.cpp"
    var $7=HEAPU8[($onset)]; //@line 489 "intonation.cpp"
    var $conv2=((($7))&255); //@line 489 "intonation.cpp"
    var $cmp=((($conv2))|0)==255; //@line 489 "intonation.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 489 "intonation.cpp"
    if (__label__ == 1) {
  
      $stage=1; //@line 490 "intonation.cpp"
      ; //@line 490 "intonation.cpp"
    }
  
    var $8=$tune_addr; //@line 492 "intonation.cpp"
    var $head_last=(($8+33)&4294967295); //@line 492 "intonation.cpp"
    var $9=HEAPU8[($head_last)]; //@line 492 "intonation.cpp"
    var $conv3=((($9))&255); //@line 492 "intonation.cpp"
    var $cmp4=((($conv3))|0)!=255; //@line 492 "intonation.cpp"
    if ($cmp4) { __label__ = 4;; } else { __label__ = 3;; } //@line 492 "intonation.cpp"
    $if_then5$$while_cond_preheader$5: do { 
      if (__label__ == 4) {
  
        var $13=$end_ix_addr; //@line 495 "intonation.cpp"
        var $sub6=((($13)-1)&4294967295); //@line 495 "intonation.cpp"
        $ix=$sub6; //@line 495 "intonation.cpp"
        ; //@line 495 "intonation.cpp"
        while(1) { 
  
          var $14=$ix; //@line 495 "intonation.cpp"
          var $15=$syl_ix_addr; //@line 495 "intonation.cpp"
          var $cmp7=((($14))|0) >= ((($15))|0); //@line 495 "intonation.cpp"
          if (!($cmp7)) { __label__ = 3;break $if_then5$$while_cond_preheader$5; } //@line 495 "intonation.cpp"
  
          var $16=$ix; //@line 497 "intonation.cpp"
          var $17=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 497 "intonation.cpp"
          var $arrayidx=(($17+6*$16)&4294967295); //@line 497 "intonation.cpp"
          var $stress8=(($arrayidx)&4294967295); //@line 497 "intonation.cpp"
          var $18=HEAP8[($stress8)]; //@line 497 "intonation.cpp"
          var $conv9=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 497 "intonation.cpp"
          var $cmp10=((($conv9))|0) >= 4; //@line 497 "intonation.cpp"
          var $19=$ix; //@line 499 "intonation.cpp"
          if ($cmp10) { __label__ = 7;break ; } //@line 497 "intonation.cpp"
  
          var $dec=((($19)-1)&4294967295); //@line 495 "intonation.cpp"
          $ix=$dec; //@line 495 "intonation.cpp"
          __label__ = 5;continue ; //@line 495 "intonation.cpp"
        }
  
        $head_final=$19; //@line 499 "intonation.cpp"
        ; //@line 500 "intonation.cpp"
      }
    } while(0);
  
    var $10=$syl_ix_addr; //@line 505 "intonation.cpp"
    var $11=$end_ix_addr; //@line 505 "intonation.cpp"
    var $cmp145=((($10))|0) < ((($11))|0); //@line 505 "intonation.cpp"
    var $12=$syl_ix_addr; //@line 507 "intonation.cpp"
    if ($cmp145) { __lastLabel__ = 3; __label__ = 9;; } else { __lastLabel__ = 3; __label__ = 39;; } //@line 505 "intonation.cpp"
    $while_body$$while_end$13: do { 
      if (__label__ == 9) {
        $while_body$14: while(1) { 
  
          var $20=__lastLabel__ == 38 ? $108 : ($12);
          var $21=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 507 "intonation.cpp"
          var $arrayidx15=(($21+6*$20)&4294967295); //@line 507 "intonation.cpp"
          $syl=$arrayidx15; //@line 507 "intonation.cpp"
          var $22=$syl; //@line 508 "intonation.cpp"
          var $stress16=(($22)&4294967295); //@line 508 "intonation.cpp"
          var $23=HEAP8[($stress16)]; //@line 508 "intonation.cpp"
          var $conv17=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 508 "intonation.cpp"
          $stress=$conv17; //@line 508 "intonation.cpp"
          var $24=$initial; //@line 510 "intonation.cpp"
          var $tobool=((($24))|0)!=0; //@line 510 "intonation.cpp"
          if ($tobool) { __label__ = 13;; } else { __label__ = 10;; } //@line 510 "intonation.cpp"
          $if_then23$$lor_lhs_false$16: do { 
            if (__label__ == 10) {
  
              var $25=$stress; //@line 510 "intonation.cpp"
              var $cmp18=((($25))|0) >= 4; //@line 510 "intonation.cpp"
              if (!($cmp18)) { __label__ = 32;break $if_then23$$lor_lhs_false$16; } //@line 510 "intonation.cpp"
  
              var $_pr=$initial; //@line 514 "intonation.cpp"
              var $tobool20=((($_pr))|0)!=0; //@line 514 "intonation.cpp"
              if ($tobool20) { __label__ = 13;break $if_then23$$lor_lhs_false$16; } //@line 514 "intonation.cpp"
  
              var $26=$stress; //@line 514 "intonation.cpp"
              var $cmp22=((($26))|0)==5; //@line 514 "intonation.cpp"
              if ($cmp22) { __label__ = 13;break $if_then23$$lor_lhs_false$16; } //@line 514 "intonation.cpp"
  
              var $44=$syl_ix_addr; //@line 544 "intonation.cpp"
              var $45=$head_final; //@line 544 "intonation.cpp"
              var $cmp49=((($44))|0)==((($45))|0); //@line 544 "intonation.cpp"
              if ($cmp49) { __label__ = 23;; } else { __label__ = 24;; } //@line 544 "intonation.cpp"
              if (__label__ == 23) {
  
                var $46=$tune_addr; //@line 547 "intonation.cpp"
                var $head_last51=(($46+33)&4294967295); //@line 547 "intonation.cpp"
                var $47=HEAPU8[($head_last51)]; //@line 547 "intonation.cpp"
                var $conv52=((($47))&255); //@line 547 "intonation.cpp"
                var $shl53=($conv52) << 8; //@line 547 "intonation.cpp"
                $pitch=$shl53; //@line 547 "intonation.cpp"
                $stage=2; //@line 548 "intonation.cpp"
                __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 549 "intonation.cpp"
              }
              else if (__label__ == 24) {
  
                var $48=$used_onset; //@line 552 "intonation.cpp"
                var $tobool55=((($48))|0)!=0; //@line 552 "intonation.cpp"
                if ($tobool55) { __label__ = 25;; } else { __label__ = 26;; } //@line 552 "intonation.cpp"
                if (__label__ == 25) {
  
                  $stage=1; //@line 554 "intonation.cpp"
                  $used_onset=0; //@line 555 "intonation.cpp"
                  var $49=$tune_addr; //@line 556 "intonation.cpp"
                  var $head_start57=(($49+31)&4294967295); //@line 556 "intonation.cpp"
                  var $50=HEAPU8[($head_start57)]; //@line 556 "intonation.cpp"
                  var $conv58=((($50))&255); //@line 556 "intonation.cpp"
                  var $shl59=($conv58) << 8; //@line 556 "intonation.cpp"
                  $pitch=$shl59; //@line 556 "intonation.cpp"
                  var $51=$n_steps; //@line 557 "intonation.cpp"
                  var $inc=((($51)+1)&4294967295); //@line 557 "intonation.cpp"
                  $n_steps=$inc; //@line 557 "intonation.cpp"
                  __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 558 "intonation.cpp"
                }
                else if (__label__ == 26) {
  
                  var $52=$n_steps; //@line 560 "intonation.cpp"
                  var $cmp61=((($52))|0) > 0; //@line 560 "intonation.cpp"
                  if ($cmp61) { __label__ = 27;; } else { __label__ = 28;; } //@line 560 "intonation.cpp"
                  if (__label__ == 27) {
  
                    var $53=$increment; //@line 561 "intonation.cpp"
                    var $54=$pitch; //@line 561 "intonation.cpp"
                    var $add63=((($54)+($53))&4294967295); //@line 561 "intonation.cpp"
                    $pitch=$add63; //@line 561 "intonation.cpp"
                    __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 561 "intonation.cpp"
                  }
                  else if (__label__ == 28) {
  
                    var $55=$tune_addr; //@line 564 "intonation.cpp"
                    var $head_end65=(($55+32)&4294967295); //@line 564 "intonation.cpp"
                    var $56=HEAPU8[($head_end65)]; //@line 564 "intonation.cpp"
                    var $conv66=((($56))&255); //@line 564 "intonation.cpp"
                    var $shl67=((($conv66)*256)&4294967295); //@line 564 "intonation.cpp"
                    var $57=$pitch_range_abs; //@line 564 "intonation.cpp"
                    var $58=$overflow_ix; //@line 564 "intonation.cpp"
                    var $inc68=((($58)+1)&4294967295); //@line 564 "intonation.cpp"
                    $overflow_ix=$inc68; //@line 564 "intonation.cpp"
                    var $59=$tune_addr; //@line 564 "intonation.cpp"
                    var $head_extend=(($59+16)&4294967295); //@line 564 "intonation.cpp"
                    var $arrayidx69=(($head_extend+$58)&4294967295); //@line 564 "intonation.cpp"
                    var $60=HEAP8[($arrayidx69)]; //@line 564 "intonation.cpp"
                    var $conv70=(tempInt=(($60)),(tempInt>=128?tempInt-256:tempInt)); //@line 564 "intonation.cpp"
                    var $mul=((($conv70)*($57))&4294967295); //@line 564 "intonation.cpp"
                    var $div71=((((($mul))|0)/64)|0); //@line 564 "intonation.cpp"
                    var $add72=((($div71)+($shl67))&4294967295); //@line 564 "intonation.cpp"
                    $pitch=$add72; //@line 564 "intonation.cpp"
                    var $61=$overflow_ix; //@line 565 "intonation.cpp"
                    var $62=$tune_addr; //@line 565 "intonation.cpp"
                    var $n_head_extend=(($62+35)&4294967295); //@line 565 "intonation.cpp"
                    var $63=HEAPU8[($n_head_extend)]; //@line 565 "intonation.cpp"
                    var $conv73=((($63))&255); //@line 565 "intonation.cpp"
                    var $cmp74=((($61))|0) >= ((($conv73))|0); //@line 565 "intonation.cpp"
                    if (!($cmp74)) { __label__ = 30;break $if_then23$$lor_lhs_false$16; } //@line 565 "intonation.cpp"
  
                    $overflow_ix=0; //@line 567 "intonation.cpp"
                    __label__ = 30;break $if_then23$$lor_lhs_false$16; //@line 568 "intonation.cpp"
                  }
                }
              }
            }
          } while(0);
          $if_then23$$if_end82$$if_else89$31: do { 
            if (__label__ == 13) {
  
              $initial=0; //@line 516 "intonation.cpp"
              $overflow_ix=0; //@line 517 "intonation.cpp"
              var $27=$tune_addr; //@line 519 "intonation.cpp"
              var $onset24=(($27+30)&4294967295); //@line 519 "intonation.cpp"
              var $28=HEAPU8[($onset24)]; //@line 519 "intonation.cpp"
              var $conv25=((($28))&255); //@line 519 "intonation.cpp"
              var $cmp26=((($conv25))|0)==255; //@line 519 "intonation.cpp"
              var $29=$syl_ix_addr; //@line 521 "intonation.cpp"
              if ($cmp26) { __label__ = 14;; } else { __label__ = 15;; } //@line 519 "intonation.cpp"
              if (__label__ == 14) {
  
                var $30=$head_final; //@line 521 "intonation.cpp"
                var $call28=__ZL16count_incrementsiii($29, $30, 4); //@line 521 "intonation.cpp"
                $n_steps=$call28; //@line 521 "intonation.cpp"
                var $31=$tune_addr; //@line 522 "intonation.cpp"
                var $head_start29=(($31+31)&4294967295); //@line 522 "intonation.cpp"
                var $32=HEAPU8[($head_start29)]; //@line 522 "intonation.cpp"
                var $conv30=((($32))&255); //@line 522 "intonation.cpp"
                var $shl31=($conv30) << 8; //@line 522 "intonation.cpp"
                $pitch=$shl31; //@line 522 "intonation.cpp"
                ; //@line 523 "intonation.cpp"
              }
              else if (__label__ == 15) {
  
                var $add=((($29)+1)&4294967295); //@line 527 "intonation.cpp"
                var $33=$head_final; //@line 527 "intonation.cpp"
                var $call32=__ZL16count_incrementsiii($add, $33, 4); //@line 527 "intonation.cpp"
                $n_steps=$call32; //@line 527 "intonation.cpp"
                var $34=$tune_addr; //@line 528 "intonation.cpp"
                var $onset33=(($34+30)&4294967295); //@line 528 "intonation.cpp"
                var $35=HEAPU8[($onset33)]; //@line 528 "intonation.cpp"
                var $conv34=((($35))&255); //@line 528 "intonation.cpp"
                var $shl35=($conv34) << 8; //@line 528 "intonation.cpp"
                $pitch=$shl35; //@line 528 "intonation.cpp"
                $used_onset=1; //@line 529 "intonation.cpp"
                ;
              }
  
              var $36=$n_steps; //@line 532 "intonation.cpp"
              var $37=$tune_addr; //@line 532 "intonation.cpp"
              var $head_max_steps=(($37+34)&4294967295); //@line 532 "intonation.cpp"
              var $38=HEAPU8[($head_max_steps)]; //@line 532 "intonation.cpp"
              var $conv37=((($38))&255); //@line 532 "intonation.cpp"
              var $cmp38=((($36))|0) > ((($conv37))|0); //@line 532 "intonation.cpp"
              if ($cmp38) { __label__ = 17;; } else { __label__ = 18;; } //@line 532 "intonation.cpp"
              if (__label__ == 17) {
  
                var $39=$tune_addr; //@line 533 "intonation.cpp"
                var $head_max_steps40=(($39+34)&4294967295); //@line 533 "intonation.cpp"
                var $40=HEAPU8[($head_max_steps40)]; //@line 533 "intonation.cpp"
                var $conv41=((($40))&255); //@line 533 "intonation.cpp"
                $n_steps=$conv41; //@line 533 "intonation.cpp"
                __lastLabel__ = 17; ; //@line 533 "intonation.cpp"
              }
              else if (__label__ == 18) {
  
                var $_pr2=$n_steps; //@line 535 "intonation.cpp"
                __lastLabel__ = 18; ;
              }
  
              var $41=__lastLabel__ == 18 ? $_pr2 : ($conv41); //@line 535 "intonation.cpp"
              var $cmp43=((($41))|0) > 1; //@line 535 "intonation.cpp"
              if ($cmp43) { __label__ = 20;; } else { __label__ = 21;; } //@line 535 "intonation.cpp"
              if (__label__ == 20) {
  
                var $42=$pitch_range; //@line 537 "intonation.cpp"
                var $43=$n_steps; //@line 537 "intonation.cpp"
                var $sub45=((($43)-1)&4294967295); //@line 537 "intonation.cpp"
                var $div=((((($42))|0)/((($sub45))|0))|0); //@line 537 "intonation.cpp"
                $increment=$div; //@line 537 "intonation.cpp"
                __label__ = 30;break $if_then23$$if_end82$$if_else89$31; //@line 538 "intonation.cpp"
              }
              else if (__label__ == 21) {
  
                $increment=0; //@line 540 "intonation.cpp"
                __label__ = 30;break $if_then23$$if_end82$$if_else89$31;
              }
            }
          } while(0);
          $if_end82$$if_else89$44: do { 
            if (__label__ == 30) {
  
              var $64=$n_steps; //@line 572 "intonation.cpp"
              var $dec81=((($64)-1)&4294967295); //@line 572 "intonation.cpp"
              $n_steps=$dec81; //@line 572 "intonation.cpp"
              var $_pr3=$stress; //@line 575 "intonation.cpp"
              var $cmp83=((($_pr3))|0) >= 4; //@line 575 "intonation.cpp"
              if (!($cmp83)) { __label__ = 32;break $if_end82$$if_else89$44; } //@line 575 "intonation.cpp"
  
              var $65=$syl_ix_addr; //@line 577 "intonation.cpp"
              var $add85=((($65)+1)&4294967295); //@line 577 "intonation.cpp"
              var $66=$end_ix_addr; //@line 577 "intonation.cpp"
              var $67=$secondary; //@line 577 "intonation.cpp"
              var $call86=__ZL15CountUnstressediii($add85, $66, $67); //@line 577 "intonation.cpp"
              $n_unstressed=$call86; //@line 577 "intonation.cpp"
              $unstressed_ix=0; //@line 578 "intonation.cpp"
              var $68=$syl; //@line 579 "intonation.cpp"
              var $stress87=(($68)&4294967295); //@line 579 "intonation.cpp"
              HEAP8[($stress87)]=6; //@line 579 "intonation.cpp"
              var $69=$tune_addr; //@line 580 "intonation.cpp"
              var $stressed_env=(($69+26)&4294967295); //@line 580 "intonation.cpp"
              var $70=HEAP8[($stressed_env)]; //@line 580 "intonation.cpp"
              var $71=$syl; //@line 580 "intonation.cpp"
              var $env=(($71+1)&4294967295); //@line 580 "intonation.cpp"
              HEAP8[($env)]=$70; //@line 580 "intonation.cpp"
              var $72=$syl; //@line 581 "intonation.cpp"
              var $73=$pitch; //@line 581 "intonation.cpp"
              var $shr=($73) >> 8; //@line 581 "intonation.cpp"
              var $74=$tune_addr; //@line 581 "intonation.cpp"
              var $stressed_drop=(($74+27)&4294967295); //@line 581 "intonation.cpp"
              var $75=HEAPU8[($stressed_drop)]; //@line 581 "intonation.cpp"
              var $conv88=((($75))&255); //@line 581 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($72, $shr, $conv88); //@line 581 "intonation.cpp"
              __label__ = 38;break $if_end82$$if_else89$44; //@line 582 "intonation.cpp"
            }
          } while(0);
          if (__label__ == 32) {
  
            var $76=$stress; //@line 584 "intonation.cpp"
            var $77=$secondary; //@line 584 "intonation.cpp"
            var $cmp90=((($76))|0) >= ((($77))|0); //@line 584 "intonation.cpp"
            if ($cmp90) { __label__ = 33;; } else { __label__ = 34;; } //@line 584 "intonation.cpp"
            if (__label__ == 33) {
  
              var $78=$syl_ix_addr; //@line 586 "intonation.cpp"
              var $add92=((($78)+1)&4294967295); //@line 586 "intonation.cpp"
              var $79=$end_ix_addr; //@line 586 "intonation.cpp"
              var $80=$secondary; //@line 586 "intonation.cpp"
              var $call93=__ZL15CountUnstressediii($add92, $79, $80); //@line 586 "intonation.cpp"
              $n_unstressed=$call93; //@line 586 "intonation.cpp"
              $unstressed_ix=0; //@line 587 "intonation.cpp"
              var $81=$syl; //@line 588 "intonation.cpp"
              var $82=$pitch; //@line 588 "intonation.cpp"
              var $shr94=($82) >> 8; //@line 588 "intonation.cpp"
              var $83=$stress; //@line 588 "intonation.cpp"
              var $84=$drops; //@line 588 "intonation.cpp"
              var $arrayidx95=(($84+4*$83)&4294967295); //@line 588 "intonation.cpp"
              var $85=HEAP32[(($arrayidx95)>>2)]; //@line 588 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($81, $shr94, $85); //@line 588 "intonation.cpp"
              ; //@line 589 "intonation.cpp"
            }
            else if (__label__ == 34) {
  
              var $86=$n_unstressed; //@line 592 "intonation.cpp"
              var $cmp97=((($86))|0) > 1; //@line 592 "intonation.cpp"
              if ($cmp97) { __label__ = 35;; } else { __label__ = 36;; } //@line 592 "intonation.cpp"
              if (__label__ == 35) {
  
                var $87=$stage; //@line 593 "intonation.cpp"
                var $88=$tune_addr; //@line 593 "intonation.cpp"
                var $unstr_end=(($88+39)&4294967295); //@line 593 "intonation.cpp"
                var $arrayidx99=(($unstr_end+$87)&4294967295); //@line 593 "intonation.cpp"
                var $89=HEAP8[($arrayidx99)]; //@line 593 "intonation.cpp"
                var $conv100=(tempInt=(($89)),(tempInt>=128?tempInt-256:tempInt)); //@line 593 "intonation.cpp"
                var $90=$stage; //@line 593 "intonation.cpp"
                var $91=$tune_addr; //@line 593 "intonation.cpp"
                var $unstr_start=(($91+36)&4294967295); //@line 593 "intonation.cpp"
                var $arrayidx101=(($unstr_start+$90)&4294967295); //@line 593 "intonation.cpp"
                var $92=HEAP8[($arrayidx101)]; //@line 593 "intonation.cpp"
                var $conv102=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt)); //@line 593 "intonation.cpp"
                var $sub103=((($conv100)-($conv102))&4294967295); //@line 593 "intonation.cpp"
                var $93=$n_unstressed; //@line 593 "intonation.cpp"
                var $sub104=((($93)-1)&4294967295); //@line 593 "intonation.cpp"
                var $div105=((((($sub103))|0)/((($sub104))|0))|0); //@line 593 "intonation.cpp"
                $unstressed_inc=$div105; //@line 593 "intonation.cpp"
                ; //@line 593 "intonation.cpp"
              }
              else if (__label__ == 36) {
  
                $unstressed_inc=0; //@line 595 "intonation.cpp"
                ;
              }
  
              var $94=$syl; //@line 597 "intonation.cpp"
              var $95=$pitch; //@line 597 "intonation.cpp"
              var $shr108=($95) >> 8; //@line 597 "intonation.cpp"
              var $96=$stage; //@line 597 "intonation.cpp"
              var $97=$tune_addr; //@line 597 "intonation.cpp"
              var $unstr_start109=(($97+36)&4294967295); //@line 597 "intonation.cpp"
              var $arrayidx110=(($unstr_start109+$96)&4294967295); //@line 597 "intonation.cpp"
              var $98=HEAP8[($arrayidx110)]; //@line 597 "intonation.cpp"
              var $conv111=(tempInt=(($98)),(tempInt>=128?tempInt-256:tempInt)); //@line 597 "intonation.cpp"
              var $99=$unstressed_inc; //@line 597 "intonation.cpp"
              var $100=$unstressed_ix; //@line 597 "intonation.cpp"
              var $mul113=((($100)*($99))&4294967295); //@line 597 "intonation.cpp"
              var $add112=((($conv111)+($shr108))&4294967295); //@line 597 "intonation.cpp"
              var $add114=((($add112)+($mul113))&4294967295); //@line 597 "intonation.cpp"
              var $101=$stress; //@line 597 "intonation.cpp"
              var $102=$drops; //@line 597 "intonation.cpp"
              var $arrayidx115=(($102+4*$101)&4294967295); //@line 597 "intonation.cpp"
              var $103=HEAP32[(($arrayidx115)>>2)]; //@line 597 "intonation.cpp"
              __ZL9set_pitchP8SYLLABLEii($94, $add114, $103); //@line 597 "intonation.cpp"
              var $104=$unstressed_ix; //@line 598 "intonation.cpp"
              var $inc116=((($104)+1)&4294967295); //@line 598 "intonation.cpp"
              $unstressed_ix=$inc116; //@line 598 "intonation.cpp"
              ;
            }
          }
  
          var $105=$syl_ix_addr; //@line 601 "intonation.cpp"
          var $inc119=((($105)+1)&4294967295); //@line 601 "intonation.cpp"
          $syl_ix_addr=$inc119; //@line 601 "intonation.cpp"
          var $106=$syl_ix_addr; //@line 505 "intonation.cpp"
          var $107=$end_ix_addr; //@line 505 "intonation.cpp"
          var $cmp14=((($106))|0) < ((($107))|0); //@line 505 "intonation.cpp"
          var $108=$syl_ix_addr; //@line 507 "intonation.cpp"
          if ($cmp14) { __lastLabel__ = 38; __label__ = 9;continue $while_body$14; } else { __lastLabel__ = 38; __label__ = 39;break $while_body$$while_end$13; } //@line 505 "intonation.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 3 ? $12 : ($108);
    ;
    return $_lcssa; //@line 603 "intonation.cpp"
    return null;
  }
  

  function __ZL15CountUnstressediii($start, $end, $limit) {
    ;
    var __label__;
  
    var $start_addr;
    var $end_addr;
    var $limit_addr;
    var $ix;
    $start_addr=$start;
    $end_addr=$end;
    $limit_addr=$limit;
    var $0=$start_addr; //@line 454 "intonation.cpp"
    $ix=$0; //@line 454 "intonation.cpp"
    ; //@line 454 "intonation.cpp"
    while(1) { 
  
      var $1=$ix; //@line 454 "intonation.cpp"
      var $2=$end_addr; //@line 454 "intonation.cpp"
      var $cmp=((($1))|0) <= ((($2))|0); //@line 454 "intonation.cpp"
      if (!($cmp)) { __label__ = 4;break ; } //@line 454 "intonation.cpp"
  
      var $3=$ix; //@line 456 "intonation.cpp"
      var $4=HEAP32[((__ZL12syllable_tab)>>2)]; //@line 456 "intonation.cpp"
      var $arrayidx=(($4+6*$3)&4294967295); //@line 456 "intonation.cpp"
      var $stress=(($arrayidx)&4294967295); //@line 456 "intonation.cpp"
      var $5=HEAP8[($stress)]; //@line 456 "intonation.cpp"
      var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 456 "intonation.cpp"
      var $6=$limit_addr; //@line 456 "intonation.cpp"
      var $cmp1=((($conv))|0) >= ((($6))|0); //@line 456 "intonation.cpp"
      if ($cmp1) { __label__ = 4;break ; } //@line 456 "intonation.cpp"
  
      var $7=$ix; //@line 454 "intonation.cpp"
      var $inc=((($7)+1)&4294967295); //@line 454 "intonation.cpp"
      $ix=$inc; //@line 454 "intonation.cpp"
      __label__ = 1;continue ; //@line 454 "intonation.cpp"
    }
  
    var $8=$ix; //@line 459 "intonation.cpp"
    var $9=$start_addr; //@line 459 "intonation.cpp"
    var $sub=((($8)-($9))&4294967295); //@line 459 "intonation.cpp"
    ;
    return $sub; //@line 459 "intonation.cpp"
    return null;
  }
  

  function _iswalpha($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 239 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 239 "readclause.cpp"
    var $1=$c_addr; //@line 240 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 239 "readclause.cpp"
    if (__label__ == 1) {
  
      var $call=_isalpha($1); //@line 240 "readclause.cpp"
      $retval=$call; //@line 240 "readclause.cpp"
      ; //@line 240 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp1=((($1))>>>0) > 12352; //@line 241 "readclause.cpp"
      var $2=$c_addr; //@line 241 "readclause.cpp"
      var $cmp2=((($2))>>>0) <= 42752; //@line 241 "readclause.cpp"
      var $or_cond=($cmp1) & ($cmp2); //@line 241 "readclause.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 241 "readclause.cpp"
      if (__label__ == 3) {
  
        $retval=1; //@line 242 "readclause.cpp"
        ; //@line 242 "readclause.cpp"
      }
      else if (__label__ == 4) {
  
        var $3=$c_addr; //@line 243 "readclause.cpp"
        var $cmp5=((($3))>>>0) > 563; //@line 243 "readclause.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 243 "readclause.cpp"
        if (__label__ == 5) {
  
          $retval=0; //@line 244 "readclause.cpp"
          ; //@line 244 "readclause.cpp"
        }
        else if (__label__ == 6) {
  
          var $4=$c_addr; //@line 245 "readclause.cpp"
          var $sub=((($4)-256)&4294967295); //@line 245 "readclause.cpp"
          var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 245 "readclause.cpp"
          var $5=HEAPU8[($arrayidx)]; //@line 245 "readclause.cpp"
          var $conv=((($5))&255); //@line 245 "readclause.cpp"
          $retval=$conv; //@line 245 "readclause.cpp"
          ; //@line 245 "readclause.cpp"
        }
      }
    }
  
    var $6=$retval; //@line 246 "readclause.cpp"
    ;
    return $6; //@line 246 "readclause.cpp"
    return null;
  }
  

  function _iswdigit($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 250 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 250 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 250 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 251 "readclause.cpp"
      var $isdigittmp=((($1)-48)&4294967295); //@line 251 "readclause.cpp"
      var $isdigit=((($isdigittmp))>>>0) < 10; //@line 251 "readclause.cpp"
      var $call=((($isdigit))&1); //@line 251 "readclause.cpp"
      $retval=$call; //@line 251 "readclause.cpp"
      ; //@line 251 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 252 "readclause.cpp"
      ; //@line 252 "readclause.cpp"
    }
  
    var $2=$retval; //@line 253 "readclause.cpp"
    ;
    return $2; //@line 253 "readclause.cpp"
    return null;
  }
  

  function _iswalnum($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 257 "readclause.cpp"
    var $call=_iswdigit($0); //@line 257 "readclause.cpp"
    var $tobool=((($call))|0)!=0; //@line 257 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 257 "readclause.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 258 "readclause.cpp"
      ; //@line 258 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 259 "readclause.cpp"
      var $call1=_iswalpha($1); //@line 259 "readclause.cpp"
      $retval=$call1; //@line 259 "readclause.cpp"
      ; //@line 259 "readclause.cpp"
    }
  
    var $2=$retval; //@line 260 "readclause.cpp"
    ;
    return $2; //@line 260 "readclause.cpp"
    return null;
  }
  

  function _towlower($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $x;
    $c_addr=$c;
    var $0=$c_addr; //@line 265 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 265 "readclause.cpp"
    var $1=$c_addr; //@line 266 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 265 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $call=_tolower($1); //@line 266 "readclause.cpp"
        $retval=$call; //@line 266 "readclause.cpp"
        ; //@line 266 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $cmp1=((($1))>>>0) > 563; //@line 267 "readclause.cpp"
        if ($cmp1) { __label__ = 4;; } else { __label__ = 3;; } //@line 267 "readclause.cpp"
        $if_then3$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $2=$c_addr; //@line 267 "readclause.cpp"
            var $sub=((($2)-256)&4294967295); //@line 267 "readclause.cpp"
            var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 267 "readclause.cpp"
            var $3=HEAPU8[($arrayidx)]; //@line 267 "readclause.cpp"
            var $conv=((($3))&255); //@line 267 "readclause.cpp"
            $x=$conv; //@line 267 "readclause.cpp"
            var $cmp2=((($conv))|0)==255; //@line 267 "readclause.cpp"
            if ($cmp2) { __label__ = 4;break $if_then3$$lor_lhs_false$5; } //@line 267 "readclause.cpp"
  
            var $5=$x; //@line 269 "readclause.cpp"
            var $cmp5=((($5))|0)==254; //@line 269 "readclause.cpp"
            if ($cmp5) { __label__ = 6;; } else { __label__ = 8;; } //@line 269 "readclause.cpp"
            $if_then6$$if_end10$8: do { 
              if (__label__ == 6) {
  
                var $6=$c_addr; //@line 272 "readclause.cpp"
                var $cmp7=((($6))|0)==304; //@line 272 "readclause.cpp"
                if (!($cmp7)) { __label__ = 8;break $if_then6$$if_end10$8; } //@line 272 "readclause.cpp"
  
                $retval=105; //@line 273 "readclause.cpp"
                __label__ = 9;break $if_then$$if_end$2; //@line 273 "readclause.cpp"
              }
            } while(0);
  
            var $7=$c_addr; //@line 275 "readclause.cpp"
            var $8=$x; //@line 275 "readclause.cpp"
            var $add=((($8)+($7))&4294967295); //@line 275 "readclause.cpp"
            $retval=$add; //@line 275 "readclause.cpp"
            __label__ = 9;break $if_then$$if_end$2; //@line 275 "readclause.cpp"
          }
        } while(0);
  
        var $4=$c_addr; //@line 268 "readclause.cpp"
        $retval=$4; //@line 268 "readclause.cpp"
        ; //@line 268 "readclause.cpp"
      }
    } while(0);
  
    var $9=$retval; //@line 276 "readclause.cpp"
    ;
    return $9; //@line 276 "readclause.cpp"
    return null;
  }
  

  function _towupper($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 281 "readclause.cpp"
    var $sub=((($0)-1)&4294967295); //@line 281 "readclause.cpp"
    var $call=_tolower($sub); //@line 281 "readclause.cpp"
    var $1=$c_addr; //@line 281 "readclause.cpp"
    var $cmp=((($call))|0)==((($1))|0); //@line 281 "readclause.cpp"
    var $2=$c_addr; //@line 282 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 281 "readclause.cpp"
    if (__label__ == 1) {
  
      var $sub1=((($2)-1)&4294967295); //@line 282 "readclause.cpp"
      $retval=$sub1; //@line 282 "readclause.cpp"
      ; //@line 282 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=$2; //@line 283 "readclause.cpp"
      ; //@line 283 "readclause.cpp"
    }
  
    var $3=$retval; //@line 284 "readclause.cpp"
    ;
    return $3; //@line 284 "readclause.cpp"
    return null;
  }
  

  function _iswupper($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $x;
    $c_addr=$c;
    var $0=$c_addr; //@line 289 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 289 "readclause.cpp"
    var $1=$c_addr; //@line 290 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 289 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $call=_isupper($1); //@line 290 "readclause.cpp"
        $retval=$call; //@line 290 "readclause.cpp"
        ; //@line 290 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $cmp1=((($1))>>>0) > 563; //@line 291 "readclause.cpp"
        if ($cmp1) { __label__ = 5;; } else { __label__ = 3;; } //@line 291 "readclause.cpp"
        $if_then5$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $2=$c_addr; //@line 291 "readclause.cpp"
            var $sub=((($2)-256)&4294967295); //@line 291 "readclause.cpp"
            var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 291 "readclause.cpp"
            var $3=HEAPU8[($arrayidx)]; //@line 291 "readclause.cpp"
            var $conv=((($3))&255); //@line 291 "readclause.cpp"
            $x=$conv; //@line 291 "readclause.cpp"
            var $cmp2=((($conv))|0)==0; //@line 291 "readclause.cpp"
            if ($cmp2) { __label__ = 5;break $if_then5$$lor_lhs_false$5; } //@line 291 "readclause.cpp"
  
            var $4=$x; //@line 291 "readclause.cpp"
            var $cmp4=((($4))|0)==255; //@line 291 "readclause.cpp"
            if ($cmp4) { __label__ = 5;break $if_then5$$lor_lhs_false$5; } //@line 291 "readclause.cpp"
  
            $retval=1; //@line 293 "readclause.cpp"
            __label__ = 7;break $if_then$$if_end$2; //@line 293 "readclause.cpp"
          }
        } while(0);
  
        $retval=0; //@line 292 "readclause.cpp"
        ; //@line 292 "readclause.cpp"
      }
    } while(0);
  
    var $5=$retval; //@line 294 "readclause.cpp"
    ;
    return $5; //@line 294 "readclause.cpp"
    return null;
  }
  

  function _iswlower($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 298 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 298 "readclause.cpp"
    var $1=$c_addr; //@line 299 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 298 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $call=_islower($1); //@line 299 "readclause.cpp"
        $retval=$call; //@line 299 "readclause.cpp"
        ; //@line 299 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $cmp1=((($1))>>>0) > 563; //@line 300 "readclause.cpp"
        if ($cmp1) { __label__ = 4;; } else { __label__ = 3;; } //@line 300 "readclause.cpp"
        $if_then3$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $2=$c_addr; //@line 300 "readclause.cpp"
            var $sub=((($2)-256)&4294967295); //@line 300 "readclause.cpp"
            var $arrayidx=((_walpha_tab+$sub)&4294967295); //@line 300 "readclause.cpp"
            var $3=HEAPU8[($arrayidx)]; //@line 300 "readclause.cpp"
            var $conv=((($3))&255); //@line 300 "readclause.cpp"
            var $cmp2=((($conv))|0)!=255; //@line 300 "readclause.cpp"
            if ($cmp2) { __label__ = 4;break $if_then3$$lor_lhs_false$5; } //@line 300 "readclause.cpp"
  
            $retval=1; //@line 302 "readclause.cpp"
            __label__ = 6;break $if_then$$if_end$2; //@line 302 "readclause.cpp"
          }
        } while(0);
  
        $retval=0; //@line 301 "readclause.cpp"
        ; //@line 301 "readclause.cpp"
      }
    } while(0);
  
    var $4=$retval; //@line 303 "readclause.cpp"
    ;
    return $4; //@line 303 "readclause.cpp"
    return null;
  }
  

  function _iswspace($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 307 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 307 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 307 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 308 "readclause.cpp"
      var $call=_isspace($1); //@line 308 "readclause.cpp"
      $retval=$call; //@line 308 "readclause.cpp"
      ; //@line 308 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 309 "readclause.cpp"
      ; //@line 309 "readclause.cpp"
    }
  
    var $2=$retval; //@line 310 "readclause.cpp"
    ;
    return $2; //@line 310 "readclause.cpp"
    return null;
  }
  

  function _iswpunct($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 314 "readclause.cpp"
    var $cmp=((($0))>>>0) < 256; //@line 314 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 314 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 315 "readclause.cpp"
      var $call=_ispunct($1); //@line 315 "readclause.cpp"
      $retval=$call; //@line 315 "readclause.cpp"
      ; //@line 315 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 316 "readclause.cpp"
      ; //@line 316 "readclause.cpp"
    }
  
    var $2=$retval; //@line 317 "readclause.cpp"
    ;
    return $2; //@line 317 "readclause.cpp"
    return null;
  }
  

  function _wcschr($str, $c) {
    ;
    var __label__;
  
    var $retval;
    var $str_addr;
    var $c_addr;
    $str_addr=$str;
    $c_addr=$c;
    ; //@line 321 "readclause.cpp"
    while(1) { 
  
      var $0=$str_addr; //@line 321 "readclause.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 321 "readclause.cpp"
      var $cmp=((($1))|0)!=0; //@line 321 "readclause.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 321 "readclause.cpp"
  
      var $2=$str_addr; //@line 323 "readclause.cpp"
      var $3=HEAP32[(($2)>>2)]; //@line 323 "readclause.cpp"
      var $4=$c_addr; //@line 323 "readclause.cpp"
      var $cmp1=((($3))|0)==((($4))|0); //@line 323 "readclause.cpp"
      var $5=$str_addr; //@line 324 "readclause.cpp"
      if ($cmp1) { __label__ = 3;break ; } //@line 323 "readclause.cpp"
  
      var $incdec_ptr=(($5+4)&4294967295); //@line 325 "readclause.cpp"
      $str_addr=$incdec_ptr; //@line 325 "readclause.cpp"
      __label__ = 1;continue ; //@line 326 "readclause.cpp"
    }
    if (__label__ == 5) {
  
      $retval=0; //@line 327 "readclause.cpp"
      ; //@line 327 "readclause.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=$5; //@line 324 "readclause.cpp"
      ; //@line 324 "readclause.cpp"
    }
  
    var $6=$retval; //@line 328 "readclause.cpp"
    ;
    return $6; //@line 328 "readclause.cpp"
    return null;
  }
  

  function _wcslen($str) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $str_addr;
    var $ix;
    $str_addr=$str;
    $ix=0; //@line 334 "readclause.cpp"
    var $0=$str_addr; //@line 336 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 336 "readclause.cpp"
    var $cmp1=((($1))|0)!=0; //@line 336 "readclause.cpp"
    var $2=$ix; //@line 338 "readclause.cpp"
    if ($cmp1) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 336 "readclause.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $6 : ($2);
          var $inc=((($3)+1)&4294967295); //@line 338 "readclause.cpp"
          $ix=$inc; //@line 338 "readclause.cpp"
          var $4=$str_addr; //@line 336 "readclause.cpp"
          var $5=HEAP32[(($4)>>2)]; //@line 336 "readclause.cpp"
          var $cmp=((($5))|0)!=0; //@line 336 "readclause.cpp"
          var $6=$ix; //@line 338 "readclause.cpp"
          if ($cmp) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $while_body$$while_end$2; } //@line 336 "readclause.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 0 ? $2 : ($6);
    ;
    return $_lcssa; //@line 340 "readclause.cpp"
    return null;
  }
  

  function _wcstod($str, $tailptr) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
    var __lastLabel__ = null;
  
    var $str_addr;
    var $tailptr_addr;
    var $ix;
    var $buf=__stackBase__;
    $str_addr=$str;
    $tailptr_addr=$tailptr;
    var $0=$str_addr; //@line 348 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 348 "readclause.cpp"
    var $call1=_isspace($1); //@line 348 "readclause.cpp"
    var $tobool2=((($call1))|0)!=0; //@line 348 "readclause.cpp"
    if ($tobool2) { __label__ = 1;; } else { __label__ = 2;; } //@line 348 "readclause.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$str_addr; //@line 348 "readclause.cpp"
          var $incdec_ptr=(($2+4)&4294967295); //@line 348 "readclause.cpp"
          $str_addr=$incdec_ptr; //@line 348 "readclause.cpp"
          var $3=$str_addr; //@line 348 "readclause.cpp"
          var $4=HEAP32[(($3)>>2)]; //@line 348 "readclause.cpp"
          var $call=_isspace($4); //@line 348 "readclause.cpp"
          var $tobool=((($call))|0)!=0; //@line 348 "readclause.cpp"
          if ($tobool) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 348 "readclause.cpp"
        }
      }
    } while(0);
  
    $ix=0; //@line 349 "readclause.cpp"
    __lastLabel__ = 2; ; //@line 349 "readclause.cpp"
    while(1) { 
  
      var $5=__lastLabel__ == 5 ? $inc : (0); //@line 349 "readclause.cpp"
      var $cmp=((($5))|0) < 80; //@line 349 "readclause.cpp"
      if (!($cmp)) { __label__ = 6;break ; } //@line 349 "readclause.cpp"
  
      var $6=$ix; //@line 351 "readclause.cpp"
      var $7=$str_addr; //@line 351 "readclause.cpp"
      var $arrayidx=(($7+4*$6)&4294967295); //@line 351 "readclause.cpp"
      var $8=HEAP32[(($arrayidx)>>2)]; //@line 351 "readclause.cpp"
      var $conv=((($8)) & 255); //@line 351 "readclause.cpp"
      var $9=$ix; //@line 351 "readclause.cpp"
      var $arrayidx1=(($buf+$9)&4294967295); //@line 351 "readclause.cpp"
      HEAP8[($arrayidx1)]=$conv; //@line 351 "readclause.cpp"
      var $10=$ix; //@line 352 "readclause.cpp"
      var $arrayidx2=(($buf+$10)&4294967295); //@line 352 "readclause.cpp"
      var $11=HEAP8[($arrayidx2)]; //@line 352 "readclause.cpp"
      var $conv3=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "readclause.cpp"
      var $call4=_isspace($conv3); //@line 352 "readclause.cpp"
      var $tobool5=((($call4))|0)!=0; //@line 352 "readclause.cpp"
      if ($tobool5) { __label__ = 6;break ; } //@line 352 "readclause.cpp"
  
      var $12=$ix; //@line 349 "readclause.cpp"
      var $inc=((($12)+1)&4294967295); //@line 349 "readclause.cpp"
      $ix=$inc; //@line 349 "readclause.cpp"
      __lastLabel__ = 5; __label__ = 3;continue ; //@line 349 "readclause.cpp"
    }
  
    var $13=$ix; //@line 355 "readclause.cpp"
    var $14=$str_addr; //@line 355 "readclause.cpp"
    var $arrayidx6=(($14+4*$13)&4294967295); //@line 355 "readclause.cpp"
    var $15=$tailptr_addr; //@line 355 "readclause.cpp"
    HEAP32[(($15)>>2)]=$arrayidx6; //@line 355 "readclause.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 356 "readclause.cpp"
    var $call7=_atof($arraydecay); //@line 356 "readclause.cpp"
    var $conv8=($call7); //@line 356 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $conv8; //@line 356 "readclause.cpp"
    return null;
  }
  

  function __Z9towlower2j($c) {
    ;
    var __label__;
  
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 366 "readclause.cpp"
    var $cmp=((($0))|0)==73; //@line 366 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 366 "readclause.cpp"
    $if_then$$if_end3$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_translator)>>2)]; //@line 368 "readclause.cpp"
        var $translator_name=(($1+280)&4294967295); //@line 368 "readclause.cpp"
        var $2=HEAP32[(($translator_name)>>2)]; //@line 368 "readclause.cpp"
        var $cmp1=((($2))|0)==29810; //@line 368 "readclause.cpp"
        if (!($cmp1)) { __label__ = 3;break $if_then$$if_end3$2; } //@line 368 "readclause.cpp"
  
        $c_addr=305; //@line 370 "readclause.cpp"
        ; //@line 371 "readclause.cpp"
      }
    } while(0);
  
    var $3=$c_addr; //@line 377 "readclause.cpp"
    var $call=_towlower($3); //@line 377 "readclause.cpp"
    ;
    return $call; //@line 377 "readclause.cpp"
    return null;
  }
  

  function __Z3Eofv() {
    ;
    var __label__;
  
    var $retval;
    var $0=HEAP32[((__ZL10ungot_char)>>2)]; //@line 404 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 404 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 404 "readclause.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 405 "readclause.cpp"
      ; //@line 405 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((__ZL7f_input)>>2)]; //@line 407 "readclause.cpp"
      var $cmp1=((($1))|0)!=0; //@line 407 "readclause.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 407 "readclause.cpp"
      if (__label__ == 3) {
  
        var $2=HEAP32[((__ZL7f_input)>>2)]; //@line 408 "readclause.cpp"
        var $_flags=(($2+12)&4294967295); //@line 408 "readclause.cpp"
        var $3=HEAP16[(($_flags)>>1)]; //@line 408 "readclause.cpp"
        var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 408 "readclause.cpp"
        var $and=($conv) & 32; //@line 408 "readclause.cpp"
        var $cmp3=((($and))|0)!=0; //@line 408 "readclause.cpp"
        var $conv4=((($cmp3))&1); //@line 408 "readclause.cpp"
        $retval=$conv4; //@line 408 "readclause.cpp"
        ; //@line 408 "readclause.cpp"
      }
      else if (__label__ == 4) {
  
        var $_b=HEAPU8[(__ZL12end_of_input_b)];
        var $4=((($_b))&1);
        $retval=$4; //@line 410 "readclause.cpp"
        ; //@line 410 "readclause.cpp"
      }
    }
  
    var $5=$retval; //@line 411 "readclause.cpp"
    ;
    return $5; //@line 411 "readclause.cpp"
    return null;
  }
  

  function __Z10Read4BytesP7__sFILE($f) {
    ;
    var __label__;
  
    var $f_addr;
    var $ix;
    var $c;
    var $acc;
    $f_addr=$f;
    $acc=0; //@line 701 "readclause.cpp"
    $ix=0; //@line 703 "readclause.cpp"
    ; //@line 703 "readclause.cpp"
    while(1) { 
  
      var $0=$f_addr; //@line 705 "readclause.cpp"
      var $call=_fgetc($0); //@line 705 "readclause.cpp"
      var $and=($call) & 255; //@line 705 "readclause.cpp"
      var $conv=((($and)) & 255); //@line 705 "readclause.cpp"
      $c=$conv; //@line 705 "readclause.cpp"
      var $1=$c; //@line 706 "readclause.cpp"
      var $conv1=((($1))&255); //@line 706 "readclause.cpp"
      var $2=$ix; //@line 706 "readclause.cpp"
      var $mul=((($2)*8)&4294967295); //@line 706 "readclause.cpp"
      var $shl=($conv1) << ($mul); //@line 706 "readclause.cpp"
      var $3=$acc; //@line 706 "readclause.cpp"
      var $add=((($shl)+($3))&4294967295); //@line 706 "readclause.cpp"
      $acc=$add; //@line 706 "readclause.cpp"
      var $4=$ix; //@line 703 "readclause.cpp"
      var $inc=((($4)+1)&4294967295); //@line 703 "readclause.cpp"
      $ix=$inc; //@line 703 "readclause.cpp"
      var $cmp=((($inc))|0) < 4; //@line 703 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 703 "readclause.cpp"
    }
  
    var $5=$acc; //@line 708 "readclause.cpp"
    ;
    return $5; //@line 708 "readclause.cpp"
    return null;
  }
  

  function __Z11AddNameDataPKci($name, $wide) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $wide_addr;
    var $ix;
    var $len;
    var $vp;
    $name_addr=$name;
    $wide_addr=$wide;
    var $0=$wide_addr; //@line 1371 "readclause.cpp"
    var $tobool=((($0))|0)!=0; //@line 1371 "readclause.cpp"
    var $1=$name_addr; //@line 1373 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1371 "readclause.cpp"
    if (__label__ == 1) {
  
      var $2=$1; //@line 1373 "readclause.cpp"
      var $call=_wcslen($2); //@line 1373 "readclause.cpp"
      var $add=((($call)+1)&4294967295); //@line 1373 "readclause.cpp"
      var $mul=((($add)*4)&4294967295); //@line 1373 "readclause.cpp"
      $len=$mul; //@line 1373 "readclause.cpp"
      var $3=HEAP32[((__ZL10n_namedata)>>2)]; //@line 1374 "readclause.cpp"
      var $sub=((($3)+3)&4294967295); //@line 1374 "readclause.cpp"
      var $rem=((($sub))>>>0)%4; //@line 1374 "readclause.cpp"
      HEAP32[((__ZL10n_namedata)>>2)]=$rem; //@line 1374 "readclause.cpp"
      ; //@line 1375 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $call2=_strlen($1); //@line 1378 "readclause.cpp"
      var $add3=((($call2)+1)&4294967295); //@line 1378 "readclause.cpp"
      $len=$add3; //@line 1378 "readclause.cpp"
      ;
    }
  
    var $4=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1381 "readclause.cpp"
    var $5=$len; //@line 1381 "readclause.cpp"
    var $add4=((($5)+($4))&4294967295); //@line 1381 "readclause.cpp"
    var $6=HEAP32[((__ZL10n_namedata)>>2)]; //@line 1381 "readclause.cpp"
    var $cmp=((($add4))|0) >= ((($6))|0); //@line 1381 "readclause.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 7;; } //@line 1381 "readclause.cpp"
    $if_then5$$if_end14$6: do { 
      if (__label__ == 4) {
  
        var $7=HEAP32[((_namedata)>>2)]; //@line 1384 "readclause.cpp"
        var $8=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1384 "readclause.cpp"
        var $9=$len; //@line 1384 "readclause.cpp"
        var $add6=((($8)+300)&4294967295); //@line 1384 "readclause.cpp"
        var $add7=((($add6)+($9))&4294967295); //@line 1384 "readclause.cpp"
        var $call8=_realloc($7, $add7); //@line 1384 "readclause.cpp"
        $vp=$call8; //@line 1384 "readclause.cpp"
        var $cmp9=((($call8))|0)==0; //@line 1384 "readclause.cpp"
        if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 1384 "readclause.cpp"
        if (__label__ == 5) {
  
          $retval=-1; //@line 1385 "readclause.cpp"
          __label__ = 8;break $if_then5$$if_end14$6; //@line 1385 "readclause.cpp"
        }
        else if (__label__ == 6) {
  
          var $10=$vp; //@line 1387 "readclause.cpp"
          HEAP32[((_namedata)>>2)]=$10; //@line 1387 "readclause.cpp"
          var $11=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1388 "readclause.cpp"
          var $12=$len; //@line 1388 "readclause.cpp"
          var $add12=((($11)+300)&4294967295); //@line 1388 "readclause.cpp"
          var $add13=((($add12)+($12))&4294967295); //@line 1388 "readclause.cpp"
          HEAP32[((__ZL10n_namedata)>>2)]=$add13; //@line 1388 "readclause.cpp"
          __label__ = 7;break $if_then5$$if_end14$6; //@line 1389 "readclause.cpp"
        }
      }
    } while(0);
    if (__label__ == 7) {
  
      var $13=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1390 "readclause.cpp"
      $ix=$13; //@line 1390 "readclause.cpp"
      var $14=HEAP32[((_namedata)>>2)]; //@line 1390 "readclause.cpp"
      var $arrayidx=(($14+$13)&4294967295); //@line 1390 "readclause.cpp"
      var $15=$name_addr; //@line 1390 "readclause.cpp"
      var $16=$len; //@line 1390 "readclause.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $15;
      $dest$ = $arrayidx;
      $stop$ = $src$ + $16;
      if (($dest$%4) == ($src$%4) && $16 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 1390 "readclause.cpp"
      var $17=$len; //@line 1391 "readclause.cpp"
      var $18=HEAP32[((__ZL11namedata_ix)>>2)]; //@line 1391 "readclause.cpp"
      var $add15=((($18)+($17))&4294967295); //@line 1391 "readclause.cpp"
      HEAP32[((__ZL11namedata_ix)>>2)]=$add15; //@line 1391 "readclause.cpp"
      var $19=$ix; //@line 1392 "readclause.cpp"
      $retval=$19; //@line 1392 "readclause.cpp"
      ; //@line 1392 "readclause.cpp"
    }
  
    var $20=$retval; //@line 1393 "readclause.cpp"
    ;
    return $20; //@line 1393 "readclause.cpp"
    return null;
  }
  

  function __Z13SetVoiceStackP12espeak_VOICE($v) {
    ;
    var __label__;
  
    var $v_addr;
    var $sp;
    $v_addr=$v;
    $sp=((__ZL10ssml_stack)&4294967295); //@line 1399 "readclause.cpp"
    var $0=$v_addr; //@line 1401 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 1401 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1401 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$sp; //@line 1403 "readclause.cpp"
      var $2=$1; //@line 1403 "readclause.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $2;
      $stop$ = $dest$ + 76;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 1403 "readclause.cpp"
      ; //@line 1404 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$v_addr; //@line 1406 "readclause.cpp"
      var $languages=(($3+4)&4294967295); //@line 1406 "readclause.cpp"
      var $4=HEAP32[(($languages)>>2)]; //@line 1406 "readclause.cpp"
      var $cmp1=((($4))|0)!=0; //@line 1406 "readclause.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1406 "readclause.cpp"
      if (__label__ == 3) {
  
        var $5=$sp; //@line 1407 "readclause.cpp"
        var $language=(($5+56)&4294967295); //@line 1407 "readclause.cpp"
        var $arraydecay=(($language)&4294967295); //@line 1407 "readclause.cpp"
        var $6=$v_addr; //@line 1407 "readclause.cpp"
        var $languages3=(($6+4)&4294967295); //@line 1407 "readclause.cpp"
        var $7=HEAP32[(($languages3)>>2)]; //@line 1407 "readclause.cpp"
        var $call=_strcpy($arraydecay, $7); //@line 1407 "readclause.cpp"
        ; //@line 1407 "readclause.cpp"
      }
  
      var $8=$v_addr; //@line 1408 "readclause.cpp"
      var $name=(($8)&4294967295); //@line 1408 "readclause.cpp"
      var $9=HEAP32[(($name)>>2)]; //@line 1408 "readclause.cpp"
      var $cmp5=((($9))|0)!=0; //@line 1408 "readclause.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1408 "readclause.cpp"
      if (__label__ == 5) {
  
        var $10=$sp; //@line 1409 "readclause.cpp"
        var $voice_name=(($10+16)&4294967295); //@line 1409 "readclause.cpp"
        var $arraydecay7=(($voice_name)&4294967295); //@line 1409 "readclause.cpp"
        var $11=$v_addr; //@line 1409 "readclause.cpp"
        var $name8=(($11)&4294967295); //@line 1409 "readclause.cpp"
        var $12=HEAP32[(($name8)>>2)]; //@line 1409 "readclause.cpp"
        var $call9=_strcpy($arraydecay7, $12); //@line 1409 "readclause.cpp"
        ; //@line 1409 "readclause.cpp"
      }
  
      var $13=$v_addr; //@line 1410 "readclause.cpp"
      var $variant=(($13+14)&4294967295); //@line 1410 "readclause.cpp"
      var $14=HEAPU8[($variant)]; //@line 1410 "readclause.cpp"
      var $conv=((($14))&255); //@line 1410 "readclause.cpp"
      var $15=$sp; //@line 1410 "readclause.cpp"
      var $voice_variant=(($15+4)&4294967295); //@line 1410 "readclause.cpp"
      HEAP32[(($voice_variant)>>2)]=$conv; //@line 1410 "readclause.cpp"
      var $16=$v_addr; //@line 1411 "readclause.cpp"
      var $age=(($16+13)&4294967295); //@line 1411 "readclause.cpp"
      var $17=HEAPU8[($age)]; //@line 1411 "readclause.cpp"
      var $conv11=((($17))&255); //@line 1411 "readclause.cpp"
      var $18=$sp; //@line 1411 "readclause.cpp"
      var $voice_age=(($18+12)&4294967295); //@line 1411 "readclause.cpp"
      HEAP32[(($voice_age)>>2)]=$conv11; //@line 1411 "readclause.cpp"
      var $19=$v_addr; //@line 1412 "readclause.cpp"
      var $gender=(($19+12)&4294967295); //@line 1412 "readclause.cpp"
      var $20=HEAPU8[($gender)]; //@line 1412 "readclause.cpp"
      var $conv12=((($20))&255); //@line 1412 "readclause.cpp"
      var $21=$sp; //@line 1412 "readclause.cpp"
      var $voice_gender=(($21+8)&4294967295); //@line 1412 "readclause.cpp"
      HEAP32[(($voice_gender)>>2)]=$conv12; //@line 1412 "readclause.cpp"
      ; //@line 1413 "readclause.cpp"
    }
  
    ;
    return; //@line 1413 "readclause.cpp"
    return;
  }
  

  function __Z10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_($tr, $f_in, $buf, $charix, $charix_top, $n_buf, $tone_type, $voice_change) {
    var __stackBase__  = STACKTOP; STACKTOP += 1136; _memset(__stackBase__, 0, 1136);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $f_in_addr;
    var $buf_addr;
    var $charix_addr;
    var $charix_top_addr;
    var $n_buf_addr;
    var $tone_type_addr;
    var $voice_change_addr;
    var $c1=__stackBase__;
    var $c2=__stackBase__+4;
    var $cprev;
    var $cprev2;
    var $c_next;
    var $parag;
    var $ix=__stackBase__+8;
    var $j;
    var $nl_count;
    var $linelength;
    var $phoneme_mode;
    var $n_xml_buf;
    var $terminator;
    var $punct;
    var $found;
    var $any_alnum;
    var $self_closing;
    var $punct_data;
    var $is_end_clause;
    var $announced_punctuation;
    var $prev_announced_punctuation;
    var $stressed_word;
    var $end_clause_after_tag;
    var $end_clause_index;
    var $xml_buf=__stackBase__+12;
    var $xml_buf2=__stackBase__+1040;
    var $p_word;
    var $text_buf=__stackBase__+1064;
    var $text_buf2=__stackBase__+1104;
    var $p2;
    $tr_addr=$tr;
    $f_in_addr=$f_in;
    $buf_addr=$buf;
    $charix_addr=$charix;
    $charix_top_addr=$charix_top;
    $n_buf_addr=$n_buf;
    $tone_type_addr=$tone_type;
    $voice_change_addr=$voice_change;
    HEAP32[(($c1)>>2)]=32; //@line 2047 "readclause.cpp"
    $cprev=32; //@line 2049 "readclause.cpp"
    $cprev2=32; //@line 2050 "readclause.cpp"
    HEAP32[(($ix)>>2)]=0; //@line 2053 "readclause.cpp"
    $linelength=0; //@line 2056 "readclause.cpp"
    $phoneme_mode=0; //@line 2057 "readclause.cpp"
    $any_alnum=0; //@line 2062 "readclause.cpp"
    $punct_data=0; //@line 2064 "readclause.cpp"
    $announced_punctuation=0; //@line 2066 "readclause.cpp"
    $stressed_word=0; //@line 2068 "readclause.cpp"
    $end_clause_after_tag=0; //@line 2069 "readclause.cpp"
    $end_clause_index=0; //@line 2070 "readclause.cpp"
    var $_b=HEAPU8[(__ZL19clear_skipping_text_b)];
    var $0=((($_b))&1);
    var $tobool=((($0))|0)!=0; //@line 2078 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 2078 "readclause.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_skipping_text)>>2)]=0; //@line 2080 "readclause.cpp"
      HEAP8[(__ZL19clear_skipping_text_b)]=0;
      ; //@line 2082 "readclause.cpp"
    }
  
    var $1=$tr_addr; //@line 2084 "readclause.cpp"
    var $phonemes_repeat_count=(($1+652)&4294967295); //@line 2084 "readclause.cpp"
    HEAP32[(($phonemes_repeat_count)>>2)]=0; //@line 2084 "readclause.cpp"
    var $2=$tr_addr; //@line 2085 "readclause.cpp"
    var $clause_upper_count=(($2+8304)&4294967295); //@line 2085 "readclause.cpp"
    HEAP32[(($clause_upper_count)>>2)]=0; //@line 2085 "readclause.cpp"
    var $3=$tr_addr; //@line 2086 "readclause.cpp"
    var $clause_lower_count=(($3+8308)&4294967295); //@line 2086 "readclause.cpp"
    HEAP32[(($clause_lower_count)>>2)]=0; //@line 2086 "readclause.cpp"
    HEAP8[(__ZL12end_of_input_b)]=0;
    var $4=$tone_type_addr; //@line 2088 "readclause.cpp"
    HEAP32[(($4)>>2)]=0; //@line 2088 "readclause.cpp"
    var $5=$voice_change_addr; //@line 2089 "readclause.cpp"
    HEAP8[($5)]=0; //@line 2089 "readclause.cpp"
    var $6=$f_in_addr; //@line 2091 "readclause.cpp"
    HEAP32[((__ZL7f_input)>>2)]=$6; //@line 2091 "readclause.cpp"
    var $7=HEAP32[((__ZL10ungot_word)>>2)]; //@line 2093 "readclause.cpp"
    var $cmp=((($7))|0)!=0; //@line 2093 "readclause.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 2093 "readclause.cpp"
    if (__label__ == 3) {
  
      var $8=$buf_addr; //@line 2095 "readclause.cpp"
      var $9=HEAP32[((__ZL10ungot_word)>>2)]; //@line 2095 "readclause.cpp"
      var $call=_strcpy($8, $9); //@line 2095 "readclause.cpp"
      var $10=HEAP32[((__ZL10ungot_word)>>2)]; //@line 2096 "readclause.cpp"
      var $call2=_strlen($10); //@line 2096 "readclause.cpp"
      var $11=HEAP32[(($ix)>>2)]; //@line 2096 "readclause.cpp"
      var $add=((($11)+($call2))&4294967295); //@line 2096 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$add; //@line 2096 "readclause.cpp"
      HEAP32[((__ZL10ungot_word)>>2)]=0; //@line 2097 "readclause.cpp"
      ; //@line 2098 "readclause.cpp"
    }
  
    var $12=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2100 "readclause.cpp"
    var $cmp4=((($12))|0)!=0; //@line 2100 "readclause.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 2100 "readclause.cpp"
    if (__label__ == 5) {
  
      var $13=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2102 "readclause.cpp"
      HEAP32[(($c2)>>2)]=$13; //@line 2102 "readclause.cpp"
      ; //@line 2103 "readclause.cpp"
    }
    else if (__label__ == 6) {
  
      var $call6=__ZL4GetCv(); //@line 2106 "readclause.cpp"
      HEAP32[(($c2)>>2)]=$call6; //@line 2106 "readclause.cpp"
      ;
    }
  
    var $arrayidx82=(($xml_buf2)&4294967295); //@line 2172 "readclause.cpp"
    var $arrayidx86=(($xml_buf2)&4294967295); //@line 2176 "readclause.cpp"
    var $arrayidx90=(($xml_buf2+1)&4294967295); //@line 2179 "readclause.cpp"
    var $arrayidx94=(($xml_buf2+2)&4294967295); //@line 2180 "readclause.cpp"
    var $arrayidx97=(($xml_buf2+1)&4294967295); //@line 2182 "readclause.cpp"
    var $arraydecay=(($xml_buf2)&4294967295); //@line 2186 "readclause.cpp"
    var $arraydecay164=(($xml_buf)&4294967295); //@line 2245 "readclause.cpp"
    var $arraydecay324=(($text_buf2)&4294967295); //@line 2396 "readclause.cpp"
    var $arraydecay328=(($text_buf)&4294967295); //@line 2398 "readclause.cpp"
    var $arraydecay329=(($text_buf2)&4294967295); //@line 2398 "readclause.cpp"
    var $arraydecay331=(($text_buf)&4294967295); //@line 2399 "readclause.cpp"
    var $arraydecay337=(($text_buf)&4294967295); //@line 2402 "readclause.cpp"
    ; //@line 2109 "readclause.cpp"
    $while_cond$12: while(1) { 
  
      var $call8=__Z3Eofv(); //@line 2109 "readclause.cpp"
      var $tobool9=((($call8))|0)==0; //@line 2109 "readclause.cpp"
      var $14=HEAP32[((__ZL10ungot_char)>>2)]; //@line 2109 "readclause.cpp"
      var $cmp10=((($14))|0)!=0; //@line 2109 "readclause.cpp"
      var $or_cond=($tobool9) | ($cmp10); //@line 2109 "readclause.cpp"
      var $15=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2109 "readclause.cpp"
      var $cmp12=((($15))|0)!=0; //@line 2109 "readclause.cpp"
      var $or_cond3=($or_cond) | ($cmp12); //@line 2109 "readclause.cpp"
      var $16=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2109 "readclause.cpp"
      var $cmp13=((($16))|0) >= 0; //@line 2109 "readclause.cpp"
      var $or_cond19=($or_cond3) | ($cmp13); //@line 2109 "readclause.cpp"
      if (!($or_cond19)) { __label__ = 256;break $while_cond$12; } //@line 2109 "readclause.cpp"
  
      var $17=HEAP32[(($c1)>>2)]; //@line 2111 "readclause.cpp"
      var $call14=_iswalnum($17); //@line 2111 "readclause.cpp"
      var $tobool15=((($call14))|0)!=0; //@line 2111 "readclause.cpp"
      if ($tobool15) { __label__ = 16;; } else { __label__ = 10;; } //@line 2111 "readclause.cpp"
      $if_end26$$if_then16$15: do { 
        if (__label__ == 10) {
  
          var $18=HEAP32[((_end_character_position)>>2)]; //@line 2113 "readclause.cpp"
          var $cmp17=((($18))|0) > 0; //@line 2113 "readclause.cpp"
          if ($cmp17) { __label__ = 11;; } else { __label__ = 13;; } //@line 2113 "readclause.cpp"
          if (__label__ == 11) {
  
            var $19=HEAP32[((_count_characters)>>2)]; //@line 2113 "readclause.cpp"
            var $20=HEAP32[((_end_character_position)>>2)]; //@line 2113 "readclause.cpp"
            var $cmp18=((($19))|0) > ((($20))|0); //@line 2113 "readclause.cpp"
            if ($cmp18) { __label__ = 12;break $while_cond$12; } //@line 2113 "readclause.cpp"
          }
  
          var $21=HEAP32[((_skip_characters)>>2)]; //@line 2119 "readclause.cpp"
          var $cmp21=((($21))|0) > 0; //@line 2119 "readclause.cpp"
          if (!($cmp21)) { __label__ = 16;break $if_end26$$if_then16$15; } //@line 2119 "readclause.cpp"
  
          var $22=HEAP32[((_count_characters)>>2)]; //@line 2119 "readclause.cpp"
          var $23=HEAP32[((_skip_characters)>>2)]; //@line 2119 "readclause.cpp"
          var $cmp23=((($22))|0) > ((($23))|0); //@line 2119 "readclause.cpp"
          if ($cmp23) { __label__ = 15;break $while_cond$12; } //@line 2119 "readclause.cpp"
        }
      } while(0);
  
      var $25=$cprev; //@line 2130 "readclause.cpp"
      $cprev2=$25; //@line 2130 "readclause.cpp"
      var $26=HEAP32[(($c1)>>2)]; //@line 2131 "readclause.cpp"
      $cprev=$26; //@line 2131 "readclause.cpp"
      var $27=HEAP32[(($c2)>>2)]; //@line 2132 "readclause.cpp"
      HEAP32[(($c1)>>2)]=$27; //@line 2132 "readclause.cpp"
      var $28=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2134 "readclause.cpp"
      var $cmp27=((($28))|0) >= 0; //@line 2134 "readclause.cpp"
      if ($cmp27) { __label__ = 17;; } else { __label__ = 19;; } //@line 2134 "readclause.cpp"
      $if_then28$$if_end32$22: do { 
        if (__label__ == 17) {
  
          var $29=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2136 "readclause.cpp"
          var $arrayidx=((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string+$29)&4294967295); //@line 2136 "readclause.cpp"
          var $30=HEAP8[($arrayidx)]; //@line 2136 "readclause.cpp"
          var $conv=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 2136 "readclause.cpp"
          var $cmp29=((($conv))|0)==0; //@line 2136 "readclause.cpp"
          if (!($cmp29)) { __label__ = 19;break $if_then28$$if_end32$22; } //@line 2136 "readclause.cpp"
  
          HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=-1; //@line 2137 "readclause.cpp"
          ; //@line 2137 "readclause.cpp"
        }
      } while(0);
  
      var $31=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2140 "readclause.cpp"
      var $cmp33=((($31))|0)==0; //@line 2140 "readclause.cpp"
      var $32=HEAP32[((__ZL11ungot_char2)>>2)]; //@line 2140 "readclause.cpp"
      var $cmp35=((($32))|0)==0; //@line 2140 "readclause.cpp"
      var $or_cond4=($cmp33) & ($cmp35); //@line 2140 "readclause.cpp"
      if ($or_cond4) { __lastLabel__ = 19; __label__ = 20;; } else { __lastLabel__ = 19; __label__ = 21;; } //@line 2140 "readclause.cpp"
      if (__label__ == 20) {
  
        var $33=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2142 "readclause.cpp"
        var $inc=((($33)+1)&4294967295); //@line 2142 "readclause.cpp"
        HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=$inc; //@line 2142 "readclause.cpp"
        var $arrayidx37=((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string+$33)&4294967295); //@line 2142 "readclause.cpp"
        var $34=HEAP8[($arrayidx37)]; //@line 2142 "readclause.cpp"
        var $conv38=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt)); //@line 2142 "readclause.cpp"
        HEAP32[(($c1)>>2)]=$conv38; //@line 2142 "readclause.cpp"
        __lastLabel__ = 20; ; //@line 2143 "readclause.cpp"
      }
  
      var $35=__lastLabel__ == 20 ? $inc : ($31); //@line 2144 "readclause.cpp"
      var $cmp40=((($35))|0) >= 0; //@line 2144 "readclause.cpp"
      if ($cmp40) { __label__ = 22;; } else { __label__ = 23;; } //@line 2144 "readclause.cpp"
      $if_then41$$if_else45$29: do { 
        if (__label__ == 22) {
  
          var $36=HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]; //@line 2146 "readclause.cpp"
          var $inc42=((($36)+1)&4294967295); //@line 2146 "readclause.cpp"
          HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=$inc42; //@line 2146 "readclause.cpp"
          var $arrayidx43=((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string+$36)&4294967295); //@line 2146 "readclause.cpp"
          var $37=HEAP8[($arrayidx43)]; //@line 2146 "readclause.cpp"
          var $conv44=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 2146 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$conv44; //@line 2146 "readclause.cpp"
          ; //@line 2147 "readclause.cpp"
        }
        else if (__label__ == 23) {
  
          var $call46=__ZL4GetCv(); //@line 2150 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call46; //@line 2150 "readclause.cpp"
          var $call47=__Z3Eofv(); //@line 2152 "readclause.cpp"
          var $tobool48=((($call47))|0)!=0; //@line 2152 "readclause.cpp"
          if (!($tobool48)) { __label__ = 25;break $if_then41$$if_else45$29; } //@line 2152 "readclause.cpp"
  
          HEAP32[(($c2)>>2)]=32; //@line 2154 "readclause.cpp"
          ; //@line 2155 "readclause.cpp"
        }
      } while(0);
  
      HEAP32[((__ZL11ungot_char2)>>2)]=0; //@line 2157 "readclause.cpp"
      var $38=HEAP32[((_option_ssml)>>2)]; //@line 2159 "readclause.cpp"
      var $tobool52=((($38))|0)!=0; //@line 2159 "readclause.cpp"
      if ($tobool52) { __label__ = 26;; } else { __label__ = 72;; } //@line 2159 "readclause.cpp"
      $land_lhs_true53$$if_end184$34: do { 
        if (__label__ == 26) {
  
          var $39=$phoneme_mode; //@line 2159 "readclause.cpp"
          var $cmp54=((($39))|0)==0; //@line 2159 "readclause.cpp"
          if (!($cmp54)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2159 "readclause.cpp"
  
          var $40=HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]; //@line 2161 "readclause.cpp"
          var $cmp56=((($40))|0)!=38; //@line 2161 "readclause.cpp"
          if ($cmp56) { __label__ = 28;; } else { __label__ = 50;; } //@line 2161 "readclause.cpp"
          $land_lhs_true57$$if_else122$37: do { 
            if (__label__ == 28) {
  
              var $41=HEAP32[(($c1)>>2)]; //@line 2161 "readclause.cpp"
              var $cmp58=((($41))|0)==38; //@line 2161 "readclause.cpp"
              if (!($cmp58)) { __label__ = 50;break $land_lhs_true57$$if_else122$37; } //@line 2161 "readclause.cpp"
  
              var $42=HEAP32[(($c2)>>2)]; //@line 2161 "readclause.cpp"
              var $cmp60=((($42))|0)==35; //@line 2161 "readclause.cpp"
              if ($cmp60) { __label__ = 31;; } else { __label__ = 30;; } //@line 2161 "readclause.cpp"
              if (__label__ == 30) {
  
                var $43=HEAP32[(($c2)>>2)]; //@line 2161 "readclause.cpp"
                var $cmp62=((($43))|0) >= 97; //@line 2161 "readclause.cpp"
                var $44=HEAP32[(($c2)>>2)]; //@line 2161 "readclause.cpp"
                var $cmp64=((($44))|0) <= 122; //@line 2161 "readclause.cpp"
                var $or_cond5=($cmp62) & ($cmp64); //@line 2161 "readclause.cpp"
                if (!($or_cond5)) { __label__ = 50;break $land_lhs_true57$$if_else122$37; } //@line 2161 "readclause.cpp"
              }
  
              $n_xml_buf=0; //@line 2163 "readclause.cpp"
              var $45=HEAP32[(($c2)>>2)]; //@line 2164 "readclause.cpp"
              HEAP32[(($c1)>>2)]=$45; //@line 2164 "readclause.cpp"
              ; //@line 2165 "readclause.cpp"
              $while_cond66$43: while(1) { 
  
                var $call67=__Z3Eofv(); //@line 2165 "readclause.cpp"
                var $tobool68=((($call67))|0)!=0; //@line 2165 "readclause.cpp"
                if ($tobool68) { __label__ = 36;break $while_cond66$43; } //@line 2165 "readclause.cpp"
  
                var $46=HEAP32[(($c1)>>2)]; //@line 2165 "readclause.cpp"
                var $call70=_iswalnum($46); //@line 2165 "readclause.cpp"
                var $tobool71=((($call70))|0)!=0; //@line 2165 "readclause.cpp"
                var $47=HEAP32[(($c1)>>2)]; //@line 2165 "readclause.cpp"
                var $cmp73=((($47))|0)==35; //@line 2165 "readclause.cpp"
                var $or_cond6=($tobool71) | ($cmp73); //@line 2165 "readclause.cpp"
                if (!($or_cond6)) { __label__ = 36;break $while_cond66$43; } //@line 2165 "readclause.cpp"
  
                var $48=$n_xml_buf; //@line 2165 "readclause.cpp"
                var $cmp74=((($48))|0) < 20; //@line 2165 "readclause.cpp"
                if (!($cmp74)) { __label__ = 36;break $while_cond66$43; }
  
                var $49=HEAP32[(($c1)>>2)]; //@line 2167 "readclause.cpp"
                var $conv76=((($49)) & 255); //@line 2167 "readclause.cpp"
                var $50=$n_xml_buf; //@line 2167 "readclause.cpp"
                var $inc77=((($50)+1)&4294967295); //@line 2167 "readclause.cpp"
                $n_xml_buf=$inc77; //@line 2167 "readclause.cpp"
                var $arrayidx78=(($xml_buf2+$50)&4294967295); //@line 2167 "readclause.cpp"
                HEAP8[($arrayidx78)]=$conv76; //@line 2167 "readclause.cpp"
                var $call79=__ZL4GetCv(); //@line 2168 "readclause.cpp"
                HEAP32[(($c1)>>2)]=$call79; //@line 2168 "readclause.cpp"
                __label__ = 32;continue $while_cond66$43; //@line 2169 "readclause.cpp"
              }
  
              var $51=$n_xml_buf; //@line 2170 "readclause.cpp"
              var $arrayidx80=(($xml_buf2+$51)&4294967295); //@line 2170 "readclause.cpp"
              HEAP8[($arrayidx80)]=0; //@line 2170 "readclause.cpp"
              var $call81=__ZL4GetCv(); //@line 2171 "readclause.cpp"
              HEAP32[(($c2)>>2)]=$call81; //@line 2171 "readclause.cpp"
              var $52=HEAP32[(($c1)>>2)]; //@line 2172 "readclause.cpp"
              var $53=HEAP32[(($c2)>>2)]; //@line 2172 "readclause.cpp"
              var $call83=_sprintf(((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string)&4294967295), ((__str38205)&4294967295), allocate([$arrayidx82,0,0,0,$52,0,0,0,$53,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 2172 "readclause.cpp"
              var $54=HEAP32[(($c1)>>2)]; //@line 2174 "readclause.cpp"
              var $cmp84=((($54))|0)==59; //@line 2174 "readclause.cpp"
              if ($cmp84) { __label__ = 37;; } else { __label__ = 44;; } //@line 2174 "readclause.cpp"
              $if_then85$$if_else109$49: do { 
                if (__label__ == 37) {
  
                  var $55=HEAP8[($arrayidx86)]; //@line 2176 "readclause.cpp"
                  var $conv87=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 2176 "readclause.cpp"
                  var $cmp88=((($conv87))|0)==35; //@line 2176 "readclause.cpp"
                  if ($cmp88) { __label__ = 38;; } else { __label__ = 41;; } //@line 2176 "readclause.cpp"
                  $if_then89$$if_else100$51: do { 
                    if (__label__ == 38) {
  
                      var $56=HEAP8[($arrayidx90)]; //@line 2179 "readclause.cpp"
                      var $conv91=(tempInt=(($56)),(tempInt>=128?tempInt-256:tempInt)); //@line 2179 "readclause.cpp"
                      var $cmp92=((($conv91))|0)==120; //@line 2179 "readclause.cpp"
                      if ($cmp92) { __label__ = 39;; } else { __label__ = 40;; } //@line 2179 "readclause.cpp"
                      if (__label__ == 39) {
  
                        var $call95=_sscanf($arrayidx94, ((__str10307)&4294967295), allocate([$c1,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 2180 "readclause.cpp"
                        $found=$call95; //@line 2180 "readclause.cpp"
                        __lastLabel__ = 39; ; //@line 2180 "readclause.cpp"
                      }
                      else if (__label__ == 40) {
  
                        var $call98=_sscanf($arrayidx97, ((__str63715)&4294967295), allocate([$c1,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 2182 "readclause.cpp"
                        $found=$call98; //@line 2182 "readclause.cpp"
                        __lastLabel__ = 40; ;
                      }
                    }
                    else if (__label__ == 41) {
  
                      var $call101=__Z10LookupMnemP8MNEM_TABPKc(((__ZL18xml_char_mnemonics)&4294967295), $arraydecay); //@line 2186 "readclause.cpp"
                      $found=$call101; //@line 2186 "readclause.cpp"
                      var $cmp102=((($call101))|0)!=-1; //@line 2186 "readclause.cpp"
                      if (!($cmp102)) { __label__ = 46;break $if_then85$$if_else109$49; } //@line 2186 "readclause.cpp"
  
                      var $57=$found; //@line 2188 "readclause.cpp"
                      HEAP32[(($c1)>>2)]=$57; //@line 2188 "readclause.cpp"
                      var $58=HEAP32[(($c2)>>2)]; //@line 2189 "readclause.cpp"
                      var $cmp104=((($58))|0)==0; //@line 2189 "readclause.cpp"
                      if ($cmp104) { __lastLabel__ = 42; ; } else { __lastLabel__ = 42; __label__ = 45;break $if_then89$$if_else100$51; } //@line 2189 "readclause.cpp"
  
                      HEAP32[(($c2)>>2)]=32; //@line 2190 "readclause.cpp"
                      var $_pr=$found; //@line 2199 "readclause.cpp"
                      __lastLabel__ = 43; ; //@line 2190 "readclause.cpp"
                    }
                  } while(0);
  
                  var $59=__lastLabel__ == 40 ? $call98 : (__lastLabel__ == 39 ? $call95 : (__lastLabel__ == 42 ? $57 : ($_pr))); //@line 2199 "readclause.cpp"
                  var $cmp111=((($59))|0) <= 0; //@line 2199 "readclause.cpp"
                  if ($cmp111) { __label__ = 46;break $if_then85$$if_else109$49; } //@line 2199 "readclause.cpp"
  
                  var $_pr23=HEAP32[(($c1)>>2)]; //@line 2206 "readclause.cpp"
                  var $cmp114=((($_pr23))|0) <= 32; //@line 2206 "readclause.cpp"
                  if (!($cmp114)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2206 "readclause.cpp"
  
                  var $60=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2206 "readclause.cpp"
                  var $cmp116=((($60))|0)==20; //@line 2206 "readclause.cpp"
                  var $61=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2206 "readclause.cpp"
                  var $cmp118=((($61))|0)==36; //@line 2206 "readclause.cpp"
                  var $or_cond8=($cmp116) | ($cmp118); //@line 2206 "readclause.cpp"
                  if (!($or_cond8)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2206 "readclause.cpp"
  
                  var $62=HEAP32[(($c1)>>2)]; //@line 2208 "readclause.cpp"
                  var $add120=((($62)+57344)&4294967295); //@line 2208 "readclause.cpp"
                  HEAP32[(($c1)>>2)]=$add120; //@line 2208 "readclause.cpp"
                  __label__ = 72;break $land_lhs_true53$$if_end184$34; //@line 2209 "readclause.cpp"
                }
                else if (__label__ == 44) {
  
                  $found=-1; //@line 2196 "readclause.cpp"
                  ;
                }
              } while(0);
  
              HEAP32[((__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix)>>2)]=0; //@line 2201 "readclause.cpp"
              HEAP32[(($c1)>>2)]=38; //@line 2202 "readclause.cpp"
              HEAP32[(($c2)>>2)]=32; //@line 2203 "readclause.cpp"
              __label__ = 72;break $land_lhs_true53$$if_end184$34; //@line 2206 "readclause.cpp"
            }
          } while(0);
  
          var $63=HEAP32[(($c1)>>2)]; //@line 2212 "readclause.cpp"
          var $cmp123=((($63))|0)==60; //@line 2212 "readclause.cpp"
          var $64=HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]; //@line 2212 "readclause.cpp"
          var $cmp125=((($64))|0)!=60; //@line 2212 "readclause.cpp"
          var $or_cond9=($cmp123) & ($cmp125); //@line 2212 "readclause.cpp"
          if (!($or_cond9)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2212 "readclause.cpp"
  
          var $65=HEAP32[(($c2)>>2)]; //@line 2214 "readclause.cpp"
          var $cmp127=((($65))|0)==33; //@line 2214 "readclause.cpp"
          if ($cmp127) { __label__ = 52;; } else { __label__ = 56;; } //@line 2214 "readclause.cpp"
          if (__label__ == 52) {
            while(1) { 
  
              var $call130=__Z3Eofv(); //@line 2217 "readclause.cpp"
              var $tobool131=((($call130))|0)!=0; //@line 2217 "readclause.cpp"
              if ($tobool131) { __label__ = 55;break ; } //@line 2217 "readclause.cpp"
  
              var $66=HEAP32[(($c1)>>2)]; //@line 2217 "readclause.cpp"
              var $cmp133=((($66))|0)!=62; //@line 2217 "readclause.cpp"
              if (!($cmp133)) { __label__ = 55;break ; }
  
              var $call136=__ZL4GetCv(); //@line 2219 "readclause.cpp"
              HEAP32[(($c1)>>2)]=$call136; //@line 2219 "readclause.cpp"
              __label__ = 52;continue ; //@line 2220 "readclause.cpp"
            }
  
            HEAP32[(($c2)>>2)]=32; //@line 2221 "readclause.cpp"
            ; //@line 2222 "readclause.cpp"
          }
          else if (__label__ == 56) {
  
            var $67=HEAP32[(($c2)>>2)]; //@line 2224 "readclause.cpp"
            var $cmp139=((($67))|0)==47; //@line 2224 "readclause.cpp"
            if ($cmp139) { __label__ = 58;; } else { __label__ = 57;; } //@line 2224 "readclause.cpp"
            if (__label__ == 57) {
  
              var $68=HEAP32[(($c2)>>2)]; //@line 2224 "readclause.cpp"
              var $call141=_iswalpha($68); //@line 2224 "readclause.cpp"
              var $tobool142=((($call141))|0)!=0; //@line 2224 "readclause.cpp"
              if (!($tobool142)) { __label__ = 72;break $land_lhs_true53$$if_end184$34; } //@line 2224 "readclause.cpp"
            }
  
            $n_xml_buf=0; //@line 2227 "readclause.cpp"
            var $69=HEAP32[(($c2)>>2)]; //@line 2228 "readclause.cpp"
            HEAP32[(($c1)>>2)]=$69; //@line 2228 "readclause.cpp"
            ; //@line 2229 "readclause.cpp"
            while(1) { 
  
              var $call145=__Z3Eofv(); //@line 2229 "readclause.cpp"
              var $tobool146=((($call145))|0)!=0; //@line 2229 "readclause.cpp"
              if ($tobool146) { __label__ = 63;break ; } //@line 2229 "readclause.cpp"
  
              var $70=HEAP32[(($c1)>>2)]; //@line 2229 "readclause.cpp"
              var $cmp148=((($70))|0)!=62; //@line 2229 "readclause.cpp"
              if (!($cmp148)) { __label__ = 63;break ; } //@line 2229 "readclause.cpp"
  
              var $71=$n_xml_buf; //@line 2229 "readclause.cpp"
              var $cmp150=((($71))|0) < 256; //@line 2229 "readclause.cpp"
              if (!($cmp150)) { __label__ = 63;break ; }
  
              var $72=HEAP32[(($c1)>>2)]; //@line 2231 "readclause.cpp"
              var $73=$n_xml_buf; //@line 2231 "readclause.cpp"
              var $inc153=((($73)+1)&4294967295); //@line 2231 "readclause.cpp"
              $n_xml_buf=$inc153; //@line 2231 "readclause.cpp"
              var $arrayidx154=(($xml_buf+$73*4)&4294967295); //@line 2231 "readclause.cpp"
              HEAP32[(($arrayidx154)>>2)]=$72; //@line 2231 "readclause.cpp"
              var $call155=__ZL4GetCv(); //@line 2232 "readclause.cpp"
              HEAP32[(($c1)>>2)]=$call155; //@line 2232 "readclause.cpp"
              __label__ = 59;continue ; //@line 2233 "readclause.cpp"
            }
  
            var $74=$n_xml_buf; //@line 2234 "readclause.cpp"
            var $arrayidx157=(($xml_buf+$74*4)&4294967295); //@line 2234 "readclause.cpp"
            HEAP32[(($arrayidx157)>>2)]=0; //@line 2234 "readclause.cpp"
            HEAP32[(($c2)>>2)]=32; //@line 2235 "readclause.cpp"
            $self_closing=0; //@line 2237 "readclause.cpp"
            var $75=$n_xml_buf; //@line 2238 "readclause.cpp"
            var $sub=((($75)-1)&4294967295); //@line 2238 "readclause.cpp"
            var $arrayidx158=(($xml_buf+$sub*4)&4294967295); //@line 2238 "readclause.cpp"
            var $76=HEAP32[(($arrayidx158)>>2)]; //@line 2238 "readclause.cpp"
            var $cmp159=((($76))|0)==47; //@line 2238 "readclause.cpp"
            if ($cmp159) { __label__ = 64;; } else { __label__ = 65;; } //@line 2238 "readclause.cpp"
            if (__label__ == 64) {
  
              var $77=$n_xml_buf; //@line 2241 "readclause.cpp"
              var $sub161=((($77)-1)&4294967295); //@line 2241 "readclause.cpp"
              var $arrayidx162=(($xml_buf+$sub161*4)&4294967295); //@line 2241 "readclause.cpp"
              HEAP32[(($arrayidx162)>>2)]=32; //@line 2241 "readclause.cpp"
              $self_closing=1; //@line 2242 "readclause.cpp"
              ; //@line 2243 "readclause.cpp"
            }
  
            var $78=$buf_addr; //@line 2245 "readclause.cpp"
            var $79=$n_buf_addr; //@line 2245 "readclause.cpp"
            var $80=$self_closing; //@line 2245 "readclause.cpp"
            var $call165=__ZL14ProcessSsmlTagPwPcRiii($arraydecay164, $78, $ix, $79, $80); //@line 2245 "readclause.cpp"
            $terminator=$call165; //@line 2245 "readclause.cpp"
            var $cmp166=((($call165))|0)!=0; //@line 2247 "readclause.cpp"
            if ($cmp166) { __label__ = 66;break $while_cond$12; } //@line 2247 "readclause.cpp"
  
            HEAP32[(($c1)>>2)]=32; //@line 2261 "readclause.cpp"
            var $call179=__ZL4GetCv(); //@line 2262 "readclause.cpp"
            HEAP32[(($c2)>>2)]=$call179; //@line 2262 "readclause.cpp"
            __label__ = 8;continue $while_cond$12; //@line 2263 "readclause.cpp"
          }
        }
      } while(0);
  
      HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]=0; //@line 2267 "readclause.cpp"
      var $_b1=HEAPU8[(__ZL11ignore_text_b)];
      var $90=((($_b1))&1);
      var $tobool185=((($90))|0)!=0; //@line 2269 "readclause.cpp"
      if ($tobool185) { __label__ = 8;continue $while_cond$12; } //@line 2269 "readclause.cpp"
  
      var $91=HEAP32[(($c2)>>2)]; //@line 2272 "readclause.cpp"
      var $cmp188=((($91))|0)==10; //@line 2272 "readclause.cpp"
      var $92=HEAP32[((_option_linelength)>>2)]; //@line 2272 "readclause.cpp"
      var $cmp190=((($92))|0)==-1; //@line 2272 "readclause.cpp"
      var $or_cond11=($cmp188) & ($cmp190); //@line 2272 "readclause.cpp"
      var $93=HEAPU32[(($c1)>>2)]; //@line 2275 "readclause.cpp"
      if ($or_cond11) { __label__ = 74;break $while_cond$12; } //@line 2272 "readclause.cpp"
  
      var $cmp208=((($93))|0)==1; //@line 2291 "readclause.cpp"
      if ($cmp208) { __label__ = 80;; } else { __label__ = 79;; } //@line 2291 "readclause.cpp"
      $if_then212$$lor_lhs_false209$90: do { 
        if (__label__ == 79) {
  
          var $111=HEAP32[(($c1)>>2)]; //@line 2291 "readclause.cpp"
          var $112=HEAP8[(_ctrl_embedded)]; //@line 2291 "readclause.cpp"
          var $conv210=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 2291 "readclause.cpp"
          var $cmp211=((($111))|0)==((($conv210))|0); //@line 2291 "readclause.cpp"
          if ($cmp211) { __label__ = 80;break $if_then212$$lor_lhs_false209$90; } else { __label__ = 97;break $if_then212$$lor_lhs_false209$90; } //@line 2291 "readclause.cpp"
        }
      } while(0);
      $if_then212$$if_end267$92: do { 
        if (__label__ == 80) {
  
          var $113=HEAP32[(($c2)>>2)]; //@line 2294 "readclause.cpp"
          var $cmp213=((($113))|0)==86; //@line 2294 "readclause.cpp"
          if ($cmp213) { __label__ = 81;break $while_cond$12; } //@line 2294 "readclause.cpp"
  
          var $123=HEAP32[(($c2)>>2)]; //@line 2303 "readclause.cpp"
          var $cmp236=((($123))|0)==66; //@line 2303 "readclause.cpp"
          if (!($cmp236)) { __label__ = 97;break $if_then212$$if_end267$92; } //@line 2303 "readclause.cpp"
  
          var $124=HEAP32[(($ix)>>2)]; //@line 2307 "readclause.cpp"
          var $125=$buf_addr; //@line 2307 "readclause.cpp"
          var $arrayidx238=(($125+$124)&4294967295); //@line 2307 "readclause.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = ((__str41208)&4294967295);
          $dest$ = $arrayidx238;
          $stop$ = $src$ + 4;
          if (($dest$%4) == ($src$%4) && 4 > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 2307 "readclause.cpp"
          var $126=HEAP32[(($ix)>>2)]; //@line 2308 "readclause.cpp"
          var $add240=((($126)+3)&4294967295); //@line 2308 "readclause.cpp"
          HEAP32[(($ix)>>2)]=$add240; //@line 2308 "readclause.cpp"
          var $call241=__ZL4GetCv(); //@line 2310 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call241; //@line 2310 "readclause.cpp"
          var $cmp242=((($call241))|0)==48; //@line 2310 "readclause.cpp"
          if ($cmp242) { __label__ = 89;; } else { __label__ = 90;; } //@line 2310 "readclause.cpp"
          $if_then243$$if_else244$96: do { 
            if (__label__ == 89) {
  
              HEAP32[((_option_punctuation)>>2)]=0; //@line 2311 "readclause.cpp"
              ; //@line 2311 "readclause.cpp"
            }
            else if (__label__ == 90) {
  
              HEAP32[((_option_punctuation)>>2)]=1; //@line 2314 "readclause.cpp"
              HEAP32[((((_option_punctlist)&4294967295))>>2)]=0; //@line 2315 "readclause.cpp"
              var $127=HEAP32[(($c2)>>2)]; //@line 2316 "readclause.cpp"
              var $cmp245=((($127))|0)!=49; //@line 2316 "readclause.cpp"
              if (!($cmp245)) { __label__ = 96;break $if_then243$$if_else244$96; } //@line 2316 "readclause.cpp"
  
              $j=0; //@line 2319 "readclause.cpp"
              ; //@line 2320 "readclause.cpp"
              while(1) { 
  
                var $128=HEAP32[(($c2)>>2)]; //@line 2320 "readclause.cpp"
                var $call248=_iswspace($128); //@line 2320 "readclause.cpp"
                var $tobool249=((($call248))|0)!=0; //@line 2320 "readclause.cpp"
                if ($tobool249) { __label__ = 95;break ; } //@line 2320 "readclause.cpp"
  
                var $call251=__Z3Eofv(); //@line 2320 "readclause.cpp"
                var $tobool252=((($call251))|0)!=0; //@line 2320 "readclause.cpp"
                var $lnot=($tobool252) ^ 1; //@line 2320 "readclause.cpp"
                if (!($lnot)) { __label__ = 95;break ; }
  
                var $129=HEAP32[(($c2)>>2)]; //@line 2322 "readclause.cpp"
                var $130=$j; //@line 2322 "readclause.cpp"
                var $inc255=((($130)+1)&4294967295); //@line 2322 "readclause.cpp"
                $j=$inc255; //@line 2322 "readclause.cpp"
                var $arrayidx256=((_option_punctlist+$130*4)&4294967295); //@line 2322 "readclause.cpp"
                HEAP32[(($arrayidx256)>>2)]=$129; //@line 2322 "readclause.cpp"
                var $call257=__ZL4GetCv(); //@line 2323 "readclause.cpp"
                HEAP32[(($c2)>>2)]=$call257; //@line 2323 "readclause.cpp"
                var $131=HEAP32[(($ix)>>2)]; //@line 2324 "readclause.cpp"
                var $inc258=((($131)+1)&4294967295); //@line 2324 "readclause.cpp"
                HEAP32[(($ix)>>2)]=$inc258; //@line 2324 "readclause.cpp"
                var $132=$buf_addr; //@line 2324 "readclause.cpp"
                var $arrayidx259=(($132+$131)&4294967295); //@line 2324 "readclause.cpp"
                HEAP8[($arrayidx259)]=32; //@line 2324 "readclause.cpp"
                __label__ = 92;continue ; //@line 2325 "readclause.cpp"
              }
  
              var $133=$j; //@line 2326 "readclause.cpp"
              var $arrayidx261=((_option_punctlist+$133*4)&4294967295); //@line 2326 "readclause.cpp"
              HEAP32[(($arrayidx261)>>2)]=0; //@line 2326 "readclause.cpp"
              HEAP32[((_option_punctuation)>>2)]=2; //@line 2327 "readclause.cpp"
              ; //@line 2328 "readclause.cpp"
            }
          } while(0);
  
          var $call264=__ZL4GetCv(); //@line 2330 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call264; //@line 2330 "readclause.cpp"
          __label__ = 8;continue $while_cond$12; //@line 2331 "readclause.cpp"
        }
      } while(0);
  
      var $134=$linelength; //@line 2335 "readclause.cpp"
      var $inc268=((($134)+1)&4294967295); //@line 2335 "readclause.cpp"
      $linelength=$inc268; //@line 2335 "readclause.cpp"
      var $135=HEAP32[(($c1)>>2)]; //@line 2337 "readclause.cpp"
      var $call269=_iswalnum($135); //@line 2337 "readclause.cpp"
      var $tobool270=((($call269))|0)!=0; //@line 2337 "readclause.cpp"
      if ($tobool270) { __label__ = 98;; } else { __label__ = 99;; } //@line 2337 "readclause.cpp"
      $if_then271$$if_else272$107: do { 
        if (__label__ == 98) {
  
          $any_alnum=1; //@line 2338 "readclause.cpp"
          ; //@line 2338 "readclause.cpp"
        }
        else if (__label__ == 99) {
  
          var $136=$stressed_word; //@line 2341 "readclause.cpp"
          var $tobool273=((($136))|0)!=0; //@line 2341 "readclause.cpp"
          if ($tobool273) { __label__ = 100;; } else { __label__ = 101;; } //@line 2341 "readclause.cpp"
          if (__label__ == 100) {
  
            $stressed_word=0; //@line 2343 "readclause.cpp"
            HEAP32[(($c1)>>2)]=1328; //@line 2344 "readclause.cpp"
            var $137=HEAP32[(($c2)>>2)]; //@line 2345 "readclause.cpp"
            __ZL6UngetCi($137); //@line 2345 "readclause.cpp"
            HEAP32[(($c2)>>2)]=32; //@line 2346 "readclause.cpp"
            ; //@line 2347 "readclause.cpp"
          }
  
          var $138=HEAP32[(($c1)>>2)]; //@line 2349 "readclause.cpp"
          var $call276=__Z11lookupwcharPKti(((__ZL12chars_ignore)&4294967295), $138); //@line 2349 "readclause.cpp"
          var $tobool277=((($call276))|0)!=0; //@line 2349 "readclause.cpp"
          if ($tobool277) { __label__ = 8;continue $while_cond$12; } //@line 2349 "readclause.cpp"
  
          var $139=HEAP32[(($c1)>>2)]; //@line 2355 "readclause.cpp"
          var $call280=_iswspace($139); //@line 2355 "readclause.cpp"
          var $tobool281=((($call280))|0)!=0; //@line 2355 "readclause.cpp"
          if ($tobool281) { __label__ = 103;; } else { __label__ = 109;; } //@line 2355 "readclause.cpp"
          $if_then282$$if_end304$114: do { 
            if (__label__ == 103) {
  
              var $140=$tr_addr; //@line 2359 "readclause.cpp"
              var $translator_name=(($140+280)&4294967295); //@line 2359 "readclause.cpp"
              var $141=HEAP32[(($translator_name)>>2)]; //@line 2359 "readclause.cpp"
              var $cmp283=((($141))|0)==6972015; //@line 2359 "readclause.cpp"
              if (!($cmp283)) { __label__ = 109;break $if_then282$$if_end304$114; } //@line 2359 "readclause.cpp"
  
              var $142=HEAP32[(($ix)>>2)]; //@line 2363 "readclause.cpp"
              var $sub285=((($142)-1)&4294967295); //@line 2363 "readclause.cpp"
              var $143=$buf_addr; //@line 2363 "readclause.cpp"
              var $arrayidx286=(($143+$sub285)&4294967295); //@line 2363 "readclause.cpp"
              $p_word=$arrayidx286; //@line 2363 "readclause.cpp"
              var $144=$p_word; //@line 2364 "readclause.cpp"
              var $arrayidx287=(($144)&4294967295); //@line 2364 "readclause.cpp"
              var $145=HEAP8[($arrayidx287)]; //@line 2364 "readclause.cpp"
              var $conv288=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 2364 "readclause.cpp"
              var $cmp289=((($conv288))|0)==105; //@line 2364 "readclause.cpp"
              if (!($cmp289)) { __label__ = 109;break $if_then282$$if_end304$114; } //@line 2364 "readclause.cpp"
  
              var $146=$p_word; //@line 2366 "readclause.cpp"
              var $arrayidx291=(($146+-1)&4294967295); //@line 2366 "readclause.cpp"
              var $147=HEAP8[($arrayidx291)]; //@line 2366 "readclause.cpp"
              var $conv292=(tempInt=(($147)),(tempInt>=128?tempInt-256:tempInt)); //@line 2366 "readclause.cpp"
              var $cmp293=((($conv292))|0)==46; //@line 2366 "readclause.cpp"
              if ($cmp293) { __label__ = 106;; } else { __label__ = 107;; } //@line 2366 "readclause.cpp"
              if (__label__ == 106) {
  
                var $148=$p_word; //@line 2367 "readclause.cpp"
                var $incdec_ptr=(($148+-1)&4294967295); //@line 2367 "readclause.cpp"
                $p_word=$incdec_ptr; //@line 2367 "readclause.cpp"
                ; //@line 2367 "readclause.cpp"
              }
  
              var $149=$p_word; //@line 2368 "readclause.cpp"
              var $arrayidx296=(($149+-1)&4294967295); //@line 2368 "readclause.cpp"
              var $150=HEAP8[($arrayidx296)]; //@line 2368 "readclause.cpp"
              var $conv297=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 2368 "readclause.cpp"
              var $cmp298=((($conv297))|0)==32; //@line 2368 "readclause.cpp"
              if ($cmp298) { __label__ = 108;break $while_cond$12; } //@line 2368 "readclause.cpp"
            }
          } while(0);
  
          var $153=HEAP32[(($c1)>>2)]; //@line 2379 "readclause.cpp"
          var $cmp305=((($153))|0)==3405; //@line 2379 "readclause.cpp"
          if (!($cmp305)) { __label__ = 112;break $if_then271$$if_else272$107; } //@line 2379 "readclause.cpp"
  
          var $154=HEAP32[(($c2)>>2)]; //@line 2382 "readclause.cpp"
          var $cmp307=((($154))|0)==8205; //@line 2382 "readclause.cpp"
          if (!($cmp307)) { __label__ = 112;break $if_then271$$if_else272$107; } //@line 2382 "readclause.cpp"
  
          HEAP32[(($c1)>>2)]=3406; //@line 2384 "readclause.cpp"
          ; //@line 2385 "readclause.cpp"
        }
      } while(0);
  
      var $155=HEAP32[(($c1)>>2)]; //@line 2389 "readclause.cpp"
      var $call312=_iswupper($155); //@line 2389 "readclause.cpp"
      var $tobool313=((($call312))|0)!=0; //@line 2389 "readclause.cpp"
      if ($tobool313) { __label__ = 113;; } else { __label__ = 118;; } //@line 2389 "readclause.cpp"
      $if_then314$$if_else343$125: do { 
        if (__label__ == 113) {
  
          var $156=$tr_addr; //@line 2391 "readclause.cpp"
          var $clause_upper_count315=(($156+8304)&4294967295); //@line 2391 "readclause.cpp"
          var $157=HEAP32[(($clause_upper_count315)>>2)]; //@line 2391 "readclause.cpp"
          var $inc316=((($157)+1)&4294967295); //@line 2391 "readclause.cpp"
          HEAP32[(($clause_upper_count315)>>2)]=$inc316; //@line 2391 "readclause.cpp"
          var $158=HEAP32[((_option_capitals)>>2)]; //@line 2392 "readclause.cpp"
          var $cmp317=((($158))|0)==2; //@line 2392 "readclause.cpp"
          var $159=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2392 "readclause.cpp"
          var $cmp319=((($159))|0)==0; //@line 2392 "readclause.cpp"
          var $or_cond13=($cmp317) & ($cmp319); //@line 2392 "readclause.cpp"
          if (!($or_cond13)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2392 "readclause.cpp"
  
          var $160=$cprev; //@line 2392 "readclause.cpp"
          var $call321=_iswupper($160); //@line 2392 "readclause.cpp"
          var $tobool322=((($call321))|0)!=0; //@line 2392 "readclause.cpp"
          if ($tobool322) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2392 "readclause.cpp"
  
          var $161=$tr_addr; //@line 2396 "readclause.cpp"
          var $call325=__ZL13LookupSpecialP10TranslatorPKcPc($161, $arraydecay324); //@line 2396 "readclause.cpp"
          var $cmp326=((($call325))|0)!=0; //@line 2396 "readclause.cpp"
          if (!($cmp326)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2396 "readclause.cpp"
  
          var $strlen=_strlen($arraydecay329); //@line 2398 "readclause.cpp"
          var $leninc=((($strlen)+1)&4294967295); //@line 2398 "readclause.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = $arraydecay329;
          $dest$ = $arraydecay328;
          $stop$ = $src$ + $leninc;
          if (($dest$%4) == ($src$%4) && $leninc > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 2398 "readclause.cpp"
          var $call332=_strlen($arraydecay331); //@line 2399 "readclause.cpp"
          $j=$call332; //@line 2399 "readclause.cpp"
          var $162=HEAP32[(($ix)>>2)]; //@line 2400 "readclause.cpp"
          var $163=$j; //@line 2400 "readclause.cpp"
          var $add333=((($163)+($162))&4294967295); //@line 2400 "readclause.cpp"
          var $164=$n_buf_addr; //@line 2400 "readclause.cpp"
          var $cmp334=((($add333))|0) < ((($164))|0); //@line 2400 "readclause.cpp"
          if (!($cmp334)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2400 "readclause.cpp"
  
          var $165=HEAP32[(($ix)>>2)]; //@line 2402 "readclause.cpp"
          var $166=$buf_addr; //@line 2402 "readclause.cpp"
          var $arrayidx336=(($166+$165)&4294967295); //@line 2402 "readclause.cpp"
          var $call338=_strcpy($arrayidx336, $arraydecay337); //@line 2402 "readclause.cpp"
          var $167=$j; //@line 2403 "readclause.cpp"
          var $168=HEAP32[(($ix)>>2)]; //@line 2403 "readclause.cpp"
          var $add339=((($168)+($167))&4294967295); //@line 2403 "readclause.cpp"
          HEAP32[(($ix)>>2)]=$add339; //@line 2403 "readclause.cpp"
          ; //@line 2404 "readclause.cpp"
        }
        else if (__label__ == 118) {
  
          var $169=HEAP32[(($c1)>>2)]; //@line 2409 "readclause.cpp"
          var $call344=_iswalpha($169); //@line 2409 "readclause.cpp"
          var $tobool345=((($call344))|0)!=0; //@line 2409 "readclause.cpp"
          if (!($tobool345)) { __label__ = 120;break $if_then314$$if_else343$125; } //@line 2409 "readclause.cpp"
  
          var $170=$tr_addr; //@line 2410 "readclause.cpp"
          var $clause_lower_count347=(($170+8308)&4294967295); //@line 2410 "readclause.cpp"
          var $171=HEAP32[(($clause_lower_count347)>>2)]; //@line 2410 "readclause.cpp"
          var $inc348=((($171)+1)&4294967295); //@line 2410 "readclause.cpp"
          HEAP32[(($clause_lower_count347)>>2)]=$inc348; //@line 2410 "readclause.cpp"
          ; //@line 2410 "readclause.cpp"
        }
      } while(0);
  
      var $172=HEAP32[((_option_phoneme_input)>>2)]; //@line 2412 "readclause.cpp"
      var $tobool351=((($172))|0)!=0; //@line 2412 "readclause.cpp"
      if ($tobool351) { __label__ = 121;; } else { __label__ = 130;; } //@line 2412 "readclause.cpp"
      $if_then352$$if_end368$134: do { 
        if (__label__ == 121) {
  
          var $173=$phoneme_mode; //@line 2414 "readclause.cpp"
          var $cmp353=((($173))|0) > 0; //@line 2414 "readclause.cpp"
          if ($cmp353) { __label__ = 122;; } else { __label__ = 123;; } //@line 2414 "readclause.cpp"
          if (__label__ == 122) {
  
            var $174=$phoneme_mode; //@line 2415 "readclause.cpp"
            var $dec=((($174)-1)&4294967295); //@line 2415 "readclause.cpp"
            $phoneme_mode=$dec; //@line 2415 "readclause.cpp"
            ; //@line 2415 "readclause.cpp"
          }
          else if (__label__ == 123) {
  
            var $175=HEAP32[(($c1)>>2)]; //@line 2417 "readclause.cpp"
            var $cmp356=((($175))|0)==91; //@line 2417 "readclause.cpp"
            if ($cmp356) { __lastLabel__ = 123; __label__ = 124;; } else { __lastLabel__ = 123; __label__ = 127;; } //@line 2417 "readclause.cpp"
            if (__label__ == 124) {
  
              var $176=HEAP32[(($c2)>>2)]; //@line 2417 "readclause.cpp"
              var $cmp358=((($176))|0)==91; //@line 2417 "readclause.cpp"
              if ($cmp358) { __label__ = 125;; } else { __label__ = 126;; } //@line 2417 "readclause.cpp"
              if (__label__ == 125) {
  
                $phoneme_mode=-1; //@line 2418 "readclause.cpp"
                __label__ = 130;break $if_then352$$if_end368$134; //@line 2418 "readclause.cpp"
              }
              else if (__label__ == 126) {
  
                var $_pr25=HEAP32[(($c1)>>2)]; //@line 2420 "readclause.cpp"
                __lastLabel__ = 126; ;
              }
            }
  
            var $177=__lastLabel__ == 126 ? $_pr25 : ($175); //@line 2420 "readclause.cpp"
            var $cmp361=((($177))|0)==93; //@line 2420 "readclause.cpp"
            if (!($cmp361)) { __label__ = 130;break $if_then352$$if_end368$134; } //@line 2420 "readclause.cpp"
  
            var $178=HEAP32[(($c2)>>2)]; //@line 2420 "readclause.cpp"
            var $cmp363=((($178))|0)==93; //@line 2420 "readclause.cpp"
            if (!($cmp363)) { __label__ = 130;break $if_then352$$if_end368$134; } //@line 2420 "readclause.cpp"
  
            $phoneme_mode=2; //@line 2421 "readclause.cpp"
            ; //@line 2421 "readclause.cpp"
          }
        }
      } while(0);
  
      var $179=HEAP32[(($c1)>>2)]; //@line 2424 "readclause.cpp"
      var $cmp369=((($179))|0)==10; //@line 2424 "readclause.cpp"
      if ($cmp369) { __label__ = 131;; } else { __label__ = 148;; } //@line 2424 "readclause.cpp"
      if (__label__ == 131) {
  
        $parag=0; //@line 2426 "readclause.cpp"
        ; //@line 2429 "readclause.cpp"
        while(1) { 
  
          var $call372=__Z3Eofv(); //@line 2429 "readclause.cpp"
          var $tobool373=((($call372))|0)!=0; //@line 2429 "readclause.cpp"
          if ($tobool373) { __label__ = 137;break ; } //@line 2429 "readclause.cpp"
  
          var $180=HEAP32[(($c2)>>2)]; //@line 2429 "readclause.cpp"
          var $call375=_iswspace($180); //@line 2429 "readclause.cpp"
          var $tobool376=((($call375))|0)!=0; //@line 2429 "readclause.cpp"
          if (!($tobool376)) { __label__ = 137;break ; }
  
          var $181=HEAP32[(($c2)>>2)]; //@line 2431 "readclause.cpp"
          var $cmp379=((($181))|0)==10; //@line 2431 "readclause.cpp"
          if ($cmp379) { __label__ = 135;; } else { __label__ = 136;; } //@line 2431 "readclause.cpp"
          if (__label__ == 135) {
  
            var $182=$parag; //@line 2432 "readclause.cpp"
            var $inc381=((($182)+1)&4294967295); //@line 2432 "readclause.cpp"
            $parag=$inc381; //@line 2432 "readclause.cpp"
            ; //@line 2432 "readclause.cpp"
          }
  
          var $call383=__ZL4GetCv(); //@line 2433 "readclause.cpp"
          HEAP32[(($c2)>>2)]=$call383; //@line 2433 "readclause.cpp"
          __label__ = 132;continue ; //@line 2434 "readclause.cpp"
        }
  
        var $183=$parag; //@line 2435 "readclause.cpp"
        var $cmp385=((($183))|0) > 0; //@line 2435 "readclause.cpp"
        if ($cmp385) { __label__ = 138;break $while_cond$12; } //@line 2435 "readclause.cpp"
  
        var $195=$linelength; //@line 2452 "readclause.cpp"
        var $196=HEAP32[((_option_linelength)>>2)]; //@line 2452 "readclause.cpp"
        var $cmp402=((($195))|0) <= ((($196))|0); //@line 2452 "readclause.cpp"
        if ($cmp402) { __label__ = 146;break $while_cond$12; } //@line 2452 "readclause.cpp"
  
        $linelength=0; //@line 2461 "readclause.cpp"
        ; //@line 2462 "readclause.cpp"
      }
  
      var $202=$announced_punctuation; //@line 2464 "readclause.cpp"
      $prev_announced_punctuation=$202; //@line 2464 "readclause.cpp"
      $announced_punctuation=0; //@line 2465 "readclause.cpp"
      var $203=$phoneme_mode; //@line 2467 "readclause.cpp"
      var $cmp409=((($203))|0)==0; //@line 2467 "readclause.cpp"
      var $204=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 2467 "readclause.cpp"
      var $cmp411=((($204))|0)==0; //@line 2467 "readclause.cpp"
      var $or_cond14=($cmp409) & ($cmp411); //@line 2467 "readclause.cpp"
      if ($or_cond14) { __label__ = 149;; } else { __label__ = 238;; } //@line 2467 "readclause.cpp"
      $if_then412$$if_end643$161: do { 
        if (__label__ == 149) {
  
          $is_end_clause=0; //@line 2469 "readclause.cpp"
          var $205=$end_clause_after_tag; //@line 2471 "readclause.cpp"
          var $tobool413=((($205))|0)!=0; //@line 2471 "readclause.cpp"
          if ($tobool413) { __label__ = 150;; } else { __label__ = 155;; } //@line 2471 "readclause.cpp"
          $if_then414$$if_end429$163: do { 
            if (__label__ == 150) {
  
              var $206=HEAP32[(($c1)>>2)]; //@line 2477 "readclause.cpp"
              var $call415=_iswspace($206); //@line 2477 "readclause.cpp"
              var $tobool416=((($call415))|0)!=0; //@line 2477 "readclause.cpp"
              if ($tobool416) { __label__ = 155;break $if_then414$$if_end429$163; } //@line 2477 "readclause.cpp"
  
              var $207=HEAP32[(($c1)>>2)]; //@line 2479 "readclause.cpp"
              var $call418=__Z7IsAlphaj($207); //@line 2479 "readclause.cpp"
              var $tobool419=((($call418))|0)!=0; //@line 2479 "readclause.cpp"
              if (!($tobool419)) { __label__ = 153;break $while_cond$12; } //@line 2479 "readclause.cpp"
  
              var $208=HEAP32[(($c1)>>2)]; //@line 2479 "readclause.cpp"
              var $call421=_iswlower($208); //@line 2479 "readclause.cpp"
              var $tobool422=((($call421))|0)!=0; //@line 2479 "readclause.cpp"
              if (!($tobool422)) { __label__ = 153;break $while_cond$12; } //@line 2479 "readclause.cpp"
  
              $end_clause_after_tag=0; //@line 2488 "readclause.cpp"
              ; //@line 2489 "readclause.cpp"
            }
          } while(0);
  
          var $216=HEAP32[(($c1)>>2)]; //@line 2492 "readclause.cpp"
          var $cmp430=((($216))|0)==46; //@line 2492 "readclause.cpp"
          if ($cmp430) { __label__ = 156;; } else { __label__ = 162;; } //@line 2492 "readclause.cpp"
          $land_lhs_true431$$if_end443$169: do { 
            if (__label__ == 156) {
  
              var $217=HEAP32[(($c2)>>2)]; //@line 2492 "readclause.cpp"
              var $cmp432=((($217))|0)==46; //@line 2492 "readclause.cpp"
              if (!($cmp432)) { __label__ = 162;break $land_lhs_true431$$if_end443$169; } //@line 2492 "readclause.cpp"
  
              var $call43538=__ZL4GetCv(); //@line 2494 "readclause.cpp"
              $c_next=$call43538; //@line 2494 "readclause.cpp"
              var $cmp43639=((($call43538))|0)==46; //@line 2494 "readclause.cpp"
              if ($cmp43639) { __label__ = 158;; } else { __label__ = 159;; } //@line 2494 "readclause.cpp"
              $while_body437$$while_end438$172: do { 
                if (__label__ == 158) {
                  while(1) { 
  
                    HEAP32[(($c1)>>2)]=8230; //@line 2497 "readclause.cpp"
                    HEAP32[(($c2)>>2)]=32; //@line 2498 "readclause.cpp"
                    var $call435=__ZL4GetCv(); //@line 2494 "readclause.cpp"
                    $c_next=$call435; //@line 2494 "readclause.cpp"
                    var $cmp436=((($call435))|0)==46; //@line 2494 "readclause.cpp"
                    if ($cmp436) { __label__ = 158;continue ; } else { __label__ = 159;break $while_body437$$while_end438$172; } //@line 2494 "readclause.cpp"
                  }
                }
              } while(0);
  
              var $218=HEAP32[(($c1)>>2)]; //@line 2500 "readclause.cpp"
              var $cmp439=((($218))|0)==8230; //@line 2500 "readclause.cpp"
              var $219=$c_next; //@line 2501 "readclause.cpp"
              if ($cmp439) { __label__ = 160;; } else { __label__ = 161;; } //@line 2500 "readclause.cpp"
              if (__label__ == 160) {
  
                HEAP32[(($c2)>>2)]=$219; //@line 2501 "readclause.cpp"
                ; //@line 2501 "readclause.cpp"
              }
              else if (__label__ == 161) {
  
                __ZL6UngetCi($219); //@line 2503 "readclause.cpp"
                ;
              }
            }
          } while(0);
  
          $punct_data=0; //@line 2506 "readclause.cpp"
          var $220=HEAP32[(($c1)>>2)]; //@line 2507 "readclause.cpp"
          var $call444=__Z11lookupwcharPKti(((__ZL11punct_chars)&4294967295), $220); //@line 2507 "readclause.cpp"
          $punct=$call444; //@line 2507 "readclause.cpp"
          var $cmp445=((($call444))|0)!=0; //@line 2507 "readclause.cpp"
          if ($cmp445) { __label__ = 163;; } else { __label__ = 171;; } //@line 2507 "readclause.cpp"
          $if_then446$$if_end471$180: do { 
            if (__label__ == 163) {
  
              var $221=$punct; //@line 2509 "readclause.cpp"
              var $arrayidx447=((__ZL16punct_attributes+$221*4)&4294967295); //@line 2509 "readclause.cpp"
              var $222=HEAP32[(($arrayidx447)>>2)]; //@line 2509 "readclause.cpp"
              $punct_data=$222; //@line 2509 "readclause.cpp"
              var $223=$punct_data; //@line 2511 "readclause.cpp"
              var $and448=($223) & 1048576; //@line 2511 "readclause.cpp"
              var $tobool449=((($and448))|0)!=0; //@line 2511 "readclause.cpp"
              if ($tobool449) { __label__ = 164;; } else { __label__ = 165;; } //@line 2511 "readclause.cpp"
              if (__label__ == 164) {
  
                $stressed_word=1; //@line 2514 "readclause.cpp"
                var $224=$punct_data; //@line 2515 "readclause.cpp"
                var $shr=($224) >> 12; //@line 2515 "readclause.cpp"
                var $and451=($shr) & 15; //@line 2515 "readclause.cpp"
                var $225=$tone_type_addr; //@line 2515 "readclause.cpp"
                HEAP32[(($225)>>2)]=$and451; //@line 2515 "readclause.cpp"
                __label__ = 8;continue $while_cond$12; //@line 2516 "readclause.cpp"
              }
              else if (__label__ == 165) {
  
                var $226=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                var $call453=_iswspace($226); //@line 2519 "readclause.cpp"
                var $tobool454=((($call453))|0)!=0; //@line 2519 "readclause.cpp"
                if ($tobool454) { __label__ = 170;; } else { __label__ = 166;; } //@line 2519 "readclause.cpp"
                $if_then469$$lor_lhs_false455$185: do { 
                  if (__label__ == 166) {
  
                    var $227=$punct_data; //@line 2519 "readclause.cpp"
                    var $and456=($227) & 32768; //@line 2519 "readclause.cpp"
                    var $tobool457=((($and456))|0)!=0; //@line 2519 "readclause.cpp"
                    if ($tobool457) { __label__ = 170;break $if_then469$$lor_lhs_false455$185; } //@line 2519 "readclause.cpp"
  
                    var $228=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                    var $call459=__Z9IsBracketi($228); //@line 2519 "readclause.cpp"
                    var $tobool460=((($call459))|0)!=0; //@line 2519 "readclause.cpp"
                    var $229=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                    var $cmp462=((($229))|0)==63; //@line 2519 "readclause.cpp"
                    var $or_cond15=($tobool460) | ($cmp462); //@line 2519 "readclause.cpp"
                    if ($or_cond15) { __label__ = 170;break $if_then469$$lor_lhs_false455$185; } //@line 2519 "readclause.cpp"
  
                    var $call464=__Z3Eofv(); //@line 2519 "readclause.cpp"
                    var $tobool465=((($call464))|0)!=0; //@line 2519 "readclause.cpp"
                    if ($tobool465) { __label__ = 170;break $if_then469$$lor_lhs_false455$185; } //@line 2519 "readclause.cpp"
  
                    var $230=HEAP32[(($c2)>>2)]; //@line 2519 "readclause.cpp"
                    var $231=HEAP8[(_ctrl_embedded)]; //@line 2519 "readclause.cpp"
                    var $conv467=(tempInt=(($231)),(tempInt>=128?tempInt-256:tempInt)); //@line 2519 "readclause.cpp"
                    var $cmp468=((($230))|0)==((($conv467))|0); //@line 2519 "readclause.cpp"
                    if (!($cmp468)) { __label__ = 171;break $if_then446$$if_end471$180; } //@line 2519 "readclause.cpp"
                  }
                } while(0);
  
                $is_end_clause=1; //@line 2523 "readclause.cpp"
                ; //@line 2524 "readclause.cpp"
              }
            }
          } while(0);
  
          var $232=HEAP32[(($c1)>>2)]; //@line 2528 "readclause.cpp"
          var $cmp472=((($232))|0)==57404; //@line 2528 "readclause.cpp"
          if ($cmp472) { __label__ = 172;; } else { __label__ = 173;; } //@line 2528 "readclause.cpp"
          if (__label__ == 172) {
  
            HEAP32[(($c1)>>2)]=60; //@line 2528 "readclause.cpp"
            ; //@line 2528 "readclause.cpp"
          }
  
          var $233=HEAP32[((_option_punctuation)>>2)]; //@line 2529 "readclause.cpp"
          var $tobool475=((($233))|0)!=0; //@line 2529 "readclause.cpp"
          if ($tobool475) { __label__ = 174;; } else { __label__ = 181;; } //@line 2529 "readclause.cpp"
          $land_lhs_true476$$if_end493$195: do { 
            if (__label__ == 174) {
  
              var $234=HEAP32[(($c1)>>2)]; //@line 2529 "readclause.cpp"
              var $call477=_iswpunct($234); //@line 2529 "readclause.cpp"
              var $tobool478=((($call477))|0)!=0; //@line 2529 "readclause.cpp"
              if (!($tobool478)) { __label__ = 181;break $land_lhs_true476$$if_end493$195; } //@line 2529 "readclause.cpp"
  
              var $_b2=HEAPU8[(__ZL10audio_text_b)];
              var $235=((($_b2))&1);
              var $cmp480=((($235))|0)==0; //@line 2529 "readclause.cpp"
              if (!($cmp480)) { __label__ = 181;break $land_lhs_true476$$if_end493$195; } //@line 2529 "readclause.cpp"
  
              var $236=HEAP32[((_option_punctuation)>>2)]; //@line 2533 "readclause.cpp"
              var $cmp482=((($236))|0)==1; //@line 2533 "readclause.cpp"
              if ($cmp482) { __label__ = 178;; } else { __label__ = 177;; } //@line 2533 "readclause.cpp"
              if (__label__ == 177) {
  
                var $237=HEAP32[(($c1)>>2)]; //@line 2533 "readclause.cpp"
                var $call484=_wcschr(((_option_punctlist)&4294967295), $237); //@line 2533 "readclause.cpp"
                var $cmp485=((($call484))|0)!=0; //@line 2533 "readclause.cpp"
                if (!($cmp485)) { __label__ = 181;break $land_lhs_true476$$if_end493$195; } //@line 2533 "readclause.cpp"
              }
  
              var $238=$tr_addr; //@line 2535 "readclause.cpp"
              var $phonemes_repeat_count487=(($238+652)&4294967295); //@line 2535 "readclause.cpp"
              HEAP32[(($phonemes_repeat_count487)>>2)]=0; //@line 2535 "readclause.cpp"
              var $239=$tr_addr; //@line 2536 "readclause.cpp"
              var $240=HEAP32[(($c1)>>2)]; //@line 2536 "readclause.cpp"
              var $241=$buf_addr; //@line 2536 "readclause.cpp"
              var $242=$is_end_clause; //@line 2536 "readclause.cpp"
              var $call488=__ZL19AnnouncePunctuationP10TranslatoriPiPcS1_i($239, $240, $c2, $241, $ix, $242); //@line 2536 "readclause.cpp"
              $terminator=$call488; //@line 2536 "readclause.cpp"
              var $cmp489=((($call488))|0) >= 0; //@line 2536 "readclause.cpp"
              if ($cmp489) { __label__ = 179;break $while_cond$12; } //@line 2536 "readclause.cpp"
  
              var $244=HEAP32[(($c1)>>2)]; //@line 2538 "readclause.cpp"
              $announced_punctuation=$244; //@line 2538 "readclause.cpp"
              ; //@line 2539 "readclause.cpp"
            }
          } while(0);
  
          var $245=$punct_data; //@line 2542 "readclause.cpp"
          var $and494=($245) & 2097152; //@line 2542 "readclause.cpp"
          var $tobool495=((($and494))|0)!=0; //@line 2542 "readclause.cpp"
          if ($tobool495) { __label__ = 182;; } else { __label__ = 185;; } //@line 2542 "readclause.cpp"
          $land_lhs_true496$$if_end510$204: do { 
            if (__label__ == 182) {
  
              var $246=$announced_punctuation; //@line 2542 "readclause.cpp"
              var $cmp497=((($246))|0)==0; //@line 2542 "readclause.cpp"
              if (!($cmp497)) { __label__ = 185;break $land_lhs_true496$$if_end510$204; } //@line 2542 "readclause.cpp"
  
              var $247=HEAP32[(($ix)>>2)]; //@line 2547 "readclause.cpp"
              var $248=$buf_addr; //@line 2547 "readclause.cpp"
              var $arrayidx499=(($248+$247)&4294967295); //@line 2547 "readclause.cpp"
              $p2=$arrayidx499; //@line 2547 "readclause.cpp"
              var $249=$p2; //@line 2548 "readclause.cpp"
              var $250=$tr_addr; //@line 2548 "readclause.cpp"
              var $251=HEAP32[(($c1)>>2)]; //@line 2548 "readclause.cpp"
              __ZL14LookupCharNameP10Translatorii($250, $251, 1); //@line 2548 "readclause.cpp"
              var $strlen20=_strlen(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295)); //@line 2548 "readclause.cpp"
              var $leninc21=((($strlen20)+1)&4294967295); //@line 2548 "readclause.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = ((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295);
              $dest$ = $249;
              $stop$ = $src$ + $leninc21;
              if (($dest$%4) == ($src$%4) && $leninc21 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 2548 "readclause.cpp"
              var $252=$p2; //@line 2549 "readclause.cpp"
              var $arrayidx502=(($252)&4294967295); //@line 2549 "readclause.cpp"
              var $253=HEAP8[($arrayidx502)]; //@line 2549 "readclause.cpp"
              var $conv503=(tempInt=(($253)),(tempInt>=128?tempInt-256:tempInt)); //@line 2549 "readclause.cpp"
              var $cmp504=((($conv503))|0)!=0; //@line 2549 "readclause.cpp"
              if (!($cmp504)) { __label__ = 185;break $land_lhs_true496$$if_end510$204; } //@line 2549 "readclause.cpp"
  
              var $254=$p2; //@line 2551 "readclause.cpp"
              var $call506=_strlen($254); //@line 2551 "readclause.cpp"
              var $255=HEAP32[(($ix)>>2)]; //@line 2551 "readclause.cpp"
              var $add507=((($255)+($call506))&4294967295); //@line 2551 "readclause.cpp"
              HEAP32[(($ix)>>2)]=$add507; //@line 2551 "readclause.cpp"
              var $256=HEAP32[(($c1)>>2)]; //@line 2552 "readclause.cpp"
              $announced_punctuation=$256; //@line 2552 "readclause.cpp"
              var $257=$punct_data; //@line 2553 "readclause.cpp"
              var $and508=($257) & -28673; //@line 2553 "readclause.cpp"
              $punct_data=$and508; //@line 2553 "readclause.cpp"
              ; //@line 2554 "readclause.cpp"
            }
          } while(0);
  
          var $258=$is_end_clause; //@line 2557 "readclause.cpp"
          var $tobool511=((($258))|0)!=0; //@line 2557 "readclause.cpp"
          if (!($tobool511)) { __label__ = 238;break $if_then412$$if_end643$161; } //@line 2557 "readclause.cpp"
  
          $nl_count=0; //@line 2559 "readclause.cpp"
          var $259=HEAP32[(($c2)>>2)]; //@line 2560 "readclause.cpp"
          $c_next=$259; //@line 2560 "readclause.cpp"
          var $260=$c_next; //@line 2562 "readclause.cpp"
          var $call513=_iswspace($260); //@line 2562 "readclause.cpp"
          var $tobool514=((($call513))|0)!=0; //@line 2562 "readclause.cpp"
          if ($tobool514) { __label__ = 187;; } else { __label__ = 192;; } //@line 2562 "readclause.cpp"
          $while_cond516$$if_end530$210: do { 
            if (__label__ == 187) {
              while(1) { 
  
                var $call517=__Z3Eofv(); //@line 2564 "readclause.cpp"
                var $tobool518=((($call517))|0)!=0; //@line 2564 "readclause.cpp"
                if ($tobool518) { __label__ = 192;break $while_cond516$$if_end530$210; } //@line 2564 "readclause.cpp"
  
                var $261=$c_next; //@line 2564 "readclause.cpp"
                var $call520=_iswspace($261); //@line 2564 "readclause.cpp"
                var $tobool521=((($call520))|0)!=0; //@line 2564 "readclause.cpp"
                if (!($tobool521)) { __label__ = 192;break $while_cond516$$if_end530$210; }
  
                var $262=$c_next; //@line 2566 "readclause.cpp"
                var $cmp524=((($262))|0)==10; //@line 2566 "readclause.cpp"
                if ($cmp524) { __label__ = 190;; } else { __label__ = 191;; } //@line 2566 "readclause.cpp"
                if (__label__ == 190) {
  
                  var $263=$nl_count; //@line 2567 "readclause.cpp"
                  var $inc526=((($263)+1)&4294967295); //@line 2567 "readclause.cpp"
                  $nl_count=$inc526; //@line 2567 "readclause.cpp"
                  ; //@line 2567 "readclause.cpp"
                }
  
                var $call528=__ZL4GetCv(); //@line 2568 "readclause.cpp"
                $c_next=$call528; //@line 2568 "readclause.cpp"
                __label__ = 187;continue ; //@line 2569 "readclause.cpp"
              }
            }
          } while(0);
  
          var $264=HEAP32[(($c1)>>2)]; //@line 2572 "readclause.cpp"
          var $cmp531=((($264))|0)==46; //@line 2572 "readclause.cpp"
          if ($cmp531) { __label__ = 193;; } else { __label__ = 195;; } //@line 2572 "readclause.cpp"
          $land_lhs_true532$$if_end535$219: do { 
            if (__label__ == 193) {
  
              var $265=$nl_count; //@line 2572 "readclause.cpp"
              var $cmp533=((($265))|0) < 2; //@line 2572 "readclause.cpp"
              if (!($cmp533)) { __label__ = 226;break $land_lhs_true532$$if_end535$219; } //@line 2572 "readclause.cpp"
  
              var $266=$punct_data; //@line 2574 "readclause.cpp"
              var $or=($266) | 4194304; //@line 2574 "readclause.cpp"
              $punct_data=$or; //@line 2574 "readclause.cpp"
              __label__ = 195;break $land_lhs_true532$$if_end535$219; //@line 2575 "readclause.cpp"
            }
          } while(0);
          $if_end535$$if_end609$222: do { 
            if (__label__ == 195) {
  
              var $_pr26=$nl_count; //@line 2577 "readclause.cpp"
              var $cmp536=((($_pr26))|0)==0; //@line 2577 "readclause.cpp"
              if (!($cmp536)) { __label__ = 226;break $if_end535$$if_end609$222; } //@line 2577 "readclause.cpp"
  
              var $267=HEAP32[(($c1)>>2)]; //@line 2579 "readclause.cpp"
              var $cmp538=((($267))|0)==44; //@line 2579 "readclause.cpp"
              if ($cmp538) { __lastLabel__ = 196; __label__ = 197;; } else { __lastLabel__ = 196; __label__ = 204;; } //@line 2579 "readclause.cpp"
              $land_lhs_true539$$if_end554$225: do { 
                if (__label__ == 197) {
  
                  var $268=$cprev; //@line 2579 "readclause.cpp"
                  var $cmp540=((($268))|0)==46; //@line 2579 "readclause.cpp"
                  if ($cmp540) { __label__ = 198;; } else { __label__ = 203;; } //@line 2579 "readclause.cpp"
                  $land_lhs_true541$$if_end554thread_pre_split$227: do { 
                    if (__label__ == 198) {
  
                      var $269=$tr_addr; //@line 2579 "readclause.cpp"
                      var $translator_name542=(($269+280)&4294967295); //@line 2579 "readclause.cpp"
                      var $270=HEAP32[(($translator_name542)>>2)]; //@line 2579 "readclause.cpp"
                      var $cmp543=((($270))|0)==26741; //@line 2579 "readclause.cpp"
                      if (!($cmp543)) { __label__ = 203;break $land_lhs_true541$$if_end554thread_pre_split$227; } //@line 2579 "readclause.cpp"
  
                      var $271=$cprev2; //@line 2579 "readclause.cpp"
                      var $call545=_iswdigit($271); //@line 2579 "readclause.cpp"
                      var $tobool546=((($call545))|0)!=0; //@line 2579 "readclause.cpp"
                      if (!($tobool546)) { __label__ = 203;break $land_lhs_true541$$if_end554thread_pre_split$227; } //@line 2579 "readclause.cpp"
  
                      var $272=$c_next; //@line 2579 "readclause.cpp"
                      var $call548=_iswdigit($272); //@line 2579 "readclause.cpp"
                      var $tobool549=((($call548))|0)!=0; //@line 2579 "readclause.cpp"
                      if ($tobool549) { __label__ = 202;; } else { __label__ = 201;; } //@line 2579 "readclause.cpp"
                      if (__label__ == 201) {
  
                        var $273=$c_next; //@line 2579 "readclause.cpp"
                        var $call551=_iswlower($273); //@line 2579 "readclause.cpp"
                        var $tobool552=((($call551))|0)!=0; //@line 2579 "readclause.cpp"
                        if (!($tobool552)) { __label__ = 203;break $land_lhs_true541$$if_end554thread_pre_split$227; } //@line 2579 "readclause.cpp"
                      }
  
                      HEAP32[(($c1)>>2)]=1367; //@line 2582 "readclause.cpp"
                      $is_end_clause=0; //@line 2583 "readclause.cpp"
                      __label__ = 220;break $land_lhs_true539$$if_end554$225; //@line 2586 "readclause.cpp"
                    }
                  } while(0);
  
                  var $_pr28=HEAP32[(($c1)>>2)]; //@line 2586 "readclause.cpp"
                  __lastLabel__ = 203; __label__ = 204;break $land_lhs_true539$$if_end554$225;
                }
              } while(0);
              $if_else595$$if_end554$235: do { 
                if (__label__ == 204) {
  
                  var $274=__lastLabel__ == 203 ? $_pr28 : ($267); //@line 2586 "readclause.cpp"
                  var $cmp555=((($274))|0)==46; //@line 2586 "readclause.cpp"
                  if (!($cmp555)) { __label__ = 220;break $if_else595$$if_end554$235; } //@line 2586 "readclause.cpp"
  
                  var $275=$tr_addr; //@line 2588 "readclause.cpp"
                  var $langopts=(($275)&4294967295); //@line 2588 "readclause.cpp"
                  var $numbers=(($langopts+184)&4294967295); //@line 2588 "readclause.cpp"
                  var $276=HEAP32[(($numbers)>>2)]; //@line 2588 "readclause.cpp"
                  var $and557=($276) & 65536; //@line 2588 "readclause.cpp"
                  var $tobool558=((($and557))|0)!=0; //@line 2588 "readclause.cpp"
                  if ($tobool558) { __label__ = 206;; } else { __label__ = 214;; } //@line 2588 "readclause.cpp"
                  $land_lhs_true559$$if_else583$238: do { 
                    if (__label__ == 206) {
  
                      var $277=$cprev; //@line 2589 "readclause.cpp"
                      var $call560=_iswdigit($277); //@line 2589 "readclause.cpp"
                      var $tobool561=((($call560))|0)!=0; //@line 2589 "readclause.cpp"
                      if ($tobool561) { __label__ = 210;; } else { __label__ = 207;; } //@line 2589 "readclause.cpp"
                      $if_then571$$lor_lhs_false562$240: do { 
                        if (__label__ == 207) {
  
                          var $278=$cprev; //@line 2589 "readclause.cpp"
                          var $call563=__ZL8IsRomanUj($278); //@line 2589 "readclause.cpp"
                          var $tobool564=((($call563))|0)!=0; //@line 2589 "readclause.cpp"
                          if (!($tobool564)) { __label__ = 214;break $land_lhs_true559$$if_else583$238; } //@line 2589 "readclause.cpp"
  
                          var $279=$cprev2; //@line 2589 "readclause.cpp"
                          var $call566=__ZL8IsRomanUj($279); //@line 2589 "readclause.cpp"
                          var $tobool567=((($call566))|0)!=0; //@line 2589 "readclause.cpp"
                          if ($tobool567) { __label__ = 210;break $if_then571$$lor_lhs_false562$240; } //@line 2589 "readclause.cpp"
  
                          var $280=$cprev2; //@line 2589 "readclause.cpp"
                          var $call569=_iswspace($280); //@line 2589 "readclause.cpp"
                          var $tobool570=((($call569))|0)!=0; //@line 2589 "readclause.cpp"
                          if (!($tobool570)) { __label__ = 214;break $land_lhs_true559$$if_else583$238; } //@line 2589 "readclause.cpp"
                        }
                      } while(0);
  
                      var $281=$cprev; //@line 2592 "readclause.cpp"
                      var $call572=_iswdigit($281); //@line 2592 "readclause.cpp"
                      var $tobool573=((($call572))|0)!=0; //@line 2592 "readclause.cpp"
                      if ($tobool573) { __label__ = 212;; } else { __label__ = 211;; } //@line 2592 "readclause.cpp"
                      if (__label__ == 212) {
  
                        var $282=$c_next; //@line 2598 "readclause.cpp"
                        var $call576=_iswlower($282); //@line 2598 "readclause.cpp"
                        var $tobool577=((($call576))|0)!=0; //@line 2598 "readclause.cpp"
                        var $283=$c_next; //@line 2598 "readclause.cpp"
                        var $cmp579=((($283))|0)==45; //@line 2598 "readclause.cpp"
                        var $or_cond16=($tobool577) | ($cmp579); //@line 2598 "readclause.cpp"
                        if (!($or_cond16)) { __label__ = 216;break $land_lhs_true559$$if_else583$238; } //@line 2598 "readclause.cpp"
  
                        $is_end_clause=0; //@line 2599 "readclause.cpp"
                        __label__ = 216;break $land_lhs_true559$$if_else583$238; //@line 2599 "readclause.cpp"
                      }
                      else if (__label__ == 211) {
  
                        $is_end_clause=0; //@line 2594 "readclause.cpp"
                        __label__ = 216;break $land_lhs_true559$$if_else583$238; //@line 2595 "readclause.cpp"
                      }
                    }
                  } while(0);
                  $if_end587$$if_else583$249: do { 
                    if (__label__ == 214) {
  
                      var $284=$c_next; //@line 2603 "readclause.cpp"
                      var $cmp584=((($284))|0)==39; //@line 2603 "readclause.cpp"
                      if (!($cmp584)) { __label__ = 216;break $if_end587$$if_else583$249; } //@line 2603 "readclause.cpp"
  
                      $is_end_clause=0; //@line 2605 "readclause.cpp"
                      ; //@line 2606 "readclause.cpp"
                    }
                  } while(0);
  
                  var $285=$c_next; //@line 2607 "readclause.cpp"
                  var $call588=_iswlower($285); //@line 2607 "readclause.cpp"
                  var $tobool589=((($call588))|0)!=0; //@line 2607 "readclause.cpp"
                  if ($tobool589) { __label__ = 217;; } else { __label__ = 218;; } //@line 2607 "readclause.cpp"
                  if (__label__ == 217) {
  
                    $is_end_clause=0; //@line 2611 "readclause.cpp"
                    ; //@line 2612 "readclause.cpp"
                  }
  
                  var $286=$any_alnum; //@line 2613 "readclause.cpp"
                  var $cmp592=((($286))|0)==0; //@line 2613 "readclause.cpp"
                  if (!($cmp592)) { __label__ = 222;break $if_else595$$if_end554$235; } //@line 2613 "readclause.cpp"
  
                  HEAP32[(($c1)>>2)]=32; //@line 2617 "readclause.cpp"
                  $is_end_clause=0; //@line 2618 "readclause.cpp"
                  __label__ = 235;break $if_end535$$if_end609$222; //@line 2619 "readclause.cpp"
                }
              } while(0);
              $if_else595$$if_end599$257: do { 
                if (__label__ == 220) {
  
                  var $287=$any_alnum; //@line 2623 "readclause.cpp"
                  var $cmp596=((($287))|0)==0; //@line 2623 "readclause.cpp"
                  if (!($cmp596)) { __label__ = 222;break $if_else595$$if_end599$257; } //@line 2623 "readclause.cpp"
  
                  $is_end_clause=0; //@line 2626 "readclause.cpp"
                  __label__ = 235;break $if_end535$$if_end609$222; //@line 2627 "readclause.cpp"
                }
              } while(0);
  
              var $_pr30=$is_end_clause; //@line 2630 "readclause.cpp"
              var $tobool600=((($_pr30))|0)!=0; //@line 2630 "readclause.cpp"
              if (!($tobool600)) { __label__ = 235;break $if_end535$$if_end609$222; } //@line 2630 "readclause.cpp"
  
              var $288=HEAP32[(($c1)>>2)]; //@line 2630 "readclause.cpp"
              var $cmp602=((($288))|0)==46; //@line 2630 "readclause.cpp"
              if (!($cmp602)) { __label__ = 226;break $if_end535$$if_end609$222; } //@line 2630 "readclause.cpp"
  
              var $289=$c_next; //@line 2630 "readclause.cpp"
              var $cmp604=((($289))|0)==60; //@line 2630 "readclause.cpp"
              var $290=HEAP32[((_option_ssml)>>2)]; //@line 2630 "readclause.cpp"
              var $tobool606=((($290))|0)!=0; //@line 2630 "readclause.cpp"
              var $or_cond17=($cmp604) & ($tobool606); //@line 2630 "readclause.cpp"
              if (!($or_cond17)) { __label__ = 226;break $if_end535$$if_end609$222; } //@line 2630 "readclause.cpp"
  
              $is_end_clause=0; //@line 2633 "readclause.cpp"
              var $291=HEAP32[(($ix)>>2)]; //@line 2634 "readclause.cpp"
              $end_clause_index=$291; //@line 2634 "readclause.cpp"
              var $292=$punct_data; //@line 2635 "readclause.cpp"
              $end_clause_after_tag=$292; //@line 2635 "readclause.cpp"
              __label__ = 235;break $if_end535$$if_end609$222; //@line 2636 "readclause.cpp"
            }
          } while(0);
          if (__label__ == 226) {
  
            var $_pr32_pr=$is_end_clause; //@line 2639 "readclause.cpp"
            var $tobool610=((($_pr32_pr))|0)!=0; //@line 2639 "readclause.cpp"
            if ($tobool610) { __label__ = 227;break $while_cond$12; } //@line 2639 "readclause.cpp"
          }
  
          var $call633=__Z3Eofv(); //@line 2659 "readclause.cpp"
          var $tobool634=((($call633))|0)!=0; //@line 2659 "readclause.cpp"
          if ($tobool634) { __label__ = 238;break $if_then412$$if_end643$161; } //@line 2659 "readclause.cpp"
  
          var $305=HEAP32[(($c2)>>2)]; //@line 2661 "readclause.cpp"
          var $call636=_iswspace($305); //@line 2661 "readclause.cpp"
          var $tobool637=((($call636))|0)!=0; //@line 2661 "readclause.cpp"
          if (!($tobool637)) { __label__ = 238;break $if_then412$$if_end643$161; } //@line 2661 "readclause.cpp"
  
          var $306=$c_next; //@line 2662 "readclause.cpp"
          __ZL6UngetCi($306); //@line 2662 "readclause.cpp"
          ; //@line 2662 "readclause.cpp"
        }
      } while(0);
  
      var $307=HEAP32[((((__ZL17speech_parameters)&4294967295))>>2)]; //@line 2668 "readclause.cpp"
      var $cmp644=((($307))|0)==1; //@line 2668 "readclause.cpp"
      if ($cmp644) { __label__ = 8;continue $while_cond$12; } //@line 2668 "readclause.cpp"
  
      var $308=HEAP32[(($c1)>>2)]; //@line 2671 "readclause.cpp"
      var $309=$announced_punctuation; //@line 2671 "readclause.cpp"
      var $cmp647=((($308))|0)==((($309))|0); //@line 2671 "readclause.cpp"
      if ($cmp647) { __label__ = 240;; } else { __label__ = 245;; } //@line 2671 "readclause.cpp"
      $if_then648$$if_end657$271: do { 
        if (__label__ == 240) {
  
          var $310=HEAP32[(($c1)>>2)]; //@line 2675 "readclause.cpp"
          var $call649=__Z9IsBracketi($310); //@line 2675 "readclause.cpp"
          var $tobool650=((($call649))|0)!=0; //@line 2675 "readclause.cpp"
          if ($tobool650) { __label__ = 241;; } else { __label__ = 242;; } //@line 2675 "readclause.cpp"
          $if_then651$$if_else652$273: do { 
            if (__label__ == 241) {
  
              HEAP32[(($c1)>>2)]=57384; //@line 2677 "readclause.cpp"
              ; //@line 2678 "readclause.cpp"
            }
            else if (__label__ == 242) {
  
              var $311=HEAP32[(($c1)>>2)]; //@line 2680 "readclause.cpp"
              var $cmp653=((($311))|0)!=45; //@line 2680 "readclause.cpp"
              if (!($cmp653)) { __label__ = 244;break $if_then651$$if_else652$273; } //@line 2680 "readclause.cpp"
  
              HEAP32[(($c1)>>2)]=32; //@line 2682 "readclause.cpp"
              ; //@line 2683 "readclause.cpp"
            }
          } while(0);
  
          var $312=HEAP32[(($ix)>>2)]; //@line 2686 "readclause.cpp"
          var $add65834=((($312)+1)&4294967295); //@line 2686 "readclause.cpp"
          $j=$add65834; //@line 2686 "readclause.cpp"
          ; //@line 2688 "readclause.cpp"
        }
        else if (__label__ == 245) {
  
          var $313=HEAP32[(($ix)>>2)]; //@line 2686 "readclause.cpp"
          var $add658=((($313)+1)&4294967295); //@line 2686 "readclause.cpp"
          $j=$add658; //@line 2686 "readclause.cpp"
          var $cmp659=((($308))|0)==57404; //@line 2688 "readclause.cpp"
          if (!($cmp659)) { __label__ = 247;break $if_then648$$if_end657$271; } //@line 2688 "readclause.cpp"
  
          HEAP32[(($c1)>>2)]=60; //@line 2688 "readclause.cpp"
          ; //@line 2688 "readclause.cpp"
        }
      } while(0);
  
      var $314=HEAP32[(($c1)>>2)]; //@line 2690 "readclause.cpp"
      var $315=HEAP32[(($ix)>>2)]; //@line 2690 "readclause.cpp"
      var $316=$buf_addr; //@line 2690 "readclause.cpp"
      var $arrayidx662=(($316+$315)&4294967295); //@line 2690 "readclause.cpp"
      var $call663=__Z8utf8_outjPc($314, $arrayidx662); //@line 2690 "readclause.cpp"
      var $317=HEAP32[(($ix)>>2)]; //@line 2690 "readclause.cpp"
      var $add664=((($317)+($call663))&4294967295); //@line 2690 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$add664; //@line 2690 "readclause.cpp"
      var $318=HEAP32[(($c1)>>2)]; //@line 2691 "readclause.cpp"
      var $call665=_iswspace($318); //@line 2691 "readclause.cpp"
      var $tobool666=((($call665))|0)!=0; //@line 2691 "readclause.cpp"
      if ($tobool666) { __label__ = 251;; } else { __label__ = 248;; } //@line 2691 "readclause.cpp"
      $if_end680$$land_lhs_true667$281: do { 
        if (__label__ == 248) {
  
          var $319=HEAP32[(($c1)>>2)]; //@line 2691 "readclause.cpp"
          var $call668=__Z9IsBracketi($319); //@line 2691 "readclause.cpp"
          var $tobool669=((($call668))|0)!=0; //@line 2691 "readclause.cpp"
          if ($tobool669) { __label__ = 251;break $if_end680$$land_lhs_true667$281; } //@line 2691 "readclause.cpp"
  
          var $320=HEAP32[((_count_characters)>>2)]; //@line 2693 "readclause.cpp"
          var $321=HEAP32[((_clause_start_char)>>2)]; //@line 2693 "readclause.cpp"
          var $sub671=((($320)-($321))&4294967295); //@line 2693 "readclause.cpp"
          var $conv672=((($sub671)) & 65535); //@line 2693 "readclause.cpp"
          var $322=HEAP32[(($ix)>>2)]; //@line 2693 "readclause.cpp"
          var $323=$charix_addr; //@line 2693 "readclause.cpp"
          var $arrayidx673=(($323+2*$322)&4294967295); //@line 2693 "readclause.cpp"
          HEAP16[(($arrayidx673)>>1)]=$conv672; //@line 2693 "readclause.cpp"
          var $324=$j; //@line 2694 "readclause.cpp"
          var $325=HEAP32[(($ix)>>2)]; //@line 2694 "readclause.cpp"
          var $cmp67537=((($324))|0) < ((($325))|0); //@line 2694 "readclause.cpp"
          if (!($cmp67537)) { __label__ = 251;break $if_end680$$land_lhs_true667$281; } //@line 2694 "readclause.cpp"
          while(1) { 
  
            var $326=$j; //@line 2695 "readclause.cpp"
            var $inc677=((($326)+1)&4294967295); //@line 2695 "readclause.cpp"
            $j=$inc677; //@line 2695 "readclause.cpp"
            var $327=$charix_addr; //@line 2695 "readclause.cpp"
            var $arrayidx678=(($327+2*$326)&4294967295); //@line 2695 "readclause.cpp"
            HEAP16[(($arrayidx678)>>1)]=-1; //@line 2695 "readclause.cpp"
            var $328=$j; //@line 2694 "readclause.cpp"
            var $329=HEAP32[(($ix)>>2)]; //@line 2694 "readclause.cpp"
            var $cmp675=((($328))|0) < ((($329))|0); //@line 2694 "readclause.cpp"
            if ($cmp675) { __label__ = 250;continue ; } else { __label__ = 251;break $if_end680$$land_lhs_true667$281; } //@line 2694 "readclause.cpp"
          }
        }
      } while(0);
  
      var $330=HEAP32[(($ix)>>2)]; //@line 2697 "readclause.cpp"
      var $331=$charix_top_addr; //@line 2697 "readclause.cpp"
      HEAP32[(($331)>>2)]=$330; //@line 2697 "readclause.cpp"
      var $332=HEAP32[(($ix)>>2)]; //@line 2699 "readclause.cpp"
      var $333=$n_buf_addr; //@line 2699 "readclause.cpp"
      var $sub681=((($333)-20)&4294967295); //@line 2699 "readclause.cpp"
      var $cmp682=((($332))|0) > ((($sub681))|0); //@line 2699 "readclause.cpp"
      if ($cmp682) { __label__ = 252;; } else { __label__ = 254;; } //@line 2699 "readclause.cpp"
      $land_lhs_true683$$lor_lhs_false689$287: do { 
        if (__label__ == 252) {
  
          var $334=HEAP32[(($c1)>>2)]; //@line 2699 "readclause.cpp"
          var $call684=__Z7IsAlphaj($334); //@line 2699 "readclause.cpp"
          var $tobool685=((($call684))|0)!=0; //@line 2699 "readclause.cpp"
          if ($tobool685) { __label__ = 254;break $land_lhs_true683$$lor_lhs_false689$287; } //@line 2699 "readclause.cpp"
  
          var $335=HEAP32[(($c1)>>2)]; //@line 2699 "readclause.cpp"
          var $call687=_iswdigit($335); //@line 2699 "readclause.cpp"
          var $tobool688=((($call687))|0)!=0; //@line 2699 "readclause.cpp"
          if (!($tobool688)) { __label__ = 255;break $while_cond$12; } //@line 2699 "readclause.cpp"
        }
      } while(0);
  
      var $336=HEAP32[(($ix)>>2)]; //@line 2699 "readclause.cpp"
      var $337=$n_buf_addr; //@line 2699 "readclause.cpp"
      var $sub690=((($337)-2)&4294967295); //@line 2699 "readclause.cpp"
      var $cmp691=((($336))|0) >= ((($sub690))|0); //@line 2699 "readclause.cpp"
      if ($cmp691) { __label__ = 255;break $while_cond$12; } else { __label__ = 8;continue $while_cond$12; } //@line 2699 "readclause.cpp"
    }
    if (__label__ == 256) {
  
      var $343=$stressed_word; //@line 2710 "readclause.cpp"
      var $tobool698=((($343))|0)!=0; //@line 2710 "readclause.cpp"
      if ($tobool698) { __label__ = 257;; } else { __label__ = 258;; } //@line 2710 "readclause.cpp"
      if (__label__ == 257) {
  
        var $344=HEAP32[(($ix)>>2)]; //@line 2712 "readclause.cpp"
        var $345=$buf_addr; //@line 2712 "readclause.cpp"
        var $arrayidx700=(($345+$344)&4294967295); //@line 2712 "readclause.cpp"
        var $call701=__Z8utf8_outjPc(1328, $arrayidx700); //@line 2712 "readclause.cpp"
        var $346=HEAP32[(($ix)>>2)]; //@line 2712 "readclause.cpp"
        var $add702=((($346)+($call701))&4294967295); //@line 2712 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$add702; //@line 2712 "readclause.cpp"
        ; //@line 2713 "readclause.cpp"
      }
  
      var $347=$end_clause_after_tag; //@line 2714 "readclause.cpp"
      var $tobool704=((($347))|0)!=0; //@line 2714 "readclause.cpp"
      if ($tobool704) { __label__ = 259;; } else { __label__ = 260;; } //@line 2714 "readclause.cpp"
      if (__label__ == 259) {
  
        var $348=$end_clause_index; //@line 2716 "readclause.cpp"
        var $349=$buf_addr; //@line 2716 "readclause.cpp"
        var $arrayidx706=(($349+$348)&4294967295); //@line 2716 "readclause.cpp"
        __ZL10RemoveCharPc($arrayidx706); //@line 2716 "readclause.cpp"
        ; //@line 2717 "readclause.cpp"
      }
  
      var $350=HEAP32[(($ix)>>2)]; //@line 2718 "readclause.cpp"
      var $351=$buf_addr; //@line 2718 "readclause.cpp"
      var $arrayidx708=(($351+$350)&4294967295); //@line 2718 "readclause.cpp"
      HEAP8[($arrayidx708)]=32; //@line 2718 "readclause.cpp"
      var $352=HEAP32[(($ix)>>2)]; //@line 2719 "readclause.cpp"
      var $add709=((($352)+1)&4294967295); //@line 2719 "readclause.cpp"
      var $353=$buf_addr; //@line 2719 "readclause.cpp"
      var $arrayidx710=(($353+$add709)&4294967295); //@line 2719 "readclause.cpp"
      HEAP8[($arrayidx710)]=0; //@line 2719 "readclause.cpp"
      $retval=589864; //@line 2720 "readclause.cpp"
      ; //@line 2720 "readclause.cpp"
    }
    else if (__label__ == 12) {
  
      HEAP8[(__ZL12end_of_input_b)]=1;
      $retval=589864; //@line 2116 "readclause.cpp"
      ; //@line 2116 "readclause.cpp"
    }
    else if (__label__ == 15) {
  
      HEAP8[(__ZL19clear_skipping_text_b)]=1;
      HEAP32[((_skip_characters)>>2)]=0; //@line 2124 "readclause.cpp"
      var $24=HEAP32[(($c2)>>2)]; //@line 2125 "readclause.cpp"
      __ZL6UngetCi($24); //@line 2125 "readclause.cpp"
      $retval=16384; //@line 2126 "readclause.cpp"
      ; //@line 2126 "readclause.cpp"
    }
    else if (__label__ == 66) {
  
      var $81=$end_clause_after_tag; //@line 2249 "readclause.cpp"
      var $tobool168=((($81))|0)!=0; //@line 2249 "readclause.cpp"
      if ($tobool168) { __label__ = 67;; } else { __label__ = 68;; } //@line 2249 "readclause.cpp"
      if (__label__ == 67) {
  
        var $82=$end_clause_index; //@line 2250 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$82; //@line 2250 "readclause.cpp"
        ; //@line 2250 "readclause.cpp"
      }
  
      var $83=HEAP32[(($ix)>>2)]; //@line 2252 "readclause.cpp"
      var $84=$buf_addr; //@line 2252 "readclause.cpp"
      var $arrayidx171=(($84+$83)&4294967295); //@line 2252 "readclause.cpp"
      HEAP8[($arrayidx171)]=32; //@line 2252 "readclause.cpp"
      var $85=HEAP32[(($ix)>>2)]; //@line 2253 "readclause.cpp"
      var $inc172=((($85)+1)&4294967295); //@line 2253 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$inc172; //@line 2253 "readclause.cpp"
      var $86=$buf_addr; //@line 2253 "readclause.cpp"
      var $arrayidx173=(($86+$85)&4294967295); //@line 2253 "readclause.cpp"
      HEAP8[($arrayidx173)]=0; //@line 2253 "readclause.cpp"
      var $87=$terminator; //@line 2255 "readclause.cpp"
      var $and=($87) & 131072; //@line 2255 "readclause.cpp"
      var $tobool174=((($and))|0)!=0; //@line 2255 "readclause.cpp"
      if ($tobool174) { __label__ = 69;; } else { __label__ = 70;; } //@line 2255 "readclause.cpp"
      if (__label__ == 69) {
  
        var $88=$voice_change_addr; //@line 2257 "readclause.cpp"
        var $call176=_strcpy($88, ((__ZL16current_voice_id)&4294967295)); //@line 2257 "readclause.cpp"
        ; //@line 2258 "readclause.cpp"
      }
  
      var $89=$terminator; //@line 2259 "readclause.cpp"
      $retval=$89; //@line 2259 "readclause.cpp"
      ; //@line 2259 "readclause.cpp"
    }
    else if (__label__ == 74) {
  
      var $call192=__Z11lookupwcharPKti(((__ZL11punct_chars)&4294967295), $93); //@line 2275 "readclause.cpp"
      $punct=$call192; //@line 2275 "readclause.cpp"
      var $cmp193=((($call192))|0)==0; //@line 2275 "readclause.cpp"
      if ($cmp193) { __label__ = 75;; } else { __label__ = 76;; } //@line 2275 "readclause.cpp"
      if (__label__ == 75) {
  
        var $94=HEAP32[((_count_characters)>>2)]; //@line 2277 "readclause.cpp"
        var $95=HEAP32[((_clause_start_char)>>2)]; //@line 2277 "readclause.cpp"
        var $sub195=((($94)-($95))&4294967295); //@line 2277 "readclause.cpp"
        var $conv196=((($sub195)) & 65535); //@line 2277 "readclause.cpp"
        var $96=HEAP32[(($ix)>>2)]; //@line 2277 "readclause.cpp"
        var $97=$charix_addr; //@line 2277 "readclause.cpp"
        var $arrayidx197=(($97+2*$96)&4294967295); //@line 2277 "readclause.cpp"
        HEAP16[(($arrayidx197)>>1)]=$conv196; //@line 2277 "readclause.cpp"
        var $98=HEAP32[(($ix)>>2)]; //@line 2278 "readclause.cpp"
        var $99=$charix_top_addr; //@line 2278 "readclause.cpp"
        HEAP32[(($99)>>2)]=$98; //@line 2278 "readclause.cpp"
        var $100=HEAP32[(($c1)>>2)]; //@line 2279 "readclause.cpp"
        var $101=HEAP32[(($ix)>>2)]; //@line 2279 "readclause.cpp"
        var $102=$buf_addr; //@line 2279 "readclause.cpp"
        var $arrayidx198=(($102+$101)&4294967295); //@line 2279 "readclause.cpp"
        var $call199=__Z8utf8_outjPc($100, $arrayidx198); //@line 2279 "readclause.cpp"
        var $103=HEAP32[(($ix)>>2)]; //@line 2279 "readclause.cpp"
        var $add200=((($103)+($call199))&4294967295); //@line 2279 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$add200; //@line 2279 "readclause.cpp"
        $terminator=524328; //@line 2280 "readclause.cpp"
        ; //@line 2281 "readclause.cpp"
      }
      else if (__label__ == 76) {
  
        var $104=$punct; //@line 2284 "readclause.cpp"
        var $arrayidx202=((__ZL16punct_attributes+$104*4)&4294967295); //@line 2284 "readclause.cpp"
        var $105=HEAP32[(($arrayidx202)>>2)]; //@line 2284 "readclause.cpp"
        $terminator=$105; //@line 2284 "readclause.cpp"
        ;
      }
  
      var $106=HEAP32[(($ix)>>2)]; //@line 2286 "readclause.cpp"
      var $107=$buf_addr; //@line 2286 "readclause.cpp"
      var $arrayidx204=(($107+$106)&4294967295); //@line 2286 "readclause.cpp"
      HEAP8[($arrayidx204)]=32; //@line 2286 "readclause.cpp"
      var $108=HEAP32[(($ix)>>2)]; //@line 2287 "readclause.cpp"
      var $add205=((($108)+1)&4294967295); //@line 2287 "readclause.cpp"
      var $109=$buf_addr; //@line 2287 "readclause.cpp"
      var $arrayidx206=(($109+$add205)&4294967295); //@line 2287 "readclause.cpp"
      HEAP8[($arrayidx206)]=0; //@line 2287 "readclause.cpp"
      var $110=$terminator; //@line 2288 "readclause.cpp"
      $retval=$110; //@line 2288 "readclause.cpp"
      ; //@line 2288 "readclause.cpp"
    }
    else if (__label__ == 81) {
  
      var $114=HEAP32[(($ix)>>2)]; //@line 2296 "readclause.cpp"
      var $inc215=((($114)+1)&4294967295); //@line 2296 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$inc215; //@line 2296 "readclause.cpp"
      var $115=$buf_addr; //@line 2296 "readclause.cpp"
      var $arrayidx216=(($115+$114)&4294967295); //@line 2296 "readclause.cpp"
      HEAP8[($arrayidx216)]=0; //@line 2296 "readclause.cpp"
      ; //@line 2297 "readclause.cpp"
      while(1) { 
  
        var $call218=__ZL4GetCv(); //@line 2297 "readclause.cpp"
        HEAP32[(($c1)>>2)]=$call218; //@line 2297 "readclause.cpp"
        var $call219=_iswspace($call218); //@line 2297 "readclause.cpp"
        var $tobool220=((($call219))|0)!=0; //@line 2297 "readclause.cpp"
        if ($tobool220) { __label__ = 86;break ; } //@line 2297 "readclause.cpp"
  
        var $call222=__Z3Eofv(); //@line 2297 "readclause.cpp"
        var $tobool223=((($call222))|0)!=0; //@line 2297 "readclause.cpp"
        if ($tobool223) { __label__ = 86;break ; } //@line 2297 "readclause.cpp"
  
        var $116=HEAP32[(($ix)>>2)]; //@line 2297 "readclause.cpp"
        var $117=$n_buf_addr; //@line 2297 "readclause.cpp"
        var $sub225=((($117)-1)&4294967295); //@line 2297 "readclause.cpp"
        var $cmp226=((($116))|0) < ((($sub225))|0); //@line 2297 "readclause.cpp"
        if (!($cmp226)) { __label__ = 86;break ; }
  
        var $118=HEAP32[(($c1)>>2)]; //@line 2298 "readclause.cpp"
        var $conv229=((($118)) & 255); //@line 2298 "readclause.cpp"
        var $119=HEAP32[(($ix)>>2)]; //@line 2298 "readclause.cpp"
        var $inc230=((($119)+1)&4294967295); //@line 2298 "readclause.cpp"
        HEAP32[(($ix)>>2)]=$inc230; //@line 2298 "readclause.cpp"
        var $120=$buf_addr; //@line 2298 "readclause.cpp"
        var $arrayidx231=(($120+$119)&4294967295); //@line 2298 "readclause.cpp"
        HEAP8[($arrayidx231)]=$conv229; //@line 2298 "readclause.cpp"
        __label__ = 82;continue ; //@line 2298 "readclause.cpp"
      }
  
      var $121=HEAP32[(($ix)>>2)]; //@line 2299 "readclause.cpp"
      var $inc233=((($121)+1)&4294967295); //@line 2299 "readclause.cpp"
      HEAP32[(($ix)>>2)]=$inc233; //@line 2299 "readclause.cpp"
      var $122=$buf_addr; //@line 2299 "readclause.cpp"
      var $arrayidx234=(($122+$121)&4294967295); //@line 2299 "readclause.cpp"
      HEAP8[($arrayidx234)]=0; //@line 2299 "readclause.cpp"
      $retval=147456; //@line 2300 "readclause.cpp"
      ; //@line 2300 "readclause.cpp"
    }
    else if (__label__ == 108) {
  
      HEAP32[((__ZL10ungot_word)>>2)]=((__str42209)&4294967295); //@line 2370 "readclause.cpp"
      var $151=HEAP32[(($c2)>>2)]; //@line 2371 "readclause.cpp"
      __ZL6UngetCi($151); //@line 2371 "readclause.cpp"
      var $152=$p_word; //@line 2372 "readclause.cpp"
      var $arrayidx300=(($152)&4294967295); //@line 2372 "readclause.cpp"
      HEAP8[($arrayidx300)]=0; //@line 2372 "readclause.cpp"
      $retval=524328; //@line 2373 "readclause.cpp"
      ; //@line 2373 "readclause.cpp"
    }
    else if (__label__ == 138) {
  
      var $184=HEAP32[(($c2)>>2)]; //@line 2438 "readclause.cpp"
      __ZL6UngetCi($184); //@line 2438 "readclause.cpp"
      var $185=$end_clause_after_tag; //@line 2440 "readclause.cpp"
      var $tobool387=((($185))|0)!=0; //@line 2440 "readclause.cpp"
      if ($tobool387) { __label__ = 139;; } else { __label__ = 140;; } //@line 2440 "readclause.cpp"
      if (__label__ == 139) {
  
        var $186=$end_clause_index; //@line 2442 "readclause.cpp"
        var $187=$buf_addr; //@line 2442 "readclause.cpp"
        var $arrayidx389=(($187+$186)&4294967295); //@line 2442 "readclause.cpp"
        __ZL10RemoveCharPc($arrayidx389); //@line 2442 "readclause.cpp"
        ; //@line 2443 "readclause.cpp"
      }
  
      var $188=HEAP32[(($ix)>>2)]; //@line 2444 "readclause.cpp"
      var $189=$buf_addr; //@line 2444 "readclause.cpp"
      var $arrayidx391=(($189+$188)&4294967295); //@line 2444 "readclause.cpp"
      HEAP8[($arrayidx391)]=32; //@line 2444 "readclause.cpp"
      var $190=HEAP32[(($ix)>>2)]; //@line 2445 "readclause.cpp"
      var $add392=((($190)+1)&4294967295); //@line 2445 "readclause.cpp"
      var $191=$buf_addr; //@line 2445 "readclause.cpp"
      var $arrayidx393=(($191+$add392)&4294967295); //@line 2445 "readclause.cpp"
      HEAP8[($arrayidx393)]=0; //@line 2445 "readclause.cpp"
      var $192=$parag; //@line 2446 "readclause.cpp"
      var $cmp394=((($192))|0) > 3; //@line 2446 "readclause.cpp"
      if ($cmp394) { __label__ = 141;; } else { __label__ = 142;; } //@line 2446 "readclause.cpp"
      if (__label__ == 141) {
  
        $parag=3; //@line 2447 "readclause.cpp"
        ; //@line 2447 "readclause.cpp"
      }
  
      var $193=HEAP32[((_option_ssml)>>2)]; //@line 2448 "readclause.cpp"
      var $tobool397=((($193))|0)!=0; //@line 2448 "readclause.cpp"
      if ($tobool397) { __label__ = 143;; } else { __label__ = 144;; } //@line 2448 "readclause.cpp"
      if (__label__ == 143) {
  
        $parag=1; //@line 2448 "readclause.cpp"
        ; //@line 2448 "readclause.cpp"
      }
  
      var $194=$parag; //@line 2449 "readclause.cpp"
      var $mul=((($194)*30)&4294967295); //@line 2449 "readclause.cpp"
      var $add400=((($mul)+524328)&4294967295); //@line 2449 "readclause.cpp"
      $retval=$add400; //@line 2449 "readclause.cpp"
      ; //@line 2449 "readclause.cpp"
    }
    else if (__label__ == 146) {
  
      var $197=HEAP32[(($c2)>>2)]; //@line 2455 "readclause.cpp"
      __ZL6UngetCi($197); //@line 2455 "readclause.cpp"
      var $198=HEAP32[(($ix)>>2)]; //@line 2456 "readclause.cpp"
      var $199=$buf_addr; //@line 2456 "readclause.cpp"
      var $arrayidx404=(($199+$198)&4294967295); //@line 2456 "readclause.cpp"
      HEAP8[($arrayidx404)]=32; //@line 2456 "readclause.cpp"
      var $200=HEAP32[(($ix)>>2)]; //@line 2457 "readclause.cpp"
      var $add405=((($200)+1)&4294967295); //@line 2457 "readclause.cpp"
      var $201=$buf_addr; //@line 2457 "readclause.cpp"
      var $arrayidx406=(($201+$add405)&4294967295); //@line 2457 "readclause.cpp"
      HEAP8[($arrayidx406)]=0; //@line 2457 "readclause.cpp"
      $retval=262174; //@line 2458 "readclause.cpp"
      ; //@line 2458 "readclause.cpp"
    }
    else if (__label__ == 153) {
  
      var $209=HEAP32[(($c2)>>2)]; //@line 2482 "readclause.cpp"
      __ZL6UngetCi($209); //@line 2482 "readclause.cpp"
      var $210=HEAP32[(($c1)>>2)]; //@line 2483 "readclause.cpp"
      HEAP32[((__ZL11ungot_char2)>>2)]=$210; //@line 2483 "readclause.cpp"
      var $211=$end_clause_index; //@line 2484 "readclause.cpp"
      var $212=$buf_addr; //@line 2484 "readclause.cpp"
      var $arrayidx424=(($212+$211)&4294967295); //@line 2484 "readclause.cpp"
      HEAP8[($arrayidx424)]=32; //@line 2484 "readclause.cpp"
      var $213=$end_clause_index; //@line 2485 "readclause.cpp"
      var $add425=((($213)+1)&4294967295); //@line 2485 "readclause.cpp"
      var $214=$buf_addr; //@line 2485 "readclause.cpp"
      var $arrayidx426=(($214+$add425)&4294967295); //@line 2485 "readclause.cpp"
      HEAP8[($arrayidx426)]=0; //@line 2485 "readclause.cpp"
      var $215=$end_clause_after_tag; //@line 2486 "readclause.cpp"
      $retval=$215; //@line 2486 "readclause.cpp"
      ; //@line 2486 "readclause.cpp"
    }
    else if (__label__ == 179) {
  
      var $243=$terminator; //@line 2537 "readclause.cpp"
      $retval=$243; //@line 2537 "readclause.cpp"
      ; //@line 2537 "readclause.cpp"
    }
    else if (__label__ == 227) {
  
      var $293=$c_next; //@line 2641 "readclause.cpp"
      __ZL6UngetCi($293); //@line 2641 "readclause.cpp"
      var $294=HEAP32[(($ix)>>2)]; //@line 2642 "readclause.cpp"
      var $295=$buf_addr; //@line 2642 "readclause.cpp"
      var $arrayidx612=(($295+$294)&4294967295); //@line 2642 "readclause.cpp"
      HEAP8[($arrayidx612)]=32; //@line 2642 "readclause.cpp"
      var $296=HEAP32[(($ix)>>2)]; //@line 2643 "readclause.cpp"
      var $add613=((($296)+1)&4294967295); //@line 2643 "readclause.cpp"
      var $297=$buf_addr; //@line 2643 "readclause.cpp"
      var $arrayidx614=(($297+$add613)&4294967295); //@line 2643 "readclause.cpp"
      HEAP8[($arrayidx614)]=0; //@line 2643 "readclause.cpp"
      var $298=$cprev; //@line 2645 "readclause.cpp"
      var $call615=_iswdigit($298); //@line 2645 "readclause.cpp"
      var $tobool616=((($call615))|0)!=0; //@line 2645 "readclause.cpp"
      if ($tobool616) { __label__ = 228;; } else { __label__ = 230;; } //@line 2645 "readclause.cpp"
      $land_lhs_true617$$if_end622$335: do { 
        if (__label__ == 228) {
  
          var $299=$c_next; //@line 2645 "readclause.cpp"
          var $call618=__Z7IsAlphaj($299); //@line 2645 "readclause.cpp"
          var $tobool619=((($call618))|0)!=0; //@line 2645 "readclause.cpp"
          if ($tobool619) { __label__ = 230;break $land_lhs_true617$$if_end622$335; } //@line 2645 "readclause.cpp"
  
          var $300=$punct_data; //@line 2647 "readclause.cpp"
          var $and621=($300) & -4194305; //@line 2647 "readclause.cpp"
          $punct_data=$and621; //@line 2647 "readclause.cpp"
          ; //@line 2648 "readclause.cpp"
        }
      } while(0);
  
      var $301=$nl_count; //@line 2649 "readclause.cpp"
      var $cmp623=((($301))|0) > 1; //@line 2649 "readclause.cpp"
      var $302=$punct_data; //@line 2651 "readclause.cpp"
      if ($cmp623) { __label__ = 231;; } else { __label__ = 234;; } //@line 2649 "readclause.cpp"
      if (__label__ == 231) {
  
        var $cmp625=((($302))|0)==532520; //@line 2651 "readclause.cpp"
        var $303=$punct_data; //@line 2651 "readclause.cpp"
        var $cmp627=((($303))|0)==536621; //@line 2651 "readclause.cpp"
        var $or_cond18=($cmp625) | ($cmp627); //@line 2651 "readclause.cpp"
        if ($or_cond18) { __label__ = 232;; } else { __label__ = 233;; } //@line 2651 "readclause.cpp"
        if (__label__ == 232) {
  
          var $304=$punct_data; //@line 2652 "readclause.cpp"
          var $add629=((($304)+35)&4294967295); //@line 2652 "readclause.cpp"
          $retval=$add629; //@line 2652 "readclause.cpp"
          ; //@line 2652 "readclause.cpp"
        }
        else if (__label__ == 233) {
  
          $retval=524358; //@line 2653 "readclause.cpp"
          ; //@line 2653 "readclause.cpp"
        }
      }
      else if (__label__ == 234) {
  
        $retval=$302; //@line 2655 "readclause.cpp"
        ; //@line 2655 "readclause.cpp"
      }
    }
    else if (__label__ == 255) {
  
      var $338=HEAP32[(($ix)>>2)]; //@line 2703 "readclause.cpp"
      var $339=$buf_addr; //@line 2703 "readclause.cpp"
      var $arrayidx693=(($339+$338)&4294967295); //@line 2703 "readclause.cpp"
      HEAP8[($arrayidx693)]=32; //@line 2703 "readclause.cpp"
      var $340=HEAP32[(($ix)>>2)]; //@line 2704 "readclause.cpp"
      var $add694=((($340)+1)&4294967295); //@line 2704 "readclause.cpp"
      var $341=$buf_addr; //@line 2704 "readclause.cpp"
      var $arrayidx695=(($341+$add694)&4294967295); //@line 2704 "readclause.cpp"
      HEAP8[($arrayidx695)]=0; //@line 2704 "readclause.cpp"
      var $342=HEAP32[(($c2)>>2)]; //@line 2705 "readclause.cpp"
      __ZL6UngetCi($342); //@line 2705 "readclause.cpp"
      $retval=16384; //@line 2706 "readclause.cpp"
      ; //@line 2706 "readclause.cpp"
    }
  
    var $354=$retval; //@line 2721 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $354; //@line 2721 "readclause.cpp"
    return null;
  }
  

  function __ZL4GetCv() {
    var __stackBase__  = STACKTOP; STACKTOP += 16; _memset(__stackBase__, 0, 16);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $c;
    var $c1;
    var $c2;
    var $cbuf=__stackBase__;
    var $ix;
    var $n_bytes;
    var $m;
    var $0=HEAP32[((__ZL10ungot_char)>>2)]; //@line 483 "readclause.cpp"
    $c1=$0; //@line 483 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 483 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 483 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        HEAP32[((__ZL10ungot_char)>>2)]=0; //@line 485 "readclause.cpp"
        var $1=$c1; //@line 486 "readclause.cpp"
        $retval=$1; //@line 486 "readclause.cpp"
        ; //@line 486 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=HEAP32[((__ZZL4GetCvE6ungot2)>>2)]; //@line 489 "readclause.cpp"
        var $cmp1=((($2))|0)!=0; //@line 489 "readclause.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 489 "readclause.cpp"
        if (__label__ == 3) {
  
          var $3=HEAP32[((__ZZL4GetCvE6ungot2)>>2)]; //@line 491 "readclause.cpp"
          $c1=$3; //@line 491 "readclause.cpp"
          HEAP32[((__ZZL4GetCvE6ungot2)>>2)]=0; //@line 492 "readclause.cpp"
          ; //@line 493 "readclause.cpp"
        }
        else if (__label__ == 4) {
  
          var $call=__ZL8GetC_getv(); //@line 496 "readclause.cpp"
          $c1=$call; //@line 496 "readclause.cpp"
          ;
        }
  
        var $4=HEAP32[((_option_multibyte)>>2)]; //@line 499 "readclause.cpp"
        var $cmp4=((($4))|0)==3; //@line 499 "readclause.cpp"
        var $5=HEAP32[((_option_multibyte)>>2)]; //@line 499 "readclause.cpp"
        var $cmp5=((($5))|0)==4; //@line 499 "readclause.cpp"
        var $or_cond=($cmp4) | ($cmp5); //@line 499 "readclause.cpp"
        if ($or_cond) { __label__ = 6;; } else { __label__ = 7;; } //@line 499 "readclause.cpp"
        if (__label__ == 6) {
  
          var $6=HEAP32[((_count_characters)>>2)]; //@line 501 "readclause.cpp"
          var $inc=((($6)+1)&4294967295); //@line 501 "readclause.cpp"
          HEAP32[((_count_characters)>>2)]=$inc; //@line 501 "readclause.cpp"
          var $7=$c1; //@line 502 "readclause.cpp"
          $retval=$7; //@line 502 "readclause.cpp"
          ; //@line 502 "readclause.cpp"
        }
        else if (__label__ == 7) {
  
          var $8=HEAP32[((_option_multibyte)>>2)]; //@line 505 "readclause.cpp"
          var $cmp8=((($8))|0) < 2; //@line 505 "readclause.cpp"
          if ($cmp8) { __label__ = 8;; } else { __label__ = 36;; } //@line 505 "readclause.cpp"
          $land_lhs_true$$if_end65thread_pre_split$12: do { 
            if (__label__ == 8) {
  
              var $9=$c1; //@line 505 "readclause.cpp"
              var $and=($9) & 128; //@line 505 "readclause.cpp"
              var $tobool=((($and))|0)!=0; //@line 505 "readclause.cpp"
              if ($tobool) { __lastLabel__ = 8; ; } else { __lastLabel__ = 8; __label__ = 37;break $land_lhs_true$$if_end65thread_pre_split$12; } //@line 505 "readclause.cpp"
  
              $n_bytes=0; //@line 508 "readclause.cpp"
              var $10=$c1; //@line 510 "readclause.cpp"
              var $and10=($10) & 224; //@line 510 "readclause.cpp"
              var $cmp11=((($and10))|0)==192; //@line 510 "readclause.cpp"
              if ($cmp11) { __label__ = 10;; } else { __label__ = 12;; } //@line 510 "readclause.cpp"
              $land_lhs_true12$$if_else16$15: do { 
                if (__label__ == 10) {
  
                  var $11=$c1; //@line 510 "readclause.cpp"
                  var $and13=($11) & 30; //@line 510 "readclause.cpp"
                  var $cmp14=((($and13))|0)!=0; //@line 510 "readclause.cpp"
                  if (!($cmp14)) { __label__ = 12;break $land_lhs_true12$$if_else16$15; } //@line 510 "readclause.cpp"
  
                  $n_bytes=1; //@line 511 "readclause.cpp"
                  __lastLabel__ = 11; __label__ = 17;break $land_lhs_true12$$if_else16$15; //@line 511 "readclause.cpp"
                }
              } while(0);
              $if_end29_thread$$if_else16$18: do { 
                if (__label__ == 12) {
  
                  var $12=$c1; //@line 513 "readclause.cpp"
                  var $and17=($12) & 240; //@line 513 "readclause.cpp"
                  var $cmp18=((($and17))|0)==224; //@line 513 "readclause.cpp"
                  if ($cmp18) { __label__ = 13;; } else { __label__ = 14;; } //@line 513 "readclause.cpp"
                  if (__label__ == 13) {
  
                    $n_bytes=2; //@line 514 "readclause.cpp"
                    __lastLabel__ = 13; __label__ = 17;break $if_end29_thread$$if_else16$18; //@line 514 "readclause.cpp"
                  }
                  else if (__label__ == 14) {
  
                    var $13=$c1; //@line 516 "readclause.cpp"
                    var $and21=($13) & 248; //@line 516 "readclause.cpp"
                    var $cmp22=((($and21))|0)==240; //@line 516 "readclause.cpp"
                    if ($cmp22) { __label__ = 15;; } else { __label__ = 18;; } //@line 516 "readclause.cpp"
                    $land_lhs_true23$$if_end29$23: do { 
                      if (__label__ == 15) {
  
                        var $14=$c1; //@line 516 "readclause.cpp"
                        var $and24=($14) & 15; //@line 516 "readclause.cpp"
                        var $cmp25=((($and24))|0) <= 4; //@line 516 "readclause.cpp"
                        if (!($cmp25)) { __label__ = 18;break $land_lhs_true23$$if_end29$23; } //@line 516 "readclause.cpp"
  
                        $n_bytes=3; //@line 517 "readclause.cpp"
                        __lastLabel__ = 16; __label__ = 17;break $if_end29_thread$$if_else16$18; //@line 517 "readclause.cpp"
                      }
                    } while(0);
  
                    var $_pr=$n_bytes; //@line 519 "readclause.cpp"
                    $ix=$_pr; //@line 519 "readclause.cpp"
                    var $cmp30=((($_pr))|0) > 0; //@line 519 "readclause.cpp"
                    if ($cmp30) { __label__ = 19;break $if_end29_thread$$if_else16$18; } else { __label__ = 33;break $if_end29_thread$$if_else16$18; } //@line 519 "readclause.cpp"
                  }
                }
              } while(0);
              $if_end29_thread$$if_then31$$if_end58$27: do { 
                if (__label__ == 17) {
  
                  var $_ph=__lastLabel__ == 13 ? 2 : (__lastLabel__ == 16 ? 3 : (1));
                  $ix=$_ph; //@line 519 "readclause.cpp"
                  __label__ = 19;break $if_end29_thread$$if_then31$$if_end58$27; //@line 519 "readclause.cpp"
                }
              } while(0);
              $if_then31$$if_end58$29: do { 
                if (__label__ == 19) {
  
                  var $15=$c1; //@line 521 "readclause.cpp"
                  var $16=$ix; //@line 521 "readclause.cpp"
                  var $arrayidx=((__ZZ8utf8_in2PiPKciE4mask+$16)&4294967295); //@line 521 "readclause.cpp"
                  var $17=HEAPU8[($arrayidx)]; //@line 521 "readclause.cpp"
                  var $conv=((($17))&255); //@line 521 "readclause.cpp"
                  var $and32=($conv) & ($15); //@line 521 "readclause.cpp"
                  $c=$and32; //@line 521 "readclause.cpp"
                  var $18=$ix; //@line 522 "readclause.cpp"
                  var $arrayidx33=((__ZZL4GetCvE5mask2+$18)&4294967295); //@line 522 "readclause.cpp"
                  var $19=HEAP8[($arrayidx33)]; //@line 522 "readclause.cpp"
                  $m=$19; //@line 522 "readclause.cpp"
                  __lastLabel__ = 19; ; //@line 523 "readclause.cpp"
                  $while_cond$31: while(1) { 
  
                    var $20=__lastLabel__ == 30 ? $dec : ($18); //@line 523 "readclause.cpp"
                    var $cmp34=((($20))|0) > 0; //@line 523 "readclause.cpp"
                    if (!($cmp34)) { __label__ = 31;break $while_cond$31; } //@line 523 "readclause.cpp"
  
                    var $call35=__ZL8GetC_getv(); //@line 525 "readclause.cpp"
                    var $21=$ix; //@line 525 "readclause.cpp"
                    var $arrayidx36=(($cbuf+$21*4)&4294967295); //@line 525 "readclause.cpp"
                    HEAP32[(($arrayidx36)>>2)]=$call35; //@line 525 "readclause.cpp"
                    $c2=$call35; //@line 525 "readclause.cpp"
                    var $cmp37=((($call35))|0)==0; //@line 525 "readclause.cpp"
                    if ($cmp37) { __label__ = 22;break $while_cond$31; } //@line 525 "readclause.cpp"
  
                    var $23=$c2; //@line 533 "readclause.cpp"
                    var $and43=($23) & 192; //@line 533 "readclause.cpp"
                    var $cmp44=((($and43))|0)!=128; //@line 533 "readclause.cpp"
                    if ($cmp44) { __label__ = 26;break $while_cond$31; } //@line 533 "readclause.cpp"
  
                    $m=-128; //@line 541 "readclause.cpp"
                    var $28=$c; //@line 542 "readclause.cpp"
                    var $shl=((($28)*64)&4294967295); //@line 542 "readclause.cpp"
                    var $29=$c2; //@line 542 "readclause.cpp"
                    var $and53=($29) & 63; //@line 542 "readclause.cpp"
                    var $add=((($and53)+($shl))&4294967295); //@line 542 "readclause.cpp"
                    $c=$add; //@line 542 "readclause.cpp"
                    var $30=$ix; //@line 543 "readclause.cpp"
                    var $dec=((($30)-1)&4294967295); //@line 543 "readclause.cpp"
                    $ix=$dec; //@line 543 "readclause.cpp"
                    __lastLabel__ = 30; __label__ = 20;continue $while_cond$31; //@line 544 "readclause.cpp"
                  }
                  if (__label__ == 22) {
  
                    var $22=HEAP32[((_option_multibyte)>>2)]; //@line 527 "readclause.cpp"
                    var $cmp39=((($22))|0)==0; //@line 527 "readclause.cpp"
                    if ($cmp39) { __label__ = 23;; } else { __label__ = 24;; } //@line 527 "readclause.cpp"
                    if (__label__ == 23) {
  
                      HEAP32[((_option_multibyte)>>2)]=2; //@line 528 "readclause.cpp"
                      ; //@line 528 "readclause.cpp"
                    }
  
                    __ZL10GetC_ungeti(32); //@line 529 "readclause.cpp"
                    ; //@line 530 "readclause.cpp"
                  }
                  else if (__label__ == 26) {
  
                    var $24=$n_bytes; //@line 536 "readclause.cpp"
                    var $cmp46=((($24))|0)==2; //@line 536 "readclause.cpp"
                    if ($cmp46) { __label__ = 27;; } else { __label__ = 29;; } //@line 536 "readclause.cpp"
                    $land_lhs_true47$$if_end51$42: do { 
                      if (__label__ == 27) {
  
                        var $25=$ix; //@line 536 "readclause.cpp"
                        var $cmp48=((($25))|0)==1; //@line 536 "readclause.cpp"
                        if (!($cmp48)) { __label__ = 29;break $land_lhs_true47$$if_end51$42; } //@line 536 "readclause.cpp"
  
                        var $arrayidx50=(($cbuf+8)&4294967295); //@line 537 "readclause.cpp"
                        var $26=HEAP32[(($arrayidx50)>>2)]; //@line 537 "readclause.cpp"
                        HEAP32[((__ZZL4GetCvE6ungot2)>>2)]=$26; //@line 537 "readclause.cpp"
                        ; //@line 537 "readclause.cpp"
                      }
                    } while(0);
  
                    var $27=$c2; //@line 538 "readclause.cpp"
                    __ZL10GetC_ungeti($27); //@line 538 "readclause.cpp"
                    ; //@line 539 "readclause.cpp"
                  }
  
                  var $31=$ix; //@line 545 "readclause.cpp"
                  var $cmp54=((($31))|0)==0; //@line 545 "readclause.cpp"
                  if (!($cmp54)) { __label__ = 33;break $if_then31$$if_end58$29; } //@line 545 "readclause.cpp"
  
                  var $32=HEAP32[((_count_characters)>>2)]; //@line 547 "readclause.cpp"
                  var $inc56=((($32)+1)&4294967295); //@line 547 "readclause.cpp"
                  HEAP32[((_count_characters)>>2)]=$inc56; //@line 547 "readclause.cpp"
                  var $33=$c; //@line 548 "readclause.cpp"
                  $retval=$33; //@line 548 "readclause.cpp"
                  __label__ = 40;break $if_then$$if_end$2; //@line 548 "readclause.cpp"
                }
              } while(0);
  
              var $34=HEAP32[((_option_multibyte)>>2)]; //@line 552 "readclause.cpp"
              var $cmp59=((($34))|0)==0; //@line 552 "readclause.cpp"
              if (!($cmp59)) { __label__ = 36;break $land_lhs_true$$if_end65thread_pre_split$12; } //@line 552 "readclause.cpp"
  
              var $call61=__Z3Eofv(); //@line 552 "readclause.cpp"
              var $tobool62=((($call61))|0)!=0; //@line 552 "readclause.cpp"
              if ($tobool62) { __label__ = 36;break $land_lhs_true$$if_end65thread_pre_split$12; } //@line 552 "readclause.cpp"
  
              HEAP32[((_option_multibyte)>>2)]=2; //@line 553 "readclause.cpp"
              __label__ = 36;break $land_lhs_true$$if_end65thread_pre_split$12; //@line 553 "readclause.cpp"
            }
          } while(0);
          if (__label__ == 36) {
  
            var $_pr2=$c1; //@line 558 "readclause.cpp"
            __lastLabel__ = 36; ;
          }
  
          var $35=__lastLabel__ == 36 ? $_pr2 : ($9); //@line 558 "readclause.cpp"
          var $36=HEAP32[((_count_characters)>>2)]; //@line 557 "readclause.cpp"
          var $inc66=((($36)+1)&4294967295); //@line 557 "readclause.cpp"
          HEAP32[((_count_characters)>>2)]=$inc66; //@line 557 "readclause.cpp"
          var $cmp67=((($35))|0) >= 160; //@line 558 "readclause.cpp"
          var $37=$c1; //@line 559 "readclause.cpp"
          if ($cmp67) { __label__ = 38;; } else { __label__ = 39;; } //@line 558 "readclause.cpp"
          if (__label__ == 38) {
  
            var $sub=((($37)-160)&4294967295); //@line 559 "readclause.cpp"
            var $38=HEAP32[((_translator)>>2)]; //@line 559 "readclause.cpp"
            var $charset_a0=(($38+696)&4294967295); //@line 559 "readclause.cpp"
            var $39=HEAP32[(($charset_a0)>>2)]; //@line 559 "readclause.cpp"
            var $arrayidx69=(($39+2*$sub)&4294967295); //@line 559 "readclause.cpp"
            var $40=HEAPU16[(($arrayidx69)>>1)]; //@line 559 "readclause.cpp"
            var $conv70=((($40))&65535); //@line 559 "readclause.cpp"
            $retval=$conv70; //@line 559 "readclause.cpp"
            ; //@line 559 "readclause.cpp"
          }
          else if (__label__ == 39) {
  
            $retval=$37; //@line 560 "readclause.cpp"
            ; //@line 560 "readclause.cpp"
          }
        }
      }
    } while(0);
  
    var $41=$retval; //@line 561 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $41; //@line 561 "readclause.cpp"
    return null;
  }
  

  function __ZL6UngetCi($c) {
    ;
    var __label__;
  
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 566 "readclause.cpp"
    HEAP32[((__ZL10ungot_char)>>2)]=$0; //@line 566 "readclause.cpp"
    ;
    return; //@line 567 "readclause.cpp"
    return;
  }
  

  function __ZL14ProcessSsmlTagPwPcRiii($xml_buf, $outbuf, $outix, $n_outbuf, $self_closing) {
    var __stackBase__  = STACKTOP; STACKTOP += 376; _memset(__stackBase__, 0, 376);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $xml_buf_addr;
    var $outbuf_addr;
    var $outix_addr;
    var $n_outbuf_addr;
    var $self_closing_addr;
    var $ix;
    var $index;
    var $c;
    var $tag_type;
    var $value;
    var $value2;
    var $value3;
    var $voice_change_flag;
    var $px;
    var $attr1;
    var $attr2;
    var $attr3;
    var $terminator;
    var $uri;
    var $param_type;
    var $tag_name=__stackBase__;
    var $buf=__stackBase__+40;
    var $sp;
    var $ssml_sp;
    var $fname=__stackBase__+120;
    $xml_buf_addr=$xml_buf;
    $outbuf_addr=$outbuf;
    $outix_addr=$outix;
    $n_outbuf_addr=$n_outbuf;
    $self_closing_addr=$self_closing;
    $ix=0; //@line 1659 "readclause.cpp"
    __lastLabel__ = 0; ; //@line 1659 "readclause.cpp"
    $for_cond$2: while(1) { 
  
      var $0=__lastLabel__ == 4 ? $inc : (0); //@line 1659 "readclause.cpp"
      var $cmp=((($0))>>>0) < 39; //@line 1659 "readclause.cpp"
      if (!($cmp)) { __label__ = 5;break $for_cond$2; } //@line 1659 "readclause.cpp"
  
      var $1=$ix; //@line 1661 "readclause.cpp"
      var $2=$xml_buf_addr; //@line 1661 "readclause.cpp"
      var $arrayidx=(($2+4*$1)&4294967295); //@line 1661 "readclause.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 1661 "readclause.cpp"
      $c=$3; //@line 1661 "readclause.cpp"
      var $cmp1=((($3))|0)==0; //@line 1661 "readclause.cpp"
      if ($cmp1) { __label__ = 5;break $for_cond$2; } //@line 1661 "readclause.cpp"
  
      var $4=$c; //@line 1661 "readclause.cpp"
      var $call=_iswspace($4); //@line 1661 "readclause.cpp"
      var $tobool=((($call))|0)!=0; //@line 1661 "readclause.cpp"
      if ($tobool) { __label__ = 5;break $for_cond$2; } //@line 1661 "readclause.cpp"
  
      var $5=$c; //@line 1663 "readclause.cpp"
      var $conv=((($5)) & 255); //@line 1663 "readclause.cpp"
      var $conv2=(tempInt=(($conv)),(tempInt>=128?tempInt-256:tempInt)); //@line 1663 "readclause.cpp"
      var $call3=_tolower($conv2); //@line 1663 "readclause.cpp"
      var $conv4=((($call3)) & 255); //@line 1663 "readclause.cpp"
      var $6=$ix; //@line 1663 "readclause.cpp"
      var $arrayidx5=(($tag_name+$6)&4294967295); //@line 1663 "readclause.cpp"
      HEAP8[($arrayidx5)]=$conv4; //@line 1663 "readclause.cpp"
      var $7=$ix; //@line 1659 "readclause.cpp"
      var $inc=((($7)+1)&4294967295); //@line 1659 "readclause.cpp"
      $ix=$inc; //@line 1659 "readclause.cpp"
      __lastLabel__ = 4; __label__ = 1;continue $for_cond$2; //@line 1659 "readclause.cpp"
    }
  
    var $8=$ix; //@line 1665 "readclause.cpp"
    var $arrayidx6=(($tag_name+$8)&4294967295); //@line 1665 "readclause.cpp"
    HEAP8[($arrayidx6)]=0; //@line 1665 "readclause.cpp"
    var $9=$ix; //@line 1667 "readclause.cpp"
    var $10=$xml_buf_addr; //@line 1667 "readclause.cpp"
    var $arrayidx7=(($10+4*$9)&4294967295); //@line 1667 "readclause.cpp"
    $px=$arrayidx7; //@line 1667 "readclause.cpp"
    var $arrayidx8=(($tag_name)&4294967295); //@line 1669 "readclause.cpp"
    var $11=HEAP8[($arrayidx8)]; //@line 1669 "readclause.cpp"
    var $conv9=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1669 "readclause.cpp"
    var $cmp10=((($conv9))|0)==47; //@line 1669 "readclause.cpp"
    if ($cmp10) { __label__ = 6;; } else { __label__ = 9;; } //@line 1669 "readclause.cpp"
    $if_then11$$if_else$8: do { 
      if (__label__ == 6) {
  
        var $arrayidx12=(($tag_name+1)&4294967295); //@line 1672 "readclause.cpp"
        var $call13=__Z10LookupMnemP8MNEM_TABPKc(((__ZL8ssmltags)&4294967295), $arrayidx12); //@line 1672 "readclause.cpp"
        $tag_type=$call13; //@line 1672 "readclause.cpp"
        var $cmp14=((($call13))|0)!=16; //@line 1672 "readclause.cpp"
        if ($cmp14) { __label__ = 7;; } else { __label__ = 8;; } //@line 1672 "readclause.cpp"
        if (__label__ == 7) {
  
          var $12=$outix_addr; //@line 1674 "readclause.cpp"
          var $13=HEAP32[(($12)>>2)]; //@line 1674 "readclause.cpp"
          var $inc16=((($13)+1)&4294967295); //@line 1674 "readclause.cpp"
          HEAP32[(($12)>>2)]=$inc16; //@line 1674 "readclause.cpp"
          var $14=$outbuf_addr; //@line 1674 "readclause.cpp"
          var $arrayidx17=(($14+$13)&4294967295); //@line 1674 "readclause.cpp"
          HEAP8[($arrayidx17)]=32; //@line 1674 "readclause.cpp"
          ; //@line 1675 "readclause.cpp"
        }
  
        var $15=$tag_type; //@line 1676 "readclause.cpp"
        var $add=((($15)+32)&4294967295); //@line 1676 "readclause.cpp"
        $tag_type=$add; //@line 1676 "readclause.cpp"
        __lastLabel__ = 8; __label__ = 14;break $if_then11$$if_else$8; //@line 1677 "readclause.cpp"
      }
      else if (__label__ == 9) {
  
        var $arraydecay=(($tag_name)&4294967295); //@line 1680 "readclause.cpp"
        var $call19=__Z10LookupMnemP8MNEM_TABPKc(((__ZL8ssmltags)&4294967295), $arraydecay); //@line 1680 "readclause.cpp"
        $tag_type=$call19; //@line 1680 "readclause.cpp"
        var $cmp20=((($call19))|0)!=16; //@line 1680 "readclause.cpp"
        if ($cmp20) { __label__ = 10;; } else { __label__ = 11;; } //@line 1680 "readclause.cpp"
        if (__label__ == 10) {
  
          var $16=$outix_addr; //@line 1683 "readclause.cpp"
          var $17=HEAP32[(($16)>>2)]; //@line 1683 "readclause.cpp"
          var $inc22=((($17)+1)&4294967295); //@line 1683 "readclause.cpp"
          HEAP32[(($16)>>2)]=$inc22; //@line 1683 "readclause.cpp"
          var $18=$outbuf_addr; //@line 1683 "readclause.cpp"
          var $arrayidx23=(($18+$17)&4294967295); //@line 1683 "readclause.cpp"
          HEAP8[($arrayidx23)]=32; //@line 1683 "readclause.cpp"
          ; //@line 1684 "readclause.cpp"
        }
  
        var $19=$self_closing_addr; //@line 1686 "readclause.cpp"
        var $tobool25=((($19))|0)!=0; //@line 1686 "readclause.cpp"
        var $20=$tag_type; //@line 1686 "readclause.cpp"
        if ($tobool25) { __lastLabel__ = 11; ; } else { __lastLabel__ = 11; __label__ = 14;break $if_then11$$if_else$8; } //@line 1686 "readclause.cpp"
  
        var $arrayidx26=((__ZL22ignore_if_self_closing+$20)&4294967295); //@line 1686 "readclause.cpp"
        var $21=HEAP8[($arrayidx26)]; //@line 1686 "readclause.cpp"
        var $tobool27=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1686 "readclause.cpp"
        if ($tobool27) { __lastLabel__ = 12; ; } else { __lastLabel__ = 12; __label__ = 14;break $if_then11$$if_else$8; } //@line 1686 "readclause.cpp"
  
        $retval=0; //@line 1687 "readclause.cpp"
        __label__ = 113;break $if_then11$$if_else$8; //@line 1687 "readclause.cpp"
      }
    } while(0);
    $if_end30$$return$19: do { 
      if (__label__ == 14) {
  
        var $22=__lastLabel__ == 12 ? $20 : (__lastLabel__ == 8 ? $add : ($20)); //@line 1695 "readclause.cpp"
        $voice_change_flag=0; //@line 1691 "readclause.cpp"
        $terminator=16384; //@line 1692 "readclause.cpp"
        var $23=HEAPU32[((__ZL12n_ssml_stack)>>2)]; //@line 1693 "readclause.cpp"
        var $sub=((($23)-1)&4294967295); //@line 1693 "readclause.cpp"
        var $arrayidx31=((__ZL10ssml_stack+$sub*76)&4294967295); //@line 1693 "readclause.cpp"
        $ssml_sp=$arrayidx31; //@line 1693 "readclause.cpp"
        if ($22 == 10) {
          __lastLabel__ = 14; __label__ = 15;;
        }
        else if ($22 == 3) {
          __lastLabel__ = 14; __label__ = 20;;
        }
        else if ($22 == 12) {
          __lastLabel__ = 14; __label__ = 25;;
        }
        else if ($22 == 42) {
          __lastLabel__ = 14; __label__ = 31;;
        }
        else if ($22 == 35) {
          __lastLabel__ = 14; __label__ = 31;;
        }
        else if ($22 == 44) {
          __lastLabel__ = 14; __label__ = 31;;
        }
        else if ($22 == 4) {
          __lastLabel__ = 14; __label__ = 32;;
        }
        else if ($22 == 36) {
          __lastLabel__ = 14; __label__ = 39;;
        }
        else if ($22 == 9) {
          __lastLabel__ = 14; __label__ = 42;;
        }
        else if ($22 == 14) {
          __lastLabel__ = 14; __label__ = 44;;
        }
        else if ($22 == 41) {
          __lastLabel__ = 14; __label__ = 45;;
        }
        else if ($22 == 46) {
          __lastLabel__ = 14; __label__ = 45;;
        }
        else if ($22 == 5) {
          __lastLabel__ = 14; __label__ = 46;;
        }
        else if ($22 == 11) {
          __lastLabel__ = 14; __label__ = 51;;
        }
        else if ($22 == 43) {
          __lastLabel__ = 14; __label__ = 66;;
        }
        else if ($22 == 13) {
          __lastLabel__ = 14; __label__ = 67;;
        }
        else if ($22 == 1) {
          __lastLabel__ = 14; __label__ = 79;;
        }
        else if ($22 == 2) {
          __lastLabel__ = 14; __label__ = 85;;
        }
        else if ($22 == 33) {
          __lastLabel__ = 14; __label__ = 88;;
        }
        else if ($22 == 34) {
          __lastLabel__ = 14; __label__ = 92;;
        }
        else if ($22 == 15) {
          __lastLabel__ = 14; __label__ = 96;;
        }
        else if ($22 == 47) {
          __lastLabel__ = 14; __label__ = 96;;
        }
        else if ($22 == 6) {
          __lastLabel__ = 14; __label__ = 97;;
        }
        else if ($22 == 7) {
          __lastLabel__ = 14; __label__ = 100;;
        }
        else if ($22 == 38) {
          __lastLabel__ = 14; __label__ = 105;;
        }
        else if ($22 == 39) {
          __lastLabel__ = 14; __label__ = 108;;
        }
        else {
        __lastLabel__ = 14; __label__ = 112;;
        }
        
        $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21: do { 
          if (__label__ == 15) {
  
            var $24=$tag_type; //@line 1698 "readclause.cpp"
            var $call32=__ZL14PushParamStacki($24); //@line 1698 "readclause.cpp"
            $sp=$call32; //@line 1698 "readclause.cpp"
            var $25=$px; //@line 1699 "readclause.cpp"
            var $call33=__ZL16GetSsmlAttributePwPKc($25, ((__str83250)&4294967295)); //@line 1699 "readclause.cpp"
            $attr1=$call33; //@line 1699 "readclause.cpp"
            var $26=$px; //@line 1700 "readclause.cpp"
            var $call34=__ZL16GetSsmlAttributePwPKc($26, ((__str84251)&4294967295)); //@line 1700 "readclause.cpp"
            $attr2=$call34; //@line 1700 "readclause.cpp"
            var $27=$attr1; //@line 1703 "readclause.cpp"
            var $call35=__ZL7attrcmpPKwPKc($27, ((__str85252)&4294967295)); //@line 1703 "readclause.cpp"
            var $cmp36=((($call35))|0)==0; //@line 1703 "readclause.cpp"
            if ($cmp36) { __label__ = 16;; } else { __label__ = 17;; } //@line 1703 "readclause.cpp"
            $if_then37$$if_else40$23: do { 
              if (__label__ == 16) {
  
                var $28=$attr2; //@line 1705 "readclause.cpp"
                var $call38=__ZL10attrlookupPKwPK8MNEM_TAB($28, ((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct)&4294967295)); //@line 1705 "readclause.cpp"
                $value=$call38; //@line 1705 "readclause.cpp"
                var $29=$value; //@line 1706 "readclause.cpp"
                var $30=$sp; //@line 1706 "readclause.cpp"
                var $parameter=(($30+4)&4294967295); //@line 1706 "readclause.cpp"
                var $arrayidx39=(($parameter+20)&4294967295); //@line 1706 "readclause.cpp"
                HEAP32[(($arrayidx39)>>2)]=$29; //@line 1706 "readclause.cpp"
                ; //@line 1707 "readclause.cpp"
              }
              else if (__label__ == 17) {
  
                var $31=$attr1; //@line 1709 "readclause.cpp"
                var $call41=__ZL7attrcmpPKwPKc($31, ((__str86253)&4294967295)); //@line 1709 "readclause.cpp"
                var $cmp42=((($call41))|0)==0; //@line 1709 "readclause.cpp"
                if (!($cmp42)) { __label__ = 19;break $if_then37$$if_else40$23; } //@line 1709 "readclause.cpp"
  
                var $32=$attr2; //@line 1711 "readclause.cpp"
                var $call44=__ZL10attrlookupPKwPK8MNEM_TAB($32, ((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals)&4294967295)); //@line 1711 "readclause.cpp"
                $value=$call44; //@line 1711 "readclause.cpp"
                var $33=$value; //@line 1712 "readclause.cpp"
                var $34=$sp; //@line 1712 "readclause.cpp"
                var $parameter45=(($34+4)&4294967295); //@line 1712 "readclause.cpp"
                var $arrayidx46=(($parameter45+24)&4294967295); //@line 1712 "readclause.cpp"
                HEAP32[(($arrayidx46)>>2)]=$33; //@line 1712 "readclause.cpp"
                ; //@line 1713 "readclause.cpp"
              }
            } while(0);
  
            var $35=$outbuf_addr; //@line 1714 "readclause.cpp"
            var $36=$outix_addr; //@line 1714 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($35, $36); //@line 1714 "readclause.cpp"
            ; //@line 1715 "readclause.cpp"
          }
          else if (__label__ == 20) {
  
            var $37=$tag_type; //@line 1718 "readclause.cpp"
            var $call50=__ZL14PushParamStacki($37); //@line 1718 "readclause.cpp"
            $sp=$call50; //@line 1718 "readclause.cpp"
            $param_type=1; //@line 1721 "readclause.cpp"
            ; //@line 1721 "readclause.cpp"
            while(1) { 
  
              var $38=$px; //@line 1723 "readclause.cpp"
              var $39=$param_type; //@line 1723 "readclause.cpp"
              var $arrayidx54=((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+$39*4)&4294967295); //@line 1723 "readclause.cpp"
              var $40=HEAP32[(($arrayidx54)>>2)]; //@line 1723 "readclause.cpp"
              var $call55=__ZL16GetSsmlAttributePwPKc($38, $40); //@line 1723 "readclause.cpp"
              $attr1=$call55; //@line 1723 "readclause.cpp"
              var $cmp56=((($call55))|0)!=0; //@line 1723 "readclause.cpp"
              if ($cmp56) { __label__ = 22;; } else { __label__ = 23;; } //@line 1723 "readclause.cpp"
              if (__label__ == 22) {
  
                var $41=$param_type; //@line 1725 "readclause.cpp"
                var $42=$attr1; //@line 1725 "readclause.cpp"
                var $43=$sp; //@line 1725 "readclause.cpp"
                __ZL19SetProsodyParameteriPwP11PARAM_STACK($41, $42, $43); //@line 1725 "readclause.cpp"
                ; //@line 1726 "readclause.cpp"
              }
  
              var $44=$param_type; //@line 1721 "readclause.cpp"
              var $inc60=((($44)+1)&4294967295); //@line 1721 "readclause.cpp"
              $param_type=$inc60; //@line 1721 "readclause.cpp"
              var $cmp52=((($inc60))|0) <= 4; //@line 1721 "readclause.cpp"
              if ($cmp52) { __label__ = 21;continue ; } else { __label__ = 24;break ; } //@line 1721 "readclause.cpp"
            }
  
            var $45=$outbuf_addr; //@line 1729 "readclause.cpp"
            var $46=$outix_addr; //@line 1729 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($45, $46); //@line 1729 "readclause.cpp"
            ; //@line 1730 "readclause.cpp"
          }
          else if (__label__ == 25) {
  
            var $47=$tag_type; //@line 1733 "readclause.cpp"
            var $call63=__ZL14PushParamStacki($47); //@line 1733 "readclause.cpp"
            $sp=$call63; //@line 1733 "readclause.cpp"
            $value=3; //@line 1734 "readclause.cpp"
            var $48=$px; //@line 1735 "readclause.cpp"
            var $call64=__ZL16GetSsmlAttributePwPKc($48, ((__str87254)&4294967295)); //@line 1735 "readclause.cpp"
            $attr1=$call64; //@line 1735 "readclause.cpp"
            var $cmp65=((($call64))|0)!=0; //@line 1735 "readclause.cpp"
            if ($cmp65) { __label__ = 26;; } else { __label__ = 27;; } //@line 1735 "readclause.cpp"
            if (__label__ == 26) {
  
              var $49=$attr1; //@line 1737 "readclause.cpp"
              var $call67=__ZL10attrlookupPKwPK8MNEM_TAB($49, ((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis)&4294967295)); //@line 1737 "readclause.cpp"
              $value=$call67; //@line 1737 "readclause.cpp"
              ; //@line 1738 "readclause.cpp"
            }
  
            var $50=HEAP32[((_translator)>>2)]; //@line 1740 "readclause.cpp"
            var $langopts=(($50)&4294967295); //@line 1740 "readclause.cpp"
            var $tone_language=(($langopts+224)&4294967295); //@line 1740 "readclause.cpp"
            var $51=HEAP32[(($tone_language)>>2)]; //@line 1740 "readclause.cpp"
            var $cmp69=((($51))|0)==1; //@line 1740 "readclause.cpp"
            var $52=$value; //@line 1745 "readclause.cpp"
            if ($cmp69) { __label__ = 28;; } else { __label__ = 29;; } //@line 1740 "readclause.cpp"
            if (__label__ == 28) {
  
              var $arrayidx71=((__ZZL14ProcessSsmlTagPwPcRiiiE23emphasis_to_pitch_range+$52)&4294967295); //@line 1745 "readclause.cpp"
              var $53=HEAPU8[($arrayidx71)]; //@line 1745 "readclause.cpp"
              var $conv72=((($53))&255); //@line 1745 "readclause.cpp"
              var $54=$sp; //@line 1745 "readclause.cpp"
              var $parameter73=(($54+4)&4294967295); //@line 1745 "readclause.cpp"
              var $arrayidx74=(($parameter73+16)&4294967295); //@line 1745 "readclause.cpp"
              HEAP32[(($arrayidx74)>>2)]=$conv72; //@line 1745 "readclause.cpp"
              var $55=$value; //@line 1746 "readclause.cpp"
              var $arrayidx75=((__ZZL14ProcessSsmlTagPwPcRiiiE18emphasis_to_volume+$55)&4294967295); //@line 1746 "readclause.cpp"
              var $56=HEAPU8[($arrayidx75)]; //@line 1746 "readclause.cpp"
              var $conv76=((($56))&255); //@line 1746 "readclause.cpp"
              var $57=$sp; //@line 1746 "readclause.cpp"
              var $parameter77=(($57+4)&4294967295); //@line 1746 "readclause.cpp"
              var $arrayidx78=(($parameter77+8)&4294967295); //@line 1746 "readclause.cpp"
              HEAP32[(($arrayidx78)>>2)]=$conv76; //@line 1746 "readclause.cpp"
              ; //@line 1747 "readclause.cpp"
            }
            else if (__label__ == 29) {
  
              var $58=$sp; //@line 1750 "readclause.cpp"
              var $parameter80=(($58+4)&4294967295); //@line 1750 "readclause.cpp"
              var $arrayidx81=(($parameter80+48)&4294967295); //@line 1750 "readclause.cpp"
              HEAP32[(($arrayidx81)>>2)]=$52; //@line 1750 "readclause.cpp"
              ;
            }
  
            var $59=$outbuf_addr; //@line 1752 "readclause.cpp"
            var $60=$outix_addr; //@line 1752 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($59, $60); //@line 1752 "readclause.cpp"
            ; //@line 1753 "readclause.cpp"
          }
          else if (__label__ == 31) {
  
            var $61=$tag_type; //@line 1758 "readclause.cpp"
            var $62=$outbuf_addr; //@line 1758 "readclause.cpp"
            var $63=$outix_addr; //@line 1758 "readclause.cpp"
            __ZL13PopParamStackiPcRi($61, $62, $63); //@line 1758 "readclause.cpp"
            ; //@line 1759 "readclause.cpp"
          }
          else if (__label__ == 32) {
  
            var $64=$px; //@line 1762 "readclause.cpp"
            var $call85=__ZL16GetSsmlAttributePwPKc($64, ((__str88255)&4294967295)); //@line 1762 "readclause.cpp"
            $attr1=$call85; //@line 1762 "readclause.cpp"
            var $65=$px; //@line 1763 "readclause.cpp"
            var $call86=__ZL16GetSsmlAttributePwPKc($65, ((__str89256)&4294967295)); //@line 1763 "readclause.cpp"
            $attr2=$call86; //@line 1763 "readclause.cpp"
            var $66=$px; //@line 1764 "readclause.cpp"
            var $call87=__ZL16GetSsmlAttributePwPKc($66, ((__str90257)&4294967295)); //@line 1764 "readclause.cpp"
            $attr3=$call87; //@line 1764 "readclause.cpp"
            var $67=$attr1; //@line 1765 "readclause.cpp"
            var $call88=__ZL10attrlookupPKwPK8MNEM_TAB($67, ((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as)&4294967295)); //@line 1765 "readclause.cpp"
            $value=$call88; //@line 1765 "readclause.cpp"
            var $68=$attr2; //@line 1766 "readclause.cpp"
            var $call89=__ZL10attrlookupPKwPK8MNEM_TAB($68, ((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format)&4294967295)); //@line 1766 "readclause.cpp"
            $value2=$call89; //@line 1766 "readclause.cpp"
            var $69=$value2; //@line 1767 "readclause.cpp"
            var $cmp90=((($69))|0)==1; //@line 1767 "readclause.cpp"
            if ($cmp90) { __label__ = 33;; } else { __label__ = 34;; } //@line 1767 "readclause.cpp"
            if (__label__ == 33) {
  
              $value=19; //@line 1768 "readclause.cpp"
              ; //@line 1768 "readclause.cpp"
            }
  
            var $70=$attr3; //@line 1770 "readclause.cpp"
            var $call93=__ZL10attrnumberPKwii($70, 0, 0); //@line 1770 "readclause.cpp"
            $value3=$call93; //@line 1770 "readclause.cpp"
            var $71=$value; //@line 1772 "readclause.cpp"
            var $cmp94=((($71))|0)==64; //@line 1772 "readclause.cpp"
            if ($cmp94) { __label__ = 35;; } else { __label__ = 38;; } //@line 1772 "readclause.cpp"
            if (__label__ == 35) {
  
              var $72=$value3; //@line 1774 "readclause.cpp"
              var $cmp96=((($72))|0) <= 1; //@line 1774 "readclause.cpp"
              if ($cmp96) { __label__ = 36;; } else { __label__ = 37;; } //@line 1774 "readclause.cpp"
              if (__label__ == 36) {
  
                $value=193; //@line 1775 "readclause.cpp"
                ; //@line 1775 "readclause.cpp"
              }
              else if (__label__ == 37) {
  
                var $73=$value3; //@line 1777 "readclause.cpp"
                var $add99=((($73)+64)&4294967295); //@line 1777 "readclause.cpp"
                $value=$add99; //@line 1777 "readclause.cpp"
                ;
              }
            }
  
            var $arraydecay102=(($buf)&4294967295); //@line 1780 "readclause.cpp"
            var $74=$value; //@line 1780 "readclause.cpp"
            var $call103=_sprintf($arraydecay102, ((__str91258)&4294967295), allocate([1,0,0,0,$74,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1780 "readclause.cpp"
            var $75=$outix_addr; //@line 1781 "readclause.cpp"
            var $76=HEAP32[(($75)>>2)]; //@line 1781 "readclause.cpp"
            var $77=$outbuf_addr; //@line 1781 "readclause.cpp"
            var $arrayidx104=(($77+$76)&4294967295); //@line 1781 "readclause.cpp"
            var $arraydecay105=(($buf)&4294967295); //@line 1781 "readclause.cpp"
            var $call106=_strcpy($arrayidx104, $arraydecay105); //@line 1781 "readclause.cpp"
            var $arraydecay107=(($buf)&4294967295); //@line 1782 "readclause.cpp"
            var $call108=_strlen($arraydecay107); //@line 1782 "readclause.cpp"
            var $78=$outix_addr; //@line 1782 "readclause.cpp"
            var $79=HEAP32[(($78)>>2)]; //@line 1782 "readclause.cpp"
            var $add109=((($79)+($call108))&4294967295); //@line 1782 "readclause.cpp"
            HEAP32[(($78)>>2)]=$add109; //@line 1782 "readclause.cpp"
            var $80=$outix_addr; //@line 1784 "readclause.cpp"
            var $81=HEAP32[(($80)>>2)]; //@line 1784 "readclause.cpp"
            HEAP32[((__ZL11sayas_start)>>2)]=$81; //@line 1784 "readclause.cpp"
            var $82=$value; //@line 1785 "readclause.cpp"
            HEAP32[((__ZL10sayas_mode)>>2)]=$82; //@line 1785 "readclause.cpp"
            ; //@line 1786 "readclause.cpp"
          }
          else if (__label__ == 39) {
  
            var $83=HEAP32[((__ZL10sayas_mode)>>2)]; //@line 1789 "readclause.cpp"
            var $cmp111=((($83))|0)==36; //@line 1789 "readclause.cpp"
            if ($cmp111) { __label__ = 40;; } else { __label__ = 41;; } //@line 1789 "readclause.cpp"
            if (__label__ == 40) {
  
              var $84=$outix_addr; //@line 1791 "readclause.cpp"
              var $85=HEAP32[(($84)>>2)]; //@line 1791 "readclause.cpp"
              var $86=$outbuf_addr; //@line 1791 "readclause.cpp"
              var $arrayidx113=(($86+$85)&4294967295); //@line 1791 "readclause.cpp"
              HEAP8[($arrayidx113)]=0; //@line 1791 "readclause.cpp"
              var $87=$outbuf_addr; //@line 1792 "readclause.cpp"
              var $88=HEAP32[((__ZL11sayas_start)>>2)]; //@line 1792 "readclause.cpp"
              var $89=$outix_addr; //@line 1792 "readclause.cpp"
              __ZL14ReplaceKeyNamePciRi($87, $88, $89); //@line 1792 "readclause.cpp"
              ; //@line 1793 "readclause.cpp"
            }
  
            var $90=$outix_addr; //@line 1795 "readclause.cpp"
            var $91=HEAP32[(($90)>>2)]; //@line 1795 "readclause.cpp"
            var $inc116=((($91)+1)&4294967295); //@line 1795 "readclause.cpp"
            HEAP32[(($90)>>2)]=$inc116; //@line 1795 "readclause.cpp"
            var $92=$outbuf_addr; //@line 1795 "readclause.cpp"
            var $arrayidx117=(($92+$91)&4294967295); //@line 1795 "readclause.cpp"
            HEAP8[($arrayidx117)]=1; //@line 1795 "readclause.cpp"
            var $93=$outix_addr; //@line 1796 "readclause.cpp"
            var $94=HEAP32[(($93)>>2)]; //@line 1796 "readclause.cpp"
            var $inc118=((($94)+1)&4294967295); //@line 1796 "readclause.cpp"
            HEAP32[(($93)>>2)]=$inc118; //@line 1796 "readclause.cpp"
            var $95=$outbuf_addr; //@line 1796 "readclause.cpp"
            var $arrayidx119=(($95+$94)&4294967295); //@line 1796 "readclause.cpp"
            HEAP8[($arrayidx119)]=89; //@line 1796 "readclause.cpp"
            HEAP32[((__ZL10sayas_mode)>>2)]=0; //@line 1797 "readclause.cpp"
            ; //@line 1798 "readclause.cpp"
          }
          else if (__label__ == 42) {
  
            var $96=$px; //@line 1801 "readclause.cpp"
            var $call121=__ZL16GetSsmlAttributePwPKc($96, ((__str92259)&4294967295)); //@line 1801 "readclause.cpp"
            $attr1=$call121; //@line 1801 "readclause.cpp"
            var $cmp122=((($call121))|0)!=0; //@line 1801 "readclause.cpp"
            if (!($cmp122)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1801 "readclause.cpp"
  
            HEAP8[(__ZL11ignore_text_b)]=1;
            var $97=$outix_addr; //@line 1805 "readclause.cpp"
            var $98=HEAP32[(($97)>>2)]; //@line 1805 "readclause.cpp"
            var $99=$outbuf_addr; //@line 1805 "readclause.cpp"
            var $arrayidx124=(($99+$98)&4294967295); //@line 1805 "readclause.cpp"
            var $100=$attr1; //@line 1805 "readclause.cpp"
            var $101=$n_outbuf_addr; //@line 1805 "readclause.cpp"
            var $102=$outix_addr; //@line 1805 "readclause.cpp"
            var $103=HEAP32[(($102)>>2)]; //@line 1805 "readclause.cpp"
            var $sub125=((($101)-($103))&4294967295); //@line 1805 "readclause.cpp"
            var $call126=__ZL13attrcopy_utf8PcPKwi($arrayidx124, $100, $sub125); //@line 1805 "readclause.cpp"
            var $104=$outix_addr; //@line 1805 "readclause.cpp"
            var $105=HEAP32[(($104)>>2)]; //@line 1805 "readclause.cpp"
            var $add127=((($105)+($call126))&4294967295); //@line 1805 "readclause.cpp"
            HEAP32[(($104)>>2)]=$add127; //@line 1805 "readclause.cpp"
            ; //@line 1806 "readclause.cpp"
          }
          else if (__label__ == 44) {
  
            HEAP8[(__ZL11ignore_text_b)]=1;
            ; //@line 1811 "readclause.cpp"
          }
          else if (__label__ == 45) {
  
            HEAP8[(__ZL11ignore_text_b)]=0;
            ; //@line 1816 "readclause.cpp"
          }
          else if (__label__ == 46) {
  
            var $106=$px; //@line 1819 "readclause.cpp"
            var $call132=__ZL16GetSsmlAttributePwPKc($106, ((__str5655)&4294967295)); //@line 1819 "readclause.cpp"
            $attr1=$call132; //@line 1819 "readclause.cpp"
            var $cmp133=((($call132))|0)!=0; //@line 1819 "readclause.cpp"
            if (!($cmp133)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1819 "readclause.cpp"
  
            var $arraydecay135=(($buf)&4294967295); //@line 1822 "readclause.cpp"
            var $107=$attr1; //@line 1822 "readclause.cpp"
            var $call136=__ZL13attrcopy_utf8PcPKwi($arraydecay135, $107, 80); //@line 1822 "readclause.cpp"
            var $arraydecay137=(($buf)&4294967295); //@line 1824 "readclause.cpp"
            var $call138=_strcmp(((_skip_marker)&4294967295), $arraydecay137); //@line 1824 "readclause.cpp"
            var $cmp139=((($call138))|0)==0; //@line 1824 "readclause.cpp"
            if ($cmp139) { __label__ = 48;; } else { __label__ = 49;; } //@line 1824 "readclause.cpp"
            if (__label__ == 48) {
  
              HEAP8[(__ZL19clear_skipping_text_b)]=1;
              HEAP8[(((_skip_marker)&4294967295))]=0; //@line 1828 "readclause.cpp"
              $retval=16384; //@line 1829 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1829 "readclause.cpp"
            }
            else if (__label__ == 49) {
  
              var $arraydecay142=(($buf)&4294967295); //@line 1832 "readclause.cpp"
              var $call143=__Z11AddNameDataPKci($arraydecay142, 0); //@line 1832 "readclause.cpp"
              $index=$call143; //@line 1832 "readclause.cpp"
              var $cmp144=((($call143))|0) >= 0; //@line 1832 "readclause.cpp"
              if (!($cmp144)) { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1832 "readclause.cpp"
  
              var $arraydecay146=(($buf)&4294967295); //@line 1834 "readclause.cpp"
              var $108=$index; //@line 1834 "readclause.cpp"
              var $call147=_sprintf($arraydecay146, ((__str94261)&4294967295), allocate([1,0,0,0,$108,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1834 "readclause.cpp"
              var $109=$outix_addr; //@line 1835 "readclause.cpp"
              var $110=HEAP32[(($109)>>2)]; //@line 1835 "readclause.cpp"
              var $111=$outbuf_addr; //@line 1835 "readclause.cpp"
              var $arrayidx148=(($111+$110)&4294967295); //@line 1835 "readclause.cpp"
              var $arraydecay149=(($buf)&4294967295); //@line 1835 "readclause.cpp"
              var $call150=_strcpy($arrayidx148, $arraydecay149); //@line 1835 "readclause.cpp"
              var $arraydecay151=(($buf)&4294967295); //@line 1836 "readclause.cpp"
              var $call152=_strlen($arraydecay151); //@line 1836 "readclause.cpp"
              var $112=$outix_addr; //@line 1836 "readclause.cpp"
              var $113=HEAP32[(($112)>>2)]; //@line 1836 "readclause.cpp"
              var $add153=((($113)+($call152))&4294967295); //@line 1836 "readclause.cpp"
              HEAP32[(($112)>>2)]=$add153; //@line 1836 "readclause.cpp"
              ; //@line 1837 "readclause.cpp"
            }
          }
          else if (__label__ == 51) {
  
            var $114=$tag_type; //@line 1842 "readclause.cpp"
            var $call157=__ZL14PushParamStacki($114); //@line 1842 "readclause.cpp"
            $sp=$call157; //@line 1842 "readclause.cpp"
            var $115=$px; //@line 1844 "readclause.cpp"
            var $call158=__ZL16GetSsmlAttributePwPKc($115, ((__str95262)&4294967295)); //@line 1844 "readclause.cpp"
            $attr1=$call158; //@line 1844 "readclause.cpp"
            var $cmp159=((($call158))|0)!=0; //@line 1844 "readclause.cpp"
            if ($cmp159) { __label__ = 52;; } else { __label__ = 62;; } //@line 1844 "readclause.cpp"
            $if_then160$$if_end215$69: do { 
              if (__label__ == 52) {
  
                var $arraydecay161=(($buf)&4294967295); //@line 1847 "readclause.cpp"
                var $116=$attr1; //@line 1847 "readclause.cpp"
                var $call162=__ZL13attrcopy_utf8PcPKwi($arraydecay161, $116, 80); //@line 1847 "readclause.cpp"
                var $117=HEAP32[((_uri_callback)>>2)]; //@line 1849 "readclause.cpp"
                var $cmp163=((($117))|0)==0; //@line 1849 "readclause.cpp"
                if ($cmp163) { __label__ = 53;; } else { __label__ = 59;; } //@line 1849 "readclause.cpp"
                if (__label__ == 53) {
  
                  var $118=HEAP32[((__ZL7xmlbase)>>2)]; //@line 1851 "readclause.cpp"
                  var $cmp165=((($118))|0)!=0; //@line 1851 "readclause.cpp"
                  if ($cmp165) { __label__ = 54;; } else { __label__ = 56;; } //@line 1851 "readclause.cpp"
                  $land_lhs_true166$$if_else176$73: do { 
                    if (__label__ == 54) {
  
                      var $arrayidx167=(($buf)&4294967295); //@line 1851 "readclause.cpp"
                      var $119=HEAP8[($arrayidx167)]; //@line 1851 "readclause.cpp"
                      var $conv168=(tempInt=(($119)),(tempInt>=128?tempInt-256:tempInt)); //@line 1851 "readclause.cpp"
                      var $cmp169=((($conv168))|0)!=47; //@line 1851 "readclause.cpp"
                      if (!($cmp169)) { __label__ = 56;break $land_lhs_true166$$if_else176$73; } //@line 1851 "readclause.cpp"
  
                      var $arraydecay171=(($fname)&4294967295); //@line 1853 "readclause.cpp"
                      var $120=HEAP32[((__ZL7xmlbase)>>2)]; //@line 1853 "readclause.cpp"
                      var $arraydecay172=(($buf)&4294967295); //@line 1853 "readclause.cpp"
                      var $call173=_sprintf($arraydecay171, ((__str96263)&4294967295), allocate([$120,0,0,0,$arraydecay172,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1853 "readclause.cpp"
                      var $arraydecay174=(($fname)&4294967295); //@line 1854 "readclause.cpp"
                      var $call175=__ZL14LoadSoundFile2PKc($arraydecay174); //@line 1854 "readclause.cpp"
                      $index=$call175; //@line 1854 "readclause.cpp"
                      __lastLabel__ = 55; __label__ = 57;break $land_lhs_true166$$if_else176$73; //@line 1855 "readclause.cpp"
                    }
                  } while(0);
                  if (__label__ == 56) {
  
                    var $arraydecay177=(($buf)&4294967295); //@line 1858 "readclause.cpp"
                    var $call178=__ZL14LoadSoundFile2PKc($arraydecay177); //@line 1858 "readclause.cpp"
                    $index=$call178; //@line 1858 "readclause.cpp"
                    __lastLabel__ = 56; ;
                  }
  
                  var $121=__lastLabel__ == 56 ? $call178 : ($call175); //@line 1860 "readclause.cpp"
                  var $cmp180=((($121))|0) >= 0; //@line 1860 "readclause.cpp"
                  if (!($cmp180)) { __label__ = 62;break $if_then160$$if_end215$69; } //@line 1860 "readclause.cpp"
  
                  var $arraydecay182=(($buf)&4294967295); //@line 1862 "readclause.cpp"
                  var $122=$index; //@line 1862 "readclause.cpp"
                  var $call183=_sprintf($arraydecay182, ((__str97264)&4294967295), allocate([1,0,0,0,$122,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1862 "readclause.cpp"
                  var $123=$outix_addr; //@line 1863 "readclause.cpp"
                  var $124=HEAP32[(($123)>>2)]; //@line 1863 "readclause.cpp"
                  var $125=$outbuf_addr; //@line 1863 "readclause.cpp"
                  var $arrayidx184=(($125+$124)&4294967295); //@line 1863 "readclause.cpp"
                  var $arraydecay185=(($buf)&4294967295); //@line 1863 "readclause.cpp"
                  var $call186=_strcpy($arrayidx184, $arraydecay185); //@line 1863 "readclause.cpp"
                  var $arraydecay187=(($buf)&4294967295); //@line 1864 "readclause.cpp"
                  var $call188=_strlen($arraydecay187); //@line 1864 "readclause.cpp"
                  var $126=$outix_addr; //@line 1864 "readclause.cpp"
                  var $127=HEAP32[(($126)>>2)]; //@line 1864 "readclause.cpp"
                  var $add189=((($127)+($call188))&4294967295); //@line 1864 "readclause.cpp"
                  HEAP32[(($126)>>2)]=$add189; //@line 1864 "readclause.cpp"
                  var $128=$sp; //@line 1865 "readclause.cpp"
                  var $parameter190=(($128+4)&4294967295); //@line 1865 "readclause.cpp"
                  var $arrayidx191=(($parameter190)&4294967295); //@line 1865 "readclause.cpp"
                  HEAP32[(($arrayidx191)>>2)]=1; //@line 1865 "readclause.cpp"
                  ; //@line 1866 "readclause.cpp"
                }
                else if (__label__ == 59) {
  
                  var $arraydecay194=(($buf)&4294967295); //@line 1870 "readclause.cpp"
                  var $call195=__Z11AddNameDataPKci($arraydecay194, 0); //@line 1870 "readclause.cpp"
                  $index=$call195; //@line 1870 "readclause.cpp"
                  var $cmp196=((($call195))|0) >= 0; //@line 1870 "readclause.cpp"
                  if (!($cmp196)) { __label__ = 62;break $if_then160$$if_end215$69; } //@line 1870 "readclause.cpp"
  
                  var $129=$index; //@line 1872 "readclause.cpp"
                  var $130=HEAP32[((_namedata)>>2)]; //@line 1872 "readclause.cpp"
                  var $arrayidx198=(($130+$129)&4294967295); //@line 1872 "readclause.cpp"
                  $uri=$arrayidx198; //@line 1872 "readclause.cpp"
                  var $131=HEAP32[((_uri_callback)>>2)]; //@line 1873 "readclause.cpp"
                  var $132=$uri; //@line 1873 "readclause.cpp"
                  var $133=HEAP32[((__ZL7xmlbase)>>2)]; //@line 1873 "readclause.cpp"
                  var $call199=FUNCTION_TABLE[$131](1, $132, $133); //@line 1873 "readclause.cpp"
                  var $cmp200=((($call199))|0)==0; //@line 1873 "readclause.cpp"
                  if (!($cmp200)) { __label__ = 62;break $if_then160$$if_end215$69; } //@line 1873 "readclause.cpp"
  
                  var $arraydecay202=(($buf)&4294967295); //@line 1875 "readclause.cpp"
                  var $134=$index; //@line 1875 "readclause.cpp"
                  var $call203=_sprintf($arraydecay202, ((__str98265)&4294967295), allocate([1,0,0,0,$134,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1875 "readclause.cpp"
                  var $135=$outix_addr; //@line 1876 "readclause.cpp"
                  var $136=HEAP32[(($135)>>2)]; //@line 1876 "readclause.cpp"
                  var $137=$outbuf_addr; //@line 1876 "readclause.cpp"
                  var $arrayidx204=(($137+$136)&4294967295); //@line 1876 "readclause.cpp"
                  var $arraydecay205=(($buf)&4294967295); //@line 1876 "readclause.cpp"
                  var $call206=_strcpy($arrayidx204, $arraydecay205); //@line 1876 "readclause.cpp"
                  var $arraydecay207=(($buf)&4294967295); //@line 1877 "readclause.cpp"
                  var $call208=_strlen($arraydecay207); //@line 1877 "readclause.cpp"
                  var $138=$outix_addr; //@line 1877 "readclause.cpp"
                  var $139=HEAP32[(($138)>>2)]; //@line 1877 "readclause.cpp"
                  var $add209=((($139)+($call208))&4294967295); //@line 1877 "readclause.cpp"
                  HEAP32[(($138)>>2)]=$add209; //@line 1877 "readclause.cpp"
                  var $140=$sp; //@line 1878 "readclause.cpp"
                  var $parameter210=(($140+4)&4294967295); //@line 1878 "readclause.cpp"
                  var $arrayidx211=(($parameter210)&4294967295); //@line 1878 "readclause.cpp"
                  HEAP32[(($arrayidx211)>>2)]=1; //@line 1878 "readclause.cpp"
                  ; //@line 1879 "readclause.cpp"
                }
              }
            } while(0);
  
            var $141=$outbuf_addr; //@line 1883 "readclause.cpp"
            var $142=$outix_addr; //@line 1883 "readclause.cpp"
            __ZL17ProcessParamStackPcRi($141, $142); //@line 1883 "readclause.cpp"
            var $143=$self_closing_addr; //@line 1885 "readclause.cpp"
            var $tobool216=((($143))|0)!=0; //@line 1885 "readclause.cpp"
            if ($tobool216) { __label__ = 63;; } else { __label__ = 64;; } //@line 1885 "readclause.cpp"
            if (__label__ == 63) {
  
              var $144=$tag_type; //@line 1886 "readclause.cpp"
              var $145=$outbuf_addr; //@line 1886 "readclause.cpp"
              var $146=$outix_addr; //@line 1886 "readclause.cpp"
              __ZL13PopParamStackiPcRi($144, $145, $146); //@line 1886 "readclause.cpp"
              ; //@line 1886 "readclause.cpp"
            }
            else if (__label__ == 64) {
  
              HEAP8[(__ZL10audio_text_b)]=1;
              ;
            }
  
            $retval=16384; //@line 1889 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1889 "readclause.cpp"
          }
          else if (__label__ == 66) {
  
            var $147=$tag_type; //@line 1892 "readclause.cpp"
            var $148=$outbuf_addr; //@line 1892 "readclause.cpp"
            var $149=$outix_addr; //@line 1892 "readclause.cpp"
            __ZL13PopParamStackiPcRi($147, $148, $149); //@line 1892 "readclause.cpp"
            HEAP8[(__ZL10audio_text_b)]=0;
            $retval=16384; //@line 1894 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1894 "readclause.cpp"
          }
          else if (__label__ == 67) {
  
            $value=21; //@line 1897 "readclause.cpp"
            $terminator=16384; //@line 1898 "readclause.cpp"
            var $150=$px; //@line 1900 "readclause.cpp"
            var $call222=__ZL16GetSsmlAttributePwPKc($150, ((__str99266)&4294967295)); //@line 1900 "readclause.cpp"
            $attr1=$call222; //@line 1900 "readclause.cpp"
            var $cmp223=((($call222))|0)!=0; //@line 1900 "readclause.cpp"
            if ($cmp223) { __label__ = 68;; } else { __label__ = 71;; } //@line 1900 "readclause.cpp"
            if (__label__ == 68) {
  
              var $151=$attr1; //@line 1903 "readclause.cpp"
              var $call225=__ZL10attrlookupPKwPK8MNEM_TAB($151, ((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break)&4294967295)); //@line 1903 "readclause.cpp"
              $value=$call225; //@line 1903 "readclause.cpp"
              var $152=$value; //@line 1904 "readclause.cpp"
              var $cmp226=((($152))|0) < 3; //@line 1904 "readclause.cpp"
              if ($cmp226) { __label__ = 69;; } else { __label__ = 70;; } //@line 1904 "readclause.cpp"
              if (__label__ == 69) {
  
                var $153=$outix_addr; //@line 1907 "readclause.cpp"
                var $154=HEAP32[(($153)>>2)]; //@line 1907 "readclause.cpp"
                var $155=$outbuf_addr; //@line 1907 "readclause.cpp"
                var $arrayidx228=(($155+$154)&4294967295); //@line 1907 "readclause.cpp"
                var $156=$value; //@line 1907 "readclause.cpp"
                var $call229=_sprintf($arrayidx228, ((__str100267)&4294967295), allocate([1,0,0,0,$156,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1907 "readclause.cpp"
                var $157=$outix_addr; //@line 1908 "readclause.cpp"
                var $158=HEAP32[(($157)>>2)]; //@line 1908 "readclause.cpp"
                var $add230=((($158)+3)&4294967295); //@line 1908 "readclause.cpp"
                HEAP32[(($157)>>2)]=$add230; //@line 1908 "readclause.cpp"
                $terminator=0; //@line 1909 "readclause.cpp"
                ; //@line 1910 "readclause.cpp"
              }
  
              var $159=$value; //@line 1911 "readclause.cpp"
              var $arrayidx232=((__ZZL14ProcessSsmlTagPwPcRiiiE11break_value+$159*4)&4294967295); //@line 1911 "readclause.cpp"
              var $160=HEAP32[(($arrayidx232)>>2)]; //@line 1911 "readclause.cpp"
              $value=$160; //@line 1911 "readclause.cpp"
              ; //@line 1912 "readclause.cpp"
            }
  
            var $161=$px; //@line 1913 "readclause.cpp"
            var $call234=__ZL16GetSsmlAttributePwPKc($161, ((__str101268)&4294967295)); //@line 1913 "readclause.cpp"
            $attr2=$call234; //@line 1913 "readclause.cpp"
            var $cmp235=((($call234))|0)!=0; //@line 1913 "readclause.cpp"
            if ($cmp235) { __label__ = 72;; } else { __label__ = 74;; } //@line 1913 "readclause.cpp"
            $if_then236$$if_end241$96: do { 
              if (__label__ == 72) {
  
                var $162=$attr2; //@line 1915 "readclause.cpp"
                var $call237=__ZL10attrnumberPKwii($162, 0, 1); //@line 1915 "readclause.cpp"
                var $mul=((($call237)*25)&4294967295); //@line 1915 "readclause.cpp"
                var $163=HEAP32[((((_speed)&4294967295))>>2)]; //@line 1915 "readclause.cpp"
                var $div=((((($mul))|0)/((($163))|0))|0); //@line 1915 "readclause.cpp"
                $value=$div; //@line 1915 "readclause.cpp"
                var $164=$terminator; //@line 1917 "readclause.cpp"
                var $cmp238=((($164))|0)==0; //@line 1917 "readclause.cpp"
                if ($cmp238) { __lastLabel__ = 72; ; } else { __lastLabel__ = 72; __label__ = 76;break $if_then236$$if_end241$96; } //@line 1917 "readclause.cpp"
  
                $terminator=16384; //@line 1918 "readclause.cpp"
                __label__ = 75;break $if_then236$$if_end241$96; //@line 1918 "readclause.cpp"
              }
              else if (__label__ == 74) {
  
                var $_pr1=$terminator; //@line 1920 "readclause.cpp"
                var $tobool242=((($_pr1))|0)!=0; //@line 1920 "readclause.cpp"
                if ($tobool242) { __label__ = 75;break $if_then236$$if_end241$96; } else { __label__ = 112;break $sw_epilog$$sw_bb$$sw_bb49$$sw_bb62$$sw_bb83$$sw_bb84$$sw_bb110$$sw_bb120$$sw_bb129$$sw_bb130$$sw_bb131$$sw_bb156$$sw_bb220$$sw_bb221$$sw_bb249$$sw_bb266$$while_cond$$while_cond280$$sw_bb293$$sw_bb294$$sw_bb302$$sw_bb317$$sw_bb324$21; } //@line 1920 "readclause.cpp"
              }
            } while(0);
            if (__label__ == 75) {
  
              var $_pr3=$value; //@line 1922 "readclause.cpp"
              __lastLabel__ = 75; ;
            }
  
            var $165=__lastLabel__ == 75 ? $_pr3 : ($div); //@line 1922 "readclause.cpp"
            var $cmp244=((($165))|0) > 4095; //@line 1922 "readclause.cpp"
            if ($cmp244) { __label__ = 77;; } else { __label__ = 78;; } //@line 1922 "readclause.cpp"
            if (__label__ == 77) {
  
              $value=4095; //@line 1923 "readclause.cpp"
              ; //@line 1923 "readclause.cpp"
            }
  
            var $166=$terminator; //@line 1924 "readclause.cpp"
            var $167=$value; //@line 1924 "readclause.cpp"
            var $add247=((($167)+($166))&4294967295); //@line 1924 "readclause.cpp"
            $retval=$add247; //@line 1924 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1924 "readclause.cpp"
          }
          else if (__label__ == 79) {
  
            var $168=$px; //@line 1929 "readclause.cpp"
            var $call250=__ZL16GetSsmlAttributePwPKc($168, ((__str102269)&4294967295)); //@line 1929 "readclause.cpp"
            $attr1=$call250; //@line 1929 "readclause.cpp"
            var $cmp251=((($call250))|0)!=0; //@line 1929 "readclause.cpp"
            if ($cmp251) { __label__ = 80;; } else { __label__ = 82;; } //@line 1929 "readclause.cpp"
            $if_then252$$if_end261$107: do { 
              if (__label__ == 80) {
  
                var $arraydecay253=(($buf)&4294967295); //@line 1931 "readclause.cpp"
                var $169=$attr1; //@line 1931 "readclause.cpp"
                var $call254=__ZL13attrcopy_utf8PcPKwi($arraydecay253, $169, 80); //@line 1931 "readclause.cpp"
                var $arraydecay255=(($buf)&4294967295); //@line 1932 "readclause.cpp"
                var $call256=__Z11AddNameDataPKci($arraydecay255, 0); //@line 1932 "readclause.cpp"
                $index=$call256; //@line 1932 "readclause.cpp"
                var $cmp257=((($call256))|0) >= 0; //@line 1932 "readclause.cpp"
                if (!($cmp257)) { __label__ = 82;break $if_then252$$if_end261$107; } //@line 1932 "readclause.cpp"
  
                var $170=$index; //@line 1934 "readclause.cpp"
                var $171=HEAP32[((_namedata)>>2)]; //@line 1934 "readclause.cpp"
                var $arrayidx259=(($171+$170)&4294967295); //@line 1934 "readclause.cpp"
                HEAP32[((__ZL7xmlbase)>>2)]=$arrayidx259; //@line 1934 "readclause.cpp"
                ; //@line 1935 "readclause.cpp"
              }
            } while(0);
  
            var $172=$px; //@line 1937 "readclause.cpp"
            var $173=$tag_type; //@line 1937 "readclause.cpp"
            var $call262=__ZL18GetVoiceAttributesPwi($172, $173); //@line 1937 "readclause.cpp"
            var $cmp263=((($call262))|0)==0; //@line 1937 "readclause.cpp"
            if ($cmp263) { __label__ = 83;; } else { __label__ = 84;; } //@line 1937 "readclause.cpp"
            if (__label__ == 83) {
  
              $retval=0; //@line 1938 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1938 "readclause.cpp"
            }
            else if (__label__ == 84) {
  
              $retval=147456; //@line 1939 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1939 "readclause.cpp"
            }
          }
          else if (__label__ == 85) {
  
            var $174=$px; //@line 1942 "readclause.cpp"
            var $175=$tag_type; //@line 1942 "readclause.cpp"
            var $call267=__ZL18GetVoiceAttributesPwi($174, $175); //@line 1942 "readclause.cpp"
            var $cmp268=((($call267))|0)==0; //@line 1942 "readclause.cpp"
            if ($cmp268) { __label__ = 86;; } else { __label__ = 87;; } //@line 1942 "readclause.cpp"
            if (__label__ == 86) {
  
              $retval=0; //@line 1943 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1943 "readclause.cpp"
            }
            else if (__label__ == 87) {
  
              $retval=147456; //@line 1944 "readclause.cpp"
              __label__ = 113;break $if_end30$$return$19; //@line 1944 "readclause.cpp"
            }
          }
          else if (__label__ == 88) {
            while(1) { 
  
              var $176=__lastLabel__ == 90 ? $dec : ($23); //@line 1948 "readclause.cpp"
              var $cmp272=((($176))|0) > 1; //@line 1948 "readclause.cpp"
              if (!($cmp272)) { __label__ = 91;break ; } //@line 1948 "readclause.cpp"
  
              var $177=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1948 "readclause.cpp"
              var $sub273=((($177)-1)&4294967295); //@line 1948 "readclause.cpp"
              var $arrayidx274=((__ZL10ssml_stack+$sub273*76)&4294967295); //@line 1948 "readclause.cpp"
              var $tag_type275=(($arrayidx274)&4294967295); //@line 1948 "readclause.cpp"
              var $178=HEAP32[(($tag_type275)>>2)]; //@line 1948 "readclause.cpp"
              var $cmp276=((($178))|0)!=1; //@line 1948 "readclause.cpp"
              if (!($cmp276)) { __label__ = 91;break ; }
  
              var $179=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1950 "readclause.cpp"
              var $dec=((($179)-1)&4294967295); //@line 1950 "readclause.cpp"
              HEAP32[((__ZL12n_ssml_stack)>>2)]=$dec; //@line 1950 "readclause.cpp"
              __lastLabel__ = 90; __label__ = 88;continue ; //@line 1951 "readclause.cpp"
            }
  
            var $180=$px; //@line 1952 "readclause.cpp"
            var $181=$tag_type; //@line 1952 "readclause.cpp"
            var $call277=__ZL18GetVoiceAttributesPwi($180, $181); //@line 1952 "readclause.cpp"
            var $add278=((($call277)+524328)&4294967295); //@line 1952 "readclause.cpp"
            $retval=$add278; //@line 1952 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1952 "readclause.cpp"
          }
          else if (__label__ == 92) {
            while(1) { 
  
              var $182=__lastLabel__ == 94 ? $dec289 : ($23); //@line 1956 "readclause.cpp"
              var $cmp281=((($182))|0) > 1; //@line 1956 "readclause.cpp"
              if (!($cmp281)) { __label__ = 95;break ; } //@line 1956 "readclause.cpp"
  
              var $183=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1956 "readclause.cpp"
              var $sub283=((($183)-1)&4294967295); //@line 1956 "readclause.cpp"
              var $arrayidx284=((__ZL10ssml_stack+$sub283*76)&4294967295); //@line 1956 "readclause.cpp"
              var $tag_type285=(($arrayidx284)&4294967295); //@line 1956 "readclause.cpp"
              var $184=HEAP32[(($tag_type285)>>2)]; //@line 1956 "readclause.cpp"
              var $cmp286=((($184))|0)!=2; //@line 1956 "readclause.cpp"
              if (!($cmp286)) { __label__ = 95;break ; }
  
              var $185=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1958 "readclause.cpp"
              var $dec289=((($185)-1)&4294967295); //@line 1958 "readclause.cpp"
              HEAP32[((__ZL12n_ssml_stack)>>2)]=$dec289; //@line 1958 "readclause.cpp"
              __lastLabel__ = 94; __label__ = 92;continue ; //@line 1959 "readclause.cpp"
            }
  
            $terminator=0; //@line 1961 "readclause.cpp"
            var $186=$terminator; //@line 1962 "readclause.cpp"
            var $187=$px; //@line 1962 "readclause.cpp"
            var $188=$tag_type; //@line 1962 "readclause.cpp"
            var $call291=__ZL18GetVoiceAttributesPwi($187, $188); //@line 1962 "readclause.cpp"
            var $add292=((($call291)+($186))&4294967295); //@line 1962 "readclause.cpp"
            $retval=$add292; //@line 1962 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1962 "readclause.cpp"
          }
          else if (__label__ == 96) {
  
            $retval=262174; //@line 1966 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1966 "readclause.cpp"
          }
          else if (__label__ == 97) {
  
            var $189=$ssml_sp; //@line 1969 "readclause.cpp"
            var $tag_type295=(($189)&4294967295); //@line 1969 "readclause.cpp"
            var $190=HEAP32[(($tag_type295)>>2)]; //@line 1969 "readclause.cpp"
            var $cmp296=((($190))|0)==6; //@line 1969 "readclause.cpp"
            if ($cmp296) { __label__ = 98;; } else { __label__ = 99;; } //@line 1969 "readclause.cpp"
            if (__label__ == 98) {
  
              var $191=$px; //@line 1972 "readclause.cpp"
              var $call298=__ZL18GetVoiceAttributesPwi($191, 38); //@line 1972 "readclause.cpp"
              $voice_change_flag=$call298; //@line 1972 "readclause.cpp"
              ; //@line 1973 "readclause.cpp"
            }
  
            var $192=$px; //@line 1974 "readclause.cpp"
            var $193=$tag_type; //@line 1974 "readclause.cpp"
            var $call300=__ZL18GetVoiceAttributesPwi($192, $193); //@line 1974 "readclause.cpp"
            var $194=$voice_change_flag; //@line 1974 "readclause.cpp"
            var $or=($194) | ($call300); //@line 1974 "readclause.cpp"
            $voice_change_flag=$or; //@line 1974 "readclause.cpp"
            var $195=$voice_change_flag; //@line 1975 "readclause.cpp"
            var $add301=((($195)+524358)&4294967295); //@line 1975 "readclause.cpp"
            $retval=$add301; //@line 1975 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1975 "readclause.cpp"
          }
          else if (__label__ == 100) {
  
            var $196=$ssml_sp; //@line 1979 "readclause.cpp"
            var $tag_type303=(($196)&4294967295); //@line 1979 "readclause.cpp"
            var $197=HEAP32[(($tag_type303)>>2)]; //@line 1979 "readclause.cpp"
            var $cmp304=((($197))|0)==6; //@line 1979 "readclause.cpp"
            if ($cmp304) { __label__ = 101;; } else { __label__ = 102;; } //@line 1979 "readclause.cpp"
            if (__label__ == 101) {
  
              var $198=$px; //@line 1982 "readclause.cpp"
              var $call306=__ZL18GetVoiceAttributesPwi($198, 38); //@line 1982 "readclause.cpp"
              $voice_change_flag=$call306; //@line 1982 "readclause.cpp"
              ; //@line 1983 "readclause.cpp"
            }
  
            var $199=$ssml_sp; //@line 1984 "readclause.cpp"
            var $tag_type308=(($199)&4294967295); //@line 1984 "readclause.cpp"
            var $200=HEAP32[(($tag_type308)>>2)]; //@line 1984 "readclause.cpp"
            var $cmp309=((($200))|0)==7; //@line 1984 "readclause.cpp"
            if ($cmp309) { __label__ = 103;; } else { __label__ = 104;; } //@line 1984 "readclause.cpp"
            if (__label__ == 103) {
  
              var $201=$px; //@line 1987 "readclause.cpp"
              var $call311=__ZL18GetVoiceAttributesPwi($201, 39); //@line 1987 "readclause.cpp"
              var $202=$voice_change_flag; //@line 1987 "readclause.cpp"
              var $or312=($202) | ($call311); //@line 1987 "readclause.cpp"
              $voice_change_flag=$or312; //@line 1987 "readclause.cpp"
              ; //@line 1988 "readclause.cpp"
            }
  
            var $203=$px; //@line 1989 "readclause.cpp"
            var $204=$tag_type; //@line 1989 "readclause.cpp"
            var $call314=__ZL18GetVoiceAttributesPwi($203, $204); //@line 1989 "readclause.cpp"
            var $205=$voice_change_flag; //@line 1989 "readclause.cpp"
            var $or315=($205) | ($call314); //@line 1989 "readclause.cpp"
            $voice_change_flag=$or315; //@line 1989 "readclause.cpp"
            var $206=$voice_change_flag; //@line 1990 "readclause.cpp"
            var $add316=((($206)+524358)&4294967295); //@line 1990 "readclause.cpp"
            $retval=$add316; //@line 1990 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1990 "readclause.cpp"
          }
          else if (__label__ == 105) {
  
            var $207=$ssml_sp; //@line 1994 "readclause.cpp"
            var $tag_type318=(($207)&4294967295); //@line 1994 "readclause.cpp"
            var $208=HEAP32[(($tag_type318)>>2)]; //@line 1994 "readclause.cpp"
            var $cmp319=((($208))|0)==6; //@line 1994 "readclause.cpp"
            if ($cmp319) { __label__ = 106;; } else { __label__ = 107;; } //@line 1994 "readclause.cpp"
            if (__label__ == 106) {
  
              var $209=$px; //@line 1997 "readclause.cpp"
              var $210=$tag_type; //@line 1997 "readclause.cpp"
              var $call321=__ZL18GetVoiceAttributesPwi($209, $210); //@line 1997 "readclause.cpp"
              $voice_change_flag=$call321; //@line 1997 "readclause.cpp"
              ; //@line 1998 "readclause.cpp"
            }
  
            var $211=$voice_change_flag; //@line 1999 "readclause.cpp"
            var $add323=((($211)+524328)&4294967295); //@line 1999 "readclause.cpp"
            $retval=$add323; //@line 1999 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 1999 "readclause.cpp"
          }
          else if (__label__ == 108) {
  
            var $212=$ssml_sp; //@line 2003 "readclause.cpp"
            var $tag_type325=(($212)&4294967295); //@line 2003 "readclause.cpp"
            var $213=HEAP32[(($tag_type325)>>2)]; //@line 2003 "readclause.cpp"
            var $cmp326=((($213))|0)==6; //@line 2003 "readclause.cpp"
            if ($cmp326) { __label__ = 110;; } else { __label__ = 109;; } //@line 2003 "readclause.cpp"
            $if_then330$$lor_lhs_false327$145: do { 
              if (__label__ == 109) {
  
                var $214=$ssml_sp; //@line 2003 "readclause.cpp"
                var $tag_type328=(($214)&4294967295); //@line 2003 "readclause.cpp"
                var $215=HEAP32[(($tag_type328)>>2)]; //@line 2003 "readclause.cpp"
                var $cmp329=((($215))|0)==7; //@line 2003 "readclause.cpp"
                if ($cmp329) { __label__ = 110;break $if_then330$$lor_lhs_false327$145; } //@line 2003 "readclause.cpp"
  
                $retval=524358; //@line 2009 "readclause.cpp"
                __label__ = 113;break $if_end30$$return$19; //@line 2009 "readclause.cpp"
              }
            } while(0);
  
            var $216=$px; //@line 2007 "readclause.cpp"
            var $217=$tag_type; //@line 2007 "readclause.cpp"
            var $call331=__ZL18GetVoiceAttributesPwi($216, $217); //@line 2007 "readclause.cpp"
            var $add332=((($call331)+524358)&4294967295); //@line 2007 "readclause.cpp"
            $retval=$add332; //@line 2007 "readclause.cpp"
            __label__ = 113;break $if_end30$$return$19; //@line 2007 "readclause.cpp"
          }
        } while(0);
  
        $retval=0; //@line 2011 "readclause.cpp"
        ; //@line 2011 "readclause.cpp"
      }
    } while(0);
  
    var $218=$retval; //@line 2012 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $218; //@line 2012 "readclause.cpp"
    return null;
  }
  

  function __ZL13LookupSpecialP10TranslatorPKcPc($tr, $text_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 124; _memset(__stackBase__, 0, 124);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $string_addr;
    var $text_out_addr;
    var $flags=__stackBase__;
    var $phonemes=__stackBase__+8;
    var $phonemes2=__stackBase__+64;
    var $string1=__stackBase__+120;
    $tr_addr=$tr;
    $string_addr=((__str6303)&4294967295);
    $text_out_addr=$text_out;
    var $0=$string_addr; //@line 593 "readclause.cpp"
    HEAP32[(($string1)>>2)]=$0; //@line 593 "readclause.cpp"
    var $arrayidx=(($flags+4)&4294967295); //@line 595 "readclause.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 595 "readclause.cpp"
    var $arrayidx1=(($flags)&4294967295); //@line 595 "readclause.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 595 "readclause.cpp"
    var $1=$tr_addr; //@line 596 "readclause.cpp"
    var $arraydecay=(($phonemes)&4294967295); //@line 596 "readclause.cpp"
    var $arraydecay2=(($flags)&4294967295); //@line 596 "readclause.cpp"
    var $call=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($1, $string1, $arraydecay, $arraydecay2, 0, 0); //@line 596 "readclause.cpp"
    var $tobool=((($call))|0)!=0; //@line 596 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 596 "readclause.cpp"
    if (__label__ == 1) {
  
      var $2=$tr_addr; //@line 598 "readclause.cpp"
      var $arraydecay3=(($phonemes)&4294967295); //@line 598 "readclause.cpp"
      var $arraydecay4=(($flags)&4294967295); //@line 598 "readclause.cpp"
      __Z13SetWordStressP10TranslatorPcPjii($2, $arraydecay3, $arraydecay4, -1, 0); //@line 598 "readclause.cpp"
      var $arraydecay5=(($phonemes)&4294967295); //@line 599 "readclause.cpp"
      var $arraydecay6=(($phonemes2)&4294967295); //@line 599 "readclause.cpp"
      __Z14DecodePhonemesPKcPc($arraydecay5, $arraydecay6); //@line 599 "readclause.cpp"
      var $3=$text_out_addr; //@line 600 "readclause.cpp"
      var $arraydecay7=(($phonemes2)&4294967295); //@line 600 "readclause.cpp"
      var $call8=_sprintf($3, ((__str60227)&4294967295), allocate([$arraydecay7,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 600 "readclause.cpp"
      var $4=$text_out_addr; //@line 601 "readclause.cpp"
      $retval=$4; //@line 601 "readclause.cpp"
      ; //@line 601 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 603 "readclause.cpp"
      ; //@line 603 "readclause.cpp"
    }
  
    var $5=$retval; //@line 604 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 604 "readclause.cpp"
    return null;
  }
  

  function __ZL10RemoveCharPc($p) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $p_addr;
    var $c=__stackBase__;
    $p_addr=$p;
    var $0=$p_addr; //@line 2020 "readclause.cpp"
    var $1=$p_addr; //@line 2020 "readclause.cpp"
    var $call=__Z7utf8_inPiPKc($c, $1); //@line 2020 "readclause.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $0;
    $stop$ = $dest$ + $call;
    $value4$ = 32;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 32;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 32;
    }; //@line 2020 "readclause.cpp"
    STACKTOP = __stackBase__;
    return; //@line 2021 "readclause.cpp"
    return;
  }
  

  function __ZL19AnnouncePunctuationP10TranslatoriPiPcS1_i($tr, $c1, $c2_ptr, $output, $bufix, $end_clause) {
    var __stackBase__  = STACKTOP; STACKTOP += 280; _memset(__stackBase__, 0, 280);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $c1_addr;
    var $c2_ptr_addr;
    var $output_addr;
    var $bufix_addr;
    var $end_clause_addr;
    var $punct_count;
    var $punctname;
    var $found;
    var $soundicon;
    var $attributes;
    var $short_pause;
    var $c2;
    var $len;
    var $bufix1;
    var $buf=__stackBase__;
    var $buf2=__stackBase__+200;
    $tr_addr=$tr;
    $c1_addr=$c1;
    $c2_ptr_addr=$c2_ptr;
    $output_addr=$output;
    $bufix_addr=$bufix;
    $end_clause_addr=$end_clause;
    $found=0; //@line 863 "readclause.cpp"
    var $0=$c2_ptr_addr; //@line 873 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 873 "readclause.cpp"
    $c2=$1; //@line 873 "readclause.cpp"
    var $arrayidx=(($buf)&4294967295); //@line 874 "readclause.cpp"
    HEAP8[($arrayidx)]=0; //@line 874 "readclause.cpp"
    var $2=$c1_addr; //@line 876 "readclause.cpp"
    var $call=__ZL15LookupSoundiconi($2); //@line 876 "readclause.cpp"
    $soundicon=$call; //@line 876 "readclause.cpp"
    var $cmp=((($call))|0) >= 0; //@line 876 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 876 "readclause.cpp"
    $if_end63_thread$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay=(($buf)&4294967295); //@line 879 "readclause.cpp"
        var $3=$soundicon; //@line 879 "readclause.cpp"
        var $call1=_sprintf($arraydecay, ((__str50217)&4294967295), allocate([$3,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 879 "readclause.cpp"
        var $4=$c2; //@line 880 "readclause.cpp"
        __ZL6UngetCi($4); //@line 880 "readclause.cpp"
        $found=1; //@line 881 "readclause.cpp"
        __label__ = 26;break $if_end63_thread$$if_else$2; //@line 946 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $5=$tr_addr; //@line 884 "readclause.cpp"
        var $6=$c1_addr; //@line 884 "readclause.cpp"
        __ZL14LookupCharNameP10Translatorii($5, $6, 0); //@line 884 "readclause.cpp"
        $punctname=((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295); //@line 884 "readclause.cpp"
        $found=1; //@line 886 "readclause.cpp"
        var $7=$bufix_addr; //@line 887 "readclause.cpp"
        var $8=HEAP32[(($7)>>2)]; //@line 887 "readclause.cpp"
        var $cmp5=((($8))|0)==0; //@line 887 "readclause.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 3;; } //@line 887 "readclause.cpp"
        $if_then9$$lor_lhs_false$5: do { 
          if (__label__ == 3) {
  
            var $9=$end_clause_addr; //@line 887 "readclause.cpp"
            var $cmp6=((($9))|0)==0; //@line 887 "readclause.cpp"
            if ($cmp6) { __label__ = 5;break $if_then9$$lor_lhs_false$5; } //@line 887 "readclause.cpp"
  
            var $10=$tr_addr; //@line 887 "readclause.cpp"
            var $langopts=(($10)&4294967295); //@line 887 "readclause.cpp"
            var $param=(($langopts+24)&4294967295); //@line 887 "readclause.cpp"
            var $arrayidx8=(($param+68)&4294967295); //@line 887 "readclause.cpp"
            var $11=HEAP32[(($arrayidx8)>>2)]; //@line 887 "readclause.cpp"
            var $and=($11) & 2; //@line 887 "readclause.cpp"
            var $tobool=((($and))|0)!=0; //@line 887 "readclause.cpp"
            if ($tobool) { __label__ = 5;break $if_then9$$lor_lhs_false$5; } //@line 887 "readclause.cpp"
  
            var $34=$c2; //@line 934 "readclause.cpp"
            __ZL6UngetCi($34); //@line 934 "readclause.cpp"
            var $35=HEAP32[((_option_ssml)>>2)]; //@line 935 "readclause.cpp"
            var $tobool51=((($35))|0)!=0; //@line 935 "readclause.cpp"
            if ($tobool51) { __label__ = 21;; } else { __label__ = 23;; } //@line 935 "readclause.cpp"
            $if_then52$$if_end58$9: do { 
              if (__label__ == 21) {
  
                var $36=$c1_addr; //@line 937 "readclause.cpp"
                var $cmp53=((($36))|0)==60; //@line 937 "readclause.cpp"
                var $37=$c1_addr; //@line 937 "readclause.cpp"
                var $cmp55=((($37))|0)==38; //@line 937 "readclause.cpp"
                var $or_cond=($cmp53) | ($cmp55); //@line 937 "readclause.cpp"
                if (!($or_cond)) { __label__ = 23;break $if_then52$$if_end58$9; } //@line 937 "readclause.cpp"
  
                var $38=$c1_addr; //@line 938 "readclause.cpp"
                HEAP32[((__ZL19ssml_ignore_l_angle)>>2)]=$38; //@line 938 "readclause.cpp"
                ; //@line 938 "readclause.cpp"
              }
            } while(0);
  
            var $39=$c1_addr; //@line 940 "readclause.cpp"
            HEAP32[((__ZL11ungot_char2)>>2)]=$39; //@line 940 "readclause.cpp"
            var $arrayidx59=(($buf)&4294967295); //@line 941 "readclause.cpp"
            HEAP8[($arrayidx59)]=32; //@line 941 "readclause.cpp"
            var $arrayidx60=(($buf+1)&4294967295); //@line 942 "readclause.cpp"
            HEAP8[($arrayidx60)]=0; //@line 942 "readclause.cpp"
            __label__ = 24;break $if_then9$$lor_lhs_false$5;
          }
        } while(0);
        $if_then9$$if_end63$13: do { 
          if (__label__ == 5) {
  
            $punct_count=1; //@line 889 "readclause.cpp"
            var $12=$c2; //@line 890 "readclause.cpp"
            var $13=$c1_addr; //@line 890 "readclause.cpp"
            var $cmp105=((($12))|0)==((($13))|0); //@line 890 "readclause.cpp"
            var $14=$c1_addr; //@line 890 "readclause.cpp"
            var $cmp116=((($14))|0)!=60; //@line 890 "readclause.cpp"
            var $or_cond17=($cmp105) & ($cmp116); //@line 890 "readclause.cpp"
            if ($or_cond17) { __label__ = 6;; } else { __label__ = 7;; } //@line 890 "readclause.cpp"
            $while_body$$while_end$15: do { 
              if (__label__ == 6) {
                while(1) { 
  
                  var $15=$punct_count; //@line 892 "readclause.cpp"
                  var $inc=((($15)+1)&4294967295); //@line 892 "readclause.cpp"
                  $punct_count=$inc; //@line 892 "readclause.cpp"
                  var $call12=__ZL4GetCv(); //@line 893 "readclause.cpp"
                  $c2=$call12; //@line 893 "readclause.cpp"
                  var $16=$c2; //@line 890 "readclause.cpp"
                  var $17=$c1_addr; //@line 890 "readclause.cpp"
                  var $cmp10=((($16))|0)==((($17))|0); //@line 890 "readclause.cpp"
                  var $18=$c1_addr; //@line 890 "readclause.cpp"
                  var $cmp11=((($18))|0)!=60; //@line 890 "readclause.cpp"
                  var $or_cond1=($cmp10) & ($cmp11); //@line 890 "readclause.cpp"
                  if ($or_cond1) { __label__ = 6;continue ; } else { __label__ = 7;break $while_body$$while_end$15; } //@line 890 "readclause.cpp"
                }
              }
            } while(0);
  
            var $19=$c2; //@line 895 "readclause.cpp"
            var $20=$c2_ptr_addr; //@line 895 "readclause.cpp"
            HEAP32[(($20)>>2)]=$19; //@line 895 "readclause.cpp"
            var $21=$end_clause_addr; //@line 896 "readclause.cpp"
            var $tobool13=((($21))|0)!=0; //@line 896 "readclause.cpp"
            if ($tobool13) { __label__ = 8;; } else { __label__ = 9;; } //@line 896 "readclause.cpp"
            if (__label__ == 8) {
  
              var $22=$c2; //@line 898 "readclause.cpp"
              __ZL6UngetCi($22); //@line 898 "readclause.cpp"
              ; //@line 899 "readclause.cpp"
            }
  
            var $23=$punct_count; //@line 901 "readclause.cpp"
            var $cmp15=((($23))|0)==1; //@line 901 "readclause.cpp"
            if ($cmp15) { __label__ = 10;; } else { __label__ = 11;; } //@line 901 "readclause.cpp"
            if (__label__ == 10) {
  
              var $arraydecay17=(($buf)&4294967295); //@line 904 "readclause.cpp"
              var $24=$punctname; //@line 904 "readclause.cpp"
              var $call18=_sprintf($arraydecay17, ((__str51218)&4294967295), allocate([$24,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 904 "readclause.cpp"
              ; //@line 905 "readclause.cpp"
            }
            else if (__label__ == 11) {
  
              var $25=$punct_count; //@line 907 "readclause.cpp"
              var $cmp20=((($25))|0) < 4; //@line 907 "readclause.cpp"
              var $arrayidx22=(($buf)&4294967295); //@line 909 "readclause.cpp"
              if ($cmp20) { __label__ = 12;; } else { __label__ = 19;; } //@line 907 "readclause.cpp"
              if (__label__ == 12) {
  
                HEAP8[($arrayidx22)]=0; //@line 909 "readclause.cpp"
                var $26=HEAP32[((((_embedded_value+8)&4294967295))>>2)]; //@line 910 "readclause.cpp"
                var $cmp23=((($26))|0) < 300; //@line 910 "readclause.cpp"
                if ($cmp23) { __label__ = 13;; } else { __label__ = 14;; } //@line 910 "readclause.cpp"
                if (__label__ == 13) {
  
                  var $arraydecay25=(($buf)&4294967295); //@line 911 "readclause.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = ((__str52219)&4294967295);
                  $dest$ = $arraydecay25;
                  $stop$ = $src$ + 6;
                  if (($dest$%4) == ($src$%4) && 6 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 911 "readclause.cpp"
                  ; //@line 911 "readclause.cpp"
                }
  
                var $27=$punct_count; //@line 913 "readclause.cpp"
                var $dec3=((($27)-1)&4294967295); //@line 913 "readclause.cpp"
                $punct_count=$dec3; //@line 913 "readclause.cpp"
                var $cmp294=((($27))|0) > 0; //@line 913 "readclause.cpp"
                if ($cmp294) { __label__ = 15;; } else { __label__ = 17;; } //@line 913 "readclause.cpp"
                $while_body30_lr_ph$$while_end36$30: do { 
                  if (__label__ == 15) {
  
                    var $arraydecay31=(($buf2)&4294967295); //@line 915 "readclause.cpp"
                    var $arraydecay33=(($buf)&4294967295); //@line 916 "readclause.cpp"
                    var $arraydecay34=(($buf2)&4294967295); //@line 916 "readclause.cpp"
                    ; //@line 913 "readclause.cpp"
                    while(1) { 
  
                      var $28=$punctname; //@line 915 "readclause.cpp"
                      var $call32=_sprintf($arraydecay31, ((__str51218)&4294967295), allocate([$28,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 915 "readclause.cpp"
                      var $call35=_strcat($arraydecay33, $arraydecay34); //@line 916 "readclause.cpp"
                      var $29=$punct_count; //@line 913 "readclause.cpp"
                      var $dec=((($29)-1)&4294967295); //@line 913 "readclause.cpp"
                      $punct_count=$dec; //@line 913 "readclause.cpp"
                      var $cmp29=((($29))|0) > 0; //@line 913 "readclause.cpp"
                      if ($cmp29) { __label__ = 16;continue ; } else { __label__ = 17;break $while_body30_lr_ph$$while_end36$30; } //@line 913 "readclause.cpp"
                    }
                  }
                } while(0);
  
                var $30=HEAP32[((((_embedded_value+8)&4294967295))>>2)]; //@line 919 "readclause.cpp"
                var $cmp37=((($30))|0) < 300; //@line 919 "readclause.cpp"
                if (!($cmp37)) { __label__ = 24;break $if_then9$$if_end63$13; } //@line 919 "readclause.cpp"
  
                var $arraydecay39=(($buf2)&4294967295); //@line 921 "readclause.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__str53220)&4294967295);
                $dest$ = $arraydecay39;
                $stop$ = $src$ + 7;
                if (($dest$%4) == ($src$%4) && 7 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 921 "readclause.cpp"
                var $arraydecay41=(($buf)&4294967295); //@line 922 "readclause.cpp"
                var $arraydecay42=(($buf2)&4294967295); //@line 922 "readclause.cpp"
                var $call43=_strcat($arraydecay41, $arraydecay42); //@line 922 "readclause.cpp"
                ; //@line 923 "readclause.cpp"
              }
              else if (__label__ == 19) {
  
                var $31=$punctname; //@line 927 "readclause.cpp"
                var $32=$punct_count; //@line 927 "readclause.cpp"
                var $33=$punctname; //@line 927 "readclause.cpp"
                var $call47=_sprintf($arrayidx22, ((__str54221)&4294967295), allocate([$31,0,0,0,$32,0,0,0,$33,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 927 "readclause.cpp"
                ;
              }
            }
          }
        } while(0);
  
        var $_pr=$found; //@line 946 "readclause.cpp"
        var $cmp64=((($_pr))|0)==0; //@line 946 "readclause.cpp"
        if (!($cmp64)) { __label__ = 26;break $if_end63_thread$$if_else$2; } //@line 946 "readclause.cpp"
  
        $retval=-1; //@line 947 "readclause.cpp"
        __label__ = 40;break $if_end63_thread$$if_else$2; //@line 947 "readclause.cpp"
      }
    } while(0);
    $if_end66$$return$39: do { 
      if (__label__ == 26) {
  
        var $40=$bufix_addr; //@line 949 "readclause.cpp"
        var $41=HEAP32[(($40)>>2)]; //@line 949 "readclause.cpp"
        $bufix1=$41; //@line 949 "readclause.cpp"
        var $arraydecay67=(($buf)&4294967295); //@line 950 "readclause.cpp"
        var $call68=_strlen($arraydecay67); //@line 950 "readclause.cpp"
        $len=$call68; //@line 950 "readclause.cpp"
        var $42=$bufix_addr; //@line 951 "readclause.cpp"
        var $43=HEAP32[(($42)>>2)]; //@line 951 "readclause.cpp"
        var $44=$output_addr; //@line 951 "readclause.cpp"
        var $arrayidx69=(($44+$43)&4294967295); //@line 951 "readclause.cpp"
        var $arraydecay70=(($buf)&4294967295); //@line 951 "readclause.cpp"
        var $call71=_strcpy($arrayidx69, $arraydecay70); //@line 951 "readclause.cpp"
        var $45=$len; //@line 952 "readclause.cpp"
        var $46=$bufix_addr; //@line 952 "readclause.cpp"
        var $47=HEAP32[(($46)>>2)]; //@line 952 "readclause.cpp"
        var $add=((($47)+($45))&4294967295); //@line 952 "readclause.cpp"
        HEAP32[(($46)>>2)]=$add; //@line 952 "readclause.cpp"
        var $48=$end_clause_addr; //@line 954 "readclause.cpp"
        var $cmp72=((($48))|0)==0; //@line 954 "readclause.cpp"
        if ($cmp72) { __label__ = 27;; } else { __label__ = 28;; } //@line 954 "readclause.cpp"
        if (__label__ == 27) {
  
          $retval=-1; //@line 955 "readclause.cpp"
          ; //@line 955 "readclause.cpp"
        }
        else if (__label__ == 28) {
  
          var $49=$c1_addr; //@line 957 "readclause.cpp"
          var $cmp75=((($49))|0)==45; //@line 957 "readclause.cpp"
          if ($cmp75) { __label__ = 29;; } else { __label__ = 30;; } //@line 957 "readclause.cpp"
          if (__label__ == 29) {
  
            $retval=16384; //@line 958 "readclause.cpp"
            ; //@line 958 "readclause.cpp"
          }
          else if (__label__ == 30) {
  
            var $50=$c1_addr; //@line 960 "readclause.cpp"
            var $call78=__Z11lookupwcharPKti(((__ZL11punct_chars)&4294967295), $50); //@line 960 "readclause.cpp"
            var $arrayidx79=((__ZL16punct_attributes+$call78*4)&4294967295); //@line 960 "readclause.cpp"
            var $51=HEAP32[(($arrayidx79)>>2)]; //@line 960 "readclause.cpp"
            $attributes=$51; //@line 960 "readclause.cpp"
            $short_pause=262148; //@line 962 "readclause.cpp"
            var $52=$attributes; //@line 963 "readclause.cpp"
            var $and80=($52) & 28672; //@line 963 "readclause.cpp"
            var $cmp81=((($and80))|0)==4096; //@line 963 "readclause.cpp"
            if ($cmp81) { __label__ = 31;; } else { __label__ = 32;; } //@line 963 "readclause.cpp"
            if (__label__ == 31) {
  
              $short_pause=266244; //@line 964 "readclause.cpp"
              ; //@line 964 "readclause.cpp"
            }
  
            var $53=$bufix1; //@line 966 "readclause.cpp"
            var $cmp84=((($53))|0) > 0; //@line 966 "readclause.cpp"
            if ($cmp84) { __label__ = 33;; } else { __label__ = 37;; } //@line 966 "readclause.cpp"
            $land_lhs_true$$if_end95$50: do { 
              if (__label__ == 33) {
  
                var $54=$tr_addr; //@line 966 "readclause.cpp"
                var $langopts85=(($54)&4294967295); //@line 966 "readclause.cpp"
                var $param86=(($langopts85+24)&4294967295); //@line 966 "readclause.cpp"
                var $arrayidx87=(($param86+68)&4294967295); //@line 966 "readclause.cpp"
                var $55=HEAP32[(($arrayidx87)>>2)]; //@line 966 "readclause.cpp"
                var $and88=($55) & 2; //@line 966 "readclause.cpp"
                var $tobool89=((($and88))|0)!=0; //@line 966 "readclause.cpp"
                if ($tobool89) { __label__ = 37;break $land_lhs_true$$if_end95$50; } //@line 966 "readclause.cpp"
  
                var $56=$attributes; //@line 968 "readclause.cpp"
                var $and91=($56) & -32769; //@line 968 "readclause.cpp"
                var $cmp92=((($and91))|0)==266270; //@line 968 "readclause.cpp"
                if ($cmp92) { __label__ = 35;; } else { __label__ = 36;; } //@line 968 "readclause.cpp"
                if (__label__ == 35) {
  
                  $retval=262148; //@line 969 "readclause.cpp"
                  __label__ = 40;break $if_end66$$return$39; //@line 969 "readclause.cpp"
                }
                else if (__label__ == 36) {
  
                  var $57=$short_pause; //@line 970 "readclause.cpp"
                  $retval=$57; //@line 970 "readclause.cpp"
                  __label__ = 40;break $if_end66$$return$39; //@line 970 "readclause.cpp"
                }
              }
            } while(0);
  
            var $58=$attributes; //@line 973 "readclause.cpp"
            var $and96=($58) & 524288; //@line 973 "readclause.cpp"
            var $tobool97=((($and96))|0)!=0; //@line 973 "readclause.cpp"
            if ($tobool97) { __label__ = 38;; } else { __label__ = 39;; } //@line 973 "readclause.cpp"
            if (__label__ == 38) {
  
              var $59=$attributes; //@line 974 "readclause.cpp"
              $retval=$59; //@line 974 "readclause.cpp"
              ; //@line 974 "readclause.cpp"
            }
            else if (__label__ == 39) {
  
              var $60=$short_pause; //@line 976 "readclause.cpp"
              $retval=$60; //@line 976 "readclause.cpp"
              ; //@line 976 "readclause.cpp"
            }
          }
        }
      }
    } while(0);
  
    var $61=$retval; //@line 977 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $61; //@line 977 "readclause.cpp"
    return null;
  }
  

  function __ZL14LookupCharNameP10Translatorii($tr, $c, $only) {
    var __stackBase__  = STACKTOP; STACKTOP += 156; _memset(__stackBase__, 0, 156);
    var __label__;
  
    var $tr_addr;
    var $c_addr;
    var $only_addr;
    var $ix;
    var $flags=__stackBase__;
    var $single_letter=__stackBase__+8;
    var $phonemes=__stackBase__+32;
    var $phonemes2=__stackBase__+92;
    var $lang_name;
    var $string=__stackBase__+152;
    $tr_addr=$tr;
    $c_addr=$c;
    $only_addr=$only;
    $lang_name=0; //@line 617 "readclause.cpp"
    HEAP8[(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295))]=0; //@line 621 "readclause.cpp"
    var $arrayidx=(($flags)&4294967295); //@line 622 "readclause.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 622 "readclause.cpp"
    var $arrayidx1=(($flags+4)&4294967295); //@line 623 "readclause.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 623 "readclause.cpp"
    var $arrayidx2=(($single_letter)&4294967295); //@line 624 "readclause.cpp"
    HEAP8[($arrayidx2)]=0; //@line 624 "readclause.cpp"
    var $arrayidx3=(($single_letter+1)&4294967295); //@line 625 "readclause.cpp"
    HEAP8[($arrayidx3)]=95; //@line 625 "readclause.cpp"
    var $0=$c_addr; //@line 626 "readclause.cpp"
    var $arrayidx4=(($single_letter+2)&4294967295); //@line 626 "readclause.cpp"
    var $call=__Z8utf8_outjPc($0, $arrayidx4); //@line 626 "readclause.cpp"
    $ix=$call; //@line 626 "readclause.cpp"
    var $1=$ix; //@line 627 "readclause.cpp"
    var $add=((($1)+2)&4294967295); //@line 627 "readclause.cpp"
    var $arrayidx5=(($single_letter+$add)&4294967295); //@line 627 "readclause.cpp"
    HEAP8[($arrayidx5)]=0; //@line 627 "readclause.cpp"
    var $2=$only_addr; //@line 629 "readclause.cpp"
    var $tobool=((($2))|0)!=0; //@line 629 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 629 "readclause.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $arrayidx6=(($single_letter+2)&4294967295); //@line 631 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx6; //@line 631 "readclause.cpp"
        var $3=$tr_addr; //@line 632 "readclause.cpp"
        var $arraydecay=(($phonemes)&4294967295); //@line 632 "readclause.cpp"
        var $arraydecay7=(($flags)&4294967295); //@line 632 "readclause.cpp"
        var $call8=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($3, $string, $arraydecay, $arraydecay7, 0, 0); //@line 632 "readclause.cpp"
        ; //@line 633 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        var $arrayidx9=(($single_letter+1)&4294967295); //@line 636 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx9; //@line 636 "readclause.cpp"
        var $4=$tr_addr; //@line 637 "readclause.cpp"
        var $arraydecay10=(($phonemes)&4294967295); //@line 637 "readclause.cpp"
        var $arraydecay11=(($flags)&4294967295); //@line 637 "readclause.cpp"
        var $call12=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($4, $string, $arraydecay10, $arraydecay11, 0, 0); //@line 637 "readclause.cpp"
        var $cmp=((($call12))|0)==0; //@line 637 "readclause.cpp"
        if (!($cmp)) { __label__ = 5;break $if_then$$if_else$2; } //@line 637 "readclause.cpp"
  
        var $arrayidx14=(($single_letter+2)&4294967295); //@line 640 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx14; //@line 640 "readclause.cpp"
        var $5=$tr_addr; //@line 641 "readclause.cpp"
        var $arraydecay15=(($phonemes)&4294967295); //@line 641 "readclause.cpp"
        var $arraydecay16=(($flags)&4294967295); //@line 641 "readclause.cpp"
        var $call17=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($5, $string, $arraydecay15, $arraydecay16, 0, 0); //@line 641 "readclause.cpp"
        var $cmp18=((($call17))|0)==0; //@line 641 "readclause.cpp"
        if (!($cmp18)) { __label__ = 5;break $if_then$$if_else$2; } //@line 641 "readclause.cpp"
  
        var $arrayidx20=(($single_letter+1)&4294967295); //@line 644 "readclause.cpp"
        HEAP8[($arrayidx20)]=32; //@line 644 "readclause.cpp"
        var $6=$tr_addr; //@line 645 "readclause.cpp"
        var $arrayidx21=(($single_letter+2)&4294967295); //@line 645 "readclause.cpp"
        var $arraydecay22=(($phonemes)&4294967295); //@line 645 "readclause.cpp"
        var $call23=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($6, $arrayidx21, $arraydecay22, 60, 0, 0, 0); //@line 645 "readclause.cpp"
        ; //@line 646 "readclause.cpp"
      }
    } while(0);
  
    var $7=$only_addr; //@line 650 "readclause.cpp"
    var $cmp26=((($7))|0)==0; //@line 650 "readclause.cpp"
    if ($cmp26) { __label__ = 6;; } else { __label__ = 13;; } //@line 650 "readclause.cpp"
    $land_lhs_true$$if_end50$8: do { 
      if (__label__ == 6) {
  
        var $arrayidx27=(($phonemes)&4294967295); //@line 650 "readclause.cpp"
        var $8=HEAP8[($arrayidx27)]; //@line 650 "readclause.cpp"
        var $conv=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 650 "readclause.cpp"
        var $cmp28=((($conv))|0)==0; //@line 650 "readclause.cpp"
        if (!($cmp28)) { __label__ = 13;break $land_lhs_true$$if_end50$8; } //@line 650 "readclause.cpp"
  
        var $9=$tr_addr; //@line 650 "readclause.cpp"
        var $translator_name=(($9+280)&4294967295); //@line 650 "readclause.cpp"
        var $10=HEAP32[(($translator_name)>>2)]; //@line 650 "readclause.cpp"
        var $cmp30=((($10))|0)!=25966; //@line 650 "readclause.cpp"
        if (!($cmp30)) { __label__ = 13;break $land_lhs_true$$if_end50$8; } //@line 650 "readclause.cpp"
  
        var $call32=__Z14SetTranslator2PKc(((__str52704)&4294967295)); //@line 653 "readclause.cpp"
        var $arrayidx33=(($single_letter+1)&4294967295); //@line 654 "readclause.cpp"
        HEAP32[(($string)>>2)]=$arrayidx33; //@line 654 "readclause.cpp"
        var $arrayidx34=(($single_letter+1)&4294967295); //@line 655 "readclause.cpp"
        HEAP8[($arrayidx34)]=95; //@line 655 "readclause.cpp"
        var $11=HEAP32[((_translator2)>>2)]; //@line 656 "readclause.cpp"
        var $arraydecay35=(($phonemes)&4294967295); //@line 656 "readclause.cpp"
        var $arraydecay36=(($flags)&4294967295); //@line 656 "readclause.cpp"
        var $call37=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($11, $string, $arraydecay35, $arraydecay36, 0, 0); //@line 656 "readclause.cpp"
        var $cmp38=((($call37))|0)==0; //@line 656 "readclause.cpp"
        if ($cmp38) { __label__ = 9;; } else { __label__ = 10;; } //@line 656 "readclause.cpp"
        if (__label__ == 9) {
  
          var $arrayidx40=(($single_letter+2)&4294967295); //@line 658 "readclause.cpp"
          HEAP32[(($string)>>2)]=$arrayidx40; //@line 658 "readclause.cpp"
          var $12=HEAP32[((_translator2)>>2)]; //@line 659 "readclause.cpp"
          var $arraydecay41=(($phonemes)&4294967295); //@line 659 "readclause.cpp"
          var $arraydecay42=(($flags)&4294967295); //@line 659 "readclause.cpp"
          var $call43=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($12, $string, $arraydecay41, $arraydecay42, 0, 0); //@line 659 "readclause.cpp"
          ; //@line 660 "readclause.cpp"
        }
  
        var $arrayidx45=(($phonemes)&4294967295); //@line 661 "readclause.cpp"
        var $13=HEAP8[($arrayidx45)]; //@line 661 "readclause.cpp"
        var $tobool46=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 661 "readclause.cpp"
        if ($tobool46) { __label__ = 11;; } else { __label__ = 12;; } //@line 661 "readclause.cpp"
        if (__label__ == 11) {
  
          $lang_name=((__str52704)&4294967295); //@line 663 "readclause.cpp"
          ; //@line 664 "readclause.cpp"
        }
        else if (__label__ == 12) {
  
          var $14=HEAP32[((_voice)>>2)]; //@line 667 "readclause.cpp"
          var $phoneme_tab_ix=(($14+40)&4294967295); //@line 667 "readclause.cpp"
          var $15=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 667 "readclause.cpp"
          __Z18SelectPhonemeTablei($15); //@line 667 "readclause.cpp"
          ;
        }
      }
    } while(0);
  
    var $arrayidx51=(($phonemes)&4294967295); //@line 671 "readclause.cpp"
    var $16=HEAP8[($arrayidx51)]; //@line 671 "readclause.cpp"
    var $tobool52=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 671 "readclause.cpp"
    if ($tobool52) { __label__ = 14;; } else { __label__ = 17;; } //@line 671 "readclause.cpp"
    $if_then53$$if_else73$19: do { 
      if (__label__ == 14) {
  
        var $17=$lang_name; //@line 673 "readclause.cpp"
        var $tobool54=((($17))|0)!=0; //@line 673 "readclause.cpp"
        if ($tobool54) { __label__ = 15;; } else { __label__ = 16;; } //@line 673 "readclause.cpp"
        if (__label__ == 15) {
  
          var $18=HEAP32[((_translator2)>>2)]; //@line 675 "readclause.cpp"
          var $arraydecay56=(($phonemes)&4294967295); //@line 675 "readclause.cpp"
          var $arraydecay57=(($flags)&4294967295); //@line 675 "readclause.cpp"
          __Z13SetWordStressP10TranslatorPcPjii($18, $arraydecay56, $arraydecay57, -1, 0); //@line 675 "readclause.cpp"
          var $arraydecay58=(($phonemes)&4294967295); //@line 676 "readclause.cpp"
          var $arraydecay59=(($phonemes2)&4294967295); //@line 676 "readclause.cpp"
          __Z14DecodePhonemesPKcPc($arraydecay58, $arraydecay59); //@line 676 "readclause.cpp"
          var $arraydecay60=(($phonemes2)&4294967295); //@line 677 "readclause.cpp"
          var $19=$tr_addr; //@line 677 "readclause.cpp"
          var $translator_name61=(($19+280)&4294967295); //@line 677 "readclause.cpp"
          var $20=HEAP32[(($translator_name61)>>2)]; //@line 677 "readclause.cpp"
          __ZL13WordToString2j($20); //@line 677 "readclause.cpp"
          var $call63=_sprintf(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295), ((__str47214)&4294967295), allocate([((__str52704)&4294967295),0,0,0,$arraydecay60,0,0,0,((__ZZL13WordToString2jE3buf)&4294967295),0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 677 "readclause.cpp"
          var $21=HEAP32[((_voice)>>2)]; //@line 678 "readclause.cpp"
          var $phoneme_tab_ix64=(($21+40)&4294967295); //@line 678 "readclause.cpp"
          var $22=HEAP32[(($phoneme_tab_ix64)>>2)]; //@line 678 "readclause.cpp"
          __Z18SelectPhonemeTablei($22); //@line 678 "readclause.cpp"
          ; //@line 679 "readclause.cpp"
        }
        else if (__label__ == 16) {
  
          var $23=$tr_addr; //@line 682 "readclause.cpp"
          var $arraydecay66=(($phonemes)&4294967295); //@line 682 "readclause.cpp"
          var $arraydecay67=(($flags)&4294967295); //@line 682 "readclause.cpp"
          __Z13SetWordStressP10TranslatorPcPjii($23, $arraydecay66, $arraydecay67, -1, 0); //@line 682 "readclause.cpp"
          var $arraydecay68=(($phonemes)&4294967295); //@line 683 "readclause.cpp"
          var $arraydecay69=(($phonemes2)&4294967295); //@line 683 "readclause.cpp"
          __Z14DecodePhonemesPKcPc($arraydecay68, $arraydecay69); //@line 683 "readclause.cpp"
          var $arraydecay70=(($phonemes2)&4294967295); //@line 684 "readclause.cpp"
          var $call71=_sprintf(((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295), ((__str48215)&4294967295), allocate([$arraydecay70,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 684 "readclause.cpp"
          ;
        }
      }
      else if (__label__ == 17) {
  
        var $24=$only_addr; //@line 688 "readclause.cpp"
        var $cmp74=((($24))|0)==0; //@line 688 "readclause.cpp"
        if (!($cmp74)) { __label__ = 19;break $if_then53$$if_else73$19; } //@line 688 "readclause.cpp"
  
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = ((__str49216)&4294967295);
        $dest$ = ((__ZZL14LookupCharNameP10TranslatoriiE3buf)&4294967295);
        $stop$ = $src$ + 17;
        if (($dest$%4) == ($src$%4) && 17 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 690 "readclause.cpp"
        ; //@line 691 "readclause.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL8IsRomanUj($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 383 "readclause.cpp"
    var $cmp=((($0))|0)==73; //@line 383 "readclause.cpp"
    var $1=$c_addr; //@line 383 "readclause.cpp"
    var $cmp1=((($1))|0)==86; //@line 383 "readclause.cpp"
    var $or_cond=($cmp) | ($cmp1); //@line 383 "readclause.cpp"
    var $2=$c_addr; //@line 383 "readclause.cpp"
    var $cmp3=((($2))|0)==88; //@line 383 "readclause.cpp"
    var $or_cond1=($or_cond) | ($cmp3); //@line 383 "readclause.cpp"
    var $3=$c_addr; //@line 383 "readclause.cpp"
    var $cmp5=((($3))|0)==76; //@line 383 "readclause.cpp"
    var $or_cond2=($or_cond1) | ($cmp5); //@line 383 "readclause.cpp"
    if ($or_cond2) { __label__ = 1;; } else { __label__ = 2;; } //@line 383 "readclause.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 384 "readclause.cpp"
      ; //@line 384 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 385 "readclause.cpp"
      ; //@line 385 "readclause.cpp"
    }
  
    var $4=$retval; //@line 386 "readclause.cpp"
    ;
    return $4; //@line 386 "readclause.cpp"
    return null;
  }
  

  function __Z12InitNamedatav() {
    ;
    var __label__;
  
    HEAP32[((__ZL11namedata_ix)>>2)]=0; //@line 2726 "readclause.cpp"
    var $0=HEAP32[((_namedata)>>2)]; //@line 2727 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 2727 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2727 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_namedata)>>2)]; //@line 2729 "readclause.cpp"
      ; //@line 2729 "readclause.cpp"
      HEAP32[((_namedata)>>2)]=0; //@line 2730 "readclause.cpp"
      HEAP32[((__ZL10n_namedata)>>2)]=0; //@line 2731 "readclause.cpp"
      ; //@line 2732 "readclause.cpp"
    }
  
    ;
    return; //@line 2733 "readclause.cpp"
    return;
  }
  

  function __Z9InitText2v() {
    ;
    var __label__;
  
    var $param;
    HEAP32[((__ZL10ungot_char)>>2)]=0; //@line 2740 "readclause.cpp"
    HEAP32[((__ZL11ungot_char2)>>2)]=0; //@line 2741 "readclause.cpp"
    HEAP32[((__ZL12n_ssml_stack)>>2)]=1; //@line 2743 "readclause.cpp"
    HEAP32[((__ZL13n_param_stack)>>2)]=1; //@line 2744 "readclause.cpp"
    HEAP32[((((__ZL10ssml_stack)&4294967295))>>2)]=0; //@line 2745 "readclause.cpp"
    $param=0; //@line 2747 "readclause.cpp"
    ; //@line 2747 "readclause.cpp"
    while(1) { 
  
      var $0=$param; //@line 2748 "readclause.cpp"
      var $arrayidx=((((_param_stack+4)&4294967295)+$0*4)&4294967295); //@line 2748 "readclause.cpp"
      var $1=HEAP32[(($arrayidx)>>2)]; //@line 2748 "readclause.cpp"
      var $2=$param; //@line 2748 "readclause.cpp"
      var $arrayidx1=((__ZL17speech_parameters+$2*4)&4294967295); //@line 2748 "readclause.cpp"
      HEAP32[(($arrayidx1)>>2)]=$1; //@line 2748 "readclause.cpp"
      var $3=$param; //@line 2747 "readclause.cpp"
      var $inc=((($3)+1)&4294967295); //@line 2747 "readclause.cpp"
      $param=$inc; //@line 2747 "readclause.cpp"
      var $cmp=((($inc))|0) < 15; //@line 2747 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 2747 "readclause.cpp"
    }
  
    var $4=HEAP32[((((__ZL17speech_parameters+20)&4294967295))>>2)]; //@line 2750 "readclause.cpp"
    HEAP32[((_option_punctuation)>>2)]=$4; //@line 2750 "readclause.cpp"
    var $5=HEAP32[((((__ZL17speech_parameters+24)&4294967295))>>2)]; //@line 2751 "readclause.cpp"
    HEAP32[((_option_capitals)>>2)]=$5; //@line 2751 "readclause.cpp"
    HEAP8[(((__ZL16current_voice_id)&4294967295))]=0; //@line 2753 "readclause.cpp"
    HEAP8[(__ZL11ignore_text_b)]=0;
    HEAP8[(__ZL10audio_text_b)]=0;
    HEAP8[(__ZL19clear_skipping_text_b)]=0;
    HEAP32[((_count_characters)>>2)]=-1; //@line 2758 "readclause.cpp"
    HEAP32[((__ZL10sayas_mode)>>2)]=0; //@line 2759 "readclause.cpp"
    HEAP32[((__ZL7xmlbase)>>2)]=0; //@line 2761 "readclause.cpp"
    ;
    return; //@line 2762 "readclause.cpp"
    return;
  }
  

  function __ZL13WordToString2j($word) {
    ;
    var __label__;
  
    var $word_addr;
    var $ix;
    var $p;
    $word_addr=$word;
    $p=((__ZZL13WordToString2jE3buf)&4294967295); //@line 577 "readclause.cpp"
    $ix=3; //@line 578 "readclause.cpp"
    ; //@line 578 "readclause.cpp"
    while(1) { 
  
      var $0=$word_addr; //@line 580 "readclause.cpp"
      var $1=$ix; //@line 580 "readclause.cpp"
      var $mul=((($1)*8)&4294967295); //@line 580 "readclause.cpp"
      var $shr=($0) >>> ((($mul))>>>0); //@line 580 "readclause.cpp"
      var $conv=((($shr)) & 255); //@line 580 "readclause.cpp"
      var $2=$p; //@line 580 "readclause.cpp"
      HEAP8[($2)]=$conv; //@line 580 "readclause.cpp"
      var $conv1=(tempInt=(($conv)),(tempInt>=128?tempInt-256:tempInt)); //@line 580 "readclause.cpp"
      var $cmp2=((($conv1))|0)!=0; //@line 580 "readclause.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 580 "readclause.cpp"
      if (__label__ == 2) {
  
        var $3=$p; //@line 581 "readclause.cpp"
        var $incdec_ptr=(($3+1)&4294967295); //@line 581 "readclause.cpp"
        $p=$incdec_ptr; //@line 581 "readclause.cpp"
        ; //@line 581 "readclause.cpp"
      }
  
      var $4=$ix; //@line 578 "readclause.cpp"
      var $dec=((($4)-1)&4294967295); //@line 578 "readclause.cpp"
      $ix=$dec; //@line 578 "readclause.cpp"
      var $cmp=((($dec))|0) >= 0; //@line 578 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 578 "readclause.cpp"
    }
  
    var $5=$p; //@line 583 "readclause.cpp"
    HEAP8[($5)]=0; //@line 583 "readclause.cpp"
    ;
    return;
    return;
  }
  

  function __ZL15LookupSoundiconi($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $ix;
    $c_addr=$c;
    $ix=4; //@line 810 "readclause.cpp"
    ; //@line 810 "readclause.cpp"
    $for_cond$2: while(1) { 
  
      var $0=$ix; //@line 810 "readclause.cpp"
      var $1=HEAP32[((_n_soundicon_tab)>>2)]; //@line 810 "readclause.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 810 "readclause.cpp"
      if (!($cmp)) { __label__ = 8;break $for_cond$2; } //@line 810 "readclause.cpp"
  
      var $2=$ix; //@line 812 "readclause.cpp"
      var $arrayidx=((_soundicon_tab+$2*16)&4294967295); //@line 812 "readclause.cpp"
      var $name=(($arrayidx)&4294967295); //@line 812 "readclause.cpp"
      var $3=HEAP32[(($name)>>2)]; //@line 812 "readclause.cpp"
      var $4=$c_addr; //@line 812 "readclause.cpp"
      var $cmp1=((($3))|0)==((($4))|0); //@line 812 "readclause.cpp"
      var $5=$ix; //@line 814 "readclause.cpp"
      if ($cmp1) { __label__ = 3;break $for_cond$2; } //@line 812 "readclause.cpp"
  
      var $inc=((($5)+1)&4294967295); //@line 810 "readclause.cpp"
      $ix=$inc; //@line 810 "readclause.cpp"
      __label__ = 1;continue $for_cond$2; //@line 810 "readclause.cpp"
    }
    $for_end$$if_then$6: do { 
      if (__label__ == 8) {
  
        $retval=-1; //@line 822 "readclause.cpp"
        ; //@line 822 "readclause.cpp"
      }
      else if (__label__ == 3) {
  
        var $arrayidx2=((_soundicon_tab+$5*16)&4294967295); //@line 814 "readclause.cpp"
        var $length=(($arrayidx2+4)&4294967295); //@line 814 "readclause.cpp"
        var $6=HEAP32[(($length)>>2)]; //@line 814 "readclause.cpp"
        var $cmp3=((($6))|0)==0; //@line 814 "readclause.cpp"
        if ($cmp3) { __label__ = 4;; } else { __label__ = 6;; } //@line 814 "readclause.cpp"
        $if_then4$$if_end7$9: do { 
          if (__label__ == 4) {
  
            var $7=$ix; //@line 816 "readclause.cpp"
            var $call=__ZL13LoadSoundFilePKci(0, $7); //@line 816 "readclause.cpp"
            var $cmp5=((($call))|0)!=0; //@line 816 "readclause.cpp"
            if (!($cmp5)) { __label__ = 6;break $if_then4$$if_end7$9; } //@line 816 "readclause.cpp"
  
            $retval=-1; //@line 817 "readclause.cpp"
            __label__ = 9;break $for_end$$if_then$6; //@line 817 "readclause.cpp"
          }
        } while(0);
  
        var $8=$ix; //@line 819 "readclause.cpp"
        $retval=$8; //@line 819 "readclause.cpp"
        ; //@line 819 "readclause.cpp"
      }
    } while(0);
  
    var $9=$retval; //@line 823 "readclause.cpp"
    ;
    return $9; //@line 823 "readclause.cpp"
    return null;
  }
  

  function __ZL13LoadSoundFilePKci($fname, $index) {
    var __stackBase__  = STACKTOP; STACKTOP += 764; _memset(__stackBase__, 0, 764);
    var __label__;
  
    var $retval;
    var $fname_addr;
    var $index_addr;
    var $f;
    var $p;
    var $ip;
    var $length;
    var $fname_temp=__stackBase__;
    var $fname2=__stackBase__+100;
    var $ix;
    var $fd_temp;
    var $resample;
    var $header=__stackBase__+304;
    var $command=__stackBase__+316;
    $fname_addr=$fname;
    $index_addr=$index;
    var $0=$fname_addr; //@line 721 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 721 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 721 "readclause.cpp"
    $if_end$$if_end3$2: do { 
      if (__label__ == 1) {
  
        var $1=$index_addr; //@line 724 "readclause.cpp"
        var $arrayidx=((_soundicon_tab+$1*16)&4294967295); //@line 724 "readclause.cpp"
        var $filename=(($arrayidx+12)&4294967295); //@line 724 "readclause.cpp"
        var $2=HEAP32[(($filename)>>2)]; //@line 724 "readclause.cpp"
        $fname_addr=$2; //@line 724 "readclause.cpp"
        var $cmp1=((($2))|0)==0; //@line 727 "readclause.cpp"
        if (!($cmp1)) { __label__ = 3;break $if_end$$if_end3$2; } //@line 727 "readclause.cpp"
  
        $retval=1; //@line 728 "readclause.cpp"
        __label__ = 23;break $if_end$$if_end3$2; //@line 728 "readclause.cpp"
      }
    } while(0);
    $return$$if_end3$5: do { 
      if (__label__ == 3) {
  
        var $3=$fname_addr; //@line 730 "readclause.cpp"
        var $arrayidx4=(($3)&4294967295); //@line 730 "readclause.cpp"
        var $4=HEAP8[($arrayidx4)]; //@line 730 "readclause.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 730 "readclause.cpp"
        var $cmp5=((($conv))|0)!=47; //@line 730 "readclause.cpp"
        if ($cmp5) { __label__ = 4;; } else { __label__ = 5;; } //@line 730 "readclause.cpp"
        if (__label__ == 4) {
  
          var $arraydecay=(($fname2)&4294967295); //@line 733 "readclause.cpp"
          var $5=$fname_addr; //@line 733 "readclause.cpp"
          var $call=_sprintf($arraydecay, ((__str55222)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,47,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 733 "readclause.cpp"
          var $arraydecay7=(($fname2)&4294967295); //@line 734 "readclause.cpp"
          $fname_addr=$arraydecay7; //@line 734 "readclause.cpp"
          ; //@line 735 "readclause.cpp"
        }
  
        $f=0; //@line 737 "readclause.cpp"
        var $6=$fname_addr; //@line 739 "readclause.cpp"
        var $call9=_fopen($6, ((__str18429)&4294967295)); //@line 739 "readclause.cpp"
        $f=$call9; //@line 739 "readclause.cpp"
        var $cmp10=((($call9))|0)!=0; //@line 739 "readclause.cpp"
        if ($cmp10) { __label__ = 6;; } else { __label__ = 18;; } //@line 739 "readclause.cpp"
        $if_then11$$if_then49$10: do { 
          if (__label__ == 6) {
  
            var $7=$f; //@line 747 "readclause.cpp"
            var $call12=_fseek($7, 20, 0); //@line 747 "readclause.cpp"
            $ix=0; //@line 748 "readclause.cpp"
            ; //@line 748 "readclause.cpp"
            $for_body$12: while(1) { 
  
              var $8=$f; //@line 749 "readclause.cpp"
              var $call14=__Z10Read4BytesP7__sFILE($8); //@line 749 "readclause.cpp"
              var $9=$ix; //@line 749 "readclause.cpp"
              var $arrayidx15=(($header+$9*4)&4294967295); //@line 749 "readclause.cpp"
              HEAP32[(($arrayidx15)>>2)]=$call14; //@line 749 "readclause.cpp"
              var $10=$ix; //@line 748 "readclause.cpp"
              var $inc=((($10)+1)&4294967295); //@line 748 "readclause.cpp"
              $ix=$inc; //@line 748 "readclause.cpp"
              var $cmp13=((($inc))|0) < 3; //@line 748 "readclause.cpp"
              if ($cmp13) { __label__ = 7;continue $for_body$12; } else { __label__ = 8;break $for_body$12; } //@line 748 "readclause.cpp"
            }
  
            var $arrayidx16=(($header)&4294967295); //@line 752 "readclause.cpp"
            var $11=HEAP32[(($arrayidx16)>>2)]; //@line 752 "readclause.cpp"
            var $cmp17=((($11))|0)!=65537; //@line 752 "readclause.cpp"
            if ($cmp17) { __label__ = 11;; } else { __label__ = 9;; } //@line 752 "readclause.cpp"
            $if_then23$$lor_lhs_false$15: do { 
              if (__label__ == 9) {
  
                var $arrayidx18=(($header+4)&4294967295); //@line 752 "readclause.cpp"
                var $12=HEAP32[(($arrayidx18)>>2)]; //@line 752 "readclause.cpp"
                var $13=HEAP32[((_samplerate)>>2)]; //@line 752 "readclause.cpp"
                var $cmp19=((($12))|0)!=((($13))|0); //@line 752 "readclause.cpp"
                if ($cmp19) { __label__ = 11;break $if_then23$$lor_lhs_false$15; } //@line 752 "readclause.cpp"
  
                var $arrayidx21=(($header+8)&4294967295); //@line 752 "readclause.cpp"
                var $14=HEAP32[(($arrayidx21)>>2)]; //@line 752 "readclause.cpp"
                var $15=HEAP32[((_samplerate)>>2)]; //@line 752 "readclause.cpp"
                var $mul=((($15)*2)&4294967295); //@line 752 "readclause.cpp"
                var $cmp22=((($14))|0)!=((($mul))|0); //@line 752 "readclause.cpp"
                if ($cmp22) { __label__ = 11;break $if_then23$$lor_lhs_false$15; } else { __label__ = 17;break $if_then23$$lor_lhs_false$15; } //@line 752 "readclause.cpp"
              }
            } while(0);
            $if_then23$$if_end47$18: do { 
              if (__label__ == 11) {
  
                var $16=$f; //@line 754 "readclause.cpp"
                var $call24=_fclose($16); //@line 754 "readclause.cpp"
                $f=0; //@line 755 "readclause.cpp"
                var $arrayidx25=(($header+8)&4294967295); //@line 757 "readclause.cpp"
                var $17=HEAP32[(($arrayidx25)>>2)]; //@line 757 "readclause.cpp"
                var $18=HEAP32[((_samplerate)>>2)]; //@line 757 "readclause.cpp"
                var $cmp26=((($17))|0)==((($18))|0); //@line 757 "readclause.cpp"
                if ($cmp26) { __label__ = 12;; } else { __label__ = 13;; } //@line 757 "readclause.cpp"
                if (__label__ == 12) {
  
                  $resample=((__str13643)&4294967295); //@line 758 "readclause.cpp"
                  ; //@line 758 "readclause.cpp"
                }
                else if (__label__ == 13) {
  
                  $resample=((__str57224)&4294967295); //@line 760 "readclause.cpp"
                  ;
                }
  
                var $arraydecay29=(($fname_temp)&4294967295); //@line 762 "readclause.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = ((__str58225)&4294967295);
                $dest$ = $arraydecay29;
                $stop$ = $src$ + 18;
                if (($dest$%4) == ($src$%4) && 18 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 762 "readclause.cpp"
                var $arraydecay31=(($fname_temp)&4294967295); //@line 763 "readclause.cpp"
                var $call32=_mkstemp($arraydecay31); //@line 763 "readclause.cpp"
                $fd_temp=$call32; //@line 763 "readclause.cpp"
                var $cmp33=((($call32))|0) >= 0; //@line 763 "readclause.cpp"
                if (!($cmp33)) { __label__ = 17;break $if_then23$$if_end47$18; } //@line 763 "readclause.cpp"
  
                var $19=$fd_temp; //@line 765 "readclause.cpp"
                var $call35=_close($19); //@line 765 "readclause.cpp"
                var $arraydecay36=(($command)&4294967295); //@line 767 "readclause.cpp"
                var $20=$fname_addr; //@line 767 "readclause.cpp"
                var $21=HEAP32[((_samplerate)>>2)]; //@line 767 "readclause.cpp"
                var $arraydecay37=(($fname_temp)&4294967295); //@line 767 "readclause.cpp"
                var $22=$resample; //@line 767 "readclause.cpp"
                var $call38=_sprintf($arraydecay36, ((__str59226)&4294967295), allocate([$20,0,0,0,$21,0,0,0,$arraydecay37,0,0,0,$22,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 767 "readclause.cpp"
                var $arraydecay39=(($command)&4294967295); //@line 768 "readclause.cpp"
                var $call40=_system($arraydecay39); //@line 768 "readclause.cpp"
                var $cmp41=((($call40))|0)==0; //@line 768 "readclause.cpp"
                if (!($cmp41)) { __label__ = 17;break $if_then23$$if_end47$18; } //@line 768 "readclause.cpp"
  
                var $arraydecay43=(($fname_temp)&4294967295); //@line 770 "readclause.cpp"
                $fname_addr=$arraydecay43; //@line 770 "readclause.cpp"
                ; //@line 771 "readclause.cpp"
              }
            } while(0);
  
            var $_pr=$f; //@line 777 "readclause.cpp"
            var $cmp48=((($_pr))|0)==0; //@line 777 "readclause.cpp"
            if ($cmp48) { __label__ = 18;break $if_then11$$if_then49$10; } else { __label__ = 20;break $if_then11$$if_then49$10; } //@line 777 "readclause.cpp"
          }
        } while(0);
        $if_then49$$if_end54$27: do { 
          if (__label__ == 18) {
  
            var $23=$fname_addr; //@line 779 "readclause.cpp"
            var $call50=_fopen($23, ((__str18429)&4294967295)); //@line 779 "readclause.cpp"
            $f=$call50; //@line 779 "readclause.cpp"
            var $cmp51=((($call50))|0)==0; //@line 780 "readclause.cpp"
            if (!($cmp51)) { __label__ = 20;break $if_then49$$if_end54$27; } //@line 780 "readclause.cpp"
  
            $retval=3; //@line 783 "readclause.cpp"
            __label__ = 23;break $return$$if_end3$5; //@line 783 "readclause.cpp"
          }
        } while(0);
  
        var $24=$fname_addr; //@line 787 "readclause.cpp"
        var $call55=__Z13GetFileLengthPKc($24); //@line 787 "readclause.cpp"
        $length=$call55; //@line 787 "readclause.cpp"
        var $25=$f; //@line 788 "readclause.cpp"
        var $call56=_fseek($25, 0, 0); //@line 788 "readclause.cpp"
        var $26=$index_addr; //@line 789 "readclause.cpp"
        var $arrayidx57=((_soundicon_tab+$26*16)&4294967295); //@line 789 "readclause.cpp"
        var $data=(($arrayidx57+8)&4294967295); //@line 789 "readclause.cpp"
        var $27=HEAP32[(($data)>>2)]; //@line 789 "readclause.cpp"
        var $28=$length; //@line 789 "readclause.cpp"
        var $call58=_realloc($27, $28); //@line 789 "readclause.cpp"
        $p=$call58; //@line 789 "readclause.cpp"
        var $cmp59=((($call58))|0)==0; //@line 789 "readclause.cpp"
        if ($cmp59) { __label__ = 21;; } else { __label__ = 22;; } //@line 789 "readclause.cpp"
        if (__label__ == 21) {
  
          var $29=$f; //@line 791 "readclause.cpp"
          var $call61=_fclose($29); //@line 791 "readclause.cpp"
          $retval=4; //@line 792 "readclause.cpp"
          ; //@line 792 "readclause.cpp"
        }
        else if (__label__ == 22) {
  
          var $30=$p; //@line 794 "readclause.cpp"
          var $31=$length; //@line 794 "readclause.cpp"
          var $32=$f; //@line 794 "readclause.cpp"
          var $call63=_fread($30, 1, $31, $32); //@line 794 "readclause.cpp"
          $length=$call63; //@line 794 "readclause.cpp"
          var $33=$f; //@line 795 "readclause.cpp"
          var $call64=_fclose($33); //@line 795 "readclause.cpp"
          var $arraydecay65=(($fname_temp)&4294967295); //@line 796 "readclause.cpp"
          var $call66=_remove($arraydecay65); //@line 796 "readclause.cpp"
          var $34=$p; //@line 798 "readclause.cpp"
          var $arrayidx67=(($34+40)&4294967295); //@line 798 "readclause.cpp"
          var $35=$arrayidx67; //@line 798 "readclause.cpp"
          $ip=$35; //@line 798 "readclause.cpp"
          var $36=$ip; //@line 799 "readclause.cpp"
          var $37=HEAP32[(($36)>>2)]; //@line 799 "readclause.cpp"
          var $div=((((($37))|0)/2)|0); //@line 799 "readclause.cpp"
          var $38=$index_addr; //@line 799 "readclause.cpp"
          var $arrayidx68=((_soundicon_tab+$38*16)&4294967295); //@line 799 "readclause.cpp"
          var $length69=(($arrayidx68+4)&4294967295); //@line 799 "readclause.cpp"
          HEAP32[(($length69)>>2)]=$div; //@line 799 "readclause.cpp"
          var $39=$p; //@line 800 "readclause.cpp"
          var $40=$index_addr; //@line 800 "readclause.cpp"
          var $arrayidx70=((_soundicon_tab+$40*16)&4294967295); //@line 800 "readclause.cpp"
          var $data71=(($arrayidx70+8)&4294967295); //@line 800 "readclause.cpp"
          HEAP32[(($data71)>>2)]=$39; //@line 800 "readclause.cpp"
          $retval=0; //@line 801 "readclause.cpp"
          ; //@line 801 "readclause.cpp"
        }
      }
    } while(0);
  
    var $41=$retval; //@line 802 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $41; //@line 802 "readclause.cpp"
    return null;
  }
  

  function __ZL14PushParamStacki($tag_type) {
    ;
    var __label__;
  
    var $tag_type_addr;
    var $ix;
    var $sp;
    $tag_type_addr=$tag_type;
    var $0=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1159 "readclause.cpp"
    var $arrayidx=((_param_stack+$0*64)&4294967295); //@line 1159 "readclause.cpp"
    $sp=$arrayidx; //@line 1159 "readclause.cpp"
    var $cmp=((($0))|0) < 19; //@line 1160 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1160 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1161 "readclause.cpp"
      var $inc=((($1)+1)&4294967295); //@line 1161 "readclause.cpp"
      HEAP32[((__ZL13n_param_stack)>>2)]=$inc; //@line 1161 "readclause.cpp"
      ; //@line 1161 "readclause.cpp"
    }
  
    var $2=$tag_type_addr; //@line 1163 "readclause.cpp"
    var $3=$sp; //@line 1163 "readclause.cpp"
    var $type=(($3)&4294967295); //@line 1163 "readclause.cpp"
    HEAP32[(($type)>>2)]=$2; //@line 1163 "readclause.cpp"
    $ix=0; //@line 1164 "readclause.cpp"
    ; //@line 1164 "readclause.cpp"
    while(1) { 
  
      var $4=$ix; //@line 1166 "readclause.cpp"
      var $5=$sp; //@line 1166 "readclause.cpp"
      var $parameter=(($5+4)&4294967295); //@line 1166 "readclause.cpp"
      var $arrayidx2=(($parameter+$4*4)&4294967295); //@line 1166 "readclause.cpp"
      HEAP32[(($arrayidx2)>>2)]=-1; //@line 1166 "readclause.cpp"
      var $6=$ix; //@line 1164 "readclause.cpp"
      var $inc3=((($6)+1)&4294967295); //@line 1164 "readclause.cpp"
      $ix=$inc3; //@line 1164 "readclause.cpp"
      var $cmp1=((($inc3))|0) < 15; //@line 1164 "readclause.cpp"
      if ($cmp1) { __label__ = 3;continue ; } else { __label__ = 4;break ; } //@line 1164 "readclause.cpp"
    }
  
    var $7=$sp; //@line 1168 "readclause.cpp"
    ;
    return $7; //@line 1168 "readclause.cpp"
    return null;
  }
  

  function __ZL16GetSsmlAttributePwPKc($pw, $name) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $pw_addr;
    var $name_addr;
    var $ix;
    $pw_addr=$pw;
    $name_addr=$name;
    ; //@line 1204 "readclause.cpp"
    $while_cond$2: while(1) { 
  
      var $0=$pw_addr; //@line 1204 "readclause.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 1204 "readclause.cpp"
      var $cmp=((($1))|0)!=0; //@line 1204 "readclause.cpp"
      if (!($cmp)) { __label__ = 17;break $while_cond$2; } //@line 1204 "readclause.cpp"
  
      var $2=$pw_addr; //@line 1206 "readclause.cpp"
      var $arrayidx=(($2+-4)&4294967295); //@line 1206 "readclause.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 1206 "readclause.cpp"
      var $call=_iswspace($3); //@line 1206 "readclause.cpp"
      var $tobool=((($call))|0)!=0; //@line 1206 "readclause.cpp"
      if ($tobool) { __label__ = 3;; } else { __label__ = 16;; } //@line 1206 "readclause.cpp"
      if (__label__ == 3) {
  
        $ix=0; //@line 1208 "readclause.cpp"
        var $4=$pw_addr; //@line 1209 "readclause.cpp"
        var $5=HEAP32[(($4)>>2)]; //@line 1209 "readclause.cpp"
        var $6=$ix; //@line 1209 "readclause.cpp"
        var $7=$name_addr; //@line 1209 "readclause.cpp"
        var $arrayidx27=(($7+$6)&4294967295); //@line 1209 "readclause.cpp"
        var $8=HEAP8[($arrayidx27)]; //@line 1209 "readclause.cpp"
        var $conv8=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 1209 "readclause.cpp"
        var $cmp39=((($5))|0)==((($conv8))|0); //@line 1209 "readclause.cpp"
        if ($cmp39) { __label__ = 4;; } else { __label__ = 5;; } //@line 1209 "readclause.cpp"
        $while_body4$$while_end$7: do { 
          if (__label__ == 4) {
            while(1) { 
  
              var $9=$pw_addr; //@line 1211 "readclause.cpp"
              var $incdec_ptr=(($9+4)&4294967295); //@line 1211 "readclause.cpp"
              $pw_addr=$incdec_ptr; //@line 1211 "readclause.cpp"
              var $10=$ix; //@line 1212 "readclause.cpp"
              var $inc=((($10)+1)&4294967295); //@line 1212 "readclause.cpp"
              $ix=$inc; //@line 1212 "readclause.cpp"
              var $11=$pw_addr; //@line 1209 "readclause.cpp"
              var $12=HEAP32[(($11)>>2)]; //@line 1209 "readclause.cpp"
              var $13=$ix; //@line 1209 "readclause.cpp"
              var $14=$name_addr; //@line 1209 "readclause.cpp"
              var $arrayidx2=(($14+$13)&4294967295); //@line 1209 "readclause.cpp"
              var $15=HEAP8[($arrayidx2)]; //@line 1209 "readclause.cpp"
              var $conv=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 1209 "readclause.cpp"
              var $cmp3=((($12))|0)==((($conv))|0); //@line 1209 "readclause.cpp"
              if ($cmp3) { __label__ = 4;continue ; } else { __label__ = 5;break $while_body4$$while_end$7; } //@line 1209 "readclause.cpp"
            }
          }
        } while(0);
  
        var $16=$ix; //@line 1214 "readclause.cpp"
        var $17=$name_addr; //@line 1214 "readclause.cpp"
        var $arrayidx5=(($17+$16)&4294967295); //@line 1214 "readclause.cpp"
        var $18=HEAP8[($arrayidx5)]; //@line 1214 "readclause.cpp"
        var $conv6=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 1214 "readclause.cpp"
        var $cmp7=((($conv6))|0)==0; //@line 1214 "readclause.cpp"
        if ($cmp7) { __label__ = 6;break $while_cond$2; } //@line 1214 "readclause.cpp"
      }
  
      var $39=$pw_addr; //@line 1226 "readclause.cpp"
      var $incdec_ptr29=(($39+4)&4294967295); //@line 1226 "readclause.cpp"
      $pw_addr=$incdec_ptr29; //@line 1226 "readclause.cpp"
      __label__ = 1;continue $while_cond$2; //@line 1227 "readclause.cpp"
    }
    $while_end30$$while_cond9_preheader$12: do { 
      if (__label__ == 17) {
  
        $retval=0; //@line 1228 "readclause.cpp"
        ; //@line 1228 "readclause.cpp"
      }
      else if (__label__ == 6) {
  
        var $19=$pw_addr; //@line 1217 "readclause.cpp"
        var $20=HEAP32[(($19)>>2)]; //@line 1217 "readclause.cpp"
        var $call104=_iswspace($20); //@line 1217 "readclause.cpp"
        var $tobool115=((($call104))|0)!=0; //@line 1217 "readclause.cpp"
        var $21=$pw_addr; //@line 1217 "readclause.cpp"
        if ($tobool115) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 8;; } //@line 1217 "readclause.cpp"
        $while_body12$$while_end14$15: do { 
          if (__label__ == 7) {
            while(1) { 
  
              var $22=__lastLabel__ == 7 ? $25 : ($21);
              var $incdec_ptr13=(($22+4)&4294967295); //@line 1217 "readclause.cpp"
              $pw_addr=$incdec_ptr13; //@line 1217 "readclause.cpp"
              var $23=$pw_addr; //@line 1217 "readclause.cpp"
              var $24=HEAP32[(($23)>>2)]; //@line 1217 "readclause.cpp"
              var $call10=_iswspace($24); //@line 1217 "readclause.cpp"
              var $tobool11=((($call10))|0)!=0; //@line 1217 "readclause.cpp"
              var $25=$pw_addr; //@line 1217 "readclause.cpp"
              if ($tobool11) { __lastLabel__ = 7; __label__ = 7;continue ; } else { __lastLabel__ = 7; __label__ = 8;break $while_body12$$while_end14$15; } //@line 1217 "readclause.cpp"
            }
          }
        } while(0);
  
        var $_lcssa3=__lastLabel__ == 6 ? $21 : ($25);
        var $26=HEAP32[(($_lcssa3)>>2)]; //@line 1218 "readclause.cpp"
        var $cmp15=((($26))|0)==61; //@line 1218 "readclause.cpp"
        if ($cmp15) { __label__ = 9;; } else { __label__ = 10;; } //@line 1218 "readclause.cpp"
        if (__label__ == 9) {
  
          var $27=$pw_addr; //@line 1218 "readclause.cpp"
          var $incdec_ptr17=(($27+4)&4294967295); //@line 1218 "readclause.cpp"
          $pw_addr=$incdec_ptr17; //@line 1218 "readclause.cpp"
          ; //@line 1218 "readclause.cpp"
        }
  
        var $28=$pw_addr; //@line 1219 "readclause.cpp"
        var $29=HEAP32[(($28)>>2)]; //@line 1219 "readclause.cpp"
        var $call191=_iswspace($29); //@line 1219 "readclause.cpp"
        var $tobool202=((($call191))|0)!=0; //@line 1219 "readclause.cpp"
        var $30=$pw_addr; //@line 1219 "readclause.cpp"
        if ($tobool202) { __lastLabel__ = 10; __label__ = 11;; } else { __lastLabel__ = 10; __label__ = 12;; } //@line 1219 "readclause.cpp"
        $while_body21$$while_end23$22: do { 
          if (__label__ == 11) {
            while(1) { 
  
              var $31=__lastLabel__ == 11 ? $34 : ($30);
              var $incdec_ptr22=(($31+4)&4294967295); //@line 1219 "readclause.cpp"
              $pw_addr=$incdec_ptr22; //@line 1219 "readclause.cpp"
              var $32=$pw_addr; //@line 1219 "readclause.cpp"
              var $33=HEAP32[(($32)>>2)]; //@line 1219 "readclause.cpp"
              var $call19=_iswspace($33); //@line 1219 "readclause.cpp"
              var $tobool20=((($call19))|0)!=0; //@line 1219 "readclause.cpp"
              var $34=$pw_addr; //@line 1219 "readclause.cpp"
              if ($tobool20) { __lastLabel__ = 11; __label__ = 11;continue ; } else { __lastLabel__ = 11; __label__ = 12;break $while_body21$$while_end23$22; } //@line 1219 "readclause.cpp"
            }
          }
        } while(0);
  
        var $_lcssa=__lastLabel__ == 10 ? $30 : ($34);
        var $35=HEAP32[(($_lcssa)>>2)]; //@line 1220 "readclause.cpp"
        var $cmp24=((($35))|0)==34; //@line 1220 "readclause.cpp"
        if ($cmp24) { __label__ = 14;; } else { __label__ = 13;; } //@line 1220 "readclause.cpp"
        $if_then26$$lor_lhs_false$26: do { 
          if (__label__ == 13) {
  
            var $36=$pw_addr; //@line 1220 "readclause.cpp"
            var $37=HEAP32[(($36)>>2)]; //@line 1220 "readclause.cpp"
            var $cmp25=((($37))|0)==39; //@line 1220 "readclause.cpp"
            if ($cmp25) { __label__ = 14;break $if_then26$$lor_lhs_false$26; } //@line 1220 "readclause.cpp"
  
            $retval=((__ZZL16GetSsmlAttributePwPKcE5empty)&4294967295); //@line 1223 "readclause.cpp"
            __label__ = 18;break $while_end30$$while_cond9_preheader$12; //@line 1223 "readclause.cpp"
          }
        } while(0);
  
        var $38=$pw_addr; //@line 1221 "readclause.cpp"
        var $add_ptr=(($38+4)&4294967295); //@line 1221 "readclause.cpp"
        $retval=$add_ptr; //@line 1221 "readclause.cpp"
        ; //@line 1221 "readclause.cpp"
      }
    } while(0);
  
    var $40=$retval; //@line 1229 "readclause.cpp"
    ;
    return $40; //@line 1229 "readclause.cpp"
    return null;
  }
  

  function __ZL7attrcmpPKwPKc($string1, $string2) {
    ;
    var __label__;
  
    var $retval;
    var $string1_addr;
    var $string2_addr;
    var $ix;
    $string1_addr=$string1;
    $string2_addr=$string2;
    var $0=$string1_addr; //@line 1236 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 1236 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1236 "readclause.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=1; //@line 1237 "readclause.cpp"
        ; //@line 1237 "readclause.cpp"
      }
      else if (__label__ == 2) {
  
        $ix=0; //@line 1239 "readclause.cpp"
        ; //@line 1239 "readclause.cpp"
        $for_cond$5: while(1) { 
  
          var $1=$ix; //@line 1239 "readclause.cpp"
          var $2=$string1_addr; //@line 1239 "readclause.cpp"
          var $arrayidx=(($2+4*$1)&4294967295); //@line 1239 "readclause.cpp"
          var $3=HEAP32[(($arrayidx)>>2)]; //@line 1239 "readclause.cpp"
          var $4=$ix; //@line 1239 "readclause.cpp"
          var $5=$string2_addr; //@line 1239 "readclause.cpp"
          var $arrayidx1=(($5+$4)&4294967295); //@line 1239 "readclause.cpp"
          var $6=HEAP8[($arrayidx1)]; //@line 1239 "readclause.cpp"
          var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 1239 "readclause.cpp"
          var $cmp2=((($3))|0)==((($conv))|0); //@line 1239 "readclause.cpp"
          if (!($cmp2)) { __label__ = 6;break $for_cond$5; } //@line 1239 "readclause.cpp"
  
          var $7=$ix; //@line 1239 "readclause.cpp"
          var $8=$string1_addr; //@line 1239 "readclause.cpp"
          var $arrayidx3=(($8+4*$7)&4294967295); //@line 1239 "readclause.cpp"
          var $9=HEAP32[(($arrayidx3)>>2)]; //@line 1239 "readclause.cpp"
          var $cmp4=((($9))|0)!=0; //@line 1239 "readclause.cpp"
          if (!($cmp4)) { __label__ = 6;break $for_cond$5; }
  
          var $10=$ix; //@line 1239 "readclause.cpp"
          var $inc=((($10)+1)&4294967295); //@line 1239 "readclause.cpp"
          $ix=$inc; //@line 1239 "readclause.cpp"
          __label__ = 3;continue $for_cond$5; //@line 1239 "readclause.cpp"
        }
  
        var $11=$ix; //@line 1242 "readclause.cpp"
        var $12=$string1_addr; //@line 1242 "readclause.cpp"
        var $arrayidx5=(($12+4*$11)&4294967295); //@line 1242 "readclause.cpp"
        var $13=HEAP32[(($arrayidx5)>>2)]; //@line 1242 "readclause.cpp"
        var $cmp6=((($13))|0)==34; //@line 1242 "readclause.cpp"
        if ($cmp6) { __label__ = 8;; } else { __label__ = 7;; } //@line 1242 "readclause.cpp"
        $land_lhs_true$$lor_lhs_false$10: do { 
          if (__label__ == 7) {
  
            var $14=$ix; //@line 1242 "readclause.cpp"
            var $15=$string1_addr; //@line 1242 "readclause.cpp"
            var $arrayidx7=(($15+4*$14)&4294967295); //@line 1242 "readclause.cpp"
            var $16=HEAP32[(($arrayidx7)>>2)]; //@line 1242 "readclause.cpp"
            var $cmp8=((($16))|0)==39; //@line 1242 "readclause.cpp"
            if ($cmp8) { __label__ = 8;break $land_lhs_true$$lor_lhs_false$10; } else { __label__ = 10;break $land_lhs_true$$lor_lhs_false$10; } //@line 1242 "readclause.cpp"
          }
        } while(0);
        $land_lhs_true$$if_end13$12: do { 
          if (__label__ == 8) {
  
            var $17=$ix; //@line 1242 "readclause.cpp"
            var $18=$string2_addr; //@line 1242 "readclause.cpp"
            var $arrayidx9=(($18+$17)&4294967295); //@line 1242 "readclause.cpp"
            var $19=HEAP8[($arrayidx9)]; //@line 1242 "readclause.cpp"
            var $conv10=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 1242 "readclause.cpp"
            var $cmp11=((($conv10))|0)==0; //@line 1242 "readclause.cpp"
            if (!($cmp11)) { __label__ = 10;break $land_lhs_true$$if_end13$12; } //@line 1242 "readclause.cpp"
  
            $retval=0; //@line 1243 "readclause.cpp"
            __label__ = 11;break $if_then$$if_end$2; //@line 1243 "readclause.cpp"
          }
        } while(0);
  
        $retval=1; //@line 1244 "readclause.cpp"
        ; //@line 1244 "readclause.cpp"
      }
    } while(0);
  
    var $20=$retval; //@line 1245 "readclause.cpp"
    ;
    return $20; //@line 1245 "readclause.cpp"
    return null;
  }
  

  function __ZL10attrlookupPKwPK8MNEM_TAB($string1, $mtab) {
    ;
    var __label__;
  
    var $retval;
    var $string1_addr;
    var $mtab_addr;
    var $ix;
    $string1_addr=$string1;
    $mtab_addr=$mtab;
    $ix=0; //@line 1252 "readclause.cpp"
    ; //@line 1252 "readclause.cpp"
    while(1) { 
  
      var $0=$ix; //@line 1252 "readclause.cpp"
      var $1=$mtab_addr; //@line 1252 "readclause.cpp"
      var $arrayidx=(($1+8*$0)&4294967295); //@line 1252 "readclause.cpp"
      var $mnem=(($arrayidx)&4294967295); //@line 1252 "readclause.cpp"
      var $2=HEAP32[(($mnem)>>2)]; //@line 1252 "readclause.cpp"
      var $cmp=((($2))|0)!=0; //@line 1252 "readclause.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 1252 "readclause.cpp"
  
      var $3=$string1_addr; //@line 1254 "readclause.cpp"
      var $4=$ix; //@line 1254 "readclause.cpp"
      var $5=$mtab_addr; //@line 1254 "readclause.cpp"
      var $arrayidx1=(($5+8*$4)&4294967295); //@line 1254 "readclause.cpp"
      var $mnem2=(($arrayidx1)&4294967295); //@line 1254 "readclause.cpp"
      var $6=HEAP32[(($mnem2)>>2)]; //@line 1254 "readclause.cpp"
      var $call=__ZL7attrcmpPKwPKc($3, $6); //@line 1254 "readclause.cpp"
      var $cmp3=((($call))|0)==0; //@line 1254 "readclause.cpp"
      var $7=$ix; //@line 1255 "readclause.cpp"
      if ($cmp3) { __label__ = 3;break ; } //@line 1254 "readclause.cpp"
  
      var $inc=((($7)+1)&4294967295); //@line 1252 "readclause.cpp"
      $ix=$inc; //@line 1252 "readclause.cpp"
      __label__ = 1;continue ; //@line 1252 "readclause.cpp"
    }
    if (__label__ == 5) {
  
      var $10=$ix; //@line 1257 "readclause.cpp"
      var $11=$mtab_addr; //@line 1257 "readclause.cpp"
      var $arrayidx5=(($11+8*$10)&4294967295); //@line 1257 "readclause.cpp"
      var $value6=(($arrayidx5+4)&4294967295); //@line 1257 "readclause.cpp"
      var $12=HEAP32[(($value6)>>2)]; //@line 1257 "readclause.cpp"
      $retval=$12; //@line 1257 "readclause.cpp"
      ; //@line 1257 "readclause.cpp"
    }
    else if (__label__ == 3) {
  
      var $8=$mtab_addr; //@line 1255 "readclause.cpp"
      var $arrayidx4=(($8+8*$7)&4294967295); //@line 1255 "readclause.cpp"
      var $value=(($arrayidx4+4)&4294967295); //@line 1255 "readclause.cpp"
      var $9=HEAP32[(($value)>>2)]; //@line 1255 "readclause.cpp"
      $retval=$9; //@line 1255 "readclause.cpp"
      ; //@line 1255 "readclause.cpp"
    }
  
    var $13=$retval; //@line 1258 "readclause.cpp"
    ;
    return $13; //@line 1258 "readclause.cpp"
    return null;
  }
  

  function __ZL17ProcessParamStackPcRi($outbuf, $outix) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
  
    var $outbuf_addr;
    var $outix_addr;
    var $param;
    var $ix;
    var $value;
    var $buf=__stackBase__;
    var $new_parameters=__stackBase__+20;
    $outbuf_addr=$outbuf;
    $outix_addr=$outix;
    $param=0; //@line 1109 "readclause.cpp"
    ; //@line 1109 "readclause.cpp"
    $for_body$2: while(1) { 
  
      var $0=$param; //@line 1110 "readclause.cpp"
      var $arrayidx=(($new_parameters+$0*4)&4294967295); //@line 1110 "readclause.cpp"
      HEAP32[(($arrayidx)>>2)]=-1; //@line 1110 "readclause.cpp"
      var $1=$param; //@line 1109 "readclause.cpp"
      var $inc=((($1)+1)&4294967295); //@line 1109 "readclause.cpp"
      $param=$inc; //@line 1109 "readclause.cpp"
      var $cmp=((($inc))|0) < 15; //@line 1109 "readclause.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 2;break $for_body$2; } //@line 1109 "readclause.cpp"
    }
  
    $ix=0; //@line 1112 "readclause.cpp"
    var $2=$ix; //@line 1112 "readclause.cpp"
    var $3=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1112 "readclause.cpp"
    var $cmp22=((($2))|0) < ((($3))|0); //@line 1112 "readclause.cpp"
    $param=0; //@line 1114 "readclause.cpp"
    if ($cmp22) { __label__ = 4;; } else { __label__ = 3;; } //@line 1112 "readclause.cpp"
    $for_body6$$for_cond20_preheader$5: do { 
      if (__label__ == 4) {
        while(1) { 
  
          var $4=$param; //@line 1116 "readclause.cpp"
          var $5=$ix; //@line 1116 "readclause.cpp"
          var $arrayidx7=((_param_stack+$5*64)&4294967295); //@line 1116 "readclause.cpp"
          var $parameter=(($arrayidx7+4)&4294967295); //@line 1116 "readclause.cpp"
          var $arrayidx8=(($parameter+$4*4)&4294967295); //@line 1116 "readclause.cpp"
          var $6=HEAP32[(($arrayidx8)>>2)]; //@line 1116 "readclause.cpp"
          var $cmp9=((($6))|0) >= 0; //@line 1116 "readclause.cpp"
          if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 1116 "readclause.cpp"
          if (__label__ == 5) {
  
            var $7=$param; //@line 1117 "readclause.cpp"
            var $8=$ix; //@line 1117 "readclause.cpp"
            var $arrayidx10=((_param_stack+$8*64)&4294967295); //@line 1117 "readclause.cpp"
            var $parameter11=(($arrayidx10+4)&4294967295); //@line 1117 "readclause.cpp"
            var $arrayidx12=(($parameter11+$7*4)&4294967295); //@line 1117 "readclause.cpp"
            var $9=HEAP32[(($arrayidx12)>>2)]; //@line 1117 "readclause.cpp"
            var $10=$param; //@line 1117 "readclause.cpp"
            var $arrayidx13=(($new_parameters+$10*4)&4294967295); //@line 1117 "readclause.cpp"
            HEAP32[(($arrayidx13)>>2)]=$9; //@line 1117 "readclause.cpp"
            ; //@line 1117 "readclause.cpp"
          }
  
          var $11=$param; //@line 1114 "readclause.cpp"
          var $inc15=((($11)+1)&4294967295); //@line 1114 "readclause.cpp"
          $param=$inc15; //@line 1114 "readclause.cpp"
          var $cmp5=((($inc15))|0) < 15; //@line 1114 "readclause.cpp"
          if ($cmp5) { __label__ = 4;continue ; } //@line 1114 "readclause.cpp"
  
          var $12=$ix; //@line 1112 "readclause.cpp"
          var $inc18=((($12)+1)&4294967295); //@line 1112 "readclause.cpp"
          $ix=$inc18; //@line 1112 "readclause.cpp"
          var $13=$ix; //@line 1112 "readclause.cpp"
          var $14=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1112 "readclause.cpp"
          var $cmp2=((($13))|0) < ((($14))|0); //@line 1112 "readclause.cpp"
          $param=0; //@line 1114 "readclause.cpp"
          if ($cmp2) { __label__ = 4;continue ; } else { __label__ = 3;break $for_body6$$for_cond20_preheader$5; } //@line 1112 "readclause.cpp"
        }
      }
    } while(0);
  
    var $arrayidx27=(($buf)&4294967295); //@line 1125 "readclause.cpp"
    var $arraydecay34=(($buf)&4294967295); //@line 1147 "readclause.cpp"
    var $arraydecay36=(($buf)&4294967295); //@line 1148 "readclause.cpp"
    var $arraydecay=(($buf)&4294967295); //@line 1142 "readclause.cpp"
    ; //@line 1121 "readclause.cpp"
    while(1) { 
  
      var $15=$param; //@line 1123 "readclause.cpp"
      var $arrayidx23=(($new_parameters+$15*4)&4294967295); //@line 1123 "readclause.cpp"
      var $16=HEAP32[(($arrayidx23)>>2)]; //@line 1123 "readclause.cpp"
      $value=$16; //@line 1123 "readclause.cpp"
      var $17=$param; //@line 1123 "readclause.cpp"
      var $arrayidx24=((__ZL17speech_parameters+$17*4)&4294967295); //@line 1123 "readclause.cpp"
      var $18=HEAP32[(($arrayidx24)>>2)]; //@line 1123 "readclause.cpp"
      var $cmp25=((($16))|0)!=((($18))|0); //@line 1123 "readclause.cpp"
      if ($cmp25) { __label__ = 9;; } else { __label__ = 14;; } //@line 1123 "readclause.cpp"
      if (__label__ == 9) {
  
        HEAP8[($arrayidx27)]=0; //@line 1125 "readclause.cpp"
        var $19=$param; //@line 1127 "readclause.cpp"
        if ($19 == 5) {
          __label__ = 10;;
        }
        else if ($19 == 6) {
          __label__ = 11;;
        }
        else if ($19 == 1) {
          __label__ = 12;;
        }
        else if ($19 == 2) {
          __label__ = 12;;
        }
        else if ($19 == 3) {
          __label__ = 12;;
        }
        else if ($19 == 4) {
          __label__ = 12;;
        }
        else if ($19 == 12) {
          __label__ = 12;;
        }
        else {
        __label__ = 13;;
        }
        
        if (__label__ == 10) {
  
          var $20=$value; //@line 1130 "readclause.cpp"
          var $sub=((($20)-1)&4294967295); //@line 1130 "readclause.cpp"
          HEAP32[((_option_punctuation)>>2)]=$sub; //@line 1130 "readclause.cpp"
          ; //@line 1131 "readclause.cpp"
        }
        else if (__label__ == 11) {
  
          var $21=$value; //@line 1134 "readclause.cpp"
          HEAP32[((_option_capitals)>>2)]=$21; //@line 1134 "readclause.cpp"
          ; //@line 1135 "readclause.cpp"
        }
        else if (__label__ == 12) {
  
          var $22=$value; //@line 1142 "readclause.cpp"
          var $23=$param; //@line 1142 "readclause.cpp"
          var $arrayidx30=((__ZZL17ProcessParamStackPcRiE10cmd_letter+$23)&4294967295); //@line 1142 "readclause.cpp"
          var $24=HEAP8[($arrayidx30)]; //@line 1142 "readclause.cpp"
          var $conv=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 1142 "readclause.cpp"
          var $call=_sprintf($arraydecay, ((__str128)&4294967295), allocate([1,0,0,0,$22,0,0,0,$conv,0,0,0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1142 "readclause.cpp"
          ; //@line 1143 "readclause.cpp"
        }
  
        var $25=$param; //@line 1146 "readclause.cpp"
        var $arrayidx31=(($new_parameters+$25*4)&4294967295); //@line 1146 "readclause.cpp"
        var $26=HEAP32[(($arrayidx31)>>2)]; //@line 1146 "readclause.cpp"
        var $27=$param; //@line 1146 "readclause.cpp"
        var $arrayidx32=((__ZL17speech_parameters+$27*4)&4294967295); //@line 1146 "readclause.cpp"
        HEAP32[(($arrayidx32)>>2)]=$26; //@line 1146 "readclause.cpp"
        var $28=$outix_addr; //@line 1147 "readclause.cpp"
        var $29=HEAP32[(($28)>>2)]; //@line 1147 "readclause.cpp"
        var $30=$outbuf_addr; //@line 1147 "readclause.cpp"
        var $arrayidx33=(($30+$29)&4294967295); //@line 1147 "readclause.cpp"
        var $call35=_strcpy($arrayidx33, $arraydecay34); //@line 1147 "readclause.cpp"
        var $call37=_strlen($arraydecay36); //@line 1148 "readclause.cpp"
        var $31=$outix_addr; //@line 1148 "readclause.cpp"
        var $32=HEAP32[(($31)>>2)]; //@line 1148 "readclause.cpp"
        var $add=((($32)+($call37))&4294967295); //@line 1148 "readclause.cpp"
        HEAP32[(($31)>>2)]=$add; //@line 1148 "readclause.cpp"
        ; //@line 1149 "readclause.cpp"
      }
  
      var $33=$param; //@line 1121 "readclause.cpp"
      var $inc40=((($33)+1)&4294967295); //@line 1121 "readclause.cpp"
      $param=$inc40; //@line 1121 "readclause.cpp"
      var $cmp21=((($inc40))|0) < 15; //@line 1121 "readclause.cpp"
      if ($cmp21) { __label__ = 8;continue ; } else { __label__ = 15;break ; } //@line 1121 "readclause.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1151 "readclause.cpp"
    return;
  }
  

  function __ZL19SetProsodyParameteriPwP11PARAM_STACK($param_type, $attr1, $sp) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $param_type_addr;
    var $attr1_addr;
    var $sp_addr;
    var $value=__stackBase__;
    var $sign;
    $param_type_addr=$param_type;
    $attr1_addr=$attr1;
    $sp_addr=$sp;
    var $0=$attr1_addr; //@line 1538 "readclause.cpp"
    var $1=$param_type_addr; //@line 1538 "readclause.cpp"
    var $arrayidx=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+$1*4)&4294967295); //@line 1538 "readclause.cpp"
    var $2=HEAP32[(($arrayidx)>>2)]; //@line 1538 "readclause.cpp"
    var $call=__ZL10attrlookupPKwPK8MNEM_TAB($0, $2); //@line 1538 "readclause.cpp"
    HEAP32[(($value)>>2)]=$call; //@line 1538 "readclause.cpp"
    var $cmp=((($call))|0) >= 0; //@line 1538 "readclause.cpp"
    var $3=$param_type_addr; //@line 1541 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1538 "readclause.cpp"
    if (__label__ == 1) {
  
      var $arrayidx1=((((_param_stack+4)&4294967295)+$3*4)&4294967295); //@line 1541 "readclause.cpp"
      var $4=HEAP32[(($arrayidx1)>>2)]; //@line 1541 "readclause.cpp"
      var $5=HEAP32[(($value)>>2)]; //@line 1541 "readclause.cpp"
      var $mul=((($5)*($4))&4294967295); //@line 1541 "readclause.cpp"
      var $div=((((($mul))|0)/100)|0); //@line 1541 "readclause.cpp"
      var $6=$param_type_addr; //@line 1541 "readclause.cpp"
      var $7=$sp_addr; //@line 1541 "readclause.cpp"
      var $parameter=(($7+4)&4294967295); //@line 1541 "readclause.cpp"
      var $arrayidx2=(($parameter+$6*4)&4294967295); //@line 1541 "readclause.cpp"
      HEAP32[(($arrayidx2)>>2)]=$div; //@line 1541 "readclause.cpp"
      ; //@line 1542 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $8=$attr1_addr; //@line 1545 "readclause.cpp"
      var $call3=__ZL18attr_prosody_valueiPKwPi($3, $8, $value); //@line 1545 "readclause.cpp"
      $sign=$call3; //@line 1545 "readclause.cpp"
      var $9=$sign; //@line 1547 "readclause.cpp"
      var $cmp4=((($9))|0)==0; //@line 1547 "readclause.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1547 "readclause.cpp"
      if (__label__ == 3) {
  
        var $10=HEAP32[(($value)>>2)]; //@line 1548 "readclause.cpp"
        var $11=$param_type_addr; //@line 1548 "readclause.cpp"
        var $12=$sp_addr; //@line 1548 "readclause.cpp"
        var $parameter6=(($12+4)&4294967295); //@line 1548 "readclause.cpp"
        var $arrayidx7=(($parameter6+$11*4)&4294967295); //@line 1548 "readclause.cpp"
        HEAP32[(($arrayidx7)>>2)]=$10; //@line 1548 "readclause.cpp"
        ; //@line 1548 "readclause.cpp"
      }
      else if (__label__ == 4) {
  
        var $13=$sign; //@line 1550 "readclause.cpp"
        var $cmp9=((($13))|0)==2; //@line 1550 "readclause.cpp"
        var $14=$param_type_addr; //@line 1553 "readclause.cpp"
        var $arrayidx11=((__ZL17speech_parameters+$14*4)&4294967295); //@line 1553 "readclause.cpp"
        var $15=HEAP32[(($arrayidx11)>>2)]; //@line 1553 "readclause.cpp"
        var $16=HEAP32[(($value)>>2)]; //@line 1553 "readclause.cpp"
        if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 1550 "readclause.cpp"
        if (__label__ == 5) {
  
          var $mul12=((($16)*($15))&4294967295); //@line 1553 "readclause.cpp"
          var $div13=((((($mul12))|0)/100)|0); //@line 1553 "readclause.cpp"
          var $17=$param_type_addr; //@line 1553 "readclause.cpp"
          var $18=$sp_addr; //@line 1553 "readclause.cpp"
          var $parameter14=(($18+4)&4294967295); //@line 1553 "readclause.cpp"
          var $arrayidx15=(($parameter14+$17*4)&4294967295); //@line 1553 "readclause.cpp"
          HEAP32[(($arrayidx15)>>2)]=$div13; //@line 1553 "readclause.cpp"
          ; //@line 1554 "readclause.cpp"
        }
        else if (__label__ == 6) {
  
          var $19=$sign; //@line 1558 "readclause.cpp"
          var $mul18=((($19)*($16))&4294967295); //@line 1558 "readclause.cpp"
          var $add=((($mul18)+($15))&4294967295); //@line 1558 "readclause.cpp"
          var $20=$param_type_addr; //@line 1558 "readclause.cpp"
          var $21=$sp_addr; //@line 1558 "readclause.cpp"
          var $parameter19=(($21+4)&4294967295); //@line 1558 "readclause.cpp"
          var $arrayidx20=(($parameter19+$20*4)&4294967295); //@line 1558 "readclause.cpp"
          HEAP32[(($arrayidx20)>>2)]=$add; //@line 1558 "readclause.cpp"
          ;
        }
      }
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1561 "readclause.cpp"
    return;
  }
  

  function __ZL13PopParamStackiPcRi($tag_type, $outbuf, $outix) {
    ;
    var __label__;
  
    var $tag_type_addr;
    var $outbuf_addr;
    var $outix_addr;
    var $ix;
    var $top;
    $tag_type_addr=$tag_type;
    $outbuf_addr=$outbuf;
    $outix_addr=$outix;
    $top=0; //@line 1176 "readclause.cpp"
    var $0=$tag_type_addr; //@line 1178 "readclause.cpp"
    var $cmp=((($0))|0) >= 32; //@line 1178 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1178 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$tag_type_addr; //@line 1179 "readclause.cpp"
      var $sub=((($1)-32)&4294967295); //@line 1179 "readclause.cpp"
      $tag_type_addr=$sub; //@line 1179 "readclause.cpp"
      ; //@line 1179 "readclause.cpp"
    }
  
    $ix=0; //@line 1181 "readclause.cpp"
    var $2=$ix; //@line 1181 "readclause.cpp"
    var $3=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1181 "readclause.cpp"
    var $cmp11=((($2))|0) < ((($3))|0); //@line 1181 "readclause.cpp"
    if ($cmp11) { __label__ = 3;; } else { __label__ = 6;; } //@line 1181 "readclause.cpp"
    $for_body$$for_end$5: do { 
      if (__label__ == 3) {
        while(1) { 
  
          var $4=$ix; //@line 1183 "readclause.cpp"
          var $arrayidx=((_param_stack+$4*64)&4294967295); //@line 1183 "readclause.cpp"
          var $type=(($arrayidx)&4294967295); //@line 1183 "readclause.cpp"
          var $5=HEAP32[(($type)>>2)]; //@line 1183 "readclause.cpp"
          var $6=$tag_type_addr; //@line 1183 "readclause.cpp"
          var $cmp2=((($5))|0)==((($6))|0); //@line 1183 "readclause.cpp"
          if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 1183 "readclause.cpp"
          if (__label__ == 4) {
  
            var $7=$ix; //@line 1185 "readclause.cpp"
            $top=$7; //@line 1185 "readclause.cpp"
            ; //@line 1186 "readclause.cpp"
          }
  
          var $8=$ix; //@line 1181 "readclause.cpp"
          var $inc=((($8)+1)&4294967295); //@line 1181 "readclause.cpp"
          $ix=$inc; //@line 1181 "readclause.cpp"
          var $9=$ix; //@line 1181 "readclause.cpp"
          var $10=HEAP32[((__ZL13n_param_stack)>>2)]; //@line 1181 "readclause.cpp"
          var $cmp1=((($9))|0) < ((($10))|0); //@line 1181 "readclause.cpp"
          if ($cmp1) { __label__ = 3;continue ; } else { __label__ = 6;break $for_body$$for_end$5; } //@line 1181 "readclause.cpp"
        }
      }
    } while(0);
  
    var $11=$top; //@line 1188 "readclause.cpp"
    var $cmp5=((($11))|0) > 0; //@line 1188 "readclause.cpp"
    if ($cmp5) { __label__ = 7;; } else { __label__ = 8;; } //@line 1188 "readclause.cpp"
    if (__label__ == 7) {
  
      var $12=$top; //@line 1190 "readclause.cpp"
      HEAP32[((__ZL13n_param_stack)>>2)]=$12; //@line 1190 "readclause.cpp"
      ; //@line 1191 "readclause.cpp"
    }
  
    var $13=$outbuf_addr; //@line 1192 "readclause.cpp"
    var $14=$outix_addr; //@line 1192 "readclause.cpp"
    __ZL17ProcessParamStackPcRi($13, $14); //@line 1192 "readclause.cpp"
    ;
    return; //@line 1193 "readclause.cpp"
    return;
  }
  

  function __ZL10attrnumberPKwii($pw, $default_value, $type) {
    ;
    var __label__;
  
    var $retval;
    var $pw_addr;
    var $default_value_addr;
    var $type_addr;
    var $value;
    $pw_addr=$pw;
    $default_value_addr=$default_value;
    $type_addr=$type;
    $value=0; //@line 1263 "readclause.cpp"
    var $0=$pw_addr; //@line 1265 "readclause.cpp"
    var $cmp=((($0))|0)==0; //@line 1265 "readclause.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 1;; } //@line 1265 "readclause.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$pw_addr; //@line 1265 "readclause.cpp"
        var $2=HEAP32[(($1)>>2)]; //@line 1265 "readclause.cpp"
        var $isdigittmp=((($2)-48)&4294967295); //@line 1265 "readclause.cpp"
        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1265 "readclause.cpp"
        var $call=((($isdigit))&1); //@line 1265 "readclause.cpp"
        var $tobool=((($call))|0)!=0; //@line 1265 "readclause.cpp"
        if (!($tobool)) { __label__ = 3;break $if_then$$lor_lhs_false$2; } //@line 1265 "readclause.cpp"
  
        var $3=$pw_addr; //@line 1268 "readclause.cpp"
        var $4=HEAP32[(($3)>>2)]; //@line 1268 "readclause.cpp"
        var $isdigittmp13=((($4)-48)&4294967295); //@line 1268 "readclause.cpp"
        var $isdigit24=((($isdigittmp13))>>>0) < 10; //@line 1268 "readclause.cpp"
        if ($isdigit24) { __label__ = 4;; } else { __label__ = 5;; } //@line 1268 "readclause.cpp"
        $while_body$$while_end$5: do { 
          if (__label__ == 4) {
            while(1) { 
  
              var $6=$value; //@line 1270 "readclause.cpp"
              var $mul=((($6)*10)&4294967295); //@line 1270 "readclause.cpp"
              var $7=$pw_addr; //@line 1270 "readclause.cpp"
              var $incdec_ptr=(($7+4)&4294967295); //@line 1270 "readclause.cpp"
              $pw_addr=$incdec_ptr; //@line 1270 "readclause.cpp"
              var $8=HEAP32[(($7)>>2)]; //@line 1270 "readclause.cpp"
              var $add=((($mul)-48)&4294967295); //@line 1270 "readclause.cpp"
              var $sub=((($add)+($8))&4294967295); //@line 1270 "readclause.cpp"
              $value=$sub; //@line 1270 "readclause.cpp"
              var $9=$pw_addr; //@line 1268 "readclause.cpp"
              var $10=HEAP32[(($9)>>2)]; //@line 1268 "readclause.cpp"
              var $isdigittmp1=((($10)-48)&4294967295); //@line 1268 "readclause.cpp"
              var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 1268 "readclause.cpp"
              var $call1=((($isdigit2))&1); //@line 1268 "readclause.cpp"
              var $tobool2=((($call1))|0)!=0; //@line 1268 "readclause.cpp"
              if ($tobool2) { __label__ = 4;continue ; } else { __label__ = 5;break $while_body$$while_end$5; } //@line 1268 "readclause.cpp"
            }
          }
        } while(0);
  
        var $11=$type_addr; //@line 1272 "readclause.cpp"
        var $cmp3=((($11))|0)==1; //@line 1272 "readclause.cpp"
        if ($cmp3) { __label__ = 6;; } else { __label__ = 8;; } //@line 1272 "readclause.cpp"
        $land_lhs_true$$if_end8$9: do { 
          if (__label__ == 6) {
  
            var $12=$pw_addr; //@line 1272 "readclause.cpp"
            var $13=HEAP32[(($12)>>2)]; //@line 1272 "readclause.cpp"
            var $call4=_towlower($13); //@line 1272 "readclause.cpp"
            var $cmp5=((($call4))|0)==115; //@line 1272 "readclause.cpp"
            if (!($cmp5)) { __label__ = 8;break $land_lhs_true$$if_end8$9; } //@line 1272 "readclause.cpp"
  
            var $14=$value; //@line 1275 "readclause.cpp"
            var $mul7=((($14)*1000)&4294967295); //@line 1275 "readclause.cpp"
            $value=$mul7; //@line 1275 "readclause.cpp"
            ; //@line 1276 "readclause.cpp"
          }
        } while(0);
  
        var $15=$value; //@line 1277 "readclause.cpp"
        $retval=$15; //@line 1277 "readclause.cpp"
        __label__ = 9;break $if_then$$lor_lhs_false$2; //@line 1277 "readclause.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $5=$default_value_addr; //@line 1266 "readclause.cpp"
      $retval=$5; //@line 1266 "readclause.cpp"
      ; //@line 1266 "readclause.cpp"
    }
  
    var $16=$retval; //@line 1278 "readclause.cpp"
    ;
    return $16; //@line 1278 "readclause.cpp"
    return null;
  }
  

  function __ZL14ReplaceKeyNamePciRi($outbuf, $index, $outix) {
    var __stackBase__  = STACKTOP; STACKTOP += 40; _memset(__stackBase__, 0, 40);
    var __label__;
  
    var $retval;
    var $outbuf_addr;
    var $index_addr;
    var $outix_addr;
    var $keynames=__stackBase__;
    var $ix;
    var $letter;
    var $p;
    $outbuf_addr=$outbuf;
    $index_addr=$index;
    $outix_addr=$outix;
    var $0=$keynames; //@line 1572 "readclause.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = __ZZL14ReplaceKeyNamePciRiE8keynames;
    $dest$ = $0;
    $stop$ = $src$ + 40;
    if (($dest$%4) == ($src$%4) && 40 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1572 "readclause.cpp"
    var $1=$index_addr; //@line 1578 "readclause.cpp"
    var $2=$outbuf_addr; //@line 1578 "readclause.cpp"
    var $arrayidx=(($2+$1)&4294967295); //@line 1578 "readclause.cpp"
    $p=$arrayidx; //@line 1578 "readclause.cpp"
    var $arraydecay=(($keynames)&4294967295); //@line 1580 "readclause.cpp"
    var $3=$p; //@line 1580 "readclause.cpp"
    var $call=__Z10LookupMnemP8MNEM_TABPKc($arraydecay, $3); //@line 1580 "readclause.cpp"
    $letter=$call; //@line 1580 "readclause.cpp"
    var $cmp=((($call))|0)!=0; //@line 1580 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1580 "readclause.cpp"
    if (__label__ == 1) {
  
      var $4=$letter; //@line 1582 "readclause.cpp"
      var $5=$p; //@line 1582 "readclause.cpp"
      var $call1=__Z8utf8_outjPc($4, $5); //@line 1582 "readclause.cpp"
      $ix=$call1; //@line 1582 "readclause.cpp"
      var $6=$index_addr; //@line 1583 "readclause.cpp"
      var $7=$ix; //@line 1583 "readclause.cpp"
      var $add=((($7)+($6))&4294967295); //@line 1583 "readclause.cpp"
      var $8=$outix_addr; //@line 1583 "readclause.cpp"
      HEAP32[(($8)>>2)]=$add; //@line 1583 "readclause.cpp"
      var $9=$letter; //@line 1584 "readclause.cpp"
      $retval=$9; //@line 1584 "readclause.cpp"
      ; //@line 1584 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 1586 "readclause.cpp"
      ; //@line 1586 "readclause.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL13attrcopy_utf8PcPKwi($buf, $pw, $len) {
    ;
    var __label__;
  
    var $buf_addr;
    var $pw_addr;
    var $len_addr;
    var $c;
    var $ix;
    var $n;
    var $prev_c;
    $buf_addr=$buf;
    $pw_addr=$pw;
    $len_addr=$len;
    $ix=0; //@line 1286 "readclause.cpp"
    $prev_c=0; //@line 1288 "readclause.cpp"
    var $0=$pw_addr; //@line 1290 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 1290 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 6;; } //@line 1290 "readclause.cpp"
    $while_cond$$if_end6$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $1=$ix; //@line 1292 "readclause.cpp"
          var $2=$len_addr; //@line 1292 "readclause.cpp"
          var $sub=((($2)-4)&4294967295); //@line 1292 "readclause.cpp"
          var $cmp1=((($1))|0) < ((($sub))|0); //@line 1292 "readclause.cpp"
          if (!($cmp1)) { __label__ = 6;break $while_cond$$if_end6$2; } //@line 1292 "readclause.cpp"
  
          var $3=$pw_addr; //@line 1292 "readclause.cpp"
          var $incdec_ptr=(($3+4)&4294967295); //@line 1292 "readclause.cpp"
          $pw_addr=$incdec_ptr; //@line 1292 "readclause.cpp"
          var $4=HEAP32[(($3)>>2)]; //@line 1292 "readclause.cpp"
          $c=$4; //@line 1292 "readclause.cpp"
          var $cmp2=((($4))|0)!=0; //@line 1292 "readclause.cpp"
          if (!($cmp2)) { __label__ = 6;break $while_cond$$if_end6$2; }
  
          var $5=$c; //@line 1294 "readclause.cpp"
          var $cmp3=((($5))|0)==34; //@line 1294 "readclause.cpp"
          if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 1294 "readclause.cpp"
          if (__label__ == 4) {
  
            var $6=$prev_c; //@line 1294 "readclause.cpp"
            var $cmp4=((($6))|0)!=92; //@line 1294 "readclause.cpp"
            if ($cmp4) { __label__ = 6;break $while_cond$$if_end6$2; } //@line 1294 "readclause.cpp"
          }
  
          var $7=$c; //@line 1296 "readclause.cpp"
          var $8=$ix; //@line 1296 "readclause.cpp"
          var $9=$buf_addr; //@line 1296 "readclause.cpp"
          var $arrayidx=(($9+$8)&4294967295); //@line 1296 "readclause.cpp"
          var $call=__Z8utf8_outjPc($7, $arrayidx); //@line 1296 "readclause.cpp"
          $n=$call; //@line 1296 "readclause.cpp"
          var $10=$n; //@line 1297 "readclause.cpp"
          var $11=$ix; //@line 1297 "readclause.cpp"
          var $add=((($11)+($10))&4294967295); //@line 1297 "readclause.cpp"
          $ix=$add; //@line 1297 "readclause.cpp"
          var $12=$c; //@line 1298 "readclause.cpp"
          $prev_c=$12; //@line 1298 "readclause.cpp"
          __label__ = 1;continue ; //@line 1299 "readclause.cpp"
        }
      }
    } while(0);
  
    var $13=$ix; //@line 1301 "readclause.cpp"
    var $14=$buf_addr; //@line 1301 "readclause.cpp"
    var $arrayidx7=(($14+$13)&4294967295); //@line 1301 "readclause.cpp"
    HEAP8[($arrayidx7)]=0; //@line 1301 "readclause.cpp"
    var $15=$ix; //@line 1302 "readclause.cpp"
    ;
    return $15; //@line 1302 "readclause.cpp"
    return null;
  }
  

  function __ZL14LoadSoundFile2PKc($fname) {
    ;
    var __label__;
  
    var $retval;
    var $fname_addr;
    var $ix;
    $fname_addr=$fname;
    $ix=0; //@line 834 "readclause.cpp"
    ; //@line 834 "readclause.cpp"
    while(1) { 
  
      var $0=$ix; //@line 834 "readclause.cpp"
      var $1=HEAP32[((_n_soundicon_tab)>>2)]; //@line 834 "readclause.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 834 "readclause.cpp"
      if (!($cmp)) { __label__ = 6;break ; } //@line 834 "readclause.cpp"
  
      var $2=$ix; //@line 836 "readclause.cpp"
      var $arrayidx=((_soundicon_tab+$2*16)&4294967295); //@line 836 "readclause.cpp"
      var $filename=(($arrayidx+12)&4294967295); //@line 836 "readclause.cpp"
      var $3=HEAP32[(($filename)>>2)]; //@line 836 "readclause.cpp"
      var $cmp1=((($3))|0)!=0; //@line 836 "readclause.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 5;; } //@line 836 "readclause.cpp"
      if (__label__ == 3) {
  
        var $4=$fname_addr; //@line 836 "readclause.cpp"
        var $5=$ix; //@line 836 "readclause.cpp"
        var $arrayidx2=((_soundicon_tab+$5*16)&4294967295); //@line 836 "readclause.cpp"
        var $filename3=(($arrayidx2+12)&4294967295); //@line 836 "readclause.cpp"
        var $6=HEAP32[(($filename3)>>2)]; //@line 836 "readclause.cpp"
        var $call=_strcmp($4, $6); //@line 836 "readclause.cpp"
        var $cmp4=((($call))|0)==0; //@line 836 "readclause.cpp"
        if ($cmp4) { __label__ = 4;break ; } //@line 836 "readclause.cpp"
      }
  
      var $8=$ix; //@line 834 "readclause.cpp"
      var $inc=((($8)+1)&4294967295); //@line 834 "readclause.cpp"
      $ix=$inc; //@line 834 "readclause.cpp"
      __label__ = 1;continue ; //@line 834 "readclause.cpp"
    }
    if (__label__ == 6) {
  
      var $9=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 841 "readclause.cpp"
      var $inc5=((($9)+1)&4294967295); //@line 841 "readclause.cpp"
      HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]=$inc5; //@line 841 "readclause.cpp"
      var $10=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 842 "readclause.cpp"
      var $cmp6=((($10))|0) >= 4; //@line 842 "readclause.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 842 "readclause.cpp"
      if (__label__ == 7) {
  
        HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]=0; //@line 843 "readclause.cpp"
        ; //@line 843 "readclause.cpp"
      }
  
      var $11=$fname_addr; //@line 845 "readclause.cpp"
      var $12=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 845 "readclause.cpp"
      var $call9=__ZL13LoadSoundFilePKci($11, $12); //@line 845 "readclause.cpp"
      var $cmp10=((($call9))|0)!=0; //@line 845 "readclause.cpp"
      if ($cmp10) { __label__ = 9;; } else { __label__ = 10;; } //@line 845 "readclause.cpp"
      if (__label__ == 9) {
  
        $retval=-1; //@line 846 "readclause.cpp"
        ; //@line 846 "readclause.cpp"
      }
      else if (__label__ == 10) {
  
        var $13=$ix; //@line 848 "readclause.cpp"
        var $arrayidx13=((_soundicon_tab+$13*16)&4294967295); //@line 848 "readclause.cpp"
        var $filename14=(($arrayidx13+12)&4294967295); //@line 848 "readclause.cpp"
        var $14=HEAP32[(($filename14)>>2)]; //@line 848 "readclause.cpp"
        var $15=$fname_addr; //@line 848 "readclause.cpp"
        var $call15=_strlen($15); //@line 848 "readclause.cpp"
        var $add=((($call15)+1)&4294967295); //@line 848 "readclause.cpp"
        var $call16=_realloc($14, $add); //@line 848 "readclause.cpp"
        var $16=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 848 "readclause.cpp"
        var $arrayidx17=((_soundicon_tab+$16*16)&4294967295); //@line 848 "readclause.cpp"
        var $filename18=(($arrayidx17+12)&4294967295); //@line 848 "readclause.cpp"
        HEAP32[(($filename18)>>2)]=$call16; //@line 848 "readclause.cpp"
        var $17=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 849 "readclause.cpp"
        var $arrayidx19=((_soundicon_tab+$17*16)&4294967295); //@line 849 "readclause.cpp"
        var $filename20=(($arrayidx19+12)&4294967295); //@line 849 "readclause.cpp"
        var $18=HEAP32[(($filename20)>>2)]; //@line 849 "readclause.cpp"
        var $19=$fname_addr; //@line 849 "readclause.cpp"
        var $call21=_strcpy($18, $19); //@line 849 "readclause.cpp"
        var $20=HEAP32[((__ZZL14LoadSoundFile2PKcE4slot)>>2)]; //@line 850 "readclause.cpp"
        $retval=$20; //@line 850 "readclause.cpp"
        ; //@line 850 "readclause.cpp"
      }
    }
    else if (__label__ == 4) {
  
      var $7=$ix; //@line 837 "readclause.cpp"
      $retval=$7; //@line 837 "readclause.cpp"
      ; //@line 837 "readclause.cpp"
    }
  
    var $21=$retval; //@line 851 "readclause.cpp"
    ;
    return $21; //@line 851 "readclause.cpp"
    return null;
  }
  

  function __ZL18GetVoiceAttributesPwi($pw, $tag_type) {
    ;
    var __label__;
  
    var $retval;
    var $pw_addr;
    var $tag_type_addr;
    var $lang;
    var $gender;
    var $name;
    var $age;
    var $variant;
    var $new_voice_id;
    var $ssml_sp;
    $pw_addr=$pw;
    $tag_type_addr=$tag_type;
    var $0=$tag_type_addr; //@line 1438 "readclause.cpp"
    var $and=($0) & 32; //@line 1438 "readclause.cpp"
    var $tobool=((($and))|0)!=0; //@line 1438 "readclause.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 1438 "readclause.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1441 "readclause.cpp"
        var $cmp=((($1))|0) > 1; //@line 1441 "readclause.cpp"
        if (!($cmp)) { __label__ = 10;break $if_then$$if_else$2; } //@line 1441 "readclause.cpp"
  
        var $2=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1443 "readclause.cpp"
        var $dec=((($2)-1)&4294967295); //@line 1443 "readclause.cpp"
        HEAP32[((__ZL12n_ssml_stack)>>2)]=$dec; //@line 1443 "readclause.cpp"
        __label__ = 10;break $if_then$$if_else$2; //@line 1444 "readclause.cpp"
      }
      else if (__label__ == 3) {
  
        var $3=$pw_addr; //@line 1449 "readclause.cpp"
        var $call=__ZL16GetSsmlAttributePwPKc($3, ((__str106273)&4294967295)); //@line 1449 "readclause.cpp"
        $lang=$call; //@line 1449 "readclause.cpp"
        var $4=$tag_type_addr; //@line 1451 "readclause.cpp"
        var $cmp2=((($4))|0)!=2; //@line 1451 "readclause.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 1451 "readclause.cpp"
        if (__label__ == 4) {
  
          $name=0; //@line 1454 "readclause.cpp"
          $variant=0; //@line 1455 "readclause.cpp"
          $age=0; //@line 1456 "readclause.cpp"
          $gender=0; //@line 1457 "readclause.cpp"
          ; //@line 1458 "readclause.cpp"
        }
        else if (__label__ == 5) {
  
          var $5=$pw_addr; //@line 1461 "readclause.cpp"
          var $call5=__ZL16GetSsmlAttributePwPKc($5, ((__str5655)&4294967295)); //@line 1461 "readclause.cpp"
          $name=$call5; //@line 1461 "readclause.cpp"
          var $6=$pw_addr; //@line 1462 "readclause.cpp"
          var $call6=__ZL16GetSsmlAttributePwPKc($6, ((__str55707)&4294967295)); //@line 1462 "readclause.cpp"
          $variant=$call6; //@line 1462 "readclause.cpp"
          var $7=$pw_addr; //@line 1463 "readclause.cpp"
          var $call7=__ZL16GetSsmlAttributePwPKc($7, ((__str108275)&4294967295)); //@line 1463 "readclause.cpp"
          $age=$call7; //@line 1463 "readclause.cpp"
          var $8=$pw_addr; //@line 1464 "readclause.cpp"
          var $call8=__ZL16GetSsmlAttributePwPKc($8, ((__str7657)&4294967295)); //@line 1464 "readclause.cpp"
          $gender=$call8; //@line 1464 "readclause.cpp"
          ;
        }
  
        var $9=$tag_type_addr; //@line 1467 "readclause.cpp"
        var $cmp10=((($9))|0)!=2; //@line 1467 "readclause.cpp"
        if ($cmp10) { __label__ = 7;; } else { __label__ = 9;; } //@line 1467 "readclause.cpp"
        $land_lhs_true$$if_end13$10: do { 
          if (__label__ == 7) {
  
            var $10=$lang; //@line 1467 "readclause.cpp"
            var $cmp11=((($10))|0)==0; //@line 1467 "readclause.cpp"
            if (!($cmp11)) { __label__ = 9;break $land_lhs_true$$if_end13$10; } //@line 1467 "readclause.cpp"
  
            $retval=0; //@line 1468 "readclause.cpp"
            __label__ = 13;break $if_then$$if_else$2; //@line 1468 "readclause.cpp"
          }
        } while(0);
  
        var $11=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1470 "readclause.cpp"
        var $inc=((($11)+1)&4294967295); //@line 1470 "readclause.cpp"
        HEAP32[((__ZL12n_ssml_stack)>>2)]=$inc; //@line 1470 "readclause.cpp"
        var $arrayidx=((__ZL10ssml_stack+$11*76)&4294967295); //@line 1470 "readclause.cpp"
        $ssml_sp=$arrayidx; //@line 1470 "readclause.cpp"
        var $12=$ssml_sp; //@line 1472 "readclause.cpp"
        var $language=(($12+56)&4294967295); //@line 1472 "readclause.cpp"
        var $arraydecay=(($language)&4294967295); //@line 1472 "readclause.cpp"
        var $13=$lang; //@line 1472 "readclause.cpp"
        var $call14=__ZL13attrcopy_utf8PcPKwi($arraydecay, $13, 20); //@line 1472 "readclause.cpp"
        var $14=$ssml_sp; //@line 1473 "readclause.cpp"
        var $voice_name=(($14+16)&4294967295); //@line 1473 "readclause.cpp"
        var $arraydecay15=(($voice_name)&4294967295); //@line 1473 "readclause.cpp"
        var $15=$name; //@line 1473 "readclause.cpp"
        var $call16=__ZL13attrcopy_utf8PcPKwi($arraydecay15, $15, 40); //@line 1473 "readclause.cpp"
        var $16=$variant; //@line 1474 "readclause.cpp"
        var $call17=__ZL10attrnumberPKwii($16, 1, 0); //@line 1474 "readclause.cpp"
        var $sub=((($call17)-1)&4294967295); //@line 1474 "readclause.cpp"
        var $17=$ssml_sp; //@line 1474 "readclause.cpp"
        var $voice_variant=(($17+4)&4294967295); //@line 1474 "readclause.cpp"
        HEAP32[(($voice_variant)>>2)]=$sub; //@line 1474 "readclause.cpp"
        var $18=$age; //@line 1475 "readclause.cpp"
        var $call18=__ZL10attrnumberPKwii($18, 0, 0); //@line 1475 "readclause.cpp"
        var $19=$ssml_sp; //@line 1475 "readclause.cpp"
        var $voice_age=(($19+12)&4294967295); //@line 1475 "readclause.cpp"
        HEAP32[(($voice_age)>>2)]=$call18; //@line 1475 "readclause.cpp"
        var $20=$gender; //@line 1476 "readclause.cpp"
        var $call19=__ZL10attrlookupPKwPK8MNEM_TAB($20, ((__ZZL18GetVoiceAttributesPwiE11mnem_gender)&4294967295)); //@line 1476 "readclause.cpp"
        var $21=$ssml_sp; //@line 1476 "readclause.cpp"
        var $voice_gender=(($21+8)&4294967295); //@line 1476 "readclause.cpp"
        HEAP32[(($voice_gender)>>2)]=$call19; //@line 1476 "readclause.cpp"
        var $22=$tag_type_addr; //@line 1477 "readclause.cpp"
        var $23=$ssml_sp; //@line 1477 "readclause.cpp"
        var $tag_type20=(($23)&4294967295); //@line 1477 "readclause.cpp"
        HEAP32[(($tag_type20)>>2)]=$22; //@line 1477 "readclause.cpp"
        __label__ = 10;break $if_then$$if_else$2;
      }
    } while(0);
    if (__label__ == 10) {
  
      var $call22=__ZL14VoiceFromStackv(); //@line 1480 "readclause.cpp"
      $new_voice_id=$call22; //@line 1480 "readclause.cpp"
      var $24=$new_voice_id; //@line 1481 "readclause.cpp"
      var $call23=_strcmp($24, ((__ZL16current_voice_id)&4294967295)); //@line 1481 "readclause.cpp"
      var $cmp24=((($call23))|0)!=0; //@line 1481 "readclause.cpp"
      if ($cmp24) { __label__ = 11;; } else { __label__ = 12;; } //@line 1481 "readclause.cpp"
      if (__label__ == 11) {
  
        var $25=$new_voice_id; //@line 1484 "readclause.cpp"
        var $call26=_strcpy(((__ZL16current_voice_id)&4294967295), $25); //@line 1484 "readclause.cpp"
        $retval=131072; //@line 1485 "readclause.cpp"
        ; //@line 1485 "readclause.cpp"
      }
      else if (__label__ == 12) {
  
        $retval=0; //@line 1488 "readclause.cpp"
        ; //@line 1488 "readclause.cpp"
      }
    }
  
    var $26=$retval; //@line 1489 "readclause.cpp"
    ;
    return $26; //@line 1489 "readclause.cpp"
    return null;
  }
  

  function __ZL14VoiceFromStackv() {
    var __stackBase__  = STACKTOP; STACKTOP += 108; _memset(__stackBase__, 0, 108);
    var __label__;
  
    var $retval;
    var $ix;
    var $sp;
    var $v_id;
    var $voice_name_specified;
    var $voice_found=__stackBase__;
    var $voice_select=__stackBase__+4;
    var $voice_name=__stackBase__+28;
    var $language=__stackBase__+68;
    var $arraydecay=(($voice_name)&4294967295); //@line 1053 "readclause.cpp"
    var $call=_strcpy($arraydecay, ((__ZL10ssml_stack+16)&4294967295)); //@line 1053 "readclause.cpp"
    var $arraydecay1=(($language)&4294967295); //@line 1054 "readclause.cpp"
    var $call2=_strcpy($arraydecay1, ((__ZL10ssml_stack+56)&4294967295)); //@line 1054 "readclause.cpp"
    var $0=HEAP32[((((__ZL10ssml_stack+12)&4294967295))>>2)]; //@line 1055 "readclause.cpp"
    var $conv=((($0)) & 255); //@line 1055 "readclause.cpp"
    var $age=(($voice_select+13)&4294967295); //@line 1055 "readclause.cpp"
    HEAP8[($age)]=$conv; //@line 1055 "readclause.cpp"
    var $1=HEAP32[((((__ZL10ssml_stack+8)&4294967295))>>2)]; //@line 1056 "readclause.cpp"
    var $conv3=((($1)) & 255); //@line 1056 "readclause.cpp"
    var $gender=(($voice_select+12)&4294967295); //@line 1056 "readclause.cpp"
    HEAP8[($gender)]=$conv3; //@line 1056 "readclause.cpp"
    var $2=HEAP32[((((__ZL10ssml_stack+4)&4294967295))>>2)]; //@line 1057 "readclause.cpp"
    var $conv4=((($2)) & 255); //@line 1057 "readclause.cpp"
    var $variant=(($voice_select+14)&4294967295); //@line 1057 "readclause.cpp"
    HEAP8[($variant)]=$conv4; //@line 1057 "readclause.cpp"
    var $identifier=(($voice_select+8)&4294967295); //@line 1058 "readclause.cpp"
    HEAP32[(($identifier)>>2)]=0; //@line 1058 "readclause.cpp"
    $ix=0; //@line 1060 "readclause.cpp"
    var $3=$ix; //@line 1060 "readclause.cpp"
    var $4=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1060 "readclause.cpp"
    var $cmp1=((($3))|0) < ((($4))|0); //@line 1060 "readclause.cpp"
    if ($cmp1) { __label__ = 1;; } else { __label__ = 15;; } //@line 1060 "readclause.cpp"
    $for_body_lr_ph$$for_end$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay13=(($voice_name)&4294967295); //@line 1068 "readclause.cpp"
        var $arrayidx17=(($language)&4294967295); //@line 1069 "readclause.cpp"
        var $gender18=(($voice_select+12)&4294967295); //@line 1070 "readclause.cpp"
        var $age19=(($voice_select+13)&4294967295); //@line 1071 "readclause.cpp"
        var $variant20=(($voice_select+14)&4294967295); //@line 1072 "readclause.cpp"
        var $arraydecay26=(($language)&4294967295); //@line 1076 "readclause.cpp"
        var $arrayidx32=(($voice_name)&4294967295); //@line 1078 "readclause.cpp"
        var $gender39=(($voice_select+12)&4294967295); //@line 1081 "readclause.cpp"
        var $age45=(($voice_select+13)&4294967295); //@line 1083 "readclause.cpp"
        var $variant51=(($voice_select+14)&4294967295); //@line 1085 "readclause.cpp"
        ; //@line 1060 "readclause.cpp"
        $for_body$4: while(1) { 
  
          var $5=$ix; //@line 1062 "readclause.cpp"
          var $arrayidx=((__ZL10ssml_stack+$5*76)&4294967295); //@line 1062 "readclause.cpp"
          $sp=$arrayidx; //@line 1062 "readclause.cpp"
          $voice_name_specified=0; //@line 1063 "readclause.cpp"
          var $6=$sp; //@line 1065 "readclause.cpp"
          var $voice_name5=(($6+16)&4294967295); //@line 1065 "readclause.cpp"
          var $arrayidx6=(($voice_name5)&4294967295); //@line 1065 "readclause.cpp"
          var $7=HEAP8[($arrayidx6)]; //@line 1065 "readclause.cpp"
          var $conv7=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1065 "readclause.cpp"
          var $cmp8=((($conv7))|0)!=0; //@line 1065 "readclause.cpp"
          if ($cmp8) { __label__ = 3;; } else { __label__ = 5;; } //@line 1065 "readclause.cpp"
          $land_lhs_true$$if_end$6: do { 
            if (__label__ == 3) {
  
              var $8=$sp; //@line 1065 "readclause.cpp"
              var $voice_name9=(($8+16)&4294967295); //@line 1065 "readclause.cpp"
              var $arraydecay10=(($voice_name9)&4294967295); //@line 1065 "readclause.cpp"
              var $call11=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(0, $arraydecay10); //@line 1065 "readclause.cpp"
              var $cmp12=((($call11))|0)!=0; //@line 1065 "readclause.cpp"
              if (!($cmp12)) { __label__ = 5;break $land_lhs_true$$if_end$6; } //@line 1065 "readclause.cpp"
  
              $voice_name_specified=1; //@line 1067 "readclause.cpp"
              var $9=$sp; //@line 1068 "readclause.cpp"
              var $voice_name14=(($9+16)&4294967295); //@line 1068 "readclause.cpp"
              var $arraydecay15=(($voice_name14)&4294967295); //@line 1068 "readclause.cpp"
              var $call16=_strcpy($arraydecay13, $arraydecay15); //@line 1068 "readclause.cpp"
              HEAP8[($arrayidx17)]=0; //@line 1069 "readclause.cpp"
              HEAP8[($gender18)]=0; //@line 1070 "readclause.cpp"
              HEAP8[($age19)]=0; //@line 1071 "readclause.cpp"
              HEAP8[($variant20)]=0; //@line 1072 "readclause.cpp"
              ; //@line 1073 "readclause.cpp"
            }
          } while(0);
  
          var $10=$sp; //@line 1074 "readclause.cpp"
          var $language21=(($10+56)&4294967295); //@line 1074 "readclause.cpp"
          var $arrayidx22=(($language21)&4294967295); //@line 1074 "readclause.cpp"
          var $11=HEAP8[($arrayidx22)]; //@line 1074 "readclause.cpp"
          var $conv23=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1074 "readclause.cpp"
          var $cmp24=((($conv23))|0)!=0; //@line 1074 "readclause.cpp"
          if ($cmp24) { __label__ = 6;; } else { __label__ = 8;; } //@line 1074 "readclause.cpp"
          $if_then25$$if_end34$10: do { 
            if (__label__ == 6) {
  
              var $12=$sp; //@line 1076 "readclause.cpp"
              var $language27=(($12+56)&4294967295); //@line 1076 "readclause.cpp"
              var $arraydecay28=(($language27)&4294967295); //@line 1076 "readclause.cpp"
              var $call29=_strcpy($arraydecay26, $arraydecay28); //@line 1076 "readclause.cpp"
              var $13=$voice_name_specified; //@line 1077 "readclause.cpp"
              var $cmp30=((($13))|0)==0; //@line 1077 "readclause.cpp"
              if (!($cmp30)) { __label__ = 8;break $if_then25$$if_end34$10; } //@line 1077 "readclause.cpp"
  
              HEAP8[($arrayidx32)]=0; //@line 1078 "readclause.cpp"
              ; //@line 1078 "readclause.cpp"
            }
          } while(0);
  
          var $14=$sp; //@line 1080 "readclause.cpp"
          var $voice_gender=(($14+8)&4294967295); //@line 1080 "readclause.cpp"
          var $15=HEAP32[(($voice_gender)>>2)]; //@line 1080 "readclause.cpp"
          var $cmp35=((($15))|0)!=0; //@line 1080 "readclause.cpp"
          if ($cmp35) { __label__ = 9;; } else { __label__ = 10;; } //@line 1080 "readclause.cpp"
          if (__label__ == 9) {
  
            var $16=$sp; //@line 1081 "readclause.cpp"
            var $voice_gender37=(($16+8)&4294967295); //@line 1081 "readclause.cpp"
            var $17=HEAP32[(($voice_gender37)>>2)]; //@line 1081 "readclause.cpp"
            var $conv38=((($17)) & 255); //@line 1081 "readclause.cpp"
            HEAP8[($gender39)]=$conv38; //@line 1081 "readclause.cpp"
            ; //@line 1081 "readclause.cpp"
          }
  
          var $18=$sp; //@line 1082 "readclause.cpp"
          var $voice_age=(($18+12)&4294967295); //@line 1082 "readclause.cpp"
          var $19=HEAP32[(($voice_age)>>2)]; //@line 1082 "readclause.cpp"
          var $cmp41=((($19))|0)!=0; //@line 1082 "readclause.cpp"
          if ($cmp41) { __label__ = 11;; } else { __label__ = 12;; } //@line 1082 "readclause.cpp"
          if (__label__ == 11) {
  
            var $20=$sp; //@line 1083 "readclause.cpp"
            var $voice_age43=(($20+12)&4294967295); //@line 1083 "readclause.cpp"
            var $21=HEAP32[(($voice_age43)>>2)]; //@line 1083 "readclause.cpp"
            var $conv44=((($21)) & 255); //@line 1083 "readclause.cpp"
            HEAP8[($age45)]=$conv44; //@line 1083 "readclause.cpp"
            ; //@line 1083 "readclause.cpp"
          }
  
          var $22=$sp; //@line 1084 "readclause.cpp"
          var $voice_variant=(($22+4)&4294967295); //@line 1084 "readclause.cpp"
          var $23=HEAP32[(($voice_variant)>>2)]; //@line 1084 "readclause.cpp"
          var $cmp47=((($23))|0)!=0; //@line 1084 "readclause.cpp"
          if ($cmp47) { __label__ = 13;; } else { __label__ = 14;; } //@line 1084 "readclause.cpp"
          if (__label__ == 13) {
  
            var $24=$sp; //@line 1085 "readclause.cpp"
            var $voice_variant49=(($24+4)&4294967295); //@line 1085 "readclause.cpp"
            var $25=HEAP32[(($voice_variant49)>>2)]; //@line 1085 "readclause.cpp"
            var $conv50=((($25)) & 255); //@line 1085 "readclause.cpp"
            HEAP8[($variant51)]=$conv50; //@line 1085 "readclause.cpp"
            ; //@line 1085 "readclause.cpp"
          }
  
          var $26=$ix; //@line 1060 "readclause.cpp"
          var $inc=((($26)+1)&4294967295); //@line 1060 "readclause.cpp"
          $ix=$inc; //@line 1060 "readclause.cpp"
          var $27=$ix; //@line 1060 "readclause.cpp"
          var $28=HEAP32[((__ZL12n_ssml_stack)>>2)]; //@line 1060 "readclause.cpp"
          var $cmp=((($27))|0) < ((($28))|0); //@line 1060 "readclause.cpp"
          if ($cmp) { __label__ = 2;continue $for_body$4; } else { __label__ = 15;break $for_body_lr_ph$$for_end$2; } //@line 1060 "readclause.cpp"
        }
      }
    } while(0);
  
    var $arraydecay53=(($voice_name)&4294967295); //@line 1088 "readclause.cpp"
    var $name=(($voice_select)&4294967295); //@line 1088 "readclause.cpp"
    HEAP32[(($name)>>2)]=$arraydecay53; //@line 1088 "readclause.cpp"
    var $arraydecay54=(($language)&4294967295); //@line 1089 "readclause.cpp"
    var $languages=(($voice_select+4)&4294967295); //@line 1089 "readclause.cpp"
    HEAP32[(($languages)>>2)]=$arraydecay54; //@line 1089 "readclause.cpp"
    var $call55=__Z11SelectVoiceP12espeak_VOICEPi($voice_select, $voice_found); //@line 1090 "readclause.cpp"
    $v_id=$call55; //@line 1090 "readclause.cpp"
    var $cmp56=((($call55))|0)==0; //@line 1091 "readclause.cpp"
    if ($cmp56) { __label__ = 16;; } else { __label__ = 17;; } //@line 1091 "readclause.cpp"
    if (__label__ == 16) {
  
      $retval=((__str45697)&4294967295); //@line 1092 "readclause.cpp"
      ; //@line 1092 "readclause.cpp"
    }
    else if (__label__ == 17) {
  
      var $29=$v_id; //@line 1093 "readclause.cpp"
      $retval=$29; //@line 1093 "readclause.cpp"
      ; //@line 1093 "readclause.cpp"
    }
  
    var $30=$retval; //@line 1094 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $30; //@line 1094 "readclause.cpp"
    return null;
  }
  

  function __ZL18attr_prosody_valueiPKwPi($param_type, $pw, $value_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $param_type_addr;
    var $pw_addr;
    var $value_out_addr;
    var $sign;
    var $tail=__stackBase__;
    var $value;
    var $x;
    $param_type_addr=$param_type;
    $pw_addr=$pw;
    $value_out_addr=$value_out;
    $sign=0; //@line 1309 "readclause.cpp"
    var $0=$pw_addr; //@line 1313 "readclause.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 1313 "readclause.cpp"
    var $call1=_iswspace($1); //@line 1313 "readclause.cpp"
    var $tobool2=((($call1))|0)!=0; //@line 1313 "readclause.cpp"
    var $2=$pw_addr; //@line 1313 "readclause.cpp"
    if ($tobool2) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 1313 "readclause.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 1 ? $6 : ($2);
          var $incdec_ptr=(($3+4)&4294967295); //@line 1313 "readclause.cpp"
          $pw_addr=$incdec_ptr; //@line 1313 "readclause.cpp"
          var $4=$pw_addr; //@line 1313 "readclause.cpp"
          var $5=HEAP32[(($4)>>2)]; //@line 1313 "readclause.cpp"
          var $call=_iswspace($5); //@line 1313 "readclause.cpp"
          var $tobool=((($call))|0)!=0; //@line 1313 "readclause.cpp"
          var $6=$pw_addr; //@line 1313 "readclause.cpp"
          if ($tobool) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $while_body$$while_end$2; } //@line 1313 "readclause.cpp"
        }
      }
    } while(0);
  
    var $_lcssa=__lastLabel__ == 0 ? $2 : ($6);
    var $7=HEAP32[(($_lcssa)>>2)]; //@line 1314 "readclause.cpp"
    var $cmp=((($7))|0)==43; //@line 1314 "readclause.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 1314 "readclause.cpp"
    if (__label__ == 3) {
  
      var $8=$pw_addr; //@line 1316 "readclause.cpp"
      var $incdec_ptr1=(($8+4)&4294967295); //@line 1316 "readclause.cpp"
      $pw_addr=$incdec_ptr1; //@line 1316 "readclause.cpp"
      $sign=1; //@line 1317 "readclause.cpp"
      ; //@line 1318 "readclause.cpp"
    }
  
    var $9=$pw_addr; //@line 1319 "readclause.cpp"
    var $10=HEAP32[(($9)>>2)]; //@line 1319 "readclause.cpp"
    var $cmp2=((($10))|0)==45; //@line 1319 "readclause.cpp"
    if ($cmp2) { __label__ = 5;; } else { __label__ = 6;; } //@line 1319 "readclause.cpp"
    if (__label__ == 5) {
  
      var $11=$pw_addr; //@line 1321 "readclause.cpp"
      var $incdec_ptr4=(($11+4)&4294967295); //@line 1321 "readclause.cpp"
      $pw_addr=$incdec_ptr4; //@line 1321 "readclause.cpp"
      $sign=-1; //@line 1322 "readclause.cpp"
      ; //@line 1323 "readclause.cpp"
    }
  
    var $12=$pw_addr; //@line 1324 "readclause.cpp"
    var $call6=_wcstod($12, $tail); //@line 1324 "readclause.cpp"
    var $conv=($call6); //@line 1324 "readclause.cpp"
    $value=$conv; //@line 1324 "readclause.cpp"
    var $13=HEAP32[(($tail)>>2)]; //@line 1325 "readclause.cpp"
    var $14=$pw_addr; //@line 1325 "readclause.cpp"
    var $cmp7=((($13))|0)==((($14))|0); //@line 1325 "readclause.cpp"
    if ($cmp7) { __label__ = 7;; } else { __label__ = 8;; } //@line 1325 "readclause.cpp"
    $if_then8$$if_end9$12: do { 
      if (__label__ == 7) {
  
        var $15=$value_out_addr; //@line 1328 "readclause.cpp"
        HEAP32[(($15)>>2)]=100; //@line 1328 "readclause.cpp"
        $retval=2; //@line 1329 "readclause.cpp"
        ; //@line 1329 "readclause.cpp"
      }
      else if (__label__ == 8) {
  
        var $16=HEAP32[(($tail)>>2)]; //@line 1332 "readclause.cpp"
        var $17=HEAP32[(($16)>>2)]; //@line 1332 "readclause.cpp"
        var $cmp10=((($17))|0)==37; //@line 1332 "readclause.cpp"
        if ($cmp10) { __label__ = 9;; } else { __label__ = 12;; } //@line 1332 "readclause.cpp"
        if (__label__ == 9) {
  
          var $18=$sign; //@line 1334 "readclause.cpp"
          var $cmp12=((($18))|0)!=0; //@line 1334 "readclause.cpp"
          if ($cmp12) { __label__ = 10;; } else { __label__ = 11;; } //@line 1334 "readclause.cpp"
          if (__label__ == 10) {
  
            var $19=$sign; //@line 1335 "readclause.cpp"
            var $conv14=((($19))|0); //@line 1335 "readclause.cpp"
            var $20=$value; //@line 1335 "readclause.cpp"
            var $mul=($conv14)*($20); //@line 1335 "readclause.cpp"
            var $add=100+($mul); //@line 1335 "readclause.cpp"
            $value=$add; //@line 1335 "readclause.cpp"
            ; //@line 1335 "readclause.cpp"
          }
  
          var $21=$value; //@line 1336 "readclause.cpp"
          var $conv16=((($21))|0); //@line 1336 "readclause.cpp"
          var $22=$value_out_addr; //@line 1336 "readclause.cpp"
          HEAP32[(($22)>>2)]=$conv16; //@line 1336 "readclause.cpp"
          $retval=2; //@line 1337 "readclause.cpp"
          ; //@line 1337 "readclause.cpp"
        }
        else if (__label__ == 12) {
  
          var $23=HEAP32[(($tail)>>2)]; //@line 1340 "readclause.cpp"
          var $arrayidx=(($23)&4294967295); //@line 1340 "readclause.cpp"
          var $24=HEAP32[(($arrayidx)>>2)]; //@line 1340 "readclause.cpp"
          var $cmp18=((($24))|0)==115; //@line 1340 "readclause.cpp"
          if ($cmp18) { __label__ = 13;; } else { __label__ = 15;; } //@line 1340 "readclause.cpp"
          $land_lhs_true$$if_end26$21: do { 
            if (__label__ == 13) {
  
              var $25=HEAP32[(($tail)>>2)]; //@line 1340 "readclause.cpp"
              var $arrayidx19=(($25+4)&4294967295); //@line 1340 "readclause.cpp"
              var $26=HEAP32[(($arrayidx19)>>2)]; //@line 1340 "readclause.cpp"
              var $cmp20=((($26))|0)==116; //@line 1340 "readclause.cpp"
              if (!($cmp20)) { __label__ = 15;break $land_lhs_true$$if_end26$21; } //@line 1340 "readclause.cpp"
  
              var $27=$value; //@line 1344 "readclause.cpp"
              var $28=$sign; //@line 1344 "readclause.cpp"
              var $conv22=((($28))|0); //@line 1344 "readclause.cpp"
              var $mul23=($27)*($conv22); //@line 1344 "readclause.cpp"
              var $div=($mul23)/12; //@line 1344 "readclause.cpp"
              var $exp2=_exp2($div); //@line 1344 "readclause.cpp"
              var $mul24=($exp2)*100; //@line 1344 "readclause.cpp"
              $x=$mul24; //@line 1344 "readclause.cpp"
              var $29=$x; //@line 1345 "readclause.cpp"
              var $conv25=((($29))|0); //@line 1345 "readclause.cpp"
              var $30=$value_out_addr; //@line 1345 "readclause.cpp"
              HEAP32[(($30)>>2)]=$conv25; //@line 1345 "readclause.cpp"
              $retval=2; //@line 1346 "readclause.cpp"
              __label__ = 21;break $if_then8$$if_end9$12; //@line 1346 "readclause.cpp"
            }
          } while(0);
  
          var $31=$param_type_addr; //@line 1349 "readclause.cpp"
          var $cmp27=((($31))|0)==1; //@line 1349 "readclause.cpp"
          if ($cmp27) { __label__ = 16;; } else { __label__ = 20;; } //@line 1349 "readclause.cpp"
          if (__label__ == 16) {
  
            var $32=$sign; //@line 1351 "readclause.cpp"
            var $cmp29=((($32))|0)==0; //@line 1351 "readclause.cpp"
            if ($cmp29) { __label__ = 17;; } else { __label__ = 18;; } //@line 1351 "readclause.cpp"
            if (__label__ == 17) {
  
              var $33=$value; //@line 1352 "readclause.cpp"
              var $mul31=($33)*100; //@line 1352 "readclause.cpp"
              var $conv32=((($mul31))|0); //@line 1352 "readclause.cpp"
              var $34=$value_out_addr; //@line 1352 "readclause.cpp"
              HEAP32[(($34)>>2)]=$conv32; //@line 1352 "readclause.cpp"
              ; //@line 1352 "readclause.cpp"
            }
            else if (__label__ == 18) {
  
              var $35=$sign; //@line 1354 "readclause.cpp"
              var $conv33=((($35))|0); //@line 1354 "readclause.cpp"
              var $36=$value; //@line 1354 "readclause.cpp"
              var $mul34=($conv33)*($36); //@line 1354 "readclause.cpp"
              var $mul35=($mul34)*100; //@line 1354 "readclause.cpp"
              var $conv36=((($mul35))|0); //@line 1354 "readclause.cpp"
              var $add37=((($conv36)+100)&4294967295); //@line 1354 "readclause.cpp"
              var $37=$value_out_addr; //@line 1354 "readclause.cpp"
              HEAP32[(($37)>>2)]=$add37; //@line 1354 "readclause.cpp"
              ;
            }
  
            $retval=2; //@line 1355 "readclause.cpp"
            ; //@line 1355 "readclause.cpp"
          }
          else if (__label__ == 20) {
  
            var $38=$value; //@line 1358 "readclause.cpp"
            var $conv40=((($38))|0); //@line 1358 "readclause.cpp"
            var $39=$value_out_addr; //@line 1358 "readclause.cpp"
            HEAP32[(($39)>>2)]=$conv40; //@line 1358 "readclause.cpp"
            var $40=$sign; //@line 1359 "readclause.cpp"
            $retval=$40; //@line 1359 "readclause.cpp"
            ; //@line 1359 "readclause.cpp"
          }
        }
      }
    } while(0);
  
    var $41=$retval; //@line 1360 "readclause.cpp"
    STACKTOP = __stackBase__;
    return $41; //@line 1360 "readclause.cpp"
    return null;
  }
  

  function __ZL8GetC_getv() {
    ;
    var __label__;
  
    var $retval;
    var $c;
    var $c2;
    var $0=HEAP32[((__ZL7f_input)>>2)]; //@line 419 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 419 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 8;; } //@line 419 "readclause.cpp"
    $if_then$$if_end13$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((__ZL7f_input)>>2)]; //@line 421 "readclause.cpp"
        var $call=_fgetc($1); //@line 421 "readclause.cpp"
        $c=$call; //@line 421 "readclause.cpp"
        var $2=HEAP32[((__ZL7f_input)>>2)]; //@line 422 "readclause.cpp"
        var $_flags=(($2+12)&4294967295); //@line 422 "readclause.cpp"
        var $3=HEAP16[(($_flags)>>1)]; //@line 422 "readclause.cpp"
        var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 422 "readclause.cpp"
        var $and=($conv) & 32; //@line 422 "readclause.cpp"
        var $cmp1=((($and))|0)!=0; //@line 422 "readclause.cpp"
        if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 422 "readclause.cpp"
        if (__label__ == 2) {
  
          $c=32; //@line 422 "readclause.cpp"
          ; //@line 422 "readclause.cpp"
        }
  
        var $4=HEAP32[((_option_multibyte)>>2)]; //@line 424 "readclause.cpp"
        var $cmp3=((($4))|0)==4; //@line 424 "readclause.cpp"
        if ($cmp3) { __label__ = 4;; } else { __label__ = 7;; } //@line 424 "readclause.cpp"
        if (__label__ == 4) {
  
          var $5=HEAP32[((__ZL7f_input)>>2)]; //@line 426 "readclause.cpp"
          var $call5=_fgetc($5); //@line 426 "readclause.cpp"
          $c2=$call5; //@line 426 "readclause.cpp"
          var $6=HEAP32[((__ZL7f_input)>>2)]; //@line 427 "readclause.cpp"
          var $_flags6=(($6+12)&4294967295); //@line 427 "readclause.cpp"
          var $7=HEAP16[(($_flags6)>>1)]; //@line 427 "readclause.cpp"
          var $conv7=(tempInt=(($7)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 427 "readclause.cpp"
          var $and8=($conv7) & 32; //@line 427 "readclause.cpp"
          var $cmp9=((($and8))|0)!=0; //@line 427 "readclause.cpp"
          if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 427 "readclause.cpp"
          if (__label__ == 5) {
  
            $c2=0; //@line 427 "readclause.cpp"
            ; //@line 427 "readclause.cpp"
          }
  
          var $8=$c; //@line 428 "readclause.cpp"
          var $9=$c2; //@line 428 "readclause.cpp"
          var $shl=((($9)*256)&4294967295); //@line 428 "readclause.cpp"
          var $add=((($shl)+($8))&4294967295); //@line 428 "readclause.cpp"
          $c=$add; //@line 428 "readclause.cpp"
          ; //@line 429 "readclause.cpp"
        }
  
        var $10=$c; //@line 430 "readclause.cpp"
        $retval=$10; //@line 430 "readclause.cpp"
        ; //@line 430 "readclause.cpp"
      }
      else if (__label__ == 8) {
  
        var $11=HEAP32[((_option_multibyte)>>2)]; //@line 433 "readclause.cpp"
        var $cmp14=((($11))|0)==3; //@line 433 "readclause.cpp"
        if ($cmp14) { __label__ = 9;; } else { __label__ = 13;; } //@line 433 "readclause.cpp"
        $if_then15$$if_else$14: do { 
          if (__label__ == 9) {
  
            var $12=HEAP32[((_p_wchar_input)>>2)]; //@line 435 "readclause.cpp"
            var $13=HEAP32[(($12)>>2)]; //@line 435 "readclause.cpp"
            var $cmp16=((($13))|0)==0; //@line 435 "readclause.cpp"
            if ($cmp16) { __label__ = 10;; } else { __label__ = 11;; } //@line 435 "readclause.cpp"
            if (__label__ == 10) {
  
              HEAP8[(__ZL12end_of_input_b)]=1;
              $retval=0; //@line 438 "readclause.cpp"
              __label__ = 20;break $if_then$$if_end13$2; //@line 438 "readclause.cpp"
            }
            else if (__label__ == 11) {
  
              var $_b1=HEAPU8[(__ZL12end_of_input_b)];
              var $14=((($_b1))&1);
              var $tobool=((($14))|0)!=0; //@line 441 "readclause.cpp"
              if ($tobool) { __label__ = 19;break $if_then15$$if_else$14; } //@line 441 "readclause.cpp"
  
              var $15=HEAP32[((_p_wchar_input)>>2)]; //@line 442 "readclause.cpp"
              var $incdec_ptr=(($15+4)&4294967295); //@line 442 "readclause.cpp"
              HEAP32[((_p_wchar_input)>>2)]=$incdec_ptr; //@line 442 "readclause.cpp"
              var $16=HEAP32[(($15)>>2)]; //@line 442 "readclause.cpp"
              $retval=$16; //@line 442 "readclause.cpp"
              __label__ = 20;break $if_then$$if_end13$2; //@line 442 "readclause.cpp"
            }
          }
          else if (__label__ == 13) {
  
            var $17=HEAP32[((_p_textinput)>>2)]; //@line 446 "readclause.cpp"
            var $18=HEAPU8[($17)]; //@line 446 "readclause.cpp"
            var $conv21=((($18))&255); //@line 446 "readclause.cpp"
            var $cmp22=((($conv21))|0)==0; //@line 446 "readclause.cpp"
            if ($cmp22) { __label__ = 14;; } else { __label__ = 15;; } //@line 446 "readclause.cpp"
            if (__label__ == 14) {
  
              HEAP8[(__ZL12end_of_input_b)]=1;
              $retval=0; //@line 449 "readclause.cpp"
              __label__ = 20;break $if_then$$if_end13$2; //@line 449 "readclause.cpp"
            }
            else if (__label__ == 15) {
  
              var $_b=HEAPU8[(__ZL12end_of_input_b)];
              var $19=((($_b))&1);
              var $tobool25=((($19))|0)!=0; //@line 452 "readclause.cpp"
              if ($tobool25) { __label__ = 19;break $if_then15$$if_else$14; } //@line 452 "readclause.cpp"
  
              var $20=HEAP32[((_option_multibyte)>>2)]; //@line 454 "readclause.cpp"
              var $cmp27=((($20))|0)==4; //@line 454 "readclause.cpp"
              var $21=HEAPU32[((_p_textinput)>>2)]; //@line 456 "readclause.cpp"
              if ($cmp27) { __label__ = 17;; } else { __label__ = 18;; } //@line 454 "readclause.cpp"
              if (__label__ == 17) {
  
                var $arrayidx=(($21)&4294967295); //@line 456 "readclause.cpp"
                var $22=HEAPU8[($arrayidx)]; //@line 456 "readclause.cpp"
                var $conv29=((($22))&255); //@line 456 "readclause.cpp"
                var $23=HEAP32[((_p_textinput)>>2)]; //@line 456 "readclause.cpp"
                var $arrayidx30=(($23+1)&4294967295); //@line 456 "readclause.cpp"
                var $24=HEAPU8[($arrayidx30)]; //@line 456 "readclause.cpp"
                var $conv31=((($24))&255); //@line 456 "readclause.cpp"
                var $shl32=((($conv31)*256)&4294967295); //@line 456 "readclause.cpp"
                var $add33=((($shl32)+($conv29))&4294967295); //@line 456 "readclause.cpp"
                $c=$add33; //@line 456 "readclause.cpp"
                var $25=HEAP32[((_p_textinput)>>2)]; //@line 457 "readclause.cpp"
                var $add_ptr=(($25+2)&4294967295); //@line 457 "readclause.cpp"
                HEAP32[((_p_textinput)>>2)]=$add_ptr; //@line 457 "readclause.cpp"
                var $26=$c; //@line 458 "readclause.cpp"
                $retval=$26; //@line 458 "readclause.cpp"
                __label__ = 20;break $if_then$$if_end13$2; //@line 458 "readclause.cpp"
              }
              else if (__label__ == 18) {
  
                var $incdec_ptr35=(($21+1)&4294967295); //@line 460 "readclause.cpp"
                HEAP32[((_p_textinput)>>2)]=$incdec_ptr35; //@line 460 "readclause.cpp"
                var $27=HEAPU8[($21)]; //@line 460 "readclause.cpp"
                var $conv36=((($27))&255); //@line 460 "readclause.cpp"
                var $and37=($conv36) & 255; //@line 460 "readclause.cpp"
                $retval=$and37; //@line 460 "readclause.cpp"
                __label__ = 20;break $if_then$$if_end13$2; //@line 460 "readclause.cpp"
              }
            }
          }
        } while(0);
  
        $retval=0; //@line 463 "readclause.cpp"
        ; //@line 463 "readclause.cpp"
      }
    } while(0);
  
    var $28=$retval; //@line 464 "readclause.cpp"
    ;
    return $28; //@line 464 "readclause.cpp"
    return null;
  }
  

  function __ZL10GetC_ungeti($c) {
    ;
    var __label__;
  
    var $c_addr;
    $c_addr=$c;
    var $0=HEAP32[((__ZL7f_input)>>2)]; //@line 392 "readclause.cpp"
    var $cmp=((($0))|0)!=0; //@line 392 "readclause.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 392 "readclause.cpp"
    if (__label__ == 1) {
  
      var $1=$c_addr; //@line 393 "readclause.cpp"
      var $2=HEAP32[((__ZL7f_input)>>2)]; //@line 393 "readclause.cpp"
      var $call=_ungetc($1, $2); //@line 393 "readclause.cpp"
      ; //@line 393 "readclause.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=HEAP32[((_p_textinput)>>2)]; //@line 396 "readclause.cpp"
      var $incdec_ptr=(($3+-1)&4294967295); //@line 396 "readclause.cpp"
      HEAP32[((_p_textinput)>>2)]=$incdec_ptr; //@line 396 "readclause.cpp"
      var $4=$c_addr; //@line 397 "readclause.cpp"
      var $conv=((($4)) & 255); //@line 397 "readclause.cpp"
      var $5=HEAP32[((_p_textinput)>>2)]; //@line 397 "readclause.cpp"
      HEAP8[($5)]=$conv; //@line 397 "readclause.cpp"
      HEAP8[(__ZL12end_of_input_b)]=0;
      ;
    }
  
    ;
    return; //@line 400 "readclause.cpp"
    return;
  }
  

  function __Z8SetSpeedi($control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $control_addr;
    var $x;
    var $s1;
    var $wpm;
    var $wpm2;
    var $wpm_value;
    var $sonic;
    $control_addr=$control;
    HEAP32[((((_speed+28)&4294967295))>>2)]=0; //@line 147 "setlengths.cpp"
    HEAP32[((((_speed+24)&4294967295))>>2)]=450; //@line 148 "setlengths.cpp"
    HEAP32[((((_speed+16)&4294967295))>>2)]=110; //@line 149 "setlengths.cpp"
    HEAP32[((((_speed+20)&4294967295))>>2)]=100; //@line 150 "setlengths.cpp"
    HEAP32[((((_speed+8)&4294967295))>>2)]=5; //@line 151 "setlengths.cpp"
    var $0=HEAP32[((((_embedded_value+8)&4294967295))>>2)]; //@line 153 "setlengths.cpp"
    $wpm=$0; //@line 153 "setlengths.cpp"
    var $1=$control_addr; //@line 154 "setlengths.cpp"
    var $cmp=((($1))|0)==2; //@line 154 "setlengths.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 154 "setlengths.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((((_embedded_value+32)&4294967295))>>2)]; //@line 155 "setlengths.cpp"
      $wpm=$2; //@line 155 "setlengths.cpp"
      ; //@line 155 "setlengths.cpp"
    }
  
    var $3=$wpm; //@line 157 "setlengths.cpp"
    $wpm_value=$3; //@line 157 "setlengths.cpp"
    var $4=HEAP32[((_voice)>>2)]; //@line 159 "setlengths.cpp"
    var $speed_percent=(($4+64)&4294967295); //@line 159 "setlengths.cpp"
    var $5=HEAP32[(($speed_percent)>>2)]; //@line 159 "setlengths.cpp"
    var $cmp1=((($5))|0) > 0; //@line 159 "setlengths.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 159 "setlengths.cpp"
    if (__label__ == 3) {
  
      var $6=$wpm; //@line 161 "setlengths.cpp"
      var $7=HEAP32[((_voice)>>2)]; //@line 161 "setlengths.cpp"
      var $speed_percent3=(($7+64)&4294967295); //@line 161 "setlengths.cpp"
      var $8=HEAP32[(($speed_percent3)>>2)]; //@line 161 "setlengths.cpp"
      var $mul=((($8)*($6))&4294967295); //@line 161 "setlengths.cpp"
      var $div=((((($mul))|0)/100)|0); //@line 161 "setlengths.cpp"
      $wpm=$div; //@line 161 "setlengths.cpp"
      ; //@line 162 "setlengths.cpp"
    }
  
    var $9=$control_addr; //@line 164 "setlengths.cpp"
    var $and=($9) & 2; //@line 164 "setlengths.cpp"
    var $tobool=((($and))|0)!=0; //@line 164 "setlengths.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 164 "setlengths.cpp"
    if (__label__ == 5) {
  
      __Z12DoSonicSpeedi(1024); //@line 166 "setlengths.cpp"
      ; //@line 167 "setlengths.cpp"
    }
  
    var $10=$wpm_value; //@line 168 "setlengths.cpp"
    var $cmp7=((($10))|0) > 450; //@line 168 "setlengths.cpp"
    if ($cmp7) { __label__ = 10;; } else { __label__ = 7;; } //@line 168 "setlengths.cpp"
    $if_then10$$lor_lhs_false$11: do { 
      if (__label__ == 7) {
  
        var $11=$wpm_value; //@line 168 "setlengths.cpp"
        var $12=HEAP32[((((_speed+32)&4294967295))>>2)]; //@line 168 "setlengths.cpp"
        var $cmp8=((($11))|0) > ((($12))|0); //@line 168 "setlengths.cpp"
        var $13=$wpm; //@line 168 "setlengths.cpp"
        if ($cmp8) { __label__ = 8;; } else { __label__ = 14;; } //@line 168 "setlengths.cpp"
        $land_lhs_true$$if_end29$13: do { 
          if (__label__ == 8) {
  
            var $cmp9=((($13))|0) > 350; //@line 168 "setlengths.cpp"
            if ($cmp9) { __label__ = 10;break $if_then10$$lor_lhs_false$11; } //@line 168 "setlengths.cpp"
  
            var $_pr2=$wpm; //@line 210 "setlengths.cpp"
            __lastLabel__ = 9; __label__ = 16;break $land_lhs_true$$if_end29$13; //@line 207 "setlengths.cpp"
          }
          else if (__label__ == 14) {
  
            var $cmp30=((($13))|0) > 450; //@line 207 "setlengths.cpp"
            if ($cmp30) { __lastLabel__ = 14; ; } else { __lastLabel__ = 14; __label__ = 16;break $land_lhs_true$$if_end29$13; } //@line 207 "setlengths.cpp"
  
            $wpm=450; //@line 208 "setlengths.cpp"
            __label__ = 17;break $land_lhs_true$$if_end29$13; //@line 210 "setlengths.cpp"
          }
        } while(0);
        $if_end32$$if_then34$18: do { 
          if (__label__ == 16) {
  
            var $29=__lastLabel__ == 9 ? $_pr2 : ($13); //@line 210 "setlengths.cpp"
            var $cmp33=((($29))|0) > 360; //@line 210 "setlengths.cpp"
            if ($cmp33) { __label__ = 17;break $if_end32$$if_then34$18; } else { __label__ = 18;break $if_end32$$if_then34$18; } //@line 210 "setlengths.cpp"
          }
        } while(0);
        if (__label__ == 17) {
  
          var $30=$wpm; //@line 212 "setlengths.cpp"
          var $sub=((($30)-360)&4294967295); //@line 212 "setlengths.cpp"
          var $div35=((((($sub))|0)/8)|0); //@line 212 "setlengths.cpp"
          HEAP32[((((_speed+28)&4294967295))>>2)]=$div35; //@line 212 "setlengths.cpp"
          ; //@line 213 "setlengths.cpp"
        }
  
        var $31=$wpm; //@line 215 "setlengths.cpp"
        $wpm2=$31; //@line 215 "setlengths.cpp"
        var $cmp37=((($31))|0) > 359; //@line 216 "setlengths.cpp"
        if ($cmp37) { __lastLabel__ = 18; __label__ = 19;; } else { __lastLabel__ = 18; __label__ = 20;; } //@line 216 "setlengths.cpp"
        if (__label__ == 19) {
  
          $wpm2=359; //@line 216 "setlengths.cpp"
          var $_pr4=$wpm; //@line 217 "setlengths.cpp"
          __lastLabel__ = 19; ; //@line 216 "setlengths.cpp"
        }
  
        var $32=__lastLabel__ == 19 ? $_pr4 : ($31); //@line 217 "setlengths.cpp"
        var $cmp40=((($32))|0) < 80; //@line 217 "setlengths.cpp"
        if ($cmp40) { __label__ = 21;; } else { __label__ = 22;; } //@line 217 "setlengths.cpp"
        if (__label__ == 21) {
  
          $wpm2=80; //@line 217 "setlengths.cpp"
          ; //@line 217 "setlengths.cpp"
        }
  
        var $33=$wpm2; //@line 218 "setlengths.cpp"
        var $sub43=((($33)-80)&4294967295); //@line 218 "setlengths.cpp"
        var $arrayidx=((__ZL12speed_lookup+$sub43)&4294967295); //@line 218 "setlengths.cpp"
        var $34=HEAPU8[($arrayidx)]; //@line 218 "setlengths.cpp"
        var $conv44=((($34))&255); //@line 218 "setlengths.cpp"
        $x=$conv44; //@line 218 "setlengths.cpp"
        var $35=$wpm; //@line 220 "setlengths.cpp"
        var $cmp45=((($35))|0) >= 380; //@line 220 "setlengths.cpp"
        if ($cmp45) { __label__ = 23;; } else { __label__ = 25;; } //@line 220 "setlengths.cpp"
        $if_end47$$if_end50$29: do { 
          if (__label__ == 23) {
  
            $x=7; //@line 221 "setlengths.cpp"
            var $_pr5=$wpm; //@line 222 "setlengths.cpp"
            var $cmp48=((($_pr5))|0) >= 400; //@line 222 "setlengths.cpp"
            if (!($cmp48)) { __label__ = 25;break $if_end47$$if_end50$29; } //@line 222 "setlengths.cpp"
  
            $x=6; //@line 223 "setlengths.cpp"
            ; //@line 223 "setlengths.cpp"
          }
        } while(0);
  
        var $36=$control_addr; //@line 225 "setlengths.cpp"
        var $and51=($36) & 1; //@line 225 "setlengths.cpp"
        var $tobool52=((($and51))|0)!=0; //@line 225 "setlengths.cpp"
        if ($tobool52) { __label__ = 26;; } else { __label__ = 28;; } //@line 225 "setlengths.cpp"
        $if_then53$$if_end67$33: do { 
          if (__label__ == 26) {
  
            var $37=$x; //@line 229 "setlengths.cpp"
            var $38=HEAP32[((_voice)>>2)]; //@line 229 "setlengths.cpp"
            var $speedf154=(($38+52)&4294967295); //@line 229 "setlengths.cpp"
            var $39=HEAP32[(($speedf154)>>2)]; //@line 229 "setlengths.cpp"
            var $mul55=((($39)*($37))&4294967295); //@line 229 "setlengths.cpp"
            var $div56=((((($mul55))|0)/256)|0); //@line 229 "setlengths.cpp"
            HEAP32[((__ZL6speed1)>>2)]=$div56; //@line 229 "setlengths.cpp"
            var $40=$x; //@line 230 "setlengths.cpp"
            var $41=HEAP32[((_voice)>>2)]; //@line 230 "setlengths.cpp"
            var $speedf257=(($41+56)&4294967295); //@line 230 "setlengths.cpp"
            var $42=HEAP32[(($speedf257)>>2)]; //@line 230 "setlengths.cpp"
            var $mul58=((($42)*($40))&4294967295); //@line 230 "setlengths.cpp"
            var $div59=((((($mul58))|0)/256)|0); //@line 230 "setlengths.cpp"
            HEAP32[((__ZL6speed2)>>2)]=$div59; //@line 230 "setlengths.cpp"
            var $43=$x; //@line 231 "setlengths.cpp"
            var $44=HEAP32[((_voice)>>2)]; //@line 231 "setlengths.cpp"
            var $speedf360=(($44+60)&4294967295); //@line 231 "setlengths.cpp"
            var $45=HEAP32[(($speedf360)>>2)]; //@line 231 "setlengths.cpp"
            var $mul61=((($45)*($43))&4294967295); //@line 231 "setlengths.cpp"
            var $div62=((((($mul61))|0)/256)|0); //@line 231 "setlengths.cpp"
            HEAP32[((__ZL6speed3)>>2)]=$div62; //@line 231 "setlengths.cpp"
            var $46=$x; //@line 233 "setlengths.cpp"
            var $cmp63=((($46))|0) <= 7; //@line 233 "setlengths.cpp"
            if (!($cmp63)) { __label__ = 28;break $if_then53$$if_end67$33; } //@line 233 "setlengths.cpp"
  
            var $47=$x; //@line 235 "setlengths.cpp"
            HEAP32[((__ZL6speed1)>>2)]=$47; //@line 235 "setlengths.cpp"
            var $48=$x; //@line 236 "setlengths.cpp"
            var $sub65=((($48)-1)&4294967295); //@line 236 "setlengths.cpp"
            HEAP32[((__ZL6speed3)>>2)]=$sub65; //@line 236 "setlengths.cpp"
            HEAP32[((__ZL6speed2)>>2)]=$sub65; //@line 236 "setlengths.cpp"
            ; //@line 237 "setlengths.cpp"
          }
        } while(0);
  
        var $49=$control_addr; //@line 240 "setlengths.cpp"
        var $and68=($49) & 2; //@line 240 "setlengths.cpp"
        var $tobool69=((($and68))|0)!=0; //@line 240 "setlengths.cpp"
        if (!($tobool69)) { __label__ = 51;break $if_then10$$lor_lhs_false$11; } //@line 240 "setlengths.cpp"
  
        var $50=$wpm; //@line 244 "setlengths.cpp"
        var $cmp71=((($50))|0) > 350; //@line 244 "setlengths.cpp"
        var $51=$wpm; //@line 246 "setlengths.cpp"
        if ($cmp71) { __label__ = 30;; } else { __label__ = 31;; } //@line 244 "setlengths.cpp"
        $if_then72$$if_else$38: do { 
          if (__label__ == 30) {
  
            var $sub73=((($51)-350)&4294967295); //@line 246 "setlengths.cpp"
            var $div74=((((($sub73))|0)/3)|0); //@line 246 "setlengths.cpp"
            var $sub75=((85-($div74))&4294967295); //@line 246 "setlengths.cpp"
            HEAP32[((((_speed+16)&4294967295))>>2)]=$sub75; //@line 246 "setlengths.cpp"
            var $52=$wpm; //@line 247 "setlengths.cpp"
            var $sub76=((($52)-350)&4294967295); //@line 247 "setlengths.cpp"
            var $div77=((((($sub76))|0)/8)|0); //@line 247 "setlengths.cpp"
            var $sub78=((60-($div77))&4294967295); //@line 247 "setlengths.cpp"
            HEAP32[((((_speed+20)&4294967295))>>2)]=$sub78; //@line 247 "setlengths.cpp"
            ; //@line 248 "setlengths.cpp"
          }
          else if (__label__ == 31) {
  
            var $cmp79=((($51))|0) > 250; //@line 250 "setlengths.cpp"
            if (!($cmp79)) { __label__ = 33;break $if_then72$$if_else$38; } //@line 250 "setlengths.cpp"
  
            var $53=$wpm; //@line 252 "setlengths.cpp"
            var $sub81=((($53)-250)&4294967295); //@line 252 "setlengths.cpp"
            var $div82=((((($sub81))|0)/4)|0); //@line 252 "setlengths.cpp"
            var $sub83=((110-($div82))&4294967295); //@line 252 "setlengths.cpp"
            HEAP32[((((_speed+16)&4294967295))>>2)]=$sub83; //@line 252 "setlengths.cpp"
            var $54=$wpm; //@line 253 "setlengths.cpp"
            var $sub84=((($54)-250)&4294967295); //@line 253 "setlengths.cpp"
            var $div85=((((($sub84))|0)/2)|0); //@line 253 "setlengths.cpp"
            var $sub86=((110-($div85))&4294967295); //@line 253 "setlengths.cpp"
            HEAP32[((((_speed+20)&4294967295))>>2)]=$sub86; //@line 253 "setlengths.cpp"
            ; //@line 254 "setlengths.cpp"
          }
        } while(0);
  
        var $55=$x; //@line 256 "setlengths.cpp"
        var $56=HEAP32[((_voice)>>2)]; //@line 256 "setlengths.cpp"
        var $speedf189=(($56+52)&4294967295); //@line 256 "setlengths.cpp"
        var $57=HEAP32[(($speedf189)>>2)]; //@line 256 "setlengths.cpp"
        var $mul90=((($57)*($55))&4294967295); //@line 256 "setlengths.cpp"
        var $div91=((((($mul90))|0)/256)|0); //@line 256 "setlengths.cpp"
        $s1=$div91; //@line 256 "setlengths.cpp"
        var $58=$wpm; //@line 258 "setlengths.cpp"
        var $cmp92=((($58))|0) >= 170; //@line 258 "setlengths.cpp"
        var $59=$s1; //@line 259 "setlengths.cpp"
        if ($cmp92) { __label__ = 34;; } else { __label__ = 35;; } //@line 258 "setlengths.cpp"
        if (__label__ == 34) {
  
          var $mul94=((($59)*150)&4294967295); //@line 259 "setlengths.cpp"
          var $div95=((((($mul94))|0)/128)|0); //@line 259 "setlengths.cpp"
          var $add=((($div95)+110)&4294967295); //@line 259 "setlengths.cpp"
          HEAP32[((((_speed+12)&4294967295))>>2)]=$add; //@line 259 "setlengths.cpp"
          ; //@line 259 "setlengths.cpp"
        }
        else if (__label__ == 35) {
  
          var $mul97=((($59)*128)&4294967295); //@line 261 "setlengths.cpp"
          var $div98=((((($mul97))|0)/130)|0); //@line 261 "setlengths.cpp"
          var $add99=((($div98)+128)&4294967295); //@line 261 "setlengths.cpp"
          HEAP32[((((_speed+12)&4294967295))>>2)]=$add99; //@line 261 "setlengths.cpp"
          ;
        }
  
        var $60=$wpm; //@line 263 "setlengths.cpp"
        var $cmp101=((($60))|0) >= 350; //@line 263 "setlengths.cpp"
        if ($cmp101) { __label__ = 37;; } else { __label__ = 40;; } //@line 263 "setlengths.cpp"
        $if_end106$$if_end117$47: do { 
          if (__label__ == 37) {
  
            var $61=$wpm; //@line 265 "setlengths.cpp"
            var $sub103=((($61)-350)&4294967295); //@line 265 "setlengths.cpp"
            var $arrayidx104=((__ZL14wav_factor_350+$sub103)&4294967295); //@line 265 "setlengths.cpp"
            var $62=HEAPU8[($arrayidx104)]; //@line 265 "setlengths.cpp"
            var $conv105=((($62))&255); //@line 265 "setlengths.cpp"
            HEAP32[((((_speed+12)&4294967295))>>2)]=$conv105; //@line 265 "setlengths.cpp"
            var $_pr7=$wpm; //@line 268 "setlengths.cpp"
            var $cmp107=((($_pr7))|0) >= 390; //@line 268 "setlengths.cpp"
            if (!($cmp107)) { __label__ = 40;break $if_end106$$if_end117$47; } //@line 268 "setlengths.cpp"
  
            var $63=$wpm; //@line 270 "setlengths.cpp"
            var $sub109=((($63)-400)&4294967295); //@line 270 "setlengths.cpp"
            var $div110=((((($sub109))|0)/2)|0); //@line 270 "setlengths.cpp"
            var $sub111=((450-($div110))&4294967295); //@line 270 "setlengths.cpp"
            HEAP32[((((_speed+24)&4294967295))>>2)]=$sub111; //@line 270 "setlengths.cpp"
            var $64=$wpm; //@line 271 "setlengths.cpp"
            var $cmp112=((($64))|0) > 440; //@line 271 "setlengths.cpp"
            if (!($cmp112)) { __label__ = 40;break $if_end106$$if_end117$47; } //@line 271 "setlengths.cpp"
  
            var $65=$wpm; //@line 272 "setlengths.cpp"
            var $_neg=(((-($65)))&4294967295);
            var $sub115=((($_neg)+860)&4294967295); //@line 272 "setlengths.cpp"
            HEAP32[((((_speed+24)&4294967295))>>2)]=$sub115; //@line 272 "setlengths.cpp"
            ; //@line 272 "setlengths.cpp"
          }
        } while(0);
  
        var $66=$s1; //@line 275 "setlengths.cpp"
        var $mul118=((($66)*256)&4294967295); //@line 275 "setlengths.cpp"
        var $div119=((((($mul118))|0)/115)|0); //@line 275 "setlengths.cpp"
        HEAP32[((((_speed)&4294967295))>>2)]=$div119; //@line 275 "setlengths.cpp"
        HEAP32[((((_speed+4)&4294967295))>>2)]=0; //@line 276 "setlengths.cpp"
        var $67=$wpm; //@line 278 "setlengths.cpp"
        var $cmp120=((($67))|0) > 430; //@line 278 "setlengths.cpp"
        if ($cmp120) { __label__ = 41;; } else { __label__ = 42;; } //@line 278 "setlengths.cpp"
        $if_then121$$if_else122$52: do { 
          if (__label__ == 41) {
  
            HEAP32[((((_speed)&4294967295))>>2)]=12; //@line 280 "setlengths.cpp"
            ; //@line 282 "setlengths.cpp"
          }
          else if (__label__ == 42) {
  
            var $68=$wpm; //@line 284 "setlengths.cpp"
            var $cmp123=((($68))|0) > 400; //@line 284 "setlengths.cpp"
            if ($cmp123) { __label__ = 43;; } else { __label__ = 44;; } //@line 284 "setlengths.cpp"
            if (__label__ == 43) {
  
              HEAP32[((((_speed)&4294967295))>>2)]=13; //@line 286 "setlengths.cpp"
              ; //@line 288 "setlengths.cpp"
            }
            else if (__label__ == 44) {
  
              var $69=$wpm; //@line 290 "setlengths.cpp"
              var $cmp126=((($69))|0) > 374; //@line 290 "setlengths.cpp"
              if ($cmp126) { __label__ = 45;; } else { __label__ = 46;; } //@line 290 "setlengths.cpp"
              if (__label__ == 45) {
  
                HEAP32[((((_speed)&4294967295))>>2)]=14; //@line 292 "setlengths.cpp"
                ; //@line 293 "setlengths.cpp"
              }
              else if (__label__ == 46) {
  
                var $70=$wpm; //@line 295 "setlengths.cpp"
                var $cmp129=((($70))|0) > 350; //@line 295 "setlengths.cpp"
                if (!($cmp129)) { __label__ = 48;break $if_then121$$if_else122$52; } //@line 295 "setlengths.cpp"
  
                var $71=$wpm; //@line 297 "setlengths.cpp"
                var $sub131=((($71)-350)&4294967295); //@line 297 "setlengths.cpp"
                var $arrayidx132=((__ZL16pause_factor_350+$sub131)&4294967295); //@line 297 "setlengths.cpp"
                var $72=HEAPU8[($arrayidx132)]; //@line 297 "setlengths.cpp"
                var $conv133=((($72))&255); //@line 297 "setlengths.cpp"
                HEAP32[((((_speed)&4294967295))>>2)]=$conv133; //@line 297 "setlengths.cpp"
                ; //@line 298 "setlengths.cpp"
              }
            }
          }
        } while(0);
  
        var $73=HEAP32[((((_speed+4)&4294967295))>>2)]; //@line 300 "setlengths.cpp"
        var $cmp138=((($73))|0)==0; //@line 300 "setlengths.cpp"
        if (!($cmp138)) { __label__ = 51;break $if_then10$$lor_lhs_false$11; } //@line 300 "setlengths.cpp"
  
        var $74=HEAP32[((((_speed)&4294967295))>>2)]; //@line 303 "setlengths.cpp"
        HEAP32[((((_speed+4)&4294967295))>>2)]=$74; //@line 303 "setlengths.cpp"
        var $cmp140=((($74))|0) < 16; //@line 303 "setlengths.cpp"
        if (!($cmp140)) { __label__ = 51;break $if_then10$$lor_lhs_false$11; } //@line 303 "setlengths.cpp"
  
        HEAP32[((((_speed+4)&4294967295))>>2)]=16; //@line 304 "setlengths.cpp"
        __label__ = 51;break $if_then10$$lor_lhs_false$11; //@line 304 "setlengths.cpp"
      }
    } while(0);
    $if_then10$$if_end144$65: do { 
      if (__label__ == 10) {
  
        var $14=$wpm; //@line 170 "setlengths.cpp"
        $wpm2=$14; //@line 170 "setlengths.cpp"
        $wpm=175; //@line 171 "setlengths.cpp"
        $x=73; //@line 175 "setlengths.cpp"
        var $15=$control_addr; //@line 176 "setlengths.cpp"
        var $and11=($15) & 1; //@line 176 "setlengths.cpp"
        var $tobool12=((($and11))|0)!=0; //@line 176 "setlengths.cpp"
        if ($tobool12) { __label__ = 11;; } else { __label__ = 12;; } //@line 176 "setlengths.cpp"
        if (__label__ == 11) {
  
          var $16=$x; //@line 178 "setlengths.cpp"
          var $17=HEAP32[((_voice)>>2)]; //@line 178 "setlengths.cpp"
          var $speedf1=(($17+52)&4294967295); //@line 178 "setlengths.cpp"
          var $18=HEAP32[(($speedf1)>>2)]; //@line 178 "setlengths.cpp"
          var $mul14=((($18)*($16))&4294967295); //@line 178 "setlengths.cpp"
          var $div15=((((($mul14))|0)/256)|0); //@line 178 "setlengths.cpp"
          HEAP32[((__ZL6speed1)>>2)]=$div15; //@line 178 "setlengths.cpp"
          var $19=$x; //@line 179 "setlengths.cpp"
          var $20=HEAP32[((_voice)>>2)]; //@line 179 "setlengths.cpp"
          var $speedf2=(($20+56)&4294967295); //@line 179 "setlengths.cpp"
          var $21=HEAP32[(($speedf2)>>2)]; //@line 179 "setlengths.cpp"
          var $mul16=((($21)*($19))&4294967295); //@line 179 "setlengths.cpp"
          var $div17=((((($mul16))|0)/256)|0); //@line 179 "setlengths.cpp"
          HEAP32[((__ZL6speed2)>>2)]=$div17; //@line 179 "setlengths.cpp"
          var $22=$x; //@line 180 "setlengths.cpp"
          var $23=HEAP32[((_voice)>>2)]; //@line 180 "setlengths.cpp"
          var $speedf3=(($23+60)&4294967295); //@line 180 "setlengths.cpp"
          var $24=HEAP32[(($speedf3)>>2)]; //@line 180 "setlengths.cpp"
          var $mul18=((($24)*($22))&4294967295); //@line 180 "setlengths.cpp"
          var $div19=((((($mul18))|0)/256)|0); //@line 180 "setlengths.cpp"
          HEAP32[((__ZL6speed3)>>2)]=$div19; //@line 180 "setlengths.cpp"
          ; //@line 181 "setlengths.cpp"
        }
  
        var $25=$control_addr; //@line 182 "setlengths.cpp"
        var $and21=($25) & 2; //@line 182 "setlengths.cpp"
        var $tobool22=((($and21))|0)!=0; //@line 182 "setlengths.cpp"
        if (!($tobool22)) { __label__ = 51;break $if_then10$$if_end144$65; } //@line 182 "setlengths.cpp"
  
        var $26=$wpm2; //@line 184 "setlengths.cpp"
        var $conv=((($26))|0); //@line 184 "setlengths.cpp"
        var $27=$wpm; //@line 184 "setlengths.cpp"
        var $conv24=((($27))|0); //@line 184 "setlengths.cpp"
        var $div25=($conv)/($conv24); //@line 184 "setlengths.cpp"
        $sonic=$div25; //@line 184 "setlengths.cpp"
        var $28=$sonic; //@line 185 "setlengths.cpp"
        var $mul26=($28)*1024; //@line 185 "setlengths.cpp"
        var $conv27=((($mul26))|0); //@line 185 "setlengths.cpp"
        __Z12DoSonicSpeedi($conv27); //@line 185 "setlengths.cpp"
        HEAP32[((((_speed)&4294967295))>>2)]=85; //@line 186 "setlengths.cpp"
        HEAP32[((((_speed+4)&4294967295))>>2)]=80; //@line 187 "setlengths.cpp"
        HEAP32[((((_speed+8)&4294967295))>>2)]=22; //@line 188 "setlengths.cpp"
        HEAP32[((((_speed+24)&4294967295))>>2)]=900; //@line 189 "setlengths.cpp"
        HEAP32[((((_speed+12)&4294967295))>>2)]=211; //@line 190 "setlengths.cpp"
        HEAP32[((((_speed+16)&4294967295))>>2)]=210; //@line 191 "setlengths.cpp"
        HEAP32[((((_speed+20)&4294967295))>>2)]=170; //@line 192 "setlengths.cpp"
        ; //@line 193 "setlengths.cpp"
      }
    } while(0);
  
    ;
    return; //@line 312 "setlengths.cpp"
    return;
  }
  

  function __Z12SetParameteriii($parameter, $value, $relative) {
    ;
    var __label__;
  
    var $parameter_addr;
    var $value_addr;
    var $relative_addr;
    var $new_value;
    var $default_value;
    $parameter_addr=$parameter;
    $value_addr=$value;
    $relative_addr=$relative;
    var $0=$value_addr; //@line 334 "setlengths.cpp"
    $new_value=$0; //@line 334 "setlengths.cpp"
    var $1=$relative_addr; //@line 337 "setlengths.cpp"
    var $tobool=((($1))|0)!=0; //@line 337 "setlengths.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 337 "setlengths.cpp"
    $if_then$$if_end2$2: do { 
      if (__label__ == 1) {
  
        var $2=$parameter_addr; //@line 339 "setlengths.cpp"
        var $cmp=((($2))|0) < 5; //@line 339 "setlengths.cpp"
        if (!($cmp)) { __label__ = 3;break $if_then$$if_end2$2; } //@line 339 "setlengths.cpp"
  
        var $3=$parameter_addr; //@line 341 "setlengths.cpp"
        var $arrayidx=((_param_defaults+$3*4)&4294967295); //@line 341 "setlengths.cpp"
        var $4=HEAP32[(($arrayidx)>>2)]; //@line 341 "setlengths.cpp"
        $default_value=$4; //@line 341 "setlengths.cpp"
        var $5=$default_value; //@line 342 "setlengths.cpp"
        var $6=$default_value; //@line 342 "setlengths.cpp"
        var $7=$value_addr; //@line 342 "setlengths.cpp"
        var $mul=((($7)*($6))&4294967295); //@line 342 "setlengths.cpp"
        var $div=((((($mul))|0)/100)|0); //@line 342 "setlengths.cpp"
        var $add=((($div)+($5))&4294967295); //@line 342 "setlengths.cpp"
        $new_value=$add; //@line 342 "setlengths.cpp"
        ; //@line 343 "setlengths.cpp"
      }
    } while(0);
  
    var $8=$new_value; //@line 345 "setlengths.cpp"
    var $9=$parameter_addr; //@line 345 "setlengths.cpp"
    var $arrayidx3=((((_param_stack+4)&4294967295)+$9*4)&4294967295); //@line 345 "setlengths.cpp"
    HEAP32[(($arrayidx3)>>2)]=$8; //@line 345 "setlengths.cpp"
    var $10=$parameter_addr; //@line 347 "setlengths.cpp"
    if ($10 == 1) {
      __label__ = 4;;
    }
    else if ($10 == 2) {
      __label__ = 5;;
    }
    else if ($10 == 3) {
      __label__ = 6;;
    }
    else if ($10 == 4) {
      __label__ = 11;;
    }
    else if ($10 == 13) {
      __label__ = 14;;
    }
    else if ($10 == 7) {
      __label__ = 15;;
    }
    else if ($10 == 9) {
      __label__ = 16;;
    }
    else {
    __label__ = 19;;
    }
    
    if (__label__ == 4) {
  
      var $11=$new_value; //@line 350 "setlengths.cpp"
      HEAP32[((((_embedded_value+8)&4294967295))>>2)]=$11; //@line 350 "setlengths.cpp"
      var $12=$new_value; //@line 351 "setlengths.cpp"
      HEAP32[((((_embedded_value+32)&4294967295))>>2)]=$12; //@line 351 "setlengths.cpp"
      __Z8SetSpeedi(3); //@line 352 "setlengths.cpp"
      ; //@line 353 "setlengths.cpp"
    }
    else if (__label__ == 5) {
  
      var $13=$new_value; //@line 356 "setlengths.cpp"
      HEAP32[((((_embedded_value+12)&4294967295))>>2)]=$13; //@line 356 "setlengths.cpp"
      var $call=__Z12GetAmplitudev(); //@line 357 "setlengths.cpp"
      ; //@line 358 "setlengths.cpp"
    }
    else if (__label__ == 6) {
  
      var $14=$new_value; //@line 361 "setlengths.cpp"
      var $cmp6=((($14))|0) > 99; //@line 361 "setlengths.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 361 "setlengths.cpp"
      $if_end8_thread$$if_end8$10: do { 
        if (__label__ == 7) {
  
          $new_value=99; //@line 361 "setlengths.cpp"
          ; //@line 362 "setlengths.cpp"
        }
        else if (__label__ == 8) {
  
          var $cmp9=((($14))|0) < 0; //@line 362 "setlengths.cpp"
          if (!($cmp9)) { __label__ = 10;break $if_end8_thread$$if_end8$10; } //@line 362 "setlengths.cpp"
  
          $new_value=0; //@line 362 "setlengths.cpp"
          ; //@line 362 "setlengths.cpp"
        }
      } while(0);
  
      var $15=$new_value; //@line 363 "setlengths.cpp"
      HEAP32[((((_embedded_value+4)&4294967295))>>2)]=$15; //@line 363 "setlengths.cpp"
      ; //@line 364 "setlengths.cpp"
    }
    else if (__label__ == 11) {
  
      var $16=$new_value; //@line 367 "setlengths.cpp"
      var $cmp13=((($16))|0) > 99; //@line 367 "setlengths.cpp"
      if ($cmp13) { __label__ = 12;; } else { __label__ = 13;; } //@line 367 "setlengths.cpp"
      if (__label__ == 12) {
  
        $new_value=99; //@line 367 "setlengths.cpp"
        ; //@line 367 "setlengths.cpp"
      }
  
      var $17=$new_value; //@line 368 "setlengths.cpp"
      HEAP32[((((_embedded_value+16)&4294967295))>>2)]=$17; //@line 368 "setlengths.cpp"
      ; //@line 369 "setlengths.cpp"
    }
    else if (__label__ == 14) {
  
      var $18=$new_value; //@line 372 "setlengths.cpp"
      HEAP32[((_option_linelength)>>2)]=$18; //@line 372 "setlengths.cpp"
      ; //@line 373 "setlengths.cpp"
    }
    else if (__label__ == 15) {
  
      var $19=$new_value; //@line 376 "setlengths.cpp"
      HEAP32[((_option_wordgap)>>2)]=$19; //@line 376 "setlengths.cpp"
      ; //@line 377 "setlengths.cpp"
    }
    else if (__label__ == 16) {
  
      var $20=$new_value; //@line 380 "setlengths.cpp"
      var $and=($20) & 255; //@line 380 "setlengths.cpp"
      var $cmp19=((($and))|0)!=0; //@line 380 "setlengths.cpp"
      if ($cmp19) { __label__ = 17;; } else { __label__ = 18;; } //@line 380 "setlengths.cpp"
      if (__label__ == 17) {
  
        var $21=$new_value; //@line 381 "setlengths.cpp"
        var $and21=($21) & 255; //@line 381 "setlengths.cpp"
        var $22=HEAP32[((_translator)>>2)]; //@line 381 "setlengths.cpp"
        var $langopts=(($22)&4294967295); //@line 381 "setlengths.cpp"
        var $intonation_group=(($langopts+228)&4294967295); //@line 381 "setlengths.cpp"
        HEAP32[(($intonation_group)>>2)]=$and21; //@line 381 "setlengths.cpp"
        ; //@line 381 "setlengths.cpp"
      }
  
      var $23=$new_value; //@line 382 "setlengths.cpp"
      HEAP32[((_option_tone_flags)>>2)]=$23; //@line 382 "setlengths.cpp"
      ; //@line 383 "setlengths.cpp"
    }
  
    ;
    return; //@line 388 "setlengths.cpp"
    return;
  }
  

  function __Z11CalcLengthsP10Translator($tr) {
    var __stackBase__  = STACKTOP; STACKTOP += 156; _memset(__stackBase__, 0, 156);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $ix;
    var $ix2;
    var $prev;
    var $next;
    var $next2;
    var $next3;
    var $p;
    var $p2;
    var $stress;
    var $type;
    var $pre_sonorant;
    var $pre_voiced;
    var $last_pitch;
    var $pitch_start;
    var $length_mod;
    var $len;
    var $env2;
    var $end_of_clause;
    var $embedded_ix=__stackBase__;
    var $min_drop;
    var $pitch1;
    var $emphasized;
    var $tone_mod;
    var $pitch_env;
    var $phdata_tone=__stackBase__+4;
    $tr_addr=$tr;
    $pre_sonorant=0; //@line 425 "setlengths.cpp"
    $pre_voiced=0; //@line 426 "setlengths.cpp"
    $last_pitch=0; //@line 427 "setlengths.cpp"
    HEAP32[(($embedded_ix)>>2)]=0; //@line 433 "setlengths.cpp"
    $pitch_env=0; //@line 438 "setlengths.cpp"
    $ix=1; //@line 441 "setlengths.cpp"
    var $0=$ix; //@line 441 "setlengths.cpp"
    var $1=HEAP32[((_n_phoneme_list)>>2)]; //@line 441 "setlengths.cpp"
    var $cmp7=((($0))|0) < ((($1))|0); //@line 441 "setlengths.cpp"
    if ($cmp7) { __label__ = 1;; } else { __label__ = 193;; } //@line 441 "setlengths.cpp"
    $for_body_lr_ph$$for_end733$2: do { 
      if (__label__ == 1) {
  
        var $pitch_env595=(($phdata_tone+124)&4294967295); //@line 779 "setlengths.cpp"
        ; //@line 441 "setlengths.cpp"
        $for_body$4: while(1) { 
  
          var $2=$ix; //@line 443 "setlengths.cpp"
          var $sub=((($2)-1)&4294967295); //@line 443 "setlengths.cpp"
          var $arrayidx=((_phoneme_list+$sub*24)&4294967295); //@line 443 "setlengths.cpp"
          $prev=$arrayidx; //@line 443 "setlengths.cpp"
          var $3=$ix; //@line 444 "setlengths.cpp"
          var $arrayidx1=((_phoneme_list+$3*24)&4294967295); //@line 444 "setlengths.cpp"
          $p=$arrayidx1; //@line 444 "setlengths.cpp"
          var $4=$p; //@line 445 "setlengths.cpp"
          var $stresslevel=(($4+1)&4294967295); //@line 445 "setlengths.cpp"
          var $5=HEAPU8[($stresslevel)]; //@line 445 "setlengths.cpp"
          var $conv=((($5))&255); //@line 445 "setlengths.cpp"
          var $and=($conv) & 7; //@line 445 "setlengths.cpp"
          $stress=$and; //@line 445 "setlengths.cpp"
          var $6=$p; //@line 446 "setlengths.cpp"
          var $stresslevel2=(($6+1)&4294967295); //@line 446 "setlengths.cpp"
          var $7=HEAPU8[($stresslevel2)]; //@line 446 "setlengths.cpp"
          var $conv3=((($7))&255); //@line 446 "setlengths.cpp"
          var $and4=($conv3) & 8; //@line 446 "setlengths.cpp"
          $emphasized=$and4; //@line 446 "setlengths.cpp"
          var $8=$ix; //@line 448 "setlengths.cpp"
          var $add=((($8)+1)&4294967295); //@line 448 "setlengths.cpp"
          var $arrayidx5=((_phoneme_list+$add*24)&4294967295); //@line 448 "setlengths.cpp"
          $next=$arrayidx5; //@line 448 "setlengths.cpp"
          var $9=$p; //@line 450 "setlengths.cpp"
          var $synthflags=(($9+4)&4294967295); //@line 450 "setlengths.cpp"
          var $10=HEAPU16[(($synthflags)>>1)]; //@line 450 "setlengths.cpp"
          var $conv6=((($10))&65535); //@line 450 "setlengths.cpp"
          var $and7=($conv6) & 2; //@line 450 "setlengths.cpp"
          var $tobool=((($and7))|0)!=0; //@line 450 "setlengths.cpp"
          if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 450 "setlengths.cpp"
          if (__label__ == 3) {
  
            __ZL11DoEmbedded2Pi($embedded_ix); //@line 452 "setlengths.cpp"
            ; //@line 453 "setlengths.cpp"
          }
  
          var $11=$p; //@line 455 "setlengths.cpp"
          var $type8=(($11+15)&4294967295); //@line 455 "setlengths.cpp"
          var $12=HEAPU8[($type8)]; //@line 455 "setlengths.cpp"
          var $conv9=((($12))&255); //@line 455 "setlengths.cpp"
          $type=$conv9; //@line 455 "setlengths.cpp"
          var $13=$p; //@line 456 "setlengths.cpp"
          var $synthflags10=(($13+4)&4294967295); //@line 456 "setlengths.cpp"
          var $14=HEAPU16[(($synthflags10)>>1)]; //@line 456 "setlengths.cpp"
          var $conv11=((($14))&65535); //@line 456 "setlengths.cpp"
          var $and12=($conv11) & 4; //@line 456 "setlengths.cpp"
          var $tobool13=((($and12))|0)!=0; //@line 456 "setlengths.cpp"
          if ($tobool13) { __label__ = 5;; } else { __label__ = 6;; } //@line 456 "setlengths.cpp"
          $if_end15_thread$$if_end15$9: do { 
            if (__label__ == 5) {
  
              $type=2; //@line 457 "setlengths.cpp"
              __label__ = 98;break $if_end15_thread$$if_end15$9; //@line 459 "setlengths.cpp"
            }
            else if (__label__ == 6) {
  
              var $_pr=$type; //@line 459 "setlengths.cpp"
              if ($_pr == 0) {
                __label__ = 7;;
              }
              else if ($_pr == 4) {
                __label__ = 8;;
              }
              else if ($_pr == 7) {
                __label__ = 23;;
              }
              else if ($_pr == 6) {
                __label__ = 23;;
              }
              else if ($_pr == 5) {
                __label__ = 49;;
              }
              else if ($_pr == 3) {
                __label__ = 74;;
              }
              else if ($_pr == 8) {
                __label__ = 74;;
              }
              else if ($_pr == 2) {
                __label__ = 98;break $if_end15_thread$$if_end15$9;
              }
              else {
              __label__ = 192;break $if_end15_thread$$if_end15$9;
              }
              
              if (__label__ == 7) {
  
                $last_pitch=0; //@line 462 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 463 "setlengths.cpp"
              }
              else if (__label__ == 8) {
  
                $last_pitch=0; //@line 466 "setlengths.cpp"
                var $15=$prev; //@line 467 "setlengths.cpp"
                var $type17=(($15+15)&4294967295); //@line 467 "setlengths.cpp"
                var $16=HEAPU8[($type17)]; //@line 467 "setlengths.cpp"
                var $conv18=((($16))&255); //@line 467 "setlengths.cpp"
                var $cmp19=((($conv18))|0)==6; //@line 467 "setlengths.cpp"
                if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 467 "setlengths.cpp"
                $if_then20$$if_else$15: do { 
                  if (__label__ == 9) {
  
                    var $17=$p; //@line 468 "setlengths.cpp"
                    var $prepause=(($17+16)&4294967295); //@line 468 "setlengths.cpp"
                    HEAP8[($prepause)]=25; //@line 468 "setlengths.cpp"
                    ; //@line 468 "setlengths.cpp"
                  }
                  else if (__label__ == 10) {
  
                    var $18=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 470 "setlengths.cpp"
                    var $cmp21=((($18))|0) > 0; //@line 470 "setlengths.cpp"
                    if ($cmp21) { __label__ = 12;; } else { __label__ = 11;; } //@line 470 "setlengths.cpp"
                    $if_then23$$lor_lhs_false$18: do { 
                      if (__label__ == 11) {
  
                        var $19=$stress; //@line 470 "setlengths.cpp"
                        var $cmp22=((($19))|0) < 4; //@line 470 "setlengths.cpp"
                        if ($cmp22) { __label__ = 12;break $if_then23$$lor_lhs_false$18; } //@line 470 "setlengths.cpp"
  
                        var $21=$p; //@line 473 "setlengths.cpp"
                        var $prepause26=(($21+16)&4294967295); //@line 473 "setlengths.cpp"
                        HEAP8[($prepause26)]=60; //@line 473 "setlengths.cpp"
                        __label__ = 14;break $if_then20$$if_else$15;
                      }
                    } while(0);
  
                    var $20=$p; //@line 471 "setlengths.cpp"
                    var $prepause24=(($20+16)&4294967295); //@line 471 "setlengths.cpp"
                    HEAP8[($prepause24)]=48; //@line 471 "setlengths.cpp"
                    ; //@line 471 "setlengths.cpp"
                  }
                } while(0);
  
                var $22=$prev; //@line 475 "setlengths.cpp"
                var $type29=(($22+15)&4294967295); //@line 475 "setlengths.cpp"
                var $23=HEAPU8[($type29)]; //@line 475 "setlengths.cpp"
                var $conv30=((($23))&255); //@line 475 "setlengths.cpp"
                var $cmp31=((($conv30))|0)==4; //@line 475 "setlengths.cpp"
                if ($cmp31) { __label__ = 15;; } else { __label__ = 16;; } //@line 475 "setlengths.cpp"
                if (__label__ == 15) {
  
                  var $24=$p; //@line 476 "setlengths.cpp"
                  var $prepause33=(($24+16)&4294967295); //@line 476 "setlengths.cpp"
                  HEAP8[($prepause33)]=60; //@line 476 "setlengths.cpp"
                  ; //@line 476 "setlengths.cpp"
                }
  
                var $25=$tr_addr; //@line 478 "setlengths.cpp"
                var $langopts=(($25)&4294967295); //@line 478 "setlengths.cpp"
                var $word_gap=(($langopts)&4294967295); //@line 478 "setlengths.cpp"
                var $26=HEAP32[(($word_gap)>>2)]; //@line 478 "setlengths.cpp"
                var $and35=($26) & 16; //@line 478 "setlengths.cpp"
                var $tobool36=((($and35))|0)!=0; //@line 478 "setlengths.cpp"
                if ($tobool36) { __label__ = 17;; } else { __label__ = 19;; } //@line 478 "setlengths.cpp"
                $land_lhs_true$$if_end40$26: do { 
                  if (__label__ == 17) {
  
                    var $27=$p; //@line 478 "setlengths.cpp"
                    var $newword=(($27+19)&4294967295); //@line 478 "setlengths.cpp"
                    var $28=HEAP8[($newword)]; //@line 478 "setlengths.cpp"
                    var $tobool37=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 478 "setlengths.cpp"
                    if (!($tobool37)) { __label__ = 19;break $land_lhs_true$$if_end40$26; } //@line 478 "setlengths.cpp"
  
                    var $29=$p; //@line 479 "setlengths.cpp"
                    var $prepause39=(($29+16)&4294967295); //@line 479 "setlengths.cpp"
                    HEAP8[($prepause39)]=60; //@line 479 "setlengths.cpp"
                    ; //@line 479 "setlengths.cpp"
                  }
                } while(0);
  
                var $30=$p; //@line 481 "setlengths.cpp"
                var $ph=(($30+8)&4294967295); //@line 481 "setlengths.cpp"
                var $31=HEAP32[(($ph)>>2)]; //@line 481 "setlengths.cpp"
                var $phflags=(($31+4)&4294967295); //@line 481 "setlengths.cpp"
                var $32=HEAP32[(($phflags)>>2)]; //@line 481 "setlengths.cpp"
                var $and41=($32) & 4194304; //@line 481 "setlengths.cpp"
                var $tobool42=((($and41))|0)!=0; //@line 481 "setlengths.cpp"
                if ($tobool42) { __label__ = 20;; } else { __label__ = 21;; } //@line 481 "setlengths.cpp"
                if (__label__ == 20) {
  
                  var $33=$p; //@line 482 "setlengths.cpp"
                  var $prepause44=(($33+16)&4294967295); //@line 482 "setlengths.cpp"
                  var $34=HEAPU8[($prepause44)]; //@line 482 "setlengths.cpp"
                  var $conv45=((($34))&255); //@line 482 "setlengths.cpp"
                  var $add46=((($conv45)+30)&4294967295); //@line 482 "setlengths.cpp"
                  var $conv47=((($add46)) & 255); //@line 482 "setlengths.cpp"
                  HEAP8[($prepause44)]=$conv47; //@line 482 "setlengths.cpp"
                  ; //@line 482 "setlengths.cpp"
                }
  
                var $35=$p; //@line 484 "setlengths.cpp"
                var $synthflags49=(($35+4)&4294967295); //@line 484 "setlengths.cpp"
                var $36=HEAPU16[(($synthflags49)>>1)]; //@line 484 "setlengths.cpp"
                var $conv50=((($36))&65535); //@line 484 "setlengths.cpp"
                var $and51=($conv50) & 8; //@line 484 "setlengths.cpp"
                var $tobool52=((($and51))|0)!=0; //@line 484 "setlengths.cpp"
                if (!($tobool52)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 484 "setlengths.cpp"
  
                var $37=$tr_addr; //@line 485 "setlengths.cpp"
                var $langopts54=(($37)&4294967295); //@line 485 "setlengths.cpp"
                var $long_stop=(($langopts54+240)&4294967295); //@line 485 "setlengths.cpp"
                var $38=HEAP32[(($long_stop)>>2)]; //@line 485 "setlengths.cpp"
                var $39=$p; //@line 485 "setlengths.cpp"
                var $prepause55=(($39+16)&4294967295); //@line 485 "setlengths.cpp"
                var $40=HEAPU8[($prepause55)]; //@line 485 "setlengths.cpp"
                var $conv56=((($40))&255); //@line 485 "setlengths.cpp"
                var $add57=((($conv56)+($38))&4294967295); //@line 485 "setlengths.cpp"
                var $conv58=((($add57)) & 255); //@line 485 "setlengths.cpp"
                HEAP8[($prepause55)]=$conv58; //@line 485 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 485 "setlengths.cpp"
              }
              else if (__label__ == 23) {
  
                var $41=$p; //@line 490 "setlengths.cpp"
                var $newword61=(($41+19)&4294967295); //@line 490 "setlengths.cpp"
                var $42=HEAP8[($newword61)]; //@line 490 "setlengths.cpp"
                var $tobool62=(tempInt=(($42)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 490 "setlengths.cpp"
                if ($tobool62) { __label__ = 24;; } else { __label__ = 27;; } //@line 490 "setlengths.cpp"
                $if_then63$$if_end76$35: do { 
                  if (__label__ == 24) {
  
                    var $43=$prev; //@line 492 "setlengths.cpp"
                    var $type64=(($43+15)&4294967295); //@line 492 "setlengths.cpp"
                    var $44=HEAPU8[($type64)]; //@line 492 "setlengths.cpp"
                    var $conv65=((($44))&255); //@line 492 "setlengths.cpp"
                    var $cmp66=((($conv65))|0)==2; //@line 492 "setlengths.cpp"
                    if ($cmp66) { __label__ = 25;; } else { __label__ = 26;; } //@line 492 "setlengths.cpp"
                    if (__label__ == 25) {
  
                      var $45=$p; //@line 492 "setlengths.cpp"
                      var $ph68=(($45+8)&4294967295); //@line 492 "setlengths.cpp"
                      var $46=HEAP32[(($ph68)>>2)]; //@line 492 "setlengths.cpp"
                      var $phflags69=(($46+4)&4294967295); //@line 492 "setlengths.cpp"
                      var $47=HEAP32[(($phflags69)>>2)]; //@line 492 "setlengths.cpp"
                      var $and70=($47) & 16777216; //@line 492 "setlengths.cpp"
                      var $tobool71=((($and70))|0)!=0; //@line 492 "setlengths.cpp"
                      if ($tobool71) { __label__ = 27;break $if_then63$$if_end76$35; } //@line 492 "setlengths.cpp"
                    }
  
                    var $48=$p; //@line 497 "setlengths.cpp"
                    var $prepause74=(($48+16)&4294967295); //@line 497 "setlengths.cpp"
                    HEAP8[($prepause74)]=15; //@line 497 "setlengths.cpp"
                    ;
                  }
                } while(0);
  
                var $49=$next; //@line 501 "setlengths.cpp"
                var $type77=(($49+15)&4294967295); //@line 501 "setlengths.cpp"
                var $50=HEAPU8[($type77)]; //@line 501 "setlengths.cpp"
                var $conv78=((($50))&255); //@line 501 "setlengths.cpp"
                var $cmp79=((($conv78))|0)==0; //@line 501 "setlengths.cpp"
                if ($cmp79) { __label__ = 28;; } else { __label__ = 31;; } //@line 501 "setlengths.cpp"
                $land_lhs_true80$$if_end91$41: do { 
                  if (__label__ == 28) {
  
                    var $51=$prev; //@line 501 "setlengths.cpp"
                    var $type81=(($51+15)&4294967295); //@line 501 "setlengths.cpp"
                    var $52=HEAPU8[($type81)]; //@line 501 "setlengths.cpp"
                    var $conv82=((($52))&255); //@line 501 "setlengths.cpp"
                    var $cmp83=((($conv82))|0)==8; //@line 501 "setlengths.cpp"
                    if (!($cmp83)) { __label__ = 31;break $land_lhs_true80$$if_end91$41; } //@line 501 "setlengths.cpp"
  
                    var $53=$p; //@line 501 "setlengths.cpp"
                    var $ph85=(($53+8)&4294967295); //@line 501 "setlengths.cpp"
                    var $54=HEAP32[(($ph85)>>2)]; //@line 501 "setlengths.cpp"
                    var $phflags86=(($54+4)&4294967295); //@line 501 "setlengths.cpp"
                    var $55=HEAP32[(($phflags86)>>2)]; //@line 501 "setlengths.cpp"
                    var $and87=($55) & 8; //@line 501 "setlengths.cpp"
                    var $tobool88=((($and87))|0)!=0; //@line 501 "setlengths.cpp"
                    if ($tobool88) { __label__ = 31;break $land_lhs_true80$$if_end91$41; } //@line 501 "setlengths.cpp"
  
                    var $56=$p; //@line 502 "setlengths.cpp"
                    var $prepause90=(($56+16)&4294967295); //@line 502 "setlengths.cpp"
                    HEAP8[($prepause90)]=25; //@line 502 "setlengths.cpp"
                    ; //@line 502 "setlengths.cpp"
                  }
                } while(0);
  
                var $57=$prev; //@line 504 "setlengths.cpp"
                var $ph92=(($57+8)&4294967295); //@line 504 "setlengths.cpp"
                var $58=HEAP32[(($ph92)>>2)]; //@line 504 "setlengths.cpp"
                var $phflags93=(($58+4)&4294967295); //@line 504 "setlengths.cpp"
                var $59=HEAP32[(($phflags93)>>2)]; //@line 504 "setlengths.cpp"
                var $and94=($59) & 16384; //@line 504 "setlengths.cpp"
                var $tobool95=((($and94))|0)!=0; //@line 504 "setlengths.cpp"
                if ($tobool95) { __label__ = 32;; } else { __label__ = 33;; } //@line 504 "setlengths.cpp"
                if (__label__ == 32) {
  
                  var $60=$p; //@line 505 "setlengths.cpp"
                  var $prepause97=(($60+16)&4294967295); //@line 505 "setlengths.cpp"
                  HEAP8[($prepause97)]=30; //@line 505 "setlengths.cpp"
                  ; //@line 505 "setlengths.cpp"
                }
  
                var $61=$tr_addr; //@line 507 "setlengths.cpp"
                var $langopts99=(($61)&4294967295); //@line 507 "setlengths.cpp"
                var $word_gap100=(($langopts99)&4294967295); //@line 507 "setlengths.cpp"
                var $62=HEAP32[(($word_gap100)>>2)]; //@line 507 "setlengths.cpp"
                var $and101=($62) & 16; //@line 507 "setlengths.cpp"
                var $tobool102=((($and101))|0)!=0; //@line 507 "setlengths.cpp"
                if ($tobool102) { __label__ = 34;; } else { __label__ = 36;; } //@line 507 "setlengths.cpp"
                $land_lhs_true103$$if_end108$49: do { 
                  if (__label__ == 34) {
  
                    var $63=$p; //@line 507 "setlengths.cpp"
                    var $newword104=(($63+19)&4294967295); //@line 507 "setlengths.cpp"
                    var $64=HEAP8[($newword104)]; //@line 507 "setlengths.cpp"
                    var $tobool105=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 507 "setlengths.cpp"
                    if (!($tobool105)) { __label__ = 36;break $land_lhs_true103$$if_end108$49; } //@line 507 "setlengths.cpp"
  
                    var $65=$p; //@line 508 "setlengths.cpp"
                    var $prepause107=(($65+16)&4294967295); //@line 508 "setlengths.cpp"
                    HEAP8[($prepause107)]=30; //@line 508 "setlengths.cpp"
                    ; //@line 508 "setlengths.cpp"
                  }
                } while(0);
  
                var $66=$p; //@line 510 "setlengths.cpp"
                var $ph109=(($66+8)&4294967295); //@line 510 "setlengths.cpp"
                var $67=HEAP32[(($ph109)>>2)]; //@line 510 "setlengths.cpp"
                var $phflags110=(($67+4)&4294967295); //@line 510 "setlengths.cpp"
                var $68=HEAP32[(($phflags110)>>2)]; //@line 510 "setlengths.cpp"
                var $and111=($68) & 32; //@line 510 "setlengths.cpp"
                var $tobool112=((($and111))|0)!=0; //@line 510 "setlengths.cpp"
                if ($tobool112) { __label__ = 37;; } else { __label__ = 42;; } //@line 510 "setlengths.cpp"
                $land_lhs_true113$$if_else128$53: do { 
                  if (__label__ == 37) {
  
                    var $69=$next; //@line 510 "setlengths.cpp"
                    var $type114=(($69+15)&4294967295); //@line 510 "setlengths.cpp"
                    var $70=HEAPU8[($type114)]; //@line 510 "setlengths.cpp"
                    var $conv115=((($70))&255); //@line 510 "setlengths.cpp"
                    var $cmp116=((($conv115))|0)==4; //@line 510 "setlengths.cpp"
                    if (!($cmp116)) { __label__ = 42;break $land_lhs_true113$$if_else128$53; } //@line 510 "setlengths.cpp"
  
                    var $71=$next; //@line 510 "setlengths.cpp"
                    var $newword118=(($71+19)&4294967295); //@line 510 "setlengths.cpp"
                    var $72=HEAP8[($newword118)]; //@line 510 "setlengths.cpp"
                    var $tobool119=(tempInt=(($72)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 510 "setlengths.cpp"
                    if ($tobool119) { __label__ = 42;break $land_lhs_true113$$if_else128$53; } //@line 510 "setlengths.cpp"
  
                    var $73=$prev; //@line 512 "setlengths.cpp"
                    var $type121=(($73+15)&4294967295); //@line 512 "setlengths.cpp"
                    var $74=HEAPU8[($type121)]; //@line 512 "setlengths.cpp"
                    var $conv122=((($74))&255); //@line 512 "setlengths.cpp"
                    var $cmp123=((($conv122))|0)==2; //@line 512 "setlengths.cpp"
                    var $75=$p; //@line 513 "setlengths.cpp"
                    var $length=(($75+12)&4294967295); //@line 513 "setlengths.cpp"
                    if ($cmp123) { __label__ = 40;; } else { __label__ = 41;; } //@line 512 "setlengths.cpp"
                    if (__label__ == 40) {
  
                      HEAP16[(($length)>>1)]=200; //@line 513 "setlengths.cpp"
                      __label__ = 43;break $land_lhs_true113$$if_else128$53; //@line 513 "setlengths.cpp"
                    }
                    else if (__label__ == 41) {
  
                      HEAP16[(($length)>>1)]=150; //@line 515 "setlengths.cpp"
                      __label__ = 43;break $land_lhs_true113$$if_else128$53;
                    }
                  }
                } while(0);
                if (__label__ == 42) {
  
                  var $76=$p; //@line 518 "setlengths.cpp"
                  var $length129=(($76+12)&4294967295); //@line 518 "setlengths.cpp"
                  HEAP16[(($length129)>>1)]=256; //@line 518 "setlengths.cpp"
                  ;
                }
  
                var $77=$type; //@line 520 "setlengths.cpp"
                var $cmp131=((($77))|0)==7; //@line 520 "setlengths.cpp"
                if (!($cmp131)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 520 "setlengths.cpp"
  
                var $78=$next; //@line 522 "setlengths.cpp"
                var $type133=(($78+15)&4294967295); //@line 522 "setlengths.cpp"
                var $79=HEAPU8[($type133)]; //@line 522 "setlengths.cpp"
                var $conv134=((($79))&255); //@line 522 "setlengths.cpp"
                var $cmp135=((($conv134))|0)==2; //@line 522 "setlengths.cpp"
                if ($cmp135) { __label__ = 45;; } else { __label__ = 46;; } //@line 522 "setlengths.cpp"
                if (__label__ == 45) {
  
                  $pre_voiced=1; //@line 524 "setlengths.cpp"
                  ; //@line 525 "setlengths.cpp"
                }
  
                var $80=$prev; //@line 526 "setlengths.cpp"
                var $type138=(($80+15)&4294967295); //@line 526 "setlengths.cpp"
                var $81=HEAPU8[($type138)]; //@line 526 "setlengths.cpp"
                var $conv139=((($81))&255); //@line 526 "setlengths.cpp"
                var $cmp140=((($conv139))|0)==2; //@line 526 "setlengths.cpp"
                if ($cmp140) { __label__ = 48;; } else { __label__ = 47;; } //@line 526 "setlengths.cpp"
                if (__label__ == 47) {
  
                  var $82=$prev; //@line 526 "setlengths.cpp"
                  var $type142=(($82+15)&4294967295); //@line 526 "setlengths.cpp"
                  var $83=HEAPU8[($type142)]; //@line 526 "setlengths.cpp"
                  var $conv143=((($83))&255); //@line 526 "setlengths.cpp"
                  var $cmp144=((($conv143))|0)==3; //@line 526 "setlengths.cpp"
                  if (!($cmp144)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 526 "setlengths.cpp"
                }
  
                var $84=$prev; //@line 528 "setlengths.cpp"
                var $length146=(($84+12)&4294967295); //@line 528 "setlengths.cpp"
                var $85=HEAP16[(($length146)>>1)]; //@line 528 "setlengths.cpp"
                var $conv147=(tempInt=(($85)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 528 "setlengths.cpp"
                var $add148=((($conv147)+255)&4294967295); //@line 528 "setlengths.cpp"
                var $div=((((($add148))|0)/2)|0); //@line 528 "setlengths.cpp"
                var $conv149=((($div)) & 65535); //@line 528 "setlengths.cpp"
                var $86=$p; //@line 528 "setlengths.cpp"
                var $length150=(($86+12)&4294967295); //@line 528 "setlengths.cpp"
                HEAP16[(($length150)>>1)]=$conv149; //@line 528 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 529 "setlengths.cpp"
              }
              else if (__label__ == 49) {
  
                var $87=$prev; //@line 534 "setlengths.cpp"
                var $type154=(($87+15)&4294967295); //@line 534 "setlengths.cpp"
                var $88=HEAPU8[($type154)]; //@line 534 "setlengths.cpp"
                var $conv155=((($88))&255); //@line 534 "setlengths.cpp"
                var $cmp156=((($conv155))|0)==7; //@line 534 "setlengths.cpp"
                if ($cmp156) { __label__ = 53;; } else { __label__ = 50;; } //@line 534 "setlengths.cpp"
                $if_then170$$lor_lhs_false157$71: do { 
                  if (__label__ == 50) {
  
                    var $89=$prev; //@line 534 "setlengths.cpp"
                    var $type158=(($89+15)&4294967295); //@line 534 "setlengths.cpp"
                    var $90=HEAPU8[($type158)]; //@line 534 "setlengths.cpp"
                    var $conv159=((($90))&255); //@line 534 "setlengths.cpp"
                    var $cmp160=((($conv159))|0)==6; //@line 534 "setlengths.cpp"
                    if ($cmp160) { __label__ = 53;break $if_then170$$lor_lhs_false157$71; } //@line 534 "setlengths.cpp"
  
                    var $91=$prev; //@line 534 "setlengths.cpp"
                    var $ph162=(($91+8)&4294967295); //@line 534 "setlengths.cpp"
                    var $92=HEAP32[(($ph162)>>2)]; //@line 534 "setlengths.cpp"
                    var $phflags163=(($92+4)&4294967295); //@line 534 "setlengths.cpp"
                    var $93=HEAP32[(($phflags163)>>2)]; //@line 534 "setlengths.cpp"
                    var $and164=($93) & 32; //@line 534 "setlengths.cpp"
                    var $tobool165=((($and164))|0)!=0; //@line 534 "setlengths.cpp"
                    if ($tobool165) { __label__ = 53;break $if_then170$$lor_lhs_false157$71; } //@line 534 "setlengths.cpp"
  
                    var $94=$prev; //@line 534 "setlengths.cpp"
                    var $type167=(($94+15)&4294967295); //@line 534 "setlengths.cpp"
                    var $95=HEAPU8[($type167)]; //@line 534 "setlengths.cpp"
                    var $conv168=((($95))&255); //@line 534 "setlengths.cpp"
                    var $cmp169=((($conv168))|0)==3; //@line 534 "setlengths.cpp"
                    if ($cmp169) { __label__ = 53;break $if_then170$$lor_lhs_false157$71; } else { __label__ = 54;break $if_then170$$lor_lhs_false157$71; } //@line 534 "setlengths.cpp"
                  }
                } while(0);
                if (__label__ == 53) {
  
                  var $96=$p; //@line 535 "setlengths.cpp"
                  var $prepause171=(($96+16)&4294967295); //@line 535 "setlengths.cpp"
                  HEAP8[($prepause171)]=30; //@line 535 "setlengths.cpp"
                  ; //@line 535 "setlengths.cpp"
                }
  
                var $97=$next; //@line 537 "setlengths.cpp"
                var $type173=(($97+15)&4294967295); //@line 537 "setlengths.cpp"
                var $98=HEAPU8[($type173)]; //@line 537 "setlengths.cpp"
                var $conv174=((($98))&255); //@line 537 "setlengths.cpp"
                var $cmp175=((($conv174))|0)==2; //@line 537 "setlengths.cpp"
                if ($cmp175) { __label__ = 56;; } else { __label__ = 55;; } //@line 537 "setlengths.cpp"
                $if_then180$$lor_lhs_false176$78: do { 
                  if (__label__ == 55) {
  
                    var $99=$next; //@line 537 "setlengths.cpp"
                    var $type177=(($99+15)&4294967295); //@line 537 "setlengths.cpp"
                    var $100=HEAPU8[($type177)]; //@line 537 "setlengths.cpp"
                    var $conv178=((($100))&255); //@line 537 "setlengths.cpp"
                    var $cmp179=((($conv178))|0)==3; //@line 537 "setlengths.cpp"
                    if ($cmp179) { __label__ = 56;break $if_then180$$lor_lhs_false176$78; } else { __label__ = 70;break $if_then180$$lor_lhs_false176$78; } //@line 537 "setlengths.cpp"
                  }
                } while(0);
                $if_then180$$if_end229$80: do { 
                  if (__label__ == 56) {
  
                    var $101=$next; //@line 539 "setlengths.cpp"
                    var $type181=(($101+15)&4294967295); //@line 539 "setlengths.cpp"
                    var $102=HEAPU8[($type181)]; //@line 539 "setlengths.cpp"
                    var $conv182=((($102))&255); //@line 539 "setlengths.cpp"
                    var $cmp183=((($conv182))|0)==2; //@line 539 "setlengths.cpp"
                    if ($cmp183) { __label__ = 58;; } else { __label__ = 57;; } //@line 539 "setlengths.cpp"
                    $if_then187$$lor_lhs_false184$82: do { 
                      if (__label__ == 57) {
  
                        var $103=$next; //@line 539 "setlengths.cpp"
                        var $newword185=(($103+19)&4294967295); //@line 539 "setlengths.cpp"
                        var $104=HEAP8[($newword185)]; //@line 539 "setlengths.cpp"
                        var $tobool186=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 539 "setlengths.cpp"
                        if ($tobool186) { __label__ = 59;break $if_then187$$lor_lhs_false184$82; } else { __label__ = 58;break $if_then187$$lor_lhs_false184$82; } //@line 539 "setlengths.cpp"
                      }
                    } while(0);
                    if (__label__ == 58) {
  
                      $pre_voiced=1; //@line 540 "setlengths.cpp"
                      ; //@line 540 "setlengths.cpp"
                    }
  
                    var $105=$p; //@line 542 "setlengths.cpp"
                    var $prepause189=(($105+16)&4294967295); //@line 542 "setlengths.cpp"
                    HEAP8[($prepause189)]=40; //@line 542 "setlengths.cpp"
                    var $106=$prev; //@line 544 "setlengths.cpp"
                    var $type190=(($106+15)&4294967295); //@line 544 "setlengths.cpp"
                    var $107=HEAPU8[($type190)]; //@line 544 "setlengths.cpp"
                    var $conv191=((($107))&255); //@line 544 "setlengths.cpp"
                    var $cmp192=((($conv191))|0)==0; //@line 544 "setlengths.cpp"
                    if ($cmp192) { __label__ = 61;; } else { __label__ = 60;; } //@line 544 "setlengths.cpp"
                    $if_then197$$lor_lhs_false193$87: do { 
                      if (__label__ == 60) {
  
                        var $108=$prev; //@line 544 "setlengths.cpp"
                        var $type194=(($108+15)&4294967295); //@line 544 "setlengths.cpp"
                        var $109=HEAPU8[($type194)]; //@line 544 "setlengths.cpp"
                        var $conv195=((($109))&255); //@line 544 "setlengths.cpp"
                        var $cmp196=((($conv195))|0)==2; //@line 544 "setlengths.cpp"
                        if ($cmp196) { __label__ = 61;break $if_then197$$lor_lhs_false193$87; } //@line 544 "setlengths.cpp"
  
                        var $111=$p; //@line 547 "setlengths.cpp"
                        var $newword200=(($111+19)&4294967295); //@line 547 "setlengths.cpp"
                        var $112=HEAPU8[($newword200)]; //@line 547 "setlengths.cpp"
                        var $conv201=((($112))&255); //@line 547 "setlengths.cpp"
                        var $cmp202=((($conv201))|0)==0; //@line 547 "setlengths.cpp"
                        if (!($cmp202)) { __label__ = 70;break $if_then180$$if_end229$80; } //@line 547 "setlengths.cpp"
  
                        var $113=$prev; //@line 549 "setlengths.cpp"
                        var $type204=(($113+15)&4294967295); //@line 549 "setlengths.cpp"
                        var $114=HEAPU8[($type204)]; //@line 549 "setlengths.cpp"
                        var $conv205=((($114))&255); //@line 549 "setlengths.cpp"
                        var $cmp206=((($conv205))|0)==3; //@line 549 "setlengths.cpp"
                        if ($cmp206) { __label__ = 64;; } else { __label__ = 65;; } //@line 549 "setlengths.cpp"
                        if (__label__ == 64) {
  
                          var $115=$p; //@line 550 "setlengths.cpp"
                          var $prepause208=(($115+16)&4294967295); //@line 550 "setlengths.cpp"
                          HEAP8[($prepause208)]=20; //@line 550 "setlengths.cpp"
                          ; //@line 550 "setlengths.cpp"
                        }
  
                        var $116=$prev; //@line 551 "setlengths.cpp"
                        var $type210=(($116+15)&4294967295); //@line 551 "setlengths.cpp"
                        var $117=HEAPU8[($type210)]; //@line 551 "setlengths.cpp"
                        var $conv211=((($117))&255); //@line 551 "setlengths.cpp"
                        var $cmp212=((($conv211))|0)==8; //@line 551 "setlengths.cpp"
                        if ($cmp212) { __label__ = 66;; } else { __label__ = 67;; } //@line 551 "setlengths.cpp"
                        if (__label__ == 66) {
  
                          var $118=$p; //@line 552 "setlengths.cpp"
                          var $prepause214=(($118+16)&4294967295); //@line 552 "setlengths.cpp"
                          HEAP8[($prepause214)]=12; //@line 552 "setlengths.cpp"
                          ; //@line 552 "setlengths.cpp"
                        }
  
                        var $119=$prev; //@line 554 "setlengths.cpp"
                        var $type216=(($119+15)&4294967295); //@line 554 "setlengths.cpp"
                        var $120=HEAPU8[($type216)]; //@line 554 "setlengths.cpp"
                        var $conv217=((($120))&255); //@line 554 "setlengths.cpp"
                        var $cmp218=((($conv217))|0)==4; //@line 554 "setlengths.cpp"
                        if (!($cmp218)) { __label__ = 70;break $if_then180$$if_end229$80; } //@line 554 "setlengths.cpp"
  
                        var $121=$prev; //@line 554 "setlengths.cpp"
                        var $ph220=(($121+8)&4294967295); //@line 554 "setlengths.cpp"
                        var $122=HEAP32[(($ph220)>>2)]; //@line 554 "setlengths.cpp"
                        var $phflags221=(($122+4)&4294967295); //@line 554 "setlengths.cpp"
                        var $123=HEAP32[(($phflags221)>>2)]; //@line 554 "setlengths.cpp"
                        var $and222=($123) & 8; //@line 554 "setlengths.cpp"
                        var $tobool223=((($and222))|0)!=0; //@line 554 "setlengths.cpp"
                        if ($tobool223) { __label__ = 70;break $if_then180$$if_end229$80; } //@line 554 "setlengths.cpp"
  
                        var $124=$p; //@line 555 "setlengths.cpp"
                        var $prepause225=(($124+16)&4294967295); //@line 555 "setlengths.cpp"
                        HEAP8[($prepause225)]=0; //@line 555 "setlengths.cpp"
                        __label__ = 70;break $if_then180$$if_end229$80; //@line 555 "setlengths.cpp"
                      }
                    } while(0);
  
                    var $110=$p; //@line 545 "setlengths.cpp"
                    var $prepause198=(($110+16)&4294967295); //@line 545 "setlengths.cpp"
                    HEAP8[($prepause198)]=0; //@line 545 "setlengths.cpp"
                    ; //@line 545 "setlengths.cpp"
                  }
                } while(0);
  
                var $125=$tr_addr; //@line 558 "setlengths.cpp"
                var $langopts230=(($125)&4294967295); //@line 558 "setlengths.cpp"
                var $word_gap231=(($langopts230)&4294967295); //@line 558 "setlengths.cpp"
                var $126=HEAP32[(($word_gap231)>>2)]; //@line 558 "setlengths.cpp"
                var $and232=($126) & 16; //@line 558 "setlengths.cpp"
                var $tobool233=((($and232))|0)!=0; //@line 558 "setlengths.cpp"
                if (!($tobool233)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 558 "setlengths.cpp"
  
                var $127=$p; //@line 558 "setlengths.cpp"
                var $newword235=(($127+19)&4294967295); //@line 558 "setlengths.cpp"
                var $128=HEAP8[($newword235)]; //@line 558 "setlengths.cpp"
                var $tobool236=(tempInt=(($128)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 558 "setlengths.cpp"
                if (!($tobool236)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 558 "setlengths.cpp"
  
                var $129=$p; //@line 558 "setlengths.cpp"
                var $prepause238=(($129+16)&4294967295); //@line 558 "setlengths.cpp"
                var $130=HEAPU8[($prepause238)]; //@line 558 "setlengths.cpp"
                var $conv239=((($130))&255); //@line 558 "setlengths.cpp"
                var $cmp240=((($conv239))|0) < 20; //@line 558 "setlengths.cpp"
                if (!($cmp240)) { __label__ = 192;break $if_end15_thread$$if_end15$9; } //@line 558 "setlengths.cpp"
  
                var $131=$p; //@line 559 "setlengths.cpp"
                var $prepause242=(($131+16)&4294967295); //@line 559 "setlengths.cpp"
                HEAP8[($prepause242)]=20; //@line 559 "setlengths.cpp"
                __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 559 "setlengths.cpp"
              }
              else if (__label__ == 74) {
  
                var $132=$tr_addr; //@line 565 "setlengths.cpp"
                var $stress_amps=(($132+660)&4294967295); //@line 565 "setlengths.cpp"
                var $arrayidx245=(($stress_amps)&4294967295); //@line 565 "setlengths.cpp"
                var $133=HEAP8[($arrayidx245)]; //@line 565 "setlengths.cpp"
                var $134=$p; //@line 565 "setlengths.cpp"
                var $amp=(($134+18)&4294967295); //@line 565 "setlengths.cpp"
                HEAP8[($amp)]=$133; //@line 565 "setlengths.cpp"
                var $135=$p; //@line 566 "setlengths.cpp"
                var $length246=(($135+12)&4294967295); //@line 566 "setlengths.cpp"
                HEAP16[(($length246)>>1)]=256; //@line 566 "setlengths.cpp"
                $min_drop=0; //@line 567 "setlengths.cpp"
                var $136=$p; //@line 569 "setlengths.cpp"
                var $newword247=(($136+19)&4294967295); //@line 569 "setlengths.cpp"
                var $137=HEAP8[($newword247)]; //@line 569 "setlengths.cpp"
                var $tobool248=(tempInt=(($137)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 569 "setlengths.cpp"
                if ($tobool248) { __label__ = 75;; } else { __label__ = 80;; } //@line 569 "setlengths.cpp"
                $if_then249$$if_end268$105: do { 
                  if (__label__ == 75) {
  
                    var $138=$prev; //@line 571 "setlengths.cpp"
                    var $type250=(($138+15)&4294967295); //@line 571 "setlengths.cpp"
                    var $139=HEAPU8[($type250)]; //@line 571 "setlengths.cpp"
                    var $conv251=((($139))&255); //@line 571 "setlengths.cpp"
                    var $cmp252=((($conv251))|0)==3; //@line 571 "setlengths.cpp"
                    if ($cmp252) { __label__ = 76;; } else { __label__ = 77;; } //@line 571 "setlengths.cpp"
                    if (__label__ == 76) {
  
                      var $140=$p; //@line 572 "setlengths.cpp"
                      var $prepause254=(($140+16)&4294967295); //@line 572 "setlengths.cpp"
                      HEAP8[($prepause254)]=25; //@line 572 "setlengths.cpp"
                      ; //@line 572 "setlengths.cpp"
                    }
  
                    var $141=$prev; //@line 573 "setlengths.cpp"
                    var $type256=(($141+15)&4294967295); //@line 573 "setlengths.cpp"
                    var $142=HEAPU8[($type256)]; //@line 573 "setlengths.cpp"
                    var $conv257=((($142))&255); //@line 573 "setlengths.cpp"
                    var $cmp258=((($conv257))|0)==2; //@line 573 "setlengths.cpp"
                    if (!($cmp258)) { __label__ = 80;break $if_then249$$if_end268$105; } //@line 573 "setlengths.cpp"
  
                    var $143=$p; //@line 575 "setlengths.cpp"
                    var $ph260=(($143+8)&4294967295); //@line 575 "setlengths.cpp"
                    var $144=HEAP32[(($ph260)>>2)]; //@line 575 "setlengths.cpp"
                    var $phflags261=(($144+4)&4294967295); //@line 575 "setlengths.cpp"
                    var $145=HEAP32[(($phflags261)>>2)]; //@line 575 "setlengths.cpp"
                    var $and262=($145) & 16777216; //@line 575 "setlengths.cpp"
                    var $tobool263=((($and262))|0)!=0; //@line 575 "setlengths.cpp"
                    if ($tobool263) { __label__ = 80;break $if_then249$$if_end268$105; } //@line 575 "setlengths.cpp"
  
                    var $146=$p; //@line 576 "setlengths.cpp"
                    var $prepause265=(($146+16)&4294967295); //@line 576 "setlengths.cpp"
                    HEAP8[($prepause265)]=12; //@line 576 "setlengths.cpp"
                    ; //@line 576 "setlengths.cpp"
                  }
                } while(0);
  
                var $147=$next; //@line 580 "setlengths.cpp"
                var $type269=(($147+15)&4294967295); //@line 580 "setlengths.cpp"
                var $148=HEAPU8[($type269)]; //@line 580 "setlengths.cpp"
                var $conv270=((($148))&255); //@line 580 "setlengths.cpp"
                var $cmp271=((($conv270))|0)==2; //@line 580 "setlengths.cpp"
                if ($cmp271) { __label__ = 81;; } else { __label__ = 82;; } //@line 580 "setlengths.cpp"
                if (__label__ == 81) {
  
                  $pre_sonorant=1; //@line 582 "setlengths.cpp"
                  __label__ = 192;break $if_end15_thread$$if_end15$9; //@line 583 "setlengths.cpp"
                }
                else if (__label__ == 82) {
  
                  var $149=$last_pitch; //@line 586 "setlengths.cpp"
                  var $conv274=((($149)) & 255); //@line 586 "setlengths.cpp"
                  var $150=$p; //@line 586 "setlengths.cpp"
                  var $pitch2=(($150+21)&4294967295); //@line 586 "setlengths.cpp"
                  HEAP8[($pitch2)]=$conv274; //@line 586 "setlengths.cpp"
                  var $151=$prev; //@line 588 "setlengths.cpp"
                  var $type275=(($151+15)&4294967295); //@line 588 "setlengths.cpp"
                  var $152=HEAPU8[($type275)]; //@line 588 "setlengths.cpp"
                  var $conv276=((($152))&255); //@line 588 "setlengths.cpp"
                  var $cmp277=((($conv276))|0)==2; //@line 588 "setlengths.cpp"
                  if ($cmp277) { __label__ = 84;; } else { __label__ = 83;; } //@line 588 "setlengths.cpp"
                  $if_then282$$lor_lhs_false278$116: do { 
                    if (__label__ == 83) {
  
                      var $153=$prev; //@line 588 "setlengths.cpp"
                      var $type279=(($153+15)&4294967295); //@line 588 "setlengths.cpp"
                      var $154=HEAPU8[($type279)]; //@line 588 "setlengths.cpp"
                      var $conv280=((($154))&255); //@line 588 "setlengths.cpp"
                      var $cmp281=((($conv280))|0)==3; //@line 588 "setlengths.cpp"
                      if ($cmp281) { __label__ = 84;break $if_then282$$lor_lhs_false278$116; } //@line 588 "setlengths.cpp"
  
                      var $172=$ix; //@line 608 "setlengths.cpp"
                      $ix2=$172; //@line 608 "setlengths.cpp"
                      ; //@line 608 "setlengths.cpp"
                      while(1) { 
  
                        var $173=$ix2; //@line 608 "setlengths.cpp"
                        var $174=HEAP32[((_n_phoneme_list)>>2)]; //@line 608 "setlengths.cpp"
                        var $cmp315=((($173))|0) < ((($174))|0); //@line 608 "setlengths.cpp"
                        if (!($cmp315)) { __label__ = 95;break $if_then282$$lor_lhs_false278$116; } //@line 608 "setlengths.cpp"
  
                        var $175=$ix2; //@line 610 "setlengths.cpp"
                        var $arrayidx317=((_phoneme_list+$175*24)&4294967295); //@line 610 "setlengths.cpp"
                        var $type318=(($arrayidx317+15)&4294967295); //@line 610 "setlengths.cpp"
                        var $176=HEAPU8[($type318)]; //@line 610 "setlengths.cpp"
                        var $conv319=((($176))&255); //@line 610 "setlengths.cpp"
                        var $cmp320=((($conv319))|0)==2; //@line 610 "setlengths.cpp"
                        var $177=$ix2; //@line 612 "setlengths.cpp"
                        if ($cmp320) { __label__ = 93;break ; } //@line 610 "setlengths.cpp"
  
                        var $inc=((($177)+1)&4294967295); //@line 608 "setlengths.cpp"
                        $ix2=$inc; //@line 608 "setlengths.cpp"
                        __label__ = 91;continue ; //@line 608 "setlengths.cpp"
                      }
  
                      var $arrayidx322=((_phoneme_list+$177*24)&4294967295); //@line 612 "setlengths.cpp"
                      var $pitch2323=(($arrayidx322+21)&4294967295); //@line 612 "setlengths.cpp"
                      var $178=HEAP8[($pitch2323)]; //@line 612 "setlengths.cpp"
                      var $179=$p; //@line 612 "setlengths.cpp"
                      var $pitch2324=(($179+21)&4294967295); //@line 612 "setlengths.cpp"
                      HEAP8[($pitch2324)]=$178; //@line 612 "setlengths.cpp"
                      __label__ = 95;break $if_then282$$lor_lhs_false278$116; //@line 613 "setlengths.cpp"
                    }
                  } while(0);
                  $if_then282$$if_end326$124: do { 
                    if (__label__ == 84) {
  
                      var $155=$prev; //@line 590 "setlengths.cpp"
                      var $length283=(($155+12)&4294967295); //@line 590 "setlengths.cpp"
                      var $156=HEAP16[(($length283)>>1)]; //@line 590 "setlengths.cpp"
                      var $157=$p; //@line 590 "setlengths.cpp"
                      var $length284=(($157+12)&4294967295); //@line 590 "setlengths.cpp"
                      HEAP16[(($length284)>>1)]=$156; //@line 590 "setlengths.cpp"
                      var $158=$p; //@line 592 "setlengths.cpp"
                      var $type285=(($158+15)&4294967295); //@line 592 "setlengths.cpp"
                      var $159=HEAPU8[($type285)]; //@line 592 "setlengths.cpp"
                      var $conv286=((($159))&255); //@line 592 "setlengths.cpp"
                      var $cmp287=((($conv286))|0)==3; //@line 592 "setlengths.cpp"
                      if ($cmp287) { __label__ = 85;; } else { __label__ = 86;; } //@line 592 "setlengths.cpp"
                      if (__label__ == 85) {
  
                        var $160=HEAP32[((__ZL6speed1)>>2)]; //@line 594 "setlengths.cpp"
                        var $conv289=((($160)) & 65535); //@line 594 "setlengths.cpp"
                        var $161=$p; //@line 594 "setlengths.cpp"
                        var $length290=(($161+12)&4294967295); //@line 594 "setlengths.cpp"
                        HEAP16[(($length290)>>1)]=$conv289; //@line 594 "setlengths.cpp"
                        ; //@line 595 "setlengths.cpp"
                      }
  
                      var $162=$next; //@line 597 "setlengths.cpp"
                      var $type292=(($162+15)&4294967295); //@line 597 "setlengths.cpp"
                      var $163=HEAPU8[($type292)]; //@line 597 "setlengths.cpp"
                      var $conv293=((($163))&255); //@line 597 "setlengths.cpp"
                      var $cmp294=((($conv293))|0)==5; //@line 597 "setlengths.cpp"
                      if ($cmp294) { __label__ = 87;; } else { __label__ = 88;; } //@line 597 "setlengths.cpp"
                      if (__label__ == 87) {
  
                        var $164=$p; //@line 599 "setlengths.cpp"
                        var $length296=(($164+12)&4294967295); //@line 599 "setlengths.cpp"
                        var $165=HEAP16[(($length296)>>1)]; //@line 599 "setlengths.cpp"
                        var $conv297=(tempInt=(($165)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 599 "setlengths.cpp"
                        var $mul=((($conv297)*160)&4294967295); //@line 599 "setlengths.cpp"
                        var $div298=((((($mul))|0)/100)|0); //@line 599 "setlengths.cpp"
                        var $conv299=((($div298)) & 65535); //@line 599 "setlengths.cpp"
                        var $166=$p; //@line 599 "setlengths.cpp"
                        var $length300=(($166+12)&4294967295); //@line 599 "setlengths.cpp"
                        HEAP16[(($length300)>>1)]=$conv299; //@line 599 "setlengths.cpp"
                        ; //@line 600 "setlengths.cpp"
                      }
  
                      var $167=$next; //@line 601 "setlengths.cpp"
                      var $type302=(($167+15)&4294967295); //@line 601 "setlengths.cpp"
                      var $168=HEAPU8[($type302)]; //@line 601 "setlengths.cpp"
                      var $conv303=((($168))&255); //@line 601 "setlengths.cpp"
                      var $cmp304=((($conv303))|0)==7; //@line 601 "setlengths.cpp"
                      if (!($cmp304)) { __label__ = 95;break $if_then282$$if_end326$124; } //@line 601 "setlengths.cpp"
  
                      var $169=$p; //@line 603 "setlengths.cpp"
                      var $length306=(($169+12)&4294967295); //@line 603 "setlengths.cpp"
                      var $170=HEAP16[(($length306)>>1)]; //@line 603 "setlengths.cpp"
                      var $conv307=(tempInt=(($170)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 603 "setlengths.cpp"
                      var $mul308=((($conv307)*120)&4294967295); //@line 603 "setlengths.cpp"
                      var $div309=((((($mul308))|0)/100)|0); //@line 603 "setlengths.cpp"
                      var $conv310=((($div309)) & 65535); //@line 603 "setlengths.cpp"
                      var $171=$p; //@line 603 "setlengths.cpp"
                      var $length311=(($171+12)&4294967295); //@line 603 "setlengths.cpp"
                      HEAP16[(($length311)>>1)]=$conv310; //@line 603 "setlengths.cpp"
                      ; //@line 604 "setlengths.cpp"
                    }
                  } while(0);
  
                  var $180=$p; //@line 618 "setlengths.cpp"
                  var $pitch2327=(($180+21)&4294967295); //@line 618 "setlengths.cpp"
                  var $181=HEAPU8[($pitch2327)]; //@line 618 "setlengths.cpp"
                  var $conv328=((($181))&255); //@line 618 "setlengths.cpp"
                  var $sub329=((($conv328)-16)&4294967295); //@line 618 "setlengths.cpp"
                  var $conv330=((($sub329)) & 255); //@line 618 "setlengths.cpp"
                  var $182=$p; //@line 618 "setlengths.cpp"
                  var $pitch1331=(($182+20)&4294967295); //@line 618 "setlengths.cpp"
                  HEAP8[($pitch1331)]=$conv330; //@line 618 "setlengths.cpp"
                  var $183=$p; //@line 619 "setlengths.cpp"
                  var $pitch2332=(($183+21)&4294967295); //@line 619 "setlengths.cpp"
                  var $184=HEAPU8[($pitch2332)]; //@line 619 "setlengths.cpp"
                  var $conv333=((($184))&255); //@line 619 "setlengths.cpp"
                  var $cmp334=((($conv333))|0) < 16; //@line 619 "setlengths.cpp"
                  if ($cmp334) { __label__ = 96;; } else { __label__ = 97;; } //@line 619 "setlengths.cpp"
                  if (__label__ == 96) {
  
                    var $185=$p; //@line 621 "setlengths.cpp"
                    var $pitch1336=(($185+20)&4294967295); //@line 621 "setlengths.cpp"
                    HEAP8[($pitch1336)]=0; //@line 621 "setlengths.cpp"
                    ; //@line 622 "setlengths.cpp"
                  }
  
                  var $186=$p; //@line 623 "setlengths.cpp"
                  var $env=(($186+14)&4294967295); //@line 623 "setlengths.cpp"
                  HEAP8[($env)]=0; //@line 623 "setlengths.cpp"
                  $pre_voiced=0; //@line 624 "setlengths.cpp"
                  __label__ = 192;break $if_end15_thread$$if_end15$9;
                }
              }
            }
          } while(0);
          if (__label__ == 98) {
  
            $min_drop=0; //@line 629 "setlengths.cpp"
            var $187=$ix; //@line 630 "setlengths.cpp"
            var $add340=((($187)+2)&4294967295); //@line 630 "setlengths.cpp"
            var $arrayidx341=((_phoneme_list+$add340*24)&4294967295); //@line 630 "setlengths.cpp"
            $next2=$arrayidx341; //@line 630 "setlengths.cpp"
            var $188=$ix; //@line 631 "setlengths.cpp"
            var $add342=((($188)+3)&4294967295); //@line 631 "setlengths.cpp"
            var $arrayidx343=((_phoneme_list+$add342*24)&4294967295); //@line 631 "setlengths.cpp"
            $next3=$arrayidx343; //@line 631 "setlengths.cpp"
            var $189=$stress; //@line 633 "setlengths.cpp"
            var $cmp344=((($189))|0) > 7; //@line 633 "setlengths.cpp"
            if ($cmp344) { __label__ = 99;; } else { __label__ = 100;; } //@line 633 "setlengths.cpp"
            $if_end346_thread$$if_end346$139: do { 
              if (__label__ == 99) {
  
                $stress=7; //@line 633 "setlengths.cpp"
                ; //@line 635 "setlengths.cpp"
              }
              else if (__label__ == 100) {
  
                var $cmp347=((($189))|0) <= 1; //@line 635 "setlengths.cpp"
                if (!($cmp347)) { __label__ = 102;break $if_end346_thread$$if_end346$139; } //@line 635 "setlengths.cpp"
  
                var $190=$stress; //@line 637 "setlengths.cpp"
                var $xor=($190) ^ 1; //@line 637 "setlengths.cpp"
                $stress=$xor; //@line 637 "setlengths.cpp"
                ; //@line 638 "setlengths.cpp"
              }
            } while(0);
  
            var $191=$pre_sonorant; //@line 639 "setlengths.cpp"
            var $tobool350=((($191))|0)!=0; //@line 639 "setlengths.cpp"
            var $192=$stress; //@line 640 "setlengths.cpp"
            var $193=$tr_addr; //@line 640 "setlengths.cpp"
            var $stress_amps352=(($193+660)&4294967295); //@line 640 "setlengths.cpp"
            var $arrayidx353=(($stress_amps352+$192)&4294967295); //@line 640 "setlengths.cpp"
            var $194=HEAPU8[($arrayidx353)]; //@line 640 "setlengths.cpp"
            if ($tobool350) { __label__ = 103;; } else { __label__ = 104;; } //@line 639 "setlengths.cpp"
            if (__label__ == 103) {
  
              var $conv354=((($194))&255); //@line 640 "setlengths.cpp"
              var $sub355=((($conv354)-1)&4294967295); //@line 640 "setlengths.cpp"
              var $conv356=((($sub355)) & 255); //@line 640 "setlengths.cpp"
              var $195=$p; //@line 640 "setlengths.cpp"
              var $amp357=(($195+18)&4294967295); //@line 640 "setlengths.cpp"
              HEAP8[($amp357)]=$conv356; //@line 640 "setlengths.cpp"
              ; //@line 640 "setlengths.cpp"
            }
            else if (__label__ == 104) {
  
              var $196=$p; //@line 642 "setlengths.cpp"
              var $amp361=(($196+18)&4294967295); //@line 642 "setlengths.cpp"
              HEAP8[($amp361)]=$194; //@line 642 "setlengths.cpp"
              ;
            }
  
            var $197=$emphasized; //@line 644 "setlengths.cpp"
            var $tobool363=((($197))|0)!=0; //@line 644 "setlengths.cpp"
            if ($tobool363) { __label__ = 106;; } else { __label__ = 107;; } //@line 644 "setlengths.cpp"
            if (__label__ == 106) {
  
              var $198=$p; //@line 645 "setlengths.cpp"
              var $amp365=(($198+18)&4294967295); //@line 645 "setlengths.cpp"
              HEAP8[($amp365)]=25; //@line 645 "setlengths.cpp"
              ; //@line 645 "setlengths.cpp"
            }
  
            var $199=$ix; //@line 647 "setlengths.cpp"
            var $200=HEAP32[((_n_phoneme_list)>>2)]; //@line 647 "setlengths.cpp"
            var $sub367=((($200)-3)&4294967295); //@line 647 "setlengths.cpp"
            var $cmp368=((($199))|0) >= ((($sub367))|0); //@line 647 "setlengths.cpp"
            if ($cmp368) { __label__ = 108;; } else { __label__ = 110;; } //@line 647 "setlengths.cpp"
            $if_then369$$if_end382$151: do { 
              if (__label__ == 108) {
  
                var $201=$p; //@line 650 "setlengths.cpp"
                var $amp370=(($201+18)&4294967295); //@line 650 "setlengths.cpp"
                var $202=HEAPU8[($amp370)]; //@line 650 "setlengths.cpp"
                var $conv371=((($202))&255); //@line 650 "setlengths.cpp"
                var $203=$tr_addr; //@line 650 "setlengths.cpp"
                var $langopts372=(($203)&4294967295); //@line 650 "setlengths.cpp"
                var $param=(($langopts372+24)&4294967295); //@line 650 "setlengths.cpp"
                var $arrayidx373=(($param+36)&4294967295); //@line 650 "setlengths.cpp"
                var $204=HEAP32[(($arrayidx373)>>2)]; //@line 650 "setlengths.cpp"
                var $cmp374=((($conv371))|0) > ((($204))|0); //@line 650 "setlengths.cpp"
                if (!($cmp374)) { __label__ = 110;break $if_then369$$if_end382$151; } //@line 650 "setlengths.cpp"
  
                var $205=$tr_addr; //@line 651 "setlengths.cpp"
                var $langopts376=(($205)&4294967295); //@line 651 "setlengths.cpp"
                var $param377=(($langopts376+24)&4294967295); //@line 651 "setlengths.cpp"
                var $arrayidx378=(($param377+36)&4294967295); //@line 651 "setlengths.cpp"
                var $206=HEAP32[(($arrayidx378)>>2)]; //@line 651 "setlengths.cpp"
                var $conv379=((($206)) & 255); //@line 651 "setlengths.cpp"
                var $207=$p; //@line 651 "setlengths.cpp"
                var $amp380=(($207+18)&4294967295); //@line 651 "setlengths.cpp"
                HEAP8[($amp380)]=$conv379; //@line 651 "setlengths.cpp"
                ; //@line 651 "setlengths.cpp"
              }
            } while(0);
  
            HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]=0; //@line 655 "setlengths.cpp"
            $end_of_clause=0; //@line 656 "setlengths.cpp"
            var $208=$p; //@line 657 "setlengths.cpp"
            var $add_ptr=(($208+24)&4294967295); //@line 657 "setlengths.cpp"
            $p2=$add_ptr; //@line 657 "setlengths.cpp"
            var $209=$p2; //@line 657 "setlengths.cpp"
            var $newword3843=(($209+19)&4294967295); //@line 657 "setlengths.cpp"
            var $210=HEAPU8[($newword3843)]; //@line 657 "setlengths.cpp"
            var $conv3854=((($210))&255); //@line 657 "setlengths.cpp"
            var $cmp3865=((($conv3854))|0)==0; //@line 657 "setlengths.cpp"
            var $211=$p2; //@line 659 "setlengths.cpp"
            if ($cmp3865) { __lastLabel__ = 110; __label__ = 111;; } else { __lastLabel__ = 110; __label__ = 117;; } //@line 657 "setlengths.cpp"
            $for_body387$$for_end405$155: do { 
              if (__label__ == 111) {
                $for_body387$156: while(1) { 
  
                  var $212=__lastLabel__ == 116 ? $224 : ($211);
                  var $type388=(($212+15)&4294967295); //@line 659 "setlengths.cpp"
                  var $213=HEAPU8[($type388)]; //@line 659 "setlengths.cpp"
                  var $conv389=((($213))&255); //@line 659 "setlengths.cpp"
                  var $cmp390=((($conv389))|0)==2; //@line 659 "setlengths.cpp"
                  if ($cmp390) { __label__ = 112;; } else { __label__ = 114;; } //@line 659 "setlengths.cpp"
                  $land_lhs_true391$$if_end398$158: do { 
                    if (__label__ == 112) {
  
                      var $214=$p2; //@line 659 "setlengths.cpp"
                      var $ph392=(($214+8)&4294967295); //@line 659 "setlengths.cpp"
                      var $215=HEAP32[(($ph392)>>2)]; //@line 659 "setlengths.cpp"
                      var $phflags393=(($215+4)&4294967295); //@line 659 "setlengths.cpp"
                      var $216=HEAP32[(($phflags393)>>2)]; //@line 659 "setlengths.cpp"
                      var $and394=($216) & 1048576; //@line 659 "setlengths.cpp"
                      var $tobool395=((($and394))|0)!=0; //@line 659 "setlengths.cpp"
                      if ($tobool395) { __label__ = 114;break $land_lhs_true391$$if_end398$158; } //@line 659 "setlengths.cpp"
  
                      var $217=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 660 "setlengths.cpp"
                      var $inc397=((($217)+1)&4294967295); //@line 660 "setlengths.cpp"
                      HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]=$inc397; //@line 660 "setlengths.cpp"
                      ; //@line 660 "setlengths.cpp"
                    }
                  } while(0);
  
                  var $218=$p2; //@line 662 "setlengths.cpp"
                  var $ph399=(($218+8)&4294967295); //@line 662 "setlengths.cpp"
                  var $219=HEAP32[(($ph399)>>2)]; //@line 662 "setlengths.cpp"
                  var $code=(($219+10)&4294967295); //@line 662 "setlengths.cpp"
                  var $220=HEAPU8[($code)]; //@line 662 "setlengths.cpp"
                  var $conv400=((($220))&255); //@line 662 "setlengths.cpp"
                  var $cmp401=((($conv400))|0)==27; //@line 662 "setlengths.cpp"
                  if ($cmp401) { __label__ = 115;; } else { __label__ = 116;; } //@line 662 "setlengths.cpp"
                  if (__label__ == 115) {
  
                    $end_of_clause=2; //@line 663 "setlengths.cpp"
                    ; //@line 663 "setlengths.cpp"
                  }
  
                  var $221=$p2; //@line 657 "setlengths.cpp"
                  var $incdec_ptr=(($221+24)&4294967295); //@line 657 "setlengths.cpp"
                  $p2=$incdec_ptr; //@line 657 "setlengths.cpp"
                  var $222=$p2; //@line 657 "setlengths.cpp"
                  var $newword384=(($222+19)&4294967295); //@line 657 "setlengths.cpp"
                  var $223=HEAPU8[($newword384)]; //@line 657 "setlengths.cpp"
                  var $conv385=((($223))&255); //@line 657 "setlengths.cpp"
                  var $cmp386=((($conv385))|0)==0; //@line 657 "setlengths.cpp"
                  var $224=$p2; //@line 659 "setlengths.cpp"
                  if ($cmp386) { __lastLabel__ = 116; __label__ = 111;continue $for_body387$156; } else { __lastLabel__ = 116; __label__ = 117;break $for_body387$$for_end405$155; } //@line 657 "setlengths.cpp"
                }
              }
            } while(0);
  
            var $_lcssa=__lastLabel__ == 110 ? $211 : ($224);
            var $ph406=(($_lcssa+8)&4294967295); //@line 665 "setlengths.cpp"
            var $225=HEAP32[(($ph406)>>2)]; //@line 665 "setlengths.cpp"
            var $code407=(($225+10)&4294967295); //@line 665 "setlengths.cpp"
            var $226=HEAPU8[($code407)]; //@line 665 "setlengths.cpp"
            var $conv408=((($226))&255); //@line 665 "setlengths.cpp"
            var $cmp409=((($conv408))|0)==27; //@line 665 "setlengths.cpp"
            if ($cmp409) { __label__ = 118;; } else { __label__ = 119;; } //@line 665 "setlengths.cpp"
            if (__label__ == 118) {
  
              $end_of_clause=2; //@line 666 "setlengths.cpp"
              ; //@line 666 "setlengths.cpp"
            }
  
            var $227=$p2; //@line 668 "setlengths.cpp"
            var $newword412=(($227+19)&4294967295); //@line 668 "setlengths.cpp"
            var $228=HEAPU8[($newword412)]; //@line 668 "setlengths.cpp"
            var $conv413=((($228))&255); //@line 668 "setlengths.cpp"
            var $and414=($conv413) & 2; //@line 668 "setlengths.cpp"
            var $tobool415=((($and414))|0)!=0; //@line 668 "setlengths.cpp"
            var $229=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 668 "setlengths.cpp"
            var $cmp417=((($229))|0)==0; //@line 668 "setlengths.cpp"
            var $or_cond=($tobool415) & ($cmp417); //@line 668 "setlengths.cpp"
            if ($or_cond) { __label__ = 120;; } else { __label__ = 121;; } //@line 668 "setlengths.cpp"
            if (__label__ == 120) {
  
              $end_of_clause=2; //@line 670 "setlengths.cpp"
              ; //@line 671 "setlengths.cpp"
            }
  
            var $230=$next; //@line 674 "setlengths.cpp"
            var $ph420=(($230+8)&4294967295); //@line 674 "setlengths.cpp"
            var $231=HEAP32[(($ph420)>>2)]; //@line 674 "setlengths.cpp"
            var $code421=(($231+10)&4294967295); //@line 674 "setlengths.cpp"
            var $232=HEAPU8[($code421)]; //@line 674 "setlengths.cpp"
            var $conv422=((($232))&255); //@line 674 "setlengths.cpp"
            var $cmp423=((($conv422))|0)==23; //@line 674 "setlengths.cpp"
            if ($cmp423) { __label__ = 122;; } else { __label__ = 124;; } //@line 674 "setlengths.cpp"
            $land_lhs_true424$$if_end431$172: do { 
              if (__label__ == 122) {
  
                var $233=$next2; //@line 674 "setlengths.cpp"
                var $type425=(($233+15)&4294967295); //@line 674 "setlengths.cpp"
                var $234=HEAPU8[($type425)]; //@line 674 "setlengths.cpp"
                var $conv426=((($234))&255); //@line 674 "setlengths.cpp"
                var $cmp427=((($conv426))|0)==0; //@line 674 "setlengths.cpp"
                if (!($cmp427)) { __label__ = 124;break $land_lhs_true424$$if_end431$172; } //@line 674 "setlengths.cpp"
  
                var $235=$next2; //@line 677 "setlengths.cpp"
                $next=$235; //@line 677 "setlengths.cpp"
                var $236=$next3; //@line 678 "setlengths.cpp"
                $next2=$236; //@line 678 "setlengths.cpp"
                var $237=$ix; //@line 679 "setlengths.cpp"
                var $add429=((($237)+4)&4294967295); //@line 679 "setlengths.cpp"
                var $arrayidx430=((_phoneme_list+$add429*24)&4294967295); //@line 679 "setlengths.cpp"
                $next3=$arrayidx430; //@line 679 "setlengths.cpp"
                ; //@line 680 "setlengths.cpp"
              }
            } while(0);
  
            var $238=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 682 "setlengths.cpp"
            var $cmp432=((($238))|0)==0; //@line 682 "setlengths.cpp"
            var $239=$next2; //@line 684 "setlengths.cpp"
            var $ph434=(($239+8)&4294967295); //@line 684 "setlengths.cpp"
            var $240=HEAP32[(($ph434)>>2)]; //@line 684 "setlengths.cpp"
            var $length_mod435=(($240+15)&4294967295); //@line 684 "setlengths.cpp"
            var $241=HEAPU8[($length_mod435)]; //@line 684 "setlengths.cpp"
            var $conv436=((($241))&255); //@line 684 "setlengths.cpp"
            var $mul437=((($conv436)*10)&4294967295); //@line 684 "setlengths.cpp"
            var $242=$next; //@line 684 "setlengths.cpp"
            var $ph438=(($242+8)&4294967295); //@line 684 "setlengths.cpp"
            var $243=HEAP32[(($ph438)>>2)]; //@line 684 "setlengths.cpp"
            var $length_mod439=(($243+15)&4294967295); //@line 684 "setlengths.cpp"
            var $244=HEAPU8[($length_mod439)]; //@line 684 "setlengths.cpp"
            var $conv440=((($244))&255); //@line 684 "setlengths.cpp"
            var $add441=((($conv440)+($mul437))&4294967295); //@line 684 "setlengths.cpp"
            var $245=$tr_addr; //@line 684 "setlengths.cpp"
            var $langopts442=(($245)&4294967295); //@line 684 "setlengths.cpp"
            if ($cmp432) { __label__ = 125;; } else { __label__ = 129;; } //@line 682 "setlengths.cpp"
            $if_then433$$if_else466$176: do { 
              if (__label__ == 125) {
  
                var $length_mods0=(($langopts442+180)&4294967295); //@line 684 "setlengths.cpp"
                var $246=HEAP32[(($length_mods0)>>2)]; //@line 684 "setlengths.cpp"
                var $arrayidx443=(($246+$add441)&4294967295); //@line 684 "setlengths.cpp"
                var $247=HEAPU8[($arrayidx443)]; //@line 684 "setlengths.cpp"
                var $conv444=((($247))&255); //@line 684 "setlengths.cpp"
                $len=$conv444; //@line 684 "setlengths.cpp"
                var $248=$next; //@line 686 "setlengths.cpp"
                var $newword445=(($248+19)&4294967295); //@line 686 "setlengths.cpp"
                var $249=HEAP8[($newword445)]; //@line 686 "setlengths.cpp"
                var $tobool446=(tempInt=(($249)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 686 "setlengths.cpp"
                if ($tobool446) { __label__ = 126;; } else { __label__ = 128;; } //@line 686 "setlengths.cpp"
                $land_lhs_true447$$if_else464$178: do { 
                  if (__label__ == 126) {
  
                    var $250=$tr_addr; //@line 686 "setlengths.cpp"
                    var $langopts448=(($250)&4294967295); //@line 686 "setlengths.cpp"
                    var $word_gap449=(($langopts448)&4294967295); //@line 686 "setlengths.cpp"
                    var $251=HEAP32[(($word_gap449)>>2)]; //@line 686 "setlengths.cpp"
                    var $and450=($251) & 32; //@line 686 "setlengths.cpp"
                    var $tobool451=((($and450))|0)!=0; //@line 686 "setlengths.cpp"
                    if (!($tobool451)) { __label__ = 128;break $land_lhs_true447$$if_else464$178; } //@line 686 "setlengths.cpp"
  
                    var $252=$len; //@line 689 "setlengths.cpp"
                    var $253=$next; //@line 689 "setlengths.cpp"
                    var $ph453=(($253+8)&4294967295); //@line 689 "setlengths.cpp"
                    var $254=HEAP32[(($ph453)>>2)]; //@line 689 "setlengths.cpp"
                    var $length_mod454=(($254+15)&4294967295); //@line 689 "setlengths.cpp"
                    var $255=HEAPU8[($length_mod454)]; //@line 689 "setlengths.cpp"
                    var $conv455=((($255))&255); //@line 689 "setlengths.cpp"
                    var $mul456=((($conv455)*10)&4294967295); //@line 689 "setlengths.cpp"
                    var $add457=((($mul456)+1)&4294967295); //@line 689 "setlengths.cpp"
                    var $256=$tr_addr; //@line 689 "setlengths.cpp"
                    var $langopts458=(($256)&4294967295); //@line 689 "setlengths.cpp"
                    var $length_mods0459=(($langopts458+180)&4294967295); //@line 689 "setlengths.cpp"
                    var $257=HEAP32[(($length_mods0459)>>2)]; //@line 689 "setlengths.cpp"
                    var $arrayidx460=(($257+$add457)&4294967295); //@line 689 "setlengths.cpp"
                    var $258=HEAPU8[($arrayidx460)]; //@line 689 "setlengths.cpp"
                    var $conv461=((($258))&255); //@line 689 "setlengths.cpp"
                    var $add462=((($conv461)+($252))&4294967295); //@line 689 "setlengths.cpp"
                    var $div463=((((($add462))|0)/2)|0); //@line 689 "setlengths.cpp"
                    $length_mod=$div463; //@line 689 "setlengths.cpp"
                    __label__ = 134;break $if_then433$$if_else466$176; //@line 690 "setlengths.cpp"
                  }
                } while(0);
  
                var $259=$len; //@line 692 "setlengths.cpp"
                $length_mod=$259; //@line 692 "setlengths.cpp"
                ;
              }
              else if (__label__ == 129) {
  
                var $length_mods=(($langopts442+176)&4294967295); //@line 696 "setlengths.cpp"
                var $260=HEAP32[(($length_mods)>>2)]; //@line 696 "setlengths.cpp"
                var $arrayidx476=(($260+$add441)&4294967295); //@line 696 "setlengths.cpp"
                var $261=HEAPU8[($arrayidx476)]; //@line 696 "setlengths.cpp"
                var $conv477=((($261))&255); //@line 696 "setlengths.cpp"
                $length_mod=$conv477; //@line 696 "setlengths.cpp"
                var $262=$next; //@line 698 "setlengths.cpp"
                var $type478=(($262+15)&4294967295); //@line 698 "setlengths.cpp"
                var $263=HEAPU8[($type478)]; //@line 698 "setlengths.cpp"
                var $conv479=((($263))&255); //@line 698 "setlengths.cpp"
                var $cmp480=((($conv479))|0)==8; //@line 698 "setlengths.cpp"
                if (!($cmp480)) { __label__ = 134;break $if_then433$$if_else466$176; } //@line 698 "setlengths.cpp"
  
                var $264=$next2; //@line 698 "setlengths.cpp"
                var $type482=(($264+15)&4294967295); //@line 698 "setlengths.cpp"
                var $265=HEAPU8[($type482)]; //@line 698 "setlengths.cpp"
                var $conv483=((($265))&255); //@line 698 "setlengths.cpp"
                var $cmp484=((($conv483))|0)==4; //@line 698 "setlengths.cpp"
                if ($cmp484) { __label__ = 132;; } else { __label__ = 131;; } //@line 698 "setlengths.cpp"
                if (__label__ == 131) {
  
                  var $266=$next2; //@line 698 "setlengths.cpp"
                  var $type486=(($266+15)&4294967295); //@line 698 "setlengths.cpp"
                  var $267=HEAPU8[($type486)]; //@line 698 "setlengths.cpp"
                  var $conv487=((($267))&255); //@line 698 "setlengths.cpp"
                  var $cmp488=((($conv487))|0)==5; //@line 698 "setlengths.cpp"
                  if (!($cmp488)) { __label__ = 134;break $if_then433$$if_else466$176; } //@line 698 "setlengths.cpp"
                }
  
                var $268=$next3; //@line 698 "setlengths.cpp"
                var $ph490=(($268+8)&4294967295); //@line 698 "setlengths.cpp"
                var $269=HEAP32[(($ph490)>>2)]; //@line 698 "setlengths.cpp"
                var $phflags491=(($269+4)&4294967295); //@line 698 "setlengths.cpp"
                var $270=HEAP32[(($phflags491)>>2)]; //@line 698 "setlengths.cpp"
                var $and492=($270) & 8; //@line 698 "setlengths.cpp"
                var $tobool493=((($and492))|0)!=0; //@line 698 "setlengths.cpp"
                if (!($tobool493)) { __label__ = 134;break $if_then433$$if_else466$176; } //@line 698 "setlengths.cpp"
  
                var $271=$length_mod; //@line 699 "setlengths.cpp"
                var $sub495=((($271)-15)&4294967295); //@line 699 "setlengths.cpp"
                $length_mod=$sub495; //@line 699 "setlengths.cpp"
                ; //@line 699 "setlengths.cpp"
              }
            } while(0);
  
            var $272=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 702 "setlengths.cpp"
            var $cmp498=((($272))|0)==0; //@line 702 "setlengths.cpp"
            if ($cmp498) { __label__ = 135;; } else { __label__ = 136;; } //@line 702 "setlengths.cpp"
            if (__label__ == 135) {
  
              var $273=HEAP32[((__ZL6speed1)>>2)]; //@line 703 "setlengths.cpp"
              var $274=$length_mod; //@line 703 "setlengths.cpp"
              var $mul500=((($274)*($273))&4294967295); //@line 703 "setlengths.cpp"
              $length_mod=$mul500; //@line 703 "setlengths.cpp"
              ; //@line 703 "setlengths.cpp"
            }
            else if (__label__ == 136) {
  
              var $275=HEAP32[((__ZZ11CalcLengthsP10TranslatorE14more_syllables)>>2)]; //@line 705 "setlengths.cpp"
              var $cmp502=((($275))|0)==1; //@line 705 "setlengths.cpp"
              if ($cmp502) { __label__ = 137;; } else { __label__ = 138;; } //@line 705 "setlengths.cpp"
              if (__label__ == 137) {
  
                var $276=HEAP32[((__ZL6speed2)>>2)]; //@line 706 "setlengths.cpp"
                var $277=$length_mod; //@line 706 "setlengths.cpp"
                var $mul504=((($277)*($276))&4294967295); //@line 706 "setlengths.cpp"
                $length_mod=$mul504; //@line 706 "setlengths.cpp"
                ; //@line 706 "setlengths.cpp"
              }
              else if (__label__ == 138) {
  
                var $278=HEAP32[((__ZL6speed3)>>2)]; //@line 708 "setlengths.cpp"
                var $279=$length_mod; //@line 708 "setlengths.cpp"
                var $mul506=((($279)*($278))&4294967295); //@line 708 "setlengths.cpp"
                $length_mod=$mul506; //@line 708 "setlengths.cpp"
                ;
              }
            }
  
            var $280=$length_mod; //@line 710 "setlengths.cpp"
            var $div509=((((($280))|0)/128)|0); //@line 710 "setlengths.cpp"
            $length_mod=$div509; //@line 710 "setlengths.cpp"
            var $cmp510=((($div509))|0) < 8; //@line 712 "setlengths.cpp"
            if ($cmp510) { __label__ = 140;; } else { __label__ = 141;; } //@line 712 "setlengths.cpp"
            if (__label__ == 140) {
  
              $length_mod=8; //@line 713 "setlengths.cpp"
              ; //@line 713 "setlengths.cpp"
            }
  
            var $281=$stress; //@line 715 "setlengths.cpp"
            var $cmp513=((($281))|0) >= 7; //@line 715 "setlengths.cpp"
            if ($cmp513) { __label__ = 142;; } else { __label__ = 144;; } //@line 715 "setlengths.cpp"
            $if_then514$$if_else520$199: do { 
              if (__label__ == 142) {
  
                var $282=$length_mod; //@line 718 "setlengths.cpp"
                var $add515=((($282)+20)&4294967295); //@line 718 "setlengths.cpp"
                $length_mod=$add515; //@line 718 "setlengths.cpp"
                var $283=$emphasized; //@line 719 "setlengths.cpp"
                var $tobool516=((($283))|0)!=0; //@line 719 "setlengths.cpp"
                if (!($tobool516)) { __label__ = 146;break $if_then514$$if_else520$199; } //@line 719 "setlengths.cpp"
  
                var $284=$length_mod; //@line 720 "setlengths.cpp"
                var $add518=((($284)+10)&4294967295); //@line 720 "setlengths.cpp"
                $length_mod=$add518; //@line 720 "setlengths.cpp"
                ; //@line 720 "setlengths.cpp"
              }
              else if (__label__ == 144) {
  
                var $285=$emphasized; //@line 723 "setlengths.cpp"
                var $tobool521=((($285))|0)!=0; //@line 723 "setlengths.cpp"
                if (!($tobool521)) { __label__ = 146;break $if_then514$$if_else520$199; } //@line 723 "setlengths.cpp"
  
                var $286=$length_mod; //@line 725 "setlengths.cpp"
                var $add523=((($286)+20)&4294967295); //@line 725 "setlengths.cpp"
                $length_mod=$add523; //@line 725 "setlengths.cpp"
                ; //@line 726 "setlengths.cpp"
              }
            } while(0);
  
            var $287=$stress; //@line 728 "setlengths.cpp"
            var $288=$tr_addr; //@line 728 "setlengths.cpp"
            var $stress_lengths=(($288+676)&4294967295); //@line 728 "setlengths.cpp"
            var $arrayidx526=(($stress_lengths+$287*2)&4294967295); //@line 728 "setlengths.cpp"
            var $289=HEAP16[(($arrayidx526)>>1)]; //@line 728 "setlengths.cpp"
            var $conv527=(tempInt=(($289)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 728 "setlengths.cpp"
            $len=$conv527; //@line 728 "setlengths.cpp"
            var $cmp528=((($conv527))|0)==0; //@line 728 "setlengths.cpp"
            if ($cmp528) { __label__ = 147;; } else { __label__ = 148;; } //@line 728 "setlengths.cpp"
            if (__label__ == 147) {
  
              var $290=$tr_addr; //@line 729 "setlengths.cpp"
              var $stress_lengths530=(($290+676)&4294967295); //@line 729 "setlengths.cpp"
              var $arrayidx531=(($stress_lengths530+12)&4294967295); //@line 729 "setlengths.cpp"
              var $291=HEAP16[(($arrayidx531)>>1)]; //@line 729 "setlengths.cpp"
              var $conv532=(tempInt=(($291)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 729 "setlengths.cpp"
              $len=$conv532; //@line 729 "setlengths.cpp"
              ; //@line 729 "setlengths.cpp"
            }
  
            var $292=$length_mod; //@line 731 "setlengths.cpp"
            var $293=$len; //@line 731 "setlengths.cpp"
            var $mul534=((($293)*($292))&4294967295); //@line 731 "setlengths.cpp"
            $length_mod=$mul534; //@line 731 "setlengths.cpp"
            var $294=$p; //@line 733 "setlengths.cpp"
            var $tone_ph=(($294+3)&4294967295); //@line 733 "setlengths.cpp"
            var $295=HEAPU8[($tone_ph)]; //@line 733 "setlengths.cpp"
            var $conv535=((($295))&255); //@line 733 "setlengths.cpp"
            var $cmp536=((($conv535))|0)!=0; //@line 733 "setlengths.cpp"
            if ($cmp536) { __label__ = 149;; } else { __label__ = 151;; } //@line 733 "setlengths.cpp"
            $if_then537$$if_end546$208: do { 
              if (__label__ == 149) {
  
                var $296=$p; //@line 735 "setlengths.cpp"
                var $tone_ph538=(($296+3)&4294967295); //@line 735 "setlengths.cpp"
                var $297=HEAPU8[($tone_ph538)]; //@line 735 "setlengths.cpp"
                var $idxprom=((($297))&255); //@line 735 "setlengths.cpp"
                var $arrayidx539=((_phoneme_tab+$idxprom*4)&4294967295); //@line 735 "setlengths.cpp"
                var $298=HEAP32[(($arrayidx539)>>2)]; //@line 735 "setlengths.cpp"
                var $std_length=(($298+14)&4294967295); //@line 735 "setlengths.cpp"
                var $299=HEAPU8[($std_length)]; //@line 735 "setlengths.cpp"
                var $conv540=((($299))&255); //@line 735 "setlengths.cpp"
                $tone_mod=$conv540; //@line 735 "setlengths.cpp"
                var $cmp541=((($conv540))|0) > 0; //@line 735 "setlengths.cpp"
                if (!($cmp541)) { __label__ = 151;break $if_then537$$if_end546$208; } //@line 735 "setlengths.cpp"
  
                var $300=$length_mod; //@line 738 "setlengths.cpp"
                var $301=$tone_mod; //@line 738 "setlengths.cpp"
                var $mul543=((($301)*($300))&4294967295); //@line 738 "setlengths.cpp"
                var $div544=((((($mul543))|0)/100)|0); //@line 738 "setlengths.cpp"
                $length_mod=$div544; //@line 738 "setlengths.cpp"
                ; //@line 739 "setlengths.cpp"
              }
            } while(0);
  
            var $302=$end_of_clause; //@line 742 "setlengths.cpp"
            var $cmp547=((($302))|0)==2; //@line 742 "setlengths.cpp"
            if ($cmp547) { __label__ = 152;; } else { __label__ = 155;; } //@line 742 "setlengths.cpp"
            if (__label__ == 152) {
  
              var $303=$p; //@line 745 "setlengths.cpp"
              var $ph549=(($303+8)&4294967295); //@line 745 "setlengths.cpp"
              var $304=HEAP32[(($ph549)>>2)]; //@line 745 "setlengths.cpp"
              var $std_length550=(($304+14)&4294967295); //@line 745 "setlengths.cpp"
              var $305=HEAPU8[($std_length550)]; //@line 745 "setlengths.cpp"
              var $conv551=((($305))&255); //@line 745 "setlengths.cpp"
              var $mul552=((($conv551)*2)&4294967295); //@line 745 "setlengths.cpp"
              $len=$mul552; //@line 745 "setlengths.cpp"
              var $306=$tr_addr; //@line 746 "setlengths.cpp"
              var $langopts553=(($306)&4294967295); //@line 746 "setlengths.cpp"
              var $stress_flags=(($langopts553+12)&4294967295); //@line 746 "setlengths.cpp"
              var $307=HEAP32[(($stress_flags)>>2)]; //@line 746 "setlengths.cpp"
              var $and554=($307) & 262144; //@line 746 "setlengths.cpp"
              var $tobool555=((($and554))|0)!=0; //@line 746 "setlengths.cpp"
              if ($tobool555) { __label__ = 153;; } else { __label__ = 154;; } //@line 746 "setlengths.cpp"
              if (__label__ == 153) {
  
                $len=200; //@line 747 "setlengths.cpp"
                ; //@line 747 "setlengths.cpp"
              }
  
              var $308=$length_mod; //@line 748 "setlengths.cpp"
              var $309=$len; //@line 748 "setlengths.cpp"
              var $sub558=((280-($309))&4294967295); //@line 748 "setlengths.cpp"
              var $div559=((((($sub558))|0)/3)|0); //@line 748 "setlengths.cpp"
              var $add560=((($div559)+256)&4294967295); //@line 748 "setlengths.cpp"
              var $mul561=((($add560)*($308))&4294967295); //@line 748 "setlengths.cpp"
              var $div562=((((($mul561))|0)/256)|0); //@line 748 "setlengths.cpp"
              $length_mod=$div562; //@line 748 "setlengths.cpp"
              ; //@line 749 "setlengths.cpp"
            }
  
            var $310=$length_mod; //@line 751 "setlengths.cpp"
            var $311=$tr_addr; //@line 751 "setlengths.cpp"
            var $langopts564=(($311)&4294967295); //@line 751 "setlengths.cpp"
            var $max_lengthmod=(($langopts564+272)&4294967295); //@line 751 "setlengths.cpp"
            var $312=HEAP32[(($max_lengthmod)>>2)]; //@line 751 "setlengths.cpp"
            var $313=HEAP32[((__ZL6speed1)>>2)]; //@line 751 "setlengths.cpp"
            var $mul565=((($313)*($312))&4294967295); //@line 751 "setlengths.cpp"
            var $cmp566=((($310))|0) > ((($mul565))|0); //@line 751 "setlengths.cpp"
            if ($cmp566) { __label__ = 156;; } else { __label__ = 157;; } //@line 751 "setlengths.cpp"
            if (__label__ == 156) {
  
              var $314=$tr_addr; //@line 754 "setlengths.cpp"
              var $langopts568=(($314)&4294967295); //@line 754 "setlengths.cpp"
              var $max_lengthmod569=(($langopts568+272)&4294967295); //@line 754 "setlengths.cpp"
              var $315=HEAP32[(($max_lengthmod569)>>2)]; //@line 754 "setlengths.cpp"
              var $316=HEAP32[((__ZL6speed1)>>2)]; //@line 754 "setlengths.cpp"
              var $mul570=((($316)*($315))&4294967295); //@line 754 "setlengths.cpp"
              $length_mod=$mul570; //@line 754 "setlengths.cpp"
              ; //@line 755 "setlengths.cpp"
            }
  
            var $317=$length_mod; //@line 757 "setlengths.cpp"
            var $div572=((((($317))|0)/128)|0); //@line 757 "setlengths.cpp"
            $length_mod=$div572; //@line 757 "setlengths.cpp"
            var $318=$p; //@line 759 "setlengths.cpp"
            var $type573=(($318+15)&4294967295); //@line 759 "setlengths.cpp"
            var $319=HEAPU8[($type573)]; //@line 759 "setlengths.cpp"
            var $conv574=((($319))&255); //@line 759 "setlengths.cpp"
            var $cmp575=((($conv574))|0)!=2; //@line 759 "setlengths.cpp"
            if ($cmp575) { __label__ = 158;; } else { __label__ = 159;; } //@line 759 "setlengths.cpp"
            if (__label__ == 158) {
  
              $length_mod=256; //@line 761 "setlengths.cpp"
              $min_drop=16; //@line 762 "setlengths.cpp"
              ; //@line 763 "setlengths.cpp"
            }
  
            var $320=$length_mod; //@line 764 "setlengths.cpp"
            var $conv578=((($320)) & 65535); //@line 764 "setlengths.cpp"
            var $321=$p; //@line 764 "setlengths.cpp"
            var $length579=(($321+12)&4294967295); //@line 764 "setlengths.cpp"
            HEAP16[(($length579)>>1)]=$conv578; //@line 764 "setlengths.cpp"
            var $322=$p; //@line 766 "setlengths.cpp"
            var $env580=(($322+14)&4294967295); //@line 766 "setlengths.cpp"
            var $323=HEAPU8[($env580)]; //@line 766 "setlengths.cpp"
            var $conv581=((($323))&255); //@line 766 "setlengths.cpp"
            var $cmp582=((($conv581))|0) >= 19; //@line 766 "setlengths.cpp"
            if ($cmp582) { __label__ = 160;; } else { __label__ = 161;; } //@line 766 "setlengths.cpp"
            if (__label__ == 160) {
  
              var $324=HEAP32[((__impure_ptr)>>2)]; //@line 768 "setlengths.cpp"
              var $_stderr=(($324+12)&4294967295); //@line 768 "setlengths.cpp"
              var $325=HEAP32[(($_stderr)>>2)]; //@line 768 "setlengths.cpp"
              var $326=_fwrite(((__str294)&4294967295), 28, 1, $325); //@line 768 "setlengths.cpp"
              var $327=$p; //@line 769 "setlengths.cpp"
              var $env584=(($327+14)&4294967295); //@line 769 "setlengths.cpp"
              HEAP8[($env584)]=0; //@line 769 "setlengths.cpp"
              ; //@line 770 "setlengths.cpp"
            }
  
            var $328=$p; //@line 774 "setlengths.cpp"
            var $env586=(($328+14)&4294967295); //@line 774 "setlengths.cpp"
            var $329=HEAPU8[($env586)]; //@line 774 "setlengths.cpp"
            var $conv587=((($329))&255); //@line 774 "setlengths.cpp"
            var $add588=((($conv587)+1)&4294967295); //@line 774 "setlengths.cpp"
            $env2=$add588; //@line 774 "setlengths.cpp"
            var $330=$p; //@line 776 "setlengths.cpp"
            var $tone_ph589=(($330+3)&4294967295); //@line 776 "setlengths.cpp"
            var $331=HEAPU8[($tone_ph589)]; //@line 776 "setlengths.cpp"
            var $conv590=((($331))&255); //@line 776 "setlengths.cpp"
            var $cmp591=((($conv590))|0)!=0; //@line 776 "setlengths.cpp"
            if ($cmp591) { __label__ = 162;; } else { __label__ = 163;; } //@line 776 "setlengths.cpp"
            if (__label__ == 162) {
  
              var $332=$p; //@line 778 "setlengths.cpp"
              var $tone_ph593=(($332+3)&4294967295); //@line 778 "setlengths.cpp"
              var $333=HEAPU8[($tone_ph593)]; //@line 778 "setlengths.cpp"
              var $conv594=((($333))&255); //@line 778 "setlengths.cpp"
              __Z17InterpretPhoneme2iP12PHONEME_DATA($conv594, $phdata_tone); //@line 778 "setlengths.cpp"
              var $334=HEAP32[(($pitch_env595)>>2)]; //@line 779 "setlengths.cpp"
              var $call596=__Z11GetEnvelopei($334); //@line 779 "setlengths.cpp"
              $pitch_env=$call596; //@line 779 "setlengths.cpp"
              ; //@line 780 "setlengths.cpp"
            }
            else if (__label__ == 163) {
  
              var $335=$env2; //@line 783 "setlengths.cpp"
              var $arrayidx598=((_envelope_data+$335*4)&4294967295); //@line 783 "setlengths.cpp"
              var $336=HEAP32[(($arrayidx598)>>2)]; //@line 783 "setlengths.cpp"
              $pitch_env=$336; //@line 783 "setlengths.cpp"
              ;
            }
  
            var $337=$p; //@line 786 "setlengths.cpp"
            var $pitch1600=(($337+20)&4294967295); //@line 786 "setlengths.cpp"
            var $338=HEAPU8[($pitch1600)]; //@line 786 "setlengths.cpp"
            var $conv601=((($338))&255); //@line 786 "setlengths.cpp"
            var $339=$p; //@line 786 "setlengths.cpp"
            var $pitch2602=(($339+21)&4294967295); //@line 786 "setlengths.cpp"
            var $340=HEAPU8[($pitch2602)]; //@line 786 "setlengths.cpp"
            var $conv603=((($340))&255); //@line 786 "setlengths.cpp"
            var $341=$p; //@line 786 "setlengths.cpp"
            var $pitch1604=(($341+20)&4294967295); //@line 786 "setlengths.cpp"
            var $342=HEAPU8[($pitch1604)]; //@line 786 "setlengths.cpp"
            var $conv605=((($342))&255); //@line 786 "setlengths.cpp"
            var $sub606=((($conv603)-($conv605))&4294967295); //@line 786 "setlengths.cpp"
            var $343=$pitch_env; //@line 786 "setlengths.cpp"
            var $arrayidx607=(($343)&4294967295); //@line 786 "setlengths.cpp"
            var $344=HEAPU8[($arrayidx607)]; //@line 786 "setlengths.cpp"
            var $conv608=((($344))&255); //@line 786 "setlengths.cpp"
            var $mul609=((($conv608)*($sub606))&4294967295); //@line 786 "setlengths.cpp"
            var $div610=((((($mul609))|0)/256)|0); //@line 786 "setlengths.cpp"
            var $add611=((($div610)+($conv601))&4294967295); //@line 786 "setlengths.cpp"
            $pitch_start=$add611; //@line 786 "setlengths.cpp"
            var $345=$pre_sonorant; //@line 788 "setlengths.cpp"
            var $tobool612=((($345))|0)!=0; //@line 788 "setlengths.cpp"
            if ($tobool612) { __lastLabel__ = 164; __label__ = 167;; } else { __lastLabel__ = 164; __label__ = 165;; } //@line 788 "setlengths.cpp"
            $if_then615$$lor_lhs_false613$231: do { 
              if (__label__ == 165) {
  
                var $346=$pre_voiced; //@line 788 "setlengths.cpp"
                var $tobool614=((($346))|0)!=0; //@line 788 "setlengths.cpp"
                if (!($tobool614)) { __label__ = 177;break $if_then615$$lor_lhs_false613$231; } //@line 788 "setlengths.cpp"
  
                var $_pr2=$pitch_start; //@line 791 "setlengths.cpp"
                __lastLabel__ = 166; __label__ = 167;break $if_then615$$lor_lhs_false613$231;
              }
            } while(0);
            $if_then615$$if_end650$234: do { 
              if (__label__ == 167) {
  
                var $347=__lastLabel__ == 166 ? $_pr2 : ($add611); //@line 791 "setlengths.cpp"
                var $cmp616=((($347))|0)==255; //@line 791 "setlengths.cpp"
                if ($cmp616) { __label__ = 168;; } else { __label__ = 169;; } //@line 791 "setlengths.cpp"
                if (__label__ == 168) {
  
                  var $348=$pitch_start; //@line 792 "setlengths.cpp"
                  $last_pitch=$348; //@line 792 "setlengths.cpp"
                  ; //@line 792 "setlengths.cpp"
                }
  
                var $349=$pitch_start; //@line 794 "setlengths.cpp"
                var $350=$last_pitch; //@line 794 "setlengths.cpp"
                var $sub619=((($349)-($350))&4294967295); //@line 794 "setlengths.cpp"
                var $cmp620=((($sub619))|0) > 16; //@line 794 "setlengths.cpp"
                if ($cmp620) { __label__ = 170;; } else { __label__ = 171;; } //@line 794 "setlengths.cpp"
                if (__label__ == 170) {
  
                  var $351=$pitch_start; //@line 795 "setlengths.cpp"
                  var $sub622=((($351)-16)&4294967295); //@line 795 "setlengths.cpp"
                  $last_pitch=$sub622; //@line 795 "setlengths.cpp"
                  ; //@line 795 "setlengths.cpp"
                }
  
                var $352=$last_pitch; //@line 797 "setlengths.cpp"
                var $conv624=((($352)) & 255); //@line 797 "setlengths.cpp"
                var $353=$prev; //@line 797 "setlengths.cpp"
                var $pitch1625=(($353+20)&4294967295); //@line 797 "setlengths.cpp"
                HEAP8[($pitch1625)]=$conv624; //@line 797 "setlengths.cpp"
                var $354=$pitch_start; //@line 798 "setlengths.cpp"
                var $conv626=((($354)) & 255); //@line 798 "setlengths.cpp"
                var $355=$prev; //@line 798 "setlengths.cpp"
                var $pitch2627=(($355+21)&4294967295); //@line 798 "setlengths.cpp"
                HEAP8[($pitch2627)]=$conv626; //@line 798 "setlengths.cpp"
                var $356=$last_pitch; //@line 799 "setlengths.cpp"
                var $357=$pitch_start; //@line 799 "setlengths.cpp"
                var $cmp628=((($356))|0) < ((($357))|0); //@line 799 "setlengths.cpp"
                var $358=$prev; //@line 801 "setlengths.cpp"
                var $env630=(($358+14)&4294967295); //@line 801 "setlengths.cpp"
                if ($cmp628) { __label__ = 172;; } else { __label__ = 173;; } //@line 799 "setlengths.cpp"
                if (__label__ == 172) {
  
                  HEAP8[($env630)]=2; //@line 801 "setlengths.cpp"
                  var $359=$env2; //@line 802 "setlengths.cpp"
                  var $conv631=((($359)) & 255); //@line 802 "setlengths.cpp"
                  var $360=$p; //@line 802 "setlengths.cpp"
                  var $env632=(($360+14)&4294967295); //@line 802 "setlengths.cpp"
                  HEAP8[($env632)]=$conv631; //@line 802 "setlengths.cpp"
                  ; //@line 803 "setlengths.cpp"
                }
                else if (__label__ == 173) {
  
                  HEAP8[($env630)]=0; //@line 806 "setlengths.cpp"
                  ;
                }
  
                var $361=$length_mod; //@line 809 "setlengths.cpp"
                var $conv636=((($361)) & 65535); //@line 809 "setlengths.cpp"
                var $362=$prev; //@line 809 "setlengths.cpp"
                var $length637=(($362+12)&4294967295); //@line 809 "setlengths.cpp"
                HEAP16[(($length637)>>1)]=$conv636; //@line 809 "setlengths.cpp"
                var $363=$p; //@line 811 "setlengths.cpp"
                var $amp638=(($363+18)&4294967295); //@line 811 "setlengths.cpp"
                var $364=HEAP8[($amp638)]; //@line 811 "setlengths.cpp"
                var $365=$prev; //@line 811 "setlengths.cpp"
                var $amp639=(($365+18)&4294967295); //@line 811 "setlengths.cpp"
                HEAP8[($amp639)]=$364; //@line 811 "setlengths.cpp"
                var $366=$prev; //@line 812 "setlengths.cpp"
                var $type640=(($366+15)&4294967295); //@line 812 "setlengths.cpp"
                var $367=HEAPU8[($type640)]; //@line 812 "setlengths.cpp"
                var $conv641=((($367))&255); //@line 812 "setlengths.cpp"
                var $cmp642=((($conv641))|0)!=3; //@line 812 "setlengths.cpp"
                if (!($cmp642)) { __label__ = 177;break $if_then615$$if_end650$234; } //@line 812 "setlengths.cpp"
  
                var $368=$prev; //@line 812 "setlengths.cpp"
                var $amp644=(($368+18)&4294967295); //@line 812 "setlengths.cpp"
                var $369=HEAPU8[($amp644)]; //@line 812 "setlengths.cpp"
                var $conv645=((($369))&255); //@line 812 "setlengths.cpp"
                var $cmp646=((($conv645))|0) > 18; //@line 812 "setlengths.cpp"
                if (!($cmp646)) { __label__ = 177;break $if_then615$$if_end650$234; } //@line 812 "setlengths.cpp"
  
                var $370=$prev; //@line 813 "setlengths.cpp"
                var $amp648=(($370+18)&4294967295); //@line 813 "setlengths.cpp"
                HEAP8[($amp648)]=18; //@line 813 "setlengths.cpp"
                ; //@line 813 "setlengths.cpp"
              }
            } while(0);
  
            var $371=$next; //@line 817 "setlengths.cpp"
            var $synthflags651=(($371+4)&4294967295); //@line 817 "setlengths.cpp"
            var $372=HEAPU16[(($synthflags651)>>1)]; //@line 817 "setlengths.cpp"
            var $conv652=((($372))&65535); //@line 817 "setlengths.cpp"
            var $and653=($conv652) & -2; //@line 817 "setlengths.cpp"
            var $conv654=((($and653)) & 65535); //@line 817 "setlengths.cpp"
            HEAP16[(($synthflags651)>>1)]=$conv654; //@line 817 "setlengths.cpp"
            var $373=$next; //@line 818 "setlengths.cpp"
            var $type655=(($373+15)&4294967295); //@line 818 "setlengths.cpp"
            var $374=HEAPU8[($type655)]; //@line 818 "setlengths.cpp"
            var $conv656=((($374))&255); //@line 818 "setlengths.cpp"
            var $cmp657=((($conv656))|0)==8; //@line 818 "setlengths.cpp"
            if ($cmp657) { __label__ = 178;; } else { __label__ = 180;; } //@line 818 "setlengths.cpp"
            $land_lhs_true658$$if_end666$249: do { 
              if (__label__ == 178) {
  
                var $375=$next2; //@line 818 "setlengths.cpp"
                var $type659=(($375+15)&4294967295); //@line 818 "setlengths.cpp"
                var $376=HEAPU8[($type659)]; //@line 818 "setlengths.cpp"
                var $conv660=((($376))&255); //@line 818 "setlengths.cpp"
                var $cmp661=((($conv660))|0)!=2; //@line 818 "setlengths.cpp"
                if (!($cmp661)) { __label__ = 180;break $land_lhs_true658$$if_end666$249; } //@line 818 "setlengths.cpp"
  
                var $377=$next; //@line 819 "setlengths.cpp"
                var $synthflags663=(($377+4)&4294967295); //@line 819 "setlengths.cpp"
                var $378=HEAPU16[(($synthflags663)>>1)]; //@line 819 "setlengths.cpp"
                var $conv664=((($378))&65535); //@line 819 "setlengths.cpp"
                var $or=($conv664) | 1; //@line 819 "setlengths.cpp"
                var $conv665=((($or)) & 65535); //@line 819 "setlengths.cpp"
                HEAP16[(($synthflags663)>>1)]=$conv665; //@line 819 "setlengths.cpp"
                ; //@line 819 "setlengths.cpp"
              }
            } while(0);
  
            var $379=$next; //@line 821 "setlengths.cpp"
            var $type667=(($379+15)&4294967295); //@line 821 "setlengths.cpp"
            var $380=HEAPU8[($type667)]; //@line 821 "setlengths.cpp"
            var $conv668=((($380))&255); //@line 821 "setlengths.cpp"
            var $cmp669=((($conv668))|0)==3; //@line 821 "setlengths.cpp"
            if ($cmp669) { __label__ = 181;; } else { __label__ = 186;; } //@line 821 "setlengths.cpp"
            $if_then670$$if_end697$253: do { 
              if (__label__ == 181) {
  
                var $381=$next; //@line 823 "setlengths.cpp"
                var $synthflags671=(($381+4)&4294967295); //@line 823 "setlengths.cpp"
                var $382=HEAPU16[(($synthflags671)>>1)]; //@line 823 "setlengths.cpp"
                var $conv672=((($382))&65535); //@line 823 "setlengths.cpp"
                var $or673=($conv672) | 1; //@line 823 "setlengths.cpp"
                var $conv674=((($or673)) & 65535); //@line 823 "setlengths.cpp"
                HEAP16[(($synthflags671)>>1)]=$conv674; //@line 823 "setlengths.cpp"
                var $383=$next2; //@line 825 "setlengths.cpp"
                var $type675=(($383+15)&4294967295); //@line 825 "setlengths.cpp"
                var $384=HEAPU8[($type675)]; //@line 825 "setlengths.cpp"
                var $conv676=((($384))&255); //@line 825 "setlengths.cpp"
                var $cmp677=((($conv676))|0)==2; //@line 825 "setlengths.cpp"
                if ($cmp677) { __label__ = 182;; } else { __label__ = 183;; } //@line 825 "setlengths.cpp"
                if (__label__ == 182) {
  
                  var $385=$next; //@line 827 "setlengths.cpp"
                  var $synthflags679=(($385+4)&4294967295); //@line 827 "setlengths.cpp"
                  var $386=HEAPU16[(($synthflags679)>>1)]; //@line 827 "setlengths.cpp"
                  var $conv680=((($386))&65535); //@line 827 "setlengths.cpp"
                  var $and681=($conv680) & -2; //@line 827 "setlengths.cpp"
                  var $conv682=((($and681)) & 65535); //@line 827 "setlengths.cpp"
                  HEAP16[(($synthflags679)>>1)]=$conv682; //@line 827 "setlengths.cpp"
                  ; //@line 828 "setlengths.cpp"
                }
  
                var $387=$next2; //@line 830 "setlengths.cpp"
                var $type684=(($387+15)&4294967295); //@line 830 "setlengths.cpp"
                var $388=HEAPU8[($type684)]; //@line 830 "setlengths.cpp"
                var $conv685=((($388))&255); //@line 830 "setlengths.cpp"
                var $cmp686=((($conv685))|0)!=2; //@line 830 "setlengths.cpp"
                if (!($cmp686)) { __label__ = 186;break $if_then670$$if_end697$253; } //@line 830 "setlengths.cpp"
  
                var $389=$next; //@line 832 "setlengths.cpp"
                var $ph688=(($389+8)&4294967295); //@line 832 "setlengths.cpp"
                var $390=HEAP32[(($ph688)>>2)]; //@line 832 "setlengths.cpp"
                var $mnemonic=(($390)&4294967295); //@line 832 "setlengths.cpp"
                var $391=HEAP32[(($mnemonic)>>2)]; //@line 832 "setlengths.cpp"
                var $cmp689=((($391))|0)==12146; //@line 832 "setlengths.cpp"
                if (!($cmp689)) { __label__ = 186;break $if_then670$$if_end697$253; } //@line 832 "setlengths.cpp"
  
                var $392=$next; //@line 834 "setlengths.cpp"
                var $synthflags691=(($392+4)&4294967295); //@line 834 "setlengths.cpp"
                var $393=HEAPU16[(($synthflags691)>>1)]; //@line 834 "setlengths.cpp"
                var $conv692=((($393))&65535); //@line 834 "setlengths.cpp"
                var $and693=($conv692) & -2; //@line 834 "setlengths.cpp"
                var $conv694=((($and693)) & 65535); //@line 834 "setlengths.cpp"
                HEAP16[(($synthflags691)>>1)]=$conv694; //@line 834 "setlengths.cpp"
                ; //@line 836 "setlengths.cpp"
              }
            } while(0);
  
            var $394=$min_drop; //@line 840 "setlengths.cpp"
            var $cmp698=((($394))|0) > 0; //@line 840 "setlengths.cpp"
            if ($cmp698) { __label__ = 187;; } else { __label__ = 191;; } //@line 840 "setlengths.cpp"
            $land_lhs_true699$$if_end715$261: do { 
              if (__label__ == 187) {
  
                var $395=$p; //@line 840 "setlengths.cpp"
                var $pitch2700=(($395+21)&4294967295); //@line 840 "setlengths.cpp"
                var $396=HEAPU8[($pitch2700)]; //@line 840 "setlengths.cpp"
                var $conv701=((($396))&255); //@line 840 "setlengths.cpp"
                var $397=$p; //@line 840 "setlengths.cpp"
                var $pitch1702=(($397+20)&4294967295); //@line 840 "setlengths.cpp"
                var $398=HEAPU8[($pitch1702)]; //@line 840 "setlengths.cpp"
                var $conv703=((($398))&255); //@line 840 "setlengths.cpp"
                var $sub704=((($conv701)-($conv703))&4294967295); //@line 840 "setlengths.cpp"
                var $399=$min_drop; //@line 840 "setlengths.cpp"
                var $cmp705=((($sub704))|0) < ((($399))|0); //@line 840 "setlengths.cpp"
                if (!($cmp705)) { __label__ = 191;break $land_lhs_true699$$if_end715$261; } //@line 840 "setlengths.cpp"
  
                var $400=$p; //@line 842 "setlengths.cpp"
                var $pitch2707=(($400+21)&4294967295); //@line 842 "setlengths.cpp"
                var $401=HEAPU8[($pitch2707)]; //@line 842 "setlengths.cpp"
                var $conv708=((($401))&255); //@line 842 "setlengths.cpp"
                var $402=$min_drop; //@line 842 "setlengths.cpp"
                var $sub709=((($conv708)-($402))&4294967295); //@line 842 "setlengths.cpp"
                $pitch1=$sub709; //@line 842 "setlengths.cpp"
                var $403=$pitch1; //@line 843 "setlengths.cpp"
                var $cmp710=((($403))|0) < 0; //@line 843 "setlengths.cpp"
                if ($cmp710) { __label__ = 189;; } else { __label__ = 190;; } //@line 843 "setlengths.cpp"
                if (__label__ == 189) {
  
                  $pitch1=0; //@line 844 "setlengths.cpp"
                  ; //@line 844 "setlengths.cpp"
                }
  
                var $404=$pitch1; //@line 845 "setlengths.cpp"
                var $conv713=((($404)) & 255); //@line 845 "setlengths.cpp"
                var $405=$p; //@line 845 "setlengths.cpp"
                var $pitch1714=(($405+20)&4294967295); //@line 845 "setlengths.cpp"
                HEAP8[($pitch1714)]=$conv713; //@line 845 "setlengths.cpp"
                ; //@line 846 "setlengths.cpp"
              }
            } while(0);
  
            var $406=$p; //@line 848 "setlengths.cpp"
            var $pitch1716=(($406+20)&4294967295); //@line 848 "setlengths.cpp"
            var $407=HEAPU8[($pitch1716)]; //@line 848 "setlengths.cpp"
            var $conv717=((($407))&255); //@line 848 "setlengths.cpp"
            var $408=$p; //@line 848 "setlengths.cpp"
            var $pitch2718=(($408+21)&4294967295); //@line 848 "setlengths.cpp"
            var $409=HEAPU8[($pitch2718)]; //@line 848 "setlengths.cpp"
            var $conv719=((($409))&255); //@line 848 "setlengths.cpp"
            var $410=$p; //@line 848 "setlengths.cpp"
            var $pitch1720=(($410+20)&4294967295); //@line 848 "setlengths.cpp"
            var $411=HEAPU8[($pitch1720)]; //@line 848 "setlengths.cpp"
            var $conv721=((($411))&255); //@line 848 "setlengths.cpp"
            var $sub722=((($conv719)-($conv721))&4294967295); //@line 848 "setlengths.cpp"
            var $412=$p; //@line 848 "setlengths.cpp"
            var $env723=(($412+14)&4294967295); //@line 848 "setlengths.cpp"
            var $413=HEAPU8[($env723)]; //@line 848 "setlengths.cpp"
            var $idxprom724=((($413))&255); //@line 848 "setlengths.cpp"
            var $arrayidx725=((_envelope_data+$idxprom724*4)&4294967295); //@line 848 "setlengths.cpp"
            var $414=HEAP32[(($arrayidx725)>>2)]; //@line 848 "setlengths.cpp"
            var $arrayidx726=(($414+127)&4294967295); //@line 848 "setlengths.cpp"
            var $415=HEAPU8[($arrayidx726)]; //@line 848 "setlengths.cpp"
            var $conv727=((($415))&255); //@line 848 "setlengths.cpp"
            var $mul728=((($conv727)*($sub722))&4294967295); //@line 848 "setlengths.cpp"
            var $div729=((((($mul728))|0)/256)|0); //@line 848 "setlengths.cpp"
            var $add730=((($div729)+($conv717))&4294967295); //@line 848 "setlengths.cpp"
            $last_pitch=$add730; //@line 848 "setlengths.cpp"
            $pre_sonorant=0; //@line 849 "setlengths.cpp"
            $pre_voiced=0; //@line 850 "setlengths.cpp"
            ; //@line 851 "setlengths.cpp"
          }
  
          var $416=$ix; //@line 441 "setlengths.cpp"
          var $inc732=((($416)+1)&4294967295); //@line 441 "setlengths.cpp"
          $ix=$inc732; //@line 441 "setlengths.cpp"
          var $417=$ix; //@line 441 "setlengths.cpp"
          var $418=HEAP32[((_n_phoneme_list)>>2)]; //@line 441 "setlengths.cpp"
          var $cmp=((($417))|0) < ((($418))|0); //@line 441 "setlengths.cpp"
          if ($cmp) { __label__ = 2;continue $for_body$4; } else { __label__ = 193;break $for_body_lr_ph$$for_end733$2; } //@line 441 "setlengths.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 854 "setlengths.cpp"
    return;
  }
  

  function __ZL11DoEmbedded2Pi($embix) {
    ;
    var __label__;
  
    var $embix_addr;
    var $word;
    $embix_addr=$embix;
    ; //@line 398 "setlengths.cpp"
    while(1) { 
  
      var $0=$embix_addr; //@line 399 "setlengths.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 399 "setlengths.cpp"
      var $inc=((($1)+1)&4294967295); //@line 399 "setlengths.cpp"
      HEAP32[(($0)>>2)]=$inc; //@line 399 "setlengths.cpp"
      var $arrayidx=((_embedded_list+$1*4)&4294967295); //@line 399 "setlengths.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 399 "setlengths.cpp"
      $word=$2; //@line 399 "setlengths.cpp"
      var $3=$word; //@line 401 "setlengths.cpp"
      var $and=($3) & 31; //@line 401 "setlengths.cpp"
      var $cmp=((($and))|0)==2; //@line 401 "setlengths.cpp"
      if ($cmp) { __label__ = 2;; } else { __label__ = 3;; } //@line 401 "setlengths.cpp"
      if (__label__ == 2) {
  
        var $4=$word; //@line 404 "setlengths.cpp"
        var $and1=($4) & 127; //@line 404 "setlengths.cpp"
        var $5=$word; //@line 404 "setlengths.cpp"
        var $shr=($5) >>> 8; //@line 404 "setlengths.cpp"
        __Z11SetEmbeddedii($and1, $shr); //@line 404 "setlengths.cpp"
        __Z8SetSpeedi(1); //@line 405 "setlengths.cpp"
        ; //@line 406 "setlengths.cpp"
      }
  
      var $6=$word; //@line 407 "setlengths.cpp"
      var $and2=($6) & 128; //@line 407 "setlengths.cpp"
      var $cmp3=((($and2))|0)==0; //@line 407 "setlengths.cpp"
      if ($cmp3) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 407 "setlengths.cpp"
    }
  
    ;
    return; //@line 408 "setlengths.cpp"
    return;
  }
  

  function __Z20LookupAccentedLetterP10TranslatorjPc($tr, $letter, $ph_buf) {
    var __stackBase__  = STACKTOP; STACKTOP += 128; _memset(__stackBase__, 0, 128);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $letter_addr;
    var $ph_buf_addr;
    var $accent_data;
    var $accent1;
    var $accent2;
    var $basic_letter;
    var $letter2;
    var $ph_letter1=__stackBase__;
    var $ph_letter2=__stackBase__+32;
    var $ph_accent1=__stackBase__+64;
    var $ph_accent2=__stackBase__+96;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $ph_buf_addr=$ph_buf;
    $accent_data=0; //@line 418 "numbers.cpp"
    $accent1=0; //@line 419 "numbers.cpp"
    $accent2=0; //@line 420 "numbers.cpp"
    $letter2=0; //@line 422 "numbers.cpp"
    var $arrayidx=(($ph_accent2)&4294967295); //@line 428 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 428 "numbers.cpp"
    var $0=$letter_addr; //@line 430 "numbers.cpp"
    var $cmp=((($0))>>>0) >= 224; //@line 430 "numbers.cpp"
    var $1=$letter_addr; //@line 430 "numbers.cpp"
    var $cmp1=((($1))>>>0) < 383; //@line 430 "numbers.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 430 "numbers.cpp"
    var $2=$letter_addr; //@line 432 "numbers.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 430 "numbers.cpp"
    if (__label__ == 1) {
  
      var $sub=((($2)-224)&4294967295); //@line 432 "numbers.cpp"
      var $arrayidx2=((__ZL18letter_accents_0e0+$sub*2)&4294967295); //@line 432 "numbers.cpp"
      var $3=HEAPU16[(($arrayidx2)>>1)]; //@line 432 "numbers.cpp"
      var $conv=((($3))&65535); //@line 432 "numbers.cpp"
      $accent_data=$conv; //@line 432 "numbers.cpp"
      __lastLabel__ = 1; ; //@line 433 "numbers.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp3=((($2))>>>0) >= 592; //@line 435 "numbers.cpp"
      var $4=$letter_addr; //@line 435 "numbers.cpp"
      var $cmp5=((($4))>>>0) <= 680; //@line 435 "numbers.cpp"
      var $or_cond1=($cmp3) & ($cmp5); //@line 435 "numbers.cpp"
      if ($or_cond1) { __label__ = 3;; } else { __label__ = 4;; } //@line 435 "numbers.cpp"
      if (__label__ == 3) {
  
        var $5=$letter_addr; //@line 437 "numbers.cpp"
        var $sub7=((($5)-592)&4294967295); //@line 437 "numbers.cpp"
        var $arrayidx8=((__ZL18letter_accents_250+$sub7*2)&4294967295); //@line 437 "numbers.cpp"
        var $6=HEAPU16[(($arrayidx8)>>1)]; //@line 437 "numbers.cpp"
        var $conv9=((($6))&65535); //@line 437 "numbers.cpp"
        $accent_data=$conv9; //@line 437 "numbers.cpp"
        __lastLabel__ = 3; ; //@line 438 "numbers.cpp"
      }
      else if (__label__ == 4) {
  
        var $_pr=$accent_data; //@line 440 "numbers.cpp"
        __lastLabel__ = 4; ;
      }
    }
  
    var $7=__lastLabel__ == 4 ? $_pr : (__lastLabel__ == 3 ? $conv9 : ($conv)); //@line 440 "numbers.cpp"
    var $cmp11=((($7))|0)!=0; //@line 440 "numbers.cpp"
    if ($cmp11) { __label__ = 6;; } else { __label__ = 24;; } //@line 440 "numbers.cpp"
    $if_then12$$if_end91$9: do { 
      if (__label__ == 6) {
  
        var $8=$accent_data; //@line 442 "numbers.cpp"
        var $and=($8) & 63; //@line 442 "numbers.cpp"
        var $add=((($and)+59)&4294967295); //@line 442 "numbers.cpp"
        $basic_letter=$add; //@line 442 "numbers.cpp"
        var $9=$basic_letter; //@line 443 "numbers.cpp"
        var $cmp13=((($9))|0) < 97; //@line 443 "numbers.cpp"
        if ($cmp13) { __label__ = 7;; } else { __label__ = 8;; } //@line 443 "numbers.cpp"
        if (__label__ == 7) {
  
          var $10=$basic_letter; //@line 444 "numbers.cpp"
          var $sub15=((($10)-59)&4294967295); //@line 444 "numbers.cpp"
          var $arrayidx16=((__ZL13non_ascii_tab+$sub15*2)&4294967295); //@line 444 "numbers.cpp"
          var $11=HEAP16[(($arrayidx16)>>1)]; //@line 444 "numbers.cpp"
          var $conv17=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 444 "numbers.cpp"
          $basic_letter=$conv17; //@line 444 "numbers.cpp"
          ; //@line 444 "numbers.cpp"
        }
  
        var $12=$accent_data; //@line 446 "numbers.cpp"
        var $and19=($12) & 32768; //@line 446 "numbers.cpp"
        var $tobool=((($and19))|0)!=0; //@line 446 "numbers.cpp"
        var $13=$accent_data; //@line 448 "numbers.cpp"
        var $shr=($13) >> 6; //@line 448 "numbers.cpp"
        if ($tobool) { __label__ = 9;; } else { __label__ = 10;; } //@line 446 "numbers.cpp"
        if (__label__ == 9) {
  
          var $and21=($shr) & 63; //@line 448 "numbers.cpp"
          $letter2=$and21; //@line 448 "numbers.cpp"
          var $14=$letter2; //@line 449 "numbers.cpp"
          var $add22=((($14)+59)&4294967295); //@line 449 "numbers.cpp"
          $letter2=$add22; //@line 449 "numbers.cpp"
          var $15=$accent_data; //@line 450 "numbers.cpp"
          var $shr23=($15) >> 12; //@line 450 "numbers.cpp"
          var $and24=($shr23) & 7; //@line 450 "numbers.cpp"
          $accent2=$and24; //@line 450 "numbers.cpp"
          ; //@line 451 "numbers.cpp"
        }
        else if (__label__ == 10) {
  
          var $and27=($shr) & 31; //@line 454 "numbers.cpp"
          $accent1=$and27; //@line 454 "numbers.cpp"
          var $16=$accent_data; //@line 455 "numbers.cpp"
          var $shr28=($16) >> 11; //@line 455 "numbers.cpp"
          var $and29=($shr28) & 15; //@line 455 "numbers.cpp"
          $accent2=$and29; //@line 455 "numbers.cpp"
          ;
        }
  
        var $17=$tr_addr; //@line 459 "numbers.cpp"
        var $18=$accent1; //@line 459 "numbers.cpp"
        var $arrayidx31=((__ZL11accents_tab+$18*8)&4294967295); //@line 459 "numbers.cpp"
        var $name=(($arrayidx31)&4294967295); //@line 459 "numbers.cpp"
        var $19=HEAP32[(($name)>>2)]; //@line 459 "numbers.cpp"
        var $arraydecay=(($ph_accent1)&4294967295); //@line 459 "numbers.cpp"
        var $call=__Z6LookupP10TranslatorPKcPc($17, $19, $arraydecay); //@line 459 "numbers.cpp"
        var $cmp32=((($call))|0)!=0; //@line 459 "numbers.cpp"
        if (!($cmp32)) { __label__ = 24;break $if_then12$$if_end91$9; } //@line 459 "numbers.cpp"
  
        var $20=$tr_addr; //@line 462 "numbers.cpp"
        var $21=$basic_letter; //@line 462 "numbers.cpp"
        var $arraydecay34=(($ph_letter1)&4294967295); //@line 462 "numbers.cpp"
        var $call35=__ZL13LookupLetter2P10TranslatorjPc($20, $21, $arraydecay34); //@line 462 "numbers.cpp"
        var $cmp36=((($call35))|0)!=0; //@line 462 "numbers.cpp"
        if (!($cmp36)) { __label__ = 24;break $if_then12$$if_end91$9; } //@line 462 "numbers.cpp"
  
        var $22=$accent2; //@line 464 "numbers.cpp"
        var $cmp38=((($22))|0)!=0; //@line 464 "numbers.cpp"
        if ($cmp38) { __label__ = 14;; } else { __label__ = 16;; } //@line 464 "numbers.cpp"
        $if_then39$$if_end56$20: do { 
          if (__label__ == 14) {
  
            var $23=$tr_addr; //@line 466 "numbers.cpp"
            var $24=$accent2; //@line 466 "numbers.cpp"
            var $arrayidx40=((__ZL11accents_tab+$24*8)&4294967295); //@line 466 "numbers.cpp"
            var $name41=(($arrayidx40)&4294967295); //@line 466 "numbers.cpp"
            var $25=HEAP32[(($name41)>>2)]; //@line 466 "numbers.cpp"
            var $arraydecay42=(($ph_accent2)&4294967295); //@line 466 "numbers.cpp"
            var $call43=__Z6LookupP10TranslatorPKcPc($23, $25, $arraydecay42); //@line 466 "numbers.cpp"
            var $26=$accent2; //@line 471 "numbers.cpp"
            var $arrayidx47=((__ZL11accents_tab+$26*8)&4294967295); //@line 471 "numbers.cpp"
            var $flags=(($arrayidx47+4)&4294967295); //@line 471 "numbers.cpp"
            var $27=HEAP32[(($flags)>>2)]; //@line 471 "numbers.cpp"
            var $and48=($27) & 1; //@line 471 "numbers.cpp"
            var $tobool49=((($and48))|0)!=0; //@line 471 "numbers.cpp"
            if (!($tobool49)) { __label__ = 16;break $if_then39$$if_end56$20; } //@line 471 "numbers.cpp"
  
            var $28=$ph_buf_addr; //@line 473 "numbers.cpp"
            var $arraydecay51=(($ph_accent2)&4294967295); //@line 473 "numbers.cpp"
            var $call52=_strcpy($28, $arraydecay51); //@line 473 "numbers.cpp"
            var $29=$ph_buf_addr; //@line 474 "numbers.cpp"
            var $call53=_strlen($29); //@line 474 "numbers.cpp"
            var $30=$ph_buf_addr; //@line 474 "numbers.cpp"
            var $add_ptr=(($30+$call53)&4294967295); //@line 474 "numbers.cpp"
            $ph_buf_addr=$add_ptr; //@line 474 "numbers.cpp"
            var $arrayidx54=(($ph_accent2)&4294967295); //@line 475 "numbers.cpp"
            HEAP8[($arrayidx54)]=0; //@line 475 "numbers.cpp"
            ; //@line 476 "numbers.cpp"
          }
        } while(0);
  
        var $31=$letter2; //@line 478 "numbers.cpp"
        var $cmp57=((($31))|0)!=0; //@line 478 "numbers.cpp"
        if ($cmp57) { __label__ = 17;; } else { __label__ = 18;; } //@line 478 "numbers.cpp"
        if (__label__ == 17) {
  
          var $32=$tr_addr; //@line 481 "numbers.cpp"
          var $33=$letter2; //@line 481 "numbers.cpp"
          var $arraydecay59=(($ph_letter2)&4294967295); //@line 481 "numbers.cpp"
          var $call60=__ZL13LookupLetter2P10TranslatorjPc($32, $33, $arraydecay59); //@line 481 "numbers.cpp"
          var $34=$ph_buf_addr; //@line 482 "numbers.cpp"
          var $arraydecay61=(($ph_accent1)&4294967295); //@line 482 "numbers.cpp"
          var $arraydecay62=(($ph_letter1)&4294967295); //@line 482 "numbers.cpp"
          var $arraydecay63=(($ph_letter2)&4294967295); //@line 482 "numbers.cpp"
          var $arraydecay64=(($ph_accent2)&4294967295); //@line 482 "numbers.cpp"
          var $call65=_sprintf($34, ((__str297)&4294967295), allocate([$arraydecay61,0,0,0,23,0,0,0,$arraydecay62,0,0,0,6,0,0,0,$arraydecay63,0,0,0,$arraydecay64,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 482 "numbers.cpp"
          ; //@line 483 "numbers.cpp"
        }
        else if (__label__ == 18) {
  
          var $35=$accent1; //@line 486 "numbers.cpp"
          var $cmp67=((($35))|0)==0; //@line 486 "numbers.cpp"
          if ($cmp67) { __label__ = 19;; } else { __label__ = 20;; } //@line 486 "numbers.cpp"
          if (__label__ == 19) {
  
            var $36=$ph_buf_addr; //@line 487 "numbers.cpp"
            var $arraydecay69=(($ph_letter1)&4294967295); //@line 487 "numbers.cpp"
            var $call70=_strcpy($36, $arraydecay69); //@line 487 "numbers.cpp"
            ; //@line 487 "numbers.cpp"
          }
          else if (__label__ == 20) {
  
            var $37=$tr_addr; //@line 489 "numbers.cpp"
            var $langopts=(($37)&4294967295); //@line 489 "numbers.cpp"
            var $accents=(($langopts+220)&4294967295); //@line 489 "numbers.cpp"
            var $38=HEAP32[(($accents)>>2)]; //@line 489 "numbers.cpp"
            var $and72=($38) & 1; //@line 489 "numbers.cpp"
            var $tobool73=((($and72))|0)!=0; //@line 489 "numbers.cpp"
            if ($tobool73) { __label__ = 22;; } else { __label__ = 21;; } //@line 489 "numbers.cpp"
            $if_then78$$lor_lhs_false$30: do { 
              if (__label__ == 21) {
  
                var $39=$accent1; //@line 489 "numbers.cpp"
                var $arrayidx74=((__ZL11accents_tab+$39*8)&4294967295); //@line 489 "numbers.cpp"
                var $flags75=(($arrayidx74+4)&4294967295); //@line 489 "numbers.cpp"
                var $40=HEAP32[(($flags75)>>2)]; //@line 489 "numbers.cpp"
                var $and76=($40) & 1; //@line 489 "numbers.cpp"
                var $tobool77=((($and76))|0)!=0; //@line 489 "numbers.cpp"
                if ($tobool77) { __label__ = 22;break $if_then78$$lor_lhs_false$30; } //@line 489 "numbers.cpp"
  
                var $42=$ph_buf_addr; //@line 492 "numbers.cpp"
                var $arraydecay83=(($ph_letter1)&4294967295); //@line 492 "numbers.cpp"
                var $arraydecay84=(($ph_accent1)&4294967295); //@line 492 "numbers.cpp"
                var $call85=_sprintf($42, ((__str2299)&4294967295), allocate([4,0,0,0,$arraydecay83,0,0,0,23,0,0,0,$arraydecay84,0,0,0,23,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 492 "numbers.cpp"
                __label__ = 24;break $if_then12$$if_end91$9;
              }
            } while(0);
  
            var $41=$ph_buf_addr; //@line 490 "numbers.cpp"
            var $arraydecay79=(($ph_accent1)&4294967295); //@line 490 "numbers.cpp"
            var $arraydecay80=(($ph_letter1)&4294967295); //@line 490 "numbers.cpp"
            var $call81=_sprintf($41, ((__str1298)&4294967295), allocate([$arraydecay79,0,0,0,23,0,0,0,6,0,0,0,$arraydecay80,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 490 "numbers.cpp"
            ; //@line 490 "numbers.cpp"
          }
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 497 "numbers.cpp"
    return;
  }
  

  function __ZL13LookupLetter2P10TranslatorjPc($tr, $letter, $ph_buf) {
    var __stackBase__  = STACKTOP; STACKTOP += 12; _memset(__stackBase__, 0, 12);
    var __label__;
  
    var $tr_addr;
    var $letter_addr;
    var $ph_buf_addr;
    var $len;
    var $single_letter=__stackBase__;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $ph_buf_addr=$ph_buf;
    var $arrayidx=(($single_letter)&4294967295); //@line 397 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 397 "numbers.cpp"
    var $arrayidx1=(($single_letter+1)&4294967295); //@line 398 "numbers.cpp"
    HEAP8[($arrayidx1)]=95; //@line 398 "numbers.cpp"
    var $0=$letter_addr; //@line 399 "numbers.cpp"
    var $arrayidx2=(($single_letter+2)&4294967295); //@line 399 "numbers.cpp"
    var $call=__Z8utf8_outjPc($0, $arrayidx2); //@line 399 "numbers.cpp"
    $len=$call; //@line 399 "numbers.cpp"
    var $1=$len; //@line 400 "numbers.cpp"
    var $add=((($1)+2)&4294967295); //@line 400 "numbers.cpp"
    var $arrayidx3=(($single_letter+$add)&4294967295); //@line 400 "numbers.cpp"
    HEAP8[($arrayidx3)]=32; //@line 400 "numbers.cpp"
    var $2=$len; //@line 401 "numbers.cpp"
    var $add4=((($2)+3)&4294967295); //@line 401 "numbers.cpp"
    var $arrayidx5=(($single_letter+$add4)&4294967295); //@line 401 "numbers.cpp"
    HEAP8[($arrayidx5)]=0; //@line 401 "numbers.cpp"
    var $3=$tr_addr; //@line 403 "numbers.cpp"
    var $arrayidx6=(($single_letter+1)&4294967295); //@line 403 "numbers.cpp"
    var $4=$ph_buf_addr; //@line 403 "numbers.cpp"
    var $call7=__Z6LookupP10TranslatorPKcPc($3, $arrayidx6, $4); //@line 403 "numbers.cpp"
    var $cmp=((($call7))|0)==0; //@line 403 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 403 "numbers.cpp"
    $if_then$$if_end15$2: do { 
      if (__label__ == 1) {
  
        var $arrayidx8=(($single_letter+1)&4294967295); //@line 405 "numbers.cpp"
        HEAP8[($arrayidx8)]=32; //@line 405 "numbers.cpp"
        var $5=$tr_addr; //@line 406 "numbers.cpp"
        var $arrayidx9=(($single_letter+2)&4294967295); //@line 406 "numbers.cpp"
        var $6=$ph_buf_addr; //@line 406 "numbers.cpp"
        var $call10=__Z6LookupP10TranslatorPKcPc($5, $arrayidx9, $6); //@line 406 "numbers.cpp"
        var $cmp11=((($call10))|0)==0; //@line 406 "numbers.cpp"
        if (!($cmp11)) { __label__ = 3;break $if_then$$if_end15$2; } //@line 406 "numbers.cpp"
  
        var $7=$tr_addr; //@line 408 "numbers.cpp"
        var $arrayidx13=(($single_letter+2)&4294967295); //@line 408 "numbers.cpp"
        var $8=$ph_buf_addr; //@line 408 "numbers.cpp"
        var $call14=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($7, $arrayidx13, $8, 20, 0, 0, 0); //@line 408 "numbers.cpp"
        ; //@line 409 "numbers.cpp"
      }
    } while(0);
  
    var $9=$ph_buf_addr; //@line 411 "numbers.cpp"
    var $arrayidx16=(($9)&4294967295); //@line 411 "numbers.cpp"
    var $10=HEAP8[($arrayidx16)]; //@line 411 "numbers.cpp"
    var $conv=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 411 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $conv; //@line 411 "numbers.cpp"
    return null;
  }
  

  function __Z12LookupLetterP10TranslatorjiPci($tr, $letter, $next_byte, $ph_buf1, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 48; _memset(__stackBase__, 0, 48);
    var __label__;
  
    var $tr_addr;
    var $letter_addr;
    var $next_byte_addr;
    var $ph_buf1_addr;
    var $control_addr;
    var $len;
    var $dict_flags=__stackBase__;
    var $ph_buf3=__stackBase__+8;
    var $ptr;
    $tr_addr=$tr;
    $letter_addr=$letter;
    $next_byte_addr=$next_byte;
    $ph_buf1_addr=$ph_buf1;
    $control_addr=$control;
    var $0=$ph_buf1_addr; //@line 511 "numbers.cpp"
    var $arrayidx=(($0)&4294967295); //@line 511 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 511 "numbers.cpp"
    var $1=$letter_addr; //@line 512 "numbers.cpp"
    var $call=__Z8utf8_outjPc($1, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295)); //@line 512 "numbers.cpp"
    $len=$call; //@line 512 "numbers.cpp"
    var $2=$len; //@line 513 "numbers.cpp"
    var $add=((($2)+2)&4294967295); //@line 513 "numbers.cpp"
    var $arrayidx1=((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+$add)&4294967295); //@line 513 "numbers.cpp"
    HEAP8[($arrayidx1)]=32; //@line 513 "numbers.cpp"
    var $3=$next_byte_addr; //@line 515 "numbers.cpp"
    var $cmp=((($3))|0)==-1; //@line 515 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 515 "numbers.cpp"
    $if_then$$if_end19$2: do { 
      if (__label__ == 1) {
  
        var $4=$tr_addr; //@line 518 "numbers.cpp"
        var $5=$ph_buf1_addr; //@line 518 "numbers.cpp"
        var $call2=__Z6LookupP10TranslatorPKcPc($4, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $5); //@line 518 "numbers.cpp"
        var $cmp3=((($call2))|0)!=0; //@line 518 "numbers.cpp"
        if ($cmp3) { __label__ = 20;break $if_then$$if_end19$2; } //@line 518 "numbers.cpp"
  
        HEAP8[(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295))]=95; //@line 521 "numbers.cpp"
        var $6=$tr_addr; //@line 522 "numbers.cpp"
        var $arraydecay=(($ph_buf3)&4294967295); //@line 522 "numbers.cpp"
        var $call5=__Z6LookupP10TranslatorPKcPc($6, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), $arraydecay); //@line 522 "numbers.cpp"
        var $cmp6=((($call5))|0)!=0; //@line 522 "numbers.cpp"
        if ($cmp6) { __label__ = 20;break $if_then$$if_end19$2; } //@line 522 "numbers.cpp"
  
        var $7=$tr_addr; //@line 526 "numbers.cpp"
        var $translator_name=(($7+280)&4294967295); //@line 526 "numbers.cpp"
        var $8=HEAP32[(($translator_name)>>2)]; //@line 526 "numbers.cpp"
        var $cmp9=((($8))|0)==25966; //@line 526 "numbers.cpp"
        if ($cmp9) { __label__ = 20;break $if_then$$if_end19$2; } //@line 526 "numbers.cpp"
  
        var $call12=__Z14SetTranslator2PKc(((__str52704)&4294967295)); //@line 529 "numbers.cpp"
        var $9=HEAP32[((_translator2)>>2)]; //@line 530 "numbers.cpp"
        var $arraydecay13=(($ph_buf3)&4294967295); //@line 530 "numbers.cpp"
        var $call14=__Z6LookupP10TranslatorPKcPc($9, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $arraydecay13); //@line 530 "numbers.cpp"
        var $cmp15=((($call14))|0)!=0; //@line 530 "numbers.cpp"
        if ($cmp15) { __label__ = 5;; } else { __label__ = 6;; } //@line 530 "numbers.cpp"
        if (__label__ == 5) {
  
          var $10=$ph_buf1_addr; //@line 533 "numbers.cpp"
          HEAP8[($10)]=21; //@line 533 "numbers.cpp"
          var $nul=(($10+1)&4294967295); //@line 533 "numbers.cpp"
          HEAP8[($nul)]=0; //@line 533 "numbers.cpp"
          ; //@line 534 "numbers.cpp"
        }
  
        var $11=HEAP32[((_voice)>>2)]; //@line 535 "numbers.cpp"
        var $phoneme_tab_ix=(($11+40)&4294967295); //@line 535 "numbers.cpp"
        var $12=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 535 "numbers.cpp"
        __Z18SelectPhonemeTablei($12); //@line 535 "numbers.cpp"
        ; //@line 536 "numbers.cpp"
      }
      else if (__label__ == 7) {
  
        var $13=$letter_addr; //@line 539 "numbers.cpp"
        var $cmp20=((($13))>>>0) <= 32; //@line 539 "numbers.cpp"
        if ($cmp20) { __label__ = 9;; } else { __label__ = 8;; } //@line 539 "numbers.cpp"
        $if_then22$$lor_lhs_false$11: do { 
          if (__label__ == 8) {
  
            var $14=$letter_addr; //@line 539 "numbers.cpp"
            var $call21=_iswspace($14); //@line 539 "numbers.cpp"
            var $tobool=((($call21))|0)!=0; //@line 539 "numbers.cpp"
            if ($tobool) { __label__ = 9;break $if_then22$$lor_lhs_false$11; } //@line 539 "numbers.cpp"
  
            var $18=$next_byte_addr; //@line 547 "numbers.cpp"
            var $cmp26=((($18))|0)!=32; //@line 547 "numbers.cpp"
            if ($cmp26) { __label__ = 11;; } else { __label__ = 12;; } //@line 547 "numbers.cpp"
            if (__label__ == 11) {
  
              $next_byte_addr=31; //@line 548 "numbers.cpp"
              ; //@line 548 "numbers.cpp"
            }
  
            var $19=$next_byte_addr; //@line 549 "numbers.cpp"
            var $conv=((($19)) & 255); //@line 549 "numbers.cpp"
            var $20=$len; //@line 549 "numbers.cpp"
            var $add29=((($20)+3)&4294967295); //@line 549 "numbers.cpp"
            var $arrayidx30=((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+$add29)&4294967295); //@line 549 "numbers.cpp"
            HEAP8[($arrayidx30)]=$conv; //@line 549 "numbers.cpp"
            HEAP8[(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295))]=95; //@line 551 "numbers.cpp"
            var $arrayidx31=(($dict_flags+4)&4294967295); //@line 554 "numbers.cpp"
            HEAP32[(($arrayidx31)>>2)]=0; //@line 554 "numbers.cpp"
            $ptr=((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295); //@line 555 "numbers.cpp"
            var $21=$tr_addr; //@line 557 "numbers.cpp"
            var $arraydecay32=(($ph_buf3)&4294967295); //@line 557 "numbers.cpp"
            var $call33=__Z6LookupP10TranslatorPKcPc($21, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), $arraydecay32); //@line 557 "numbers.cpp"
            var $cmp34=((($call33))|0)==0; //@line 557 "numbers.cpp"
            if ($cmp34) { __label__ = 13;; } else { __label__ = 15;; } //@line 557 "numbers.cpp"
            $if_then35$$if_end43$17: do { 
              if (__label__ == 13) {
  
                HEAP8[(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295))]=32; //@line 559 "numbers.cpp"
                var $22=$tr_addr; //@line 560 "numbers.cpp"
                var $arraydecay36=(($ph_buf3)&4294967295); //@line 560 "numbers.cpp"
                var $call37=__Z6LookupP10TranslatorPKcPc($22, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $arraydecay36); //@line 560 "numbers.cpp"
                var $cmp38=((($call37))|0)==0; //@line 560 "numbers.cpp"
                if (!($cmp38)) { __label__ = 15;break $if_then35$$if_end43$17; } //@line 560 "numbers.cpp"
  
                var $23=$tr_addr; //@line 562 "numbers.cpp"
                var $arraydecay40=(($ph_buf3)&4294967295); //@line 562 "numbers.cpp"
                var $call41=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($23, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+2)&4294967295), $arraydecay40, 40, 0, 268435456, 0); //@line 562 "numbers.cpp"
                ; //@line 563 "numbers.cpp"
              }
            } while(0);
  
            var $arrayidx44=(($ph_buf3)&4294967295); //@line 566 "numbers.cpp"
            var $24=HEAP8[($arrayidx44)]; //@line 566 "numbers.cpp"
            var $conv45=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 566 "numbers.cpp"
            var $cmp46=((($conv45))|0)==0; //@line 566 "numbers.cpp"
            if ($cmp46) { __label__ = 16;; } else { __label__ = 17;; } //@line 566 "numbers.cpp"
            if (__label__ == 16) {
  
              var $25=$tr_addr; //@line 568 "numbers.cpp"
              var $26=$letter_addr; //@line 568 "numbers.cpp"
              var $arraydecay48=(($ph_buf3)&4294967295); //@line 568 "numbers.cpp"
              __Z20LookupAccentedLetterP10TranslatorjPc($25, $26, $arraydecay48); //@line 568 "numbers.cpp"
              ; //@line 569 "numbers.cpp"
            }
  
            var $27=$ph_buf1_addr; //@line 571 "numbers.cpp"
            var $arraydecay50=(($ph_buf3)&4294967295); //@line 571 "numbers.cpp"
            var $call51=_strcpy($27, $arraydecay50); //@line 571 "numbers.cpp"
            var $28=$ph_buf1_addr; //@line 572 "numbers.cpp"
            var $arrayidx52=(($28)&4294967295); //@line 572 "numbers.cpp"
            var $29=HEAP8[($arrayidx52)]; //@line 572 "numbers.cpp"
            var $conv53=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 572 "numbers.cpp"
            var $cmp54=((($conv53))|0)==0; //@line 572 "numbers.cpp"
            if ($cmp54) { __label__ = 20;break $if_then$$if_end19$2; } //@line 572 "numbers.cpp"
  
            var $30=$ph_buf1_addr; //@line 572 "numbers.cpp"
            var $arrayidx56=(($30)&4294967295); //@line 572 "numbers.cpp"
            var $31=HEAP8[($arrayidx56)]; //@line 572 "numbers.cpp"
            var $conv57=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 572 "numbers.cpp"
            var $cmp58=((($conv57))|0)==21; //@line 572 "numbers.cpp"
            if ($cmp58) { __label__ = 20;break $if_then$$if_end19$2; } //@line 572 "numbers.cpp"
  
            var $arrayidx61=(($dict_flags)&4294967295); //@line 577 "numbers.cpp"
            HEAP32[(($arrayidx61)>>2)]=0; //@line 577 "numbers.cpp"
            var $arrayidx62=(($dict_flags+4)&4294967295); //@line 578 "numbers.cpp"
            HEAP32[(($arrayidx62)>>2)]=0; //@line 578 "numbers.cpp"
            var $32=$tr_addr; //@line 579 "numbers.cpp"
            var $33=$ph_buf1_addr; //@line 579 "numbers.cpp"
            var $arraydecay63=(($dict_flags)&4294967295); //@line 579 "numbers.cpp"
            var $34=$control_addr; //@line 579 "numbers.cpp"
            var $and=($34) & 1; //@line 579 "numbers.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($32, $33, $arraydecay63, -1, $and); //@line 579 "numbers.cpp"
            __label__ = 20;break $if_then$$if_end19$2; //@line 581 "numbers.cpp"
          }
        } while(0);
  
        var $15=$letter_addr; //@line 542 "numbers.cpp"
        var $call23=_sprintf(((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), ((__str5302)&4294967295), allocate([$15,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 542 "numbers.cpp"
        var $16=$tr_addr; //@line 543 "numbers.cpp"
        var $17=$ph_buf1_addr; //@line 543 "numbers.cpp"
        var $call24=__Z6LookupP10TranslatorPKcPc($16, ((__ZZ12LookupLetterP10TranslatorjiPciE13single_letter+1)&4294967295), $17); //@line 543 "numbers.cpp"
        ; //@line 544 "numbers.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 581 "numbers.cpp"
    return;
  }
  

  function __Z15TranslateLetterP10TranslatorPcS1_i($tr, $word, $phonemes, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 152; _memset(__stackBase__, 0, 152);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $phonemes_addr;
    var $control_addr;
    var $n_bytes;
    var $letter=__stackBase__;
    var $len;
    var $save_option_phonemes;
    var $p2;
    var $pbuf;
    var $capital=__stackBase__+4;
    var $ph_buf=__stackBase__+24;
    var $ph_buf2=__stackBase__+84;
    var $hexbuf=__stackBase__+144;
    $tr_addr=$tr;
    $word_addr=$word;
    $phonemes_addr=$phonemes;
    $control_addr=$control;
    var $arrayidx=(($ph_buf)&4294967295); //@line 603 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 603 "numbers.cpp"
    var $arrayidx1=(($capital)&4294967295); //@line 604 "numbers.cpp"
    HEAP8[($arrayidx1)]=0; //@line 604 "numbers.cpp"
    var $0=$word_addr; //@line 606 "numbers.cpp"
    var $call=__Z7utf8_inPiPKc($letter, $0); //@line 606 "numbers.cpp"
    $n_bytes=$call; //@line 606 "numbers.cpp"
    var $1=HEAP32[(($letter)>>2)]; //@line 608 "numbers.cpp"
    var $and=($1) & 1048320; //@line 608 "numbers.cpp"
    var $cmp=((($and))|0)==57344; //@line 608 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 608 "numbers.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[(($letter)>>2)]; //@line 610 "numbers.cpp"
      var $and2=($2) & 255; //@line 610 "numbers.cpp"
      HEAP32[(($letter)>>2)]=$and2; //@line 610 "numbers.cpp"
      ; //@line 611 "numbers.cpp"
    }
  
    var $3=$control_addr; //@line 613 "numbers.cpp"
    var $and3=($3) & 2; //@line 613 "numbers.cpp"
    var $tobool=((($and3))|0)!=0; //@line 613 "numbers.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 5;; } //@line 613 "numbers.cpp"
    $if_then4$$if_end10$5: do { 
      if (__label__ == 3) {
  
        var $4=HEAP32[(($letter)>>2)]; //@line 616 "numbers.cpp"
        var $call5=_iswupper($4); //@line 616 "numbers.cpp"
        var $tobool6=((($call5))|0)!=0; //@line 616 "numbers.cpp"
        if (!($tobool6)) { __label__ = 5;break $if_then4$$if_end10$5; } //@line 616 "numbers.cpp"
  
        var $5=$tr_addr; //@line 618 "numbers.cpp"
        var $arraydecay=(($capital)&4294967295); //@line 618 "numbers.cpp"
        var $call8=__Z6LookupP10TranslatorPKcPc($5, ((__str6303)&4294967295), $arraydecay); //@line 618 "numbers.cpp"
        ; //@line 619 "numbers.cpp"
      }
    } while(0);
  
    var $6=HEAP32[(($letter)>>2)]; //@line 621 "numbers.cpp"
    var $call11=__Z9towlower2j($6); //@line 621 "numbers.cpp"
    HEAP32[(($letter)>>2)]=$call11; //@line 621 "numbers.cpp"
    var $7=$tr_addr; //@line 623 "numbers.cpp"
    var $8=HEAP32[(($letter)>>2)]; //@line 623 "numbers.cpp"
    var $9=$n_bytes; //@line 623 "numbers.cpp"
    var $10=$word_addr; //@line 623 "numbers.cpp"
    var $arrayidx12=(($10+$9)&4294967295); //@line 623 "numbers.cpp"
    var $11=HEAP8[($arrayidx12)]; //@line 623 "numbers.cpp"
    var $conv=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 623 "numbers.cpp"
    var $arraydecay13=(($ph_buf)&4294967295); //@line 623 "numbers.cpp"
    var $12=$control_addr; //@line 623 "numbers.cpp"
    var $and14=($12) & 1; //@line 623 "numbers.cpp"
    __Z12LookupLetterP10TranslatorjiPci($7, $8, $conv, $arraydecay13, $and14); //@line 623 "numbers.cpp"
    var $arrayidx15=(($ph_buf)&4294967295); //@line 625 "numbers.cpp"
    var $13=HEAP8[($arrayidx15)]; //@line 625 "numbers.cpp"
    var $conv16=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 625 "numbers.cpp"
    var $cmp17=((($conv16))|0)==21; //@line 625 "numbers.cpp"
    if ($cmp17) { __label__ = 6;; } else { __label__ = 7;; } //@line 625 "numbers.cpp"
    $if_then18$$if_end21$9: do { 
      if (__label__ == 6) {
  
        var $14=$phonemes_addr; //@line 627 "numbers.cpp"
        var $arraydecay19=(($ph_buf)&4294967295); //@line 627 "numbers.cpp"
        var $call20=_strcpy($14, $arraydecay19); //@line 627 "numbers.cpp"
        $retval=0; //@line 628 "numbers.cpp"
        ; //@line 628 "numbers.cpp"
      }
      else if (__label__ == 7) {
  
        var $arrayidx22=(($ph_buf)&4294967295); //@line 631 "numbers.cpp"
        var $15=HEAP8[($arrayidx22)]; //@line 631 "numbers.cpp"
        var $conv23=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 631 "numbers.cpp"
        var $cmp24=((($conv23))|0)==0; //@line 631 "numbers.cpp"
        if ($cmp24) { __label__ = 8;; } else { __label__ = 11;; } //@line 631 "numbers.cpp"
        $land_lhs_true$$if_end38$12: do { 
          if (__label__ == 8) {
  
            var $16=$tr_addr; //@line 631 "numbers.cpp"
            var $translator_name=(($16+280)&4294967295); //@line 631 "numbers.cpp"
            var $17=HEAP32[(($translator_name)>>2)]; //@line 631 "numbers.cpp"
            var $cmp25=((($17))|0)!=25966; //@line 631 "numbers.cpp"
            if (!($cmp25)) { __label__ = 11;break $land_lhs_true$$if_end38$12; } //@line 631 "numbers.cpp"
  
            var $call27=__Z14SetTranslator2PKc(((__str52704)&4294967295)); //@line 634 "numbers.cpp"
            var $18=HEAP32[((_option_phonemes)>>2)]; //@line 635 "numbers.cpp"
            $save_option_phonemes=$18; //@line 635 "numbers.cpp"
            HEAP32[((_option_phonemes)>>2)]=0; //@line 636 "numbers.cpp"
            var $19=HEAP32[((_translator2)>>2)]; //@line 637 "numbers.cpp"
            var $20=HEAP32[(($letter)>>2)]; //@line 637 "numbers.cpp"
            var $21=$n_bytes; //@line 637 "numbers.cpp"
            var $22=$word_addr; //@line 637 "numbers.cpp"
            var $arrayidx28=(($22+$21)&4294967295); //@line 637 "numbers.cpp"
            var $23=HEAP8[($arrayidx28)]; //@line 637 "numbers.cpp"
            var $conv29=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 637 "numbers.cpp"
            var $arraydecay30=(($ph_buf)&4294967295); //@line 637 "numbers.cpp"
            var $24=$control_addr; //@line 637 "numbers.cpp"
            var $and31=($24) & 1; //@line 637 "numbers.cpp"
            __Z12LookupLetterP10TranslatorjiPci($19, $20, $conv29, $arraydecay30, $and31); //@line 637 "numbers.cpp"
            var $25=HEAP32[((_voice)>>2)]; //@line 638 "numbers.cpp"
            var $phoneme_tab_ix=(($25+40)&4294967295); //@line 638 "numbers.cpp"
            var $26=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 638 "numbers.cpp"
            __Z18SelectPhonemeTablei($26); //@line 638 "numbers.cpp"
            var $27=$save_option_phonemes; //@line 639 "numbers.cpp"
            HEAP32[((_option_phonemes)>>2)]=$27; //@line 639 "numbers.cpp"
            var $arrayidx32=(($ph_buf)&4294967295); //@line 641 "numbers.cpp"
            var $28=HEAP8[($arrayidx32)]; //@line 641 "numbers.cpp"
            var $conv33=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 641 "numbers.cpp"
            var $cmp34=((($conv33))|0)!=0; //@line 641 "numbers.cpp"
            if (!($cmp34)) { __label__ = 11;break $land_lhs_true$$if_end38$12; } //@line 641 "numbers.cpp"
  
            var $29=$phonemes_addr; //@line 643 "numbers.cpp"
            var $call36=_sprintf($29, ((__str7304)&4294967295), allocate([21,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 643 "numbers.cpp"
            $retval=0; //@line 644 "numbers.cpp"
            __label__ = 26;break $if_then18$$if_end21$9; //@line 644 "numbers.cpp"
          }
        } while(0);
  
        var $arrayidx39=(($ph_buf)&4294967295); //@line 648 "numbers.cpp"
        var $30=HEAP8[($arrayidx39)]; //@line 648 "numbers.cpp"
        var $conv40=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 648 "numbers.cpp"
        var $cmp41=((($conv40))|0)==0; //@line 648 "numbers.cpp"
        if ($cmp41) { __label__ = 12;; } else { __label__ = 20;; } //@line 648 "numbers.cpp"
        $if_then42$$if_end73$17: do { 
          if (__label__ == 12) {
  
            var $31=HEAP32[(($letter)>>2)]; //@line 651 "numbers.cpp"
            var $call43=_iswalpha($31); //@line 651 "numbers.cpp"
            var $tobool44=((($call43))|0)!=0; //@line 651 "numbers.cpp"
            if ($tobool44) { __label__ = 13;; } else { __label__ = 14;; } //@line 651 "numbers.cpp"
            if (__label__ == 13) {
  
              var $32=$tr_addr; //@line 652 "numbers.cpp"
              var $arraydecay46=(($ph_buf)&4294967295); //@line 652 "numbers.cpp"
              var $call47=__Z6LookupP10TranslatorPKcPc($32, ((__str8305)&4294967295), $arraydecay46); //@line 652 "numbers.cpp"
              ; //@line 652 "numbers.cpp"
            }
  
            var $arrayidx49=(($ph_buf)&4294967295); //@line 654 "numbers.cpp"
            var $33=HEAP8[($arrayidx49)]; //@line 654 "numbers.cpp"
            var $conv50=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 654 "numbers.cpp"
            var $cmp51=((($conv50))|0)==0; //@line 654 "numbers.cpp"
            if ($cmp51) { __label__ = 15;; } else { __label__ = 17;; } //@line 654 "numbers.cpp"
            $land_lhs_true52$$if_end58$22: do { 
              if (__label__ == 15) {
  
                var $34=HEAP32[(($letter)>>2)]; //@line 654 "numbers.cpp"
                var $call53=_iswspace($34); //@line 654 "numbers.cpp"
                var $tobool54=((($call53))|0)!=0; //@line 654 "numbers.cpp"
                if ($tobool54) { __label__ = 17;break $land_lhs_true52$$if_end58$22; } //@line 654 "numbers.cpp"
  
                var $35=$tr_addr; //@line 655 "numbers.cpp"
                var $arraydecay56=(($ph_buf)&4294967295); //@line 655 "numbers.cpp"
                var $call57=__Z6LookupP10TranslatorPKcPc($35, ((__str9306)&4294967295), $arraydecay56); //@line 655 "numbers.cpp"
                ; //@line 655 "numbers.cpp"
              }
            } while(0);
  
            var $arrayidx59=(($ph_buf)&4294967295); //@line 657 "numbers.cpp"
            var $36=HEAP8[($arrayidx59)]; //@line 657 "numbers.cpp"
            var $conv60=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 657 "numbers.cpp"
            var $cmp61=((($conv60))|0)!=0; //@line 657 "numbers.cpp"
            if (!($cmp61)) { __label__ = 20;break $if_then42$$if_end73$17; } //@line 657 "numbers.cpp"
  
            var $arraydecay63=(($hexbuf)&4294967295); //@line 660 "numbers.cpp"
            var $37=HEAP32[(($letter)>>2)]; //@line 660 "numbers.cpp"
            var $call64=_sprintf($arraydecay63, ((__str10307)&4294967295), allocate([$37,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 660 "numbers.cpp"
            var $arraydecay65=(($ph_buf)&4294967295); //@line 661 "numbers.cpp"
            $pbuf=$arraydecay65; //@line 661 "numbers.cpp"
            var $arraydecay66=(($hexbuf)&4294967295); //@line 662 "numbers.cpp"
            $p2=$arraydecay66; //@line 662 "numbers.cpp"
            var $38=$p2; //@line 662 "numbers.cpp"
            var $39=HEAP8[($38)]; //@line 662 "numbers.cpp"
            var $conv671=(tempInt=(($39)),(tempInt>=128?tempInt-256:tempInt)); //@line 662 "numbers.cpp"
            var $cmp682=((($conv671))|0)!=0; //@line 662 "numbers.cpp"
            if (!($cmp682)) { __label__ = 20;break $if_then42$$if_end73$17; } //@line 662 "numbers.cpp"
            while(1) { 
  
              var $40=$pbuf; //@line 664 "numbers.cpp"
              var $call69=_strlen($40); //@line 664 "numbers.cpp"
              var $41=$pbuf; //@line 664 "numbers.cpp"
              var $add_ptr=(($41+$call69)&4294967295); //@line 664 "numbers.cpp"
              $pbuf=$add_ptr; //@line 664 "numbers.cpp"
              var $42=$pbuf; //@line 665 "numbers.cpp"
              var $incdec_ptr=(($42+1)&4294967295); //@line 665 "numbers.cpp"
              $pbuf=$incdec_ptr; //@line 665 "numbers.cpp"
              HEAP8[($42)]=23; //@line 665 "numbers.cpp"
              var $43=$tr_addr; //@line 666 "numbers.cpp"
              var $44=$p2; //@line 666 "numbers.cpp"
              var $45=HEAP8[($44)]; //@line 666 "numbers.cpp"
              var $conv70=(tempInt=(($45)),(tempInt>=128?tempInt-256:tempInt)); //@line 666 "numbers.cpp"
              var $46=$pbuf; //@line 666 "numbers.cpp"
              __Z12LookupLetterP10TranslatorjiPci($43, $conv70, 0, $46, 1); //@line 666 "numbers.cpp"
              var $47=$p2; //@line 662 "numbers.cpp"
              var $incdec_ptr71=(($47+1)&4294967295); //@line 662 "numbers.cpp"
              $p2=$incdec_ptr71; //@line 662 "numbers.cpp"
              var $48=$p2; //@line 662 "numbers.cpp"
              var $49=HEAP8[($48)]; //@line 662 "numbers.cpp"
              var $conv67=(tempInt=(($49)),(tempInt>=128?tempInt-256:tempInt)); //@line 662 "numbers.cpp"
              var $cmp68=((($conv67))|0)!=0; //@line 662 "numbers.cpp"
              if ($cmp68) { __label__ = 19;continue ; } else { __label__ = 20;break $if_then42$$if_end73$17; } //@line 662 "numbers.cpp"
            }
          }
        } while(0);
  
        var $50=$phonemes_addr; //@line 671 "numbers.cpp"
        var $call74=_strlen($50); //@line 671 "numbers.cpp"
        $len=$call74; //@line 671 "numbers.cpp"
        var $51=$tr_addr; //@line 672 "numbers.cpp"
        var $langopts=(($51)&4294967295); //@line 672 "numbers.cpp"
        var $accents=(($langopts+220)&4294967295); //@line 672 "numbers.cpp"
        var $52=HEAP32[(($accents)>>2)]; //@line 672 "numbers.cpp"
        var $and75=($52) & 2; //@line 672 "numbers.cpp"
        var $tobool76=((($and75))|0)!=0; //@line 672 "numbers.cpp"
        var $arraydecay78=(($ph_buf2)&4294967295); //@line 673 "numbers.cpp"
        if ($tobool76) { __label__ = 21;; } else { __label__ = 22;; } //@line 672 "numbers.cpp"
        if (__label__ == 21) {
  
          var $arraydecay79=(($ph_buf)&4294967295); //@line 673 "numbers.cpp"
          var $arraydecay80=(($capital)&4294967295); //@line 673 "numbers.cpp"
          var $call81=_sprintf($arraydecay78, ((__str11308)&4294967295), allocate([255,0,0,0,$arraydecay79,0,0,0,$arraydecay80,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 673 "numbers.cpp"
          ; //@line 673 "numbers.cpp"
        }
        else if (__label__ == 22) {
  
          var $arraydecay83=(($capital)&4294967295); //@line 675 "numbers.cpp"
          var $arraydecay84=(($ph_buf)&4294967295); //@line 675 "numbers.cpp"
          var $call85=_sprintf($arraydecay78, ((__str11308)&4294967295), allocate([255,0,0,0,$arraydecay83,0,0,0,$arraydecay84,0,0,0], ["i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 675 "numbers.cpp"
          ;
        }
  
        var $53=$len; //@line 676 "numbers.cpp"
        var $arraydecay87=(($ph_buf2)&4294967295); //@line 676 "numbers.cpp"
        var $call88=_strlen($arraydecay87); //@line 676 "numbers.cpp"
        var $add=((($call88)+($53))&4294967295); //@line 676 "numbers.cpp"
        var $cmp89=((($add))>>>0) < 160; //@line 676 "numbers.cpp"
        if ($cmp89) { __label__ = 24;; } else { __label__ = 25;; } //@line 676 "numbers.cpp"
        if (__label__ == 24) {
  
          var $54=$len; //@line 678 "numbers.cpp"
          var $55=$phonemes_addr; //@line 678 "numbers.cpp"
          var $arrayidx91=(($55+$54)&4294967295); //@line 678 "numbers.cpp"
          var $arraydecay92=(($ph_buf2)&4294967295); //@line 678 "numbers.cpp"
          var $call93=_strcpy($arrayidx91, $arraydecay92); //@line 678 "numbers.cpp"
          ; //@line 679 "numbers.cpp"
        }
  
        var $56=$n_bytes; //@line 680 "numbers.cpp"
        $retval=$56; //@line 680 "numbers.cpp"
        ; //@line 680 "numbers.cpp"
      }
    } while(0);
  
    var $57=$retval; //@line 681 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $57; //@line 681 "numbers.cpp"
    return null;
  }
  

  function __Z17SetSpellingStressP10TranslatorPcii($tr, $phonemes, $control, $n_chars) {
    var __stackBase__  = STACKTOP; STACKTOP += 160; _memset(__stackBase__, 0, 160);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $phonemes_addr;
    var $control_addr;
    var $n_chars_addr;
    var $ix;
    var $c;
    var $n_stress;
    var $count;
    var $buf=__stackBase__;
    $tr_addr=$tr;
    $phonemes_addr=$phonemes;
    $control_addr=$control;
    $n_chars_addr=$n_chars;
    $n_stress=0; //@line 690 "numbers.cpp"
    $ix=0; //@line 694 "numbers.cpp"
    var $0=$ix; //@line 694 "numbers.cpp"
    var $1=$phonemes_addr; //@line 694 "numbers.cpp"
    var $arrayidx4=(($1+$0)&4294967295); //@line 694 "numbers.cpp"
    var $2=HEAP8[($arrayidx4)]; //@line 694 "numbers.cpp"
    var $conv5=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 694 "numbers.cpp"
    $c=$conv5; //@line 694 "numbers.cpp"
    var $cmp6=((($conv5))|0)!=0; //@line 694 "numbers.cpp"
    if ($cmp6) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 4;; } //@line 694 "numbers.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=__lastLabel__ == 0 ? $conv5 : ($conv); //@line 696 "numbers.cpp"
          var $cmp1=((($3))|0)==6; //@line 696 "numbers.cpp"
          if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 696 "numbers.cpp"
          if (__label__ == 2) {
  
            var $4=$n_stress; //@line 698 "numbers.cpp"
            var $inc=((($4)+1)&4294967295); //@line 698 "numbers.cpp"
            $n_stress=$inc; //@line 698 "numbers.cpp"
            ; //@line 699 "numbers.cpp"
          }
  
          var $5=$c; //@line 700 "numbers.cpp"
          var $conv2=((($5)) & 255); //@line 700 "numbers.cpp"
          var $6=$ix; //@line 700 "numbers.cpp"
          var $arrayidx3=(($buf+$6)&4294967295); //@line 700 "numbers.cpp"
          HEAP8[($arrayidx3)]=$conv2; //@line 700 "numbers.cpp"
          var $7=$ix; //@line 694 "numbers.cpp"
          var $inc4=((($7)+1)&4294967295); //@line 694 "numbers.cpp"
          $ix=$inc4; //@line 694 "numbers.cpp"
          var $8=$ix; //@line 694 "numbers.cpp"
          var $9=$phonemes_addr; //@line 694 "numbers.cpp"
          var $arrayidx=(($9+$8)&4294967295); //@line 694 "numbers.cpp"
          var $10=HEAP8[($arrayidx)]; //@line 694 "numbers.cpp"
          var $conv=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 694 "numbers.cpp"
          $c=$conv; //@line 694 "numbers.cpp"
          var $cmp=((($conv))|0)!=0; //@line 694 "numbers.cpp"
          if ($cmp) { __lastLabel__ = 3; __label__ = 1;continue ; } else { __lastLabel__ = 3; __label__ = 4;break $for_body$$for_end$2; } //@line 694 "numbers.cpp"
        }
      }
    } while(0);
  
    var $11=$ix; //@line 702 "numbers.cpp"
    var $arrayidx5=(($buf+$11)&4294967295); //@line 702 "numbers.cpp"
    HEAP8[($arrayidx5)]=0; //@line 702 "numbers.cpp"
    $count=0; //@line 704 "numbers.cpp"
    $ix=0; //@line 705 "numbers.cpp"
    var $12=$ix; //@line 705 "numbers.cpp"
    var $arrayidx71=(($buf+$12)&4294967295); //@line 705 "numbers.cpp"
    var $13=HEAPU8[($arrayidx71)]; //@line 705 "numbers.cpp"
    var $conv82=((($13))&255); //@line 705 "numbers.cpp"
    $c=$conv82; //@line 705 "numbers.cpp"
    var $cmp93=((($conv82))|0)!=0; //@line 705 "numbers.cpp"
    if ($cmp93) { __lastLabel__ = 4; __label__ = 5;; } else { __lastLabel__ = 4; __label__ = 26;; } //@line 705 "numbers.cpp"
    $for_body10$$for_end52$9: do { 
      if (__label__ == 5) {
        $for_body10$10: while(1) { 
  
          var $14=__lastLabel__ == 4 ? $conv82 : ($conv8); //@line 707 "numbers.cpp"
          var $cmp11=((($14))|0)==6; //@line 707 "numbers.cpp"
          if ($cmp11) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 15;; } //@line 707 "numbers.cpp"
          $land_lhs_true$$if_else29$12: do { 
            if (__label__ == 6) {
  
              var $15=$n_chars_addr; //@line 707 "numbers.cpp"
              var $cmp12=((($15))|0) > 1; //@line 707 "numbers.cpp"
              if ($cmp12) { __label__ = 7;; } else { __label__ = 14;; } //@line 707 "numbers.cpp"
              if (__label__ == 7) {
  
                var $16=$count; //@line 709 "numbers.cpp"
                var $inc14=((($16)+1)&4294967295); //@line 709 "numbers.cpp"
                $count=$inc14; //@line 709 "numbers.cpp"
                var $17=$tr_addr; //@line 711 "numbers.cpp"
                var $langopts=(($17)&4294967295); //@line 711 "numbers.cpp"
                var $spelling_stress=(($langopts+249)&4294967295); //@line 711 "numbers.cpp"
                var $18=HEAP8[($spelling_stress)]; //@line 711 "numbers.cpp"
                var $conv15=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 711 "numbers.cpp"
                var $cmp16=((($conv15))|0)==1; //@line 711 "numbers.cpp"
                var $19=$count; //@line 714 "numbers.cpp"
                if ($cmp16) { __label__ = 8;; } else { __label__ = 10;; } //@line 711 "numbers.cpp"
                if (__label__ == 8) {
  
                  var $cmp18=((($19))|0) > 1; //@line 714 "numbers.cpp"
                  if (!($cmp18)) { __label__ = 24;break $land_lhs_true$$if_else29$12; } //@line 714 "numbers.cpp"
  
                  $c=5; //@line 715 "numbers.cpp"
                  __label__ = 24;break $land_lhs_true$$if_else29$12; //@line 715 "numbers.cpp"
                }
                else if (__label__ == 10) {
  
                  var $20=$n_stress; //@line 719 "numbers.cpp"
                  var $cmp21=((($19))|0)!=((($20))|0); //@line 719 "numbers.cpp"
                  if (!($cmp21)) { __label__ = 24;break $land_lhs_true$$if_else29$12; } //@line 719 "numbers.cpp"
  
                  var $21=$count; //@line 721 "numbers.cpp"
                  var $rem=((($21))|0)%3; //@line 721 "numbers.cpp"
                  var $cmp23=((($rem))|0)!=0; //@line 721 "numbers.cpp"
                  if ($cmp23) { __label__ = 13;; } else { __label__ = 12;; } //@line 721 "numbers.cpp"
                  if (__label__ == 12) {
  
                    var $22=$count; //@line 721 "numbers.cpp"
                    var $23=$n_stress; //@line 721 "numbers.cpp"
                    var $sub=((($23)-1)&4294967295); //@line 721 "numbers.cpp"
                    var $cmp24=((($22))|0)==((($sub))|0); //@line 721 "numbers.cpp"
                    if (!($cmp24)) { __label__ = 24;break $land_lhs_true$$if_else29$12; } //@line 721 "numbers.cpp"
                  }
  
                  $c=5; //@line 722 "numbers.cpp"
                  __label__ = 24;break $land_lhs_true$$if_else29$12; //@line 722 "numbers.cpp"
                }
              }
              else if (__label__ == 14) {
  
                var $_pr=$c; //@line 727 "numbers.cpp"
                __lastLabel__ = 14; __label__ = 15;break $land_lhs_true$$if_else29$12;
              }
            }
          } while(0);
          $if_end48$$if_else29$25: do { 
            if (__label__ == 15) {
  
              var $24=__lastLabel__ == 14 ? $_pr : ($14); //@line 727 "numbers.cpp"
              var $cmp30=((($24))|0)==255; //@line 727 "numbers.cpp"
              if (!($cmp30)) { __label__ = 24;break $if_end48$$if_else29$25; } //@line 727 "numbers.cpp"
  
              var $25=$control_addr; //@line 729 "numbers.cpp"
              var $cmp32=((($25))|0) < 2; //@line 729 "numbers.cpp"
              if ($cmp32) { __label__ = 25;break $if_end48$$if_else29$25; } //@line 729 "numbers.cpp"
  
              var $26=$ix; //@line 729 "numbers.cpp"
              var $cmp34=((($26))|0)==0; //@line 729 "numbers.cpp"
              if ($cmp34) { __label__ = 25;break $if_end48$$if_else29$25; } //@line 729 "numbers.cpp"
  
              var $27=$control_addr; //@line 732 "numbers.cpp"
              var $cmp37=((($27))|0)==4; //@line 732 "numbers.cpp"
              if ($cmp37) { __label__ = 19;; } else { __label__ = 20;; } //@line 732 "numbers.cpp"
              if (__label__ == 19) {
  
                $c=9; //@line 733 "numbers.cpp"
                ; //@line 733 "numbers.cpp"
              }
  
              var $28=$count; //@line 734 "numbers.cpp"
              var $rem40=((($28))|0)%3; //@line 734 "numbers.cpp"
              var $cmp41=((($rem40))|0)==0; //@line 734 "numbers.cpp"
              if ($cmp41) { __label__ = 22;; } else { __label__ = 21;; } //@line 734 "numbers.cpp"
              $if_then44$$lor_lhs_false42$33: do { 
                if (__label__ == 21) {
  
                  var $29=$control_addr; //@line 734 "numbers.cpp"
                  var $cmp43=((($29))|0) > 2; //@line 734 "numbers.cpp"
                  if ($cmp43) { __label__ = 22;break $if_then44$$lor_lhs_false42$33; } //@line 734 "numbers.cpp"
  
                  $c=23; //@line 737 "numbers.cpp"
                  __label__ = 24;break $if_end48$$if_else29$25;
                }
              } while(0);
  
              $c=11; //@line 735 "numbers.cpp"
              __label__ = 24;break $if_end48$$if_else29$25; //@line 735 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 24) {
  
            var $30=$c; //@line 741 "numbers.cpp"
            var $conv49=((($30)) & 255); //@line 741 "numbers.cpp"
            var $31=$phonemes_addr; //@line 741 "numbers.cpp"
            var $incdec_ptr=(($31+1)&4294967295); //@line 741 "numbers.cpp"
            $phonemes_addr=$incdec_ptr; //@line 741 "numbers.cpp"
            HEAP8[($31)]=$conv49; //@line 741 "numbers.cpp"
            ; //@line 742 "numbers.cpp"
          }
  
          var $32=$ix; //@line 705 "numbers.cpp"
          var $inc51=((($32)+1)&4294967295); //@line 705 "numbers.cpp"
          $ix=$inc51; //@line 705 "numbers.cpp"
          var $33=$ix; //@line 705 "numbers.cpp"
          var $arrayidx7=(($buf+$33)&4294967295); //@line 705 "numbers.cpp"
          var $34=HEAPU8[($arrayidx7)]; //@line 705 "numbers.cpp"
          var $conv8=((($34))&255); //@line 705 "numbers.cpp"
          $c=$conv8; //@line 705 "numbers.cpp"
          var $cmp9=((($conv8))|0)!=0; //@line 705 "numbers.cpp"
          if ($cmp9) { __lastLabel__ = 25; __label__ = 5;continue $for_body10$10; } else { __lastLabel__ = 25; __label__ = 26;break $for_body10$$for_end52$9; } //@line 705 "numbers.cpp"
        }
      }
    } while(0);
  
    var $35=$control_addr; //@line 743 "numbers.cpp"
    var $cmp53=((($35))|0) >= 2; //@line 743 "numbers.cpp"
    if ($cmp53) { __label__ = 27;; } else { __label__ = 28;; } //@line 743 "numbers.cpp"
    if (__label__ == 27) {
  
      var $36=$phonemes_addr; //@line 744 "numbers.cpp"
      var $incdec_ptr55=(($36+1)&4294967295); //@line 744 "numbers.cpp"
      $phonemes_addr=$incdec_ptr55; //@line 744 "numbers.cpp"
      HEAP8[($36)]=11; //@line 744 "numbers.cpp"
      ; //@line 744 "numbers.cpp"
    }
  
    var $37=$phonemes_addr; //@line 745 "numbers.cpp"
    HEAP8[($37)]=0; //@line 745 "numbers.cpp"
    STACKTOP = __stackBase__;
    return; //@line 746 "numbers.cpp"
    return;
  }
  

  function __Z14TranslateRomanP10TranslatorPcS1_P8WORD_TAB($tr, $word, $ph_out, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 200; _memset(__stackBase__, 0, 200);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $ph_out_addr;
    var $wtab_addr;
    var $c;
    var $p;
    var $p2;
    var $acc;
    var $prev;
    var $value;
    var $subtract;
    var $repeat;
    var $n_digits;
    var $word_start;
    var $num_control;
    var $flags=__stackBase__;
    var $ph_roman=__stackBase__+8;
    var $number_chars=__stackBase__+40;
    $tr_addr=$tr;
    $word_addr=$word;
    $ph_out_addr=$ph_out;
    $wtab_addr=$wtab;
    $repeat=0; //@line 839 "numbers.cpp"
    $n_digits=0; //@line 840 "numbers.cpp"
    $num_control=0; //@line 842 "numbers.cpp"
    $acc=0; //@line 850 "numbers.cpp"
    $prev=0; //@line 851 "numbers.cpp"
    $subtract=32767; //@line 852 "numbers.cpp"
    var $0=$ph_out_addr; //@line 853 "numbers.cpp"
    var $arrayidx=(($0)&4294967295); //@line 853 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 853 "numbers.cpp"
    var $arrayidx1=(($flags)&4294967295); //@line 854 "numbers.cpp"
    HEAP32[(($arrayidx1)>>2)]=0; //@line 854 "numbers.cpp"
    var $arrayidx2=(($flags+4)&4294967295); //@line 855 "numbers.cpp"
    HEAP32[(($arrayidx2)>>2)]=0; //@line 855 "numbers.cpp"
    var $1=$tr_addr; //@line 857 "numbers.cpp"
    var $langopts=(($1)&4294967295); //@line 857 "numbers.cpp"
    var $numbers=(($langopts+184)&4294967295); //@line 857 "numbers.cpp"
    var $2=HEAP32[(($numbers)>>2)]; //@line 857 "numbers.cpp"
    var $and=($2) & 33554432; //@line 857 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 857 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 857 "numbers.cpp"
    $land_lhs_true$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $3=$wtab_addr; //@line 857 "numbers.cpp"
        var $arrayidx3=(($3)&4294967295); //@line 857 "numbers.cpp"
        var $flags4=(($arrayidx3)&4294967295); //@line 857 "numbers.cpp"
        var $4=HEAP32[(($flags4)>>2)]; //@line 857 "numbers.cpp"
        var $and5=($4) & 1; //@line 857 "numbers.cpp"
        var $tobool6=((($and5))|0)!=0; //@line 857 "numbers.cpp"
        if ($tobool6) { __label__ = 2;break $land_lhs_true$$lor_lhs_false$2; } else { __label__ = 3;break $land_lhs_true$$lor_lhs_false$2; } //@line 857 "numbers.cpp"
      }
    } while(0);
    $lor_lhs_false$$if_then$4: do { 
      if (__label__ == 2) {
  
        var $5=$word_addr; //@line 857 "numbers.cpp"
        var $arrayidx7=(($5+-2)&4294967295); //@line 857 "numbers.cpp"
        var $6=HEAP8[($arrayidx7)]; //@line 857 "numbers.cpp"
        var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 857 "numbers.cpp"
        var $isdigittmp=((($conv)-48)&4294967295); //@line 857 "numbers.cpp"
        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 857 "numbers.cpp"
        var $call=((($isdigit))&1); //@line 857 "numbers.cpp"
        var $tobool8=((($call))|0)!=0; //@line 857 "numbers.cpp"
        if ($tobool8) { __label__ = 3;break $lor_lhs_false$$if_then$4; } //@line 857 "numbers.cpp"
  
        var $7=$word_addr; //@line 860 "numbers.cpp"
        $word_start=$7; //@line 860 "numbers.cpp"
        ; //@line 861 "numbers.cpp"
        $while_cond$7: while(1) { 
  
          var $8=$word_addr; //@line 861 "numbers.cpp"
          var $incdec_ptr=(($8+1)&4294967295); //@line 861 "numbers.cpp"
          $word_addr=$incdec_ptr; //@line 861 "numbers.cpp"
          var $9=HEAP8[($8)]; //@line 861 "numbers.cpp"
          var $conv9=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 861 "numbers.cpp"
          $c=$conv9; //@line 861 "numbers.cpp"
          var $cmp=((($conv9))|0)!=32; //@line 861 "numbers.cpp"
          if (!($cmp)) { __label__ = 25;break $while_cond$7; } //@line 861 "numbers.cpp"
  
          var $10=$c; //@line 863 "numbers.cpp"
          var $memchr=_memchr(((__str12309)&4294967295), $10, 8); //@line 863 "numbers.cpp"
          $p2=$memchr; //@line 863 "numbers.cpp"
          var $cmp11=((($memchr))|0)==0; //@line 863 "numbers.cpp"
          if ($cmp11) { __label__ = 7;break $while_cond$7; } //@line 863 "numbers.cpp"
  
          var $11=$p2; //@line 866 "numbers.cpp"
          var $sub_ptr_lhs_cast=($11); //@line 866 "numbers.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-(__str12309))&4294967295); //@line 866 "numbers.cpp"
          var $arrayidx14=((__ZZ14TranslateRomanP10TranslatorPcS1_P8WORD_TABE12roman_values+$sub_ptr_sub*4)&4294967295); //@line 866 "numbers.cpp"
          var $12=HEAP32[(($arrayidx14)>>2)]; //@line 866 "numbers.cpp"
          $value=$12; //@line 866 "numbers.cpp"
          var $13=$value; //@line 867 "numbers.cpp"
          var $14=$prev; //@line 867 "numbers.cpp"
          var $cmp15=((($13))|0)==((($14))|0); //@line 867 "numbers.cpp"
          if ($cmp15) { __label__ = 9;; } else { __label__ = 11;; } //@line 867 "numbers.cpp"
          if (__label__ == 9) {
  
            var $15=$repeat; //@line 869 "numbers.cpp"
            var $inc=((($15)+1)&4294967295); //@line 869 "numbers.cpp"
            $repeat=$inc; //@line 869 "numbers.cpp"
            var $16=$repeat; //@line 870 "numbers.cpp"
            var $cmp17=((($16))|0) >= 3; //@line 870 "numbers.cpp"
            if ($cmp17) { __label__ = 10;break $while_cond$7; } //@line 870 "numbers.cpp"
          }
          else if (__label__ == 11) {
  
            $repeat=0; //@line 874 "numbers.cpp"
            ;
          }
  
          var $17=$prev; //@line 876 "numbers.cpp"
          var $cmp21=((($17))|0) > 1; //@line 876 "numbers.cpp"
          var $18=$prev; //@line 876 "numbers.cpp"
          var $cmp23=((($18))|0)!=10; //@line 876 "numbers.cpp"
          var $or_cond=($cmp21) & ($cmp23); //@line 876 "numbers.cpp"
          var $19=$prev; //@line 876 "numbers.cpp"
          var $cmp25=((($19))|0)!=100; //@line 876 "numbers.cpp"
          var $or_cond1=($or_cond) & ($cmp25); //@line 876 "numbers.cpp"
          if ($or_cond1) { __lastLabel__ = 12; __label__ = 13;; } else { __lastLabel__ = 12; __label__ = 15;; } //@line 876 "numbers.cpp"
          if (__label__ == 13) {
  
            var $20=$value; //@line 878 "numbers.cpp"
            var $21=$prev; //@line 878 "numbers.cpp"
            var $cmp27=((($20))|0) >= ((($21))|0); //@line 878 "numbers.cpp"
            if ($cmp27) { __lastLabel__ = 13; __label__ = 14;break $while_cond$7; } else { __lastLabel__ = 13; ; } //@line 878 "numbers.cpp"
          }
  
          var $22=__lastLabel__ == 13 ? $21 : ($19); //@line 881 "numbers.cpp"
          var $cmp31=((($22))|0)!=0; //@line 881 "numbers.cpp"
          if ($cmp31) { __label__ = 16;; } else { __label__ = 21;; } //@line 881 "numbers.cpp"
          $land_lhs_true32$$if_else40$18: do { 
            if (__label__ == 16) {
  
              var $23=$prev; //@line 881 "numbers.cpp"
              var $24=$value; //@line 881 "numbers.cpp"
              var $cmp33=((($23))|0) < ((($24))|0); //@line 881 "numbers.cpp"
              if (!($cmp33)) { __label__ = 21;break $land_lhs_true32$$if_else40$18; } //@line 881 "numbers.cpp"
  
              var $25=$acc; //@line 883 "numbers.cpp"
              var $rem=((($25))|0)%10; //@line 883 "numbers.cpp"
              var $cmp35=((($rem))|0)!=0; //@line 883 "numbers.cpp"
              if ($cmp35) { __label__ = 19;break $while_cond$7; } //@line 883 "numbers.cpp"
  
              var $26=$prev; //@line 883 "numbers.cpp"
              var $mul=((($26)*10)&4294967295); //@line 883 "numbers.cpp"
              var $27=$value; //@line 883 "numbers.cpp"
              var $cmp37=((($mul))|0) < ((($27))|0); //@line 883 "numbers.cpp"
              if ($cmp37) { __label__ = 19;break $while_cond$7; } //@line 883 "numbers.cpp"
  
              var $28=$prev; //@line 885 "numbers.cpp"
              $subtract=$28; //@line 885 "numbers.cpp"
              var $29=$subtract; //@line 886 "numbers.cpp"
              var $30=$value; //@line 886 "numbers.cpp"
              var $sub=((($30)-($29))&4294967295); //@line 886 "numbers.cpp"
              $value=$sub; //@line 886 "numbers.cpp"
              __label__ = 24;break $land_lhs_true32$$if_else40$18; //@line 887 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 21) {
  
            var $31=$value; //@line 889 "numbers.cpp"
            var $32=$subtract; //@line 889 "numbers.cpp"
            var $cmp41=((($31))|0) >= ((($32))|0); //@line 889 "numbers.cpp"
            if ($cmp41) { __label__ = 22;break $while_cond$7; } //@line 889 "numbers.cpp"
  
            var $33=$prev; //@line 892 "numbers.cpp"
            var $34=$acc; //@line 892 "numbers.cpp"
            var $add=((($34)+($33))&4294967295); //@line 892 "numbers.cpp"
            $acc=$add; //@line 892 "numbers.cpp"
            ;
          }
  
          var $35=$value; //@line 893 "numbers.cpp"
          $prev=$35; //@line 893 "numbers.cpp"
          var $36=$n_digits; //@line 894 "numbers.cpp"
          var $inc46=((($36)+1)&4294967295); //@line 894 "numbers.cpp"
          $n_digits=$inc46; //@line 894 "numbers.cpp"
          __label__ = 5;continue $while_cond$7; //@line 895 "numbers.cpp"
        }
        if (__label__ == 25) {
  
          var $37=$word_addr; //@line 897 "numbers.cpp"
          var $arrayidx47=(($37)&4294967295); //@line 897 "numbers.cpp"
          var $38=HEAP8[($arrayidx47)]; //@line 897 "numbers.cpp"
          var $conv48=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 897 "numbers.cpp"
          var $isdigittmp2=((($conv48)-48)&4294967295); //@line 897 "numbers.cpp"
          var $isdigit3=((($isdigittmp2))>>>0) < 10; //@line 897 "numbers.cpp"
          var $call49=((($isdigit3))&1); //@line 897 "numbers.cpp"
          var $tobool50=((($call49))|0)!=0; //@line 897 "numbers.cpp"
          if ($tobool50) { __label__ = 26;; } else { __label__ = 27;; } //@line 897 "numbers.cpp"
          if (__label__ == 26) {
  
            $retval=0; //@line 898 "numbers.cpp"
            __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 898 "numbers.cpp"
          }
          else if (__label__ == 27) {
  
            var $39=$prev; //@line 900 "numbers.cpp"
            var $40=$acc; //@line 900 "numbers.cpp"
            var $add53=((($40)+($39))&4294967295); //@line 900 "numbers.cpp"
            $acc=$add53; //@line 900 "numbers.cpp"
            var $41=$acc; //@line 901 "numbers.cpp"
            var $42=$tr_addr; //@line 901 "numbers.cpp"
            var $langopts54=(($42)&4294967295); //@line 901 "numbers.cpp"
            var $min_roman=(($langopts54+200)&4294967295); //@line 901 "numbers.cpp"
            var $43=HEAP32[(($min_roman)>>2)]; //@line 901 "numbers.cpp"
            var $cmp55=((($41))|0) < ((($43))|0); //@line 901 "numbers.cpp"
            if ($cmp55) { __label__ = 28;; } else { __label__ = 29;; } //@line 901 "numbers.cpp"
            if (__label__ == 28) {
  
              $retval=0; //@line 902 "numbers.cpp"
              __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 902 "numbers.cpp"
            }
            else if (__label__ == 29) {
  
              var $44=$acc; //@line 904 "numbers.cpp"
              var $45=$tr_addr; //@line 904 "numbers.cpp"
              var $langopts58=(($45)&4294967295); //@line 904 "numbers.cpp"
              var $max_roman=(($langopts58+196)&4294967295); //@line 904 "numbers.cpp"
              var $46=HEAP32[(($max_roman)>>2)]; //@line 904 "numbers.cpp"
              var $cmp59=((($44))|0) > ((($46))|0); //@line 904 "numbers.cpp"
              if ($cmp59) { __label__ = 30;; } else { __label__ = 31;; } //@line 904 "numbers.cpp"
              if (__label__ == 30) {
  
                $retval=0; //@line 905 "numbers.cpp"
                __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 905 "numbers.cpp"
              }
              else if (__label__ == 31) {
  
                var $47=$tr_addr; //@line 908 "numbers.cpp"
                var $arraydecay=(($ph_roman)&4294967295); //@line 908 "numbers.cpp"
                var $call62=__Z6LookupP10TranslatorPKcPc($47, ((__str13310)&4294967295), $arraydecay); //@line 908 "numbers.cpp"
                var $48=$ph_out_addr; //@line 909 "numbers.cpp"
                var $arrayidx63=(($48)&4294967295); //@line 909 "numbers.cpp"
                $p=$arrayidx63; //@line 909 "numbers.cpp"
                var $49=$tr_addr; //@line 911 "numbers.cpp"
                var $langopts64=(($49)&4294967295); //@line 911 "numbers.cpp"
                var $numbers65=(($langopts64+184)&4294967295); //@line 911 "numbers.cpp"
                var $50=HEAP32[(($numbers65)>>2)]; //@line 911 "numbers.cpp"
                var $and66=($50) & 67108864; //@line 911 "numbers.cpp"
                var $cmp67=((($and66))|0)==0; //@line 911 "numbers.cpp"
                if ($cmp67) { __label__ = 32;; } else { __label__ = 33;; } //@line 911 "numbers.cpp"
                if (__label__ == 32) {
  
                  var $51=$ph_out_addr; //@line 913 "numbers.cpp"
                  var $arraydecay69=(($ph_roman)&4294967295); //@line 913 "numbers.cpp"
                  var $call70=_strcpy($51, $arraydecay69); //@line 913 "numbers.cpp"
                  var $arraydecay71=(($ph_roman)&4294967295); //@line 914 "numbers.cpp"
                  var $call72=_strlen($arraydecay71); //@line 914 "numbers.cpp"
                  var $52=$ph_out_addr; //@line 914 "numbers.cpp"
                  var $arrayidx73=(($52+$call72)&4294967295); //@line 914 "numbers.cpp"
                  $p=$arrayidx73; //@line 914 "numbers.cpp"
                  ; //@line 915 "numbers.cpp"
                }
  
                var $arraydecay75=(($number_chars)&4294967295); //@line 917 "numbers.cpp"
                var $53=$acc; //@line 917 "numbers.cpp"
                var $call76=_sprintf($arraydecay75, ((__str14311)&4294967295), allocate([$53,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 917 "numbers.cpp"
                var $54=$word_addr; //@line 919 "numbers.cpp"
                var $arrayidx77=(($54)&4294967295); //@line 919 "numbers.cpp"
                var $55=HEAP8[($arrayidx77)]; //@line 919 "numbers.cpp"
                var $conv78=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 919 "numbers.cpp"
                var $cmp79=((($conv78))|0)==46; //@line 919 "numbers.cpp"
                if ($cmp79) { __label__ = 34;; } else { __label__ = 35;; } //@line 919 "numbers.cpp"
                if (__label__ == 34) {
  
                  $retval=0; //@line 922 "numbers.cpp"
                  __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 922 "numbers.cpp"
                }
                else if (__label__ == 35) {
  
                  var $56=$tr_addr; //@line 925 "numbers.cpp"
                  var $57=$word_start; //@line 925 "numbers.cpp"
                  var $58=$word_addr; //@line 925 "numbers.cpp"
                  var $59=$wtab_addr; //@line 925 "numbers.cpp"
                  var $call82=__ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi($56, $57, $58, $59, 1); //@line 925 "numbers.cpp"
                  var $tobool83=((($call82))|0)!=0; //@line 925 "numbers.cpp"
                  if ($tobool83) { __label__ = 36;; } else { __label__ = 37;; } //@line 925 "numbers.cpp"
                  if (__label__ == 36) {
  
                    var $60=$wtab_addr; //@line 926 "numbers.cpp"
                    var $arrayidx85=(($60)&4294967295); //@line 926 "numbers.cpp"
                    var $flags86=(($arrayidx85)&4294967295); //@line 926 "numbers.cpp"
                    var $61=HEAP32[(($flags86)>>2)]; //@line 926 "numbers.cpp"
                    var $or=($61) | 32768; //@line 926 "numbers.cpp"
                    HEAP32[(($flags86)>>2)]=$or; //@line 926 "numbers.cpp"
                    ; //@line 926 "numbers.cpp"
                  }
  
                  var $62=$tr_addr; //@line 928 "numbers.cpp"
                  var $langopts88=(($62)&4294967295); //@line 928 "numbers.cpp"
                  var $numbers89=(($langopts88+184)&4294967295); //@line 928 "numbers.cpp"
                  var $63=HEAP32[(($numbers89)>>2)]; //@line 928 "numbers.cpp"
                  var $and90=($63) & 134217728; //@line 928 "numbers.cpp"
                  var $tobool91=((($and90))|0)!=0; //@line 928 "numbers.cpp"
                  if ($tobool91) { __label__ = 38;; } else { __label__ = 45;; } //@line 928 "numbers.cpp"
                  $if_then92$$if_end117$47: do { 
                    if (__label__ == 38) {
  
                      var $64=$tr_addr; //@line 930 "numbers.cpp"
                      var $translator_name=(($64+280)&4294967295); //@line 930 "numbers.cpp"
                      var $65=HEAP32[(($translator_name)>>2)]; //@line 930 "numbers.cpp"
                      var $cmp93=((($65))|0)==26741; //@line 930 "numbers.cpp"
                      var $66=$wtab_addr; //@line 932 "numbers.cpp"
                      var $arrayidx95=(($66)&4294967295); //@line 932 "numbers.cpp"
                      var $flags96=(($arrayidx95)&4294967295); //@line 932 "numbers.cpp"
                      var $67=HEAP32[(($flags96)>>2)]; //@line 932 "numbers.cpp"
                      if ($cmp93) { __label__ = 39;; } else { __label__ = 44;; } //@line 930 "numbers.cpp"
                      if (__label__ == 39) {
  
                        var $and97=($67) & 32768; //@line 932 "numbers.cpp"
                        var $tobool98=((($and97))|0)!=0; //@line 932 "numbers.cpp"
                        if ($tobool98) { __label__ = 45;break $if_then92$$if_end117$47; } //@line 932 "numbers.cpp"
  
                        var $68=$wtab_addr; //@line 934 "numbers.cpp"
                        var $arrayidx100=(($68)&4294967295); //@line 934 "numbers.cpp"
                        var $flags101=(($arrayidx100)&4294967295); //@line 934 "numbers.cpp"
                        var $69=HEAP32[(($flags101)>>2)]; //@line 934 "numbers.cpp"
                        var $and102=($69) & 16384; //@line 934 "numbers.cpp"
                        var $tobool103=((($and102))|0)!=0; //@line 934 "numbers.cpp"
                        if ($tobool103) { __label__ = 41;; } else { __label__ = 43;; } //@line 934 "numbers.cpp"
                        $land_lhs_true104$$if_else109$52: do { 
                          if (__label__ == 41) {
  
                            var $70=$word_addr; //@line 934 "numbers.cpp"
                            var $71=$acc; //@line 934 "numbers.cpp"
                            var $call105=__ZL11hu_number_ePKcii($70, 0, $71); //@line 934 "numbers.cpp"
                            var $tobool106=((($call105))|0)!=0; //@line 934 "numbers.cpp"
                            if (!($tobool106)) { __label__ = 43;break $land_lhs_true104$$if_else109$52; } //@line 934 "numbers.cpp"
  
                            var $72=$num_control; //@line 937 "numbers.cpp"
                            var $or108=($72) | 1; //@line 937 "numbers.cpp"
                            $num_control=$or108; //@line 937 "numbers.cpp"
                            __label__ = 45;break $if_then92$$if_end117$47; //@line 941 "numbers.cpp"
                          }
                        } while(0);
  
                        $retval=0; //@line 940 "numbers.cpp"
                        __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 940 "numbers.cpp"
                      }
                      else if (__label__ == 44) {
  
                        var $or115=($67) | 32768; //@line 945 "numbers.cpp"
                        HEAP32[(($flags96)>>2)]=$or115; //@line 945 "numbers.cpp"
                        ;
                      }
                    }
                  } while(0);
  
                  var $73=$tr_addr; //@line 949 "numbers.cpp"
                  var $prev_dict_flags=(($73+8320)&4294967295); //@line 949 "numbers.cpp"
                  HEAP32[(($prev_dict_flags)>>2)]=0; //@line 949 "numbers.cpp"
                  var $74=$tr_addr; //@line 950 "numbers.cpp"
                  var $arrayidx118=(($number_chars+2)&4294967295); //@line 950 "numbers.cpp"
                  var $75=$p; //@line 950 "numbers.cpp"
                  var $arraydecay119=(($flags)&4294967295); //@line 950 "numbers.cpp"
                  var $76=$wtab_addr; //@line 950 "numbers.cpp"
                  var $77=$num_control; //@line 950 "numbers.cpp"
                  var $call120=__Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi($74, $arrayidx118, $75, $arraydecay119, $76, $77); //@line 950 "numbers.cpp"
                  var $78=$tr_addr; //@line 952 "numbers.cpp"
                  var $langopts121=(($78)&4294967295); //@line 952 "numbers.cpp"
                  var $numbers122=(($langopts121+184)&4294967295); //@line 952 "numbers.cpp"
                  var $79=HEAP32[(($numbers122)>>2)]; //@line 952 "numbers.cpp"
                  var $and123=($79) & 67108864; //@line 952 "numbers.cpp"
                  var $tobool124=((($and123))|0)!=0; //@line 952 "numbers.cpp"
                  if ($tobool124) { __label__ = 46;; } else { __label__ = 47;; } //@line 952 "numbers.cpp"
                  if (__label__ == 46) {
  
                    var $80=$ph_out_addr; //@line 953 "numbers.cpp"
                    var $arraydecay126=(($ph_roman)&4294967295); //@line 953 "numbers.cpp"
                    var $call127=_strcat($80, $arraydecay126); //@line 953 "numbers.cpp"
                    ; //@line 953 "numbers.cpp"
                  }
  
                  $retval=1; //@line 955 "numbers.cpp"
                  __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 955 "numbers.cpp"
                }
              }
            }
          }
        }
        else if (__label__ == 7) {
  
          $retval=0; //@line 864 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 864 "numbers.cpp"
        }
        else if (__label__ == 10) {
  
          $retval=0; //@line 871 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 871 "numbers.cpp"
        }
        else if (__label__ == 14) {
  
          $retval=0; //@line 879 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 879 "numbers.cpp"
        }
        else if (__label__ == 19) {
  
          $retval=0; //@line 884 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 884 "numbers.cpp"
        }
        else if (__label__ == 22) {
  
          $retval=0; //@line 890 "numbers.cpp"
          __label__ = 48;break $lor_lhs_false$$if_then$4; //@line 890 "numbers.cpp"
        }
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=0; //@line 858 "numbers.cpp"
      ; //@line 858 "numbers.cpp"
    }
  
    var $81=$retval; //@line 956 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $81; //@line 956 "numbers.cpp"
    return null;
  }
  

  function __ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi($tr, $word, $word_end, $wtab, $roman) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $tr_addr;
    var $word_addr;
    var $word_end_addr;
    var $wtab_addr;
    var $roman_addr;
    var $ordinal;
    var $c2=__stackBase__;
    var $nextflags;
    $tr_addr=$tr;
    $word_addr=$word;
    $word_end_addr=$word_end;
    $wtab_addr=$wtab;
    $roman_addr=$roman;
    $ordinal=0; //@line 758 "numbers.cpp"
    var $0=$tr_addr; //@line 762 "numbers.cpp"
    var $langopts=(($0)&4294967295); //@line 762 "numbers.cpp"
    var $numbers=(($langopts+184)&4294967295); //@line 762 "numbers.cpp"
    var $1=HEAP32[(($numbers)>>2)]; //@line 762 "numbers.cpp"
    var $and=($1) & 65536; //@line 762 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 762 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 32;; } //@line 762 "numbers.cpp"
    $land_lhs_true$$if_end92$2: do { 
      if (__label__ == 1) {
  
        var $2=$word_end_addr; //@line 762 "numbers.cpp"
        var $arrayidx=(($2)&4294967295); //@line 762 "numbers.cpp"
        var $3=HEAP8[($arrayidx)]; //@line 762 "numbers.cpp"
        var $conv=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 762 "numbers.cpp"
        var $cmp=((($conv))|0)==46; //@line 762 "numbers.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 2;; } //@line 762 "numbers.cpp"
        if (__label__ == 2) {
  
          var $4=$wtab_addr; //@line 762 "numbers.cpp"
          var $arrayidx1=(($4)&4294967295); //@line 762 "numbers.cpp"
          var $flags=(($arrayidx1)&4294967295); //@line 762 "numbers.cpp"
          var $5=HEAP32[(($flags)>>2)]; //@line 762 "numbers.cpp"
          var $and2=($5) & 65536; //@line 762 "numbers.cpp"
          var $tobool3=((($and2))|0)!=0; //@line 762 "numbers.cpp"
          if (!($tobool3)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 762 "numbers.cpp"
        }
  
        var $6=$wtab_addr; //@line 762 "numbers.cpp"
        var $arrayidx5=(($6+12)&4294967295); //@line 762 "numbers.cpp"
        var $flags6=(($arrayidx5)&4294967295); //@line 762 "numbers.cpp"
        var $7=HEAP32[(($flags6)>>2)]; //@line 762 "numbers.cpp"
        var $and7=($7) & 256; //@line 762 "numbers.cpp"
        var $tobool8=((($and7))|0)!=0; //@line 762 "numbers.cpp"
        if ($tobool8) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 762 "numbers.cpp"
  
        var $8=$roman_addr; //@line 764 "numbers.cpp"
        var $tobool9=((($8))|0)!=0; //@line 764 "numbers.cpp"
        if ($tobool9) { __label__ = 6;; } else { __label__ = 5;; } //@line 764 "numbers.cpp"
        if (__label__ == 5) {
  
          var $9=$wtab_addr; //@line 764 "numbers.cpp"
          var $arrayidx11=(($9+12)&4294967295); //@line 764 "numbers.cpp"
          var $flags12=(($arrayidx11)&4294967295); //@line 764 "numbers.cpp"
          var $10=HEAP32[(($flags12)>>2)]; //@line 764 "numbers.cpp"
          var $and13=($10) & 2; //@line 764 "numbers.cpp"
          var $tobool14=((($and13))|0)!=0; //@line 764 "numbers.cpp"
          if ($tobool14) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 764 "numbers.cpp"
        }
  
        var $11=$word_end_addr; //@line 766 "numbers.cpp"
        var $arrayidx16=(($11)&4294967295); //@line 766 "numbers.cpp"
        var $12=HEAP8[($arrayidx16)]; //@line 766 "numbers.cpp"
        var $conv17=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 766 "numbers.cpp"
        var $cmp18=((($conv17))|0)==46; //@line 766 "numbers.cpp"
        var $13=$word_end_addr; //@line 767 "numbers.cpp"
        if ($cmp18) { __label__ = 7;; } else { __label__ = 8;; } //@line 766 "numbers.cpp"
        if (__label__ == 7) {
  
          var $arrayidx20=(($13+2)&4294967295); //@line 767 "numbers.cpp"
          var $call=__Z7utf8_inPiPKc($c2, $arrayidx20); //@line 767 "numbers.cpp"
          ; //@line 767 "numbers.cpp"
        }
        else if (__label__ == 8) {
  
          var $arrayidx21=(($13)&4294967295); //@line 769 "numbers.cpp"
          var $call22=__Z7utf8_inPiPKc($c2, $arrayidx21); //@line 769 "numbers.cpp"
          ;
        }
  
        var $14=$word_end_addr; //@line 771 "numbers.cpp"
        var $arrayidx23=(($14)&4294967295); //@line 771 "numbers.cpp"
        var $15=HEAP8[($arrayidx23)]; //@line 771 "numbers.cpp"
        var $conv24=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 771 "numbers.cpp"
        var $cmp25=((($conv24))|0)!=0; //@line 771 "numbers.cpp"
        if (!($cmp25)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 771 "numbers.cpp"
  
        var $16=$word_end_addr; //@line 771 "numbers.cpp"
        var $arrayidx27=(($16+1)&4294967295); //@line 771 "numbers.cpp"
        var $17=HEAP8[($arrayidx27)]; //@line 771 "numbers.cpp"
        var $conv28=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 771 "numbers.cpp"
        var $cmp29=((($conv28))|0)!=0; //@line 771 "numbers.cpp"
        if (!($cmp29)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 771 "numbers.cpp"
  
        var $18=HEAP32[(($c2)>>2)]; //@line 771 "numbers.cpp"
        var $cmp31=((($18))|0)==0; //@line 771 "numbers.cpp"
        if ($cmp31) { __label__ = 14;; } else { __label__ = 12;; } //@line 771 "numbers.cpp"
        $if_then40$$lor_lhs_false32$17: do { 
          if (__label__ == 12) {
  
            var $19=$wtab_addr; //@line 771 "numbers.cpp"
            var $arrayidx33=(($19)&4294967295); //@line 771 "numbers.cpp"
            var $flags34=(($arrayidx33)&4294967295); //@line 771 "numbers.cpp"
            var $20=HEAP32[(($flags34)>>2)]; //@line 771 "numbers.cpp"
            var $and35=($20) & 131072; //@line 771 "numbers.cpp"
            var $tobool36=((($and35))|0)!=0; //@line 771 "numbers.cpp"
            if ($tobool36) { __label__ = 14;break $if_then40$$lor_lhs_false32$17; } //@line 771 "numbers.cpp"
  
            var $21=HEAP32[(($c2)>>2)]; //@line 771 "numbers.cpp"
            var $call38=__Z7IsAlphaj($21); //@line 771 "numbers.cpp"
            var $tobool39=((($call38))|0)!=0; //@line 771 "numbers.cpp"
            if (!($tobool39)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 771 "numbers.cpp"
          }
        } while(0);
  
        $ordinal=2; //@line 776 "numbers.cpp"
        var $22=$word_end_addr; //@line 777 "numbers.cpp"
        var $arrayidx41=(($22)&4294967295); //@line 777 "numbers.cpp"
        var $23=HEAP8[($arrayidx41)]; //@line 777 "numbers.cpp"
        var $conv42=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 777 "numbers.cpp"
        var $cmp43=((($conv42))|0)==46; //@line 777 "numbers.cpp"
        if ($cmp43) { __label__ = 15;; } else { __label__ = 16;; } //@line 777 "numbers.cpp"
        if (__label__ == 15) {
  
          var $24=$word_end_addr; //@line 778 "numbers.cpp"
          var $arrayidx45=(($24)&4294967295); //@line 778 "numbers.cpp"
          HEAP8[($arrayidx45)]=32; //@line 778 "numbers.cpp"
          ; //@line 778 "numbers.cpp"
        }
  
        var $25=$roman_addr; //@line 780 "numbers.cpp"
        var $cmp47=((($25))|0)==0; //@line 780 "numbers.cpp"
        if (!($cmp47)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 780 "numbers.cpp"
  
        var $26=$tr_addr; //@line 780 "numbers.cpp"
        var $translator_name=(($26+280)&4294967295); //@line 780 "numbers.cpp"
        var $27=HEAP32[(($translator_name)>>2)]; //@line 780 "numbers.cpp"
        var $cmp49=((($27))|0)==26741; //@line 780 "numbers.cpp"
        if (!($cmp49)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 780 "numbers.cpp"
  
        $nextflags=0; //@line 783 "numbers.cpp"
        var $28=HEAP32[(($c2)>>2)]; //@line 784 "numbers.cpp"
        var $call51=__Z7IsAlphaj($28); //@line 784 "numbers.cpp"
        var $tobool52=((($call51))|0)!=0; //@line 784 "numbers.cpp"
        if ($tobool52) { __label__ = 19;; } else { __label__ = 20;; } //@line 784 "numbers.cpp"
        if (__label__ == 19) {
  
          var $29=$tr_addr; //@line 786 "numbers.cpp"
          var $30=$word_end_addr; //@line 786 "numbers.cpp"
          var $arrayidx54=(($30+2)&4294967295); //@line 786 "numbers.cpp"
          var $call55=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($29, $arrayidx54, 0, 0); //@line 786 "numbers.cpp"
          $nextflags=$call55; //@line 786 "numbers.cpp"
          ; //@line 787 "numbers.cpp"
        }
  
        var $31=$tr_addr; //@line 789 "numbers.cpp"
        var $prev_dict_flags=(($31+8320)&4294967295); //@line 789 "numbers.cpp"
        var $32=HEAP32[(($prev_dict_flags)>>2)]; //@line 789 "numbers.cpp"
        var $and57=($32) & 1048576; //@line 789 "numbers.cpp"
        var $tobool58=((($and57))|0)!=0; //@line 789 "numbers.cpp"
        if ($tobool58) { __label__ = 21;; } else { __label__ = 25;; } //@line 789 "numbers.cpp"
        $land_lhs_true59$$if_end70$29: do { 
          if (__label__ == 21) {
  
            var $33=HEAP32[(($c2)>>2)]; //@line 789 "numbers.cpp"
            var $cmp60=((($33))|0)==0; //@line 789 "numbers.cpp"
            if ($cmp60) { __label__ = 24;; } else { __label__ = 22;; } //@line 789 "numbers.cpp"
            $if_then69$$lor_lhs_false61$31: do { 
              if (__label__ == 22) {
  
                var $34=$wtab_addr; //@line 789 "numbers.cpp"
                var $arrayidx62=(($34)&4294967295); //@line 789 "numbers.cpp"
                var $flags63=(($arrayidx62)&4294967295); //@line 789 "numbers.cpp"
                var $35=HEAP32[(($flags63)>>2)]; //@line 789 "numbers.cpp"
                var $and64=($35) & 131072; //@line 789 "numbers.cpp"
                var $tobool65=((($and64))|0)!=0; //@line 789 "numbers.cpp"
                if ($tobool65) { __label__ = 24;break $if_then69$$lor_lhs_false61$31; } //@line 789 "numbers.cpp"
  
                var $36=HEAP32[(($c2)>>2)]; //@line 789 "numbers.cpp"
                var $call67=_iswdigit($36); //@line 789 "numbers.cpp"
                var $tobool68=((($call67))|0)!=0; //@line 789 "numbers.cpp"
                if (!($tobool68)) { __label__ = 25;break $land_lhs_true59$$if_end70$29; } //@line 789 "numbers.cpp"
              }
            } while(0);
  
            $ordinal=0; //@line 790 "numbers.cpp"
            ; //@line 790 "numbers.cpp"
          }
        } while(0);
  
        var $37=$nextflags; //@line 792 "numbers.cpp"
        var $and71=($37) & 1048576; //@line 792 "numbers.cpp"
        var $tobool72=((($and71))|0)!=0; //@line 792 "numbers.cpp"
        if ($tobool72) { __label__ = 26;; } else { __label__ = 27;; } //@line 792 "numbers.cpp"
        if (__label__ == 26) {
  
          $ordinal=0; //@line 793 "numbers.cpp"
          ; //@line 793 "numbers.cpp"
        }
  
        var $38=$nextflags; //@line 795 "numbers.cpp"
        var $and75=($38) & 4194304; //@line 795 "numbers.cpp"
        var $tobool76=((($and75))|0)!=0; //@line 795 "numbers.cpp"
        if (!($tobool76)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 795 "numbers.cpp"
  
        var $39=$word_addr; //@line 797 "numbers.cpp"
        var $arrayidx78=(($39+-2)&4294967295); //@line 797 "numbers.cpp"
        var $40=HEAP8[($arrayidx78)]; //@line 797 "numbers.cpp"
        var $conv79=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 797 "numbers.cpp"
        var $cmp80=((($conv79))|0)==45; //@line 797 "numbers.cpp"
        if ($cmp80) { __label__ = 29;; } else { __label__ = 30;; } //@line 797 "numbers.cpp"
        if (__label__ == 29) {
  
          $ordinal=0; //@line 798 "numbers.cpp"
          ; //@line 798 "numbers.cpp"
        }
  
        var $41=$tr_addr; //@line 800 "numbers.cpp"
        var $prev_dict_flags83=(($41+8320)&4294967295); //@line 800 "numbers.cpp"
        var $42=HEAP32[(($prev_dict_flags83)>>2)]; //@line 800 "numbers.cpp"
        var $and84=($42) & 5242880; //@line 800 "numbers.cpp"
        var $tobool85=((($and84))|0)!=0; //@line 800 "numbers.cpp"
        if (!($tobool85)) { __label__ = 32;break $land_lhs_true$$if_end92$2; } //@line 800 "numbers.cpp"
  
        $ordinal=34; //@line 801 "numbers.cpp"
        ; //@line 801 "numbers.cpp"
      }
    } while(0);
  
    var $43=$ordinal; //@line 807 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $43; //@line 807 "numbers.cpp"
    return null;
  }
  

  function __ZL11hu_number_ePKcii($word, $thousandplex, $value) {
    ;
    var __label__;
  
    var $retval;
    var $word_addr;
    var $thousandplex_addr;
    var $value_addr;
    $word_addr=$word;
    $thousandplex_addr=$thousandplex;
    $value_addr=$value;
    var $0=$word_addr; //@line 815 "numbers.cpp"
    var $arrayidx=(($0)&4294967295); //@line 815 "numbers.cpp"
    var $1=HEAP8[($arrayidx)]; //@line 815 "numbers.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 815 "numbers.cpp"
    var $cmp=((($conv))|0)==97; //@line 815 "numbers.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 815 "numbers.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $2=$word_addr; //@line 815 "numbers.cpp"
        var $arrayidx1=(($2)&4294967295); //@line 815 "numbers.cpp"
        var $3=HEAP8[($arrayidx1)]; //@line 815 "numbers.cpp"
        var $conv2=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 815 "numbers.cpp"
        var $cmp3=((($conv2))|0)==101; //@line 815 "numbers.cpp"
        if ($cmp3) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 815 "numbers.cpp"
  
        $retval=0; //@line 825 "numbers.cpp"
        __label__ = 13;break $if_then$$lor_lhs_false$2; //@line 825 "numbers.cpp"
      }
    } while(0);
    $if_then$$return$5: do { 
      if (__label__ == 2) {
  
        var $4=$word_addr; //@line 817 "numbers.cpp"
        var $arrayidx4=(($4+1)&4294967295); //@line 817 "numbers.cpp"
        var $5=HEAP8[($arrayidx4)]; //@line 817 "numbers.cpp"
        var $conv5=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
        var $cmp6=((($conv5))|0)==32; //@line 817 "numbers.cpp"
        if ($cmp6) { __label__ = 6;; } else { __label__ = 3;; } //@line 817 "numbers.cpp"
        $if_then18$$lor_lhs_false7$7: do { 
          if (__label__ == 3) {
  
            var $6=$word_addr; //@line 817 "numbers.cpp"
            var $arrayidx8=(($6+1)&4294967295); //@line 817 "numbers.cpp"
            var $7=HEAP8[($arrayidx8)]; //@line 817 "numbers.cpp"
            var $conv9=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
            var $cmp10=((($conv9))|0)==122; //@line 817 "numbers.cpp"
            if ($cmp10) { __label__ = 6;break $if_then18$$lor_lhs_false7$7; } //@line 817 "numbers.cpp"
  
            var $8=$word_addr; //@line 817 "numbers.cpp"
            var $arrayidx12=(($8+1)&4294967295); //@line 817 "numbers.cpp"
            var $9=HEAP8[($arrayidx12)]; //@line 817 "numbers.cpp"
            var $conv13=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
            var $cmp14=((($conv13))|0)==116; //@line 817 "numbers.cpp"
            if ($cmp14) { __label__ = 5;; } else { __label__ = 7;; } //@line 817 "numbers.cpp"
            if (__label__ == 5) {
  
              var $10=$word_addr; //@line 817 "numbers.cpp"
              var $arrayidx15=(($10+2)&4294967295); //@line 817 "numbers.cpp"
              var $11=HEAP8[($arrayidx15)]; //@line 817 "numbers.cpp"
              var $conv16=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "numbers.cpp"
              var $cmp17=((($conv16))|0)==116; //@line 817 "numbers.cpp"
              if ($cmp17) { __label__ = 6;break $if_then18$$lor_lhs_false7$7; } //@line 817 "numbers.cpp"
            }
  
            var $12=$thousandplex_addr; //@line 820 "numbers.cpp"
            var $cmp19=((($12))|0)==1; //@line 820 "numbers.cpp"
            if ($cmp19) { __label__ = 9;; } else { __label__ = 8;; } //@line 820 "numbers.cpp"
            $land_lhs_true22$$lor_lhs_false20$13: do { 
              if (__label__ == 8) {
  
                var $13=$value_addr; //@line 820 "numbers.cpp"
                var $rem=((($13))|0)%1000; //@line 820 "numbers.cpp"
                var $cmp21=((($rem))|0)==0; //@line 820 "numbers.cpp"
                if ($cmp21) { __label__ = 9;break $land_lhs_true22$$lor_lhs_false20$13; } else { __label__ = 11;break $land_lhs_true22$$lor_lhs_false20$13; } //@line 820 "numbers.cpp"
              }
            } while(0);
            $land_lhs_true22$$if_end27$15: do { 
              if (__label__ == 9) {
  
                var $14=$word_addr; //@line 820 "numbers.cpp"
                var $arrayidx23=(($14+1)&4294967295); //@line 820 "numbers.cpp"
                var $15=HEAP8[($arrayidx23)]; //@line 820 "numbers.cpp"
                var $conv24=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 820 "numbers.cpp"
                var $cmp25=((($conv24))|0)==108; //@line 820 "numbers.cpp"
                if (!($cmp25)) { __label__ = 11;break $land_lhs_true22$$if_end27$15; } //@line 820 "numbers.cpp"
  
                $retval=0; //@line 821 "numbers.cpp"
                __label__ = 13;break $if_then$$return$5; //@line 821 "numbers.cpp"
              }
            } while(0);
  
            $retval=1; //@line 823 "numbers.cpp"
            __label__ = 13;break $if_then$$return$5; //@line 823 "numbers.cpp"
          }
        } while(0);
  
        $retval=0; //@line 818 "numbers.cpp"
        ; //@line 818 "numbers.cpp"
      }
    } while(0);
  
    var $16=$retval; //@line 826 "numbers.cpp"
    ;
    return $16; //@line 826 "numbers.cpp"
    return null;
  }
  

  function __Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi($tr, $word1, $ph_out, $flags, $wtab, $control) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $word1_addr;
    var $ph_out_addr;
    var $flags_addr;
    var $wtab_addr;
    var $control_addr;
    $tr_addr=$tr;
    $word1_addr=$word1;
    $ph_out_addr=$ph_out;
    $flags_addr=$flags;
    $wtab_addr=$wtab;
    $control_addr=$control;
    var $0=HEAP32[((_option_sayas)>>2)]; //@line 1944 "numbers.cpp"
    var $cmp=((($0))|0)==193; //@line 1944 "numbers.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 1944 "numbers.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$wtab_addr; //@line 1944 "numbers.cpp"
        var $arrayidx=(($1)&4294967295); //@line 1944 "numbers.cpp"
        var $flags1=(($arrayidx)&4294967295); //@line 1944 "numbers.cpp"
        var $2=HEAP32[(($flags1)>>2)]; //@line 1944 "numbers.cpp"
        var $and=($2) & 524288; //@line 1944 "numbers.cpp"
        var $tobool=((($and))|0)!=0; //@line 1944 "numbers.cpp"
        if ($tobool) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 1944 "numbers.cpp"
  
        var $3=$tr_addr; //@line 1947 "numbers.cpp"
        var $langopts=(($3)&4294967295); //@line 1947 "numbers.cpp"
        var $numbers=(($langopts+184)&4294967295); //@line 1947 "numbers.cpp"
        var $4=HEAP32[(($numbers)>>2)]; //@line 1947 "numbers.cpp"
        var $cmp2=((($4))|0)!=0; //@line 1947 "numbers.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 5;; } //@line 1947 "numbers.cpp"
        if (__label__ == 4) {
  
          var $5=$tr_addr; //@line 1948 "numbers.cpp"
          var $6=$word1_addr; //@line 1948 "numbers.cpp"
          var $7=$ph_out_addr; //@line 1948 "numbers.cpp"
          var $8=$flags_addr; //@line 1948 "numbers.cpp"
          var $9=$wtab_addr; //@line 1948 "numbers.cpp"
          var $10=$control_addr; //@line 1948 "numbers.cpp"
          var $call=__ZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABi($5, $6, $7, $8, $9, $10); //@line 1948 "numbers.cpp"
          $retval=$call; //@line 1948 "numbers.cpp"
          __label__ = 6;break $if_then$$lor_lhs_false$2; //@line 1948 "numbers.cpp"
        }
        else if (__label__ == 5) {
  
          $retval=0; //@line 1950 "numbers.cpp"
          __label__ = 6;break $if_then$$lor_lhs_false$2; //@line 1950 "numbers.cpp"
        }
      }
    } while(0);
    if (__label__ == 2) {
  
      $retval=0; //@line 1945 "numbers.cpp"
      ; //@line 1945 "numbers.cpp"
    }
  
    var $11=$retval; //@line 1951 "numbers.cpp"
    ;
    return $11; //@line 1951 "numbers.cpp"
    return null;
  }
  

  function __ZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABi($tr, $word, $ph_out, $flags, $wtab, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 560; _memset(__stackBase__, 0, 560);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $ph_out_addr;
    var $flags_addr;
    var $wtab_addr;
    var $control_addr;
    var $n_digits;
    var $value;
    var $ix;
    var $digix;
    var $c;
    var $suppress_null;
    var $decimal_point;
    var $thousandplex;
    var $thousands_exact;
    var $thousands_inc;
    var $prev_thousands;
    var $ordinal;
    var $dot_ordinal;
    var $this_value;
    var $decimal_count;
    var $max_decimal_count;
    var $decimal_mode;
    var $hyphen;
    var $suffix_ix;
    var $skipwords;
    var $p=__stackBase__;
    var $string=__stackBase__+4;
    var $buf1=__stackBase__+24;
    var $ph_append=__stackBase__+124;
    var $ph_buf=__stackBase__+176;
    var $ph_buf2=__stackBase__+376;
    var $ph_zeros=__stackBase__+428;
    var $suffix=__stackBase__+480;
    var $buf_digit_lookup=__stackBase__+500;
    var $p2=__stackBase__+552;
    var $next_char=__stackBase__+556;
    var $p562;
    $tr_addr=$tr;
    $word_addr=$word;
    $ph_out_addr=$ph_out;
    $flags_addr=$flags;
    $wtab_addr=$wtab;
    $control_addr=$control;
    $suppress_null=0; //@line 1577 "numbers.cpp"
    $decimal_point=0; //@line 1578 "numbers.cpp"
    $thousandplex=0; //@line 1579 "numbers.cpp"
    $thousands_exact=1; //@line 1580 "numbers.cpp"
    $thousands_inc=0; //@line 1581 "numbers.cpp"
    $prev_thousands=0; //@line 1582 "numbers.cpp"
    $ordinal=0; //@line 1583 "numbers.cpp"
    $skipwords=0; //@line 1591 "numbers.cpp"
    var $0=$flags_addr; //@line 1604 "numbers.cpp"
    HEAP32[(($0)>>2)]=0; //@line 1604 "numbers.cpp"
    HEAP32[((__ZL14n_digit_lookup)>>2)]=0; //@line 1605 "numbers.cpp"
    var $arrayidx=(($buf_digit_lookup)&4294967295); //@line 1606 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 1606 "numbers.cpp"
    var $arraydecay=(($buf_digit_lookup)&4294967295); //@line 1607 "numbers.cpp"
    HEAP32[((__ZL12digit_lookup)>>2)]=$arraydecay; //@line 1607 "numbers.cpp"
    var $1=$control_addr; //@line 1608 "numbers.cpp"
    HEAP32[((__ZL14number_control)>>2)]=$1; //@line 1608 "numbers.cpp"
    $ix=0; //@line 1610 "numbers.cpp"
    var $2=$ix; //@line 1610 "numbers.cpp"
    var $3=$word_addr; //@line 1610 "numbers.cpp"
    var $arrayidx167=(($3+$2)&4294967295); //@line 1610 "numbers.cpp"
    var $4=HEAP8[($arrayidx167)]; //@line 1610 "numbers.cpp"
    var $conv68=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1610 "numbers.cpp"
    var $isdigittmp69=((($conv68)-48)&4294967295); //@line 1610 "numbers.cpp"
    var $isdigit70=((($isdigittmp69))>>>0) < 10; //@line 1610 "numbers.cpp"
    var $5=$ix; //@line 1610 "numbers.cpp"
    if ($isdigit70) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 1610 "numbers.cpp"
    $for_inc$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $6=__lastLabel__ == 1 ? $10 : ($5);
          var $inc=((($6)+1)&4294967295); //@line 1610 "numbers.cpp"
          $ix=$inc; //@line 1610 "numbers.cpp"
          var $7=$ix; //@line 1610 "numbers.cpp"
          var $8=$word_addr; //@line 1610 "numbers.cpp"
          var $arrayidx1=(($8+$7)&4294967295); //@line 1610 "numbers.cpp"
          var $9=HEAP8[($arrayidx1)]; //@line 1610 "numbers.cpp"
          var $conv=(tempInt=(($9)),(tempInt>=128?tempInt-256:tempInt)); //@line 1610 "numbers.cpp"
          var $isdigittmp=((($conv)-48)&4294967295); //@line 1610 "numbers.cpp"
          var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1610 "numbers.cpp"
          var $call=((($isdigit))&1); //@line 1610 "numbers.cpp"
          var $tobool=((($call))|0)!=0; //@line 1610 "numbers.cpp"
          var $10=$ix; //@line 1610 "numbers.cpp"
          if ($tobool) { __lastLabel__ = 1; __label__ = 1;continue ; } else { __lastLabel__ = 1; __label__ = 2;break $for_inc$$for_end$2; } //@line 1610 "numbers.cpp"
        }
      }
    } while(0);
  
    var $_lcssa65=__lastLabel__ == 0 ? $5 : ($10);
    $n_digits=$_lcssa65; //@line 1611 "numbers.cpp"
    var $11=$word_addr; //@line 1612 "numbers.cpp"
    var $call2=_atoi($11); //@line 1612 "numbers.cpp"
    $this_value=$call2; //@line 1612 "numbers.cpp"
    $value=$call2; //@line 1612 "numbers.cpp"
    var $cmp=((($_lcssa65))|0)==3; //@line 1615 "numbers.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 6;; } //@line 1615 "numbers.cpp"
    $land_lhs_true$$if_else$6: do { 
      if (__label__ == 3) {
  
        var $12=$word_addr; //@line 1615 "numbers.cpp"
        var $arrayidx3=(($12+-2)&4294967295); //@line 1615 "numbers.cpp"
        var $13=HEAP8[($arrayidx3)]; //@line 1615 "numbers.cpp"
        var $conv4=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1615 "numbers.cpp"
        var $14=$tr_addr; //@line 1615 "numbers.cpp"
        var $langopts=(($14)&4294967295); //@line 1615 "numbers.cpp"
        var $thousands_sep=(($langopts+204)&4294967295); //@line 1615 "numbers.cpp"
        var $15=HEAP32[(($thousands_sep)>>2)]; //@line 1615 "numbers.cpp"
        var $cmp5=((($conv4))|0)==((($15))|0); //@line 1615 "numbers.cpp"
        if (!($cmp5)) { __label__ = 6;break $land_lhs_true$$if_else$6; } //@line 1615 "numbers.cpp"
  
        var $16=$word_addr; //@line 1615 "numbers.cpp"
        var $arrayidx7=(($16+-3)&4294967295); //@line 1615 "numbers.cpp"
        var $17=HEAP8[($arrayidx7)]; //@line 1615 "numbers.cpp"
        var $conv8=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1615 "numbers.cpp"
        var $isdigittmp6=((($conv8)-48)&4294967295); //@line 1615 "numbers.cpp"
        var $isdigit7=((($isdigittmp6))>>>0) < 10; //@line 1615 "numbers.cpp"
        var $call9=((($isdigit7))&1); //@line 1615 "numbers.cpp"
        var $tobool10=((($call9))|0)!=0; //@line 1615 "numbers.cpp"
        if (!($tobool10)) { __label__ = 6;break $land_lhs_true$$if_else$6; } //@line 1615 "numbers.cpp"
  
        $prev_thousands=1; //@line 1617 "numbers.cpp"
        __label__ = 14;break $land_lhs_true$$if_else$6; //@line 1618 "numbers.cpp"
      }
    } while(0);
    $if_end32$$if_else$10: do { 
      if (__label__ == 6) {
  
        var $18=$tr_addr; //@line 1620 "numbers.cpp"
        var $langopts11=(($18)&4294967295); //@line 1620 "numbers.cpp"
        var $thousands_sep12=(($langopts11+204)&4294967295); //@line 1620 "numbers.cpp"
        var $19=HEAP32[(($thousands_sep12)>>2)]; //@line 1620 "numbers.cpp"
        var $cmp13=((($19))|0)==32; //@line 1620 "numbers.cpp"
        if ($cmp13) { __label__ = 8;; } else { __label__ = 7;; } //@line 1620 "numbers.cpp"
        $if_then16$$lor_lhs_false$12: do { 
          if (__label__ == 7) {
  
            var $20=$tr_addr; //@line 1620 "numbers.cpp"
            var $langopts14=(($20)&4294967295); //@line 1620 "numbers.cpp"
            var $numbers=(($langopts14+184)&4294967295); //@line 1620 "numbers.cpp"
            var $21=HEAP32[(($numbers)>>2)]; //@line 1620 "numbers.cpp"
            var $and=($21) & 4096; //@line 1620 "numbers.cpp"
            var $tobool15=((($and))|0)!=0; //@line 1620 "numbers.cpp"
            if ($tobool15) { __label__ = 8;break $if_then16$$lor_lhs_false$12; } else { __label__ = 12;break $if_then16$$lor_lhs_false$12; } //@line 1620 "numbers.cpp"
          }
        } while(0);
        $if_then16$$if_end29$14: do { 
          if (__label__ == 8) {
  
            var $22=$n_digits; //@line 1623 "numbers.cpp"
            var $cmp17=((($22))|0)==3; //@line 1623 "numbers.cpp"
            if (!($cmp17)) { __label__ = 12;break $if_then16$$if_end29$14; } //@line 1623 "numbers.cpp"
  
            var $23=$wtab_addr; //@line 1623 "numbers.cpp"
            var $flags19=(($23)&4294967295); //@line 1623 "numbers.cpp"
            var $24=HEAP32[(($flags19)>>2)]; //@line 1623 "numbers.cpp"
            var $and20=($24) & 262144; //@line 1623 "numbers.cpp"
            var $tobool21=((($and20))|0)!=0; //@line 1623 "numbers.cpp"
            if ($tobool21) { __label__ = 12;break $if_then16$$if_end29$14; } //@line 1623 "numbers.cpp"
  
            var $25=$word_addr; //@line 1623 "numbers.cpp"
            var $arrayidx23=(($25+-2)&4294967295); //@line 1623 "numbers.cpp"
            var $26=HEAP8[($arrayidx23)]; //@line 1623 "numbers.cpp"
            var $conv24=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 1623 "numbers.cpp"
            var $isdigittmp8=((($conv24)-48)&4294967295); //@line 1623 "numbers.cpp"
            var $isdigit9=((($isdigittmp8))>>>0) < 10; //@line 1623 "numbers.cpp"
            var $call25=((($isdigit9))&1); //@line 1623 "numbers.cpp"
            var $tobool26=((($call25))|0)!=0; //@line 1623 "numbers.cpp"
            if (!($tobool26)) { __label__ = 12;break $if_then16$$if_end29$14; } //@line 1623 "numbers.cpp"
  
            $prev_thousands=1; //@line 1625 "numbers.cpp"
            __label__ = 14;break $if_end32$$if_else$10; //@line 1626 "numbers.cpp"
          }
        } while(0);
  
        var $_pr=$prev_thousands; //@line 1628 "numbers.cpp"
        var $cmp30=((($_pr))|0)==0; //@line 1628 "numbers.cpp"
        if (!($cmp30)) { __label__ = 14;break $if_end32$$if_else$10; } //@line 1628 "numbers.cpp"
  
        HEAP32[((__ZL23speak_missing_thousands)>>2)]=0; //@line 1630 "numbers.cpp"
        ; //@line 1631 "numbers.cpp"
      }
    } while(0);
  
    HEAP8[(((__ZL11ph_ordinal2)&4294967295))]=0; //@line 1633 "numbers.cpp"
    var $arrayidx33=(($ph_zeros)&4294967295); //@line 1634 "numbers.cpp"
    HEAP8[($arrayidx33)]=0; //@line 1634 "numbers.cpp"
    var $27=$prev_thousands; //@line 1636 "numbers.cpp"
    var $tobool34=((($27))|0)!=0; //@line 1636 "numbers.cpp"
    if ($tobool34) { __label__ = 16;; } else { __label__ = 15;; } //@line 1636 "numbers.cpp"
    $if_then39$$lor_lhs_false35$22: do { 
      if (__label__ == 15) {
  
        var $28=$word_addr; //@line 1636 "numbers.cpp"
        var $arrayidx36=(($28)&4294967295); //@line 1636 "numbers.cpp"
        var $29=HEAP8[($arrayidx36)]; //@line 1636 "numbers.cpp"
        var $conv37=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 1636 "numbers.cpp"
        var $cmp38=((($conv37))|0)!=48; //@line 1636 "numbers.cpp"
        if ($cmp38) { __label__ = 16;break $if_then39$$lor_lhs_false35$22; } else { __label__ = 18;break $if_then39$$lor_lhs_false35$22; } //@line 1636 "numbers.cpp"
      }
    } while(0);
    $if_then39$$if_end45$24: do { 
      if (__label__ == 16) {
  
        var $30=$tr_addr; //@line 1639 "numbers.cpp"
        var $31=$word_addr; //@line 1639 "numbers.cpp"
        var $32=$ix; //@line 1639 "numbers.cpp"
        var $33=$word_addr; //@line 1639 "numbers.cpp"
        var $arrayidx40=(($33+$32)&4294967295); //@line 1639 "numbers.cpp"
        var $34=$wtab_addr; //@line 1639 "numbers.cpp"
        var $call41=__ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi($30, $31, $arrayidx40, $34, 0); //@line 1639 "numbers.cpp"
        $ordinal=$call41; //@line 1639 "numbers.cpp"
        var $cmp42=((($call41))|0)!=0; //@line 1639 "numbers.cpp"
        if (!($cmp42)) { __label__ = 18;break $if_then39$$if_end45$24; } //@line 1639 "numbers.cpp"
  
        $dot_ordinal=1; //@line 1640 "numbers.cpp"
        ; //@line 1640 "numbers.cpp"
      }
    } while(0);
  
    var $35=$ix; //@line 1643 "numbers.cpp"
    var $36=$word_addr; //@line 1643 "numbers.cpp"
    var $arrayidx46=(($36+$35)&4294967295); //@line 1643 "numbers.cpp"
    var $37=HEAP8[($arrayidx46)]; //@line 1643 "numbers.cpp"
    var $conv47=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "numbers.cpp"
    var $cmp48=((($conv47))|0)==46; //@line 1643 "numbers.cpp"
    if ($cmp48) { __label__ = 19;; } else { __label__ = 23;; } //@line 1643 "numbers.cpp"
    $land_lhs_true49$$if_end67$28: do { 
      if (__label__ == 19) {
  
        var $38=$ix; //@line 1643 "numbers.cpp"
        var $add=((($38)+1)&4294967295); //@line 1643 "numbers.cpp"
        var $39=$word_addr; //@line 1643 "numbers.cpp"
        var $arrayidx50=(($39+$add)&4294967295); //@line 1643 "numbers.cpp"
        var $40=HEAP8[($arrayidx50)]; //@line 1643 "numbers.cpp"
        var $conv51=(tempInt=(($40)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "numbers.cpp"
        var $isdigittmp10=((($conv51)-48)&4294967295); //@line 1643 "numbers.cpp"
        var $isdigit11=((($isdigittmp10))>>>0) < 10; //@line 1643 "numbers.cpp"
        var $call52=((($isdigit11))&1); //@line 1643 "numbers.cpp"
        var $tobool53=((($call52))|0)!=0; //@line 1643 "numbers.cpp"
        if ($tobool53) { __label__ = 23;break $land_lhs_true49$$if_end67$28; } //@line 1643 "numbers.cpp"
  
        var $41=$ix; //@line 1643 "numbers.cpp"
        var $add55=((($41)+2)&4294967295); //@line 1643 "numbers.cpp"
        var $42=$word_addr; //@line 1643 "numbers.cpp"
        var $arrayidx56=(($42+$add55)&4294967295); //@line 1643 "numbers.cpp"
        var $43=HEAP8[($arrayidx56)]; //@line 1643 "numbers.cpp"
        var $conv57=(tempInt=(($43)),(tempInt>=128?tempInt-256:tempInt)); //@line 1643 "numbers.cpp"
        var $isdigittmp12=((($conv57)-48)&4294967295); //@line 1643 "numbers.cpp"
        var $isdigit13=((($isdigittmp12))>>>0) < 10; //@line 1643 "numbers.cpp"
        var $call58=((($isdigit13))&1); //@line 1643 "numbers.cpp"
        var $tobool59=((($call58))|0)!=0; //@line 1643 "numbers.cpp"
        if ($tobool59) { __label__ = 23;break $land_lhs_true49$$if_end67$28; } //@line 1643 "numbers.cpp"
  
        var $44=$wtab_addr; //@line 1643 "numbers.cpp"
        var $arrayidx61=(($44+12)&4294967295); //@line 1643 "numbers.cpp"
        var $flags62=(($arrayidx61)&4294967295); //@line 1643 "numbers.cpp"
        var $45=HEAP32[(($flags62)>>2)]; //@line 1643 "numbers.cpp"
        var $and63=($45) & 256; //@line 1643 "numbers.cpp"
        var $tobool64=((($and63))|0)!=0; //@line 1643 "numbers.cpp"
        if ($tobool64) { __label__ = 23;break $land_lhs_true49$$if_end67$28; } //@line 1643 "numbers.cpp"
  
        var $46=$ix; //@line 1646 "numbers.cpp"
        var $47=$word_addr; //@line 1646 "numbers.cpp"
        var $arrayidx66=(($47+$46)&4294967295); //@line 1646 "numbers.cpp"
        HEAP8[($arrayidx66)]=0; //@line 1646 "numbers.cpp"
        ; //@line 1647 "numbers.cpp"
      }
    } while(0);
  
    var $48=$ordinal; //@line 1649 "numbers.cpp"
    var $cmp68=((($48))|0)==0; //@line 1649 "numbers.cpp"
    if ($cmp68) { __label__ = 25;; } else { __label__ = 24;; } //@line 1649 "numbers.cpp"
    $if_then71$$lor_lhs_false69$34: do { 
      if (__label__ == 24) {
  
        var $49=$tr_addr; //@line 1649 "numbers.cpp"
        var $translator_name=(($49+280)&4294967295); //@line 1649 "numbers.cpp"
        var $50=HEAP32[(($translator_name)>>2)]; //@line 1649 "numbers.cpp"
        var $cmp70=((($50))|0)==26741; //@line 1649 "numbers.cpp"
        if ($cmp70) { __label__ = 25;break $if_then71$$lor_lhs_false69$34; } else { __label__ = 38;break $if_then71$$lor_lhs_false69$34; } //@line 1649 "numbers.cpp"
      }
    } while(0);
    $if_then71$$if_end123$36: do { 
      if (__label__ == 25) {
  
        var $51=$ix; //@line 1653 "numbers.cpp"
        var $inc72=((($51)+1)&4294967295); //@line 1653 "numbers.cpp"
        $ix=$inc72; //@line 1653 "numbers.cpp"
        $hyphen=0; //@line 1654 "numbers.cpp"
        var $arraydecay73=(($suffix)&4294967295); //@line 1655 "numbers.cpp"
        HEAP32[(($p)>>2)]=$arraydecay73; //@line 1655 "numbers.cpp"
        var $52=$wtab_addr; //@line 1656 "numbers.cpp"
        var $arrayidx74=(($52)&4294967295); //@line 1656 "numbers.cpp"
        var $flags75=(($arrayidx74)&4294967295); //@line 1656 "numbers.cpp"
        var $53=HEAP32[(($flags75)>>2)]; //@line 1656 "numbers.cpp"
        var $and76=($53) & 16384; //@line 1656 "numbers.cpp"
        var $tobool77=((($and76))|0)!=0; //@line 1656 "numbers.cpp"
        if ($tobool77) { __label__ = 26;; } else { __label__ = 27;; } //@line 1656 "numbers.cpp"
        if (__label__ == 26) {
  
          var $54=HEAP32[(($p)>>2)]; //@line 1658 "numbers.cpp"
          var $incdec_ptr=(($54+1)&4294967295); //@line 1658 "numbers.cpp"
          HEAP32[(($p)>>2)]=$incdec_ptr; //@line 1658 "numbers.cpp"
          HEAP8[($54)]=45; //@line 1658 "numbers.cpp"
          $hyphen=1; //@line 1659 "numbers.cpp"
          var $55=$ix; //@line 1660 "numbers.cpp"
          var $inc79=((($55)+1)&4294967295); //@line 1660 "numbers.cpp"
          $ix=$inc79; //@line 1660 "numbers.cpp"
          ; //@line 1661 "numbers.cpp"
        }
        $while_cond$40: while(1) { 
  
          var $56=$ix; //@line 1662 "numbers.cpp"
          var $57=$word_addr; //@line 1662 "numbers.cpp"
          var $arrayidx81=(($57+$56)&4294967295); //@line 1662 "numbers.cpp"
          var $58=HEAP8[($arrayidx81)]; //@line 1662 "numbers.cpp"
          var $conv82=(tempInt=(($58)),(tempInt>=128?tempInt-256:tempInt)); //@line 1662 "numbers.cpp"
          var $cmp83=((($conv82))|0)!=0; //@line 1662 "numbers.cpp"
          if (!($cmp83)) { __label__ = 31;break $while_cond$40; } //@line 1662 "numbers.cpp"
  
          var $59=$ix; //@line 1662 "numbers.cpp"
          var $60=$word_addr; //@line 1662 "numbers.cpp"
          var $arrayidx85=(($60+$59)&4294967295); //@line 1662 "numbers.cpp"
          var $61=HEAP8[($arrayidx85)]; //@line 1662 "numbers.cpp"
          var $conv86=(tempInt=(($61)),(tempInt>=128?tempInt-256:tempInt)); //@line 1662 "numbers.cpp"
          var $cmp87=((($conv86))|0)!=32; //@line 1662 "numbers.cpp"
          if (!($cmp87)) { __label__ = 31;break $while_cond$40; } //@line 1662 "numbers.cpp"
  
          var $62=$ix; //@line 1662 "numbers.cpp"
          var $cmp88=((($62))|0) < 19; //@line 1662 "numbers.cpp"
          if (!($cmp88)) { __label__ = 31;break $while_cond$40; }
  
          var $63=$ix; //@line 1664 "numbers.cpp"
          var $inc89=((($63)+1)&4294967295); //@line 1664 "numbers.cpp"
          $ix=$inc89; //@line 1664 "numbers.cpp"
          var $64=$word_addr; //@line 1664 "numbers.cpp"
          var $arrayidx90=(($64+$63)&4294967295); //@line 1664 "numbers.cpp"
          var $65=HEAP8[($arrayidx90)]; //@line 1664 "numbers.cpp"
          var $66=HEAP32[(($p)>>2)]; //@line 1664 "numbers.cpp"
          var $incdec_ptr91=(($66+1)&4294967295); //@line 1664 "numbers.cpp"
          HEAP32[(($p)>>2)]=$incdec_ptr91; //@line 1664 "numbers.cpp"
          HEAP8[($66)]=$65; //@line 1664 "numbers.cpp"
          __label__ = 27;continue $while_cond$40; //@line 1665 "numbers.cpp"
        }
  
        var $67=HEAP32[(($p)>>2)]; //@line 1666 "numbers.cpp"
        HEAP8[($67)]=0; //@line 1666 "numbers.cpp"
        var $arrayidx92=(($suffix)&4294967295); //@line 1668 "numbers.cpp"
        var $68=HEAP8[($arrayidx92)]; //@line 1668 "numbers.cpp"
        var $conv93=(tempInt=(($68)),(tempInt>=128?tempInt-256:tempInt)); //@line 1668 "numbers.cpp"
        var $cmp94=((($conv93))|0)!=0; //@line 1668 "numbers.cpp"
        if (!($cmp94)) { __label__ = 38;break $if_then71$$if_end123$36; } //@line 1668 "numbers.cpp"
  
        var $69=$tr_addr; //@line 1670 "numbers.cpp"
        var $langopts96=(($69)&4294967295); //@line 1670 "numbers.cpp"
        var $ordinal_indicator=(($langopts96+216)&4294967295); //@line 1670 "numbers.cpp"
        var $70=HEAP32[(($ordinal_indicator)>>2)]; //@line 1670 "numbers.cpp"
        var $cmp97=((($70))|0)!=0; //@line 1670 "numbers.cpp"
        if ($cmp97) { __label__ = 33;; } else { __label__ = 35;; } //@line 1670 "numbers.cpp"
        $land_lhs_true98$$if_else105$47: do { 
          if (__label__ == 33) {
  
            var $arraydecay99=(($suffix)&4294967295); //@line 1670 "numbers.cpp"
            var $71=$tr_addr; //@line 1670 "numbers.cpp"
            var $langopts100=(($71)&4294967295); //@line 1670 "numbers.cpp"
            var $ordinal_indicator101=(($langopts100+216)&4294967295); //@line 1670 "numbers.cpp"
            var $72=HEAP32[(($ordinal_indicator101)>>2)]; //@line 1670 "numbers.cpp"
            var $call102=_strcmp($arraydecay99, $72); //@line 1670 "numbers.cpp"
            var $cmp103=((($call102))|0)==0; //@line 1670 "numbers.cpp"
            if (!($cmp103)) { __label__ = 35;break $land_lhs_true98$$if_else105$47; } //@line 1670 "numbers.cpp"
  
            $ordinal=2; //@line 1672 "numbers.cpp"
            __label__ = 38;break $if_then71$$if_end123$36; //@line 1673 "numbers.cpp"
          }
        } while(0);
  
        var $arrayidx106=(($suffix)&4294967295); //@line 1675 "numbers.cpp"
        var $73=HEAP8[($arrayidx106)]; //@line 1675 "numbers.cpp"
        var $conv107=(tempInt=(($73)),(tempInt>=128?tempInt-256:tempInt)); //@line 1675 "numbers.cpp"
        var $isdigittmp14=((($conv107)-48)&4294967295); //@line 1675 "numbers.cpp"
        var $isdigit15=((($isdigittmp14))>>>0) < 10; //@line 1675 "numbers.cpp"
        var $call108=((($isdigit15))&1); //@line 1675 "numbers.cpp"
        var $tobool109=((($call108))|0)!=0; //@line 1675 "numbers.cpp"
        if ($tobool109) { __label__ = 38;break $if_then71$$if_end123$36; } //@line 1675 "numbers.cpp"
  
        var $arraydecay111=(($string)&4294967295); //@line 1677 "numbers.cpp"
        var $arraydecay112=(($suffix)&4294967295); //@line 1677 "numbers.cpp"
        var $call113=_sprintf($arraydecay111, ((__str15312)&4294967295), allocate([$arraydecay112,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1677 "numbers.cpp"
        var $74=$tr_addr; //@line 1678 "numbers.cpp"
        var $arraydecay114=(($string)&4294967295); //@line 1678 "numbers.cpp"
        var $call115=__Z6LookupP10TranslatorPKcPc($74, $arraydecay114, ((__ZL11ph_ordinal2)&4294967295)); //@line 1678 "numbers.cpp"
        var $tobool116=((($call115))|0)!=0; //@line 1678 "numbers.cpp"
        if (!($tobool116)) { __label__ = 38;break $if_then71$$if_end123$36; } //@line 1678 "numbers.cpp"
  
        $ordinal=2; //@line 1681 "numbers.cpp"
        var $75=$flags_addr; //@line 1682 "numbers.cpp"
        var $arrayidx118=(($75)&4294967295); //@line 1682 "numbers.cpp"
        var $76=HEAP32[(($arrayidx118)>>2)]; //@line 1682 "numbers.cpp"
        var $or=($76) | 128; //@line 1682 "numbers.cpp"
        HEAP32[(($arrayidx118)>>2)]=$or; //@line 1682 "numbers.cpp"
        $skipwords=1; //@line 1683 "numbers.cpp"
        ; //@line 1684 "numbers.cpp"
      }
    } while(0);
  
    var $77=$wtab_addr; //@line 1689 "numbers.cpp"
    var $arrayidx124=(($77)&4294967295); //@line 1689 "numbers.cpp"
    var $flags125=(($arrayidx124)&4294967295); //@line 1689 "numbers.cpp"
    var $78=HEAP32[(($flags125)>>2)]; //@line 1689 "numbers.cpp"
    var $and126=($78) & 32768; //@line 1689 "numbers.cpp"
    var $tobool127=((($and126))|0)!=0; //@line 1689 "numbers.cpp"
    if ($tobool127) { __label__ = 39;; } else { __label__ = 40;; } //@line 1689 "numbers.cpp"
    if (__label__ == 39) {
  
      $ordinal=2; //@line 1690 "numbers.cpp"
      ; //@line 1690 "numbers.cpp"
    }
  
    var $arrayidx130=(($ph_append)&4294967295); //@line 1692 "numbers.cpp"
    HEAP8[($arrayidx130)]=0; //@line 1692 "numbers.cpp"
    var $arrayidx131=(($ph_buf2)&4294967295); //@line 1693 "numbers.cpp"
    HEAP8[($arrayidx131)]=0; //@line 1693 "numbers.cpp"
    var $79=$word_addr; //@line 1696 "numbers.cpp"
    var $arrayidx132=(($79)&4294967295); //@line 1696 "numbers.cpp"
    var $80=HEAP8[($arrayidx132)]; //@line 1696 "numbers.cpp"
    var $conv133=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 1696 "numbers.cpp"
    var $cmp134=((($conv133))|0)==48; //@line 1696 "numbers.cpp"
    if ($cmp134) { __label__ = 41;; } else { __label__ = 55;; } //@line 1696 "numbers.cpp"
    $land_lhs_true135$$if_end185$57: do { 
      if (__label__ == 41) {
  
        var $81=$prev_thousands; //@line 1696 "numbers.cpp"
        var $cmp136=((($81))|0)==0; //@line 1696 "numbers.cpp"
        if (!($cmp136)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1696 "numbers.cpp"
  
        var $82=$word_addr; //@line 1696 "numbers.cpp"
        var $arrayidx138=(($82+1)&4294967295); //@line 1696 "numbers.cpp"
        var $83=HEAP8[($arrayidx138)]; //@line 1696 "numbers.cpp"
        var $conv139=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 1696 "numbers.cpp"
        var $cmp140=((($conv139))|0)!=32; //@line 1696 "numbers.cpp"
        if (!($cmp140)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1696 "numbers.cpp"
  
        var $84=$word_addr; //@line 1696 "numbers.cpp"
        var $arrayidx142=(($84+1)&4294967295); //@line 1696 "numbers.cpp"
        var $85=HEAP8[($arrayidx142)]; //@line 1696 "numbers.cpp"
        var $conv143=(tempInt=(($85)),(tempInt>=128?tempInt-256:tempInt)); //@line 1696 "numbers.cpp"
        var $86=$tr_addr; //@line 1696 "numbers.cpp"
        var $langopts144=(($86)&4294967295); //@line 1696 "numbers.cpp"
        var $decimal_sep=(($langopts144+208)&4294967295); //@line 1696 "numbers.cpp"
        var $87=HEAP32[(($decimal_sep)>>2)]; //@line 1696 "numbers.cpp"
        var $cmp145=((($conv143))|0)!=((($87))|0); //@line 1696 "numbers.cpp"
        if (!($cmp145)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1696 "numbers.cpp"
  
        var $88=$n_digits; //@line 1698 "numbers.cpp"
        var $cmp147=((($88))|0)==2; //@line 1698 "numbers.cpp"
        if ($cmp147) { __lastLabel__ = 44; __label__ = 45;; } else { __lastLabel__ = 44; __label__ = 49;; } //@line 1698 "numbers.cpp"
        if (__label__ == 45) {
  
          var $89=$word_addr; //@line 1698 "numbers.cpp"
          var $arrayidx149=(($89+3)&4294967295); //@line 1698 "numbers.cpp"
          var $90=HEAP8[($arrayidx149)]; //@line 1698 "numbers.cpp"
          var $conv150=(tempInt=(($90)),(tempInt>=128?tempInt-256:tempInt)); //@line 1698 "numbers.cpp"
          var $cmp151=((($conv150))|0)==58; //@line 1698 "numbers.cpp"
          if ($cmp151) { __label__ = 46;; } else { __label__ = 48;; } //@line 1698 "numbers.cpp"
          $land_lhs_true152$$if_else163thread_pre_split$64: do { 
            if (__label__ == 46) {
  
              var $91=$word_addr; //@line 1698 "numbers.cpp"
              var $arrayidx153=(($91+5)&4294967295); //@line 1698 "numbers.cpp"
              var $92=HEAP8[($arrayidx153)]; //@line 1698 "numbers.cpp"
              var $conv154=(tempInt=(($92)),(tempInt>=128?tempInt-256:tempInt)); //@line 1698 "numbers.cpp"
              var $isdigittmp16=((($conv154)-48)&4294967295); //@line 1698 "numbers.cpp"
              var $isdigit17=((($isdigittmp16))>>>0) < 10; //@line 1698 "numbers.cpp"
              var $call155=((($isdigit17))&1); //@line 1698 "numbers.cpp"
              var $tobool156=((($call155))|0)!=0; //@line 1698 "numbers.cpp"
              if (!($tobool156)) { __label__ = 48;break $land_lhs_true152$$if_else163thread_pre_split$64; } //@line 1698 "numbers.cpp"
  
              var $93=$word_addr; //@line 1698 "numbers.cpp"
              var $arrayidx158=(($93+7)&4294967295); //@line 1698 "numbers.cpp"
              var $94=HEAP8[($arrayidx158)]; //@line 1698 "numbers.cpp"
              var $conv159=(tempInt=(($94)),(tempInt>=128?tempInt-256:tempInt)); //@line 1698 "numbers.cpp"
              var $call160=_isspace($conv159); //@line 1698 "numbers.cpp"
              var $tobool161=((($call160))|0)!=0; //@line 1698 "numbers.cpp"
              if ($tobool161) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1698 "numbers.cpp"
            }
          } while(0);
  
          var $_pr43=$n_digits; //@line 1704 "numbers.cpp"
          __lastLabel__ = 48; ;
        }
  
        var $95=__lastLabel__ == 48 ? $_pr43 : ($88); //@line 1704 "numbers.cpp"
        var $cmp164=((($95))|0) > 3; //@line 1704 "numbers.cpp"
        if ($cmp164) { __label__ = 50;; } else { __label__ = 51;; } //@line 1704 "numbers.cpp"
        if (__label__ == 50) {
  
          var $96=$flags_addr; //@line 1706 "numbers.cpp"
          var $arrayidx166=(($96)&4294967295); //@line 1706 "numbers.cpp"
          var $97=HEAP32[(($arrayidx166)>>2)]; //@line 1706 "numbers.cpp"
          var $and167=($97) & -129; //@line 1706 "numbers.cpp"
          HEAP32[(($arrayidx166)>>2)]=$and167; //@line 1706 "numbers.cpp"
          $retval=0; //@line 1707 "numbers.cpp"
          __label__ = 157;break $land_lhs_true135$$if_end185$57; //@line 1707 "numbers.cpp"
        }
        else if (__label__ == 51) {
  
          $ix=0; //@line 1711 "numbers.cpp"
          var $arraydecay177=(($ph_zeros)&4294967295); //@line 1713 "numbers.cpp"
          ; //@line 1711 "numbers.cpp"
          while(1) { 
  
            var $98=$ix; //@line 1711 "numbers.cpp"
            var $99=$word_addr; //@line 1711 "numbers.cpp"
            var $arrayidx170=(($99+$98)&4294967295); //@line 1711 "numbers.cpp"
            var $100=HEAP8[($arrayidx170)]; //@line 1711 "numbers.cpp"
            var $conv171=(tempInt=(($100)),(tempInt>=128?tempInt-256:tempInt)); //@line 1711 "numbers.cpp"
            var $cmp172=((($conv171))|0)==48; //@line 1711 "numbers.cpp"
            if (!($cmp172)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; } //@line 1711 "numbers.cpp"
  
            var $101=$ix; //@line 1711 "numbers.cpp"
            var $102=$n_digits; //@line 1711 "numbers.cpp"
            var $sub=((($102)-1)&4294967295); //@line 1711 "numbers.cpp"
            var $cmp174=((($101))|0) < ((($sub))|0); //@line 1711 "numbers.cpp"
            if (!($cmp174)) { __label__ = 55;break $land_lhs_true135$$if_end185$57; }
  
            var $103=$tr_addr; //@line 1713 "numbers.cpp"
            var $call178=_strlen($arraydecay177); //@line 1713 "numbers.cpp"
            var $arrayidx179=(($ph_zeros+$call178)&4294967295); //@line 1713 "numbers.cpp"
            var $call180=__Z6LookupP10TranslatorPKcPc($103, ((__str16313)&4294967295), $arrayidx179); //@line 1713 "numbers.cpp"
            var $104=$ix; //@line 1711 "numbers.cpp"
            var $inc182=((($104)+1)&4294967295); //@line 1711 "numbers.cpp"
            $ix=$inc182; //@line 1711 "numbers.cpp"
            __label__ = 52;continue ; //@line 1711 "numbers.cpp"
          }
        }
      }
    } while(0);
    if (__label__ == 55) {
  
      var $105=$tr_addr; //@line 1718 "numbers.cpp"
      var $langopts186=(($105)&4294967295); //@line 1718 "numbers.cpp"
      var $numbers187=(($langopts186+184)&4294967295); //@line 1718 "numbers.cpp"
      var $106=HEAP32[(($numbers187)>>2)]; //@line 1718 "numbers.cpp"
      var $and188=($106) & 4096; //@line 1718 "numbers.cpp"
      var $tobool189=((($and188))|0)!=0; //@line 1718 "numbers.cpp"
      if ($tobool189) { __label__ = 56;; } else { __label__ = 58;; } //@line 1718 "numbers.cpp"
      $land_lhs_true190$$if_else195$78: do { 
        if (__label__ == 56) {
  
          var $107=$n_digits; //@line 1718 "numbers.cpp"
          var $108=$word_addr; //@line 1718 "numbers.cpp"
          var $arrayidx191=(($108+$107)&4294967295); //@line 1718 "numbers.cpp"
          var $109=HEAP8[($arrayidx191)]; //@line 1718 "numbers.cpp"
          var $conv192=(tempInt=(($109)),(tempInt>=128?tempInt-256:tempInt)); //@line 1718 "numbers.cpp"
          var $cmp193=((($conv192))|0)==32; //@line 1718 "numbers.cpp"
          if (!($cmp193)) { __label__ = 58;break $land_lhs_true190$$if_else195$78; } //@line 1718 "numbers.cpp"
  
          $thousands_inc=1; //@line 1719 "numbers.cpp"
          __label__ = 60;break $land_lhs_true190$$if_else195$78; //@line 1719 "numbers.cpp"
        }
      } while(0);
      $if_end203_thread$$if_else195$81: do { 
        if (__label__ == 58) {
  
          var $110=$n_digits; //@line 1721 "numbers.cpp"
          var $111=$word_addr; //@line 1721 "numbers.cpp"
          var $arrayidx196=(($111+$110)&4294967295); //@line 1721 "numbers.cpp"
          var $112=HEAP8[($arrayidx196)]; //@line 1721 "numbers.cpp"
          var $conv197=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 1721 "numbers.cpp"
          var $113=$tr_addr; //@line 1721 "numbers.cpp"
          var $langopts198=(($113)&4294967295); //@line 1721 "numbers.cpp"
          var $thousands_sep199=(($langopts198+204)&4294967295); //@line 1721 "numbers.cpp"
          var $114=HEAP32[(($thousands_sep199)>>2)]; //@line 1721 "numbers.cpp"
          var $cmp200=((($conv197))|0)==((($114))|0); //@line 1721 "numbers.cpp"
          if ($cmp200) { __label__ = 59;; } else { __label__ = 61;; } //@line 1721 "numbers.cpp"
          if (__label__ == 59) {
  
            $thousands_inc=2; //@line 1722 "numbers.cpp"
            __label__ = 60;break $if_end203_thread$$if_else195$81; //@line 1722 "numbers.cpp"
          }
          else if (__label__ == 61) {
  
            var $_pr44=$thousands_inc; //@line 1725 "numbers.cpp"
            var $116=$n_digits; //@line 1724 "numbers.cpp"
            var $add204=((($116)+2)&4294967295); //@line 1724 "numbers.cpp"
            $suffix_ix=$add204; //@line 1724 "numbers.cpp"
            var $cmp205=((($_pr44))|0) > 0; //@line 1725 "numbers.cpp"
            if ($cmp205) { __label__ = 62;break $if_end203_thread$$if_else195$81; } else { __label__ = 77;break $if_end203_thread$$if_else195$81; } //@line 1725 "numbers.cpp"
          }
        }
      } while(0);
      $if_end203_thread$$if_then206$$if_end282$86: do { 
        if (__label__ == 60) {
  
          var $115=$n_digits; //@line 1724 "numbers.cpp"
          var $add20445=((($115)+2)&4294967295); //@line 1724 "numbers.cpp"
          $suffix_ix=$add20445; //@line 1724 "numbers.cpp"
          __label__ = 62;break $if_end203_thread$$if_then206$$if_end282$86; //@line 1725 "numbers.cpp"
        }
      } while(0);
      $if_then206$$if_end282$88: do { 
        if (__label__ == 62) {
  
          var $117=$n_digits; //@line 1729 "numbers.cpp"
          var $118=$thousands_inc; //@line 1729 "numbers.cpp"
          var $add207=((($118)+($117))&4294967295); //@line 1729 "numbers.cpp"
          $digix=$add207; //@line 1729 "numbers.cpp"
          ; //@line 1731 "numbers.cpp"
          $while_cond208$90: while(1) { 
  
            var $119=$thousandplex; //@line 1731 "numbers.cpp"
            var $add209=((($119)+1)&4294967295); //@line 1731 "numbers.cpp"
            var $120=$wtab_addr; //@line 1731 "numbers.cpp"
            var $arrayidx210=(($120+12*$add209)&4294967295); //@line 1731 "numbers.cpp"
            var $flags211=(($arrayidx210)&4294967295); //@line 1731 "numbers.cpp"
            var $121=HEAP32[(($flags211)>>2)]; //@line 1731 "numbers.cpp"
            var $and212=($121) & 262144; //@line 1731 "numbers.cpp"
            var $cmp213=((($and212))|0)==0; //@line 1731 "numbers.cpp"
            if (!($cmp213)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1731 "numbers.cpp"
  
            var $122=$digix; //@line 1732 "numbers.cpp"
            var $123=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx215=(($123+$122)&4294967295); //@line 1732 "numbers.cpp"
            var $124=HEAP8[($arrayidx215)]; //@line 1732 "numbers.cpp"
            var $conv216=(tempInt=(($124)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp18=((($conv216)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit19=((($isdigittmp18))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call217=((($isdigit19))&1); //@line 1732 "numbers.cpp"
            var $tobool218=((($call217))|0)!=0; //@line 1732 "numbers.cpp"
            if (!($tobool218)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $125=$digix; //@line 1732 "numbers.cpp"
            var $add220=((($125)+1)&4294967295); //@line 1732 "numbers.cpp"
            var $126=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx221=(($126+$add220)&4294967295); //@line 1732 "numbers.cpp"
            var $127=HEAP8[($arrayidx221)]; //@line 1732 "numbers.cpp"
            var $conv222=(tempInt=(($127)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp20=((($conv222)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit21=((($isdigittmp20))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call223=((($isdigit21))&1); //@line 1732 "numbers.cpp"
            var $tobool224=((($call223))|0)!=0; //@line 1732 "numbers.cpp"
            if (!($tobool224)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $128=$digix; //@line 1732 "numbers.cpp"
            var $add226=((($128)+2)&4294967295); //@line 1732 "numbers.cpp"
            var $129=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx227=(($129+$add226)&4294967295); //@line 1732 "numbers.cpp"
            var $130=HEAP8[($arrayidx227)]; //@line 1732 "numbers.cpp"
            var $conv228=(tempInt=(($130)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp22=((($conv228)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit23=((($isdigittmp22))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call229=((($isdigit23))&1); //@line 1732 "numbers.cpp"
            var $tobool230=((($call229))|0)!=0; //@line 1732 "numbers.cpp"
            if (!($tobool230)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $131=$digix; //@line 1732 "numbers.cpp"
            var $add232=((($131)+3)&4294967295); //@line 1732 "numbers.cpp"
            var $132=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx233=(($132+$add232)&4294967295); //@line 1732 "numbers.cpp"
            var $133=HEAP8[($arrayidx233)]; //@line 1732 "numbers.cpp"
            var $conv234=(tempInt=(($133)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp24=((($conv234)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit25=((($isdigittmp24))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call235=((($isdigit25))&1); //@line 1732 "numbers.cpp"
            var $tobool236=((($call235))|0)!=0; //@line 1732 "numbers.cpp"
            if ($tobool236) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1732 "numbers.cpp"
  
            var $134=$digix; //@line 1732 "numbers.cpp"
            var $sub238=((($134)-1)&4294967295); //@line 1732 "numbers.cpp"
            var $135=$word_addr; //@line 1732 "numbers.cpp"
            var $arrayidx239=(($135+$sub238)&4294967295); //@line 1732 "numbers.cpp"
            var $136=HEAP8[($arrayidx239)]; //@line 1732 "numbers.cpp"
            var $conv240=(tempInt=(($136)),(tempInt>=128?tempInt-256:tempInt)); //@line 1732 "numbers.cpp"
            var $isdigittmp26=((($conv240)-48)&4294967295); //@line 1732 "numbers.cpp"
            var $isdigit27=((($isdigittmp26))>>>0) < 10; //@line 1732 "numbers.cpp"
            var $call241=((($isdigit27))&1); //@line 1732 "numbers.cpp"
            var $tobool242=((($call241))|0)!=0; //@line 1732 "numbers.cpp"
            var $lnot=($tobool242) ^ 1; //@line 1732 "numbers.cpp"
            if (!($lnot)) { __label__ = 77;break $if_then206$$if_end282$88; }
  
            var $137=$digix; //@line 1734 "numbers.cpp"
            var $138=$word_addr; //@line 1734 "numbers.cpp"
            var $arrayidx245=(($138+$137)&4294967295); //@line 1734 "numbers.cpp"
            var $139=HEAP8[($arrayidx245)]; //@line 1734 "numbers.cpp"
            var $conv246=(tempInt=(($139)),(tempInt>=128?tempInt-256:tempInt)); //@line 1734 "numbers.cpp"
            var $cmp247=((($conv246))|0)!=48; //@line 1734 "numbers.cpp"
            if ($cmp247) { __label__ = 72;; } else { __label__ = 70;; } //@line 1734 "numbers.cpp"
            $if_then258$$lor_lhs_false248$98: do { 
              if (__label__ == 70) {
  
                var $140=$digix; //@line 1734 "numbers.cpp"
                var $add249=((($140)+1)&4294967295); //@line 1734 "numbers.cpp"
                var $141=$word_addr; //@line 1734 "numbers.cpp"
                var $arrayidx250=(($141+$add249)&4294967295); //@line 1734 "numbers.cpp"
                var $142=HEAP8[($arrayidx250)]; //@line 1734 "numbers.cpp"
                var $conv251=(tempInt=(($142)),(tempInt>=128?tempInt-256:tempInt)); //@line 1734 "numbers.cpp"
                var $cmp252=((($conv251))|0)!=48; //@line 1734 "numbers.cpp"
                if ($cmp252) { __label__ = 72;break $if_then258$$lor_lhs_false248$98; } //@line 1734 "numbers.cpp"
  
                var $143=$digix; //@line 1734 "numbers.cpp"
                var $add254=((($143)+2)&4294967295); //@line 1734 "numbers.cpp"
                var $144=$word_addr; //@line 1734 "numbers.cpp"
                var $arrayidx255=(($144+$add254)&4294967295); //@line 1734 "numbers.cpp"
                var $145=HEAP8[($arrayidx255)]; //@line 1734 "numbers.cpp"
                var $conv256=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 1734 "numbers.cpp"
                var $cmp257=((($conv256))|0)!=48; //@line 1734 "numbers.cpp"
                if ($cmp257) { __label__ = 72;break $if_then258$$lor_lhs_false248$98; } else { __label__ = 73;break $if_then258$$lor_lhs_false248$98; } //@line 1734 "numbers.cpp"
              }
            } while(0);
            if (__label__ == 72) {
  
              $thousands_exact=0; //@line 1735 "numbers.cpp"
              ; //@line 1735 "numbers.cpp"
            }
  
            var $146=$thousandplex; //@line 1737 "numbers.cpp"
            var $inc260=((($146)+1)&4294967295); //@line 1737 "numbers.cpp"
            $thousandplex=$inc260; //@line 1737 "numbers.cpp"
            var $147=$digix; //@line 1738 "numbers.cpp"
            var $add261=((($147)+3)&4294967295); //@line 1738 "numbers.cpp"
            $digix=$add261; //@line 1738 "numbers.cpp"
            var $148=$digix; //@line 1739 "numbers.cpp"
            var $149=$word_addr; //@line 1739 "numbers.cpp"
            var $arrayidx262=(($149+$148)&4294967295); //@line 1739 "numbers.cpp"
            var $150=HEAP8[($arrayidx262)]; //@line 1739 "numbers.cpp"
            var $conv263=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 1739 "numbers.cpp"
            var $151=$tr_addr; //@line 1739 "numbers.cpp"
            var $langopts264=(($151)&4294967295); //@line 1739 "numbers.cpp"
            var $thousands_sep265=(($langopts264+204)&4294967295); //@line 1739 "numbers.cpp"
            var $152=HEAP32[(($thousands_sep265)>>2)]; //@line 1739 "numbers.cpp"
            var $cmp266=((($conv263))|0)==((($152))|0); //@line 1739 "numbers.cpp"
            if ($cmp266) { __label__ = 76;; } else { __label__ = 74;; } //@line 1739 "numbers.cpp"
            if (__label__ == 74) {
  
              var $153=$tr_addr; //@line 1739 "numbers.cpp"
              var $langopts268=(($153)&4294967295); //@line 1739 "numbers.cpp"
              var $numbers269=(($langopts268+184)&4294967295); //@line 1739 "numbers.cpp"
              var $154=HEAP32[(($numbers269)>>2)]; //@line 1739 "numbers.cpp"
              var $and270=($154) & 4096; //@line 1739 "numbers.cpp"
              var $tobool271=((($and270))|0)!=0; //@line 1739 "numbers.cpp"
              if (!($tobool271)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1739 "numbers.cpp"
  
              var $155=$digix; //@line 1739 "numbers.cpp"
              var $156=$word_addr; //@line 1739 "numbers.cpp"
              var $arrayidx273=(($156+$155)&4294967295); //@line 1739 "numbers.cpp"
              var $157=HEAP8[($arrayidx273)]; //@line 1739 "numbers.cpp"
              var $conv274=(tempInt=(($157)),(tempInt>=128?tempInt-256:tempInt)); //@line 1739 "numbers.cpp"
              var $cmp275=((($conv274))|0)==32; //@line 1739 "numbers.cpp"
              if (!($cmp275)) { __label__ = 77;break $if_then206$$if_end282$88; } //@line 1739 "numbers.cpp"
            }
  
            var $158=$digix; //@line 1741 "numbers.cpp"
            var $add277=((($158)+2)&4294967295); //@line 1741 "numbers.cpp"
            $suffix_ix=$add277; //@line 1741 "numbers.cpp"
            var $159=$thousands_inc; //@line 1742 "numbers.cpp"
            var $160=$digix; //@line 1742 "numbers.cpp"
            var $add278=((($160)+($159))&4294967295); //@line 1742 "numbers.cpp"
            $digix=$add278; //@line 1742 "numbers.cpp"
            __label__ = 63;continue $while_cond208$90; //@line 1746 "numbers.cpp"
          }
        }
      } while(0);
  
      var $161=$value; //@line 1749 "numbers.cpp"
      var $cmp283=((($161))|0)==0; //@line 1749 "numbers.cpp"
      if ($cmp283) { __label__ = 78;; } else { __label__ = 80;; } //@line 1749 "numbers.cpp"
      $land_lhs_true284$$if_end287$109: do { 
        if (__label__ == 78) {
  
          var $162=$prev_thousands; //@line 1749 "numbers.cpp"
          var $tobool285=((($162))|0)!=0; //@line 1749 "numbers.cpp"
          if (!($tobool285)) { __label__ = 80;break $land_lhs_true284$$if_end287$109; } //@line 1749 "numbers.cpp"
  
          $suppress_null=1; //@line 1751 "numbers.cpp"
          ; //@line 1752 "numbers.cpp"
        }
      } while(0);
  
      var $163=$tr_addr; //@line 1754 "numbers.cpp"
      var $translator_name288=(($163+280)&4294967295); //@line 1754 "numbers.cpp"
      var $164=HEAP32[(($translator_name288)>>2)]; //@line 1754 "numbers.cpp"
      var $cmp289=((($164))|0)==26741; //@line 1754 "numbers.cpp"
      if ($cmp289) { __label__ = 81;; } else { __label__ = 85;; } //@line 1754 "numbers.cpp"
      $if_then290$$if_end304$113: do { 
        if (__label__ == 81) {
  
          var $165=$thousandplex; //@line 1757 "numbers.cpp"
          var $166=$wtab_addr; //@line 1757 "numbers.cpp"
          var $arrayidx291=(($166+12*$165)&4294967295); //@line 1757 "numbers.cpp"
          var $flags292=(($arrayidx291)&4294967295); //@line 1757 "numbers.cpp"
          var $167=HEAP32[(($flags292)>>2)]; //@line 1757 "numbers.cpp"
          var $and293=($167) & 16384; //@line 1757 "numbers.cpp"
          var $tobool294=((($and293))|0)!=0; //@line 1757 "numbers.cpp"
          if (!($tobool294)) { __label__ = 85;break $if_then290$$if_end304$113; } //@line 1757 "numbers.cpp"
  
          var $168=$thousands_exact; //@line 1757 "numbers.cpp"
          var $cmp296=((($168))|0)==1; //@line 1757 "numbers.cpp"
          if (!($cmp296)) { __label__ = 85;break $if_then290$$if_end304$113; } //@line 1757 "numbers.cpp"
  
          var $169=$suffix_ix; //@line 1757 "numbers.cpp"
          var $170=$word_addr; //@line 1757 "numbers.cpp"
          var $arrayidx298=(($170+$169)&4294967295); //@line 1757 "numbers.cpp"
          var $171=$thousandplex; //@line 1757 "numbers.cpp"
          var $172=$value; //@line 1757 "numbers.cpp"
          var $call299=__ZL11hu_number_ePKcii($arrayidx298, $171, $172); //@line 1757 "numbers.cpp"
          var $tobool300=((($call299))|0)!=0; //@line 1757 "numbers.cpp"
          if (!($tobool300)) { __label__ = 85;break $if_then290$$if_end304$113; } //@line 1757 "numbers.cpp"
  
          var $173=HEAP32[((__ZL14number_control)>>2)]; //@line 1759 "numbers.cpp"
          var $or302=($173) | 1; //@line 1759 "numbers.cpp"
          HEAP32[((__ZL14number_control)>>2)]=$or302; //@line 1759 "numbers.cpp"
          ; //@line 1760 "numbers.cpp"
        }
      } while(0);
  
      var $174=$n_digits; //@line 1763 "numbers.cpp"
      var $175=$word_addr; //@line 1763 "numbers.cpp"
      var $arrayidx305=(($175+$174)&4294967295); //@line 1763 "numbers.cpp"
      var $176=HEAP8[($arrayidx305)]; //@line 1763 "numbers.cpp"
      var $conv306=(tempInt=(($176)),(tempInt>=128?tempInt-256:tempInt)); //@line 1763 "numbers.cpp"
      var $177=$tr_addr; //@line 1763 "numbers.cpp"
      var $langopts307=(($177)&4294967295); //@line 1763 "numbers.cpp"
      var $decimal_sep308=(($langopts307+208)&4294967295); //@line 1763 "numbers.cpp"
      var $178=HEAP32[(($decimal_sep308)>>2)]; //@line 1763 "numbers.cpp"
      var $cmp309=((($conv306))|0)==((($178))|0); //@line 1763 "numbers.cpp"
      if ($cmp309) { __label__ = 86;; } else { __label__ = 88;; } //@line 1763 "numbers.cpp"
      $land_lhs_true310$$if_else319$119: do { 
        if (__label__ == 86) {
  
          var $179=$n_digits; //@line 1763 "numbers.cpp"
          var $add311=((($179)+1)&4294967295); //@line 1763 "numbers.cpp"
          var $180=$word_addr; //@line 1763 "numbers.cpp"
          var $arrayidx312=(($180+$add311)&4294967295); //@line 1763 "numbers.cpp"
          var $181=HEAP8[($arrayidx312)]; //@line 1763 "numbers.cpp"
          var $conv313=(tempInt=(($181)),(tempInt>=128?tempInt-256:tempInt)); //@line 1763 "numbers.cpp"
          var $isdigittmp28=((($conv313)-48)&4294967295); //@line 1763 "numbers.cpp"
          var $isdigit29=((($isdigittmp28))>>>0) < 10; //@line 1763 "numbers.cpp"
          var $call314=((($isdigit29))&1); //@line 1763 "numbers.cpp"
          var $tobool315=((($call314))|0)!=0; //@line 1763 "numbers.cpp"
          if (!($tobool315)) { __label__ = 88;break $land_lhs_true310$$if_else319$119; } //@line 1763 "numbers.cpp"
  
          var $182=$tr_addr; //@line 1766 "numbers.cpp"
          var $arraydecay317=(($ph_append)&4294967295); //@line 1766 "numbers.cpp"
          var $call318=__Z6LookupP10TranslatorPKcPc($182, ((__str17314)&4294967295), $arraydecay317); //@line 1766 "numbers.cpp"
          $decimal_point=1; //@line 1767 "numbers.cpp"
          __label__ = 98;break $land_lhs_true310$$if_else319$119; //@line 1768 "numbers.cpp"
        }
      } while(0);
      $if_end356$$if_else319$122: do { 
        if (__label__ == 88) {
  
          var $183=$suppress_null; //@line 1770 "numbers.cpp"
          var $cmp320=((($183))|0)==0; //@line 1770 "numbers.cpp"
          if ($cmp320) { __label__ = 89;; } else { __label__ = 95;; } //@line 1770 "numbers.cpp"
          if (__label__ == 89) {
  
            var $184=$thousands_inc; //@line 1772 "numbers.cpp"
            var $cmp322=((($184))|0) > 0; //@line 1772 "numbers.cpp"
            if (!($cmp322)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1772 "numbers.cpp"
  
            var $185=$thousandplex; //@line 1774 "numbers.cpp"
            var $cmp324=((($185))|0) > 0; //@line 1774 "numbers.cpp"
            if (!($cmp324)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1774 "numbers.cpp"
  
            var $186=$value; //@line 1774 "numbers.cpp"
            var $cmp326=((($186))|0) < 1000; //@line 1774 "numbers.cpp"
            if (!($cmp326)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1774 "numbers.cpp"
  
            var $187=$suppress_null; //@line 1776 "numbers.cpp"
            var $cmp328=((($187))|0)==0; //@line 1776 "numbers.cpp"
            if (!($cmp328)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1776 "numbers.cpp"
  
            var $188=$tr_addr; //@line 1776 "numbers.cpp"
            var $189=$value; //@line 1776 "numbers.cpp"
            var $190=$thousandplex; //@line 1776 "numbers.cpp"
            var $191=$thousands_exact; //@line 1776 "numbers.cpp"
            var $arraydecay330=(($ph_append)&4294967295); //@line 1776 "numbers.cpp"
            var $call331=__ZL15LookupThousandsP10TranslatoriiiPc($188, $189, $190, $191, $arraydecay330); //@line 1776 "numbers.cpp"
            var $tobool332=((($call331))|0)!=0; //@line 1776 "numbers.cpp"
            if (!($tobool332)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1776 "numbers.cpp"
  
            $value=0; //@line 1779 "numbers.cpp"
            $suppress_null=1; //@line 1780 "numbers.cpp"
            ; //@line 1781 "numbers.cpp"
          }
          else if (__label__ == 95) {
  
            var $192=HEAP32[((__ZL23speak_missing_thousands)>>2)]; //@line 1787 "numbers.cpp"
            var $cmp338=((($192))|0)==1; //@line 1787 "numbers.cpp"
            if (!($cmp338)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1787 "numbers.cpp"
  
            var $arraydecay340=(($string)&4294967295); //@line 1790 "numbers.cpp"
            var $193=$thousandplex; //@line 1790 "numbers.cpp"
            var $add341=((($193)+1)&4294967295); //@line 1790 "numbers.cpp"
            var $call342=_sprintf($arraydecay340, ((__str18315)&4294967295), allocate([$add341,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1790 "numbers.cpp"
            var $194=$tr_addr; //@line 1791 "numbers.cpp"
            var $arraydecay343=(($string)&4294967295); //@line 1791 "numbers.cpp"
            var $arraydecay344=(($buf1)&4294967295); //@line 1791 "numbers.cpp"
            var $call345=__Z6LookupP10TranslatorPKcPc($194, $arraydecay343, $arraydecay344); //@line 1791 "numbers.cpp"
            var $cmp346=((($call345))|0)==0; //@line 1791 "numbers.cpp"
            if (!($cmp346)) { __label__ = 98;break $if_end356$$if_else319$122; } //@line 1791 "numbers.cpp"
  
            var $arraydecay348=(($string)&4294967295); //@line 1793 "numbers.cpp"
            var $195=$thousandplex; //@line 1793 "numbers.cpp"
            var $call349=_sprintf($arraydecay348, ((__str18315)&4294967295), allocate([$195,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1793 "numbers.cpp"
            var $196=$tr_addr; //@line 1794 "numbers.cpp"
            var $arraydecay350=(($string)&4294967295); //@line 1794 "numbers.cpp"
            var $arraydecay351=(($ph_append)&4294967295); //@line 1794 "numbers.cpp"
            var $call352=__Z6LookupP10TranslatorPKcPc($196, $arraydecay350, $arraydecay351); //@line 1794 "numbers.cpp"
            ; //@line 1795 "numbers.cpp"
          }
        }
      } while(0);
  
      var $arrayidx357=(($ph_append)&4294967295); //@line 1798 "numbers.cpp"
      var $197=HEAP8[($arrayidx357)]; //@line 1798 "numbers.cpp"
      var $conv358=(tempInt=(($197)),(tempInt>=128?tempInt-256:tempInt)); //@line 1798 "numbers.cpp"
      var $cmp359=((($conv358))|0)==0; //@line 1798 "numbers.cpp"
      if ($cmp359) { __label__ = 99;; } else { __label__ = 102;; } //@line 1798 "numbers.cpp"
      $land_lhs_true360$$if_end369$135: do { 
        if (__label__ == 99) {
  
          var $198=$n_digits; //@line 1798 "numbers.cpp"
          var $199=$word_addr; //@line 1798 "numbers.cpp"
          var $arrayidx361=(($199+$198)&4294967295); //@line 1798 "numbers.cpp"
          var $200=HEAP8[($arrayidx361)]; //@line 1798 "numbers.cpp"
          var $conv362=(tempInt=(($200)),(tempInt>=128?tempInt-256:tempInt)); //@line 1798 "numbers.cpp"
          var $cmp363=((($conv362))|0)==46; //@line 1798 "numbers.cpp"
          if (!($cmp363)) { __label__ = 102;break $land_lhs_true360$$if_end369$135; } //@line 1798 "numbers.cpp"
  
          var $201=$thousandplex; //@line 1798 "numbers.cpp"
          var $cmp365=((($201))|0)==0; //@line 1798 "numbers.cpp"
          if (!($cmp365)) { __label__ = 112;break $land_lhs_true360$$if_end369$135; } //@line 1798 "numbers.cpp"
  
          var $202=$tr_addr; //@line 1800 "numbers.cpp"
          var $arraydecay367=(($ph_append)&4294967295); //@line 1800 "numbers.cpp"
          var $call368=__Z6LookupP10TranslatorPKcPc($202, ((__str19316)&4294967295), $arraydecay367); //@line 1800 "numbers.cpp"
          __label__ = 102;break $land_lhs_true360$$if_end369$135; //@line 1801 "numbers.cpp"
        }
      } while(0);
      $if_end369$$if_end404$139: do { 
        if (__label__ == 102) {
  
          var $_pr47=$thousandplex; //@line 1803 "numbers.cpp"
          var $cmp370=((($_pr47))|0)==0; //@line 1803 "numbers.cpp"
          if (!($cmp370)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1803 "numbers.cpp"
  
          var $203=$word_addr; //@line 1807 "numbers.cpp"
          HEAP32[(($p)>>2)]=$203; //@line 1807 "numbers.cpp"
          var $204=HEAP32[(($p)>>2)]; //@line 1808 "numbers.cpp"
          var $arrayidx37360=(($204+1)&4294967295); //@line 1808 "numbers.cpp"
          var $205=HEAP8[($arrayidx37360)]; //@line 1808 "numbers.cpp"
          var $conv37461=(tempInt=(($205)),(tempInt>=128?tempInt-256:tempInt)); //@line 1808 "numbers.cpp"
          var $isdigittmp3062=((($conv37461)-48)&4294967295); //@line 1808 "numbers.cpp"
          var $isdigit3163=((($isdigittmp3062))>>>0) < 10; //@line 1808 "numbers.cpp"
          var $206=HEAPU32[(($p)>>2)]; //@line 1808 "numbers.cpp"
          if ($isdigit3163) { __lastLabel__ = 103; __label__ = 104;; } else { __lastLabel__ = 103; __label__ = 105;; } //@line 1808 "numbers.cpp"
          $while_body377$$while_end379$142: do { 
            if (__label__ == 104) {
              while(1) { 
  
                var $207=__lastLabel__ == 104 ? $210 : ($206);
                var $incdec_ptr378=(($207+1)&4294967295); //@line 1808 "numbers.cpp"
                HEAP32[(($p)>>2)]=$incdec_ptr378; //@line 1808 "numbers.cpp"
                var $208=HEAP32[(($p)>>2)]; //@line 1808 "numbers.cpp"
                var $arrayidx373=(($208+1)&4294967295); //@line 1808 "numbers.cpp"
                var $209=HEAP8[($arrayidx373)]; //@line 1808 "numbers.cpp"
                var $conv374=(tempInt=(($209)),(tempInt>=128?tempInt-256:tempInt)); //@line 1808 "numbers.cpp"
                var $isdigittmp30=((($conv374)-48)&4294967295); //@line 1808 "numbers.cpp"
                var $isdigit31=((($isdigittmp30))>>>0) < 10; //@line 1808 "numbers.cpp"
                var $call375=((($isdigit31))&1); //@line 1808 "numbers.cpp"
                var $tobool376=((($call375))|0)!=0; //@line 1808 "numbers.cpp"
                var $210=HEAPU32[(($p)>>2)]; //@line 1808 "numbers.cpp"
                if ($tobool376) { __lastLabel__ = 104; __label__ = 104;continue ; } else { __lastLabel__ = 104; __label__ = 105;break $while_body377$$while_end379$142; } //@line 1808 "numbers.cpp"
              }
            }
          } while(0);
  
          var $_lcssa=__lastLabel__ == 103 ? $206 : ($210);
          var $arrayidx380=(($_lcssa+-1)&4294967295); //@line 1809 "numbers.cpp"
          var $211=HEAP8[($arrayidx380)]; //@line 1809 "numbers.cpp"
          var $conv381=(tempInt=(($211)),(tempInt>=128?tempInt-256:tempInt)); //@line 1809 "numbers.cpp"
          var $isdigittmp32=((($conv381)-48)&4294967295); //@line 1809 "numbers.cpp"
          var $isdigit33=((($isdigittmp32))>>>0) < 10; //@line 1809 "numbers.cpp"
          var $call382=((($isdigit33))&1); //@line 1809 "numbers.cpp"
          var $tobool383=((($call382))|0)!=0; //@line 1809 "numbers.cpp"
          if ($tobool383) { __label__ = 106;; } else { __label__ = 108;; } //@line 1809 "numbers.cpp"
          $if_then384$$if_end390$146: do { 
            if (__label__ == 106) {
  
              var $212=HEAP32[(($p)>>2)]; //@line 1811 "numbers.cpp"
              var $add_ptr=(($212+-1)&4294967295); //@line 1811 "numbers.cpp"
              HEAP32[(($p2)>>2)]=$add_ptr; //@line 1811 "numbers.cpp"
              var $213=$tr_addr; //@line 1812 "numbers.cpp"
              var $arraydecay385=(($buf_digit_lookup)&4294967295); //@line 1812 "numbers.cpp"
              var $214=$flags_addr; //@line 1812 "numbers.cpp"
              var $215=$wtab_addr; //@line 1812 "numbers.cpp"
              var $call386=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($213, $p2, $arraydecay385, $214, 4, $215); //@line 1812 "numbers.cpp"
              var $tobool387=((($call386))|0)!=0; //@line 1812 "numbers.cpp"
              if (!($tobool387)) { __label__ = 108;break $if_then384$$if_end390$146; } //@line 1812 "numbers.cpp"
  
              HEAP32[((__ZL14n_digit_lookup)>>2)]=2; //@line 1814 "numbers.cpp"
              ; //@line 1815 "numbers.cpp"
            }
          } while(0);
  
          var $arrayidx391=(($buf_digit_lookup)&4294967295); //@line 1819 "numbers.cpp"
          var $216=HEAP8[($arrayidx391)]; //@line 1819 "numbers.cpp"
          var $conv392=(tempInt=(($216)),(tempInt>=128?tempInt-256:tempInt)); //@line 1819 "numbers.cpp"
          var $cmp393=((($conv392))|0)==0; //@line 1819 "numbers.cpp"
          if (!($cmp393)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1819 "numbers.cpp"
  
          var $217=HEAP32[(($p)>>2)]; //@line 1819 "numbers.cpp"
          var $218=HEAP8[($217)]; //@line 1819 "numbers.cpp"
          var $conv395=(tempInt=(($218)),(tempInt>=128?tempInt-256:tempInt)); //@line 1819 "numbers.cpp"
          var $cmp396=((($conv395))|0)!=48; //@line 1819 "numbers.cpp"
          if (!($cmp396)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1819 "numbers.cpp"
  
          var $219=$tr_addr; //@line 1822 "numbers.cpp"
          var $arraydecay398=(($buf_digit_lookup)&4294967295); //@line 1822 "numbers.cpp"
          var $220=$flags_addr; //@line 1822 "numbers.cpp"
          var $221=$wtab_addr; //@line 1822 "numbers.cpp"
          var $call399=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($219, $p, $arraydecay398, $220, 4, $221); //@line 1822 "numbers.cpp"
          var $tobool400=((($call399))|0)!=0; //@line 1822 "numbers.cpp"
          if (!($tobool400)) { __label__ = 112;break $if_end369$$if_end404$139; } //@line 1822 "numbers.cpp"
  
          HEAP32[((__ZL14n_digit_lookup)>>2)]=1; //@line 1824 "numbers.cpp"
          ; //@line 1825 "numbers.cpp"
        }
      } while(0);
  
      var $222=$tr_addr; //@line 1829 "numbers.cpp"
      var $223=$value; //@line 1829 "numbers.cpp"
      var $arraydecay405=(($ph_buf)&4294967295); //@line 1829 "numbers.cpp"
      var $224=$suppress_null; //@line 1829 "numbers.cpp"
      var $225=$thousandplex; //@line 1829 "numbers.cpp"
      var $226=$prev_thousands; //@line 1829 "numbers.cpp"
      var $227=$ordinal; //@line 1829 "numbers.cpp"
      var $or406=($227) | ($226); //@line 1829 "numbers.cpp"
      __ZL10LookupNum3P10TranslatoriPciii($222, $223, $arraydecay405, $224, $225, $or406); //@line 1829 "numbers.cpp"
      var $228=$thousandplex; //@line 1830 "numbers.cpp"
      var $cmp408=((($228))|0) > 0; //@line 1830 "numbers.cpp"
      if ($cmp408) { __label__ = 113;; } else { __label__ = 115;; } //@line 1830 "numbers.cpp"
      $land_lhs_true409$$if_else419$154: do { 
        if (__label__ == 113) {
  
          var $229=$tr_addr; //@line 1830 "numbers.cpp"
          var $langopts410=(($229)&4294967295); //@line 1830 "numbers.cpp"
          var $numbers2=(($langopts410+188)&4294967295); //@line 1830 "numbers.cpp"
          var $230=HEAP32[(($numbers2)>>2)]; //@line 1830 "numbers.cpp"
          var $and411=($230) & 512; //@line 1830 "numbers.cpp"
          var $tobool412=((($and411))|0)!=0; //@line 1830 "numbers.cpp"
          if (!($tobool412)) { __label__ = 115;break $land_lhs_true409$$if_else419$154; } //@line 1830 "numbers.cpp"
  
          var $231=$ph_out_addr; //@line 1831 "numbers.cpp"
          var $arraydecay414=(($ph_zeros)&4294967295); //@line 1831 "numbers.cpp"
          var $arraydecay415=(($ph_append)&4294967295); //@line 1831 "numbers.cpp"
          var $arraydecay416=(($ph_buf2)&4294967295); //@line 1831 "numbers.cpp"
          var $arraydecay417=(($ph_buf)&4294967295); //@line 1831 "numbers.cpp"
          var $call418=_sprintf($231, ((__str20317)&4294967295), allocate([$arraydecay414,0,0,0,$arraydecay415,0,0,0,$arraydecay416,0,0,0,$arraydecay417,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1831 "numbers.cpp"
          __label__ = 116;break $land_lhs_true409$$if_else419$154; //@line 1831 "numbers.cpp"
        }
      } while(0);
      if (__label__ == 115) {
  
        var $232=$ph_out_addr; //@line 1833 "numbers.cpp"
        var $arraydecay420=(($ph_zeros)&4294967295); //@line 1833 "numbers.cpp"
        var $arraydecay421=(($ph_buf2)&4294967295); //@line 1833 "numbers.cpp"
        var $arraydecay422=(($ph_buf)&4294967295); //@line 1833 "numbers.cpp"
        var $arraydecay423=(($ph_append)&4294967295); //@line 1833 "numbers.cpp"
        var $call424=_sprintf($232, ((__str20317)&4294967295), allocate([$arraydecay420,0,0,0,$arraydecay421,0,0,0,$arraydecay422,0,0,0,$arraydecay423,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1833 "numbers.cpp"
        ;
      }
  
      var $arraydecay472=(($ph_buf)&4294967295); //@line 1870 "numbers.cpp"
      var $arraydecay480=(($string)&4294967295); //@line 1874 "numbers.cpp"
      var $arraydecay482=(($string)&4294967295); //@line 1875 "numbers.cpp"
      var $arraydecay483=(($buf1)&4294967295); //@line 1875 "numbers.cpp"
      var $arraydecay488=(($ph_buf)&4294967295); //@line 1878 "numbers.cpp"
      var $arraydecay489=(($buf1)&4294967295); //@line 1878 "numbers.cpp"
      var $arraydecay492=(($ph_buf)&4294967295); //@line 1880 "numbers.cpp"
      var $arraydecay504=(($buf1)&4294967295); //@line 1888 "numbers.cpp"
      var $arraydecay506=(($buf1)&4294967295); //@line 1889 "numbers.cpp"
      var $arraydecay463=(($buf1)&4294967295); //@line 1862 "numbers.cpp"
      var $arraydecay465=(($buf1)&4294967295); //@line 1863 "numbers.cpp"
      var $arraydecay448=(($buf1)&4294967295); //@line 1855 "numbers.cpp"
      var $arraydecay450=(($buf1)&4294967295); //@line 1856 "numbers.cpp"
      var $arraydecay524=(($buf1)&4294967295); //@line 1900 "numbers.cpp"
      var $arraydecay526=(($buf1)&4294967295); //@line 1901 "numbers.cpp"
      var $arraydecay529=(($buf1)&4294967295); //@line 1905 "numbers.cpp"
      var $arraydecay533=(($buf1)&4294967295); //@line 1906 "numbers.cpp"
      var $arraydecay547=(($buf1)&4294967295); //@line 1910 "numbers.cpp"
      var $arraydecay549=(($buf1)&4294967295); //@line 1911 "numbers.cpp"
      ; //@line 1836 "numbers.cpp"
      $while_cond426thread_pre_split$160: while(1) { 
  
        var $_pr49=$decimal_point; //@line 1836 "numbers.cpp"
        __lastLabel__ = 117; ;
        $while_cond426$162: while(1) { 
  
          var $233=__lastLabel__ == 117 ? $_pr49 : (0); //@line 1836 "numbers.cpp"
          var $tobool427=((($233))|0)!=0; //@line 1836 "numbers.cpp"
          if (!($tobool427)) { __label__ = 145;break $while_cond426thread_pre_split$160; } //@line 1836 "numbers.cpp"
  
          var $234=$n_digits; //@line 1838 "numbers.cpp"
          var $inc429=((($234)+1)&4294967295); //@line 1838 "numbers.cpp"
          $n_digits=$inc429; //@line 1838 "numbers.cpp"
          $decimal_count=0; //@line 1840 "numbers.cpp"
          var $235=$n_digits; //@line 1841 "numbers.cpp"
          var $236=$decimal_count; //@line 1841 "numbers.cpp"
          var $add43153=((($236)+($235))&4294967295); //@line 1841 "numbers.cpp"
          var $237=$word_addr; //@line 1841 "numbers.cpp"
          var $arrayidx43254=(($237+$add43153)&4294967295); //@line 1841 "numbers.cpp"
          var $238=HEAP8[($arrayidx43254)]; //@line 1841 "numbers.cpp"
          var $conv43355=(tempInt=(($238)),(tempInt>=128?tempInt-256:tempInt)); //@line 1841 "numbers.cpp"
          var $isdigittmp3456=((($conv43355)-48)&4294967295); //@line 1841 "numbers.cpp"
          var $isdigit3557=((($isdigittmp3456))>>>0) < 10; //@line 1841 "numbers.cpp"
          var $call43458=((($isdigit3557))&1); //@line 1841 "numbers.cpp"
          var $tobool43559=((($call43458))|0)!=0; //@line 1841 "numbers.cpp"
          if ($tobool43559) { __label__ = 120;; } else { __label__ = 121;; } //@line 1841 "numbers.cpp"
          $while_body436$$while_end438$165: do { 
            if (__label__ == 120) {
              while(1) { 
  
                var $239=$decimal_count; //@line 1842 "numbers.cpp"
                var $inc437=((($239)+1)&4294967295); //@line 1842 "numbers.cpp"
                $decimal_count=$inc437; //@line 1842 "numbers.cpp"
                var $240=$n_digits; //@line 1841 "numbers.cpp"
                var $241=$decimal_count; //@line 1841 "numbers.cpp"
                var $add431=((($241)+($240))&4294967295); //@line 1841 "numbers.cpp"
                var $242=$word_addr; //@line 1841 "numbers.cpp"
                var $arrayidx432=(($242+$add431)&4294967295); //@line 1841 "numbers.cpp"
                var $243=HEAP8[($arrayidx432)]; //@line 1841 "numbers.cpp"
                var $conv433=(tempInt=(($243)),(tempInt>=128?tempInt-256:tempInt)); //@line 1841 "numbers.cpp"
                var $isdigittmp34=((($conv433)-48)&4294967295); //@line 1841 "numbers.cpp"
                var $isdigit35=((($isdigittmp34))>>>0) < 10; //@line 1841 "numbers.cpp"
                var $call434=((($isdigit35))&1); //@line 1841 "numbers.cpp"
                var $tobool435=((($call434))|0)!=0; //@line 1841 "numbers.cpp"
                if ($tobool435) { __label__ = 120;continue ; } else { __label__ = 121;break $while_body436$$while_end438$165; } //@line 1841 "numbers.cpp"
              }
            }
          } while(0);
  
          $max_decimal_count=2; //@line 1846 "numbers.cpp"
          var $244=$tr_addr; //@line 1847 "numbers.cpp"
          var $langopts439=(($244)&4294967295); //@line 1847 "numbers.cpp"
          var $numbers440=(($langopts439+184)&4294967295); //@line 1847 "numbers.cpp"
          var $245=HEAP32[(($numbers440)>>2)]; //@line 1847 "numbers.cpp"
          var $and441=($245) & 57344; //@line 1847 "numbers.cpp"
          $decimal_mode=$and441; //@line 1847 "numbers.cpp"
          if ($and441 == 32768) {
            __label__ = 122;;
          }
          else if ($and441 == 16384) {
            __label__ = 123;;
          }
          else if ($and441 == 8192) {
            __label__ = 128;;
          }
          else if ($and441 == 40960) {
            __label__ = 128;;
          }
          else if ($and441 == 24576) {
            __label__ = 133;;
          }
          else {
          __label__ = 136;;
          }
          
          $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169: do { 
            if (__label__ == 122) {
  
              $max_decimal_count=5; //@line 1850 "numbers.cpp"
              __label__ = 123;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; //@line 1850 "numbers.cpp"
            }
            else if (__label__ == 128) {
  
              var $267=$tr_addr; //@line 1870 "numbers.cpp"
              var $268=$n_digits; //@line 1870 "numbers.cpp"
              var $269=$word_addr; //@line 1870 "numbers.cpp"
              var $arrayidx470=(($269+$268)&4294967295); //@line 1870 "numbers.cpp"
              var $call471=_atoi($arrayidx470); //@line 1870 "numbers.cpp"
              __ZL10LookupNum3P10TranslatoriPciii($267, $call471, $arraydecay472, 0, 0, 0); //@line 1870 "numbers.cpp"
              var $270=$n_digits; //@line 1871 "numbers.cpp"
              var $271=$word_addr; //@line 1871 "numbers.cpp"
              var $arrayidx474=(($271+$270)&4294967295); //@line 1871 "numbers.cpp"
              var $272=HEAP8[($arrayidx474)]; //@line 1871 "numbers.cpp"
              var $conv475=(tempInt=(($272)),(tempInt>=128?tempInt-256:tempInt)); //@line 1871 "numbers.cpp"
              var $cmp476=((($conv475))|0)==48; //@line 1871 "numbers.cpp"
              if ($cmp476) { __label__ = 130;; } else { __label__ = 129;; } //@line 1871 "numbers.cpp"
              $if_then479$$lor_lhs_false477$172: do { 
                if (__label__ == 129) {
  
                  var $273=$decimal_mode; //@line 1871 "numbers.cpp"
                  var $cmp478=((($273))|0)==40960; //@line 1871 "numbers.cpp"
                  if ($cmp478) { __label__ = 130;break $if_then479$$lor_lhs_false477$172; } else { __label__ = 132;break $if_then479$$lor_lhs_false477$172; } //@line 1871 "numbers.cpp"
                }
              } while(0);
              if (__label__ == 130) {
  
                var $274=$decimal_count; //@line 1874 "numbers.cpp"
                var $call481=_sprintf($arraydecay480, ((__str21318)&4294967295), allocate([$274,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1874 "numbers.cpp"
                var $275=$tr_addr; //@line 1875 "numbers.cpp"
                var $call484=__Z6LookupP10TranslatorPKcPc($275, $arraydecay482, $arraydecay483); //@line 1875 "numbers.cpp"
                var $cmp485=((($call484))|0)==0; //@line 1875 "numbers.cpp"
                if ($cmp485) { __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; } //@line 1875 "numbers.cpp"
  
                var $call490=_strcat($arraydecay488, $arraydecay489); //@line 1878 "numbers.cpp"
                ; //@line 1879 "numbers.cpp"
              }
  
              var $276=$ph_out_addr; //@line 1880 "numbers.cpp"
              var $call493=_strcat($276, $arraydecay492); //@line 1880 "numbers.cpp"
              var $277=$decimal_count; //@line 1881 "numbers.cpp"
              var $278=$n_digits; //@line 1881 "numbers.cpp"
              var $add494=((($278)+($277))&4294967295); //@line 1881 "numbers.cpp"
              $n_digits=$add494; //@line 1881 "numbers.cpp"
              __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; //@line 1882 "numbers.cpp"
            }
            else if (__label__ == 133) {
  
              var $279=$decimal_count; //@line 1886 "numbers.cpp"
              var $cmp496=((($279))|0) <= 4; //@line 1886 "numbers.cpp"
              if (!($cmp496)) { __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; } //@line 1886 "numbers.cpp"
  
              var $280=$n_digits; //@line 1886 "numbers.cpp"
              var $281=$word_addr; //@line 1886 "numbers.cpp"
              var $arrayidx498=(($281+$280)&4294967295); //@line 1886 "numbers.cpp"
              var $282=HEAP8[($arrayidx498)]; //@line 1886 "numbers.cpp"
              var $conv499=(tempInt=(($282)),(tempInt>=128?tempInt-256:tempInt)); //@line 1886 "numbers.cpp"
              var $cmp500=((($conv499))|0)!=48; //@line 1886 "numbers.cpp"
              if (!($cmp500)) { __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; } //@line 1886 "numbers.cpp"
  
              var $283=$tr_addr; //@line 1888 "numbers.cpp"
              var $284=$n_digits; //@line 1888 "numbers.cpp"
              var $285=$word_addr; //@line 1888 "numbers.cpp"
              var $arrayidx502=(($285+$284)&4294967295); //@line 1888 "numbers.cpp"
              var $call503=_atoi($arrayidx502); //@line 1888 "numbers.cpp"
              __ZL10LookupNum3P10TranslatoriPciii($283, $call503, $arraydecay504, 0, 0, 0); //@line 1888 "numbers.cpp"
              var $286=$ph_out_addr; //@line 1889 "numbers.cpp"
              var $call507=_strcat($286, $arraydecay506); //@line 1889 "numbers.cpp"
              var $287=$decimal_count; //@line 1890 "numbers.cpp"
              var $288=$n_digits; //@line 1890 "numbers.cpp"
              var $add508=((($288)+($287))&4294967295); //@line 1890 "numbers.cpp"
              $n_digits=$add508; //@line 1890 "numbers.cpp"
              __label__ = 136;break $while_cond510$$sw_bb$$while_cond443_preheader$$sw_bb469$$sw_bb495$169; //@line 1891 "numbers.cpp"
            }
          } while(0);
          $while_cond510$$while_cond443_preheader$181: do { 
            if (__label__ == 123) {
  
              var $246=$n_digits; //@line 1853 "numbers.cpp"
              var $247=$word_addr; //@line 1853 "numbers.cpp"
              var $arrayidx44450=(($247+$246)&4294967295); //@line 1853 "numbers.cpp"
              var $248=HEAP8[($arrayidx44450)]; //@line 1853 "numbers.cpp"
              var $conv44551=(tempInt=(($248)),(tempInt>=128?tempInt-256:tempInt)); //@line 1853 "numbers.cpp"
              var $cmp44652=((($conv44551))|0)==48; //@line 1853 "numbers.cpp"
              if ($cmp44652) { __label__ = 124;; } else { __label__ = 125;; } //@line 1853 "numbers.cpp"
              $while_body447$$while_end453$183: do { 
                if (__label__ == 124) {
                  while(1) { 
  
                    var $249=$tr_addr; //@line 1855 "numbers.cpp"
                    var $call449=__Z6LookupP10TranslatorPKcPc($249, ((__str16313)&4294967295), $arraydecay448); //@line 1855 "numbers.cpp"
                    var $250=$ph_out_addr; //@line 1856 "numbers.cpp"
                    var $call451=_strcat($250, $arraydecay450); //@line 1856 "numbers.cpp"
                    var $251=$decimal_count; //@line 1857 "numbers.cpp"
                    var $dec=((($251)-1)&4294967295); //@line 1857 "numbers.cpp"
                    $decimal_count=$dec; //@line 1857 "numbers.cpp"
                    var $252=$n_digits; //@line 1858 "numbers.cpp"
                    var $inc452=((($252)+1)&4294967295); //@line 1858 "numbers.cpp"
                    $n_digits=$inc452; //@line 1858 "numbers.cpp"
                    var $253=$n_digits; //@line 1853 "numbers.cpp"
                    var $254=$word_addr; //@line 1853 "numbers.cpp"
                    var $arrayidx444=(($254+$253)&4294967295); //@line 1853 "numbers.cpp"
                    var $255=HEAP8[($arrayidx444)]; //@line 1853 "numbers.cpp"
                    var $conv445=(tempInt=(($255)),(tempInt>=128?tempInt-256:tempInt)); //@line 1853 "numbers.cpp"
                    var $cmp446=((($conv445))|0)==48; //@line 1853 "numbers.cpp"
                    if ($cmp446) { __label__ = 124;continue ; } else { __label__ = 125;break $while_body447$$while_end453$183; } //@line 1853 "numbers.cpp"
                  }
                }
              } while(0);
  
              var $256=$decimal_count; //@line 1860 "numbers.cpp"
              var $257=$max_decimal_count; //@line 1860 "numbers.cpp"
              var $cmp454=((($256))|0) <= ((($257))|0); //@line 1860 "numbers.cpp"
              if (!($cmp454)) { __label__ = 136;break $while_cond510$$while_cond443_preheader$181; } //@line 1860 "numbers.cpp"
  
              var $258=$n_digits; //@line 1860 "numbers.cpp"
              var $259=$word_addr; //@line 1860 "numbers.cpp"
              var $arrayidx456=(($259+$258)&4294967295); //@line 1860 "numbers.cpp"
              var $260=HEAP8[($arrayidx456)]; //@line 1860 "numbers.cpp"
              var $conv457=(tempInt=(($260)),(tempInt>=128?tempInt-256:tempInt)); //@line 1860 "numbers.cpp"
              var $isdigittmp36=((($conv457)-48)&4294967295); //@line 1860 "numbers.cpp"
              var $isdigit37=((($isdigittmp36))>>>0) < 10; //@line 1860 "numbers.cpp"
              var $call458=((($isdigit37))&1); //@line 1860 "numbers.cpp"
              var $tobool459=((($call458))|0)!=0; //@line 1860 "numbers.cpp"
              if (!($tobool459)) { __label__ = 136;break $while_cond510$$while_cond443_preheader$181; } //@line 1860 "numbers.cpp"
  
              var $261=$tr_addr; //@line 1862 "numbers.cpp"
              var $262=$n_digits; //@line 1862 "numbers.cpp"
              var $263=$word_addr; //@line 1862 "numbers.cpp"
              var $arrayidx461=(($263+$262)&4294967295); //@line 1862 "numbers.cpp"
              var $call462=_atoi($arrayidx461); //@line 1862 "numbers.cpp"
              __ZL10LookupNum3P10TranslatoriPciii($261, $call462, $arraydecay463, 0, 0, 0); //@line 1862 "numbers.cpp"
              var $264=$ph_out_addr; //@line 1863 "numbers.cpp"
              var $call466=_strcat($264, $arraydecay465); //@line 1863 "numbers.cpp"
              var $265=$decimal_count; //@line 1864 "numbers.cpp"
              var $266=$n_digits; //@line 1864 "numbers.cpp"
              var $add467=((($266)+($265))&4294967295); //@line 1864 "numbers.cpp"
              $n_digits=$add467; //@line 1864 "numbers.cpp"
              ; //@line 1865 "numbers.cpp"
            }
          } while(0);
          while(1) { 
  
            var $289=$n_digits; //@line 1896 "numbers.cpp"
            var $290=$word_addr; //@line 1896 "numbers.cpp"
            var $arrayidx511=(($290+$289)&4294967295); //@line 1896 "numbers.cpp"
            var $291=HEAPU8[($arrayidx511)]; //@line 1896 "numbers.cpp"
            $c=$291; //@line 1896 "numbers.cpp"
            var $conv512=((($291))&255); //@line 1896 "numbers.cpp"
            var $isdigittmp38=((($conv512)-48)&4294967295); //@line 1896 "numbers.cpp"
            var $isdigit39=((($isdigittmp38))>>>0) < 10; //@line 1896 "numbers.cpp"
            var $call513=((($isdigit39))&1); //@line 1896 "numbers.cpp"
            var $tobool514=((($call513))|0)!=0; //@line 1896 "numbers.cpp"
            if (!($tobool514)) { __label__ = 139;break ; } //@line 1896 "numbers.cpp"
  
            var $292=$ph_out_addr; //@line 1896 "numbers.cpp"
            var $call516=_strlen($292); //@line 1896 "numbers.cpp"
            var $cmp517=((($call516))>>>0) < 150; //@line 1896 "numbers.cpp"
            if (!($cmp517)) { __label__ = 139;break ; }
  
            var $293=$n_digits; //@line 1899 "numbers.cpp"
            var $inc520=((($293)+1)&4294967295); //@line 1899 "numbers.cpp"
            $n_digits=$inc520; //@line 1899 "numbers.cpp"
            var $294=$word_addr; //@line 1899 "numbers.cpp"
            var $arrayidx521=(($294+$293)&4294967295); //@line 1899 "numbers.cpp"
            var $295=HEAP8[($arrayidx521)]; //@line 1899 "numbers.cpp"
            var $conv522=(tempInt=(($295)),(tempInt>=128?tempInt-256:tempInt)); //@line 1899 "numbers.cpp"
            var $sub523=((($conv522)-48)&4294967295); //@line 1899 "numbers.cpp"
            $value=$sub523; //@line 1899 "numbers.cpp"
            var $296=$tr_addr; //@line 1900 "numbers.cpp"
            var $297=$value; //@line 1900 "numbers.cpp"
            var $call525=__ZL10LookupNum2P10TranslatoriiPc($296, $297, 2, $arraydecay524); //@line 1900 "numbers.cpp"
            var $298=$ph_out_addr; //@line 1901 "numbers.cpp"
            var $call527=_strcat($298, $arraydecay526); //@line 1901 "numbers.cpp"
            __label__ = 136;continue ; //@line 1902 "numbers.cpp"
          }
  
          var $299=$tr_addr; //@line 1905 "numbers.cpp"
          var $call530=__Z6LookupP10TranslatorPKcPc($299, ((__str22319)&4294967295), $arraydecay529); //@line 1905 "numbers.cpp"
          var $tobool531=((($call530))|0)!=0; //@line 1905 "numbers.cpp"
          if ($tobool531) { __label__ = 140;; } else { __label__ = 141;; } //@line 1905 "numbers.cpp"
          if (__label__ == 140) {
  
            var $300=$ph_out_addr; //@line 1906 "numbers.cpp"
            var $call534=_strcat($300, $arraydecay533); //@line 1906 "numbers.cpp"
            ; //@line 1906 "numbers.cpp"
          }
  
          var $301=$c; //@line 1908 "numbers.cpp"
          var $conv536=((($301))&255); //@line 1908 "numbers.cpp"
          var $302=$tr_addr; //@line 1908 "numbers.cpp"
          var $langopts537=(($302)&4294967295); //@line 1908 "numbers.cpp"
          var $decimal_sep538=(($langopts537+208)&4294967295); //@line 1908 "numbers.cpp"
          var $303=HEAP32[(($decimal_sep538)>>2)]; //@line 1908 "numbers.cpp"
          var $cmp539=((($conv536))|0)==((($303))|0); //@line 1908 "numbers.cpp"
          if ($cmp539) { __label__ = 142;; } else { __label__ = 144;; } //@line 1908 "numbers.cpp"
          if (__label__ == 142) {
  
            var $304=$n_digits; //@line 1908 "numbers.cpp"
            var $add541=((($304)+1)&4294967295); //@line 1908 "numbers.cpp"
            var $305=$word_addr; //@line 1908 "numbers.cpp"
            var $arrayidx542=(($305+$add541)&4294967295); //@line 1908 "numbers.cpp"
            var $306=HEAP8[($arrayidx542)]; //@line 1908 "numbers.cpp"
            var $conv543=(tempInt=(($306)),(tempInt>=128?tempInt-256:tempInt)); //@line 1908 "numbers.cpp"
            var $isdigittmp40=((($conv543)-48)&4294967295); //@line 1908 "numbers.cpp"
            var $isdigit41=((($isdigittmp40))>>>0) < 10; //@line 1908 "numbers.cpp"
            var $call544=((($isdigit41))&1); //@line 1908 "numbers.cpp"
            var $tobool545=((($call544))|0)!=0; //@line 1908 "numbers.cpp"
            if ($tobool545) { __label__ = 143;break $while_cond426$162; } //@line 1908 "numbers.cpp"
          }
  
          $decimal_point=0; //@line 1915 "numbers.cpp"
          __lastLabel__ = 144; __label__ = 118;continue $while_cond426$162;
        }
  
        var $307=$tr_addr; //@line 1910 "numbers.cpp"
        var $call548=__Z6LookupP10TranslatorPKcPc($307, ((__str17314)&4294967295), $arraydecay547); //@line 1910 "numbers.cpp"
        var $308=$ph_out_addr; //@line 1911 "numbers.cpp"
        var $call550=_strcat($308, $arraydecay549); //@line 1911 "numbers.cpp"
        __label__ = 117;continue $while_cond426thread_pre_split$160; //@line 1912 "numbers.cpp"
      }
  
      var $309=$ph_out_addr; //@line 1918 "numbers.cpp"
      var $arrayidx554=(($309)&4294967295); //@line 1918 "numbers.cpp"
      var $310=HEAP8[($arrayidx554)]; //@line 1918 "numbers.cpp"
      var $conv555=(tempInt=(($310)),(tempInt>=128?tempInt-256:tempInt)); //@line 1918 "numbers.cpp"
      var $cmp556=((($conv555))|0)!=0; //@line 1918 "numbers.cpp"
      if ($cmp556) { __label__ = 146;; } else { __label__ = 154;; } //@line 1918 "numbers.cpp"
      $land_lhs_true557$$if_end588$202: do { 
        if (__label__ == 146) {
  
          var $311=$ph_out_addr; //@line 1918 "numbers.cpp"
          var $arrayidx558=(($311)&4294967295); //@line 1918 "numbers.cpp"
          var $312=HEAP8[($arrayidx558)]; //@line 1918 "numbers.cpp"
          var $conv559=(tempInt=(($312)),(tempInt>=128?tempInt-256:tempInt)); //@line 1918 "numbers.cpp"
          var $cmp560=((($conv559))|0)!=21; //@line 1918 "numbers.cpp"
          if (!($cmp560)) { __label__ = 154;break $land_lhs_true557$$if_end588$202; } //@line 1918 "numbers.cpp"
  
          var $313=$n_digits; //@line 1922 "numbers.cpp"
          var $add563=((($313)+1)&4294967295); //@line 1922 "numbers.cpp"
          var $314=$word_addr; //@line 1922 "numbers.cpp"
          var $arrayidx564=(($314+$add563)&4294967295); //@line 1922 "numbers.cpp"
          $p562=$arrayidx564; //@line 1922 "numbers.cpp"
          var $315=$p562; //@line 1924 "numbers.cpp"
          var $call565=__Z7utf8_inPiPKc($next_char, $315); //@line 1924 "numbers.cpp"
          var $316=$p562; //@line 1924 "numbers.cpp"
          var $add_ptr566=(($316+$call565)&4294967295); //@line 1924 "numbers.cpp"
          $p562=$add_ptr566; //@line 1924 "numbers.cpp"
          var $317=$tr_addr; //@line 1925 "numbers.cpp"
          var $langopts567=(($317)&4294967295); //@line 1925 "numbers.cpp"
          var $numbers568=(($langopts567+184)&4294967295); //@line 1925 "numbers.cpp"
          var $318=HEAP32[(($numbers568)>>2)]; //@line 1925 "numbers.cpp"
          var $and569=($318) & 131072; //@line 1925 "numbers.cpp"
          var $tobool570=((($and569))|0)!=0; //@line 1925 "numbers.cpp"
          if ($tobool570) { __label__ = 148;; } else { __label__ = 150;; } //@line 1925 "numbers.cpp"
          $land_lhs_true571$$if_end575$205: do { 
            if (__label__ == 148) {
  
              var $319=HEAP32[(($next_char)>>2)]; //@line 1925 "numbers.cpp"
              var $cmp572=((($319))|0)==32; //@line 1925 "numbers.cpp"
              if (!($cmp572)) { __label__ = 150;break $land_lhs_true571$$if_end575$205; } //@line 1925 "numbers.cpp"
  
              var $320=$p562; //@line 1926 "numbers.cpp"
              var $call574=__Z7utf8_inPiPKc($next_char, $320); //@line 1926 "numbers.cpp"
              ; //@line 1926 "numbers.cpp"
            }
          } while(0);
  
          var $321=HEAP32[(($next_char)>>2)]; //@line 1928 "numbers.cpp"
          var $call576=_iswalpha($321); //@line 1928 "numbers.cpp"
          var $tobool577=((($call576))|0)!=0; //@line 1928 "numbers.cpp"
          if ($tobool577) { __label__ = 154;break $land_lhs_true557$$if_end588$202; } //@line 1928 "numbers.cpp"
  
          var $322=$thousandplex; //@line 1928 "numbers.cpp"
          var $323=$wtab_addr; //@line 1928 "numbers.cpp"
          var $arrayidx579=(($323+12*$322)&4294967295); //@line 1928 "numbers.cpp"
          var $flags580=(($arrayidx579)&4294967295); //@line 1928 "numbers.cpp"
          var $324=HEAP32[(($flags580)>>2)]; //@line 1928 "numbers.cpp"
          var $and581=($324) & 16384; //@line 1928 "numbers.cpp"
          var $tobool582=((($and581))|0)!=0; //@line 1928 "numbers.cpp"
          if ($tobool582) { __label__ = 152;; } else { __label__ = 153;; } //@line 1928 "numbers.cpp"
          if (__label__ == 152) {
  
            var $325=$thousands_exact; //@line 1928 "numbers.cpp"
            var $cmp584=((($325))|0)!=0; //@line 1928 "numbers.cpp"
            if ($cmp584) { __label__ = 154;break $land_lhs_true557$$if_end588$202; } //@line 1928 "numbers.cpp"
          }
  
          var $326=$ph_out_addr; //@line 1929 "numbers.cpp"
          var $strlen=_strlen($326); //@line 1929 "numbers.cpp"
          var $endptr=(($326+$strlen)&4294967295); //@line 1929 "numbers.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = ((__ZZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABiE9str_pause)&4294967295);
          $dest$ = $endptr;
          $stop$ = $src$ + 2;
          if (($dest$%4) == ($src$%4) && 2 > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 1929 "numbers.cpp"
          ; //@line 1929 "numbers.cpp"
        }
      } while(0);
  
      var $327=$flags_addr; //@line 1932 "numbers.cpp"
      var $328=HEAP32[(($327)>>2)]; //@line 1932 "numbers.cpp"
      var $or589=($328) | -2147483648; //@line 1932 "numbers.cpp"
      HEAP32[(($327)>>2)]=$or589; //@line 1932 "numbers.cpp"
      var $329=HEAP32[((__ZL23speak_missing_thousands)>>2)]; //@line 1933 "numbers.cpp"
      var $dec590=((($329)-1)&4294967295); //@line 1933 "numbers.cpp"
      HEAP32[((__ZL23speak_missing_thousands)>>2)]=$dec590; //@line 1933 "numbers.cpp"
      var $330=$skipwords; //@line 1935 "numbers.cpp"
      var $tobool591=((($330))|0)!=0; //@line 1935 "numbers.cpp"
      if ($tobool591) { __label__ = 155;; } else { __label__ = 156;; } //@line 1935 "numbers.cpp"
      if (__label__ == 155) {
  
        var $331=$skipwords; //@line 1936 "numbers.cpp"
        HEAP32[((_dictionary_skipwords)>>2)]=$331; //@line 1936 "numbers.cpp"
        ; //@line 1936 "numbers.cpp"
      }
  
      $retval=1; //@line 1937 "numbers.cpp"
      ; //@line 1937 "numbers.cpp"
    }
  
    var $332=$retval; //@line 1938 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $332; //@line 1938 "numbers.cpp"
    return null;
  }
  

  function __ZL15LookupThousandsP10TranslatoriiiPc($tr, $value, $thousandplex, $thousands_exact, $ph_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 104; _memset(__stackBase__, 0, 104);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $value_addr;
    var $thousandplex_addr;
    var $thousands_exact_addr;
    var $ph_out_addr;
    var $found;
    var $found_value;
    var $string=__stackBase__;
    var $ph_of=__stackBase__+12;
    var $ph_thousands=__stackBase__+24;
    var $ph_buf=__stackBase__+64;
    $tr_addr=$tr;
    $value_addr=$value;
    $thousandplex_addr=$thousandplex;
    $thousands_exact_addr=$thousands_exact;
    $ph_out_addr=$ph_out;
    $found_value=0; //@line 991 "numbers.cpp"
    var $arrayidx=(($ph_of)&4294967295); //@line 997 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 997 "numbers.cpp"
    var $0=$value_addr; //@line 1000 "numbers.cpp"
    var $cmp=((($0))|0) > 0; //@line 1000 "numbers.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 12;; } //@line 1000 "numbers.cpp"
    $if_then$$if_end36thread_pre_split$2: do { 
      if (__label__ == 1) {
  
        var $1=$thousands_exact_addr; //@line 1002 "numbers.cpp"
        var $and=($1) & 1; //@line 1002 "numbers.cpp"
        var $tobool=((($and))|0)!=0; //@line 1002 "numbers.cpp"
        if ($tobool) { __label__ = 2;; } else { __label__ = 9;; } //@line 1002 "numbers.cpp"
        $if_then1$$if_end27thread_pre_split$4: do { 
          if (__label__ == 2) {
  
            var $2=$thousands_exact_addr; //@line 1004 "numbers.cpp"
            var $and2=($2) & 2; //@line 1004 "numbers.cpp"
            var $tobool3=((($and2))|0)!=0; //@line 1004 "numbers.cpp"
            if ($tobool3) { __label__ = 3;; } else { __label__ = 4;; } //@line 1004 "numbers.cpp"
            if (__label__ == 3) {
  
              var $arraydecay=(($string)&4294967295); //@line 1007 "numbers.cpp"
              var $3=$value_addr; //@line 1007 "numbers.cpp"
              var $4=$thousandplex_addr; //@line 1007 "numbers.cpp"
              var $call=_sprintf($arraydecay, ((__str42339)&4294967295), allocate([$3,0,0,0,$4,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1007 "numbers.cpp"
              var $5=$tr_addr; //@line 1008 "numbers.cpp"
              var $arraydecay5=(($string)&4294967295); //@line 1008 "numbers.cpp"
              var $arraydecay6=(($ph_thousands)&4294967295); //@line 1008 "numbers.cpp"
              var $call7=__Z6LookupP10TranslatorPKcPc($5, $arraydecay5, $arraydecay6); //@line 1008 "numbers.cpp"
              $found_value=$call7; //@line 1008 "numbers.cpp"
              ; //@line 1009 "numbers.cpp"
            }
  
            var $6=$found_value; //@line 1010 "numbers.cpp"
            var $tobool8=((($6))|0)!=0; //@line 1010 "numbers.cpp"
            var $lnot=($tobool8) ^ 1; //@line 1010 "numbers.cpp"
            var $conv=((($lnot))&1); //@line 1010 "numbers.cpp"
            var $7=HEAP32[((__ZL14number_control)>>2)]; //@line 1010 "numbers.cpp"
            var $and9=($7) & 1; //@line 1010 "numbers.cpp"
            var $and10=($and9) & ($conv); //@line 1010 "numbers.cpp"
            var $tobool11=((($and10))|0)!=0; //@line 1010 "numbers.cpp"
            if ($tobool11) { __label__ = 5;; } else { __label__ = 6;; } //@line 1010 "numbers.cpp"
            if (__label__ == 5) {
  
              var $arraydecay13=(($string)&4294967295); //@line 1013 "numbers.cpp"
              var $8=$value_addr; //@line 1013 "numbers.cpp"
              var $9=$thousandplex_addr; //@line 1013 "numbers.cpp"
              var $call14=_sprintf($arraydecay13, ((__str43340)&4294967295), allocate([$8,0,0,0,$9,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1013 "numbers.cpp"
              var $10=$tr_addr; //@line 1014 "numbers.cpp"
              var $arraydecay15=(($string)&4294967295); //@line 1014 "numbers.cpp"
              var $arraydecay16=(($ph_thousands)&4294967295); //@line 1014 "numbers.cpp"
              var $call17=__Z6LookupP10TranslatorPKcPc($10, $arraydecay15, $arraydecay16); //@line 1014 "numbers.cpp"
              $found_value=$call17; //@line 1014 "numbers.cpp"
              __lastLabel__ = 5; ; //@line 1015 "numbers.cpp"
            }
            else if (__label__ == 6) {
  
              var $_pr=$found_value; //@line 1016 "numbers.cpp"
              __lastLabel__ = 6; ;
            }
  
            var $11=__lastLabel__ == 6 ? $_pr : ($call17); //@line 1016 "numbers.cpp"
            var $tobool19=((($11))|0)!=0; //@line 1016 "numbers.cpp"
            if ($tobool19) { __label__ = 9;break $if_then1$$if_end27thread_pre_split$4; } //@line 1016 "numbers.cpp"
  
            var $arraydecay21=(($string)&4294967295); //@line 1019 "numbers.cpp"
            var $12=$value_addr; //@line 1019 "numbers.cpp"
            var $13=$thousandplex_addr; //@line 1019 "numbers.cpp"
            var $call22=_sprintf($arraydecay21, ((__str44341)&4294967295), allocate([$12,0,0,0,$13,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1019 "numbers.cpp"
            var $14=$tr_addr; //@line 1020 "numbers.cpp"
            var $arraydecay23=(($string)&4294967295); //@line 1020 "numbers.cpp"
            var $arraydecay24=(($ph_thousands)&4294967295); //@line 1020 "numbers.cpp"
            var $call25=__Z6LookupP10TranslatorPKcPc($14, $arraydecay23, $arraydecay24); //@line 1020 "numbers.cpp"
            $found_value=$call25; //@line 1020 "numbers.cpp"
            __lastLabel__ = 8; __label__ = 10;break $if_then1$$if_end27thread_pre_split$4; //@line 1021 "numbers.cpp"
          }
        } while(0);
        if (__label__ == 9) {
  
          var $_pr1=$found_value; //@line 1023 "numbers.cpp"
          __lastLabel__ = 9; ;
        }
  
        var $15=__lastLabel__ == 9 ? $_pr1 : ($call25); //@line 1023 "numbers.cpp"
        var $cmp28=((($15))|0)==0; //@line 1023 "numbers.cpp"
        if (!($cmp28)) { __label__ = 12;break $if_then$$if_end36thread_pre_split$2; } //@line 1023 "numbers.cpp"
  
        var $arraydecay30=(($string)&4294967295); //@line 1025 "numbers.cpp"
        var $16=$value_addr; //@line 1025 "numbers.cpp"
        var $17=$thousandplex_addr; //@line 1025 "numbers.cpp"
        var $call31=_sprintf($arraydecay30, ((__str45342)&4294967295), allocate([$16,0,0,0,$17,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1025 "numbers.cpp"
        var $18=$tr_addr; //@line 1026 "numbers.cpp"
        var $arraydecay32=(($string)&4294967295); //@line 1026 "numbers.cpp"
        var $arraydecay33=(($ph_thousands)&4294967295); //@line 1026 "numbers.cpp"
        var $call34=__Z6LookupP10TranslatorPKcPc($18, $arraydecay32, $arraydecay33); //@line 1026 "numbers.cpp"
        $found_value=$call34; //@line 1026 "numbers.cpp"
        __lastLabel__ = 11; __label__ = 13;break $if_then$$if_end36thread_pre_split$2; //@line 1027 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 12) {
  
      var $_pr2=$found_value; //@line 1030 "numbers.cpp"
      __lastLabel__ = 12; ;
    }
  
    var $19=__lastLabel__ == 12 ? $_pr2 : ($call34); //@line 1030 "numbers.cpp"
    var $cmp37=((($19))|0)==0; //@line 1030 "numbers.cpp"
    if ($cmp37) { __label__ = 14;; } else { __label__ = 36;; } //@line 1030 "numbers.cpp"
    $if_then38$$if_end118$21: do { 
      if (__label__ == 14) {
  
        var $20=$value_addr; //@line 1032 "numbers.cpp"
        var $rem=((($20))|0)%100; //@line 1032 "numbers.cpp"
        var $cmp39=((($rem))|0) >= 20; //@line 1032 "numbers.cpp"
        if ($cmp39) { __label__ = 15;; } else { __label__ = 16;; } //@line 1032 "numbers.cpp"
        if (__label__ == 15) {
  
          var $21=$tr_addr; //@line 1034 "numbers.cpp"
          var $arraydecay41=(($ph_of)&4294967295); //@line 1034 "numbers.cpp"
          var $call42=__Z6LookupP10TranslatorPKcPc($21, ((__str46343)&4294967295), $arraydecay41); //@line 1034 "numbers.cpp"
          ; //@line 1035 "numbers.cpp"
        }
  
        $found=0; //@line 1037 "numbers.cpp"
        var $22=$thousands_exact_addr; //@line 1038 "numbers.cpp"
        var $and44=($22) & 1; //@line 1038 "numbers.cpp"
        var $tobool45=((($and44))|0)!=0; //@line 1038 "numbers.cpp"
        if ($tobool45) { __label__ = 17;; } else { __label__ = 28;; } //@line 1038 "numbers.cpp"
        if (__label__ == 17) {
  
          var $23=$thousands_exact_addr; //@line 1040 "numbers.cpp"
          var $and47=($23) & 2; //@line 1040 "numbers.cpp"
          var $tobool48=((($and47))|0)!=0; //@line 1040 "numbers.cpp"
          if ($tobool48) { __label__ = 18;; } else { __label__ = 19;; } //@line 1040 "numbers.cpp"
          if (__label__ == 18) {
  
            var $arraydecay50=(($string)&4294967295); //@line 1043 "numbers.cpp"
            var $24=$value_addr; //@line 1043 "numbers.cpp"
            var $call51=__ZL9M_Varianti($24); //@line 1043 "numbers.cpp"
            var $25=$thousandplex_addr; //@line 1043 "numbers.cpp"
            var $call52=_sprintf($arraydecay50, ((__str47344)&4294967295), allocate([$call51,0,0,0,$25,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1043 "numbers.cpp"
            var $26=$tr_addr; //@line 1044 "numbers.cpp"
            var $arraydecay53=(($string)&4294967295); //@line 1044 "numbers.cpp"
            var $arraydecay54=(($ph_thousands)&4294967295); //@line 1044 "numbers.cpp"
            var $call55=__Z6LookupP10TranslatorPKcPc($26, $arraydecay53, $arraydecay54); //@line 1044 "numbers.cpp"
            $found=$call55; //@line 1044 "numbers.cpp"
            __lastLabel__ = 18; ; //@line 1045 "numbers.cpp"
          }
          else if (__label__ == 19) {
  
            var $_pr3=$found; //@line 1046 "numbers.cpp"
            __lastLabel__ = 19; ;
          }
  
          var $27=__lastLabel__ == 19 ? $_pr3 : ($call55); //@line 1046 "numbers.cpp"
          var $tobool57=((($27))|0)!=0; //@line 1046 "numbers.cpp"
          if ($tobool57) { __label__ = 23;; } else { __label__ = 21;; } //@line 1046 "numbers.cpp"
          $if_end67thread_pre_split$$land_lhs_true$32: do { 
            if (__label__ == 21) {
  
              var $28=HEAP32[((__ZL14number_control)>>2)]; //@line 1046 "numbers.cpp"
              var $and58=($28) & 1; //@line 1046 "numbers.cpp"
              var $tobool59=((($and58))|0)!=0; //@line 1046 "numbers.cpp"
              if (!($tobool59)) { __label__ = 23;break $if_end67thread_pre_split$$land_lhs_true$32; } //@line 1046 "numbers.cpp"
  
              var $arraydecay61=(($string)&4294967295); //@line 1049 "numbers.cpp"
              var $29=$value_addr; //@line 1049 "numbers.cpp"
              var $call62=__ZL9M_Varianti($29); //@line 1049 "numbers.cpp"
              var $30=$thousandplex_addr; //@line 1049 "numbers.cpp"
              var $call63=_sprintf($arraydecay61, ((__str48345)&4294967295), allocate([$call62,0,0,0,$30,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1049 "numbers.cpp"
              var $31=$tr_addr; //@line 1050 "numbers.cpp"
              var $arraydecay64=(($string)&4294967295); //@line 1050 "numbers.cpp"
              var $arraydecay65=(($ph_thousands)&4294967295); //@line 1050 "numbers.cpp"
              var $call66=__Z6LookupP10TranslatorPKcPc($31, $arraydecay64, $arraydecay65); //@line 1050 "numbers.cpp"
              $found=$call66; //@line 1050 "numbers.cpp"
              __lastLabel__ = 22; __label__ = 24;break $if_end67thread_pre_split$$land_lhs_true$32; //@line 1051 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 23) {
  
            var $_pr4=$found; //@line 1052 "numbers.cpp"
            __lastLabel__ = 23; ;
          }
  
          var $32=__lastLabel__ == 23 ? $_pr4 : ($call66); //@line 1052 "numbers.cpp"
          var $tobool68=((($32))|0)!=0; //@line 1052 "numbers.cpp"
          if ($tobool68) { __label__ = 26;; } else { __label__ = 25;; } //@line 1052 "numbers.cpp"
          if (__label__ == 26) {
  
            var $_pr5=$found; //@line 1059 "numbers.cpp"
            __lastLabel__ = 26; ;
          }
          else if (__label__ == 25) {
  
            var $arraydecay70=(($string)&4294967295); //@line 1055 "numbers.cpp"
            var $33=$value_addr; //@line 1055 "numbers.cpp"
            var $call71=__ZL9M_Varianti($33); //@line 1055 "numbers.cpp"
            var $34=$thousandplex_addr; //@line 1055 "numbers.cpp"
            var $call72=_sprintf($arraydecay70, ((__str49346)&4294967295), allocate([$call71,0,0,0,$34,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1055 "numbers.cpp"
            var $35=$tr_addr; //@line 1056 "numbers.cpp"
            var $arraydecay73=(($string)&4294967295); //@line 1056 "numbers.cpp"
            var $arraydecay74=(($ph_thousands)&4294967295); //@line 1056 "numbers.cpp"
            var $call75=__Z6LookupP10TranslatorPKcPc($35, $arraydecay73, $arraydecay74); //@line 1056 "numbers.cpp"
            $found=$call75; //@line 1056 "numbers.cpp"
            __lastLabel__ = 25; ; //@line 1057 "numbers.cpp"
          }
  
          var $36=__lastLabel__ == 26 ? $_pr5 : ($call75); //@line 1059 "numbers.cpp"
          var $cmp78=((($36))|0)==0; //@line 1059 "numbers.cpp"
          if (!($cmp78)) { __label__ = 36;break $if_then38$$if_end118$21; } //@line 1059 "numbers.cpp"
        }
  
        var $arraydecay80=(($string)&4294967295); //@line 1061 "numbers.cpp"
        var $37=$value_addr; //@line 1061 "numbers.cpp"
        var $call81=__ZL9M_Varianti($37); //@line 1061 "numbers.cpp"
        var $38=$thousandplex_addr; //@line 1061 "numbers.cpp"
        var $call82=_sprintf($arraydecay80, ((__str50347)&4294967295), allocate([$call81,0,0,0,$38,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1061 "numbers.cpp"
        var $39=$tr_addr; //@line 1063 "numbers.cpp"
        var $arraydecay83=(($string)&4294967295); //@line 1063 "numbers.cpp"
        var $arraydecay84=(($ph_thousands)&4294967295); //@line 1063 "numbers.cpp"
        var $call85=__Z6LookupP10TranslatorPKcPc($39, $arraydecay83, $arraydecay84); //@line 1063 "numbers.cpp"
        var $cmp86=((($call85))|0)==0; //@line 1063 "numbers.cpp"
        if (!($cmp86)) { __label__ = 36;break $if_then38$$if_end118$21; } //@line 1063 "numbers.cpp"
  
        var $40=$thousandplex_addr; //@line 1065 "numbers.cpp"
        var $cmp88=((($40))|0) > 3; //@line 1065 "numbers.cpp"
        if ($cmp88) { __label__ = 30;; } else { __label__ = 32;; } //@line 1065 "numbers.cpp"
        $if_then89$$if_end100$44: do { 
          if (__label__ == 30) {
  
            var $arraydecay90=(($string)&4294967295); //@line 1067 "numbers.cpp"
            var $41=$thousandplex_addr; //@line 1067 "numbers.cpp"
            var $sub=((($41)-1)&4294967295); //@line 1067 "numbers.cpp"
            var $call91=_sprintf($arraydecay90, ((__str18315)&4294967295), allocate([$sub,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1067 "numbers.cpp"
            var $42=$tr_addr; //@line 1068 "numbers.cpp"
            var $arraydecay92=(($string)&4294967295); //@line 1068 "numbers.cpp"
            var $arraydecay93=(($ph_buf)&4294967295); //@line 1068 "numbers.cpp"
            var $call94=__Z6LookupP10TranslatorPKcPc($42, $arraydecay92, $arraydecay93); //@line 1068 "numbers.cpp"
            var $cmp95=((($call94))|0)==0; //@line 1068 "numbers.cpp"
            if (!($cmp95)) { __label__ = 32;break $if_then89$$if_end100$44; } //@line 1068 "numbers.cpp"
  
            var $43=$tr_addr; //@line 1071 "numbers.cpp"
            var $arraydecay97=(($ph_thousands)&4294967295); //@line 1071 "numbers.cpp"
            var $call98=__Z6LookupP10TranslatorPKcPc($43, ((__str51348)&4294967295), $arraydecay97); //@line 1071 "numbers.cpp"
            HEAP32[((__ZL23speak_missing_thousands)>>2)]=3; //@line 1072 "numbers.cpp"
            ; //@line 1073 "numbers.cpp"
          }
        } while(0);
  
        var $arrayidx101=(($ph_thousands)&4294967295); //@line 1075 "numbers.cpp"
        var $44=HEAP8[($arrayidx101)]; //@line 1075 "numbers.cpp"
        var $conv102=(tempInt=(($44)),(tempInt>=128?tempInt-256:tempInt)); //@line 1075 "numbers.cpp"
        var $cmp103=((($conv102))|0)==0; //@line 1075 "numbers.cpp"
        if (!($cmp103)) { __label__ = 36;break $if_then38$$if_end118$21; } //@line 1075 "numbers.cpp"
  
        var $arraydecay105=(($string)&4294967295); //@line 1078 "numbers.cpp"
        var $45=$value_addr; //@line 1078 "numbers.cpp"
        var $call106=_sprintf($arraydecay105, ((__str52349)&4294967295), allocate([$45,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1078 "numbers.cpp"
        var $46=$tr_addr; //@line 1079 "numbers.cpp"
        var $arraydecay107=(($string)&4294967295); //@line 1079 "numbers.cpp"
        var $arraydecay108=(($ph_thousands)&4294967295); //@line 1079 "numbers.cpp"
        var $call109=__Z6LookupP10TranslatorPKcPc($46, $arraydecay107, $arraydecay108); //@line 1079 "numbers.cpp"
        $found_value=$call109; //@line 1079 "numbers.cpp"
        var $cmp110=((($call109))|0)==0; //@line 1079 "numbers.cpp"
        if ($cmp110) { __label__ = 34;; } else { __label__ = 35;; } //@line 1079 "numbers.cpp"
        if (__label__ == 34) {
  
          var $47=$tr_addr; //@line 1080 "numbers.cpp"
          var $arraydecay112=(($ph_thousands)&4294967295); //@line 1080 "numbers.cpp"
          var $call113=__Z6LookupP10TranslatorPKcPc($47, ((__str53350)&4294967295), $arraydecay112); //@line 1080 "numbers.cpp"
          ; //@line 1080 "numbers.cpp"
        }
  
        HEAP32[((__ZL23speak_missing_thousands)>>2)]=2; //@line 1081 "numbers.cpp"
        ; //@line 1082 "numbers.cpp"
      }
    } while(0);
  
    var $48=$ph_out_addr; //@line 1086 "numbers.cpp"
    var $arraydecay119=(($ph_of)&4294967295); //@line 1086 "numbers.cpp"
    var $arraydecay120=(($ph_thousands)&4294967295); //@line 1086 "numbers.cpp"
    var $call121=_sprintf($48, ((__str47699)&4294967295), allocate([$arraydecay119,0,0,0,$arraydecay120,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1086 "numbers.cpp"
    var $49=$value_addr; //@line 1088 "numbers.cpp"
    var $cmp122=((($49))|0)==1; //@line 1088 "numbers.cpp"
    if ($cmp122) { __label__ = 37;; } else { __label__ = 40;; } //@line 1088 "numbers.cpp"
    $land_lhs_true123$$if_end129$53: do { 
      if (__label__ == 37) {
  
        var $50=$thousandplex_addr; //@line 1088 "numbers.cpp"
        var $cmp124=((($50))|0)==1; //@line 1088 "numbers.cpp"
        if (!($cmp124)) { __label__ = 40;break $land_lhs_true123$$if_end129$53; } //@line 1088 "numbers.cpp"
  
        var $51=$tr_addr; //@line 1088 "numbers.cpp"
        var $langopts=(($51)&4294967295); //@line 1088 "numbers.cpp"
        var $numbers=(($langopts+184)&4294967295); //@line 1088 "numbers.cpp"
        var $52=HEAP32[(($numbers)>>2)]; //@line 1088 "numbers.cpp"
        var $and126=($52) & 2097152; //@line 1088 "numbers.cpp"
        var $tobool127=((($and126))|0)!=0; //@line 1088 "numbers.cpp"
        if (!($tobool127)) { __label__ = 40;break $land_lhs_true123$$if_end129$53; } //@line 1088 "numbers.cpp"
  
        $retval=1; //@line 1089 "numbers.cpp"
        __label__ = 41;break $land_lhs_true123$$if_end129$53; //@line 1089 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 40) {
  
      var $53=$found_value; //@line 1091 "numbers.cpp"
      $retval=$53; //@line 1091 "numbers.cpp"
      ; //@line 1091 "numbers.cpp"
    }
  
    var $54=$retval; //@line 1092 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $54; //@line 1092 "numbers.cpp"
    return null;
  }
  

  function __ZL10LookupNum3P10TranslatoriPciii($tr, $value, $ph_out, $suppress_null, $thousandplex, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 380; _memset(__stackBase__, 0, 380);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $value_addr;
    var $ph_out_addr;
    var $suppress_null_addr;
    var $thousandplex_addr;
    var $control_addr;
    var $found;
    var $hundreds;
    var $tensunits;
    var $x;
    var $ix;
    var $exact;
    var $ordinal;
    var $say_zero_hundred;
    var $string=__stackBase__;
    var $buf1=__stackBase__+12;
    var $buf2=__stackBase__+112;
    var $ph_100=__stackBase__+212;
    var $ph_10T=__stackBase__+232;
    var $ph_digits=__stackBase__+252;
    var $ph_thousands=__stackBase__+304;
    var $ph_hundred_and=__stackBase__+356;
    var $ph_thousand_and=__stackBase__+368;
    $tr_addr=$tr;
    $value_addr=$value;
    $ph_out_addr=$ph_out;
    $suppress_null_addr=$suppress_null;
    $thousandplex_addr=$thousandplex;
    $control_addr=$control;
    $say_zero_hundred=0; //@line 1364 "numbers.cpp"
    var $0=$control_addr; //@line 1375 "numbers.cpp"
    var $and=($0) & 34; //@line 1375 "numbers.cpp"
    $ordinal=$and; //@line 1375 "numbers.cpp"
    var $1=$value_addr; //@line 1376 "numbers.cpp"
    var $div=((((($1))|0)/100)|0); //@line 1376 "numbers.cpp"
    $hundreds=$div; //@line 1376 "numbers.cpp"
    var $2=$value_addr; //@line 1377 "numbers.cpp"
    var $rem=((($2))|0)%100; //@line 1377 "numbers.cpp"
    $tensunits=$rem; //@line 1377 "numbers.cpp"
    var $arrayidx=(($buf1)&4294967295); //@line 1378 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 1378 "numbers.cpp"
    var $arrayidx1=(($ph_thousands)&4294967295); //@line 1380 "numbers.cpp"
    HEAP8[($arrayidx1)]=0; //@line 1380 "numbers.cpp"
    var $arrayidx2=(($ph_thousand_and)&4294967295); //@line 1381 "numbers.cpp"
    HEAP8[($arrayidx2)]=0; //@line 1381 "numbers.cpp"
    var $3=$tr_addr; //@line 1383 "numbers.cpp"
    var $langopts=(($3)&4294967295); //@line 1383 "numbers.cpp"
    var $numbers=(($langopts+184)&4294967295); //@line 1383 "numbers.cpp"
    var $4=HEAP32[(($numbers)>>2)]; //@line 1383 "numbers.cpp"
    var $and3=($4) & 4194304; //@line 1383 "numbers.cpp"
    var $tobool=((($and3))|0)!=0; //@line 1383 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 4;; } //@line 1383 "numbers.cpp"
    $land_lhs_true$$if_endthread_pre_split$2: do { 
      if (__label__ == 1) {
  
        var $5=$control_addr; //@line 1383 "numbers.cpp"
        var $and4=($5) & 1; //@line 1383 "numbers.cpp"
        var $tobool5=((($and4))|0)!=0; //@line 1383 "numbers.cpp"
        if ($tobool5) { __label__ = 3;; } else { __label__ = 2;; } //@line 1383 "numbers.cpp"
        if (__label__ == 2) {
  
          var $6=$hundreds; //@line 1383 "numbers.cpp"
          var $cmp=((($6))|0) >= 10; //@line 1383 "numbers.cpp"
          if ($cmp) { __lastLabel__ = 2; ; } else { __lastLabel__ = 2; __label__ = 5;break $land_lhs_true$$if_endthread_pre_split$2; } //@line 1383 "numbers.cpp"
        }
  
        $say_zero_hundred=1; //@line 1385 "numbers.cpp"
        __label__ = 4;break $land_lhs_true$$if_endthread_pre_split$2; //@line 1386 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 4) {
  
      var $_pr=$hundreds; //@line 1388 "numbers.cpp"
      __lastLabel__ = 4; ;
    }
  
    var $7=__lastLabel__ == 4 ? $_pr : ($6); //@line 1388 "numbers.cpp"
    var $cmp6=((($7))|0) > 0; //@line 1388 "numbers.cpp"
    if ($cmp6) { __label__ = 7;; } else { __label__ = 6;; } //@line 1388 "numbers.cpp"
    $if_then9$$lor_lhs_false7$10: do { 
      if (__label__ == 6) {
  
        var $8=$say_zero_hundred; //@line 1388 "numbers.cpp"
        var $tobool8=((($8))|0)!=0; //@line 1388 "numbers.cpp"
        if ($tobool8) { __label__ = 7;break $if_then9$$lor_lhs_false7$10; } else { __label__ = 61;break $if_then9$$lor_lhs_false7$10; } //@line 1388 "numbers.cpp"
      }
    } while(0);
    if (__label__ == 7) {
  
      $found=0; //@line 1390 "numbers.cpp"
      var $9=$ordinal; //@line 1391 "numbers.cpp"
      var $tobool10=((($9))|0)!=0; //@line 1391 "numbers.cpp"
      if ($tobool10) { __label__ = 8;; } else { __label__ = 12;; } //@line 1391 "numbers.cpp"
      $land_lhs_true11$$if_then16$14: do { 
        if (__label__ == 8) {
  
          var $10=$tensunits; //@line 1391 "numbers.cpp"
          var $cmp12=((($10))|0)==0; //@line 1391 "numbers.cpp"
          if ($cmp12) { __label__ = 9;; } else { __label__ = 10;; } //@line 1391 "numbers.cpp"
          if (__label__ == 9) {
  
            var $11=$tr_addr; //@line 1394 "numbers.cpp"
            var $arraydecay=(($ph_100)&4294967295); //@line 1394 "numbers.cpp"
            var $call=__Z6LookupP10TranslatorPKcPc($11, ((__str35332)&4294967295), $arraydecay); //@line 1394 "numbers.cpp"
            $found=$call; //@line 1394 "numbers.cpp"
            __lastLabel__ = 9; ; //@line 1395 "numbers.cpp"
          }
          else if (__label__ == 10) {
  
            var $_pr1=$found; //@line 1396 "numbers.cpp"
            __lastLabel__ = 10; ;
          }
  
          var $12=__lastLabel__ == 10 ? $_pr1 : ($call); //@line 1396 "numbers.cpp"
          var $cmp15=((($12))|0)==0; //@line 1396 "numbers.cpp"
          if ($cmp15) { __label__ = 12;break $land_lhs_true11$$if_then16$14; } else { __label__ = 17;break $land_lhs_true11$$if_then16$14; } //@line 1396 "numbers.cpp"
        }
      } while(0);
      $if_then16$$if_end27$20: do { 
        if (__label__ == 12) {
  
          var $13=$tensunits; //@line 1398 "numbers.cpp"
          var $cmp17=((($13))|0)==0; //@line 1398 "numbers.cpp"
          if ($cmp17) { __label__ = 13;; } else { __label__ = 14;; } //@line 1398 "numbers.cpp"
          if (__label__ == 13) {
  
            var $14=$tr_addr; //@line 1401 "numbers.cpp"
            var $arraydecay19=(($ph_100)&4294967295); //@line 1401 "numbers.cpp"
            var $call20=__Z6LookupP10TranslatorPKcPc($14, ((__str36333)&4294967295), $arraydecay19); //@line 1401 "numbers.cpp"
            $found=$call20; //@line 1401 "numbers.cpp"
            __lastLabel__ = 13; ; //@line 1402 "numbers.cpp"
          }
          else if (__label__ == 14) {
  
            var $_pr3=$found; //@line 1403 "numbers.cpp"
            __lastLabel__ = 14; ;
          }
  
          var $15=__lastLabel__ == 14 ? $_pr3 : ($call20); //@line 1403 "numbers.cpp"
          var $tobool22=((($15))|0)!=0; //@line 1403 "numbers.cpp"
          if ($tobool22) { __label__ = 17;break $if_then16$$if_end27$20; } //@line 1403 "numbers.cpp"
  
          var $16=$tr_addr; //@line 1405 "numbers.cpp"
          var $arraydecay24=(($ph_100)&4294967295); //@line 1405 "numbers.cpp"
          var $call25=__Z6LookupP10TranslatorPKcPc($16, ((__str37334)&4294967295), $arraydecay24); //@line 1405 "numbers.cpp"
          ; //@line 1406 "numbers.cpp"
        }
      } while(0);
  
      var $17=$tr_addr; //@line 1409 "numbers.cpp"
      var $langopts28=(($17)&4294967295); //@line 1409 "numbers.cpp"
      var $numbers29=(($langopts28+184)&4294967295); //@line 1409 "numbers.cpp"
      var $18=HEAP32[(($numbers29)>>2)]; //@line 1409 "numbers.cpp"
      var $and30=($18) & 2048; //@line 1409 "numbers.cpp"
      var $cmp31=((($and30))|0)!=0; //@line 1409 "numbers.cpp"
      var $19=$hundreds; //@line 1409 "numbers.cpp"
      if ($cmp31) { __label__ = 18;; } else { __label__ = 19;; } //@line 1409 "numbers.cpp"
      $land_lhs_true32$$if_else$28: do { 
        if (__label__ == 18) {
  
          var $cmp33=((($19))|0)!=19; //@line 1409 "numbers.cpp"
          var $20=$hundreds; //@line 1415 "numbers.cpp"
          var $cmp35=((($20))|0) >= 10; //@line 1415 "numbers.cpp"
          var $or_cond=($cmp33) & ($cmp35); //@line 1409 "numbers.cpp"
          if ($or_cond) { __label__ = 20;break $land_lhs_true32$$if_else$28; } else { __label__ = 33;break $land_lhs_true32$$if_else$28; } //@line 1409 "numbers.cpp"
        }
        else if (__label__ == 19) {
  
          var $cmp35_old=((($19))|0) >= 10; //@line 1415 "numbers.cpp"
          if ($cmp35_old) { __label__ = 20;break $land_lhs_true32$$if_else$28; } else { __label__ = 33;break $land_lhs_true32$$if_else$28; } //@line 1415 "numbers.cpp"
        }
      } while(0);
      if (__label__ == 20) {
  
        var $arrayidx37=(($ph_digits)&4294967295); //@line 1417 "numbers.cpp"
        HEAP8[($arrayidx37)]=0; //@line 1417 "numbers.cpp"
        $exact=0; //@line 1419 "numbers.cpp"
        var $21=$value_addr; //@line 1420 "numbers.cpp"
        var $rem38=((($21))|0)%1000; //@line 1420 "numbers.cpp"
        var $cmp39=((($rem38))|0)==0; //@line 1420 "numbers.cpp"
        if ($cmp39) { __label__ = 21;; } else { __label__ = 22;; } //@line 1420 "numbers.cpp"
        if (__label__ == 21) {
  
          $exact=1; //@line 1421 "numbers.cpp"
          ; //@line 1421 "numbers.cpp"
        }
  
        var $22=$tr_addr; //@line 1423 "numbers.cpp"
        var $23=$hundreds; //@line 1423 "numbers.cpp"
        var $div42=((((($23))|0)/10)|0); //@line 1423 "numbers.cpp"
        var $24=$thousandplex_addr; //@line 1423 "numbers.cpp"
        var $add=((($24)+1)&4294967295); //@line 1423 "numbers.cpp"
        var $25=$exact; //@line 1423 "numbers.cpp"
        var $26=$ordinal; //@line 1423 "numbers.cpp"
        var $or=($26) | ($25); //@line 1423 "numbers.cpp"
        var $arraydecay43=(($ph_10T)&4294967295); //@line 1423 "numbers.cpp"
        var $call44=__ZL15LookupThousandsP10TranslatoriiiPc($22, $div42, $add, $or, $arraydecay43); //@line 1423 "numbers.cpp"
        var $cmp45=((($call44))|0)==0; //@line 1423 "numbers.cpp"
        if ($cmp45) { __label__ = 23;; } else { __label__ = 26;; } //@line 1423 "numbers.cpp"
        if (__label__ == 23) {
  
          $x=0; //@line 1425 "numbers.cpp"
          var $27=$tr_addr; //@line 1426 "numbers.cpp"
          var $langopts47=(($27)&4294967295); //@line 1426 "numbers.cpp"
          var $numbers2=(($langopts47+188)&4294967295); //@line 1426 "numbers.cpp"
          var $28=HEAP32[(($numbers2)>>2)]; //@line 1426 "numbers.cpp"
          var $29=$thousandplex_addr; //@line 1426 "numbers.cpp"
          var $add48=((($29)+1)&4294967295); //@line 1426 "numbers.cpp"
          var $shl=1 << ($add48); //@line 1426 "numbers.cpp"
          var $and49=($shl) & ($28); //@line 1426 "numbers.cpp"
          var $tobool50=((($and49))|0)!=0; //@line 1426 "numbers.cpp"
          if ($tobool50) { __label__ = 24;; } else { __label__ = 25;; } //@line 1426 "numbers.cpp"
          if (__label__ == 24) {
  
            $x=8; //@line 1427 "numbers.cpp"
            ; //@line 1427 "numbers.cpp"
          }
  
          var $30=$tr_addr; //@line 1428 "numbers.cpp"
          var $31=$hundreds; //@line 1428 "numbers.cpp"
          var $div53=((((($31))|0)/10)|0); //@line 1428 "numbers.cpp"
          var $32=$x; //@line 1428 "numbers.cpp"
          var $arraydecay54=(($ph_digits)&4294967295); //@line 1428 "numbers.cpp"
          var $call55=__ZL10LookupNum2P10TranslatoriiPc($30, $div53, $32, $arraydecay54); //@line 1428 "numbers.cpp"
          ; //@line 1429 "numbers.cpp"
        }
  
        var $33=$tr_addr; //@line 1431 "numbers.cpp"
        var $langopts57=(($33)&4294967295); //@line 1431 "numbers.cpp"
        var $numbers258=(($langopts57+188)&4294967295); //@line 1431 "numbers.cpp"
        var $34=HEAP32[(($numbers258)>>2)]; //@line 1431 "numbers.cpp"
        var $and59=($34) & 512; //@line 1431 "numbers.cpp"
        var $tobool60=((($and59))|0)!=0; //@line 1431 "numbers.cpp"
        var $arraydecay62=(($ph_thousands)&4294967295); //@line 1432 "numbers.cpp"
        if ($tobool60) { __label__ = 27;; } else { __label__ = 28;; } //@line 1431 "numbers.cpp"
        if (__label__ == 27) {
  
          var $arraydecay63=(($ph_10T)&4294967295); //@line 1432 "numbers.cpp"
          var $arraydecay64=(($ph_digits)&4294967295); //@line 1432 "numbers.cpp"
          var $call65=_sprintf($arraydecay62, ((__str47699)&4294967295), allocate([$arraydecay63,0,0,0,$arraydecay64,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1432 "numbers.cpp"
          ; //@line 1432 "numbers.cpp"
        }
        else if (__label__ == 28) {
  
          var $arraydecay68=(($ph_digits)&4294967295); //@line 1434 "numbers.cpp"
          var $arraydecay69=(($ph_10T)&4294967295); //@line 1434 "numbers.cpp"
          var $call70=_sprintf($arraydecay62, ((__str47699)&4294967295), allocate([$arraydecay68,0,0,0,$arraydecay69,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1434 "numbers.cpp"
          ;
        }
  
        var $35=$hundreds; //@line 1436 "numbers.cpp"
        var $rem72=((($35))|0)%10; //@line 1436 "numbers.cpp"
        $hundreds=$rem72; //@line 1436 "numbers.cpp"
        var $cmp73=((($rem72))|0)==0; //@line 1437 "numbers.cpp"
        if ($cmp73) { __label__ = 30;; } else { __label__ = 32;; } //@line 1437 "numbers.cpp"
        $land_lhs_true74$$if_end78$46: do { 
          if (__label__ == 30) {
  
            var $36=$say_zero_hundred; //@line 1437 "numbers.cpp"
            var $cmp75=((($36))|0)==0; //@line 1437 "numbers.cpp"
            if (!($cmp75)) { __label__ = 32;break $land_lhs_true74$$if_end78$46; } //@line 1437 "numbers.cpp"
  
            var $arrayidx77=(($ph_100)&4294967295); //@line 1438 "numbers.cpp"
            HEAP8[($arrayidx77)]=0; //@line 1438 "numbers.cpp"
            ; //@line 1438 "numbers.cpp"
          }
        } while(0);
  
        $suppress_null_addr=1; //@line 1439 "numbers.cpp"
        ; //@line 1440 "numbers.cpp"
      }
  
      var $arrayidx81=(($ph_digits)&4294967295); //@line 1442 "numbers.cpp"
      HEAP8[($arrayidx81)]=0; //@line 1442 "numbers.cpp"
      var $37=$hundreds; //@line 1444 "numbers.cpp"
      var $cmp82=((($37))|0) > 0; //@line 1444 "numbers.cpp"
      if ($cmp82) { __label__ = 35;; } else { __label__ = 34;; } //@line 1444 "numbers.cpp"
      $if_then85$$lor_lhs_false83$51: do { 
        if (__label__ == 34) {
  
          var $38=$say_zero_hundred; //@line 1444 "numbers.cpp"
          var $tobool84=((($38))|0)!=0; //@line 1444 "numbers.cpp"
          if ($tobool84) { __label__ = 35;break $if_then85$$lor_lhs_false83$51; } else { __label__ = 60;break $if_then85$$lor_lhs_false83$51; } //@line 1444 "numbers.cpp"
        }
      } while(0);
      $if_then85$$if_end166$53: do { 
        if (__label__ == 35) {
  
          var $39=$tr_addr; //@line 1446 "numbers.cpp"
          var $langopts86=(($39)&4294967295); //@line 1446 "numbers.cpp"
          var $numbers87=(($langopts86+184)&4294967295); //@line 1446 "numbers.cpp"
          var $40=HEAP32[(($numbers87)>>2)]; //@line 1446 "numbers.cpp"
          var $and88=($40) & 262144; //@line 1446 "numbers.cpp"
          var $tobool89=((($and88))|0)!=0; //@line 1446 "numbers.cpp"
          if ($tobool89) { __label__ = 36;; } else { __label__ = 39;; } //@line 1446 "numbers.cpp"
          $land_lhs_true90$$if_end99$55: do { 
            if (__label__ == 36) {
  
              var $41=$control_addr; //@line 1446 "numbers.cpp"
              var $and91=($41) & 1; //@line 1446 "numbers.cpp"
              var $tobool92=((($and91))|0)!=0; //@line 1446 "numbers.cpp"
              if ($tobool92) { __label__ = 38;; } else { __label__ = 37;; } //@line 1446 "numbers.cpp"
              if (__label__ == 37) {
  
                var $arrayidx94=(($ph_thousands)&4294967295); //@line 1446 "numbers.cpp"
                var $42=HEAP8[($arrayidx94)]; //@line 1446 "numbers.cpp"
                var $conv=(tempInt=(($42)),(tempInt>=128?tempInt-256:tempInt)); //@line 1446 "numbers.cpp"
                var $cmp95=((($conv))|0)!=0; //@line 1446 "numbers.cpp"
                if (!($cmp95)) { __label__ = 39;break $land_lhs_true90$$if_end99$55; } //@line 1446 "numbers.cpp"
              }
  
              var $43=$tr_addr; //@line 1448 "numbers.cpp"
              var $arraydecay97=(($ph_thousand_and)&4294967295); //@line 1448 "numbers.cpp"
              var $call98=__Z6LookupP10TranslatorPKcPc($43, ((__str33330)&4294967295), $arraydecay97); //@line 1448 "numbers.cpp"
              ; //@line 1449 "numbers.cpp"
            }
          } while(0);
  
          $suppress_null_addr=1; //@line 1451 "numbers.cpp"
          $found=0; //@line 1453 "numbers.cpp"
          var $44=$ordinal; //@line 1454 "numbers.cpp"
          var $tobool100=((($44))|0)!=0; //@line 1454 "numbers.cpp"
          if ($tobool100) { __label__ = 40;; } else { __label__ = 45;; } //@line 1454 "numbers.cpp"
          $land_lhs_true101$$if_end124$61: do { 
            if (__label__ == 40) {
  
              var $45=$tensunits; //@line 1454 "numbers.cpp"
              var $cmp102=((($45))|0)==0; //@line 1454 "numbers.cpp"
              if ($cmp102) { __label__ = 42;; } else { __label__ = 41;; } //@line 1454 "numbers.cpp"
              if (__label__ == 41) {
  
                var $46=$tr_addr; //@line 1454 "numbers.cpp"
                var $langopts104=(($46)&4294967295); //@line 1454 "numbers.cpp"
                var $numbers2105=(($langopts104+188)&4294967295); //@line 1454 "numbers.cpp"
                var $47=HEAP32[(($numbers2105)>>2)]; //@line 1454 "numbers.cpp"
                var $and106=($47) & 4096; //@line 1454 "numbers.cpp"
                var $tobool107=((($and106))|0)!=0; //@line 1454 "numbers.cpp"
                if (!($tobool107)) { __label__ = 45;break $land_lhs_true101$$if_end124$61; } //@line 1454 "numbers.cpp"
              }
  
              var $arraydecay109=(($string)&4294967295); //@line 1458 "numbers.cpp"
              var $48=$hundreds; //@line 1458 "numbers.cpp"
              var $call110=_sprintf($arraydecay109, ((__str39336)&4294967295), allocate([$48,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1458 "numbers.cpp"
              var $49=$tr_addr; //@line 1459 "numbers.cpp"
              var $arraydecay111=(($string)&4294967295); //@line 1459 "numbers.cpp"
              var $arraydecay112=(($ph_digits)&4294967295); //@line 1459 "numbers.cpp"
              var $call113=__Z6LookupP10TranslatorPKcPc($49, $arraydecay111, $arraydecay112); //@line 1459 "numbers.cpp"
              $found=$call113; //@line 1459 "numbers.cpp"
              var $50=$tr_addr; //@line 1461 "numbers.cpp"
              var $langopts114=(($50)&4294967295); //@line 1461 "numbers.cpp"
              var $numbers2115=(($langopts114+188)&4294967295); //@line 1461 "numbers.cpp"
              var $51=HEAP32[(($numbers2115)>>2)]; //@line 1461 "numbers.cpp"
              var $and116=($51) & 4096; //@line 1461 "numbers.cpp"
              var $tobool117=((($and116))|0)!=0; //@line 1461 "numbers.cpp"
              if (!($tobool117)) { __label__ = 45;break $land_lhs_true101$$if_end124$61; } //@line 1461 "numbers.cpp"
  
              var $52=$tensunits; //@line 1461 "numbers.cpp"
              var $cmp119=((($52))|0) > 0; //@line 1461 "numbers.cpp"
              if (!($cmp119)) { __label__ = 45;break $land_lhs_true101$$if_end124$61; } //@line 1461 "numbers.cpp"
  
              var $arraydecay121=(($ph_digits)&4294967295); //@line 1465 "numbers.cpp"
              var $call122=_strcat($arraydecay121, ((__ZL11ph_ordinal2)&4294967295)); //@line 1465 "numbers.cpp"
              ; //@line 1466 "numbers.cpp"
            }
          } while(0);
  
          var $53=$hundreds; //@line 1469 "numbers.cpp"
          var $cmp125=((($53))|0)==0; //@line 1469 "numbers.cpp"
          if ($cmp125) { __label__ = 46;; } else { __label__ = 48;; } //@line 1469 "numbers.cpp"
          $land_lhs_true126$$if_else131$69: do { 
            if (__label__ == 46) {
  
              var $54=$say_zero_hundred; //@line 1469 "numbers.cpp"
              var $tobool127=((($54))|0)!=0; //@line 1469 "numbers.cpp"
              if (!($tobool127)) { __label__ = 48;break $land_lhs_true126$$if_else131$69; } //@line 1469 "numbers.cpp"
  
              var $55=$tr_addr; //@line 1471 "numbers.cpp"
              var $arraydecay129=(($ph_digits)&4294967295); //@line 1471 "numbers.cpp"
              var $call130=__Z6LookupP10TranslatorPKcPc($55, ((__str16313)&4294967295), $arraydecay129); //@line 1471 "numbers.cpp"
              __label__ = 60;break $if_then85$$if_end166$53; //@line 1472 "numbers.cpp"
            }
          } while(0);
  
          var $56=$found; //@line 1475 "numbers.cpp"
          var $tobool132=((($56))|0)!=0; //@line 1475 "numbers.cpp"
          if ($tobool132) { __label__ = 54;; } else { __label__ = 49;; } //@line 1475 "numbers.cpp"
          $if_end149thread_pre_split$$land_lhs_true133$73: do { 
            if (__label__ == 49) {
  
              var $57=$tensunits; //@line 1475 "numbers.cpp"
              var $cmp134=((($57))|0)==0; //@line 1475 "numbers.cpp"
              if ($cmp134) { __label__ = 50;; } else { __label__ = 51;; } //@line 1475 "numbers.cpp"
              if (__label__ == 50) {
  
                var $arraydecay136=(($string)&4294967295); //@line 1478 "numbers.cpp"
                var $58=$hundreds; //@line 1478 "numbers.cpp"
                var $call137=_sprintf($arraydecay136, ((__str40337)&4294967295), allocate([$58,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1478 "numbers.cpp"
                var $59=$tr_addr; //@line 1479 "numbers.cpp"
                var $arraydecay138=(($string)&4294967295); //@line 1479 "numbers.cpp"
                var $arraydecay139=(($ph_digits)&4294967295); //@line 1479 "numbers.cpp"
                var $call140=__Z6LookupP10TranslatorPKcPc($59, $arraydecay138, $arraydecay139); //@line 1479 "numbers.cpp"
                $found=$call140; //@line 1479 "numbers.cpp"
                __lastLabel__ = 50; ; //@line 1480 "numbers.cpp"
              }
              else if (__label__ == 51) {
  
                var $_pr4=$found; //@line 1482 "numbers.cpp"
                __lastLabel__ = 51; ;
              }
  
              var $60=__lastLabel__ == 51 ? $_pr4 : ($call140); //@line 1482 "numbers.cpp"
              var $tobool142=((($60))|0)!=0; //@line 1482 "numbers.cpp"
              if ($tobool142) { __label__ = 54;break $if_end149thread_pre_split$$land_lhs_true133$73; } //@line 1482 "numbers.cpp"
  
              var $arraydecay144=(($string)&4294967295); //@line 1484 "numbers.cpp"
              var $61=$hundreds; //@line 1484 "numbers.cpp"
              var $call145=_sprintf($arraydecay144, ((__str41338)&4294967295), allocate([$61,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1484 "numbers.cpp"
              var $62=$tr_addr; //@line 1485 "numbers.cpp"
              var $arraydecay146=(($string)&4294967295); //@line 1485 "numbers.cpp"
              var $arraydecay147=(($ph_digits)&4294967295); //@line 1485 "numbers.cpp"
              var $call148=__Z6LookupP10TranslatorPKcPc($62, $arraydecay146, $arraydecay147); //@line 1485 "numbers.cpp"
              $found=$call148; //@line 1485 "numbers.cpp"
              __lastLabel__ = 53; __label__ = 55;break $if_end149thread_pre_split$$land_lhs_true133$73; //@line 1486 "numbers.cpp"
            }
          } while(0);
          if (__label__ == 54) {
  
            var $_pr6=$found; //@line 1488 "numbers.cpp"
            __lastLabel__ = 54; ;
          }
  
          var $63=__lastLabel__ == 54 ? $_pr6 : ($call148); //@line 1488 "numbers.cpp"
          var $tobool150=((($63))|0)!=0; //@line 1488 "numbers.cpp"
          if ($tobool150) { __label__ = 56;; } else { __label__ = 57;; } //@line 1488 "numbers.cpp"
          if (__label__ == 56) {
  
            var $arrayidx152=(($ph_100)&4294967295); //@line 1490 "numbers.cpp"
            HEAP8[($arrayidx152)]=0; //@line 1490 "numbers.cpp"
            ; //@line 1491 "numbers.cpp"
          }
          else if (__label__ == 57) {
  
            var $64=$hundreds; //@line 1494 "numbers.cpp"
            var $cmp154=((($64))|0) > 1; //@line 1494 "numbers.cpp"
            if ($cmp154) { __label__ = 59;; } else { __label__ = 58;; } //@line 1494 "numbers.cpp"
            if (__label__ == 58) {
  
              var $65=$tr_addr; //@line 1494 "numbers.cpp"
              var $langopts156=(($65)&4294967295); //@line 1494 "numbers.cpp"
              var $numbers157=(($langopts156+184)&4294967295); //@line 1494 "numbers.cpp"
              var $66=HEAP32[(($numbers157)>>2)]; //@line 1494 "numbers.cpp"
              var $and158=($66) & 1024; //@line 1494 "numbers.cpp"
              var $cmp159=((($and158))|0)==0; //@line 1494 "numbers.cpp"
              if (!($cmp159)) { __label__ = 60;break $if_then85$$if_end166$53; } //@line 1494 "numbers.cpp"
            }
  
            var $67=$tr_addr; //@line 1496 "numbers.cpp"
            var $68=$hundreds; //@line 1496 "numbers.cpp"
            var $arraydecay161=(($ph_digits)&4294967295); //@line 1496 "numbers.cpp"
            var $call162=__ZL10LookupNum2P10TranslatoriiPc($67, $68, 0, $arraydecay161); //@line 1496 "numbers.cpp"
            ; //@line 1497 "numbers.cpp"
          }
        }
      } while(0);
  
      var $arraydecay167=(($buf1)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay168=(($ph_thousands)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay169=(($ph_thousand_and)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay170=(($ph_digits)&4294967295); //@line 1502 "numbers.cpp"
      var $arraydecay171=(($ph_100)&4294967295); //@line 1502 "numbers.cpp"
      var $call172=_sprintf($arraydecay167, ((__str20317)&4294967295), allocate([$arraydecay168,0,0,0,$arraydecay169,0,0,0,$arraydecay170,0,0,0,$arraydecay171,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1502 "numbers.cpp"
      ; //@line 1503 "numbers.cpp"
    }
  
    var $arrayidx174=(($ph_hundred_and)&4294967295); //@line 1505 "numbers.cpp"
    HEAP8[($arrayidx174)]=0; //@line 1505 "numbers.cpp"
    var $69=$tensunits; //@line 1506 "numbers.cpp"
    var $cmp175=((($69))|0) > 0; //@line 1506 "numbers.cpp"
    if ($cmp175) { __label__ = 62;; } else { __label__ = 74;; } //@line 1506 "numbers.cpp"
    $if_then176$$if_end217$91: do { 
      if (__label__ == 62) {
  
        var $70=$value_addr; //@line 1508 "numbers.cpp"
        var $cmp177=((($70))|0) > 100; //@line 1508 "numbers.cpp"
        if ($cmp177) { __label__ = 65;; } else { __label__ = 63;; } //@line 1508 "numbers.cpp"
        $if_then183$$lor_lhs_false178$93: do { 
          if (__label__ == 63) {
  
            var $71=$control_addr; //@line 1508 "numbers.cpp"
            var $and179=($71) & 1; //@line 1508 "numbers.cpp"
            var $tobool180=((($and179))|0)!=0; //@line 1508 "numbers.cpp"
            if (!($tobool180)) { __label__ = 69;break $if_then183$$lor_lhs_false178$93; } //@line 1508 "numbers.cpp"
  
            var $72=$thousandplex_addr; //@line 1508 "numbers.cpp"
            var $cmp182=((($72))|0)==0; //@line 1508 "numbers.cpp"
            if ($cmp182) { __label__ = 65;break $if_then183$$lor_lhs_false178$93; } else { __label__ = 69;break $if_then183$$lor_lhs_false178$93; } //@line 1508 "numbers.cpp"
          }
        } while(0);
        $if_then183$$if_end199$96: do { 
          if (__label__ == 65) {
  
            var $73=$tr_addr; //@line 1510 "numbers.cpp"
            var $langopts184=(($73)&4294967295); //@line 1510 "numbers.cpp"
            var $numbers185=(($langopts184+184)&4294967295); //@line 1510 "numbers.cpp"
            var $74=HEAP32[(($numbers185)>>2)]; //@line 1510 "numbers.cpp"
            var $and186=($74) & 64; //@line 1510 "numbers.cpp"
            var $tobool187=((($and186))|0)!=0; //@line 1510 "numbers.cpp"
            if ($tobool187) { __label__ = 68;; } else { __label__ = 66;; } //@line 1510 "numbers.cpp"
            if (__label__ == 66) {
  
              var $75=$tr_addr; //@line 1510 "numbers.cpp"
              var $langopts189=(($75)&4294967295); //@line 1510 "numbers.cpp"
              var $numbers190=(($langopts189+184)&4294967295); //@line 1510 "numbers.cpp"
              var $76=HEAP32[(($numbers190)>>2)]; //@line 1510 "numbers.cpp"
              var $and191=($76) & 8388608; //@line 1510 "numbers.cpp"
              var $tobool192=((($and191))|0)!=0; //@line 1510 "numbers.cpp"
              if (!($tobool192)) { __label__ = 69;break $if_then183$$if_end199$96; } //@line 1510 "numbers.cpp"
  
              var $77=$tensunits; //@line 1510 "numbers.cpp"
              var $cmp194=((($77))|0) < 10; //@line 1510 "numbers.cpp"
              if (!($cmp194)) { __label__ = 69;break $if_then183$$if_end199$96; } //@line 1510 "numbers.cpp"
            }
  
            var $78=$tr_addr; //@line 1512 "numbers.cpp"
            var $arraydecay196=(($ph_hundred_and)&4294967295); //@line 1512 "numbers.cpp"
            var $call197=__Z6LookupP10TranslatorPKcPc($78, ((__str33330)&4294967295), $arraydecay196); //@line 1512 "numbers.cpp"
            ; //@line 1513 "numbers.cpp"
          }
        } while(0);
  
        var $79=$tr_addr; //@line 1515 "numbers.cpp"
        var $langopts200=(($79)&4294967295); //@line 1515 "numbers.cpp"
        var $numbers201=(($langopts200+184)&4294967295); //@line 1515 "numbers.cpp"
        var $80=HEAP32[(($numbers201)>>2)]; //@line 1515 "numbers.cpp"
        var $and202=($80) & 524288; //@line 1515 "numbers.cpp"
        var $tobool203=((($and202))|0)!=0; //@line 1515 "numbers.cpp"
        if (!($tobool203)) { __label__ = 74;break $if_then176$$if_end217$91; } //@line 1515 "numbers.cpp"
  
        var $81=$hundreds; //@line 1515 "numbers.cpp"
        var $cmp205=((($81))|0)==0; //@line 1515 "numbers.cpp"
        if (!($cmp205)) { __label__ = 74;break $if_then176$$if_end217$91; } //@line 1515 "numbers.cpp"
  
        var $82=$control_addr; //@line 1515 "numbers.cpp"
        var $and207=($82) & 1; //@line 1515 "numbers.cpp"
        var $tobool208=((($and207))|0)!=0; //@line 1515 "numbers.cpp"
        if ($tobool208) { __label__ = 73;; } else { __label__ = 72;; } //@line 1515 "numbers.cpp"
        if (__label__ == 72) {
  
          var $arrayidx210=(($ph_thousands)&4294967295); //@line 1515 "numbers.cpp"
          var $83=HEAP8[($arrayidx210)]; //@line 1515 "numbers.cpp"
          var $conv211=(tempInt=(($83)),(tempInt>=128?tempInt-256:tempInt)); //@line 1515 "numbers.cpp"
          var $cmp212=((($conv211))|0)!=0; //@line 1515 "numbers.cpp"
          if (!($cmp212)) { __label__ = 74;break $if_then176$$if_end217$91; } //@line 1515 "numbers.cpp"
        }
  
        var $84=$tr_addr; //@line 1517 "numbers.cpp"
        var $arraydecay214=(($ph_hundred_and)&4294967295); //@line 1517 "numbers.cpp"
        var $call215=__Z6LookupP10TranslatorPKcPc($84, ((__str33330)&4294967295), $arraydecay214); //@line 1517 "numbers.cpp"
        ; //@line 1518 "numbers.cpp"
      }
    } while(0);
  
    var $arrayidx218=(($buf2)&4294967295); //@line 1522 "numbers.cpp"
    HEAP8[($arrayidx218)]=0; //@line 1522 "numbers.cpp"
    var $85=$tensunits; //@line 1524 "numbers.cpp"
    var $cmp219=((($85))|0)!=0; //@line 1524 "numbers.cpp"
    if ($cmp219) { __label__ = 76;; } else { __label__ = 75;; } //@line 1524 "numbers.cpp"
    $if_then222$$lor_lhs_false220$109: do { 
      if (__label__ == 75) {
  
        var $86=$suppress_null_addr; //@line 1524 "numbers.cpp"
        var $cmp221=((($86))|0)==0; //@line 1524 "numbers.cpp"
        if ($cmp221) { __label__ = 76;break $if_then222$$lor_lhs_false220$109; } //@line 1524 "numbers.cpp"
  
        var $102=HEAP8[(((__ZL11ph_ordinal2)&4294967295))]; //@line 1551 "numbers.cpp"
        var $conv262=(tempInt=(($102)),(tempInt>=128?tempInt-256:tempInt)); //@line 1551 "numbers.cpp"
        var $cmp263=((($conv262))|0)!=0; //@line 1551 "numbers.cpp"
        if (!($cmp263)) { __label__ = 94;break $if_then222$$lor_lhs_false220$109; } //@line 1551 "numbers.cpp"
  
        var $arraydecay265=(($buf1)&4294967295); //@line 1553 "numbers.cpp"
        var $call266=_strlen($arraydecay265); //@line 1553 "numbers.cpp"
        $ix=$call266; //@line 1553 "numbers.cpp"
        var $103=$ix; //@line 1554 "numbers.cpp"
        var $cmp267=((($103))|0) > 0; //@line 1554 "numbers.cpp"
        if ($cmp267) { __label__ = 91;; } else { __label__ = 93;; } //@line 1554 "numbers.cpp"
        $land_lhs_true268$$if_end275$113: do { 
          if (__label__ == 91) {
  
            var $104=$ix; //@line 1554 "numbers.cpp"
            var $sub=((($104)-1)&4294967295); //@line 1554 "numbers.cpp"
            var $arrayidx269=(($buf1+$sub)&4294967295); //@line 1554 "numbers.cpp"
            var $105=HEAP8[($arrayidx269)]; //@line 1554 "numbers.cpp"
            var $conv270=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt)); //@line 1554 "numbers.cpp"
            var $cmp271=((($conv270))|0)==10; //@line 1554 "numbers.cpp"
            if (!($cmp271)) { __label__ = 93;break $land_lhs_true268$$if_end275$113; } //@line 1554 "numbers.cpp"
  
            var $106=$ix; //@line 1555 "numbers.cpp"
            var $sub273=((($106)-1)&4294967295); //@line 1555 "numbers.cpp"
            var $arrayidx274=(($buf1+$sub273)&4294967295); //@line 1555 "numbers.cpp"
            HEAP8[($arrayidx274)]=0; //@line 1555 "numbers.cpp"
            ; //@line 1555 "numbers.cpp"
          }
        } while(0);
  
        var $arraydecay276=(($buf2)&4294967295); //@line 1556 "numbers.cpp"
        var $call277=_strcpy($arraydecay276, ((__ZL11ph_ordinal2)&4294967295)); //@line 1556 "numbers.cpp"
        __label__ = 94;break $if_then222$$lor_lhs_false220$109; //@line 1557 "numbers.cpp"
      }
    } while(0);
    $if_then222$$if_end279$117: do { 
      if (__label__ == 76) {
  
        $x=0; //@line 1526 "numbers.cpp"
        var $87=$thousandplex_addr; //@line 1527 "numbers.cpp"
        var $cmp223=((($87))|0)==0; //@line 1527 "numbers.cpp"
        if ($cmp223) { __label__ = 77;; } else { __label__ = 84;; } //@line 1527 "numbers.cpp"
        $if_then224$$if_else240$119: do { 
          if (__label__ == 77) {
  
            $x=2; //@line 1529 "numbers.cpp"
            var $88=$ordinal; //@line 1530 "numbers.cpp"
            var $tobool225=((($88))|0)!=0; //@line 1530 "numbers.cpp"
            if ($tobool225) { __label__ = 78;; } else { __label__ = 79;; } //@line 1530 "numbers.cpp"
            if (__label__ == 78) {
  
              $x=3; //@line 1531 "numbers.cpp"
              ; //@line 1531 "numbers.cpp"
            }
  
            var $89=$value_addr; //@line 1532 "numbers.cpp"
            var $cmp228=((($89))|0) < 100; //@line 1532 "numbers.cpp"
            if ($cmp228) { __label__ = 80;; } else { __label__ = 82;; } //@line 1532 "numbers.cpp"
            $land_lhs_true229$$if_end234$124: do { 
              if (__label__ == 80) {
  
                var $90=$control_addr; //@line 1532 "numbers.cpp"
                var $and230=($90) & 1; //@line 1532 "numbers.cpp"
                var $tobool231=((($and230))|0)!=0; //@line 1532 "numbers.cpp"
                if ($tobool231) { __label__ = 82;break $land_lhs_true229$$if_end234$124; } //@line 1532 "numbers.cpp"
  
                var $91=$x; //@line 1533 "numbers.cpp"
                var $or233=($91) | 4; //@line 1533 "numbers.cpp"
                $x=$or233; //@line 1533 "numbers.cpp"
                ; //@line 1533 "numbers.cpp"
              }
            } while(0);
  
            var $92=$ordinal; //@line 1534 "numbers.cpp"
            var $and235=($92) & 32; //@line 1534 "numbers.cpp"
            var $tobool236=((($and235))|0)!=0; //@line 1534 "numbers.cpp"
            if (!($tobool236)) { __label__ = 86;break $if_then224$$if_else240$119; } //@line 1534 "numbers.cpp"
  
            var $93=$x; //@line 1535 "numbers.cpp"
            var $or238=($93) | 32; //@line 1535 "numbers.cpp"
            $x=$or238; //@line 1535 "numbers.cpp"
            ; //@line 1535 "numbers.cpp"
          }
          else if (__label__ == 84) {
  
            var $94=$tr_addr; //@line 1539 "numbers.cpp"
            var $langopts241=(($94)&4294967295); //@line 1539 "numbers.cpp"
            var $numbers2242=(($langopts241+188)&4294967295); //@line 1539 "numbers.cpp"
            var $95=HEAP32[(($numbers2242)>>2)]; //@line 1539 "numbers.cpp"
            var $96=$thousandplex_addr; //@line 1539 "numbers.cpp"
            var $shl243=1 << ($96); //@line 1539 "numbers.cpp"
            var $and244=($shl243) & ($95); //@line 1539 "numbers.cpp"
            var $tobool245=((($and244))|0)!=0; //@line 1539 "numbers.cpp"
            if (!($tobool245)) { __label__ = 86;break $if_then224$$if_else240$119; } //@line 1539 "numbers.cpp"
  
            $x=8; //@line 1540 "numbers.cpp"
            ; //@line 1540 "numbers.cpp"
          }
        } while(0);
  
        var $97=$tr_addr; //@line 1543 "numbers.cpp"
        var $98=$tensunits; //@line 1543 "numbers.cpp"
        var $99=$x; //@line 1543 "numbers.cpp"
        var $arraydecay249=(($buf2)&4294967295); //@line 1543 "numbers.cpp"
        var $call250=__ZL10LookupNum2P10TranslatoriiPc($97, $98, $99, $arraydecay249); //@line 1543 "numbers.cpp"
        var $cmp251=((($call250))|0)!=0; //@line 1543 "numbers.cpp"
        if (!($cmp251)) { __label__ = 94;break $if_then222$$if_end279$117; } //@line 1543 "numbers.cpp"
  
        var $100=$tr_addr; //@line 1545 "numbers.cpp"
        var $langopts253=(($100)&4294967295); //@line 1545 "numbers.cpp"
        var $numbers254=(($langopts253+184)&4294967295); //@line 1545 "numbers.cpp"
        var $101=HEAP32[(($numbers254)>>2)]; //@line 1545 "numbers.cpp"
        var $and255=($101) & 128; //@line 1545 "numbers.cpp"
        var $tobool256=((($and255))|0)!=0; //@line 1545 "numbers.cpp"
        if (!($tobool256)) { __label__ = 94;break $if_then222$$if_end279$117; } //@line 1545 "numbers.cpp"
  
        var $arrayidx258=(($ph_hundred_and)&4294967295); //@line 1546 "numbers.cpp"
        HEAP8[($arrayidx258)]=0; //@line 1546 "numbers.cpp"
        ; //@line 1546 "numbers.cpp"
      }
    } while(0);
  
    var $107=$ph_out_addr; //@line 1560 "numbers.cpp"
    var $arraydecay280=(($buf1)&4294967295); //@line 1560 "numbers.cpp"
    var $arraydecay281=(($ph_hundred_and)&4294967295); //@line 1560 "numbers.cpp"
    var $arraydecay282=(($buf2)&4294967295); //@line 1560 "numbers.cpp"
    var $call283=_sprintf($107, ((__str6549)&4294967295), allocate([$arraydecay280,0,0,0,$arraydecay281,0,0,0,$arraydecay282,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1560 "numbers.cpp"
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL10LookupNum2P10TranslatoriiPc($tr, $value, $control, $ph_out) {
    var __stackBase__  = STACKTOP; STACKTOP += 148; _memset(__stackBase__, 0, 148);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $value_addr;
    var $control_addr;
    var $ph_out_addr;
    var $found;
    var $ix;
    var $units;
    var $tens;
    var $used_and;
    var $found_ordinal;
    var $next_phtype;
    var $ord_type;
    var $string=__stackBase__;
    var $ph_ordinal=__stackBase__+12;
    var $ph_tens=__stackBase__+32;
    var $ph_digits=__stackBase__+84;
    var $ph_and=__stackBase__+136;
    $tr_addr=$tr;
    $value_addr=$value;
    $control_addr=$control;
    $ph_out_addr=$ph_out;
    $used_and=0; //@line 1109 "numbers.cpp"
    $found_ordinal=0; //@line 1110 "numbers.cpp"
    $ord_type=111; //@line 1112 "numbers.cpp"
    var $0=$value_addr; //@line 1119 "numbers.cpp"
    var $rem=((($0))|0)%10; //@line 1119 "numbers.cpp"
    $units=$rem; //@line 1119 "numbers.cpp"
    var $1=$value_addr; //@line 1120 "numbers.cpp"
    var $div=((((($1))|0)/10)|0); //@line 1120 "numbers.cpp"
    $tens=$div; //@line 1120 "numbers.cpp"
    $found=0; //@line 1122 "numbers.cpp"
    var $arrayidx=(($ph_ordinal)&4294967295); //@line 1123 "numbers.cpp"
    HEAP8[($arrayidx)]=0; //@line 1123 "numbers.cpp"
    var $arrayidx1=(($ph_tens)&4294967295); //@line 1124 "numbers.cpp"
    HEAP8[($arrayidx1)]=0; //@line 1124 "numbers.cpp"
    var $arrayidx2=(($ph_digits)&4294967295); //@line 1125 "numbers.cpp"
    HEAP8[($arrayidx2)]=0; //@line 1125 "numbers.cpp"
    var $arrayidx3=(($ph_and)&4294967295); //@line 1126 "numbers.cpp"
    HEAP8[($arrayidx3)]=0; //@line 1126 "numbers.cpp"
    var $2=$control_addr; //@line 1128 "numbers.cpp"
    var $and=($2) & 32; //@line 1128 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 1128 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1128 "numbers.cpp"
    if (__label__ == 1) {
  
      $ord_type=113; //@line 1130 "numbers.cpp"
      ; //@line 1131 "numbers.cpp"
    }
  
    var $3=$control_addr; //@line 1133 "numbers.cpp"
    var $and4=($3) & 2; //@line 1133 "numbers.cpp"
    var $tobool5=((($and4))|0)!=0; //@line 1133 "numbers.cpp"
    var $4=HEAP32[((__ZL14n_digit_lookup)>>2)]; //@line 1133 "numbers.cpp"
    var $cmp=((($4))|0)==2; //@line 1133 "numbers.cpp"
    var $or_cond=($tobool5) & ($cmp); //@line 1133 "numbers.cpp"
    if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 1133 "numbers.cpp"
    $if_then6$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $5=$ph_out_addr; //@line 1136 "numbers.cpp"
        var $6=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1136 "numbers.cpp"
        var $call=_strcpy($5, $6); //@line 1136 "numbers.cpp"
        ; //@line 1137 "numbers.cpp"
      }
      else if (__label__ == 4) {
  
        var $7=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1140 "numbers.cpp"
        var $arrayidx7=(($7)&4294967295); //@line 1140 "numbers.cpp"
        var $8=HEAP8[($arrayidx7)]; //@line 1140 "numbers.cpp"
        var $conv=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 1140 "numbers.cpp"
        var $cmp8=((($conv))|0)==0; //@line 1140 "numbers.cpp"
        if ($cmp8) { __label__ = 5;; } else { __label__ = 23;; } //@line 1140 "numbers.cpp"
        $if_then9$$if_end72$8: do { 
          if (__label__ == 5) {
  
            var $9=$control_addr; //@line 1143 "numbers.cpp"
            var $and10=($9) & 8; //@line 1143 "numbers.cpp"
            var $tobool11=((($and10))|0)!=0; //@line 1143 "numbers.cpp"
            if ($tobool11) { __label__ = 6;; } else { __label__ = 7;; } //@line 1143 "numbers.cpp"
            if (__label__ == 6) {
  
              var $arraydecay=(($string)&4294967295); //@line 1145 "numbers.cpp"
              var $10=$value_addr; //@line 1145 "numbers.cpp"
              var $call13=_sprintf($arraydecay, ((__str23320)&4294967295), allocate([$10,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1145 "numbers.cpp"
              var $11=$tr_addr; //@line 1146 "numbers.cpp"
              var $arraydecay14=(($string)&4294967295); //@line 1146 "numbers.cpp"
              var $arraydecay15=(($ph_digits)&4294967295); //@line 1146 "numbers.cpp"
              var $call16=__Z6LookupP10TranslatorPKcPc($11, $arraydecay14, $arraydecay15); //@line 1146 "numbers.cpp"
              $found=$call16; //@line 1146 "numbers.cpp"
              __lastLabel__ = 6; ; //@line 1147 "numbers.cpp"
            }
            else if (__label__ == 7) {
  
              var $12=$control_addr; //@line 1149 "numbers.cpp"
              var $and18=($12) & 1; //@line 1149 "numbers.cpp"
              var $tobool19=((($and18))|0)!=0; //@line 1149 "numbers.cpp"
              if ($tobool19) { __label__ = 8;; } else { __label__ = 14;; } //@line 1149 "numbers.cpp"
              if (__label__ == 8) {
  
                var $arraydecay21=(($ph_ordinal)&4294967295); //@line 1151 "numbers.cpp"
                var $call22=_strcpy($arraydecay21, ((__ZL11ph_ordinal2)&4294967295)); //@line 1151 "numbers.cpp"
                var $13=$control_addr; //@line 1153 "numbers.cpp"
                var $and23=($13) & 4; //@line 1153 "numbers.cpp"
                var $tobool24=((($and23))|0)!=0; //@line 1153 "numbers.cpp"
                if ($tobool24) { __label__ = 9;; } else { __label__ = 10;; } //@line 1153 "numbers.cpp"
                if (__label__ == 9) {
  
                  var $arraydecay26=(($string)&4294967295); //@line 1155 "numbers.cpp"
                  var $14=$value_addr; //@line 1155 "numbers.cpp"
                  var $15=$ord_type; //@line 1155 "numbers.cpp"
                  var $call27=_sprintf($arraydecay26, ((__str24321)&4294967295), allocate([$14,0,0,0,$15,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1155 "numbers.cpp"
                  var $16=$tr_addr; //@line 1156 "numbers.cpp"
                  var $arraydecay28=(($string)&4294967295); //@line 1156 "numbers.cpp"
                  var $arraydecay29=(($ph_digits)&4294967295); //@line 1156 "numbers.cpp"
                  var $call30=__Z6LookupP10TranslatorPKcPc($16, $arraydecay28, $arraydecay29); //@line 1156 "numbers.cpp"
                  $found=$call30; //@line 1156 "numbers.cpp"
                  __lastLabel__ = 9; ; //@line 1157 "numbers.cpp"
                }
                else if (__label__ == 10) {
  
                  var $_pr=$found; //@line 1158 "numbers.cpp"
                  __lastLabel__ = 10; ;
                }
  
                var $17=__lastLabel__ == 10 ? $_pr : ($call30); //@line 1158 "numbers.cpp"
                var $cmp32=((($17))|0)==0; //@line 1158 "numbers.cpp"
                if ($cmp32) { __label__ = 12;; } else { __label__ = 13;; } //@line 1158 "numbers.cpp"
                if (__label__ == 12) {
  
                  var $arraydecay34=(($string)&4294967295); //@line 1160 "numbers.cpp"
                  var $18=$value_addr; //@line 1160 "numbers.cpp"
                  var $19=$ord_type; //@line 1160 "numbers.cpp"
                  var $call35=_sprintf($arraydecay34, ((__str25322)&4294967295), allocate([$18,0,0,0,$19,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1160 "numbers.cpp"
                  var $20=$tr_addr; //@line 1161 "numbers.cpp"
                  var $arraydecay36=(($string)&4294967295); //@line 1161 "numbers.cpp"
                  var $arraydecay37=(($ph_digits)&4294967295); //@line 1161 "numbers.cpp"
                  var $call38=__Z6LookupP10TranslatorPKcPc($20, $arraydecay36, $arraydecay37); //@line 1161 "numbers.cpp"
                  $found=$call38; //@line 1161 "numbers.cpp"
                  ; //@line 1162 "numbers.cpp"
                }
  
                var $21=$found; //@line 1163 "numbers.cpp"
                $found_ordinal=$21; //@line 1163 "numbers.cpp"
                __lastLabel__ = 13; ; //@line 1164 "numbers.cpp"
              }
              else if (__label__ == 14) {
  
                var $_pr1=$found; //@line 1166 "numbers.cpp"
                __lastLabel__ = 14; ;
              }
            }
  
            var $22=__lastLabel__ == 14 ? $_pr1 : (__lastLabel__ == 13 ? $21 : ($call16)); //@line 1166 "numbers.cpp"
            var $cmp42=((($22))|0)==0; //@line 1166 "numbers.cpp"
            if (!($cmp42)) { __label__ = 23;break $if_then9$$if_end72$8; } //@line 1166 "numbers.cpp"
  
            var $23=$control_addr; //@line 1168 "numbers.cpp"
            var $and44=($23) & 2; //@line 1168 "numbers.cpp"
            var $tobool45=((($and44))|0)!=0; //@line 1168 "numbers.cpp"
            if ($tobool45) { __label__ = 17;; } else { __label__ = 19;; } //@line 1168 "numbers.cpp"
            if (__label__ == 17) {
  
              var $24=HEAP32[((__ZL14number_control)>>2)]; //@line 1171 "numbers.cpp"
              var $and47=($24) & 1; //@line 1171 "numbers.cpp"
              var $tobool48=((($and47))|0)!=0; //@line 1171 "numbers.cpp"
              if ($tobool48) { __label__ = 18;; } else { __label__ = 20;; } //@line 1171 "numbers.cpp"
              if (__label__ == 18) {
  
                var $arraydecay50=(($string)&4294967295); //@line 1174 "numbers.cpp"
                var $25=$value_addr; //@line 1174 "numbers.cpp"
                var $call51=_sprintf($arraydecay50, ((__str26323)&4294967295), allocate([$25,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1174 "numbers.cpp"
                var $26=$tr_addr; //@line 1175 "numbers.cpp"
                var $arraydecay52=(($string)&4294967295); //@line 1175 "numbers.cpp"
                var $arraydecay53=(($ph_digits)&4294967295); //@line 1175 "numbers.cpp"
                var $call54=__Z6LookupP10TranslatorPKcPc($26, $arraydecay52, $arraydecay53); //@line 1175 "numbers.cpp"
                $found=$call54; //@line 1175 "numbers.cpp"
                __lastLabel__ = 18; ; //@line 1176 "numbers.cpp"
              }
              else if (__label__ == 20) {
  
                var $_pr2=$found; //@line 1185 "numbers.cpp"
                __lastLabel__ = 20; ;
              }
            }
            else if (__label__ == 19) {
  
              var $arraydecay57=(($string)&4294967295); //@line 1181 "numbers.cpp"
              var $27=$value_addr; //@line 1181 "numbers.cpp"
              var $call58=_sprintf($arraydecay57, ((__str27324)&4294967295), allocate([$27,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1181 "numbers.cpp"
              var $28=$tr_addr; //@line 1182 "numbers.cpp"
              var $arraydecay59=(($string)&4294967295); //@line 1182 "numbers.cpp"
              var $arraydecay60=(($ph_digits)&4294967295); //@line 1182 "numbers.cpp"
              var $call61=__Z6LookupP10TranslatorPKcPc($28, $arraydecay59, $arraydecay60); //@line 1182 "numbers.cpp"
              $found=$call61; //@line 1182 "numbers.cpp"
              __lastLabel__ = 19; ;
            }
  
            var $29=__lastLabel__ == 20 ? $_pr2 : (__lastLabel__ == 18 ? $call54 : ($call61)); //@line 1185 "numbers.cpp"
            var $tobool63=((($29))|0)!=0; //@line 1185 "numbers.cpp"
            if ($tobool63) { __label__ = 23;break $if_then9$$if_end72$8; } //@line 1185 "numbers.cpp"
  
            var $arraydecay65=(($string)&4294967295); //@line 1187 "numbers.cpp"
            var $30=$value_addr; //@line 1187 "numbers.cpp"
            var $call66=_sprintf($arraydecay65, ((__str28325)&4294967295), allocate([$30,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1187 "numbers.cpp"
            var $31=$tr_addr; //@line 1188 "numbers.cpp"
            var $arraydecay67=(($string)&4294967295); //@line 1188 "numbers.cpp"
            var $arraydecay68=(($ph_digits)&4294967295); //@line 1188 "numbers.cpp"
            var $call69=__Z6LookupP10TranslatorPKcPc($31, $arraydecay67, $arraydecay68); //@line 1188 "numbers.cpp"
            $found=$call69; //@line 1188 "numbers.cpp"
            ; //@line 1189 "numbers.cpp"
          }
        } while(0);
  
        var $32=$control_addr; //@line 1195 "numbers.cpp"
        var $and73=($32) & 16; //@line 1195 "numbers.cpp"
        var $tobool74=((($and73))|0)!=0; //@line 1195 "numbers.cpp"
        if ($tobool74) { __label__ = 24;; } else { __label__ = 26;; } //@line 1195 "numbers.cpp"
        $land_lhs_true75$$if_else80$34: do { 
          if (__label__ == 24) {
  
            var $33=$value_addr; //@line 1195 "numbers.cpp"
            var $cmp76=((($33))|0) < 10; //@line 1195 "numbers.cpp"
            if (!($cmp76)) { __label__ = 26;break $land_lhs_true75$$if_else80$34; } //@line 1195 "numbers.cpp"
  
            var $34=$tr_addr; //@line 1198 "numbers.cpp"
            var $arraydecay78=(($ph_tens)&4294967295); //@line 1198 "numbers.cpp"
            var $call79=__Z6LookupP10TranslatorPKcPc($34, ((__str16313)&4294967295), $arraydecay78); //@line 1198 "numbers.cpp"
            __label__ = 61;break $land_lhs_true75$$if_else80$34; //@line 1199 "numbers.cpp"
          }
        } while(0);
        $if_end221$$if_else80$37: do { 
          if (__label__ == 26) {
  
            var $35=$found; //@line 1202 "numbers.cpp"
            var $tobool81=((($35))|0)!=0; //@line 1202 "numbers.cpp"
            if ($tobool81) { __label__ = 27;; } else { __label__ = 28;; } //@line 1202 "numbers.cpp"
            if (__label__ == 27) {
  
              var $arrayidx83=(($ph_tens)&4294967295); //@line 1204 "numbers.cpp"
              HEAP8[($arrayidx83)]=0; //@line 1204 "numbers.cpp"
              ; //@line 1205 "numbers.cpp"
            }
            else if (__label__ == 28) {
  
              var $36=$control_addr; //@line 1209 "numbers.cpp"
              var $and85=($36) & 1; //@line 1209 "numbers.cpp"
              var $tobool86=((($and85))|0)!=0; //@line 1209 "numbers.cpp"
              if ($tobool86) { __label__ = 29;; } else { __label__ = 36;; } //@line 1209 "numbers.cpp"
              $land_lhs_true87$$if_end114$42: do { 
                if (__label__ == 29) {
  
                  var $37=$units; //@line 1209 "numbers.cpp"
                  var $cmp88=((($37))|0)==0; //@line 1209 "numbers.cpp"
                  if ($cmp88) { __label__ = 32;; } else { __label__ = 30;; } //@line 1209 "numbers.cpp"
                  $if_then95$$lor_lhs_false$44: do { 
                    if (__label__ == 30) {
  
                      var $38=$tr_addr; //@line 1209 "numbers.cpp"
                      var $langopts=(($38)&4294967295); //@line 1209 "numbers.cpp"
                      var $numbers=(($langopts+184)&4294967295); //@line 1209 "numbers.cpp"
                      var $39=HEAP32[(($numbers)>>2)]; //@line 1209 "numbers.cpp"
                      var $and89=($39) & 16; //@line 1209 "numbers.cpp"
                      var $tobool90=((($and89))|0)!=0; //@line 1209 "numbers.cpp"
                      if ($tobool90) { __label__ = 32;break $if_then95$$lor_lhs_false$44; } //@line 1209 "numbers.cpp"
  
                      var $40=$tr_addr; //@line 1209 "numbers.cpp"
                      var $langopts92=(($40)&4294967295); //@line 1209 "numbers.cpp"
                      var $numbers2=(($langopts92+188)&4294967295); //@line 1209 "numbers.cpp"
                      var $41=HEAP32[(($numbers2)>>2)]; //@line 1209 "numbers.cpp"
                      var $and93=($41) & 4096; //@line 1209 "numbers.cpp"
                      var $tobool94=((($and93))|0)!=0; //@line 1209 "numbers.cpp"
                      if (!($tobool94)) { __label__ = 36;break $land_lhs_true87$$if_end114$42; } //@line 1209 "numbers.cpp"
                    }
                  } while(0);
  
                  var $arraydecay96=(($string)&4294967295); //@line 1212 "numbers.cpp"
                  var $42=$tens; //@line 1212 "numbers.cpp"
                  var $43=$ord_type; //@line 1212 "numbers.cpp"
                  var $call97=_sprintf($arraydecay96, ((__str29326)&4294967295), allocate([$42,0,0,0,$43,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1212 "numbers.cpp"
                  var $44=$tr_addr; //@line 1213 "numbers.cpp"
                  var $arraydecay98=(($string)&4294967295); //@line 1213 "numbers.cpp"
                  var $arraydecay99=(($ph_tens)&4294967295); //@line 1213 "numbers.cpp"
                  var $call100=__Z6LookupP10TranslatorPKcPc($44, $arraydecay98, $arraydecay99); //@line 1213 "numbers.cpp"
                  var $cmp101=((($call100))|0)!=0; //@line 1213 "numbers.cpp"
                  if (!($cmp101)) { __label__ = 36;break $land_lhs_true87$$if_end114$42; } //@line 1213 "numbers.cpp"
  
                  $found_ordinal=1; //@line 1215 "numbers.cpp"
                  var $45=$units; //@line 1217 "numbers.cpp"
                  var $cmp103=((($45))|0)!=0; //@line 1217 "numbers.cpp"
                  if (!($cmp103)) { __label__ = 38;break $land_lhs_true87$$if_end114$42; } //@line 1217 "numbers.cpp"
  
                  var $46=$tr_addr; //@line 1217 "numbers.cpp"
                  var $langopts105=(($46)&4294967295); //@line 1217 "numbers.cpp"
                  var $numbers2106=(($langopts105+188)&4294967295); //@line 1217 "numbers.cpp"
                  var $47=HEAP32[(($numbers2106)>>2)]; //@line 1217 "numbers.cpp"
                  var $and107=($47) & 4096; //@line 1217 "numbers.cpp"
                  var $tobool108=((($and107))|0)!=0; //@line 1217 "numbers.cpp"
                  if (!($tobool108)) { __label__ = 36;break $land_lhs_true87$$if_end114$42; } //@line 1217 "numbers.cpp"
  
                  var $arraydecay110=(($ph_tens)&4294967295); //@line 1220 "numbers.cpp"
                  var $call111=_strcat($arraydecay110, ((__ZL11ph_ordinal2)&4294967295)); //@line 1220 "numbers.cpp"
                  __label__ = 36;break $land_lhs_true87$$if_end114$42; //@line 1221 "numbers.cpp"
                }
              } while(0);
              $if_end114$$if_end122$51: do { 
                if (__label__ == 36) {
  
                  var $_pr3=$found_ordinal; //@line 1224 "numbers.cpp"
                  var $cmp115=((($_pr3))|0)==0; //@line 1224 "numbers.cpp"
                  if (!($cmp115)) { __label__ = 38;break $if_end114$$if_end122$51; } //@line 1224 "numbers.cpp"
  
                  var $arraydecay117=(($string)&4294967295); //@line 1226 "numbers.cpp"
                  var $48=$tens; //@line 1226 "numbers.cpp"
                  var $call118=_sprintf($arraydecay117, ((__str30327)&4294967295), allocate([$48,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1226 "numbers.cpp"
                  var $49=$tr_addr; //@line 1227 "numbers.cpp"
                  var $arraydecay119=(($string)&4294967295); //@line 1227 "numbers.cpp"
                  var $arraydecay120=(($ph_tens)&4294967295); //@line 1227 "numbers.cpp"
                  var $call121=__Z6LookupP10TranslatorPKcPc($49, $arraydecay119, $arraydecay120); //@line 1227 "numbers.cpp"
                  ; //@line 1228 "numbers.cpp"
                }
              } while(0);
  
              var $arrayidx123=(($ph_tens)&4294967295); //@line 1230 "numbers.cpp"
              var $50=HEAP8[($arrayidx123)]; //@line 1230 "numbers.cpp"
              var $conv124=(tempInt=(($50)),(tempInt>=128?tempInt-256:tempInt)); //@line 1230 "numbers.cpp"
              var $cmp125=((($conv124))|0)==0; //@line 1230 "numbers.cpp"
              if ($cmp125) { __label__ = 39;; } else { __label__ = 41;; } //@line 1230 "numbers.cpp"
              $land_lhs_true126$$if_end139$55: do { 
                if (__label__ == 39) {
  
                  var $51=$tr_addr; //@line 1230 "numbers.cpp"
                  var $langopts127=(($51)&4294967295); //@line 1230 "numbers.cpp"
                  var $numbers128=(($langopts127+184)&4294967295); //@line 1230 "numbers.cpp"
                  var $52=HEAP32[(($numbers128)>>2)]; //@line 1230 "numbers.cpp"
                  var $and129=($52) & 1048576; //@line 1230 "numbers.cpp"
                  var $tobool130=((($and129))|0)!=0; //@line 1230 "numbers.cpp"
                  if (!($tobool130)) { __label__ = 41;break $land_lhs_true126$$if_end139$55; } //@line 1230 "numbers.cpp"
  
                  var $53=$value_addr; //@line 1233 "numbers.cpp"
                  var $rem132=((($53))|0)%20; //@line 1233 "numbers.cpp"
                  $units=$rem132; //@line 1233 "numbers.cpp"
                  var $arraydecay133=(($string)&4294967295); //@line 1234 "numbers.cpp"
                  var $54=$tens; //@line 1234 "numbers.cpp"
                  var $and134=($54) & 254; //@line 1234 "numbers.cpp"
                  var $call135=_sprintf($arraydecay133, ((__str30327)&4294967295), allocate([$and134,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1234 "numbers.cpp"
                  var $55=$tr_addr; //@line 1235 "numbers.cpp"
                  var $arraydecay136=(($string)&4294967295); //@line 1235 "numbers.cpp"
                  var $arraydecay137=(($ph_tens)&4294967295); //@line 1235 "numbers.cpp"
                  var $call138=__Z6LookupP10TranslatorPKcPc($55, $arraydecay136, $arraydecay137); //@line 1235 "numbers.cpp"
                  ; //@line 1236 "numbers.cpp"
                }
              } while(0);
  
              var $arrayidx140=(($ph_digits)&4294967295); //@line 1238 "numbers.cpp"
              HEAP8[($arrayidx140)]=0; //@line 1238 "numbers.cpp"
              var $56=$units; //@line 1239 "numbers.cpp"
              var $cmp141=((($56))|0) > 0; //@line 1239 "numbers.cpp"
              if (!($cmp141)) { __label__ = 61;break $if_end221$$if_else80$37; } //@line 1239 "numbers.cpp"
  
              $found=0; //@line 1241 "numbers.cpp"
              var $57=$control_addr; //@line 1243 "numbers.cpp"
              var $and143=($57) & 2; //@line 1243 "numbers.cpp"
              var $tobool144=((($and143))|0)!=0; //@line 1243 "numbers.cpp"
              if ($tobool144) { __label__ = 43;; } else { __label__ = 45;; } //@line 1243 "numbers.cpp"
              $land_lhs_true145$$if_else153$60: do { 
                if (__label__ == 43) {
  
                  var $58=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1243 "numbers.cpp"
                  var $arrayidx146=(($58)&4294967295); //@line 1243 "numbers.cpp"
                  var $59=HEAP8[($arrayidx146)]; //@line 1243 "numbers.cpp"
                  var $conv147=(tempInt=(($59)),(tempInt>=128?tempInt-256:tempInt)); //@line 1243 "numbers.cpp"
                  var $cmp148=((($conv147))|0)!=0; //@line 1243 "numbers.cpp"
                  if (!($cmp148)) { __label__ = 45;break $land_lhs_true145$$if_else153$60; } //@line 1243 "numbers.cpp"
  
                  var $arraydecay150=(($ph_digits)&4294967295); //@line 1246 "numbers.cpp"
                  var $60=HEAP32[((__ZL12digit_lookup)>>2)]; //@line 1246 "numbers.cpp"
                  var $call151=_strcpy($arraydecay150, $60); //@line 1246 "numbers.cpp"
                  $found_ordinal=1; //@line 1247 "numbers.cpp"
                  var $arrayidx152=(($ph_ordinal)&4294967295); //@line 1248 "numbers.cpp"
                  HEAP8[($arrayidx152)]=0; //@line 1248 "numbers.cpp"
                  __label__ = 61;break $if_end221$$if_else80$37; //@line 1249 "numbers.cpp"
                }
              } while(0);
  
              var $61=$control_addr; //@line 1252 "numbers.cpp"
              var $and154=($61) & 8; //@line 1252 "numbers.cpp"
              var $tobool155=((($and154))|0)!=0; //@line 1252 "numbers.cpp"
              if ($tobool155) { __label__ = 46;; } else { __label__ = 47;; } //@line 1252 "numbers.cpp"
              if (__label__ == 46) {
  
                var $arraydecay157=(($string)&4294967295); //@line 1255 "numbers.cpp"
                var $62=$units; //@line 1255 "numbers.cpp"
                var $call158=_sprintf($arraydecay157, ((__str23320)&4294967295), allocate([$62,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1255 "numbers.cpp"
                var $63=$tr_addr; //@line 1256 "numbers.cpp"
                var $arraydecay159=(($string)&4294967295); //@line 1256 "numbers.cpp"
                var $arraydecay160=(($ph_digits)&4294967295); //@line 1256 "numbers.cpp"
                var $call161=__Z6LookupP10TranslatorPKcPc($63, $arraydecay159, $arraydecay160); //@line 1256 "numbers.cpp"
                $found=$call161; //@line 1256 "numbers.cpp"
                ; //@line 1257 "numbers.cpp"
              }
  
              var $64=$control_addr; //@line 1258 "numbers.cpp"
              var $and163=($64) & 1; //@line 1258 "numbers.cpp"
              var $tobool164=((($and163))|0)!=0; //@line 1258 "numbers.cpp"
              if ($tobool164) { __label__ = 48;; } else { __label__ = 51;; } //@line 1258 "numbers.cpp"
              $land_lhs_true165$$if_end179$67: do { 
                if (__label__ == 48) {
  
                  var $65=$tr_addr; //@line 1258 "numbers.cpp"
                  var $langopts166=(($65)&4294967295); //@line 1258 "numbers.cpp"
                  var $numbers167=(($langopts166+184)&4294967295); //@line 1258 "numbers.cpp"
                  var $66=HEAP32[(($numbers167)>>2)]; //@line 1258 "numbers.cpp"
                  var $and168=($66) & 16; //@line 1258 "numbers.cpp"
                  var $cmp169=((($and168))|0)==0; //@line 1258 "numbers.cpp"
                  if (!($cmp169)) { __label__ = 51;break $land_lhs_true165$$if_end179$67; } //@line 1258 "numbers.cpp"
  
                  var $arraydecay171=(($string)&4294967295); //@line 1261 "numbers.cpp"
                  var $67=$units; //@line 1261 "numbers.cpp"
                  var $68=$ord_type; //@line 1261 "numbers.cpp"
                  var $call172=_sprintf($arraydecay171, ((__str25322)&4294967295), allocate([$67,0,0,0,$68,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1261 "numbers.cpp"
                  var $69=$tr_addr; //@line 1262 "numbers.cpp"
                  var $arraydecay173=(($string)&4294967295); //@line 1262 "numbers.cpp"
                  var $arraydecay174=(($ph_digits)&4294967295); //@line 1262 "numbers.cpp"
                  var $call175=__Z6LookupP10TranslatorPKcPc($69, $arraydecay173, $arraydecay174); //@line 1262 "numbers.cpp"
                  $found=$call175; //@line 1262 "numbers.cpp"
                  var $cmp176=((($call175))|0)!=0; //@line 1262 "numbers.cpp"
                  if (!($cmp176)) { __label__ = 52;break $land_lhs_true165$$if_end179$67; } //@line 1262 "numbers.cpp"
  
                  $found_ordinal=1; //@line 1264 "numbers.cpp"
                  __label__ = 51;break $land_lhs_true165$$if_end179$67; //@line 1265 "numbers.cpp"
                }
              } while(0);
              if (__label__ == 51) {
  
                var $_pr5=$found; //@line 1267 "numbers.cpp"
                var $cmp180=((($_pr5))|0)==0; //@line 1267 "numbers.cpp"
                if (!($cmp180)) { __label__ = 61;break $if_end221$$if_else80$37; } //@line 1267 "numbers.cpp"
              }
  
              var $70=HEAP32[((__ZL14number_control)>>2)]; //@line 1269 "numbers.cpp"
              var $and182=($70) & 1; //@line 1269 "numbers.cpp"
              var $tobool183=((($and182))|0)!=0; //@line 1269 "numbers.cpp"
              if ($tobool183) { __label__ = 53;; } else { __label__ = 55;; } //@line 1269 "numbers.cpp"
              $land_lhs_true184$$if_else193$74: do { 
                if (__label__ == 53) {
  
                  var $71=$control_addr; //@line 1269 "numbers.cpp"
                  var $and185=($71) & 2; //@line 1269 "numbers.cpp"
                  var $tobool186=((($and185))|0)!=0; //@line 1269 "numbers.cpp"
                  if (!($tobool186)) { __label__ = 55;break $land_lhs_true184$$if_else193$74; } //@line 1269 "numbers.cpp"
  
                  var $arraydecay188=(($string)&4294967295); //@line 1272 "numbers.cpp"
                  var $72=$units; //@line 1272 "numbers.cpp"
                  var $call189=_sprintf($arraydecay188, ((__str26323)&4294967295), allocate([$72,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1272 "numbers.cpp"
                  var $73=$tr_addr; //@line 1273 "numbers.cpp"
                  var $arraydecay190=(($string)&4294967295); //@line 1273 "numbers.cpp"
                  var $arraydecay191=(($ph_digits)&4294967295); //@line 1273 "numbers.cpp"
                  var $call192=__Z6LookupP10TranslatorPKcPc($73, $arraydecay190, $arraydecay191); //@line 1273 "numbers.cpp"
                  $found=$call192; //@line 1273 "numbers.cpp"
                  __lastLabel__ = 54; __label__ = 59;break $land_lhs_true184$$if_else193$74; //@line 1274 "numbers.cpp"
                }
              } while(0);
              $if_end209$$if_else193$77: do { 
                if (__label__ == 55) {
  
                  var $74=$control_addr; //@line 1276 "numbers.cpp"
                  var $and194=($74) & 2; //@line 1276 "numbers.cpp"
                  var $cmp195=((($and194))|0)==0; //@line 1276 "numbers.cpp"
                  if ($cmp195) { __label__ = 57;; } else { __label__ = 56;; } //@line 1276 "numbers.cpp"
                  $if_then201$$lor_lhs_false196$79: do { 
                    if (__label__ == 56) {
  
                      var $75=$tr_addr; //@line 1276 "numbers.cpp"
                      var $langopts197=(($75)&4294967295); //@line 1276 "numbers.cpp"
                      var $numbers198=(($langopts197+184)&4294967295); //@line 1276 "numbers.cpp"
                      var $76=HEAP32[(($numbers198)>>2)]; //@line 1276 "numbers.cpp"
                      var $and199=($76) & 16; //@line 1276 "numbers.cpp"
                      var $cmp200=((($and199))|0)!=0; //@line 1276 "numbers.cpp"
                      if ($cmp200) { __label__ = 57;break $if_then201$$lor_lhs_false196$79; } //@line 1276 "numbers.cpp"
  
                      var $_pr7=$found; //@line 1283 "numbers.cpp"
                      __lastLabel__ = 58; __label__ = 59;break $if_end209$$if_else193$77;
                    }
                  } while(0);
  
                  var $arraydecay202=(($string)&4294967295); //@line 1279 "numbers.cpp"
                  var $77=$units; //@line 1279 "numbers.cpp"
                  var $call203=_sprintf($arraydecay202, ((__str27324)&4294967295), allocate([$77,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1279 "numbers.cpp"
                  var $78=$tr_addr; //@line 1280 "numbers.cpp"
                  var $arraydecay204=(($string)&4294967295); //@line 1280 "numbers.cpp"
                  var $arraydecay205=(($ph_digits)&4294967295); //@line 1280 "numbers.cpp"
                  var $call206=__Z6LookupP10TranslatorPKcPc($78, $arraydecay204, $arraydecay205); //@line 1280 "numbers.cpp"
                  $found=$call206; //@line 1280 "numbers.cpp"
                  __lastLabel__ = 57; ; //@line 1281 "numbers.cpp"
                }
              } while(0);
  
              var $79=__lastLabel__ == 58 ? $_pr7 : (__lastLabel__ == 54 ? $call192 : ($call206)); //@line 1283 "numbers.cpp"
              var $cmp210=((($79))|0)==0; //@line 1283 "numbers.cpp"
              if (!($cmp210)) { __label__ = 61;break $if_end221$$if_else80$37; } //@line 1283 "numbers.cpp"
  
              var $arraydecay212=(($string)&4294967295); //@line 1285 "numbers.cpp"
              var $80=$units; //@line 1285 "numbers.cpp"
              var $call213=_sprintf($arraydecay212, ((__str28325)&4294967295), allocate([$80,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1285 "numbers.cpp"
              var $81=$tr_addr; //@line 1286 "numbers.cpp"
              var $arraydecay214=(($string)&4294967295); //@line 1286 "numbers.cpp"
              var $arraydecay215=(($ph_digits)&4294967295); //@line 1286 "numbers.cpp"
              var $call216=__Z6LookupP10TranslatorPKcPc($81, $arraydecay214, $arraydecay215); //@line 1286 "numbers.cpp"
              ; //@line 1287 "numbers.cpp"
            }
          }
        } while(0);
  
        var $82=$control_addr; //@line 1293 "numbers.cpp"
        var $and222=($82) & 1; //@line 1293 "numbers.cpp"
        var $tobool223=((($and222))|0)!=0; //@line 1293 "numbers.cpp"
        if ($tobool223) { __label__ = 62;; } else { __label__ = 70;; } //@line 1293 "numbers.cpp"
        $land_lhs_true224$$if_end251$86: do { 
          if (__label__ == 62) {
  
            var $83=$found_ordinal; //@line 1293 "numbers.cpp"
            var $cmp225=((($83))|0)==0; //@line 1293 "numbers.cpp"
            if (!($cmp225)) { __label__ = 70;break $land_lhs_true224$$if_end251$86; } //@line 1293 "numbers.cpp"
  
            var $arrayidx227=(($ph_ordinal)&4294967295); //@line 1293 "numbers.cpp"
            var $84=HEAP8[($arrayidx227)]; //@line 1293 "numbers.cpp"
            var $conv228=(tempInt=(($84)),(tempInt>=128?tempInt-256:tempInt)); //@line 1293 "numbers.cpp"
            var $cmp229=((($conv228))|0)==0; //@line 1293 "numbers.cpp"
            if (!($cmp229)) { __label__ = 70;break $land_lhs_true224$$if_end251$86; } //@line 1293 "numbers.cpp"
  
            var $85=$value_addr; //@line 1295 "numbers.cpp"
            var $cmp231=((($85))|0) >= 20; //@line 1295 "numbers.cpp"
            if ($cmp231) { __label__ = 65;; } else { __label__ = 68;; } //@line 1295 "numbers.cpp"
            $land_lhs_true232$$if_end243$90: do { 
              if (__label__ == 65) {
  
                var $86=$value_addr; //@line 1295 "numbers.cpp"
                var $rem233=((($86))|0)%10; //@line 1295 "numbers.cpp"
                var $cmp234=((($rem233))|0)==0; //@line 1295 "numbers.cpp"
                if ($cmp234) { __label__ = 67;; } else { __label__ = 66;; } //@line 1295 "numbers.cpp"
                if (__label__ == 66) {
  
                  var $87=$tr_addr; //@line 1295 "numbers.cpp"
                  var $langopts236=(($87)&4294967295); //@line 1295 "numbers.cpp"
                  var $numbers237=(($langopts236+184)&4294967295); //@line 1295 "numbers.cpp"
                  var $88=HEAP32[(($numbers237)>>2)]; //@line 1295 "numbers.cpp"
                  var $and238=($88) & 16; //@line 1295 "numbers.cpp"
                  var $tobool239=((($and238))|0)!=0; //@line 1295 "numbers.cpp"
                  if (!($tobool239)) { __label__ = 68;break $land_lhs_true232$$if_end243$90; } //@line 1295 "numbers.cpp"
                }
  
                var $89=$tr_addr; //@line 1296 "numbers.cpp"
                var $arraydecay241=(($ph_ordinal)&4294967295); //@line 1296 "numbers.cpp"
                var $call242=__Z6LookupP10TranslatorPKcPc($89, ((__str31328)&4294967295), $arraydecay241); //@line 1296 "numbers.cpp"
                ; //@line 1296 "numbers.cpp"
              }
            } while(0);
  
            var $arrayidx244=(($ph_ordinal)&4294967295); //@line 1297 "numbers.cpp"
            var $90=HEAP8[($arrayidx244)]; //@line 1297 "numbers.cpp"
            var $conv245=(tempInt=(($90)),(tempInt>=128?tempInt-256:tempInt)); //@line 1297 "numbers.cpp"
            var $cmp246=((($conv245))|0)==0; //@line 1297 "numbers.cpp"
            if (!($cmp246)) { __label__ = 70;break $land_lhs_true224$$if_end251$86; } //@line 1297 "numbers.cpp"
  
            var $91=$tr_addr; //@line 1298 "numbers.cpp"
            var $arraydecay248=(($ph_ordinal)&4294967295); //@line 1298 "numbers.cpp"
            var $call249=__Z6LookupP10TranslatorPKcPc($91, ((__str32329)&4294967295), $arraydecay248); //@line 1298 "numbers.cpp"
            ; //@line 1298 "numbers.cpp"
          }
        } while(0);
  
        var $92=$tr_addr; //@line 1301 "numbers.cpp"
        var $langopts252=(($92)&4294967295); //@line 1301 "numbers.cpp"
        var $numbers253=(($langopts252+184)&4294967295); //@line 1301 "numbers.cpp"
        var $93=HEAP32[(($numbers253)>>2)]; //@line 1301 "numbers.cpp"
        var $and254=($93) & 48; //@line 1301 "numbers.cpp"
        var $tobool255=((($and254))|0)!=0; //@line 1301 "numbers.cpp"
        if ($tobool255) { __label__ = 71;; } else { __label__ = 79;; } //@line 1301 "numbers.cpp"
        $land_lhs_true256$$if_else291$98: do { 
          if (__label__ == 71) {
  
            var $arrayidx257=(($ph_tens)&4294967295); //@line 1301 "numbers.cpp"
            var $94=HEAP8[($arrayidx257)]; //@line 1301 "numbers.cpp"
            var $conv258=(tempInt=(($94)),(tempInt>=128?tempInt-256:tempInt)); //@line 1301 "numbers.cpp"
            var $cmp259=((($conv258))|0)!=0; //@line 1301 "numbers.cpp"
            if (!($cmp259)) { __label__ = 79;break $land_lhs_true256$$if_else291$98; } //@line 1301 "numbers.cpp"
  
            var $arrayidx261=(($ph_digits)&4294967295); //@line 1301 "numbers.cpp"
            var $95=HEAP8[($arrayidx261)]; //@line 1301 "numbers.cpp"
            var $conv262=(tempInt=(($95)),(tempInt>=128?tempInt-256:tempInt)); //@line 1301 "numbers.cpp"
            var $cmp263=((($conv262))|0)!=0; //@line 1301 "numbers.cpp"
            if (!($cmp263)) { __label__ = 79;break $land_lhs_true256$$if_else291$98; } //@line 1301 "numbers.cpp"
  
            var $96=$tr_addr; //@line 1303 "numbers.cpp"
            var $arraydecay265=(($ph_and)&4294967295); //@line 1303 "numbers.cpp"
            var $call266=__Z6LookupP10TranslatorPKcPc($96, ((__str33330)&4294967295), $arraydecay265); //@line 1303 "numbers.cpp"
            var $97=$tr_addr; //@line 1305 "numbers.cpp"
            var $langopts267=(($97)&4294967295); //@line 1305 "numbers.cpp"
            var $numbers2268=(($langopts267+188)&4294967295); //@line 1305 "numbers.cpp"
            var $98=HEAP32[(($numbers2268)>>2)]; //@line 1305 "numbers.cpp"
            var $and269=($98) & 4096; //@line 1305 "numbers.cpp"
            var $tobool270=((($and269))|0)!=0; //@line 1305 "numbers.cpp"
            if ($tobool270) { __label__ = 74;; } else { __label__ = 75;; } //@line 1305 "numbers.cpp"
            if (__label__ == 74) {
  
              var $arrayidx272=(($ph_and)&4294967295); //@line 1306 "numbers.cpp"
              HEAP8[($arrayidx272)]=0; //@line 1306 "numbers.cpp"
              ; //@line 1306 "numbers.cpp"
            }
  
            var $99=$tr_addr; //@line 1308 "numbers.cpp"
            var $langopts274=(($99)&4294967295); //@line 1308 "numbers.cpp"
            var $numbers275=(($langopts274+184)&4294967295); //@line 1308 "numbers.cpp"
            var $100=HEAP32[(($numbers275)>>2)]; //@line 1308 "numbers.cpp"
            var $and276=($100) & 16; //@line 1308 "numbers.cpp"
            var $tobool277=((($and276))|0)!=0; //@line 1308 "numbers.cpp"
            var $101=$ph_out_addr; //@line 1309 "numbers.cpp"
            if ($tobool277) { __label__ = 76;; } else { __label__ = 77;; } //@line 1308 "numbers.cpp"
            if (__label__ == 76) {
  
              var $arraydecay279=(($ph_digits)&4294967295); //@line 1309 "numbers.cpp"
              var $arraydecay280=(($ph_and)&4294967295); //@line 1309 "numbers.cpp"
              var $arraydecay281=(($ph_tens)&4294967295); //@line 1309 "numbers.cpp"
              var $arraydecay282=(($ph_ordinal)&4294967295); //@line 1309 "numbers.cpp"
              var $call283=_sprintf($101, ((__str20317)&4294967295), allocate([$arraydecay279,0,0,0,$arraydecay280,0,0,0,$arraydecay281,0,0,0,$arraydecay282,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1309 "numbers.cpp"
              ; //@line 1309 "numbers.cpp"
            }
            else if (__label__ == 77) {
  
              var $arraydecay285=(($ph_tens)&4294967295); //@line 1311 "numbers.cpp"
              var $arraydecay286=(($ph_and)&4294967295); //@line 1311 "numbers.cpp"
              var $arraydecay287=(($ph_digits)&4294967295); //@line 1311 "numbers.cpp"
              var $arraydecay288=(($ph_ordinal)&4294967295); //@line 1311 "numbers.cpp"
              var $call289=_sprintf($101, ((__str20317)&4294967295), allocate([$arraydecay285,0,0,0,$arraydecay286,0,0,0,$arraydecay287,0,0,0,$arraydecay288,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1311 "numbers.cpp"
              ;
            }
  
            $used_and=1; //@line 1312 "numbers.cpp"
            __label__ = 88;break $if_then6$$if_else$5; //@line 1313 "numbers.cpp"
          }
        } while(0);
  
        var $102=$tr_addr; //@line 1316 "numbers.cpp"
        var $langopts292=(($102)&4294967295); //@line 1316 "numbers.cpp"
        var $numbers293=(($langopts292+184)&4294967295); //@line 1316 "numbers.cpp"
        var $103=HEAP32[(($numbers293)>>2)]; //@line 1316 "numbers.cpp"
        var $and294=($103) & 512; //@line 1316 "numbers.cpp"
        var $tobool295=((($and294))|0)!=0; //@line 1316 "numbers.cpp"
        if ($tobool295) { __label__ = 80;; } else { __label__ = 87;; } //@line 1316 "numbers.cpp"
        $if_then296$$if_end329$110: do { 
          if (__label__ == 80) {
  
            var $arraydecay297=(($ph_tens)&4294967295); //@line 1319 "numbers.cpp"
            var $call298=_strlen($arraydecay297); //@line 1319 "numbers.cpp"
            var $sub=((($call298)-1)&4294967295); //@line 1319 "numbers.cpp"
            $ix=$sub; //@line 1319 "numbers.cpp"
            var $cmp299=((($sub))|0) >= 0; //@line 1319 "numbers.cpp"
            if (!($cmp299)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1319 "numbers.cpp"
  
            var $arrayidx301=(($ph_digits)&4294967295); //@line 1319 "numbers.cpp"
            var $104=HEAP8[($arrayidx301)]; //@line 1319 "numbers.cpp"
            var $conv302=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt)); //@line 1319 "numbers.cpp"
            var $cmp303=((($conv302))|0)!=0; //@line 1319 "numbers.cpp"
            if (!($cmp303)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1319 "numbers.cpp"
  
            var $arrayidx305=(($ph_digits)&4294967295); //@line 1321 "numbers.cpp"
            var $105=HEAP8[($arrayidx305)]; //@line 1321 "numbers.cpp"
            var $conv306=(tempInt=(($105)),(tempInt>=128?tempInt-256:tempInt)); //@line 1321 "numbers.cpp"
            var $arrayidx307=((_phoneme_tab+$conv306*4)&4294967295); //@line 1321 "numbers.cpp"
            var $106=HEAP32[(($arrayidx307)>>2)]; //@line 1321 "numbers.cpp"
            var $type=(($106+11)&4294967295); //@line 1321 "numbers.cpp"
            var $107=HEAPU8[($type)]; //@line 1321 "numbers.cpp"
            var $conv308=((($107))&255); //@line 1321 "numbers.cpp"
            $next_phtype=$conv308; //@line 1321 "numbers.cpp"
            var $cmp309=((($conv308))|0)==1; //@line 1321 "numbers.cpp"
            if ($cmp309) { __label__ = 83;; } else { __label__ = 84;; } //@line 1321 "numbers.cpp"
            if (__label__ == 83) {
  
              var $arrayidx311=(($ph_digits+1)&4294967295); //@line 1322 "numbers.cpp"
              var $108=HEAP8[($arrayidx311)]; //@line 1322 "numbers.cpp"
              var $conv312=(tempInt=(($108)),(tempInt>=128?tempInt-256:tempInt)); //@line 1322 "numbers.cpp"
              var $arrayidx313=((_phoneme_tab+$conv312*4)&4294967295); //@line 1322 "numbers.cpp"
              var $109=HEAP32[(($arrayidx313)>>2)]; //@line 1322 "numbers.cpp"
              var $type314=(($109+11)&4294967295); //@line 1322 "numbers.cpp"
              var $110=HEAPU8[($type314)]; //@line 1322 "numbers.cpp"
              var $conv315=((($110))&255); //@line 1322 "numbers.cpp"
              $next_phtype=$conv315; //@line 1322 "numbers.cpp"
              ; //@line 1322 "numbers.cpp"
            }
  
            var $111=$ix; //@line 1324 "numbers.cpp"
            var $arrayidx317=(($ph_tens+$111)&4294967295); //@line 1324 "numbers.cpp"
            var $112=HEAP8[($arrayidx317)]; //@line 1324 "numbers.cpp"
            var $conv318=(tempInt=(($112)),(tempInt>=128?tempInt-256:tempInt)); //@line 1324 "numbers.cpp"
            var $arrayidx319=((_phoneme_tab+$conv318*4)&4294967295); //@line 1324 "numbers.cpp"
            var $113=HEAP32[(($arrayidx319)>>2)]; //@line 1324 "numbers.cpp"
            var $type320=(($113+11)&4294967295); //@line 1324 "numbers.cpp"
            var $114=HEAPU8[($type320)]; //@line 1324 "numbers.cpp"
            var $conv321=((($114))&255); //@line 1324 "numbers.cpp"
            var $cmp322=((($conv321))|0)==2; //@line 1324 "numbers.cpp"
            if (!($cmp322)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1324 "numbers.cpp"
  
            var $115=$next_phtype; //@line 1324 "numbers.cpp"
            var $cmp324=((($115))|0)==2; //@line 1324 "numbers.cpp"
            if (!($cmp324)) { __label__ = 87;break $if_then296$$if_end329$110; } //@line 1324 "numbers.cpp"
  
            var $116=$ix; //@line 1325 "numbers.cpp"
            var $arrayidx326=(($ph_tens+$116)&4294967295); //@line 1325 "numbers.cpp"
            HEAP8[($arrayidx326)]=0; //@line 1325 "numbers.cpp"
            ; //@line 1325 "numbers.cpp"
          }
        } while(0);
  
        var $117=$ph_out_addr; //@line 1328 "numbers.cpp"
        var $arraydecay330=(($ph_tens)&4294967295); //@line 1328 "numbers.cpp"
        var $arraydecay331=(($ph_digits)&4294967295); //@line 1328 "numbers.cpp"
        var $arraydecay332=(($ph_ordinal)&4294967295); //@line 1328 "numbers.cpp"
        var $call333=_sprintf($117, ((__str6549)&4294967295), allocate([$arraydecay330,0,0,0,$arraydecay331,0,0,0,$arraydecay332,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1328 "numbers.cpp"
        ;
      }
    } while(0);
  
    var $118=$tr_addr; //@line 1332 "numbers.cpp"
    var $langopts336=(($118)&4294967295); //@line 1332 "numbers.cpp"
    var $numbers337=(($langopts336+184)&4294967295); //@line 1332 "numbers.cpp"
    var $119=HEAP32[(($numbers337)>>2)]; //@line 1332 "numbers.cpp"
    var $and338=($119) & 256; //@line 1332 "numbers.cpp"
    var $tobool339=((($and338))|0)!=0; //@line 1332 "numbers.cpp"
    if ($tobool339) { __label__ = 89;; } else { __label__ = 95;; } //@line 1332 "numbers.cpp"
    $if_then340$$if_end354$121: do { 
      if (__label__ == 89) {
  
        $found=0; //@line 1335 "numbers.cpp"
        var $120=$ph_out_addr; //@line 1336 "numbers.cpp"
        var $call341=_strlen($120); //@line 1336 "numbers.cpp"
        var $sub342=((($call341)-1)&4294967295); //@line 1336 "numbers.cpp"
        $ix=$sub342; //@line 1336 "numbers.cpp"
        var $cmp3439=((($sub342))|0) >= 0; //@line 1336 "numbers.cpp"
        if (!($cmp3439)) { __label__ = 95;break $if_then340$$if_end354$121; } //@line 1336 "numbers.cpp"
        while(1) { 
  
          var $121=$ix; //@line 1338 "numbers.cpp"
          var $122=$ph_out_addr; //@line 1338 "numbers.cpp"
          var $arrayidx344=(($122+$121)&4294967295); //@line 1338 "numbers.cpp"
          var $123=HEAP8[($arrayidx344)]; //@line 1338 "numbers.cpp"
          var $conv345=(tempInt=(($123)),(tempInt>=128?tempInt-256:tempInt)); //@line 1338 "numbers.cpp"
          var $cmp346=((($conv345))|0)==6; //@line 1338 "numbers.cpp"
          if ($cmp346) { __label__ = 91;; } else { __label__ = 94;; } //@line 1338 "numbers.cpp"
          if (__label__ == 91) {
  
            var $124=$found; //@line 1340 "numbers.cpp"
            var $tobool348=((($124))|0)!=0; //@line 1340 "numbers.cpp"
            if ($tobool348) { __label__ = 92;; } else { __label__ = 93;; } //@line 1340 "numbers.cpp"
            if (__label__ == 92) {
  
              var $125=$ix; //@line 1341 "numbers.cpp"
              var $126=$ph_out_addr; //@line 1341 "numbers.cpp"
              var $arrayidx350=(($126+$125)&4294967295); //@line 1341 "numbers.cpp"
              HEAP8[($arrayidx350)]=5; //@line 1341 "numbers.cpp"
              ; //@line 1341 "numbers.cpp"
            }
            else if (__label__ == 93) {
  
              $found=1; //@line 1343 "numbers.cpp"
              ;
            }
          }
  
          var $127=$ix; //@line 1336 "numbers.cpp"
          var $dec=((($127)-1)&4294967295); //@line 1336 "numbers.cpp"
          $ix=$dec; //@line 1336 "numbers.cpp"
          var $cmp343=((($dec))|0) >= 0; //@line 1336 "numbers.cpp"
          if ($cmp343) { __label__ = 90;continue ; } else { __label__ = 95;break $if_then340$$if_end354$121; } //@line 1336 "numbers.cpp"
        }
      }
    } while(0);
  
    var $128=$used_and; //@line 1347 "numbers.cpp"
    STACKTOP = __stackBase__;
    return $128; //@line 1347 "numbers.cpp"
    return null;
  }
  

  function __ZL9M_Varianti($value) {
    ;
    var __label__;
  
    var $retval;
    var $value_addr;
    $value_addr=$value;
    var $0=HEAP32[((_translator)>>2)]; //@line 963 "numbers.cpp"
    var $langopts=(($0)&4294967295); //@line 963 "numbers.cpp"
    var $numbers2=(($langopts+188)&4294967295); //@line 963 "numbers.cpp"
    var $1=HEAP32[(($numbers2)>>2)]; //@line 963 "numbers.cpp"
    var $and=($1) & 256; //@line 963 "numbers.cpp"
    var $tobool=((($and))|0)!=0; //@line 963 "numbers.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 963 "numbers.cpp"
    $land_lhs_true$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $2=$value_addr; //@line 963 "numbers.cpp"
        var $cmp=((($2))|0) >= 2; //@line 963 "numbers.cpp"
        var $3=$value_addr; //@line 963 "numbers.cpp"
        var $cmp2=((($3))|0) <= 4; //@line 963 "numbers.cpp"
        var $or_cond=($cmp) & ($cmp2); //@line 963 "numbers.cpp"
        if (!($or_cond)) { __label__ = 3;break $land_lhs_true$$if_else$2; } //@line 963 "numbers.cpp"
  
        $retval=((__str54351)&4294967295); //@line 964 "numbers.cpp"
        __label__ = 13;break $land_lhs_true$$if_else$2; //@line 964 "numbers.cpp"
      }
    } while(0);
    $return$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $4=$value_addr; //@line 966 "numbers.cpp"
        var $rem=((($4))|0)%100; //@line 966 "numbers.cpp"
        var $cmp3=((($rem))|0) < 10; //@line 966 "numbers.cpp"
        if ($cmp3) { __label__ = 5;; } else { __label__ = 4;; } //@line 966 "numbers.cpp"
        $if_then6$$lor_lhs_false$7: do { 
          if (__label__ == 4) {
  
            var $5=$value_addr; //@line 966 "numbers.cpp"
            var $rem4=((($5))|0)%100; //@line 966 "numbers.cpp"
            var $cmp5=((($rem4))|0) > 20; //@line 966 "numbers.cpp"
            if ($cmp5) { __label__ = 5;break $if_then6$$lor_lhs_false$7; } else { __label__ = 12;break $if_then6$$lor_lhs_false$7; } //@line 966 "numbers.cpp"
          }
        } while(0);
        $if_then6$$if_end28$9: do { 
          if (__label__ == 5) {
  
            var $6=HEAP32[((_translator)>>2)]; //@line 968 "numbers.cpp"
            var $langopts7=(($6)&4294967295); //@line 968 "numbers.cpp"
            var $numbers28=(($langopts7+188)&4294967295); //@line 968 "numbers.cpp"
            var $7=HEAP32[(($numbers28)>>2)]; //@line 968 "numbers.cpp"
            var $and9=($7) & 64; //@line 968 "numbers.cpp"
            var $tobool10=((($and9))|0)!=0; //@line 968 "numbers.cpp"
            if ($tobool10) { __label__ = 6;; } else { __label__ = 9;; } //@line 968 "numbers.cpp"
            $land_lhs_true11$$if_end$11: do { 
              if (__label__ == 6) {
  
                var $8=$value_addr; //@line 968 "numbers.cpp"
                var $rem12=((($8))|0)%10; //@line 968 "numbers.cpp"
                var $cmp13=((($rem12))|0) >= 2; //@line 968 "numbers.cpp"
                if (!($cmp13)) { __label__ = 9;break $land_lhs_true11$$if_end$11; } //@line 968 "numbers.cpp"
  
                var $9=$value_addr; //@line 968 "numbers.cpp"
                var $rem15=((($9))|0)%10; //@line 968 "numbers.cpp"
                var $cmp16=((($rem15))|0) <= 4; //@line 968 "numbers.cpp"
                if (!($cmp16)) { __label__ = 9;break $land_lhs_true11$$if_end$11; } //@line 968 "numbers.cpp"
  
                $retval=((__str54351)&4294967295); //@line 973 "numbers.cpp"
                __label__ = 13;break $return$$if_else$5; //@line 973 "numbers.cpp"
              }
            } while(0);
  
            var $10=HEAP32[((_translator)>>2)]; //@line 976 "numbers.cpp"
            var $langopts18=(($10)&4294967295); //@line 976 "numbers.cpp"
            var $numbers219=(($langopts18+188)&4294967295); //@line 976 "numbers.cpp"
            var $11=HEAP32[(($numbers219)>>2)]; //@line 976 "numbers.cpp"
            var $and20=($11) & 128; //@line 976 "numbers.cpp"
            var $tobool21=((($and20))|0)!=0; //@line 976 "numbers.cpp"
            if (!($tobool21)) { __label__ = 12;break $if_then6$$if_end28$9; } //@line 976 "numbers.cpp"
  
            var $12=$value_addr; //@line 976 "numbers.cpp"
            var $rem23=((($12))|0)%10; //@line 976 "numbers.cpp"
            var $cmp24=((($rem23))|0)==1; //@line 976 "numbers.cpp"
            if (!($cmp24)) { __label__ = 12;break $if_then6$$if_end28$9; } //@line 976 "numbers.cpp"
  
            $retval=((__str55352)&4294967295); //@line 979 "numbers.cpp"
            __label__ = 13;break $return$$if_else$5; //@line 979 "numbers.cpp"
          }
        } while(0);
  
        $retval=((__str56353)&4294967295); //@line 983 "numbers.cpp"
        ; //@line 983 "numbers.cpp"
      }
    } while(0);
  
    var $13=$retval; //@line 984 "numbers.cpp"
    ;
    return $13; //@line 984 "numbers.cpp"
    return null;
  }
  

  function __Z15LoadMbrolaTablePKcS0_i($mbrola_voice, $phtrans, $srate) {
    var __stackBase__  = STACKTOP; STACKTOP += 168; _memset(__stackBase__, 0, 168);
    var __label__;
  
    var $retval;
    var $mbrola_voice_addr;
    var $phtrans_addr;
    var $srate_addr;
    var $size;
    var $ix;
    var $pw;
    var $f_in;
    var $path=__stackBase__;
    $mbrola_voice_addr=$mbrola_voice;
    $phtrans_addr=$phtrans;
    $srate_addr=$srate;
    HEAP8[(((_mbrola_name)&4294967295))]=0; //@line 124 "synth_mbrola.cpp"
    HEAP32[((_mbrola_delay)>>2)]=0; //@line 125 "synth_mbrola.cpp"
    HEAP32[((__ZL15mbr_name_prefix)>>2)]=0; //@line 126 "synth_mbrola.cpp"
    var $0=$mbrola_voice_addr; //@line 128 "synth_mbrola.cpp"
    var $cmp=((($0))|0)==0; //@line 128 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 128 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_samplerate_native)>>2)]; //@line 130 "synth_mbrola.cpp"
      HEAP32[((_samplerate)>>2)]=$1; //@line 130 "synth_mbrola.cpp"
      __Z12SetParameteriii(14, 0, 0); //@line 131 "synth_mbrola.cpp"
      $retval=0; //@line 132 "synth_mbrola.cpp"
      ; //@line 132 "synth_mbrola.cpp"
    }
    else if (__label__ == 2) {
  
      var $arraydecay=(($path)&4294967295); //@line 135 "synth_mbrola.cpp"
      var $2=$mbrola_voice_addr; //@line 135 "synth_mbrola.cpp"
      var $call=_sprintf($arraydecay, ((__str382)&4294967295), allocate([((_path_home)&4294967295),0,0,0,$2,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 135 "synth_mbrola.cpp"
      var $arraydecay1=(($path)&4294967295); //@line 139 "synth_mbrola.cpp"
      var $call2=__Z13GetFileLengthPKc($arraydecay1); //@line 139 "synth_mbrola.cpp"
      var $cmp3=((($call2))|0) <= 0; //@line 139 "synth_mbrola.cpp"
      if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 139 "synth_mbrola.cpp"
      if (__label__ == 3) {
  
        var $arraydecay5=(($path)&4294967295); //@line 141 "synth_mbrola.cpp"
        var $3=$mbrola_voice_addr; //@line 141 "synth_mbrola.cpp"
        var $call6=_sprintf($arraydecay5, ((__str1383)&4294967295), allocate([$3,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 141 "synth_mbrola.cpp"
        ; //@line 142 "synth_mbrola.cpp"
      }
  
      var $arraydecay8=(($path)&4294967295); //@line 143 "synth_mbrola.cpp"
      var $call9=__Z13GetFileLengthPKc($arraydecay8); //@line 143 "synth_mbrola.cpp"
      var $cmp10=((($call9))|0) <= 0; //@line 143 "synth_mbrola.cpp"
      if ($cmp10) { __label__ = 5;; } else { __label__ = 6;; } //@line 143 "synth_mbrola.cpp"
      if (__label__ == 5) {
  
        var $arraydecay12=(($path)&4294967295); //@line 145 "synth_mbrola.cpp"
        var $4=$mbrola_voice_addr; //@line 145 "synth_mbrola.cpp"
        var $5=$mbrola_voice_addr; //@line 145 "synth_mbrola.cpp"
        var $call13=_sprintf($arraydecay12, ((__str2384)&4294967295), allocate([$4,0,0,0,$5,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 145 "synth_mbrola.cpp"
        ; //@line 146 "synth_mbrola.cpp"
      }
  
      var $arraydecay15=(($path)&4294967295); //@line 147 "synth_mbrola.cpp"
      var $call16=__Z13GetFileLengthPKc($arraydecay15); //@line 147 "synth_mbrola.cpp"
      var $cmp17=((($call16))|0) <= 0; //@line 147 "synth_mbrola.cpp"
      if ($cmp17) { __label__ = 7;; } else { __label__ = 8;; } //@line 147 "synth_mbrola.cpp"
      if (__label__ == 7) {
  
        var $arraydecay19=(($path)&4294967295); //@line 149 "synth_mbrola.cpp"
        var $6=$mbrola_voice_addr; //@line 149 "synth_mbrola.cpp"
        var $call20=_sprintf($arraydecay19, ((__str3385)&4294967295), allocate([$6,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 149 "synth_mbrola.cpp"
        ; //@line 150 "synth_mbrola.cpp"
      }
  
      var $arraydecay22=(($path)&4294967295); //@line 160 "synth_mbrola.cpp"
      var $call23=_init_MBR($arraydecay22); //@line 160 "synth_mbrola.cpp"
      var $cmp24=((($call23))|0)!=0; //@line 160 "synth_mbrola.cpp"
      if ($cmp24) { __label__ = 9;; } else { __label__ = 10;; } //@line 160 "synth_mbrola.cpp"
      if (__label__ == 9) {
  
        $retval=2; //@line 161 "synth_mbrola.cpp"
        ; //@line 161 "synth_mbrola.cpp"
      }
      else if (__label__ == 10) {
  
        _setNoError_MBR(); //@line 163 "synth_mbrola.cpp"
        var $arraydecay27=(($path)&4294967295); //@line 166 "synth_mbrola.cpp"
        var $7=$phtrans_addr; //@line 166 "synth_mbrola.cpp"
        var $call28=_sprintf($arraydecay27, ((__str4386)&4294967295), allocate([((_path_home)&4294967295),0,0,0,$7,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 166 "synth_mbrola.cpp"
        var $arraydecay29=(($path)&4294967295); //@line 167 "synth_mbrola.cpp"
        var $call30=__Z13GetFileLengthPKc($arraydecay29); //@line 167 "synth_mbrola.cpp"
        $size=$call30; //@line 167 "synth_mbrola.cpp"
        var $arraydecay31=(($path)&4294967295); //@line 168 "synth_mbrola.cpp"
        var $call32=_fopen($arraydecay31, ((__str18429)&4294967295)); //@line 168 "synth_mbrola.cpp"
        $f_in=$call32; //@line 168 "synth_mbrola.cpp"
        var $cmp33=((($call32))|0)==0; //@line 168 "synth_mbrola.cpp"
        if ($cmp33) { __label__ = 11;; } else { __label__ = 12;; } //@line 168 "synth_mbrola.cpp"
        if (__label__ == 11) {
  
          _close_MBR(); //@line 169 "synth_mbrola.cpp"
          $retval=2; //@line 170 "synth_mbrola.cpp"
          ; //@line 170 "synth_mbrola.cpp"
        }
        else if (__label__ == 12) {
  
          var $8=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 173 "synth_mbrola.cpp"
          var $9=$8; //@line 173 "synth_mbrola.cpp"
          var $10=$size; //@line 173 "synth_mbrola.cpp"
          var $call36=_realloc($9, $10); //@line 173 "synth_mbrola.cpp"
          var $11=$call36; //@line 173 "synth_mbrola.cpp"
          HEAP32[((__ZL10mbrola_tab)>>2)]=$11; //@line 173 "synth_mbrola.cpp"
          var $cmp37=((($11))|0)==0; //@line 173 "synth_mbrola.cpp"
          var $12=$f_in; //@line 175 "synth_mbrola.cpp"
          if ($cmp37) { __label__ = 13;; } else { __label__ = 14;; } //@line 173 "synth_mbrola.cpp"
          if (__label__ == 13) {
  
            var $call39=_fclose($12); //@line 175 "synth_mbrola.cpp"
            _close_MBR(); //@line 176 "synth_mbrola.cpp"
            $retval=-1; //@line 177 "synth_mbrola.cpp"
            ; //@line 177 "synth_mbrola.cpp"
          }
          else if (__label__ == 14) {
  
            var $call41=__Z10Read4BytesP7__sFILE($12); //@line 180 "synth_mbrola.cpp"
            HEAP32[((__ZL14mbrola_control)>>2)]=$call41; //@line 180 "synth_mbrola.cpp"
            var $13=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 181 "synth_mbrola.cpp"
            var $14=$13; //@line 181 "synth_mbrola.cpp"
            $pw=$14; //@line 181 "synth_mbrola.cpp"
            $ix=4; //@line 182 "synth_mbrola.cpp"
            var $15=$ix; //@line 182 "synth_mbrola.cpp"
            var $16=$size; //@line 182 "synth_mbrola.cpp"
            var $cmp421=((($15))|0) < ((($16))|0); //@line 182 "synth_mbrola.cpp"
            if ($cmp421) { __label__ = 15;; } else { __label__ = 16;; } //@line 182 "synth_mbrola.cpp"
            $for_body$$for_end$23: do { 
              if (__label__ == 15) {
                while(1) { 
  
                  var $17=$f_in; //@line 184 "synth_mbrola.cpp"
                  var $call43=__Z10Read4BytesP7__sFILE($17); //@line 184 "synth_mbrola.cpp"
                  var $18=$pw; //@line 184 "synth_mbrola.cpp"
                  var $incdec_ptr=(($18+4)&4294967295); //@line 184 "synth_mbrola.cpp"
                  $pw=$incdec_ptr; //@line 184 "synth_mbrola.cpp"
                  HEAP32[(($18)>>2)]=$call43; //@line 184 "synth_mbrola.cpp"
                  var $19=$ix; //@line 182 "synth_mbrola.cpp"
                  var $add=((($19)+4)&4294967295); //@line 182 "synth_mbrola.cpp"
                  $ix=$add; //@line 182 "synth_mbrola.cpp"
                  var $20=$ix; //@line 182 "synth_mbrola.cpp"
                  var $21=$size; //@line 182 "synth_mbrola.cpp"
                  var $cmp42=((($20))|0) < ((($21))|0); //@line 182 "synth_mbrola.cpp"
                  if ($cmp42) { __label__ = 15;continue ; } else { __label__ = 16;break $for_body$$for_end$23; } //@line 182 "synth_mbrola.cpp"
                }
              }
            } while(0);
  
            var $22=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 186 "synth_mbrola.cpp"
            var $23=$22; //@line 186 "synth_mbrola.cpp"
            var $24=$size; //@line 186 "synth_mbrola.cpp"
            var $25=$f_in; //@line 186 "synth_mbrola.cpp"
            var $call44=_fread($23, 1, $24, $25); //@line 186 "synth_mbrola.cpp"
            $size=$call44; //@line 186 "synth_mbrola.cpp"
            var $26=$f_in; //@line 187 "synth_mbrola.cpp"
            var $call45=_fclose($26); //@line 187 "synth_mbrola.cpp"
            var $27=HEAP32[((__ZL14mbrola_control)>>2)]; //@line 189 "synth_mbrola.cpp"
            var $and=($27) & 255; //@line 189 "synth_mbrola.cpp"
            var $conv=((($and))|0); //@line 189 "synth_mbrola.cpp"
            var $div=($conv)/16; //@line 189 "synth_mbrola.cpp"
            _setVolumeRatio_MBR($div); //@line 189 "synth_mbrola.cpp"
            var $28=$srate_addr; //@line 191 "synth_mbrola.cpp"
            HEAP32[((_samplerate)>>2)]=$28; //@line 191 "synth_mbrola.cpp"
            var $cmp46=((($28))|0)==22050; //@line 192 "synth_mbrola.cpp"
            if ($cmp46) { __label__ = 17;; } else { __label__ = 18;; } //@line 192 "synth_mbrola.cpp"
            if (__label__ == 17) {
  
              __Z12SetParameteriii(14, 0, 0); //@line 193 "synth_mbrola.cpp"
              ; //@line 193 "synth_mbrola.cpp"
            }
            else if (__label__ == 18) {
  
              __Z12SetParameteriii(14, 1, 0); //@line 195 "synth_mbrola.cpp"
              ;
            }
  
            var $29=$mbrola_voice_addr; //@line 196 "synth_mbrola.cpp"
            var $call49=_strcpy(((_mbrola_name)&4294967295), $29); //@line 196 "synth_mbrola.cpp"
            HEAP32[((_mbrola_delay)>>2)]=1000; //@line 198 "synth_mbrola.cpp"
            $retval=0; //@line 199 "synth_mbrola.cpp"
            ; //@line 199 "synth_mbrola.cpp"
          }
        }
      }
    }
  
    var $30=$retval; //@line 200 "synth_mbrola.cpp"
    STACKTOP = __stackBase__;
    return $30; //@line 200 "synth_mbrola.cpp"
    return null;
  }
  

  function _setNoError_MBR() {
    ;
    var __label__;
  
    ;
    return; //@line 102 "./mbrowrap.h"
    return;
  }
  

  function __Z15MbrolaTranslateP12PHONEME_LISTiiP7__sFILE($plist, $n_phonemes, $resume, $f_mbrola) {
    var __stackBase__  = STACKTOP; STACKTOP += 332; _memset(__stackBase__, 0, 332);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $plist_addr;
    var $n_phonemes_addr;
    var $resume_addr;
    var $f_mbrola_addr;
    var $name;
    var $len;
    var $len1;
    var $ph;
    var $ph_next;
    var $ph_prev;
    var $p;
    var $next;
    var $prev;
    var $phdata=__stackBase__;
    var $fmtp=__stackBase__+152;
    var $pause;
    var $released;
    var $name2=__stackBase__+200;
    var $control=__stackBase__+204;
    var $done;
    var $len_percent=__stackBase__+208;
    var $final_pitch;
    var $ptr;
    var $mbr_buf=__stackBase__+212;
    var $pitch;
    var $pitch101;
    var $res;
    $plist_addr=$plist;
    $n_phonemes_addr=$n_phonemes;
    $resume_addr=$resume;
    $f_mbrola_addr=$f_mbrola;
    $pause=0; //@line 416 "synth_mbrola.cpp"
    var $0=$resume_addr; //@line 430 "synth_mbrola.cpp"
    var $tobool=((($0))|0)!=0; //@line 430 "synth_mbrola.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 430 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=1; //@line 431 "synth_mbrola.cpp"
      HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix)>>2)]=0; //@line 432 "synth_mbrola.cpp"
      HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count)>>2)]=0; //@line 433 "synth_mbrola.cpp"
      ; //@line 434 "synth_mbrola.cpp"
    }
  
    var $arraydecay=(($mbr_buf)&4294967295); //@line 441 "synth_mbrola.cpp"
    var $arraydecay233=(($mbr_buf)&4294967295); //@line 597 "synth_mbrola.cpp"
    var $arraydecay234=(($mbr_buf)&4294967295); //@line 597 "synth_mbrola.cpp"
    var $sub_ptr_rhs_cast=($arraydecay234); //@line 597 "synth_mbrola.cpp"
    var $1=$fmtp; //@line 556 "synth_mbrola.cpp"
    var $sound_addr=(($phdata+68)&4294967295); //@line 558 "synth_mbrola.cpp"
    var $arrayidx176=(($sound_addr)&4294967295); //@line 558 "synth_mbrola.cpp"
    var $fmt_addr=(($fmtp+8)&4294967295); //@line 558 "synth_mbrola.cpp"
    ; //@line 436 "synth_mbrola.cpp"
    $while_cond$5: while(1) { 
  
      var $2=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 436 "synth_mbrola.cpp"
      var $3=$n_phonemes_addr; //@line 436 "synth_mbrola.cpp"
      var $cmp=((($2))|0) < ((($3))|0); //@line 436 "synth_mbrola.cpp"
      if (!($cmp)) { __label__ = 64;break $while_cond$5; } //@line 436 "synth_mbrola.cpp"
  
      var $call=__Z9WcmdqFreev(); //@line 438 "synth_mbrola.cpp"
      var $cmp1=((($call))|0) < 22; //@line 438 "synth_mbrola.cpp"
      if ($cmp1) { __label__ = 5;break $while_cond$5; } //@line 438 "synth_mbrola.cpp"
  
      $ptr=$arraydecay; //@line 441 "synth_mbrola.cpp"
      var $4=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 443 "synth_mbrola.cpp"
      var $5=$plist_addr; //@line 443 "synth_mbrola.cpp"
      var $arrayidx=(($5+24*$4)&4294967295); //@line 443 "synth_mbrola.cpp"
      $p=$arrayidx; //@line 443 "synth_mbrola.cpp"
      var $6=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 444 "synth_mbrola.cpp"
      var $add=((($6)+1)&4294967295); //@line 444 "synth_mbrola.cpp"
      var $7=$plist_addr; //@line 444 "synth_mbrola.cpp"
      var $arrayidx4=(($7+24*$add)&4294967295); //@line 444 "synth_mbrola.cpp"
      $next=$arrayidx4; //@line 444 "synth_mbrola.cpp"
      var $8=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 445 "synth_mbrola.cpp"
      var $sub=((($8)-1)&4294967295); //@line 445 "synth_mbrola.cpp"
      var $9=$plist_addr; //@line 445 "synth_mbrola.cpp"
      var $arrayidx5=(($9+24*$sub)&4294967295); //@line 445 "synth_mbrola.cpp"
      $prev=$arrayidx5; //@line 445 "synth_mbrola.cpp"
      var $10=$p; //@line 446 "synth_mbrola.cpp"
      var $ph6=(($10+8)&4294967295); //@line 446 "synth_mbrola.cpp"
      var $11=HEAP32[(($ph6)>>2)]; //@line 446 "synth_mbrola.cpp"
      $ph=$11; //@line 446 "synth_mbrola.cpp"
      var $12=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 447 "synth_mbrola.cpp"
      var $sub7=((($12)-1)&4294967295); //@line 447 "synth_mbrola.cpp"
      var $13=$plist_addr; //@line 447 "synth_mbrola.cpp"
      var $arrayidx8=(($13+24*$sub7)&4294967295); //@line 447 "synth_mbrola.cpp"
      var $ph9=(($arrayidx8+8)&4294967295); //@line 447 "synth_mbrola.cpp"
      var $14=HEAP32[(($ph9)>>2)]; //@line 447 "synth_mbrola.cpp"
      $ph_prev=$14; //@line 447 "synth_mbrola.cpp"
      var $15=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 448 "synth_mbrola.cpp"
      var $add10=((($15)+1)&4294967295); //@line 448 "synth_mbrola.cpp"
      var $16=$plist_addr; //@line 448 "synth_mbrola.cpp"
      var $arrayidx11=(($16+24*$add10)&4294967295); //@line 448 "synth_mbrola.cpp"
      var $ph12=(($arrayidx11+8)&4294967295); //@line 448 "synth_mbrola.cpp"
      var $17=HEAP32[(($ph12)>>2)]; //@line 448 "synth_mbrola.cpp"
      $ph_next=$17; //@line 448 "synth_mbrola.cpp"
      var $18=$p; //@line 450 "synth_mbrola.cpp"
      var $synthflags=(($18+4)&4294967295); //@line 450 "synth_mbrola.cpp"
      var $19=HEAPU16[(($synthflags)>>1)]; //@line 450 "synth_mbrola.cpp"
      var $conv=((($19))&65535); //@line 450 "synth_mbrola.cpp"
      var $and=($conv) & 2; //@line 450 "synth_mbrola.cpp"
      var $tobool13=((($and))|0)!=0; //@line 450 "synth_mbrola.cpp"
      if ($tobool13) { __label__ = 7;; } else { __label__ = 8;; } //@line 450 "synth_mbrola.cpp"
      if (__label__ == 7) {
  
        var $20=$p; //@line 452 "synth_mbrola.cpp"
        var $sourceix=(($20+6)&4294967295); //@line 452 "synth_mbrola.cpp"
        var $21=HEAPU16[(($sourceix)>>1)]; //@line 452 "synth_mbrola.cpp"
        var $conv15=((($21))&65535); //@line 452 "synth_mbrola.cpp"
        __Z10DoEmbeddedPii(__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix, $conv15); //@line 452 "synth_mbrola.cpp"
        ; //@line 453 "synth_mbrola.cpp"
      }
  
      var $22=$p; //@line 455 "synth_mbrola.cpp"
      var $newword=(($22+19)&4294967295); //@line 455 "synth_mbrola.cpp"
      var $23=HEAPU8[($newword)]; //@line 455 "synth_mbrola.cpp"
      var $conv17=((($23))&255); //@line 455 "synth_mbrola.cpp"
      var $and18=($conv17) & 4; //@line 455 "synth_mbrola.cpp"
      var $tobool19=((($and18))|0)!=0; //@line 455 "synth_mbrola.cpp"
      if ($tobool19) { __label__ = 9;; } else { __label__ = 10;; } //@line 455 "synth_mbrola.cpp"
      if (__label__ == 9) {
  
        var $24=$p; //@line 456 "synth_mbrola.cpp"
        var $sourceix21=(($24+6)&4294967295); //@line 456 "synth_mbrola.cpp"
        var $25=HEAPU16[(($sourceix21)>>1)]; //@line 456 "synth_mbrola.cpp"
        var $conv22=((($25))&65535); //@line 456 "synth_mbrola.cpp"
        var $and23=($conv22) & 2047; //@line 456 "synth_mbrola.cpp"
        var $26=HEAP32[((_clause_start_char)>>2)]; //@line 456 "synth_mbrola.cpp"
        var $add24=((($and23)+($26))&4294967295); //@line 456 "synth_mbrola.cpp"
        var $27=HEAP32[((_count_sentences)>>2)]; //@line 456 "synth_mbrola.cpp"
        __Z8DoMarkeriiii(2, $add24, 0, $27); //@line 456 "synth_mbrola.cpp"
        ; //@line 456 "synth_mbrola.cpp"
      }
  
      var $28=$p; //@line 457 "synth_mbrola.cpp"
      var $newword26=(($28+19)&4294967295); //@line 457 "synth_mbrola.cpp"
      var $29=HEAPU8[($newword26)]; //@line 457 "synth_mbrola.cpp"
      var $conv27=((($29))&255); //@line 457 "synth_mbrola.cpp"
      var $and28=($conv27) & 1; //@line 457 "synth_mbrola.cpp"
      var $tobool29=((($and28))|0)!=0; //@line 457 "synth_mbrola.cpp"
      if ($tobool29) { __label__ = 11;; } else { __label__ = 12;; } //@line 457 "synth_mbrola.cpp"
      if (__label__ == 11) {
  
        var $30=$p; //@line 458 "synth_mbrola.cpp"
        var $sourceix31=(($30+6)&4294967295); //@line 458 "synth_mbrola.cpp"
        var $31=HEAPU16[(($sourceix31)>>1)]; //@line 458 "synth_mbrola.cpp"
        var $conv32=((($31))&65535); //@line 458 "synth_mbrola.cpp"
        var $and33=($conv32) & 2047; //@line 458 "synth_mbrola.cpp"
        var $32=HEAP32[((_clause_start_char)>>2)]; //@line 458 "synth_mbrola.cpp"
        var $add34=((($and33)+($32))&4294967295); //@line 458 "synth_mbrola.cpp"
        var $33=$p; //@line 458 "synth_mbrola.cpp"
        var $sourceix35=(($33+6)&4294967295); //@line 458 "synth_mbrola.cpp"
        var $34=HEAPU16[(($sourceix35)>>1)]; //@line 458 "synth_mbrola.cpp"
        var $conv36=((($34))&65535); //@line 458 "synth_mbrola.cpp"
        var $shr=($conv36) >> 11; //@line 458 "synth_mbrola.cpp"
        var $35=HEAP32[((_clause_start_word)>>2)]; //@line 458 "synth_mbrola.cpp"
        var $36=HEAPU32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count)>>2)]; //@line 458 "synth_mbrola.cpp"
        var $inc=((($36)+1)&4294967295); //@line 458 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count)>>2)]=$inc; //@line 458 "synth_mbrola.cpp"
        var $add37=((($36)+($35))&4294967295); //@line 458 "synth_mbrola.cpp"
        __Z8DoMarkeriiii(1, $add34, $shr, $add37); //@line 458 "synth_mbrola.cpp"
        ; //@line 458 "synth_mbrola.cpp"
      }
  
      var $37=$p; //@line 460 "synth_mbrola.cpp"
      var $38=$ph; //@line 460 "synth_mbrola.cpp"
      var $39=$ph_prev; //@line 460 "synth_mbrola.cpp"
      var $40=$ph_next; //@line 460 "synth_mbrola.cpp"
      var $call39=__ZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_($37, $38, $39, $40, $name2, $len_percent, $control); //@line 460 "synth_mbrola.cpp"
      $name=$call39; //@line 460 "synth_mbrola.cpp"
      var $41=HEAP32[(($control)>>2)]; //@line 461 "synth_mbrola.cpp"
      var $and40=($41) & 1; //@line 461 "synth_mbrola.cpp"
      var $tobool41=((($and40))|0)!=0; //@line 461 "synth_mbrola.cpp"
      if ($tobool41) { __lastLabel__ = 12; __label__ = 13;; } else { __lastLabel__ = 12; __label__ = 14;; } //@line 461 "synth_mbrola.cpp"
      if (__label__ == 13) {
  
        var $42=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 462 "synth_mbrola.cpp"
        var $inc43=((($42)+1)&4294967295); //@line 462 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=$inc43; //@line 462 "synth_mbrola.cpp"
        var $_pr=$name; //@line 464 "synth_mbrola.cpp"
        __lastLabel__ = 13; ; //@line 462 "synth_mbrola.cpp"
      }
  
      var $43=__lastLabel__ == 13 ? $_pr : ($call39); //@line 464 "synth_mbrola.cpp"
      var $cmp45=((($43))|0)==0; //@line 464 "synth_mbrola.cpp"
      if ($cmp45) { __label__ = 15;; } else { __label__ = 16;; } //@line 464 "synth_mbrola.cpp"
      if (__label__ == 15) {
  
        var $44=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 465 "synth_mbrola.cpp"
        var $inc47=((($44)+1)&4294967295); //@line 465 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=$inc47; //@line 465 "synth_mbrola.cpp"
        __label__ = 3;continue $while_cond$5; //@line 466 "synth_mbrola.cpp"
      }
      else if (__label__ == 16) {
  
        var $45=$ph; //@line 469 "synth_mbrola.cpp"
        var $type=(($45+11)&4294967295); //@line 469 "synth_mbrola.cpp"
        var $46=HEAPU8[($type)]; //@line 469 "synth_mbrola.cpp"
        var $conv49=((($46))&255); //@line 469 "synth_mbrola.cpp"
        var $cmp50=((($conv49))|0)==0; //@line 469 "synth_mbrola.cpp"
        if ($cmp50) { __label__ = 17;; } else { __label__ = 20;; } //@line 469 "synth_mbrola.cpp"
        $land_lhs_true$$if_else$24: do { 
          if (__label__ == 17) {
  
            var $47=$name; //@line 469 "synth_mbrola.cpp"
            var $48=$ph; //@line 469 "synth_mbrola.cpp"
            var $mnemonic=(($48)&4294967295); //@line 469 "synth_mbrola.cpp"
            var $49=HEAP32[(($mnemonic)>>2)]; //@line 469 "synth_mbrola.cpp"
            var $cmp51=((($47))|0)==((($49))|0); //@line 469 "synth_mbrola.cpp"
            if (!($cmp51)) { __label__ = 20;break $land_lhs_true$$if_else$24; } //@line 469 "synth_mbrola.cpp"
  
            $name=95; //@line 472 "synth_mbrola.cpp"
            var $50=$p; //@line 473 "synth_mbrola.cpp"
            var $length=(($50+12)&4294967295); //@line 473 "synth_mbrola.cpp"
            var $51=HEAP16[(($length)>>1)]; //@line 473 "synth_mbrola.cpp"
            var $conv53=(tempInt=(($51)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 473 "synth_mbrola.cpp"
            var $52=HEAP32[((((_speed)&4294967295))>>2)]; //@line 473 "synth_mbrola.cpp"
            var $mul=((($conv53)*($52))&4294967295); //@line 473 "synth_mbrola.cpp"
            var $div=((((($mul))|0)/256)|0); //@line 473 "synth_mbrola.cpp"
            $len=$div; //@line 473 "synth_mbrola.cpp"
            var $53=$len; //@line 475 "synth_mbrola.cpp"
            var $cmp54=((($53))|0)==0; //@line 475 "synth_mbrola.cpp"
            if (!($cmp54)) { __label__ = 21;break $land_lhs_true$$if_else$24; } //@line 475 "synth_mbrola.cpp"
  
            $len=1; //@line 476 "synth_mbrola.cpp"
            __label__ = 21;break $land_lhs_true$$if_else$24; //@line 476 "synth_mbrola.cpp"
          }
        } while(0);
        if (__label__ == 20) {
  
          var $54=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 479 "synth_mbrola.cpp"
          var $mul57=((($54)*80)&4294967295); //@line 479 "synth_mbrola.cpp"
          var $div58=((((($mul57))|0)/256)|0); //@line 479 "synth_mbrola.cpp"
          $len=$div58; //@line 479 "synth_mbrola.cpp"
          ;
        }
  
        var $55=$p; //@line 481 "synth_mbrola.cpp"
        var $sourceix60=(($55+6)&4294967295); //@line 481 "synth_mbrola.cpp"
        var $56=HEAPU16[(($sourceix60)>>1)]; //@line 481 "synth_mbrola.cpp"
        var $conv61=((($56))&65535); //@line 481 "synth_mbrola.cpp"
        var $and62=($conv61) & 2047; //@line 481 "synth_mbrola.cpp"
        var $57=HEAP32[((_clause_start_char)>>2)]; //@line 481 "synth_mbrola.cpp"
        var $add63=((($and62)+($57))&4294967295); //@line 481 "synth_mbrola.cpp"
        var $58=$ph; //@line 481 "synth_mbrola.cpp"
        var $mnemonic64=(($58)&4294967295); //@line 481 "synth_mbrola.cpp"
        var $59=HEAP32[(($mnemonic64)>>2)]; //@line 481 "synth_mbrola.cpp"
        __Z8DoMarkeriiii(7, $add63, 0, $59); //@line 481 "synth_mbrola.cpp"
        var $60=$ptr; //@line 483 "synth_mbrola.cpp"
        var $61=$name; //@line 483 "synth_mbrola.cpp"
        var $call65=__Z12WordToStringj($61); //@line 483 "synth_mbrola.cpp"
        var $call66=_sprintf($60, ((__str6388)&4294967295), allocate([((__ZZ12WordToStringjE3buf)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 483 "synth_mbrola.cpp"
        var $62=$ptr; //@line 483 "synth_mbrola.cpp"
        var $add_ptr=(($62+$call66)&4294967295); //@line 483 "synth_mbrola.cpp"
        $ptr=$add_ptr; //@line 483 "synth_mbrola.cpp"
        var $63=HEAP32[(($name2)>>2)]; //@line 485 "synth_mbrola.cpp"
        var $cmp67=((($63))|0)==95; //@line 485 "synth_mbrola.cpp"
        if ($cmp67) { __label__ = 22;; } else { __label__ = 23;; } //@line 485 "synth_mbrola.cpp"
        if (__label__ == 22) {
  
          var $64=HEAP32[(($len_percent)>>2)]; //@line 488 "synth_mbrola.cpp"
          $pause=$64; //@line 488 "synth_mbrola.cpp"
          HEAP32[(($name2)>>2)]=0; //@line 489 "synth_mbrola.cpp"
          ; //@line 490 "synth_mbrola.cpp"
        }
  
        $done=0; //@line 492 "synth_mbrola.cpp"
        $final_pitch=((__str13643)&4294967295); //@line 493 "synth_mbrola.cpp"
        var $65=$ph; //@line 495 "synth_mbrola.cpp"
        var $type70=(($65+11)&4294967295); //@line 495 "synth_mbrola.cpp"
        var $66=HEAPU8[($type70)]; //@line 495 "synth_mbrola.cpp"
        var $conv71=((($66))&255); //@line 495 "synth_mbrola.cpp"
        if ($conv71 == 2) {
          __label__ = 24;;
        }
        else if ($conv71 == 4) {
          __label__ = 32;;
        }
        else if ($conv71 == 5) {
          __label__ = 40;;
        }
        else if ($conv71 == 6) {
          __label__ = 41;;
        }
        else if ($conv71 == 8) {
          __label__ = 44;;
        }
        else if ($conv71 == 3) {
          __label__ = 48;;
        }
        else {
        __label__ = 50;;
        }
        
        $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34: do { 
          if (__label__ == 24) {
  
            var $67=$ph; //@line 498 "synth_mbrola.cpp"
            var $std_length=(($67+14)&4294967295); //@line 498 "synth_mbrola.cpp"
            var $68=HEAPU8[($std_length)]; //@line 498 "synth_mbrola.cpp"
            var $conv72=((($68))&255); //@line 498 "synth_mbrola.cpp"
            $len=$conv72; //@line 498 "synth_mbrola.cpp"
            var $69=$p; //@line 499 "synth_mbrola.cpp"
            var $synthflags73=(($69+4)&4294967295); //@line 499 "synth_mbrola.cpp"
            var $70=HEAPU16[(($synthflags73)>>1)]; //@line 499 "synth_mbrola.cpp"
            var $conv74=((($70))&65535); //@line 499 "synth_mbrola.cpp"
            var $and75=($conv74) & 8; //@line 499 "synth_mbrola.cpp"
            var $tobool76=((($and75))|0)!=0; //@line 499 "synth_mbrola.cpp"
            if ($tobool76) { __label__ = 25;; } else { __label__ = 26;; } //@line 499 "synth_mbrola.cpp"
            if (__label__ == 25) {
  
              var $71=HEAP32[((((_phoneme_tab+48)&4294967295))>>2)]; //@line 500 "synth_mbrola.cpp"
              var $std_length78=(($71+14)&4294967295); //@line 500 "synth_mbrola.cpp"
              var $72=HEAPU8[($std_length78)]; //@line 500 "synth_mbrola.cpp"
              var $conv79=((($72))&255); //@line 500 "synth_mbrola.cpp"
              var $73=$len; //@line 500 "synth_mbrola.cpp"
              var $add80=((($73)+($conv79))&4294967295); //@line 500 "synth_mbrola.cpp"
              $len=$add80; //@line 500 "synth_mbrola.cpp"
              ; //@line 500 "synth_mbrola.cpp"
            }
  
            var $74=$ph_next; //@line 502 "synth_mbrola.cpp"
            var $type82=(($74+11)&4294967295); //@line 502 "synth_mbrola.cpp"
            var $75=HEAPU8[($type82)]; //@line 502 "synth_mbrola.cpp"
            var $conv83=((($75))&255); //@line 502 "synth_mbrola.cpp"
            var $cmp84=((($conv83))|0)==0; //@line 502 "synth_mbrola.cpp"
            if ($cmp84) { __label__ = 27;; } else { __label__ = 28;; } //@line 502 "synth_mbrola.cpp"
            if (__label__ == 27) {
  
              var $76=$len; //@line 503 "synth_mbrola.cpp"
              var $add86=((($76)+50)&4294967295); //@line 503 "synth_mbrola.cpp"
              $len=$add86; //@line 503 "synth_mbrola.cpp"
              ; //@line 503 "synth_mbrola.cpp"
            }
  
            var $77=$len; //@line 504 "synth_mbrola.cpp"
            var $78=$p; //@line 504 "synth_mbrola.cpp"
            var $length88=(($78+12)&4294967295); //@line 504 "synth_mbrola.cpp"
            var $79=HEAP16[(($length88)>>1)]; //@line 504 "synth_mbrola.cpp"
            var $conv89=(tempInt=(($79)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 504 "synth_mbrola.cpp"
            var $mul90=((($conv89)*($77))&4294967295); //@line 504 "synth_mbrola.cpp"
            var $div91=((((($mul90))|0)/256)|0); //@line 504 "synth_mbrola.cpp"
            $len=$div91; //@line 504 "synth_mbrola.cpp"
            var $80=HEAP32[(($name2)>>2)]; //@line 506 "synth_mbrola.cpp"
            var $cmp92=((($80))|0)==0; //@line 506 "synth_mbrola.cpp"
            var $81=$p; //@line 508 "synth_mbrola.cpp"
            var $env=(($81+14)&4294967295); //@line 508 "synth_mbrola.cpp"
            var $82=HEAPU8[($env)]; //@line 508 "synth_mbrola.cpp"
            var $conv94=((($82))&255); //@line 508 "synth_mbrola.cpp"
            var $83=$p; //@line 508 "synth_mbrola.cpp"
            var $pitch1=(($83+20)&4294967295); //@line 508 "synth_mbrola.cpp"
            var $84=HEAPU8[($pitch1)]; //@line 508 "synth_mbrola.cpp"
            var $conv95=((($84))&255); //@line 508 "synth_mbrola.cpp"
            var $85=$p; //@line 508 "synth_mbrola.cpp"
            var $pitch2=(($85+21)&4294967295); //@line 508 "synth_mbrola.cpp"
            var $86=HEAPU8[($pitch2)]; //@line 508 "synth_mbrola.cpp"
            var $conv96=((($86))&255); //@line 508 "synth_mbrola.cpp"
            if ($cmp92) { __label__ = 29;; } else { __label__ = 30;; } //@line 506 "synth_mbrola.cpp"
            if (__label__ == 29) {
  
              __ZL10WritePitchiiiii($conv94, $conv95, $conv96, 0, 0); //@line 508 "synth_mbrola.cpp"
              $pitch=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 508 "synth_mbrola.cpp"
              var $87=$ptr; //@line 509 "synth_mbrola.cpp"
              var $88=$len; //@line 509 "synth_mbrola.cpp"
              var $89=$pitch; //@line 509 "synth_mbrola.cpp"
              var $call98=_sprintf($87, ((__str8390)&4294967295), allocate([$88,0,0,0,$89,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 509 "synth_mbrola.cpp"
              var $90=$ptr; //@line 509 "synth_mbrola.cpp"
              var $add_ptr99=(($90+$call98)&4294967295); //@line 509 "synth_mbrola.cpp"
              $ptr=$add_ptr99; //@line 509 "synth_mbrola.cpp"
              ; //@line 510 "synth_mbrola.cpp"
            }
            else if (__label__ == 30) {
  
              var $91=HEAP32[(($len_percent)>>2)]; //@line 515 "synth_mbrola.cpp"
              __ZL10WritePitchiiiii($conv94, $conv95, $conv96, $91, 0); //@line 515 "synth_mbrola.cpp"
              $pitch101=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 515 "synth_mbrola.cpp"
              var $92=$len; //@line 516 "synth_mbrola.cpp"
              var $93=HEAP32[(($len_percent)>>2)]; //@line 516 "synth_mbrola.cpp"
              var $mul109=((($93)*($92))&4294967295); //@line 516 "synth_mbrola.cpp"
              var $div110=((((($mul109))|0)/100)|0); //@line 516 "synth_mbrola.cpp"
              $len1=$div110; //@line 516 "synth_mbrola.cpp"
              var $94=$ptr; //@line 517 "synth_mbrola.cpp"
              var $95=$len1; //@line 517 "synth_mbrola.cpp"
              var $96=$pitch101; //@line 517 "synth_mbrola.cpp"
              var $call111=_sprintf($94, ((__str8390)&4294967295), allocate([$95,0,0,0,$96,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 517 "synth_mbrola.cpp"
              var $97=$ptr; //@line 517 "synth_mbrola.cpp"
              var $add_ptr112=(($97+$call111)&4294967295); //@line 517 "synth_mbrola.cpp"
              $ptr=$add_ptr112; //@line 517 "synth_mbrola.cpp"
              var $98=$p; //@line 519 "synth_mbrola.cpp"
              var $env113=(($98+14)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $99=HEAPU8[($env113)]; //@line 519 "synth_mbrola.cpp"
              var $conv114=((($99))&255); //@line 519 "synth_mbrola.cpp"
              var $100=$p; //@line 519 "synth_mbrola.cpp"
              var $pitch1115=(($100+20)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $101=HEAPU8[($pitch1115)]; //@line 519 "synth_mbrola.cpp"
              var $conv116=((($101))&255); //@line 519 "synth_mbrola.cpp"
              var $102=$p; //@line 519 "synth_mbrola.cpp"
              var $pitch2117=(($102+21)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $103=HEAPU8[($pitch2117)]; //@line 519 "synth_mbrola.cpp"
              var $conv118=((($103))&255); //@line 519 "synth_mbrola.cpp"
              var $104=HEAP32[(($len_percent)>>2)]; //@line 519 "synth_mbrola.cpp"
              var $sub119=(((-($104)))&4294967295); //@line 519 "synth_mbrola.cpp"
              __ZL10WritePitchiiiii($conv114, $conv116, $conv118, $sub119, 0); //@line 519 "synth_mbrola.cpp"
              $pitch101=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 519 "synth_mbrola.cpp"
              var $105=$ptr; //@line 520 "synth_mbrola.cpp"
              var $106=HEAP32[(($name2)>>2)]; //@line 520 "synth_mbrola.cpp"
              var $call121=__Z12WordToStringj($106); //@line 520 "synth_mbrola.cpp"
              var $107=$len; //@line 520 "synth_mbrola.cpp"
              var $108=$len1; //@line 520 "synth_mbrola.cpp"
              var $sub122=((($107)-($108))&4294967295); //@line 520 "synth_mbrola.cpp"
              var $109=$pitch101; //@line 520 "synth_mbrola.cpp"
              var $call123=_sprintf($105, ((__str9391)&4294967295), allocate([((__ZZ12WordToStringjE3buf)&4294967295),0,0,0,$sub122,0,0,0,$109,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 520 "synth_mbrola.cpp"
              var $110=$ptr; //@line 520 "synth_mbrola.cpp"
              var $add_ptr124=(($110+$call123)&4294967295); //@line 520 "synth_mbrola.cpp"
              $ptr=$add_ptr124; //@line 520 "synth_mbrola.cpp"
              ;
            }
  
            $done=1; //@line 522 "synth_mbrola.cpp"
            __label__ = 54;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 577 "synth_mbrola.cpp"
          }
          else if (__label__ == 32) {
  
            $released=0; //@line 526 "synth_mbrola.cpp"
            var $111=$next; //@line 527 "synth_mbrola.cpp"
            var $type127=(($111+15)&4294967295); //@line 527 "synth_mbrola.cpp"
            var $112=HEAPU8[($type127)]; //@line 527 "synth_mbrola.cpp"
            var $conv128=((($112))&255); //@line 527 "synth_mbrola.cpp"
            var $cmp129=((($conv128))|0)==2; //@line 527 "synth_mbrola.cpp"
            if ($cmp129) { __label__ = 33;; } else { __label__ = 34;; } //@line 527 "synth_mbrola.cpp"
            if (__label__ == 33) {
  
              $released=1; //@line 527 "synth_mbrola.cpp"
              ; //@line 527 "synth_mbrola.cpp"
            }
  
            var $113=$next; //@line 528 "synth_mbrola.cpp"
            var $type132=(($113+15)&4294967295); //@line 528 "synth_mbrola.cpp"
            var $114=HEAPU8[($type132)]; //@line 528 "synth_mbrola.cpp"
            var $conv133=((($114))&255); //@line 528 "synth_mbrola.cpp"
            var $cmp134=((($conv133))|0)==3; //@line 528 "synth_mbrola.cpp"
            if ($cmp134) { __label__ = 35;; } else { __label__ = 37;; } //@line 528 "synth_mbrola.cpp"
            $land_lhs_true135$$if_end139$50: do { 
              if (__label__ == 35) {
  
                var $115=$next; //@line 528 "synth_mbrola.cpp"
                var $newword136=(($115+19)&4294967295); //@line 528 "synth_mbrola.cpp"
                var $116=HEAP8[($newword136)]; //@line 528 "synth_mbrola.cpp"
                var $tobool137=(tempInt=(($116)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 528 "synth_mbrola.cpp"
                if ($tobool137) { __label__ = 37;break $land_lhs_true135$$if_end139$50; } //@line 528 "synth_mbrola.cpp"
  
                $released=1; //@line 528 "synth_mbrola.cpp"
                __label__ = 39;break $land_lhs_true135$$if_end139$50; //@line 530 "synth_mbrola.cpp"
              }
            } while(0);
            $if_end139$$if_end145$53: do { 
              if (__label__ == 37) {
  
                var $_pr1=$released; //@line 530 "synth_mbrola.cpp"
                var $cmp140=((($_pr1))|0)==0; //@line 530 "synth_mbrola.cpp"
                if (!($cmp140)) { __label__ = 39;break $if_end139$$if_end145$53; } //@line 530 "synth_mbrola.cpp"
  
                var $117=$p; //@line 531 "synth_mbrola.cpp"
                var $synthflags142=(($117+4)&4294967295); //@line 531 "synth_mbrola.cpp"
                var $118=HEAPU16[(($synthflags142)>>1)]; //@line 531 "synth_mbrola.cpp"
                var $conv143=((($118))&65535); //@line 531 "synth_mbrola.cpp"
                var $or=($conv143) | 8192; //@line 531 "synth_mbrola.cpp"
                var $conv144=((($or)) & 65535); //@line 531 "synth_mbrola.cpp"
                HEAP16[(($synthflags142)>>1)]=$conv144; //@line 531 "synth_mbrola.cpp"
                ; //@line 531 "synth_mbrola.cpp"
              }
            } while(0);
  
            var $119=$p; //@line 532 "synth_mbrola.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $119, $phdata); //@line 532 "synth_mbrola.cpp"
            var $call146=__Z9DoSample3P12PHONEME_DATAii($phdata, 0, -1); //@line 533 "synth_mbrola.cpp"
            $len=$call146; //@line 533 "synth_mbrola.cpp"
            var $120=$len; //@line 535 "synth_mbrola.cpp"
            var $mul147=((($120)*1000)&4294967295); //@line 535 "synth_mbrola.cpp"
            var $121=HEAP32[((_samplerate)>>2)]; //@line 535 "synth_mbrola.cpp"
            var $div148=((((($mul147))|0)/((($121))|0))|0); //@line 535 "synth_mbrola.cpp"
            $len=$div148; //@line 535 "synth_mbrola.cpp"
            var $122=$p; //@line 536 "synth_mbrola.cpp"
            var $prepause=(($122+16)&4294967295); //@line 536 "synth_mbrola.cpp"
            var $123=HEAPU8[($prepause)]; //@line 536 "synth_mbrola.cpp"
            var $conv149=((($123))&255); //@line 536 "synth_mbrola.cpp"
            var $call150=__Z11PauseLengthii($conv149, 1); //@line 536 "synth_mbrola.cpp"
            var $124=$len; //@line 536 "synth_mbrola.cpp"
            var $add151=((($124)+($call150))&4294967295); //@line 536 "synth_mbrola.cpp"
            $len=$add151; //@line 536 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 537 "synth_mbrola.cpp"
          }
          else if (__label__ == 40) {
  
            var $125=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 540 "synth_mbrola.cpp"
            var $mul153=((($125)*80)&4294967295); //@line 540 "synth_mbrola.cpp"
            var $div154=((((($mul153))|0)/256)|0); //@line 540 "synth_mbrola.cpp"
            $len=$div154; //@line 540 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 541 "synth_mbrola.cpp"
          }
          else if (__label__ == 41) {
  
            $len=0; //@line 544 "synth_mbrola.cpp"
            var $126=$p; //@line 545 "synth_mbrola.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $126, $phdata); //@line 545 "synth_mbrola.cpp"
            var $127=$p; //@line 546 "synth_mbrola.cpp"
            var $synthflags156=(($127+4)&4294967295); //@line 546 "synth_mbrola.cpp"
            var $128=HEAPU16[(($synthflags156)>>1)]; //@line 546 "synth_mbrola.cpp"
            var $conv157=((($128))&65535); //@line 546 "synth_mbrola.cpp"
            var $and158=($conv157) & 8; //@line 546 "synth_mbrola.cpp"
            var $tobool159=((($and158))|0)!=0; //@line 546 "synth_mbrola.cpp"
            if ($tobool159) { __label__ = 42;; } else { __label__ = 43;; } //@line 546 "synth_mbrola.cpp"
            if (__label__ == 42) {
  
              var $129=$p; //@line 547 "synth_mbrola.cpp"
              var $length161=(($129+12)&4294967295); //@line 547 "synth_mbrola.cpp"
              var $130=HEAP16[(($length161)>>1)]; //@line 547 "synth_mbrola.cpp"
              var $conv162=(tempInt=(($130)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 547 "synth_mbrola.cpp"
              var $call163=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv162, -1); //@line 547 "synth_mbrola.cpp"
              $len=$call163; //@line 547 "synth_mbrola.cpp"
              ; //@line 547 "synth_mbrola.cpp"
            }
  
            var $131=$p; //@line 548 "synth_mbrola.cpp"
            var $length165=(($131+12)&4294967295); //@line 548 "synth_mbrola.cpp"
            var $132=HEAP16[(($length165)>>1)]; //@line 548 "synth_mbrola.cpp"
            var $conv166=(tempInt=(($132)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 548 "synth_mbrola.cpp"
            var $call167=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv166, -1); //@line 548 "synth_mbrola.cpp"
            var $133=$len; //@line 548 "synth_mbrola.cpp"
            var $add168=((($133)+($call167))&4294967295); //@line 548 "synth_mbrola.cpp"
            $len=$add168; //@line 548 "synth_mbrola.cpp"
            var $134=$len; //@line 550 "synth_mbrola.cpp"
            var $mul169=((($134)*1000)&4294967295); //@line 550 "synth_mbrola.cpp"
            var $135=HEAP32[((_samplerate)>>2)]; //@line 550 "synth_mbrola.cpp"
            var $div170=((((($mul169))|0)/((($135))|0))|0); //@line 550 "synth_mbrola.cpp"
            $len=$div170; //@line 550 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 551 "synth_mbrola.cpp"
          }
          else if (__label__ == 44) {
  
            var $136=$next; //@line 554 "synth_mbrola.cpp"
            var $type172=(($136+15)&4294967295); //@line 554 "synth_mbrola.cpp"
            var $137=HEAPU8[($type172)]; //@line 554 "synth_mbrola.cpp"
            var $conv173=((($137))&255); //@line 554 "synth_mbrola.cpp"
            var $cmp174=((($conv173))|0)!=2; //@line 554 "synth_mbrola.cpp"
            if (!($cmp174)) { __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; } //@line 554 "synth_mbrola.cpp"
  
            var $dest$, $stop$, $stop4$, $fast$, $value4$;
            $dest$ = $1;
            $stop$ = $dest$ + 48;
            $value4$ = 0;
            if ($value4$ < 0) $value4$ += 256;
            $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
            while ($dest$%4 !== 0 && $dest$ < $stop$) {
              ;; HEAP8[$dest$++] = 0;
            }
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($dest$ < $stop4$) {
            ;;;;;;;  HEAP32[$dest$++] = $value4$;
            }
            $dest$ <<= 2;
            while ($dest$ < $stop$) {
              ;; HEAP8[$dest$++] = 0;
            }; //@line 556 "synth_mbrola.cpp"
            var $138=$p; //@line 557 "synth_mbrola.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $138, $phdata); //@line 557 "synth_mbrola.cpp"
            var $139=HEAP32[(($arrayidx176)>>2)]; //@line 558 "synth_mbrola.cpp"
            HEAP32[(($fmt_addr)>>2)]=$139; //@line 558 "synth_mbrola.cpp"
            var $140=$p; //@line 559 "synth_mbrola.cpp"
            var $ph177=(($140+8)&4294967295); //@line 559 "synth_mbrola.cpp"
            var $141=HEAP32[(($ph177)>>2)]; //@line 559 "synth_mbrola.cpp"
            var $142=$p; //@line 559 "synth_mbrola.cpp"
            var $call178=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($141, 0, $fmtp, $142, -1); //@line 559 "synth_mbrola.cpp"
            $len=$call178; //@line 559 "synth_mbrola.cpp"
            var $143=$len; //@line 561 "synth_mbrola.cpp"
            var $mul179=((($143)*1000)&4294967295); //@line 561 "synth_mbrola.cpp"
            var $144=HEAP32[((_samplerate)>>2)]; //@line 561 "synth_mbrola.cpp"
            var $div180=((((($mul179))|0)/((($144))|0))|0); //@line 561 "synth_mbrola.cpp"
            $len=$div180; //@line 561 "synth_mbrola.cpp"
            var $145=$next; //@line 562 "synth_mbrola.cpp"
            var $type181=(($145+15)&4294967295); //@line 562 "synth_mbrola.cpp"
            var $146=HEAPU8[($type181)]; //@line 562 "synth_mbrola.cpp"
            var $conv182=((($146))&255); //@line 562 "synth_mbrola.cpp"
            var $cmp183=((($conv182))|0)==0; //@line 562 "synth_mbrola.cpp"
            if ($cmp183) { __label__ = 46;; } else { __label__ = 47;; } //@line 562 "synth_mbrola.cpp"
            if (__label__ == 46) {
  
              var $147=$len; //@line 563 "synth_mbrola.cpp"
              var $add185=((($147)+50)&4294967295); //@line 563 "synth_mbrola.cpp"
              $len=$add185; //@line 563 "synth_mbrola.cpp"
              ; //@line 563 "synth_mbrola.cpp"
            }
  
            var $148=$p; //@line 564 "synth_mbrola.cpp"
            var $env187=(($148+14)&4294967295); //@line 564 "synth_mbrola.cpp"
            var $149=HEAPU8[($env187)]; //@line 564 "synth_mbrola.cpp"
            var $conv188=((($149))&255); //@line 564 "synth_mbrola.cpp"
            var $150=$p; //@line 564 "synth_mbrola.cpp"
            var $pitch1189=(($150+20)&4294967295); //@line 564 "synth_mbrola.cpp"
            var $151=HEAPU8[($pitch1189)]; //@line 564 "synth_mbrola.cpp"
            var $conv190=((($151))&255); //@line 564 "synth_mbrola.cpp"
            var $152=$p; //@line 564 "synth_mbrola.cpp"
            var $pitch2191=(($152+21)&4294967295); //@line 564 "synth_mbrola.cpp"
            var $153=HEAPU8[($pitch2191)]; //@line 564 "synth_mbrola.cpp"
            var $conv192=((($153))&255); //@line 564 "synth_mbrola.cpp"
            __ZL10WritePitchiiiii($conv188, $conv190, $conv192, 0, 1); //@line 564 "synth_mbrola.cpp"
            $final_pitch=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 564 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 565 "synth_mbrola.cpp"
          }
          else if (__label__ == 48) {
  
            var $154=$next; //@line 569 "synth_mbrola.cpp"
            var $type196=(($154+15)&4294967295); //@line 569 "synth_mbrola.cpp"
            var $155=HEAPU8[($type196)]; //@line 569 "synth_mbrola.cpp"
            var $conv197=((($155))&255); //@line 569 "synth_mbrola.cpp"
            var $cmp198=((($conv197))|0)==0; //@line 569 "synth_mbrola.cpp"
            if (!($cmp198)) { __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; } //@line 569 "synth_mbrola.cpp"
  
            var $156=$len; //@line 571 "synth_mbrola.cpp"
            var $add200=((($156)+50)&4294967295); //@line 571 "synth_mbrola.cpp"
            $len=$add200; //@line 571 "synth_mbrola.cpp"
            var $157=$p; //@line 572 "synth_mbrola.cpp"
            var $env201=(($157+14)&4294967295); //@line 572 "synth_mbrola.cpp"
            var $158=HEAPU8[($env201)]; //@line 572 "synth_mbrola.cpp"
            var $conv202=((($158))&255); //@line 572 "synth_mbrola.cpp"
            var $159=$p; //@line 572 "synth_mbrola.cpp"
            var $pitch1203=(($159+20)&4294967295); //@line 572 "synth_mbrola.cpp"
            var $160=HEAPU8[($pitch1203)]; //@line 572 "synth_mbrola.cpp"
            var $conv204=((($160))&255); //@line 572 "synth_mbrola.cpp"
            var $161=$p; //@line 572 "synth_mbrola.cpp"
            var $pitch2205=(($161+21)&4294967295); //@line 572 "synth_mbrola.cpp"
            var $162=HEAPU8[($pitch2205)]; //@line 572 "synth_mbrola.cpp"
            var $conv206=((($162))&255); //@line 572 "synth_mbrola.cpp"
            __ZL10WritePitchiiiii($conv202, $conv204, $conv206, 0, 1); //@line 572 "synth_mbrola.cpp"
            $final_pitch=((__ZZL10WritePitchiiiiiE6output)&4294967295); //@line 572 "synth_mbrola.cpp"
            __label__ = 50;break $sw_epilog$$sw_bb$$sw_bb126$$sw_bb152$$sw_bb155$$sw_bb171$$sw_bb195$34; //@line 573 "synth_mbrola.cpp"
          }
        } while(0);
        $sw_epilog$$if_end222$69: do { 
          if (__label__ == 50) {
  
            var $_pr3=$done; //@line 577 "synth_mbrola.cpp"
            var $tobool209=((($_pr3))|0)!=0; //@line 577 "synth_mbrola.cpp"
            if ($tobool209) { __label__ = 54;break $sw_epilog$$if_end222$69; } //@line 577 "synth_mbrola.cpp"
  
            var $163=HEAP32[(($name2)>>2)]; //@line 579 "synth_mbrola.cpp"
            var $cmp211=((($163))|0)!=0; //@line 579 "synth_mbrola.cpp"
            if ($cmp211) { __label__ = 52;; } else { __label__ = 53;; } //@line 579 "synth_mbrola.cpp"
            if (__label__ == 52) {
  
              var $164=$len; //@line 581 "synth_mbrola.cpp"
              var $165=HEAP32[(($len_percent)>>2)]; //@line 581 "synth_mbrola.cpp"
              var $mul213=((($165)*($164))&4294967295); //@line 581 "synth_mbrola.cpp"
              var $div214=((((($mul213))|0)/100)|0); //@line 581 "synth_mbrola.cpp"
              $len1=$div214; //@line 581 "synth_mbrola.cpp"
              var $166=$ptr; //@line 582 "synth_mbrola.cpp"
              var $167=$len1; //@line 582 "synth_mbrola.cpp"
              var $168=HEAP32[(($name2)>>2)]; //@line 582 "synth_mbrola.cpp"
              var $call215=__Z12WordToStringj($168); //@line 582 "synth_mbrola.cpp"
              var $call216=_sprintf($166, ((__str10392)&4294967295), allocate([$167,0,0,0,((__ZZ12WordToStringjE3buf)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 582 "synth_mbrola.cpp"
              var $169=$ptr; //@line 582 "synth_mbrola.cpp"
              var $add_ptr217=(($169+$call216)&4294967295); //@line 582 "synth_mbrola.cpp"
              $ptr=$add_ptr217; //@line 582 "synth_mbrola.cpp"
              var $170=$len1; //@line 583 "synth_mbrola.cpp"
              var $171=$len; //@line 583 "synth_mbrola.cpp"
              var $sub218=((($171)-($170))&4294967295); //@line 583 "synth_mbrola.cpp"
              $len=$sub218; //@line 583 "synth_mbrola.cpp"
              ; //@line 584 "synth_mbrola.cpp"
            }
  
            var $172=$ptr; //@line 585 "synth_mbrola.cpp"
            var $173=$len; //@line 585 "synth_mbrola.cpp"
            var $174=$final_pitch; //@line 585 "synth_mbrola.cpp"
            var $call220=_sprintf($172, ((__str11393)&4294967295), allocate([$173,0,0,0,$174,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 585 "synth_mbrola.cpp"
            var $175=$ptr; //@line 585 "synth_mbrola.cpp"
            var $add_ptr221=(($175+$call220)&4294967295); //@line 585 "synth_mbrola.cpp"
            $ptr=$add_ptr221; //@line 585 "synth_mbrola.cpp"
            ; //@line 586 "synth_mbrola.cpp"
          }
        } while(0);
  
        var $176=$pause; //@line 588 "synth_mbrola.cpp"
        var $tobool223=((($176))|0)!=0; //@line 588 "synth_mbrola.cpp"
        if ($tobool223) { __label__ = 55;; } else { __label__ = 56;; } //@line 588 "synth_mbrola.cpp"
        if (__label__ == 55) {
  
          var $177=$pause; //@line 590 "synth_mbrola.cpp"
          var $call225=__Z11PauseLengthii($177, 0); //@line 590 "synth_mbrola.cpp"
          var $178=$len; //@line 590 "synth_mbrola.cpp"
          var $add226=((($178)+($call225))&4294967295); //@line 590 "synth_mbrola.cpp"
          $len=$add226; //@line 590 "synth_mbrola.cpp"
          var $179=$ptr; //@line 591 "synth_mbrola.cpp"
          var $180=$pause; //@line 591 "synth_mbrola.cpp"
          var $call227=__Z11PauseLengthii($180, 0); //@line 591 "synth_mbrola.cpp"
          var $call228=_sprintf($179, ((__str12394)&4294967295), allocate([$call227,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 591 "synth_mbrola.cpp"
          var $181=$ptr; //@line 591 "synth_mbrola.cpp"
          var $add_ptr229=(($181+$call228)&4294967295); //@line 591 "synth_mbrola.cpp"
          $ptr=$add_ptr229; //@line 591 "synth_mbrola.cpp"
          $pause=0; //@line 592 "synth_mbrola.cpp"
          ; //@line 593 "synth_mbrola.cpp"
        }
  
        var $182=$f_mbrola_addr; //@line 595 "synth_mbrola.cpp"
        var $tobool231=((($182))|0)!=0; //@line 595 "synth_mbrola.cpp"
        if ($tobool231) { __label__ = 57;; } else { __label__ = 58;; } //@line 595 "synth_mbrola.cpp"
        if (__label__ == 57) {
  
          var $183=$ptr; //@line 597 "synth_mbrola.cpp"
          var $sub_ptr_lhs_cast=($183); //@line 597 "synth_mbrola.cpp"
          var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 597 "synth_mbrola.cpp"
          var $184=$f_mbrola_addr; //@line 597 "synth_mbrola.cpp"
          var $call235=_fwrite($arraydecay233, 1, $sub_ptr_sub, $184); //@line 597 "synth_mbrola.cpp"
          ; //@line 598 "synth_mbrola.cpp"
        }
        else if (__label__ == 58) {
  
          var $call238=_write_MBR($arraydecay233); //@line 601 "synth_mbrola.cpp"
          $res=$call238; //@line 601 "synth_mbrola.cpp"
          var $185=$res; //@line 602 "synth_mbrola.cpp"
          var $cmp239=((($185))|0) < 0; //@line 602 "synth_mbrola.cpp"
          if ($cmp239) { __label__ = 59;break $while_cond$5; } //@line 602 "synth_mbrola.cpp"
  
          var $186=$res; //@line 604 "synth_mbrola.cpp"
          var $cmp242=((($186))|0)==0; //@line 604 "synth_mbrola.cpp"
          if ($cmp242) { __label__ = 61;break $while_cond$5; } //@line 604 "synth_mbrola.cpp"
  
          var $187=HEAP32[((_wcmdq_tail)>>2)]; //@line 606 "synth_mbrola.cpp"
          var $arrayidx245=((_wcmdq+$187*16)&4294967295); //@line 606 "synth_mbrola.cpp"
          var $arrayidx246=(($arrayidx245)&4294967295); //@line 606 "synth_mbrola.cpp"
          HEAP32[(($arrayidx246)>>2)]=13; //@line 606 "synth_mbrola.cpp"
          var $188=$len; //@line 607 "synth_mbrola.cpp"
          var $189=HEAP32[((_wcmdq_tail)>>2)]; //@line 607 "synth_mbrola.cpp"
          var $arrayidx247=((_wcmdq+$189*16)&4294967295); //@line 607 "synth_mbrola.cpp"
          var $arrayidx248=(($arrayidx247+4)&4294967295); //@line 607 "synth_mbrola.cpp"
          HEAP32[(($arrayidx248)>>2)]=$188; //@line 607 "synth_mbrola.cpp"
          __Z8WcmdqIncv(); //@line 608 "synth_mbrola.cpp"
          ;
        }
  
        var $190=HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]; //@line 611 "synth_mbrola.cpp"
        var $inc250=((($190)+1)&4294967295); //@line 611 "synth_mbrola.cpp"
        HEAP32[((__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix)>>2)]=$inc250; //@line 611 "synth_mbrola.cpp"
        __label__ = 3;continue $while_cond$5; //@line 612 "synth_mbrola.cpp"
      }
    }
    if (__label__ == 64) {
  
      var $191=$f_mbrola_addr; //@line 614 "synth_mbrola.cpp"
      var $tobool251=((($191))|0)!=0; //@line 614 "synth_mbrola.cpp"
      if ($tobool251) { __label__ = 66;; } else { __label__ = 65;; } //@line 614 "synth_mbrola.cpp"
      if (__label__ == 65) {
  
        var $call253=_flush_MBR(); //@line 616 "synth_mbrola.cpp"
        var $192=HEAP32[((_wcmdq_tail)>>2)]; //@line 619 "synth_mbrola.cpp"
        var $arrayidx254=((_wcmdq+$192*16)&4294967295); //@line 619 "synth_mbrola.cpp"
        var $arrayidx255=(($arrayidx254)&4294967295); //@line 619 "synth_mbrola.cpp"
        HEAP32[(($arrayidx255)>>2)]=13; //@line 619 "synth_mbrola.cpp"
        var $193=HEAP32[((_wcmdq_tail)>>2)]; //@line 620 "synth_mbrola.cpp"
        var $arrayidx256=((_wcmdq+$193*16)&4294967295); //@line 620 "synth_mbrola.cpp"
        var $arrayidx257=(($arrayidx256+4)&4294967295); //@line 620 "synth_mbrola.cpp"
        HEAP32[(($arrayidx257)>>2)]=500; //@line 620 "synth_mbrola.cpp"
        __Z8WcmdqIncv(); //@line 621 "synth_mbrola.cpp"
        ; //@line 622 "synth_mbrola.cpp"
      }
  
      $retval=0; //@line 624 "synth_mbrola.cpp"
      ; //@line 624 "synth_mbrola.cpp"
    }
    else if (__label__ == 5) {
  
      $retval=1; //@line 439 "synth_mbrola.cpp"
      ; //@line 439 "synth_mbrola.cpp"
    }
    else if (__label__ == 59) {
  
      $retval=0; //@line 603 "synth_mbrola.cpp"
      ; //@line 603 "synth_mbrola.cpp"
    }
    else if (__label__ == 61) {
  
      $retval=1; //@line 605 "synth_mbrola.cpp"
      ; //@line 605 "synth_mbrola.cpp"
    }
  
    var $194=$retval; //@line 625 "synth_mbrola.cpp"
    STACKTOP = __stackBase__;
    return $194; //@line 625 "synth_mbrola.cpp"
    return null;
  }
  

  function __ZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_($plist, $ph, $ph_prev, $ph_next, $name2, $split, $control) {
    ;
    var __label__;
  
    var $retval;
    var $plist_addr;
    var $ph_addr;
    var $ph_prev_addr;
    var $ph_next_addr;
    var $name2_addr;
    var $split_addr;
    var $control_addr;
    var $pr;
    var $other_ph;
    var $found;
    $plist_addr=$plist;
    $ph_addr=$ph;
    $ph_prev_addr=$ph_prev;
    $ph_next_addr=$ph_next;
    $name2_addr=$name2;
    $split_addr=$split;
    $control_addr=$control;
    $found=0; //@line 209 "synth_mbrola.cpp"
    var $0=$name2_addr; //@line 219 "synth_mbrola.cpp"
    HEAP32[(($0)>>2)]=0; //@line 219 "synth_mbrola.cpp"
    var $1=$split_addr; //@line 220 "synth_mbrola.cpp"
    HEAP32[(($1)>>2)]=0; //@line 220 "synth_mbrola.cpp"
    var $2=$control_addr; //@line 221 "synth_mbrola.cpp"
    HEAP32[(($2)>>2)]=0; //@line 221 "synth_mbrola.cpp"
    var $3=$ph_addr; //@line 222 "synth_mbrola.cpp"
    var $mnemonic=(($3)&4294967295); //@line 222 "synth_mbrola.cpp"
    var $4=HEAP32[(($mnemonic)>>2)]; //@line 222 "synth_mbrola.cpp"
    HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]=$4; //@line 222 "synth_mbrola.cpp"
    var $5=HEAP32[((__ZL10mbrola_tab)>>2)]; //@line 224 "synth_mbrola.cpp"
    $pr=$5; //@line 224 "synth_mbrola.cpp"
    ; //@line 225 "synth_mbrola.cpp"
    $while_cond$2: while(1) { 
  
      var $6=$pr; //@line 225 "synth_mbrola.cpp"
      var $name=(($6)&4294967295); //@line 225 "synth_mbrola.cpp"
      var $7=HEAP32[(($name)>>2)]; //@line 225 "synth_mbrola.cpp"
      var $cmp=((($7))|0)!=0; //@line 225 "synth_mbrola.cpp"
      if (!($cmp)) { __label__ = 28;break $while_cond$2; } //@line 225 "synth_mbrola.cpp"
  
      var $8=HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]; //@line 227 "synth_mbrola.cpp"
      var $9=$pr; //@line 227 "synth_mbrola.cpp"
      var $name1=(($9)&4294967295); //@line 227 "synth_mbrola.cpp"
      var $10=HEAP32[(($name1)>>2)]; //@line 227 "synth_mbrola.cpp"
      var $cmp2=((($8))|0)==((($10))|0); //@line 227 "synth_mbrola.cpp"
      if ($cmp2) { __label__ = 3;; } else { __label__ = 27;; } //@line 227 "synth_mbrola.cpp"
      $if_then$$if_end60$5: do { 
        if (__label__ == 3) {
  
          var $11=$pr; //@line 229 "synth_mbrola.cpp"
          var $next_phoneme=(($11+4)&4294967295); //@line 229 "synth_mbrola.cpp"
          var $12=HEAP32[(($next_phoneme)>>2)]; //@line 229 "synth_mbrola.cpp"
          var $cmp3=((($12))|0)==0; //@line 229 "synth_mbrola.cpp"
          if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 229 "synth_mbrola.cpp"
          $if_then4$$if_else$7: do { 
            if (__label__ == 4) {
  
              $found=1; //@line 230 "synth_mbrola.cpp"
              ; //@line 230 "synth_mbrola.cpp"
            }
            else if (__label__ == 5) {
  
              var $13=$pr; //@line 232 "synth_mbrola.cpp"
              var $next_phoneme5=(($13+4)&4294967295); //@line 232 "synth_mbrola.cpp"
              var $14=HEAP32[(($next_phoneme5)>>2)]; //@line 232 "synth_mbrola.cpp"
              var $cmp6=((($14))|0)==58; //@line 232 "synth_mbrola.cpp"
              if ($cmp6) { __label__ = 6;; } else { __label__ = 8;; } //@line 232 "synth_mbrola.cpp"
              $land_lhs_true$$if_else8$10: do { 
                if (__label__ == 6) {
  
                  var $15=$plist_addr; //@line 232 "synth_mbrola.cpp"
                  var $synthflags=(($15+4)&4294967295); //@line 232 "synth_mbrola.cpp"
                  var $16=HEAPU16[(($synthflags)>>1)]; //@line 232 "synth_mbrola.cpp"
                  var $conv=((($16))&65535); //@line 232 "synth_mbrola.cpp"
                  var $and=($conv) & 8; //@line 232 "synth_mbrola.cpp"
                  var $tobool=((($and))|0)!=0; //@line 232 "synth_mbrola.cpp"
                  if (!($tobool)) { __label__ = 8;break $land_lhs_true$$if_else8$10; } //@line 232 "synth_mbrola.cpp"
  
                  $found=1; //@line 234 "synth_mbrola.cpp"
                  __label__ = 20;break $if_then4$$if_else$7; //@line 235 "synth_mbrola.cpp"
                }
              } while(0);
  
              var $17=$pr; //@line 238 "synth_mbrola.cpp"
              var $control9=(($17+20)&4294967295); //@line 238 "synth_mbrola.cpp"
              var $18=HEAP32[(($control9)>>2)]; //@line 238 "synth_mbrola.cpp"
              var $and10=($18) & 2; //@line 238 "synth_mbrola.cpp"
              var $tobool11=((($and10))|0)!=0; //@line 238 "synth_mbrola.cpp"
              if ($tobool11) { __label__ = 9;; } else { __label__ = 10;; } //@line 238 "synth_mbrola.cpp"
              $if_then12$$if_else13$14: do { 
                if (__label__ == 9) {
  
                  var $19=$ph_prev_addr; //@line 239 "synth_mbrola.cpp"
                  $other_ph=$19; //@line 239 "synth_mbrola.cpp"
                  ; //@line 239 "synth_mbrola.cpp"
                }
                else if (__label__ == 10) {
  
                  var $20=$pr; //@line 241 "synth_mbrola.cpp"
                  var $control14=(($20+20)&4294967295); //@line 241 "synth_mbrola.cpp"
                  var $21=HEAP32[(($control14)>>2)]; //@line 241 "synth_mbrola.cpp"
                  var $and15=($21) & 8; //@line 241 "synth_mbrola.cpp"
                  var $tobool16=((($and15))|0)!=0; //@line 241 "synth_mbrola.cpp"
                  if ($tobool16) { __label__ = 11;; } else { __label__ = 13;; } //@line 241 "synth_mbrola.cpp"
                  $land_lhs_true17$$if_else20$17: do { 
                    if (__label__ == 11) {
  
                      var $22=$plist_addr; //@line 241 "synth_mbrola.cpp"
                      var $add_ptr=(($22+24)&4294967295); //@line 241 "synth_mbrola.cpp"
                      var $newword=(($add_ptr+19)&4294967295); //@line 241 "synth_mbrola.cpp"
                      var $23=HEAP8[($newword)]; //@line 241 "synth_mbrola.cpp"
                      var $tobool18=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 241 "synth_mbrola.cpp"
                      if (!($tobool18)) { __label__ = 13;break $land_lhs_true17$$if_else20$17; } //@line 241 "synth_mbrola.cpp"
  
                      var $24=HEAP32[((((_phoneme_tab)&4294967295))>>2)]; //@line 242 "synth_mbrola.cpp"
                      $other_ph=$24; //@line 242 "synth_mbrola.cpp"
                      __label__ = 14;break $if_then12$$if_else13$14; //@line 242 "synth_mbrola.cpp"
                    }
                  } while(0);
  
                  var $25=$ph_next_addr; //@line 244 "synth_mbrola.cpp"
                  $other_ph=$25; //@line 244 "synth_mbrola.cpp"
                  ;
                }
              } while(0);
  
              var $26=$pr; //@line 246 "synth_mbrola.cpp"
              var $next_phoneme22=(($26+4)&4294967295); //@line 246 "synth_mbrola.cpp"
              var $27=HEAP32[(($next_phoneme22)>>2)]; //@line 246 "synth_mbrola.cpp"
              var $28=$other_ph; //@line 246 "synth_mbrola.cpp"
              var $mnemonic23=(($28)&4294967295); //@line 246 "synth_mbrola.cpp"
              var $29=HEAP32[(($mnemonic23)>>2)]; //@line 246 "synth_mbrola.cpp"
              var $cmp24=((($27))|0)==((($29))|0); //@line 246 "synth_mbrola.cpp"
              if ($cmp24) { __label__ = 19;; } else { __label__ = 15;; } //@line 246 "synth_mbrola.cpp"
              $if_then37$$lor_lhs_false$22: do { 
                if (__label__ == 15) {
  
                  var $30=$pr; //@line 246 "synth_mbrola.cpp"
                  var $next_phoneme25=(($30+4)&4294967295); //@line 246 "synth_mbrola.cpp"
                  var $31=HEAP32[(($next_phoneme25)>>2)]; //@line 246 "synth_mbrola.cpp"
                  var $cmp26=((($31))|0)==2; //@line 246 "synth_mbrola.cpp"
                  if ($cmp26) { __label__ = 16;; } else { __label__ = 17;; } //@line 246 "synth_mbrola.cpp"
                  if (__label__ == 16) {
  
                    var $32=$other_ph; //@line 246 "synth_mbrola.cpp"
                    var $type=(($32+11)&4294967295); //@line 246 "synth_mbrola.cpp"
                    var $33=HEAPU8[($type)]; //@line 246 "synth_mbrola.cpp"
                    var $conv28=((($33))&255); //@line 246 "synth_mbrola.cpp"
                    var $cmp29=((($conv28))|0)==2; //@line 246 "synth_mbrola.cpp"
                    if ($cmp29) { __label__ = 19;break $if_then37$$lor_lhs_false$22; } //@line 246 "synth_mbrola.cpp"
                  }
  
                  var $34=$pr; //@line 246 "synth_mbrola.cpp"
                  var $next_phoneme31=(($34+4)&4294967295); //@line 246 "synth_mbrola.cpp"
                  var $35=HEAP32[(($next_phoneme31)>>2)]; //@line 246 "synth_mbrola.cpp"
                  var $cmp32=((($35))|0)==95; //@line 246 "synth_mbrola.cpp"
                  if (!($cmp32)) { __label__ = 20;break $if_then4$$if_else$7; } //@line 246 "synth_mbrola.cpp"
  
                  var $36=$other_ph; //@line 246 "synth_mbrola.cpp"
                  var $type34=(($36+11)&4294967295); //@line 246 "synth_mbrola.cpp"
                  var $37=HEAPU8[($type34)]; //@line 246 "synth_mbrola.cpp"
                  var $conv35=((($37))&255); //@line 246 "synth_mbrola.cpp"
                  var $cmp36=((($conv35))|0)==0; //@line 246 "synth_mbrola.cpp"
                  if (!($cmp36)) { __label__ = 20;break $if_then4$$if_else$7; } //@line 246 "synth_mbrola.cpp"
                }
              } while(0);
  
              $found=1; //@line 250 "synth_mbrola.cpp"
              ; //@line 251 "synth_mbrola.cpp"
            }
          } while(0);
  
          var $38=$pr; //@line 254 "synth_mbrola.cpp"
          var $control41=(($38+20)&4294967295); //@line 254 "synth_mbrola.cpp"
          var $39=HEAP32[(($control41)>>2)]; //@line 254 "synth_mbrola.cpp"
          var $and42=($39) & 4; //@line 254 "synth_mbrola.cpp"
          var $tobool43=((($and42))|0)!=0; //@line 254 "synth_mbrola.cpp"
          if ($tobool43) { __label__ = 21;; } else { __label__ = 23;; } //@line 254 "synth_mbrola.cpp"
          $land_lhs_true44$$if_end49$30: do { 
            if (__label__ == 21) {
  
              var $40=$plist_addr; //@line 254 "synth_mbrola.cpp"
              var $newword45=(($40+19)&4294967295); //@line 254 "synth_mbrola.cpp"
              var $41=HEAPU8[($newword45)]; //@line 254 "synth_mbrola.cpp"
              var $conv46=((($41))&255); //@line 254 "synth_mbrola.cpp"
              var $cmp47=((($conv46))|0)==0; //@line 254 "synth_mbrola.cpp"
              if (!($cmp47)) { __label__ = 23;break $land_lhs_true44$$if_end49$30; } //@line 254 "synth_mbrola.cpp"
  
              $found=0; //@line 255 "synth_mbrola.cpp"
              __label__ = 27;break $if_then$$if_end60$5; //@line 257 "synth_mbrola.cpp"
            }
          } while(0);
  
          var $_pr=$found; //@line 257 "synth_mbrola.cpp"
          var $tobool50=((($_pr))|0)!=0; //@line 257 "synth_mbrola.cpp"
          if ($tobool50) { __label__ = 24;break $while_cond$2; } //@line 257 "synth_mbrola.cpp"
        }
      } while(0);
  
      var $55=$pr; //@line 273 "synth_mbrola.cpp"
      var $incdec_ptr=(($55+24)&4294967295); //@line 273 "synth_mbrola.cpp"
      $pr=$incdec_ptr; //@line 273 "synth_mbrola.cpp"
      __label__ = 1;continue $while_cond$2; //@line 274 "synth_mbrola.cpp"
    }
    $while_end$$if_then51$35: do { 
      if (__label__ == 24) {
  
        var $42=$pr; //@line 259 "synth_mbrola.cpp"
        var $mbr_name2=(($42+12)&4294967295); //@line 259 "synth_mbrola.cpp"
        var $43=HEAP32[(($mbr_name2)>>2)]; //@line 259 "synth_mbrola.cpp"
        var $44=$name2_addr; //@line 259 "synth_mbrola.cpp"
        HEAP32[(($44)>>2)]=$43; //@line 259 "synth_mbrola.cpp"
        var $45=$pr; //@line 260 "synth_mbrola.cpp"
        var $percent=(($45+16)&4294967295); //@line 260 "synth_mbrola.cpp"
        var $46=HEAP32[(($percent)>>2)]; //@line 260 "synth_mbrola.cpp"
        var $47=$split_addr; //@line 260 "synth_mbrola.cpp"
        HEAP32[(($47)>>2)]=$46; //@line 260 "synth_mbrola.cpp"
        var $48=$pr; //@line 261 "synth_mbrola.cpp"
        var $control52=(($48+20)&4294967295); //@line 261 "synth_mbrola.cpp"
        var $49=HEAP32[(($control52)>>2)]; //@line 261 "synth_mbrola.cpp"
        var $50=$control_addr; //@line 261 "synth_mbrola.cpp"
        HEAP32[(($50)>>2)]=$49; //@line 261 "synth_mbrola.cpp"
        var $51=$pr; //@line 263 "synth_mbrola.cpp"
        var $control53=(($51+20)&4294967295); //@line 263 "synth_mbrola.cpp"
        var $52=HEAP32[(($control53)>>2)]; //@line 263 "synth_mbrola.cpp"
        var $and54=($52) & 16; //@line 263 "synth_mbrola.cpp"
        var $tobool55=((($and54))|0)!=0; //@line 263 "synth_mbrola.cpp"
        var $53=$pr; //@line 265 "synth_mbrola.cpp"
        var $mbr_name=(($53+8)&4294967295); //@line 265 "synth_mbrola.cpp"
        var $54=HEAP32[(($mbr_name)>>2)]; //@line 265 "synth_mbrola.cpp"
        if ($tobool55) { __label__ = 25;; } else { __label__ = 26;; } //@line 263 "synth_mbrola.cpp"
        if (__label__ == 25) {
  
          HEAP32[((__ZL15mbr_name_prefix)>>2)]=$54; //@line 265 "synth_mbrola.cpp"
          $retval=0; //@line 266 "synth_mbrola.cpp"
          __label__ = 31;break $while_end$$if_then51$35; //@line 266 "synth_mbrola.cpp"
        }
        else if (__label__ == 26) {
  
          HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]=$54; //@line 268 "synth_mbrola.cpp"
          __label__ = 28;break $while_end$$if_then51$35; //@line 269 "synth_mbrola.cpp"
        }
      }
    } while(0);
    if (__label__ == 28) {
  
      var $56=HEAP32[((__ZL15mbr_name_prefix)>>2)]; //@line 276 "synth_mbrola.cpp"
      var $cmp61=((($56))|0)!=0; //@line 276 "synth_mbrola.cpp"
      if ($cmp61) { __label__ = 29;; } else { __label__ = 30;; } //@line 276 "synth_mbrola.cpp"
      if (__label__ == 29) {
  
        var $57=HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]; //@line 278 "synth_mbrola.cpp"
        var $shl=($57) << 8; //@line 278 "synth_mbrola.cpp"
        var $58=HEAP32[((__ZL15mbr_name_prefix)>>2)]; //@line 278 "synth_mbrola.cpp"
        var $and63=($58) & 255; //@line 278 "synth_mbrola.cpp"
        var $or=($and63) | ($shl); //@line 278 "synth_mbrola.cpp"
        HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]=$or; //@line 278 "synth_mbrola.cpp"
        ; //@line 279 "synth_mbrola.cpp"
      }
  
      HEAP32[((__ZL15mbr_name_prefix)>>2)]=0; //@line 280 "synth_mbrola.cpp"
      var $59=HEAP32[((__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem)>>2)]; //@line 281 "synth_mbrola.cpp"
      $retval=$59; //@line 281 "synth_mbrola.cpp"
      ; //@line 281 "synth_mbrola.cpp"
    }
  
    var $60=$retval; //@line 282 "synth_mbrola.cpp"
    ;
    return $60; //@line 282 "synth_mbrola.cpp"
    return null;
  }
  

  function __ZL10WritePitchiiiii($env, $pitch1, $pitch2, $split, $final) {
    var __stackBase__  = STACKTOP; STACKTOP += 76; _memset(__stackBase__, 0, 76);
    var __label__;
    var __lastLabel__ = null;
  
    var $env_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    var $split_addr;
    var $final_addr;
    var $x;
    var $ix;
    var $pitch_base=__stackBase__;
    var $pitch_range=__stackBase__+4;
    var $p1;
    var $p2;
    var $p_end;
    var $pitch_env;
    var $max;
    var $min;
    var $y_max;
    var $y_min;
    var $env100;
    var $y2;
    var $y=__stackBase__+8;
    var $env_split;
    var $buf=__stackBase__+24;
    $env_addr=$env;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    $split_addr=$split;
    $final_addr=$final;
    $max=-1; //@line 294 "synth_mbrola.cpp"
    $min=999; //@line 295 "synth_mbrola.cpp"
    $y_max=0; //@line 296 "synth_mbrola.cpp"
    $y_min=0; //@line 297 "synth_mbrola.cpp"
    $env100=80; //@line 298 "synth_mbrola.cpp"
    HEAP8[(((__ZZL10WritePitchiiiiiE6output)&4294967295))]=0; //@line 305 "synth_mbrola.cpp"
    var $0=$env_addr; //@line 306 "synth_mbrola.cpp"
    var $arrayidx=((_envelope_data+$0*4)&4294967295); //@line 306 "synth_mbrola.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 306 "synth_mbrola.cpp"
    $pitch_env=$1; //@line 306 "synth_mbrola.cpp"
    var $2=HEAP32[((_voice)>>2)]; //@line 309 "synth_mbrola.cpp"
    var $3=$pitch1_addr; //@line 309 "synth_mbrola.cpp"
    var $4=$pitch2_addr; //@line 309 "synth_mbrola.cpp"
    __Z9SetPitch2P7voice_tiiPiS1_($2, $3, $4, $pitch_base, $pitch_range); //@line 309 "synth_mbrola.cpp"
    var $5=$split_addr; //@line 312 "synth_mbrola.cpp"
    var $mul=((($5)*128)&4294967295); //@line 312 "synth_mbrola.cpp"
    var $div=((((($mul))|0)/100)|0); //@line 312 "synth_mbrola.cpp"
    $env_split=$div; //@line 312 "synth_mbrola.cpp"
    var $6=$env_split; //@line 313 "synth_mbrola.cpp"
    var $cmp=((($6))|0) < 0; //@line 313 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 313 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      var $7=$env_split; //@line 314 "synth_mbrola.cpp"
      var $sub=(((-($7)))&4294967295); //@line 314 "synth_mbrola.cpp"
      $env_split=$sub; //@line 314 "synth_mbrola.cpp"
      ; //@line 314 "synth_mbrola.cpp"
    }
  
    $x=0; //@line 317 "synth_mbrola.cpp"
    ; //@line 317 "synth_mbrola.cpp"
    $for_body$5: while(1) { 
  
      var $8=$x; //@line 319 "synth_mbrola.cpp"
      var $9=$pitch_env; //@line 319 "synth_mbrola.cpp"
      var $arrayidx2=(($9+$8)&4294967295); //@line 319 "synth_mbrola.cpp"
      var $10=HEAPU8[($arrayidx2)]; //@line 319 "synth_mbrola.cpp"
      var $conv=((($10))&255); //@line 319 "synth_mbrola.cpp"
      var $11=$max; //@line 319 "synth_mbrola.cpp"
      var $cmp3=((($conv))|0) > ((($11))|0); //@line 319 "synth_mbrola.cpp"
      if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 319 "synth_mbrola.cpp"
      if (__label__ == 4) {
  
        var $12=$x; //@line 321 "synth_mbrola.cpp"
        var $13=$pitch_env; //@line 321 "synth_mbrola.cpp"
        var $arrayidx5=(($13+$12)&4294967295); //@line 321 "synth_mbrola.cpp"
        var $14=HEAPU8[($arrayidx5)]; //@line 321 "synth_mbrola.cpp"
        var $conv6=((($14))&255); //@line 321 "synth_mbrola.cpp"
        $max=$conv6; //@line 321 "synth_mbrola.cpp"
        var $15=$x; //@line 322 "synth_mbrola.cpp"
        $y_max=$15; //@line 322 "synth_mbrola.cpp"
        ; //@line 323 "synth_mbrola.cpp"
      }
  
      var $16=$x; //@line 324 "synth_mbrola.cpp"
      var $17=$pitch_env; //@line 324 "synth_mbrola.cpp"
      var $arrayidx8=(($17+$16)&4294967295); //@line 324 "synth_mbrola.cpp"
      var $18=HEAPU8[($arrayidx8)]; //@line 324 "synth_mbrola.cpp"
      var $conv9=((($18))&255); //@line 324 "synth_mbrola.cpp"
      var $19=$min; //@line 324 "synth_mbrola.cpp"
      var $cmp10=((($conv9))|0) < ((($19))|0); //@line 324 "synth_mbrola.cpp"
      if ($cmp10) { __label__ = 6;; } else { __label__ = 7;; } //@line 324 "synth_mbrola.cpp"
      if (__label__ == 6) {
  
        var $20=$x; //@line 326 "synth_mbrola.cpp"
        var $21=$pitch_env; //@line 326 "synth_mbrola.cpp"
        var $arrayidx12=(($21+$20)&4294967295); //@line 326 "synth_mbrola.cpp"
        var $22=HEAPU8[($arrayidx12)]; //@line 326 "synth_mbrola.cpp"
        var $conv13=((($22))&255); //@line 326 "synth_mbrola.cpp"
        $min=$conv13; //@line 326 "synth_mbrola.cpp"
        var $23=$x; //@line 327 "synth_mbrola.cpp"
        $y_min=$23; //@line 327 "synth_mbrola.cpp"
        ; //@line 328 "synth_mbrola.cpp"
      }
  
      var $24=$x; //@line 317 "synth_mbrola.cpp"
      var $inc=((($24)+1)&4294967295); //@line 317 "synth_mbrola.cpp"
      $x=$inc; //@line 317 "synth_mbrola.cpp"
      var $cmp1=((($inc))|0) < 128; //@line 317 "synth_mbrola.cpp"
      if ($cmp1) { __label__ = 3;continue $for_body$5; } else { __label__ = 8;break $for_body$5; } //@line 317 "synth_mbrola.cpp"
    }
  
    var $arrayidx15=(($y+8)&4294967295); //@line 332 "synth_mbrola.cpp"
    HEAP32[(($arrayidx15)>>2)]=64; //@line 332 "synth_mbrola.cpp"
    var $25=$y_max; //@line 333 "synth_mbrola.cpp"
    var $cmp16=((($25))|0) > 0; //@line 333 "synth_mbrola.cpp"
    var $26=$y_max; //@line 333 "synth_mbrola.cpp"
    var $cmp17=((($26))|0) < 127; //@line 333 "synth_mbrola.cpp"
    var $or_cond=($cmp16) & ($cmp17); //@line 333 "synth_mbrola.cpp"
    if ($or_cond) { __label__ = 9;; } else { __label__ = 10;; } //@line 333 "synth_mbrola.cpp"
    if (__label__ == 9) {
  
      var $27=$y_max; //@line 335 "synth_mbrola.cpp"
      var $arrayidx19=(($y+8)&4294967295); //@line 335 "synth_mbrola.cpp"
      HEAP32[(($arrayidx19)>>2)]=$27; //@line 335 "synth_mbrola.cpp"
      ; //@line 336 "synth_mbrola.cpp"
    }
  
    var $28=$y_min; //@line 337 "synth_mbrola.cpp"
    var $cmp21=((($28))|0) > 0; //@line 337 "synth_mbrola.cpp"
    var $29=$y_min; //@line 337 "synth_mbrola.cpp"
    var $cmp23=((($29))|0) < 127; //@line 337 "synth_mbrola.cpp"
    var $or_cond1=($cmp21) & ($cmp23); //@line 337 "synth_mbrola.cpp"
    if ($or_cond1) { __label__ = 11;; } else { __label__ = 12;; } //@line 337 "synth_mbrola.cpp"
    if (__label__ == 11) {
  
      var $30=$y_min; //@line 339 "synth_mbrola.cpp"
      var $arrayidx25=(($y+8)&4294967295); //@line 339 "synth_mbrola.cpp"
      HEAP32[(($arrayidx25)>>2)]=$30; //@line 339 "synth_mbrola.cpp"
      ; //@line 340 "synth_mbrola.cpp"
    }
  
    var $arrayidx27=(($y+8)&4294967295); //@line 341 "synth_mbrola.cpp"
    var $31=HEAP32[(($arrayidx27)>>2)]; //@line 341 "synth_mbrola.cpp"
    var $div28=((((($31))|0)/2)|0); //@line 341 "synth_mbrola.cpp"
    var $arrayidx29=(($y+4)&4294967295); //@line 341 "synth_mbrola.cpp"
    HEAP32[(($arrayidx29)>>2)]=$div28; //@line 341 "synth_mbrola.cpp"
    var $arrayidx30=(($y+8)&4294967295); //@line 342 "synth_mbrola.cpp"
    var $32=HEAP32[(($arrayidx30)>>2)]; //@line 342 "synth_mbrola.cpp"
    var $arrayidx31=(($y+8)&4294967295); //@line 342 "synth_mbrola.cpp"
    var $33=HEAP32[(($arrayidx31)>>2)]; //@line 342 "synth_mbrola.cpp"
    var $sub32=((127-($33))&4294967295); //@line 342 "synth_mbrola.cpp"
    var $div33=((((($sub32))|0)/2)|0); //@line 342 "synth_mbrola.cpp"
    var $add=((($div33)+($32))&4294967295); //@line 342 "synth_mbrola.cpp"
    var $arrayidx34=(($y+12)&4294967295); //@line 342 "synth_mbrola.cpp"
    HEAP32[(($arrayidx34)>>2)]=$add; //@line 342 "synth_mbrola.cpp"
    var $34=$pitch_env; //@line 345 "synth_mbrola.cpp"
    var $arrayidx35=(($34)&4294967295); //@line 345 "synth_mbrola.cpp"
    var $35=HEAPU8[($arrayidx35)]; //@line 345 "synth_mbrola.cpp"
    var $conv36=((($35))&255); //@line 345 "synth_mbrola.cpp"
    var $36=HEAP32[(($pitch_range)>>2)]; //@line 345 "synth_mbrola.cpp"
    var $mul37=((($conv36)*($36))&4294967295); //@line 345 "synth_mbrola.cpp"
    var $shr=($mul37) >> 8; //@line 345 "synth_mbrola.cpp"
    var $37=HEAP32[(($pitch_base)>>2)]; //@line 345 "synth_mbrola.cpp"
    var $add38=((($shr)+($37))&4294967295); //@line 345 "synth_mbrola.cpp"
    $p1=$add38; //@line 345 "synth_mbrola.cpp"
    var $38=$pitch_env; //@line 346 "synth_mbrola.cpp"
    var $arrayidx39=(($38+127)&4294967295); //@line 346 "synth_mbrola.cpp"
    var $39=HEAPU8[($arrayidx39)]; //@line 346 "synth_mbrola.cpp"
    var $conv40=((($39))&255); //@line 346 "synth_mbrola.cpp"
    var $40=HEAP32[(($pitch_range)>>2)]; //@line 346 "synth_mbrola.cpp"
    var $mul41=((($conv40)*($40))&4294967295); //@line 346 "synth_mbrola.cpp"
    var $shr42=($mul41) >> 8; //@line 346 "synth_mbrola.cpp"
    var $41=HEAP32[(($pitch_base)>>2)]; //@line 346 "synth_mbrola.cpp"
    var $add43=((($shr42)+($41))&4294967295); //@line 346 "synth_mbrola.cpp"
    $p_end=$add43; //@line 346 "synth_mbrola.cpp"
    var $42=$split_addr; //@line 349 "synth_mbrola.cpp"
    var $cmp44=((($42))|0) >= 0; //@line 349 "synth_mbrola.cpp"
    if ($cmp44) { __label__ = 13;; } else { __label__ = 14;; } //@line 349 "synth_mbrola.cpp"
    if (__label__ == 13) {
  
      var $arraydecay=(($buf)&4294967295); //@line 351 "synth_mbrola.cpp"
      var $43=$p1; //@line 351 "synth_mbrola.cpp"
      var $div46=((((($43))|0)/4096)|0); //@line 351 "synth_mbrola.cpp"
      var $call=_sprintf($arraydecay, ((__str13395)&4294967295), allocate([$div46,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 351 "synth_mbrola.cpp"
      var $arraydecay47=(($buf)&4294967295); //@line 352 "synth_mbrola.cpp"
      var $call48=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay47); //@line 352 "synth_mbrola.cpp"
      ; //@line 353 "synth_mbrola.cpp"
    }
  
    var $44=$env_addr; //@line 356 "synth_mbrola.cpp"
    var $cmp50=((($44))|0) > 1; //@line 356 "synth_mbrola.cpp"
    if ($cmp50) { __label__ = 15;; } else { __label__ = 25;; } //@line 356 "synth_mbrola.cpp"
    $if_then51$$if_end91$23: do { 
      if (__label__ == 15) {
  
        $ix=1; //@line 358 "synth_mbrola.cpp"
        var $arraydecay82=(($buf)&4294967295); //@line 377 "synth_mbrola.cpp"
        var $arraydecay85=(($buf)&4294967295); //@line 378 "synth_mbrola.cpp"
        ; //@line 358 "synth_mbrola.cpp"
        $for_body54$25: while(1) { 
  
          var $45=$ix; //@line 360 "synth_mbrola.cpp"
          var $arrayidx55=(($y+$45*4)&4294967295); //@line 360 "synth_mbrola.cpp"
          var $46=HEAP32[(($arrayidx55)>>2)]; //@line 360 "synth_mbrola.cpp"
          var $47=$pitch_env; //@line 360 "synth_mbrola.cpp"
          var $arrayidx56=(($47+$46)&4294967295); //@line 360 "synth_mbrola.cpp"
          var $48=HEAPU8[($arrayidx56)]; //@line 360 "synth_mbrola.cpp"
          var $conv57=((($48))&255); //@line 360 "synth_mbrola.cpp"
          var $49=HEAP32[(($pitch_range)>>2)]; //@line 360 "synth_mbrola.cpp"
          var $mul58=((($conv57)*($49))&4294967295); //@line 360 "synth_mbrola.cpp"
          var $shr59=($mul58) >> 8; //@line 360 "synth_mbrola.cpp"
          var $50=HEAP32[(($pitch_base)>>2)]; //@line 360 "synth_mbrola.cpp"
          var $add60=((($shr59)+($50))&4294967295); //@line 360 "synth_mbrola.cpp"
          $p2=$add60; //@line 360 "synth_mbrola.cpp"
          var $51=$split_addr; //@line 362 "synth_mbrola.cpp"
          var $cmp61=((($51))|0) > 0; //@line 362 "synth_mbrola.cpp"
          if ($cmp61) { __label__ = 17;; } else { __label__ = 18;; } //@line 362 "synth_mbrola.cpp"
          if (__label__ == 17) {
  
            var $52=$ix; //@line 364 "synth_mbrola.cpp"
            var $arrayidx63=(($y+$52*4)&4294967295); //@line 364 "synth_mbrola.cpp"
            var $53=HEAP32[(($arrayidx63)>>2)]; //@line 364 "synth_mbrola.cpp"
            var $54=$env100; //@line 364 "synth_mbrola.cpp"
            var $mul64=((($54)*($53))&4294967295); //@line 364 "synth_mbrola.cpp"
            var $55=$env_split; //@line 364 "synth_mbrola.cpp"
            var $div65=((((($mul64))|0)/((($55))|0))|0); //@line 364 "synth_mbrola.cpp"
            $y2=$div65; //@line 364 "synth_mbrola.cpp"
            __lastLabel__ = 17; ; //@line 365 "synth_mbrola.cpp"
          }
          else if (__label__ == 18) {
  
            var $56=$split_addr; //@line 367 "synth_mbrola.cpp"
            var $cmp66=((($56))|0) < 0; //@line 367 "synth_mbrola.cpp"
            var $57=$ix; //@line 369 "synth_mbrola.cpp"
            var $arrayidx68=(($y+$57*4)&4294967295); //@line 369 "synth_mbrola.cpp"
            var $58=HEAP32[(($arrayidx68)>>2)]; //@line 369 "synth_mbrola.cpp"
            if ($cmp66) { __label__ = 19;; } else { __label__ = 20;; } //@line 367 "synth_mbrola.cpp"
            if (__label__ == 19) {
  
              var $59=$env_split; //@line 369 "synth_mbrola.cpp"
              var $sub69=((($58)-($59))&4294967295); //@line 369 "synth_mbrola.cpp"
              var $60=$env100; //@line 369 "synth_mbrola.cpp"
              var $mul70=((($sub69)*($60))&4294967295); //@line 369 "synth_mbrola.cpp"
              var $61=$env_split; //@line 369 "synth_mbrola.cpp"
              var $div71=((((($mul70))|0)/((($61))|0))|0); //@line 369 "synth_mbrola.cpp"
              $y2=$div71; //@line 369 "synth_mbrola.cpp"
              __lastLabel__ = 19; ; //@line 370 "synth_mbrola.cpp"
            }
            else if (__label__ == 20) {
  
              var $62=$env100; //@line 373 "synth_mbrola.cpp"
              var $mul74=((($62)*($58))&4294967295); //@line 373 "synth_mbrola.cpp"
              var $div75=((((($mul74))|0)/128)|0); //@line 373 "synth_mbrola.cpp"
              $y2=$div75; //@line 373 "synth_mbrola.cpp"
              __lastLabel__ = 20; ;
            }
          }
  
          var $63=__lastLabel__ == 19 ? $div71 : (__lastLabel__ == 20 ? $div75 : ($div65)); //@line 375 "synth_mbrola.cpp"
          var $cmp78=((($63))|0) > 0; //@line 375 "synth_mbrola.cpp"
          if ($cmp78) { __label__ = 22;; } else { __label__ = 24;; } //@line 375 "synth_mbrola.cpp"
          $land_lhs_true79$$for_inc88$34: do { 
            if (__label__ == 22) {
  
              var $64=$y2; //@line 375 "synth_mbrola.cpp"
              var $65=$env100; //@line 375 "synth_mbrola.cpp"
              var $cmp80=((($64))|0) <= ((($65))|0); //@line 375 "synth_mbrola.cpp"
              if (!($cmp80)) { __label__ = 24;break $land_lhs_true79$$for_inc88$34; } //@line 375 "synth_mbrola.cpp"
  
              var $66=$y2; //@line 377 "synth_mbrola.cpp"
              var $67=$p2; //@line 377 "synth_mbrola.cpp"
              var $div83=((((($67))|0)/4096)|0); //@line 377 "synth_mbrola.cpp"
              var $call84=_sprintf($arraydecay82, ((__str14396)&4294967295), allocate([$66,0,0,0,$div83,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 377 "synth_mbrola.cpp"
              var $call86=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay85); //@line 378 "synth_mbrola.cpp"
              ; //@line 379 "synth_mbrola.cpp"
            }
          } while(0);
  
          var $68=$ix; //@line 358 "synth_mbrola.cpp"
          var $inc89=((($68)+1)&4294967295); //@line 358 "synth_mbrola.cpp"
          $ix=$inc89; //@line 358 "synth_mbrola.cpp"
          var $cmp53=((($inc89))|0) < 4; //@line 358 "synth_mbrola.cpp"
          if ($cmp53) { __label__ = 16;continue $for_body54$25; } else { __label__ = 25;break $if_then51$$if_end91$23; } //@line 358 "synth_mbrola.cpp"
        }
      }
    } while(0);
  
    var $69=$p_end; //@line 383 "synth_mbrola.cpp"
    var $div92=((((($69))|0)/4096)|0); //@line 383 "synth_mbrola.cpp"
    $p_end=$div92; //@line 383 "synth_mbrola.cpp"
    var $70=$split_addr; //@line 384 "synth_mbrola.cpp"
    var $cmp93=((($70))|0) <= 0; //@line 384 "synth_mbrola.cpp"
    if ($cmp93) { __label__ = 26;; } else { __label__ = 27;; } //@line 384 "synth_mbrola.cpp"
    if (__label__ == 26) {
  
      var $arraydecay95=(($buf)&4294967295); //@line 386 "synth_mbrola.cpp"
      var $71=$env100; //@line 386 "synth_mbrola.cpp"
      var $72=$p_end; //@line 386 "synth_mbrola.cpp"
      var $call96=_sprintf($arraydecay95, ((__str14396)&4294967295), allocate([$71,0,0,0,$72,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 386 "synth_mbrola.cpp"
      var $arraydecay97=(($buf)&4294967295); //@line 387 "synth_mbrola.cpp"
      var $call98=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay97); //@line 387 "synth_mbrola.cpp"
      ; //@line 388 "synth_mbrola.cpp"
    }
  
    var $73=$env100; //@line 389 "synth_mbrola.cpp"
    var $cmp100=((($73))|0) < 100; //@line 389 "synth_mbrola.cpp"
    if ($cmp100) { __label__ = 28;; } else { __label__ = 29;; } //@line 389 "synth_mbrola.cpp"
    if (__label__ == 28) {
  
      var $arraydecay102=(($buf)&4294967295); //@line 391 "synth_mbrola.cpp"
      var $74=$p_end; //@line 391 "synth_mbrola.cpp"
      var $call103=_sprintf($arraydecay102, ((__str14396)&4294967295), allocate([100,0,0,0,$74,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 391 "synth_mbrola.cpp"
      var $arraydecay104=(($buf)&4294967295); //@line 392 "synth_mbrola.cpp"
      var $call105=_strcat(((__ZZL10WritePitchiiiiiE6output)&4294967295), $arraydecay104); //@line 392 "synth_mbrola.cpp"
      ; //@line 393 "synth_mbrola.cpp"
    }
  
    var $strlen=_strlen(((__ZZL10WritePitchiiiiiE6output)&4294967295)); //@line 394 "synth_mbrola.cpp"
    var $endptr=((((__ZZL10WritePitchiiiiiE6output)&4294967295)+$strlen)&4294967295); //@line 394 "synth_mbrola.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = ((__str15397)&4294967295);
    $dest$ = $endptr;
    $stop$ = $src$ + 2;
    if (($dest$%4) == ($src$%4) && 2 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 394 "synth_mbrola.cpp"
    var $75=$final_addr; //@line 396 "synth_mbrola.cpp"
    var $tobool=((($75))|0)!=0; //@line 396 "synth_mbrola.cpp"
    if ($tobool) { __label__ = 30;; } else { __label__ = 31;; } //@line 396 "synth_mbrola.cpp"
    if (__label__ == 30) {
  
      var $76=$p_end; //@line 397 "synth_mbrola.cpp"
      var $call109=_sprintf(((__ZZL10WritePitchiiiiiE6output)&4294967295), ((__str16398)&4294967295), allocate([$76,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 397 "synth_mbrola.cpp"
      ; //@line 397 "synth_mbrola.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __Z14MbrolaGenerateP12PHONEME_LISTPii($phoneme_list, $n_ph, $resume) {
    ;
    var __label__;
  
    var $retval;
    var $phoneme_list_addr;
    var $n_ph_addr;
    var $resume_addr;
    var $f_mbrola;
    var $again;
    $phoneme_list_addr=$phoneme_list;
    $n_ph_addr=$n_ph;
    $resume_addr=$resume;
    $f_mbrola=0; //@line 630 "synth_mbrola.cpp"
    var $0=$n_ph_addr; //@line 632 "synth_mbrola.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 632 "synth_mbrola.cpp"
    var $cmp=((($1))|0)==0; //@line 632 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 632 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 633 "synth_mbrola.cpp"
      ; //@line 633 "synth_mbrola.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=HEAP32[((_option_mbrola_phonemes)>>2)]; //@line 635 "synth_mbrola.cpp"
      var $tobool=((($2))|0)!=0; //@line 635 "synth_mbrola.cpp"
      if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 635 "synth_mbrola.cpp"
      if (__label__ == 3) {
  
        var $3=HEAP32[((_f_trans)>>2)]; //@line 638 "synth_mbrola.cpp"
        $f_mbrola=$3; //@line 638 "synth_mbrola.cpp"
        ; //@line 639 "synth_mbrola.cpp"
      }
  
      var $4=$phoneme_list_addr; //@line 641 "synth_mbrola.cpp"
      var $5=$n_ph_addr; //@line 641 "synth_mbrola.cpp"
      var $6=HEAP32[(($5)>>2)]; //@line 641 "synth_mbrola.cpp"
      var $7=$resume_addr; //@line 641 "synth_mbrola.cpp"
      var $8=$f_mbrola; //@line 641 "synth_mbrola.cpp"
      var $call=__Z15MbrolaTranslateP12PHONEME_LISTiiP7__sFILE($4, $6, $7, $8); //@line 641 "synth_mbrola.cpp"
      $again=$call; //@line 641 "synth_mbrola.cpp"
      var $tobool3=((($call))|0)!=0; //@line 642 "synth_mbrola.cpp"
      if ($tobool3) { __label__ = 6;; } else { __label__ = 5;; } //@line 642 "synth_mbrola.cpp"
      if (__label__ == 5) {
  
        var $9=$n_ph_addr; //@line 643 "synth_mbrola.cpp"
        HEAP32[(($9)>>2)]=0; //@line 643 "synth_mbrola.cpp"
        ; //@line 643 "synth_mbrola.cpp"
      }
  
      var $10=$again; //@line 644 "synth_mbrola.cpp"
      $retval=$10; //@line 644 "synth_mbrola.cpp"
      ; //@line 644 "synth_mbrola.cpp"
    }
  
    var $11=$retval; //@line 645 "synth_mbrola.cpp"
    ;
    return $11; //@line 645 "synth_mbrola.cpp"
    return null;
  }
  

  function __Z10MbrolaFillii($length, $resume) {
    ;
    var __label__;
  
    var $retval;
    var $length_addr;
    var $resume_addr;
    var $req_samples;
    var $result;
    $length_addr=$length;
    $resume_addr=$resume;
    var $0=$resume_addr; //@line 655 "synth_mbrola.cpp"
    var $tobool=((($0))|0)!=0; //@line 655 "synth_mbrola.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 655 "synth_mbrola.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_samplerate)>>2)]; //@line 656 "synth_mbrola.cpp"
      var $2=$length_addr; //@line 656 "synth_mbrola.cpp"
      var $mul=((($2)*($1))&4294967295); //@line 656 "synth_mbrola.cpp"
      var $div=((((($mul))|0)/1000)|0); //@line 656 "synth_mbrola.cpp"
      HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]=$div; //@line 656 "synth_mbrola.cpp"
      ; //@line 656 "synth_mbrola.cpp"
    }
  
    var $3=HEAP32[((_out_end)>>2)]; //@line 658 "synth_mbrola.cpp"
    var $4=HEAP32[((_out_ptr)>>2)]; //@line 658 "synth_mbrola.cpp"
    var $sub_ptr_lhs_cast=($3); //@line 658 "synth_mbrola.cpp"
    var $sub_ptr_rhs_cast=($4); //@line 658 "synth_mbrola.cpp"
    var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 658 "synth_mbrola.cpp"
    var $div1=((((($sub_ptr_sub))|0)/2)|0); //@line 658 "synth_mbrola.cpp"
    $req_samples=$div1; //@line 658 "synth_mbrola.cpp"
    var $5=$req_samples; //@line 659 "synth_mbrola.cpp"
    var $6=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 659 "synth_mbrola.cpp"
    var $cmp=((($5))|0) > ((($6))|0); //@line 659 "synth_mbrola.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 659 "synth_mbrola.cpp"
    if (__label__ == 3) {
  
      var $7=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 660 "synth_mbrola.cpp"
      $req_samples=$7; //@line 660 "synth_mbrola.cpp"
      ; //@line 660 "synth_mbrola.cpp"
    }
  
    var $8=HEAP32[((_out_ptr)>>2)]; //@line 661 "synth_mbrola.cpp"
    var $9=$8; //@line 661 "synth_mbrola.cpp"
    var $10=$9; //@line 661 "synth_mbrola.cpp"
    var $11=$req_samples; //@line 661 "synth_mbrola.cpp"
    var $call=_read_MBR($10, $11); //@line 661 "synth_mbrola.cpp"
    $result=$call; //@line 661 "synth_mbrola.cpp"
    var $cmp4=((($call))|0) <= 0; //@line 662 "synth_mbrola.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 662 "synth_mbrola.cpp"
    if (__label__ == 5) {
  
      $retval=0; //@line 663 "synth_mbrola.cpp"
      ; //@line 663 "synth_mbrola.cpp"
    }
    else if (__label__ == 6) {
  
      var $12=$result; //@line 664 "synth_mbrola.cpp"
      var $mul7=((($12)*2)&4294967295); //@line 664 "synth_mbrola.cpp"
      var $13=HEAP32[((_out_ptr)>>2)]; //@line 664 "synth_mbrola.cpp"
      var $add_ptr=(($13+$mul7)&4294967295); //@line 664 "synth_mbrola.cpp"
      HEAP32[((_out_ptr)>>2)]=$add_ptr; //@line 664 "synth_mbrola.cpp"
      var $14=$result; //@line 665 "synth_mbrola.cpp"
      var $15=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 665 "synth_mbrola.cpp"
      var $sub=((($15)-($14))&4294967295); //@line 665 "synth_mbrola.cpp"
      HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]=$sub; //@line 665 "synth_mbrola.cpp"
      var $16=HEAP32[((__ZZ10MbrolaFilliiE9n_samples)>>2)]; //@line 666 "synth_mbrola.cpp"
      var $tobool8=((($16))|0)!=0; //@line 666 "synth_mbrola.cpp"
      var $cond=($tobool8) ? 1 : 0; //@line 666 "synth_mbrola.cpp"
      $retval=$cond; //@line 666 "synth_mbrola.cpp"
      ; //@line 666 "synth_mbrola.cpp"
    }
  
    var $17=$retval; //@line 667 "synth_mbrola.cpp"
    ;
    return $17; //@line 667 "synth_mbrola.cpp"
    return null;
  }
  

  function __Z11MbrolaResetv() {
    ;
    var __label__;
  
    var $call=_reset_MBR(); //@line 674 "synth_mbrola.cpp"
    ;
    return; //@line 675 "synth_mbrola.cpp"
    return;
  }
  

  function __Z10LoadPhDatav() {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $ix;
    var $n_phonemes;
    var $version;
    var $result;
    var $length=__stackBase__;
    var $p;
    var $pw;
    $result=1; //@line 116 "synthdata.cpp"
    var $0=HEAP32[((__ZL16phoneme_tab_data)>>2)]; //@line 121 "synthdata.cpp"
    var $call=__ZL10ReadPhFilePvPKcPi($0, ((__str1412)&4294967295), 0); //@line 121 "synthdata.cpp"
    HEAP32[((__ZL16phoneme_tab_data)>>2)]=$call; //@line 121 "synthdata.cpp"
    var $cmp=((($call))|0)==0; //@line 121 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 121 "synthdata.cpp"
    if (__label__ == 1) {
  
      $retval=-1; //@line 122 "synthdata.cpp"
      ; //@line 122 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((_phoneme_index)>>2)]; //@line 123 "synthdata.cpp"
      var $2=$1; //@line 123 "synthdata.cpp"
      var $call1=__ZL10ReadPhFilePvPKcPi($2, ((__str2413)&4294967295), 0); //@line 123 "synthdata.cpp"
      var $3=$call1; //@line 123 "synthdata.cpp"
      HEAP32[((_phoneme_index)>>2)]=$3; //@line 123 "synthdata.cpp"
      var $cmp2=((($3))|0)==0; //@line 123 "synthdata.cpp"
      if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 123 "synthdata.cpp"
      if (__label__ == 3) {
  
        $retval=-1; //@line 124 "synthdata.cpp"
        ; //@line 124 "synthdata.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=HEAP32[((_phondata_ptr)>>2)]; //@line 125 "synthdata.cpp"
        var $call5=__ZL10ReadPhFilePvPKcPi($4, ((__str3414)&4294967295), 0); //@line 125 "synthdata.cpp"
        HEAP32[((_phondata_ptr)>>2)]=$call5; //@line 125 "synthdata.cpp"
        var $cmp6=((($call5))|0)==0; //@line 125 "synthdata.cpp"
        if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 125 "synthdata.cpp"
        if (__label__ == 5) {
  
          $retval=-1; //@line 126 "synthdata.cpp"
          ; //@line 126 "synthdata.cpp"
        }
        else if (__label__ == 6) {
  
          var $5=HEAP32[((_tunes)>>2)]; //@line 127 "synthdata.cpp"
          var $6=$5; //@line 127 "synthdata.cpp"
          var $call9=__ZL10ReadPhFilePvPKcPi($6, ((__str4415)&4294967295), $length); //@line 127 "synthdata.cpp"
          var $7=$call9; //@line 127 "synthdata.cpp"
          HEAP32[((_tunes)>>2)]=$7; //@line 127 "synthdata.cpp"
          var $cmp10=((($7))|0)==0; //@line 127 "synthdata.cpp"
          if ($cmp10) { __label__ = 7;; } else { __label__ = 8;; } //@line 127 "synthdata.cpp"
          if (__label__ == 7) {
  
            $retval=-1; //@line 128 "synthdata.cpp"
            ; //@line 128 "synthdata.cpp"
          }
          else if (__label__ == 8) {
  
            var $8=HEAP32[((_phondata_ptr)>>2)]; //@line 129 "synthdata.cpp"
            HEAP32[((_wavefile_data)>>2)]=$8; //@line 129 "synthdata.cpp"
            var $9=HEAPU32[(($length)>>2)]; //@line 130 "synthdata.cpp"
            var $div=Math.floor(((($9))>>>0)/68); //@line 130 "synthdata.cpp"
            HEAP32[((_n_tunes)>>2)]=$div; //@line 130 "synthdata.cpp"
            $version=0; //@line 133 "synthdata.cpp"
            $ix=0; //@line 134 "synthdata.cpp"
            ; //@line 134 "synthdata.cpp"
            $for_body$14: while(1) { 
  
              var $10=$ix; //@line 136 "synthdata.cpp"
              var $11=HEAP32[((_wavefile_data)>>2)]; //@line 136 "synthdata.cpp"
              var $arrayidx=(($11+$10)&4294967295); //@line 136 "synthdata.cpp"
              var $12=HEAPU8[($arrayidx)]; //@line 136 "synthdata.cpp"
              var $conv=((($12))&255); //@line 136 "synthdata.cpp"
              var $13=$ix; //@line 136 "synthdata.cpp"
              var $mul=((($13)*8)&4294967295); //@line 136 "synthdata.cpp"
              var $shl=($conv) << ($mul); //@line 136 "synthdata.cpp"
              var $14=$version; //@line 136 "synthdata.cpp"
              var $add=((($shl)+($14))&4294967295); //@line 136 "synthdata.cpp"
              $version=$add; //@line 136 "synthdata.cpp"
              var $15=$ix; //@line 134 "synthdata.cpp"
              var $inc=((($15)+1)&4294967295); //@line 134 "synthdata.cpp"
              $ix=$inc; //@line 134 "synthdata.cpp"
              var $cmp13=((($inc))|0) < 4; //@line 134 "synthdata.cpp"
              if ($cmp13) { __label__ = 9;continue $for_body$14; } else { __label__ = 10;break $for_body$14; } //@line 134 "synthdata.cpp"
            }
  
            var $16=$version; //@line 139 "synthdata.cpp"
            var $cmp14=((($16))|0)!=83200; //@line 139 "synthdata.cpp"
            if ($cmp14) { __label__ = 11;; } else { __label__ = 12;; } //@line 139 "synthdata.cpp"
            if (__label__ == 11) {
  
              var $17=$version; //@line 141 "synthdata.cpp"
              $result=$17; //@line 141 "synthdata.cpp"
              ; //@line 142 "synthdata.cpp"
            }
  
            var $18=HEAP32[((__ZL16phoneme_tab_data)>>2)]; //@line 145 "synthdata.cpp"
            $p=$18; //@line 145 "synthdata.cpp"
            var $19=$p; //@line 146 "synthdata.cpp"
            var $arrayidx17=(($19)&4294967295); //@line 146 "synthdata.cpp"
            var $20=HEAPU8[($arrayidx17)]; //@line 146 "synthdata.cpp"
            var $conv18=((($20))&255); //@line 146 "synthdata.cpp"
            HEAP32[((_n_phoneme_tables)>>2)]=$conv18; //@line 146 "synthdata.cpp"
            var $21=$p; //@line 147 "synthdata.cpp"
            var $add_ptr=(($21+4)&4294967295); //@line 147 "synthdata.cpp"
            $p=$add_ptr; //@line 147 "synthdata.cpp"
            $ix=0; //@line 149 "synthdata.cpp"
            var $22=$ix; //@line 149 "synthdata.cpp"
            var $23=HEAP32[((_n_phoneme_tables)>>2)]; //@line 149 "synthdata.cpp"
            var $cmp201=((($22))|0) < ((($23))|0); //@line 149 "synthdata.cpp"
            if ($cmp201) { __label__ = 13;; } else { __label__ = 14;; } //@line 149 "synthdata.cpp"
            $for_body21$$for_end42$20: do { 
              if (__label__ == 13) {
                while(1) { 
  
                  var $24=$p; //@line 151 "synthdata.cpp"
                  var $arrayidx22=(($24)&4294967295); //@line 151 "synthdata.cpp"
                  var $25=HEAPU8[($arrayidx22)]; //@line 151 "synthdata.cpp"
                  var $conv23=((($25))&255); //@line 151 "synthdata.cpp"
                  $n_phonemes=$conv23; //@line 151 "synthdata.cpp"
                  var $26=$p; //@line 152 "synthdata.cpp"
                  var $arrayidx24=(($26)&4294967295); //@line 152 "synthdata.cpp"
                  var $27=HEAPU8[($arrayidx24)]; //@line 152 "synthdata.cpp"
                  var $conv25=((($27))&255); //@line 152 "synthdata.cpp"
                  var $28=$ix; //@line 152 "synthdata.cpp"
                  var $arrayidx26=((_phoneme_tab_list+$28*48)&4294967295); //@line 152 "synthdata.cpp"
                  var $n_phonemes27=(($arrayidx26+36)&4294967295); //@line 152 "synthdata.cpp"
                  HEAP32[(($n_phonemes27)>>2)]=$conv25; //@line 152 "synthdata.cpp"
                  var $29=$p; //@line 153 "synthdata.cpp"
                  var $arrayidx28=(($29+1)&4294967295); //@line 153 "synthdata.cpp"
                  var $30=HEAPU8[($arrayidx28)]; //@line 153 "synthdata.cpp"
                  var $conv29=((($30))&255); //@line 153 "synthdata.cpp"
                  var $31=$ix; //@line 153 "synthdata.cpp"
                  var $arrayidx30=((_phoneme_tab_list+$31*48)&4294967295); //@line 153 "synthdata.cpp"
                  var $includes=(($arrayidx30+40)&4294967295); //@line 153 "synthdata.cpp"
                  HEAP32[(($includes)>>2)]=$conv29; //@line 153 "synthdata.cpp"
                  var $32=$p; //@line 154 "synthdata.cpp"
                  var $33=$32; //@line 154 "synthdata.cpp"
                  $pw=$33; //@line 154 "synthdata.cpp"
                  var $34=$pw; //@line 155 "synthdata.cpp"
                  var $arrayidx31=(($34+4)&4294967295); //@line 155 "synthdata.cpp"
                  var $35=HEAP32[(($arrayidx31)>>2)]; //@line 155 "synthdata.cpp"
                  var $call32=__Z13Reverse4Bytesi($35); //@line 155 "synthdata.cpp"
                  var $36=$ix; //@line 155 "synthdata.cpp"
                  var $arrayidx33=((_phoneme_tab_list+$36*48)&4294967295); //@line 155 "synthdata.cpp"
                  var $equivalence_tables=(($arrayidx33+44)&4294967295); //@line 155 "synthdata.cpp"
                  HEAP32[(($equivalence_tables)>>2)]=$call32; //@line 155 "synthdata.cpp"
                  var $37=$p; //@line 156 "synthdata.cpp"
                  var $add_ptr34=(($37+8)&4294967295); //@line 156 "synthdata.cpp"
                  $p=$add_ptr34; //@line 156 "synthdata.cpp"
                  var $38=$ix; //@line 157 "synthdata.cpp"
                  var $arrayidx35=((_phoneme_tab_list+$38*48)&4294967295); //@line 157 "synthdata.cpp"
                  var $name=(($arrayidx35)&4294967295); //@line 157 "synthdata.cpp"
                  var $arraydecay=(($name)&4294967295); //@line 157 "synthdata.cpp"
                  var $39=$p; //@line 157 "synthdata.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $39;
                  $dest$ = $arraydecay;
                  $stop$ = $src$ + 32;
                  if (($dest$%4) == ($src$%4) && 32 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 157 "synthdata.cpp"
                  var $40=$p; //@line 158 "synthdata.cpp"
                  var $add_ptr36=(($40+32)&4294967295); //@line 158 "synthdata.cpp"
                  $p=$add_ptr36; //@line 158 "synthdata.cpp"
                  var $41=$p; //@line 159 "synthdata.cpp"
                  var $42=$41; //@line 159 "synthdata.cpp"
                  var $43=$ix; //@line 159 "synthdata.cpp"
                  var $arrayidx37=((_phoneme_tab_list+$43*48)&4294967295); //@line 159 "synthdata.cpp"
                  var $phoneme_tab_ptr=(($arrayidx37+32)&4294967295); //@line 159 "synthdata.cpp"
                  HEAP32[(($phoneme_tab_ptr)>>2)]=$42; //@line 159 "synthdata.cpp"
                  var $44=$n_phonemes; //@line 160 "synthdata.cpp"
                  var $mul38=((($44)*16)&4294967295); //@line 160 "synthdata.cpp"
                  var $45=$p; //@line 160 "synthdata.cpp"
                  var $add_ptr39=(($45+$mul38)&4294967295); //@line 160 "synthdata.cpp"
                  $p=$add_ptr39; //@line 160 "synthdata.cpp"
                  var $46=$ix; //@line 149 "synthdata.cpp"
                  var $inc41=((($46)+1)&4294967295); //@line 149 "synthdata.cpp"
                  $ix=$inc41; //@line 149 "synthdata.cpp"
                  var $47=$ix; //@line 149 "synthdata.cpp"
                  var $48=HEAP32[((_n_phoneme_tables)>>2)]; //@line 149 "synthdata.cpp"
                  var $cmp20=((($47))|0) < ((($48))|0); //@line 149 "synthdata.cpp"
                  if ($cmp20) { __label__ = 13;continue ; } else { __label__ = 14;break $for_body21$$for_end42$20; } //@line 149 "synthdata.cpp"
                }
              }
            } while(0);
  
            var $49=HEAP32[((_phoneme_tab_number)>>2)]; //@line 163 "synthdata.cpp"
            var $50=HEAP32[((_n_phoneme_tables)>>2)]; //@line 163 "synthdata.cpp"
            var $cmp43=((($49))|0) >= ((($50))|0); //@line 163 "synthdata.cpp"
            if ($cmp43) { __label__ = 15;; } else { __label__ = 16;; } //@line 163 "synthdata.cpp"
            if (__label__ == 15) {
  
              HEAP32[((_phoneme_tab_number)>>2)]=0; //@line 164 "synthdata.cpp"
              ; //@line 164 "synthdata.cpp"
            }
  
            var $51=$result; //@line 166 "synthdata.cpp"
            $retval=$51; //@line 166 "synthdata.cpp"
            ; //@line 166 "synthdata.cpp"
          }
        }
      }
    }
  
    var $52=$retval; //@line 167 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return $52; //@line 167 "synthdata.cpp"
    return null;
  }
  

  function __ZL10ReadPhFilePvPKcPi($ptr, $fname, $size) {
    var __stackBase__  = STACKTOP; STACKTOP += 192; _memset(__stackBase__, 0, 192);
    var __label__;
  
    var $retval;
    var $ptr_addr;
    var $fname_addr;
    var $size_addr;
    var $f_in;
    var $p;
    var $length;
    var $buf=__stackBase__;
    $ptr_addr=$ptr;
    $fname_addr=$fname;
    $size_addr=$size;
    var $arraydecay=(($buf)&4294967295); //@line 81 "synthdata.cpp"
    var $0=$fname_addr; //@line 81 "synthdata.cpp"
    var $call=_sprintf($arraydecay, ((__str74726)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,$0,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 81 "synthdata.cpp"
    var $arraydecay1=(($buf)&4294967295); //@line 82 "synthdata.cpp"
    var $call2=__Z13GetFileLengthPKc($arraydecay1); //@line 82 "synthdata.cpp"
    $length=$call2; //@line 82 "synthdata.cpp"
    var $arraydecay3=(($buf)&4294967295); //@line 84 "synthdata.cpp"
    var $call4=_fopen($arraydecay3, ((__str18429)&4294967295)); //@line 84 "synthdata.cpp"
    $f_in=$call4; //@line 84 "synthdata.cpp"
    var $cmp=((($call4))|0)==0; //@line 84 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 84 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 86 "synthdata.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 86 "synthdata.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 86 "synthdata.cpp"
      var $arraydecay5=(($buf)&4294967295); //@line 86 "synthdata.cpp"
      var $call6=_fprintf($2, ((__str19430)&4294967295), allocate([$arraydecay5,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 86 "synthdata.cpp"
      $retval=0; //@line 87 "synthdata.cpp"
      ; //@line 87 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$ptr_addr; //@line 90 "synthdata.cpp"
      var $cmp7=((($3))|0)!=0; //@line 90 "synthdata.cpp"
      if ($cmp7) { __label__ = 3;; } else { __label__ = 4;; } //@line 90 "synthdata.cpp"
      if (__label__ == 3) {
  
        var $4=$ptr_addr; //@line 91 "synthdata.cpp"
        __Z4FreePv($4); //@line 91 "synthdata.cpp"
        ; //@line 91 "synthdata.cpp"
      }
  
      var $5=$length; //@line 93 "synthdata.cpp"
      var $call10=__Z5Alloci($5); //@line 93 "synthdata.cpp"
      $p=$call10; //@line 93 "synthdata.cpp"
      var $cmp11=((($call10))|0)==0; //@line 93 "synthdata.cpp"
      if ($cmp11) { __label__ = 5;; } else { __label__ = 6;; } //@line 93 "synthdata.cpp"
      if (__label__ == 5) {
  
        var $6=$f_in; //@line 95 "synthdata.cpp"
        var $call13=_fclose($6); //@line 95 "synthdata.cpp"
        $retval=0; //@line 96 "synthdata.cpp"
        ; //@line 96 "synthdata.cpp"
      }
      else if (__label__ == 6) {
  
        var $7=$p; //@line 98 "synthdata.cpp"
        var $8=$length; //@line 98 "synthdata.cpp"
        var $9=$f_in; //@line 98 "synthdata.cpp"
        var $call15=_fread($7, 1, $8, $9); //@line 98 "synthdata.cpp"
        var $10=$length; //@line 98 "synthdata.cpp"
        var $cmp16=((($call15))|0)!=((($10))|0); //@line 98 "synthdata.cpp"
        var $11=$f_in; //@line 100 "synthdata.cpp"
        var $call18=_fclose($11); //@line 100 "synthdata.cpp"
        if ($cmp16) { __label__ = 7;; } else { __label__ = 8;; } //@line 98 "synthdata.cpp"
        if (__label__ == 7) {
  
          $retval=0; //@line 101 "synthdata.cpp"
          ; //@line 101 "synthdata.cpp"
        }
        else if (__label__ == 8) {
  
          var $12=$size_addr; //@line 105 "synthdata.cpp"
          var $cmp21=((($12))|0)!=0; //@line 105 "synthdata.cpp"
          if ($cmp21) { __label__ = 9;; } else { __label__ = 10;; } //@line 105 "synthdata.cpp"
          if (__label__ == 9) {
  
            var $13=$length; //@line 106 "synthdata.cpp"
            var $14=$size_addr; //@line 106 "synthdata.cpp"
            HEAP32[(($14)>>2)]=$13; //@line 106 "synthdata.cpp"
            ; //@line 106 "synthdata.cpp"
          }
  
          var $15=$p; //@line 107 "synthdata.cpp"
          $retval=$15; //@line 107 "synthdata.cpp"
          ; //@line 107 "synthdata.cpp"
        }
      }
    }
  
    var $16=$retval; //@line 108 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return $16; //@line 108 "synthdata.cpp"
    return null;
  }
  

  function __Z10FreePhDatav() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL16phoneme_tab_data)>>2)]; //@line 172 "synthdata.cpp"
    __Z4FreePv($0); //@line 172 "synthdata.cpp"
    var $1=HEAP32[((_phoneme_index)>>2)]; //@line 173 "synthdata.cpp"
    var $2=$1; //@line 173 "synthdata.cpp"
    __Z4FreePv($2); //@line 173 "synthdata.cpp"
    var $3=HEAP32[((_phondata_ptr)>>2)]; //@line 174 "synthdata.cpp"
    __Z4FreePv($3); //@line 174 "synthdata.cpp"
    HEAP32[((__ZL16phoneme_tab_data)>>2)]=0; //@line 175 "synthdata.cpp"
    HEAP32[((_phoneme_index)>>2)]=0; //@line 176 "synthdata.cpp"
    HEAP32[((_phondata_ptr)>>2)]=0; //@line 177 "synthdata.cpp"
    ;
    return; //@line 178 "synthdata.cpp"
    return;
  }
  

  function __Z11PhonemeCodej($mnem) {
    ;
    var __label__;
  
    var $retval;
    var $mnem_addr;
    var $ix;
    $mnem_addr=$mnem;
    $ix=0; //@line 185 "synthdata.cpp"
    ; //@line 185 "synthdata.cpp"
    while(1) { 
  
      var $0=$ix; //@line 185 "synthdata.cpp"
      var $1=HEAP32[((_n_phoneme_tab)>>2)]; //@line 185 "synthdata.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 185 "synthdata.cpp"
      if (!($cmp)) { __label__ = 6;break ; } //@line 185 "synthdata.cpp"
  
      var $2=$ix; //@line 187 "synthdata.cpp"
      var $arrayidx=((_phoneme_tab+$2*4)&4294967295); //@line 187 "synthdata.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 187 "synthdata.cpp"
      var $cmp1=((($3))|0)==0; //@line 187 "synthdata.cpp"
      if ($cmp1) { __label__ = 5;; } else { __label__ = 3;; } //@line 187 "synthdata.cpp"
      if (__label__ == 3) {
  
        var $4=$ix; //@line 189 "synthdata.cpp"
        var $arrayidx2=((_phoneme_tab+$4*4)&4294967295); //@line 189 "synthdata.cpp"
        var $5=HEAP32[(($arrayidx2)>>2)]; //@line 189 "synthdata.cpp"
        var $mnemonic=(($5)&4294967295); //@line 189 "synthdata.cpp"
        var $6=HEAP32[(($mnemonic)>>2)]; //@line 189 "synthdata.cpp"
        var $7=$mnem_addr; //@line 189 "synthdata.cpp"
        var $cmp3=((($6))|0)==((($7))|0); //@line 189 "synthdata.cpp"
        if ($cmp3) { __label__ = 4;break ; } //@line 189 "synthdata.cpp"
      }
  
      var $11=$ix; //@line 185 "synthdata.cpp"
      var $inc=((($11)+1)&4294967295); //@line 185 "synthdata.cpp"
      $ix=$inc; //@line 185 "synthdata.cpp"
      __label__ = 1;continue ; //@line 185 "synthdata.cpp"
    }
    if (__label__ == 6) {
  
      $retval=0; //@line 192 "synthdata.cpp"
      ; //@line 192 "synthdata.cpp"
    }
    else if (__label__ == 4) {
  
      var $8=$ix; //@line 190 "synthdata.cpp"
      var $arrayidx5=((_phoneme_tab+$8*4)&4294967295); //@line 190 "synthdata.cpp"
      var $9=HEAP32[(($arrayidx5)>>2)]; //@line 190 "synthdata.cpp"
      var $code=(($9+10)&4294967295); //@line 190 "synthdata.cpp"
      var $10=HEAPU8[($code)]; //@line 190 "synthdata.cpp"
      var $conv=((($10))&255); //@line 190 "synthdata.cpp"
      $retval=$conv; //@line 190 "synthdata.cpp"
      ; //@line 190 "synthdata.cpp"
    }
  
    var $12=$retval; //@line 193 "synthdata.cpp"
    ;
    return $12; //@line 193 "synthdata.cpp"
    return null;
  }
  

  function __Z19LookupPhonemeStringPKc($string) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $string_addr;
    var $ix;
    var $c;
    var $mnem;
    $string_addr=$string;
    $mnem=0; //@line 203 "synthdata.cpp"
    $ix=0; //@line 204 "synthdata.cpp"
    __lastLabel__ = 0; ; //@line 204 "synthdata.cpp"
    while(1) { 
  
      var $0=__lastLabel__ == 3 ? $inc : (0); //@line 204 "synthdata.cpp"
      var $cmp=((($0))|0) < 4; //@line 204 "synthdata.cpp"
      if (!($cmp)) { __label__ = 4;break ; } //@line 204 "synthdata.cpp"
  
      var $1=$ix; //@line 206 "synthdata.cpp"
      var $2=$string_addr; //@line 206 "synthdata.cpp"
      var $arrayidx=(($2+$1)&4294967295); //@line 206 "synthdata.cpp"
      var $3=HEAP8[($arrayidx)]; //@line 206 "synthdata.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 206 "synthdata.cpp"
      var $cmp1=((($conv))|0)==0; //@line 206 "synthdata.cpp"
      if ($cmp1) { __label__ = 4;break ; } //@line 206 "synthdata.cpp"
  
      var $4=$ix; //@line 207 "synthdata.cpp"
      var $5=$string_addr; //@line 207 "synthdata.cpp"
      var $arrayidx2=(($5+$4)&4294967295); //@line 207 "synthdata.cpp"
      var $6=HEAP8[($arrayidx2)]; //@line 207 "synthdata.cpp"
      $c=$6; //@line 207 "synthdata.cpp"
      var $7=$c; //@line 208 "synthdata.cpp"
      var $conv3=((($7))&255); //@line 208 "synthdata.cpp"
      var $8=$ix; //@line 208 "synthdata.cpp"
      var $mul=((($8)*8)&4294967295); //@line 208 "synthdata.cpp"
      var $shl=($conv3) << ($mul); //@line 208 "synthdata.cpp"
      var $9=$mnem; //@line 208 "synthdata.cpp"
      var $or=($shl) | ($9); //@line 208 "synthdata.cpp"
      $mnem=$or; //@line 208 "synthdata.cpp"
      var $10=$ix; //@line 204 "synthdata.cpp"
      var $inc=((($10)+1)&4294967295); //@line 204 "synthdata.cpp"
      $ix=$inc; //@line 204 "synthdata.cpp"
      __lastLabel__ = 3; __label__ = 1;continue ; //@line 204 "synthdata.cpp"
    }
  
    var $11=$mnem; //@line 211 "synthdata.cpp"
    var $call=__Z11PhonemeCodej($11); //@line 211 "synthdata.cpp"
    ;
    return $call; //@line 211 "synthdata.cpp"
    return null;
  }
  

  function __Z11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LIST($this_ph, $which, $fmt_params, $n_frames, $plist) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
    var __lastLabel__ = null;
  
    var $this_ph_addr;
    var $which_addr;
    var $fmt_params_addr;
    var $n_frames_addr;
    var $plist_addr;
    var $ix;
    var $nf=__stackBase__;
    var $nf1;
    var $seq_break;
    var $frames;
    var $length1;
    var $length_std;
    var $length_factor;
    var $seq;
    var $seq2;
    var $seqk;
    var $seqk2;
    var $frame;
    $this_ph_addr=$this_ph;
    $which_addr=$which;
    $fmt_params_addr=$fmt_params;
    $n_frames_addr=$n_frames;
    $plist_addr=$plist;
    var $0=$fmt_params_addr; //@line 232 "synthdata.cpp"
    var $fmt_addr=(($0+8)&4294967295); //@line 232 "synthdata.cpp"
    var $1=HEAP32[(($fmt_addr)>>2)]; //@line 232 "synthdata.cpp"
    var $2=HEAP32[((_phondata_ptr)>>2)]; //@line 232 "synthdata.cpp"
    var $arrayidx=(($2+$1)&4294967295); //@line 232 "synthdata.cpp"
    var $3=$arrayidx; //@line 232 "synthdata.cpp"
    $seq=$3; //@line 232 "synthdata.cpp"
    var $4=$seq; //@line 233 "synthdata.cpp"
    var $5=$4; //@line 233 "synthdata.cpp"
    $seqk=$5; //@line 233 "synthdata.cpp"
    var $6=$seq; //@line 234 "synthdata.cpp"
    var $n_frames1=(($6+2)&4294967295); //@line 234 "synthdata.cpp"
    var $7=HEAPU8[($n_frames1)]; //@line 234 "synthdata.cpp"
    var $conv=((($7))&255); //@line 234 "synthdata.cpp"
    HEAP32[(($nf)>>2)]=$conv; //@line 234 "synthdata.cpp"
    var $8=HEAP32[(($nf)>>2)]; //@line 237 "synthdata.cpp"
    var $cmp=((($8))|0) >= 25; //@line 237 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 237 "synthdata.cpp"
    if (__label__ == 1) {
  
      HEAP32[(($nf)>>2)]=24; //@line 238 "synthdata.cpp"
      ; //@line 238 "synthdata.cpp"
    }
  
    var $9=$fmt_params_addr; //@line 240 "synthdata.cpp"
    var $fmt2_lenadj=(($9+24)&4294967295); //@line 240 "synthdata.cpp"
    var $10=HEAP32[(($fmt2_lenadj)>>2)]; //@line 240 "synthdata.cpp"
    var $11=$fmt_params_addr; //@line 240 "synthdata.cpp"
    var $fmt_length=(($11+12)&4294967295); //@line 240 "synthdata.cpp"
    var $12=HEAP32[(($fmt_length)>>2)]; //@line 240 "synthdata.cpp"
    var $add=((($12)+($10))&4294967295); //@line 240 "synthdata.cpp"
    HEAP32[((_seq_len_adjust)>>2)]=$add; //@line 240 "synthdata.cpp"
    $seq_break=0; //@line 241 "synthdata.cpp"
    $ix=0; //@line 243 "synthdata.cpp"
    var $13=$ix; //@line 243 "synthdata.cpp"
    var $14=HEAP32[(($nf)>>2)]; //@line 243 "synthdata.cpp"
    var $cmp29=((($13))|0) < ((($14))|0); //@line 243 "synthdata.cpp"
    if ($cmp29) { __label__ = 4;; } else { __label__ = 3;; } //@line 243 "synthdata.cpp"
    $for_body$$for_end_thread$5: do { 
      if (__label__ == 4) {
        while(1) { 
  
          var $15=$seq; //@line 245 "synthdata.cpp"
          var $frame3=(($15+4)&4294967295); //@line 245 "synthdata.cpp"
          var $arrayidx4=(($frame3)&4294967295); //@line 245 "synthdata.cpp"
          var $frflags=(($arrayidx4)&4294967295); //@line 245 "synthdata.cpp"
          var $16=HEAP16[(($frflags)>>1)]; //@line 245 "synthdata.cpp"
          var $conv5=(tempInt=(($16)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 245 "synthdata.cpp"
          var $and=($conv5) & 1; //@line 245 "synthdata.cpp"
          var $tobool=((($and))|0)!=0; //@line 245 "synthdata.cpp"
          var $17=$ix; //@line 246 "synthdata.cpp"
          if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 245 "synthdata.cpp"
          if (__label__ == 5) {
  
            var $18=$seqk; //@line 246 "synthdata.cpp"
            var $frame7=(($18+4)&4294967295); //@line 246 "synthdata.cpp"
            var $arrayidx8=(($frame7+$17*64)&4294967295); //@line 246 "synthdata.cpp"
            $frame=$arrayidx8; //@line 246 "synthdata.cpp"
            ; //@line 246 "synthdata.cpp"
          }
          else if (__label__ == 6) {
  
            var $19=$seq; //@line 248 "synthdata.cpp"
            var $frame9=(($19+4)&4294967295); //@line 248 "synthdata.cpp"
            var $arrayidx10=(($frame9+$17*44)&4294967295); //@line 248 "synthdata.cpp"
            var $20=$arrayidx10; //@line 248 "synthdata.cpp"
            $frame=$20; //@line 248 "synthdata.cpp"
            ;
          }
  
          var $21=$frame; //@line 249 "synthdata.cpp"
          var $22=$ix; //@line 249 "synthdata.cpp"
          var $arrayidx12=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$22*8)&4294967295); //@line 249 "synthdata.cpp"
          var $frame13=(($arrayidx12+4)&4294967295); //@line 249 "synthdata.cpp"
          HEAP32[(($frame13)>>2)]=$21; //@line 249 "synthdata.cpp"
          var $23=$frame; //@line 250 "synthdata.cpp"
          var $frflags14=(($23)&4294967295); //@line 250 "synthdata.cpp"
          var $24=HEAP16[(($frflags14)>>1)]; //@line 250 "synthdata.cpp"
          var $25=$ix; //@line 250 "synthdata.cpp"
          var $arrayidx15=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$25*8)&4294967295); //@line 250 "synthdata.cpp"
          var $frflags16=(($arrayidx15+2)&4294967295); //@line 250 "synthdata.cpp"
          HEAP16[(($frflags16)>>1)]=$24; //@line 250 "synthdata.cpp"
          var $26=$frame; //@line 251 "synthdata.cpp"
          var $length=(($26+16)&4294967295); //@line 251 "synthdata.cpp"
          var $27=HEAPU8[($length)]; //@line 251 "synthdata.cpp"
          var $conv17=((($27))&255); //@line 251 "synthdata.cpp"
          var $28=$ix; //@line 251 "synthdata.cpp"
          var $arrayidx18=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$28*8)&4294967295); //@line 251 "synthdata.cpp"
          var $length19=(($arrayidx18)&4294967295); //@line 251 "synthdata.cpp"
          HEAP16[(($length19)>>1)]=$conv17; //@line 251 "synthdata.cpp"
          var $29=$frame; //@line 252 "synthdata.cpp"
          var $frflags20=(($29)&4294967295); //@line 252 "synthdata.cpp"
          var $30=HEAP16[(($frflags20)>>1)]; //@line 252 "synthdata.cpp"
          var $conv21=(tempInt=(($30)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 252 "synthdata.cpp"
          var $and22=($conv21) & 2; //@line 252 "synthdata.cpp"
          var $tobool23=((($and22))|0)!=0; //@line 252 "synthdata.cpp"
          if ($tobool23) { __label__ = 8;; } else { __label__ = 9;; } //@line 252 "synthdata.cpp"
          if (__label__ == 8) {
  
            var $31=$ix; //@line 253 "synthdata.cpp"
            $seq_break=$31; //@line 253 "synthdata.cpp"
            ; //@line 253 "synthdata.cpp"
          }
  
          var $32=$ix; //@line 243 "synthdata.cpp"
          var $inc=((($32)+1)&4294967295); //@line 243 "synthdata.cpp"
          $ix=$inc; //@line 243 "synthdata.cpp"
          var $33=$ix; //@line 243 "synthdata.cpp"
          var $34=HEAP32[(($nf)>>2)]; //@line 243 "synthdata.cpp"
          var $cmp2=((($33))|0) < ((($34))|0); //@line 243 "synthdata.cpp"
          if ($cmp2) { __label__ = 4;continue ; } else { __label__ = 10;break ; } //@line 243 "synthdata.cpp"
        }
  
        var $_pr10=$seq_break; //@line 257 "synthdata.cpp"
        $frames=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf)&4294967295); //@line 256 "synthdata.cpp"
        var $cmp26=((($_pr10))|0) > 0; //@line 257 "synthdata.cpp"
        if (!($cmp26)) { __label__ = 14;break $for_body$$for_end_thread$5; } //@line 257 "synthdata.cpp"
  
        var $35=$which_addr; //@line 259 "synthdata.cpp"
        var $cmp28=((($35))|0)==1; //@line 259 "synthdata.cpp"
        var $36=$seq_break; //@line 261 "synthdata.cpp"
        if ($cmp28) { __label__ = 12;; } else { __label__ = 13;; } //@line 259 "synthdata.cpp"
        if (__label__ == 12) {
  
          var $add30=((($36)+1)&4294967295); //@line 261 "synthdata.cpp"
          HEAP32[(($nf)>>2)]=$add30; //@line 261 "synthdata.cpp"
          ; //@line 262 "synthdata.cpp"
        }
        else if (__label__ == 13) {
  
          var $arrayidx32=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf+$36*8)&4294967295); //@line 265 "synthdata.cpp"
          $frames=$arrayidx32; //@line 265 "synthdata.cpp"
          var $37=$seq_break; //@line 266 "synthdata.cpp"
          var $38=HEAP32[(($nf)>>2)]; //@line 266 "synthdata.cpp"
          var $sub=((($38)-($37))&4294967295); //@line 266 "synthdata.cpp"
          HEAP32[(($nf)>>2)]=$sub; //@line 266 "synthdata.cpp"
          ;
        }
      }
      else if (__label__ == 3) {
  
        $frames=((__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf)&4294967295); //@line 256 "synthdata.cpp"
        ; //@line 257 "synthdata.cpp"
      }
    } while(0);
  
    var $39=$this_ph_addr; //@line 271 "synthdata.cpp"
    var $type=(($39+11)&4294967295); //@line 271 "synthdata.cpp"
    var $40=HEAPU8[($type)]; //@line 271 "synthdata.cpp"
    var $conv35=((($40))&255); //@line 271 "synthdata.cpp"
    var $cmp36=((($conv35))|0)==2; //@line 271 "synthdata.cpp"
    if ($cmp36) { __label__ = 15;; } else { __label__ = 18;; } //@line 271 "synthdata.cpp"
    $land_lhs_true$$if_end42$22: do { 
      if (__label__ == 15) {
  
        var $41=$fmt_params_addr; //@line 271 "synthdata.cpp"
        var $fmt2_addr=(($41+20)&4294967295); //@line 271 "synthdata.cpp"
        var $42=HEAP32[(($fmt2_addr)>>2)]; //@line 271 "synthdata.cpp"
        var $cmp37=((($42))|0)==0; //@line 271 "synthdata.cpp"
        if (!($cmp37)) { __label__ = 18;break $land_lhs_true$$if_end42$22; } //@line 271 "synthdata.cpp"
  
        var $43=$fmt_params_addr; //@line 271 "synthdata.cpp"
        var $use_vowelin=(($43+4)&4294967295); //@line 271 "synthdata.cpp"
        var $44=HEAP32[(($use_vowelin)>>2)]; //@line 271 "synthdata.cpp"
        var $tobool39=((($44))|0)!=0; //@line 271 "synthdata.cpp"
        if (!($tobool39)) { __label__ = 18;break $land_lhs_true$$if_end42$22; } //@line 271 "synthdata.cpp"
  
        var $45=$frames; //@line 273 "synthdata.cpp"
        var $46=$fmt_params_addr; //@line 273 "synthdata.cpp"
        var $transition0=(($46+36)&4294967295); //@line 273 "synthdata.cpp"
        var $47=HEAP32[(($transition0)>>2)]; //@line 273 "synthdata.cpp"
        var $48=$fmt_params_addr; //@line 273 "synthdata.cpp"
        var $transition1=(($48+40)&4294967295); //@line 273 "synthdata.cpp"
        var $49=HEAP32[(($transition1)>>2)]; //@line 273 "synthdata.cpp"
        var $50=$which_addr; //@line 273 "synthdata.cpp"
        var $call=__Z18FormantTransition2P10frameref_tRijjP11PHONEME_TABi($45, $nf, $47, $49, 0, $50); //@line 273 "synthdata.cpp"
        var $51=HEAP32[((_seq_len_adjust)>>2)]; //@line 273 "synthdata.cpp"
        var $add41=((($51)+($call))&4294967295); //@line 273 "synthdata.cpp"
        HEAP32[((_seq_len_adjust)>>2)]=$add41; //@line 273 "synthdata.cpp"
        ; //@line 274 "synthdata.cpp"
      }
    } while(0);
  
    $length1=0; //@line 276 "synthdata.cpp"
    var $52=HEAP32[(($nf)>>2)]; //@line 277 "synthdata.cpp"
    var $sub43=((($52)-1)&4294967295); //@line 277 "synthdata.cpp"
    $nf1=$sub43; //@line 277 "synthdata.cpp"
    $ix=0; //@line 278 "synthdata.cpp"
    var $53=$ix; //@line 278 "synthdata.cpp"
    var $54=$nf1; //@line 278 "synthdata.cpp"
    var $cmp457=((($53))|0) < ((($54))|0); //@line 278 "synthdata.cpp"
    if ($cmp457) { __label__ = 19;; } else { __label__ = 20;; } //@line 278 "synthdata.cpp"
    $for_body46$$for_end53$27: do { 
      if (__label__ == 19) {
        while(1) { 
  
          var $55=$ix; //@line 279 "synthdata.cpp"
          var $56=$frames; //@line 279 "synthdata.cpp"
          var $arrayidx47=(($56+8*$55)&4294967295); //@line 279 "synthdata.cpp"
          var $length48=(($arrayidx47)&4294967295); //@line 279 "synthdata.cpp"
          var $57=HEAP16[(($length48)>>1)]; //@line 279 "synthdata.cpp"
          var $conv49=(tempInt=(($57)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 279 "synthdata.cpp"
          var $58=$length1; //@line 279 "synthdata.cpp"
          var $add50=((($58)+($conv49))&4294967295); //@line 279 "synthdata.cpp"
          $length1=$add50; //@line 279 "synthdata.cpp"
          var $59=$ix; //@line 278 "synthdata.cpp"
          var $inc52=((($59)+1)&4294967295); //@line 278 "synthdata.cpp"
          $ix=$inc52; //@line 278 "synthdata.cpp"
          var $60=$ix; //@line 278 "synthdata.cpp"
          var $61=$nf1; //@line 278 "synthdata.cpp"
          var $cmp45=((($60))|0) < ((($61))|0); //@line 278 "synthdata.cpp"
          if ($cmp45) { __label__ = 19;continue ; } else { __label__ = 20;break $for_body46$$for_end53$27; } //@line 278 "synthdata.cpp"
        }
      }
    } while(0);
  
    var $62=$fmt_params_addr; //@line 281 "synthdata.cpp"
    var $fmt2_addr54=(($62+20)&4294967295); //@line 281 "synthdata.cpp"
    var $63=HEAP32[(($fmt2_addr54)>>2)]; //@line 281 "synthdata.cpp"
    var $cmp55=((($63))|0)!=0; //@line 281 "synthdata.cpp"
    if ($cmp55) { __label__ = 21;; } else { __label__ = 29;; } //@line 281 "synthdata.cpp"
    if (__label__ == 21) {
  
      var $64=$fmt_params_addr; //@line 285 "synthdata.cpp"
      var $fmt2_addr57=(($64+20)&4294967295); //@line 285 "synthdata.cpp"
      var $65=HEAP32[(($fmt2_addr57)>>2)]; //@line 285 "synthdata.cpp"
      var $66=HEAP32[((_phondata_ptr)>>2)]; //@line 285 "synthdata.cpp"
      var $arrayidx58=(($66+$65)&4294967295); //@line 285 "synthdata.cpp"
      var $67=$arrayidx58; //@line 285 "synthdata.cpp"
      $seq2=$67; //@line 285 "synthdata.cpp"
      var $68=$seq2; //@line 286 "synthdata.cpp"
      var $69=$68; //@line 286 "synthdata.cpp"
      $seqk2=$69; //@line 286 "synthdata.cpp"
      var $70=HEAP32[(($nf)>>2)]; //@line 289 "synthdata.cpp"
      var $dec=((($70)-1)&4294967295); //@line 289 "synthdata.cpp"
      HEAP32[(($nf)>>2)]=$dec; //@line 289 "synthdata.cpp"
      $ix=0; //@line 290 "synthdata.cpp"
      var $71=$ix; //@line 290 "synthdata.cpp"
      var $72=$seq2; //@line 290 "synthdata.cpp"
      var $n_frames604=(($72+2)&4294967295); //@line 290 "synthdata.cpp"
      var $73=HEAPU8[($n_frames604)]; //@line 290 "synthdata.cpp"
      var $conv615=((($73))&255); //@line 290 "synthdata.cpp"
      var $cmp626=((($71))|0) < ((($conv615))|0); //@line 290 "synthdata.cpp"
      if ($cmp626) { __label__ = 22;; } else { __label__ = 28;; } //@line 290 "synthdata.cpp"
      $for_body63$$for_end92$33: do { 
        if (__label__ == 22) {
          while(1) { 
  
            var $74=$seq2; //@line 292 "synthdata.cpp"
            var $frame64=(($74+4)&4294967295); //@line 292 "synthdata.cpp"
            var $arrayidx65=(($frame64)&4294967295); //@line 292 "synthdata.cpp"
            var $frflags66=(($arrayidx65)&4294967295); //@line 292 "synthdata.cpp"
            var $75=HEAP16[(($frflags66)>>1)]; //@line 292 "synthdata.cpp"
            var $conv67=(tempInt=(($75)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 292 "synthdata.cpp"
            var $and68=($conv67) & 1; //@line 292 "synthdata.cpp"
            var $tobool69=((($and68))|0)!=0; //@line 292 "synthdata.cpp"
            var $76=$ix; //@line 293 "synthdata.cpp"
            if ($tobool69) { __label__ = 23;; } else { __label__ = 24;; } //@line 292 "synthdata.cpp"
            if (__label__ == 23) {
  
              var $77=$seqk2; //@line 293 "synthdata.cpp"
              var $frame71=(($77+4)&4294967295); //@line 293 "synthdata.cpp"
              var $arrayidx72=(($frame71+$76*64)&4294967295); //@line 293 "synthdata.cpp"
              $frame=$arrayidx72; //@line 293 "synthdata.cpp"
              ; //@line 293 "synthdata.cpp"
            }
            else if (__label__ == 24) {
  
              var $78=$seq2; //@line 295 "synthdata.cpp"
              var $frame74=(($78+4)&4294967295); //@line 295 "synthdata.cpp"
              var $arrayidx75=(($frame74+$76*44)&4294967295); //@line 295 "synthdata.cpp"
              var $79=$arrayidx75; //@line 295 "synthdata.cpp"
              $frame=$79; //@line 295 "synthdata.cpp"
              ;
            }
  
            var $80=$frame; //@line 297 "synthdata.cpp"
            var $length77=(($80+16)&4294967295); //@line 297 "synthdata.cpp"
            var $81=HEAPU8[($length77)]; //@line 297 "synthdata.cpp"
            var $conv78=((($81))&255); //@line 297 "synthdata.cpp"
            var $82=HEAP32[(($nf)>>2)]; //@line 297 "synthdata.cpp"
            var $83=$frames; //@line 297 "synthdata.cpp"
            var $arrayidx79=(($83+8*$82)&4294967295); //@line 297 "synthdata.cpp"
            var $length80=(($arrayidx79)&4294967295); //@line 297 "synthdata.cpp"
            HEAP16[(($length80)>>1)]=$conv78; //@line 297 "synthdata.cpp"
            var $84=$ix; //@line 298 "synthdata.cpp"
            var $cmp81=((($84))|0) > 0; //@line 298 "synthdata.cpp"
            if ($cmp81) { __label__ = 26;; } else { __label__ = 27;; } //@line 298 "synthdata.cpp"
            if (__label__ == 26) {
  
              var $85=$frame; //@line 300 "synthdata.cpp"
              var $86=HEAP32[(($nf)>>2)]; //@line 300 "synthdata.cpp"
              var $87=$frames; //@line 300 "synthdata.cpp"
              var $arrayidx83=(($87+8*$86)&4294967295); //@line 300 "synthdata.cpp"
              var $frame84=(($arrayidx83+4)&4294967295); //@line 300 "synthdata.cpp"
              HEAP32[(($frame84)>>2)]=$85; //@line 300 "synthdata.cpp"
              var $88=$frame; //@line 301 "synthdata.cpp"
              var $frflags85=(($88)&4294967295); //@line 301 "synthdata.cpp"
              var $89=HEAP16[(($frflags85)>>1)]; //@line 301 "synthdata.cpp"
              var $90=HEAP32[(($nf)>>2)]; //@line 301 "synthdata.cpp"
              var $91=$frames; //@line 301 "synthdata.cpp"
              var $arrayidx86=(($91+8*$90)&4294967295); //@line 301 "synthdata.cpp"
              var $frflags87=(($arrayidx86+2)&4294967295); //@line 301 "synthdata.cpp"
              HEAP16[(($frflags87)>>1)]=$89; //@line 301 "synthdata.cpp"
              ; //@line 302 "synthdata.cpp"
            }
  
            var $92=HEAP32[(($nf)>>2)]; //@line 303 "synthdata.cpp"
            var $inc89=((($92)+1)&4294967295); //@line 303 "synthdata.cpp"
            HEAP32[(($nf)>>2)]=$inc89; //@line 303 "synthdata.cpp"
            var $93=$ix; //@line 290 "synthdata.cpp"
            var $inc91=((($93)+1)&4294967295); //@line 290 "synthdata.cpp"
            $ix=$inc91; //@line 290 "synthdata.cpp"
            var $94=$ix; //@line 290 "synthdata.cpp"
            var $95=$seq2; //@line 290 "synthdata.cpp"
            var $n_frames60=(($95+2)&4294967295); //@line 290 "synthdata.cpp"
            var $96=HEAPU8[($n_frames60)]; //@line 290 "synthdata.cpp"
            var $conv61=((($96))&255); //@line 290 "synthdata.cpp"
            var $cmp62=((($94))|0) < ((($conv61))|0); //@line 290 "synthdata.cpp"
            if ($cmp62) { __label__ = 22;continue ; } else { __label__ = 28;break $for_body63$$for_end92$33; } //@line 290 "synthdata.cpp"
          }
        }
      } while(0);
  
      HEAP32[((_wavefile_ix)>>2)]=0; //@line 305 "synthdata.cpp"
      ; //@line 306 "synthdata.cpp"
    }
  
    var $97=$length1; //@line 308 "synthdata.cpp"
    var $cmp94=((($97))|0) > 0; //@line 308 "synthdata.cpp"
    if ($cmp94) { __label__ = 30;; } else { __label__ = 47;; } //@line 308 "synthdata.cpp"
    $if_then95$$if_end175$45: do { 
      if (__label__ == 30) {
  
        var $98=$which_addr; //@line 310 "synthdata.cpp"
        var $cmp96=((($98))|0)==2; //@line 310 "synthdata.cpp"
        if ($cmp96) { __label__ = 31;; } else { __label__ = 37;; } //@line 310 "synthdata.cpp"
        if (__label__ == 31) {
  
          var $99=$fmt_params_addr; //@line 315 "synthdata.cpp"
          var $std_length=(($99+44)&4294967295); //@line 315 "synthdata.cpp"
          var $100=HEAP32[(($std_length)>>2)]; //@line 315 "synthdata.cpp"
          var $101=HEAP32[((_seq_len_adjust)>>2)]; //@line 315 "synthdata.cpp"
          var $add98=((($100)-45)&4294967295); //@line 315 "synthdata.cpp"
          var $sub99=((($add98)+($101))&4294967295); //@line 315 "synthdata.cpp"
          $length_std=$sub99; //@line 315 "synthdata.cpp"
          var $102=$length_std; //@line 316 "synthdata.cpp"
          var $cmp100=((($102))|0) < 10; //@line 316 "synthdata.cpp"
          if ($cmp100) { __label__ = 32;; } else { __label__ = 33;; } //@line 316 "synthdata.cpp"
          if (__label__ == 32) {
  
            $length_std=10; //@line 317 "synthdata.cpp"
            ; //@line 317 "synthdata.cpp"
          }
  
          var $103=$plist_addr; //@line 318 "synthdata.cpp"
          var $synthflags=(($103+4)&4294967295); //@line 318 "synthdata.cpp"
          var $104=HEAPU16[(($synthflags)>>1)]; //@line 318 "synthdata.cpp"
          var $conv103=((($104))&65535); //@line 318 "synthdata.cpp"
          var $and104=($conv103) & 8; //@line 318 "synthdata.cpp"
          var $tobool105=((($and104))|0)!=0; //@line 318 "synthdata.cpp"
          if ($tobool105) { __label__ = 34;; } else { __label__ = 35;; } //@line 318 "synthdata.cpp"
          if (__label__ == 34) {
  
            var $105=HEAP32[((((_phoneme_tab+48)&4294967295))>>2)]; //@line 319 "synthdata.cpp"
            var $std_length107=(($105+14)&4294967295); //@line 319 "synthdata.cpp"
            var $106=HEAPU8[($std_length107)]; //@line 319 "synthdata.cpp"
            var $conv108=((($106))&255); //@line 319 "synthdata.cpp"
            var $mul=((($conv108)*2)&4294967295); //@line 319 "synthdata.cpp"
            var $107=$length_std; //@line 319 "synthdata.cpp"
            var $add109=((($mul)+($107))&4294967295); //@line 319 "synthdata.cpp"
            $length_std=$add109; //@line 319 "synthdata.cpp"
            ; //@line 319 "synthdata.cpp"
          }
  
          var $108=$length_std; //@line 324 "synthdata.cpp"
          var $mul111=((($108)*256)&4294967295); //@line 324 "synthdata.cpp"
          var $109=$length1; //@line 324 "synthdata.cpp"
          var $div=((((($mul111))|0)/((($109))|0))|0); //@line 324 "synthdata.cpp"
          $length_factor=$div; //@line 324 "synthdata.cpp"
          $ix=0; //@line 326 "synthdata.cpp"
          var $110=$ix; //@line 326 "synthdata.cpp"
          var $111=$nf1; //@line 326 "synthdata.cpp"
          var $cmp1133=((($110))|0) < ((($111))|0); //@line 326 "synthdata.cpp"
          if (!($cmp1133)) { __label__ = 47;break $if_then95$$if_end175$45; } //@line 326 "synthdata.cpp"
          while(1) { 
  
            var $112=$ix; //@line 328 "synthdata.cpp"
            var $113=$frames; //@line 328 "synthdata.cpp"
            var $arrayidx115=(($113+8*$112)&4294967295); //@line 328 "synthdata.cpp"
            var $length116=(($arrayidx115)&4294967295); //@line 328 "synthdata.cpp"
            var $114=HEAP16[(($length116)>>1)]; //@line 328 "synthdata.cpp"
            var $conv117=(tempInt=(($114)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 328 "synthdata.cpp"
            var $115=$length_factor; //@line 328 "synthdata.cpp"
            var $mul118=((($conv117)*($115))&4294967295); //@line 328 "synthdata.cpp"
            var $div119=((((($mul118))|0)/256)|0); //@line 328 "synthdata.cpp"
            var $conv120=((($div119)) & 65535); //@line 328 "synthdata.cpp"
            var $116=$ix; //@line 328 "synthdata.cpp"
            var $117=$frames; //@line 328 "synthdata.cpp"
            var $arrayidx121=(($117+8*$116)&4294967295); //@line 328 "synthdata.cpp"
            var $length122=(($arrayidx121)&4294967295); //@line 328 "synthdata.cpp"
            HEAP16[(($length122)>>1)]=$conv120; //@line 328 "synthdata.cpp"
            var $118=$ix; //@line 326 "synthdata.cpp"
            var $inc124=((($118)+1)&4294967295); //@line 326 "synthdata.cpp"
            $ix=$inc124; //@line 326 "synthdata.cpp"
            var $119=$ix; //@line 326 "synthdata.cpp"
            var $120=$nf1; //@line 326 "synthdata.cpp"
            var $cmp113=((($119))|0) < ((($120))|0); //@line 326 "synthdata.cpp"
            if ($cmp113) { __label__ = 36;continue ; } else { __label__ = 47;break $if_then95$$if_end175$45; } //@line 326 "synthdata.cpp"
          }
        }
        else if (__label__ == 37) {
  
          var $121=$which_addr; //@line 333 "synthdata.cpp"
          var $cmp127=((($121))|0)==1; //@line 333 "synthdata.cpp"
          var $122=$fmt_params_addr; //@line 336 "synthdata.cpp"
          if ($cmp127) { __label__ = 38;; } else { __label__ = 41;; } //@line 333 "synthdata.cpp"
          $if_then128$$if_else145$58: do { 
            if (__label__ == 38) {
  
              var $fmt_control=(($122)&4294967295); //@line 336 "synthdata.cpp"
              var $123=HEAP32[(($fmt_control)>>2)]; //@line 336 "synthdata.cpp"
              var $cmp129=((($123))|0)==1; //@line 336 "synthdata.cpp"
              if (!($cmp129)) { __label__ = 43;break $if_then128$$if_else145$58; } //@line 336 "synthdata.cpp"
  
              var $124=$fmt_params_addr; //@line 340 "synthdata.cpp"
              var $std_length131=(($124+44)&4294967295); //@line 340 "synthdata.cpp"
              var $125=HEAP32[(($std_length131)>>2)]; //@line 340 "synthdata.cpp"
              var $cmp132=((($125))|0) < 130; //@line 340 "synthdata.cpp"
              if (!($cmp132)) { __label__ = 43;break $if_then128$$if_else145$58; } //@line 340 "synthdata.cpp"
  
              var $126=$frames; //@line 341 "synthdata.cpp"
              var $arrayidx134=(($126)&4294967295); //@line 341 "synthdata.cpp"
              var $length135=(($arrayidx134)&4294967295); //@line 341 "synthdata.cpp"
              var $127=HEAP16[(($length135)>>1)]; //@line 341 "synthdata.cpp"
              var $conv136=(tempInt=(($127)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 341 "synthdata.cpp"
              var $128=$fmt_params_addr; //@line 341 "synthdata.cpp"
              var $std_length137=(($128+44)&4294967295); //@line 341 "synthdata.cpp"
              var $129=HEAP32[(($std_length137)>>2)]; //@line 341 "synthdata.cpp"
              var $mul138=((($129)*($conv136))&4294967295); //@line 341 "synthdata.cpp"
              var $div139=((((($mul138))|0)/130)|0); //@line 341 "synthdata.cpp"
              var $conv140=((($div139)) & 65535); //@line 341 "synthdata.cpp"
              var $130=$frames; //@line 341 "synthdata.cpp"
              var $arrayidx141=(($130)&4294967295); //@line 341 "synthdata.cpp"
              var $length142=(($arrayidx141)&4294967295); //@line 341 "synthdata.cpp"
              HEAP16[(($length142)>>1)]=$conv140; //@line 341 "synthdata.cpp"
              __label__ = 43;break $if_then128$$if_else145$58; //@line 341 "synthdata.cpp"
            }
            else if (__label__ == 41) {
  
              var $std_length146=(($122+44)&4294967295); //@line 347 "synthdata.cpp"
              var $131=HEAP32[(($std_length146)>>2)]; //@line 347 "synthdata.cpp"
              var $cmp147=((($131))|0) > 0; //@line 347 "synthdata.cpp"
              if (!($cmp147)) { __label__ = 43;break $if_then128$$if_else145$58; } //@line 347 "synthdata.cpp"
  
              var $132=$fmt_params_addr; //@line 349 "synthdata.cpp"
              var $std_length149=(($132+44)&4294967295); //@line 349 "synthdata.cpp"
              var $133=HEAP32[(($std_length149)>>2)]; //@line 349 "synthdata.cpp"
              var $134=$length1; //@line 349 "synthdata.cpp"
              var $sub150=((($133)-($134))&4294967295); //@line 349 "synthdata.cpp"
              var $135=HEAP32[((_seq_len_adjust)>>2)]; //@line 349 "synthdata.cpp"
              var $add151=((($135)+($sub150))&4294967295); //@line 349 "synthdata.cpp"
              HEAP32[((_seq_len_adjust)>>2)]=$add151; //@line 349 "synthdata.cpp"
              __lastLabel__ = 42; __label__ = 44;break $if_then128$$if_else145$58; //@line 350 "synthdata.cpp"
            }
          } while(0);
          if (__label__ == 43) {
  
            var $_pr=HEAP32[((_seq_len_adjust)>>2)]; //@line 353 "synthdata.cpp"
            __lastLabel__ = 43; ;
          }
  
          var $136=__lastLabel__ == 43 ? $_pr : ($add151); //@line 353 "synthdata.cpp"
          var $cmp154=((($136))|0)!=0; //@line 353 "synthdata.cpp"
          if (!($cmp154)) { __label__ = 47;break $if_then95$$if_end175$45; } //@line 353 "synthdata.cpp"
  
          var $137=$length1; //@line 355 "synthdata.cpp"
          var $138=HEAP32[((_seq_len_adjust)>>2)]; //@line 355 "synthdata.cpp"
          var $add156=((($138)+($137))&4294967295); //@line 355 "synthdata.cpp"
          var $mul157=((($add156)*256)&4294967295); //@line 355 "synthdata.cpp"
          var $139=$length1; //@line 355 "synthdata.cpp"
          var $div158=((((($mul157))|0)/((($139))|0))|0); //@line 355 "synthdata.cpp"
          $length_factor=$div158; //@line 355 "synthdata.cpp"
          $ix=0; //@line 356 "synthdata.cpp"
          var $140=$ix; //@line 356 "synthdata.cpp"
          var $141=$nf1; //@line 356 "synthdata.cpp"
          var $cmp1601=((($140))|0) < ((($141))|0); //@line 356 "synthdata.cpp"
          if (!($cmp1601)) { __label__ = 47;break $if_then95$$if_end175$45; } //@line 356 "synthdata.cpp"
          while(1) { 
  
            var $142=$ix; //@line 358 "synthdata.cpp"
            var $143=$frames; //@line 358 "synthdata.cpp"
            var $arrayidx162=(($143+8*$142)&4294967295); //@line 358 "synthdata.cpp"
            var $length163=(($arrayidx162)&4294967295); //@line 358 "synthdata.cpp"
            var $144=HEAP16[(($length163)>>1)]; //@line 358 "synthdata.cpp"
            var $conv164=(tempInt=(($144)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 358 "synthdata.cpp"
            var $145=$length_factor; //@line 358 "synthdata.cpp"
            var $mul165=((($conv164)*($145))&4294967295); //@line 358 "synthdata.cpp"
            var $div166=((((($mul165))|0)/256)|0); //@line 358 "synthdata.cpp"
            var $conv167=((($div166)) & 65535); //@line 358 "synthdata.cpp"
            var $146=$ix; //@line 358 "synthdata.cpp"
            var $147=$frames; //@line 358 "synthdata.cpp"
            var $arrayidx168=(($147+8*$146)&4294967295); //@line 358 "synthdata.cpp"
            var $length169=(($arrayidx168)&4294967295); //@line 358 "synthdata.cpp"
            HEAP16[(($length169)>>1)]=$conv167; //@line 358 "synthdata.cpp"
            var $148=$ix; //@line 356 "synthdata.cpp"
            var $inc171=((($148)+1)&4294967295); //@line 356 "synthdata.cpp"
            $ix=$inc171; //@line 356 "synthdata.cpp"
            var $149=$ix; //@line 356 "synthdata.cpp"
            var $150=$nf1; //@line 356 "synthdata.cpp"
            var $cmp160=((($149))|0) < ((($150))|0); //@line 356 "synthdata.cpp"
            if ($cmp160) { __label__ = 46;continue ; } else { __label__ = 47;break $if_then95$$if_end175$45; } //@line 356 "synthdata.cpp"
          }
        }
      }
    } while(0);
  
    var $151=HEAP32[(($nf)>>2)]; //@line 364 "synthdata.cpp"
    var $152=$n_frames_addr; //@line 364 "synthdata.cpp"
    HEAP32[(($152)>>2)]=$151; //@line 364 "synthdata.cpp"
    var $153=$frames; //@line 365 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return $153; //@line 365 "synthdata.cpp"
    return null;
  }
  

  function __Z11GetEnvelopei($index) {
    ;
    var __label__;
  
    var $retval;
    var $index_addr;
    $index_addr=$index;
    var $0=$index_addr; //@line 372 "synthdata.cpp"
    var $cmp=((($0))|0)==0; //@line 372 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 372 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__impure_ptr)>>2)]; //@line 374 "synthdata.cpp"
      var $_stderr=(($1+12)&4294967295); //@line 374 "synthdata.cpp"
      var $2=HEAP32[(($_stderr)>>2)]; //@line 374 "synthdata.cpp"
      var $3=_fwrite(((__str5416)&4294967295), 20, 1, $2); //@line 374 "synthdata.cpp"
      var $4=HEAP32[((((_envelope_data)&4294967295))>>2)]; //@line 375 "synthdata.cpp"
      $retval=$4; //@line 375 "synthdata.cpp"
      ; //@line 375 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $5=$index_addr; //@line 377 "synthdata.cpp"
      var $6=HEAP32[((_phondata_ptr)>>2)]; //@line 377 "synthdata.cpp"
      var $arrayidx=(($6+$5)&4294967295); //@line 377 "synthdata.cpp"
      $retval=$arrayidx; //@line 377 "synthdata.cpp"
      ; //@line 377 "synthdata.cpp"
    }
  
    var $7=$retval; //@line 378 "synthdata.cpp"
    ;
    return $7; //@line 378 "synthdata.cpp"
    return null;
  }
  

  function __Z18SelectPhonemeTablei($number) {
    ;
    var __label__;
  
    var $number_addr;
    $number_addr=$number;
    HEAP32[((_n_phoneme_tab)>>2)]=0; //@line 416 "synthdata.cpp"
    var $0=$number_addr; //@line 417 "synthdata.cpp"
    __ZL17SetUpPhonemeTableii($0, 0); //@line 417 "synthdata.cpp"
    var $1=HEAP32[((_n_phoneme_tab)>>2)]; //@line 418 "synthdata.cpp"
    var $inc=((($1)+1)&4294967295); //@line 418 "synthdata.cpp"
    HEAP32[((_n_phoneme_tab)>>2)]=$inc; //@line 418 "synthdata.cpp"
    var $2=$number_addr; //@line 419 "synthdata.cpp"
    HEAP32[((_current_phoneme_table)>>2)]=$2; //@line 419 "synthdata.cpp"
    ;
    return; //@line 420 "synthdata.cpp"
    return;
  }
  

  function __ZL17SetUpPhonemeTableii($number, $recursing) {
    ;
    var __label__;
  
    var $number_addr;
    var $recursing_addr;
    var $ix;
    var $includes;
    var $ph_code;
    var $phtab;
    $number_addr=$number;
    $recursing_addr=$recursing;
    var $0=$recursing_addr; //@line 388 "synthdata.cpp"
    var $cmp=((($0))|0)==0; //@line 388 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 388 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = ((_phoneme_tab_flags)&4294967295);
      $stop$ = $dest$ + 256;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 390 "synthdata.cpp"
      ; //@line 391 "synthdata.cpp"
    }
  
    var $1=$number_addr; //@line 393 "synthdata.cpp"
    var $arrayidx=((_phoneme_tab_list+$1*48)&4294967295); //@line 393 "synthdata.cpp"
    var $includes1=(($arrayidx+40)&4294967295); //@line 393 "synthdata.cpp"
    var $2=HEAP32[(($includes1)>>2)]; //@line 393 "synthdata.cpp"
    $includes=$2; //@line 393 "synthdata.cpp"
    var $cmp2=((($2))|0) > 0; //@line 393 "synthdata.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 393 "synthdata.cpp"
    if (__label__ == 3) {
  
      var $3=$includes; //@line 396 "synthdata.cpp"
      var $sub=((($3)-1)&4294967295); //@line 396 "synthdata.cpp"
      __ZL17SetUpPhonemeTableii($sub, 1); //@line 396 "synthdata.cpp"
      ; //@line 397 "synthdata.cpp"
    }
  
    var $4=$number_addr; //@line 400 "synthdata.cpp"
    var $arrayidx5=((_phoneme_tab_list+$4*48)&4294967295); //@line 400 "synthdata.cpp"
    var $phoneme_tab_ptr=(($arrayidx5+32)&4294967295); //@line 400 "synthdata.cpp"
    var $5=HEAP32[(($phoneme_tab_ptr)>>2)]; //@line 400 "synthdata.cpp"
    $phtab=$5; //@line 400 "synthdata.cpp"
    $ix=0; //@line 401 "synthdata.cpp"
    var $6=$ix; //@line 401 "synthdata.cpp"
    var $7=$number_addr; //@line 401 "synthdata.cpp"
    var $arrayidx61=((_phoneme_tab_list+$7*48)&4294967295); //@line 401 "synthdata.cpp"
    var $n_phonemes2=(($arrayidx61+36)&4294967295); //@line 401 "synthdata.cpp"
    var $8=HEAP32[(($n_phonemes2)>>2)]; //@line 401 "synthdata.cpp"
    var $cmp73=((($6))|0) < ((($8))|0); //@line 401 "synthdata.cpp"
    if ($cmp73) { __label__ = 5;; } else { __label__ = 10;; } //@line 401 "synthdata.cpp"
    $for_body$$for_end$8: do { 
      if (__label__ == 5) {
        while(1) { 
  
          var $9=$ix; //@line 403 "synthdata.cpp"
          var $10=$phtab; //@line 403 "synthdata.cpp"
          var $arrayidx8=(($10+16*$9)&4294967295); //@line 403 "synthdata.cpp"
          var $code=(($arrayidx8+10)&4294967295); //@line 403 "synthdata.cpp"
          var $11=HEAPU8[($code)]; //@line 403 "synthdata.cpp"
          var $conv=((($11))&255); //@line 403 "synthdata.cpp"
          $ph_code=$conv; //@line 403 "synthdata.cpp"
          var $12=$ix; //@line 404 "synthdata.cpp"
          var $13=$phtab; //@line 404 "synthdata.cpp"
          var $arrayidx9=(($13+16*$12)&4294967295); //@line 404 "synthdata.cpp"
          var $14=$ph_code; //@line 404 "synthdata.cpp"
          var $arrayidx10=((_phoneme_tab+$14*4)&4294967295); //@line 404 "synthdata.cpp"
          HEAP32[(($arrayidx10)>>2)]=$arrayidx9; //@line 404 "synthdata.cpp"
          var $15=$ph_code; //@line 405 "synthdata.cpp"
          var $16=HEAP32[((_n_phoneme_tab)>>2)]; //@line 405 "synthdata.cpp"
          var $cmp11=((($15))|0) > ((($16))|0); //@line 405 "synthdata.cpp"
          if ($cmp11) { __label__ = 6;; } else { __label__ = 7;; } //@line 405 "synthdata.cpp"
          if (__label__ == 6) {
  
            var $17=$ph_code; //@line 406 "synthdata.cpp"
            HEAP32[((_n_phoneme_tab)>>2)]=$17; //@line 406 "synthdata.cpp"
            ; //@line 406 "synthdata.cpp"
          }
  
          var $18=$recursing_addr; //@line 408 "synthdata.cpp"
          var $cmp14=((($18))|0)==0; //@line 408 "synthdata.cpp"
          if ($cmp14) { __label__ = 8;; } else { __label__ = 9;; } //@line 408 "synthdata.cpp"
          if (__label__ == 8) {
  
            var $19=$ph_code; //@line 409 "synthdata.cpp"
            var $arrayidx16=((_phoneme_tab_flags+$19)&4294967295); //@line 409 "synthdata.cpp"
            var $20=HEAPU8[($arrayidx16)]; //@line 409 "synthdata.cpp"
            var $conv17=((($20))&255); //@line 409 "synthdata.cpp"
            var $or=($conv17) | 1; //@line 409 "synthdata.cpp"
            var $conv18=((($or)) & 255); //@line 409 "synthdata.cpp"
            HEAP8[($arrayidx16)]=$conv18; //@line 409 "synthdata.cpp"
            ; //@line 409 "synthdata.cpp"
          }
  
          var $21=$ix; //@line 401 "synthdata.cpp"
          var $inc=((($21)+1)&4294967295); //@line 401 "synthdata.cpp"
          $ix=$inc; //@line 401 "synthdata.cpp"
          var $22=$ix; //@line 401 "synthdata.cpp"
          var $23=$number_addr; //@line 401 "synthdata.cpp"
          var $arrayidx6=((_phoneme_tab_list+$23*48)&4294967295); //@line 401 "synthdata.cpp"
          var $n_phonemes=(($arrayidx6+36)&4294967295); //@line 401 "synthdata.cpp"
          var $24=HEAP32[(($n_phonemes)>>2)]; //@line 401 "synthdata.cpp"
          var $cmp7=((($22))|0) < ((($24))|0); //@line 401 "synthdata.cpp"
          if ($cmp7) { __label__ = 5;continue ; } else { __label__ = 10;break $for_body$$for_end$8; } //@line 401 "synthdata.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 411 "synthdata.cpp"
    return;
  }
  

  function __Z18LookupPhonemeTablePKc($name) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $ix;
    $name_addr=$name;
    $ix=0; //@line 427 "synthdata.cpp"
    ; //@line 427 "synthdata.cpp"
    while(1) { 
  
      var $0=$ix; //@line 427 "synthdata.cpp"
      var $1=HEAP32[((_n_phoneme_tables)>>2)]; //@line 427 "synthdata.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 427 "synthdata.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 427 "synthdata.cpp"
  
      var $2=$name_addr; //@line 429 "synthdata.cpp"
      var $3=$ix; //@line 429 "synthdata.cpp"
      var $arrayidx=((_phoneme_tab_list+$3*48)&4294967295); //@line 429 "synthdata.cpp"
      var $name1=(($arrayidx)&4294967295); //@line 429 "synthdata.cpp"
      var $arraydecay=(($name1)&4294967295); //@line 429 "synthdata.cpp"
      var $call=_strcmp($2, $arraydecay); //@line 429 "synthdata.cpp"
      var $cmp2=((($call))|0)==0; //@line 429 "synthdata.cpp"
      var $4=$ix; //@line 431 "synthdata.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 429 "synthdata.cpp"
  
      var $inc=((($4)+1)&4294967295); //@line 427 "synthdata.cpp"
      $ix=$inc; //@line 427 "synthdata.cpp"
      __label__ = 1;continue ; //@line 427 "synthdata.cpp"
    }
    if (__label__ == 3) {
  
      HEAP32[((_phoneme_tab_number)>>2)]=$4; //@line 431 "synthdata.cpp"
      ; //@line 432 "synthdata.cpp"
    }
  
    var $5=$ix; //@line 435 "synthdata.cpp"
    var $6=HEAP32[((_n_phoneme_tables)>>2)]; //@line 435 "synthdata.cpp"
    var $cmp3=((($5))|0)==((($6))|0); //@line 435 "synthdata.cpp"
    if ($cmp3) { __label__ = 6;; } else { __label__ = 7;; } //@line 435 "synthdata.cpp"
    if (__label__ == 6) {
  
      $retval=-1; //@line 436 "synthdata.cpp"
      ; //@line 436 "synthdata.cpp"
    }
    else if (__label__ == 7) {
  
      var $7=$ix; //@line 438 "synthdata.cpp"
      $retval=$7; //@line 438 "synthdata.cpp"
      ; //@line 438 "synthdata.cpp"
    }
  
    var $8=$retval; //@line 439 "synthdata.cpp"
    ;
    return $8; //@line 439 "synthdata.cpp"
    return null;
  }
  

  function __Z22SelectPhonemeTableNamePKc($name) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $ix;
    $name_addr=$name;
    var $0=$name_addr; //@line 448 "synthdata.cpp"
    var $call=__Z18LookupPhonemeTablePKc($0); //@line 448 "synthdata.cpp"
    $ix=$call; //@line 448 "synthdata.cpp"
    var $cmp=((($call))|0)==-1; //@line 448 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 448 "synthdata.cpp"
    if (__label__ == 1) {
  
      $retval=-1; //@line 449 "synthdata.cpp"
      ; //@line 449 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$ix; //@line 451 "synthdata.cpp"
      __Z18SelectPhonemeTablei($1); //@line 451 "synthdata.cpp"
      var $2=$ix; //@line 452 "synthdata.cpp"
      $retval=$2; //@line 452 "synthdata.cpp"
      ; //@line 452 "synthdata.cpp"
    }
  
    var $3=$retval; //@line 453 "synthdata.cpp"
    ;
    return $3; //@line 453 "synthdata.cpp"
    return null;
  }
  

  function __Z10LoadConfigv() {
    var __stackBase__  = STACKTOP; STACKTOP += 364; _memset(__stackBase__, 0, 364);
    var __label__;
  
    var $buf=__stackBase__;
    var $f;
    var $ix;
    var $c1=__stackBase__+160;
    var $p;
    var $string=__stackBase__+164;
    HEAP32[((_logging_type)>>2)]=0; //@line 468 "synthdata.cpp"
    $ix=0; //@line 470 "synthdata.cpp"
    ; //@line 470 "synthdata.cpp"
    $for_body$2: while(1) { 
  
      var $0=$ix; //@line 472 "synthdata.cpp"
      var $arrayidx=((_soundicon_tab+$0*16)&4294967295); //@line 472 "synthdata.cpp"
      var $filename=(($arrayidx+12)&4294967295); //@line 472 "synthdata.cpp"
      HEAP32[(($filename)>>2)]=0; //@line 472 "synthdata.cpp"
      var $1=$ix; //@line 473 "synthdata.cpp"
      var $arrayidx1=((_soundicon_tab+$1*16)&4294967295); //@line 473 "synthdata.cpp"
      var $data=(($arrayidx1+8)&4294967295); //@line 473 "synthdata.cpp"
      HEAP32[(($data)>>2)]=0; //@line 473 "synthdata.cpp"
      var $2=$ix; //@line 470 "synthdata.cpp"
      var $inc=((($2)+1)&4294967295); //@line 470 "synthdata.cpp"
      $ix=$inc; //@line 470 "synthdata.cpp"
      var $cmp=((($inc))|0) < 4; //@line 470 "synthdata.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 2;break $for_body$2; } //@line 470 "synthdata.cpp"
    }
  
    var $arraydecay=(($buf)&4294967295); //@line 476 "synthdata.cpp"
    var $call=_sprintf($arraydecay, ((__str74726)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,((__str7418)&4294967295),0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 476 "synthdata.cpp"
    var $arraydecay2=(($buf)&4294967295); //@line 477 "synthdata.cpp"
    var $call3=_fopen($arraydecay2, ((__str51703)&4294967295)); //@line 477 "synthdata.cpp"
    $f=$call3; //@line 477 "synthdata.cpp"
    var $cmp4=((($call3))|0)==0; //@line 477 "synthdata.cpp"
    if ($cmp4) { __label__ = 17;; } else { __label__ = 3;; } //@line 477 "synthdata.cpp"
    $while_end$$while_cond_preheader$5: do { 
      if (__label__ == 3) {
  
        var $arraydecay5=(($buf)&4294967295); //@line 482 "synthdata.cpp"
        var $3=$f; //@line 482 "synthdata.cpp"
        var $call61=_fgets($arraydecay5, 160, $3); //@line 482 "synthdata.cpp"
        var $cmp72=((($call61))|0)!=0; //@line 482 "synthdata.cpp"
        if (!($cmp72)) { __label__ = 17;break $while_end$$while_cond_preheader$5; } //@line 482 "synthdata.cpp"
  
        var $arrayidx8=(($buf)&4294967295); //@line 484 "synthdata.cpp"
        var $arraydecay12=(($buf)&4294967295); //@line 486 "synthdata.cpp"
        var $arrayidx16=(($buf+4)&4294967295); //@line 488 "synthdata.cpp"
        var $arraydecay17=(($string)&4294967295); //@line 488 "synthdata.cpp"
        var $arraydecay21=(($string)&4294967295); //@line 489 "synthdata.cpp"
        var $arraydecay24=(($buf)&4294967295); //@line 492 "synthdata.cpp"
        var $arrayidx28=(($buf+5)&4294967295); //@line 494 "synthdata.cpp"
        var $arraydecay30=(($buf)&4294967295); //@line 497 "synthdata.cpp"
        var $arrayidx34=(($buf+10)&4294967295); //@line 499 "synthdata.cpp"
        var $arraydecay37=(($buf)&4294967295); //@line 502 "synthdata.cpp"
        var $arrayidx41=(($buf+10)&4294967295); //@line 504 "synthdata.cpp"
        var $arraydecay42=(($string)&4294967295); //@line 504 "synthdata.cpp"
        var $arraydecay48=(($string)&4294967295); //@line 508 "synthdata.cpp"
        var $arraydecay51=(($string)&4294967295); //@line 509 "synthdata.cpp"
        ; //@line 482 "synthdata.cpp"
        $while_body$8: while(1) { 
  
          var $4=HEAP8[($arrayidx8)]; //@line 484 "synthdata.cpp"
          var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 484 "synthdata.cpp"
          var $cmp9=((($conv))|0)==47; //@line 484 "synthdata.cpp"
          if ($cmp9) { __label__ = 6;; } else { __label__ = 7;; } //@line 484 "synthdata.cpp"
          $while_cond_backedge$$if_end11$10: do { 
            if (__label__ == 7) {
  
              var $call13=_memcmp($arraydecay12, ((__str9420)&4294967295), 3); //@line 486 "synthdata.cpp"
              var $cmp14=((($call13))|0)==0; //@line 486 "synthdata.cpp"
              if ($cmp14) { __label__ = 8;; } else { __label__ = 10;; } //@line 486 "synthdata.cpp"
              if (__label__ == 8) {
  
                var $call18=_sscanf($arrayidx16, ((__str10421)&4294967295), allocate([_logging_type,0,0,0,$arraydecay17,0,0,0], ["i32*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 488 "synthdata.cpp"
                var $cmp19=((($call18))|0)==2; //@line 488 "synthdata.cpp"
                if (!($cmp19)) { __label__ = 6;break $while_cond_backedge$$if_end11$10; } //@line 488 "synthdata.cpp"
  
                var $call22=_fopen($arraydecay21, ((__str11422)&4294967295)); //@line 489 "synthdata.cpp"
                HEAP32[((_f_logespeak)>>2)]=$call22; //@line 489 "synthdata.cpp"
                ; //@line 489 "synthdata.cpp"
              }
              else if (__label__ == 10) {
  
                var $call25=_memcmp($arraydecay24, ((__str27677)&4294967295), 4); //@line 492 "synthdata.cpp"
                var $cmp26=((($call25))|0)==0; //@line 492 "synthdata.cpp"
                if ($cmp26) { __label__ = 11;; } else { __label__ = 12;; } //@line 492 "synthdata.cpp"
                if (__label__ == 11) {
  
                  __Z14ReadTonePointsPcPi($arrayidx28, ((_tone_points)&4294967295)); //@line 494 "synthdata.cpp"
                  ; //@line 495 "synthdata.cpp"
                }
                else if (__label__ == 12) {
  
                  var $call31=_memcmp($arraydecay30, ((__str13424)&4294967295), 9); //@line 497 "synthdata.cpp"
                  var $cmp32=((($call31))|0)==0; //@line 497 "synthdata.cpp"
                  if ($cmp32) { __label__ = 13;; } else { __label__ = 14;; } //@line 497 "synthdata.cpp"
                  if (__label__ == 13) {
  
                    var $call35=_sscanf($arrayidx34, ((__str63715)&4294967295), allocate([_option_device_number,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 499 "synthdata.cpp"
                    ; //@line 500 "synthdata.cpp"
                  }
                  else if (__label__ == 14) {
  
                    var $call38=_memcmp($arraydecay37, ((__str15426)&4294967295), 9); //@line 502 "synthdata.cpp"
                    var $cmp39=((($call38))|0)==0; //@line 502 "synthdata.cpp"
                    if (!($cmp39)) { __label__ = 6;break $while_cond_backedge$$if_end11$10; } //@line 502 "synthdata.cpp"
  
                    var $call43=_sscanf($arrayidx41, ((__str16427)&4294967295), allocate([$c1,0,0,0,$arraydecay42,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 504 "synthdata.cpp"
                    $ix=$call43; //@line 504 "synthdata.cpp"
                    var $6=$ix; //@line 505 "synthdata.cpp"
                    var $cmp44=((($6))|0)==2; //@line 505 "synthdata.cpp"
                    if (!($cmp44)) { __label__ = 6;break $while_cond_backedge$$if_end11$10; } //@line 505 "synthdata.cpp"
  
                    var $7=HEAP8[($c1)]; //@line 507 "synthdata.cpp"
                    var $conv46=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 507 "synthdata.cpp"
                    var $8=HEAP32[((_n_soundicon_tab)>>2)]; //@line 507 "synthdata.cpp"
                    var $arrayidx47=((_soundicon_tab+$8*16)&4294967295); //@line 507 "synthdata.cpp"
                    var $name=(($arrayidx47)&4294967295); //@line 507 "synthdata.cpp"
                    HEAP32[(($name)>>2)]=$conv46; //@line 507 "synthdata.cpp"
                    var $call49=_strlen($arraydecay48); //@line 508 "synthdata.cpp"
                    var $add=((($call49)+1)&4294967295); //@line 508 "synthdata.cpp"
                    var $call50=__Z5Alloci($add); //@line 508 "synthdata.cpp"
                    $p=$call50; //@line 508 "synthdata.cpp"
                    var $9=$p; //@line 509 "synthdata.cpp"
                    var $call52=_strcpy($9, $arraydecay51); //@line 509 "synthdata.cpp"
                    var $10=$p; //@line 510 "synthdata.cpp"
                    var $11=HEAP32[((_n_soundicon_tab)>>2)]; //@line 510 "synthdata.cpp"
                    var $arrayidx53=((_soundicon_tab+$11*16)&4294967295); //@line 510 "synthdata.cpp"
                    var $filename54=(($arrayidx53+12)&4294967295); //@line 510 "synthdata.cpp"
                    HEAP32[(($filename54)>>2)]=$10; //@line 510 "synthdata.cpp"
                    var $12=HEAP32[((_n_soundicon_tab)>>2)]; //@line 511 "synthdata.cpp"
                    var $inc55=((($12)+1)&4294967295); //@line 511 "synthdata.cpp"
                    HEAP32[((_n_soundicon_tab)>>2)]=$inc55; //@line 511 "synthdata.cpp"
                    var $arrayidx56=((_soundicon_tab+$12*16)&4294967295); //@line 511 "synthdata.cpp"
                    var $length=(($arrayidx56+4)&4294967295); //@line 511 "synthdata.cpp"
                    HEAP32[(($length)>>2)]=0; //@line 511 "synthdata.cpp"
                    ; //@line 512 "synthdata.cpp"
                  }
                }
              }
            }
          } while(0);
  
          var $5=$f; //@line 482 "synthdata.cpp"
          var $call6=_fgets($arraydecay5, 160, $5); //@line 482 "synthdata.cpp"
          var $cmp7=((($call6))|0)!=0; //@line 482 "synthdata.cpp"
          if ($cmp7) { __label__ = 5;continue $while_body$8; } else { __label__ = 17;break $while_end$$while_cond_preheader$5; } //@line 482 "synthdata.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 515 "synthdata.cpp"
    return;
  }
  

  function __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($tr, $control, $plist, $phdata) {
    var __stackBase__  = STACKTOP; STACKTOP += 44; _memset(__stackBase__, 0, 44);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $control_addr;
    var $plist_addr;
    var $phdata_addr;
    var $ph;
    var $prog=__stackBase__;
    var $instn;
    var $instn2;
    var $or_flag;
    var $truth;
    var $data;
    var $end_flag;
    var $ix;
    var $param_sc;
    var $n_return;
    var $return_addr=__stackBase__+4;
    $tr_addr=$tr;
    $control_addr=$control;
    $plist_addr=$plist;
    $phdata_addr=$phdata;
    $n_return=0; //@line 852 "synthdata.cpp"
    var $0=$plist_addr; //@line 855 "synthdata.cpp"
    var $ph1=(($0+8)&4294967295); //@line 855 "synthdata.cpp"
    var $1=HEAP32[(($ph1)>>2)]; //@line 855 "synthdata.cpp"
    $ph=$1; //@line 855 "synthdata.cpp"
    var $2=$phdata_addr; //@line 857 "synthdata.cpp"
    var $3=$2; //@line 857 "synthdata.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $3;
    $stop$ = $dest$ + 152;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 857 "synthdata.cpp"
    var $4=$ph; //@line 858 "synthdata.cpp"
    var $std_length=(($4+14)&4294967295); //@line 858 "synthdata.cpp"
    var $5=HEAPU8[($std_length)]; //@line 858 "synthdata.cpp"
    var $conv=((($5))&255); //@line 858 "synthdata.cpp"
    var $6=$phdata_addr; //@line 858 "synthdata.cpp"
    var $pd_param=(($6+4)&4294967295); //@line 858 "synthdata.cpp"
    var $arrayidx=(($pd_param+40)&4294967295); //@line 858 "synthdata.cpp"
    HEAP32[(($arrayidx)>>2)]=$conv; //@line 858 "synthdata.cpp"
    var $7=$ph; //@line 859 "synthdata.cpp"
    var $length_mod=(($7+15)&4294967295); //@line 859 "synthdata.cpp"
    var $8=HEAPU8[($length_mod)]; //@line 859 "synthdata.cpp"
    var $conv2=((($8))&255); //@line 859 "synthdata.cpp"
    var $9=$phdata_addr; //@line 859 "synthdata.cpp"
    var $pd_param3=(($9+4)&4294967295); //@line 859 "synthdata.cpp"
    var $arrayidx4=(($pd_param3+36)&4294967295); //@line 859 "synthdata.cpp"
    HEAP32[(($arrayidx4)>>2)]=$conv2; //@line 859 "synthdata.cpp"
    var $10=$ph; //@line 861 "synthdata.cpp"
    var $program=(($10+8)&4294967295); //@line 861 "synthdata.cpp"
    var $11=HEAPU16[(($program)>>1)]; //@line 861 "synthdata.cpp"
    var $conv5=((($11))&65535); //@line 861 "synthdata.cpp"
    var $cmp=((($conv5))|0)==0; //@line 861 "synthdata.cpp"
    if ($cmp) { __label__ = 69;; } else { __label__ = 1;; } //@line 861 "synthdata.cpp"
    $for_end237$$if_end$2: do { 
      if (__label__ == 1) {
  
        $end_flag=0; //@line 864 "synthdata.cpp"
        var $12=$ph; //@line 866 "synthdata.cpp"
        var $program6=(($12+8)&4294967295); //@line 866 "synthdata.cpp"
        var $13=HEAPU16[(($program6)>>1)]; //@line 866 "synthdata.cpp"
        var $idxprom=((($13))&65535); //@line 866 "synthdata.cpp"
        var $14=HEAP32[((_phoneme_index)>>2)]; //@line 866 "synthdata.cpp"
        var $arrayidx7=(($14+2*$idxprom)&4294967295); //@line 866 "synthdata.cpp"
        HEAP32[(($prog)>>2)]=$arrayidx7; //@line 866 "synthdata.cpp"
        var $15=$end_flag; //@line 866 "synthdata.cpp"
        var $cmp89=((($15))|0)!=1; //@line 866 "synthdata.cpp"
        if (!($cmp89)) { __label__ = 69;break $for_end237$$if_end$2; } //@line 866 "synthdata.cpp"
        $for_body$4: while(1) { 
  
          var $16=HEAP32[(($prog)>>2)]; //@line 868 "synthdata.cpp"
          var $17=HEAP16[(($16)>>1)]; //@line 868 "synthdata.cpp"
          $instn=$17; //@line 868 "synthdata.cpp"
          var $18=$instn; //@line 869 "synthdata.cpp"
          var $conv9=((($18))&65535); //@line 869 "synthdata.cpp"
          var $shr=($conv9) >> 8; //@line 869 "synthdata.cpp"
          var $and=($shr) & 15; //@line 869 "synthdata.cpp"
          $instn2=$and; //@line 869 "synthdata.cpp"
          $or_flag=0; //@line 870 "synthdata.cpp"
          var $19=$instn; //@line 872 "synthdata.cpp"
          var $conv10=((($19))&65535); //@line 872 "synthdata.cpp"
          var $shr11=($conv10) >> 12; //@line 872 "synthdata.cpp"
          if ($shr11 == 0) {
            __label__ = 3;;
          }
          else if ($shr11 == 1) {
            __label__ = 21;;
          }
          else if ($shr11 == 2) {
            __label__ = 25;;
          }
          else if ($shr11 == 3) {
            __label__ = 25;;
          }
          else if ($shr11 == 6) {
            __label__ = 40;;
          }
          else if ($shr11 == 9) {
            __label__ = 44;;
          }
          else if ($shr11 == 10) {
            __label__ = 49;;
          }
          else if ($shr11 == 11) {
            __label__ = 53;;
          }
          else if ($shr11 == 12) {
            __label__ = 53;;
          }
          else if ($shr11 == 13) {
            __label__ = 53;;
          }
          else if ($shr11 == 14) {
            __label__ = 53;;
          }
          else if ($shr11 == 15) {
            __label__ = 53;;
          }
          else {
          __label__ = 61;;
          }
          
          $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6: do { 
            if (__label__ == 61) {
  
              var $153=$ph; //@line 1077 "synthdata.cpp"
              var $154=$instn; //@line 1077 "synthdata.cpp"
              var $conv222=((($154))&65535); //@line 1077 "synthdata.cpp"
              __ZL12InvalidInstnP11PHONEME_TABi($153, $conv222); //@line 1077 "synthdata.cpp"
              ; //@line 1078 "synthdata.cpp"
            }
            else if (__label__ == 3) {
  
              var $20=$instn; //@line 875 "synthdata.cpp"
              var $conv12=((($20))&65535); //@line 875 "synthdata.cpp"
              var $and13=($conv12) & 255; //@line 875 "synthdata.cpp"
              $data=$and13; //@line 875 "synthdata.cpp"
              var $21=$instn2; //@line 877 "synthdata.cpp"
              var $cmp14=((($21))|0)==0; //@line 877 "synthdata.cpp"
              if ($cmp14) { __label__ = 4;; } else { __label__ = 7;; } //@line 877 "synthdata.cpp"
              if (__label__ == 4) {
  
                var $22=$data; //@line 880 "synthdata.cpp"
                if ($22 == 1) {
                  __label__ = 5;;
                }
                else if ($22 == 2) {
                  __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6;
                }
                else {
                __label__ = 6;;
                }
                
                if (__label__ == 6) {
  
                  var $23=$ph; //@line 890 "synthdata.cpp"
                  var $24=$instn; //@line 890 "synthdata.cpp"
                  var $conv17=((($24))&65535); //@line 890 "synthdata.cpp"
                  __ZL12InvalidInstnP11PHONEME_TABi($23, $conv17); //@line 890 "synthdata.cpp"
                  ; //@line 891 "synthdata.cpp"
                }
                else if (__label__ == 5) {
  
                  $end_flag=1; //@line 883 "synthdata.cpp"
                  ; //@line 884 "synthdata.cpp"
                }
              }
              else if (__label__ == 7) {
  
                var $25=$instn2; //@line 895 "synthdata.cpp"
                var $cmp18=((($25))|0)==5; //@line 895 "synthdata.cpp"
                if ($cmp18) { __label__ = 8;; } else { __label__ = 10;; } //@line 895 "synthdata.cpp"
                if (__label__ == 8) {
  
                  var $26=$plist_addr; //@line 897 "synthdata.cpp"
                  var $arrayidx20=(($26+24)&4294967295); //@line 897 "synthdata.cpp"
                  var $phcode=(($arrayidx20)&4294967295); //@line 897 "synthdata.cpp"
                  var $27=HEAPU8[($phcode)]; //@line 897 "synthdata.cpp"
                  var $idxprom21=((($27))&255); //@line 897 "synthdata.cpp"
                  var $arrayidx22=((_phoneme_tab+$idxprom21*4)&4294967295); //@line 897 "synthdata.cpp"
                  var $28=HEAP32[(($arrayidx22)>>2)]; //@line 897 "synthdata.cpp"
                  var $type=(($28+11)&4294967295); //@line 897 "synthdata.cpp"
                  var $29=HEAPU8[($type)]; //@line 897 "synthdata.cpp"
                  var $conv23=((($29))&255); //@line 897 "synthdata.cpp"
                  var $cmp24=((($conv23))|0)==2; //@line 897 "synthdata.cpp"
                  if (!($cmp24)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 897 "synthdata.cpp"
  
                  var $30=$data; //@line 898 "synthdata.cpp"
                  var $31=$phdata_addr; //@line 898 "synthdata.cpp"
                  var $pd_param26=(($31+4)&4294967295); //@line 898 "synthdata.cpp"
                  var $arrayidx27=(($pd_param26+16)&4294967295); //@line 898 "synthdata.cpp"
                  HEAP32[(($arrayidx27)>>2)]=$30; //@line 898 "synthdata.cpp"
                  ; //@line 898 "synthdata.cpp"
                }
                else if (__label__ == 10) {
  
                  var $32=$instn2; //@line 901 "synthdata.cpp"
                  var $cmp30=((($32))|0)==13; //@line 901 "synthdata.cpp"
                  if ($cmp30) { __label__ = 11;; } else { __label__ = 14;; } //@line 901 "synthdata.cpp"
                  if (__label__ == 11) {
  
                    $ix=0; //@line 904 "synthdata.cpp"
                    var $33=$ix; //@line 904 "synthdata.cpp"
                    var $34=$data; //@line 904 "synthdata.cpp"
                    var $cmp333=((($33))|0) < ((($34))|0); //@line 904 "synthdata.cpp"
                    var $35=$ix; //@line 904 "synthdata.cpp"
                    var $cmp344=((($35))|0) < 16; //@line 904 "synthdata.cpp"
                    var $or_cond15=($cmp333) & ($cmp344); //@line 904 "synthdata.cpp"
                    if ($or_cond15) { __label__ = 12;; } else { __label__ = 13;; } //@line 904 "synthdata.cpp"
                    $for_body35$$for_end$21: do { 
                      if (__label__ == 12) {
                        while(1) { 
  
                          var $36=HEAP32[(($prog)>>2)]; //@line 906 "synthdata.cpp"
                          var $incdec_ptr=(($36+2)&4294967295); //@line 906 "synthdata.cpp"
                          HEAP32[(($prog)>>2)]=$incdec_ptr; //@line 906 "synthdata.cpp"
                          var $37=HEAP32[(($prog)>>2)]; //@line 907 "synthdata.cpp"
                          var $arrayidx36=(($37)&4294967295); //@line 907 "synthdata.cpp"
                          var $38=HEAPU16[(($arrayidx36)>>1)]; //@line 907 "synthdata.cpp"
                          var $conv37=((($38))&65535); //@line 907 "synthdata.cpp"
                          var $shr38=($conv37) >> 8; //@line 907 "synthdata.cpp"
                          var $conv39=((($shr38)) & 255); //@line 907 "synthdata.cpp"
                          var $39=$ix; //@line 907 "synthdata.cpp"
                          var $40=$phdata_addr; //@line 907 "synthdata.cpp"
                          var $ipa_string=(($40+132)&4294967295); //@line 907 "synthdata.cpp"
                          var $arrayidx40=(($ipa_string+$39)&4294967295); //@line 907 "synthdata.cpp"
                          HEAP8[($arrayidx40)]=$conv39; //@line 907 "synthdata.cpp"
                          var $41=HEAP32[(($prog)>>2)]; //@line 908 "synthdata.cpp"
                          var $arrayidx41=(($41)&4294967295); //@line 908 "synthdata.cpp"
                          var $42=HEAPU16[(($arrayidx41)>>1)]; //@line 908 "synthdata.cpp"
                          var $conv42=((($42))&65535); //@line 908 "synthdata.cpp"
                          var $and43=($conv42) & 255; //@line 908 "synthdata.cpp"
                          var $conv44=((($and43)) & 255); //@line 908 "synthdata.cpp"
                          var $43=$ix; //@line 908 "synthdata.cpp"
                          var $add=((($43)+1)&4294967295); //@line 908 "synthdata.cpp"
                          var $44=$phdata_addr; //@line 908 "synthdata.cpp"
                          var $ipa_string45=(($44+132)&4294967295); //@line 908 "synthdata.cpp"
                          var $arrayidx46=(($ipa_string45+$add)&4294967295); //@line 908 "synthdata.cpp"
                          HEAP8[($arrayidx46)]=$conv44; //@line 908 "synthdata.cpp"
                          var $45=$ix; //@line 904 "synthdata.cpp"
                          var $add47=((($45)+2)&4294967295); //@line 904 "synthdata.cpp"
                          $ix=$add47; //@line 904 "synthdata.cpp"
                          var $46=$ix; //@line 904 "synthdata.cpp"
                          var $47=$data; //@line 904 "synthdata.cpp"
                          var $cmp33=((($46))|0) < ((($47))|0); //@line 904 "synthdata.cpp"
                          var $48=$ix; //@line 904 "synthdata.cpp"
                          var $cmp34=((($48))|0) < 16; //@line 904 "synthdata.cpp"
                          var $or_cond1=($cmp33) & ($cmp34); //@line 904 "synthdata.cpp"
                          if ($or_cond1) { __label__ = 12;continue ; } else { __label__ = 13;break $for_body35$$for_end$21; } //@line 904 "synthdata.cpp"
                        }
                      }
                    } while(0);
  
                    var $49=$ix; //@line 910 "synthdata.cpp"
                    var $50=$phdata_addr; //@line 910 "synthdata.cpp"
                    var $ipa_string48=(($50+132)&4294967295); //@line 910 "synthdata.cpp"
                    var $arrayidx49=(($ipa_string48+$49)&4294967295); //@line 910 "synthdata.cpp"
                    HEAP8[($arrayidx49)]=0; //@line 910 "synthdata.cpp"
                    ; //@line 911 "synthdata.cpp"
                  }
                  else if (__label__ == 14) {
  
                    var $51=$instn2; //@line 913 "synthdata.cpp"
                    var $cmp51=((($51))|0) < 16; //@line 913 "synthdata.cpp"
                    if ($cmp51) { __label__ = 15;; } else { __label__ = 20;; } //@line 913 "synthdata.cpp"
                    if (__label__ == 15) {
  
                      var $52=$instn2; //@line 915 "synthdata.cpp"
                      var $cmp53=((($52))|0)==12; //@line 915 "synthdata.cpp"
                      if ($cmp53) { __label__ = 16;; } else { __label__ = 17;; } //@line 915 "synthdata.cpp"
                      if (__label__ == 16) {
  
                        var $53=$data; //@line 917 "synthdata.cpp"
                        var $54=$phdata_addr; //@line 917 "synthdata.cpp"
                        var $pd_param55=(($54+4)&4294967295); //@line 917 "synthdata.cpp"
                        var $arrayidx56=(($pd_param55+4)&4294967295); //@line 917 "synthdata.cpp"
                        HEAP32[(($arrayidx56)>>2)]=$53; //@line 917 "synthdata.cpp"
                        ; //@line 918 "synthdata.cpp"
                      }
  
                      var $55=$data; //@line 919 "synthdata.cpp"
                      var $56=$instn2; //@line 919 "synthdata.cpp"
                      var $57=$phdata_addr; //@line 919 "synthdata.cpp"
                      var $pd_param58=(($57+4)&4294967295); //@line 919 "synthdata.cpp"
                      var $arrayidx59=(($pd_param58+$56*4)&4294967295); //@line 919 "synthdata.cpp"
                      HEAP32[(($arrayidx59)>>2)]=$55; //@line 919 "synthdata.cpp"
                      var $58=$instn2; //@line 920 "synthdata.cpp"
                      var $cmp60=((($58))|0)==1; //@line 920 "synthdata.cpp"
                      if (!($cmp60)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 920 "synthdata.cpp"
  
                      var $59=$control_addr; //@line 920 "synthdata.cpp"
                      var $and61=($59) & 256; //@line 920 "synthdata.cpp"
                      var $tobool=((($and61))|0)!=0; //@line 920 "synthdata.cpp"
                      if (!($tobool)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 920 "synthdata.cpp"
  
                      $end_flag=1; //@line 923 "synthdata.cpp"
                      ; //@line 924 "synthdata.cpp"
                    }
                    else if (__label__ == 20) {
  
                      var $60=$ph; //@line 928 "synthdata.cpp"
                      var $61=$instn; //@line 928 "synthdata.cpp"
                      var $conv65=((($61))&65535); //@line 928 "synthdata.cpp"
                      __ZL12InvalidInstnP11PHONEME_TABi($60, $conv65); //@line 928 "synthdata.cpp"
                      ;
                    }
                  }
                }
              }
            }
            else if (__label__ == 21) {
  
              var $62=$tr_addr; //@line 933 "synthdata.cpp"
              var $cmp71=((($62))|0)==0; //@line 933 "synthdata.cpp"
              if ($cmp71) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 933 "synthdata.cpp"
  
              var $63=$instn2; //@line 936 "synthdata.cpp"
              var $cmp74=((($63))|0) < 8; //@line 936 "synthdata.cpp"
              if (!($cmp74)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 936 "synthdata.cpp"
  
              var $64=$tr_addr; //@line 939 "synthdata.cpp"
              var $65=$plist_addr; //@line 939 "synthdata.cpp"
              var $66=$instn2; //@line 939 "synthdata.cpp"
              var $and76=($66) & 7; //@line 939 "synthdata.cpp"
              var $call=__ZL15StressConditionP10TranslatorP12PHONEME_LISTii($64, $65, $and76, 1); //@line 939 "synthdata.cpp"
              if (!($call)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 939 "synthdata.cpp"
  
              var $67=$instn; //@line 941 "synthdata.cpp"
              var $conv78=((($67))&65535); //@line 941 "synthdata.cpp"
              var $and79=($conv78) & 255; //@line 941 "synthdata.cpp"
              var $68=$phdata_addr; //@line 941 "synthdata.cpp"
              var $pd_param80=(($68+4)&4294967295); //@line 941 "synthdata.cpp"
              var $arrayidx81=(($pd_param80+4)&4294967295); //@line 941 "synthdata.cpp"
              HEAP32[(($arrayidx81)>>2)]=$and79; //@line 941 "synthdata.cpp"
              $end_flag=1; //@line 942 "synthdata.cpp"
              ; //@line 943 "synthdata.cpp"
            }
            else if (__label__ == 25) {
  
              $or_flag=0; //@line 950 "synthdata.cpp"
              $truth=1; //@line 951 "synthdata.cpp"
              var $69=$instn; //@line 952 "synthdata.cpp"
              var $conv856=((($69))&65535); //@line 952 "synthdata.cpp"
              var $and867=($conv856) & 57344; //@line 952 "synthdata.cpp"
              var $cmp878=((($and867))|0)==8192; //@line 952 "synthdata.cpp"
              if ($cmp878) { __label__ = 26;; } else { __label__ = 34;; } //@line 952 "synthdata.cpp"
              $while_body$$while_end$39: do { 
                if (__label__ == 26) {
                  while(1) { 
  
                    var $70=$or_flag; //@line 955 "synthdata.cpp"
                    var $tobool88=((($70))|0)!=0; //@line 955 "synthdata.cpp"
                    var $71=$truth; //@line 956 "synthdata.cpp"
                    var $tobool90=((($71)) & 1); //@line 956 "synthdata.cpp"
                    if ($tobool88) { __label__ = 27;; } else { __label__ = 30;; } //@line 955 "synthdata.cpp"
                    if (__label__ == 27) {
  
                      if ($tobool90) { __lastLabel__ = 27; __label__ = 29;; } else { __lastLabel__ = 27; __label__ = 28;; } //@line 956 "synthdata.cpp"
                      if (__label__ == 28) {
  
                        var $72=$tr_addr; //@line 956 "synthdata.cpp"
                        var $73=$control_addr; //@line 956 "synthdata.cpp"
                        var $74=$plist_addr; //@line 956 "synthdata.cpp"
                        var $75=$instn; //@line 956 "synthdata.cpp"
                        var $conv91=((($75))&65535); //@line 956 "synthdata.cpp"
                        var $and92=($conv91) & 4095; //@line 956 "synthdata.cpp"
                        var $call93=__ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi($72, $73, $74, $and92); //@line 956 "synthdata.cpp"
                        __lastLabel__ = 28; ; //@line 956 "synthdata.cpp"
                      }
  
                      var $76=__lastLabel__ == 27 ? 1 : ($call93);
                      var $frombool=((($76))&1); //@line 956 "synthdata.cpp"
                      $truth=$frombool; //@line 956 "synthdata.cpp"
                      ; //@line 956 "synthdata.cpp"
                    }
                    else if (__label__ == 30) {
  
                      if ($tobool90) { __lastLabel__ = 30; __label__ = 31;; } else { __lastLabel__ = 30; __label__ = 32;; } //@line 958 "synthdata.cpp"
                      if (__label__ == 31) {
  
                        var $77=$tr_addr; //@line 958 "synthdata.cpp"
                        var $78=$control_addr; //@line 958 "synthdata.cpp"
                        var $79=$plist_addr; //@line 958 "synthdata.cpp"
                        var $80=$instn; //@line 958 "synthdata.cpp"
                        var $conv97=((($80))&65535); //@line 958 "synthdata.cpp"
                        var $and98=($conv97) & 4095; //@line 958 "synthdata.cpp"
                        var $call99=__ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi($77, $78, $79, $and98); //@line 958 "synthdata.cpp"
                        __lastLabel__ = 31; ;
                      }
  
                      var $81=__lastLabel__ == 30 ? 0 : ($call99);
                      var $frombool101=((($81))&1);
                      $truth=$frombool101;
                      ;
                    }
  
                    var $82=$instn; //@line 959 "synthdata.cpp"
                    var $conv103=((($82))&65535); //@line 959 "synthdata.cpp"
                    var $and104=($conv103) & 4096; //@line 959 "synthdata.cpp"
                    $or_flag=$and104; //@line 959 "synthdata.cpp"
                    var $83=HEAP32[(($prog)>>2)]; //@line 960 "synthdata.cpp"
                    var $incdec_ptr105=(($83+2)&4294967295); //@line 960 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$incdec_ptr105; //@line 960 "synthdata.cpp"
                    var $84=HEAP16[(($incdec_ptr105)>>1)]; //@line 960 "synthdata.cpp"
                    $instn=$84; //@line 960 "synthdata.cpp"
                    var $85=$instn; //@line 952 "synthdata.cpp"
                    var $conv85=((($85))&65535); //@line 952 "synthdata.cpp"
                    var $and86=($conv85) & 57344; //@line 952 "synthdata.cpp"
                    var $cmp87=((($and86))|0)==8192; //@line 952 "synthdata.cpp"
                    if ($cmp87) { __label__ = 26;continue ; } else { __label__ = 34;break $while_body$$while_end$39; } //@line 952 "synthdata.cpp"
                  }
                }
              } while(0);
  
              var $86=$truth; //@line 963 "synthdata.cpp"
              var $tobool106=((($86)) & 1); //@line 963 "synthdata.cpp"
              var $conv107=((($tobool106))&1); //@line 963 "synthdata.cpp"
              var $cmp108=((($conv107))|0)==0; //@line 963 "synthdata.cpp"
              if ($cmp108) { __label__ = 35;; } else { __label__ = 39;; } //@line 963 "synthdata.cpp"
              $if_then109$$if_end127$53: do { 
                if (__label__ == 35) {
  
                  var $87=$instn; //@line 965 "synthdata.cpp"
                  var $conv110=((($87))&65535); //@line 965 "synthdata.cpp"
                  var $and111=($conv110) & 63488; //@line 965 "synthdata.cpp"
                  var $cmp112=((($and111))|0)==26624; //@line 965 "synthdata.cpp"
                  if ($cmp112) { __label__ = 36;; } else { __label__ = 37;; } //@line 965 "synthdata.cpp"
                  if (__label__ == 36) {
  
                    var $88=$instn; //@line 967 "synthdata.cpp"
                    var $conv114=((($88))&65535); //@line 967 "synthdata.cpp"
                    var $and115=($conv114) & 255; //@line 967 "synthdata.cpp"
                    var $89=HEAP32[(($prog)>>2)]; //@line 967 "synthdata.cpp"
                    var $add_ptr=(($89+2*$and115)&4294967295); //@line 967 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$add_ptr; //@line 967 "synthdata.cpp"
                    ; //@line 968 "synthdata.cpp"
                  }
                  else if (__label__ == 37) {
  
                    var $90=HEAP32[(($prog)>>2)]; //@line 972 "synthdata.cpp"
                    var $call117=__ZL13NumInstnWordsPt($90); //@line 972 "synthdata.cpp"
                    var $91=HEAP32[(($prog)>>2)]; //@line 972 "synthdata.cpp"
                    var $add_ptr118=(($91+2*$call117)&4294967295); //@line 972 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$add_ptr118; //@line 972 "synthdata.cpp"
                    var $92=HEAP32[(($prog)>>2)]; //@line 973 "synthdata.cpp"
                    var $arrayidx119=(($92)&4294967295); //@line 973 "synthdata.cpp"
                    var $93=HEAPU16[(($arrayidx119)>>1)]; //@line 973 "synthdata.cpp"
                    var $conv120=((($93))&65535); //@line 973 "synthdata.cpp"
                    var $and121=($conv120) & 65024; //@line 973 "synthdata.cpp"
                    var $cmp122=((($and121))|0)==24576; //@line 973 "synthdata.cpp"
                    if (!($cmp122)) { __label__ = 39;break $if_then109$$if_end127$53; } //@line 973 "synthdata.cpp"
  
                    var $94=HEAP32[(($prog)>>2)]; //@line 974 "synthdata.cpp"
                    var $incdec_ptr124=(($94+2)&4294967295); //@line 974 "synthdata.cpp"
                    HEAP32[(($prog)>>2)]=$incdec_ptr124; //@line 974 "synthdata.cpp"
                    ; //@line 974 "synthdata.cpp"
                  }
                }
              } while(0);
  
              var $95=HEAP32[(($prog)>>2)]; //@line 977 "synthdata.cpp"
              var $incdec_ptr128=(($95+-2)&4294967295); //@line 977 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr128; //@line 977 "synthdata.cpp"
              ; //@line 978 "synthdata.cpp"
            }
            else if (__label__ == 40) {
  
              var $96=$instn2; //@line 982 "synthdata.cpp"
              var $shr130=($96) >> 1; //@line 982 "synthdata.cpp"
              if ($shr130 == 0) {
                __label__ = 41;;
              }
              else if ($shr130 == 6) {
                __label__ = 43;;
              }
              else if ($shr130 == 5) {
                __label__ = 42;;
              }
              else {
              __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6;
              }
              
              if (__label__ == 41) {
  
                var $97=$instn; //@line 985 "synthdata.cpp"
                var $conv132=((($97))&65535); //@line 985 "synthdata.cpp"
                var $and133=($conv132) & 255; //@line 985 "synthdata.cpp"
                var $sub=((($and133)-1)&4294967295); //@line 985 "synthdata.cpp"
                var $98=HEAP32[(($prog)>>2)]; //@line 985 "synthdata.cpp"
                var $add_ptr134=(($98+2*$sub)&4294967295); //@line 985 "synthdata.cpp"
                HEAP32[(($prog)>>2)]=$add_ptr134; //@line 985 "synthdata.cpp"
                ; //@line 986 "synthdata.cpp"
              }
              else if (__label__ == 43) {
  
                var $101=$plist_addr; //@line 997 "synthdata.cpp"
                var $102=$phdata_addr; //@line 997 "synthdata.cpp"
                __ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti($101, $102, $prog, 3); //@line 997 "synthdata.cpp"
                ; //@line 998 "synthdata.cpp"
              }
              else if (__label__ == 42) {
  
                var $99=$plist_addr; //@line 993 "synthdata.cpp"
                var $100=$phdata_addr; //@line 993 "synthdata.cpp"
                __ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti($99, $100, $prog, 2); //@line 993 "synthdata.cpp"
                ; //@line 994 "synthdata.cpp"
              }
            }
            else if (__label__ == 44) {
  
              var $103=$instn; //@line 1003 "synthdata.cpp"
              var $conv139=((($103))&65535); //@line 1003 "synthdata.cpp"
              var $and140=($conv139) & 15; //@line 1003 "synthdata.cpp"
              var $shl=((($and140)*65536)&4294967295); //@line 1003 "synthdata.cpp"
              var $104=HEAP32[(($prog)>>2)]; //@line 1003 "synthdata.cpp"
              var $arrayidx141=(($104+2)&4294967295); //@line 1003 "synthdata.cpp"
              var $105=HEAPU16[(($arrayidx141)>>1)]; //@line 1003 "synthdata.cpp"
              var $conv142=((($105))&65535); //@line 1003 "synthdata.cpp"
              var $add143=((($shl)+($conv142))&4294967295); //@line 1003 "synthdata.cpp"
              $data=$add143; //@line 1003 "synthdata.cpp"
              var $106=HEAP32[(($prog)>>2)]; //@line 1004 "synthdata.cpp"
              var $incdec_ptr144=(($106+2)&4294967295); //@line 1004 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr144; //@line 1004 "synthdata.cpp"
              var $107=$instn2; //@line 1005 "synthdata.cpp"
              if ($107 == 1) {
                __label__ = 45;;
              }
              else if ($107 == 2) {
                __label__ = 47;;
              }
              else if ($107 == 3) {
                __label__ = 48;;
              }
              else {
              __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6;
              }
              
              if (__label__ == 45) {
  
                var $108=$n_return; //@line 1009 "synthdata.cpp"
                var $cmp146=((($108))|0) < 10; //@line 1009 "synthdata.cpp"
                if (!($cmp146)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 1009 "synthdata.cpp"
  
                var $109=HEAP32[(($prog)>>2)]; //@line 1011 "synthdata.cpp"
                var $110=$n_return; //@line 1011 "synthdata.cpp"
                var $inc=((($110)+1)&4294967295); //@line 1011 "synthdata.cpp"
                $n_return=$inc; //@line 1011 "synthdata.cpp"
                var $arrayidx148=(($return_addr+$110*4)&4294967295); //@line 1011 "synthdata.cpp"
                HEAP32[(($arrayidx148)>>2)]=$109; //@line 1011 "synthdata.cpp"
                var $111=$data; //@line 1012 "synthdata.cpp"
                var $112=HEAP32[((_phoneme_index)>>2)]; //@line 1012 "synthdata.cpp"
                var $arrayidx149=(($112+2*$111)&4294967295); //@line 1012 "synthdata.cpp"
                var $add_ptr150=(($arrayidx149+-2)&4294967295); //@line 1012 "synthdata.cpp"
                HEAP32[(($prog)>>2)]=$add_ptr150; //@line 1012 "synthdata.cpp"
                ; //@line 1013 "synthdata.cpp"
              }
              else if (__label__ == 47) {
  
                var $113=$data; //@line 1018 "synthdata.cpp"
                var $114=$phdata_addr; //@line 1018 "synthdata.cpp"
                var $pitch_env=(($114+124)&4294967295); //@line 1018 "synthdata.cpp"
                HEAP32[(($pitch_env)>>2)]=$113; //@line 1018 "synthdata.cpp"
                ; //@line 1019 "synthdata.cpp"
              }
              else if (__label__ == 48) {
  
                var $115=$data; //@line 1023 "synthdata.cpp"
                var $116=$phdata_addr; //@line 1023 "synthdata.cpp"
                var $amp_env=(($116+128)&4294967295); //@line 1023 "synthdata.cpp"
                HEAP32[(($amp_env)>>2)]=$115; //@line 1023 "synthdata.cpp"
                ; //@line 1024 "synthdata.cpp"
              }
            }
            else if (__label__ == 49) {
  
              var $117=$instn2; //@line 1029 "synthdata.cpp"
              var $cmp156=((($117))|0)==1; //@line 1029 "synthdata.cpp"
              if ($cmp156) { __label__ = 50;; } else { __label__ = 51;; } //@line 1029 "synthdata.cpp"
              if (__label__ == 50) {
  
                $ix=0; //@line 1030 "synthdata.cpp"
                ; //@line 1030 "synthdata.cpp"
              }
              else if (__label__ == 51) {
  
                $ix=2; //@line 1032 "synthdata.cpp"
                ;
              }
  
              var $118=HEAP32[(($prog)>>2)]; //@line 1034 "synthdata.cpp"
              var $arrayidx160=(($118)&4294967295); //@line 1034 "synthdata.cpp"
              var $119=HEAPU16[(($arrayidx160)>>1)]; //@line 1034 "synthdata.cpp"
              var $conv161=((($119))&65535); //@line 1034 "synthdata.cpp"
              var $and162=($conv161) & 255; //@line 1034 "synthdata.cpp"
              var $shl163=((($and162)*65536)&4294967295); //@line 1034 "synthdata.cpp"
              var $120=HEAP32[(($prog)>>2)]; //@line 1034 "synthdata.cpp"
              var $arrayidx164=(($120+2)&4294967295); //@line 1034 "synthdata.cpp"
              var $121=HEAPU16[(($arrayidx164)>>1)]; //@line 1034 "synthdata.cpp"
              var $conv165=((($121))&65535); //@line 1034 "synthdata.cpp"
              var $add166=((($shl163)+($conv165))&4294967295); //@line 1034 "synthdata.cpp"
              var $122=$ix; //@line 1034 "synthdata.cpp"
              var $123=$phdata_addr; //@line 1034 "synthdata.cpp"
              var $vowel_transition=(($123+108)&4294967295); //@line 1034 "synthdata.cpp"
              var $arrayidx167=(($vowel_transition+$122*4)&4294967295); //@line 1034 "synthdata.cpp"
              HEAP32[(($arrayidx167)>>2)]=$add166; //@line 1034 "synthdata.cpp"
              var $124=HEAP32[(($prog)>>2)]; //@line 1035 "synthdata.cpp"
              var $arrayidx168=(($124+4)&4294967295); //@line 1035 "synthdata.cpp"
              var $125=HEAPU16[(($arrayidx168)>>1)]; //@line 1035 "synthdata.cpp"
              var $conv169=((($125))&65535); //@line 1035 "synthdata.cpp"
              var $shl170=((($conv169)*65536)&4294967295); //@line 1035 "synthdata.cpp"
              var $126=HEAP32[(($prog)>>2)]; //@line 1035 "synthdata.cpp"
              var $arrayidx171=(($126+6)&4294967295); //@line 1035 "synthdata.cpp"
              var $127=HEAPU16[(($arrayidx171)>>1)]; //@line 1035 "synthdata.cpp"
              var $conv172=((($127))&65535); //@line 1035 "synthdata.cpp"
              var $add173=((($conv172)+($shl170))&4294967295); //@line 1035 "synthdata.cpp"
              var $128=$ix; //@line 1035 "synthdata.cpp"
              var $add174=((($128)+1)&4294967295); //@line 1035 "synthdata.cpp"
              var $129=$phdata_addr; //@line 1035 "synthdata.cpp"
              var $vowel_transition175=(($129+108)&4294967295); //@line 1035 "synthdata.cpp"
              var $arrayidx176=(($vowel_transition175+$add174*4)&4294967295); //@line 1035 "synthdata.cpp"
              HEAP32[(($arrayidx176)>>2)]=$add173; //@line 1035 "synthdata.cpp"
              var $130=HEAP32[(($prog)>>2)]; //@line 1036 "synthdata.cpp"
              var $add_ptr177=(($130+6)&4294967295); //@line 1036 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$add_ptr177; //@line 1036 "synthdata.cpp"
              ; //@line 1037 "synthdata.cpp"
            }
            else if (__label__ == 53) {
  
              var $131=$instn; //@line 1044 "synthdata.cpp"
              var $conv179=((($131))&65535); //@line 1044 "synthdata.cpp"
              var $shr180=($conv179) >> 12; //@line 1044 "synthdata.cpp"
              var $sub181=((($shr180)-11)&4294967295); //@line 1044 "synthdata.cpp"
              $instn2=$sub181; //@line 1044 "synthdata.cpp"
              var $132=$instn; //@line 1045 "synthdata.cpp"
              var $conv182=((($132))&65535); //@line 1045 "synthdata.cpp"
              var $and183=($conv182) & 15; //@line 1045 "synthdata.cpp"
              var $shl184=((($and183)*262144)&4294967295); //@line 1045 "synthdata.cpp"
              var $133=HEAP32[(($prog)>>2)]; //@line 1045 "synthdata.cpp"
              var $arrayidx185=(($133+2)&4294967295); //@line 1045 "synthdata.cpp"
              var $134=HEAPU16[(($arrayidx185)>>1)]; //@line 1045 "synthdata.cpp"
              var $conv186=((($134))&65535); //@line 1045 "synthdata.cpp"
              var $shl187=((($conv186)*4)&4294967295); //@line 1045 "synthdata.cpp"
              var $add188=((($shl187)+($shl184))&4294967295); //@line 1045 "synthdata.cpp"
              var $135=$instn2; //@line 1045 "synthdata.cpp"
              var $136=$phdata_addr; //@line 1045 "synthdata.cpp"
              var $sound_addr=(($136+68)&4294967295); //@line 1045 "synthdata.cpp"
              var $arrayidx189=(($sound_addr+$135*4)&4294967295); //@line 1045 "synthdata.cpp"
              HEAP32[(($arrayidx189)>>2)]=$add188; //@line 1045 "synthdata.cpp"
              var $137=$instn; //@line 1046 "synthdata.cpp"
              var $conv190=((($137))&65535); //@line 1046 "synthdata.cpp"
              var $shr191=($conv190) >> 4; //@line 1046 "synthdata.cpp"
              var $and192=($shr191) & 255; //@line 1046 "synthdata.cpp"
              var $138=$instn2; //@line 1046 "synthdata.cpp"
              var $139=$phdata_addr; //@line 1046 "synthdata.cpp"
              var $sound_param=(($139+88)&4294967295); //@line 1046 "synthdata.cpp"
              var $arrayidx193=(($sound_param+$138*4)&4294967295); //@line 1046 "synthdata.cpp"
              HEAP32[(($arrayidx193)>>2)]=$and192; //@line 1046 "synthdata.cpp"
              var $conv194=((($and192)) & 255); //@line 1046 "synthdata.cpp"
              $param_sc=$conv194; //@line 1046 "synthdata.cpp"
              var $140=HEAP32[(($prog)>>2)]; //@line 1047 "synthdata.cpp"
              var $incdec_ptr195=(($140+2)&4294967295); //@line 1047 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr195; //@line 1047 "synthdata.cpp"
              var $141=HEAP32[(($prog)>>2)]; //@line 1049 "synthdata.cpp"
              var $arrayidx196=(($141+2)&4294967295); //@line 1049 "synthdata.cpp"
              var $142=HEAPU16[(($arrayidx196)>>1)]; //@line 1049 "synthdata.cpp"
              var $conv197=((($142))&65535); //@line 1049 "synthdata.cpp"
              var $cmp198=((($conv197))|0)!=2; //@line 1049 "synthdata.cpp"
              if (!($cmp198)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 1049 "synthdata.cpp"
  
              var $143=$instn2; //@line 1051 "synthdata.cpp"
              var $cmp200=((($143))|0) < 2; //@line 1051 "synthdata.cpp"
              if ($cmp200) { __label__ = 55;; } else { __label__ = 57;; } //@line 1051 "synthdata.cpp"
              $if_then201$$if_else208$78: do { 
                if (__label__ == 55) {
  
                  $end_flag=1; //@line 1054 "synthdata.cpp"
                  var $144=HEAP32[(($prog)>>2)]; //@line 1055 "synthdata.cpp"
                  var $arrayidx202=(($144+2)&4294967295); //@line 1055 "synthdata.cpp"
                  var $145=HEAPU16[(($arrayidx202)>>1)]; //@line 1055 "synthdata.cpp"
                  var $conv203=((($145))&65535); //@line 1055 "synthdata.cpp"
                  var $shr204=($conv203) >> 12; //@line 1055 "synthdata.cpp"
                  var $cmp205=((($shr204))|0)==15; //@line 1055 "synthdata.cpp"
                  if (!($cmp205)) { __label__ = 59;break $if_then201$$if_else208$78; } //@line 1055 "synthdata.cpp"
  
                  $end_flag=2; //@line 1058 "synthdata.cpp"
                  ; //@line 1059 "synthdata.cpp"
                }
                else if (__label__ == 57) {
  
                  var $146=$instn2; //@line 1062 "synthdata.cpp"
                  var $cmp209=((($146))|0)==4; //@line 1062 "synthdata.cpp"
                  if (!($cmp209)) { __label__ = 59;break $if_then201$$if_else208$78; } //@line 1062 "synthdata.cpp"
  
                  var $147=$end_flag; //@line 1065 "synthdata.cpp"
                  var $dec=((($147)-1)&4294967295); //@line 1065 "synthdata.cpp"
                  $end_flag=$dec; //@line 1065 "synthdata.cpp"
                  ; //@line 1066 "synthdata.cpp"
                }
              } while(0);
  
              var $148=$instn2; //@line 1068 "synthdata.cpp"
              var $cmp213=((($148))|0)==2; //@line 1068 "synthdata.cpp"
              var $149=$instn2; //@line 1068 "synthdata.cpp"
              var $cmp214=((($149))|0)==3; //@line 1068 "synthdata.cpp"
              var $or_cond=($cmp213) | ($cmp214); //@line 1068 "synthdata.cpp"
              if (!($or_cond)) { __label__ = 62;break $sw_default221$$sw_bb$$sw_bb70$$sw_bb84$$sw_bb129$$sw_bb138$$sw_bb155$$sw_bb178$6; } //@line 1068 "synthdata.cpp"
  
              var $150=$param_sc; //@line 1071 "synthdata.cpp"
              var $conv216=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 1071 "synthdata.cpp"
              var $151=$instn2; //@line 1071 "synthdata.cpp"
              var $152=$phdata_addr; //@line 1071 "synthdata.cpp"
              var $sound_param217=(($152+88)&4294967295); //@line 1071 "synthdata.cpp"
              var $arrayidx218=(($sound_param217+$151*4)&4294967295); //@line 1071 "synthdata.cpp"
              HEAP32[(($arrayidx218)>>2)]=$conv216; //@line 1071 "synthdata.cpp"
              ; //@line 1072 "synthdata.cpp"
            }
          } while(0);
  
          var $155=$ph; //@line 1081 "synthdata.cpp"
          var $phflags=(($155+4)&4294967295); //@line 1081 "synthdata.cpp"
          var $156=HEAP32[(($phflags)>>2)]; //@line 1081 "synthdata.cpp"
          var $and224=($156) & 4096; //@line 1081 "synthdata.cpp"
          var $tobool225=((($and224))|0)!=0; //@line 1081 "synthdata.cpp"
          if ($tobool225) { __label__ = 63;; } else { __label__ = 64;; } //@line 1081 "synthdata.cpp"
          $if_end227_thread$$if_end227$86: do { 
            if (__label__ == 63) {
  
              $end_flag=1; //@line 1083 "synthdata.cpp"
              ; //@line 1086 "synthdata.cpp"
            }
            else if (__label__ == 64) {
  
              var $_pr=$end_flag; //@line 1086 "synthdata.cpp"
              var $cmp228=((($_pr))|0)==1; //@line 1086 "synthdata.cpp"
              if ($cmp228) { __label__ = 66;break $if_end227_thread$$if_end227$86; } //@line 1086 "synthdata.cpp"
  
              var $157=HEAP32[(($prog)>>2)]; //@line 866 "synthdata.cpp"
              var $incdec_ptr23611=(($157+2)&4294967295); //@line 866 "synthdata.cpp"
              HEAP32[(($prog)>>2)]=$incdec_ptr23611; //@line 866 "synthdata.cpp"
              __label__ = 2;continue $for_body$4; //@line 866 "synthdata.cpp"
            }
          } while(0);
  
          var $158=$n_return; //@line 1086 "synthdata.cpp"
          var $cmp230=((($158))|0) > 0; //@line 1086 "synthdata.cpp"
          if ($cmp230) { __label__ = 67;; } else { __label__ = 68;; } //@line 1086 "synthdata.cpp"
          if (__label__ == 67) {
  
            $end_flag=0; //@line 1089 "synthdata.cpp"
            var $159=$n_return; //@line 1090 "synthdata.cpp"
            var $dec232=((($159)-1)&4294967295); //@line 1090 "synthdata.cpp"
            $n_return=$dec232; //@line 1090 "synthdata.cpp"
            var $arrayidx233=(($return_addr+$dec232*4)&4294967295); //@line 1090 "synthdata.cpp"
            var $160=HEAP32[(($arrayidx233)>>2)]; //@line 1090 "synthdata.cpp"
            HEAP32[(($prog)>>2)]=$160; //@line 1090 "synthdata.cpp"
            ; //@line 1091 "synthdata.cpp"
          }
  
          var $_pr10=$end_flag; //@line 866 "synthdata.cpp"
          var $161=HEAP32[(($prog)>>2)]; //@line 866 "synthdata.cpp"
          var $incdec_ptr236=(($161+2)&4294967295); //@line 866 "synthdata.cpp"
          HEAP32[(($prog)>>2)]=$incdec_ptr236; //@line 866 "synthdata.cpp"
          var $cmp8=((($_pr10))|0)!=1; //@line 866 "synthdata.cpp"
          if ($cmp8) { __label__ = 2;continue $for_body$4; } else { __label__ = 69;break $for_end237$$if_end$2; } //@line 866 "synthdata.cpp"
        }
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 1094 "synthdata.cpp"
    return;
  }
  

  function __ZL12InvalidInstnP11PHONEME_TABi($ph, $instn) {
    ;
    var __label__;
  
    var $ph_addr;
    var $instn_addr;
    $ph_addr=$ph;
    $instn_addr=$instn;
    var $0=HEAP32[((__impure_ptr)>>2)]; //@line 525 "synthdata.cpp"
    var $_stderr=(($0+12)&4294967295); //@line 525 "synthdata.cpp"
    var $1=HEAP32[(($_stderr)>>2)]; //@line 525 "synthdata.cpp"
    var $2=$instn_addr; //@line 525 "synthdata.cpp"
    var $3=$ph_addr; //@line 525 "synthdata.cpp"
    var $mnemonic=(($3)&4294967295); //@line 525 "synthdata.cpp"
    var $4=HEAP32[(($mnemonic)>>2)]; //@line 525 "synthdata.cpp"
    var $call=__Z12WordToStringj($4); //@line 525 "synthdata.cpp"
    var $call1=_fprintf($1, ((__str17428)&4294967295), allocate([$2,0,0,0,((__ZZ12WordToStringjE3buf)&4294967295),0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 525 "synthdata.cpp"
    ;
    return; //@line 526 "synthdata.cpp"
    return;
  }
  

  function __ZL15StressConditionP10TranslatorP12PHONEME_LISTii($tr, $plist, $condition, $control) {
    ;
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $plist_addr;
    var $condition_addr;
    var $control_addr;
    var $stress_level;
    var $pl;
    $tr_addr=$tr;
    $plist_addr=$plist;
    $condition_addr=$condition;
    $control_addr=$control;
    var $0=$plist_addr; //@line 538 "synthdata.cpp"
    var $arrayidx=(($0)&4294967295); //@line 538 "synthdata.cpp"
    var $phcode=(($arrayidx)&4294967295); //@line 538 "synthdata.cpp"
    var $1=HEAPU8[($phcode)]; //@line 538 "synthdata.cpp"
    var $idxprom=((($1))&255); //@line 538 "synthdata.cpp"
    var $arrayidx1=((_phoneme_tab+$idxprom*4)&4294967295); //@line 538 "synthdata.cpp"
    var $2=HEAP32[(($arrayidx1)>>2)]; //@line 538 "synthdata.cpp"
    var $type=(($2+11)&4294967295); //@line 538 "synthdata.cpp"
    var $3=HEAPU8[($type)]; //@line 538 "synthdata.cpp"
    var $conv=((($3))&255); //@line 538 "synthdata.cpp"
    var $cmp=((($conv))|0)==2; //@line 538 "synthdata.cpp"
    var $4=$plist_addr; //@line 540 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 538 "synthdata.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        $pl=$4; //@line 540 "synthdata.cpp"
        __label__ = 5;break $if_then$$if_else$2; //@line 541 "synthdata.cpp"
      }
      else if (__label__ == 2) {
  
        var $arrayidx2=(($4+24)&4294967295); //@line 545 "synthdata.cpp"
        var $phcode3=(($arrayidx2)&4294967295); //@line 545 "synthdata.cpp"
        var $5=HEAPU8[($phcode3)]; //@line 545 "synthdata.cpp"
        var $idxprom4=((($5))&255); //@line 545 "synthdata.cpp"
        var $arrayidx5=((_phoneme_tab+$idxprom4*4)&4294967295); //@line 545 "synthdata.cpp"
        var $6=HEAP32[(($arrayidx5)>>2)]; //@line 545 "synthdata.cpp"
        var $type6=(($6+11)&4294967295); //@line 545 "synthdata.cpp"
        var $7=HEAPU8[($type6)]; //@line 545 "synthdata.cpp"
        var $conv7=((($7))&255); //@line 545 "synthdata.cpp"
        var $cmp8=((($conv7))|0)==2; //@line 545 "synthdata.cpp"
        if ($cmp8) { __label__ = 3;; } else { __label__ = 4;; } //@line 545 "synthdata.cpp"
        if (__label__ == 3) {
  
          var $8=$plist_addr; //@line 547 "synthdata.cpp"
          var $arrayidx10=(($8+24)&4294967295); //@line 547 "synthdata.cpp"
          $pl=$arrayidx10; //@line 547 "synthdata.cpp"
          __label__ = 5;break $if_then$$if_else$2;
        }
        else if (__label__ == 4) {
  
          $retval=0; //@line 550 "synthdata.cpp"
          __label__ = 21;break $if_then$$if_else$2; //@line 550 "synthdata.cpp"
        }
      }
    } while(0);
    $if_end12$$return$8: do { 
      if (__label__ == 5) {
  
        var $9=$pl; //@line 553 "synthdata.cpp"
        var $stresslevel=(($9+1)&4294967295); //@line 553 "synthdata.cpp"
        var $10=HEAPU8[($stresslevel)]; //@line 553 "synthdata.cpp"
        var $conv13=((($10))&255); //@line 553 "synthdata.cpp"
        var $and=($conv13) & 15; //@line 553 "synthdata.cpp"
        $stress_level=$and; //@line 553 "synthdata.cpp"
        var $11=$tr_addr; //@line 555 "synthdata.cpp"
        var $cmp14=((($11))|0)!=0; //@line 555 "synthdata.cpp"
        if ($cmp14) { __label__ = 6;; } else { __label__ = 13;; } //@line 555 "synthdata.cpp"
        $if_then15$$if_end36$10: do { 
          if (__label__ == 6) {
  
            var $12=$control_addr; //@line 557 "synthdata.cpp"
            var $and16=($12) & 1; //@line 557 "synthdata.cpp"
            var $tobool=((($and16))|0)!=0; //@line 557 "synthdata.cpp"
            if ($tobool) { __label__ = 7;; } else { __label__ = 10;; } //@line 557 "synthdata.cpp"
            $land_lhs_true$$if_end25$12: do { 
              if (__label__ == 7) {
  
                var $13=$plist_addr; //@line 557 "synthdata.cpp"
                var $synthflags=(($13+4)&4294967295); //@line 557 "synthdata.cpp"
                var $14=HEAPU16[(($synthflags)>>1)]; //@line 557 "synthdata.cpp"
                var $conv17=((($14))&65535); //@line 557 "synthdata.cpp"
                var $and18=($conv17) & 16; //@line 557 "synthdata.cpp"
                var $tobool19=((($and18))|0)!=0; //@line 557 "synthdata.cpp"
                if (!($tobool19)) { __label__ = 10;break $land_lhs_true$$if_end25$12; } //@line 557 "synthdata.cpp"
  
                var $15=$tr_addr; //@line 557 "synthdata.cpp"
                var $langopts=(($15)&4294967295); //@line 557 "synthdata.cpp"
                var $param=(($langopts+24)&4294967295); //@line 557 "synthdata.cpp"
                var $arrayidx21=(($param+40)&4294967295); //@line 557 "synthdata.cpp"
                var $16=HEAP32[(($arrayidx21)>>2)]; //@line 557 "synthdata.cpp"
                var $and22=($16) & 1; //@line 557 "synthdata.cpp"
                var $cmp23=((($and22))|0)==0; //@line 557 "synthdata.cpp"
                if (!($cmp23)) { __label__ = 10;break $land_lhs_true$$if_end25$12; } //@line 557 "synthdata.cpp"
  
                $retval=0; //@line 560 "synthdata.cpp"
                __label__ = 21;break $if_end12$$return$8; //@line 560 "synthdata.cpp"
              }
            } while(0);
  
            var $17=$tr_addr; //@line 563 "synthdata.cpp"
            var $langopts26=(($17)&4294967295); //@line 563 "synthdata.cpp"
            var $param27=(($langopts26+24)&4294967295); //@line 563 "synthdata.cpp"
            var $arrayidx28=(($param27+40)&4294967295); //@line 563 "synthdata.cpp"
            var $18=HEAP32[(($arrayidx28)>>2)]; //@line 563 "synthdata.cpp"
            var $and29=($18) & 2; //@line 563 "synthdata.cpp"
            var $tobool30=((($and29))|0)!=0; //@line 563 "synthdata.cpp"
            if (!($tobool30)) { __label__ = 13;break $if_then15$$if_end36$10; } //@line 563 "synthdata.cpp"
  
            var $19=$stress_level; //@line 563 "synthdata.cpp"
            var $20=$pl; //@line 563 "synthdata.cpp"
            var $wordstress=(($20+2)&4294967295); //@line 563 "synthdata.cpp"
            var $21=HEAPU8[($wordstress)]; //@line 563 "synthdata.cpp"
            var $conv32=((($21))&255); //@line 563 "synthdata.cpp"
            var $cmp33=((($19))|0) >= ((($conv32))|0); //@line 563 "synthdata.cpp"
            if (!($cmp33)) { __label__ = 13;break $if_then15$$if_end36$10; } //@line 563 "synthdata.cpp"
  
            $stress_level=4; //@line 566 "synthdata.cpp"
            ; //@line 567 "synthdata.cpp"
          }
        } while(0);
  
        var $22=$condition_addr; //@line 570 "synthdata.cpp"
        var $cmp37=((($22))|0)==4; //@line 570 "synthdata.cpp"
        if ($cmp37) { __label__ = 14;; } else { __label__ = 15;; } //@line 570 "synthdata.cpp"
        if (__label__ == 14) {
  
          var $23=$stress_level; //@line 572 "synthdata.cpp"
          var $24=$pl; //@line 572 "synthdata.cpp"
          var $wordstress39=(($24+2)&4294967295); //@line 572 "synthdata.cpp"
          var $25=HEAPU8[($wordstress39)]; //@line 572 "synthdata.cpp"
          var $conv40=((($25))&255); //@line 572 "synthdata.cpp"
          var $cmp41=((($23))|0) >= ((($conv40))|0); //@line 572 "synthdata.cpp"
          $retval=$cmp41; //@line 572 "synthdata.cpp"
          ; //@line 572 "synthdata.cpp"
        }
        else if (__label__ == 15) {
  
          var $26=$condition_addr; //@line 575 "synthdata.cpp"
          var $cmp43=((($26))|0)==3; //@line 575 "synthdata.cpp"
          var $27=$stress_level; //@line 578 "synthdata.cpp"
          if ($cmp43) { __label__ = 16;; } else { __label__ = 18;; } //@line 575 "synthdata.cpp"
          $if_then44$$if_else48$23: do { 
            if (__label__ == 16) {
  
              var $cmp45=((($27))|0) > 3; //@line 578 "synthdata.cpp"
              if (!($cmp45)) { __label__ = 20;break $if_then44$$if_else48$23; } //@line 578 "synthdata.cpp"
  
              $retval=1; //@line 579 "synthdata.cpp"
              __label__ = 21;break $if_end12$$return$8; //@line 579 "synthdata.cpp"
            }
            else if (__label__ == 18) {
  
              var $28=$condition_addr; //@line 583 "synthdata.cpp"
              var $arrayidx49=((__ZZL15StressConditionP10TranslatorP12PHONEME_LISTiiE15condition_level+$28*4)&4294967295); //@line 583 "synthdata.cpp"
              var $29=HEAP32[(($arrayidx49)>>2)]; //@line 583 "synthdata.cpp"
              var $cmp50=((($27))|0) < ((($29))|0); //@line 583 "synthdata.cpp"
              if (!($cmp50)) { __label__ = 20;break $if_then44$$if_else48$23; } //@line 583 "synthdata.cpp"
  
              $retval=1; //@line 584 "synthdata.cpp"
              __label__ = 21;break $if_end12$$return$8; //@line 584 "synthdata.cpp"
            }
          } while(0);
  
          $retval=0; //@line 586 "synthdata.cpp"
          ; //@line 586 "synthdata.cpp"
        }
      }
    } while(0);
  
    var $30=$retval; //@line 588 "synthdata.cpp"
    ;
    return $30; //@line 588 "synthdata.cpp"
    return null;
  }
  

  function __ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi($tr, $control, $plist, $instn) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $control_addr;
    var $plist_addr;
    var $instn_addr;
    var $which;
    var $data;
    var $instn2;
    var $count;
    var $ph;
    var $plist_this;
    $tr_addr=$tr;
    $control_addr=$control;
    $plist_addr=$plist;
    $instn_addr=$instn;
    var $0=$instn_addr; //@line 601 "synthdata.cpp"
    var $and=($0) & 255; //@line 601 "synthdata.cpp"
    $data=$and; //@line 601 "synthdata.cpp"
    var $1=$instn_addr; //@line 602 "synthdata.cpp"
    var $shr=($1) >> 8; //@line 602 "synthdata.cpp"
    $instn2=$shr; //@line 602 "synthdata.cpp"
    var $2=$instn2; //@line 604 "synthdata.cpp"
    var $cmp=((($2))|0) < 14; //@line 604 "synthdata.cpp"
    var $3=$instn2; //@line 606 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 67;; } //@line 604 "synthdata.cpp"
    $if_then$$if_else187$2: do { 
      if (__label__ == 1) {
  
        var $rem=((($3))|0)%7; //@line 606 "synthdata.cpp"
        $which=$rem; //@line 606 "synthdata.cpp"
        var $4=$which; //@line 608 "synthdata.cpp"
        var $cmp1=((($4))|0)==4; //@line 608 "synthdata.cpp"
        if ($cmp1) { __lastLabel__ = 1; __label__ = 2;; } else { __lastLabel__ = 1; __label__ = 5;; } //@line 608 "synthdata.cpp"
        if (__label__ == 2) {
  
          var $5=$plist_addr; //@line 611 "synthdata.cpp"
          var $arrayidx=(($5+24)&4294967295); //@line 611 "synthdata.cpp"
          var $sourceix=(($arrayidx+6)&4294967295); //@line 611 "synthdata.cpp"
          var $6=HEAP16[(($sourceix)>>1)]; //@line 611 "synthdata.cpp"
          var $tobool=(tempInt=(($6)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 611 "synthdata.cpp"
          if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 611 "synthdata.cpp"
          if (__label__ == 3) {
  
            $retval=0; //@line 612 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 612 "synthdata.cpp"
          }
          else if (__label__ == 4) {
  
            var $_pr=$which; //@line 614 "synthdata.cpp"
            __lastLabel__ = 4; ;
          }
        }
  
        var $7=__lastLabel__ == 4 ? $_pr : ($4); //@line 614 "synthdata.cpp"
        var $cmp5=((($7))|0)==5; //@line 614 "synthdata.cpp"
        if ($cmp5) { __label__ = 6;; } else { __label__ = 8;; } //@line 614 "synthdata.cpp"
        $if_then6$$if_end12$10: do { 
          if (__label__ == 6) {
  
            var $8=$plist_addr; //@line 617 "synthdata.cpp"
            var $arrayidx7=(($8)&4294967295); //@line 617 "synthdata.cpp"
            var $sourceix8=(($arrayidx7+6)&4294967295); //@line 617 "synthdata.cpp"
            var $9=HEAP16[(($sourceix8)>>1)]; //@line 617 "synthdata.cpp"
            var $tobool9=(tempInt=(($9)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 617 "synthdata.cpp"
            if (!($tobool9)) { __label__ = 8;break $if_then6$$if_end12$10; } //@line 617 "synthdata.cpp"
  
            $retval=0; //@line 618 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 618 "synthdata.cpp"
          }
        } while(0);
  
        var $10=$which; //@line 620 "synthdata.cpp"
        var $cmp13=((($10))|0)==7; //@line 620 "synthdata.cpp"
        if ($cmp13) { __lastLabel__ = 8; __label__ = 9;; } else { __lastLabel__ = 8; __label__ = 13;; } //@line 620 "synthdata.cpp"
        $if_then14$$if_end23$14: do { 
          if (__label__ == 9) {
  
            var $11=$plist_addr; //@line 623 "synthdata.cpp"
            var $arrayidx15=(($11+24)&4294967295); //@line 623 "synthdata.cpp"
            var $sourceix16=(($arrayidx15+6)&4294967295); //@line 623 "synthdata.cpp"
            var $12=HEAP16[(($sourceix16)>>1)]; //@line 623 "synthdata.cpp"
            var $tobool17=(tempInt=(($12)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 623 "synthdata.cpp"
            if ($tobool17) { __label__ = 11;; } else { __label__ = 10;; } //@line 623 "synthdata.cpp"
            $if_then21$$lor_lhs_false$16: do { 
              if (__label__ == 10) {
  
                var $13=$plist_addr; //@line 623 "synthdata.cpp"
                var $arrayidx18=(($13+48)&4294967295); //@line 623 "synthdata.cpp"
                var $sourceix19=(($arrayidx18+6)&4294967295); //@line 623 "synthdata.cpp"
                var $14=HEAP16[(($sourceix19)>>1)]; //@line 623 "synthdata.cpp"
                var $tobool20=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 623 "synthdata.cpp"
                if ($tobool20) { __label__ = 11;break $if_then21$$lor_lhs_false$16; } //@line 623 "synthdata.cpp"
  
                var $_pr1=$which; //@line 627 "synthdata.cpp"
                __lastLabel__ = 12; __label__ = 13;break $if_then14$$if_end23$14;
              }
            } while(0);
  
            $retval=0; //@line 624 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 624 "synthdata.cpp"
          }
        } while(0);
  
        var $15=__lastLabel__ == 12 ? $_pr1 : ($10); //@line 627 "synthdata.cpp"
        var $cmp24=((($15))|0)==6; //@line 627 "synthdata.cpp"
        if ($cmp24) { __label__ = 14;; } else { __label__ = 19;; } //@line 627 "synthdata.cpp"
        $if_then25$$if_else$21: do { 
          if (__label__ == 14) {
  
            $which=2; //@line 630 "synthdata.cpp"
            ; //@line 630 "synthdata.cpp"
            while(1) { 
  
              var $16=$which; //@line 632 "synthdata.cpp"
              var $sub=((($16)-1)&4294967295); //@line 632 "synthdata.cpp"
              var $17=$plist_addr; //@line 632 "synthdata.cpp"
              var $arrayidx26=(($17+24*$sub)&4294967295); //@line 632 "synthdata.cpp"
              var $sourceix27=(($arrayidx26+6)&4294967295); //@line 632 "synthdata.cpp"
              var $18=HEAP16[(($sourceix27)>>1)]; //@line 632 "synthdata.cpp"
              var $tobool28=(tempInt=(($18)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 632 "synthdata.cpp"
              if ($tobool28) { __label__ = 16;break ; } //@line 632 "synthdata.cpp"
  
              var $19=$which; //@line 634 "synthdata.cpp"
              var $sub31=((($19)-1)&4294967295); //@line 634 "synthdata.cpp"
              var $20=$plist_addr; //@line 634 "synthdata.cpp"
              var $arrayidx32=(($20+24*$sub31)&4294967295); //@line 634 "synthdata.cpp"
              var $phcode=(($arrayidx32)&4294967295); //@line 634 "synthdata.cpp"
              var $21=HEAPU8[($phcode)]; //@line 634 "synthdata.cpp"
              var $idxprom=((($21))&255); //@line 634 "synthdata.cpp"
              var $arrayidx33=((_phoneme_tab+$idxprom*4)&4294967295); //@line 634 "synthdata.cpp"
              var $22=HEAP32[(($arrayidx33)>>2)]; //@line 634 "synthdata.cpp"
              var $type=(($22+11)&4294967295); //@line 634 "synthdata.cpp"
              var $23=HEAPU8[($type)]; //@line 634 "synthdata.cpp"
              var $conv=((($23))&255); //@line 634 "synthdata.cpp"
              var $cmp34=((($conv))|0)==2; //@line 634 "synthdata.cpp"
              var $_pr2=$which; //@line 644 "synthdata.cpp"
              if ($cmp34) { __lastLabel__ = 17; __label__ = 20;break $if_then25$$if_else$21; } else { __lastLabel__ = 17; ; } //@line 634 "synthdata.cpp"
  
              var $inc=((($_pr2)+1)&4294967295); //@line 630 "synthdata.cpp"
              $which=$inc; //@line 630 "synthdata.cpp"
              __label__ = 15;continue ; //@line 630 "synthdata.cpp"
            }
  
            $retval=0; //@line 633 "synthdata.cpp"
            __label__ = 73;break $if_then$$if_else187$2; //@line 633 "synthdata.cpp"
          }
          else if (__label__ == 19) {
  
            var $24=$which; //@line 640 "synthdata.cpp"
            var $arrayidx37=((__ZZL18InterpretConditionP10TranslatoriP12PHONEME_LISTiE11ph_position+$24*4)&4294967295); //@line 640 "synthdata.cpp"
            var $25=HEAP32[(($arrayidx37)>>2)]; //@line 640 "synthdata.cpp"
            $which=$25; //@line 640 "synthdata.cpp"
            __lastLabel__ = 19; ;
          }
        } while(0);
  
        var $26=__lastLabel__ == 19 ? $25 : ($_pr2); //@line 644 "synthdata.cpp"
        var $27=$plist_addr; //@line 643 "synthdata.cpp"
        $plist_this=$27; //@line 643 "synthdata.cpp"
        var $sub39=((($26)-1)&4294967295); //@line 644 "synthdata.cpp"
        var $28=$plist_addr; //@line 644 "synthdata.cpp"
        var $arrayidx40=(($28+24*$sub39)&4294967295); //@line 644 "synthdata.cpp"
        $plist_addr=$arrayidx40; //@line 644 "synthdata.cpp"
        var $cmp41=((($26))|0)==0; //@line 646 "synthdata.cpp"
        if ($cmp41) { __label__ = 21;; } else { __label__ = 23;; } //@line 646 "synthdata.cpp"
        $if_then42$$if_end49$30: do { 
          if (__label__ == 21) {
  
            var $29=$plist_addr; //@line 648 "synthdata.cpp"
            var $phcode43=(($29)&4294967295); //@line 648 "synthdata.cpp"
            var $30=HEAPU8[($phcode43)]; //@line 648 "synthdata.cpp"
            var $conv44=((($30))&255); //@line 648 "synthdata.cpp"
            var $cmp45=((($conv44))|0)==1; //@line 648 "synthdata.cpp"
            if (!($cmp45)) { __label__ = 23;break $if_then42$$if_end49$30; } //@line 648 "synthdata.cpp"
  
            var $31=$plist_addr; //@line 651 "synthdata.cpp"
            var $arrayidx47=(($31+-24)&4294967295); //@line 651 "synthdata.cpp"
            $plist_addr=$arrayidx47; //@line 651 "synthdata.cpp"
            ; //@line 652 "synthdata.cpp"
          }
        } while(0);
  
        var $32=$control_addr; //@line 655 "synthdata.cpp"
        var $and50=($32) & 256; //@line 655 "synthdata.cpp"
        var $tobool51=((($and50))|0)!=0; //@line 655 "synthdata.cpp"
        if ($tobool51) { __label__ = 24;; } else { __label__ = 25;; } //@line 655 "synthdata.cpp"
        if (__label__ == 24) {
  
          var $33=$plist_addr; //@line 658 "synthdata.cpp"
          var $phcode53=(($33)&4294967295); //@line 658 "synthdata.cpp"
          var $34=HEAPU8[($phcode53)]; //@line 658 "synthdata.cpp"
          var $idxprom54=((($34))&255); //@line 658 "synthdata.cpp"
          var $arrayidx55=((_phoneme_tab+$idxprom54*4)&4294967295); //@line 658 "synthdata.cpp"
          var $35=HEAP32[(($arrayidx55)>>2)]; //@line 658 "synthdata.cpp"
          var $36=$plist_addr; //@line 658 "synthdata.cpp"
          var $ph56=(($36+8)&4294967295); //@line 658 "synthdata.cpp"
          HEAP32[(($ph56)>>2)]=$35; //@line 658 "synthdata.cpp"
          ; //@line 659 "synthdata.cpp"
        }
  
        var $37=$plist_addr; //@line 660 "synthdata.cpp"
        var $ph58=(($37+8)&4294967295); //@line 660 "synthdata.cpp"
        var $38=HEAP32[(($ph58)>>2)]; //@line 660 "synthdata.cpp"
        $ph=$38; //@line 660 "synthdata.cpp"
        var $39=$instn2; //@line 662 "synthdata.cpp"
        var $cmp59=((($39))|0) < 7; //@line 662 "synthdata.cpp"
        if ($cmp59) { __label__ = 26;; } else { __label__ = 32;; } //@line 662 "synthdata.cpp"
        if (__label__ == 26) {
  
          var $40=$data; //@line 665 "synthdata.cpp"
          var $arrayidx61=((_phoneme_tab+$40*4)&4294967295); //@line 665 "synthdata.cpp"
          var $41=HEAP32[(($arrayidx61)>>2)]; //@line 665 "synthdata.cpp"
          var $mnemonic=(($41)&4294967295); //@line 665 "synthdata.cpp"
          var $42=HEAP32[(($mnemonic)>>2)]; //@line 665 "synthdata.cpp"
          var $43=$ph; //@line 665 "synthdata.cpp"
          var $mnemonic62=(($43)&4294967295); //@line 665 "synthdata.cpp"
          var $44=HEAP32[(($mnemonic62)>>2)]; //@line 665 "synthdata.cpp"
          var $cmp63=((($42))|0)==((($44))|0); //@line 665 "synthdata.cpp"
          var $conv64=((($cmp63))&1); //@line 665 "synthdata.cpp"
          var $cmp65=((($conv64))|0)==1; //@line 665 "synthdata.cpp"
          if ($cmp65) { __label__ = 27;; } else { __label__ = 28;; } //@line 665 "synthdata.cpp"
          if (__label__ == 27) {
  
            $retval=1; //@line 666 "synthdata.cpp"
            ; //@line 666 "synthdata.cpp"
          }
          else if (__label__ == 28) {
  
            var $45=$which; //@line 667 "synthdata.cpp"
            var $cmp68=((($45))|0)==0; //@line 667 "synthdata.cpp"
            if ($cmp68) { __label__ = 29;; } else { __label__ = 31;; } //@line 667 "synthdata.cpp"
            $land_lhs_true$$if_end75$42: do { 
              if (__label__ == 29) {
  
                var $46=$ph; //@line 667 "synthdata.cpp"
                var $type69=(($46+11)&4294967295); //@line 667 "synthdata.cpp"
                var $47=HEAPU8[($type69)]; //@line 667 "synthdata.cpp"
                var $conv70=((($47))&255); //@line 667 "synthdata.cpp"
                var $cmp71=((($conv70))|0)==2; //@line 667 "synthdata.cpp"
                if (!($cmp71)) { __label__ = 31;break $land_lhs_true$$if_end75$42; } //@line 667 "synthdata.cpp"
  
                var $48=$data; //@line 668 "synthdata.cpp"
                var $49=$ph; //@line 668 "synthdata.cpp"
                var $end_type=(($49+13)&4294967295); //@line 668 "synthdata.cpp"
                var $50=HEAPU8[($end_type)]; //@line 668 "synthdata.cpp"
                var $conv73=((($50))&255); //@line 668 "synthdata.cpp"
                var $cmp74=((($48))|0)==((($conv73))|0); //@line 668 "synthdata.cpp"
                $retval=$cmp74; //@line 668 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 668 "synthdata.cpp"
              }
            } while(0);
  
            var $51=$data; //@line 669 "synthdata.cpp"
            var $52=$ph; //@line 669 "synthdata.cpp"
            var $start_type=(($52+12)&4294967295); //@line 669 "synthdata.cpp"
            var $53=HEAPU8[($start_type)]; //@line 669 "synthdata.cpp"
            var $conv76=((($53))&255); //@line 669 "synthdata.cpp"
            var $cmp77=((($51))|0)==((($conv76))|0); //@line 669 "synthdata.cpp"
            $retval=$cmp77; //@line 669 "synthdata.cpp"
            ; //@line 669 "synthdata.cpp"
          }
        }
        else if (__label__ == 32) {
  
          var $54=$instn_addr; //@line 672 "synthdata.cpp"
          var $and79=($54) & 31; //@line 672 "synthdata.cpp"
          $data=$and79; //@line 672 "synthdata.cpp"
          var $55=$instn_addr; //@line 674 "synthdata.cpp"
          var $and80=($55) & 224; //@line 674 "synthdata.cpp"
          if ($and80 == 0) {
            __label__ = 33;;
          }
          else if ($and80 == 32) {
            __label__ = 34;;
          }
          else if ($and80 == 64) {
            __label__ = 35;;
          }
          else if ($and80 == 128) {
            __label__ = 36;;
          }
          else {
          __label__ = 66;;
          }
          
          if (__label__ == 66) {
  
            $retval=0; //@line 758 "synthdata.cpp"
            ; //@line 758 "synthdata.cpp"
          }
          else if (__label__ == 33) {
  
            var $56=$ph; //@line 678 "synthdata.cpp"
            var $type81=(($56+11)&4294967295); //@line 678 "synthdata.cpp"
            var $57=HEAPU8[($type81)]; //@line 678 "synthdata.cpp"
            var $conv82=((($57))&255); //@line 678 "synthdata.cpp"
            var $58=$data; //@line 678 "synthdata.cpp"
            var $cmp83=((($conv82))|0)==((($58))|0); //@line 678 "synthdata.cpp"
            $retval=$cmp83; //@line 678 "synthdata.cpp"
            ; //@line 678 "synthdata.cpp"
          }
          else if (__label__ == 34) {
  
            var $59=$ph; //@line 683 "synthdata.cpp"
            var $phflags=(($59+4)&4294967295); //@line 683 "synthdata.cpp"
            var $60=HEAPU32[(($phflags)>>2)]; //@line 683 "synthdata.cpp"
            var $shr85=($60) >>> 16; //@line 683 "synthdata.cpp"
            var $and86=($shr85) & 15; //@line 683 "synthdata.cpp"
            var $61=$data; //@line 683 "synthdata.cpp"
            var $cmp87=((($and86))|0)==((($61))|0); //@line 683 "synthdata.cpp"
            $retval=$cmp87; //@line 683 "synthdata.cpp"
            ; //@line 683 "synthdata.cpp"
          }
          else if (__label__ == 35) {
  
            var $62=$ph; //@line 688 "synthdata.cpp"
            var $phflags89=(($62+4)&4294967295); //@line 688 "synthdata.cpp"
            var $63=HEAP32[(($phflags89)>>2)]; //@line 688 "synthdata.cpp"
            var $64=$data; //@line 688 "synthdata.cpp"
            var $shl=1 << ($64); //@line 688 "synthdata.cpp"
            var $and90=($shl) & ($63); //@line 688 "synthdata.cpp"
            var $cmp91=((($and90))|0)!=0; //@line 688 "synthdata.cpp"
            $retval=$cmp91; //@line 688 "synthdata.cpp"
            ; //@line 688 "synthdata.cpp"
          }
          else if (__label__ == 36) {
  
            var $65=$data; //@line 692 "synthdata.cpp"
            if ($65 == 0) {
              __label__ = 37;;
            }
            else if ($65 == 1) {
              __label__ = 37;;
            }
            else if ($65 == 2) {
              __label__ = 37;;
            }
            else if ($65 == 3) {
              __label__ = 37;;
            }
            else if ($65 == 4) {
              __label__ = 37;;
            }
            else if ($65 == 5) {
              __label__ = 38;;
            }
            else if ($65 == 6) {
              __label__ = 41;;
            }
            else if ($65 == 7) {
              __label__ = 42;;
            }
            else if ($65 == 8) {
              __label__ = 43;;
            }
            else if ($65 == 9) {
              __label__ = 46;;
            }
            else if ($65 == 10) {
              __label__ = 51;;
            }
            else if ($65 == 11) {
              __label__ = 52;;
            }
            else if ($65 == 12) {
              __label__ = 56;;
            }
            else {
            __label__ = 60;;
            }
            
            $sw_bb169$$sw_bb93$$sw_bb94$$sw_bb101$$sw_bb105$$sw_bb109$$sw_bb120$$sw_bb134$$for_cond139$$sw_bb156$53: do { 
              if (__label__ == 37) {
  
                var $66=$tr_addr; //@line 699 "synthdata.cpp"
                var $67=$plist_addr; //@line 699 "synthdata.cpp"
                var $68=$data; //@line 699 "synthdata.cpp"
                var $call=__ZL15StressConditionP10TranslatorP12PHONEME_LISTii($66, $67, $68, 0); //@line 699 "synthdata.cpp"
                $retval=$call; //@line 699 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 699 "synthdata.cpp"
              }
              else if (__label__ == 38) {
  
                var $69=$ph; //@line 702 "synthdata.cpp"
                var $type95=(($69+11)&4294967295); //@line 702 "synthdata.cpp"
                var $70=HEAPU8[($type95)]; //@line 702 "synthdata.cpp"
                var $conv96=((($70))&255); //@line 702 "synthdata.cpp"
                var $cmp97=((($conv96))|0)==0; //@line 702 "synthdata.cpp"
                if ($cmp97) { __lastLabel__ = 38; __label__ = 40;; } else { __lastLabel__ = 38; __label__ = 39;; } //@line 702 "synthdata.cpp"
                if (__label__ == 39) {
  
                  var $71=$plist_this; //@line 702 "synthdata.cpp"
                  var $synthflags=(($71+4)&4294967295); //@line 702 "synthdata.cpp"
                  var $72=HEAPU16[(($synthflags)>>1)]; //@line 702 "synthdata.cpp"
                  var $conv98=((($72))&65535); //@line 702 "synthdata.cpp"
                  var $and99=($conv98) & 8192; //@line 702 "synthdata.cpp"
                  var $tobool100=((($and99))|0)!=0; //@line 702 "synthdata.cpp"
                  __lastLabel__ = 39; ; //@line 702 "synthdata.cpp"
                }
  
                var $73=__lastLabel__ == 38 ? 1 : ($tobool100);
                $retval=$73; //@line 702 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 702 "synthdata.cpp"
              }
              else if (__label__ == 41) {
  
                var $74=$plist_addr; //@line 705 "synthdata.cpp"
                var $sourceix102=(($74+6)&4294967295); //@line 705 "synthdata.cpp"
                var $75=HEAPU16[(($sourceix102)>>1)]; //@line 705 "synthdata.cpp"
                var $conv103=((($75))&65535); //@line 705 "synthdata.cpp"
                var $cmp104=((($conv103))|0)!=0; //@line 705 "synthdata.cpp"
                $retval=$cmp104; //@line 705 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 705 "synthdata.cpp"
              }
              else if (__label__ == 42) {
  
                var $76=$plist_addr; //@line 708 "synthdata.cpp"
                var $sourceix106=(($76+6)&4294967295); //@line 708 "synthdata.cpp"
                var $77=HEAPU16[(($sourceix106)>>1)]; //@line 708 "synthdata.cpp"
                var $conv107=((($77))&65535); //@line 708 "synthdata.cpp"
                var $cmp108=((($conv107))|0)==0; //@line 708 "synthdata.cpp"
                $retval=$cmp108; //@line 708 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 708 "synthdata.cpp"
              }
              else if (__label__ == 43) {
  
                var $78=$plist_addr; //@line 711 "synthdata.cpp"
                var $arrayidx110=(($78+24)&4294967295); //@line 711 "synthdata.cpp"
                var $sourceix111=(($arrayidx110+6)&4294967295); //@line 711 "synthdata.cpp"
                var $79=HEAP16[(($sourceix111)>>1)]; //@line 711 "synthdata.cpp"
                var $tobool112=(tempInt=(($79)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 711 "synthdata.cpp"
                if ($tobool112) { __lastLabel__ = 43; __label__ = 45;; } else { __lastLabel__ = 43; __label__ = 44;; } //@line 711 "synthdata.cpp"
                if (__label__ == 44) {
  
                  var $80=$plist_addr; //@line 711 "synthdata.cpp"
                  var $arrayidx114=(($80+24)&4294967295); //@line 711 "synthdata.cpp"
                  var $ph115=(($arrayidx114+8)&4294967295); //@line 711 "synthdata.cpp"
                  var $81=HEAP32[(($ph115)>>2)]; //@line 711 "synthdata.cpp"
                  var $type116=(($81+11)&4294967295); //@line 711 "synthdata.cpp"
                  var $82=HEAPU8[($type116)]; //@line 711 "synthdata.cpp"
                  var $conv117=((($82))&255); //@line 711 "synthdata.cpp"
                  var $cmp118=((($conv117))|0)==0; //@line 711 "synthdata.cpp"
                  __lastLabel__ = 44; ; //@line 711 "synthdata.cpp"
                }
  
                var $83=__lastLabel__ == 43 ? 1 : ($cmp118);
                $retval=$83; //@line 711 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 711 "synthdata.cpp"
              }
              else if (__label__ == 46) {
  
                var $84=$plist_addr; //@line 715 "synthdata.cpp"
                var $sourceix121=(($84+6)&4294967295); //@line 715 "synthdata.cpp"
                var $85=HEAPU16[(($sourceix121)>>1)]; //@line 715 "synthdata.cpp"
                var $conv122=((($85))&65535); //@line 715 "synthdata.cpp"
                var $cmp123=((($conv122))|0)!=0; //@line 715 "synthdata.cpp"
                if ($cmp123) { __label__ = 47;; } else { __label__ = 48;; } //@line 715 "synthdata.cpp"
                if (__label__ == 47) {
  
                  $retval=0; //@line 716 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 716 "synthdata.cpp"
                }
                else if (__label__ == 48) {
                  while(1) { 
  
                    var $86=$plist_addr; //@line 718 "synthdata.cpp"
                    var $incdec_ptr=(($86+-24)&4294967295); //@line 718 "synthdata.cpp"
                    $plist_addr=$incdec_ptr; //@line 718 "synthdata.cpp"
                    var $87=$plist_addr; //@line 719 "synthdata.cpp"
                    var $stresslevel=(($87+1)&4294967295); //@line 719 "synthdata.cpp"
                    var $88=HEAPU8[($stresslevel)]; //@line 719 "synthdata.cpp"
                    var $conv126=((($88))&255); //@line 719 "synthdata.cpp"
                    var $and127=($conv126) & 15; //@line 719 "synthdata.cpp"
                    var $cmp128=((($and127))|0) >= 4; //@line 719 "synthdata.cpp"
                    if ($cmp128) { __label__ = 49;break ; } //@line 719 "synthdata.cpp"
  
                    var $89=$plist_addr; //@line 722 "synthdata.cpp"
                    var $sourceix131=(($89+6)&4294967295); //@line 722 "synthdata.cpp"
                    var $90=HEAPU16[(($sourceix131)>>1)]; //@line 722 "synthdata.cpp"
                    var $conv132=((($90))&65535); //@line 722 "synthdata.cpp"
                    var $cmp133=((($conv132))|0)==0; //@line 722 "synthdata.cpp"
                    if ($cmp133) { __label__ = 48;continue ; } else { __label__ = 60;break $sw_bb169$$sw_bb93$$sw_bb94$$sw_bb101$$sw_bb105$$sw_bb109$$sw_bb120$$sw_bb134$$for_cond139$$sw_bb156$53; } //@line 722 "synthdata.cpp"
                  }
  
                  $retval=1; //@line 720 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 720 "synthdata.cpp"
                }
              }
              else if (__label__ == 51) {
  
                var $91=$ph; //@line 726 "synthdata.cpp"
                var $type135=(($91+11)&4294967295); //@line 726 "synthdata.cpp"
                var $92=HEAPU8[($type135)]; //@line 726 "synthdata.cpp"
                var $conv136=((($92))&255); //@line 726 "synthdata.cpp"
                var $cmp137=((($conv136))|0)!=2; //@line 726 "synthdata.cpp"
                $retval=$cmp137; //@line 726 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 726 "synthdata.cpp"
              }
              else if (__label__ == 52) {
                while(1) { 
  
                  var $93=$plist_addr; //@line 731 "synthdata.cpp"
                  var $incdec_ptr140=(($93+24)&4294967295); //@line 731 "synthdata.cpp"
                  $plist_addr=$incdec_ptr140; //@line 731 "synthdata.cpp"
                  var $94=$plist_addr; //@line 732 "synthdata.cpp"
                  var $phcode141=(($94)&4294967295); //@line 732 "synthdata.cpp"
                  var $95=HEAPU8[($phcode141)]; //@line 732 "synthdata.cpp"
                  var $idxprom142=((($95))&255); //@line 732 "synthdata.cpp"
                  var $arrayidx143=((_phoneme_tab+$idxprom142*4)&4294967295); //@line 732 "synthdata.cpp"
                  var $96=HEAP32[(($arrayidx143)>>2)]; //@line 732 "synthdata.cpp"
                  var $97=$plist_addr; //@line 732 "synthdata.cpp"
                  var $ph144=(($97+8)&4294967295); //@line 732 "synthdata.cpp"
                  HEAP32[(($ph144)>>2)]=$96; //@line 732 "synthdata.cpp"
                  var $98=$plist_addr; //@line 733 "synthdata.cpp"
                  var $sourceix145=(($98+6)&4294967295); //@line 733 "synthdata.cpp"
                  var $99=HEAPU16[(($sourceix145)>>1)]; //@line 733 "synthdata.cpp"
                  var $conv146=((($99))&65535); //@line 733 "synthdata.cpp"
                  var $cmp147=((($conv146))|0)!=0; //@line 733 "synthdata.cpp"
                  if ($cmp147) { __label__ = 53;break ; } //@line 733 "synthdata.cpp"
  
                  var $100=$plist_addr; //@line 735 "synthdata.cpp"
                  var $ph150=(($100+8)&4294967295); //@line 735 "synthdata.cpp"
                  var $101=HEAP32[(($ph150)>>2)]; //@line 735 "synthdata.cpp"
                  var $type151=(($101+11)&4294967295); //@line 735 "synthdata.cpp"
                  var $102=HEAPU8[($type151)]; //@line 735 "synthdata.cpp"
                  var $conv152=((($102))&255); //@line 735 "synthdata.cpp"
                  var $cmp153=((($conv152))|0)==2; //@line 735 "synthdata.cpp"
                  if ($cmp153) { __label__ = 55;break ; } else { __label__ = 52;continue ; } //@line 735 "synthdata.cpp"
                }
                if (__label__ == 53) {
  
                  $retval=1; //@line 734 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 734 "synthdata.cpp"
                }
                else if (__label__ == 55) {
  
                  $retval=0; //@line 736 "synthdata.cpp"
                  __label__ = 73;break $if_then$$if_else187$2; //@line 736 "synthdata.cpp"
                }
              }
              else if (__label__ == 56) {
  
                var $103=$ph; //@line 741 "synthdata.cpp"
                var $type157=(($103+11)&4294967295); //@line 741 "synthdata.cpp"
                var $104=HEAPU8[($type157)]; //@line 741 "synthdata.cpp"
                var $conv158=((($104))&255); //@line 741 "synthdata.cpp"
                var $cmp159=((($conv158))|0)==2; //@line 741 "synthdata.cpp"
                if ($cmp159) { __lastLabel__ = 56; __label__ = 59;; } else { __lastLabel__ = 56; __label__ = 57;; } //@line 741 "synthdata.cpp"
                $lor_end168$$lor_lhs_false160$80: do { 
                  if (__label__ == 57) {
  
                    var $105=$ph; //@line 741 "synthdata.cpp"
                    var $type161=(($105+11)&4294967295); //@line 741 "synthdata.cpp"
                    var $106=HEAPU8[($type161)]; //@line 741 "synthdata.cpp"
                    var $conv162=((($106))&255); //@line 741 "synthdata.cpp"
                    var $cmp163=((($conv162))|0)==3; //@line 741 "synthdata.cpp"
                    if ($cmp163) { __lastLabel__ = 57; __label__ = 59;break $lor_end168$$lor_lhs_false160$80; } else { __lastLabel__ = 57; ; } //@line 741 "synthdata.cpp"
  
                    var $107=$ph; //@line 741 "synthdata.cpp"
                    var $phflags165=(($107+4)&4294967295); //@line 741 "synthdata.cpp"
                    var $108=HEAP32[(($phflags165)>>2)]; //@line 741 "synthdata.cpp"
                    var $and166=($108) & 16; //@line 741 "synthdata.cpp"
                    var $tobool167=((($and166))|0)!=0; //@line 741 "synthdata.cpp"
                    __lastLabel__ = 58; ; //@line 741 "synthdata.cpp"
                  }
                } while(0);
  
                var $109=__lastLabel__ == 57 ? 1 : (__lastLabel__ == 56 ? 1 : ($tobool167));
                $retval=$109; //@line 741 "synthdata.cpp"
                __label__ = 73;break $if_then$$if_else187$2; //@line 741 "synthdata.cpp"
              }
            } while(0);
  
            $count=0; //@line 745 "synthdata.cpp"
            ; //@line 746 "synthdata.cpp"
            while(1) { 
  
              var $110=$plist_addr; //@line 748 "synthdata.cpp"
              var $ph171=(($110+8)&4294967295); //@line 748 "synthdata.cpp"
              var $111=HEAP32[(($ph171)>>2)]; //@line 748 "synthdata.cpp"
              var $type172=(($111+11)&4294967295); //@line 748 "synthdata.cpp"
              var $112=HEAPU8[($type172)]; //@line 748 "synthdata.cpp"
              var $conv173=((($112))&255); //@line 748 "synthdata.cpp"
              var $cmp174=((($conv173))|0)==2; //@line 748 "synthdata.cpp"
              if ($cmp174) { __label__ = 62;; } else { __label__ = 63;; } //@line 748 "synthdata.cpp"
              if (__label__ == 62) {
  
                var $113=$count; //@line 749 "synthdata.cpp"
                var $inc176=((($113)+1)&4294967295); //@line 749 "synthdata.cpp"
                $count=$inc176; //@line 749 "synthdata.cpp"
                ; //@line 749 "synthdata.cpp"
              }
  
              var $114=$plist_addr; //@line 750 "synthdata.cpp"
              var $sourceix178=(($114+6)&4294967295); //@line 750 "synthdata.cpp"
              var $115=HEAPU16[(($sourceix178)>>1)]; //@line 750 "synthdata.cpp"
              var $conv179=((($115))&65535); //@line 750 "synthdata.cpp"
              var $cmp180=((($conv179))|0)!=0; //@line 750 "synthdata.cpp"
              if ($cmp180) { __label__ = 65;break ; } //@line 750 "synthdata.cpp"
  
              var $116=$plist_addr; //@line 752 "synthdata.cpp"
              var $incdec_ptr183=(($116+-24)&4294967295); //@line 752 "synthdata.cpp"
              $plist_addr=$incdec_ptr183; //@line 752 "synthdata.cpp"
              __label__ = 61;continue ; //@line 753 "synthdata.cpp"
            }
  
            var $117=$count; //@line 754 "synthdata.cpp"
            var $cmp185=((($117))|0)==1; //@line 754 "synthdata.cpp"
            $retval=$cmp185; //@line 754 "synthdata.cpp"
            ; //@line 754 "synthdata.cpp"
          }
        }
      }
      else if (__label__ == 67) {
  
        var $cmp188=((($3))|0)==15; //@line 761 "synthdata.cpp"
        if ($cmp188) { __label__ = 68;; } else { __label__ = 72;; } //@line 761 "synthdata.cpp"
        $if_then189$$if_end201$93: do { 
          if (__label__ == 68) {
  
            var $118=$data; //@line 764 "synthdata.cpp"
            if ($118 == 1) {
              __label__ = 69;;
            }
            else if ($118 == 2) {
              __label__ = 70;;
            }
            else if ($118 == 3) {
              __label__ = 71;;
            }
            else {
            __label__ = 72;break $if_then189$$if_end201$93;
            }
            
            if (__label__ == 69) {
  
              var $119=$control_addr; //@line 767 "synthdata.cpp"
              var $and191=($119) & 1; //@line 767 "synthdata.cpp"
              var $tobool192=((($and191))|0)!=0; //@line 767 "synthdata.cpp"
              $retval=$tobool192; //@line 767 "synthdata.cpp"
              __label__ = 73;break $if_then$$if_else187$2; //@line 767 "synthdata.cpp"
            }
            else if (__label__ == 70) {
  
              var $120=HEAP32[((_voice)>>2)]; //@line 769 "synthdata.cpp"
              var $klattv=(($120+112)&4294967295); //@line 769 "synthdata.cpp"
              var $arrayidx194=(($klattv)&4294967295); //@line 769 "synthdata.cpp"
              var $121=HEAP32[(($arrayidx194)>>2)]; //@line 769 "synthdata.cpp"
              var $cmp195=((($121))|0)!=0; //@line 769 "synthdata.cpp"
              $retval=$cmp195; //@line 769 "synthdata.cpp"
              __label__ = 73;break $if_then$$if_else187$2; //@line 769 "synthdata.cpp"
            }
            else if (__label__ == 71) {
  
              var $122=HEAP8[(((_mbrola_name)&4294967295))]; //@line 771 "synthdata.cpp"
              var $conv197=(tempInt=(($122)),(tempInt>=128?tempInt-256:tempInt)); //@line 771 "synthdata.cpp"
              var $cmp198=((($conv197))|0)!=0; //@line 771 "synthdata.cpp"
              $retval=$cmp198; //@line 771 "synthdata.cpp"
              __label__ = 73;break $if_then$$if_else187$2; //@line 771 "synthdata.cpp"
            }
          }
        } while(0);
  
        $retval=0; //@line 774 "synthdata.cpp"
        ; //@line 774 "synthdata.cpp"
      }
    } while(0);
  
    var $123=$retval; //@line 775 "synthdata.cpp"
    ;
    return $123; //@line 775 "synthdata.cpp"
    return null;
  }
  

  function __ZL13NumInstnWordsPt($prog) {
    ;
    var __label__;
  
    var $retval;
    var $prog_addr;
    var $instn;
    var $instn2;
    var $instn_type;
    $prog_addr=$prog;
    var $0=$prog_addr; //@line 814 "synthdata.cpp"
    var $1=HEAPU16[(($0)>>1)]; //@line 814 "synthdata.cpp"
    var $conv=((($1))&65535); //@line 814 "synthdata.cpp"
    $instn=$conv; //@line 814 "synthdata.cpp"
    var $2=$instn; //@line 815 "synthdata.cpp"
    var $shr=($2) >> 12; //@line 815 "synthdata.cpp"
    $instn_type=$shr; //@line 815 "synthdata.cpp"
    var $3=$instn_type; //@line 816 "synthdata.cpp"
    var $cmp=((($3))|0) < 11; //@line 816 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 816 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $4=$instn_type; //@line 817 "synthdata.cpp"
      var $arrayidx=((__ZZL13NumInstnWordsPtE7n_words+$4)&4294967295); //@line 817 "synthdata.cpp"
      var $5=HEAP8[($arrayidx)]; //@line 817 "synthdata.cpp"
      var $conv1=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 817 "synthdata.cpp"
      $retval=$conv1; //@line 817 "synthdata.cpp"
      ; //@line 817 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $6=$prog_addr; //@line 820 "synthdata.cpp"
      var $arrayidx2=(($6+4)&4294967295); //@line 820 "synthdata.cpp"
      var $7=HEAPU16[(($arrayidx2)>>1)]; //@line 820 "synthdata.cpp"
      var $conv3=((($7))&65535); //@line 820 "synthdata.cpp"
      $instn2=$conv3; //@line 820 "synthdata.cpp"
      var $8=$instn2; //@line 821 "synthdata.cpp"
      var $shr4=($8) >> 12; //@line 821 "synthdata.cpp"
      var $cmp5=((($shr4))|0)==15; //@line 821 "synthdata.cpp"
      if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 821 "synthdata.cpp"
      if (__label__ == 3) {
  
        $retval=4; //@line 824 "synthdata.cpp"
        ; //@line 824 "synthdata.cpp"
      }
      else if (__label__ == 4) {
  
        var $9=$instn2; //@line 826 "synthdata.cpp"
        var $cmp8=((($9))|0)==2; //@line 826 "synthdata.cpp"
        if ($cmp8) { __label__ = 5;; } else { __label__ = 6;; } //@line 826 "synthdata.cpp"
        if (__label__ == 5) {
  
          $retval=3; //@line 828 "synthdata.cpp"
          ; //@line 828 "synthdata.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=2; //@line 830 "synthdata.cpp"
          ; //@line 830 "synthdata.cpp"
        }
      }
    }
  
    var $10=$retval; //@line 831 "synthdata.cpp"
    ;
    return $10; //@line 831 "synthdata.cpp"
    return null;
  }
  

  function __ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti($plist, $phdata, $p_prog, $instn_type) {
    ;
    var __label__;
  
    var $plist_addr;
    var $phdata_addr;
    var $p_prog_addr;
    var $instn_type_addr;
    var $prog;
    var $voweltype;
    var $x;
    $plist_addr=$plist;
    $phdata_addr=$phdata;
    $p_prog_addr=$p_prog;
    $instn_type_addr=$instn_type;
    var $0=$instn_type_addr; //@line 784 "synthdata.cpp"
    var $cmp=((($0))|0)==2; //@line 784 "synthdata.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 784 "synthdata.cpp"
    if (__label__ == 1) {
  
      var $1=$phdata_addr; //@line 786 "synthdata.cpp"
      var $pd_control=(($1)&4294967295); //@line 786 "synthdata.cpp"
      var $2=HEAP32[(($pd_control)>>2)]; //@line 786 "synthdata.cpp"
      var $or=($2) | 2; //@line 786 "synthdata.cpp"
      HEAP32[(($pd_control)>>2)]=$or; //@line 786 "synthdata.cpp"
      var $3=$plist_addr; //@line 787 "synthdata.cpp"
      var $arrayidx=(($3+24)&4294967295); //@line 787 "synthdata.cpp"
      var $ph=(($arrayidx+8)&4294967295); //@line 787 "synthdata.cpp"
      var $4=HEAP32[(($ph)>>2)]; //@line 787 "synthdata.cpp"
      var $start_type=(($4+12)&4294967295); //@line 787 "synthdata.cpp"
      var $5=HEAPU8[($start_type)]; //@line 787 "synthdata.cpp"
      var $conv=((($5))&255); //@line 787 "synthdata.cpp"
      $voweltype=$conv; //@line 787 "synthdata.cpp"
      ; //@line 788 "synthdata.cpp"
    }
    else if (__label__ == 2) {
  
      var $6=$plist_addr; //@line 791 "synthdata.cpp"
      var $arrayidx1=(($6+-24)&4294967295); //@line 791 "synthdata.cpp"
      var $ph2=(($arrayidx1+8)&4294967295); //@line 791 "synthdata.cpp"
      var $7=HEAP32[(($ph2)>>2)]; //@line 791 "synthdata.cpp"
      var $end_type=(($7+13)&4294967295); //@line 791 "synthdata.cpp"
      var $8=HEAPU8[($end_type)]; //@line 791 "synthdata.cpp"
      var $conv3=((($8))&255); //@line 791 "synthdata.cpp"
      $voweltype=$conv3; //@line 791 "synthdata.cpp"
      ;
    }
  
    var $9=$voweltype; //@line 794 "synthdata.cpp"
    var $sub=((($9)-28)&4294967295); //@line 794 "synthdata.cpp"
    $voweltype=$sub; //@line 794 "synthdata.cpp"
    var $10=$voweltype; //@line 795 "synthdata.cpp"
    var $cmp4=((($10))|0) >= 0; //@line 795 "synthdata.cpp"
    var $11=$voweltype; //@line 795 "synthdata.cpp"
    var $cmp5=((($11))|0) < 6; //@line 795 "synthdata.cpp"
    var $or_cond=($cmp4) & ($cmp5); //@line 795 "synthdata.cpp"
    if ($or_cond) { __label__ = 4;; } else { __label__ = 5;; } //@line 795 "synthdata.cpp"
    if (__label__ == 4) {
  
      var $12=$p_prog_addr; //@line 797 "synthdata.cpp"
      var $13=HEAP32[(($12)>>2)]; //@line 797 "synthdata.cpp"
      var $14=$voweltype; //@line 797 "synthdata.cpp"
      var $mul=((($14)*2)&4294967295); //@line 797 "synthdata.cpp"
      var $add_ptr=(($13+2*$mul)&4294967295); //@line 797 "synthdata.cpp"
      $prog=$add_ptr; //@line 797 "synthdata.cpp"
      var $15=$prog; //@line 798 "synthdata.cpp"
      var $arrayidx7=(($15+2)&4294967295); //@line 798 "synthdata.cpp"
      var $16=HEAPU16[(($arrayidx7)>>1)]; //@line 798 "synthdata.cpp"
      var $conv8=((($16))&65535); //@line 798 "synthdata.cpp"
      var $and=($conv8) & 15; //@line 798 "synthdata.cpp"
      var $shl=((($and)*65536)&4294967295); //@line 798 "synthdata.cpp"
      var $17=$prog; //@line 798 "synthdata.cpp"
      var $arrayidx9=(($17+4)&4294967295); //@line 798 "synthdata.cpp"
      var $18=HEAPU16[(($arrayidx9)>>1)]; //@line 798 "synthdata.cpp"
      var $conv10=((($18))&65535); //@line 798 "synthdata.cpp"
      var $add=((($shl)+($conv10))&4294967295); //@line 798 "synthdata.cpp"
      var $mul11=((($add)*4)&4294967295); //@line 798 "synthdata.cpp"
      var $19=$instn_type_addr; //@line 798 "synthdata.cpp"
      var $20=$phdata_addr; //@line 798 "synthdata.cpp"
      var $sound_addr=(($20+68)&4294967295); //@line 798 "synthdata.cpp"
      var $arrayidx12=(($sound_addr+$19*4)&4294967295); //@line 798 "synthdata.cpp"
      HEAP32[(($arrayidx12)>>2)]=$mul11; //@line 798 "synthdata.cpp"
      var $21=$prog; //@line 799 "synthdata.cpp"
      var $arrayidx13=(($21+2)&4294967295); //@line 799 "synthdata.cpp"
      var $22=HEAPU16[(($arrayidx13)>>1)]; //@line 799 "synthdata.cpp"
      var $conv14=((($22))&65535); //@line 799 "synthdata.cpp"
      var $shr=($conv14) >> 4; //@line 799 "synthdata.cpp"
      var $and15=($shr) & 255; //@line 799 "synthdata.cpp"
      var $conv16=((($and15)) & 255); //@line 799 "synthdata.cpp"
      $x=$conv16; //@line 799 "synthdata.cpp"
      var $23=$x; //@line 800 "synthdata.cpp"
      var $conv17=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 800 "synthdata.cpp"
      var $24=$instn_type_addr; //@line 800 "synthdata.cpp"
      var $25=$phdata_addr; //@line 800 "synthdata.cpp"
      var $sound_param=(($25+88)&4294967295); //@line 800 "synthdata.cpp"
      var $arrayidx18=(($sound_param+$24*4)&4294967295); //@line 800 "synthdata.cpp"
      HEAP32[(($arrayidx18)>>2)]=$conv17; //@line 800 "synthdata.cpp"
      ; //@line 801 "synthdata.cpp"
    }
  
    var $26=$p_prog_addr; //@line 803 "synthdata.cpp"
    var $27=HEAP32[(($26)>>2)]; //@line 803 "synthdata.cpp"
    var $add_ptr20=(($27+24)&4294967295); //@line 803 "synthdata.cpp"
    HEAP32[(($26)>>2)]=$add_ptr20; //@line 803 "synthdata.cpp"
    ;
    return; //@line 804 "synthdata.cpp"
    return;
  }
  

  function __Z17InterpretPhoneme2iP12PHONEME_DATA($phcode, $phdata) {
    var __stackBase__  = STACKTOP; STACKTOP += 96; _memset(__stackBase__, 0, 96);
    var __label__;
  
    var $phcode_addr;
    var $phdata_addr;
    var $ix;
    var $plist=__stackBase__;
    $phcode_addr=$phcode;
    $phdata_addr=$phdata;
    var $arraydecay=(($plist)&4294967295); //@line 1102 "synthdata.cpp"
    var $0=$arraydecay; //@line 1102 "synthdata.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $0;
    $stop$ = $dest$ + 96;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1102 "synthdata.cpp"
    $ix=0; //@line 1104 "synthdata.cpp"
    ; //@line 1104 "synthdata.cpp"
    while(1) { 
  
      var $1=$ix; //@line 1106 "synthdata.cpp"
      var $arrayidx=(($plist+$1*24)&4294967295); //@line 1106 "synthdata.cpp"
      var $phcode1=(($arrayidx)&4294967295); //@line 1106 "synthdata.cpp"
      HEAP8[($phcode1)]=9; //@line 1106 "synthdata.cpp"
      var $2=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 1107 "synthdata.cpp"
      var $3=$ix; //@line 1107 "synthdata.cpp"
      var $arrayidx2=(($plist+$3*24)&4294967295); //@line 1107 "synthdata.cpp"
      var $ph=(($arrayidx2+8)&4294967295); //@line 1107 "synthdata.cpp"
      HEAP32[(($ph)>>2)]=$2; //@line 1107 "synthdata.cpp"
      var $4=$ix; //@line 1104 "synthdata.cpp"
      var $inc=((($4)+1)&4294967295); //@line 1104 "synthdata.cpp"
      $ix=$inc; //@line 1104 "synthdata.cpp"
      var $cmp=((($inc))|0) < 4; //@line 1104 "synthdata.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1104 "synthdata.cpp"
    }
  
    var $5=$phcode_addr; //@line 1110 "synthdata.cpp"
    var $conv=((($5)) & 255); //@line 1110 "synthdata.cpp"
    var $arrayidx3=(($plist+24)&4294967295); //@line 1110 "synthdata.cpp"
    var $phcode4=(($arrayidx3)&4294967295); //@line 1110 "synthdata.cpp"
    HEAP8[($phcode4)]=$conv; //@line 1110 "synthdata.cpp"
    var $6=$phcode_addr; //@line 1111 "synthdata.cpp"
    var $arrayidx5=((_phoneme_tab+$6*4)&4294967295); //@line 1111 "synthdata.cpp"
    var $7=HEAP32[(($arrayidx5)>>2)]; //@line 1111 "synthdata.cpp"
    var $arrayidx6=(($plist+24)&4294967295); //@line 1111 "synthdata.cpp"
    var $ph7=(($arrayidx6+8)&4294967295); //@line 1111 "synthdata.cpp"
    HEAP32[(($ph7)>>2)]=$7; //@line 1111 "synthdata.cpp"
    var $arrayidx8=(($plist+48)&4294967295); //@line 1112 "synthdata.cpp"
    var $sourceix=(($arrayidx8+6)&4294967295); //@line 1112 "synthdata.cpp"
    HEAP16[(($sourceix)>>1)]=1; //@line 1112 "synthdata.cpp"
    var $arrayidx9=(($plist+24)&4294967295); //@line 1114 "synthdata.cpp"
    var $8=$phdata_addr; //@line 1114 "synthdata.cpp"
    __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $arrayidx9, $8); //@line 1114 "synthdata.cpp"
    STACKTOP = __stackBase__;
    return; //@line 1115 "synthdata.cpp"
    return;
  }
  

  function __Z12WordToStringj($word) {
    ;
    var __label__;
  
    var $word_addr;
    var $ix;
    $word_addr=$word;
    $ix=0; //@line 85 "synthesize.cpp"
    ; //@line 85 "synthesize.cpp"
    while(1) { 
  
      var $0=$word_addr; //@line 86 "synthesize.cpp"
      var $1=$ix; //@line 86 "synthesize.cpp"
      var $mul=((($1)*8)&4294967295); //@line 86 "synthesize.cpp"
      var $shr=($0) >>> ((($mul))>>>0); //@line 86 "synthesize.cpp"
      var $conv=((($shr)) & 255); //@line 86 "synthesize.cpp"
      var $2=$ix; //@line 86 "synthesize.cpp"
      var $arrayidx=((__ZZ12WordToStringjE3buf+$2)&4294967295); //@line 86 "synthesize.cpp"
      HEAP8[($arrayidx)]=$conv; //@line 86 "synthesize.cpp"
      var $3=$ix; //@line 85 "synthesize.cpp"
      var $inc=((($3)+1)&4294967295); //@line 85 "synthesize.cpp"
      $ix=$inc; //@line 85 "synthesize.cpp"
      var $cmp=((($inc))|0) < 3; //@line 85 "synthesize.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 85 "synthesize.cpp"
    }
  
    HEAP8[(((__ZZ12WordToStringjE3buf+4)&4294967295))]=0; //@line 87 "synthesize.cpp"
    ;
    return ((__ZZ12WordToStringjE3buf)&4294967295); //@line 88 "synthesize.cpp"
    return null;
  }
  

  function __Z14SynthesizeInitv() {
    ;
    var __label__;
  
    HEAP32[((__ZL14last_pitch_cmd)>>2)]=0; //@line 95 "synthesize.cpp"
    HEAP32[((__ZL12last_amp_cmd)>>2)]=0; //@line 96 "synthesize.cpp"
    HEAP32[((__ZL10last_frame)>>2)]=0; //@line 97 "synthesize.cpp"
    HEAP32[((__ZL15syllable_centre)>>2)]=-1; //@line 98 "synthesize.cpp"
    ;
    return; //@line 104 "synthesize.cpp"
    return;
  }
  

  function __Z11PauseLengthii($pause, $control) {
    ;
    var __label__;
  
    var $pause_addr;
    var $control_addr;
    var $len;
    $pause_addr=$pause;
    $control_addr=$control;
    var $0=$control_addr; //@line 193 "synthesize.cpp"
    var $cmp=((($0))|0)==0; //@line 193 "synthesize.cpp"
    var $1=$pause_addr; //@line 195 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 193 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $cmp1=((($1))|0) >= 200; //@line 195 "synthesize.cpp"
      var $2=$pause_addr; //@line 196 "synthesize.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 195 "synthesize.cpp"
      if (__label__ == 2) {
  
        var $3=HEAP32[((((_speed+4)&4294967295))>>2)]; //@line 196 "synthesize.cpp"
        var $mul=((($3)*($2))&4294967295); //@line 196 "synthesize.cpp"
        var $div=((((($mul))|0)/256)|0); //@line 196 "synthesize.cpp"
        $len=$div; //@line 196 "synthesize.cpp"
        ; //@line 196 "synthesize.cpp"
      }
      else if (__label__ == 3) {
  
        var $4=HEAP32[((((_speed)&4294967295))>>2)]; //@line 198 "synthesize.cpp"
        var $mul3=((($4)*($2))&4294967295); //@line 198 "synthesize.cpp"
        var $div4=((((($mul3))|0)/256)|0); //@line 198 "synthesize.cpp"
        $len=$div4; //@line 198 "synthesize.cpp"
        ;
      }
    }
    else if (__label__ == 4) {
  
      var $5=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 201 "synthesize.cpp"
      var $mul6=((($5)*($1))&4294967295); //@line 201 "synthesize.cpp"
      var $div7=((((($mul6))|0)/256)|0); //@line 201 "synthesize.cpp"
      $len=$div7; //@line 201 "synthesize.cpp"
      ;
    }
  
    var $6=$len; //@line 203 "synthesize.cpp"
    var $7=HEAP32[((((_speed+8)&4294967295))>>2)]; //@line 203 "synthesize.cpp"
    var $cmp9=((($6))|0) < ((($7))|0); //@line 203 "synthesize.cpp"
    if ($cmp9) { __label__ = 6;; } else { __label__ = 7;; } //@line 203 "synthesize.cpp"
    if (__label__ == 6) {
  
      var $8=HEAP32[((((_speed+8)&4294967295))>>2)]; //@line 205 "synthesize.cpp"
      $len=$8; //@line 205 "synthesize.cpp"
      ; //@line 206 "synthesize.cpp"
    }
  
    var $9=$len; //@line 207 "synthesize.cpp"
    ;
    return $9; //@line 207 "synthesize.cpp"
    return null;
  }
  

  function __Z9DoSample3P12PHONEME_DATAii($phdata, $length_mod, $amp) {
    ;
    var __label__;
  
    var $phdata_addr;
    var $length_mod_addr;
    var $amp_addr;
    var $amp2;
    var $len;
    $phdata_addr=$phdata;
    $length_mod_addr=$length_mod;
    $amp_addr=$amp;
    __ZL8EndPitchi(1); //@line 405 "synthesize.cpp"
    var $0=$amp_addr; //@line 407 "synthesize.cpp"
    var $cmp=((($0))|0)==-1; //@line 407 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 407 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $1=$amp_addr; //@line 410 "synthesize.cpp"
      $amp2=$1; //@line 410 "synthesize.cpp"
      ; //@line 411 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$phdata_addr; //@line 414 "synthesize.cpp"
      var $sound_param=(($2+88)&4294967295); //@line 414 "synthesize.cpp"
      var $arrayidx=(($sound_param+4)&4294967295); //@line 414 "synthesize.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 414 "synthesize.cpp"
      $amp2=$3; //@line 414 "synthesize.cpp"
      var $4=$amp2; //@line 415 "synthesize.cpp"
      var $cmp1=((($4))|0)==0; //@line 415 "synthesize.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 415 "synthesize.cpp"
      if (__label__ == 3) {
  
        $amp2=100; //@line 416 "synthesize.cpp"
        ; //@line 416 "synthesize.cpp"
      }
  
      var $5=$amp2; //@line 417 "synthesize.cpp"
      var $mul=((($5)*32)&4294967295); //@line 417 "synthesize.cpp"
      var $div=((((($mul))|0)/100)|0); //@line 417 "synthesize.cpp"
      $amp2=$div; //@line 417 "synthesize.cpp"
      ;
    }
  
    HEAP32[((_seq_len_adjust)>>2)]=0; //@line 420 "synthesize.cpp"
    var $6=$phdata_addr; //@line 422 "synthesize.cpp"
    var $sound_addr=(($6+68)&4294967295); //@line 422 "synthesize.cpp"
    var $arrayidx4=(($sound_addr+4)&4294967295); //@line 422 "synthesize.cpp"
    var $7=HEAP32[(($arrayidx4)>>2)]; //@line 422 "synthesize.cpp"
    var $cmp5=((($7))|0)==0; //@line 422 "synthesize.cpp"
    if ($cmp5) { __label__ = 6;; } else { __label__ = 7;; } //@line 422 "synthesize.cpp"
    if (__label__ == 6) {
  
      $len=0; //@line 424 "synthesize.cpp"
      ; //@line 425 "synthesize.cpp"
    }
    else if (__label__ == 7) {
  
      var $8=$phdata_addr; //@line 428 "synthesize.cpp"
      var $sound_addr8=(($8+68)&4294967295); //@line 428 "synthesize.cpp"
      var $arrayidx9=(($sound_addr8+4)&4294967295); //@line 428 "synthesize.cpp"
      var $9=HEAP32[(($arrayidx9)>>2)]; //@line 428 "synthesize.cpp"
      var $10=$phdata_addr; //@line 428 "synthesize.cpp"
      var $pd_param=(($10+4)&4294967295); //@line 428 "synthesize.cpp"
      var $arrayidx10=(($pd_param+40)&4294967295); //@line 428 "synthesize.cpp"
      var $11=HEAP32[(($arrayidx10)>>2)]; //@line 428 "synthesize.cpp"
      var $mul11=((($11)*2)&4294967295); //@line 428 "synthesize.cpp"
      var $12=$phdata_addr; //@line 428 "synthesize.cpp"
      var $pd_control=(($12)&4294967295); //@line 428 "synthesize.cpp"
      var $13=HEAP32[(($pd_control)>>2)]; //@line 428 "synthesize.cpp"
      var $14=$length_mod_addr; //@line 428 "synthesize.cpp"
      var $15=$amp2; //@line 428 "synthesize.cpp"
      var $call=__ZL9DoSample2iiiiii($9, 2, $mul11, $13, $14, $15); //@line 428 "synthesize.cpp"
      $len=$call; //@line 428 "synthesize.cpp"
      ;
    }
  
    HEAP32[((__ZL10last_frame)>>2)]=0; //@line 430 "synthesize.cpp"
    var $16=$len; //@line 431 "synthesize.cpp"
    ;
    return $16; //@line 431 "synthesize.cpp"
    return null;
  }
  

  function __ZL8EndPitchi($voice_break) {
    ;
    var __label__;
  
    var $voice_break_addr;
    $voice_break_addr=$voice_break;
    var $0=HEAP32[((__ZL12pitch_length)>>2)]; //@line 123 "synthesize.cpp"
    var $cmp=((($0))|0) > 0; //@line 123 "synthesize.cpp"
    var $1=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 123 "synthesize.cpp"
    var $cmp1=((($1))|0) >= 0; //@line 123 "synthesize.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 123 "synthesize.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 4;; } //@line 123 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 125 "synthesize.cpp"
      var $arrayidx=((_wcmdq+$2*16)&4294967295); //@line 125 "synthesize.cpp"
      var $arrayidx2=(($arrayidx+4)&4294967295); //@line 125 "synthesize.cpp"
      var $3=HEAP32[(($arrayidx2)>>2)]; //@line 125 "synthesize.cpp"
      var $cmp3=((($3))|0)==0; //@line 125 "synthesize.cpp"
      if ($cmp3) { __label__ = 2;; } else { __label__ = 3;; } //@line 125 "synthesize.cpp"
      if (__label__ == 2) {
  
        var $4=HEAP32[((__ZL12pitch_length)>>2)]; //@line 126 "synthesize.cpp"
        var $5=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 126 "synthesize.cpp"
        var $arrayidx5=((_wcmdq+$5*16)&4294967295); //@line 126 "synthesize.cpp"
        var $arrayidx6=(($arrayidx5+4)&4294967295); //@line 126 "synthesize.cpp"
        HEAP32[(($arrayidx6)>>2)]=$4; //@line 126 "synthesize.cpp"
        ; //@line 126 "synthesize.cpp"
      }
  
      HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 127 "synthesize.cpp"
      ; //@line 128 "synthesize.cpp"
    }
  
    var $6=$voice_break_addr; //@line 130 "synthesize.cpp"
    var $tobool=((($6))|0)!=0; //@line 130 "synthesize.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 130 "synthesize.cpp"
    if (__label__ == 5) {
  
      HEAP32[((__ZL10last_wcmdq)>>2)]=-1; //@line 132 "synthesize.cpp"
      HEAP32[((__ZL10last_frame)>>2)]=0; //@line 133 "synthesize.cpp"
      var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 134 "synthesize.cpp"
      HEAP32[((__ZL12syllable_end)>>2)]=$7; //@line 134 "synthesize.cpp"
      __ZL11SmoothSpectv(); //@line 135 "synthesize.cpp"
      HEAP32[((__ZL15syllable_centre)>>2)]=-1; //@line 136 "synthesize.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = _vowel_transition;
      $stop$ = $dest$ + 16;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 137 "synthesize.cpp"
      ; //@line 138 "synthesize.cpp"
    }
  
    ;
    return; //@line 139 "synthesize.cpp"
    return;
  }
  

  function __ZL9DoSample2iiiiii($index, $which, $std_length, $control, $length_mod, $amp) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $index_addr;
    var $which_addr;
    var $std_length_addr;
    var $control_addr;
    var $length_mod_addr;
    var $amp_addr;
    var $length;
    var $wav_length;
    var $wav_scale;
    var $min_length;
    var $x;
    var $len4;
    var $q;
    var $p;
    $index_addr=$index;
    $which_addr=$which;
    $std_length_addr=$std_length;
    $control_addr=$control;
    $length_mod_addr=$length_mod;
    $amp_addr=$amp;
    var $0=$index_addr; //@line 254 "synthesize.cpp"
    var $and=($0) & 8388607; //@line 254 "synthesize.cpp"
    $index_addr=$and; //@line 254 "synthesize.cpp"
    var $1=$index_addr; //@line 255 "synthesize.cpp"
    var $2=HEAP32[((_wavefile_data)>>2)]; //@line 255 "synthesize.cpp"
    var $arrayidx=(($2+$1)&4294967295); //@line 255 "synthesize.cpp"
    $p=$arrayidx; //@line 255 "synthesize.cpp"
    var $3=$p; //@line 256 "synthesize.cpp"
    var $arrayidx1=(($3+2)&4294967295); //@line 256 "synthesize.cpp"
    var $4=HEAPU8[($arrayidx1)]; //@line 256 "synthesize.cpp"
    var $conv=((($4))&255); //@line 256 "synthesize.cpp"
    $wav_scale=$conv; //@line 256 "synthesize.cpp"
    var $5=$p; //@line 257 "synthesize.cpp"
    var $arrayidx2=(($5+1)&4294967295); //@line 257 "synthesize.cpp"
    var $6=HEAPU8[($arrayidx2)]; //@line 257 "synthesize.cpp"
    var $conv3=((($6))&255); //@line 257 "synthesize.cpp"
    var $mul=((($conv3)*256)&4294967295); //@line 257 "synthesize.cpp"
    $wav_length=$mul; //@line 257 "synthesize.cpp"
    var $7=$p; //@line 258 "synthesize.cpp"
    var $arrayidx4=(($7)&4294967295); //@line 258 "synthesize.cpp"
    var $8=HEAPU8[($arrayidx4)]; //@line 258 "synthesize.cpp"
    var $conv5=((($8))&255); //@line 258 "synthesize.cpp"
    var $9=$wav_length; //@line 258 "synthesize.cpp"
    var $add=((($9)+($conv5))&4294967295); //@line 258 "synthesize.cpp"
    $wav_length=$add; //@line 258 "synthesize.cpp"
    var $10=$wav_length; //@line 260 "synthesize.cpp"
    var $cmp=((($10))|0)==0; //@line 260 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 260 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 261 "synthesize.cpp"
      ; //@line 261 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=HEAP32[((((_speed+24)&4294967295))>>2)]; //@line 263 "synthesize.cpp"
      $min_length=$11; //@line 263 "synthesize.cpp"
      var $12=$wav_scale; //@line 265 "synthesize.cpp"
      var $cmp6=((($12))|0)==0; //@line 265 "synthesize.cpp"
      if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 265 "synthesize.cpp"
      if (__label__ == 3) {
  
        var $13=$min_length; //@line 266 "synthesize.cpp"
        var $mul8=((($13)*2)&4294967295); //@line 266 "synthesize.cpp"
        $min_length=$mul8; //@line 266 "synthesize.cpp"
        ; //@line 266 "synthesize.cpp"
      }
  
      var $14=$std_length_addr; //@line 275 "synthesize.cpp"
      var $cmp10=((($14))|0) > 0; //@line 275 "synthesize.cpp"
      if ($cmp10) { __label__ = 5;; } else { __label__ = 9;; } //@line 275 "synthesize.cpp"
      $if_then11$$if_else22$8: do { 
        if (__label__ == 5) {
  
          var $15=$std_length_addr; //@line 277 "synthesize.cpp"
          var $16=HEAP32[((_samplerate)>>2)]; //@line 277 "synthesize.cpp"
          var $mul12=((($16)*($15))&4294967295); //@line 277 "synthesize.cpp"
          var $div=((((($mul12))|0)/1000)|0); //@line 277 "synthesize.cpp"
          $std_length_addr=$div; //@line 277 "synthesize.cpp"
          var $17=$wav_scale; //@line 278 "synthesize.cpp"
          var $cmp13=((($17))|0)==0; //@line 278 "synthesize.cpp"
          if ($cmp13) { __label__ = 6;; } else { __label__ = 7;; } //@line 278 "synthesize.cpp"
          if (__label__ == 6) {
  
            var $18=$std_length_addr; //@line 279 "synthesize.cpp"
            var $mul15=((($18)*2)&4294967295); //@line 279 "synthesize.cpp"
            $std_length_addr=$mul15; //@line 279 "synthesize.cpp"
            ; //@line 279 "synthesize.cpp"
          }
  
          var $19=$min_length; //@line 281 "synthesize.cpp"
          var $20=$std_length_addr; //@line 281 "synthesize.cpp"
          var $mul17=((($20)*($19))&4294967295); //@line 281 "synthesize.cpp"
          var $21=$wav_length; //@line 281 "synthesize.cpp"
          var $div18=((((($mul17))|0)/((($21))|0))|0); //@line 281 "synthesize.cpp"
          $x=$div18; //@line 281 "synthesize.cpp"
          var $22=$x; //@line 282 "synthesize.cpp"
          var $23=$min_length; //@line 282 "synthesize.cpp"
          var $cmp19=((($22))|0) > ((($23))|0); //@line 282 "synthesize.cpp"
          if (!($cmp19)) { __label__ = 10;break $if_then11$$if_else22$8; } //@line 282 "synthesize.cpp"
  
          var $24=$x; //@line 283 "synthesize.cpp"
          $min_length=$24; //@line 283 "synthesize.cpp"
          ; //@line 283 "synthesize.cpp"
        }
        else if (__label__ == 9) {
  
          var $25=$wav_length; //@line 288 "synthesize.cpp"
          $std_length_addr=$25; //@line 288 "synthesize.cpp"
          ;
        }
      } while(0);
  
      var $26=$length_mod_addr; //@line 291 "synthesize.cpp"
      var $cmp24=((($26))|0) > 0; //@line 291 "synthesize.cpp"
      if ($cmp24) { __label__ = 11;; } else { __label__ = 12;; } //@line 291 "synthesize.cpp"
      if (__label__ == 11) {
  
        var $27=$std_length_addr; //@line 293 "synthesize.cpp"
        var $28=$length_mod_addr; //@line 293 "synthesize.cpp"
        var $mul26=((($28)*($27))&4294967295); //@line 293 "synthesize.cpp"
        var $div27=((((($mul26))|0)/256)|0); //@line 293 "synthesize.cpp"
        $std_length_addr=$div27; //@line 293 "synthesize.cpp"
        ; //@line 294 "synthesize.cpp"
      }
  
      var $29=$std_length_addr; //@line 296 "synthesize.cpp"
      var $30=HEAP32[((((_speed+12)&4294967295))>>2)]; //@line 296 "synthesize.cpp"
      var $mul29=((($30)*($29))&4294967295); //@line 296 "synthesize.cpp"
      var $div30=((((($mul29))|0)/256)|0); //@line 296 "synthesize.cpp"
      $length=$div30; //@line 296 "synthesize.cpp"
      var $31=$control_addr; //@line 298 "synthesize.cpp"
      var $and31=($31) & 4; //@line 298 "synthesize.cpp"
      var $tobool=((($and31))|0)!=0; //@line 298 "synthesize.cpp"
      if ($tobool) { __label__ = 13;; } else { __label__ = 15;; } //@line 298 "synthesize.cpp"
      $if_then32$$if_end37$19: do { 
        if (__label__ == 13) {
  
          var $32=$length; //@line 302 "synthesize.cpp"
          var $33=$std_length_addr; //@line 302 "synthesize.cpp"
          var $cmp33=((($32))|0) > ((($33))|0); //@line 302 "synthesize.cpp"
          if (!($cmp33)) { __label__ = 15;break $if_then32$$if_end37$19; } //@line 302 "synthesize.cpp"
  
          var $34=$std_length_addr; //@line 305 "synthesize.cpp"
          $length=$34; //@line 305 "synthesize.cpp"
          ; //@line 306 "synthesize.cpp"
        }
      } while(0);
  
      var $35=$length; //@line 314 "synthesize.cpp"
      var $36=$min_length; //@line 314 "synthesize.cpp"
      var $cmp38=((($35))|0) < ((($36))|0); //@line 314 "synthesize.cpp"
      if ($cmp38) { __label__ = 16;; } else { __label__ = 17;; } //@line 314 "synthesize.cpp"
      if (__label__ == 16) {
  
        var $37=$min_length; //@line 315 "synthesize.cpp"
        $length=$37; //@line 315 "synthesize.cpp"
        ; //@line 315 "synthesize.cpp"
      }
  
      var $38=$wav_scale; //@line 318 "synthesize.cpp"
      var $cmp41=((($38))|0)==0; //@line 318 "synthesize.cpp"
      if ($cmp41) { __label__ = 18;; } else { __label__ = 19;; } //@line 318 "synthesize.cpp"
      if (__label__ == 18) {
  
        var $39=$length; //@line 321 "synthesize.cpp"
        var $div43=((((($39))|0)/2)|0); //@line 321 "synthesize.cpp"
        $length=$div43; //@line 321 "synthesize.cpp"
        var $40=$wav_length; //@line 322 "synthesize.cpp"
        var $div44=((((($40))|0)/2)|0); //@line 322 "synthesize.cpp"
        $wav_length=$div44; //@line 322 "synthesize.cpp"
        ; //@line 323 "synthesize.cpp"
      }
  
      var $41=$amp_addr; //@line 325 "synthesize.cpp"
      var $cmp46=((($41))|0) < 0; //@line 325 "synthesize.cpp"
      if ($cmp46) { __label__ = 20;; } else { __label__ = 21;; } //@line 325 "synthesize.cpp"
      if (__label__ == 20) {
  
        var $42=$length; //@line 326 "synthesize.cpp"
        $retval=$42; //@line 326 "synthesize.cpp"
        ; //@line 326 "synthesize.cpp"
      }
      else if (__label__ == 21) {
  
        var $43=$wav_length; //@line 328 "synthesize.cpp"
        var $div49=((((($43))|0)/4)|0); //@line 328 "synthesize.cpp"
        $len4=$div49; //@line 328 "synthesize.cpp"
        var $44=$index_addr; //@line 330 "synthesize.cpp"
        var $add50=((($44)+4)&4294967295); //@line 330 "synthesize.cpp"
        $index_addr=$add50; //@line 330 "synthesize.cpp"
        var $45=$which_addr; //@line 332 "synthesize.cpp"
        var $and51=($45) & 256; //@line 332 "synthesize.cpp"
        var $tobool52=((($and51))|0)!=0; //@line 332 "synthesize.cpp"
        if ($tobool52) { __label__ = 22;; } else { __label__ = 23;; } //@line 332 "synthesize.cpp"
        if (__label__ == 22) {
  
          var $46=HEAP32[((_wcmdq_tail)>>2)]; //@line 335 "synthesize.cpp"
          HEAP32[((__ZL10last_wcmdq)>>2)]=$46; //@line 335 "synthesize.cpp"
          var $47=HEAP32[((_wcmdq_tail)>>2)]; //@line 336 "synthesize.cpp"
          var $arrayidx54=((_wcmdq+$47*16)&4294967295); //@line 336 "synthesize.cpp"
          var $arraydecay=(($arrayidx54)&4294967295); //@line 336 "synthesize.cpp"
          $q=$arraydecay; //@line 336 "synthesize.cpp"
          var $48=$q; //@line 337 "synthesize.cpp"
          var $arrayidx55=(($48)&4294967295); //@line 337 "synthesize.cpp"
          HEAP32[(($arrayidx55)>>2)]=7; //@line 337 "synthesize.cpp"
          var $49=$length; //@line 338 "synthesize.cpp"
          var $50=$wav_length; //@line 338 "synthesize.cpp"
          var $shl=($50) << 16; //@line 338 "synthesize.cpp"
          var $or=($shl) | ($49); //@line 338 "synthesize.cpp"
          var $51=$q; //@line 338 "synthesize.cpp"
          var $arrayidx56=(($51+4)&4294967295); //@line 338 "synthesize.cpp"
          HEAP32[(($arrayidx56)>>2)]=$or; //@line 338 "synthesize.cpp"
          var $52=$index_addr; //@line 339 "synthesize.cpp"
          var $53=HEAP32[((_wavefile_data)>>2)]; //@line 339 "synthesize.cpp"
          var $arrayidx57=(($53+$52)&4294967295); //@line 339 "synthesize.cpp"
          var $54=($arrayidx57); //@line 339 "synthesize.cpp"
          var $55=$q; //@line 339 "synthesize.cpp"
          var $arrayidx58=(($55+8)&4294967295); //@line 339 "synthesize.cpp"
          HEAP32[(($arrayidx58)>>2)]=$54; //@line 339 "synthesize.cpp"
          var $56=$wav_scale; //@line 340 "synthesize.cpp"
          var $57=$amp_addr; //@line 340 "synthesize.cpp"
          var $shl59=((($57)*256)&4294967295); //@line 340 "synthesize.cpp"
          var $add60=((($shl59)+($56))&4294967295); //@line 340 "synthesize.cpp"
          var $58=$q; //@line 340 "synthesize.cpp"
          var $arrayidx61=(($58+12)&4294967295); //@line 340 "synthesize.cpp"
          HEAP32[(($arrayidx61)>>2)]=$add60; //@line 340 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 341 "synthesize.cpp"
          var $59=$length; //@line 342 "synthesize.cpp"
          $retval=$59; //@line 342 "synthesize.cpp"
          ; //@line 342 "synthesize.cpp"
        }
        else if (__label__ == 23) {
  
          var $60=$length; //@line 345 "synthesize.cpp"
          var $61=$wav_length; //@line 345 "synthesize.cpp"
          var $cmp63=((($60))|0) > ((($61))|0); //@line 345 "synthesize.cpp"
          if ($cmp63) { __label__ = 24;; } else { __label__ = 25;; } //@line 345 "synthesize.cpp"
          if (__label__ == 24) {
  
            var $62=$len4; //@line 347 "synthesize.cpp"
            var $mul65=((($62)*3)&4294967295); //@line 347 "synthesize.cpp"
            $x=$mul65; //@line 347 "synthesize.cpp"
            var $63=$x; //@line 348 "synthesize.cpp"
            var $64=$length; //@line 348 "synthesize.cpp"
            var $sub=((($64)-($63))&4294967295); //@line 348 "synthesize.cpp"
            $length=$sub; //@line 348 "synthesize.cpp"
            ; //@line 349 "synthesize.cpp"
          }
          else if (__label__ == 25) {
  
            var $65=$length; //@line 352 "synthesize.cpp"
            $x=$65; //@line 352 "synthesize.cpp"
            $length=0; //@line 353 "synthesize.cpp"
            ;
          }
  
          var $66=HEAP32[((_wcmdq_tail)>>2)]; //@line 356 "synthesize.cpp"
          HEAP32[((__ZL10last_wcmdq)>>2)]=$66; //@line 356 "synthesize.cpp"
          var $67=HEAP32[((_wcmdq_tail)>>2)]; //@line 357 "synthesize.cpp"
          var $arrayidx68=((_wcmdq+$67*16)&4294967295); //@line 357 "synthesize.cpp"
          var $arraydecay69=(($arrayidx68)&4294967295); //@line 357 "synthesize.cpp"
          $q=$arraydecay69; //@line 357 "synthesize.cpp"
          var $68=$q; //@line 358 "synthesize.cpp"
          var $arrayidx70=(($68)&4294967295); //@line 358 "synthesize.cpp"
          HEAP32[(($arrayidx70)>>2)]=6; //@line 358 "synthesize.cpp"
          var $69=$x; //@line 359 "synthesize.cpp"
          var $70=$q; //@line 359 "synthesize.cpp"
          var $arrayidx71=(($70+4)&4294967295); //@line 359 "synthesize.cpp"
          HEAP32[(($arrayidx71)>>2)]=$69; //@line 359 "synthesize.cpp"
          var $71=$index_addr; //@line 360 "synthesize.cpp"
          var $72=HEAP32[((_wavefile_data)>>2)]; //@line 360 "synthesize.cpp"
          var $arrayidx72=(($72+$71)&4294967295); //@line 360 "synthesize.cpp"
          var $73=($arrayidx72); //@line 360 "synthesize.cpp"
          var $74=$q; //@line 360 "synthesize.cpp"
          var $arrayidx73=(($74+8)&4294967295); //@line 360 "synthesize.cpp"
          HEAP32[(($arrayidx73)>>2)]=$73; //@line 360 "synthesize.cpp"
          var $75=$wav_scale; //@line 361 "synthesize.cpp"
          var $76=$amp_addr; //@line 361 "synthesize.cpp"
          var $shl74=((($76)*256)&4294967295); //@line 361 "synthesize.cpp"
          var $add75=((($shl74)+($75))&4294967295); //@line 361 "synthesize.cpp"
          var $77=$q; //@line 361 "synthesize.cpp"
          var $arrayidx76=(($77+12)&4294967295); //@line 361 "synthesize.cpp"
          HEAP32[(($arrayidx76)>>2)]=$add75; //@line 361 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 362 "synthesize.cpp"
          var $78=$length; //@line 365 "synthesize.cpp"
          var $79=$len4; //@line 365 "synthesize.cpp"
          var $mul771=((($79)*3)&4294967295); //@line 365 "synthesize.cpp"
          var $cmp782=((($78))|0) > ((($mul771))|0); //@line 365 "synthesize.cpp"
          if ($cmp782) { __lastLabel__ = 26; __label__ = 27;; } else { __lastLabel__ = 26; __label__ = 30;; } //@line 365 "synthesize.cpp"
          $while_body$$while_end$39: do { 
            if (__label__ == 27) {
              while(1) { 
  
                var $80=$len4; //@line 367 "synthesize.cpp"
                $x=$80; //@line 367 "synthesize.cpp"
                var $81=$wav_scale; //@line 368 "synthesize.cpp"
                var $cmp79=((($81))|0)==0; //@line 368 "synthesize.cpp"
                if ($cmp79) { __label__ = 28;; } else { __label__ = 29;; } //@line 368 "synthesize.cpp"
                if (__label__ == 28) {
  
                  var $82=$x; //@line 369 "synthesize.cpp"
                  var $mul81=((($82)*2)&4294967295); //@line 369 "synthesize.cpp"
                  $x=$mul81; //@line 369 "synthesize.cpp"
                  ; //@line 369 "synthesize.cpp"
                }
  
                var $83=HEAP32[((_wcmdq_tail)>>2)]; //@line 371 "synthesize.cpp"
                HEAP32[((__ZL10last_wcmdq)>>2)]=$83; //@line 371 "synthesize.cpp"
                var $84=HEAP32[((_wcmdq_tail)>>2)]; //@line 372 "synthesize.cpp"
                var $arrayidx83=((_wcmdq+$84*16)&4294967295); //@line 372 "synthesize.cpp"
                var $arraydecay84=(($arrayidx83)&4294967295); //@line 372 "synthesize.cpp"
                $q=$arraydecay84; //@line 372 "synthesize.cpp"
                var $85=$q; //@line 373 "synthesize.cpp"
                var $arrayidx85=(($85)&4294967295); //@line 373 "synthesize.cpp"
                HEAP32[(($arrayidx85)>>2)]=6; //@line 373 "synthesize.cpp"
                var $86=$len4; //@line 374 "synthesize.cpp"
                var $mul86=((($86)*2)&4294967295); //@line 374 "synthesize.cpp"
                var $87=$q; //@line 374 "synthesize.cpp"
                var $arrayidx87=(($87+4)&4294967295); //@line 374 "synthesize.cpp"
                HEAP32[(($arrayidx87)>>2)]=$mul86; //@line 374 "synthesize.cpp"
                var $88=$index_addr; //@line 375 "synthesize.cpp"
                var $89=$x; //@line 375 "synthesize.cpp"
                var $add88=((($89)+($88))&4294967295); //@line 375 "synthesize.cpp"
                var $90=HEAP32[((_wavefile_data)>>2)]; //@line 375 "synthesize.cpp"
                var $arrayidx89=(($90+$add88)&4294967295); //@line 375 "synthesize.cpp"
                var $91=($arrayidx89); //@line 375 "synthesize.cpp"
                var $92=$q; //@line 375 "synthesize.cpp"
                var $arrayidx90=(($92+8)&4294967295); //@line 375 "synthesize.cpp"
                HEAP32[(($arrayidx90)>>2)]=$91; //@line 375 "synthesize.cpp"
                var $93=$wav_scale; //@line 376 "synthesize.cpp"
                var $94=$amp_addr; //@line 376 "synthesize.cpp"
                var $shl91=((($94)*256)&4294967295); //@line 376 "synthesize.cpp"
                var $add92=((($shl91)+($93))&4294967295); //@line 376 "synthesize.cpp"
                var $95=$q; //@line 376 "synthesize.cpp"
                var $arrayidx93=(($95+12)&4294967295); //@line 376 "synthesize.cpp"
                HEAP32[(($arrayidx93)>>2)]=$add92; //@line 376 "synthesize.cpp"
                __Z8WcmdqIncv(); //@line 377 "synthesize.cpp"
                var $96=$len4; //@line 379 "synthesize.cpp"
                var $mul94=((($96)*2)&4294967295); //@line 379 "synthesize.cpp"
                var $97=$length; //@line 379 "synthesize.cpp"
                var $sub95=((($97)-($mul94))&4294967295); //@line 379 "synthesize.cpp"
                $length=$sub95; //@line 379 "synthesize.cpp"
                var $98=$length; //@line 365 "synthesize.cpp"
                var $99=$len4; //@line 365 "synthesize.cpp"
                var $mul77=((($99)*3)&4294967295); //@line 365 "synthesize.cpp"
                var $cmp78=((($98))|0) > ((($mul77))|0); //@line 365 "synthesize.cpp"
                if ($cmp78) { __lastLabel__ = 29; __label__ = 27;continue ; } else { __lastLabel__ = 29; __label__ = 30;break $while_body$$while_end$39; } //@line 365 "synthesize.cpp"
              }
            }
          } while(0);
  
          var $100=__lastLabel__ == 29 ? $98 : ($78); //@line 382 "synthesize.cpp"
          var $cmp96=((($100))|0) > 0; //@line 382 "synthesize.cpp"
          if ($cmp96) { __label__ = 31;; } else { __label__ = 34;; } //@line 382 "synthesize.cpp"
          if (__label__ == 31) {
  
            var $101=$wav_length; //@line 384 "synthesize.cpp"
            var $102=$length; //@line 384 "synthesize.cpp"
            var $sub98=((($101)-($102))&4294967295); //@line 384 "synthesize.cpp"
            $x=$sub98; //@line 384 "synthesize.cpp"
            var $103=$wav_scale; //@line 385 "synthesize.cpp"
            var $cmp99=((($103))|0)==0; //@line 385 "synthesize.cpp"
            if ($cmp99) { __label__ = 32;; } else { __label__ = 33;; } //@line 385 "synthesize.cpp"
            if (__label__ == 32) {
  
              var $104=$x; //@line 386 "synthesize.cpp"
              var $mul101=((($104)*2)&4294967295); //@line 386 "synthesize.cpp"
              $x=$mul101; //@line 386 "synthesize.cpp"
              ; //@line 386 "synthesize.cpp"
            }
  
            var $105=HEAP32[((_wcmdq_tail)>>2)]; //@line 387 "synthesize.cpp"
            HEAP32[((__ZL10last_wcmdq)>>2)]=$105; //@line 387 "synthesize.cpp"
            var $106=HEAP32[((_wcmdq_tail)>>2)]; //@line 388 "synthesize.cpp"
            var $arrayidx103=((_wcmdq+$106*16)&4294967295); //@line 388 "synthesize.cpp"
            var $arraydecay104=(($arrayidx103)&4294967295); //@line 388 "synthesize.cpp"
            $q=$arraydecay104; //@line 388 "synthesize.cpp"
            var $107=$q; //@line 389 "synthesize.cpp"
            var $arrayidx105=(($107)&4294967295); //@line 389 "synthesize.cpp"
            HEAP32[(($arrayidx105)>>2)]=6; //@line 389 "synthesize.cpp"
            var $108=$length; //@line 390 "synthesize.cpp"
            var $109=$q; //@line 390 "synthesize.cpp"
            var $arrayidx106=(($109+4)&4294967295); //@line 390 "synthesize.cpp"
            HEAP32[(($arrayidx106)>>2)]=$108; //@line 390 "synthesize.cpp"
            var $110=$index_addr; //@line 391 "synthesize.cpp"
            var $111=$x; //@line 391 "synthesize.cpp"
            var $add107=((($111)+($110))&4294967295); //@line 391 "synthesize.cpp"
            var $112=HEAP32[((_wavefile_data)>>2)]; //@line 391 "synthesize.cpp"
            var $arrayidx108=(($112+$add107)&4294967295); //@line 391 "synthesize.cpp"
            var $113=($arrayidx108); //@line 391 "synthesize.cpp"
            var $114=$q; //@line 391 "synthesize.cpp"
            var $arrayidx109=(($114+8)&4294967295); //@line 391 "synthesize.cpp"
            HEAP32[(($arrayidx109)>>2)]=$113; //@line 391 "synthesize.cpp"
            var $115=$wav_scale; //@line 392 "synthesize.cpp"
            var $116=$amp_addr; //@line 392 "synthesize.cpp"
            var $shl110=((($116)*256)&4294967295); //@line 392 "synthesize.cpp"
            var $add111=((($shl110)+($115))&4294967295); //@line 392 "synthesize.cpp"
            var $117=$q; //@line 392 "synthesize.cpp"
            var $arrayidx112=(($117+12)&4294967295); //@line 392 "synthesize.cpp"
            HEAP32[(($arrayidx112)>>2)]=$add111; //@line 392 "synthesize.cpp"
            __Z8WcmdqIncv(); //@line 393 "synthesize.cpp"
            ; //@line 394 "synthesize.cpp"
          }
  
          var $118=$length; //@line 396 "synthesize.cpp"
          $retval=$118; //@line 396 "synthesize.cpp"
          ; //@line 396 "synthesize.cpp"
        }
      }
    }
  
    var $119=$retval; //@line 397 "synthesize.cpp"
    ;
    return $119; //@line 397 "synthesize.cpp"
    return null;
  }
  

  function __Z18FormantTransition2P10frameref_tRijjP11PHONEME_TABi($seq, $n_frames, $data1, $data2, $other_ph, $which) {
    ;
    var __label__;
  
    var $retval;
    var $seq_addr;
    var $n_frames_addr;
    var $data1_addr;
    var $data2_addr;
    var $other_ph_addr;
    var $which_addr;
    var $ix;
    var $formant;
    var $next_rms;
    var $len;
    var $rms;
    var $f1;
    var $f2;
    var $f2_min;
    var $f2_max;
    var $f3_adj;
    var $f3_amp;
    var $flags;
    var $vcolour;
    var $fr;
    var $x;
    $seq_addr=$seq;
    $n_frames_addr=$n_frames;
    $data1_addr=$data1;
    $data2_addr=$data2;
    $other_ph_addr=$other_ph;
    $which_addr=$which;
    $fr=0; //@line 640 "synthesize.cpp"
    var $0=$n_frames_addr; //@line 642 "synthesize.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 642 "synthesize.cpp"
    var $cmp=((($1))|0) < 2; //@line 642 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 642 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 643 "synthesize.cpp"
      ; //@line 643 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$data1_addr; //@line 645 "synthesize.cpp"
      var $and=($2) & 63; //@line 645 "synthesize.cpp"
      var $mul=((($and)*2)&4294967295); //@line 645 "synthesize.cpp"
      $len=$mul; //@line 645 "synthesize.cpp"
      var $3=$data1_addr; //@line 646 "synthesize.cpp"
      var $shr=($3) >>> 6; //@line 646 "synthesize.cpp"
      var $and1=($shr) & 63; //@line 646 "synthesize.cpp"
      $rms=$and1; //@line 646 "synthesize.cpp"
      var $4=$data1_addr; //@line 647 "synthesize.cpp"
      var $shr2=($4) >>> 12; //@line 647 "synthesize.cpp"
      $flags=$shr2; //@line 647 "synthesize.cpp"
      var $5=$data2_addr; //@line 649 "synthesize.cpp"
      var $and3=($5) & 63; //@line 649 "synthesize.cpp"
      var $mul4=((($and3)*50)&4294967295); //@line 649 "synthesize.cpp"
      $f2=$mul4; //@line 649 "synthesize.cpp"
      var $6=$data2_addr; //@line 650 "synthesize.cpp"
      var $shr5=($6) >>> 6; //@line 650 "synthesize.cpp"
      var $and6=($shr5) & 31; //@line 650 "synthesize.cpp"
      var $sub=((($and6)-15)&4294967295); //@line 650 "synthesize.cpp"
      var $mul7=((($sub)*50)&4294967295); //@line 650 "synthesize.cpp"
      $f2_min=$mul7; //@line 650 "synthesize.cpp"
      var $7=$data2_addr; //@line 651 "synthesize.cpp"
      var $shr8=($7) >>> 11; //@line 651 "synthesize.cpp"
      var $and9=($shr8) & 31; //@line 651 "synthesize.cpp"
      var $sub10=((($and9)-15)&4294967295); //@line 651 "synthesize.cpp"
      var $mul11=((($sub10)*50)&4294967295); //@line 651 "synthesize.cpp"
      $f2_max=$mul11; //@line 651 "synthesize.cpp"
      var $8=$data2_addr; //@line 652 "synthesize.cpp"
      var $shr12=($8) >>> 16; //@line 652 "synthesize.cpp"
      var $and13=($shr12) & 31; //@line 652 "synthesize.cpp"
      var $sub14=((($and13)-15)&4294967295); //@line 652 "synthesize.cpp"
      var $mul15=((($sub14)*50)&4294967295); //@line 652 "synthesize.cpp"
      $f3_adj=$mul15; //@line 652 "synthesize.cpp"
      var $9=$data2_addr; //@line 653 "synthesize.cpp"
      var $shr16=($9) >>> 21; //@line 653 "synthesize.cpp"
      var $and17=($shr16) & 31; //@line 653 "synthesize.cpp"
      var $mul18=((($and17)*8)&4294967295); //@line 653 "synthesize.cpp"
      $f3_amp=$mul18; //@line 653 "synthesize.cpp"
      var $10=$data2_addr; //@line 654 "synthesize.cpp"
      var $shr19=($10) >>> 26; //@line 654 "synthesize.cpp"
      var $and20=($shr19) & 7; //@line 654 "synthesize.cpp"
      $f1=$and20; //@line 654 "synthesize.cpp"
      var $11=$data2_addr; //@line 655 "synthesize.cpp"
      var $shr21=($11) >>> 29; //@line 655 "synthesize.cpp"
      $vcolour=$shr21; //@line 655 "synthesize.cpp"
      var $12=$other_ph_addr; //@line 660 "synthesize.cpp"
      var $cmp22=((($12))|0)!=0; //@line 660 "synthesize.cpp"
      if ($cmp22) { __label__ = 3;; } else { __label__ = 5;; } //@line 660 "synthesize.cpp"
      $land_lhs_true$$if_end25$5: do { 
        if (__label__ == 3) {
  
          var $13=$other_ph_addr; //@line 660 "synthesize.cpp"
          var $mnemonic=(($13)&4294967295); //@line 660 "synthesize.cpp"
          var $14=HEAP32[(($mnemonic)>>2)]; //@line 660 "synthesize.cpp"
          var $cmp23=((($14))|0)==63; //@line 660 "synthesize.cpp"
          if (!($cmp23)) { __label__ = 5;break $land_lhs_true$$if_end25$5; } //@line 660 "synthesize.cpp"
  
          var $15=$flags; //@line 661 "synthesize.cpp"
          var $or=($15) | 8; //@line 661 "synthesize.cpp"
          $flags=$or; //@line 661 "synthesize.cpp"
          ; //@line 661 "synthesize.cpp"
        }
      } while(0);
  
      var $16=$which_addr; //@line 663 "synthesize.cpp"
      var $cmp26=((($16))|0)==1; //@line 663 "synthesize.cpp"
      if ($cmp26) { __label__ = 6;; } else { __label__ = 20;; } //@line 663 "synthesize.cpp"
      $if_then27$$if_else85$9: do { 
        if (__label__ == 6) {
  
          var $17=$seq_addr; //@line 666 "synthesize.cpp"
          var $arrayidx=(($17)&4294967295); //@line 666 "synthesize.cpp"
          var $frame=(($arrayidx+4)&4294967295); //@line 666 "synthesize.cpp"
          var $18=HEAP32[(($frame)>>2)]; //@line 666 "synthesize.cpp"
          var $call=__ZL9CopyFrameP7frame_ti($18, 0); //@line 666 "synthesize.cpp"
          $fr=$call; //@line 666 "synthesize.cpp"
          var $19=$fr; //@line 667 "synthesize.cpp"
          var $20=$seq_addr; //@line 667 "synthesize.cpp"
          var $arrayidx28=(($20)&4294967295); //@line 667 "synthesize.cpp"
          var $frame29=(($arrayidx28+4)&4294967295); //@line 667 "synthesize.cpp"
          HEAP32[(($frame29)>>2)]=$19; //@line 667 "synthesize.cpp"
          var $21=$seq_addr; //@line 668 "synthesize.cpp"
          var $arrayidx30=(($21)&4294967295); //@line 668 "synthesize.cpp"
          var $length=(($arrayidx30)&4294967295); //@line 668 "synthesize.cpp"
          HEAP16[(($length)>>1)]=50; //@line 668 "synthesize.cpp"
          var $22=$len; //@line 669 "synthesize.cpp"
          var $cmp31=((($22))|0) > 0; //@line 669 "synthesize.cpp"
          if ($cmp31) { __label__ = 7;; } else { __label__ = 8;; } //@line 669 "synthesize.cpp"
          if (__label__ == 7) {
  
            var $23=$len; //@line 670 "synthesize.cpp"
            var $conv=((($23)) & 65535); //@line 670 "synthesize.cpp"
            var $24=$seq_addr; //@line 670 "synthesize.cpp"
            var $arrayidx33=(($24)&4294967295); //@line 670 "synthesize.cpp"
            var $length34=(($arrayidx33)&4294967295); //@line 670 "synthesize.cpp"
            HEAP16[(($length34)>>1)]=$conv; //@line 670 "synthesize.cpp"
            ; //@line 670 "synthesize.cpp"
          }
  
          var $25=$seq_addr; //@line 671 "synthesize.cpp"
          var $arrayidx36=(($25)&4294967295); //@line 671 "synthesize.cpp"
          var $frflags=(($arrayidx36+2)&4294967295); //@line 671 "synthesize.cpp"
          var $26=HEAP16[(($frflags)>>1)]; //@line 671 "synthesize.cpp"
          var $conv37=(tempInt=(($26)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 671 "synthesize.cpp"
          var $or38=($conv37) | 16384; //@line 671 "synthesize.cpp"
          var $conv39=((($or38)) & 65535); //@line 671 "synthesize.cpp"
          HEAP16[(($frflags)>>1)]=$conv39; //@line 671 "synthesize.cpp"
          var $27=$fr; //@line 672 "synthesize.cpp"
          var $frflags40=(($27)&4294967295); //@line 672 "synthesize.cpp"
          var $28=HEAP16[(($frflags40)>>1)]; //@line 672 "synthesize.cpp"
          var $conv41=(tempInt=(($28)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 672 "synthesize.cpp"
          var $or42=($conv41) | 16384; //@line 672 "synthesize.cpp"
          var $conv43=((($or42)) & 65535); //@line 672 "synthesize.cpp"
          HEAP16[(($frflags40)>>1)]=$conv43; //@line 672 "synthesize.cpp"
          var $29=$seq_addr; //@line 674 "synthesize.cpp"
          var $arrayidx44=(($29+8)&4294967295); //@line 674 "synthesize.cpp"
          var $frame45=(($arrayidx44+4)&4294967295); //@line 674 "synthesize.cpp"
          var $30=HEAP32[(($frame45)>>2)]; //@line 674 "synthesize.cpp"
          var $rms46=(($30+17)&4294967295); //@line 674 "synthesize.cpp"
          var $31=HEAPU8[($rms46)]; //@line 674 "synthesize.cpp"
          var $conv47=((($31))&255); //@line 674 "synthesize.cpp"
          $next_rms=$conv47; //@line 674 "synthesize.cpp"
          var $32=HEAP32[((_voice)>>2)]; //@line 676 "synthesize.cpp"
          var $klattv=(($32+112)&4294967295); //@line 676 "synthesize.cpp"
          var $arrayidx48=(($klattv)&4294967295); //@line 676 "synthesize.cpp"
          var $33=HEAP32[(($arrayidx48)>>2)]; //@line 676 "synthesize.cpp"
          var $tobool=((($33))|0)!=0; //@line 676 "synthesize.cpp"
          if ($tobool) { __label__ = 9;; } else { __label__ = 10;; } //@line 676 "synthesize.cpp"
          if (__label__ == 9) {
  
            var $34=$seq_addr; //@line 679 "synthesize.cpp"
            var $arrayidx50=(($34+8)&4294967295); //@line 679 "synthesize.cpp"
            var $frame51=(($arrayidx50+4)&4294967295); //@line 679 "synthesize.cpp"
            var $35=HEAP32[(($frame51)>>2)]; //@line 679 "synthesize.cpp"
            var $klattp=(($35+39)&4294967295); //@line 679 "synthesize.cpp"
            var $arrayidx52=(($klattp)&4294967295); //@line 679 "synthesize.cpp"
            var $36=HEAPU8[($arrayidx52)]; //@line 679 "synthesize.cpp"
            var $conv53=((($36))&255); //@line 679 "synthesize.cpp"
            var $sub54=((($conv53)-4)&4294967295); //@line 679 "synthesize.cpp"
            var $conv55=((($sub54)) & 255); //@line 679 "synthesize.cpp"
            var $37=$fr; //@line 679 "synthesize.cpp"
            var $klattp56=(($37+39)&4294967295); //@line 679 "synthesize.cpp"
            var $arrayidx57=(($klattp56)&4294967295); //@line 679 "synthesize.cpp"
            HEAP8[($arrayidx57)]=$conv55; //@line 679 "synthesize.cpp"
            ; //@line 680 "synthesize.cpp"
          }
  
          var $38=$f2; //@line 681 "synthesize.cpp"
          var $cmp59=((($38))|0)!=0; //@line 681 "synthesize.cpp"
          if ($cmp59) { __label__ = 11;; } else { __label__ = 15;; } //@line 681 "synthesize.cpp"
          $if_then60$$if_else$17: do { 
            if (__label__ == 11) {
  
              var $39=$rms; //@line 683 "synthesize.cpp"
              var $and61=($39) & 32; //@line 683 "synthesize.cpp"
              var $tobool62=((($and61))|0)!=0; //@line 683 "synthesize.cpp"
              if ($tobool62) { __label__ = 12;; } else { __label__ = 13;; } //@line 683 "synthesize.cpp"
              if (__label__ == 12) {
  
                var $40=$fr; //@line 685 "synthesize.cpp"
                var $41=$next_rms; //@line 685 "synthesize.cpp"
                var $42=$rms; //@line 685 "synthesize.cpp"
                var $and64=($42) & 31; //@line 685 "synthesize.cpp"
                var $mul65=((($and64)*($41))&4294967295); //@line 685 "synthesize.cpp"
                var $div=((((($mul65))|0)/30)|0); //@line 685 "synthesize.cpp"
                __ZL13set_frame_rmsP7frame_ti($40, $div); //@line 685 "synthesize.cpp"
                ; //@line 686 "synthesize.cpp"
              }
  
              var $43=$fr; //@line 687 "synthesize.cpp"
              var $44=$f2; //@line 687 "synthesize.cpp"
              var $45=$f2_min; //@line 687 "synthesize.cpp"
              var $46=$f2_max; //@line 687 "synthesize.cpp"
              var $47=$f1; //@line 687 "synthesize.cpp"
              var $48=$f3_adj; //@line 687 "synthesize.cpp"
              var $49=$f3_amp; //@line 687 "synthesize.cpp"
              var $50=$flags; //@line 687 "synthesize.cpp"
              __ZL14AdjustFormantsP7frame_tiiiiiii($43, $44, $45, $46, $47, $48, $49, $50); //@line 687 "synthesize.cpp"
              var $51=$rms; //@line 689 "synthesize.cpp"
              var $and67=($51) & 32; //@line 689 "synthesize.cpp"
              var $cmp68=((($and67))|0)==0; //@line 689 "synthesize.cpp"
              if (!($cmp68)) { __label__ = 18;break $if_then60$$if_else$17; } //@line 689 "synthesize.cpp"
  
              var $52=$fr; //@line 691 "synthesize.cpp"
              var $53=$rms; //@line 691 "synthesize.cpp"
              var $mul70=((($53)*2)&4294967295); //@line 691 "synthesize.cpp"
              __ZL13set_frame_rmsP7frame_ti($52, $mul70); //@line 691 "synthesize.cpp"
              ; //@line 692 "synthesize.cpp"
            }
            else if (__label__ == 15) {
  
              var $54=$flags; //@line 696 "synthesize.cpp"
              var $and72=($54) & 8; //@line 696 "synthesize.cpp"
              var $tobool73=((($and72))|0)!=0; //@line 696 "synthesize.cpp"
              var $55=$fr; //@line 697 "synthesize.cpp"
              if ($tobool73) { __label__ = 16;; } else { __label__ = 17;; } //@line 696 "synthesize.cpp"
              if (__label__ == 16) {
  
                var $56=$next_rms; //@line 697 "synthesize.cpp"
                var $mul75=((($56)*24)&4294967295); //@line 697 "synthesize.cpp"
                var $div76=((((($mul75))|0)/32)|0); //@line 697 "synthesize.cpp"
                __ZL13set_frame_rmsP7frame_ti($55, $div76); //@line 697 "synthesize.cpp"
                ; //@line 697 "synthesize.cpp"
              }
              else if (__label__ == 17) {
  
                __ZL13set_frame_rmsP7frame_ti($55, 28); //@line 699 "synthesize.cpp"
                ;
              }
            }
          } while(0);
  
          var $57=$flags; //@line 702 "synthesize.cpp"
          var $and80=($57) & 8; //@line 702 "synthesize.cpp"
          var $tobool81=((($and80))|0)!=0; //@line 702 "synthesize.cpp"
          if (!($tobool81)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 702 "synthesize.cpp"
  
          var $58=$fr; //@line 705 "synthesize.cpp"
          var $call83=__ZL14VowelClosenessP7frame_t($58); //@line 705 "synthesize.cpp"
          var $shl=((($call83)*256)&4294967295); //@line 705 "synthesize.cpp"
          var $add=((($shl)+2048)&4294967295); //@line 705 "synthesize.cpp"
          HEAP32[((__ZL10modn_flags)>>2)]=$add; //@line 705 "synthesize.cpp"
          ; //@line 706 "synthesize.cpp"
        }
        else if (__label__ == 20) {
  
          var $59=$rms; //@line 711 "synthesize.cpp"
          var $mul86=((($59)*2)&4294967295); //@line 711 "synthesize.cpp"
          $rms=$mul86; //@line 711 "synthesize.cpp"
          var $60=$f2; //@line 712 "synthesize.cpp"
          var $cmp87=((($60))|0)!=0; //@line 712 "synthesize.cpp"
          if ($cmp87) { __label__ = 22;; } else { __label__ = 21;; } //@line 712 "synthesize.cpp"
          if (__label__ == 21) {
  
            var $61=$flags; //@line 712 "synthesize.cpp"
            var $cmp88=((($61))|0)!=0; //@line 712 "synthesize.cpp"
            if (!($cmp88)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 712 "synthesize.cpp"
          }
  
          var $62=$flags; //@line 715 "synthesize.cpp"
          var $and90=($62) & 8; //@line 715 "synthesize.cpp"
          var $tobool91=((($and90))|0)!=0; //@line 715 "synthesize.cpp"
          if ($tobool91) { __label__ = 23;; } else { __label__ = 24;; } //@line 715 "synthesize.cpp"
          $if_then92$$if_else103$33: do { 
            if (__label__ == 23) {
  
              var $63=$n_frames_addr; //@line 717 "synthesize.cpp"
              var $64=HEAP32[(($63)>>2)]; //@line 717 "synthesize.cpp"
              var $sub93=((($64)-1)&4294967295); //@line 717 "synthesize.cpp"
              var $65=$seq_addr; //@line 717 "synthesize.cpp"
              var $arrayidx94=(($65+8*$sub93)&4294967295); //@line 717 "synthesize.cpp"
              var $frame95=(($arrayidx94+4)&4294967295); //@line 717 "synthesize.cpp"
              var $66=HEAP32[(($frame95)>>2)]; //@line 717 "synthesize.cpp"
              var $call96=__ZL9CopyFrameP7frame_ti($66, 0); //@line 717 "synthesize.cpp"
              $fr=$call96; //@line 717 "synthesize.cpp"
              var $67=$fr; //@line 718 "synthesize.cpp"
              var $68=$n_frames_addr; //@line 718 "synthesize.cpp"
              var $69=HEAP32[(($68)>>2)]; //@line 718 "synthesize.cpp"
              var $sub97=((($69)-1)&4294967295); //@line 718 "synthesize.cpp"
              var $70=$seq_addr; //@line 718 "synthesize.cpp"
              var $arrayidx98=(($70+8*$sub97)&4294967295); //@line 718 "synthesize.cpp"
              var $frame99=(($arrayidx98+4)&4294967295); //@line 718 "synthesize.cpp"
              HEAP32[(($frame99)>>2)]=$67; //@line 718 "synthesize.cpp"
              $rms=35; //@line 719 "synthesize.cpp"
              var $71=$fr; //@line 722 "synthesize.cpp"
              var $call100=__ZL14VowelClosenessP7frame_t($71); //@line 722 "synthesize.cpp"
              var $shl101=((($call100)*256)&4294967295); //@line 722 "synthesize.cpp"
              var $add102=((($shl101)+1024)&4294967295); //@line 722 "synthesize.cpp"
              HEAP32[((__ZL10modn_flags)>>2)]=$add102; //@line 722 "synthesize.cpp"
              ; //@line 723 "synthesize.cpp"
            }
            else if (__label__ == 24) {
  
              var $72=$seq_addr; //@line 726 "synthesize.cpp"
              var $73=$n_frames_addr; //@line 726 "synthesize.cpp"
              var $74=HEAP32[(($73)>>2)]; //@line 726 "synthesize.cpp"
              var $inc=((($74)+1)&4294967295); //@line 726 "synthesize.cpp"
              HEAP32[(($73)>>2)]=$inc; //@line 726 "synthesize.cpp"
              var $75=$len; //@line 726 "synthesize.cpp"
              var $call104=__ZL18DuplicateLastFrameP10frameref_tii($72, $74, $75); //@line 726 "synthesize.cpp"
              $fr=$call104; //@line 726 "synthesize.cpp"
              var $76=$len; //@line 727 "synthesize.cpp"
              var $cmp105=((($76))|0) > 36; //@line 727 "synthesize.cpp"
              if ($cmp105) { __label__ = 25;; } else { __label__ = 26;; } //@line 727 "synthesize.cpp"
              if (__label__ == 25) {
  
                var $77=$len; //@line 728 "synthesize.cpp"
                var $78=HEAP32[((_seq_len_adjust)>>2)]; //@line 728 "synthesize.cpp"
                var $sub107=((($77)-36)&4294967295); //@line 728 "synthesize.cpp"
                var $add108=((($sub107)+($78))&4294967295); //@line 728 "synthesize.cpp"
                HEAP32[((_seq_len_adjust)>>2)]=$add108; //@line 728 "synthesize.cpp"
                ; //@line 728 "synthesize.cpp"
              }
  
              var $79=$f2; //@line 730 "synthesize.cpp"
              var $cmp110=((($79))|0)!=0; //@line 730 "synthesize.cpp"
              if (!($cmp110)) { __label__ = 28;break $if_then92$$if_else103$33; } //@line 730 "synthesize.cpp"
  
              var $80=$fr; //@line 732 "synthesize.cpp"
              var $81=$f2; //@line 732 "synthesize.cpp"
              var $82=$f2_min; //@line 732 "synthesize.cpp"
              var $83=$f2_max; //@line 732 "synthesize.cpp"
              var $84=$f1; //@line 732 "synthesize.cpp"
              var $85=$f3_adj; //@line 732 "synthesize.cpp"
              var $86=$f3_amp; //@line 732 "synthesize.cpp"
              var $87=$flags; //@line 732 "synthesize.cpp"
              __ZL14AdjustFormantsP7frame_tiiiiiii($80, $81, $82, $83, $84, $85, $86, $87); //@line 732 "synthesize.cpp"
              ; //@line 733 "synthesize.cpp"
            }
          } while(0);
  
          var $88=$fr; //@line 736 "synthesize.cpp"
          var $89=$rms; //@line 736 "synthesize.cpp"
          __ZL13set_frame_rmsP7frame_ti($88, $89); //@line 736 "synthesize.cpp"
          var $90=$vcolour; //@line 738 "synthesize.cpp"
          var $cmp114=((($90))|0) > 0; //@line 738 "synthesize.cpp"
          var $91=$vcolour; //@line 738 "synthesize.cpp"
          var $cmp116=((($91))|0) <= 2; //@line 738 "synthesize.cpp"
          var $or_cond=($cmp114) & ($cmp116); //@line 738 "synthesize.cpp"
          if (!($or_cond)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 738 "synthesize.cpp"
  
          $ix=0; //@line 740 "synthesize.cpp"
          var $92=$ix; //@line 740 "synthesize.cpp"
          var $93=$n_frames_addr; //@line 740 "synthesize.cpp"
          var $94=HEAP32[(($93)>>2)]; //@line 740 "synthesize.cpp"
          var $cmp1181=((($92))|0) < ((($94))|0); //@line 740 "synthesize.cpp"
          if (!($cmp1181)) { __label__ = 33;break $if_then27$$if_else85$9; } //@line 740 "synthesize.cpp"
          $for_body$42: while(1) { 
  
            var $95=$ix; //@line 742 "synthesize.cpp"
            var $96=$seq_addr; //@line 742 "synthesize.cpp"
            var $arrayidx119=(($96+8*$95)&4294967295); //@line 742 "synthesize.cpp"
            var $frame120=(($arrayidx119+4)&4294967295); //@line 742 "synthesize.cpp"
            var $97=HEAP32[(($frame120)>>2)]; //@line 742 "synthesize.cpp"
            var $call121=__ZL9CopyFrameP7frame_ti($97, 0); //@line 742 "synthesize.cpp"
            $fr=$call121; //@line 742 "synthesize.cpp"
            var $98=$fr; //@line 743 "synthesize.cpp"
            var $99=$ix; //@line 743 "synthesize.cpp"
            var $100=$seq_addr; //@line 743 "synthesize.cpp"
            var $arrayidx122=(($100+8*$99)&4294967295); //@line 743 "synthesize.cpp"
            var $frame123=(($arrayidx122+4)&4294967295); //@line 743 "synthesize.cpp"
            HEAP32[(($frame123)>>2)]=$98; //@line 743 "synthesize.cpp"
            $formant=1; //@line 745 "synthesize.cpp"
            ; //@line 745 "synthesize.cpp"
            while(1) { 
  
              var $101=$formant; //@line 748 "synthesize.cpp"
              var $102=$fr; //@line 748 "synthesize.cpp"
              var $ffreq=(($102+2)&4294967295); //@line 748 "synthesize.cpp"
              var $arrayidx127=(($ffreq+$101*2)&4294967295); //@line 748 "synthesize.cpp"
              var $103=HEAP16[(($arrayidx127)>>1)]; //@line 748 "synthesize.cpp"
              var $conv128=(tempInt=(($103)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 748 "synthesize.cpp"
              var $104=$formant; //@line 748 "synthesize.cpp"
              var $sub129=((($104)-1)&4294967295); //@line 748 "synthesize.cpp"
              var $105=$vcolour; //@line 748 "synthesize.cpp"
              var $sub130=((($105)-1)&4294967295); //@line 748 "synthesize.cpp"
              var $arrayidx131=((__ZZ18FormantTransition2P10frameref_tRijjP11PHONEME_TABiE10vcolouring+$sub130*10)&4294967295); //@line 748 "synthesize.cpp"
              var $arrayidx132=(($arrayidx131+$sub129*2)&4294967295); //@line 748 "synthesize.cpp"
              var $106=HEAP16[(($arrayidx132)>>1)]; //@line 748 "synthesize.cpp"
              var $conv133=(tempInt=(($106)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 748 "synthesize.cpp"
              var $mul134=((($conv133)*($conv128))&4294967295); //@line 748 "synthesize.cpp"
              $x=$mul134; //@line 748 "synthesize.cpp"
              var $107=$x; //@line 749 "synthesize.cpp"
              var $div135=((((($107))|0)/256)|0); //@line 749 "synthesize.cpp"
              var $conv136=((($div135)) & 65535); //@line 749 "synthesize.cpp"
              var $108=$formant; //@line 749 "synthesize.cpp"
              var $109=$fr; //@line 749 "synthesize.cpp"
              var $ffreq137=(($109+2)&4294967295); //@line 749 "synthesize.cpp"
              var $arrayidx138=(($ffreq137+$108*2)&4294967295); //@line 749 "synthesize.cpp"
              HEAP16[(($arrayidx138)>>1)]=$conv136; //@line 749 "synthesize.cpp"
              var $110=$formant; //@line 745 "synthesize.cpp"
              var $inc139=((($110)+1)&4294967295); //@line 745 "synthesize.cpp"
              $formant=$inc139; //@line 745 "synthesize.cpp"
              var $cmp125=((($inc139))|0) <= 5; //@line 745 "synthesize.cpp"
              if ($cmp125) { __label__ = 31;continue ; } else { __label__ = 32;break ; } //@line 745 "synthesize.cpp"
            }
  
            var $111=$ix; //@line 740 "synthesize.cpp"
            var $inc141=((($111)+1)&4294967295); //@line 740 "synthesize.cpp"
            $ix=$inc141; //@line 740 "synthesize.cpp"
            var $112=$ix; //@line 740 "synthesize.cpp"
            var $113=$n_frames_addr; //@line 740 "synthesize.cpp"
            var $114=HEAP32[(($113)>>2)]; //@line 740 "synthesize.cpp"
            var $cmp118=((($112))|0) < ((($114))|0); //@line 740 "synthesize.cpp"
            if ($cmp118) { __label__ = 30;continue $for_body$42; } else { __label__ = 33;break $if_then27$$if_else85$9; } //@line 740 "synthesize.cpp"
          }
        }
      } while(0);
  
      var $115=$fr; //@line 756 "synthesize.cpp"
      var $cmp146=((($115))|0)!=0; //@line 756 "synthesize.cpp"
      if ($cmp146) { __label__ = 34;; } else { __label__ = 38;; } //@line 756 "synthesize.cpp"
      $if_then147$$if_end164$48: do { 
        if (__label__ == 34) {
  
          var $116=$flags; //@line 758 "synthesize.cpp"
          var $and148=($116) & 4; //@line 758 "synthesize.cpp"
          var $tobool149=((($and148))|0)!=0; //@line 758 "synthesize.cpp"
          if ($tobool149) { __label__ = 35;; } else { __label__ = 36;; } //@line 758 "synthesize.cpp"
          if (__label__ == 35) {
  
            var $117=$fr; //@line 759 "synthesize.cpp"
            var $frflags151=(($117)&4294967295); //@line 759 "synthesize.cpp"
            var $118=HEAP16[(($frflags151)>>1)]; //@line 759 "synthesize.cpp"
            var $conv152=(tempInt=(($118)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 759 "synthesize.cpp"
            var $or153=($conv152) | 32; //@line 759 "synthesize.cpp"
            var $conv154=((($or153)) & 65535); //@line 759 "synthesize.cpp"
            HEAP16[(($frflags151)>>1)]=$conv154; //@line 759 "synthesize.cpp"
            ; //@line 759 "synthesize.cpp"
          }
  
          var $119=$flags; //@line 760 "synthesize.cpp"
          var $and156=($119) & 2; //@line 760 "synthesize.cpp"
          var $tobool157=((($and156))|0)!=0; //@line 760 "synthesize.cpp"
          if (!($tobool157)) { __label__ = 38;break $if_then147$$if_end164$48; } //@line 760 "synthesize.cpp"
  
          var $120=$fr; //@line 761 "synthesize.cpp"
          var $frflags159=(($120)&4294967295); //@line 761 "synthesize.cpp"
          var $121=HEAP16[(($frflags159)>>1)]; //@line 761 "synthesize.cpp"
          var $conv160=(tempInt=(($121)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 761 "synthesize.cpp"
          var $or161=($conv160) | 16; //@line 761 "synthesize.cpp"
          var $conv162=((($or161)) & 65535); //@line 761 "synthesize.cpp"
          HEAP16[(($frflags159)>>1)]=$conv162; //@line 761 "synthesize.cpp"
          ; //@line 761 "synthesize.cpp"
        }
      } while(0);
  
      var $122=$flags; //@line 764 "synthesize.cpp"
      var $and165=($122) & 64; //@line 764 "synthesize.cpp"
      var $tobool166=((($and165))|0)!=0; //@line 764 "synthesize.cpp"
      if ($tobool166) { __label__ = 39;; } else { __label__ = 40;; } //@line 764 "synthesize.cpp"
      if (__label__ == 39) {
  
        __ZL7DoPauseii(12, 0); //@line 765 "synthesize.cpp"
        ; //@line 765 "synthesize.cpp"
      }
  
      var $123=$flags; //@line 767 "synthesize.cpp"
      var $and169=($123) & 16; //@line 767 "synthesize.cpp"
      var $tobool170=((($and169))|0)!=0; //@line 767 "synthesize.cpp"
      if ($tobool170) { __label__ = 41;; } else { __label__ = 42;; } //@line 767 "synthesize.cpp"
      if (__label__ == 41) {
  
        var $124=$len; //@line 768 "synthesize.cpp"
        $retval=$124; //@line 768 "synthesize.cpp"
        ; //@line 768 "synthesize.cpp"
      }
      else if (__label__ == 42) {
  
        $retval=0; //@line 769 "synthesize.cpp"
        ; //@line 769 "synthesize.cpp"
      }
    }
  
    var $125=$retval; //@line 770 "synthesize.cpp"
    ;
    return $125; //@line 770 "synthesize.cpp"
    return null;
  }
  

  function __ZL9CopyFrameP7frame_ti($frame1, $copy) {
    ;
    var __label__;
  
    var $retval;
    var $frame1_addr;
    var $copy_addr;
    var $frame2;
    $frame1_addr=$frame1;
    $copy_addr=$copy;
    var $0=$copy_addr; //@line 524 "synthesize.cpp"
    var $cmp=((($0))|0)==0; //@line 524 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 524 "synthesize.cpp"
    $land_lhs_true$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=$frame1_addr; //@line 524 "synthesize.cpp"
        var $frflags=(($1)&4294967295); //@line 524 "synthesize.cpp"
        var $2=HEAP16[(($frflags)>>1)]; //@line 524 "synthesize.cpp"
        var $conv=(tempInt=(($2)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 524 "synthesize.cpp"
        var $and=($conv) & 32768; //@line 524 "synthesize.cpp"
        var $tobool=((($and))|0)!=0; //@line 524 "synthesize.cpp"
        if (!($tobool)) { __label__ = 3;break $land_lhs_true$$if_end$2; } //@line 524 "synthesize.cpp"
  
        var $3=$frame1_addr; //@line 527 "synthesize.cpp"
        $retval=$3; //@line 527 "synthesize.cpp"
        __label__ = 6;break $land_lhs_true$$if_end$2; //@line 527 "synthesize.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $call=__ZL10AllocFramev(); //@line 530 "synthesize.cpp"
      $frame2=$call; //@line 530 "synthesize.cpp"
      var $cmp1=((($call))|0)!=0; //@line 531 "synthesize.cpp"
      if ($cmp1) { __label__ = 4;; } else { __label__ = 5;; } //@line 531 "synthesize.cpp"
      if (__label__ == 4) {
  
        var $4=$frame2; //@line 533 "synthesize.cpp"
        var $5=$4; //@line 533 "synthesize.cpp"
        var $6=$frame1_addr; //@line 533 "synthesize.cpp"
        var $7=$6; //@line 533 "synthesize.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $7;
        $dest$ = $5;
        $stop$ = $src$ + 64;
        if (($dest$%4) == ($src$%4) && 64 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 533 "synthesize.cpp"
        var $8=$frame2; //@line 534 "synthesize.cpp"
        var $length=(($8+16)&4294967295); //@line 534 "synthesize.cpp"
        HEAP8[($length)]=0; //@line 534 "synthesize.cpp"
        var $9=$frame2; //@line 535 "synthesize.cpp"
        var $frflags3=(($9)&4294967295); //@line 535 "synthesize.cpp"
        var $10=HEAP16[(($frflags3)>>1)]; //@line 535 "synthesize.cpp"
        var $conv4=(tempInt=(($10)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 535 "synthesize.cpp"
        var $or=($conv4) | 32768; //@line 535 "synthesize.cpp"
        var $conv5=((($or)) & 65535); //@line 535 "synthesize.cpp"
        HEAP16[(($frflags3)>>1)]=$conv5; //@line 535 "synthesize.cpp"
        ; //@line 536 "synthesize.cpp"
      }
  
      var $11=$frame2; //@line 537 "synthesize.cpp"
      $retval=$11; //@line 537 "synthesize.cpp"
      ; //@line 537 "synthesize.cpp"
    }
  
    var $12=$retval; //@line 538 "synthesize.cpp"
    ;
    return $12; //@line 538 "synthesize.cpp"
    return null;
  }
  

  function __ZL13set_frame_rmsP7frame_ti($fr, $new_rms) {
    ;
    var __label__;
  
    var $fr_addr;
    var $new_rms_addr;
    var $x;
    var $h;
    var $ix;
    $fr_addr=$fr;
    $new_rms_addr=$new_rms;
    var $0=HEAP32[((_voice)>>2)]; //@line 478 "synthesize.cpp"
    var $klattv=(($0+112)&4294967295); //@line 478 "synthesize.cpp"
    var $arrayidx=(($klattv)&4294967295); //@line 478 "synthesize.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 478 "synthesize.cpp"
    var $tobool=((($1))|0)!=0; //@line 478 "synthesize.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 3;; } //@line 478 "synthesize.cpp"
    $if_then$$if_end3$2: do { 
      if (__label__ == 1) {
  
        var $2=$new_rms_addr; //@line 480 "synthesize.cpp"
        var $cmp=((($2))|0)==-1; //@line 480 "synthesize.cpp"
        if (!($cmp)) { __label__ = 8;break $if_then$$if_end3$2; } //@line 480 "synthesize.cpp"
  
        var $3=$fr_addr; //@line 482 "synthesize.cpp"
        var $klattp=(($3+39)&4294967295); //@line 482 "synthesize.cpp"
        var $arrayidx2=(($klattp)&4294967295); //@line 482 "synthesize.cpp"
        HEAP8[($arrayidx2)]=50; //@line 482 "synthesize.cpp"
        ; //@line 483 "synthesize.cpp"
      }
      else if (__label__ == 3) {
  
        var $4=$fr_addr; //@line 487 "synthesize.cpp"
        var $rms=(($4+17)&4294967295); //@line 487 "synthesize.cpp"
        var $5=HEAPU8[($rms)]; //@line 487 "synthesize.cpp"
        var $conv=((($5))&255); //@line 487 "synthesize.cpp"
        var $cmp4=((($conv))|0)==0; //@line 487 "synthesize.cpp"
        if ($cmp4) { __label__ = 8;break $if_then$$if_end3$2; } //@line 487 "synthesize.cpp"
  
        var $6=$new_rms_addr; //@line 488 "synthesize.cpp"
        var $mul=((($6)*64)&4294967295); //@line 488 "synthesize.cpp"
        var $7=$fr_addr; //@line 488 "synthesize.cpp"
        var $rms7=(($7+17)&4294967295); //@line 488 "synthesize.cpp"
        var $8=HEAPU8[($rms7)]; //@line 488 "synthesize.cpp"
        var $conv8=((($8))&255); //@line 488 "synthesize.cpp"
        var $div=((((($mul))|0)/((($conv8))|0))|0); //@line 488 "synthesize.cpp"
        $x=$div; //@line 488 "synthesize.cpp"
        var $9=$x; //@line 489 "synthesize.cpp"
        var $cmp9=((($9))|0) >= 200; //@line 489 "synthesize.cpp"
        if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 489 "synthesize.cpp"
        if (__label__ == 5) {
  
          $x=199; //@line 489 "synthesize.cpp"
          ; //@line 489 "synthesize.cpp"
        }
  
        var $10=$x; //@line 491 "synthesize.cpp"
        var $arrayidx12=((__ZZL13set_frame_rmsP7frame_tiE8sqrt_tab+$10*2)&4294967295); //@line 491 "synthesize.cpp"
        var $11=HEAP16[(($arrayidx12)>>1)]; //@line 491 "synthesize.cpp"
        var $conv13=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 491 "synthesize.cpp"
        $x=$conv13; //@line 491 "synthesize.cpp"
        $ix=0; //@line 493 "synthesize.cpp"
        ; //@line 493 "synthesize.cpp"
        while(1) { 
  
          var $12=$ix; //@line 495 "synthesize.cpp"
          var $13=$fr_addr; //@line 495 "synthesize.cpp"
          var $fheight=(($13+18)&4294967295); //@line 495 "synthesize.cpp"
          var $arrayidx15=(($fheight+$12)&4294967295); //@line 495 "synthesize.cpp"
          var $14=HEAPU8[($arrayidx15)]; //@line 495 "synthesize.cpp"
          var $conv16=((($14))&255); //@line 495 "synthesize.cpp"
          var $15=$x; //@line 495 "synthesize.cpp"
          var $mul17=((($conv16)*($15))&4294967295); //@line 495 "synthesize.cpp"
          $h=$mul17; //@line 495 "synthesize.cpp"
          var $16=$h; //@line 496 "synthesize.cpp"
          var $div18=((((($16))|0)/512)|0); //@line 496 "synthesize.cpp"
          var $conv19=((($div18)) & 255); //@line 496 "synthesize.cpp"
          var $17=$ix; //@line 496 "synthesize.cpp"
          var $18=$fr_addr; //@line 496 "synthesize.cpp"
          var $fheight20=(($18+18)&4294967295); //@line 496 "synthesize.cpp"
          var $arrayidx21=(($fheight20+$17)&4294967295); //@line 496 "synthesize.cpp"
          HEAP8[($arrayidx21)]=$conv19; //@line 496 "synthesize.cpp"
          var $19=$ix; //@line 493 "synthesize.cpp"
          var $inc=((($19)+1)&4294967295); //@line 493 "synthesize.cpp"
          $ix=$inc; //@line 493 "synthesize.cpp"
          var $cmp14=((($inc))|0) < 8; //@line 493 "synthesize.cpp"
          if ($cmp14) { __label__ = 7;continue ; } else { __label__ = 8;break $if_then$$if_end3$2; } //@line 493 "synthesize.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 498 "synthesize.cpp"
    return;
  }
  

  function __ZL14AdjustFormantsP7frame_tiiiiiii($fr, $target, $min, $max, $f1_adj, $f3_adj, $hf_reduce, $flags) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $fr_addr;
    var $target_addr;
    var $min_addr;
    var $max_addr;
    var $f1_adj_addr;
    var $f3_adj_addr;
    var $hf_reduce_addr;
    var $flags_addr;
    var $x;
    $fr_addr=$fr;
    $target_addr=$target;
    $min_addr=$min;
    $max_addr=$max;
    $f1_adj_addr=$f1_adj;
    $f3_adj_addr=$f3_adj;
    $hf_reduce_addr=$hf_reduce;
    $flags_addr=$flags;
    var $0=$target_addr; //@line 559 "synthesize.cpp"
    var $1=HEAP32[((_voice)>>2)]; //@line 559 "synthesize.cpp"
    var $formant_factor=(($1+96)&4294967295); //@line 559 "synthesize.cpp"
    var $2=HEAP32[(($formant_factor)>>2)]; //@line 559 "synthesize.cpp"
    var $mul=((($2)*($0))&4294967295); //@line 559 "synthesize.cpp"
    var $div=((((($mul))|0)/256)|0); //@line 559 "synthesize.cpp"
    $target_addr=$div; //@line 559 "synthesize.cpp"
    var $3=$target_addr; //@line 561 "synthesize.cpp"
    var $4=$fr_addr; //@line 561 "synthesize.cpp"
    var $ffreq=(($4+2)&4294967295); //@line 561 "synthesize.cpp"
    var $arrayidx=(($ffreq+4)&4294967295); //@line 561 "synthesize.cpp"
    var $5=HEAP16[(($arrayidx)>>1)]; //@line 561 "synthesize.cpp"
    var $conv=(tempInt=(($5)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 561 "synthesize.cpp"
    var $sub=((($3)-($conv))&4294967295); //@line 561 "synthesize.cpp"
    var $div1=((((($sub))|0)/2)|0); //@line 561 "synthesize.cpp"
    $x=$div1; //@line 561 "synthesize.cpp"
    var $6=$x; //@line 562 "synthesize.cpp"
    var $7=$max_addr; //@line 562 "synthesize.cpp"
    var $cmp=((($6))|0) > ((($7))|0); //@line 562 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 562 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $8=$max_addr; //@line 562 "synthesize.cpp"
      $x=$8; //@line 562 "synthesize.cpp"
      ; //@line 562 "synthesize.cpp"
    }
  
    var $9=$x; //@line 563 "synthesize.cpp"
    var $10=$min_addr; //@line 563 "synthesize.cpp"
    var $cmp2=((($9))|0) < ((($10))|0); //@line 563 "synthesize.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 563 "synthesize.cpp"
    if (__label__ == 3) {
  
      var $11=$min_addr; //@line 563 "synthesize.cpp"
      $x=$11; //@line 563 "synthesize.cpp"
      ; //@line 563 "synthesize.cpp"
    }
  
    var $12=$x; //@line 564 "synthesize.cpp"
    var $13=$fr_addr; //@line 564 "synthesize.cpp"
    var $ffreq5=(($13+2)&4294967295); //@line 564 "synthesize.cpp"
    var $arrayidx6=(($ffreq5+4)&4294967295); //@line 564 "synthesize.cpp"
    var $14=HEAP16[(($arrayidx6)>>1)]; //@line 564 "synthesize.cpp"
    var $conv7=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 564 "synthesize.cpp"
    var $add=((($conv7)+($12))&4294967295); //@line 564 "synthesize.cpp"
    var $conv8=((($add)) & 65535); //@line 564 "synthesize.cpp"
    HEAP16[(($arrayidx6)>>1)]=$conv8; //@line 564 "synthesize.cpp"
    var $15=$f3_adj_addr; //@line 565 "synthesize.cpp"
    var $16=$fr_addr; //@line 565 "synthesize.cpp"
    var $ffreq9=(($16+2)&4294967295); //@line 565 "synthesize.cpp"
    var $arrayidx10=(($ffreq9+6)&4294967295); //@line 565 "synthesize.cpp"
    var $17=HEAP16[(($arrayidx10)>>1)]; //@line 565 "synthesize.cpp"
    var $conv11=(tempInt=(($17)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 565 "synthesize.cpp"
    var $add12=((($conv11)+($15))&4294967295); //@line 565 "synthesize.cpp"
    var $conv13=((($add12)) & 65535); //@line 565 "synthesize.cpp"
    HEAP16[(($arrayidx10)>>1)]=$conv13; //@line 565 "synthesize.cpp"
    var $18=$flags_addr; //@line 567 "synthesize.cpp"
    var $and=($18) & 32; //@line 567 "synthesize.cpp"
    var $tobool=((($and))|0)!=0; //@line 567 "synthesize.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 567 "synthesize.cpp"
    if (__label__ == 5) {
  
      var $19=$f3_adj_addr; //@line 569 "synthesize.cpp"
      var $sub15=(((-($19)))&4294967295); //@line 569 "synthesize.cpp"
      $f3_adj_addr=$sub15; //@line 569 "synthesize.cpp"
      ; //@line 570 "synthesize.cpp"
    }
  
    var $20=$f3_adj_addr; //@line 571 "synthesize.cpp"
    var $21=$fr_addr; //@line 571 "synthesize.cpp"
    var $ffreq17=(($21+2)&4294967295); //@line 571 "synthesize.cpp"
    var $arrayidx18=(($ffreq17+8)&4294967295); //@line 571 "synthesize.cpp"
    var $22=HEAP16[(($arrayidx18)>>1)]; //@line 571 "synthesize.cpp"
    var $conv19=(tempInt=(($22)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 571 "synthesize.cpp"
    var $add20=((($conv19)+($20))&4294967295); //@line 571 "synthesize.cpp"
    var $conv21=((($add20)) & 65535); //@line 571 "synthesize.cpp"
    HEAP16[(($arrayidx18)>>1)]=$conv21; //@line 571 "synthesize.cpp"
    var $23=$f3_adj_addr; //@line 572 "synthesize.cpp"
    var $24=$fr_addr; //@line 572 "synthesize.cpp"
    var $ffreq22=(($24+2)&4294967295); //@line 572 "synthesize.cpp"
    var $arrayidx23=(($ffreq22+10)&4294967295); //@line 572 "synthesize.cpp"
    var $25=HEAP16[(($arrayidx23)>>1)]; //@line 572 "synthesize.cpp"
    var $conv24=(tempInt=(($25)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 572 "synthesize.cpp"
    var $add25=((($conv24)+($23))&4294967295); //@line 572 "synthesize.cpp"
    var $conv26=((($add25)) & 65535); //@line 572 "synthesize.cpp"
    HEAP16[(($arrayidx23)>>1)]=$conv26; //@line 572 "synthesize.cpp"
    var $26=$f1_adj_addr; //@line 574 "synthesize.cpp"
    var $cmp27=((($26))|0)==1; //@line 574 "synthesize.cpp"
    if ($cmp27) { __lastLabel__ = 6; __label__ = 7;; } else { __lastLabel__ = 6; __label__ = 12;; } //@line 574 "synthesize.cpp"
    if (__label__ == 7) {
  
      var $27=$fr_addr; //@line 576 "synthesize.cpp"
      var $ffreq29=(($27+2)&4294967295); //@line 576 "synthesize.cpp"
      var $arrayidx30=(($ffreq29+2)&4294967295); //@line 576 "synthesize.cpp"
      var $28=HEAP16[(($arrayidx30)>>1)]; //@line 576 "synthesize.cpp"
      var $conv31=(tempInt=(($28)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 576 "synthesize.cpp"
      var $sub32=((235-($conv31))&4294967295); //@line 576 "synthesize.cpp"
      $x=$sub32; //@line 576 "synthesize.cpp"
      var $29=$x; //@line 577 "synthesize.cpp"
      var $cmp33=((($29))|0) < -100; //@line 577 "synthesize.cpp"
      if ($cmp33) { __label__ = 8;; } else { __label__ = 9;; } //@line 577 "synthesize.cpp"
      $if_end35_thread$$if_end35$13: do { 
        if (__label__ == 8) {
  
          $x=-100; //@line 577 "synthesize.cpp"
          ; //@line 578 "synthesize.cpp"
        }
        else if (__label__ == 9) {
  
          var $cmp36=((($29))|0) > -60; //@line 578 "synthesize.cpp"
          if (!($cmp36)) { __label__ = 11;break $if_end35_thread$$if_end35$13; } //@line 578 "synthesize.cpp"
  
          $x=-60; //@line 578 "synthesize.cpp"
          ; //@line 578 "synthesize.cpp"
        }
      } while(0);
  
      var $30=$x; //@line 579 "synthesize.cpp"
      var $31=$fr_addr; //@line 579 "synthesize.cpp"
      var $ffreq39=(($31+2)&4294967295); //@line 579 "synthesize.cpp"
      var $arrayidx40=(($ffreq39+2)&4294967295); //@line 579 "synthesize.cpp"
      var $32=HEAP16[(($arrayidx40)>>1)]; //@line 579 "synthesize.cpp"
      var $conv41=(tempInt=(($32)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 579 "synthesize.cpp"
      var $add42=((($conv41)+($30))&4294967295); //@line 579 "synthesize.cpp"
      var $conv43=((($add42)) & 65535); //@line 579 "synthesize.cpp"
      HEAP16[(($arrayidx40)>>1)]=$conv43; //@line 579 "synthesize.cpp"
      var $_pr=$f1_adj_addr; //@line 581 "synthesize.cpp"
      __lastLabel__ = 11; ; //@line 580 "synthesize.cpp"
    }
  
    var $33=__lastLabel__ == 11 ? $_pr : ($26); //@line 581 "synthesize.cpp"
    var $cmp45=((($33))|0)==2; //@line 581 "synthesize.cpp"
    if ($cmp45) { __label__ = 13;; } else { __label__ = 18;; } //@line 581 "synthesize.cpp"
    if (__label__ == 13) {
  
      var $34=$fr_addr; //@line 583 "synthesize.cpp"
      var $ffreq47=(($34+2)&4294967295); //@line 583 "synthesize.cpp"
      var $arrayidx48=(($ffreq47+2)&4294967295); //@line 583 "synthesize.cpp"
      var $35=HEAP16[(($arrayidx48)>>1)]; //@line 583 "synthesize.cpp"
      var $conv49=(tempInt=(($35)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 583 "synthesize.cpp"
      var $sub50=((235-($conv49))&4294967295); //@line 583 "synthesize.cpp"
      $x=$sub50; //@line 583 "synthesize.cpp"
      var $36=$x; //@line 584 "synthesize.cpp"
      var $cmp51=((($36))|0) < -300; //@line 584 "synthesize.cpp"
      if ($cmp51) { __label__ = 14;; } else { __label__ = 15;; } //@line 584 "synthesize.cpp"
      $if_end53_thread$$if_end53$21: do { 
        if (__label__ == 14) {
  
          $x=-300; //@line 584 "synthesize.cpp"
          ; //@line 585 "synthesize.cpp"
        }
        else if (__label__ == 15) {
  
          var $cmp54=((($36))|0) > -150; //@line 585 "synthesize.cpp"
          if (!($cmp54)) { __label__ = 17;break $if_end53_thread$$if_end53$21; } //@line 585 "synthesize.cpp"
  
          $x=-150; //@line 585 "synthesize.cpp"
          ; //@line 585 "synthesize.cpp"
        }
      } while(0);
  
      var $37=$x; //@line 586 "synthesize.cpp"
      var $38=$fr_addr; //@line 586 "synthesize.cpp"
      var $ffreq57=(($38+2)&4294967295); //@line 586 "synthesize.cpp"
      var $arrayidx58=(($ffreq57+2)&4294967295); //@line 586 "synthesize.cpp"
      var $39=HEAP16[(($arrayidx58)>>1)]; //@line 586 "synthesize.cpp"
      var $conv59=(tempInt=(($39)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 586 "synthesize.cpp"
      var $add60=((($conv59)+($37))&4294967295); //@line 586 "synthesize.cpp"
      var $conv61=((($add60)) & 65535); //@line 586 "synthesize.cpp"
      HEAP16[(($arrayidx58)>>1)]=$conv61; //@line 586 "synthesize.cpp"
      var $40=$x; //@line 587 "synthesize.cpp"
      var $41=$fr_addr; //@line 587 "synthesize.cpp"
      var $ffreq62=(($41+2)&4294967295); //@line 587 "synthesize.cpp"
      var $arrayidx63=(($ffreq62)&4294967295); //@line 587 "synthesize.cpp"
      var $42=HEAP16[(($arrayidx63)>>1)]; //@line 587 "synthesize.cpp"
      var $conv64=(tempInt=(($42)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 587 "synthesize.cpp"
      var $add65=((($conv64)+($40))&4294967295); //@line 587 "synthesize.cpp"
      var $conv66=((($add65)) & 65535); //@line 587 "synthesize.cpp"
      HEAP16[(($arrayidx63)>>1)]=$conv66; //@line 587 "synthesize.cpp"
      ; //@line 588 "synthesize.cpp"
    }
  
    var $43=$f1_adj_addr; //@line 589 "synthesize.cpp"
    var $cmp68=((($43))|0)==3; //@line 589 "synthesize.cpp"
    if ($cmp68) { __label__ = 19;; } else { __label__ = 24;; } //@line 589 "synthesize.cpp"
    if (__label__ == 19) {
  
      var $44=$fr_addr; //@line 591 "synthesize.cpp"
      var $ffreq70=(($44+2)&4294967295); //@line 591 "synthesize.cpp"
      var $arrayidx71=(($ffreq70+2)&4294967295); //@line 591 "synthesize.cpp"
      var $45=HEAP16[(($arrayidx71)>>1)]; //@line 591 "synthesize.cpp"
      var $conv72=(tempInt=(($45)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 591 "synthesize.cpp"
      var $sub73=((100-($conv72))&4294967295); //@line 591 "synthesize.cpp"
      $x=$sub73; //@line 591 "synthesize.cpp"
      var $46=$x; //@line 592 "synthesize.cpp"
      var $cmp74=((($46))|0) < -400; //@line 592 "synthesize.cpp"
      if ($cmp74) { __label__ = 20;; } else { __label__ = 21;; } //@line 592 "synthesize.cpp"
      $if_end76_thread$$if_end76$29: do { 
        if (__label__ == 20) {
  
          $x=-400; //@line 592 "synthesize.cpp"
          ; //@line 593 "synthesize.cpp"
        }
        else if (__label__ == 21) {
  
          var $cmp77=((($46))|0) > -300; //@line 593 "synthesize.cpp"
          if (!($cmp77)) { __label__ = 23;break $if_end76_thread$$if_end76$29; } //@line 593 "synthesize.cpp"
  
          $x=-400; //@line 593 "synthesize.cpp"
          ; //@line 593 "synthesize.cpp"
        }
      } while(0);
  
      var $47=$x; //@line 594 "synthesize.cpp"
      var $48=$fr_addr; //@line 594 "synthesize.cpp"
      var $ffreq80=(($48+2)&4294967295); //@line 594 "synthesize.cpp"
      var $arrayidx81=(($ffreq80+2)&4294967295); //@line 594 "synthesize.cpp"
      var $49=HEAP16[(($arrayidx81)>>1)]; //@line 594 "synthesize.cpp"
      var $conv82=(tempInt=(($49)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 594 "synthesize.cpp"
      var $add83=((($conv82)+($47))&4294967295); //@line 594 "synthesize.cpp"
      var $conv84=((($add83)) & 65535); //@line 594 "synthesize.cpp"
      HEAP16[(($arrayidx81)>>1)]=$conv84; //@line 594 "synthesize.cpp"
      var $50=$x; //@line 595 "synthesize.cpp"
      var $51=$fr_addr; //@line 595 "synthesize.cpp"
      var $ffreq85=(($51+2)&4294967295); //@line 595 "synthesize.cpp"
      var $arrayidx86=(($ffreq85)&4294967295); //@line 595 "synthesize.cpp"
      var $52=HEAP16[(($arrayidx86)>>1)]; //@line 595 "synthesize.cpp"
      var $conv87=(tempInt=(($52)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 595 "synthesize.cpp"
      var $add88=((($conv87)+($50))&4294967295); //@line 595 "synthesize.cpp"
      var $conv89=((($add88)) & 65535); //@line 595 "synthesize.cpp"
      HEAP16[(($arrayidx86)>>1)]=$conv89; //@line 595 "synthesize.cpp"
      ; //@line 596 "synthesize.cpp"
    }
  
    var $53=$fr_addr; //@line 597 "synthesize.cpp"
    var $54=$hf_reduce_addr; //@line 597 "synthesize.cpp"
    __ZL18formants_reduce_hfP7frame_ti($53, $54); //@line 597 "synthesize.cpp"
    ;
    return; //@line 598 "synthesize.cpp"
    return;
  }
  

  function __ZL14VowelClosenessP7frame_t($fr) {
    ;
    var __label__;
  
    var $retval;
    var $fr_addr;
    var $f1;
    $fr_addr=$fr;
    var $0=$fr_addr; //@line 606 "synthesize.cpp"
    var $ffreq=(($0+2)&4294967295); //@line 606 "synthesize.cpp"
    var $arrayidx=(($ffreq+2)&4294967295); //@line 606 "synthesize.cpp"
    var $1=HEAP16[(($arrayidx)>>1)]; //@line 606 "synthesize.cpp"
    var $conv=(tempInt=(($1)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 606 "synthesize.cpp"
    $f1=$conv; //@line 606 "synthesize.cpp"
    var $cmp=((($conv))|0) < 300; //@line 606 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 606 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=3; //@line 607 "synthesize.cpp"
      ; //@line 607 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$f1; //@line 608 "synthesize.cpp"
      var $cmp1=((($2))|0) < 400; //@line 608 "synthesize.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 608 "synthesize.cpp"
      if (__label__ == 3) {
  
        $retval=2; //@line 609 "synthesize.cpp"
        ; //@line 609 "synthesize.cpp"
      }
      else if (__label__ == 4) {
  
        var $3=$f1; //@line 610 "synthesize.cpp"
        var $cmp4=((($3))|0) < 500; //@line 610 "synthesize.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 610 "synthesize.cpp"
        if (__label__ == 5) {
  
          $retval=1; //@line 611 "synthesize.cpp"
          ; //@line 611 "synthesize.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=0; //@line 612 "synthesize.cpp"
          ; //@line 612 "synthesize.cpp"
        }
      }
    }
  
    var $4=$retval; //@line 613 "synthesize.cpp"
    ;
    return $4; //@line 613 "synthesize.cpp"
    return null;
  }
  

  function __ZL18DuplicateLastFrameP10frameref_tii($seq, $n_frames, $length) {
    ;
    var __label__;
  
    var $seq_addr;
    var $n_frames_addr;
    var $length_addr;
    var $fr;
    $seq_addr=$seq;
    $n_frames_addr=$n_frames;
    $length_addr=$length;
    var $0=$length_addr; //@line 545 "synthesize.cpp"
    var $conv=((($0)) & 65535); //@line 545 "synthesize.cpp"
    var $1=$n_frames_addr; //@line 545 "synthesize.cpp"
    var $sub=((($1)-1)&4294967295); //@line 545 "synthesize.cpp"
    var $2=$seq_addr; //@line 545 "synthesize.cpp"
    var $arrayidx=(($2+8*$sub)&4294967295); //@line 545 "synthesize.cpp"
    var $length1=(($arrayidx)&4294967295); //@line 545 "synthesize.cpp"
    HEAP16[(($length1)>>1)]=$conv; //@line 545 "synthesize.cpp"
    var $3=$n_frames_addr; //@line 546 "synthesize.cpp"
    var $sub2=((($3)-1)&4294967295); //@line 546 "synthesize.cpp"
    var $4=$seq_addr; //@line 546 "synthesize.cpp"
    var $arrayidx3=(($4+8*$sub2)&4294967295); //@line 546 "synthesize.cpp"
    var $frame=(($arrayidx3+4)&4294967295); //@line 546 "synthesize.cpp"
    var $5=HEAP32[(($frame)>>2)]; //@line 546 "synthesize.cpp"
    var $call=__ZL9CopyFrameP7frame_ti($5, 1); //@line 546 "synthesize.cpp"
    $fr=$call; //@line 546 "synthesize.cpp"
    var $6=$fr; //@line 547 "synthesize.cpp"
    var $7=$n_frames_addr; //@line 547 "synthesize.cpp"
    var $8=$seq_addr; //@line 547 "synthesize.cpp"
    var $arrayidx4=(($8+8*$7)&4294967295); //@line 547 "synthesize.cpp"
    var $frame5=(($arrayidx4+4)&4294967295); //@line 547 "synthesize.cpp"
    HEAP32[(($frame5)>>2)]=$6; //@line 547 "synthesize.cpp"
    var $9=$n_frames_addr; //@line 548 "synthesize.cpp"
    var $10=$seq_addr; //@line 548 "synthesize.cpp"
    var $arrayidx6=(($10+8*$9)&4294967295); //@line 548 "synthesize.cpp"
    var $length7=(($arrayidx6)&4294967295); //@line 548 "synthesize.cpp"
    HEAP16[(($length7)>>1)]=0; //@line 548 "synthesize.cpp"
    var $11=$fr; //@line 549 "synthesize.cpp"
    ;
    return $11; //@line 549 "synthesize.cpp"
    return null;
  }
  

  function __ZL7DoPauseii($length, $control) {
    ;
    var __label__;
  
    var $length_addr;
    var $control_addr;
    var $len;
    $length_addr=$length;
    $control_addr=$control;
    var $0=$length_addr; //@line 216 "synthesize.cpp"
    var $cmp=((($0))|0)==0; //@line 216 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 216 "synthesize.cpp"
    if (__label__ == 1) {
  
      $len=0; //@line 217 "synthesize.cpp"
      ; //@line 217 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$length_addr; //@line 220 "synthesize.cpp"
      var $2=$control_addr; //@line 220 "synthesize.cpp"
      var $call=__Z11PauseLengthii($1, $2); //@line 220 "synthesize.cpp"
      $len=$call; //@line 220 "synthesize.cpp"
      var $3=$len; //@line 222 "synthesize.cpp"
      var $4=HEAP32[((_samplerate)>>2)]; //@line 222 "synthesize.cpp"
      var $mul=((($4)*($3))&4294967295); //@line 222 "synthesize.cpp"
      var $div=((((($mul))|0)/1000)|0); //@line 222 "synthesize.cpp"
      $len=$div; //@line 222 "synthesize.cpp"
      ;
    }
  
    __ZL8EndPitchi(1); //@line 225 "synthesize.cpp"
    var $5=HEAP32[((_wcmdq_tail)>>2)]; //@line 226 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$5*16)&4294967295); //@line 226 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 226 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=5; //@line 226 "synthesize.cpp"
    var $6=$len; //@line 227 "synthesize.cpp"
    var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 227 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$7*16)&4294967295); //@line 227 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 227 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$6; //@line 227 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 228 "synthesize.cpp"
    HEAP32[((__ZL10last_frame)>>2)]=0; //@line 229 "synthesize.cpp"
    var $8=HEAP32[((__ZL13fmt_amplitude)>>2)]; //@line 231 "synthesize.cpp"
    var $cmp4=((($8))|0)!=0; //@line 231 "synthesize.cpp"
    if ($cmp4) { __label__ = 4;; } else { __label__ = 5;; } //@line 231 "synthesize.cpp"
    if (__label__ == 4) {
  
      var $9=HEAP32[((_wcmdq_tail)>>2)]; //@line 233 "synthesize.cpp"
      var $arrayidx6=((_wcmdq+$9*16)&4294967295); //@line 233 "synthesize.cpp"
      var $arrayidx7=(($arrayidx6)&4294967295); //@line 233 "synthesize.cpp"
      HEAP32[(($arrayidx7)>>2)]=14; //@line 233 "synthesize.cpp"
      HEAP32[((__ZL13fmt_amplitude)>>2)]=0; //@line 234 "synthesize.cpp"
      var $10=HEAP32[((_wcmdq_tail)>>2)]; //@line 234 "synthesize.cpp"
      var $arrayidx8=((_wcmdq+$10*16)&4294967295); //@line 234 "synthesize.cpp"
      var $arrayidx9=(($arrayidx8+4)&4294967295); //@line 234 "synthesize.cpp"
      HEAP32[(($arrayidx9)>>2)]=0; //@line 234 "synthesize.cpp"
      __Z8WcmdqIncv(); //@line 235 "synthesize.cpp"
      ; //@line 236 "synthesize.cpp"
    }
  
    ;
    return; //@line 237 "synthesize.cpp"
    return;
  }
  

  function __Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($this_ph, $which, $fmt_params, $plist, $modulation) {
    var __stackBase__  = STACKTOP; STACKTOP += 104; _memset(__stackBase__, 0, 104);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $this_ph_addr;
    var $which_addr;
    var $fmt_params_addr;
    var $plist_addr;
    var $modulation_addr;
    var $n_frames=__stackBase__;
    var $frames;
    var $frameix;
    var $frame1;
    var $frame2;
    var $fr;
    var $ix;
    var $q;
    var $len;
    var $frame_length;
    var $length_factor;
    var $length_mod;
    var $length_sum;
    var $length_min;
    var $total_len;
    var $wcmd_spect;
    var $frame_lengths=__stackBase__+4;
    $this_ph_addr=$this_ph;
    $which_addr=$which;
    $fmt_params_addr=$fmt_params;
    $plist_addr=$plist;
    $modulation_addr=$modulation;
    $total_len=0; //@line 1007 "synthesize.cpp"
    $wcmd_spect=3; //@line 1009 "synthesize.cpp"
    var $0=$fmt_params_addr; //@line 1012 "synthesize.cpp"
    var $fmt_addr=(($0+8)&4294967295); //@line 1012 "synthesize.cpp"
    var $1=HEAP32[(($fmt_addr)>>2)]; //@line 1012 "synthesize.cpp"
    var $cmp=((($1))|0)==0; //@line 1012 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1012 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1013 "synthesize.cpp"
      ; //@line 1013 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$plist_addr; //@line 1015 "synthesize.cpp"
      var $length=(($2+12)&4294967295); //@line 1015 "synthesize.cpp"
      var $3=HEAP16[(($length)>>1)]; //@line 1015 "synthesize.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1015 "synthesize.cpp"
      $length_mod=$conv; //@line 1015 "synthesize.cpp"
      var $4=$length_mod; //@line 1016 "synthesize.cpp"
      var $cmp1=((($4))|0)==0; //@line 1016 "synthesize.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1016 "synthesize.cpp"
      if (__label__ == 3) {
  
        $length_mod=256; //@line 1016 "synthesize.cpp"
        ; //@line 1016 "synthesize.cpp"
      }
  
      var $5=HEAP32[((_samplerate)>>2)]; //@line 1018 "synthesize.cpp"
      var $div=((((($5))|0)/70)|0); //@line 1018 "synthesize.cpp"
      $length_min=$div; //@line 1018 "synthesize.cpp"
      var $6=$which_addr; //@line 1019 "synthesize.cpp"
      var $cmp4=((($6))|0)==2; //@line 1019 "synthesize.cpp"
      if ($cmp4) { __lastLabel__ = 4; __label__ = 5;; } else { __lastLabel__ = 4; __label__ = 11;; } //@line 1019 "synthesize.cpp"
      if (__label__ == 5) {
  
        var $7=HEAP32[((_translator)>>2)]; //@line 1021 "synthesize.cpp"
        var $langopts=(($7)&4294967295); //@line 1021 "synthesize.cpp"
        var $param=(($langopts+24)&4294967295); //@line 1021 "synthesize.cpp"
        var $arrayidx=(($param+72)&4294967295); //@line 1021 "synthesize.cpp"
        var $8=HEAP32[(($arrayidx)>>2)]; //@line 1021 "synthesize.cpp"
        var $cmp6=((($8))|0) > 0; //@line 1021 "synthesize.cpp"
        if ($cmp6) { __label__ = 6;; } else { __label__ = 10;; } //@line 1021 "synthesize.cpp"
        $land_lhs_true$$if_end18thread_pre_split$10: do { 
          if (__label__ == 6) {
  
            var $9=$this_ph_addr; //@line 1021 "synthesize.cpp"
            var $std_length=(($9+14)&4294967295); //@line 1021 "synthesize.cpp"
            var $10=HEAPU8[($std_length)]; //@line 1021 "synthesize.cpp"
            var $conv7=((($10))&255); //@line 1021 "synthesize.cpp"
            var $11=HEAP32[((_translator)>>2)]; //@line 1021 "synthesize.cpp"
            var $langopts8=(($11)&4294967295); //@line 1021 "synthesize.cpp"
            var $param9=(($langopts8+24)&4294967295); //@line 1021 "synthesize.cpp"
            var $arrayidx10=(($param9+72)&4294967295); //@line 1021 "synthesize.cpp"
            var $12=HEAP32[(($arrayidx10)>>2)]; //@line 1021 "synthesize.cpp"
            var $cmp11=((($conv7))|0) >= ((($12))|0); //@line 1021 "synthesize.cpp"
            if ($cmp11) { __label__ = 9;; } else { __label__ = 7;; } //@line 1021 "synthesize.cpp"
            $if_then16$$lor_lhs_false$12: do { 
              if (__label__ == 7) {
  
                var $13=$plist_addr; //@line 1021 "synthesize.cpp"
                var $synthflags=(($13+4)&4294967295); //@line 1021 "synthesize.cpp"
                var $14=HEAPU16[(($synthflags)>>1)]; //@line 1021 "synthesize.cpp"
                var $conv12=((($14))&65535); //@line 1021 "synthesize.cpp"
                var $and=($conv12) & 8; //@line 1021 "synthesize.cpp"
                var $tobool=((($and))|0)!=0; //@line 1021 "synthesize.cpp"
                if ($tobool) { __label__ = 9;break $if_then16$$lor_lhs_false$12; } //@line 1021 "synthesize.cpp"
  
                var $15=$this_ph_addr; //@line 1021 "synthesize.cpp"
                var $phflags=(($15+4)&4294967295); //@line 1021 "synthesize.cpp"
                var $16=HEAP32[(($phflags)>>2)]; //@line 1021 "synthesize.cpp"
                var $and14=($16) & 2097152; //@line 1021 "synthesize.cpp"
                var $tobool15=((($and14))|0)!=0; //@line 1021 "synthesize.cpp"
                if (!($tobool15)) { __label__ = 10;break $land_lhs_true$$if_end18thread_pre_split$10; } //@line 1021 "synthesize.cpp"
              }
            } while(0);
  
            var $17=$length_min; //@line 1022 "synthesize.cpp"
            var $mul=((($17)*2)&4294967295); //@line 1022 "synthesize.cpp"
            $length_min=$mul; //@line 1022 "synthesize.cpp"
            ; //@line 1022 "synthesize.cpp"
          }
        } while(0);
  
        var $_pr=$which_addr; //@line 1025 "synthesize.cpp"
        __lastLabel__ = 10; ;
      }
  
      var $18=__lastLabel__ == 10 ? $_pr : ($6); //@line 1025 "synthesize.cpp"
      var $cmp19=((($18))|0)==1; //@line 1025 "synthesize.cpp"
      if ($cmp19) { __label__ = 12;; } else { __label__ = 17;; } //@line 1025 "synthesize.cpp"
      $if_then20$$if_end41$18: do { 
        if (__label__ == 12) {
  
          var $19=$this_ph_addr; //@line 1028 "synthesize.cpp"
          var $type=(($19+11)&4294967295); //@line 1028 "synthesize.cpp"
          var $20=HEAPU8[($type)]; //@line 1028 "synthesize.cpp"
          var $conv21=((($20))&255); //@line 1028 "synthesize.cpp"
          var $cmp22=((($conv21))|0)==3; //@line 1028 "synthesize.cpp"
          if ($cmp22) { __label__ = 15;; } else { __label__ = 13;; } //@line 1028 "synthesize.cpp"
          $if_then33$$lor_lhs_false23$20: do { 
            if (__label__ == 13) {
  
              var $21=$plist_addr; //@line 1028 "synthesize.cpp"
              var $arrayidx24=(($21+-24)&4294967295); //@line 1028 "synthesize.cpp"
              var $type25=(($arrayidx24+15)&4294967295); //@line 1028 "synthesize.cpp"
              var $22=HEAPU8[($type25)]; //@line 1028 "synthesize.cpp"
              var $conv26=((($22))&255); //@line 1028 "synthesize.cpp"
              var $cmp27=((($conv26))|0)==3; //@line 1028 "synthesize.cpp"
              if ($cmp27) { __label__ = 15;break $if_then33$$lor_lhs_false23$20; } //@line 1028 "synthesize.cpp"
  
              var $23=$plist_addr; //@line 1028 "synthesize.cpp"
              var $arrayidx29=(($23+-24)&4294967295); //@line 1028 "synthesize.cpp"
              var $type30=(($arrayidx29+15)&4294967295); //@line 1028 "synthesize.cpp"
              var $24=HEAPU8[($type30)]; //@line 1028 "synthesize.cpp"
              var $conv31=((($24))&255); //@line 1028 "synthesize.cpp"
              var $cmp32=((($conv31))|0)==8; //@line 1028 "synthesize.cpp"
              if (!($cmp32)) { __label__ = 17;break $if_then20$$if_end41$18; } //@line 1028 "synthesize.cpp"
            }
          } while(0);
  
          var $25=$length_mod; //@line 1030 "synthesize.cpp"
          var $26=HEAP32[((_translator)>>2)]; //@line 1030 "synthesize.cpp"
          var $langopts34=(($26)&4294967295); //@line 1030 "synthesize.cpp"
          var $param35=(($langopts34+24)&4294967295); //@line 1030 "synthesize.cpp"
          var $arrayidx36=(($param35+28)&4294967295); //@line 1030 "synthesize.cpp"
          var $27=HEAP32[(($arrayidx36)>>2)]; //@line 1030 "synthesize.cpp"
          $len=$27; //@line 1030 "synthesize.cpp"
          var $cmp37=((($25))|0) < ((($27))|0); //@line 1030 "synthesize.cpp"
          if (!($cmp37)) { __label__ = 17;break $if_then20$$if_end41$18; } //@line 1030 "synthesize.cpp"
  
          var $28=$len; //@line 1032 "synthesize.cpp"
          $length_mod=$28; //@line 1032 "synthesize.cpp"
          ; //@line 1033 "synthesize.cpp"
        }
      } while(0);
  
      HEAP32[((__ZL10modn_flags)>>2)]=0; //@line 1037 "synthesize.cpp"
      var $29=$this_ph_addr; //@line 1038 "synthesize.cpp"
      var $30=$which_addr; //@line 1038 "synthesize.cpp"
      var $31=$fmt_params_addr; //@line 1038 "synthesize.cpp"
      var $32=$plist_addr; //@line 1038 "synthesize.cpp"
      var $call=__Z11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LIST($29, $30, $31, $n_frames, $32); //@line 1038 "synthesize.cpp"
      $frames=$call; //@line 1038 "synthesize.cpp"
      var $cmp42=((($call))|0)==0; //@line 1039 "synthesize.cpp"
      if ($cmp42) { __label__ = 18;; } else { __label__ = 19;; } //@line 1039 "synthesize.cpp"
      if (__label__ == 18) {
  
        $retval=0; //@line 1040 "synthesize.cpp"
        ; //@line 1040 "synthesize.cpp"
      }
      else if (__label__ == 19) {
  
        var $33=$fmt_params_addr; //@line 1042 "synthesize.cpp"
        var $fmt_amp=(($33+16)&4294967295); //@line 1042 "synthesize.cpp"
        var $34=HEAP32[(($fmt_amp)>>2)]; //@line 1042 "synthesize.cpp"
        var $35=HEAP32[((__ZL13fmt_amplitude)>>2)]; //@line 1042 "synthesize.cpp"
        var $cmp45=((($34))|0)!=((($35))|0); //@line 1042 "synthesize.cpp"
        if ($cmp45) { __label__ = 20;; } else { __label__ = 21;; } //@line 1042 "synthesize.cpp"
        if (__label__ == 20) {
  
          var $36=HEAP32[((_wcmdq_tail)>>2)]; //@line 1045 "synthesize.cpp"
          var $arrayidx47=((_wcmdq+$36*16)&4294967295); //@line 1045 "synthesize.cpp"
          var $arraydecay=(($arrayidx47)&4294967295); //@line 1045 "synthesize.cpp"
          $q=$arraydecay; //@line 1045 "synthesize.cpp"
          var $37=$q; //@line 1046 "synthesize.cpp"
          var $arrayidx48=(($37)&4294967295); //@line 1046 "synthesize.cpp"
          HEAP32[(($arrayidx48)>>2)]=14; //@line 1046 "synthesize.cpp"
          var $38=$fmt_params_addr; //@line 1047 "synthesize.cpp"
          var $fmt_amp49=(($38+16)&4294967295); //@line 1047 "synthesize.cpp"
          var $39=HEAP32[(($fmt_amp49)>>2)]; //@line 1047 "synthesize.cpp"
          HEAP32[((__ZL13fmt_amplitude)>>2)]=$39; //@line 1047 "synthesize.cpp"
          var $40=$q; //@line 1047 "synthesize.cpp"
          var $arrayidx50=(($40+4)&4294967295); //@line 1047 "synthesize.cpp"
          HEAP32[(($arrayidx50)>>2)]=$39; //@line 1047 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1048 "synthesize.cpp"
          ; //@line 1049 "synthesize.cpp"
        }
  
        var $41=$frames; //@line 1051 "synthesize.cpp"
        var $arrayidx52=(($41)&4294967295); //@line 1051 "synthesize.cpp"
        var $frame=(($arrayidx52+4)&4294967295); //@line 1051 "synthesize.cpp"
        var $42=HEAP32[(($frame)>>2)]; //@line 1051 "synthesize.cpp"
        $frame1=$42; //@line 1051 "synthesize.cpp"
        var $43=HEAP32[((_voice)>>2)]; //@line 1052 "synthesize.cpp"
        var $klattv=(($43+112)&4294967295); //@line 1052 "synthesize.cpp"
        var $arrayidx53=(($klattv)&4294967295); //@line 1052 "synthesize.cpp"
        var $44=HEAP32[(($arrayidx53)>>2)]; //@line 1052 "synthesize.cpp"
        var $tobool54=((($44))|0)!=0; //@line 1052 "synthesize.cpp"
        if ($tobool54) { __label__ = 22;; } else { __label__ = 23;; } //@line 1052 "synthesize.cpp"
        if (__label__ == 22) {
  
          $wcmd_spect=1; //@line 1053 "synthesize.cpp"
          ; //@line 1053 "synthesize.cpp"
        }
  
        var $45=$fmt_params_addr; //@line 1055 "synthesize.cpp"
        var $wav_addr=(($45+28)&4294967295); //@line 1055 "synthesize.cpp"
        var $46=HEAP32[(($wav_addr)>>2)]; //@line 1055 "synthesize.cpp"
        HEAP32[((_wavefile_ix)>>2)]=$46; //@line 1055 "synthesize.cpp"
        var $47=$fmt_params_addr; //@line 1057 "synthesize.cpp"
        var $wav_amp=(($47+32)&4294967295); //@line 1057 "synthesize.cpp"
        var $48=HEAP32[(($wav_amp)>>2)]; //@line 1057 "synthesize.cpp"
        var $cmp57=((($48))|0)==0; //@line 1057 "synthesize.cpp"
        if ($cmp57) { __label__ = 24;; } else { __label__ = 25;; } //@line 1057 "synthesize.cpp"
        if (__label__ == 24) {
  
          HEAP32[((_wavefile_amp)>>2)]=32; //@line 1058 "synthesize.cpp"
          ; //@line 1058 "synthesize.cpp"
        }
        else if (__label__ == 25) {
  
          var $49=$fmt_params_addr; //@line 1060 "synthesize.cpp"
          var $wav_amp59=(($49+32)&4294967295); //@line 1060 "synthesize.cpp"
          var $50=HEAP32[(($wav_amp59)>>2)]; //@line 1060 "synthesize.cpp"
          var $mul60=((($50)*32)&4294967295); //@line 1060 "synthesize.cpp"
          var $div61=((((($mul60))|0)/100)|0); //@line 1060 "synthesize.cpp"
          HEAP32[((_wavefile_amp)>>2)]=$div61; //@line 1060 "synthesize.cpp"
          ;
        }
  
        var $51=HEAP32[((_wavefile_ix)>>2)]; //@line 1062 "synthesize.cpp"
        var $cmp63=((($51))|0)==0; //@line 1062 "synthesize.cpp"
        if ($cmp63) { __label__ = 27;; } else { __label__ = 33;; } //@line 1062 "synthesize.cpp"
        $if_then64$$if_end79$39: do { 
          if (__label__ == 27) {
  
            var $_b=HEAPU8[(__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b)];
            var $52=((($_b))&1);
            var $tobool65=((($52))|0)!=0; //@line 1064 "synthesize.cpp"
            if ($tobool65) { __label__ = 28;; } else { __label__ = 31;; } //@line 1064 "synthesize.cpp"
            if (__label__ == 28) {
  
              $wcmd_spect=4; //@line 1067 "synthesize.cpp"
              var $53=HEAP32[((_voice)>>2)]; //@line 1068 "synthesize.cpp"
              var $klattv67=(($53+112)&4294967295); //@line 1068 "synthesize.cpp"
              var $arrayidx68=(($klattv67)&4294967295); //@line 1068 "synthesize.cpp"
              var $54=HEAP32[(($arrayidx68)>>2)]; //@line 1068 "synthesize.cpp"
              var $tobool69=((($54))|0)!=0; //@line 1068 "synthesize.cpp"
              if ($tobool69) { __label__ = 29;; } else { __label__ = 30;; } //@line 1068 "synthesize.cpp"
              if (__label__ == 29) {
  
                $wcmd_spect=2; //@line 1069 "synthesize.cpp"
                ; //@line 1069 "synthesize.cpp"
              }
  
              HEAP8[(__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b)]=0;
              ; //@line 1071 "synthesize.cpp"
            }
            else if (__label__ == 31) {
  
              $wcmd_spect=3; //@line 1074 "synthesize.cpp"
              var $55=HEAP32[((_voice)>>2)]; //@line 1075 "synthesize.cpp"
              var $klattv73=(($55+112)&4294967295); //@line 1075 "synthesize.cpp"
              var $arrayidx74=(($klattv73)&4294967295); //@line 1075 "synthesize.cpp"
              var $56=HEAP32[(($arrayidx74)>>2)]; //@line 1075 "synthesize.cpp"
              var $tobool75=((($56))|0)!=0; //@line 1075 "synthesize.cpp"
              if (!($tobool75)) { __label__ = 33;break $if_then64$$if_end79$39; } //@line 1075 "synthesize.cpp"
  
              $wcmd_spect=1; //@line 1076 "synthesize.cpp"
              ; //@line 1076 "synthesize.cpp"
            }
          }
        } while(0);
  
        var $57=HEAP32[((__ZL10last_frame)>>2)]; //@line 1080 "synthesize.cpp"
        var $cmp80=((($57))|0)!=0; //@line 1080 "synthesize.cpp"
        if ($cmp80) { __label__ = 34;; } else { __label__ = 43;; } //@line 1080 "synthesize.cpp"
        $if_then81$$if_end117$49: do { 
          if (__label__ == 34) {
  
            var $58=HEAP32[((__ZL10last_frame)>>2)]; //@line 1082 "synthesize.cpp"
            var $length82=(($58+16)&4294967295); //@line 1082 "synthesize.cpp"
            var $59=HEAPU8[($length82)]; //@line 1082 "synthesize.cpp"
            var $conv83=((($59))&255); //@line 1082 "synthesize.cpp"
            var $cmp84=((($conv83))|0) < 2; //@line 1082 "synthesize.cpp"
            if ($cmp84) { __label__ = 36;; } else { __label__ = 35;; } //@line 1082 "synthesize.cpp"
            if (__label__ == 35) {
  
              var $60=HEAP32[((__ZL10last_frame)>>2)]; //@line 1082 "synthesize.cpp"
              var $frflags=(($60)&4294967295); //@line 1082 "synthesize.cpp"
              var $61=HEAP16[(($frflags)>>1)]; //@line 1082 "synthesize.cpp"
              var $conv86=(tempInt=(($61)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1082 "synthesize.cpp"
              var $and87=($conv86) & 2; //@line 1082 "synthesize.cpp"
              var $tobool88=((($and87))|0)!=0; //@line 1082 "synthesize.cpp"
              if (!($tobool88)) { __label__ = 43;break $if_then81$$if_end117$49; } //@line 1082 "synthesize.cpp"
            }
  
            var $62=HEAP32[((__ZL10last_frame)>>2)]; //@line 1082 "synthesize.cpp"
            var $frflags90=(($62)&4294967295); //@line 1082 "synthesize.cpp"
            var $63=HEAP16[(($frflags90)>>1)]; //@line 1082 "synthesize.cpp"
            var $conv91=(tempInt=(($63)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1082 "synthesize.cpp"
            var $and92=($conv91) & 16; //@line 1082 "synthesize.cpp"
            var $tobool93=((($and92))|0)!=0; //@line 1082 "synthesize.cpp"
            if ($tobool93) { __label__ = 43;break $if_then81$$if_end117$49; } //@line 1082 "synthesize.cpp"
  
            var $64=$frame1; //@line 1086 "synthesize.cpp"
            var $65=($64); //@line 1086 "synthesize.cpp"
            var $66=HEAP32[((__ZL10last_wcmdq)>>2)]; //@line 1086 "synthesize.cpp"
            var $arrayidx95=((_wcmdq+$66*16)&4294967295); //@line 1086 "synthesize.cpp"
            var $arrayidx96=(($arrayidx95+12)&4294967295); //@line 1086 "synthesize.cpp"
            HEAP32[(($arrayidx96)>>2)]=$65; //@line 1086 "synthesize.cpp"
            var $67=HEAP32[((__ZL10last_frame)>>2)]; //@line 1088 "synthesize.cpp"
            var $frflags97=(($67)&4294967295); //@line 1088 "synthesize.cpp"
            var $68=HEAP16[(($frflags97)>>1)]; //@line 1088 "synthesize.cpp"
            var $conv98=(tempInt=(($68)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1088 "synthesize.cpp"
            var $and99=($conv98) & 8; //@line 1088 "synthesize.cpp"
            var $tobool100=((($and99))|0)!=0; //@line 1088 "synthesize.cpp"
            if (!($tobool100)) { __label__ = 43;break $if_then81$$if_end117$49; } //@line 1088 "synthesize.cpp"
  
            var $69=$frame1; //@line 1091 "synthesize.cpp"
            var $call102=__ZL9CopyFrameP7frame_ti($69, 1); //@line 1091 "synthesize.cpp"
            $fr=$call102; //@line 1091 "synthesize.cpp"
            $ix=3; //@line 1092 "synthesize.cpp"
            __lastLabel__ = 38; ; //@line 1092 "synthesize.cpp"
            while(1) { 
  
              var $70=__lastLabel__ == 38 ? 3 : ($inc); //@line 1094 "synthesize.cpp"
              var $cmp104=((($70))|0) < 7; //@line 1094 "synthesize.cpp"
              if ($cmp104) { __label__ = 40;; } else { __label__ = 41;; } //@line 1094 "synthesize.cpp"
              if (__label__ == 40) {
  
                var $71=$ix; //@line 1095 "synthesize.cpp"
                var $72=HEAP32[((__ZL10last_frame)>>2)]; //@line 1095 "synthesize.cpp"
                var $ffreq=(($72+2)&4294967295); //@line 1095 "synthesize.cpp"
                var $arrayidx106=(($ffreq+$71*2)&4294967295); //@line 1095 "synthesize.cpp"
                var $73=HEAP16[(($arrayidx106)>>1)]; //@line 1095 "synthesize.cpp"
                var $74=$ix; //@line 1095 "synthesize.cpp"
                var $75=$fr; //@line 1095 "synthesize.cpp"
                var $ffreq107=(($75+2)&4294967295); //@line 1095 "synthesize.cpp"
                var $arrayidx108=(($ffreq107+$74*2)&4294967295); //@line 1095 "synthesize.cpp"
                HEAP16[(($arrayidx108)>>1)]=$73; //@line 1095 "synthesize.cpp"
                ; //@line 1095 "synthesize.cpp"
              }
  
              var $76=$ix; //@line 1096 "synthesize.cpp"
              var $77=HEAP32[((__ZL10last_frame)>>2)]; //@line 1096 "synthesize.cpp"
              var $fheight=(($77+18)&4294967295); //@line 1096 "synthesize.cpp"
              var $arrayidx110=(($fheight+$76)&4294967295); //@line 1096 "synthesize.cpp"
              var $78=HEAP8[($arrayidx110)]; //@line 1096 "synthesize.cpp"
              var $79=$ix; //@line 1096 "synthesize.cpp"
              var $80=$fr; //@line 1096 "synthesize.cpp"
              var $fheight111=(($80+18)&4294967295); //@line 1096 "synthesize.cpp"
              var $arrayidx112=(($fheight111+$79)&4294967295); //@line 1096 "synthesize.cpp"
              HEAP8[($arrayidx112)]=$78; //@line 1096 "synthesize.cpp"
              var $81=$ix; //@line 1092 "synthesize.cpp"
              var $inc=((($81)+1)&4294967295); //@line 1092 "synthesize.cpp"
              $ix=$inc; //@line 1092 "synthesize.cpp"
              var $cmp103=((($inc))|0) < 8; //@line 1092 "synthesize.cpp"
              if ($cmp103) { __lastLabel__ = 41; __label__ = 39;continue ; } else { __lastLabel__ = 41; __label__ = 42;break ; } //@line 1092 "synthesize.cpp"
            }
  
            var $82=$fr; //@line 1098 "synthesize.cpp"
            var $83=($82); //@line 1098 "synthesize.cpp"
            var $84=HEAP32[((__ZL10last_wcmdq)>>2)]; //@line 1098 "synthesize.cpp"
            var $arrayidx113=((_wcmdq+$84*16)&4294967295); //@line 1098 "synthesize.cpp"
            var $arrayidx114=(($arrayidx113+12)&4294967295); //@line 1098 "synthesize.cpp"
            HEAP32[(($arrayidx114)>>2)]=$83; //@line 1098 "synthesize.cpp"
            ; //@line 1099 "synthesize.cpp"
          }
        } while(0);
  
        var $85=$this_ph_addr; //@line 1103 "synthesize.cpp"
        var $type118=(($85+11)&4294967295); //@line 1103 "synthesize.cpp"
        var $86=HEAPU8[($type118)]; //@line 1103 "synthesize.cpp"
        var $conv119=((($86))&255); //@line 1103 "synthesize.cpp"
        var $cmp120=((($conv119))|0)==2; //@line 1103 "synthesize.cpp"
        if ($cmp120) { __label__ = 44;; } else { __label__ = 46;; } //@line 1103 "synthesize.cpp"
        $land_lhs_true121$$if_end124$63: do { 
          if (__label__ == 44) {
  
            var $87=$which_addr; //@line 1103 "synthesize.cpp"
            var $cmp122=((($87))|0)==2; //@line 1103 "synthesize.cpp"
            if (!($cmp122)) { __label__ = 46;break $land_lhs_true121$$if_end124$63; } //@line 1103 "synthesize.cpp"
  
            __ZL11SmoothSpectv(); //@line 1105 "synthesize.cpp"
            var $88=HEAP32[((_wcmdq_tail)>>2)]; //@line 1108 "synthesize.cpp"
            HEAP32[((__ZL15syllable_centre)>>2)]=$88; //@line 1108 "synthesize.cpp"
            ; //@line 1109 "synthesize.cpp"
          }
        } while(0);
  
        $length_sum=0; //@line 1111 "synthesize.cpp"
        $frameix=1; //@line 1112 "synthesize.cpp"
        var $89=$frameix; //@line 1112 "synthesize.cpp"
        var $90=HEAP32[(($n_frames)>>2)]; //@line 1112 "synthesize.cpp"
        var $cmp1263=((($89))|0) < ((($90))|0); //@line 1112 "synthesize.cpp"
        if ($cmp1263) { __label__ = 47;; } else { __label__ = 56;; } //@line 1112 "synthesize.cpp"
        $for_body127$$if_end180$67: do { 
          if (__label__ == 47) {
            $for_body127$68: while(1) { 
  
              var $91=$length_mod; //@line 1114 "synthesize.cpp"
              $length_factor=$91; //@line 1114 "synthesize.cpp"
              var $92=$frameix; //@line 1115 "synthesize.cpp"
              var $sub=((($92)-1)&4294967295); //@line 1115 "synthesize.cpp"
              var $93=$frames; //@line 1115 "synthesize.cpp"
              var $arrayidx128=(($93+8*$sub)&4294967295); //@line 1115 "synthesize.cpp"
              var $frflags129=(($arrayidx128+2)&4294967295); //@line 1115 "synthesize.cpp"
              var $94=HEAP16[(($frflags129)>>1)]; //@line 1115 "synthesize.cpp"
              var $conv130=(tempInt=(($94)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1115 "synthesize.cpp"
              var $and131=($conv130) & 4; //@line 1115 "synthesize.cpp"
              var $tobool132=((($and131))|0)!=0; //@line 1115 "synthesize.cpp"
              if ($tobool132) { __label__ = 48;; } else { __label__ = 49;; } //@line 1115 "synthesize.cpp"
              $if_then133$$if_else138$70: do { 
                if (__label__ == 48) {
  
                  var $95=$length_mod; //@line 1117 "synthesize.cpp"
                  var $96=HEAP32[((((_speed+16)&4294967295))>>2)]; //@line 1117 "synthesize.cpp"
                  var $sub134=((256-($96))&4294967295); //@line 1117 "synthesize.cpp"
                  var $mul135=((($sub134)*($95))&4294967295); //@line 1117 "synthesize.cpp"
                  var $97=HEAP32[((((_speed+16)&4294967295))>>2)]; //@line 1117 "synthesize.cpp"
                  var $mul136=((($97)*256)&4294967295); //@line 1117 "synthesize.cpp"
                  var $add=((($mul135)+($mul136))&4294967295); //@line 1117 "synthesize.cpp"
                  var $div137=((((($add))|0)/256)|0); //@line 1117 "synthesize.cpp"
                  $length_factor=$div137; //@line 1117 "synthesize.cpp"
                  ; //@line 1118 "synthesize.cpp"
                }
                else if (__label__ == 49) {
  
                  var $98=$frameix; //@line 1120 "synthesize.cpp"
                  var $sub139=((($98)-1)&4294967295); //@line 1120 "synthesize.cpp"
                  var $99=$frames; //@line 1120 "synthesize.cpp"
                  var $arrayidx140=(($99+8*$sub139)&4294967295); //@line 1120 "synthesize.cpp"
                  var $frflags141=(($arrayidx140+2)&4294967295); //@line 1120 "synthesize.cpp"
                  var $100=HEAP16[(($frflags141)>>1)]; //@line 1120 "synthesize.cpp"
                  var $conv142=(tempInt=(($100)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1120 "synthesize.cpp"
                  var $and143=($conv142) & 16384; //@line 1120 "synthesize.cpp"
                  var $tobool144=((($and143))|0)!=0; //@line 1120 "synthesize.cpp"
                  if (!($tobool144)) { __label__ = 51;break $if_then133$$if_else138$70; } //@line 1120 "synthesize.cpp"
  
                  var $101=$length_mod; //@line 1122 "synthesize.cpp"
                  var $102=HEAP32[((((_speed+20)&4294967295))>>2)]; //@line 1122 "synthesize.cpp"
                  var $sub146=((256-($102))&4294967295); //@line 1122 "synthesize.cpp"
                  var $mul147=((($sub146)*($101))&4294967295); //@line 1122 "synthesize.cpp"
                  var $103=HEAP32[((((_speed+20)&4294967295))>>2)]; //@line 1122 "synthesize.cpp"
                  var $mul148=((($103)*256)&4294967295); //@line 1122 "synthesize.cpp"
                  var $add149=((($mul147)+($mul148))&4294967295); //@line 1122 "synthesize.cpp"
                  var $div150=((((($add149))|0)/256)|0); //@line 1122 "synthesize.cpp"
                  $length_factor=$div150; //@line 1122 "synthesize.cpp"
                  ; //@line 1123 "synthesize.cpp"
                }
              } while(0);
  
              var $104=$frameix; //@line 1125 "synthesize.cpp"
              var $sub153=((($104)-1)&4294967295); //@line 1125 "synthesize.cpp"
              var $105=$frames; //@line 1125 "synthesize.cpp"
              var $arrayidx154=(($105+8*$sub153)&4294967295); //@line 1125 "synthesize.cpp"
              var $length155=(($arrayidx154)&4294967295); //@line 1125 "synthesize.cpp"
              var $106=HEAP16[(($length155)>>1)]; //@line 1125 "synthesize.cpp"
              var $conv156=(tempInt=(($106)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1125 "synthesize.cpp"
              $frame_length=$conv156; //@line 1125 "synthesize.cpp"
              var $107=$frame_length; //@line 1126 "synthesize.cpp"
              var $108=HEAP32[((_samplerate)>>2)]; //@line 1126 "synthesize.cpp"
              var $mul157=((($108)*($107))&4294967295); //@line 1126 "synthesize.cpp"
              var $div158=((((($mul157))|0)/1000)|0); //@line 1126 "synthesize.cpp"
              $len=$div158; //@line 1126 "synthesize.cpp"
              var $109=$len; //@line 1127 "synthesize.cpp"
              var $110=$length_factor; //@line 1127 "synthesize.cpp"
              var $mul159=((($110)*($109))&4294967295); //@line 1127 "synthesize.cpp"
              var $div160=((((($mul159))|0)/256)|0); //@line 1127 "synthesize.cpp"
              $len=$div160; //@line 1127 "synthesize.cpp"
              var $111=$len; //@line 1128 "synthesize.cpp"
              var $112=$length_sum; //@line 1128 "synthesize.cpp"
              var $add161=((($112)+($111))&4294967295); //@line 1128 "synthesize.cpp"
              $length_sum=$add161; //@line 1128 "synthesize.cpp"
              var $113=$len; //@line 1129 "synthesize.cpp"
              var $114=$frameix; //@line 1129 "synthesize.cpp"
              var $arrayidx162=(($frame_lengths+$114*4)&4294967295); //@line 1129 "synthesize.cpp"
              HEAP32[(($arrayidx162)>>2)]=$113; //@line 1129 "synthesize.cpp"
              var $115=$frameix; //@line 1112 "synthesize.cpp"
              var $inc164=((($115)+1)&4294967295); //@line 1112 "synthesize.cpp"
              $frameix=$inc164; //@line 1112 "synthesize.cpp"
              var $116=$frameix; //@line 1112 "synthesize.cpp"
              var $117=HEAP32[(($n_frames)>>2)]; //@line 1112 "synthesize.cpp"
              var $cmp126=((($116))|0) < ((($117))|0); //@line 1112 "synthesize.cpp"
              if ($cmp126) { __label__ = 47;continue $for_body127$68; } else { __label__ = 52;break $for_body127$68; } //@line 1112 "synthesize.cpp"
            }
  
            var $_pr4=$length_sum; //@line 1132 "synthesize.cpp"
            var $cmp166=((($_pr4))|0) > 0; //@line 1132 "synthesize.cpp"
            if (!($cmp166)) { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1132 "synthesize.cpp"
  
            var $118=$length_sum; //@line 1132 "synthesize.cpp"
            var $119=$length_min; //@line 1132 "synthesize.cpp"
            var $cmp168=((($118))|0) < ((($119))|0); //@line 1132 "synthesize.cpp"
            if (!($cmp168)) { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1132 "synthesize.cpp"
  
            $frameix=1; //@line 1135 "synthesize.cpp"
            var $120=$frameix; //@line 1135 "synthesize.cpp"
            var $121=HEAP32[(($n_frames)>>2)]; //@line 1135 "synthesize.cpp"
            var $cmp1712=((($120))|0) < ((($121))|0); //@line 1135 "synthesize.cpp"
            if (!($cmp1712)) { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1135 "synthesize.cpp"
            while(1) { 
  
              var $122=$frameix; //@line 1137 "synthesize.cpp"
              var $arrayidx173=(($frame_lengths+$122*4)&4294967295); //@line 1137 "synthesize.cpp"
              var $123=HEAP32[(($arrayidx173)>>2)]; //@line 1137 "synthesize.cpp"
              var $124=$length_min; //@line 1137 "synthesize.cpp"
              var $mul174=((($124)*($123))&4294967295); //@line 1137 "synthesize.cpp"
              var $125=$length_sum; //@line 1137 "synthesize.cpp"
              var $div175=((((($mul174))|0)/((($125))|0))|0); //@line 1137 "synthesize.cpp"
              var $126=$frameix; //@line 1137 "synthesize.cpp"
              var $arrayidx176=(($frame_lengths+$126*4)&4294967295); //@line 1137 "synthesize.cpp"
              HEAP32[(($arrayidx176)>>2)]=$div175; //@line 1137 "synthesize.cpp"
              var $127=$frameix; //@line 1135 "synthesize.cpp"
              var $inc178=((($127)+1)&4294967295); //@line 1135 "synthesize.cpp"
              $frameix=$inc178; //@line 1135 "synthesize.cpp"
              var $128=$frameix; //@line 1135 "synthesize.cpp"
              var $129=HEAP32[(($n_frames)>>2)]; //@line 1135 "synthesize.cpp"
              var $cmp171=((($128))|0) < ((($129))|0); //@line 1135 "synthesize.cpp"
              if ($cmp171) { __label__ = 55;continue ; } else { __label__ = 56;break $for_body127$$if_end180$67; } //@line 1135 "synthesize.cpp"
            }
          }
        } while(0);
  
        $frameix=1; //@line 1141 "synthesize.cpp"
        var $130=$frameix; //@line 1141 "synthesize.cpp"
        var $131=HEAP32[(($n_frames)>>2)]; //@line 1141 "synthesize.cpp"
        var $cmp1821=((($130))|0) < ((($131))|0); //@line 1141 "synthesize.cpp"
        if ($cmp1821) { __label__ = 57;; } else { __label__ = 72;; } //@line 1141 "synthesize.cpp"
        $for_body183$$for_end235$81: do { 
          if (__label__ == 57) {
            $for_body183$82: while(1) { 
  
              var $132=$frameix; //@line 1143 "synthesize.cpp"
              var $133=$frames; //@line 1143 "synthesize.cpp"
              var $arrayidx184=(($133+8*$132)&4294967295); //@line 1143 "synthesize.cpp"
              var $frame185=(($arrayidx184+4)&4294967295); //@line 1143 "synthesize.cpp"
              var $134=HEAP32[(($frame185)>>2)]; //@line 1143 "synthesize.cpp"
              $frame2=$134; //@line 1143 "synthesize.cpp"
              var $135=$fmt_params_addr; //@line 1145 "synthesize.cpp"
              var $wav_addr186=(($135+28)&4294967295); //@line 1145 "synthesize.cpp"
              var $136=HEAP32[(($wav_addr186)>>2)]; //@line 1145 "synthesize.cpp"
              var $cmp187=((($136))|0)!=0; //@line 1145 "synthesize.cpp"
              if ($cmp187) { __label__ = 58;; } else { __label__ = 60;; } //@line 1145 "synthesize.cpp"
              $land_lhs_true188$$if_end198$84: do { 
                if (__label__ == 58) {
  
                  var $137=$frame1; //@line 1145 "synthesize.cpp"
                  var $frflags189=(($137)&4294967295); //@line 1145 "synthesize.cpp"
                  var $138=HEAP16[(($frflags189)>>1)]; //@line 1145 "synthesize.cpp"
                  var $conv190=(tempInt=(($138)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1145 "synthesize.cpp"
                  var $and191=($conv190) & 128; //@line 1145 "synthesize.cpp"
                  var $cmp192=((($and191))|0)==0; //@line 1145 "synthesize.cpp"
                  if (!($cmp192)) { __label__ = 60;break $land_lhs_true188$$if_end198$84; } //@line 1145 "synthesize.cpp"
  
                  HEAP32[((_seq_len_adjust)>>2)]=0; //@line 1148 "synthesize.cpp"
                  var $139=$fmt_params_addr; //@line 1149 "synthesize.cpp"
                  var $wav_addr194=(($139+28)&4294967295); //@line 1149 "synthesize.cpp"
                  var $140=HEAP32[(($wav_addr194)>>2)]; //@line 1149 "synthesize.cpp"
                  var $141=$which_addr; //@line 1149 "synthesize.cpp"
                  var $add195=((($141)+256)&4294967295); //@line 1149 "synthesize.cpp"
                  var $142=$fmt_params_addr; //@line 1149 "synthesize.cpp"
                  var $fmt_control=(($142)&4294967295); //@line 1149 "synthesize.cpp"
                  var $143=HEAP32[(($fmt_control)>>2)]; //@line 1149 "synthesize.cpp"
                  var $144=HEAP32[((_wavefile_amp)>>2)]; //@line 1149 "synthesize.cpp"
                  var $call196=__ZL9DoSample2iiiiii($140, $add195, 0, $143, 0, $144); //@line 1149 "synthesize.cpp"
                  HEAP8[(__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b)]=1;
                  HEAP32[((_wavefile_ix)>>2)]=0; //@line 1151 "synthesize.cpp"
                  var $145=$fmt_params_addr; //@line 1152 "synthesize.cpp"
                  var $wav_addr197=(($145+28)&4294967295); //@line 1152 "synthesize.cpp"
                  HEAP32[(($wav_addr197)>>2)]=0; //@line 1152 "synthesize.cpp"
                  ; //@line 1153 "synthesize.cpp"
                }
              } while(0);
  
              var $146=$modulation_addr; //@line 1155 "synthesize.cpp"
              var $cmp199=((($146))|0) >= 0; //@line 1155 "synthesize.cpp"
              if ($cmp199) { __label__ = 61;; } else { __label__ = 66;; } //@line 1155 "synthesize.cpp"
              $if_then200$$if_end214$88: do { 
                if (__label__ == 61) {
  
                  var $147=$frame1; //@line 1157 "synthesize.cpp"
                  var $frflags201=(($147)&4294967295); //@line 1157 "synthesize.cpp"
                  var $148=HEAP16[(($frflags201)>>1)]; //@line 1157 "synthesize.cpp"
                  var $conv202=(tempInt=(($148)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1157 "synthesize.cpp"
                  var $and203=($conv202) & 64; //@line 1157 "synthesize.cpp"
                  var $tobool204=((($and203))|0)!=0; //@line 1157 "synthesize.cpp"
                  if ($tobool204) { __label__ = 62;; } else { __label__ = 63;; } //@line 1157 "synthesize.cpp"
                  if (__label__ == 62) {
  
                    $modulation_addr=6; //@line 1159 "synthesize.cpp"
                    ; //@line 1160 "synthesize.cpp"
                  }
  
                  var $149=$frameix; //@line 1161 "synthesize.cpp"
                  var $150=HEAP32[(($n_frames)>>2)]; //@line 1161 "synthesize.cpp"
                  var $sub207=((($150)-1)&4294967295); //@line 1161 "synthesize.cpp"
                  var $cmp208=((($149))|0)==((($sub207))|0); //@line 1161 "synthesize.cpp"
                  if (!($cmp208)) { __label__ = 66;break $if_then200$$if_end214$88; } //@line 1161 "synthesize.cpp"
  
                  var $151=HEAP32[((__ZL10modn_flags)>>2)]; //@line 1161 "synthesize.cpp"
                  var $and210=($151) & 3840; //@line 1161 "synthesize.cpp"
                  var $tobool211=((($and210))|0)!=0; //@line 1161 "synthesize.cpp"
                  if (!($tobool211)) { __label__ = 66;break $if_then200$$if_end214$88; } //@line 1161 "synthesize.cpp"
  
                  var $152=HEAP32[((__ZL10modn_flags)>>2)]; //@line 1162 "synthesize.cpp"
                  var $153=$modulation_addr; //@line 1162 "synthesize.cpp"
                  var $or=($153) | ($152); //@line 1162 "synthesize.cpp"
                  $modulation_addr=$or; //@line 1162 "synthesize.cpp"
                  ; //@line 1162 "synthesize.cpp"
                }
              } while(0);
  
              var $154=$frameix; //@line 1165 "synthesize.cpp"
              var $arrayidx215=(($frame_lengths+$154*4)&4294967295); //@line 1165 "synthesize.cpp"
              var $155=HEAP32[(($arrayidx215)>>2)]; //@line 1165 "synthesize.cpp"
              $len=$155; //@line 1165 "synthesize.cpp"
              var $156=HEAP32[((__ZL12pitch_length)>>2)]; //@line 1166 "synthesize.cpp"
              var $add216=((($156)+($155))&4294967295); //@line 1166 "synthesize.cpp"
              HEAP32[((__ZL12pitch_length)>>2)]=$add216; //@line 1166 "synthesize.cpp"
              var $157=HEAP32[((__ZL10amp_length)>>2)]; //@line 1167 "synthesize.cpp"
              var $add217=((($157)+($155))&4294967295); //@line 1167 "synthesize.cpp"
              HEAP32[((__ZL10amp_length)>>2)]=$add217; //@line 1167 "synthesize.cpp"
              var $cmp218=((($155))|0)==0; //@line 1169 "synthesize.cpp"
              if ($cmp218) { __label__ = 67;; } else { __label__ = 68;; } //@line 1169 "synthesize.cpp"
              if (__label__ == 67) {
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1171 "synthesize.cpp"
                var $158=$frame2; //@line 1172 "synthesize.cpp"
                $frame1=$158; //@line 1172 "synthesize.cpp"
                ; //@line 1173 "synthesize.cpp"
              }
              else if (__label__ == 68) {
  
                var $159=HEAP32[((_wcmdq_tail)>>2)]; //@line 1176 "synthesize.cpp"
                HEAP32[((__ZL10last_wcmdq)>>2)]=$159; //@line 1176 "synthesize.cpp"
                var $160=$modulation_addr; //@line 1178 "synthesize.cpp"
                var $cmp221=((($160))|0) >= 0; //@line 1178 "synthesize.cpp"
                if ($cmp221) { __label__ = 69;; } else { __label__ = 70;; } //@line 1178 "synthesize.cpp"
                if (__label__ == 69) {
  
                  var $161=HEAP32[((_wcmdq_tail)>>2)]; //@line 1180 "synthesize.cpp"
                  var $arrayidx223=((_wcmdq+$161*16)&4294967295); //@line 1180 "synthesize.cpp"
                  var $arraydecay224=(($arrayidx223)&4294967295); //@line 1180 "synthesize.cpp"
                  $q=$arraydecay224; //@line 1180 "synthesize.cpp"
                  var $162=$wcmd_spect; //@line 1181 "synthesize.cpp"
                  var $163=$q; //@line 1181 "synthesize.cpp"
                  var $arrayidx225=(($163)&4294967295); //@line 1181 "synthesize.cpp"
                  HEAP32[(($arrayidx225)>>2)]=$162; //@line 1181 "synthesize.cpp"
                  var $164=$len; //@line 1182 "synthesize.cpp"
                  var $165=$modulation_addr; //@line 1182 "synthesize.cpp"
                  var $shl=((($165)*65536)&4294967295); //@line 1182 "synthesize.cpp"
                  var $add226=((($shl)+($164))&4294967295); //@line 1182 "synthesize.cpp"
                  var $166=$q; //@line 1182 "synthesize.cpp"
                  var $arrayidx227=(($166+4)&4294967295); //@line 1182 "synthesize.cpp"
                  HEAP32[(($arrayidx227)>>2)]=$add226; //@line 1182 "synthesize.cpp"
                  var $167=$frame1; //@line 1183 "synthesize.cpp"
                  var $168=($167); //@line 1183 "synthesize.cpp"
                  var $169=$q; //@line 1183 "synthesize.cpp"
                  var $arrayidx228=(($169+8)&4294967295); //@line 1183 "synthesize.cpp"
                  HEAP32[(($arrayidx228)>>2)]=$168; //@line 1183 "synthesize.cpp"
                  var $170=$frame2; //@line 1184 "synthesize.cpp"
                  var $171=($170); //@line 1184 "synthesize.cpp"
                  var $172=$q; //@line 1184 "synthesize.cpp"
                  var $arrayidx229=(($172+12)&4294967295); //@line 1184 "synthesize.cpp"
                  HEAP32[(($arrayidx229)>>2)]=$171; //@line 1184 "synthesize.cpp"
                  __Z8WcmdqIncv(); //@line 1186 "synthesize.cpp"
                  ; //@line 1187 "synthesize.cpp"
                }
  
                var $173=$frame2; //@line 1188 "synthesize.cpp"
                $frame1=$173; //@line 1188 "synthesize.cpp"
                HEAP32[((__ZL10last_frame)>>2)]=$173; //@line 1188 "synthesize.cpp"
                var $174=$len; //@line 1189 "synthesize.cpp"
                var $175=$total_len; //@line 1189 "synthesize.cpp"
                var $add231=((($175)+($174))&4294967295); //@line 1189 "synthesize.cpp"
                $total_len=$add231; //@line 1189 "synthesize.cpp"
                ;
              }
  
              var $176=$frameix; //@line 1141 "synthesize.cpp"
              var $inc234=((($176)+1)&4294967295); //@line 1141 "synthesize.cpp"
              $frameix=$inc234; //@line 1141 "synthesize.cpp"
              var $177=$frameix; //@line 1141 "synthesize.cpp"
              var $178=HEAP32[(($n_frames)>>2)]; //@line 1141 "synthesize.cpp"
              var $cmp182=((($177))|0) < ((($178))|0); //@line 1141 "synthesize.cpp"
              if ($cmp182) { __label__ = 57;continue $for_body183$82; } else { __label__ = 72;break $for_body183$$for_end235$81; } //@line 1141 "synthesize.cpp"
            }
          }
        } while(0);
  
        var $179=$which_addr; //@line 1193 "synthesize.cpp"
        var $cmp236=((($179))|0)!=1; //@line 1193 "synthesize.cpp"
        var $180=HEAP32[((__ZL13fmt_amplitude)>>2)]; //@line 1193 "synthesize.cpp"
        var $cmp238=((($180))|0)!=0; //@line 1193 "synthesize.cpp"
        var $or_cond=($cmp236) & ($cmp238); //@line 1193 "synthesize.cpp"
        if ($or_cond) { __label__ = 73;; } else { __label__ = 74;; } //@line 1193 "synthesize.cpp"
        if (__label__ == 73) {
  
          var $181=HEAP32[((_wcmdq_tail)>>2)]; //@line 1195 "synthesize.cpp"
          var $arrayidx240=((_wcmdq+$181*16)&4294967295); //@line 1195 "synthesize.cpp"
          var $arraydecay241=(($arrayidx240)&4294967295); //@line 1195 "synthesize.cpp"
          $q=$arraydecay241; //@line 1195 "synthesize.cpp"
          var $182=$q; //@line 1196 "synthesize.cpp"
          var $arrayidx242=(($182)&4294967295); //@line 1196 "synthesize.cpp"
          HEAP32[(($arrayidx242)>>2)]=14; //@line 1196 "synthesize.cpp"
          HEAP32[((__ZL13fmt_amplitude)>>2)]=0; //@line 1197 "synthesize.cpp"
          var $183=$q; //@line 1197 "synthesize.cpp"
          var $arrayidx243=(($183+4)&4294967295); //@line 1197 "synthesize.cpp"
          HEAP32[(($arrayidx243)>>2)]=0; //@line 1197 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1198 "synthesize.cpp"
          ; //@line 1199 "synthesize.cpp"
        }
  
        var $184=$total_len; //@line 1202 "synthesize.cpp"
        $retval=$184; //@line 1202 "synthesize.cpp"
        ; //@line 1202 "synthesize.cpp"
      }
    }
  
    var $185=$retval; //@line 1203 "synthesize.cpp"
    STACKTOP = __stackBase__;
    return $185; //@line 1203 "synthesize.cpp"
    return null;
  }
  

  function __ZL11SmoothSpectv() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $q;
    var $frame;
    var $frame2;
    var $frame1;
    var $frame_centre;
    var $ix;
    var $len;
    var $pk;
    var $modified;
    var $allowed;
    var $diff;
    var $f1;
    var $f2;
    var $f1142;
    var $f2143;
    var $0=HEAP32[((__ZL14syllable_start)>>2)]; //@line 790 "synthesize.cpp"
    var $1=HEAP32[((__ZL12syllable_end)>>2)]; //@line 790 "synthesize.cpp"
    var $cmp=((($0))|0)==((($1))|0); //@line 790 "synthesize.cpp"
    if ($cmp) { __label__ = 58;; } else { __label__ = 1;; } //@line 790 "synthesize.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $2=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 793 "synthesize.cpp"
        var $cmp1=((($2))|0) < 0; //@line 793 "synthesize.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 2;; } //@line 793 "synthesize.cpp"
        $if_then3$$lor_lhs_false$4: do { 
          if (__label__ == 2) {
  
            var $3=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 793 "synthesize.cpp"
            var $4=HEAP32[((__ZL14syllable_start)>>2)]; //@line 793 "synthesize.cpp"
            var $cmp2=((($3))|0)==((($4))|0); //@line 793 "synthesize.cpp"
            if ($cmp2) { __label__ = 3;break $if_then3$$lor_lhs_false$4; } //@line 793 "synthesize.cpp"
  
            var $6=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 799 "synthesize.cpp"
            var $arrayidx=((_wcmdq+$6*16)&4294967295); //@line 799 "synthesize.cpp"
            var $arraydecay=(($arrayidx)&4294967295); //@line 799 "synthesize.cpp"
            $q=$arraydecay; //@line 799 "synthesize.cpp"
            var $7=$q; //@line 800 "synthesize.cpp"
            var $arrayidx5=(($7+8)&4294967295); //@line 800 "synthesize.cpp"
            var $8=HEAP32[(($arrayidx5)>>2)]; //@line 800 "synthesize.cpp"
            var $9=($8); //@line 800 "synthesize.cpp"
            $frame_centre=$9; //@line 800 "synthesize.cpp"
            var $10=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 803 "synthesize.cpp"
            var $sub=((($10)-1)&4294967295); //@line 803 "synthesize.cpp"
            $ix=$sub; //@line 803 "synthesize.cpp"
            var $11=$frame_centre; //@line 804 "synthesize.cpp"
            $frame2=$11; //@line 804 "synthesize.cpp"
            $frame=$11; //@line 804 "synthesize.cpp"
            __lastLabel__ = 4; ; //@line 805 "synthesize.cpp"
            $for_cond$7: while(1) { 
  
              var $12=__lastLabel__ == 30 ? $dec : ($sub); //@line 807 "synthesize.cpp"
              var $cmp6=((($12))|0) < 0; //@line 807 "synthesize.cpp"
              if ($cmp6) { __label__ = 6;; } else { __label__ = 7;; } //@line 807 "synthesize.cpp"
              if (__label__ == 6) {
  
                $ix=159; //@line 807 "synthesize.cpp"
                ; //@line 807 "synthesize.cpp"
              }
  
              var $13=$ix; //@line 808 "synthesize.cpp"
              var $arrayidx9=((_wcmdq+$13*16)&4294967295); //@line 808 "synthesize.cpp"
              var $arraydecay10=(($arrayidx9)&4294967295); //@line 808 "synthesize.cpp"
              $q=$arraydecay10; //@line 808 "synthesize.cpp"
              var $14=$q; //@line 810 "synthesize.cpp"
              var $arrayidx11=(($14)&4294967295); //@line 810 "synthesize.cpp"
              var $15=HEAP32[(($arrayidx11)>>2)]; //@line 810 "synthesize.cpp"
              var $cmp12=((($15))|0)==5; //@line 810 "synthesize.cpp"
              if ($cmp12) { __label__ = 31;break $for_cond$7; } //@line 810 "synthesize.cpp"
  
              var $16=$q; //@line 810 "synthesize.cpp"
              var $arrayidx14=(($16)&4294967295); //@line 810 "synthesize.cpp"
              var $17=HEAP32[(($arrayidx14)>>2)]; //@line 810 "synthesize.cpp"
              var $cmp15=((($17))|0)==6; //@line 810 "synthesize.cpp"
              if ($cmp15) { __label__ = 31;break $for_cond$7; } //@line 810 "synthesize.cpp"
  
              var $18=$q; //@line 813 "synthesize.cpp"
              var $arrayidx18=(($18)&4294967295); //@line 813 "synthesize.cpp"
              var $19=HEAP32[(($arrayidx18)>>2)]; //@line 813 "synthesize.cpp"
              var $cmp19=((($19))|0) <= 4; //@line 813 "synthesize.cpp"
              if ($cmp19) { __label__ = 10;; } else { __label__ = 29;; } //@line 813 "synthesize.cpp"
              $if_then20$$if_end95$14: do { 
                if (__label__ == 10) {
  
                  var $20=$q; //@line 815 "synthesize.cpp"
                  var $arrayidx21=(($20+4)&4294967295); //@line 815 "synthesize.cpp"
                  var $21=HEAP32[(($arrayidx21)>>2)]; //@line 815 "synthesize.cpp"
                  var $and=($21) & 65535; //@line 815 "synthesize.cpp"
                  $len=$and; //@line 815 "synthesize.cpp"
                  var $22=$q; //@line 817 "synthesize.cpp"
                  var $arrayidx22=(($22+12)&4294967295); //@line 817 "synthesize.cpp"
                  var $23=HEAP32[(($arrayidx22)>>2)]; //@line 817 "synthesize.cpp"
                  var $24=($23); //@line 817 "synthesize.cpp"
                  $frame1=$24; //@line 817 "synthesize.cpp"
                  var $25=$frame1; //@line 818 "synthesize.cpp"
                  var $26=$frame; //@line 818 "synthesize.cpp"
                  var $cmp23=((($25))|0)==((($26))|0); //@line 818 "synthesize.cpp"
                  if (!($cmp23)) { __label__ = 31;break $for_cond$7; } //@line 818 "synthesize.cpp"
  
                  var $27=$frame2; //@line 820 "synthesize.cpp"
                  var $28=($27); //@line 820 "synthesize.cpp"
                  var $29=$q; //@line 820 "synthesize.cpp"
                  var $arrayidx25=(($29+12)&4294967295); //@line 820 "synthesize.cpp"
                  HEAP32[(($arrayidx25)>>2)]=$28; //@line 820 "synthesize.cpp"
                  var $30=$frame2; //@line 821 "synthesize.cpp"
                  $frame1=$30; //@line 821 "synthesize.cpp"
                  var $31=$q; //@line 826 "synthesize.cpp"
                  var $arrayidx27=(($31+8)&4294967295); //@line 826 "synthesize.cpp"
                  var $32=HEAP32[(($arrayidx27)>>2)]; //@line 826 "synthesize.cpp"
                  var $33=($32); //@line 826 "synthesize.cpp"
                  $frame2=$33; //@line 826 "synthesize.cpp"
                  $frame=$33; //@line 826 "synthesize.cpp"
                  $modified=0; //@line 827 "synthesize.cpp"
                  var $34=$frame; //@line 829 "synthesize.cpp"
                  var $frflags=(($34)&4294967295); //@line 829 "synthesize.cpp"
                  var $35=HEAP16[(($frflags)>>1)]; //@line 829 "synthesize.cpp"
                  var $conv=(tempInt=(($35)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 829 "synthesize.cpp"
                  var $and28=($conv) & 16; //@line 829 "synthesize.cpp"
                  var $tobool=((($and28))|0)!=0; //@line 829 "synthesize.cpp"
                  if ($tobool) { __label__ = 31;break $for_cond$7; } //@line 829 "synthesize.cpp"
  
                  var $36=$frame; //@line 832 "synthesize.cpp"
                  var $frflags31=(($36)&4294967295); //@line 832 "synthesize.cpp"
                  var $37=HEAP16[(($frflags31)>>1)]; //@line 832 "synthesize.cpp"
                  var $conv32=(tempInt=(($37)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 832 "synthesize.cpp"
                  var $and33=($conv32) & 32; //@line 832 "synthesize.cpp"
                  var $tobool34=((($and33))|0)!=0; //@line 832 "synthesize.cpp"
                  if ($tobool34) { __label__ = 13;; } else { __label__ = 14;; } //@line 832 "synthesize.cpp"
                  if (__label__ == 13) {
  
                    var $38=$len; //@line 833 "synthesize.cpp"
                    var $mul=((($38)*12)&4294967295); //@line 833 "synthesize.cpp"
                    var $div=((((($mul))|0)/10)|0); //@line 833 "synthesize.cpp"
                    $len=$div; //@line 833 "synthesize.cpp"
                    ; //@line 833 "synthesize.cpp"
                  }
  
                  $pk=0; //@line 835 "synthesize.cpp"
                  ; //@line 835 "synthesize.cpp"
                  $for_body$21: while(1) { 
  
                    var $39=$frame; //@line 839 "synthesize.cpp"
                    var $frflags39=(($39)&4294967295); //@line 839 "synthesize.cpp"
                    var $40=HEAP16[(($frflags39)>>1)]; //@line 839 "synthesize.cpp"
                    var $conv40=(tempInt=(($40)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 839 "synthesize.cpp"
                    var $and41=($conv40) & 8; //@line 839 "synthesize.cpp"
                    var $tobool42=((($and41))|0)!=0; //@line 839 "synthesize.cpp"
                    if ($tobool42) { __label__ = 16;; } else { __label__ = 17;; } //@line 839 "synthesize.cpp"
                    $land_lhs_true$$if_end45$23: do { 
                      if (__label__ == 16) {
  
                        var $41=$pk; //@line 839 "synthesize.cpp"
                        var $cmp43=((($41))|0) < 3; //@line 839 "synthesize.cpp"
                        if ($cmp43) { __label__ = 28;break $land_lhs_true$$if_end45$23; } else { __label__ = 17;break $land_lhs_true$$if_end45$23; } //@line 839 "synthesize.cpp"
                      }
                    } while(0);
                    $for_inc$$if_end45$25: do { 
                      if (__label__ == 17) {
  
                        var $42=$pk; //@line 842 "synthesize.cpp"
                        var $43=$frame1; //@line 842 "synthesize.cpp"
                        var $ffreq=(($43+2)&4294967295); //@line 842 "synthesize.cpp"
                        var $arrayidx46=(($ffreq+$42*2)&4294967295); //@line 842 "synthesize.cpp"
                        var $44=HEAP16[(($arrayidx46)>>1)]; //@line 842 "synthesize.cpp"
                        var $conv47=(tempInt=(($44)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 842 "synthesize.cpp"
                        $f1=$conv47; //@line 842 "synthesize.cpp"
                        var $45=$pk; //@line 843 "synthesize.cpp"
                        var $46=$frame; //@line 843 "synthesize.cpp"
                        var $ffreq48=(($46+2)&4294967295); //@line 843 "synthesize.cpp"
                        var $arrayidx49=(($ffreq48+$45*2)&4294967295); //@line 843 "synthesize.cpp"
                        var $47=HEAP16[(($arrayidx49)>>1)]; //@line 843 "synthesize.cpp"
                        var $conv50=(tempInt=(($47)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 843 "synthesize.cpp"
                        $f2=$conv50; //@line 843 "synthesize.cpp"
                        var $48=$f2; //@line 846 "synthesize.cpp"
                        var $49=$f1; //@line 846 "synthesize.cpp"
                        var $sub51=((($48)-($49))&4294967295); //@line 846 "synthesize.cpp"
                        $diff=$sub51; //@line 846 "synthesize.cpp"
                        var $cmp52=((($sub51))|0) > 0; //@line 846 "synthesize.cpp"
                        var $50=$f1; //@line 848 "synthesize.cpp"
                        if ($cmp52) { __label__ = 18;; } else { __label__ = 19;; } //@line 846 "synthesize.cpp"
                        if (__label__ == 18) {
  
                          var $mul54=((($50)*2)&4294967295); //@line 848 "synthesize.cpp"
                          var $51=$f2; //@line 848 "synthesize.cpp"
                          var $add=((($51)+($mul54))&4294967295); //@line 848 "synthesize.cpp"
                          $allowed=$add; //@line 848 "synthesize.cpp"
                          ; //@line 849 "synthesize.cpp"
                        }
                        else if (__label__ == 19) {
  
                          var $52=$f2; //@line 852 "synthesize.cpp"
                          var $mul56=((($52)*2)&4294967295); //@line 852 "synthesize.cpp"
                          var $add57=((($mul56)+($50))&4294967295); //@line 852 "synthesize.cpp"
                          $allowed=$add57; //@line 852 "synthesize.cpp"
                          ;
                        }
  
                        var $53=$allowed; //@line 857 "synthesize.cpp"
                        var $54=$pk; //@line 857 "synthesize.cpp"
                        var $arrayidx59=((_formant_rate+$54*4)&4294967295); //@line 857 "synthesize.cpp"
                        var $55=HEAP32[(($arrayidx59)>>2)]; //@line 857 "synthesize.cpp"
                        var $mul60=((($55)*($53))&4294967295); //@line 857 "synthesize.cpp"
                        var $div61=((((($mul60))|0)/3000)|0); //@line 857 "synthesize.cpp"
                        $allowed=$div61; //@line 857 "synthesize.cpp"
                        var $56=$allowed; //@line 858 "synthesize.cpp"
                        var $57=$len; //@line 858 "synthesize.cpp"
                        var $mul62=((($57)*($56))&4294967295); //@line 858 "synthesize.cpp"
                        var $div63=((((($mul62))|0)/256)|0); //@line 858 "synthesize.cpp"
                        $allowed=$div63; //@line 858 "synthesize.cpp"
                        var $58=$diff; //@line 860 "synthesize.cpp"
                        var $59=$allowed; //@line 860 "synthesize.cpp"
                        var $cmp64=((($58))|0) > ((($59))|0); //@line 860 "synthesize.cpp"
                        if ($cmp64) { __label__ = 21;; } else { __label__ = 24;; } //@line 860 "synthesize.cpp"
                        if (__label__ == 21) {
  
                          var $60=$modified; //@line 862 "synthesize.cpp"
                          var $cmp66=((($60))|0)==0; //@line 862 "synthesize.cpp"
                          if ($cmp66) { __label__ = 22;; } else { __label__ = 23;; } //@line 862 "synthesize.cpp"
                          if (__label__ == 22) {
  
                            var $61=$frame; //@line 864 "synthesize.cpp"
                            var $call=__ZL9CopyFrameP7frame_ti($61, 0); //@line 864 "synthesize.cpp"
                            $frame2=$call; //@line 864 "synthesize.cpp"
                            $modified=1; //@line 865 "synthesize.cpp"
                            ; //@line 866 "synthesize.cpp"
                          }
  
                          var $62=$pk; //@line 867 "synthesize.cpp"
                          var $63=$frame1; //@line 867 "synthesize.cpp"
                          var $ffreq69=(($63+2)&4294967295); //@line 867 "synthesize.cpp"
                          var $arrayidx70=(($ffreq69+$62*2)&4294967295); //@line 867 "synthesize.cpp"
                          var $64=HEAP16[(($arrayidx70)>>1)]; //@line 867 "synthesize.cpp"
                          var $conv71=(tempInt=(($64)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 867 "synthesize.cpp"
                          var $65=$allowed; //@line 867 "synthesize.cpp"
                          var $add72=((($conv71)+($65))&4294967295); //@line 867 "synthesize.cpp"
                          var $conv73=((($add72)) & 65535); //@line 867 "synthesize.cpp"
                          var $66=$pk; //@line 867 "synthesize.cpp"
                          var $67=$frame2; //@line 867 "synthesize.cpp"
                          var $ffreq74=(($67+2)&4294967295); //@line 867 "synthesize.cpp"
                          var $arrayidx75=(($ffreq74+$66*2)&4294967295); //@line 867 "synthesize.cpp"
                          HEAP16[(($arrayidx75)>>1)]=$conv73; //@line 867 "synthesize.cpp"
                          var $68=$frame2; //@line 868 "synthesize.cpp"
                          var $69=($68); //@line 868 "synthesize.cpp"
                          var $70=$q; //@line 868 "synthesize.cpp"
                          var $arrayidx76=(($70+8)&4294967295); //@line 868 "synthesize.cpp"
                          HEAP32[(($arrayidx76)>>2)]=$69; //@line 868 "synthesize.cpp"
                          ; //@line 869 "synthesize.cpp"
                        }
                        else if (__label__ == 24) {
  
                          var $71=$diff; //@line 871 "synthesize.cpp"
                          var $72=$allowed; //@line 871 "synthesize.cpp"
                          var $sub78=(((-($72)))&4294967295); //@line 871 "synthesize.cpp"
                          var $cmp79=((($71))|0) < ((($sub78))|0); //@line 871 "synthesize.cpp"
                          if (!($cmp79)) { __label__ = 28;break $for_inc$$if_end45$25; } //@line 871 "synthesize.cpp"
  
                          var $73=$modified; //@line 873 "synthesize.cpp"
                          var $cmp81=((($73))|0)==0; //@line 873 "synthesize.cpp"
                          if ($cmp81) { __label__ = 26;; } else { __label__ = 27;; } //@line 873 "synthesize.cpp"
                          if (__label__ == 26) {
  
                            var $74=$frame; //@line 875 "synthesize.cpp"
                            var $call83=__ZL9CopyFrameP7frame_ti($74, 0); //@line 875 "synthesize.cpp"
                            $frame2=$call83; //@line 875 "synthesize.cpp"
                            $modified=1; //@line 876 "synthesize.cpp"
                            ; //@line 877 "synthesize.cpp"
                          }
  
                          var $75=$pk; //@line 878 "synthesize.cpp"
                          var $76=$frame1; //@line 878 "synthesize.cpp"
                          var $ffreq85=(($76+2)&4294967295); //@line 878 "synthesize.cpp"
                          var $arrayidx86=(($ffreq85+$75*2)&4294967295); //@line 878 "synthesize.cpp"
                          var $77=HEAP16[(($arrayidx86)>>1)]; //@line 878 "synthesize.cpp"
                          var $conv87=(tempInt=(($77)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 878 "synthesize.cpp"
                          var $78=$allowed; //@line 878 "synthesize.cpp"
                          var $sub88=((($conv87)-($78))&4294967295); //@line 878 "synthesize.cpp"
                          var $conv89=((($sub88)) & 65535); //@line 878 "synthesize.cpp"
                          var $79=$pk; //@line 878 "synthesize.cpp"
                          var $80=$frame2; //@line 878 "synthesize.cpp"
                          var $ffreq90=(($80+2)&4294967295); //@line 878 "synthesize.cpp"
                          var $arrayidx91=(($ffreq90+$79*2)&4294967295); //@line 878 "synthesize.cpp"
                          HEAP16[(($arrayidx91)>>1)]=$conv89; //@line 878 "synthesize.cpp"
                          var $81=$frame2; //@line 879 "synthesize.cpp"
                          var $82=($81); //@line 879 "synthesize.cpp"
                          var $83=$q; //@line 879 "synthesize.cpp"
                          var $arrayidx92=(($83+8)&4294967295); //@line 879 "synthesize.cpp"
                          HEAP32[(($arrayidx92)>>2)]=$82; //@line 879 "synthesize.cpp"
                          ; //@line 880 "synthesize.cpp"
                        }
                      }
                    } while(0);
  
                    var $84=$pk; //@line 835 "synthesize.cpp"
                    var $inc=((($84)+1)&4294967295); //@line 835 "synthesize.cpp"
                    $pk=$inc; //@line 835 "synthesize.cpp"
                    var $cmp38=((($inc))|0) < 6; //@line 835 "synthesize.cpp"
                    if ($cmp38) { __label__ = 15;continue $for_body$21; } else { __label__ = 29;break $if_then20$$if_end95$14; } //@line 835 "synthesize.cpp"
                  }
                }
              } while(0);
  
              var $85=$ix; //@line 884 "synthesize.cpp"
              var $86=HEAP32[((__ZL14syllable_start)>>2)]; //@line 884 "synthesize.cpp"
              var $cmp96=((($85))|0)==((($86))|0); //@line 884 "synthesize.cpp"
              if ($cmp96) { __label__ = 31;break $for_cond$7; } //@line 884 "synthesize.cpp"
  
              var $87=$ix; //@line 886 "synthesize.cpp"
              var $dec=((($87)-1)&4294967295); //@line 886 "synthesize.cpp"
              $ix=$dec; //@line 886 "synthesize.cpp"
              __lastLabel__ = 30; __label__ = 5;continue $for_cond$7; //@line 887 "synthesize.cpp"
            }
  
            var $88=HEAP32[((__ZL15syllable_centre)>>2)]; //@line 890 "synthesize.cpp"
            $ix=$88; //@line 890 "synthesize.cpp"
            $frame=0; //@line 892 "synthesize.cpp"
            ; //@line 893 "synthesize.cpp"
            $for_cond100$45: while(1) { 
  
              var $89=$ix; //@line 895 "synthesize.cpp"
              var $arrayidx101=((_wcmdq+$89*16)&4294967295); //@line 895 "synthesize.cpp"
              var $arraydecay102=(($arrayidx101)&4294967295); //@line 895 "synthesize.cpp"
              $q=$arraydecay102; //@line 895 "synthesize.cpp"
              var $90=$q; //@line 897 "synthesize.cpp"
              var $arrayidx103=(($90)&4294967295); //@line 897 "synthesize.cpp"
              var $91=HEAP32[(($arrayidx103)>>2)]; //@line 897 "synthesize.cpp"
              var $cmp104=((($91))|0)==5; //@line 897 "synthesize.cpp"
              if ($cmp104) { __label__ = 57;break $for_cond100$45; } //@line 897 "synthesize.cpp"
  
              var $92=$q; //@line 897 "synthesize.cpp"
              var $arrayidx106=(($92)&4294967295); //@line 897 "synthesize.cpp"
              var $93=HEAP32[(($arrayidx106)>>2)]; //@line 897 "synthesize.cpp"
              var $cmp107=((($93))|0)==6; //@line 897 "synthesize.cpp"
              if ($cmp107) { __label__ = 57;break $for_cond100$45; } //@line 897 "synthesize.cpp"
  
              var $94=$q; //@line 900 "synthesize.cpp"
              var $arrayidx110=(($94)&4294967295); //@line 900 "synthesize.cpp"
              var $95=HEAP32[(($arrayidx110)>>2)]; //@line 900 "synthesize.cpp"
              var $cmp111=((($95))|0) <= 4; //@line 900 "synthesize.cpp"
              if ($cmp111) { __label__ = 35;; } else { __label__ = 54;; } //@line 900 "synthesize.cpp"
              $if_then112$$if_end199$49: do { 
                if (__label__ == 35) {
  
                  var $96=$q; //@line 903 "synthesize.cpp"
                  var $arrayidx113=(($96+4)&4294967295); //@line 903 "synthesize.cpp"
                  var $97=HEAP32[(($arrayidx113)>>2)]; //@line 903 "synthesize.cpp"
                  var $and114=($97) & 65535; //@line 903 "synthesize.cpp"
                  $len=$and114; //@line 903 "synthesize.cpp"
                  var $98=$q; //@line 905 "synthesize.cpp"
                  var $arrayidx115=(($98+8)&4294967295); //@line 905 "synthesize.cpp"
                  var $99=HEAP32[(($arrayidx115)>>2)]; //@line 905 "synthesize.cpp"
                  var $100=($99); //@line 905 "synthesize.cpp"
                  $frame1=$100; //@line 905 "synthesize.cpp"
                  var $101=$frame; //@line 906 "synthesize.cpp"
                  var $cmp116=((($101))|0)!=0; //@line 906 "synthesize.cpp"
                  if ($cmp116) { __label__ = 36;; } else { __label__ = 38;; } //@line 906 "synthesize.cpp"
                  if (__label__ == 36) {
  
                    var $102=$frame1; //@line 908 "synthesize.cpp"
                    var $103=$frame; //@line 908 "synthesize.cpp"
                    var $cmp118=((($102))|0)==((($103))|0); //@line 908 "synthesize.cpp"
                    if (!($cmp118)) { __label__ = 57;break $for_cond100$45; } //@line 908 "synthesize.cpp"
  
                    var $104=$frame2; //@line 910 "synthesize.cpp"
                    var $105=($104); //@line 910 "synthesize.cpp"
                    var $106=$q; //@line 910 "synthesize.cpp"
                    var $arrayidx120=(($106+8)&4294967295); //@line 910 "synthesize.cpp"
                    HEAP32[(($arrayidx120)>>2)]=$105; //@line 910 "synthesize.cpp"
                    var $107=$frame2; //@line 911 "synthesize.cpp"
                    $frame1=$107; //@line 911 "synthesize.cpp"
                    ; //@line 915 "synthesize.cpp"
                  }
  
                  var $108=$q; //@line 917 "synthesize.cpp"
                  var $arrayidx124=(($108+12)&4294967295); //@line 917 "synthesize.cpp"
                  var $109=HEAP32[(($arrayidx124)>>2)]; //@line 917 "synthesize.cpp"
                  var $110=($109); //@line 917 "synthesize.cpp"
                  $frame2=$110; //@line 917 "synthesize.cpp"
                  $frame=$110; //@line 917 "synthesize.cpp"
                  $modified=0; //@line 918 "synthesize.cpp"
                  var $111=$frame1; //@line 920 "synthesize.cpp"
                  var $frflags125=(($111)&4294967295); //@line 920 "synthesize.cpp"
                  var $112=HEAP16[(($frflags125)>>1)]; //@line 920 "synthesize.cpp"
                  var $conv126=(tempInt=(($112)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 920 "synthesize.cpp"
                  var $and127=($conv126) & 16; //@line 920 "synthesize.cpp"
                  var $tobool128=((($and127))|0)!=0; //@line 920 "synthesize.cpp"
                  if ($tobool128) { __label__ = 57;break $for_cond100$45; } //@line 920 "synthesize.cpp"
  
                  var $113=$frame1; //@line 923 "synthesize.cpp"
                  var $frflags131=(($113)&4294967295); //@line 923 "synthesize.cpp"
                  var $114=HEAP16[(($frflags131)>>1)]; //@line 923 "synthesize.cpp"
                  var $conv132=(tempInt=(($114)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 923 "synthesize.cpp"
                  var $and133=($conv132) & 32; //@line 923 "synthesize.cpp"
                  var $tobool134=((($and133))|0)!=0; //@line 923 "synthesize.cpp"
                  if ($tobool134) { __label__ = 40;; } else { __label__ = 41;; } //@line 923 "synthesize.cpp"
                  if (__label__ == 40) {
  
                    var $115=$len; //@line 924 "synthesize.cpp"
                    var $mul136=((($115)*6)&4294967295); //@line 924 "synthesize.cpp"
                    var $div137=((((($mul136))|0)/5)|0); //@line 924 "synthesize.cpp"
                    $len=$div137; //@line 924 "synthesize.cpp"
                    ; //@line 924 "synthesize.cpp"
                  }
  
                  $pk=0; //@line 926 "synthesize.cpp"
                  ; //@line 926 "synthesize.cpp"
                  $for_body141$59: while(1) { 
  
                    var $116=$pk; //@line 929 "synthesize.cpp"
                    var $117=$frame1; //@line 929 "synthesize.cpp"
                    var $ffreq144=(($117+2)&4294967295); //@line 929 "synthesize.cpp"
                    var $arrayidx145=(($ffreq144+$116*2)&4294967295); //@line 929 "synthesize.cpp"
                    var $118=HEAP16[(($arrayidx145)>>1)]; //@line 929 "synthesize.cpp"
                    var $conv146=(tempInt=(($118)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 929 "synthesize.cpp"
                    $f1142=$conv146; //@line 929 "synthesize.cpp"
                    var $119=$pk; //@line 930 "synthesize.cpp"
                    var $120=$frame; //@line 930 "synthesize.cpp"
                    var $ffreq147=(($120+2)&4294967295); //@line 930 "synthesize.cpp"
                    var $arrayidx148=(($ffreq147+$119*2)&4294967295); //@line 930 "synthesize.cpp"
                    var $121=HEAP16[(($arrayidx148)>>1)]; //@line 930 "synthesize.cpp"
                    var $conv149=(tempInt=(($121)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 930 "synthesize.cpp"
                    $f2143=$conv149; //@line 930 "synthesize.cpp"
                    var $122=$f2143; //@line 933 "synthesize.cpp"
                    var $123=$f1142; //@line 933 "synthesize.cpp"
                    var $sub150=((($122)-($123))&4294967295); //@line 933 "synthesize.cpp"
                    $diff=$sub150; //@line 933 "synthesize.cpp"
                    var $cmp151=((($sub150))|0) > 0; //@line 933 "synthesize.cpp"
                    var $124=$f1142; //@line 935 "synthesize.cpp"
                    if ($cmp151) { __label__ = 43;; } else { __label__ = 44;; } //@line 933 "synthesize.cpp"
                    if (__label__ == 43) {
  
                      var $mul153=((($124)*2)&4294967295); //@line 935 "synthesize.cpp"
                      var $125=$f2143; //@line 935 "synthesize.cpp"
                      var $add154=((($125)+($mul153))&4294967295); //@line 935 "synthesize.cpp"
                      $allowed=$add154; //@line 935 "synthesize.cpp"
                      ; //@line 936 "synthesize.cpp"
                    }
                    else if (__label__ == 44) {
  
                      var $126=$f2143; //@line 939 "synthesize.cpp"
                      var $mul156=((($126)*2)&4294967295); //@line 939 "synthesize.cpp"
                      var $add157=((($mul156)+($124))&4294967295); //@line 939 "synthesize.cpp"
                      $allowed=$add157; //@line 939 "synthesize.cpp"
                      ;
                    }
  
                    var $127=$allowed; //@line 941 "synthesize.cpp"
                    var $128=$pk; //@line 941 "synthesize.cpp"
                    var $arrayidx159=((_formant_rate+$128*4)&4294967295); //@line 941 "synthesize.cpp"
                    var $129=HEAP32[(($arrayidx159)>>2)]; //@line 941 "synthesize.cpp"
                    var $mul160=((($129)*($127))&4294967295); //@line 941 "synthesize.cpp"
                    var $div161=((((($mul160))|0)/3000)|0); //@line 941 "synthesize.cpp"
                    $allowed=$div161; //@line 941 "synthesize.cpp"
                    var $130=$allowed; //@line 942 "synthesize.cpp"
                    var $131=$len; //@line 942 "synthesize.cpp"
                    var $mul162=((($131)*($130))&4294967295); //@line 942 "synthesize.cpp"
                    var $div163=((((($mul162))|0)/256)|0); //@line 942 "synthesize.cpp"
                    $allowed=$div163; //@line 942 "synthesize.cpp"
                    var $132=$diff; //@line 944 "synthesize.cpp"
                    var $133=$allowed; //@line 944 "synthesize.cpp"
                    var $cmp164=((($132))|0) > ((($133))|0); //@line 944 "synthesize.cpp"
                    if ($cmp164) { __label__ = 46;; } else { __label__ = 49;; } //@line 944 "synthesize.cpp"
                    $if_then165$$if_else178$65: do { 
                      if (__label__ == 46) {
  
                        var $134=$modified; //@line 946 "synthesize.cpp"
                        var $cmp166=((($134))|0)==0; //@line 946 "synthesize.cpp"
                        if ($cmp166) { __label__ = 47;; } else { __label__ = 48;; } //@line 946 "synthesize.cpp"
                        if (__label__ == 47) {
  
                          var $135=$frame; //@line 948 "synthesize.cpp"
                          var $call168=__ZL9CopyFrameP7frame_ti($135, 0); //@line 948 "synthesize.cpp"
                          $frame2=$call168; //@line 948 "synthesize.cpp"
                          $modified=1; //@line 949 "synthesize.cpp"
                          ; //@line 950 "synthesize.cpp"
                        }
  
                        var $136=$pk; //@line 951 "synthesize.cpp"
                        var $137=$frame1; //@line 951 "synthesize.cpp"
                        var $ffreq170=(($137+2)&4294967295); //@line 951 "synthesize.cpp"
                        var $arrayidx171=(($ffreq170+$136*2)&4294967295); //@line 951 "synthesize.cpp"
                        var $138=HEAP16[(($arrayidx171)>>1)]; //@line 951 "synthesize.cpp"
                        var $conv172=(tempInt=(($138)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 951 "synthesize.cpp"
                        var $139=$allowed; //@line 951 "synthesize.cpp"
                        var $add173=((($conv172)+($139))&4294967295); //@line 951 "synthesize.cpp"
                        var $conv174=((($add173)) & 65535); //@line 951 "synthesize.cpp"
                        var $140=$pk; //@line 951 "synthesize.cpp"
                        var $141=$frame2; //@line 951 "synthesize.cpp"
                        var $ffreq175=(($141+2)&4294967295); //@line 951 "synthesize.cpp"
                        var $arrayidx176=(($ffreq175+$140*2)&4294967295); //@line 951 "synthesize.cpp"
                        HEAP16[(($arrayidx176)>>1)]=$conv174; //@line 951 "synthesize.cpp"
                        var $142=$frame2; //@line 952 "synthesize.cpp"
                        var $143=($142); //@line 952 "synthesize.cpp"
                        var $144=$q; //@line 952 "synthesize.cpp"
                        var $arrayidx177=(($144+12)&4294967295); //@line 952 "synthesize.cpp"
                        HEAP32[(($arrayidx177)>>2)]=$143; //@line 952 "synthesize.cpp"
                        ; //@line 953 "synthesize.cpp"
                      }
                      else if (__label__ == 49) {
  
                        var $145=$diff; //@line 955 "synthesize.cpp"
                        var $146=$allowed; //@line 955 "synthesize.cpp"
                        var $sub179=(((-($146)))&4294967295); //@line 955 "synthesize.cpp"
                        var $cmp180=((($145))|0) < ((($sub179))|0); //@line 955 "synthesize.cpp"
                        if (!($cmp180)) { __label__ = 53;break $if_then165$$if_else178$65; } //@line 955 "synthesize.cpp"
  
                        var $147=$modified; //@line 957 "synthesize.cpp"
                        var $cmp182=((($147))|0)==0; //@line 957 "synthesize.cpp"
                        if ($cmp182) { __label__ = 51;; } else { __label__ = 52;; } //@line 957 "synthesize.cpp"
                        if (__label__ == 51) {
  
                          var $148=$frame; //@line 959 "synthesize.cpp"
                          var $call184=__ZL9CopyFrameP7frame_ti($148, 0); //@line 959 "synthesize.cpp"
                          $frame2=$call184; //@line 959 "synthesize.cpp"
                          $modified=1; //@line 960 "synthesize.cpp"
                          ; //@line 961 "synthesize.cpp"
                        }
  
                        var $149=$pk; //@line 962 "synthesize.cpp"
                        var $150=$frame1; //@line 962 "synthesize.cpp"
                        var $ffreq186=(($150+2)&4294967295); //@line 962 "synthesize.cpp"
                        var $arrayidx187=(($ffreq186+$149*2)&4294967295); //@line 962 "synthesize.cpp"
                        var $151=HEAP16[(($arrayidx187)>>1)]; //@line 962 "synthesize.cpp"
                        var $conv188=(tempInt=(($151)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 962 "synthesize.cpp"
                        var $152=$allowed; //@line 962 "synthesize.cpp"
                        var $sub189=((($conv188)-($152))&4294967295); //@line 962 "synthesize.cpp"
                        var $conv190=((($sub189)) & 65535); //@line 962 "synthesize.cpp"
                        var $153=$pk; //@line 962 "synthesize.cpp"
                        var $154=$frame2; //@line 962 "synthesize.cpp"
                        var $ffreq191=(($154+2)&4294967295); //@line 962 "synthesize.cpp"
                        var $arrayidx192=(($ffreq191+$153*2)&4294967295); //@line 962 "synthesize.cpp"
                        HEAP16[(($arrayidx192)>>1)]=$conv190; //@line 962 "synthesize.cpp"
                        var $155=$frame2; //@line 963 "synthesize.cpp"
                        var $156=($155); //@line 963 "synthesize.cpp"
                        var $157=$q; //@line 963 "synthesize.cpp"
                        var $arrayidx193=(($157+12)&4294967295); //@line 963 "synthesize.cpp"
                        HEAP32[(($arrayidx193)>>2)]=$156; //@line 963 "synthesize.cpp"
                        ; //@line 964 "synthesize.cpp"
                      }
                    } while(0);
  
                    var $158=$pk; //@line 926 "synthesize.cpp"
                    var $inc197=((($158)+1)&4294967295); //@line 926 "synthesize.cpp"
                    $pk=$inc197; //@line 926 "synthesize.cpp"
                    var $cmp140=((($inc197))|0) < 6; //@line 926 "synthesize.cpp"
                    if ($cmp140) { __label__ = 42;continue $for_body141$59; } else { __label__ = 54;break $if_then112$$if_end199$49; } //@line 926 "synthesize.cpp"
                  }
                }
              } while(0);
  
              var $159=$ix; //@line 968 "synthesize.cpp"
              var $inc200=((($159)+1)&4294967295); //@line 968 "synthesize.cpp"
              $ix=$inc200; //@line 968 "synthesize.cpp"
              var $cmp201=((($inc200))|0) >= 160; //@line 969 "synthesize.cpp"
              if ($cmp201) { __label__ = 55;; } else { __label__ = 56;; } //@line 969 "synthesize.cpp"
              if (__label__ == 55) {
  
                $ix=0; //@line 969 "synthesize.cpp"
                ; //@line 969 "synthesize.cpp"
              }
  
              var $160=$ix; //@line 970 "synthesize.cpp"
              var $161=HEAP32[((__ZL12syllable_end)>>2)]; //@line 970 "synthesize.cpp"
              var $cmp204=((($160))|0)==((($161))|0); //@line 970 "synthesize.cpp"
              if ($cmp204) { __label__ = 57;break $for_cond100$45; } else { __label__ = 32;continue $for_cond100$45; } //@line 970 "synthesize.cpp"
            }
  
            var $162=HEAP32[((__ZL12syllable_end)>>2)]; //@line 974 "synthesize.cpp"
            HEAP32[((__ZL14syllable_start)>>2)]=$162; //@line 974 "synthesize.cpp"
            __label__ = 58;break $return$$if_end$2; //@line 975 "synthesize.cpp"
          }
        } while(0);
  
        var $5=HEAP32[((__ZL12syllable_end)>>2)]; //@line 795 "synthesize.cpp"
        HEAP32[((__ZL14syllable_start)>>2)]=$5; //@line 795 "synthesize.cpp"
        ; //@line 796 "synthesize.cpp"
      }
    } while(0);
  
    ;
    return; //@line 975 "synthesize.cpp"
    return;
  }
  

  function __Z8DoMarkeriiii($type, $char_posn, $length, $value) {
    ;
    var __label__;
  
    var $type_addr;
    var $char_posn_addr;
    var $length_addr;
    var $value_addr;
    $type_addr=$type;
    $char_posn_addr=$char_posn;
    $length_addr=$length;
    $value_addr=$value;
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 1212 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$0*16)&4294967295); //@line 1212 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 1212 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=10; //@line 1212 "synthesize.cpp"
    var $1=$type_addr; //@line 1213 "synthesize.cpp"
    var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 1213 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$2*16)&4294967295); //@line 1213 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 1213 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$1; //@line 1213 "synthesize.cpp"
    var $3=$char_posn_addr; //@line 1214 "synthesize.cpp"
    var $and=($3) & 16777215; //@line 1214 "synthesize.cpp"
    var $4=$length_addr; //@line 1214 "synthesize.cpp"
    var $shl=($4) << 24; //@line 1214 "synthesize.cpp"
    var $or=($shl) | ($and); //@line 1214 "synthesize.cpp"
    var $5=HEAP32[((_wcmdq_tail)>>2)]; //@line 1214 "synthesize.cpp"
    var $arrayidx4=((_wcmdq+$5*16)&4294967295); //@line 1214 "synthesize.cpp"
    var $arrayidx5=(($arrayidx4+8)&4294967295); //@line 1214 "synthesize.cpp"
    HEAP32[(($arrayidx5)>>2)]=$or; //@line 1214 "synthesize.cpp"
    var $6=$value_addr; //@line 1215 "synthesize.cpp"
    var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 1215 "synthesize.cpp"
    var $arrayidx6=((_wcmdq+$7*16)&4294967295); //@line 1215 "synthesize.cpp"
    var $arrayidx7=(($arrayidx6+12)&4294967295); //@line 1215 "synthesize.cpp"
    HEAP32[(($arrayidx7)>>2)]=$6; //@line 1215 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 1216 "synthesize.cpp"
    ;
    return; //@line 1218 "synthesize.cpp"
    return;
  }
  

  function __Z12DoSonicSpeedi($value) {
    ;
    var __label__;
  
    var $value_addr;
    $value_addr=$value;
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 1224 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$0*16)&4294967295); //@line 1224 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 1224 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=15; //@line 1224 "synthesize.cpp"
    var $1=$value_addr; //@line 1225 "synthesize.cpp"
    var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 1225 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$2*16)&4294967295); //@line 1225 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 1225 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$1; //@line 1225 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 1226 "synthesize.cpp"
    ;
    return; //@line 1227 "synthesize.cpp"
    return;
  }
  

  function __Z13DoVoiceChangeP7voice_t($v) {
    ;
    var __label__;
  
    var $v_addr;
    var $v2;
    $v_addr=$v;
    var $call=_malloc(1344); //@line 1235 "synthesize.cpp"
    var $0=$call; //@line 1235 "synthesize.cpp"
    $v2=$0; //@line 1235 "synthesize.cpp"
    var $1=$v2; //@line 1236 "synthesize.cpp"
    var $2=$1; //@line 1236 "synthesize.cpp"
    var $3=$v_addr; //@line 1236 "synthesize.cpp"
    var $4=$3; //@line 1236 "synthesize.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $4;
    $dest$ = $2;
    $stop$ = $src$ + 1344;
    if (($dest$%4) == ($src$%4) && 1344 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1236 "synthesize.cpp"
    var $5=HEAP32[((_wcmdq_tail)>>2)]; //@line 1237 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$5*16)&4294967295); //@line 1237 "synthesize.cpp"
    var $arrayidx1=(($arrayidx)&4294967295); //@line 1237 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=11; //@line 1237 "synthesize.cpp"
    var $6=$v2; //@line 1238 "synthesize.cpp"
    var $7=($6); //@line 1238 "synthesize.cpp"
    var $8=HEAP32[((_wcmdq_tail)>>2)]; //@line 1238 "synthesize.cpp"
    var $arrayidx2=((_wcmdq+$8*16)&4294967295); //@line 1238 "synthesize.cpp"
    var $arrayidx3=(($arrayidx2+4)&4294967295); //@line 1238 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$7; //@line 1238 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 1239 "synthesize.cpp"
    ;
    return; //@line 1240 "synthesize.cpp"
    return;
  }
  

  function __Z10DoEmbeddedPii($embix, $sourceix) {
    ;
    var __label__;
  
    var $embix_addr;
    var $sourceix_addr;
    var $word;
    var $value;
    var $command;
    $embix_addr=$embix;
    $sourceix_addr=$sourceix;
    ; //@line 1250 "synthesize.cpp"
    $do_body$2: while(1) { 
  
      var $0=$embix_addr; //@line 1251 "synthesize.cpp"
      var $1=HEAP32[(($0)>>2)]; //@line 1251 "synthesize.cpp"
      var $arrayidx=((_embedded_list+$1*4)&4294967295); //@line 1251 "synthesize.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 1251 "synthesize.cpp"
      $word=$2; //@line 1251 "synthesize.cpp"
      var $3=$word; //@line 1252 "synthesize.cpp"
      var $shr=($3) >>> 8; //@line 1252 "synthesize.cpp"
      $value=$shr; //@line 1252 "synthesize.cpp"
      var $4=$word; //@line 1253 "synthesize.cpp"
      var $and=($4) & 127; //@line 1253 "synthesize.cpp"
      $command=$and; //@line 1253 "synthesize.cpp"
      var $cmp=((($and))|0)==0; //@line 1255 "synthesize.cpp"
      if ($cmp) { __label__ = 11;break $do_body$2; } //@line 1255 "synthesize.cpp"
  
      var $5=$embix_addr; //@line 1258 "synthesize.cpp"
      var $6=HEAP32[(($5)>>2)]; //@line 1258 "synthesize.cpp"
      var $inc=((($6)+1)&4294967295); //@line 1258 "synthesize.cpp"
      HEAP32[(($5)>>2)]=$inc; //@line 1258 "synthesize.cpp"
      var $7=$command; //@line 1260 "synthesize.cpp"
      var $and1=($7) & 31; //@line 1260 "synthesize.cpp"
      if ($and1 == 2) {
        __label__ = 3;;
      }
      else if ($and1 == 7) {
        __label__ = 4;;
      }
      else if ($and1 == 10) {
        __label__ = 7;;
      }
      else if ($and1 == 11) {
        __label__ = 8;;
      }
      else {
      __label__ = 9;;
      }
      
      $sw_default$$sw_bb$$sw_bb3$$sw_bb23$$sw_bb26$5: do { 
        if (__label__ == 9) {
  
          __ZL7DoPauseii(10, 0); //@line 1291 "synthesize.cpp"
          var $28=HEAP32[((_wcmdq_tail)>>2)]; //@line 1292 "synthesize.cpp"
          var $arrayidx28=((_wcmdq+$28*16)&4294967295); //@line 1292 "synthesize.cpp"
          var $arrayidx29=(($arrayidx28)&4294967295); //@line 1292 "synthesize.cpp"
          HEAP32[(($arrayidx29)>>2)]=12; //@line 1292 "synthesize.cpp"
          var $29=$command; //@line 1293 "synthesize.cpp"
          var $30=HEAP32[((_wcmdq_tail)>>2)]; //@line 1293 "synthesize.cpp"
          var $arrayidx30=((_wcmdq+$30*16)&4294967295); //@line 1293 "synthesize.cpp"
          var $arrayidx31=(($arrayidx30+4)&4294967295); //@line 1293 "synthesize.cpp"
          HEAP32[(($arrayidx31)>>2)]=$29; //@line 1293 "synthesize.cpp"
          var $31=$value; //@line 1294 "synthesize.cpp"
          var $32=HEAP32[((_wcmdq_tail)>>2)]; //@line 1294 "synthesize.cpp"
          var $arrayidx32=((_wcmdq+$32*16)&4294967295); //@line 1294 "synthesize.cpp"
          var $arrayidx33=(($arrayidx32+8)&4294967295); //@line 1294 "synthesize.cpp"
          HEAP32[(($arrayidx33)>>2)]=$31; //@line 1294 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1295 "synthesize.cpp"
          ; //@line 1296 "synthesize.cpp"
        }
        else if (__label__ == 3) {
  
          var $8=$command; //@line 1263 "synthesize.cpp"
          var $and2=($8) & 96; //@line 1263 "synthesize.cpp"
          var $add=((($and2)+8)&4294967295); //@line 1263 "synthesize.cpp"
          var $9=$value; //@line 1263 "synthesize.cpp"
          __Z11SetEmbeddedii($add, $9); //@line 1263 "synthesize.cpp"
          __Z8SetSpeedi(2); //@line 1264 "synthesize.cpp"
          ; //@line 1265 "synthesize.cpp"
        }
        else if (__label__ == 4) {
  
          var $10=$value; //@line 1268 "synthesize.cpp"
          var $11=HEAP32[((_n_soundicon_tab)>>2)]; //@line 1268 "synthesize.cpp"
          var $cmp4=((($10))|0) < ((($11))|0); //@line 1268 "synthesize.cpp"
          if (!($cmp4)) { __label__ = 10;break $sw_default$$sw_bb$$sw_bb3$$sw_bb23$$sw_bb26$5; } //@line 1268 "synthesize.cpp"
  
          var $12=$value; //@line 1270 "synthesize.cpp"
          var $arrayidx6=((_soundicon_tab+$12*16)&4294967295); //@line 1270 "synthesize.cpp"
          var $length=(($arrayidx6+4)&4294967295); //@line 1270 "synthesize.cpp"
          var $13=HEAP32[(($length)>>2)]; //@line 1270 "synthesize.cpp"
          var $cmp7=((($13))|0)!=0; //@line 1270 "synthesize.cpp"
          if (!($cmp7)) { __label__ = 10;break $sw_default$$sw_bb$$sw_bb3$$sw_bb23$$sw_bb26$5; } //@line 1270 "synthesize.cpp"
  
          __ZL7DoPauseii(10, 0); //@line 1272 "synthesize.cpp"
          var $14=HEAP32[((_wcmdq_tail)>>2)]; //@line 1273 "synthesize.cpp"
          var $arrayidx9=((_wcmdq+$14*16)&4294967295); //@line 1273 "synthesize.cpp"
          var $arrayidx10=(($arrayidx9)&4294967295); //@line 1273 "synthesize.cpp"
          HEAP32[(($arrayidx10)>>2)]=6; //@line 1273 "synthesize.cpp"
          var $15=$value; //@line 1274 "synthesize.cpp"
          var $arrayidx11=((_soundicon_tab+$15*16)&4294967295); //@line 1274 "synthesize.cpp"
          var $length12=(($arrayidx11+4)&4294967295); //@line 1274 "synthesize.cpp"
          var $16=HEAP32[(($length12)>>2)]; //@line 1274 "synthesize.cpp"
          var $17=HEAP32[((_wcmdq_tail)>>2)]; //@line 1274 "synthesize.cpp"
          var $arrayidx13=((_wcmdq+$17*16)&4294967295); //@line 1274 "synthesize.cpp"
          var $arrayidx14=(($arrayidx13+4)&4294967295); //@line 1274 "synthesize.cpp"
          HEAP32[(($arrayidx14)>>2)]=$16; //@line 1274 "synthesize.cpp"
          var $18=$value; //@line 1275 "synthesize.cpp"
          var $arrayidx15=((_soundicon_tab+$18*16)&4294967295); //@line 1275 "synthesize.cpp"
          var $data=(($arrayidx15+8)&4294967295); //@line 1275 "synthesize.cpp"
          var $19=HEAP32[(($data)>>2)]; //@line 1275 "synthesize.cpp"
          var $20=($19); //@line 1275 "synthesize.cpp"
          var $add16=((($20)+44)&4294967295); //@line 1275 "synthesize.cpp"
          var $21=HEAP32[((_wcmdq_tail)>>2)]; //@line 1275 "synthesize.cpp"
          var $arrayidx17=((_wcmdq+$21*16)&4294967295); //@line 1275 "synthesize.cpp"
          var $arrayidx18=(($arrayidx17+8)&4294967295); //@line 1275 "synthesize.cpp"
          HEAP32[(($arrayidx18)>>2)]=$add16; //@line 1275 "synthesize.cpp"
          var $22=HEAP32[((_wcmdq_tail)>>2)]; //@line 1276 "synthesize.cpp"
          var $arrayidx19=((_wcmdq+$22*16)&4294967295); //@line 1276 "synthesize.cpp"
          var $arrayidx20=(($arrayidx19+12)&4294967295); //@line 1276 "synthesize.cpp"
          HEAP32[(($arrayidx20)>>2)]=5376; //@line 1276 "synthesize.cpp"
          __Z8WcmdqIncv(); //@line 1277 "synthesize.cpp"
          ; //@line 1278 "synthesize.cpp"
        }
        else if (__label__ == 7) {
  
          var $23=$sourceix_addr; //@line 1283 "synthesize.cpp"
          var $and24=($23) & 2047; //@line 1283 "synthesize.cpp"
          var $24=HEAP32[((_clause_start_char)>>2)]; //@line 1283 "synthesize.cpp"
          var $add25=((($and24)+($24))&4294967295); //@line 1283 "synthesize.cpp"
          var $25=$value; //@line 1283 "synthesize.cpp"
          __Z8DoMarkeriiii(3, $add25, 0, $25); //@line 1283 "synthesize.cpp"
          ; //@line 1284 "synthesize.cpp"
        }
        else if (__label__ == 8) {
  
          var $26=HEAP32[((_count_characters)>>2)]; //@line 1287 "synthesize.cpp"
          var $add27=((($26)+1)&4294967295); //@line 1287 "synthesize.cpp"
          var $27=$value; //@line 1287 "synthesize.cpp"
          __Z8DoMarkeriiii(4, $add27, 0, $27); //@line 1287 "synthesize.cpp"
          ; //@line 1288 "synthesize.cpp"
        }
      } while(0);
  
      var $33=$word; //@line 1298 "synthesize.cpp"
      var $and34=($33) & 128; //@line 1298 "synthesize.cpp"
      var $cmp35=((($and34))|0)==0; //@line 1298 "synthesize.cpp"
      if ($cmp35) { __label__ = 1;continue $do_body$2; } else { __label__ = 11;break $do_body$2; } //@line 1298 "synthesize.cpp"
    }
  
    ;
    return; //@line 1299 "synthesize.cpp"
    return;
  }
  

  function __Z8GenerateP12PHONEME_LISTPii($phoneme_list, $n_ph, $resume) {
    var __stackBase__  = STACKTOP; STACKTOP += 656; _memset(__stackBase__, 0, 656);
    var __label__;
  
    var $retval;
    var $phoneme_list_addr;
    var $n_ph_addr;
    var $resume_addr;
    var $prev;
    var $next;
    var $next2;
    var $p;
    var $released;
    var $stress;
    var $modulation;
    var $pre_voiced;
    var $free_min;
    var $pitch_env;
    var $amp_env;
    var $ph;
    var $prev_ph;
    var $phdata=__stackBase__;
    var $phdata_prev=__stackBase__+152;
    var $phdata_next=__stackBase__+304;
    var $phdata_tone=__stackBase__+456;
    var $fmtp=__stackBase__+608;
    $phoneme_list_addr=$phoneme_list;
    $n_ph_addr=$n_ph;
    $resume_addr=$resume;
    $pitch_env=0; //@line 1317 "synthesize.cpp"
    var $0=HEAP32[((_option_quiet)>>2)]; //@line 1329 "synthesize.cpp"
    var $tobool=((($0))|0)!=0; //@line 1329 "synthesize.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1329 "synthesize.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1330 "synthesize.cpp"
      ; //@line 1330 "synthesize.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP8[(((_mbrola_name)&4294967295))]; //@line 1332 "synthesize.cpp"
      var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 1332 "synthesize.cpp"
      var $cmp=((($conv))|0)!=0; //@line 1332 "synthesize.cpp"
      if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 1332 "synthesize.cpp"
      if (__label__ == 3) {
  
        var $2=$phoneme_list_addr; //@line 1333 "synthesize.cpp"
        var $3=$n_ph_addr; //@line 1333 "synthesize.cpp"
        var $4=$resume_addr; //@line 1333 "synthesize.cpp"
        var $call=__Z14MbrolaGenerateP12PHONEME_LISTPii($2, $3, $4); //@line 1333 "synthesize.cpp"
        $retval=$call; //@line 1333 "synthesize.cpp"
        ; //@line 1333 "synthesize.cpp"
      }
      else if (__label__ == 4) {
  
        var $5=$resume_addr; //@line 1335 "synthesize.cpp"
        var $cmp3=((($5))|0)==0; //@line 1335 "synthesize.cpp"
        if ($cmp3) { __label__ = 5;; } else { __label__ = 6;; } //@line 1335 "synthesize.cpp"
        if (__label__ == 5) {
  
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]=1; //@line 1337 "synthesize.cpp"
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix)>>2)]=0; //@line 1338 "synthesize.cpp"
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE10word_count)>>2)]=0; //@line 1339 "synthesize.cpp"
          HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 1340 "synthesize.cpp"
          HEAP32[((__ZL10amp_length)>>2)]=0; //@line 1341 "synthesize.cpp"
          HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1342 "synthesize.cpp"
          HEAP32[((__ZL10last_wcmdq)>>2)]=-1; //@line 1343 "synthesize.cpp"
          var $6=HEAP32[((_wcmdq_tail)>>2)]; //@line 1344 "synthesize.cpp"
          HEAP32[((__ZL14syllable_start)>>2)]=$6; //@line 1344 "synthesize.cpp"
          var $7=HEAP32[((_wcmdq_tail)>>2)]; //@line 1345 "synthesize.cpp"
          HEAP32[((__ZL12syllable_end)>>2)]=$7; //@line 1345 "synthesize.cpp"
          HEAP32[((__ZL15syllable_centre)>>2)]=-1; //@line 1346 "synthesize.cpp"
          HEAP32[((__ZL14last_pitch_cmd)>>2)]=-1; //@line 1347 "synthesize.cpp"
          var $dest$, $stop$, $stop4$, $fast$, $value4$;
          $dest$ = _vowel_transition;
          $stop$ = $dest$ + 16;
          $value4$ = 0;
          if ($value4$ < 0) $value4$ += 256;
          $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
          while ($dest$%4 !== 0 && $dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($dest$ < $stop4$) {
          ;;;;;;;  HEAP32[$dest$++] = $value4$;
          }
          $dest$ <<= 2;
          while ($dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }; //@line 1348 "synthesize.cpp"
          __ZL7DoPauseii(0, 0); //@line 1349 "synthesize.cpp"
          ; //@line 1350 "synthesize.cpp"
        }
  
        var $pd_control=(($phdata)&4294967295); //@line 1432 "synthesize.cpp"
        var $8=$fmtp; //@line 1448 "synthesize.cpp"
        var $fmt_control=(($fmtp)&4294967295); //@line 1449 "synthesize.cpp"
        var $sound_addr=(($phdata+68)&4294967295); //@line 1478 "synthesize.cpp"
        var $arrayidx173=(($sound_addr)&4294967295); //@line 1478 "synthesize.cpp"
        var $fmt_addr=(($fmtp+8)&4294967295); //@line 1478 "synthesize.cpp"
        var $sound_param=(($phdata+88)&4294967295); //@line 1479 "synthesize.cpp"
        var $arrayidx174=(($sound_param)&4294967295); //@line 1479 "synthesize.cpp"
        var $fmt_amp=(($fmtp+16)&4294967295); //@line 1479 "synthesize.cpp"
        var $sound_addr199=(($phdata+68)&4294967295); //@line 1506 "synthesize.cpp"
        var $arrayidx200=(($sound_addr199)&4294967295); //@line 1506 "synthesize.cpp"
        var $fmt_addr201=(($fmtp+8)&4294967295); //@line 1506 "synthesize.cpp"
        var $sound_param202=(($phdata+88)&4294967295); //@line 1507 "synthesize.cpp"
        var $arrayidx203=(($sound_param202)&4294967295); //@line 1507 "synthesize.cpp"
        var $fmt_amp204=(($fmtp+16)&4294967295); //@line 1507 "synthesize.cpp"
        var $sound_addr205=(($phdata+68)&4294967295); //@line 1508 "synthesize.cpp"
        var $arrayidx206=(($sound_addr205+16)&4294967295); //@line 1508 "synthesize.cpp"
        var $wav_addr=(($fmtp+28)&4294967295); //@line 1508 "synthesize.cpp"
        var $sound_param207=(($phdata+88)&4294967295); //@line 1509 "synthesize.cpp"
        var $arrayidx208=(($sound_param207+16)&4294967295); //@line 1509 "synthesize.cpp"
        var $wav_amp=(($fmtp+32)&4294967295); //@line 1509 "synthesize.cpp"
        var $9=$fmtp; //@line 1551 "synthesize.cpp"
        var $pd_param=(($phdata+4)&4294967295); //@line 1552 "synthesize.cpp"
        var $arrayidx290=(($pd_param+40)&4294967295); //@line 1552 "synthesize.cpp"
        var $std_length=(($fmtp+44)&4294967295); //@line 1552 "synthesize.cpp"
        var $sound_addr291=(($phdata+68)&4294967295); //@line 1553 "synthesize.cpp"
        var $arrayidx292=(($sound_addr291)&4294967295); //@line 1553 "synthesize.cpp"
        var $fmt_addr293=(($fmtp+8)&4294967295); //@line 1553 "synthesize.cpp"
        var $sound_param294=(($phdata+88)&4294967295); //@line 1554 "synthesize.cpp"
        var $arrayidx295=(($sound_param294)&4294967295); //@line 1554 "synthesize.cpp"
        var $fmt_amp296=(($fmtp+16)&4294967295); //@line 1554 "synthesize.cpp"
        var $sound_addr297=(($phdata+68)&4294967295); //@line 1555 "synthesize.cpp"
        var $arrayidx298=(($sound_addr297+16)&4294967295); //@line 1555 "synthesize.cpp"
        var $wav_addr299=(($fmtp+28)&4294967295); //@line 1555 "synthesize.cpp"
        var $sound_param300=(($phdata+88)&4294967295); //@line 1556 "synthesize.cpp"
        var $arrayidx301=(($sound_param300+16)&4294967295); //@line 1556 "synthesize.cpp"
        var $wav_amp302=(($fmtp+32)&4294967295); //@line 1556 "synthesize.cpp"
        var $10=$fmtp; //@line 1564 "synthesize.cpp"
        var $pd_param334=(($phdata+4)&4294967295); //@line 1577 "synthesize.cpp"
        var $arrayidx335=(($pd_param334+40)&4294967295); //@line 1577 "synthesize.cpp"
        var $std_length337=(($fmtp+44)&4294967295); //@line 1577 "synthesize.cpp"
        var $sound_addr338=(($phdata+68)&4294967295); //@line 1578 "synthesize.cpp"
        var $arrayidx339=(($sound_addr338)&4294967295); //@line 1578 "synthesize.cpp"
        var $fmt_addr340=(($fmtp+8)&4294967295); //@line 1578 "synthesize.cpp"
        var $sound_param341=(($phdata+88)&4294967295); //@line 1579 "synthesize.cpp"
        var $arrayidx342=(($sound_param341)&4294967295); //@line 1579 "synthesize.cpp"
        var $fmt_amp343=(($fmtp+16)&4294967295); //@line 1579 "synthesize.cpp"
        var $11=$fmtp; //@line 1601 "synthesize.cpp"
        var $pd_param400=(($phdata+4)&4294967295); //@line 1626 "synthesize.cpp"
        var $arrayidx401=(($pd_param400+40)&4294967295); //@line 1626 "synthesize.cpp"
        var $std_length403=(($fmtp+44)&4294967295); //@line 1626 "synthesize.cpp"
        var $sound_addr404=(($phdata+68)&4294967295); //@line 1627 "synthesize.cpp"
        var $arrayidx405=(($sound_addr404)&4294967295); //@line 1627 "synthesize.cpp"
        var $fmt_addr406=(($fmtp+8)&4294967295); //@line 1627 "synthesize.cpp"
        var $sound_param407=(($phdata+88)&4294967295); //@line 1628 "synthesize.cpp"
        var $arrayidx408=(($sound_param407)&4294967295); //@line 1628 "synthesize.cpp"
        var $fmt_amp409=(($fmtp+16)&4294967295); //@line 1628 "synthesize.cpp"
        var $sound_addr410=(($phdata+68)&4294967295); //@line 1629 "synthesize.cpp"
        var $arrayidx411=(($sound_addr410+16)&4294967295); //@line 1629 "synthesize.cpp"
        var $wav_addr412=(($fmtp+28)&4294967295); //@line 1629 "synthesize.cpp"
        var $sound_param413=(($phdata+88)&4294967295); //@line 1630 "synthesize.cpp"
        var $arrayidx414=(($sound_param413+16)&4294967295); //@line 1630 "synthesize.cpp"
        var $wav_amp415=(($fmtp+32)&4294967295); //@line 1630 "synthesize.cpp"
        var $12=$fmtp; //@line 1639 "synthesize.cpp"
        var $pd_param422=(($phdata+4)&4294967295); //@line 1642 "synthesize.cpp"
        var $arrayidx423=(($pd_param422+40)&4294967295); //@line 1642 "synthesize.cpp"
        var $std_length425=(($fmtp+44)&4294967295); //@line 1642 "synthesize.cpp"
        var $sound_addr426=(($phdata+68)&4294967295); //@line 1644 "synthesize.cpp"
        var $arrayidx427=(($sound_addr426+8)&4294967295); //@line 1644 "synthesize.cpp"
        var $fmt_addr428=(($fmtp+8)&4294967295); //@line 1644 "synthesize.cpp"
        var $pd_control431=(($phdata)&4294967295); //@line 1644 "synthesize.cpp"
        var $sound_param435=(($phdata+88)&4294967295); //@line 1647 "synthesize.cpp"
        var $arrayidx436=(($sound_param435+8)&4294967295); //@line 1647 "synthesize.cpp"
        var $fmt_length=(($fmtp+12)&4294967295); //@line 1647 "synthesize.cpp"
        var $fmt_addr455=(($fmtp+8)&4294967295); //@line 1663 "synthesize.cpp"
        var $use_vowelin=(($fmtp+4)&4294967295); //@line 1666 "synthesize.cpp"
        var $fmt_control458=(($fmtp)&4294967295); //@line 1667 "synthesize.cpp"
        var $sound_addr459=(($phdata+68)&4294967295); //@line 1668 "synthesize.cpp"
        var $arrayidx460=(($sound_addr459)&4294967295); //@line 1668 "synthesize.cpp"
        var $fmt_addr461=(($fmtp+8)&4294967295); //@line 1668 "synthesize.cpp"
        var $sound_param463=(($phdata+88)&4294967295); //@line 1671 "synthesize.cpp"
        var $arrayidx464=(($sound_param463)&4294967295); //@line 1671 "synthesize.cpp"
        var $fmt_amp465=(($fmtp+16)&4294967295); //@line 1671 "synthesize.cpp"
        var $pitch_env474=(($phdata_tone+124)&4294967295); //@line 1678 "synthesize.cpp"
        var $amp_env476=(($phdata_tone+128)&4294967295); //@line 1679 "synthesize.cpp"
        var $amp_env479=(($phdata_tone+128)&4294967295); //@line 1680 "synthesize.cpp"
        var $sound_addr542=(($phdata+68)&4294967295); //@line 1721 "synthesize.cpp"
        var $arrayidx543=(($sound_addr542)&4294967295); //@line 1721 "synthesize.cpp"
        var $fmt_addr544=(($fmtp+8)&4294967295); //@line 1721 "synthesize.cpp"
        var $sound_param545=(($phdata+88)&4294967295); //@line 1722 "synthesize.cpp"
        var $arrayidx546=(($sound_param545)&4294967295); //@line 1722 "synthesize.cpp"
        var $fmt_amp547=(($fmtp+16)&4294967295); //@line 1722 "synthesize.cpp"
        var $transition0548=(($fmtp+36)&4294967295); //@line 1723 "synthesize.cpp"
        var $transition1549=(($fmtp+40)&4294967295); //@line 1724 "synthesize.cpp"
        var $sound_addr550=(($phdata+68)&4294967295); //@line 1726 "synthesize.cpp"
        var $arrayidx551=(($sound_addr550+12)&4294967295); //@line 1726 "synthesize.cpp"
        var $fmt2_addr=(($fmtp+20)&4294967295); //@line 1726 "synthesize.cpp"
        var $sound_param554=(($phdata+88)&4294967295); //@line 1728 "synthesize.cpp"
        var $arrayidx555=(($sound_param554+12)&4294967295); //@line 1728 "synthesize.cpp"
        var $fmt2_lenadj556=(($fmtp+24)&4294967295); //@line 1728 "synthesize.cpp"
        var $fmt2_lenadj562=(($fmtp+24)&4294967295); //@line 1733 "synthesize.cpp"
        var $use_vowelin563=(($fmtp+4)&4294967295); //@line 1736 "synthesize.cpp"
        var $vowel_transition564=(($phdata_next+108)&4294967295); //@line 1737 "synthesize.cpp"
        var $arrayidx565=(($vowel_transition564+8)&4294967295); //@line 1737 "synthesize.cpp"
        var $transition0566=(($fmtp+36)&4294967295); //@line 1737 "synthesize.cpp"
        var $vowel_transition567=(($phdata_next+108)&4294967295); //@line 1738 "synthesize.cpp"
        var $arrayidx568=(($vowel_transition567+12)&4294967295); //@line 1738 "synthesize.cpp"
        var $transition1569=(($fmtp+40)&4294967295); //@line 1738 "synthesize.cpp"
        var $sound_addr570=(($phdata_next+68)&4294967295); //@line 1740 "synthesize.cpp"
        var $arrayidx571=(($sound_addr570+12)&4294967295); //@line 1740 "synthesize.cpp"
        var $fmt2_addr572=(($fmtp+20)&4294967295); //@line 1740 "synthesize.cpp"
        var $sound_param575=(($phdata_next+88)&4294967295); //@line 1742 "synthesize.cpp"
        var $arrayidx576=(($sound_param575+12)&4294967295); //@line 1742 "synthesize.cpp"
        var $fmt2_lenadj577=(($fmtp+24)&4294967295); //@line 1742 "synthesize.cpp"
        var $sound_addr442=(($phdata_prev+68)&4294967295); //@line 1654 "synthesize.cpp"
        var $arrayidx443=(($sound_addr442+8)&4294967295); //@line 1654 "synthesize.cpp"
        var $fmt_addr444=(($fmtp+8)&4294967295); //@line 1654 "synthesize.cpp"
        var $sound_param447=(($phdata_prev+88)&4294967295); //@line 1657 "synthesize.cpp"
        var $arrayidx448=(($sound_param447+8)&4294967295); //@line 1657 "synthesize.cpp"
        var $fmt2_lenadj=(($fmtp+24)&4294967295); //@line 1657 "synthesize.cpp"
        var $vowel_transition=(($phdata_prev+108)&4294967295); //@line 1659 "synthesize.cpp"
        var $arrayidx450=(($vowel_transition)&4294967295); //@line 1659 "synthesize.cpp"
        var $transition0=(($fmtp+36)&4294967295); //@line 1659 "synthesize.cpp"
        var $vowel_transition451=(($phdata_prev+108)&4294967295); //@line 1660 "synthesize.cpp"
        var $arrayidx452=(($vowel_transition451+4)&4294967295); //@line 1660 "synthesize.cpp"
        var $transition1=(($fmtp+40)&4294967295); //@line 1660 "synthesize.cpp"
        ; //@line 1352 "synthesize.cpp"
        $while_cond$11: while(1) { 
  
          var $13=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1352 "synthesize.cpp"
          var $14=$n_ph_addr; //@line 1352 "synthesize.cpp"
          var $15=HEAP32[(($14)>>2)]; //@line 1352 "synthesize.cpp"
          var $cmp6=((($13))|0) < ((($15))|0); //@line 1352 "synthesize.cpp"
          if (!($cmp6)) { __label__ = 134;break $while_cond$11; } //@line 1352 "synthesize.cpp"
  
          var $16=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1354 "synthesize.cpp"
          var $17=$phoneme_list_addr; //@line 1354 "synthesize.cpp"
          var $arrayidx=(($17+24*$16)&4294967295); //@line 1354 "synthesize.cpp"
          $p=$arrayidx; //@line 1354 "synthesize.cpp"
          var $18=$p; //@line 1356 "synthesize.cpp"
          var $type=(($18+15)&4294967295); //@line 1356 "synthesize.cpp"
          var $19=HEAPU8[($type)]; //@line 1356 "synthesize.cpp"
          var $conv7=((($19))&255); //@line 1356 "synthesize.cpp"
          var $cmp8=((($conv7))|0)==0; //@line 1356 "synthesize.cpp"
          if ($cmp8) { __label__ = 9;; } else { __label__ = 10;; } //@line 1356 "synthesize.cpp"
          if (__label__ == 9) {
  
            $free_min=5; //@line 1357 "synthesize.cpp"
            ; //@line 1357 "synthesize.cpp"
          }
          else if (__label__ == 10) {
  
            var $20=$p; //@line 1359 "synthesize.cpp"
            var $type10=(($20+15)&4294967295); //@line 1359 "synthesize.cpp"
            var $21=HEAPU8[($type10)]; //@line 1359 "synthesize.cpp"
            var $conv11=((($21))&255); //@line 1359 "synthesize.cpp"
            var $cmp12=((($conv11))|0)!=2; //@line 1359 "synthesize.cpp"
            if ($cmp12) { __label__ = 11;; } else { __label__ = 12;; } //@line 1359 "synthesize.cpp"
            if (__label__ == 11) {
  
              $free_min=10; //@line 1360 "synthesize.cpp"
              ; //@line 1360 "synthesize.cpp"
            }
            else if (__label__ == 12) {
  
              $free_min=22; //@line 1362 "synthesize.cpp"
              ;
            }
          }
  
          var $call17=__Z9WcmdqFreev(); //@line 1364 "synthesize.cpp"
          var $22=$free_min; //@line 1364 "synthesize.cpp"
          var $cmp18=((($call17))|0) <= ((($22))|0); //@line 1364 "synthesize.cpp"
          if ($cmp18) { __label__ = 14;break $while_cond$11; } //@line 1364 "synthesize.cpp"
  
          var $23=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1367 "synthesize.cpp"
          var $sub=((($23)-1)&4294967295); //@line 1367 "synthesize.cpp"
          var $24=$phoneme_list_addr; //@line 1367 "synthesize.cpp"
          var $arrayidx21=(($24+24*$sub)&4294967295); //@line 1367 "synthesize.cpp"
          $prev=$arrayidx21; //@line 1367 "synthesize.cpp"
          var $25=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1368 "synthesize.cpp"
          var $add=((($25)+1)&4294967295); //@line 1368 "synthesize.cpp"
          var $26=$phoneme_list_addr; //@line 1368 "synthesize.cpp"
          var $arrayidx22=(($26+24*$add)&4294967295); //@line 1368 "synthesize.cpp"
          $next=$arrayidx22; //@line 1368 "synthesize.cpp"
          var $27=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1369 "synthesize.cpp"
          var $add23=((($27)+2)&4294967295); //@line 1369 "synthesize.cpp"
          var $28=$phoneme_list_addr; //@line 1369 "synthesize.cpp"
          var $arrayidx24=(($28+24*$add23)&4294967295); //@line 1369 "synthesize.cpp"
          $next2=$arrayidx24; //@line 1369 "synthesize.cpp"
          var $29=$p; //@line 1371 "synthesize.cpp"
          var $synthflags=(($29+4)&4294967295); //@line 1371 "synthesize.cpp"
          var $30=HEAPU16[(($synthflags)>>1)]; //@line 1371 "synthesize.cpp"
          var $conv25=((($30))&65535); //@line 1371 "synthesize.cpp"
          var $and=($conv25) & 2; //@line 1371 "synthesize.cpp"
          var $tobool26=((($and))|0)!=0; //@line 1371 "synthesize.cpp"
          if ($tobool26) { __label__ = 16;; } else { __label__ = 17;; } //@line 1371 "synthesize.cpp"
          if (__label__ == 16) {
  
            var $31=$p; //@line 1373 "synthesize.cpp"
            var $sourceix=(($31+6)&4294967295); //@line 1373 "synthesize.cpp"
            var $32=HEAPU16[(($sourceix)>>1)]; //@line 1373 "synthesize.cpp"
            var $conv28=((($32))&65535); //@line 1373 "synthesize.cpp"
            __Z10DoEmbeddedPii(__ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix, $conv28); //@line 1373 "synthesize.cpp"
            ; //@line 1374 "synthesize.cpp"
          }
  
          var $33=$p; //@line 1376 "synthesize.cpp"
          var $newword=(($33+19)&4294967295); //@line 1376 "synthesize.cpp"
          var $34=HEAP8[($newword)]; //@line 1376 "synthesize.cpp"
          var $tobool30=(tempInt=(($34)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1376 "synthesize.cpp"
          if ($tobool30) { __label__ = 18;; } else { __label__ = 26;; } //@line 1376 "synthesize.cpp"
          $if_then31$$if_end63$25: do { 
            if (__label__ == 18) {
  
              var $35=$p; //@line 1378 "synthesize.cpp"
              var $type32=(($35+15)&4294967295); //@line 1378 "synthesize.cpp"
              var $36=HEAPU8[($type32)]; //@line 1378 "synthesize.cpp"
              var $conv33=((($36))&255); //@line 1378 "synthesize.cpp"
              var $cmp34=((($conv33))|0)==2; //@line 1378 "synthesize.cpp"
              if ($cmp34) { __label__ = 19;; } else { __label__ = 20;; } //@line 1378 "synthesize.cpp"
              $land_lhs_true$$lor_lhs_false$27: do { 
                if (__label__ == 19) {
  
                  var $37=HEAP32[((_translator)>>2)]; //@line 1378 "synthesize.cpp"
                  var $langopts=(($37)&4294967295); //@line 1378 "synthesize.cpp"
                  var $param=(($langopts+24)&4294967295); //@line 1378 "synthesize.cpp"
                  var $arrayidx35=(($param+32)&4294967295); //@line 1378 "synthesize.cpp"
                  var $38=HEAP32[(($arrayidx35)>>2)]; //@line 1378 "synthesize.cpp"
                  var $and36=($38) & 1; //@line 1378 "synthesize.cpp"
                  var $tobool37=((($and36))|0)!=0; //@line 1378 "synthesize.cpp"
                  if ($tobool37) { __label__ = 22;break $land_lhs_true$$lor_lhs_false$27; } else { __label__ = 20;break $land_lhs_true$$lor_lhs_false$27; } //@line 1378 "synthesize.cpp"
                }
              } while(0);
              $if_end43$$lor_lhs_false$29: do { 
                if (__label__ == 20) {
  
                  var $39=$p; //@line 1378 "synthesize.cpp"
                  var $ph38=(($39+8)&4294967295); //@line 1378 "synthesize.cpp"
                  var $40=HEAP32[(($ph38)>>2)]; //@line 1378 "synthesize.cpp"
                  var $phflags=(($40+4)&4294967295); //@line 1378 "synthesize.cpp"
                  var $41=HEAP32[(($phflags)>>2)]; //@line 1378 "synthesize.cpp"
                  var $and39=($41) & 16777216; //@line 1378 "synthesize.cpp"
                  var $tobool40=((($and39))|0)!=0; //@line 1378 "synthesize.cpp"
                  if ($tobool40) { __label__ = 22;break $if_end43$$lor_lhs_false$29; } //@line 1378 "synthesize.cpp"
  
                  HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1384 "synthesize.cpp"
                  ;
                }
              } while(0);
  
              var $42=$p; //@line 1387 "synthesize.cpp"
              var $sourceix44=(($42+6)&4294967295); //@line 1387 "synthesize.cpp"
              var $43=HEAPU16[(($sourceix44)>>1)]; //@line 1387 "synthesize.cpp"
              var $conv45=((($43))&65535); //@line 1387 "synthesize.cpp"
              var $and46=($conv45) & 2047; //@line 1387 "synthesize.cpp"
              var $44=HEAP32[((_clause_start_char)>>2)]; //@line 1387 "synthesize.cpp"
              var $add47=((($and46)+($44))&4294967295); //@line 1387 "synthesize.cpp"
              HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]=$add47; //@line 1387 "synthesize.cpp"
              var $45=$p; //@line 1389 "synthesize.cpp"
              var $newword48=(($45+19)&4294967295); //@line 1389 "synthesize.cpp"
              var $46=HEAPU8[($newword48)]; //@line 1389 "synthesize.cpp"
              var $conv49=((($46))&255); //@line 1389 "synthesize.cpp"
              var $and50=($conv49) & 4; //@line 1389 "synthesize.cpp"
              var $tobool51=((($and50))|0)!=0; //@line 1389 "synthesize.cpp"
              if ($tobool51) { __label__ = 23;; } else { __label__ = 24;; } //@line 1389 "synthesize.cpp"
              if (__label__ == 23) {
  
                var $47=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1390 "synthesize.cpp"
                var $48=HEAP32[((_count_sentences)>>2)]; //@line 1390 "synthesize.cpp"
                __Z8DoMarkeriiii(2, $47, 0, $48); //@line 1390 "synthesize.cpp"
                ; //@line 1390 "synthesize.cpp"
              }
  
              var $49=$p; //@line 1395 "synthesize.cpp"
              var $newword54=(($49+19)&4294967295); //@line 1395 "synthesize.cpp"
              var $50=HEAPU8[($newword54)]; //@line 1395 "synthesize.cpp"
              var $conv55=((($50))&255); //@line 1395 "synthesize.cpp"
              var $and56=($conv55) & 1; //@line 1395 "synthesize.cpp"
              var $tobool57=((($and56))|0)!=0; //@line 1395 "synthesize.cpp"
              if (!($tobool57)) { __label__ = 26;break $if_then31$$if_end63$25; } //@line 1395 "synthesize.cpp"
  
              var $51=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1396 "synthesize.cpp"
              var $52=$p; //@line 1396 "synthesize.cpp"
              var $sourceix59=(($52+6)&4294967295); //@line 1396 "synthesize.cpp"
              var $53=HEAPU16[(($sourceix59)>>1)]; //@line 1396 "synthesize.cpp"
              var $conv60=((($53))&65535); //@line 1396 "synthesize.cpp"
              var $shr=($conv60) >> 11; //@line 1396 "synthesize.cpp"
              var $54=HEAP32[((_clause_start_word)>>2)]; //@line 1396 "synthesize.cpp"
              var $55=HEAPU32[((__ZZ8GenerateP12PHONEME_LISTPiiE10word_count)>>2)]; //@line 1396 "synthesize.cpp"
              var $inc=((($55)+1)&4294967295); //@line 1396 "synthesize.cpp"
              HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE10word_count)>>2)]=$inc; //@line 1396 "synthesize.cpp"
              var $add61=((($55)+($54))&4294967295); //@line 1396 "synthesize.cpp"
              __Z8DoMarkeriiii(1, $51, $shr, $add61); //@line 1396 "synthesize.cpp"
              ; //@line 1396 "synthesize.cpp"
            }
          } while(0);
  
          __ZL12EndAmplitudev(); //@line 1399 "synthesize.cpp"
          var $56=$p; //@line 1401 "synthesize.cpp"
          var $prepause=(($56+16)&4294967295); //@line 1401 "synthesize.cpp"
          var $57=HEAPU8[($prepause)]; //@line 1401 "synthesize.cpp"
          var $conv64=((($57))&255); //@line 1401 "synthesize.cpp"
          var $cmp65=((($conv64))|0) > 0; //@line 1401 "synthesize.cpp"
          if ($cmp65) { __label__ = 27;; } else { __label__ = 28;; } //@line 1401 "synthesize.cpp"
          if (__label__ == 27) {
  
            var $58=$p; //@line 1402 "synthesize.cpp"
            var $prepause67=(($58+16)&4294967295); //@line 1402 "synthesize.cpp"
            var $59=HEAPU8[($prepause67)]; //@line 1402 "synthesize.cpp"
            var $conv68=((($59))&255); //@line 1402 "synthesize.cpp"
            __ZL7DoPauseii($conv68, 1); //@line 1402 "synthesize.cpp"
            ; //@line 1402 "synthesize.cpp"
          }
  
          var $60=HEAP32[((_option_phoneme_events)>>2)]; //@line 1404 "synthesize.cpp"
          var $tobool70=((($60))|0)!=0; //@line 1404 "synthesize.cpp"
          if ($tobool70) { __label__ = 29;; } else { __label__ = 31;; } //@line 1404 "synthesize.cpp"
          $land_lhs_true71$$if_end77$41: do { 
            if (__label__ == 29) {
  
              var $61=$p; //@line 1404 "synthesize.cpp"
              var $type72=(($61+15)&4294967295); //@line 1404 "synthesize.cpp"
              var $62=HEAPU8[($type72)]; //@line 1404 "synthesize.cpp"
              var $conv73=((($62))&255); //@line 1404 "synthesize.cpp"
              var $cmp74=((($conv73))|0)!=2; //@line 1404 "synthesize.cpp"
              if (!($cmp74)) { __label__ = 31;break $land_lhs_true71$$if_end77$41; } //@line 1404 "synthesize.cpp"
  
              var $63=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1407 "synthesize.cpp"
              var $64=$p; //@line 1407 "synthesize.cpp"
              var $ph76=(($64+8)&4294967295); //@line 1407 "synthesize.cpp"
              var $65=HEAP32[(($ph76)>>2)]; //@line 1407 "synthesize.cpp"
              var $mnemonic=(($65)&4294967295); //@line 1407 "synthesize.cpp"
              var $66=HEAP32[(($mnemonic)>>2)]; //@line 1407 "synthesize.cpp"
              __Z8DoMarkeriiii(7, $63, 0, $66); //@line 1407 "synthesize.cpp"
              ; //@line 1408 "synthesize.cpp"
            }
          } while(0);
  
          var $67=$p; //@line 1410 "synthesize.cpp"
          var $type78=(($67+15)&4294967295); //@line 1410 "synthesize.cpp"
          var $68=HEAPU8[($type78)]; //@line 1410 "synthesize.cpp"
          var $conv79=((($68))&255); //@line 1410 "synthesize.cpp"
          if ($conv79 == 0) {
            __label__ = 32;;
          }
          else if ($conv79 == 4) {
            __label__ = 33;;
          }
          else if ($conv79 == 6) {
            __label__ = 41;;
          }
          else if ($conv79 == 5) {
            __label__ = 44;;
          }
          else if ($conv79 == 7) {
            __label__ = 67;;
          }
          else if ($conv79 == 8) {
            __label__ = 81;;
          }
          else if ($conv79 == 3) {
            __label__ = 91;;
          }
          else if ($conv79 == 2) {
            __label__ = 100;;
          }
          else {
          __label__ = 133;;
          }
          
          $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45: do { 
            if (__label__ == 32) {
  
              var $69=$p; //@line 1413 "synthesize.cpp"
              var $length=(($69+12)&4294967295); //@line 1413 "synthesize.cpp"
              var $70=HEAP16[(($length)>>1)]; //@line 1413 "synthesize.cpp"
              var $conv80=(tempInt=(($70)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1413 "synthesize.cpp"
              __ZL7DoPauseii($conv80, 0); //@line 1413 "synthesize.cpp"
              ; //@line 1414 "synthesize.cpp"
            }
            else if (__label__ == 33) {
  
              $released=0; //@line 1417 "synthesize.cpp"
              var $71=$next; //@line 1418 "synthesize.cpp"
              var $type82=(($71+15)&4294967295); //@line 1418 "synthesize.cpp"
              var $72=HEAPU8[($type82)]; //@line 1418 "synthesize.cpp"
              var $conv83=((($72))&255); //@line 1418 "synthesize.cpp"
              var $cmp84=((($conv83))|0)==2; //@line 1418 "synthesize.cpp"
              if ($cmp84) { __label__ = 34;; } else { __label__ = 35;; } //@line 1418 "synthesize.cpp"
              $if_then85$$if_else86$48: do { 
                if (__label__ == 34) {
  
                  $released=1; //@line 1420 "synthesize.cpp"
                  ; //@line 1421 "synthesize.cpp"
                }
                else if (__label__ == 35) {
  
                  var $73=$next; //@line 1423 "synthesize.cpp"
                  var $newword87=(($73+19)&4294967295); //@line 1423 "synthesize.cpp"
                  var $74=HEAP8[($newword87)]; //@line 1423 "synthesize.cpp"
                  var $tobool88=(tempInt=(($74)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1423 "synthesize.cpp"
                  if ($tobool88) { __label__ = 38;; } else { __label__ = 36;; } //@line 1423 "synthesize.cpp"
                  $if_end96$$if_then89$51: do { 
                    if (__label__ == 36) {
  
                      var $75=$next; //@line 1425 "synthesize.cpp"
                      var $type90=(($75+15)&4294967295); //@line 1425 "synthesize.cpp"
                      var $76=HEAPU8[($type90)]; //@line 1425 "synthesize.cpp"
                      var $conv91=((($76))&255); //@line 1425 "synthesize.cpp"
                      var $cmp92=((($conv91))|0)==3; //@line 1425 "synthesize.cpp"
                      if (!($cmp92)) { __label__ = 38;break $if_end96$$if_then89$51; } //@line 1425 "synthesize.cpp"
  
                      $released=1; //@line 1425 "synthesize.cpp"
                      __label__ = 40;break $if_then85$$if_else86$48; //@line 1425 "synthesize.cpp"
                    }
                  } while(0);
  
                  var $_pr=$released; //@line 1428 "synthesize.cpp"
                  var $cmp97=((($_pr))|0)==0; //@line 1428 "synthesize.cpp"
                  if (!($cmp97)) { __label__ = 40;break $if_then85$$if_else86$48; } //@line 1428 "synthesize.cpp"
  
                  var $77=$p; //@line 1429 "synthesize.cpp"
                  var $synthflags99=(($77+4)&4294967295); //@line 1429 "synthesize.cpp"
                  var $78=HEAPU16[(($synthflags99)>>1)]; //@line 1429 "synthesize.cpp"
                  var $conv100=((($78))&65535); //@line 1429 "synthesize.cpp"
                  var $or=($conv100) | 8192; //@line 1429 "synthesize.cpp"
                  var $conv101=((($or)) & 65535); //@line 1429 "synthesize.cpp"
                  HEAP16[(($synthflags99)>>1)]=$conv101; //@line 1429 "synthesize.cpp"
                  ; //@line 1429 "synthesize.cpp"
                }
              } while(0);
  
              var $79=$p; //@line 1431 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $79, $phdata); //@line 1431 "synthesize.cpp"
              var $80=HEAP32[(($pd_control)>>2)]; //@line 1432 "synthesize.cpp"
              var $or103=($80) | 4; //@line 1432 "synthesize.cpp"
              HEAP32[(($pd_control)>>2)]=$or103; //@line 1432 "synthesize.cpp"
              var $call104=__Z9DoSample3P12PHONEME_DATAii($phdata, 0, 0); //@line 1433 "synthesize.cpp"
              ; //@line 1434 "synthesize.cpp"
            }
            else if (__label__ == 41) {
  
              var $81=$p; //@line 1437 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $81, $phdata); //@line 1437 "synthesize.cpp"
              var $82=$p; //@line 1439 "synthesize.cpp"
              var $synthflags106=(($82+4)&4294967295); //@line 1439 "synthesize.cpp"
              var $83=HEAPU16[(($synthflags106)>>1)]; //@line 1439 "synthesize.cpp"
              var $conv107=((($83))&65535); //@line 1439 "synthesize.cpp"
              var $and108=($conv107) & 8; //@line 1439 "synthesize.cpp"
              var $tobool109=((($and108))|0)!=0; //@line 1439 "synthesize.cpp"
              if ($tobool109) { __label__ = 42;; } else { __label__ = 43;; } //@line 1439 "synthesize.cpp"
              if (__label__ == 42) {
  
                var $84=$p; //@line 1441 "synthesize.cpp"
                var $length111=(($84+12)&4294967295); //@line 1441 "synthesize.cpp"
                var $85=HEAP16[(($length111)>>1)]; //@line 1441 "synthesize.cpp"
                var $conv112=(tempInt=(($85)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1441 "synthesize.cpp"
                var $call113=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv112, 0); //@line 1441 "synthesize.cpp"
                ; //@line 1442 "synthesize.cpp"
              }
  
              var $86=$p; //@line 1443 "synthesize.cpp"
              var $length115=(($86+12)&4294967295); //@line 1443 "synthesize.cpp"
              var $87=HEAP16[(($length115)>>1)]; //@line 1443 "synthesize.cpp"
              var $conv116=(tempInt=(($87)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1443 "synthesize.cpp"
              var $call117=__Z9DoSample3P12PHONEME_DATAii($phdata, $conv116, 0); //@line 1443 "synthesize.cpp"
              ; //@line 1444 "synthesize.cpp"
            }
            else if (__label__ == 44) {
  
              var $88=$p; //@line 1447 "synthesize.cpp"
              var $ph119=(($88+8)&4294967295); //@line 1447 "synthesize.cpp"
              var $89=HEAP32[(($ph119)>>2)]; //@line 1447 "synthesize.cpp"
              $ph=$89; //@line 1447 "synthesize.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $8;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1448 "synthesize.cpp"
              HEAP32[(($fmt_control)>>2)]=4; //@line 1449 "synthesize.cpp"
              $pre_voiced=0; //@line 1451 "synthesize.cpp"
              var $90=$next; //@line 1452 "synthesize.cpp"
              var $type120=(($90+15)&4294967295); //@line 1452 "synthesize.cpp"
              var $91=HEAPU8[($type120)]; //@line 1452 "synthesize.cpp"
              var $conv121=((($91))&255); //@line 1452 "synthesize.cpp"
              var $cmp122=((($conv121))|0)==2; //@line 1452 "synthesize.cpp"
              if ($cmp122) { __label__ = 45;; } else { __label__ = 46;; } //@line 1452 "synthesize.cpp"
              $if_then123$$if_else128$62: do { 
                if (__label__ == 45) {
  
                  var $92=$p; //@line 1454 "synthesize.cpp"
                  var $amp=(($92+18)&4294967295); //@line 1454 "synthesize.cpp"
                  var $93=HEAPU8[($amp)]; //@line 1454 "synthesize.cpp"
                  var $conv124=((($93))&255); //@line 1454 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv124, 0); //@line 1454 "synthesize.cpp"
                  var $94=$p; //@line 1455 "synthesize.cpp"
                  var $env=(($94+14)&4294967295); //@line 1455 "synthesize.cpp"
                  var $95=HEAPU8[($env)]; //@line 1455 "synthesize.cpp"
                  var $idxprom=((($95))&255); //@line 1455 "synthesize.cpp"
                  var $arrayidx125=((_envelope_data+$idxprom*4)&4294967295); //@line 1455 "synthesize.cpp"
                  var $96=HEAP32[(($arrayidx125)>>2)]; //@line 1455 "synthesize.cpp"
                  var $97=$p; //@line 1455 "synthesize.cpp"
                  var $pitch1=(($97+20)&4294967295); //@line 1455 "synthesize.cpp"
                  var $98=HEAPU8[($pitch1)]; //@line 1455 "synthesize.cpp"
                  var $conv126=((($98))&255); //@line 1455 "synthesize.cpp"
                  var $99=$p; //@line 1455 "synthesize.cpp"
                  var $pitch2=(($99+21)&4294967295); //@line 1455 "synthesize.cpp"
                  var $100=HEAPU8[($pitch2)]; //@line 1455 "synthesize.cpp"
                  var $conv127=((($100))&255); //@line 1455 "synthesize.cpp"
                  __ZL7DoPitchPhii($96, $conv126, $conv127); //@line 1455 "synthesize.cpp"
                  $pre_voiced=1; //@line 1456 "synthesize.cpp"
                  ; //@line 1457 "synthesize.cpp"
                }
                else if (__label__ == 46) {
  
                  var $101=$next; //@line 1459 "synthesize.cpp"
                  var $type129=(($101+15)&4294967295); //@line 1459 "synthesize.cpp"
                  var $102=HEAPU8[($type129)]; //@line 1459 "synthesize.cpp"
                  var $conv130=((($102))&255); //@line 1459 "synthesize.cpp"
                  var $cmp131=((($conv130))|0)==3; //@line 1459 "synthesize.cpp"
                  if ($cmp131) { __label__ = 47;; } else { __label__ = 49;; } //@line 1459 "synthesize.cpp"
                  $land_lhs_true132$$if_else145$65: do { 
                    if (__label__ == 47) {
  
                      var $103=$next; //@line 1459 "synthesize.cpp"
                      var $newword133=(($103+19)&4294967295); //@line 1459 "synthesize.cpp"
                      var $104=HEAP8[($newword133)]; //@line 1459 "synthesize.cpp"
                      var $tobool134=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 1459 "synthesize.cpp"
                      if ($tobool134) { __label__ = 49;break $land_lhs_true132$$if_else145$65; } //@line 1459 "synthesize.cpp"
  
                      var $105=$next; //@line 1461 "synthesize.cpp"
                      var $amp136=(($105+18)&4294967295); //@line 1461 "synthesize.cpp"
                      var $106=HEAPU8[($amp136)]; //@line 1461 "synthesize.cpp"
                      var $conv137=((($106))&255); //@line 1461 "synthesize.cpp"
                      __ZL11DoAmplitudeiPh($conv137, 0); //@line 1461 "synthesize.cpp"
                      var $107=$next; //@line 1462 "synthesize.cpp"
                      var $env138=(($107+14)&4294967295); //@line 1462 "synthesize.cpp"
                      var $108=HEAPU8[($env138)]; //@line 1462 "synthesize.cpp"
                      var $idxprom139=((($108))&255); //@line 1462 "synthesize.cpp"
                      var $arrayidx140=((_envelope_data+$idxprom139*4)&4294967295); //@line 1462 "synthesize.cpp"
                      var $109=HEAP32[(($arrayidx140)>>2)]; //@line 1462 "synthesize.cpp"
                      var $110=$next; //@line 1462 "synthesize.cpp"
                      var $pitch1141=(($110+20)&4294967295); //@line 1462 "synthesize.cpp"
                      var $111=HEAPU8[($pitch1141)]; //@line 1462 "synthesize.cpp"
                      var $conv142=((($111))&255); //@line 1462 "synthesize.cpp"
                      var $112=$next; //@line 1462 "synthesize.cpp"
                      var $pitch2143=(($112+21)&4294967295); //@line 1462 "synthesize.cpp"
                      var $113=HEAPU8[($pitch2143)]; //@line 1462 "synthesize.cpp"
                      var $conv144=((($113))&255); //@line 1462 "synthesize.cpp"
                      __ZL7DoPitchPhii($109, $conv142, $conv144); //@line 1462 "synthesize.cpp"
                      $pre_voiced=1; //@line 1463 "synthesize.cpp"
                      __label__ = 51;break $if_then123$$if_else128$62; //@line 1464 "synthesize.cpp"
                    }
                  } while(0);
  
                  var $114=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 1467 "synthesize.cpp"
                  var $cmp146=((($114))|0) < 0; //@line 1467 "synthesize.cpp"
                  if (!($cmp146)) { __label__ = 51;break $if_then123$$if_else128$62; } //@line 1467 "synthesize.cpp"
  
                  var $115=$next; //@line 1469 "synthesize.cpp"
                  var $amp148=(($115+18)&4294967295); //@line 1469 "synthesize.cpp"
                  var $116=HEAPU8[($amp148)]; //@line 1469 "synthesize.cpp"
                  var $conv149=((($116))&255); //@line 1469 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv149, 0); //@line 1469 "synthesize.cpp"
                  var $117=$p; //@line 1470 "synthesize.cpp"
                  var $env150=(($117+14)&4294967295); //@line 1470 "synthesize.cpp"
                  var $118=HEAPU8[($env150)]; //@line 1470 "synthesize.cpp"
                  var $idxprom151=((($118))&255); //@line 1470 "synthesize.cpp"
                  var $arrayidx152=((_envelope_data+$idxprom151*4)&4294967295); //@line 1470 "synthesize.cpp"
                  var $119=HEAP32[(($arrayidx152)>>2)]; //@line 1470 "synthesize.cpp"
                  var $120=$p; //@line 1470 "synthesize.cpp"
                  var $pitch1153=(($120+20)&4294967295); //@line 1470 "synthesize.cpp"
                  var $121=HEAPU8[($pitch1153)]; //@line 1470 "synthesize.cpp"
                  var $conv154=((($121))&255); //@line 1470 "synthesize.cpp"
                  var $122=$p; //@line 1470 "synthesize.cpp"
                  var $pitch2155=(($122+21)&4294967295); //@line 1470 "synthesize.cpp"
                  var $123=HEAPU8[($pitch2155)]; //@line 1470 "synthesize.cpp"
                  var $conv156=((($123))&255); //@line 1470 "synthesize.cpp"
                  __ZL7DoPitchPhii($119, $conv154, $conv156); //@line 1470 "synthesize.cpp"
                  ; //@line 1471 "synthesize.cpp"
                }
              } while(0);
  
              var $124=$prev; //@line 1474 "synthesize.cpp"
              var $type160=(($124+15)&4294967295); //@line 1474 "synthesize.cpp"
              var $125=HEAPU8[($type160)]; //@line 1474 "synthesize.cpp"
              var $conv161=((($125))&255); //@line 1474 "synthesize.cpp"
              var $cmp162=((($conv161))|0)==2; //@line 1474 "synthesize.cpp"
              if ($cmp162) { __label__ = 54;; } else { __label__ = 52;; } //@line 1474 "synthesize.cpp"
              $if_then172$$lor_lhs_false163$71: do { 
                if (__label__ == 52) {
  
                  var $126=$prev; //@line 1474 "synthesize.cpp"
                  var $ph164=(($126+8)&4294967295); //@line 1474 "synthesize.cpp"
                  var $127=HEAP32[(($ph164)>>2)]; //@line 1474 "synthesize.cpp"
                  var $phflags165=(($127+4)&4294967295); //@line 1474 "synthesize.cpp"
                  var $128=HEAP32[(($phflags165)>>2)]; //@line 1474 "synthesize.cpp"
                  var $and166=($128) & 256; //@line 1474 "synthesize.cpp"
                  var $tobool167=((($and166))|0)!=0; //@line 1474 "synthesize.cpp"
                  if ($tobool167) { __label__ = 54;break $if_then172$$lor_lhs_false163$71; } //@line 1474 "synthesize.cpp"
  
                  var $129=$ph; //@line 1474 "synthesize.cpp"
                  var $phflags169=(($129+4)&4294967295); //@line 1474 "synthesize.cpp"
                  var $130=HEAP32[(($phflags169)>>2)]; //@line 1474 "synthesize.cpp"
                  var $and170=($130) & 33554432; //@line 1474 "synthesize.cpp"
                  var $tobool171=((($and170))|0)!=0; //@line 1474 "synthesize.cpp"
                  if ($tobool171) { __label__ = 54;break $if_then172$$lor_lhs_false163$71; } //@line 1474 "synthesize.cpp"
  
                  var $140=$p; //@line 1490 "synthesize.cpp"
                  var $synthflags184=(($140+4)&4294967295); //@line 1490 "synthesize.cpp"
                  var $141=HEAPU16[(($synthflags184)>>1)]; //@line 1490 "synthesize.cpp"
                  var $conv185=((($141))&65535); //@line 1490 "synthesize.cpp"
                  var $and186=($conv185) & 8; //@line 1490 "synthesize.cpp"
                  var $tobool187=((($and186))|0)!=0; //@line 1490 "synthesize.cpp"
                  if (!($tobool187)) { __label__ = 58;break $if_then172$$lor_lhs_false163$71; } //@line 1490 "synthesize.cpp"
  
                  __ZL7DoPauseii(50, 0); //@line 1492 "synthesize.cpp"
                  __label__ = 58;break $if_then172$$lor_lhs_false163$71; //@line 1493 "synthesize.cpp"
                }
              } while(0);
              $if_then172$$if_end190$76: do { 
                if (__label__ == 54) {
  
                  var $131=$p; //@line 1477 "synthesize.cpp"
                  __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 1, $131, $phdata); //@line 1477 "synthesize.cpp"
                  var $132=HEAP32[(($arrayidx173)>>2)]; //@line 1478 "synthesize.cpp"
                  HEAP32[(($fmt_addr)>>2)]=$132; //@line 1478 "synthesize.cpp"
                  var $133=HEAP32[(($arrayidx174)>>2)]; //@line 1479 "synthesize.cpp"
                  HEAP32[(($fmt_amp)>>2)]=$133; //@line 1479 "synthesize.cpp"
                  var $134=$ph; //@line 1481 "synthesize.cpp"
                  var $135=$p; //@line 1481 "synthesize.cpp"
                  var $call175=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($134, 0, $fmtp, $135, 0); //@line 1481 "synthesize.cpp"
                  var $136=$p; //@line 1482 "synthesize.cpp"
                  var $synthflags176=(($136+4)&4294967295); //@line 1482 "synthesize.cpp"
                  var $137=HEAPU16[(($synthflags176)>>1)]; //@line 1482 "synthesize.cpp"
                  var $conv177=((($137))&65535); //@line 1482 "synthesize.cpp"
                  var $and178=($conv177) & 8; //@line 1482 "synthesize.cpp"
                  var $tobool179=((($and178))|0)!=0; //@line 1482 "synthesize.cpp"
                  if (!($tobool179)) { __label__ = 58;break $if_then172$$if_end190$76; } //@line 1482 "synthesize.cpp"
  
                  __ZL7DoPauseii(25, 1); //@line 1484 "synthesize.cpp"
                  var $138=$ph; //@line 1485 "synthesize.cpp"
                  var $139=$p; //@line 1485 "synthesize.cpp"
                  var $call181=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($138, 0, $fmtp, $139, 0); //@line 1485 "synthesize.cpp"
                  ; //@line 1486 "synthesize.cpp"
                }
              } while(0);
  
              var $142=$pre_voiced; //@line 1496 "synthesize.cpp"
              var $tobool191=((($142))|0)!=0; //@line 1496 "synthesize.cpp"
              if ($tobool191) { __label__ = 59;; } else { __label__ = 60;; } //@line 1496 "synthesize.cpp"
              if (__label__ == 59) {
  
                __ZL13StartSyllablev(); //@line 1499 "synthesize.cpp"
                ; //@line 1500 "synthesize.cpp"
              }
              else if (__label__ == 60) {
  
                var $143=$p; //@line 1503 "synthesize.cpp"
                var $synthflags194=(($143+4)&4294967295); //@line 1503 "synthesize.cpp"
                var $144=HEAPU16[(($synthflags194)>>1)]; //@line 1503 "synthesize.cpp"
                var $conv195=((($144))&65535); //@line 1503 "synthesize.cpp"
                var $or196=($conv195) | 8192; //@line 1503 "synthesize.cpp"
                var $conv197=((($or196)) & 65535); //@line 1503 "synthesize.cpp"
                HEAP16[(($synthflags194)>>1)]=$conv197; //@line 1503 "synthesize.cpp"
                ;
              }
  
              var $145=$p; //@line 1505 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $145, $phdata); //@line 1505 "synthesize.cpp"
              var $146=HEAP32[(($arrayidx200)>>2)]; //@line 1506 "synthesize.cpp"
              HEAP32[(($fmt_addr201)>>2)]=$146; //@line 1506 "synthesize.cpp"
              var $147=HEAP32[(($arrayidx203)>>2)]; //@line 1507 "synthesize.cpp"
              HEAP32[(($fmt_amp204)>>2)]=$147; //@line 1507 "synthesize.cpp"
              var $148=HEAP32[(($arrayidx206)>>2)]; //@line 1508 "synthesize.cpp"
              HEAP32[(($wav_addr)>>2)]=$148; //@line 1508 "synthesize.cpp"
              var $149=HEAP32[(($arrayidx208)>>2)]; //@line 1509 "synthesize.cpp"
              HEAP32[(($wav_amp)>>2)]=$149; //@line 1509 "synthesize.cpp"
              var $150=$ph; //@line 1510 "synthesize.cpp"
              var $151=$p; //@line 1510 "synthesize.cpp"
              var $call209=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($150, 0, $fmtp, $151, 0); //@line 1510 "synthesize.cpp"
              var $152=$p; //@line 1512 "synthesize.cpp"
              var $newword210=(($152+19)&4294967295); //@line 1512 "synthesize.cpp"
              var $153=HEAPU8[($newword210)]; //@line 1512 "synthesize.cpp"
              var $conv211=((($153))&255); //@line 1512 "synthesize.cpp"
              var $cmp212=((($conv211))|0)==0; //@line 1512 "synthesize.cpp"
              if (!($cmp212)) { __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; } //@line 1512 "synthesize.cpp"
  
              var $154=$next2; //@line 1512 "synthesize.cpp"
              var $newword214=(($154+19)&4294967295); //@line 1512 "synthesize.cpp"
              var $155=HEAPU8[($newword214)]; //@line 1512 "synthesize.cpp"
              var $conv215=((($155))&255); //@line 1512 "synthesize.cpp"
              var $cmp216=((($conv215))|0)==0; //@line 1512 "synthesize.cpp"
              if (!($cmp216)) { __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; } //@line 1512 "synthesize.cpp"
  
              var $156=$next; //@line 1514 "synthesize.cpp"
              var $type218=(($156+15)&4294967295); //@line 1514 "synthesize.cpp"
              var $157=HEAPU8[($type218)]; //@line 1514 "synthesize.cpp"
              var $conv219=((($157))&255); //@line 1514 "synthesize.cpp"
              var $cmp220=((($conv219))|0)==7; //@line 1514 "synthesize.cpp"
              if ($cmp220) { __label__ = 64;; } else { __label__ = 65;; } //@line 1514 "synthesize.cpp"
              if (__label__ == 64) {
  
                __ZL7DoPauseii(20, 0); //@line 1515 "synthesize.cpp"
                ; //@line 1515 "synthesize.cpp"
              }
  
              var $158=$next; //@line 1516 "synthesize.cpp"
              var $type223=(($158+15)&4294967295); //@line 1516 "synthesize.cpp"
              var $159=HEAPU8[($type223)]; //@line 1516 "synthesize.cpp"
              var $conv224=((($159))&255); //@line 1516 "synthesize.cpp"
              var $cmp225=((($conv224))|0)==6; //@line 1516 "synthesize.cpp"
              if (!($cmp225)) { __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; } //@line 1516 "synthesize.cpp"
  
              __ZL7DoPauseii(12, 0); //@line 1517 "synthesize.cpp"
              ; //@line 1517 "synthesize.cpp"
            }
            else if (__label__ == 67) {
  
              var $160=$next; //@line 1522 "synthesize.cpp"
              var $type230=(($160+15)&4294967295); //@line 1522 "synthesize.cpp"
              var $161=HEAPU8[($type230)]; //@line 1522 "synthesize.cpp"
              var $conv231=((($161))&255); //@line 1522 "synthesize.cpp"
              var $cmp232=((($conv231))|0)==2; //@line 1522 "synthesize.cpp"
              if ($cmp232) { __label__ = 68;; } else { __label__ = 69;; } //@line 1522 "synthesize.cpp"
              $if_then233$$if_else243$91: do { 
                if (__label__ == 68) {
  
                  var $162=$p; //@line 1524 "synthesize.cpp"
                  var $amp234=(($162+18)&4294967295); //@line 1524 "synthesize.cpp"
                  var $163=HEAPU8[($amp234)]; //@line 1524 "synthesize.cpp"
                  var $conv235=((($163))&255); //@line 1524 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv235, 0); //@line 1524 "synthesize.cpp"
                  var $164=$p; //@line 1525 "synthesize.cpp"
                  var $env236=(($164+14)&4294967295); //@line 1525 "synthesize.cpp"
                  var $165=HEAPU8[($env236)]; //@line 1525 "synthesize.cpp"
                  var $idxprom237=((($165))&255); //@line 1525 "synthesize.cpp"
                  var $arrayidx238=((_envelope_data+$idxprom237*4)&4294967295); //@line 1525 "synthesize.cpp"
                  var $166=HEAP32[(($arrayidx238)>>2)]; //@line 1525 "synthesize.cpp"
                  var $167=$p; //@line 1525 "synthesize.cpp"
                  var $pitch1239=(($167+20)&4294967295); //@line 1525 "synthesize.cpp"
                  var $168=HEAPU8[($pitch1239)]; //@line 1525 "synthesize.cpp"
                  var $conv240=((($168))&255); //@line 1525 "synthesize.cpp"
                  var $169=$p; //@line 1525 "synthesize.cpp"
                  var $pitch2241=(($169+21)&4294967295); //@line 1525 "synthesize.cpp"
                  var $170=HEAPU8[($pitch2241)]; //@line 1525 "synthesize.cpp"
                  var $conv242=((($170))&255); //@line 1525 "synthesize.cpp"
                  __ZL7DoPitchPhii($166, $conv240, $conv242); //@line 1525 "synthesize.cpp"
                  ; //@line 1526 "synthesize.cpp"
                }
                else if (__label__ == 69) {
  
                  var $171=$next; //@line 1528 "synthesize.cpp"
                  var $type244=(($171+15)&4294967295); //@line 1528 "synthesize.cpp"
                  var $172=HEAPU8[($type244)]; //@line 1528 "synthesize.cpp"
                  var $conv245=((($172))&255); //@line 1528 "synthesize.cpp"
                  var $cmp246=((($conv245))|0)==3; //@line 1528 "synthesize.cpp"
                  if ($cmp246) { __label__ = 70;; } else { __label__ = 71;; } //@line 1528 "synthesize.cpp"
                  if (__label__ == 70) {
  
                    var $173=$next; //@line 1530 "synthesize.cpp"
                    var $amp248=(($173+18)&4294967295); //@line 1530 "synthesize.cpp"
                    var $174=HEAPU8[($amp248)]; //@line 1530 "synthesize.cpp"
                    var $conv249=((($174))&255); //@line 1530 "synthesize.cpp"
                    __ZL11DoAmplitudeiPh($conv249, 0); //@line 1530 "synthesize.cpp"
                    var $175=$next; //@line 1531 "synthesize.cpp"
                    var $env250=(($175+14)&4294967295); //@line 1531 "synthesize.cpp"
                    var $176=HEAPU8[($env250)]; //@line 1531 "synthesize.cpp"
                    var $idxprom251=((($176))&255); //@line 1531 "synthesize.cpp"
                    var $arrayidx252=((_envelope_data+$idxprom251*4)&4294967295); //@line 1531 "synthesize.cpp"
                    var $177=HEAP32[(($arrayidx252)>>2)]; //@line 1531 "synthesize.cpp"
                    var $178=$next; //@line 1531 "synthesize.cpp"
                    var $pitch1253=(($178+20)&4294967295); //@line 1531 "synthesize.cpp"
                    var $179=HEAPU8[($pitch1253)]; //@line 1531 "synthesize.cpp"
                    var $conv254=((($179))&255); //@line 1531 "synthesize.cpp"
                    var $180=$next; //@line 1531 "synthesize.cpp"
                    var $pitch2255=(($180+21)&4294967295); //@line 1531 "synthesize.cpp"
                    var $181=HEAPU8[($pitch2255)]; //@line 1531 "synthesize.cpp"
                    var $conv256=((($181))&255); //@line 1531 "synthesize.cpp"
                    __ZL7DoPitchPhii($177, $conv254, $conv256); //@line 1531 "synthesize.cpp"
                    ; //@line 1532 "synthesize.cpp"
                  }
                  else if (__label__ == 71) {
  
                    var $182=HEAP32[((__ZL14last_pitch_cmd)>>2)]; //@line 1535 "synthesize.cpp"
                    var $cmp258=((($182))|0) < 0; //@line 1535 "synthesize.cpp"
                    if (!($cmp258)) { __label__ = 73;break $if_then233$$if_else243$91; } //@line 1535 "synthesize.cpp"
  
                    var $183=$p; //@line 1537 "synthesize.cpp"
                    var $amp260=(($183+18)&4294967295); //@line 1537 "synthesize.cpp"
                    var $184=HEAPU8[($amp260)]; //@line 1537 "synthesize.cpp"
                    var $conv261=((($184))&255); //@line 1537 "synthesize.cpp"
                    __ZL11DoAmplitudeiPh($conv261, 0); //@line 1537 "synthesize.cpp"
                    var $185=$p; //@line 1538 "synthesize.cpp"
                    var $env262=(($185+14)&4294967295); //@line 1538 "synthesize.cpp"
                    var $186=HEAPU8[($env262)]; //@line 1538 "synthesize.cpp"
                    var $idxprom263=((($186))&255); //@line 1538 "synthesize.cpp"
                    var $arrayidx264=((_envelope_data+$idxprom263*4)&4294967295); //@line 1538 "synthesize.cpp"
                    var $187=HEAP32[(($arrayidx264)>>2)]; //@line 1538 "synthesize.cpp"
                    var $188=$p; //@line 1538 "synthesize.cpp"
                    var $pitch1265=(($188+20)&4294967295); //@line 1538 "synthesize.cpp"
                    var $189=HEAPU8[($pitch1265)]; //@line 1538 "synthesize.cpp"
                    var $conv266=((($189))&255); //@line 1538 "synthesize.cpp"
                    var $190=$p; //@line 1538 "synthesize.cpp"
                    var $pitch2267=(($190+21)&4294967295); //@line 1538 "synthesize.cpp"
                    var $191=HEAPU8[($pitch2267)]; //@line 1538 "synthesize.cpp"
                    var $conv268=((($191))&255); //@line 1538 "synthesize.cpp"
                    __ZL7DoPitchPhii($187, $conv266, $conv268); //@line 1538 "synthesize.cpp"
                    ; //@line 1539 "synthesize.cpp"
                  }
                }
              } while(0);
  
              var $192=$next; //@line 1542 "synthesize.cpp"
              var $type272=(($192+15)&4294967295); //@line 1542 "synthesize.cpp"
              var $193=HEAPU8[($type272)]; //@line 1542 "synthesize.cpp"
              var $conv273=((($193))&255); //@line 1542 "synthesize.cpp"
              var $cmp274=((($conv273))|0)==2; //@line 1542 "synthesize.cpp"
              if ($cmp274) { __label__ = 76;; } else { __label__ = 74;; } //@line 1542 "synthesize.cpp"
              $if_then283$$lor_lhs_false275$99: do { 
                if (__label__ == 74) {
  
                  var $194=$next; //@line 1542 "synthesize.cpp"
                  var $type276=(($194+15)&4294967295); //@line 1542 "synthesize.cpp"
                  var $195=HEAPU8[($type276)]; //@line 1542 "synthesize.cpp"
                  var $conv277=((($195))&255); //@line 1542 "synthesize.cpp"
                  var $cmp278=((($conv277))|0)==3; //@line 1542 "synthesize.cpp"
                  if ($cmp278) { __label__ = 75;; } else { __label__ = 77;; } //@line 1542 "synthesize.cpp"
                  if (__label__ == 75) {
  
                    var $196=$next; //@line 1542 "synthesize.cpp"
                    var $newword280=(($196+19)&4294967295); //@line 1542 "synthesize.cpp"
                    var $197=HEAPU8[($newword280)]; //@line 1542 "synthesize.cpp"
                    var $conv281=((($197))&255); //@line 1542 "synthesize.cpp"
                    var $cmp282=((($conv281))|0)==0; //@line 1542 "synthesize.cpp"
                    if ($cmp282) { __label__ = 76;break $if_then283$$lor_lhs_false275$99; } //@line 1542 "synthesize.cpp"
                  }
  
                  var $198=$p; //@line 1548 "synthesize.cpp"
                  var $synthflags285=(($198+4)&4294967295); //@line 1548 "synthesize.cpp"
                  var $199=HEAPU16[(($synthflags285)>>1)]; //@line 1548 "synthesize.cpp"
                  var $conv286=((($199))&65535); //@line 1548 "synthesize.cpp"
                  var $or287=($conv286) | 8192; //@line 1548 "synthesize.cpp"
                  var $conv288=((($or287)) & 65535); //@line 1548 "synthesize.cpp"
                  HEAP16[(($synthflags285)>>1)]=$conv288; //@line 1548 "synthesize.cpp"
                  __label__ = 78;break $if_then283$$lor_lhs_false275$99;
                }
              } while(0);
              if (__label__ == 76) {
  
                __ZL13StartSyllablev(); //@line 1544 "synthesize.cpp"
                ; //@line 1545 "synthesize.cpp"
              }
  
              var $200=$p; //@line 1550 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $200, $phdata); //@line 1550 "synthesize.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $9;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1551 "synthesize.cpp"
              var $201=HEAP32[(($arrayidx290)>>2)]; //@line 1552 "synthesize.cpp"
              var $mul=((($201)*2)&4294967295); //@line 1552 "synthesize.cpp"
              HEAP32[(($std_length)>>2)]=$mul; //@line 1552 "synthesize.cpp"
              var $202=HEAP32[(($arrayidx292)>>2)]; //@line 1553 "synthesize.cpp"
              HEAP32[(($fmt_addr293)>>2)]=$202; //@line 1553 "synthesize.cpp"
              var $203=HEAP32[(($arrayidx295)>>2)]; //@line 1554 "synthesize.cpp"
              HEAP32[(($fmt_amp296)>>2)]=$203; //@line 1554 "synthesize.cpp"
              var $204=HEAP32[(($arrayidx298)>>2)]; //@line 1555 "synthesize.cpp"
              HEAP32[(($wav_addr299)>>2)]=$204; //@line 1555 "synthesize.cpp"
              var $205=HEAP32[(($arrayidx301)>>2)]; //@line 1556 "synthesize.cpp"
              HEAP32[(($wav_amp302)>>2)]=$205; //@line 1556 "synthesize.cpp"
              var $206=$p; //@line 1558 "synthesize.cpp"
              var $synthflags303=(($206+4)&4294967295); //@line 1558 "synthesize.cpp"
              var $207=HEAPU16[(($synthflags303)>>1)]; //@line 1558 "synthesize.cpp"
              var $conv304=((($207))&65535); //@line 1558 "synthesize.cpp"
              var $and305=($conv304) & 8; //@line 1558 "synthesize.cpp"
              var $tobool306=((($and305))|0)!=0; //@line 1558 "synthesize.cpp"
              if ($tobool306) { __label__ = 79;; } else { __label__ = 80;; } //@line 1558 "synthesize.cpp"
              if (__label__ == 79) {
  
                var $208=$p; //@line 1559 "synthesize.cpp"
                var $ph308=(($208+8)&4294967295); //@line 1559 "synthesize.cpp"
                var $209=HEAP32[(($ph308)>>2)]; //@line 1559 "synthesize.cpp"
                var $210=$p; //@line 1559 "synthesize.cpp"
                var $call309=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($209, 0, $fmtp, $210, 0); //@line 1559 "synthesize.cpp"
                ; //@line 1559 "synthesize.cpp"
              }
  
              var $211=$p; //@line 1560 "synthesize.cpp"
              var $ph311=(($211+8)&4294967295); //@line 1560 "synthesize.cpp"
              var $212=HEAP32[(($ph311)>>2)]; //@line 1560 "synthesize.cpp"
              var $213=$p; //@line 1560 "synthesize.cpp"
              var $call312=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($212, 0, $fmtp, $213, 0); //@line 1560 "synthesize.cpp"
              ; //@line 1561 "synthesize.cpp"
            }
            else if (__label__ == 81) {
  
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $10;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1564 "synthesize.cpp"
              var $214=$p; //@line 1565 "synthesize.cpp"
              var $synthflags314=(($214+4)&4294967295); //@line 1565 "synthesize.cpp"
              var $215=HEAPU16[(($synthflags314)>>1)]; //@line 1565 "synthesize.cpp"
              var $conv315=((($215))&65535); //@line 1565 "synthesize.cpp"
              var $and316=($conv315) & 1; //@line 1565 "synthesize.cpp"
              var $tobool317=((($and316))|0)!=0; //@line 1565 "synthesize.cpp"
              if ($tobool317) { __label__ = 83;; } else { __label__ = 82;; } //@line 1565 "synthesize.cpp"
              if (__label__ == 82) {
  
                var $216=$p; //@line 1567 "synthesize.cpp"
                var $amp319=(($216+18)&4294967295); //@line 1567 "synthesize.cpp"
                var $217=HEAPU8[($amp319)]; //@line 1567 "synthesize.cpp"
                var $conv320=((($217))&255); //@line 1567 "synthesize.cpp"
                __ZL11DoAmplitudeiPh($conv320, 0); //@line 1567 "synthesize.cpp"
                var $218=$p; //@line 1568 "synthesize.cpp"
                var $env321=(($218+14)&4294967295); //@line 1568 "synthesize.cpp"
                var $219=HEAPU8[($env321)]; //@line 1568 "synthesize.cpp"
                var $idxprom322=((($219))&255); //@line 1568 "synthesize.cpp"
                var $arrayidx323=((_envelope_data+$idxprom322*4)&4294967295); //@line 1568 "synthesize.cpp"
                var $220=HEAP32[(($arrayidx323)>>2)]; //@line 1568 "synthesize.cpp"
                var $221=$p; //@line 1568 "synthesize.cpp"
                var $pitch1324=(($221+20)&4294967295); //@line 1568 "synthesize.cpp"
                var $222=HEAPU8[($pitch1324)]; //@line 1568 "synthesize.cpp"
                var $conv325=((($222))&255); //@line 1568 "synthesize.cpp"
                var $223=$p; //@line 1568 "synthesize.cpp"
                var $pitch2326=(($223+21)&4294967295); //@line 1568 "synthesize.cpp"
                var $224=HEAPU8[($pitch2326)]; //@line 1568 "synthesize.cpp"
                var $conv327=((($224))&255); //@line 1568 "synthesize.cpp"
                __ZL7DoPitchPhii($220, $conv325, $conv327); //@line 1568 "synthesize.cpp"
                ; //@line 1569 "synthesize.cpp"
              }
  
              var $225=$prev; //@line 1571 "synthesize.cpp"
              var $type329=(($225+15)&4294967295); //@line 1571 "synthesize.cpp"
              var $226=HEAPU8[($type329)]; //@line 1571 "synthesize.cpp"
              var $conv330=((($226))&255); //@line 1571 "synthesize.cpp"
              var $cmp331=((($conv330))|0)==8; //@line 1571 "synthesize.cpp"
              if ($cmp331) { __label__ = 84;; } else { __label__ = 85;; } //@line 1571 "synthesize.cpp"
              if (__label__ == 84) {
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1573 "synthesize.cpp"
                ; //@line 1574 "synthesize.cpp"
              }
  
              var $227=$p; //@line 1576 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $227, $phdata); //@line 1576 "synthesize.cpp"
              var $228=HEAP32[(($arrayidx335)>>2)]; //@line 1577 "synthesize.cpp"
              var $mul336=((($228)*2)&4294967295); //@line 1577 "synthesize.cpp"
              HEAP32[(($std_length337)>>2)]=$mul336; //@line 1577 "synthesize.cpp"
              var $229=HEAP32[(($arrayidx339)>>2)]; //@line 1578 "synthesize.cpp"
              HEAP32[(($fmt_addr340)>>2)]=$229; //@line 1578 "synthesize.cpp"
              var $230=HEAP32[(($arrayidx342)>>2)]; //@line 1579 "synthesize.cpp"
              HEAP32[(($fmt_amp343)>>2)]=$230; //@line 1579 "synthesize.cpp"
              var $231=$next; //@line 1581 "synthesize.cpp"
              var $type344=(($231+15)&4294967295); //@line 1581 "synthesize.cpp"
              var $232=HEAPU8[($type344)]; //@line 1581 "synthesize.cpp"
              var $conv345=((($232))&255); //@line 1581 "synthesize.cpp"
              var $cmp346=((($conv345))|0)==2; //@line 1581 "synthesize.cpp"
              if ($cmp346) { __label__ = 86;; } else { __label__ = 87;; } //@line 1581 "synthesize.cpp"
              if (__label__ == 86) {
  
                __ZL13StartSyllablev(); //@line 1583 "synthesize.cpp"
                var $233=$p; //@line 1584 "synthesize.cpp"
                var $ph348=(($233+8)&4294967295); //@line 1584 "synthesize.cpp"
                var $234=HEAP32[(($ph348)>>2)]; //@line 1584 "synthesize.cpp"
                var $235=$p; //@line 1584 "synthesize.cpp"
                var $call349=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($234, 0, $fmtp, $235, 0); //@line 1584 "synthesize.cpp"
                ; //@line 1585 "synthesize.cpp"
              }
              else if (__label__ == 87) {
  
                var $236=$prev; //@line 1587 "synthesize.cpp"
                var $type351=(($236+15)&4294967295); //@line 1587 "synthesize.cpp"
                var $237=HEAPU8[($type351)]; //@line 1587 "synthesize.cpp"
                var $conv352=((($237))&255); //@line 1587 "synthesize.cpp"
                var $cmp353=((($conv352))|0)==2; //@line 1587 "synthesize.cpp"
                if ($cmp353) { __label__ = 88;; } else { __label__ = 90;; } //@line 1587 "synthesize.cpp"
                $land_lhs_true354$$if_else362$120: do { 
                  if (__label__ == 88) {
  
                    var $238=$p; //@line 1587 "synthesize.cpp"
                    var $synthflags355=(($238+4)&4294967295); //@line 1587 "synthesize.cpp"
                    var $239=HEAPU16[(($synthflags355)>>1)]; //@line 1587 "synthesize.cpp"
                    var $conv356=((($239))&65535); //@line 1587 "synthesize.cpp"
                    var $and357=($conv356) & 1; //@line 1587 "synthesize.cpp"
                    var $tobool358=((($and357))|0)!=0; //@line 1587 "synthesize.cpp"
                    if (!($tobool358)) { __label__ = 90;break $land_lhs_true354$$if_else362$120; } //@line 1587 "synthesize.cpp"
  
                    var $240=$p; //@line 1589 "synthesize.cpp"
                    var $ph360=(($240+8)&4294967295); //@line 1589 "synthesize.cpp"
                    var $241=HEAP32[(($ph360)>>2)]; //@line 1589 "synthesize.cpp"
                    var $242=$p; //@line 1589 "synthesize.cpp"
                    var $call361=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($241, 0, $fmtp, $242, 0); //@line 1589 "synthesize.cpp"
                    __label__ = 133;break $sw_epilog$$sw_bb$$sw_bb81$$sw_bb105$$sw_bb118$$sw_bb229$$sw_bb313$$sw_bb367$$sw_bb418$45; //@line 1590 "synthesize.cpp"
                  }
                } while(0);
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1593 "synthesize.cpp"
                var $243=$p; //@line 1594 "synthesize.cpp"
                var $ph363=(($243+8)&4294967295); //@line 1594 "synthesize.cpp"
                var $244=HEAP32[(($ph363)>>2)]; //@line 1594 "synthesize.cpp"
                var $245=$p; //@line 1594 "synthesize.cpp"
                var $call364=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($244, 0, $fmtp, $245, 0); //@line 1594 "synthesize.cpp"
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1595 "synthesize.cpp"
                ;
              }
            }
            else if (__label__ == 91) {
  
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $11;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1601 "synthesize.cpp"
              $modulation=0; //@line 1602 "synthesize.cpp"
              var $246=$p; //@line 1603 "synthesize.cpp"
              var $ph368=(($246+8)&4294967295); //@line 1603 "synthesize.cpp"
              var $247=HEAP32[(($ph368)>>2)]; //@line 1603 "synthesize.cpp"
              var $phflags369=(($247+4)&4294967295); //@line 1603 "synthesize.cpp"
              var $248=HEAP32[(($phflags369)>>2)]; //@line 1603 "synthesize.cpp"
              var $and370=($248) & 128; //@line 1603 "synthesize.cpp"
              var $tobool371=((($and370))|0)!=0; //@line 1603 "synthesize.cpp"
              if ($tobool371) { __label__ = 92;; } else { __label__ = 93;; } //@line 1603 "synthesize.cpp"
              if (__label__ == 92) {
  
                $modulation=5; //@line 1604 "synthesize.cpp"
                ; //@line 1604 "synthesize.cpp"
              }
  
              var $249=$prev; //@line 1606 "synthesize.cpp"
              var $ph374=(($249+8)&4294967295); //@line 1606 "synthesize.cpp"
              var $250=HEAP32[(($ph374)>>2)]; //@line 1606 "synthesize.cpp"
              $prev_ph=$250; //@line 1606 "synthesize.cpp"
              var $251=$p; //@line 1610 "synthesize.cpp"
              var $synthflags375=(($251+4)&4294967295); //@line 1610 "synthesize.cpp"
              var $252=HEAPU16[(($synthflags375)>>1)]; //@line 1610 "synthesize.cpp"
              var $conv376=((($252))&65535); //@line 1610 "synthesize.cpp"
              var $and377=($conv376) & 1; //@line 1610 "synthesize.cpp"
              var $tobool378=((($and377))|0)!=0; //@line 1610 "synthesize.cpp"
              if ($tobool378) { __label__ = 95;; } else { __label__ = 94;; } //@line 1610 "synthesize.cpp"
              if (__label__ == 94) {
  
                var $253=$p; //@line 1612 "synthesize.cpp"
                var $amp380=(($253+18)&4294967295); //@line 1612 "synthesize.cpp"
                var $254=HEAPU8[($amp380)]; //@line 1612 "synthesize.cpp"
                var $conv381=((($254))&255); //@line 1612 "synthesize.cpp"
                __ZL11DoAmplitudeiPh($conv381, 0); //@line 1612 "synthesize.cpp"
                var $255=$p; //@line 1613 "synthesize.cpp"
                var $env382=(($255+14)&4294967295); //@line 1613 "synthesize.cpp"
                var $256=HEAPU8[($env382)]; //@line 1613 "synthesize.cpp"
                var $idxprom383=((($256))&255); //@line 1613 "synthesize.cpp"
                var $arrayidx384=((_envelope_data+$idxprom383*4)&4294967295); //@line 1613 "synthesize.cpp"
                var $257=HEAP32[(($arrayidx384)>>2)]; //@line 1613 "synthesize.cpp"
                var $258=$p; //@line 1613 "synthesize.cpp"
                var $pitch1385=(($258+20)&4294967295); //@line 1613 "synthesize.cpp"
                var $259=HEAPU8[($pitch1385)]; //@line 1613 "synthesize.cpp"
                var $conv386=((($259))&255); //@line 1613 "synthesize.cpp"
                var $260=$p; //@line 1613 "synthesize.cpp"
                var $pitch2387=(($260+21)&4294967295); //@line 1613 "synthesize.cpp"
                var $261=HEAPU8[($pitch2387)]; //@line 1613 "synthesize.cpp"
                var $conv388=((($261))&255); //@line 1613 "synthesize.cpp"
                __ZL7DoPitchPhii($257, $conv386, $conv388); //@line 1613 "synthesize.cpp"
                ; //@line 1614 "synthesize.cpp"
              }
  
              var $262=$prev; //@line 1616 "synthesize.cpp"
              var $type390=(($262+15)&4294967295); //@line 1616 "synthesize.cpp"
              var $263=HEAPU8[($type390)]; //@line 1616 "synthesize.cpp"
              var $conv391=((($263))&255); //@line 1616 "synthesize.cpp"
              var $cmp392=((($conv391))|0)==8; //@line 1616 "synthesize.cpp"
              if ($cmp392) { __label__ = 96;; } else { __label__ = 97;; } //@line 1616 "synthesize.cpp"
              if (__label__ == 96) {
  
                HEAP32[((__ZL10last_frame)>>2)]=0; //@line 1618 "synthesize.cpp"
                ; //@line 1619 "synthesize.cpp"
              }
  
              var $264=$next; //@line 1621 "synthesize.cpp"
              var $type395=(($264+15)&4294967295); //@line 1621 "synthesize.cpp"
              var $265=HEAPU8[($type395)]; //@line 1621 "synthesize.cpp"
              var $conv396=((($265))&255); //@line 1621 "synthesize.cpp"
              var $cmp397=((($conv396))|0)==2; //@line 1621 "synthesize.cpp"
              if ($cmp397) { __label__ = 98;; } else { __label__ = 99;; } //@line 1621 "synthesize.cpp"
              if (__label__ == 98) {
  
                __ZL13StartSyllablev(); //@line 1623 "synthesize.cpp"
                ; //@line 1624 "synthesize.cpp"
              }
  
              var $266=$p; //@line 1625 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $266, $phdata); //@line 1625 "synthesize.cpp"
              var $267=HEAP32[(($arrayidx401)>>2)]; //@line 1626 "synthesize.cpp"
              var $mul402=((($267)*2)&4294967295); //@line 1626 "synthesize.cpp"
              HEAP32[(($std_length403)>>2)]=$mul402; //@line 1626 "synthesize.cpp"
              var $268=HEAP32[(($arrayidx405)>>2)]; //@line 1627 "synthesize.cpp"
              HEAP32[(($fmt_addr406)>>2)]=$268; //@line 1627 "synthesize.cpp"
              var $269=HEAP32[(($arrayidx408)>>2)]; //@line 1628 "synthesize.cpp"
              HEAP32[(($fmt_amp409)>>2)]=$269; //@line 1628 "synthesize.cpp"
              var $270=HEAP32[(($arrayidx411)>>2)]; //@line 1629 "synthesize.cpp"
              HEAP32[(($wav_addr412)>>2)]=$270; //@line 1629 "synthesize.cpp"
              var $271=HEAP32[(($arrayidx414)>>2)]; //@line 1630 "synthesize.cpp"
              HEAP32[(($wav_amp415)>>2)]=$271; //@line 1630 "synthesize.cpp"
              var $272=$p; //@line 1631 "synthesize.cpp"
              var $ph416=(($272+8)&4294967295); //@line 1631 "synthesize.cpp"
              var $273=HEAP32[(($ph416)>>2)]; //@line 1631 "synthesize.cpp"
              var $274=$p; //@line 1631 "synthesize.cpp"
              var $275=$modulation; //@line 1631 "synthesize.cpp"
              var $call417=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($273, 0, $fmtp, $274, $275); //@line 1631 "synthesize.cpp"
              ; //@line 1633 "synthesize.cpp"
            }
            else if (__label__ == 100) {
  
              var $276=$p; //@line 1636 "synthesize.cpp"
              var $ph419=(($276+8)&4294967295); //@line 1636 "synthesize.cpp"
              var $277=HEAP32[(($ph419)>>2)]; //@line 1636 "synthesize.cpp"
              $ph=$277; //@line 1636 "synthesize.cpp"
              var $278=$p; //@line 1637 "synthesize.cpp"
              var $stresslevel=(($278+1)&4294967295); //@line 1637 "synthesize.cpp"
              var $279=HEAPU8[($stresslevel)]; //@line 1637 "synthesize.cpp"
              var $conv420=((($279))&255); //@line 1637 "synthesize.cpp"
              var $and421=($conv420) & 15; //@line 1637 "synthesize.cpp"
              $stress=$and421; //@line 1637 "synthesize.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $12;
              $stop$ = $dest$ + 48;
              $value4$ = 0;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 0;
              }; //@line 1639 "synthesize.cpp"
              var $280=$p; //@line 1641 "synthesize.cpp"
              __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $280, $phdata); //@line 1641 "synthesize.cpp"
              var $281=HEAP32[(($arrayidx423)>>2)]; //@line 1642 "synthesize.cpp"
              var $mul424=((($281)*2)&4294967295); //@line 1642 "synthesize.cpp"
              HEAP32[(($std_length425)>>2)]=$mul424; //@line 1642 "synthesize.cpp"
              var $282=HEAP32[(($arrayidx427)>>2)]; //@line 1644 "synthesize.cpp"
              HEAP32[(($fmt_addr428)>>2)]=$282; //@line 1644 "synthesize.cpp"
              var $cmp429=((($282))|0)!=0; //@line 1644 "synthesize.cpp"
              if ($cmp429) { __label__ = 101;; } else { __label__ = 103;; } //@line 1644 "synthesize.cpp"
              $land_lhs_true430$$if_else437$138: do { 
                if (__label__ == 101) {
  
                  var $283=HEAP32[(($pd_control431)>>2)]; //@line 1644 "synthesize.cpp"
                  var $and432=($283) & 2; //@line 1644 "synthesize.cpp"
                  var $cmp433=((($and432))|0)==0; //@line 1644 "synthesize.cpp"
                  if (!($cmp433)) { __label__ = 103;break $land_lhs_true430$$if_else437$138; } //@line 1644 "synthesize.cpp"
  
                  var $284=HEAP32[(($arrayidx436)>>2)]; //@line 1647 "synthesize.cpp"
                  HEAP32[(($fmt_length)>>2)]=$284; //@line 1647 "synthesize.cpp"
                  __label__ = 107;break $land_lhs_true430$$if_else437$138; //@line 1648 "synthesize.cpp"
                }
              } while(0);
              $if_end454$$if_else437$141: do { 
                if (__label__ == 103) {
  
                  var $285=$prev; //@line 1650 "synthesize.cpp"
                  var $type438=(($285+15)&4294967295); //@line 1650 "synthesize.cpp"
                  var $286=HEAPU8[($type438)]; //@line 1650 "synthesize.cpp"
                  var $conv439=((($286))&255); //@line 1650 "synthesize.cpp"
                  var $cmp440=((($conv439))|0)!=0; //@line 1650 "synthesize.cpp"
                  if (!($cmp440)) { __label__ = 107;break $if_end454$$if_else437$141; } //@line 1650 "synthesize.cpp"
  
                  var $287=$prev; //@line 1653 "synthesize.cpp"
                  __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $287, $phdata_prev); //@line 1653 "synthesize.cpp"
                  var $288=HEAP32[(($arrayidx443)>>2)]; //@line 1654 "synthesize.cpp"
                  HEAP32[(($fmt_addr444)>>2)]=$288; //@line 1654 "synthesize.cpp"
                  var $cmp445=((($288))|0)!=0; //@line 1654 "synthesize.cpp"
                  if ($cmp445) { __label__ = 105;; } else { __label__ = 106;; } //@line 1654 "synthesize.cpp"
                  if (__label__ == 105) {
  
                    var $289=HEAP32[(($arrayidx448)>>2)]; //@line 1657 "synthesize.cpp"
                    HEAP32[(($fmt2_lenadj)>>2)]=$289; //@line 1657 "synthesize.cpp"
                    ; //@line 1658 "synthesize.cpp"
                  }
  
                  var $290=HEAP32[(($arrayidx450)>>2)]; //@line 1659 "synthesize.cpp"
                  HEAP32[(($transition0)>>2)]=$290; //@line 1659 "synthesize.cpp"
                  var $291=HEAP32[(($arrayidx452)>>2)]; //@line 1660 "synthesize.cpp"
                  HEAP32[(($transition1)>>2)]=$291; //@line 1660 "synthesize.cpp"
                  ; //@line 1661 "synthesize.cpp"
                }
              } while(0);
  
              var $292=HEAP32[(($fmt_addr455)>>2)]; //@line 1663 "synthesize.cpp"
              var $cmp456=((($292))|0)==0; //@line 1663 "synthesize.cpp"
              if ($cmp456) { __label__ = 108;; } else { __label__ = 109;; } //@line 1663 "synthesize.cpp"
              if (__label__ == 108) {
  
                HEAP32[(($use_vowelin)>>2)]=1; //@line 1666 "synthesize.cpp"
                HEAP32[(($fmt_control458)>>2)]=1; //@line 1667 "synthesize.cpp"
                var $293=HEAP32[(($arrayidx460)>>2)]; //@line 1668 "synthesize.cpp"
                HEAP32[(($fmt_addr461)>>2)]=$293; //@line 1668 "synthesize.cpp"
                ; //@line 1669 "synthesize.cpp"
              }
  
              var $294=HEAP32[(($arrayidx464)>>2)]; //@line 1671 "synthesize.cpp"
              HEAP32[(($fmt_amp465)>>2)]=$294; //@line 1671 "synthesize.cpp"
              var $295=$p; //@line 1673 "synthesize.cpp"
              var $env466=(($295+14)&4294967295); //@line 1673 "synthesize.cpp"
              var $296=HEAPU8[($env466)]; //@line 1673 "synthesize.cpp"
              var $idxprom467=((($296))&255); //@line 1673 "synthesize.cpp"
              var $arrayidx468=((_envelope_data+$idxprom467*4)&4294967295); //@line 1673 "synthesize.cpp"
              var $297=HEAP32[(($arrayidx468)>>2)]; //@line 1673 "synthesize.cpp"
              $pitch_env=$297; //@line 1673 "synthesize.cpp"
              $amp_env=0; //@line 1674 "synthesize.cpp"
              var $298=$p; //@line 1675 "synthesize.cpp"
              var $tone_ph=(($298+3)&4294967295); //@line 1675 "synthesize.cpp"
              var $299=HEAPU8[($tone_ph)]; //@line 1675 "synthesize.cpp"
              var $conv469=((($299))&255); //@line 1675 "synthesize.cpp"
              var $cmp470=((($conv469))|0)!=0; //@line 1675 "synthesize.cpp"
              if ($cmp470) { __label__ = 110;; } else { __label__ = 112;; } //@line 1675 "synthesize.cpp"
              $if_then471$$if_end482$151: do { 
                if (__label__ == 110) {
  
                  var $300=$p; //@line 1677 "synthesize.cpp"
                  var $tone_ph472=(($300+3)&4294967295); //@line 1677 "synthesize.cpp"
                  var $301=HEAPU8[($tone_ph472)]; //@line 1677 "synthesize.cpp"
                  var $conv473=((($301))&255); //@line 1677 "synthesize.cpp"
                  __Z17InterpretPhoneme2iP12PHONEME_DATA($conv473, $phdata_tone); //@line 1677 "synthesize.cpp"
                  var $302=HEAP32[(($pitch_env474)>>2)]; //@line 1678 "synthesize.cpp"
                  var $call475=__Z11GetEnvelopei($302); //@line 1678 "synthesize.cpp"
                  $pitch_env=$call475; //@line 1678 "synthesize.cpp"
                  var $303=HEAP32[(($amp_env476)>>2)]; //@line 1679 "synthesize.cpp"
                  var $cmp477=((($303))|0) > 0; //@line 1679 "synthesize.cpp"
                  if (!($cmp477)) { __label__ = 112;break $if_then471$$if_end482$151; } //@line 1679 "synthesize.cpp"
  
                  var $304=HEAP32[(($amp_env479)>>2)]; //@line 1680 "synthesize.cpp"
                  var $call480=__Z11GetEnvelopei($304); //@line 1680 "synthesize.cpp"
                  $amp_env=$call480; //@line 1680 "synthesize.cpp"
                  ; //@line 1680 "synthesize.cpp"
                }
              } while(0);
  
              __ZL13StartSyllablev(); //@line 1683 "synthesize.cpp"
              $modulation=2; //@line 1685 "synthesize.cpp"
              var $305=$stress; //@line 1686 "synthesize.cpp"
              var $cmp483=((($305))|0) <= 1; //@line 1686 "synthesize.cpp"
              if ($cmp483) { __label__ = 113;; } else { __label__ = 114;; } //@line 1686 "synthesize.cpp"
              $if_then484$$if_else485$155: do { 
                if (__label__ == 113) {
  
                  $modulation=1; //@line 1687 "synthesize.cpp"
                  ; //@line 1687 "synthesize.cpp"
                }
                else if (__label__ == 114) {
  
                  var $306=$stress; //@line 1689 "synthesize.cpp"
                  var $cmp486=((($306))|0) >= 7; //@line 1689 "synthesize.cpp"
                  if (!($cmp486)) { __label__ = 116;break $if_then484$$if_else485$155; } //@line 1689 "synthesize.cpp"
  
                  $modulation=3; //@line 1690 "synthesize.cpp"
                  ; //@line 1690 "synthesize.cpp"
                }
              } while(0);
  
              var $307=$prev; //@line 1692 "synthesize.cpp"
              var $type490=(($307+15)&4294967295); //@line 1692 "synthesize.cpp"
              var $308=HEAPU8[($type490)]; //@line 1692 "synthesize.cpp"
              var $conv491=((($308))&255); //@line 1692 "synthesize.cpp"
              var $cmp492=((($conv491))|0)==5; //@line 1692 "synthesize.cpp"
              if ($cmp492) { __label__ = 118;; } else { __label__ = 117;; } //@line 1692 "synthesize.cpp"
              $if_then497$$lor_lhs_false493$160: do { 
                if (__label__ == 117) {
  
                  var $309=$prev; //@line 1692 "synthesize.cpp"
                  var $type494=(($309+15)&4294967295); //@line 1692 "synthesize.cpp"
                  var $310=HEAPU8[($type494)]; //@line 1692 "synthesize.cpp"
                  var $conv495=((($310))&255); //@line 1692 "synthesize.cpp"
                  var $cmp496=((($conv495))|0)==7; //@line 1692 "synthesize.cpp"
                  if ($cmp496) { __label__ = 118;break $if_then497$$lor_lhs_false493$160; } //@line 1692 "synthesize.cpp"
  
                  var $322=$prev; //@line 1699 "synthesize.cpp"
                  var $type506=(($322+15)&4294967295); //@line 1699 "synthesize.cpp"
                  var $323=HEAPU8[($type506)]; //@line 1699 "synthesize.cpp"
                  var $conv507=((($323))&255); //@line 1699 "synthesize.cpp"
                  var $cmp508=((($conv507))|0)==3; //@line 1699 "synthesize.cpp"
                  if ($cmp508) { __label__ = 121;; } else { __label__ = 120;; } //@line 1699 "synthesize.cpp"
                  $if_then513$$lor_lhs_false509$163: do { 
                    if (__label__ == 120) {
  
                      var $324=$prev; //@line 1699 "synthesize.cpp"
                      var $type510=(($324+15)&4294967295); //@line 1699 "synthesize.cpp"
                      var $325=HEAPU8[($type510)]; //@line 1699 "synthesize.cpp"
                      var $conv511=((($325))&255); //@line 1699 "synthesize.cpp"
                      var $cmp512=((($conv511))|0)==8; //@line 1699 "synthesize.cpp"
                      if ($cmp512) { __label__ = 121;break $if_then513$$lor_lhs_false509$163; } //@line 1699 "synthesize.cpp"
  
                      var $337=$p; //@line 1707 "synthesize.cpp"
                      var $synthflags522=(($337+4)&4294967295); //@line 1707 "synthesize.cpp"
                      var $338=HEAPU16[(($synthflags522)>>1)]; //@line 1707 "synthesize.cpp"
                      var $conv523=((($338))&65535); //@line 1707 "synthesize.cpp"
                      var $and524=($conv523) & 1; //@line 1707 "synthesize.cpp"
                      var $tobool525=((($and524))|0)!=0; //@line 1707 "synthesize.cpp"
                      if ($tobool525) { __label__ = 124;; } else { __label__ = 123;; } //@line 1707 "synthesize.cpp"
                      if (__label__ == 123) {
  
                        var $339=$p; //@line 1709 "synthesize.cpp"
                        var $amp527=(($339+18)&4294967295); //@line 1709 "synthesize.cpp"
                        var $340=HEAPU8[($amp527)]; //@line 1709 "synthesize.cpp"
                        var $conv528=((($340))&255); //@line 1709 "synthesize.cpp"
                        var $341=$amp_env; //@line 1709 "synthesize.cpp"
                        __ZL11DoAmplitudeiPh($conv528, $341); //@line 1709 "synthesize.cpp"
                        var $342=$pitch_env; //@line 1710 "synthesize.cpp"
                        var $343=$p; //@line 1710 "synthesize.cpp"
                        var $pitch1529=(($343+20)&4294967295); //@line 1710 "synthesize.cpp"
                        var $344=HEAPU8[($pitch1529)]; //@line 1710 "synthesize.cpp"
                        var $conv530=((($344))&255); //@line 1710 "synthesize.cpp"
                        var $345=$p; //@line 1710 "synthesize.cpp"
                        var $pitch2531=(($345+21)&4294967295); //@line 1710 "synthesize.cpp"
                        var $346=HEAPU8[($pitch2531)]; //@line 1710 "synthesize.cpp"
                        var $conv532=((($346))&255); //@line 1710 "synthesize.cpp"
                        __ZL7DoPitchPhii($342, $conv530, $conv532); //@line 1710 "synthesize.cpp"
                        ; //@line 1711 "synthesize.cpp"
                      }
  
                      var $347=$ph; //@line 1713 "synthesize.cpp"
                      var $348=$p; //@line 1713 "synthesize.cpp"
                      var $349=$modulation; //@line 1713 "synthesize.cpp"
                      var $call534=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($347, 1, $fmtp, $348, $349); //@line 1713 "synthesize.cpp"
                      __label__ = 125;break $if_then497$$lor_lhs_false493$160;
                    }
                  } while(0);
  
                  var $326=$p; //@line 1701 "synthesize.cpp"
                  var $amp514=(($326+18)&4294967295); //@line 1701 "synthesize.cpp"
                  var $327=HEAPU8[($amp514)]; //@line 1701 "synthesize.cpp"
                  var $conv515=((($327))&255); //@line 1701 "synthesize.cpp"
                  var $328=$amp_env; //@line 1701 "synthesize.cpp"
                  __ZL11DoAmplitudeiPh($conv515, $328); //@line 1701 "synthesize.cpp"
                  var $329=$ph; //@line 1702 "synthesize.cpp"
                  var $330=$p; //@line 1702 "synthesize.cpp"
                  var $331=$modulation; //@line 1702 "synthesize.cpp"
                  var $call516=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($329, 1, $fmtp, $330, $331); //@line 1702 "synthesize.cpp"
                  var $332=$pitch_env; //@line 1703 "synthesize.cpp"
                  var $333=$p; //@line 1703 "synthesize.cpp"
                  var $pitch1517=(($333+20)&4294967295); //@line 1703 "synthesize.cpp"
                  var $334=HEAPU8[($pitch1517)]; //@line 1703 "synthesize.cpp"
                  var $conv518=((($334))&255); //@line 1703 "synthesize.cpp"
                  var $335=$p; //@line 1703 "synthesize.cpp"
                  var $pitch2519=(($335+21)&4294967295); //@line 1703 "synthesize.cpp"
                  var $336=HEAPU8[($pitch2519)]; //@line 1703 "synthesize.cpp"
                  var $conv520=((($336))&255); //@line 1703 "synthesize.cpp"
                  __ZL7DoPitchPhii($332, $conv518, $conv520); //@line 1703 "synthesize.cpp"
                  __label__ = 125;break $if_then497$$lor_lhs_false493$160; //@line 1704 "synthesize.cpp"
                }
              } while(0);
              if (__label__ == 118) {
  
                var $311=$p; //@line 1694 "synthesize.cpp"
                var $amp498=(($311+18)&4294967295); //@line 1694 "synthesize.cpp"
                var $312=HEAPU8[($amp498)]; //@line 1694 "synthesize.cpp"
                var $conv499=((($312))&255); //@line 1694 "synthesize.cpp"
                var $313=$amp_env; //@line 1694 "synthesize.cpp"
                __ZL11DoAmplitudeiPh($conv499, $313); //@line 1694 "synthesize.cpp"
                var $314=$pitch_env; //@line 1695 "synthesize.cpp"
                var $315=$p; //@line 1695 "synthesize.cpp"
                var $pitch1500=(($315+20)&4294967295); //@line 1695 "synthesize.cpp"
                var $316=HEAPU8[($pitch1500)]; //@line 1695 "synthesize.cpp"
                var $conv501=((($316))&255); //@line 1695 "synthesize.cpp"
                var $317=$p; //@line 1695 "synthesize.cpp"
                var $pitch2502=(($317+21)&4294967295); //@line 1695 "synthesize.cpp"
                var $318=HEAPU8[($pitch2502)]; //@line 1695 "synthesize.cpp"
                var $conv503=((($318))&255); //@line 1695 "synthesize.cpp"
                __ZL7DoPitchPhii($314, $conv501, $conv503); //@line 1695 "synthesize.cpp"
                var $319=$ph; //@line 1696 "synthesize.cpp"
                var $320=$p; //@line 1696 "synthesize.cpp"
                var $321=$modulation; //@line 1696 "synthesize.cpp"
                var $call504=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($319, 1, $fmtp, $320, $321); //@line 1696 "synthesize.cpp"
                ; //@line 1697 "synthesize.cpp"
              }
  
              var $350=HEAP32[((_option_phoneme_events)>>2)]; //@line 1716 "synthesize.cpp"
              var $tobool537=((($350))|0)!=0; //@line 1716 "synthesize.cpp"
              if ($tobool537) { __label__ = 126;; } else { __label__ = 127;; } //@line 1716 "synthesize.cpp"
              if (__label__ == 126) {
  
                var $351=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix)>>2)]; //@line 1718 "synthesize.cpp"
                var $352=$p; //@line 1718 "synthesize.cpp"
                var $ph539=(($352+8)&4294967295); //@line 1718 "synthesize.cpp"
                var $353=HEAP32[(($ph539)>>2)]; //@line 1718 "synthesize.cpp"
                var $mnemonic540=(($353)&4294967295); //@line 1718 "synthesize.cpp"
                var $354=HEAP32[(($mnemonic540)>>2)]; //@line 1718 "synthesize.cpp"
                __Z8DoMarkeriiii(7, $351, 0, $354); //@line 1718 "synthesize.cpp"
                ; //@line 1719 "synthesize.cpp"
              }
  
              var $355=HEAP32[(($arrayidx543)>>2)]; //@line 1721 "synthesize.cpp"
              HEAP32[(($fmt_addr544)>>2)]=$355; //@line 1721 "synthesize.cpp"
              var $356=HEAP32[(($arrayidx546)>>2)]; //@line 1722 "synthesize.cpp"
              HEAP32[(($fmt_amp547)>>2)]=$356; //@line 1722 "synthesize.cpp"
              HEAP32[(($transition0548)>>2)]=0; //@line 1723 "synthesize.cpp"
              HEAP32[(($transition1549)>>2)]=0; //@line 1724 "synthesize.cpp"
              var $357=HEAP32[(($arrayidx551)>>2)]; //@line 1726 "synthesize.cpp"
              HEAP32[(($fmt2_addr)>>2)]=$357; //@line 1726 "synthesize.cpp"
              var $cmp552=((($357))|0)!=0; //@line 1726 "synthesize.cpp"
              if ($cmp552) { __label__ = 128;; } else { __label__ = 129;; } //@line 1726 "synthesize.cpp"
              $if_then553$$if_else557$176: do { 
                if (__label__ == 128) {
  
                  var $358=HEAP32[(($arrayidx555)>>2)]; //@line 1728 "synthesize.cpp"
                  HEAP32[(($fmt2_lenadj556)>>2)]=$358; //@line 1728 "synthesize.cpp"
                  ; //@line 1729 "synthesize.cpp"
                }
                else if (__label__ == 129) {
  
                  var $359=$next; //@line 1731 "synthesize.cpp"
                  var $type558=(($359+15)&4294967295); //@line 1731 "synthesize.cpp"
                  var $360=HEAPU8[($type558)]; //@line 1731 "synthesize.cpp"
                  var $conv559=((($360))&255); //@line 1731 "synthesize.cpp"
                  var $cmp560=((($conv559))|0)!=0; //@line 1731 "synthesize.cpp"
                  if (!($cmp560)) { __label__ = 132;break $if_then553$$if_else557$176; } //@line 1731 "synthesize.cpp"
  
                  HEAP32[(($fmt2_lenadj562)>>2)]=0; //@line 1733 "synthesize.cpp"
                  var $361=$next; //@line 1734 "synthesize.cpp"
                  __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA(0, 0, $361, $phdata_next); //@line 1734 "synthesize.cpp"
                  HEAP32[(($use_vowelin563)>>2)]=1; //@line 1736 "synthesize.cpp"
                  var $362=HEAP32[(($arrayidx565)>>2)]; //@line 1737 "synthesize.cpp"
                  HEAP32[(($transition0566)>>2)]=$362; //@line 1737 "synthesize.cpp"
                  var $363=HEAP32[(($arrayidx568)>>2)]; //@line 1738 "synthesize.cpp"
                  HEAP32[(($transition1569)>>2)]=$363; //@line 1738 "synthesize.cpp"
                  var $364=HEAP32[(($arrayidx571)>>2)]; //@line 1740 "synthesize.cpp"
                  HEAP32[(($fmt2_addr572)>>2)]=$364; //@line 1740 "synthesize.cpp"
                  var $cmp573=((($364))|0)!=0; //@line 1740 "synthesize.cpp"
                  if (!($cmp573)) { __label__ = 132;break $if_then553$$if_else557$176; } //@line 1740 "synthesize.cpp"
  
                  var $365=HEAP32[(($arrayidx576)>>2)]; //@line 1742 "synthesize.cpp"
                  HEAP32[(($fmt2_lenadj577)>>2)]=$365; //@line 1742 "synthesize.cpp"
                  ; //@line 1743 "synthesize.cpp"
                }
              } while(0);
  
              var $366=$ph; //@line 1746 "synthesize.cpp"
              var $367=$p; //@line 1746 "synthesize.cpp"
              var $368=$modulation; //@line 1746 "synthesize.cpp"
              var $call581=__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi($366, 2, $fmtp, $367, $368); //@line 1746 "synthesize.cpp"
              ; //@line 1748 "synthesize.cpp"
            }
          } while(0);
  
          var $369=HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]; //@line 1750 "synthesize.cpp"
          var $inc582=((($369)+1)&4294967295); //@line 1750 "synthesize.cpp"
          HEAP32[((__ZZ8GenerateP12PHONEME_LISTPiiE2ix)>>2)]=$inc582; //@line 1750 "synthesize.cpp"
          __label__ = 7;continue $while_cond$11; //@line 1751 "synthesize.cpp"
        }
        if (__label__ == 134) {
  
          __ZL8EndPitchi(1); //@line 1752 "synthesize.cpp"
          var $370=$n_ph_addr; //@line 1753 "synthesize.cpp"
          var $371=HEAP32[(($370)>>2)]; //@line 1753 "synthesize.cpp"
          var $cmp583=((($371))|0) > 0; //@line 1753 "synthesize.cpp"
          if ($cmp583) { __label__ = 135;; } else { __label__ = 136;; } //@line 1753 "synthesize.cpp"
          if (__label__ == 135) {
  
            var $372=HEAP32[((_count_characters)>>2)]; //@line 1755 "synthesize.cpp"
            var $373=HEAP32[((_count_sentences)>>2)]; //@line 1755 "synthesize.cpp"
            __Z8DoMarkeriiii(5, $372, 0, $373); //@line 1755 "synthesize.cpp"
            var $374=$n_ph_addr; //@line 1756 "synthesize.cpp"
            HEAP32[(($374)>>2)]=0; //@line 1756 "synthesize.cpp"
            ; //@line 1757 "synthesize.cpp"
          }
  
          $retval=0; //@line 1759 "synthesize.cpp"
          ; //@line 1759 "synthesize.cpp"
        }
        else if (__label__ == 14) {
  
          $retval=1; //@line 1365 "synthesize.cpp"
          ; //@line 1365 "synthesize.cpp"
        }
      }
    }
  
    var $375=$retval; //@line 1760 "synthesize.cpp"
    STACKTOP = __stackBase__;
    return $375; //@line 1760 "synthesize.cpp"
    return null;
  }
  

  function __ZL12EndAmplitudev() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL10amp_length)>>2)]; //@line 110 "synthesize.cpp"
    var $cmp=((($0))|0) > 0; //@line 110 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 110 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL12last_amp_cmd)>>2)]; //@line 112 "synthesize.cpp"
      var $arrayidx=((_wcmdq+$1*16)&4294967295); //@line 112 "synthesize.cpp"
      var $arrayidx1=(($arrayidx+4)&4294967295); //@line 112 "synthesize.cpp"
      var $2=HEAP32[(($arrayidx1)>>2)]; //@line 112 "synthesize.cpp"
      var $cmp2=((($2))|0)==0; //@line 112 "synthesize.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 112 "synthesize.cpp"
      if (__label__ == 2) {
  
        var $3=HEAP32[((__ZL10amp_length)>>2)]; //@line 113 "synthesize.cpp"
        var $4=HEAP32[((__ZL12last_amp_cmd)>>2)]; //@line 113 "synthesize.cpp"
        var $arrayidx4=((_wcmdq+$4*16)&4294967295); //@line 113 "synthesize.cpp"
        var $arrayidx5=(($arrayidx4+4)&4294967295); //@line 113 "synthesize.cpp"
        HEAP32[(($arrayidx5)>>2)]=$3; //@line 113 "synthesize.cpp"
        ; //@line 113 "synthesize.cpp"
      }
  
      HEAP32[((__ZL10amp_length)>>2)]=0; //@line 114 "synthesize.cpp"
      ; //@line 115 "synthesize.cpp"
    }
  
    ;
    return; //@line 116 "synthesize.cpp"
    return;
  }
  

  function __ZL11DoAmplitudeiPh($amp, $amp_env) {
    ;
    var __label__;
  
    var $amp_addr;
    var $amp_env_addr;
    var $q;
    $amp_addr=$amp;
    $amp_env_addr=$amp_env;
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 147 "synthesize.cpp"
    HEAP32[((__ZL12last_amp_cmd)>>2)]=$0; //@line 147 "synthesize.cpp"
    HEAP32[((__ZL10amp_length)>>2)]=0; //@line 148 "synthesize.cpp"
    var $1=HEAP32[((_wcmdq_tail)>>2)]; //@line 150 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$1*16)&4294967295); //@line 150 "synthesize.cpp"
    var $arraydecay=(($arrayidx)&4294967295); //@line 150 "synthesize.cpp"
    $q=$arraydecay; //@line 150 "synthesize.cpp"
    var $2=$q; //@line 151 "synthesize.cpp"
    var $arrayidx1=(($2)&4294967295); //@line 151 "synthesize.cpp"
    HEAP32[(($arrayidx1)>>2)]=8; //@line 151 "synthesize.cpp"
    var $3=$q; //@line 152 "synthesize.cpp"
    var $arrayidx2=(($3+4)&4294967295); //@line 152 "synthesize.cpp"
    HEAP32[(($arrayidx2)>>2)]=0; //@line 152 "synthesize.cpp"
    var $4=$amp_env_addr; //@line 153 "synthesize.cpp"
    var $5=($4); //@line 153 "synthesize.cpp"
    var $6=$q; //@line 153 "synthesize.cpp"
    var $arrayidx3=(($6+8)&4294967295); //@line 153 "synthesize.cpp"
    HEAP32[(($arrayidx3)>>2)]=$5; //@line 153 "synthesize.cpp"
    var $7=$amp_addr; //@line 154 "synthesize.cpp"
    var $8=$q; //@line 154 "synthesize.cpp"
    var $arrayidx4=(($8+12)&4294967295); //@line 154 "synthesize.cpp"
    HEAP32[(($arrayidx4)>>2)]=$7; //@line 154 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 155 "synthesize.cpp"
    ;
    return; //@line 156 "synthesize.cpp"
    return;
  }
  

  function __ZL7DoPitchPhii($env, $pitch1, $pitch2) {
    ;
    var __label__;
  
    var $env_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    var $q;
    $env_addr=$env;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    __ZL8EndPitchi(0); //@line 164 "synthesize.cpp"
    var $0=$pitch1_addr; //@line 166 "synthesize.cpp"
    var $cmp=((($0))|0)==255; //@line 166 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 166 "synthesize.cpp"
    $if_end_thread$$if_end$2: do { 
      if (__label__ == 1) {
  
        $pitch1_addr=55; //@line 169 "synthesize.cpp"
        $pitch2_addr=76; //@line 170 "synthesize.cpp"
        var $1=HEAP32[((((_envelope_data)&4294967295))>>2)]; //@line 171 "synthesize.cpp"
        $env_addr=$1; //@line 171 "synthesize.cpp"
        var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL14last_pitch_cmd)>>2)]=$2; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 174 "synthesize.cpp"
        ; //@line 176 "synthesize.cpp"
      }
      else if (__label__ == 2) {
  
        var $_pr=$pitch2_addr; //@line 176 "synthesize.cpp"
        var $3=HEAP32[((_wcmdq_tail)>>2)]; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL14last_pitch_cmd)>>2)]=$3; //@line 173 "synthesize.cpp"
        HEAP32[((__ZL12pitch_length)>>2)]=0; //@line 174 "synthesize.cpp"
        var $cmp1=((($_pr))|0) < 0; //@line 176 "synthesize.cpp"
        if (!($cmp1)) { __label__ = 4;break $if_end_thread$$if_end$2; } //@line 176 "synthesize.cpp"
  
        $pitch2_addr=0; //@line 177 "synthesize.cpp"
        ; //@line 177 "synthesize.cpp"
      }
    } while(0);
  
    var $4=HEAP32[((_wcmdq_tail)>>2)]; //@line 179 "synthesize.cpp"
    var $arrayidx=((_wcmdq+$4*16)&4294967295); //@line 179 "synthesize.cpp"
    var $arraydecay=(($arrayidx)&4294967295); //@line 179 "synthesize.cpp"
    $q=$arraydecay; //@line 179 "synthesize.cpp"
    var $5=$q; //@line 180 "synthesize.cpp"
    var $arrayidx4=(($5)&4294967295); //@line 180 "synthesize.cpp"
    HEAP32[(($arrayidx4)>>2)]=9; //@line 180 "synthesize.cpp"
    var $6=$q; //@line 181 "synthesize.cpp"
    var $arrayidx5=(($6+4)&4294967295); //@line 181 "synthesize.cpp"
    HEAP32[(($arrayidx5)>>2)]=0; //@line 181 "synthesize.cpp"
    var $7=$env_addr; //@line 182 "synthesize.cpp"
    var $8=($7); //@line 182 "synthesize.cpp"
    var $9=$q; //@line 182 "synthesize.cpp"
    var $arrayidx6=(($9+8)&4294967295); //@line 182 "synthesize.cpp"
    HEAP32[(($arrayidx6)>>2)]=$8; //@line 182 "synthesize.cpp"
    var $10=$pitch1_addr; //@line 183 "synthesize.cpp"
    var $shl=((($10)*65536)&4294967295); //@line 183 "synthesize.cpp"
    var $11=$pitch2_addr; //@line 183 "synthesize.cpp"
    var $add=((($shl)+($11))&4294967295); //@line 183 "synthesize.cpp"
    var $12=$q; //@line 183 "synthesize.cpp"
    var $arrayidx7=(($12+12)&4294967295); //@line 183 "synthesize.cpp"
    HEAP32[(($arrayidx7)>>2)]=$add; //@line 183 "synthesize.cpp"
    __Z8WcmdqIncv(); //@line 184 "synthesize.cpp"
    ;
    return; //@line 185 "synthesize.cpp"
    return;
  }
  

  function __ZL13StartSyllablev() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL12syllable_end)>>2)]; //@line 981 "synthesize.cpp"
    var $1=HEAP32[((__ZL14syllable_start)>>2)]; //@line 981 "synthesize.cpp"
    var $cmp=((($0))|0)==((($1))|0); //@line 981 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 981 "synthesize.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((_wcmdq_tail)>>2)]; //@line 982 "synthesize.cpp"
      HEAP32[((__ZL12syllable_end)>>2)]=$2; //@line 982 "synthesize.cpp"
      ; //@line 982 "synthesize.cpp"
    }
  
    ;
    return; //@line 983 "synthesize.cpp"
    return;
  }
  

  function __Z12SynthOnTimerv() {
    ;
    var __label__;
  
    var $retval;
    var $_b=HEAPU8[(__ZL8timer_on_b)];
    var $0=((($_b))&1);
    var $tobool=((($0))|0)!=0; //@line 1770 "synthesize.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 1770 "synthesize.cpp"
    if (__label__ == 2) {
      while(1) { 
  
        var $call1=__Z9WcmdqUsedv(); //@line 1776 "synthesize.cpp"
        var $call5=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 1); //@line 1779 "synthesize.cpp"
        var $cmp6=((($call5))|0)==0; //@line 1779 "synthesize.cpp"
        if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 1779 "synthesize.cpp"
        if (__label__ == 3) {
  
          var $call8=__Z15SpeakNextClauseP7__sFILEPKvi(0, 0, 1); //@line 1781 "synthesize.cpp"
          ; //@line 1782 "synthesize.cpp"
        }
  
        var $1=HEAP32[((_skipping_text)>>2)]; //@line 1783 "synthesize.cpp"
        var $tobool10=((($1))|0)!=0; //@line 1783 "synthesize.cpp"
        if ($tobool10) { __label__ = 2;continue ; } else { __label__ = 5;break ; } //@line 1783 "synthesize.cpp"
      }
  
      $retval=0; //@line 1785 "synthesize.cpp"
      ; //@line 1785 "synthesize.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 1772 "synthesize.cpp"
      ; //@line 1772 "synthesize.cpp"
    }
  
    var $2=$retval; //@line 1786 "synthesize.cpp"
    ;
    return $2; //@line 1786 "synthesize.cpp"
    return null;
  }
  

  function __Z15SpeakNextClauseP7__sFILEPKvi($f_in, $text_in, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 8; _memset(__stackBase__, 0, 8);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $f_in_addr;
    var $text_in_addr;
    var $control_addr;
    var $clause_tone=__stackBase__;
    var $voice_change=__stackBase__+4;
    $f_in_addr=$f_in;
    $text_in_addr=$text_in;
    $control_addr=$control;
    var $0=$control_addr; //@line 1814 "synthesize.cpp"
    var $cmp=((($0))|0)==4; //@line 1814 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1814 "synthesize.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1816 "synthesize.cpp"
        var $cmp1=((($1))|0)==0; //@line 1816 "synthesize.cpp"
        var $2=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]; //@line 1816 "synthesize.cpp"
        var $cmp2=((($2))|0)==0; //@line 1816 "synthesize.cpp"
        var $or_cond=($cmp1) & ($cmp2); //@line 1816 "synthesize.cpp"
        if ($or_cond) { __label__ = 2;; } else { __label__ = 3;; } //@line 1816 "synthesize.cpp"
        if (__label__ == 2) {
  
          $retval=0; //@line 1817 "synthesize.cpp"
          ; //@line 1817 "synthesize.cpp"
        }
        else if (__label__ == 3) {
  
          $retval=1; //@line 1819 "synthesize.cpp"
          ; //@line 1819 "synthesize.cpp"
        }
      }
      else if (__label__ == 4) {
  
        var $3=$control_addr; //@line 1822 "synthesize.cpp"
        var $cmp4=((($3))|0)==2; //@line 1822 "synthesize.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 8;; } //@line 1822 "synthesize.cpp"
        if (__label__ == 5) {
  
          HEAP8[(__ZL8timer_on_b)]=0;
          HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]=0; //@line 1826 "synthesize.cpp"
          var $4=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1827 "synthesize.cpp"
          var $cmp6=((($4))|0)!=0; //@line 1827 "synthesize.cpp"
          if ($cmp6) { __label__ = 6;; } else { __label__ = 7;; } //@line 1827 "synthesize.cpp"
          if (__label__ == 6) {
  
            var $5=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1829 "synthesize.cpp"
            var $call=_fclose($5); //@line 1829 "synthesize.cpp"
            HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]=0; //@line 1830 "synthesize.cpp"
            ; //@line 1831 "synthesize.cpp"
          }
  
          HEAP32[((_n_phoneme_list)>>2)]=0; //@line 1832 "synthesize.cpp"
          __Z9WcmdqStopv(); //@line 1833 "synthesize.cpp"
          HEAP32[((((_embedded_value+24)&4294967295))>>2)]=0; //@line 1835 "synthesize.cpp"
          $retval=0; //@line 1836 "synthesize.cpp"
          ; //@line 1836 "synthesize.cpp"
        }
        else if (__label__ == 8) {
  
          var $6=$control_addr; //@line 1839 "synthesize.cpp"
          var $cmp10=((($6))|0)==3; //@line 1839 "synthesize.cpp"
          if ($cmp10) { __label__ = 9;; } else { __label__ = 13;; } //@line 1839 "synthesize.cpp"
          if (__label__ == 9) {
  
            var $_b=HEAPU8[(__ZL6paused_b)];
            var $7=($_b) ? 2 : 0;
            var $cmp12=((($7))|0)==0; //@line 1842 "synthesize.cpp"
            if ($cmp12) { __label__ = 10;; } else { __label__ = 11;; } //@line 1842 "synthesize.cpp"
            if (__label__ == 10) {
  
              HEAP8[(__ZL8timer_on_b)]=0;
              HEAP8[(__ZL6paused_b)]=1;
              ; //@line 1846 "synthesize.cpp"
            }
            else if (__label__ == 11) {
  
              HEAP8[(__ZL8timer_on_b)]=1;
              HEAP8[(__ZL6paused_b)]=0;
              var $call16=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 0); //@line 1852 "synthesize.cpp"
              ;
            }
  
            $retval=0; //@line 1854 "synthesize.cpp"
            ; //@line 1854 "synthesize.cpp"
          }
          else if (__label__ == 13) {
  
            var $8=$control_addr; //@line 1857 "synthesize.cpp"
            var $cmp19=((($8))|0)==5; //@line 1857 "synthesize.cpp"
            if ($cmp19) { __label__ = 14;; } else { __label__ = 15;; } //@line 1857 "synthesize.cpp"
            if (__label__ == 14) {
  
              HEAP32[((_n_phoneme_list)>>2)]=0; //@line 1860 "synthesize.cpp"
              __Z9WcmdqStopv(); //@line 1861 "synthesize.cpp"
              $retval=0; //@line 1862 "synthesize.cpp"
              ; //@line 1862 "synthesize.cpp"
            }
            else if (__label__ == 15) {
  
              var $9=$f_in_addr; //@line 1865 "synthesize.cpp"
              var $cmp22=((($9))|0)!=0; //@line 1865 "synthesize.cpp"
              if ($cmp22) { __label__ = 17;; } else { __label__ = 16;; } //@line 1865 "synthesize.cpp"
              $if_then24$$lor_lhs_false$24: do { 
                if (__label__ == 16) {
  
                  var $10=$text_in_addr; //@line 1865 "synthesize.cpp"
                  var $cmp23=((($10))|0)!=0; //@line 1865 "synthesize.cpp"
                  if ($cmp23) { __label__ = 17;break $if_then24$$lor_lhs_false$24; } else { __label__ = 18;break $if_then24$$lor_lhs_false$24; } //@line 1865 "synthesize.cpp"
                }
              } while(0);
              if (__label__ == 17) {
  
                var $11=$f_in_addr; //@line 1867 "synthesize.cpp"
                HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]=$11; //@line 1867 "synthesize.cpp"
                var $12=$text_in_addr; //@line 1868 "synthesize.cpp"
                HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]=$12; //@line 1868 "synthesize.cpp"
                HEAP8[(__ZL8timer_on_b)]=1;
                HEAP8[(__ZL6paused_b)]=0;
                ; //@line 1871 "synthesize.cpp"
              }
  
              var $13=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1873 "synthesize.cpp"
              var $cmp26=((($13))|0)==0; //@line 1873 "synthesize.cpp"
              var $14=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]; //@line 1873 "synthesize.cpp"
              var $cmp28=((($14))|0)==0; //@line 1873 "synthesize.cpp"
              var $or_cond1=($cmp26) & ($cmp28); //@line 1873 "synthesize.cpp"
              if ($or_cond1) { __label__ = 19;; } else { __label__ = 20;; } //@line 1873 "synthesize.cpp"
              if (__label__ == 19) {
  
                HEAP32[((_skipping_text)>>2)]=0; //@line 1875 "synthesize.cpp"
                HEAP8[(__ZL8timer_on_b)]=0;
                $retval=0; //@line 1877 "synthesize.cpp"
                ; //@line 1877 "synthesize.cpp"
              }
              else if (__label__ == 20) {
  
                var $15=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1880 "synthesize.cpp"
                var $cmp31=((($15))|0)!=0; //@line 1880 "synthesize.cpp"
                if ($cmp31) { __label__ = 21;; } else { __label__ = 23;; } //@line 1880 "synthesize.cpp"
                $land_lhs_true32$$if_end36$32: do { 
                  if (__label__ == 21) {
  
                    var $16=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1880 "synthesize.cpp"
                    var $_flags=(($16+12)&4294967295); //@line 1880 "synthesize.cpp"
                    var $17=HEAP16[(($_flags)>>1)]; //@line 1880 "synthesize.cpp"
                    var $conv=(tempInt=(($17)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1880 "synthesize.cpp"
                    var $and=($conv) & 32; //@line 1880 "synthesize.cpp"
                    var $cmp33=((($and))|0)!=0; //@line 1880 "synthesize.cpp"
                    if (!($cmp33)) { __label__ = 23;break $land_lhs_true32$$if_end36$32; } //@line 1880 "synthesize.cpp"
  
                    HEAP8[(__ZL8timer_on_b)]=0;
                    var $18=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1883 "synthesize.cpp"
                    var $call35=_fclose($18); //@line 1883 "synthesize.cpp"
                    HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]=0; //@line 1884 "synthesize.cpp"
                    $retval=0; //@line 1885 "synthesize.cpp"
                    __label__ = 39;break $if_then$$if_end$2; //@line 1885 "synthesize.cpp"
                  }
                } while(0);
  
                var $19=HEAP32[((_current_phoneme_table)>>2)]; //@line 1888 "synthesize.cpp"
                var $20=HEAP32[((_voice)>>2)]; //@line 1888 "synthesize.cpp"
                var $phoneme_tab_ix=(($20+40)&4294967295); //@line 1888 "synthesize.cpp"
                var $21=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 1888 "synthesize.cpp"
                var $cmp37=((($19))|0)!=((($21))|0); //@line 1888 "synthesize.cpp"
                if ($cmp37) { __label__ = 24;; } else { __label__ = 25;; } //@line 1888 "synthesize.cpp"
                if (__label__ == 24) {
  
                  var $22=HEAP32[((_voice)>>2)]; //@line 1890 "synthesize.cpp"
                  var $phoneme_tab_ix39=(($22+40)&4294967295); //@line 1890 "synthesize.cpp"
                  var $23=HEAP32[(($phoneme_tab_ix39)>>2)]; //@line 1890 "synthesize.cpp"
                  __Z18SelectPhonemeTablei($23); //@line 1890 "synthesize.cpp"
                  ; //@line 1891 "synthesize.cpp"
                }
  
                var $24=HEAP32[((_translator)>>2)]; //@line 1895 "synthesize.cpp"
                var $25=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text)>>2)]; //@line 1895 "synthesize.cpp"
                var $26=HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]; //@line 1895 "synthesize.cpp"
                var $call41=__Z15TranslateClauseP10TranslatorP7__sFILEPKvPiPPc($24, $25, $26, $clause_tone, $voice_change); //@line 1895 "synthesize.cpp"
                HEAP32[((__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text)>>2)]=$call41; //@line 1895 "synthesize.cpp"
                var $27=HEAP32[((_translator)>>2)]; //@line 1897 "synthesize.cpp"
                var $28=HEAP32[(($clause_tone)>>2)]; //@line 1897 "synthesize.cpp"
                __Z11CalcPitchesP10Translatori($27, $28); //@line 1897 "synthesize.cpp"
                var $29=HEAP32[((_translator)>>2)]; //@line 1898 "synthesize.cpp"
                __Z11CalcLengthsP10Translator($29); //@line 1898 "synthesize.cpp"
                var $30=HEAP32[((_option_phonemes)>>2)]; //@line 1900 "synthesize.cpp"
                var $cmp42=((($30))|0) > 0; //@line 1900 "synthesize.cpp"
                var $31=HEAP32[((_phoneme_callback)>>2)]; //@line 1900 "synthesize.cpp"
                var $cmp44=((($31))|0)!=0; //@line 1900 "synthesize.cpp"
                var $or_cond2=($cmp42) | ($cmp44); //@line 1900 "synthesize.cpp"
                if ($or_cond2) { __label__ = 26;; } else { __label__ = 31;; } //@line 1900 "synthesize.cpp"
                $if_then45$$if_end62$39: do { 
                  if (__label__ == 26) {
  
                    var $32=HEAP32[((_translator)>>2)]; //@line 1902 "synthesize.cpp"
                    var $phon_out=(($32+332)&4294967295); //@line 1902 "synthesize.cpp"
                    var $arraydecay=(($phon_out)&4294967295); //@line 1902 "synthesize.cpp"
                    __Z26GetTranslatedPhonemeStringPci($arraydecay, 300); //@line 1902 "synthesize.cpp"
                    var $33=HEAP32[((_option_phonemes)>>2)]; //@line 1903 "synthesize.cpp"
                    var $cmp46=((($33))|0) > 0; //@line 1903 "synthesize.cpp"
                    if ($cmp46) { __label__ = 27;; } else { __label__ = 29;; } //@line 1903 "synthesize.cpp"
                    $if_then47$$if_end55$41: do { 
                      if (__label__ == 27) {
  
                        var $34=HEAP32[((_f_trans)>>2)]; //@line 1905 "synthesize.cpp"
                        var $35=HEAP32[((_translator)>>2)]; //@line 1905 "synthesize.cpp"
                        var $phon_out48=(($35+332)&4294967295); //@line 1905 "synthesize.cpp"
                        var $arraydecay49=(($phon_out48)&4294967295); //@line 1905 "synthesize.cpp"
                        var $call50=_fprintf($34, ((__str459)&4294967295), allocate([$arraydecay49,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1905 "synthesize.cpp"
                        var $call51=_iswalpha(269); //@line 1907 "synthesize.cpp"
                        var $tobool=((($call51))|0)!=0; //@line 1907 "synthesize.cpp"
                        if ($tobool) { __label__ = 29;break $if_then47$$if_end55$41; } //@line 1907 "synthesize.cpp"
  
                        var $36=HEAP32[((__impure_ptr)>>2)]; //@line 1910 "synthesize.cpp"
                        var $_stderr=(($36+12)&4294967295); //@line 1910 "synthesize.cpp"
                        var $37=HEAP32[(($_stderr)>>2)]; //@line 1910 "synthesize.cpp"
                        var $38=_fwrite(((__str1460)&4294967295), 88, 1, $37); //@line 1910 "synthesize.cpp"
                        ; //@line 1911 "synthesize.cpp"
                      }
                    } while(0);
  
                    var $39=HEAP32[((_phoneme_callback)>>2)]; //@line 1913 "synthesize.cpp"
                    var $cmp56=((($39))|0)!=0; //@line 1913 "synthesize.cpp"
                    if (!($cmp56)) { __label__ = 31;break $if_then45$$if_end62$39; } //@line 1913 "synthesize.cpp"
  
                    var $40=HEAP32[((_phoneme_callback)>>2)]; //@line 1915 "synthesize.cpp"
                    var $41=HEAP32[((_translator)>>2)]; //@line 1915 "synthesize.cpp"
                    var $phon_out58=(($41+332)&4294967295); //@line 1915 "synthesize.cpp"
                    var $arraydecay59=(($phon_out58)&4294967295); //@line 1915 "synthesize.cpp"
                    var $call60=FUNCTION_TABLE[$40]($arraydecay59); //@line 1915 "synthesize.cpp"
                    ; //@line 1916 "synthesize.cpp"
                  }
                } while(0);
  
                var $42=HEAP32[((_skipping_text)>>2)]; //@line 1920 "synthesize.cpp"
                var $tobool63=((($42))|0)!=0; //@line 1920 "synthesize.cpp"
                if ($tobool63) { __label__ = 32;; } else { __label__ = 33;; } //@line 1920 "synthesize.cpp"
                if (__label__ == 32) {
  
                  HEAP32[((_n_phoneme_list)>>2)]=0; //@line 1922 "synthesize.cpp"
                  $retval=1; //@line 1923 "synthesize.cpp"
                  ; //@line 1923 "synthesize.cpp"
                }
                else if (__label__ == 33) {
  
                  var $call66=__Z8GenerateP12PHONEME_LISTPii(((_phoneme_list)&4294967295), _n_phoneme_list, 0); //@line 1926 "synthesize.cpp"
                  var $43=HEAP32[(($voice_change)>>2)]; //@line 1929 "synthesize.cpp"
                  var $cmp68=((($43))|0)!=0; //@line 1929 "synthesize.cpp"
                  if ($cmp68) { __label__ = 34;; } else { __label__ = 35;; } //@line 1929 "synthesize.cpp"
                  if (__label__ == 34) {
  
                    var $44=HEAP32[(($voice_change)>>2)]; //@line 1932 "synthesize.cpp"
                    var $call70=__Z16LoadVoiceVariantPKci($44, 0); //@line 1932 "synthesize.cpp"
                    HEAP32[((__ZL9new_voice)>>2)]=$call70; //@line 1932 "synthesize.cpp"
                    __lastLabel__ = 34; ; //@line 1933 "synthesize.cpp"
                  }
                  else if (__label__ == 35) {
  
                    var $_pr=HEAP32[((__ZL9new_voice)>>2)]; //@line 1935 "synthesize.cpp"
                    __lastLabel__ = 35; ;
                  }
  
                  var $45=__lastLabel__ == 35 ? $_pr : ($call70); //@line 1935 "synthesize.cpp"
                  var $tobool72=((($45))|0)!=0; //@line 1935 "synthesize.cpp"
                  if ($tobool72) { __label__ = 37;; } else { __label__ = 38;; } //@line 1935 "synthesize.cpp"
                  if (__label__ == 37) {
  
                    var $46=HEAP32[((_voice)>>2)]; //@line 1939 "synthesize.cpp"
                    __Z13DoVoiceChangeP7voice_t($46); //@line 1939 "synthesize.cpp"
                    HEAP32[((__ZL9new_voice)>>2)]=0; //@line 1940 "synthesize.cpp"
                    ; //@line 1941 "synthesize.cpp"
                  }
  
                  $retval=1; //@line 1943 "synthesize.cpp"
                  ; //@line 1943 "synthesize.cpp"
                }
              }
            }
          }
        }
      }
    } while(0);
  
    var $47=$retval; //@line 1944 "synthesize.cpp"
    STACKTOP = __stackBase__;
    return $47; //@line 1944 "synthesize.cpp"
    return null;
  }
  

  function __Z11SynthStatusv() {
    ;
    var __label__;
  
    var $_b=HEAPU8[(__ZL8timer_on_b)];
    var $0=((($_b))&1);
    var $_b1=HEAPU8[(__ZL6paused_b)];
    var $1=($_b1) ? 2 : 0;
    var $or=($1) | ($0); //@line 1791 "synthesize.cpp"
    ;
    return $or; //@line 1791 "synthesize.cpp"
    return null;
  }
  

  function __ZL18formants_reduce_hfP7frame_ti($fr, $level) {
    ;
    var __label__;
  
    var $fr_addr;
    var $level_addr;
    var $ix;
    var $x;
    $fr_addr=$fr;
    $level_addr=$level;
    var $0=HEAP32[((_voice)>>2)]; //@line 508 "synthesize.cpp"
    var $klattv=(($0+112)&4294967295); //@line 508 "synthesize.cpp"
    var $arrayidx=(($klattv)&4294967295); //@line 508 "synthesize.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 508 "synthesize.cpp"
    var $tobool=((($1))|0)!=0; //@line 508 "synthesize.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 1;; } //@line 508 "synthesize.cpp"
    $for_end$$if_end$2: do { 
      if (__label__ == 1) {
  
        $ix=2; //@line 511 "synthesize.cpp"
        ; //@line 511 "synthesize.cpp"
        while(1) { 
  
          var $2=$ix; //@line 513 "synthesize.cpp"
          var $3=$fr_addr; //@line 513 "synthesize.cpp"
          var $fheight=(($3+18)&4294967295); //@line 513 "synthesize.cpp"
          var $arrayidx1=(($fheight+$2)&4294967295); //@line 513 "synthesize.cpp"
          var $4=HEAPU8[($arrayidx1)]; //@line 513 "synthesize.cpp"
          var $conv=((($4))&255); //@line 513 "synthesize.cpp"
          var $5=$level_addr; //@line 513 "synthesize.cpp"
          var $mul=((($conv)*($5))&4294967295); //@line 513 "synthesize.cpp"
          $x=$mul; //@line 513 "synthesize.cpp"
          var $6=$x; //@line 514 "synthesize.cpp"
          var $div=((((($6))|0)/100)|0); //@line 514 "synthesize.cpp"
          var $conv2=((($div)) & 255); //@line 514 "synthesize.cpp"
          var $7=$ix; //@line 514 "synthesize.cpp"
          var $8=$fr_addr; //@line 514 "synthesize.cpp"
          var $fheight3=(($8+18)&4294967295); //@line 514 "synthesize.cpp"
          var $arrayidx4=(($fheight3+$7)&4294967295); //@line 514 "synthesize.cpp"
          HEAP8[($arrayidx4)]=$conv2; //@line 514 "synthesize.cpp"
          var $9=$ix; //@line 511 "synthesize.cpp"
          var $inc=((($9)+1)&4294967295); //@line 511 "synthesize.cpp"
          $ix=$inc; //@line 511 "synthesize.cpp"
          var $cmp=((($inc))|0) < 8; //@line 511 "synthesize.cpp"
          if ($cmp) { __label__ = 2;continue ; } else { __label__ = 3;break $for_end$$if_end$2; } //@line 511 "synthesize.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 516 "synthesize.cpp"
    return;
  }
  

  function __ZL10AllocFramev() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZZL10AllocFramevE2ix)>>2)]; //@line 447 "synthesize.cpp"
    var $inc=((($0)+1)&4294967295); //@line 447 "synthesize.cpp"
    HEAP32[((__ZZL10AllocFramevE2ix)>>2)]=$inc; //@line 447 "synthesize.cpp"
    var $cmp=((($inc))|0) >= 160; //@line 448 "synthesize.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 448 "synthesize.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZZL10AllocFramevE2ix)>>2)]=0; //@line 449 "synthesize.cpp"
      ; //@line 449 "synthesize.cpp"
    }
  
    var $1=HEAP32[((__ZZL10AllocFramevE2ix)>>2)]; //@line 450 "synthesize.cpp"
    var $arrayidx=((__ZZL10AllocFramevE10frame_pool+$1*64)&4294967295); //@line 450 "synthesize.cpp"
    ;
    return $arrayidx; //@line 450 "synthesize.cpp"
    return null;
  }
  

  function __Z13SetLengthModsP10Translatori($tr, $value) {
    ;
    var __label__;
  
    var $tr_addr;
    var $value_addr;
    var $value2;
    $tr_addr=$tr;
    $value_addr=$value;
    var $0=$value_addr; //@line 363 "translate.cpp"
    var $rem=((($0))|0)%100; //@line 363 "translate.cpp"
    var $arrayidx=((__ZL15length_mod_tabs+$rem*4)&4294967295); //@line 363 "translate.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 363 "translate.cpp"
    var $2=$tr_addr; //@line 363 "translate.cpp"
    var $langopts=(($2)&4294967295); //@line 363 "translate.cpp"
    var $length_mods=(($langopts+176)&4294967295); //@line 363 "translate.cpp"
    HEAP32[(($length_mods)>>2)]=$1; //@line 363 "translate.cpp"
    var $3=$tr_addr; //@line 363 "translate.cpp"
    var $langopts1=(($3)&4294967295); //@line 363 "translate.cpp"
    var $length_mods0=(($langopts1+180)&4294967295); //@line 363 "translate.cpp"
    HEAP32[(($length_mods0)>>2)]=$1; //@line 363 "translate.cpp"
    var $4=$value_addr; //@line 364 "translate.cpp"
    var $div=((((($4))|0)/100)|0); //@line 364 "translate.cpp"
    $value2=$div; //@line 364 "translate.cpp"
    var $cmp=((($div))|0)!=0; //@line 364 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 364 "translate.cpp"
    if (__label__ == 1) {
  
      var $5=$value2; //@line 366 "translate.cpp"
      var $arrayidx2=((__ZL15length_mod_tabs+$5*4)&4294967295); //@line 366 "translate.cpp"
      var $6=HEAP32[(($arrayidx2)>>2)]; //@line 366 "translate.cpp"
      var $7=$tr_addr; //@line 366 "translate.cpp"
      var $langopts3=(($7)&4294967295); //@line 366 "translate.cpp"
      var $length_mods04=(($langopts3+180)&4294967295); //@line 366 "translate.cpp"
      HEAP32[(($length_mods04)>>2)]=$6; //@line 366 "translate.cpp"
      ; //@line 367 "translate.cpp"
    }
  
    ;
    return; //@line 368 "translate.cpp"
    return;
  }
  

  function __Z7IsAlphaj($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 379 "translate.cpp"
    var $call=_iswalpha($0); //@line 379 "translate.cpp"
    var $tobool=((($call))|0)!=0; //@line 379 "translate.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 379 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 380 "translate.cpp"
      ; //@line 380 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 382 "translate.cpp"
      var $cmp=((($1))>>>0) >= 2305; //@line 382 "translate.cpp"
      var $2=$c_addr; //@line 382 "translate.cpp"
      var $cmp1=((($2))>>>0) <= 3575; //@line 382 "translate.cpp"
      var $or_cond=($cmp) & ($cmp1); //@line 382 "translate.cpp"
      var $3=$c_addr; //@line 385 "translate.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 10;; } //@line 382 "translate.cpp"
      if (__label__ == 3) {
  
        var $and=($3) & 127; //@line 385 "translate.cpp"
        var $cmp3=((($and))>>>0) < 100; //@line 385 "translate.cpp"
        if ($cmp3) { __label__ = 4;; } else { __label__ = 5;; } //@line 385 "translate.cpp"
        if (__label__ == 4) {
  
          $retval=1; //@line 386 "translate.cpp"
          ; //@line 386 "translate.cpp"
        }
        else if (__label__ == 5) {
  
          var $4=$c_addr; //@line 387 "translate.cpp"
          var $call6=__Z11lookupwcharPKti(((__ZZ7IsAlphajE18extra_indic_alphas)&4294967295), $4); //@line 387 "translate.cpp"
          var $cmp7=((($call6))|0)!=0; //@line 387 "translate.cpp"
          if ($cmp7) { __label__ = 6;; } else { __label__ = 7;; } //@line 387 "translate.cpp"
          if (__label__ == 6) {
  
            $retval=1; //@line 388 "translate.cpp"
            ; //@line 388 "translate.cpp"
          }
          else if (__label__ == 7) {
  
            var $5=$c_addr; //@line 389 "translate.cpp"
            var $cmp10=((($5))>>>0) >= 3450; //@line 389 "translate.cpp"
            var $6=$c_addr; //@line 389 "translate.cpp"
            var $cmp12=((($6))>>>0) <= 3455; //@line 389 "translate.cpp"
            var $or_cond1=($cmp10) & ($cmp12); //@line 389 "translate.cpp"
            if ($or_cond1) { __label__ = 8;; } else { __label__ = 9;; } //@line 389 "translate.cpp"
            if (__label__ == 8) {
  
              $retval=1; //@line 390 "translate.cpp"
              ; //@line 390 "translate.cpp"
            }
            else if (__label__ == 9) {
  
              $retval=0; //@line 392 "translate.cpp"
              ; //@line 392 "translate.cpp"
            }
          }
        }
      }
      else if (__label__ == 10) {
  
        var $cmp16=((($3))>>>0) >= 1611; //@line 395 "translate.cpp"
        var $7=$c_addr; //@line 395 "translate.cpp"
        var $cmp18=((($7))>>>0) <= 1630; //@line 395 "translate.cpp"
        var $or_cond2=($cmp16) & ($cmp18); //@line 395 "translate.cpp"
        if ($or_cond2) { __label__ = 11;; } else { __label__ = 12;; } //@line 395 "translate.cpp"
        if (__label__ == 11) {
  
          $retval=1; //@line 396 "translate.cpp"
          ; //@line 396 "translate.cpp"
        }
        else if (__label__ == 12) {
  
          var $8=$c_addr; //@line 398 "translate.cpp"
          var $cmp21=((($8))>>>0) >= 768; //@line 398 "translate.cpp"
          var $9=$c_addr; //@line 398 "translate.cpp"
          var $cmp23=((($9))>>>0) <= 879; //@line 398 "translate.cpp"
          var $or_cond3=($cmp21) & ($cmp23); //@line 398 "translate.cpp"
          if ($or_cond3) { __label__ = 13;; } else { __label__ = 14;; } //@line 398 "translate.cpp"
          if (__label__ == 13) {
  
            $retval=1; //@line 399 "translate.cpp"
            ; //@line 399 "translate.cpp"
          }
          else if (__label__ == 14) {
  
            var $10=$c_addr; //@line 401 "translate.cpp"
            var $cmp26=((($10))>>>0) >= 1920; //@line 401 "translate.cpp"
            var $11=$c_addr; //@line 401 "translate.cpp"
            var $cmp28=((($11))>>>0) <= 1969; //@line 401 "translate.cpp"
            var $or_cond4=($cmp26) & ($cmp28); //@line 401 "translate.cpp"
            if ($or_cond4) { __label__ = 15;; } else { __label__ = 16;; } //@line 401 "translate.cpp"
            if (__label__ == 15) {
  
              $retval=1; //@line 402 "translate.cpp"
              ; //@line 402 "translate.cpp"
            }
            else if (__label__ == 16) {
  
              var $12=$c_addr; //@line 404 "translate.cpp"
              var $cmp31=((($12))>>>0) >= 4352; //@line 404 "translate.cpp"
              var $13=$c_addr; //@line 404 "translate.cpp"
              var $cmp33=((($13))>>>0) <= 4607; //@line 404 "translate.cpp"
              var $or_cond5=($cmp31) & ($cmp33); //@line 404 "translate.cpp"
              if ($or_cond5) { __label__ = 17;; } else { __label__ = 18;; } //@line 404 "translate.cpp"
              if (__label__ == 17) {
  
                $retval=1; //@line 405 "translate.cpp"
                ; //@line 405 "translate.cpp"
              }
              else if (__label__ == 18) {
  
                var $14=$c_addr; //@line 407 "translate.cpp"
                var $cmp36=((($14))>>>0) > 12352; //@line 407 "translate.cpp"
                var $15=$c_addr; //@line 407 "translate.cpp"
                var $cmp38=((($15))>>>0) <= 42752; //@line 407 "translate.cpp"
                var $or_cond6=($cmp36) & ($cmp38); //@line 407 "translate.cpp"
                if ($or_cond6) { __label__ = 19;; } else { __label__ = 20;; } //@line 407 "translate.cpp"
                if (__label__ == 19) {
  
                  $retval=1; //@line 408 "translate.cpp"
                  ; //@line 408 "translate.cpp"
                }
                else if (__label__ == 20) {
  
                  $retval=0; //@line 410 "translate.cpp"
                  ; //@line 410 "translate.cpp"
                }
              }
            }
          }
        }
      }
    }
  
    var $16=$retval; //@line 411 "translate.cpp"
    ;
    return $16; //@line 411 "translate.cpp"
    return null;
  }
  

  function __Z11lookupwcharPKti($list, $c) {
    ;
    var __label__;
  
    var $retval;
    var $list_addr;
    var $c_addr;
    var $ix;
    $list_addr=$list;
    $c_addr=$c;
    $ix=0; //@line 456 "translate.cpp"
    ; //@line 456 "translate.cpp"
    while(1) { 
  
      var $0=$ix; //@line 456 "translate.cpp"
      var $1=$list_addr; //@line 456 "translate.cpp"
      var $arrayidx=(($1+2*$0)&4294967295); //@line 456 "translate.cpp"
      var $2=HEAPU16[(($arrayidx)>>1)]; //@line 456 "translate.cpp"
      var $conv=((($2))&65535); //@line 456 "translate.cpp"
      var $cmp=((($conv))|0)!=0; //@line 456 "translate.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 456 "translate.cpp"
  
      var $3=$ix; //@line 458 "translate.cpp"
      var $4=$list_addr; //@line 458 "translate.cpp"
      var $arrayidx1=(($4+2*$3)&4294967295); //@line 458 "translate.cpp"
      var $5=HEAPU16[(($arrayidx1)>>1)]; //@line 458 "translate.cpp"
      var $conv2=((($5))&65535); //@line 458 "translate.cpp"
      var $6=$c_addr; //@line 458 "translate.cpp"
      var $cmp3=((($conv2))|0)==((($6))|0); //@line 458 "translate.cpp"
      var $7=$ix; //@line 459 "translate.cpp"
      var $add=((($7)+1)&4294967295); //@line 459 "translate.cpp"
      if ($cmp3) { __label__ = 3;break ; } //@line 458 "translate.cpp"
  
      $ix=$add; //@line 456 "translate.cpp"
      __label__ = 1;continue ; //@line 456 "translate.cpp"
    }
    if (__label__ == 5) {
  
      $retval=0; //@line 461 "translate.cpp"
      ; //@line 461 "translate.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=$add; //@line 459 "translate.cpp"
      ; //@line 459 "translate.cpp"
    }
  
    var $8=$retval; //@line 462 "translate.cpp"
    ;
    return $8; //@line 462 "translate.cpp"
    return null;
  }
  

  function __Z7IsDigitj($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 422 "translate.cpp"
    var $call=_iswdigit($0); //@line 422 "translate.cpp"
    var $tobool=((($call))|0)!=0; //@line 422 "translate.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 422 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 423 "translate.cpp"
      ; //@line 423 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 425 "translate.cpp"
      var $cmp=((($1))>>>0) >= 2406; //@line 425 "translate.cpp"
      var $2=$c_addr; //@line 425 "translate.cpp"
      var $cmp1=((($2))>>>0) <= 2415; //@line 425 "translate.cpp"
      var $or_cond=($cmp) & ($cmp1); //@line 425 "translate.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 425 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=1; //@line 426 "translate.cpp"
        ; //@line 426 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        $retval=0; //@line 428 "translate.cpp"
        ; //@line 428 "translate.cpp"
      }
    }
  
    var $3=$retval; //@line 429 "translate.cpp"
    ;
    return $3; //@line 429 "translate.cpp"
    return null;
  }
  

  function __Z7IsSpacej($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 433 "translate.cpp"
    var $cmp=((($0))|0)==0; //@line 433 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 433 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 434 "translate.cpp"
      ; //@line 434 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 435 "translate.cpp"
      var $cmp1=((($1))>>>0) >= 9472; //@line 435 "translate.cpp"
      var $2=$c_addr; //@line 435 "translate.cpp"
      var $cmp2=((($2))>>>0) < 9632; //@line 435 "translate.cpp"
      var $or_cond=($cmp1) & ($cmp2); //@line 435 "translate.cpp"
      if ($or_cond) { __label__ = 3;; } else { __label__ = 4;; } //@line 435 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=1; //@line 436 "translate.cpp"
        ; //@line 436 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $3=$c_addr; //@line 439 "translate.cpp"
        var $call=_iswspace($3); //@line 439 "translate.cpp"
        $retval=$call; //@line 439 "translate.cpp"
        ; //@line 439 "translate.cpp"
      }
    }
  
    var $4=$retval; //@line 440 "translate.cpp"
    ;
    return $4; //@line 440 "translate.cpp"
    return null;
  }
  

  function __Z16DeleteTranslatorP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 445 "translate.cpp"
    var $data_dictlist=(($0+1052)&4294967295); //@line 445 "translate.cpp"
    var $1=HEAP32[(($data_dictlist)>>2)]; //@line 445 "translate.cpp"
    var $cmp=((($1))|0)!=0; //@line 445 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 445 "translate.cpp"
    if (__label__ == 1) {
  
      var $2=$tr_addr; //@line 446 "translate.cpp"
      var $data_dictlist1=(($2+1052)&4294967295); //@line 446 "translate.cpp"
      var $3=HEAP32[(($data_dictlist1)>>2)]; //@line 446 "translate.cpp"
      __Z4FreePv($3); //@line 446 "translate.cpp"
      ; //@line 446 "translate.cpp"
    }
  
    var $4=$tr_addr; //@line 447 "translate.cpp"
    var $5=$4; //@line 447 "translate.cpp"
    __Z4FreePv($5); //@line 447 "translate.cpp"
    ;
    return; //@line 448 "translate.cpp"
    return;
  }
  

  function __Z9IsBracketi($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 466 "translate.cpp"
    var $cmp=((($0))|0) >= 8212; //@line 466 "translate.cpp"
    var $1=$c_addr; //@line 466 "translate.cpp"
    var $cmp1=((($1))|0) <= 8223; //@line 466 "translate.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 466 "translate.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 466 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 467 "translate.cpp"
      ; //@line 467 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$c_addr; //@line 468 "translate.cpp"
      var $call=__Z11lookupwcharPKti(((__ZL8brackets)&4294967295), $2); //@line 468 "translate.cpp"
      $retval=$call; //@line 468 "translate.cpp"
      ; //@line 468 "translate.cpp"
    }
  
    var $3=$retval; //@line 469 "translate.cpp"
    ;
    return $3; //@line 469 "translate.cpp"
    return null;
  }
  

  function __Z8utf8_outjPc($c, $buf) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    var $buf_addr;
    var $n_bytes;
    var $j;
    var $shift;
    $c_addr=$c;
    $buf_addr=$buf;
    var $0=$c_addr; //@line 481 "translate.cpp"
    var $cmp=((($0))>>>0) < 128; //@line 481 "translate.cpp"
    var $1=$c_addr; //@line 483 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 481 "translate.cpp"
    if (__label__ == 1) {
  
      var $conv=((($1)) & 255); //@line 483 "translate.cpp"
      var $2=$buf_addr; //@line 483 "translate.cpp"
      var $arrayidx=(($2)&4294967295); //@line 483 "translate.cpp"
      HEAP8[($arrayidx)]=$conv; //@line 483 "translate.cpp"
      $retval=1; //@line 484 "translate.cpp"
      ; //@line 484 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $cmp1=((($1))>>>0) >= 1114112; //@line 486 "translate.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 486 "translate.cpp"
      if (__label__ == 3) {
  
        var $3=$buf_addr; //@line 488 "translate.cpp"
        var $arrayidx3=(($3)&4294967295); //@line 488 "translate.cpp"
        HEAP8[($arrayidx3)]=32; //@line 488 "translate.cpp"
        $retval=1; //@line 489 "translate.cpp"
        ; //@line 489 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$c_addr; //@line 491 "translate.cpp"
        var $cmp5=((($4))>>>0) < 2048; //@line 491 "translate.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 491 "translate.cpp"
        if (__label__ == 5) {
  
          $n_bytes=1; //@line 492 "translate.cpp"
          ; //@line 492 "translate.cpp"
        }
        else if (__label__ == 6) {
  
          var $5=$c_addr; //@line 494 "translate.cpp"
          var $cmp7=((($5))>>>0) < 65536; //@line 494 "translate.cpp"
          if ($cmp7) { __label__ = 7;; } else { __label__ = 8;; } //@line 494 "translate.cpp"
          if (__label__ == 7) {
  
            $n_bytes=2; //@line 495 "translate.cpp"
            ; //@line 495 "translate.cpp"
          }
          else if (__label__ == 8) {
  
            $n_bytes=3; //@line 497 "translate.cpp"
            ;
          }
        }
  
        var $6=$n_bytes; //@line 499 "translate.cpp"
        var $mul=((($6)*6)&4294967295); //@line 499 "translate.cpp"
        $shift=$mul; //@line 499 "translate.cpp"
        var $7=$n_bytes; //@line 500 "translate.cpp"
        var $arrayidx12=((__ZZ8utf8_outjPcE4code+$7)&4294967295); //@line 500 "translate.cpp"
        var $8=HEAPU8[($arrayidx12)]; //@line 500 "translate.cpp"
        var $conv13=((($8))&255); //@line 500 "translate.cpp"
        var $9=$c_addr; //@line 500 "translate.cpp"
        var $10=$shift; //@line 500 "translate.cpp"
        var $shr=($9) >>> ((($10))>>>0); //@line 500 "translate.cpp"
        var $or=($shr) | ($conv13); //@line 500 "translate.cpp"
        var $conv14=((($or)) & 255); //@line 500 "translate.cpp"
        var $11=$buf_addr; //@line 500 "translate.cpp"
        var $arrayidx15=(($11)&4294967295); //@line 500 "translate.cpp"
        HEAP8[($arrayidx15)]=$conv14; //@line 500 "translate.cpp"
        $j=0; //@line 501 "translate.cpp"
        var $12=$j; //@line 501 "translate.cpp"
        var $13=$n_bytes; //@line 501 "translate.cpp"
        var $cmp161=((($12))|0) < ((($13))|0); //@line 501 "translate.cpp"
        if ($cmp161) { __label__ = 10;; } else { __label__ = 11;; } //@line 501 "translate.cpp"
        $for_body$$for_end$15: do { 
          if (__label__ == 10) {
            while(1) { 
  
              var $14=$shift; //@line 503 "translate.cpp"
              var $sub=((($14)-6)&4294967295); //@line 503 "translate.cpp"
              $shift=$sub; //@line 503 "translate.cpp"
              var $15=$c_addr; //@line 504 "translate.cpp"
              var $16=$shift; //@line 504 "translate.cpp"
              var $shr17=($15) >>> ((($16))>>>0); //@line 504 "translate.cpp"
              var $and=($shr17) & 63; //@line 504 "translate.cpp"
              var $add=((($and)+128)&4294967295); //@line 504 "translate.cpp"
              var $conv18=((($add)) & 255); //@line 504 "translate.cpp"
              var $17=$j; //@line 504 "translate.cpp"
              var $add19=((($17)+1)&4294967295); //@line 504 "translate.cpp"
              var $18=$buf_addr; //@line 504 "translate.cpp"
              var $arrayidx20=(($18+$add19)&4294967295); //@line 504 "translate.cpp"
              HEAP8[($arrayidx20)]=$conv18; //@line 504 "translate.cpp"
              var $19=$j; //@line 501 "translate.cpp"
              var $inc=((($19)+1)&4294967295); //@line 501 "translate.cpp"
              $j=$inc; //@line 501 "translate.cpp"
              var $20=$j; //@line 501 "translate.cpp"
              var $21=$n_bytes; //@line 501 "translate.cpp"
              var $cmp16=((($20))|0) < ((($21))|0); //@line 501 "translate.cpp"
              if ($cmp16) { __label__ = 10;continue ; } else { __label__ = 11;break $for_body$$for_end$15; } //@line 501 "translate.cpp"
            }
          }
        } while(0);
  
        var $22=$n_bytes; //@line 506 "translate.cpp"
        var $add21=((($22)+1)&4294967295); //@line 506 "translate.cpp"
        $retval=$add21; //@line 506 "translate.cpp"
        ; //@line 506 "translate.cpp"
      }
    }
  
    var $23=$retval; //@line 507 "translate.cpp"
    ;
    return $23; //@line 507 "translate.cpp"
    return null;
  }
  

  function __Z11utf8_nbytesPKc($buf) {
    ;
    var __label__;
  
    var $retval;
    var $buf_addr;
    var $c;
    $buf_addr=$buf;
    var $0=$buf_addr; //@line 513 "translate.cpp"
    var $arrayidx=(($0)&4294967295); //@line 513 "translate.cpp"
    var $1=HEAP8[($arrayidx)]; //@line 513 "translate.cpp"
    $c=$1; //@line 513 "translate.cpp"
    var $2=$c; //@line 514 "translate.cpp"
    var $conv=((($2))&255); //@line 514 "translate.cpp"
    var $cmp=((($conv))|0) < 128; //@line 514 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 514 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 515 "translate.cpp"
      ; //@line 515 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$c; //@line 516 "translate.cpp"
      var $conv1=((($3))&255); //@line 516 "translate.cpp"
      var $cmp2=((($conv1))|0) < 224; //@line 516 "translate.cpp"
      if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 516 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=2; //@line 517 "translate.cpp"
        ; //@line 517 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$c; //@line 518 "translate.cpp"
        var $conv5=((($4))&255); //@line 518 "translate.cpp"
        var $cmp6=((($conv5))|0) < 240; //@line 518 "translate.cpp"
        if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 518 "translate.cpp"
        if (__label__ == 5) {
  
          $retval=3; //@line 519 "translate.cpp"
          ; //@line 519 "translate.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=4; //@line 520 "translate.cpp"
          ; //@line 520 "translate.cpp"
        }
      }
    }
  
    var $5=$retval; //@line 521 "translate.cpp"
    ;
    return $5; //@line 521 "translate.cpp"
    return null;
  }
  

  function __Z8utf8_in2PiPKci($c, $buf, $backwards) {
    ;
    var __label__;
  
    var $c_addr;
    var $buf_addr;
    var $backwards_addr;
    var $c1;
    var $n_bytes;
    var $ix;
    $c_addr=$c;
    $buf_addr=$buf;
    $backwards_addr=$backwards;
    var $0=$buf_addr; //@line 535 "translate.cpp"
    var $1=HEAP8[($0)]; //@line 535 "translate.cpp"
    var $conv2=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 535 "translate.cpp"
    var $and3=($conv2) & 192; //@line 535 "translate.cpp"
    var $cmp4=((($and3))|0)==128; //@line 535 "translate.cpp"
    if ($cmp4) { __label__ = 1;; } else { __label__ = 5;; } //@line 535 "translate.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$backwards_addr; //@line 538 "translate.cpp"
          var $tobool=((($2))|0)!=0; //@line 538 "translate.cpp"
          var $3=$buf_addr; //@line 539 "translate.cpp"
          if ($tobool) { __label__ = 2;; } else { __label__ = 3;; } //@line 538 "translate.cpp"
          if (__label__ == 2) {
  
            var $incdec_ptr=(($3+-1)&4294967295); //@line 539 "translate.cpp"
            $buf_addr=$incdec_ptr; //@line 539 "translate.cpp"
            ; //@line 539 "translate.cpp"
          }
          else if (__label__ == 3) {
  
            var $incdec_ptr1=(($3+1)&4294967295); //@line 541 "translate.cpp"
            $buf_addr=$incdec_ptr1; //@line 541 "translate.cpp"
            ;
          }
  
          var $4=$buf_addr; //@line 535 "translate.cpp"
          var $5=HEAP8[($4)]; //@line 535 "translate.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 535 "translate.cpp"
          var $and=($conv) & 192; //@line 535 "translate.cpp"
          var $cmp=((($and))|0)==128; //@line 535 "translate.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 5;break $while_body$$while_end$2; } //@line 535 "translate.cpp"
        }
      }
    } while(0);
  
    $n_bytes=0; //@line 544 "translate.cpp"
    var $6=$buf_addr; //@line 546 "translate.cpp"
    var $incdec_ptr2=(($6+1)&4294967295); //@line 546 "translate.cpp"
    $buf_addr=$incdec_ptr2; //@line 546 "translate.cpp"
    var $7=HEAP8[($6)]; //@line 546 "translate.cpp"
    var $conv3=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 546 "translate.cpp"
    $c1=$conv3; //@line 546 "translate.cpp"
    var $and4=($conv3) & 128; //@line 546 "translate.cpp"
    var $tobool5=((($and4))|0)!=0; //@line 546 "translate.cpp"
    if ($tobool5) { __label__ = 6;; } else { __label__ = 14;; } //@line 546 "translate.cpp"
    $if_then6$$if_end27$10: do { 
      if (__label__ == 6) {
  
        var $8=$c1; //@line 548 "translate.cpp"
        var $and7=($8) & 224; //@line 548 "translate.cpp"
        var $cmp8=((($and7))|0)==192; //@line 548 "translate.cpp"
        if ($cmp8) { __label__ = 7;; } else { __label__ = 8;; } //@line 548 "translate.cpp"
        $if_then9$$if_else10$12: do { 
          if (__label__ == 7) {
  
            $n_bytes=1; //@line 549 "translate.cpp"
            ; //@line 549 "translate.cpp"
          }
          else if (__label__ == 8) {
  
            var $9=$c1; //@line 551 "translate.cpp"
            var $and11=($9) & 240; //@line 551 "translate.cpp"
            var $cmp12=((($and11))|0)==224; //@line 551 "translate.cpp"
            if ($cmp12) { __label__ = 9;; } else { __label__ = 10;; } //@line 551 "translate.cpp"
            if (__label__ == 9) {
  
              $n_bytes=2; //@line 552 "translate.cpp"
              ; //@line 552 "translate.cpp"
            }
            else if (__label__ == 10) {
  
              var $10=$c1; //@line 554 "translate.cpp"
              var $and15=($10) & 248; //@line 554 "translate.cpp"
              var $cmp16=((($and15))|0)==240; //@line 554 "translate.cpp"
              if (!($cmp16)) { __label__ = 12;break $if_then9$$if_else10$12; } //@line 554 "translate.cpp"
  
              $n_bytes=3; //@line 555 "translate.cpp"
              ; //@line 555 "translate.cpp"
            }
          }
        } while(0);
  
        var $11=$n_bytes; //@line 557 "translate.cpp"
        var $arrayidx=((__ZZ8utf8_in2PiPKciE4mask+$11)&4294967295); //@line 557 "translate.cpp"
        var $12=HEAPU8[($arrayidx)]; //@line 557 "translate.cpp"
        var $conv21=((($12))&255); //@line 557 "translate.cpp"
        var $13=$c1; //@line 557 "translate.cpp"
        var $and22=($13) & ($conv21); //@line 557 "translate.cpp"
        $c1=$and22; //@line 557 "translate.cpp"
        $ix=0; //@line 558 "translate.cpp"
        var $14=$ix; //@line 558 "translate.cpp"
        var $15=$n_bytes; //@line 558 "translate.cpp"
        var $cmp231=((($14))|0) < ((($15))|0); //@line 558 "translate.cpp"
        if (!($cmp231)) { __label__ = 14;break $if_then6$$if_end27$10; } //@line 558 "translate.cpp"
        while(1) { 
  
          var $16=$c1; //@line 560 "translate.cpp"
          var $shl=((($16)*64)&4294967295); //@line 560 "translate.cpp"
          var $17=$buf_addr; //@line 560 "translate.cpp"
          var $incdec_ptr24=(($17+1)&4294967295); //@line 560 "translate.cpp"
          $buf_addr=$incdec_ptr24; //@line 560 "translate.cpp"
          var $18=HEAP8[($17)]; //@line 560 "translate.cpp"
          var $conv25=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 560 "translate.cpp"
          var $and26=($conv25) & 63; //@line 560 "translate.cpp"
          var $add=((($and26)+($shl))&4294967295); //@line 560 "translate.cpp"
          $c1=$add; //@line 560 "translate.cpp"
          var $19=$ix; //@line 558 "translate.cpp"
          var $inc=((($19)+1)&4294967295); //@line 558 "translate.cpp"
          $ix=$inc; //@line 558 "translate.cpp"
          var $20=$ix; //@line 558 "translate.cpp"
          var $21=$n_bytes; //@line 558 "translate.cpp"
          var $cmp23=((($20))|0) < ((($21))|0); //@line 558 "translate.cpp"
          if ($cmp23) { __label__ = 13;continue ; } else { __label__ = 14;break $if_then6$$if_end27$10; } //@line 558 "translate.cpp"
        }
      }
    } while(0);
  
    var $22=$c1; //@line 563 "translate.cpp"
    var $23=$c_addr; //@line 563 "translate.cpp"
    HEAP32[(($23)>>2)]=$22; //@line 563 "translate.cpp"
    var $24=$n_bytes; //@line 564 "translate.cpp"
    var $add28=((($24)+1)&4294967295); //@line 564 "translate.cpp"
    ;
    return $add28; //@line 564 "translate.cpp"
    return null;
  }
  

  function __Z7utf8_inPiPKc($c, $buf) {
    ;
    var __label__;
  
    var $c_addr;
    var $buf_addr;
    $c_addr=$c;
    $buf_addr=$buf;
    var $0=$c_addr; //@line 572 "translate.cpp"
    var $1=$buf_addr; //@line 572 "translate.cpp"
    var $call=__Z8utf8_in2PiPKci($0, $1, 0); //@line 572 "translate.cpp"
    ;
    return $call; //@line 572 "translate.cpp"
    return null;
  }
  

  function __Z8strchr_wPKci($s, $c) {
    ;
    var __label__;
  
    var $retval;
    var $s_addr;
    var $c_addr;
    $s_addr=$s;
    $c_addr=$c;
    var $0=$c_addr; //@line 579 "translate.cpp"
    var $cmp=((($0))|0) >= 128; //@line 579 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 579 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 580 "translate.cpp"
      ; //@line 580 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$s_addr; //@line 581 "translate.cpp"
      var $2=$c_addr; //@line 581 "translate.cpp"
      var $call=_strchr($1, $2); //@line 581 "translate.cpp"
      $retval=$call; //@line 581 "translate.cpp"
      ; //@line 581 "translate.cpp"
    }
  
    var $3=$retval; //@line 582 "translate.cpp"
    ;
    return $3; //@line 582 "translate.cpp"
    return null;
  }
  

  function __Z10IsAllUpperPKc($word) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $word_addr;
    var $c=__stackBase__;
    $word_addr=$word;
    ; //@line 588 "translate.cpp"
    while(1) { 
  
      var $0=$word_addr; //@line 588 "translate.cpp"
      var $1=HEAP8[($0)]; //@line 588 "translate.cpp"
      var $conv=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 588 "translate.cpp"
      var $cmp=((($conv))|0)!=0; //@line 588 "translate.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 588 "translate.cpp"
  
      var $2=$word_addr; //@line 588 "translate.cpp"
      var $3=HEAP8[($2)]; //@line 588 "translate.cpp"
      var $conv1=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 588 "translate.cpp"
      var $call=__Z8isspace2j($conv1); //@line 588 "translate.cpp"
      var $tobool=((($call))|0)!=0; //@line 588 "translate.cpp"
      var $lnot=($tobool) ^ 1; //@line 588 "translate.cpp"
      if (!($lnot)) { __label__ = 5;break ; }
  
      var $4=$word_addr; //@line 590 "translate.cpp"
      var $call2=__Z7utf8_inPiPKc($c, $4); //@line 590 "translate.cpp"
      var $5=$word_addr; //@line 590 "translate.cpp"
      var $add_ptr=(($5+$call2)&4294967295); //@line 590 "translate.cpp"
      $word_addr=$add_ptr; //@line 590 "translate.cpp"
      var $6=HEAP32[(($c)>>2)]; //@line 591 "translate.cpp"
      var $call3=_iswupper($6); //@line 591 "translate.cpp"
      var $tobool4=((($call3))|0)!=0; //@line 591 "translate.cpp"
      if ($tobool4) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 591 "translate.cpp"
    }
    if (__label__ == 5) {
  
      $retval=1; //@line 594 "translate.cpp"
      ; //@line 594 "translate.cpp"
    }
    else if (__label__ == 4) {
  
      $retval=0; //@line 592 "translate.cpp"
      ; //@line 592 "translate.cpp"
    }
  
    var $7=$retval; //@line 595 "translate.cpp"
    STACKTOP = __stackBase__;
    return $7; //@line 595 "translate.cpp"
    return null;
  }
  

  function __Z24ChangeEquivalentPhonemesP10TranslatoriPc($tr, $lang2, $phonemes) {
    var __stackBase__  = STACKTOP; STACKTOP += 160; _memset(__stackBase__, 0, 160);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $lang2_addr;
    var $phonemes_addr;
    var $ix;
    var $len;
    var $phon;
    var $p;
    var $pb;
    var $eqlist;
    var $p_out;
    var $p_in;
    var $remove_stress;
    var $phonbuf=__stackBase__;
    $tr_addr=$tr;
    $lang2_addr=$lang2;
    $phonemes_addr=$phonemes;
    $remove_stress=0; //@line 707 "translate.cpp"
    var $0=$tr_addr; //@line 711 "translate.cpp"
    var $phoneme_tab_ix=(($0+656)&4294967295); //@line 711 "translate.cpp"
    var $1=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 711 "translate.cpp"
    var $arrayidx=((_phoneme_tab_list+$1*48)&4294967295); //@line 711 "translate.cpp"
    var $equivalence_tables=(($arrayidx+44)&4294967295); //@line 711 "translate.cpp"
    var $2=HEAP32[(($equivalence_tables)>>2)]; //@line 711 "translate.cpp"
    $ix=$2; //@line 711 "translate.cpp"
    var $cmp=((($2))|0)==0; //@line 711 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 711 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 712 "translate.cpp"
      ; //@line 712 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$ix; //@line 714 "translate.cpp"
      var $4=HEAP32[((_phondata_ptr)>>2)]; //@line 714 "translate.cpp"
      var $arrayidx1=(($4+$3)&4294967295); //@line 714 "translate.cpp"
      $pb=$arrayidx1; //@line 714 "translate.cpp"
      ; //@line 716 "translate.cpp"
      $for_cond$5: while(1) { 
  
        var $5=$pb; //@line 718 "translate.cpp"
        var $arrayidx2=(($5)&4294967295); //@line 718 "translate.cpp"
        var $6=HEAPU8[($arrayidx2)]; //@line 718 "translate.cpp"
        var $conv=((($6))&255); //@line 718 "translate.cpp"
        var $cmp3=((($conv))|0)==0; //@line 718 "translate.cpp"
        if ($cmp3) { __label__ = 4;break $for_cond$5; } //@line 718 "translate.cpp"
  
        var $7=$pb; //@line 721 "translate.cpp"
        var $arrayidx6=(($7)&4294967295); //@line 721 "translate.cpp"
        var $8=HEAPU8[($arrayidx6)]; //@line 721 "translate.cpp"
        var $conv7=((($8))&255); //@line 721 "translate.cpp"
        var $9=$lang2_addr; //@line 721 "translate.cpp"
        var $cmp8=((($conv7))|0)==((($9))|0); //@line 721 "translate.cpp"
        var $10=$pb; //@line 727 "translate.cpp"
        if ($cmp8) { __label__ = 7;break $for_cond$5; } //@line 721 "translate.cpp"
  
        var $arrayidx11=(($10+2)&4294967295); //@line 724 "translate.cpp"
        var $11=HEAPU8[($arrayidx11)]; //@line 724 "translate.cpp"
        var $conv12=((($11))&255); //@line 724 "translate.cpp"
        var $shl=((($conv12)*256)&4294967295); //@line 724 "translate.cpp"
        var $12=$pb; //@line 724 "translate.cpp"
        var $arrayidx13=(($12+3)&4294967295); //@line 724 "translate.cpp"
        var $13=HEAPU8[($arrayidx13)]; //@line 724 "translate.cpp"
        var $conv14=((($13))&255); //@line 724 "translate.cpp"
        var $add=((($conv14)+($shl))&4294967295); //@line 724 "translate.cpp"
        $len=$add; //@line 724 "translate.cpp"
        var $14=$len; //@line 725 "translate.cpp"
        var $mul=((($14)*4)&4294967295); //@line 725 "translate.cpp"
        var $15=$pb; //@line 725 "translate.cpp"
        var $add_ptr=(($15+$mul)&4294967295); //@line 725 "translate.cpp"
        $pb=$add_ptr; //@line 725 "translate.cpp"
        __label__ = 3;continue $for_cond$5; //@line 726 "translate.cpp"
      }
      if (__label__ == 4) {
  
        $retval=0; //@line 719 "translate.cpp"
        ; //@line 719 "translate.cpp"
      }
      else if (__label__ == 7) {
  
        var $arrayidx15=(($10+1)&4294967295); //@line 727 "translate.cpp"
        var $16=HEAPU8[($arrayidx15)]; //@line 727 "translate.cpp"
        var $conv16=((($16))&255); //@line 727 "translate.cpp"
        $remove_stress=$conv16; //@line 727 "translate.cpp"
        var $17=HEAP32[((_option_phonemes)>>2)]; //@line 729 "translate.cpp"
        var $cmp17=((($17))|0)==2; //@line 729 "translate.cpp"
        if ($cmp17) { __label__ = 8;; } else { __label__ = 9;; } //@line 729 "translate.cpp"
        if (__label__ == 8) {
  
          var $18=$phonemes_addr; //@line 731 "translate.cpp"
          var $arraydecay=(($phonbuf)&4294967295); //@line 731 "translate.cpp"
          __Z14DecodePhonemesPKcPc($18, $arraydecay); //@line 731 "translate.cpp"
          var $19=HEAP32[((_f_trans)>>2)]; //@line 732 "translate.cpp"
          var $20=$lang2_addr; //@line 732 "translate.cpp"
          var $arrayidx19=((_phoneme_tab_list+$20*48)&4294967295); //@line 732 "translate.cpp"
          var $name=(($arrayidx19)&4294967295); //@line 732 "translate.cpp"
          var $arraydecay20=(($name)&4294967295); //@line 732 "translate.cpp"
          var $arraydecay21=(($phonbuf)&4294967295); //@line 732 "translate.cpp"
          var $21=$tr_addr; //@line 732 "translate.cpp"
          var $phoneme_tab_ix22=(($21+656)&4294967295); //@line 732 "translate.cpp"
          var $22=HEAP32[(($phoneme_tab_ix22)>>2)]; //@line 732 "translate.cpp"
          var $arrayidx23=((_phoneme_tab_list+$22*48)&4294967295); //@line 732 "translate.cpp"
          var $name24=(($arrayidx23)&4294967295); //@line 732 "translate.cpp"
          var $arraydecay25=(($name24)&4294967295); //@line 732 "translate.cpp"
          var $call=_fprintf($19, ((__str543)&4294967295), allocate([$arraydecay20,0,0,0,$arraydecay21,0,0,0,$arraydecay25,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 732 "translate.cpp"
          ; //@line 733 "translate.cpp"
        }
  
        var $23=$phonemes_addr; //@line 735 "translate.cpp"
        $p_in=$23; //@line 735 "translate.cpp"
        var $24=$pb; //@line 736 "translate.cpp"
        var $arrayidx27=(($24+8)&4294967295); //@line 736 "translate.cpp"
        $eqlist=$arrayidx27; //@line 736 "translate.cpp"
        var $arraydecay28=(($phonbuf)&4294967295); //@line 737 "translate.cpp"
        $p_out=$arraydecay28; //@line 737 "translate.cpp"
        var $25=$p_in; //@line 739 "translate.cpp"
        var $incdec_ptr1=(($25+1)&4294967295); //@line 739 "translate.cpp"
        $p_in=$incdec_ptr1; //@line 739 "translate.cpp"
        var $26=HEAP8[($25)]; //@line 739 "translate.cpp"
        $phon=$26; //@line 739 "translate.cpp"
        var $conv292=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 739 "translate.cpp"
        var $cmp303=((($conv292))|0)!=0; //@line 739 "translate.cpp"
        if ($cmp303) { __label__ = 10;; } else { __label__ = 20;; } //@line 739 "translate.cpp"
        $while_body$$while_end56$15: do { 
          if (__label__ == 10) {
            $while_body$16: while(1) { 
  
              var $27=$remove_stress; //@line 741 "translate.cpp"
              var $tobool=((($27))|0)!=0; //@line 741 "translate.cpp"
              if ($tobool) { __label__ = 11;; } else { __label__ = 13;; } //@line 741 "translate.cpp"
              $land_lhs_true$$if_end34$18: do { 
                if (__label__ == 11) {
  
                  var $28=$phon; //@line 741 "translate.cpp"
                  var $conv31=(tempInt=(($28)),(tempInt>=128?tempInt-256:tempInt)); //@line 741 "translate.cpp"
                  var $and=($conv31) & 255; //@line 741 "translate.cpp"
                  var $cmp32=((($and))|0) < 8; //@line 741 "translate.cpp"
                  if ($cmp32) { __label__ = 12;break $land_lhs_true$$if_end34$18; } else { __label__ = 13;break $land_lhs_true$$if_end34$18; } //@line 741 "translate.cpp"
                }
              } while(0);
              $while_cond_backedge$$if_end34$20: do { 
                if (__label__ == 13) {
  
                  var $31=$eqlist; //@line 745 "translate.cpp"
                  $p=$31; //@line 745 "translate.cpp"
                  ; //@line 746 "translate.cpp"
                  while(1) { 
  
                    var $32=$p; //@line 746 "translate.cpp"
                    var $33=HEAP8[($32)]; //@line 746 "translate.cpp"
                    var $conv36=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 746 "translate.cpp"
                    var $cmp37=((($conv36))|0)!=0; //@line 746 "translate.cpp"
                    if (!($cmp37)) { __label__ = 18;break ; } //@line 746 "translate.cpp"
  
                    var $34=$p; //@line 748 "translate.cpp"
                    var $arrayidx39=(($34+1)&4294967295); //@line 748 "translate.cpp"
                    var $call40=_strlen($arrayidx39); //@line 748 "translate.cpp"
                    $len=$call40; //@line 748 "translate.cpp"
                    var $35=$p; //@line 749 "translate.cpp"
                    var $36=HEAP8[($35)]; //@line 749 "translate.cpp"
                    var $conv41=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 749 "translate.cpp"
                    var $37=$phon; //@line 749 "translate.cpp"
                    var $conv42=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 749 "translate.cpp"
                    var $cmp43=((($conv41))|0)==((($conv42))|0); //@line 749 "translate.cpp"
                    if ($cmp43) { __label__ = 16;break ; } //@line 749 "translate.cpp"
  
                    var $42=$len; //@line 755 "translate.cpp"
                    var $add49=((($42)+2)&4294967295); //@line 755 "translate.cpp"
                    var $43=$p; //@line 755 "translate.cpp"
                    var $add_ptr50=(($43+$add49)&4294967295); //@line 755 "translate.cpp"
                    $p=$add_ptr50; //@line 755 "translate.cpp"
                    __label__ = 14;continue ; //@line 756 "translate.cpp"
                  }
                  if (__label__ == 16) {
  
                    var $38=$p_out; //@line 751 "translate.cpp"
                    var $39=$p; //@line 751 "translate.cpp"
                    var $arrayidx45=(($39+1)&4294967295); //@line 751 "translate.cpp"
                    var $call46=_strcpy($38, $arrayidx45); //@line 751 "translate.cpp"
                    var $40=$len; //@line 752 "translate.cpp"
                    var $41=$p_out; //@line 752 "translate.cpp"
                    var $add_ptr47=(($41+$40)&4294967295); //@line 752 "translate.cpp"
                    $p_out=$add_ptr47; //@line 752 "translate.cpp"
                    ; //@line 753 "translate.cpp"
                  }
  
                  var $44=$p; //@line 757 "translate.cpp"
                  var $45=HEAP8[($44)]; //@line 757 "translate.cpp"
                  var $conv51=(tempInt=(($45)),(tempInt>=128?tempInt-256:tempInt)); //@line 757 "translate.cpp"
                  var $cmp52=((($conv51))|0)==0; //@line 757 "translate.cpp"
                  if (!($cmp52)) { __label__ = 12;break $while_cond_backedge$$if_end34$20; } //@line 757 "translate.cpp"
  
                  var $46=$phon; //@line 760 "translate.cpp"
                  var $47=$p_out; //@line 760 "translate.cpp"
                  var $incdec_ptr54=(($47+1)&4294967295); //@line 760 "translate.cpp"
                  $p_out=$incdec_ptr54; //@line 760 "translate.cpp"
                  HEAP8[($47)]=$46; //@line 760 "translate.cpp"
                  ; //@line 761 "translate.cpp"
                }
              } while(0);
  
              var $29=$p_in; //@line 739 "translate.cpp"
              var $incdec_ptr=(($29+1)&4294967295); //@line 739 "translate.cpp"
              $p_in=$incdec_ptr; //@line 739 "translate.cpp"
              var $30=HEAP8[($29)]; //@line 739 "translate.cpp"
              $phon=$30; //@line 739 "translate.cpp"
              var $conv29=(tempInt=(($30)),(tempInt>=128?tempInt-256:tempInt)); //@line 739 "translate.cpp"
              var $cmp30=((($conv29))|0)!=0; //@line 739 "translate.cpp"
              if ($cmp30) { __label__ = 10;continue $while_body$16; } else { __label__ = 20;break $while_body$$while_end56$15; } //@line 739 "translate.cpp"
            }
          }
        } while(0);
  
        var $48=$p_out; //@line 763 "translate.cpp"
        HEAP8[($48)]=0; //@line 763 "translate.cpp"
        var $49=$remove_stress; //@line 765 "translate.cpp"
        var $tobool57=((($49))|0)!=0; //@line 765 "translate.cpp"
        if ($tobool57) { __label__ = 21;; } else { __label__ = 22;; } //@line 765 "translate.cpp"
        if (__label__ == 21) {
  
          var $50=$tr_addr; //@line 767 "translate.cpp"
          var $arraydecay59=(($phonbuf)&4294967295); //@line 767 "translate.cpp"
          __Z13SetWordStressP10TranslatorPcPjii($50, $arraydecay59, 0, -1, 0); //@line 767 "translate.cpp"
          ; //@line 768 "translate.cpp"
        }
  
        var $51=$phonemes_addr; //@line 770 "translate.cpp"
        var $arraydecay61=(($phonbuf)&4294967295); //@line 770 "translate.cpp"
        var $call62=_strcpy($51, $arraydecay61); //@line 770 "translate.cpp"
        var $52=HEAP32[((_option_phonemes)>>2)]; //@line 772 "translate.cpp"
        var $cmp63=((($52))|0)==2; //@line 772 "translate.cpp"
        if ($cmp63) { __label__ = 23;; } else { __label__ = 24;; } //@line 772 "translate.cpp"
        if (__label__ == 23) {
  
          var $53=$tr_addr; //@line 774 "translate.cpp"
          var $phoneme_tab_ix65=(($53+656)&4294967295); //@line 774 "translate.cpp"
          var $54=HEAP32[(($phoneme_tab_ix65)>>2)]; //@line 774 "translate.cpp"
          __Z18SelectPhonemeTablei($54); //@line 774 "translate.cpp"
          var $55=$phonemes_addr; //@line 775 "translate.cpp"
          var $arraydecay66=(($phonbuf)&4294967295); //@line 775 "translate.cpp"
          __Z14DecodePhonemesPKcPc($55, $arraydecay66); //@line 775 "translate.cpp"
          var $56=HEAP32[((_f_trans)>>2)]; //@line 776 "translate.cpp"
          var $arraydecay67=(($phonbuf)&4294967295); //@line 776 "translate.cpp"
          var $call68=_fprintf($56, ((__str1544)&4294967295), allocate([$arraydecay67,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 776 "translate.cpp"
          ; //@line 777 "translate.cpp"
        }
  
        $retval=1; //@line 778 "translate.cpp"
        ; //@line 778 "translate.cpp"
      }
    }
  
    var $57=$retval; //@line 779 "translate.cpp"
    STACKTOP = __stackBase__;
    return $57; //@line 779 "translate.cpp"
    return null;
  }
  

  function __Z13TranslateWordP10TranslatorPciP8WORD_TAB($tr, $word_start, $next_pause, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 1656; _memset(__stackBase__, 0, 1656);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_start_addr;
    var $next_pause_addr;
    var $wtab_addr;
    var $word1=__stackBase__;
    var $word_length;
    var $ix;
    var $p;
    var $pfix;
    var $n_chars;
    var $dictionary_flags=__stackBase__+4;
    var $dictionary_flags2=__stackBase__+12;
    var $end_type;
    var $prefix_type;
    var $prefix_stress;
    var $wordx=__stackBase__+20;
    var $phonemes=__stackBase__+24;
    var $ph_limit;
    var $prefix_phonemes=__stackBase__+184;
    var $unpron_phonemes=__stackBase__+344;
    var $end_phonemes=__stackBase__+504;
    var $word_copy=__stackBase__+664;
    var $word_copy2=__stackBase__+824;
    var $word_copy_length;
    var $prefix_chars=__stackBase__+984;
    var $found;
    var $end_flags;
    var $c_temp;
    var $first_char=__stackBase__+1052;
    var $last_char=__stackBase__+1056;
    var $add_plural_suffix;
    var $prefix_flags;
    var $confirm_prefix;
    var $spell_word;
    var $stress_bits;
    var $emphasize_allcaps;
    var $wflags;
    var $wmark;
    var $was_unpronouncable;
    var $wtab_null=__stackBase__+1060;
    var $posn;
    var $non_initial;
    var $length;
    var $wc=__stackBase__+1156;
    var $loopcount;
    var $end2;
    var $phonemes2=__stackBase__+1160;
    var $end_phonemes2=__stackBase__+1320;
    var $wordpf=__stackBase__+1480;
    var $prefix_phonemes2=__stackBase__+1484;
    var $phonemes2482=__stackBase__+1496;
    var $p659;
    $tr_addr=$tr;
    $word_start_addr=$word_start;
    $next_pause_addr=$next_pause;
    $wtab_addr=$wtab;
    $end_type=0; //@line 796 "translate.cpp"
    $prefix_type=0; //@line 797 "translate.cpp"
    $found=0; //@line 809 "translate.cpp"
    HEAP32[(($last_char)>>2)]=0; //@line 813 "translate.cpp"
    $add_plural_suffix=0; //@line 814 "translate.cpp"
    $prefix_flags=0; //@line 815 "translate.cpp"
    $emphasize_allcaps=0; //@line 819 "translate.cpp"
    $was_unpronouncable=0; //@line 822 "translate.cpp"
    var $0=$wtab_addr; //@line 831 "translate.cpp"
    var $cmp=((($0))|0)==0; //@line 831 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 831 "translate.cpp"
    if (__label__ == 1) {
  
      var $arraydecay=(($wtab_null)&4294967295); //@line 833 "translate.cpp"
      var $1=$arraydecay; //@line 833 "translate.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $1;
      $stop$ = $dest$ + 96;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 833 "translate.cpp"
      var $arraydecay1=(($wtab_null)&4294967295); //@line 834 "translate.cpp"
      $wtab_addr=$arraydecay1; //@line 834 "translate.cpp"
      ; //@line 835 "translate.cpp"
    }
  
    var $2=$wtab_addr; //@line 836 "translate.cpp"
    var $flags=(($2)&4294967295); //@line 836 "translate.cpp"
    var $3=HEAP32[(($flags)>>2)]; //@line 836 "translate.cpp"
    $wflags=$3; //@line 836 "translate.cpp"
    var $4=$wtab_addr; //@line 837 "translate.cpp"
    var $wmark2=(($4+9)&4294967295); //@line 837 "translate.cpp"
    var $5=HEAPU8[($wmark2)]; //@line 837 "translate.cpp"
    var $conv=((($5))&255); //@line 837 "translate.cpp"
    $wmark=$conv; //@line 837 "translate.cpp"
    var $arrayidx=(($dictionary_flags)&4294967295); //@line 839 "translate.cpp"
    HEAP32[(($arrayidx)>>2)]=0; //@line 839 "translate.cpp"
    var $arrayidx3=(($dictionary_flags+4)&4294967295); //@line 840 "translate.cpp"
    HEAP32[(($arrayidx3)>>2)]=0; //@line 840 "translate.cpp"
    var $arrayidx4=(($dictionary_flags2)&4294967295); //@line 841 "translate.cpp"
    HEAP32[(($arrayidx4)>>2)]=0; //@line 841 "translate.cpp"
    var $arrayidx5=(($dictionary_flags2+4)&4294967295); //@line 842 "translate.cpp"
    HEAP32[(($arrayidx5)>>2)]=0; //@line 842 "translate.cpp"
    HEAP32[((_dictionary_skipwords)>>2)]=0; //@line 843 "translate.cpp"
    var $arrayidx6=(($phonemes)&4294967295); //@line 845 "translate.cpp"
    HEAP8[($arrayidx6)]=0; //@line 845 "translate.cpp"
    var $arrayidx7=(($unpron_phonemes)&4294967295); //@line 846 "translate.cpp"
    HEAP8[($arrayidx7)]=0; //@line 846 "translate.cpp"
    var $arrayidx8=(($prefix_phonemes)&4294967295); //@line 847 "translate.cpp"
    HEAP8[($arrayidx8)]=0; //@line 847 "translate.cpp"
    var $arrayidx9=(($end_phonemes)&4294967295); //@line 848 "translate.cpp"
    HEAP8[($arrayidx9)]=0; //@line 848 "translate.cpp"
    var $arrayidx10=(($phonemes+160)&4294967295); //@line 849 "translate.cpp"
    $ph_limit=$arrayidx10; //@line 849 "translate.cpp"
    var $6=$tr_addr; //@line 851 "translate.cpp"
    var $data_dictlist=(($6+1052)&4294967295); //@line 851 "translate.cpp"
    var $7=HEAP32[(($data_dictlist)>>2)]; //@line 851 "translate.cpp"
    var $cmp11=((($7))|0)==0; //@line 851 "translate.cpp"
    if ($cmp11) { __label__ = 3;; } else { __label__ = 4;; } //@line 851 "translate.cpp"
    $if_then12$$if_end13$5: do { 
      if (__label__ == 3) {
  
        HEAP8[(((_word_phonemes)&4294967295))]=0; //@line 854 "translate.cpp"
        $retval=0; //@line 855 "translate.cpp"
        ; //@line 855 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $8=$word_start_addr; //@line 859 "translate.cpp"
        HEAP32[(($word1)>>2)]=$8; //@line 859 "translate.cpp"
        var $9=HEAP32[(($word1)>>2)]; //@line 860 "translate.cpp"
        var $10=HEAP8[($9)]; //@line 860 "translate.cpp"
        var $conv14=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 860 "translate.cpp"
        var $cmp15=((($conv14))|0)==32; //@line 860 "translate.cpp"
        if ($cmp15) { __label__ = 5;; } else { __label__ = 6;; } //@line 860 "translate.cpp"
        if (__label__ == 5) {
  
          var $11=HEAP32[(($word1)>>2)]; //@line 860 "translate.cpp"
          var $incdec_ptr=(($11+1)&4294967295); //@line 860 "translate.cpp"
          HEAP32[(($word1)>>2)]=$incdec_ptr; //@line 860 "translate.cpp"
          ; //@line 860 "translate.cpp"
        }
  
        var $12=HEAP32[(($word1)>>2)]; //@line 861 "translate.cpp"
        HEAP32[(($wordx)>>2)]=$12; //@line 861 "translate.cpp"
        var $13=HEAP32[(($wordx)>>2)]; //@line 863 "translate.cpp"
        var $call=__Z7utf8_inPiPKc($first_char, $13); //@line 863 "translate.cpp"
        $word_length=0; //@line 864 "translate.cpp"
        ; //@line 865 "translate.cpp"
        $while_cond$11: while(1) { 
  
          var $14=HEAP32[(($wordx)>>2)]; //@line 865 "translate.cpp"
          var $15=HEAP8[($14)]; //@line 865 "translate.cpp"
          var $conv18=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 865 "translate.cpp"
          var $cmp19=((($conv18))|0)!=0; //@line 865 "translate.cpp"
          var $16=HEAP32[(($wordx)>>2)]; //@line 865 "translate.cpp"
          if ($cmp19) { __lastLabel__ = 7; ; } else { __lastLabel__ = 7; __label__ = 10;break $while_cond$11; } //@line 865 "translate.cpp"
  
          var $17=HEAP8[($16)]; //@line 865 "translate.cpp"
          var $conv20=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 865 "translate.cpp"
          var $cmp21=((($conv20))|0)!=32; //@line 865 "translate.cpp"
          var $18=HEAP32[(($wordx)>>2)]; //@line 867 "translate.cpp"
          if ($cmp21) { __lastLabel__ = 8; ; } else { __lastLabel__ = 8; __label__ = 10;break $while_cond$11; }
  
          var $call22=__Z7utf8_inPiPKc($last_char, $18); //@line 867 "translate.cpp"
          var $19=HEAP32[(($wordx)>>2)]; //@line 867 "translate.cpp"
          var $add_ptr=(($19+$call22)&4294967295); //@line 867 "translate.cpp"
          HEAP32[(($wordx)>>2)]=$add_ptr; //@line 867 "translate.cpp"
          var $20=$word_length; //@line 868 "translate.cpp"
          var $inc=((($20)+1)&4294967295); //@line 868 "translate.cpp"
          $word_length=$inc; //@line 868 "translate.cpp"
          __label__ = 7;continue $while_cond$11; //@line 869 "translate.cpp"
        }
  
        var $21=__lastLabel__ == 8 ? $18 : ($16);
        var $22=$word_start_addr; //@line 871 "translate.cpp"
        var $sub_ptr_lhs_cast=($21); //@line 871 "translate.cpp"
        var $sub_ptr_rhs_cast=($22); //@line 871 "translate.cpp"
        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 871 "translate.cpp"
        $word_copy_length=$sub_ptr_sub; //@line 871 "translate.cpp"
        var $cmp23=((($sub_ptr_sub))|0) >= 160; //@line 872 "translate.cpp"
        if ($cmp23) { __label__ = 11;; } else { __label__ = 12;; } //@line 872 "translate.cpp"
        if (__label__ == 11) {
  
          $word_copy_length=159; //@line 873 "translate.cpp"
          ; //@line 873 "translate.cpp"
        }
  
        var $arraydecay26=(($word_copy2)&4294967295); //@line 874 "translate.cpp"
        var $23=$word_start_addr; //@line 874 "translate.cpp"
        var $24=$word_copy_length; //@line 874 "translate.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $23;
        $dest$ = $arraydecay26;
        $stop$ = $src$ + $24;
        if (($dest$%4) == ($src$%4) && $24 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 874 "translate.cpp"
        $spell_word=0; //@line 876 "translate.cpp"
        var $25=HEAP32[((_option_sayas)>>2)]; //@line 878 "translate.cpp"
        var $cmp27=((($25))|0)==36; //@line 878 "translate.cpp"
        if ($cmp27) { __label__ = 13;; } else { __label__ = 16;; } //@line 878 "translate.cpp"
        if (__label__ == 13) {
  
          var $26=$word_length; //@line 880 "translate.cpp"
          var $cmp29=((($26))|0)==1; //@line 880 "translate.cpp"
          if ($cmp29) { __label__ = 14;; } else { __label__ = 15;; } //@line 880 "translate.cpp"
          if (__label__ == 14) {
  
            $spell_word=4; //@line 881 "translate.cpp"
            ; //@line 881 "translate.cpp"
          }
          else if (__label__ == 15) {
  
            var $27=HEAP32[(($word1)>>2)]; //@line 885 "translate.cpp"
            var $incdec_ptr31=(($27+-1)&4294967295); //@line 885 "translate.cpp"
            HEAP32[(($word1)>>2)]=$incdec_ptr31; //@line 885 "translate.cpp"
            var $28=HEAP32[(($word1)>>2)]; //@line 886 "translate.cpp"
            HEAP8[($28)]=95; //@line 886 "translate.cpp"
            var $29=$tr_addr; //@line 887 "translate.cpp"
            var $arraydecay32=(($phonemes)&4294967295); //@line 887 "translate.cpp"
            var $arraydecay33=(($dictionary_flags)&4294967295); //@line 887 "translate.cpp"
            var $30=$wtab_addr; //@line 887 "translate.cpp"
            var $call34=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($29, $word1, $arraydecay32, $arraydecay33, 0, $30); //@line 887 "translate.cpp"
            $found=$call34; //@line 887 "translate.cpp"
            ;
          }
        }
  
        var $31=HEAP32[((_option_sayas)>>2)]; //@line 893 "translate.cpp"
        var $and=($31) & 16; //@line 893 "translate.cpp"
        var $tobool=((($and))|0)!=0; //@line 893 "translate.cpp"
        if ($tobool) { __label__ = 17;; } else { __label__ = 18;; } //@line 893 "translate.cpp"
        $if_then37$$if_else39$25: do { 
          if (__label__ == 17) {
  
            var $32=HEAP32[((_option_sayas)>>2)]; //@line 896 "translate.cpp"
            var $and38=($32) & 15; //@line 896 "translate.cpp"
            $spell_word=$and38; //@line 896 "translate.cpp"
            __lastLabel__ = 17; __label__ = 70;break $if_then37$$if_else39$25; //@line 897 "translate.cpp"
          }
          else if (__label__ == 18) {
  
            var $33=$found; //@line 900 "translate.cpp"
            var $tobool40=((($33))|0)!=0; //@line 900 "translate.cpp"
            if ($tobool40) { __label__ = 20;; } else { __label__ = 19;; } //@line 900 "translate.cpp"
            if (__label__ == 19) {
  
              var $34=$tr_addr; //@line 901 "translate.cpp"
              var $arraydecay42=(($phonemes)&4294967295); //@line 901 "translate.cpp"
              var $arraydecay43=(($dictionary_flags)&4294967295); //@line 901 "translate.cpp"
              var $35=$wtab_addr; //@line 901 "translate.cpp"
              var $call44=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($34, $word1, $arraydecay42, $arraydecay43, 2, $35); //@line 901 "translate.cpp"
              $found=$call44; //@line 901 "translate.cpp"
              ; //@line 901 "translate.cpp"
            }
  
            var $arrayidx46=(($dictionary_flags)&4294967295); //@line 904 "translate.cpp"
            var $36=HEAP32[(($arrayidx46)>>2)]; //@line 904 "translate.cpp"
            var $and47=($36) & 1; //@line 904 "translate.cpp"
            var $tobool48=((($and47))|0)!=0; //@line 904 "translate.cpp"
            if ($tobool48) { __label__ = 21;; } else { __label__ = 23;; } //@line 904 "translate.cpp"
            $land_lhs_true$$if_end54$31: do { 
              if (__label__ == 21) {
  
                var $37=HEAP32[(($wordx)>>2)]; //@line 904 "translate.cpp"
                var $arrayidx49=(($37+1)&4294967295); //@line 904 "translate.cpp"
                var $38=HEAP8[($arrayidx49)]; //@line 904 "translate.cpp"
                var $conv50=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 904 "translate.cpp"
                var $cmp51=((($conv50))|0)==46; //@line 904 "translate.cpp"
                if (!($cmp51)) { __label__ = 23;break $land_lhs_true$$if_end54$31; } //@line 904 "translate.cpp"
  
                var $39=HEAP32[(($wordx)>>2)]; //@line 906 "translate.cpp"
                var $arrayidx53=(($39+1)&4294967295); //@line 906 "translate.cpp"
                HEAP8[($arrayidx53)]=32; //@line 906 "translate.cpp"
                ; //@line 907 "translate.cpp"
              }
            } while(0);
  
            var $arrayidx55=(($dictionary_flags)&4294967295); //@line 909 "translate.cpp"
            var $40=HEAP32[(($arrayidx55)>>2)]; //@line 909 "translate.cpp"
            var $and56=($40) & 536870912; //@line 909 "translate.cpp"
            var $tobool57=((($and56))|0)!=0; //@line 909 "translate.cpp"
            if ($tobool57) { __label__ = 24;; } else { __label__ = 27;; } //@line 909 "translate.cpp"
            $if_then58$$if_else80$35: do { 
              if (__label__ == 24) {
  
                var $41=HEAP32[(($word1)>>2)]; //@line 911 "translate.cpp"
                var $arrayidx59=(($41)&4294967295); //@line 911 "translate.cpp"
                var $42=HEAP8[($arrayidx59)]; //@line 911 "translate.cpp"
                var $conv60=(tempInt=(($42)),(tempInt>=128?tempInt-256:tempInt)); //@line 911 "translate.cpp"
                HEAP32[(($first_char)>>2)]=$conv60; //@line 911 "translate.cpp"
                var $arrayidx61=(($dictionary_flags)&4294967295); //@line 912 "translate.cpp"
                var $43=HEAP32[(($arrayidx61)>>2)]; //@line 912 "translate.cpp"
                var $and62=($43) & 127; //@line 912 "translate.cpp"
                $stress_bits=$and62; //@line 912 "translate.cpp"
                var $44=$tr_addr; //@line 913 "translate.cpp"
                var $arraydecay63=(($phonemes)&4294967295); //@line 913 "translate.cpp"
                var $arraydecay64=(($dictionary_flags2)&4294967295); //@line 913 "translate.cpp"
                var $45=$wtab_addr; //@line 913 "translate.cpp"
                var $call65=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($44, $word1, $arraydecay63, $arraydecay64, 0, $45); //@line 913 "translate.cpp"
                $found=$call65; //@line 913 "translate.cpp"
                var $arrayidx66=(($dictionary_flags2)&4294967295); //@line 914 "translate.cpp"
                var $46=HEAP32[(($arrayidx66)>>2)]; //@line 914 "translate.cpp"
                var $cmp67=((($46))|0)!=0; //@line 914 "translate.cpp"
                if (!($cmp67)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 914 "translate.cpp"
  
                var $arrayidx69=(($dictionary_flags2)&4294967295); //@line 916 "translate.cpp"
                var $47=HEAP32[(($arrayidx69)>>2)]; //@line 916 "translate.cpp"
                var $arrayidx70=(($dictionary_flags)&4294967295); //@line 916 "translate.cpp"
                HEAP32[(($arrayidx70)>>2)]=$47; //@line 916 "translate.cpp"
                var $arrayidx71=(($dictionary_flags2+4)&4294967295); //@line 917 "translate.cpp"
                var $48=HEAP32[(($arrayidx71)>>2)]; //@line 917 "translate.cpp"
                var $arrayidx72=(($dictionary_flags+4)&4294967295); //@line 917 "translate.cpp"
                HEAP32[(($arrayidx72)>>2)]=$48; //@line 917 "translate.cpp"
                var $49=$stress_bits; //@line 918 "translate.cpp"
                var $cmp73=((($49))|0)!=0; //@line 918 "translate.cpp"
                if (!($cmp73)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 918 "translate.cpp"
  
                var $arrayidx75=(($dictionary_flags)&4294967295); //@line 921 "translate.cpp"
                var $50=HEAP32[(($arrayidx75)>>2)]; //@line 921 "translate.cpp"
                var $and76=($50) & -128; //@line 921 "translate.cpp"
                var $51=$stress_bits; //@line 921 "translate.cpp"
                var $or=($and76) | ($51); //@line 921 "translate.cpp"
                var $arrayidx77=(($dictionary_flags)&4294967295); //@line 921 "translate.cpp"
                HEAP32[(($arrayidx77)>>2)]=$or; //@line 921 "translate.cpp"
                ; //@line 922 "translate.cpp"
              }
              else if (__label__ == 27) {
  
                var $52=$found; //@line 926 "translate.cpp"
                var $cmp81=((($52))|0)==0; //@line 926 "translate.cpp"
                if (!($cmp81)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 926 "translate.cpp"
  
                var $arrayidx83=(($dictionary_flags)&4294967295); //@line 926 "translate.cpp"
                var $53=HEAP32[(($arrayidx83)>>2)]; //@line 926 "translate.cpp"
                var $and84=($53) & 128; //@line 926 "translate.cpp"
                var $tobool85=((($and84))|0)!=0; //@line 926 "translate.cpp"
                if (!($tobool85)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 926 "translate.cpp"
  
                var $54=HEAP32[(($word1)>>2)]; //@line 929 "translate.cpp"
                HEAP32[(($wordx)>>2)]=$54; //@line 929 "translate.cpp"
                $ix=0; //@line 930 "translate.cpp"
                var $55=$ix; //@line 931 "translate.cpp"
                var $56=HEAP32[((_dictionary_skipwords)>>2)]; //@line 931 "translate.cpp"
                var $cmp8815=((($55))|0) < ((($56))|0); //@line 931 "translate.cpp"
                if (!($cmp8815)) { __label__ = 33;break $if_then58$$if_else80$35; } //@line 931 "translate.cpp"
                while(1) { 
  
                  var $57=HEAP32[(($wordx)>>2)]; //@line 933 "translate.cpp"
                  var $58=HEAP8[($57)]; //@line 933 "translate.cpp"
                  var $conv90=(tempInt=(($58)),(tempInt>=128?tempInt-256:tempInt)); //@line 933 "translate.cpp"
                  var $cmp91=((($conv90))|0)==32; //@line 933 "translate.cpp"
                  if ($cmp91) { __label__ = 31;; } else { __label__ = 32;; } //@line 933 "translate.cpp"
                  if (__label__ == 31) {
  
                    var $59=HEAP32[(($wordx)>>2)]; //@line 935 "translate.cpp"
                    HEAP8[($59)]=45; //@line 935 "translate.cpp"
                    var $60=$ix; //@line 936 "translate.cpp"
                    var $inc93=((($60)+1)&4294967295); //@line 936 "translate.cpp"
                    $ix=$inc93; //@line 936 "translate.cpp"
                    ; //@line 937 "translate.cpp"
                  }
  
                  var $61=HEAP32[(($wordx)>>2)]; //@line 938 "translate.cpp"
                  var $incdec_ptr95=(($61+1)&4294967295); //@line 938 "translate.cpp"
                  HEAP32[(($wordx)>>2)]=$incdec_ptr95; //@line 938 "translate.cpp"
                  var $62=$ix; //@line 931 "translate.cpp"
                  var $63=HEAP32[((_dictionary_skipwords)>>2)]; //@line 931 "translate.cpp"
                  var $cmp88=((($62))|0) < ((($63))|0); //@line 931 "translate.cpp"
                  if ($cmp88) { __label__ = 30;continue ; } else { __label__ = 33;break $if_then58$$if_else80$35; } //@line 931 "translate.cpp"
                }
              }
            } while(0);
  
            var $64=$word_length; //@line 942 "translate.cpp"
            var $cmp99=((($64))|0)==1; //@line 942 "translate.cpp"
            var $65=HEAP32[((_dictionary_skipwords)>>2)]; //@line 942 "translate.cpp"
            var $cmp101=((($65))|0)==0; //@line 942 "translate.cpp"
            var $or_cond=($cmp99) & ($cmp101); //@line 942 "translate.cpp"
            if ($or_cond) { __label__ = 34;; } else { __label__ = 37;; } //@line 942 "translate.cpp"
            $if_then102$$if_end113$48: do { 
              if (__label__ == 34) {
  
                var $66=HEAP32[(($word1)>>2)]; //@line 945 "translate.cpp"
                var $67=$wtab_addr; //@line 945 "translate.cpp"
                var $call103=__ZL17CheckDottedAbbrevPcP8WORD_TAB($66, $67); //@line 945 "translate.cpp"
                var $tobool104=((($call103))|0)!=0; //@line 945 "translate.cpp"
                if (!($tobool104)) { __label__ = 37;break $if_then102$$if_end113$48; } //@line 945 "translate.cpp"
  
                var $arrayidx106=(($dictionary_flags)&4294967295); //@line 947 "translate.cpp"
                HEAP32[(($arrayidx106)>>2)]=0; //@line 947 "translate.cpp"
                var $arrayidx107=(($dictionary_flags+4)&4294967295); //@line 948 "translate.cpp"
                HEAP32[(($arrayidx107)>>2)]=0; //@line 948 "translate.cpp"
                $spell_word=1; //@line 949 "translate.cpp"
                var $68=HEAP32[((_dictionary_skipwords)>>2)]; //@line 950 "translate.cpp"
                var $tobool108=((($68))|0)!=0; //@line 950 "translate.cpp"
                if (!($tobool108)) { __label__ = 37;break $if_then102$$if_end113$48; } //@line 950 "translate.cpp"
  
                var $arrayidx110=(($dictionary_flags)&4294967295); //@line 951 "translate.cpp"
                HEAP32[(($arrayidx110)>>2)]=128; //@line 951 "translate.cpp"
                ; //@line 951 "translate.cpp"
              }
            } while(0);
  
            var $arrayidx114=(($phonemes)&4294967295); //@line 958 "translate.cpp"
            var $69=HEAP8[($arrayidx114)]; //@line 958 "translate.cpp"
            var $conv115=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 958 "translate.cpp"
            var $cmp116=((($conv115))|0)==21; //@line 958 "translate.cpp"
            if ($cmp116) { __label__ = 38;; } else { __label__ = 39;; } //@line 958 "translate.cpp"
            if (__label__ == 38) {
  
              var $arraydecay118=(($phonemes)&4294967295); //@line 961 "translate.cpp"
              var $call119=_strcpy(((_word_phonemes)&4294967295), $arraydecay118); //@line 961 "translate.cpp"
              $retval=0; //@line 962 "translate.cpp"
              __label__ = 236;break $if_then12$$if_end13$5; //@line 962 "translate.cpp"
            }
            else if (__label__ == 39) {
  
              var $70=$wmark; //@line 965 "translate.cpp"
              var $cmp121=((($70))|0) > 0; //@line 965 "translate.cpp"
              var $71=$wmark; //@line 965 "translate.cpp"
              var $cmp123=((($71))|0) < 8; //@line 965 "translate.cpp"
              var $or_cond1=($cmp121) & ($cmp123); //@line 965 "translate.cpp"
              if ($or_cond1) { __label__ = 40;; } else { __label__ = 41;; } //@line 965 "translate.cpp"
              if (__label__ == 40) {
  
                var $arrayidx125=(($dictionary_flags)&4294967295); //@line 968 "translate.cpp"
                var $72=HEAP32[(($arrayidx125)>>2)]; //@line 968 "translate.cpp"
                var $and126=($72) & -16; //@line 968 "translate.cpp"
                var $73=$wmark; //@line 968 "translate.cpp"
                var $or127=($and126) | ($73); //@line 968 "translate.cpp"
                var $arrayidx128=(($dictionary_flags)&4294967295); //@line 968 "translate.cpp"
                HEAP32[(($arrayidx128)>>2)]=$or127; //@line 968 "translate.cpp"
                ; //@line 969 "translate.cpp"
              }
  
              var $74=$found; //@line 971 "translate.cpp"
              var $tobool130=((($74))|0)!=0; //@line 971 "translate.cpp"
              if ($tobool130) { __label__ = 49;; } else { __label__ = 42;; } //@line 971 "translate.cpp"
              $if_end150$$land_lhs_true131$59: do { 
                if (__label__ == 42) {
  
                  var $arrayidx132=(($dictionary_flags)&4294967295); //@line 971 "translate.cpp"
                  var $75=HEAP32[(($arrayidx132)>>2)]; //@line 971 "translate.cpp"
                  var $and133=($75) & 131072; //@line 971 "translate.cpp"
                  var $tobool134=((($and133))|0)!=0; //@line 971 "translate.cpp"
                  if ($tobool134) { __label__ = 43;; } else { __label__ = 44;; } //@line 971 "translate.cpp"
                  if (__label__ == 43) {
  
                    $spell_word=1; //@line 974 "translate.cpp"
                    ; //@line 975 "translate.cpp"
                  }
  
                  var $_pr=$found; //@line 977 "translate.cpp"
                  var $tobool137=((($_pr))|0)!=0; //@line 977 "translate.cpp"
                  if ($tobool137) { __label__ = 49;break $if_end150$$land_lhs_true131$59; } //@line 977 "translate.cpp"
  
                  var $76=HEAP32[(($first_char)>>2)]; //@line 977 "translate.cpp"
                  var $call139=_iswdigit($76); //@line 977 "translate.cpp"
                  var $tobool140=((($call139))|0)!=0; //@line 977 "translate.cpp"
                  if (!($tobool140)) { __label__ = 49;break $if_end150$$land_lhs_true131$59; } //@line 977 "translate.cpp"
  
                  var $77=$tr_addr; //@line 979 "translate.cpp"
                  var $call142=__Z6LookupP10TranslatorPKcPc($77, ((__str2545)&4294967295), ((_word_phonemes)&4294967295)); //@line 979 "translate.cpp"
                  var $78=HEAP8[(((_word_phonemes)&4294967295))]; //@line 980 "translate.cpp"
                  var $conv143=(tempInt=(($78)),(tempInt>=128?tempInt-256:tempInt)); //@line 980 "translate.cpp"
                  var $cmp144=((($conv143))|0)==21; //@line 980 "translate.cpp"
                  if ($cmp144) { __label__ = 47;; } else { __label__ = 48;; } //@line 980 "translate.cpp"
                  if (__label__ == 47) {
  
                    $retval=0; //@line 981 "translate.cpp"
                    __label__ = 236;break $if_then12$$if_end13$5; //@line 981 "translate.cpp"
                  }
                  else if (__label__ == 48) {
  
                    var $79=$tr_addr; //@line 983 "translate.cpp"
                    var $80=HEAP32[(($word1)>>2)]; //@line 983 "translate.cpp"
                    var $arraydecay147=(($phonemes)&4294967295); //@line 983 "translate.cpp"
                    var $arraydecay148=(($dictionary_flags)&4294967295); //@line 983 "translate.cpp"
                    var $81=$wtab_addr; //@line 983 "translate.cpp"
                    var $call149=__Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi($79, $80, $arraydecay147, $arraydecay148, $81, 0); //@line 983 "translate.cpp"
                    $found=$call149; //@line 983 "translate.cpp"
                    ; //@line 984 "translate.cpp"
                  }
                }
              } while(0);
  
              var $82=$found; //@line 986 "translate.cpp"
              var $tobool151=((($82))|0)!=0; //@line 986 "translate.cpp"
              var $lnot=($tobool151) ^ 1; //@line 986 "translate.cpp"
              var $conv152=((($lnot))&1); //@line 986 "translate.cpp"
              var $83=$wflags; //@line 986 "translate.cpp"
              var $and153=($83) & 3; //@line 986 "translate.cpp"
              var $cmp154=((($and153))|0)!=2; //@line 986 "translate.cpp"
              var $conv155=((($cmp154))&1); //@line 986 "translate.cpp"
              var $and156=($conv155) & ($conv152); //@line 986 "translate.cpp"
              var $tobool157=((($and156))|0)!=0; //@line 986 "translate.cpp"
              if ($tobool157) { __label__ = 50;; } else { __label__ = 57;; } //@line 986 "translate.cpp"
              $if_then158$$if_end186$70: do { 
                if (__label__ == 50) {
  
                  var $84=$tr_addr; //@line 990 "translate.cpp"
                  var $langopts=(($84)&4294967295); //@line 990 "translate.cpp"
                  var $numbers=(($langopts+184)&4294967295); //@line 990 "translate.cpp"
                  var $85=HEAP32[(($numbers)>>2)]; //@line 990 "translate.cpp"
                  var $and159=($85) & 16777216; //@line 990 "translate.cpp"
                  var $tobool160=((($and159))|0)!=0; //@line 990 "translate.cpp"
                  if ($tobool160) { __label__ = 53;; } else { __label__ = 51;; } //@line 990 "translate.cpp"
                  if (__label__ == 51) {
  
                    var $86=$tr_addr; //@line 990 "translate.cpp"
                    var $langopts161=(($86)&4294967295); //@line 990 "translate.cpp"
                    var $numbers162=(($langopts161+184)&4294967295); //@line 990 "translate.cpp"
                    var $87=HEAP32[(($numbers162)>>2)]; //@line 990 "translate.cpp"
                    var $and163=($87) & 33554432; //@line 990 "translate.cpp"
                    var $tobool164=((($and163))|0)!=0; //@line 990 "translate.cpp"
                    if (!($tobool164)) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 990 "translate.cpp"
  
                    var $88=$wflags; //@line 990 "translate.cpp"
                    var $and166=($88) & 1; //@line 990 "translate.cpp"
                    var $tobool167=((($and166))|0)!=0; //@line 990 "translate.cpp"
                    if (!($tobool167)) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 990 "translate.cpp"
                  }
  
                  var $89=$wflags; //@line 992 "translate.cpp"
                  var $and169=($89) & 16; //@line 992 "translate.cpp"
                  var $tobool170=((($and169))|0)!=0; //@line 992 "translate.cpp"
                  if ($tobool170) { __label__ = 55;; } else { __label__ = 54;; } //@line 992 "translate.cpp"
                  if (__label__ == 54) {
  
                    var $90=$wtab_addr; //@line 992 "translate.cpp"
                    var $arrayidx172=(($90+12)&4294967295); //@line 992 "translate.cpp"
                    var $flags173=(($arrayidx172)&4294967295); //@line 992 "translate.cpp"
                    var $91=HEAP32[(($flags173)>>2)]; //@line 992 "translate.cpp"
                    var $and174=($91) & 256; //@line 992 "translate.cpp"
                    var $tobool175=((($and174))|0)!=0; //@line 992 "translate.cpp"
                    if ($tobool175) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 992 "translate.cpp"
                  }
  
                  var $92=$tr_addr; //@line 995 "translate.cpp"
                  var $93=HEAP32[(($word1)>>2)]; //@line 995 "translate.cpp"
                  var $arraydecay177=(($phonemes)&4294967295); //@line 995 "translate.cpp"
                  var $94=$wtab_addr; //@line 995 "translate.cpp"
                  var $call178=__Z14TranslateRomanP10TranslatorPcS1_P8WORD_TAB($92, $93, $arraydecay177, $94); //@line 995 "translate.cpp"
                  $found=$call178; //@line 995 "translate.cpp"
                  var $cmp179=((($call178))|0)!=0; //@line 995 "translate.cpp"
                  if (!($cmp179)) { __label__ = 57;break $if_then158$$if_end186$70; } //@line 995 "translate.cpp"
  
                  var $arrayidx181=(($dictionary_flags)&4294967295); //@line 996 "translate.cpp"
                  var $95=HEAP32[(($arrayidx181)>>2)]; //@line 996 "translate.cpp"
                  var $or182=($95) | 131072; //@line 996 "translate.cpp"
                  HEAP32[(($arrayidx181)>>2)]=$or182; //@line 996 "translate.cpp"
                  ; //@line 996 "translate.cpp"
                }
              } while(0);
  
              var $96=$wflags; //@line 1001 "translate.cpp"
              var $and187=($96) & 1; //@line 1001 "translate.cpp"
              var $tobool188=((($and187))|0)!=0; //@line 1001 "translate.cpp"
              if ($tobool188) { __label__ = 58;; } else { __label__ = 69;; } //@line 1001 "translate.cpp"
              $land_lhs_true189$$if_end219thread_pre_split$81: do { 
                if (__label__ == 58) {
  
                  var $97=$word_length; //@line 1001 "translate.cpp"
                  var $cmp190=((($97))|0) > 1; //@line 1001 "translate.cpp"
                  if (!($cmp190)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1001 "translate.cpp"
  
                  var $98=HEAP32[(($first_char)>>2)]; //@line 1001 "translate.cpp"
                  var $call192=_iswalpha($98); //@line 1001 "translate.cpp"
                  var $tobool193=((($call192))|0)!=0; //@line 1001 "translate.cpp"
                  if (!($tobool193)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1001 "translate.cpp"
  
                  var $99=HEAP32[((_option_tone_flags)>>2)]; //@line 1003 "translate.cpp"
                  var $and195=($99) & 256; //@line 1003 "translate.cpp"
                  var $tobool196=((($and195))|0)!=0; //@line 1003 "translate.cpp"
                  if ($tobool196) { __label__ = 61;; } else { __label__ = 63;; } //@line 1003 "translate.cpp"
                  $land_lhs_true197$$if_else202$85: do { 
                    if (__label__ == 61) {
  
                      var $arrayidx198=(($dictionary_flags)&4294967295); //@line 1003 "translate.cpp"
                      var $100=HEAP32[(($arrayidx198)>>2)]; //@line 1003 "translate.cpp"
                      var $and199=($100) & 131072; //@line 1003 "translate.cpp"
                      var $tobool200=((($and199))|0)!=0; //@line 1003 "translate.cpp"
                      if ($tobool200) { __label__ = 63;break $land_lhs_true197$$if_else202$85; } //@line 1003 "translate.cpp"
  
                      $emphasize_allcaps=2048; //@line 1006 "translate.cpp"
                      __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; //@line 1007 "translate.cpp"
                    }
                  } while(0);
  
                  var $101=$found; //@line 1009 "translate.cpp"
                  var $tobool203=((($101))|0)!=0; //@line 1009 "translate.cpp"
                  if ($tobool203) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $arrayidx205=(($dictionary_flags)&4294967295); //@line 1009 "translate.cpp"
                  var $102=HEAP32[(($arrayidx205)>>2)]; //@line 1009 "translate.cpp"
                  var $and206=($102) & 128; //@line 1009 "translate.cpp"
                  var $tobool207=((($and206))|0)!=0; //@line 1009 "translate.cpp"
                  if ($tobool207) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $103=$word_length; //@line 1009 "translate.cpp"
                  var $cmp209=((($103))|0) < 4; //@line 1009 "translate.cpp"
                  if (!($cmp209)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $104=$tr_addr; //@line 1009 "translate.cpp"
                  var $clause_lower_count=(($104+8308)&4294967295); //@line 1009 "translate.cpp"
                  var $105=HEAP32[(($clause_lower_count)>>2)]; //@line 1009 "translate.cpp"
                  var $cmp211=((($105))|0) > 3; //@line 1009 "translate.cpp"
                  if (!($cmp211)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  var $106=$tr_addr; //@line 1009 "translate.cpp"
                  var $clause_upper_count=(($106+8304)&4294967295); //@line 1009 "translate.cpp"
                  var $107=HEAP32[(($clause_upper_count)>>2)]; //@line 1009 "translate.cpp"
                  var $108=$tr_addr; //@line 1009 "translate.cpp"
                  var $clause_lower_count213=(($108+8308)&4294967295); //@line 1009 "translate.cpp"
                  var $109=HEAP32[(($clause_lower_count213)>>2)]; //@line 1009 "translate.cpp"
                  var $cmp214=((($107))|0) <= ((($109))|0); //@line 1009 "translate.cpp"
                  if (!($cmp214)) { __label__ = 69;break $land_lhs_true189$$if_end219thread_pre_split$81; } //@line 1009 "translate.cpp"
  
                  $spell_word=1; //@line 1013 "translate.cpp"
                  __label__ = 71;break $if_then37$$if_else39$25; //@line 1018 "translate.cpp"
                }
              } while(0);
  
              var $_pr5=$spell_word; //@line 1018 "translate.cpp"
              __lastLabel__ = 69; __label__ = 70;break $if_then37$$if_else39$25;
            }
          }
        } while(0);
        $if_end219$$if_then221$95: do { 
          if (__label__ == 70) {
  
            var $110=__lastLabel__ == 69 ? $_pr5 : ($and38); //@line 1018 "translate.cpp"
            var $cmp220=((($110))|0) > 0; //@line 1018 "translate.cpp"
            if ($cmp220) { __label__ = 71;break $if_end219$$if_then221$95; } //@line 1018 "translate.cpp"
  
            var $115=$found; //@line 1032 "translate.cpp"
            var $cmp232=((($115))|0)==0; //@line 1032 "translate.cpp"
            if (!($cmp232)) { __label__ = 166;break $if_end219$$if_then221$95; } //@line 1032 "translate.cpp"
  
            $posn=0; //@line 1040 "translate.cpp"
            $non_initial=0; //@line 1041 "translate.cpp"
            $length=999; //@line 1042 "translate.cpp"
            var $116=HEAP32[(($word1)>>2)]; //@line 1043 "translate.cpp"
            HEAP32[(($wordx)>>2)]=$116; //@line 1043 "translate.cpp"
            var $arraydecay252=(($unpron_phonemes)&4294967295); //@line 1058 "translate.cpp"
            var $arrayidx256=(($unpron_phonemes)&4294967295); //@line 1060 "translate.cpp"
            ; //@line 1045 "translate.cpp"
            $while_cond234$99: while(1) { 
  
              var $117=$length; //@line 1045 "translate.cpp"
              var $cmp235=((($117))|0) < 3; //@line 1045 "translate.cpp"
              var $118=$length; //@line 1045 "translate.cpp"
              var $cmp237=((($118))|0) > 0; //@line 1045 "translate.cpp"
              var $or_cond2=($cmp235) & ($cmp237); //@line 1045 "translate.cpp"
              if ($or_cond2) { __label__ = 80;; } else { __label__ = 78;; } //@line 1045 "translate.cpp"
              if (__label__ == 78) {
  
                var $119=$word_length; //@line 1045 "translate.cpp"
                var $cmp238=((($119))|0) > 1; //@line 1045 "translate.cpp"
                if (!($cmp238)) { __label__ = 89;break $while_cond234$99; } //@line 1045 "translate.cpp"
  
                var $120=$tr_addr; //@line 1045 "translate.cpp"
                var $121=HEAP32[(($wordx)>>2)]; //@line 1045 "translate.cpp"
                var $122=$posn; //@line 1045 "translate.cpp"
                var $call240=__Z14UnpronouncableP10TranslatorPci($120, $121, $122); //@line 1045 "translate.cpp"
                var $tobool241=((($call240))|0)!=0; //@line 1045 "translate.cpp"
                if (!($tobool241)) { __label__ = 89;break $while_cond234$99; }
              }
  
              $was_unpronouncable=67108864; //@line 1049 "translate.cpp"
              $emphasize_allcaps=0; //@line 1050 "translate.cpp"
              var $123=HEAP32[(($wordx)>>2)]; //@line 1052 "translate.cpp"
              var $arrayidx244=(($123)&4294967295); //@line 1052 "translate.cpp"
              var $124=HEAP8[($arrayidx244)]; //@line 1052 "translate.cpp"
              var $conv245=(tempInt=(($124)),(tempInt>=128?tempInt-256:tempInt)); //@line 1052 "translate.cpp"
              var $cmp246=((($conv245))|0)==39; //@line 1052 "translate.cpp"
              if ($cmp246) { __label__ = 89;break $while_cond234$99; } //@line 1052 "translate.cpp"
  
              var $125=$posn; //@line 1055 "translate.cpp"
              var $cmp249=((($125))|0) > 0; //@line 1055 "translate.cpp"
              if ($cmp249) { __label__ = 82;; } else { __label__ = 83;; } //@line 1055 "translate.cpp"
              if (__label__ == 82) {
  
                $non_initial=1; //@line 1056 "translate.cpp"
                ; //@line 1056 "translate.cpp"
              }
  
              var $126=$tr_addr; //@line 1058 "translate.cpp"
              var $127=HEAP32[(($wordx)>>2)]; //@line 1058 "translate.cpp"
              var $128=$non_initial; //@line 1058 "translate.cpp"
              var $call253=__Z15TranslateLetterP10TranslatorPcS1_i($126, $127, $arraydecay252, $128); //@line 1058 "translate.cpp"
              var $129=HEAP32[(($wordx)>>2)]; //@line 1058 "translate.cpp"
              var $add_ptr254=(($129+$call253)&4294967295); //@line 1058 "translate.cpp"
              HEAP32[(($wordx)>>2)]=$add_ptr254; //@line 1058 "translate.cpp"
              var $130=$posn; //@line 1059 "translate.cpp"
              var $inc255=((($130)+1)&4294967295); //@line 1059 "translate.cpp"
              $posn=$inc255; //@line 1059 "translate.cpp"
              var $131=HEAP8[($arrayidx256)]; //@line 1060 "translate.cpp"
              var $conv257=(tempInt=(($131)),(tempInt>=128?tempInt-256:tempInt)); //@line 1060 "translate.cpp"
              var $cmp258=((($conv257))|0)==21; //@line 1060 "translate.cpp"
              if ($cmp258) { __label__ = 84;break $while_cond234$99; } //@line 1060 "translate.cpp"
  
              $length=0; //@line 1080 "translate.cpp"
              var $132=$length; //@line 1081 "translate.cpp"
              var $133=HEAP32[(($wordx)>>2)]; //@line 1081 "translate.cpp"
              var $arrayidx26921=(($133+$132)&4294967295); //@line 1081 "translate.cpp"
              var $134=HEAP8[($arrayidx26921)]; //@line 1081 "translate.cpp"
              var $conv27022=(tempInt=(($134)),(tempInt>=128?tempInt-256:tempInt)); //@line 1081 "translate.cpp"
              var $cmp27123=((($conv27022))|0)!=32; //@line 1081 "translate.cpp"
              if (!($cmp27123)) { __label__ = 77;continue $while_cond234$99; } //@line 1081 "translate.cpp"
              while(1) { 
  
                var $135=$length; //@line 1081 "translate.cpp"
                var $inc273=((($135)+1)&4294967295); //@line 1081 "translate.cpp"
                $length=$inc273; //@line 1081 "translate.cpp"
                var $136=$length; //@line 1081 "translate.cpp"
                var $137=HEAP32[(($wordx)>>2)]; //@line 1081 "translate.cpp"
                var $arrayidx269=(($137+$136)&4294967295); //@line 1081 "translate.cpp"
                var $138=HEAP8[($arrayidx269)]; //@line 1081 "translate.cpp"
                var $conv270=(tempInt=(($138)),(tempInt>=128?tempInt-256:tempInt)); //@line 1081 "translate.cpp"
                var $cmp271=((($conv270))|0)!=32; //@line 1081 "translate.cpp"
                if ($cmp271) { __label__ = 88;continue ; } else { __label__ = 77;continue $while_cond234$99; } //@line 1081 "translate.cpp"
              }
            }
            if (__label__ == 89) {
  
              var $139=$tr_addr; //@line 1083 "translate.cpp"
              var $arraydecay276=(($unpron_phonemes)&4294967295); //@line 1083 "translate.cpp"
              var $140=$posn; //@line 1083 "translate.cpp"
              __Z17SetSpellingStressP10TranslatorPcii($139, $arraydecay276, 0, $140); //@line 1083 "translate.cpp"
              var $141=HEAP32[(($wordx)>>2)]; //@line 1086 "translate.cpp"
              var $142=HEAP8[($141)]; //@line 1086 "translate.cpp"
              var $conv277=(tempInt=(($142)),(tempInt>=128?tempInt-256:tempInt)); //@line 1086 "translate.cpp"
              var $cmp278=((($conv277))|0)!=32; //@line 1086 "translate.cpp"
              if (!($cmp278)) { __label__ = 166;break $if_end219$$if_then221$95; } //@line 1086 "translate.cpp"
  
              var $arrayidx280=(($unpron_phonemes)&4294967295); //@line 1088 "translate.cpp"
              var $143=HEAP8[($arrayidx280)]; //@line 1088 "translate.cpp"
              var $conv281=(tempInt=(($143)),(tempInt>=128?tempInt-256:tempInt)); //@line 1088 "translate.cpp"
              var $cmp282=((($conv281))|0)!=0; //@line 1088 "translate.cpp"
              if ($cmp282) { __label__ = 91;; } else { __label__ = 93;; } //@line 1088 "translate.cpp"
              $land_lhs_true283$$if_end289$115: do { 
                if (__label__ == 91) {
  
                  var $144=HEAP32[(($wordx)>>2)]; //@line 1088 "translate.cpp"
                  var $arrayidx284=(($144)&4294967295); //@line 1088 "translate.cpp"
                  var $145=HEAP8[($arrayidx284)]; //@line 1088 "translate.cpp"
                  var $conv285=(tempInt=(($145)),(tempInt>=128?tempInt-256:tempInt)); //@line 1088 "translate.cpp"
                  var $cmp286=((($conv285))|0)!=39; //@line 1088 "translate.cpp"
                  if (!($cmp286)) { __label__ = 93;break $land_lhs_true283$$if_end289$115; } //@line 1088 "translate.cpp"
  
                  var $146=HEAP32[(($wordx)>>2)]; //@line 1091 "translate.cpp"
                  var $arrayidx288=(($146+-1)&4294967295); //@line 1091 "translate.cpp"
                  HEAP8[($arrayidx288)]=32; //@line 1091 "translate.cpp"
                  ; //@line 1092 "translate.cpp"
                }
              } while(0);
  
              var $147=$tr_addr; //@line 1095 "translate.cpp"
              var $148=HEAP32[(($wordx)>>2)]; //@line 1095 "translate.cpp"
              var $arraydecay290=(($phonemes)&4294967295); //@line 1095 "translate.cpp"
              var $arraydecay291=(($end_phonemes)&4294967295); //@line 1095 "translate.cpp"
              var $149=$wflags; //@line 1095 "translate.cpp"
              var $arraydecay292=(($dictionary_flags)&4294967295); //@line 1095 "translate.cpp"
              var $call293=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($147, $148, $arraydecay290, 160, $arraydecay291, $149, $arraydecay292); //@line 1095 "translate.cpp"
              $end_type=$call293; //@line 1095 "translate.cpp"
              var $arrayidx294=(($phonemes)&4294967295); //@line 1097 "translate.cpp"
              var $150=HEAP8[($arrayidx294)]; //@line 1097 "translate.cpp"
              var $conv295=(tempInt=(($150)),(tempInt>=128?tempInt-256:tempInt)); //@line 1097 "translate.cpp"
              var $cmp296=((($conv295))|0)==21; //@line 1097 "translate.cpp"
              var $arraydecay298=(($phonemes)&4294967295); //@line 1100 "translate.cpp"
              if ($cmp296) { __label__ = 94;; } else { __label__ = 95;; } //@line 1097 "translate.cpp"
              if (__label__ == 94) {
  
                var $call299=_strcpy(((_word_phonemes)&4294967295), $arraydecay298); //@line 1100 "translate.cpp"
                $retval=0; //@line 1101 "translate.cpp"
                __label__ = 236;break $if_then12$$if_end13$5; //@line 1101 "translate.cpp"
              }
              else if (__label__ == 95) {
  
                var $151=HEAP8[($arraydecay298)]; //@line 1104 "translate.cpp"
                var $conv302=(tempInt=(($151)),(tempInt>=128?tempInt-256:tempInt)); //@line 1104 "translate.cpp"
                var $cmp303=((($conv302))|0)==0; //@line 1104 "translate.cpp"
                if ($cmp303) { __label__ = 96;; } else { __label__ = 101;; } //@line 1104 "translate.cpp"
                $land_lhs_true304$$if_end321$122: do { 
                  if (__label__ == 96) {
  
                    var $arrayidx305=(($end_phonemes)&4294967295); //@line 1104 "translate.cpp"
                    var $152=HEAP8[($arrayidx305)]; //@line 1104 "translate.cpp"
                    var $conv306=(tempInt=(($152)),(tempInt>=128?tempInt-256:tempInt)); //@line 1104 "translate.cpp"
                    var $cmp307=((($conv306))|0)==0; //@line 1104 "translate.cpp"
                    if (!($cmp307)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1104 "translate.cpp"
  
                    var $153=HEAP32[(($wordx)>>2)]; //@line 1109 "translate.cpp"
                    var $call309=__Z7utf8_inPiPKc($wc, $153); //@line 1109 "translate.cpp"
                    var $154=$word_length; //@line 1110 "translate.cpp"
                    var $cmp310=((($154))|0)==1; //@line 1110 "translate.cpp"
                    if (!($cmp310)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1110 "translate.cpp"
  
                    var $155=HEAP32[(($wc)>>2)]; //@line 1110 "translate.cpp"
                    var $call312=__Z7IsAlphaj($155); //@line 1110 "translate.cpp"
                    var $tobool313=((($call312))|0)!=0; //@line 1110 "translate.cpp"
                    if (!($tobool313)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1110 "translate.cpp"
  
                    var $156=$tr_addr; //@line 1112 "translate.cpp"
                    var $157=HEAP32[(($wordx)>>2)]; //@line 1112 "translate.cpp"
                    var $arraydecay315=(($phonemes)&4294967295); //@line 1112 "translate.cpp"
                    var $158=$spell_word; //@line 1112 "translate.cpp"
                    var $call316=__ZL22SpeakIndividualLettersP10TranslatorPcS1_i($156, $157, $arraydecay315, $158); //@line 1112 "translate.cpp"
                    HEAP32[(($wordx)>>2)]=$call316; //@line 1112 "translate.cpp"
                    var $cmp317=((($call316))|0)==0; //@line 1112 "translate.cpp"
                    if (!($cmp317)) { __label__ = 101;break $land_lhs_true304$$if_end321$122; } //@line 1112 "translate.cpp"
  
                    $retval=0; //@line 1114 "translate.cpp"
                    __label__ = 236;break $if_then12$$if_end13$5; //@line 1114 "translate.cpp"
                  }
                } while(0);
  
                var $159=HEAP32[(($wordx)>>2)]; //@line 1119 "translate.cpp"
                var $arrayidx322=(($159+-1)&4294967295); //@line 1119 "translate.cpp"
                var $160=HEAP8[($arrayidx322)]; //@line 1119 "translate.cpp"
                $c_temp=$160; //@line 1119 "translate.cpp"
                $found=0; //@line 1121 "translate.cpp"
                $confirm_prefix=1; //@line 1122 "translate.cpp"
                $loopcount=0; //@line 1123 "translate.cpp"
                var $arrayidx333=(($phonemes2)&4294967295); //@line 1134 "translate.cpp"
                var $arraydecay334=(($phonemes2)&4294967295); //@line 1135 "translate.cpp"
                var $arraydecay335=(($end_phonemes2)&4294967295); //@line 1135 "translate.cpp"
                var $arraydecay338=(($dictionary_flags)&4294967295); //@line 1135 "translate.cpp"
                var $arraydecay342=(($word_copy)&4294967295); //@line 1138 "translate.cpp"
                var $arraydecay344=(($phonemes)&4294967295); //@line 1139 "translate.cpp"
                var $arraydecay345=(($end_phonemes)&4294967295); //@line 1139 "translate.cpp"
                var $arraydecay347=(($dictionary_flags)&4294967295); //@line 1139 "translate.cpp"
                var $arraydecay349=(($word_copy)&4294967295); //@line 1140 "translate.cpp"
                var $arraydecay350=(($word_copy)&4294967295); //@line 1140 "translate.cpp"
                var $arraydecay355=(($phonemes)&4294967295); //@line 1146 "translate.cpp"
                var $arraydecay356=(($phonemes2)&4294967295); //@line 1146 "translate.cpp"
                var $arraydecay358=(($end_phonemes)&4294967295); //@line 1147 "translate.cpp"
                var $arraydecay359=(($end_phonemes2)&4294967295); //@line 1147 "translate.cpp"
                var $arraydecay363=(($end_phonemes)&4294967295); //@line 1150 "translate.cpp"
                var $arraydecay364=(($end_phonemes2)&4294967295); //@line 1150 "translate.cpp"
                var $arraydecay365=(($end_phonemes2)&4294967295); //@line 1151 "translate.cpp"
                var $arraydecay418=(($prefix_phonemes2)&4294967295); //@line 1204 "translate.cpp"
                var $arraydecay419=(($end_phonemes)&4294967295); //@line 1204 "translate.cpp"
                var $arrayidx420=(($prefix_chars+1)&4294967295); //@line 1205 "translate.cpp"
                var $arraydecay421=(($prefix_phonemes)&4294967295); //@line 1206 "translate.cpp"
                var $arraydecay422=(($phonemes)&4294967295); //@line 1206 "translate.cpp"
                var $arraydecay424=(($phonemes)&4294967295); //@line 1209 "translate.cpp"
                var $arraydecay425=(($dictionary_flags)&4294967295); //@line 1209 "translate.cpp"
                var $arraydecay429=(($prefix_phonemes)&4294967295); //@line 1212 "translate.cpp"
                var $arraydecay430=(($phonemes)&4294967295); //@line 1212 "translate.cpp"
                var $arrayidx433=(($dictionary_flags)&4294967295); //@line 1214 "translate.cpp"
                var $arrayidx437=(($prefix_phonemes)&4294967295); //@line 1216 "translate.cpp"
                var $arraydecay438=(($prefix_phonemes)&4294967295); //@line 1217 "translate.cpp"
                var $arrayidx446=(($end_phonemes)&4294967295); //@line 1224 "translate.cpp"
                var $arraydecay447=(($phonemes)&4294967295); //@line 1227 "translate.cpp"
                var $arraydecay448=(($dictionary_flags2)&4294967295); //@line 1227 "translate.cpp"
                var $arrayidx450=(($dictionary_flags)&4294967295); //@line 1228 "translate.cpp"
                var $arrayidx453=(($dictionary_flags2)&4294967295); //@line 1230 "translate.cpp"
                var $arrayidx454=(($dictionary_flags)&4294967295); //@line 1230 "translate.cpp"
                var $arrayidx455=(($dictionary_flags2+4)&4294967295); //@line 1231 "translate.cpp"
                var $arrayidx456=(($dictionary_flags+4)&4294967295); //@line 1231 "translate.cpp"
                var $arraydecay461=(($phonemes)&4294967295); //@line 1237 "translate.cpp"
                var $arraydecay462=(($end_phonemes)&4294967295); //@line 1237 "translate.cpp"
                var $arraydecay463=(($dictionary_flags)&4294967295); //@line 1237 "translate.cpp"
                var $arrayidx465=(($phonemes)&4294967295); //@line 1239 "translate.cpp"
                var $arraydecay442=(($prefix_phonemes)&4294967295); //@line 1222 "translate.cpp"
                var $arraydecay443=(($end_phonemes)&4294967295); //@line 1222 "translate.cpp"
                var $arrayidx392=(($prefix_chars)&4294967295); //@line 1179 "translate.cpp"
                __lastLabel__ = 101; ; //@line 1123 "translate.cpp"
                $for_cond$129: while(1) { 
  
                  var $161=__lastLabel__ == 136 ? $inc475 : (0); //@line 1123 "translate.cpp"
                  var $cmp323=((($161))|0) < 50; //@line 1123 "translate.cpp"
                  var $162=$end_type; //@line 1123 "translate.cpp"
                  if (!($cmp323)) { __label__ = 137;break $for_cond$129; } //@line 1123 "translate.cpp"
  
                  var $and325=($162) & 1024; //@line 1123 "translate.cpp"
                  var $tobool326=((($and325))|0)!=0; //@line 1123 "translate.cpp"
                  if (!($tobool326)) { __label__ = 137;break $for_cond$129; }
  
                  var $163=$confirm_prefix; //@line 1127 "translate.cpp"
                  var $tobool328=((($163))|0)!=0; //@line 1127 "translate.cpp"
                  if ($tobool328) { __label__ = 105;; } else { __label__ = 111;; } //@line 1127 "translate.cpp"
                  $land_lhs_true329$$if_end370$133: do { 
                    if (__label__ == 105) {
  
                      var $164=$end_type; //@line 1127 "translate.cpp"
                      var $and330=($164) & 131072; //@line 1127 "translate.cpp"
                      var $tobool331=((($and330))|0)!=0; //@line 1127 "translate.cpp"
                      if ($tobool331) { __label__ = 111;break $land_lhs_true329$$if_end370$133; } //@line 1127 "translate.cpp"
  
                      HEAP8[($arrayidx333)]=0; //@line 1134 "translate.cpp"
                      var $165=$tr_addr; //@line 1135 "translate.cpp"
                      var $166=HEAP32[(($wordx)>>2)]; //@line 1135 "translate.cpp"
                      var $167=$wflags; //@line 1135 "translate.cpp"
                      var $or337=($167) | 805306368; //@line 1135 "translate.cpp"
                      var $call339=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($165, $166, $arraydecay334, 160, $arraydecay335, $or337, $arraydecay338); //@line 1135 "translate.cpp"
                      $end2=$call339; //@line 1135 "translate.cpp"
                      var $168=$end2; //@line 1136 "translate.cpp"
                      var $tobool340=((($168))|0)!=0; //@line 1136 "translate.cpp"
                      if (!($tobool340)) { __label__ = 111;break $land_lhs_true329$$if_end370$133; } //@line 1136 "translate.cpp"
  
                      var $169=$tr_addr; //@line 1138 "translate.cpp"
                      var $170=HEAP32[(($wordx)>>2)]; //@line 1138 "translate.cpp"
                      var $171=$end2; //@line 1138 "translate.cpp"
                      var $call343=__Z12RemoveEndingP10TranslatorPciS1_($169, $170, $171, $arraydecay342); //@line 1138 "translate.cpp"
                      var $172=$tr_addr; //@line 1139 "translate.cpp"
                      var $173=HEAP32[(($wordx)>>2)]; //@line 1139 "translate.cpp"
                      var $174=$wflags; //@line 1139 "translate.cpp"
                      var $or346=($174) | 268435456; //@line 1139 "translate.cpp"
                      var $call348=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($172, $173, $arraydecay344, 160, $arraydecay345, $or346, $arraydecay347); //@line 1139 "translate.cpp"
                      $end_type=$call348; //@line 1139 "translate.cpp"
                      var $175=HEAP32[(($wordx)>>2)]; //@line 1140 "translate.cpp"
                      var $call351=_strlen($arraydecay350); //@line 1140 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $arraydecay349;
                      $dest$ = $175;
                      $stop$ = $src$ + $call351;
                      if (($dest$%4) == ($src$%4) && $call351 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 1140 "translate.cpp"
                      var $176=$end_type; //@line 1141 "translate.cpp"
                      var $and352=($176) & 1024; //@line 1141 "translate.cpp"
                      var $cmp353=((($and352))|0)==0; //@line 1141 "translate.cpp"
                      if ($cmp353) { __label__ = 108;; } else { __label__ = 110;; } //@line 1141 "translate.cpp"
                      $if_then354$$if_end368$137: do { 
                        if (__label__ == 108) {
  
                          var $177=$end2; //@line 1145 "translate.cpp"
                          $end_type=$177; //@line 1145 "translate.cpp"
                          var $call357=_strcpy($arraydecay355, $arraydecay356); //@line 1146 "translate.cpp"
                          var $call360=_strcpy($arraydecay358, $arraydecay359); //@line 1147 "translate.cpp"
                          var $178=HEAP32[((_option_phonemes)>>2)]; //@line 1148 "translate.cpp"
                          var $cmp361=((($178))|0)==2; //@line 1148 "translate.cpp"
                          if (!($cmp361)) { __label__ = 110;break $if_then354$$if_end368$137; } //@line 1148 "translate.cpp"
  
                          __Z14DecodePhonemesPKcPc($arraydecay363, $arraydecay364); //@line 1150 "translate.cpp"
                          var $179=HEAP32[((_f_trans)>>2)]; //@line 1151 "translate.cpp"
                          var $call366=_fprintf($179, ((__str4547)&4294967295), allocate([$arraydecay365,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 1151 "translate.cpp"
                          ; //@line 1152 "translate.cpp"
                        }
                      } while(0);
  
                      $confirm_prefix=0; //@line 1154 "translate.cpp"
                      __label__ = 136;break $land_lhs_true329$$if_end370$133; //@line 1155 "translate.cpp"
                    }
                  } while(0);
                  $if_end370$$for_inc474$141: do { 
                    if (__label__ == 111) {
  
                      var $180=$end_type; //@line 1159 "translate.cpp"
                      $prefix_type=$180; //@line 1159 "translate.cpp"
                      var $181=$prefix_type; //@line 1161 "translate.cpp"
                      var $and371=($181) & 2048; //@line 1161 "translate.cpp"
                      var $tobool372=((($and371))|0)!=0; //@line 1161 "translate.cpp"
                      if ($tobool372) { __label__ = 112;; } else { __label__ = 113;; } //@line 1161 "translate.cpp"
                      if (__label__ == 112) {
  
                        var $182=$tr_addr; //@line 1163 "translate.cpp"
                        var $expect_verb=(($182+8272)&4294967295); //@line 1163 "translate.cpp"
                        HEAP32[(($expect_verb)>>2)]=1; //@line 1163 "translate.cpp"
                        ; //@line 1164 "translate.cpp"
                      }
  
                      var $183=$c_temp; //@line 1166 "translate.cpp"
                      var $184=HEAP32[(($wordx)>>2)]; //@line 1166 "translate.cpp"
                      var $arrayidx375=(($184+-1)&4294967295); //@line 1166 "translate.cpp"
                      HEAP8[($arrayidx375)]=$183; //@line 1166 "translate.cpp"
                      var $185=$prefix_type; //@line 1168 "translate.cpp"
                      var $and376=($185) & 131072; //@line 1168 "translate.cpp"
                      var $cmp377=((($and376))|0)==0; //@line 1168 "translate.cpp"
                      if ($cmp377) { __label__ = 114;; } else { __label__ = 118;; } //@line 1168 "translate.cpp"
                      $if_then378$$if_else391$146: do { 
                        if (__label__ == 114) {
  
                          var $186=$prefix_type; //@line 1170 "translate.cpp"
                          var $and379=($186) & 15; //@line 1170 "translate.cpp"
                          $ix=$and379; //@line 1170 "translate.cpp"
                          var $cmp38119=((($and379))|0) > 0; //@line 1170 "translate.cpp"
                          if (!($cmp38119)) { __label__ = 124;break $if_then378$$if_else391$146; } //@line 1170 "translate.cpp"
                          $for_body382$148: while(1) { 
  
                            var $187=HEAP32[(($wordx)>>2)]; //@line 1172 "translate.cpp"
                            var $incdec_ptr383=(($187+1)&4294967295); //@line 1172 "translate.cpp"
                            HEAP32[(($wordx)>>2)]=$incdec_ptr383; //@line 1172 "translate.cpp"
                            var $188=HEAP32[(($wordx)>>2)]; //@line 1173 "translate.cpp"
                            var $189=HEAP8[($188)]; //@line 1173 "translate.cpp"
                            var $conv38516=(tempInt=(($189)),(tempInt>=128?tempInt-256:tempInt)); //@line 1173 "translate.cpp"
                            var $and38617=($conv38516) & 192; //@line 1173 "translate.cpp"
                            var $cmp38718=((($and38617))|0)==128; //@line 1173 "translate.cpp"
                            if ($cmp38718) { __label__ = 116;; } else { __label__ = 117;; } //@line 1173 "translate.cpp"
                            $while_body388$$for_inc$150: do { 
                              if (__label__ == 116) {
                                while(1) { 
  
                                  var $190=HEAP32[(($wordx)>>2)]; //@line 1173 "translate.cpp"
                                  var $incdec_ptr389=(($190+1)&4294967295); //@line 1173 "translate.cpp"
                                  HEAP32[(($wordx)>>2)]=$incdec_ptr389; //@line 1173 "translate.cpp"
                                  var $191=HEAP32[(($wordx)>>2)]; //@line 1173 "translate.cpp"
                                  var $192=HEAP8[($191)]; //@line 1173 "translate.cpp"
                                  var $conv385=(tempInt=(($192)),(tempInt>=128?tempInt-256:tempInt)); //@line 1173 "translate.cpp"
                                  var $and386=($conv385) & 192; //@line 1173 "translate.cpp"
                                  var $cmp387=((($and386))|0)==128; //@line 1173 "translate.cpp"
                                  if ($cmp387) { __label__ = 116;continue ; } else { __label__ = 117;break $while_body388$$for_inc$150; } //@line 1173 "translate.cpp"
                                }
                              }
                            } while(0);
  
                            var $193=$ix; //@line 1170 "translate.cpp"
                            var $dec=((($193)-1)&4294967295); //@line 1170 "translate.cpp"
                            $ix=$dec; //@line 1170 "translate.cpp"
                            var $cmp381=((($dec))|0) > 0; //@line 1170 "translate.cpp"
                            if ($cmp381) { __label__ = 115;continue $for_body382$148; } else { __label__ = 124;break $if_then378$$if_else391$146; } //@line 1170 "translate.cpp"
                          }
                        }
                        else if (__label__ == 118) {
  
                          $pfix=1; //@line 1178 "translate.cpp"
                          HEAP8[($arrayidx392)]=0; //@line 1179 "translate.cpp"
                          var $194=$prefix_type; //@line 1180 "translate.cpp"
                          var $and393=($194) & 63; //@line 1180 "translate.cpp"
                          $n_chars=$and393; //@line 1180 "translate.cpp"
                          $ix=0; //@line 1182 "translate.cpp"
                          var $195=$ix; //@line 1182 "translate.cpp"
                          var $196=$n_chars; //@line 1182 "translate.cpp"
                          var $cmp39520=((($195))|0) < ((($196))|0); //@line 1182 "translate.cpp"
                          if ($cmp39520) { __label__ = 119;; } else { __label__ = 123;; } //@line 1182 "translate.cpp"
                          $for_body396$$for_end410$155: do { 
                            if (__label__ == 119) {
                              $for_body396$156: while(1) { 
  
                                var $197=HEAP32[(($wordx)>>2)]; //@line 1184 "translate.cpp"
                                var $incdec_ptr397=(($197+1)&4294967295); //@line 1184 "translate.cpp"
                                HEAP32[(($wordx)>>2)]=$incdec_ptr397; //@line 1184 "translate.cpp"
                                var $198=HEAP8[($197)]; //@line 1184 "translate.cpp"
                                var $199=$pfix; //@line 1184 "translate.cpp"
                                var $inc398=((($199)+1)&4294967295); //@line 1184 "translate.cpp"
                                $pfix=$inc398; //@line 1184 "translate.cpp"
                                var $arrayidx399=(($prefix_chars+$199)&4294967295); //@line 1184 "translate.cpp"
                                HEAP8[($arrayidx399)]=$198; //@line 1184 "translate.cpp"
                                var $200=$prefix_type; //@line 1186 "translate.cpp"
                                var $and400=($200) & 131072; //@line 1186 "translate.cpp"
                                var $tobool401=((($and400))|0)!=0; //@line 1186 "translate.cpp"
                                if ($tobool401) { __label__ = 120;; } else { __label__ = 122;; } //@line 1186 "translate.cpp"
                                $land_lhs_true402$$for_inc408$158: do { 
                                  if (__label__ == 120) {
  
                                    var $201=$ix; //@line 1186 "translate.cpp"
                                    var $202=$n_chars; //@line 1186 "translate.cpp"
                                    var $sub=((($202)-1)&4294967295); //@line 1186 "translate.cpp"
                                    var $cmp403=((($201))|0)==((($sub))|0); //@line 1186 "translate.cpp"
                                    if (!($cmp403)) { __label__ = 122;break $land_lhs_true402$$for_inc408$158; } //@line 1186 "translate.cpp"
  
                                    var $203=$pfix; //@line 1188 "translate.cpp"
                                    var $sub405=((($203)-1)&4294967295); //@line 1188 "translate.cpp"
                                    var $arrayidx406=(($prefix_chars+$sub405)&4294967295); //@line 1188 "translate.cpp"
                                    HEAP8[($arrayidx406)]=0; //@line 1188 "translate.cpp"
                                    ; //@line 1189 "translate.cpp"
                                  }
                                } while(0);
  
                                var $204=$ix; //@line 1182 "translate.cpp"
                                var $inc409=((($204)+1)&4294967295); //@line 1182 "translate.cpp"
                                $ix=$inc409; //@line 1182 "translate.cpp"
                                var $205=$ix; //@line 1182 "translate.cpp"
                                var $206=$n_chars; //@line 1182 "translate.cpp"
                                var $cmp395=((($205))|0) < ((($206))|0); //@line 1182 "translate.cpp"
                                if ($cmp395) { __label__ = 119;continue $for_body396$156; } else { __label__ = 123;break $for_body396$$for_end410$155; } //@line 1182 "translate.cpp"
                              }
                            }
                          } while(0);
  
                          var $207=$pfix; //@line 1191 "translate.cpp"
                          var $arrayidx411=(($prefix_chars+$207)&4294967295); //@line 1191 "translate.cpp"
                          HEAP8[($arrayidx411)]=0; //@line 1191 "translate.cpp"
                          ;
                        }
                      } while(0);
  
                      var $208=HEAP32[(($wordx)>>2)]; //@line 1193 "translate.cpp"
                      var $arrayidx413=(($208+-1)&4294967295); //@line 1193 "translate.cpp"
                      var $209=HEAP8[($arrayidx413)]; //@line 1193 "translate.cpp"
                      $c_temp=$209; //@line 1193 "translate.cpp"
                      var $210=HEAP32[(($wordx)>>2)]; //@line 1194 "translate.cpp"
                      var $arrayidx414=(($210+-1)&4294967295); //@line 1194 "translate.cpp"
                      HEAP8[($arrayidx414)]=32; //@line 1194 "translate.cpp"
                      $confirm_prefix=1; //@line 1195 "translate.cpp"
                      var $211=$prefix_type; //@line 1197 "translate.cpp"
                      var $and415=($211) & 131072; //@line 1197 "translate.cpp"
                      var $tobool416=((($and415))|0)!=0; //@line 1197 "translate.cpp"
                      if ($tobool416) { __label__ = 125;; } else { __label__ = 129;; } //@line 1197 "translate.cpp"
                      $if_then417$$if_else441$164: do { 
                        if (__label__ == 125) {
  
                          __Z8strncpy0PcPKci($arraydecay418, $arraydecay419, 12); //@line 1204 "translate.cpp"
                          HEAP32[(($wordpf)>>2)]=$arrayidx420; //@line 1205 "translate.cpp"
                          var $call423=_strcpy($arraydecay421, $arraydecay422); //@line 1206 "translate.cpp"
                          var $212=$tr_addr; //@line 1209 "translate.cpp"
                          var $213=$wtab_addr; //@line 1209 "translate.cpp"
                          var $call426=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($212, $wordpf, $arraydecay424, $arraydecay425, 0, $213); //@line 1209 "translate.cpp"
                          $found=$call426; //@line 1209 "translate.cpp"
                          var $214=$found; //@line 1210 "translate.cpp"
                          var $tobool427=((($214))|0)!=0; //@line 1210 "translate.cpp"
                          if ($tobool427) { __label__ = 126;; } else { __label__ = 127;; } //@line 1210 "translate.cpp"
                          if (__label__ == 126) {
  
                            var $call431=_strcpy($arraydecay429, $arraydecay430); //@line 1212 "translate.cpp"
                            ; //@line 1213 "translate.cpp"
                          }
  
                          var $215=HEAP32[(($arrayidx433)>>2)]; //@line 1214 "translate.cpp"
                          var $and434=($215) & 131072; //@line 1214 "translate.cpp"
                          var $tobool435=((($and434))|0)!=0; //@line 1214 "translate.cpp"
                          if (!($tobool435)) { __label__ = 130;break $if_then417$$if_else441$164; } //@line 1214 "translate.cpp"
  
                          HEAP8[($arrayidx437)]=0; //@line 1216 "translate.cpp"
                          var $216=$tr_addr; //@line 1217 "translate.cpp"
                          var $217=HEAP32[(($wordpf)>>2)]; //@line 1217 "translate.cpp"
                          var $call439=__ZL22SpeakIndividualLettersP10TranslatorPcS1_i($216, $217, $arraydecay438, 1); //@line 1217 "translate.cpp"
                          ; //@line 1218 "translate.cpp"
                        }
                        else if (__label__ == 129) {
  
                          var $call444=_strcat($arraydecay442, $arraydecay443); //@line 1222 "translate.cpp"
                          ;
                        }
                      } while(0);
  
                      HEAP8[($arrayidx446)]=0; //@line 1224 "translate.cpp"
                      $end_type=0; //@line 1226 "translate.cpp"
                      var $218=$tr_addr; //@line 1227 "translate.cpp"
                      var $219=$wtab_addr; //@line 1227 "translate.cpp"
                      var $call449=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($218, $wordx, $arraydecay447, $arraydecay448, 1024, $219); //@line 1227 "translate.cpp"
                      $found=$call449; //@line 1227 "translate.cpp"
                      var $220=HEAP32[(($arrayidx450)>>2)]; //@line 1228 "translate.cpp"
                      var $cmp451=((($220))|0)==0; //@line 1228 "translate.cpp"
                      if ($cmp451) { __label__ = 131;; } else { __label__ = 132;; } //@line 1228 "translate.cpp"
                      if (__label__ == 131) {
  
                        var $221=HEAP32[(($arrayidx453)>>2)]; //@line 1230 "translate.cpp"
                        HEAP32[(($arrayidx454)>>2)]=$221; //@line 1230 "translate.cpp"
                        var $222=HEAP32[(($arrayidx455)>>2)]; //@line 1231 "translate.cpp"
                        HEAP32[(($arrayidx456)>>2)]=$222; //@line 1231 "translate.cpp"
                        ; //@line 1232 "translate.cpp"
                      }
                      else if (__label__ == 132) {
  
                        $prefix_flags=1; //@line 1234 "translate.cpp"
                        ;
                      }
  
                      var $223=$found; //@line 1235 "translate.cpp"
                      var $cmp459=((($223))|0)==0; //@line 1235 "translate.cpp"
                      if (!($cmp459)) { __label__ = 136;break $if_end370$$for_inc474$141; } //@line 1235 "translate.cpp"
  
                      var $224=$tr_addr; //@line 1237 "translate.cpp"
                      var $225=HEAP32[(($wordx)>>2)]; //@line 1237 "translate.cpp"
                      var $call464=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($224, $225, $arraydecay461, 160, $arraydecay462, 0, $arraydecay463); //@line 1237 "translate.cpp"
                      $end_type=$call464; //@line 1237 "translate.cpp"
                      var $226=HEAP8[($arrayidx465)]; //@line 1239 "translate.cpp"
                      var $conv466=(tempInt=(($226)),(tempInt>=128?tempInt-256:tempInt)); //@line 1239 "translate.cpp"
                      var $cmp467=((($conv466))|0)==21; //@line 1239 "translate.cpp"
                      if ($cmp467) { __label__ = 135;break $for_cond$129; } //@line 1239 "translate.cpp"
                    }
                  } while(0);
  
                  var $229=$loopcount; //@line 1123 "translate.cpp"
                  var $inc475=((($229)+1)&4294967295); //@line 1123 "translate.cpp"
                  $loopcount=$inc475; //@line 1123 "translate.cpp"
                  __lastLabel__ = 136; __label__ = 102;continue $for_cond$129; //@line 1123 "translate.cpp"
                }
                if (__label__ == 137) {
  
                  var $cmp477=((($162))|0)!=0; //@line 1249 "translate.cpp"
                  if ($cmp477) { __label__ = 138;; } else { __label__ = 165;; } //@line 1249 "translate.cpp"
                  $land_lhs_true478$$if_end603$180: do { 
                    if (__label__ == 138) {
  
                      var $230=$end_type; //@line 1249 "translate.cpp"
                      var $and479=($230) & 1024; //@line 1249 "translate.cpp"
                      var $tobool480=((($and479))|0)!=0; //@line 1249 "translate.cpp"
                      if ($tobool480) { __label__ = 165;break $land_lhs_true478$$if_end603$180; } //@line 1249 "translate.cpp"
  
                      var $arraydecay483=(($phonemes2482)&4294967295); //@line 1252 "translate.cpp"
                      var $arraydecay484=(($phonemes)&4294967295); //@line 1252 "translate.cpp"
                      var $call485=_strcpy($arraydecay483, $arraydecay484); //@line 1252 "translate.cpp"
                      var $231=$tr_addr; //@line 1255 "translate.cpp"
                      var $232=HEAP32[(($wordx)>>2)]; //@line 1255 "translate.cpp"
                      var $233=$end_type; //@line 1255 "translate.cpp"
                      var $arraydecay486=(($word_copy)&4294967295); //@line 1255 "translate.cpp"
                      var $call487=__Z12RemoveEndingP10TranslatorPciS1_($231, $232, $233, $arraydecay486); //@line 1255 "translate.cpp"
                      $end_flags=$call487; //@line 1255 "translate.cpp"
                      var $arrayidx488=(($phonemes)&4294967295); //@line 1257 "translate.cpp"
                      HEAP8[($arrayidx488)]=0; //@line 1257 "translate.cpp"
                      var $arrayidx489=(($prefix_phonemes)&4294967295); //@line 1259 "translate.cpp"
                      var $234=HEAP8[($arrayidx489)]; //@line 1259 "translate.cpp"
                      var $conv490=(tempInt=(($234)),(tempInt>=128?tempInt-256:tempInt)); //@line 1259 "translate.cpp"
                      var $cmp491=((($conv490))|0)!=0; //@line 1259 "translate.cpp"
                      if ($cmp491) { __label__ = 140;; } else { __label__ = 148;; } //@line 1259 "translate.cpp"
                      $if_then492$$if_end526$183: do { 
                        if (__label__ == 140) {
  
                          var $235=$c_temp; //@line 1262 "translate.cpp"
                          var $236=HEAP32[(($wordx)>>2)]; //@line 1262 "translate.cpp"
                          var $arrayidx493=(($236+-1)&4294967295); //@line 1262 "translate.cpp"
                          HEAP8[($arrayidx493)]=$235; //@line 1262 "translate.cpp"
                          var $237=$tr_addr; //@line 1263 "translate.cpp"
                          var $arraydecay494=(($phonemes)&4294967295); //@line 1263 "translate.cpp"
                          var $arraydecay495=(($dictionary_flags2)&4294967295); //@line 1263 "translate.cpp"
                          var $238=$end_flags; //@line 1263 "translate.cpp"
                          var $239=$wtab_addr; //@line 1263 "translate.cpp"
                          var $call496=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($237, $word1, $arraydecay494, $arraydecay495, $238, $239); //@line 1263 "translate.cpp"
                          $found=$call496; //@line 1263 "translate.cpp"
                          var $240=HEAP32[(($wordx)>>2)]; //@line 1264 "translate.cpp"
                          var $arrayidx497=(($240+-1)&4294967295); //@line 1264 "translate.cpp"
                          HEAP8[($arrayidx497)]=32; //@line 1264 "translate.cpp"
                          var $arrayidx498=(($phonemes)&4294967295); //@line 1265 "translate.cpp"
                          var $241=HEAP8[($arrayidx498)]; //@line 1265 "translate.cpp"
                          var $conv499=(tempInt=(($241)),(tempInt>=128?tempInt-256:tempInt)); //@line 1265 "translate.cpp"
                          var $cmp500=((($conv499))|0)==21; //@line 1265 "translate.cpp"
                          if ($cmp500) { __label__ = 141;; } else { __label__ = 142;; } //@line 1265 "translate.cpp"
                          if (__label__ == 141) {
  
                            var $242=HEAP32[(($wordx)>>2)]; //@line 1268 "translate.cpp"
                            var $arraydecay502=(($word_copy)&4294967295); //@line 1268 "translate.cpp"
                            var $arraydecay503=(($word_copy)&4294967295); //@line 1268 "translate.cpp"
                            var $call504=_strlen($arraydecay503); //@line 1268 "translate.cpp"
                            var $src$, $dest$, $stop$, $stop4$, $fast$;
                            $src$ = $arraydecay502;
                            $dest$ = $242;
                            $stop$ = $src$ + $call504;
                            if (($dest$%4) == ($src$%4) && $call504 > 8) {
                              while ($src$%4 !== 0 && $src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }
                              $src$ >>= 2;
                              $dest$ >>= 2;
                              $stop4$ = $stop$ >> 2;
                              while ($src$ < $stop4$) {
                            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                              }
                              $src$ <<= 2;
                              $dest$ <<= 2;
                            }while ($src$ < $stop$) {
                              ; HEAP8[$dest$++] = HEAP8[$src$++];
                            }; //@line 1268 "translate.cpp"
                            var $arraydecay505=(($phonemes)&4294967295); //@line 1269 "translate.cpp"
                            var $call506=_strcpy(((_word_phonemes)&4294967295), $arraydecay505); //@line 1269 "translate.cpp"
                            $retval=0; //@line 1270 "translate.cpp"
                            __label__ = 236;break $if_then12$$if_end13$5; //@line 1270 "translate.cpp"
                          }
                          else if (__label__ == 142) {
  
                            var $arrayidx508=(($dictionary_flags)&4294967295); //@line 1272 "translate.cpp"
                            var $243=HEAP32[(($arrayidx508)>>2)]; //@line 1272 "translate.cpp"
                            var $cmp509=((($243))|0)==0; //@line 1272 "translate.cpp"
                            if ($cmp509) { __label__ = 143;; } else { __label__ = 144;; } //@line 1272 "translate.cpp"
                            if (__label__ == 143) {
  
                              var $arrayidx511=(($dictionary_flags2)&4294967295); //@line 1274 "translate.cpp"
                              var $244=HEAP32[(($arrayidx511)>>2)]; //@line 1274 "translate.cpp"
                              var $arrayidx512=(($dictionary_flags)&4294967295); //@line 1274 "translate.cpp"
                              HEAP32[(($arrayidx512)>>2)]=$244; //@line 1274 "translate.cpp"
                              var $arrayidx513=(($dictionary_flags2+4)&4294967295); //@line 1275 "translate.cpp"
                              var $245=HEAP32[(($arrayidx513)>>2)]; //@line 1275 "translate.cpp"
                              var $arrayidx514=(($dictionary_flags+4)&4294967295); //@line 1275 "translate.cpp"
                              HEAP32[(($arrayidx514)>>2)]=$245; //@line 1275 "translate.cpp"
                              ; //@line 1276 "translate.cpp"
                            }
  
                            var $246=$found; //@line 1277 "translate.cpp"
                            var $tobool516=((($246))|0)!=0; //@line 1277 "translate.cpp"
                            if ($tobool516) { __label__ = 145;; } else { __label__ = 146;; } //@line 1277 "translate.cpp"
                            if (__label__ == 145) {
  
                              var $arrayidx518=(($prefix_phonemes)&4294967295); //@line 1278 "translate.cpp"
                              HEAP8[($arrayidx518)]=0; //@line 1278 "translate.cpp"
                              var $_pr8=$found; //@line 1280 "translate.cpp"
                              var $cmp520=((($_pr8))|0)==0; //@line 1280 "translate.cpp"
                              if (!($cmp520)) { __label__ = 162;break $if_then492$$if_end526$183; } //@line 1280 "translate.cpp"
                            }
  
                            var $arrayidx522=(($dictionary_flags2)&4294967295); //@line 1280 "translate.cpp"
                            var $247=HEAP32[(($arrayidx522)>>2)]; //@line 1280 "translate.cpp"
                            var $cmp523=((($247))|0)!=0; //@line 1280 "translate.cpp"
                            if (!($cmp523)) { __label__ = 148;break $if_then492$$if_end526$183; } //@line 1280 "translate.cpp"
  
                            $prefix_flags=1; //@line 1281 "translate.cpp"
                            __label__ = 148;break $if_then492$$if_end526$183; //@line 1281 "translate.cpp"
                          }
                        }
                      } while(0);
                      $if_end526$$if_end592$195: do { 
                        if (__label__ == 148) {
  
                          var $_pr10=$found; //@line 1283 "translate.cpp"
                          var $cmp527=((($_pr10))|0)==0; //@line 1283 "translate.cpp"
                          if (!($cmp527)) { __label__ = 162;break $if_end526$$if_end592$195; } //@line 1283 "translate.cpp"
  
                          var $248=$tr_addr; //@line 1285 "translate.cpp"
                          var $arraydecay529=(($phonemes)&4294967295); //@line 1285 "translate.cpp"
                          var $arraydecay530=(($dictionary_flags2)&4294967295); //@line 1285 "translate.cpp"
                          var $249=$end_flags; //@line 1285 "translate.cpp"
                          var $250=$wtab_addr; //@line 1285 "translate.cpp"
                          var $call531=__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB($248, $wordx, $arraydecay529, $arraydecay530, $249, $250); //@line 1285 "translate.cpp"
                          $found=$call531; //@line 1285 "translate.cpp"
                          var $arrayidx532=(($phonemes)&4294967295); //@line 1286 "translate.cpp"
                          var $251=HEAP8[($arrayidx532)]; //@line 1286 "translate.cpp"
                          var $conv533=(tempInt=(($251)),(tempInt>=128?tempInt-256:tempInt)); //@line 1286 "translate.cpp"
                          var $cmp534=((($conv533))|0)==21; //@line 1286 "translate.cpp"
                          if ($cmp534) { __label__ = 150;; } else { __label__ = 151;; } //@line 1286 "translate.cpp"
                          if (__label__ == 150) {
  
                            var $252=HEAP32[(($wordx)>>2)]; //@line 1289 "translate.cpp"
                            var $arraydecay536=(($word_copy)&4294967295); //@line 1289 "translate.cpp"
                            var $arraydecay537=(($word_copy)&4294967295); //@line 1289 "translate.cpp"
                            var $call538=_strlen($arraydecay537); //@line 1289 "translate.cpp"
                            var $src$, $dest$, $stop$, $stop4$, $fast$;
                            $src$ = $arraydecay536;
                            $dest$ = $252;
                            $stop$ = $src$ + $call538;
                            if (($dest$%4) == ($src$%4) && $call538 > 8) {
                              while ($src$%4 !== 0 && $src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }
                              $src$ >>= 2;
                              $dest$ >>= 2;
                              $stop4$ = $stop$ >> 2;
                              while ($src$ < $stop4$) {
                            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                              }
                              $src$ <<= 2;
                              $dest$ <<= 2;
                            }while ($src$ < $stop$) {
                              ; HEAP8[$dest$++] = HEAP8[$src$++];
                            }; //@line 1289 "translate.cpp"
                            var $arraydecay539=(($phonemes)&4294967295); //@line 1290 "translate.cpp"
                            var $call540=_strcpy(((_word_phonemes)&4294967295), $arraydecay539); //@line 1290 "translate.cpp"
                            $retval=0; //@line 1291 "translate.cpp"
                            __label__ = 236;break $if_then12$$if_end13$5; //@line 1291 "translate.cpp"
                          }
                          else if (__label__ == 151) {
  
                            var $arrayidx547=(($dictionary_flags)&4294967295); //@line 1299 "translate.cpp"
                            var $253=HEAP32[(($arrayidx547)>>2)]; //@line 1299 "translate.cpp"
                            var $cmp548=((($253))|0)==0; //@line 1299 "translate.cpp"
                            if ($cmp548) { __label__ = 152;; } else { __label__ = 153;; } //@line 1299 "translate.cpp"
                            if (__label__ == 152) {
  
                              var $arrayidx550=(($dictionary_flags2)&4294967295); //@line 1301 "translate.cpp"
                              var $254=HEAP32[(($arrayidx550)>>2)]; //@line 1301 "translate.cpp"
                              var $arrayidx551=(($dictionary_flags)&4294967295); //@line 1301 "translate.cpp"
                              HEAP32[(($arrayidx551)>>2)]=$254; //@line 1301 "translate.cpp"
                              var $arrayidx552=(($dictionary_flags2+4)&4294967295); //@line 1302 "translate.cpp"
                              var $255=HEAP32[(($arrayidx552)>>2)]; //@line 1302 "translate.cpp"
                              var $arrayidx553=(($dictionary_flags+4)&4294967295); //@line 1302 "translate.cpp"
                              HEAP32[(($arrayidx553)>>2)]=$255; //@line 1302 "translate.cpp"
                              ; //@line 1303 "translate.cpp"
                            }
  
                            var $_pr12_pr=$found; //@line 1305 "translate.cpp"
                            var $cmp556=((($_pr12_pr))|0)==0; //@line 1305 "translate.cpp"
                            if (!($cmp556)) { __label__ = 162;break $if_end526$$if_end592$195; } //@line 1305 "translate.cpp"
  
                            var $256=$end_type; //@line 1307 "translate.cpp"
                            var $and558=($256) & 16384; //@line 1307 "translate.cpp"
                            var $tobool559=((($and558))|0)!=0; //@line 1307 "translate.cpp"
                            if ($tobool559) { __label__ = 155;; } else { __label__ = 156;; } //@line 1307 "translate.cpp"
                            if (__label__ == 155) {
  
                              var $arraydecay561=(($phonemes)&4294967295); //@line 1310 "translate.cpp"
                              var $arraydecay562=(($phonemes2482)&4294967295); //@line 1310 "translate.cpp"
                              var $call563=_strcpy($arraydecay561, $arraydecay562); //@line 1310 "translate.cpp"
                              var $257=$tr_addr; //@line 1313 "translate.cpp"
                              var $arraydecay564=(($phonemes)&4294967295); //@line 1313 "translate.cpp"
                              var $arrayidx565=(($dictionary_flags)&4294967295); //@line 1313 "translate.cpp"
                              var $258=HEAP32[(($arrayidx565)>>2)]; //@line 1313 "translate.cpp"
                              __Z21ApplySpecialAttributeP10TranslatorPci($257, $arraydecay564, $258); //@line 1313 "translate.cpp"
                              ; //@line 1314 "translate.cpp"
                            }
                            else if (__label__ == 156) {
  
                              var $259=$end_flags; //@line 1317 "translate.cpp"
                              var $and567=($259) & 4; //@line 1317 "translate.cpp"
                              var $tobool568=((($and567))|0)!=0; //@line 1317 "translate.cpp"
                              if ($tobool568) { __label__ = 157;; } else { __label__ = 158;; } //@line 1317 "translate.cpp"
                              if (__label__ == 157) {
  
                                var $260=$wflags; //@line 1318 "translate.cpp"
                                var $or570=($260) | 8192; //@line 1318 "translate.cpp"
                                $wflags=$or570; //@line 1318 "translate.cpp"
                                ; //@line 1318 "translate.cpp"
                              }
  
                              var $261=$end_type; //@line 1319 "translate.cpp"
                              var $and572=($261) & 262144; //@line 1319 "translate.cpp"
                              var $tobool573=((($and572))|0)!=0; //@line 1319 "translate.cpp"
                              if ($tobool573) { __label__ = 159;; } else { __label__ = 160;; } //@line 1319 "translate.cpp"
                              if (__label__ == 159) {
  
                                var $262=$wflags; //@line 1320 "translate.cpp"
                                var $or575=($262) | 134217728; //@line 1320 "translate.cpp"
                                $wflags=$or575; //@line 1320 "translate.cpp"
                                ; //@line 1320 "translate.cpp"
                              }
  
                              var $263=$tr_addr; //@line 1322 "translate.cpp"
                              var $264=HEAP32[(($wordx)>>2)]; //@line 1322 "translate.cpp"
                              var $arraydecay577=(($phonemes)&4294967295); //@line 1322 "translate.cpp"
                              var $265=$wflags; //@line 1322 "translate.cpp"
                              var $arraydecay578=(($dictionary_flags)&4294967295); //@line 1322 "translate.cpp"
                              var $call579=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($263, $264, $arraydecay577, 160, 0, $265, $arraydecay578); //@line 1322 "translate.cpp"
                              var $arrayidx580=(($phonemes)&4294967295); //@line 1324 "translate.cpp"
                              var $266=HEAP8[($arrayidx580)]; //@line 1324 "translate.cpp"
                              var $conv581=(tempInt=(($266)),(tempInt>=128?tempInt-256:tempInt)); //@line 1324 "translate.cpp"
                              var $cmp582=((($conv581))|0)==21; //@line 1324 "translate.cpp"
                              if (!($cmp582)) { __label__ = 162;break $if_end526$$if_end592$195; } //@line 1324 "translate.cpp"
  
                              var $arraydecay584=(($phonemes)&4294967295); //@line 1327 "translate.cpp"
                              var $call585=_strcpy(((_word_phonemes)&4294967295), $arraydecay584); //@line 1327 "translate.cpp"
                              var $267=HEAP32[(($wordx)>>2)]; //@line 1328 "translate.cpp"
                              var $arraydecay586=(($word_copy)&4294967295); //@line 1328 "translate.cpp"
                              var $arraydecay587=(($word_copy)&4294967295); //@line 1328 "translate.cpp"
                              var $call588=_strlen($arraydecay587); //@line 1328 "translate.cpp"
                              var $src$, $dest$, $stop$, $stop4$, $fast$;
                              $src$ = $arraydecay586;
                              $dest$ = $267;
                              $stop$ = $src$ + $call588;
                              if (($dest$%4) == ($src$%4) && $call588 > 8) {
                                while ($src$%4 !== 0 && $src$ < $stop$) {
                                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                                }
                                $src$ >>= 2;
                                $dest$ >>= 2;
                                $stop4$ = $stop$ >> 2;
                                while ($src$ < $stop4$) {
                              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                                }
                                $src$ <<= 2;
                                $dest$ <<= 2;
                              }while ($src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }; //@line 1328 "translate.cpp"
                              var $268=$c_temp; //@line 1329 "translate.cpp"
                              var $269=HEAP32[(($wordx)>>2)]; //@line 1329 "translate.cpp"
                              var $arrayidx589=(($269+-1)&4294967295); //@line 1329 "translate.cpp"
                              HEAP8[($arrayidx589)]=$268; //@line 1329 "translate.cpp"
                              $retval=0; //@line 1330 "translate.cpp"
                              __label__ = 236;break $if_then12$$if_end13$5; //@line 1330 "translate.cpp"
                            }
                          }
                        }
                      } while(0);
  
                      var $270=$end_type; //@line 1335 "translate.cpp"
                      var $and593=($270) & 65536; //@line 1335 "translate.cpp"
                      var $cmp594=((($and593))|0)==0; //@line 1335 "translate.cpp"
                      if ($cmp594) { __label__ = 163;; } else { __label__ = 164;; } //@line 1335 "translate.cpp"
                      if (__label__ == 163) {
  
                        var $271=$tr_addr; //@line 1338 "translate.cpp"
                        var $arraydecay596=(($phonemes)&4294967295); //@line 1338 "translate.cpp"
                        var $arraydecay597=(($end_phonemes)&4294967295); //@line 1338 "translate.cpp"
                        __Z14AppendPhonemesP10TranslatorPciPKc($271, $arraydecay596, 160, $arraydecay597); //@line 1338 "translate.cpp"
                        var $arrayidx598=(($end_phonemes)&4294967295); //@line 1339 "translate.cpp"
                        HEAP8[($arrayidx598)]=0; //@line 1339 "translate.cpp"
                        ; //@line 1340 "translate.cpp"
                      }
  
                      var $272=HEAP32[(($wordx)>>2)]; //@line 1341 "translate.cpp"
                      var $arraydecay600=(($word_copy)&4294967295); //@line 1341 "translate.cpp"
                      var $arraydecay601=(($word_copy)&4294967295); //@line 1341 "translate.cpp"
                      var $call602=_strlen($arraydecay601); //@line 1341 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $arraydecay600;
                      $dest$ = $272;
                      $stop$ = $src$ + $call602;
                      if (($dest$%4) == ($src$%4) && $call602 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 1341 "translate.cpp"
                      ; //@line 1342 "translate.cpp"
                    }
                  } while(0);
  
                  var $273=$c_temp; //@line 1343 "translate.cpp"
                  var $274=HEAP32[(($wordx)>>2)]; //@line 1343 "translate.cpp"
                  var $arrayidx604=(($274+-1)&4294967295); //@line 1343 "translate.cpp"
                  HEAP8[($arrayidx604)]=$273; //@line 1343 "translate.cpp"
                  __label__ = 166;break $if_end219$$if_then221$95; //@line 1344 "translate.cpp"
                }
                else if (__label__ == 135) {
  
                  var $227=$c_temp; //@line 1242 "translate.cpp"
                  var $228=HEAP32[(($wordx)>>2)]; //@line 1242 "translate.cpp"
                  var $arrayidx469=(($228+-1)&4294967295); //@line 1242 "translate.cpp"
                  HEAP8[($arrayidx469)]=$227; //@line 1242 "translate.cpp"
                  var $arraydecay470=(($phonemes)&4294967295); //@line 1243 "translate.cpp"
                  var $call471=_strcpy(((_word_phonemes)&4294967295), $arraydecay470); //@line 1243 "translate.cpp"
                  $retval=0; //@line 1244 "translate.cpp"
                  __label__ = 236;break $if_then12$$if_end13$5; //@line 1244 "translate.cpp"
                }
              }
            }
            else if (__label__ == 84) {
  
              var $arraydecay260=(($unpron_phonemes)&4294967295); //@line 1063 "translate.cpp"
              var $call261=_strcpy(((_word_phonemes)&4294967295), $arraydecay260); //@line 1063 "translate.cpp"
              var $arrayidx262=(($unpron_phonemes+1)&4294967295); //@line 1064 "translate.cpp"
              var $call263=_strcmp($arrayidx262, ((__str52704)&4294967295)); //@line 1064 "translate.cpp"
              var $cmp264=((($call263))|0)==0; //@line 1064 "translate.cpp"
              if ($cmp264) { __label__ = 85;; } else { __label__ = 86;; } //@line 1064 "translate.cpp"
              if (__label__ == 85) {
  
                $retval=65536; //@line 1065 "translate.cpp"
                __label__ = 236;break $if_then12$$if_end13$5; //@line 1065 "translate.cpp"
              }
              else if (__label__ == 86) {
  
                $retval=0; //@line 1066 "translate.cpp"
                __label__ = 236;break $if_then12$$if_end13$5; //@line 1066 "translate.cpp"
              }
            }
          }
        } while(0);
        $if_then221$$if_end607$225: do { 
          if (__label__ == 71) {
  
            var $arrayidx222=(($phonemes)&4294967295); //@line 1021 "translate.cpp"
            HEAP8[($arrayidx222)]=0; //@line 1021 "translate.cpp"
            $end_type=0; //@line 1022 "translate.cpp"
            var $111=$tr_addr; //@line 1024 "translate.cpp"
            var $112=HEAP32[(($word1)>>2)]; //@line 1024 "translate.cpp"
            var $arraydecay223=(($phonemes)&4294967295); //@line 1024 "translate.cpp"
            var $113=$spell_word; //@line 1024 "translate.cpp"
            var $call224=__ZL22SpeakIndividualLettersP10TranslatorPcS1_i($111, $112, $arraydecay223, $113); //@line 1024 "translate.cpp"
            var $cmp225=((($call224))|0)==0; //@line 1024 "translate.cpp"
            if (!($cmp225)) { __label__ = 166;break $if_then221$$if_end607$225; } //@line 1024 "translate.cpp"
  
            var $114=$word_length; //@line 1026 "translate.cpp"
            var $cmp227=((($114))|0) > 1; //@line 1026 "translate.cpp"
            if ($cmp227) { __label__ = 73;; } else { __label__ = 74;; } //@line 1026 "translate.cpp"
            if (__label__ == 73) {
  
              $retval=65536; //@line 1027 "translate.cpp"
              __label__ = 236;break $if_then12$$if_end13$5; //@line 1027 "translate.cpp"
            }
            else if (__label__ == 74) {
  
              $retval=0; //@line 1028 "translate.cpp"
              __label__ = 236;break $if_then12$$if_end13$5; //@line 1028 "translate.cpp"
            }
          }
        } while(0);
  
        var $275=$add_plural_suffix; //@line 1347 "translate.cpp"
        var $tobool608=((($275))|0)!=0; //@line 1347 "translate.cpp"
        if ($tobool608) { __label__ = 168;; } else { __label__ = 167;; } //@line 1347 "translate.cpp"
        $if_then612$$lor_lhs_false609$232: do { 
          if (__label__ == 167) {
  
            var $276=$wflags; //@line 1347 "translate.cpp"
            var $and610=($276) & 4; //@line 1347 "translate.cpp"
            var $tobool611=((($and610))|0)!=0; //@line 1347 "translate.cpp"
            if ($tobool611) { __label__ = 168;break $if_then612$$lor_lhs_false609$232; } else { __label__ = 174;break $if_then612$$lor_lhs_false609$232; } //@line 1347 "translate.cpp"
          }
        } while(0);
        $if_then612$$if_end630$234: do { 
          if (__label__ == 168) {
  
            var $277=HEAP32[(($last_char)>>2)]; //@line 1350 "translate.cpp"
            var $cmp613=((($277))|0)==102; //@line 1350 "translate.cpp"
            if ($cmp613) { __label__ = 169;; } else { __label__ = 170;; } //@line 1350 "translate.cpp"
            if (__label__ == 169) {
  
              var $278=$tr_addr; //@line 1351 "translate.cpp"
              var $arraydecay615=(($phonemes)&4294967295); //@line 1351 "translate.cpp"
              var $call616=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($278, ((__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_ss+1)&4294967295), $arraydecay615, 160, 0, 0, 0); //@line 1351 "translate.cpp"
              ; //@line 1351 "translate.cpp"
            }
            else if (__label__ == 170) {
  
              var $279=HEAP32[(($last_char)>>2)]; //@line 1353 "translate.cpp"
              var $cmp618=((($279))|0)==0; //@line 1353 "translate.cpp"
              if ($cmp618) { __label__ = 172;; } else { __label__ = 171;; } //@line 1353 "translate.cpp"
              $if_then622$$lor_lhs_false619$239: do { 
                if (__label__ == 171) {
  
                  var $280=HEAP32[(($last_char)>>2)]; //@line 1353 "translate.cpp"
                  var $call620=__Z8strchr_wPKci(((__str5548)&4294967295), $280); //@line 1353 "translate.cpp"
                  var $cmp621=((($call620))|0)==0; //@line 1353 "translate.cpp"
                  if ($cmp621) { __label__ = 172;break $if_then622$$lor_lhs_false619$239; } //@line 1353 "translate.cpp"
  
                  var $282=$tr_addr; //@line 1356 "translate.cpp"
                  var $arraydecay626=(($phonemes)&4294967295); //@line 1356 "translate.cpp"
                  var $call627=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($282, ((__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_iz+1)&4294967295), $arraydecay626, 160, 0, 0, 0); //@line 1356 "translate.cpp"
                  __label__ = 174;break $if_then612$$if_end630$234;
                }
              } while(0);
  
              var $281=$tr_addr; //@line 1354 "translate.cpp"
              var $arraydecay623=(($phonemes)&4294967295); //@line 1354 "translate.cpp"
              var $call624=__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj($281, ((__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_zz+1)&4294967295), $arraydecay623, 160, 0, 0, 0); //@line 1354 "translate.cpp"
              ; //@line 1354 "translate.cpp"
            }
          }
        } while(0);
  
        var $283=$emphasize_allcaps; //@line 1359 "translate.cpp"
        var $284=$wflags; //@line 1359 "translate.cpp"
        var $or631=($284) | ($283); //@line 1359 "translate.cpp"
        $wflags=$or631; //@line 1359 "translate.cpp"
        $prefix_stress=0; //@line 1364 "translate.cpp"
        var $arraydecay632=(($prefix_phonemes)&4294967295); //@line 1365 "translate.cpp"
        $p=$arraydecay632; //@line 1365 "translate.cpp"
        var $285=$p; //@line 1365 "translate.cpp"
        var $286=HEAP8[($285)]; //@line 1365 "translate.cpp"
        var $conv63426=(tempInt=(($286)),(tempInt>=128?tempInt-256:tempInt)); //@line 1365 "translate.cpp"
        var $cmp63527=((($conv63426))|0)!=0; //@line 1365 "translate.cpp"
        if ($cmp63527) { __label__ = 175;; } else { __label__ = 179;; } //@line 1365 "translate.cpp"
        $for_body636$$for_end647$244: do { 
          if (__label__ == 175) {
            $for_body636$245: while(1) { 
  
              var $287=$p; //@line 1367 "translate.cpp"
              var $288=HEAP8[($287)]; //@line 1367 "translate.cpp"
              var $conv637=(tempInt=(($288)),(tempInt>=128?tempInt-256:tempInt)); //@line 1367 "translate.cpp"
              var $cmp638=((($conv637))|0)==6; //@line 1367 "translate.cpp"
              if ($cmp638) { __label__ = 177;; } else { __label__ = 176;; } //@line 1367 "translate.cpp"
              $if_then642$$lor_lhs_false639$247: do { 
                if (__label__ == 176) {
  
                  var $289=$p; //@line 1367 "translate.cpp"
                  var $290=HEAP8[($289)]; //@line 1367 "translate.cpp"
                  var $conv640=(tempInt=(($290)),(tempInt>=128?tempInt-256:tempInt)); //@line 1367 "translate.cpp"
                  var $cmp641=((($conv640))|0)==7; //@line 1367 "translate.cpp"
                  if ($cmp641) { __label__ = 177;break $if_then642$$lor_lhs_false639$247; } else { __label__ = 178;break $if_then642$$lor_lhs_false639$247; } //@line 1367 "translate.cpp"
                }
              } while(0);
              if (__label__ == 177) {
  
                var $291=$p; //@line 1369 "translate.cpp"
                var $292=HEAP8[($291)]; //@line 1369 "translate.cpp"
                var $conv643=(tempInt=(($292)),(tempInt>=128?tempInt-256:tempInt)); //@line 1369 "translate.cpp"
                $prefix_stress=$conv643; //@line 1369 "translate.cpp"
                ; //@line 1370 "translate.cpp"
              }
  
              var $293=$p; //@line 1365 "translate.cpp"
              var $incdec_ptr646=(($293+1)&4294967295); //@line 1365 "translate.cpp"
              $p=$incdec_ptr646; //@line 1365 "translate.cpp"
              var $294=$p; //@line 1365 "translate.cpp"
              var $295=HEAP8[($294)]; //@line 1365 "translate.cpp"
              var $conv634=(tempInt=(($295)),(tempInt>=128?tempInt-256:tempInt)); //@line 1365 "translate.cpp"
              var $cmp635=((($conv634))|0)!=0; //@line 1365 "translate.cpp"
              if ($cmp635) { __label__ = 175;continue $for_body636$245; } else { __label__ = 179;break $for_body636$$for_end647$244; } //@line 1365 "translate.cpp"
            }
          }
        } while(0);
  
        var $296=$prefix_flags; //@line 1372 "translate.cpp"
        var $tobool648=((($296))|0)!=0; //@line 1372 "translate.cpp"
        if ($tobool648) { __label__ = 181;; } else { __label__ = 180;; } //@line 1372 "translate.cpp"
        $if_then651$$lor_lhs_false649$253: do { 
          if (__label__ == 180) {
  
            var $297=$prefix_stress; //@line 1372 "translate.cpp"
            var $cmp650=((($297))|0)!=0; //@line 1372 "translate.cpp"
            if ($cmp650) { __label__ = 181;break $if_then651$$lor_lhs_false649$253; } //@line 1372 "translate.cpp"
  
            var $313=$tr_addr; //@line 1415 "translate.cpp"
            var $arraydecay695=(($phonemes)&4294967295); //@line 1415 "translate.cpp"
            var $arraydecay696=(($dictionary_flags)&4294967295); //@line 1415 "translate.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($313, $arraydecay695, $arraydecay696, -1, 0); //@line 1415 "translate.cpp"
            var $arraydecay701=(($unpron_phonemes)&4294967295); //@line 1421 "translate.cpp"
            var $arraydecay702=(($prefix_phonemes)&4294967295); //@line 1421 "translate.cpp"
            var $arraydecay703=(($phonemes)&4294967295); //@line 1421 "translate.cpp"
            var $call704=_snprintf(((_word_phonemes)&4294967295), 160, ((__str6549)&4294967295), allocate([$arraydecay701,0,0,0,$arraydecay702,0,0,0,$arraydecay703,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1421 "translate.cpp"
            HEAP8[(((_word_phonemes+159)&4294967295))]=0; //@line 1423 "translate.cpp"
            __label__ = 192;break $if_then651$$lor_lhs_false649$253;
          }
        } while(0);
        $if_then651$$if_end705$256: do { 
          if (__label__ == 181) {
  
            var $298=$tr_addr; //@line 1374 "translate.cpp"
            var $langopts652=(($298)&4294967295); //@line 1374 "translate.cpp"
            var $param=(($langopts652+24)&4294967295); //@line 1374 "translate.cpp"
            var $arrayidx653=(($param+12)&4294967295); //@line 1374 "translate.cpp"
            var $299=HEAP32[(($arrayidx653)>>2)]; //@line 1374 "translate.cpp"
            var $tobool654=((($299))|0)!=0; //@line 1374 "translate.cpp"
            if ($tobool654) { __label__ = 183;; } else { __label__ = 182;; } //@line 1374 "translate.cpp"
            $if_then658$$lor_lhs_false655$258: do { 
              if (__label__ == 182) {
  
                var $300=$prefix_type; //@line 1374 "translate.cpp"
                var $and656=($300) & 65536; //@line 1374 "translate.cpp"
                var $tobool657=((($and656))|0)!=0; //@line 1374 "translate.cpp"
                if ($tobool657) { __label__ = 183;break $if_then658$$lor_lhs_false655$258; } //@line 1374 "translate.cpp"
  
                var $arraydecay684=(($unpron_phonemes)&4294967295); //@line 1406 "translate.cpp"
                var $arraydecay685=(($prefix_phonemes)&4294967295); //@line 1406 "translate.cpp"
                var $arraydecay686=(($phonemes)&4294967295); //@line 1406 "translate.cpp"
                var $call687=_snprintf(((_word_phonemes)&4294967295), 160, ((__str6549)&4294967295), allocate([$arraydecay684,0,0,0,$arraydecay685,0,0,0,$arraydecay686,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1406 "translate.cpp"
                HEAP8[(((_word_phonemes+159)&4294967295))]=0; //@line 1408 "translate.cpp"
                var $312=$tr_addr; //@line 1409 "translate.cpp"
                var $arraydecay688=(($dictionary_flags)&4294967295); //@line 1409 "translate.cpp"
                __Z13SetWordStressP10TranslatorPcPjii($312, ((_word_phonemes)&4294967295), $arraydecay688, -1, 0); //@line 1409 "translate.cpp"
                __label__ = 192;break $if_then651$$if_end705$256;
              }
            } while(0);
  
            var $301=$tr_addr; //@line 1378 "translate.cpp"
            var $arraydecay660=(($phonemes)&4294967295); //@line 1378 "translate.cpp"
            var $arraydecay661=(($dictionary_flags)&4294967295); //@line 1378 "translate.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($301, $arraydecay660, $arraydecay661, 3, 0); //@line 1378 "translate.cpp"
            $ix=0; //@line 1381 "translate.cpp"
            var $arraydecay662=(($prefix_phonemes)&4294967295); //@line 1382 "translate.cpp"
            $p659=$arraydecay662; //@line 1382 "translate.cpp"
            var $302=$p659; //@line 1382 "translate.cpp"
            var $303=HEAP8[($302)]; //@line 1382 "translate.cpp"
            var $conv66424=(tempInt=(($303)),(tempInt>=128?tempInt-256:tempInt)); //@line 1382 "translate.cpp"
            var $cmp66525=((($conv66424))|0)!=0; //@line 1382 "translate.cpp"
            if ($cmp66525) { __label__ = 184;; } else { __label__ = 189;; } //@line 1382 "translate.cpp"
            $for_body666$$for_end677$262: do { 
              if (__label__ == 184) {
                while(1) { 
  
                  var $304=$p659; //@line 1384 "translate.cpp"
                  var $305=HEAP8[($304)]; //@line 1384 "translate.cpp"
                  var $conv667=(tempInt=(($305)),(tempInt>=128?tempInt-256:tempInt)); //@line 1384 "translate.cpp"
                  var $cmp668=((($conv667))|0)==6; //@line 1384 "translate.cpp"
                  if ($cmp668) { __label__ = 185;; } else { __label__ = 188;; } //@line 1384 "translate.cpp"
                  if (__label__ == 185) {
  
                    var $306=$ix; //@line 1386 "translate.cpp"
                    var $cmp670=((($306))|0)==0; //@line 1386 "translate.cpp"
                    if ($cmp670) { __label__ = 186;; } else { __label__ = 187;; } //@line 1386 "translate.cpp"
                    if (__label__ == 186) {
  
                      $ix=1; //@line 1387 "translate.cpp"
                      ; //@line 1387 "translate.cpp"
                    }
                    else if (__label__ == 187) {
  
                      var $307=$p659; //@line 1389 "translate.cpp"
                      HEAP8[($307)]=5; //@line 1389 "translate.cpp"
                      ;
                    }
                  }
  
                  var $308=$p659; //@line 1382 "translate.cpp"
                  var $incdec_ptr676=(($308+1)&4294967295); //@line 1382 "translate.cpp"
                  $p659=$incdec_ptr676; //@line 1382 "translate.cpp"
                  var $309=$p659; //@line 1382 "translate.cpp"
                  var $310=HEAP8[($309)]; //@line 1382 "translate.cpp"
                  var $conv664=(tempInt=(($310)),(tempInt>=128?tempInt-256:tempInt)); //@line 1382 "translate.cpp"
                  var $cmp665=((($conv664))|0)!=0; //@line 1382 "translate.cpp"
                  if ($cmp665) { __label__ = 184;continue ; } else { __label__ = 189;break $for_body666$$for_end677$262; } //@line 1382 "translate.cpp"
                }
              }
            } while(0);
  
            var $arraydecay678=(($unpron_phonemes)&4294967295); //@line 1395 "translate.cpp"
            var $arraydecay679=(($prefix_phonemes)&4294967295); //@line 1395 "translate.cpp"
            var $arraydecay680=(($phonemes)&4294967295); //@line 1395 "translate.cpp"
            var $call681=_snprintf(((_word_phonemes)&4294967295), 160, ((__str6549)&4294967295), allocate([$arraydecay678,0,0,0,$arraydecay679,0,0,0,$arraydecay680,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1395 "translate.cpp"
            HEAP8[(((_word_phonemes+159)&4294967295))]=0; //@line 1397 "translate.cpp"
            var $311=$tr_addr; //@line 1398 "translate.cpp"
            var $arraydecay682=(($dictionary_flags)&4294967295); //@line 1398 "translate.cpp"
            __Z13SetWordStressP10TranslatorPcPjii($311, ((_word_phonemes)&4294967295), $arraydecay682, -1, 0); //@line 1398 "translate.cpp"
            ; //@line 1399 "translate.cpp"
          }
        } while(0);
  
        var $arrayidx706=(($end_phonemes)&4294967295); //@line 1426 "translate.cpp"
        var $314=HEAP8[($arrayidx706)]; //@line 1426 "translate.cpp"
        var $conv707=(tempInt=(($314)),(tempInt>=128?tempInt-256:tempInt)); //@line 1426 "translate.cpp"
        var $cmp708=((($conv707))|0)!=0; //@line 1426 "translate.cpp"
        if ($cmp708) { __label__ = 193;; } else { __label__ = 194;; } //@line 1426 "translate.cpp"
        if (__label__ == 193) {
  
          var $call710=_strlen(((_word_phonemes)&4294967295)); //@line 1429 "translate.cpp"
          $ix=$call710; //@line 1429 "translate.cpp"
          var $315=$ix; //@line 1430 "translate.cpp"
          var $sub711=((159-($315))&4294967295); //@line 1430 "translate.cpp"
          var $arrayidx712=(($end_phonemes+$sub711)&4294967295); //@line 1430 "translate.cpp"
          HEAP8[($arrayidx712)]=0; //@line 1430 "translate.cpp"
          var $316=$ix; //@line 1431 "translate.cpp"
          var $arrayidx713=((_word_phonemes+$316)&4294967295); //@line 1431 "translate.cpp"
          var $arraydecay714=(($end_phonemes)&4294967295); //@line 1431 "translate.cpp"
          var $call715=_strcpy($arrayidx713, $arraydecay714); //@line 1431 "translate.cpp"
          ; //@line 1432 "translate.cpp"
        }
  
        var $317=$wflags; //@line 1434 "translate.cpp"
        var $and717=($317) & 16; //@line 1434 "translate.cpp"
        var $tobool718=((($and717))|0)!=0; //@line 1434 "translate.cpp"
        if ($tobool718) { __label__ = 195;; } else { __label__ = 196;; } //@line 1434 "translate.cpp"
        if (__label__ == 195) {
  
          var $arrayidx720=(($dictionary_flags)&4294967295); //@line 1438 "translate.cpp"
          var $318=HEAP32[(($arrayidx720)>>2)]; //@line 1438 "translate.cpp"
          var $and721=($318) & -268435457; //@line 1438 "translate.cpp"
          HEAP32[(($arrayidx720)>>2)]=$and721; //@line 1438 "translate.cpp"
          ; //@line 1439 "translate.cpp"
        }
  
        var $319=$wflags; //@line 1441 "translate.cpp"
        var $and723=($319) & 128; //@line 1441 "translate.cpp"
        var $tobool724=((($and723))|0)!=0; //@line 1441 "translate.cpp"
        if ($tobool724) { __label__ = 197;; } else { __label__ = 199;; } //@line 1441 "translate.cpp"
        $land_lhs_true725$$if_else730$279: do { 
          if (__label__ == 197) {
  
            var $320=$tr_addr; //@line 1441 "translate.cpp"
            var $langopts726=(($320)&4294967295); //@line 1441 "translate.cpp"
            var $stress_flags=(($langopts726+12)&4294967295); //@line 1441 "translate.cpp"
            var $321=HEAP32[(($stress_flags)>>2)]; //@line 1441 "translate.cpp"
            var $and727=($321) & 1048576; //@line 1441 "translate.cpp"
            var $tobool728=((($and727))|0)!=0; //@line 1441 "translate.cpp"
            if (!($tobool728)) { __label__ = 199;break $land_lhs_true725$$if_else730$279; } //@line 1441 "translate.cpp"
  
            var $322=$tr_addr; //@line 1443 "translate.cpp"
            __Z16ChangeWordStressP10TranslatorPci($322, ((_word_phonemes)&4294967295), 3); //@line 1443 "translate.cpp"
            __label__ = 208;break $land_lhs_true725$$if_else730$279; //@line 1444 "translate.cpp"
          }
        } while(0);
        $if_end761$$if_else730$282: do { 
          if (__label__ == 199) {
  
            var $323=$wflags; //@line 1446 "translate.cpp"
            var $and731=($323) & 3072; //@line 1446 "translate.cpp"
            var $tobool732=((($and731))|0)!=0; //@line 1446 "translate.cpp"
            if ($tobool732) { __label__ = 200;; } else { __label__ = 202;; } //@line 1446 "translate.cpp"
            if (__label__ == 200) {
  
              var $324=$tr_addr; //@line 1450 "translate.cpp"
              __Z16ChangeWordStressP10TranslatorPci($324, ((_word_phonemes)&4294967295), 6); //@line 1450 "translate.cpp"
              var $325=$wflags; //@line 1452 "translate.cpp"
              var $and734=($325) & 2048; //@line 1452 "translate.cpp"
              var $tobool735=((($and734))|0)!=0; //@line 1452 "translate.cpp"
              if (!($tobool735)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1452 "translate.cpp"
  
              var $arrayidx737=(($dictionary_flags)&4294967295); //@line 1453 "translate.cpp"
              var $326=HEAP32[(($arrayidx737)>>2)]; //@line 1453 "translate.cpp"
              var $or738=($326) | 268435456; //@line 1453 "translate.cpp"
              HEAP32[(($arrayidx737)>>2)]=$or738; //@line 1453 "translate.cpp"
              ; //@line 1453 "translate.cpp"
            }
            else if (__label__ == 202) {
  
              var $327=HEAP32[((_dictionary_skipwords)>>2)]; //@line 1456 "translate.cpp"
              var $328=$wtab_addr; //@line 1456 "translate.cpp"
              var $arrayidx741=(($328+12*$327)&4294967295); //@line 1456 "translate.cpp"
              var $flags742=(($arrayidx741)&4294967295); //@line 1456 "translate.cpp"
              var $329=HEAP32[(($flags742)>>2)]; //@line 1456 "translate.cpp"
              var $and743=($329) & 16; //@line 1456 "translate.cpp"
              var $tobool744=((($and743))|0)!=0; //@line 1456 "translate.cpp"
              if (!($tobool744)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1456 "translate.cpp"
  
              var $arrayidx746=(($dictionary_flags)&4294967295); //@line 1459 "translate.cpp"
              var $330=HEAP32[(($arrayidx746)>>2)]; //@line 1459 "translate.cpp"
              var $and747=($330) & 6144; //@line 1459 "translate.cpp"
              var $tobool748=((($and747))|0)!=0; //@line 1459 "translate.cpp"
              if ($tobool748) { __label__ = 204;; } else { __label__ = 205;; } //@line 1459 "translate.cpp"
              if (__label__ == 204) {
  
                var $331=$tr_addr; //@line 1460 "translate.cpp"
                __Z16ChangeWordStressP10TranslatorPci($331, ((_word_phonemes)&4294967295), 4); //@line 1460 "translate.cpp"
                ; //@line 1460 "translate.cpp"
              }
              else if (__label__ == 205) {
  
                var $arrayidx751=(($dictionary_flags)&4294967295); //@line 1462 "translate.cpp"
                var $332=HEAP32[(($arrayidx751)>>2)]; //@line 1462 "translate.cpp"
                var $and752=($332) & 8192; //@line 1462 "translate.cpp"
                var $tobool753=((($and752))|0)!=0; //@line 1462 "translate.cpp"
                if (!($tobool753)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1462 "translate.cpp"
  
                var $_b=HEAPU8[(__ZL18any_stressed_words_b)];
                var $333=((($_b))&1);
                var $tobool755=((($333))|0)!=0; //@line 1462 "translate.cpp"
                if (!($tobool755)) { __label__ = 208;break $if_end761$$if_else730$282; } //@line 1462 "translate.cpp"
  
                var $334=$tr_addr; //@line 1463 "translate.cpp"
                __Z16ChangeWordStressP10TranslatorPci($334, ((_word_phonemes)&4294967295), 3); //@line 1463 "translate.cpp"
                ; //@line 1463 "translate.cpp"
              }
            }
          }
        } while(0);
  
        var $335=$end_type; //@line 1468 "translate.cpp"
        var $and762=($335) & 8192; //@line 1468 "translate.cpp"
        var $tobool763=((($and762))|0)!=0; //@line 1468 "translate.cpp"
        if ($tobool763) { __label__ = 209;; } else { __label__ = 210;; } //@line 1468 "translate.cpp"
        if (__label__ == 209) {
  
          var $336=$tr_addr; //@line 1471 "translate.cpp"
          var $expect_verb765=(($336+8272)&4294967295); //@line 1471 "translate.cpp"
          HEAP32[(($expect_verb765)>>2)]=2; //@line 1471 "translate.cpp"
          var $337=$tr_addr; //@line 1472 "translate.cpp"
          var $expect_verb_s=(($337+8280)&4294967295); //@line 1472 "translate.cpp"
          HEAP32[(($expect_verb_s)>>2)]=2; //@line 1472 "translate.cpp"
          ; //@line 1473 "translate.cpp"
        }
  
        var $arrayidx767=(($dictionary_flags+4)&4294967295); //@line 1475 "translate.cpp"
        var $338=HEAP32[(($arrayidx767)>>2)]; //@line 1475 "translate.cpp"
        var $and768=($338) & 8; //@line 1475 "translate.cpp"
        var $tobool769=((($and768))|0)!=0; //@line 1475 "translate.cpp"
        if ($tobool769) { __label__ = 211;; } else { __label__ = 212;; } //@line 1475 "translate.cpp"
        $if_then770$$if_else772$298: do { 
          if (__label__ == 211) {
  
            var $339=$tr_addr; //@line 1478 "translate.cpp"
            var $expect_past=(($339+8276)&4294967295); //@line 1478 "translate.cpp"
            HEAP32[(($expect_past)>>2)]=3; //@line 1478 "translate.cpp"
            var $340=$tr_addr; //@line 1479 "translate.cpp"
            var $expect_verb771=(($340+8272)&4294967295); //@line 1479 "translate.cpp"
            HEAP32[(($expect_verb771)>>2)]=0; //@line 1479 "translate.cpp"
            var $341=$tr_addr; //@line 1480 "translate.cpp"
            var $expect_noun=(($341+8284)&4294967295); //@line 1480 "translate.cpp"
            HEAP32[(($expect_noun)>>2)]=0; //@line 1480 "translate.cpp"
            ; //@line 1481 "translate.cpp"
          }
          else if (__label__ == 212) {
  
            var $arrayidx773=(($dictionary_flags+4)&4294967295); //@line 1483 "translate.cpp"
            var $342=HEAP32[(($arrayidx773)>>2)]; //@line 1483 "translate.cpp"
            var $and774=($342) & 1; //@line 1483 "translate.cpp"
            var $tobool775=((($and774))|0)!=0; //@line 1483 "translate.cpp"
            if ($tobool775) { __label__ = 213;; } else { __label__ = 214;; } //@line 1483 "translate.cpp"
            if (__label__ == 213) {
  
              var $343=$tr_addr; //@line 1486 "translate.cpp"
              var $expect_verb777=(($343+8272)&4294967295); //@line 1486 "translate.cpp"
              HEAP32[(($expect_verb777)>>2)]=2; //@line 1486 "translate.cpp"
              var $344=$tr_addr; //@line 1487 "translate.cpp"
              var $expect_verb_s778=(($344+8280)&4294967295); //@line 1487 "translate.cpp"
              HEAP32[(($expect_verb_s778)>>2)]=0; //@line 1487 "translate.cpp"
              var $345=$tr_addr; //@line 1488 "translate.cpp"
              var $expect_noun779=(($345+8284)&4294967295); //@line 1488 "translate.cpp"
              HEAP32[(($expect_noun779)>>2)]=0; //@line 1488 "translate.cpp"
              ; //@line 1489 "translate.cpp"
            }
            else if (__label__ == 214) {
  
              var $arrayidx781=(($dictionary_flags+4)&4294967295); //@line 1491 "translate.cpp"
              var $346=HEAP32[(($arrayidx781)>>2)]; //@line 1491 "translate.cpp"
              var $and782=($346) & 2; //@line 1491 "translate.cpp"
              var $tobool783=((($and782))|0)!=0; //@line 1491 "translate.cpp"
              if ($tobool783) { __label__ = 215;; } else { __label__ = 216;; } //@line 1491 "translate.cpp"
              if (__label__ == 215) {
  
                var $347=$tr_addr; //@line 1494 "translate.cpp"
                var $expect_verb785=(($347+8272)&4294967295); //@line 1494 "translate.cpp"
                HEAP32[(($expect_verb785)>>2)]=0; //@line 1494 "translate.cpp"
                var $348=$tr_addr; //@line 1495 "translate.cpp"
                var $expect_verb_s786=(($348+8280)&4294967295); //@line 1495 "translate.cpp"
                HEAP32[(($expect_verb_s786)>>2)]=2; //@line 1495 "translate.cpp"
                var $349=$tr_addr; //@line 1496 "translate.cpp"
                var $expect_past787=(($349+8276)&4294967295); //@line 1496 "translate.cpp"
                HEAP32[(($expect_past787)>>2)]=0; //@line 1496 "translate.cpp"
                var $350=$tr_addr; //@line 1497 "translate.cpp"
                var $expect_noun788=(($350+8284)&4294967295); //@line 1497 "translate.cpp"
                HEAP32[(($expect_noun788)>>2)]=0; //@line 1497 "translate.cpp"
                ; //@line 1498 "translate.cpp"
              }
              else if (__label__ == 216) {
  
                var $arrayidx790=(($dictionary_flags+4)&4294967295); //@line 1500 "translate.cpp"
                var $351=HEAP32[(($arrayidx790)>>2)]; //@line 1500 "translate.cpp"
                var $and791=($351) & 4; //@line 1500 "translate.cpp"
                var $tobool792=((($and791))|0)!=0; //@line 1500 "translate.cpp"
                if (!($tobool792)) { __label__ = 218;break $if_then770$$if_else772$298; } //@line 1500 "translate.cpp"
  
                var $352=$tr_addr; //@line 1503 "translate.cpp"
                var $expect_noun794=(($352+8284)&4294967295); //@line 1503 "translate.cpp"
                HEAP32[(($expect_noun794)>>2)]=2; //@line 1503 "translate.cpp"
                var $353=$tr_addr; //@line 1504 "translate.cpp"
                var $expect_verb795=(($353+8272)&4294967295); //@line 1504 "translate.cpp"
                HEAP32[(($expect_verb795)>>2)]=0; //@line 1504 "translate.cpp"
                var $354=$tr_addr; //@line 1505 "translate.cpp"
                var $expect_verb_s796=(($354+8280)&4294967295); //@line 1505 "translate.cpp"
                HEAP32[(($expect_verb_s796)>>2)]=0; //@line 1505 "translate.cpp"
                var $355=$tr_addr; //@line 1506 "translate.cpp"
                var $expect_past797=(($355+8276)&4294967295); //@line 1506 "translate.cpp"
                HEAP32[(($expect_past797)>>2)]=0; //@line 1506 "translate.cpp"
                ; //@line 1507 "translate.cpp"
              }
            }
          }
        } while(0);
  
        var $356=HEAP32[(($wordx)>>2)]; //@line 1509 "translate.cpp"
        var $arrayidx802=(($356)&4294967295); //@line 1509 "translate.cpp"
        var $357=HEAP8[($arrayidx802)]; //@line 1509 "translate.cpp"
        var $conv803=(tempInt=(($357)),(tempInt>=128?tempInt-256:tempInt)); //@line 1509 "translate.cpp"
        var $cmp804=((($conv803))|0)!=0; //@line 1509 "translate.cpp"
        if ($cmp804) { __label__ = 219;; } else { __label__ = 228;; } //@line 1509 "translate.cpp"
        $land_lhs_true805$$if_end834$309: do { 
          if (__label__ == 219) {
  
            var $arrayidx806=(($dictionary_flags+4)&4294967295); //@line 1509 "translate.cpp"
            var $358=HEAP32[(($arrayidx806)>>2)]; //@line 1509 "translate.cpp"
            var $and807=($358) & 256; //@line 1509 "translate.cpp"
            var $tobool808=((($and807))|0)!=0; //@line 1509 "translate.cpp"
            if ($tobool808) { __label__ = 228;break $land_lhs_true805$$if_end834$309; } //@line 1509 "translate.cpp"
  
            var $359=$tr_addr; //@line 1511 "translate.cpp"
            var $expect_verb810=(($359+8272)&4294967295); //@line 1511 "translate.cpp"
            var $360=HEAP32[(($expect_verb810)>>2)]; //@line 1511 "translate.cpp"
            var $cmp811=((($360))|0) > 0; //@line 1511 "translate.cpp"
            if ($cmp811) { __label__ = 221;; } else { __label__ = 222;; } //@line 1511 "translate.cpp"
            if (__label__ == 221) {
  
              var $361=$tr_addr; //@line 1512 "translate.cpp"
              var $expect_verb813=(($361+8272)&4294967295); //@line 1512 "translate.cpp"
              var $362=HEAP32[(($expect_verb813)>>2)]; //@line 1512 "translate.cpp"
              var $dec814=((($362)-1)&4294967295); //@line 1512 "translate.cpp"
              HEAP32[(($expect_verb813)>>2)]=$dec814; //@line 1512 "translate.cpp"
              ; //@line 1512 "translate.cpp"
            }
  
            var $363=$tr_addr; //@line 1514 "translate.cpp"
            var $expect_verb_s816=(($363+8280)&4294967295); //@line 1514 "translate.cpp"
            var $364=HEAP32[(($expect_verb_s816)>>2)]; //@line 1514 "translate.cpp"
            var $cmp817=((($364))|0) > 0; //@line 1514 "translate.cpp"
            if ($cmp817) { __label__ = 223;; } else { __label__ = 224;; } //@line 1514 "translate.cpp"
            if (__label__ == 223) {
  
              var $365=$tr_addr; //@line 1515 "translate.cpp"
              var $expect_verb_s819=(($365+8280)&4294967295); //@line 1515 "translate.cpp"
              var $366=HEAP32[(($expect_verb_s819)>>2)]; //@line 1515 "translate.cpp"
              var $dec820=((($366)-1)&4294967295); //@line 1515 "translate.cpp"
              HEAP32[(($expect_verb_s819)>>2)]=$dec820; //@line 1515 "translate.cpp"
              ; //@line 1515 "translate.cpp"
            }
  
            var $367=$tr_addr; //@line 1517 "translate.cpp"
            var $expect_noun822=(($367+8284)&4294967295); //@line 1517 "translate.cpp"
            var $368=HEAP32[(($expect_noun822)>>2)]; //@line 1517 "translate.cpp"
            var $cmp823=((($368))|0) > 0; //@line 1517 "translate.cpp"
            if ($cmp823) { __label__ = 225;; } else { __label__ = 226;; } //@line 1517 "translate.cpp"
            if (__label__ == 225) {
  
              var $369=$tr_addr; //@line 1518 "translate.cpp"
              var $expect_noun825=(($369+8284)&4294967295); //@line 1518 "translate.cpp"
              var $370=HEAP32[(($expect_noun825)>>2)]; //@line 1518 "translate.cpp"
              var $dec826=((($370)-1)&4294967295); //@line 1518 "translate.cpp"
              HEAP32[(($expect_noun825)>>2)]=$dec826; //@line 1518 "translate.cpp"
              ; //@line 1518 "translate.cpp"
            }
  
            var $371=$tr_addr; //@line 1520 "translate.cpp"
            var $expect_past828=(($371+8276)&4294967295); //@line 1520 "translate.cpp"
            var $372=HEAP32[(($expect_past828)>>2)]; //@line 1520 "translate.cpp"
            var $cmp829=((($372))|0) > 0; //@line 1520 "translate.cpp"
            if (!($cmp829)) { __label__ = 228;break $land_lhs_true805$$if_end834$309; } //@line 1520 "translate.cpp"
  
            var $373=$tr_addr; //@line 1521 "translate.cpp"
            var $expect_past831=(($373+8276)&4294967295); //@line 1521 "translate.cpp"
            var $374=HEAP32[(($expect_past831)>>2)]; //@line 1521 "translate.cpp"
            var $dec832=((($374)-1)&4294967295); //@line 1521 "translate.cpp"
            HEAP32[(($expect_past831)>>2)]=$dec832; //@line 1521 "translate.cpp"
            ; //@line 1521 "translate.cpp"
          }
        } while(0);
  
        var $375=$word_length; //@line 1524 "translate.cpp"
        var $cmp835=((($375))|0)==1; //@line 1524 "translate.cpp"
        if ($cmp835) { __label__ = 229;; } else { __label__ = 232;; } //@line 1524 "translate.cpp"
        $land_lhs_true836$$if_end846$323: do { 
          if (__label__ == 229) {
  
            var $376=$tr_addr; //@line 1524 "translate.cpp"
            var $translator_name=(($376+280)&4294967295); //@line 1524 "translate.cpp"
            var $377=HEAP32[(($translator_name)>>2)]; //@line 1524 "translate.cpp"
            var $cmp837=((($377))|0)==25966; //@line 1524 "translate.cpp"
            if (!($cmp837)) { __label__ = 232;break $land_lhs_true836$$if_end846$323; } //@line 1524 "translate.cpp"
  
            var $378=HEAP32[(($first_char)>>2)]; //@line 1524 "translate.cpp"
            var $call839=_iswalpha($378); //@line 1524 "translate.cpp"
            var $tobool840=((($call839))|0)!=0; //@line 1524 "translate.cpp"
            var $379=HEAP32[(($first_char)>>2)]; //@line 1524 "translate.cpp"
            var $cmp842=((($379))|0)!=105; //@line 1524 "translate.cpp"
            var $or_cond3=($tobool840) & ($cmp842); //@line 1524 "translate.cpp"
            if (!($or_cond3)) { __label__ = 232;break $land_lhs_true836$$if_end846$323; } //@line 1524 "translate.cpp"
  
            var $arrayidx844=(($dictionary_flags)&4294967295); //@line 1528 "translate.cpp"
            var $380=HEAP32[(($arrayidx844)>>2)]; //@line 1528 "translate.cpp"
            var $or845=($380) | 16777216; //@line 1528 "translate.cpp"
            HEAP32[(($arrayidx844)>>2)]=$or845; //@line 1528 "translate.cpp"
            ; //@line 1529 "translate.cpp"
          }
        } while(0);
  
        var $381=$tr_addr; //@line 1531 "translate.cpp"
        var $langopts847=(($381)&4294967295); //@line 1531 "translate.cpp"
        var $param848=(($langopts847+24)&4294967295); //@line 1531 "translate.cpp"
        var $arrayidx849=(($param848+60)&4294967295); //@line 1531 "translate.cpp"
        var $382=HEAP32[(($arrayidx849)>>2)]; //@line 1531 "translate.cpp"
        var $and850=($382) & 2; //@line 1531 "translate.cpp"
        var $tobool851=((($and850))|0)!=0; //@line 1531 "translate.cpp"
        if ($tobool851) { __label__ = 233;; } else { __label__ = 235;; } //@line 1531 "translate.cpp"
        $land_lhs_true852$$if_end858$328: do { 
          if (__label__ == 233) {
  
            var $arrayidx853=(($dictionary_flags)&4294967295); //@line 1531 "translate.cpp"
            var $383=HEAP32[(($arrayidx853)>>2)]; //@line 1531 "translate.cpp"
            var $and854=($383) & 3145728; //@line 1531 "translate.cpp"
            var $cmp855=((($and854))|0)!=0; //@line 1531 "translate.cpp"
            if (!($cmp855)) { __label__ = 235;break $land_lhs_true852$$if_end858$328; } //@line 1531 "translate.cpp"
  
            var $384=$tr_addr; //@line 1533 "translate.cpp"
            var $arrayidx857=(($dictionary_flags)&4294967295); //@line 1533 "translate.cpp"
            var $385=HEAP32[(($arrayidx857)>>2)]; //@line 1533 "translate.cpp"
            __Z22ApplySpecialAttribute2P10TranslatorPci($384, ((_word_phonemes)&4294967295), $385); //@line 1533 "translate.cpp"
            ; //@line 1534 "translate.cpp"
          }
        } while(0);
  
        var $386=$was_unpronouncable; //@line 1536 "translate.cpp"
        var $arrayidx859=(($dictionary_flags)&4294967295); //@line 1536 "translate.cpp"
        var $387=HEAP32[(($arrayidx859)>>2)]; //@line 1536 "translate.cpp"
        var $or860=($387) | ($386); //@line 1536 "translate.cpp"
        HEAP32[(($arrayidx859)>>2)]=$or860; //@line 1536 "translate.cpp"
        var $388=$word_start_addr; //@line 1537 "translate.cpp"
        var $arraydecay861=(($word_copy2)&4294967295); //@line 1537 "translate.cpp"
        var $389=$word_copy_length; //@line 1537 "translate.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $arraydecay861;
        $dest$ = $388;
        $stop$ = $src$ + $389;
        if (($dest$%4) == ($src$%4) && $389 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 1537 "translate.cpp"
        var $arrayidx862=(($dictionary_flags)&4294967295); //@line 1538 "translate.cpp"
        var $390=HEAP32[(($arrayidx862)>>2)]; //@line 1538 "translate.cpp"
        $retval=$390; //@line 1538 "translate.cpp"
        ; //@line 1538 "translate.cpp"
      }
    } while(0);
  
    var $391=$retval; //@line 1539 "translate.cpp"
    STACKTOP = __stackBase__;
    return $391; //@line 1539 "translate.cpp"
    return null;
  }
  

  function __ZL17CheckDottedAbbrevPcP8WORD_TAB($word1, $wtab) {
    var __stackBase__  = STACKTOP; STACKTOP += 84; _memset(__stackBase__, 0, 84);
    var __label__;
  
    var $word1_addr;
    var $wtab_addr;
    var $wc=__stackBase__;
    var $count;
    var $nbytes;
    var $ok;
    var $ix;
    var $word;
    var $wbuf;
    var $word_buf=__stackBase__+4;
    $word1_addr=$word1;
    $wtab_addr=$wtab;
    $count=0; //@line 628 "translate.cpp"
    var $0=$word1_addr; //@line 636 "translate.cpp"
    $word=$0; //@line 636 "translate.cpp"
    var $arraydecay=(($word_buf)&4294967295); //@line 637 "translate.cpp"
    $wbuf=$arraydecay; //@line 637 "translate.cpp"
    $ix=0; //@line 638 "translate.cpp"
    ; //@line 640 "translate.cpp"
    $for_cond$2: while(1) { 
  
      $ok=0; //@line 642 "translate.cpp"
      var $1=$word; //@line 643 "translate.cpp"
      var $call=__Z7utf8_inPiPKc($wc, $1); //@line 643 "translate.cpp"
      $nbytes=$call; //@line 643 "translate.cpp"
      var $2=$nbytes; //@line 644 "translate.cpp"
      var $3=$word; //@line 644 "translate.cpp"
      var $arrayidx=(($3+$2)&4294967295); //@line 644 "translate.cpp"
      var $4=HEAP8[($arrayidx)]; //@line 644 "translate.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 644 "translate.cpp"
      var $cmp=((($conv))|0)==32; //@line 644 "translate.cpp"
      if ($cmp) { __label__ = 2;; } else { __label__ = 11;; } //@line 644 "translate.cpp"
      $land_lhs_true$$if_end27$4: do { 
        if (__label__ == 2) {
  
          var $5=HEAP32[(($wc)>>2)]; //@line 644 "translate.cpp"
          var $call1=__Z7IsAlphaj($5); //@line 644 "translate.cpp"
          var $tobool=((($call1))|0)!=0; //@line 644 "translate.cpp"
          if (!($tobool)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 644 "translate.cpp"
  
          var $6=$nbytes; //@line 646 "translate.cpp"
          var $add=((($6)+1)&4294967295); //@line 646 "translate.cpp"
          var $7=$word; //@line 646 "translate.cpp"
          var $arrayidx2=(($7+$add)&4294967295); //@line 646 "translate.cpp"
          var $8=HEAP8[($arrayidx2)]; //@line 646 "translate.cpp"
          var $conv3=(tempInt=(($8)),(tempInt>=128?tempInt-256:tempInt)); //@line 646 "translate.cpp"
          var $cmp4=((($conv3))|0)==46; //@line 646 "translate.cpp"
          if ($cmp4) { __label__ = 4;; } else { __label__ = 8;; } //@line 646 "translate.cpp"
          if (__label__ == 4) {
  
            var $9=$nbytes; //@line 648 "translate.cpp"
            var $add6=((($9)+2)&4294967295); //@line 648 "translate.cpp"
            var $10=$word; //@line 648 "translate.cpp"
            var $arrayidx7=(($10+$add6)&4294967295); //@line 648 "translate.cpp"
            var $11=HEAP8[($arrayidx7)]; //@line 648 "translate.cpp"
            var $conv8=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 648 "translate.cpp"
            var $cmp9=((($conv8))|0)==32; //@line 648 "translate.cpp"
            if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 648 "translate.cpp"
            if (__label__ == 5) {
  
              $ok=1; //@line 649 "translate.cpp"
              __label__ = 12;break $land_lhs_true$$if_end27$4; //@line 649 "translate.cpp"
            }
            else if (__label__ == 6) {
  
              var $12=$nbytes; //@line 651 "translate.cpp"
              var $add11=((($12)+2)&4294967295); //@line 651 "translate.cpp"
              var $13=$word; //@line 651 "translate.cpp"
              var $arrayidx12=(($13+$add11)&4294967295); //@line 651 "translate.cpp"
              var $14=HEAP8[($arrayidx12)]; //@line 651 "translate.cpp"
              var $conv13=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 651 "translate.cpp"
              var $cmp14=((($conv13))|0)==39; //@line 651 "translate.cpp"
              if (!($cmp14)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 651 "translate.cpp"
  
              var $15=$nbytes; //@line 653 "translate.cpp"
              var $add16=((($15)+2)&4294967295); //@line 653 "translate.cpp"
              $nbytes=$add16; //@line 653 "translate.cpp"
              $ok=2; //@line 654 "translate.cpp"
              __label__ = 12;break $land_lhs_true$$if_end27$4; //@line 655 "translate.cpp"
            }
          }
          else if (__label__ == 8) {
  
            var $16=$count; //@line 658 "translate.cpp"
            var $cmp19=((($16))|0) > 0; //@line 658 "translate.cpp"
            if (!($cmp19)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 658 "translate.cpp"
  
            var $17=$nbytes; //@line 658 "translate.cpp"
            var $18=$word; //@line 658 "translate.cpp"
            var $arrayidx21=(($18+$17)&4294967295); //@line 658 "translate.cpp"
            var $19=HEAP8[($arrayidx21)]; //@line 658 "translate.cpp"
            var $conv22=(tempInt=(($19)),(tempInt>=128?tempInt-256:tempInt)); //@line 658 "translate.cpp"
            var $cmp23=((($conv22))|0)==32; //@line 658 "translate.cpp"
            if (!($cmp23)) { __label__ = 11;break $land_lhs_true$$if_end27$4; } //@line 658 "translate.cpp"
  
            $ok=2; //@line 659 "translate.cpp"
            __label__ = 12;break $land_lhs_true$$if_end27$4; //@line 659 "translate.cpp"
          }
        }
      } while(0);
      if (__label__ == 11) {
  
        var $_pr=$ok; //@line 662 "translate.cpp"
        var $cmp28=((($_pr))|0)==0; //@line 662 "translate.cpp"
        if ($cmp28) { __label__ = 17;break $for_cond$2; } //@line 662 "translate.cpp"
      }
  
      $ix=0; //@line 665 "translate.cpp"
      var $20=$ix; //@line 665 "translate.cpp"
      var $21=$nbytes; //@line 665 "translate.cpp"
      var $cmp324=((($20))|0) < ((($21))|0); //@line 665 "translate.cpp"
      if ($cmp324) { __label__ = 13;; } else { __label__ = 14;; } //@line 665 "translate.cpp"
      $for_body$$for_end$19: do { 
        if (__label__ == 13) {
          while(1) { 
  
            var $22=$ix; //@line 666 "translate.cpp"
            var $23=$word; //@line 666 "translate.cpp"
            var $arrayidx33=(($23+$22)&4294967295); //@line 666 "translate.cpp"
            var $24=HEAP8[($arrayidx33)]; //@line 666 "translate.cpp"
            var $25=$wbuf; //@line 666 "translate.cpp"
            var $incdec_ptr=(($25+1)&4294967295); //@line 666 "translate.cpp"
            $wbuf=$incdec_ptr; //@line 666 "translate.cpp"
            HEAP8[($25)]=$24; //@line 666 "translate.cpp"
            var $26=$ix; //@line 665 "translate.cpp"
            var $inc=((($26)+1)&4294967295); //@line 665 "translate.cpp"
            $ix=$inc; //@line 665 "translate.cpp"
            var $27=$ix; //@line 665 "translate.cpp"
            var $28=$nbytes; //@line 665 "translate.cpp"
            var $cmp32=((($27))|0) < ((($28))|0); //@line 665 "translate.cpp"
            if ($cmp32) { __label__ = 13;continue ; } else { __label__ = 14;break $for_body$$for_end$19; } //@line 665 "translate.cpp"
          }
        }
      } while(0);
  
      var $29=$count; //@line 668 "translate.cpp"
      var $inc34=((($29)+1)&4294967295); //@line 668 "translate.cpp"
      $count=$inc34; //@line 668 "translate.cpp"
      var $30=$ok; //@line 670 "translate.cpp"
      var $cmp35=((($30))|0)==2; //@line 670 "translate.cpp"
      var $31=$nbytes; //@line 672 "translate.cpp"
      if ($cmp35) { __label__ = 15;break $for_cond$2; } //@line 670 "translate.cpp"
  
      var $add38=((($31)+3)&4294967295); //@line 676 "translate.cpp"
      var $33=$word; //@line 676 "translate.cpp"
      var $add_ptr39=(($33+$add38)&4294967295); //@line 676 "translate.cpp"
      $word=$add_ptr39; //@line 676 "translate.cpp"
      __label__ = 1;continue $for_cond$2; //@line 677 "translate.cpp"
    }
    if (__label__ == 15) {
  
      var $32=$word; //@line 672 "translate.cpp"
      var $add_ptr=(($32+$31)&4294967295); //@line 672 "translate.cpp"
      $word=$add_ptr; //@line 672 "translate.cpp"
      ; //@line 673 "translate.cpp"
    }
  
    var $34=$count; //@line 679 "translate.cpp"
    var $cmp41=((($34))|0) > 1; //@line 679 "translate.cpp"
    if ($cmp41) { __label__ = 18;; } else { __label__ = 21;; } //@line 679 "translate.cpp"
    if (__label__ == 18) {
  
      var $35=$wbuf; //@line 681 "translate.cpp"
      var $arraydecay43=(($word_buf)&4294967295); //@line 681 "translate.cpp"
      var $sub_ptr_lhs_cast=($35); //@line 681 "translate.cpp"
      var $sub_ptr_rhs_cast=($arraydecay43); //@line 681 "translate.cpp"
      var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 681 "translate.cpp"
      $ix=$sub_ptr_sub; //@line 681 "translate.cpp"
      var $36=$word1_addr; //@line 682 "translate.cpp"
      var $arraydecay44=(($word_buf)&4294967295); //@line 682 "translate.cpp"
      var $37=$ix; //@line 682 "translate.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $arraydecay44;
      $dest$ = $36;
      $stop$ = $src$ + $37;
      if (($dest$%4) == ($src$%4) && $37 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 682 "translate.cpp"
      var $38=$ix; //@line 683 "translate.cpp"
      var $39=$word1_addr; //@line 683 "translate.cpp"
      var $arrayidx452=(($39+$38)&4294967295); //@line 683 "translate.cpp"
      var $40=$word; //@line 683 "translate.cpp"
      var $cmp463=((($arrayidx452))>>>0) < ((($40))>>>0); //@line 683 "translate.cpp"
      if ($cmp463) { __label__ = 19;; } else { __label__ = 20;; } //@line 683 "translate.cpp"
      $while_body$$while_end$29: do { 
        if (__label__ == 19) {
          while(1) { 
  
            var $41=$ix; //@line 684 "translate.cpp"
            var $inc47=((($41)+1)&4294967295); //@line 684 "translate.cpp"
            $ix=$inc47; //@line 684 "translate.cpp"
            var $42=$word1_addr; //@line 684 "translate.cpp"
            var $arrayidx48=(($42+$41)&4294967295); //@line 684 "translate.cpp"
            HEAP8[($arrayidx48)]=32; //@line 684 "translate.cpp"
            var $43=$ix; //@line 683 "translate.cpp"
            var $44=$word1_addr; //@line 683 "translate.cpp"
            var $arrayidx45=(($44+$43)&4294967295); //@line 683 "translate.cpp"
            var $45=$word; //@line 683 "translate.cpp"
            var $cmp46=((($arrayidx45))>>>0) < ((($45))>>>0); //@line 683 "translate.cpp"
            if ($cmp46) { __label__ = 19;continue ; } else { __label__ = 20;break $while_body$$while_end$29; } //@line 683 "translate.cpp"
          }
        }
      } while(0);
  
      var $46=$count; //@line 685 "translate.cpp"
      var $sub=((($46)-1)&4294967295); //@line 685 "translate.cpp"
      var $mul=((($sub)*2)&4294967295); //@line 685 "translate.cpp"
      HEAP32[((_dictionary_skipwords)>>2)]=$mul; //@line 685 "translate.cpp"
      ; //@line 686 "translate.cpp"
    }
  
    var $47=$count; //@line 687 "translate.cpp"
    STACKTOP = __stackBase__;
    return $47; //@line 687 "translate.cpp"
    return null;
  }
  

  function __ZL22SpeakIndividualLettersP10TranslatorPcS1_i($tr, $word, $phonemes, $spell_word) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $phonemes_addr;
    var $spell_word_addr;
    var $posn;
    var $capitals;
    var $non_initial;
    $tr_addr=$tr;
    $word_addr=$word;
    $phonemes_addr=$phonemes;
    $spell_word_addr=$spell_word;
    $posn=0; //@line 600 "translate.cpp"
    $capitals=0; //@line 601 "translate.cpp"
    $non_initial=0; //@line 602 "translate.cpp"
    var $0=$spell_word_addr; //@line 604 "translate.cpp"
    var $cmp=((($0))|0) > 2; //@line 604 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 604 "translate.cpp"
    if (__label__ == 1) {
  
      $capitals=2; //@line 605 "translate.cpp"
      ; //@line 605 "translate.cpp"
    }
    $while_cond$4: while(1) { 
  
      var $1=$word_addr; //@line 607 "translate.cpp"
      var $2=HEAP8[($1)]; //@line 607 "translate.cpp"
      var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 607 "translate.cpp"
      var $cmp1=((($conv))|0)!=32; //@line 607 "translate.cpp"
      if (!($cmp1)) { __label__ = 3;break $while_cond$4; } //@line 607 "translate.cpp"
  
      var $4=$word_addr; //@line 607 "translate.cpp"
      var $5=HEAP8[($4)]; //@line 607 "translate.cpp"
      var $conv2=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 607 "translate.cpp"
      var $cmp3=((($conv2))|0)!=0; //@line 607 "translate.cpp"
      var $6=$tr_addr; //@line 609 "translate.cpp"
      if ($cmp3) { __lastLabel__ = 4; ; } else { __lastLabel__ = 4; __label__ = 7;break $while_cond$4; }
  
      var $7=$word_addr; //@line 609 "translate.cpp"
      var $8=$phonemes_addr; //@line 609 "translate.cpp"
      var $9=$capitals; //@line 609 "translate.cpp"
      var $10=$non_initial; //@line 609 "translate.cpp"
      var $or=($10) | ($9); //@line 609 "translate.cpp"
      var $call=__Z15TranslateLetterP10TranslatorPcS1_i($6, $7, $8, $or); //@line 609 "translate.cpp"
      var $11=$word_addr; //@line 609 "translate.cpp"
      var $add_ptr=(($11+$call)&4294967295); //@line 609 "translate.cpp"
      $word_addr=$add_ptr; //@line 609 "translate.cpp"
      var $12=$posn; //@line 610 "translate.cpp"
      var $inc=((($12)+1)&4294967295); //@line 610 "translate.cpp"
      $posn=$inc; //@line 610 "translate.cpp"
      $non_initial=1; //@line 611 "translate.cpp"
      var $13=$phonemes_addr; //@line 612 "translate.cpp"
      var $arrayidx=(($13)&4294967295); //@line 612 "translate.cpp"
      var $14=HEAP8[($arrayidx)]; //@line 612 "translate.cpp"
      var $conv4=(tempInt=(($14)),(tempInt>=128?tempInt-256:tempInt)); //@line 612 "translate.cpp"
      var $cmp5=((($conv4))|0)==21; //@line 612 "translate.cpp"
      if ($cmp5) { __label__ = 6;break $while_cond$4; } else { __label__ = 2;continue $while_cond$4; } //@line 612 "translate.cpp"
    }
    $land_end_thread$$while_end$$if_then6$8: do { 
      if (__label__ == 3) {
  
        var $3=$tr_addr; //@line 609 "translate.cpp"
        __lastLabel__ = 3; __label__ = 7;break $land_end_thread$$while_end$$if_then6$8;
      }
      else if (__label__ == 6) {
  
        var $15=$phonemes_addr; //@line 615 "translate.cpp"
        var $call7=_strcpy(((_word_phonemes)&4294967295), $15); //@line 615 "translate.cpp"
        $retval=0; //@line 616 "translate.cpp"
        __label__ = 8;break $land_end_thread$$while_end$$if_then6$8; //@line 616 "translate.cpp"
      }
    } while(0);
    if (__label__ == 7) {
  
      var $16=__lastLabel__ == 3 ? $3 : ($6);
      var $17=$phonemes_addr; //@line 619 "translate.cpp"
      var $18=$spell_word_addr; //@line 619 "translate.cpp"
      var $19=$posn; //@line 619 "translate.cpp"
      __Z17SetSpellingStressP10TranslatorPcii($16, $17, $18, $19); //@line 619 "translate.cpp"
      var $20=$word_addr; //@line 620 "translate.cpp"
      $retval=$20; //@line 620 "translate.cpp"
      ; //@line 620 "translate.cpp"
    }
  
    var $21=$retval; //@line 621 "translate.cpp"
    ;
    return $21; //@line 621 "translate.cpp"
    return null;
  }
  

  function __Z14SetTranslator2PKc($new_language) {
    ;
    var __label__;
  
    var $new_language_addr;
    var $new_phoneme_tab;
    $new_language_addr=$new_language;
    var $0=$new_language_addr; //@line 1571 "translate.cpp"
    var $call=__Z22SelectPhonemeTableNamePKc($0); //@line 1571 "translate.cpp"
    $new_phoneme_tab=$call; //@line 1571 "translate.cpp"
    var $cmp=((($call))|0) >= 0; //@line 1571 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 1571 "translate.cpp"
    $if_then$$if_end14$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_translator2)>>2)]; //@line 1573 "translate.cpp"
        var $cmp1=((($1))|0)!=0; //@line 1573 "translate.cpp"
        if ($cmp1) { __label__ = 2;; } else { __label__ = 5;; } //@line 1573 "translate.cpp"
        if (__label__ == 2) {
  
          var $2=$new_language_addr; //@line 1573 "translate.cpp"
          var $call2=_strcmp($2, ((__ZL20translator2_language)&4294967295)); //@line 1573 "translate.cpp"
          var $cmp3=((($call2))|0)!=0; //@line 1573 "translate.cpp"
          var $3=HEAP32[((_translator2)>>2)]; //@line 1576 "translate.cpp"
          if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 1573 "translate.cpp"
          if (__label__ == 3) {
  
            __Z16DeleteTranslatorP10Translator($3); //@line 1576 "translate.cpp"
            HEAP32[((_translator2)>>2)]=0; //@line 1577 "translate.cpp"
            ; //@line 1578 "translate.cpp"
          }
          else if (__label__ == 4) {
  
            var $cmp5=((($3))|0)==0; //@line 1580 "translate.cpp"
            if (!($cmp5)) { __label__ = 7;break $if_then$$if_end14$2; } //@line 1580 "translate.cpp"
          }
        }
  
        var $4=$new_language_addr; //@line 1582 "translate.cpp"
        var $call7=__Z16SelectTranslatorPKc($4); //@line 1582 "translate.cpp"
        HEAP32[((_translator2)>>2)]=$call7; //@line 1582 "translate.cpp"
        var $5=$new_language_addr; //@line 1583 "translate.cpp"
        var $call8=_strcpy(((__ZL20translator2_language)&4294967295), $5); //@line 1583 "translate.cpp"
        var $6=HEAP32[((_translator2)>>2)]; //@line 1585 "translate.cpp"
        var $7=$new_language_addr; //@line 1585 "translate.cpp"
        var $call9=__Z14LoadDictionaryP10TranslatorPKci($6, $7, 0); //@line 1585 "translate.cpp"
        var $cmp10=((($call9))|0)!=0; //@line 1585 "translate.cpp"
        if (!($cmp10)) { __label__ = 7;break $if_then$$if_end14$2; } //@line 1585 "translate.cpp"
  
        var $8=HEAP32[((_voice)>>2)]; //@line 1587 "translate.cpp"
        var $phoneme_tab_ix=(($8+40)&4294967295); //@line 1587 "translate.cpp"
        var $9=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 1587 "translate.cpp"
        __Z18SelectPhonemeTablei($9); //@line 1587 "translate.cpp"
        $new_phoneme_tab=-1; //@line 1588 "translate.cpp"
        HEAP8[(((__ZL20translator2_language)&4294967295))]=0; //@line 1589 "translate.cpp"
        ; //@line 1590 "translate.cpp"
      }
    } while(0);
  
    var $10=$new_phoneme_tab; //@line 1593 "translate.cpp"
    ;
    return $10; //@line 1593 "translate.cpp"
    return null;
  }
  

  function __Z15TranslateClauseP10TranslatorP7__sFILEPKvPiPPc($tr, $f_text, $vp_input, $tone_out, $voice_change) {
    var __stackBase__  = STACKTOP; STACKTOP += 6500; _memset(__stackBase__, 0, 6500);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $f_text_addr;
    var $vp_input_addr;
    var $tone_out_addr;
    var $voice_change_addr;
    var $ix;
    var $c;
    var $cc=__stackBase__;
    var $source_index=__stackBase__+4;
    var $prev_source_index;
    var $source_index_word;
    var $prev_in=__stackBase__+8;
    var $prev_out=__stackBase__+12;
    var $prev_out2;
    var $prev_in2;
    var $prev_in_save;
    var $next_in=__stackBase__+16;
    var $next_in_nbytes;
    var $char_inserted=__stackBase__+20;
    var $clause_pause;
    var $pre_pause_add;
    var $word_mark;
    var $all_upper_case;
    var $finished;
    var $single_quoted;
    var $phoneme_mode;
    var $dict_flags;
    var $word_flags;
    var $next_word_flags;
    var $embedded_count;
    var $letter_count;
    var $space_inserted;
    var $syllable_marked;
    var $decimal_sep_count;
    var $word;
    var $p;
    var $j;
    var $k;
    var $n_digits;
    var $individual_digits;
    var $charix_top=__stackBase__+24;
    var $charix=__stackBase__+28;
    var $words=__stackBase__+1436;
    var $word_count;
    var $sbuf=__stackBase__+5036;
    var $terminator;
    var $tone;
    var $tone2=__stackBase__+5736;
    var $srcix;
    var $next2_in=__stackBase__+5740;
    var $nx;
    var $c_temp=__stackBase__+5744;
    var $pn;
    var $pw;
    var $nw;
    var $number_buf=__stackBase__+5748;
    var $num_wtab=__stackBase__+5900;
    var $p2;
    $tr_addr=$tr;
    $f_text_addr=$f_text;
    $vp_input_addr=$vp_input;
    $tone_out_addr=$tone_out;
    $voice_change_addr=$voice_change;
    HEAP32[(($source_index)>>2)]=0; //@line 2344 "translate.cpp"
    $prev_source_index=0; //@line 2345 "translate.cpp"
    $source_index_word=0; //@line 2346 "translate.cpp"
    HEAP32[(($prev_out)>>2)]=32; //@line 2348 "translate.cpp"
    $prev_in2=0; //@line 2350 "translate.cpp"
    $prev_in_save=0; //@line 2351 "translate.cpp"
    HEAP32[(($char_inserted)>>2)]=0; //@line 2354 "translate.cpp"
    $pre_pause_add=0; //@line 2356 "translate.cpp"
    $word_mark=0; //@line 2357 "translate.cpp"
    $all_upper_case=1; //@line 2358 "translate.cpp"
    $phoneme_mode=0; //@line 2361 "translate.cpp"
    $dict_flags=0; //@line 2362 "translate.cpp"
    $embedded_count=0; //@line 2365 "translate.cpp"
    $letter_count=0; //@line 2366 "translate.cpp"
    $space_inserted=0; //@line 2367 "translate.cpp"
    $syllable_marked=0; //@line 2368 "translate.cpp"
    $decimal_sep_count=0; //@line 2369 "translate.cpp"
    HEAP32[(($charix_top)>>2)]=0; //@line 2375 "translate.cpp"
    $word_count=0; //@line 2380 "translate.cpp"
    var $0=$tr_addr; //@line 2388 "translate.cpp"
    var $cmp=((($0))|0)==0; //@line 2388 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2388 "translate.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=0; //@line 2390 "translate.cpp"
        ; //@line 2390 "translate.cpp"
      }
      else if (__label__ == 2) {
  
        var $1=$vp_input_addr; //@line 2393 "translate.cpp"
        HEAP32[((_p_textinput)>>2)]=$1; //@line 2393 "translate.cpp"
        var $2=$vp_input_addr; //@line 2394 "translate.cpp"
        var $3=$2; //@line 2394 "translate.cpp"
        HEAP32[((_p_wchar_input)>>2)]=$3; //@line 2394 "translate.cpp"
        HEAP32[((__ZL11embedded_ix)>>2)]=0; //@line 2396 "translate.cpp"
        HEAP32[((__ZL13embedded_read)>>2)]=0; //@line 2397 "translate.cpp"
        HEAP32[((_pre_pause)>>2)]=0; //@line 2398 "translate.cpp"
        HEAP8[(__ZL18any_stressed_words_b)]=0;
        var $4=HEAP32[((_count_characters)>>2)]; //@line 2401 "translate.cpp"
        HEAP32[((_clause_start_char)>>2)]=$4; //@line 2401 "translate.cpp"
        var $cmp1=((($4))|0) < 0; //@line 2401 "translate.cpp"
        if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 2401 "translate.cpp"
        if (__label__ == 3) {
  
          HEAP32[((_clause_start_char)>>2)]=0; //@line 2402 "translate.cpp"
          ; //@line 2402 "translate.cpp"
        }
  
        var $5=HEAP32[((_count_words)>>2)]; //@line 2403 "translate.cpp"
        var $add=((($5)+1)&4294967295); //@line 2403 "translate.cpp"
        HEAP32[((_clause_start_word)>>2)]=$add; //@line 2403 "translate.cpp"
        $ix=0; //@line 2405 "translate.cpp"
        ; //@line 2405 "translate.cpp"
        $for_body$8: while(1) { 
  
          var $6=$ix; //@line 2406 "translate.cpp"
          var $arrayidx=(($charix+$6*2)&4294967295); //@line 2406 "translate.cpp"
          HEAP16[(($arrayidx)>>1)]=0; //@line 2406 "translate.cpp"
          var $7=$ix; //@line 2405 "translate.cpp"
          var $inc=((($7)+1)&4294967295); //@line 2405 "translate.cpp"
          $ix=$inc; //@line 2405 "translate.cpp"
          var $cmp4=((($inc))|0) < 700; //@line 2405 "translate.cpp"
          if ($cmp4) { __label__ = 5;continue $for_body$8; } else { __label__ = 6;break $for_body$8; } //@line 2405 "translate.cpp"
        }
  
        var $8=$tr_addr; //@line 2407 "translate.cpp"
        var $9=$f_text_addr; //@line 2407 "translate.cpp"
        var $arraydecay=(($charix)&4294967295); //@line 2407 "translate.cpp"
        var $call=__Z10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_($8, $9, ((__ZL6source)&4294967295), $arraydecay, $charix_top, 700, $tone2, ((__ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name)&4294967295)); //@line 2407 "translate.cpp"
        $terminator=$call; //@line 2407 "translate.cpp"
        var $10=HEAP32[((_f_logespeak)>>2)]; //@line 2409 "translate.cpp"
        var $cmp5=((($10))|0)!=0; //@line 2409 "translate.cpp"
        if ($cmp5) { __label__ = 7;; } else { __label__ = 11;; } //@line 2409 "translate.cpp"
        $land_lhs_true$$if_end17$11: do { 
          if (__label__ == 7) {
  
            var $11=HEAP32[((_logging_type)>>2)]; //@line 2409 "translate.cpp"
            var $and=($11) & 4; //@line 2409 "translate.cpp"
            var $tobool=((($and))|0)!=0; //@line 2409 "translate.cpp"
            if (!($tobool)) { __label__ = 11;break $land_lhs_true$$if_end17$11; } //@line 2409 "translate.cpp"
  
            var $12=HEAP32[((_f_logespeak)>>2)]; //@line 2411 "translate.cpp"
            var $13=$terminator; //@line 2411 "translate.cpp"
            var $call7=_fprintf($12, ((__str7550)&4294967295), allocate([$13,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 2411 "translate.cpp"
            $p=((__ZL6source)&4294967295); //@line 2412 "translate.cpp"
            var $14=$p; //@line 2412 "translate.cpp"
            var $15=HEAP8[($14)]; //@line 2412 "translate.cpp"
            var $conv59=(tempInt=(($15)),(tempInt>=128?tempInt-256:tempInt)); //@line 2412 "translate.cpp"
            var $cmp960=((($conv59))|0)!=0; //@line 2412 "translate.cpp"
            if ($cmp960) { __label__ = 9;; } else { __label__ = 10;; } //@line 2412 "translate.cpp"
            $for_body10$$for_end14$14: do { 
              if (__label__ == 9) {
                while(1) { 
  
                  var $16=$p; //@line 2413 "translate.cpp"
                  var $17=HEAP8[($16)]; //@line 2413 "translate.cpp"
                  var $conv11=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 2413 "translate.cpp"
                  var $18=HEAP32[((_f_logespeak)>>2)]; //@line 2413 "translate.cpp"
                  var $call12=_fputc($conv11, $18); //@line 2413 "translate.cpp"
                  var $19=$p; //@line 2412 "translate.cpp"
                  var $incdec_ptr=(($19+1)&4294967295); //@line 2412 "translate.cpp"
                  $p=$incdec_ptr; //@line 2412 "translate.cpp"
                  var $20=$p; //@line 2412 "translate.cpp"
                  var $21=HEAP8[($20)]; //@line 2412 "translate.cpp"
                  var $conv=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 2412 "translate.cpp"
                  var $cmp9=((($conv))|0)!=0; //@line 2412 "translate.cpp"
                  if ($cmp9) { __label__ = 9;continue ; } else { __label__ = 10;break $for_body10$$for_end14$14; } //@line 2412 "translate.cpp"
                }
              }
            } while(0);
  
            var $22=HEAP32[((_f_logespeak)>>2)]; //@line 2414 "translate.cpp"
            var $23=_fwrite(((__str8551)&4294967295), 10, 1, $22); //@line 2414 "translate.cpp"
            var $24=HEAP32[((_f_logespeak)>>2)]; //@line 2415 "translate.cpp"
            var $call16=_fflush($24); //@line 2415 "translate.cpp"
            ; //@line 2416 "translate.cpp"
          }
        } while(0);
  
        $p=((__ZL6source)&4294967295); //@line 2417 "translate.cpp"
        var $25=HEAP32[(($charix_top)>>2)]; //@line 2419 "translate.cpp"
        var $add18=((($25)+1)&4294967295); //@line 2419 "translate.cpp"
        var $arrayidx19=(($charix+$add18*2)&4294967295); //@line 2419 "translate.cpp"
        HEAP16[(($arrayidx19)>>1)]=0; //@line 2419 "translate.cpp"
        var $26=HEAP32[(($charix_top)>>2)]; //@line 2420 "translate.cpp"
        var $add20=((($26)+2)&4294967295); //@line 2420 "translate.cpp"
        var $arrayidx21=(($charix+$add20*2)&4294967295); //@line 2420 "translate.cpp"
        HEAP16[(($arrayidx21)>>1)]=32767; //@line 2420 "translate.cpp"
        var $27=HEAP32[(($charix_top)>>2)]; //@line 2421 "translate.cpp"
        var $add22=((($27)+3)&4294967295); //@line 2421 "translate.cpp"
        var $arrayidx23=(($charix+$add22*2)&4294967295); //@line 2421 "translate.cpp"
        HEAP16[(($arrayidx23)>>1)]=0; //@line 2421 "translate.cpp"
        var $28=$terminator; //@line 2423 "translate.cpp"
        var $and24=($28) & 4095; //@line 2423 "translate.cpp"
        var $mul=((($and24)*10)&4294967295); //@line 2423 "translate.cpp"
        $clause_pause=$mul; //@line 2423 "translate.cpp"
        var $29=$terminator; //@line 2424 "translate.cpp"
        var $shr=($29) >> 12; //@line 2424 "translate.cpp"
        var $and25=($shr) & 7; //@line 2424 "translate.cpp"
        $tone=$and25; //@line 2424 "translate.cpp"
        var $30=HEAP32[(($tone2)>>2)]; //@line 2425 "translate.cpp"
        var $cmp26=((($30))|0)!=0; //@line 2425 "translate.cpp"
        if ($cmp26) { __label__ = 12;; } else { __label__ = 13;; } //@line 2425 "translate.cpp"
        if (__label__ == 12) {
  
          var $31=HEAP32[(($tone2)>>2)]; //@line 2428 "translate.cpp"
          $tone=$31; //@line 2428 "translate.cpp"
          ; //@line 2429 "translate.cpp"
        }
  
        $p=((__ZL6source)&4294967295); //@line 2431 "translate.cpp"
        ; //@line 2431 "translate.cpp"
        $for_cond29$22: while(1) { 
  
          var $32=$p; //@line 2431 "translate.cpp"
          var $33=HEAP8[($32)]; //@line 2431 "translate.cpp"
          var $conv30=(tempInt=(($33)),(tempInt>=128?tempInt-256:tempInt)); //@line 2431 "translate.cpp"
          var $cmp31=((($conv30))|0)!=0; //@line 2431 "translate.cpp"
          if (!($cmp31)) { __label__ = 17;break $for_cond29$22; } //@line 2431 "translate.cpp"
  
          var $34=$p; //@line 2433 "translate.cpp"
          var $35=HEAP8[($34)]; //@line 2433 "translate.cpp"
          var $conv33=(tempInt=(($35)),(tempInt>=128?tempInt-256:tempInt)); //@line 2433 "translate.cpp"
          var $call34=__Z8isspace2j($conv33); //@line 2433 "translate.cpp"
          var $tobool35=((($call34))|0)!=0; //@line 2433 "translate.cpp"
          if (!($tobool35)) { __label__ = 17;break $for_cond29$22; } //@line 2433 "translate.cpp"
  
          var $36=$p; //@line 2431 "translate.cpp"
          var $incdec_ptr39=(($36+1)&4294967295); //@line 2431 "translate.cpp"
          $p=$incdec_ptr39; //@line 2431 "translate.cpp"
          __label__ = 14;continue $for_cond29$22; //@line 2431 "translate.cpp"
        }
  
        var $37=$p; //@line 2438 "translate.cpp"
        var $38=HEAP8[($37)]; //@line 2438 "translate.cpp"
        var $conv41=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 2438 "translate.cpp"
        var $cmp42=((($conv41))|0)==0; //@line 2438 "translate.cpp"
        if ($cmp42) { __label__ = 18;; } else { __label__ = 21;; } //@line 2438 "translate.cpp"
        if (__label__ == 18) {
  
          var $39=HEAP32[((__ZL16max_clause_pause)>>2)]; //@line 2442 "translate.cpp"
          var $40=$clause_pause; //@line 2442 "translate.cpp"
          var $sub=((($40)-($39))&4294967295); //@line 2442 "translate.cpp"
          $clause_pause=$sub; //@line 2442 "translate.cpp"
          var $41=$clause_pause; //@line 2443 "translate.cpp"
          var $cmp44=((($41))|0) < 0; //@line 2443 "translate.cpp"
          if ($cmp44) { __label__ = 19;; } else { __label__ = 20;; } //@line 2443 "translate.cpp"
          if (__label__ == 19) {
  
            $clause_pause=0; //@line 2444 "translate.cpp"
            ; //@line 2444 "translate.cpp"
          }
  
          var $42=$terminator; //@line 2446 "translate.cpp"
          var $and47=($42) & -524289; //@line 2446 "translate.cpp"
          $terminator=$and47; //@line 2446 "translate.cpp"
          var $43=$clause_pause; //@line 2447 "translate.cpp"
          var $44=HEAP32[((__ZL16max_clause_pause)>>2)]; //@line 2447 "translate.cpp"
          var $add48=((($44)+($43))&4294967295); //@line 2447 "translate.cpp"
          HEAP32[((__ZL16max_clause_pause)>>2)]=$add48; //@line 2447 "translate.cpp"
          ; //@line 2448 "translate.cpp"
        }
        else if (__label__ == 21) {
  
          var $45=$clause_pause; //@line 2451 "translate.cpp"
          HEAP32[((__ZL16max_clause_pause)>>2)]=$45; //@line 2451 "translate.cpp"
          ;
        }
  
        var $46=$terminator; //@line 2453 "translate.cpp"
        var $47=$tr_addr; //@line 2453 "translate.cpp"
        var $clause_terminator=(($47+8324)&4294967295); //@line 2453 "translate.cpp"
        HEAP32[(($clause_terminator)>>2)]=$46; //@line 2453 "translate.cpp"
        var $48=HEAP32[((_new_sentence)>>2)]; //@line 2455 "translate.cpp"
        var $tobool50=((($48))|0)!=0; //@line 2455 "translate.cpp"
        if ($tobool50) { __label__ = 23;; } else { __label__ = 26;; } //@line 2455 "translate.cpp"
        $if_then51$$if_end59$34: do { 
          if (__label__ == 23) {
  
            var $49=HEAP32[((_count_sentences)>>2)]; //@line 2457 "translate.cpp"
            var $inc52=((($49)+1)&4294967295); //@line 2457 "translate.cpp"
            HEAP32[((_count_sentences)>>2)]=$inc52; //@line 2457 "translate.cpp"
            var $50=HEAP32[((_skip_sentences)>>2)]; //@line 2458 "translate.cpp"
            var $cmp53=((($50))|0) > 0; //@line 2458 "translate.cpp"
            if (!($cmp53)) { __label__ = 26;break $if_then51$$if_end59$34; } //@line 2458 "translate.cpp"
  
            var $51=HEAP32[((_skip_sentences)>>2)]; //@line 2460 "translate.cpp"
            var $dec=((($51)-1)&4294967295); //@line 2460 "translate.cpp"
            HEAP32[((_skip_sentences)>>2)]=$dec; //@line 2460 "translate.cpp"
            var $52=HEAP32[((_skip_sentences)>>2)]; //@line 2461 "translate.cpp"
            var $cmp55=((($52))|0)==0; //@line 2461 "translate.cpp"
            if (!($cmp55)) { __label__ = 26;break $if_then51$$if_end59$34; } //@line 2461 "translate.cpp"
  
            HEAP32[((_skipping_text)>>2)]=0; //@line 2462 "translate.cpp"
            ; //@line 2462 "translate.cpp"
          }
        } while(0);
  
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = ((_ph_list2)&4294967295);
        $stop$ = $dest$ + 8;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 2466 "translate.cpp"
        HEAP8[(((_ph_list2)&4294967295))]=10; //@line 2467 "translate.cpp"
        HEAP32[((_n_ph_list2)>>2)]=1; //@line 2469 "translate.cpp"
        var $53=$tr_addr; //@line 2470 "translate.cpp"
        var $prev_last_stress=(($53+8288)&4294967295); //@line 2470 "translate.cpp"
        HEAP32[(($prev_last_stress)>>2)]=0; //@line 2470 "translate.cpp"
        var $54=$tr_addr; //@line 2471 "translate.cpp"
        var $prepause_timeout=(($54+8312)&4294967295); //@line 2471 "translate.cpp"
        HEAP32[(($prepause_timeout)>>2)]=0; //@line 2471 "translate.cpp"
        var $55=$tr_addr; //@line 2472 "translate.cpp"
        var $expect_verb=(($55+8272)&4294967295); //@line 2472 "translate.cpp"
        HEAP32[(($expect_verb)>>2)]=0; //@line 2472 "translate.cpp"
        var $56=$tr_addr; //@line 2473 "translate.cpp"
        var $expect_noun=(($56+8284)&4294967295); //@line 2473 "translate.cpp"
        HEAP32[(($expect_noun)>>2)]=0; //@line 2473 "translate.cpp"
        var $57=$tr_addr; //@line 2474 "translate.cpp"
        var $expect_past=(($57+8276)&4294967295); //@line 2474 "translate.cpp"
        HEAP32[(($expect_past)>>2)]=0; //@line 2474 "translate.cpp"
        var $58=$tr_addr; //@line 2475 "translate.cpp"
        var $expect_verb_s=(($58+8280)&4294967295); //@line 2475 "translate.cpp"
        HEAP32[(($expect_verb_s)>>2)]=0; //@line 2475 "translate.cpp"
        var $59=$tr_addr; //@line 2476 "translate.cpp"
        var $phonemes_repeat_count=(($59+652)&4294967295); //@line 2476 "translate.cpp"
        HEAP32[(($phonemes_repeat_count)>>2)]=0; //@line 2476 "translate.cpp"
        var $60=$tr_addr; //@line 2477 "translate.cpp"
        var $end_stressed_vowel=(($60+8316)&4294967295); //@line 2477 "translate.cpp"
        HEAP32[(($end_stressed_vowel)>>2)]=0; //@line 2477 "translate.cpp"
        var $61=$tr_addr; //@line 2478 "translate.cpp"
        var $prev_dict_flags=(($61+8320)&4294967295); //@line 2478 "translate.cpp"
        HEAP32[(($prev_dict_flags)>>2)]=0; //@line 2478 "translate.cpp"
        $word_count=0; //@line 2480 "translate.cpp"
        $single_quoted=0; //@line 2481 "translate.cpp"
        $word_flags=0; //@line 2482 "translate.cpp"
        $next_word_flags=0; //@line 2483 "translate.cpp"
        var $arrayidx60=(($sbuf)&4294967295); //@line 2485 "translate.cpp"
        HEAP8[($arrayidx60)]=0; //@line 2485 "translate.cpp"
        var $arrayidx61=(($sbuf+1)&4294967295); //@line 2486 "translate.cpp"
        HEAP8[($arrayidx61)]=32; //@line 2486 "translate.cpp"
        var $arrayidx62=(($sbuf+2)&4294967295); //@line 2487 "translate.cpp"
        HEAP8[($arrayidx62)]=32; //@line 2487 "translate.cpp"
        $ix=3; //@line 2488 "translate.cpp"
        HEAP32[(($prev_in)>>2)]=32; //@line 2489 "translate.cpp"
        var $62=$ix; //@line 2491 "translate.cpp"
        var $conv63=((($62)) & 65535); //@line 2491 "translate.cpp"
        var $arrayidx64=(($words)&4294967295); //@line 2491 "translate.cpp"
        var $start=(($arrayidx64+4)&4294967295); //@line 2491 "translate.cpp"
        HEAP16[(($start)>>1)]=$conv63; //@line 2491 "translate.cpp"
        var $arrayidx65=(($words)&4294967295); //@line 2492 "translate.cpp"
        var $flags=(($arrayidx65)&4294967295); //@line 2492 "translate.cpp"
        HEAP32[(($flags)>>2)]=0; //@line 2492 "translate.cpp"
        $finished=0; //@line 2493 "translate.cpp"
        $j=0; //@line 2495 "translate.cpp"
        var $63=$j; //@line 2495 "translate.cpp"
        var $arrayidx6755=(($charix+$63*2)&4294967295); //@line 2495 "translate.cpp"
        var $64=HEAP16[(($arrayidx6755)>>1)]; //@line 2495 "translate.cpp"
        var $conv6856=(tempInt=(($64)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2495 "translate.cpp"
        var $cmp6957=((($conv6856))|0) <= 0; //@line 2495 "translate.cpp"
        var $65=$j; //@line 2495 "translate.cpp"
        if ($cmp6957) { __lastLabel__ = 26; __label__ = 27;; } else { __lastLabel__ = 26; __label__ = 28;; } //@line 2495 "translate.cpp"
        $for_inc71$$for_end73$39: do { 
          if (__label__ == 27) {
            while(1) { 
  
              var $66=__lastLabel__ == 27 ? $69 : ($65);
              var $inc72=((($66)+1)&4294967295); //@line 2495 "translate.cpp"
              $j=$inc72; //@line 2495 "translate.cpp"
              var $67=$j; //@line 2495 "translate.cpp"
              var $arrayidx67=(($charix+$67*2)&4294967295); //@line 2495 "translate.cpp"
              var $68=HEAP16[(($arrayidx67)>>1)]; //@line 2495 "translate.cpp"
              var $conv68=(tempInt=(($68)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2495 "translate.cpp"
              var $cmp69=((($conv68))|0) <= 0; //@line 2495 "translate.cpp"
              var $69=$j; //@line 2495 "translate.cpp"
              if ($cmp69) { __lastLabel__ = 27; __label__ = 27;continue ; } else { __lastLabel__ = 27; __label__ = 28;break $for_inc71$$for_end73$39; } //@line 2495 "translate.cpp"
            }
          }
        } while(0);
  
        var $_lcssa54=__lastLabel__ == 26 ? $65 : ($69);
        var $arrayidx74=(($charix+$_lcssa54*2)&4294967295); //@line 2496 "translate.cpp"
        var $70=HEAP16[(($arrayidx74)>>1)]; //@line 2496 "translate.cpp"
        var $arrayidx75=(($words)&4294967295); //@line 2496 "translate.cpp"
        var $sourceix=(($arrayidx75+6)&4294967295); //@line 2496 "translate.cpp"
        HEAP16[(($sourceix)>>1)]=$70; //@line 2496 "translate.cpp"
        $k=0; //@line 2497 "translate.cpp"
        var $71=$j; //@line 2498 "translate.cpp"
        var $arrayidx7651=(($charix+$71*2)&4294967295); //@line 2498 "translate.cpp"
        var $72=HEAP16[(($arrayidx7651)>>1)]; //@line 2498 "translate.cpp"
        var $conv7752=(tempInt=(($72)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2498 "translate.cpp"
        var $cmp7853=((($conv7752))|0)!=0; //@line 2498 "translate.cpp"
        if ($cmp7853) { __label__ = 29;; } else { __label__ = 32;; } //@line 2498 "translate.cpp"
        $while_body$$while_end$43: do { 
          if (__label__ == 29) {
            while(1) { 
  
              var $73=$j; //@line 2501 "translate.cpp"
              var $inc79=((($73)+1)&4294967295); //@line 2501 "translate.cpp"
              $j=$inc79; //@line 2501 "translate.cpp"
              var $arrayidx80=(($charix+$73*2)&4294967295); //@line 2501 "translate.cpp"
              var $74=HEAP16[(($arrayidx80)>>1)]; //@line 2501 "translate.cpp"
              var $conv81=(tempInt=(($74)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2501 "translate.cpp"
              var $cmp82=((($conv81))|0)!=-1; //@line 2501 "translate.cpp"
              if ($cmp82) { __label__ = 30;; } else { __label__ = 31;; } //@line 2501 "translate.cpp"
              if (__label__ == 30) {
  
                var $75=$k; //@line 2502 "translate.cpp"
                var $inc84=((($75)+1)&4294967295); //@line 2502 "translate.cpp"
                $k=$inc84; //@line 2502 "translate.cpp"
                ; //@line 2502 "translate.cpp"
              }
  
              var $76=$j; //@line 2498 "translate.cpp"
              var $arrayidx76=(($charix+$76*2)&4294967295); //@line 2498 "translate.cpp"
              var $77=HEAP16[(($arrayidx76)>>1)]; //@line 2498 "translate.cpp"
              var $conv77=(tempInt=(($77)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2498 "translate.cpp"
              var $cmp78=((($conv77))|0)!=0; //@line 2498 "translate.cpp"
              if ($cmp78) { __label__ = 29;continue ; } else { __label__ = 32;break $while_body$$while_end$43; } //@line 2498 "translate.cpp"
            }
          }
        } while(0);
  
        var $78=$k; //@line 2504 "translate.cpp"
        var $conv86=((($78)) & 255); //@line 2504 "translate.cpp"
        var $arrayidx87=(($words)&4294967295); //@line 2504 "translate.cpp"
        var $length=(($arrayidx87+10)&4294967295); //@line 2504 "translate.cpp"
        HEAP8[($length)]=$conv86; //@line 2504 "translate.cpp"
        ; //@line 2506 "translate.cpp"
        $while_cond88$50: while(1) { 
  
          var $79=$finished; //@line 2506 "translate.cpp"
          var $tobool89=((($79))|0)!=0; //@line 2506 "translate.cpp"
          if ($tobool89) { __label__ = 230;break $while_cond88$50; } //@line 2506 "translate.cpp"
  
          var $80=$ix; //@line 2506 "translate.cpp"
          var $cmp91=((($80))|0) < 700; //@line 2506 "translate.cpp"
          var $81=HEAP32[((_n_ph_list2)>>2)]; //@line 2506 "translate.cpp"
          var $cmp92=((($81))|0) < 996; //@line 2506 "translate.cpp"
          var $or_cond12=($cmp91) & ($cmp92); //@line 2506 "translate.cpp"
          if (!($or_cond12)) { __label__ = 230;break $while_cond88$50; } //@line 2506 "translate.cpp"
  
          var $82=HEAP32[(($prev_out)>>2)]; //@line 2508 "translate.cpp"
          $prev_out2=$82; //@line 2508 "translate.cpp"
          var $83=$ix; //@line 2509 "translate.cpp"
          var $sub94=((($83)-1)&4294967295); //@line 2509 "translate.cpp"
          var $arrayidx95=(($sbuf+$sub94)&4294967295); //@line 2509 "translate.cpp"
          var $call96=__Z8utf8_in2PiPKci($prev_out, $arrayidx95, 1); //@line 2509 "translate.cpp"
          var $84=$tr_addr; //@line 2511 "translate.cpp"
          var $langopts=(($84)&4294967295); //@line 2511 "translate.cpp"
          var $tone_numbers=(($langopts+250)&4294967295); //@line 2511 "translate.cpp"
          var $85=HEAP8[($tone_numbers)]; //@line 2511 "translate.cpp"
          var $tobool97=(tempInt=(($85)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2511 "translate.cpp"
          if ($tobool97) { __label__ = 36;; } else { __label__ = 39;; } //@line 2511 "translate.cpp"
          $land_lhs_true98$$if_end105$54: do { 
            if (__label__ == 36) {
  
              var $86=HEAP32[(($prev_out)>>2)]; //@line 2511 "translate.cpp"
              var $call99=__ZL9IsDigit09j($86); //@line 2511 "translate.cpp"
              var $tobool100=((($call99))|0)!=0; //@line 2511 "translate.cpp"
              if (!($tobool100)) { __label__ = 39;break $land_lhs_true98$$if_end105$54; } //@line 2511 "translate.cpp"
  
              var $87=$prev_out2; //@line 2511 "translate.cpp"
              var $call102=__Z7IsAlphaj($87); //@line 2511 "translate.cpp"
              var $tobool103=((($call102))|0)!=0; //@line 2511 "translate.cpp"
              if (!($tobool103)) { __label__ = 39;break $land_lhs_true98$$if_end105$54; } //@line 2511 "translate.cpp"
  
              HEAP32[(($prev_out)>>2)]=97; //@line 2514 "translate.cpp"
              ; //@line 2515 "translate.cpp"
            }
          } while(0);
  
          var $88=$prev_in_save; //@line 2517 "translate.cpp"
          var $cmp106=((($88))|0)!=0; //@line 2517 "translate.cpp"
          if ($cmp106) { __label__ = 40;; } else { __label__ = 41;; } //@line 2517 "translate.cpp"
          $if_then107$$if_else108$59: do { 
            if (__label__ == 40) {
  
              var $89=$prev_in_save; //@line 2519 "translate.cpp"
              HEAP32[(($prev_in)>>2)]=$89; //@line 2519 "translate.cpp"
              $prev_in_save=0; //@line 2520 "translate.cpp"
              ; //@line 2521 "translate.cpp"
            }
            else if (__label__ == 41) {
  
              var $90=HEAPU32[(($source_index)>>2)]; //@line 2523 "translate.cpp"
              var $cmp109=((($90))>>>0) > 0; //@line 2523 "translate.cpp"
              if (!($cmp109)) { __label__ = 43;break $if_then107$$if_else108$59; } //@line 2523 "translate.cpp"
  
              var $91=HEAP32[(($prev_in)>>2)]; //@line 2525 "translate.cpp"
              $prev_in2=$91; //@line 2525 "translate.cpp"
              var $92=HEAP32[(($source_index)>>2)]; //@line 2526 "translate.cpp"
              var $sub111=((($92)-1)&4294967295); //@line 2526 "translate.cpp"
              var $arrayidx112=((__ZL6source+$sub111)&4294967295); //@line 2526 "translate.cpp"
              var $call113=__Z8utf8_in2PiPKci($prev_in, $arrayidx112, 1); //@line 2526 "translate.cpp"
              ; //@line 2527 "translate.cpp"
            }
          } while(0);
  
          var $93=HEAP32[(($source_index)>>2)]; //@line 2529 "translate.cpp"
          $prev_source_index=$93; //@line 2529 "translate.cpp"
          var $94=HEAP32[(($char_inserted)>>2)]; //@line 2531 "translate.cpp"
          var $tobool116=((($94))|0)!=0; //@line 2531 "translate.cpp"
          if ($tobool116) { __label__ = 44;; } else { __label__ = 45;; } //@line 2531 "translate.cpp"
          if (__label__ == 44) {
  
            var $95=HEAP32[(($char_inserted)>>2)]; //@line 2533 "translate.cpp"
            $c=$95; //@line 2533 "translate.cpp"
            HEAP32[(($char_inserted)>>2)]=0; //@line 2534 "translate.cpp"
            ; //@line 2535 "translate.cpp"
          }
          else if (__label__ == 45) {
  
            var $96=HEAP32[(($source_index)>>2)]; //@line 2538 "translate.cpp"
            var $arrayidx119=((__ZL6source+$96)&4294967295); //@line 2538 "translate.cpp"
            var $call120=__Z7utf8_inPiPKc($cc, $arrayidx119); //@line 2538 "translate.cpp"
            var $97=HEAP32[(($source_index)>>2)]; //@line 2538 "translate.cpp"
            var $add121=((($97)+($call120))&4294967295); //@line 2538 "translate.cpp"
            HEAP32[(($source_index)>>2)]=$add121; //@line 2538 "translate.cpp"
            var $98=HEAP32[(($cc)>>2)]; //@line 2539 "translate.cpp"
            $c=$98; //@line 2539 "translate.cpp"
            ;
          }
  
          var $99=HEAP32[(($source_index)>>2)]; //@line 2541 "translate.cpp"
          var $arrayidx123=((__ZL6source+$99)&4294967295); //@line 2541 "translate.cpp"
          var $call124=__Z7utf8_inPiPKc($next_in, $arrayidx123); //@line 2541 "translate.cpp"
          $next_in_nbytes=$call124; //@line 2541 "translate.cpp"
          var $100=$c; //@line 2543 "translate.cpp"
          if ($100 == 0) {
            __label__ = 47;;
          }
          else if ($100 == 1) {
            __label__ = 49;;
          }
          else {
          __label__ = 48;;
          }
          
          $lor_lhs_false$$if_end127_thread$$if_then131$68: do { 
            if (__label__ == 47) {
  
              $finished=1; //@line 2545 "translate.cpp"
              $c=32; //@line 2546 "translate.cpp"
              __label__ = 48;break $lor_lhs_false$$if_end127_thread$$if_then131$68; //@line 2549 "translate.cpp"
            }
          } while(0);
          $lor_lhs_false$$if_then131$70: do { 
            if (__label__ == 48) {
  
              var $101=$c; //@line 2549 "translate.cpp"
              var $102=HEAP8[(_ctrl_embedded)]; //@line 2549 "translate.cpp"
              var $conv129=(tempInt=(($102)),(tempInt>=128?tempInt-256:tempInt)); //@line 2549 "translate.cpp"
              var $cmp130=((($101))|0)==((($conv129))|0); //@line 2549 "translate.cpp"
              if ($cmp130) { __label__ = 49;break $lor_lhs_false$$if_then131$70; } else { __label__ = 52;break $lor_lhs_false$$if_then131$70; } //@line 2549 "translate.cpp"
            }
          } while(0);
          if (__label__ == 49) {
  
            var $103=HEAP32[(($source_index)>>2)]; //@line 2552 "translate.cpp"
            var $sub132=((($103)-1)&4294967295); //@line 2552 "translate.cpp"
            $srcix=$sub132; //@line 2552 "translate.cpp"
            var $104=HEAP32[(($prev_in)>>2)]; //@line 2554 "translate.cpp"
            var $cmp133=((($104))|0)!=32; //@line 2554 "translate.cpp"
            if ($cmp133) { __label__ = 50;; } else { __label__ = 51;; } //@line 2554 "translate.cpp"
            if (__label__ == 50) {
  
              $c=32; //@line 2556 "translate.cpp"
              var $105=$c; //@line 2557 "translate.cpp"
              $prev_in_save=$105; //@line 2557 "translate.cpp"
              var $106=HEAP32[(($source_index)>>2)]; //@line 2558 "translate.cpp"
              var $dec135=((($106)-1)&4294967295); //@line 2558 "translate.cpp"
              HEAP32[(($source_index)>>2)]=$dec135; //@line 2558 "translate.cpp"
              ; //@line 2569 "translate.cpp"
            }
            else if (__label__ == 51) {
  
              var $call137=__ZL15EmbeddedCommandRj($source_index); //@line 2562 "translate.cpp"
              var $107=$embedded_count; //@line 2562 "translate.cpp"
              var $add138=((($107)+($call137))&4294967295); //@line 2562 "translate.cpp"
              $embedded_count=$add138; //@line 2562 "translate.cpp"
              var $108=HEAP32[(($prev_in)>>2)]; //@line 2563 "translate.cpp"
              $prev_in_save=$108; //@line 2563 "translate.cpp"
              var $109=$srcix; //@line 2565 "translate.cpp"
              var $arrayidx139=((__ZL6source+$109)&4294967295); //@line 2565 "translate.cpp"
              var $110=HEAP32[(($source_index)>>2)]; //@line 2565 "translate.cpp"
              var $111=$srcix; //@line 2565 "translate.cpp"
              var $sub140=((($110)-($111))&4294967295); //@line 2565 "translate.cpp"
              var $dest$, $stop$, $stop4$, $fast$, $value4$;
              $dest$ = $arrayidx139;
              $stop$ = $dest$ + $sub140;
              $value4$ = 32;
              if ($value4$ < 0) $value4$ += 256;
              $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
              while ($dest$%4 !== 0 && $dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 32;
              }
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($dest$ < $stop4$) {
              ;;;;;;;  HEAP32[$dest$++] = $value4$;
              }
              $dest$ <<= 2;
              while ($dest$ < $stop$) {
                ;; HEAP8[$dest$++] = 32;
              }; //@line 2565 "translate.cpp"
              var $112=$srcix; //@line 2566 "translate.cpp"
              HEAP32[(($source_index)>>2)]=$112; //@line 2566 "translate.cpp"
              __label__ = 33;continue $while_cond88$50; //@line 2567 "translate.cpp"
            }
          }
  
          var $113=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2571 "translate.cpp"
          var $cmp143=((($113))|0)==36; //@line 2571 "translate.cpp"
          if ($cmp143) { __label__ = 53;; } else { __label__ = 58;; } //@line 2571 "translate.cpp"
          $land_lhs_true144$$if_end153$78: do { 
            if (__label__ == 53) {
  
              var $114=$c; //@line 2571 "translate.cpp"
              var $cmp145=((($114))|0)!=32; //@line 2571 "translate.cpp"
              if (!($cmp145)) { __label__ = 58;break $land_lhs_true144$$if_end153$78; } //@line 2571 "translate.cpp"
  
              var $115=HEAP32[(($prev_in)>>2)]; //@line 2573 "translate.cpp"
              var $cmp147=((($115))|0)==32; //@line 2573 "translate.cpp"
              if ($cmp147) { __label__ = 55;; } else { __label__ = 57;; } //@line 2573 "translate.cpp"
              $land_lhs_true148$$if_end151$81: do { 
                if (__label__ == 55) {
  
                  var $116=HEAP32[(($next_in)>>2)]; //@line 2573 "translate.cpp"
                  var $cmp149=((($116))|0)==32; //@line 2573 "translate.cpp"
                  if (!($cmp149)) { __label__ = 57;break $land_lhs_true148$$if_end151$81; } //@line 2573 "translate.cpp"
  
                  HEAP32[((__ZL13option_sayas2)>>2)]=20; //@line 2574 "translate.cpp"
                  ; //@line 2574 "translate.cpp"
                }
              } while(0);
  
              var $117=$c; //@line 2575 "translate.cpp"
              var $call152=__Z9towlower2j($117); //@line 2575 "translate.cpp"
              $c=$call152; //@line 2575 "translate.cpp"
              ; //@line 2576 "translate.cpp"
            }
          } while(0);
  
          var $118=$phoneme_mode; //@line 2579 "translate.cpp"
          var $tobool154=((($118))|0)!=0; //@line 2579 "translate.cpp"
          if ($tobool154) { __label__ = 59;; } else { __label__ = 62;; } //@line 2579 "translate.cpp"
          $if_then155$$if_else162$86: do { 
            if (__label__ == 59) {
  
              $all_upper_case=8; //@line 2581 "translate.cpp"
              var $119=$c; //@line 2583 "translate.cpp"
              var $cmp156=((($119))|0)==93; //@line 2583 "translate.cpp"
              if (!($cmp156)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2583 "translate.cpp"
  
              var $120=HEAP32[(($next_in)>>2)]; //@line 2583 "translate.cpp"
              var $cmp158=((($120))|0)==93; //@line 2583 "translate.cpp"
              if (!($cmp158)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2583 "translate.cpp"
  
              $phoneme_mode=0; //@line 2585 "translate.cpp"
              var $121=HEAP32[(($source_index)>>2)]; //@line 2586 "translate.cpp"
              var $inc160=((($121)+1)&4294967295); //@line 2586 "translate.cpp"
              HEAP32[(($source_index)>>2)]=$inc160; //@line 2586 "translate.cpp"
              $c=32; //@line 2587 "translate.cpp"
              ; //@line 2588 "translate.cpp"
            }
            else if (__label__ == 62) {
  
              var $122=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2591 "translate.cpp"
              var $and163=($122) & 240; //@line 2591 "translate.cpp"
              var $cmp164=((($and163))|0)==64; //@line 2591 "translate.cpp"
              if ($cmp164) { __label__ = 63;; } else { __label__ = 68;; } //@line 2591 "translate.cpp"
              if (__label__ == 63) {
  
                var $123=$c; //@line 2593 "translate.cpp"
                var $call166=_iswdigit($123); //@line 2593 "translate.cpp"
                var $tobool167=((($call166))|0)!=0; //@line 2593 "translate.cpp"
                if ($tobool167) { __label__ = 64;; } else { __label__ = 66;; } //@line 2593 "translate.cpp"
                if (__label__ == 64) {
  
                  var $124=HEAP32[((__ZL18count_sayas_digits)>>2)]; //@line 2595 "translate.cpp"
                  var $inc169=((($124)+1)&4294967295); //@line 2595 "translate.cpp"
                  HEAP32[((__ZL18count_sayas_digits)>>2)]=$inc169; //@line 2595 "translate.cpp"
                  var $125=HEAP32[((__ZL18count_sayas_digits)>>2)]; //@line 2596 "translate.cpp"
                  var $126=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2596 "translate.cpp"
                  var $and170=($126) & 15; //@line 2596 "translate.cpp"
                  var $cmp171=((($125))|0) > ((($and170))|0); //@line 2596 "translate.cpp"
                  if (!($cmp171)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2596 "translate.cpp"
  
                  $c=32; //@line 2599 "translate.cpp"
                  $space_inserted=1; //@line 2600 "translate.cpp"
                  HEAP32[((__ZL18count_sayas_digits)>>2)]=0; //@line 2601 "translate.cpp"
                  ; //@line 2602 "translate.cpp"
                }
                else if (__label__ == 66) {
  
                  HEAP32[((__ZL18count_sayas_digits)>>2)]=0; //@line 2606 "translate.cpp"
                  var $127=HEAP32[(($prev_out)>>2)]; //@line 2607 "translate.cpp"
                  var $call175=_iswdigit($127); //@line 2607 "translate.cpp"
                  var $tobool176=((($call175))|0)!=0; //@line 2607 "translate.cpp"
                  if (!($tobool176)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2607 "translate.cpp"
  
                  $c=32; //@line 2609 "translate.cpp"
                  $space_inserted=1; //@line 2610 "translate.cpp"
                  ; //@line 2611 "translate.cpp"
                }
              }
              else if (__label__ == 68) {
  
                var $128=HEAP32[((__ZL13option_sayas2)>>2)]; //@line 2615 "translate.cpp"
                var $and181=($128) & 16; //@line 2615 "translate.cpp"
                var $cmp182=((($and181))|0)==0; //@line 2615 "translate.cpp"
                if (!($cmp182)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2615 "translate.cpp"
  
                var $129=$c; //@line 2628 "translate.cpp"
                var $cmp184=((($129))|0)==146; //@line 2628 "translate.cpp"
                var $130=$c; //@line 2628 "translate.cpp"
                var $cmp186=((($130))|0)==180; //@line 2628 "translate.cpp"
                var $or_cond=($cmp184) | ($cmp186); //@line 2628 "translate.cpp"
                var $131=$c; //@line 2628 "translate.cpp"
                var $cmp188=((($131))|0)==8217; //@line 2628 "translate.cpp"
                var $or_cond2=($or_cond) | ($cmp188); //@line 2628 "translate.cpp"
                var $132=$c; //@line 2628 "translate.cpp"
                var $cmp190=((($132))|0)==8242; //@line 2628 "translate.cpp"
                var $or_cond3=($or_cond2) | ($cmp190); //@line 2628 "translate.cpp"
                if ($or_cond3) { __label__ = 70;; } else { __label__ = 71;; } //@line 2628 "translate.cpp"
                if (__label__ == 70) {
  
                  $c=39; //@line 2629 "translate.cpp"
                  ; //@line 2629 "translate.cpp"
                }
  
                var $133=$c; //@line 2631 "translate.cpp"
                var $cmp193=((($133))|0)==8216; //@line 2631 "translate.cpp"
                var $134=$c; //@line 2631 "translate.cpp"
                var $cmp195=((($134))|0)==63; //@line 2631 "translate.cpp"
                var $or_cond4=($cmp193) | ($cmp195); //@line 2631 "translate.cpp"
                if ($or_cond4) { __lastLabel__ = 71; __label__ = 72;; } else { __lastLabel__ = 71; __label__ = 76;; } //@line 2631 "translate.cpp"
                $land_lhs_true196$$if_end203$103: do { 
                  if (__label__ == 72) {
  
                    var $135=HEAP32[(($prev_out)>>2)]; //@line 2631 "translate.cpp"
                    var $call197=__Z7IsAlphaj($135); //@line 2631 "translate.cpp"
                    var $tobool198=((($call197))|0)!=0; //@line 2631 "translate.cpp"
                    if ($tobool198) { __label__ = 73;; } else { __label__ = 75;; } //@line 2631 "translate.cpp"
                    $land_lhs_true199$$if_end203thread_pre_split$105: do { 
                      if (__label__ == 73) {
  
                        var $136=HEAP32[(($next_in)>>2)]; //@line 2631 "translate.cpp"
                        var $call200=__Z7IsAlphaj($136); //@line 2631 "translate.cpp"
                        var $tobool201=((($call200))|0)!=0; //@line 2631 "translate.cpp"
                        if (!($tobool201)) { __label__ = 75;break $land_lhs_true199$$if_end203thread_pre_split$105; } //@line 2631 "translate.cpp"
  
                        $c=39; //@line 2634 "translate.cpp"
                        __label__ = 80;break $land_lhs_true196$$if_end203$103; //@line 2644 "translate.cpp"
                      }
                    } while(0);
  
                    var $_pr=$c; //@line 2637 "translate.cpp"
                    __lastLabel__ = 75; __label__ = 76;break $land_lhs_true196$$if_end203$103;
                  }
                } while(0);
                $if_end210$$if_end203$109: do { 
                  if (__label__ == 76) {
  
                    var $137=__lastLabel__ == 75 ? $_pr : ($134); //@line 2637 "translate.cpp"
                    var $cmp204=((($137))|0)==1328; //@line 2637 "translate.cpp"
                    if ($cmp204) { __label__ = 77;; } else { __label__ = 78;; } //@line 2637 "translate.cpp"
                    if (__label__ == 77) {
  
                      $c=32; //@line 2640 "translate.cpp"
                      var $138=$word_flags; //@line 2641 "translate.cpp"
                      var $or=($138) | 1024; //@line 2641 "translate.cpp"
                      $word_flags=$or; //@line 2641 "translate.cpp"
                      ; //@line 2644 "translate.cpp"
                    }
                    else if (__label__ == 78) {
  
                      var $_pr15_pr=$c; //@line 2644 "translate.cpp"
                      var $cmp207=((($_pr15_pr))|0)==1367; //@line 2644 "translate.cpp"
                      if (!($cmp207)) { __label__ = 80;break $if_end210$$if_end203$109; } //@line 2644 "translate.cpp"
  
                      $c=32; //@line 2646 "translate.cpp"
                      var $139=$word_flags; //@line 2647 "translate.cpp"
                      var $or209=($139) | 131072; //@line 2647 "translate.cpp"
                      $word_flags=$or209; //@line 2647 "translate.cpp"
                      ; //@line 2648 "translate.cpp"
                    }
                  }
                } while(0);
  
                var $140=$tr_addr; //@line 2650 "translate.cpp"
                var $141=HEAP32[(($source_index)>>2)]; //@line 2650 "translate.cpp"
                var $arrayidx211=((__ZL6source+$141)&4294967295); //@line 2650 "translate.cpp"
                var $142=HEAP32[(($prev_in)>>2)]; //@line 2650 "translate.cpp"
                var $143=$c; //@line 2650 "translate.cpp"
                var $144=HEAP32[(($next_in)>>2)]; //@line 2650 "translate.cpp"
                var $call212=__ZL13TranslateCharP10TranslatorPcijjPi($140, $arrayidx211, $142, $143, $144, $char_inserted); //@line 2650 "translate.cpp"
                $c=$call212; //@line 2650 "translate.cpp"
                var $cmp213=((($call212))|0)==8; //@line 2651 "translate.cpp"
                if ($cmp213) { __label__ = 33;continue $while_cond88$50; } //@line 2651 "translate.cpp"
  
                var $145=HEAP32[(($char_inserted)>>2)]; //@line 2654 "translate.cpp"
                var $tobool216=((($145))|0)!=0; //@line 2654 "translate.cpp"
                if ($tobool216) { __label__ = 82;; } else { __label__ = 83;; } //@line 2654 "translate.cpp"
                if (__label__ == 82) {
  
                  var $146=HEAP32[(($char_inserted)>>2)]; //@line 2655 "translate.cpp"
                  HEAP32[(($next_in)>>2)]=$146; //@line 2655 "translate.cpp"
                  ; //@line 2655 "translate.cpp"
                }
  
                var $147=$c; //@line 2658 "translate.cpp"
                var $call219=__Z7IsAlphaj($147); //@line 2658 "translate.cpp"
                var $tobool220=((($call219))|0)!=0; //@line 2658 "translate.cpp"
                if ($tobool220) { __label__ = 91;; } else { __label__ = 84;; } //@line 2658 "translate.cpp"
                $if_end244$$land_lhs_true221$120: do { 
                  if (__label__ == 84) {
  
                    var $148=$c; //@line 2658 "translate.cpp"
                    var $call222=__Z7IsSpacej($148); //@line 2658 "translate.cpp"
                    var $tobool223=((($call222))|0)!=0; //@line 2658 "translate.cpp"
                    if ($tobool223) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2658 "translate.cpp"
  
                    var $149=$tr_addr; //@line 2658 "translate.cpp"
                    var $punct_within_word=(($149+704)&4294967295); //@line 2658 "translate.cpp"
                    var $150=HEAP32[(($punct_within_word)>>2)]; //@line 2658 "translate.cpp"
                    var $151=$c; //@line 2658 "translate.cpp"
                    var $call225=_wcschr($150, $151); //@line 2658 "translate.cpp"
                    var $cmp226=((($call225))|0)==0; //@line 2658 "translate.cpp"
                    if (!($cmp226)) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2658 "translate.cpp"
  
                    var $152=HEAP32[(($prev_out)>>2)]; //@line 2660 "translate.cpp"
                    var $call228=__Z7IsAlphaj($152); //@line 2660 "translate.cpp"
                    var $tobool229=((($call228))|0)!=0; //@line 2660 "translate.cpp"
                    if (!($tobool229)) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2660 "translate.cpp"
  
                    var $153=$tr_addr; //@line 2662 "translate.cpp"
                    var $langopts231=(($153)&4294967295); //@line 2662 "translate.cpp"
                    var $tone_numbers232=(($langopts231+250)&4294967295); //@line 2662 "translate.cpp"
                    var $154=HEAP8[($tone_numbers232)]; //@line 2662 "translate.cpp"
                    var $tobool233=(tempInt=(($154)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2662 "translate.cpp"
                    if ($tobool233) { __label__ = 88;; } else { __label__ = 90;; } //@line 2662 "translate.cpp"
                    $land_lhs_true234$$if_else241$125: do { 
                      if (__label__ == 88) {
  
                        var $155=$c; //@line 2662 "translate.cpp"
                        var $call235=__ZL9IsDigit09j($155); //@line 2662 "translate.cpp"
                        var $tobool236=((($call235))|0)!=0; //@line 2662 "translate.cpp"
                        if (!($tobool236)) { __label__ = 90;break $land_lhs_true234$$if_else241$125; } //@line 2662 "translate.cpp"
  
                        var $156=HEAP32[(($next_in)>>2)]; //@line 2662 "translate.cpp"
                        var $call238=__ZL9IsDigit09j($156); //@line 2662 "translate.cpp"
                        var $tobool239=((($call238))|0)!=0; //@line 2662 "translate.cpp"
                        if (!($tobool239)) { __label__ = 91;break $if_end244$$land_lhs_true221$120; } //@line 2662 "translate.cpp"
                      }
                    } while(0);
  
                    $c=32; //@line 2668 "translate.cpp"
                    $space_inserted=1; //@line 2669 "translate.cpp"
                    ;
                  }
                } while(0);
  
                var $157=HEAP32[(($prev_out)>>2)]; //@line 2674 "translate.cpp"
                var $call245=_iswdigit($157); //@line 2674 "translate.cpp"
                var $tobool246=((($call245))|0)!=0; //@line 2674 "translate.cpp"
                if ($tobool246) { __label__ = 92;; } else { __label__ = 94;; } //@line 2674 "translate.cpp"
                $if_then247$$if_else258$130: do { 
                  if (__label__ == 92) {
  
                    var $158=$c; //@line 2676 "translate.cpp"
                    var $call248=_iswdigit($158); //@line 2676 "translate.cpp"
                    var $tobool249=((($call248))|0)==0; //@line 2676 "translate.cpp"
                    var $159=$c; //@line 2676 "translate.cpp"
                    var $cmp251=((($159))|0)!=46; //@line 2676 "translate.cpp"
                    var $or_cond5=($tobool249) & ($cmp251); //@line 2676 "translate.cpp"
                    var $160=$c; //@line 2676 "translate.cpp"
                    var $cmp253=((($160))|0)!=44; //@line 2676 "translate.cpp"
                    var $or_cond6=($or_cond5) & ($cmp253); //@line 2676 "translate.cpp"
                    var $161=$c; //@line 2676 "translate.cpp"
                    var $cmp255=((($161))|0)!=32; //@line 2676 "translate.cpp"
                    var $or_cond7=($or_cond6) & ($cmp255); //@line 2676 "translate.cpp"
                    if ($or_cond7) { __lastLabel__ = 92; ; } else { __lastLabel__ = 92; __label__ = 97;break $if_then247$$if_else258$130; } //@line 2676 "translate.cpp"
  
                    $c=32; //@line 2678 "translate.cpp"
                    $space_inserted=1; //@line 2679 "translate.cpp"
                    __label__ = 101;break $if_then247$$if_else258$130; //@line 2690 "translate.cpp"
                  }
                  else if (__label__ == 94) {
  
                    var $162=HEAP32[(($prev_in)>>2)]; //@line 2684 "translate.cpp"
                    var $cmp259=((($162))|0)!=44; //@line 2684 "translate.cpp"
                    if ($cmp259) { __label__ = 95;; } else { __label__ = 96;; } //@line 2684 "translate.cpp"
                    if (__label__ == 95) {
  
                      $decimal_sep_count=0; //@line 2686 "translate.cpp"
                      ; //@line 2687 "translate.cpp"
                    }
  
                    var $_pr17=$c; //@line 2690 "translate.cpp"
                    __lastLabel__ = 96; __label__ = 97;break $if_then247$$if_else258$130;
                  }
                } while(0);
                $if_end273$$if_end262$137: do { 
                  if (__label__ == 97) {
  
                    var $163=__lastLabel__ == 96 ? $_pr17 : ($161); //@line 2690 "translate.cpp"
                    var $cmp263=((($163))|0)==91; //@line 2690 "translate.cpp"
                    if (!($cmp263)) { __label__ = 101;break $if_end273$$if_end262$137; } //@line 2690 "translate.cpp"
  
                    var $164=HEAP32[(($next_in)>>2)]; //@line 2692 "translate.cpp"
                    var $cmp265=((($164))|0)==2; //@line 2692 "translate.cpp"
                    if ($cmp265) { __label__ = 100;; } else { __label__ = 99;; } //@line 2692 "translate.cpp"
                    if (__label__ == 99) {
  
                      var $165=HEAP32[(($next_in)>>2)]; //@line 2692 "translate.cpp"
                      var $cmp267=((($165))|0)==91; //@line 2692 "translate.cpp"
                      var $166=HEAP32[((_option_phoneme_input)>>2)]; //@line 2692 "translate.cpp"
                      var $tobool269=((($166))|0)!=0; //@line 2692 "translate.cpp"
                      var $or_cond8=($cmp267) & ($tobool269); //@line 2692 "translate.cpp"
                      if (!($or_cond8)) { __label__ = 101;break $if_end273$$if_end262$137; } //@line 2692 "translate.cpp"
                    }
  
                    $phoneme_mode=8; //@line 2695 "translate.cpp"
                    var $167=HEAP32[(($source_index)>>2)]; //@line 2696 "translate.cpp"
                    var $inc271=((($167)+1)&4294967295); //@line 2696 "translate.cpp"
                    HEAP32[(($source_index)>>2)]=$inc271; //@line 2696 "translate.cpp"
                    __label__ = 33;continue $while_cond88$50; //@line 2697 "translate.cpp"
                  }
                } while(0);
  
                var $168=$c; //@line 2701 "translate.cpp"
                var $call274=__Z7IsAlphaj($168); //@line 2701 "translate.cpp"
                var $tobool275=((($call274))|0)!=0; //@line 2701 "translate.cpp"
                if ($tobool275) { __label__ = 102;; } else { __label__ = 138;; } //@line 2701 "translate.cpp"
                if (__label__ == 102) {
  
                  var $169=HEAP32[(($prev_out)>>2)]; //@line 2703 "translate.cpp"
                  var $call277=__Z7IsAlphaj($169); //@line 2703 "translate.cpp"
                  var $tobool278=((($call277))|0)!=0; //@line 2703 "translate.cpp"
                  if ($tobool278) { __label__ = 103;; } else { __label__ = 106;; } //@line 2703 "translate.cpp"
                  $lor_lhs_false279$$if_then286$146: do { 
                    if (__label__ == 103) {
  
                      var $170=$tr_addr; //@line 2703 "translate.cpp"
                      var $langopts280=(($170)&4294967295); //@line 2703 "translate.cpp"
                      var $ideographs=(($langopts280+251)&4294967295); //@line 2703 "translate.cpp"
                      var $171=HEAP8[($ideographs)]; //@line 2703 "translate.cpp"
                      var $tobool281=(tempInt=(($171)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2703 "translate.cpp"
                      if (!($tobool281)) { __label__ = 118;break $lor_lhs_false279$$if_then286$146; } //@line 2703 "translate.cpp"
  
                      var $172=$c; //@line 2703 "translate.cpp"
                      var $cmp283=((($172))|0) > 12352; //@line 2703 "translate.cpp"
                      if ($cmp283) { __label__ = 106;break $lor_lhs_false279$$if_then286$146; } //@line 2703 "translate.cpp"
  
                      var $173=HEAP32[(($prev_out)>>2)]; //@line 2703 "translate.cpp"
                      var $cmp285=((($173))|0) > 12352; //@line 2703 "translate.cpp"
                      if ($cmp285) { __label__ = 106;break $lor_lhs_false279$$if_then286$146; } else { __label__ = 118;break $lor_lhs_false279$$if_then286$146; } //@line 2703 "translate.cpp"
                    }
                  } while(0);
                  $if_then286$$if_end327$150: do { 
                    if (__label__ == 106) {
  
                      var $174=$tr_addr; //@line 2705 "translate.cpp"
                      var $punct_within_word287=(($174+704)&4294967295); //@line 2705 "translate.cpp"
                      var $175=HEAP32[(($punct_within_word287)>>2)]; //@line 2705 "translate.cpp"
                      var $176=HEAP32[(($prev_out)>>2)]; //@line 2705 "translate.cpp"
                      var $call288=_wcschr($175, $176); //@line 2705 "translate.cpp"
                      var $cmp289=((($call288))|0)==0; //@line 2705 "translate.cpp"
                      if ($cmp289) { __label__ = 107;; } else { __label__ = 108;; } //@line 2705 "translate.cpp"
                      if (__label__ == 107) {
  
                        $letter_count=0; //@line 2706 "translate.cpp"
                        ; //@line 2706 "translate.cpp"
                      }
  
                      var $177=HEAP32[(($prev_out)>>2)]; //@line 2708 "translate.cpp"
                      var $cmp292=((($177))|0)!=32; //@line 2708 "translate.cpp"
                      if ($cmp292) { __label__ = 109;; } else { __label__ = 112;; } //@line 2708 "translate.cpp"
                      $land_lhs_true293$$if_else303$155: do { 
                        if (__label__ == 109) {
  
                          var $178=$tr_addr; //@line 2708 "translate.cpp"
                          var $punct_within_word294=(($178+704)&4294967295); //@line 2708 "translate.cpp"
                          var $179=HEAP32[(($punct_within_word294)>>2)]; //@line 2708 "translate.cpp"
                          var $180=HEAP32[(($prev_out)>>2)]; //@line 2708 "translate.cpp"
                          var $call295=_wcschr($179, $180); //@line 2708 "translate.cpp"
                          var $cmp296=((($call295))|0)==0; //@line 2708 "translate.cpp"
                          if (!($cmp296)) { __label__ = 112;break $land_lhs_true293$$if_else303$155; } //@line 2708 "translate.cpp"
  
                          $c=32; //@line 2711 "translate.cpp"
                          $space_inserted=1; //@line 2712 "translate.cpp"
                          var $181=HEAP32[(($prev_out)>>2)]; //@line 2714 "translate.cpp"
                          var $call298=__Z9IsBracketi($181); //@line 2714 "translate.cpp"
                          var $tobool299=((($call298))|0)!=0; //@line 2714 "translate.cpp"
                          if ($tobool299) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2714 "translate.cpp"
  
                          var $182=$next_word_flags; //@line 2716 "translate.cpp"
                          var $or301=($182) | 256; //@line 2716 "translate.cpp"
                          $next_word_flags=$or301; //@line 2716 "translate.cpp"
                          __label__ = 118;break $if_then286$$if_end327$150; //@line 2717 "translate.cpp"
                        }
                      } while(0);
  
                      var $183=$c; //@line 2721 "translate.cpp"
                      var $call304=_iswupper($183); //@line 2721 "translate.cpp"
                      var $tobool305=((($call304))|0)!=0; //@line 2721 "translate.cpp"
                      if ($tobool305) { __label__ = 113;; } else { __label__ = 114;; } //@line 2721 "translate.cpp"
                      if (__label__ == 113) {
  
                        var $184=$word_flags; //@line 2722 "translate.cpp"
                        var $or307=($184) | 2; //@line 2722 "translate.cpp"
                        $word_flags=$or307; //@line 2722 "translate.cpp"
                        ; //@line 2722 "translate.cpp"
                      }
  
                      var $185=HEAP32[(($prev_out)>>2)]; //@line 2724 "translate.cpp"
                      var $cmp309=((($185))|0)==32; //@line 2724 "translate.cpp"
                      if (!($cmp309)) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2724 "translate.cpp"
  
                      var $186=$ix; //@line 2724 "translate.cpp"
                      var $sub311=((($186)-2)&4294967295); //@line 2724 "translate.cpp"
                      var $arrayidx312=(($sbuf+$sub311)&4294967295); //@line 2724 "translate.cpp"
                      var $187=HEAP8[($arrayidx312)]; //@line 2724 "translate.cpp"
                      var $conv313=(tempInt=(($187)),(tempInt>=128?tempInt-256:tempInt)); //@line 2724 "translate.cpp"
                      var $call314=_iswdigit($conv313); //@line 2724 "translate.cpp"
                      var $tobool315=((($call314))|0)!=0; //@line 2724 "translate.cpp"
                      if (!($tobool315)) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2724 "translate.cpp"
  
                      var $188=HEAP32[(($prev_in)>>2)]; //@line 2724 "translate.cpp"
                      var $call317=_iswdigit($188); //@line 2724 "translate.cpp"
                      var $tobool318=((($call317))|0)!=0; //@line 2724 "translate.cpp"
                      if ($tobool318) { __label__ = 118;break $if_then286$$if_end327$150; } //@line 2724 "translate.cpp"
  
                      var $189=$ix; //@line 2728 "translate.cpp"
                      var $inc320=((($189)+1)&4294967295); //@line 2728 "translate.cpp"
                      $ix=$inc320; //@line 2728 "translate.cpp"
                      var $arrayidx321=(($sbuf+$189)&4294967295); //@line 2728 "translate.cpp"
                      HEAP8[($arrayidx321)]=32; //@line 2728 "translate.cpp"
                      var $190=$word_count; //@line 2729 "translate.cpp"
                      var $arrayidx322=(($words+$190*12)&4294967295); //@line 2729 "translate.cpp"
                      var $start323=(($arrayidx322+4)&4294967295); //@line 2729 "translate.cpp"
                      var $191=HEAP16[(($start323)>>1)]; //@line 2729 "translate.cpp"
                      var $inc324=((($191)+1)&65535); //@line 2729 "translate.cpp"
                      HEAP16[(($start323)>>1)]=$inc324; //@line 2729 "translate.cpp"
                      ; //@line 2730 "translate.cpp"
                    }
                  } while(0);
  
                  var $192=$letter_count; //@line 2734 "translate.cpp"
                  var $inc328=((($192)+1)&4294967295); //@line 2734 "translate.cpp"
                  $letter_count=$inc328; //@line 2734 "translate.cpp"
                  var $193=$c; //@line 2736 "translate.cpp"
                  var $call329=_iswupper($193); //@line 2736 "translate.cpp"
                  var $tobool330=((($call329))|0)!=0; //@line 2736 "translate.cpp"
                  if ($tobool330) { __label__ = 119;; } else { __label__ = 130;; } //@line 2736 "translate.cpp"
                  if (__label__ == 119) {
  
                    var $194=$c; //@line 2738 "translate.cpp"
                    var $call332=__Z9towlower2j($194); //@line 2738 "translate.cpp"
                    $c=$call332; //@line 2738 "translate.cpp"
                    var $195=$tr_addr; //@line 2740 "translate.cpp"
                    var $langopts333=(($195)&4294967295); //@line 2740 "translate.cpp"
                    var $param=(($langopts333+24)&4294967295); //@line 2740 "translate.cpp"
                    var $arrayidx334=(($param+52)&4294967295); //@line 2740 "translate.cpp"
                    var $196=HEAP32[(($arrayidx334)>>2)]; //@line 2740 "translate.cpp"
                    $j=$196; //@line 2740 "translate.cpp"
                    var $cmp335=((($196))|0) > 0; //@line 2740 "translate.cpp"
                    if ($cmp335) { __label__ = 120;; } else { __label__ = 123;; } //@line 2740 "translate.cpp"
                    if (__label__ == 120) {
  
                      var $197=$j; //@line 2742 "translate.cpp"
                      var $cmp337=((($197))|0)==2; //@line 2742 "translate.cpp"
                      if (!($cmp337)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2742 "translate.cpp"
  
                      var $198=$syllable_marked; //@line 2742 "translate.cpp"
                      var $cmp339=((($198))|0)==0; //@line 2742 "translate.cpp"
                      if (!($cmp339)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2742 "translate.cpp"
  
                      var $199=$c; //@line 2744 "translate.cpp"
                      HEAP32[(($char_inserted)>>2)]=$199; //@line 2744 "translate.cpp"
                      $c=712; //@line 2745 "translate.cpp"
                      $syllable_marked=1; //@line 2746 "translate.cpp"
                      ; //@line 2747 "translate.cpp"
                    }
                    else if (__label__ == 123) {
  
                      var $200=HEAP32[(($prev_in)>>2)]; //@line 2751 "translate.cpp"
                      var $call343=_iswlower($200); //@line 2751 "translate.cpp"
                      var $tobool344=((($call343))|0)!=0; //@line 2751 "translate.cpp"
                      if ($tobool344) { __label__ = 124;; } else { __label__ = 125;; } //@line 2751 "translate.cpp"
                      if (__label__ == 124) {
  
                        $c=32; //@line 2753 "translate.cpp"
                        $space_inserted=1; //@line 2754 "translate.cpp"
                        var $201=$c; //@line 2755 "translate.cpp"
                        $prev_in_save=$201; //@line 2755 "translate.cpp"
                        ; //@line 2757 "translate.cpp"
                      }
                      else if (__label__ == 125) {
  
                        var $202=$c; //@line 2759 "translate.cpp"
                        var $cmp347=((($202))|0)!=32; //@line 2759 "translate.cpp"
                        if (!($cmp347)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2759 "translate.cpp"
  
                        var $203=HEAP32[(($prev_in)>>2)]; //@line 2759 "translate.cpp"
                        var $call349=_iswupper($203); //@line 2759 "translate.cpp"
                        var $tobool350=((($call349))|0)!=0; //@line 2759 "translate.cpp"
                        if (!($tobool350)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2759 "translate.cpp"
  
                        var $204=HEAP32[(($next_in)>>2)]; //@line 2759 "translate.cpp"
                        var $call352=_iswlower($204); //@line 2759 "translate.cpp"
                        var $tobool353=((($call352))|0)!=0; //@line 2759 "translate.cpp"
                        if (!($tobool353)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2759 "translate.cpp"
  
                        var $205=HEAP32[(($source_index)>>2)]; //@line 2762 "translate.cpp"
                        var $206=$next_in_nbytes; //@line 2762 "translate.cpp"
                        var $add355=((($206)+($205))&4294967295); //@line 2762 "translate.cpp"
                        var $arrayidx356=((__ZL6source+$add355)&4294967295); //@line 2762 "translate.cpp"
                        var $call357=__Z7utf8_inPiPKc($next2_in, $arrayidx356); //@line 2762 "translate.cpp"
                        var $207=HEAP32[(($next2_in)>>2)]; //@line 2763 "translate.cpp"
                        var $call358=__Z7IsAlphaj($207); //@line 2763 "translate.cpp"
                        var $tobool359=((($call358))|0)!=0; //@line 2763 "translate.cpp"
                        if (!($tobool359)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2763 "translate.cpp"
  
                        $c=32; //@line 2766 "translate.cpp"
                        $space_inserted=1; //@line 2767 "translate.cpp"
                        var $208=$c; //@line 2768 "translate.cpp"
                        $prev_in_save=$208; //@line 2768 "translate.cpp"
                        var $209=$next_word_flags; //@line 2769 "translate.cpp"
                        var $or361=($209) | 256; //@line 2769 "translate.cpp"
                        $next_word_flags=$or361; //@line 2769 "translate.cpp"
                        ; //@line 2770 "translate.cpp"
                      }
                    }
                  }
                  else if (__label__ == 130) {
  
                    var $210=$all_upper_case; //@line 2776 "translate.cpp"
                    var $tobool367=((($210))|0)!=0; //@line 2776 "translate.cpp"
                    if ($tobool367) { __label__ = 131;; } else { __label__ = 137;; } //@line 2776 "translate.cpp"
                    $land_lhs_true368$$if_else386$182: do { 
                      if (__label__ == 131) {
  
                        var $211=$letter_count; //@line 2776 "translate.cpp"
                        var $cmp369=((($211))|0) > 2; //@line 2776 "translate.cpp"
                        if (!($cmp369)) { __label__ = 137;break $land_lhs_true368$$if_else386$182; } //@line 2776 "translate.cpp"
  
                        var $212=$c; //@line 2778 "translate.cpp"
                        var $cmp371=((($212))|0)==115; //@line 2778 "translate.cpp"
                        if ($cmp371) { __label__ = 133;; } else { __label__ = 136;; } //@line 2778 "translate.cpp"
                        $land_lhs_true372$$if_else384$185: do { 
                          if (__label__ == 133) {
  
                            var $213=HEAP32[(($next_in)>>2)]; //@line 2778 "translate.cpp"
                            var $cmp373=((($213))|0)==32; //@line 2778 "translate.cpp"
                            if (!($cmp373)) { __label__ = 136;break $land_lhs_true372$$if_else384$185; } //@line 2778 "translate.cpp"
  
                            $c=32; //@line 2780 "translate.cpp"
                            var $214=$all_upper_case; //@line 2781 "translate.cpp"
                            var $or375=($214) | 4; //@line 2781 "translate.cpp"
                            $all_upper_case=$or375; //@line 2781 "translate.cpp"
                            var $215=$ix; //@line 2783 "translate.cpp"
                            var $sub376=((($215)-1)&4294967295); //@line 2783 "translate.cpp"
                            var $arrayidx377=(($sbuf+$sub376)&4294967295); //@line 2783 "translate.cpp"
                            var $216=HEAP8[($arrayidx377)]; //@line 2783 "translate.cpp"
                            var $conv378=(tempInt=(($216)),(tempInt>=128?tempInt-256:tempInt)); //@line 2783 "translate.cpp"
                            var $cmp379=((($conv378))|0)==39; //@line 2783 "translate.cpp"
                            if (!($cmp379)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2783 "translate.cpp"
  
                            var $217=$ix; //@line 2784 "translate.cpp"
                            var $sub381=((($217)-1)&4294967295); //@line 2784 "translate.cpp"
                            var $arrayidx382=(($sbuf+$sub381)&4294967295); //@line 2784 "translate.cpp"
                            HEAP8[($arrayidx382)]=32; //@line 2784 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2784 "translate.cpp"
                          }
                        } while(0);
  
                        $all_upper_case=0; //@line 2787 "translate.cpp"
                        __label__ = 195;break $if_then155$$if_else162$86;
                      }
                    } while(0);
  
                    $all_upper_case=0; //@line 2790 "translate.cpp"
                    ;
                  }
                }
                else if (__label__ == 138) {
  
                  var $218=$c; //@line 2794 "translate.cpp"
                  var $cmp390=((($218))|0)==45; //@line 2794 "translate.cpp"
                  if ($cmp390) { __label__ = 139;; } else { __label__ = 154;; } //@line 2794 "translate.cpp"
                  if (__label__ == 139) {
  
                    var $219=HEAP32[(($prev_in)>>2)]; //@line 2796 "translate.cpp"
                    var $call392=__Z7IsSpacej($219); //@line 2796 "translate.cpp"
                    var $tobool393=((($call392))|0)!=0; //@line 2796 "translate.cpp"
                    if ($tobool393) { __label__ = 146;; } else { __label__ = 140;; } //@line 2796 "translate.cpp"
                    $if_else410$$land_lhs_true394$194: do { 
                      if (__label__ == 140) {
  
                        var $220=HEAP32[(($next_in)>>2)]; //@line 2796 "translate.cpp"
                        var $call395=__Z7IsAlphaj($220); //@line 2796 "translate.cpp"
                        var $tobool396=((($call395))|0)!=0; //@line 2796 "translate.cpp"
                        if (!($tobool396)) { __label__ = 146;break $if_else410$$land_lhs_true394$194; } //@line 2796 "translate.cpp"
  
                        var $221=HEAP32[(($prev_out)>>2)]; //@line 2798 "translate.cpp"
                        var $cmp398=((($221))|0)!=32; //@line 2798 "translate.cpp"
                        if ($cmp398) { __label__ = 142;; } else { __label__ = 143;; } //@line 2798 "translate.cpp"
                        if (__label__ == 142) {
  
                          $c=32; //@line 2801 "translate.cpp"
                          $space_inserted=1; //@line 2802 "translate.cpp"
                          __label__ = 195;break $if_then155$$if_else162$86; //@line 2803 "translate.cpp"
                        }
                        else if (__label__ == 143) {
  
                          var $222=$word_flags; //@line 2807 "translate.cpp"
                          var $or401=($222) | 128; //@line 2807 "translate.cpp"
                          $word_flags=$or401; //@line 2807 "translate.cpp"
                          var $223=$word_count; //@line 2808 "translate.cpp"
                          var $cmp402=((($223))|0) > 0; //@line 2808 "translate.cpp"
                          if ($cmp402) { __label__ = 144;; } else { __label__ = 145;; } //@line 2808 "translate.cpp"
                          if (__label__ == 144) {
  
                            var $224=$word_count; //@line 2809 "translate.cpp"
                            var $sub404=((($224)-1)&4294967295); //@line 2809 "translate.cpp"
                            var $arrayidx405=(($words+$sub404*12)&4294967295); //@line 2809 "translate.cpp"
                            var $flags406=(($arrayidx405)&4294967295); //@line 2809 "translate.cpp"
                            var $225=HEAP32[(($flags406)>>2)]; //@line 2809 "translate.cpp"
                            var $or407=($225) | 16384; //@line 2809 "translate.cpp"
                            HEAP32[(($flags406)>>2)]=$or407; //@line 2809 "translate.cpp"
                            ; //@line 2809 "translate.cpp"
                          }
  
                          $c=32; //@line 2810 "translate.cpp"
                          __label__ = 195;break $if_then155$$if_else162$86;
                        }
                      }
                    } while(0);
  
                    var $226=HEAP32[(($prev_in)>>2)]; //@line 2814 "translate.cpp"
                    var $cmp411=((($226))|0)==32; //@line 2814 "translate.cpp"
                    var $227=HEAP32[(($next_in)>>2)]; //@line 2814 "translate.cpp"
                    var $cmp413=((($227))|0)==32; //@line 2814 "translate.cpp"
                    var $or_cond26=($cmp411) & ($cmp413); //@line 2814 "translate.cpp"
                    if ($or_cond26) { __label__ = 147;; } else { __label__ = 148;; } //@line 2814 "translate.cpp"
                    if (__label__ == 147) {
  
                      $c=32; //@line 2817 "translate.cpp"
                      $pre_pause_add=4; //@line 2818 "translate.cpp"
                      ; //@line 2819 "translate.cpp"
                    }
                    else if (__label__ == 148) {
  
                      var $cmp416=((($227))|0)==45; //@line 2821 "translate.cpp"
                      if ($cmp416) { __label__ = 149;; } else { __label__ = 150;; } //@line 2821 "translate.cpp"
                      if (__label__ == 149) {
  
                        var $228=HEAP32[(($source_index)>>2)]; //@line 2824 "translate.cpp"
                        var $inc418=((($228)+1)&4294967295); //@line 2824 "translate.cpp"
                        HEAP32[(($source_index)>>2)]=$inc418; //@line 2824 "translate.cpp"
                        $c=32; //@line 2825 "translate.cpp"
                        $pre_pause_add=4; //@line 2826 "translate.cpp"
                        ; //@line 2827 "translate.cpp"
                      }
                      else if (__label__ == 150) {
  
                        var $229=HEAP32[(($prev_out)>>2)]; //@line 2829 "translate.cpp"
                        var $cmp420=((($229))|0)==32; //@line 2829 "translate.cpp"
                        if (!($cmp420)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2829 "translate.cpp"
  
                        var $230=$ix; //@line 2829 "translate.cpp"
                        var $sub422=((($230)-2)&4294967295); //@line 2829 "translate.cpp"
                        var $arrayidx423=(($sbuf+$sub422)&4294967295); //@line 2829 "translate.cpp"
                        var $231=HEAP8[($arrayidx423)]; //@line 2829 "translate.cpp"
                        var $conv424=(tempInt=(($231)),(tempInt>=128?tempInt-256:tempInt)); //@line 2829 "translate.cpp"
                        var $call425=__Z7IsAlphaj($conv424); //@line 2829 "translate.cpp"
                        var $tobool426=((($call425))|0)!=0; //@line 2829 "translate.cpp"
                        if (!($tobool426)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2829 "translate.cpp"
  
                        var $232=HEAP32[(($prev_in)>>2)]; //@line 2829 "translate.cpp"
                        var $call428=__Z7IsAlphaj($232); //@line 2829 "translate.cpp"
                        var $tobool429=((($call428))|0)!=0; //@line 2829 "translate.cpp"
                        if ($tobool429) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2829 "translate.cpp"
  
                        var $233=$ix; //@line 2832 "translate.cpp"
                        var $inc431=((($233)+1)&4294967295); //@line 2832 "translate.cpp"
                        $ix=$inc431; //@line 2832 "translate.cpp"
                        var $arrayidx432=(($sbuf+$233)&4294967295); //@line 2832 "translate.cpp"
                        HEAP8[($arrayidx432)]=32; //@line 2832 "translate.cpp"
                        var $234=$word_count; //@line 2833 "translate.cpp"
                        var $arrayidx433=(($words+$234*12)&4294967295); //@line 2833 "translate.cpp"
                        var $start434=(($arrayidx433+4)&4294967295); //@line 2833 "translate.cpp"
                        var $235=HEAP16[(($start434)>>1)]; //@line 2833 "translate.cpp"
                        var $inc435=((($235)+1)&65535); //@line 2833 "translate.cpp"
                        HEAP16[(($start434)>>1)]=$inc435; //@line 2833 "translate.cpp"
                        ; //@line 2834 "translate.cpp"
                      }
                    }
                  }
                  else if (__label__ == 154) {
  
                    var $236=$c; //@line 2837 "translate.cpp"
                    var $cmp441=((($236))|0)==46; //@line 2837 "translate.cpp"
                    if ($cmp441) { __label__ = 155;; } else { __label__ = 162;; } //@line 2837 "translate.cpp"
                    if (__label__ == 155) {
  
                      var $237=HEAP32[(($prev_out)>>2)]; //@line 2839 "translate.cpp"
                      var $cmp443=((($237))|0)==46; //@line 2839 "translate.cpp"
                      if ($cmp443) { __label__ = 156;; } else { __label__ = 157;; } //@line 2839 "translate.cpp"
                      if (__label__ == 156) {
  
                        $c=32; //@line 2842 "translate.cpp"
                        $space_inserted=1; //@line 2843 "translate.cpp"
                        ; //@line 2844 "translate.cpp"
                      }
                      else if (__label__ == 157) {
  
                        var $238=$word_count; //@line 2846 "translate.cpp"
                        var $cmp446=((($238))|0) > 0; //@line 2846 "translate.cpp"
                        if (!($cmp446)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2846 "translate.cpp"
  
                        var $239=$word_count; //@line 2846 "translate.cpp"
                        var $sub448=((($239)-1)&4294967295); //@line 2846 "translate.cpp"
                        var $arrayidx449=(($words+$sub448*12)&4294967295); //@line 2846 "translate.cpp"
                        var $flags450=(($arrayidx449)&4294967295); //@line 2846 "translate.cpp"
                        var $240=HEAP32[(($flags450)>>2)]; //@line 2846 "translate.cpp"
                        var $and451=($240) & 256; //@line 2846 "translate.cpp"
                        var $tobool452=((($and451))|0)!=0; //@line 2846 "translate.cpp"
                        if ($tobool452) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2846 "translate.cpp"
  
                        var $241=HEAP32[(($prev_in)>>2)]; //@line 2846 "translate.cpp"
                        var $call454=__Z7IsAlphaj($241); //@line 2846 "translate.cpp"
                        var $tobool455=((($call454))|0)!=0; //@line 2846 "translate.cpp"
                        if (!($tobool455)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2846 "translate.cpp"
  
                        var $242=$word_count; //@line 2849 "translate.cpp"
                        var $sub457=((($242)-1)&4294967295); //@line 2849 "translate.cpp"
                        var $arrayidx458=(($words+$sub457*12)&4294967295); //@line 2849 "translate.cpp"
                        var $flags459=(($arrayidx458)&4294967295); //@line 2849 "translate.cpp"
                        var $243=HEAP32[(($flags459)>>2)]; //@line 2849 "translate.cpp"
                        var $or460=($243) | 65536; //@line 2849 "translate.cpp"
                        HEAP32[(($flags459)>>2)]=$or460; //@line 2849 "translate.cpp"
                        var $244=HEAP32[(($next_in)>>2)]; //@line 2851 "translate.cpp"
                        var $call461=__Z7IsSpacej($244); //@line 2851 "translate.cpp"
                        var $tobool462=((($call461))|0)!=0; //@line 2851 "translate.cpp"
                        var $245=HEAP32[(($next_in)>>2)]; //@line 2851 "translate.cpp"
                        var $cmp464=((($245))|0)==45; //@line 2851 "translate.cpp"
                        var $or_cond9=($tobool462) | ($cmp464); //@line 2851 "translate.cpp"
                        if (!($or_cond9)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2851 "translate.cpp"
  
                        $c=32; //@line 2852 "translate.cpp"
                        ; //@line 2852 "translate.cpp"
                      }
                    }
                    else if (__label__ == 162) {
  
                      var $246=$c; //@line 2856 "translate.cpp"
                      var $cmp470=((($246))|0)==39; //@line 2856 "translate.cpp"
                      if ($cmp470) { __label__ = 163;; } else { __label__ = 178;; } //@line 2856 "translate.cpp"
                      if (__label__ == 163) {
  
                        var $247=HEAP32[(($prev_in)>>2)]; //@line 2858 "translate.cpp"
                        var $cmp472=((($247))|0)==46; //@line 2858 "translate.cpp"
                        if ($cmp472) { __label__ = 165;; } else { __label__ = 164;; } //@line 2858 "translate.cpp"
                        $land_lhs_true476$$lor_lhs_false473$226: do { 
                          if (__label__ == 164) {
  
                            var $248=HEAP32[(($prev_in)>>2)]; //@line 2858 "translate.cpp"
                            var $call474=_iswalnum($248); //@line 2858 "translate.cpp"
                            var $tobool475=((($call474))|0)!=0; //@line 2858 "translate.cpp"
                            if ($tobool475) { __label__ = 165;break $land_lhs_true476$$lor_lhs_false473$226; } else { __label__ = 167;break $land_lhs_true476$$lor_lhs_false473$226; } //@line 2858 "translate.cpp"
                          }
                        } while(0);
                        $land_lhs_true476$$if_else480$228: do { 
                          if (__label__ == 165) {
  
                            var $249=HEAP32[(($next_in)>>2)]; //@line 2858 "translate.cpp"
                            var $call477=__Z7IsAlphaj($249); //@line 2858 "translate.cpp"
                            var $tobool478=((($call477))|0)!=0; //@line 2858 "translate.cpp"
                            if (!($tobool478)) { __label__ = 167;break $land_lhs_true476$$if_else480$228; } //@line 2858 "translate.cpp"
  
                            $single_quoted=0; //@line 2861 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2862 "translate.cpp"
                          }
                        } while(0);
  
                        var $250=$tr_addr; //@line 2864 "translate.cpp"
                        var $char_plus_apostrophe=(($250+700)&4294967295); //@line 2864 "translate.cpp"
                        var $251=HEAP32[(($char_plus_apostrophe)>>2)]; //@line 2864 "translate.cpp"
                        var $252=HEAP32[(($prev_in)>>2)]; //@line 2864 "translate.cpp"
                        var $call481=_wcschr($251, $252); //@line 2864 "translate.cpp"
                        var $cmp482=((($call481))|0)!=0; //@line 2864 "translate.cpp"
                        if ($cmp482) { __label__ = 168;; } else { __label__ = 171;; } //@line 2864 "translate.cpp"
                        $land_lhs_true483$$if_else490$232: do { 
                          if (__label__ == 168) {
  
                            var $253=$prev_out2; //@line 2864 "translate.cpp"
                            var $cmp484=((($253))|0)==32; //@line 2864 "translate.cpp"
                            if (!($cmp484)) { __label__ = 171;break $land_lhs_true483$$if_else490$232; } //@line 2864 "translate.cpp"
  
                            $single_quoted=0; //@line 2867 "translate.cpp"
                            var $254=HEAP32[(($next_in)>>2)]; //@line 2868 "translate.cpp"
                            var $cmp486=((($254))|0)==32; //@line 2868 "translate.cpp"
                            if (!($cmp486)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2868 "translate.cpp"
  
                            var $255=HEAP32[(($source_index)>>2)]; //@line 2870 "translate.cpp"
                            var $inc488=((($255)+1)&4294967295); //@line 2870 "translate.cpp"
                            HEAP32[(($source_index)>>2)]=$inc488; //@line 2870 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2871 "translate.cpp"
                          }
                        } while(0);
  
                        var $256=HEAP32[(($prev_out)>>2)]; //@line 2875 "translate.cpp"
                        var $cmp491=((($256))|0)==115; //@line 2875 "translate.cpp"
                        if ($cmp491) { __label__ = 172;; } else { __label__ = 174;; } //@line 2875 "translate.cpp"
                        $land_lhs_true492$$if_else495$237: do { 
                          if (__label__ == 172) {
  
                            var $257=$single_quoted; //@line 2875 "translate.cpp"
                            var $cmp493=((($257))|0)==0; //@line 2875 "translate.cpp"
                            if (!($cmp493)) { __label__ = 174;break $land_lhs_true492$$if_else495$237; } //@line 2875 "translate.cpp"
  
                            $c=32; //@line 2878 "translate.cpp"
                            __label__ = 195;break $if_then155$$if_else162$86; //@line 2879 "translate.cpp"
                          }
                        } while(0);
  
                        var $258=HEAP32[(($prev_out)>>2)]; //@line 2882 "translate.cpp"
                        var $call496=__Z7IsSpacej($258); //@line 2882 "translate.cpp"
                        var $tobool497=((($call496))|0)!=0; //@line 2882 "translate.cpp"
                        if ($tobool497) { __label__ = 175;; } else { __label__ = 176;; } //@line 2882 "translate.cpp"
                        if (__label__ == 175) {
  
                          $single_quoted=1; //@line 2883 "translate.cpp"
                          ; //@line 2883 "translate.cpp"
                        }
                        else if (__label__ == 176) {
  
                          $single_quoted=0; //@line 2885 "translate.cpp"
                          ;
                        }
  
                        $pre_pause_add=4; //@line 2887 "translate.cpp"
                        $c=32; //@line 2888 "translate.cpp"
                        ;
                      }
                      else if (__label__ == 178) {
  
                        var $259=$c; //@line 2902 "translate.cpp"
                        var $call505=__Z11lookupwcharPKti(((__ZL6breaks)&4294967295), $259); //@line 2902 "translate.cpp"
                        var $cmp506=((($call505))|0)!=0; //@line 2902 "translate.cpp"
                        if ($cmp506) { __label__ = 179;; } else { __label__ = 180;; } //@line 2902 "translate.cpp"
                        if (__label__ == 179) {
  
                          $c=32; //@line 2904 "translate.cpp"
                          ; //@line 2905 "translate.cpp"
                        }
                        else if (__label__ == 180) {
  
                          var $260=$c; //@line 2907 "translate.cpp"
                          var $call509=_iswdigit($260); //@line 2907 "translate.cpp"
                          var $tobool510=((($call509))|0)!=0; //@line 2907 "translate.cpp"
                          if (!($tobool510)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2907 "translate.cpp"
  
                          var $261=$tr_addr; //@line 2909 "translate.cpp"
                          var $langopts512=(($261)&4294967295); //@line 2909 "translate.cpp"
                          var $tone_numbers513=(($langopts512+250)&4294967295); //@line 2909 "translate.cpp"
                          var $262=HEAP8[($tone_numbers513)]; //@line 2909 "translate.cpp"
                          var $tobool514=(tempInt=(($262)),(tempInt>=128?tempInt-256:tempInt))!=0; //@line 2909 "translate.cpp"
                          if ($tobool514) { __label__ = 182;; } else { __label__ = 184;; } //@line 2909 "translate.cpp"
                          $land_lhs_true515$$if_else522$250: do { 
                            if (__label__ == 182) {
  
                              var $263=HEAP32[(($prev_out)>>2)]; //@line 2909 "translate.cpp"
                              var $call516=__Z7IsAlphaj($263); //@line 2909 "translate.cpp"
                              var $tobool517=((($call516))|0)!=0; //@line 2909 "translate.cpp"
                              if (!($tobool517)) { __label__ = 184;break $land_lhs_true515$$if_else522$250; } //@line 2909 "translate.cpp"
  
                              var $264=HEAP32[(($next_in)>>2)]; //@line 2909 "translate.cpp"
                              var $call519=__Z7IsDigitj($264); //@line 2909 "translate.cpp"
                              var $tobool520=((($call519))|0)!=0; //@line 2909 "translate.cpp"
                              if (!($tobool520)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2909 "translate.cpp"
                            }
                          } while(0);
  
                          var $265=HEAP32[(($prev_out)>>2)]; //@line 2913 "translate.cpp"
                          var $cmp523=((($265))|0)!=32; //@line 2913 "translate.cpp"
                          if ($cmp523) { __label__ = 185;; } else { __label__ = 192;; } //@line 2913 "translate.cpp"
                          if (__label__ == 185) {
  
                            var $266=HEAP32[(($prev_out)>>2)]; //@line 2913 "translate.cpp"
                            var $call525=_iswdigit($266); //@line 2913 "translate.cpp"
                            var $tobool526=((($call525))|0)!=0; //@line 2913 "translate.cpp"
                            var $_pr20=HEAP32[(($prev_out)>>2)]; //@line 2926 "translate.cpp"
                            if ($tobool526) { __label__ = 191;; } else { __label__ = 186;; } //@line 2913 "translate.cpp"
                            if (__label__ == 191) {
  
                              var $cmp540=((($_pr20))|0)==32; //@line 2926 "translate.cpp"
                              if (!($cmp540)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2926 "translate.cpp"
                            }
                            else if (__label__ == 186) {
  
                              var $267=$tr_addr; //@line 2915 "translate.cpp"
                              var $langopts528=(($267)&4294967295); //@line 2915 "translate.cpp"
                              var $decimal_sep=(($langopts528+208)&4294967295); //@line 2915 "translate.cpp"
                              var $268=HEAP32[(($decimal_sep)>>2)]; //@line 2915 "translate.cpp"
                              var $cmp529=((($_pr20))|0)!=((($268))|0); //@line 2915 "translate.cpp"
                              if ($cmp529) { __label__ = 189;; } else { __label__ = 187;; } //@line 2915 "translate.cpp"
                              $if_then536$$lor_lhs_false530$259: do { 
                                if (__label__ == 187) {
  
                                  var $269=$decimal_sep_count; //@line 2915 "translate.cpp"
                                  var $cmp531=((($269))|0) > 0; //@line 2915 "translate.cpp"
                                  if ($cmp531) { __label__ = 188;; } else { __label__ = 190;; } //@line 2915 "translate.cpp"
                                  if (__label__ == 188) {
  
                                    var $270=$tr_addr; //@line 2915 "translate.cpp"
                                    var $langopts533=(($270)&4294967295); //@line 2915 "translate.cpp"
                                    var $decimal_sep534=(($langopts533+208)&4294967295); //@line 2915 "translate.cpp"
                                    var $271=HEAP32[(($decimal_sep534)>>2)]; //@line 2915 "translate.cpp"
                                    var $cmp535=((($271))|0)==44; //@line 2915 "translate.cpp"
                                    if ($cmp535) { __label__ = 189;break $if_then536$$lor_lhs_false530$259; } //@line 2915 "translate.cpp"
                                  }
  
                                  $decimal_sep_count=1; //@line 2922 "translate.cpp"
                                  __label__ = 195;break $if_then155$$if_else162$86;
                                }
                              } while(0);
  
                              $c=32; //@line 2917 "translate.cpp"
                              $space_inserted=1; //@line 2918 "translate.cpp"
                              __label__ = 195;break $if_then155$$if_else162$86; //@line 2919 "translate.cpp"
                            }
                          }
  
                          var $272=$ix; //@line 2926 "translate.cpp"
                          var $sub542=((($272)-2)&4294967295); //@line 2926 "translate.cpp"
                          var $arrayidx543=(($sbuf+$sub542)&4294967295); //@line 2926 "translate.cpp"
                          var $273=HEAP8[($arrayidx543)]; //@line 2926 "translate.cpp"
                          var $conv544=(tempInt=(($273)),(tempInt>=128?tempInt-256:tempInt)); //@line 2926 "translate.cpp"
                          var $call545=__Z7IsAlphaj($conv544); //@line 2926 "translate.cpp"
                          var $tobool546=((($call545))|0)!=0; //@line 2926 "translate.cpp"
                          if (!($tobool546)) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2926 "translate.cpp"
  
                          var $274=HEAP32[(($prev_in)>>2)]; //@line 2926 "translate.cpp"
                          var $call548=__Z7IsAlphaj($274); //@line 2926 "translate.cpp"
                          var $tobool549=((($call548))|0)!=0; //@line 2926 "translate.cpp"
                          if ($tobool549) { __label__ = 195;break $if_then155$$if_else162$86; } //@line 2926 "translate.cpp"
  
                          var $275=$ix; //@line 2929 "translate.cpp"
                          var $inc551=((($275)+1)&4294967295); //@line 2929 "translate.cpp"
                          $ix=$inc551; //@line 2929 "translate.cpp"
                          var $arrayidx552=(($sbuf+$275)&4294967295); //@line 2929 "translate.cpp"
                          HEAP8[($arrayidx552)]=32; //@line 2929 "translate.cpp"
                          var $276=$word_count; //@line 2930 "translate.cpp"
                          var $arrayidx553=(($words+$276*12)&4294967295); //@line 2930 "translate.cpp"
                          var $start554=(($arrayidx553+4)&4294967295); //@line 2930 "translate.cpp"
                          var $277=HEAP16[(($start554)>>1)]; //@line 2930 "translate.cpp"
                          var $inc555=((($277)+1)&65535); //@line 2930 "translate.cpp"
                          HEAP16[(($start554)>>1)]=$inc555; //@line 2930 "translate.cpp"
                          ; //@line 2931 "translate.cpp"
                        }
                      }
                    }
                  }
                }
              }
            }
          } while(0);
  
          var $278=$c; //@line 2935 "translate.cpp"
          var $call568=__Z7IsSpacej($278); //@line 2935 "translate.cpp"
          var $tobool569=((($call568))|0)!=0; //@line 2935 "translate.cpp"
          if ($tobool569) { __label__ = 196;; } else { __label__ = 225;; } //@line 2935 "translate.cpp"
          $if_then570$$if_else688$269: do { 
            if (__label__ == 196) {
  
              var $279=HEAP32[(($prev_out)>>2)]; //@line 2937 "translate.cpp"
              var $cmp571=((($279))|0)==32; //@line 2937 "translate.cpp"
              if ($cmp571) { __label__ = 197;; } else { __label__ = 198;; } //@line 2937 "translate.cpp"
              if (__label__ == 197) {
  
                var $280=$word_flags; //@line 2939 "translate.cpp"
                var $or573=($280) | 262144; //@line 2939 "translate.cpp"
                $word_flags=$or573; //@line 2939 "translate.cpp"
                __label__ = 33;continue $while_cond88$50; //@line 2940 "translate.cpp"
              }
              else if (__label__ == 198) {
  
                var $281=HEAP32[(($cc)>>2)]; //@line 2943 "translate.cpp"
                var $cmp575=((($281))|0)==9; //@line 2943 "translate.cpp"
                var $282=HEAP32[(($cc)>>2)]; //@line 2943 "translate.cpp"
                var $cmp577=((($282))|0)==10; //@line 2943 "translate.cpp"
                var $or_cond10=($cmp575) | ($cmp577); //@line 2943 "translate.cpp"
                if ($or_cond10) { __label__ = 199;; } else { __label__ = 200;; } //@line 2943 "translate.cpp"
                if (__label__ == 199) {
  
                  var $283=$next_word_flags; //@line 2945 "translate.cpp"
                  var $or579=($283) | 262144; //@line 2945 "translate.cpp"
                  $next_word_flags=$or579; //@line 2945 "translate.cpp"
                  ; //@line 2946 "translate.cpp"
                }
  
                var $284=$space_inserted; //@line 2948 "translate.cpp"
                var $tobool581=((($284))|0)!=0; //@line 2948 "translate.cpp"
                if ($tobool581) { __label__ = 201;; } else { __label__ = 208;; } //@line 2948 "translate.cpp"
                if (__label__ == 201) {
  
                  $j=0; //@line 2951 "translate.cpp"
                  var $285=HEAP32[(($source_index)>>2)]; //@line 2952 "translate.cpp"
                  var $sub583=((($285)-1)&4294967295); //@line 2952 "translate.cpp"
                  $k=$sub583; //@line 2952 "translate.cpp"
                  ; //@line 2953 "translate.cpp"
                  while(1) { 
  
                    var $286=$k; //@line 2953 "translate.cpp"
                    var $287=$source_index_word; //@line 2953 "translate.cpp"
                    var $cmp585=((($286))|0) >= ((($287))|0); //@line 2953 "translate.cpp"
                    if (!($cmp585)) { __label__ = 207;break ; } //@line 2953 "translate.cpp"
  
                    var $288=$k; //@line 2953 "translate.cpp"
                    var $arrayidx587=(($charix+$288*2)&4294967295); //@line 2953 "translate.cpp"
                    var $289=HEAP16[(($arrayidx587)>>1)]; //@line 2953 "translate.cpp"
                    var $conv588=(tempInt=(($289)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2953 "translate.cpp"
                    var $cmp589=((($conv588))|0)!=0; //@line 2953 "translate.cpp"
                    if (!($cmp589)) { __label__ = 207;break ; }
  
                    var $290=$k; //@line 2955 "translate.cpp"
                    var $arrayidx592=(($charix+$290*2)&4294967295); //@line 2955 "translate.cpp"
                    var $291=HEAP16[(($arrayidx592)>>1)]; //@line 2955 "translate.cpp"
                    var $conv593=(tempInt=(($291)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2955 "translate.cpp"
                    var $cmp594=((($conv593))|0) > 0; //@line 2955 "translate.cpp"
                    if ($cmp594) { __label__ = 205;; } else { __label__ = 206;; } //@line 2955 "translate.cpp"
                    if (__label__ == 205) {
  
                      var $292=$j; //@line 2956 "translate.cpp"
                      var $inc596=((($292)+1)&4294967295); //@line 2956 "translate.cpp"
                      $j=$inc596; //@line 2956 "translate.cpp"
                      ; //@line 2956 "translate.cpp"
                    }
  
                    var $293=$k; //@line 2957 "translate.cpp"
                    var $dec598=((($293)-1)&4294967295); //@line 2957 "translate.cpp"
                    $k=$dec598; //@line 2957 "translate.cpp"
                    __label__ = 202;continue ; //@line 2958 "translate.cpp"
                  }
  
                  var $294=$j; //@line 2959 "translate.cpp"
                  var $conv600=((($294)) & 255); //@line 2959 "translate.cpp"
                  var $295=$word_count; //@line 2959 "translate.cpp"
                  var $arrayidx601=(($words+$295*12)&4294967295); //@line 2959 "translate.cpp"
                  var $length602=(($arrayidx601+10)&4294967295); //@line 2959 "translate.cpp"
                  HEAP8[($length602)]=$conv600; //@line 2959 "translate.cpp"
                  ; //@line 2960 "translate.cpp"
                }
  
                var $296=HEAP32[(($source_index)>>2)]; //@line 2962 "translate.cpp"
                $source_index_word=$296; //@line 2962 "translate.cpp"
                var $297=$ix; //@line 2965 "translate.cpp"
                var $inc604=((($297)+1)&4294967295); //@line 2965 "translate.cpp"
                $ix=$inc604; //@line 2965 "translate.cpp"
                var $arrayidx605=(($sbuf+$297)&4294967295); //@line 2965 "translate.cpp"
                HEAP8[($arrayidx605)]=32; //@line 2965 "translate.cpp"
                var $298=$word_count; //@line 2967 "translate.cpp"
                var $cmp606=((($298))|0) < 299; //@line 2967 "translate.cpp"
                if ($cmp606) { __label__ = 209;; } else { __label__ = 223;; } //@line 2967 "translate.cpp"
                $land_lhs_true607$$if_end684$288: do { 
                  if (__label__ == 209) {
  
                    var $299=$ix; //@line 2967 "translate.cpp"
                    var $300=$word_count; //@line 2967 "translate.cpp"
                    var $arrayidx608=(($words+$300*12)&4294967295); //@line 2967 "translate.cpp"
                    var $start609=(($arrayidx608+4)&4294967295); //@line 2967 "translate.cpp"
                    var $301=HEAPU16[(($start609)>>1)]; //@line 2967 "translate.cpp"
                    var $conv610=((($301))&65535); //@line 2967 "translate.cpp"
                    var $cmp611=((($299))|0) > ((($conv610))|0); //@line 2967 "translate.cpp"
                    if (!($cmp611)) { __label__ = 223;break $land_lhs_true607$$if_end684$288; } //@line 2967 "translate.cpp"
  
                    var $302=$embedded_count; //@line 2969 "translate.cpp"
                    var $cmp613=((($302))|0) > 0; //@line 2969 "translate.cpp"
                    if ($cmp613) { __label__ = 211;; } else { __label__ = 212;; } //@line 2969 "translate.cpp"
                    if (__label__ == 211) {
  
                      var $303=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2972 "translate.cpp"
                      var $sub615=((($303)-1)&4294967295); //@line 2972 "translate.cpp"
                      var $arrayidx616=((_embedded_list+$sub615*4)&4294967295); //@line 2972 "translate.cpp"
                      var $304=HEAP32[(($arrayidx616)>>2)]; //@line 2972 "translate.cpp"
                      var $or617=($304) | 128; //@line 2972 "translate.cpp"
                      HEAP32[(($arrayidx616)>>2)]=$or617; //@line 2972 "translate.cpp"
                      var $305=$word_count; //@line 2973 "translate.cpp"
                      var $arrayidx618=(($words+$305*12)&4294967295); //@line 2973 "translate.cpp"
                      var $flags619=(($arrayidx618)&4294967295); //@line 2973 "translate.cpp"
                      var $306=HEAP32[(($flags619)>>2)]; //@line 2973 "translate.cpp"
                      var $or620=($306) | 64; //@line 2973 "translate.cpp"
                      HEAP32[(($flags619)>>2)]=$or620; //@line 2973 "translate.cpp"
                      $embedded_count=0; //@line 2974 "translate.cpp"
                      ; //@line 2975 "translate.cpp"
                    }
  
                    var $307=HEAP32[((_pre_pause)>>2)]; //@line 2976 "translate.cpp"
                    var $conv622=((($307)) & 255); //@line 2976 "translate.cpp"
                    var $308=$word_count; //@line 2976 "translate.cpp"
                    var $arrayidx623=(($words+$308*12)&4294967295); //@line 2976 "translate.cpp"
                    var $pre_pause=(($arrayidx623+8)&4294967295); //@line 2976 "translate.cpp"
                    HEAP8[($pre_pause)]=$conv622; //@line 2976 "translate.cpp"
                    var $309=$all_upper_case; //@line 2977 "translate.cpp"
                    var $310=$word_flags; //@line 2977 "translate.cpp"
                    var $_b=HEAPU8[(__ZL13word_emphasis_b)];
                    var $311=($_b) ? 2048 : 0;
                    var $312=$word_count; //@line 2977 "translate.cpp"
                    var $arrayidx626=(($words+$312*12)&4294967295); //@line 2977 "translate.cpp"
                    var $flags627=(($arrayidx626)&4294967295); //@line 2977 "translate.cpp"
                    var $313=HEAP32[(($flags627)>>2)]; //@line 2977 "translate.cpp"
                    var $or624=($310) | ($309); //@line 2977 "translate.cpp"
                    var $or625=($or624) | ($311); //@line 2977 "translate.cpp"
                    var $or628=($or625) | ($313); //@line 2977 "translate.cpp"
                    HEAP32[(($flags627)>>2)]=$or628; //@line 2977 "translate.cpp"
                    var $314=$word_mark; //@line 2978 "translate.cpp"
                    var $conv629=((($314)) & 255); //@line 2978 "translate.cpp"
                    var $315=$word_count; //@line 2978 "translate.cpp"
                    var $arrayidx630=(($words+$315*12)&4294967295); //@line 2978 "translate.cpp"
                    var $wmark=(($arrayidx630+9)&4294967295); //@line 2978 "translate.cpp"
                    HEAP8[($wmark)]=$conv629; //@line 2978 "translate.cpp"
                    var $316=HEAP32[((_pre_pause)>>2)]; //@line 2980 "translate.cpp"
                    var $cmp631=((($316))|0) > 0; //@line 2980 "translate.cpp"
                    if ($cmp631) { __label__ = 213;; } else { __label__ = 216;; } //@line 2980 "translate.cpp"
                    if (__label__ == 213) {
  
                      var $317=$ix; //@line 2983 "translate.cpp"
                      $j=$317; //@line 2983 "translate.cpp"
                      var $318=$j; //@line 2983 "translate.cpp"
                      var $319=$word_count; //@line 2983 "translate.cpp"
                      var $arrayidx63438=(($words+$319*12)&4294967295); //@line 2983 "translate.cpp"
                      var $start63539=(($arrayidx63438+4)&4294967295); //@line 2983 "translate.cpp"
                      var $320=HEAPU16[(($start63539)>>1)]; //@line 2983 "translate.cpp"
                      var $conv63640=((($320))&65535); //@line 2983 "translate.cpp"
                      var $cmp63741=((($318))|0) > ((($conv63640))|0); //@line 2983 "translate.cpp"
                      var $321=$j; //@line 2985 "translate.cpp"
                      if ($cmp63741) { __lastLabel__ = 213; __label__ = 214;; } else { __lastLabel__ = 213; __label__ = 215;; } //@line 2983 "translate.cpp"
                      $for_body638$$for_end644$296: do { 
                        if (__label__ == 214) {
                          while(1) { 
  
                            var $322=__lastLabel__ == 214 ? $329 : ($321);
                            var $sub639=((($322)-1)&4294967295); //@line 2985 "translate.cpp"
                            var $arrayidx640=(($sbuf+$sub639)&4294967295); //@line 2985 "translate.cpp"
                            var $323=HEAP8[($arrayidx640)]; //@line 2985 "translate.cpp"
                            var $324=$j; //@line 2985 "translate.cpp"
                            var $arrayidx641=(($sbuf+$324)&4294967295); //@line 2985 "translate.cpp"
                            HEAP8[($arrayidx641)]=$323; //@line 2985 "translate.cpp"
                            var $325=$j; //@line 2983 "translate.cpp"
                            var $dec643=((($325)-1)&4294967295); //@line 2983 "translate.cpp"
                            $j=$dec643; //@line 2983 "translate.cpp"
                            var $326=$j; //@line 2983 "translate.cpp"
                            var $327=$word_count; //@line 2983 "translate.cpp"
                            var $arrayidx634=(($words+$327*12)&4294967295); //@line 2983 "translate.cpp"
                            var $start635=(($arrayidx634+4)&4294967295); //@line 2983 "translate.cpp"
                            var $328=HEAPU16[(($start635)>>1)]; //@line 2983 "translate.cpp"
                            var $conv636=((($328))&65535); //@line 2983 "translate.cpp"
                            var $cmp637=((($326))|0) > ((($conv636))|0); //@line 2983 "translate.cpp"
                            var $329=$j; //@line 2985 "translate.cpp"
                            if ($cmp637) { __lastLabel__ = 214; __label__ = 214;continue ; } else { __lastLabel__ = 214; __label__ = 215;break $for_body638$$for_end644$296; } //@line 2983 "translate.cpp"
                          }
                        }
                      } while(0);
  
                      var $_lcssa37=__lastLabel__ == 213 ? $321 : ($329);
                      var $arrayidx645=(($sbuf+$_lcssa37)&4294967295); //@line 2987 "translate.cpp"
                      HEAP8[($arrayidx645)]=32; //@line 2987 "translate.cpp"
                      var $330=$word_count; //@line 2988 "translate.cpp"
                      var $arrayidx646=(($words+$330*12)&4294967295); //@line 2988 "translate.cpp"
                      var $start647=(($arrayidx646+4)&4294967295); //@line 2988 "translate.cpp"
                      var $331=HEAP16[(($start647)>>1)]; //@line 2988 "translate.cpp"
                      var $inc648=((($331)+1)&65535); //@line 2988 "translate.cpp"
                      HEAP16[(($start647)>>1)]=$inc648; //@line 2988 "translate.cpp"
                      var $332=$ix; //@line 2989 "translate.cpp"
                      var $inc649=((($332)+1)&4294967295); //@line 2989 "translate.cpp"
                      $ix=$inc649; //@line 2989 "translate.cpp"
                      ; //@line 2990 "translate.cpp"
                    }
  
                    var $333=$word_count; //@line 2992 "translate.cpp"
                    var $inc651=((($333)+1)&4294967295); //@line 2992 "translate.cpp"
                    $word_count=$inc651; //@line 2992 "translate.cpp"
                    var $334=$ix; //@line 2993 "translate.cpp"
                    var $conv652=((($334)) & 65535); //@line 2993 "translate.cpp"
                    var $335=$word_count; //@line 2993 "translate.cpp"
                    var $arrayidx653=(($words+$335*12)&4294967295); //@line 2993 "translate.cpp"
                    var $start654=(($arrayidx653+4)&4294967295); //@line 2993 "translate.cpp"
                    HEAP16[(($start654)>>1)]=$conv652; //@line 2993 "translate.cpp"
                    var $336=$word_count; //@line 2994 "translate.cpp"
                    var $arrayidx655=(($words+$336*12)&4294967295); //@line 2994 "translate.cpp"
                    var $flags656=(($arrayidx655)&4294967295); //@line 2994 "translate.cpp"
                    HEAP32[(($flags656)>>2)]=0; //@line 2994 "translate.cpp"
                    var $337=HEAP32[(($source_index)>>2)]; //@line 2996 "translate.cpp"
                    $j=$337; //@line 2996 "translate.cpp"
                    var $338=$j; //@line 2996 "translate.cpp"
                    var $arrayidx65844=(($charix+$338*2)&4294967295); //@line 2996 "translate.cpp"
                    var $339=HEAP16[(($arrayidx65844)>>1)]; //@line 2996 "translate.cpp"
                    var $conv65945=(tempInt=(($339)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2996 "translate.cpp"
                    var $cmp66046=((($conv65945))|0) <= 0; //@line 2996 "translate.cpp"
                    var $340=$j; //@line 2996 "translate.cpp"
                    if ($cmp66046) { __lastLabel__ = 216; __label__ = 217;; } else { __lastLabel__ = 216; __label__ = 218;; } //@line 2996 "translate.cpp"
                    $for_inc662$$for_end664$301: do { 
                      if (__label__ == 217) {
                        while(1) { 
  
                          var $341=__lastLabel__ == 217 ? $344 : ($340);
                          var $inc663=((($341)+1)&4294967295); //@line 2996 "translate.cpp"
                          $j=$inc663; //@line 2996 "translate.cpp"
                          var $342=$j; //@line 2996 "translate.cpp"
                          var $arrayidx658=(($charix+$342*2)&4294967295); //@line 2996 "translate.cpp"
                          var $343=HEAP16[(($arrayidx658)>>1)]; //@line 2996 "translate.cpp"
                          var $conv659=(tempInt=(($343)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2996 "translate.cpp"
                          var $cmp660=((($conv659))|0) <= 0; //@line 2996 "translate.cpp"
                          var $344=$j; //@line 2996 "translate.cpp"
                          if ($cmp660) { __lastLabel__ = 217; __label__ = 217;continue ; } else { __lastLabel__ = 217; __label__ = 218;break $for_inc662$$for_end664$301; } //@line 2996 "translate.cpp"
                        }
                      }
                    } while(0);
  
                    var $_lcssa43=__lastLabel__ == 216 ? $340 : ($344);
                    var $arrayidx665=(($charix+$_lcssa43*2)&4294967295); //@line 2997 "translate.cpp"
                    var $345=HEAP16[(($arrayidx665)>>1)]; //@line 2997 "translate.cpp"
                    var $346=$word_count; //@line 2997 "translate.cpp"
                    var $arrayidx666=(($words+$346*12)&4294967295); //@line 2997 "translate.cpp"
                    var $sourceix667=(($arrayidx666+6)&4294967295); //@line 2997 "translate.cpp"
                    HEAP16[(($sourceix667)>>1)]=$345; //@line 2997 "translate.cpp"
                    $k=0; //@line 2998 "translate.cpp"
                    var $347=$j; //@line 2999 "translate.cpp"
                    var $arrayidx66948=(($charix+$347*2)&4294967295); //@line 2999 "translate.cpp"
                    var $348=HEAP16[(($arrayidx66948)>>1)]; //@line 2999 "translate.cpp"
                    var $conv67049=(tempInt=(($348)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2999 "translate.cpp"
                    var $cmp67150=((($conv67049))|0)!=0; //@line 2999 "translate.cpp"
                    if ($cmp67150) { __label__ = 219;; } else { __label__ = 222;; } //@line 2999 "translate.cpp"
                    $while_body672$$while_end680$305: do { 
                      if (__label__ == 219) {
                        while(1) { 
  
                          var $349=$j; //@line 3002 "translate.cpp"
                          var $inc673=((($349)+1)&4294967295); //@line 3002 "translate.cpp"
                          $j=$inc673; //@line 3002 "translate.cpp"
                          var $arrayidx674=(($charix+$349*2)&4294967295); //@line 3002 "translate.cpp"
                          var $350=HEAP16[(($arrayidx674)>>1)]; //@line 3002 "translate.cpp"
                          var $conv675=(tempInt=(($350)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 3002 "translate.cpp"
                          var $cmp676=((($conv675))|0)!=-1; //@line 3002 "translate.cpp"
                          if ($cmp676) { __label__ = 220;; } else { __label__ = 221;; } //@line 3002 "translate.cpp"
                          if (__label__ == 220) {
  
                            var $351=$k; //@line 3003 "translate.cpp"
                            var $inc678=((($351)+1)&4294967295); //@line 3003 "translate.cpp"
                            $k=$inc678; //@line 3003 "translate.cpp"
                            ; //@line 3003 "translate.cpp"
                          }
  
                          var $352=$j; //@line 2999 "translate.cpp"
                          var $arrayidx669=(($charix+$352*2)&4294967295); //@line 2999 "translate.cpp"
                          var $353=HEAP16[(($arrayidx669)>>1)]; //@line 2999 "translate.cpp"
                          var $conv670=(tempInt=(($353)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 2999 "translate.cpp"
                          var $cmp671=((($conv670))|0)!=0; //@line 2999 "translate.cpp"
                          if ($cmp671) { __label__ = 219;continue ; } else { __label__ = 222;break $while_body672$$while_end680$305; } //@line 2999 "translate.cpp"
                        }
                      }
                    } while(0);
  
                    var $354=$k; //@line 3005 "translate.cpp"
                    var $conv681=((($354)) & 255); //@line 3005 "translate.cpp"
                    var $355=$word_count; //@line 3005 "translate.cpp"
                    var $arrayidx682=(($words+$355*12)&4294967295); //@line 3005 "translate.cpp"
                    var $length683=(($arrayidx682+10)&4294967295); //@line 3005 "translate.cpp"
                    HEAP8[($length683)]=$conv681; //@line 3005 "translate.cpp"
                    var $356=$next_word_flags; //@line 3007 "translate.cpp"
                    $word_flags=$356; //@line 3007 "translate.cpp"
                    $next_word_flags=0; //@line 3008 "translate.cpp"
                    HEAP32[((_pre_pause)>>2)]=0; //@line 3009 "translate.cpp"
                    $word_mark=0; //@line 3010 "translate.cpp"
                    $all_upper_case=1; //@line 3011 "translate.cpp"
                    $syllable_marked=0; //@line 3012 "translate.cpp"
                    ; //@line 3013 "translate.cpp"
                  }
                } while(0);
  
                var $357=$space_inserted; //@line 3015 "translate.cpp"
                var $tobool685=((($357))|0)!=0; //@line 3015 "translate.cpp"
                if (!($tobool685)) { __label__ = 227;break $if_then570$$if_else688$269; } //@line 3015 "translate.cpp"
  
                var $358=$prev_source_index; //@line 3017 "translate.cpp"
                HEAP32[(($source_index)>>2)]=$358; //@line 3017 "translate.cpp"
                HEAP32[(($char_inserted)>>2)]=0; //@line 3018 "translate.cpp"
                $space_inserted=0; //@line 3019 "translate.cpp"
                ; //@line 3020 "translate.cpp"
              }
            }
            else if (__label__ == 225) {
  
              var $359=$ix; //@line 3024 "translate.cpp"
              var $cmp689=((($359))|0) < 696; //@line 3024 "translate.cpp"
              if (!($cmp689)) { __label__ = 227;break $if_then570$$if_else688$269; } //@line 3024 "translate.cpp"
  
              var $360=$c; //@line 3025 "translate.cpp"
              var $361=$ix; //@line 3025 "translate.cpp"
              var $arrayidx691=(($sbuf+$361)&4294967295); //@line 3025 "translate.cpp"
              var $call692=__Z8utf8_outjPc($360, $arrayidx691); //@line 3025 "translate.cpp"
              var $362=$ix; //@line 3025 "translate.cpp"
              var $add693=((($362)+($call692))&4294967295); //@line 3025 "translate.cpp"
              $ix=$add693; //@line 3025 "translate.cpp"
              ; //@line 3025 "translate.cpp"
            }
          } while(0);
  
          var $363=$pre_pause_add; //@line 3027 "translate.cpp"
          var $364=HEAP32[((_pre_pause)>>2)]; //@line 3027 "translate.cpp"
          var $cmp696=((($363))|0) > ((($364))|0); //@line 3027 "translate.cpp"
          if ($cmp696) { __label__ = 228;; } else { __label__ = 229;; } //@line 3027 "translate.cpp"
          if (__label__ == 228) {
  
            var $365=$pre_pause_add; //@line 3028 "translate.cpp"
            HEAP32[((_pre_pause)>>2)]=$365; //@line 3028 "translate.cpp"
            ; //@line 3028 "translate.cpp"
          }
  
          $pre_pause_add=0; //@line 3029 "translate.cpp"
          __label__ = 33;continue $while_cond88$50; //@line 3030 "translate.cpp"
        }
  
        var $366=$word_count; //@line 3032 "translate.cpp"
        var $cmp700=((($366))|0)==0; //@line 3032 "translate.cpp"
        if ($cmp700) { __label__ = 231;; } else { __label__ = 233;; } //@line 3032 "translate.cpp"
        $land_lhs_true701$$if_end710$321: do { 
          if (__label__ == 231) {
  
            var $367=$embedded_count; //@line 3032 "translate.cpp"
            var $cmp702=((($367))|0) > 0; //@line 3032 "translate.cpp"
            if (!($cmp702)) { __label__ = 233;break $land_lhs_true701$$if_end710$321; } //@line 3032 "translate.cpp"
  
            var $368=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 3035 "translate.cpp"
            var $sub704=((($368)-1)&4294967295); //@line 3035 "translate.cpp"
            var $arrayidx705=((_embedded_list+$sub704*4)&4294967295); //@line 3035 "translate.cpp"
            var $369=HEAP32[(($arrayidx705)>>2)]; //@line 3035 "translate.cpp"
            var $or706=($369) | 128; //@line 3035 "translate.cpp"
            HEAP32[(($arrayidx705)>>2)]=$or706; //@line 3035 "translate.cpp"
            var $370=$word_count; //@line 3036 "translate.cpp"
            var $arrayidx707=(($words+$370*12)&4294967295); //@line 3036 "translate.cpp"
            var $flags708=(($arrayidx707)&4294967295); //@line 3036 "translate.cpp"
            var $371=HEAP32[(($flags708)>>2)]; //@line 3036 "translate.cpp"
            var $or709=($371) | 64; //@line 3036 "translate.cpp"
            HEAP32[(($flags708)>>2)]=$or709; //@line 3036 "translate.cpp"
            $word_count=1; //@line 3037 "translate.cpp"
            ; //@line 3038 "translate.cpp"
          }
        } while(0);
  
        var $372=$ix; //@line 3040 "translate.cpp"
        var $sub711=((($372)-1)&4294967295); //@line 3040 "translate.cpp"
        var $arrayidx712=(($sbuf+$sub711)&4294967295); //@line 3040 "translate.cpp"
        var $373=$tr_addr; //@line 3040 "translate.cpp"
        var $clause_end=(($373+8292)&4294967295); //@line 3040 "translate.cpp"
        HEAP32[(($clause_end)>>2)]=$arrayidx712; //@line 3040 "translate.cpp"
        var $374=$ix; //@line 3041 "translate.cpp"
        var $arrayidx713=(($sbuf+$374)&4294967295); //@line 3041 "translate.cpp"
        HEAP8[($arrayidx713)]=0; //@line 3041 "translate.cpp"
        var $arrayidx714=(($words)&4294967295); //@line 3042 "translate.cpp"
        var $pre_pause715=(($arrayidx714+8)&4294967295); //@line 3042 "translate.cpp"
        HEAP8[($pre_pause715)]=0; //@line 3042 "translate.cpp"
        var $375=$word_count; //@line 3043 "translate.cpp"
        var $arrayidx716=(($words+$375*12)&4294967295); //@line 3043 "translate.cpp"
        var $pre_pause717=(($arrayidx716+8)&4294967295); //@line 3043 "translate.cpp"
        HEAP8[($pre_pause717)]=8; //@line 3043 "translate.cpp"
        var $376=$word_count; //@line 3044 "translate.cpp"
        var $cmp718=((($376))|0) > 0; //@line 3044 "translate.cpp"
        if ($cmp718) { __label__ = 234;; } else { __label__ = 241;; } //@line 3044 "translate.cpp"
        $if_then719$$if_end751$325: do { 
          if (__label__ == 234) {
  
            var $377=$word_count; //@line 3046 "translate.cpp"
            var $sub720=((($377)-1)&4294967295); //@line 3046 "translate.cpp"
            $ix=$sub720; //@line 3046 "translate.cpp"
            __lastLabel__ = 234; ; //@line 3047 "translate.cpp"
            while(1) { 
  
              var $378=__lastLabel__ == 237 ? $dec732 : ($sub720); //@line 3047 "translate.cpp"
              var $cmp722=((($378))|0) > 0; //@line 3047 "translate.cpp"
              var $379=$ix; //@line 3047 "translate.cpp"
              if ($cmp722) { __lastLabel__ = 235; ; } else { __lastLabel__ = 235; __label__ = 238;break ; } //@line 3047 "translate.cpp"
  
              var $arrayidx724=(($words+$379*12)&4294967295); //@line 3047 "translate.cpp"
              var $start725=(($arrayidx724+4)&4294967295); //@line 3047 "translate.cpp"
              var $380=HEAPU16[(($start725)>>1)]; //@line 3047 "translate.cpp"
              var $idxprom=((($380))&65535); //@line 3047 "translate.cpp"
              var $arrayidx726=(($sbuf+$idxprom)&4294967295); //@line 3047 "translate.cpp"
              var $381=HEAP8[($arrayidx726)]; //@line 3047 "translate.cpp"
              var $conv727=(tempInt=(($381)),(tempInt>=128?tempInt-256:tempInt)); //@line 3047 "translate.cpp"
              var $call728=__Z9IsBracketi($conv727); //@line 3047 "translate.cpp"
              var $tobool729=((($call728))|0)!=0; //@line 3047 "translate.cpp"
              var $382=$ix; //@line 3048 "translate.cpp"
              if ($tobool729) { __lastLabel__ = 236; ; } else { __lastLabel__ = 236; __label__ = 238;break ; }
  
              var $dec732=((($382)-1)&4294967295); //@line 3048 "translate.cpp"
              $ix=$dec732; //@line 3048 "translate.cpp"
              __lastLabel__ = 237; __label__ = 235;continue ; //@line 3048 "translate.cpp"
            }
  
            var $383=__lastLabel__ == 236 ? $382 : ($379);
            var $arrayidx734=(($words+$383*12)&4294967295); //@line 3049 "translate.cpp"
            var $flags735=(($arrayidx734)&4294967295); //@line 3049 "translate.cpp"
            var $384=HEAP32[(($flags735)>>2)]; //@line 3049 "translate.cpp"
            var $or736=($384) | 16; //@line 3049 "translate.cpp"
            HEAP32[(($flags735)>>2)]=$or736; //@line 3049 "translate.cpp"
            var $385=$terminator; //@line 3052 "translate.cpp"
            var $and737=($385) & 4194304; //@line 3052 "translate.cpp"
            var $tobool738=((($and737))|0)!=0; //@line 3052 "translate.cpp"
            if (!($tobool738)) { __label__ = 241;break $if_then719$$if_end751$325; } //@line 3052 "translate.cpp"
  
            var $386=$word_count; //@line 3052 "translate.cpp"
            var $sub740=((($386)-1)&4294967295); //@line 3052 "translate.cpp"
            var $arrayidx741=(($words+$sub740*12)&4294967295); //@line 3052 "translate.cpp"
            var $flags742=(($arrayidx741)&4294967295); //@line 3052 "translate.cpp"
            var $387=HEAP32[(($flags742)>>2)]; //@line 3052 "translate.cpp"
            var $and743=($387) & 256; //@line 3052 "translate.cpp"
            var $tobool744=((($and743))|0)!=0; //@line 3052 "translate.cpp"
            if ($tobool744) { __label__ = 241;break $if_then719$$if_end751$325; } //@line 3052 "translate.cpp"
  
            var $388=$word_count; //@line 3053 "translate.cpp"
            var $sub746=((($388)-1)&4294967295); //@line 3053 "translate.cpp"
            var $arrayidx747=(($words+$sub746*12)&4294967295); //@line 3053 "translate.cpp"
            var $flags748=(($arrayidx747)&4294967295); //@line 3053 "translate.cpp"
            var $389=HEAP32[(($flags748)>>2)]; //@line 3053 "translate.cpp"
            var $or749=($389) | 65536; //@line 3053 "translate.cpp"
            HEAP32[(($flags748)>>2)]=$or749; //@line 3053 "translate.cpp"
            ; //@line 3053 "translate.cpp"
          }
        } while(0);
  
        var $arrayidx752=(($words)&4294967295); //@line 3055 "translate.cpp"
        var $flags753=(($arrayidx752)&4294967295); //@line 3055 "translate.cpp"
        var $390=HEAP32[(($flags753)>>2)]; //@line 3055 "translate.cpp"
        var $or754=($390) | 512; //@line 3055 "translate.cpp"
        HEAP32[(($flags753)>>2)]=$or754; //@line 3055 "translate.cpp"
        $ix=0; //@line 3058 "translate.cpp"
        var $391=$ix; //@line 3058 "translate.cpp"
        var $392=$word_count; //@line 3058 "translate.cpp"
        var $cmp75636=((($391))|0) < ((($392))|0); //@line 3058 "translate.cpp"
        if ($cmp75636) { __label__ = 242;; } else { __label__ = 296;; } //@line 3058 "translate.cpp"
        $for_body757_lr_ph$$for_end994$335: do { 
          if (__label__ == 242) {
  
            var $arraydecay781=(($number_buf)&4294967295); //@line 3086 "translate.cpp"
            var $arrayidx783=(($number_buf+130)&4294967295); //@line 3087 "translate.cpp"
            var $arraydecay816=(($number_buf)&4294967295); //@line 3104 "translate.cpp"
            var $sub_ptr_rhs_cast818=($arraydecay816); //@line 3104 "translate.cpp"
            var $arraydecay820=(($number_buf)&4294967295); //@line 3105 "translate.cpp"
            var $arrayidx836=(($number_buf)&4294967295); //@line 3117 "translate.cpp"
            var $arrayidx837=(($number_buf+1)&4294967295); //@line 3118 "translate.cpp"
            var $arrayidx850=(($number_buf+130)&4294967295); //@line 3126 "translate.cpp"
            var $arrayidx920=(($number_buf+1)&4294967295); //@line 3167 "translate.cpp"
            var $arraydecay967=(($number_buf)&4294967295); //@line 3191 "translate.cpp"
            var $arrayidx969=(($number_buf+2)&4294967295); //@line 3193 "translate.cpp"
            var $arrayidx970=(($number_buf+2)&4294967295); //@line 3194 "translate.cpp"
            ; //@line 3058 "translate.cpp"
            $for_body757$337: while(1) { 
  
              var $393=HEAP32[((_count_words)>>2)]; //@line 3069 "translate.cpp"
              var $inc758=((($393)+1)&4294967295); //@line 3069 "translate.cpp"
              HEAP32[((_count_words)>>2)]=$inc758; //@line 3069 "translate.cpp"
              var $394=HEAP32[((_skip_words)>>2)]; //@line 3070 "translate.cpp"
              var $cmp759=((($394))|0) > 0; //@line 3070 "translate.cpp"
              if ($cmp759) { __label__ = 244;; } else { __label__ = 246;; } //@line 3070 "translate.cpp"
              $if_then760$$if_end765$339: do { 
                if (__label__ == 244) {
  
                  var $395=HEAP32[((_skip_words)>>2)]; //@line 3072 "translate.cpp"
                  var $dec761=((($395)-1)&4294967295); //@line 3072 "translate.cpp"
                  HEAP32[((_skip_words)>>2)]=$dec761; //@line 3072 "translate.cpp"
                  var $396=HEAP32[((_skip_words)>>2)]; //@line 3073 "translate.cpp"
                  var $cmp762=((($396))|0)==0; //@line 3073 "translate.cpp"
                  if (!($cmp762)) { __label__ = 246;break $if_then760$$if_end765$339; } //@line 3073 "translate.cpp"
  
                  HEAP32[((_skipping_text)>>2)]=0; //@line 3074 "translate.cpp"
                  __label__ = 247;break $if_then760$$if_end765$339; //@line 3076 "translate.cpp"
                }
              } while(0);
              $if_end768$$if_end765$342: do { 
                if (__label__ == 246) {
  
                  var $_pr22=HEAP32[((_skipping_text)>>2)]; //@line 3076 "translate.cpp"
                  var $tobool766=((($_pr22))|0)!=0; //@line 3076 "translate.cpp"
                  if ($tobool766) { __label__ = 295;break $if_end768$$if_end765$342; } else { __label__ = 247;break $if_end768$$if_end765$342; } //@line 3076 "translate.cpp"
                }
              } while(0);
              $if_end768$$for_inc992$344: do { 
                if (__label__ == 247) {
  
                  var $397=$ix; //@line 3081 "translate.cpp"
                  var $arrayidx769=(($words+$397*12)&4294967295); //@line 3081 "translate.cpp"
                  var $start770=(($arrayidx769+4)&4294967295); //@line 3081 "translate.cpp"
                  var $398=HEAPU16[(($start770)>>1)]; //@line 3081 "translate.cpp"
                  var $idxprom771=((($398))&65535); //@line 3081 "translate.cpp"
                  var $arrayidx772=(($sbuf+$idxprom771)&4294967295); //@line 3081 "translate.cpp"
                  $pw=$arrayidx772; //@line 3081 "translate.cpp"
                  $word=$arrayidx772; //@line 3081 "translate.cpp"
                  var $399=$word; //@line 3083 "translate.cpp"
                  var $arrayidx773=(($399)&4294967295); //@line 3083 "translate.cpp"
                  var $400=HEAP8[($arrayidx773)]; //@line 3083 "translate.cpp"
                  var $conv774=(tempInt=(($400)),(tempInt>=128?tempInt-256:tempInt)); //@line 3083 "translate.cpp"
                  var $call775=_iswdigit($conv774); //@line 3083 "translate.cpp"
                  var $tobool776=((($call775))|0)!=0; //@line 3083 "translate.cpp"
                  if ($tobool776) { __label__ = 248;; } else { __label__ = 261;; } //@line 3083 "translate.cpp"
                  $land_lhs_true777$$if_end824$346: do { 
                    if (__label__ == 248) {
  
                      var $401=$tr_addr; //@line 3083 "translate.cpp"
                      var $langopts778=(($401)&4294967295); //@line 3083 "translate.cpp"
                      var $break_numbers=(($langopts778+192)&4294967295); //@line 3083 "translate.cpp"
                      var $402=HEAP32[(($break_numbers)>>2)]; //@line 3083 "translate.cpp"
                      var $cmp779=((($402))|0)!=1227133512; //@line 3083 "translate.cpp"
                      if (!($cmp779)) { __label__ = 261;break $land_lhs_true777$$if_end824$346; } //@line 3083 "translate.cpp"
  
                      $pn=$arraydecay781; //@line 3086 "translate.cpp"
                      ; //@line 3087 "translate.cpp"
                      while(1) { 
  
                        var $403=$pn; //@line 3087 "translate.cpp"
                        var $cmp784=((($403))>>>0) < ((($arrayidx783))>>>0); //@line 3087 "translate.cpp"
                        if (!($cmp784)) { __label__ = 260;break ; } //@line 3087 "translate.cpp"
  
                        var $404=$pw; //@line 3089 "translate.cpp"
                        var $405=HEAP8[($404)]; //@line 3089 "translate.cpp"
                        var $conv786=(tempInt=(($405)),(tempInt>=128?tempInt-256:tempInt)); //@line 3089 "translate.cpp"
                        var $call787=_iswdigit($conv786); //@line 3089 "translate.cpp"
                        var $tobool788=((($call787))|0)!=0; //@line 3089 "translate.cpp"
                        var $406=$pw; //@line 3091 "translate.cpp"
                        if ($tobool788) { __label__ = 252;; } else { __label__ = 253;; } //@line 3089 "translate.cpp"
                        if (__label__ == 252) {
  
                          var $incdec_ptr790=(($406+1)&4294967295); //@line 3091 "translate.cpp"
                          $pw=$incdec_ptr790; //@line 3091 "translate.cpp"
                          var $407=HEAP8[($406)]; //@line 3091 "translate.cpp"
                          var $408=$pn; //@line 3091 "translate.cpp"
                          var $incdec_ptr791=(($408+1)&4294967295); //@line 3091 "translate.cpp"
                          $pn=$incdec_ptr791; //@line 3091 "translate.cpp"
                          HEAP8[($408)]=$407; //@line 3091 "translate.cpp"
                          __label__ = 250;continue ; //@line 3092 "translate.cpp"
                        }
                        else if (__label__ == 253) {
  
                          var $409=HEAP8[($406)]; //@line 3094 "translate.cpp"
                          var $conv793=(tempInt=(($409)),(tempInt>=128?tempInt-256:tempInt)); //@line 3094 "translate.cpp"
                          var $410=$tr_addr; //@line 3094 "translate.cpp"
                          var $langopts794=(($410)&4294967295); //@line 3094 "translate.cpp"
                          var $thousands_sep=(($langopts794+204)&4294967295); //@line 3094 "translate.cpp"
                          var $411=HEAP32[(($thousands_sep)>>2)]; //@line 3094 "translate.cpp"
                          var $cmp795=((($conv793))|0)==((($411))|0); //@line 3094 "translate.cpp"
                          if (!($cmp795)) { __label__ = 259;break ; } //@line 3094 "translate.cpp"
  
                          var $412=$pw; //@line 3094 "translate.cpp"
                          var $arrayidx797=(($412+1)&4294967295); //@line 3094 "translate.cpp"
                          var $413=HEAP8[($arrayidx797)]; //@line 3094 "translate.cpp"
                          var $conv798=(tempInt=(($413)),(tempInt>=128?tempInt-256:tempInt)); //@line 3094 "translate.cpp"
                          var $cmp799=((($conv798))|0)==32; //@line 3094 "translate.cpp"
                          if (!($cmp799)) { __label__ = 259;break ; } //@line 3094 "translate.cpp"
  
                          var $414=$pw; //@line 3095 "translate.cpp"
                          var $arrayidx801=(($414+2)&4294967295); //@line 3095 "translate.cpp"
                          var $415=HEAP8[($arrayidx801)]; //@line 3095 "translate.cpp"
                          var $conv802=(tempInt=(($415)),(tempInt>=128?tempInt-256:tempInt)); //@line 3095 "translate.cpp"
                          var $call803=_iswdigit($conv802); //@line 3095 "translate.cpp"
                          var $tobool804=((($call803))|0)!=0; //@line 3095 "translate.cpp"
                          if (!($tobool804)) { __label__ = 259;break ; } //@line 3095 "translate.cpp"
  
                          var $416=$pw; //@line 3095 "translate.cpp"
                          var $arrayidx806=(($416+3)&4294967295); //@line 3095 "translate.cpp"
                          var $417=HEAP8[($arrayidx806)]; //@line 3095 "translate.cpp"
                          var $conv807=(tempInt=(($417)),(tempInt>=128?tempInt-256:tempInt)); //@line 3095 "translate.cpp"
                          var $cmp808=((($conv807))|0)!=32; //@line 3095 "translate.cpp"
                          if (!($cmp808)) { __label__ = 259;break ; } //@line 3095 "translate.cpp"
  
                          var $418=$pw; //@line 3095 "translate.cpp"
                          var $arrayidx810=(($418+4)&4294967295); //@line 3095 "translate.cpp"
                          var $419=HEAP8[($arrayidx810)]; //@line 3095 "translate.cpp"
                          var $conv811=(tempInt=(($419)),(tempInt>=128?tempInt-256:tempInt)); //@line 3095 "translate.cpp"
                          var $cmp812=((($conv811))|0)!=32; //@line 3095 "translate.cpp"
                          if (!($cmp812)) { __label__ = 259;break ; } //@line 3095 "translate.cpp"
  
                          var $420=$pw; //@line 3097 "translate.cpp"
                          var $add_ptr=(($420+2)&4294967295); //@line 3097 "translate.cpp"
                          $pw=$add_ptr; //@line 3097 "translate.cpp"
                          var $421=$ix; //@line 3098 "translate.cpp"
                          var $inc814=((($421)+1)&4294967295); //@line 3098 "translate.cpp"
                          $ix=$inc814; //@line 3098 "translate.cpp"
                          __label__ = 250;continue ;
                        }
                      }
                      if (__label__ == 259) {
  
                        var $422=$pw; //@line 3102 "translate.cpp"
                        var $423=$word; //@line 3102 "translate.cpp"
                        var $sub_ptr_lhs_cast=($422); //@line 3102 "translate.cpp"
                        var $sub_ptr_rhs_cast=($423); //@line 3102 "translate.cpp"
                        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 3102 "translate.cpp"
                        $nx=$sub_ptr_sub; //@line 3102 "translate.cpp"
                        var $424=$word; //@line 3103 "translate.cpp"
                        var $425=$nx; //@line 3103 "translate.cpp"
                        var $dest$, $stop$, $stop4$, $fast$, $value4$;
                        $dest$ = $424;
                        $stop$ = $dest$ + $425;
                        $value4$ = 32;
                        if ($value4$ < 0) $value4$ += 256;
                        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
                        while ($dest$%4 !== 0 && $dest$ < $stop$) {
                          ;; HEAP8[$dest$++] = 32;
                        }
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($dest$ < $stop4$) {
                        ;;;;;;;  HEAP32[$dest$++] = $value4$;
                        }
                        $dest$ <<= 2;
                        while ($dest$ < $stop$) {
                          ;; HEAP8[$dest$++] = 32;
                        }; //@line 3103 "translate.cpp"
                        var $426=$pn; //@line 3104 "translate.cpp"
                        var $sub_ptr_lhs_cast817=($426); //@line 3104 "translate.cpp"
                        var $sub_ptr_sub819=((($sub_ptr_lhs_cast817)-($sub_ptr_rhs_cast818))&4294967295); //@line 3104 "translate.cpp"
                        $nx=$sub_ptr_sub819; //@line 3104 "translate.cpp"
                        var $427=$word; //@line 3105 "translate.cpp"
                        var $428=$nx; //@line 3105 "translate.cpp"
                        var $src$, $dest$, $stop$, $stop4$, $fast$;
                        $src$ = $arraydecay820;
                        $dest$ = $427;
                        $stop$ = $src$ + $428;
                        if (($dest$%4) == ($src$%4) && $428 > 8) {
                          while ($src$%4 !== 0 && $src$ < $stop$) {
                            ; HEAP8[$dest$++] = HEAP8[$src$++];
                          }
                          $src$ >>= 2;
                          $dest$ >>= 2;
                          $stop4$ = $stop$ >> 2;
                          while ($src$ < $stop4$) {
                        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                          }
                          $src$ <<= 2;
                          $dest$ <<= 2;
                        }while ($src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }; //@line 3105 "translate.cpp"
                        ; //@line 3106 "translate.cpp"
                      }
  
                      var $429=$word; //@line 3109 "translate.cpp"
                      $pw=$429; //@line 3109 "translate.cpp"
                      ; //@line 3110 "translate.cpp"
                    }
                  } while(0);
  
                  $n_digits=0; //@line 3112 "translate.cpp"
                  var $430=$n_digits; //@line 3112 "translate.cpp"
                  var $431=$word; //@line 3112 "translate.cpp"
                  var $arrayidx82630=(($431+$430)&4294967295); //@line 3112 "translate.cpp"
                  var $432=HEAP8[($arrayidx82630)]; //@line 3112 "translate.cpp"
                  var $conv82731=(tempInt=(($432)),(tempInt>=128?tempInt-256:tempInt)); //@line 3112 "translate.cpp"
                  var $call82832=_iswdigit($conv82731); //@line 3112 "translate.cpp"
                  var $tobool82933=((($call82832))|0)!=0; //@line 3112 "translate.cpp"
                  var $433=$n_digits; //@line 3112 "translate.cpp"
                  if ($tobool82933) { __lastLabel__ = 261; __label__ = 262;; } else { __lastLabel__ = 261; __label__ = 263;; } //@line 3112 "translate.cpp"
                  $for_inc831$$for_end833$364: do { 
                    if (__label__ == 262) {
                      while(1) { 
  
                        var $434=__lastLabel__ == 262 ? $438 : ($433);
                        var $inc832=((($434)+1)&4294967295); //@line 3112 "translate.cpp"
                        $n_digits=$inc832; //@line 3112 "translate.cpp"
                        var $435=$n_digits; //@line 3112 "translate.cpp"
                        var $436=$word; //@line 3112 "translate.cpp"
                        var $arrayidx826=(($436+$435)&4294967295); //@line 3112 "translate.cpp"
                        var $437=HEAP8[($arrayidx826)]; //@line 3112 "translate.cpp"
                        var $conv827=(tempInt=(($437)),(tempInt>=128?tempInt-256:tempInt)); //@line 3112 "translate.cpp"
                        var $call828=_iswdigit($conv827); //@line 3112 "translate.cpp"
                        var $tobool829=((($call828))|0)!=0; //@line 3112 "translate.cpp"
                        var $438=$n_digits; //@line 3112 "translate.cpp"
                        if ($tobool829) { __lastLabel__ = 262; __label__ = 262;continue ; } else { __lastLabel__ = 262; __label__ = 263;break $for_inc831$$for_end833$364; } //@line 3112 "translate.cpp"
                      }
                    }
                  } while(0);
  
                  var $_lcssa29=__lastLabel__ == 261 ? $433 : ($438);
                  var $cmp834=((($_lcssa29))|0) > 4; //@line 3114 "translate.cpp"
                  if ($cmp834) { __label__ = 264;; } else { __label__ = 284;; } //@line 3114 "translate.cpp"
                  $if_then835$$if_else939$368: do { 
                    if (__label__ == 264) {
  
                      HEAP8[($arrayidx836)]=32; //@line 3117 "translate.cpp"
                      $pn=$arrayidx837; //@line 3118 "translate.cpp"
                      var $439=$n_digits; //@line 3119 "translate.cpp"
                      $nx=$439; //@line 3119 "translate.cpp"
                      $nw=0; //@line 3120 "translate.cpp"
                      $individual_digits=0; //@line 3121 "translate.cpp"
                      var $440=$n_digits; //@line 3123 "translate.cpp"
                      var $441=$tr_addr; //@line 3123 "translate.cpp"
                      var $langopts838=(($441)&4294967295); //@line 3123 "translate.cpp"
                      var $max_digits=(($langopts838+212)&4294967295); //@line 3123 "translate.cpp"
                      var $442=HEAP32[(($max_digits)>>2)]; //@line 3123 "translate.cpp"
                      var $cmp839=((($440))|0) > ((($442))|0); //@line 3123 "translate.cpp"
                      if ($cmp839) { __label__ = 266;; } else { __label__ = 265;; } //@line 3123 "translate.cpp"
                      $if_then844$$lor_lhs_false840$370: do { 
                        if (__label__ == 265) {
  
                          var $443=$word; //@line 3123 "translate.cpp"
                          var $arrayidx841=(($443)&4294967295); //@line 3123 "translate.cpp"
                          var $444=HEAP8[($arrayidx841)]; //@line 3123 "translate.cpp"
                          var $conv842=(tempInt=(($444)),(tempInt>=128?tempInt-256:tempInt)); //@line 3123 "translate.cpp"
                          var $cmp843=((($conv842))|0)==48; //@line 3123 "translate.cpp"
                          if ($cmp843) { __label__ = 266;break $if_then844$$lor_lhs_false840$370; } else { __label__ = 267;break $if_then844$$lor_lhs_false840$370; } //@line 3123 "translate.cpp"
                        }
                      } while(0);
                      if (__label__ == 266) {
  
                        var $445=$ix; //@line 3124 "translate.cpp"
                        var $arrayidx845=(($words+$445*12)&4294967295); //@line 3124 "translate.cpp"
                        var $flags846=(($arrayidx845)&4294967295); //@line 3124 "translate.cpp"
                        var $446=HEAP32[(($flags846)>>2)]; //@line 3124 "translate.cpp"
                        var $or847=($446) | 524288; //@line 3124 "translate.cpp"
                        HEAP32[(($flags846)>>2)]=$or847; //@line 3124 "translate.cpp"
                        ; //@line 3124 "translate.cpp"
                      }
                      $while_cond849$374: while(1) { 
  
                        var $447=$pn; //@line 3126 "translate.cpp"
                        var $cmp851=((($447))>>>0) < ((($arrayidx850))>>>0); //@line 3126 "translate.cpp"
                        if (!($cmp851)) { __label__ = 278;break $while_cond849$374; } //@line 3126 "translate.cpp"
  
                        var $448=$pw; //@line 3128 "translate.cpp"
                        var $incdec_ptr853=(($448+1)&4294967295); //@line 3128 "translate.cpp"
                        $pw=$incdec_ptr853; //@line 3128 "translate.cpp"
                        var $449=HEAP8[($448)]; //@line 3128 "translate.cpp"
                        var $conv854=(tempInt=(($449)),(tempInt>=128?tempInt-256:tempInt)); //@line 3128 "translate.cpp"
                        $c=$conv854; //@line 3128 "translate.cpp"
                        var $isdigittmp=((($conv854)-48)&4294967295); //@line 3128 "translate.cpp"
                        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 3128 "translate.cpp"
                        var $call855=((($isdigit))&1); //@line 3128 "translate.cpp"
                        var $tobool856=((($call855))|0)!=0; //@line 3128 "translate.cpp"
                        if ($tobool856) { __label__ = 270;; } else { __label__ = 269;; } //@line 3128 "translate.cpp"
                        if (__label__ == 269) {
  
                          var $450=$c; //@line 3128 "translate.cpp"
                          var $451=$tr_addr; //@line 3128 "translate.cpp"
                          var $langopts858=(($451)&4294967295); //@line 3128 "translate.cpp"
                          var $decimal_sep859=(($langopts858+208)&4294967295); //@line 3128 "translate.cpp"
                          var $452=HEAP32[(($decimal_sep859)>>2)]; //@line 3128 "translate.cpp"
                          var $cmp860=((($450))|0)!=((($452))|0); //@line 3128 "translate.cpp"
                          if ($cmp860) { __label__ = 278;break $while_cond849$374; } //@line 3128 "translate.cpp"
                        }
  
                        var $453=$c; //@line 3131 "translate.cpp"
                        var $conv863=((($453)) & 255); //@line 3131 "translate.cpp"
                        var $454=$pn; //@line 3131 "translate.cpp"
                        var $incdec_ptr864=(($454+1)&4294967295); //@line 3131 "translate.cpp"
                        $pn=$incdec_ptr864; //@line 3131 "translate.cpp"
                        HEAP8[($454)]=$conv863; //@line 3131 "translate.cpp"
                        var $455=$nx; //@line 3132 "translate.cpp"
                        var $dec865=((($455)-1)&4294967295); //@line 3132 "translate.cpp"
                        $nx=$dec865; //@line 3132 "translate.cpp"
                        var $cmp866=((($dec865))|0) > 0; //@line 3132 "translate.cpp"
                        if (!($cmp866)) { __label__ = 267;continue $while_cond849$374; } //@line 3132 "translate.cpp"
  
                        var $456=$tr_addr; //@line 3132 "translate.cpp"
                        var $langopts868=(($456)&4294967295); //@line 3132 "translate.cpp"
                        var $break_numbers869=(($langopts868+192)&4294967295); //@line 3132 "translate.cpp"
                        var $457=HEAP32[(($break_numbers869)>>2)]; //@line 3132 "translate.cpp"
                        var $458=$nx; //@line 3132 "translate.cpp"
                        var $shl=1 << ($458); //@line 3132 "translate.cpp"
                        var $and870=($shl) & ($457); //@line 3132 "translate.cpp"
                        var $tobool871=((($and870))|0)!=0; //@line 3132 "translate.cpp"
                        if (!($tobool871)) { __label__ = 267;continue $while_cond849$374; } //@line 3132 "translate.cpp"
  
                        var $459=$nw; //@line 3134 "translate.cpp"
                        var $inc873=((($459)+1)&4294967295); //@line 3134 "translate.cpp"
                        $nw=$inc873; //@line 3134 "translate.cpp"
                        var $arrayidx874=(($num_wtab+$459*12)&4294967295); //@line 3134 "translate.cpp"
                        var $460=$arrayidx874; //@line 3134 "translate.cpp"
                        var $461=$ix; //@line 3134 "translate.cpp"
                        var $arrayidx875=(($words+$461*12)&4294967295); //@line 3134 "translate.cpp"
                        var $462=$arrayidx875; //@line 3134 "translate.cpp"
                        var $src$, $dest$, $stop$, $stop4$, $fast$;
                        $src$ = $462;
                        $dest$ = $460;
                        $stop$ = $src$ + 12;
                        if (($dest$%4) == ($src$%4) && 12 > 8) {
                          while ($src$%4 !== 0 && $src$ < $stop$) {
                            ; HEAP8[$dest$++] = HEAP8[$src$++];
                          }
                          $src$ >>= 2;
                          $dest$ >>= 2;
                          $stop4$ = $stop$ >> 2;
                          while ($src$ < $stop4$) {
                        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                          }
                          $src$ <<= 2;
                          $dest$ <<= 2;
                        }while ($src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }; //@line 3134 "translate.cpp"
                        var $463=$tr_addr; //@line 3136 "translate.cpp"
                        var $langopts876=(($463)&4294967295); //@line 3136 "translate.cpp"
                        var $thousands_sep877=(($langopts876+204)&4294967295); //@line 3136 "translate.cpp"
                        var $464=HEAP32[(($thousands_sep877)>>2)]; //@line 3136 "translate.cpp"
                        var $cmp878=((($464))|0)!=32; //@line 3136 "translate.cpp"
                        if ($cmp878) { __label__ = 273;; } else { __label__ = 274;; } //@line 3136 "translate.cpp"
                        if (__label__ == 273) {
  
                          var $465=$tr_addr; //@line 3138 "translate.cpp"
                          var $langopts880=(($465)&4294967295); //@line 3138 "translate.cpp"
                          var $thousands_sep881=(($langopts880+204)&4294967295); //@line 3138 "translate.cpp"
                          var $466=HEAP32[(($thousands_sep881)>>2)]; //@line 3138 "translate.cpp"
                          var $conv882=((($466)) & 255); //@line 3138 "translate.cpp"
                          var $467=$pn; //@line 3138 "translate.cpp"
                          var $incdec_ptr883=(($467+1)&4294967295); //@line 3138 "translate.cpp"
                          $pn=$incdec_ptr883; //@line 3138 "translate.cpp"
                          HEAP8[($467)]=$conv882; //@line 3138 "translate.cpp"
                          ; //@line 3139 "translate.cpp"
                        }
  
                        var $468=$pn; //@line 3140 "translate.cpp"
                        var $incdec_ptr885=(($468+1)&4294967295); //@line 3140 "translate.cpp"
                        $pn=$incdec_ptr885; //@line 3140 "translate.cpp"
                        HEAP8[($468)]=32; //@line 3140 "translate.cpp"
                        var $469=$tr_addr; //@line 3141 "translate.cpp"
                        var $langopts886=(($469)&4294967295); //@line 3141 "translate.cpp"
                        var $break_numbers887=(($langopts886+192)&4294967295); //@line 3141 "translate.cpp"
                        var $470=HEAP32[(($break_numbers887)>>2)]; //@line 3141 "translate.cpp"
                        var $471=$nx; //@line 3141 "translate.cpp"
                        var $sub888=((($471)-1)&4294967295); //@line 3141 "translate.cpp"
                        var $shl889=1 << ($sub888); //@line 3141 "translate.cpp"
                        var $and890=($shl889) & ($470); //@line 3141 "translate.cpp"
                        var $tobool891=((($and890))|0)!=0; //@line 3141 "translate.cpp"
                        if ($tobool891) { __label__ = 275;; } else { __label__ = 276;; } //@line 3141 "translate.cpp"
                        if (__label__ == 275) {
  
                          var $472=$pn; //@line 3144 "translate.cpp"
                          var $incdec_ptr893=(($472+1)&4294967295); //@line 3144 "translate.cpp"
                          $pn=$incdec_ptr893; //@line 3144 "translate.cpp"
                          HEAP8[($472)]=48; //@line 3144 "translate.cpp"
                          var $473=$pn; //@line 3145 "translate.cpp"
                          var $incdec_ptr894=(($473+1)&4294967295); //@line 3145 "translate.cpp"
                          $pn=$incdec_ptr894; //@line 3145 "translate.cpp"
                          HEAP8[($473)]=48; //@line 3145 "translate.cpp"
                          ; //@line 3146 "translate.cpp"
                        }
  
                        var $474=$tr_addr; //@line 3147 "translate.cpp"
                        var $langopts896=(($474)&4294967295); //@line 3147 "translate.cpp"
                        var $break_numbers897=(($langopts896+192)&4294967295); //@line 3147 "translate.cpp"
                        var $475=HEAP32[(($break_numbers897)>>2)]; //@line 3147 "translate.cpp"
                        var $476=$nx; //@line 3147 "translate.cpp"
                        var $sub898=((($476)-2)&4294967295); //@line 3147 "translate.cpp"
                        var $shl899=1 << ($sub898); //@line 3147 "translate.cpp"
                        var $and900=($shl899) & ($475); //@line 3147 "translate.cpp"
                        var $tobool901=((($and900))|0)!=0; //@line 3147 "translate.cpp"
                        if (!($tobool901)) { __label__ = 267;continue $while_cond849$374; } //@line 3147 "translate.cpp"
  
                        var $477=$pn; //@line 3150 "translate.cpp"
                        var $incdec_ptr903=(($477+1)&4294967295); //@line 3150 "translate.cpp"
                        $pn=$incdec_ptr903; //@line 3150 "translate.cpp"
                        HEAP8[($477)]=48; //@line 3150 "translate.cpp"
                        __label__ = 267;continue $while_cond849$374; //@line 3151 "translate.cpp"
                      }
  
                      var $478=$pw; //@line 3154 "translate.cpp"
                      var $incdec_ptr907=(($478+-1)&4294967295); //@line 3154 "translate.cpp"
                      $pw=$incdec_ptr907; //@line 3154 "translate.cpp"
                      var $479=$nw; //@line 3155 "translate.cpp"
                      var $arrayidx908=(($num_wtab+$479*12)&4294967295); //@line 3155 "translate.cpp"
                      var $480=$arrayidx908; //@line 3155 "translate.cpp"
                      var $481=$ix; //@line 3155 "translate.cpp"
                      var $arrayidx909=(($words+$481*12)&4294967295); //@line 3155 "translate.cpp"
                      var $482=$arrayidx909; //@line 3155 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $482;
                      $dest$ = $480;
                      $stop$ = $src$ + 24;
                      if (($dest$%4) == ($src$%4) && 24 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 3155 "translate.cpp"
                      $j=1; //@line 3157 "translate.cpp"
                      var $483=$j; //@line 3157 "translate.cpp"
                      var $484=$nw; //@line 3157 "translate.cpp"
                      var $cmp91134=((($483))|0) <= ((($484))|0); //@line 3157 "translate.cpp"
                      if ($cmp91134) { __label__ = 279;; } else { __label__ = 280;; } //@line 3157 "translate.cpp"
                      $for_body912$$for_end918$390: do { 
                        if (__label__ == 279) {
                          while(1) { 
  
                            var $485=$j; //@line 3159 "translate.cpp"
                            var $arrayidx913=(($num_wtab+$485*12)&4294967295); //@line 3159 "translate.cpp"
                            var $flags914=(($arrayidx913)&4294967295); //@line 3159 "translate.cpp"
                            var $486=HEAP32[(($flags914)>>2)]; //@line 3159 "translate.cpp"
                            var $and915=($486) & -262209; //@line 3159 "translate.cpp"
                            HEAP32[(($flags914)>>2)]=$and915; //@line 3159 "translate.cpp"
                            var $487=$j; //@line 3157 "translate.cpp"
                            var $inc917=((($487)+1)&4294967295); //@line 3157 "translate.cpp"
                            $j=$inc917; //@line 3157 "translate.cpp"
                            var $488=$j; //@line 3157 "translate.cpp"
                            var $489=$nw; //@line 3157 "translate.cpp"
                            var $cmp911=((($488))|0) <= ((($489))|0); //@line 3157 "translate.cpp"
                            if ($cmp911) { __label__ = 279;continue ; } else { __label__ = 280;break $for_body912$$for_end918$390; } //@line 3157 "translate.cpp"
                          }
                        }
                      } while(0);
  
                      var $490=$pn; //@line 3163 "translate.cpp"
                      var $491=$pw; //@line 3163 "translate.cpp"
                      var $src$, $dest$, $stop$, $stop4$, $fast$;
                      $src$ = $491;
                      $dest$ = $490;
                      $stop$ = $src$ + 16;
                      if (($dest$%4) == ($src$%4) && 16 > 8) {
                        while ($src$%4 !== 0 && $src$ < $stop$) {
                          ; HEAP8[$dest$++] = HEAP8[$src$++];
                        }
                        $src$ >>= 2;
                        $dest$ >>= 2;
                        $stop4$ = $stop$ >> 2;
                        while ($src$ < $stop4$) {
                      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                        }
                        $src$ <<= 2;
                        $dest$ <<= 2;
                      }while ($src$ < $stop$) {
                        ; HEAP8[$dest$++] = HEAP8[$src$++];
                      }; //@line 3163 "translate.cpp"
                      var $492=$pn; //@line 3164 "translate.cpp"
                      var $arrayidx919=(($492+16)&4294967295); //@line 3164 "translate.cpp"
                      HEAP8[($arrayidx919)]=0; //@line 3164 "translate.cpp"
                      $nw=0; //@line 3165 "translate.cpp"
                      $pw=$arrayidx920; //@line 3167 "translate.cpp"
                      var $493=$pw; //@line 3167 "translate.cpp"
                      var $494=$pn; //@line 3167 "translate.cpp"
                      var $cmp92235=((($493))>>>0) < ((($494))>>>0); //@line 3167 "translate.cpp"
                      if (!($cmp92235)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3167 "translate.cpp"
                      $for_body923$394: while(1) { 
  
                        var $495=$tr_addr; //@line 3170 "translate.cpp"
                        var $496=$pw; //@line 3170 "translate.cpp"
                        var $497=$nw; //@line 3170 "translate.cpp"
                        var $inc924=((($497)+1)&4294967295); //@line 3170 "translate.cpp"
                        $nw=$inc924; //@line 3170 "translate.cpp"
                        var $arrayidx925=(($num_wtab+$497*12)&4294967295); //@line 3170 "translate.cpp"
                        var $498=$ix; //@line 3170 "translate.cpp"
                        var $arrayidx926=(($words+$498*12)&4294967295); //@line 3170 "translate.cpp"
                        var $pre_pause927=(($arrayidx926+8)&4294967295); //@line 3170 "translate.cpp"
                        var $499=HEAPU8[($pre_pause927)]; //@line 3170 "translate.cpp"
                        var $conv928=((($499))&255); //@line 3170 "translate.cpp"
                        var $call929=__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($495, $496, $arrayidx925, $conv928, 0); //@line 3170 "translate.cpp"
                        $dict_flags=$call929; //@line 3170 "translate.cpp"
                        ; //@line 3171 "translate.cpp"
                        while(1) { 
  
                          var $500=$pw; //@line 3171 "translate.cpp"
                          var $incdec_ptr931=(($500+1)&4294967295); //@line 3171 "translate.cpp"
                          $pw=$incdec_ptr931; //@line 3171 "translate.cpp"
                          var $501=HEAP8[($500)]; //@line 3171 "translate.cpp"
                          var $conv932=(tempInt=(($501)),(tempInt>=128?tempInt-256:tempInt)); //@line 3171 "translate.cpp"
                          var $cmp933=((($conv932))|0)!=32; //@line 3171 "translate.cpp"
                          if ($cmp933) { __label__ = 282;continue ; } else { __label__ = 283;break ; } //@line 3171 "translate.cpp"
                        }
  
                        var $502=$ix; //@line 3172 "translate.cpp"
                        var $arrayidx936=(($words+$502*12)&4294967295); //@line 3172 "translate.cpp"
                        var $pre_pause937=(($arrayidx936+8)&4294967295); //@line 3172 "translate.cpp"
                        HEAP8[($pre_pause937)]=0; //@line 3172 "translate.cpp"
                        var $503=$pw; //@line 3167 "translate.cpp"
                        var $504=$pn; //@line 3167 "translate.cpp"
                        var $cmp922=((($503))>>>0) < ((($504))>>>0); //@line 3167 "translate.cpp"
                        if ($cmp922) { __label__ = 281;continue $for_body923$394; } else { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3167 "translate.cpp"
                      }
                    }
                    else if (__label__ == 284) {
  
                      HEAP32[((_pre_pause)>>2)]=0; //@line 3177 "translate.cpp"
                      var $505=$tr_addr; //@line 3178 "translate.cpp"
                      var $506=$word; //@line 3178 "translate.cpp"
                      var $507=$ix; //@line 3178 "translate.cpp"
                      var $arrayidx940=(($words+$507*12)&4294967295); //@line 3178 "translate.cpp"
                      var $508=$ix; //@line 3178 "translate.cpp"
                      var $arrayidx941=(($words+$508*12)&4294967295); //@line 3178 "translate.cpp"
                      var $pre_pause942=(($arrayidx941+8)&4294967295); //@line 3178 "translate.cpp"
                      var $509=HEAPU8[($pre_pause942)]; //@line 3178 "translate.cpp"
                      var $conv943=((($509))&255); //@line 3178 "translate.cpp"
                      var $510=$ix; //@line 3178 "translate.cpp"
                      var $add944=((($510)+1)&4294967295); //@line 3178 "translate.cpp"
                      var $arrayidx945=(($words+$add944*12)&4294967295); //@line 3178 "translate.cpp"
                      var $pre_pause946=(($arrayidx945+8)&4294967295); //@line 3178 "translate.cpp"
                      var $511=HEAPU8[($pre_pause946)]; //@line 3178 "translate.cpp"
                      var $conv947=((($511))&255); //@line 3178 "translate.cpp"
                      var $call948=__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($505, $506, $arrayidx940, $conv943, $conv947); //@line 3178 "translate.cpp"
                      $dict_flags=$call948; //@line 3178 "translate.cpp"
                      var $512=HEAP32[((_pre_pause)>>2)]; //@line 3180 "translate.cpp"
                      var $513=$ix; //@line 3180 "translate.cpp"
                      var $add949=((($513)+1)&4294967295); //@line 3180 "translate.cpp"
                      var $arrayidx950=(($words+$add949*12)&4294967295); //@line 3180 "translate.cpp"
                      var $pre_pause951=(($arrayidx950+8)&4294967295); //@line 3180 "translate.cpp"
                      var $514=HEAPU8[($pre_pause951)]; //@line 3180 "translate.cpp"
                      var $conv952=((($514))&255); //@line 3180 "translate.cpp"
                      var $cmp953=((($512))|0) > ((($conv952))|0); //@line 3180 "translate.cpp"
                      if ($cmp953) { __label__ = 285;; } else { __label__ = 286;; } //@line 3180 "translate.cpp"
                      if (__label__ == 285) {
  
                        var $515=HEAP32[((_pre_pause)>>2)]; //@line 3182 "translate.cpp"
                        var $conv955=((($515)) & 255); //@line 3182 "translate.cpp"
                        var $516=$ix; //@line 3182 "translate.cpp"
                        var $add956=((($516)+1)&4294967295); //@line 3182 "translate.cpp"
                        var $arrayidx957=(($words+$add956*12)&4294967295); //@line 3182 "translate.cpp"
                        var $pre_pause958=(($arrayidx957+8)&4294967295); //@line 3182 "translate.cpp"
                        HEAP8[($pre_pause958)]=$conv955; //@line 3182 "translate.cpp"
                        HEAP32[((_pre_pause)>>2)]=0; //@line 3183 "translate.cpp"
                        ; //@line 3184 "translate.cpp"
                      }
  
                      var $517=$dict_flags; //@line 3186 "translate.cpp"
                      var $and960=($517) & 65536; //@line 3186 "translate.cpp"
                      var $tobool961=((($and960))|0)!=0; //@line 3186 "translate.cpp"
                      if ($tobool961) { __label__ = 287;; } else { __label__ = 289;; } //@line 3186 "translate.cpp"
                      $if_then962$$if_end975$403: do { 
                        if (__label__ == 287) {
  
                          var $518=$word; //@line 3189 "translate.cpp"
                          $pw=$518; //@line 3189 "translate.cpp"
                          var $519=$pw; //@line 3189 "translate.cpp"
                          var $520=HEAP8[($519)]; //@line 3189 "translate.cpp"
                          var $conv96427=(tempInt=(($520)),(tempInt>=128?tempInt-256:tempInt)); //@line 3189 "translate.cpp"
                          var $cmp96528=((($conv96427))|0)!=32; //@line 3189 "translate.cpp"
                          if (!($cmp96528)) { __label__ = 289;break $if_then962$$if_end975$403; } //@line 3189 "translate.cpp"
                          while(1) { 
  
                            var $dest$, $stop$, $stop4$, $fast$, $value4$;
                            $dest$ = $arraydecay967;
                            $stop$ = $dest$ + 9;
                            $value4$ = 32;
                            if ($value4$ < 0) $value4$ += 256;
                            $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
                            while ($dest$%4 !== 0 && $dest$ < $stop$) {
                              ;; HEAP8[$dest$++] = 32;
                            }
                            $dest$ >>= 2;
                            $stop4$ = $stop$ >> 2;
                            while ($dest$ < $stop4$) {
                            ;;;;;;;  HEAP32[$dest$++] = $value4$;
                            }
                            $dest$ <<= 2;
                            while ($dest$ < $stop$) {
                              ;; HEAP8[$dest$++] = 32;
                            }; //@line 3191 "translate.cpp"
                            var $521=$pw; //@line 3192 "translate.cpp"
                            var $call968=__Z7utf8_inPiPKc($c_temp, $521); //@line 3192 "translate.cpp"
                            $nx=$call968; //@line 3192 "translate.cpp"
                            var $522=$pw; //@line 3193 "translate.cpp"
                            var $523=$nx; //@line 3193 "translate.cpp"
                            var $src$, $dest$, $stop$, $stop4$, $fast$;
                            $src$ = $522;
                            $dest$ = $arrayidx969;
                            $stop$ = $src$ + $523;
                            if (($dest$%4) == ($src$%4) && $523 > 8) {
                              while ($src$%4 !== 0 && $src$ < $stop$) {
                                ; HEAP8[$dest$++] = HEAP8[$src$++];
                              }
                              $src$ >>= 2;
                              $dest$ >>= 2;
                              $stop4$ = $stop$ >> 2;
                              while ($src$ < $stop4$) {
                            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                              }
                              $src$ <<= 2;
                              $dest$ <<= 2;
                            }while ($src$ < $stop$) {
                              ; HEAP8[$dest$++] = HEAP8[$src$++];
                            }; //@line 3193 "translate.cpp"
                            var $524=$tr_addr; //@line 3194 "translate.cpp"
                            var $525=$ix; //@line 3194 "translate.cpp"
                            var $arrayidx971=(($words+$525*12)&4294967295); //@line 3194 "translate.cpp"
                            var $call972=__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($524, $arrayidx970, $arrayidx971, 0, 0); //@line 3194 "translate.cpp"
                            var $526=$nx; //@line 3195 "translate.cpp"
                            var $527=$pw; //@line 3195 "translate.cpp"
                            var $add_ptr973=(($527+$526)&4294967295); //@line 3195 "translate.cpp"
                            $pw=$add_ptr973; //@line 3195 "translate.cpp"
                            var $528=$pw; //@line 3189 "translate.cpp"
                            var $529=HEAP8[($528)]; //@line 3189 "translate.cpp"
                            var $conv964=(tempInt=(($529)),(tempInt>=128?tempInt-256:tempInt)); //@line 3189 "translate.cpp"
                            var $cmp965=((($conv964))|0)!=32; //@line 3189 "translate.cpp"
                            if ($cmp965) { __label__ = 288;continue ; } else { __label__ = 289;break $if_then962$$if_end975$403; } //@line 3189 "translate.cpp"
                          }
                        }
                      } while(0);
  
                      var $530=$dict_flags; //@line 3199 "translate.cpp"
                      var $and976=($530) & 50331648; //@line 3199 "translate.cpp"
                      var $tobool977=((($and976))|0)!=0; //@line 3199 "translate.cpp"
                      if (!($tobool977)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3199 "translate.cpp"
  
                      var $531=$ix; //@line 3199 "translate.cpp"
                      var $532=$word_count; //@line 3199 "translate.cpp"
                      var $sub979=((($532)-1)&4294967295); //@line 3199 "translate.cpp"
                      var $cmp980=((($531))|0)==((($sub979))|0); //@line 3199 "translate.cpp"
                      if (!($cmp980)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3199 "translate.cpp"
  
                      var $533=$terminator; //@line 3199 "translate.cpp"
                      var $and982=($533) & 4194304; //@line 3199 "translate.cpp"
                      var $tobool983=((($and982))|0)!=0; //@line 3199 "translate.cpp"
                      if (!($tobool983)) { __label__ = 293;break $if_then835$$if_else939$368; } //@line 3199 "translate.cpp"
  
                      $clause_pause=10; //@line 3202 "translate.cpp"
                      $tone=4; //@line 3203 "translate.cpp"
                      ; //@line 3204 "translate.cpp"
                    }
                  } while(0);
  
                  var $534=$dict_flags; //@line 3207 "translate.cpp"
                  var $and987=($534) & 128; //@line 3207 "translate.cpp"
                  var $tobool988=((($and987))|0)!=0; //@line 3207 "translate.cpp"
                  if (!($tobool988)) { __label__ = 295;break $if_end768$$for_inc992$344; } //@line 3207 "translate.cpp"
  
                  var $535=HEAP32[((_dictionary_skipwords)>>2)]; //@line 3209 "translate.cpp"
                  var $536=$ix; //@line 3209 "translate.cpp"
                  var $add990=((($536)+($535))&4294967295); //@line 3209 "translate.cpp"
                  $ix=$add990; //@line 3209 "translate.cpp"
                  ; //@line 3210 "translate.cpp"
                }
              } while(0);
  
              var $537=$ix; //@line 3058 "translate.cpp"
              var $inc993=((($537)+1)&4294967295); //@line 3058 "translate.cpp"
              $ix=$inc993; //@line 3058 "translate.cpp"
              var $538=$ix; //@line 3058 "translate.cpp"
              var $539=$word_count; //@line 3058 "translate.cpp"
              var $cmp756=((($538))|0) < ((($539))|0); //@line 3058 "translate.cpp"
              if ($cmp756) { __label__ = 243;continue $for_body757$337; } else { __label__ = 296;break $for_body757_lr_ph$$for_end994$335; } //@line 3058 "translate.cpp"
            }
          }
        } while(0);
  
        $ix=0; //@line 3213 "translate.cpp"
        var $540=HEAP32[((_n_ph_list2)>>2)]; //@line 3217 "translate.cpp"
        __lastLabel__ = 296; ; //@line 3213 "translate.cpp"
        $for_body997$415: while(1) { 
  
          var $541=__lastLabel__ == 296 ? $540 : ($549);
          var $542=$ix; //@line 3217 "translate.cpp"
          var $add998=((($542)+($541))&4294967295); //@line 3217 "translate.cpp"
          var $arrayidx999=((_ph_list2+$add998*8)&4294967295); //@line 3217 "translate.cpp"
          $p2=$arrayidx999; //@line 3217 "translate.cpp"
          var $543=$p2; //@line 3218 "translate.cpp"
          var $phcode=(($543)&4294967295); //@line 3218 "translate.cpp"
          HEAP8[($phcode)]=9; //@line 3218 "translate.cpp"
          var $544=$p2; //@line 3219 "translate.cpp"
          var $stresslevel=(($544+1)&4294967295); //@line 3219 "translate.cpp"
          HEAP8[($stresslevel)]=0; //@line 3219 "translate.cpp"
          var $545=HEAP32[(($source_index)>>2)]; //@line 3220 "translate.cpp"
          var $conv1000=((($545)) & 65535); //@line 3220 "translate.cpp"
          var $546=$p2; //@line 3220 "translate.cpp"
          var $sourceix1001=(($546+6)&4294967295); //@line 3220 "translate.cpp"
          HEAP16[(($sourceix1001)>>1)]=$conv1000; //@line 3220 "translate.cpp"
          var $547=$p2; //@line 3221 "translate.cpp"
          var $synthflags=(($547+4)&4294967295); //@line 3221 "translate.cpp"
          HEAP16[(($synthflags)>>1)]=0; //@line 3221 "translate.cpp"
          var $548=$ix; //@line 3213 "translate.cpp"
          var $inc1003=((($548)+1)&4294967295); //@line 3213 "translate.cpp"
          $ix=$inc1003; //@line 3213 "translate.cpp"
          var $cmp996=((($inc1003))|0) < 2; //@line 3213 "translate.cpp"
          var $549=HEAP32[((_n_ph_list2)>>2)]; //@line 3217 "translate.cpp"
          if ($cmp996) { __lastLabel__ = 297; __label__ = 297;continue $for_body997$415; } else { __lastLabel__ = 297; __label__ = 298;break $for_body997$415; } //@line 3213 "translate.cpp"
        }
  
        var $add1005=((($549)+2)&4294967295); //@line 3223 "translate.cpp"
        HEAP32[((_n_ph_list2)>>2)]=$add1005; //@line 3223 "translate.cpp"
        var $550=HEAP32[((_count_words)>>2)]; //@line 3225 "translate.cpp"
        var $cmp1006=((($550))|0)==0; //@line 3225 "translate.cpp"
        if ($cmp1006) { __label__ = 299;; } else { __label__ = 300;; } //@line 3225 "translate.cpp"
        if (__label__ == 299) {
  
          $clause_pause=0; //@line 3227 "translate.cpp"
          ; //@line 3228 "translate.cpp"
        }
  
        var $call1009=__Z3Eofv(); //@line 3229 "translate.cpp"
        var $tobool1010=((($call1009))|0)!=0; //@line 3229 "translate.cpp"
        if ($tobool1010) { __label__ = 301;; } else { __label__ = 303;; } //@line 3229 "translate.cpp"
        $land_lhs_true1011$$if_end1016$421: do { 
          if (__label__ == 301) {
  
            var $551=$word_count; //@line 3229 "translate.cpp"
            var $cmp1012=((($551))|0)==0; //@line 3229 "translate.cpp"
            var $552=HEAP32[((_option_endpause)>>2)]; //@line 3229 "translate.cpp"
            var $cmp1014=((($552))|0)==0; //@line 3229 "translate.cpp"
            var $or_cond11=($cmp1012) | ($cmp1014); //@line 3229 "translate.cpp"
            if (!($or_cond11)) { __label__ = 303;break $land_lhs_true1011$$if_end1016$421; } //@line 3229 "translate.cpp"
  
            $clause_pause=10; //@line 3231 "translate.cpp"
            ; //@line 3232 "translate.cpp"
          }
        } while(0);
  
        var $553=$tr_addr; //@line 3234 "translate.cpp"
        var $554=$clause_pause; //@line 3234 "translate.cpp"
        var $555=HEAP32[((_new_sentence)>>2)]; //@line 3234 "translate.cpp"
        __Z15MakePhonemeListP10Translatorii($553, $554, $555); //@line 3234 "translate.cpp"
        var $556=$embedded_count; //@line 3236 "translate.cpp"
        var $tobool1017=((($556))|0)!=0; //@line 3236 "translate.cpp"
        if ($tobool1017) { __label__ = 304;; } else { __label__ = 305;; } //@line 3236 "translate.cpp"
        if (__label__ == 304) {
  
          var $557=HEAP32[((_n_phoneme_list)>>2)]; //@line 3238 "translate.cpp"
          var $sub1019=((($557)-2)&4294967295); //@line 3238 "translate.cpp"
          var $arrayidx1020=((_phoneme_list+$sub1019*24)&4294967295); //@line 3238 "translate.cpp"
          var $synthflags1021=(($arrayidx1020+4)&4294967295); //@line 3238 "translate.cpp"
          HEAP16[(($synthflags1021)>>1)]=2; //@line 3238 "translate.cpp"
          var $558=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 3239 "translate.cpp"
          var $sub1022=((($558)-1)&4294967295); //@line 3239 "translate.cpp"
          var $arrayidx1023=((_embedded_list+$sub1022*4)&4294967295); //@line 3239 "translate.cpp"
          var $559=HEAP32[(($arrayidx1023)>>2)]; //@line 3239 "translate.cpp"
          var $or1024=($559) | 128; //@line 3239 "translate.cpp"
          HEAP32[(($arrayidx1023)>>2)]=$or1024; //@line 3239 "translate.cpp"
          ; //@line 3240 "translate.cpp"
        }
  
        var $560=$tone; //@line 3245 "translate.cpp"
        var $561=$tone_out_addr; //@line 3245 "translate.cpp"
        HEAP32[(($561)>>2)]=$560; //@line 3245 "translate.cpp"
        HEAP32[((_new_sentence)>>2)]=0; //@line 3247 "translate.cpp"
        var $562=$terminator; //@line 3248 "translate.cpp"
        var $and1026=($562) & 524288; //@line 3248 "translate.cpp"
        var $tobool1027=((($and1026))|0)!=0; //@line 3248 "translate.cpp"
        if ($tobool1027) { __label__ = 306;; } else { __label__ = 307;; } //@line 3248 "translate.cpp"
        if (__label__ == 306) {
  
          HEAP32[((_new_sentence)>>2)]=1; //@line 3250 "translate.cpp"
          ; //@line 3251 "translate.cpp"
        }
  
        var $563=$voice_change_addr; //@line 3254 "translate.cpp"
        var $cmp1030=((($563))|0)!=0; //@line 3254 "translate.cpp"
        if ($cmp1030) { __label__ = 308;; } else { __label__ = 311;; } //@line 3254 "translate.cpp"
        if (__label__ == 308) {
  
          var $564=$terminator; //@line 3257 "translate.cpp"
          var $and1032=($564) & 131072; //@line 3257 "translate.cpp"
          var $tobool1033=((($and1032))|0)!=0; //@line 3257 "translate.cpp"
          var $565=$voice_change_addr; //@line 3258 "translate.cpp"
          if ($tobool1033) { __label__ = 309;; } else { __label__ = 310;; } //@line 3257 "translate.cpp"
          if (__label__ == 309) {
  
            HEAP32[(($565)>>2)]=((__ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name)&4294967295); //@line 3258 "translate.cpp"
            ; //@line 3258 "translate.cpp"
          }
          else if (__label__ == 310) {
  
            HEAP32[(($565)>>2)]=0; //@line 3260 "translate.cpp"
            ;
          }
        }
  
        var $call1038=__Z3Eofv(); //@line 3263 "translate.cpp"
        var $tobool1039=((($call1038))|0)!=0; //@line 3263 "translate.cpp"
        if ($tobool1039) { __label__ = 313;; } else { __label__ = 312;; } //@line 3263 "translate.cpp"
        $if_then1042$$lor_lhs_false1040$437: do { 
          if (__label__ == 312) {
  
            var $566=$vp_input_addr; //@line 3263 "translate.cpp"
            var $cmp1041=((($566))|0)==0; //@line 3263 "translate.cpp"
            if ($cmp1041) { __label__ = 313;break $if_then1042$$lor_lhs_false1040$437; } //@line 3263 "translate.cpp"
  
            var $567=HEAP32[((_option_multibyte)>>2)]; //@line 3266 "translate.cpp"
            var $cmp1044=((($567))|0)==3; //@line 3266 "translate.cpp"
            if ($cmp1044) { __label__ = 315;; } else { __label__ = 316;; } //@line 3266 "translate.cpp"
            if (__label__ == 315) {
  
              var $568=HEAP32[((_p_wchar_input)>>2)]; //@line 3267 "translate.cpp"
              var $569=$568; //@line 3267 "translate.cpp"
              $retval=$569; //@line 3267 "translate.cpp"
              __label__ = 317;break $if_then$$if_end$2; //@line 3267 "translate.cpp"
            }
            else if (__label__ == 316) {
  
              var $570=HEAP32[((_p_textinput)>>2)]; //@line 3269 "translate.cpp"
              $retval=$570; //@line 3269 "translate.cpp"
              __label__ = 317;break $if_then$$if_end$2; //@line 3269 "translate.cpp"
            }
          }
        } while(0);
  
        $retval=0; //@line 3264 "translate.cpp"
        ; //@line 3264 "translate.cpp"
      }
    } while(0);
  
    var $571=$retval; //@line 3270 "translate.cpp"
    STACKTOP = __stackBase__;
    return $571; //@line 3270 "translate.cpp"
    return null;
  }
  

  function __ZL9IsDigit09j($c) {
    ;
    var __label__;
  
    var $retval;
    var $c_addr;
    $c_addr=$c;
    var $0=$c_addr; //@line 415 "translate.cpp"
    var $cmp=((($0))>>>0) >= 48; //@line 415 "translate.cpp"
    var $1=$c_addr; //@line 415 "translate.cpp"
    var $cmp1=((($1))>>>0) <= 57; //@line 415 "translate.cpp"
    var $or_cond=($cmp) & ($cmp1); //@line 415 "translate.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 415 "translate.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 416 "translate.cpp"
      ; //@line 416 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      $retval=0; //@line 417 "translate.cpp"
      ; //@line 417 "translate.cpp"
    }
  
    var $2=$retval; //@line 418 "translate.cpp"
    ;
    return $2; //@line 418 "translate.cpp"
    return null;
  }
  

  function __ZL15EmbeddedCommandRj($source_index) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $source_index_addr;
    var $commands;
    var $value;
    var $sign;
    var $c;
    var $p;
    var $cmd;
    $source_index_addr=$source_index;
    $commands=((__str12555)&4294967295); //@line 2131 "translate.cpp"
    $value=-1; //@line 2132 "translate.cpp"
    $sign=0; //@line 2133 "translate.cpp"
    var $0=$source_index_addr; //@line 2138 "translate.cpp"
    var $1=HEAP32[(($0)>>2)]; //@line 2138 "translate.cpp"
    var $arrayidx=((__ZL6source+$1)&4294967295); //@line 2138 "translate.cpp"
    var $2=HEAP8[($arrayidx)]; //@line 2138 "translate.cpp"
    $c=$2; //@line 2138 "translate.cpp"
    var $3=$c; //@line 2139 "translate.cpp"
    var $conv=((($3))&255); //@line 2139 "translate.cpp"
    var $cmp=((($conv))|0)==43; //@line 2139 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 2139 "translate.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        $sign=64; //@line 2141 "translate.cpp"
        var $4=$source_index_addr; //@line 2142 "translate.cpp"
        var $5=HEAP32[(($4)>>2)]; //@line 2142 "translate.cpp"
        var $inc=((($5)+1)&4294967295); //@line 2142 "translate.cpp"
        HEAP32[(($4)>>2)]=$inc; //@line 2142 "translate.cpp"
        ; //@line 2143 "translate.cpp"
      }
      else if (__label__ == 2) {
  
        var $6=$c; //@line 2145 "translate.cpp"
        var $conv1=((($6))&255); //@line 2145 "translate.cpp"
        var $cmp2=((($conv1))|0)==45; //@line 2145 "translate.cpp"
        if (!($cmp2)) { __label__ = 4;break $if_then$$if_else$2; } //@line 2145 "translate.cpp"
  
        $sign=96; //@line 2147 "translate.cpp"
        var $7=$source_index_addr; //@line 2148 "translate.cpp"
        var $8=HEAP32[(($7)>>2)]; //@line 2148 "translate.cpp"
        var $inc4=((($8)+1)&4294967295); //@line 2148 "translate.cpp"
        HEAP32[(($7)>>2)]=$inc4; //@line 2148 "translate.cpp"
        ; //@line 2149 "translate.cpp"
      }
    } while(0);
  
    var $9=$source_index_addr; //@line 2151 "translate.cpp"
    var $10=HEAP32[(($9)>>2)]; //@line 2151 "translate.cpp"
    var $arrayidx6=((__ZL6source+$10)&4294967295); //@line 2151 "translate.cpp"
    var $11=HEAP8[($arrayidx6)]; //@line 2151 "translate.cpp"
    var $conv7=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 2151 "translate.cpp"
    var $isdigittmp=((($conv7)-48)&4294967295); //@line 2151 "translate.cpp"
    var $isdigit=((($isdigittmp))>>>0) < 10; //@line 2151 "translate.cpp"
    var $call=((($isdigit))&1); //@line 2151 "translate.cpp"
    var $tobool=((($call))|0)!=0; //@line 2151 "translate.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 7;; } //@line 2151 "translate.cpp"
    $if_then8$$if_end16$7: do { 
      if (__label__ == 5) {
  
        var $12=$source_index_addr; //@line 2153 "translate.cpp"
        var $13=HEAP32[(($12)>>2)]; //@line 2153 "translate.cpp"
        var $arrayidx9=((__ZL6source+$13)&4294967295); //@line 2153 "translate.cpp"
        var $call10=_atoi($arrayidx9); //@line 2153 "translate.cpp"
        $value=$call10; //@line 2153 "translate.cpp"
        var $14=$source_index_addr; //@line 2154 "translate.cpp"
        var $15=HEAP32[(($14)>>2)]; //@line 2154 "translate.cpp"
        var $arrayidx113=((__ZL6source+$15)&4294967295); //@line 2154 "translate.cpp"
        var $16=HEAP8[($arrayidx113)]; //@line 2154 "translate.cpp"
        var $conv124=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 2154 "translate.cpp"
        var $isdigittmp15=((($conv124)-48)&4294967295); //@line 2154 "translate.cpp"
        var $isdigit26=((($isdigittmp15))>>>0) < 10; //@line 2154 "translate.cpp"
        if (!($isdigit26)) { __label__ = 7;break $if_then8$$if_end16$7; } //@line 2154 "translate.cpp"
        while(1) { 
  
          var $17=$source_index_addr; //@line 2155 "translate.cpp"
          var $18=HEAP32[(($17)>>2)]; //@line 2155 "translate.cpp"
          var $inc15=((($18)+1)&4294967295); //@line 2155 "translate.cpp"
          HEAP32[(($17)>>2)]=$inc15; //@line 2155 "translate.cpp"
          var $19=$source_index_addr; //@line 2154 "translate.cpp"
          var $20=HEAP32[(($19)>>2)]; //@line 2154 "translate.cpp"
          var $arrayidx11=((__ZL6source+$20)&4294967295); //@line 2154 "translate.cpp"
          var $21=HEAP8[($arrayidx11)]; //@line 2154 "translate.cpp"
          var $conv12=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 2154 "translate.cpp"
          var $isdigittmp1=((($conv12)-48)&4294967295); //@line 2154 "translate.cpp"
          var $isdigit2=((($isdigittmp1))>>>0) < 10; //@line 2154 "translate.cpp"
          var $call13=((($isdigit2))&1); //@line 2154 "translate.cpp"
          var $tobool14=((($call13))|0)!=0; //@line 2154 "translate.cpp"
          if ($tobool14) { __label__ = 6;continue ; } else { __label__ = 7;break $if_then8$$if_end16$7; } //@line 2154 "translate.cpp"
        }
      }
    } while(0);
  
    var $22=$source_index_addr; //@line 2158 "translate.cpp"
    var $23=HEAP32[(($22)>>2)]; //@line 2158 "translate.cpp"
    var $inc17=((($23)+1)&4294967295); //@line 2158 "translate.cpp"
    HEAP32[(($22)>>2)]=$inc17; //@line 2158 "translate.cpp"
    var $arrayidx18=((__ZL6source+$23)&4294967295); //@line 2158 "translate.cpp"
    var $24=HEAP8[($arrayidx18)]; //@line 2158 "translate.cpp"
    $c=$24; //@line 2158 "translate.cpp"
    var $25=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2159 "translate.cpp"
    var $cmp19=((($25))|0) >= 248; //@line 2159 "translate.cpp"
    if ($cmp19) { __label__ = 8;; } else { __label__ = 9;; } //@line 2159 "translate.cpp"
    if (__label__ == 8) {
  
      $retval=0; //@line 2160 "translate.cpp"
      ; //@line 2160 "translate.cpp"
    }
    else if (__label__ == 9) {
  
      var $26=$commands; //@line 2162 "translate.cpp"
      var $27=$c; //@line 2162 "translate.cpp"
      var $conv22=((($27))&255); //@line 2162 "translate.cpp"
      var $call23=__Z8strchr_wPKci($26, $conv22); //@line 2162 "translate.cpp"
      $p=$call23; //@line 2162 "translate.cpp"
      var $cmp24=((($call23))|0)==0; //@line 2162 "translate.cpp"
      if ($cmp24) { __label__ = 10;; } else { __label__ = 11;; } //@line 2162 "translate.cpp"
      if (__label__ == 10) {
  
        $retval=0; //@line 2163 "translate.cpp"
        ; //@line 2163 "translate.cpp"
      }
      else if (__label__ == 11) {
  
        var $28=$p; //@line 2164 "translate.cpp"
        var $29=$commands; //@line 2164 "translate.cpp"
        var $sub_ptr_lhs_cast=($28); //@line 2164 "translate.cpp"
        var $sub_ptr_rhs_cast=($29); //@line 2164 "translate.cpp"
        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2164 "translate.cpp"
        var $add=((($sub_ptr_sub)+1)&4294967295); //@line 2164 "translate.cpp"
        $cmd=$add; //@line 2164 "translate.cpp"
        var $30=$value; //@line 2165 "translate.cpp"
        var $cmp27=((($30))|0)==-1; //@line 2165 "translate.cpp"
        if ($cmp27) { __lastLabel__ = 11; __label__ = 12;; } else { __lastLabel__ = 11; __label__ = 13;; } //@line 2165 "translate.cpp"
        if (__label__ == 12) {
  
          var $31=$cmd; //@line 2167 "translate.cpp"
          var $arrayidx29=((_embedded_default+$31*4)&4294967295); //@line 2167 "translate.cpp"
          var $32=HEAP32[(($arrayidx29)>>2)]; //@line 2167 "translate.cpp"
          $value=$32; //@line 2167 "translate.cpp"
          $sign=0; //@line 2168 "translate.cpp"
          __lastLabel__ = 12; ; //@line 2169 "translate.cpp"
        }
  
        var $33=__lastLabel__ == 12 ? $31 : ($add); //@line 2171 "translate.cpp"
        var $cmp31=((($33))|0)==9; //@line 2171 "translate.cpp"
        if ($cmp31) { __label__ = 14;; } else { __label__ = 15;; } //@line 2171 "translate.cpp"
        if (__label__ == 14) {
  
          var $34=$value; //@line 2173 "translate.cpp"
          HEAP32[((__ZL13option_sayas2)>>2)]=$34; //@line 2173 "translate.cpp"
          HEAP32[((__ZL18count_sayas_digits)>>2)]=0; //@line 2174 "translate.cpp"
          ; //@line 2175 "translate.cpp"
        }
  
        var $35=$cmd; //@line 2176 "translate.cpp"
        var $cmp34=((($35))|0)==13; //@line 2176 "translate.cpp"
        if ($cmp34) { __label__ = 16;; } else { __label__ = 19;; } //@line 2176 "translate.cpp"
        if (__label__ == 16) {
  
          var $36=$value; //@line 2178 "translate.cpp"
          var $cmp36=((($36))|0) >= 3; //@line 2178 "translate.cpp"
          if ($cmp36) { __label__ = 17;; } else { __label__ = 18;; } //@line 2178 "translate.cpp"
          if (__label__ == 17) {
  
            HEAP8[(__ZL13word_emphasis_b)]=1;
            ; //@line 2179 "translate.cpp"
          }
          else if (__label__ == 18) {
  
            HEAP8[(__ZL13word_emphasis_b)]=0;
            ;
          }
        }
  
        var $37=$cmd; //@line 2184 "translate.cpp"
        var $38=$sign; //@line 2184 "translate.cpp"
        var $39=$value; //@line 2184 "translate.cpp"
        var $shl=((($39)*256)&4294967295); //@line 2184 "translate.cpp"
        var $add41=((($38)+($37))&4294967295); //@line 2184 "translate.cpp"
        var $add42=((($add41)+($shl))&4294967295); //@line 2184 "translate.cpp"
        var $40=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2184 "translate.cpp"
        var $inc43=((($40)+1)&4294967295); //@line 2184 "translate.cpp"
        HEAP32[((__ZL11embedded_ix)>>2)]=$inc43; //@line 2184 "translate.cpp"
        var $arrayidx44=((_embedded_list+$40*4)&4294967295); //@line 2184 "translate.cpp"
        HEAP32[(($arrayidx44)>>2)]=$add42; //@line 2184 "translate.cpp"
        $retval=1; //@line 2185 "translate.cpp"
        ; //@line 2185 "translate.cpp"
      }
    }
  
    var $41=$retval; //@line 2186 "translate.cpp"
    ;
    return $41; //@line 2186 "translate.cpp"
    return null;
  }
  

  function __ZL13TranslateCharP10TranslatorPcijjPi($tr, $ptr, $prev_in, $c, $next_in, $insert) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $tr_addr;
    var $ptr_addr;
    var $prev_in_addr;
    var $c_addr;
    var $next_in_addr;
    var $insert_addr;
    var $code;
    var $initial;
    var $medial;
    var $final;
    var $next2=__stackBase__;
    $tr_addr=$tr;
    $ptr_addr=$ptr;
    $prev_in_addr=$prev_in;
    $c_addr=$c;
    $next_in_addr=$next_in;
    $insert_addr=$insert;
    var $0=$tr_addr; //@line 2276 "translate.cpp"
    var $translator_name=(($0+280)&4294967295); //@line 2276 "translate.cpp"
    var $1=HEAP32[(($translator_name)>>2)]; //@line 2276 "translate.cpp"
    if ($1 == 24934) {
      __label__ = 1;;
    }
    else if ($1 == 28268) {
      __label__ = 1;;
    }
    else if ($1 == 27503) {
      __label__ = 9;;
    }
    else {
    __label__ = 18;;
    }
    
    $sw_epilog$$sw_bb$$sw_bb17$2: do { 
      if (__label__ == 1) {
  
        var $2=$prev_in_addr; //@line 2283 "translate.cpp"
        var $call=_iswalpha($2); //@line 2283 "translate.cpp"
        var $tobool=((($call))|0)!=0; //@line 2283 "translate.cpp"
        if ($tobool) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2283 "translate.cpp"
  
        var $3=$ptr_addr; //@line 2285 "translate.cpp"
        var $arrayidx=(($3+1)&4294967295); //@line 2285 "translate.cpp"
        var $call1=__Z7utf8_inPiPKc($next2, $arrayidx); //@line 2285 "translate.cpp"
        var $4=$c_addr; //@line 2287 "translate.cpp"
        var $cmp=((($4))|0)==39; //@line 2287 "translate.cpp"
        if (!($cmp)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2287 "translate.cpp"
  
        var $5=HEAP32[(($next2)>>2)]; //@line 2287 "translate.cpp"
        var $call2=__Z7IsSpacej($5); //@line 2287 "translate.cpp"
        var $tobool3=((($call2))|0)!=0; //@line 2287 "translate.cpp"
        if (!($tobool3)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2287 "translate.cpp"
  
        var $6=$next_in_addr; //@line 2289 "translate.cpp"
        var $cmp5=((($6))|0)==110; //@line 2289 "translate.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 7;; } //@line 2289 "translate.cpp"
        $land_lhs_true6$$if_end$7: do { 
          if (__label__ == 5) {
  
            var $7=$tr_addr; //@line 2289 "translate.cpp"
            var $translator_name7=(($7+280)&4294967295); //@line 2289 "translate.cpp"
            var $8=HEAP32[(($translator_name7)>>2)]; //@line 2289 "translate.cpp"
            var $cmp8=((($8))|0)==24934; //@line 2289 "translate.cpp"
            if (!($cmp8)) { __label__ = 7;break $land_lhs_true6$$if_end$7; } //@line 2289 "translate.cpp"
  
            var $9=$ptr_addr; //@line 2292 "translate.cpp"
            var $arrayidx10=(($9)&4294967295); //@line 2292 "translate.cpp"
            HEAP8[($arrayidx10)]=32; //@line 2292 "translate.cpp"
            $retval=601; //@line 2293 "translate.cpp"
            __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2293 "translate.cpp"
          }
        } while(0);
  
        var $10=$next_in_addr; //@line 2295 "translate.cpp"
        var $cmp11=((($10))|0)==110; //@line 2295 "translate.cpp"
        var $11=$next_in_addr; //@line 2295 "translate.cpp"
        var $cmp12=((($11))|0)==116; //@line 2295 "translate.cpp"
        var $or_cond=($cmp11) | ($cmp12); //@line 2295 "translate.cpp"
        if (!($or_cond)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2295 "translate.cpp"
  
        $retval=601; //@line 2298 "translate.cpp"
        __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2298 "translate.cpp"
      }
      else if (__label__ == 9) {
  
        var $12=$c_addr; //@line 2305 "translate.cpp"
        var $sub=((($12)-44032)&4294967295); //@line 2305 "translate.cpp"
        $code=$sub; //@line 2305 "translate.cpp"
        var $cmp18=((($sub))|0) >= 0; //@line 2305 "translate.cpp"
        var $13=$c_addr; //@line 2305 "translate.cpp"
        var $cmp20=((($13))>>>0) <= 55215; //@line 2305 "translate.cpp"
        var $or_cond1=($cmp18) & ($cmp20); //@line 2305 "translate.cpp"
        if ($or_cond1) { __label__ = 10;; } else { __label__ = 15;; } //@line 2305 "translate.cpp"
        if (__label__ == 10) {
  
          var $14=$code; //@line 2308 "translate.cpp"
          var $div=((((($14))|0)/28)|0); //@line 2308 "translate.cpp"
          var $div22=((((($div))|0)/21)|0); //@line 2308 "translate.cpp"
          $initial=$div22; //@line 2308 "translate.cpp"
          var $15=$code; //@line 2309 "translate.cpp"
          var $div23=((((($15))|0)/28)|0); //@line 2309 "translate.cpp"
          var $rem=((($div23))|0)%21; //@line 2309 "translate.cpp"
          $medial=$rem; //@line 2309 "translate.cpp"
          var $16=$code; //@line 2310 "translate.cpp"
          var $rem24=((($16))|0)%28; //@line 2310 "translate.cpp"
          $final=$rem24; //@line 2310 "translate.cpp"
          var $17=$initial; //@line 2312 "translate.cpp"
          var $cmp25=((($17))|0)==11; //@line 2312 "translate.cpp"
          if ($cmp25) { __label__ = 11;; } else { __label__ = 13;; } //@line 2312 "translate.cpp"
          $if_then26$$if_else$15: do { 
            if (__label__ == 11) {
  
              var $18=$medial; //@line 2315 "translate.cpp"
              var $add=((($18)+4449)&4294967295); //@line 2315 "translate.cpp"
              $c_addr=$add; //@line 2315 "translate.cpp"
              var $19=$final; //@line 2316 "translate.cpp"
              var $cmp27=((($19))|0) > 0; //@line 2316 "translate.cpp"
              if (!($cmp27)) { __label__ = 14;break $if_then26$$if_else$15; } //@line 2316 "translate.cpp"
  
              var $20=$final; //@line 2317 "translate.cpp"
              var $add29=((($20)+4519)&4294967295); //@line 2317 "translate.cpp"
              var $21=$insert_addr; //@line 2317 "translate.cpp"
              HEAP32[(($21)>>2)]=$add29; //@line 2317 "translate.cpp"
              ; //@line 2317 "translate.cpp"
            }
            else if (__label__ == 13) {
  
              var $22=$initial; //@line 2322 "translate.cpp"
              var $add31=((($22)+4352)&4294967295); //@line 2322 "translate.cpp"
              $c_addr=$add31; //@line 2322 "translate.cpp"
              var $23=$medial; //@line 2323 "translate.cpp"
              var $mul=((($23)*28)&4294967295); //@line 2323 "translate.cpp"
              var $24=$final; //@line 2323 "translate.cpp"
              var $add33=((($24)+50500)&4294967295); //@line 2323 "translate.cpp"
              var $add34=((($add33)+($mul))&4294967295); //@line 2323 "translate.cpp"
              var $25=$insert_addr; //@line 2323 "translate.cpp"
              HEAP32[(($25)>>2)]=$add34; //@line 2323 "translate.cpp"
              ;
            }
          } while(0);
  
          var $26=$c_addr; //@line 2325 "translate.cpp"
          $retval=$26; //@line 2325 "translate.cpp"
          __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2325 "translate.cpp"
        }
        else if (__label__ == 15) {
  
          var $27=$c_addr; //@line 2328 "translate.cpp"
          var $sub37=((($27)-12592)&4294967295); //@line 2328 "translate.cpp"
          $code=$sub37; //@line 2328 "translate.cpp"
          var $cmp38=((($sub37))|0) >= 0; //@line 2328 "translate.cpp"
          if (!($cmp38)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2328 "translate.cpp"
  
          var $28=$code; //@line 2328 "translate.cpp"
          var $cmp40=((($28))|0) < 52; //@line 2328 "translate.cpp"
          if (!($cmp40)) { __label__ = 18;break $sw_epilog$$sw_bb$$sw_bb17$2; } //@line 2328 "translate.cpp"
  
          var $29=$code; //@line 2331 "translate.cpp"
          var $arrayidx42=((__ZZL13TranslateCharP10TranslatorPcijjPiE20hangul_compatibility+$29)&4294967295); //@line 2331 "translate.cpp"
          var $30=HEAPU8[($arrayidx42)]; //@line 2331 "translate.cpp"
          var $conv=((($30))&255); //@line 2331 "translate.cpp"
          var $add43=((($conv)+4352)&4294967295); //@line 2331 "translate.cpp"
          $retval=$add43; //@line 2331 "translate.cpp"
          __label__ = 19;break $sw_epilog$$sw_bb$$sw_bb17$2; //@line 2331 "translate.cpp"
        }
      }
    } while(0);
    if (__label__ == 18) {
  
      var $31=$tr_addr; //@line 2335 "translate.cpp"
      var $32=$c_addr; //@line 2335 "translate.cpp"
      var $33=$next_in_addr; //@line 2335 "translate.cpp"
      var $34=$insert_addr; //@line 2335 "translate.cpp"
      var $call46=__ZL14SubstituteCharP10TranslatorjjPi($31, $32, $33, $34); //@line 2335 "translate.cpp"
      $retval=$call46; //@line 2335 "translate.cpp"
      ; //@line 2335 "translate.cpp"
    }
  
    var $35=$retval; //@line 2336 "translate.cpp"
    STACKTOP = __stackBase__;
    return $35; //@line 2336 "translate.cpp"
    return null;
  }
  

  function __ZL14TranslateWord2P10TranslatorPcP8WORD_TABii($tr, $word, $wtab, $pre_pause, $next_pause) {
    var __stackBase__  = STACKTOP; STACKTOP += 392; _memset(__stackBase__, 0, 392);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $word_addr;
    var $wtab_addr;
    var $pre_pause_addr;
    var $next_pause_addr;
    var $flags;
    var $stress;
    var $next_stress;
    var $next_tone;
    var $p;
    var $srcix;
    var $embedded_cmd;
    var $value;
    var $found_dict_flag;
    var $ph_code;
    var $plist2;
    var $ph;
    var $max_stress;
    var $max_stress_ix;
    var $prev_vowel;
    var $pitch_raised;
    var $switch_phonemes;
    var $first_phoneme;
    var $source_ix;
    var $len;
    var $ix;
    var $sylimit;
    var $new_language;
    var $bad_phoneme=__stackBase__;
    var $word_flags;
    var $word_copy_len;
    var $word_copy=__stackBase__+4;
    var $old_dictionary_name=__stackBase__+168;
    var $c1;
    var $lang_name=__stackBase__+208;
    var $c2;
    var $p2;
    var $ok;
    var $flags2=__stackBase__+220;
    var $c_word2=__stackBase__+228;
    var $ph_buf=__stackBase__+232;
    $tr_addr=$tr;
    $word_addr=$word;
    $wtab_addr=$wtab;
    $pre_pause_addr=$pre_pause;
    $next_pause_addr=$next_pause;
    $flags=0; //@line 1600 "translate.cpp"
    $next_tone=0; //@line 1603 "translate.cpp"
    $max_stress_ix=0; //@line 1613 "translate.cpp"
    $prev_vowel=-1; //@line 1614 "translate.cpp"
    $pitch_raised=0; //@line 1615 "translate.cpp"
    $switch_phonemes=-1; //@line 1616 "translate.cpp"
    $first_phoneme=1; //@line 1617 "translate.cpp"
    var $0=HEAP32[((_f_logespeak)>>2)]; //@line 1629 "translate.cpp"
    var $cmp=((($0))|0)!=0; //@line 1629 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 1629 "translate.cpp"
    $land_lhs_true$$if_end10$2: do { 
      if (__label__ == 1) {
  
        var $1=HEAP32[((_logging_type)>>2)]; //@line 1629 "translate.cpp"
        var $and=($1) & 8; //@line 1629 "translate.cpp"
        var $tobool=((($and))|0)!=0; //@line 1629 "translate.cpp"
        if (!($tobool)) { __label__ = 7;break $land_lhs_true$$if_end10$2; } //@line 1629 "translate.cpp"
  
        var $2=HEAP32[((_f_logespeak)>>2)]; //@line 1631 "translate.cpp"
        var $3=$wtab_addr; //@line 1631 "translate.cpp"
        var $flags1=(($3)&4294967295); //@line 1631 "translate.cpp"
        var $4=HEAP32[(($flags1)>>2)]; //@line 1631 "translate.cpp"
        var $5=$wtab_addr; //@line 1631 "translate.cpp"
        var $length=(($5+10)&4294967295); //@line 1631 "translate.cpp"
        var $6=HEAPU8[($length)]; //@line 1631 "translate.cpp"
        var $conv=((($6))&255); //@line 1631 "translate.cpp"
        var $call=_fprintf($2, ((__str9552)&4294967295), allocate([$4,0,0,0,$conv,0,0,0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1631 "translate.cpp"
        $ix=0; //@line 1632 "translate.cpp"
        __lastLabel__ = 2; ; //@line 1632 "translate.cpp"
        while(1) { 
  
          var $7=__lastLabel__ == 5 ? $inc : (0); //@line 1632 "translate.cpp"
          var $cmp2=((($7))|0) < 40; //@line 1632 "translate.cpp"
          if (!($cmp2)) { __label__ = 6;break ; } //@line 1632 "translate.cpp"
  
          var $8=$ix; //@line 1634 "translate.cpp"
          var $9=$word_addr; //@line 1634 "translate.cpp"
          var $arrayidx=(($9+$8)&4294967295); //@line 1634 "translate.cpp"
          var $10=HEAP8[($arrayidx)]; //@line 1634 "translate.cpp"
          var $conv3=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1634 "translate.cpp"
          var $cmp4=((($conv3))|0)==0; //@line 1634 "translate.cpp"
          if ($cmp4) { __label__ = 6;break ; } //@line 1634 "translate.cpp"
  
          var $11=$ix; //@line 1635 "translate.cpp"
          var $12=$word_addr; //@line 1635 "translate.cpp"
          var $arrayidx6=(($12+$11)&4294967295); //@line 1635 "translate.cpp"
          var $13=HEAP8[($arrayidx6)]; //@line 1635 "translate.cpp"
          var $conv7=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1635 "translate.cpp"
          var $14=HEAP32[((_f_logespeak)>>2)]; //@line 1635 "translate.cpp"
          var $call8=_fputc($conv7, $14); //@line 1635 "translate.cpp"
          var $15=$ix; //@line 1632 "translate.cpp"
          var $inc=((($15)+1)&4294967295); //@line 1632 "translate.cpp"
          $ix=$inc; //@line 1632 "translate.cpp"
          __lastLabel__ = 5; __label__ = 3;continue ; //@line 1632 "translate.cpp"
        }
  
        var $16=HEAP32[((_f_logespeak)>>2)]; //@line 1637 "translate.cpp"
        var $17=_fwrite(((__str10553)&4294967295), 2, 1, $16); //@line 1637 "translate.cpp"
        ; //@line 1638 "translate.cpp"
      }
    } while(0);
  
    var $18=$wtab_addr; //@line 1640 "translate.cpp"
    var $length11=(($18+10)&4294967295); //@line 1640 "translate.cpp"
    var $19=HEAPU8[($length11)]; //@line 1640 "translate.cpp"
    var $conv12=((($19))&255); //@line 1640 "translate.cpp"
    $len=$conv12; //@line 1640 "translate.cpp"
    var $cmp13=((($conv12))|0) > 31; //@line 1641 "translate.cpp"
    if ($cmp13) { __label__ = 8;; } else { __label__ = 9;; } //@line 1641 "translate.cpp"
    if (__label__ == 8) {
  
      $len=31; //@line 1641 "translate.cpp"
      ; //@line 1641 "translate.cpp"
    }
  
    var $20=$wtab_addr; //@line 1642 "translate.cpp"
    var $sourceix=(($20+6)&4294967295); //@line 1642 "translate.cpp"
    var $21=HEAPU16[(($sourceix)>>1)]; //@line 1642 "translate.cpp"
    var $conv16=((($21))&65535); //@line 1642 "translate.cpp"
    var $and17=($conv16) & 2047; //@line 1642 "translate.cpp"
    var $22=$len; //@line 1642 "translate.cpp"
    var $shl=($22) << 11; //@line 1642 "translate.cpp"
    var $or=($and17) | ($shl); //@line 1642 "translate.cpp"
    $source_ix=$or; //@line 1642 "translate.cpp"
    var $23=$wtab_addr; //@line 1644 "translate.cpp"
    var $arrayidx18=(($23)&4294967295); //@line 1644 "translate.cpp"
    var $flags19=(($arrayidx18)&4294967295); //@line 1644 "translate.cpp"
    var $24=HEAP32[(($flags19)>>2)]; //@line 1644 "translate.cpp"
    $word_flags=$24; //@line 1644 "translate.cpp"
    var $25=$word_flags; //@line 1645 "translate.cpp"
    var $and20=($25) & 64; //@line 1645 "translate.cpp"
    var $tobool21=((($and20))|0)!=0; //@line 1645 "translate.cpp"
    if ($tobool21) { __label__ = 10;; } else { __label__ = 18;; } //@line 1645 "translate.cpp"
    $if_then22$$if_end33$14: do { 
      if (__label__ == 10) {
  
        HEAP8[(__ZL13embedded_flag_b)]=1;
        ; //@line 1649 "translate.cpp"
        while(1) { 
  
          var $26=HEAP32[((__ZL13embedded_read)>>2)]; //@line 1651 "translate.cpp"
          var $inc23=((($26)+1)&4294967295); //@line 1651 "translate.cpp"
          HEAP32[((__ZL13embedded_read)>>2)]=$inc23; //@line 1651 "translate.cpp"
          var $arrayidx24=((_embedded_list+$26*4)&4294967295); //@line 1651 "translate.cpp"
          var $27=HEAP32[(($arrayidx24)>>2)]; //@line 1651 "translate.cpp"
          $embedded_cmd=$27; //@line 1651 "translate.cpp"
          var $28=$embedded_cmd; //@line 1652 "translate.cpp"
          var $shr=($28) >> 8; //@line 1652 "translate.cpp"
          $value=$shr; //@line 1652 "translate.cpp"
          var $29=$embedded_cmd; //@line 1654 "translate.cpp"
          var $and25=($29) & 31; //@line 1654 "translate.cpp"
          if ($and25 == 9) {
            __label__ = 12;;
          }
          else if ($and25 == 13) {
            __label__ = 13;;
          }
          else if ($and25 == 12) {
            __label__ = 14;;
          }
          else {
          __label__ = 17;;
          }
          
          if (__label__ == 12) {
  
            var $30=$value; //@line 1657 "translate.cpp"
            HEAP32[((_option_sayas)>>2)]=$30; //@line 1657 "translate.cpp"
            ; //@line 1658 "translate.cpp"
          }
          else if (__label__ == 13) {
  
            var $31=$value; //@line 1661 "translate.cpp"
            HEAP32[((__ZL15option_emphasis)>>2)]=$31; //@line 1661 "translate.cpp"
            ; //@line 1662 "translate.cpp"
          }
          else if (__label__ == 14) {
  
            var $32=$value; //@line 1666 "translate.cpp"
            var $cmp28=((($32))|0)==0; //@line 1666 "translate.cpp"
            if ($cmp28) { __label__ = 15;; } else { __label__ = 16;; } //@line 1666 "translate.cpp"
            if (__label__ == 15) {
  
              $pre_pause_addr=0; //@line 1667 "translate.cpp"
              ; //@line 1667 "translate.cpp"
            }
            else if (__label__ == 16) {
  
              var $33=$value; //@line 1669 "translate.cpp"
              var $34=$pre_pause_addr; //@line 1669 "translate.cpp"
              var $add=((($34)+($33))&4294967295); //@line 1669 "translate.cpp"
              $pre_pause_addr=$add; //@line 1669 "translate.cpp"
              ;
            }
          }
  
          var $35=$embedded_cmd; //@line 1672 "translate.cpp"
          var $and31=($35) & 128; //@line 1672 "translate.cpp"
          var $cmp32=((($and31))|0)==0; //@line 1672 "translate.cpp"
          if ($cmp32) { __label__ = 11;continue ; } else { __label__ = 18;break $if_then22$$if_end33$14; } //@line 1672 "translate.cpp"
        }
      }
    } while(0);
  
    var $36=$word_addr; //@line 1675 "translate.cpp"
    var $arrayidx34=(($36)&4294967295); //@line 1675 "translate.cpp"
    var $37=HEAP8[($arrayidx34)]; //@line 1675 "translate.cpp"
    var $conv35=(tempInt=(($37)),(tempInt>=128?tempInt-256:tempInt)); //@line 1675 "translate.cpp"
    var $cmp36=((($conv35))|0)==0; //@line 1675 "translate.cpp"
    if ($cmp36) { __label__ = 19;; } else { __label__ = 20;; } //@line 1675 "translate.cpp"
    $if_then37$$if_end38$27: do { 
      if (__label__ == 19) {
  
        HEAP8[(((_word_phonemes)&4294967295))]=0; //@line 1678 "translate.cpp"
        $retval=0; //@line 1679 "translate.cpp"
        ; //@line 1679 "translate.cpp"
      }
      else if (__label__ == 20) {
  
        var $38=$tr_addr; //@line 1683 "translate.cpp"
        var $prepause_timeout=(($38+8312)&4294967295); //@line 1683 "translate.cpp"
        var $39=HEAP32[(($prepause_timeout)>>2)]; //@line 1683 "translate.cpp"
        var $cmp39=((($39))|0) > 0; //@line 1683 "translate.cpp"
        if ($cmp39) { __label__ = 21;; } else { __label__ = 22;; } //@line 1683 "translate.cpp"
        if (__label__ == 21) {
  
          var $40=$tr_addr; //@line 1684 "translate.cpp"
          var $prepause_timeout41=(($40+8312)&4294967295); //@line 1684 "translate.cpp"
          var $41=HEAP32[(($prepause_timeout41)>>2)]; //@line 1684 "translate.cpp"
          var $dec=((($41)-1)&4294967295); //@line 1684 "translate.cpp"
          HEAP32[(($prepause_timeout41)>>2)]=$dec; //@line 1684 "translate.cpp"
          ; //@line 1684 "translate.cpp"
        }
  
        var $42=HEAP32[((_option_sayas)>>2)]; //@line 1686 "translate.cpp"
        var $and43=($42) & 240; //@line 1686 "translate.cpp"
        var $cmp44=((($and43))|0)==16; //@line 1686 "translate.cpp"
        if ($cmp44) { __label__ = 23;; } else { __label__ = 25;; } //@line 1686 "translate.cpp"
        $if_then45$$if_end51$33: do { 
          if (__label__ == 23) {
  
            var $43=$word_flags; //@line 1688 "translate.cpp"
            var $and46=($43) & 512; //@line 1688 "translate.cpp"
            var $tobool47=((($and46))|0)!=0; //@line 1688 "translate.cpp"
            if ($tobool47) { __label__ = 25;break $if_then45$$if_end51$33; } //@line 1688 "translate.cpp"
  
            var $44=$pre_pause_addr; //@line 1691 "translate.cpp"
            var $add49=((($44)+4)&4294967295); //@line 1691 "translate.cpp"
            $pre_pause_addr=$add49; //@line 1691 "translate.cpp"
            ; //@line 1692 "translate.cpp"
          }
        } while(0);
  
        var $45=$word_flags; //@line 1695 "translate.cpp"
        var $and52=($45) & 2; //@line 1695 "translate.cpp"
        var $tobool53=((($and52))|0)!=0; //@line 1695 "translate.cpp"
        if ($tobool53) { __label__ = 26;; } else { __label__ = 32;; } //@line 1695 "translate.cpp"
        $if_then54$$if_end72$37: do { 
          if (__label__ == 26) {
  
            var $46=HEAP32[((_option_capitals)>>2)]; //@line 1697 "translate.cpp"
            var $cmp55=((($46))|0) > 2; //@line 1697 "translate.cpp"
            var $47=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 1697 "translate.cpp"
            var $cmp57=((($47))|0) < 244; //@line 1697 "translate.cpp"
            var $or_cond=($cmp55) & ($cmp57); //@line 1697 "translate.cpp"
            if (!($or_cond)) { __label__ = 32;break $if_then54$$if_end72$37; } //@line 1697 "translate.cpp"
  
            var $_b3=HEAPU8[(__ZL13embedded_flag_b)];
            var $48=($_b3) ? 2 : 0;
            var $tobool59=((($48))|0)!=0; //@line 1700 "translate.cpp"
            if ($tobool59) { __label__ = 28;; } else { __label__ = 29;; } //@line 1700 "translate.cpp"
            if (__label__ == 28) {
  
              var $49=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 1701 "translate.cpp"
              var $sub=((($49)-1)&4294967295); //@line 1701 "translate.cpp"
              var $arrayidx61=((_embedded_list+$sub*4)&4294967295); //@line 1701 "translate.cpp"
              var $50=HEAP32[(($arrayidx61)>>2)]; //@line 1701 "translate.cpp"
              var $and62=($50) & -129; //@line 1701 "translate.cpp"
              HEAP32[(($arrayidx61)>>2)]=$and62; //@line 1701 "translate.cpp"
              ; //@line 1701 "translate.cpp"
            }
  
            var $51=HEAP32[((_option_capitals)>>2)]; //@line 1702 "translate.cpp"
            $pitch_raised=$51; //@line 1702 "translate.cpp"
            var $cmp64=((($51))|0)==3; //@line 1702 "translate.cpp"
            if ($cmp64) { __label__ = 30;; } else { __label__ = 31;; } //@line 1702 "translate.cpp"
            if (__label__ == 30) {
  
              $pitch_raised=20; //@line 1703 "translate.cpp"
              ; //@line 1703 "translate.cpp"
            }
  
            var $52=$pitch_raised; //@line 1704 "translate.cpp"
            var $shl67=((($52)*256)&4294967295); //@line 1704 "translate.cpp"
            var $add68=((($shl67)+193)&4294967295); //@line 1704 "translate.cpp"
            var $53=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 1704 "translate.cpp"
            var $inc69=((($53)+1)&4294967295); //@line 1704 "translate.cpp"
            HEAP32[((__ZL11embedded_ix)>>2)]=$inc69; //@line 1704 "translate.cpp"
            var $arrayidx70=((_embedded_list+$53*4)&4294967295); //@line 1704 "translate.cpp"
            HEAP32[(($arrayidx70)>>2)]=$add68; //@line 1704 "translate.cpp"
            HEAP8[(__ZL13embedded_flag_b)]=1;
            ; //@line 1706 "translate.cpp"
          }
        } while(0);
  
        $p=((_word_phonemes)&4294967295); //@line 1709 "translate.cpp"
        var $54=$word_flags; //@line 1710 "translate.cpp"
        var $and73=($54) & 8; //@line 1710 "translate.cpp"
        var $tobool74=((($and73))|0)!=0; //@line 1710 "translate.cpp"
        if ($tobool74) { __label__ = 33;; } else { __label__ = 40;; } //@line 1710 "translate.cpp"
        $if_then75$$if_else100$47: do { 
          if (__label__ == 33) {
  
            var $55=$word_addr; //@line 1716 "translate.cpp"
            var $call76=_memcmp($55, ((__str11554)&4294967295), 3); //@line 1716 "translate.cpp"
            var $cmp77=((($call76))|0)==0; //@line 1716 "translate.cpp"
            var $56=$word_addr; //@line 1719 "translate.cpp"
            if ($cmp77) { __label__ = 34;; } else { __label__ = 38;; } //@line 1716 "translate.cpp"
            $if_then78$$if_else96$49: do { 
              if (__label__ == 34) {
  
                var $add_ptr=(($56+3)&4294967295); //@line 1719 "translate.cpp"
                $word_addr=$add_ptr; //@line 1719 "translate.cpp"
                $ix=0; //@line 1720 "translate.cpp"
                var $57=$word_addr; //@line 1722 "translate.cpp"
                var $incdec_ptr32=(($57+1)&4294967295); //@line 1722 "translate.cpp"
                $word_addr=$incdec_ptr32; //@line 1722 "translate.cpp"
                var $58=HEAP8[($57)]; //@line 1722 "translate.cpp"
                var $conv8033=(tempInt=(($58)),(tempInt>=128?tempInt-256:tempInt)); //@line 1722 "translate.cpp"
                $c1=$conv8033; //@line 1722 "translate.cpp"
                var $59=$c1; //@line 1723 "translate.cpp"
                var $cmp8134=((($59))|0)==32; //@line 1723 "translate.cpp"
                var $60=$c1; //@line 1723 "translate.cpp"
                var $cmp8235=((($60))|0)==0; //@line 1723 "translate.cpp"
                var $or_cond436=($cmp8134) | ($cmp8235); //@line 1723 "translate.cpp"
                if ($or_cond436) { __label__ = 36;; } else { __label__ = 35;; } //@line 1723 "translate.cpp"
                $for_end89$$if_end84$51: do { 
                  if (__label__ == 35) {
                    while(1) { 
  
                      var $61=$c1; //@line 1725 "translate.cpp"
                      var $call85=_tolower($61); //@line 1725 "translate.cpp"
                      var $conv86=((($call85)) & 255); //@line 1725 "translate.cpp"
                      var $62=$ix; //@line 1725 "translate.cpp"
                      var $inc87=((($62)+1)&4294967295); //@line 1725 "translate.cpp"
                      $ix=$inc87; //@line 1725 "translate.cpp"
                      var $arrayidx88=(($lang_name+$62)&4294967295); //@line 1725 "translate.cpp"
                      HEAP8[($arrayidx88)]=$conv86; //@line 1725 "translate.cpp"
                      var $63=$word_addr; //@line 1722 "translate.cpp"
                      var $incdec_ptr=(($63+1)&4294967295); //@line 1722 "translate.cpp"
                      $word_addr=$incdec_ptr; //@line 1722 "translate.cpp"
                      var $64=HEAP8[($63)]; //@line 1722 "translate.cpp"
                      var $conv80=(tempInt=(($64)),(tempInt>=128?tempInt-256:tempInt)); //@line 1722 "translate.cpp"
                      $c1=$conv80; //@line 1722 "translate.cpp"
                      var $65=$c1; //@line 1723 "translate.cpp"
                      var $cmp81=((($65))|0)==32; //@line 1723 "translate.cpp"
                      var $66=$c1; //@line 1723 "translate.cpp"
                      var $cmp82=((($66))|0)==0; //@line 1723 "translate.cpp"
                      var $or_cond4=($cmp81) | ($cmp82); //@line 1723 "translate.cpp"
                      if ($or_cond4) { __label__ = 36;break $for_end89$$if_end84$51; } else { __label__ = 35;continue ; } //@line 1723 "translate.cpp"
                    }
                  }
                } while(0);
  
                var $67=$ix; //@line 1727 "translate.cpp"
                var $arrayidx90=(($lang_name+$67)&4294967295); //@line 1727 "translate.cpp"
                HEAP8[($arrayidx90)]=0; //@line 1727 "translate.cpp"
                var $arraydecay=(($lang_name)&4294967295); //@line 1729 "translate.cpp"
                var $call91=__Z18LookupPhonemeTablePKc($arraydecay); //@line 1729 "translate.cpp"
                $ix=$call91; //@line 1729 "translate.cpp"
                var $cmp92=((($call91))|0) > 0; //@line 1729 "translate.cpp"
                if (!($cmp92)) { __label__ = 39;break $if_then78$$if_else96$49; } //@line 1729 "translate.cpp"
  
                var $68=$ix; //@line 1731 "translate.cpp"
                __Z18SelectPhonemeTablei($68); //@line 1731 "translate.cpp"
                HEAP8[(((_word_phonemes)&4294967295))]=21; //@line 1732 "translate.cpp"
                var $69=$ix; //@line 1733 "translate.cpp"
                var $conv94=((($69)) & 255); //@line 1733 "translate.cpp"
                HEAP8[(((_word_phonemes+1)&4294967295))]=$conv94; //@line 1733 "translate.cpp"
                HEAP8[(((_word_phonemes+2)&4294967295))]=0; //@line 1734 "translate.cpp"
                ; //@line 1735 "translate.cpp"
              }
              else if (__label__ == 38) {
  
                var $arraydecay97=(($bad_phoneme)&4294967295); //@line 1739 "translate.cpp"
                var $call98=__Z14EncodePhonemesPcS_Ph($56, ((_word_phonemes)&4294967295), $arraydecay97); //@line 1739 "translate.cpp"
                ;
              }
            } while(0);
  
            $flags=-2147483648; //@line 1741 "translate.cpp"
            ; //@line 1742 "translate.cpp"
          }
          else if (__label__ == 40) {
  
            $ix=0; //@line 1746 "translate.cpp"
            ; //@line 1747 "translate.cpp"
            $while_cond$59: while(1) { 
  
              var $70=$ix; //@line 1747 "translate.cpp"
              var $71=$word_addr; //@line 1747 "translate.cpp"
              var $arrayidx101=(($71+$70)&4294967295); //@line 1747 "translate.cpp"
              var $72=HEAP8[($arrayidx101)]; //@line 1747 "translate.cpp"
              var $73=$ix; //@line 1747 "translate.cpp"
              var $arrayidx102=(($word_copy+$73)&4294967295); //@line 1747 "translate.cpp"
              HEAP8[($arrayidx102)]=$72; //@line 1747 "translate.cpp"
              var $conv103=(tempInt=(($72)),(tempInt>=128?tempInt-256:tempInt)); //@line 1747 "translate.cpp"
              $c2=$conv103; //@line 1747 "translate.cpp"
              var $cmp104=((($conv103))|0)!=32; //@line 1747 "translate.cpp"
              if (!($cmp104)) { __label__ = 43;break $while_cond$59; } //@line 1747 "translate.cpp"
  
              var $74=$c2; //@line 1747 "translate.cpp"
              var $cmp106=((($74))|0)!=0; //@line 1747 "translate.cpp"
              if (!($cmp106)) { __label__ = 43;break $while_cond$59; } //@line 1747 "translate.cpp"
  
              var $76=$ix; //@line 1747 "translate.cpp"
              var $cmp107=((($76))|0) < 160; //@line 1747 "translate.cpp"
              var $77=$ix; //@line 1747 "translate.cpp"
              if ($cmp107) { __lastLabel__ = 44; ; } else { __lastLabel__ = 44; __label__ = 46;break $while_cond$59; }
  
              var $inc108=((($77)+1)&4294967295); //@line 1747 "translate.cpp"
              $ix=$inc108; //@line 1747 "translate.cpp"
              __label__ = 41;continue $while_cond$59; //@line 1747 "translate.cpp"
            }
            if (__label__ == 43) {
  
              var $75=$ix; //@line 1747 "translate.cpp"
              __lastLabel__ = 43; ;
            }
  
            var $78=__lastLabel__ == 43 ? $75 : ($77);
            $word_copy_len=$78; //@line 1748 "translate.cpp"
            var $79=HEAP32[((_translator)>>2)]; //@line 1750 "translate.cpp"
            var $80=$word_addr; //@line 1750 "translate.cpp"
            var $81=$next_pause_addr; //@line 1750 "translate.cpp"
            var $82=$wtab_addr; //@line 1750 "translate.cpp"
            var $call109=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($79, $80, $81, $82); //@line 1750 "translate.cpp"
            $flags=$call109; //@line 1750 "translate.cpp"
            var $83=$flags; //@line 1752 "translate.cpp"
            var $and110=($83) & 65536; //@line 1752 "translate.cpp"
            var $tobool111=((($and110))|0)!=0; //@line 1752 "translate.cpp"
            if ($tobool111) { __label__ = 47;; } else { __label__ = 48;; } //@line 1752 "translate.cpp"
            if (__label__ == 47) {
  
              var $84=$word_addr; //@line 1755 "translate.cpp"
              var $arraydecay113=(($word_copy)&4294967295); //@line 1755 "translate.cpp"
              var $85=$word_copy_len; //@line 1755 "translate.cpp"
              var $src$, $dest$, $stop$, $stop4$, $fast$;
              $src$ = $arraydecay113;
              $dest$ = $84;
              $stop$ = $src$ + $85;
              if (($dest$%4) == ($src$%4) && $85 > 8) {
                while ($src$%4 !== 0 && $src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }
                $src$ >>= 2;
                $dest$ >>= 2;
                $stop4$ = $stop$ >> 2;
                while ($src$ < $stop4$) {
              ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                }
                $src$ <<= 2;
                $dest$ <<= 2;
              }while ($src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }; //@line 1755 "translate.cpp"
              var $86=$flags; //@line 1756 "translate.cpp"
              $retval=$86; //@line 1756 "translate.cpp"
              __label__ = 171;break $if_then37$$if_end38$27; //@line 1756 "translate.cpp"
            }
            else if (__label__ == 48) {
  
              var $87=$flags; //@line 1759 "translate.cpp"
              var $and115=($87) & 8388608; //@line 1759 "translate.cpp"
              var $tobool116=((($and115))|0)!=0; //@line 1759 "translate.cpp"
              if ($tobool116) { __label__ = 49;; } else { __label__ = 72;; } //@line 1759 "translate.cpp"
              $land_lhs_true117$$if_end192$70: do { 
                if (__label__ == 49) {
  
                  var $88=$wtab_addr; //@line 1759 "translate.cpp"
                  var $arrayidx118=(($88+12)&4294967295); //@line 1759 "translate.cpp"
                  var $flags119=(($arrayidx118)&4294967295); //@line 1759 "translate.cpp"
                  var $89=HEAP32[(($flags119)>>2)]; //@line 1759 "translate.cpp"
                  var $and120=($89) & 8; //@line 1759 "translate.cpp"
                  var $tobool121=((($and120))|0)!=0; //@line 1759 "translate.cpp"
                  if ($tobool121) { __label__ = 72;break $land_lhs_true117$$if_end192$70; } //@line 1759 "translate.cpp"
  
                  $ok=1; //@line 1762 "translate.cpp"
                  var $arrayidx123=(($flags2)&4294967295); //@line 1767 "translate.cpp"
                  HEAP32[(($arrayidx123)>>2)]=0; //@line 1767 "translate.cpp"
                  var $90=$tr_addr; //@line 1768 "translate.cpp"
                  var $langopts=(($90)&4294967295); //@line 1768 "translate.cpp"
                  var $param=(($langopts+24)&4294967295); //@line 1768 "translate.cpp"
                  var $arrayidx124=(($param+44)&4294967295); //@line 1768 "translate.cpp"
                  var $91=HEAP32[(($arrayidx124)>>2)]; //@line 1768 "translate.cpp"
                  $sylimit=$91; //@line 1768 "translate.cpp"
                  var $92=$word_addr; //@line 1772 "translate.cpp"
                  $p2=$92; //@line 1772 "translate.cpp"
                  var $93=$p2; //@line 1773 "translate.cpp"
                  var $94=HEAP8[($93)]; //@line 1773 "translate.cpp"
                  var $conv12620=(tempInt=(($94)),(tempInt>=128?tempInt-256:tempInt)); //@line 1773 "translate.cpp"
                  var $cmp12721=((($conv12620))|0)!=32; //@line 1773 "translate.cpp"
                  var $95=$p2; //@line 1773 "translate.cpp"
                  var $incdec_ptr12922=(($95+1)&4294967295); //@line 1773 "translate.cpp"
                  if ($cmp12721) { __lastLabel__ = 50; __label__ = 51;; } else { __lastLabel__ = 50; __label__ = 52;; } //@line 1773 "translate.cpp"
                  $while_body128$$while_end130$73: do { 
                    if (__label__ == 51) {
                      while(1) { 
  
                        var $incdec_ptr12923=__lastLabel__ == 51 ? $incdec_ptr129 : ($incdec_ptr12922);
                        $p2=$incdec_ptr12923; //@line 1773 "translate.cpp"
                        var $96=$p2; //@line 1773 "translate.cpp"
                        var $97=HEAP8[($96)]; //@line 1773 "translate.cpp"
                        var $conv126=(tempInt=(($97)),(tempInt>=128?tempInt-256:tempInt)); //@line 1773 "translate.cpp"
                        var $cmp127=((($conv126))|0)!=32; //@line 1773 "translate.cpp"
                        var $98=$p2; //@line 1773 "translate.cpp"
                        var $incdec_ptr129=(($98+1)&4294967295); //@line 1773 "translate.cpp"
                        if ($cmp127) { __lastLabel__ = 51; __label__ = 51;continue ; } else { __lastLabel__ = 51; __label__ = 52;break $while_body128$$while_end130$73; } //@line 1773 "translate.cpp"
                      }
                    }
                  } while(0);
  
                  var $incdec_ptr129_lcssa=__lastLabel__ == 50 ? $incdec_ptr12922 : ($incdec_ptr129);
                  var $call132=__Z7utf8_inPiPKc($c_word2, $incdec_ptr129_lcssa); //@line 1775 "translate.cpp"
                  var $99=HEAP32[(($c_word2)>>2)]; //@line 1776 "translate.cpp"
                  var $call133=_iswalpha($99); //@line 1776 "translate.cpp"
                  var $tobool134=((($call133))|0)!=0; //@line 1776 "translate.cpp"
                  if ($tobool134) { __label__ = 54;; } else { __label__ = 53;; } //@line 1776 "translate.cpp"
                  if (__label__ == 54) {
  
                    var $_pr=$ok; //@line 1781 "translate.cpp"
                    var $cmp137=((($_pr))|0)!=0; //@line 1781 "translate.cpp"
                    if (!($cmp137)) { __label__ = 72;break $land_lhs_true117$$if_end192$70; } //@line 1781 "translate.cpp"
  
                    var $arraydecay139=(($ph_buf)&4294967295); //@line 1783 "translate.cpp"
                    var $call140=_strcpy($arraydecay139, ((_word_phonemes)&4294967295)); //@line 1783 "translate.cpp"
                    var $100=HEAP32[((_translator)>>2)]; //@line 1785 "translate.cpp"
                    var $101=$p2; //@line 1785 "translate.cpp"
                    var $add_ptr141=(($101+1)&4294967295); //@line 1785 "translate.cpp"
                    var $102=$wtab_addr; //@line 1785 "translate.cpp"
                    var $add_ptr142=(($102+12)&4294967295); //@line 1785 "translate.cpp"
                    var $call143=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($100, $add_ptr141, 0, $add_ptr142); //@line 1785 "translate.cpp"
                    var $arrayidx144=(($flags2)&4294967295); //@line 1785 "translate.cpp"
                    HEAP32[(($arrayidx144)>>2)]=$call143; //@line 1785 "translate.cpp"
                    var $arrayidx145=(($flags2)&4294967295); //@line 1786 "translate.cpp"
                    var $103=HEAP32[(($arrayidx145)>>2)]; //@line 1786 "translate.cpp"
                    var $and146=($103) & 67108864; //@line 1786 "translate.cpp"
                    var $tobool147=((($and146))|0)!=0; //@line 1786 "translate.cpp"
                    if ($tobool147) { __label__ = 56;; } else { __label__ = 57;; } //@line 1786 "translate.cpp"
                    if (__label__ == 56) {
  
                      $ok=0; //@line 1787 "translate.cpp"
                      ; //@line 1787 "translate.cpp"
                    }
  
                    var $104=$sylimit; //@line 1789 "translate.cpp"
                    var $and150=($104) & 256; //@line 1789 "translate.cpp"
                    var $tobool151=((($and150))|0)!=0; //@line 1789 "translate.cpp"
                    if ($tobool151) { __label__ = 58;; } else { __label__ = 60;; } //@line 1789 "translate.cpp"
                    $if_then152$$if_end158$83: do { 
                      if (__label__ == 58) {
  
                        var $arrayidx153=(($flags2)&4294967295); //@line 1792 "translate.cpp"
                        var $105=HEAP32[(($arrayidx153)>>2)]; //@line 1792 "translate.cpp"
                        var $and154=($105) & 1048576; //@line 1792 "translate.cpp"
                        var $cmp155=((($and154))|0)==0; //@line 1792 "translate.cpp"
                        if (!($cmp155)) { __label__ = 60;break $if_then152$$if_end158$83; } //@line 1792 "translate.cpp"
  
                        $ok=0; //@line 1794 "translate.cpp"
                        ; //@line 1795 "translate.cpp"
                      }
                    } while(0);
  
                    var $106=$sylimit; //@line 1798 "translate.cpp"
                    var $and159=($106) & 512; //@line 1798 "translate.cpp"
                    var $tobool160=((($and159))|0)!=0; //@line 1798 "translate.cpp"
                    if ($tobool160) { __label__ = 61;; } else { __label__ = 63;; } //@line 1798 "translate.cpp"
                    $land_lhs_true161$$if_end167$87: do { 
                      if (__label__ == 61) {
  
                        var $107=$wtab_addr; //@line 1798 "translate.cpp"
                        var $add_ptr162=(($107+12)&4294967295); //@line 1798 "translate.cpp"
                        var $flags163=(($add_ptr162)&4294967295); //@line 1798 "translate.cpp"
                        var $108=HEAP32[(($flags163)>>2)]; //@line 1798 "translate.cpp"
                        var $and164=($108) & 16; //@line 1798 "translate.cpp"
                        var $tobool165=((($and164))|0)!=0; //@line 1798 "translate.cpp"
                        if (!($tobool165)) { __label__ = 63;break $land_lhs_true161$$if_end167$87; } //@line 1798 "translate.cpp"
  
                        $ok=0; //@line 1801 "translate.cpp"
                        __label__ = 64;break $land_lhs_true161$$if_end167$87; //@line 1804 "translate.cpp"
                      }
                    } while(0);
                    $if_end173$$if_end167$90: do { 
                      if (__label__ == 63) {
  
                        var $_pr8=$ok; //@line 1804 "translate.cpp"
                        var $cmp168=((($_pr8))|0)==0; //@line 1804 "translate.cpp"
                        if ($cmp168) { __label__ = 64;break $if_end173$$if_end167$90; } else { __label__ = 65;break $if_end173$$if_end167$90; } //@line 1804 "translate.cpp"
                      }
                    } while(0);
                    if (__label__ == 64) {
  
                      var $arraydecay170=(($ph_buf)&4294967295); //@line 1806 "translate.cpp"
                      var $call171=_strcpy(((_word_phonemes)&4294967295), $arraydecay170); //@line 1806 "translate.cpp"
                      var $_pr10_pr=$ok; //@line 1810 "translate.cpp"
                      var $tobool174=((($_pr10_pr))|0)!=0; //@line 1810 "translate.cpp"
                      if (!($tobool174)) { __label__ = 72;break $land_lhs_true117$$if_end192$70; } //@line 1810 "translate.cpp"
                    }
  
                    var $109=$p2; //@line 1812 "translate.cpp"
                    HEAP8[($109)]=45; //@line 1812 "translate.cpp"
                    var $110=HEAP32[((_translator)>>2)]; //@line 1813 "translate.cpp"
                    var $111=$word_addr; //@line 1813 "translate.cpp"
                    var $112=$next_pause_addr; //@line 1813 "translate.cpp"
                    var $113=$wtab_addr; //@line 1813 "translate.cpp"
                    var $call176=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($110, $111, $112, $113); //@line 1813 "translate.cpp"
                    $flags=$call176; //@line 1813 "translate.cpp"
                    var $114=$sylimit; //@line 1814 "translate.cpp"
                    var $cmp177=((($114))|0) > 0; //@line 1814 "translate.cpp"
                    if ($cmp177) { __lastLabel__ = 65; __label__ = 66;; } else { __lastLabel__ = 65; __label__ = 69;; } //@line 1814 "translate.cpp"
                    if (__label__ == 66) {
  
                      var $115=$p; //@line 1814 "translate.cpp"
                      var $call179=__ZL14CountSyllablesPh($115); //@line 1814 "translate.cpp"
                      var $116=$sylimit; //@line 1814 "translate.cpp"
                      var $and180=($116) & 31; //@line 1814 "translate.cpp"
                      var $cmp181=((($call179))|0) > ((($and180))|0); //@line 1814 "translate.cpp"
                      if ($cmp181) { __label__ = 67;; } else { __label__ = 68;; } //@line 1814 "translate.cpp"
                      if (__label__ == 67) {
  
                        var $117=$p2; //@line 1817 "translate.cpp"
                        HEAP8[($117)]=32; //@line 1817 "translate.cpp"
                        var $118=HEAP32[((_translator)>>2)]; //@line 1818 "translate.cpp"
                        var $119=$word_addr; //@line 1818 "translate.cpp"
                        var $120=$next_pause_addr; //@line 1818 "translate.cpp"
                        var $121=$wtab_addr; //@line 1818 "translate.cpp"
                        var $call183=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($118, $119, $120, $121); //@line 1818 "translate.cpp"
                        $flags=$call183; //@line 1818 "translate.cpp"
                        __label__ = 72;break $land_lhs_true117$$if_end192$70; //@line 1819 "translate.cpp"
                      }
                      else if (__label__ == 68) {
  
                        var $_pr14=$flags; //@line 1822 "translate.cpp"
                        __lastLabel__ = 68; ;
                      }
                    }
  
                    var $122=__lastLabel__ == 68 ? $_pr14 : ($call176); //@line 1822 "translate.cpp"
                    var $cmp185=((($122))|0)==0; //@line 1822 "translate.cpp"
                    if ($cmp185) { __label__ = 70;; } else { __label__ = 71;; } //@line 1822 "translate.cpp"
                    if (__label__ == 70) {
  
                      var $arrayidx187=(($flags2)&4294967295); //@line 1823 "translate.cpp"
                      var $123=HEAP32[(($arrayidx187)>>2)]; //@line 1823 "translate.cpp"
                      $flags=$123; //@line 1823 "translate.cpp"
                      ; //@line 1823 "translate.cpp"
                    }
  
                    var $124=$flags; //@line 1824 "translate.cpp"
                    var $or189=($124) | 128; //@line 1824 "translate.cpp"
                    $flags=$or189; //@line 1824 "translate.cpp"
                    HEAP32[((_dictionary_skipwords)>>2)]=1; //@line 1825 "translate.cpp"
                    ;
                  }
                  else if (__label__ == 53) {
  
                    $ok=0; //@line 1778 "translate.cpp"
                    ; //@line 1810 "translate.cpp"
                  }
                }
              } while(0);
  
              var $125=$p; //@line 1830 "translate.cpp"
              var $arrayidx193=(($125)&4294967295); //@line 1830 "translate.cpp"
              var $126=HEAPU8[($arrayidx193)]; //@line 1830 "translate.cpp"
              var $conv194=((($126))&255); //@line 1830 "translate.cpp"
              var $cmp195=((($conv194))|0)==21; //@line 1830 "translate.cpp"
              if ($cmp195) { __label__ = 73;; } else { __label__ = 84;; } //@line 1830 "translate.cpp"
              $if_then196$$if_end232$106: do { 
                if (__label__ == 73) {
  
                  var $127=$word_addr; //@line 1833 "translate.cpp"
                  var $arraydecay197=(($word_copy)&4294967295); //@line 1833 "translate.cpp"
                  var $128=$word_copy_len; //@line 1833 "translate.cpp"
                  var $src$, $dest$, $stop$, $stop4$, $fast$;
                  $src$ = $arraydecay197;
                  $dest$ = $127;
                  $stop$ = $src$ + $128;
                  if (($dest$%4) == ($src$%4) && $128 > 8) {
                    while ($src$%4 !== 0 && $src$ < $stop$) {
                      ; HEAP8[$dest$++] = HEAP8[$src$++];
                    }
                    $src$ >>= 2;
                    $dest$ >>= 2;
                    $stop4$ = $stop$ >> 2;
                    while ($src$ < $stop4$) {
                  ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                    }
                    $src$ <<= 2;
                    $dest$ <<= 2;
                  }while ($src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }; //@line 1833 "translate.cpp"
                  var $129=$p; //@line 1835 "translate.cpp"
                  var $arrayidx198=(($129+1)&4294967295); //@line 1835 "translate.cpp"
                  $new_language=$arrayidx198; //@line 1835 "translate.cpp"
                  var $130=$new_language; //@line 1836 "translate.cpp"
                  var $arrayidx199=(($130)&4294967295); //@line 1836 "translate.cpp"
                  var $131=HEAP8[($arrayidx199)]; //@line 1836 "translate.cpp"
                  var $conv200=(tempInt=(($131)),(tempInt>=128?tempInt-256:tempInt)); //@line 1836 "translate.cpp"
                  var $cmp201=((($conv200))|0)==0; //@line 1836 "translate.cpp"
                  if ($cmp201) { __label__ = 74;; } else { __label__ = 75;; } //@line 1836 "translate.cpp"
                  if (__label__ == 74) {
  
                    $new_language=((__str52704)&4294967295); //@line 1837 "translate.cpp"
                    ; //@line 1837 "translate.cpp"
                  }
  
                  var $arraydecay204=(($old_dictionary_name)&4294967295); //@line 1839 "translate.cpp"
                  var $call205=_strcpy($arraydecay204, ((_dictionary_name)&4294967295)); //@line 1839 "translate.cpp"
                  var $132=$new_language; //@line 1840 "translate.cpp"
                  var $call206=__Z14SetTranslator2PKc($132); //@line 1840 "translate.cpp"
                  $switch_phonemes=$call206; //@line 1840 "translate.cpp"
                  var $cmp207=((($call206))|0) >= 0; //@line 1842 "translate.cpp"
                  if ($cmp207) { __label__ = 76;; } else { __label__ = 79;; } //@line 1842 "translate.cpp"
                  $if_then208$$if_then217$111: do { 
                    if (__label__ == 76) {
  
                      var $133=HEAP32[((_translator2)>>2)]; //@line 1845 "translate.cpp"
                      var $134=$word_addr; //@line 1845 "translate.cpp"
                      var $135=$next_pause_addr; //@line 1845 "translate.cpp"
                      var $136=$wtab_addr; //@line 1845 "translate.cpp"
                      var $call209=__Z13TranslateWordP10TranslatorPciP8WORD_TAB($133, $134, $135, $136); //@line 1845 "translate.cpp"
                      $flags=$call209; //@line 1845 "translate.cpp"
                      var $137=$p; //@line 1847 "translate.cpp"
                      var $arrayidx210=(($137)&4294967295); //@line 1847 "translate.cpp"
                      var $138=HEAPU8[($arrayidx210)]; //@line 1847 "translate.cpp"
                      var $conv211=((($138))&255); //@line 1847 "translate.cpp"
                      var $cmp212=((($conv211))|0)==21; //@line 1847 "translate.cpp"
                      if ($cmp212) { __label__ = 77;; } else { __label__ = 78;; } //@line 1847 "translate.cpp"
                      if (__label__ == 77) {
  
                        $switch_phonemes=-1; //@line 1850 "translate.cpp"
                        __label__ = 79;break $if_then208$$if_then217$111; //@line 1851 "translate.cpp"
                      }
                      else if (__label__ == 78) {
  
                        var $_pr15=$switch_phonemes; //@line 1853 "translate.cpp"
                        var $cmp216=((($_pr15))|0) < 0; //@line 1853 "translate.cpp"
                        if ($cmp216) { __label__ = 79;break $if_then208$$if_then217$111; } else { __label__ = 80;break $if_then208$$if_then217$111; } //@line 1853 "translate.cpp"
                      }
                    }
                  } while(0);
                  if (__label__ == 79) {
  
                    var $139=$p; //@line 1856 "translate.cpp"
                    var $arrayidx218=(($139)&4294967295); //@line 1856 "translate.cpp"
                    HEAP8[($arrayidx218)]=13; //@line 1856 "translate.cpp"
                    var $140=$p; //@line 1857 "translate.cpp"
                    var $arrayidx219=(($140+1)&4294967295); //@line 1857 "translate.cpp"
                    HEAP8[($arrayidx219)]=13; //@line 1857 "translate.cpp"
                    var $141=$p; //@line 1858 "translate.cpp"
                    var $arrayidx220=(($141+2)&4294967295); //@line 1858 "translate.cpp"
                    HEAP8[($arrayidx220)]=0; //@line 1858 "translate.cpp"
                    ; //@line 1859 "translate.cpp"
                  }
  
                  var $142=$tr_addr; //@line 1863 "translate.cpp"
                  var $143=$switch_phonemes; //@line 1863 "translate.cpp"
                  var $144=$p; //@line 1863 "translate.cpp"
                  var $call222=__Z24ChangeEquivalentPhonemesP10TranslatoriPc($142, $143, $144); //@line 1863 "translate.cpp"
                  var $tobool223=((($call222))|0)!=0; //@line 1863 "translate.cpp"
                  if ($tobool223) { __label__ = 81;; } else { __label__ = 82;; } //@line 1863 "translate.cpp"
                  if (__label__ == 81) {
  
                    $switch_phonemes=-1; //@line 1866 "translate.cpp"
                    ; //@line 1869 "translate.cpp"
                  }
                  else if (__label__ == 82) {
  
                    var $_pr17=$switch_phonemes; //@line 1869 "translate.cpp"
                    var $cmp226=((($_pr17))|0)==-1; //@line 1869 "translate.cpp"
                    if (!($cmp226)) { __label__ = 84;break $if_then196$$if_end232$106; } //@line 1869 "translate.cpp"
                  }
  
                  var $arraydecay228=(($old_dictionary_name)&4294967295); //@line 1871 "translate.cpp"
                  var $call229=_strcpy(((_dictionary_name)&4294967295), $arraydecay228); //@line 1871 "translate.cpp"
                  var $145=HEAP32[((_voice)>>2)]; //@line 1872 "translate.cpp"
                  var $phoneme_tab_ix=(($145+40)&4294967295); //@line 1872 "translate.cpp"
                  var $146=HEAP32[(($phoneme_tab_ix)>>2)]; //@line 1872 "translate.cpp"
                  __Z18SelectPhonemeTablei($146); //@line 1872 "translate.cpp"
                  var $147=HEAP32[((_voice)>>2)]; //@line 1876 "translate.cpp"
                  var $phoneme_tab_ix230=(($147+40)&4294967295); //@line 1876 "translate.cpp"
                  var $148=HEAP32[(($phoneme_tab_ix230)>>2)]; //@line 1876 "translate.cpp"
                  $switch_phonemes=$148; //@line 1876 "translate.cpp"
                  ; //@line 1877 "translate.cpp"
                }
              } while(0);
  
              var $149=$word_flags; //@line 1880 "translate.cpp"
              var $and233=($149) & 128; //@line 1880 "translate.cpp"
              var $tobool234=((($and233))|0)!=0; //@line 1880 "translate.cpp"
              if ($tobool234) { __label__ = 95;; } else { __label__ = 85;; } //@line 1880 "translate.cpp"
              $if_end261$$if_then235$124: do { 
                if (__label__ == 85) {
  
                  var $150=$flags; //@line 1882 "translate.cpp"
                  var $and236=($150) & 268435456; //@line 1882 "translate.cpp"
                  var $tobool237=((($and236))|0)!=0; //@line 1882 "translate.cpp"
                  if ($tobool237) { __label__ = 86;; } else { __label__ = 88;; } //@line 1882 "translate.cpp"
                  $if_then238$$if_end242$126: do { 
                    if (__label__ == 86) {
  
                      var $151=$pre_pause_addr; //@line 1884 "translate.cpp"
                      var $cmp239=((($151))|0) < 1; //@line 1884 "translate.cpp"
                      if (!($cmp239)) { __label__ = 88;break $if_then238$$if_end242$126; } //@line 1884 "translate.cpp"
  
                      $pre_pause_addr=1; //@line 1885 "translate.cpp"
                      ; //@line 1885 "translate.cpp"
                    }
                  } while(0);
  
                  var $152=$flags; //@line 1887 "translate.cpp"
                  var $and243=($152) & 256; //@line 1887 "translate.cpp"
                  var $tobool244=((($and243))|0)!=0; //@line 1887 "translate.cpp"
                  if (!($tobool244)) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $153=$word_flags; //@line 1887 "translate.cpp"
                  var $tobool246=((($153))|0)!=0; //@line 1887 "translate.cpp"
                  if ($tobool246) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $154=$wtab_addr; //@line 1887 "translate.cpp"
                  var $arrayidx248=(($154+-12)&4294967295); //@line 1887 "translate.cpp"
                  var $flags249=(($arrayidx248)&4294967295); //@line 1887 "translate.cpp"
                  var $155=HEAP32[(($flags249)>>2)]; //@line 1887 "translate.cpp"
                  var $and250=($155) & 512; //@line 1887 "translate.cpp"
                  var $tobool251=((($and250))|0)!=0; //@line 1887 "translate.cpp"
                  if ($tobool251) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $156=$tr_addr; //@line 1887 "translate.cpp"
                  var $prepause_timeout253=(($156+8312)&4294967295); //@line 1887 "translate.cpp"
                  var $157=HEAP32[(($prepause_timeout253)>>2)]; //@line 1887 "translate.cpp"
                  var $cmp254=((($157))|0)==0; //@line 1887 "translate.cpp"
                  if (!($cmp254)) { __label__ = 95;break $if_end261$$if_then235$124; } //@line 1887 "translate.cpp"
  
                  var $158=$pre_pause_addr; //@line 1890 "translate.cpp"
                  var $cmp256=((($158))|0) < 4; //@line 1890 "translate.cpp"
                  if ($cmp256) { __label__ = 93;; } else { __label__ = 94;; } //@line 1890 "translate.cpp"
                  if (__label__ == 93) {
  
                    $pre_pause_addr=4; //@line 1890 "translate.cpp"
                    ; //@line 1890 "translate.cpp"
                  }
  
                  var $159=$tr_addr; //@line 1891 "translate.cpp"
                  var $prepause_timeout259=(($159+8312)&4294967295); //@line 1891 "translate.cpp"
                  HEAP32[(($prepause_timeout259)>>2)]=3; //@line 1891 "translate.cpp"
                  ; //@line 1892 "translate.cpp"
                }
              } while(0);
  
              var $160=HEAP32[((__ZL15option_emphasis)>>2)]; //@line 1895 "translate.cpp"
              var $cmp262=((($160))|0) >= 3; //@line 1895 "translate.cpp"
              if (!($cmp262)) { __label__ = 98;break $if_then75$$if_else100$47; } //@line 1895 "translate.cpp"
  
              var $161=$pre_pause_addr; //@line 1895 "translate.cpp"
              var $cmp264=((($161))|0) < 1; //@line 1895 "translate.cpp"
              if (!($cmp264)) { __label__ = 98;break $if_then75$$if_else100$47; } //@line 1895 "translate.cpp"
  
              $pre_pause_addr=1; //@line 1896 "translate.cpp"
              ; //@line 1896 "translate.cpp"
            }
          }
        } while(0);
  
        var $162=HEAP32[((_n_ph_list2)>>2)]; //@line 1899 "translate.cpp"
        var $arrayidx268=((_ph_list2+$162*8)&4294967295); //@line 1899 "translate.cpp"
        $plist2=$arrayidx268; //@line 1899 "translate.cpp"
        $stress=0; //@line 1900 "translate.cpp"
        $next_stress=1; //@line 1901 "translate.cpp"
        $srcix=0; //@line 1902 "translate.cpp"
        $max_stress=-1; //@line 1903 "translate.cpp"
        $found_dict_flag=0; //@line 1905 "translate.cpp"
        var $163=$flags; //@line 1906 "translate.cpp"
        var $and269=($163) & -2147483648; //@line 1906 "translate.cpp"
        var $tobool270=((($and269))|0)!=0; //@line 1906 "translate.cpp"
        if ($tobool270) { __label__ = 99;; } else { __label__ = 101;; } //@line 1906 "translate.cpp"
        $land_lhs_true271$$while_cond276_preheader$141: do { 
          if (__label__ == 99) {
  
            var $164=$flags; //@line 1906 "translate.cpp"
            var $and272=($164) & 536870912; //@line 1906 "translate.cpp"
            var $tobool273=((($and272))|0)!=0; //@line 1906 "translate.cpp"
            if ($tobool273) { __label__ = 101;break $land_lhs_true271$$while_cond276_preheader$141; } //@line 1906 "translate.cpp"
  
            $found_dict_flag=16; //@line 1907 "translate.cpp"
            ; //@line 1907 "translate.cpp"
          }
        } while(0);
  
        var $165=$pre_pause_addr; //@line 1909 "translate.cpp"
        var $cmp27729=((($165))|0) > 0; //@line 1909 "translate.cpp"
        var $166=HEAP32[((_n_ph_list2)>>2)]; //@line 1909 "translate.cpp"
        var $cmp27930=((($166))|0) < 996; //@line 1909 "translate.cpp"
        var $or_cond531=($cmp27729) & ($cmp27930); //@line 1909 "translate.cpp"
        if ($or_cond531) { __lastLabel__ = 101; __label__ = 102;; } else { __lastLabel__ = 101; __label__ = 106;; } //@line 1909 "translate.cpp"
        $while_body281$$while_end292$145: do { 
          if (__label__ == 102) {
            while(1) { 
  
              var $167=__lastLabel__ == 101 ? $165 : ($173); //@line 1913 "translate.cpp"
              var $cmp282=((($167))|0) > 1; //@line 1913 "translate.cpp"
              var $168=HEAP32[((_n_ph_list2)>>2)]; //@line 1915 "translate.cpp"
              var $inc284=((($168)+1)&4294967295); //@line 1915 "translate.cpp"
              HEAP32[((_n_ph_list2)>>2)]=$inc284; //@line 1915 "translate.cpp"
              var $arrayidx285=((_ph_list2+$168*8)&4294967295); //@line 1915 "translate.cpp"
              if ($cmp282) { __label__ = 103;; } else { __label__ = 104;; } //@line 1913 "translate.cpp"
              if (__label__ == 103) {
  
                __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx285, 9); //@line 1915 "translate.cpp"
                var $169=$pre_pause_addr; //@line 1916 "translate.cpp"
                var $sub286=((($169)-2)&4294967295); //@line 1916 "translate.cpp"
                $pre_pause_addr=$sub286; //@line 1916 "translate.cpp"
                ; //@line 1917 "translate.cpp"
              }
              else if (__label__ == 104) {
  
                __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx285, 11); //@line 1920 "translate.cpp"
                var $170=$pre_pause_addr; //@line 1921 "translate.cpp"
                var $dec290=((($170)-1)&4294967295); //@line 1921 "translate.cpp"
                $pre_pause_addr=$dec290; //@line 1921 "translate.cpp"
                ;
              }
  
              var $171=$tr_addr; //@line 1923 "translate.cpp"
              var $end_stressed_vowel=(($171+8316)&4294967295); //@line 1923 "translate.cpp"
              HEAP32[(($end_stressed_vowel)>>2)]=0; //@line 1923 "translate.cpp"
              var $172=$tr_addr; //@line 1924 "translate.cpp"
              var $prev_dict_flags=(($172+8320)&4294967295); //@line 1924 "translate.cpp"
              HEAP32[(($prev_dict_flags)>>2)]=0; //@line 1924 "translate.cpp"
              var $173=$pre_pause_addr; //@line 1909 "translate.cpp"
              var $cmp277=((($173))|0) > 0; //@line 1909 "translate.cpp"
              var $174=HEAP32[((_n_ph_list2)>>2)]; //@line 1909 "translate.cpp"
              var $cmp279=((($174))|0) < 996; //@line 1909 "translate.cpp"
              var $or_cond5=($cmp277) & ($cmp279); //@line 1909 "translate.cpp"
              if ($or_cond5) { __lastLabel__ = 105; __label__ = 102;continue ; } else { __lastLabel__ = 105; __label__ = 106;break $while_body281$$while_end292$145; } //@line 1909 "translate.cpp"
            }
          }
        } while(0);
  
        var $175=HEAP32[((_option_capitals)>>2)]; //@line 1927 "translate.cpp"
        var $cmp293=((($175))|0)==1; //@line 1927 "translate.cpp"
        if ($cmp293) { __label__ = 107;; } else { __label__ = 111;; } //@line 1927 "translate.cpp"
        $land_lhs_true294$$if_end315$153: do { 
          if (__label__ == 107) {
  
            var $176=$word_flags; //@line 1927 "translate.cpp"
            var $and295=($176) & 2; //@line 1927 "translate.cpp"
            var $tobool296=((($and295))|0)!=0; //@line 1927 "translate.cpp"
            if (!($tobool296)) { __label__ = 111;break $land_lhs_true294$$if_end315$153; } //@line 1927 "translate.cpp"
  
            var $177=HEAP32[((_n_ph_list2)>>2)]; //@line 1929 "translate.cpp"
            var $inc298=((($177)+1)&4294967295); //@line 1929 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc298; //@line 1929 "translate.cpp"
            var $arrayidx299=((_ph_list2+$177*8)&4294967295); //@line 1929 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx299, 10); //@line 1929 "translate.cpp"
            var $178=HEAP32[((_n_ph_list2)>>2)]; //@line 1930 "translate.cpp"
            var $inc300=((($178)+1)&4294967295); //@line 1930 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc300; //@line 1930 "translate.cpp"
            var $arrayidx301=((_ph_list2+$178*8)&4294967295); //@line 1930 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx301, 18); //@line 1930 "translate.cpp"
            var $179=$word_flags; //@line 1931 "translate.cpp"
            var $and302=($179) & 1; //@line 1931 "translate.cpp"
            var $tobool303=((($and302))|0)!=0; //@line 1931 "translate.cpp"
            if (!($tobool303)) { __label__ = 111;break $land_lhs_true294$$if_end315$153; } //@line 1931 "translate.cpp"
  
            var $180=$word_addr; //@line 1931 "translate.cpp"
            var $arrayidx305=(($180+1)&4294967295); //@line 1931 "translate.cpp"
            var $181=HEAP8[($arrayidx305)]; //@line 1931 "translate.cpp"
            var $conv306=(tempInt=(($181)),(tempInt>=128?tempInt-256:tempInt)); //@line 1931 "translate.cpp"
            var $call307=__Z7IsAlphaj($conv306); //@line 1931 "translate.cpp"
            var $tobool308=((($call307))|0)!=0; //@line 1931 "translate.cpp"
            if (!($tobool308)) { __label__ = 111;break $land_lhs_true294$$if_end315$153; } //@line 1931 "translate.cpp"
  
            var $182=HEAP32[((_n_ph_list2)>>2)]; //@line 1934 "translate.cpp"
            var $inc310=((($182)+1)&4294967295); //@line 1934 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc310; //@line 1934 "translate.cpp"
            var $arrayidx311=((_ph_list2+$182*8)&4294967295); //@line 1934 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx311, 10); //@line 1934 "translate.cpp"
            var $183=HEAP32[((_n_ph_list2)>>2)]; //@line 1935 "translate.cpp"
            var $inc312=((($183)+1)&4294967295); //@line 1935 "translate.cpp"
            HEAP32[((_n_ph_list2)>>2)]=$inc312; //@line 1935 "translate.cpp"
            var $arrayidx313=((_ph_list2+$183*8)&4294967295); //@line 1935 "translate.cpp"
            __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx313, 18); //@line 1935 "translate.cpp"
            ; //@line 1936 "translate.cpp"
          }
        } while(0);
  
        var $184=$switch_phonemes; //@line 1939 "translate.cpp"
        var $cmp316=((($184))|0) >= 0; //@line 1939 "translate.cpp"
        if ($cmp316) { __label__ = 112;; } else { __label__ = 113;; } //@line 1939 "translate.cpp"
        if (__label__ == 112) {
  
          var $185=HEAP32[((_n_ph_list2)>>2)]; //@line 1942 "translate.cpp"
          var $arrayidx318=((_ph_list2+$185*8)&4294967295); //@line 1942 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx318, 21); //@line 1942 "translate.cpp"
          var $186=$switch_phonemes; //@line 1943 "translate.cpp"
          var $conv319=((($186)) & 255); //@line 1943 "translate.cpp"
          var $187=HEAP32[((_n_ph_list2)>>2)]; //@line 1943 "translate.cpp"
          var $inc320=((($187)+1)&4294967295); //@line 1943 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc320; //@line 1943 "translate.cpp"
          var $arrayidx321=((_ph_list2+$187*8)&4294967295); //@line 1943 "translate.cpp"
          var $tone_ph=(($arrayidx321+3)&4294967295); //@line 1943 "translate.cpp"
          HEAP8[($tone_ph)]=$conv319; //@line 1943 "translate.cpp"
          ; //@line 1944 "translate.cpp"
        }
  
        var $188=$word_flags; //@line 1947 "translate.cpp"
        var $and323=($188) & 128; //@line 1947 "translate.cpp"
        var $tobool324=((($and323))|0)!=0; //@line 1947 "translate.cpp"
        if ($tobool324) { __label__ = 114;; } else { __label__ = 116;; } //@line 1947 "translate.cpp"
        $land_lhs_true325$$if_end331$162: do { 
          if (__label__ == 114) {
  
            var $189=$p; //@line 1947 "translate.cpp"
            var $190=HEAPU8[($189)]; //@line 1947 "translate.cpp"
            var $idxprom=((($190))&255); //@line 1947 "translate.cpp"
            var $arrayidx326=((_phoneme_tab+$idxprom*4)&4294967295); //@line 1947 "translate.cpp"
            var $191=HEAP32[(($arrayidx326)>>2)]; //@line 1947 "translate.cpp"
            var $type=(($191+11)&4294967295); //@line 1947 "translate.cpp"
            var $192=HEAPU8[($type)]; //@line 1947 "translate.cpp"
            var $conv327=((($192))&255); //@line 1947 "translate.cpp"
            var $cmp328=((($conv327))|0)==0; //@line 1947 "translate.cpp"
            if (!($cmp328)) { __label__ = 116;break $land_lhs_true325$$if_end331$162; } //@line 1947 "translate.cpp"
  
            var $193=$p; //@line 1948 "translate.cpp"
            var $incdec_ptr330=(($193+1)&4294967295); //@line 1948 "translate.cpp"
            $p=$incdec_ptr330; //@line 1948 "translate.cpp"
            ; //@line 1948 "translate.cpp"
          }
        } while(0);
  
        var $194=$p; //@line 1950 "translate.cpp"
        var $arrayidx332=(($194)&4294967295); //@line 1950 "translate.cpp"
        var $195=HEAPU8[($arrayidx332)]; //@line 1950 "translate.cpp"
        var $conv333=((($195))&255); //@line 1950 "translate.cpp"
        var $cmp334=((($conv333))|0)==0; //@line 1950 "translate.cpp"
        if ($cmp334) { __label__ = 117;; } else { __label__ = 119;; } //@line 1950 "translate.cpp"
        $land_lhs_true335$$while_cond341_preheader$166: do { 
          if (__label__ == 117) {
  
            var $_b2=HEAPU8[(__ZL13embedded_flag_b)];
            var $196=($_b2) ? 2 : 0;
            var $tobool336=((($196))|0)!=0; //@line 1950 "translate.cpp"
            if (!($tobool336)) { __label__ = 119;break $land_lhs_true335$$while_cond341_preheader$166; } //@line 1950 "translate.cpp"
  
            var $197=$p; //@line 1953 "translate.cpp"
            var $arrayidx338=(($197)&4294967295); //@line 1953 "translate.cpp"
            HEAP8[($arrayidx338)]=23; //@line 1953 "translate.cpp"
            var $198=$p; //@line 1954 "translate.cpp"
            var $arrayidx339=(($198+1)&4294967295); //@line 1954 "translate.cpp"
            HEAP8[($arrayidx339)]=0; //@line 1954 "translate.cpp"
            ; //@line 1955 "translate.cpp"
          }
        } while(0);
  
        var $199=$p; //@line 1957 "translate.cpp"
        var $incdec_ptr34224=(($199+1)&4294967295); //@line 1957 "translate.cpp"
        $p=$incdec_ptr34224; //@line 1957 "translate.cpp"
        var $200=HEAPU8[($199)]; //@line 1957 "translate.cpp"
        $ph_code=$200; //@line 1957 "translate.cpp"
        var $conv34325=((($200))&255); //@line 1957 "translate.cpp"
        var $cmp34426=((($conv34325))|0)!=0; //@line 1957 "translate.cpp"
        var $201=HEAP32[((_n_ph_list2)>>2)]; //@line 1957 "translate.cpp"
        var $cmp34627=((($201))|0) < 996; //@line 1957 "translate.cpp"
        var $or_cond628=($cmp34426) & ($cmp34627); //@line 1957 "translate.cpp"
        if ($or_cond628) { __label__ = 120;; } else { __label__ = 157;; } //@line 1957 "translate.cpp"
        $while_body348$$while_end511$170: do { 
          if (__label__ == 120) {
            $while_body348$171: while(1) { 
  
              var $202=$ph_code; //@line 1959 "translate.cpp"
              var $conv349=((($202))&255); //@line 1959 "translate.cpp"
              var $cmp350=((($conv349))|0)==255; //@line 1959 "translate.cpp"
              if ($cmp350) { __label__ = 121;; } else { __label__ = 122;; } //@line 1959 "translate.cpp"
              $while_cond341_backedge$$if_end352$173: do { 
                if (__label__ == 122) {
  
                  var $206=$ph_code; //@line 1963 "translate.cpp"
                  var $idxprom353=((($206))&255); //@line 1963 "translate.cpp"
                  var $arrayidx354=((_phoneme_tab+$idxprom353*4)&4294967295); //@line 1963 "translate.cpp"
                  var $207=HEAP32[(($arrayidx354)>>2)]; //@line 1963 "translate.cpp"
                  $ph=$207; //@line 1963 "translate.cpp"
                  var $208=$ph_code; //@line 1965 "translate.cpp"
                  var $conv355=((($208))&255); //@line 1965 "translate.cpp"
                  var $cmp356=((($conv355))|0)==21; //@line 1965 "translate.cpp"
                  if ($cmp356) { __label__ = 123;; } else { __label__ = 124;; } //@line 1965 "translate.cpp"
                  if (__label__ == 123) {
  
                    var $209=$ph_code; //@line 1967 "translate.cpp"
                    var $210=HEAP32[((_n_ph_list2)>>2)]; //@line 1967 "translate.cpp"
                    var $arrayidx358=((_ph_list2+$210*8)&4294967295); //@line 1967 "translate.cpp"
                    var $phcode=(($arrayidx358)&4294967295); //@line 1967 "translate.cpp"
                    HEAP8[($phcode)]=$209; //@line 1967 "translate.cpp"
                    var $211=HEAP32[((_n_ph_list2)>>2)]; //@line 1968 "translate.cpp"
                    var $arrayidx359=((_ph_list2+$211*8)&4294967295); //@line 1968 "translate.cpp"
                    var $sourceix360=(($arrayidx359+6)&4294967295); //@line 1968 "translate.cpp"
                    HEAP16[(($sourceix360)>>1)]=0; //@line 1968 "translate.cpp"
                    var $_b1=HEAPU8[(__ZL13embedded_flag_b)];
                    var $212=($_b1) ? 2 : 0;
                    var $conv361=((($212)) & 65535); //@line 1969 "translate.cpp"
                    var $213=HEAP32[((_n_ph_list2)>>2)]; //@line 1969 "translate.cpp"
                    var $arrayidx362=((_ph_list2+$213*8)&4294967295); //@line 1969 "translate.cpp"
                    var $synthflags=(($arrayidx362+4)&4294967295); //@line 1969 "translate.cpp"
                    HEAP16[(($synthflags)>>1)]=$conv361; //@line 1969 "translate.cpp"
                    var $214=$p; //@line 1970 "translate.cpp"
                    var $incdec_ptr363=(($214+1)&4294967295); //@line 1970 "translate.cpp"
                    $p=$incdec_ptr363; //@line 1970 "translate.cpp"
                    var $215=HEAP8[($214)]; //@line 1970 "translate.cpp"
                    var $216=HEAP32[((_n_ph_list2)>>2)]; //@line 1970 "translate.cpp"
                    var $inc364=((($216)+1)&4294967295); //@line 1970 "translate.cpp"
                    HEAP32[((_n_ph_list2)>>2)]=$inc364; //@line 1970 "translate.cpp"
                    var $arrayidx365=((_ph_list2+$216*8)&4294967295); //@line 1970 "translate.cpp"
                    var $tone_ph366=(($arrayidx365+3)&4294967295); //@line 1970 "translate.cpp"
                    HEAP8[($tone_ph366)]=$215; //@line 1970 "translate.cpp"
                    ; //@line 1971 "translate.cpp"
                  }
                  else if (__label__ == 124) {
  
                    var $217=$ph; //@line 1973 "translate.cpp"
                    var $type368=(($217+11)&4294967295); //@line 1973 "translate.cpp"
                    var $218=HEAPU8[($type368)]; //@line 1973 "translate.cpp"
                    var $conv369=((($218))&255); //@line 1973 "translate.cpp"
                    var $cmp370=((($conv369))|0)==1; //@line 1973 "translate.cpp"
                    if ($cmp370) { __label__ = 125;; } else { __label__ = 130;; } //@line 1973 "translate.cpp"
                    if (__label__ == 125) {
  
                      var $219=$ph; //@line 1978 "translate.cpp"
                      var $program=(($219+8)&4294967295); //@line 1978 "translate.cpp"
                      var $220=HEAPU16[(($program)>>1)]; //@line 1978 "translate.cpp"
                      var $conv372=((($220))&65535); //@line 1978 "translate.cpp"
                      var $cmp373=((($conv372))|0)==0; //@line 1978 "translate.cpp"
                      if ($cmp373) { __label__ = 126;; } else { __label__ = 127;; } //@line 1978 "translate.cpp"
                      if (__label__ == 126) {
  
                        var $221=$ph; //@line 1979 "translate.cpp"
                        var $std_length=(($221+14)&4294967295); //@line 1979 "translate.cpp"
                        var $222=HEAPU8[($std_length)]; //@line 1979 "translate.cpp"
                        var $conv375=((($222))&255); //@line 1979 "translate.cpp"
                        $next_stress=$conv375; //@line 1979 "translate.cpp"
                        ; //@line 1979 "translate.cpp"
                      }
                      else if (__label__ == 127) {
  
                        var $223=$prev_vowel; //@line 1983 "translate.cpp"
                        var $cmp377=((($223))|0) >= 0; //@line 1983 "translate.cpp"
                        var $224=$ph_code; //@line 1985 "translate.cpp"
                        if ($cmp377) { __label__ = 128;; } else { __label__ = 129;; } //@line 1983 "translate.cpp"
                        if (__label__ == 128) {
  
                          var $225=$prev_vowel; //@line 1985 "translate.cpp"
                          var $arrayidx379=((_ph_list2+$225*8)&4294967295); //@line 1985 "translate.cpp"
                          var $tone_ph380=(($arrayidx379+3)&4294967295); //@line 1985 "translate.cpp"
                          HEAP8[($tone_ph380)]=$224; //@line 1985 "translate.cpp"
                          ; //@line 1986 "translate.cpp"
                        }
                        else if (__label__ == 129) {
  
                          var $conv382=((($224))&255); //@line 1989 "translate.cpp"
                          $next_tone=$conv382; //@line 1989 "translate.cpp"
                          ;
                        }
                      }
                    }
                    else if (__label__ == 130) {
  
                      var $226=$ph_code; //@line 1994 "translate.cpp"
                      var $conv386=((($226))&255); //@line 1994 "translate.cpp"
                      var $cmp387=((($conv386))|0)==20; //@line 1994 "translate.cpp"
                      if ($cmp387) { __label__ = 131;; } else { __label__ = 132;; } //@line 1994 "translate.cpp"
                      if (__label__ == 131) {
  
                        var $227=HEAP32[((_n_ph_list2)>>2)]; //@line 1997 "translate.cpp"
                        var $sub389=((($227)-1)&4294967295); //@line 1997 "translate.cpp"
                        $prev_vowel=$sub389; //@line 1997 "translate.cpp"
                        var $228=$prev_vowel; //@line 1998 "translate.cpp"
                        var $arrayidx390=((_ph_list2+$228*8)&4294967295); //@line 1998 "translate.cpp"
                        var $synthflags391=(($arrayidx390+4)&4294967295); //@line 1998 "translate.cpp"
                        var $229=HEAPU16[(($synthflags391)>>1)]; //@line 1998 "translate.cpp"
                        var $conv392=((($229))&65535); //@line 1998 "translate.cpp"
                        var $or393=($conv392) | 4; //@line 1998 "translate.cpp"
                        var $conv394=((($or393)) & 65535); //@line 1998 "translate.cpp"
                        HEAP16[(($synthflags391)>>1)]=$conv394; //@line 1998 "translate.cpp"
                        var $230=$next_stress; //@line 1999 "translate.cpp"
                        var $conv395=((($230)) & 255); //@line 1999 "translate.cpp"
                        var $231=$prev_vowel; //@line 1999 "translate.cpp"
                        var $arrayidx396=((_ph_list2+$231*8)&4294967295); //@line 1999 "translate.cpp"
                        var $stresslevel=(($arrayidx396+1)&4294967295); //@line 1999 "translate.cpp"
                        HEAP8[($stresslevel)]=$conv395; //@line 1999 "translate.cpp"
                        ; //@line 2000 "translate.cpp"
                      }
                      else if (__label__ == 132) {
  
                        var $232=$ph_code; //@line 2002 "translate.cpp"
                        var $conv398=((($232))&255); //@line 2002 "translate.cpp"
                        var $cmp399=((($conv398))|0)==12; //@line 2002 "translate.cpp"
                        if ($cmp399) { __label__ = 133;; } else { __label__ = 134;; } //@line 2002 "translate.cpp"
                        if (__label__ == 133) {
  
                          var $233=HEAP32[((_n_ph_list2)>>2)]; //@line 2004 "translate.cpp"
                          var $sub401=((($233)-1)&4294967295); //@line 2004 "translate.cpp"
                          var $arrayidx402=((_ph_list2+$sub401*8)&4294967295); //@line 2004 "translate.cpp"
                          var $synthflags403=(($arrayidx402+4)&4294967295); //@line 2004 "translate.cpp"
                          var $234=HEAPU16[(($synthflags403)>>1)]; //@line 2004 "translate.cpp"
                          var $conv404=((($234))&65535); //@line 2004 "translate.cpp"
                          var $or405=($conv404) | 8; //@line 2004 "translate.cpp"
                          var $conv406=((($or405)) & 65535); //@line 2004 "translate.cpp"
                          HEAP16[(($synthflags403)>>1)]=$conv406; //@line 2004 "translate.cpp"
                          ; //@line 2005 "translate.cpp"
                        }
                        else if (__label__ == 134) {
  
                          var $235=$ph_code; //@line 2007 "translate.cpp"
                          var $conv408=((($235))&255); //@line 2007 "translate.cpp"
                          var $cmp409=((($conv408))|0)==15; //@line 2007 "translate.cpp"
                          if ($cmp409) { __label__ = 135;; } else { __label__ = 136;; } //@line 2007 "translate.cpp"
                          if (__label__ == 135) {
  
                            var $236=$source_ix; //@line 2012 "translate.cpp"
                            var $add411=((($236)+1)&4294967295); //@line 2012 "translate.cpp"
                            $srcix=$add411; //@line 2012 "translate.cpp"
                            ; //@line 2013 "translate.cpp"
                          }
                          else if (__label__ == 136) {
  
                            var $237=$ph_code; //@line 2015 "translate.cpp"
                            var $conv413=((($237))&255); //@line 2015 "translate.cpp"
                            var $cmp414=((($conv413))|0)==22; //@line 2015 "translate.cpp"
                            if ($cmp414) { __label__ = 137;; } else { __label__ = 139;; } //@line 2015 "translate.cpp"
                            if (__label__ == 137) {
  
                              var $238=$tr_addr; //@line 2018 "translate.cpp"
                              var $langopts416=(($238)&4294967295); //@line 2018 "translate.cpp"
                              var $param417=(($langopts416+24)&4294967295); //@line 2018 "translate.cpp"
                              var $arrayidx418=(($param417+56)&4294967295); //@line 2018 "translate.cpp"
                              var $239=HEAP32[(($arrayidx418)>>2)]; //@line 2018 "translate.cpp"
                              var $tobool419=((($239))|0)!=0; //@line 2018 "translate.cpp"
                              if (!($tobool419)) { __label__ = 121;break $while_cond341_backedge$$if_end352$173; } //@line 2018 "translate.cpp"
  
                              var $240=$flags; //@line 2020 "translate.cpp"
                              var $or421=($240) | 524288; //@line 2020 "translate.cpp"
                              $flags=$or421; //@line 2020 "translate.cpp"
                              ; //@line 2021 "translate.cpp"
                            }
                            else if (__label__ == 139) {
  
                              var $241=$ph_code; //@line 2025 "translate.cpp"
                              var $242=HEAP32[((_n_ph_list2)>>2)]; //@line 2025 "translate.cpp"
                              var $arrayidx424=((_ph_list2+$242*8)&4294967295); //@line 2025 "translate.cpp"
                              var $phcode425=(($arrayidx424)&4294967295); //@line 2025 "translate.cpp"
                              HEAP8[($phcode425)]=$241; //@line 2025 "translate.cpp"
                              var $243=HEAP32[((_n_ph_list2)>>2)]; //@line 2026 "translate.cpp"
                              var $arrayidx426=((_ph_list2+$243*8)&4294967295); //@line 2026 "translate.cpp"
                              var $tone_ph427=(($arrayidx426+3)&4294967295); //@line 2026 "translate.cpp"
                              HEAP8[($tone_ph427)]=0; //@line 2026 "translate.cpp"
                              var $_b=HEAPU8[(__ZL13embedded_flag_b)];
                              var $244=($_b) ? 2 : 0;
                              var $245=$found_dict_flag; //@line 2027 "translate.cpp"
                              var $or428=($244) | ($245); //@line 2027 "translate.cpp"
                              var $conv429=((($or428)) & 65535); //@line 2027 "translate.cpp"
                              var $246=HEAP32[((_n_ph_list2)>>2)]; //@line 2027 "translate.cpp"
                              var $arrayidx430=((_ph_list2+$246*8)&4294967295); //@line 2027 "translate.cpp"
                              var $synthflags431=(($arrayidx430+4)&4294967295); //@line 2027 "translate.cpp"
                              HEAP16[(($synthflags431)>>1)]=$conv429; //@line 2027 "translate.cpp"
                              HEAP8[(__ZL13embedded_flag_b)]=0;
                              var $247=$srcix; //@line 2029 "translate.cpp"
                              var $conv432=((($247)) & 65535); //@line 2029 "translate.cpp"
                              var $248=HEAP32[((_n_ph_list2)>>2)]; //@line 2029 "translate.cpp"
                              var $arrayidx433=((_ph_list2+$248*8)&4294967295); //@line 2029 "translate.cpp"
                              var $sourceix434=(($arrayidx433+6)&4294967295); //@line 2029 "translate.cpp"
                              HEAP16[(($sourceix434)>>1)]=$conv432; //@line 2029 "translate.cpp"
                              $srcix=0; //@line 2030 "translate.cpp"
                              var $249=$ph; //@line 2032 "translate.cpp"
                              var $type435=(($249+11)&4294967295); //@line 2032 "translate.cpp"
                              var $250=HEAPU8[($type435)]; //@line 2032 "translate.cpp"
                              var $conv436=((($250))&255); //@line 2032 "translate.cpp"
                              var $cmp437=((($conv436))|0)==2; //@line 2032 "translate.cpp"
                              if ($cmp437) { __label__ = 140;; } else { __label__ = 149;; } //@line 2032 "translate.cpp"
                              $if_then438$$if_else466$200: do { 
                                if (__label__ == 140) {
  
                                  var $251=$next_stress; //@line 2034 "translate.cpp"
                                  $stress=$251; //@line 2034 "translate.cpp"
                                  $next_stress=1; //@line 2035 "translate.cpp"
                                  var $252=$stress; //@line 2037 "translate.cpp"
                                  var $cmp439=((($252))|0) >= 4; //@line 2037 "translate.cpp"
                                  if ($cmp439) { __label__ = 141;; } else { __label__ = 142;; } //@line 2037 "translate.cpp"
                                  if (__label__ == 141) {
  
                                    HEAP8[(__ZL18any_stressed_words_b)]=1;
                                    ; //@line 2040 "translate.cpp"
                                  }
  
                                  var $253=$prev_vowel; //@line 2042 "translate.cpp"
                                  var $cmp442=((($253))|0) >= 0; //@line 2042 "translate.cpp"
                                  if ($cmp442) { __label__ = 143;; } else { __label__ = 145;; } //@line 2042 "translate.cpp"
                                  $land_lhs_true443$$if_end451$205: do { 
                                    if (__label__ == 143) {
  
                                      var $254=HEAP32[((_n_ph_list2)>>2)]; //@line 2042 "translate.cpp"
                                      var $sub444=((($254)-1)&4294967295); //@line 2042 "translate.cpp"
                                      var $255=$prev_vowel; //@line 2042 "translate.cpp"
                                      var $cmp445=((($sub444))|0)!=((($255))|0); //@line 2042 "translate.cpp"
                                      if (!($cmp445)) { __label__ = 145;break $land_lhs_true443$$if_end451$205; } //@line 2042 "translate.cpp"
  
                                      var $256=$stress; //@line 2043 "translate.cpp"
                                      var $conv447=((($256)) & 255); //@line 2043 "translate.cpp"
                                      var $257=HEAP32[((_n_ph_list2)>>2)]; //@line 2043 "translate.cpp"
                                      var $sub448=((($257)-1)&4294967295); //@line 2043 "translate.cpp"
                                      var $arrayidx449=((_ph_list2+$sub448*8)&4294967295); //@line 2043 "translate.cpp"
                                      var $stresslevel450=(($arrayidx449+1)&4294967295); //@line 2043 "translate.cpp"
                                      HEAP8[($stresslevel450)]=$conv447; //@line 2043 "translate.cpp"
                                      ; //@line 2043 "translate.cpp"
                                    }
                                  } while(0);
  
                                  var $258=HEAP32[((_n_ph_list2)>>2)]; //@line 2045 "translate.cpp"
                                  var $arrayidx452=((_ph_list2+$258*8)&4294967295); //@line 2045 "translate.cpp"
                                  var $synthflags453=(($arrayidx452+4)&4294967295); //@line 2045 "translate.cpp"
                                  var $259=HEAPU16[(($synthflags453)>>1)]; //@line 2045 "translate.cpp"
                                  var $conv454=((($259))&65535); //@line 2045 "translate.cpp"
                                  var $or455=($conv454) | 4; //@line 2045 "translate.cpp"
                                  var $conv456=((($or455)) & 65535); //@line 2045 "translate.cpp"
                                  HEAP16[(($synthflags453)>>1)]=$conv456; //@line 2045 "translate.cpp"
                                  var $260=HEAP32[((_n_ph_list2)>>2)]; //@line 2046 "translate.cpp"
                                  $prev_vowel=$260; //@line 2046 "translate.cpp"
                                  var $261=$stress; //@line 2048 "translate.cpp"
                                  var $262=$max_stress; //@line 2048 "translate.cpp"
                                  var $cmp457=((($261))|0) > ((($262))|0); //@line 2048 "translate.cpp"
                                  if ($cmp457) { __label__ = 146;; } else { __label__ = 147;; } //@line 2048 "translate.cpp"
                                  if (__label__ == 146) {
  
                                    var $263=$stress; //@line 2050 "translate.cpp"
                                    $max_stress=$263; //@line 2050 "translate.cpp"
                                    var $264=HEAP32[((_n_ph_list2)>>2)]; //@line 2051 "translate.cpp"
                                    $max_stress_ix=$264; //@line 2051 "translate.cpp"
                                    ; //@line 2052 "translate.cpp"
                                  }
  
                                  var $265=$next_tone; //@line 2053 "translate.cpp"
                                  var $cmp460=((($265))|0)!=0; //@line 2053 "translate.cpp"
                                  if (!($cmp460)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2053 "translate.cpp"
  
                                  var $266=$next_tone; //@line 2055 "translate.cpp"
                                  var $conv462=((($266)) & 255); //@line 2055 "translate.cpp"
                                  var $267=HEAP32[((_n_ph_list2)>>2)]; //@line 2055 "translate.cpp"
                                  var $arrayidx463=((_ph_list2+$267*8)&4294967295); //@line 2055 "translate.cpp"
                                  var $tone_ph464=(($arrayidx463+3)&4294967295); //@line 2055 "translate.cpp"
                                  HEAP8[($tone_ph464)]=$conv462; //@line 2055 "translate.cpp"
                                  $next_tone=0; //@line 2056 "translate.cpp"
                                  ; //@line 2057 "translate.cpp"
                                }
                                else if (__label__ == 149) {
  
                                  var $268=$first_phoneme; //@line 2061 "translate.cpp"
                                  var $tobool467=((($268))|0)!=0; //@line 2061 "translate.cpp"
                                  if (!($tobool467)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2061 "translate.cpp"
  
                                  var $269=$tr_addr; //@line 2061 "translate.cpp"
                                  var $langopts469=(($269)&4294967295); //@line 2061 "translate.cpp"
                                  var $param470=(($langopts469+24)&4294967295); //@line 2061 "translate.cpp"
                                  var $arrayidx471=(($param470+56)&4294967295); //@line 2061 "translate.cpp"
                                  var $270=HEAP32[(($arrayidx471)>>2)]; //@line 2061 "translate.cpp"
                                  var $tobool472=((($270))|0)!=0; //@line 2061 "translate.cpp"
                                  if (!($tobool472)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2061 "translate.cpp"
  
                                  var $271=$tr_addr; //@line 2063 "translate.cpp"
                                  var $prev_dict_flags474=(($271+8320)&4294967295); //@line 2063 "translate.cpp"
                                  var $272=HEAP32[(($prev_dict_flags474)>>2)]; //@line 2063 "translate.cpp"
                                  var $and475=($272) & 524288; //@line 2063 "translate.cpp"
                                  var $tobool476=((($and475))|0)!=0; //@line 2063 "translate.cpp"
                                  if ($tobool476) { __label__ = 152;; } else { __label__ = 153;; } //@line 2063 "translate.cpp"
                                  $land_lhs_true477$$lor_lhs_false483$216: do { 
                                    if (__label__ == 152) {
  
                                      var $273=$tr_addr; //@line 2063 "translate.cpp"
                                      var $langopts478=(($273)&4294967295); //@line 2063 "translate.cpp"
                                      var $param479=(($langopts478+24)&4294967295); //@line 2063 "translate.cpp"
                                      var $arrayidx480=(($param479+56)&4294967295); //@line 2063 "translate.cpp"
                                      var $274=HEAP32[(($arrayidx480)>>2)]; //@line 2063 "translate.cpp"
                                      var $and481=($274) & 1; //@line 2063 "translate.cpp"
                                      var $tobool482=((($and481))|0)!=0; //@line 2063 "translate.cpp"
                                      if ($tobool482) { __label__ = 155;break $land_lhs_true477$$lor_lhs_false483$216; } else { __label__ = 153;break $land_lhs_true477$$lor_lhs_false483$216; } //@line 2063 "translate.cpp"
                                    }
                                  } while(0);
                                  if (__label__ == 153) {
  
                                    var $275=$tr_addr; //@line 2063 "translate.cpp"
                                    var $end_stressed_vowel484=(($275+8316)&4294967295); //@line 2063 "translate.cpp"
                                    var $276=HEAP32[(($end_stressed_vowel484)>>2)]; //@line 2063 "translate.cpp"
                                    var $tobool485=((($276))|0)!=0; //@line 2063 "translate.cpp"
                                    if (!($tobool485)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2063 "translate.cpp"
  
                                    var $277=$tr_addr; //@line 2063 "translate.cpp"
                                    var $langopts487=(($277)&4294967295); //@line 2063 "translate.cpp"
                                    var $param488=(($langopts487+24)&4294967295); //@line 2063 "translate.cpp"
                                    var $arrayidx489=(($param488+56)&4294967295); //@line 2063 "translate.cpp"
                                    var $278=HEAP32[(($arrayidx489)>>2)]; //@line 2063 "translate.cpp"
                                    var $and490=($278) & 2; //@line 2063 "translate.cpp"
                                    var $tobool491=((($and490))|0)!=0; //@line 2063 "translate.cpp"
                                    if (!($tobool491)) { __label__ = 156;break $if_then438$$if_else466$200; } //@line 2063 "translate.cpp"
                                  }
  
                                  var $279=HEAP32[((_n_ph_list2)>>2)]; //@line 2068 "translate.cpp"
                                  var $arrayidx493=((_ph_list2+$279*8)&4294967295); //@line 2068 "translate.cpp"
                                  var $synthflags494=(($arrayidx493+4)&4294967295); //@line 2068 "translate.cpp"
                                  var $280=HEAPU16[(($synthflags494)>>1)]; //@line 2068 "translate.cpp"
                                  var $conv495=((($280))&65535); //@line 2068 "translate.cpp"
                                  var $or496=($conv495) | 8; //@line 2068 "translate.cpp"
                                  var $conv497=((($or496)) & 65535); //@line 2068 "translate.cpp"
                                  HEAP16[(($synthflags494)>>1)]=$conv497; //@line 2068 "translate.cpp"
                                  ; //@line 2069 "translate.cpp"
                                }
                              } while(0);
  
                              var $281=$stress; //@line 2073 "translate.cpp"
                              var $conv501=((($281)) & 255); //@line 2073 "translate.cpp"
                              var $282=HEAP32[((_n_ph_list2)>>2)]; //@line 2073 "translate.cpp"
                              var $arrayidx502=((_ph_list2+$282*8)&4294967295); //@line 2073 "translate.cpp"
                              var $stresslevel503=(($arrayidx502+1)&4294967295); //@line 2073 "translate.cpp"
                              HEAP8[($stresslevel503)]=$conv501; //@line 2073 "translate.cpp"
                              var $283=HEAP32[((_n_ph_list2)>>2)]; //@line 2074 "translate.cpp"
                              var $inc504=((($283)+1)&4294967295); //@line 2074 "translate.cpp"
                              HEAP32[((_n_ph_list2)>>2)]=$inc504; //@line 2074 "translate.cpp"
                              $first_phoneme=0; //@line 2075 "translate.cpp"
                              ;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } while(0);
  
              var $203=$p; //@line 1957 "translate.cpp"
              var $incdec_ptr342=(($203+1)&4294967295); //@line 1957 "translate.cpp"
              $p=$incdec_ptr342; //@line 1957 "translate.cpp"
              var $204=HEAPU8[($203)]; //@line 1957 "translate.cpp"
              $ph_code=$204; //@line 1957 "translate.cpp"
              var $conv343=((($204))&255); //@line 1957 "translate.cpp"
              var $cmp344=((($conv343))|0)!=0; //@line 1957 "translate.cpp"
              var $205=HEAP32[((_n_ph_list2)>>2)]; //@line 1957 "translate.cpp"
              var $cmp346=((($205))|0) < 996; //@line 1957 "translate.cpp"
              var $or_cond6=($cmp344) & ($cmp346); //@line 1957 "translate.cpp"
              if ($or_cond6) { __label__ = 120;continue $while_body348$171; } else { __label__ = 157;break $while_body348$$while_end511$170; } //@line 1957 "translate.cpp"
            }
          }
        } while(0);
  
        var $284=$word_flags; //@line 2079 "translate.cpp"
        var $and512=($284) & 131072; //@line 2079 "translate.cpp"
        var $tobool513=((($and512))|0)!=0; //@line 2079 "translate.cpp"
        if ($tobool513) { __label__ = 158;; } else { __label__ = 159;; } //@line 2079 "translate.cpp"
        if (__label__ == 158) {
  
          var $285=HEAP32[((_n_ph_list2)>>2)]; //@line 2081 "translate.cpp"
          var $inc515=((($285)+1)&4294967295); //@line 2081 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc515; //@line 2081 "translate.cpp"
          var $arrayidx516=((_ph_list2+$285*8)&4294967295); //@line 2081 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx516, 27); //@line 2081 "translate.cpp"
          ; //@line 2082 "translate.cpp"
        }
  
        var $286=$word_flags; //@line 2085 "translate.cpp"
        var $and518=($286) & 128; //@line 2085 "translate.cpp"
        var $cmp519=((($and518))|0)==0; //@line 2085 "translate.cpp"
        if ($cmp519) { __label__ = 160;; } else { __label__ = 161;; } //@line 2085 "translate.cpp"
        if (__label__ == 160) {
  
          var $287=$source_ix; //@line 2087 "translate.cpp"
          var $conv521=((($287)) & 65535); //@line 2087 "translate.cpp"
          var $288=$plist2; //@line 2087 "translate.cpp"
          var $sourceix522=(($288+6)&4294967295); //@line 2087 "translate.cpp"
          HEAP16[(($sourceix522)>>1)]=$conv521; //@line 2087 "translate.cpp"
          ; //@line 2088 "translate.cpp"
        }
  
        var $289=$tr_addr; //@line 2090 "translate.cpp"
        var $end_stressed_vowel524=(($289+8316)&4294967295); //@line 2090 "translate.cpp"
        HEAP32[(($end_stressed_vowel524)>>2)]=0; //@line 2090 "translate.cpp"
        var $290=$stress; //@line 2091 "translate.cpp"
        var $cmp525=((($290))|0) >= 4; //@line 2091 "translate.cpp"
        if ($cmp525) { __label__ = 162;; } else { __label__ = 164;; } //@line 2091 "translate.cpp"
        $land_lhs_true526$$if_end537$231: do { 
          if (__label__ == 162) {
  
            var $291=HEAP32[((_n_ph_list2)>>2)]; //@line 2091 "translate.cpp"
            var $sub527=((($291)-1)&4294967295); //@line 2091 "translate.cpp"
            var $arrayidx528=((_ph_list2+$sub527*8)&4294967295); //@line 2091 "translate.cpp"
            var $phcode529=(($arrayidx528)&4294967295); //@line 2091 "translate.cpp"
            var $292=HEAPU8[($phcode529)]; //@line 2091 "translate.cpp"
            var $idxprom530=((($292))&255); //@line 2091 "translate.cpp"
            var $arrayidx531=((_phoneme_tab+$idxprom530*4)&4294967295); //@line 2091 "translate.cpp"
            var $293=HEAP32[(($arrayidx531)>>2)]; //@line 2091 "translate.cpp"
            var $type532=(($293+11)&4294967295); //@line 2091 "translate.cpp"
            var $294=HEAPU8[($type532)]; //@line 2091 "translate.cpp"
            var $conv533=((($294))&255); //@line 2091 "translate.cpp"
            var $cmp534=((($conv533))|0)==2; //@line 2091 "translate.cpp"
            if (!($cmp534)) { __label__ = 164;break $land_lhs_true526$$if_end537$231; } //@line 2091 "translate.cpp"
  
            var $295=$tr_addr; //@line 2093 "translate.cpp"
            var $end_stressed_vowel536=(($295+8316)&4294967295); //@line 2093 "translate.cpp"
            HEAP32[(($end_stressed_vowel536)>>2)]=1; //@line 2093 "translate.cpp"
            ; //@line 2094 "translate.cpp"
          }
        } while(0);
  
        var $296=$switch_phonemes; //@line 2096 "translate.cpp"
        var $cmp538=((($296))|0) >= 0; //@line 2096 "translate.cpp"
        if ($cmp538) { __label__ = 165;; } else { __label__ = 166;; } //@line 2096 "translate.cpp"
        if (__label__ == 165) {
  
          var $arraydecay540=(($old_dictionary_name)&4294967295); //@line 2099 "translate.cpp"
          var $call541=_strcpy(((_dictionary_name)&4294967295), $arraydecay540); //@line 2099 "translate.cpp"
          var $297=HEAP32[((_voice)>>2)]; //@line 2100 "translate.cpp"
          var $phoneme_tab_ix542=(($297+40)&4294967295); //@line 2100 "translate.cpp"
          var $298=HEAP32[(($phoneme_tab_ix542)>>2)]; //@line 2100 "translate.cpp"
          __Z18SelectPhonemeTablei($298); //@line 2100 "translate.cpp"
          var $299=HEAP32[((_n_ph_list2)>>2)]; //@line 2101 "translate.cpp"
          var $arrayidx543=((_ph_list2+$299*8)&4294967295); //@line 2101 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx543, 21); //@line 2101 "translate.cpp"
          var $300=HEAP32[((_voice)>>2)]; //@line 2102 "translate.cpp"
          var $phoneme_tab_ix544=(($300+40)&4294967295); //@line 2102 "translate.cpp"
          var $301=HEAP32[(($phoneme_tab_ix544)>>2)]; //@line 2102 "translate.cpp"
          var $conv545=((($301)) & 255); //@line 2102 "translate.cpp"
          var $302=HEAP32[((_n_ph_list2)>>2)]; //@line 2102 "translate.cpp"
          var $inc546=((($302)+1)&4294967295); //@line 2102 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc546; //@line 2102 "translate.cpp"
          var $arrayidx547=((_ph_list2+$302*8)&4294967295); //@line 2102 "translate.cpp"
          var $tone_ph548=(($arrayidx547+3)&4294967295); //@line 2102 "translate.cpp"
          HEAP8[($tone_ph548)]=$conv545; //@line 2102 "translate.cpp"
          ; //@line 2103 "translate.cpp"
        }
  
        var $303=$pitch_raised; //@line 2106 "translate.cpp"
        var $cmp550=((($303))|0) > 0; //@line 2106 "translate.cpp"
        if ($cmp550) { __label__ = 167;; } else { __label__ = 168;; } //@line 2106 "translate.cpp"
        if (__label__ == 167) {
  
          var $304=$pitch_raised; //@line 2108 "translate.cpp"
          var $shl552=((($304)*256)&4294967295); //@line 2108 "translate.cpp"
          var $add553=((($shl552)+225)&4294967295); //@line 2108 "translate.cpp"
          var $305=HEAP32[((__ZL11embedded_ix)>>2)]; //@line 2108 "translate.cpp"
          var $inc554=((($305)+1)&4294967295); //@line 2108 "translate.cpp"
          HEAP32[((__ZL11embedded_ix)>>2)]=$inc554; //@line 2108 "translate.cpp"
          var $arrayidx555=((_embedded_list+$305*4)&4294967295); //@line 2108 "translate.cpp"
          HEAP32[(($arrayidx555)>>2)]=$add553; //@line 2108 "translate.cpp"
          var $306=HEAP32[((_n_ph_list2)>>2)]; //@line 2109 "translate.cpp"
          var $arrayidx556=((_ph_list2+$306*8)&4294967295); //@line 2109 "translate.cpp"
          __ZL9SetPlist2P13PHONEME_LIST2h($arrayidx556, 10); //@line 2109 "translate.cpp"
          var $307=HEAP32[((_n_ph_list2)>>2)]; //@line 2110 "translate.cpp"
          var $inc557=((($307)+1)&4294967295); //@line 2110 "translate.cpp"
          HEAP32[((_n_ph_list2)>>2)]=$inc557; //@line 2110 "translate.cpp"
          var $arrayidx558=((_ph_list2+$307*8)&4294967295); //@line 2110 "translate.cpp"
          var $synthflags559=(($arrayidx558+4)&4294967295); //@line 2110 "translate.cpp"
          HEAP16[(($synthflags559)>>1)]=2; //@line 2110 "translate.cpp"
          ; //@line 2111 "translate.cpp"
        }
  
        var $308=$flags; //@line 2113 "translate.cpp"
        var $and561=($308) & 4096; //@line 2113 "translate.cpp"
        var $tobool562=((($and561))|0)!=0; //@line 2113 "translate.cpp"
        if ($tobool562) { __label__ = 169;; } else { __label__ = 170;; } //@line 2113 "translate.cpp"
        if (__label__ == 169) {
  
          var $309=$max_stress_ix; //@line 2116 "translate.cpp"
          var $arrayidx564=((_ph_list2+$309*8)&4294967295); //@line 2116 "translate.cpp"
          var $synthflags565=(($arrayidx564+4)&4294967295); //@line 2116 "translate.cpp"
          var $310=HEAPU16[(($synthflags565)>>1)]; //@line 2116 "translate.cpp"
          var $conv566=((($310))&65535); //@line 2116 "translate.cpp"
          var $or567=($conv566) | 64; //@line 2116 "translate.cpp"
          var $conv568=((($or567)) & 65535); //@line 2116 "translate.cpp"
          HEAP16[(($synthflags565)>>1)]=$conv568; //@line 2116 "translate.cpp"
          ; //@line 2117 "translate.cpp"
        }
  
        var $311=$flags; //@line 2119 "translate.cpp"
        var $312=$tr_addr; //@line 2119 "translate.cpp"
        var $prev_dict_flags570=(($312+8320)&4294967295); //@line 2119 "translate.cpp"
        HEAP32[(($prev_dict_flags570)>>2)]=$311; //@line 2119 "translate.cpp"
        var $313=$flags; //@line 2120 "translate.cpp"
        $retval=$313; //@line 2120 "translate.cpp"
        ; //@line 2120 "translate.cpp"
      }
    } while(0);
  
    var $314=$retval; //@line 2121 "translate.cpp"
    STACKTOP = __stackBase__;
    return $314; //@line 2121 "translate.cpp"
    return null;
  }
  

  function __Z8InitTexti($control) {
    ;
    var __label__;
  
    var $control_addr;
    $control_addr=$control;
    HEAP32[((_count_sentences)>>2)]=0; //@line 3278 "translate.cpp"
    HEAP32[((_count_words)>>2)]=0; //@line 3279 "translate.cpp"
    HEAP32[((_end_character_position)>>2)]=0; //@line 3280 "translate.cpp"
    HEAP32[((_skip_sentences)>>2)]=0; //@line 3281 "translate.cpp"
    HEAP8[(((_skip_marker)&4294967295))]=0; //@line 3282 "translate.cpp"
    HEAP32[((_skip_words)>>2)]=0; //@line 3283 "translate.cpp"
    HEAP32[((_skip_characters)>>2)]=0; //@line 3284 "translate.cpp"
    HEAP32[((_skipping_text)>>2)]=0; //@line 3285 "translate.cpp"
    HEAP32[((_new_sentence)>>2)]=1; //@line 3286 "translate.cpp"
    HEAP32[((_option_sayas)>>2)]=0; //@line 3290 "translate.cpp"
    HEAP32[((__ZL13option_sayas2)>>2)]=0; //@line 3291 "translate.cpp"
    HEAP32[((__ZL15option_emphasis)>>2)]=0; //@line 3292 "translate.cpp"
    HEAP8[(__ZL13word_emphasis_b)]=0;
    HEAP8[(__ZL13embedded_flag_b)]=0;
    __Z9InitText2v(); //@line 3296 "translate.cpp"
    var $0=$control_addr; //@line 3298 "translate.cpp"
    var $and=($0) & 8192; //@line 3298 "translate.cpp"
    var $cmp=((($and))|0)==0; //@line 3298 "translate.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 3298 "translate.cpp"
    if (__label__ == 1) {
  
      __Z12InitNamedatav(); //@line 3300 "translate.cpp"
      ; //@line 3301 "translate.cpp"
    }
  
    ;
    return; //@line 3302 "translate.cpp"
    return;
  }
  

  function __ZL14CountSyllablesPh($phonemes) {
    ;
    var __label__;
  
    var $phonemes_addr;
    var $count;
    var $phon;
    $phonemes_addr=$phonemes;
    $count=0; //@line 1555 "translate.cpp"
    var $0=$phonemes_addr; //@line 1557 "translate.cpp"
    var $incdec_ptr1=(($0+1)&4294967295); //@line 1557 "translate.cpp"
    $phonemes_addr=$incdec_ptr1; //@line 1557 "translate.cpp"
    var $1=HEAPU8[($0)]; //@line 1557 "translate.cpp"
    var $conv2=((($1))&255); //@line 1557 "translate.cpp"
    $phon=$conv2; //@line 1557 "translate.cpp"
    var $cmp3=((($conv2))|0)!=0; //@line 1557 "translate.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 4;; } //@line 1557 "translate.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$phon; //@line 1559 "translate.cpp"
          var $arrayidx=((_phoneme_tab+$2*4)&4294967295); //@line 1559 "translate.cpp"
          var $3=HEAP32[(($arrayidx)>>2)]; //@line 1559 "translate.cpp"
          var $type=(($3+11)&4294967295); //@line 1559 "translate.cpp"
          var $4=HEAPU8[($type)]; //@line 1559 "translate.cpp"
          var $conv1=((($4))&255); //@line 1559 "translate.cpp"
          var $cmp2=((($conv1))|0)==2; //@line 1559 "translate.cpp"
          if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 1559 "translate.cpp"
          if (__label__ == 2) {
  
            var $5=$count; //@line 1560 "translate.cpp"
            var $inc=((($5)+1)&4294967295); //@line 1560 "translate.cpp"
            $count=$inc; //@line 1560 "translate.cpp"
            ; //@line 1560 "translate.cpp"
          }
  
          var $6=$phonemes_addr; //@line 1557 "translate.cpp"
          var $incdec_ptr=(($6+1)&4294967295); //@line 1557 "translate.cpp"
          $phonemes_addr=$incdec_ptr; //@line 1557 "translate.cpp"
          var $7=HEAPU8[($6)]; //@line 1557 "translate.cpp"
          var $conv=((($7))&255); //@line 1557 "translate.cpp"
          $phon=$conv; //@line 1557 "translate.cpp"
          var $cmp=((($conv))|0)!=0; //@line 1557 "translate.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break $while_body$$while_end$2; } //@line 1557 "translate.cpp"
        }
      }
    } while(0);
  
    var $8=$count; //@line 1562 "translate.cpp"
    ;
    return $8; //@line 1562 "translate.cpp"
    return null;
  }
  

  function __ZL9SetPlist2P13PHONEME_LIST2h($p, $phcode) {
    ;
    var __label__;
  
    var $p_addr;
    var $phcode_addr;
    $p_addr=$p;
    $phcode_addr=$phcode;
    var $0=$phcode_addr; //@line 1545 "translate.cpp"
    var $1=$p_addr; //@line 1545 "translate.cpp"
    var $phcode1=(($1)&4294967295); //@line 1545 "translate.cpp"
    HEAP8[($phcode1)]=$0; //@line 1545 "translate.cpp"
    var $2=$p_addr; //@line 1546 "translate.cpp"
    var $stresslevel=(($2+1)&4294967295); //@line 1546 "translate.cpp"
    HEAP8[($stresslevel)]=0; //@line 1546 "translate.cpp"
    var $3=$p_addr; //@line 1547 "translate.cpp"
    var $tone_ph=(($3+3)&4294967295); //@line 1547 "translate.cpp"
    HEAP8[($tone_ph)]=0; //@line 1547 "translate.cpp"
    var $_b=HEAPU8[(__ZL13embedded_flag_b)];
    var $4=($_b) ? 2 : 0;
    var $conv=((($4)) & 65535); //@line 1548 "translate.cpp"
    var $5=$p_addr; //@line 1548 "translate.cpp"
    var $synthflags=(($5+4)&4294967295); //@line 1548 "translate.cpp"
    HEAP16[(($synthflags)>>1)]=$conv; //@line 1548 "translate.cpp"
    var $6=$p_addr; //@line 1549 "translate.cpp"
    var $sourceix=(($6+6)&4294967295); //@line 1549 "translate.cpp"
    HEAP16[(($sourceix)>>1)]=0; //@line 1549 "translate.cpp"
    HEAP8[(__ZL13embedded_flag_b)]=0;
    ;
    return; //@line 1551 "translate.cpp"
    return;
  }
  

  function __ZL14SubstituteCharP10TranslatorjjPi($tr, $c, $next_in, $insert) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $tr_addr;
    var $c_addr;
    var $next_in_addr;
    var $insert_addr;
    var $ix;
    var $word;
    var $new_c;
    var $c2;
    var $c_lower;
    var $upper_case;
    var $replace_chars;
    $tr_addr=$tr;
    $c_addr=$c;
    $next_in_addr=$next_in;
    $insert_addr=$insert;
    $upper_case=0; //@line 2195 "translate.cpp"
    var $_b=HEAPU8[(__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b)];
    var $0=((($_b))&1);
    var $tobool=((($0))|0)!=0; //@line 2199 "translate.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 2199 "translate.cpp"
    if (__label__ == 1) {
  
      HEAP8[(__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b)]=0;
      $retval=8; //@line 2202 "translate.cpp"
      ; //@line 2202 "translate.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$c_addr; //@line 2204 "translate.cpp"
      var $cmp=((($1))|0)==0; //@line 2204 "translate.cpp"
      if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 2204 "translate.cpp"
      if (__label__ == 3) {
  
        $retval=0; //@line 2204 "translate.cpp"
        ; //@line 2204 "translate.cpp"
      }
      else if (__label__ == 4) {
  
        var $2=$tr_addr; //@line 2206 "translate.cpp"
        var $langopts=(($2)&4294967295); //@line 2206 "translate.cpp"
        var $replace_chars3=(($langopts+264)&4294967295); //@line 2206 "translate.cpp"
        var $3=HEAP32[(($replace_chars3)>>2)]; //@line 2206 "translate.cpp"
        $replace_chars=$3; //@line 2206 "translate.cpp"
        var $cmp4=((($3))|0)==0; //@line 2206 "translate.cpp"
        var $4=$c_addr; //@line 2207 "translate.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 2206 "translate.cpp"
        if (__label__ == 5) {
  
          $retval=$4; //@line 2207 "translate.cpp"
          ; //@line 2207 "translate.cpp"
        }
        else if (__label__ == 6) {
  
          $c_lower=$4; //@line 2211 "translate.cpp"
          var $call=_iswupper($4); //@line 2211 "translate.cpp"
          var $tobool7=((($call))|0)!=0; //@line 2211 "translate.cpp"
          if ($tobool7) { __label__ = 7;; } else { __label__ = 8;; } //@line 2211 "translate.cpp"
          if (__label__ == 7) {
  
            var $5=$c_addr; //@line 2213 "translate.cpp"
            var $call9=_towlower($5); //@line 2213 "translate.cpp"
            $c_lower=$call9; //@line 2213 "translate.cpp"
            $upper_case=1; //@line 2214 "translate.cpp"
            ; //@line 2215 "translate.cpp"
          }
  
          $new_c=0; //@line 2217 "translate.cpp"
          $ix=0; //@line 2218 "translate.cpp"
          ; //@line 2218 "translate.cpp"
          $for_cond$14: while(1) { 
  
            var $6=$ix; //@line 2218 "translate.cpp"
            var $7=$replace_chars; //@line 2218 "translate.cpp"
            var $arrayidx=(($7+4*$6)&4294967295); //@line 2218 "translate.cpp"
            var $8=HEAP32[(($arrayidx)>>2)]; //@line 2218 "translate.cpp"
            $word=$8; //@line 2218 "translate.cpp"
            var $cmp11=((($8))|0)!=0; //@line 2218 "translate.cpp"
            if (!($cmp11)) { __label__ = 16;break $for_cond$14; } //@line 2218 "translate.cpp"
  
            var $9=$c_lower; //@line 2220 "translate.cpp"
            var $10=$word; //@line 2220 "translate.cpp"
            var $and=($10) & 65535; //@line 2220 "translate.cpp"
            var $cmp12=((($9))|0)==((($and))|0); //@line 2220 "translate.cpp"
            if ($cmp12) { __label__ = 11;; } else { __label__ = 15;; } //@line 2220 "translate.cpp"
            if (__label__ == 11) {
  
              var $11=$word; //@line 2222 "translate.cpp"
              var $shr=($11) >>> 16; //@line 2222 "translate.cpp"
              var $cmp14=((($shr))|0)==0; //@line 2222 "translate.cpp"
              if ($cmp14) { __label__ = 12;break $for_cond$14; } //@line 2222 "translate.cpp"
  
              var $15=$word; //@line 2227 "translate.cpp"
              var $shr18=($15) >>> 16; //@line 2227 "translate.cpp"
              var $16=$next_in_addr; //@line 2227 "translate.cpp"
              var $call19=_towlower($16); //@line 2227 "translate.cpp"
              var $cmp20=((($shr18))|0)==((($call19))|0); //@line 2227 "translate.cpp"
              if ($cmp20) { __label__ = 14;break $for_cond$14; } //@line 2227 "translate.cpp"
            }
  
            var $20=$ix; //@line 2218 "translate.cpp"
            var $add26=((($20)+2)&4294967295); //@line 2218 "translate.cpp"
            $ix=$add26; //@line 2218 "translate.cpp"
            __label__ = 9;continue $for_cond$14; //@line 2218 "translate.cpp"
          }
          if (__label__ == 16) {
  
            var $_pr=$new_c; //@line 2236 "translate.cpp"
            __lastLabel__ = 16; ;
          }
          else if (__label__ == 12) {
  
            var $12=$ix; //@line 2224 "translate.cpp"
            var $add=((($12)+1)&4294967295); //@line 2224 "translate.cpp"
            var $13=$replace_chars; //@line 2224 "translate.cpp"
            var $arrayidx16=(($13+4*$add)&4294967295); //@line 2224 "translate.cpp"
            var $14=HEAPU32[(($arrayidx16)>>2)]; //@line 2224 "translate.cpp"
            $new_c=$14; //@line 2224 "translate.cpp"
            __lastLabel__ = 12; ; //@line 2225 "translate.cpp"
          }
          else if (__label__ == 14) {
  
            var $17=$ix; //@line 2229 "translate.cpp"
            var $add22=((($17)+1)&4294967295); //@line 2229 "translate.cpp"
            var $18=$replace_chars; //@line 2229 "translate.cpp"
            var $arrayidx23=(($18+4*$add22)&4294967295); //@line 2229 "translate.cpp"
            var $19=HEAPU32[(($arrayidx23)>>2)]; //@line 2229 "translate.cpp"
            $new_c=$19; //@line 2229 "translate.cpp"
            HEAP8[(__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b)]=1;
            __lastLabel__ = 14; ; //@line 2231 "translate.cpp"
          }
  
          var $21=__lastLabel__ == 16 ? $_pr : (__lastLabel__ == 14 ? $19 : ($14)); //@line 2236 "translate.cpp"
          var $cmp27=((($21))|0)==0; //@line 2236 "translate.cpp"
          if ($cmp27) { __label__ = 18;; } else { __label__ = 19;; } //@line 2236 "translate.cpp"
          if (__label__ == 18) {
  
            var $22=$c_addr; //@line 2237 "translate.cpp"
            $retval=$22; //@line 2237 "translate.cpp"
            ; //@line 2237 "translate.cpp"
          }
          else if (__label__ == 19) {
  
            var $23=$new_c; //@line 2239 "translate.cpp"
            var $and30=($23) & -2097152; //@line 2239 "translate.cpp"
            var $tobool31=((($and30))|0)!=0; //@line 2239 "translate.cpp"
            if ($tobool31) { __label__ = 20;; } else { __label__ = 24;; } //@line 2239 "translate.cpp"
            if (__label__ == 20) {
  
              var $24=$new_c; //@line 2243 "translate.cpp"
              var $shr33=($24) >>> 16; //@line 2243 "translate.cpp"
              $c2=$shr33; //@line 2243 "translate.cpp"
              var $25=$upper_case; //@line 2244 "translate.cpp"
              var $tobool34=((($25))|0)!=0; //@line 2244 "translate.cpp"
              if ($tobool34) { __label__ = 21;; } else { __label__ = 23;; } //@line 2244 "translate.cpp"
              $land_lhs_true$$if_end39$31: do { 
                if (__label__ == 21) {
  
                  var $26=$next_in_addr; //@line 2244 "translate.cpp"
                  var $call35=_iswupper($26); //@line 2244 "translate.cpp"
                  var $tobool36=((($call35))|0)!=0; //@line 2244 "translate.cpp"
                  if (!($tobool36)) { __label__ = 23;break $land_lhs_true$$if_end39$31; } //@line 2244 "translate.cpp"
  
                  var $27=$c2; //@line 2245 "translate.cpp"
                  var $call38=_towupper($27); //@line 2245 "translate.cpp"
                  $c2=$call38; //@line 2245 "translate.cpp"
                  ; //@line 2245 "translate.cpp"
                }
              } while(0);
  
              var $28=$c2; //@line 2246 "translate.cpp"
              var $29=$insert_addr; //@line 2246 "translate.cpp"
              HEAP32[(($29)>>2)]=$28; //@line 2246 "translate.cpp"
              var $30=$new_c; //@line 2247 "translate.cpp"
              var $and40=($30) & 65535; //@line 2247 "translate.cpp"
              $new_c=$and40; //@line 2247 "translate.cpp"
              ; //@line 2248 "translate.cpp"
            }
  
            var $31=$upper_case; //@line 2250 "translate.cpp"
            var $tobool42=((($31))|0)!=0; //@line 2250 "translate.cpp"
            if ($tobool42) { __label__ = 25;; } else { __label__ = 26;; } //@line 2250 "translate.cpp"
            if (__label__ == 25) {
  
              var $32=$new_c; //@line 2251 "translate.cpp"
              var $call44=_towupper($32); //@line 2251 "translate.cpp"
              $new_c=$call44; //@line 2251 "translate.cpp"
              ; //@line 2251 "translate.cpp"
            }
  
            var $33=$new_c; //@line 2252 "translate.cpp"
            $retval=$33; //@line 2252 "translate.cpp"
            ; //@line 2252 "translate.cpp"
          }
        }
      }
    }
  
    var $34=$retval; //@line 2254 "translate.cpp"
    ;
    return $34; //@line 2254 "translate.cpp"
    return null;
  }
  

  function _init_MBR($voice_path) {
    var __stackBase__  = STACKTOP; STACKTOP += 48; _memset(__stackBase__, 0, 48);
    var __label__;
  
    var $retval;
    var $voice_path_addr;
    var $error;
    var $result;
    var $wavhdr=__stackBase__;
    $voice_path_addr=$voice_path;
    var $0=$voice_path_addr; //@line 484 "mbrowrap.cpp"
    var $call=__ZL12start_mbrolaPKc($0); //@line 484 "mbrowrap.cpp"
    $error=$call; //@line 484 "mbrowrap.cpp"
    var $1=$error; //@line 485 "mbrowrap.cpp"
    var $tobool=((($1))|0)!=0; //@line 485 "mbrowrap.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 485 "mbrowrap.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=-1; //@line 486 "mbrowrap.cpp"
        ; //@line 486 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        var $call1=__ZL14send_to_mbrolaPKc(((__str580)&4294967295)); //@line 488 "mbrowrap.cpp"
        $result=$call1; //@line 488 "mbrowrap.cpp"
        var $2=$result; //@line 489 "mbrowrap.cpp"
        var $cmp=((($2))|0)!=2; //@line 489 "mbrowrap.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 489 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          __ZL11stop_mbrolav(); //@line 490 "mbrowrap.cpp"
          $retval=-1; //@line 491 "mbrowrap.cpp"
          ; //@line 491 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          var $arraydecay=(($wavhdr)&4294967295); //@line 495 "mbrowrap.cpp"
          var $call4=__ZL19receive_from_mbrolaPvj($arraydecay, 45); //@line 495 "mbrowrap.cpp"
          $result=$call4; //@line 495 "mbrowrap.cpp"
          var $3=$result; //@line 496 "mbrowrap.cpp"
          var $cmp5=((($3))|0)!=44; //@line 496 "mbrowrap.cpp"
          if ($cmp5) { __label__ = 5;; } else { __label__ = 8;; } //@line 496 "mbrowrap.cpp"
          if (__label__ == 5) {
  
            var $4=$result; //@line 497 "mbrowrap.cpp"
            var $cmp7=((($4))|0) >= 0; //@line 497 "mbrowrap.cpp"
            if ($cmp7) { __label__ = 6;; } else { __label__ = 7;; } //@line 497 "mbrowrap.cpp"
            if (__label__ == 6) {
  
              __ZL3errPKcz(((__str1581)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 498 "mbrowrap.cpp"
              ; //@line 498 "mbrowrap.cpp"
            }
  
            __ZL11stop_mbrolav(); //@line 499 "mbrowrap.cpp"
            $retval=-1; //@line 500 "mbrowrap.cpp"
            ; //@line 500 "mbrowrap.cpp"
          }
          else if (__label__ == 8) {
  
            var $arraydecay11=(($wavhdr)&4294967295); //@line 504 "mbrowrap.cpp"
            var $call12=_memcmp($arraydecay11, ((__str2582)&4294967295), 4); //@line 504 "mbrowrap.cpp"
            var $cmp13=((($call12))|0)!=0; //@line 504 "mbrowrap.cpp"
            if ($cmp13) { __label__ = 10;; } else { __label__ = 9;; } //@line 504 "mbrowrap.cpp"
            $if_then17$$lor_lhs_false$14: do { 
              if (__label__ == 9) {
  
                var $arraydecay14=(($wavhdr)&4294967295); //@line 505 "mbrowrap.cpp"
                var $add_ptr=(($arraydecay14+8)&4294967295); //@line 505 "mbrowrap.cpp"
                var $call15=_memcmp($add_ptr, ((__str3583)&4294967295), 8); //@line 505 "mbrowrap.cpp"
                var $cmp16=((($call15))|0)!=0; //@line 505 "mbrowrap.cpp"
                if ($cmp16) { __label__ = 10;break $if_then17$$lor_lhs_false$14; } //@line 505 "mbrowrap.cpp"
  
                var $arrayidx=(($wavhdr+24)&4294967295); //@line 510 "mbrowrap.cpp"
                var $5=HEAPU8[($arrayidx)]; //@line 510 "mbrowrap.cpp"
                var $conv=((($5))&255); //@line 510 "mbrowrap.cpp"
                var $arrayidx19=(($wavhdr+25)&4294967295); //@line 510 "mbrowrap.cpp"
                var $6=HEAPU8[($arrayidx19)]; //@line 510 "mbrowrap.cpp"
                var $conv20=((($6))&255); //@line 510 "mbrowrap.cpp"
                var $shl=((($conv20)*256)&4294967295); //@line 510 "mbrowrap.cpp"
                var $arrayidx21=(($wavhdr+26)&4294967295); //@line 510 "mbrowrap.cpp"
                var $7=HEAPU8[($arrayidx21)]; //@line 510 "mbrowrap.cpp"
                var $conv22=((($7))&255); //@line 510 "mbrowrap.cpp"
                var $shl23=((($conv22)*65536)&4294967295); //@line 510 "mbrowrap.cpp"
                var $arrayidx25=(($wavhdr+27)&4294967295); //@line 510 "mbrowrap.cpp"
                var $8=HEAPU8[($arrayidx25)]; //@line 510 "mbrowrap.cpp"
                var $conv26=((($8))&255); //@line 510 "mbrowrap.cpp"
                var $shl27=((($conv26)*16777216)&4294967295); //@line 510 "mbrowrap.cpp"
                var $add=((($shl)+($conv))&4294967295); //@line 510 "mbrowrap.cpp"
                var $add24=((($add)+($shl23))&4294967295); //@line 510 "mbrowrap.cpp"
                var $add28=((($add24)+($shl27))&4294967295); //@line 510 "mbrowrap.cpp"
                HEAP32[((__ZL14mbr_samplerate)>>2)]=$add28; //@line 510 "mbrowrap.cpp"
                var $9=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 515 "mbrowrap.cpp"
                var $10=$voice_path_addr; //@line 515 "mbrowrap.cpp"
                var $cmp29=((($9))|0)!=((($10))|0); //@line 515 "mbrowrap.cpp"
                if ($cmp29) { __label__ = 12;; } else { __label__ = 13;; } //@line 515 "mbrowrap.cpp"
                if (__label__ == 12) {
  
                  var $11=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 516 "mbrowrap.cpp"
                  ; //@line 516 "mbrowrap.cpp"
                  var $12=$voice_path_addr; //@line 517 "mbrowrap.cpp"
                  var $call31=_strdup($12); //@line 517 "mbrowrap.cpp"
                  HEAP32[((__ZL14mbr_voice_path)>>2)]=$call31; //@line 517 "mbrowrap.cpp"
                  ; //@line 518 "mbrowrap.cpp"
                }
  
                $retval=0; //@line 520 "mbrowrap.cpp"
                __label__ = 14;break $if_then$$if_end$2; //@line 520 "mbrowrap.cpp"
              }
            } while(0);
  
            __ZL3errPKcz(((__str4584)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 506 "mbrowrap.cpp"
            __ZL11stop_mbrolav(); //@line 507 "mbrowrap.cpp"
            $retval=-1; //@line 508 "mbrowrap.cpp"
            ; //@line 508 "mbrowrap.cpp"
          }
        }
      }
    } while(0);
  
    var $13=$retval; //@line 521 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $13; //@line 521 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL12start_mbrolaPKc($voice_path) {
    var __stackBase__  = STACKTOP; STACKTOP += 44; _memset(__stackBase__, 0, 44);
    var __label__;
  
    var $retval;
    var $voice_path_addr;
    var $error;
    var $p_stdin=__stackBase__;
    var $p_stdout=__stackBase__+8;
    var $p_stderr=__stackBase__+16;
    var $charbuf=__stackBase__+24;
    var $i;
    $voice_path_addr=$voice_path;
    var $0=HEAP32[((__ZL9mbr_state)>>2)]; //@line 128 "mbrowrap.cpp"
    var $cmp=((($0))|0)!=0; //@line 128 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 128 "mbrowrap.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        __ZL3errPKcz(((__str22602)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 129 "mbrowrap.cpp"
        $retval=-1; //@line 130 "mbrowrap.cpp"
        ; //@line 130 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        var $arraydecay=(($p_stdin)&4294967295); //@line 133 "mbrowrap.cpp"
        var $arraydecay1=(($p_stdout)&4294967295); //@line 133 "mbrowrap.cpp"
        var $arraydecay2=(($p_stderr)&4294967295); //@line 133 "mbrowrap.cpp"
        var $call=__ZL12create_pipesPiS_S_($arraydecay, $arraydecay1, $arraydecay2); //@line 133 "mbrowrap.cpp"
        $error=$call; //@line 133 "mbrowrap.cpp"
        var $1=$error; //@line 134 "mbrowrap.cpp"
        var $tobool=((($1))|0)!=0; //@line 134 "mbrowrap.cpp"
        if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 134 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          $retval=-1; //@line 135 "mbrowrap.cpp"
          ; //@line 135 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          var $call5=_fork(); //@line 137 "mbrowrap.cpp"
          HEAP32[((__ZL7mbr_pid)>>2)]=$call5; //@line 137 "mbrowrap.cpp"
          var $2=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 139 "mbrowrap.cpp"
          var $cmp6=((($2))|0)==-1; //@line 139 "mbrowrap.cpp"
          if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 139 "mbrowrap.cpp"
          if (__label__ == 5) {
  
            var $call8=___errno(); //@line 140 "mbrowrap.cpp"
            var $3=HEAP32[(($call8)>>2)]; //@line 140 "mbrowrap.cpp"
            $error=$3; //@line 140 "mbrowrap.cpp"
            var $arraydecay9=(($p_stdin)&4294967295); //@line 141 "mbrowrap.cpp"
            var $arraydecay10=(($p_stdout)&4294967295); //@line 141 "mbrowrap.cpp"
            var $arraydecay11=(($p_stderr)&4294967295); //@line 141 "mbrowrap.cpp"
            __ZL11close_pipesPiS_S_($arraydecay9, $arraydecay10, $arraydecay11); //@line 141 "mbrowrap.cpp"
            var $4=$error; //@line 142 "mbrowrap.cpp"
            var $call12=_strerror($4); //@line 142 "mbrowrap.cpp"
            __ZL3errPKcz(((__str23603)&4294967295), allocate([$call12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 142 "mbrowrap.cpp"
            $retval=-1; //@line 143 "mbrowrap.cpp"
            ; //@line 143 "mbrowrap.cpp"
          }
          else if (__label__ == 6) {
  
            var $5=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 146 "mbrowrap.cpp"
            var $cmp14=((($5))|0)==0; //@line 146 "mbrowrap.cpp"
            if ($cmp14) { __label__ = 7;; } else { __label__ = 14;; } //@line 146 "mbrowrap.cpp"
            if (__label__ == 7) {
  
              var $arrayidx=(($p_stdin)&4294967295); //@line 149 "mbrowrap.cpp"
              var $6=HEAP32[(($arrayidx)>>2)]; //@line 149 "mbrowrap.cpp"
              var $call16=_dup2($6, 0); //@line 149 "mbrowrap.cpp"
              var $cmp17=((($call16))|0)==-1; //@line 149 "mbrowrap.cpp"
              if ($cmp17) { __label__ = 10;; } else { __label__ = 8;; } //@line 149 "mbrowrap.cpp"
              $if_then25$$lor_lhs_false$13: do { 
                if (__label__ == 8) {
  
                  var $arrayidx18=(($p_stdout+4)&4294967295); //@line 150 "mbrowrap.cpp"
                  var $7=HEAP32[(($arrayidx18)>>2)]; //@line 150 "mbrowrap.cpp"
                  var $call19=_dup2($7, 1); //@line 150 "mbrowrap.cpp"
                  var $cmp20=((($call19))|0)==-1; //@line 150 "mbrowrap.cpp"
                  if ($cmp20) { __label__ = 10;break $if_then25$$lor_lhs_false$13; } //@line 150 "mbrowrap.cpp"
  
                  var $arrayidx22=(($p_stderr+4)&4294967295); //@line 151 "mbrowrap.cpp"
                  var $8=HEAP32[(($arrayidx22)>>2)]; //@line 151 "mbrowrap.cpp"
                  var $call23=_dup2($8, 2); //@line 151 "mbrowrap.cpp"
                  var $cmp24=((($call23))|0)==-1; //@line 151 "mbrowrap.cpp"
                  if ($cmp24) { __label__ = 10;break $if_then25$$lor_lhs_false$13; } else { __label__ = 11;break $if_then25$$lor_lhs_false$13; } //@line 151 "mbrowrap.cpp"
                }
              } while(0);
              if (__label__ == 10) {
  
                var $call26=___errno(); //@line 153 "mbrowrap.cpp"
                var $9=HEAP32[(($call26)>>2)]; //@line 153 "mbrowrap.cpp"
                var $call27=_strerror($9); //@line 153 "mbrowrap.cpp"
                var $call28=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str24604)&4294967295), allocate([$call27,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 153 "mbrowrap.cpp"
                var $arrayidx29=(($p_stderr+4)&4294967295); //@line 154 "mbrowrap.cpp"
                var $10=HEAP32[(($arrayidx29)>>2)]; //@line 154 "mbrowrap.cpp"
                var $call30=_strlen(((__ZL12mbr_errorbuf)&4294967295)); //@line 154 "mbrowrap.cpp"
                var $call31=_write($10, ((__ZL12mbr_errorbuf)&4294967295), $call30); //@line 154 "mbrowrap.cpp"
                __exit(1); //@line 155 "mbrowrap.cpp"
                ; //@line 156 "mbrowrap.cpp"
              }
  
              var $arrayidx33=(($p_stderr+4)&4294967295); //@line 158 "mbrowrap.cpp"
              var $11=HEAP32[(($arrayidx33)>>2)]; //@line 158 "mbrowrap.cpp"
              $i=$11; //@line 158 "mbrowrap.cpp"
              var $cmp341=((($11))|0) > 2; //@line 158 "mbrowrap.cpp"
              if ($cmp341) { __label__ = 12;; } else { __label__ = 13;; } //@line 158 "mbrowrap.cpp"
              $for_body$$for_end$19: do { 
                if (__label__ == 12) {
                  while(1) { 
  
                    var $12=$i; //@line 159 "mbrowrap.cpp"
                    var $call35=_close($12); //@line 159 "mbrowrap.cpp"
                    var $13=$i; //@line 158 "mbrowrap.cpp"
                    var $dec=((($13)-1)&4294967295); //@line 158 "mbrowrap.cpp"
                    $i=$dec; //@line 158 "mbrowrap.cpp"
                    var $cmp34=((($dec))|0) > 2; //@line 158 "mbrowrap.cpp"
                    if ($cmp34) { __label__ = 12;continue ; } else { __label__ = 13;break $for_body$$for_end$19; } //@line 158 "mbrowrap.cpp"
                  }
                }
              } while(0);
  
              var $call36=_signal(1, 1); //@line 160 "mbrowrap.cpp"
              var $call37=_signal(2, 1); //@line 161 "mbrowrap.cpp"
              var $call38=_signal(3, 1); //@line 162 "mbrowrap.cpp"
              var $call39=_signal(15, 1); //@line 163 "mbrowrap.cpp"
              var $arraydecay40=(($charbuf)&4294967295); //@line 165 "mbrowrap.cpp"
              var $14=HEAPF32[((__ZL10mbr_volume)>>2)]; //@line 165 "mbrowrap.cpp"
              var $conv=($14); //@line 165 "mbrowrap.cpp"
              var $call41=_snprintf($arraydecay40, 20, ((__str25605)&4294967295), allocate([$conv,0,0,0,0,0,0,0], ["double",0,0,0,0,0,0,0], ALLOC_STACK)); //@line 165 "mbrowrap.cpp"
              var $arraydecay42=(($charbuf)&4294967295); //@line 166 "mbrowrap.cpp"
              var $15=$voice_path_addr; //@line 166 "mbrowrap.cpp"
              var $call43=_execlp(((__str33683)&4294967295), ((__str33683)&4294967295), allocate([((__str27607)&4294967295),0,0,0,((__str28608)&4294967295),0,0,0,$arraydecay42,0,0,0,$15,0,0,0,((__str56708)&4294967295),0,0,0,((__str30610)&4294967295),0,0,0,0,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 166 "mbrowrap.cpp"
              var $call44=___errno(); //@line 170 "mbrowrap.cpp"
              var $16=HEAP32[(($call44)>>2)]; //@line 170 "mbrowrap.cpp"
              var $call45=_strerror($16); //@line 170 "mbrowrap.cpp"
              var $call46=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str31611)&4294967295), allocate([$call45,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 170 "mbrowrap.cpp"
              var $call47=_strlen(((__ZL12mbr_errorbuf)&4294967295)); //@line 171 "mbrowrap.cpp"
              var $call48=_write(2, ((__ZL12mbr_errorbuf)&4294967295), $call47); //@line 171 "mbrowrap.cpp"
              __exit(1); //@line 172 "mbrowrap.cpp"
              ; //@line 173 "mbrowrap.cpp"
            }
  
            var $arraydecay50=(($charbuf)&4294967295); //@line 175 "mbrowrap.cpp"
            var $17=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 175 "mbrowrap.cpp"
            var $call51=_snprintf($arraydecay50, 20, ((__str32612)&4294967295), allocate([$17,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 175 "mbrowrap.cpp"
            var $arraydecay52=(($charbuf)&4294967295); //@line 176 "mbrowrap.cpp"
            var $call53=_open($arraydecay52, 0, allocate(1, "i32", ALLOC_STACK)); //@line 176 "mbrowrap.cpp"
            HEAP32[((__ZL13mbr_proc_stat)>>2)]=$call53; //@line 176 "mbrowrap.cpp"
            var $cmp54=((($call53))|0)==-1; //@line 177 "mbrowrap.cpp"
            if ($cmp54) { __label__ = 15;; } else { __label__ = 16;; } //@line 177 "mbrowrap.cpp"
            if (__label__ == 15) {
  
              var $call56=___errno(); //@line 178 "mbrowrap.cpp"
              var $18=HEAP32[(($call56)>>2)]; //@line 178 "mbrowrap.cpp"
              $error=$18; //@line 178 "mbrowrap.cpp"
              var $arraydecay57=(($p_stdin)&4294967295); //@line 179 "mbrowrap.cpp"
              var $arraydecay58=(($p_stdout)&4294967295); //@line 179 "mbrowrap.cpp"
              var $arraydecay59=(($p_stderr)&4294967295); //@line 179 "mbrowrap.cpp"
              __ZL11close_pipesPiS_S_($arraydecay57, $arraydecay58, $arraydecay59); //@line 179 "mbrowrap.cpp"
              var $19=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 180 "mbrowrap.cpp"
              var $call60=_waitpid($19, 0, 0); //@line 180 "mbrowrap.cpp"
              HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 181 "mbrowrap.cpp"
              var $20=$error; //@line 182 "mbrowrap.cpp"
              var $call61=_strerror($20); //@line 182 "mbrowrap.cpp"
              __ZL3errPKcz(((__str33613)&4294967295), allocate([$call61,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 182 "mbrowrap.cpp"
              $retval=-1; //@line 183 "mbrowrap.cpp"
              ; //@line 183 "mbrowrap.cpp"
            }
            else if (__label__ == 16) {
  
              var $call63=_signal(13, 1); //@line 186 "mbrowrap.cpp"
              var $arrayidx64=(($p_stdin+4)&4294967295); //@line 188 "mbrowrap.cpp"
              var $21=HEAP32[(($arrayidx64)>>2)]; //@line 188 "mbrowrap.cpp"
              var $call65=_fcntl($21, 4, allocate([16384,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 188 "mbrowrap.cpp"
              var $cmp66=((($call65))|0)==-1; //@line 188 "mbrowrap.cpp"
              if ($cmp66) { __label__ = 19;; } else { __label__ = 17;; } //@line 188 "mbrowrap.cpp"
              $if_then75$$lor_lhs_false67$27: do { 
                if (__label__ == 17) {
  
                  var $arrayidx68=(($p_stdout)&4294967295); //@line 189 "mbrowrap.cpp"
                  var $22=HEAP32[(($arrayidx68)>>2)]; //@line 189 "mbrowrap.cpp"
                  var $call69=_fcntl($22, 4, allocate([16384,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 189 "mbrowrap.cpp"
                  var $cmp70=((($call69))|0)==-1; //@line 189 "mbrowrap.cpp"
                  if ($cmp70) { __label__ = 19;break $if_then75$$lor_lhs_false67$27; } //@line 189 "mbrowrap.cpp"
  
                  var $arrayidx72=(($p_stderr)&4294967295); //@line 190 "mbrowrap.cpp"
                  var $23=HEAP32[(($arrayidx72)>>2)]; //@line 190 "mbrowrap.cpp"
                  var $call73=_fcntl($23, 4, allocate([16384,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 190 "mbrowrap.cpp"
                  var $cmp74=((($call73))|0)==-1; //@line 190 "mbrowrap.cpp"
                  if ($cmp74) { __label__ = 19;break $if_then75$$lor_lhs_false67$27; } //@line 190 "mbrowrap.cpp"
  
                  var $arrayidx83=(($p_stdin+4)&4294967295); //@line 199 "mbrowrap.cpp"
                  var $27=HEAP32[(($arrayidx83)>>2)]; //@line 199 "mbrowrap.cpp"
                  HEAP32[((__ZL10mbr_cmd_fd)>>2)]=$27; //@line 199 "mbrowrap.cpp"
                  var $arrayidx84=(($p_stdout)&4294967295); //@line 200 "mbrowrap.cpp"
                  var $28=HEAP32[(($arrayidx84)>>2)]; //@line 200 "mbrowrap.cpp"
                  HEAP32[((__ZL12mbr_audio_fd)>>2)]=$28; //@line 200 "mbrowrap.cpp"
                  var $arrayidx85=(($p_stderr)&4294967295); //@line 201 "mbrowrap.cpp"
                  var $29=HEAP32[(($arrayidx85)>>2)]; //@line 201 "mbrowrap.cpp"
                  HEAP32[((__ZL12mbr_error_fd)>>2)]=$29; //@line 201 "mbrowrap.cpp"
                  var $arrayidx86=(($p_stdin)&4294967295); //@line 202 "mbrowrap.cpp"
                  var $30=HEAP32[(($arrayidx86)>>2)]; //@line 202 "mbrowrap.cpp"
                  var $call87=_close($30); //@line 202 "mbrowrap.cpp"
                  var $arrayidx88=(($p_stdout+4)&4294967295); //@line 203 "mbrowrap.cpp"
                  var $31=HEAP32[(($arrayidx88)>>2)]; //@line 203 "mbrowrap.cpp"
                  var $call89=_close($31); //@line 203 "mbrowrap.cpp"
                  var $arrayidx90=(($p_stderr+4)&4294967295); //@line 204 "mbrowrap.cpp"
                  var $32=HEAP32[(($arrayidx90)>>2)]; //@line 204 "mbrowrap.cpp"
                  var $call91=_close($32); //@line 204 "mbrowrap.cpp"
                  HEAP32[((__ZL9mbr_state)>>2)]=1; //@line 206 "mbrowrap.cpp"
                  $retval=0; //@line 207 "mbrowrap.cpp"
                  __label__ = 21;break $if_then$$if_end$2; //@line 207 "mbrowrap.cpp"
                }
              } while(0);
  
              var $call76=___errno(); //@line 191 "mbrowrap.cpp"
              var $24=HEAP32[(($call76)>>2)]; //@line 191 "mbrowrap.cpp"
              $error=$24; //@line 191 "mbrowrap.cpp"
              var $arraydecay77=(($p_stdin)&4294967295); //@line 192 "mbrowrap.cpp"
              var $arraydecay78=(($p_stdout)&4294967295); //@line 192 "mbrowrap.cpp"
              var $arraydecay79=(($p_stderr)&4294967295); //@line 192 "mbrowrap.cpp"
              __ZL11close_pipesPiS_S_($arraydecay77, $arraydecay78, $arraydecay79); //@line 192 "mbrowrap.cpp"
              var $25=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 193 "mbrowrap.cpp"
              var $call80=_waitpid($25, 0, 0); //@line 193 "mbrowrap.cpp"
              HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 194 "mbrowrap.cpp"
              var $26=$error; //@line 195 "mbrowrap.cpp"
              var $call81=_strerror($26); //@line 195 "mbrowrap.cpp"
              __ZL3errPKcz(((__str34614)&4294967295), allocate([$call81,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 195 "mbrowrap.cpp"
              $retval=-1; //@line 196 "mbrowrap.cpp"
              ; //@line 196 "mbrowrap.cpp"
            }
          }
        }
      }
    } while(0);
  
    var $33=$retval; //@line 208 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $33; //@line 208 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL14send_to_mbrolaPKc($cmd) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $cmd_addr;
    var $result;
    var $len;
    var $error;
    var $data;
    $cmd_addr=$cmd;
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 328 "mbrowrap.cpp"
    var $tobool=((($0))|0)!=0; //@line 328 "mbrowrap.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 328 "mbrowrap.cpp"
    $if_end$$if_then$2: do { 
      if (__label__ == 2) {
  
        var $1=$cmd_addr; //@line 331 "mbrowrap.cpp"
        var $call=_strlen($1); //@line 331 "mbrowrap.cpp"
        $len=$call; //@line 331 "mbrowrap.cpp"
        var $2=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 332 "mbrowrap.cpp"
        var $3=$cmd_addr; //@line 332 "mbrowrap.cpp"
        var $4=$len; //@line 332 "mbrowrap.cpp"
        var $call1=_write($2, $3, $4); //@line 332 "mbrowrap.cpp"
        $result=$call1; //@line 332 "mbrowrap.cpp"
        var $5=$result; //@line 334 "mbrowrap.cpp"
        var $cmp=((($5))|0)==-1; //@line 334 "mbrowrap.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 10;; } //@line 334 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          var $call3=___errno(); //@line 335 "mbrowrap.cpp"
          var $6=HEAP32[(($call3)>>2)]; //@line 335 "mbrowrap.cpp"
          $error=$6; //@line 335 "mbrowrap.cpp"
          var $7=$error; //@line 336 "mbrowrap.cpp"
          var $cmp4=((($7))|0)==32; //@line 336 "mbrowrap.cpp"
          if ($cmp4) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 7;; } //@line 336 "mbrowrap.cpp"
          if (__label__ == 4) {
  
            var $call5=__ZL17mbrola_has_errorsv(); //@line 336 "mbrowrap.cpp"
            var $tobool6=((($call5))|0)!=0; //@line 336 "mbrowrap.cpp"
            if ($tobool6) { __label__ = 5;; } else { __label__ = 6;; } //@line 336 "mbrowrap.cpp"
            if (__label__ == 5) {
  
              $retval=-1; //@line 337 "mbrowrap.cpp"
              __label__ = 17;break $if_end$$if_then$2; //@line 337 "mbrowrap.cpp"
            }
            else if (__label__ == 6) {
  
              var $_pr=$error; //@line 338 "mbrowrap.cpp"
              __lastLabel__ = 6; ;
            }
          }
  
          var $8=__lastLabel__ == 6 ? $_pr : ($7); //@line 338 "mbrowrap.cpp"
          var $cmp8=((($8))|0)==11; //@line 338 "mbrowrap.cpp"
          if ($cmp8) { __label__ = 8;; } else { __label__ = 9;; } //@line 338 "mbrowrap.cpp"
          if (__label__ == 8) {
  
            $result=0; //@line 339 "mbrowrap.cpp"
            ; //@line 344 "mbrowrap.cpp"
          }
          else if (__label__ == 9) {
  
            var $9=$error; //@line 341 "mbrowrap.cpp"
            var $call11=_strerror($9); //@line 341 "mbrowrap.cpp"
            __ZL3errPKcz(((__str20600)&4294967295), allocate([$call11,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 341 "mbrowrap.cpp"
            $retval=-1; //@line 342 "mbrowrap.cpp"
            __label__ = 17;break $if_end$$if_then$2; //@line 342 "mbrowrap.cpp"
          }
        }
  
        var $10=$result; //@line 346 "mbrowrap.cpp"
        var $11=$len; //@line 346 "mbrowrap.cpp"
        var $cmp15=((($10))|0)!=((($11))|0); //@line 346 "mbrowrap.cpp"
        if ($cmp15) { __label__ = 11;; } else { __label__ = 16;; } //@line 346 "mbrowrap.cpp"
        $if_then16$$if_end28$16: do { 
          if (__label__ == 11) {
  
            var $12=$len; //@line 348 "mbrowrap.cpp"
            var $13=$result; //@line 348 "mbrowrap.cpp"
            var $_neg=(((-($13)))&4294967295);
            var $add=((($12)+16)&4294967295); //@line 348 "mbrowrap.cpp"
            var $sub=((($add)+($_neg))&4294967295); //@line 348 "mbrowrap.cpp"
            var $call17=_malloc($sub); //@line 348 "mbrowrap.cpp"
            var $14=$call17; //@line 348 "mbrowrap.cpp"
            $data=$14; //@line 348 "mbrowrap.cpp"
            var $15=$data; //@line 349 "mbrowrap.cpp"
            var $tobool18=((($15))|0)!=0; //@line 349 "mbrowrap.cpp"
            if (!($tobool18)) { __label__ = 16;break $if_then16$$if_end28$16; } //@line 349 "mbrowrap.cpp"
  
            var $16=$data; //@line 350 "mbrowrap.cpp"
            var $next=(($16)&4294967295); //@line 350 "mbrowrap.cpp"
            HEAP32[(($next)>>2)]=0; //@line 350 "mbrowrap.cpp"
            var $17=$data; //@line 351 "mbrowrap.cpp"
            var $done=(($17+4)&4294967295); //@line 351 "mbrowrap.cpp"
            HEAP32[(($done)>>2)]=0; //@line 351 "mbrowrap.cpp"
            var $18=$len; //@line 352 "mbrowrap.cpp"
            var $19=$result; //@line 352 "mbrowrap.cpp"
            var $sub20=((($18)-($19))&4294967295); //@line 352 "mbrowrap.cpp"
            var $20=$data; //@line 352 "mbrowrap.cpp"
            var $size=(($20+8)&4294967295); //@line 352 "mbrowrap.cpp"
            HEAP32[(($size)>>2)]=$sub20; //@line 352 "mbrowrap.cpp"
            var $21=$data; //@line 353 "mbrowrap.cpp"
            var $buffer=(($21+12)&4294967295); //@line 353 "mbrowrap.cpp"
            var $arraydecay=(($buffer)&4294967295); //@line 353 "mbrowrap.cpp"
            var $22=$cmd_addr; //@line 353 "mbrowrap.cpp"
            var $23=$result; //@line 353 "mbrowrap.cpp"
            var $add_ptr=(($22+$23)&4294967295); //@line 353 "mbrowrap.cpp"
            var $24=$len; //@line 353 "mbrowrap.cpp"
            var $25=$result; //@line 353 "mbrowrap.cpp"
            var $sub21=((($24)-($25))&4294967295); //@line 353 "mbrowrap.cpp"
            var $src$, $dest$, $stop$, $stop4$, $fast$;
            $src$ = $add_ptr;
            $dest$ = $arraydecay;
            $stop$ = $src$ + $sub21;
            if (($dest$%4) == ($src$%4) && $sub21 > 8) {
              while ($src$%4 !== 0 && $src$ < $stop$) {
                ; HEAP8[$dest$++] = HEAP8[$src$++];
              }
              $src$ >>= 2;
              $dest$ >>= 2;
              $stop4$ = $stop$ >> 2;
              while ($src$ < $stop4$) {
            ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
              }
              $src$ <<= 2;
              $dest$ <<= 2;
            }while ($src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }; //@line 353 "mbrowrap.cpp"
            var $26=$len; //@line 354 "mbrowrap.cpp"
            $result=$26; //@line 354 "mbrowrap.cpp"
            var $27=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 355 "mbrowrap.cpp"
            var $tobool22=((($27))|0)!=0; //@line 355 "mbrowrap.cpp"
            var $28=$data; //@line 358 "mbrowrap.cpp"
            if ($tobool22) { __label__ = 14;; } else { __label__ = 13;; } //@line 355 "mbrowrap.cpp"
            if (__label__ == 14) {
  
              var $29=HEAP32[((__ZL21mbr_pending_data_tail)>>2)]; //@line 358 "mbrowrap.cpp"
              var $next25=(($29)&4294967295); //@line 358 "mbrowrap.cpp"
              HEAP32[(($next25)>>2)]=$28; //@line 358 "mbrowrap.cpp"
              ;
            }
            else if (__label__ == 13) {
  
              HEAP32[((__ZL21mbr_pending_data_head)>>2)]=$28; //@line 356 "mbrowrap.cpp"
              ; //@line 356 "mbrowrap.cpp"
            }
  
            var $30=$data; //@line 359 "mbrowrap.cpp"
            HEAP32[((__ZL21mbr_pending_data_tail)>>2)]=$30; //@line 359 "mbrowrap.cpp"
            ; //@line 360 "mbrowrap.cpp"
          }
        } while(0);
  
        var $31=$result; //@line 363 "mbrowrap.cpp"
        $retval=$31; //@line 363 "mbrowrap.cpp"
        ; //@line 363 "mbrowrap.cpp"
      }
      else if (__label__ == 1) {
  
        $retval=-1; //@line 329 "mbrowrap.cpp"
        ; //@line 329 "mbrowrap.cpp"
      }
    } while(0);
  
    var $32=$retval; //@line 364 "mbrowrap.cpp"
    ;
    return $32; //@line 364 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL11stop_mbrolav() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL9mbr_state)>>2)]; //@line 212 "mbrowrap.cpp"
    var $cmp=((($0))|0)==0; //@line 212 "mbrowrap.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 1;; } //@line 212 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL13mbr_proc_stat)>>2)]; //@line 214 "mbrowrap.cpp"
      var $call=_close($1); //@line 214 "mbrowrap.cpp"
      var $2=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 215 "mbrowrap.cpp"
      var $call1=_close($2); //@line 215 "mbrowrap.cpp"
      var $3=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 216 "mbrowrap.cpp"
      var $call2=_close($3); //@line 216 "mbrowrap.cpp"
      var $4=HEAP32[((__ZL12mbr_error_fd)>>2)]; //@line 217 "mbrowrap.cpp"
      var $call3=_close($4); //@line 217 "mbrowrap.cpp"
      var $5=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 218 "mbrowrap.cpp"
      var $tobool=((($5))|0)!=0; //@line 218 "mbrowrap.cpp"
      if ($tobool) { __label__ = 2;; } else { __label__ = 3;; } //@line 218 "mbrowrap.cpp"
      if (__label__ == 2) {
  
        var $6=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 219 "mbrowrap.cpp"
        var $call5=_kill($6, 15); //@line 219 "mbrowrap.cpp"
        var $7=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 220 "mbrowrap.cpp"
        var $call6=_waitpid($7, 0, 0); //@line 220 "mbrowrap.cpp"
        HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 221 "mbrowrap.cpp"
        ; //@line 222 "mbrowrap.cpp"
      }
  
      HEAP32[((__ZL9mbr_state)>>2)]=0; //@line 223 "mbrowrap.cpp"
      ; //@line 224 "mbrowrap.cpp"
    }
  
    ;
    return; //@line 224 "mbrowrap.cpp"
    return;
  }
  

  function __ZL19receive_from_mbrolaPvj($buffer, $bufsize) {
    var __stackBase__  = STACKTOP; STACKTOP += 24; _memset(__stackBase__, 0, 24);
    var __label__;
  
    var $retval;
    var $buffer_addr;
    var $bufsize_addr;
    var $result;
    var $wait;
    var $cursize;
    var $pollfd=__stackBase__;
    var $nfds;
    var $idle;
    var $head;
    var $data;
    var $left;
    var $error;
    var $curpos;
    var $space;
    var $obtained;
    $buffer_addr=$buffer;
    $bufsize_addr=$bufsize;
    $wait=1; //@line 384 "mbrowrap.cpp"
    $cursize=0; //@line 385 "mbrowrap.cpp"
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 387 "mbrowrap.cpp"
    var $tobool=((($0))|0)!=0; //@line 387 "mbrowrap.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 387 "mbrowrap.cpp"
    $do_body_preheader$$if_then$2: do { 
      if (__label__ == 1) {
  
        var $arrayidx=(($pollfd)&4294967295); //@line 395 "mbrowrap.cpp"
        var $fd=(($arrayidx)&4294967295); //@line 395 "mbrowrap.cpp"
        var $arrayidx1=(($pollfd)&4294967295); //@line 396 "mbrowrap.cpp"
        var $events=(($arrayidx1+4)&4294967295); //@line 396 "mbrowrap.cpp"
        var $arrayidx2=(($pollfd+8)&4294967295); //@line 399 "mbrowrap.cpp"
        var $fd3=(($arrayidx2)&4294967295); //@line 399 "mbrowrap.cpp"
        var $arrayidx4=(($pollfd+8)&4294967295); //@line 400 "mbrowrap.cpp"
        var $events5=(($arrayidx4+4)&4294967295); //@line 400 "mbrowrap.cpp"
        var $arrayidx9=(($pollfd+16)&4294967295); //@line 404 "mbrowrap.cpp"
        var $fd10=(($arrayidx9)&4294967295); //@line 404 "mbrowrap.cpp"
        var $arrayidx11=(($pollfd+16)&4294967295); //@line 405 "mbrowrap.cpp"
        var $events12=(($arrayidx11+4)&4294967295); //@line 405 "mbrowrap.cpp"
        var $arraydecay=(($pollfd)&4294967295); //@line 410 "mbrowrap.cpp"
        var $arrayidx29=(($pollfd+8)&4294967295); //@line 432 "mbrowrap.cpp"
        var $revents=(($arrayidx29+6)&4294967295); //@line 432 "mbrowrap.cpp"
        var $arrayidx37=(($pollfd+16)&4294967295); //@line 435 "mbrowrap.cpp"
        var $revents38=(($arrayidx37+6)&4294967295); //@line 435 "mbrowrap.cpp"
        var $arrayidx66=(($pollfd)&4294967295); //@line 459 "mbrowrap.cpp"
        var $revents67=(($arrayidx66+6)&4294967295); //@line 459 "mbrowrap.cpp"
        ; //@line 391 "mbrowrap.cpp"
        $do_body$4: while(1) { 
  
          $nfds=0; //@line 392 "mbrowrap.cpp"
          var $1=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 395 "mbrowrap.cpp"
          HEAP32[(($fd)>>2)]=$1; //@line 395 "mbrowrap.cpp"
          HEAP16[(($events)>>1)]=1; //@line 396 "mbrowrap.cpp"
          var $2=$nfds; //@line 397 "mbrowrap.cpp"
          var $inc=((($2)+1)&4294967295); //@line 397 "mbrowrap.cpp"
          $nfds=$inc; //@line 397 "mbrowrap.cpp"
          var $3=HEAP32[((__ZL12mbr_error_fd)>>2)]; //@line 399 "mbrowrap.cpp"
          HEAP32[(($fd3)>>2)]=$3; //@line 399 "mbrowrap.cpp"
          HEAP16[(($events5)>>1)]=1; //@line 400 "mbrowrap.cpp"
          var $4=$nfds; //@line 401 "mbrowrap.cpp"
          var $inc6=((($4)+1)&4294967295); //@line 401 "mbrowrap.cpp"
          $nfds=$inc6; //@line 401 "mbrowrap.cpp"
          var $5=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 403 "mbrowrap.cpp"
          var $tobool7=((($5))|0)!=0; //@line 403 "mbrowrap.cpp"
          if ($tobool7) { __label__ = 4;; } else { __label__ = 5;; } //@line 403 "mbrowrap.cpp"
          if (__label__ == 4) {
  
            var $6=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 404 "mbrowrap.cpp"
            HEAP32[(($fd10)>>2)]=$6; //@line 404 "mbrowrap.cpp"
            HEAP16[(($events12)>>1)]=2; //@line 405 "mbrowrap.cpp"
            var $7=$nfds; //@line 406 "mbrowrap.cpp"
            var $inc13=((($7)+1)&4294967295); //@line 406 "mbrowrap.cpp"
            $nfds=$inc13; //@line 406 "mbrowrap.cpp"
            ; //@line 407 "mbrowrap.cpp"
          }
  
          var $call=__ZL14mbrola_is_idlev(); //@line 409 "mbrowrap.cpp"
          $idle=$call; //@line 409 "mbrowrap.cpp"
          var $8=$nfds; //@line 410 "mbrowrap.cpp"
          var $9=$idle; //@line 410 "mbrowrap.cpp"
          var $tobool15=((($9))|0)!=0; //@line 410 "mbrowrap.cpp"
          var $10=$wait; //@line 410 "mbrowrap.cpp"
          var $cond=($tobool15) ? 0 : ($10); //@line 410 "mbrowrap.cpp"
          var $call16=_poll($arraydecay, $8, $cond); //@line 410 "mbrowrap.cpp"
          $result=$call16; //@line 410 "mbrowrap.cpp"
          var $cmp=((($call16))|0)==-1; //@line 411 "mbrowrap.cpp"
          if ($cmp) { __label__ = 6;break $do_body$4; } //@line 411 "mbrowrap.cpp"
  
          var $12=$result; //@line 415 "mbrowrap.cpp"
          var $cmp21=((($12))|0)==0; //@line 415 "mbrowrap.cpp"
          if ($cmp21) { __label__ = 8;; } else { __label__ = 13;; } //@line 415 "mbrowrap.cpp"
          $if_then22$$if_end28$10: do { 
            if (__label__ == 8) {
  
              var $13=$idle; //@line 416 "mbrowrap.cpp"
              var $tobool23=((($13))|0)!=0; //@line 416 "mbrowrap.cpp"
              if ($tobool23) { __label__ = 9;break $do_body$4; } //@line 416 "mbrowrap.cpp"
  
              var $14=$wait; //@line 420 "mbrowrap.cpp"
              var $cmp25=((($14))|0) >= 3750; //@line 420 "mbrowrap.cpp"
              if ($cmp25) { __label__ = 11;break $do_body$4; } //@line 420 "mbrowrap.cpp"
  
              var $15=$wait; //@line 425 "mbrowrap.cpp"
              var $mul=((($15)*4)&4294967295); //@line 425 "mbrowrap.cpp"
              $wait=$mul; //@line 425 "mbrowrap.cpp"
              ; //@line 426 "mbrowrap.cpp"
            }
            else if (__label__ == 13) {
  
              $wait=1; //@line 430 "mbrowrap.cpp"
              var $16=HEAP16[(($revents)>>1)]; //@line 432 "mbrowrap.cpp"
              var $tobool30=(tempInt=(($16)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 432 "mbrowrap.cpp"
              if ($tobool30) { __label__ = 14;; } else { __label__ = 16;; } //@line 432 "mbrowrap.cpp"
              if (__label__ == 14) {
  
                var $call31=__ZL17mbrola_has_errorsv(); //@line 432 "mbrowrap.cpp"
                var $tobool32=((($call31))|0)!=0; //@line 432 "mbrowrap.cpp"
                if ($tobool32) { __label__ = 15;break $do_body$4; } //@line 432 "mbrowrap.cpp"
              }
  
              var $17=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 435 "mbrowrap.cpp"
              var $tobool35=((($17))|0)!=0; //@line 435 "mbrowrap.cpp"
              if ($tobool35) { __label__ = 17;; } else { __label__ = 27;; } //@line 435 "mbrowrap.cpp"
              $land_lhs_true36$$if_end65$18: do { 
                if (__label__ == 17) {
  
                  var $18=HEAP16[(($revents38)>>1)]; //@line 435 "mbrowrap.cpp"
                  var $tobool39=(tempInt=(($18)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 435 "mbrowrap.cpp"
                  if (!($tobool39)) { __label__ = 27;break $land_lhs_true36$$if_end65$18; } //@line 435 "mbrowrap.cpp"
  
                  var $19=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 436 "mbrowrap.cpp"
                  $head=$19; //@line 436 "mbrowrap.cpp"
                  var $20=$head; //@line 437 "mbrowrap.cpp"
                  var $buffer41=(($20+12)&4294967295); //@line 437 "mbrowrap.cpp"
                  var $arraydecay42=(($buffer41)&4294967295); //@line 437 "mbrowrap.cpp"
                  var $21=$head; //@line 437 "mbrowrap.cpp"
                  var $done=(($21+4)&4294967295); //@line 437 "mbrowrap.cpp"
                  var $22=HEAP32[(($done)>>2)]; //@line 437 "mbrowrap.cpp"
                  var $add_ptr=(($arraydecay42+$22)&4294967295); //@line 437 "mbrowrap.cpp"
                  $data=$add_ptr; //@line 437 "mbrowrap.cpp"
                  var $23=$head; //@line 438 "mbrowrap.cpp"
                  var $size=(($23+8)&4294967295); //@line 438 "mbrowrap.cpp"
                  var $24=HEAP32[(($size)>>2)]; //@line 438 "mbrowrap.cpp"
                  var $25=$head; //@line 438 "mbrowrap.cpp"
                  var $done43=(($25+4)&4294967295); //@line 438 "mbrowrap.cpp"
                  var $26=HEAP32[(($done43)>>2)]; //@line 438 "mbrowrap.cpp"
                  var $sub=((($24)-($26))&4294967295); //@line 438 "mbrowrap.cpp"
                  $left=$sub; //@line 438 "mbrowrap.cpp"
                  var $27=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 439 "mbrowrap.cpp"
                  var $28=$data; //@line 439 "mbrowrap.cpp"
                  var $29=$left; //@line 439 "mbrowrap.cpp"
                  var $call44=_write($27, $28, $29); //@line 439 "mbrowrap.cpp"
                  $result=$call44; //@line 439 "mbrowrap.cpp"
                  var $30=$result; //@line 440 "mbrowrap.cpp"
                  var $cmp45=((($30))|0)==-1; //@line 440 "mbrowrap.cpp"
                  if ($cmp45) { __label__ = 19;break $do_body$4; } //@line 440 "mbrowrap.cpp"
  
                  var $34=$result; //@line 447 "mbrowrap.cpp"
                  var $35=$left; //@line 447 "mbrowrap.cpp"
                  var $cmp56=((($34))|0)!=((($35))|0); //@line 447 "mbrowrap.cpp"
                  if ($cmp56) { __label__ = 24;; } else { __label__ = 25;; } //@line 447 "mbrowrap.cpp"
                  if (__label__ == 24) {
  
                    var $36=$result; //@line 448 "mbrowrap.cpp"
                    var $37=$head; //@line 448 "mbrowrap.cpp"
                    var $done58=(($37+4)&4294967295); //@line 448 "mbrowrap.cpp"
                    var $38=HEAP32[(($done58)>>2)]; //@line 448 "mbrowrap.cpp"
                    var $add=((($38)+($36))&4294967295); //@line 448 "mbrowrap.cpp"
                    HEAP32[(($done58)>>2)]=$add; //@line 448 "mbrowrap.cpp"
                    ; //@line 449 "mbrowrap.cpp"
                  }
                  else if (__label__ == 25) {
  
                    var $39=$head; //@line 450 "mbrowrap.cpp"
                    var $next=(($39)&4294967295); //@line 450 "mbrowrap.cpp"
                    var $40=HEAP32[(($next)>>2)]; //@line 450 "mbrowrap.cpp"
                    HEAP32[((__ZL21mbr_pending_data_head)>>2)]=$40; //@line 450 "mbrowrap.cpp"
                    var $41=$head; //@line 451 "mbrowrap.cpp"
                    var $42=$41; //@line 451 "mbrowrap.cpp"
                    ; //@line 451 "mbrowrap.cpp"
                    var $43=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 452 "mbrowrap.cpp"
                    var $tobool60=((($43))|0)!=0; //@line 452 "mbrowrap.cpp"
                    if ($tobool60) { __label__ = 31;break $if_then22$$if_end28$10; } //@line 452 "mbrowrap.cpp"
  
                    HEAP32[((__ZL21mbr_pending_data_tail)>>2)]=0; //@line 453 "mbrowrap.cpp"
                    ;
                  }
                }
              } while(0);
  
              var $44=HEAP16[(($revents67)>>1)]; //@line 459 "mbrowrap.cpp"
              var $tobool68=(tempInt=(($44)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 459 "mbrowrap.cpp"
              if (!($tobool68)) { __label__ = 31;break $if_then22$$if_end28$10; } //@line 459 "mbrowrap.cpp"
  
              var $45=$buffer_addr; //@line 460 "mbrowrap.cpp"
              var $46=$cursize; //@line 460 "mbrowrap.cpp"
              var $add_ptr70=(($45+$46)&4294967295); //@line 460 "mbrowrap.cpp"
              $curpos=$add_ptr70; //@line 460 "mbrowrap.cpp"
              var $47=$bufsize_addr; //@line 461 "mbrowrap.cpp"
              var $48=$cursize; //@line 461 "mbrowrap.cpp"
              var $sub71=((($47)-($48))&4294967295); //@line 461 "mbrowrap.cpp"
              $space=$sub71; //@line 461 "mbrowrap.cpp"
              var $49=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 462 "mbrowrap.cpp"
              var $50=$curpos; //@line 462 "mbrowrap.cpp"
              var $51=$space; //@line 462 "mbrowrap.cpp"
              var $call72=_read($49, $50, $51); //@line 462 "mbrowrap.cpp"
              $obtained=$call72; //@line 462 "mbrowrap.cpp"
              var $52=$obtained; //@line 463 "mbrowrap.cpp"
              var $cmp73=((($52))|0)==-1; //@line 463 "mbrowrap.cpp"
              if ($cmp73) { __label__ = 29;break $do_body$4; } //@line 463 "mbrowrap.cpp"
  
              var $54=$obtained; //@line 467 "mbrowrap.cpp"
              var $55=$cursize; //@line 467 "mbrowrap.cpp"
              var $add78=((($55)+($54))&4294967295); //@line 467 "mbrowrap.cpp"
              $cursize=$add78; //@line 467 "mbrowrap.cpp"
              HEAP32[((__ZL9mbr_state)>>2)]=3; //@line 468 "mbrowrap.cpp"
              ; //@line 469 "mbrowrap.cpp"
            }
          } while(0);
  
          var $56=$cursize; //@line 470 "mbrowrap.cpp"
          var $57=$bufsize_addr; //@line 470 "mbrowrap.cpp"
          var $cmp80=((($56))>>>0) < ((($57))>>>0); //@line 470 "mbrowrap.cpp"
          if ($cmp80) { __label__ = 3;continue $do_body$4; } else { __label__ = 32;break $do_body$4; } //@line 470 "mbrowrap.cpp"
        }
        if (__label__ == 6) {
  
          var $call18=___errno(); //@line 412 "mbrowrap.cpp"
          var $11=HEAP32[(($call18)>>2)]; //@line 412 "mbrowrap.cpp"
          var $call19=_strerror($11); //@line 412 "mbrowrap.cpp"
          __ZL3errPKcz(((__str18598)&4294967295), allocate([$call19,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 412 "mbrowrap.cpp"
          $retval=-1; //@line 413 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 413 "mbrowrap.cpp"
        }
        else if (__label__ == 9) {
  
          HEAP32[((__ZL9mbr_state)>>2)]=1; //@line 417 "mbrowrap.cpp"
          ; //@line 418 "mbrowrap.cpp"
        }
        else if (__label__ == 11) {
  
          HEAP32[((__ZL9mbr_state)>>2)]=4; //@line 421 "mbrowrap.cpp"
          __ZL3errPKcz(((__str19599)&4294967295), allocate(1, "i32", ALLOC_STACK)); //@line 422 "mbrowrap.cpp"
          ; //@line 423 "mbrowrap.cpp"
        }
        else if (__label__ == 15) {
  
          $retval=-1; //@line 433 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 433 "mbrowrap.cpp"
        }
        else if (__label__ == 19) {
  
          var $call47=___errno(); //@line 441 "mbrowrap.cpp"
          var $31=HEAP32[(($call47)>>2)]; //@line 441 "mbrowrap.cpp"
          $error=$31; //@line 441 "mbrowrap.cpp"
          var $32=$error; //@line 442 "mbrowrap.cpp"
          var $cmp48=((($32))|0)==32; //@line 442 "mbrowrap.cpp"
          if ($cmp48) { __label__ = 20;; } else { __label__ = 22;; } //@line 442 "mbrowrap.cpp"
          $land_lhs_true49$$if_end53$36: do { 
            if (__label__ == 20) {
  
              var $call50=__ZL17mbrola_has_errorsv(); //@line 442 "mbrowrap.cpp"
              var $tobool51=((($call50))|0)!=0; //@line 442 "mbrowrap.cpp"
              if (!($tobool51)) { __label__ = 22;break $land_lhs_true49$$if_end53$36; } //@line 442 "mbrowrap.cpp"
  
              $retval=-1; //@line 443 "mbrowrap.cpp"
              __label__ = 33;break $do_body_preheader$$if_then$2; //@line 443 "mbrowrap.cpp"
            }
          } while(0);
  
          var $33=$error; //@line 444 "mbrowrap.cpp"
          var $call54=_strerror($33); //@line 444 "mbrowrap.cpp"
          __ZL3errPKcz(((__str20600)&4294967295), allocate([$call54,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 444 "mbrowrap.cpp"
          $retval=-1; //@line 445 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 445 "mbrowrap.cpp"
        }
        else if (__label__ == 29) {
  
          var $call75=___errno(); //@line 464 "mbrowrap.cpp"
          var $53=HEAP32[(($call75)>>2)]; //@line 464 "mbrowrap.cpp"
          var $call76=_strerror($53); //@line 464 "mbrowrap.cpp"
          __ZL3errPKcz(((__str21601)&4294967295), allocate([$call76,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 464 "mbrowrap.cpp"
          $retval=-1; //@line 465 "mbrowrap.cpp"
          __label__ = 33;break $do_body_preheader$$if_then$2; //@line 465 "mbrowrap.cpp"
        }
  
        var $58=$cursize; //@line 472 "mbrowrap.cpp"
        $retval=$58; //@line 472 "mbrowrap.cpp"
        ; //@line 472 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        $retval=-1; //@line 388 "mbrowrap.cpp"
        ; //@line 388 "mbrowrap.cpp"
      }
    } while(0);
  
    var $59=$retval; //@line 473 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $59; //@line 473 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL3errPKcz($errmsg) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $errmsg_addr;
    var $params=__stackBase__;
    $errmsg_addr=$errmsg;
    var $params1=$params; //@line 84 "mbrowrap.cpp"
    HEAP32[(($params1)>>2)]=arguments[__ZL3errPKcz.length];; //@line 84 "mbrowrap.cpp"
    var $0=$errmsg_addr; //@line 85 "mbrowrap.cpp"
    var $1=HEAP32[(($params)>>2)]; //@line 85 "mbrowrap.cpp"
    var $call=_vsnprintf(((__ZL12mbr_errorbuf)&4294967295), 160, $0, $1); //@line 85 "mbrowrap.cpp"
    var $params2=$params; //@line 86 "mbrowrap.cpp"
    ; //@line 86 "mbrowrap.cpp"
    __ZL3logPKcz(((__str16596)&4294967295), allocate([((__ZL12mbr_errorbuf)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 87 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return; //@line 88 "mbrowrap.cpp"
    return;
  }
  

  function _close_MBR() {
    ;
    var __label__;
  
    __ZL11stop_mbrolav(); //@line 525 "mbrowrap.cpp"
    __ZL17free_pending_datav(); //@line 526 "mbrowrap.cpp"
    var $0=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 527 "mbrowrap.cpp"
    ; //@line 527 "mbrowrap.cpp"
    HEAP32[((__ZL14mbr_voice_path)>>2)]=0; //@line 528 "mbrowrap.cpp"
    HEAPF32[((__ZL10mbr_volume)>>2)]=1; //@line 529 "mbrowrap.cpp"
    ;
    return; //@line 530 "mbrowrap.cpp"
    return;
  }
  

  function __ZL17free_pending_datav() {
    ;
    var __label__;
  
    var $p;
    var $head;
    var $0=HEAP32[((__ZL21mbr_pending_data_head)>>2)]; //@line 228 "mbrowrap.cpp"
    $head=$0; //@line 228 "mbrowrap.cpp"
    var $tobool1=((($0))|0)!=0; //@line 229 "mbrowrap.cpp"
    if ($tobool1) { __label__ = 1;; } else { __label__ = 2;; } //@line 229 "mbrowrap.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $1=$head; //@line 230 "mbrowrap.cpp"
          $p=$1; //@line 230 "mbrowrap.cpp"
          var $2=$head; //@line 231 "mbrowrap.cpp"
          var $next=(($2)&4294967295); //@line 231 "mbrowrap.cpp"
          var $3=HEAP32[(($next)>>2)]; //@line 231 "mbrowrap.cpp"
          $head=$3; //@line 231 "mbrowrap.cpp"
          var $4=$p; //@line 232 "mbrowrap.cpp"
          var $5=$4; //@line 232 "mbrowrap.cpp"
          ; //@line 232 "mbrowrap.cpp"
          var $_pr=$head; //@line 229 "mbrowrap.cpp"
          var $tobool=((($_pr))|0)!=0; //@line 229 "mbrowrap.cpp"
          if ($tobool) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 229 "mbrowrap.cpp"
        }
      }
    } while(0);
  
    HEAP32[((__ZL21mbr_pending_data_head)>>2)]=0; //@line 234 "mbrowrap.cpp"
    HEAP32[((__ZL21mbr_pending_data_tail)>>2)]=0; //@line 235 "mbrowrap.cpp"
    ;
    return; //@line 236 "mbrowrap.cpp"
    return;
  }
  

  function _reset_MBR() {
    var __stackBase__  = STACKTOP; STACKTOP += 4096; _memset(__stackBase__, 0, 4096);
    var __label__;
  
    var $retval;
    var $result;
    var $success;
    var $dummybuf=__stackBase__;
    $success=1; //@line 534 "mbrowrap.cpp"
    var $0=HEAP32[((__ZL9mbr_state)>>2)]; //@line 537 "mbrowrap.cpp"
    var $cmp=((($0))|0)==1; //@line 537 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 537 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 538 "mbrowrap.cpp"
      ; //@line 538 "mbrowrap.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 539 "mbrowrap.cpp"
      var $tobool=((($1))|0)!=0; //@line 539 "mbrowrap.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 539 "mbrowrap.cpp"
      if (__label__ == 4) {
  
        var $2=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 541 "mbrowrap.cpp"
        var $call=_kill($2, 30); //@line 541 "mbrowrap.cpp"
        var $cmp3=((($call))|0)==-1; //@line 541 "mbrowrap.cpp"
        if ($cmp3) { __label__ = 5;; } else { __label__ = 6;; } //@line 541 "mbrowrap.cpp"
        if (__label__ == 5) {
  
          $success=0; //@line 542 "mbrowrap.cpp"
          ; //@line 542 "mbrowrap.cpp"
        }
  
        __ZL17free_pending_datav(); //@line 543 "mbrowrap.cpp"
        var $3=HEAP32[((__ZL10mbr_cmd_fd)>>2)]; //@line 544 "mbrowrap.cpp"
        var $call6=_write($3, ((__str5585)&4294967295), 3); //@line 544 "mbrowrap.cpp"
        $result=$call6; //@line 544 "mbrowrap.cpp"
        var $cmp7=((($call6))|0)!=3; //@line 545 "mbrowrap.cpp"
        if ($cmp7) { __label__ = 7;; } else { __label__ = 8;; } //@line 545 "mbrowrap.cpp"
        if (__label__ == 7) {
  
          $success=0; //@line 546 "mbrowrap.cpp"
          ; //@line 546 "mbrowrap.cpp"
        }
  
        var $arraydecay=(($dummybuf)&4294967295); //@line 548 "mbrowrap.cpp"
        ; //@line 548 "mbrowrap.cpp"
        $do_body$13: while(1) { 
  
          var $4=HEAP32[((__ZL12mbr_audio_fd)>>2)]; //@line 548 "mbrowrap.cpp"
          var $call10=_read($4, $arraydecay, 4096); //@line 548 "mbrowrap.cpp"
          $result=$call10; //@line 548 "mbrowrap.cpp"
          var $cmp11=((($call10))|0) > 0; //@line 549 "mbrowrap.cpp"
          if ($cmp11) { __label__ = 9;continue $do_body$13; } else { __label__ = 10;break $do_body$13; } //@line 549 "mbrowrap.cpp"
        }
  
        var $5=$result; //@line 550 "mbrowrap.cpp"
        var $cmp12=((($5))|0)!=-1; //@line 550 "mbrowrap.cpp"
        if ($cmp12) { __label__ = 12;; } else { __label__ = 11;; } //@line 550 "mbrowrap.cpp"
        $if_then15$$lor_lhs_false$16: do { 
          if (__label__ == 11) {
  
            var $call13=___errno(); //@line 550 "mbrowrap.cpp"
            var $6=HEAP32[(($call13)>>2)]; //@line 550 "mbrowrap.cpp"
            var $cmp14=((($6))|0)!=11; //@line 550 "mbrowrap.cpp"
            if ($cmp14) { __label__ = 12;break $if_then15$$lor_lhs_false$16; } else { __label__ = 13;break $if_then15$$lor_lhs_false$16; } //@line 550 "mbrowrap.cpp"
          }
        } while(0);
        if (__label__ == 12) {
  
          $success=0; //@line 551 "mbrowrap.cpp"
          ; //@line 551 "mbrowrap.cpp"
        }
  
        var $call17=__ZL17mbrola_has_errorsv(); //@line 552 "mbrowrap.cpp"
        var $tobool18=((($call17))|0)!=0; //@line 552 "mbrowrap.cpp"
        if ($tobool18) { __label__ = 16;; } else { __label__ = 14;; } //@line 552 "mbrowrap.cpp"
        $if_end21$$land_lhs_true$21: do { 
          if (__label__ == 14) {
  
            var $7=$success; //@line 552 "mbrowrap.cpp"
            var $tobool19=((($7))|0)!=0; //@line 552 "mbrowrap.cpp"
            if (!($tobool19)) { __label__ = 16;break $if_end21$$land_lhs_true$21; } //@line 552 "mbrowrap.cpp"
  
            HEAP32[((__ZL9mbr_state)>>2)]=1; //@line 553 "mbrowrap.cpp"
            ; //@line 553 "mbrowrap.cpp"
          }
        } while(0);
  
        var $8=$success; //@line 554 "mbrowrap.cpp"
        $retval=$8; //@line 554 "mbrowrap.cpp"
        ; //@line 554 "mbrowrap.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 540 "mbrowrap.cpp"
        ; //@line 540 "mbrowrap.cpp"
      }
    }
  
    var $9=$retval; //@line 555 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $9; //@line 555 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL17mbrola_has_errorsv() {
    var __stackBase__  = STACKTOP; STACKTOP += 256; _memset(__stackBase__, 0, 256);
    var __label__;
  
    var $retval;
    var $result;
    var $buffer=__stackBase__;
    var $buf_ptr;
    var $lf;
    var $arraydecay=(($buffer)&4294967295); //@line 284 "mbrowrap.cpp"
    $buf_ptr=$arraydecay; //@line 284 "mbrowrap.cpp"
    var $arraydecay1=(($buffer)&4294967295); //@line 286 "mbrowrap.cpp"
    var $sub_ptr_rhs_cast=($arraydecay1); //@line 286 "mbrowrap.cpp"
    var $sub_ptr_rhs_cast_neg=(((-($sub_ptr_rhs_cast)))&4294967295);
    var $sub_ptr_rhs_cast_neg_neg=(((-($sub_ptr_rhs_cast_neg)))&4294967295);
    var $sub=((($sub_ptr_rhs_cast_neg_neg)+255)&4294967295); //@line 286 "mbrowrap.cpp"
    var $arraydecay27=(($buffer)&4294967295); //@line 318 "mbrowrap.cpp"
    var $arraydecay28=(($buffer)&4294967295); //@line 319 "mbrowrap.cpp"
    ; //@line 285 "mbrowrap.cpp"
    $for_cond$2: while(1) { 
  
      var $0=HEAP32[((__ZL12mbr_error_fd)>>2)]; //@line 286 "mbrowrap.cpp"
      var $1=$buf_ptr; //@line 286 "mbrowrap.cpp"
      var $2=$buf_ptr; //@line 286 "mbrowrap.cpp"
      var $sub_ptr_lhs_cast=($2); //@line 286 "mbrowrap.cpp"
      var $sub_ptr_lhs_cast_neg=(((-($sub_ptr_lhs_cast)))&4294967295);
      var $sub2=((($sub)+($sub_ptr_lhs_cast_neg))&4294967295); //@line 286 "mbrowrap.cpp"
      var $call=_read($0, $1, $sub2); //@line 286 "mbrowrap.cpp"
      $result=$call; //@line 286 "mbrowrap.cpp"
      var $cmp=((($call))|0)==-1; //@line 288 "mbrowrap.cpp"
      if ($cmp) { __label__ = 2;break $for_cond$2; } //@line 288 "mbrowrap.cpp"
  
      var $5=$result; //@line 295 "mbrowrap.cpp"
      var $cmp9=((($5))|0)==0; //@line 295 "mbrowrap.cpp"
      if ($cmp9) { __label__ = 6;break $for_cond$2; } //@line 295 "mbrowrap.cpp"
  
      var $6=$result; //@line 300 "mbrowrap.cpp"
      var $7=$buf_ptr; //@line 300 "mbrowrap.cpp"
      var $arrayidx=(($7+$6)&4294967295); //@line 300 "mbrowrap.cpp"
      HEAP8[($arrayidx)]=0; //@line 300 "mbrowrap.cpp"
      ; //@line 302 "mbrowrap.cpp"
      $for_cond13$6: while(1) { 
  
        var $8=$buf_ptr; //@line 302 "mbrowrap.cpp"
        var $call14=_strchr($8, 10); //@line 302 "mbrowrap.cpp"
        $lf=$call14; //@line 302 "mbrowrap.cpp"
        var $tobool=((($call14))|0)!=0; //@line 302 "mbrowrap.cpp"
        var $9=$buf_ptr; //@line 304 "mbrowrap.cpp"
        if (!($tobool)) { __label__ = 14;break $for_cond13$6; } //@line 302 "mbrowrap.cpp"
  
        var $call15=_strncmp($9, ((__str8588)&4294967295), 18); //@line 304 "mbrowrap.cpp"
        var $cmp16=((($call15))|0)==0; //@line 304 "mbrowrap.cpp"
        if ($cmp16) { __label__ = 13;; } else { __label__ = 10;; } //@line 304 "mbrowrap.cpp"
        $for_inc$$lor_lhs_false$9: do { 
          if (__label__ == 10) {
  
            var $10=$buf_ptr; //@line 305 "mbrowrap.cpp"
            var $call17=_strncmp($10, ((__str9589)&4294967295), 18); //@line 305 "mbrowrap.cpp"
            var $cmp18=((($call17))|0)==0; //@line 305 "mbrowrap.cpp"
            if ($cmp18) { __label__ = 13;break $for_inc$$lor_lhs_false$9; } //@line 305 "mbrowrap.cpp"
  
            var $11=$lf; //@line 307 "mbrowrap.cpp"
            HEAP8[($11)]=0; //@line 307 "mbrowrap.cpp"
            var $12=$buf_ptr; //@line 308 "mbrowrap.cpp"
            __ZL3logPKcz(((__str10590)&4294967295), allocate([$12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 308 "mbrowrap.cpp"
            var $13=$lf; //@line 310 "mbrowrap.cpp"
            var $14=$result; //@line 310 "mbrowrap.cpp"
            var $sub21=((($14)-1)&4294967295); //@line 310 "mbrowrap.cpp"
            var $15=$buf_ptr; //@line 310 "mbrowrap.cpp"
            var $arrayidx22=(($15+$sub21)&4294967295); //@line 310 "mbrowrap.cpp"
            var $cmp23=((($13))|0)==((($arrayidx22))|0); //@line 310 "mbrowrap.cpp"
            if ($cmp23) { __label__ = 12;break $for_cond$2; } //@line 310 "mbrowrap.cpp"
          }
        } while(0);
  
        var $17=$lf; //@line 302 "mbrowrap.cpp"
        var $add_ptr=(($17+1)&4294967295); //@line 302 "mbrowrap.cpp"
        $buf_ptr=$add_ptr; //@line 302 "mbrowrap.cpp"
        __label__ = 8;continue $for_cond13$6; //@line 302 "mbrowrap.cpp"
      }
  
      var $18=$result; //@line 318 "mbrowrap.cpp"
      _llvm_memmove_p0i8_p0i8_i32($arraydecay27, $9, $18, 1, 0); //@line 318 "mbrowrap.cpp"
      var $19=$result; //@line 319 "mbrowrap.cpp"
      var $add_ptr29=(($arraydecay28+$19)&4294967295); //@line 319 "mbrowrap.cpp"
      $buf_ptr=$add_ptr29; //@line 319 "mbrowrap.cpp"
      __label__ = 1;continue $for_cond$2; //@line 320 "mbrowrap.cpp"
    }
    if (__label__ == 2) {
  
      var $call3=___errno(); //@line 289 "mbrowrap.cpp"
      var $3=HEAP32[(($call3)>>2)]; //@line 289 "mbrowrap.cpp"
      var $cmp4=((($3))|0)==11; //@line 289 "mbrowrap.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 289 "mbrowrap.cpp"
      if (__label__ == 3) {
  
        $retval=0; //@line 290 "mbrowrap.cpp"
        ; //@line 290 "mbrowrap.cpp"
      }
      else if (__label__ == 4) {
  
        var $call6=___errno(); //@line 291 "mbrowrap.cpp"
        var $4=HEAP32[(($call6)>>2)]; //@line 291 "mbrowrap.cpp"
        var $call7=_strerror($4); //@line 291 "mbrowrap.cpp"
        __ZL3errPKcz(((__str7587)&4294967295), allocate([$call7,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 291 "mbrowrap.cpp"
        $retval=-1; //@line 292 "mbrowrap.cpp"
        ; //@line 292 "mbrowrap.cpp"
      }
    }
    else if (__label__ == 6) {
  
      __ZL11mbrola_diedv(); //@line 297 "mbrowrap.cpp"
      $retval=-1; //@line 297 "mbrowrap.cpp"
      ; //@line 297 "mbrowrap.cpp"
    }
    else if (__label__ == 12) {
  
      var $16=$buf_ptr; //@line 311 "mbrowrap.cpp"
      var $call25=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str57709)&4294967295), allocate([$16,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 311 "mbrowrap.cpp"
      $retval=0; //@line 314 "mbrowrap.cpp"
      ; //@line 314 "mbrowrap.cpp"
    }
  
    var $20=$retval; //@line 321 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $20; //@line 321 "mbrowrap.cpp"
    return null;
  }
  

  function _read_MBR($buffer, $nb_samples) {
    ;
    var __label__;
  
    var $buffer_addr;
    var $nb_samples_addr;
    var $result;
    $buffer_addr=$buffer;
    $nb_samples_addr=$nb_samples;
    var $0=$buffer_addr; //@line 559 "mbrowrap.cpp"
    var $1=$nb_samples_addr; //@line 559 "mbrowrap.cpp"
    var $mul=((($1)*2)&4294967295); //@line 559 "mbrowrap.cpp"
    var $call=__ZL19receive_from_mbrolaPvj($0, $mul); //@line 559 "mbrowrap.cpp"
    $result=$call; //@line 559 "mbrowrap.cpp"
    var $2=$result; //@line 560 "mbrowrap.cpp"
    var $cmp=((($2))|0) > 0; //@line 560 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 560 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      var $3=$result; //@line 561 "mbrowrap.cpp"
      var $div=((((($3))|0)/2)|0); //@line 561 "mbrowrap.cpp"
      $result=$div; //@line 561 "mbrowrap.cpp"
      ; //@line 561 "mbrowrap.cpp"
    }
  
    var $4=$result; //@line 562 "mbrowrap.cpp"
    ;
    return $4; //@line 562 "mbrowrap.cpp"
    return null;
  }
  

  function _write_MBR($data) {
    ;
    var __label__;
  
    var $data_addr;
    $data_addr=$data;
    HEAP32[((__ZL9mbr_state)>>2)]=2; //@line 567 "mbrowrap.cpp"
    var $0=$data_addr; //@line 568 "mbrowrap.cpp"
    var $call=__ZL14send_to_mbrolaPKc($0); //@line 568 "mbrowrap.cpp"
    ;
    return $call; //@line 568 "mbrowrap.cpp"
    return null;
  }
  

  function _flush_MBR() {
    ;
    var __label__;
  
    var $call=__ZL14send_to_mbrolaPKc(((__str5585)&4294967295)); //@line 573 "mbrowrap.cpp"
    var $cmp=((($call))|0)==3; //@line 573 "mbrowrap.cpp"
    var $conv=((($cmp))&1); //@line 573 "mbrowrap.cpp"
    ;
    return $conv; //@line 573 "mbrowrap.cpp"
    return null;
  }
  

  function _getFreq_MBR() {
    ;
    var __label__;
  
    var $0=HEAP32[((__ZL14mbr_samplerate)>>2)]; //@line 578 "mbrowrap.cpp"
    ;
    return $0; //@line 578 "mbrowrap.cpp"
    return null;
  }
  

  function _setVolumeRatio_MBR($value) {
    ;
    var __label__;
  
    var $value_addr;
    $value_addr=$value;
    var $0=$value_addr; //@line 583 "mbrowrap.cpp"
    var $1=HEAPF32[((__ZL10mbr_volume)>>2)]; //@line 583 "mbrowrap.cpp"
    var $cmp=($0) == ($1); //@line 583 "mbrowrap.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 1;; } //@line 583 "mbrowrap.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $2=$value_addr; //@line 585 "mbrowrap.cpp"
        HEAPF32[((__ZL10mbr_volume)>>2)]=$2; //@line 585 "mbrowrap.cpp"
        var $3=HEAP32[((__ZL9mbr_state)>>2)]; //@line 586 "mbrowrap.cpp"
        var $cmp1=((($3))|0)!=1; //@line 586 "mbrowrap.cpp"
        if ($cmp1) { __label__ = 3;break $return$$if_end$2; } //@line 586 "mbrowrap.cpp"
  
        __ZL11stop_mbrolav(); //@line 592 "mbrowrap.cpp"
        var $4=HEAP32[((__ZL14mbr_voice_path)>>2)]; //@line 593 "mbrowrap.cpp"
        var $call=_init_MBR($4); //@line 593 "mbrowrap.cpp"
        ; //@line 594 "mbrowrap.cpp"
      }
    } while(0);
  
    ;
    return; //@line 594 "mbrowrap.cpp"
    return;
  }
  

  function _lastErrorStr_MBR($buffer, $bufsize) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $buffer_addr;
    var $bufsize_addr;
    var $result;
    $buffer_addr=$buffer;
    $bufsize_addr=$bufsize;
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 599 "mbrowrap.cpp"
    var $tobool=((($0))|0)!=0; //@line 599 "mbrowrap.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 599 "mbrowrap.cpp"
    if (__label__ == 1) {
  
      var $call=__ZL17mbrola_has_errorsv(); //@line 600 "mbrowrap.cpp"
      ; //@line 600 "mbrowrap.cpp"
    }
  
    var $1=$buffer_addr; //@line 601 "mbrowrap.cpp"
    var $2=$bufsize_addr; //@line 601 "mbrowrap.cpp"
    var $call1=_snprintf($1, $2, ((__str57709)&4294967295), allocate([((__ZL12mbr_errorbuf)&4294967295),0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 601 "mbrowrap.cpp"
    $result=$call1; //@line 601 "mbrowrap.cpp"
    var $3=$result; //@line 602 "mbrowrap.cpp"
    var $4=$bufsize_addr; //@line 602 "mbrowrap.cpp"
    var $cmp=((($3))|0) >= ((($4))|0); //@line 602 "mbrowrap.cpp"
    if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 602 "mbrowrap.cpp"
    if (__label__ == 3) {
  
      var $5=$bufsize_addr; //@line 602 "mbrowrap.cpp"
      var $sub=((($5)-1)&4294967295); //@line 602 "mbrowrap.cpp"
      __lastLabel__ = 3; ; //@line 602 "mbrowrap.cpp"
    }
    else if (__label__ == 4) {
  
      var $6=$result; //@line 602 "mbrowrap.cpp"
      __lastLabel__ = 4; ; //@line 602 "mbrowrap.cpp"
    }
  
    var $cond=__lastLabel__ == 3 ? $sub : ($6); //@line 602 "mbrowrap.cpp"
    ;
    return $cond; //@line 602 "mbrowrap.cpp"
    return null;
  }
  

  function _resetError_MBR() {
    ;
    var __label__;
  
    HEAP8[(((__ZL12mbr_errorbuf)&4294967295))]=0; //@line 607 "mbrowrap.cpp"
    ;
    return; //@line 608 "mbrowrap.cpp"
    return;
  }
  

  function __ZL11mbrola_diedv() {
    var __stackBase__  = STACKTOP; STACKTOP += 84; _memset(__stackBase__, 0, 84);
    var __label__;
  
    var $pid;
    var $status=__stackBase__;
    var $len;
    var $msg;
    var $msgbuf=__stackBase__+4;
    var $sig;
    var $exst;
    var $0=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 245 "mbrowrap.cpp"
    var $call=_waitpid($0, $status, 1); //@line 245 "mbrowrap.cpp"
    $pid=$call; //@line 245 "mbrowrap.cpp"
    var $1=$pid; //@line 246 "mbrowrap.cpp"
    var $tobool=((($1))|0)!=0; //@line 246 "mbrowrap.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 246 "mbrowrap.cpp"
    $if_else$$if_then$2: do { 
      if (__label__ == 2) {
  
        var $2=$pid; //@line 248 "mbrowrap.cpp"
        var $3=HEAP32[((__ZL7mbr_pid)>>2)]; //@line 248 "mbrowrap.cpp"
        var $cmp=((($2))|0)!=((($3))|0); //@line 248 "mbrowrap.cpp"
        if ($cmp) { __label__ = 3;; } else { __label__ = 4;; } //@line 248 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          $msg=((__str12592)&4294967295); //@line 249 "mbrowrap.cpp"
          ; //@line 250 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          HEAP32[((__ZL7mbr_pid)>>2)]=0; //@line 251 "mbrowrap.cpp"
          var $4=HEAP32[(($status)>>2)]; //@line 252 "mbrowrap.cpp"
          var $and=($4) & 127; //@line 252 "mbrowrap.cpp"
          var $cmp3=((($and))|0) > 0; //@line 252 "mbrowrap.cpp"
          if ($cmp3) { __label__ = 5;; } else { __label__ = 7;; } //@line 252 "mbrowrap.cpp"
          $land_lhs_true$$if_else10$7: do { 
            if (__label__ == 5) {
  
              var $5=HEAP32[(($status)>>2)]; //@line 252 "mbrowrap.cpp"
              var $and4=($5) & 127; //@line 252 "mbrowrap.cpp"
              var $cmp5=((($and4))|0) < 127; //@line 252 "mbrowrap.cpp"
              if (!($cmp5)) { __label__ = 7;break $land_lhs_true$$if_else10$7; } //@line 252 "mbrowrap.cpp"
  
              var $6=HEAP32[(($status)>>2)]; //@line 253 "mbrowrap.cpp"
              var $and7=($6) & 127; //@line 253 "mbrowrap.cpp"
              $sig=$and7; //@line 253 "mbrowrap.cpp"
              var $arraydecay=(($msgbuf)&4294967295); //@line 254 "mbrowrap.cpp"
              var $7=$sig; //@line 254 "mbrowrap.cpp"
              var $call8=_snprintf($arraydecay, 80, ((__str13593)&4294967295), allocate([$7,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 254 "mbrowrap.cpp"
              var $arraydecay9=(($msgbuf)&4294967295); //@line 256 "mbrowrap.cpp"
              $msg=$arraydecay9; //@line 256 "mbrowrap.cpp"
              __label__ = 10;break $if_else$$if_then$2; //@line 257 "mbrowrap.cpp"
            }
          } while(0);
  
          var $8=HEAP32[(($status)>>2)]; //@line 257 "mbrowrap.cpp"
          var $and11=($8) & 255; //@line 257 "mbrowrap.cpp"
          var $cmp12=((($and11))|0)==0; //@line 257 "mbrowrap.cpp"
          if ($cmp12) { __label__ = 8;; } else { __label__ = 9;; } //@line 257 "mbrowrap.cpp"
          if (__label__ == 8) {
  
            var $9=HEAP32[(($status)>>2)]; //@line 258 "mbrowrap.cpp"
            var $shr=($9) >> 8; //@line 258 "mbrowrap.cpp"
            var $and14=($shr) & 255; //@line 258 "mbrowrap.cpp"
            $exst=$and14; //@line 258 "mbrowrap.cpp"
            var $arraydecay15=(($msgbuf)&4294967295); //@line 259 "mbrowrap.cpp"
            var $10=$exst; //@line 259 "mbrowrap.cpp"
            var $call16=_snprintf($arraydecay15, 80, ((__str14594)&4294967295), allocate([$10,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 259 "mbrowrap.cpp"
            var $arraydecay17=(($msgbuf)&4294967295); //@line 261 "mbrowrap.cpp"
            $msg=$arraydecay17; //@line 261 "mbrowrap.cpp"
            ; //@line 262 "mbrowrap.cpp"
          }
          else if (__label__ == 9) {
  
            $msg=((__str15595)&4294967295); //@line 263 "mbrowrap.cpp"
            ;
          }
        }
      }
      else if (__label__ == 1) {
  
        $msg=((__str11591)&4294967295); //@line 247 "mbrowrap.cpp"
        ; //@line 248 "mbrowrap.cpp"
      }
    } while(0);
  
    var $11=$msg; //@line 267 "mbrowrap.cpp"
    __ZL3logPKcz(((__str16596)&4294967295), allocate([$11,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 267 "mbrowrap.cpp"
    var $call22=_strlen(((__ZL12mbr_errorbuf)&4294967295)); //@line 269 "mbrowrap.cpp"
    $len=$call22; //@line 269 "mbrowrap.cpp"
    var $tobool23=((($call22))|0)!=0; //@line 270 "mbrowrap.cpp"
    if ($tobool23) { __label__ = 12;; } else { __label__ = 11;; } //@line 270 "mbrowrap.cpp"
    if (__label__ == 12) {
  
      var $13=$len; //@line 273 "mbrowrap.cpp"
      var $add_ptr=((((__ZL12mbr_errorbuf)&4294967295)+$13)&4294967295); //@line 273 "mbrowrap.cpp"
      var $14=$len; //@line 273 "mbrowrap.cpp"
      var $sub=((160-($14))&4294967295); //@line 273 "mbrowrap.cpp"
      var $15=$msg; //@line 273 "mbrowrap.cpp"
      var $call27=_snprintf($add_ptr, $sub, ((__str17597)&4294967295), allocate([$15,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 273 "mbrowrap.cpp"
      ;
    }
    else if (__label__ == 11) {
  
      var $12=$msg; //@line 271 "mbrowrap.cpp"
      var $call25=_snprintf(((__ZL12mbr_errorbuf)&4294967295), 160, ((__str57709)&4294967295), allocate([$12,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 271 "mbrowrap.cpp"
      ; //@line 271 "mbrowrap.cpp"
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __ZL3logPKcz($msg) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $msg_addr;
    var $params=__stackBase__;
    $msg_addr=$msg;
    var $params1=$params; //@line 74 "mbrowrap.cpp"
    HEAP32[(($params1)>>2)]=arguments[__ZL3logPKcz.length];; //@line 74 "mbrowrap.cpp"
    var $0=HEAP32[((__impure_ptr)>>2)]; //@line 75 "mbrowrap.cpp"
    var $_stderr=(($0+12)&4294967295); //@line 75 "mbrowrap.cpp"
    var $1=HEAP32[(($_stderr)>>2)]; //@line 75 "mbrowrap.cpp"
    var $2=$msg_addr; //@line 75 "mbrowrap.cpp"
    var $3=HEAP32[(($params)>>2)]; //@line 75 "mbrowrap.cpp"
    var $call=_vfprintf($1, $2, $3); //@line 75 "mbrowrap.cpp"
    var $4=HEAP32[((__impure_ptr)>>2)]; //@line 76 "mbrowrap.cpp"
    var $_stderr2=(($4+12)&4294967295); //@line 76 "mbrowrap.cpp"
    var $5=HEAP32[(($_stderr2)>>2)]; //@line 76 "mbrowrap.cpp"
    var $call3=_fputc(10, $5); //@line 76 "mbrowrap.cpp"
    var $params4=$params; //@line 77 "mbrowrap.cpp"
    ; //@line 77 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return; //@line 78 "mbrowrap.cpp"
    return;
  }
  

  function __ZL14mbrola_is_idlev() {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $p;
    var $buffer=__stackBase__;
    var $0=HEAP32[((__ZL13mbr_proc_stat)>>2)]; //@line 372 "mbrowrap.cpp"
    var $call=_lseek($0, 0, 0); //@line 372 "mbrowrap.cpp"
    var $cmp=((($call))|0)!=0; //@line 372 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 372 "mbrowrap.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=0; //@line 373 "mbrowrap.cpp"
        ; //@line 373 "mbrowrap.cpp"
      }
      else if (__label__ == 2) {
  
        var $1=HEAP32[((__ZL13mbr_proc_stat)>>2)]; //@line 374 "mbrowrap.cpp"
        var $arraydecay=(($buffer)&4294967295); //@line 374 "mbrowrap.cpp"
        var $call1=_read($1, $arraydecay, 20); //@line 374 "mbrowrap.cpp"
        var $cmp2=((($call1))|0)!=20; //@line 374 "mbrowrap.cpp"
        if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 374 "mbrowrap.cpp"
        if (__label__ == 3) {
  
          $retval=0; //@line 375 "mbrowrap.cpp"
          ; //@line 375 "mbrowrap.cpp"
        }
        else if (__label__ == 4) {
  
          var $arraydecay5=(($buffer)&4294967295); //@line 376 "mbrowrap.cpp"
          var $call6=_memchr($arraydecay5, 41, 20); //@line 376 "mbrowrap.cpp"
          $p=$call6; //@line 376 "mbrowrap.cpp"
          var $2=$p; //@line 377 "mbrowrap.cpp"
          var $tobool=((($2))|0)!=0; //@line 377 "mbrowrap.cpp"
          if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 377 "mbrowrap.cpp"
          $lor_lhs_false$$if_then9$8: do { 
            if (__label__ == 5) {
  
              var $3=$p; //@line 377 "mbrowrap.cpp"
              var $arraydecay7=(($buffer)&4294967295); //@line 377 "mbrowrap.cpp"
              var $sub_ptr_lhs_cast=($3); //@line 377 "mbrowrap.cpp"
              var $sub_ptr_rhs_cast=($arraydecay7); //@line 377 "mbrowrap.cpp"
              var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 377 "mbrowrap.cpp"
              var $cmp8=((($sub_ptr_sub))>>>0) >= 18; //@line 377 "mbrowrap.cpp"
              if ($cmp8) { __label__ = 6;break $lor_lhs_false$$if_then9$8; } //@line 377 "mbrowrap.cpp"
  
              var $4=$p; //@line 379 "mbrowrap.cpp"
              var $arrayidx=(($4+1)&4294967295); //@line 379 "mbrowrap.cpp"
              var $5=HEAP8[($arrayidx)]; //@line 379 "mbrowrap.cpp"
              var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 379 "mbrowrap.cpp"
              var $cmp11=((($conv))|0)==32; //@line 379 "mbrowrap.cpp"
              if ($cmp11) { __lastLabel__ = 7; __label__ = 8;; } else { __lastLabel__ = 7; __label__ = 9;; } //@line 379 "mbrowrap.cpp"
              if (__label__ == 8) {
  
                var $6=$p; //@line 379 "mbrowrap.cpp"
                var $arrayidx12=(($6+2)&4294967295); //@line 379 "mbrowrap.cpp"
                var $7=HEAP8[($arrayidx12)]; //@line 379 "mbrowrap.cpp"
                var $conv13=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 379 "mbrowrap.cpp"
                var $cmp14=((($conv13))|0)==83; //@line 379 "mbrowrap.cpp"
                __lastLabel__ = 8; ;
              }
  
              var $8=__lastLabel__ == 7 ? 0 : ($cmp14);
              var $conv15=((($8))&1);
              $retval=$conv15;
              __label__ = 10;break $if_then$$if_end$2;
            }
          } while(0);
  
          $retval=0; //@line 378 "mbrowrap.cpp"
          ; //@line 378 "mbrowrap.cpp"
        }
      }
    } while(0);
  
    var $9=$retval; //@line 380 "mbrowrap.cpp"
    STACKTOP = __stackBase__;
    return $9; //@line 380 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL12create_pipesPiS_S_($p1, $p2, $p3) {
    ;
    var __label__;
  
    var $retval;
    var $p1_addr;
    var $p2_addr;
    var $p3_addr;
    var $error;
    $p1_addr=$p1;
    $p2_addr=$p2;
    $p3_addr=$p3;
    var $0=$p1_addr; //@line 94 "mbrowrap.cpp"
    var $call=_pipe($0); //@line 94 "mbrowrap.cpp"
    var $cmp=((($call))|0)!=-1; //@line 94 "mbrowrap.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 7;; } //@line 94 "mbrowrap.cpp"
    $if_then$$if_else18$2: do { 
      if (__label__ == 1) {
  
        var $1=$p2_addr; //@line 95 "mbrowrap.cpp"
        var $call1=_pipe($1); //@line 95 "mbrowrap.cpp"
        var $cmp2=((($call1))|0)!=-1; //@line 95 "mbrowrap.cpp"
        if ($cmp2) { __label__ = 2;; } else { __label__ = 5;; } //@line 95 "mbrowrap.cpp"
        if (__label__ == 2) {
  
          var $2=$p3_addr; //@line 96 "mbrowrap.cpp"
          var $call4=_pipe($2); //@line 96 "mbrowrap.cpp"
          var $cmp5=((($call4))|0)!=-1; //@line 96 "mbrowrap.cpp"
          if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 96 "mbrowrap.cpp"
          if (__label__ == 3) {
  
            $retval=0; //@line 97 "mbrowrap.cpp"
            __label__ = 9;break $if_then$$if_else18$2; //@line 97 "mbrowrap.cpp"
          }
          else if (__label__ == 4) {
  
            var $call7=___errno(); //@line 99 "mbrowrap.cpp"
            var $3=HEAP32[(($call7)>>2)]; //@line 99 "mbrowrap.cpp"
            $error=$3; //@line 99 "mbrowrap.cpp"
            var $4=$p2_addr; //@line 100 "mbrowrap.cpp"
            var $arrayidx=(($4)&4294967295); //@line 100 "mbrowrap.cpp"
            var $5=HEAP32[(($arrayidx)>>2)]; //@line 100 "mbrowrap.cpp"
            var $call8=_close($5); //@line 100 "mbrowrap.cpp"
            var $6=$p2_addr; //@line 101 "mbrowrap.cpp"
            var $arrayidx9=(($6+4)&4294967295); //@line 101 "mbrowrap.cpp"
            var $7=HEAP32[(($arrayidx9)>>2)]; //@line 101 "mbrowrap.cpp"
            var $call10=_close($7); //@line 101 "mbrowrap.cpp"
            ; //@line 102 "mbrowrap.cpp"
          }
        }
        else if (__label__ == 5) {
  
          var $call12=___errno(); //@line 103 "mbrowrap.cpp"
          var $8=HEAP32[(($call12)>>2)]; //@line 103 "mbrowrap.cpp"
          $error=$8; //@line 103 "mbrowrap.cpp"
          ;
        }
  
        var $9=$p1_addr; //@line 104 "mbrowrap.cpp"
        var $arrayidx14=(($9)&4294967295); //@line 104 "mbrowrap.cpp"
        var $10=HEAP32[(($arrayidx14)>>2)]; //@line 104 "mbrowrap.cpp"
        var $call15=_close($10); //@line 104 "mbrowrap.cpp"
        var $11=$p1_addr; //@line 105 "mbrowrap.cpp"
        var $arrayidx16=(($11+4)&4294967295); //@line 105 "mbrowrap.cpp"
        var $12=HEAP32[(($arrayidx16)>>2)]; //@line 105 "mbrowrap.cpp"
        var $call17=_close($12); //@line 105 "mbrowrap.cpp"
        __label__ = 8;break $if_then$$if_else18$2; //@line 106 "mbrowrap.cpp"
      }
      else if (__label__ == 7) {
  
        var $call19=___errno(); //@line 107 "mbrowrap.cpp"
        var $13=HEAP32[(($call19)>>2)]; //@line 107 "mbrowrap.cpp"
        $error=$13; //@line 107 "mbrowrap.cpp"
        __label__ = 8;break $if_then$$if_else18$2;
      }
    } while(0);
    if (__label__ == 8) {
  
      var $14=$error; //@line 109 "mbrowrap.cpp"
      var $call21=_strerror($14); //@line 109 "mbrowrap.cpp"
      __ZL3errPKcz(((__str35615)&4294967295), allocate([$call21,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 109 "mbrowrap.cpp"
      $retval=-1; //@line 110 "mbrowrap.cpp"
      ; //@line 110 "mbrowrap.cpp"
    }
  
    var $15=$retval; //@line 111 "mbrowrap.cpp"
    ;
    return $15; //@line 111 "mbrowrap.cpp"
    return null;
  }
  

  function __ZL11close_pipesPiS_S_($p1, $p2, $p3) {
    ;
    var __label__;
  
    var $p1_addr;
    var $p2_addr;
    var $p3_addr;
    $p1_addr=$p1;
    $p2_addr=$p2;
    $p3_addr=$p3;
    var $0=$p1_addr; //@line 115 "mbrowrap.cpp"
    var $arrayidx=(($0)&4294967295); //@line 115 "mbrowrap.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 115 "mbrowrap.cpp"
    var $call=_close($1); //@line 115 "mbrowrap.cpp"
    var $2=$p1_addr; //@line 116 "mbrowrap.cpp"
    var $arrayidx1=(($2+4)&4294967295); //@line 116 "mbrowrap.cpp"
    var $3=HEAP32[(($arrayidx1)>>2)]; //@line 116 "mbrowrap.cpp"
    var $call2=_close($3); //@line 116 "mbrowrap.cpp"
    var $4=$p2_addr; //@line 117 "mbrowrap.cpp"
    var $arrayidx3=(($4)&4294967295); //@line 117 "mbrowrap.cpp"
    var $5=HEAP32[(($arrayidx3)>>2)]; //@line 117 "mbrowrap.cpp"
    var $call4=_close($5); //@line 117 "mbrowrap.cpp"
    var $6=$p2_addr; //@line 118 "mbrowrap.cpp"
    var $arrayidx5=(($6+4)&4294967295); //@line 118 "mbrowrap.cpp"
    var $7=HEAP32[(($arrayidx5)>>2)]; //@line 118 "mbrowrap.cpp"
    var $call6=_close($7); //@line 118 "mbrowrap.cpp"
    var $8=$p3_addr; //@line 119 "mbrowrap.cpp"
    var $arrayidx7=(($8)&4294967295); //@line 119 "mbrowrap.cpp"
    var $9=HEAP32[(($arrayidx7)>>2)]; //@line 119 "mbrowrap.cpp"
    var $call8=_close($9); //@line 119 "mbrowrap.cpp"
    var $10=$p3_addr; //@line 120 "mbrowrap.cpp"
    var $arrayidx9=(($10+4)&4294967295); //@line 120 "mbrowrap.cpp"
    var $11=HEAP32[(($arrayidx9)>>2)]; //@line 120 "mbrowrap.cpp"
    var $call10=_close($11); //@line 120 "mbrowrap.cpp"
    ;
    return; //@line 121 "mbrowrap.cpp"
    return;
  }
  

  function __Z15SetIndicLettersP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 308 "tr_languages.cpp"
    var $letter_bits=(($0+708)&4294967295); //@line 308 "tr_languages.cpp"
    var $arraydecay=(($letter_bits)&4294967295); //@line 308 "tr_languages.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $arraydecay;
    $stop$ = $dest$ + 256;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 308 "tr_languages.cpp"
    var $1=$tr_addr; //@line 309 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($1, 0, 4, 20); //@line 309 "tr_languages.cpp"
    var $2=$tr_addr; //@line 310 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($2, 0, 62, 77); //@line 310 "tr_languages.cpp"
    var $3=$tr_addr; //@line 311 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($3, 0, 85, 87); //@line 311 "tr_languages.cpp"
    var $4=$tr_addr; //@line 313 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($4, 1, 62, 77); //@line 313 "tr_languages.cpp"
    var $5=$tr_addr; //@line 314 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($5, 1, 85, 87); //@line 314 "tr_languages.cpp"
    var $6=$tr_addr; //@line 316 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($6, 2, 21, 57); //@line 316 "tr_languages.cpp"
    var $7=$tr_addr; //@line 317 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($7, 2, ((__ZZ15SetIndicLettersP10TranslatorE15dev_consonants2)&4294967295)); //@line 317 "tr_languages.cpp"
    var $8=$tr_addr; //@line 319 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($8, 6, 4, 20); //@line 319 "tr_languages.cpp"
    var $9=$tr_addr; //@line 320 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($9, 6, 62, 76); //@line 320 "tr_languages.cpp"
    var $10=$tr_addr; //@line 321 "tr_languages.cpp"
    __ZL18SetLetterBitsRangeP10Translatoriii($10, 6, 85, 87); //@line 321 "tr_languages.cpp"
    var $11=$tr_addr; //@line 323 "tr_languages.cpp"
    var $langopts=(($11)&4294967295); //@line 323 "tr_languages.cpp"
    var $param=(($langopts+24)&4294967295); //@line 323 "tr_languages.cpp"
    var $arrayidx=(($param+20)&4294967295); //@line 323 "tr_languages.cpp"
    HEAP32[(($arrayidx)>>2)]=1; //@line 323 "tr_languages.cpp"
    var $12=$tr_addr; //@line 324 "tr_languages.cpp"
    var $letter_bits_offset=(($12+964)&4294967295); //@line 324 "tr_languages.cpp"
    var $13=HEAP32[(($letter_bits_offset)>>2)]; //@line 324 "tr_languages.cpp"
    var $add=((($13)+77)&4294967295); //@line 324 "tr_languages.cpp"
    var $14=$tr_addr; //@line 324 "tr_languages.cpp"
    var $langopts1=(($14)&4294967295); //@line 324 "tr_languages.cpp"
    var $suffix_add_e=(($langopts1+276)&4294967295); //@line 324 "tr_languages.cpp"
    HEAP32[(($suffix_add_e)>>2)]=$add; //@line 324 "tr_languages.cpp"
    ;
    return; //@line 325 "tr_languages.cpp"
    return;
  }
  

  function __ZL18SetLetterBitsRangeP10Translatoriii($tr, $group, $first, $last) {
    ;
    var __label__;
  
    var $tr_addr;
    var $group_addr;
    var $first_addr;
    var $last_addr;
    var $bits;
    var $ix;
    $tr_addr=$tr;
    $group_addr=$group;
    $first_addr=$first;
    $last_addr=$last;
    var $0=$group_addr; //@line 105 "tr_languages.cpp"
    var $shl=1 << ($0); //@line 105 "tr_languages.cpp"
    $bits=$shl; //@line 105 "tr_languages.cpp"
    var $1=$first_addr; //@line 106 "tr_languages.cpp"
    $ix=$1; //@line 106 "tr_languages.cpp"
    var $2=$ix; //@line 106 "tr_languages.cpp"
    var $3=$last_addr; //@line 106 "tr_languages.cpp"
    var $cmp1=((($2))|0) <= ((($3))|0); //@line 106 "tr_languages.cpp"
    if ($cmp1) { __label__ = 1;; } else { __label__ = 2;; } //@line 106 "tr_languages.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $4=$bits; //@line 108 "tr_languages.cpp"
          var $5=$ix; //@line 108 "tr_languages.cpp"
          var $6=$tr_addr; //@line 108 "tr_languages.cpp"
          var $letter_bits=(($6+708)&4294967295); //@line 108 "tr_languages.cpp"
          var $arrayidx=(($letter_bits+$5)&4294967295); //@line 108 "tr_languages.cpp"
          var $7=HEAPU8[($arrayidx)]; //@line 108 "tr_languages.cpp"
          var $conv=((($7))&255); //@line 108 "tr_languages.cpp"
          var $or=($conv) | ($4); //@line 108 "tr_languages.cpp"
          var $conv1=((($or)) & 255); //@line 108 "tr_languages.cpp"
          HEAP8[($arrayidx)]=$conv1; //@line 108 "tr_languages.cpp"
          var $8=$ix; //@line 106 "tr_languages.cpp"
          var $inc=((($8)+1)&4294967295); //@line 106 "tr_languages.cpp"
          $ix=$inc; //@line 106 "tr_languages.cpp"
          var $9=$ix; //@line 106 "tr_languages.cpp"
          var $10=$last_addr; //@line 106 "tr_languages.cpp"
          var $cmp=((($9))|0) <= ((($10))|0); //@line 106 "tr_languages.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $for_body$$for_end$2; } //@line 106 "tr_languages.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 110 "tr_languages.cpp"
    return;
  }
  

  function __ZL13SetLetterBitsP10TranslatoriPKc($tr, $group, $string) {
    ;
    var __label__;
  
    var $tr_addr;
    var $group_addr;
    var $string_addr;
    var $bits;
    var $c;
    $tr_addr=$tr;
    $group_addr=$group;
    $string_addr=$string;
    var $0=$group_addr; //@line 95 "tr_languages.cpp"
    var $shl=1 << ($0); //@line 95 "tr_languages.cpp"
    $bits=$shl; //@line 95 "tr_languages.cpp"
    var $1=$string_addr; //@line 96 "tr_languages.cpp"
    var $incdec_ptr1=(($1+1)&4294967295); //@line 96 "tr_languages.cpp"
    $string_addr=$incdec_ptr1; //@line 96 "tr_languages.cpp"
    var $2=HEAPU8[($1)]; //@line 96 "tr_languages.cpp"
    $c=$2; //@line 96 "tr_languages.cpp"
    var $conv3=((($2))&255); //@line 96 "tr_languages.cpp"
    var $cmp4=((($conv3))|0)!=0; //@line 96 "tr_languages.cpp"
    if ($cmp4) { __label__ = 1;; } else { __label__ = 2;; } //@line 96 "tr_languages.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $3=$bits; //@line 97 "tr_languages.cpp"
          var $4=$c; //@line 97 "tr_languages.cpp"
          var $idxprom=((($4))&255); //@line 97 "tr_languages.cpp"
          var $5=$tr_addr; //@line 97 "tr_languages.cpp"
          var $letter_bits=(($5+708)&4294967295); //@line 97 "tr_languages.cpp"
          var $arrayidx=(($letter_bits+$idxprom)&4294967295); //@line 97 "tr_languages.cpp"
          var $6=HEAPU8[($arrayidx)]; //@line 97 "tr_languages.cpp"
          var $conv1=((($6))&255); //@line 97 "tr_languages.cpp"
          var $or=($conv1) | ($3); //@line 97 "tr_languages.cpp"
          var $conv2=((($or)) & 255); //@line 97 "tr_languages.cpp"
          HEAP8[($arrayidx)]=$conv2; //@line 97 "tr_languages.cpp"
          var $7=$string_addr; //@line 96 "tr_languages.cpp"
          var $incdec_ptr=(($7+1)&4294967295); //@line 96 "tr_languages.cpp"
          $string_addr=$incdec_ptr; //@line 96 "tr_languages.cpp"
          var $8=HEAPU8[($7)]; //@line 96 "tr_languages.cpp"
          $c=$8; //@line 96 "tr_languages.cpp"
          var $conv=((($8))&255); //@line 96 "tr_languages.cpp"
          var $cmp=((($conv))|0)!=0; //@line 96 "tr_languages.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 96 "tr_languages.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 98 "tr_languages.cpp"
    return;
  }
  

  function __Z15SetupTranslatorP10TranslatorPKsPKh($tr, $lengths, $amps) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $lengths_addr;
    var $amps_addr;
    $tr_addr=$tr;
    $lengths_addr=$lengths;
    $amps_addr=$amps;
    var $0=$lengths_addr; //@line 330 "tr_languages.cpp"
    var $cmp=((($0))|0)!=0; //@line 330 "tr_languages.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 330 "tr_languages.cpp"
    if (__label__ == 1) {
  
      var $1=$tr_addr; //@line 331 "tr_languages.cpp"
      var $stress_lengths=(($1+676)&4294967295); //@line 331 "tr_languages.cpp"
      var $arraydecay=(($stress_lengths)&4294967295); //@line 331 "tr_languages.cpp"
      var $2=$arraydecay; //@line 331 "tr_languages.cpp"
      var $3=$lengths_addr; //@line 331 "tr_languages.cpp"
      var $4=$3; //@line 331 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $4;
      $dest$ = $2;
      $stop$ = $src$ + 16;
      if (($dest$%4) == ($src$%4) && 16 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 331 "tr_languages.cpp"
      var $_pr=$amps_addr; //@line 332 "tr_languages.cpp"
      __lastLabel__ = 1; ; //@line 331 "tr_languages.cpp"
    }
  
    var $5=__lastLabel__ == 1 ? $_pr : ($amps); //@line 332 "tr_languages.cpp"
    var $cmp1=((($5))|0)!=0; //@line 332 "tr_languages.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 332 "tr_languages.cpp"
    if (__label__ == 3) {
  
      var $6=$tr_addr; //@line 333 "tr_languages.cpp"
      var $stress_amps=(($6+660)&4294967295); //@line 333 "tr_languages.cpp"
      var $arraydecay3=(($stress_amps)&4294967295); //@line 333 "tr_languages.cpp"
      var $7=$amps_addr; //@line 333 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $7;
      $dest$ = $arraydecay3;
      $stop$ = $src$ + 8;
      if (($dest$%4) == ($src$%4) && 8 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 333 "tr_languages.cpp"
      ; //@line 333 "tr_languages.cpp"
    }
  
    ;
    return; //@line 334 "tr_languages.cpp"
    return;
  }
  

  function __Z16SelectTranslatorPKc($name) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $name_addr;
    var $name2;
    var $tr;
    $name_addr=$name;
    $name2=0; //@line 339 "tr_languages.cpp"
    var $0=$name_addr; //@line 352 "tr_languages.cpp"
    var $1=HEAP8[($0)]; //@line 352 "tr_languages.cpp"
    var $conv2=(tempInt=(($1)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "tr_languages.cpp"
    var $cmp3=((($conv2))|0)!=0; //@line 352 "tr_languages.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 2;; } //@line 352 "tr_languages.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$name2; //@line 353 "tr_languages.cpp"
          var $shl=((($2)*256)&4294967295); //@line 353 "tr_languages.cpp"
          var $3=$name_addr; //@line 353 "tr_languages.cpp"
          var $incdec_ptr=(($3+1)&4294967295); //@line 353 "tr_languages.cpp"
          $name_addr=$incdec_ptr; //@line 353 "tr_languages.cpp"
          var $4=HEAP8[($3)]; //@line 353 "tr_languages.cpp"
          var $conv1=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 353 "tr_languages.cpp"
          var $add=((($conv1)+($shl))&4294967295); //@line 353 "tr_languages.cpp"
          $name2=$add; //@line 353 "tr_languages.cpp"
          var $5=$name_addr; //@line 352 "tr_languages.cpp"
          var $6=HEAP8[($5)]; //@line 352 "tr_languages.cpp"
          var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "tr_languages.cpp"
          var $cmp=((($conv))|0)!=0; //@line 352 "tr_languages.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $while_body$$while_end$2; } //@line 352 "tr_languages.cpp"
        }
      }
    } while(0);
  
    var $call=__ZL13NewTranslatorv(); //@line 355 "tr_languages.cpp"
    $tr=$call; //@line 355 "tr_languages.cpp"
    var $7=$name2; //@line 357 "tr_languages.cpp"
    if ($7 == 24934) {
      __label__ = 3;;
    }
    else if ($7 == 24941) {
      __label__ = 4;;
    }
    else if ($7 == 24946) {
      __label__ = 5;;
    }
    else if ($7 == 25191) {
      __label__ = 6;;
    }
    else if ($7 == 25198) {
      __label__ = 7;;
    }
    else if ($7 == 25465) {
      __label__ = 8;;
    }
    else if ($7 == 25697) {
      __label__ = 9;;
    }
    else if ($7 == 25701) {
      __label__ = 10;;
    }
    else if ($7 == 25718) {
      __label__ = 11;;
    }
    else if ($7 == 25966) {
      __label__ = 12;;
    }
    else if ($7 == 25964) {
      __label__ = 13;;
    }
    else if ($7 == 6779491) {
      __label__ = 13;;
    }
    else if ($7 == 25967) {
      __label__ = 15;;
    }
    else if ($7 == 25971) {
      __label__ = 16;;
    }
    else if ($7 == 25441) {
      __label__ = 16;;
    }
    else if ($7 == 7364976) {
      __label__ = 16;;
    }
    else if ($7 == 25973) {
      __label__ = 21;;
    }
    else if ($7 == 26209) {
      __label__ = 22;;
    }
    else if ($7 == 25972) {
      __label__ = 23;;
    }
    else if ($7 == 26217) {
      __label__ = 24;;
    }
    else if ($7 == 26226) {
      __label__ = 25;;
    }
    else if ($7 == 26729) {
      __label__ = 26;;
    }
    else if ($7 == 28261) {
      __label__ = 26;;
    }
    else if ($7 == 28769) {
      __label__ = 26;;
    }
    else if ($7 == 26738) {
      __label__ = 29;;
    }
    else if ($7 == 25203) {
      __label__ = 29;;
    }
    else if ($7 == 29554) {
      __label__ = 29;;
    }
    else if ($7 == 26740) {
      __label__ = 33;;
    }
    else if ($7 == 26741) {
      __label__ = 34;;
    }
    else if ($7 == 26745) {
      __label__ = 35;;
    }
    else if ($7 == 26980) {
      __label__ = 36;;
    }
    else if ($7 == 26995) {
      __label__ = 37;;
    }
    else if ($7 == 26996) {
      __label__ = 38;;
    }
    else if ($7 == 6972015) {
      __label__ = 39;;
    }
    else if ($7 == 27489) {
      __label__ = 40;;
    }
    else if ($7 == 27503) {
      __label__ = 41;;
    }
    else if ($7 == 27509) {
      __label__ = 42;;
    }
    else if ($7 == 27745) {
      __label__ = 43;;
    }
    else if ($7 == 27766) {
      __label__ = 44;;
    }
    else if ($7 == 28011) {
      __label__ = 45;;
    }
    else if ($7 == 28268) {
      __label__ = 46;;
    }
    else if ($7 == 28271) {
      __label__ = 47;;
    }
    else if ($7 == 28525) {
      __label__ = 48;;
    }
    else if ($7 == 28780) {
      __label__ = 49;;
    }
    else if ($7 == 28788) {
      __label__ = 50;;
    }
    else if ($7 == 29295) {
      __label__ = 51;;
    }
    else if ($7 == 29301) {
      __label__ = 52;;
    }
    else if ($7 == 29303) {
      __label__ = 53;;
    }
    else if ($7 == 29547) {
      __label__ = 54;;
    }
    else if ($7 == 25459) {
      __label__ = 54;;
    }
    else if ($7 == 29545) {
      __label__ = 57;;
    }
    else if ($7 == 29548) {
      __label__ = 58;;
    }
    else if ($7 == 29553) {
      __label__ = 59;;
    }
    else if ($7 == 29558) {
      __label__ = 60;;
    }
    else if ($7 == 29559) {
      __label__ = 61;;
    }
    else if ($7 == 29806) {
      __label__ = 61;;
    }
    else if ($7 == 29793) {
      __label__ = 62;;
    }
    else if ($7 == 28012) {
      __label__ = 62;;
    }
    else if ($7 == 27502) {
      __label__ = 62;;
    }
    else if ($7 == 28018) {
      __label__ = 62;;
    }
    else if ($7 == 29797) {
      __label__ = 62;;
    }
    else if ($7 == 29810) {
      __label__ = 73;;
    }
    else if ($7 == 30066) {
      __label__ = 74;;
    }
    else if ($7 == 30313) {
      __label__ = 75;;
    }
    else if ($7 == 30575) {
      __label__ = 76;;
    }
    else if ($7 == 31336) {
      __label__ = 77;;
    }
    else if ($7 == 8022137) {
      __label__ = 77;;
    }
    else {
    __label__ = 79;;
    }
    
    $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6: do { 
      if (__label__ == 79) {
  
        var $495=$tr; //@line 1330 "tr_languages.cpp"
        var $langopts756=(($495)&4294967295); //@line 1330 "tr_languages.cpp"
        var $param757=(($langopts756+24)&4294967295); //@line 1330 "tr_languages.cpp"
        var $arrayidx758=(($param757+20)&4294967295); //@line 1330 "tr_languages.cpp"
        HEAP32[(($arrayidx758)>>2)]=1; //@line 1330 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1331 "tr_languages.cpp"
      }
      else if (__label__ == 3) {
  
        var $8=$tr; //@line 362 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($8, ((__ZZ16SelectTranslatorPKcE17stress_lengths_af)&4294967295), 0); //@line 362 "tr_languages.cpp"
        var $9=$tr; //@line 364 "tr_languages.cpp"
        var $langopts=(($9)&4294967295); //@line 364 "tr_languages.cpp"
        var $stress_rule=(($langopts+8)&4294967295); //@line 364 "tr_languages.cpp"
        HEAP32[(($stress_rule)>>2)]=0; //@line 364 "tr_languages.cpp"
        var $10=$tr; //@line 365 "tr_languages.cpp"
        var $langopts2=(($10)&4294967295); //@line 365 "tr_languages.cpp"
        var $vowel_pause=(($langopts2+4)&4294967295); //@line 365 "tr_languages.cpp"
        HEAP32[(($vowel_pause)>>2)]=48; //@line 365 "tr_languages.cpp"
        var $11=$tr; //@line 366 "tr_languages.cpp"
        var $langopts3=(($11)&4294967295); //@line 366 "tr_languages.cpp"
        var $param=(($langopts3+24)&4294967295); //@line 366 "tr_languages.cpp"
        var $arrayidx=(($param+4)&4294967295); //@line 366 "tr_languages.cpp"
        HEAP32[(($arrayidx)>>2)]=1; //@line 366 "tr_languages.cpp"
        var $12=$tr; //@line 367 "tr_languages.cpp"
        var $langopts4=(($12)&4294967295); //@line 367 "tr_languages.cpp"
        var $param5=(($langopts4+24)&4294967295); //@line 367 "tr_languages.cpp"
        var $arrayidx6=(($param5+12)&4294967295); //@line 367 "tr_languages.cpp"
        HEAP32[(($arrayidx6)>>2)]=1; //@line 367 "tr_languages.cpp"
        var $13=$tr; //@line 368 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($13, 121); //@line 368 "tr_languages.cpp"
        var $14=$tr; //@line 370 "tr_languages.cpp"
        var $langopts7=(($14)&4294967295); //@line 370 "tr_languages.cpp"
        var $numbers=(($langopts7+184)&4294967295); //@line 370 "tr_languages.cpp"
        HEAP32[(($numbers)>>2)]=16779472; //@line 370 "tr_languages.cpp"
        var $15=$tr; //@line 371 "tr_languages.cpp"
        var $langopts8=(($15)&4294967295); //@line 371 "tr_languages.cpp"
        var $accents=(($langopts8+220)&4294967295); //@line 371 "tr_languages.cpp"
        HEAP32[(($accents)>>2)]=1; //@line 371 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 373 "tr_languages.cpp"
      }
      else if (__label__ == 4) {
  
        var $16=$tr; //@line 377 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($16, ((__ZZ16SelectTranslatorPKcE17stress_lengths_fr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_fr)&4294967295)); //@line 377 "tr_languages.cpp"
        var $17=$tr; //@line 378 "tr_languages.cpp"
        var $langopts10=(($17)&4294967295); //@line 378 "tr_languages.cpp"
        var $stress_rule11=(($langopts10+8)&4294967295); //@line 378 "tr_languages.cpp"
        HEAP32[(($stress_rule11)>>2)]=0; //@line 378 "tr_languages.cpp"
        var $18=$tr; //@line 379 "tr_languages.cpp"
        var $langopts12=(($18)&4294967295); //@line 379 "tr_languages.cpp"
        var $stress_flags=(($langopts12+12)&4294967295); //@line 379 "tr_languages.cpp"
        HEAP32[(($stress_flags)>>2)]=36; //@line 379 "tr_languages.cpp"
        var $19=$tr; //@line 380 "tr_languages.cpp"
        var $langopts13=(($19)&4294967295); //@line 380 "tr_languages.cpp"
        var $length_mods=(($langopts13+176)&4294967295); //@line 380 "tr_languages.cpp"
        var $20=HEAP32[(($length_mods)>>2)]; //@line 380 "tr_languages.cpp"
        var $21=$tr; //@line 380 "tr_languages.cpp"
        var $langopts14=(($21)&4294967295); //@line 380 "tr_languages.cpp"
        var $length_mods0=(($langopts14+180)&4294967295); //@line 380 "tr_languages.cpp"
        HEAP32[(($length_mods0)>>2)]=$20; //@line 380 "tr_languages.cpp"
        var $22=$tr; //@line 381 "tr_languages.cpp"
        var $langopts15=(($22)&4294967295); //@line 381 "tr_languages.cpp"
        var $param16=(($langopts15+24)&4294967295); //@line 381 "tr_languages.cpp"
        var $arrayidx17=(($param16+20)&4294967295); //@line 381 "tr_languages.cpp"
        HEAP32[(($arrayidx17)>>2)]=1; //@line 381 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 383 "tr_languages.cpp"
      }
      else if (__label__ == 5) {
  
        var $23=$tr; //@line 387 "tr_languages.cpp"
        var $letter_bits_offset=(($23+964)&4294967295); //@line 387 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset)>>2)]=1536; //@line 387 "tr_languages.cpp"
        var $24=$tr; //@line 388 "tr_languages.cpp"
        var $langopts19=(($24)&4294967295); //@line 388 "tr_languages.cpp"
        var $numbers20=(($langopts19+184)&4294967295); //@line 388 "tr_languages.cpp"
        HEAP32[(($numbers20)>>2)]=2884720; //@line 388 "tr_languages.cpp"
        var $25=$tr; //@line 389 "tr_languages.cpp"
        var $langopts21=(($25)&4294967295); //@line 389 "tr_languages.cpp"
        var $param22=(($langopts21+24)&4294967295); //@line 389 "tr_languages.cpp"
        var $arrayidx23=(($param22+20)&4294967295); //@line 389 "tr_languages.cpp"
        HEAP32[(($arrayidx23)>>2)]=1; //@line 389 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 390 "tr_languages.cpp"
      }
      else if (__label__ == 6) {
  
        var $26=$tr; //@line 394 "tr_languages.cpp"
        __ZL18SetCyrillicLettersP10Translator($26); //@line 394 "tr_languages.cpp"
        var $27=$tr; //@line 395 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($27, 42); //@line 395 "tr_languages.cpp"
        var $28=$tr; //@line 396 "tr_languages.cpp"
        var $langopts25=(($28)&4294967295); //@line 396 "tr_languages.cpp"
        var $param26=(($langopts25+24)&4294967295); //@line 396 "tr_languages.cpp"
        var $arrayidx27=(($param26+20)&4294967295); //@line 396 "tr_languages.cpp"
        HEAP32[(($arrayidx27)>>2)]=1074; //@line 396 "tr_languages.cpp"
        var $29=$tr; //@line 397 "tr_languages.cpp"
        var $langopts28=(($29)&4294967295); //@line 397 "tr_languages.cpp"
        var $param29=(($langopts28+24)&4294967295); //@line 397 "tr_languages.cpp"
        var $arrayidx30=(($param29+16)&4294967295); //@line 397 "tr_languages.cpp"
        HEAP32[(($arrayidx30)>>2)]=23; //@line 397 "tr_languages.cpp"
        var $30=$tr; //@line 398 "tr_languages.cpp"
        var $langopts31=(($30)&4294967295); //@line 398 "tr_languages.cpp"
        var $param32=(($langopts31+24)&4294967295); //@line 398 "tr_languages.cpp"
        var $arrayidx33=(($param32+40)&4294967295); //@line 398 "tr_languages.cpp"
        HEAP32[(($arrayidx33)>>2)]=2; //@line 398 "tr_languages.cpp"
        var $31=$tr; //@line 399 "tr_languages.cpp"
        var $langopts34=(($31)&4294967295); //@line 399 "tr_languages.cpp"
        var $stress_rule35=(($langopts34+8)&4294967295); //@line 399 "tr_languages.cpp"
        HEAP32[(($stress_rule35)>>2)]=2; //@line 399 "tr_languages.cpp"
        var $32=$tr; //@line 400 "tr_languages.cpp"
        var $langopts36=(($32)&4294967295); //@line 400 "tr_languages.cpp"
        var $numbers37=(($langopts36+184)&4294967295); //@line 400 "tr_languages.cpp"
        HEAP32[(($numbers37)>>2)]=184554728; //@line 400 "tr_languages.cpp"
        var $33=$tr; //@line 401 "tr_languages.cpp"
        var $langopts38=(($33)&4294967295); //@line 401 "tr_languages.cpp"
        var $thousands_sep=(($langopts38+204)&4294967295); //@line 401 "tr_languages.cpp"
        HEAP32[(($thousands_sep)>>2)]=32; //@line 401 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 403 "tr_languages.cpp"
      }
      else if (__label__ == 7) {
  
        var $34=$tr; //@line 410 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($34, ((__ZZ16SelectTranslatorPKcE17stress_lengths_bn)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_bn)&4294967295)); //@line 410 "tr_languages.cpp"
        var $35=$tr; //@line 411 "tr_languages.cpp"
        var $langopts40=(($35)&4294967295); //@line 411 "tr_languages.cpp"
        var $length_mods41=(($langopts40+176)&4294967295); //@line 411 "tr_languages.cpp"
        var $36=HEAP32[(($length_mods41)>>2)]; //@line 411 "tr_languages.cpp"
        var $37=$tr; //@line 411 "tr_languages.cpp"
        var $langopts42=(($37)&4294967295); //@line 411 "tr_languages.cpp"
        var $length_mods043=(($langopts42+180)&4294967295); //@line 411 "tr_languages.cpp"
        HEAP32[(($length_mods043)>>2)]=$36; //@line 411 "tr_languages.cpp"
        var $38=$tr; //@line 413 "tr_languages.cpp"
        var $langopts44=(($38)&4294967295); //@line 413 "tr_languages.cpp"
        var $stress_rule45=(($langopts44+8)&4294967295); //@line 413 "tr_languages.cpp"
        HEAP32[(($stress_rule45)>>2)]=0; //@line 413 "tr_languages.cpp"
        var $39=$tr; //@line 414 "tr_languages.cpp"
        var $langopts46=(($39)&4294967295); //@line 414 "tr_languages.cpp"
        var $stress_flags47=(($langopts46+12)&4294967295); //@line 414 "tr_languages.cpp"
        HEAP32[(($stress_flags47)>>2)]=65540; //@line 414 "tr_languages.cpp"
        var $40=$tr; //@line 415 "tr_languages.cpp"
        var $letter_bits_offset48=(($40+964)&4294967295); //@line 415 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset48)>>2)]=2432; //@line 415 "tr_languages.cpp"
        var $41=$tr; //@line 416 "tr_languages.cpp"
        __Z15SetIndicLettersP10Translator($41); //@line 416 "tr_languages.cpp"
        var $42=$tr; //@line 417 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($42, 4, 62, 76); //@line 417 "tr_languages.cpp"
        var $43=$tr; //@line 419 "tr_languages.cpp"
        var $langopts49=(($43)&4294967295); //@line 419 "tr_languages.cpp"
        var $numbers50=(($langopts49+184)&4294967295); //@line 419 "tr_languages.cpp"
        HEAP32[(($numbers50)>>2)]=1; //@line 419 "tr_languages.cpp"
        var $44=$tr; //@line 420 "tr_languages.cpp"
        var $langopts51=(($44)&4294967295); //@line 420 "tr_languages.cpp"
        var $break_numbers=(($langopts51+192)&4294967295); //@line 420 "tr_languages.cpp"
        HEAP32[(($break_numbers)>>2)]=613567144; //@line 420 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 422 "tr_languages.cpp"
      }
      else if (__label__ == 8) {
  
        var $45=$tr; //@line 429 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($45, ((__ZZ16SelectTranslatorPKcE17stress_lengths_cy)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_cy)&4294967295)); //@line 429 "tr_languages.cpp"
        var $46=HEAP32[((((_charsets+56)&4294967295))>>2)]; //@line 431 "tr_languages.cpp"
        var $47=$tr; //@line 431 "tr_languages.cpp"
        var $charset_a0=(($47+696)&4294967295); //@line 431 "tr_languages.cpp"
        HEAP32[(($charset_a0)>>2)]=$46; //@line 431 "tr_languages.cpp"
        var $48=$tr; //@line 433 "tr_languages.cpp"
        var $langopts53=(($48)&4294967295); //@line 433 "tr_languages.cpp"
        var $stress_rule54=(($langopts53+8)&4294967295); //@line 433 "tr_languages.cpp"
        HEAP32[(($stress_rule54)>>2)]=2; //@line 433 "tr_languages.cpp"
        var $49=$tr; //@line 437 "tr_languages.cpp"
        var $langopts55=(($49)&4294967295); //@line 437 "tr_languages.cpp"
        var $stress_flags56=(($langopts55+12)&4294967295); //@line 437 "tr_languages.cpp"
        HEAP32[(($stress_flags56)>>2)]=22; //@line 437 "tr_languages.cpp"
        var $50=$tr; //@line 438 "tr_languages.cpp"
        var $langopts57=(($50)&4294967295); //@line 438 "tr_languages.cpp"
        var $unstressed_wd1=(($langopts57+16)&4294967295); //@line 438 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1)>>2)]=0; //@line 438 "tr_languages.cpp"
        var $51=$tr; //@line 439 "tr_languages.cpp"
        var $langopts58=(($51)&4294967295); //@line 439 "tr_languages.cpp"
        var $unstressed_wd2=(($langopts58+20)&4294967295); //@line 439 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2)>>2)]=2; //@line 439 "tr_languages.cpp"
        var $52=$tr; //@line 440 "tr_languages.cpp"
        var $langopts59=(($52)&4294967295); //@line 440 "tr_languages.cpp"
        var $param60=(($langopts59+24)&4294967295); //@line 440 "tr_languages.cpp"
        var $arrayidx61=(($param60+28)&4294967295); //@line 440 "tr_languages.cpp"
        HEAP32[(($arrayidx61)>>2)]=120; //@line 440 "tr_languages.cpp"
        var $53=$tr; //@line 442 "tr_languages.cpp"
        var $langopts62=(($53)&4294967295); //@line 442 "tr_languages.cpp"
        var $numbers63=(($langopts62+184)&4294967295); //@line 442 "tr_languages.cpp"
        HEAP32[(($numbers63)>>2)]=1024; //@line 442 "tr_languages.cpp"
        var $54=$tr; //@line 444 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($54, 119); //@line 444 "tr_languages.cpp"
        var $55=$tr; //@line 445 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($55, 121); //@line 445 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 447 "tr_languages.cpp"
      }
      else if (__label__ == 9) {
  
        var $56=$tr; //@line 452 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($56, ((__ZZ16SelectTranslatorPKcE17stress_lengths_da)&4294967295), 0); //@line 452 "tr_languages.cpp"
        var $57=$tr; //@line 454 "tr_languages.cpp"
        var $langopts65=(($57)&4294967295); //@line 454 "tr_languages.cpp"
        var $stress_rule66=(($langopts65+8)&4294967295); //@line 454 "tr_languages.cpp"
        HEAP32[(($stress_rule66)>>2)]=0; //@line 454 "tr_languages.cpp"
        var $58=$tr; //@line 455 "tr_languages.cpp"
        var $langopts67=(($58)&4294967295); //@line 455 "tr_languages.cpp"
        var $param68=(($langopts67+24)&4294967295); //@line 455 "tr_languages.cpp"
        var $arrayidx69=(($param68+12)&4294967295); //@line 455 "tr_languages.cpp"
        HEAP32[(($arrayidx69)>>2)]=1; //@line 455 "tr_languages.cpp"
        var $59=$tr; //@line 456 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($59, 121); //@line 456 "tr_languages.cpp"
        var $60=$tr; //@line 457 "tr_languages.cpp"
        var $langopts70=(($60)&4294967295); //@line 457 "tr_languages.cpp"
        var $numbers71=(($langopts70+184)&4294967295); //@line 457 "tr_languages.cpp"
        HEAP32[(($numbers71)>>2)]=184618072; //@line 457 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 459 "tr_languages.cpp"
      }
      else if (__label__ == 10) {
  
        var $61=$tr; //@line 466 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($61, ((__ZZ16SelectTranslatorPKcE17stress_lengths_de)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_de)&4294967295)); //@line 466 "tr_languages.cpp"
        var $62=$tr; //@line 467 "tr_languages.cpp"
        var $langopts73=(($62)&4294967295); //@line 467 "tr_languages.cpp"
        var $stress_rule74=(($langopts73+8)&4294967295); //@line 467 "tr_languages.cpp"
        HEAP32[(($stress_rule74)>>2)]=0; //@line 467 "tr_languages.cpp"
        var $63=$tr; //@line 468 "tr_languages.cpp"
        var $langopts75=(($63)&4294967295); //@line 468 "tr_languages.cpp"
        var $word_gap=(($langopts75)&4294967295); //@line 468 "tr_languages.cpp"
        HEAP32[(($word_gap)>>2)]=8; //@line 468 "tr_languages.cpp"
        var $64=$tr; //@line 469 "tr_languages.cpp"
        var $langopts76=(($64)&4294967295); //@line 469 "tr_languages.cpp"
        var $vowel_pause77=(($langopts76+4)&4294967295); //@line 469 "tr_languages.cpp"
        HEAP32[(($vowel_pause77)>>2)]=48; //@line 469 "tr_languages.cpp"
        var $65=$tr; //@line 470 "tr_languages.cpp"
        var $langopts78=(($65)&4294967295); //@line 470 "tr_languages.cpp"
        var $param79=(($langopts78+24)&4294967295); //@line 470 "tr_languages.cpp"
        var $arrayidx80=(($param79+12)&4294967295); //@line 470 "tr_languages.cpp"
        HEAP32[(($arrayidx80)>>2)]=1; //@line 470 "tr_languages.cpp"
        var $66=$tr; //@line 471 "tr_languages.cpp"
        var $langopts81=(($66)&4294967295); //@line 471 "tr_languages.cpp"
        var $param82=(($langopts81+24)&4294967295); //@line 471 "tr_languages.cpp"
        var $arrayidx83=(($param82+16)&4294967295); //@line 471 "tr_languages.cpp"
        HEAP32[(($arrayidx83)>>2)]=16; //@line 471 "tr_languages.cpp"
        var $67=$tr; //@line 472 "tr_languages.cpp"
        var $langopts84=(($67)&4294967295); //@line 472 "tr_languages.cpp"
        var $param85=(($langopts84+24)&4294967295); //@line 472 "tr_languages.cpp"
        var $arrayidx86=(($param85+72)&4294967295); //@line 472 "tr_languages.cpp"
        HEAP32[(($arrayidx86)>>2)]=87; //@line 472 "tr_languages.cpp"
        var $68=$tr; //@line 474 "tr_languages.cpp"
        var $langopts87=(($68)&4294967295); //@line 474 "tr_languages.cpp"
        var $numbers88=(($langopts87+184)&4294967295); //@line 474 "tr_languages.cpp"
        HEAP32[(($numbers88)>>2)]=16846872; //@line 474 "tr_languages.cpp"
        var $69=$tr; //@line 476 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($69, 121); //@line 476 "tr_languages.cpp"
        var $70=$tr; //@line 477 "tr_languages.cpp"
        var $langopts89=(($70)&4294967295); //@line 477 "tr_languages.cpp"
        var $param90=(($langopts89+24)&4294967295); //@line 477 "tr_languages.cpp"
        var $arrayidx91=(($param90+20)&4294967295); //@line 477 "tr_languages.cpp"
        HEAP32[(($arrayidx91)>>2)]=2; //@line 477 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 479 "tr_languages.cpp"
      }
      else if (__label__ == 11) {
  
        var $71=$tr; //@line 483 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($71, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 483 "tr_languages.cpp"
        var $72=$tr; //@line 484 "tr_languages.cpp"
        var $langopts93=(($72)&4294967295); //@line 484 "tr_languages.cpp"
        var $param94=(($langopts93+24)&4294967295); //@line 484 "tr_languages.cpp"
        var $arrayidx95=(($param94+20)&4294967295); //@line 484 "tr_languages.cpp"
        HEAP32[(($arrayidx95)>>2)]=1; //@line 484 "tr_languages.cpp"
        var $73=$tr; //@line 485 "tr_languages.cpp"
        var $langopts96=(($73)&4294967295); //@line 485 "tr_languages.cpp"
        var $length_mods97=(($langopts96+176)&4294967295); //@line 485 "tr_languages.cpp"
        var $74=HEAP32[(($length_mods97)>>2)]; //@line 485 "tr_languages.cpp"
        var $75=$tr; //@line 485 "tr_languages.cpp"
        var $langopts98=(($75)&4294967295); //@line 485 "tr_languages.cpp"
        var $length_mods099=(($langopts98+180)&4294967295); //@line 485 "tr_languages.cpp"
        HEAP32[(($length_mods099)>>2)]=$74; //@line 485 "tr_languages.cpp"
        var $76=$tr; //@line 486 "tr_languages.cpp"
        var $letter_bits_offset100=(($76+964)&4294967295); //@line 486 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset100)>>2)]=1920; //@line 486 "tr_languages.cpp"
        var $77=$tr; //@line 487 "tr_languages.cpp"
        var $langopts101=(($77)&4294967295); //@line 487 "tr_languages.cpp"
        var $stress_rule102=(($langopts101+8)&4294967295); //@line 487 "tr_languages.cpp"
        HEAP32[(($stress_rule102)>>2)]=0; //@line 487 "tr_languages.cpp"
        var $78=$tr; //@line 488 "tr_languages.cpp"
        var $langopts103=(($78)&4294967295); //@line 488 "tr_languages.cpp"
        var $stress_flags104=(($langopts103+12)&4294967295); //@line 488 "tr_languages.cpp"
        HEAP32[(($stress_flags104)>>2)]=65540; //@line 488 "tr_languages.cpp"
        var $79=$tr; //@line 489 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($79, 1, 38, 48); //@line 489 "tr_languages.cpp"
        var $80=$tr; //@line 490 "tr_languages.cpp"
        var $langopts105=(($80)&4294967295); //@line 490 "tr_languages.cpp"
        var $break_numbers106=(($langopts105+192)&4294967295); //@line 490 "tr_languages.cpp"
        HEAP32[(($break_numbers106)>>2)]=5288; //@line 490 "tr_languages.cpp"
        var $81=$tr; //@line 491 "tr_languages.cpp"
        var $langopts107=(($81)&4294967295); //@line 491 "tr_languages.cpp"
        var $numbers108=(($langopts107+184)&4294967295); //@line 491 "tr_languages.cpp"
        HEAP32[(($numbers108)>>2)]=1; //@line 491 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 493 "tr_languages.cpp"
      }
      else if (__label__ == 12) {
  
        var $82=$tr; //@line 498 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($82, ((__ZZ16SelectTranslatorPKcE17stress_lengths_en)&4294967295), 0); //@line 498 "tr_languages.cpp"
        var $83=$tr; //@line 500 "tr_languages.cpp"
        var $langopts110=(($83)&4294967295); //@line 500 "tr_languages.cpp"
        var $stress_rule111=(($langopts110+8)&4294967295); //@line 500 "tr_languages.cpp"
        HEAP32[(($stress_rule111)>>2)]=0; //@line 500 "tr_languages.cpp"
        var $84=$tr; //@line 501 "tr_languages.cpp"
        var $langopts112=(($84)&4294967295); //@line 501 "tr_languages.cpp"
        var $stress_flags113=(($langopts112+12)&4294967295); //@line 501 "tr_languages.cpp"
        HEAP32[(($stress_flags113)>>2)]=8; //@line 501 "tr_languages.cpp"
        var $85=$tr; //@line 502 "tr_languages.cpp"
        var $langopts114=(($85)&4294967295); //@line 502 "tr_languages.cpp"
        var $numbers115=(($langopts114+184)&4294967295); //@line 502 "tr_languages.cpp"
        HEAP32[(($numbers115)>>2)]=16779328; //@line 502 "tr_languages.cpp"
        var $86=$tr; //@line 503 "tr_languages.cpp"
        var $langopts116=(($86)&4294967295); //@line 503 "tr_languages.cpp"
        var $param117=(($langopts116+24)&4294967295); //@line 503 "tr_languages.cpp"
        var $arrayidx118=(($param117+44)&4294967295); //@line 503 "tr_languages.cpp"
        HEAP32[(($arrayidx118)>>2)]=2; //@line 503 "tr_languages.cpp"
        var $87=$tr; //@line 504 "tr_languages.cpp"
        var $langopts119=(($87)&4294967295); //@line 504 "tr_languages.cpp"
        var $suffix_add_e=(($langopts119+276)&4294967295); //@line 504 "tr_languages.cpp"
        HEAP32[(($suffix_add_e)>>2)]=101; //@line 504 "tr_languages.cpp"
        var $88=$tr; //@line 505 "tr_languages.cpp"
        var $langopts120=(($88)&4294967295); //@line 505 "tr_languages.cpp"
        var $param121=(($langopts120+24)&4294967295); //@line 505 "tr_languages.cpp"
        var $arrayidx122=(($param121+20)&4294967295); //@line 505 "tr_languages.cpp"
        HEAP32[(($arrayidx122)>>2)]=2; //@line 505 "tr_languages.cpp"
        var $89=$tr; //@line 506 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($89, 6, ((__str630)&4294967295)); //@line 506 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 508 "tr_languages.cpp"
      }
      else if (__label__ == 13) {
  
        var $90=$tr; //@line 523 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($90, ((__ZZ16SelectTranslatorPKcE17stress_lengths_el)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_el)&4294967295)); //@line 523 "tr_languages.cpp"
        var $91=HEAP32[((((_charsets+28)&4294967295))>>2)]; //@line 525 "tr_languages.cpp"
        var $92=$tr; //@line 525 "tr_languages.cpp"
        var $charset_a0124=(($92+696)&4294967295); //@line 525 "tr_languages.cpp"
        HEAP32[(($charset_a0124)>>2)]=$91; //@line 525 "tr_languages.cpp"
        var $93=$tr; //@line 526 "tr_languages.cpp"
        var $char_plus_apostrophe=(($93+700)&4294967295); //@line 526 "tr_languages.cpp"
        HEAP32[(($char_plus_apostrophe)>>2)]=((__ZZ16SelectTranslatorPKcE18el_char_apostrophe)&4294967295); //@line 526 "tr_languages.cpp"
        var $94=$tr; //@line 528 "tr_languages.cpp"
        var $letter_bits_offset125=(($94+964)&4294967295); //@line 528 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset125)>>2)]=896; //@line 528 "tr_languages.cpp"
        var $95=$tr; //@line 529 "tr_languages.cpp"
        var $letter_bits=(($95+708)&4294967295); //@line 529 "tr_languages.cpp"
        var $arraydecay=(($letter_bits)&4294967295); //@line 529 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 529 "tr_languages.cpp"
        var $96=$tr; //@line 530 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($96, 0, ((__ZZ16SelectTranslatorPKcE9el_vowels)&4294967295)); //@line 530 "tr_languages.cpp"
        var $97=$tr; //@line 531 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($97, 7, ((__ZZ16SelectTranslatorPKcE9el_vowels)&4294967295)); //@line 531 "tr_languages.cpp"
        var $98=$tr; //@line 532 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($98, 1, ((__ZZ16SelectTranslatorPKcE12el_voiceless)&4294967295)); //@line 532 "tr_languages.cpp"
        var $99=$tr; //@line 533 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($99, 2, ((__ZZ16SelectTranslatorPKcE13el_consonants)&4294967295)); //@line 533 "tr_languages.cpp"
        var $100=$tr; //@line 534 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($100, 6, ((__ZZ16SelectTranslatorPKcE10el_fvowels)&4294967295)); //@line 534 "tr_languages.cpp"
        var $101=$tr; //@line 536 "tr_languages.cpp"
        var $langopts126=(($101)&4294967295); //@line 536 "tr_languages.cpp"
        var $length_mods127=(($langopts126+176)&4294967295); //@line 536 "tr_languages.cpp"
        var $102=HEAP32[(($length_mods127)>>2)]; //@line 536 "tr_languages.cpp"
        var $103=$tr; //@line 536 "tr_languages.cpp"
        var $langopts128=(($103)&4294967295); //@line 536 "tr_languages.cpp"
        var $length_mods0129=(($langopts128+180)&4294967295); //@line 536 "tr_languages.cpp"
        HEAP32[(($length_mods0129)>>2)]=$102; //@line 536 "tr_languages.cpp"
        var $104=$tr; //@line 537 "tr_languages.cpp"
        var $langopts130=(($104)&4294967295); //@line 537 "tr_languages.cpp"
        var $stress_rule131=(($langopts130+8)&4294967295); //@line 537 "tr_languages.cpp"
        HEAP32[(($stress_rule131)>>2)]=2; //@line 537 "tr_languages.cpp"
        var $105=$tr; //@line 538 "tr_languages.cpp"
        var $langopts132=(($105)&4294967295); //@line 538 "tr_languages.cpp"
        var $stress_flags133=(($langopts132+12)&4294967295); //@line 538 "tr_languages.cpp"
        HEAP32[(($stress_flags133)>>2)]=6; //@line 538 "tr_languages.cpp"
        var $106=$tr; //@line 539 "tr_languages.cpp"
        var $langopts134=(($106)&4294967295); //@line 539 "tr_languages.cpp"
        var $unstressed_wd1135=(($langopts134+16)&4294967295); //@line 539 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1135)>>2)]=0; //@line 539 "tr_languages.cpp"
        var $107=$tr; //@line 540 "tr_languages.cpp"
        var $langopts136=(($107)&4294967295); //@line 540 "tr_languages.cpp"
        var $unstressed_wd2137=(($langopts136+20)&4294967295); //@line 540 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2137)>>2)]=2; //@line 540 "tr_languages.cpp"
        var $108=$tr; //@line 541 "tr_languages.cpp"
        var $langopts138=(($108)&4294967295); //@line 541 "tr_languages.cpp"
        var $param139=(($langopts138+24)&4294967295); //@line 541 "tr_languages.cpp"
        var $arrayidx140=(($param139+28)&4294967295); //@line 541 "tr_languages.cpp"
        HEAP32[(($arrayidx140)>>2)]=130; //@line 541 "tr_languages.cpp"
        var $109=$tr; //@line 543 "tr_languages.cpp"
        var $langopts141=(($109)&4294967295); //@line 543 "tr_languages.cpp"
        var $numbers142=(($langopts141+184)&4294967295); //@line 543 "tr_languages.cpp"
        HEAP32[(($numbers142)>>2)]=264; //@line 543 "tr_languages.cpp"
        var $110=$tr; //@line 544 "tr_languages.cpp"
        var $langopts143=(($110)&4294967295); //@line 544 "tr_languages.cpp"
        var $numbers2=(($langopts143+188)&4294967295); //@line 544 "tr_languages.cpp"
        HEAP32[(($numbers2)>>2)]=4098; //@line 544 "tr_languages.cpp"
        var $111=$name2; //@line 546 "tr_languages.cpp"
        var $cmp144=((($111))|0)==6779491; //@line 546 "tr_languages.cpp"
        if (!($cmp144)) { __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; } //@line 546 "tr_languages.cpp"
  
        var $112=$tr; //@line 549 "tr_languages.cpp"
        var $langopts145=(($112)&4294967295); //@line 549 "tr_languages.cpp"
        var $param146=(($langopts145+24)&4294967295); //@line 549 "tr_languages.cpp"
        var $arrayidx147=(($param146+20)&4294967295); //@line 549 "tr_languages.cpp"
        HEAP32[(($arrayidx147)>>2)]=1; //@line 549 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 550 "tr_languages.cpp"
      }
      else if (__label__ == 15) {
  
        var $113=$tr; //@line 560 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($113, ((__ZZ16SelectTranslatorPKcE17stress_lengths_eo)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_eo)&4294967295)); //@line 560 "tr_languages.cpp"
        var $114=HEAP32[((((_charsets+12)&4294967295))>>2)]; //@line 562 "tr_languages.cpp"
        var $115=$tr; //@line 562 "tr_languages.cpp"
        var $charset_a0149=(($115+696)&4294967295); //@line 562 "tr_languages.cpp"
        HEAP32[(($charset_a0149)>>2)]=$114; //@line 562 "tr_languages.cpp"
        var $116=$tr; //@line 563 "tr_languages.cpp"
        var $char_plus_apostrophe150=(($116+700)&4294967295); //@line 563 "tr_languages.cpp"
        HEAP32[(($char_plus_apostrophe150)>>2)]=((__ZZ16SelectTranslatorPKcE18eo_char_apostrophe)&4294967295); //@line 563 "tr_languages.cpp"
        var $117=$tr; //@line 566 "tr_languages.cpp"
        var $langopts151=(($117)&4294967295); //@line 566 "tr_languages.cpp"
        var $vowel_pause152=(($langopts151+4)&4294967295); //@line 566 "tr_languages.cpp"
        HEAP32[(($vowel_pause152)>>2)]=2; //@line 566 "tr_languages.cpp"
        var $118=$tr; //@line 567 "tr_languages.cpp"
        var $langopts153=(($118)&4294967295); //@line 567 "tr_languages.cpp"
        var $stress_rule154=(($langopts153+8)&4294967295); //@line 567 "tr_languages.cpp"
        HEAP32[(($stress_rule154)>>2)]=2; //@line 567 "tr_languages.cpp"
        var $119=$tr; //@line 568 "tr_languages.cpp"
        var $langopts155=(($119)&4294967295); //@line 568 "tr_languages.cpp"
        var $stress_flags156=(($langopts155+12)&4294967295); //@line 568 "tr_languages.cpp"
        HEAP32[(($stress_flags156)>>2)]=22; //@line 568 "tr_languages.cpp"
        var $120=$tr; //@line 570 "tr_languages.cpp"
        var $langopts157=(($120)&4294967295); //@line 570 "tr_languages.cpp"
        var $unstressed_wd2158=(($langopts157+20)&4294967295); //@line 570 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2158)>>2)]=2; //@line 570 "tr_languages.cpp"
        var $121=$tr; //@line 572 "tr_languages.cpp"
        var $langopts159=(($121)&4294967295); //@line 572 "tr_languages.cpp"
        var $numbers160=(($langopts159+184)&4294967295); //@line 572 "tr_languages.cpp"
        HEAP32[(($numbers160)>>2)]=16782344; //@line 572 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 574 "tr_languages.cpp"
      }
      else if (__label__ == 16) {
  
        var $122=$tr; //@line 585 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($122, ((__ZZ16SelectTranslatorPKcE17stress_lengths_es)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_es)&4294967295)); //@line 585 "tr_languages.cpp"
        var $123=$tr; //@line 587 "tr_languages.cpp"
        var $langopts162=(($123)&4294967295); //@line 587 "tr_languages.cpp"
        var $length_mods163=(($langopts162+176)&4294967295); //@line 587 "tr_languages.cpp"
        var $124=HEAP32[(($length_mods163)>>2)]; //@line 587 "tr_languages.cpp"
        var $125=$tr; //@line 587 "tr_languages.cpp"
        var $langopts164=(($125)&4294967295); //@line 587 "tr_languages.cpp"
        var $length_mods0165=(($langopts164+180)&4294967295); //@line 587 "tr_languages.cpp"
        HEAP32[(($length_mods0165)>>2)]=$124; //@line 587 "tr_languages.cpp"
        var $126=$tr; //@line 588 "tr_languages.cpp"
        var $langopts166=(($126)&4294967295); //@line 588 "tr_languages.cpp"
        var $stress_rule167=(($langopts166+8)&4294967295); //@line 588 "tr_languages.cpp"
        HEAP32[(($stress_rule167)>>2)]=2; //@line 588 "tr_languages.cpp"
        var $127=$tr; //@line 592 "tr_languages.cpp"
        var $langopts168=(($127)&4294967295); //@line 592 "tr_languages.cpp"
        var $stress_flags169=(($langopts168+12)&4294967295); //@line 592 "tr_languages.cpp"
        HEAP32[(($stress_flags169)>>2)]=534; //@line 592 "tr_languages.cpp"
        var $128=$tr; //@line 593 "tr_languages.cpp"
        var $langopts170=(($128)&4294967295); //@line 593 "tr_languages.cpp"
        var $unstressed_wd1171=(($langopts170+16)&4294967295); //@line 593 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1171)>>2)]=0; //@line 593 "tr_languages.cpp"
        var $129=$tr; //@line 594 "tr_languages.cpp"
        var $langopts172=(($129)&4294967295); //@line 594 "tr_languages.cpp"
        var $unstressed_wd2173=(($langopts172+20)&4294967295); //@line 594 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2173)>>2)]=2; //@line 594 "tr_languages.cpp"
        var $130=$tr; //@line 595 "tr_languages.cpp"
        var $langopts174=(($130)&4294967295); //@line 595 "tr_languages.cpp"
        var $param175=(($langopts174+24)&4294967295); //@line 595 "tr_languages.cpp"
        var $arrayidx176=(($param175+28)&4294967295); //@line 595 "tr_languages.cpp"
        HEAP32[(($arrayidx176)>>2)]=120; //@line 595 "tr_languages.cpp"
        var $131=$tr; //@line 597 "tr_languages.cpp"
        var $langopts177=(($131)&4294967295); //@line 597 "tr_languages.cpp"
        var $numbers178=(($langopts177+184)&4294967295); //@line 597 "tr_languages.cpp"
        HEAP32[(($numbers178)>>2)]=85984552; //@line 597 "tr_languages.cpp"
        var $132=$tr; //@line 598 "tr_languages.cpp"
        var $langopts179=(($132)&4294967295); //@line 598 "tr_languages.cpp"
        var $numbers2180=(($langopts179+188)&4294967295); //@line 598 "tr_languages.cpp"
        HEAP32[(($numbers2180)>>2)]=4096; //@line 598 "tr_languages.cpp"
        var $133=$name2; //@line 600 "tr_languages.cpp"
        var $cmp181=((($133))|0)==25441; //@line 600 "tr_languages.cpp"
        if ($cmp181) { __label__ = 17;; } else { __label__ = 18;; } //@line 600 "tr_languages.cpp"
        if (__label__ == 17) {
  
          var $134=$tr; //@line 602 "tr_languages.cpp"
          var $punct_within_word=(($134+704)&4294967295); //@line 602 "tr_languages.cpp"
          HEAP32[(($punct_within_word)>>2)]=((__ZZ16SelectTranslatorPKcE20ca_punct_within_word)&4294967295); //@line 602 "tr_languages.cpp"
          var $135=$tr; //@line 603 "tr_languages.cpp"
          var $langopts183=(($135)&4294967295); //@line 603 "tr_languages.cpp"
          var $stress_flags184=(($langopts183+12)&4294967295); //@line 603 "tr_languages.cpp"
          HEAP32[(($stress_flags184)>>2)]=566; //@line 603 "tr_languages.cpp"
          __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 604 "tr_languages.cpp"
        }
        else if (__label__ == 18) {
  
          var $136=$name2; //@line 606 "tr_languages.cpp"
          var $cmp185=((($136))|0)==7364976; //@line 606 "tr_languages.cpp"
          var $137=$tr; //@line 608 "tr_languages.cpp"
          var $langopts187=(($137)&4294967295); //@line 608 "tr_languages.cpp"
          if ($cmp185) { __label__ = 19;; } else { __label__ = 20;; } //@line 606 "tr_languages.cpp"
          if (__label__ == 19) {
  
            var $stress_flags188=(($langopts187+12)&4294967295); //@line 608 "tr_languages.cpp"
            HEAP32[(($stress_flags188)>>2)]=310; //@line 608 "tr_languages.cpp"
            __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 609 "tr_languages.cpp"
          }
          else if (__label__ == 20) {
  
            var $param191=(($langopts187+24)&4294967295); //@line 612 "tr_languages.cpp"
            var $arrayidx192=(($param191+20)&4294967295); //@line 612 "tr_languages.cpp"
            HEAP32[(($arrayidx192)>>2)]=2; //@line 612 "tr_languages.cpp"
            __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6;
          }
        }
      }
      else if (__label__ == 21) {
  
        var $138=$tr; //@line 621 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($138, ((__ZZ16SelectTranslatorPKcE17stress_lengths_eu)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_eu)&4294967295)); //@line 621 "tr_languages.cpp"
        var $139=$tr; //@line 622 "tr_languages.cpp"
        var $langopts196=(($139)&4294967295); //@line 622 "tr_languages.cpp"
        var $stress_rule197=(($langopts196+8)&4294967295); //@line 622 "tr_languages.cpp"
        HEAP32[(($stress_rule197)>>2)]=1; //@line 622 "tr_languages.cpp"
        var $140=$tr; //@line 623 "tr_languages.cpp"
        var $langopts198=(($140)&4294967295); //@line 623 "tr_languages.cpp"
        var $numbers199=(($langopts198+184)&4294967295); //@line 623 "tr_languages.cpp"
        HEAP32[(($numbers199)>>2)]=1049960; //@line 623 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 625 "tr_languages.cpp"
      }
      else if (__label__ == 22) {
  
        var $141=$tr; //@line 630 "tr_languages.cpp"
        var $letter_bits_offset201=(($141+964)&4294967295); //@line 630 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset201)>>2)]=1536; //@line 630 "tr_languages.cpp"
        var $142=$tr; //@line 631 "tr_languages.cpp"
        var $langopts202=(($142)&4294967295); //@line 631 "tr_languages.cpp"
        var $numbers203=(($langopts202+184)&4294967295); //@line 631 "tr_languages.cpp"
        HEAP32[(($numbers203)>>2)]=96; //@line 631 "tr_languages.cpp"
        var $143=$tr; //@line 632 "tr_languages.cpp"
        var $langopts204=(($143)&4294967295); //@line 632 "tr_languages.cpp"
        var $param205=(($langopts204+24)&4294967295); //@line 632 "tr_languages.cpp"
        var $arrayidx206=(($param205+20)&4294967295); //@line 632 "tr_languages.cpp"
        HEAP32[(($arrayidx206)>>2)]=1; //@line 632 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 634 "tr_languages.cpp"
      }
      else if (__label__ == 23) {
  
        var $144=HEAP32[((((_charsets+16)&4294967295))>>2)]; //@line 638 "tr_languages.cpp"
        var $145=$tr; //@line 638 "tr_languages.cpp"
        var $charset_a0208=(($145+696)&4294967295); //@line 638 "tr_languages.cpp"
        HEAP32[(($charset_a0208)>>2)]=$144; //@line 638 "tr_languages.cpp"
        __label__ = 24;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 638 "tr_languages.cpp"
      }
      else if (__label__ == 25) {
  
        var $155=$tr; //@line 662 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($155, ((__ZZ16SelectTranslatorPKcE17stress_lengths_fr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_fr)&4294967295)); //@line 662 "tr_languages.cpp"
        var $156=$tr; //@line 663 "tr_languages.cpp"
        var $langopts223=(($156)&4294967295); //@line 663 "tr_languages.cpp"
        var $stress_rule224=(($langopts223+8)&4294967295); //@line 663 "tr_languages.cpp"
        HEAP32[(($stress_rule224)>>2)]=3; //@line 663 "tr_languages.cpp"
        var $157=$tr; //@line 664 "tr_languages.cpp"
        var $langopts225=(($157)&4294967295); //@line 664 "tr_languages.cpp"
        var $stress_flags226=(($langopts225+12)&4294967295); //@line 664 "tr_languages.cpp"
        HEAP32[(($stress_flags226)>>2)]=36; //@line 664 "tr_languages.cpp"
        var $158=$tr; //@line 665 "tr_languages.cpp"
        var $langopts227=(($158)&4294967295); //@line 665 "tr_languages.cpp"
        var $param228=(($langopts227+24)&4294967295); //@line 665 "tr_languages.cpp"
        var $arrayidx229=(($param228+8)&4294967295); //@line 665 "tr_languages.cpp"
        HEAP32[(($arrayidx229)>>2)]=1; //@line 665 "tr_languages.cpp"
        var $159=$tr; //@line 666 "tr_languages.cpp"
        var $langopts230=(($159)&4294967295); //@line 666 "tr_languages.cpp"
        var $length_mods231=(($langopts230+176)&4294967295); //@line 666 "tr_languages.cpp"
        var $160=HEAP32[(($length_mods231)>>2)]; //@line 666 "tr_languages.cpp"
        var $161=$tr; //@line 666 "tr_languages.cpp"
        var $langopts232=(($161)&4294967295); //@line 666 "tr_languages.cpp"
        var $length_mods0233=(($langopts232+180)&4294967295); //@line 666 "tr_languages.cpp"
        HEAP32[(($length_mods0233)>>2)]=$160; //@line 666 "tr_languages.cpp"
        var $162=$tr; //@line 667 "tr_languages.cpp"
        var $langopts234=(($162)&4294967295); //@line 667 "tr_languages.cpp"
        var $accents235=(($langopts234+220)&4294967295); //@line 667 "tr_languages.cpp"
        HEAP32[(($accents235)>>2)]=2; //@line 667 "tr_languages.cpp"
        var $163=$tr; //@line 669 "tr_languages.cpp"
        var $langopts236=(($163)&4294967295); //@line 669 "tr_languages.cpp"
        var $numbers237=(($langopts236+184)&4294967295); //@line 669 "tr_languages.cpp"
        HEAP32[(($numbers237)>>2)]=118658312; //@line 669 "tr_languages.cpp"
        var $164=$tr; //@line 670 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($164, 121); //@line 670 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 672 "tr_languages.cpp"
      }
      else if (__label__ == 26) {
  
        var $165=$tr; //@line 681 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($165, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hi)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hi)&4294967295)); //@line 681 "tr_languages.cpp"
        var $166=HEAP32[((((_charsets+76)&4294967295))>>2)]; //@line 682 "tr_languages.cpp"
        var $167=$tr; //@line 682 "tr_languages.cpp"
        var $charset_a0239=(($167+696)&4294967295); //@line 682 "tr_languages.cpp"
        HEAP32[(($charset_a0239)>>2)]=$166; //@line 682 "tr_languages.cpp"
        var $168=$tr; //@line 683 "tr_languages.cpp"
        var $langopts240=(($168)&4294967295); //@line 683 "tr_languages.cpp"
        var $length_mods241=(($langopts240+176)&4294967295); //@line 683 "tr_languages.cpp"
        var $169=HEAP32[(($length_mods241)>>2)]; //@line 683 "tr_languages.cpp"
        var $170=$tr; //@line 683 "tr_languages.cpp"
        var $langopts242=(($170)&4294967295); //@line 683 "tr_languages.cpp"
        var $length_mods0243=(($langopts242+180)&4294967295); //@line 683 "tr_languages.cpp"
        HEAP32[(($length_mods0243)>>2)]=$169; //@line 683 "tr_languages.cpp"
        var $171=$tr; //@line 685 "tr_languages.cpp"
        var $langopts244=(($171)&4294967295); //@line 685 "tr_languages.cpp"
        var $stress_rule245=(($langopts244+8)&4294967295); //@line 685 "tr_languages.cpp"
        HEAP32[(($stress_rule245)>>2)]=6; //@line 685 "tr_languages.cpp"
        var $172=$tr; //@line 686 "tr_languages.cpp"
        var $langopts246=(($172)&4294967295); //@line 686 "tr_languages.cpp"
        var $stress_flags247=(($langopts246+12)&4294967295); //@line 686 "tr_languages.cpp"
        HEAP32[(($stress_flags247)>>2)]=65540; //@line 686 "tr_languages.cpp"
        var $173=$tr; //@line 687 "tr_languages.cpp"
        var $langopts248=(($173)&4294967295); //@line 687 "tr_languages.cpp"
        var $numbers249=(($langopts248+184)&4294967295); //@line 687 "tr_languages.cpp"
        HEAP32[(($numbers249)>>2)]=16; //@line 687 "tr_languages.cpp"
        var $174=$tr; //@line 688 "tr_languages.cpp"
        var $langopts250=(($174)&4294967295); //@line 688 "tr_languages.cpp"
        var $break_numbers251=(($langopts250+192)&4294967295); //@line 688 "tr_languages.cpp"
        HEAP32[(($break_numbers251)>>2)]=84648; //@line 688 "tr_languages.cpp"
        var $175=$tr; //@line 689 "tr_languages.cpp"
        var $letter_bits_offset252=(($175+964)&4294967295); //@line 689 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset252)>>2)]=2304; //@line 689 "tr_languages.cpp"
        var $176=$name2; //@line 691 "tr_languages.cpp"
        var $cmp253=((($176))|0)==28769; //@line 691 "tr_languages.cpp"
        if ($cmp253) { __label__ = 27;; } else { __label__ = 28;; } //@line 691 "tr_languages.cpp"
        if (__label__ == 27) {
  
          var $177=$tr; //@line 693 "tr_languages.cpp"
          var $letter_bits_offset255=(($177+964)&4294967295); //@line 693 "tr_languages.cpp"
          HEAP32[(($letter_bits_offset255)>>2)]=2560; //@line 693 "tr_languages.cpp"
          ; //@line 694 "tr_languages.cpp"
        }
  
        var $178=$tr; //@line 695 "tr_languages.cpp"
        __Z15SetIndicLettersP10Translator($178); //@line 695 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 697 "tr_languages.cpp"
      }
      else if (__label__ == 29) {
  
        var $cmp258=((($7))|0)==29554; //@line 708 "tr_languages.cpp"
        var $179=$tr; //@line 709 "tr_languages.cpp"
        if ($cmp258) { __label__ = 30;; } else { __label__ = 31;; } //@line 708 "tr_languages.cpp"
        if (__label__ == 30) {
  
          __Z15SetupTranslatorP10TranslatorPKsPKh($179, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hr)&4294967295)); //@line 709 "tr_languages.cpp"
          ; //@line 709 "tr_languages.cpp"
        }
        else if (__label__ == 31) {
  
          __Z15SetupTranslatorP10TranslatorPKsPKh($179, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hr)&4294967295)); //@line 711 "tr_languages.cpp"
          ;
        }
  
        var $180=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 712 "tr_languages.cpp"
        var $181=$tr; //@line 712 "tr_languages.cpp"
        var $charset_a0262=(($181+696)&4294967295); //@line 712 "tr_languages.cpp"
        HEAP32[(($charset_a0262)>>2)]=$180; //@line 712 "tr_languages.cpp"
        var $182=$tr; //@line 714 "tr_languages.cpp"
        var $langopts263=(($182)&4294967295); //@line 714 "tr_languages.cpp"
        var $stress_rule264=(($langopts263+8)&4294967295); //@line 714 "tr_languages.cpp"
        HEAP32[(($stress_rule264)>>2)]=0; //@line 714 "tr_languages.cpp"
        var $183=$tr; //@line 715 "tr_languages.cpp"
        var $langopts265=(($183)&4294967295); //@line 715 "tr_languages.cpp"
        var $stress_flags266=(($langopts265+12)&4294967295); //@line 715 "tr_languages.cpp"
        HEAP32[(($stress_flags266)>>2)]=16; //@line 715 "tr_languages.cpp"
        var $184=$tr; //@line 716 "tr_languages.cpp"
        var $langopts267=(($184)&4294967295); //@line 716 "tr_languages.cpp"
        var $param268=(($langopts267+24)&4294967295); //@line 716 "tr_languages.cpp"
        var $arrayidx269=(($param268+16)&4294967295); //@line 716 "tr_languages.cpp"
        HEAP32[(($arrayidx269)>>2)]=3; //@line 716 "tr_languages.cpp"
        var $185=$tr; //@line 717 "tr_languages.cpp"
        var $langopts270=(($185)&4294967295); //@line 717 "tr_languages.cpp"
        var $max_initial_consonants=(($langopts270+248)&4294967295); //@line 717 "tr_languages.cpp"
        HEAP8[($max_initial_consonants)]=5; //@line 717 "tr_languages.cpp"
        var $186=$tr; //@line 718 "tr_languages.cpp"
        var $langopts271=(($186)&4294967295); //@line 718 "tr_languages.cpp"
        var $spelling_stress272=(($langopts271+249)&4294967295); //@line 718 "tr_languages.cpp"
        HEAP8[($spelling_stress272)]=1; //@line 718 "tr_languages.cpp"
        var $187=$tr; //@line 719 "tr_languages.cpp"
        var $langopts273=(($187)&4294967295); //@line 719 "tr_languages.cpp"
        var $accents274=(($langopts273+220)&4294967295); //@line 719 "tr_languages.cpp"
        HEAP32[(($accents274)>>2)]=1; //@line 719 "tr_languages.cpp"
        var $188=$tr; //@line 721 "tr_languages.cpp"
        var $langopts275=(($188)&4294967295); //@line 721 "tr_languages.cpp"
        var $numbers276=(($langopts275+184)&4294967295); //@line 721 "tr_languages.cpp"
        HEAP32[(($numbers276)>>2)]=33572172; //@line 721 "tr_languages.cpp"
        var $189=$tr; //@line 722 "tr_languages.cpp"
        var $langopts277=(($189)&4294967295); //@line 722 "tr_languages.cpp"
        var $numbers2278=(($langopts277+188)&4294967295); //@line 722 "tr_languages.cpp"
        HEAP32[(($numbers2278)>>2)]=74; //@line 722 "tr_languages.cpp"
        var $190=$tr; //@line 723 "tr_languages.cpp"
        var $langopts279=(($190)&4294967295); //@line 723 "tr_languages.cpp"
        var $replace_chars=(($langopts279+264)&4294967295); //@line 723 "tr_languages.cpp"
        HEAP32[(($replace_chars)>>2)]=((__ZL22replace_cyrillic_latin)&4294967295); //@line 723 "tr_languages.cpp"
        var $191=$tr; //@line 725 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($191, 121); //@line 725 "tr_languages.cpp"
        var $192=$tr; //@line 726 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($192, 114); //@line 726 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 728 "tr_languages.cpp"
      }
      else if (__label__ == 33) {
  
        var $193=$tr; //@line 733 "tr_languages.cpp"
        var $langopts281=(($193)&4294967295); //@line 733 "tr_languages.cpp"
        var $stress_rule282=(($langopts281+8)&4294967295); //@line 733 "tr_languages.cpp"
        HEAP32[(($stress_rule282)>>2)]=3; //@line 733 "tr_languages.cpp"
        var $194=$tr; //@line 734 "tr_languages.cpp"
        var $langopts283=(($194)&4294967295); //@line 734 "tr_languages.cpp"
        var $stress_flags284=(($langopts283+12)&4294967295); //@line 734 "tr_languages.cpp"
        HEAP32[(($stress_flags284)>>2)]=36; //@line 734 "tr_languages.cpp"
        var $195=$tr; //@line 735 "tr_languages.cpp"
        var $langopts285=(($195)&4294967295); //@line 735 "tr_languages.cpp"
        var $numbers286=(($langopts285+184)&4294967295); //@line 735 "tr_languages.cpp"
        HEAP32[(($numbers286)>>2)]=17990912; //@line 735 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 736 "tr_languages.cpp"
      }
      else if (__label__ == 34) {
  
        var $196=$tr; //@line 744 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($196, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hu)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_hu)&4294967295)); //@line 744 "tr_languages.cpp"
        var $197=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 745 "tr_languages.cpp"
        var $198=$tr; //@line 745 "tr_languages.cpp"
        var $charset_a0288=(($198+696)&4294967295); //@line 745 "tr_languages.cpp"
        HEAP32[(($charset_a0288)>>2)]=$197; //@line 745 "tr_languages.cpp"
        var $199=$tr; //@line 747 "tr_languages.cpp"
        var $langopts289=(($199)&4294967295); //@line 747 "tr_languages.cpp"
        var $vowel_pause290=(($langopts289+4)&4294967295); //@line 747 "tr_languages.cpp"
        HEAP32[(($vowel_pause290)>>2)]=32; //@line 747 "tr_languages.cpp"
        var $200=$tr; //@line 748 "tr_languages.cpp"
        var $langopts291=(($200)&4294967295); //@line 748 "tr_languages.cpp"
        var $stress_rule292=(($langopts291+8)&4294967295); //@line 748 "tr_languages.cpp"
        HEAP32[(($stress_rule292)>>2)]=0; //@line 748 "tr_languages.cpp"
        var $201=$tr; //@line 749 "tr_languages.cpp"
        var $langopts293=(($201)&4294967295); //@line 749 "tr_languages.cpp"
        var $stress_flags294=(($langopts293+12)&4294967295); //@line 749 "tr_languages.cpp"
        HEAP32[(($stress_flags294)>>2)]=1081398; //@line 749 "tr_languages.cpp"
        var $202=$tr; //@line 750 "tr_languages.cpp"
        var $langopts295=(($202)&4294967295); //@line 750 "tr_languages.cpp"
        var $unstressed_wd1296=(($langopts295+16)&4294967295); //@line 750 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1296)>>2)]=2; //@line 750 "tr_languages.cpp"
        var $203=$tr; //@line 751 "tr_languages.cpp"
        var $langopts297=(($203)&4294967295); //@line 751 "tr_languages.cpp"
        var $param298=(($langopts297+24)&4294967295); //@line 751 "tr_languages.cpp"
        var $arrayidx299=(($param298+56)&4294967295); //@line 751 "tr_languages.cpp"
        HEAP32[(($arrayidx299)>>2)]=1; //@line 751 "tr_languages.cpp"
        var $204=$tr; //@line 752 "tr_languages.cpp"
        var $langopts300=(($204)&4294967295); //@line 752 "tr_languages.cpp"
        var $param301=(($langopts300+24)&4294967295); //@line 752 "tr_languages.cpp"
        var $arrayidx302=(($param301+68)&4294967295); //@line 752 "tr_languages.cpp"
        HEAP32[(($arrayidx302)>>2)]=2; //@line 752 "tr_languages.cpp"
        var $205=$tr; //@line 754 "tr_languages.cpp"
        var $langopts303=(($205)&4294967295); //@line 754 "tr_languages.cpp"
        var $numbers304=(($langopts303+184)&4294967295); //@line 754 "tr_languages.cpp"
        HEAP32[(($numbers304)>>2)]=186758144; //@line 754 "tr_languages.cpp"
        var $206=$tr; //@line 755 "tr_languages.cpp"
        var $langopts305=(($206)&4294967295); //@line 755 "tr_languages.cpp"
        var $thousands_sep306=(($langopts305+204)&4294967295); //@line 755 "tr_languages.cpp"
        HEAP32[(($thousands_sep306)>>2)]=32; //@line 755 "tr_languages.cpp"
        var $207=$tr; //@line 756 "tr_languages.cpp"
        var $langopts307=(($207)&4294967295); //@line 756 "tr_languages.cpp"
        var $decimal_sep=(($langopts307+208)&4294967295); //@line 756 "tr_languages.cpp"
        HEAP32[(($decimal_sep)>>2)]=44; //@line 756 "tr_languages.cpp"
        var $208=$tr; //@line 757 "tr_languages.cpp"
        var $langopts308=(($208)&4294967295); //@line 757 "tr_languages.cpp"
        var $max_roman=(($langopts308+196)&4294967295); //@line 757 "tr_languages.cpp"
        HEAP32[(($max_roman)>>2)]=899; //@line 757 "tr_languages.cpp"
        var $209=$tr; //@line 758 "tr_languages.cpp"
        var $langopts309=(($209)&4294967295); //@line 758 "tr_languages.cpp"
        var $min_roman=(($langopts309+200)&4294967295); //@line 758 "tr_languages.cpp"
        HEAP32[(($min_roman)>>2)]=1; //@line 758 "tr_languages.cpp"
        var $210=$tr; //@line 759 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($210, 121); //@line 759 "tr_languages.cpp"
        var $211=$tr; //@line 760 "tr_languages.cpp"
        var $langopts310=(($211)&4294967295); //@line 760 "tr_languages.cpp"
        var $spelling_stress311=(($langopts310+249)&4294967295); //@line 760 "tr_languages.cpp"
        HEAP8[($spelling_stress311)]=1; //@line 760 "tr_languages.cpp"
        var $212=$tr; //@line 761 "tr_languages.cpp"
        __Z13SetLengthModsP10Translatori($212, 3); //@line 761 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 763 "tr_languages.cpp"
      }
      else if (__label__ == 35) {
  
        var $213=$tr; //@line 772 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($213, ((__ZZ16SelectTranslatorPKcE17stress_lengths_hy)&4294967295), 0); //@line 772 "tr_languages.cpp"
        var $214=$tr; //@line 773 "tr_languages.cpp"
        var $langopts313=(($214)&4294967295); //@line 773 "tr_languages.cpp"
        var $stress_rule314=(($langopts313+8)&4294967295); //@line 773 "tr_languages.cpp"
        HEAP32[(($stress_rule314)>>2)]=3; //@line 773 "tr_languages.cpp"
        var $215=$tr; //@line 775 "tr_languages.cpp"
        var $letter_bits_offset315=(($215+964)&4294967295); //@line 775 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset315)>>2)]=1328; //@line 775 "tr_languages.cpp"
        var $216=$tr; //@line 776 "tr_languages.cpp"
        var $letter_bits316=(($216+708)&4294967295); //@line 776 "tr_languages.cpp"
        var $arraydecay317=(($letter_bits316)&4294967295); //@line 776 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay317;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 776 "tr_languages.cpp"
        var $217=$tr; //@line 777 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($217, 0, ((__ZZ16SelectTranslatorPKcE9hy_vowels)&4294967295)); //@line 777 "tr_languages.cpp"
        var $218=$tr; //@line 778 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($218, 7, ((__ZZ16SelectTranslatorPKcE9hy_vowels)&4294967295)); //@line 778 "tr_languages.cpp"
        var $219=$tr; //@line 779 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($219, 2, ((__ZZ16SelectTranslatorPKcE13hy_consonants)&4294967295)); //@line 779 "tr_languages.cpp"
        var $220=$tr; //@line 780 "tr_languages.cpp"
        var $langopts318=(($220)&4294967295); //@line 780 "tr_languages.cpp"
        var $max_initial_consonants319=(($langopts318+248)&4294967295); //@line 780 "tr_languages.cpp"
        HEAP8[($max_initial_consonants319)]=6; //@line 780 "tr_languages.cpp"
        var $221=$tr; //@line 781 "tr_languages.cpp"
        var $langopts320=(($221)&4294967295); //@line 781 "tr_languages.cpp"
        var $numbers321=(($langopts320+184)&4294967295); //@line 781 "tr_languages.cpp"
        HEAP32[(($numbers321)>>2)]=1032; //@line 781 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 784 "tr_languages.cpp"
      }
      else if (__label__ == 36) {
  
        var $222=$tr; //@line 791 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($222, ((__ZZ16SelectTranslatorPKcE17stress_lengths_id)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_id)&4294967295)); //@line 791 "tr_languages.cpp"
        var $223=$tr; //@line 792 "tr_languages.cpp"
        var $langopts323=(($223)&4294967295); //@line 792 "tr_languages.cpp"
        var $stress_rule324=(($langopts323+8)&4294967295); //@line 792 "tr_languages.cpp"
        HEAP32[(($stress_rule324)>>2)]=2; //@line 792 "tr_languages.cpp"
        var $224=$tr; //@line 793 "tr_languages.cpp"
        var $langopts325=(($224)&4294967295); //@line 793 "tr_languages.cpp"
        var $numbers326=(($langopts325+184)&4294967295); //@line 793 "tr_languages.cpp"
        HEAP32[(($numbers326)>>2)]=16781320; //@line 793 "tr_languages.cpp"
        var $225=$tr; //@line 794 "tr_languages.cpp"
        var $langopts327=(($225)&4294967295); //@line 794 "tr_languages.cpp"
        var $stress_flags328=(($langopts327+12)&4294967295); //@line 794 "tr_languages.cpp"
        HEAP32[(($stress_flags328)>>2)]=22; //@line 794 "tr_languages.cpp"
        var $226=$tr; //@line 795 "tr_languages.cpp"
        var $langopts329=(($226)&4294967295); //@line 795 "tr_languages.cpp"
        var $accents330=(($langopts329+220)&4294967295); //@line 795 "tr_languages.cpp"
        HEAP32[(($accents330)>>2)]=2; //@line 795 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 797 "tr_languages.cpp"
      }
      else if (__label__ == 37) {
  
        var $227=$tr; //@line 804 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($227, ((__ZZ16SelectTranslatorPKcE17stress_lengths_is)&4294967295), 0); //@line 804 "tr_languages.cpp"
        var $228=$tr; //@line 805 "tr_languages.cpp"
        var $langopts332=(($228)&4294967295); //@line 805 "tr_languages.cpp"
        var $stress_rule333=(($langopts332+8)&4294967295); //@line 805 "tr_languages.cpp"
        HEAP32[(($stress_rule333)>>2)]=0; //@line 805 "tr_languages.cpp"
        var $229=$tr; //@line 806 "tr_languages.cpp"
        var $langopts334=(($229)&4294967295); //@line 806 "tr_languages.cpp"
        var $stress_flags335=(($langopts334+12)&4294967295); //@line 806 "tr_languages.cpp"
        HEAP32[(($stress_flags335)>>2)]=16; //@line 806 "tr_languages.cpp"
        var $230=$tr; //@line 807 "tr_languages.cpp"
        var $langopts336=(($230)&4294967295); //@line 807 "tr_languages.cpp"
        var $param337=(($langopts336+24)&4294967295); //@line 807 "tr_languages.cpp"
        var $arrayidx338=(($param337+8)&4294967295); //@line 807 "tr_languages.cpp"
        HEAP32[(($arrayidx338)>>2)]=17; //@line 807 "tr_languages.cpp"
        var $231=$tr; //@line 808 "tr_languages.cpp"
        var $langopts339=(($231)&4294967295); //@line 808 "tr_languages.cpp"
        var $param340=(($langopts339+24)&4294967295); //@line 808 "tr_languages.cpp"
        var $arrayidx341=(($param340+40)&4294967295); //@line 808 "tr_languages.cpp"
        HEAP32[(($arrayidx341)>>2)]=2; //@line 808 "tr_languages.cpp"
        var $232=$tr; //@line 810 "tr_languages.cpp"
        __ZL15ResetLetterBitsP10Translatori($232, 24); //@line 810 "tr_languages.cpp"
        var $233=$tr; //@line 811 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($233, 4, ((__str1631)&4294967295)); //@line 811 "tr_languages.cpp"
        var $234=$tr; //@line 812 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($234, 3, ((__str2632)&4294967295)); //@line 812 "tr_languages.cpp"
        var $235=$tr; //@line 813 "tr_languages.cpp"
        var $letter_groups=(($235+968)&4294967295); //@line 813 "tr_languages.cpp"
        var $arrayidx342=(($letter_groups+4)&4294967295); //@line 813 "tr_languages.cpp"
        HEAP32[(($arrayidx342)>>2)]=((__ZZ16SelectTranslatorPKcE16is_lettergroup_B)&4294967295); //@line 813 "tr_languages.cpp"
        var $236=$tr; //@line 814 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($236, 121); //@line 814 "tr_languages.cpp"
        var $237=$tr; //@line 815 "tr_languages.cpp"
        var $langopts343=(($237)&4294967295); //@line 815 "tr_languages.cpp"
        var $numbers344=(($langopts343+184)&4294967295); //@line 815 "tr_languages.cpp"
        HEAP32[(($numbers344)>>2)]=2280; //@line 815 "tr_languages.cpp"
        var $238=$tr; //@line 816 "tr_languages.cpp"
        var $langopts345=(($238)&4294967295); //@line 816 "tr_languages.cpp"
        var $numbers2346=(($langopts345+188)&4294967295); //@line 816 "tr_languages.cpp"
        HEAP32[(($numbers2346)>>2)]=2; //@line 816 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 818 "tr_languages.cpp"
      }
      else if (__label__ == 38) {
  
        var $239=$tr; //@line 825 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($239, ((__ZZ16SelectTranslatorPKcE17stress_lengths_it)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_it)&4294967295)); //@line 825 "tr_languages.cpp"
        var $240=$tr; //@line 827 "tr_languages.cpp"
        var $langopts348=(($240)&4294967295); //@line 827 "tr_languages.cpp"
        var $length_mods349=(($langopts348+176)&4294967295); //@line 827 "tr_languages.cpp"
        var $241=HEAP32[(($length_mods349)>>2)]; //@line 827 "tr_languages.cpp"
        var $242=$tr; //@line 827 "tr_languages.cpp"
        var $langopts350=(($242)&4294967295); //@line 827 "tr_languages.cpp"
        var $length_mods0351=(($langopts350+180)&4294967295); //@line 827 "tr_languages.cpp"
        HEAP32[(($length_mods0351)>>2)]=$241; //@line 827 "tr_languages.cpp"
        var $243=$tr; //@line 828 "tr_languages.cpp"
        var $langopts352=(($243)&4294967295); //@line 828 "tr_languages.cpp"
        var $stress_rule353=(($langopts352+8)&4294967295); //@line 828 "tr_languages.cpp"
        HEAP32[(($stress_rule353)>>2)]=2; //@line 828 "tr_languages.cpp"
        var $244=$tr; //@line 829 "tr_languages.cpp"
        var $langopts354=(($244)&4294967295); //@line 829 "tr_languages.cpp"
        var $stress_flags355=(($langopts354+12)&4294967295); //@line 829 "tr_languages.cpp"
        HEAP32[(($stress_flags355)>>2)]=131088; //@line 829 "tr_languages.cpp"
        var $245=$tr; //@line 830 "tr_languages.cpp"
        var $langopts356=(($245)&4294967295); //@line 830 "tr_languages.cpp"
        var $vowel_pause357=(($langopts356+4)&4294967295); //@line 830 "tr_languages.cpp"
        HEAP32[(($vowel_pause357)>>2)]=1; //@line 830 "tr_languages.cpp"
        var $246=$tr; //@line 831 "tr_languages.cpp"
        var $langopts358=(($246)&4294967295); //@line 831 "tr_languages.cpp"
        var $unstressed_wd1359=(($langopts358+16)&4294967295); //@line 831 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1359)>>2)]=2; //@line 831 "tr_languages.cpp"
        var $247=$tr; //@line 832 "tr_languages.cpp"
        var $langopts360=(($247)&4294967295); //@line 832 "tr_languages.cpp"
        var $unstressed_wd2361=(($langopts360+20)&4294967295); //@line 832 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2361)>>2)]=2; //@line 832 "tr_languages.cpp"
        var $248=$tr; //@line 833 "tr_languages.cpp"
        var $langopts362=(($248)&4294967295); //@line 833 "tr_languages.cpp"
        var $param363=(($langopts362+24)&4294967295); //@line 833 "tr_languages.cpp"
        var $arrayidx364=(($param363+8)&4294967295); //@line 833 "tr_languages.cpp"
        HEAP32[(($arrayidx364)>>2)]=2; //@line 833 "tr_languages.cpp"
        var $249=$tr; //@line 834 "tr_languages.cpp"
        var $langopts365=(($249)&4294967295); //@line 834 "tr_languages.cpp"
        var $param366=(($langopts365+24)&4294967295); //@line 834 "tr_languages.cpp"
        var $arrayidx367=(($param366+56)&4294967295); //@line 834 "tr_languages.cpp"
        HEAP32[(($arrayidx367)>>2)]=2; //@line 834 "tr_languages.cpp"
        var $250=$tr; //@line 835 "tr_languages.cpp"
        var $langopts368=(($250)&4294967295); //@line 835 "tr_languages.cpp"
        var $param369=(($langopts368+24)&4294967295); //@line 835 "tr_languages.cpp"
        var $arrayidx370=(($param369+28)&4294967295); //@line 835 "tr_languages.cpp"
        HEAP32[(($arrayidx370)>>2)]=130; //@line 835 "tr_languages.cpp"
        var $251=$tr; //@line 836 "tr_languages.cpp"
        var $langopts371=(($251)&4294967295); //@line 836 "tr_languages.cpp"
        var $param372=(($langopts371+24)&4294967295); //@line 836 "tr_languages.cpp"
        var $arrayidx373=(($param372+40)&4294967295); //@line 836 "tr_languages.cpp"
        HEAP32[(($arrayidx373)>>2)]=1; //@line 836 "tr_languages.cpp"
        var $252=$tr; //@line 837 "tr_languages.cpp"
        var $langopts374=(($252)&4294967295); //@line 837 "tr_languages.cpp"
        var $param375=(($langopts374+24)&4294967295); //@line 837 "tr_languages.cpp"
        var $arrayidx376=(($param375+60)&4294967295); //@line 837 "tr_languages.cpp"
        HEAP32[(($arrayidx376)>>2)]=2; //@line 837 "tr_languages.cpp"
        var $253=$tr; //@line 838 "tr_languages.cpp"
        var $langopts377=(($253)&4294967295); //@line 838 "tr_languages.cpp"
        var $numbers378=(($langopts377+184)&4294967295); //@line 838 "tr_languages.cpp"
        HEAP32[(($numbers378)>>2)]=16786952; //@line 838 "tr_languages.cpp"
        var $254=$tr; //@line 839 "tr_languages.cpp"
        var $langopts379=(($254)&4294967295); //@line 839 "tr_languages.cpp"
        var $accents380=(($langopts379+220)&4294967295); //@line 839 "tr_languages.cpp"
        HEAP32[(($accents380)>>2)]=2; //@line 839 "tr_languages.cpp"
        var $255=$tr; //@line 840 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($255, 121); //@line 840 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 842 "tr_languages.cpp"
      }
      else if (__label__ == 39) {
  
        var $256=$tr; //@line 849 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($256, ((__ZZ16SelectTranslatorPKcE18stress_lengths_jbo)&4294967295), 0); //@line 849 "tr_languages.cpp"
        var $257=$tr; //@line 850 "tr_languages.cpp"
        var $langopts382=(($257)&4294967295); //@line 850 "tr_languages.cpp"
        var $stress_rule383=(($langopts382+8)&4294967295); //@line 850 "tr_languages.cpp"
        HEAP32[(($stress_rule383)>>2)]=2; //@line 850 "tr_languages.cpp"
        var $258=$tr; //@line 851 "tr_languages.cpp"
        var $langopts384=(($258)&4294967295); //@line 851 "tr_languages.cpp"
        var $vowel_pause385=(($langopts384+4)&4294967295); //@line 851 "tr_languages.cpp"
        HEAP32[(($vowel_pause385)>>2)]=524; //@line 851 "tr_languages.cpp"
        var $259=$tr; //@line 853 "tr_languages.cpp"
        var $punct_within_word386=(($259+704)&4294967295); //@line 853 "tr_languages.cpp"
        HEAP32[(($punct_within_word386)>>2)]=((__ZZ16SelectTranslatorPKcE21jbo_punct_within_word)&4294967295); //@line 853 "tr_languages.cpp"
        var $260=$tr; //@line 854 "tr_languages.cpp"
        var $langopts387=(($260)&4294967295); //@line 854 "tr_languages.cpp"
        var $param388=(($langopts387+24)&4294967295); //@line 854 "tr_languages.cpp"
        var $arrayidx389=(($param388+52)&4294967295); //@line 854 "tr_languages.cpp"
        HEAP32[(($arrayidx389)>>2)]=2; //@line 854 "tr_languages.cpp"
        var $261=$tr; //@line 855 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($261, 121); //@line 855 "tr_languages.cpp"
        var $262=$tr; //@line 856 "tr_languages.cpp"
        var $langopts390=(($262)&4294967295); //@line 856 "tr_languages.cpp"
        var $max_lengthmod=(($langopts390+272)&4294967295); //@line 856 "tr_languages.cpp"
        HEAP32[(($max_lengthmod)>>2)]=368; //@line 856 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 858 "tr_languages.cpp"
      }
      else if (__label__ == 40) {
  
        var $263=$tr; //@line 865 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($263, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 865 "tr_languages.cpp"
        var $264=$tr; //@line 866 "tr_languages.cpp"
        var $letter_bits392=(($264+708)&4294967295); //@line 866 "tr_languages.cpp"
        var $arraydecay393=(($letter_bits392)&4294967295); //@line 866 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay393;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 866 "tr_languages.cpp"
        var $265=$tr; //@line 867 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($265, 0, ((__ZZ16SelectTranslatorPKcE9ka_vowels)&4294967295)); //@line 867 "tr_languages.cpp"
        var $266=$tr; //@line 868 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($266, 2, ((__ZZ16SelectTranslatorPKcE13ka_consonants)&4294967295)); //@line 868 "tr_languages.cpp"
        var $267=$tr; //@line 869 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($267, 7, ((__ZZ16SelectTranslatorPKcE9ka_vowels)&4294967295)); //@line 869 "tr_languages.cpp"
        var $268=$tr; //@line 871 "tr_languages.cpp"
        var $langopts394=(($268)&4294967295); //@line 871 "tr_languages.cpp"
        var $stress_rule395=(($langopts394+8)&4294967295); //@line 871 "tr_languages.cpp"
        HEAP32[(($stress_rule395)>>2)]=0; //@line 871 "tr_languages.cpp"
        var $269=$tr; //@line 872 "tr_languages.cpp"
        var $langopts396=(($269)&4294967295); //@line 872 "tr_languages.cpp"
        var $stress_flags397=(($langopts396+12)&4294967295); //@line 872 "tr_languages.cpp"
        HEAP32[(($stress_flags397)>>2)]=16; //@line 872 "tr_languages.cpp"
        var $270=$tr; //@line 873 "tr_languages.cpp"
        var $letter_bits_offset398=(($270+964)&4294967295); //@line 873 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset398)>>2)]=4224; //@line 873 "tr_languages.cpp"
        var $271=$tr; //@line 875 "tr_languages.cpp"
        var $langopts399=(($271)&4294967295); //@line 875 "tr_languages.cpp"
        var $max_initial_consonants400=(($langopts399+248)&4294967295); //@line 875 "tr_languages.cpp"
        HEAP8[($max_initial_consonants400)]=7; //@line 875 "tr_languages.cpp"
        var $272=$tr; //@line 876 "tr_languages.cpp"
        var $langopts401=(($272)&4294967295); //@line 876 "tr_languages.cpp"
        var $numbers402=(($langopts401+184)&4294967295); //@line 876 "tr_languages.cpp"
        HEAP32[(($numbers402)>>2)]=3187744; //@line 876 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 878 "tr_languages.cpp"
      }
      else if (__label__ == 41) {
  
        var $273=$tr; //@line 885 "tr_languages.cpp"
        var $letter_bits_offset404=(($273+964)&4294967295); //@line 885 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset404)>>2)]=4352; //@line 885 "tr_languages.cpp"
        var $274=$tr; //@line 886 "tr_languages.cpp"
        var $letter_bits405=(($274+708)&4294967295); //@line 886 "tr_languages.cpp"
        var $arraydecay406=(($letter_bits405)&4294967295); //@line 886 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay406;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 886 "tr_languages.cpp"
        var $275=$tr; //@line 887 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($275, 0, 97, 117); //@line 887 "tr_languages.cpp"
        var $276=$tr; //@line 888 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($276, 6, ((__ZZ16SelectTranslatorPKcE10ko_ivowels)&4294967295)); //@line 888 "tr_languages.cpp"
        var $277=$tr; //@line 889 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($277, 5, ((__ZZ16SelectTranslatorPKcE9ko_voiced)&4294967295)); //@line 889 "tr_languages.cpp"
        var $278=$tr; //@line 891 "tr_languages.cpp"
        var $langopts407=(($278)&4294967295); //@line 891 "tr_languages.cpp"
        var $stress_rule408=(($langopts407+8)&4294967295); //@line 891 "tr_languages.cpp"
        HEAP32[(($stress_rule408)>>2)]=8; //@line 891 "tr_languages.cpp"
        var $279=$tr; //@line 892 "tr_languages.cpp"
        var $langopts409=(($279)&4294967295); //@line 892 "tr_languages.cpp"
        var $param410=(($langopts409+24)&4294967295); //@line 892 "tr_languages.cpp"
        var $arrayidx411=(($param410+20)&4294967295); //@line 892 "tr_languages.cpp"
        HEAP32[(($arrayidx411)>>2)]=1; //@line 892 "tr_languages.cpp"
        var $280=$tr; //@line 893 "tr_languages.cpp"
        var $langopts412=(($280)&4294967295); //@line 893 "tr_languages.cpp"
        var $numbers413=(($langopts412+184)&4294967295); //@line 893 "tr_languages.cpp"
        HEAP32[(($numbers413)>>2)]=1024; //@line 893 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 895 "tr_languages.cpp"
      }
      else if (__label__ == 42) {
  
        var $281=$tr; //@line 902 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($281, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ku)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ku)&4294967295)); //@line 902 "tr_languages.cpp"
        var $282=HEAP32[((((_charsets+36)&4294967295))>>2)]; //@line 903 "tr_languages.cpp"
        var $283=$tr; //@line 903 "tr_languages.cpp"
        var $charset_a0415=(($283+696)&4294967295); //@line 903 "tr_languages.cpp"
        HEAP32[(($charset_a0415)>>2)]=$282; //@line 903 "tr_languages.cpp"
        var $284=$tr; //@line 905 "tr_languages.cpp"
        var $langopts416=(($284)&4294967295); //@line 905 "tr_languages.cpp"
        var $stress_rule417=(($langopts416+8)&4294967295); //@line 905 "tr_languages.cpp"
        HEAP32[(($stress_rule417)>>2)]=7; //@line 905 "tr_languages.cpp"
        var $285=$tr; //@line 907 "tr_languages.cpp"
        var $langopts418=(($285)&4294967295); //@line 907 "tr_languages.cpp"
        var $numbers419=(($langopts418+184)&4294967295); //@line 907 "tr_languages.cpp"
        HEAP32[(($numbers419)>>2)]=263264; //@line 907 "tr_languages.cpp"
        var $286=$tr; //@line 908 "tr_languages.cpp"
        var $langopts420=(($286)&4294967295); //@line 908 "tr_languages.cpp"
        var $max_initial_consonants421=(($langopts420+248)&4294967295); //@line 908 "tr_languages.cpp"
        HEAP8[($max_initial_consonants421)]=2; //@line 908 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 910 "tr_languages.cpp"
      }
      else if (__label__ == 43) {
  
        var $287=HEAP32[((((_charsets+16)&4294967295))>>2)]; //@line 914 "tr_languages.cpp"
        var $288=$tr; //@line 914 "tr_languages.cpp"
        var $charset_a0423=(($288+696)&4294967295); //@line 914 "tr_languages.cpp"
        HEAP32[(($charset_a0423)>>2)]=$287; //@line 914 "tr_languages.cpp"
        var $289=$tr; //@line 915 "tr_languages.cpp"
        var $langopts424=(($289)&4294967295); //@line 915 "tr_languages.cpp"
        var $stress_rule425=(($langopts424+8)&4294967295); //@line 915 "tr_languages.cpp"
        HEAP32[(($stress_rule425)>>2)]=2; //@line 915 "tr_languages.cpp"
        var $290=$tr; //@line 916 "tr_languages.cpp"
        var $langopts426=(($290)&4294967295); //@line 916 "tr_languages.cpp"
        var $stress_flags427=(($langopts426+12)&4294967295); //@line 916 "tr_languages.cpp"
        HEAP32[(($stress_flags427)>>2)]=32; //@line 916 "tr_languages.cpp"
        var $291=$tr; //@line 917 "tr_languages.cpp"
        var $langopts428=(($291)&4294967295); //@line 917 "tr_languages.cpp"
        var $unstressed_wd1429=(($langopts428+16)&4294967295); //@line 917 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1429)>>2)]=0; //@line 917 "tr_languages.cpp"
        var $292=$tr; //@line 918 "tr_languages.cpp"
        var $langopts430=(($292)&4294967295); //@line 918 "tr_languages.cpp"
        var $unstressed_wd2431=(($langopts430+20)&4294967295); //@line 918 "tr_languages.cpp"
        HEAP32[(($unstressed_wd2431)>>2)]=2; //@line 918 "tr_languages.cpp"
        var $293=$tr; //@line 919 "tr_languages.cpp"
        var $langopts432=(($293)&4294967295); //@line 919 "tr_languages.cpp"
        var $param433=(($langopts432+24)&4294967295); //@line 919 "tr_languages.cpp"
        var $arrayidx434=(($param433+4)&4294967295); //@line 919 "tr_languages.cpp"
        HEAP32[(($arrayidx434)>>2)]=1; //@line 919 "tr_languages.cpp"
        var $294=$tr; //@line 920 "tr_languages.cpp"
        var $langopts435=(($294)&4294967295); //@line 920 "tr_languages.cpp"
        var $numbers436=(($langopts435+184)&4294967295); //@line 920 "tr_languages.cpp"
        HEAP32[(($numbers436)>>2)]=16777216; //@line 920 "tr_languages.cpp"
        var $295=$tr; //@line 921 "tr_languages.cpp"
        var $langopts437=(($295)&4294967295); //@line 921 "tr_languages.cpp"
        var $max_roman438=(($langopts437+196)&4294967295); //@line 921 "tr_languages.cpp"
        HEAP32[(($max_roman438)>>2)]=5000; //@line 921 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 923 "tr_languages.cpp"
      }
      else if (__label__ == 44) {
  
        var $296=$tr; //@line 930 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($296, ((__ZZ16SelectTranslatorPKcE17stress_lengths_lv)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_lv)&4294967295)); //@line 930 "tr_languages.cpp"
        var $297=$tr; //@line 932 "tr_languages.cpp"
        var $langopts440=(($297)&4294967295); //@line 932 "tr_languages.cpp"
        var $stress_rule441=(($langopts440+8)&4294967295); //@line 932 "tr_languages.cpp"
        HEAP32[(($stress_rule441)>>2)]=0; //@line 932 "tr_languages.cpp"
        var $298=$tr; //@line 933 "tr_languages.cpp"
        var $langopts442=(($298)&4294967295); //@line 933 "tr_languages.cpp"
        var $spelling_stress443=(($langopts442+249)&4294967295); //@line 933 "tr_languages.cpp"
        HEAP8[($spelling_stress443)]=1; //@line 933 "tr_languages.cpp"
        var $299=HEAP32[((((_charsets+16)&4294967295))>>2)]; //@line 934 "tr_languages.cpp"
        var $300=$tr; //@line 934 "tr_languages.cpp"
        var $charset_a0444=(($300+696)&4294967295); //@line 934 "tr_languages.cpp"
        HEAP32[(($charset_a0444)>>2)]=$299; //@line 934 "tr_languages.cpp"
        var $301=$tr; //@line 935 "tr_languages.cpp"
        var $langopts445=(($301)&4294967295); //@line 935 "tr_languages.cpp"
        var $numbers446=(($langopts445+184)&4294967295); //@line 935 "tr_languages.cpp"
        HEAP32[(($numbers446)>>2)]=99336; //@line 935 "tr_languages.cpp"
        var $302=$tr; //@line 936 "tr_languages.cpp"
        var $langopts447=(($302)&4294967295); //@line 936 "tr_languages.cpp"
        var $stress_flags448=(($langopts447+12)&4294967295); //@line 936 "tr_languages.cpp"
        HEAP32[(($stress_flags448)>>2)]=262166; //@line 936 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 938 "tr_languages.cpp"
      }
      else if (__label__ == 45) {
  
        var $303=$tr; //@line 947 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($303, ((__ZZ16SelectTranslatorPKcE17stress_lengths_mk)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_mk)&4294967295)); //@line 947 "tr_languages.cpp"
        var $304=HEAP32[((((_charsets+20)&4294967295))>>2)]; //@line 948 "tr_languages.cpp"
        var $305=$tr; //@line 948 "tr_languages.cpp"
        var $charset_a0450=(($305+696)&4294967295); //@line 948 "tr_languages.cpp"
        HEAP32[(($charset_a0450)>>2)]=$304; //@line 948 "tr_languages.cpp"
        var $306=$tr; //@line 949 "tr_languages.cpp"
        var $letter_groups451=(($306+968)&4294967295); //@line 949 "tr_languages.cpp"
        var $arrayidx452=(($letter_groups451+28)&4294967295); //@line 949 "tr_languages.cpp"
        HEAP32[(($arrayidx452)>>2)]=((__ZZ16SelectTranslatorPKcE15vowels_cyrillic)&4294967295); //@line 949 "tr_languages.cpp"
        var $307=$tr; //@line 949 "tr_languages.cpp"
        var $letter_groups453=(($307+968)&4294967295); //@line 949 "tr_languages.cpp"
        var $arrayidx454=(($letter_groups453)&4294967295); //@line 949 "tr_languages.cpp"
        HEAP32[(($arrayidx454)>>2)]=((__ZZ16SelectTranslatorPKcE15vowels_cyrillic)&4294967295); //@line 949 "tr_languages.cpp"
        var $308=$tr; //@line 951 "tr_languages.cpp"
        var $langopts455=(($308)&4294967295); //@line 951 "tr_languages.cpp"
        var $stress_rule456=(($langopts455+8)&4294967295); //@line 951 "tr_languages.cpp"
        HEAP32[(($stress_rule456)>>2)]=4; //@line 951 "tr_languages.cpp"
        var $309=$tr; //@line 952 "tr_languages.cpp"
        var $langopts457=(($309)&4294967295); //@line 952 "tr_languages.cpp"
        var $numbers458=(($langopts457+184)&4294967295); //@line 952 "tr_languages.cpp"
        HEAP32[(($numbers458)>>2)]=2114600; //@line 952 "tr_languages.cpp"
        var $310=$tr; //@line 953 "tr_languages.cpp"
        var $langopts459=(($310)&4294967295); //@line 953 "tr_languages.cpp"
        var $numbers2460=(($langopts459+188)&4294967295); //@line 953 "tr_languages.cpp"
        HEAP32[(($numbers2460)>>2)]=138; //@line 953 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 955 "tr_languages.cpp"
      }
      else if (__label__ == 46) {
  
        var $311=$tr; //@line 962 "tr_languages.cpp"
        var $langopts462=(($311)&4294967295); //@line 962 "tr_languages.cpp"
        var $stress_rule463=(($langopts462+8)&4294967295); //@line 962 "tr_languages.cpp"
        HEAP32[(($stress_rule463)>>2)]=0; //@line 962 "tr_languages.cpp"
        var $312=$tr; //@line 963 "tr_languages.cpp"
        var $langopts464=(($312)&4294967295); //@line 963 "tr_languages.cpp"
        var $vowel_pause465=(($langopts464+4)&4294967295); //@line 963 "tr_languages.cpp"
        HEAP32[(($vowel_pause465)>>2)]=48; //@line 963 "tr_languages.cpp"
        var $313=$tr; //@line 964 "tr_languages.cpp"
        var $langopts466=(($313)&4294967295); //@line 964 "tr_languages.cpp"
        var $param467=(($langopts466+24)&4294967295); //@line 964 "tr_languages.cpp"
        var $arrayidx468=(($param467+4)&4294967295); //@line 964 "tr_languages.cpp"
        HEAP32[(($arrayidx468)>>2)]=1; //@line 964 "tr_languages.cpp"
        var $314=$tr; //@line 965 "tr_languages.cpp"
        var $langopts469=(($314)&4294967295); //@line 965 "tr_languages.cpp"
        var $param470=(($langopts469+24)&4294967295); //@line 965 "tr_languages.cpp"
        var $arrayidx471=(($param470+12)&4294967295); //@line 965 "tr_languages.cpp"
        HEAP32[(($arrayidx471)>>2)]=1; //@line 965 "tr_languages.cpp"
        var $315=$tr; //@line 966 "tr_languages.cpp"
        var $langopts472=(($315)&4294967295); //@line 966 "tr_languages.cpp"
        var $param473=(($langopts472+24)&4294967295); //@line 966 "tr_languages.cpp"
        var $arrayidx474=(($param473+16)&4294967295); //@line 966 "tr_languages.cpp"
        HEAP32[(($arrayidx474)>>2)]=16; //@line 966 "tr_languages.cpp"
        var $316=$tr; //@line 967 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($316, 121); //@line 967 "tr_languages.cpp"
        var $317=$tr; //@line 969 "tr_languages.cpp"
        var $langopts475=(($317)&4294967295); //@line 969 "tr_languages.cpp"
        var $numbers476=(($langopts475+184)&4294967295); //@line 969 "tr_languages.cpp"
        HEAP32[(($numbers476)>>2)]=2169880; //@line 969 "tr_languages.cpp"
        var $318=$tr; //@line 970 "tr_languages.cpp"
        var $langopts477=(($318)&4294967295); //@line 970 "tr_languages.cpp"
        var $ordinal_indicator=(($langopts477+216)&4294967295); //@line 970 "tr_languages.cpp"
        HEAP32[(($ordinal_indicator)>>2)]=((__str3633)&4294967295); //@line 970 "tr_languages.cpp"
        var $319=$tr; //@line 971 "tr_languages.cpp"
        var $langopts478=(($319)&4294967295); //@line 971 "tr_languages.cpp"
        var $stress_flags479=(($langopts478+12)&4294967295); //@line 971 "tr_languages.cpp"
        HEAP32[(($stress_flags479)>>2)]=128; //@line 971 "tr_languages.cpp"
        var $320=$tr; //@line 972 "tr_languages.cpp"
        var $stress_lengths=(($320+676)&4294967295); //@line 972 "tr_languages.cpp"
        var $arraydecay480=(($stress_lengths)&4294967295); //@line 972 "tr_languages.cpp"
        var $321=$arraydecay480; //@line 972 "tr_languages.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = __ZZ16SelectTranslatorPKcE17stress_lengths_nl;
        $dest$ = $321;
        $stop$ = $src$ + 16;
        if (($dest$%4) == ($src$%4) && 16 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 972 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 974 "tr_languages.cpp"
      }
      else if (__label__ == 47) {
  
        var $322=$tr; //@line 980 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($322, ((__ZZ16SelectTranslatorPKcE17stress_lengths_no)&4294967295), 0); //@line 980 "tr_languages.cpp"
        var $323=$tr; //@line 981 "tr_languages.cpp"
        var $langopts482=(($323)&4294967295); //@line 981 "tr_languages.cpp"
        var $stress_rule483=(($langopts482+8)&4294967295); //@line 981 "tr_languages.cpp"
        HEAP32[(($stress_rule483)>>2)]=0; //@line 981 "tr_languages.cpp"
        var $324=$tr; //@line 982 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($324, 121); //@line 982 "tr_languages.cpp"
        var $325=$tr; //@line 983 "tr_languages.cpp"
        var $langopts484=(($325)&4294967295); //@line 983 "tr_languages.cpp"
        var $numbers485=(($langopts484+184)&4294967295); //@line 983 "tr_languages.cpp"
        HEAP32[(($numbers485)>>2)]=71752; //@line 983 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 985 "tr_languages.cpp"
      }
      else if (__label__ == 48) {
  
        var $326=$tr; //@line 992 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($326, ((__ZZ16SelectTranslatorPKcE17stress_lengths_om)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_om)&4294967295)); //@line 992 "tr_languages.cpp"
        var $327=$tr; //@line 993 "tr_languages.cpp"
        var $langopts487=(($327)&4294967295); //@line 993 "tr_languages.cpp"
        var $stress_rule488=(($langopts487+8)&4294967295); //@line 993 "tr_languages.cpp"
        HEAP32[(($stress_rule488)>>2)]=2; //@line 993 "tr_languages.cpp"
        var $328=$tr; //@line 994 "tr_languages.cpp"
        var $langopts489=(($328)&4294967295); //@line 994 "tr_languages.cpp"
        var $stress_flags490=(($langopts489+12)&4294967295); //@line 994 "tr_languages.cpp"
        HEAP32[(($stress_flags490)>>2)]=524310; //@line 994 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 996 "tr_languages.cpp"
      }
      else if (__label__ == 49) {
  
        var $329=$tr; //@line 1003 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($329, ((__ZZ16SelectTranslatorPKcE17stress_lengths_pl)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_pl)&4294967295)); //@line 1003 "tr_languages.cpp"
        var $330=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1005 "tr_languages.cpp"
        var $331=$tr; //@line 1005 "tr_languages.cpp"
        var $charset_a0492=(($331+696)&4294967295); //@line 1005 "tr_languages.cpp"
        HEAP32[(($charset_a0492)>>2)]=$330; //@line 1005 "tr_languages.cpp"
        var $332=$tr; //@line 1006 "tr_languages.cpp"
        var $langopts493=(($332)&4294967295); //@line 1006 "tr_languages.cpp"
        var $stress_rule494=(($langopts493+8)&4294967295); //@line 1006 "tr_languages.cpp"
        HEAP32[(($stress_rule494)>>2)]=2; //@line 1006 "tr_languages.cpp"
        var $333=$tr; //@line 1007 "tr_languages.cpp"
        var $langopts495=(($333)&4294967295); //@line 1007 "tr_languages.cpp"
        var $stress_flags496=(($langopts495+12)&4294967295); //@line 1007 "tr_languages.cpp"
        HEAP32[(($stress_flags496)>>2)]=6; //@line 1007 "tr_languages.cpp"
        var $334=$tr; //@line 1008 "tr_languages.cpp"
        var $langopts497=(($334)&4294967295); //@line 1008 "tr_languages.cpp"
        var $param498=(($langopts497+24)&4294967295); //@line 1008 "tr_languages.cpp"
        var $arrayidx499=(($param498+16)&4294967295); //@line 1008 "tr_languages.cpp"
        HEAP32[(($arrayidx499)>>2)]=8; //@line 1008 "tr_languages.cpp"
        var $335=$tr; //@line 1009 "tr_languages.cpp"
        var $langopts500=(($335)&4294967295); //@line 1009 "tr_languages.cpp"
        var $max_initial_consonants501=(($langopts500+248)&4294967295); //@line 1009 "tr_languages.cpp"
        HEAP8[($max_initial_consonants501)]=7; //@line 1009 "tr_languages.cpp"
        var $336=$tr; //@line 1010 "tr_languages.cpp"
        var $langopts502=(($336)&4294967295); //@line 1010 "tr_languages.cpp"
        var $numbers503=(($langopts502+184)&4294967295); //@line 1010 "tr_languages.cpp"
        HEAP32[(($numbers503)>>2)]=20488; //@line 1010 "tr_languages.cpp"
        var $337=$tr; //@line 1011 "tr_languages.cpp"
        var $langopts504=(($337)&4294967295); //@line 1011 "tr_languages.cpp"
        var $numbers2505=(($langopts504+188)&4294967295); //@line 1011 "tr_languages.cpp"
        HEAP32[(($numbers2505)>>2)]=64; //@line 1011 "tr_languages.cpp"
        var $338=$tr; //@line 1012 "tr_languages.cpp"
        var $langopts506=(($338)&4294967295); //@line 1012 "tr_languages.cpp"
        var $param507=(($langopts506+24)&4294967295); //@line 1012 "tr_languages.cpp"
        var $arrayidx508=(($param507+44)&4294967295); //@line 1012 "tr_languages.cpp"
        HEAP32[(($arrayidx508)>>2)]=260; //@line 1012 "tr_languages.cpp"
        var $339=$tr; //@line 1013 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($339, 121); //@line 1013 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1015 "tr_languages.cpp"
      }
      else if (__label__ == 50) {
  
        var $340=$tr; //@line 1022 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($340, ((__ZZ16SelectTranslatorPKcE17stress_lengths_pt)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_pt)&4294967295)); //@line 1022 "tr_languages.cpp"
        var $341=$tr; //@line 1023 "tr_languages.cpp"
        var $langopts510=(($341)&4294967295); //@line 1023 "tr_languages.cpp"
        var $length_mods511=(($langopts510+176)&4294967295); //@line 1023 "tr_languages.cpp"
        var $342=HEAP32[(($length_mods511)>>2)]; //@line 1023 "tr_languages.cpp"
        var $343=$tr; //@line 1023 "tr_languages.cpp"
        var $langopts512=(($343)&4294967295); //@line 1023 "tr_languages.cpp"
        var $length_mods0513=(($langopts512+180)&4294967295); //@line 1023 "tr_languages.cpp"
        HEAP32[(($length_mods0513)>>2)]=$342; //@line 1023 "tr_languages.cpp"
        var $344=$tr; //@line 1025 "tr_languages.cpp"
        var $langopts514=(($344)&4294967295); //@line 1025 "tr_languages.cpp"
        var $stress_rule515=(($langopts514+8)&4294967295); //@line 1025 "tr_languages.cpp"
        HEAP32[(($stress_rule515)>>2)]=3; //@line 1025 "tr_languages.cpp"
        var $345=$tr; //@line 1026 "tr_languages.cpp"
        var $langopts516=(($345)&4294967295); //@line 1026 "tr_languages.cpp"
        var $stress_flags517=(($langopts516+12)&4294967295); //@line 1026 "tr_languages.cpp"
        HEAP32[(($stress_flags517)>>2)]=139286; //@line 1026 "tr_languages.cpp"
        var $346=$tr; //@line 1027 "tr_languages.cpp"
        var $langopts518=(($346)&4294967295); //@line 1027 "tr_languages.cpp"
        var $numbers519=(($langopts518+184)&4294967295); //@line 1027 "tr_languages.cpp"
        HEAP32[(($numbers519)>>2)]=16793704; //@line 1027 "tr_languages.cpp"
        var $347=$tr; //@line 1028 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($347, 121); //@line 1028 "tr_languages.cpp"
        var $348=$tr; //@line 1029 "tr_languages.cpp"
        __ZL15ResetLetterBitsP10Translatori($348, 2); //@line 1029 "tr_languages.cpp"
        var $349=$tr; //@line 1030 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($349, 1, ((__str4634)&4294967295)); //@line 1030 "tr_languages.cpp"
        var $350=$tr; //@line 1031 "tr_languages.cpp"
        var $langopts520=(($350)&4294967295); //@line 1031 "tr_languages.cpp"
        var $param521=(($langopts520+24)&4294967295); //@line 1031 "tr_languages.cpp"
        var $arrayidx522=(($param521+60)&4294967295); //@line 1031 "tr_languages.cpp"
        HEAP32[(($arrayidx522)>>2)]=2; //@line 1031 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1033 "tr_languages.cpp"
      }
      else if (__label__ == 51) {
  
        var $351=$tr; //@line 1040 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($351, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ro)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ro)&4294967295)); //@line 1040 "tr_languages.cpp"
        var $352=$tr; //@line 1042 "tr_languages.cpp"
        var $langopts524=(($352)&4294967295); //@line 1042 "tr_languages.cpp"
        var $stress_rule525=(($langopts524+8)&4294967295); //@line 1042 "tr_languages.cpp"
        HEAP32[(($stress_rule525)>>2)]=2; //@line 1042 "tr_languages.cpp"
        var $353=$tr; //@line 1043 "tr_languages.cpp"
        var $langopts526=(($353)&4294967295); //@line 1043 "tr_languages.cpp"
        var $stress_flags527=(($langopts526+12)&4294967295); //@line 1043 "tr_languages.cpp"
        HEAP32[(($stress_flags527)>>2)]=262; //@line 1043 "tr_languages.cpp"
        var $354=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1045 "tr_languages.cpp"
        var $355=$tr; //@line 1045 "tr_languages.cpp"
        var $charset_a0528=(($355+696)&4294967295); //@line 1045 "tr_languages.cpp"
        HEAP32[(($charset_a0528)>>2)]=$354; //@line 1045 "tr_languages.cpp"
        var $356=$tr; //@line 1046 "tr_languages.cpp"
        var $langopts529=(($356)&4294967295); //@line 1046 "tr_languages.cpp"
        var $numbers530=(($langopts529+184)&4294967295); //@line 1046 "tr_languages.cpp"
        HEAP32[(($numbers530)>>2)]=16805928; //@line 1046 "tr_languages.cpp"
        var $357=$tr; //@line 1047 "tr_languages.cpp"
        var $langopts531=(($357)&4294967295); //@line 1047 "tr_languages.cpp"
        var $numbers2532=(($langopts531+188)&4294967295); //@line 1047 "tr_languages.cpp"
        HEAP32[(($numbers2532)>>2)]=30; //@line 1047 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1049 "tr_languages.cpp"
      }
      else if (__label__ == 52) {
  
        var $358=$tr; //@line 1052 "tr_languages.cpp"
        __ZL18Translator_RussianP10Translator($358); //@line 1052 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1053 "tr_languages.cpp"
      }
      else if (__label__ == 53) {
  
        var $359=$tr; //@line 1057 "tr_languages.cpp"
        var $langopts535=(($359)&4294967295); //@line 1057 "tr_languages.cpp"
        var $stress_rule536=(($langopts535+8)&4294967295); //@line 1057 "tr_languages.cpp"
        HEAP32[(($stress_rule536)>>2)]=2; //@line 1057 "tr_languages.cpp"
        var $360=$tr; //@line 1058 "tr_languages.cpp"
        var $langopts537=(($360)&4294967295); //@line 1058 "tr_languages.cpp"
        var $stress_flags538=(($langopts537+12)&4294967295); //@line 1058 "tr_languages.cpp"
        HEAP32[(($stress_flags538)>>2)]=22; //@line 1058 "tr_languages.cpp"
        var $361=$tr; //@line 1059 "tr_languages.cpp"
        var $langopts539=(($361)&4294967295); //@line 1059 "tr_languages.cpp"
        var $length_mods540=(($langopts539+176)&4294967295); //@line 1059 "tr_languages.cpp"
        var $362=HEAP32[(($length_mods540)>>2)]; //@line 1059 "tr_languages.cpp"
        var $363=$tr; //@line 1059 "tr_languages.cpp"
        var $langopts541=(($363)&4294967295); //@line 1059 "tr_languages.cpp"
        var $length_mods0542=(($langopts541+180)&4294967295); //@line 1059 "tr_languages.cpp"
        HEAP32[(($length_mods0542)>>2)]=$362; //@line 1059 "tr_languages.cpp"
        var $364=$tr; //@line 1061 "tr_languages.cpp"
        var $langopts543=(($364)&4294967295); //@line 1061 "tr_languages.cpp"
        var $numbers544=(($langopts543+184)&4294967295); //@line 1061 "tr_languages.cpp"
        HEAP32[(($numbers544)>>2)]=278624; //@line 1061 "tr_languages.cpp"
        var $365=$tr; //@line 1062 "tr_languages.cpp"
        var $langopts545=(($365)&4294967295); //@line 1062 "tr_languages.cpp"
        var $numbers2546=(($langopts545+188)&4294967295); //@line 1062 "tr_languages.cpp"
        HEAP32[(($numbers2546)>>2)]=512; //@line 1062 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1064 "tr_languages.cpp"
      }
      else if (__label__ == 54) {
  
        var $366=$tr; //@line 1071 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($366, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sk)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sk)&4294967295)); //@line 1071 "tr_languages.cpp"
        var $367=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1072 "tr_languages.cpp"
        var $368=$tr; //@line 1072 "tr_languages.cpp"
        var $charset_a0548=(($368+696)&4294967295); //@line 1072 "tr_languages.cpp"
        HEAP32[(($charset_a0548)>>2)]=$367; //@line 1072 "tr_languages.cpp"
        var $369=$tr; //@line 1074 "tr_languages.cpp"
        var $langopts549=(($369)&4294967295); //@line 1074 "tr_languages.cpp"
        var $stress_rule550=(($langopts549+8)&4294967295); //@line 1074 "tr_languages.cpp"
        HEAP32[(($stress_rule550)>>2)]=0; //@line 1074 "tr_languages.cpp"
        var $370=$tr; //@line 1075 "tr_languages.cpp"
        var $langopts551=(($370)&4294967295); //@line 1075 "tr_languages.cpp"
        var $stress_flags552=(($langopts551+12)&4294967295); //@line 1075 "tr_languages.cpp"
        HEAP32[(($stress_flags552)>>2)]=22; //@line 1075 "tr_languages.cpp"
        var $371=$tr; //@line 1076 "tr_languages.cpp"
        var $langopts553=(($371)&4294967295); //@line 1076 "tr_languages.cpp"
        var $param554=(($langopts553+24)&4294967295); //@line 1076 "tr_languages.cpp"
        var $arrayidx555=(($param554+16)&4294967295); //@line 1076 "tr_languages.cpp"
        HEAP32[(($arrayidx555)>>2)]=3; //@line 1076 "tr_languages.cpp"
        var $372=$tr; //@line 1077 "tr_languages.cpp"
        var $langopts556=(($372)&4294967295); //@line 1077 "tr_languages.cpp"
        var $max_initial_consonants557=(($langopts556+248)&4294967295); //@line 1077 "tr_languages.cpp"
        HEAP8[($max_initial_consonants557)]=5; //@line 1077 "tr_languages.cpp"
        var $373=$tr; //@line 1078 "tr_languages.cpp"
        var $langopts558=(($373)&4294967295); //@line 1078 "tr_languages.cpp"
        var $spelling_stress559=(($langopts558+249)&4294967295); //@line 1078 "tr_languages.cpp"
        HEAP8[($spelling_stress559)]=1; //@line 1078 "tr_languages.cpp"
        var $374=$tr; //@line 1079 "tr_languages.cpp"
        var $langopts560=(($374)&4294967295); //@line 1079 "tr_languages.cpp"
        var $param561=(($langopts560+24)&4294967295); //@line 1079 "tr_languages.cpp"
        var $arrayidx562=(($param561+44)&4294967295); //@line 1079 "tr_languages.cpp"
        HEAP32[(($arrayidx562)>>2)]=4; //@line 1079 "tr_languages.cpp"
        var $375=$tr; //@line 1081 "tr_languages.cpp"
        var $langopts563=(($375)&4294967295); //@line 1081 "tr_languages.cpp"
        var $numbers564=(($langopts563+184)&4294967295); //@line 1081 "tr_languages.cpp"
        HEAP32[(($numbers564)>>2)]=16794624; //@line 1081 "tr_languages.cpp"
        var $376=$tr; //@line 1082 "tr_languages.cpp"
        var $langopts565=(($376)&4294967295); //@line 1082 "tr_languages.cpp"
        var $numbers2566=(($langopts565+188)&4294967295); //@line 1082 "tr_languages.cpp"
        HEAP32[(($numbers2566)>>2)]=256; //@line 1082 "tr_languages.cpp"
        var $377=$tr; //@line 1083 "tr_languages.cpp"
        var $langopts567=(($377)&4294967295); //@line 1083 "tr_languages.cpp"
        var $thousands_sep568=(($langopts567+204)&4294967295); //@line 1083 "tr_languages.cpp"
        HEAP32[(($thousands_sep568)>>2)]=0; //@line 1083 "tr_languages.cpp"
        var $378=$tr; //@line 1084 "tr_languages.cpp"
        var $langopts569=(($378)&4294967295); //@line 1084 "tr_languages.cpp"
        var $decimal_sep570=(($langopts569+208)&4294967295); //@line 1084 "tr_languages.cpp"
        HEAP32[(($decimal_sep570)>>2)]=44; //@line 1084 "tr_languages.cpp"
        var $379=$name2; //@line 1086 "tr_languages.cpp"
        var $cmp571=((($379))|0)==25459; //@line 1086 "tr_languages.cpp"
        if ($cmp571) { __label__ = 55;; } else { __label__ = 56;; } //@line 1086 "tr_languages.cpp"
        if (__label__ == 55) {
  
          var $380=$tr; //@line 1088 "tr_languages.cpp"
          var $langopts573=(($380)&4294967295); //@line 1088 "tr_languages.cpp"
          var $numbers2574=(($langopts573+188)&4294967295); //@line 1088 "tr_languages.cpp"
          HEAP32[(($numbers2574)>>2)]=264; //@line 1088 "tr_languages.cpp"
          ; //@line 1089 "tr_languages.cpp"
        }
  
        var $381=$tr; //@line 1091 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($381, 121); //@line 1091 "tr_languages.cpp"
        var $382=$tr; //@line 1092 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($382, 114); //@line 1092 "tr_languages.cpp"
        var $383=$tr; //@line 1093 "tr_languages.cpp"
        __ZL15ResetLetterBitsP10Translatori($383, 32); //@line 1093 "tr_languages.cpp"
        var $384=$tr; //@line 1094 "tr_languages.cpp"
        __ZL13SetLetterBitsP10TranslatoriPKc($384, 5, ((__str5635)&4294967295)); //@line 1094 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1096 "tr_languages.cpp"
      }
      else if (__label__ == 57) {
  
        var $385=$tr; //@line 1100 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($385, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 1100 "tr_languages.cpp"
        var $386=$tr; //@line 1101 "tr_languages.cpp"
        var $langopts577=(($386)&4294967295); //@line 1101 "tr_languages.cpp"
        var $length_mods578=(($langopts577+176)&4294967295); //@line 1101 "tr_languages.cpp"
        var $387=HEAP32[(($length_mods578)>>2)]; //@line 1101 "tr_languages.cpp"
        var $388=$tr; //@line 1101 "tr_languages.cpp"
        var $langopts579=(($388)&4294967295); //@line 1101 "tr_languages.cpp"
        var $length_mods0580=(($langopts579+180)&4294967295); //@line 1101 "tr_languages.cpp"
        HEAP32[(($length_mods0580)>>2)]=$387; //@line 1101 "tr_languages.cpp"
        var $389=$tr; //@line 1103 "tr_languages.cpp"
        var $langopts581=(($389)&4294967295); //@line 1103 "tr_languages.cpp"
        var $stress_rule582=(($langopts581+8)&4294967295); //@line 1103 "tr_languages.cpp"
        HEAP32[(($stress_rule582)>>2)]=0; //@line 1103 "tr_languages.cpp"
        var $390=$tr; //@line 1104 "tr_languages.cpp"
        var $langopts583=(($390)&4294967295); //@line 1104 "tr_languages.cpp"
        var $stress_flags584=(($langopts583+12)&4294967295); //@line 1104 "tr_languages.cpp"
        HEAP32[(($stress_flags584)>>2)]=65556; //@line 1104 "tr_languages.cpp"
        var $391=$tr; //@line 1105 "tr_languages.cpp"
        var $langopts585=(($391)&4294967295); //@line 1105 "tr_languages.cpp"
        var $spelling_stress586=(($langopts585+249)&4294967295); //@line 1105 "tr_languages.cpp"
        HEAP8[($spelling_stress586)]=1; //@line 1105 "tr_languages.cpp"
        var $392=$tr; //@line 1107 "tr_languages.cpp"
        var $letter_bits_offset587=(($392+964)&4294967295); //@line 1107 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset587)>>2)]=3456; //@line 1107 "tr_languages.cpp"
        var $393=$tr; //@line 1108 "tr_languages.cpp"
        var $letter_bits588=(($393+708)&4294967295); //@line 1108 "tr_languages.cpp"
        var $arraydecay589=(($letter_bits588)&4294967295); //@line 1108 "tr_languages.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $arraydecay589;
        $stop$ = $dest$ + 256;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 1108 "tr_languages.cpp"
        var $394=$tr; //@line 1109 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($394, 0, 5, 22); //@line 1109 "tr_languages.cpp"
        var $395=$tr; //@line 1110 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($395, 0, 74, 115); //@line 1110 "tr_languages.cpp"
        var $396=$tr; //@line 1112 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($396, 1, 74, 115); //@line 1112 "tr_languages.cpp"
        var $397=$tr; //@line 1114 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($397, 2, 26, 70); //@line 1114 "tr_languages.cpp"
        var $398=$tr; //@line 1116 "tr_languages.cpp"
        var $langopts590=(($398)&4294967295); //@line 1116 "tr_languages.cpp"
        var $param591=(($langopts590+24)&4294967295); //@line 1116 "tr_languages.cpp"
        var $arrayidx592=(($param591+20)&4294967295); //@line 1116 "tr_languages.cpp"
        HEAP32[(($arrayidx592)>>2)]=1; //@line 1116 "tr_languages.cpp"
        var $399=$tr; //@line 1117 "tr_languages.cpp"
        var $letter_bits_offset593=(($399+964)&4294967295); //@line 1117 "tr_languages.cpp"
        var $400=HEAP32[(($letter_bits_offset593)>>2)]; //@line 1117 "tr_languages.cpp"
        var $add594=((($400)+74)&4294967295); //@line 1117 "tr_languages.cpp"
        var $401=$tr; //@line 1117 "tr_languages.cpp"
        var $langopts595=(($401)&4294967295); //@line 1117 "tr_languages.cpp"
        var $suffix_add_e596=(($langopts595+276)&4294967295); //@line 1117 "tr_languages.cpp"
        HEAP32[(($suffix_add_e596)>>2)]=$add594; //@line 1117 "tr_languages.cpp"
        var $402=$tr; //@line 1118 "tr_languages.cpp"
        var $langopts597=(($402)&4294967295); //@line 1118 "tr_languages.cpp"
        var $numbers598=(($langopts597+184)&4294967295); //@line 1118 "tr_languages.cpp"
        HEAP32[(($numbers598)>>2)]=2097152; //@line 1118 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1120 "tr_languages.cpp"
      }
      else if (__label__ == 58) {
  
        var $403=HEAP32[((((_charsets+8)&4294967295))>>2)]; //@line 1123 "tr_languages.cpp"
        var $404=$tr; //@line 1123 "tr_languages.cpp"
        var $charset_a0600=(($404+696)&4294967295); //@line 1123 "tr_languages.cpp"
        HEAP32[(($charset_a0600)>>2)]=$403; //@line 1123 "tr_languages.cpp"
        var $405=$tr; //@line 1124 "tr_languages.cpp"
        var $langopts601=(($405)&4294967295); //@line 1124 "tr_languages.cpp"
        var $stress_rule602=(($langopts601+8)&4294967295); //@line 1124 "tr_languages.cpp"
        HEAP32[(($stress_rule602)>>2)]=2; //@line 1124 "tr_languages.cpp"
        var $406=$tr; //@line 1125 "tr_languages.cpp"
        var $langopts603=(($406)&4294967295); //@line 1125 "tr_languages.cpp"
        var $stress_flags604=(($langopts603+12)&4294967295); //@line 1125 "tr_languages.cpp"
        HEAP32[(($stress_flags604)>>2)]=32; //@line 1125 "tr_languages.cpp"
        var $407=$tr; //@line 1126 "tr_languages.cpp"
        var $langopts605=(($407)&4294967295); //@line 1126 "tr_languages.cpp"
        var $param606=(($langopts605+24)&4294967295); //@line 1126 "tr_languages.cpp"
        var $arrayidx607=(($param606+16)&4294967295); //@line 1126 "tr_languages.cpp"
        HEAP32[(($arrayidx607)>>2)]=19; //@line 1126 "tr_languages.cpp"
        var $408=$tr; //@line 1127 "tr_languages.cpp"
        var $langopts608=(($408)&4294967295); //@line 1127 "tr_languages.cpp"
        var $numbers609=(($langopts608+184)&4294967295); //@line 1127 "tr_languages.cpp"
        HEAP32[(($numbers609)>>2)]=16864280; //@line 1127 "tr_languages.cpp"
        var $409=$tr; //@line 1128 "tr_languages.cpp"
        var $langopts610=(($409)&4294967295); //@line 1128 "tr_languages.cpp"
        var $numbers2611=(($langopts610+188)&4294967295); //@line 1128 "tr_languages.cpp"
        HEAP32[(($numbers2611)>>2)]=256; //@line 1128 "tr_languages.cpp"
        var $410=$tr; //@line 1129 "tr_languages.cpp"
        var $langopts612=(($410)&4294967295); //@line 1129 "tr_languages.cpp"
        var $thousands_sep613=(($langopts612+204)&4294967295); //@line 1129 "tr_languages.cpp"
        HEAP32[(($thousands_sep613)>>2)]=32; //@line 1129 "tr_languages.cpp"
        var $411=$tr; //@line 1130 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($411, 114); //@line 1130 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1131 "tr_languages.cpp"
      }
      else if (__label__ == 59) {
  
        var $412=$tr; //@line 1138 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($412, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sq)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sq)&4294967295)); //@line 1138 "tr_languages.cpp"
        var $413=$tr; //@line 1140 "tr_languages.cpp"
        var $langopts615=(($413)&4294967295); //@line 1140 "tr_languages.cpp"
        var $stress_rule616=(($langopts615+8)&4294967295); //@line 1140 "tr_languages.cpp"
        HEAP32[(($stress_rule616)>>2)]=2; //@line 1140 "tr_languages.cpp"
        var $414=$tr; //@line 1141 "tr_languages.cpp"
        var $langopts617=(($414)&4294967295); //@line 1141 "tr_languages.cpp"
        var $stress_flags618=(($langopts617+12)&4294967295); //@line 1141 "tr_languages.cpp"
        HEAP32[(($stress_flags618)>>2)]=278; //@line 1141 "tr_languages.cpp"
        var $415=$tr; //@line 1142 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($415, 121); //@line 1142 "tr_languages.cpp"
        var $416=$tr; //@line 1143 "tr_languages.cpp"
        var $langopts619=(($416)&4294967295); //@line 1143 "tr_languages.cpp"
        var $numbers620=(($langopts619+184)&4294967295); //@line 1143 "tr_languages.cpp"
        HEAP32[(($numbers620)>>2)]=32872; //@line 1143 "tr_languages.cpp"
        var $417=$tr; //@line 1144 "tr_languages.cpp"
        var $langopts621=(($417)&4294967295); //@line 1144 "tr_languages.cpp"
        var $accents622=(($langopts621+220)&4294967295); //@line 1144 "tr_languages.cpp"
        HEAP32[(($accents622)>>2)]=2; //@line 1144 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1146 "tr_languages.cpp"
      }
      else if (__label__ == 60) {
  
        var $418=$tr; //@line 1153 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($418, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sv)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sv)&4294967295)); //@line 1153 "tr_languages.cpp"
        var $419=$tr; //@line 1155 "tr_languages.cpp"
        var $langopts624=(($419)&4294967295); //@line 1155 "tr_languages.cpp"
        var $stress_rule625=(($langopts624+8)&4294967295); //@line 1155 "tr_languages.cpp"
        HEAP32[(($stress_rule625)>>2)]=0; //@line 1155 "tr_languages.cpp"
        var $420=$tr; //@line 1156 "tr_languages.cpp"
        __ZL14SetLetterVowelP10Translatori($420, 121); //@line 1156 "tr_languages.cpp"
        var $421=$tr; //@line 1157 "tr_languages.cpp"
        var $langopts626=(($421)&4294967295); //@line 1157 "tr_languages.cpp"
        var $numbers627=(($langopts626+184)&4294967295); //@line 1157 "tr_languages.cpp"
        HEAP32[(($numbers627)>>2)]=6408; //@line 1157 "tr_languages.cpp"
        var $422=$tr; //@line 1158 "tr_languages.cpp"
        var $langopts628=(($422)&4294967295); //@line 1158 "tr_languages.cpp"
        var $accents629=(($langopts628+220)&4294967295); //@line 1158 "tr_languages.cpp"
        HEAP32[(($accents629)>>2)]=1; //@line 1158 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1160 "tr_languages.cpp"
      }
      else if (__label__ == 61) {
  
        var $423=$tr; //@line 1168 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($423, ((__ZZ16SelectTranslatorPKcE17stress_lengths_sw)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_sw)&4294967295)); //@line 1168 "tr_languages.cpp"
        var $424=$tr; //@line 1169 "tr_languages.cpp"
        var $langopts631=(($424)&4294967295); //@line 1169 "tr_languages.cpp"
        var $length_mods632=(($langopts631+176)&4294967295); //@line 1169 "tr_languages.cpp"
        var $425=HEAP32[(($length_mods632)>>2)]; //@line 1169 "tr_languages.cpp"
        var $426=$tr; //@line 1169 "tr_languages.cpp"
        var $langopts633=(($426)&4294967295); //@line 1169 "tr_languages.cpp"
        var $length_mods0634=(($langopts633+180)&4294967295); //@line 1169 "tr_languages.cpp"
        HEAP32[(($length_mods0634)>>2)]=$425; //@line 1169 "tr_languages.cpp"
        var $427=$tr; //@line 1171 "tr_languages.cpp"
        var $langopts635=(($427)&4294967295); //@line 1171 "tr_languages.cpp"
        var $vowel_pause636=(($langopts635+4)&4294967295); //@line 1171 "tr_languages.cpp"
        HEAP32[(($vowel_pause636)>>2)]=1; //@line 1171 "tr_languages.cpp"
        var $428=$tr; //@line 1172 "tr_languages.cpp"
        var $langopts637=(($428)&4294967295); //@line 1172 "tr_languages.cpp"
        var $stress_rule638=(($langopts637+8)&4294967295); //@line 1172 "tr_languages.cpp"
        HEAP32[(($stress_rule638)>>2)]=2; //@line 1172 "tr_languages.cpp"
        var $429=$tr; //@line 1173 "tr_languages.cpp"
        var $langopts639=(($429)&4294967295); //@line 1173 "tr_languages.cpp"
        var $stress_flags640=(($langopts639+12)&4294967295); //@line 1173 "tr_languages.cpp"
        HEAP32[(($stress_flags640)>>2)]=22; //@line 1173 "tr_languages.cpp"
        var $430=$tr; //@line 1175 "tr_languages.cpp"
        var $langopts641=(($430)&4294967295); //@line 1175 "tr_languages.cpp"
        var $numbers642=(($langopts641+184)&4294967295); //@line 1175 "tr_languages.cpp"
        HEAP32[(($numbers642)>>2)]=1248; //@line 1175 "tr_languages.cpp"
        var $431=$tr; //@line 1176 "tr_languages.cpp"
        var $langopts643=(($431)&4294967295); //@line 1176 "tr_languages.cpp"
        var $break_numbers644=(($langopts643+192)&4294967295); //@line 1176 "tr_languages.cpp"
        HEAP32[(($break_numbers644)>>2)]=1227133544; //@line 1176 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1178 "tr_languages.cpp"
      }
      else if (__label__ == 62) {
  
        var $432=$tr; //@line 1186 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($432, ((__ZZ16SelectTranslatorPKcE17stress_lengths_ta)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_ta)&4294967295)); //@line 1186 "tr_languages.cpp"
        var $433=$tr; //@line 1187 "tr_languages.cpp"
        var $langopts646=(($433)&4294967295); //@line 1187 "tr_languages.cpp"
        var $length_mods647=(($langopts646+176)&4294967295); //@line 1187 "tr_languages.cpp"
        var $434=HEAP32[(($length_mods647)>>2)]; //@line 1187 "tr_languages.cpp"
        var $435=$tr; //@line 1187 "tr_languages.cpp"
        var $langopts648=(($435)&4294967295); //@line 1187 "tr_languages.cpp"
        var $length_mods0649=(($langopts648+180)&4294967295); //@line 1187 "tr_languages.cpp"
        HEAP32[(($length_mods0649)>>2)]=$434; //@line 1187 "tr_languages.cpp"
        var $436=$tr; //@line 1189 "tr_languages.cpp"
        var $langopts650=(($436)&4294967295); //@line 1189 "tr_languages.cpp"
        var $stress_rule651=(($langopts650+8)&4294967295); //@line 1189 "tr_languages.cpp"
        HEAP32[(($stress_rule651)>>2)]=0; //@line 1189 "tr_languages.cpp"
        var $437=$tr; //@line 1190 "tr_languages.cpp"
        var $langopts652=(($437)&4294967295); //@line 1190 "tr_languages.cpp"
        var $stress_flags653=(($langopts652+12)&4294967295); //@line 1190 "tr_languages.cpp"
        HEAP32[(($stress_flags653)>>2)]=65540; //@line 1190 "tr_languages.cpp"
        var $438=$tr; //@line 1191 "tr_languages.cpp"
        var $langopts654=(($438)&4294967295); //@line 1191 "tr_languages.cpp"
        var $spelling_stress655=(($langopts654+249)&4294967295); //@line 1191 "tr_languages.cpp"
        HEAP8[($spelling_stress655)]=1; //@line 1191 "tr_languages.cpp"
        var $439=$tr; //@line 1192 "tr_languages.cpp"
        var $langopts656=(($439)&4294967295); //@line 1192 "tr_languages.cpp"
        var $break_numbers657=(($langopts656+192)&4294967295); //@line 1192 "tr_languages.cpp"
        HEAP32[(($break_numbers657)>>2)]=5288; //@line 1192 "tr_languages.cpp"
        var $440=$name2; //@line 1194 "tr_languages.cpp"
        var $cmp658=((($440))|0)==29793; //@line 1194 "tr_languages.cpp"
        if ($cmp658) { __lastLabel__ = 62; __label__ = 63;; } else { __lastLabel__ = 62; __label__ = 64;; } //@line 1194 "tr_languages.cpp"
        if (__label__ == 63) {
  
          var $441=$tr; //@line 1196 "tr_languages.cpp"
          var $letter_bits_offset660=(($441+964)&4294967295); //@line 1196 "tr_languages.cpp"
          HEAP32[(($letter_bits_offset660)>>2)]=2944; //@line 1196 "tr_languages.cpp"
          var $442=$tr; //@line 1197 "tr_languages.cpp"
          var $langopts661=(($442)&4294967295); //@line 1197 "tr_languages.cpp"
          var $numbers662=(($langopts661+184)&4294967295); //@line 1197 "tr_languages.cpp"
          HEAP32[(($numbers662)>>2)]=2097152; //@line 1197 "tr_languages.cpp"
          var $_pr=$name2; //@line 1199 "tr_languages.cpp"
          __lastLabel__ = 63; ; //@line 1198 "tr_languages.cpp"
        }
  
        var $443=__lastLabel__ == 63 ? $_pr : ($440); //@line 1199 "tr_languages.cpp"
        var $cmp664=((($443))|0)==28018; //@line 1199 "tr_languages.cpp"
        if ($cmp664) { __label__ = 65;; } else { __label__ = 66;; } //@line 1199 "tr_languages.cpp"
        $if_then665$$if_else667$75: do { 
          if (__label__ == 65) {
  
            var $444=$tr; //@line 1201 "tr_languages.cpp"
            var $letter_bits_offset666=(($444+964)&4294967295); //@line 1201 "tr_languages.cpp"
            HEAP32[(($letter_bits_offset666)>>2)]=2304; //@line 1201 "tr_languages.cpp"
            ; //@line 1202 "tr_languages.cpp"
          }
          else if (__label__ == 66) {
  
            var $445=$name2; //@line 1204 "tr_languages.cpp"
            var $cmp668=((($445))|0)==28012; //@line 1204 "tr_languages.cpp"
            if ($cmp668) { __label__ = 67;; } else { __label__ = 68;; } //@line 1204 "tr_languages.cpp"
            if (__label__ == 67) {
  
              var $446=$tr; //@line 1206 "tr_languages.cpp"
              var $letter_bits_offset670=(($446+964)&4294967295); //@line 1206 "tr_languages.cpp"
              HEAP32[(($letter_bits_offset670)>>2)]=3328; //@line 1206 "tr_languages.cpp"
              var $447=$tr; //@line 1207 "tr_languages.cpp"
              var $langopts671=(($447)&4294967295); //@line 1207 "tr_languages.cpp"
              var $numbers672=(($langopts671+184)&4294967295); //@line 1207 "tr_languages.cpp"
              HEAP32[(($numbers672)>>2)]=2097152; //@line 1207 "tr_languages.cpp"
              ; //@line 1208 "tr_languages.cpp"
            }
            else if (__label__ == 68) {
  
              var $448=$name2; //@line 1210 "tr_languages.cpp"
              var $cmp674=((($448))|0)==27502; //@line 1210 "tr_languages.cpp"
              if ($cmp674) { __label__ = 69;; } else { __label__ = 70;; } //@line 1210 "tr_languages.cpp"
              if (__label__ == 69) {
  
                var $449=$tr; //@line 1212 "tr_languages.cpp"
                var $letter_bits_offset676=(($449+964)&4294967295); //@line 1212 "tr_languages.cpp"
                HEAP32[(($letter_bits_offset676)>>2)]=3200; //@line 1212 "tr_languages.cpp"
                var $450=$tr; //@line 1213 "tr_languages.cpp"
                var $langopts677=(($450)&4294967295); //@line 1213 "tr_languages.cpp"
                var $numbers678=(($langopts677+184)&4294967295); //@line 1213 "tr_languages.cpp"
                HEAP32[(($numbers678)>>2)]=1; //@line 1213 "tr_languages.cpp"
                ; //@line 1214 "tr_languages.cpp"
              }
              else if (__label__ == 70) {
  
                var $451=$name2; //@line 1216 "tr_languages.cpp"
                var $cmp680=((($451))|0)==29797; //@line 1216 "tr_languages.cpp"
                if (!($cmp680)) { __label__ = 72;break $if_then665$$if_else667$75; } //@line 1216 "tr_languages.cpp"
  
                var $452=$tr; //@line 1218 "tr_languages.cpp"
                var $letter_bits_offset682=(($452+964)&4294967295); //@line 1218 "tr_languages.cpp"
                HEAP32[(($letter_bits_offset682)>>2)]=3072; //@line 1218 "tr_languages.cpp"
                var $453=$tr; //@line 1219 "tr_languages.cpp"
                var $langopts683=(($453)&4294967295); //@line 1219 "tr_languages.cpp"
                var $numbers684=(($langopts683+184)&4294967295); //@line 1219 "tr_languages.cpp"
                HEAP32[(($numbers684)>>2)]=1; //@line 1219 "tr_languages.cpp"
                ; //@line 1220 "tr_languages.cpp"
              }
            }
          }
        } while(0);
  
        var $454=$tr; //@line 1221 "tr_languages.cpp"
        var $langopts689=(($454)&4294967295); //@line 1221 "tr_languages.cpp"
        var $param690=(($langopts689+24)&4294967295); //@line 1221 "tr_languages.cpp"
        var $arrayidx691=(($param690+32)&4294967295); //@line 1221 "tr_languages.cpp"
        HEAP32[(($arrayidx691)>>2)]=1; //@line 1221 "tr_languages.cpp"
        var $455=$tr; //@line 1222 "tr_languages.cpp"
        __Z15SetIndicLettersP10Translator($455); //@line 1222 "tr_languages.cpp"
        var $456=$tr; //@line 1223 "tr_languages.cpp"
        __ZL18SetLetterBitsRangeP10Translatoriii($456, 1, 78, 78); //@line 1223 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1225 "tr_languages.cpp"
      }
      else if (__label__ == 73) {
  
        var $457=$tr; //@line 1250 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($457, ((__ZZ16SelectTranslatorPKcE17stress_lengths_tr)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_tr)&4294967295)); //@line 1250 "tr_languages.cpp"
        var $458=HEAP32[((((_charsets+36)&4294967295))>>2)]; //@line 1251 "tr_languages.cpp"
        var $459=$tr; //@line 1251 "tr_languages.cpp"
        var $charset_a0693=(($459+696)&4294967295); //@line 1251 "tr_languages.cpp"
        HEAP32[(($charset_a0693)>>2)]=$458; //@line 1251 "tr_languages.cpp"
        var $460=$tr; //@line 1253 "tr_languages.cpp"
        var $langopts694=(($460)&4294967295); //@line 1253 "tr_languages.cpp"
        var $stress_rule695=(($langopts694+8)&4294967295); //@line 1253 "tr_languages.cpp"
        HEAP32[(($stress_rule695)>>2)]=7; //@line 1253 "tr_languages.cpp"
        var $461=$tr; //@line 1254 "tr_languages.cpp"
        var $langopts696=(($461)&4294967295); //@line 1254 "tr_languages.cpp"
        var $stress_flags697=(($langopts696+12)&4294967295); //@line 1254 "tr_languages.cpp"
        HEAP32[(($stress_flags697)>>2)]=32; //@line 1254 "tr_languages.cpp"
        var $462=$tr; //@line 1256 "tr_languages.cpp"
        var $langopts698=(($462)&4294967295); //@line 1256 "tr_languages.cpp"
        var $numbers699=(($langopts698+184)&4294967295); //@line 1256 "tr_languages.cpp"
        HEAP32[(($numbers699)>>2)]=2114824; //@line 1256 "tr_languages.cpp"
        var $463=$tr; //@line 1257 "tr_languages.cpp"
        var $langopts700=(($463)&4294967295); //@line 1257 "tr_languages.cpp"
        var $max_initial_consonants701=(($langopts700+248)&4294967295); //@line 1257 "tr_languages.cpp"
        HEAP8[($max_initial_consonants701)]=2; //@line 1257 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1259 "tr_languages.cpp"
      }
      else if (__label__ == 74) {
  
        var $464=$tr; //@line 1262 "tr_languages.cpp"
        var $letter_bits_offset703=(($464+964)&4294967295); //@line 1262 "tr_languages.cpp"
        HEAP32[(($letter_bits_offset703)>>2)]=1536; //@line 1262 "tr_languages.cpp"
        var $465=$tr; //@line 1263 "tr_languages.cpp"
        var $langopts704=(($465)&4294967295); //@line 1263 "tr_languages.cpp"
        var $param705=(($langopts704+24)&4294967295); //@line 1263 "tr_languages.cpp"
        var $arrayidx706=(($param705+20)&4294967295); //@line 1263 "tr_languages.cpp"
        HEAP32[(($arrayidx706)>>2)]=1; //@line 1263 "tr_languages.cpp"
        var $466=$tr; //@line 1264 "tr_languages.cpp"
        var $langopts707=(($466)&4294967295); //@line 1264 "tr_languages.cpp"
        var $numbers708=(($langopts707+184)&4294967295); //@line 1264 "tr_languages.cpp"
        HEAP32[(($numbers708)>>2)]=16; //@line 1264 "tr_languages.cpp"
        var $467=$tr; //@line 1265 "tr_languages.cpp"
        var $langopts709=(($467)&4294967295); //@line 1265 "tr_languages.cpp"
        var $break_numbers710=(($langopts709+192)&4294967295); //@line 1265 "tr_languages.cpp"
        HEAP32[(($break_numbers710)>>2)]=21160; //@line 1265 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1266 "tr_languages.cpp"
      }
      else if (__label__ == 75) {
  
        var $468=$tr; //@line 1286 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($468, ((__ZZ16SelectTranslatorPKcE17stress_lengths_vi)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_vi)&4294967295)); //@line 1286 "tr_languages.cpp"
        var $469=$tr; //@line 1287 "tr_languages.cpp"
        var $langopts712=(($469)&4294967295); //@line 1287 "tr_languages.cpp"
        var $length_mods713=(($langopts712+176)&4294967295); //@line 1287 "tr_languages.cpp"
        var $470=HEAP32[(($length_mods713)>>2)]; //@line 1287 "tr_languages.cpp"
        var $471=$tr; //@line 1287 "tr_languages.cpp"
        var $langopts714=(($471)&4294967295); //@line 1287 "tr_languages.cpp"
        var $length_mods0715=(($langopts714+180)&4294967295); //@line 1287 "tr_languages.cpp"
        HEAP32[(($length_mods0715)>>2)]=$470; //@line 1287 "tr_languages.cpp"
        var $472=$tr; //@line 1289 "tr_languages.cpp"
        var $langopts716=(($472)&4294967295); //@line 1289 "tr_languages.cpp"
        var $stress_rule717=(($langopts716+8)&4294967295); //@line 1289 "tr_languages.cpp"
        HEAP32[(($stress_rule717)>>2)]=0; //@line 1289 "tr_languages.cpp"
        var $473=$tr; //@line 1290 "tr_languages.cpp"
        var $langopts718=(($473)&4294967295); //@line 1290 "tr_languages.cpp"
        var $word_gap719=(($langopts718)&4294967295); //@line 1290 "tr_languages.cpp"
        HEAP32[(($word_gap719)>>2)]=33; //@line 1290 "tr_languages.cpp"
        var $474=$tr; //@line 1292 "tr_languages.cpp"
        var $letter_groups720=(($474+968)&4294967295); //@line 1292 "tr_languages.cpp"
        var $arrayidx721=(($letter_groups720+28)&4294967295); //@line 1292 "tr_languages.cpp"
        HEAP32[(($arrayidx721)>>2)]=((__ZZ16SelectTranslatorPKcE9vowels_vi)&4294967295); //@line 1292 "tr_languages.cpp"
        var $475=$tr; //@line 1292 "tr_languages.cpp"
        var $letter_groups722=(($475+968)&4294967295); //@line 1292 "tr_languages.cpp"
        var $arrayidx723=(($letter_groups722)&4294967295); //@line 1292 "tr_languages.cpp"
        HEAP32[(($arrayidx723)>>2)]=((__ZZ16SelectTranslatorPKcE9vowels_vi)&4294967295); //@line 1292 "tr_languages.cpp"
        var $476=$tr; //@line 1293 "tr_languages.cpp"
        var $langopts724=(($476)&4294967295); //@line 1293 "tr_languages.cpp"
        var $tone_language=(($langopts724+224)&4294967295); //@line 1293 "tr_languages.cpp"
        HEAP32[(($tone_language)>>2)]=1; //@line 1293 "tr_languages.cpp"
        var $477=$tr; //@line 1294 "tr_languages.cpp"
        var $langopts725=(($477)&4294967295); //@line 1294 "tr_languages.cpp"
        var $unstressed_wd1726=(($langopts725+16)&4294967295); //@line 1294 "tr_languages.cpp"
        HEAP32[(($unstressed_wd1726)>>2)]=2; //@line 1294 "tr_languages.cpp"
        var $478=$tr; //@line 1295 "tr_languages.cpp"
        var $langopts727=(($478)&4294967295); //@line 1295 "tr_languages.cpp"
        var $numbers728=(($langopts727+184)&4294967295); //@line 1295 "tr_languages.cpp"
        HEAP32[(($numbers728)>>2)]=12615688; //@line 1295 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1298 "tr_languages.cpp"
      }
      else if (__label__ == 76) {
  
        var $479=$tr; //@line 1301 "tr_languages.cpp"
        var $langopts730=(($479)&4294967295); //@line 1301 "tr_languages.cpp"
        var $stress_rule731=(($langopts730+8)&4294967295); //@line 1301 "tr_languages.cpp"
        HEAP32[(($stress_rule731)>>2)]=0; //@line 1301 "tr_languages.cpp"
        var $480=$tr; //@line 1302 "tr_languages.cpp"
        var $langopts732=(($480)&4294967295); //@line 1302 "tr_languages.cpp"
        var $numbers733=(($langopts732+184)&4294967295); //@line 1302 "tr_languages.cpp"
        HEAP32[(($numbers733)>>2)]=2098528; //@line 1302 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1303 "tr_languages.cpp"
      }
      else if (__label__ == 77) {
  
        var $481=$tr; //@line 1311 "tr_languages.cpp"
        __Z15SetupTranslatorP10TranslatorPKsPKh($481, ((__ZZ16SelectTranslatorPKcE17stress_lengths_zh)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_zh)&4294967295)); //@line 1311 "tr_languages.cpp"
        var $482=$tr; //@line 1313 "tr_languages.cpp"
        var $langopts735=(($482)&4294967295); //@line 1313 "tr_languages.cpp"
        var $stress_rule736=(($langopts735+8)&4294967295); //@line 1313 "tr_languages.cpp"
        HEAP32[(($stress_rule736)>>2)]=3; //@line 1313 "tr_languages.cpp"
        var $483=$tr; //@line 1314 "tr_languages.cpp"
        var $langopts737=(($483)&4294967295); //@line 1314 "tr_languages.cpp"
        var $stress_flags738=(($langopts737+12)&4294967295); //@line 1314 "tr_languages.cpp"
        HEAP32[(($stress_flags738)>>2)]=2; //@line 1314 "tr_languages.cpp"
        var $484=$tr; //@line 1315 "tr_languages.cpp"
        var $langopts739=(($484)&4294967295); //@line 1315 "tr_languages.cpp"
        var $vowel_pause740=(($langopts739+4)&4294967295); //@line 1315 "tr_languages.cpp"
        HEAP32[(($vowel_pause740)>>2)]=0; //@line 1315 "tr_languages.cpp"
        var $485=$tr; //@line 1316 "tr_languages.cpp"
        var $langopts741=(($485)&4294967295); //@line 1316 "tr_languages.cpp"
        var $tone_language742=(($langopts741+224)&4294967295); //@line 1316 "tr_languages.cpp"
        HEAP32[(($tone_language742)>>2)]=1; //@line 1316 "tr_languages.cpp"
        var $486=$tr; //@line 1317 "tr_languages.cpp"
        var $langopts743=(($486)&4294967295); //@line 1317 "tr_languages.cpp"
        var $length_mods744=(($langopts743+176)&4294967295); //@line 1317 "tr_languages.cpp"
        var $487=HEAP32[(($length_mods744)>>2)]; //@line 1317 "tr_languages.cpp"
        var $488=$tr; //@line 1317 "tr_languages.cpp"
        var $langopts745=(($488)&4294967295); //@line 1317 "tr_languages.cpp"
        var $length_mods0746=(($langopts745+180)&4294967295); //@line 1317 "tr_languages.cpp"
        HEAP32[(($length_mods0746)>>2)]=$487; //@line 1317 "tr_languages.cpp"
        var $489=$tr; //@line 1318 "tr_languages.cpp"
        var $langopts747=(($489)&4294967295); //@line 1318 "tr_languages.cpp"
        var $tone_numbers=(($langopts747+250)&4294967295); //@line 1318 "tr_languages.cpp"
        HEAP8[($tone_numbers)]=1; //@line 1318 "tr_languages.cpp"
        var $490=$tr; //@line 1319 "tr_languages.cpp"
        var $langopts748=(($490)&4294967295); //@line 1319 "tr_languages.cpp"
        var $ideographs=(($langopts748+251)&4294967295); //@line 1319 "tr_languages.cpp"
        HEAP8[($ideographs)]=1; //@line 1319 "tr_languages.cpp"
        var $491=$tr; //@line 1320 "tr_languages.cpp"
        var $langopts749=(($491)&4294967295); //@line 1320 "tr_languages.cpp"
        var $word_gap750=(($langopts749)&4294967295); //@line 1320 "tr_languages.cpp"
        HEAP32[(($word_gap750)>>2)]=33; //@line 1320 "tr_languages.cpp"
        var $492=$name2; //@line 1321 "tr_languages.cpp"
        var $cmp751=((($492))|0)==31336; //@line 1321 "tr_languages.cpp"
        if (!($cmp751)) { __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; } //@line 1321 "tr_languages.cpp"
  
        var $493=$tr; //@line 1323 "tr_languages.cpp"
        var $langopts753=(($493)&4294967295); //@line 1323 "tr_languages.cpp"
        var $textmode=(($langopts753+252)&4294967295); //@line 1323 "tr_languages.cpp"
        HEAP8[($textmode)]=1; //@line 1323 "tr_languages.cpp"
        var $494=$tr; //@line 1324 "tr_languages.cpp"
        var $langopts754=(($494)&4294967295); //@line 1324 "tr_languages.cpp"
        var $listx=(($langopts754+260)&4294967295); //@line 1324 "tr_languages.cpp"
        HEAP32[(($listx)>>2)]=1; //@line 1324 "tr_languages.cpp"
        __label__ = 80;break $sw_default$$sw_bb$$sw_bb9$$sw_bb18$$sw_bb24$$sw_bb39$$sw_bb52$$sw_bb64$$sw_bb72$$sw_bb92$$sw_bb109$$sw_bb123$$sw_bb148$$sw_bb161$$sw_bb195$$sw_bb200$$sw_bb207$$sw_bb209$$sw_bb222$$sw_bb238$$sw_bb257$$sw_bb280$$sw_bb287$$sw_bb312$$sw_bb322$$sw_bb331$$sw_bb347$$sw_bb381$$sw_bb391$$sw_bb403$$sw_bb414$$sw_bb422$$sw_bb439$$sw_bb449$$sw_bb461$$sw_bb481$$sw_bb486$$sw_bb491$$sw_bb509$$sw_bb523$$sw_bb533$$sw_bb534$$sw_bb547$$sw_bb576$$sw_bb599$$sw_bb614$$sw_bb623$$sw_bb630$$sw_bb645$$sw_bb692$$sw_bb702$$sw_bb711$$sw_bb729$$sw_bb734$6; //@line 1325 "tr_languages.cpp"
      }
    } while(0);
    if (__label__ == 24) {
  
      var $146=$tr; //@line 645 "tr_languages.cpp"
      __Z15SetupTranslatorP10TranslatorPKsPKh($146, ((__ZZ16SelectTranslatorPKcE17stress_lengths_fi)&4294967295), ((__ZZ16SelectTranslatorPKcE14stress_amps_fi)&4294967295)); //@line 645 "tr_languages.cpp"
      var $147=$tr; //@line 647 "tr_languages.cpp"
      var $langopts210=(($147)&4294967295); //@line 647 "tr_languages.cpp"
      var $stress_rule211=(($langopts210+8)&4294967295); //@line 647 "tr_languages.cpp"
      HEAP32[(($stress_rule211)>>2)]=0; //@line 647 "tr_languages.cpp"
      var $148=$tr; //@line 648 "tr_languages.cpp"
      var $langopts212=(($148)&4294967295); //@line 648 "tr_languages.cpp"
      var $stress_flags213=(($langopts212+12)&4294967295); //@line 648 "tr_languages.cpp"
      HEAP32[(($stress_flags213)>>2)]=86; //@line 648 "tr_languages.cpp"
      var $149=$tr; //@line 649 "tr_languages.cpp"
      var $langopts214=(($149)&4294967295); //@line 649 "tr_languages.cpp"
      var $param215=(($langopts214+24)&4294967295); //@line 649 "tr_languages.cpp"
      var $arrayidx216=(($param215+56)&4294967295); //@line 649 "tr_languages.cpp"
      HEAP32[(($arrayidx216)>>2)]=1; //@line 649 "tr_languages.cpp"
      var $150=$tr; //@line 650 "tr_languages.cpp"
      var $langopts217=(($150)&4294967295); //@line 650 "tr_languages.cpp"
      var $long_stop=(($langopts217+240)&4294967295); //@line 650 "tr_languages.cpp"
      HEAP32[(($long_stop)>>2)]=130; //@line 650 "tr_languages.cpp"
      var $151=$tr; //@line 652 "tr_languages.cpp"
      var $langopts218=(($151)&4294967295); //@line 652 "tr_languages.cpp"
      var $numbers219=(($langopts218+184)&4294967295); //@line 652 "tr_languages.cpp"
      HEAP32[(($numbers219)>>2)]=4104; //@line 652 "tr_languages.cpp"
      var $152=$tr; //@line 653 "tr_languages.cpp"
      __ZL14SetLetterVowelP10Translatori($152, 121); //@line 653 "tr_languages.cpp"
      var $153=$tr; //@line 655 "tr_languages.cpp"
      var $langopts220=(($153)&4294967295); //@line 655 "tr_languages.cpp"
      var $spelling_stress=(($langopts220+249)&4294967295); //@line 655 "tr_languages.cpp"
      HEAP8[($spelling_stress)]=1; //@line 655 "tr_languages.cpp"
      var $154=$tr; //@line 656 "tr_languages.cpp"
      var $langopts221=(($154)&4294967295); //@line 656 "tr_languages.cpp"
      var $intonation_group=(($langopts221+228)&4294967295); //@line 656 "tr_languages.cpp"
      HEAP32[(($intonation_group)>>2)]=3; //@line 656 "tr_languages.cpp"
      ; //@line 658 "tr_languages.cpp"
    }
  
    var $496=$name2; //@line 1334 "tr_languages.cpp"
    var $497=$tr; //@line 1334 "tr_languages.cpp"
    var $translator_name=(($497+280)&4294967295); //@line 1334 "tr_languages.cpp"
    HEAP32[(($translator_name)>>2)]=$496; //@line 1334 "tr_languages.cpp"
    var $498=$tr; //@line 1336 "tr_languages.cpp"
    var $langopts759=(($498)&4294967295); //@line 1336 "tr_languages.cpp"
    var $numbers760=(($langopts759+184)&4294967295); //@line 1336 "tr_languages.cpp"
    var $499=HEAP32[(($numbers760)>>2)]; //@line 1336 "tr_languages.cpp"
    var $and=($499) & 8; //@line 1336 "tr_languages.cpp"
    var $tobool=((($and))|0)!=0; //@line 1336 "tr_languages.cpp"
    if ($tobool) { __label__ = 81;; } else { __label__ = 82;; } //@line 1336 "tr_languages.cpp"
    if (__label__ == 81) {
  
      var $500=$tr; //@line 1339 "tr_languages.cpp"
      var $langopts762=(($500)&4294967295); //@line 1339 "tr_languages.cpp"
      var $thousands_sep763=(($langopts762+204)&4294967295); //@line 1339 "tr_languages.cpp"
      HEAP32[(($thousands_sep763)>>2)]=46; //@line 1339 "tr_languages.cpp"
      var $501=$tr; //@line 1340 "tr_languages.cpp"
      var $langopts764=(($501)&4294967295); //@line 1340 "tr_languages.cpp"
      var $decimal_sep765=(($langopts764+208)&4294967295); //@line 1340 "tr_languages.cpp"
      HEAP32[(($decimal_sep765)>>2)]=44; //@line 1340 "tr_languages.cpp"
      ; //@line 1341 "tr_languages.cpp"
    }
  
    var $502=$tr; //@line 1342 "tr_languages.cpp"
    var $langopts767=(($502)&4294967295); //@line 1342 "tr_languages.cpp"
    var $numbers768=(($langopts767+184)&4294967295); //@line 1342 "tr_languages.cpp"
    var $503=HEAP32[(($numbers768)>>2)]; //@line 1342 "tr_languages.cpp"
    var $and769=($503) & 4; //@line 1342 "tr_languages.cpp"
    var $tobool770=((($and769))|0)!=0; //@line 1342 "tr_languages.cpp"
    if ($tobool770) { __label__ = 83;; } else { __label__ = 84;; } //@line 1342 "tr_languages.cpp"
    if (__label__ == 83) {
  
      var $504=$tr; //@line 1344 "tr_languages.cpp"
      var $langopts772=(($504)&4294967295); //@line 1344 "tr_languages.cpp"
      var $thousands_sep773=(($langopts772+204)&4294967295); //@line 1344 "tr_languages.cpp"
      HEAP32[(($thousands_sep773)>>2)]=0; //@line 1344 "tr_languages.cpp"
      ; //@line 1345 "tr_languages.cpp"
    }
  
    var $505=$tr; //@line 1347 "tr_languages.cpp"
    ;
    return $505; //@line 1347 "tr_languages.cpp"
    return null;
  }
  

  function __ZL13NewTranslatorv() {
    ;
    var __label__;
  
    var $retval;
    var $tr;
    var $ix;
    var $call=__Z5Alloci(8328); //@line 123 "tr_languages.cpp"
    var $0=$call; //@line 123 "tr_languages.cpp"
    $tr=$0; //@line 123 "tr_languages.cpp"
    var $1=$tr; //@line 124 "tr_languages.cpp"
    var $cmp=((($1))|0)==0; //@line 124 "tr_languages.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 124 "tr_languages.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 125 "tr_languages.cpp"
      ; //@line 125 "tr_languages.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=HEAP32[((((_charsets+4)&4294967295))>>2)]; //@line 127 "tr_languages.cpp"
      var $3=$tr; //@line 127 "tr_languages.cpp"
      var $charset_a0=(($3+696)&4294967295); //@line 127 "tr_languages.cpp"
      HEAP32[(($charset_a0)>>2)]=$2; //@line 127 "tr_languages.cpp"
      HEAP8[(((_dictionary_name)&4294967295))]=0; //@line 128 "tr_languages.cpp"
      var $4=$tr; //@line 129 "tr_languages.cpp"
      var $dict_condition=(($4+692)&4294967295); //@line 129 "tr_languages.cpp"
      HEAP32[(($dict_condition)>>2)]=0; //@line 129 "tr_languages.cpp"
      var $5=$tr; //@line 130 "tr_languages.cpp"
      var $data_dictrules=(($5+1048)&4294967295); //@line 130 "tr_languages.cpp"
      HEAP32[(($data_dictrules)>>2)]=0; //@line 130 "tr_languages.cpp"
      var $6=$tr; //@line 131 "tr_languages.cpp"
      var $data_dictlist=(($6+1052)&4294967295); //@line 131 "tr_languages.cpp"
      HEAP32[(($data_dictlist)>>2)]=0; //@line 131 "tr_languages.cpp"
      var $7=$tr; //@line 133 "tr_languages.cpp"
      var $transpose_min=(($7+288)&4294967295); //@line 133 "tr_languages.cpp"
      HEAP32[(($transpose_min)>>2)]=97; //@line 133 "tr_languages.cpp"
      var $8=$tr; //@line 134 "tr_languages.cpp"
      var $transpose_max=(($8+284)&4294967295); //@line 134 "tr_languages.cpp"
      HEAP32[(($transpose_max)>>2)]=122; //@line 134 "tr_languages.cpp"
      var $9=$tr; //@line 135 "tr_languages.cpp"
      var $frequent_pairs=(($9+8268)&4294967295); //@line 135 "tr_languages.cpp"
      HEAP32[(($frequent_pairs)>>2)]=0; //@line 135 "tr_languages.cpp"
      var $10=$tr; //@line 138 "tr_languages.cpp"
      var $letter_bits_offset=(($10+964)&4294967295); //@line 138 "tr_languages.cpp"
      HEAP32[(($letter_bits_offset)>>2)]=0; //@line 138 "tr_languages.cpp"
      var $11=$tr; //@line 139 "tr_languages.cpp"
      var $letter_bits=(($11+708)&4294967295); //@line 139 "tr_languages.cpp"
      var $arraydecay=(($letter_bits)&4294967295); //@line 139 "tr_languages.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $arraydecay;
      $stop$ = $dest$ + 256;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 139 "tr_languages.cpp"
      var $12=$tr; //@line 140 "tr_languages.cpp"
      var $letter_groups=(($12+968)&4294967295); //@line 140 "tr_languages.cpp"
      var $arraydecay1=(($letter_groups)&4294967295); //@line 140 "tr_languages.cpp"
      var $13=$arraydecay1; //@line 140 "tr_languages.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $13;
      $stop$ = $dest$ + 32;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 140 "tr_languages.cpp"
      var $14=$tr; //@line 144 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($14, 0, ((__str6636)&4294967295)); //@line 144 "tr_languages.cpp"
      var $15=$tr; //@line 145 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($15, 1, ((__str7637)&4294967295)); //@line 145 "tr_languages.cpp"
      var $16=$tr; //@line 146 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($16, 2, ((__str8638)&4294967295)); //@line 146 "tr_languages.cpp"
      var $17=$tr; //@line 147 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($17, 3, ((__str9639)&4294967295)); //@line 147 "tr_languages.cpp"
      var $18=$tr; //@line 148 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($18, 4, ((__str10640)&4294967295)); //@line 148 "tr_languages.cpp"
      var $19=$tr; //@line 149 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($19, 5, ((__str11641)&4294967295)); //@line 149 "tr_languages.cpp"
      var $20=$tr; //@line 150 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($20, 6, ((__str12642)&4294967295)); //@line 150 "tr_languages.cpp"
      var $21=$tr; //@line 151 "tr_languages.cpp"
      __ZL13SetLetterBitsP10TranslatoriPKc($21, 7, ((__str630)&4294967295)); //@line 151 "tr_languages.cpp"
      var $22=$tr; //@line 154 "tr_languages.cpp"
      var $char_plus_apostrophe=(($22+700)&4294967295); //@line 154 "tr_languages.cpp"
      HEAP32[(($char_plus_apostrophe)>>2)]=((__ZZL13NewTranslatorvE13empty_wstring)&4294967295); //@line 154 "tr_languages.cpp"
      var $23=$tr; //@line 155 "tr_languages.cpp"
      var $punct_within_word=(($23+704)&4294967295); //@line 155 "tr_languages.cpp"
      HEAP32[(($punct_within_word)>>2)]=((__ZZL13NewTranslatorvE13punct_in_word)&4294967295); //@line 155 "tr_languages.cpp"
      $ix=0; //@line 157 "tr_languages.cpp"
      ; //@line 157 "tr_languages.cpp"
      while(1) { 
  
        var $24=$ix; //@line 159 "tr_languages.cpp"
        var $arrayidx=((__ZZL13NewTranslatorvE12stress_amps2+$24)&4294967295); //@line 159 "tr_languages.cpp"
        var $25=HEAP8[($arrayidx)]; //@line 159 "tr_languages.cpp"
        var $26=$ix; //@line 159 "tr_languages.cpp"
        var $27=$tr; //@line 159 "tr_languages.cpp"
        var $stress_amps=(($27+660)&4294967295); //@line 159 "tr_languages.cpp"
        var $arrayidx3=(($stress_amps+$26)&4294967295); //@line 159 "tr_languages.cpp"
        HEAP8[($arrayidx3)]=$25; //@line 159 "tr_languages.cpp"
        var $28=$ix; //@line 160 "tr_languages.cpp"
        var $arrayidx4=((__ZZL13NewTranslatorvE12stress_amps2+$28)&4294967295); //@line 160 "tr_languages.cpp"
        var $29=HEAPU8[($arrayidx4)]; //@line 160 "tr_languages.cpp"
        var $conv=((($29))&255); //@line 160 "tr_languages.cpp"
        var $sub=((($conv)-1)&4294967295); //@line 160 "tr_languages.cpp"
        var $conv5=((($sub)) & 255); //@line 160 "tr_languages.cpp"
        var $30=$ix; //@line 160 "tr_languages.cpp"
        var $31=$tr; //@line 160 "tr_languages.cpp"
        var $stress_amps_r=(($31+668)&4294967295); //@line 160 "tr_languages.cpp"
        var $arrayidx6=(($stress_amps_r+$30)&4294967295); //@line 160 "tr_languages.cpp"
        HEAP8[($arrayidx6)]=$conv5; //@line 160 "tr_languages.cpp"
        var $32=$ix; //@line 161 "tr_languages.cpp"
        var $arrayidx7=((__ZZL13NewTranslatorvE15stress_lengths2+$32*2)&4294967295); //@line 161 "tr_languages.cpp"
        var $33=HEAP16[(($arrayidx7)>>1)]; //@line 161 "tr_languages.cpp"
        var $34=$ix; //@line 161 "tr_languages.cpp"
        var $35=$tr; //@line 161 "tr_languages.cpp"
        var $stress_lengths=(($35+676)&4294967295); //@line 161 "tr_languages.cpp"
        var $arrayidx8=(($stress_lengths+$34*2)&4294967295); //@line 161 "tr_languages.cpp"
        HEAP16[(($arrayidx8)>>1)]=$33; //@line 161 "tr_languages.cpp"
        var $36=$ix; //@line 157 "tr_languages.cpp"
        var $inc=((($36)+1)&4294967295); //@line 157 "tr_languages.cpp"
        $ix=$inc; //@line 157 "tr_languages.cpp"
        var $cmp2=((($inc))|0) < 8; //@line 157 "tr_languages.cpp"
        if ($cmp2) { __label__ = 3;continue ; } else { __label__ = 4;break ; } //@line 157 "tr_languages.cpp"
      }
  
      var $37=$tr; //@line 163 "tr_languages.cpp"
      var $langopts=(($37)&4294967295); //@line 163 "tr_languages.cpp"
      var $38=$langopts; //@line 163 "tr_languages.cpp"
      var $dest$, $stop$, $stop4$, $fast$, $value4$;
      $dest$ = $38;
      $stop$ = $dest$ + 280;
      $value4$ = 0;
      if ($value4$ < 0) $value4$ += 256;
      $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
      while ($dest$%4 !== 0 && $dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($dest$ < $stop4$) {
      ;;;;;;;  HEAP32[$dest$++] = $value4$;
      }
      $dest$ <<= 2;
      while ($dest$ < $stop$) {
        ;; HEAP8[$dest$++] = 0;
      }; //@line 163 "tr_languages.cpp"
      var $39=$tr; //@line 164 "tr_languages.cpp"
      var $langopts9=(($39)&4294967295); //@line 164 "tr_languages.cpp"
      var $max_lengthmod=(($langopts9+272)&4294967295); //@line 164 "tr_languages.cpp"
      HEAP32[(($max_lengthmod)>>2)]=500; //@line 164 "tr_languages.cpp"
      var $40=$tr; //@line 166 "tr_languages.cpp"
      var $langopts10=(($40)&4294967295); //@line 166 "tr_languages.cpp"
      var $stress_rule=(($langopts10+8)&4294967295); //@line 166 "tr_languages.cpp"
      HEAP32[(($stress_rule)>>2)]=2; //@line 166 "tr_languages.cpp"
      var $41=$tr; //@line 167 "tr_languages.cpp"
      var $langopts11=(($41)&4294967295); //@line 167 "tr_languages.cpp"
      var $unstressed_wd1=(($langopts11+16)&4294967295); //@line 167 "tr_languages.cpp"
      HEAP32[(($unstressed_wd1)>>2)]=1; //@line 167 "tr_languages.cpp"
      var $42=$tr; //@line 168 "tr_languages.cpp"
      var $langopts12=(($42)&4294967295); //@line 168 "tr_languages.cpp"
      var $unstressed_wd2=(($langopts12+20)&4294967295); //@line 168 "tr_languages.cpp"
      HEAP32[(($unstressed_wd2)>>2)]=3; //@line 168 "tr_languages.cpp"
      var $43=$tr; //@line 169 "tr_languages.cpp"
      var $langopts13=(($43)&4294967295); //@line 169 "tr_languages.cpp"
      var $param=(($langopts13+24)&4294967295); //@line 169 "tr_languages.cpp"
      var $arrayidx14=(($param+28)&4294967295); //@line 169 "tr_languages.cpp"
      HEAP32[(($arrayidx14)>>2)]=95; //@line 169 "tr_languages.cpp"
      var $44=$tr; //@line 170 "tr_languages.cpp"
      var $langopts15=(($44)&4294967295); //@line 170 "tr_languages.cpp"
      var $param16=(($langopts15+24)&4294967295); //@line 170 "tr_languages.cpp"
      var $arrayidx17=(($param16+72)&4294967295); //@line 170 "tr_languages.cpp"
      HEAP32[(($arrayidx17)>>2)]=95; //@line 170 "tr_languages.cpp"
      var $45=$tr; //@line 171 "tr_languages.cpp"
      var $langopts18=(($45)&4294967295); //@line 171 "tr_languages.cpp"
      var $param19=(($langopts18+24)&4294967295); //@line 171 "tr_languages.cpp"
      var $arrayidx20=(($param19+36)&4294967295); //@line 171 "tr_languages.cpp"
      HEAP32[(($arrayidx20)>>2)]=19; //@line 171 "tr_languages.cpp"
      var $46=$tr; //@line 172 "tr_languages.cpp"
      var $langopts21=(($46)&4294967295); //@line 172 "tr_languages.cpp"
      var $param22=(($langopts21+24)&4294967295); //@line 172 "tr_languages.cpp"
      var $arrayidx23=(($param22+20)&4294967295); //@line 172 "tr_languages.cpp"
      HEAP32[(($arrayidx23)>>2)]=115; //@line 172 "tr_languages.cpp"
      var $47=$tr; //@line 173 "tr_languages.cpp"
      var $langopts24=(($47)&4294967295); //@line 173 "tr_languages.cpp"
      var $param25=(($langopts24+24)&4294967295); //@line 173 "tr_languages.cpp"
      var $arrayidx26=(($param25+64)&4294967295); //@line 173 "tr_languages.cpp"
      HEAP32[(($arrayidx26)>>2)]=4; //@line 173 "tr_languages.cpp"
      var $48=$tr; //@line 174 "tr_languages.cpp"
      var $langopts27=(($48)&4294967295); //@line 174 "tr_languages.cpp"
      var $param2=(($langopts27+100)&4294967295); //@line 174 "tr_languages.cpp"
      var $arrayidx28=(($param2+64)&4294967295); //@line 174 "tr_languages.cpp"
      HEAP32[(($arrayidx28)>>2)]=2; //@line 174 "tr_languages.cpp"
      var $49=$tr; //@line 175 "tr_languages.cpp"
      var $langopts29=(($49)&4294967295); //@line 175 "tr_languages.cpp"
      var $max_initial_consonants=(($langopts29+248)&4294967295); //@line 175 "tr_languages.cpp"
      HEAP8[($max_initial_consonants)]=3; //@line 175 "tr_languages.cpp"
      var $50=$tr; //@line 176 "tr_languages.cpp"
      var $langopts30=(($50)&4294967295); //@line 176 "tr_languages.cpp"
      var $replace_chars=(($langopts30+264)&4294967295); //@line 176 "tr_languages.cpp"
      HEAP32[(($replace_chars)>>2)]=0; //@line 176 "tr_languages.cpp"
      var $51=$tr; //@line 177 "tr_languages.cpp"
      var $langopts31=(($51)&4294967295); //@line 177 "tr_languages.cpp"
      var $ascii_language=(($langopts31+268)&4294967295); //@line 177 "tr_languages.cpp"
      HEAP32[(($ascii_language)>>2)]=((__str13643)&4294967295); //@line 177 "tr_languages.cpp"
      var $52=$tr; //@line 180 "tr_languages.cpp"
      __Z13SetLengthModsP10Translatori($52, 201); //@line 180 "tr_languages.cpp"
      var $53=$tr; //@line 184 "tr_languages.cpp"
      var $langopts32=(($53)&4294967295); //@line 184 "tr_languages.cpp"
      var $long_stop=(($langopts32+240)&4294967295); //@line 184 "tr_languages.cpp"
      HEAP32[(($long_stop)>>2)]=100; //@line 184 "tr_languages.cpp"
      var $54=$tr; //@line 186 "tr_languages.cpp"
      var $langopts33=(($54)&4294967295); //@line 186 "tr_languages.cpp"
      var $max_roman=(($langopts33+196)&4294967295); //@line 186 "tr_languages.cpp"
      HEAP32[(($max_roman)>>2)]=49; //@line 186 "tr_languages.cpp"
      var $55=$tr; //@line 187 "tr_languages.cpp"
      var $langopts34=(($55)&4294967295); //@line 187 "tr_languages.cpp"
      var $min_roman=(($langopts34+200)&4294967295); //@line 187 "tr_languages.cpp"
      HEAP32[(($min_roman)>>2)]=2; //@line 187 "tr_languages.cpp"
      var $56=$tr; //@line 188 "tr_languages.cpp"
      var $langopts35=(($56)&4294967295); //@line 188 "tr_languages.cpp"
      var $thousands_sep=(($langopts35+204)&4294967295); //@line 188 "tr_languages.cpp"
      HEAP32[(($thousands_sep)>>2)]=44; //@line 188 "tr_languages.cpp"
      var $57=$tr; //@line 189 "tr_languages.cpp"
      var $langopts36=(($57)&4294967295); //@line 189 "tr_languages.cpp"
      var $decimal_sep=(($langopts36+208)&4294967295); //@line 189 "tr_languages.cpp"
      HEAP32[(($decimal_sep)>>2)]=46; //@line 189 "tr_languages.cpp"
      var $58=$tr; //@line 190 "tr_languages.cpp"
      var $langopts37=(($58)&4294967295); //@line 190 "tr_languages.cpp"
      var $break_numbers=(($langopts37+192)&4294967295); //@line 190 "tr_languages.cpp"
      HEAP32[(($break_numbers)>>2)]=1227133512; //@line 190 "tr_languages.cpp"
      var $59=$tr; //@line 191 "tr_languages.cpp"
      var $langopts38=(($59)&4294967295); //@line 191 "tr_languages.cpp"
      var $max_digits=(($langopts38+212)&4294967295); //@line 191 "tr_languages.cpp"
      HEAP32[(($max_digits)>>2)]=14; //@line 191 "tr_languages.cpp"
      var $60=$tr; //@line 193 "tr_languages.cpp"
      var $punct_to_tone=(($60+1000)&4294967295); //@line 193 "tr_languages.cpp"
      var $arraydecay39=(($punct_to_tone)&4294967295); //@line 193 "tr_languages.cpp"
      var $61=$arraydecay39; //@line 193 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((_punctuation_to_tone)&4294967295);
      $dest$ = $61;
      $stop$ = $src$ + 48;
      if (($dest$%4) == ($src$%4) && 48 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 193 "tr_languages.cpp"
      var $62=$tr; //@line 195 "tr_languages.cpp"
      var $langopts40=(($62)&4294967295); //@line 195 "tr_languages.cpp"
      var $tunes=(($langopts40+232)&4294967295); //@line 195 "tr_languages.cpp"
      var $arraydecay41=(($tunes)&4294967295); //@line 195 "tr_languages.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((__ZZL13NewTranslatorvE13default_tunes)&4294967295);
      $dest$ = $arraydecay41;
      $stop$ = $src$ + 6;
      if (($dest$%4) == ($src$%4) && 6 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 195 "tr_languages.cpp"
      var $63=$tr; //@line 197 "tr_languages.cpp"
      $retval=$63; //@line 197 "tr_languages.cpp"
      ; //@line 197 "tr_languages.cpp"
    }
  
    var $64=$retval; //@line 198 "tr_languages.cpp"
    ;
    return $64; //@line 198 "tr_languages.cpp"
    return null;
  }
  

  function __ZL14SetLetterVowelP10Translatori($tr, $c) {
    ;
    var __label__;
  
    var $tr_addr;
    var $c_addr;
    $tr_addr=$tr;
    $c_addr=$c;
    var $0=$c_addr; //@line 73 "tr_languages.cpp"
    var $1=$tr_addr; //@line 73 "tr_languages.cpp"
    var $letter_bits=(($1+708)&4294967295); //@line 73 "tr_languages.cpp"
    var $arrayidx=(($letter_bits+$0)&4294967295); //@line 73 "tr_languages.cpp"
    var $2=HEAPU8[($arrayidx)]; //@line 73 "tr_languages.cpp"
    var $conv=((($2))&255); //@line 73 "tr_languages.cpp"
    var $and=($conv) & 64; //@line 73 "tr_languages.cpp"
    var $or=($and) | 129; //@line 73 "tr_languages.cpp"
    var $conv1=((($or)) & 255); //@line 73 "tr_languages.cpp"
    var $3=$c_addr; //@line 73 "tr_languages.cpp"
    var $4=$tr_addr; //@line 73 "tr_languages.cpp"
    var $letter_bits2=(($4+708)&4294967295); //@line 73 "tr_languages.cpp"
    var $arrayidx3=(($letter_bits2+$3)&4294967295); //@line 73 "tr_languages.cpp"
    HEAP8[($arrayidx3)]=$conv1; //@line 73 "tr_languages.cpp"
    ;
    return; //@line 74 "tr_languages.cpp"
    return;
  }
  

  function __ZL18SetCyrillicLettersP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=HEAP32[((((_charsets+72)&4294967295))>>2)]; //@line 285 "tr_languages.cpp"
    var $1=$tr_addr; //@line 285 "tr_languages.cpp"
    var $charset_a0=(($1+696)&4294967295); //@line 285 "tr_languages.cpp"
    HEAP32[(($charset_a0)>>2)]=$0; //@line 285 "tr_languages.cpp"
    var $2=$tr_addr; //@line 286 "tr_languages.cpp"
    var $transpose_min=(($2+288)&4294967295); //@line 286 "tr_languages.cpp"
    HEAP32[(($transpose_min)>>2)]=1072; //@line 286 "tr_languages.cpp"
    var $3=$tr_addr; //@line 287 "tr_languages.cpp"
    var $transpose_max=(($3+284)&4294967295); //@line 287 "tr_languages.cpp"
    HEAP32[(($transpose_max)>>2)]=1105; //@line 287 "tr_languages.cpp"
    var $4=$tr_addr; //@line 288 "tr_languages.cpp"
    var $frequent_pairs=(($4+8268)&4294967295); //@line 288 "tr_languages.cpp"
    HEAP32[(($frequent_pairs)>>2)]=((__ZL8pairs_ru)&4294967295); //@line 288 "tr_languages.cpp"
    var $5=$tr_addr; //@line 290 "tr_languages.cpp"
    var $letter_bits_offset=(($5+964)&4294967295); //@line 290 "tr_languages.cpp"
    HEAP32[(($letter_bits_offset)>>2)]=1056; //@line 290 "tr_languages.cpp"
    var $6=$tr_addr; //@line 291 "tr_languages.cpp"
    var $letter_bits=(($6+708)&4294967295); //@line 291 "tr_languages.cpp"
    var $arraydecay=(($letter_bits)&4294967295); //@line 291 "tr_languages.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $arraydecay;
    $stop$ = $dest$ + 256;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 291 "tr_languages.cpp"
    var $7=$tr_addr; //@line 292 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($7, 0, ((__ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels)&4294967295)); //@line 292 "tr_languages.cpp"
    var $8=$tr_addr; //@line 293 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($8, 1, ((__ZZL18SetCyrillicLettersP10TranslatorE7ru_soft)&4294967295)); //@line 293 "tr_languages.cpp"
    var $9=$tr_addr; //@line 294 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($9, 2, ((__ZZL18SetCyrillicLettersP10TranslatorE13ru_consonants)&4294967295)); //@line 294 "tr_languages.cpp"
    var $10=$tr_addr; //@line 295 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($10, 3, ((__ZZL18SetCyrillicLettersP10TranslatorE7ru_hard)&4294967295)); //@line 295 "tr_languages.cpp"
    var $11=$tr_addr; //@line 296 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($11, 4, ((__ZZL18SetCyrillicLettersP10TranslatorE10ru_nothard)&4294967295)); //@line 296 "tr_languages.cpp"
    var $12=$tr_addr; //@line 297 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($12, 5, ((__ZZL18SetCyrillicLettersP10TranslatorE9ru_voiced)&4294967295)); //@line 297 "tr_languages.cpp"
    var $13=$tr_addr; //@line 298 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($13, 6, ((__ZZL18SetCyrillicLettersP10TranslatorE10ru_ivowels)&4294967295)); //@line 298 "tr_languages.cpp"
    var $14=$tr_addr; //@line 299 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($14, 7, ((__ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels)&4294967295)); //@line 299 "tr_languages.cpp"
    ;
    return; //@line 300 "tr_languages.cpp"
    return;
  }
  

  function __ZL15ResetLetterBitsP10Translatori($tr, $groups) {
    ;
    var __label__;
  
    var $tr_addr;
    var $groups_addr;
    var $ix;
    var $mask;
    $tr_addr=$tr;
    $groups_addr=$groups;
    var $0=$groups_addr; //@line 82 "tr_languages.cpp"
    var $neg=($0) ^ -1; //@line 82 "tr_languages.cpp"
    $mask=$neg; //@line 82 "tr_languages.cpp"
    $ix=0; //@line 84 "tr_languages.cpp"
    ; //@line 84 "tr_languages.cpp"
    while(1) { 
  
      var $1=$mask; //@line 86 "tr_languages.cpp"
      var $2=$ix; //@line 86 "tr_languages.cpp"
      var $3=$tr_addr; //@line 86 "tr_languages.cpp"
      var $letter_bits=(($3+708)&4294967295); //@line 86 "tr_languages.cpp"
      var $arrayidx=(($letter_bits+$2)&4294967295); //@line 86 "tr_languages.cpp"
      var $4=HEAPU8[($arrayidx)]; //@line 86 "tr_languages.cpp"
      var $conv=((($4))&255); //@line 86 "tr_languages.cpp"
      var $and=($conv) & ($1); //@line 86 "tr_languages.cpp"
      var $conv1=((($and)) & 255); //@line 86 "tr_languages.cpp"
      HEAP8[($arrayidx)]=$conv1; //@line 86 "tr_languages.cpp"
      var $5=$ix; //@line 84 "tr_languages.cpp"
      var $inc=((($5)+1)&4294967295); //@line 84 "tr_languages.cpp"
      $ix=$inc; //@line 84 "tr_languages.cpp"
      var $cmp=((($inc))>>>0) < 256; //@line 84 "tr_languages.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 84 "tr_languages.cpp"
    }
  
    ;
    return; //@line 88 "tr_languages.cpp"
    return;
  }
  

  function __ZL18Translator_RussianP10Translator($tr) {
    ;
    var __label__;
  
    var $tr_addr;
    $tr_addr=$tr;
    var $0=$tr_addr; //@line 1363 "tr_languages.cpp"
    __Z15SetupTranslatorP10TranslatorPKsPKh($0, ((__ZZL18Translator_RussianP10TranslatorE17stress_lengths_ru)&4294967295), ((__ZZL18Translator_RussianP10TranslatorE14stress_amps_ru)&4294967295)); //@line 1363 "tr_languages.cpp"
    var $1=$tr_addr; //@line 1364 "tr_languages.cpp"
    __ZL18SetCyrillicLettersP10Translator($1); //@line 1364 "tr_languages.cpp"
    var $2=$tr_addr; //@line 1365 "tr_languages.cpp"
    __ZL13SetLetterBitsP10TranslatoriPKc($2, 6, ((__ZZL18Translator_RussianP10TranslatorE11ru_ivowels2)&4294967295)); //@line 1365 "tr_languages.cpp"
    var $3=$tr_addr; //@line 1367 "tr_languages.cpp"
    var $langopts=(($3)&4294967295); //@line 1367 "tr_languages.cpp"
    var $param=(($langopts+24)&4294967295); //@line 1367 "tr_languages.cpp"
    var $arrayidx=(($param+20)&4294967295); //@line 1367 "tr_languages.cpp"
    HEAP32[(($arrayidx)>>2)]=1074; //@line 1367 "tr_languages.cpp"
    var $4=$tr_addr; //@line 1368 "tr_languages.cpp"
    var $langopts1=(($4)&4294967295); //@line 1368 "tr_languages.cpp"
    var $param2=(($langopts1+24)&4294967295); //@line 1368 "tr_languages.cpp"
    var $arrayidx3=(($param2+16)&4294967295); //@line 1368 "tr_languages.cpp"
    HEAP32[(($arrayidx3)>>2)]=1; //@line 1368 "tr_languages.cpp"
    var $5=$tr_addr; //@line 1369 "tr_languages.cpp"
    var $langopts4=(($5)&4294967295); //@line 1369 "tr_languages.cpp"
    var $param5=(($langopts4+24)&4294967295); //@line 1369 "tr_languages.cpp"
    var $arrayidx6=(($param5+40)&4294967295); //@line 1369 "tr_languages.cpp"
    HEAP32[(($arrayidx6)>>2)]=2; //@line 1369 "tr_languages.cpp"
    var $6=$tr_addr; //@line 1370 "tr_languages.cpp"
    var $langopts7=(($6)&4294967295); //@line 1370 "tr_languages.cpp"
    var $stress_rule=(($langopts7+8)&4294967295); //@line 1370 "tr_languages.cpp"
    HEAP32[(($stress_rule)>>2)]=5; //@line 1370 "tr_languages.cpp"
    var $7=$tr_addr; //@line 1371 "tr_languages.cpp"
    var $langopts8=(($7)&4294967295); //@line 1371 "tr_languages.cpp"
    var $stress_flags=(($langopts8+12)&4294967295); //@line 1371 "tr_languages.cpp"
    HEAP32[(($stress_flags)>>2)]=32; //@line 1371 "tr_languages.cpp"
    var $8=$tr_addr; //@line 1373 "tr_languages.cpp"
    var $langopts9=(($8)&4294967295); //@line 1373 "tr_languages.cpp"
    var $numbers=(($langopts9+184)&4294967295); //@line 1373 "tr_languages.cpp"
    HEAP32[(($numbers)>>2)]=1032; //@line 1373 "tr_languages.cpp"
    var $9=$tr_addr; //@line 1374 "tr_languages.cpp"
    var $langopts10=(($9)&4294967295); //@line 1374 "tr_languages.cpp"
    var $numbers2=(($langopts10+188)&4294967295); //@line 1374 "tr_languages.cpp"
    HEAP32[(($numbers2)>>2)]=194; //@line 1374 "tr_languages.cpp"
    var $10=$tr_addr; //@line 1375 "tr_languages.cpp"
    var $langopts11=(($10)&4294967295); //@line 1375 "tr_languages.cpp"
    var $phoneme_change=(($langopts11+244)&4294967295); //@line 1375 "tr_languages.cpp"
    HEAP32[(($phoneme_change)>>2)]=1; //@line 1375 "tr_languages.cpp"
    var $11=$tr_addr; //@line 1376 "tr_languages.cpp"
    var $langopts12=(($11)&4294967295); //@line 1376 "tr_languages.cpp"
    var $testing=(($langopts12+256)&4294967295); //@line 1376 "tr_languages.cpp"
    HEAP32[(($testing)>>2)]=2; //@line 1376 "tr_languages.cpp"
    ;
    return; //@line 1378 "tr_languages.cpp"
    return;
  }
  

  function __Z14ReadTonePointsPcPi($string, $tone_pts) {
    ;
    var __label__;
  
    var $string_addr;
    var $tone_pts_addr;
    var $ix;
    $string_addr=$string;
    $tone_pts_addr=$tone_pts;
    $ix=0; //@line 256 "voices.cpp"
    ; //@line 256 "voices.cpp"
    while(1) { 
  
      var $0=$ix; //@line 257 "voices.cpp"
      var $1=$tone_pts_addr; //@line 257 "voices.cpp"
      var $arrayidx=(($1+4*$0)&4294967295); //@line 257 "voices.cpp"
      HEAP32[(($arrayidx)>>2)]=-1; //@line 257 "voices.cpp"
      var $2=$ix; //@line 256 "voices.cpp"
      var $inc=((($2)+1)&4294967295); //@line 256 "voices.cpp"
      $ix=$inc; //@line 256 "voices.cpp"
      var $cmp=((($inc))|0) < 12; //@line 256 "voices.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 256 "voices.cpp"
    }
  
    var $3=$string_addr; //@line 259 "voices.cpp"
    var $4=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx1=(($4)&4294967295); //@line 259 "voices.cpp"
    var $5=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx2=(($5+4)&4294967295); //@line 259 "voices.cpp"
    var $6=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx3=(($6+8)&4294967295); //@line 259 "voices.cpp"
    var $7=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx4=(($7+12)&4294967295); //@line 259 "voices.cpp"
    var $8=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx5=(($8+16)&4294967295); //@line 259 "voices.cpp"
    var $9=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx6=(($9+20)&4294967295); //@line 259 "voices.cpp"
    var $10=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx7=(($10+24)&4294967295); //@line 259 "voices.cpp"
    var $11=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx8=(($11+28)&4294967295); //@line 259 "voices.cpp"
    var $12=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx9=(($12+32)&4294967295); //@line 259 "voices.cpp"
    var $13=$tone_pts_addr; //@line 259 "voices.cpp"
    var $arrayidx10=(($13+36)&4294967295); //@line 259 "voices.cpp"
    var $call=_sscanf($3, ((__str44696)&4294967295), allocate([$arrayidx1,0,0,0,$arrayidx2,0,0,0,$arrayidx3,0,0,0,$arrayidx4,0,0,0,$arrayidx5,0,0,0,$arrayidx6,0,0,0,$arrayidx7,0,0,0,$arrayidx8,0,0,0,$arrayidx9,0,0,0,$arrayidx10,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 259 "voices.cpp"
    ;
    return; //@line 263 "voices.cpp"
    return;
  }
  

  function __Z10VoiceReseti($tone_only) {
    ;
    var __label__;
  
    var $tone_only_addr;
    var $pk;
    $tone_only_addr=$tone_only;
    var $0=HEAP32[((_voice)>>2)]; //@line 393 "voices.cpp"
    var $pitch_base=(($0+44)&4294967295); //@line 393 "voices.cpp"
    HEAP32[(($pitch_base)>>2)]=290816; //@line 393 "voices.cpp"
    var $1=HEAP32[((_voice)>>2)]; //@line 394 "voices.cpp"
    var $pitch_range=(($1+48)&4294967295); //@line 394 "voices.cpp"
    HEAP32[(($pitch_range)>>2)]=4104; //@line 394 "voices.cpp"
    var $2=HEAP32[((_voice)>>2)]; //@line 400 "voices.cpp"
    var $formant_factor=(($2+96)&4294967295); //@line 400 "voices.cpp"
    HEAP32[(($formant_factor)>>2)]=256; //@line 400 "voices.cpp"
    var $3=HEAP32[((_voice)>>2)]; //@line 402 "voices.cpp"
    var $speed_percent=(($3+64)&4294967295); //@line 402 "voices.cpp"
    HEAP32[(($speed_percent)>>2)]=100; //@line 402 "voices.cpp"
    var $4=HEAP32[((_voice)>>2)]; //@line 403 "voices.cpp"
    var $echo_delay=(($4+76)&4294967295); //@line 403 "voices.cpp"
    HEAP32[(($echo_delay)>>2)]=0; //@line 403 "voices.cpp"
    var $5=HEAP32[((_voice)>>2)]; //@line 404 "voices.cpp"
    var $echo_amp=(($5+80)&4294967295); //@line 404 "voices.cpp"
    HEAP32[(($echo_amp)>>2)]=0; //@line 404 "voices.cpp"
    var $6=HEAP32[((_voice)>>2)]; //@line 405 "voices.cpp"
    var $flutter=(($6+68)&4294967295); //@line 405 "voices.cpp"
    HEAP32[(($flutter)>>2)]=64; //@line 405 "voices.cpp"
    var $7=HEAP32[((_voice)>>2)]; //@line 406 "voices.cpp"
    var $n_harmonic_peaks=(($7+84)&4294967295); //@line 406 "voices.cpp"
    HEAP32[(($n_harmonic_peaks)>>2)]=5; //@line 406 "voices.cpp"
    var $8=HEAP32[((_voice)>>2)]; //@line 407 "voices.cpp"
    var $peak_shape=(($8+88)&4294967295); //@line 407 "voices.cpp"
    HEAP32[(($peak_shape)>>2)]=0; //@line 407 "voices.cpp"
    var $9=HEAP32[((_voice)>>2)]; //@line 408 "voices.cpp"
    var $voicing=(($9+92)&4294967295); //@line 408 "voices.cpp"
    HEAP32[(($voicing)>>2)]=64; //@line 408 "voices.cpp"
    var $10=HEAP32[((_voice)>>2)]; //@line 409 "voices.cpp"
    var $consonant_amp=(($10+100)&4294967295); //@line 409 "voices.cpp"
    HEAP32[(($consonant_amp)>>2)]=100; //@line 409 "voices.cpp"
    var $11=HEAP32[((_voice)>>2)]; //@line 410 "voices.cpp"
    var $consonant_ampv=(($11+104)&4294967295); //@line 410 "voices.cpp"
    HEAP32[(($consonant_ampv)>>2)]=100; //@line 410 "voices.cpp"
    var $12=HEAP32[((_voice)>>2)]; //@line 411 "voices.cpp"
    var $samplerate=(($12+108)&4294967295); //@line 411 "voices.cpp"
    HEAP32[(($samplerate)>>2)]=22050; //@line 411 "voices.cpp"
    var $13=HEAP32[((_voice)>>2)]; //@line 412 "voices.cpp"
    var $klattv=(($13+112)&4294967295); //@line 412 "voices.cpp"
    var $arraydecay=(($klattv)&4294967295); //@line 412 "voices.cpp"
    var $14=$arraydecay; //@line 412 "voices.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $14;
    $stop$ = $dest$ + 32;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 412 "voices.cpp"
    HEAP32[((((_speed+32)&4294967295))>>2)]=450; //@line 414 "voices.cpp"
    HEAP32[((((_speed+32+4)&4294967295))>>2)]=800; //@line 415 "voices.cpp"
    HEAP32[((((_speed+32+8)&4294967295))>>2)]=175; //@line 416 "voices.cpp"
    var $15=HEAP32[((_voice)>>2)]; //@line 421 "voices.cpp"
    var $roughness=(($15+72)&4294967295); //@line 421 "voices.cpp"
    HEAP32[(($roughness)>>2)]=2; //@line 421 "voices.cpp"
    __Z10InitBreathv(); //@line 424 "voices.cpp"
    $pk=0; //@line 425 "voices.cpp"
    ; //@line 425 "voices.cpp"
    while(1) { 
  
      var $16=$pk; //@line 427 "voices.cpp"
      var $17=HEAP32[((_voice)>>2)]; //@line 427 "voices.cpp"
      var $freq=(($17+144)&4294967295); //@line 427 "voices.cpp"
      var $arrayidx=(($freq+$16*2)&4294967295); //@line 427 "voices.cpp"
      HEAP16[(($arrayidx)>>1)]=256; //@line 427 "voices.cpp"
      var $18=$pk; //@line 428 "voices.cpp"
      var $arrayidx1=((__ZZ10VoiceResetiE15default_heights+$18)&4294967295); //@line 428 "voices.cpp"
      var $19=HEAPU8[($arrayidx1)]; //@line 428 "voices.cpp"
      var $conv=((($19))&255); //@line 428 "voices.cpp"
      var $mul=((($conv)*2)&4294967295); //@line 428 "voices.cpp"
      var $conv2=((($mul)) & 65535); //@line 428 "voices.cpp"
      var $20=$pk; //@line 428 "voices.cpp"
      var $21=HEAP32[((_voice)>>2)]; //@line 428 "voices.cpp"
      var $height=(($21+162)&4294967295); //@line 428 "voices.cpp"
      var $arrayidx3=(($height+$20*2)&4294967295); //@line 428 "voices.cpp"
      HEAP16[(($arrayidx3)>>1)]=$conv2; //@line 428 "voices.cpp"
      var $22=$pk; //@line 429 "voices.cpp"
      var $arrayidx4=((__ZZ10VoiceResetiE14default_widths+$22)&4294967295); //@line 429 "voices.cpp"
      var $23=HEAPU8[($arrayidx4)]; //@line 429 "voices.cpp"
      var $conv5=((($23))&255); //@line 429 "voices.cpp"
      var $mul6=((($conv5)*2)&4294967295); //@line 429 "voices.cpp"
      var $conv7=((($mul6)) & 65535); //@line 429 "voices.cpp"
      var $24=$pk; //@line 429 "voices.cpp"
      var $25=HEAP32[((_voice)>>2)]; //@line 429 "voices.cpp"
      var $width=(($25+180)&4294967295); //@line 429 "voices.cpp"
      var $arrayidx8=(($width+$24*2)&4294967295); //@line 429 "voices.cpp"
      HEAP16[(($arrayidx8)>>1)]=$conv7; //@line 429 "voices.cpp"
      var $26=$pk; //@line 430 "voices.cpp"
      var $27=HEAP32[((_voice)>>2)]; //@line 430 "voices.cpp"
      var $breath=(($27+272)&4294967295); //@line 430 "voices.cpp"
      var $arrayidx9=(($breath+$26*4)&4294967295); //@line 430 "voices.cpp"
      HEAP32[(($arrayidx9)>>2)]=0; //@line 430 "voices.cpp"
      var $28=$pk; //@line 431 "voices.cpp"
      var $arrayidx10=((__ZZ10VoiceResetiE13breath_widths+$28*4)&4294967295); //@line 431 "voices.cpp"
      var $29=HEAP32[(($arrayidx10)>>2)]; //@line 431 "voices.cpp"
      var $30=$pk; //@line 431 "voices.cpp"
      var $31=HEAP32[((_voice)>>2)]; //@line 431 "voices.cpp"
      var $breathw=(($31+308)&4294967295); //@line 431 "voices.cpp"
      var $arrayidx11=(($breathw+$30*4)&4294967295); //@line 431 "voices.cpp"
      HEAP32[(($arrayidx11)>>2)]=$29; //@line 431 "voices.cpp"
      var $32=$pk; //@line 432 "voices.cpp"
      var $33=HEAP32[((_voice)>>2)]; //@line 432 "voices.cpp"
      var $freqadd=(($33+198)&4294967295); //@line 432 "voices.cpp"
      var $arrayidx12=(($freqadd+$32*2)&4294967295); //@line 432 "voices.cpp"
      HEAP16[(($arrayidx12)>>1)]=0; //@line 432 "voices.cpp"
      var $34=$pk; //@line 435 "voices.cpp"
      var $arrayidx13=((__ZL18formant_rate_22050+$34*4)&4294967295); //@line 435 "voices.cpp"
      var $35=HEAP32[(($arrayidx13)>>2)]; //@line 435 "voices.cpp"
      var $mul14=((($35)*22050)&4294967295); //@line 435 "voices.cpp"
      var $36=HEAP32[((_samplerate)>>2)]; //@line 435 "voices.cpp"
      var $div=((((($mul14))|0)/((($36))|0))|0); //@line 435 "voices.cpp"
      var $37=$pk; //@line 435 "voices.cpp"
      var $arrayidx15=((_formant_rate+$37*4)&4294967295); //@line 435 "voices.cpp"
      HEAP32[(($arrayidx15)>>2)]=$div; //@line 435 "voices.cpp"
      var $38=$pk; //@line 425 "voices.cpp"
      var $inc=((($38)+1)&4294967295); //@line 425 "voices.cpp"
      $pk=$inc; //@line 425 "voices.cpp"
      var $cmp=((($inc))|0) < 9; //@line 425 "voices.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 425 "voices.cpp"
    }
  
    var $39=HEAP32[((_voice)>>2)]; //@line 437 "voices.cpp"
    var $height16=(($39+162)&4294967295); //@line 437 "voices.cpp"
    var $arrayidx17=(($height16+4)&4294967295); //@line 437 "voices.cpp"
    HEAP16[(($arrayidx17)>>1)]=240; //@line 437 "voices.cpp"
    var $40=HEAP32[((_voice)>>2)]; //@line 443 "voices.cpp"
    __ZL13SetToneAdjustP7voice_tPi($40, ((_tone_points)&4294967295)); //@line 443 "voices.cpp"
    var $41=HEAP32[((_voice)>>2)]; //@line 446 "voices.cpp"
    var $speedf1=(($41+52)&4294967295); //@line 446 "voices.cpp"
    HEAP32[(($speedf1)>>2)]=256; //@line 446 "voices.cpp"
    var $42=HEAP32[((_voice)>>2)]; //@line 447 "voices.cpp"
    var $speedf2=(($42+56)&4294967295); //@line 447 "voices.cpp"
    HEAP32[(($speedf2)>>2)]=238; //@line 447 "voices.cpp"
    var $43=HEAP32[((_voice)>>2)]; //@line 448 "voices.cpp"
    var $speedf3=(($43+60)&4294967295); //@line 448 "voices.cpp"
    HEAP32[(($speedf3)>>2)]=232; //@line 448 "voices.cpp"
    var $44=$tone_only_addr; //@line 450 "voices.cpp"
    var $cmp18=((($44))|0)==0; //@line 450 "voices.cpp"
    if ($cmp18) { __label__ = 3;; } else { __label__ = 4;; } //@line 450 "voices.cpp"
    if (__label__ == 3) {
  
      HEAP32[((_n_replace_phonemes)>>2)]=0; //@line 452 "voices.cpp"
      HEAP32[((_option_quiet)>>2)]=0; //@line 453 "voices.cpp"
      var $call=__Z15LoadMbrolaTablePKcS0_i(0, 0, 0); //@line 454 "voices.cpp"
      ; //@line 455 "voices.cpp"
    }
  
    ;
    return; //@line 456 "voices.cpp"
    return;
  }
  

  function __ZL13SetToneAdjustP7voice_tPi($voice, $tone_pts) {
    ;
    var __label__;
  
    var $voice_addr;
    var $tone_pts_addr;
    var $ix;
    var $pt;
    var $y;
    var $freq1;
    var $freq2;
    var $height1;
    var $height2;
    var $rate;
    $voice_addr=$voice;
    $tone_pts_addr=$tone_pts;
    $freq1=0; //@line 217 "voices.cpp"
    var $0=$tone_pts_addr; //@line 219 "voices.cpp"
    var $arrayidx=(($0+4)&4294967295); //@line 219 "voices.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 219 "voices.cpp"
    $height1=$1; //@line 219 "voices.cpp"
    $pt=0; //@line 223 "voices.cpp"
    ; //@line 223 "voices.cpp"
    $for_body$2: while(1) { 
  
      var $2=$pt; //@line 225 "voices.cpp"
      var $3=$tone_pts_addr; //@line 225 "voices.cpp"
      var $arrayidx1=(($3+4*$2)&4294967295); //@line 225 "voices.cpp"
      var $4=HEAP32[(($arrayidx1)>>2)]; //@line 225 "voices.cpp"
      var $cmp2=((($4))|0)==-1; //@line 225 "voices.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 4;; } //@line 225 "voices.cpp"
      $if_then$$if_end8$4: do { 
        if (__label__ == 2) {
  
          var $5=$pt; //@line 227 "voices.cpp"
          var $6=$tone_pts_addr; //@line 227 "voices.cpp"
          var $arrayidx3=(($6+4*$5)&4294967295); //@line 227 "voices.cpp"
          HEAP32[(($arrayidx3)>>2)]=8000; //@line 227 "voices.cpp"
          var $7=$pt; //@line 228 "voices.cpp"
          var $cmp4=((($7))|0) > 0; //@line 228 "voices.cpp"
          if (!($cmp4)) { __label__ = 4;break $if_then$$if_end8$4; } //@line 228 "voices.cpp"
  
          var $8=$pt; //@line 229 "voices.cpp"
          var $sub=((($8)-1)&4294967295); //@line 229 "voices.cpp"
          var $9=$tone_pts_addr; //@line 229 "voices.cpp"
          var $arrayidx6=(($9+4*$sub)&4294967295); //@line 229 "voices.cpp"
          var $10=HEAP32[(($arrayidx6)>>2)]; //@line 229 "voices.cpp"
          var $11=$pt; //@line 229 "voices.cpp"
          var $add=((($11)+1)&4294967295); //@line 229 "voices.cpp"
          var $12=$tone_pts_addr; //@line 229 "voices.cpp"
          var $arrayidx7=(($12+4*$add)&4294967295); //@line 229 "voices.cpp"
          HEAP32[(($arrayidx7)>>2)]=$10; //@line 229 "voices.cpp"
          ; //@line 229 "voices.cpp"
        }
      } while(0);
  
      var $13=$pt; //@line 231 "voices.cpp"
      var $14=$tone_pts_addr; //@line 231 "voices.cpp"
      var $arrayidx9=(($14+4*$13)&4294967295); //@line 231 "voices.cpp"
      var $15=HEAP32[(($arrayidx9)>>2)]; //@line 231 "voices.cpp"
      var $div=((((($15))|0)/8)|0); //@line 231 "voices.cpp"
      $freq2=$div; //@line 231 "voices.cpp"
      var $16=$pt; //@line 232 "voices.cpp"
      var $add10=((($16)+1)&4294967295); //@line 232 "voices.cpp"
      var $17=$tone_pts_addr; //@line 232 "voices.cpp"
      var $arrayidx11=(($17+4*$add10)&4294967295); //@line 232 "voices.cpp"
      var $18=HEAP32[(($arrayidx11)>>2)]; //@line 232 "voices.cpp"
      $height2=$18; //@line 232 "voices.cpp"
      var $19=$freq2; //@line 233 "voices.cpp"
      var $20=$freq1; //@line 233 "voices.cpp"
      var $sub12=((($19)-($20))&4294967295); //@line 233 "voices.cpp"
      var $cmp13=((($sub12))|0) > 0; //@line 233 "voices.cpp"
      if ($cmp13) { __label__ = 5;; } else { __label__ = 9;; } //@line 233 "voices.cpp"
      $if_then14$$if_end31$8: do { 
        if (__label__ == 5) {
  
          var $21=$height2; //@line 235 "voices.cpp"
          var $22=$height1; //@line 235 "voices.cpp"
          var $sub15=((($21)-($22))&4294967295); //@line 235 "voices.cpp"
          var $conv=((($sub15))|0); //@line 235 "voices.cpp"
          var $23=$freq2; //@line 235 "voices.cpp"
          var $24=$freq1; //@line 235 "voices.cpp"
          var $sub16=((($23)-($24))&4294967295); //@line 235 "voices.cpp"
          var $conv17=((($sub16))|0); //@line 235 "voices.cpp"
          var $div18=($conv)/($conv17); //@line 235 "voices.cpp"
          $rate=$div18; //@line 235 "voices.cpp"
          var $25=$freq1; //@line 237 "voices.cpp"
          $ix=$25; //@line 237 "voices.cpp"
          var $26=$ix; //@line 237 "voices.cpp"
          var $27=$freq2; //@line 237 "voices.cpp"
          var $cmp201=((($26))|0) < ((($27))|0); //@line 237 "voices.cpp"
          if (!($cmp201)) { __label__ = 9;break $if_then14$$if_end31$8; } //@line 237 "voices.cpp"
          while(1) { 
  
            var $28=$height1; //@line 239 "voices.cpp"
            var $29=$rate; //@line 239 "voices.cpp"
            var $30=$ix; //@line 239 "voices.cpp"
            var $31=$freq1; //@line 239 "voices.cpp"
            var $sub22=((($30)-($31))&4294967295); //@line 239 "voices.cpp"
            var $conv23=((($sub22))|0); //@line 239 "voices.cpp"
            var $mul=($29)*($conv23); //@line 239 "voices.cpp"
            var $conv24=((($mul))|0); //@line 239 "voices.cpp"
            var $add25=((($conv24)+($28))&4294967295); //@line 239 "voices.cpp"
            $y=$add25; //@line 239 "voices.cpp"
            var $cmp26=((($add25))|0) > 255; //@line 240 "voices.cpp"
            if ($cmp26) { __label__ = 7;; } else { __label__ = 8;; } //@line 240 "voices.cpp"
            if (__label__ == 7) {
  
              $y=255; //@line 241 "voices.cpp"
              ; //@line 241 "voices.cpp"
            }
  
            var $32=$y; //@line 242 "voices.cpp"
            var $conv29=((($32)) & 255); //@line 242 "voices.cpp"
            var $33=$ix; //@line 242 "voices.cpp"
            var $34=$voice_addr; //@line 242 "voices.cpp"
            var $tone_adjust=(($34+344)&4294967295); //@line 242 "voices.cpp"
            var $arrayidx30=(($tone_adjust+$33)&4294967295); //@line 242 "voices.cpp"
            HEAP8[($arrayidx30)]=$conv29; //@line 242 "voices.cpp"
            var $35=$ix; //@line 237 "voices.cpp"
            var $inc=((($35)+1)&4294967295); //@line 237 "voices.cpp"
            $ix=$inc; //@line 237 "voices.cpp"
            var $36=$ix; //@line 237 "voices.cpp"
            var $37=$freq2; //@line 237 "voices.cpp"
            var $cmp20=((($36))|0) < ((($37))|0); //@line 237 "voices.cpp"
            if ($cmp20) { __label__ = 6;continue ; } else { __label__ = 9;break $if_then14$$if_end31$8; } //@line 237 "voices.cpp"
          }
        }
      } while(0);
  
      var $38=$freq2; //@line 245 "voices.cpp"
      $freq1=$38; //@line 245 "voices.cpp"
      var $39=$height2; //@line 246 "voices.cpp"
      $height1=$39; //@line 246 "voices.cpp"
      var $40=$pt; //@line 223 "voices.cpp"
      var $add33=((($40)+2)&4294967295); //@line 223 "voices.cpp"
      $pt=$add33; //@line 223 "voices.cpp"
      var $cmp=((($add33))|0) < 12; //@line 223 "voices.cpp"
      if ($cmp) { __label__ = 1;continue $for_body$2; } else { __label__ = 10;break $for_body$2; } //@line 223 "voices.cpp"
    }
  
    ;
    return; //@line 248 "voices.cpp"
    return;
  }
  

  function __Z9LoadVoicePKci($vname, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 1260; _memset(__stackBase__, 0, 1260);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $vname_addr;
    var $control_addr;
    var $f_voice;
    var $p;
    var $key;
    var $ix;
    var $n;
    var $value=__stackBase__;
    var $value2=__stackBase__+4;
    var $error;
    var $langix;
    var $tone_only;
    var $language_set;
    var $phonemes_set;
    var $stress_amps_set;
    var $stress_lengths_set;
    var $stress_add_set;
    var $conditional_rules;
    var $langopts;
    var $new_translator;
    var $voicename=__stackBase__+8;
    var $language_name=__stackBase__+48;
    var $translator_name=__stackBase__+88;
    var $new_dictionary=__stackBase__+128;
    var $phonemes_name=__stackBase__+168;
    var $option_name=__stackBase__+208;
    var $language_type;
    var $buf=__stackBase__+248;
    var $path_voices=__stackBase__+448;
    var $langname=__stackBase__+612;
    var $stress_amps=__stackBase__+616;
    var $stress_lengths=__stackBase__+648;
    var $stress_add=__stackBase__+680;
    var $names=__stackBase__+712;
    var $pitch1=__stackBase__+1032;
    var $pitch2=__stackBase__+1036;
    var $len;
    var $priority=__stackBase__+1040;
    var $age=__stackBase__+1044;
    var $vgender=__stackBase__+1048;
    var $factor;
    var $tone_data=__stackBase__+1128;
    var $srate=__stackBase__+1176;
    var $name=__stackBase__+1180;
    var $phtrans=__stackBase__+1220;
    $vname_addr=$vname;
    $control_addr=$control;
    $f_voice=0; //@line 528 "voices.cpp"
    $error=0; //@line 535 "voices.cpp"
    $langix=0; //@line 536 "voices.cpp"
    var $0=$control_addr; //@line 537 "voices.cpp"
    var $and=($0) & 2; //@line 537 "voices.cpp"
    $tone_only=$and; //@line 537 "voices.cpp"
    $language_set=0; //@line 538 "voices.cpp"
    $phonemes_set=0; //@line 539 "voices.cpp"
    $stress_amps_set=0; //@line 540 "voices.cpp"
    $stress_lengths_set=0; //@line 541 "voices.cpp"
    $stress_add_set=0; //@line 542 "voices.cpp"
    $conditional_rules=0; //@line 543 "voices.cpp"
    $langopts=0; //@line 544 "voices.cpp"
    $new_translator=0; //@line 546 "voices.cpp"
    var $arraydecay=(($voicename)&4294967295); //@line 571 "voices.cpp"
    var $1=$vname_addr; //@line 571 "voices.cpp"
    var $call=_strcpy($arraydecay, $1); //@line 571 "voices.cpp"
    var $arrayidx=(($voicename)&4294967295); //@line 572 "voices.cpp"
    var $2=HEAP8[($arrayidx)]; //@line 572 "voices.cpp"
    var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 572 "voices.cpp"
    var $cmp=((($conv))|0)==0; //@line 572 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 572 "voices.cpp"
    if (__label__ == 1) {
  
      var $arraydecay1=(($voicename)&4294967295); //@line 573 "voices.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = ((__str45697)&4294967295);
      $dest$ = $arraydecay1;
      $stop$ = $src$ + 8;
      if (($dest$%4) == ($src$%4) && 8 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 573 "voices.cpp"
      ; //@line 573 "voices.cpp"
    }
  
    var $3=$control_addr; //@line 575 "voices.cpp"
    var $and3=($3) & 16; //@line 575 "voices.cpp"
    var $tobool=((($and3))|0)!=0; //@line 575 "voices.cpp"
    if ($tobool) { __label__ = 3;; } else { __label__ = 5;; } //@line 575 "voices.cpp"
    $if_then4$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $arraydecay5=(($buf)&4294967295); //@line 577 "voices.cpp"
        var $4=$vname_addr; //@line 577 "voices.cpp"
        var $call6=_strcpy($arraydecay5, $4); //@line 577 "voices.cpp"
        var $arraydecay7=(($buf)&4294967295); //@line 578 "voices.cpp"
        var $call8=__Z13GetFileLengthPKc($arraydecay7); //@line 578 "voices.cpp"
        var $cmp9=((($call8))|0) <= 0; //@line 578 "voices.cpp"
        if (!($cmp9)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 578 "voices.cpp"
  
        $retval=0; //@line 579 "voices.cpp"
        __label__ = 137;break $if_then4$$if_else$5; //@line 579 "voices.cpp"
      }
      else if (__label__ == 5) {
  
        var $arraydecay12=(($path_voices)&4294967295); //@line 583 "voices.cpp"
        var $call13=_sprintf($arraydecay12, ((__str46698)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0,47,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 583 "voices.cpp"
        var $arraydecay14=(($buf)&4294967295); //@line 584 "voices.cpp"
        var $arraydecay15=(($path_voices)&4294967295); //@line 584 "voices.cpp"
        var $arraydecay16=(($voicename)&4294967295); //@line 584 "voices.cpp"
        var $call17=_sprintf($arraydecay14, ((__str47699)&4294967295), allocate([$arraydecay15,0,0,0,$arraydecay16,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 584 "voices.cpp"
        var $arraydecay18=(($buf)&4294967295); //@line 586 "voices.cpp"
        var $call19=__Z13GetFileLengthPKc($arraydecay18); //@line 586 "voices.cpp"
        var $cmp20=((($call19))|0) <= 0; //@line 586 "voices.cpp"
        if (!($cmp20)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 586 "voices.cpp"
  
        var $arrayidx22=(($voicename)&4294967295); //@line 589 "voices.cpp"
        var $5=HEAP8[($arrayidx22)]; //@line 589 "voices.cpp"
        var $arrayidx23=(($langname)&4294967295); //@line 589 "voices.cpp"
        HEAP8[($arrayidx23)]=$5; //@line 589 "voices.cpp"
        var $arrayidx24=(($voicename+1)&4294967295); //@line 590 "voices.cpp"
        var $6=HEAP8[($arrayidx24)]; //@line 590 "voices.cpp"
        var $arrayidx25=(($langname+1)&4294967295); //@line 590 "voices.cpp"
        HEAP8[($arrayidx25)]=$6; //@line 590 "voices.cpp"
        var $arrayidx26=(($langname+2)&4294967295); //@line 591 "voices.cpp"
        HEAP8[($arrayidx26)]=0; //@line 591 "voices.cpp"
        var $arraydecay27=(($buf)&4294967295); //@line 592 "voices.cpp"
        var $arraydecay28=(($path_voices)&4294967295); //@line 592 "voices.cpp"
        var $arraydecay29=(($langname)&4294967295); //@line 592 "voices.cpp"
        var $arraydecay30=(($voicename)&4294967295); //@line 592 "voices.cpp"
        var $call31=_sprintf($arraydecay27, ((__str48700)&4294967295), allocate([$arraydecay28,0,0,0,$arraydecay29,0,0,0,47,0,0,0,$arraydecay30,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 592 "voices.cpp"
        var $arraydecay32=(($buf)&4294967295); //@line 594 "voices.cpp"
        var $call33=__Z13GetFileLengthPKc($arraydecay32); //@line 594 "voices.cpp"
        var $cmp34=((($call33))|0) <= 0; //@line 594 "voices.cpp"
        if (!($cmp34)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 594 "voices.cpp"
  
        var $arraydecay36=(($buf)&4294967295); //@line 597 "voices.cpp"
        var $arraydecay37=(($path_voices)&4294967295); //@line 597 "voices.cpp"
        var $arraydecay38=(($voicename)&4294967295); //@line 597 "voices.cpp"
        var $call39=_sprintf($arraydecay36, ((__str49701)&4294967295), allocate([$arraydecay37,0,0,0,47,0,0,0,$arraydecay38,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 597 "voices.cpp"
        var $arraydecay40=(($buf)&4294967295); //@line 599 "voices.cpp"
        var $call41=__Z13GetFileLengthPKc($arraydecay40); //@line 599 "voices.cpp"
        var $cmp42=((($call41))|0) <= 0; //@line 599 "voices.cpp"
        if (!($cmp42)) { __label__ = 9;break $if_then4$$if_else$5; } //@line 599 "voices.cpp"
  
        var $arraydecay44=(($buf)&4294967295); //@line 602 "voices.cpp"
        var $arraydecay45=(($path_voices)&4294967295); //@line 602 "voices.cpp"
        var $arraydecay46=(($voicename)&4294967295); //@line 602 "voices.cpp"
        var $call47=_sprintf($arraydecay44, ((__str50702)&4294967295), allocate([$arraydecay45,0,0,0,47,0,0,0,$arraydecay46,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 602 "voices.cpp"
        __label__ = 9;break $if_then4$$if_else$5; //@line 603 "voices.cpp"
      }
    } while(0);
    $return$$if_end51$12: do { 
      if (__label__ == 9) {
  
        var $arraydecay52=(($buf)&4294967295); //@line 608 "voices.cpp"
        var $call53=_fopen($arraydecay52, ((__str51703)&4294967295)); //@line 608 "voices.cpp"
        $f_voice=$call53; //@line 608 "voices.cpp"
        $language_type=((__str52704)&4294967295); //@line 610 "voices.cpp"
        var $cmp54=((($call53))|0)==0; //@line 611 "voices.cpp"
        if ($cmp54) { __label__ = 10;; } else { __label__ = 14;; } //@line 611 "voices.cpp"
        $if_then55$$if_end66$14: do { 
          if (__label__ == 10) {
  
            var $7=$control_addr; //@line 613 "voices.cpp"
            var $and56=($7) & 3; //@line 613 "voices.cpp"
            var $tobool57=((($and56))|0)!=0; //@line 613 "voices.cpp"
            if ($tobool57) { __label__ = 11;; } else { __label__ = 12;; } //@line 613 "voices.cpp"
            if (__label__ == 11) {
  
              $retval=0; //@line 614 "voices.cpp"
              __label__ = 137;break $return$$if_end51$12; //@line 614 "voices.cpp"
            }
            else if (__label__ == 12) {
  
              var $arraydecay60=(($voicename)&4294967295); //@line 616 "voices.cpp"
              var $call61=__Z22SelectPhonemeTableNamePKc($arraydecay60); //@line 616 "voices.cpp"
              var $cmp62=((($call61))|0) >= 0; //@line 616 "voices.cpp"
              if (!($cmp62)) { __label__ = 14;break $if_then55$$if_end66$14; } //@line 616 "voices.cpp"
  
              var $arraydecay64=(($voicename)&4294967295); //@line 617 "voices.cpp"
              $language_type=$arraydecay64; //@line 617 "voices.cpp"
              ; //@line 617 "voices.cpp"
            }
          }
        } while(0);
  
        var $8=$tone_only; //@line 620 "voices.cpp"
        var $tobool67=((($8))|0)==0; //@line 620 "voices.cpp"
        var $9=HEAP32[((_translator)>>2)]; //@line 620 "voices.cpp"
        var $cmp68=((($9))|0)!=0; //@line 620 "voices.cpp"
        var $or_cond=($tobool67) & ($cmp68); //@line 620 "voices.cpp"
        if ($or_cond) { __label__ = 15;; } else { __label__ = 16;; } //@line 620 "voices.cpp"
        if (__label__ == 15) {
  
          var $10=HEAP32[((_translator)>>2)]; //@line 622 "voices.cpp"
          __Z16DeleteTranslatorP10Translator($10); //@line 622 "voices.cpp"
          HEAP32[((_translator)>>2)]=0; //@line 623 "voices.cpp"
          ; //@line 624 "voices.cpp"
        }
  
        var $arraydecay71=(($translator_name)&4294967295); //@line 626 "voices.cpp"
        var $11=$language_type; //@line 626 "voices.cpp"
        var $call72=_strcpy($arraydecay71, $11); //@line 626 "voices.cpp"
        var $arraydecay73=(($new_dictionary)&4294967295); //@line 627 "voices.cpp"
        var $12=$language_type; //@line 627 "voices.cpp"
        var $call74=_strcpy($arraydecay73, $12); //@line 627 "voices.cpp"
        var $arraydecay75=(($phonemes_name)&4294967295); //@line 628 "voices.cpp"
        var $13=$language_type; //@line 628 "voices.cpp"
        var $call76=_strcpy($arraydecay75, $13); //@line 628 "voices.cpp"
        var $14=$tone_only; //@line 631 "voices.cpp"
        var $tobool77=((($14))|0)!=0; //@line 631 "voices.cpp"
        if ($tobool77) { __label__ = 18;; } else { __label__ = 17;; } //@line 631 "voices.cpp"
        if (__label__ == 18) {
  
          var $call80=_strchr(((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295), 43); //@line 645 "voices.cpp"
          $p=$call80; //@line 645 "voices.cpp"
          var $cmp81=((($call80))|0)!=0; //@line 645 "voices.cpp"
          if ($cmp81) { __label__ = 19;; } else { __label__ = 20;; } //@line 645 "voices.cpp"
          if (__label__ == 19) {
  
            var $16=$p; //@line 646 "voices.cpp"
            HEAP8[($16)]=0; //@line 646 "voices.cpp"
            ; //@line 646 "voices.cpp"
          }
  
          var $arraydecay84=(($buf)&4294967295); //@line 647 "voices.cpp"
          var $17=$vname_addr; //@line 647 "voices.cpp"
          var $arrayidx85=(($17+3)&4294967295); //@line 647 "voices.cpp"
          var $call86=_sprintf($arraydecay84, ((__str53705)&4294967295), allocate([$arrayidx85,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 647 "voices.cpp"
          var $arraydecay87=(($buf)&4294967295); //@line 648 "voices.cpp"
          var $call88=_strcat(((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295), $arraydecay87); //@line 648 "voices.cpp"
          var $18=HEAP32[((_translator)>>2)]; //@line 649 "voices.cpp"
          var $langopts89=(($18)&4294967295); //@line 649 "voices.cpp"
          $langopts=$langopts89; //@line 649 "voices.cpp"
          ;
        }
        else if (__label__ == 17) {
  
          HEAP32[((_voice)>>2)]=__ZL9voicedata; //@line 633 "voices.cpp"
          var $15=$vname_addr; //@line 634 "voices.cpp"
          __Z8strncpy0PcPKci(((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295), $15, 40); //@line 634 "voices.cpp"
          HEAP8[(((__ZZ9LoadVoicePKciE10voice_name)&4294967295))]=0; //@line 635 "voices.cpp"
          HEAP8[(((__ZZ9LoadVoicePKciE15voice_languages)&4294967295))]=0; //@line 636 "voices.cpp"
          HEAP32[((((_voice_selected+8)&4294967295))>>2)]=((__ZZ9LoadVoicePKciE16voice_identifier)&4294967295); //@line 638 "voices.cpp"
          HEAP32[((((_voice_selected)&4294967295))>>2)]=((__ZZ9LoadVoicePKciE10voice_name)&4294967295); //@line 639 "voices.cpp"
          HEAP32[((((_voice_selected+4)&4294967295))>>2)]=((__ZZ9LoadVoicePKciE15voice_languages)&4294967295); //@line 640 "voices.cpp"
          ; //@line 641 "voices.cpp"
        }
  
        var $19=$tone_only; //@line 651 "voices.cpp"
        __Z10VoiceReseti($19); //@line 651 "voices.cpp"
        var $20=$tone_only; //@line 653 "voices.cpp"
        var $tobool91=((($20))|0)!=0; //@line 653 "voices.cpp"
        if ($tobool91) { __label__ = 23;; } else { __label__ = 22;; } //@line 653 "voices.cpp"
        if (__label__ == 22) {
  
          var $arraydecay93=(($phonemes_name)&4294967295); //@line 654 "voices.cpp"
          var $call94=__Z22SelectPhonemeTableNamePKc($arraydecay93); //@line 654 "voices.cpp"
          ; //@line 654 "voices.cpp"
        }
  
        var $arraydecay97=(($buf)&4294967295); //@line 657 "voices.cpp"
        var $arraydecay100=(($buf)&4294967295); //@line 660 "voices.cpp"
        var $arrayidx109=(($buf)&4294967295); //@line 663 "voices.cpp"
        var $arraydecay114=(($buf)&4294967295); //@line 665 "voices.cpp"
        var $arraydecay416=(($buf)&4294967295); //@line 954 "voices.cpp"
        var $arrayidx119=(($language_name)&4294967295); //@line 678 "voices.cpp"
        var $arraydecay120=(($language_name)&4294967295); //@line 680 "voices.cpp"
        var $arraydecay122=(($language_name)&4294967295); //@line 681 "voices.cpp"
        var $arraydecay127=(($language_name)&4294967295); //@line 684 "voices.cpp"
        var $arraydecay136=(($language_name)&4294967295); //@line 690 "voices.cpp"
        var $arraydecay142=(($language_name)&4294967295); //@line 697 "voices.cpp"
        var $arraydecay144=(($translator_name)&4294967295); //@line 699 "voices.cpp"
        var $arraydecay146=(($new_dictionary)&4294967295); //@line 700 "voices.cpp"
        var $arraydecay148=(($phonemes_name)&4294967295); //@line 701 "voices.cpp"
        var $arraydecay150=(($phonemes_name)&4294967295); //@line 702 "voices.cpp"
        var $arraydecay155=(($translator_name)&4294967295); //@line 707 "voices.cpp"
        var $arraydecay170=(($vgender)&4294967295); //@line 725 "voices.cpp"
        var $arraydecay172=(($vgender)&4294967295); //@line 726 "voices.cpp"
        var $arraydecay180=(($translator_name)&4294967295); //@line 734 "voices.cpp"
        var $arraydecay185=(($translator_name)&4294967295); //@line 739 "voices.cpp"
        var $arraydecay189=(($new_dictionary)&4294967295); //@line 744 "voices.cpp"
        var $arraydecay192=(($phonemes_name)&4294967295); //@line 748 "voices.cpp"
        var $arraydecay206=(($stress_lengths)&4294967295); //@line 768 "voices.cpp"
        var $arraydecay209=(($stress_amps)&4294967295); //@line 772 "voices.cpp"
        var $arraydecay212=(($stress_add)&4294967295); //@line 776 "voices.cpp"
        var $arrayidx222=(($names)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay223=(($arrayidx222)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx224=(($names+40)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay225=(($arrayidx224)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx226=(($names+80)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay227=(($arrayidx226)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx228=(($names+120)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay229=(($arrayidx228)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx230=(($names+160)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay231=(($arrayidx230)&4294967295); //@line 786 "voices.cpp"
        var $arrayidx232=(($names+200)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay233=(($arrayidx232)&4294967295); //@line 786 "voices.cpp"
        var $arraydecay290=(($phonemes_name)&4294967295); //@line 818 "voices.cpp"
        var $arraydecay308=(($option_name)&4294967295); //@line 846 "voices.cpp"
        var $arraydecay312=(($option_name)&4294967295); //@line 846 "voices.cpp"
        var $arraydecay320=(($buf)&4294967295); //@line 853 "voices.cpp"
        var $arraydecay347=(($tone_data)&4294967295); //@line 889 "voices.cpp"
        var $arraydecay348=(($tone_data)&4294967295); //@line 890 "voices.cpp"
        var $arrayidx385=(($phtrans)&4294967295); //@line 926 "voices.cpp"
        var $arraydecay386=(($name)&4294967295); //@line 927 "voices.cpp"
        var $arraydecay387=(($phtrans)&4294967295); //@line 927 "voices.cpp"
        var $arraydecay389=(($name)&4294967295); //@line 928 "voices.cpp"
        var $arraydecay390=(($phtrans)&4294967295); //@line 928 "voices.cpp"
        ; //@line 657 "voices.cpp"
        $while_cond$34: while(1) { 
  
          var $21=$f_voice; //@line 657 "voices.cpp"
          var $cmp96=((($21))|0)!=0; //@line 657 "voices.cpp"
          if (!($cmp96)) { __label__ = 114;break $while_cond$34; } //@line 657 "voices.cpp"
  
          var $22=$f_voice; //@line 657 "voices.cpp"
          var $call98=__ZL11fgets_stripPciP7__sFILE($arraydecay97, 200, $22); //@line 657 "voices.cpp"
          var $cmp99=((($call98))|0)!=0; //@line 657 "voices.cpp"
          if (!($cmp99)) { __label__ = 112;break $while_cond$34; }
  
          $p=$arraydecay100; //@line 660 "voices.cpp"
          ; //@line 660 "voices.cpp"
          $for_cond$38: while(1) { 
  
            var $23=$p; //@line 660 "voices.cpp"
            var $24=HEAP8[($23)]; //@line 660 "voices.cpp"
            var $conv101=(tempInt=(($24)),(tempInt>=128?tempInt-256:tempInt)); //@line 660 "voices.cpp"
            var $cmp102=((($conv101))|0)!=0; //@line 660 "voices.cpp"
            if (!($cmp102)) { __label__ = 30;break $for_cond$38; } //@line 660 "voices.cpp"
  
            var $25=$p; //@line 660 "voices.cpp"
            var $26=HEAP8[($25)]; //@line 660 "voices.cpp"
            var $conv104=(tempInt=(($26)),(tempInt>=128?tempInt-256:tempInt)); //@line 660 "voices.cpp"
            var $call105=_isspace($conv104); //@line 660 "voices.cpp"
            var $tobool106=((($call105))|0)!=0; //@line 660 "voices.cpp"
            var $lnot=($tobool106) ^ 1; //@line 660 "voices.cpp"
            if (!($lnot)) { __label__ = 30;break $for_cond$38; }
  
            var $27=$p; //@line 660 "voices.cpp"
            var $incdec_ptr=(($27+1)&4294967295); //@line 660 "voices.cpp"
            $p=$incdec_ptr; //@line 660 "voices.cpp"
            __label__ = 27;continue $for_cond$38; //@line 660 "voices.cpp"
          }
  
          var $28=$p; //@line 661 "voices.cpp"
          var $incdec_ptr108=(($28+1)&4294967295); //@line 661 "voices.cpp"
          $p=$incdec_ptr108; //@line 661 "voices.cpp"
          HEAP8[($28)]=0; //@line 661 "voices.cpp"
          var $29=HEAP8[($arrayidx109)]; //@line 663 "voices.cpp"
          var $conv110=(tempInt=(($29)),(tempInt>=128?tempInt-256:tempInt)); //@line 663 "voices.cpp"
          var $cmp111=((($conv110))|0)==0; //@line 663 "voices.cpp"
          if ($cmp111) { __label__ = 24;continue $while_cond$34; } //@line 663 "voices.cpp"
  
          var $call115=__Z10LookupMnemP8MNEM_TABPKc(((__ZL11keyword_tab)&4294967295), $arraydecay114); //@line 665 "voices.cpp"
          $key=$call115; //@line 665 "voices.cpp"
          var $30=$key; //@line 667 "voices.cpp"
          if ($30 == 2) {
            __label__ = 33;;
          }
          else if ($30 == 1) {
            __label__ = 41;;
          }
          else if ($30 == 3) {
            __label__ = 45;;
          }
          else if ($30 == 4) {
            __label__ = 46;;
          }
          else if ($30 == 6) {
            __label__ = 50;;
          }
          else if ($30 == 5) {
            __label__ = 51;;
          }
          else if ($30 == 7) {
            __label__ = 52;;
          }
          else if ($30 == 8) {
            __label__ = 53;;
          }
          else if ($30 == 20) {
            __label__ = 54;;
          }
          else if ($30 == 21) {
            __label__ = 55;;
          }
          else if ($30 == 22) {
            __label__ = 56;;
          }
          else if ($30 == 18) {
            __label__ = 57;;
          }
          else if ($30 == 19) {
            __label__ = 59;;
          }
          else if ($30 == 23) {
            __label__ = 32;;
          }
          else if ($30 == 32) {
            __label__ = 73;;
          }
          else if ($30 == 17) {
            __label__ = 76;;
          }
          else if ($30 == 24) {
            __label__ = 77;;
          }
          else if ($30 == 25) {
            __label__ = 78;;
          }
          else if ($30 == 26) {
            __label__ = 80;;
          }
          else if ($30 == 27) {
            __label__ = 81;;
          }
          else if ($30 == 9) {
            __label__ = 85;;
          }
          else if ($30 == 10) {
            __label__ = 86;;
          }
          else if ($30 == 11) {
            __label__ = 88;;
          }
          else if ($30 == 12) {
            __label__ = 90;;
          }
          else if ($30 == 13) {
            __label__ = 94;;
          }
          else if ($30 == 14) {
            __label__ = 95;;
          }
          else if ($30 == 15) {
            __label__ = 97;;
          }
          else if ($30 == 16) {
            __label__ = 101;;
          }
          else if ($30 == 33) {
            __label__ = 102;;
          }
          else if ($30 == 31) {
            __label__ = 103;;
          }
          else if ($30 == 28) {
            __label__ = 104;;
          }
          else if ($30 == 29) {
            __label__ = 107;;
          }
          else if ($30 == 30) {
            __label__ = 108;;
          }
          else {
          __label__ = 109;;
          }
          
          if (__label__ == 109) {
  
            var $195=$key; //@line 948 "voices.cpp"
            var $and407=($195) & 65280; //@line 948 "voices.cpp"
            var $cmp408=((($and407))|0)==256; //@line 948 "voices.cpp"
            if ($cmp408) { __label__ = 110;; } else { __label__ = 111;; } //@line 948 "voices.cpp"
            if (__label__ == 110) {
  
              var $196=$p; //@line 950 "voices.cpp"
              var $197=$key; //@line 950 "voices.cpp"
              var $and410=($197) & 255; //@line 950 "voices.cpp"
              var $198=$langopts; //@line 950 "voices.cpp"
              var $param411=(($198+24)&4294967295); //@line 950 "voices.cpp"
              var $arrayidx412=(($param411+$and410*4)&4294967295); //@line 950 "voices.cpp"
              var $call413=_sscanf($196, ((__str63715)&4294967295), allocate([$arrayidx412,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 950 "voices.cpp"
              __label__ = 24;continue $while_cond$34; //@line 951 "voices.cpp"
            }
            else if (__label__ == 111) {
  
              var $199=HEAP32[((__impure_ptr)>>2)]; //@line 954 "voices.cpp"
              var $_stderr415=(($199+12)&4294967295); //@line 954 "voices.cpp"
              var $200=HEAP32[(($_stderr415)>>2)]; //@line 954 "voices.cpp"
              var $call417=_fprintf($200, ((__str68720)&4294967295), allocate([$arraydecay416,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 954 "voices.cpp"
              __label__ = 24;continue $while_cond$34;
            }
          }
          else if (__label__ == 33) {
  
            var $33=$tone_only; //@line 674 "voices.cpp"
            var $tobool116=((($33))|0)!=0; //@line 674 "voices.cpp"
            if ($tobool116) { __label__ = 24;continue $while_cond$34; } //@line 674 "voices.cpp"
  
            HEAP32[(($priority)>>2)]=5; //@line 677 "voices.cpp"
            HEAP8[($arrayidx119)]=0; //@line 678 "voices.cpp"
            var $34=$p; //@line 680 "voices.cpp"
            var $call121=_sscanf($34, ((__str54706)&4294967295), allocate([$arraydecay120,0,0,0,$priority,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 680 "voices.cpp"
            var $call123=_strcmp($arraydecay122, ((__str55707)&4294967295)); //@line 681 "voices.cpp"
            var $cmp124=((($call123))|0)==0; //@line 681 "voices.cpp"
            if ($cmp124) { __label__ = 24;continue $while_cond$34; } //@line 681 "voices.cpp"
  
            var $call128=_strlen($arraydecay127); //@line 684 "voices.cpp"
            var $add=((($call128)+2)&4294967295); //@line 684 "voices.cpp"
            $len=$add; //@line 684 "voices.cpp"
            var $35=$len; //@line 686 "voices.cpp"
            var $36=$langix; //@line 686 "voices.cpp"
            var $_neg=(((-($36)))&4294967295);
            var $sub129=((($_neg)+99)&4294967295); //@line 686 "voices.cpp"
            var $cmp130=((($35))>>>0) < ((($sub129))>>>0); //@line 686 "voices.cpp"
            if ($cmp130) { __label__ = 36;; } else { __label__ = 37;; } //@line 686 "voices.cpp"
            if (__label__ == 36) {
  
              var $37=HEAP32[(($priority)>>2)]; //@line 688 "voices.cpp"
              var $conv132=((($37)) & 255); //@line 688 "voices.cpp"
              var $38=$langix; //@line 688 "voices.cpp"
              var $arrayidx133=((__ZZ9LoadVoicePKciE15voice_languages+$38)&4294967295); //@line 688 "voices.cpp"
              HEAP8[($arrayidx133)]=$conv132; //@line 688 "voices.cpp"
              var $39=$langix; //@line 690 "voices.cpp"
              var $add134=((($39)+1)&4294967295); //@line 690 "voices.cpp"
              var $arrayidx135=((__ZZ9LoadVoicePKciE15voice_languages+$add134)&4294967295); //@line 690 "voices.cpp"
              var $call137=_strcpy($arrayidx135, $arraydecay136); //@line 690 "voices.cpp"
              var $40=$len; //@line 691 "voices.cpp"
              var $41=$langix; //@line 691 "voices.cpp"
              var $add138=((($41)+($40))&4294967295); //@line 691 "voices.cpp"
              $langix=$add138; //@line 691 "voices.cpp"
              ; //@line 692 "voices.cpp"
            }
  
            var $42=$language_set; //@line 695 "voices.cpp"
            var $cmp140=((($42))|0)==0; //@line 695 "voices.cpp"
            if (!($cmp140)) { __label__ = 24;continue $while_cond$34; } //@line 695 "voices.cpp"
  
            var $call143=_strtok($arraydecay142, ((__str56708)&4294967295)); //@line 697 "voices.cpp"
            $language_type=$call143; //@line 697 "voices.cpp"
            $language_set=1; //@line 698 "voices.cpp"
            var $43=$language_type; //@line 699 "voices.cpp"
            var $call145=_strcpy($arraydecay144, $43); //@line 699 "voices.cpp"
            var $44=$language_type; //@line 700 "voices.cpp"
            var $call147=_strcpy($arraydecay146, $44); //@line 700 "voices.cpp"
            var $45=$language_type; //@line 701 "voices.cpp"
            var $call149=_strcpy($arraydecay148, $45); //@line 701 "voices.cpp"
            var $call151=__Z22SelectPhonemeTableNamePKc($arraydecay150); //@line 702 "voices.cpp"
            var $46=$new_translator; //@line 704 "voices.cpp"
            var $cmp152=((($46))|0)!=0; //@line 704 "voices.cpp"
            if ($cmp152) { __label__ = 39;; } else { __label__ = 40;; } //@line 704 "voices.cpp"
            if (__label__ == 39) {
  
              var $47=$new_translator; //@line 705 "voices.cpp"
              __Z16DeleteTranslatorP10Translator($47); //@line 705 "voices.cpp"
              ; //@line 705 "voices.cpp"
            }
  
            var $call156=__Z16SelectTranslatorPKc($arraydecay155); //@line 707 "voices.cpp"
            $new_translator=$call156; //@line 707 "voices.cpp"
            var $48=$new_translator; //@line 708 "voices.cpp"
            var $langopts157=(($48)&4294967295); //@line 708 "voices.cpp"
            $langopts=$langopts157; //@line 708 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 709 "voices.cpp"
          }
          else if (__label__ == 41) {
  
            var $49=$tone_only; //@line 714 "voices.cpp"
            var $cmp160=((($49))|0)==0; //@line 714 "voices.cpp"
            if (!($cmp160)) { __label__ = 24;continue $while_cond$34; } //@line 714 "voices.cpp"
  
            var $50=$p; //@line 716 "voices.cpp"
            var $51=HEAP8[($50)]; //@line 716 "voices.cpp"
            var $conv1636=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 716 "voices.cpp"
            var $call1647=_isspace($conv1636); //@line 716 "voices.cpp"
            var $tobool1658=((($call1647))|0)!=0; //@line 716 "voices.cpp"
            var $52=$p; //@line 716 "voices.cpp"
            if ($tobool1658) { __lastLabel__ = 42; __label__ = 43;; } else { __lastLabel__ = 42; __label__ = 44;; } //@line 716 "voices.cpp"
            $while_body166$$while_end$61: do { 
              if (__label__ == 43) {
                while(1) { 
  
                  var $53=__lastLabel__ == 43 ? $56 : ($52);
                  var $incdec_ptr167=(($53+1)&4294967295); //@line 716 "voices.cpp"
                  $p=$incdec_ptr167; //@line 716 "voices.cpp"
                  var $54=$p; //@line 716 "voices.cpp"
                  var $55=HEAP8[($54)]; //@line 716 "voices.cpp"
                  var $conv163=(tempInt=(($55)),(tempInt>=128?tempInt-256:tempInt)); //@line 716 "voices.cpp"
                  var $call164=_isspace($conv163); //@line 716 "voices.cpp"
                  var $tobool165=((($call164))|0)!=0; //@line 716 "voices.cpp"
                  var $56=$p; //@line 716 "voices.cpp"
                  if ($tobool165) { __lastLabel__ = 43; __label__ = 43;continue ; } else { __lastLabel__ = 43; __label__ = 44;break $while_body166$$while_end$61; } //@line 716 "voices.cpp"
                }
              }
            } while(0);
  
            var $_lcssa=__lastLabel__ == 42 ? $52 : ($56);
            __Z8strncpy0PcPKci(((__ZZ9LoadVoicePKciE10voice_name)&4294967295), $_lcssa, 40); //@line 717 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 718 "voices.cpp"
          }
          else if (__label__ == 45) {
  
            HEAP32[(($age)>>2)]=0; //@line 723 "voices.cpp"
            var $57=$p; //@line 725 "voices.cpp"
            var $call171=_sscanf($57, ((__str54706)&4294967295), allocate([$arraydecay170,0,0,0,$age,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 725 "voices.cpp"
            var $call173=__Z10LookupMnemP8MNEM_TABPKc(((_genders)&4294967295), $arraydecay172); //@line 726 "voices.cpp"
            var $conv174=((($call173)) & 255); //@line 726 "voices.cpp"
            HEAP8[(((_voice_selected+12)&4294967295))]=$conv174; //@line 726 "voices.cpp"
            var $58=HEAP32[(($age)>>2)]; //@line 727 "voices.cpp"
            var $conv175=((($58)) & 255); //@line 727 "voices.cpp"
            HEAP8[(((_voice_selected+13)&4294967295))]=$conv175; //@line 727 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 729 "voices.cpp"
          }
          else if (__label__ == 46) {
  
            var $59=$tone_only; //@line 732 "voices.cpp"
            var $tobool177=((($59))|0)!=0; //@line 732 "voices.cpp"
            if ($tobool177) { __label__ = 24;continue $while_cond$34; } //@line 732 "voices.cpp"
  
            var $60=$p; //@line 734 "voices.cpp"
            var $call181=_sscanf($60, ((__str57709)&4294967295), allocate([$arraydecay180,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 734 "voices.cpp"
            var $61=$new_translator; //@line 736 "voices.cpp"
            var $cmp182=((($61))|0)!=0; //@line 736 "voices.cpp"
            if ($cmp182) { __label__ = 48;; } else { __label__ = 49;; } //@line 736 "voices.cpp"
            if (__label__ == 48) {
  
              var $62=$new_translator; //@line 737 "voices.cpp"
              __Z16DeleteTranslatorP10Translator($62); //@line 737 "voices.cpp"
              ; //@line 737 "voices.cpp"
            }
  
            var $call186=__Z16SelectTranslatorPKc($arraydecay185); //@line 739 "voices.cpp"
            $new_translator=$call186; //@line 739 "voices.cpp"
            var $63=$new_translator; //@line 740 "voices.cpp"
            var $langopts187=(($63)&4294967295); //@line 740 "voices.cpp"
            $langopts=$langopts187; //@line 740 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 741 "voices.cpp"
          }
          else if (__label__ == 50) {
  
            var $64=$p; //@line 744 "voices.cpp"
            var $call190=_sscanf($64, ((__str57709)&4294967295), allocate([$arraydecay189,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 744 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 745 "voices.cpp"
          }
          else if (__label__ == 51) {
  
            var $65=$p; //@line 748 "voices.cpp"
            var $call193=_sscanf($65, ((__str57709)&4294967295), allocate([$arraydecay192,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 748 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 749 "voices.cpp"
          }
          else if (__label__ == 52) {
  
            var $66=$p; //@line 752 "voices.cpp"
            __ZL12VoiceFormantPc($66); //@line 752 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 753 "voices.cpp"
          }
          else if (__label__ == 53) {
  
            var $67=$p; //@line 759 "voices.cpp"
            var $call196=_sscanf($67, ((__str58710)&4294967295), allocate([$pitch1,0,0,0,$pitch2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 759 "voices.cpp"
            $n=$call196; //@line 759 "voices.cpp"
            var $68=HEAP32[(($pitch1)>>2)]; //@line 760 "voices.cpp"
            var $sub197=((($68)-9)&4294967295); //@line 760 "voices.cpp"
            var $shl=($sub197) << 12; //@line 760 "voices.cpp"
            var $69=HEAP32[((_voice)>>2)]; //@line 760 "voices.cpp"
            var $pitch_base=(($69+44)&4294967295); //@line 760 "voices.cpp"
            HEAP32[(($pitch_base)>>2)]=$shl; //@line 760 "voices.cpp"
            var $70=HEAP32[(($pitch2)>>2)]; //@line 761 "voices.cpp"
            var $71=HEAP32[(($pitch1)>>2)]; //@line 761 "voices.cpp"
            var $sub198=((($70)-($71))&4294967295); //@line 761 "voices.cpp"
            var $mul=((($sub198)*108)&4294967295); //@line 761 "voices.cpp"
            var $72=HEAP32[((_voice)>>2)]; //@line 761 "voices.cpp"
            var $pitch_range=(($72+48)&4294967295); //@line 761 "voices.cpp"
            HEAP32[(($pitch_range)>>2)]=$mul; //@line 761 "voices.cpp"
            var $73=HEAP32[(($pitch1)>>2)]; //@line 762 "voices.cpp"
            var $sub199=((($73)-82)&4294967295); //@line 762 "voices.cpp"
            var $conv200=((($sub199))|0); //@line 762 "voices.cpp"
            var $div=($conv200)/82; //@line 762 "voices.cpp"
            $factor=$div; //@line 762 "voices.cpp"
            var $74=$factor; //@line 763 "voices.cpp"
            var $div201=($74)/4; //@line 763 "voices.cpp"
            var $add202=1+($div201); //@line 763 "voices.cpp"
            var $mul203=($add202)*256; //@line 763 "voices.cpp"
            var $conv204=((($mul203))|0); //@line 763 "voices.cpp"
            var $75=HEAP32[((_voice)>>2)]; //@line 763 "voices.cpp"
            var $formant_factor=(($75+96)&4294967295); //@line 763 "voices.cpp"
            HEAP32[(($formant_factor)>>2)]=$conv204; //@line 763 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 765 "voices.cpp"
          }
          else if (__label__ == 54) {
  
            var $76=$p; //@line 768 "voices.cpp"
            var $call207=__ZL12Read8NumbersPcPi($76, $arraydecay206); //@line 768 "voices.cpp"
            $stress_lengths_set=$call207; //@line 768 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 769 "voices.cpp"
          }
          else if (__label__ == 55) {
  
            var $77=$p; //@line 772 "voices.cpp"
            var $call210=__ZL12Read8NumbersPcPi($77, $arraydecay209); //@line 772 "voices.cpp"
            $stress_amps_set=$call210; //@line 772 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 773 "voices.cpp"
          }
          else if (__label__ == 56) {
  
            var $78=$p; //@line 776 "voices.cpp"
            var $call213=__ZL12Read8NumbersPcPi($78, $arraydecay212); //@line 776 "voices.cpp"
            $stress_add_set=$call213; //@line 776 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 777 "voices.cpp"
          }
          else if (__label__ == 57) {
  
            var $79=$p; //@line 780 "voices.cpp"
            var $call215=_sscanf($79, ((__str58710)&4294967295), allocate([_option_tone_flags,0,0,0,_option_tone2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 780 "voices.cpp"
            var $80=HEAP32[((_option_tone_flags)>>2)]; //@line 781 "voices.cpp"
            var $and216=($80) & 255; //@line 781 "voices.cpp"
            var $cmp217=((($and216))|0)!=0; //@line 781 "voices.cpp"
            if (!($cmp217)) { __label__ = 24;continue $while_cond$34; } //@line 781 "voices.cpp"
  
            var $81=HEAP32[((_option_tone_flags)>>2)]; //@line 782 "voices.cpp"
            var $and219=($81) & 255; //@line 782 "voices.cpp"
            var $82=$langopts; //@line 782 "voices.cpp"
            var $intonation_group=(($82+228)&4294967295); //@line 782 "voices.cpp"
            HEAP32[(($intonation_group)>>2)]=$and219; //@line 782 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 782 "voices.cpp"
          }
          else if (__label__ == 59) {
  
            var $83=$p; //@line 786 "voices.cpp"
            var $call234=_sscanf($83, ((__str59711)&4294967295), allocate([$arraydecay223,0,0,0,$arraydecay225,0,0,0,$arraydecay227,0,0,0,$arraydecay229,0,0,0,$arraydecay231,0,0,0,$arraydecay233,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 786 "voices.cpp"
            $n=$call234; //@line 786 "voices.cpp"
            var $84=$langopts; //@line 787 "voices.cpp"
            var $intonation_group235=(($84+228)&4294967295); //@line 787 "voices.cpp"
            HEAP32[(($intonation_group235)>>2)]=0; //@line 787 "voices.cpp"
            $ix=0; //@line 788 "voices.cpp"
            var $85=$ix; //@line 788 "voices.cpp"
            var $86=$n; //@line 788 "voices.cpp"
            var $cmp2379=((($85))|0) < ((($86))|0); //@line 788 "voices.cpp"
            if (!($cmp2379)) { __label__ = 24;continue $while_cond$34; } //@line 788 "voices.cpp"
            while(1) { 
  
              var $87=$ix; //@line 790 "voices.cpp"
              var $arrayidx239=(($names+$87*40)&4294967295); //@line 790 "voices.cpp"
              var $arraydecay240=(($arrayidx239)&4294967295); //@line 790 "voices.cpp"
              var $call241=_strcmp($arraydecay240, ((__str60712)&4294967295)); //@line 790 "voices.cpp"
              var $cmp242=((($call241))|0)==0; //@line 790 "voices.cpp"
              if ($cmp242) { __label__ = 64;; } else { __label__ = 61;; } //@line 790 "voices.cpp"
              if (__label__ == 61) {
  
                var $88=$ix; //@line 793 "voices.cpp"
                var $arrayidx245=(($names+$88*40)&4294967295); //@line 793 "voices.cpp"
                var $arraydecay246=(($arrayidx245)&4294967295); //@line 793 "voices.cpp"
                var $call247=__ZL10LookupTunePKc($arraydecay246); //@line 793 "voices.cpp"
                HEAP32[(($value)>>2)]=$call247; //@line 793 "voices.cpp"
                var $cmp248=((($call247))|0) < 0; //@line 793 "voices.cpp"
                if ($cmp248) { __label__ = 62;; } else { __label__ = 63;; } //@line 793 "voices.cpp"
                if (__label__ == 62) {
  
                  var $89=HEAP32[((__impure_ptr)>>2)]; //@line 794 "voices.cpp"
                  var $_stderr=(($89+12)&4294967295); //@line 794 "voices.cpp"
                  var $90=HEAP32[(($_stderr)>>2)]; //@line 794 "voices.cpp"
                  var $91=$ix; //@line 794 "voices.cpp"
                  var $arrayidx250=(($names+$91*40)&4294967295); //@line 794 "voices.cpp"
                  var $arraydecay251=(($arrayidx250)&4294967295); //@line 794 "voices.cpp"
                  var $call252=_fprintf($90, ((__str61713)&4294967295), allocate([$arraydecay251,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 794 "voices.cpp"
                  ; //@line 794 "voices.cpp"
                }
                else if (__label__ == 63) {
  
                  var $92=HEAP32[(($value)>>2)]; //@line 796 "voices.cpp"
                  var $conv254=((($92)) & 255); //@line 796 "voices.cpp"
                  var $93=$ix; //@line 796 "voices.cpp"
                  var $94=$langopts; //@line 796 "voices.cpp"
                  var $tunes=(($94+232)&4294967295); //@line 796 "voices.cpp"
                  var $arrayidx255=(($tunes+$93)&4294967295); //@line 796 "voices.cpp"
                  HEAP8[($arrayidx255)]=$conv254; //@line 796 "voices.cpp"
                  ;
                }
              }
  
              var $95=$ix; //@line 788 "voices.cpp"
              var $inc=((($95)+1)&4294967295); //@line 788 "voices.cpp"
              $ix=$inc; //@line 788 "voices.cpp"
              var $96=$ix; //@line 788 "voices.cpp"
              var $97=$n; //@line 788 "voices.cpp"
              var $cmp237=((($96))|0) < ((($97))|0); //@line 788 "voices.cpp"
              if ($cmp237) { __label__ = 60;continue ; } else { __label__ = 24;continue $while_cond$34; } //@line 788 "voices.cpp"
            }
          }
          else if (__label__ == 32) {
  
            var $31=$p; //@line 801 "voices.cpp"
            var $32=HEAP8[($31)]; //@line 801 "voices.cpp"
            var $conv26117=(tempInt=(($32)),(tempInt>=128?tempInt-256:tempInt)); //@line 801 "voices.cpp"
            var $cmp26218=((($conv26117))|0)!=0; //@line 801 "voices.cpp"
            if (!($cmp26218)) { __label__ = 24;continue $while_cond$34; } //@line 801 "voices.cpp"
            $while_cond264_preheader$90: while(1) { 
  
              var $100=$p; //@line 803 "voices.cpp"
              var $101=HEAP8[($100)]; //@line 803 "voices.cpp"
              var $conv26510=(tempInt=(($101)),(tempInt>=128?tempInt-256:tempInt)); //@line 803 "voices.cpp"
              var $call26611=_isspace($conv26510); //@line 803 "voices.cpp"
              var $tobool26712=((($call26611))|0)!=0; //@line 803 "voices.cpp"
              if ($tobool26712) { __label__ = 67;; } else { __label__ = 68;; } //@line 803 "voices.cpp"
              $while_body268$$while_end270$92: do { 
                if (__label__ == 67) {
                  while(1) { 
  
                    var $102=$p; //@line 803 "voices.cpp"
                    var $incdec_ptr269=(($102+1)&4294967295); //@line 803 "voices.cpp"
                    $p=$incdec_ptr269; //@line 803 "voices.cpp"
                    var $103=$p; //@line 803 "voices.cpp"
                    var $104=HEAP8[($103)]; //@line 803 "voices.cpp"
                    var $conv265=(tempInt=(($104)),(tempInt>=128?tempInt-256:tempInt)); //@line 803 "voices.cpp"
                    var $call266=_isspace($conv265); //@line 803 "voices.cpp"
                    var $tobool267=((($call266))|0)!=0; //@line 803 "voices.cpp"
                    if ($tobool267) { __label__ = 67;continue ; } else { __label__ = 68;break $while_body268$$while_end270$92; } //@line 803 "voices.cpp"
                  }
                }
              } while(0);
  
              $n=-1; //@line 804 "voices.cpp"
              var $105=$p; //@line 805 "voices.cpp"
              var $call271=_atoi($105); //@line 805 "voices.cpp"
              $n=$call271; //@line 805 "voices.cpp"
              var $cmp272=((($call271))|0) > 0; //@line 805 "voices.cpp"
              if ($cmp272) { __label__ = 69;; } else { __label__ = 71;; } //@line 805 "voices.cpp"
              $land_lhs_true273$$while_cond279_preheader$96: do { 
                if (__label__ == 69) {
  
                  var $106=$n; //@line 805 "voices.cpp"
                  var $cmp274=((($106))|0) < 32; //@line 805 "voices.cpp"
                  if (!($cmp274)) { __label__ = 71;break $land_lhs_true273$$while_cond279_preheader$96; } //@line 805 "voices.cpp"
  
                  var $107=$p; //@line 807 "voices.cpp"
                  var $incdec_ptr276=(($107+1)&4294967295); //@line 807 "voices.cpp"
                  $p=$incdec_ptr276; //@line 807 "voices.cpp"
                  var $108=$n; //@line 808 "voices.cpp"
                  var $shl277=1 << ($108); //@line 808 "voices.cpp"
                  var $109=$conditional_rules; //@line 808 "voices.cpp"
                  var $or=($109) | ($shl277); //@line 808 "voices.cpp"
                  $conditional_rules=$or; //@line 808 "voices.cpp"
                  ; //@line 809 "voices.cpp"
                }
              } while(0);
  
              var $110=$p; //@line 810 "voices.cpp"
              var $111=HEAP8[($110)]; //@line 810 "voices.cpp"
              var $conv28013=(tempInt=(($111)),(tempInt>=128?tempInt-256:tempInt)); //@line 810 "voices.cpp"
              var $call28114=_isalnum($conv28013); //@line 810 "voices.cpp"
              var $tobool28215=((($call28114))|0)!=0; //@line 810 "voices.cpp"
              if ($tobool28215) { __label__ = 72;; } else { __label__ = 65;; } //@line 810 "voices.cpp"
              $while_body283$$while_cond260_loopexit$100: do { 
                if (__label__ == 72) {
                  while(1) { 
  
                    var $112=$p; //@line 810 "voices.cpp"
                    var $incdec_ptr284=(($112+1)&4294967295); //@line 810 "voices.cpp"
                    $p=$incdec_ptr284; //@line 810 "voices.cpp"
                    var $113=$p; //@line 810 "voices.cpp"
                    var $114=HEAP8[($113)]; //@line 810 "voices.cpp"
                    var $conv280=(tempInt=(($114)),(tempInt>=128?tempInt-256:tempInt)); //@line 810 "voices.cpp"
                    var $call281=_isalnum($conv280); //@line 810 "voices.cpp"
                    var $tobool282=((($call281))|0)!=0; //@line 810 "voices.cpp"
                    if ($tobool282) { __label__ = 72;continue ; } else { __label__ = 65;break $while_body283$$while_cond260_loopexit$100; } //@line 810 "voices.cpp"
                  }
                }
              } while(0);
  
              var $98=$p; //@line 801 "voices.cpp"
              var $99=HEAP8[($98)]; //@line 801 "voices.cpp"
              var $conv261=(tempInt=(($99)),(tempInt>=128?tempInt-256:tempInt)); //@line 801 "voices.cpp"
              var $cmp262=((($conv261))|0)!=0; //@line 801 "voices.cpp"
              if ($cmp262) { __label__ = 66;continue $while_cond264_preheader$90; } else { __label__ = 24;continue $while_cond$34; } //@line 801 "voices.cpp"
            }
          }
          else if (__label__ == 73) {
  
            var $115=$phonemes_set; //@line 815 "voices.cpp"
            var $cmp288=((($115))|0)==0; //@line 815 "voices.cpp"
            if ($cmp288) { __label__ = 74;; } else { __label__ = 75;; } //@line 815 "voices.cpp"
            if (__label__ == 74) {
  
              var $call291=__Z22SelectPhonemeTableNamePKc($arraydecay290); //@line 818 "voices.cpp"
              $phonemes_set=1; //@line 819 "voices.cpp"
              ; //@line 820 "voices.cpp"
            }
  
            var $116=$key; //@line 821 "voices.cpp"
            var $117=$p; //@line 821 "voices.cpp"
            __ZL18PhonemeReplacementiPc($116, $117); //@line 821 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 822 "voices.cpp"
          }
          else if (__label__ == 76) {
  
            var $118=$p; //@line 825 "voices.cpp"
            var $119=$langopts; //@line 825 "voices.cpp"
            var $word_gap=(($119)&4294967295); //@line 825 "voices.cpp"
            var $120=$langopts; //@line 825 "voices.cpp"
            var $vowel_pause=(($120+4)&4294967295); //@line 825 "voices.cpp"
            var $call294=_sscanf($118, ((__str58710)&4294967295), allocate([$word_gap,0,0,0,$vowel_pause,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 825 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 826 "voices.cpp"
          }
          else if (__label__ == 77) {
  
            var $121=$p; //@line 829 "voices.cpp"
            var $122=$langopts; //@line 829 "voices.cpp"
            var $stress_rule=(($122+8)&4294967295); //@line 829 "voices.cpp"
            var $123=$langopts; //@line 829 "voices.cpp"
            var $stress_flags=(($123+12)&4294967295); //@line 829 "voices.cpp"
            var $124=$langopts; //@line 829 "voices.cpp"
            var $unstressed_wd1=(($124+16)&4294967295); //@line 829 "voices.cpp"
            var $125=$langopts; //@line 829 "voices.cpp"
            var $unstressed_wd2=(($125+20)&4294967295); //@line 829 "voices.cpp"
            var $call296=_sscanf($121, ((__str62714)&4294967295), allocate([$stress_rule,0,0,0,$stress_flags,0,0,0,$unstressed_wd1,0,0,0,$unstressed_wd2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 829 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 833 "voices.cpp"
          }
          else if (__label__ == 78) {
  
            var $126=$p; //@line 836 "voices.cpp"
            var $call298=_sscanf($126, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 836 "voices.cpp"
            var $cmp299=((($call298))|0)==1; //@line 836 "voices.cpp"
            var $127=HEAP32[(($value)>>2)]; //@line 836 "voices.cpp"
            var $cmp301=((($127))|0) < 20; //@line 836 "voices.cpp"
            var $or_cond1=($cmp299) & ($cmp301); //@line 836 "voices.cpp"
            if (!($or_cond1)) { __label__ = 24;continue $while_cond$34; } //@line 836 "voices.cpp"
  
            var $128=HEAP32[(($value)>>2)]; //@line 837 "voices.cpp"
            var $arrayidx303=((_charsets+$128*4)&4294967295); //@line 837 "voices.cpp"
            var $129=HEAP32[(($arrayidx303)>>2)]; //@line 837 "voices.cpp"
            var $130=$new_translator; //@line 837 "voices.cpp"
            var $charset_a0=(($130+696)&4294967295); //@line 837 "voices.cpp"
            HEAP32[(($charset_a0)>>2)]=$129; //@line 837 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 837 "voices.cpp"
          }
          else if (__label__ == 80) {
  
            var $131=$p; //@line 841 "voices.cpp"
            var $132=$langopts; //@line 841 "voices.cpp"
            var $numbers=(($132+184)&4294967295); //@line 841 "voices.cpp"
            var $133=$langopts; //@line 841 "voices.cpp"
            var $numbers2=(($133+188)&4294967295); //@line 841 "voices.cpp"
            var $call306=_sscanf($131, ((__str58710)&4294967295), allocate([$numbers,0,0,0,$numbers2,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 841 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 842 "voices.cpp"
          }
          else if (__label__ == 81) {
  
            HEAP32[(($value2)>>2)]=0; //@line 845 "voices.cpp"
            var $134=$p; //@line 846 "voices.cpp"
            var $call309=_sscanf($134, ((__str64716)&4294967295), allocate([$arraydecay308,0,0,0,$value,0,0,0,$value2,0,0,0], ["i8*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 846 "voices.cpp"
            var $cmp310=((($call309))|0) >= 2; //@line 846 "voices.cpp"
            if ($cmp310) { __label__ = 82;; } else { __label__ = 84;; } //@line 846 "voices.cpp"
            $land_lhs_true311$$if_else318$114: do { 
              if (__label__ == 82) {
  
                var $call313=__Z10LookupMnemP8MNEM_TABPKc(((__ZL11options_tab)&4294967295), $arraydecay312); //@line 846 "voices.cpp"
                $ix=$call313; //@line 846 "voices.cpp"
                var $cmp314=((($call313))|0) >= 0; //@line 846 "voices.cpp"
                if (!($cmp314)) { __label__ = 84;break $land_lhs_true311$$if_else318$114; } //@line 846 "voices.cpp"
  
                var $135=HEAP32[(($value)>>2)]; //@line 848 "voices.cpp"
                var $136=$ix; //@line 848 "voices.cpp"
                var $137=$langopts; //@line 848 "voices.cpp"
                var $param=(($137+24)&4294967295); //@line 848 "voices.cpp"
                var $arrayidx316=(($param+$136*4)&4294967295); //@line 848 "voices.cpp"
                HEAP32[(($arrayidx316)>>2)]=$135; //@line 848 "voices.cpp"
                var $138=HEAP32[(($value2)>>2)]; //@line 849 "voices.cpp"
                var $139=$ix; //@line 849 "voices.cpp"
                var $140=$langopts; //@line 849 "voices.cpp"
                var $param2=(($140+100)&4294967295); //@line 849 "voices.cpp"
                var $arrayidx317=(($param2+$139*4)&4294967295); //@line 849 "voices.cpp"
                HEAP32[(($arrayidx317)>>2)]=$138; //@line 849 "voices.cpp"
                __label__ = 24;continue $while_cond$34; //@line 850 "voices.cpp"
              }
            } while(0);
  
            var $141=HEAP32[((__impure_ptr)>>2)]; //@line 853 "voices.cpp"
            var $_stderr319=(($141+12)&4294967295); //@line 853 "voices.cpp"
            var $142=HEAP32[(($_stderr319)>>2)]; //@line 853 "voices.cpp"
            var $143=$p; //@line 853 "voices.cpp"
            var $call321=_fprintf($142, ((__str65717)&4294967295), allocate([$arraydecay320,0,0,0,$143,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 853 "voices.cpp"
            __label__ = 24;continue $while_cond$34;
          }
          else if (__label__ == 85) {
  
            HEAP32[(($value)>>2)]=0; //@line 859 "voices.cpp"
            var $144=HEAP32[((_voice)>>2)]; //@line 860 "voices.cpp"
            var $echo_amp=(($144+80)&4294967295); //@line 860 "voices.cpp"
            HEAP32[(($echo_amp)>>2)]=0; //@line 860 "voices.cpp"
            var $145=$p; //@line 861 "voices.cpp"
            var $146=HEAP32[((_voice)>>2)]; //@line 861 "voices.cpp"
            var $echo_delay=(($146+76)&4294967295); //@line 861 "voices.cpp"
            var $147=HEAP32[((_voice)>>2)]; //@line 861 "voices.cpp"
            var $echo_amp324=(($147+80)&4294967295); //@line 861 "voices.cpp"
            var $call325=_sscanf($145, ((__str58710)&4294967295), allocate([$echo_delay,0,0,0,$echo_amp324,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 861 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 862 "voices.cpp"
          }
          else if (__label__ == 86) {
  
            var $148=$p; //@line 865 "voices.cpp"
            var $call327=_sscanf($148, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 865 "voices.cpp"
            var $cmp328=((($call327))|0)==1; //@line 865 "voices.cpp"
            if (!($cmp328)) { __label__ = 24;continue $while_cond$34; } //@line 865 "voices.cpp"
  
            var $149=HEAP32[(($value)>>2)]; //@line 866 "voices.cpp"
            var $mul330=((($149)*32)&4294967295); //@line 866 "voices.cpp"
            var $150=HEAP32[((_voice)>>2)]; //@line 866 "voices.cpp"
            var $flutter=(($150+68)&4294967295); //@line 866 "voices.cpp"
            HEAP32[(($flutter)>>2)]=$mul330; //@line 866 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 866 "voices.cpp"
          }
          else if (__label__ == 88) {
  
            var $151=$p; //@line 870 "voices.cpp"
            var $call333=_sscanf($151, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 870 "voices.cpp"
            var $cmp334=((($call333))|0)==1; //@line 870 "voices.cpp"
            if (!($cmp334)) { __label__ = 24;continue $while_cond$34; } //@line 870 "voices.cpp"
  
            var $152=HEAP32[(($value)>>2)]; //@line 871 "voices.cpp"
            var $153=HEAP32[((_voice)>>2)]; //@line 871 "voices.cpp"
            var $roughness=(($153+72)&4294967295); //@line 871 "voices.cpp"
            HEAP32[(($roughness)>>2)]=$152; //@line 871 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 871 "voices.cpp"
          }
          else if (__label__ == 90) {
  
            var $154=$p; //@line 875 "voices.cpp"
            var $call338=_sscanf($154, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 875 "voices.cpp"
            var $cmp339=((($call338))|0)==1; //@line 875 "voices.cpp"
            if (!($cmp339)) { __label__ = 24;continue $while_cond$34; } //@line 875 "voices.cpp"
  
            var $155=HEAP32[(($value)>>2)]; //@line 877 "voices.cpp"
            var $cmp341=((($155))|0) > 4; //@line 877 "voices.cpp"
            if ($cmp341) { __label__ = 92;; } else { __label__ = 93;; } //@line 877 "voices.cpp"
            if (__label__ == 92) {
  
              var $156=HEAP32[((_voice)>>2)]; //@line 879 "voices.cpp"
              var $peak_shape=(($156+88)&4294967295); //@line 879 "voices.cpp"
              HEAP32[(($peak_shape)>>2)]=1; //@line 879 "voices.cpp"
              HEAP32[(($value)>>2)]=4; //@line 880 "voices.cpp"
              ; //@line 881 "voices.cpp"
            }
  
            var $157=HEAP32[(($value)>>2)]; //@line 882 "voices.cpp"
            var $add344=((($157)+1)&4294967295); //@line 882 "voices.cpp"
            var $158=HEAP32[((_voice)>>2)]; //@line 882 "voices.cpp"
            var $n_harmonic_peaks=(($158+84)&4294967295); //@line 882 "voices.cpp"
            HEAP32[(($n_harmonic_peaks)>>2)]=$add344; //@line 882 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 883 "voices.cpp"
          }
          else if (__label__ == 94) {
  
            var $159=$p; //@line 889 "voices.cpp"
            __Z14ReadTonePointsPcPi($159, $arraydecay347); //@line 889 "voices.cpp"
            var $160=HEAP32[((_voice)>>2)]; //@line 890 "voices.cpp"
            __ZL13SetToneAdjustP7voice_tPi($160, $arraydecay348); //@line 890 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 892 "voices.cpp"
          }
          else if (__label__ == 95) {
  
            var $161=$p; //@line 895 "voices.cpp"
            var $call350=_sscanf($161, ((__str63715)&4294967295), allocate([$value,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 895 "voices.cpp"
            var $cmp351=((($call350))|0)==1; //@line 895 "voices.cpp"
            if (!($cmp351)) { __label__ = 24;continue $while_cond$34; } //@line 895 "voices.cpp"
  
            var $162=HEAP32[(($value)>>2)]; //@line 896 "voices.cpp"
            var $mul353=((($162)*64)&4294967295); //@line 896 "voices.cpp"
            var $div354=((((($mul353))|0)/100)|0); //@line 896 "voices.cpp"
            var $163=HEAP32[((_voice)>>2)]; //@line 896 "voices.cpp"
            var $voicing=(($163+92)&4294967295); //@line 896 "voices.cpp"
            HEAP32[(($voicing)>>2)]=$div354; //@line 896 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 896 "voices.cpp"
          }
          else if (__label__ == 97) {
  
            var $164=$p; //@line 900 "voices.cpp"
            var $165=HEAP32[((_voice)>>2)]; //@line 900 "voices.cpp"
            var $breath=(($165+272)&4294967295); //@line 900 "voices.cpp"
            var $arrayidx357=(($breath+4)&4294967295); //@line 900 "voices.cpp"
            var $call358=__ZL12Read8NumbersPcPi($164, $arrayidx357); //@line 900 "voices.cpp"
            var $166=HEAP32[((_voice)>>2)]; //@line 900 "voices.cpp"
            var $breath359=(($166+272)&4294967295); //@line 900 "voices.cpp"
            var $arrayidx360=(($breath359)&4294967295); //@line 900 "voices.cpp"
            HEAP32[(($arrayidx360)>>2)]=$call358; //@line 900 "voices.cpp"
            $ix=1; //@line 901 "voices.cpp"
            ; //@line 901 "voices.cpp"
            while(1) { 
  
              var $167=$ix; //@line 903 "voices.cpp"
              var $rem=((($167))|0)%2; //@line 903 "voices.cpp"
              var $tobool364=((($rem))|0)!=0; //@line 903 "voices.cpp"
              if ($tobool364) { __label__ = 99;; } else { __label__ = 100;; } //@line 903 "voices.cpp"
              if (__label__ == 99) {
  
                var $168=$ix; //@line 904 "voices.cpp"
                var $169=HEAP32[((_voice)>>2)]; //@line 904 "voices.cpp"
                var $breath366=(($169+272)&4294967295); //@line 904 "voices.cpp"
                var $arrayidx367=(($breath366+$168*4)&4294967295); //@line 904 "voices.cpp"
                var $170=HEAP32[(($arrayidx367)>>2)]; //@line 904 "voices.cpp"
                var $sub368=(((-($170)))&4294967295); //@line 904 "voices.cpp"
                var $171=$ix; //@line 904 "voices.cpp"
                var $172=HEAP32[((_voice)>>2)]; //@line 904 "voices.cpp"
                var $breath369=(($172+272)&4294967295); //@line 904 "voices.cpp"
                var $arrayidx370=(($breath369+$171*4)&4294967295); //@line 904 "voices.cpp"
                HEAP32[(($arrayidx370)>>2)]=$sub368; //@line 904 "voices.cpp"
                ; //@line 904 "voices.cpp"
              }
  
              var $173=$ix; //@line 901 "voices.cpp"
              var $inc373=((($173)+1)&4294967295); //@line 901 "voices.cpp"
              $ix=$inc373; //@line 901 "voices.cpp"
              var $cmp362=((($inc373))|0) < 8; //@line 901 "voices.cpp"
              if ($cmp362) { __label__ = 98;continue ; } else { __label__ = 24;continue $while_cond$34; } //@line 901 "voices.cpp"
            }
          }
          else if (__label__ == 101) {
  
            var $174=$p; //@line 909 "voices.cpp"
            var $175=HEAP32[((_voice)>>2)]; //@line 909 "voices.cpp"
            var $breathw=(($175+308)&4294967295); //@line 909 "voices.cpp"
            var $arrayidx376=(($breathw+4)&4294967295); //@line 909 "voices.cpp"
            var $call377=__ZL12Read8NumbersPcPi($174, $arrayidx376); //@line 909 "voices.cpp"
            var $176=HEAP32[((_voice)>>2)]; //@line 909 "voices.cpp"
            var $breathw378=(($176+308)&4294967295); //@line 909 "voices.cpp"
            var $arrayidx379=(($breathw378)&4294967295); //@line 909 "voices.cpp"
            HEAP32[(($arrayidx379)>>2)]=$call377; //@line 909 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 910 "voices.cpp"
          }
          else if (__label__ == 102) {
  
            var $177=$p; //@line 913 "voices.cpp"
            var $178=HEAP32[((_voice)>>2)]; //@line 913 "voices.cpp"
            var $consonant_amp=(($178+100)&4294967295); //@line 913 "voices.cpp"
            var $179=HEAP32[((_voice)>>2)]; //@line 913 "voices.cpp"
            var $consonant_ampv=(($179+104)&4294967295); //@line 913 "voices.cpp"
            var $call381=_sscanf($177, ((__str58710)&4294967295), allocate([$consonant_amp,0,0,0,$consonant_ampv,0,0,0], ["i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 913 "voices.cpp"
            HEAP32[(($value)>>2)]=$call381; //@line 913 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 914 "voices.cpp"
          }
          else if (__label__ == 103) {
  
            var $180=$p; //@line 917 "voices.cpp"
            var $181=HEAP32[((_voice)>>2)]; //@line 917 "voices.cpp"
            var $speed_percent=(($181+64)&4294967295); //@line 917 "voices.cpp"
            var $call383=_sscanf($180, ((__str63715)&4294967295), allocate([$speed_percent,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 917 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 918 "voices.cpp"
          }
          else if (__label__ == 104) {
  
            HEAP32[(($srate)>>2)]=16000; //@line 922 "voices.cpp"
            HEAP8[($arrayidx385)]=0; //@line 926 "voices.cpp"
            var $182=$p; //@line 927 "voices.cpp"
            var $call388=_sscanf($182, ((__str66718)&4294967295), allocate([$arraydecay386,0,0,0,$arraydecay387,0,0,0,$srate,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 927 "voices.cpp"
            var $183=HEAP32[(($srate)>>2)]; //@line 928 "voices.cpp"
            var $call391=__Z15LoadMbrolaTablePKcS0_i($arraydecay389, $arraydecay390, $183); //@line 928 "voices.cpp"
            var $cmp392=((($call391))|0)!=0; //@line 928 "voices.cpp"
            if ($cmp392) { __label__ = 105;; } else { __label__ = 106;; } //@line 928 "voices.cpp"
            if (__label__ == 105) {
  
              var $184=HEAP32[((__impure_ptr)>>2)]; //@line 930 "voices.cpp"
              var $_stderr394=(($184+12)&4294967295); //@line 930 "voices.cpp"
              var $185=HEAP32[(($_stderr394)>>2)]; //@line 930 "voices.cpp"
              var $186=_fwrite(((__str67719)&4294967295), 23, 1, $185); //@line 930 "voices.cpp"
              ; //@line 931 "voices.cpp"
            }
  
            var $187=HEAP32[(($srate)>>2)]; //@line 932 "voices.cpp"
            var $188=HEAP32[((_voice)>>2)]; //@line 932 "voices.cpp"
            var $samplerate=(($188+108)&4294967295); //@line 932 "voices.cpp"
            HEAP32[(($samplerate)>>2)]=$187; //@line 932 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 934 "voices.cpp"
          }
          else if (__label__ == 107) {
  
            var $189=HEAP32[((_voice)>>2)]; //@line 937 "voices.cpp"
            var $klattv=(($189+112)&4294967295); //@line 937 "voices.cpp"
            var $arrayidx398=(($klattv)&4294967295); //@line 937 "voices.cpp"
            HEAP32[(($arrayidx398)>>2)]=1; //@line 937 "voices.cpp"
            var $190=$p; //@line 938 "voices.cpp"
            var $191=HEAP32[((_voice)>>2)]; //@line 938 "voices.cpp"
            var $klattv399=(($191+112)&4294967295); //@line 938 "voices.cpp"
            var $arraydecay400=(($klattv399)&4294967295); //@line 938 "voices.cpp"
            var $call401=__ZL12Read8NumbersPcPi($190, $arraydecay400); //@line 938 "voices.cpp"
            var $192=HEAP32[((_voice)>>2)]; //@line 939 "voices.cpp"
            var $klattv402=(($192+112)&4294967295); //@line 939 "voices.cpp"
            var $arrayidx403=(($klattv402+20)&4294967295); //@line 939 "voices.cpp"
            var $193=HEAP32[(($arrayidx403)>>2)]; //@line 939 "voices.cpp"
            var $sub404=((($193)-40)&4294967295); //@line 939 "voices.cpp"
            HEAP32[(($arrayidx403)>>2)]=$sub404; //@line 939 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 940 "voices.cpp"
          }
          else if (__label__ == 108) {
  
            var $194=$p; //@line 943 "voices.cpp"
            var $call406=__ZL12Read8NumbersPcPi($194, ((_speed+32)&4294967295)); //@line 943 "voices.cpp"
            __Z8SetSpeedi(3); //@line 944 "voices.cpp"
            __label__ = 24;continue $while_cond$34; //@line 945 "voices.cpp"
          }
        }
        $if_end423$$while_end419$146: do { 
          if (__label__ == 112) {
  
            var $_pr=$f_voice; //@line 959 "voices.cpp"
            var $cmp420=((($_pr))|0)!=0; //@line 959 "voices.cpp"
            if (!($cmp420)) { __label__ = 114;break $if_end423$$while_end419$146; } //@line 959 "voices.cpp"
  
            var $201=$f_voice; //@line 960 "voices.cpp"
            var $call422=_fclose($201); //@line 960 "voices.cpp"
            ; //@line 960 "voices.cpp"
          }
        } while(0);
  
        var $202=$new_translator; //@line 962 "voices.cpp"
        var $cmp424=((($202))|0)==0; //@line 962 "voices.cpp"
        if ($cmp424) { __label__ = 115;; } else { __label__ = 117;; } //@line 962 "voices.cpp"
        $land_lhs_true425$$if_end430$150: do { 
          if (__label__ == 115) {
  
            var $203=$tone_only; //@line 962 "voices.cpp"
            var $tobool426=((($203))|0)!=0; //@line 962 "voices.cpp"
            if ($tobool426) { __label__ = 117;break $land_lhs_true425$$if_end430$150; } //@line 962 "voices.cpp"
  
            var $arraydecay428=(($translator_name)&4294967295); //@line 965 "voices.cpp"
            var $call429=__Z16SelectTranslatorPKc($arraydecay428); //@line 965 "voices.cpp"
            $new_translator=$call429; //@line 965 "voices.cpp"
            ; //@line 966 "voices.cpp"
          }
        } while(0);
  
        __Z8SetSpeedi(3); //@line 968 "voices.cpp"
        $ix=0; //@line 970 "voices.cpp"
        ; //@line 970 "voices.cpp"
        $for_body433$154: while(1) { 
  
          var $204=$ix; //@line 972 "voices.cpp"
          var $205=HEAP32[((_voice)>>2)]; //@line 972 "voices.cpp"
          var $freq=(($205+144)&4294967295); //@line 972 "voices.cpp"
          var $arrayidx434=(($freq+$204*2)&4294967295); //@line 972 "voices.cpp"
          var $206=HEAP16[(($arrayidx434)>>1)]; //@line 972 "voices.cpp"
          var $207=$ix; //@line 972 "voices.cpp"
          var $208=HEAP32[((_voice)>>2)]; //@line 972 "voices.cpp"
          var $freq2=(($208+216)&4294967295); //@line 972 "voices.cpp"
          var $arrayidx435=(($freq2+$207*2)&4294967295); //@line 972 "voices.cpp"
          HEAP16[(($arrayidx435)>>1)]=$206; //@line 972 "voices.cpp"
          var $209=$ix; //@line 973 "voices.cpp"
          var $210=HEAP32[((_voice)>>2)]; //@line 973 "voices.cpp"
          var $height=(($210+162)&4294967295); //@line 973 "voices.cpp"
          var $arrayidx436=(($height+$209*2)&4294967295); //@line 973 "voices.cpp"
          var $211=HEAP16[(($arrayidx436)>>1)]; //@line 973 "voices.cpp"
          var $212=$ix; //@line 973 "voices.cpp"
          var $213=HEAP32[((_voice)>>2)]; //@line 973 "voices.cpp"
          var $height2=(($213+234)&4294967295); //@line 973 "voices.cpp"
          var $arrayidx437=(($height2+$212*2)&4294967295); //@line 973 "voices.cpp"
          HEAP16[(($arrayidx437)>>1)]=$211; //@line 973 "voices.cpp"
          var $214=$ix; //@line 974 "voices.cpp"
          var $215=HEAP32[((_voice)>>2)]; //@line 974 "voices.cpp"
          var $width=(($215+180)&4294967295); //@line 974 "voices.cpp"
          var $arrayidx438=(($width+$214*2)&4294967295); //@line 974 "voices.cpp"
          var $216=HEAP16[(($arrayidx438)>>1)]; //@line 974 "voices.cpp"
          var $217=$ix; //@line 974 "voices.cpp"
          var $218=HEAP32[((_voice)>>2)]; //@line 974 "voices.cpp"
          var $width2=(($218+252)&4294967295); //@line 974 "voices.cpp"
          var $arrayidx439=(($width2+$217*2)&4294967295); //@line 974 "voices.cpp"
          HEAP16[(($arrayidx439)>>1)]=$216; //@line 974 "voices.cpp"
          var $219=$ix; //@line 970 "voices.cpp"
          var $inc441=((($219)+1)&4294967295); //@line 970 "voices.cpp"
          $ix=$inc441; //@line 970 "voices.cpp"
          var $cmp432=((($inc441))|0) < 9; //@line 970 "voices.cpp"
          if ($cmp432) { __label__ = 118;continue $for_body433$154; } else { __label__ = 119;break $for_body433$154; } //@line 970 "voices.cpp"
        }
  
        var $220=$tone_only; //@line 977 "voices.cpp"
        var $tobool443=((($220))|0)!=0; //@line 977 "voices.cpp"
        if ($tobool443) { __label__ = 120;; } else { __label__ = 121;; } //@line 977 "voices.cpp"
        if (__label__ == 120) {
  
          var $221=HEAP32[((_translator)>>2)]; //@line 979 "voices.cpp"
          $new_translator=$221; //@line 979 "voices.cpp"
          ; //@line 980 "voices.cpp"
        }
        else if (__label__ == 121) {
  
          var $arraydecay446=(($phonemes_name)&4294967295); //@line 983 "voices.cpp"
          var $call447=__Z22SelectPhonemeTableNamePKc($arraydecay446); //@line 983 "voices.cpp"
          $ix=$call447; //@line 983 "voices.cpp"
          var $cmp448=((($call447))|0) < 0; //@line 983 "voices.cpp"
          if ($cmp448) { __label__ = 122;; } else { __label__ = 123;; } //@line 983 "voices.cpp"
          if (__label__ == 122) {
  
            var $222=HEAP32[((__impure_ptr)>>2)]; //@line 985 "voices.cpp"
            var $_stderr450=(($222+12)&4294967295); //@line 985 "voices.cpp"
            var $223=HEAP32[(($_stderr450)>>2)]; //@line 985 "voices.cpp"
            var $arraydecay451=(($phonemes_name)&4294967295); //@line 985 "voices.cpp"
            var $call452=_fprintf($223, ((__str69721)&4294967295), allocate([$arraydecay451,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 985 "voices.cpp"
            ; //@line 986 "voices.cpp"
          }
  
          var $224=$ix; //@line 987 "voices.cpp"
          var $225=HEAP32[((_voice)>>2)]; //@line 987 "voices.cpp"
          var $phoneme_tab_ix=(($225+40)&4294967295); //@line 987 "voices.cpp"
          HEAP32[(($phoneme_tab_ix)>>2)]=$224; //@line 987 "voices.cpp"
          var $226=$ix; //@line 988 "voices.cpp"
          var $227=$new_translator; //@line 988 "voices.cpp"
          var $phoneme_tab_ix454=(($227+656)&4294967295); //@line 988 "voices.cpp"
          HEAP32[(($phoneme_tab_ix454)>>2)]=$226; //@line 988 "voices.cpp"
          var $228=$new_translator; //@line 989 "voices.cpp"
          var $arraydecay455=(($new_dictionary)&4294967295); //@line 989 "voices.cpp"
          var $229=$control_addr; //@line 989 "voices.cpp"
          var $and456=($229) & 4; //@line 989 "voices.cpp"
          var $call457=__Z14LoadDictionaryP10TranslatorPKci($228, $arraydecay455, $and456); //@line 989 "voices.cpp"
          $error=$call457; //@line 989 "voices.cpp"
          var $230=HEAP8[(((_dictionary_name)&4294967295))]; //@line 990 "voices.cpp"
          var $conv458=(tempInt=(($230)),(tempInt>=128?tempInt-256:tempInt)); //@line 990 "voices.cpp"
          var $cmp459=((($conv458))|0)==0; //@line 990 "voices.cpp"
          if ($cmp459) { __label__ = 124;; } else { __label__ = 125;; } //@line 990 "voices.cpp"
          if (__label__ == 124) {
  
            $retval=0; //@line 991 "voices.cpp"
            __label__ = 137;break $return$$if_end51$12; //@line 991 "voices.cpp"
          }
          else if (__label__ == 125) {
  
            var $231=$conditional_rules; //@line 993 "voices.cpp"
            var $232=$new_translator; //@line 993 "voices.cpp"
            var $dict_condition=(($232+692)&4294967295); //@line 993 "voices.cpp"
            HEAP32[(($dict_condition)>>2)]=$231; //@line 993 "voices.cpp"
            var $233=$langix; //@line 995 "voices.cpp"
            var $arrayidx462=((__ZZ9LoadVoicePKciE15voice_languages+$233)&4294967295); //@line 995 "voices.cpp"
            HEAP8[($arrayidx462)]=0; //@line 995 "voices.cpp"
            ;
          }
        }
  
        var $234=$new_translator; //@line 998 "voices.cpp"
        var $langopts464=(($234)&4294967295); //@line 998 "voices.cpp"
        $langopts=$langopts464; //@line 998 "voices.cpp"
        var $235=$langopts; //@line 1001 "voices.cpp"
        var $param465=(($235+24)&4294967295); //@line 1001 "voices.cpp"
        var $arrayidx466=(($param465+24)&4294967295); //@line 1001 "voices.cpp"
        var $236=HEAP32[(($arrayidx466)>>2)]; //@line 1001 "voices.cpp"
        HEAP32[(($value)>>2)]=$236; //@line 1001 "voices.cpp"
        var $cmp467=((($236))|0)!=0; //@line 1001 "voices.cpp"
        if ($cmp467) { __label__ = 127;; } else { __label__ = 128;; } //@line 1001 "voices.cpp"
        if (__label__ == 127) {
  
          var $237=$new_translator; //@line 1003 "voices.cpp"
          var $238=HEAP32[(($value)>>2)]; //@line 1003 "voices.cpp"
          __Z13SetLengthModsP10Translatori($237, $238); //@line 1003 "voices.cpp"
          ; //@line 1004 "voices.cpp"
        }
  
        var $239=HEAP32[((_voice)>>2)]; //@line 1006 "voices.cpp"
        var $width470=(($239+180)&4294967295); //@line 1006 "voices.cpp"
        var $arrayidx471=(($width470)&4294967295); //@line 1006 "voices.cpp"
        var $240=HEAP16[(($arrayidx471)>>1)]; //@line 1006 "voices.cpp"
        var $conv472=(tempInt=(($240)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1006 "voices.cpp"
        var $mul473=((($conv472)*105)&4294967295); //@line 1006 "voices.cpp"
        var $div474=((((($mul473))|0)/100)|0); //@line 1006 "voices.cpp"
        var $conv475=((($div474)) & 65535); //@line 1006 "voices.cpp"
        var $241=HEAP32[((_voice)>>2)]; //@line 1006 "voices.cpp"
        var $width476=(($241+180)&4294967295); //@line 1006 "voices.cpp"
        var $arrayidx477=(($width476)&4294967295); //@line 1006 "voices.cpp"
        HEAP16[(($arrayidx477)>>1)]=$conv475; //@line 1006 "voices.cpp"
        var $242=$tone_only; //@line 1008 "voices.cpp"
        var $tobool478=((($242))|0)!=0; //@line 1008 "voices.cpp"
        if ($tobool478) { __label__ = 130;; } else { __label__ = 129;; } //@line 1008 "voices.cpp"
        if (__label__ == 129) {
  
          var $243=$new_translator; //@line 1010 "voices.cpp"
          HEAP32[((_translator)>>2)]=$243; //@line 1010 "voices.cpp"
          ; //@line 1011 "voices.cpp"
        }
  
        $ix=0; //@line 1014 "voices.cpp"
        var $244=$ix; //@line 1014 "voices.cpp"
        var $245=$stress_lengths_set; //@line 1014 "voices.cpp"
        var $cmp4825=((($244))|0) < ((($245))|0); //@line 1014 "voices.cpp"
        if ($cmp4825) { __label__ = 131;; } else { __label__ = 132;; } //@line 1014 "voices.cpp"
        $for_body483$$for_end490$173: do { 
          if (__label__ == 131) {
            while(1) { 
  
              var $246=$ix; //@line 1016 "voices.cpp"
              var $arrayidx484=(($stress_lengths+$246*4)&4294967295); //@line 1016 "voices.cpp"
              var $247=HEAP32[(($arrayidx484)>>2)]; //@line 1016 "voices.cpp"
              var $conv485=((($247)) & 65535); //@line 1016 "voices.cpp"
              var $248=$ix; //@line 1016 "voices.cpp"
              var $249=HEAP32[((_translator)>>2)]; //@line 1016 "voices.cpp"
              var $stress_lengths486=(($249+676)&4294967295); //@line 1016 "voices.cpp"
              var $arrayidx487=(($stress_lengths486+$248*2)&4294967295); //@line 1016 "voices.cpp"
              HEAP16[(($arrayidx487)>>1)]=$conv485; //@line 1016 "voices.cpp"
              var $250=$ix; //@line 1014 "voices.cpp"
              var $inc489=((($250)+1)&4294967295); //@line 1014 "voices.cpp"
              $ix=$inc489; //@line 1014 "voices.cpp"
              var $251=$ix; //@line 1014 "voices.cpp"
              var $252=$stress_lengths_set; //@line 1014 "voices.cpp"
              var $cmp482=((($251))|0) < ((($252))|0); //@line 1014 "voices.cpp"
              if ($cmp482) { __label__ = 131;continue ; } else { __label__ = 132;break $for_body483$$for_end490$173; } //@line 1014 "voices.cpp"
            }
          }
        } while(0);
  
        $ix=0; //@line 1018 "voices.cpp"
        var $253=$ix; //@line 1018 "voices.cpp"
        var $254=$stress_add_set; //@line 1018 "voices.cpp"
        var $cmp4924=((($253))|0) < ((($254))|0); //@line 1018 "voices.cpp"
        if ($cmp4924) { __label__ = 133;; } else { __label__ = 134;; } //@line 1018 "voices.cpp"
        $for_body493$$for_end502$177: do { 
          if (__label__ == 133) {
            while(1) { 
  
              var $255=$ix; //@line 1020 "voices.cpp"
              var $arrayidx494=(($stress_add+$255*4)&4294967295); //@line 1020 "voices.cpp"
              var $256=HEAP32[(($arrayidx494)>>2)]; //@line 1020 "voices.cpp"
              var $257=$ix; //@line 1020 "voices.cpp"
              var $258=HEAP32[((_translator)>>2)]; //@line 1020 "voices.cpp"
              var $stress_lengths495=(($258+676)&4294967295); //@line 1020 "voices.cpp"
              var $arrayidx496=(($stress_lengths495+$257*2)&4294967295); //@line 1020 "voices.cpp"
              var $259=HEAP16[(($arrayidx496)>>1)]; //@line 1020 "voices.cpp"
              var $conv497=(tempInt=(($259)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1020 "voices.cpp"
              var $add498=((($conv497)+($256))&4294967295); //@line 1020 "voices.cpp"
              var $conv499=((($add498)) & 65535); //@line 1020 "voices.cpp"
              HEAP16[(($arrayidx496)>>1)]=$conv499; //@line 1020 "voices.cpp"
              var $260=$ix; //@line 1018 "voices.cpp"
              var $inc501=((($260)+1)&4294967295); //@line 1018 "voices.cpp"
              $ix=$inc501; //@line 1018 "voices.cpp"
              var $261=$ix; //@line 1018 "voices.cpp"
              var $262=$stress_add_set; //@line 1018 "voices.cpp"
              var $cmp492=((($261))|0) < ((($262))|0); //@line 1018 "voices.cpp"
              if ($cmp492) { __label__ = 133;continue ; } else { __label__ = 134;break $for_body493$$for_end502$177; } //@line 1018 "voices.cpp"
            }
          }
        } while(0);
  
        $ix=0; //@line 1022 "voices.cpp"
        var $263=$ix; //@line 1022 "voices.cpp"
        var $264=$stress_amps_set; //@line 1022 "voices.cpp"
        var $cmp5043=((($263))|0) < ((($264))|0); //@line 1022 "voices.cpp"
        if ($cmp5043) { __label__ = 135;; } else { __label__ = 136;; } //@line 1022 "voices.cpp"
        $for_body505$$for_end516$181: do { 
          if (__label__ == 135) {
            while(1) { 
  
              var $265=$ix; //@line 1024 "voices.cpp"
              var $arrayidx506=(($stress_amps+$265*4)&4294967295); //@line 1024 "voices.cpp"
              var $266=HEAP32[(($arrayidx506)>>2)]; //@line 1024 "voices.cpp"
              var $conv507=((($266)) & 255); //@line 1024 "voices.cpp"
              var $267=$ix; //@line 1024 "voices.cpp"
              var $268=HEAP32[((_translator)>>2)]; //@line 1024 "voices.cpp"
              var $stress_amps508=(($268+660)&4294967295); //@line 1024 "voices.cpp"
              var $arrayidx509=(($stress_amps508+$267)&4294967295); //@line 1024 "voices.cpp"
              HEAP8[($arrayidx509)]=$conv507; //@line 1024 "voices.cpp"
              var $269=$ix; //@line 1025 "voices.cpp"
              var $arrayidx510=(($stress_amps+$269*4)&4294967295); //@line 1025 "voices.cpp"
              var $270=HEAP32[(($arrayidx510)>>2)]; //@line 1025 "voices.cpp"
              var $sub511=((($270)-1)&4294967295); //@line 1025 "voices.cpp"
              var $conv512=((($sub511)) & 255); //@line 1025 "voices.cpp"
              var $271=$ix; //@line 1025 "voices.cpp"
              var $272=HEAP32[((_translator)>>2)]; //@line 1025 "voices.cpp"
              var $stress_amps_r=(($272+668)&4294967295); //@line 1025 "voices.cpp"
              var $arrayidx513=(($stress_amps_r+$271)&4294967295); //@line 1025 "voices.cpp"
              HEAP8[($arrayidx513)]=$conv512; //@line 1025 "voices.cpp"
              var $273=$ix; //@line 1022 "voices.cpp"
              var $inc515=((($273)+1)&4294967295); //@line 1022 "voices.cpp"
              $ix=$inc515; //@line 1022 "voices.cpp"
              var $274=$ix; //@line 1022 "voices.cpp"
              var $275=$stress_amps_set; //@line 1022 "voices.cpp"
              var $cmp504=((($274))|0) < ((($275))|0); //@line 1022 "voices.cpp"
              if ($cmp504) { __label__ = 135;continue ; } else { __label__ = 136;break $for_body505$$for_end516$181; } //@line 1022 "voices.cpp"
            }
          }
        } while(0);
  
        var $276=HEAP32[((_voice)>>2)]; //@line 1028 "voices.cpp"
        $retval=$276; //@line 1028 "voices.cpp"
        ; //@line 1028 "voices.cpp"
      }
    } while(0);
  
    var $277=$retval; //@line 1029 "voices.cpp"
    STACKTOP = __stackBase__;
    return $277; //@line 1029 "voices.cpp"
    return null;
  }
  

  function __ZL11fgets_stripPciP7__sFILE($buf, $size, $f_in) {
    ;
    var __label__;
  
    var $retval;
    var $buf_addr;
    var $size_addr;
    var $f_in_addr;
    var $len;
    var $p;
    $buf_addr=$buf;
    $size_addr=$size;
    $f_in_addr=$f_in;
    var $0=$buf_addr; //@line 184 "voices.cpp"
    var $1=$size_addr; //@line 184 "voices.cpp"
    var $2=$f_in_addr; //@line 184 "voices.cpp"
    var $call=_fgets($0, $1, $2); //@line 184 "voices.cpp"
    var $cmp=((($call))|0)==0; //@line 184 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 184 "voices.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 185 "voices.cpp"
      ; //@line 185 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$buf_addr; //@line 187 "voices.cpp"
      var $call1=_strlen($3); //@line 187 "voices.cpp"
      $len=$call1; //@line 187 "voices.cpp"
      ; //@line 188 "voices.cpp"
      while(1) { 
  
        var $4=$len; //@line 188 "voices.cpp"
        var $dec=((($4)-1)&4294967295); //@line 188 "voices.cpp"
        $len=$dec; //@line 188 "voices.cpp"
        var $cmp2=((($dec))|0) > 0; //@line 188 "voices.cpp"
        if (!($cmp2)) { __label__ = 6;break ; } //@line 188 "voices.cpp"
  
        var $5=$len; //@line 188 "voices.cpp"
        var $6=$buf_addr; //@line 188 "voices.cpp"
        var $arrayidx=(($6+$5)&4294967295); //@line 188 "voices.cpp"
        var $7=HEAP8[($arrayidx)]; //@line 188 "voices.cpp"
        var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 188 "voices.cpp"
        var $call3=_isspace($conv); //@line 188 "voices.cpp"
        var $tobool=((($call3))|0)!=0; //@line 188 "voices.cpp"
        if (!($tobool)) { __label__ = 6;break ; }
  
        var $8=$len; //@line 189 "voices.cpp"
        var $9=$buf_addr; //@line 189 "voices.cpp"
        var $arrayidx4=(($9+$8)&4294967295); //@line 189 "voices.cpp"
        HEAP8[($arrayidx4)]=0; //@line 189 "voices.cpp"
        __label__ = 3;continue ; //@line 189 "voices.cpp"
      }
  
      var $10=$buf_addr; //@line 191 "voices.cpp"
      var $call5=_strstr($10, ((__str82734)&4294967295)); //@line 191 "voices.cpp"
      $p=$call5; //@line 191 "voices.cpp"
      var $cmp6=((($call5))|0)!=0; //@line 191 "voices.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 191 "voices.cpp"
      if (__label__ == 7) {
  
        var $11=$p; //@line 192 "voices.cpp"
        HEAP8[($11)]=0; //@line 192 "voices.cpp"
        ; //@line 192 "voices.cpp"
      }
  
      var $12=$buf_addr; //@line 194 "voices.cpp"
      $retval=$12; //@line 194 "voices.cpp"
      ; //@line 194 "voices.cpp"
    }
  
    var $13=$retval; //@line 195 "voices.cpp"
    ;
    return $13; //@line 195 "voices.cpp"
    return null;
  }
  

  function __ZL12VoiceFormantPc($p) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $p_addr;
    var $ix;
    var $formant=__stackBase__;
    var $freq=__stackBase__+4;
    var $height=__stackBase__+8;
    var $width=__stackBase__+12;
    var $freqadd=__stackBase__+16;
    $p_addr=$p;
    HEAP32[(($freq)>>2)]=100; //@line 464 "voices.cpp"
    HEAP32[(($height)>>2)]=100; //@line 465 "voices.cpp"
    HEAP32[(($width)>>2)]=100; //@line 466 "voices.cpp"
    HEAP32[(($freqadd)>>2)]=0; //@line 467 "voices.cpp"
    var $0=$p_addr; //@line 469 "voices.cpp"
    var $call=_sscanf($0, ((__str81733)&4294967295), allocate([$formant,0,0,0,$freq,0,0,0,$height,0,0,0,$width,0,0,0,$freqadd,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 469 "voices.cpp"
    $ix=$call; //@line 469 "voices.cpp"
    var $1=$ix; //@line 470 "voices.cpp"
    var $cmp=((($1))|0) < 2; //@line 470 "voices.cpp"
    if ($cmp) { __label__ = 9;; } else { __label__ = 1;; } //@line 470 "voices.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $2=HEAP32[(($formant)>>2)]; //@line 473 "voices.cpp"
        var $cmp1=((($2))|0) < 0; //@line 473 "voices.cpp"
        var $3=HEAP32[(($formant)>>2)]; //@line 473 "voices.cpp"
        var $cmp2=((($3))|0) > 8; //@line 473 "voices.cpp"
        var $or_cond=($cmp1) | ($cmp2); //@line 473 "voices.cpp"
        if ($or_cond) { __label__ = 9;break $return$$if_end$2; } //@line 473 "voices.cpp"
  
        var $4=HEAP32[(($freq)>>2)]; //@line 476 "voices.cpp"
        var $cmp5=((($4))|0) >= 0; //@line 476 "voices.cpp"
        if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 476 "voices.cpp"
        if (__label__ == 3) {
  
          var $5=HEAP32[(($freq)>>2)]; //@line 477 "voices.cpp"
          var $conv=((($5))|0); //@line 477 "voices.cpp"
          var $mul=($conv)*2.56001; //@line 477 "voices.cpp"
          var $conv7=((($mul))|0); //@line 477 "voices.cpp"
          var $conv8=((($conv7)) & 65535); //@line 477 "voices.cpp"
          var $6=HEAP32[(($formant)>>2)]; //@line 477 "voices.cpp"
          var $7=HEAP32[((_voice)>>2)]; //@line 477 "voices.cpp"
          var $freq9=(($7+144)&4294967295); //@line 477 "voices.cpp"
          var $arrayidx=(($freq9+$6*2)&4294967295); //@line 477 "voices.cpp"
          HEAP16[(($arrayidx)>>1)]=$conv8; //@line 477 "voices.cpp"
          ; //@line 477 "voices.cpp"
        }
  
        var $8=HEAP32[(($height)>>2)]; //@line 478 "voices.cpp"
        var $cmp11=((($8))|0) >= 0; //@line 478 "voices.cpp"
        if ($cmp11) { __label__ = 5;; } else { __label__ = 6;; } //@line 478 "voices.cpp"
        if (__label__ == 5) {
  
          var $9=HEAP32[(($height)>>2)]; //@line 479 "voices.cpp"
          var $conv13=((($9))|0); //@line 479 "voices.cpp"
          var $mul14=($conv13)*2.56001; //@line 479 "voices.cpp"
          var $conv15=((($mul14))|0); //@line 479 "voices.cpp"
          var $conv16=((($conv15)) & 65535); //@line 479 "voices.cpp"
          var $10=HEAP32[(($formant)>>2)]; //@line 479 "voices.cpp"
          var $11=HEAP32[((_voice)>>2)]; //@line 479 "voices.cpp"
          var $height17=(($11+162)&4294967295); //@line 479 "voices.cpp"
          var $arrayidx18=(($height17+$10*2)&4294967295); //@line 479 "voices.cpp"
          HEAP16[(($arrayidx18)>>1)]=$conv16; //@line 479 "voices.cpp"
          ; //@line 479 "voices.cpp"
        }
  
        var $12=HEAP32[(($width)>>2)]; //@line 480 "voices.cpp"
        var $cmp20=((($12))|0) >= 0; //@line 480 "voices.cpp"
        if ($cmp20) { __label__ = 7;; } else { __label__ = 8;; } //@line 480 "voices.cpp"
        if (__label__ == 7) {
  
          var $13=HEAP32[(($width)>>2)]; //@line 481 "voices.cpp"
          var $conv22=((($13))|0); //@line 481 "voices.cpp"
          var $mul23=($conv22)*2.56001; //@line 481 "voices.cpp"
          var $conv24=((($mul23))|0); //@line 481 "voices.cpp"
          var $conv25=((($conv24)) & 65535); //@line 481 "voices.cpp"
          var $14=HEAP32[(($formant)>>2)]; //@line 481 "voices.cpp"
          var $15=HEAP32[((_voice)>>2)]; //@line 481 "voices.cpp"
          var $width26=(($15+180)&4294967295); //@line 481 "voices.cpp"
          var $arrayidx27=(($width26+$14*2)&4294967295); //@line 481 "voices.cpp"
          HEAP16[(($arrayidx27)>>1)]=$conv25; //@line 481 "voices.cpp"
          ; //@line 481 "voices.cpp"
        }
  
        var $16=HEAP32[(($freqadd)>>2)]; //@line 482 "voices.cpp"
        var $conv29=((($16)) & 65535); //@line 482 "voices.cpp"
        var $17=HEAP32[(($formant)>>2)]; //@line 482 "voices.cpp"
        var $18=HEAP32[((_voice)>>2)]; //@line 482 "voices.cpp"
        var $freqadd30=(($18+198)&4294967295); //@line 482 "voices.cpp"
        var $arrayidx31=(($freqadd30+$17*2)&4294967295); //@line 482 "voices.cpp"
        HEAP16[(($arrayidx31)>>1)]=$conv29; //@line 482 "voices.cpp"
        ; //@line 483 "voices.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 483 "voices.cpp"
    return;
  }
  

  function __ZL12Read8NumbersPcPi($data_in, $data) {
    ;
    var __label__;
  
    var $data_in_addr;
    var $data_addr;
    $data_in_addr=$data_in;
    $data_addr=$data;
    var $0=$data_addr; //@line 515 "voices.cpp"
    var $1=$0; //@line 515 "voices.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $1;
    $stop$ = $dest$ + 12;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 515 "voices.cpp"
    var $2=$data_in_addr; //@line 516 "voices.cpp"
    var $3=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx=(($3)&4294967295); //@line 516 "voices.cpp"
    var $4=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx1=(($4+4)&4294967295); //@line 516 "voices.cpp"
    var $5=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx2=(($5+8)&4294967295); //@line 516 "voices.cpp"
    var $6=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx3=(($6+12)&4294967295); //@line 516 "voices.cpp"
    var $7=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx4=(($7+16)&4294967295); //@line 516 "voices.cpp"
    var $8=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx5=(($8+20)&4294967295); //@line 516 "voices.cpp"
    var $9=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx6=(($9+24)&4294967295); //@line 516 "voices.cpp"
    var $10=$data_addr; //@line 516 "voices.cpp"
    var $arrayidx7=(($10+28)&4294967295); //@line 516 "voices.cpp"
    var $call=_sscanf($2, ((__str80732)&4294967295), allocate([$arrayidx,0,0,0,$arrayidx1,0,0,0,$arrayidx2,0,0,0,$arrayidx3,0,0,0,$arrayidx4,0,0,0,$arrayidx5,0,0,0,$arrayidx6,0,0,0,$arrayidx7,0,0,0], ["i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 516 "voices.cpp"
    ;
    return $call; //@line 516 "voices.cpp"
    return null;
  }
  

  function __ZL10LookupTunePKc($name) {
    ;
    var __label__;
  
    var $retval;
    var $name_addr;
    var $ix;
    $name_addr=$name;
    $ix=0; //@line 202 "voices.cpp"
    ; //@line 202 "voices.cpp"
    while(1) { 
  
      var $0=$ix; //@line 202 "voices.cpp"
      var $1=HEAP32[((_n_tunes)>>2)]; //@line 202 "voices.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 202 "voices.cpp"
      if (!($cmp)) { __label__ = 5;break ; } //@line 202 "voices.cpp"
  
      var $2=$name_addr; //@line 204 "voices.cpp"
      var $3=$ix; //@line 204 "voices.cpp"
      var $4=HEAP32[((_tunes)>>2)]; //@line 204 "voices.cpp"
      var $arrayidx=(($4+68*$3)&4294967295); //@line 204 "voices.cpp"
      var $name1=(($arrayidx)&4294967295); //@line 204 "voices.cpp"
      var $arraydecay=(($name1)&4294967295); //@line 204 "voices.cpp"
      var $call=_strcmp($2, $arraydecay); //@line 204 "voices.cpp"
      var $cmp2=((($call))|0)==0; //@line 204 "voices.cpp"
      var $5=$ix; //@line 205 "voices.cpp"
      if ($cmp2) { __label__ = 3;break ; } //@line 204 "voices.cpp"
  
      var $inc=((($5)+1)&4294967295); //@line 202 "voices.cpp"
      $ix=$inc; //@line 202 "voices.cpp"
      __label__ = 1;continue ; //@line 202 "voices.cpp"
    }
    if (__label__ == 5) {
  
      $retval=-1; //@line 207 "voices.cpp"
      ; //@line 207 "voices.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=$5; //@line 205 "voices.cpp"
      ; //@line 205 "voices.cpp"
    }
  
    var $6=$retval; //@line 208 "voices.cpp"
    ;
    return $6; //@line 208 "voices.cpp"
    return null;
  }
  

  function __ZL18PhonemeReplacementiPc($type, $p) {
    var __stackBase__  = STACKTOP; STACKTOP += 28; _memset(__stackBase__, 0, 28);
    var __label__;
  
    var $type_addr;
    var $p_addr;
    var $n;
    var $phon;
    var $flags=__stackBase__;
    var $phon_string1=__stackBase__+4;
    var $phon_string2=__stackBase__+16;
    $type_addr=$type;
    $p_addr=$p;
    HEAP32[(($flags)>>2)]=0; //@line 493 "voices.cpp"
    var $arraydecay=(($phon_string2)&4294967295); //@line 497 "voices.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = ((__str60712)&4294967295);
    $dest$ = $arraydecay;
    $stop$ = $src$ + 5;
    if (($dest$%4) == ($src$%4) && 5 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 497 "voices.cpp"
    var $0=$p_addr; //@line 498 "voices.cpp"
    var $arraydecay1=(($phon_string1)&4294967295); //@line 498 "voices.cpp"
    var $arraydecay2=(($phon_string2)&4294967295); //@line 498 "voices.cpp"
    var $call3=_sscanf($0, ((__str79731)&4294967295), allocate([$flags,0,0,0,$arraydecay1,0,0,0,$arraydecay2,0,0,0], ["i32*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 498 "voices.cpp"
    $n=$call3; //@line 498 "voices.cpp"
    var $1=$n; //@line 499 "voices.cpp"
    var $cmp=((($1))|0) < 2; //@line 499 "voices.cpp"
    var $2=HEAP32[((_n_replace_phonemes)>>2)]; //@line 499 "voices.cpp"
    var $cmp4=((($2))|0) >= 60; //@line 499 "voices.cpp"
    var $or_cond=($cmp) | ($cmp4); //@line 499 "voices.cpp"
    if ($or_cond) { __label__ = 3;; } else { __label__ = 1;; } //@line 499 "voices.cpp"
    $return$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay5=(($phon_string1)&4294967295); //@line 502 "voices.cpp"
        var $call6=__Z19LookupPhonemeStringPKc($arraydecay5); //@line 502 "voices.cpp"
        $phon=$call6; //@line 502 "voices.cpp"
        var $cmp7=((($call6))|0)==0; //@line 502 "voices.cpp"
        if ($cmp7) { __label__ = 3;break $return$$if_end$2; } //@line 502 "voices.cpp"
  
        var $3=$phon; //@line 505 "voices.cpp"
        var $conv=((($3)) & 255); //@line 505 "voices.cpp"
        var $4=HEAP32[((_n_replace_phonemes)>>2)]; //@line 505 "voices.cpp"
        var $arrayidx=((_replace_phonemes+$4*3)&4294967295); //@line 505 "voices.cpp"
        var $old_ph=(($arrayidx)&4294967295); //@line 505 "voices.cpp"
        HEAP8[($old_ph)]=$conv; //@line 505 "voices.cpp"
        var $arraydecay10=(($phon_string2)&4294967295); //@line 506 "voices.cpp"
        var $call11=__Z19LookupPhonemeStringPKc($arraydecay10); //@line 506 "voices.cpp"
        var $conv12=((($call11)) & 255); //@line 506 "voices.cpp"
        var $5=HEAP32[((_n_replace_phonemes)>>2)]; //@line 506 "voices.cpp"
        var $arrayidx13=((_replace_phonemes+$5*3)&4294967295); //@line 506 "voices.cpp"
        var $new_ph=(($arrayidx13+1)&4294967295); //@line 506 "voices.cpp"
        HEAP8[($new_ph)]=$conv12; //@line 506 "voices.cpp"
        var $6=HEAP32[(($flags)>>2)]; //@line 507 "voices.cpp"
        var $conv14=((($6)) & 255); //@line 507 "voices.cpp"
        var $7=HEAP32[((_n_replace_phonemes)>>2)]; //@line 507 "voices.cpp"
        var $inc=((($7)+1)&4294967295); //@line 507 "voices.cpp"
        HEAP32[((_n_replace_phonemes)>>2)]=$inc; //@line 507 "voices.cpp"
        var $arrayidx15=((_replace_phonemes+$7*3)&4294967295); //@line 507 "voices.cpp"
        var $type16=(($arrayidx15+2)&4294967295); //@line 507 "voices.cpp"
        HEAP8[($type16)]=$conv14; //@line 507 "voices.cpp"
        ; //@line 508 "voices.cpp"
      }
    } while(0);
  
    STACKTOP = __stackBase__;
    return; //@line 508 "voices.cpp"
    return;
  }
  

  function __Z16LoadVoiceVariantPKci($vname, $variant_num) {
    var __stackBase__  = STACKTOP; STACKTOP += 60; _memset(__stackBase__, 0, 60);
    var __label__;
  
    var $retval;
    var $vname_addr;
    var $variant_num_addr;
    var $v;
    var $variant_name;
    var $buf=__stackBase__;
    $vname_addr=$vname;
    $variant_num_addr=$variant_num;
    var $arraydecay=(($buf)&4294967295); //@line 1085 "voices.cpp"
    var $0=$vname_addr; //@line 1085 "voices.cpp"
    __Z8strncpy0PcPKci($arraydecay, $0, 60); //@line 1085 "voices.cpp"
    var $arraydecay1=(($buf)&4294967295); //@line 1086 "voices.cpp"
    var $1=$variant_num_addr; //@line 1086 "voices.cpp"
    __ZL23ExtractVoiceVariantNamePci($arraydecay1, $1); //@line 1086 "voices.cpp"
    $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1086 "voices.cpp"
    var $arraydecay2=(($buf)&4294967295); //@line 1088 "voices.cpp"
    var $call3=__Z9LoadVoicePKci($arraydecay2, 0); //@line 1088 "voices.cpp"
    $v=$call3; //@line 1088 "voices.cpp"
    var $cmp=((($call3))|0)==0; //@line 1088 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1088 "voices.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1089 "voices.cpp"
      ; //@line 1089 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$variant_name; //@line 1091 "voices.cpp"
      var $arrayidx=(($2)&4294967295); //@line 1091 "voices.cpp"
      var $3=HEAP8[($arrayidx)]; //@line 1091 "voices.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=128?tempInt-256:tempInt)); //@line 1091 "voices.cpp"
      var $cmp4=((($conv))|0)!=0; //@line 1091 "voices.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1091 "voices.cpp"
      if (__label__ == 3) {
  
        var $4=$variant_name; //@line 1093 "voices.cpp"
        var $call6=__Z9LoadVoicePKci($4, 2); //@line 1093 "voices.cpp"
        $v=$call6; //@line 1093 "voices.cpp"
        ; //@line 1094 "voices.cpp"
      }
  
      var $5=$v; //@line 1095 "voices.cpp"
      $retval=$5; //@line 1095 "voices.cpp"
      ; //@line 1095 "voices.cpp"
    }
  
    var $6=$retval; //@line 1096 "voices.cpp"
    STACKTOP = __stackBase__;
    return $6; //@line 1096 "voices.cpp"
    return null;
  }
  

  function __ZL23ExtractVoiceVariantNamePci($vname, $variant_num) {
    var __stackBase__  = STACKTOP; STACKTOP += 8; _memset(__stackBase__, 0, 8);
    var __label__;
    var __lastLabel__ = null;
  
    var $vname_addr;
    var $variant_num_addr;
    var $p;
    var $variant_prefix=__stackBase__;
    $vname_addr=$vname;
    $variant_num_addr=$variant_num;
    HEAP8[(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295))]=0; //@line 1041 "voices.cpp"
    var $arraydecay=(($variant_prefix)&4294967295); //@line 1042 "voices.cpp"
    var $call=_sprintf($arraydecay, ((__str76728)&4294967295), allocate([47,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 1042 "voices.cpp"
    var $0=$vname_addr; //@line 1044 "voices.cpp"
    var $cmp=((($0))|0)!=0; //@line 1044 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 5;; } //@line 1044 "voices.cpp"
    $if_then$$if_end10thread_pre_split$2: do { 
      if (__label__ == 1) {
  
        var $1=$vname_addr; //@line 1046 "voices.cpp"
        var $call1=_strchr($1, 43); //@line 1046 "voices.cpp"
        $p=$call1; //@line 1046 "voices.cpp"
        var $cmp2=((($call1))|0)!=0; //@line 1046 "voices.cpp"
        if (!($cmp2)) { __label__ = 5;break $if_then$$if_end10thread_pre_split$2; } //@line 1046 "voices.cpp"
  
        var $2=$p; //@line 1049 "voices.cpp"
        var $incdec_ptr=(($2+1)&4294967295); //@line 1049 "voices.cpp"
        $p=$incdec_ptr; //@line 1049 "voices.cpp"
        HEAP8[($2)]=0; //@line 1049 "voices.cpp"
        var $3=$p; //@line 1050 "voices.cpp"
        var $4=HEAP8[($3)]; //@line 1050 "voices.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1050 "voices.cpp"
        var $isdigittmp=((($conv)-48)&4294967295); //@line 1050 "voices.cpp"
        var $isdigit=((($isdigittmp))>>>0) < 10; //@line 1050 "voices.cpp"
        var $call4=((($isdigit))&1); //@line 1050 "voices.cpp"
        var $tobool=((($call4))|0)!=0; //@line 1050 "voices.cpp"
        if ($tobool) { __label__ = 3;; } else { __label__ = 4;; } //@line 1050 "voices.cpp"
        if (__label__ == 3) {
  
          var $5=$p; //@line 1052 "voices.cpp"
          var $call6=_atoi($5); //@line 1052 "voices.cpp"
          $variant_num_addr=$call6; //@line 1052 "voices.cpp"
          __lastLabel__ = 3; __label__ = 6;break $if_then$$if_end10thread_pre_split$2; //@line 1053 "voices.cpp"
        }
        else if (__label__ == 4) {
  
          var $arraydecay7=(($variant_prefix)&4294967295); //@line 1057 "voices.cpp"
          var $call8=_strcpy(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295), $arraydecay7); //@line 1057 "voices.cpp"
          var $6=$p; //@line 1058 "voices.cpp"
          __Z8strncpy0PcPKci(((__ZZL23ExtractVoiceVariantNamePciE12variant_name+3)&4294967295), $6, 17); //@line 1058 "voices.cpp"
          __label__ = 5;break $if_then$$if_end10thread_pre_split$2;
        }
      }
    } while(0);
    if (__label__ == 5) {
  
      var $_pr=$variant_num_addr; //@line 1063 "voices.cpp"
      __lastLabel__ = 5; ;
    }
  
    var $7=__lastLabel__ == 5 ? $_pr : ($call6); //@line 1063 "voices.cpp"
    var $cmp11=((($7))|0) > 0; //@line 1063 "voices.cpp"
    if ($cmp11) { __label__ = 7;; } else { __label__ = 10;; } //@line 1063 "voices.cpp"
    if (__label__ == 7) {
  
      var $8=$variant_num_addr; //@line 1065 "voices.cpp"
      var $cmp13=((($8))|0) < 10; //@line 1065 "voices.cpp"
      var $arraydecay15=(($variant_prefix)&4294967295); //@line 1066 "voices.cpp"
      var $9=$variant_num_addr; //@line 1066 "voices.cpp"
      if ($cmp13) { __label__ = 8;; } else { __label__ = 9;; } //@line 1065 "voices.cpp"
      if (__label__ == 8) {
  
        var $call16=_sprintf(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295), ((__str77729)&4294967295), allocate([$arraydecay15,0,0,0,$9,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1066 "voices.cpp"
        ; //@line 1066 "voices.cpp"
      }
      else if (__label__ == 9) {
  
        var $sub=((($9)-10)&4294967295); //@line 1068 "voices.cpp"
        var $call19=_sprintf(((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295), ((__str78730)&4294967295), allocate([$arraydecay15,0,0,0,$sub,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1068 "voices.cpp"
        ;
      }
    }
  
    STACKTOP = __stackBase__;
    return;
    return;
  }
  

  function __Z17SelectVoiceByNamePP12espeak_VOICEPKc($voices, $name) {
    var __stackBase__  = STACKTOP; STACKTOP += 44; _memset(__stackBase__, 0, 44);
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $voices_addr;
    var $name_addr;
    var $ix;
    var $match_fname;
    var $match_fname2;
    var $match_name;
    var $id;
    var $last_part_len;
    var $last_part=__stackBase__;
    $voices_addr=$voices;
    $name_addr=$name;
    $match_fname=-1; //@line 1325 "voices.cpp"
    $match_fname2=-1; //@line 1326 "voices.cpp"
    $match_name=-1; //@line 1327 "voices.cpp"
    var $0=$voices_addr; //@line 1332 "voices.cpp"
    var $cmp=((($0))|0)==0; //@line 1332 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1332 "voices.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1334 "voices.cpp"
      var $cmp1=((($1))|0)==0; //@line 1334 "voices.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 1334 "voices.cpp"
      if (__label__ == 2) {
  
        var $call=_espeak_ListVoices(0); //@line 1335 "voices.cpp"
        ; //@line 1335 "voices.cpp"
      }
  
      $voices_addr=((__ZL11voices_list)&4294967295); //@line 1336 "voices.cpp"
      ; //@line 1337 "voices.cpp"
    }
  
    var $arraydecay=(($last_part)&4294967295); //@line 1339 "voices.cpp"
    var $2=$name_addr; //@line 1339 "voices.cpp"
    var $call4=_sprintf($arraydecay, ((__str70722)&4294967295), allocate([47,0,0,0,$2,0,0,0], ["i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1339 "voices.cpp"
    var $arraydecay5=(($last_part)&4294967295); //@line 1340 "voices.cpp"
    var $call6=_strlen($arraydecay5); //@line 1340 "voices.cpp"
    $last_part_len=$call6; //@line 1340 "voices.cpp"
    $ix=0; //@line 1342 "voices.cpp"
    var $arraydecay18=(($last_part)&4294967295); //@line 1355 "voices.cpp"
    ; //@line 1342 "voices.cpp"
    $for_cond$8: while(1) { 
  
      var $3=$ix; //@line 1342 "voices.cpp"
      var $4=$voices_addr; //@line 1342 "voices.cpp"
      var $arrayidx=(($4+4*$3)&4294967295); //@line 1342 "voices.cpp"
      var $5=HEAP32[(($arrayidx)>>2)]; //@line 1342 "voices.cpp"
      var $cmp7=((($5))|0)!=0; //@line 1342 "voices.cpp"
      if (!($cmp7)) { __label__ = 13;break $for_cond$8; } //@line 1342 "voices.cpp"
  
      var $6=$name_addr; //@line 1344 "voices.cpp"
      var $7=$ix; //@line 1344 "voices.cpp"
      var $8=$voices_addr; //@line 1344 "voices.cpp"
      var $arrayidx8=(($8+4*$7)&4294967295); //@line 1344 "voices.cpp"
      var $9=HEAP32[(($arrayidx8)>>2)]; //@line 1344 "voices.cpp"
      var $name9=(($9)&4294967295); //@line 1344 "voices.cpp"
      var $10=HEAP32[(($name9)>>2)]; //@line 1344 "voices.cpp"
      var $call10=_strcmp($6, $10); //@line 1344 "voices.cpp"
      var $cmp11=((($call10))|0)==0; //@line 1344 "voices.cpp"
      if ($cmp11) { __label__ = 7;break $for_cond$8; } //@line 1344 "voices.cpp"
  
      var $12=$name_addr; //@line 1350 "voices.cpp"
      var $13=$ix; //@line 1350 "voices.cpp"
      var $14=$voices_addr; //@line 1350 "voices.cpp"
      var $arrayidx13=(($14+4*$13)&4294967295); //@line 1350 "voices.cpp"
      var $15=HEAP32[(($arrayidx13)>>2)]; //@line 1350 "voices.cpp"
      var $identifier=(($15+8)&4294967295); //@line 1350 "voices.cpp"
      var $16=HEAP32[(($identifier)>>2)]; //@line 1350 "voices.cpp"
      $id=$16; //@line 1350 "voices.cpp"
      var $call14=_strcmp($12, $16); //@line 1350 "voices.cpp"
      var $cmp15=((($call14))|0)==0; //@line 1350 "voices.cpp"
      if ($cmp15) { __label__ = 9;; } else { __label__ = 10;; } //@line 1350 "voices.cpp"
      $if_then16$$if_else17$12: do { 
        if (__label__ == 9) {
  
          var $17=$ix; //@line 1352 "voices.cpp"
          $match_fname=$17; //@line 1352 "voices.cpp"
          ; //@line 1353 "voices.cpp"
        }
        else if (__label__ == 10) {
  
          var $18=$id; //@line 1355 "voices.cpp"
          var $call19=_strlen($18); //@line 1355 "voices.cpp"
          var $19=$last_part_len; //@line 1355 "voices.cpp"
          var $sub=((($call19)-($19))&4294967295); //@line 1355 "voices.cpp"
          var $20=$id; //@line 1355 "voices.cpp"
          var $arrayidx20=(($20+$sub)&4294967295); //@line 1355 "voices.cpp"
          var $call21=_strcmp($arraydecay18, $arrayidx20); //@line 1355 "voices.cpp"
          var $cmp22=((($call21))|0)==0; //@line 1355 "voices.cpp"
          if (!($cmp22)) { __label__ = 12;break $if_then16$$if_else17$12; } //@line 1355 "voices.cpp"
  
          var $21=$ix; //@line 1357 "voices.cpp"
          $match_fname2=$21; //@line 1357 "voices.cpp"
          ; //@line 1358 "voices.cpp"
        }
      } while(0);
  
      var $22=$ix; //@line 1342 "voices.cpp"
      var $inc=((($22)+1)&4294967295); //@line 1342 "voices.cpp"
      $ix=$inc; //@line 1342 "voices.cpp"
      __label__ = 5;continue $for_cond$8; //@line 1342 "voices.cpp"
    }
    if (__label__ == 13) {
  
      var $_pr=$match_name; //@line 1361 "voices.cpp"
      __lastLabel__ = 13; ;
    }
    else if (__label__ == 7) {
  
      var $11=$ix; //@line 1346 "voices.cpp"
      $match_name=$11; //@line 1346 "voices.cpp"
      __lastLabel__ = 7; ; //@line 1347 "voices.cpp"
    }
  
    var $23=__lastLabel__ == 13 ? $_pr : ($11); //@line 1361 "voices.cpp"
    var $cmp27=((($23))|0) < 0; //@line 1361 "voices.cpp"
    if ($cmp27) { __label__ = 15;; } else { __label__ = 17;; } //@line 1361 "voices.cpp"
    $if_then28$$if_end32thread_pre_split$21: do { 
      if (__label__ == 15) {
  
        var $24=$match_fname; //@line 1363 "voices.cpp"
        $match_name=$24; //@line 1363 "voices.cpp"
        var $25=$match_name; //@line 1364 "voices.cpp"
        var $cmp29=((($25))|0) < 0; //@line 1364 "voices.cpp"
        if (!($cmp29)) { __label__ = 20;break $if_then28$$if_end32thread_pre_split$21; } //@line 1364 "voices.cpp"
  
        var $26=$match_fname2; //@line 1365 "voices.cpp"
        $match_name=$26; //@line 1365 "voices.cpp"
        __lastLabel__ = 16; __label__ = 18;break $if_then28$$if_end32thread_pre_split$21; //@line 1365 "voices.cpp"
      }
      else if (__label__ == 17) {
  
        var $_pr1=$match_name; //@line 1368 "voices.cpp"
        __lastLabel__ = 17; __label__ = 18;break $if_then28$$if_end32thread_pre_split$21;
      }
    } while(0);
    $if_end32$$if_end35$25: do { 
      if (__label__ == 18) {
  
        var $27=__lastLabel__ == 17 ? $_pr1 : ($26); //@line 1368 "voices.cpp"
        var $cmp33=((($27))|0) < 0; //@line 1368 "voices.cpp"
        if (!($cmp33)) { __label__ = 20;break $if_end32$$if_end35$25; } //@line 1368 "voices.cpp"
  
        $retval=0; //@line 1369 "voices.cpp"
        __label__ = 21;break $if_end32$$if_end35$25; //@line 1369 "voices.cpp"
      }
    } while(0);
    if (__label__ == 20) {
  
      var $28=$match_name; //@line 1371 "voices.cpp"
      var $29=$voices_addr; //@line 1371 "voices.cpp"
      var $arrayidx36=(($29+4*$28)&4294967295); //@line 1371 "voices.cpp"
      var $30=HEAP32[(($arrayidx36)>>2)]; //@line 1371 "voices.cpp"
      $retval=$30; //@line 1371 "voices.cpp"
      ; //@line 1371 "voices.cpp"
    }
  
    var $31=$retval; //@line 1372 "voices.cpp"
    STACKTOP = __stackBase__;
    return $31; //@line 1372 "voices.cpp"
    return null;
  }
  

  function _espeak_ListVoices($voice_spec) {
    var __stackBase__  = STACKTOP; STACKTOP += 164; _memset(__stackBase__, 0, 164);
    var __label__;
  
    var $voice_spec_addr;
    var $ix;
    var $j;
    var $v;
    var $path_voices=__stackBase__;
    $voice_spec_addr=$voice_spec;
    $ix=0; //@line 1753 "voices.cpp"
    var $0=$ix; //@line 1753 "voices.cpp"
    var $1=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1753 "voices.cpp"
    var $cmp3=((($0))|0) < ((($1))|0); //@line 1753 "voices.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 4;; } //@line 1753 "voices.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$ix; //@line 1755 "voices.cpp"
          var $arrayidx=((__ZL11voices_list+$2*4)&4294967295); //@line 1755 "voices.cpp"
          var $3=HEAP32[(($arrayidx)>>2)]; //@line 1755 "voices.cpp"
          var $cmp1=((($3))|0)!=0; //@line 1755 "voices.cpp"
          if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 1755 "voices.cpp"
          if (__label__ == 2) {
  
            var $4=$ix; //@line 1756 "voices.cpp"
            var $arrayidx2=((__ZL11voices_list+$4*4)&4294967295); //@line 1756 "voices.cpp"
            var $5=HEAP32[(($arrayidx2)>>2)]; //@line 1756 "voices.cpp"
            var $6=$5; //@line 1756 "voices.cpp"
            ; //@line 1756 "voices.cpp"
            ; //@line 1756 "voices.cpp"
          }
  
          var $7=$ix; //@line 1753 "voices.cpp"
          var $inc=((($7)+1)&4294967295); //@line 1753 "voices.cpp"
          $ix=$inc; //@line 1753 "voices.cpp"
          var $8=$ix; //@line 1753 "voices.cpp"
          var $9=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1753 "voices.cpp"
          var $cmp=((($8))|0) < ((($9))|0); //@line 1753 "voices.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break $for_body$$for_end$2; } //@line 1753 "voices.cpp"
        }
      }
    } while(0);
  
    HEAP32[((__ZL13n_voices_list)>>2)]=0; //@line 1758 "voices.cpp"
    var $arraydecay=(($path_voices)&4294967295); //@line 1760 "voices.cpp"
    var $call=_sprintf($arraydecay, ((__str72724)&4294967295), allocate([((_path_home)&4294967295),0,0,0,47,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 1760 "voices.cpp"
    var $arraydecay3=(($path_voices)&4294967295); //@line 1761 "voices.cpp"
    var $call4=_strlen($arraydecay3); //@line 1761 "voices.cpp"
    var $add=((($call4)+1)&4294967295); //@line 1761 "voices.cpp"
    HEAP32[((__ZL15len_path_voices)>>2)]=$add; //@line 1761 "voices.cpp"
    var $arraydecay5=(($path_voices)&4294967295); //@line 1763 "voices.cpp"
    __ZL9GetVoicesPKc($arraydecay5); //@line 1763 "voices.cpp"
    var $10=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1764 "voices.cpp"
    var $arrayidx6=((__ZL11voices_list+$10*4)&4294967295); //@line 1764 "voices.cpp"
    HEAP32[(($arrayidx6)>>2)]=0; //@line 1764 "voices.cpp"
    var $11=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1767 "voices.cpp"
    _qsort(__ZL11voices_list, $11, 4, 6); //@line 1767 "voices.cpp"
    var $12=$voice_spec_addr; //@line 1771 "voices.cpp"
    var $tobool=((($12))|0)!=0; //@line 1771 "voices.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 6;; } //@line 1771 "voices.cpp"
    if (__label__ == 5) {
  
      var $13=$voice_spec_addr; //@line 1774 "voices.cpp"
      var $call8=__ZL14SetVoiceScoresP12espeak_VOICEPS0_i($13, ((__ZZ17espeak_ListVoicesE6voices)&4294967295), 1); //@line 1774 "voices.cpp"
      ; //@line 1775 "voices.cpp"
    }
    else if (__label__ == 6) {
  
      $j=0; //@line 1779 "voices.cpp"
      $ix=0; //@line 1780 "voices.cpp"
      var $14=$ix; //@line 1780 "voices.cpp"
      var $arrayidx101=((__ZL11voices_list+$14*4)&4294967295); //@line 1780 "voices.cpp"
      var $15=HEAP32[(($arrayidx101)>>2)]; //@line 1780 "voices.cpp"
      $v=$15; //@line 1780 "voices.cpp"
      var $cmp112=((($15))|0)!=0; //@line 1780 "voices.cpp"
      if ($cmp112) { __label__ = 7;; } else { __label__ = 12;; } //@line 1780 "voices.cpp"
      $for_body12$$for_end28$12: do { 
        if (__label__ == 7) {
          $for_body12$13: while(1) { 
  
            var $16=$v; //@line 1782 "voices.cpp"
            var $languages=(($16+4)&4294967295); //@line 1782 "voices.cpp"
            var $17=HEAP32[(($languages)>>2)]; //@line 1782 "voices.cpp"
            var $arrayidx13=(($17)&4294967295); //@line 1782 "voices.cpp"
            var $18=HEAP8[($arrayidx13)]; //@line 1782 "voices.cpp"
            var $conv=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 1782 "voices.cpp"
            var $cmp14=((($conv))|0)!=0; //@line 1782 "voices.cpp"
            if ($cmp14) { __label__ = 8;; } else { __label__ = 11;; } //@line 1782 "voices.cpp"
            $land_lhs_true$$for_inc26$15: do { 
              if (__label__ == 8) {
  
                var $19=$v; //@line 1782 "voices.cpp"
                var $languages15=(($19+4)&4294967295); //@line 1782 "voices.cpp"
                var $20=HEAP32[(($languages15)>>2)]; //@line 1782 "voices.cpp"
                var $arrayidx16=(($20+1)&4294967295); //@line 1782 "voices.cpp"
                var $call17=_strcmp($arrayidx16, ((__str55707)&4294967295)); //@line 1782 "voices.cpp"
                var $cmp18=((($call17))|0)!=0; //@line 1782 "voices.cpp"
                if (!($cmp18)) { __label__ = 11;break $land_lhs_true$$for_inc26$15; } //@line 1782 "voices.cpp"
  
                var $21=$v; //@line 1782 "voices.cpp"
                var $identifier=(($21+8)&4294967295); //@line 1782 "voices.cpp"
                var $22=HEAP32[(($identifier)>>2)]; //@line 1782 "voices.cpp"
                var $call20=_memcmp($22, ((__str73725)&4294967295), 3); //@line 1782 "voices.cpp"
                var $cmp21=((($call20))|0)!=0; //@line 1782 "voices.cpp"
                if (!($cmp21)) { __label__ = 11;break $land_lhs_true$$for_inc26$15; } //@line 1782 "voices.cpp"
  
                var $23=$v; //@line 1784 "voices.cpp"
                var $24=$j; //@line 1784 "voices.cpp"
                var $inc23=((($24)+1)&4294967295); //@line 1784 "voices.cpp"
                $j=$inc23; //@line 1784 "voices.cpp"
                var $arrayidx24=((__ZZ17espeak_ListVoicesE6voices+$24*4)&4294967295); //@line 1784 "voices.cpp"
                HEAP32[(($arrayidx24)>>2)]=$23; //@line 1784 "voices.cpp"
                ; //@line 1785 "voices.cpp"
              }
            } while(0);
  
            var $25=$ix; //@line 1780 "voices.cpp"
            var $inc27=((($25)+1)&4294967295); //@line 1780 "voices.cpp"
            $ix=$inc27; //@line 1780 "voices.cpp"
            var $26=$ix; //@line 1780 "voices.cpp"
            var $arrayidx10=((__ZL11voices_list+$26*4)&4294967295); //@line 1780 "voices.cpp"
            var $27=HEAP32[(($arrayidx10)>>2)]; //@line 1780 "voices.cpp"
            $v=$27; //@line 1780 "voices.cpp"
            var $cmp11=((($27))|0)!=0; //@line 1780 "voices.cpp"
            if ($cmp11) { __label__ = 7;continue $for_body12$13; } else { __label__ = 12;break $for_body12$$for_end28$12; } //@line 1780 "voices.cpp"
          }
        }
      } while(0);
  
      var $28=$j; //@line 1787 "voices.cpp"
      var $arrayidx29=((__ZZ17espeak_ListVoicesE6voices+$28*4)&4294967295); //@line 1787 "voices.cpp"
      HEAP32[(($arrayidx29)>>2)]=0; //@line 1787 "voices.cpp"
      ;
    }
  
    STACKTOP = __stackBase__;
    return ((__ZZ17espeak_ListVoicesE6voices)&4294967295); //@line 1789 "voices.cpp"
    return null;
  }
  

  function __Z11SelectVoiceP12espeak_VOICEPi($voice_select, $found) {
    var __stackBase__  = STACKTOP; STACKTOP += 1272; _memset(__stackBase__, 0, 1272);
    var __label__;
  
    var $retval;
    var $voice_select_addr;
    var $found_addr;
    var $nv;
    var $ix;
    var $ix2;
    var $j;
    var $n_variants;
    var $variant_number;
    var $gender;
    var $skip;
    var $aged;
    var $variant_name;
    var $p;
    var $p_start;
    var $vp;
    var $vp2;
    var $voice_select2=__stackBase__;
    var $voices=__stackBase__+24;
    var $voices2=__stackBase__+624;
    $voice_select_addr=$voice_select;
    $found_addr=$found;
    $aged=1; //@line 1388 "voices.cpp"
    $vp=0; //@line 1391 "voices.cpp"
    var $0=$found_addr; //@line 1399 "voices.cpp"
    HEAP32[(($0)>>2)]=1; //@line 1399 "voices.cpp"
    var $1=$voice_select2; //@line 1400 "voices.cpp"
    var $2=$voice_select_addr; //@line 1400 "voices.cpp"
    var $3=$2; //@line 1400 "voices.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $3;
    $dest$ = $1;
    $stop$ = $src$ + 24;
    if (($dest$%4) == ($src$%4) && 24 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1400 "voices.cpp"
    var $4=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1402 "voices.cpp"
    var $cmp=((($4))|0)==0; //@line 1402 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1402 "voices.cpp"
    if (__label__ == 1) {
  
      var $call=_espeak_ListVoices(0); //@line 1403 "voices.cpp"
      ; //@line 1403 "voices.cpp"
    }
  
    var $languages=(($voice_select2+4)&4294967295); //@line 1405 "voices.cpp"
    var $5=HEAP32[(($languages)>>2)]; //@line 1405 "voices.cpp"
    var $cmp1=((($5))|0)==0; //@line 1405 "voices.cpp"
    if ($cmp1) { __label__ = 4;; } else { __label__ = 3;; } //@line 1405 "voices.cpp"
    $if_then4$$lor_lhs_false$5: do { 
      if (__label__ == 3) {
  
        var $languages2=(($voice_select2+4)&4294967295); //@line 1405 "voices.cpp"
        var $6=HEAP32[(($languages2)>>2)]; //@line 1405 "voices.cpp"
        var $arrayidx=(($6)&4294967295); //@line 1405 "voices.cpp"
        var $7=HEAP8[($arrayidx)]; //@line 1405 "voices.cpp"
        var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1405 "voices.cpp"
        var $cmp3=((($conv))|0)==0; //@line 1405 "voices.cpp"
        if ($cmp3) { __label__ = 4;break $if_then4$$lor_lhs_false$5; } else { __label__ = 14;break $if_then4$$lor_lhs_false$5; } //@line 1405 "voices.cpp"
      }
    } while(0);
    $if_then4$$if_end41$7: do { 
      if (__label__ == 4) {
  
        var $name=(($voice_select2)&4294967295); //@line 1410 "voices.cpp"
        var $8=HEAP32[(($name)>>2)]; //@line 1410 "voices.cpp"
        var $cmp5=((($8))|0)==0; //@line 1410 "voices.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 7;; } //@line 1410 "voices.cpp"
        $if_then6$$if_end12$9: do { 
          if (__label__ == 5) {
  
            var $identifier=(($voice_select2+8)&4294967295); //@line 1412 "voices.cpp"
            var $9=HEAP32[(($identifier)>>2)]; //@line 1412 "voices.cpp"
            var $name7=(($voice_select2)&4294967295); //@line 1412 "voices.cpp"
            HEAP32[(($name7)>>2)]=$9; //@line 1412 "voices.cpp"
            var $cmp8=((($9))|0)==0; //@line 1412 "voices.cpp"
            if (!($cmp8)) { __label__ = 7;break $if_then6$$if_end12$9; } //@line 1412 "voices.cpp"
  
            var $name10=(($voice_select2)&4294967295); //@line 1413 "voices.cpp"
            HEAP32[(($name10)>>2)]=((__str45697)&4294967295); //@line 1413 "voices.cpp"
            ; //@line 1413 "voices.cpp"
          }
        } while(0);
  
        var $name13=(($voice_select2)&4294967295); //@line 1416 "voices.cpp"
        var $10=HEAP32[(($name13)>>2)]; //@line 1416 "voices.cpp"
        __Z8strncpy0PcPKci(((__ZZ11SelectVoiceP12espeak_VOICEPiE3buf)&4294967295), $10, 60); //@line 1416 "voices.cpp"
        __ZL23ExtractVoiceVariantNamePci(((__ZZ11SelectVoiceP12espeak_VOICEPiE3buf)&4294967295), 0); //@line 1417 "voices.cpp"
        $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1417 "voices.cpp"
        var $call15=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(((__ZL11voices_list)&4294967295), ((__ZZ11SelectVoiceP12espeak_VOICEPiE3buf)&4294967295)); //@line 1419 "voices.cpp"
        $vp=$call15; //@line 1419 "voices.cpp"
        var $cmp16=((($call15))|0)!=0; //@line 1420 "voices.cpp"
        if (!($cmp16)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1420 "voices.cpp"
  
        var $11=$vp; //@line 1422 "voices.cpp"
        var $languages18=(($11+4)&4294967295); //@line 1422 "voices.cpp"
        var $12=HEAP32[(($languages18)>>2)]; //@line 1422 "voices.cpp"
        var $arrayidx19=(($12+1)&4294967295); //@line 1422 "voices.cpp"
        var $languages20=(($voice_select2+4)&4294967295); //@line 1422 "voices.cpp"
        HEAP32[(($languages20)>>2)]=$arrayidx19; //@line 1422 "voices.cpp"
        var $gender21=(($voice_select2+12)&4294967295); //@line 1424 "voices.cpp"
        var $13=HEAPU8[($gender21)]; //@line 1424 "voices.cpp"
        var $conv22=((($13))&255); //@line 1424 "voices.cpp"
        var $cmp23=((($conv22))|0)==0; //@line 1424 "voices.cpp"
        if (!($cmp23)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1424 "voices.cpp"
  
        var $age=(($voice_select2+13)&4294967295); //@line 1424 "voices.cpp"
        var $14=HEAPU8[($age)]; //@line 1424 "voices.cpp"
        var $conv24=((($14))&255); //@line 1424 "voices.cpp"
        var $cmp25=((($conv24))|0)==0; //@line 1424 "voices.cpp"
        if (!($cmp25)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1424 "voices.cpp"
  
        var $variant=(($voice_select2+14)&4294967295); //@line 1424 "voices.cpp"
        var $15=HEAPU8[($variant)]; //@line 1424 "voices.cpp"
        var $conv27=((($15))&255); //@line 1424 "voices.cpp"
        var $cmp28=((($conv27))|0)==0; //@line 1424 "voices.cpp"
        if (!($cmp28)) { __label__ = 14;break $if_then4$$if_end41$7; } //@line 1424 "voices.cpp"
  
        var $16=$variant_name; //@line 1426 "voices.cpp"
        var $arrayidx30=(($16)&4294967295); //@line 1426 "voices.cpp"
        var $17=HEAP8[($arrayidx30)]; //@line 1426 "voices.cpp"
        var $conv31=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1426 "voices.cpp"
        var $cmp32=((($conv31))|0)!=0; //@line 1426 "voices.cpp"
        var $18=$vp; //@line 1428 "voices.cpp"
        var $identifier34=(($18+8)&4294967295); //@line 1428 "voices.cpp"
        var $19=HEAP32[(($identifier34)>>2)]; //@line 1428 "voices.cpp"
        if ($cmp32) { __label__ = 12;; } else { __label__ = 13;; } //@line 1426 "voices.cpp"
        if (__label__ == 12) {
  
          var $20=$variant_name; //@line 1428 "voices.cpp"
          var $arrayidx35=(($20+3)&4294967295); //@line 1428 "voices.cpp"
          var $call36=_sprintf(((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295), ((__str71723)&4294967295), allocate([$19,0,0,0,$arrayidx35,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1428 "voices.cpp"
          $retval=((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295); //@line 1429 "voices.cpp"
          __label__ = 53;break $if_then4$$if_end41$7; //@line 1429 "voices.cpp"
        }
        else if (__label__ == 13) {
  
          $retval=$19; //@line 1432 "voices.cpp"
          __label__ = 53;break $if_then4$$if_end41$7; //@line 1432 "voices.cpp"
        }
      }
    } while(0);
    if (__label__ == 14) {
  
      var $arraydecay=(($voices)&4294967295); //@line 1438 "voices.cpp"
      var $call42=__ZL14SetVoiceScoresP12espeak_VOICEPS0_i($voice_select2, $arraydecay, 0); //@line 1438 "voices.cpp"
      $nv=$call42; //@line 1438 "voices.cpp"
      var $cmp43=((($call42))|0)==0; //@line 1440 "voices.cpp"
      if ($cmp43) { __label__ = 15;; } else { __label__ = 17;; } //@line 1440 "voices.cpp"
      $if_then44$$if_end50$22: do { 
        if (__label__ == 15) {
  
          var $21=$found_addr; //@line 1443 "voices.cpp"
          HEAP32[(($21)>>2)]=0; //@line 1443 "voices.cpp"
          var $call45=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(((__ZL11voices_list)&4294967295), ((__str45697)&4294967295)); //@line 1444 "voices.cpp"
          var $arrayidx46=(($voices)&4294967295); //@line 1444 "voices.cpp"
          HEAP32[(($arrayidx46)>>2)]=$call45; //@line 1444 "voices.cpp"
          var $cmp47=((($call45))|0)!=0; //@line 1444 "voices.cpp"
          if (!($cmp47)) { __label__ = 17;break $if_then44$$if_end50$22; } //@line 1444 "voices.cpp"
  
          $nv=1; //@line 1445 "voices.cpp"
          ; //@line 1445 "voices.cpp"
        }
      } while(0);
  
      $gender=0; //@line 1448 "voices.cpp"
      var $gender51=(($voice_select2+12)&4294967295); //@line 1449 "voices.cpp"
      var $22=HEAPU8[($gender51)]; //@line 1449 "voices.cpp"
      var $conv52=((($22))&255); //@line 1449 "voices.cpp"
      var $cmp53=((($conv52))|0)==2; //@line 1449 "voices.cpp"
      if ($cmp53) { __label__ = 20;; } else { __label__ = 18;; } //@line 1449 "voices.cpp"
      $if_then62$$lor_lhs_false54$26: do { 
        if (__label__ == 18) {
  
          var $age55=(($voice_select2+13)&4294967295); //@line 1449 "voices.cpp"
          var $23=HEAPU8[($age55)]; //@line 1449 "voices.cpp"
          var $conv56=((($23))&255); //@line 1449 "voices.cpp"
          var $cmp57=((($conv56))|0) > 0; //@line 1449 "voices.cpp"
          if ($cmp57) { __label__ = 19;; } else { __label__ = 21;; } //@line 1449 "voices.cpp"
          if (__label__ == 19) {
  
            var $age59=(($voice_select2+13)&4294967295); //@line 1449 "voices.cpp"
            var $24=HEAPU8[($age59)]; //@line 1449 "voices.cpp"
            var $conv60=((($24))&255); //@line 1449 "voices.cpp"
            var $cmp61=((($conv60))|0) < 13; //@line 1449 "voices.cpp"
            if ($cmp61) { __label__ = 20;break $if_then62$$lor_lhs_false54$26; } //@line 1449 "voices.cpp"
          }
  
          var $gender63=(($voice_select2+12)&4294967295); //@line 1452 "voices.cpp"
          var $25=HEAPU8[($gender63)]; //@line 1452 "voices.cpp"
          var $conv64=((($25))&255); //@line 1452 "voices.cpp"
          var $cmp65=((($conv64))|0)==1; //@line 1452 "voices.cpp"
          if (!($cmp65)) { __label__ = 23;break $if_then62$$lor_lhs_false54$26; } //@line 1452 "voices.cpp"
  
          $gender=1; //@line 1453 "voices.cpp"
          __label__ = 23;break $if_then62$$lor_lhs_false54$26; //@line 1453 "voices.cpp"
        }
      } while(0);
      if (__label__ == 20) {
  
        $gender=2; //@line 1450 "voices.cpp"
        ; //@line 1450 "voices.cpp"
      }
  
      var $age69=(($voice_select2+13)&4294967295); //@line 1456 "voices.cpp"
      var $26=HEAPU8[($age69)]; //@line 1456 "voices.cpp"
      var $conv70=((($26))&255); //@line 1456 "voices.cpp"
      var $cmp71=((($conv70))|0) < 60; //@line 1456 "voices.cpp"
      if ($cmp71) { __label__ = 24;; } else { __label__ = 25;; } //@line 1456 "voices.cpp"
      $if_end73_thread$$if_end73$35: do { 
        if (__label__ == 24) {
  
          $aged=0; //@line 1457 "voices.cpp"
          var $27=$gender; //@line 1459 "voices.cpp"
          var $arrayidx742=((_variant_lists+$27*4)&4294967295); //@line 1459 "voices.cpp"
          var $28=HEAP32[(($arrayidx742)>>2)]; //@line 1459 "voices.cpp"
          $p_start=$28; //@line 1459 "voices.cpp"
          $p=$28; //@line 1459 "voices.cpp"
          __label__ = 26;break $if_end73_thread$$if_end73$35; //@line 1460 "voices.cpp"
        }
        else if (__label__ == 25) {
  
          var $_pr=$aged; //@line 1460 "voices.cpp"
          var $29=$gender; //@line 1459 "voices.cpp"
          var $arrayidx74=((_variant_lists+$29*4)&4294967295); //@line 1459 "voices.cpp"
          var $30=HEAP32[(($arrayidx74)>>2)]; //@line 1459 "voices.cpp"
          $p_start=$30; //@line 1459 "voices.cpp"
          $p=$30; //@line 1459 "voices.cpp"
          var $cmp75=((($_pr))|0)==0; //@line 1460 "voices.cpp"
          if ($cmp75) { __label__ = 26;break $if_end73_thread$$if_end73$35; } else { __label__ = 27;break $if_end73_thread$$if_end73$35; } //@line 1460 "voices.cpp"
        }
      } while(0);
      if (__label__ == 26) {
  
        var $31=$p; //@line 1461 "voices.cpp"
        var $incdec_ptr=(($31+1)&4294967295); //@line 1461 "voices.cpp"
        $p=$incdec_ptr; //@line 1461 "voices.cpp"
        ; //@line 1461 "voices.cpp"
      }
  
      $n_variants=0; //@line 1464 "voices.cpp"
      $ix=0; //@line 1465 "voices.cpp"
      $ix2=0; //@line 1465 "voices.cpp"
      var $32=$ix; //@line 1465 "voices.cpp"
      var $33=$nv; //@line 1465 "voices.cpp"
      var $cmp786=((($32))|0) < ((($33))|0); //@line 1465 "voices.cpp"
      if ($cmp786) { __label__ = 28;; } else { __label__ = 44;; } //@line 1465 "voices.cpp"
      $for_body$$while_cond$41: do { 
        if (__label__ == 28) {
          $for_body$42: while(1) { 
  
            var $34=$ix; //@line 1467 "voices.cpp"
            var $arrayidx79=(($voices+$34*4)&4294967295); //@line 1467 "voices.cpp"
            var $35=HEAP32[(($arrayidx79)>>2)]; //@line 1467 "voices.cpp"
            $vp=$35; //@line 1467 "voices.cpp"
            $skip=0; //@line 1469 "voices.cpp"
            var $36=$gender; //@line 1470 "voices.cpp"
            var $cmp80=((($36))|0)!=0; //@line 1470 "voices.cpp"
            if ($cmp80) { __label__ = 29;; } else { __label__ = 31;; } //@line 1470 "voices.cpp"
            $land_lhs_true81$$if_end86$44: do { 
              if (__label__ == 29) {
  
                var $37=$vp; //@line 1470 "voices.cpp"
                var $gender82=(($37+12)&4294967295); //@line 1470 "voices.cpp"
                var $38=HEAPU8[($gender82)]; //@line 1470 "voices.cpp"
                var $conv83=((($38))&255); //@line 1470 "voices.cpp"
                var $39=$gender; //@line 1470 "voices.cpp"
                var $cmp84=((($conv83))|0)!=((($39))|0); //@line 1470 "voices.cpp"
                if (!($cmp84)) { __label__ = 31;break $land_lhs_true81$$if_end86$44; } //@line 1470 "voices.cpp"
  
                $skip=1; //@line 1472 "voices.cpp"
                ; //@line 1473 "voices.cpp"
              }
            } while(0);
  
            var $40=$ix2; //@line 1474 "voices.cpp"
            var $cmp87=((($40))|0)==0; //@line 1474 "voices.cpp"
            if ($cmp87) { __label__ = 32;; } else { __label__ = 35;; } //@line 1474 "voices.cpp"
            $land_lhs_true88$$if_end94$48: do { 
              if (__label__ == 32) {
  
                var $41=$aged; //@line 1474 "voices.cpp"
                var $tobool=((($41))|0)!=0; //@line 1474 "voices.cpp"
                if (!($tobool)) { __label__ = 35;break $land_lhs_true88$$if_end94$48; } //@line 1474 "voices.cpp"
  
                var $42=$vp; //@line 1474 "voices.cpp"
                var $age90=(($42+13)&4294967295); //@line 1474 "voices.cpp"
                var $43=HEAPU8[($age90)]; //@line 1474 "voices.cpp"
                var $conv91=((($43))&255); //@line 1474 "voices.cpp"
                var $cmp92=((($conv91))|0) < 60; //@line 1474 "voices.cpp"
                if (!($cmp92)) { __label__ = 35;break $land_lhs_true88$$if_end94$48; } //@line 1474 "voices.cpp"
  
                $skip=1; //@line 1476 "voices.cpp"
                __label__ = 37;break $land_lhs_true88$$if_end94$48; //@line 1478 "voices.cpp"
              }
            } while(0);
            $if_end98$$if_end94$52: do { 
              if (__label__ == 35) {
  
                var $_pr4=$skip; //@line 1478 "voices.cpp"
                var $cmp95=((($_pr4))|0)==0; //@line 1478 "voices.cpp"
                if (!($cmp95)) { __label__ = 37;break $if_end98$$if_end94$52; } //@line 1478 "voices.cpp"
  
                var $44=$vp; //@line 1480 "voices.cpp"
                var $45=$ix2; //@line 1480 "voices.cpp"
                var $inc=((($45)+1)&4294967295); //@line 1480 "voices.cpp"
                $ix2=$inc; //@line 1480 "voices.cpp"
                var $arrayidx97=(($voices2+$45*4)&4294967295); //@line 1480 "voices.cpp"
                HEAP32[(($arrayidx97)>>2)]=$44; //@line 1480 "voices.cpp"
                ; //@line 1481 "voices.cpp"
              }
            } while(0);
  
            $j=0; //@line 1483 "voices.cpp"
            ; //@line 1483 "voices.cpp"
            while(1) { 
  
              var $46=$j; //@line 1483 "voices.cpp"
              var $47=$vp; //@line 1483 "voices.cpp"
              var $xx1=(($47+15)&4294967295); //@line 1483 "voices.cpp"
              var $48=HEAPU8[($xx1)]; //@line 1483 "voices.cpp"
              var $conv100=((($48))&255); //@line 1483 "voices.cpp"
              var $cmp101=((($46))|0) < ((($conv100))|0); //@line 1483 "voices.cpp"
              if (!($cmp101)) { __label__ = 43;break ; } //@line 1483 "voices.cpp"
  
              var $49=$n_variants; //@line 1483 "voices.cpp"
              var $cmp102=((($49))|0) < 12; //@line 1483 "voices.cpp"
              if (!($cmp102)) { __label__ = 43;break ; }
  
              var $50=$p; //@line 1485 "voices.cpp"
              var $51=HEAP8[($50)]; //@line 1485 "voices.cpp"
              var $conv104=(tempInt=(($51)),(tempInt>=128?tempInt-256:tempInt)); //@line 1485 "voices.cpp"
              $variant_number=$conv104; //@line 1485 "voices.cpp"
              var $cmp105=((($conv104))|0)==0; //@line 1485 "voices.cpp"
              if ($cmp105) { __label__ = 41;; } else { __label__ = 42;; } //@line 1485 "voices.cpp"
              if (__label__ == 41) {
  
                var $52=$p_start; //@line 1487 "voices.cpp"
                $p=$52; //@line 1487 "voices.cpp"
                __label__ = 38;continue ; //@line 1488 "voices.cpp"
              }
              else if (__label__ == 42) {
  
                var $53=$n_variants; //@line 1491 "voices.cpp"
                var $inc108=((($53)+1)&4294967295); //@line 1491 "voices.cpp"
                $n_variants=$inc108; //@line 1491 "voices.cpp"
                var $arrayidx109=((__ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants+$53*24)&4294967295); //@line 1491 "voices.cpp"
                $vp2=$arrayidx109; //@line 1491 "voices.cpp"
                var $54=$vp2; //@line 1492 "voices.cpp"
                var $55=$54; //@line 1492 "voices.cpp"
                var $56=$vp; //@line 1492 "voices.cpp"
                var $57=$56; //@line 1492 "voices.cpp"
                var $src$, $dest$, $stop$, $stop4$, $fast$;
                $src$ = $57;
                $dest$ = $55;
                $stop$ = $src$ + 24;
                if (($dest$%4) == ($src$%4) && 24 > 8) {
                  while ($src$%4 !== 0 && $src$ < $stop$) {
                    ; HEAP8[$dest$++] = HEAP8[$src$++];
                  }
                  $src$ >>= 2;
                  $dest$ >>= 2;
                  $stop4$ = $stop$ >> 2;
                  while ($src$ < $stop4$) {
                ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
                  }
                  $src$ <<= 2;
                  $dest$ <<= 2;
                }while ($src$ < $stop$) {
                  ; HEAP8[$dest$++] = HEAP8[$src$++];
                }; //@line 1492 "voices.cpp"
                var $58=$variant_number; //@line 1493 "voices.cpp"
                var $conv110=((($58)) & 255); //@line 1493 "voices.cpp"
                var $59=$vp2; //@line 1493 "voices.cpp"
                var $variant111=(($59+14)&4294967295); //@line 1493 "voices.cpp"
                HEAP8[($variant111)]=$conv110; //@line 1493 "voices.cpp"
                var $60=$vp2; //@line 1494 "voices.cpp"
                var $61=$ix2; //@line 1494 "voices.cpp"
                var $inc112=((($61)+1)&4294967295); //@line 1494 "voices.cpp"
                $ix2=$inc112; //@line 1494 "voices.cpp"
                var $arrayidx113=(($voices2+$61*4)&4294967295); //@line 1494 "voices.cpp"
                HEAP32[(($arrayidx113)>>2)]=$60; //@line 1494 "voices.cpp"
                var $62=$p; //@line 1495 "voices.cpp"
                var $incdec_ptr114=(($62+1)&4294967295); //@line 1495 "voices.cpp"
                $p=$incdec_ptr114; //@line 1495 "voices.cpp"
                var $63=$j; //@line 1496 "voices.cpp"
                var $inc115=((($63)+1)&4294967295); //@line 1496 "voices.cpp"
                $j=$inc115; //@line 1496 "voices.cpp"
                __label__ = 38;continue ; //@line 1497 "voices.cpp"
              }
            }
  
            var $64=$ix; //@line 1465 "voices.cpp"
            var $inc116=((($64)+1)&4294967295); //@line 1465 "voices.cpp"
            $ix=$inc116; //@line 1465 "voices.cpp"
            var $65=$ix; //@line 1465 "voices.cpp"
            var $66=$nv; //@line 1465 "voices.cpp"
            var $cmp78=((($65))|0) < ((($66))|0); //@line 1465 "voices.cpp"
            if ($cmp78) { __label__ = 28;continue $for_body$42; } else { __label__ = 44;break $for_body$$while_cond$41; } //@line 1465 "voices.cpp"
          }
        }
      } while(0);
      while(1) { 
  
        var $67=$vp; //@line 1500 "voices.cpp"
        var $cmp118=((($67))|0)!=0; //@line 1500 "voices.cpp"
        if (!($cmp118)) { __label__ = 48;break ; } //@line 1500 "voices.cpp"
  
        var $68=$p; //@line 1500 "voices.cpp"
        var $incdec_ptr120=(($68+1)&4294967295); //@line 1500 "voices.cpp"
        $p=$incdec_ptr120; //@line 1500 "voices.cpp"
        var $69=HEAP8[($68)]; //@line 1500 "voices.cpp"
        var $conv121=(tempInt=(($69)),(tempInt>=128?tempInt-256:tempInt)); //@line 1500 "voices.cpp"
        $variant_number=$conv121; //@line 1500 "voices.cpp"
        var $cmp122=((($conv121))|0)!=0; //@line 1500 "voices.cpp"
        if (!($cmp122)) { __label__ = 48;break ; } //@line 1500 "voices.cpp"
  
        var $70=$n_variants; //@line 1500 "voices.cpp"
        var $cmp124=((($70))|0) < 12; //@line 1500 "voices.cpp"
        if (!($cmp124)) { __label__ = 48;break ; }
  
        var $71=$n_variants; //@line 1502 "voices.cpp"
        var $inc126=((($71)+1)&4294967295); //@line 1502 "voices.cpp"
        $n_variants=$inc126; //@line 1502 "voices.cpp"
        var $arrayidx127=((__ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants+$71*24)&4294967295); //@line 1502 "voices.cpp"
        $vp2=$arrayidx127; //@line 1502 "voices.cpp"
        var $72=$vp2; //@line 1503 "voices.cpp"
        var $73=$72; //@line 1503 "voices.cpp"
        var $74=$vp; //@line 1503 "voices.cpp"
        var $75=$74; //@line 1503 "voices.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $75;
        $dest$ = $73;
        $stop$ = $src$ + 24;
        if (($dest$%4) == ($src$%4) && 24 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 1503 "voices.cpp"
        var $76=$variant_number; //@line 1504 "voices.cpp"
        var $conv128=((($76)) & 255); //@line 1504 "voices.cpp"
        var $77=$vp2; //@line 1504 "voices.cpp"
        var $variant129=(($77+14)&4294967295); //@line 1504 "voices.cpp"
        HEAP8[($variant129)]=$conv128; //@line 1504 "voices.cpp"
        var $78=$vp2; //@line 1505 "voices.cpp"
        var $79=$ix2; //@line 1505 "voices.cpp"
        var $inc130=((($79)+1)&4294967295); //@line 1505 "voices.cpp"
        $ix2=$inc130; //@line 1505 "voices.cpp"
        var $arrayidx131=(($voices2+$79*4)&4294967295); //@line 1505 "voices.cpp"
        HEAP32[(($arrayidx131)>>2)]=$78; //@line 1505 "voices.cpp"
        __label__ = 44;continue ; //@line 1506 "voices.cpp"
      }
  
      var $80=$ix2; //@line 1509 "voices.cpp"
      var $cmp132=((($80))|0)==0; //@line 1509 "voices.cpp"
      if ($cmp132) { __label__ = 49;; } else { __label__ = 50;; } //@line 1509 "voices.cpp"
      if (__label__ == 49) {
  
        $retval=0; //@line 1510 "voices.cpp"
        ; //@line 1510 "voices.cpp"
      }
      else if (__label__ == 50) {
  
        var $variant135=(($voice_select2+14)&4294967295); //@line 1511 "voices.cpp"
        var $81=HEAPU8[($variant135)]; //@line 1511 "voices.cpp"
        var $conv136=((($81))&255); //@line 1511 "voices.cpp"
        var $82=$ix2; //@line 1511 "voices.cpp"
        var $rem=((($conv136))|0)%((($82))|0); //@line 1511 "voices.cpp"
        var $arrayidx137=(($voices2+$rem*4)&4294967295); //@line 1511 "voices.cpp"
        var $83=HEAP32[(($arrayidx137)>>2)]; //@line 1511 "voices.cpp"
        $vp=$83; //@line 1511 "voices.cpp"
        var $84=$vp; //@line 1513 "voices.cpp"
        var $variant138=(($84+14)&4294967295); //@line 1513 "voices.cpp"
        var $85=HEAPU8[($variant138)]; //@line 1513 "voices.cpp"
        var $conv139=((($85))&255); //@line 1513 "voices.cpp"
        var $cmp140=((($conv139))|0)!=0; //@line 1513 "voices.cpp"
        var $86=$vp; //@line 1515 "voices.cpp"
        if ($cmp140) { __label__ = 51;; } else { __label__ = 52;; } //@line 1513 "voices.cpp"
        if (__label__ == 51) {
  
          var $variant142=(($86+14)&4294967295); //@line 1515 "voices.cpp"
          var $87=HEAPU8[($variant142)]; //@line 1515 "voices.cpp"
          var $conv143=((($87))&255); //@line 1515 "voices.cpp"
          __ZL23ExtractVoiceVariantNamePci(0, $conv143); //@line 1515 "voices.cpp"
          $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1515 "voices.cpp"
          var $88=$vp; //@line 1516 "voices.cpp"
          var $identifier145=(($88+8)&4294967295); //@line 1516 "voices.cpp"
          var $89=HEAP32[(($identifier145)>>2)]; //@line 1516 "voices.cpp"
          var $90=$variant_name; //@line 1516 "voices.cpp"
          var $arrayidx146=(($90+3)&4294967295); //@line 1516 "voices.cpp"
          var $call147=_sprintf(((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295), ((__str71723)&4294967295), allocate([$89,0,0,0,$arrayidx146,0,0,0], ["i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1516 "voices.cpp"
          $retval=((__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id)&4294967295); //@line 1517 "voices.cpp"
          ; //@line 1517 "voices.cpp"
        }
        else if (__label__ == 52) {
  
          var $identifier149=(($86+8)&4294967295); //@line 1520 "voices.cpp"
          var $91=HEAP32[(($identifier149)>>2)]; //@line 1520 "voices.cpp"
          $retval=$91; //@line 1520 "voices.cpp"
          ; //@line 1520 "voices.cpp"
        }
      }
    }
  
    var $92=$retval; //@line 1521 "voices.cpp"
    STACKTOP = __stackBase__;
    return $92; //@line 1521 "voices.cpp"
    return null;
  }
  

  function __ZL14SetVoiceScoresP12espeak_VOICEPS0_i($voice_select, $voices, $control) {
    var __stackBase__  = STACKTOP; STACKTOP += 80; _memset(__stackBase__, 0, 80);
    var __label__;
  
    var $retval;
    var $voice_select_addr;
    var $voices_addr;
    var $control_addr;
    var $ix;
    var $score;
    var $nv;
    var $n_parts;
    var $lang_len;
    var $vp;
    var $language=__stackBase__;
    $voice_select_addr=$voice_select;
    $voices_addr=$voices;
    $control_addr=$control;
    $n_parts=0; //@line 1277 "voices.cpp"
    $lang_len=0; //@line 1278 "voices.cpp"
    var $0=$voice_select_addr; //@line 1283 "voices.cpp"
    var $languages=(($0+4)&4294967295); //@line 1283 "voices.cpp"
    var $1=HEAP32[(($languages)>>2)]; //@line 1283 "voices.cpp"
    var $cmp=((($1))|0)!=0; //@line 1283 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 6;; } //@line 1283 "voices.cpp"
    $land_lhs_true$$if_end16$2: do { 
      if (__label__ == 1) {
  
        var $2=$voice_select_addr; //@line 1283 "voices.cpp"
        var $languages1=(($2+4)&4294967295); //@line 1283 "voices.cpp"
        var $3=HEAP32[(($languages1)>>2)]; //@line 1283 "voices.cpp"
        var $arrayidx=(($3)&4294967295); //@line 1283 "voices.cpp"
        var $4=HEAP8[($arrayidx)]; //@line 1283 "voices.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1283 "voices.cpp"
        var $cmp2=((($conv))|0)!=0; //@line 1283 "voices.cpp"
        if (!($cmp2)) { __label__ = 6;break $land_lhs_true$$if_end16$2; } //@line 1283 "voices.cpp"
  
        $n_parts=1; //@line 1285 "voices.cpp"
        var $5=$voice_select_addr; //@line 1286 "voices.cpp"
        var $languages3=(($5+4)&4294967295); //@line 1286 "voices.cpp"
        var $6=HEAP32[(($languages3)>>2)]; //@line 1286 "voices.cpp"
        var $call=_strlen($6); //@line 1286 "voices.cpp"
        $lang_len=$call; //@line 1286 "voices.cpp"
        $ix=0; //@line 1287 "voices.cpp"
        var $7=$ix; //@line 1287 "voices.cpp"
        var $8=$lang_len; //@line 1287 "voices.cpp"
        var $cmp42=((($7))|0) <= ((($8))|0); //@line 1287 "voices.cpp"
        var $9=$ix; //@line 1287 "voices.cpp"
        var $cmp53=((($9))>>>0) < 80; //@line 1287 "voices.cpp"
        var $or_cond4=($cmp42) & ($cmp53); //@line 1287 "voices.cpp"
        if (!($or_cond4)) { __label__ = 6;break $land_lhs_true$$if_end16$2; } //@line 1287 "voices.cpp"
        while(1) { 
  
          var $10=$ix; //@line 1289 "voices.cpp"
          var $11=$voice_select_addr; //@line 1289 "voices.cpp"
          var $languages6=(($11+4)&4294967295); //@line 1289 "voices.cpp"
          var $12=HEAP32[(($languages6)>>2)]; //@line 1289 "voices.cpp"
          var $arrayidx7=(($12+$10)&4294967295); //@line 1289 "voices.cpp"
          var $13=HEAP8[($arrayidx7)]; //@line 1289 "voices.cpp"
          var $conv8=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1289 "voices.cpp"
          var $call9=_tolower($conv8); //@line 1289 "voices.cpp"
          var $conv10=((($call9)) & 255); //@line 1289 "voices.cpp"
          var $14=$ix; //@line 1289 "voices.cpp"
          var $arrayidx11=(($language+$14)&4294967295); //@line 1289 "voices.cpp"
          HEAP8[($arrayidx11)]=$conv10; //@line 1289 "voices.cpp"
          var $conv12=(tempInt=(($conv10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1289 "voices.cpp"
          var $cmp13=((($conv12))|0)==45; //@line 1289 "voices.cpp"
          if ($cmp13) { __label__ = 4;; } else { __label__ = 5;; } //@line 1289 "voices.cpp"
          if (__label__ == 4) {
  
            var $15=$n_parts; //@line 1290 "voices.cpp"
            var $inc=((($15)+1)&4294967295); //@line 1290 "voices.cpp"
            $n_parts=$inc; //@line 1290 "voices.cpp"
            ; //@line 1290 "voices.cpp"
          }
  
          var $16=$ix; //@line 1287 "voices.cpp"
          var $inc15=((($16)+1)&4294967295); //@line 1287 "voices.cpp"
          $ix=$inc15; //@line 1287 "voices.cpp"
          var $17=$ix; //@line 1287 "voices.cpp"
          var $18=$lang_len; //@line 1287 "voices.cpp"
          var $cmp4=((($17))|0) <= ((($18))|0); //@line 1287 "voices.cpp"
          var $19=$ix; //@line 1287 "voices.cpp"
          var $cmp5=((($19))>>>0) < 80; //@line 1287 "voices.cpp"
          var $or_cond=($cmp4) & ($cmp5); //@line 1287 "voices.cpp"
          if ($or_cond) { __label__ = 3;continue ; } else { __label__ = 6;break $land_lhs_true$$if_end16$2; } //@line 1287 "voices.cpp"
        }
      }
    } while(0);
  
    $nv=0; //@line 1294 "voices.cpp"
    $ix=0; //@line 1295 "voices.cpp"
    var $20=$ix; //@line 1295 "voices.cpp"
    var $21=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1295 "voices.cpp"
    var $cmp181=((($20))|0) < ((($21))|0); //@line 1295 "voices.cpp"
    if ($cmp181) { __label__ = 7;; } else { __label__ = 13;; } //@line 1295 "voices.cpp"
    $for_body19_lr_ph$$for_end37$11: do { 
      if (__label__ == 7) {
  
        var $arraydecay=(($language)&4294967295); //@line 1302 "voices.cpp"
        ; //@line 1295 "voices.cpp"
        $for_body19$13: while(1) { 
  
          var $22=$ix; //@line 1297 "voices.cpp"
          var $arrayidx20=((__ZL11voices_list+$22*4)&4294967295); //@line 1297 "voices.cpp"
          var $23=HEAP32[(($arrayidx20)>>2)]; //@line 1297 "voices.cpp"
          $vp=$23; //@line 1297 "voices.cpp"
          var $24=$control_addr; //@line 1299 "voices.cpp"
          var $and=($24) & 1; //@line 1299 "voices.cpp"
          var $cmp21=((($and))|0)==0; //@line 1299 "voices.cpp"
          if ($cmp21) { __label__ = 9;; } else { __label__ = 10;; } //@line 1299 "voices.cpp"
          $land_lhs_true22$$if_end26$15: do { 
            if (__label__ == 9) {
  
              var $25=$vp; //@line 1299 "voices.cpp"
              var $identifier=(($25+8)&4294967295); //@line 1299 "voices.cpp"
              var $26=HEAP32[(($identifier)>>2)]; //@line 1299 "voices.cpp"
              var $call23=_memcmp($26, ((__str73725)&4294967295), 3); //@line 1299 "voices.cpp"
              var $cmp24=((($call23))|0)==0; //@line 1299 "voices.cpp"
              if ($cmp24) { __label__ = 12;break $land_lhs_true22$$if_end26$15; } else { __label__ = 10;break $land_lhs_true22$$if_end26$15; } //@line 1299 "voices.cpp"
            }
          } while(0);
          $for_inc35$$if_end26$17: do { 
            if (__label__ == 10) {
  
              var $27=$voice_select_addr; //@line 1302 "voices.cpp"
              var $28=$n_parts; //@line 1302 "voices.cpp"
              var $29=$lang_len; //@line 1302 "voices.cpp"
              var $30=$ix; //@line 1302 "voices.cpp"
              var $arrayidx27=((__ZL11voices_list+$30*4)&4294967295); //@line 1302 "voices.cpp"
              var $31=HEAP32[(($arrayidx27)>>2)]; //@line 1302 "voices.cpp"
              var $call28=__ZL10ScoreVoiceP12espeak_VOICEPKciiS0_($27, $arraydecay, $28, $29, $31); //@line 1302 "voices.cpp"
              $score=$call28; //@line 1302 "voices.cpp"
              var $cmp29=((($call28))|0) > 0; //@line 1302 "voices.cpp"
              if (!($cmp29)) { __label__ = 12;break $for_inc35$$if_end26$17; } //@line 1302 "voices.cpp"
  
              var $32=$vp; //@line 1304 "voices.cpp"
              var $33=$nv; //@line 1304 "voices.cpp"
              var $inc31=((($33)+1)&4294967295); //@line 1304 "voices.cpp"
              $nv=$inc31; //@line 1304 "voices.cpp"
              var $34=$voices_addr; //@line 1304 "voices.cpp"
              var $arrayidx32=(($34+4*$33)&4294967295); //@line 1304 "voices.cpp"
              HEAP32[(($arrayidx32)>>2)]=$32; //@line 1304 "voices.cpp"
              var $35=$score; //@line 1305 "voices.cpp"
              var $36=$vp; //@line 1305 "voices.cpp"
              var $score33=(($36+16)&4294967295); //@line 1305 "voices.cpp"
              HEAP32[(($score33)>>2)]=$35; //@line 1305 "voices.cpp"
              ; //@line 1306 "voices.cpp"
            }
          } while(0);
  
          var $37=$ix; //@line 1295 "voices.cpp"
          var $inc36=((($37)+1)&4294967295); //@line 1295 "voices.cpp"
          $ix=$inc36; //@line 1295 "voices.cpp"
          var $38=$ix; //@line 1295 "voices.cpp"
          var $39=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1295 "voices.cpp"
          var $cmp18=((($38))|0) < ((($39))|0); //@line 1295 "voices.cpp"
          if ($cmp18) { __label__ = 8;continue $for_body19$13; } else { __label__ = 13;break $for_body19_lr_ph$$for_end37$11; } //@line 1295 "voices.cpp"
        }
      }
    } while(0);
  
    var $40=$nv; //@line 1308 "voices.cpp"
    var $41=$voices_addr; //@line 1308 "voices.cpp"
    var $arrayidx38=(($41+4*$40)&4294967295); //@line 1308 "voices.cpp"
    HEAP32[(($arrayidx38)>>2)]=0; //@line 1308 "voices.cpp"
    var $42=$nv; //@line 1310 "voices.cpp"
    var $cmp39=((($42))|0)==0; //@line 1310 "voices.cpp"
    if ($cmp39) { __label__ = 14;; } else { __label__ = 15;; } //@line 1310 "voices.cpp"
    if (__label__ == 14) {
  
      $retval=0; //@line 1311 "voices.cpp"
      ; //@line 1311 "voices.cpp"
    }
    else if (__label__ == 15) {
  
      var $43=$voices_addr; //@line 1314 "voices.cpp"
      var $44=$43; //@line 1314 "voices.cpp"
      var $45=$nv; //@line 1314 "voices.cpp"
      _qsort($44, $45, 4, 8); //@line 1314 "voices.cpp"
      var $46=$nv; //@line 1316 "voices.cpp"
      $retval=$46; //@line 1316 "voices.cpp"
      ; //@line 1316 "voices.cpp"
    }
  
    var $47=$retval; //@line 1317 "voices.cpp"
    STACKTOP = __stackBase__;
    return $47; //@line 1317 "voices.cpp"
    return null;
  }
  

  function __Z14SetVoiceByNamePKc($name) {
    var __stackBase__  = STACKTOP; STACKTOP += 24; _memset(__stackBase__, 0, 24);
    var __label__;
  
    var $retval;
    var $name_addr;
    var $v;
    var $voice_selector=__stackBase__;
    var $variant_name;
    $name_addr=$name;
    var $0=$name_addr; //@line 1673 "voices.cpp"
    __Z8strncpy0PcPKci(((__ZZ14SetVoiceByNamePKcE3buf)&4294967295), $0, 60); //@line 1673 "voices.cpp"
    __ZL23ExtractVoiceVariantNamePci(((__ZZ14SetVoiceByNamePKcE3buf)&4294967295), 0); //@line 1674 "voices.cpp"
    $variant_name=((__ZZL23ExtractVoiceVariantNamePciE12variant_name)&4294967295); //@line 1674 "voices.cpp"
    var $1=$voice_selector; //@line 1676 "voices.cpp"
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = $1;
    $stop$ = $dest$ + 24;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 1676 "voices.cpp"
    var $2=$name_addr; //@line 1678 "voices.cpp"
    var $name1=(($voice_selector)&4294967295); //@line 1678 "voices.cpp"
    HEAP32[(($name1)>>2)]=$2; //@line 1678 "voices.cpp"
    var $call2=__Z9LoadVoicePKci(((__ZZ14SetVoiceByNamePKcE3buf)&4294967295), 1); //@line 1683 "voices.cpp"
    var $cmp=((($call2))|0)!=0; //@line 1683 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1683 "voices.cpp"
    $if_then$$if_end6$2: do { 
      if (__label__ == 1) {
  
        var $3=$variant_name; //@line 1685 "voices.cpp"
        var $arrayidx=(($3)&4294967295); //@line 1685 "voices.cpp"
        var $4=HEAP8[($arrayidx)]; //@line 1685 "voices.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 1685 "voices.cpp"
        var $cmp3=((($conv))|0)!=0; //@line 1685 "voices.cpp"
        if ($cmp3) { __label__ = 2;; } else { __label__ = 3;; } //@line 1685 "voices.cpp"
        if (__label__ == 2) {
  
          var $5=$variant_name; //@line 1687 "voices.cpp"
          var $call5=__Z9LoadVoicePKci($5, 2); //@line 1687 "voices.cpp"
          ; //@line 1688 "voices.cpp"
        }
  
        var $6=HEAP32[((_voice)>>2)]; //@line 1690 "voices.cpp"
        __Z13DoVoiceChangeP7voice_t($6); //@line 1690 "voices.cpp"
        __Z13SetVoiceStackP12espeak_VOICE($voice_selector); //@line 1691 "voices.cpp"
        $retval=0; //@line 1692 "voices.cpp"
        ; //@line 1692 "voices.cpp"
      }
      else if (__label__ == 4) {
  
        var $7=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1695 "voices.cpp"
        var $cmp7=((($7))|0)==0; //@line 1695 "voices.cpp"
        if ($cmp7) { __label__ = 5;; } else { __label__ = 6;; } //@line 1695 "voices.cpp"
        if (__label__ == 5) {
  
          var $call9=_espeak_ListVoices(0); //@line 1696 "voices.cpp"
          ; //@line 1696 "voices.cpp"
        }
  
        var $call11=__Z17SelectVoiceByNamePP12espeak_VOICEPKc(((__ZL11voices_list)&4294967295), ((__ZZ14SetVoiceByNamePKcE3buf)&4294967295)); //@line 1698 "voices.cpp"
        $v=$call11; //@line 1698 "voices.cpp"
        var $cmp12=((($call11))|0)!=0; //@line 1698 "voices.cpp"
        if ($cmp12) { __label__ = 7;; } else { __label__ = 11;; } //@line 1698 "voices.cpp"
        $if_then13$$if_end24$11: do { 
          if (__label__ == 7) {
  
            var $8=$v; //@line 1700 "voices.cpp"
            var $identifier=(($8+8)&4294967295); //@line 1700 "voices.cpp"
            var $9=HEAP32[(($identifier)>>2)]; //@line 1700 "voices.cpp"
            var $call14=__Z9LoadVoicePKci($9, 0); //@line 1700 "voices.cpp"
            var $cmp15=((($call14))|0)!=0; //@line 1700 "voices.cpp"
            if (!($cmp15)) { __label__ = 11;break $if_then13$$if_end24$11; } //@line 1700 "voices.cpp"
  
            var $10=$variant_name; //@line 1702 "voices.cpp"
            var $arrayidx17=(($10)&4294967295); //@line 1702 "voices.cpp"
            var $11=HEAP8[($arrayidx17)]; //@line 1702 "voices.cpp"
            var $conv18=(tempInt=(($11)),(tempInt>=128?tempInt-256:tempInt)); //@line 1702 "voices.cpp"
            var $cmp19=((($conv18))|0)!=0; //@line 1702 "voices.cpp"
            if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 1702 "voices.cpp"
            if (__label__ == 9) {
  
              var $12=$variant_name; //@line 1704 "voices.cpp"
              var $call21=__Z9LoadVoicePKci($12, 2); //@line 1704 "voices.cpp"
              ; //@line 1705 "voices.cpp"
            }
  
            var $13=HEAP32[((_voice)>>2)]; //@line 1706 "voices.cpp"
            __Z13DoVoiceChangeP7voice_t($13); //@line 1706 "voices.cpp"
            __Z13SetVoiceStackP12espeak_VOICE($voice_selector); //@line 1707 "voices.cpp"
            $retval=0; //@line 1708 "voices.cpp"
            __label__ = 12;break $if_then$$if_end6$2; //@line 1708 "voices.cpp"
          }
        } while(0);
  
        $retval=-1; //@line 1711 "voices.cpp"
        ; //@line 1711 "voices.cpp"
      }
    } while(0);
  
    var $14=$retval; //@line 1712 "voices.cpp"
    STACKTOP = __stackBase__;
    return $14; //@line 1712 "voices.cpp"
    return null;
  }
  

  function __Z20SetVoiceByPropertiesP12espeak_VOICE($voice_selector) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $retval;
    var $voice_selector_addr;
    var $voice_id;
    var $voice_found=__stackBase__;
    $voice_selector_addr=$voice_selector;
    var $0=$voice_selector_addr; //@line 1721 "voices.cpp"
    var $call=__Z11SelectVoiceP12espeak_VOICEPi($0, $voice_found); //@line 1721 "voices.cpp"
    $voice_id=$call; //@line 1721 "voices.cpp"
    var $1=HEAP32[(($voice_found)>>2)]; //@line 1723 "voices.cpp"
    var $cmp=((($1))|0)==0; //@line 1723 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1723 "voices.cpp"
    if (__label__ == 1) {
  
      $retval=2; //@line 1724 "voices.cpp"
      ; //@line 1724 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$voice_id; //@line 1726 "voices.cpp"
      var $call1=__Z16LoadVoiceVariantPKci($2, 0); //@line 1726 "voices.cpp"
      var $3=HEAP32[((_voice)>>2)]; //@line 1727 "voices.cpp"
      __Z13DoVoiceChangeP7voice_t($3); //@line 1727 "voices.cpp"
      var $4=$voice_selector_addr; //@line 1728 "voices.cpp"
      __Z13SetVoiceStackP12espeak_VOICE($4); //@line 1728 "voices.cpp"
      $retval=0; //@line 1730 "voices.cpp"
      ; //@line 1730 "voices.cpp"
    }
  
    var $5=$retval; //@line 1731 "voices.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 1731 "voices.cpp"
    return null;
  }
  

  function __ZL9GetVoicesPKc($path) {
    var __stackBase__  = STACKTOP; STACKTOP += 252; _memset(__stackBase__, 0, 252);
    var __label__;
    var __lastLabel__ = null;
  
    var $path_addr;
    var $f_voice;
    var $voice_data;
    var $ftype;
    var $fname=__stackBase__;
    var $dir;
    var $ent;
    $path_addr=$path;
    var $0=$path_addr; //@line 1625 "voices.cpp"
    var $call=_opendir($0); //@line 1625 "voices.cpp"
    $dir=$call; //@line 1625 "voices.cpp"
    var $cmp=((($call))|0)==0; //@line 1625 "voices.cpp"
    if ($cmp) { __label__ = 13;; } else { __label__ = 1;; } //@line 1625 "voices.cpp"
    if (__label__ == 1) {
  
      var $1=$dir; //@line 1628 "voices.cpp"
      var $call11=_readdir($1); //@line 1628 "voices.cpp"
      $ent=$call11; //@line 1628 "voices.cpp"
      var $cmp22=((($call11))|0)==0; //@line 1628 "voices.cpp"
      var $2=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1630 "voices.cpp"
      var $cmp33=((($2))|0) >= 148; //@line 1630 "voices.cpp"
      var $or_cond4=($cmp22) | ($cmp33); //@line 1628 "voices.cpp"
      if ($or_cond4) { __label__ = 12;; } else { __label__ = 2;; } //@line 1628 "voices.cpp"
      $while_end$$if_end5_lr_ph$4: do { 
        if (__label__ == 2) {
  
          var $arraydecay=(($fname)&4294967295); //@line 1633 "voices.cpp"
          var $arraydecay8=(($fname)&4294967295); //@line 1635 "voices.cpp"
          var $arraydecay14=(($fname)&4294967295); //@line 1640 "voices.cpp"
          var $arraydecay17=(($fname)&4294967295); //@line 1646 "voices.cpp"
          var $arraydecay22=(($fname)&4294967295); //@line 1650 "voices.cpp"
          ; //@line 1628 "voices.cpp"
          $if_end5$6: while(1) { 
  
            var $3=$path_addr; //@line 1633 "voices.cpp"
            var $4=$ent; //@line 1633 "voices.cpp"
            var $d_name=(($4+4)&4294967295); //@line 1633 "voices.cpp"
            var $arraydecay6=(($d_name)&4294967295); //@line 1633 "voices.cpp"
            var $call7=_sprintf($arraydecay, ((__str74726)&4294967295), allocate([$3,0,0,0,47,0,0,0,$arraydecay6,0,0,0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 1633 "voices.cpp"
            var $call9=__Z13GetFileLengthPKc($arraydecay8); //@line 1635 "voices.cpp"
            $ftype=$call9; //@line 1635 "voices.cpp"
            var $cmp10=((($call9))|0)==-2; //@line 1637 "voices.cpp"
            if ($cmp10) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 7;; } //@line 1637 "voices.cpp"
            $land_lhs_true$$if_else$8: do { 
              if (__label__ == 4) {
  
                var $5=$ent; //@line 1637 "voices.cpp"
                var $d_name11=(($5+4)&4294967295); //@line 1637 "voices.cpp"
                var $arrayidx=(($d_name11)&4294967295); //@line 1637 "voices.cpp"
                var $6=HEAP8[($arrayidx)]; //@line 1637 "voices.cpp"
                var $conv=(tempInt=(($6)),(tempInt>=128?tempInt-256:tempInt)); //@line 1637 "voices.cpp"
                var $cmp12=((($conv))|0)!=46; //@line 1637 "voices.cpp"
                if ($cmp12) { __label__ = 5;; } else { __label__ = 6;; } //@line 1637 "voices.cpp"
                if (__label__ == 5) {
  
                  __ZL9GetVoicesPKc($arraydecay14); //@line 1640 "voices.cpp"
                  __label__ = 9;break $land_lhs_true$$if_else$8; //@line 1641 "voices.cpp"
                }
                else if (__label__ == 6) {
  
                  var $_pr=$ftype; //@line 1643 "voices.cpp"
                  __lastLabel__ = 6; __label__ = 7;break $land_lhs_true$$if_else$8;
                }
              }
            } while(0);
            $while_cond_backedge$$if_else$13: do { 
              if (__label__ == 7) {
  
                var $7=__lastLabel__ == 6 ? $_pr : ($call9); //@line 1643 "voices.cpp"
                var $cmp15=((($7))|0) > 0; //@line 1643 "voices.cpp"
                if (!($cmp15)) { __label__ = 9;break $while_cond_backedge$$if_else$13; } //@line 1643 "voices.cpp"
  
                var $call18=_fopen($arraydecay17, ((__str51703)&4294967295)); //@line 1646 "voices.cpp"
                $f_voice=$call18; //@line 1646 "voices.cpp"
                var $cmp19=((($call18))|0)==0; //@line 1646 "voices.cpp"
                if ($cmp19) { __label__ = 9;break $while_cond_backedge$$if_else$13; } //@line 1646 "voices.cpp"
  
                var $10=$f_voice; //@line 1650 "voices.cpp"
                var $11=HEAP32[((__ZL15len_path_voices)>>2)]; //@line 1650 "voices.cpp"
                var $add_ptr=(($arraydecay22+$11)&4294967295); //@line 1650 "voices.cpp"
                var $12=$ent; //@line 1650 "voices.cpp"
                var $d_name23=(($12+4)&4294967295); //@line 1650 "voices.cpp"
                var $arraydecay24=(($d_name23)&4294967295); //@line 1650 "voices.cpp"
                var $call25=__ZL13ReadVoiceFileP7__sFILEPKcS2_($10, $add_ptr, $arraydecay24); //@line 1650 "voices.cpp"
                $voice_data=$call25; //@line 1650 "voices.cpp"
                var $13=$f_voice; //@line 1651 "voices.cpp"
                var $call26=_fclose($13); //@line 1651 "voices.cpp"
                var $14=$voice_data; //@line 1653 "voices.cpp"
                var $cmp27=((($14))|0)!=0; //@line 1653 "voices.cpp"
                if (!($cmp27)) { __label__ = 9;break $while_cond_backedge$$if_else$13; } //@line 1653 "voices.cpp"
  
                var $15=$voice_data; //@line 1655 "voices.cpp"
                var $16=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1655 "voices.cpp"
                var $inc=((($16)+1)&4294967295); //@line 1655 "voices.cpp"
                HEAP32[((__ZL13n_voices_list)>>2)]=$inc; //@line 1655 "voices.cpp"
                var $arrayidx29=((__ZL11voices_list+$16*4)&4294967295); //@line 1655 "voices.cpp"
                HEAP32[(($arrayidx29)>>2)]=$15; //@line 1655 "voices.cpp"
                ; //@line 1656 "voices.cpp"
              }
            } while(0);
  
            var $8=$dir; //@line 1628 "voices.cpp"
            var $call1=_readdir($8); //@line 1628 "voices.cpp"
            $ent=$call1; //@line 1628 "voices.cpp"
            var $cmp2=((($call1))|0)==0; //@line 1628 "voices.cpp"
            var $9=HEAP32[((__ZL13n_voices_list)>>2)]; //@line 1630 "voices.cpp"
            var $cmp3=((($9))|0) >= 148; //@line 1630 "voices.cpp"
            var $or_cond=($cmp2) | ($cmp3); //@line 1628 "voices.cpp"
            if ($or_cond) { __label__ = 12;break $while_end$$if_end5_lr_ph$4; } else { __label__ = 3;continue $if_end5$6; } //@line 1628 "voices.cpp"
          }
        }
      } while(0);
  
      var $17=$dir; //@line 1659 "voices.cpp"
      var $call33=_closedir($17); //@line 1659 "voices.cpp"
      ; //@line 1662 "voices.cpp"
    }
  
    STACKTOP = __stackBase__;
    return; //@line 1662 "voices.cpp"
    return;
  }
  

  function __ZL15VoiceNameSorterPKvS0_($p1, $p2) {
    ;
    var __label__;
  
    var $retval;
    var $p1_addr;
    var $p2_addr;
    var $ix;
    var $v1;
    var $v2;
    $p1_addr=$p1;
    $p2_addr=$p2;
    var $0=$p1_addr; //@line 1103 "voices.cpp"
    var $1=$0; //@line 1103 "voices.cpp"
    var $2=HEAP32[(($1)>>2)]; //@line 1103 "voices.cpp"
    $v1=$2; //@line 1103 "voices.cpp"
    var $3=$p2_addr; //@line 1104 "voices.cpp"
    var $4=$3; //@line 1104 "voices.cpp"
    var $5=HEAP32[(($4)>>2)]; //@line 1104 "voices.cpp"
    $v2=$5; //@line 1104 "voices.cpp"
    var $6=$v1; //@line 1107 "voices.cpp"
    var $languages=(($6+4)&4294967295); //@line 1107 "voices.cpp"
    var $7=HEAP32[(($languages)>>2)]; //@line 1107 "voices.cpp"
    var $arrayidx=(($7+1)&4294967295); //@line 1107 "voices.cpp"
    var $8=$v2; //@line 1107 "voices.cpp"
    var $languages1=(($8+4)&4294967295); //@line 1107 "voices.cpp"
    var $9=HEAP32[(($languages1)>>2)]; //@line 1107 "voices.cpp"
    var $arrayidx2=(($9+1)&4294967295); //@line 1107 "voices.cpp"
    var $call=_strcmp($arrayidx, $arrayidx2); //@line 1107 "voices.cpp"
    $ix=$call; //@line 1107 "voices.cpp"
    var $cmp=((($call))|0)!=0; //@line 1107 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1107 "voices.cpp"
    if (__label__ == 1) {
  
      var $10=$ix; //@line 1108 "voices.cpp"
      $retval=$10; //@line 1108 "voices.cpp"
      ; //@line 1108 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=$v1; //@line 1109 "voices.cpp"
      var $languages3=(($11+4)&4294967295); //@line 1109 "voices.cpp"
      var $12=HEAP32[(($languages3)>>2)]; //@line 1109 "voices.cpp"
      var $arrayidx4=(($12)&4294967295); //@line 1109 "voices.cpp"
      var $13=HEAP8[($arrayidx4)]; //@line 1109 "voices.cpp"
      var $conv=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1109 "voices.cpp"
      var $14=$v2; //@line 1109 "voices.cpp"
      var $languages5=(($14+4)&4294967295); //@line 1109 "voices.cpp"
      var $15=HEAP32[(($languages5)>>2)]; //@line 1109 "voices.cpp"
      var $arrayidx6=(($15)&4294967295); //@line 1109 "voices.cpp"
      var $16=HEAP8[($arrayidx6)]; //@line 1109 "voices.cpp"
      var $conv7=(tempInt=(($16)),(tempInt>=128?tempInt-256:tempInt)); //@line 1109 "voices.cpp"
      var $sub=((($conv)-($conv7))&4294967295); //@line 1109 "voices.cpp"
      $ix=$sub; //@line 1109 "voices.cpp"
      var $cmp8=((($sub))|0)!=0; //@line 1109 "voices.cpp"
      if ($cmp8) { __label__ = 3;; } else { __label__ = 4;; } //@line 1109 "voices.cpp"
      if (__label__ == 3) {
  
        var $17=$ix; //@line 1110 "voices.cpp"
        $retval=$17; //@line 1110 "voices.cpp"
        ; //@line 1110 "voices.cpp"
      }
      else if (__label__ == 4) {
  
        var $18=$v1; //@line 1111 "voices.cpp"
        var $name=(($18)&4294967295); //@line 1111 "voices.cpp"
        var $19=HEAP32[(($name)>>2)]; //@line 1111 "voices.cpp"
        var $20=$v2; //@line 1111 "voices.cpp"
        var $name11=(($20)&4294967295); //@line 1111 "voices.cpp"
        var $21=HEAP32[(($name11)>>2)]; //@line 1111 "voices.cpp"
        var $call12=_strcmp($19, $21); //@line 1111 "voices.cpp"
        $retval=$call12; //@line 1111 "voices.cpp"
        ; //@line 1111 "voices.cpp"
      }
    }
  
    var $22=$retval; //@line 1112 "voices.cpp"
    ;
    return $22; //@line 1112 "voices.cpp"
    return null;
  }
  

  function _espeak_GetCurrentVoice() {
    ;
    var __label__;
  
    ;
    return _voice_selected; //@line 1798 "voices.cpp"
    return null;
  }
  

  function __ZL13ReadVoiceFileP7__sFILEPKcS2_($f_in, $fname, $leafname) {
    var __stackBase__  = STACKTOP; STACKTOP += 672; _memset(__stackBase__, 0, 672);
    var __label__;
  
    var $retval;
    var $f_in_addr;
    var $fname_addr;
    var $leafname_addr;
    var $linebuf=__stackBase__;
    var $vname=__stackBase__+120;
    var $vgender=__stackBase__+200;
    var $vlanguage=__stackBase__+280;
    var $languages=__stackBase__+360;
    var $len;
    var $langix;
    var $n_languages;
    var $p;
    var $voice_data;
    var $priority=__stackBase__+660;
    var $age=__stackBase__+664;
    var $n_variants=__stackBase__+668;
    var $gender;
    $f_in_addr=$f_in;
    $fname_addr=$fname;
    $leafname_addr=$leafname;
    $langix=0; //@line 281 "voices.cpp"
    $n_languages=0; //@line 282 "voices.cpp"
    HEAP32[(($n_variants)>>2)]=3; //@line 287 "voices.cpp"
    var $arrayidx=(($vname)&4294967295); //@line 304 "voices.cpp"
    HEAP8[($arrayidx)]=0; //@line 304 "voices.cpp"
    var $arrayidx1=(($vgender)&4294967295); //@line 305 "voices.cpp"
    HEAP8[($arrayidx1)]=0; //@line 305 "voices.cpp"
    HEAP32[(($age)>>2)]=0; //@line 306 "voices.cpp"
    var $arraydecay=(($linebuf)&4294967295); //@line 308 "voices.cpp"
    var $0=$f_in_addr; //@line 308 "voices.cpp"
    var $call4=__ZL11fgets_stripPciP7__sFILE($arraydecay, 120, $0); //@line 308 "voices.cpp"
    var $cmp5=((($call4))|0)!=0; //@line 308 "voices.cpp"
    if ($cmp5) { __label__ = 1;; } else { __label__ = 14;; } //@line 308 "voices.cpp"
    $while_body_lr_ph$$while_end49$2: do { 
      if (__label__ == 1) {
  
        var $arraydecay2=(($linebuf)&4294967295); //@line 310 "voices.cpp"
        var $arrayidx5=(($linebuf+4)&4294967295); //@line 312 "voices.cpp"
        var $arraydecay9=(($vname)&4294967295); //@line 314 "voices.cpp"
        var $arraydecay10=(($linebuf)&4294967295); //@line 317 "voices.cpp"
        var $arrayidx14=(($vlanguage)&4294967295); //@line 320 "voices.cpp"
        var $arrayidx15=(($linebuf+8)&4294967295); //@line 322 "voices.cpp"
        var $arraydecay16=(($vlanguage)&4294967295); //@line 322 "voices.cpp"
        var $arraydecay18=(($vlanguage)&4294967295); //@line 323 "voices.cpp"
        var $arraydecay27=(($vlanguage)&4294967295); //@line 329 "voices.cpp"
        var $arraydecay31=(($linebuf)&4294967295); //@line 335 "voices.cpp"
        var $arrayidx35=(($linebuf+6)&4294967295); //@line 337 "voices.cpp"
        var $arraydecay36=(($vgender)&4294967295); //@line 337 "voices.cpp"
        var $arraydecay39=(($linebuf)&4294967295); //@line 340 "voices.cpp"
        var $arrayidx43=(($linebuf+8)&4294967295); //@line 342 "voices.cpp"
        ; //@line 308 "voices.cpp"
        $while_body$4: while(1) { 
  
          var $call3=_memcmp($arraydecay2, ((__str5655)&4294967295), 4); //@line 310 "voices.cpp"
          var $cmp4=((($call3))|0)==0; //@line 310 "voices.cpp"
          if ($cmp4) { __label__ = 3;; } else { __label__ = 6;; } //@line 310 "voices.cpp"
          $if_then$$if_else$6: do { 
            if (__label__ == 3) {
  
              $p=$arrayidx5; //@line 312 "voices.cpp"
              var $1=$p; //@line 313 "voices.cpp"
              var $2=HEAP8[($1)]; //@line 313 "voices.cpp"
              var $conv1=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 313 "voices.cpp"
              var $call72=_isspace($conv1); //@line 313 "voices.cpp"
              var $tobool3=((($call72))|0)!=0; //@line 313 "voices.cpp"
              if ($tobool3) { __label__ = 4;; } else { __label__ = 5;; } //@line 313 "voices.cpp"
              $while_body8$$while_end$8: do { 
                if (__label__ == 4) {
                  while(1) { 
  
                    var $3=$p; //@line 313 "voices.cpp"
                    var $incdec_ptr=(($3+1)&4294967295); //@line 313 "voices.cpp"
                    $p=$incdec_ptr; //@line 313 "voices.cpp"
                    var $4=$p; //@line 313 "voices.cpp"
                    var $5=HEAP8[($4)]; //@line 313 "voices.cpp"
                    var $conv=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 313 "voices.cpp"
                    var $call7=_isspace($conv); //@line 313 "voices.cpp"
                    var $tobool=((($call7))|0)!=0; //@line 313 "voices.cpp"
                    if ($tobool) { __label__ = 4;continue ; } else { __label__ = 5;break $while_body8$$while_end$8; } //@line 313 "voices.cpp"
                  }
                }
              } while(0);
  
              var $6=$p; //@line 314 "voices.cpp"
              __Z8strncpy0PcPKci($arraydecay9, $6, 80); //@line 314 "voices.cpp"
              ; //@line 315 "voices.cpp"
            }
            else if (__label__ == 6) {
  
              var $call11=_memcmp($arraydecay10, ((__str6656)&4294967295), 8); //@line 317 "voices.cpp"
              var $cmp12=((($call11))|0)==0; //@line 317 "voices.cpp"
              if ($cmp12) { __label__ = 7;; } else { __label__ = 10;; } //@line 317 "voices.cpp"
              if (__label__ == 7) {
  
                HEAP32[(($priority)>>2)]=5; //@line 319 "voices.cpp"
                HEAP8[($arrayidx14)]=0; //@line 320 "voices.cpp"
                var $call17=_sscanf($arrayidx15, ((__str54706)&4294967295), allocate([$arraydecay16,0,0,0,$priority,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 322 "voices.cpp"
                var $call19=_strlen($arraydecay18); //@line 323 "voices.cpp"
                var $add=((($call19)+2)&4294967295); //@line 323 "voices.cpp"
                $len=$add; //@line 323 "voices.cpp"
                var $7=$len; //@line 325 "voices.cpp"
                var $8=$langix; //@line 325 "voices.cpp"
                var $_neg=(((-($8)))&4294967295);
                var $sub20=((($_neg)+299)&4294967295); //@line 325 "voices.cpp"
                var $cmp21=((($7))>>>0) < ((($sub20))>>>0); //@line 325 "voices.cpp"
                if (!($cmp21)) { __label__ = 9;break $if_then$$if_else$6; } //@line 325 "voices.cpp"
  
                var $9=HEAP32[(($priority)>>2)]; //@line 327 "voices.cpp"
                var $conv23=((($9)) & 255); //@line 327 "voices.cpp"
                var $10=$langix; //@line 327 "voices.cpp"
                var $arrayidx24=(($languages+$10)&4294967295); //@line 327 "voices.cpp"
                HEAP8[($arrayidx24)]=$conv23; //@line 327 "voices.cpp"
                var $11=$langix; //@line 329 "voices.cpp"
                var $add25=((($11)+1)&4294967295); //@line 329 "voices.cpp"
                var $arrayidx26=(($languages+$add25)&4294967295); //@line 329 "voices.cpp"
                var $call28=_strcpy($arrayidx26, $arraydecay27); //@line 329 "voices.cpp"
                var $12=$len; //@line 330 "voices.cpp"
                var $13=$langix; //@line 330 "voices.cpp"
                var $add29=((($13)+($12))&4294967295); //@line 330 "voices.cpp"
                $langix=$add29; //@line 330 "voices.cpp"
                var $14=$n_languages; //@line 331 "voices.cpp"
                var $inc=((($14)+1)&4294967295); //@line 331 "voices.cpp"
                $n_languages=$inc; //@line 331 "voices.cpp"
                ; //@line 332 "voices.cpp"
              }
              else if (__label__ == 10) {
  
                var $call32=_memcmp($arraydecay31, ((__str7657)&4294967295), 6); //@line 335 "voices.cpp"
                var $cmp33=((($call32))|0)==0; //@line 335 "voices.cpp"
                if ($cmp33) { __label__ = 11;; } else { __label__ = 12;; } //@line 335 "voices.cpp"
                if (__label__ == 11) {
  
                  var $call37=_sscanf($arrayidx35, ((__str54706)&4294967295), allocate([$arraydecay36,0,0,0,$age,0,0,0], ["i8*",0,0,0,"i32*",0,0,0], ALLOC_STACK)); //@line 337 "voices.cpp"
                  ; //@line 338 "voices.cpp"
                }
                else if (__label__ == 12) {
  
                  var $call40=_memcmp($arraydecay39, ((__str75727)&4294967295), 8); //@line 340 "voices.cpp"
                  var $cmp41=((($call40))|0)==0; //@line 340 "voices.cpp"
                  if (!($cmp41)) { __label__ = 9;break $if_then$$if_else$6; } //@line 340 "voices.cpp"
  
                  var $call44=_sscanf($arrayidx43, ((__str63715)&4294967295), allocate([$n_variants,0,0,0], ["i32*",0,0,0], ALLOC_STACK)); //@line 342 "voices.cpp"
                  ; //@line 343 "voices.cpp"
                }
              }
            }
          } while(0);
  
          var $15=$f_in_addr; //@line 308 "voices.cpp"
          var $call=__ZL11fgets_stripPciP7__sFILE($arraydecay, 120, $15); //@line 308 "voices.cpp"
          var $cmp=((($call))|0)!=0; //@line 308 "voices.cpp"
          if ($cmp) { __label__ = 2;continue $while_body$4; } else { __label__ = 14;break $while_body_lr_ph$$while_end49$2; } //@line 308 "voices.cpp"
        }
      }
    } while(0);
  
    var $16=$langix; //@line 345 "voices.cpp"
    var $inc50=((($16)+1)&4294967295); //@line 345 "voices.cpp"
    $langix=$inc50; //@line 345 "voices.cpp"
    var $arrayidx51=(($languages+$16)&4294967295); //@line 345 "voices.cpp"
    HEAP8[($arrayidx51)]=0; //@line 345 "voices.cpp"
    var $arraydecay52=(($vgender)&4294967295); //@line 347 "voices.cpp"
    var $call53=__Z10LookupMnemP8MNEM_TABPKc(((_genders)&4294967295), $arraydecay52); //@line 347 "voices.cpp"
    $gender=$call53; //@line 347 "voices.cpp"
    var $17=$n_languages; //@line 349 "voices.cpp"
    var $cmp54=((($17))|0)==0; //@line 349 "voices.cpp"
    if ($cmp54) { __label__ = 15;; } else { __label__ = 16;; } //@line 349 "voices.cpp"
    if (__label__ == 15) {
  
      $retval=0; //@line 351 "voices.cpp"
      ; //@line 351 "voices.cpp"
    }
    else if (__label__ == 16) {
  
      var $18=$langix; //@line 354 "voices.cpp"
      var $19=$fname_addr; //@line 354 "voices.cpp"
      var $call58=_strlen($19); //@line 354 "voices.cpp"
      var $arraydecay60=(($vname)&4294967295); //@line 354 "voices.cpp"
      var $call61=_strlen($arraydecay60); //@line 354 "voices.cpp"
      var $add59=((($18)+27)&4294967295); //@line 354 "voices.cpp"
      var $add62=((($add59)+($call58))&4294967295); //@line 354 "voices.cpp"
      var $add63=((($add62)+($call61))&4294967295); //@line 354 "voices.cpp"
      var $call64=_calloc($add63, 1); //@line 354 "voices.cpp"
      $p=$call64; //@line 354 "voices.cpp"
      var $20=$p; //@line 355 "voices.cpp"
      var $21=$20; //@line 355 "voices.cpp"
      $voice_data=$21; //@line 355 "voices.cpp"
      var $22=$p; //@line 356 "voices.cpp"
      var $arrayidx65=(($22+24)&4294967295); //@line 356 "voices.cpp"
      $p=$arrayidx65; //@line 356 "voices.cpp"
      var $23=$p; //@line 358 "voices.cpp"
      var $arraydecay66=(($languages)&4294967295); //@line 358 "voices.cpp"
      var $24=$langix; //@line 358 "voices.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $arraydecay66;
      $dest$ = $23;
      $stop$ = $src$ + $24;
      if (($dest$%4) == ($src$%4) && $24 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 358 "voices.cpp"
      var $25=$p; //@line 359 "voices.cpp"
      var $26=$voice_data; //@line 359 "voices.cpp"
      var $languages67=(($26+4)&4294967295); //@line 359 "voices.cpp"
      HEAP32[(($languages67)>>2)]=$25; //@line 359 "voices.cpp"
      var $27=$langix; //@line 361 "voices.cpp"
      var $28=$p; //@line 361 "voices.cpp"
      var $arrayidx68=(($28+$27)&4294967295); //@line 361 "voices.cpp"
      var $29=$fname_addr; //@line 361 "voices.cpp"
      var $call69=_strcpy($arrayidx68, $29); //@line 361 "voices.cpp"
      var $30=$langix; //@line 362 "voices.cpp"
      var $31=$p; //@line 362 "voices.cpp"
      var $arrayidx70=(($31+$30)&4294967295); //@line 362 "voices.cpp"
      var $32=$voice_data; //@line 362 "voices.cpp"
      var $identifier=(($32+8)&4294967295); //@line 362 "voices.cpp"
      HEAP32[(($identifier)>>2)]=$arrayidx70; //@line 362 "voices.cpp"
      var $33=$langix; //@line 363 "voices.cpp"
      var $34=$p; //@line 363 "voices.cpp"
      var $arrayidx71=(($34+$33)&4294967295); //@line 363 "voices.cpp"
      var $35=$voice_data; //@line 363 "voices.cpp"
      var $name=(($35)&4294967295); //@line 363 "voices.cpp"
      HEAP32[(($name)>>2)]=$arrayidx71; //@line 363 "voices.cpp"
      var $arrayidx72=(($vname)&4294967295); //@line 365 "voices.cpp"
      var $36=HEAP8[($arrayidx72)]; //@line 365 "voices.cpp"
      var $conv73=(tempInt=(($36)),(tempInt>=128?tempInt-256:tempInt)); //@line 365 "voices.cpp"
      var $cmp74=((($conv73))|0)!=0; //@line 365 "voices.cpp"
      if ($cmp74) { __label__ = 17;; } else { __label__ = 18;; } //@line 365 "voices.cpp"
      if (__label__ == 17) {
  
        var $37=$fname_addr; //@line 367 "voices.cpp"
        var $call76=_strlen($37); //@line 367 "voices.cpp"
        var $38=$langix; //@line 367 "voices.cpp"
        var $add77=((($call76)+1)&4294967295); //@line 367 "voices.cpp"
        var $add78=((($add77)+($38))&4294967295); //@line 367 "voices.cpp"
        $langix=$add78; //@line 367 "voices.cpp"
        var $39=$langix; //@line 368 "voices.cpp"
        var $40=$p; //@line 368 "voices.cpp"
        var $arrayidx79=(($40+$39)&4294967295); //@line 368 "voices.cpp"
        var $arraydecay80=(($vname)&4294967295); //@line 368 "voices.cpp"
        var $call81=_strcpy($arrayidx79, $arraydecay80); //@line 368 "voices.cpp"
        var $41=$langix; //@line 369 "voices.cpp"
        var $42=$p; //@line 369 "voices.cpp"
        var $arrayidx82=(($42+$41)&4294967295); //@line 369 "voices.cpp"
        var $43=$voice_data; //@line 369 "voices.cpp"
        var $name83=(($43)&4294967295); //@line 369 "voices.cpp"
        HEAP32[(($name83)>>2)]=$arrayidx82; //@line 369 "voices.cpp"
        ; //@line 370 "voices.cpp"
      }
  
      var $44=HEAP32[(($age)>>2)]; //@line 372 "voices.cpp"
      var $conv85=((($44)) & 255); //@line 372 "voices.cpp"
      var $45=$voice_data; //@line 372 "voices.cpp"
      var $age86=(($45+13)&4294967295); //@line 372 "voices.cpp"
      HEAP8[($age86)]=$conv85; //@line 372 "voices.cpp"
      var $46=$gender; //@line 373 "voices.cpp"
      var $conv87=((($46)) & 255); //@line 373 "voices.cpp"
      var $47=$voice_data; //@line 373 "voices.cpp"
      var $gender88=(($47+12)&4294967295); //@line 373 "voices.cpp"
      HEAP8[($gender88)]=$conv87; //@line 373 "voices.cpp"
      var $48=$voice_data; //@line 374 "voices.cpp"
      var $variant=(($48+14)&4294967295); //@line 374 "voices.cpp"
      HEAP8[($variant)]=0; //@line 374 "voices.cpp"
      var $49=HEAP32[(($n_variants)>>2)]; //@line 375 "voices.cpp"
      var $conv89=((($49)) & 255); //@line 375 "voices.cpp"
      var $50=$voice_data; //@line 375 "voices.cpp"
      var $xx1=(($50+15)&4294967295); //@line 375 "voices.cpp"
      HEAP8[($xx1)]=$conv89; //@line 375 "voices.cpp"
      var $51=$voice_data; //@line 376 "voices.cpp"
      $retval=$51; //@line 376 "voices.cpp"
      ; //@line 376 "voices.cpp"
    }
  
    var $52=$retval; //@line 377 "voices.cpp"
    STACKTOP = __stackBase__;
    return $52; //@line 377 "voices.cpp"
    return null;
  }
  

  function __ZL10ScoreVoiceP12espeak_VOICEPKciiS0_($voice_spec, $spec_language, $spec_n_parts, $spec_lang_len, $voice) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $voice_spec_addr;
    var $spec_language_addr;
    var $spec_n_parts_addr;
    var $spec_lang_len_addr;
    var $voice_addr;
    var $ix;
    var $p;
    var $c1;
    var $c2;
    var $language_priority;
    var $n_parts;
    var $matching;
    var $matching_parts;
    var $score;
    var $x;
    var $ratio;
    var $required_age;
    var $diff;
    $voice_spec_addr=$voice_spec;
    $spec_language_addr=$spec_language;
    $spec_n_parts_addr=$spec_n_parts;
    $spec_lang_len_addr=$spec_lang_len;
    $voice_addr=$voice;
    $score=0; //@line 1136 "voices.cpp"
    var $0=$voice_addr; //@line 1142 "voices.cpp"
    var $languages=(($0+4)&4294967295); //@line 1142 "voices.cpp"
    var $1=HEAP32[(($languages)>>2)]; //@line 1142 "voices.cpp"
    $p=$1; //@line 1142 "voices.cpp"
    var $2=$spec_language_addr; //@line 1144 "voices.cpp"
    var $call=_strcmp($2, ((__str33683)&4294967295)); //@line 1144 "voices.cpp"
    var $cmp=((($call))|0)==0; //@line 1144 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 4;; } //@line 1144 "voices.cpp"
    $if_then$$if_end4$2: do { 
      if (__label__ == 1) {
  
        var $3=$voice_addr; //@line 1147 "voices.cpp"
        var $identifier=(($3+8)&4294967295); //@line 1147 "voices.cpp"
        var $4=HEAP32[(($identifier)>>2)]; //@line 1147 "voices.cpp"
        var $call1=_memcmp($4, ((__str73725)&4294967295), 3); //@line 1147 "voices.cpp"
        var $cmp2=((($call1))|0)==0; //@line 1147 "voices.cpp"
        if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 1147 "voices.cpp"
        if (__label__ == 2) {
  
          $retval=100; //@line 1148 "voices.cpp"
          ; //@line 1148 "voices.cpp"
        }
        else if (__label__ == 3) {
  
          $retval=0; //@line 1149 "voices.cpp"
          ; //@line 1149 "voices.cpp"
        }
      }
      else if (__label__ == 4) {
  
        var $5=$spec_n_parts_addr; //@line 1152 "voices.cpp"
        var $cmp5=((($5))|0)==0; //@line 1152 "voices.cpp"
        if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 1152 "voices.cpp"
        $if_end60_thread$$if_else$8: do { 
          if (__label__ == 5) {
  
            $score=100; //@line 1154 "voices.cpp"
            ; //@line 1215 "voices.cpp"
          }
          else if (__label__ == 6) {
  
            var $6=$p; //@line 1158 "voices.cpp"
            var $7=HEAP8[($6)]; //@line 1158 "voices.cpp"
            var $conv=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 1158 "voices.cpp"
            var $cmp7=((($conv))|0)==0; //@line 1158 "voices.cpp"
            if ($cmp7) { __label__ = 7;; } else { __label__ = 9;; } //@line 1158 "voices.cpp"
            $land_lhs_true$$while_cond_preheader$11: do { 
              if (__label__ == 7) {
  
                var $8=$spec_language_addr; //@line 1158 "voices.cpp"
                var $call8=_strcmp($8, ((__str75727)&4294967295)); //@line 1158 "voices.cpp"
                var $cmp9=((($call8))|0)==0; //@line 1158 "voices.cpp"
                if (!($cmp9)) { __label__ = 9;break $land_lhs_true$$while_cond_preheader$11; } //@line 1158 "voices.cpp"
  
                $score=100; //@line 1161 "voices.cpp"
                ; //@line 1162 "voices.cpp"
              }
            } while(0);
  
            var $9=$p; //@line 1165 "voices.cpp"
            var $10=HEAP8[($9)]; //@line 1165 "voices.cpp"
            var $conv123=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1165 "voices.cpp"
            var $cmp134=((($conv123))|0)!=0; //@line 1165 "voices.cpp"
            if ($cmp134) { __label__ = 10;; } else { __label__ = 31;; } //@line 1165 "voices.cpp"
            $while_body$$if_end60$15: do { 
              if (__label__ == 10) {
                $while_body$16: while(1) { 
  
                  var $11=$p; //@line 1167 "voices.cpp"
                  var $incdec_ptr=(($11+1)&4294967295); //@line 1167 "voices.cpp"
                  $p=$incdec_ptr; //@line 1167 "voices.cpp"
                  var $12=HEAP8[($11)]; //@line 1167 "voices.cpp"
                  var $conv14=(tempInt=(($12)),(tempInt>=128?tempInt-256:tempInt)); //@line 1167 "voices.cpp"
                  $language_priority=$conv14; //@line 1167 "voices.cpp"
                  $matching=1; //@line 1169 "voices.cpp"
                  $matching_parts=0; //@line 1170 "voices.cpp"
                  $n_parts=1; //@line 1171 "voices.cpp"
                  $ix=0; //@line 1173 "voices.cpp"
                  ; //@line 1173 "voices.cpp"
                  $for_cond$18: while(1) { 
  
                    var $13=$ix; //@line 1175 "voices.cpp"
                    var $14=$spec_lang_len_addr; //@line 1175 "voices.cpp"
                    var $cmp15=((($13))|0) >= ((($14))|0); //@line 1175 "voices.cpp"
                    if ($cmp15) { __label__ = 13;; } else { __label__ = 12;; } //@line 1175 "voices.cpp"
                    $if_then18$$lor_lhs_false$20: do { 
                      if (__label__ == 12) {
  
                        var $15=$ix; //@line 1175 "voices.cpp"
                        var $16=$spec_language_addr; //@line 1175 "voices.cpp"
                        var $arrayidx=(($16+$15)&4294967295); //@line 1175 "voices.cpp"
                        var $17=HEAP8[($arrayidx)]; //@line 1175 "voices.cpp"
                        var $conv16=(tempInt=(($17)),(tempInt>=128?tempInt-256:tempInt)); //@line 1175 "voices.cpp"
                        $c1=$conv16; //@line 1175 "voices.cpp"
                        var $cmp17=((($conv16))|0)==45; //@line 1175 "voices.cpp"
                        if ($cmp17) { __label__ = 13;break $if_then18$$lor_lhs_false$20; } else { __label__ = 14;break $if_then18$$lor_lhs_false$20; } //@line 1175 "voices.cpp"
                      }
                    } while(0);
                    if (__label__ == 13) {
  
                      $c1=0; //@line 1176 "voices.cpp"
                      ; //@line 1176 "voices.cpp"
                    }
  
                    var $18=$ix; //@line 1177 "voices.cpp"
                    var $19=$p; //@line 1177 "voices.cpp"
                    var $arrayidx20=(($19+$18)&4294967295); //@line 1177 "voices.cpp"
                    var $20=HEAP8[($arrayidx20)]; //@line 1177 "voices.cpp"
                    var $conv21=(tempInt=(($20)),(tempInt>=128?tempInt-256:tempInt)); //@line 1177 "voices.cpp"
                    $c2=$conv21; //@line 1177 "voices.cpp"
                    var $cmp22=((($conv21))|0)==45; //@line 1177 "voices.cpp"
                    if ($cmp22) { __label__ = 15;; } else { __label__ = 16;; } //@line 1177 "voices.cpp"
                    if (__label__ == 15) {
  
                      $c2=0; //@line 1178 "voices.cpp"
                      ; //@line 1178 "voices.cpp"
                    }
  
                    var $21=$c1; //@line 1180 "voices.cpp"
                    var $22=$c2; //@line 1180 "voices.cpp"
                    var $cmp25=((($21))|0)!=((($22))|0); //@line 1180 "voices.cpp"
                    if ($cmp25) { __label__ = 17;; } else { __label__ = 18;; } //@line 1180 "voices.cpp"
                    if (__label__ == 17) {
  
                      $matching=0; //@line 1182 "voices.cpp"
                      ; //@line 1183 "voices.cpp"
                    }
  
                    var $23=$ix; //@line 1185 "voices.cpp"
                    var $24=$p; //@line 1185 "voices.cpp"
                    var $arrayidx28=(($24+$23)&4294967295); //@line 1185 "voices.cpp"
                    var $25=HEAP8[($arrayidx28)]; //@line 1185 "voices.cpp"
                    var $conv29=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 1185 "voices.cpp"
                    var $cmp30=((($conv29))|0)==45; //@line 1185 "voices.cpp"
                    if ($cmp30) { __label__ = 19;; } else { __label__ = 21;; } //@line 1185 "voices.cpp"
                    $if_then31$$if_end35$31: do { 
                      if (__label__ == 19) {
  
                        var $26=$n_parts; //@line 1187 "voices.cpp"
                        var $inc=((($26)+1)&4294967295); //@line 1187 "voices.cpp"
                        $n_parts=$inc; //@line 1187 "voices.cpp"
                        var $27=$matching; //@line 1188 "voices.cpp"
                        var $tobool=((($27))|0)!=0; //@line 1188 "voices.cpp"
                        if (!($tobool)) { __label__ = 21;break $if_then31$$if_end35$31; } //@line 1188 "voices.cpp"
  
                        var $28=$matching_parts; //@line 1189 "voices.cpp"
                        var $inc33=((($28)+1)&4294967295); //@line 1189 "voices.cpp"
                        $matching_parts=$inc33; //@line 1189 "voices.cpp"
                        ; //@line 1189 "voices.cpp"
                      }
                    } while(0);
  
                    var $29=$ix; //@line 1191 "voices.cpp"
                    var $30=$p; //@line 1191 "voices.cpp"
                    var $arrayidx36=(($30+$29)&4294967295); //@line 1191 "voices.cpp"
                    var $31=HEAP8[($arrayidx36)]; //@line 1191 "voices.cpp"
                    var $conv37=(tempInt=(($31)),(tempInt>=128?tempInt-256:tempInt)); //@line 1191 "voices.cpp"
                    var $cmp38=((($conv37))|0)==0; //@line 1191 "voices.cpp"
                    var $32=$ix; //@line 1194 "voices.cpp"
                    var $add=((($32)+1)&4294967295); //@line 1194 "voices.cpp"
                    if ($cmp38) { __label__ = 23;break $for_cond$18; } //@line 1191 "voices.cpp"
  
                    $ix=$add; //@line 1173 "voices.cpp"
                    __label__ = 11;continue $for_cond$18; //@line 1173 "voices.cpp"
                  }
  
                  var $33=$p; //@line 1194 "voices.cpp"
                  var $add_ptr=(($33+$add)&4294967295); //@line 1194 "voices.cpp"
                  $p=$add_ptr; //@line 1194 "voices.cpp"
                  var $34=$matching; //@line 1195 "voices.cpp"
                  var $35=$matching_parts; //@line 1195 "voices.cpp"
                  var $add42=((($35)+($34))&4294967295); //@line 1195 "voices.cpp"
                  $matching_parts=$add42; //@line 1195 "voices.cpp"
                  var $36=$matching_parts; //@line 1197 "voices.cpp"
                  var $cmp43=((($36))|0)==0; //@line 1197 "voices.cpp"
                  if ($cmp43) { __label__ = 24;; } else { __label__ = 25;; } //@line 1197 "voices.cpp"
                  $while_cond_backedge$$if_end45$37: do { 
                    if (__label__ == 25) {
  
                      $x=5; //@line 1200 "voices.cpp"
                      var $39=$spec_n_parts_addr; //@line 1202 "voices.cpp"
                      var $40=$matching_parts; //@line 1202 "voices.cpp"
                      var $sub=((($39)-($40))&4294967295); //@line 1202 "voices.cpp"
                      $diff=$sub; //@line 1202 "voices.cpp"
                      var $cmp46=((($sub))|0) > 0; //@line 1202 "voices.cpp"
                      if ($cmp46) { __label__ = 26;; } else { __label__ = 27;; } //@line 1202 "voices.cpp"
                      if (__label__ == 26) {
  
                        var $41=$diff; //@line 1203 "voices.cpp"
                        var $42=$x; //@line 1203 "voices.cpp"
                        var $sub48=((($42)-($41))&4294967295); //@line 1203 "voices.cpp"
                        $x=$sub48; //@line 1203 "voices.cpp"
                        ; //@line 1203 "voices.cpp"
                      }
  
                      var $43=$n_parts; //@line 1206 "voices.cpp"
                      var $44=$matching_parts; //@line 1206 "voices.cpp"
                      var $sub50=((($43)-($44))&4294967295); //@line 1206 "voices.cpp"
                      $diff=$sub50; //@line 1206 "voices.cpp"
                      var $cmp51=((($sub50))|0) > 0; //@line 1206 "voices.cpp"
                      if ($cmp51) { __label__ = 28;; } else { __label__ = 29;; } //@line 1206 "voices.cpp"
                      if (__label__ == 28) {
  
                        var $45=$diff; //@line 1207 "voices.cpp"
                        var $46=$x; //@line 1207 "voices.cpp"
                        var $sub53=((($46)-($45))&4294967295); //@line 1207 "voices.cpp"
                        $x=$sub53; //@line 1207 "voices.cpp"
                        ; //@line 1207 "voices.cpp"
                      }
  
                      var $47=$x; //@line 1209 "voices.cpp"
                      var $mul=((($47)*100)&4294967295); //@line 1209 "voices.cpp"
                      var $48=$language_priority; //@line 1209 "voices.cpp"
                      var $mul55=((($48)*2)&4294967295); //@line 1209 "voices.cpp"
                      var $sub56=((($mul)-($mul55))&4294967295); //@line 1209 "voices.cpp"
                      $x=$sub56; //@line 1209 "voices.cpp"
                      var $49=$x; //@line 1211 "voices.cpp"
                      var $50=$score; //@line 1211 "voices.cpp"
                      var $cmp57=((($49))|0) > ((($50))|0); //@line 1211 "voices.cpp"
                      if (!($cmp57)) { __label__ = 24;break $while_cond_backedge$$if_end45$37; } //@line 1211 "voices.cpp"
  
                      var $51=$x; //@line 1212 "voices.cpp"
                      $score=$51; //@line 1212 "voices.cpp"
                      ; //@line 1212 "voices.cpp"
                    }
                  } while(0);
  
                  var $37=$p; //@line 1165 "voices.cpp"
                  var $38=HEAP8[($37)]; //@line 1165 "voices.cpp"
                  var $conv12=(tempInt=(($38)),(tempInt>=128?tempInt-256:tempInt)); //@line 1165 "voices.cpp"
                  var $cmp13=((($conv12))|0)!=0; //@line 1165 "voices.cpp"
                  if ($cmp13) { __label__ = 10;continue $while_body$16; } else { __label__ = 31;break $while_body$$if_end60$15; } //@line 1165 "voices.cpp"
                }
              }
            } while(0);
  
            var $_pr=$score; //@line 1215 "voices.cpp"
            var $cmp61=((($_pr))|0)==0; //@line 1215 "voices.cpp"
            if (!($cmp61)) { __label__ = 33;break $if_end60_thread$$if_else$8; } //@line 1215 "voices.cpp"
  
            $retval=0; //@line 1216 "voices.cpp"
            __label__ = 63;break $if_then$$if_end4$2; //@line 1216 "voices.cpp"
          }
        } while(0);
  
        var $52=$voice_spec_addr; //@line 1218 "voices.cpp"
        var $name=(($52)&4294967295); //@line 1218 "voices.cpp"
        var $53=HEAP32[(($name)>>2)]; //@line 1218 "voices.cpp"
        var $cmp64=((($53))|0)!=0; //@line 1218 "voices.cpp"
        if ($cmp64) { __label__ = 34;; } else { __label__ = 38;; } //@line 1218 "voices.cpp"
        $if_then65$$if_end81$50: do { 
          if (__label__ == 34) {
  
            var $54=$voice_spec_addr; //@line 1220 "voices.cpp"
            var $name66=(($54)&4294967295); //@line 1220 "voices.cpp"
            var $55=HEAP32[(($name66)>>2)]; //@line 1220 "voices.cpp"
            var $56=$voice_addr; //@line 1220 "voices.cpp"
            var $name67=(($56)&4294967295); //@line 1220 "voices.cpp"
            var $57=HEAP32[(($name67)>>2)]; //@line 1220 "voices.cpp"
            var $call68=_strcmp($55, $57); //@line 1220 "voices.cpp"
            var $cmp69=((($call68))|0)==0; //@line 1220 "voices.cpp"
            if ($cmp69) { __label__ = 35;; } else { __label__ = 36;; } //@line 1220 "voices.cpp"
            if (__label__ == 35) {
  
              var $58=$score; //@line 1223 "voices.cpp"
              var $add71=((($58)+500)&4294967295); //@line 1223 "voices.cpp"
              $score=$add71; //@line 1223 "voices.cpp"
              ; //@line 1224 "voices.cpp"
            }
            else if (__label__ == 36) {
  
              var $59=$voice_spec_addr; //@line 1226 "voices.cpp"
              var $name73=(($59)&4294967295); //@line 1226 "voices.cpp"
              var $60=HEAP32[(($name73)>>2)]; //@line 1226 "voices.cpp"
              var $61=$voice_addr; //@line 1226 "voices.cpp"
              var $identifier74=(($61+8)&4294967295); //@line 1226 "voices.cpp"
              var $62=HEAP32[(($identifier74)>>2)]; //@line 1226 "voices.cpp"
              var $call75=_strcmp($60, $62); //@line 1226 "voices.cpp"
              var $cmp76=((($call75))|0)==0; //@line 1226 "voices.cpp"
              if (!($cmp76)) { __label__ = 38;break $if_then65$$if_end81$50; } //@line 1226 "voices.cpp"
  
              var $63=$score; //@line 1228 "voices.cpp"
              var $add78=((($63)+400)&4294967295); //@line 1228 "voices.cpp"
              $score=$add78; //@line 1228 "voices.cpp"
              ; //@line 1229 "voices.cpp"
            }
          }
        } while(0);
  
        var $64=$voice_spec_addr; //@line 1232 "voices.cpp"
        var $gender=(($64+12)&4294967295); //@line 1232 "voices.cpp"
        var $65=HEAPU8[($gender)]; //@line 1232 "voices.cpp"
        var $conv82=((($65))&255); //@line 1232 "voices.cpp"
        var $cmp83=((($conv82))|0)==1; //@line 1232 "voices.cpp"
        if ($cmp83) { __label__ = 40;; } else { __label__ = 39;; } //@line 1232 "voices.cpp"
        $land_lhs_true88$$lor_lhs_false84$57: do { 
          if (__label__ == 39) {
  
            var $66=$voice_spec_addr; //@line 1232 "voices.cpp"
            var $gender85=(($66+12)&4294967295); //@line 1232 "voices.cpp"
            var $67=HEAPU8[($gender85)]; //@line 1232 "voices.cpp"
            var $conv86=((($67))&255); //@line 1232 "voices.cpp"
            var $cmp87=((($conv86))|0)==2; //@line 1232 "voices.cpp"
            if ($cmp87) { __label__ = 40;break $land_lhs_true88$$lor_lhs_false84$57; } else { __label__ = 45;break $land_lhs_true88$$lor_lhs_false84$57; } //@line 1232 "voices.cpp"
          }
        } while(0);
        $land_lhs_true88$$if_end107$59: do { 
          if (__label__ == 40) {
  
            var $68=$voice_addr; //@line 1232 "voices.cpp"
            var $gender89=(($68+12)&4294967295); //@line 1232 "voices.cpp"
            var $69=HEAPU8[($gender89)]; //@line 1232 "voices.cpp"
            var $conv90=((($69))&255); //@line 1232 "voices.cpp"
            var $cmp91=((($conv90))|0)==1; //@line 1232 "voices.cpp"
            if ($cmp91) { __label__ = 42;; } else { __label__ = 41;; } //@line 1232 "voices.cpp"
            if (__label__ == 41) {
  
              var $70=$voice_addr; //@line 1232 "voices.cpp"
              var $gender93=(($70+12)&4294967295); //@line 1232 "voices.cpp"
              var $71=HEAPU8[($gender93)]; //@line 1232 "voices.cpp"
              var $conv94=((($71))&255); //@line 1232 "voices.cpp"
              var $cmp95=((($conv94))|0)==2; //@line 1232 "voices.cpp"
              if (!($cmp95)) { __label__ = 45;break $land_lhs_true88$$if_end107$59; } //@line 1232 "voices.cpp"
            }
  
            var $72=$voice_spec_addr; //@line 1235 "voices.cpp"
            var $gender97=(($72+12)&4294967295); //@line 1235 "voices.cpp"
            var $73=HEAPU8[($gender97)]; //@line 1235 "voices.cpp"
            var $conv98=((($73))&255); //@line 1235 "voices.cpp"
            var $74=$voice_addr; //@line 1235 "voices.cpp"
            var $gender99=(($74+12)&4294967295); //@line 1235 "voices.cpp"
            var $75=HEAPU8[($gender99)]; //@line 1235 "voices.cpp"
            var $conv100=((($75))&255); //@line 1235 "voices.cpp"
            var $cmp101=((($conv98))|0)==((($conv100))|0); //@line 1235 "voices.cpp"
            var $76=$score; //@line 1236 "voices.cpp"
            if ($cmp101) { __label__ = 43;; } else { __label__ = 44;; } //@line 1235 "voices.cpp"
            if (__label__ == 43) {
  
              var $add103=((($76)+50)&4294967295); //@line 1236 "voices.cpp"
              $score=$add103; //@line 1236 "voices.cpp"
              ; //@line 1236 "voices.cpp"
            }
            else if (__label__ == 44) {
  
              var $sub105=((($76)-50)&4294967295); //@line 1238 "voices.cpp"
              $score=$sub105; //@line 1238 "voices.cpp"
              ;
            }
          }
        } while(0);
  
        var $77=$voice_spec_addr; //@line 1241 "voices.cpp"
        var $age=(($77+13)&4294967295); //@line 1241 "voices.cpp"
        var $78=HEAPU8[($age)]; //@line 1241 "voices.cpp"
        var $conv108=((($78))&255); //@line 1241 "voices.cpp"
        var $cmp109=((($conv108))|0) <= 12; //@line 1241 "voices.cpp"
        if ($cmp109) { __label__ = 46;; } else { __label__ = 49;; } //@line 1241 "voices.cpp"
        $land_lhs_true110$$if_end120$68: do { 
          if (__label__ == 46) {
  
            var $79=$voice_addr; //@line 1241 "voices.cpp"
            var $gender111=(($79+12)&4294967295); //@line 1241 "voices.cpp"
            var $80=HEAPU8[($gender111)]; //@line 1241 "voices.cpp"
            var $conv112=((($80))&255); //@line 1241 "voices.cpp"
            var $cmp113=((($conv112))|0)==2; //@line 1241 "voices.cpp"
            if (!($cmp113)) { __label__ = 49;break $land_lhs_true110$$if_end120$68; } //@line 1241 "voices.cpp"
  
            var $81=$voice_addr; //@line 1241 "voices.cpp"
            var $age115=(($81+13)&4294967295); //@line 1241 "voices.cpp"
            var $82=HEAPU8[($age115)]; //@line 1241 "voices.cpp"
            var $conv116=((($82))&255); //@line 1241 "voices.cpp"
            var $cmp117=((($conv116))|0) > 12; //@line 1241 "voices.cpp"
            if (!($cmp117)) { __label__ = 49;break $land_lhs_true110$$if_end120$68; } //@line 1241 "voices.cpp"
  
            var $83=$score; //@line 1243 "voices.cpp"
            var $add119=((($83)+5)&4294967295); //@line 1243 "voices.cpp"
            $score=$add119; //@line 1243 "voices.cpp"
            ; //@line 1244 "voices.cpp"
          }
        } while(0);
  
        var $84=$voice_addr; //@line 1246 "voices.cpp"
        var $age121=(($84+13)&4294967295); //@line 1246 "voices.cpp"
        var $85=HEAPU8[($age121)]; //@line 1246 "voices.cpp"
        var $conv122=((($85))&255); //@line 1246 "voices.cpp"
        var $cmp123=((($conv122))|0)!=0; //@line 1246 "voices.cpp"
        if ($cmp123) { __label__ = 50;; } else { __label__ = 59;; } //@line 1246 "voices.cpp"
        $if_then124$$if_end153thread_pre_split$73: do { 
          if (__label__ == 50) {
  
            var $86=$voice_spec_addr; //@line 1248 "voices.cpp"
            var $age125=(($86+13)&4294967295); //@line 1248 "voices.cpp"
            var $87=HEAPU8[($age125)]; //@line 1248 "voices.cpp"
            var $conv126=((($87))&255); //@line 1248 "voices.cpp"
            var $cmp127=((($conv126))|0)==0; //@line 1248 "voices.cpp"
            if ($cmp127) { __label__ = 51;; } else { __label__ = 52;; } //@line 1248 "voices.cpp"
            if (__label__ == 51) {
  
              $required_age=30; //@line 1249 "voices.cpp"
              ; //@line 1249 "voices.cpp"
            }
            else if (__label__ == 52) {
  
              var $88=$voice_spec_addr; //@line 1251 "voices.cpp"
              var $age130=(($88+13)&4294967295); //@line 1251 "voices.cpp"
              var $89=HEAPU8[($age130)]; //@line 1251 "voices.cpp"
              var $conv131=((($89))&255); //@line 1251 "voices.cpp"
              $required_age=$conv131; //@line 1251 "voices.cpp"
              ;
            }
  
            var $90=$required_age; //@line 1253 "voices.cpp"
            var $mul133=((($90)*100)&4294967295); //@line 1253 "voices.cpp"
            var $91=$voice_addr; //@line 1253 "voices.cpp"
            var $age134=(($91+13)&4294967295); //@line 1253 "voices.cpp"
            var $92=HEAPU8[($age134)]; //@line 1253 "voices.cpp"
            var $conv135=((($92))&255); //@line 1253 "voices.cpp"
            var $div=((((($mul133))|0)/((($conv135))|0))|0); //@line 1253 "voices.cpp"
            $ratio=$div; //@line 1253 "voices.cpp"
            var $cmp136=((($div))|0) < 100; //@line 1254 "voices.cpp"
            if ($cmp136) { __label__ = 54;; } else { __label__ = 55;; } //@line 1254 "voices.cpp"
            if (__label__ == 54) {
  
              var $93=$ratio; //@line 1255 "voices.cpp"
              var $div138=((10000/((($93))|0))|0); //@line 1255 "voices.cpp"
              $ratio=$div138; //@line 1255 "voices.cpp"
              ; //@line 1255 "voices.cpp"
            }
  
            var $94=$ratio; //@line 1256 "voices.cpp"
            var $sub140=((($94)-100)&4294967295); //@line 1256 "voices.cpp"
            var $div141=((((($sub140))|0)/10)|0); //@line 1256 "voices.cpp"
            $ratio=$div141; //@line 1256 "voices.cpp"
            var $95=$ratio; //@line 1257 "voices.cpp"
            var $sub142=((5-($95))&4294967295); //@line 1257 "voices.cpp"
            $x=$sub142; //@line 1257 "voices.cpp"
            var $cmp143=((($sub142))|0) > 0; //@line 1258 "voices.cpp"
            if ($cmp143) { __label__ = 56;; } else { __label__ = 57;; } //@line 1258 "voices.cpp"
            if (__label__ == 56) {
  
              $x=0; //@line 1258 "voices.cpp"
              ; //@line 1258 "voices.cpp"
            }
  
            var $96=$score; //@line 1260 "voices.cpp"
            var $97=$x; //@line 1260 "voices.cpp"
            var $add146=((($97)+($96))&4294967295); //@line 1260 "voices.cpp"
            $score=$add146; //@line 1260 "voices.cpp"
            var $98=$voice_spec_addr; //@line 1262 "voices.cpp"
            var $age147=(($98+13)&4294967295); //@line 1262 "voices.cpp"
            var $99=HEAPU8[($age147)]; //@line 1262 "voices.cpp"
            var $conv148=((($99))&255); //@line 1262 "voices.cpp"
            var $cmp149=((($conv148))|0) > 0; //@line 1262 "voices.cpp"
            if (!($cmp149)) { __label__ = 59;break $if_then124$$if_end153thread_pre_split$73; } //@line 1262 "voices.cpp"
  
            var $100=$score; //@line 1263 "voices.cpp"
            var $add151=((($100)+10)&4294967295); //@line 1263 "voices.cpp"
            $score=$add151; //@line 1263 "voices.cpp"
            __lastLabel__ = 58; __label__ = 60;break $if_then124$$if_end153thread_pre_split$73; //@line 1263 "voices.cpp"
          }
        } while(0);
        if (__label__ == 59) {
  
          var $_pr2=$score; //@line 1265 "voices.cpp"
          __lastLabel__ = 59; ;
        }
  
        var $101=__lastLabel__ == 59 ? $_pr2 : ($add151); //@line 1265 "voices.cpp"
        var $cmp154=((($101))|0) < 1; //@line 1265 "voices.cpp"
        if ($cmp154) { __label__ = 61;; } else { __label__ = 62;; } //@line 1265 "voices.cpp"
        if (__label__ == 61) {
  
          $score=1; //@line 1266 "voices.cpp"
          ; //@line 1266 "voices.cpp"
        }
  
        var $102=$score; //@line 1267 "voices.cpp"
        $retval=$102; //@line 1267 "voices.cpp"
        ; //@line 1267 "voices.cpp"
      }
    } while(0);
  
    var $103=$retval; //@line 1268 "voices.cpp"
    ;
    return $103; //@line 1268 "voices.cpp"
    return null;
  }
  

  function __ZL16VoiceScoreSorterPKvS0_($p1, $p2) {
    ;
    var __label__;
  
    var $retval;
    var $p1_addr;
    var $p2_addr;
    var $ix;
    var $v1;
    var $v2;
    $p1_addr=$p1;
    $p2_addr=$p2;
    var $0=$p1_addr; //@line 1118 "voices.cpp"
    var $1=$0; //@line 1118 "voices.cpp"
    var $2=HEAP32[(($1)>>2)]; //@line 1118 "voices.cpp"
    $v1=$2; //@line 1118 "voices.cpp"
    var $3=$p2_addr; //@line 1119 "voices.cpp"
    var $4=$3; //@line 1119 "voices.cpp"
    var $5=HEAP32[(($4)>>2)]; //@line 1119 "voices.cpp"
    $v2=$5; //@line 1119 "voices.cpp"
    var $6=$v2; //@line 1121 "voices.cpp"
    var $score=(($6+16)&4294967295); //@line 1121 "voices.cpp"
    var $7=HEAP32[(($score)>>2)]; //@line 1121 "voices.cpp"
    var $8=$v1; //@line 1121 "voices.cpp"
    var $score1=(($8+16)&4294967295); //@line 1121 "voices.cpp"
    var $9=HEAP32[(($score1)>>2)]; //@line 1121 "voices.cpp"
    var $sub=((($7)-($9))&4294967295); //@line 1121 "voices.cpp"
    $ix=$sub; //@line 1121 "voices.cpp"
    var $cmp=((($sub))|0)!=0; //@line 1121 "voices.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1121 "voices.cpp"
    if (__label__ == 1) {
  
      var $10=$ix; //@line 1122 "voices.cpp"
      $retval=$10; //@line 1122 "voices.cpp"
      ; //@line 1122 "voices.cpp"
    }
    else if (__label__ == 2) {
  
      var $11=$v1; //@line 1123 "voices.cpp"
      var $name=(($11)&4294967295); //@line 1123 "voices.cpp"
      var $12=HEAP32[(($name)>>2)]; //@line 1123 "voices.cpp"
      var $13=$v2; //@line 1123 "voices.cpp"
      var $name2=(($13)&4294967295); //@line 1123 "voices.cpp"
      var $14=HEAP32[(($name2)>>2)]; //@line 1123 "voices.cpp"
      var $call=_strcmp($12, $14); //@line 1123 "voices.cpp"
      $retval=$call; //@line 1123 "voices.cpp"
      ; //@line 1123 "voices.cpp"
    }
  
    var $15=$retval; //@line 1124 "voices.cpp"
    ;
    return $15; //@line 1124 "voices.cpp"
    return null;
  }
  

  function __Z9WcmdqStopv() {
    ;
    var __label__;
  
    HEAP32[((_wcmdq_head)>>2)]=0; //@line 287 "wavegen.cpp"
    HEAP32[((_wcmdq_tail)>>2)]=0; //@line 288 "wavegen.cpp"
    var $0=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 289 "wavegen.cpp"
    var $cmp=((($0))|0)!=0; //@line 289 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 289 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 291 "wavegen.cpp"
      _sonicDestroyStream($1); //@line 291 "wavegen.cpp"
      HEAP32[((__ZL18sonicSpeedupStream)>>2)]=0; //@line 292 "wavegen.cpp"
      ; //@line 293 "wavegen.cpp"
    }
  
    var $2=HEAP8[(((_mbrola_name)&4294967295))]; //@line 297 "wavegen.cpp"
    var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 297 "wavegen.cpp"
    var $cmp1=((($conv))|0)!=0; //@line 297 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 297 "wavegen.cpp"
    if (__label__ == 3) {
  
      __Z11MbrolaResetv(); //@line 298 "wavegen.cpp"
      ; //@line 298 "wavegen.cpp"
    }
  
    ;
    return; //@line 299 "wavegen.cpp"
    return;
  }
  

  function __Z9WcmdqFreev() {
    ;
    var __label__;
  
    var $i;
    var $0=HEAP32[((_wcmdq_head)>>2)]; //@line 305 "wavegen.cpp"
    var $1=HEAP32[((_wcmdq_tail)>>2)]; //@line 305 "wavegen.cpp"
    var $sub=((($0)-($1))&4294967295); //@line 305 "wavegen.cpp"
    $i=$sub; //@line 305 "wavegen.cpp"
    var $2=$i; //@line 306 "wavegen.cpp"
    var $cmp=((($2))|0) <= 0; //@line 306 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 306 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $3=$i; //@line 306 "wavegen.cpp"
      var $add=((($3)+160)&4294967295); //@line 306 "wavegen.cpp"
      $i=$add; //@line 306 "wavegen.cpp"
      ; //@line 306 "wavegen.cpp"
    }
  
    var $4=$i; //@line 307 "wavegen.cpp"
    ;
    return $4; //@line 307 "wavegen.cpp"
    return null;
  }
  

  function __Z9WcmdqUsedv() {
    ;
    var __label__;
  
    var $call=__Z9WcmdqFreev(); //@line 312 "wavegen.cpp"
    var $sub=((160-($call))&4294967295); //@line 312 "wavegen.cpp"
    ;
    return $sub; //@line 312 "wavegen.cpp"
    return null;
  }
  

  function __Z8WcmdqIncv() {
    ;
    var __label__;
  
    var $0=HEAP32[((_wcmdq_tail)>>2)]; //@line 318 "wavegen.cpp"
    var $inc=((($0)+1)&4294967295); //@line 318 "wavegen.cpp"
    HEAP32[((_wcmdq_tail)>>2)]=$inc; //@line 318 "wavegen.cpp"
    var $cmp=((($inc))|0) >= 160; //@line 319 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 319 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_wcmdq_tail)>>2)]=0; //@line 319 "wavegen.cpp"
      ; //@line 319 "wavegen.cpp"
    }
  
    ;
    return; //@line 320 "wavegen.cpp"
    return;
  }
  

  function __Z16WavegenOpenSoundv() {
    ;
    var __label__;
  
    ;
    return 0; //@line 715 "wavegen.cpp"
    return null;
  }
  

  function __Z17WavegenCloseSoundv() {
    ;
    var __label__;
  
    ;
    return 0; //@line 719 "wavegen.cpp"
    return null;
  }
  

  function __Z16WavegenInitSoundv() {
    ;
    var __label__;
  
    ;
    return 0; //@line 723 "wavegen.cpp"
    return null;
  }
  

  function __Z11WavegenInitii($rate, $wavemult_fact) {
    ;
    var __label__;
  
    var $rate_addr;
    var $wavemult_fact_addr;
    var $ix;
    var $x;
    $rate_addr=$rate;
    $wavemult_fact_addr=$wavemult_fact;
    var $0=$wavemult_fact_addr; //@line 733 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 733 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 733 "wavegen.cpp"
    if (__label__ == 1) {
  
      $wavemult_fact_addr=60; //@line 734 "wavegen.cpp"
      ; //@line 734 "wavegen.cpp"
    }
  
    HEAP32[((_wvoice)>>2)]=0; //@line 736 "wavegen.cpp"
    var $1=$rate_addr; //@line 737 "wavegen.cpp"
    HEAP32[((_samplerate_native)>>2)]=$1; //@line 737 "wavegen.cpp"
    HEAP32[((_samplerate)>>2)]=$1; //@line 737 "wavegen.cpp"
    var $2=HEAP32[((_samplerate)>>2)]; //@line 738 "wavegen.cpp"
    var $div=((134217728/((($2))|0))|0); //@line 738 "wavegen.cpp"
    HEAP32[((__ZL16PHASE_INC_FACTOR)>>2)]=$div; //@line 738 "wavegen.cpp"
    var $3=HEAP32[((_samplerate)>>2)]; //@line 739 "wavegen.cpp"
    var $mul=((($3)*64)&4294967295); //@line 739 "wavegen.cpp"
    var $4=$rate_addr; //@line 739 "wavegen.cpp"
    var $div1=((((($mul))|0)/((($4))|0))|0); //@line 739 "wavegen.cpp"
    HEAP32[((__ZL11Flutter_inc)>>2)]=$div1; //@line 739 "wavegen.cpp"
    HEAP32[((__ZL11samplecount)>>2)]=0; //@line 740 "wavegen.cpp"
    HEAP32[((__ZL8nsamples)>>2)]=0; //@line 741 "wavegen.cpp"
    HEAP32[((__ZL9wavephase)>>2)]=2147483647; //@line 742 "wavegen.cpp"
    HEAP32[((((_wdata+52)&4294967295))>>2)]=32; //@line 745 "wavegen.cpp"
    HEAP32[((((_wdata+60)&4294967295))>>2)]=100; //@line 746 "wavegen.cpp"
    $ix=0; //@line 748 "wavegen.cpp"
    ; //@line 748 "wavegen.cpp"
    $for_body$5: while(1) { 
  
      var $5=$ix; //@line 749 "wavegen.cpp"
      var $arrayidx=((_embedded_default+$5*4)&4294967295); //@line 749 "wavegen.cpp"
      var $6=HEAP32[(($arrayidx)>>2)]; //@line 749 "wavegen.cpp"
      var $7=$ix; //@line 749 "wavegen.cpp"
      var $arrayidx3=((_embedded_value+$7*4)&4294967295); //@line 749 "wavegen.cpp"
      HEAP32[(($arrayidx3)>>2)]=$6; //@line 749 "wavegen.cpp"
      var $8=$ix; //@line 748 "wavegen.cpp"
      var $inc=((($8)+1)&4294967295); //@line 748 "wavegen.cpp"
      $ix=$inc; //@line 748 "wavegen.cpp"
      var $cmp2=((($inc))|0) < 15; //@line 748 "wavegen.cpp"
      if ($cmp2) { __label__ = 3;continue $for_body$5; } else { __label__ = 4;break $for_body$5; } //@line 748 "wavegen.cpp"
    }
  
    var $9=HEAP32[((_samplerate)>>2)]; //@line 754 "wavegen.cpp"
    var $10=$wavemult_fact_addr; //@line 754 "wavegen.cpp"
    var $mul4=((($10)*($9))&4294967295); //@line 754 "wavegen.cpp"
    var $div5=((((($mul4))|0)/12800)|0); //@line 754 "wavegen.cpp"
    HEAP32[((__ZL12wavemult_max)>>2)]=$div5; //@line 754 "wavegen.cpp"
    var $11=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 755 "wavegen.cpp"
    var $cmp6=((($11))|0) > 128; //@line 755 "wavegen.cpp"
    if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 755 "wavegen.cpp"
    if (__label__ == 5) {
  
      HEAP32[((__ZL12wavemult_max)>>2)]=128; //@line 755 "wavegen.cpp"
      ; //@line 755 "wavegen.cpp"
    }
  
    var $12=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 757 "wavegen.cpp"
    var $div9=((((($12))|0)/2)|0); //@line 757 "wavegen.cpp"
    HEAP32[((__ZL15wavemult_offset)>>2)]=$div9; //@line 757 "wavegen.cpp"
    var $13=HEAP32[((_samplerate)>>2)]; //@line 759 "wavegen.cpp"
    var $cmp10=((($13))|0)!=22050; //@line 759 "wavegen.cpp"
    if ($cmp10) { __label__ = 7;; } else { __label__ = 9;; } //@line 759 "wavegen.cpp"
    $if_then11$$if_end25$11: do { 
      if (__label__ == 7) {
  
        $ix=0; //@line 763 "wavegen.cpp"
        var $14=$ix; //@line 763 "wavegen.cpp"
        var $15=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 763 "wavegen.cpp"
        var $cmp131=((($14))|0) < ((($15))|0); //@line 763 "wavegen.cpp"
        if (!($cmp131)) { __label__ = 9;break $if_then11$$if_end25$11; } //@line 763 "wavegen.cpp"
        while(1) { 
  
          var $16=$ix; //@line 765 "wavegen.cpp"
          var $conv=((($16))|0); //@line 765 "wavegen.cpp"
          var $mul15=6.283185307*($conv); //@line 765 "wavegen.cpp"
          var $17=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 765 "wavegen.cpp"
          var $conv16=((($17))|0); //@line 765 "wavegen.cpp"
          var $div17=($mul15)/($conv16); //@line 765 "wavegen.cpp"
          var $call=_cos($div17); //@line 765 "wavegen.cpp"
          var $sub=1-($call); //@line 765 "wavegen.cpp"
          var $mul18=127*($sub); //@line 765 "wavegen.cpp"
          $x=$mul18; //@line 765 "wavegen.cpp"
          var $18=$x; //@line 766 "wavegen.cpp"
          var $conv19=((($18))|0); //@line 766 "wavegen.cpp"
          var $conv20=((($conv19)) & 255); //@line 766 "wavegen.cpp"
          var $19=$ix; //@line 766 "wavegen.cpp"
          var $arrayidx21=((__ZL8wavemult+$19)&4294967295); //@line 766 "wavegen.cpp"
          HEAP8[($arrayidx21)]=$conv20; //@line 766 "wavegen.cpp"
          var $20=$ix; //@line 763 "wavegen.cpp"
          var $inc23=((($20)+1)&4294967295); //@line 763 "wavegen.cpp"
          $ix=$inc23; //@line 763 "wavegen.cpp"
          var $21=$ix; //@line 763 "wavegen.cpp"
          var $22=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 763 "wavegen.cpp"
          var $cmp13=((($21))|0) < ((($22))|0); //@line 763 "wavegen.cpp"
          if ($cmp13) { __label__ = 8;continue ; } else { __label__ = 9;break $if_then11$$if_end25$11; } //@line 763 "wavegen.cpp"
        }
      }
    } while(0);
  
    __ZL17WavegenInitPkDatai(1); //@line 770 "wavegen.cpp"
    __ZL17WavegenInitPkDatai(0); //@line 771 "wavegen.cpp"
    HEAP32[((__ZL8pk_shape)>>2)]=((__ZL9pk_shape2)&4294967295); //@line 772 "wavegen.cpp"
    __Z9KlattInitv(); //@line 775 "wavegen.cpp"
    ;
    return; //@line 782 "wavegen.cpp"
    return;
  }
  

  function __ZL17WavegenInitPkDatai($which) {
    ;
    var __label__;
  
    ;
    return; //@line 411 "wavegen.cpp"
    return;
  }
  

  function __Z12GetAmplitudev() {
    ;
    var __label__;
  
    var $amp;
    var $0=HEAP32[((((_embedded_value+12)&4294967295))>>2)]; //@line 792 "wavegen.cpp"
    var $mul=((($0)*55)&4294967295); //@line 792 "wavegen.cpp"
    var $div=((((($mul))|0)/100)|0); //@line 792 "wavegen.cpp"
    $amp=$div; //@line 792 "wavegen.cpp"
    var $1=$amp; //@line 793 "wavegen.cpp"
    var $2=HEAP32[((((_embedded_value+52)&4294967295))>>2)]; //@line 793 "wavegen.cpp"
    var $arrayidx=((__ZZ12GetAmplitudevE12amp_emphasis+$2)&4294967295); //@line 793 "wavegen.cpp"
    var $3=HEAPU8[($arrayidx)]; //@line 793 "wavegen.cpp"
    var $conv=((($3))&255); //@line 793 "wavegen.cpp"
    var $mul1=((($conv)*($1))&4294967295); //@line 793 "wavegen.cpp"
    var $div2=((((($mul1))|0)/16)|0); //@line 793 "wavegen.cpp"
    HEAP32[((__ZL17general_amplitude)>>2)]=$div2; //@line 793 "wavegen.cpp"
    var $4=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 794 "wavegen.cpp"
    ;
    return $4; //@line 794 "wavegen.cpp"
    return null;
  }
  

  function __Z16PeaksToHarmspectP15wavegen_peaks_tiPii($peaks, $pitch, $htab, $control) {
    ;
    var __label__;
  
    var $retval;
    var $peaks_addr;
    var $pitch_addr;
    var $htab_addr;
    var $control_addr;
    var $f;
    var $p;
    var $fp;
    var $fhi;
    var $h;
    var $pk;
    var $hmax;
    var $hmax_samplerate;
    var $x;
    var $ix;
    var $h1;
    var $y;
    var $h2;
    $peaks_addr=$peaks;
    $pitch_addr=$pitch;
    $htab_addr=$htab;
    $control_addr=$control;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 877 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 877 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 877 "wavegen.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 878 "wavegen.cpp"
      ; //@line 878 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=HEAP32[((_wvoice)>>2)]; //@line 879 "wavegen.cpp"
      var $n_harmonic_peaks=(($1+84)&4294967295); //@line 879 "wavegen.cpp"
      var $2=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 879 "wavegen.cpp"
      var $3=$peaks_addr; //@line 879 "wavegen.cpp"
      var $arrayidx=(($3+80*$2)&4294967295); //@line 879 "wavegen.cpp"
      var $freq=(($arrayidx)&4294967295); //@line 879 "wavegen.cpp"
      var $4=HEAP32[(($freq)>>2)]; //@line 879 "wavegen.cpp"
      var $5=HEAP32[((_wvoice)>>2)]; //@line 879 "wavegen.cpp"
      var $n_harmonic_peaks1=(($5+84)&4294967295); //@line 879 "wavegen.cpp"
      var $6=HEAP32[(($n_harmonic_peaks1)>>2)]; //@line 879 "wavegen.cpp"
      var $7=$peaks_addr; //@line 879 "wavegen.cpp"
      var $arrayidx2=(($7+80*$6)&4294967295); //@line 879 "wavegen.cpp"
      var $right=(($arrayidx2+12)&4294967295); //@line 879 "wavegen.cpp"
      var $8=HEAP32[(($right)>>2)]; //@line 879 "wavegen.cpp"
      var $add=((($8)+($4))&4294967295); //@line 879 "wavegen.cpp"
      var $9=$pitch_addr; //@line 879 "wavegen.cpp"
      var $div=((((($add))|0)/((($9))|0))|0); //@line 879 "wavegen.cpp"
      $hmax=$div; //@line 879 "wavegen.cpp"
      var $10=$hmax; //@line 880 "wavegen.cpp"
      var $cmp3=((($10))|0) >= 400; //@line 880 "wavegen.cpp"
      if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 880 "wavegen.cpp"
      if (__label__ == 3) {
  
        $hmax=399; //@line 881 "wavegen.cpp"
        ; //@line 881 "wavegen.cpp"
      }
  
      var $11=HEAP32[((_samplerate)>>2)]; //@line 884 "wavegen.cpp"
      var $mul=((($11)*19)&4294967295); //@line 884 "wavegen.cpp"
      var $div6=((((($mul))|0)/40)|0); //@line 884 "wavegen.cpp"
      var $shl=($div6) << 16; //@line 884 "wavegen.cpp"
      var $12=$pitch_addr; //@line 884 "wavegen.cpp"
      var $div7=((((($shl))|0)/((($12))|0))|0); //@line 884 "wavegen.cpp"
      $hmax_samplerate=$div7; //@line 884 "wavegen.cpp"
      var $13=$hmax; //@line 887 "wavegen.cpp"
      var $14=$hmax_samplerate; //@line 887 "wavegen.cpp"
      var $cmp8=((($13))|0) > ((($14))|0); //@line 887 "wavegen.cpp"
      if ($cmp8) { __label__ = 5;; } else { __label__ = 6;; } //@line 887 "wavegen.cpp"
      if (__label__ == 5) {
  
        var $15=$hmax_samplerate; //@line 888 "wavegen.cpp"
        $hmax=$15; //@line 888 "wavegen.cpp"
        ; //@line 888 "wavegen.cpp"
      }
  
      $h=0; //@line 890 "wavegen.cpp"
      var $16=$h; //@line 890 "wavegen.cpp"
      var $17=$hmax; //@line 890 "wavegen.cpp"
      var $cmp118=((($16))|0) <= ((($17))|0); //@line 890 "wavegen.cpp"
      if ($cmp118) { __label__ = 7;; } else { __label__ = 8;; } //@line 890 "wavegen.cpp"
      $for_body$$for_end$11: do { 
        if (__label__ == 7) {
          while(1) { 
  
            var $18=$h; //@line 891 "wavegen.cpp"
            var $19=$htab_addr; //@line 891 "wavegen.cpp"
            var $arrayidx12=(($19+4*$18)&4294967295); //@line 891 "wavegen.cpp"
            HEAP32[(($arrayidx12)>>2)]=0; //@line 891 "wavegen.cpp"
            var $20=$h; //@line 890 "wavegen.cpp"
            var $inc=((($20)+1)&4294967295); //@line 890 "wavegen.cpp"
            $h=$inc; //@line 890 "wavegen.cpp"
            var $21=$h; //@line 890 "wavegen.cpp"
            var $22=$hmax; //@line 890 "wavegen.cpp"
            var $cmp11=((($21))|0) <= ((($22))|0); //@line 890 "wavegen.cpp"
            if ($cmp11) { __label__ = 7;continue ; } else { __label__ = 8;break $for_body$$for_end$11; } //@line 890 "wavegen.cpp"
          }
        }
      } while(0);
  
      $h=0; //@line 893 "wavegen.cpp"
      $pk=0; //@line 894 "wavegen.cpp"
      var $23=$pk; //@line 894 "wavegen.cpp"
      var $24=HEAP32[((_wvoice)>>2)]; //@line 894 "wavegen.cpp"
      var $n_harmonic_peaks146=(($24+84)&4294967295); //@line 894 "wavegen.cpp"
      var $25=HEAP32[(($n_harmonic_peaks146)>>2)]; //@line 894 "wavegen.cpp"
      var $cmp157=((($23))|0) <= ((($25))|0); //@line 894 "wavegen.cpp"
      if ($cmp157) { __label__ = 9;; } else { __label__ = 18;; } //@line 894 "wavegen.cpp"
      $for_body16$$for_end67$15: do { 
        if (__label__ == 9) {
          $for_body16$16: while(1) { 
  
            var $26=$pk; //@line 896 "wavegen.cpp"
            var $27=$peaks_addr; //@line 896 "wavegen.cpp"
            var $arrayidx17=(($27+80*$26)&4294967295); //@line 896 "wavegen.cpp"
            $p=$arrayidx17; //@line 896 "wavegen.cpp"
            var $28=$p; //@line 897 "wavegen.cpp"
            var $height=(($28+4)&4294967295); //@line 897 "wavegen.cpp"
            var $29=HEAP32[(($height)>>2)]; //@line 897 "wavegen.cpp"
            var $cmp18=((($29))|0)==0; //@line 897 "wavegen.cpp"
            if ($cmp18) { __label__ = 17;; } else { __label__ = 10;; } //@line 897 "wavegen.cpp"
            $for_inc65$$lor_lhs_false$18: do { 
              if (__label__ == 10) {
  
                var $30=$p; //@line 897 "wavegen.cpp"
                var $freq19=(($30)&4294967295); //@line 897 "wavegen.cpp"
                var $31=HEAP32[(($freq19)>>2)]; //@line 897 "wavegen.cpp"
                $fp=$31; //@line 897 "wavegen.cpp"
                var $cmp20=((($31))|0)==0; //@line 897 "wavegen.cpp"
                if ($cmp20) { __label__ = 17;break $for_inc65$$lor_lhs_false$18; } //@line 897 "wavegen.cpp"
  
                var $32=$p; //@line 900 "wavegen.cpp"
                var $freq23=(($32)&4294967295); //@line 900 "wavegen.cpp"
                var $33=HEAP32[(($freq23)>>2)]; //@line 900 "wavegen.cpp"
                var $34=$p; //@line 900 "wavegen.cpp"
                var $right24=(($34+12)&4294967295); //@line 900 "wavegen.cpp"
                var $35=HEAP32[(($right24)>>2)]; //@line 900 "wavegen.cpp"
                var $add25=((($35)+($33))&4294967295); //@line 900 "wavegen.cpp"
                $fhi=$add25; //@line 900 "wavegen.cpp"
                var $36=$p; //@line 901 "wavegen.cpp"
                var $freq26=(($36)&4294967295); //@line 901 "wavegen.cpp"
                var $37=HEAP32[(($freq26)>>2)]; //@line 901 "wavegen.cpp"
                var $38=$p; //@line 901 "wavegen.cpp"
                var $left=(($38+8)&4294967295); //@line 901 "wavegen.cpp"
                var $39=HEAP32[(($left)>>2)]; //@line 901 "wavegen.cpp"
                var $sub=((($37)-($39))&4294967295); //@line 901 "wavegen.cpp"
                var $40=$pitch_addr; //@line 901 "wavegen.cpp"
                var $div27=((((($sub))|0)/((($40))|0))|0); //@line 901 "wavegen.cpp"
                var $add28=((($div27)+1)&4294967295); //@line 901 "wavegen.cpp"
                $h=$add28; //@line 901 "wavegen.cpp"
                var $41=$h; //@line 902 "wavegen.cpp"
                var $cmp29=((($41))|0) <= 0; //@line 902 "wavegen.cpp"
                if ($cmp29) { __label__ = 12;; } else { __label__ = 13;; } //@line 902 "wavegen.cpp"
                if (__label__ == 12) {
  
                  $h=1; //@line 902 "wavegen.cpp"
                  ; //@line 902 "wavegen.cpp"
                }
  
                var $42=$pitch_addr; //@line 904 "wavegen.cpp"
                var $43=$h; //@line 904 "wavegen.cpp"
                var $mul32=((($43)*($42))&4294967295); //@line 904 "wavegen.cpp"
                $f=$mul32; //@line 904 "wavegen.cpp"
                var $44=$f; //@line 904 "wavegen.cpp"
                var $45=$fp; //@line 904 "wavegen.cpp"
                var $cmp344=((($44))|0) < ((($45))|0); //@line 904 "wavegen.cpp"
                if ($cmp344) { __label__ = 14;; } else { __label__ = 15;; } //@line 904 "wavegen.cpp"
                $for_body35$$for_cond48_loopexit$24: do { 
                  if (__label__ == 14) {
                    while(1) { 
  
                      var $46=$fp; //@line 906 "wavegen.cpp"
                      var $47=$f; //@line 906 "wavegen.cpp"
                      var $sub36=((($46)-($47))&4294967295); //@line 906 "wavegen.cpp"
                      var $48=$p; //@line 906 "wavegen.cpp"
                      var $left37=(($48+8)&4294967295); //@line 906 "wavegen.cpp"
                      var $49=HEAP32[(($left37)>>2)]; //@line 906 "wavegen.cpp"
                      var $shr=($49) >> 8; //@line 906 "wavegen.cpp"
                      var $div38=((((($sub36))|0)/((($shr))|0))|0); //@line 906 "wavegen.cpp"
                      var $50=HEAP32[((__ZL8pk_shape)>>2)]; //@line 906 "wavegen.cpp"
                      var $arrayidx39=(($50+$div38)&4294967295); //@line 906 "wavegen.cpp"
                      var $51=HEAPU8[($arrayidx39)]; //@line 906 "wavegen.cpp"
                      var $conv=((($51))&255); //@line 906 "wavegen.cpp"
                      var $52=$p; //@line 906 "wavegen.cpp"
                      var $height40=(($52+4)&4294967295); //@line 906 "wavegen.cpp"
                      var $53=HEAP32[(($height40)>>2)]; //@line 906 "wavegen.cpp"
                      var $mul41=((($53)*($conv))&4294967295); //@line 906 "wavegen.cpp"
                      var $54=$h; //@line 906 "wavegen.cpp"
                      var $inc42=((($54)+1)&4294967295); //@line 906 "wavegen.cpp"
                      $h=$inc42; //@line 906 "wavegen.cpp"
                      var $55=$htab_addr; //@line 906 "wavegen.cpp"
                      var $arrayidx43=(($55+4*$54)&4294967295); //@line 906 "wavegen.cpp"
                      var $56=HEAP32[(($arrayidx43)>>2)]; //@line 906 "wavegen.cpp"
                      var $add44=((($56)+($mul41))&4294967295); //@line 906 "wavegen.cpp"
                      HEAP32[(($arrayidx43)>>2)]=$add44; //@line 906 "wavegen.cpp"
                      var $57=$pitch_addr; //@line 904 "wavegen.cpp"
                      var $58=$f; //@line 904 "wavegen.cpp"
                      var $add46=((($58)+($57))&4294967295); //@line 904 "wavegen.cpp"
                      $f=$add46; //@line 904 "wavegen.cpp"
                      var $59=$f; //@line 904 "wavegen.cpp"
                      var $60=$fp; //@line 904 "wavegen.cpp"
                      var $cmp34=((($59))|0) < ((($60))|0); //@line 904 "wavegen.cpp"
                      if ($cmp34) { __label__ = 14;continue ; } else { __label__ = 15;break $for_body35$$for_cond48_loopexit$24; } //@line 904 "wavegen.cpp"
                    }
                  }
                } while(0);
  
                var $61=$f; //@line 908 "wavegen.cpp"
                var $62=$fhi; //@line 908 "wavegen.cpp"
                var $cmp495=((($61))|0) < ((($62))|0); //@line 908 "wavegen.cpp"
                if (!($cmp495)) { __label__ = 17;break $for_inc65$$lor_lhs_false$18; } //@line 908 "wavegen.cpp"
                while(1) { 
  
                  var $63=$f; //@line 910 "wavegen.cpp"
                  var $64=$fp; //@line 910 "wavegen.cpp"
                  var $sub51=((($63)-($64))&4294967295); //@line 910 "wavegen.cpp"
                  var $65=$p; //@line 910 "wavegen.cpp"
                  var $right52=(($65+12)&4294967295); //@line 910 "wavegen.cpp"
                  var $66=HEAP32[(($right52)>>2)]; //@line 910 "wavegen.cpp"
                  var $shr53=($66) >> 8; //@line 910 "wavegen.cpp"
                  var $div54=((((($sub51))|0)/((($shr53))|0))|0); //@line 910 "wavegen.cpp"
                  var $67=HEAP32[((__ZL8pk_shape)>>2)]; //@line 910 "wavegen.cpp"
                  var $arrayidx55=(($67+$div54)&4294967295); //@line 910 "wavegen.cpp"
                  var $68=HEAPU8[($arrayidx55)]; //@line 910 "wavegen.cpp"
                  var $conv56=((($68))&255); //@line 910 "wavegen.cpp"
                  var $69=$p; //@line 910 "wavegen.cpp"
                  var $height57=(($69+4)&4294967295); //@line 910 "wavegen.cpp"
                  var $70=HEAP32[(($height57)>>2)]; //@line 910 "wavegen.cpp"
                  var $mul58=((($70)*($conv56))&4294967295); //@line 910 "wavegen.cpp"
                  var $71=$h; //@line 910 "wavegen.cpp"
                  var $inc59=((($71)+1)&4294967295); //@line 910 "wavegen.cpp"
                  $h=$inc59; //@line 910 "wavegen.cpp"
                  var $72=$htab_addr; //@line 910 "wavegen.cpp"
                  var $arrayidx60=(($72+4*$71)&4294967295); //@line 910 "wavegen.cpp"
                  var $73=HEAP32[(($arrayidx60)>>2)]; //@line 910 "wavegen.cpp"
                  var $add61=((($73)+($mul58))&4294967295); //@line 910 "wavegen.cpp"
                  HEAP32[(($arrayidx60)>>2)]=$add61; //@line 910 "wavegen.cpp"
                  var $74=$pitch_addr; //@line 908 "wavegen.cpp"
                  var $75=$f; //@line 908 "wavegen.cpp"
                  var $add63=((($75)+($74))&4294967295); //@line 908 "wavegen.cpp"
                  $f=$add63; //@line 908 "wavegen.cpp"
                  var $76=$f; //@line 908 "wavegen.cpp"
                  var $77=$fhi; //@line 908 "wavegen.cpp"
                  var $cmp49=((($76))|0) < ((($77))|0); //@line 908 "wavegen.cpp"
                  if ($cmp49) { __label__ = 16;continue ; } else { __label__ = 17;break $for_inc65$$lor_lhs_false$18; } //@line 908 "wavegen.cpp"
                }
              }
            } while(0);
  
            var $78=$pk; //@line 894 "wavegen.cpp"
            var $inc66=((($78)+1)&4294967295); //@line 894 "wavegen.cpp"
            $pk=$inc66; //@line 894 "wavegen.cpp"
            var $79=$pk; //@line 894 "wavegen.cpp"
            var $80=HEAP32[((_wvoice)>>2)]; //@line 894 "wavegen.cpp"
            var $n_harmonic_peaks14=(($80+84)&4294967295); //@line 894 "wavegen.cpp"
            var $81=HEAP32[(($n_harmonic_peaks14)>>2)]; //@line 894 "wavegen.cpp"
            var $cmp15=((($79))|0) <= ((($81))|0); //@line 894 "wavegen.cpp"
            if ($cmp15) { __label__ = 9;continue $for_body16$16; } else { __label__ = 18;break $for_body16$$for_end67$15; } //@line 894 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $82=$peaks_addr; //@line 918 "wavegen.cpp"
      var $arrayidx68=(($82+80)&4294967295); //@line 918 "wavegen.cpp"
      var $height69=(($arrayidx68+4)&4294967295); //@line 918 "wavegen.cpp"
      var $83=HEAP32[(($height69)>>2)]; //@line 918 "wavegen.cpp"
      var $mul70=((($83)*10)&4294967295); //@line 918 "wavegen.cpp"
      $y=$mul70; //@line 918 "wavegen.cpp"
      var $84=$pitch_addr; //@line 919 "wavegen.cpp"
      var $div71=((65536000/((($84))|0))|0); //@line 919 "wavegen.cpp"
      $h2=$div71; //@line 919 "wavegen.cpp"
      var $cmp72=((($div71))|0) > 0; //@line 920 "wavegen.cpp"
      if ($cmp72) { __label__ = 19;; } else { __label__ = 21;; } //@line 920 "wavegen.cpp"
      $if_then73$$for_cond81thread_pre_split$32: do { 
        if (__label__ == 19) {
  
          var $85=$y; //@line 922 "wavegen.cpp"
          var $86=$h2; //@line 922 "wavegen.cpp"
          var $div74=((((($85))|0)/((($86))|0))|0); //@line 922 "wavegen.cpp"
          $x=$div74; //@line 922 "wavegen.cpp"
          $h=1; //@line 923 "wavegen.cpp"
          var $cmp753=((($85))|0) > 0; //@line 924 "wavegen.cpp"
          if (!($cmp753)) { __label__ = 21;break $if_then73$$for_cond81thread_pre_split$32; } //@line 924 "wavegen.cpp"
          while(1) { 
  
            var $87=$y; //@line 926 "wavegen.cpp"
            var $88=$h; //@line 926 "wavegen.cpp"
            var $inc76=((($88)+1)&4294967295); //@line 926 "wavegen.cpp"
            $h=$inc76; //@line 926 "wavegen.cpp"
            var $89=$htab_addr; //@line 926 "wavegen.cpp"
            var $arrayidx77=(($89+4*$88)&4294967295); //@line 926 "wavegen.cpp"
            var $90=HEAP32[(($arrayidx77)>>2)]; //@line 926 "wavegen.cpp"
            var $add78=((($90)+($87))&4294967295); //@line 926 "wavegen.cpp"
            HEAP32[(($arrayidx77)>>2)]=$add78; //@line 926 "wavegen.cpp"
            var $91=$x; //@line 927 "wavegen.cpp"
            var $92=$y; //@line 927 "wavegen.cpp"
            var $sub79=((($92)-($91))&4294967295); //@line 927 "wavegen.cpp"
            $y=$sub79; //@line 927 "wavegen.cpp"
            var $cmp75=((($sub79))|0) > 0; //@line 924 "wavegen.cpp"
            if ($cmp75) { __label__ = 20;continue ; } else { __label__ = 21;break $if_then73$$for_cond81thread_pre_split$32; } //@line 924 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $_pr=$pk; //@line 933 "wavegen.cpp"
      var $cmp822=((($_pr))|0) < 9; //@line 933 "wavegen.cpp"
      if ($cmp822) { __label__ = 22;; } else { __label__ = 27;; } //@line 933 "wavegen.cpp"
      $for_body83$$for_end105$37: do { 
        if (__label__ == 22) {
          while(1) { 
  
            var $93=$pk; //@line 935 "wavegen.cpp"
            var $94=$peaks_addr; //@line 935 "wavegen.cpp"
            var $arrayidx84=(($94+80*$93)&4294967295); //@line 935 "wavegen.cpp"
            var $height85=(($arrayidx84+4)&4294967295); //@line 935 "wavegen.cpp"
            var $95=HEAP32[(($height85)>>2)]; //@line 935 "wavegen.cpp"
            var $shr86=($95) >> 14; //@line 935 "wavegen.cpp"
            $x=$shr86; //@line 935 "wavegen.cpp"
            var $96=$x; //@line 936 "wavegen.cpp"
            var $97=$x; //@line 936 "wavegen.cpp"
            var $mul87=((($96)*5)&4294967295); //@line 936 "wavegen.cpp"
            var $mul88=((($mul87)*($97))&4294967295); //@line 936 "wavegen.cpp"
            var $div89=((((($mul88))|0)/2)|0); //@line 936 "wavegen.cpp"
            var $98=$pk; //@line 936 "wavegen.cpp"
            var $arrayidx90=((__ZL11peak_height+$98*4)&4294967295); //@line 936 "wavegen.cpp"
            HEAP32[(($arrayidx90)>>2)]=$div89; //@line 936 "wavegen.cpp"
            var $99=$control_addr; //@line 939 "wavegen.cpp"
            var $cmp91=((($99))|0)==0; //@line 939 "wavegen.cpp"
            if ($cmp91) { __label__ = 23;; } else { __label__ = 24;; } //@line 939 "wavegen.cpp"
            if (__label__ == 23) {
  
              var $100=$pk; //@line 942 "wavegen.cpp"
              var $101=$peaks_addr; //@line 942 "wavegen.cpp"
              var $arrayidx93=(($101+80*$100)&4294967295); //@line 942 "wavegen.cpp"
              var $freq94=(($arrayidx93)&4294967295); //@line 942 "wavegen.cpp"
              var $102=HEAP32[(($freq94)>>2)]; //@line 942 "wavegen.cpp"
              var $103=$pitch_addr; //@line 942 "wavegen.cpp"
              var $div95=((((($102))|0)/((($103))|0))|0); //@line 942 "wavegen.cpp"
              var $104=$pk; //@line 942 "wavegen.cpp"
              var $arrayidx96=((__ZL13peak_harmonic+$104*4)&4294967295); //@line 942 "wavegen.cpp"
              HEAP32[(($arrayidx96)>>2)]=$div95; //@line 942 "wavegen.cpp"
              ; //@line 943 "wavegen.cpp"
            }
  
            var $105=$pk; //@line 945 "wavegen.cpp"
            var $arrayidx98=((__ZL13peak_harmonic+$105*4)&4294967295); //@line 945 "wavegen.cpp"
            var $106=HEAP32[(($arrayidx98)>>2)]; //@line 945 "wavegen.cpp"
            var $107=$hmax_samplerate; //@line 945 "wavegen.cpp"
            var $cmp99=((($106))|0) >= ((($107))|0); //@line 945 "wavegen.cpp"
            if ($cmp99) { __label__ = 25;; } else { __label__ = 26;; } //@line 945 "wavegen.cpp"
            if (__label__ == 25) {
  
              var $108=$pk; //@line 946 "wavegen.cpp"
              var $arrayidx101=((__ZL11peak_height+$108*4)&4294967295); //@line 946 "wavegen.cpp"
              HEAP32[(($arrayidx101)>>2)]=0; //@line 946 "wavegen.cpp"
              ; //@line 946 "wavegen.cpp"
            }
  
            var $109=$pk; //@line 933 "wavegen.cpp"
            var $inc104=((($109)+1)&4294967295); //@line 933 "wavegen.cpp"
            $pk=$inc104; //@line 933 "wavegen.cpp"
            var $cmp82=((($inc104))|0) < 9; //@line 933 "wavegen.cpp"
            if ($cmp82) { __label__ = 22;continue ; } else { __label__ = 27;break $for_body83$$for_end105$37; } //@line 933 "wavegen.cpp"
          }
        }
      } while(0);
  
      $f=0; //@line 950 "wavegen.cpp"
      $h=0; //@line 951 "wavegen.cpp"
      var $110=$h; //@line 951 "wavegen.cpp"
      var $111=$hmax; //@line 951 "wavegen.cpp"
      var $cmp1071=((($110))|0) <= ((($111))|0); //@line 951 "wavegen.cpp"
      if ($cmp1071) { __label__ = 28;; } else { __label__ = 31;; } //@line 951 "wavegen.cpp"
      $for_body108$$for_end127$47: do { 
        if (__label__ == 28) {
          while(1) { 
  
            var $112=$h; //@line 953 "wavegen.cpp"
            var $113=$htab_addr; //@line 953 "wavegen.cpp"
            var $arrayidx109=(($113+4*$112)&4294967295); //@line 953 "wavegen.cpp"
            var $114=HEAP32[(($arrayidx109)>>2)]; //@line 953 "wavegen.cpp"
            var $shr110=($114) >> 15; //@line 953 "wavegen.cpp"
            $x=$shr110; //@line 953 "wavegen.cpp"
            var $115=$x; //@line 954 "wavegen.cpp"
            var $116=$x; //@line 954 "wavegen.cpp"
            var $mul111=((($116)*($115))&4294967295); //@line 954 "wavegen.cpp"
            var $shr112=($mul111) >> 8; //@line 954 "wavegen.cpp"
            var $117=$h; //@line 954 "wavegen.cpp"
            var $118=$htab_addr; //@line 954 "wavegen.cpp"
            var $arrayidx113=(($118+4*$117)&4294967295); //@line 954 "wavegen.cpp"
            HEAP32[(($arrayidx113)>>2)]=$shr112; //@line 954 "wavegen.cpp"
            var $119=$f; //@line 956 "wavegen.cpp"
            var $shr114=($119) >> 19; //@line 956 "wavegen.cpp"
            $ix=$shr114; //@line 956 "wavegen.cpp"
            var $cmp115=((($shr114))|0) < 1000; //@line 956 "wavegen.cpp"
            if ($cmp115) { __label__ = 29;; } else { __label__ = 30;; } //@line 956 "wavegen.cpp"
            if (__label__ == 29) {
  
              var $120=$h; //@line 958 "wavegen.cpp"
              var $121=$htab_addr; //@line 958 "wavegen.cpp"
              var $arrayidx117=(($121+4*$120)&4294967295); //@line 958 "wavegen.cpp"
              var $122=HEAP32[(($arrayidx117)>>2)]; //@line 958 "wavegen.cpp"
              var $123=$ix; //@line 958 "wavegen.cpp"
              var $124=HEAP32[((_wvoice)>>2)]; //@line 958 "wavegen.cpp"
              var $tone_adjust=(($124+344)&4294967295); //@line 958 "wavegen.cpp"
              var $arrayidx118=(($tone_adjust+$123)&4294967295); //@line 958 "wavegen.cpp"
              var $125=HEAPU8[($arrayidx118)]; //@line 958 "wavegen.cpp"
              var $conv119=((($125))&255); //@line 958 "wavegen.cpp"
              var $mul120=((($conv119)*($122))&4294967295); //@line 958 "wavegen.cpp"
              var $shr121=($mul120) >> 13; //@line 958 "wavegen.cpp"
              var $126=$h; //@line 958 "wavegen.cpp"
              var $127=$htab_addr; //@line 958 "wavegen.cpp"
              var $arrayidx122=(($127+4*$126)&4294967295); //@line 958 "wavegen.cpp"
              HEAP32[(($arrayidx122)>>2)]=$shr121; //@line 958 "wavegen.cpp"
              ; //@line 959 "wavegen.cpp"
            }
  
            var $128=$h; //@line 951 "wavegen.cpp"
            var $inc125=((($128)+1)&4294967295); //@line 951 "wavegen.cpp"
            $h=$inc125; //@line 951 "wavegen.cpp"
            var $129=$pitch_addr; //@line 951 "wavegen.cpp"
            var $130=$f; //@line 951 "wavegen.cpp"
            var $add126=((($130)+($129))&4294967295); //@line 951 "wavegen.cpp"
            $f=$add126; //@line 951 "wavegen.cpp"
            var $131=$h; //@line 951 "wavegen.cpp"
            var $132=$hmax; //@line 951 "wavegen.cpp"
            var $cmp107=((($131))|0) <= ((($132))|0); //@line 951 "wavegen.cpp"
            if ($cmp107) { __label__ = 28;continue ; } else { __label__ = 31;break $for_body108$$for_end127$47; } //@line 951 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $133=$htab_addr; //@line 963 "wavegen.cpp"
      var $arrayidx128=(($133+4)&4294967295); //@line 963 "wavegen.cpp"
      var $134=HEAP32[(($arrayidx128)>>2)]; //@line 963 "wavegen.cpp"
      var $_b=HEAPU8[(__ZL16option_harmonic1_b)];
      var $135=($_b) ? 6 : 10;
      var $mul129=((($135)*($134))&4294967295); //@line 963 "wavegen.cpp"
      $h1=$mul129; //@line 963 "wavegen.cpp"
      var $136=$h1; //@line 964 "wavegen.cpp"
      var $div130=((((($136))|0)/8)|0); //@line 964 "wavegen.cpp"
      var $137=$htab_addr; //@line 964 "wavegen.cpp"
      var $arrayidx131=(($137+4)&4294967295); //@line 964 "wavegen.cpp"
      HEAP32[(($arrayidx131)>>2)]=$div130; //@line 964 "wavegen.cpp"
      var $138=$control_addr; //@line 968 "wavegen.cpp"
      var $and=($138) & 1; //@line 968 "wavegen.cpp"
      var $tobool=((($and))|0)!=0; //@line 968 "wavegen.cpp"
      if ($tobool) { __label__ = 32;; } else { __label__ = 34;; } //@line 968 "wavegen.cpp"
      $if_then132$$if_end144$54: do { 
        if (__label__ == 32) {
  
          $h=1; //@line 970 "wavegen.cpp"
          ; //@line 970 "wavegen.cpp"
          while(1) { 
  
            var $139=$h; //@line 972 "wavegen.cpp"
            var $140=$htab_addr; //@line 972 "wavegen.cpp"
            var $arrayidx136=(($140+4*$139)&4294967295); //@line 972 "wavegen.cpp"
            var $141=HEAP32[(($arrayidx136)>>2)]; //@line 972 "wavegen.cpp"
            var $142=$h; //@line 972 "wavegen.cpp"
            var $143=HEAP32[((__ZL9harmspect)>>2)]; //@line 972 "wavegen.cpp"
            var $arrayidx137=(($143+4*$142)&4294967295); //@line 972 "wavegen.cpp"
            var $144=HEAP32[(($arrayidx137)>>2)]; //@line 972 "wavegen.cpp"
            var $sub138=((($141)-($144))&4294967295); //@line 972 "wavegen.cpp"
            var $shr139=($sub138) >> 3; //@line 972 "wavegen.cpp"
            var $145=$h; //@line 972 "wavegen.cpp"
            var $arrayidx140=((__ZL8harm_inc+$145*4)&4294967295); //@line 972 "wavegen.cpp"
            HEAP32[(($arrayidx140)>>2)]=$shr139; //@line 972 "wavegen.cpp"
            var $146=$h; //@line 970 "wavegen.cpp"
            var $inc142=((($146)+1)&4294967295); //@line 970 "wavegen.cpp"
            $h=$inc142; //@line 970 "wavegen.cpp"
            var $cmp134=((($inc142))|0) < 30; //@line 970 "wavegen.cpp"
            if ($cmp134) { __label__ = 33;continue ; } else { __label__ = 34;break $if_then132$$if_end144$54; } //@line 970 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $147=$hmax; //@line 976 "wavegen.cpp"
      $retval=$147; //@line 976 "wavegen.cpp"
      ; //@line 976 "wavegen.cpp"
    }
  
    var $148=$retval; //@line 977 "wavegen.cpp"
    ;
    return $148; //@line 977 "wavegen.cpp"
    return null;
  }
  

  function __Z10InitBreathv() {
    ;
    var __label__;
  
    var $ix;
    var $0=HEAP32[((_samplerate)>>2)]; //@line 1104 "wavegen.cpp"
    var $conv=((($0))|0); //@line 1104 "wavegen.cpp"
    var $div=-3.1415927/($conv); //@line 1104 "wavegen.cpp"
    HEAPF32[((__ZL10minus_pi_t)>>2)]=$div; //@line 1104 "wavegen.cpp"
    var $1=HEAPF32[((__ZL10minus_pi_t)>>2)]; //@line 1105 "wavegen.cpp"
    var $mul=-2*($1); //@line 1105 "wavegen.cpp"
    HEAPF32[((__ZL8two_pi_t)>>2)]=$mul; //@line 1105 "wavegen.cpp"
    $ix=0; //@line 1107 "wavegen.cpp"
    ; //@line 1107 "wavegen.cpp"
    while(1) { 
  
      var $2=$ix; //@line 1109 "wavegen.cpp"
      var $arrayidx=((__ZL7rbreath+$2*40)&4294967295); //@line 1109 "wavegen.cpp"
      __ZL12setresonatorP9RESONATORiii($arrayidx, 2000, 200, 1); //@line 1109 "wavegen.cpp"
      var $3=$ix; //@line 1107 "wavegen.cpp"
      var $inc=((($3)+1)&4294967295); //@line 1107 "wavegen.cpp"
      $ix=$inc; //@line 1107 "wavegen.cpp"
      var $cmp=((($inc))|0) < 9; //@line 1107 "wavegen.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1107 "wavegen.cpp"
    }
  
    ;
    return; //@line 1112 "wavegen.cpp"
    return;
  }
  

  function __ZL12setresonatorP9RESONATORiii($rp, $freq, $bwidth, $init) {
    ;
    var __label__;
  
    var $rp_addr;
    var $freq_addr;
    var $bwidth_addr;
    var $init_addr;
    var $x;
    var $arg;
    $rp_addr=$rp;
    $freq_addr=$freq;
    $bwidth_addr=$bwidth;
    $init_addr=$init;
    var $0=$init_addr; //@line 1075 "wavegen.cpp"
    var $tobool=((($0))|0)!=0; //@line 1075 "wavegen.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1075 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=$rp_addr; //@line 1077 "wavegen.cpp"
      var $x1=(($1+24)&4294967295); //@line 1077 "wavegen.cpp"
      HEAPF32[(($x1)>>2)]=0; //@line 1077 "wavegen.cpp"
      var $2=$rp_addr; //@line 1078 "wavegen.cpp"
      var $x2=(($2+32)&4294967295); //@line 1078 "wavegen.cpp"
      HEAPF32[(($x2)>>2)]=0; //@line 1078 "wavegen.cpp"
      ; //@line 1079 "wavegen.cpp"
    }
  
    var $3=HEAPF32[((__ZL10minus_pi_t)>>2)]; //@line 1082 "wavegen.cpp"
    var $4=$bwidth_addr; //@line 1082 "wavegen.cpp"
    var $conv=((($4))|0); //@line 1082 "wavegen.cpp"
    var $mul=($3)*($conv); //@line 1082 "wavegen.cpp"
    $arg=$mul; //@line 1082 "wavegen.cpp"
    var $5=$arg; //@line 1083 "wavegen.cpp"
    var $call=_exp($5); //@line 1083 "wavegen.cpp"
    $x=$call; //@line 1083 "wavegen.cpp"
    var $6=$x; //@line 1086 "wavegen.cpp"
    var $7=$x; //@line 1086 "wavegen.cpp"
    var $mul1=($6)*($7); //@line 1086 "wavegen.cpp"
    var $sub=(-($mul1)); //@line 1086 "wavegen.cpp"
    var $8=$rp_addr; //@line 1086 "wavegen.cpp"
    var $c=(($8+16)&4294967295); //@line 1086 "wavegen.cpp"
    HEAPF32[(($c)>>2)]=$sub; //@line 1086 "wavegen.cpp"
    var $9=HEAPF32[((__ZL8two_pi_t)>>2)]; //@line 1090 "wavegen.cpp"
    var $10=$freq_addr; //@line 1090 "wavegen.cpp"
    var $conv2=((($10))|0); //@line 1090 "wavegen.cpp"
    var $mul3=($9)*($conv2); //@line 1090 "wavegen.cpp"
    $arg=$mul3; //@line 1090 "wavegen.cpp"
    var $11=$x; //@line 1091 "wavegen.cpp"
    var $12=$arg; //@line 1091 "wavegen.cpp"
    var $call4=_cos($12); //@line 1091 "wavegen.cpp"
    var $mul5=($11)*($call4); //@line 1091 "wavegen.cpp"
    var $mul6=($mul5)*2; //@line 1091 "wavegen.cpp"
    var $13=$rp_addr; //@line 1091 "wavegen.cpp"
    var $b=(($13+8)&4294967295); //@line 1091 "wavegen.cpp"
    HEAPF32[(($b)>>2)]=$mul6; //@line 1091 "wavegen.cpp"
    var $14=$rp_addr; //@line 1094 "wavegen.cpp"
    var $b7=(($14+8)&4294967295); //@line 1094 "wavegen.cpp"
    var $15=HEAPF32[(($b7)>>2)]; //@line 1094 "wavegen.cpp"
    var $sub8=1-($15); //@line 1094 "wavegen.cpp"
    var $16=$rp_addr; //@line 1094 "wavegen.cpp"
    var $c9=(($16+16)&4294967295); //@line 1094 "wavegen.cpp"
    var $17=HEAPF32[(($c9)>>2)]; //@line 1094 "wavegen.cpp"
    var $sub10=($sub8)-($17); //@line 1094 "wavegen.cpp"
    var $18=$rp_addr; //@line 1094 "wavegen.cpp"
    var $a=(($18)&4294967295); //@line 1094 "wavegen.cpp"
    HEAPF32[(($a)>>2)]=$sub10; //@line 1094 "wavegen.cpp"
    ;
    return; //@line 1095 "wavegen.cpp"
    return;
  }
  

  function __Z7Wavegenv() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $waveph;
    var $theta;
    var $total;
    var $h;
    var $ix;
    var $z;
    var $z1;
    var $z2;
    var $echo;
    var $ov;
    var $pk;
    var $c;
    var $sample;
    var $amp;
    var $modn_amp;
    var $modn_period;
    ; //@line 1186 "wavegen.cpp"
    $for_cond$2: while(1) { 
  
      var $_b=HEAPU8[(__ZL8end_wave_b)];
      var $0=((($_b))&1);
      var $cmp=((($0))|0)==0; //@line 1188 "wavegen.cpp"
      var $1=HEAP32[((__ZL11samplecount)>>2)]; //@line 1188 "wavegen.cpp"
      var $2=HEAP32[((__ZL8nsamples)>>2)]; //@line 1188 "wavegen.cpp"
      var $cmp1=((($1))|0)==((($2))|0); //@line 1188 "wavegen.cpp"
      var $or_cond3=($cmp) & ($cmp1); //@line 1188 "wavegen.cpp"
      if ($or_cond3) { __label__ = 2;break $for_cond$2; } //@line 1188 "wavegen.cpp"
  
      var $and=($1) & 63; //@line 1191 "wavegen.cpp"
      var $cmp2=((($and))|0)==0; //@line 1191 "wavegen.cpp"
      if ($cmp2) { __label__ = 4;; } else { __label__ = 8;; } //@line 1191 "wavegen.cpp"
      $if_then3$$if_else19$5: do { 
        if (__label__ == 4) {
  
          var $cmp4=((($1))|0)==0; //@line 1194 "wavegen.cpp"
          if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 1194 "wavegen.cpp"
          if (__label__ == 5) {
  
            HEAP32[((__ZL7hswitch)>>2)]=0; //@line 1196 "wavegen.cpp"
            HEAP32[((__ZL9harmspect)>>2)]=((__ZL6hspect)&4294967295); //@line 1197 "wavegen.cpp"
            var $3=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1198 "wavegen.cpp"
            var $shl=($3) << 4; //@line 1198 "wavegen.cpp"
            var $call=__Z16PeaksToHarmspectP15wavegen_peaks_tiPii(((__ZL5peaks)&4294967295), $shl, ((__ZL6hspect)&4294967295), 0); //@line 1198 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]=$call; //@line 1198 "wavegen.cpp"
            var $4=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 1202 "wavegen.cpp"
            var $5=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1202 "wavegen.cpp"
            var $shr=($5) >> 8; //@line 1202 "wavegen.cpp"
            var $6=HEAP32[((((_wdata+60)&4294967295))>>2)]; //@line 1202 "wavegen.cpp"
            var $mul=((($6)*($4))&4294967295); //@line 1202 "wavegen.cpp"
            var $mul6=((($mul)*($shr))&4294967295); //@line 1202 "wavegen.cpp"
            var $div=((((($mul6))|0)/80000)|0); //@line 1202 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div; //@line 1202 "wavegen.cpp"
            var $7=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1205 "wavegen.cpp"
            var $shr7=($7) >> 12; //@line 1205 "wavegen.cpp"
            var $div8=((890/((($shr7))|0))|0); //@line 1205 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE13h_switch_sign)>>2)]=$div8; //@line 1205 "wavegen.cpp"
            ; //@line 1206 "wavegen.cpp"
          }
          else if (__label__ == 6) {
  
            __ZL17AdvanceParametersv(); //@line 1208 "wavegen.cpp"
            ;
          }
  
          var $8=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1211 "wavegen.cpp"
          var $shr10=($8) >> 7; //@line 1211 "wavegen.cpp"
          var $9=HEAP32[((__ZL16PHASE_INC_FACTOR)>>2)]; //@line 1211 "wavegen.cpp"
          var $mul11=((($shr10)*($9))&4294967295); //@line 1211 "wavegen.cpp"
          HEAP32[((__ZL8phaseinc)>>2)]=$mul11; //@line 1211 "wavegen.cpp"
          var $10=HEAP32[((_samplerate)>>2)]; //@line 1212 "wavegen.cpp"
          var $11=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1212 "wavegen.cpp"
          var $shr12=($11) >> 12; //@line 1212 "wavegen.cpp"
          var $div13=((((($10))|0)/((($shr12))|0))|0); //@line 1212 "wavegen.cpp"
          HEAP32[((__ZL13cycle_samples)>>2)]=$div13; //@line 1212 "wavegen.cpp"
          var $12=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1213 "wavegen.cpp"
          var $shr14=($12) >> 11; //@line 1213 "wavegen.cpp"
          HEAP32[((__ZL9hf_factor)>>2)]=$shr14; //@line 1213 "wavegen.cpp"
          var $13=HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]; //@line 1215 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE4maxh)>>2)]=$13; //@line 1215 "wavegen.cpp"
          var $14=HEAP32[((__ZL7hswitch)>>2)]; //@line 1216 "wavegen.cpp"
          var $arrayidx=((__ZL6hspect+$14*1600)&4294967295); //@line 1216 "wavegen.cpp"
          var $arraydecay=(($arrayidx)&4294967295); //@line 1216 "wavegen.cpp"
          HEAP32[((__ZL9harmspect)>>2)]=$arraydecay; //@line 1216 "wavegen.cpp"
          var $15=HEAP32[((__ZL7hswitch)>>2)]; //@line 1217 "wavegen.cpp"
          var $xor=($15) ^ 1; //@line 1217 "wavegen.cpp"
          HEAP32[((__ZL7hswitch)>>2)]=$xor; //@line 1217 "wavegen.cpp"
          var $16=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1218 "wavegen.cpp"
          var $shl15=($16) << 4; //@line 1218 "wavegen.cpp"
          var $17=HEAP32[((__ZL7hswitch)>>2)]; //@line 1218 "wavegen.cpp"
          var $arrayidx16=((__ZL6hspect+$17*1600)&4294967295); //@line 1218 "wavegen.cpp"
          var $arraydecay17=(($arrayidx16)&4294967295); //@line 1218 "wavegen.cpp"
          var $call18=__Z16PeaksToHarmspectP15wavegen_peaks_tiPii(((__ZL5peaks)&4294967295), $shl15, $arraydecay17, 1); //@line 1218 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]=$call18; //@line 1218 "wavegen.cpp"
          __ZL9SetBreathv(); //@line 1220 "wavegen.cpp"
          ; //@line 1221 "wavegen.cpp"
        }
        else if (__label__ == 8) {
  
          var $and20=($1) & 7; //@line 1223 "wavegen.cpp"
          var $cmp21=((($and20))|0)==0; //@line 1223 "wavegen.cpp"
          if (!($cmp21)) { __label__ = 16;break $if_then3$$if_else19$5; } //@line 1223 "wavegen.cpp"
  
          $h=1; //@line 1225 "wavegen.cpp"
          __lastLabel__ = 9; ; //@line 1225 "wavegen.cpp"
          while(1) { 
  
            var $18=__lastLabel__ == 13 ? $inc : (1); //@line 1225 "wavegen.cpp"
            var $cmp24=((($18))|0) < 30; //@line 1225 "wavegen.cpp"
            if (!($cmp24)) { __label__ = 14;break ; } //@line 1225 "wavegen.cpp"
  
            var $19=$h; //@line 1225 "wavegen.cpp"
            var $20=HEAP32[((__ZZ7WavegenvE5maxh2)>>2)]; //@line 1225 "wavegen.cpp"
            var $cmp26=((($19))|0) <= ((($20))|0); //@line 1225 "wavegen.cpp"
            if (!($cmp26)) { __label__ = 14;break ; } //@line 1225 "wavegen.cpp"
  
            var $21=$h; //@line 1225 "wavegen.cpp"
            var $22=HEAP32[((__ZZ7WavegenvE4maxh)>>2)]; //@line 1225 "wavegen.cpp"
            var $cmp27=((($21))|0) <= ((($22))|0); //@line 1225 "wavegen.cpp"
            if (!($cmp27)) { __label__ = 14;break ; }
  
            var $23=$h; //@line 1227 "wavegen.cpp"
            var $arrayidx28=((__ZL8harm_inc+$23*4)&4294967295); //@line 1227 "wavegen.cpp"
            var $24=HEAP32[(($arrayidx28)>>2)]; //@line 1227 "wavegen.cpp"
            var $25=$h; //@line 1227 "wavegen.cpp"
            var $26=HEAP32[((__ZL9harmspect)>>2)]; //@line 1227 "wavegen.cpp"
            var $arrayidx29=(($26+4*$25)&4294967295); //@line 1227 "wavegen.cpp"
            var $27=HEAP32[(($arrayidx29)>>2)]; //@line 1227 "wavegen.cpp"
            var $add=((($27)+($24))&4294967295); //@line 1227 "wavegen.cpp"
            HEAP32[(($arrayidx29)>>2)]=$add; //@line 1227 "wavegen.cpp"
            var $28=$h; //@line 1225 "wavegen.cpp"
            var $inc=((($28)+1)&4294967295); //@line 1225 "wavegen.cpp"
            $h=$inc; //@line 1225 "wavegen.cpp"
            __lastLabel__ = 13; __label__ = 10;continue ; //@line 1225 "wavegen.cpp"
          }
  
          var $29=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1231 "wavegen.cpp"
          var $cmp30=((($29))|0) < 256; //@line 1231 "wavegen.cpp"
          if (!($cmp30)) { __label__ = 16;break $if_then3$$if_else19$5; } //@line 1231 "wavegen.cpp"
  
          var $30=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1231 "wavegen.cpp"
          var $inc32=((($30)+1)&4294967295); //@line 1231 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE3agc)>>2)]=$inc32; //@line 1231 "wavegen.cpp"
          ; //@line 1231 "wavegen.cpp"
        }
      } while(0);
  
      var $31=HEAP32[((__ZL11samplecount)>>2)]; //@line 1234 "wavegen.cpp"
      var $inc36=((($31)+1)&4294967295); //@line 1234 "wavegen.cpp"
      HEAP32[((__ZL11samplecount)>>2)]=$inc36; //@line 1234 "wavegen.cpp"
      var $32=HEAP32[((__ZL9wavephase)>>2)]; //@line 1236 "wavegen.cpp"
      var $cmp37=((($32))|0) > 0; //@line 1236 "wavegen.cpp"
      var $33=HEAP32[((__ZL8phaseinc)>>2)]; //@line 1238 "wavegen.cpp"
      var $34=HEAP32[((__ZL9wavephase)>>2)]; //@line 1238 "wavegen.cpp"
      var $add39=((($34)+($33))&4294967295); //@line 1238 "wavegen.cpp"
      HEAP32[((__ZL9wavephase)>>2)]=$add39; //@line 1238 "wavegen.cpp"
      var $35=HEAP32[((__ZL9wavephase)>>2)]; //@line 1239 "wavegen.cpp"
      var $cmp40=((($35))|0) < 0; //@line 1239 "wavegen.cpp"
      var $or_cond=($cmp37) & ($cmp40); //@line 1236 "wavegen.cpp"
      if ($or_cond) { __label__ = 17;; } else { __label__ = 38;; } //@line 1236 "wavegen.cpp"
      $if_then41$$if_end118$21: do { 
        if (__label__ == 17) {
  
          var $36=HEAP32[((__ZL15wavemult_offset)>>2)]; //@line 1242 "wavegen.cpp"
          var $37=HEAP32[((__ZL13cycle_samples)>>2)]; //@line 1242 "wavegen.cpp"
          var $div42=((((($37))|0)/2)|0); //@line 1242 "wavegen.cpp"
          var $sub=((($36)-($div42))&4294967295); //@line 1242 "wavegen.cpp"
          HEAP32[((__ZL6cbytes)>>2)]=$sub; //@line 1242 "wavegen.cpp"
          var $38=HEAP32[((__ZL11samplecount)>>2)]; //@line 1243 "wavegen.cpp"
          var $39=HEAP32[((__ZL8nsamples)>>2)]; //@line 1243 "wavegen.cpp"
          var $cmp43=((($38))|0) > ((($39))|0); //@line 1243 "wavegen.cpp"
          if ($cmp43) { __label__ = 18;break $for_cond$2; } //@line 1243 "wavegen.cpp"
  
          var $40=HEAP32[((__ZZ7WavegenvE11cycle_count)>>2)]; //@line 1246 "wavegen.cpp"
          var $inc46=((($40)+1)&4294967295); //@line 1246 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE11cycle_count)>>2)]=$inc46; //@line 1246 "wavegen.cpp"
          var $41=HEAP32[((_wvoice)>>2)]; //@line 1248 "wavegen.cpp"
          var $n_harmonic_peaks=(($41+84)&4294967295); //@line 1248 "wavegen.cpp"
          var $42=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 1248 "wavegen.cpp"
          var $add47=((($42)+1)&4294967295); //@line 1248 "wavegen.cpp"
          $pk=$add47; //@line 1248 "wavegen.cpp"
          var $cmp495=((($add47))|0) < 9; //@line 1248 "wavegen.cpp"
          if ($cmp495) { __label__ = 20;; } else { __label__ = 21;; } //@line 1248 "wavegen.cpp"
          $for_body50$$for_end57$24: do { 
            if (__label__ == 20) {
              while(1) { 
  
                var $43=$pk; //@line 1251 "wavegen.cpp"
                var $arrayidx51=((__ZL5peaks+$43*80)&4294967295); //@line 1251 "wavegen.cpp"
                var $freq=(($arrayidx51)&4294967295); //@line 1251 "wavegen.cpp"
                var $44=HEAP32[(($freq)>>2)]; //@line 1251 "wavegen.cpp"
                var $45=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1251 "wavegen.cpp"
                var $mul52=((($45)*16)&4294967295); //@line 1251 "wavegen.cpp"
                var $div53=((((($44))|0)/((($mul52))|0))|0); //@line 1251 "wavegen.cpp"
                var $46=$pk; //@line 1251 "wavegen.cpp"
                var $arrayidx54=((__ZL13peak_harmonic+$46*4)&4294967295); //@line 1251 "wavegen.cpp"
                HEAP32[(($arrayidx54)>>2)]=$div53; //@line 1251 "wavegen.cpp"
                var $47=$pk; //@line 1248 "wavegen.cpp"
                var $inc56=((($47)+1)&4294967295); //@line 1248 "wavegen.cpp"
                $pk=$inc56; //@line 1248 "wavegen.cpp"
                var $cmp49=((($inc56))|0) < 9; //@line 1248 "wavegen.cpp"
                if ($cmp49) { __label__ = 20;continue ; } else { __label__ = 21;break $for_body50$$for_end57$24; } //@line 1248 "wavegen.cpp"
              }
            }
          } while(0);
  
          var $48=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 1256 "wavegen.cpp"
          var $49=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1256 "wavegen.cpp"
          var $shr58=($49) >> 8; //@line 1256 "wavegen.cpp"
          var $50=HEAP32[((((_wdata+60)&4294967295))>>2)]; //@line 1256 "wavegen.cpp"
          var $mul59=((($50)*($48))&4294967295); //@line 1256 "wavegen.cpp"
          var $mul60=((($mul59)*($shr58))&4294967295); //@line 1256 "wavegen.cpp"
          var $div61=((((($mul60))|0)/80000)|0); //@line 1256 "wavegen.cpp"
          HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div61; //@line 1256 "wavegen.cpp"
          var $51=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1258 "wavegen.cpp"
          var $cmp62=((($51))|0) > 0; //@line 1258 "wavegen.cpp"
          if ($cmp62) { __label__ = 22;; } else { __label__ = 28;; } //@line 1258 "wavegen.cpp"
          $if_then63$$if_end81$28: do { 
            if (__label__ == 22) {
  
              var $52=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1260 "wavegen.cpp"
              var $cmp64=((($52))|0)==3; //@line 1260 "wavegen.cpp"
              if ($cmp64) { __label__ = 23;; } else { __label__ = 25;; } //@line 1260 "wavegen.cpp"
              if (__label__ == 23) {
  
                var $53=HEAP32[((__ZL8nsamples)>>2)]; //@line 1262 "wavegen.cpp"
                var $54=HEAP32[((__ZL11samplecount)>>2)]; //@line 1262 "wavegen.cpp"
                var $sub66=((($53)-($54))&4294967295); //@line 1262 "wavegen.cpp"
                var $55=HEAP32[((__ZL13cycle_samples)>>2)]; //@line 1262 "wavegen.cpp"
                var $mul67=((($55)*2)&4294967295); //@line 1262 "wavegen.cpp"
                var $cmp68=((($sub66))|0) < ((($mul67))|0); //@line 1262 "wavegen.cpp"
                if (!($cmp68)) { __label__ = 28;break $if_then63$$if_end81$28; } //@line 1262 "wavegen.cpp"
  
                HEAP32[((__ZL12glottal_flag)>>2)]=2; //@line 1266 "wavegen.cpp"
                var $56=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1267 "wavegen.cpp"
                var $57=HEAP32[((__ZL14glottal_reduce)>>2)]; //@line 1267 "wavegen.cpp"
                var $mul70=((($57)*($56))&4294967295); //@line 1267 "wavegen.cpp"
                var $div71=((((($mul70))|0)/256)|0); //@line 1267 "wavegen.cpp"
                HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div71; //@line 1267 "wavegen.cpp"
                ; //@line 1268 "wavegen.cpp"
              }
              else if (__label__ == 25) {
  
                var $58=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1271 "wavegen.cpp"
                var $cmp74=((($58))|0)==4; //@line 1271 "wavegen.cpp"
                if ($cmp74) { __label__ = 26;; } else { __label__ = 27;; } //@line 1271 "wavegen.cpp"
                if (__label__ == 26) {
  
                  HEAP32[((__ZL12glottal_flag)>>2)]=2; //@line 1275 "wavegen.cpp"
                  var $59=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1276 "wavegen.cpp"
                  var $60=HEAP32[((__ZL14glottal_reduce)>>2)]; //@line 1276 "wavegen.cpp"
                  var $mul76=((($60)*($59))&4294967295); //@line 1276 "wavegen.cpp"
                  var $div77=((((($mul76))|0)/256)|0); //@line 1276 "wavegen.cpp"
                  HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div77; //@line 1276 "wavegen.cpp"
                  ; //@line 1277 "wavegen.cpp"
                }
                else if (__label__ == 27) {
  
                  var $61=HEAP32[((__ZL12glottal_flag)>>2)]; //@line 1280 "wavegen.cpp"
                  var $dec=((($61)-1)&4294967295); //@line 1280 "wavegen.cpp"
                  HEAP32[((__ZL12glottal_flag)>>2)]=$dec; //@line 1280 "wavegen.cpp"
                  ;
                }
              }
            }
          } while(0);
  
          var $62=HEAP32[((__ZL13amplitude_env)>>2)]; //@line 1284 "wavegen.cpp"
          var $cmp82=((($62))|0)!=0; //@line 1284 "wavegen.cpp"
          if ($cmp82) { __label__ = 29;; } else { __label__ = 32;; } //@line 1284 "wavegen.cpp"
          if (__label__ == 29) {
  
            var $63=HEAP32[((__ZL6amp_ix)>>2)]; //@line 1287 "wavegen.cpp"
            var $shr84=($63) >> 8; //@line 1287 "wavegen.cpp"
            $ix=$shr84; //@line 1287 "wavegen.cpp"
            var $cmp85=((($shr84))|0) > 127; //@line 1287 "wavegen.cpp"
            if ($cmp85) { __label__ = 30;; } else { __label__ = 31;; } //@line 1287 "wavegen.cpp"
            if (__label__ == 30) {
  
              $ix=127; //@line 1287 "wavegen.cpp"
              ; //@line 1287 "wavegen.cpp"
            }
  
            var $64=$ix; //@line 1288 "wavegen.cpp"
            var $65=HEAP32[((__ZL13amplitude_env)>>2)]; //@line 1288 "wavegen.cpp"
            var $arrayidx88=(($65+$64)&4294967295); //@line 1288 "wavegen.cpp"
            var $66=HEAPU8[($arrayidx88)]; //@line 1288 "wavegen.cpp"
            var $conv=((($66))&255); //@line 1288 "wavegen.cpp"
            $amp=$conv; //@line 1288 "wavegen.cpp"
            var $67=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1289 "wavegen.cpp"
            var $68=$amp; //@line 1289 "wavegen.cpp"
            var $mul89=((($68)*($67))&4294967295); //@line 1289 "wavegen.cpp"
            var $div90=((((($mul89))|0)/128)|0); //@line 1289 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div90; //@line 1289 "wavegen.cpp"
            ; //@line 1292 "wavegen.cpp"
          }
  
          $modn_period=0; //@line 1295 "wavegen.cpp"
          var $69=HEAP32[((_voice)>>2)]; //@line 1296 "wavegen.cpp"
          var $roughness=(($69+72)&4294967295); //@line 1296 "wavegen.cpp"
          var $70=HEAP32[(($roughness)>>2)]; //@line 1296 "wavegen.cpp"
          var $cmp92=((($70))|0) < 8; //@line 1296 "wavegen.cpp"
          if (!($cmp92)) { __label__ = 38;break $if_then41$$if_end118$21; } //@line 1296 "wavegen.cpp"
  
          var $71=HEAP32[((__ZL15modulation_type)>>2)]; //@line 1298 "wavegen.cpp"
          var $72=HEAP32[((_voice)>>2)]; //@line 1298 "wavegen.cpp"
          var $roughness94=(($72+72)&4294967295); //@line 1298 "wavegen.cpp"
          var $73=HEAP32[(($roughness94)>>2)]; //@line 1298 "wavegen.cpp"
          var $arrayidx95=((__ZL14modulation_tab+$73*8)&4294967295); //@line 1298 "wavegen.cpp"
          var $arrayidx96=(($arrayidx95+$71)&4294967295); //@line 1298 "wavegen.cpp"
          var $74=HEAPU8[($arrayidx96)]; //@line 1298 "wavegen.cpp"
          var $conv97=((($74))&255); //@line 1298 "wavegen.cpp"
          $modn_period=$conv97; //@line 1298 "wavegen.cpp"
          var $75=$modn_period; //@line 1299 "wavegen.cpp"
          var $and98=($75) & 15; //@line 1299 "wavegen.cpp"
          $modn_amp=$and98; //@line 1299 "wavegen.cpp"
          var $76=$modn_period; //@line 1300 "wavegen.cpp"
          var $shr99=($76) >> 4; //@line 1300 "wavegen.cpp"
          $modn_period=$shr99; //@line 1300 "wavegen.cpp"
          var $cmp101=((($shr99))|0)!=0; //@line 1303 "wavegen.cpp"
          if (!($cmp101)) { __label__ = 38;break $if_then41$$if_end118$21; } //@line 1303 "wavegen.cpp"
  
          var $77=$modn_period; //@line 1305 "wavegen.cpp"
          var $cmp103=((($77))|0)==15; //@line 1305 "wavegen.cpp"
          if ($cmp103) { __label__ = 35;; } else { __label__ = 36;; } //@line 1305 "wavegen.cpp"
          if (__label__ == 35) {
  
            var $78=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1308 "wavegen.cpp"
            var $79=$modn_amp; //@line 1308 "wavegen.cpp"
            var $mul105=((($79)*($78))&4294967295); //@line 1308 "wavegen.cpp"
            var $div106=((((($mul105))|0)/16)|0); //@line 1308 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div106; //@line 1308 "wavegen.cpp"
            HEAP32[((__ZL15modulation_type)>>2)]=0; //@line 1309 "wavegen.cpp"
            ; //@line 1310 "wavegen.cpp"
          }
          else if (__label__ == 36) {
  
            var $80=HEAP32[((__ZZ7WavegenvE11cycle_count)>>2)]; //@line 1314 "wavegen.cpp"
            var $81=$modn_period; //@line 1314 "wavegen.cpp"
            var $rem=((($80))|0)%((($81))|0); //@line 1314 "wavegen.cpp"
            var $cmp108=((($rem))|0)==0; //@line 1314 "wavegen.cpp"
            if (!($cmp108)) { __label__ = 38;break $if_then41$$if_end118$21; } //@line 1314 "wavegen.cpp"
  
            var $82=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1315 "wavegen.cpp"
            var $83=$modn_amp; //@line 1315 "wavegen.cpp"
            var $mul110=((($83)*($82))&4294967295); //@line 1315 "wavegen.cpp"
            var $div111=((((($mul110))|0)/16)|0); //@line 1315 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]=$div111; //@line 1315 "wavegen.cpp"
            ; //@line 1315 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $84=HEAP32[((__ZL9wavephase)>>2)]; //@line 1324 "wavegen.cpp"
      var $shr119=($84) >> 16; //@line 1324 "wavegen.cpp"
      var $conv120=((($shr119)) & 65535); //@line 1324 "wavegen.cpp"
      $waveph=$conv120; //@line 1324 "wavegen.cpp"
      $total=0; //@line 1325 "wavegen.cpp"
      var $85=HEAP32[((__ZL6cbytes)>>2)]; //@line 1331 "wavegen.cpp"
      var $inc121=((($85)+1)&4294967295); //@line 1331 "wavegen.cpp"
      HEAP32[((__ZL6cbytes)>>2)]=$inc121; //@line 1331 "wavegen.cpp"
      var $cmp122=((($inc121))|0) >= 0; //@line 1332 "wavegen.cpp"
      if ($cmp122) { __label__ = 39;; } else { __label__ = 43;; } //@line 1332 "wavegen.cpp"
      $land_lhs_true123$$if_end149$51: do { 
        if (__label__ == 39) {
  
          var $86=HEAP32[((__ZL6cbytes)>>2)]; //@line 1332 "wavegen.cpp"
          var $87=HEAP32[((__ZL12wavemult_max)>>2)]; //@line 1332 "wavegen.cpp"
          var $cmp124=((($86))|0) < ((($87))|0); //@line 1332 "wavegen.cpp"
          if (!($cmp124)) { __label__ = 43;break $land_lhs_true123$$if_end149$51; } //@line 1332 "wavegen.cpp"
  
          var $88=HEAP32[((_wvoice)>>2)]; //@line 1334 "wavegen.cpp"
          var $n_harmonic_peaks126=(($88+84)&4294967295); //@line 1334 "wavegen.cpp"
          var $89=HEAP32[(($n_harmonic_peaks126)>>2)]; //@line 1334 "wavegen.cpp"
          var $add127=((($89)+1)&4294967295); //@line 1334 "wavegen.cpp"
          $pk=$add127; //@line 1334 "wavegen.cpp"
          var $cmp1294=((($add127))|0) < 9; //@line 1334 "wavegen.cpp"
          if ($cmp1294) { __label__ = 41;; } else { __label__ = 42;; } //@line 1334 "wavegen.cpp"
          $for_body130$$for_end144$54: do { 
            if (__label__ == 41) {
              while(1) { 
  
                var $90=$pk; //@line 1336 "wavegen.cpp"
                var $arrayidx131=((__ZL13peak_harmonic+$90*4)&4294967295); //@line 1336 "wavegen.cpp"
                var $91=HEAP32[(($arrayidx131)>>2)]; //@line 1336 "wavegen.cpp"
                var $92=$waveph; //@line 1336 "wavegen.cpp"
                var $conv132=((($92))&65535); //@line 1336 "wavegen.cpp"
                var $mul133=((($conv132)*($91))&4294967295); //@line 1336 "wavegen.cpp"
                var $conv134=((($mul133)) & 65535); //@line 1336 "wavegen.cpp"
                $theta=$conv134; //@line 1336 "wavegen.cpp"
                var $93=$theta; //@line 1337 "wavegen.cpp"
                var $conv135=((($93))&65535); //@line 1337 "wavegen.cpp"
                var $shr136=($conv135) >> 5; //@line 1337 "wavegen.cpp"
                var $arrayidx137=((_sin_tab+$shr136*2)&4294967295); //@line 1337 "wavegen.cpp"
                var $94=HEAP16[(($arrayidx137)>>1)]; //@line 1337 "wavegen.cpp"
                var $conv138=(tempInt=(($94)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1337 "wavegen.cpp"
                var $95=$pk; //@line 1337 "wavegen.cpp"
                var $arrayidx139=((__ZL11peak_height+$95*4)&4294967295); //@line 1337 "wavegen.cpp"
                var $96=HEAP32[(($arrayidx139)>>2)]; //@line 1337 "wavegen.cpp"
                var $mul140=((($96)*($conv138))&4294967295); //@line 1337 "wavegen.cpp"
                var $97=$total; //@line 1337 "wavegen.cpp"
                var $add141=((($97)+($mul140))&4294967295); //@line 1337 "wavegen.cpp"
                $total=$add141; //@line 1337 "wavegen.cpp"
                var $98=$pk; //@line 1334 "wavegen.cpp"
                var $inc143=((($98)+1)&4294967295); //@line 1334 "wavegen.cpp"
                $pk=$inc143; //@line 1334 "wavegen.cpp"
                var $cmp129=((($inc143))|0) < 9; //@line 1334 "wavegen.cpp"
                if ($cmp129) { __label__ = 41;continue ; } else { __label__ = 42;break $for_body130$$for_end144$54; } //@line 1334 "wavegen.cpp"
              }
            }
          } while(0);
  
          var $99=$total; //@line 1341 "wavegen.cpp"
          var $100=HEAP32[((__ZL9hf_factor)>>2)]; //@line 1341 "wavegen.cpp"
          var $div145=((((($99))|0)/((($100))|0))|0); //@line 1341 "wavegen.cpp"
          var $101=HEAP32[((__ZL6cbytes)>>2)]; //@line 1341 "wavegen.cpp"
          var $arrayidx146=((__ZL8wavemult+$101)&4294967295); //@line 1341 "wavegen.cpp"
          var $102=HEAPU8[($arrayidx146)]; //@line 1341 "wavegen.cpp"
          var $conv147=((($102))&255); //@line 1341 "wavegen.cpp"
          var $mul148=((($conv147)*($div145))&4294967295); //@line 1341 "wavegen.cpp"
          $total=$mul148; //@line 1341 "wavegen.cpp"
          ; //@line 1342 "wavegen.cpp"
        }
      } while(0);
  
      var $103=$waveph; //@line 1349 "wavegen.cpp"
      $theta=$103; //@line 1349 "wavegen.cpp"
      $h=1; //@line 1351 "wavegen.cpp"
      var $104=$h; //@line 1351 "wavegen.cpp"
      var $105=HEAP32[((__ZZ7WavegenvE13h_switch_sign)>>2)]; //@line 1351 "wavegen.cpp"
      var $cmp1516=((($104))|0) <= ((($105))|0); //@line 1351 "wavegen.cpp"
      if ($cmp1516) { __label__ = 44;; } else { __label__ = 45;; } //@line 1351 "wavegen.cpp"
      $for_body152$$while_cond_loopexit$59: do { 
        if (__label__ == 44) {
          while(1) { 
  
            var $106=$theta; //@line 1353 "wavegen.cpp"
            var $conv153=((($106))&65535); //@line 1353 "wavegen.cpp"
            var $shr154=($conv153) >> 5; //@line 1353 "wavegen.cpp"
            var $arrayidx155=((_sin_tab+$shr154*2)&4294967295); //@line 1353 "wavegen.cpp"
            var $107=HEAP16[(($arrayidx155)>>1)]; //@line 1353 "wavegen.cpp"
            var $conv156=(tempInt=(($107)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1353 "wavegen.cpp"
            var $108=$h; //@line 1353 "wavegen.cpp"
            var $109=HEAP32[((__ZL9harmspect)>>2)]; //@line 1353 "wavegen.cpp"
            var $arrayidx157=(($109+4*$108)&4294967295); //@line 1353 "wavegen.cpp"
            var $110=HEAP32[(($arrayidx157)>>2)]; //@line 1353 "wavegen.cpp"
            var $mul158=((($110)*($conv156))&4294967295); //@line 1353 "wavegen.cpp"
            var $111=$total; //@line 1353 "wavegen.cpp"
            var $add159=((($111)+($mul158))&4294967295); //@line 1353 "wavegen.cpp"
            $total=$add159; //@line 1353 "wavegen.cpp"
            var $112=$waveph; //@line 1354 "wavegen.cpp"
            var $conv160=((($112))&65535); //@line 1354 "wavegen.cpp"
            var $113=$theta; //@line 1354 "wavegen.cpp"
            var $conv161=((($113))&65535); //@line 1354 "wavegen.cpp"
            var $add162=((($conv161)+($conv160))&4294967295); //@line 1354 "wavegen.cpp"
            var $conv163=((($add162)) & 65535); //@line 1354 "wavegen.cpp"
            $theta=$conv163; //@line 1354 "wavegen.cpp"
            var $114=$h; //@line 1351 "wavegen.cpp"
            var $inc165=((($114)+1)&4294967295); //@line 1351 "wavegen.cpp"
            $h=$inc165; //@line 1351 "wavegen.cpp"
            var $115=$h; //@line 1351 "wavegen.cpp"
            var $116=HEAP32[((__ZZ7WavegenvE13h_switch_sign)>>2)]; //@line 1351 "wavegen.cpp"
            var $cmp151=((($115))|0) <= ((($116))|0); //@line 1351 "wavegen.cpp"
            if ($cmp151) { __label__ = 44;continue ; } else { __label__ = 45;break $for_body152$$while_cond_loopexit$59; } //@line 1351 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $117=$h; //@line 1356 "wavegen.cpp"
      var $118=HEAP32[((__ZZ7WavegenvE4maxh)>>2)]; //@line 1356 "wavegen.cpp"
      var $cmp1677=((($117))|0) <= ((($118))|0); //@line 1356 "wavegen.cpp"
      if ($cmp1677) { __label__ = 46;; } else { __label__ = 47;; } //@line 1356 "wavegen.cpp"
      $while_body$$while_end$63: do { 
        if (__label__ == 46) {
          while(1) { 
  
            var $119=$theta; //@line 1358 "wavegen.cpp"
            var $conv168=((($119))&65535); //@line 1358 "wavegen.cpp"
            var $shr169=($conv168) >> 5; //@line 1358 "wavegen.cpp"
            var $arrayidx170=((_sin_tab+$shr169*2)&4294967295); //@line 1358 "wavegen.cpp"
            var $120=HEAP16[(($arrayidx170)>>1)]; //@line 1358 "wavegen.cpp"
            var $conv171=(tempInt=(($120)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1358 "wavegen.cpp"
            var $121=$h; //@line 1358 "wavegen.cpp"
            var $122=HEAP32[((__ZL9harmspect)>>2)]; //@line 1358 "wavegen.cpp"
            var $arrayidx172=(($122+4*$121)&4294967295); //@line 1358 "wavegen.cpp"
            var $123=HEAP32[(($arrayidx172)>>2)]; //@line 1358 "wavegen.cpp"
            var $mul173=((($123)*($conv171))&4294967295); //@line 1358 "wavegen.cpp"
            var $124=$total; //@line 1358 "wavegen.cpp"
            var $sub174=((($124)-($mul173))&4294967295); //@line 1358 "wavegen.cpp"
            $total=$sub174; //@line 1358 "wavegen.cpp"
            var $125=$waveph; //@line 1359 "wavegen.cpp"
            var $conv175=((($125))&65535); //@line 1359 "wavegen.cpp"
            var $126=$theta; //@line 1359 "wavegen.cpp"
            var $conv176=((($126))&65535); //@line 1359 "wavegen.cpp"
            var $add177=((($conv176)+($conv175))&4294967295); //@line 1359 "wavegen.cpp"
            var $conv178=((($add177)) & 65535); //@line 1359 "wavegen.cpp"
            $theta=$conv178; //@line 1359 "wavegen.cpp"
            var $127=$h; //@line 1360 "wavegen.cpp"
            var $inc179=((($127)+1)&4294967295); //@line 1360 "wavegen.cpp"
            $h=$inc179; //@line 1360 "wavegen.cpp"
            var $128=$h; //@line 1356 "wavegen.cpp"
            var $129=HEAP32[((__ZZ7WavegenvE4maxh)>>2)]; //@line 1356 "wavegen.cpp"
            var $cmp167=((($128))|0) <= ((($129))|0); //@line 1356 "wavegen.cpp"
            if ($cmp167) { __label__ = 46;continue ; } else { __label__ = 47;break $while_body$$while_end$63; } //@line 1356 "wavegen.cpp"
          }
        }
      } while(0);
  
      var $130=HEAP32[((__ZL7voicing)>>2)]; //@line 1364 "wavegen.cpp"
      var $cmp180=((($130))|0)!=64; //@line 1364 "wavegen.cpp"
      if ($cmp180) { __label__ = 48;; } else { __label__ = 49;; } //@line 1364 "wavegen.cpp"
      if (__label__ == 48) {
  
        var $131=$total; //@line 1366 "wavegen.cpp"
        var $shr182=($131) >> 6; //@line 1366 "wavegen.cpp"
        var $132=HEAP32[((__ZL7voicing)>>2)]; //@line 1366 "wavegen.cpp"
        var $mul183=((($shr182)*($132))&4294967295); //@line 1366 "wavegen.cpp"
        $total=$mul183; //@line 1366 "wavegen.cpp"
        ; //@line 1367 "wavegen.cpp"
      }
  
      var $133=HEAP32[((_wvoice)>>2)]; //@line 1370 "wavegen.cpp"
      var $breath=(($133+272)&4294967295); //@line 1370 "wavegen.cpp"
      var $arrayidx185=(($breath)&4294967295); //@line 1370 "wavegen.cpp"
      var $134=HEAP32[(($arrayidx185)>>2)]; //@line 1370 "wavegen.cpp"
      var $tobool=((($134))|0)!=0; //@line 1370 "wavegen.cpp"
      if ($tobool) { __label__ = 50;; } else { __label__ = 51;; } //@line 1370 "wavegen.cpp"
      if (__label__ == 50) {
  
        var $call187=__ZL11ApplyBreathv(); //@line 1372 "wavegen.cpp"
        var $135=$total; //@line 1372 "wavegen.cpp"
        var $add188=((($135)+($call187))&4294967295); //@line 1372 "wavegen.cpp"
        $total=$add188; //@line 1372 "wavegen.cpp"
        ; //@line 1373 "wavegen.cpp"
      }
  
      $z2=0; //@line 1377 "wavegen.cpp"
      var $136=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1378 "wavegen.cpp"
      var $137=HEAP32[((((_wdata+28)&4294967295))>>2)]; //@line 1378 "wavegen.cpp"
      var $cmp190=((($136))|0) < ((($137))|0); //@line 1378 "wavegen.cpp"
      if ($cmp190) { __label__ = 52;; } else { __label__ = 57;; } //@line 1378 "wavegen.cpp"
      $if_then191$$if_end222$73: do { 
        if (__label__ == 52) {
  
          var $138=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 1380 "wavegen.cpp"
          var $cmp192=((($138))|0)==0; //@line 1380 "wavegen.cpp"
          if ($cmp192) { __label__ = 53;; } else { __label__ = 54;; } //@line 1380 "wavegen.cpp"
          if (__label__ == 53) {
  
            var $139=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1383 "wavegen.cpp"
            var $140=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1383 "wavegen.cpp"
            var $add194=((($139)+1)&4294967295); //@line 1383 "wavegen.cpp"
            var $add195=((($add194)+($140))&4294967295); //@line 1383 "wavegen.cpp"
            var $141=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 1383 "wavegen.cpp"
            var $arrayidx196=(($141+$add195)&4294967295); //@line 1383 "wavegen.cpp"
            var $142=HEAP8[($arrayidx196)]; //@line 1383 "wavegen.cpp"
            $c=$142; //@line 1383 "wavegen.cpp"
            var $143=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1384 "wavegen.cpp"
            var $144=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1384 "wavegen.cpp"
            var $add197=((($144)+($143))&4294967295); //@line 1384 "wavegen.cpp"
            var $145=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 1384 "wavegen.cpp"
            var $arrayidx198=(($145+$add197)&4294967295); //@line 1384 "wavegen.cpp"
            var $146=HEAPU8[($arrayidx198)]; //@line 1384 "wavegen.cpp"
            var $conv199=((($146))&255); //@line 1384 "wavegen.cpp"
            var $147=$c; //@line 1384 "wavegen.cpp"
            var $conv200=(tempInt=(($147)),(tempInt>=128?tempInt-256:tempInt)); //@line 1384 "wavegen.cpp"
            var $mul201=((($conv200)*256)&4294967295); //@line 1384 "wavegen.cpp"
            var $add202=((($mul201)+($conv199))&4294967295); //@line 1384 "wavegen.cpp"
            $sample=$add202; //@line 1384 "wavegen.cpp"
            var $148=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1385 "wavegen.cpp"
            var $add203=((($148)+2)&4294967295); //@line 1385 "wavegen.cpp"
            HEAP32[((((_wdata+40)&4294967295))>>2)]=$add203; //@line 1385 "wavegen.cpp"
            ; //@line 1386 "wavegen.cpp"
          }
          else if (__label__ == 54) {
  
            var $149=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $150=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $inc205=((($150)+1)&4294967295); //@line 1390 "wavegen.cpp"
            HEAP32[((((_wdata+40)&4294967295))>>2)]=$inc205; //@line 1390 "wavegen.cpp"
            var $add206=((($150)+($149))&4294967295); //@line 1390 "wavegen.cpp"
            var $151=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $arrayidx207=(($151+$add206)&4294967295); //@line 1390 "wavegen.cpp"
            var $152=HEAP8[($arrayidx207)]; //@line 1390 "wavegen.cpp"
            var $conv208=(tempInt=(($152)),(tempInt>=128?tempInt-256:tempInt)); //@line 1390 "wavegen.cpp"
            var $153=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 1390 "wavegen.cpp"
            var $mul209=((($conv208)*($153))&4294967295); //@line 1390 "wavegen.cpp"
            $sample=$mul209; //@line 1390 "wavegen.cpp"
            ;
          }
  
          var $154=$sample; //@line 1392 "wavegen.cpp"
          var $155=HEAP32[((((_wdata+56)&4294967295))>>2)]; //@line 1392 "wavegen.cpp"
          var $mul211=((($155)*($154))&4294967295); //@line 1392 "wavegen.cpp"
          var $shr212=($mul211) >> 10; //@line 1392 "wavegen.cpp"
          $z2=$shr212; //@line 1392 "wavegen.cpp"
          var $156=$z2; //@line 1393 "wavegen.cpp"
          var $157=HEAP32[((((_wdata+36)&4294967295))>>2)]; //@line 1393 "wavegen.cpp"
          var $mul213=((($157)*($156))&4294967295); //@line 1393 "wavegen.cpp"
          var $div214=((((($mul213))|0)/32)|0); //@line 1393 "wavegen.cpp"
          $z2=$div214; //@line 1393 "wavegen.cpp"
          var $158=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 1395 "wavegen.cpp"
          var $159=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1395 "wavegen.cpp"
          var $add215=((($159)+($158))&4294967295); //@line 1395 "wavegen.cpp"
          var $160=HEAP32[((((_wdata+44)&4294967295))>>2)]; //@line 1395 "wavegen.cpp"
          var $cmp216=((($add215))|0) >= ((($160))|0); //@line 1395 "wavegen.cpp"
          if (!($cmp216)) { __label__ = 57;break $if_then191$$if_end222$73; } //@line 1395 "wavegen.cpp"
  
          var $161=HEAP32[((((_wdata+44)&4294967295))>>2)]; //@line 1396 "wavegen.cpp"
          var $mul218=((($161)*3)&4294967295); //@line 1396 "wavegen.cpp"
          var $div219=((((($mul218))|0)/4)|0); //@line 1396 "wavegen.cpp"
          var $162=HEAP32[((((_wdata+48)&4294967295))>>2)]; //@line 1396 "wavegen.cpp"
          var $sub220=((($162)-($div219))&4294967295); //@line 1396 "wavegen.cpp"
          HEAP32[((((_wdata+48)&4294967295))>>2)]=$sub220; //@line 1396 "wavegen.cpp"
          ; //@line 1396 "wavegen.cpp"
        }
      } while(0);
  
      var $163=$z2; //@line 1399 "wavegen.cpp"
      var $164=$total; //@line 1399 "wavegen.cpp"
      var $shr223=($164) >> 8; //@line 1399 "wavegen.cpp"
      var $165=HEAP32[((__ZZ7WavegenvE10amplitude2)>>2)]; //@line 1399 "wavegen.cpp"
      var $mul224=((($shr223)*($165))&4294967295); //@line 1399 "wavegen.cpp"
      var $shr225=($mul224) >> 13; //@line 1399 "wavegen.cpp"
      var $add226=((($shr225)+($163))&4294967295); //@line 1399 "wavegen.cpp"
      $z1=$add226; //@line 1399 "wavegen.cpp"
      var $166=HEAP32[((_echo_tail)>>2)]; //@line 1401 "wavegen.cpp"
      var $inc227=((($166)+1)&4294967295); //@line 1401 "wavegen.cpp"
      HEAP32[((_echo_tail)>>2)]=$inc227; //@line 1401 "wavegen.cpp"
      var $arrayidx228=((_echo_buf+$166*2)&4294967295); //@line 1401 "wavegen.cpp"
      var $167=HEAP16[(($arrayidx228)>>1)]; //@line 1401 "wavegen.cpp"
      var $conv229=(tempInt=(($167)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1401 "wavegen.cpp"
      var $168=HEAP32[((_echo_amp)>>2)]; //@line 1401 "wavegen.cpp"
      var $mul230=((($conv229)*($168))&4294967295); //@line 1401 "wavegen.cpp"
      $echo=$mul230; //@line 1401 "wavegen.cpp"
      var $169=$echo; //@line 1402 "wavegen.cpp"
      var $shr231=($169) >> 8; //@line 1402 "wavegen.cpp"
      var $170=$z1; //@line 1402 "wavegen.cpp"
      var $add232=((($170)+($shr231))&4294967295); //@line 1402 "wavegen.cpp"
      $z1=$add232; //@line 1402 "wavegen.cpp"
      var $171=HEAP32[((_echo_tail)>>2)]; //@line 1403 "wavegen.cpp"
      var $cmp233=((($171))|0) >= 5500; //@line 1403 "wavegen.cpp"
      if ($cmp233) { __label__ = 58;; } else { __label__ = 59;; } //@line 1403 "wavegen.cpp"
      if (__label__ == 58) {
  
        HEAP32[((_echo_tail)>>2)]=0; //@line 1404 "wavegen.cpp"
        ; //@line 1404 "wavegen.cpp"
      }
  
      var $172=$z1; //@line 1406 "wavegen.cpp"
      var $173=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1406 "wavegen.cpp"
      var $mul236=((($173)*($172))&4294967295); //@line 1406 "wavegen.cpp"
      var $shr237=($mul236) >> 8; //@line 1406 "wavegen.cpp"
      $z=$shr237; //@line 1406 "wavegen.cpp"
      var $cmp238=((($shr237))|0) >= 32768; //@line 1409 "wavegen.cpp"
      if ($cmp238) { __label__ = 60;; } else { __label__ = 63;; } //@line 1409 "wavegen.cpp"
      $if_then239$$if_else247$84: do { 
        if (__label__ == 60) {
  
          var $174=$z1; //@line 1411 "wavegen.cpp"
          var $div240=((8388608/((($174))|0))|0); //@line 1411 "wavegen.cpp"
          var $sub241=((($div240)-1)&4294967295); //@line 1411 "wavegen.cpp"
          $ov=$sub241; //@line 1411 "wavegen.cpp"
          var $175=$ov; //@line 1412 "wavegen.cpp"
          var $176=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1412 "wavegen.cpp"
          var $cmp242=((($175))|0) < ((($176))|0); //@line 1412 "wavegen.cpp"
          if ($cmp242) { __label__ = 61;; } else { __label__ = 62;; } //@line 1412 "wavegen.cpp"
          if (__label__ == 61) {
  
            var $177=$ov; //@line 1412 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE3agc)>>2)]=$177; //@line 1412 "wavegen.cpp"
            ; //@line 1412 "wavegen.cpp"
          }
  
          var $178=$z1; //@line 1413 "wavegen.cpp"
          var $179=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1413 "wavegen.cpp"
          var $mul245=((($179)*($178))&4294967295); //@line 1413 "wavegen.cpp"
          var $shr246=($mul245) >> 8; //@line 1413 "wavegen.cpp"
          $z=$shr246; //@line 1413 "wavegen.cpp"
          ; //@line 1414 "wavegen.cpp"
        }
        else if (__label__ == 63) {
  
          var $180=$z; //@line 1416 "wavegen.cpp"
          var $cmp248=((($180))|0) <= -32768; //@line 1416 "wavegen.cpp"
          if (!($cmp248)) { __label__ = 67;break $if_then239$$if_else247$84; } //@line 1416 "wavegen.cpp"
  
          var $181=$z1; //@line 1418 "wavegen.cpp"
          var $div250=((-8388608/((($181))|0))|0); //@line 1418 "wavegen.cpp"
          var $sub251=((($div250)-1)&4294967295); //@line 1418 "wavegen.cpp"
          $ov=$sub251; //@line 1418 "wavegen.cpp"
          var $182=$ov; //@line 1419 "wavegen.cpp"
          var $183=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1419 "wavegen.cpp"
          var $cmp252=((($182))|0) < ((($183))|0); //@line 1419 "wavegen.cpp"
          if ($cmp252) { __label__ = 65;; } else { __label__ = 66;; } //@line 1419 "wavegen.cpp"
          if (__label__ == 65) {
  
            var $184=$ov; //@line 1419 "wavegen.cpp"
            HEAP32[((__ZZ7WavegenvE3agc)>>2)]=$184; //@line 1419 "wavegen.cpp"
            ; //@line 1419 "wavegen.cpp"
          }
  
          var $185=$z1; //@line 1420 "wavegen.cpp"
          var $186=HEAP32[((__ZZ7WavegenvE3agc)>>2)]; //@line 1420 "wavegen.cpp"
          var $mul255=((($186)*($185))&4294967295); //@line 1420 "wavegen.cpp"
          var $shr256=($mul255) >> 8; //@line 1420 "wavegen.cpp"
          $z=$shr256; //@line 1420 "wavegen.cpp"
          ; //@line 1421 "wavegen.cpp"
        }
      } while(0);
  
      var $187=$z; //@line 1422 "wavegen.cpp"
      var $conv259=((($187)) & 255); //@line 1422 "wavegen.cpp"
      var $188=HEAP32[((_out_ptr)>>2)]; //@line 1422 "wavegen.cpp"
      var $incdec_ptr=(($188+1)&4294967295); //@line 1422 "wavegen.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 1422 "wavegen.cpp"
      HEAP8[($188)]=$conv259; //@line 1422 "wavegen.cpp"
      var $189=$z; //@line 1423 "wavegen.cpp"
      var $shr260=($189) >> 8; //@line 1423 "wavegen.cpp"
      var $conv261=((($shr260)) & 255); //@line 1423 "wavegen.cpp"
      var $190=HEAP32[((_out_ptr)>>2)]; //@line 1423 "wavegen.cpp"
      var $incdec_ptr262=(($190+1)&4294967295); //@line 1423 "wavegen.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr262; //@line 1423 "wavegen.cpp"
      HEAP8[($190)]=$conv261; //@line 1423 "wavegen.cpp"
      var $191=$z; //@line 1425 "wavegen.cpp"
      var $conv263=((($191)) & 65535); //@line 1425 "wavegen.cpp"
      var $192=HEAP32[((_echo_head)>>2)]; //@line 1425 "wavegen.cpp"
      var $inc264=((($192)+1)&4294967295); //@line 1425 "wavegen.cpp"
      HEAP32[((_echo_head)>>2)]=$inc264; //@line 1425 "wavegen.cpp"
      var $arrayidx265=((_echo_buf+$192*2)&4294967295); //@line 1425 "wavegen.cpp"
      HEAP16[(($arrayidx265)>>1)]=$conv263; //@line 1425 "wavegen.cpp"
      var $193=HEAP32[((_echo_head)>>2)]; //@line 1426 "wavegen.cpp"
      var $cmp266=((($193))|0) >= 5500; //@line 1426 "wavegen.cpp"
      if ($cmp266) { __label__ = 68;; } else { __label__ = 69;; } //@line 1426 "wavegen.cpp"
      if (__label__ == 68) {
  
        HEAP32[((_echo_head)>>2)]=0; //@line 1427 "wavegen.cpp"
        ; //@line 1427 "wavegen.cpp"
      }
  
      var $194=HEAPU32[((_out_ptr)>>2)]; //@line 1429 "wavegen.cpp"
      var $195=HEAPU32[((_out_end)>>2)]; //@line 1429 "wavegen.cpp"
      var $cmp269=((($194))>>>0) >= ((($195))>>>0); //@line 1429 "wavegen.cpp"
      if ($cmp269) { __label__ = 70;break $for_cond$2; } else { __label__ = 1;continue $for_cond$2; } //@line 1429 "wavegen.cpp"
    }
    if (__label__ == 2) {
  
      $retval=0; //@line 1189 "wavegen.cpp"
      ; //@line 1189 "wavegen.cpp"
    }
    else if (__label__ == 18) {
  
      $retval=0; //@line 1244 "wavegen.cpp"
      ; //@line 1244 "wavegen.cpp"
    }
    else if (__label__ == 70) {
  
      $retval=1; //@line 1430 "wavegen.cpp"
      ; //@line 1430 "wavegen.cpp"
    }
  
    var $196=$retval; //@line 1433 "wavegen.cpp"
    ;
    return $196; //@line 1433 "wavegen.cpp"
    return null;
  }
  

  function __ZL17AdvanceParametersv() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $x;
    var $ix;
    var $0=HEAP32[((((_wdata+12)&4294967295))>>2)]; //@line 990 "wavegen.cpp"
    var $1=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 990 "wavegen.cpp"
    var $add=((($1)+($0))&4294967295); //@line 990 "wavegen.cpp"
    HEAP32[((((_wdata+8)&4294967295))>>2)]=$add; //@line 990 "wavegen.cpp"
    var $2=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 991 "wavegen.cpp"
    var $shr=($2) >> 8; //@line 991 "wavegen.cpp"
    $ix=$shr; //@line 991 "wavegen.cpp"
    var $cmp=((($shr))|0) > 127; //@line 991 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 991 "wavegen.cpp"
    if (__label__ == 1) {
  
      $ix=127; //@line 991 "wavegen.cpp"
      ; //@line 991 "wavegen.cpp"
    }
  
    var $3=$ix; //@line 992 "wavegen.cpp"
    var $4=HEAP32[((((_wdata)&4294967295))>>2)]; //@line 992 "wavegen.cpp"
    var $arrayidx=(($4+$3)&4294967295); //@line 992 "wavegen.cpp"
    var $5=HEAPU8[($arrayidx)]; //@line 992 "wavegen.cpp"
    var $conv=((($5))&255); //@line 992 "wavegen.cpp"
    var $6=HEAP32[((((_wdata+20)&4294967295))>>2)]; //@line 992 "wavegen.cpp"
    var $mul=((($conv)*($6))&4294967295); //@line 992 "wavegen.cpp"
    $x=$mul; //@line 992 "wavegen.cpp"
    var $7=$x; //@line 993 "wavegen.cpp"
    var $shr1=($7) >> 8; //@line 993 "wavegen.cpp"
    var $8=HEAP32[((((_wdata+16)&4294967295))>>2)]; //@line 993 "wavegen.cpp"
    var $add2=((($shr1)+($8))&4294967295); //@line 993 "wavegen.cpp"
    HEAP32[((((_wdata+4)&4294967295))>>2)]=$add2; //@line 993 "wavegen.cpp"
    var $9=HEAP32[((__ZL7amp_inc)>>2)]; //@line 995 "wavegen.cpp"
    var $10=HEAP32[((__ZL6amp_ix)>>2)]; //@line 995 "wavegen.cpp"
    var $add3=((($10)+($9))&4294967295); //@line 995 "wavegen.cpp"
    HEAP32[((__ZL6amp_ix)>>2)]=$add3; //@line 995 "wavegen.cpp"
    var $11=HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]; //@line 998 "wavegen.cpp"
    var $cmp4=((($11))|0) >= 23552; //@line 998 "wavegen.cpp"
    if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 998 "wavegen.cpp"
    if (__label__ == 3) {
  
      HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]=0; //@line 999 "wavegen.cpp"
      ; //@line 999 "wavegen.cpp"
    }
  
    var $12=HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]; //@line 1000 "wavegen.cpp"
    var $shr7=($12) >> 6; //@line 1000 "wavegen.cpp"
    var $arrayidx8=((__ZL11Flutter_tab+$shr7)&4294967295); //@line 1000 "wavegen.cpp"
    var $13=HEAPU8[($arrayidx8)]; //@line 1000 "wavegen.cpp"
    var $conv9=((($13))&255); //@line 1000 "wavegen.cpp"
    var $sub=((($conv9)-128)&4294967295); //@line 1000 "wavegen.cpp"
    var $14=HEAP32[((__ZL11flutter_amp)>>2)]; //@line 1000 "wavegen.cpp"
    var $mul10=((($sub)*($14))&4294967295); //@line 1000 "wavegen.cpp"
    $x=$mul10; //@line 1000 "wavegen.cpp"
    var $15=HEAP32[((__ZL11Flutter_inc)>>2)]; //@line 1001 "wavegen.cpp"
    var $16=HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]; //@line 1001 "wavegen.cpp"
    var $add11=((($16)+($15))&4294967295); //@line 1001 "wavegen.cpp"
    HEAP32[((__ZZL17AdvanceParametersvE10Flutter_ix)>>2)]=$add11; //@line 1001 "wavegen.cpp"
    var $17=$x; //@line 1002 "wavegen.cpp"
    var $18=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1002 "wavegen.cpp"
    var $add12=((($18)+($17))&4294967295); //@line 1002 "wavegen.cpp"
    HEAP32[((((_wdata+4)&4294967295))>>2)]=$add12; //@line 1002 "wavegen.cpp"
    var $cmp13=((($add12))|0) < 102400; //@line 1003 "wavegen.cpp"
    if ($cmp13) { __label__ = 5;; } else { __label__ = 6;; } //@line 1003 "wavegen.cpp"
    if (__label__ == 5) {
  
      HEAP32[((((_wdata+4)&4294967295))>>2)]=102400; //@line 1004 "wavegen.cpp"
      ; //@line 1004 "wavegen.cpp"
    }
  
    var $19=HEAP32[((__ZL11samplecount)>>2)]; //@line 1006 "wavegen.cpp"
    var $20=HEAP32[((__ZL17samplecount_start)>>2)]; //@line 1006 "wavegen.cpp"
    var $cmp16=((($19))|0)==((($20))|0); //@line 1006 "wavegen.cpp"
    if ($cmp16) { __label__ = 21;; } else { __label__ = 7;; } //@line 1006 "wavegen.cpp"
    $for_end93$$if_end18$11: do { 
      if (__label__ == 7) {
  
        $ix=0; //@line 1009 "wavegen.cpp"
        var $21=$ix; //@line 1009 "wavegen.cpp"
        var $22=HEAP32[((_wvoice)>>2)]; //@line 1009 "wavegen.cpp"
        var $n_harmonic_peaks2=(($22+84)&4294967295); //@line 1009 "wavegen.cpp"
        var $23=HEAP32[(($n_harmonic_peaks2)>>2)]; //@line 1009 "wavegen.cpp"
        var $cmp193=((($21))|0) <= ((($23))|0); //@line 1009 "wavegen.cpp"
        if ($cmp193) { __lastLabel__ = 7; __label__ = 9;; } else { __lastLabel__ = 7; __label__ = 8;; } //@line 1009 "wavegen.cpp"
        $for_body$$for_cond60_preheader$13: do { 
          if (__label__ == 9) {
            while(1) { 
  
              var $24=$ix; //@line 1011 "wavegen.cpp"
              var $arrayidx20=((__ZL5peaks+$24*80)&4294967295); //@line 1011 "wavegen.cpp"
              var $freq_inc=(($arrayidx20+48)&4294967295); //@line 1011 "wavegen.cpp"
              var $25=HEAPF32[(($freq_inc)>>2)]; //@line 1011 "wavegen.cpp"
              var $26=$ix; //@line 1011 "wavegen.cpp"
              var $arrayidx21=((__ZL5peaks+$26*80)&4294967295); //@line 1011 "wavegen.cpp"
              var $freq1=(($arrayidx21+16)&4294967295); //@line 1011 "wavegen.cpp"
              var $27=HEAPF32[(($freq1)>>2)]; //@line 1011 "wavegen.cpp"
              var $add22=($27)+($25); //@line 1011 "wavegen.cpp"
              HEAPF32[(($freq1)>>2)]=$add22; //@line 1011 "wavegen.cpp"
              var $28=$ix; //@line 1012 "wavegen.cpp"
              var $arrayidx23=((__ZL5peaks+$28*80)&4294967295); //@line 1012 "wavegen.cpp"
              var $freq124=(($arrayidx23+16)&4294967295); //@line 1012 "wavegen.cpp"
              var $29=HEAPF32[(($freq124)>>2)]; //@line 1012 "wavegen.cpp"
              var $conv25=((($29))|0); //@line 1012 "wavegen.cpp"
              var $30=$ix; //@line 1012 "wavegen.cpp"
              var $arrayidx26=((__ZL5peaks+$30*80)&4294967295); //@line 1012 "wavegen.cpp"
              var $freq=(($arrayidx26)&4294967295); //@line 1012 "wavegen.cpp"
              HEAP32[(($freq)>>2)]=$conv25; //@line 1012 "wavegen.cpp"
              var $31=$ix; //@line 1013 "wavegen.cpp"
              var $arrayidx27=((__ZL5peaks+$31*80)&4294967295); //@line 1013 "wavegen.cpp"
              var $height_inc=(($arrayidx27+56)&4294967295); //@line 1013 "wavegen.cpp"
              var $32=HEAPF32[(($height_inc)>>2)]; //@line 1013 "wavegen.cpp"
              var $33=$ix; //@line 1013 "wavegen.cpp"
              var $arrayidx28=((__ZL5peaks+$33*80)&4294967295); //@line 1013 "wavegen.cpp"
              var $height1=(($arrayidx28+24)&4294967295); //@line 1013 "wavegen.cpp"
              var $34=HEAPF32[(($height1)>>2)]; //@line 1013 "wavegen.cpp"
              var $add29=($34)+($32); //@line 1013 "wavegen.cpp"
              HEAPF32[(($height1)>>2)]=$add29; //@line 1013 "wavegen.cpp"
              var $35=$ix; //@line 1014 "wavegen.cpp"
              var $arrayidx30=((__ZL5peaks+$35*80)&4294967295); //@line 1014 "wavegen.cpp"
              var $height131=(($arrayidx30+24)&4294967295); //@line 1014 "wavegen.cpp"
              var $36=HEAPF32[(($height131)>>2)]; //@line 1014 "wavegen.cpp"
              var $conv32=((($36))|0); //@line 1014 "wavegen.cpp"
              var $37=$ix; //@line 1014 "wavegen.cpp"
              var $arrayidx33=((__ZL5peaks+$37*80)&4294967295); //@line 1014 "wavegen.cpp"
              var $height=(($arrayidx33+4)&4294967295); //@line 1014 "wavegen.cpp"
              HEAP32[(($height)>>2)]=$conv32; //@line 1014 "wavegen.cpp"
              var $cmp34=((($conv32))|0) < 0; //@line 1014 "wavegen.cpp"
              if ($cmp34) { __label__ = 10;; } else { __label__ = 11;; } //@line 1014 "wavegen.cpp"
              if (__label__ == 10) {
  
                var $38=$ix; //@line 1015 "wavegen.cpp"
                var $arrayidx36=((__ZL5peaks+$38*80)&4294967295); //@line 1015 "wavegen.cpp"
                var $height37=(($arrayidx36+4)&4294967295); //@line 1015 "wavegen.cpp"
                HEAP32[(($height37)>>2)]=0; //@line 1015 "wavegen.cpp"
                ; //@line 1015 "wavegen.cpp"
              }
  
              var $39=$ix; //@line 1016 "wavegen.cpp"
              var $arrayidx39=((__ZL5peaks+$39*80)&4294967295); //@line 1016 "wavegen.cpp"
              var $left_inc=(($arrayidx39+64)&4294967295); //@line 1016 "wavegen.cpp"
              var $40=HEAPF32[(($left_inc)>>2)]; //@line 1016 "wavegen.cpp"
              var $41=$ix; //@line 1016 "wavegen.cpp"
              var $arrayidx40=((__ZL5peaks+$41*80)&4294967295); //@line 1016 "wavegen.cpp"
              var $left1=(($arrayidx40+32)&4294967295); //@line 1016 "wavegen.cpp"
              var $42=HEAPF32[(($left1)>>2)]; //@line 1016 "wavegen.cpp"
              var $add41=($42)+($40); //@line 1016 "wavegen.cpp"
              HEAPF32[(($left1)>>2)]=$add41; //@line 1016 "wavegen.cpp"
              var $43=$ix; //@line 1017 "wavegen.cpp"
              var $arrayidx42=((__ZL5peaks+$43*80)&4294967295); //@line 1017 "wavegen.cpp"
              var $left143=(($arrayidx42+32)&4294967295); //@line 1017 "wavegen.cpp"
              var $44=HEAPF32[(($left143)>>2)]; //@line 1017 "wavegen.cpp"
              var $conv44=((($44))|0); //@line 1017 "wavegen.cpp"
              var $45=$ix; //@line 1017 "wavegen.cpp"
              var $arrayidx45=((__ZL5peaks+$45*80)&4294967295); //@line 1017 "wavegen.cpp"
              var $left=(($arrayidx45+8)&4294967295); //@line 1017 "wavegen.cpp"
              HEAP32[(($left)>>2)]=$conv44; //@line 1017 "wavegen.cpp"
              var $46=$ix; //@line 1018 "wavegen.cpp"
              var $cmp46=((($46))|0) < 3; //@line 1018 "wavegen.cpp"
              var $47=$ix; //@line 1020 "wavegen.cpp"
              var $arrayidx48=((__ZL5peaks+$47*80)&4294967295); //@line 1020 "wavegen.cpp"
              if ($cmp46) { __label__ = 12;; } else { __label__ = 13;; } //@line 1018 "wavegen.cpp"
              if (__label__ == 12) {
  
                var $right_inc=(($arrayidx48+72)&4294967295); //@line 1020 "wavegen.cpp"
                var $48=HEAPF32[(($right_inc)>>2)]; //@line 1020 "wavegen.cpp"
                var $49=$ix; //@line 1020 "wavegen.cpp"
                var $arrayidx49=((__ZL5peaks+$49*80)&4294967295); //@line 1020 "wavegen.cpp"
                var $right1=(($arrayidx49+40)&4294967295); //@line 1020 "wavegen.cpp"
                var $50=HEAPF32[(($right1)>>2)]; //@line 1020 "wavegen.cpp"
                var $add50=($50)+($48); //@line 1020 "wavegen.cpp"
                HEAPF32[(($right1)>>2)]=$add50; //@line 1020 "wavegen.cpp"
                var $51=$ix; //@line 1021 "wavegen.cpp"
                var $arrayidx51=((__ZL5peaks+$51*80)&4294967295); //@line 1021 "wavegen.cpp"
                var $right152=(($arrayidx51+40)&4294967295); //@line 1021 "wavegen.cpp"
                var $52=HEAPF32[(($right152)>>2)]; //@line 1021 "wavegen.cpp"
                var $conv53=((($52))|0); //@line 1021 "wavegen.cpp"
                var $53=$ix; //@line 1021 "wavegen.cpp"
                var $arrayidx54=((__ZL5peaks+$53*80)&4294967295); //@line 1021 "wavegen.cpp"
                var $right=(($arrayidx54+12)&4294967295); //@line 1021 "wavegen.cpp"
                HEAP32[(($right)>>2)]=$conv53; //@line 1021 "wavegen.cpp"
                ; //@line 1022 "wavegen.cpp"
              }
              else if (__label__ == 13) {
  
                var $left56=(($arrayidx48+8)&4294967295); //@line 1025 "wavegen.cpp"
                var $54=HEAP32[(($left56)>>2)]; //@line 1025 "wavegen.cpp"
                var $55=$ix; //@line 1025 "wavegen.cpp"
                var $arrayidx57=((__ZL5peaks+$55*80)&4294967295); //@line 1025 "wavegen.cpp"
                var $right58=(($arrayidx57+12)&4294967295); //@line 1025 "wavegen.cpp"
                HEAP32[(($right58)>>2)]=$54; //@line 1025 "wavegen.cpp"
                ;
              }
  
              var $56=$ix; //@line 1009 "wavegen.cpp"
              var $inc=((($56)+1)&4294967295); //@line 1009 "wavegen.cpp"
              $ix=$inc; //@line 1009 "wavegen.cpp"
              var $57=$ix; //@line 1009 "wavegen.cpp"
              var $58=HEAP32[((_wvoice)>>2)]; //@line 1009 "wavegen.cpp"
              var $n_harmonic_peaks=(($58+84)&4294967295); //@line 1009 "wavegen.cpp"
              var $59=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 1009 "wavegen.cpp"
              var $cmp19=((($57))|0) <= ((($59))|0); //@line 1009 "wavegen.cpp"
              if ($cmp19) { __lastLabel__ = 14; __label__ = 9;continue ; } else { __lastLabel__ = 14; __label__ = 8;break $for_body$$for_cond60_preheader$13; } //@line 1009 "wavegen.cpp"
            }
          }
        } while(0);
  
        var $_lcssa=__lastLabel__ == 7 ? $21 : ($57);
        var $cmp611=((($_lcssa))|0) < 8; //@line 1028 "wavegen.cpp"
        if (!($cmp611)) { __label__ = 21;break $for_end93$$if_end18$11; } //@line 1028 "wavegen.cpp"
  
        var $_pr=$ix; //@line 1031 "wavegen.cpp"
        __lastLabel__ = 15; ;
        while(1) { 
  
          var $60=__lastLabel__ == 15 ? $_pr : ($inc92); //@line 1031 "wavegen.cpp"
          var $cmp63=((($60))|0) < 7; //@line 1031 "wavegen.cpp"
          if ($cmp63) { __label__ = 17;; } else { __label__ = 18;; } //@line 1031 "wavegen.cpp"
          if (__label__ == 17) {
  
            var $61=$ix; //@line 1033 "wavegen.cpp"
            var $arrayidx65=((__ZL5peaks+$61*80)&4294967295); //@line 1033 "wavegen.cpp"
            var $freq_inc66=(($arrayidx65+48)&4294967295); //@line 1033 "wavegen.cpp"
            var $62=HEAPF32[(($freq_inc66)>>2)]; //@line 1033 "wavegen.cpp"
            var $63=$ix; //@line 1033 "wavegen.cpp"
            var $arrayidx67=((__ZL5peaks+$63*80)&4294967295); //@line 1033 "wavegen.cpp"
            var $freq168=(($arrayidx67+16)&4294967295); //@line 1033 "wavegen.cpp"
            var $64=HEAPF32[(($freq168)>>2)]; //@line 1033 "wavegen.cpp"
            var $add69=($64)+($62); //@line 1033 "wavegen.cpp"
            HEAPF32[(($freq168)>>2)]=$add69; //@line 1033 "wavegen.cpp"
            var $65=$ix; //@line 1034 "wavegen.cpp"
            var $arrayidx70=((__ZL5peaks+$65*80)&4294967295); //@line 1034 "wavegen.cpp"
            var $freq171=(($arrayidx70+16)&4294967295); //@line 1034 "wavegen.cpp"
            var $66=HEAPF32[(($freq171)>>2)]; //@line 1034 "wavegen.cpp"
            var $conv72=((($66))|0); //@line 1034 "wavegen.cpp"
            var $67=$ix; //@line 1034 "wavegen.cpp"
            var $arrayidx73=((__ZL5peaks+$67*80)&4294967295); //@line 1034 "wavegen.cpp"
            var $freq74=(($arrayidx73)&4294967295); //@line 1034 "wavegen.cpp"
            HEAP32[(($freq74)>>2)]=$conv72; //@line 1034 "wavegen.cpp"
            ; //@line 1035 "wavegen.cpp"
          }
  
          var $68=$ix; //@line 1036 "wavegen.cpp"
          var $arrayidx76=((__ZL5peaks+$68*80)&4294967295); //@line 1036 "wavegen.cpp"
          var $height_inc77=(($arrayidx76+56)&4294967295); //@line 1036 "wavegen.cpp"
          var $69=HEAPF32[(($height_inc77)>>2)]; //@line 1036 "wavegen.cpp"
          var $70=$ix; //@line 1036 "wavegen.cpp"
          var $arrayidx78=((__ZL5peaks+$70*80)&4294967295); //@line 1036 "wavegen.cpp"
          var $height179=(($arrayidx78+24)&4294967295); //@line 1036 "wavegen.cpp"
          var $71=HEAPF32[(($height179)>>2)]; //@line 1036 "wavegen.cpp"
          var $add80=($71)+($69); //@line 1036 "wavegen.cpp"
          HEAPF32[(($height179)>>2)]=$add80; //@line 1036 "wavegen.cpp"
          var $72=$ix; //@line 1037 "wavegen.cpp"
          var $arrayidx81=((__ZL5peaks+$72*80)&4294967295); //@line 1037 "wavegen.cpp"
          var $height182=(($arrayidx81+24)&4294967295); //@line 1037 "wavegen.cpp"
          var $73=HEAPF32[(($height182)>>2)]; //@line 1037 "wavegen.cpp"
          var $conv83=((($73))|0); //@line 1037 "wavegen.cpp"
          var $74=$ix; //@line 1037 "wavegen.cpp"
          var $arrayidx84=((__ZL5peaks+$74*80)&4294967295); //@line 1037 "wavegen.cpp"
          var $height85=(($arrayidx84+4)&4294967295); //@line 1037 "wavegen.cpp"
          HEAP32[(($height85)>>2)]=$conv83; //@line 1037 "wavegen.cpp"
          var $cmp86=((($conv83))|0) < 0; //@line 1037 "wavegen.cpp"
          if ($cmp86) { __label__ = 19;; } else { __label__ = 20;; } //@line 1037 "wavegen.cpp"
          if (__label__ == 19) {
  
            var $75=$ix; //@line 1038 "wavegen.cpp"
            var $arrayidx88=((__ZL5peaks+$75*80)&4294967295); //@line 1038 "wavegen.cpp"
            var $height89=(($arrayidx88+4)&4294967295); //@line 1038 "wavegen.cpp"
            HEAP32[(($height89)>>2)]=0; //@line 1038 "wavegen.cpp"
            ; //@line 1038 "wavegen.cpp"
          }
  
          var $76=$ix; //@line 1028 "wavegen.cpp"
          var $inc92=((($76)+1)&4294967295); //@line 1028 "wavegen.cpp"
          $ix=$inc92; //@line 1028 "wavegen.cpp"
          var $cmp61=((($inc92))|0) < 8; //@line 1028 "wavegen.cpp"
          if ($cmp61) { __lastLabel__ = 20; __label__ = 16;continue ; } else { __lastLabel__ = 20; __label__ = 21;break $for_end93$$if_end18$11; } //@line 1028 "wavegen.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1049 "wavegen.cpp"
    return;
  }
  

  function __ZL9SetBreathv() {
    ;
    var __label__;
  
    var $pk;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 1121 "wavegen.cpp"
    var $breath=(($0+272)&4294967295); //@line 1121 "wavegen.cpp"
    var $arrayidx=(($breath)&4294967295); //@line 1121 "wavegen.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 1121 "wavegen.cpp"
    var $cmp=((($1))|0)==0; //@line 1121 "wavegen.cpp"
    if ($cmp) { __label__ = 5;; } else { __label__ = 1;; } //@line 1121 "wavegen.cpp"
    $for_end$$if_end$2: do { 
      if (__label__ == 1) {
  
        $pk=1; //@line 1124 "wavegen.cpp"
        ; //@line 1124 "wavegen.cpp"
        while(1) { 
  
          var $2=$pk; //@line 1126 "wavegen.cpp"
          var $3=HEAP32[((_wvoice)>>2)]; //@line 1126 "wavegen.cpp"
          var $breath2=(($3+272)&4294967295); //@line 1126 "wavegen.cpp"
          var $arrayidx3=(($breath2+$2*4)&4294967295); //@line 1126 "wavegen.cpp"
          var $4=HEAP32[(($arrayidx3)>>2)]; //@line 1126 "wavegen.cpp"
          var $cmp4=((($4))|0)!=0; //@line 1126 "wavegen.cpp"
          if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1126 "wavegen.cpp"
          if (__label__ == 3) {
  
            var $5=$pk; //@line 1130 "wavegen.cpp"
            var $arrayidx6=((__ZL7rbreath+$5*40)&4294967295); //@line 1130 "wavegen.cpp"
            var $6=$pk; //@line 1130 "wavegen.cpp"
            var $arrayidx7=((__ZL5peaks+$6*80)&4294967295); //@line 1130 "wavegen.cpp"
            var $freq=(($arrayidx7)&4294967295); //@line 1130 "wavegen.cpp"
            var $7=HEAP32[(($freq)>>2)]; //@line 1130 "wavegen.cpp"
            var $shr=($7) >> 16; //@line 1130 "wavegen.cpp"
            var $8=$pk; //@line 1130 "wavegen.cpp"
            var $9=HEAP32[((_wvoice)>>2)]; //@line 1130 "wavegen.cpp"
            var $breathw=(($9+308)&4294967295); //@line 1130 "wavegen.cpp"
            var $arrayidx8=(($breathw+$8*4)&4294967295); //@line 1130 "wavegen.cpp"
            var $10=HEAP32[(($arrayidx8)>>2)]; //@line 1130 "wavegen.cpp"
            __ZL12setresonatorP9RESONATORiii($arrayidx6, $shr, $10, 0); //@line 1130 "wavegen.cpp"
            ; //@line 1131 "wavegen.cpp"
          }
  
          var $11=$pk; //@line 1124 "wavegen.cpp"
          var $inc=((($11)+1)&4294967295); //@line 1124 "wavegen.cpp"
          $pk=$inc; //@line 1124 "wavegen.cpp"
          var $cmp1=((($inc))|0) < 9; //@line 1124 "wavegen.cpp"
          if ($cmp1) { __label__ = 2;continue ; } else { __label__ = 5;break $for_end$$if_end$2; } //@line 1124 "wavegen.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1134 "wavegen.cpp"
    return;
  }
  

  function __ZL11ApplyBreathv() {
    ;
    var __label__;
  
    var $value;
    var $noise;
    var $ix;
    var $amp;
    $value=0; //@line 1139 "wavegen.cpp"
    var $call=_rand(); //@line 1146 "wavegen.cpp"
    var $and=($call) & 16383; //@line 1146 "wavegen.cpp"
    var $sub=((($and)-8192)&4294967295); //@line 1146 "wavegen.cpp"
    $noise=$sub; //@line 1146 "wavegen.cpp"
    $ix=1; //@line 1148 "wavegen.cpp"
    ; //@line 1148 "wavegen.cpp"
    while(1) { 
  
      var $0=$ix; //@line 1150 "wavegen.cpp"
      var $1=HEAP32[((_wvoice)>>2)]; //@line 1150 "wavegen.cpp"
      var $breath=(($1+272)&4294967295); //@line 1150 "wavegen.cpp"
      var $arrayidx=(($breath+$0*4)&4294967295); //@line 1150 "wavegen.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 1150 "wavegen.cpp"
      $amp=$2; //@line 1150 "wavegen.cpp"
      var $cmp1=((($2))|0)!=0; //@line 1150 "wavegen.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 1150 "wavegen.cpp"
      if (__label__ == 2) {
  
        var $3=$ix; //@line 1152 "wavegen.cpp"
        var $arrayidx2=((__ZL5peaks+$3*80)&4294967295); //@line 1152 "wavegen.cpp"
        var $height=(($arrayidx2+4)&4294967295); //@line 1152 "wavegen.cpp"
        var $4=HEAP32[(($height)>>2)]; //@line 1152 "wavegen.cpp"
        var $shr=($4) >> 14; //@line 1152 "wavegen.cpp"
        var $5=$amp; //@line 1152 "wavegen.cpp"
        var $mul=((($5)*($shr))&4294967295); //@line 1152 "wavegen.cpp"
        $amp=$mul; //@line 1152 "wavegen.cpp"
        var $6=$ix; //@line 1153 "wavegen.cpp"
        var $arrayidx3=((__ZL7rbreath+$6*40)&4294967295); //@line 1153 "wavegen.cpp"
        var $7=$noise; //@line 1153 "wavegen.cpp"
        var $conv=((($7))|0); //@line 1153 "wavegen.cpp"
        var $call4=__ZL9resonatorP9RESONATORd($arrayidx3, $conv); //@line 1153 "wavegen.cpp"
        var $8=$amp; //@line 1153 "wavegen.cpp"
        var $conv5=((($8))|0); //@line 1153 "wavegen.cpp"
        var $mul6=($call4)*($conv5); //@line 1153 "wavegen.cpp"
        var $conv7=((($mul6))|0); //@line 1153 "wavegen.cpp"
        var $9=$value; //@line 1153 "wavegen.cpp"
        var $add=((($conv7)+($9))&4294967295); //@line 1153 "wavegen.cpp"
        $value=$add; //@line 1153 "wavegen.cpp"
        ; //@line 1154 "wavegen.cpp"
      }
  
      var $10=$ix; //@line 1148 "wavegen.cpp"
      var $inc=((($10)+1)&4294967295); //@line 1148 "wavegen.cpp"
      $ix=$inc; //@line 1148 "wavegen.cpp"
      var $cmp=((($inc))|0) < 9; //@line 1148 "wavegen.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 4;break ; } //@line 1148 "wavegen.cpp"
    }
  
    var $11=$value; //@line 1157 "wavegen.cpp"
    ;
    return $11; //@line 1157 "wavegen.cpp"
    return null;
  }
  

  function __Z11SetEmbeddedii($control, $value) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $control_addr;
    var $value_addr;
    var $sign;
    var $command;
    $control_addr=$control;
    $value_addr=$value;
    $sign=0; //@line 1567 "wavegen.cpp"
    var $0=$control_addr; //@line 1570 "wavegen.cpp"
    var $and=($0) & 31; //@line 1570 "wavegen.cpp"
    $command=$and; //@line 1570 "wavegen.cpp"
    var $1=$control_addr; //@line 1571 "wavegen.cpp"
    var $and1=($1) & 96; //@line 1571 "wavegen.cpp"
    var $cmp=((($and1))|0)==96; //@line 1571 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1571 "wavegen.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        $sign=-1; //@line 1572 "wavegen.cpp"
        ; //@line 1572 "wavegen.cpp"
      }
      else if (__label__ == 2) {
  
        var $2=$control_addr; //@line 1574 "wavegen.cpp"
        var $and2=($2) & 96; //@line 1574 "wavegen.cpp"
        var $cmp3=((($and2))|0)==64; //@line 1574 "wavegen.cpp"
        if (!($cmp3)) { __label__ = 4;break $if_then$$if_else$2; } //@line 1574 "wavegen.cpp"
  
        $sign=1; //@line 1575 "wavegen.cpp"
        ; //@line 1575 "wavegen.cpp"
      }
    } while(0);
  
    var $3=$command; //@line 1577 "wavegen.cpp"
    var $cmp6=((($3))|0) < 15; //@line 1577 "wavegen.cpp"
    if ($cmp6) { __lastLabel__ = 4; __label__ = 5;; } else { __lastLabel__ = 4; __label__ = 9;; } //@line 1577 "wavegen.cpp"
    if (__label__ == 5) {
  
      var $4=$sign; //@line 1579 "wavegen.cpp"
      var $cmp8=((($4))|0)==0; //@line 1579 "wavegen.cpp"
      var $5=$value_addr; //@line 1580 "wavegen.cpp"
      if ($cmp8) { __label__ = 6;; } else { __label__ = 7;; } //@line 1579 "wavegen.cpp"
      if (__label__ == 6) {
  
        var $6=$command; //@line 1580 "wavegen.cpp"
        var $arrayidx=((_embedded_value+$6*4)&4294967295); //@line 1580 "wavegen.cpp"
        HEAP32[(($arrayidx)>>2)]=$5; //@line 1580 "wavegen.cpp"
        ; //@line 1580 "wavegen.cpp"
      }
      else if (__label__ == 7) {
  
        var $7=$sign; //@line 1582 "wavegen.cpp"
        var $mul=((($7)*($5))&4294967295); //@line 1582 "wavegen.cpp"
        var $8=$command; //@line 1582 "wavegen.cpp"
        var $arrayidx11=((_embedded_value+$8*4)&4294967295); //@line 1582 "wavegen.cpp"
        var $9=HEAP32[(($arrayidx11)>>2)]; //@line 1582 "wavegen.cpp"
        var $add=((($9)+($mul))&4294967295); //@line 1582 "wavegen.cpp"
        HEAP32[(($arrayidx11)>>2)]=$add; //@line 1582 "wavegen.cpp"
        ;
      }
  
      var $10=$command; //@line 1583 "wavegen.cpp"
      var $arrayidx13=((_embedded_value+$10*4)&4294967295); //@line 1583 "wavegen.cpp"
      var $11=HEAP32[(($arrayidx13)>>2)]; //@line 1583 "wavegen.cpp"
      var $12=$command; //@line 1583 "wavegen.cpp"
      var $arrayidx14=((__ZL12embedded_max+$12*4)&4294967295); //@line 1583 "wavegen.cpp"
      var $13=HEAP32[(($arrayidx14)>>2)]; //@line 1583 "wavegen.cpp"
      var $call=__ZL13SetWithRange0ii($11, $13); //@line 1583 "wavegen.cpp"
      var $14=$command; //@line 1583 "wavegen.cpp"
      var $arrayidx15=((_embedded_value+$14*4)&4294967295); //@line 1583 "wavegen.cpp"
      HEAP32[(($arrayidx15)>>2)]=$call; //@line 1583 "wavegen.cpp"
      var $_pr=$command; //@line 1586 "wavegen.cpp"
      __lastLabel__ = 8; ; //@line 1584 "wavegen.cpp"
    }
  
    var $15=__lastLabel__ == 8 ? $_pr : ($3); //@line 1586 "wavegen.cpp"
    if ($15 == 6) {
      __label__ = 10;;
    }
    else if ($15 == 1) {
      __label__ = 11;;
    }
    else if ($15 == 3) {
      __label__ = 12;;
    }
    else if ($15 == 13) {
      __label__ = 13;;
    }
    else if ($15 == 5) {
      __label__ = 14;;
    }
    else {
    __label__ = 15;;
    }
    
    $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14: do { 
      if (__label__ == 10) {
  
        __ZL14WavegenSetEchov(); //@line 1589 "wavegen.cpp"
        __label__ = 11;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1589 "wavegen.cpp"
      }
      else if (__label__ == 12) {
  
        var $call19=__Z12GetAmplitudev(); //@line 1595 "wavegen.cpp"
        HEAP32[((__ZL17general_amplitude)>>2)]=$call19; //@line 1595 "wavegen.cpp"
        __label__ = 15;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1596 "wavegen.cpp"
      }
      else if (__label__ == 13) {
  
        var $call21=__Z12GetAmplitudev(); //@line 1599 "wavegen.cpp"
        HEAP32[((__ZL17general_amplitude)>>2)]=$call21; //@line 1599 "wavegen.cpp"
        __label__ = 15;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1600 "wavegen.cpp"
      }
      else if (__label__ == 14) {
  
        __ZL14WavegenSetEchov(); //@line 1603 "wavegen.cpp"
        __label__ = 15;break $sw_epilog$$sw_bb$$sw_bb17$$sw_bb18$$sw_bb20$$sw_bb22$14; //@line 1604 "wavegen.cpp"
      }
    } while(0);
    if (__label__ == 11) {
  
      __ZL16SetPitchFormantsv(); //@line 1591 "wavegen.cpp"
      ; //@line 1592 "wavegen.cpp"
    }
  
    ;
    return; //@line 1606 "wavegen.cpp"
    return;
  }
  

  function __ZL13SetWithRange0ii($value, $max) {
    ;
    var __label__;
  
    var $retval;
    var $value_addr;
    var $max_addr;
    $value_addr=$value;
    $max_addr=$max;
    var $0=$value_addr; //@line 1535 "wavegen.cpp"
    var $cmp=((($0))|0) < 0; //@line 1535 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1535 "wavegen.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1536 "wavegen.cpp"
      ; //@line 1536 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$value_addr; //@line 1537 "wavegen.cpp"
      var $2=$max_addr; //@line 1537 "wavegen.cpp"
      var $cmp1=((($1))|0) > ((($2))|0); //@line 1537 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1537 "wavegen.cpp"
      if (__label__ == 3) {
  
        var $3=$max_addr; //@line 1538 "wavegen.cpp"
        $retval=$3; //@line 1538 "wavegen.cpp"
        ; //@line 1538 "wavegen.cpp"
      }
      else if (__label__ == 4) {
  
        var $4=$value_addr; //@line 1539 "wavegen.cpp"
        $retval=$4; //@line 1539 "wavegen.cpp"
        ; //@line 1539 "wavegen.cpp"
      }
    }
  
    var $5=$retval; //@line 1540 "wavegen.cpp"
    ;
    return $5; //@line 1540 "wavegen.cpp"
    return null;
  }
  

  function __ZL14WavegenSetEchov() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $delay;
    var $amp;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 803 "wavegen.cpp"
    var $voicing=(($0+92)&4294967295); //@line 803 "wavegen.cpp"
    var $1=HEAP32[(($voicing)>>2)]; //@line 803 "wavegen.cpp"
    HEAP32[((__ZL7voicing)>>2)]=$1; //@line 803 "wavegen.cpp"
    var $2=HEAP32[((_wvoice)>>2)]; //@line 804 "wavegen.cpp"
    var $echo_delay=(($2+76)&4294967295); //@line 804 "wavegen.cpp"
    var $3=HEAP32[(($echo_delay)>>2)]; //@line 804 "wavegen.cpp"
    $delay=$3; //@line 804 "wavegen.cpp"
    var $4=HEAP32[((_wvoice)>>2)]; //@line 805 "wavegen.cpp"
    var $echo_amp=(($4+80)&4294967295); //@line 805 "wavegen.cpp"
    var $5=HEAP32[(($echo_amp)>>2)]; //@line 805 "wavegen.cpp"
    $amp=$5; //@line 805 "wavegen.cpp"
    var $6=$delay; //@line 807 "wavegen.cpp"
    var $cmp=((($6))|0) >= 5500; //@line 807 "wavegen.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 807 "wavegen.cpp"
    if (__label__ == 1) {
  
      $delay=5499; //@line 808 "wavegen.cpp"
      var $_pr=$amp; //@line 809 "wavegen.cpp"
      __lastLabel__ = 1; ; //@line 808 "wavegen.cpp"
    }
  
    var $7=__lastLabel__ == 1 ? $_pr : ($5); //@line 809 "wavegen.cpp"
    var $cmp1=((($7))|0) > 100; //@line 809 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 809 "wavegen.cpp"
    if (__label__ == 3) {
  
      $amp=100; //@line 810 "wavegen.cpp"
      ; //@line 810 "wavegen.cpp"
    }
  
    var $dest$, $stop$, $stop4$, $fast$, $value4$;
    $dest$ = _echo_buf;
    $stop$ = $dest$ + 11000;
    $value4$ = 0;
    if ($value4$ < 0) $value4$ += 256;
    $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
    while ($dest$%4 !== 0 && $dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }
    $dest$ >>= 2;
    $stop4$ = $stop$ >> 2;
    while ($dest$ < $stop4$) {
    ;;;;;;;  HEAP32[$dest$++] = $value4$;
    }
    $dest$ <<= 2;
    while ($dest$ < $stop$) {
      ;; HEAP8[$dest$++] = 0;
    }; //@line 812 "wavegen.cpp"
    HEAP32[((_echo_tail)>>2)]=0; //@line 813 "wavegen.cpp"
    var $8=HEAP32[((((_embedded_value+20)&4294967295))>>2)]; //@line 815 "wavegen.cpp"
    var $cmp4=((($8))|0) > 0; //@line 815 "wavegen.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 815 "wavegen.cpp"
    $if_end6_thread$$if_end6$8: do { 
      if (__label__ == 5) {
  
        var $9=HEAP32[((((_embedded_value+20)&4294967295))>>2)]; //@line 818 "wavegen.cpp"
        $amp=$9; //@line 818 "wavegen.cpp"
        $delay=130; //@line 819 "wavegen.cpp"
        ; //@line 831 "wavegen.cpp"
      }
      else if (__label__ == 6) {
  
        var $_pr1=$delay; //@line 831 "wavegen.cpp"
        var $cmp7=((($_pr1))|0)==0; //@line 831 "wavegen.cpp"
        if (!($cmp7)) { __label__ = 8;break $if_end6_thread$$if_end6$8; } //@line 831 "wavegen.cpp"
  
        $amp=0; //@line 832 "wavegen.cpp"
        ; //@line 832 "wavegen.cpp"
      }
    } while(0);
  
    var $10=$delay; //@line 834 "wavegen.cpp"
    var $11=HEAP32[((_samplerate)>>2)]; //@line 834 "wavegen.cpp"
    var $mul=((($11)*($10))&4294967295); //@line 834 "wavegen.cpp"
    var $div=((((($mul))|0)/1000)|0); //@line 834 "wavegen.cpp"
    HEAP32[((_echo_head)>>2)]=$div; //@line 834 "wavegen.cpp"
    var $12=HEAP32[((_echo_head)>>2)]; //@line 835 "wavegen.cpp"
    HEAP32[((__ZL11echo_length)>>2)]=$12; //@line 835 "wavegen.cpp"
    var $13=$amp; //@line 836 "wavegen.cpp"
    var $cmp10=((($13))|0)==0; //@line 836 "wavegen.cpp"
    if ($cmp10) { __lastLabel__ = 8; __label__ = 9;; } else { __lastLabel__ = 8; __label__ = 10;; } //@line 836 "wavegen.cpp"
    if (__label__ == 9) {
  
      HEAP32[((__ZL11echo_length)>>2)]=0; //@line 837 "wavegen.cpp"
      var $_pr3=$amp; //@line 838 "wavegen.cpp"
      __lastLabel__ = 9; ; //@line 837 "wavegen.cpp"
    }
  
    var $14=__lastLabel__ == 9 ? $_pr3 : ($13); //@line 838 "wavegen.cpp"
    var $cmp13=((($14))|0) > 20; //@line 838 "wavegen.cpp"
    if ($cmp13) { __label__ = 11;; } else { __label__ = 12;; } //@line 838 "wavegen.cpp"
    if (__label__ == 11) {
  
      var $15=HEAP32[((_echo_head)>>2)]; //@line 839 "wavegen.cpp"
      var $mul15=((($15)*2)&4294967295); //@line 839 "wavegen.cpp"
      HEAP32[((__ZL11echo_length)>>2)]=$mul15; //@line 839 "wavegen.cpp"
      ; //@line 839 "wavegen.cpp"
    }
  
    var $16=$amp; //@line 842 "wavegen.cpp"
    HEAP32[((_echo_amp)>>2)]=$16; //@line 842 "wavegen.cpp"
    var $call=__Z12GetAmplitudev(); //@line 844 "wavegen.cpp"
    HEAP32[((__ZL17general_amplitude)>>2)]=$call; //@line 844 "wavegen.cpp"
    var $17=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 845 "wavegen.cpp"
    var $18=$amp; //@line 845 "wavegen.cpp"
    var $sub=((500-($18))&4294967295); //@line 845 "wavegen.cpp"
    var $mul17=((($sub)*($17))&4294967295); //@line 845 "wavegen.cpp"
    var $div18=((((($mul17))|0)/500)|0); //@line 845 "wavegen.cpp"
    HEAP32[((__ZL17general_amplitude)>>2)]=$div18; //@line 845 "wavegen.cpp"
    ;
    return; //@line 846 "wavegen.cpp"
    return;
  }
  

  function __ZL16SetPitchFormantsv() {
    ;
    var __label__;
  
    var $ix;
    var $factor;
    var $pitch_value;
    var $0=HEAP32[((((_embedded_value+4)&4294967295))>>2)]; //@line 1550 "wavegen.cpp"
    $pitch_value=$0; //@line 1550 "wavegen.cpp"
    var $cmp=((($0))|0) > 101; //@line 1550 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1550 "wavegen.cpp"
    if (__label__ == 1) {
  
      $pitch_value=101; //@line 1551 "wavegen.cpp"
      ; //@line 1551 "wavegen.cpp"
    }
  
    var $1=$pitch_value; //@line 1553 "wavegen.cpp"
    var $sub=((($1)-50)&4294967295); //@line 1553 "wavegen.cpp"
    var $mul=((($sub)*25)&4294967295); //@line 1553 "wavegen.cpp"
    var $div=((((($mul))|0)/50)|0); //@line 1553 "wavegen.cpp"
    var $add=((($div)+256)&4294967295); //@line 1553 "wavegen.cpp"
    $factor=$add; //@line 1553 "wavegen.cpp"
    $ix=0; //@line 1554 "wavegen.cpp"
    ; //@line 1554 "wavegen.cpp"
    while(1) { 
  
      var $2=$ix; //@line 1556 "wavegen.cpp"
      var $3=HEAP32[((_wvoice)>>2)]; //@line 1556 "wavegen.cpp"
      var $freq2=(($3+216)&4294967295); //@line 1556 "wavegen.cpp"
      var $arrayidx=(($freq2+$2*2)&4294967295); //@line 1556 "wavegen.cpp"
      var $4=HEAP16[(($arrayidx)>>1)]; //@line 1556 "wavegen.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1556 "wavegen.cpp"
      var $5=$factor; //@line 1556 "wavegen.cpp"
      var $mul2=((($conv)*($5))&4294967295); //@line 1556 "wavegen.cpp"
      var $div3=((((($mul2))|0)/256)|0); //@line 1556 "wavegen.cpp"
      var $conv4=((($div3)) & 65535); //@line 1556 "wavegen.cpp"
      var $6=$ix; //@line 1556 "wavegen.cpp"
      var $7=HEAP32[((_wvoice)>>2)]; //@line 1556 "wavegen.cpp"
      var $freq=(($7+144)&4294967295); //@line 1556 "wavegen.cpp"
      var $arrayidx5=(($freq+$6*2)&4294967295); //@line 1556 "wavegen.cpp"
      HEAP16[(($arrayidx5)>>1)]=$conv4; //@line 1556 "wavegen.cpp"
      var $8=$ix; //@line 1554 "wavegen.cpp"
      var $inc=((($8)+1)&4294967295); //@line 1554 "wavegen.cpp"
      $ix=$inc; //@line 1554 "wavegen.cpp"
      var $cmp1=((($inc))|0) <= 5; //@line 1554 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;continue ; } else { __label__ = 4;break ; } //@line 1554 "wavegen.cpp"
    }
  
    var $9=HEAP32[((((_embedded_value+24)&4294967295))>>2)]; //@line 1558 "wavegen.cpp"
    var $mul6=((($9)*3)&4294967295); //@line 1558 "wavegen.cpp"
    $factor=$mul6; //@line 1558 "wavegen.cpp"
    var $10=HEAP32[((_wvoice)>>2)]; //@line 1559 "wavegen.cpp"
    var $height2=(($10+234)&4294967295); //@line 1559 "wavegen.cpp"
    var $arrayidx7=(($height2)&4294967295); //@line 1559 "wavegen.cpp"
    var $11=HEAP16[(($arrayidx7)>>1)]; //@line 1559 "wavegen.cpp"
    var $conv8=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1559 "wavegen.cpp"
    var $12=$factor; //@line 1559 "wavegen.cpp"
    var $mul9=((($12)*2)&4294967295); //@line 1559 "wavegen.cpp"
    var $sub10=((256-($mul9))&4294967295); //@line 1559 "wavegen.cpp"
    var $mul11=((($sub10)*($conv8))&4294967295); //@line 1559 "wavegen.cpp"
    var $div12=((((($mul11))|0)/256)|0); //@line 1559 "wavegen.cpp"
    var $conv13=((($div12)) & 65535); //@line 1559 "wavegen.cpp"
    var $13=HEAP32[((_wvoice)>>2)]; //@line 1559 "wavegen.cpp"
    var $height=(($13+162)&4294967295); //@line 1559 "wavegen.cpp"
    var $arrayidx14=(($height)&4294967295); //@line 1559 "wavegen.cpp"
    HEAP16[(($arrayidx14)>>1)]=$conv13; //@line 1559 "wavegen.cpp"
    var $14=HEAP32[((_wvoice)>>2)]; //@line 1560 "wavegen.cpp"
    var $height215=(($14+234)&4294967295); //@line 1560 "wavegen.cpp"
    var $arrayidx16=(($height215+2)&4294967295); //@line 1560 "wavegen.cpp"
    var $15=HEAP16[(($arrayidx16)>>1)]; //@line 1560 "wavegen.cpp"
    var $conv17=(tempInt=(($15)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1560 "wavegen.cpp"
    var $16=$factor; //@line 1560 "wavegen.cpp"
    var $sub18=((256-($16))&4294967295); //@line 1560 "wavegen.cpp"
    var $mul19=((($sub18)*($conv17))&4294967295); //@line 1560 "wavegen.cpp"
    var $div20=((((($mul19))|0)/256)|0); //@line 1560 "wavegen.cpp"
    var $conv21=((($div20)) & 65535); //@line 1560 "wavegen.cpp"
    var $17=HEAP32[((_wvoice)>>2)]; //@line 1560 "wavegen.cpp"
    var $height22=(($17+162)&4294967295); //@line 1560 "wavegen.cpp"
    var $arrayidx23=(($height22+2)&4294967295); //@line 1560 "wavegen.cpp"
    HEAP16[(($arrayidx23)>>1)]=$conv21; //@line 1560 "wavegen.cpp"
    ;
    return; //@line 1561 "wavegen.cpp"
    return;
  }
  

  function __Z15WavegenSetVoiceP7voice_t($v) {
    ;
    var __label__;
  
    var $v_addr;
    $v_addr=$v;
    var $0=$v_addr; //@line 1613 "wavegen.cpp"
    var $1=$0; //@line 1613 "wavegen.cpp"
    var $src$, $dest$, $stop$, $stop4$, $fast$;
    $src$ = $1;
    $dest$ = ((__ZZ15WavegenSetVoiceP7voice_tE2v2)&4294967295);
    $stop$ = $src$ + 1344;
    if (($dest$%4) == ($src$%4) && 1344 > 8) {
      while ($src$%4 !== 0 && $src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }
      $src$ >>= 2;
      $dest$ >>= 2;
      $stop4$ = $stop$ >> 2;
      while ($src$ < $stop4$) {
    ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
      }
      $src$ <<= 2;
      $dest$ <<= 2;
    }while ($src$ < $stop$) {
      ; HEAP8[$dest$++] = HEAP8[$src$++];
    }; //@line 1613 "wavegen.cpp"
    HEAP32[((_wvoice)>>2)]=__ZZ15WavegenSetVoiceP7voice_tE2v2; //@line 1614 "wavegen.cpp"
    var $2=$v_addr; //@line 1616 "wavegen.cpp"
    var $peak_shape=(($2+88)&4294967295); //@line 1616 "wavegen.cpp"
    var $3=HEAP32[(($peak_shape)>>2)]; //@line 1616 "wavegen.cpp"
    var $cmp=((($3))|0)==0; //@line 1616 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1616 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL8pk_shape)>>2)]=((_pk_shape1)&4294967295); //@line 1617 "wavegen.cpp"
      ; //@line 1617 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      HEAP32[((__ZL8pk_shape)>>2)]=((__ZL9pk_shape2)&4294967295); //@line 1619 "wavegen.cpp"
      ;
    }
  
    var $4=$v_addr; //@line 1621 "wavegen.cpp"
    var $consonant_amp=(($4+100)&4294967295); //@line 1621 "wavegen.cpp"
    var $5=HEAP32[(($consonant_amp)>>2)]; //@line 1621 "wavegen.cpp"
    var $mul=((($5)*26)&4294967295); //@line 1621 "wavegen.cpp"
    var $div=((((($mul))|0)/100)|0); //@line 1621 "wavegen.cpp"
    HEAP32[((__ZL13consonant_amp)>>2)]=$div; //@line 1621 "wavegen.cpp"
    var $6=HEAP32[((_samplerate)>>2)]; //@line 1622 "wavegen.cpp"
    var $cmp1=((($6))|0) <= 11000; //@line 1622 "wavegen.cpp"
    if ($cmp1) { __label__ = 4;; } else { __label__ = 5;; } //@line 1622 "wavegen.cpp"
    if (__label__ == 4) {
  
      var $7=HEAP32[((__ZL13consonant_amp)>>2)]; //@line 1624 "wavegen.cpp"
      var $mul3=((($7)*2)&4294967295); //@line 1624 "wavegen.cpp"
      HEAP32[((__ZL13consonant_amp)>>2)]=$mul3; //@line 1624 "wavegen.cpp"
      HEAP8[(__ZL16option_harmonic1_b)]=1;
      ; //@line 1626 "wavegen.cpp"
    }
  
    __ZL14WavegenSetEchov(); //@line 1627 "wavegen.cpp"
    __ZL16SetPitchFormantsv(); //@line 1628 "wavegen.cpp"
    var $8=HEAP32[((_wvoice)>>2)]; //@line 1629 "wavegen.cpp"
    var $samplerate=(($8+108)&4294967295); //@line 1629 "wavegen.cpp"
    var $9=HEAP32[(($samplerate)>>2)]; //@line 1629 "wavegen.cpp"
    var $10=HEAP32[((_out_ptr)>>2)]; //@line 1629 "wavegen.cpp"
    __Z11MarkerEventijiPh(8, 0, $9, $10); //@line 1629 "wavegen.cpp"
    ;
    return; //@line 1631 "wavegen.cpp"
    return;
  }
  

  function __Z9SetPitch2P7voice_tiiPiS1_($voice, $pitch1, $pitch2, $pitch_base, $pitch_range) {
    ;
    var __label__;
  
    var $voice_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    var $pitch_base_addr;
    var $pitch_range_addr;
    var $x;
    var $base;
    var $range;
    var $pitch_value;
    $voice_addr=$voice;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    $pitch_base_addr=$pitch_base;
    $pitch_range_addr=$pitch_range;
    var $0=$pitch1_addr; //@line 1656 "wavegen.cpp"
    var $1=$pitch2_addr; //@line 1656 "wavegen.cpp"
    var $cmp=((($0))|0) > ((($1))|0); //@line 1656 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1656 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $2=$pitch1_addr; //@line 1658 "wavegen.cpp"
      $x=$2; //@line 1658 "wavegen.cpp"
      var $3=$pitch2_addr; //@line 1659 "wavegen.cpp"
      $pitch1_addr=$3; //@line 1659 "wavegen.cpp"
      var $4=$x; //@line 1660 "wavegen.cpp"
      $pitch2_addr=$4; //@line 1660 "wavegen.cpp"
      ; //@line 1661 "wavegen.cpp"
    }
  
    var $5=HEAP32[((((_embedded_value+4)&4294967295))>>2)]; //@line 1663 "wavegen.cpp"
    $pitch_value=$5; //@line 1663 "wavegen.cpp"
    var $cmp1=((($5))|0) > 101; //@line 1663 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1663 "wavegen.cpp"
    if (__label__ == 3) {
  
      $pitch_value=101; //@line 1664 "wavegen.cpp"
      ; //@line 1664 "wavegen.cpp"
    }
  
    var $6=HEAP32[((((_embedded_value+24)&4294967295))>>2)]; //@line 1665 "wavegen.cpp"
    var $7=$pitch_value; //@line 1665 "wavegen.cpp"
    var $sub=((($7)-($6))&4294967295); //@line 1665 "wavegen.cpp"
    $pitch_value=$sub; //@line 1665 "wavegen.cpp"
    var $cmp4=((($sub))|0) < 0; //@line 1666 "wavegen.cpp"
    if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 1666 "wavegen.cpp"
    if (__label__ == 5) {
  
      $pitch_value=0; //@line 1667 "wavegen.cpp"
      ; //@line 1667 "wavegen.cpp"
    }
  
    var $8=$voice_addr; //@line 1669 "wavegen.cpp"
    var $pitch_base7=(($8+44)&4294967295); //@line 1669 "wavegen.cpp"
    var $9=HEAP32[(($pitch_base7)>>2)]; //@line 1669 "wavegen.cpp"
    var $10=$pitch_value; //@line 1669 "wavegen.cpp"
    var $arrayidx=((_pitch_adjust_tab+$10)&4294967295); //@line 1669 "wavegen.cpp"
    var $11=HEAPU8[($arrayidx)]; //@line 1669 "wavegen.cpp"
    var $conv=((($11))&255); //@line 1669 "wavegen.cpp"
    var $mul=((($conv)*($9))&4294967295); //@line 1669 "wavegen.cpp"
    var $div=((((($mul))|0)/128)|0); //@line 1669 "wavegen.cpp"
    $base=$div; //@line 1669 "wavegen.cpp"
    var $12=$voice_addr; //@line 1670 "wavegen.cpp"
    var $pitch_range8=(($12+48)&4294967295); //@line 1670 "wavegen.cpp"
    var $13=HEAP32[(($pitch_range8)>>2)]; //@line 1670 "wavegen.cpp"
    var $14=HEAP32[((((_embedded_value+16)&4294967295))>>2)]; //@line 1670 "wavegen.cpp"
    var $mul9=((($14)*($13))&4294967295); //@line 1670 "wavegen.cpp"
    var $div10=((((($mul9))|0)/50)|0); //@line 1670 "wavegen.cpp"
    $range=$div10; //@line 1670 "wavegen.cpp"
    var $15=$range; //@line 1673 "wavegen.cpp"
    var $16=$voice_addr; //@line 1673 "wavegen.cpp"
    var $pitch_range11=(($16+48)&4294967295); //@line 1673 "wavegen.cpp"
    var $17=HEAP32[(($pitch_range11)>>2)]; //@line 1673 "wavegen.cpp"
    var $sub12=((($15)-($17))&4294967295); //@line 1673 "wavegen.cpp"
    var $mul13=((($sub12)*18)&4294967295); //@line 1673 "wavegen.cpp"
    var $18=$base; //@line 1673 "wavegen.cpp"
    var $sub14=((($18)-($mul13))&4294967295); //@line 1673 "wavegen.cpp"
    $base=$sub14; //@line 1673 "wavegen.cpp"
    var $19=$base; //@line 1675 "wavegen.cpp"
    var $20=$pitch1_addr; //@line 1675 "wavegen.cpp"
    var $21=$range; //@line 1675 "wavegen.cpp"
    var $mul15=((($21)*($20))&4294967295); //@line 1675 "wavegen.cpp"
    var $div16=((((($mul15))|0)/2)|0); //@line 1675 "wavegen.cpp"
    var $add=((($div16)+($19))&4294967295); //@line 1675 "wavegen.cpp"
    var $22=$pitch_base_addr; //@line 1675 "wavegen.cpp"
    HEAP32[(($22)>>2)]=$add; //@line 1675 "wavegen.cpp"
    var $23=$base; //@line 1676 "wavegen.cpp"
    var $24=$pitch2_addr; //@line 1676 "wavegen.cpp"
    var $25=$range; //@line 1676 "wavegen.cpp"
    var $mul17=((($25)*($24))&4294967295); //@line 1676 "wavegen.cpp"
    var $div18=((((($mul17))|0)/2)|0); //@line 1676 "wavegen.cpp"
    var $26=$pitch_base_addr; //@line 1676 "wavegen.cpp"
    var $27=HEAP32[(($26)>>2)]; //@line 1676 "wavegen.cpp"
    var $_neg=(((-($27)))&4294967295);
    var $add19=((($div18)+($23))&4294967295); //@line 1676 "wavegen.cpp"
    var $sub20=((($add19)+($_neg))&4294967295); //@line 1676 "wavegen.cpp"
    var $28=$pitch_range_addr; //@line 1676 "wavegen.cpp"
    HEAP32[(($28)>>2)]=$sub20; //@line 1676 "wavegen.cpp"
    ;
    return; //@line 1677 "wavegen.cpp"
    return;
  }
  

  function __Z8SetPitchiPhii($length, $env, $pitch1, $pitch2) {
    ;
    var __label__;
  
    var $length_addr;
    var $env_addr;
    var $pitch1_addr;
    var $pitch2_addr;
    $length_addr=$length;
    $env_addr=$env;
    $pitch1_addr=$pitch1;
    $pitch2_addr=$pitch2;
    var $0=$env_addr; //@line 1696 "wavegen.cpp"
    HEAP32[((((_wdata)&4294967295))>>2)]=$0; //@line 1696 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1696 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1696 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((((_wdata)&4294967295))>>2)]=((_env_fall)&4294967295); //@line 1697 "wavegen.cpp"
      ; //@line 1697 "wavegen.cpp"
    }
  
    HEAP32[((((_wdata+8)&4294967295))>>2)]=0; //@line 1699 "wavegen.cpp"
    var $1=$length_addr; //@line 1700 "wavegen.cpp"
    var $cmp1=((($1))|0)==0; //@line 1700 "wavegen.cpp"
    if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1700 "wavegen.cpp"
    if (__label__ == 3) {
  
      HEAP32[((((_wdata+12)&4294967295))>>2)]=0; //@line 1701 "wavegen.cpp"
      ; //@line 1701 "wavegen.cpp"
    }
    else if (__label__ == 4) {
  
      var $2=$length_addr; //@line 1703 "wavegen.cpp"
      var $div=((2097152/((($2))|0))|0); //@line 1703 "wavegen.cpp"
      HEAP32[((((_wdata+12)&4294967295))>>2)]=$div; //@line 1703 "wavegen.cpp"
      ;
    }
  
    var $3=HEAP32[((_wvoice)>>2)]; //@line 1705 "wavegen.cpp"
    var $4=$pitch1_addr; //@line 1705 "wavegen.cpp"
    var $5=$pitch2_addr; //@line 1705 "wavegen.cpp"
    __Z9SetPitch2P7voice_tiiPiS1_($3, $4, $5, ((_wdata+16)&4294967295), ((_wdata+20)&4294967295)); //@line 1705 "wavegen.cpp"
    var $6=HEAP32[((((_wdata)&4294967295))>>2)]; //@line 1707 "wavegen.cpp"
    var $arrayidx=(($6)&4294967295); //@line 1707 "wavegen.cpp"
    var $7=HEAPU8[($arrayidx)]; //@line 1707 "wavegen.cpp"
    var $conv=((($7))&255); //@line 1707 "wavegen.cpp"
    var $8=HEAP32[((((_wdata+20)&4294967295))>>2)]; //@line 1707 "wavegen.cpp"
    var $mul=((($conv)*($8))&4294967295); //@line 1707 "wavegen.cpp"
    var $shr=($mul) >> 8; //@line 1707 "wavegen.cpp"
    var $9=HEAP32[((((_wdata+16)&4294967295))>>2)]; //@line 1707 "wavegen.cpp"
    var $add=((($shr)+($9))&4294967295); //@line 1707 "wavegen.cpp"
    HEAP32[((((_wdata+4)&4294967295))>>2)]=$add; //@line 1707 "wavegen.cpp"
    var $10=HEAP32[((_wvoice)>>2)]; //@line 1709 "wavegen.cpp"
    var $flutter=(($10+68)&4294967295); //@line 1709 "wavegen.cpp"
    var $11=HEAP32[(($flutter)>>2)]; //@line 1709 "wavegen.cpp"
    HEAP32[((__ZL11flutter_amp)>>2)]=$11; //@line 1709 "wavegen.cpp"
    ;
    return; //@line 1711 "wavegen.cpp"
    return;
  }
  

  function __Z8SetSynthiiP7frame_tS0_P7voice_t($length, $modn, $fr1, $fr2, $v) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $length_addr;
    var $modn_addr;
    var $fr1_addr;
    var $fr2_addr;
    var $v_addr;
    var $ix;
    var $next;
    var $length2;
    var $length4;
    var $qix;
    var $cmd;
    $length_addr=$length;
    $modn_addr=$modn;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    $v_addr=$v;
    HEAP8[(__ZL8end_wave_b)]=1;
    var $0=$modn_addr; //@line 1749 "wavegen.cpp"
    var $and=($0) & 255; //@line 1749 "wavegen.cpp"
    HEAP32[((__ZL15modulation_type)>>2)]=$and; //@line 1749 "wavegen.cpp"
    HEAP32[((__ZL12glottal_flag)>>2)]=0; //@line 1751 "wavegen.cpp"
    var $1=$modn_addr; //@line 1752 "wavegen.cpp"
    var $and1=($1) & 1024; //@line 1752 "wavegen.cpp"
    var $tobool=((($and1))|0)!=0; //@line 1752 "wavegen.cpp"
    if ($tobool) { __label__ = 1;; } else { __label__ = 2;; } //@line 1752 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL12glottal_flag)>>2)]=3; //@line 1754 "wavegen.cpp"
      var $2=$modn_addr; //@line 1755 "wavegen.cpp"
      var $shr=($2) >> 8; //@line 1755 "wavegen.cpp"
      var $and2=($shr) & 3; //@line 1755 "wavegen.cpp"
      var $arrayidx=((__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab1+$and2*4)&4294967295); //@line 1755 "wavegen.cpp"
      var $3=HEAP32[(($arrayidx)>>2)]; //@line 1755 "wavegen.cpp"
      HEAP32[((__ZL14glottal_reduce)>>2)]=$3; //@line 1755 "wavegen.cpp"
      ; //@line 1756 "wavegen.cpp"
    }
  
    var $4=$modn_addr; //@line 1757 "wavegen.cpp"
    var $and3=($4) & 2048; //@line 1757 "wavegen.cpp"
    var $tobool4=((($and3))|0)!=0; //@line 1757 "wavegen.cpp"
    if ($tobool4) { __label__ = 3;; } else { __label__ = 4;; } //@line 1757 "wavegen.cpp"
    if (__label__ == 3) {
  
      HEAP32[((__ZL12glottal_flag)>>2)]=4; //@line 1759 "wavegen.cpp"
      var $5=$modn_addr; //@line 1760 "wavegen.cpp"
      var $shr6=($5) >> 8; //@line 1760 "wavegen.cpp"
      var $and7=($shr6) & 3; //@line 1760 "wavegen.cpp"
      var $arrayidx8=((__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab2+$and7*4)&4294967295); //@line 1760 "wavegen.cpp"
      var $6=HEAP32[(($arrayidx8)>>2)]; //@line 1760 "wavegen.cpp"
      HEAP32[((__ZL14glottal_reduce)>>2)]=$6; //@line 1760 "wavegen.cpp"
      ; //@line 1761 "wavegen.cpp"
    }
  
    var $7=HEAP32[((_wcmdq_head)>>2)]; //@line 1763 "wavegen.cpp"
    var $add=((($7)+1)&4294967295); //@line 1763 "wavegen.cpp"
    $qix=$add; //@line 1763 "wavegen.cpp"
    __lastLabel__ = 4; ; //@line 1763 "wavegen.cpp"
    $for_cond$8: while(1) { 
  
      var $8=__lastLabel__ == 11 ? $inc : ($add); //@line 1765 "wavegen.cpp"
      var $cmp=((($8))|0) >= 160; //@line 1765 "wavegen.cpp"
      if ($cmp) { __label__ = 6;; } else { __label__ = 7;; } //@line 1765 "wavegen.cpp"
      if (__label__ == 6) {
  
        $qix=0; //@line 1765 "wavegen.cpp"
        ; //@line 1765 "wavegen.cpp"
      }
  
      var $9=$qix; //@line 1766 "wavegen.cpp"
      var $10=HEAP32[((_wcmdq_tail)>>2)]; //@line 1766 "wavegen.cpp"
      var $cmp12=((($9))|0)==((($10))|0); //@line 1766 "wavegen.cpp"
      if ($cmp12) { __label__ = 12;break $for_cond$8; } //@line 1766 "wavegen.cpp"
  
      var $11=$qix; //@line 1768 "wavegen.cpp"
      var $arrayidx15=((_wcmdq+$11*16)&4294967295); //@line 1768 "wavegen.cpp"
      var $arrayidx16=(($arrayidx15)&4294967295); //@line 1768 "wavegen.cpp"
      var $12=HEAP32[(($arrayidx16)>>2)]; //@line 1768 "wavegen.cpp"
      $cmd=$12; //@line 1768 "wavegen.cpp"
      var $13=$cmd; //@line 1769 "wavegen.cpp"
      var $cmp17=((($13))|0)==3; //@line 1769 "wavegen.cpp"
      if ($cmp17) { __label__ = 9;break $for_cond$8; } //@line 1769 "wavegen.cpp"
  
      var $14=$cmd; //@line 1774 "wavegen.cpp"
      var $cmp20=((($14))|0)==6; //@line 1774 "wavegen.cpp"
      var $15=$cmd; //@line 1774 "wavegen.cpp"
      var $cmp21=((($15))|0)==5; //@line 1774 "wavegen.cpp"
      var $or_cond=($cmp20) | ($cmp21); //@line 1774 "wavegen.cpp"
      if ($or_cond) { __label__ = 12;break $for_cond$8; } //@line 1774 "wavegen.cpp"
  
      var $16=$qix; //@line 1763 "wavegen.cpp"
      var $inc=((($16)+1)&4294967295); //@line 1763 "wavegen.cpp"
      $qix=$inc; //@line 1763 "wavegen.cpp"
      __lastLabel__ = 11; __label__ = 5;continue $for_cond$8; //@line 1763 "wavegen.cpp"
    }
    if (__label__ == 9) {
  
      HEAP8[(__ZL8end_wave_b)]=0;
      ; //@line 1772 "wavegen.cpp"
    }
  
    var $17=$length_addr; //@line 1779 "wavegen.cpp"
    var $add24=((($17)+32)&4294967295); //@line 1779 "wavegen.cpp"
    var $and25=($add24) & -64; //@line 1779 "wavegen.cpp"
    $length2=$and25; //@line 1779 "wavegen.cpp"
    var $cmp26=((($and25))|0)==0; //@line 1780 "wavegen.cpp"
    if ($cmp26) { __label__ = 13;; } else { __label__ = 14;; } //@line 1780 "wavegen.cpp"
    if (__label__ == 13) {
  
      $length2=64; //@line 1781 "wavegen.cpp"
      ; //@line 1781 "wavegen.cpp"
    }
  
    var $18=HEAP32[((__ZL11samplecount)>>2)]; //@line 1784 "wavegen.cpp"
    HEAP32[((__ZL17samplecount_start)>>2)]=$18; //@line 1784 "wavegen.cpp"
    var $19=$length2; //@line 1785 "wavegen.cpp"
    var $20=HEAP32[((__ZL8nsamples)>>2)]; //@line 1785 "wavegen.cpp"
    var $add29=((($20)+($19))&4294967295); //@line 1785 "wavegen.cpp"
    HEAP32[((__ZL8nsamples)>>2)]=$add29; //@line 1785 "wavegen.cpp"
    var $21=$length2; //@line 1787 "wavegen.cpp"
    var $div=((((($21))|0)/4)|0); //@line 1787 "wavegen.cpp"
    $length4=$div; //@line 1787 "wavegen.cpp"
    var $22=$v_addr; //@line 1789 "wavegen.cpp"
    var $freq=(($22+144)&4294967295); //@line 1789 "wavegen.cpp"
    var $arrayidx30=(($freq+14)&4294967295); //@line 1789 "wavegen.cpp"
    var $23=HEAP16[(($arrayidx30)>>1)]; //@line 1789 "wavegen.cpp"
    var $conv=(tempInt=(($23)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1789 "wavegen.cpp"
    var $mul=((($conv)*7800)&4294967295); //@line 1789 "wavegen.cpp"
    var $24=$v_addr; //@line 1789 "wavegen.cpp"
    var $freqadd=(($24+198)&4294967295); //@line 1789 "wavegen.cpp"
    var $arrayidx31=(($freqadd+14)&4294967295); //@line 1789 "wavegen.cpp"
    var $25=HEAP16[(($arrayidx31)>>1)]; //@line 1789 "wavegen.cpp"
    var $conv32=(tempInt=(($25)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1789 "wavegen.cpp"
    var $mul33=((($conv32)*256)&4294967295); //@line 1789 "wavegen.cpp"
    var $add34=((($mul33)+($mul))&4294967295); //@line 1789 "wavegen.cpp"
    var $shl=($add34) << 8; //@line 1789 "wavegen.cpp"
    HEAP32[((((__ZL5peaks+560)&4294967295))>>2)]=$shl; //@line 1789 "wavegen.cpp"
    var $26=$v_addr; //@line 1790 "wavegen.cpp"
    var $freq35=(($26+144)&4294967295); //@line 1790 "wavegen.cpp"
    var $arrayidx36=(($freq35+16)&4294967295); //@line 1790 "wavegen.cpp"
    var $27=HEAP16[(($arrayidx36)>>1)]; //@line 1790 "wavegen.cpp"
    var $conv37=(tempInt=(($27)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1790 "wavegen.cpp"
    var $mul38=((($conv37)*9000)&4294967295); //@line 1790 "wavegen.cpp"
    var $28=$v_addr; //@line 1790 "wavegen.cpp"
    var $freqadd39=(($28+198)&4294967295); //@line 1790 "wavegen.cpp"
    var $arrayidx40=(($freqadd39+16)&4294967295); //@line 1790 "wavegen.cpp"
    var $29=HEAP16[(($arrayidx40)>>1)]; //@line 1790 "wavegen.cpp"
    var $conv41=(tempInt=(($29)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1790 "wavegen.cpp"
    var $mul42=((($conv41)*256)&4294967295); //@line 1790 "wavegen.cpp"
    var $add43=((($mul42)+($mul38))&4294967295); //@line 1790 "wavegen.cpp"
    var $shl44=($add43) << 8; //@line 1790 "wavegen.cpp"
    HEAP32[((((__ZL5peaks+640)&4294967295))>>2)]=$shl44; //@line 1790 "wavegen.cpp"
    $ix=0; //@line 1792 "wavegen.cpp"
    __lastLabel__ = 14; ; //@line 1792 "wavegen.cpp"
    $for_body$22: while(1) { 
  
      var $30=__lastLabel__ == 14 ? 0 : ($inc187); //@line 1794 "wavegen.cpp"
      var $cmp47=((($30))|0) < 7; //@line 1794 "wavegen.cpp"
      if ($cmp47) { __label__ = 16;; } else { __label__ = 17;; } //@line 1794 "wavegen.cpp"
      if (__label__ == 16) {
  
        var $31=$ix; //@line 1796 "wavegen.cpp"
        var $32=$fr1_addr; //@line 1796 "wavegen.cpp"
        var $ffreq=(($32+2)&4294967295); //@line 1796 "wavegen.cpp"
        var $arrayidx49=(($ffreq+$31*2)&4294967295); //@line 1796 "wavegen.cpp"
        var $33=HEAP16[(($arrayidx49)>>1)]; //@line 1796 "wavegen.cpp"
        var $conv50=(tempInt=(($33)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1796 "wavegen.cpp"
        var $34=$ix; //@line 1796 "wavegen.cpp"
        var $35=$v_addr; //@line 1796 "wavegen.cpp"
        var $freq51=(($35+144)&4294967295); //@line 1796 "wavegen.cpp"
        var $arrayidx52=(($freq51+$34*2)&4294967295); //@line 1796 "wavegen.cpp"
        var $36=HEAP16[(($arrayidx52)>>1)]; //@line 1796 "wavegen.cpp"
        var $conv53=(tempInt=(($36)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1796 "wavegen.cpp"
        var $mul54=((($conv53)*($conv50))&4294967295); //@line 1796 "wavegen.cpp"
        var $37=$ix; //@line 1796 "wavegen.cpp"
        var $38=$v_addr; //@line 1796 "wavegen.cpp"
        var $freqadd55=(($38+198)&4294967295); //@line 1796 "wavegen.cpp"
        var $arrayidx56=(($freqadd55+$37*2)&4294967295); //@line 1796 "wavegen.cpp"
        var $39=HEAP16[(($arrayidx56)>>1)]; //@line 1796 "wavegen.cpp"
        var $conv57=(tempInt=(($39)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1796 "wavegen.cpp"
        var $mul58=((($conv57)*256)&4294967295); //@line 1796 "wavegen.cpp"
        var $add59=((($mul58)+($mul54))&4294967295); //@line 1796 "wavegen.cpp"
        var $shl60=($add59) << 8; //@line 1796 "wavegen.cpp"
        var $conv61=((($shl60))|0); //@line 1796 "wavegen.cpp"
        var $40=$ix; //@line 1796 "wavegen.cpp"
        var $arrayidx62=((__ZL5peaks+$40*80)&4294967295); //@line 1796 "wavegen.cpp"
        var $freq1=(($arrayidx62+16)&4294967295); //@line 1796 "wavegen.cpp"
        HEAPF32[(($freq1)>>2)]=$conv61; //@line 1796 "wavegen.cpp"
        var $41=$ix; //@line 1797 "wavegen.cpp"
        var $arrayidx63=((__ZL5peaks+$41*80)&4294967295); //@line 1797 "wavegen.cpp"
        var $freq164=(($arrayidx63+16)&4294967295); //@line 1797 "wavegen.cpp"
        var $42=HEAPF32[(($freq164)>>2)]; //@line 1797 "wavegen.cpp"
        var $conv65=((($42))|0); //@line 1797 "wavegen.cpp"
        var $43=$ix; //@line 1797 "wavegen.cpp"
        var $arrayidx66=((__ZL5peaks+$43*80)&4294967295); //@line 1797 "wavegen.cpp"
        var $freq67=(($arrayidx66)&4294967295); //@line 1797 "wavegen.cpp"
        HEAP32[(($freq67)>>2)]=$conv65; //@line 1797 "wavegen.cpp"
        var $44=$ix; //@line 1798 "wavegen.cpp"
        var $45=$fr2_addr; //@line 1798 "wavegen.cpp"
        var $ffreq68=(($45+2)&4294967295); //@line 1798 "wavegen.cpp"
        var $arrayidx69=(($ffreq68+$44*2)&4294967295); //@line 1798 "wavegen.cpp"
        var $46=HEAP16[(($arrayidx69)>>1)]; //@line 1798 "wavegen.cpp"
        var $conv70=(tempInt=(($46)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1798 "wavegen.cpp"
        var $47=$ix; //@line 1798 "wavegen.cpp"
        var $48=$v_addr; //@line 1798 "wavegen.cpp"
        var $freq71=(($48+144)&4294967295); //@line 1798 "wavegen.cpp"
        var $arrayidx72=(($freq71+$47*2)&4294967295); //@line 1798 "wavegen.cpp"
        var $49=HEAP16[(($arrayidx72)>>1)]; //@line 1798 "wavegen.cpp"
        var $conv73=(tempInt=(($49)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1798 "wavegen.cpp"
        var $mul74=((($conv73)*($conv70))&4294967295); //@line 1798 "wavegen.cpp"
        var $50=$ix; //@line 1798 "wavegen.cpp"
        var $51=$v_addr; //@line 1798 "wavegen.cpp"
        var $freqadd75=(($51+198)&4294967295); //@line 1798 "wavegen.cpp"
        var $arrayidx76=(($freqadd75+$50*2)&4294967295); //@line 1798 "wavegen.cpp"
        var $52=HEAP16[(($arrayidx76)>>1)]; //@line 1798 "wavegen.cpp"
        var $conv77=(tempInt=(($52)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1798 "wavegen.cpp"
        var $mul78=((($conv77)*256)&4294967295); //@line 1798 "wavegen.cpp"
        var $add79=((($mul78)+($mul74))&4294967295); //@line 1798 "wavegen.cpp"
        var $shl80=($add79) << 8; //@line 1798 "wavegen.cpp"
        var $conv81=((($shl80))|0); //@line 1798 "wavegen.cpp"
        $next=$conv81; //@line 1798 "wavegen.cpp"
        var $53=$next; //@line 1799 "wavegen.cpp"
        var $54=$ix; //@line 1799 "wavegen.cpp"
        var $arrayidx82=((__ZL5peaks+$54*80)&4294967295); //@line 1799 "wavegen.cpp"
        var $freq183=(($arrayidx82+16)&4294967295); //@line 1799 "wavegen.cpp"
        var $55=HEAPF32[(($freq183)>>2)]; //@line 1799 "wavegen.cpp"
        var $sub=($53)-($55); //@line 1799 "wavegen.cpp"
        var $mul84=($sub)*16; //@line 1799 "wavegen.cpp"
        var $56=$length4; //@line 1799 "wavegen.cpp"
        var $conv85=((($56))|0); //@line 1799 "wavegen.cpp"
        var $div86=($mul84)/($conv85); //@line 1799 "wavegen.cpp"
        var $57=$ix; //@line 1799 "wavegen.cpp"
        var $arrayidx87=((__ZL5peaks+$57*80)&4294967295); //@line 1799 "wavegen.cpp"
        var $freq_inc=(($arrayidx87+48)&4294967295); //@line 1799 "wavegen.cpp"
        HEAPF32[(($freq_inc)>>2)]=$div86; //@line 1799 "wavegen.cpp"
        ; //@line 1800 "wavegen.cpp"
      }
  
      var $58=$ix; //@line 1802 "wavegen.cpp"
      var $59=$fr1_addr; //@line 1802 "wavegen.cpp"
      var $fheight=(($59+18)&4294967295); //@line 1802 "wavegen.cpp"
      var $arrayidx89=(($fheight+$58)&4294967295); //@line 1802 "wavegen.cpp"
      var $60=HEAPU8[($arrayidx89)]; //@line 1802 "wavegen.cpp"
      var $conv90=((($60))&255); //@line 1802 "wavegen.cpp"
      var $61=$ix; //@line 1802 "wavegen.cpp"
      var $62=$v_addr; //@line 1802 "wavegen.cpp"
      var $height=(($62+162)&4294967295); //@line 1802 "wavegen.cpp"
      var $arrayidx91=(($height+$61*2)&4294967295); //@line 1802 "wavegen.cpp"
      var $63=HEAP16[(($arrayidx91)>>1)]; //@line 1802 "wavegen.cpp"
      var $conv92=(tempInt=(($63)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1802 "wavegen.cpp"
      var $mul93=((($conv90)*64)&4294967295); //@line 1802 "wavegen.cpp"
      var $shl94=((($mul93)*($conv92))&4294967295); //@line 1802 "wavegen.cpp"
      var $conv95=((($shl94))|0); //@line 1802 "wavegen.cpp"
      var $64=$ix; //@line 1802 "wavegen.cpp"
      var $arrayidx96=((__ZL5peaks+$64*80)&4294967295); //@line 1802 "wavegen.cpp"
      var $height1=(($arrayidx96+24)&4294967295); //@line 1802 "wavegen.cpp"
      HEAPF32[(($height1)>>2)]=$conv95; //@line 1802 "wavegen.cpp"
      var $65=$ix; //@line 1803 "wavegen.cpp"
      var $arrayidx97=((__ZL5peaks+$65*80)&4294967295); //@line 1803 "wavegen.cpp"
      var $height198=(($arrayidx97+24)&4294967295); //@line 1803 "wavegen.cpp"
      var $66=HEAPF32[(($height198)>>2)]; //@line 1803 "wavegen.cpp"
      var $conv99=((($66))|0); //@line 1803 "wavegen.cpp"
      var $67=$ix; //@line 1803 "wavegen.cpp"
      var $arrayidx100=((__ZL5peaks+$67*80)&4294967295); //@line 1803 "wavegen.cpp"
      var $height101=(($arrayidx100+4)&4294967295); //@line 1803 "wavegen.cpp"
      HEAP32[(($height101)>>2)]=$conv99; //@line 1803 "wavegen.cpp"
      var $68=$ix; //@line 1804 "wavegen.cpp"
      var $69=$fr2_addr; //@line 1804 "wavegen.cpp"
      var $fheight102=(($69+18)&4294967295); //@line 1804 "wavegen.cpp"
      var $arrayidx103=(($fheight102+$68)&4294967295); //@line 1804 "wavegen.cpp"
      var $70=HEAPU8[($arrayidx103)]; //@line 1804 "wavegen.cpp"
      var $conv104=((($70))&255); //@line 1804 "wavegen.cpp"
      var $71=$ix; //@line 1804 "wavegen.cpp"
      var $72=$v_addr; //@line 1804 "wavegen.cpp"
      var $height105=(($72+162)&4294967295); //@line 1804 "wavegen.cpp"
      var $arrayidx106=(($height105+$71*2)&4294967295); //@line 1804 "wavegen.cpp"
      var $73=HEAP16[(($arrayidx106)>>1)]; //@line 1804 "wavegen.cpp"
      var $conv107=(tempInt=(($73)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1804 "wavegen.cpp"
      var $mul108=((($conv104)*64)&4294967295); //@line 1804 "wavegen.cpp"
      var $shl109=((($mul108)*($conv107))&4294967295); //@line 1804 "wavegen.cpp"
      var $conv110=((($shl109))|0); //@line 1804 "wavegen.cpp"
      $next=$conv110; //@line 1804 "wavegen.cpp"
      var $74=$next; //@line 1805 "wavegen.cpp"
      var $75=$ix; //@line 1805 "wavegen.cpp"
      var $arrayidx111=((__ZL5peaks+$75*80)&4294967295); //@line 1805 "wavegen.cpp"
      var $height1112=(($arrayidx111+24)&4294967295); //@line 1805 "wavegen.cpp"
      var $76=HEAPF32[(($height1112)>>2)]; //@line 1805 "wavegen.cpp"
      var $sub113=($74)-($76); //@line 1805 "wavegen.cpp"
      var $mul114=($sub113)*64; //@line 1805 "wavegen.cpp"
      var $77=$length2; //@line 1805 "wavegen.cpp"
      var $conv115=((($77))|0); //@line 1805 "wavegen.cpp"
      var $div116=($mul114)/($conv115); //@line 1805 "wavegen.cpp"
      var $78=$ix; //@line 1805 "wavegen.cpp"
      var $arrayidx117=((__ZL5peaks+$78*80)&4294967295); //@line 1805 "wavegen.cpp"
      var $height_inc=(($arrayidx117+56)&4294967295); //@line 1805 "wavegen.cpp"
      HEAPF32[(($height_inc)>>2)]=$div116; //@line 1805 "wavegen.cpp"
      var $79=$ix; //@line 1807 "wavegen.cpp"
      var $cmp118=((($79))|0) <= 5; //@line 1807 "wavegen.cpp"
      if ($cmp118) { __label__ = 18;; } else { __label__ = 22;; } //@line 1807 "wavegen.cpp"
      $land_lhs_true$$for_inc186$27: do { 
        if (__label__ == 18) {
  
          var $80=$ix; //@line 1807 "wavegen.cpp"
          var $81=HEAP32[((_wvoice)>>2)]; //@line 1807 "wavegen.cpp"
          var $n_harmonic_peaks=(($81+84)&4294967295); //@line 1807 "wavegen.cpp"
          var $82=HEAP32[(($n_harmonic_peaks)>>2)]; //@line 1807 "wavegen.cpp"
          var $cmp119=((($80))|0) <= ((($82))|0); //@line 1807 "wavegen.cpp"
          if (!($cmp119)) { __label__ = 22;break $land_lhs_true$$for_inc186$27; } //@line 1807 "wavegen.cpp"
  
          var $83=$ix; //@line 1809 "wavegen.cpp"
          var $84=$fr1_addr; //@line 1809 "wavegen.cpp"
          var $fwidth=(($84+26)&4294967295); //@line 1809 "wavegen.cpp"
          var $arrayidx121=(($fwidth+$83)&4294967295); //@line 1809 "wavegen.cpp"
          var $85=HEAPU8[($arrayidx121)]; //@line 1809 "wavegen.cpp"
          var $conv122=((($85))&255); //@line 1809 "wavegen.cpp"
          var $86=$ix; //@line 1809 "wavegen.cpp"
          var $87=$v_addr; //@line 1809 "wavegen.cpp"
          var $width=(($87+180)&4294967295); //@line 1809 "wavegen.cpp"
          var $arrayidx123=(($width+$86*2)&4294967295); //@line 1809 "wavegen.cpp"
          var $88=HEAP16[(($arrayidx123)>>1)]; //@line 1809 "wavegen.cpp"
          var $conv124=(tempInt=(($88)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1809 "wavegen.cpp"
          var $mul125=((($conv122)*1024)&4294967295); //@line 1809 "wavegen.cpp"
          var $shl126=((($mul125)*($conv124))&4294967295); //@line 1809 "wavegen.cpp"
          var $conv127=((($shl126))|0); //@line 1809 "wavegen.cpp"
          var $89=$ix; //@line 1809 "wavegen.cpp"
          var $arrayidx128=((__ZL5peaks+$89*80)&4294967295); //@line 1809 "wavegen.cpp"
          var $left1=(($arrayidx128+32)&4294967295); //@line 1809 "wavegen.cpp"
          HEAPF32[(($left1)>>2)]=$conv127; //@line 1809 "wavegen.cpp"
          var $90=$ix; //@line 1810 "wavegen.cpp"
          var $arrayidx129=((__ZL5peaks+$90*80)&4294967295); //@line 1810 "wavegen.cpp"
          var $left1130=(($arrayidx129+32)&4294967295); //@line 1810 "wavegen.cpp"
          var $91=HEAPF32[(($left1130)>>2)]; //@line 1810 "wavegen.cpp"
          var $conv131=((($91))|0); //@line 1810 "wavegen.cpp"
          var $92=$ix; //@line 1810 "wavegen.cpp"
          var $arrayidx132=((__ZL5peaks+$92*80)&4294967295); //@line 1810 "wavegen.cpp"
          var $left=(($arrayidx132+8)&4294967295); //@line 1810 "wavegen.cpp"
          HEAP32[(($left)>>2)]=$conv131; //@line 1810 "wavegen.cpp"
          var $93=$ix; //@line 1811 "wavegen.cpp"
          var $94=$fr2_addr; //@line 1811 "wavegen.cpp"
          var $fwidth133=(($94+26)&4294967295); //@line 1811 "wavegen.cpp"
          var $arrayidx134=(($fwidth133+$93)&4294967295); //@line 1811 "wavegen.cpp"
          var $95=HEAPU8[($arrayidx134)]; //@line 1811 "wavegen.cpp"
          var $conv135=((($95))&255); //@line 1811 "wavegen.cpp"
          var $96=$ix; //@line 1811 "wavegen.cpp"
          var $97=$v_addr; //@line 1811 "wavegen.cpp"
          var $width136=(($97+180)&4294967295); //@line 1811 "wavegen.cpp"
          var $arrayidx137=(($width136+$96*2)&4294967295); //@line 1811 "wavegen.cpp"
          var $98=HEAP16[(($arrayidx137)>>1)]; //@line 1811 "wavegen.cpp"
          var $conv138=(tempInt=(($98)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1811 "wavegen.cpp"
          var $mul139=((($conv135)*1024)&4294967295); //@line 1811 "wavegen.cpp"
          var $shl140=((($mul139)*($conv138))&4294967295); //@line 1811 "wavegen.cpp"
          var $conv141=((($shl140))|0); //@line 1811 "wavegen.cpp"
          $next=$conv141; //@line 1811 "wavegen.cpp"
          var $99=$next; //@line 1812 "wavegen.cpp"
          var $100=$ix; //@line 1812 "wavegen.cpp"
          var $arrayidx142=((__ZL5peaks+$100*80)&4294967295); //@line 1812 "wavegen.cpp"
          var $left1143=(($arrayidx142+32)&4294967295); //@line 1812 "wavegen.cpp"
          var $101=HEAPF32[(($left1143)>>2)]; //@line 1812 "wavegen.cpp"
          var $sub144=($99)-($101); //@line 1812 "wavegen.cpp"
          var $mul145=($sub144)*64; //@line 1812 "wavegen.cpp"
          var $102=$length2; //@line 1812 "wavegen.cpp"
          var $conv146=((($102))|0); //@line 1812 "wavegen.cpp"
          var $div147=($mul145)/($conv146); //@line 1812 "wavegen.cpp"
          var $103=$ix; //@line 1812 "wavegen.cpp"
          var $arrayidx148=((__ZL5peaks+$103*80)&4294967295); //@line 1812 "wavegen.cpp"
          var $left_inc=(($arrayidx148+64)&4294967295); //@line 1812 "wavegen.cpp"
          HEAPF32[(($left_inc)>>2)]=$div147; //@line 1812 "wavegen.cpp"
          var $104=$ix; //@line 1814 "wavegen.cpp"
          var $cmp149=((($104))|0) < 3; //@line 1814 "wavegen.cpp"
          var $105=$ix; //@line 1816 "wavegen.cpp"
          if ($cmp149) { __label__ = 20;; } else { __label__ = 21;; } //@line 1814 "wavegen.cpp"
          if (__label__ == 20) {
  
            var $106=$fr1_addr; //@line 1816 "wavegen.cpp"
            var $fright=(($106+32)&4294967295); //@line 1816 "wavegen.cpp"
            var $arrayidx151=(($fright+$105)&4294967295); //@line 1816 "wavegen.cpp"
            var $107=HEAPU8[($arrayidx151)]; //@line 1816 "wavegen.cpp"
            var $conv152=((($107))&255); //@line 1816 "wavegen.cpp"
            var $108=$ix; //@line 1816 "wavegen.cpp"
            var $109=$v_addr; //@line 1816 "wavegen.cpp"
            var $width153=(($109+180)&4294967295); //@line 1816 "wavegen.cpp"
            var $arrayidx154=(($width153+$108*2)&4294967295); //@line 1816 "wavegen.cpp"
            var $110=HEAP16[(($arrayidx154)>>1)]; //@line 1816 "wavegen.cpp"
            var $conv155=(tempInt=(($110)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1816 "wavegen.cpp"
            var $mul156=((($conv152)*1024)&4294967295); //@line 1816 "wavegen.cpp"
            var $shl157=((($mul156)*($conv155))&4294967295); //@line 1816 "wavegen.cpp"
            var $conv158=((($shl157))|0); //@line 1816 "wavegen.cpp"
            var $111=$ix; //@line 1816 "wavegen.cpp"
            var $arrayidx159=((__ZL5peaks+$111*80)&4294967295); //@line 1816 "wavegen.cpp"
            var $right1=(($arrayidx159+40)&4294967295); //@line 1816 "wavegen.cpp"
            HEAPF32[(($right1)>>2)]=$conv158; //@line 1816 "wavegen.cpp"
            var $112=$ix; //@line 1817 "wavegen.cpp"
            var $arrayidx160=((__ZL5peaks+$112*80)&4294967295); //@line 1817 "wavegen.cpp"
            var $right1161=(($arrayidx160+40)&4294967295); //@line 1817 "wavegen.cpp"
            var $113=HEAPF32[(($right1161)>>2)]; //@line 1817 "wavegen.cpp"
            var $conv162=((($113))|0); //@line 1817 "wavegen.cpp"
            var $114=$ix; //@line 1817 "wavegen.cpp"
            var $arrayidx163=((__ZL5peaks+$114*80)&4294967295); //@line 1817 "wavegen.cpp"
            var $right=(($arrayidx163+12)&4294967295); //@line 1817 "wavegen.cpp"
            HEAP32[(($right)>>2)]=$conv162; //@line 1817 "wavegen.cpp"
            var $115=$ix; //@line 1818 "wavegen.cpp"
            var $116=$fr2_addr; //@line 1818 "wavegen.cpp"
            var $fright164=(($116+32)&4294967295); //@line 1818 "wavegen.cpp"
            var $arrayidx165=(($fright164+$115)&4294967295); //@line 1818 "wavegen.cpp"
            var $117=HEAPU8[($arrayidx165)]; //@line 1818 "wavegen.cpp"
            var $conv166=((($117))&255); //@line 1818 "wavegen.cpp"
            var $118=$ix; //@line 1818 "wavegen.cpp"
            var $119=$v_addr; //@line 1818 "wavegen.cpp"
            var $width167=(($119+180)&4294967295); //@line 1818 "wavegen.cpp"
            var $arrayidx168=(($width167+$118*2)&4294967295); //@line 1818 "wavegen.cpp"
            var $120=HEAP16[(($arrayidx168)>>1)]; //@line 1818 "wavegen.cpp"
            var $conv169=(tempInt=(($120)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1818 "wavegen.cpp"
            var $mul170=((($conv166)*1024)&4294967295); //@line 1818 "wavegen.cpp"
            var $shl171=((($mul170)*($conv169))&4294967295); //@line 1818 "wavegen.cpp"
            var $conv172=((($shl171))|0); //@line 1818 "wavegen.cpp"
            $next=$conv172; //@line 1818 "wavegen.cpp"
            var $121=$next; //@line 1819 "wavegen.cpp"
            var $122=$ix; //@line 1819 "wavegen.cpp"
            var $arrayidx173=((__ZL5peaks+$122*80)&4294967295); //@line 1819 "wavegen.cpp"
            var $right1174=(($arrayidx173+40)&4294967295); //@line 1819 "wavegen.cpp"
            var $123=HEAPF32[(($right1174)>>2)]; //@line 1819 "wavegen.cpp"
            var $sub175=($121)-($123); //@line 1819 "wavegen.cpp"
            var $mul176=($sub175)*64; //@line 1819 "wavegen.cpp"
            var $124=$length2; //@line 1819 "wavegen.cpp"
            var $conv177=((($124))|0); //@line 1819 "wavegen.cpp"
            var $div178=($mul176)/($conv177); //@line 1819 "wavegen.cpp"
            var $125=$ix; //@line 1819 "wavegen.cpp"
            var $arrayidx179=((__ZL5peaks+$125*80)&4294967295); //@line 1819 "wavegen.cpp"
            var $right_inc=(($arrayidx179+72)&4294967295); //@line 1819 "wavegen.cpp"
            HEAPF32[(($right_inc)>>2)]=$div178; //@line 1819 "wavegen.cpp"
            ; //@line 1820 "wavegen.cpp"
          }
          else if (__label__ == 21) {
  
            var $arrayidx180=((__ZL5peaks+$105*80)&4294967295); //@line 1823 "wavegen.cpp"
            var $left181=(($arrayidx180+8)&4294967295); //@line 1823 "wavegen.cpp"
            var $126=HEAP32[(($left181)>>2)]; //@line 1823 "wavegen.cpp"
            var $127=$ix; //@line 1823 "wavegen.cpp"
            var $arrayidx182=((__ZL5peaks+$127*80)&4294967295); //@line 1823 "wavegen.cpp"
            var $right183=(($arrayidx182+12)&4294967295); //@line 1823 "wavegen.cpp"
            HEAP32[(($right183)>>2)]=$126; //@line 1823 "wavegen.cpp"
            ;
          }
        }
      } while(0);
  
      var $128=$ix; //@line 1792 "wavegen.cpp"
      var $inc187=((($128)+1)&4294967295); //@line 1792 "wavegen.cpp"
      $ix=$inc187; //@line 1792 "wavegen.cpp"
      var $cmp46=((($inc187))|0) < 8; //@line 1792 "wavegen.cpp"
      if ($cmp46) { __lastLabel__ = 22; __label__ = 15;continue $for_body$22; } else { __lastLabel__ = 22; __label__ = 23;break $for_body$22; } //@line 1792 "wavegen.cpp"
    }
  
    ;
    return; //@line 1827 "wavegen.cpp"
    return;
  }
  

  function __Z11Write4BytesP7__sFILEi($f, $value) {
    ;
    var __label__;
  
    var $f_addr;
    var $value_addr;
    var $ix;
    $f_addr=$f;
    $value_addr=$value;
    $ix=0; //@line 1843 "wavegen.cpp"
    ; //@line 1843 "wavegen.cpp"
    while(1) { 
  
      var $0=$value_addr; //@line 1845 "wavegen.cpp"
      var $and=($0) & 255; //@line 1845 "wavegen.cpp"
      var $1=$f_addr; //@line 1845 "wavegen.cpp"
      var $call=_fputc($and, $1); //@line 1845 "wavegen.cpp"
      var $2=$value_addr; //@line 1846 "wavegen.cpp"
      var $shr=($2) >> 8; //@line 1846 "wavegen.cpp"
      $value_addr=$shr; //@line 1846 "wavegen.cpp"
      var $3=$ix; //@line 1843 "wavegen.cpp"
      var $inc=((($3)+1)&4294967295); //@line 1843 "wavegen.cpp"
      $ix=$inc; //@line 1843 "wavegen.cpp"
      var $cmp=((($inc))|0) < 4; //@line 1843 "wavegen.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1843 "wavegen.cpp"
    }
  
    ;
    return; //@line 1848 "wavegen.cpp"
    return;
  }
  

  function __Z12WavegenFill2i($fill_zeros) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $fill_zeros_addr;
    var $q;
    var $length;
    var $result;
    $fill_zeros_addr=$fill_zeros;
    ; //@line 1864 "wavegen.cpp"
    $while_cond$2: while(1) { 
  
      var $0=HEAPU32[((_out_ptr)>>2)]; //@line 1864 "wavegen.cpp"
      var $1=HEAPU32[((_out_end)>>2)]; //@line 1864 "wavegen.cpp"
      var $cmp=((($0))>>>0) < ((($1))>>>0); //@line 1864 "wavegen.cpp"
      if (!($cmp)) { __label__ = 36;break $while_cond$2; } //@line 1864 "wavegen.cpp"
  
      var $call=__Z9WcmdqUsedv(); //@line 1866 "wavegen.cpp"
      var $cmp1=((($call))|0) <= 0; //@line 1866 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;break $while_cond$2; } //@line 1866 "wavegen.cpp"
  
      $result=0; //@line 1884 "wavegen.cpp"
      var $12=HEAP32[((_wcmdq_head)>>2)]; //@line 1885 "wavegen.cpp"
      var $arrayidx=((_wcmdq+$12*16)&4294967295); //@line 1885 "wavegen.cpp"
      var $arraydecay=(($arrayidx)&4294967295); //@line 1885 "wavegen.cpp"
      $q=$arraydecay; //@line 1885 "wavegen.cpp"
      var $13=$q; //@line 1886 "wavegen.cpp"
      var $arrayidx14=(($13+4)&4294967295); //@line 1886 "wavegen.cpp"
      var $14=HEAP32[(($arrayidx14)>>2)]; //@line 1886 "wavegen.cpp"
      $length=$14; //@line 1886 "wavegen.cpp"
      var $15=$q; //@line 1888 "wavegen.cpp"
      var $arrayidx15=(($15)&4294967295); //@line 1888 "wavegen.cpp"
      var $16=HEAP32[(($arrayidx15)>>2)]; //@line 1888 "wavegen.cpp"
      if ($16 == 9) {
        __label__ = 11;;
      }
      else if ($16 == 5) {
        __label__ = 12;;
      }
      else if ($16 == 6) {
        __label__ = 15;;
      }
      else if ($16 == 7) {
        __label__ = 16;;
      }
      else if ($16 == 4) {
        __label__ = 19;;
      }
      else if ($16 == 3) {
        __label__ = 20;;
      }
      else if ($16 == 2) {
        __label__ = 21;;
      }
      else if ($16 == 1) {
        __label__ = 22;;
      }
      else if ($16 == 10) {
        __label__ = 23;;
      }
      else if ($16 == 8) {
        __label__ = 25;;
      }
      else if ($16 == 11) {
        __label__ = 26;;
      }
      else if ($16 == 12) {
        __label__ = 27;;
      }
      else if ($16 == 13) {
        __label__ = 28;;
      }
      else if ($16 == 14) {
        __label__ = 29;;
      }
      else if ($16 == 15) {
        __label__ = 31;;
      }
      else {
      __label__ = 32;;
      }
      
      $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6: do { 
        if (__label__ == 11) {
  
          var $17=$length; //@line 1891 "wavegen.cpp"
          var $18=$q; //@line 1891 "wavegen.cpp"
          var $arrayidx16=(($18+8)&4294967295); //@line 1891 "wavegen.cpp"
          var $19=HEAP32[(($arrayidx16)>>2)]; //@line 1891 "wavegen.cpp"
          var $20=($19); //@line 1891 "wavegen.cpp"
          var $21=$q; //@line 1891 "wavegen.cpp"
          var $arrayidx17=(($21+12)&4294967295); //@line 1891 "wavegen.cpp"
          var $22=HEAP32[(($arrayidx17)>>2)]; //@line 1891 "wavegen.cpp"
          var $shr=($22) >> 16; //@line 1891 "wavegen.cpp"
          var $23=$q; //@line 1891 "wavegen.cpp"
          var $arrayidx18=(($23+12)&4294967295); //@line 1891 "wavegen.cpp"
          var $24=HEAP32[(($arrayidx18)>>2)]; //@line 1891 "wavegen.cpp"
          var $and=($24) & 65535; //@line 1891 "wavegen.cpp"
          __Z8SetPitchiPhii($17, $20, $shr, $and); //@line 1891 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1892 "wavegen.cpp"
        }
        else if (__label__ == 12) {
  
          var $25=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1895 "wavegen.cpp"
          var $cmp20=((($25))|0)==0; //@line 1895 "wavegen.cpp"
          if ($cmp20) { __label__ = 13;; } else { __label__ = 14;; } //@line 1895 "wavegen.cpp"
          if (__label__ == 13) {
  
            var $26=$length; //@line 1897 "wavegen.cpp"
            var $27=HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]; //@line 1897 "wavegen.cpp"
            var $sub=((($27)-($26))&4294967295); //@line 1897 "wavegen.cpp"
            HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$sub; //@line 1897 "wavegen.cpp"
            ; //@line 1898 "wavegen.cpp"
          }
  
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1899 "wavegen.cpp"
          HEAP32[((((_wdata+60)&4294967295))>>2)]=100; //@line 1900 "wavegen.cpp"
          __Z10KlattReseti(1); //@line 1901 "wavegen.cpp"
          var $28=$length; //@line 1902 "wavegen.cpp"
          var $29=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1902 "wavegen.cpp"
          var $call23=__ZL11PlaySilenceii($28, $29); //@line 1902 "wavegen.cpp"
          $result=$call23; //@line 1902 "wavegen.cpp"
          __lastLabel__ = 14; __label__ = 33;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1903 "wavegen.cpp"
        }
        else if (__label__ == 15) {
  
          var $30=HEAP32[((__ZL11echo_length)>>2)]; //@line 1906 "wavegen.cpp"
          HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$30; //@line 1906 "wavegen.cpp"
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1907 "wavegen.cpp"
          __Z10KlattReseti(1); //@line 1908 "wavegen.cpp"
          var $31=$length; //@line 1909 "wavegen.cpp"
          var $32=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1909 "wavegen.cpp"
          var $33=$q; //@line 1909 "wavegen.cpp"
          var $arrayidx25=(($33+8)&4294967295); //@line 1909 "wavegen.cpp"
          var $34=HEAP32[(($arrayidx25)>>2)]; //@line 1909 "wavegen.cpp"
          var $35=($34); //@line 1909 "wavegen.cpp"
          var $36=$q; //@line 1909 "wavegen.cpp"
          var $arrayidx26=(($36+12)&4294967295); //@line 1909 "wavegen.cpp"
          var $37=HEAP32[(($arrayidx26)>>2)]; //@line 1909 "wavegen.cpp"
          var $and27=($37) & 255; //@line 1909 "wavegen.cpp"
          var $38=$q; //@line 1909 "wavegen.cpp"
          var $arrayidx28=(($38+12)&4294967295); //@line 1909 "wavegen.cpp"
          var $39=HEAP32[(($arrayidx28)>>2)]; //@line 1909 "wavegen.cpp"
          var $shr29=($39) >> 8; //@line 1909 "wavegen.cpp"
          var $call30=__ZL8PlayWaveiiPhii($31, $32, $35, $and27, $shr29); //@line 1909 "wavegen.cpp"
          $result=$call30; //@line 1909 "wavegen.cpp"
          __lastLabel__ = 15; __label__ = 33;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1910 "wavegen.cpp"
        }
        else if (__label__ == 16) {
  
          var $40=$q; //@line 1914 "wavegen.cpp"
          var $arrayidx32=(($40+12)&4294967295); //@line 1914 "wavegen.cpp"
          var $41=HEAP32[(($arrayidx32)>>2)]; //@line 1914 "wavegen.cpp"
          var $shr33=($41) >> 8; //@line 1914 "wavegen.cpp"
          HEAP32[((((_wdata+36)&4294967295))>>2)]=$shr33; //@line 1914 "wavegen.cpp"
          var $42=$q; //@line 1915 "wavegen.cpp"
          var $arrayidx34=(($42+12)&4294967295); //@line 1915 "wavegen.cpp"
          var $43=HEAP32[(($arrayidx34)>>2)]; //@line 1915 "wavegen.cpp"
          var $and35=($43) & 255; //@line 1915 "wavegen.cpp"
          HEAP32[((((_wdata+32)&4294967295))>>2)]=$and35; //@line 1915 "wavegen.cpp"
          var $44=$length; //@line 1916 "wavegen.cpp"
          var $and36=($44) & 65535; //@line 1916 "wavegen.cpp"
          HEAP32[((((_wdata+28)&4294967295))>>2)]=$and36; //@line 1916 "wavegen.cpp"
          var $45=$length; //@line 1917 "wavegen.cpp"
          var $shr37=($45) >> 16; //@line 1917 "wavegen.cpp"
          var $and38=($shr37) & 65535; //@line 1917 "wavegen.cpp"
          HEAP32[((((_wdata+44)&4294967295))>>2)]=$and38; //@line 1917 "wavegen.cpp"
          var $46=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 1918 "wavegen.cpp"
          var $cmp39=((($46))|0)==0; //@line 1918 "wavegen.cpp"
          if ($cmp39) { __label__ = 17;; } else { __label__ = 18;; } //@line 1918 "wavegen.cpp"
          if (__label__ == 17) {
  
            var $47=HEAP32[((((_wdata+28)&4294967295))>>2)]; //@line 1920 "wavegen.cpp"
            var $mul=((($47)*2)&4294967295); //@line 1920 "wavegen.cpp"
            HEAP32[((((_wdata+28)&4294967295))>>2)]=$mul; //@line 1920 "wavegen.cpp"
            var $48=HEAP32[((((_wdata+44)&4294967295))>>2)]; //@line 1921 "wavegen.cpp"
            var $mul41=((($48)*2)&4294967295); //@line 1921 "wavegen.cpp"
            HEAP32[((((_wdata+44)&4294967295))>>2)]=$mul41; //@line 1921 "wavegen.cpp"
            ; //@line 1922 "wavegen.cpp"
          }
  
          HEAP32[((((_wdata+40)&4294967295))>>2)]=0; //@line 1923 "wavegen.cpp"
          HEAP32[((((_wdata+48)&4294967295))>>2)]=0; //@line 1924 "wavegen.cpp"
          var $49=$q; //@line 1925 "wavegen.cpp"
          var $arrayidx43=(($49+8)&4294967295); //@line 1925 "wavegen.cpp"
          var $50=HEAP32[(($arrayidx43)>>2)]; //@line 1925 "wavegen.cpp"
          var $51=($50); //@line 1925 "wavegen.cpp"
          HEAP32[((((_wdata+24)&4294967295))>>2)]=$51; //@line 1925 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1926 "wavegen.cpp"
        }
        else if (__label__ == 19) {
  
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1929 "wavegen.cpp"
          __label__ = 20;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1929 "wavegen.cpp"
        }
        else if (__label__ == 21) {
  
          HEAP32[((((_wdata+28)&4294967295))>>2)]=0; //@line 1937 "wavegen.cpp"
          __label__ = 22;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1937 "wavegen.cpp"
        }
        else if (__label__ == 23) {
  
          var $74=$q; //@line 1945 "wavegen.cpp"
          var $arrayidx61=(($74+4)&4294967295); //@line 1945 "wavegen.cpp"
          var $75=HEAP32[(($arrayidx61)>>2)]; //@line 1945 "wavegen.cpp"
          var $76=$q; //@line 1945 "wavegen.cpp"
          var $arrayidx62=(($76+8)&4294967295); //@line 1945 "wavegen.cpp"
          var $77=HEAP32[(($arrayidx62)>>2)]; //@line 1945 "wavegen.cpp"
          var $78=$q; //@line 1945 "wavegen.cpp"
          var $arrayidx63=(($78+12)&4294967295); //@line 1945 "wavegen.cpp"
          var $79=HEAP32[(($arrayidx63)>>2)]; //@line 1945 "wavegen.cpp"
          var $80=HEAP32[((_out_ptr)>>2)]; //@line 1945 "wavegen.cpp"
          __Z11MarkerEventijiPh($75, $77, $79, $80); //@line 1945 "wavegen.cpp"
          var $81=$q; //@line 1949 "wavegen.cpp"
          var $arrayidx64=(($81+4)&4294967295); //@line 1949 "wavegen.cpp"
          var $82=HEAP32[(($arrayidx64)>>2)]; //@line 1949 "wavegen.cpp"
          var $cmp65=((($82))|0)==1; //@line 1949 "wavegen.cpp"
          if (!($cmp65)) { __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; } //@line 1949 "wavegen.cpp"
  
          var $83=$q; //@line 1951 "wavegen.cpp"
          var $arrayidx67=(($83+8)&4294967295); //@line 1951 "wavegen.cpp"
          var $84=HEAP32[(($arrayidx67)>>2)]; //@line 1951 "wavegen.cpp"
          var $and68=($84) & 16777215; //@line 1951 "wavegen.cpp"
          HEAP32[((_current_source_index)>>2)]=$and68; //@line 1951 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1952 "wavegen.cpp"
        }
        else if (__label__ == 25) {
  
          var $85=$length; //@line 1956 "wavegen.cpp"
          var $86=$q; //@line 1956 "wavegen.cpp"
          var $arrayidx71=(($86+8)&4294967295); //@line 1956 "wavegen.cpp"
          var $87=HEAP32[(($arrayidx71)>>2)]; //@line 1956 "wavegen.cpp"
          var $88=($87); //@line 1956 "wavegen.cpp"
          var $89=$q; //@line 1956 "wavegen.cpp"
          var $arrayidx72=(($89+12)&4294967295); //@line 1956 "wavegen.cpp"
          var $90=HEAP32[(($arrayidx72)>>2)]; //@line 1956 "wavegen.cpp"
          __ZL12SetAmplitudeiPhi($85, $88, $90); //@line 1956 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1957 "wavegen.cpp"
        }
        else if (__label__ == 26) {
  
          var $91=$q; //@line 1960 "wavegen.cpp"
          var $arrayidx74=(($91+4)&4294967295); //@line 1960 "wavegen.cpp"
          var $92=HEAP32[(($arrayidx74)>>2)]; //@line 1960 "wavegen.cpp"
          var $93=($92); //@line 1960 "wavegen.cpp"
          __Z15WavegenSetVoiceP7voice_t($93); //@line 1960 "wavegen.cpp"
          var $94=$q; //@line 1961 "wavegen.cpp"
          var $arrayidx75=(($94+4)&4294967295); //@line 1961 "wavegen.cpp"
          var $95=HEAP32[(($arrayidx75)>>2)]; //@line 1961 "wavegen.cpp"
          var $96=($95); //@line 1961 "wavegen.cpp"
          var $97=$96; //@line 1961 "wavegen.cpp"
          ; //@line 1961 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1962 "wavegen.cpp"
        }
        else if (__label__ == 27) {
  
          var $98=$q; //@line 1965 "wavegen.cpp"
          var $arrayidx77=(($98+4)&4294967295); //@line 1965 "wavegen.cpp"
          var $99=HEAP32[(($arrayidx77)>>2)]; //@line 1965 "wavegen.cpp"
          var $100=$q; //@line 1965 "wavegen.cpp"
          var $arrayidx78=(($100+8)&4294967295); //@line 1965 "wavegen.cpp"
          var $101=HEAP32[(($arrayidx78)>>2)]; //@line 1965 "wavegen.cpp"
          __Z11SetEmbeddedii($99, $101); //@line 1965 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1966 "wavegen.cpp"
        }
        else if (__label__ == 28) {
  
          var $102=$length; //@line 1969 "wavegen.cpp"
          var $103=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1969 "wavegen.cpp"
          var $call80=__Z10MbrolaFillii($102, $103); //@line 1969 "wavegen.cpp"
          $result=$call80; //@line 1969 "wavegen.cpp"
          __lastLabel__ = 28; __label__ = 33;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1970 "wavegen.cpp"
        }
        else if (__label__ == 29) {
  
          var $104=$q; //@line 1973 "wavegen.cpp"
          var $arrayidx82=(($104+4)&4294967295); //@line 1973 "wavegen.cpp"
          var $105=HEAP32[(($arrayidx82)>>2)]; //@line 1973 "wavegen.cpp"
          HEAP32[((((_wdata+60)&4294967295))>>2)]=$105; //@line 1973 "wavegen.cpp"
          var $cmp83=((($105))|0)==0; //@line 1973 "wavegen.cpp"
          if (!($cmp83)) { __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; } //@line 1973 "wavegen.cpp"
  
          HEAP32[((((_wdata+60)&4294967295))>>2)]=100; //@line 1974 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1974 "wavegen.cpp"
        }
        else if (__label__ == 31) {
  
          var $106=$q; //@line 1978 "wavegen.cpp"
          var $arrayidx87=(($106+4)&4294967295); //@line 1978 "wavegen.cpp"
          var $107=HEAP32[(($arrayidx87)>>2)]; //@line 1978 "wavegen.cpp"
          var $conv=((($107))|0); //@line 1978 "wavegen.cpp"
          var $div=($conv)/1024; //@line 1978 "wavegen.cpp"
          HEAPF32[((_sonicSpeed)>>2)]=$div; //@line 1978 "wavegen.cpp"
          __label__ = 32;break $sw_epilogthread_pre_split$$sw_bb$$sw_bb19$$sw_bb24$$sw_bb31$$sw_bb44$$sw_bb45$$sw_bb52$$sw_bb53$$sw_bb60$$sw_bb70$$sw_bb73$$sw_bb76$$sw_bb79$$sw_bb81$$sw_bb86$6; //@line 1979 "wavegen.cpp"
        }
      } while(0);
      if (__label__ == 32) {
  
        var $_pr=$result; //@line 1982 "wavegen.cpp"
        __lastLabel__ = 32; ;
      }
      else if (__label__ == 20) {
  
        var $52=HEAP32[((__ZL11echo_length)>>2)]; //@line 1931 "wavegen.cpp"
        HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$52; //@line 1931 "wavegen.cpp"
        var $53=$length; //@line 1932 "wavegen.cpp"
        var $and46=($53) & 65535; //@line 1932 "wavegen.cpp"
        var $54=$q; //@line 1932 "wavegen.cpp"
        var $arrayidx47=(($54+4)&4294967295); //@line 1932 "wavegen.cpp"
        var $55=HEAP32[(($arrayidx47)>>2)]; //@line 1932 "wavegen.cpp"
        var $shr48=($55) >> 16; //@line 1932 "wavegen.cpp"
        var $56=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1932 "wavegen.cpp"
        var $57=$q; //@line 1932 "wavegen.cpp"
        var $arrayidx49=(($57+8)&4294967295); //@line 1932 "wavegen.cpp"
        var $58=HEAP32[(($arrayidx49)>>2)]; //@line 1932 "wavegen.cpp"
        var $59=($58); //@line 1932 "wavegen.cpp"
        var $60=$q; //@line 1932 "wavegen.cpp"
        var $arrayidx50=(($60+12)&4294967295); //@line 1932 "wavegen.cpp"
        var $61=HEAP32[(($arrayidx50)>>2)]; //@line 1932 "wavegen.cpp"
        var $62=($61); //@line 1932 "wavegen.cpp"
        var $call51=__ZL8Wavegen2iiiP7frame_tS0_($and46, $shr48, $56, $59, $62); //@line 1932 "wavegen.cpp"
        $result=$call51; //@line 1932 "wavegen.cpp"
        __lastLabel__ = 20; ; //@line 1933 "wavegen.cpp"
      }
      else if (__label__ == 22) {
  
        var $63=HEAP32[((__ZL11echo_length)>>2)]; //@line 1939 "wavegen.cpp"
        HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]=$63; //@line 1939 "wavegen.cpp"
        var $64=$length; //@line 1940 "wavegen.cpp"
        var $and54=($64) & 65535; //@line 1940 "wavegen.cpp"
        var $65=$q; //@line 1940 "wavegen.cpp"
        var $arrayidx55=(($65+4)&4294967295); //@line 1940 "wavegen.cpp"
        var $66=HEAP32[(($arrayidx55)>>2)]; //@line 1940 "wavegen.cpp"
        var $shr56=($66) >> 16; //@line 1940 "wavegen.cpp"
        var $67=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1940 "wavegen.cpp"
        var $68=$q; //@line 1940 "wavegen.cpp"
        var $arrayidx57=(($68+8)&4294967295); //@line 1940 "wavegen.cpp"
        var $69=HEAP32[(($arrayidx57)>>2)]; //@line 1940 "wavegen.cpp"
        var $70=($69); //@line 1940 "wavegen.cpp"
        var $71=$q; //@line 1940 "wavegen.cpp"
        var $arrayidx58=(($71+12)&4294967295); //@line 1940 "wavegen.cpp"
        var $72=HEAP32[(($arrayidx58)>>2)]; //@line 1940 "wavegen.cpp"
        var $73=($72); //@line 1940 "wavegen.cpp"
        var $call59=__Z14Wavegen_Klatt2iiiP7frame_tS0_($and54, $shr56, $67, $70, $73); //@line 1940 "wavegen.cpp"
        $result=$call59; //@line 1940 "wavegen.cpp"
        __lastLabel__ = 22; ; //@line 1941 "wavegen.cpp"
      }
  
      var $108=__lastLabel__ == 32 ? $_pr : (__lastLabel__ == 28 ? $call80 : (__lastLabel__ == 22 ? $call59 : (__lastLabel__ == 20 ? $call51 : (__lastLabel__ == 15 ? $call30 : ($call23))))); //@line 1982 "wavegen.cpp"
      var $cmp88=((($108))|0)==0; //@line 1982 "wavegen.cpp"
      if ($cmp88) { __label__ = 34;; } else { __label__ = 35;; } //@line 1982 "wavegen.cpp"
      if (__label__ == 34) {
  
        __ZL12WcmdqIncHeadv(); //@line 1984 "wavegen.cpp"
        HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]=0; //@line 1985 "wavegen.cpp"
        __label__ = 1;continue $while_cond$2; //@line 1986 "wavegen.cpp"
      }
      else if (__label__ == 35) {
  
        HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]=1; //@line 1989 "wavegen.cpp"
        __label__ = 1;continue $while_cond$2;
      }
    }
    $while_end91$$if_then$36: do { 
      if (__label__ == 36) {
  
        $retval=0; //@line 1993 "wavegen.cpp"
        ; //@line 1993 "wavegen.cpp"
      }
      else if (__label__ == 3) {
  
        var $2=HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]; //@line 1868 "wavegen.cpp"
        var $cmp2=((($2))|0) > 0; //@line 1868 "wavegen.cpp"
        if ($cmp2) { __label__ = 4;; } else { __label__ = 6;; } //@line 1868 "wavegen.cpp"
        $if_then3$$if_end7$39: do { 
          if (__label__ == 4) {
  
            var $3=HEAP32[((__ZZ12WavegenFill2iE13echo_complete)>>2)]; //@line 1871 "wavegen.cpp"
            var $4=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1871 "wavegen.cpp"
            var $call4=__ZL11PlaySilenceii($3, $4); //@line 1871 "wavegen.cpp"
            HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]=$call4; //@line 1871 "wavegen.cpp"
            var $5=HEAP32[((__ZZ12WavegenFill2iE6resume)>>2)]; //@line 1872 "wavegen.cpp"
            var $cmp5=((($5))|0)==1; //@line 1872 "wavegen.cpp"
            if (!($cmp5)) { __label__ = 6;break $if_then3$$if_end7$39; } //@line 1872 "wavegen.cpp"
  
            $retval=0; //@line 1873 "wavegen.cpp"
            __label__ = 37;break $while_end91$$if_then$36; //@line 1873 "wavegen.cpp"
          }
        } while(0);
  
        var $6=$fill_zeros_addr; //@line 1876 "wavegen.cpp"
        var $tobool=((($6))|0)!=0; //@line 1876 "wavegen.cpp"
        if ($tobool) { __label__ = 7;; } else { __label__ = 9;; } //@line 1876 "wavegen.cpp"
        $while_cond9_preheader$$if_end12$43: do { 
          if (__label__ == 7) {
  
            var $7=HEAPU32[((_out_ptr)>>2)]; //@line 1878 "wavegen.cpp"
            var $8=HEAPU32[((_out_end)>>2)]; //@line 1878 "wavegen.cpp"
            var $cmp101=((($7))>>>0) < ((($8))>>>0); //@line 1878 "wavegen.cpp"
            if (!($cmp101)) { __label__ = 9;break $while_cond9_preheader$$if_end12$43; } //@line 1878 "wavegen.cpp"
            while(1) { 
  
              var $9=HEAP32[((_out_ptr)>>2)]; //@line 1879 "wavegen.cpp"
              var $incdec_ptr=(($9+1)&4294967295); //@line 1879 "wavegen.cpp"
              HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 1879 "wavegen.cpp"
              HEAP8[($9)]=0; //@line 1879 "wavegen.cpp"
              var $10=HEAPU32[((_out_ptr)>>2)]; //@line 1878 "wavegen.cpp"
              var $11=HEAPU32[((_out_end)>>2)]; //@line 1878 "wavegen.cpp"
              var $cmp10=((($10))>>>0) < ((($11))>>>0); //@line 1878 "wavegen.cpp"
              if ($cmp10) { __label__ = 8;continue ; } else { __label__ = 9;break $while_cond9_preheader$$if_end12$43; } //@line 1878 "wavegen.cpp"
            }
          }
        } while(0);
  
        $retval=1; //@line 1881 "wavegen.cpp"
        ; //@line 1881 "wavegen.cpp"
      }
    } while(0);
  
    var $109=$retval; //@line 1994 "wavegen.cpp"
    ;
    return $109; //@line 1994 "wavegen.cpp"
    return null;
  }
  

  function __ZL11PlaySilenceii($length, $resume) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $length_addr;
    var $resume_addr;
    var $value;
    $length_addr=$length;
    $resume_addr=$resume;
    $value=0; //@line 1439 "wavegen.cpp"
    HEAP32[((__ZL8nsamples)>>2)]=0; //@line 1441 "wavegen.cpp"
    HEAP32[((__ZL11samplecount)>>2)]=0; //@line 1442 "wavegen.cpp"
    HEAP32[((__ZL9wavephase)>>2)]=2147483647; //@line 1443 "wavegen.cpp"
    var $0=$length_addr; //@line 1445 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1445 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1445 "wavegen.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 1446 "wavegen.cpp"
      ; //@line 1446 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$resume_addr; //@line 1448 "wavegen.cpp"
      var $cmp1=((($1))|0)==0; //@line 1448 "wavegen.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 1448 "wavegen.cpp"
      $if_then2$$while_condthread_pre_split$5: do { 
        if (__label__ == 3) {
  
          var $2=$length_addr; //@line 1449 "wavegen.cpp"
          HEAP32[((__ZZL11PlaySilenceiiE9n_samples)>>2)]=$2; //@line 1449 "wavegen.cpp"
          __lastLabel__ = 3; __label__ = 5;break $if_then2$$while_condthread_pre_split$5; //@line 1449 "wavegen.cpp"
        }
      } while(0);
      while(1) { 
        if (__label__ == 5) {
  
          var $3=__lastLabel__ == 4 ? $_pr : ($2); //@line 1451 "wavegen.cpp"
          var $dec=((($3)-1)&4294967295); //@line 1451 "wavegen.cpp"
          HEAP32[((__ZZL11PlaySilenceiiE9n_samples)>>2)]=$dec; //@line 1451 "wavegen.cpp"
          var $cmp4=((($3))|0) > 0; //@line 1451 "wavegen.cpp"
          if (!($cmp4)) { __label__ = 12;break ; } //@line 1451 "wavegen.cpp"
  
          var $4=HEAP32[((_echo_tail)>>2)]; //@line 1453 "wavegen.cpp"
          var $inc=((($4)+1)&4294967295); //@line 1453 "wavegen.cpp"
          HEAP32[((_echo_tail)>>2)]=$inc; //@line 1453 "wavegen.cpp"
          var $arrayidx=((_echo_buf+$4*2)&4294967295); //@line 1453 "wavegen.cpp"
          var $5=HEAP16[(($arrayidx)>>1)]; //@line 1453 "wavegen.cpp"
          var $conv=(tempInt=(($5)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1453 "wavegen.cpp"
          var $6=HEAP32[((_echo_amp)>>2)]; //@line 1453 "wavegen.cpp"
          var $mul=((($conv)*($6))&4294967295); //@line 1453 "wavegen.cpp"
          var $shr=($mul) >> 8; //@line 1453 "wavegen.cpp"
          $value=$shr; //@line 1453 "wavegen.cpp"
          var $7=HEAP32[((_echo_tail)>>2)]; //@line 1455 "wavegen.cpp"
          var $cmp5=((($7))|0) >= 5500; //@line 1455 "wavegen.cpp"
          if ($cmp5) { __label__ = 7;; } else { __label__ = 8;; } //@line 1455 "wavegen.cpp"
          if (__label__ == 7) {
  
            HEAP32[((_echo_tail)>>2)]=0; //@line 1456 "wavegen.cpp"
            ; //@line 1456 "wavegen.cpp"
          }
  
          var $8=$value; //@line 1458 "wavegen.cpp"
          var $conv8=((($8)) & 255); //@line 1458 "wavegen.cpp"
          var $9=HEAP32[((_out_ptr)>>2)]; //@line 1458 "wavegen.cpp"
          var $incdec_ptr=(($9+1)&4294967295); //@line 1458 "wavegen.cpp"
          HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 1458 "wavegen.cpp"
          HEAP8[($9)]=$conv8; //@line 1458 "wavegen.cpp"
          var $10=$value; //@line 1459 "wavegen.cpp"
          var $shr9=($10) >> 8; //@line 1459 "wavegen.cpp"
          var $conv10=((($shr9)) & 255); //@line 1459 "wavegen.cpp"
          var $11=HEAP32[((_out_ptr)>>2)]; //@line 1459 "wavegen.cpp"
          var $incdec_ptr11=(($11+1)&4294967295); //@line 1459 "wavegen.cpp"
          HEAP32[((_out_ptr)>>2)]=$incdec_ptr11; //@line 1459 "wavegen.cpp"
          HEAP8[($11)]=$conv10; //@line 1459 "wavegen.cpp"
          var $12=$value; //@line 1461 "wavegen.cpp"
          var $conv12=((($12)) & 65535); //@line 1461 "wavegen.cpp"
          var $13=HEAP32[((_echo_head)>>2)]; //@line 1461 "wavegen.cpp"
          var $inc13=((($13)+1)&4294967295); //@line 1461 "wavegen.cpp"
          HEAP32[((_echo_head)>>2)]=$inc13; //@line 1461 "wavegen.cpp"
          var $arrayidx14=((_echo_buf+$13*2)&4294967295); //@line 1461 "wavegen.cpp"
          HEAP16[(($arrayidx14)>>1)]=$conv12; //@line 1461 "wavegen.cpp"
          var $14=HEAP32[((_echo_head)>>2)]; //@line 1462 "wavegen.cpp"
          var $cmp15=((($14))|0) >= 5500; //@line 1462 "wavegen.cpp"
          if ($cmp15) { __label__ = 9;; } else { __label__ = 10;; } //@line 1462 "wavegen.cpp"
          if (__label__ == 9) {
  
            HEAP32[((_echo_head)>>2)]=0; //@line 1463 "wavegen.cpp"
            ; //@line 1463 "wavegen.cpp"
          }
  
          var $15=HEAPU32[((_out_ptr)>>2)]; //@line 1465 "wavegen.cpp"
          var $16=HEAPU32[((_out_end)>>2)]; //@line 1465 "wavegen.cpp"
          var $cmp18=((($15))>>>0) >= ((($16))>>>0); //@line 1465 "wavegen.cpp"
          if ($cmp18) { __label__ = 11;break ; } else { __label__ = 4;continue ; } //@line 1465 "wavegen.cpp"
        }
        else if (__label__ == 4) {
  
          var $_pr=HEAP32[((__ZZL11PlaySilenceiiE9n_samples)>>2)]; //@line 1451 "wavegen.cpp"
          __lastLabel__ = 4; __label__ = 5;continue ;
        }
      }
      if (__label__ == 12) {
  
        $retval=0; //@line 1468 "wavegen.cpp"
        ; //@line 1468 "wavegen.cpp"
      }
      else if (__label__ == 11) {
  
        $retval=1; //@line 1466 "wavegen.cpp"
        ; //@line 1466 "wavegen.cpp"
      }
    }
  
    var $17=$retval; //@line 1469 "wavegen.cpp"
    ;
    return $17; //@line 1469 "wavegen.cpp"
    return null;
  }
  

  function __ZL8PlayWaveiiPhii($length, $resume, $data, $scale, $amp) {
    ;
    var __label__;
  
    var $retval;
    var $length_addr;
    var $resume_addr;
    var $data_addr;
    var $scale_addr;
    var $amp_addr;
    var $value;
    var $c;
    $length_addr=$length;
    $resume_addr=$resume;
    $data_addr=$data;
    $scale_addr=$scale;
    $amp_addr=$amp;
    var $0=$resume_addr; //@line 1480 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1480 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1480 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=$length_addr; //@line 1482 "wavegen.cpp"
      HEAP32[((__ZZL8PlayWaveiiPhiiE9n_samples)>>2)]=$1; //@line 1482 "wavegen.cpp"
      HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]=0; //@line 1483 "wavegen.cpp"
      ; //@line 1484 "wavegen.cpp"
    }
  
    HEAP32[((__ZL8nsamples)>>2)]=0; //@line 1486 "wavegen.cpp"
    HEAP32[((__ZL11samplecount)>>2)]=0; //@line 1487 "wavegen.cpp"
    ; //@line 1489 "wavegen.cpp"
    $while_cond$5: while(1) { 
  
      var $2=HEAP32[((__ZZL8PlayWaveiiPhiiE9n_samples)>>2)]; //@line 1489 "wavegen.cpp"
      var $dec=((($2)-1)&4294967295); //@line 1489 "wavegen.cpp"
      HEAP32[((__ZZL8PlayWaveiiPhiiE9n_samples)>>2)]=$dec; //@line 1489 "wavegen.cpp"
      var $cmp1=((($2))|0) > 0; //@line 1489 "wavegen.cpp"
      if (!($cmp1)) { __label__ = 17;break $while_cond$5; } //@line 1489 "wavegen.cpp"
  
      var $3=$scale_addr; //@line 1491 "wavegen.cpp"
      var $cmp2=((($3))|0)==0; //@line 1491 "wavegen.cpp"
      var $4=HEAPU32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]; //@line 1494 "wavegen.cpp"
      var $add=((($4)+1)&4294967295); //@line 1494 "wavegen.cpp"
      if ($cmp2) { __label__ = 5;; } else { __label__ = 6;; } //@line 1491 "wavegen.cpp"
      if (__label__ == 5) {
  
        var $5=$data_addr; //@line 1494 "wavegen.cpp"
        var $arrayidx=(($5+$add)&4294967295); //@line 1494 "wavegen.cpp"
        var $6=HEAP8[($arrayidx)]; //@line 1494 "wavegen.cpp"
        $c=$6; //@line 1494 "wavegen.cpp"
        var $7=HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]; //@line 1495 "wavegen.cpp"
        var $8=$data_addr; //@line 1495 "wavegen.cpp"
        var $arrayidx4=(($8+$7)&4294967295); //@line 1495 "wavegen.cpp"
        var $9=HEAPU8[($arrayidx4)]; //@line 1495 "wavegen.cpp"
        var $conv=((($9))&255); //@line 1495 "wavegen.cpp"
        var $10=$c; //@line 1495 "wavegen.cpp"
        var $conv5=(tempInt=(($10)),(tempInt>=128?tempInt-256:tempInt)); //@line 1495 "wavegen.cpp"
        var $mul=((($conv5)*256)&4294967295); //@line 1495 "wavegen.cpp"
        var $add6=((($mul)+($conv))&4294967295); //@line 1495 "wavegen.cpp"
        $value=$add6; //@line 1495 "wavegen.cpp"
        var $11=HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]; //@line 1496 "wavegen.cpp"
        var $add7=((($11)+2)&4294967295); //@line 1496 "wavegen.cpp"
        HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]=$add7; //@line 1496 "wavegen.cpp"
        ; //@line 1497 "wavegen.cpp"
      }
      else if (__label__ == 6) {
  
        HEAP32[((__ZZL8PlayWaveiiPhiiE2ix)>>2)]=$add; //@line 1501 "wavegen.cpp"
        var $12=$data_addr; //@line 1501 "wavegen.cpp"
        var $arrayidx8=(($12+$4)&4294967295); //@line 1501 "wavegen.cpp"
        var $13=HEAP8[($arrayidx8)]; //@line 1501 "wavegen.cpp"
        var $conv9=(tempInt=(($13)),(tempInt>=128?tempInt-256:tempInt)); //@line 1501 "wavegen.cpp"
        var $14=$scale_addr; //@line 1501 "wavegen.cpp"
        var $mul10=((($conv9)*($14))&4294967295); //@line 1501 "wavegen.cpp"
        $value=$mul10; //@line 1501 "wavegen.cpp"
        ;
      }
  
      var $15=HEAP32[((__ZL13consonant_amp)>>2)]; //@line 1503 "wavegen.cpp"
      var $16=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 1503 "wavegen.cpp"
      var $17=$value; //@line 1503 "wavegen.cpp"
      var $mul12=((($16)*($15))&4294967295); //@line 1503 "wavegen.cpp"
      var $mul13=((($mul12)*($17))&4294967295); //@line 1503 "wavegen.cpp"
      $value=$mul13; //@line 1503 "wavegen.cpp"
      var $18=$value; //@line 1504 "wavegen.cpp"
      var $shr=($18) >> 10; //@line 1504 "wavegen.cpp"
      $value=$shr; //@line 1504 "wavegen.cpp"
      var $19=$value; //@line 1505 "wavegen.cpp"
      var $20=$amp_addr; //@line 1505 "wavegen.cpp"
      var $mul14=((($20)*($19))&4294967295); //@line 1505 "wavegen.cpp"
      var $div=((((($mul14))|0)/32)|0); //@line 1505 "wavegen.cpp"
      $value=$div; //@line 1505 "wavegen.cpp"
      var $21=HEAP32[((_echo_tail)>>2)]; //@line 1507 "wavegen.cpp"
      var $inc15=((($21)+1)&4294967295); //@line 1507 "wavegen.cpp"
      HEAP32[((_echo_tail)>>2)]=$inc15; //@line 1507 "wavegen.cpp"
      var $arrayidx16=((_echo_buf+$21*2)&4294967295); //@line 1507 "wavegen.cpp"
      var $22=HEAP16[(($arrayidx16)>>1)]; //@line 1507 "wavegen.cpp"
      var $conv17=(tempInt=(($22)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1507 "wavegen.cpp"
      var $23=HEAP32[((_echo_amp)>>2)]; //@line 1507 "wavegen.cpp"
      var $mul18=((($conv17)*($23))&4294967295); //@line 1507 "wavegen.cpp"
      var $shr19=($mul18) >> 8; //@line 1507 "wavegen.cpp"
      var $24=$value; //@line 1507 "wavegen.cpp"
      var $add20=((($shr19)+($24))&4294967295); //@line 1507 "wavegen.cpp"
      $value=$add20; //@line 1507 "wavegen.cpp"
      var $cmp21=((($add20))|0) > 32767; //@line 1509 "wavegen.cpp"
      if ($cmp21) { __label__ = 8;; } else { __label__ = 9;; } //@line 1509 "wavegen.cpp"
      $if_then22$$if_else23$12: do { 
        if (__label__ == 8) {
  
          $value=32768; //@line 1510 "wavegen.cpp"
          ; //@line 1510 "wavegen.cpp"
        }
        else if (__label__ == 9) {
  
          var $25=$value; //@line 1512 "wavegen.cpp"
          var $cmp24=((($25))|0) < -32768; //@line 1512 "wavegen.cpp"
          if (!($cmp24)) { __label__ = 11;break $if_then22$$if_else23$12; } //@line 1512 "wavegen.cpp"
  
          $value=-32768; //@line 1513 "wavegen.cpp"
          ; //@line 1513 "wavegen.cpp"
        }
      } while(0);
  
      var $26=HEAP32[((_echo_tail)>>2)]; //@line 1515 "wavegen.cpp"
      var $cmp28=((($26))|0) >= 5500; //@line 1515 "wavegen.cpp"
      if ($cmp28) { __label__ = 12;; } else { __label__ = 13;; } //@line 1515 "wavegen.cpp"
      if (__label__ == 12) {
  
        HEAP32[((_echo_tail)>>2)]=0; //@line 1516 "wavegen.cpp"
        ; //@line 1516 "wavegen.cpp"
      }
  
      var $27=$value; //@line 1518 "wavegen.cpp"
      var $conv31=((($27)) & 255); //@line 1518 "wavegen.cpp"
      var $28=HEAP32[((_out_ptr)>>2)]; //@line 1518 "wavegen.cpp"
      var $arrayidx32=(($28)&4294967295); //@line 1518 "wavegen.cpp"
      HEAP8[($arrayidx32)]=$conv31; //@line 1518 "wavegen.cpp"
      var $29=$value; //@line 1519 "wavegen.cpp"
      var $shr33=($29) >> 8; //@line 1519 "wavegen.cpp"
      var $conv34=((($shr33)) & 255); //@line 1519 "wavegen.cpp"
      var $30=HEAP32[((_out_ptr)>>2)]; //@line 1519 "wavegen.cpp"
      var $arrayidx35=(($30+1)&4294967295); //@line 1519 "wavegen.cpp"
      HEAP8[($arrayidx35)]=$conv34; //@line 1519 "wavegen.cpp"
      var $31=HEAP32[((_out_ptr)>>2)]; //@line 1520 "wavegen.cpp"
      var $add_ptr=(($31+2)&4294967295); //@line 1520 "wavegen.cpp"
      HEAP32[((_out_ptr)>>2)]=$add_ptr; //@line 1520 "wavegen.cpp"
      var $32=$value; //@line 1522 "wavegen.cpp"
      var $mul36=((($32)*3)&4294967295); //@line 1522 "wavegen.cpp"
      var $div37=((((($mul36))|0)/4)|0); //@line 1522 "wavegen.cpp"
      var $conv38=((($div37)) & 65535); //@line 1522 "wavegen.cpp"
      var $33=HEAP32[((_echo_head)>>2)]; //@line 1522 "wavegen.cpp"
      var $inc39=((($33)+1)&4294967295); //@line 1522 "wavegen.cpp"
      HEAP32[((_echo_head)>>2)]=$inc39; //@line 1522 "wavegen.cpp"
      var $arrayidx40=((_echo_buf+$33*2)&4294967295); //@line 1522 "wavegen.cpp"
      HEAP16[(($arrayidx40)>>1)]=$conv38; //@line 1522 "wavegen.cpp"
      var $34=HEAP32[((_echo_head)>>2)]; //@line 1523 "wavegen.cpp"
      var $cmp41=((($34))|0) >= 5500; //@line 1523 "wavegen.cpp"
      if ($cmp41) { __label__ = 14;; } else { __label__ = 15;; } //@line 1523 "wavegen.cpp"
      if (__label__ == 14) {
  
        HEAP32[((_echo_head)>>2)]=0; //@line 1524 "wavegen.cpp"
        ; //@line 1524 "wavegen.cpp"
      }
  
      var $35=HEAPU32[((_out_ptr)>>2)]; //@line 1526 "wavegen.cpp"
      var $36=HEAPU32[((_out_end)>>2)]; //@line 1526 "wavegen.cpp"
      var $cmp44=((($35))>>>0) >= ((($36))>>>0); //@line 1526 "wavegen.cpp"
      if ($cmp44) { __label__ = 16;break $while_cond$5; } else { __label__ = 3;continue $while_cond$5; } //@line 1526 "wavegen.cpp"
    }
    if (__label__ == 17) {
  
      $retval=0; //@line 1529 "wavegen.cpp"
      ; //@line 1529 "wavegen.cpp"
    }
    else if (__label__ == 16) {
  
      $retval=1; //@line 1527 "wavegen.cpp"
      ; //@line 1527 "wavegen.cpp"
    }
  
    var $37=$retval; //@line 1530 "wavegen.cpp"
    ;
    return $37; //@line 1530 "wavegen.cpp"
    return null;
  }
  

  function __ZL8Wavegen2iiiP7frame_tS0_($length, $modulation, $resume, $fr1, $fr2) {
    ;
    var __label__;
  
    var $length_addr;
    var $modulation_addr;
    var $resume_addr;
    var $fr1_addr;
    var $fr2_addr;
    $length_addr=$length;
    $modulation_addr=$modulation;
    $resume_addr=$resume;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    var $0=$resume_addr; //@line 1832 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1832 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1832 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=$length_addr; //@line 1833 "wavegen.cpp"
      var $2=$modulation_addr; //@line 1833 "wavegen.cpp"
      var $3=$fr1_addr; //@line 1833 "wavegen.cpp"
      var $4=$fr2_addr; //@line 1833 "wavegen.cpp"
      var $5=HEAP32[((_wvoice)>>2)]; //@line 1833 "wavegen.cpp"
      __Z8SetSynthiiP7frame_tS0_P7voice_t($1, $2, $3, $4, $5); //@line 1833 "wavegen.cpp"
      ; //@line 1833 "wavegen.cpp"
    }
  
    var $call=__Z7Wavegenv(); //@line 1835 "wavegen.cpp"
    ;
    return $call; //@line 1835 "wavegen.cpp"
    return null;
  }
  

  function __ZL12SetAmplitudeiPhi($length, $amp_env, $value) {
    ;
    var __label__;
  
    var $length_addr;
    var $amp_env_addr;
    var $value_addr;
    $length_addr=$length;
    $amp_env_addr=$amp_env;
    $value_addr=$value;
    HEAP32[((__ZL6amp_ix)>>2)]=0; //@line 1636 "wavegen.cpp"
    var $0=$length_addr; //@line 1637 "wavegen.cpp"
    var $cmp=((($0))|0)==0; //@line 1637 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1637 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL7amp_inc)>>2)]=0; //@line 1638 "wavegen.cpp"
      ; //@line 1638 "wavegen.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$length_addr; //@line 1640 "wavegen.cpp"
      var $div=((2097152/((($1))|0))|0); //@line 1640 "wavegen.cpp"
      HEAP32[((__ZL7amp_inc)>>2)]=$div; //@line 1640 "wavegen.cpp"
      ;
    }
  
    var $2=$value_addr; //@line 1642 "wavegen.cpp"
    var $3=HEAP32[((__ZL17general_amplitude)>>2)]; //@line 1642 "wavegen.cpp"
    var $mul=((($3)*($2))&4294967295); //@line 1642 "wavegen.cpp"
    var $div1=((((($mul))|0)/16)|0); //@line 1642 "wavegen.cpp"
    HEAP32[((((_wdata+52)&4294967295))>>2)]=$div1; //@line 1642 "wavegen.cpp"
    var $4=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 1643 "wavegen.cpp"
    var $5=HEAP32[((_wvoice)>>2)]; //@line 1643 "wavegen.cpp"
    var $consonant_ampv=(($5+104)&4294967295); //@line 1643 "wavegen.cpp"
    var $6=HEAP32[(($consonant_ampv)>>2)]; //@line 1643 "wavegen.cpp"
    var $mul2=((($4)*15)&4294967295); //@line 1643 "wavegen.cpp"
    var $mul3=((($mul2)*($6))&4294967295); //@line 1643 "wavegen.cpp"
    var $div4=((((($mul3))|0)/100)|0); //@line 1643 "wavegen.cpp"
    HEAP32[((((_wdata+56)&4294967295))>>2)]=$div4; //@line 1643 "wavegen.cpp"
    var $7=$amp_env_addr; //@line 1645 "wavegen.cpp"
    HEAP32[((__ZL13amplitude_env)>>2)]=$7; //@line 1645 "wavegen.cpp"
    ;
    return; //@line 1646 "wavegen.cpp"
    return;
  }
  

  function __ZL12WcmdqIncHeadv() {
    ;
    var __label__;
  
    var $0=HEAP32[((_wcmdq_head)>>2)]; //@line 324 "wavegen.cpp"
    var $inc=((($0)+1)&4294967295); //@line 324 "wavegen.cpp"
    HEAP32[((_wcmdq_head)>>2)]=$inc; //@line 324 "wavegen.cpp"
    var $cmp=((($inc))|0) >= 160; //@line 325 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 325 "wavegen.cpp"
    if (__label__ == 1) {
  
      HEAP32[((_wcmdq_head)>>2)]=0; //@line 325 "wavegen.cpp"
      ; //@line 325 "wavegen.cpp"
    }
  
    ;
    return; //@line 326 "wavegen.cpp"
    return;
  }
  

  function __Z11WavegenFilli($fill_zeros) {
    ;
    var __label__;
  
    var $fill_zeros_addr;
    var $finished;
    var $p_start;
    var $length;
    var $max_length;
    $fill_zeros_addr=$fill_zeros;
    var $0=HEAP32[((_out_ptr)>>2)]; //@line 2033 "wavegen.cpp"
    $p_start=$0; //@line 2033 "wavegen.cpp"
    var $call=__Z12WavegenFill2i(0); //@line 2036 "wavegen.cpp"
    $finished=$call; //@line 2036 "wavegen.cpp"
    var $1=HEAPF32[((_sonicSpeed)>>2)]; //@line 2038 "wavegen.cpp"
    var $cmp=($1) > 1; //@line 2038 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 2038 "wavegen.cpp"
    $if_then$$if_end8$2: do { 
      if (__label__ == 1) {
  
        var $2=HEAP32[((_out_end)>>2)]; //@line 2040 "wavegen.cpp"
        var $3=$p_start; //@line 2040 "wavegen.cpp"
        var $sub_ptr_lhs_cast=($2); //@line 2040 "wavegen.cpp"
        var $sub_ptr_rhs_cast=($3); //@line 2040 "wavegen.cpp"
        var $sub_ptr_sub=((($sub_ptr_lhs_cast)-($sub_ptr_rhs_cast))&4294967295); //@line 2040 "wavegen.cpp"
        $max_length=$sub_ptr_sub; //@line 2040 "wavegen.cpp"
        var $4=$p_start; //@line 2041 "wavegen.cpp"
        var $5=$4; //@line 2041 "wavegen.cpp"
        var $6=HEAP32[((_out_ptr)>>2)]; //@line 2041 "wavegen.cpp"
        var $7=$p_start; //@line 2041 "wavegen.cpp"
        var $sub_ptr_lhs_cast1=($6); //@line 2041 "wavegen.cpp"
        var $sub_ptr_rhs_cast2=($7); //@line 2041 "wavegen.cpp"
        var $sub_ptr_sub3=((($sub_ptr_lhs_cast1)-($sub_ptr_rhs_cast2))&4294967295); //@line 2041 "wavegen.cpp"
        var $div=((((($sub_ptr_sub3))|0)/2)|0); //@line 2041 "wavegen.cpp"
        var $8=$max_length; //@line 2041 "wavegen.cpp"
        var $div4=((((($8))|0)/2)|0); //@line 2041 "wavegen.cpp"
        var $9=$finished; //@line 2041 "wavegen.cpp"
        var $call5=__ZL7SpeedUpPsiii($5, $div, $div4, $9); //@line 2041 "wavegen.cpp"
        var $mul=((($call5)*2)&4294967295); //@line 2041 "wavegen.cpp"
        $length=$mul; //@line 2041 "wavegen.cpp"
        var $10=$p_start; //@line 2042 "wavegen.cpp"
        var $11=$length; //@line 2042 "wavegen.cpp"
        var $add_ptr=(($10+$11)&4294967295); //@line 2042 "wavegen.cpp"
        HEAP32[((_out_ptr)>>2)]=$add_ptr; //@line 2042 "wavegen.cpp"
        var $12=$length; //@line 2044 "wavegen.cpp"
        var $13=$max_length; //@line 2044 "wavegen.cpp"
        var $cmp6=((($12))|0) >= ((($13))|0); //@line 2044 "wavegen.cpp"
        if (!($cmp6)) { __label__ = 3;break $if_then$$if_end8$2; } //@line 2044 "wavegen.cpp"
  
        $finished=0; //@line 2045 "wavegen.cpp"
        ; //@line 2045 "wavegen.cpp"
      }
    } while(0);
  
    var $14=$finished; //@line 2047 "wavegen.cpp"
    ;
    return $14; //@line 2047 "wavegen.cpp"
    return null;
  }
  

  function __ZL7SpeedUpPsiii($outbuf, $length_in, $length_out, $end_of_text) {
    ;
    var __label__;
  
    var $retval;
    var $outbuf_addr;
    var $length_in_addr;
    var $length_out_addr;
    var $end_of_text_addr;
    $outbuf_addr=$outbuf;
    $length_in_addr=$length_in;
    $length_out_addr=$length_out;
    $end_of_text_addr=$end_of_text;
    var $0=$length_in_addr; //@line 2000 "wavegen.cpp"
    var $cmp=((($0))|0) > 0; //@line 2000 "wavegen.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 6;; } //@line 2000 "wavegen.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2002 "wavegen.cpp"
      var $cmp1=((($1))|0)==0; //@line 2002 "wavegen.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 3;; } //@line 2002 "wavegen.cpp"
      if (__label__ == 2) {
  
        var $call=_sonicCreateStream(22050, 1); //@line 2004 "wavegen.cpp"
        HEAP32[((__ZL18sonicSpeedupStream)>>2)]=$call; //@line 2004 "wavegen.cpp"
        ; //@line 2005 "wavegen.cpp"
      }
  
      var $2=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2006 "wavegen.cpp"
      var $call3=_sonicGetSpeed($2); //@line 2006 "wavegen.cpp"
      var $conv=($call3); //@line 2006 "wavegen.cpp"
      var $3=HEAPF32[((_sonicSpeed)>>2)]; //@line 2006 "wavegen.cpp"
      var $cmp4=($conv) != ($3); //@line 2006 "wavegen.cpp"
      if ($cmp4) { __label__ = 4;; } else { __label__ = 5;; } //@line 2006 "wavegen.cpp"
      if (__label__ == 4) {
  
        var $4=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2008 "wavegen.cpp"
        var $5=HEAPF32[((_sonicSpeed)>>2)]; //@line 2008 "wavegen.cpp"
        var $conv6=($5); //@line 2008 "wavegen.cpp"
        _sonicSetSpeed($4, $conv6); //@line 2008 "wavegen.cpp"
        ; //@line 2009 "wavegen.cpp"
      }
  
      var $6=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2011 "wavegen.cpp"
      var $7=$outbuf_addr; //@line 2011 "wavegen.cpp"
      var $8=$length_in_addr; //@line 2011 "wavegen.cpp"
      var $call8=_sonicWriteShortToStream($6, $7, $8); //@line 2011 "wavegen.cpp"
      ; //@line 2012 "wavegen.cpp"
    }
  
    var $9=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2014 "wavegen.cpp"
    var $cmp10=((($9))|0)==0; //@line 2014 "wavegen.cpp"
    if ($cmp10) { __label__ = 7;; } else { __label__ = 8;; } //@line 2014 "wavegen.cpp"
    if (__label__ == 7) {
  
      $retval=0; //@line 2015 "wavegen.cpp"
      ; //@line 2015 "wavegen.cpp"
    }
    else if (__label__ == 8) {
  
      var $10=$end_of_text_addr; //@line 2017 "wavegen.cpp"
      var $tobool=((($10))|0)!=0; //@line 2017 "wavegen.cpp"
      if ($tobool) { __label__ = 9;; } else { __label__ = 10;; } //@line 2017 "wavegen.cpp"
      if (__label__ == 9) {
  
        var $11=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2019 "wavegen.cpp"
        var $call14=_sonicFlushStream($11); //@line 2019 "wavegen.cpp"
        ; //@line 2020 "wavegen.cpp"
      }
  
      var $12=HEAP32[((__ZL18sonicSpeedupStream)>>2)]; //@line 2021 "wavegen.cpp"
      var $13=$outbuf_addr; //@line 2021 "wavegen.cpp"
      var $14=$length_out_addr; //@line 2021 "wavegen.cpp"
      var $call16=_sonicReadShortFromStream($12, $13, $14); //@line 2021 "wavegen.cpp"
      $retval=$call16; //@line 2021 "wavegen.cpp"
      ; //@line 2021 "wavegen.cpp"
    }
  
    var $15=$retval; //@line 2022 "wavegen.cpp"
    ;
    return $15; //@line 2022 "wavegen.cpp"
    return null;
  }
  

  function __ZL9resonatorP9RESONATORd($r, $input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=$r;
    $input_addr=$input;
    var $0=$r_addr; //@line 1057 "wavegen.cpp"
    var $a=(($0)&4294967295); //@line 1057 "wavegen.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 1057 "wavegen.cpp"
    var $2=$input_addr; //@line 1057 "wavegen.cpp"
    var $mul=($1)*($2); //@line 1057 "wavegen.cpp"
    var $3=$r_addr; //@line 1057 "wavegen.cpp"
    var $b=(($3+8)&4294967295); //@line 1057 "wavegen.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 1057 "wavegen.cpp"
    var $5=$r_addr; //@line 1057 "wavegen.cpp"
    var $x1=(($5+24)&4294967295); //@line 1057 "wavegen.cpp"
    var $6=HEAPF32[(($x1)>>2)]; //@line 1057 "wavegen.cpp"
    var $mul1=($4)*($6); //@line 1057 "wavegen.cpp"
    var $add=($mul)+($mul1); //@line 1057 "wavegen.cpp"
    var $7=$r_addr; //@line 1057 "wavegen.cpp"
    var $c=(($7+16)&4294967295); //@line 1057 "wavegen.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 1057 "wavegen.cpp"
    var $9=$r_addr; //@line 1057 "wavegen.cpp"
    var $x2=(($9+32)&4294967295); //@line 1057 "wavegen.cpp"
    var $10=HEAPF32[(($x2)>>2)]; //@line 1057 "wavegen.cpp"
    var $mul2=($8)*($10); //@line 1057 "wavegen.cpp"
    var $add3=($add)+($mul2); //@line 1057 "wavegen.cpp"
    $x=$add3; //@line 1057 "wavegen.cpp"
    var $11=$r_addr; //@line 1058 "wavegen.cpp"
    var $x14=(($11+24)&4294967295); //@line 1058 "wavegen.cpp"
    var $12=HEAPF32[(($x14)>>2)]; //@line 1058 "wavegen.cpp"
    var $13=$r_addr; //@line 1058 "wavegen.cpp"
    var $x25=(($13+32)&4294967295); //@line 1058 "wavegen.cpp"
    HEAPF32[(($x25)>>2)]=$12; //@line 1058 "wavegen.cpp"
    var $14=$x; //@line 1059 "wavegen.cpp"
    var $15=$r_addr; //@line 1059 "wavegen.cpp"
    var $x16=(($15+24)&4294967295); //@line 1059 "wavegen.cpp"
    HEAPF32[(($x16)>>2)]=$14; //@line 1059 "wavegen.cpp"
    var $16=$x; //@line 1061 "wavegen.cpp"
    ;
    return $16; //@line 1061 "wavegen.cpp"
    return null;
  }
  

  function __Z15MakePhonemeListP10Translatorii($tr, $post_pause, $start_sentence) {
    var __stackBase__  = STACKTOP; STACKTOP += 24152; _memset(__stackBase__, 0, 24152);
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $post_pause_addr;
    var $start_sentence_addr;
    var $ix;
    var $j;
    var $insert_ph;
    var $phlist;
    var $ph;
    var $prev;
    var $next;
    var $next2;
    var $unstress_count;
    var $word_stress;
    var $switched_language;
    var $max_stress;
    var $voicing;
    var $regression;
    var $end_sourceix;
    var $alternative;
    var $first_vowel;
    var $phdata=__stackBase__;
    var $n_ph_list3;
    var $plist3;
    var $plist3_inserted;
    var $ph_list3=__stackBase__+152;
    var $plist2;
    var $type;
    var $word_end_devoice;
    var $k;
    var $nextw;
    var $ph2;
    var $ph2266;
    var $p;
    var $x;
    $tr_addr=$tr;
    $post_pause_addr=$post_pause;
    $start_sentence_addr=$start_sentence;
    $ix=0; //@line 112 "phonemelist.cpp"
    $insert_ph=0; //@line 114 "phonemelist.cpp"
    $unstress_count=0; //@line 118 "phonemelist.cpp"
    $word_stress=0; //@line 119 "phonemelist.cpp"
    $switched_language=0; //@line 120 "phonemelist.cpp"
    $first_vowel=0; //@line 126 "phonemelist.cpp"
    $plist3_inserted=0; //@line 131 "phonemelist.cpp"
    $plist2=((_ph_list2)&4294967295); //@line 137 "phonemelist.cpp"
    $phlist=((_phoneme_list)&4294967295); //@line 138 "phonemelist.cpp"
    var $0=HEAP32[((_n_ph_list2)>>2)]; //@line 139 "phonemelist.cpp"
    var $sub=((($0)-1)&4294967295); //@line 139 "phonemelist.cpp"
    var $1=$plist2; //@line 139 "phonemelist.cpp"
    var $arrayidx=(($1+8*$sub)&4294967295); //@line 139 "phonemelist.cpp"
    var $sourceix=(($arrayidx+6)&4294967295); //@line 139 "phonemelist.cpp"
    var $2=HEAPU16[(($sourceix)>>1)]; //@line 139 "phonemelist.cpp"
    var $conv=((($2))&65535); //@line 139 "phonemelist.cpp"
    $end_sourceix=$conv; //@line 139 "phonemelist.cpp"
    $max_stress=0; //@line 142 "phonemelist.cpp"
    var $3=HEAP32[((_n_ph_list2)>>2)]; //@line 143 "phonemelist.cpp"
    var $sub1=((($3)-3)&4294967295); //@line 143 "phonemelist.cpp"
    $j=$sub1; //@line 143 "phonemelist.cpp"
    __lastLabel__ = 0; ; //@line 143 "phonemelist.cpp"
    $for_cond$2: while(1) { 
  
      var $4=__lastLabel__ == 5 ? $dec : ($sub1); //@line 143 "phonemelist.cpp"
      var $cmp=((($4))|0) >= 0; //@line 143 "phonemelist.cpp"
      if (!($cmp)) { __label__ = 6;break $for_cond$2; } //@line 143 "phonemelist.cpp"
  
      var $5=$j; //@line 146 "phonemelist.cpp"
      var $6=$plist2; //@line 146 "phonemelist.cpp"
      var $arrayidx2=(($6+8*$5)&4294967295); //@line 146 "phonemelist.cpp"
      var $stresslevel=(($arrayidx2+1)&4294967295); //@line 146 "phonemelist.cpp"
      var $7=HEAPU8[($stresslevel)]; //@line 146 "phonemelist.cpp"
      var $conv3=((($7))&255); //@line 146 "phonemelist.cpp"
      var $and=($conv3) & 127; //@line 146 "phonemelist.cpp"
      var $8=$max_stress; //@line 146 "phonemelist.cpp"
      var $cmp4=((($and))|0) > ((($8))|0); //@line 146 "phonemelist.cpp"
      if ($cmp4) { __label__ = 3;; } else { __label__ = 4;; } //@line 146 "phonemelist.cpp"
      if (__label__ == 3) {
  
        var $9=$j; //@line 147 "phonemelist.cpp"
        var $10=$plist2; //@line 147 "phonemelist.cpp"
        var $arrayidx5=(($10+8*$9)&4294967295); //@line 147 "phonemelist.cpp"
        var $stresslevel6=(($arrayidx5+1)&4294967295); //@line 147 "phonemelist.cpp"
        var $11=HEAPU8[($stresslevel6)]; //@line 147 "phonemelist.cpp"
        var $conv7=((($11))&255); //@line 147 "phonemelist.cpp"
        var $and8=($conv7) & 127; //@line 147 "phonemelist.cpp"
        $max_stress=$and8; //@line 147 "phonemelist.cpp"
        ; //@line 147 "phonemelist.cpp"
      }
  
      var $12=$j; //@line 148 "phonemelist.cpp"
      var $13=$plist2; //@line 148 "phonemelist.cpp"
      var $arrayidx9=(($13+8*$12)&4294967295); //@line 148 "phonemelist.cpp"
      var $sourceix10=(($arrayidx9+6)&4294967295); //@line 148 "phonemelist.cpp"
      var $14=HEAPU16[(($sourceix10)>>1)]; //@line 148 "phonemelist.cpp"
      var $conv11=((($14))&65535); //@line 148 "phonemelist.cpp"
      var $cmp12=((($conv11))|0)!=0; //@line 148 "phonemelist.cpp"
      if ($cmp12) { __label__ = 6;break $for_cond$2; } //@line 148 "phonemelist.cpp"
  
      var $15=$j; //@line 143 "phonemelist.cpp"
      var $dec=((($15)-1)&4294967295); //@line 143 "phonemelist.cpp"
      $j=$dec; //@line 143 "phonemelist.cpp"
      __lastLabel__ = 5; __label__ = 1;continue $for_cond$2; //@line 143 "phonemelist.cpp"
    }
  
    var $16=$max_stress; //@line 151 "phonemelist.cpp"
    var $cmp15=((($16))|0) < 4; //@line 151 "phonemelist.cpp"
    if ($cmp15) { __label__ = 7;; } else { __label__ = 11;; } //@line 151 "phonemelist.cpp"
    $while_cond$$if_end32$10: do { 
      if (__label__ == 7) {
        while(1) { 
  
          var $17=$j; //@line 154 "phonemelist.cpp"
          var $dec17=((($17)-1)&4294967295); //@line 154 "phonemelist.cpp"
          $j=$dec17; //@line 154 "phonemelist.cpp"
          var $cmp18=((($dec17))|0) >= 0; //@line 154 "phonemelist.cpp"
          if (!($cmp18)) { __label__ = 11;break $while_cond$$if_end32$10; } //@line 154 "phonemelist.cpp"
  
          var $18=$j; //@line 156 "phonemelist.cpp"
          var $19=$plist2; //@line 156 "phonemelist.cpp"
          var $arrayidx19=(($19+8*$18)&4294967295); //@line 156 "phonemelist.cpp"
          var $synthflags=(($arrayidx19+4)&4294967295); //@line 156 "phonemelist.cpp"
          var $20=HEAPU16[(($synthflags)>>1)]; //@line 156 "phonemelist.cpp"
          var $conv20=((($20))&65535); //@line 156 "phonemelist.cpp"
          var $and21=($conv20) & 64; //@line 156 "phonemelist.cpp"
          var $tobool=((($and21))|0)!=0; //@line 156 "phonemelist.cpp"
          var $21=$j; //@line 158 "phonemelist.cpp"
          var $22=$plist2; //@line 158 "phonemelist.cpp"
          var $arrayidx23=(($22+8*$21)&4294967295); //@line 158 "phonemelist.cpp"
          var $stresslevel24=(($arrayidx23+1)&4294967295); //@line 158 "phonemelist.cpp"
          if ($tobool) { __label__ = 9;break ; } //@line 156 "phonemelist.cpp"
  
          var $23=HEAPU8[($stresslevel24)]; //@line 161 "phonemelist.cpp"
          var $conv28=((($23))&255); //@line 161 "phonemelist.cpp"
          var $cmp29=((($conv28))|0) >= 4; //@line 161 "phonemelist.cpp"
          if ($cmp29) { __label__ = 11;break $while_cond$$if_end32$10; } else { __label__ = 7;continue ; } //@line 161 "phonemelist.cpp"
        }
  
        HEAP8[($stresslevel24)]=4; //@line 158 "phonemelist.cpp"
        ; //@line 159 "phonemelist.cpp"
      }
    } while(0);
  
    var $24=$tr_addr; //@line 169 "phonemelist.cpp"
    var $langopts=(($24)&4294967295); //@line 169 "phonemelist.cpp"
    var $param=(($langopts+24)&4294967295); //@line 169 "phonemelist.cpp"
    var $arrayidx33=(($param+16)&4294967295); //@line 169 "phonemelist.cpp"
    var $25=HEAP32[(($arrayidx33)>>2)]; //@line 169 "phonemelist.cpp"
    $regression=$25; //@line 169 "phonemelist.cpp"
    var $cmp34=((($25))|0)!=0; //@line 169 "phonemelist.cpp"
    if ($cmp34) { __label__ = 12;; } else { __label__ = 51;; } //@line 169 "phonemelist.cpp"
    $if_then35$$if_end143$17: do { 
      if (__label__ == 12) {
  
        $word_end_devoice=0; //@line 174 "phonemelist.cpp"
        $voicing=0; //@line 175 "phonemelist.cpp"
        var $26=HEAP32[((_n_ph_list2)>>2)]; //@line 177 "phonemelist.cpp"
        var $sub36=((($26)-1)&4294967295); //@line 177 "phonemelist.cpp"
        $j=$sub36; //@line 177 "phonemelist.cpp"
        var $cmp389=((($sub36))|0) >= 0; //@line 177 "phonemelist.cpp"
        if (!($cmp389)) { __label__ = 51;break $if_then35$$if_end143$17; } //@line 177 "phonemelist.cpp"
        $for_body39$19: while(1) { 
  
          var $27=$j; //@line 179 "phonemelist.cpp"
          var $28=$plist2; //@line 179 "phonemelist.cpp"
          var $arrayidx40=(($28+8*$27)&4294967295); //@line 179 "phonemelist.cpp"
          var $phcode=(($arrayidx40)&4294967295); //@line 179 "phonemelist.cpp"
          var $29=HEAPU8[($phcode)]; //@line 179 "phonemelist.cpp"
          var $idxprom=((($29))&255); //@line 179 "phonemelist.cpp"
          var $arrayidx41=((_phoneme_tab+$idxprom*4)&4294967295); //@line 179 "phonemelist.cpp"
          var $30=HEAPU32[(($arrayidx41)>>2)]; //@line 179 "phonemelist.cpp"
          $ph=$30; //@line 179 "phonemelist.cpp"
          var $cmp42=((($30))|0)==0; //@line 180 "phonemelist.cpp"
          if ($cmp42) { __label__ = 50;; } else { __label__ = 14;; } //@line 180 "phonemelist.cpp"
          $for_inc140$$if_end44$21: do { 
            if (__label__ == 14) {
  
              var $31=$ph; //@line 183 "phonemelist.cpp"
              var $code=(($31+10)&4294967295); //@line 183 "phonemelist.cpp"
              var $32=HEAPU8[($code)]; //@line 183 "phonemelist.cpp"
              var $conv45=((($32))&255); //@line 183 "phonemelist.cpp"
              var $cmp46=((($conv45))|0)==21; //@line 183 "phonemelist.cpp"
              var $33=$switched_language; //@line 184 "phonemelist.cpp"
              if ($cmp46) { __lastLabel__ = 14; __label__ = 15;; } else { __lastLabel__ = 14; __label__ = 16;; } //@line 183 "phonemelist.cpp"
              if (__label__ == 15) {
  
                var $xor=($33) ^ 1; //@line 184 "phonemelist.cpp"
                $switched_language=$xor; //@line 184 "phonemelist.cpp"
                __lastLabel__ = 15; ; //@line 184 "phonemelist.cpp"
              }
  
              var $34=__lastLabel__ == 15 ? $xor : ($33); //@line 185 "phonemelist.cpp"
              var $tobool49=((($34))|0)!=0; //@line 185 "phonemelist.cpp"
              if ($tobool49) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 185 "phonemelist.cpp"
  
              var $35=$ph; //@line 188 "phonemelist.cpp"
              var $type52=(($35+11)&4294967295); //@line 188 "phonemelist.cpp"
              var $36=HEAPU8[($type52)]; //@line 188 "phonemelist.cpp"
              var $conv53=((($36))&255); //@line 188 "phonemelist.cpp"
              $type=$conv53; //@line 188 "phonemelist.cpp"
              var $37=$regression; //@line 190 "phonemelist.cpp"
              var $and54=($37) & 2; //@line 190 "phonemelist.cpp"
              var $tobool55=((($and54))|0)!=0; //@line 190 "phonemelist.cpp"
              if ($tobool55) { __label__ = 18;; } else { __label__ = 24;; } //@line 190 "phonemelist.cpp"
              $if_then56$$if_end69$27: do { 
                if (__label__ == 18) {
  
                  var $38=$ph; //@line 193 "phonemelist.cpp"
                  var $mnemonic=(($38)&4294967295); //@line 193 "phonemelist.cpp"
                  var $39=HEAP32[(($mnemonic)>>2)]; //@line 193 "phonemelist.cpp"
                  var $cmp57=((($39))|0)==118; //@line 193 "phonemelist.cpp"
                  if ($cmp57) { __label__ = 21;; } else { __label__ = 19;; } //@line 193 "phonemelist.cpp"
                  $if_then64$$lor_lhs_false$29: do { 
                    if (__label__ == 19) {
  
                      var $40=$ph; //@line 193 "phonemelist.cpp"
                      var $mnemonic58=(($40)&4294967295); //@line 193 "phonemelist.cpp"
                      var $41=HEAP32[(($mnemonic58)>>2)]; //@line 193 "phonemelist.cpp"
                      var $cmp59=((($41))|0)==15222; //@line 193 "phonemelist.cpp"
                      if ($cmp59) { __label__ = 21;break $if_then64$$lor_lhs_false$29; } //@line 193 "phonemelist.cpp"
  
                      var $42=$ph; //@line 193 "phonemelist.cpp"
                      var $mnemonic61=(($42)&4294967295); //@line 193 "phonemelist.cpp"
                      var $43=HEAP32[(($mnemonic61)>>2)]; //@line 193 "phonemelist.cpp"
                      var $and62=($43) & 255; //@line 193 "phonemelist.cpp"
                      var $cmp63=((($and62))|0)==82; //@line 193 "phonemelist.cpp"
                      if (!($cmp63)) { __label__ = 24;break $if_then56$$if_end69$27; } //@line 193 "phonemelist.cpp"
                    }
                  } while(0);
  
                  var $44=$word_end_devoice; //@line 195 "phonemelist.cpp"
                  var $cmp65=((($44))|0)==1; //@line 195 "phonemelist.cpp"
                  if ($cmp65) { __label__ = 22;; } else { __label__ = 23;; } //@line 195 "phonemelist.cpp"
                  if (__label__ == 22) {
  
                    $voicing=0; //@line 196 "phonemelist.cpp"
                    ; //@line 196 "phonemelist.cpp"
                  }
                  else if (__label__ == 23) {
  
                    $type=3; //@line 198 "phonemelist.cpp"
                    ;
                  }
                }
              } while(0);
  
              var $45=$type; //@line 202 "phonemelist.cpp"
              var $cmp70=((($45))|0)==4; //@line 202 "phonemelist.cpp"
              var $46=$type; //@line 202 "phonemelist.cpp"
              var $cmp72=((($46))|0)==6; //@line 202 "phonemelist.cpp"
              var $or_cond=($cmp70) | ($cmp72); //@line 202 "phonemelist.cpp"
              if ($or_cond) { __label__ = 25;; } else { __label__ = 32;; } //@line 202 "phonemelist.cpp"
              $if_then73$$if_else89$37: do { 
                if (__label__ == 25) {
  
                  var $47=$voicing; //@line 204 "phonemelist.cpp"
                  var $cmp74=((($47))|0)==0; //@line 204 "phonemelist.cpp"
                  if ($cmp74) { __lastLabel__ = 25; __label__ = 26;; } else { __lastLabel__ = 25; __label__ = 29;; } //@line 204 "phonemelist.cpp"
                  if (__label__ == 26) {
  
                    var $48=$regression; //@line 204 "phonemelist.cpp"
                    var $and75=($48) & 15; //@line 204 "phonemelist.cpp"
                    var $tobool76=((($and75))|0)!=0; //@line 204 "phonemelist.cpp"
                    if ($tobool76) { __label__ = 27;; } else { __label__ = 28;; } //@line 204 "phonemelist.cpp"
                    if (__label__ == 27) {
  
                      $voicing=1; //@line 206 "phonemelist.cpp"
                      __label__ = 44;break $if_then73$$if_else89$37; //@line 207 "phonemelist.cpp"
                    }
                    else if (__label__ == 28) {
  
                      var $_pr5=$voicing; //@line 209 "phonemelist.cpp"
                      __lastLabel__ = 28; ;
                    }
                  }
  
                  var $49=__lastLabel__ == 28 ? $_pr5 : ($47); //@line 209 "phonemelist.cpp"
                  var $cmp79=((($49))|0)==2; //@line 209 "phonemelist.cpp"
                  if (!($cmp79)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 209 "phonemelist.cpp"
  
                  var $50=$ph; //@line 209 "phonemelist.cpp"
                  var $end_type=(($50+13)&4294967295); //@line 209 "phonemelist.cpp"
                  var $51=HEAPU8[($end_type)]; //@line 209 "phonemelist.cpp"
                  var $conv81=((($51))&255); //@line 209 "phonemelist.cpp"
                  var $cmp82=((($conv81))|0)!=0; //@line 209 "phonemelist.cpp"
                  if (!($cmp82)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 209 "phonemelist.cpp"
  
                  var $52=$ph; //@line 211 "phonemelist.cpp"
                  var $end_type84=(($52+13)&4294967295); //@line 211 "phonemelist.cpp"
                  var $53=HEAP8[($end_type84)]; //@line 211 "phonemelist.cpp"
                  var $54=$j; //@line 211 "phonemelist.cpp"
                  var $55=$plist2; //@line 211 "phonemelist.cpp"
                  var $arrayidx85=(($55+8*$54)&4294967295); //@line 211 "phonemelist.cpp"
                  var $phcode86=(($arrayidx85)&4294967295); //@line 211 "phonemelist.cpp"
                  HEAP8[($phcode86)]=$53; //@line 211 "phonemelist.cpp"
                  ; //@line 212 "phonemelist.cpp"
                }
                else if (__label__ == 32) {
  
                  var $56=$type; //@line 215 "phonemelist.cpp"
                  var $cmp90=((($56))|0)==5; //@line 215 "phonemelist.cpp"
                  var $57=$type; //@line 215 "phonemelist.cpp"
                  var $cmp92=((($57))|0)==7; //@line 215 "phonemelist.cpp"
                  var $or_cond1=($cmp90) | ($cmp92); //@line 215 "phonemelist.cpp"
                  if ($or_cond1) { __label__ = 33;; } else { __label__ = 40;; } //@line 215 "phonemelist.cpp"
                  if (__label__ == 33) {
  
                    var $58=$voicing; //@line 217 "phonemelist.cpp"
                    var $cmp94=((($58))|0)==0; //@line 217 "phonemelist.cpp"
                    if ($cmp94) { __lastLabel__ = 33; __label__ = 34;; } else { __lastLabel__ = 33; __label__ = 37;; } //@line 217 "phonemelist.cpp"
                    if (__label__ == 34) {
  
                      var $59=$regression; //@line 217 "phonemelist.cpp"
                      var $and96=($59) & 15; //@line 217 "phonemelist.cpp"
                      var $tobool97=((($and96))|0)!=0; //@line 217 "phonemelist.cpp"
                      if ($tobool97) { __label__ = 35;; } else { __label__ = 36;; } //@line 217 "phonemelist.cpp"
                      if (__label__ == 35) {
  
                        $voicing=2; //@line 219 "phonemelist.cpp"
                        __label__ = 44;break $if_then73$$if_else89$37; //@line 220 "phonemelist.cpp"
                      }
                      else if (__label__ == 36) {
  
                        var $_pr6=$voicing; //@line 222 "phonemelist.cpp"
                        __lastLabel__ = 36; ;
                      }
                    }
  
                    var $60=__lastLabel__ == 36 ? $_pr6 : ($58); //@line 222 "phonemelist.cpp"
                    var $cmp100=((($60))|0)==1; //@line 222 "phonemelist.cpp"
                    if (!($cmp100)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 222 "phonemelist.cpp"
  
                    var $61=$ph; //@line 222 "phonemelist.cpp"
                    var $end_type102=(($61+13)&4294967295); //@line 222 "phonemelist.cpp"
                    var $62=HEAPU8[($end_type102)]; //@line 222 "phonemelist.cpp"
                    var $conv103=((($62))&255); //@line 222 "phonemelist.cpp"
                    var $cmp104=((($conv103))|0)!=0; //@line 222 "phonemelist.cpp"
                    if (!($cmp104)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 222 "phonemelist.cpp"
  
                    var $63=$ph; //@line 224 "phonemelist.cpp"
                    var $end_type106=(($63+13)&4294967295); //@line 224 "phonemelist.cpp"
                    var $64=HEAP8[($end_type106)]; //@line 224 "phonemelist.cpp"
                    var $65=$j; //@line 224 "phonemelist.cpp"
                    var $66=$plist2; //@line 224 "phonemelist.cpp"
                    var $arrayidx107=(($66+8*$65)&4294967295); //@line 224 "phonemelist.cpp"
                    var $phcode108=(($arrayidx107)&4294967295); //@line 224 "phonemelist.cpp"
                    HEAP8[($phcode108)]=$64; //@line 224 "phonemelist.cpp"
                    ; //@line 225 "phonemelist.cpp"
                  }
                  else if (__label__ == 40) {
  
                    var $67=$regression; //@line 229 "phonemelist.cpp"
                    var $and112=($67) & 8; //@line 229 "phonemelist.cpp"
                    var $tobool113=((($and112))|0)!=0; //@line 229 "phonemelist.cpp"
                    if ($tobool113) { __label__ = 41;; } else { __label__ = 43;; } //@line 229 "phonemelist.cpp"
                    if (__label__ == 41) {
  
                      var $68=$type; //@line 232 "phonemelist.cpp"
                      var $cmp115=((($68))|0)==0; //@line 232 "phonemelist.cpp"
                      var $69=$type; //@line 232 "phonemelist.cpp"
                      var $cmp117=((($69))|0)==2; //@line 232 "phonemelist.cpp"
                      var $or_cond2=($cmp115) | ($cmp117); //@line 232 "phonemelist.cpp"
                      if (!($or_cond2)) { __label__ = 44;break $if_then73$$if_else89$37; } //@line 232 "phonemelist.cpp"
  
                      $voicing=0; //@line 233 "phonemelist.cpp"
                      ; //@line 233 "phonemelist.cpp"
                    }
                    else if (__label__ == 43) {
  
                      $voicing=0; //@line 237 "phonemelist.cpp"
                      ;
                    }
                  }
                }
              } while(0);
  
              $word_end_devoice=0; //@line 241 "phonemelist.cpp"
              var $70=$j; //@line 242 "phonemelist.cpp"
              var $71=$plist2; //@line 242 "phonemelist.cpp"
              var $arrayidx124=(($71+8*$70)&4294967295); //@line 242 "phonemelist.cpp"
              var $sourceix125=(($arrayidx124+6)&4294967295); //@line 242 "phonemelist.cpp"
              var $72=HEAP16[(($sourceix125)>>1)]; //@line 242 "phonemelist.cpp"
              var $tobool126=(tempInt=(($72)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 242 "phonemelist.cpp"
              if (!($tobool126)) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 242 "phonemelist.cpp"
  
              var $73=$regression; //@line 244 "phonemelist.cpp"
              var $and128=($73) & 4; //@line 244 "phonemelist.cpp"
              var $tobool129=((($and128))|0)!=0; //@line 244 "phonemelist.cpp"
              if ($tobool129) { __label__ = 46;; } else { __label__ = 47;; } //@line 244 "phonemelist.cpp"
              if (__label__ == 46) {
  
                $voicing=0; //@line 247 "phonemelist.cpp"
                ; //@line 248 "phonemelist.cpp"
              }
  
              var $74=$regression; //@line 249 "phonemelist.cpp"
              var $and132=($74) & 16; //@line 249 "phonemelist.cpp"
              var $tobool133=((($and132))|0)!=0; //@line 249 "phonemelist.cpp"
              if (!($tobool133)) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 249 "phonemelist.cpp"
  
              var $75=$voicing; //@line 252 "phonemelist.cpp"
              var $cmp135=((($75))|0)==0; //@line 252 "phonemelist.cpp"
              if (!($cmp135)) { __label__ = 50;break $for_inc140$$if_end44$21; } //@line 252 "phonemelist.cpp"
  
              $voicing=1; //@line 254 "phonemelist.cpp"
              $word_end_devoice=1; //@line 255 "phonemelist.cpp"
              ; //@line 256 "phonemelist.cpp"
            }
          } while(0);
  
          var $76=$j; //@line 177 "phonemelist.cpp"
          var $dec141=((($76)-1)&4294967295); //@line 177 "phonemelist.cpp"
          $j=$dec141; //@line 177 "phonemelist.cpp"
          var $cmp38=((($dec141))|0) >= 0; //@line 177 "phonemelist.cpp"
          if ($cmp38) { __label__ = 13;continue $for_body39$19; } else { __label__ = 51;break $if_then35$$if_end143$17; } //@line 177 "phonemelist.cpp"
        }
      }
    } while(0);
  
    var $77=$tr_addr; //@line 262 "phonemelist.cpp"
    var $arraydecay=(($ph_list3)&4294967295); //@line 262 "phonemelist.cpp"
    var $call=__ZL18SubstitutePhonemesP10TranslatorP12PHONEME_LIST($77, $arraydecay); //@line 262 "phonemelist.cpp"
    var $sub144=((($call)-2)&4294967295); //@line 262 "phonemelist.cpp"
    $n_ph_list3=$sub144; //@line 262 "phonemelist.cpp"
    $j=0; //@line 264 "phonemelist.cpp"
    ; //@line 264 "phonemelist.cpp"
    $for_cond145$72: while(1) { 
  
      var $78=$j; //@line 264 "phonemelist.cpp"
      var $79=$n_ph_list3; //@line 264 "phonemelist.cpp"
      var $cmp146=((($78))|0) < ((($79))|0); //@line 264 "phonemelist.cpp"
      if (!($cmp146)) { __label__ = 64;break $for_cond145$72; } //@line 264 "phonemelist.cpp"
  
      var $80=$ix; //@line 264 "phonemelist.cpp"
      var $cmp147=((($80))|0) < 997; //@line 264 "phonemelist.cpp"
      if (!($cmp147)) { __label__ = 64;break $for_cond145$72; }
  
      var $81=$j; //@line 266 "phonemelist.cpp"
      var $arrayidx149=(($ph_list3+$81*24)&4294967295); //@line 266 "phonemelist.cpp"
      var $sourceix150=(($arrayidx149+6)&4294967295); //@line 266 "phonemelist.cpp"
      var $82=HEAP16[(($sourceix150)>>1)]; //@line 266 "phonemelist.cpp"
      var $tobool151=(tempInt=(($82)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 266 "phonemelist.cpp"
      if ($tobool151) { __label__ = 55;; } else { __label__ = 63;; } //@line 266 "phonemelist.cpp"
      if (__label__ == 55) {
  
        $word_stress=0; //@line 271 "phonemelist.cpp"
        var $83=$j; //@line 274 "phonemelist.cpp"
        $nextw=$83; //@line 274 "phonemelist.cpp"
        ; //@line 274 "phonemelist.cpp"
        $for_cond153$78: while(1) { 
  
          var $84=$nextw; //@line 274 "phonemelist.cpp"
          var $85=$n_ph_list3; //@line 274 "phonemelist.cpp"
          var $cmp154=((($84))|0) < ((($85))|0); //@line 274 "phonemelist.cpp"
          if (!($cmp154)) { __label__ = 60;break $for_cond153$78; } //@line 274 "phonemelist.cpp"
  
          var $86=$nextw; //@line 276 "phonemelist.cpp"
          var $arrayidx156=(($ph_list3+$86*24)&4294967295); //@line 276 "phonemelist.cpp"
          var $stresslevel157=(($arrayidx156+1)&4294967295); //@line 276 "phonemelist.cpp"
          var $87=HEAPU8[($stresslevel157)]; //@line 276 "phonemelist.cpp"
          var $conv158=((($87))&255); //@line 276 "phonemelist.cpp"
          var $88=$word_stress; //@line 276 "phonemelist.cpp"
          var $cmp159=((($conv158))|0) > ((($88))|0); //@line 276 "phonemelist.cpp"
          if ($cmp159) { __label__ = 58;; } else { __label__ = 59;; } //@line 276 "phonemelist.cpp"
          if (__label__ == 58) {
  
            var $89=$nextw; //@line 277 "phonemelist.cpp"
            var $arrayidx161=(($ph_list3+$89*24)&4294967295); //@line 277 "phonemelist.cpp"
            var $stresslevel162=(($arrayidx161+1)&4294967295); //@line 277 "phonemelist.cpp"
            var $90=HEAPU8[($stresslevel162)]; //@line 277 "phonemelist.cpp"
            var $conv163=((($90))&255); //@line 277 "phonemelist.cpp"
            $word_stress=$conv163; //@line 277 "phonemelist.cpp"
            ; //@line 277 "phonemelist.cpp"
          }
  
          var $91=$nextw; //@line 279 "phonemelist.cpp"
          var $inc=((($91)+1)&4294967295); //@line 279 "phonemelist.cpp"
          $nextw=$inc; //@line 279 "phonemelist.cpp"
          var $92=$nextw; //@line 280 "phonemelist.cpp"
          var $arrayidx165=(($ph_list3+$92*24)&4294967295); //@line 280 "phonemelist.cpp"
          var $sourceix166=(($arrayidx165+6)&4294967295); //@line 280 "phonemelist.cpp"
          var $93=HEAP16[(($sourceix166)>>1)]; //@line 280 "phonemelist.cpp"
          var $tobool167=(tempInt=(($93)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 280 "phonemelist.cpp"
          if ($tobool167) { __label__ = 60;break $for_cond153$78; } else { __label__ = 56;continue $for_cond153$78; } //@line 280 "phonemelist.cpp"
        }
  
        var $94=$j; //@line 283 "phonemelist.cpp"
        $k=$94; //@line 283 "phonemelist.cpp"
        var $95=$k; //@line 283 "phonemelist.cpp"
        var $96=$nextw; //@line 283 "phonemelist.cpp"
        var $cmp1728=((($95))|0) < ((($96))|0); //@line 283 "phonemelist.cpp"
        if ($cmp1728) { __label__ = 61;; } else { __label__ = 62;; } //@line 283 "phonemelist.cpp"
        $for_body173$$for_end178$85: do { 
          if (__label__ == 61) {
            while(1) { 
  
              var $97=$word_stress; //@line 285 "phonemelist.cpp"
              var $conv174=((($97)) & 255); //@line 285 "phonemelist.cpp"
              var $98=$k; //@line 285 "phonemelist.cpp"
              var $arrayidx175=(($ph_list3+$98*24)&4294967295); //@line 285 "phonemelist.cpp"
              var $wordstress=(($arrayidx175+2)&4294967295); //@line 285 "phonemelist.cpp"
              HEAP8[($wordstress)]=$conv174; //@line 285 "phonemelist.cpp"
              var $99=$k; //@line 283 "phonemelist.cpp"
              var $inc177=((($99)+1)&4294967295); //@line 283 "phonemelist.cpp"
              $k=$inc177; //@line 283 "phonemelist.cpp"
              var $100=$k; //@line 283 "phonemelist.cpp"
              var $101=$nextw; //@line 283 "phonemelist.cpp"
              var $cmp172=((($100))|0) < ((($101))|0); //@line 283 "phonemelist.cpp"
              if ($cmp172) { __label__ = 61;continue ; } else { __label__ = 62;break $for_body173$$for_end178$85; } //@line 283 "phonemelist.cpp"
            }
          }
        } while(0);
  
        var $102=$nextw; //@line 287 "phonemelist.cpp"
        $j=$102; //@line 287 "phonemelist.cpp"
        __label__ = 52;continue $for_cond145$72; //@line 288 "phonemelist.cpp"
      }
      else if (__label__ == 63) {
  
        var $103=$j; //@line 291 "phonemelist.cpp"
        var $inc180=((($103)+1)&4294967295); //@line 291 "phonemelist.cpp"
        $j=$inc180; //@line 291 "phonemelist.cpp"
        __label__ = 52;continue $for_cond145$72;
      }
    }
  
    var $104=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 296 "phonemelist.cpp"
    $ph=$104; //@line 296 "phonemelist.cpp"
    var $105=$ph; //@line 297 "phonemelist.cpp"
    var $arrayidx183=(($ph_list3)&4294967295); //@line 297 "phonemelist.cpp"
    var $ph184=(($arrayidx183+8)&4294967295); //@line 297 "phonemelist.cpp"
    HEAP32[(($ph184)>>2)]=$105; //@line 297 "phonemelist.cpp"
    $switched_language=0; //@line 299 "phonemelist.cpp"
    $j=0; //@line 301 "phonemelist.cpp"
    var $pd_param=(($phdata+4)&4294967295); //@line 346 "phonemelist.cpp"
    var $arrayidx233=(($pd_param+12)&4294967295); //@line 346 "phonemelist.cpp"
    var $pd_param262=(($phdata+4)&4294967295); //@line 371 "phonemelist.cpp"
    var $arrayidx263=(($pd_param262+4)&4294967295); //@line 371 "phonemelist.cpp"
    var $pd_param480=(($phdata+4)&4294967295); //@line 568 "phonemelist.cpp"
    var $arrayidx481=(($pd_param480+16)&4294967295); //@line 568 "phonemelist.cpp"
    var $pd_param484=(($phdata+4)&4294967295); //@line 570 "phonemelist.cpp"
    var $arrayidx485=(($pd_param484+16)&4294967295); //@line 570 "phonemelist.cpp"
    var $pd_param537=(($phdata+4)&4294967295); //@line 608 "phonemelist.cpp"
    var $arrayidx538=(($pd_param537+40)&4294967295); //@line 608 "phonemelist.cpp"
    ; //@line 301 "phonemelist.cpp"
    $for_cond185$91: while(1) { 
  
      var $106=$insert_ph; //@line 301 "phonemelist.cpp"
      var $tobool186=((($106))|0)!=0; //@line 301 "phonemelist.cpp"
      if ($tobool186) { __lastLabel__ = 65; __label__ = 69;; } else { __lastLabel__ = 65; __label__ = 66;; } //@line 301 "phonemelist.cpp"
      if (__label__ == 66) {
  
        var $107=$j; //@line 301 "phonemelist.cpp"
        var $108=$n_ph_list3; //@line 301 "phonemelist.cpp"
        var $cmp187=((($107))|0) < ((($108))|0); //@line 301 "phonemelist.cpp"
        if (!($cmp187)) { __label__ = 158;break $for_cond185$91; } //@line 301 "phonemelist.cpp"
  
        var $109=$ix; //@line 301 "phonemelist.cpp"
        var $cmp189=((($109))|0) < 997; //@line 301 "phonemelist.cpp"
        if (!($cmp189)) { __label__ = 158;break $for_cond185$91; }
  
        var $_pr7=$insert_ph; //@line 307 "phonemelist.cpp"
        __lastLabel__ = 68; ;
      }
  
      var $110=__lastLabel__ == 68 ? $_pr7 : ($106); //@line 307 "phonemelist.cpp"
      var $111=$ph; //@line 303 "phonemelist.cpp"
      $prev=$111; //@line 303 "phonemelist.cpp"
      var $112=$j; //@line 305 "phonemelist.cpp"
      var $arrayidx192=(($ph_list3+$112*24)&4294967295); //@line 305 "phonemelist.cpp"
      $plist3=$arrayidx192; //@line 305 "phonemelist.cpp"
      var $cmp193=((($110))|0)!=0; //@line 307 "phonemelist.cpp"
      var $113=$plist3; //@line 310 "phonemelist.cpp"
      var $phcode195=(($113)&4294967295); //@line 310 "phonemelist.cpp"
      var $114=HEAPU8[($phcode195)]; //@line 310 "phonemelist.cpp"
      var $idxprom196=((($114))&255); //@line 310 "phonemelist.cpp"
      var $arrayidx197=((_phoneme_tab+$idxprom196*4)&4294967295); //@line 310 "phonemelist.cpp"
      var $115=HEAP32[(($arrayidx197)>>2)]; //@line 310 "phonemelist.cpp"
      if ($cmp193) { __label__ = 70;; } else { __label__ = 73;; } //@line 307 "phonemelist.cpp"
      if (__label__ == 70) {
  
        $next=$115; //@line 310 "phonemelist.cpp"
        var $116=$j; //@line 314 "phonemelist.cpp"
        var $dec198=((($116)-1)&4294967295); //@line 314 "phonemelist.cpp"
        $j=$dec198; //@line 314 "phonemelist.cpp"
        var $117=$j; //@line 315 "phonemelist.cpp"
        var $arrayidx199=(($ph_list3+$117*24)&4294967295); //@line 315 "phonemelist.cpp"
        $plist3_inserted=$arrayidx199; //@line 315 "phonemelist.cpp"
        $plist3=$arrayidx199; //@line 315 "phonemelist.cpp"
        var $118=$j; //@line 316 "phonemelist.cpp"
        var $cmp200=((($118))|0) > 0; //@line 316 "phonemelist.cpp"
        if ($cmp200) { __label__ = 71;; } else { __label__ = 72;; } //@line 316 "phonemelist.cpp"
        if (__label__ == 71) {
  
          var $119=$plist3; //@line 318 "phonemelist.cpp"
          var $arrayidx202=(($119+-24)&4294967295); //@line 318 "phonemelist.cpp"
          var $120=$arrayidx202; //@line 318 "phonemelist.cpp"
          var $121=$plist3; //@line 318 "phonemelist.cpp"
          var $arrayidx203=(($121)&4294967295); //@line 318 "phonemelist.cpp"
          var $122=$arrayidx203; //@line 318 "phonemelist.cpp"
          var $src$, $dest$, $stop$, $stop4$, $fast$;
          $src$ = $122;
          $dest$ = $120;
          $stop$ = $src$ + 24;
          if (($dest$%4) == ($src$%4) && 24 > 8) {
            while ($src$%4 !== 0 && $src$ < $stop$) {
              ; HEAP8[$dest$++] = HEAP8[$src$++];
            }
            $src$ >>= 2;
            $dest$ >>= 2;
            $stop4$ = $stop$ >> 2;
            while ($src$ < $stop4$) {
          ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
            }
            $src$ <<= 2;
            $dest$ <<= 2;
          }while ($src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }; //@line 318 "phonemelist.cpp"
          ; //@line 319 "phonemelist.cpp"
        }
  
        var $123=$plist3; //@line 320 "phonemelist.cpp"
        var $arrayidx205=(($123)&4294967295); //@line 320 "phonemelist.cpp"
        var $124=$arrayidx205; //@line 320 "phonemelist.cpp"
        var $dest$, $stop$, $stop4$, $fast$, $value4$;
        $dest$ = $124;
        $stop$ = $dest$ + 24;
        $value4$ = 0;
        if ($value4$ < 0) $value4$ += 256;
        $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
        while ($dest$%4 !== 0 && $dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($dest$ < $stop4$) {
        ;;;;;;;  HEAP32[$dest$++] = $value4$;
        }
        $dest$ <<= 2;
        while ($dest$ < $stop$) {
          ;; HEAP8[$dest$++] = 0;
        }; //@line 320 "phonemelist.cpp"
        var $125=$insert_ph; //@line 321 "phonemelist.cpp"
        var $conv206=((($125)) & 255); //@line 321 "phonemelist.cpp"
        var $126=$plist3; //@line 321 "phonemelist.cpp"
        var $phcode207=(($126)&4294967295); //@line 321 "phonemelist.cpp"
        HEAP8[($phcode207)]=$conv206; //@line 321 "phonemelist.cpp"
        var $127=$insert_ph; //@line 322 "phonemelist.cpp"
        var $arrayidx208=((_phoneme_tab+$127*4)&4294967295); //@line 322 "phonemelist.cpp"
        var $128=HEAP32[(($arrayidx208)>>2)]; //@line 322 "phonemelist.cpp"
        $ph=$128; //@line 322 "phonemelist.cpp"
        var $129=$ph; //@line 323 "phonemelist.cpp"
        var $130=$plist3; //@line 323 "phonemelist.cpp"
        var $ph209=(($130+8)&4294967295); //@line 323 "phonemelist.cpp"
        HEAP32[(($ph209)>>2)]=$129; //@line 323 "phonemelist.cpp"
        $insert_ph=0; //@line 324 "phonemelist.cpp"
        ; //@line 325 "phonemelist.cpp"
      }
      else if (__label__ == 73) {
  
        $ph=$115; //@line 329 "phonemelist.cpp"
        var $131=$ph; //@line 330 "phonemelist.cpp"
        var $132=$plist3; //@line 330 "phonemelist.cpp"
        var $arrayidx214=(($132)&4294967295); //@line 330 "phonemelist.cpp"
        var $ph215=(($arrayidx214+8)&4294967295); //@line 330 "phonemelist.cpp"
        HEAP32[(($ph215)>>2)]=$131; //@line 330 "phonemelist.cpp"
        var $133=$plist3; //@line 332 "phonemelist.cpp"
        var $phcode216=(($133)&4294967295); //@line 332 "phonemelist.cpp"
        var $134=HEAPU8[($phcode216)]; //@line 332 "phonemelist.cpp"
        var $conv217=((($134))&255); //@line 332 "phonemelist.cpp"
        var $cmp218=((($conv217))|0)==21; //@line 332 "phonemelist.cpp"
        if ($cmp218) { __label__ = 74;; } else { __label__ = 75;; } //@line 332 "phonemelist.cpp"
        if (__label__ == 74) {
  
          var $135=$plist3; //@line 335 "phonemelist.cpp"
          var $tone_ph=(($135+3)&4294967295); //@line 335 "phonemelist.cpp"
          var $136=HEAPU8[($tone_ph)]; //@line 335 "phonemelist.cpp"
          var $conv220=((($136))&255); //@line 335 "phonemelist.cpp"
          __Z18SelectPhonemeTablei($conv220); //@line 335 "phonemelist.cpp"
          var $137=$switched_language; //@line 336 "phonemelist.cpp"
          var $xor221=($137) ^ 32; //@line 336 "phonemelist.cpp"
          $switched_language=$xor221; //@line 336 "phonemelist.cpp"
          ; //@line 337 "phonemelist.cpp"
        }
  
        var $138=$plist3; //@line 338 "phonemelist.cpp"
        var $arrayidx223=(($138+24)&4294967295); //@line 338 "phonemelist.cpp"
        var $phcode224=(($arrayidx223)&4294967295); //@line 338 "phonemelist.cpp"
        var $139=HEAPU8[($phcode224)]; //@line 338 "phonemelist.cpp"
        var $idxprom225=((($139))&255); //@line 338 "phonemelist.cpp"
        var $arrayidx226=((_phoneme_tab+$idxprom225*4)&4294967295); //@line 338 "phonemelist.cpp"
        var $140=HEAP32[(($arrayidx226)>>2)]; //@line 338 "phonemelist.cpp"
        $next=$140; //@line 338 "phonemelist.cpp"
        var $141=$next; //@line 339 "phonemelist.cpp"
        var $142=$plist3; //@line 339 "phonemelist.cpp"
        var $arrayidx227=(($142+24)&4294967295); //@line 339 "phonemelist.cpp"
        var $ph228=(($arrayidx227+8)&4294967295); //@line 339 "phonemelist.cpp"
        HEAP32[(($ph228)>>2)]=$141; //@line 339 "phonemelist.cpp"
        ;
      }
  
      var $143=$ph; //@line 342 "phonemelist.cpp"
      var $cmp230=((($143))|0)==0; //@line 342 "phonemelist.cpp"
      if ($cmp230) { __label__ = 157;; } else { __label__ = 77;; } //@line 342 "phonemelist.cpp"
      $for_inc584$$if_end232$108: do { 
        if (__label__ == 77) {
  
          var $144=$tr_addr; //@line 344 "phonemelist.cpp"
          var $145=$plist3; //@line 344 "phonemelist.cpp"
          __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($144, 256, $145, $phdata); //@line 344 "phonemelist.cpp"
          var $146=HEAP32[(($arrayidx233)>>2)]; //@line 346 "phonemelist.cpp"
          $alternative=$146; //@line 346 "phonemelist.cpp"
          var $cmp234=((($146))|0) > 0; //@line 346 "phonemelist.cpp"
          if ($cmp234) { __label__ = 78;; } else { __label__ = 83;; } //@line 346 "phonemelist.cpp"
          if (__label__ == 78) {
  
            var $147=$ph; //@line 350 "phonemelist.cpp"
            $ph2=$147; //@line 350 "phonemelist.cpp"
            var $148=$plist3; //@line 352 "phonemelist.cpp"
            var $phcode236=(($148)&4294967295); //@line 352 "phonemelist.cpp"
            var $149=HEAPU8[($phcode236)]; //@line 352 "phonemelist.cpp"
            var $conv237=((($149))&255); //@line 352 "phonemelist.cpp"
            $insert_ph=$conv237; //@line 352 "phonemelist.cpp"
            var $150=$alternative; //@line 353 "phonemelist.cpp"
            var $arrayidx238=((_phoneme_tab+$150*4)&4294967295); //@line 353 "phonemelist.cpp"
            var $151=HEAP32[(($arrayidx238)>>2)]; //@line 353 "phonemelist.cpp"
            $ph=$151; //@line 353 "phonemelist.cpp"
            var $152=$ph; //@line 354 "phonemelist.cpp"
            var $153=$plist3; //@line 354 "phonemelist.cpp"
            var $ph239=(($153+8)&4294967295); //@line 354 "phonemelist.cpp"
            HEAP32[(($ph239)>>2)]=$152; //@line 354 "phonemelist.cpp"
            var $154=$alternative; //@line 355 "phonemelist.cpp"
            var $conv240=((($154)) & 255); //@line 355 "phonemelist.cpp"
            var $155=$plist3; //@line 355 "phonemelist.cpp"
            var $phcode241=(($155)&4294967295); //@line 355 "phonemelist.cpp"
            HEAP8[($phcode241)]=$conv240; //@line 355 "phonemelist.cpp"
            var $156=$ph; //@line 357 "phonemelist.cpp"
            var $type242=(($156+11)&4294967295); //@line 357 "phonemelist.cpp"
            var $157=HEAPU8[($type242)]; //@line 357 "phonemelist.cpp"
            var $conv243=((($157))&255); //@line 357 "phonemelist.cpp"
            var $cmp244=((($conv243))|0)==2; //@line 357 "phonemelist.cpp"
            var $158=$plist3; //@line 359 "phonemelist.cpp"
            var $synthflags246=(($158+4)&4294967295); //@line 359 "phonemelist.cpp"
            var $159=HEAPU16[(($synthflags246)>>1)]; //@line 359 "phonemelist.cpp"
            var $conv247=((($159))&65535); //@line 359 "phonemelist.cpp"
            if ($cmp244) { __label__ = 79;; } else { __label__ = 81;; } //@line 357 "phonemelist.cpp"
            $if_then245$$if_else255$112: do { 
              if (__label__ == 79) {
  
                var $or=($conv247) | 4; //@line 359 "phonemelist.cpp"
                var $conv248=((($or)) & 65535); //@line 359 "phonemelist.cpp"
                HEAP16[(($synthflags246)>>1)]=$conv248; //@line 359 "phonemelist.cpp"
                var $160=$ph2; //@line 360 "phonemelist.cpp"
                var $type249=(($160+11)&4294967295); //@line 360 "phonemelist.cpp"
                var $161=HEAPU8[($type249)]; //@line 360 "phonemelist.cpp"
                var $conv250=((($161))&255); //@line 360 "phonemelist.cpp"
                var $cmp251=((($conv250))|0)!=2; //@line 360 "phonemelist.cpp"
                if (!($cmp251)) { __label__ = 82;break $if_then245$$if_else255$112; } //@line 360 "phonemelist.cpp"
  
                var $162=$plist3; //@line 361 "phonemelist.cpp"
                var $stresslevel253=(($162+1)&4294967295); //@line 361 "phonemelist.cpp"
                HEAP8[($stresslevel253)]=0; //@line 361 "phonemelist.cpp"
                ; //@line 361 "phonemelist.cpp"
              }
              else if (__label__ == 81) {
  
                var $and258=($conv247) & -5; //@line 364 "phonemelist.cpp"
                var $conv259=((($and258)) & 65535); //@line 364 "phonemelist.cpp"
                HEAP16[(($synthflags246)>>1)]=$conv259; //@line 364 "phonemelist.cpp"
                ;
              }
            } while(0);
  
            var $163=$tr_addr; //@line 368 "phonemelist.cpp"
            var $164=$plist3; //@line 368 "phonemelist.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($163, 256, $164, $phdata); //@line 368 "phonemelist.cpp"
            ; //@line 369 "phonemelist.cpp"
          }
  
          var $165=HEAP32[(($arrayidx263)>>2)]; //@line 371 "phonemelist.cpp"
          $alternative=$165; //@line 371 "phonemelist.cpp"
          var $cmp264=((($165))|0) > 0; //@line 371 "phonemelist.cpp"
          if ($cmp264) { __label__ = 84;; } else { __label__ = 90;; } //@line 371 "phonemelist.cpp"
          if (__label__ == 84) {
  
            var $166=$ph; //@line 374 "phonemelist.cpp"
            $ph2266=$166; //@line 374 "phonemelist.cpp"
            var $167=$alternative; //@line 375 "phonemelist.cpp"
            var $arrayidx267=((_phoneme_tab+$167*4)&4294967295); //@line 375 "phonemelist.cpp"
            var $168=HEAP32[(($arrayidx267)>>2)]; //@line 375 "phonemelist.cpp"
            $ph=$168; //@line 375 "phonemelist.cpp"
            var $169=$ph; //@line 376 "phonemelist.cpp"
            var $170=$plist3; //@line 376 "phonemelist.cpp"
            var $ph268=(($170+8)&4294967295); //@line 376 "phonemelist.cpp"
            HEAP32[(($ph268)>>2)]=$169; //@line 376 "phonemelist.cpp"
            var $171=$alternative; //@line 377 "phonemelist.cpp"
            var $conv269=((($171)) & 255); //@line 377 "phonemelist.cpp"
            var $172=$plist3; //@line 377 "phonemelist.cpp"
            var $phcode270=(($172)&4294967295); //@line 377 "phonemelist.cpp"
            HEAP8[($phcode270)]=$conv269; //@line 377 "phonemelist.cpp"
            var $173=$alternative; //@line 379 "phonemelist.cpp"
            var $cmp271=((($173))|0)==1; //@line 379 "phonemelist.cpp"
            if ($cmp271) { __label__ = 157;break $for_inc584$$if_end232$108; } //@line 379 "phonemelist.cpp"
  
            var $174=$ph; //@line 382 "phonemelist.cpp"
            var $type274=(($174+11)&4294967295); //@line 382 "phonemelist.cpp"
            var $175=HEAPU8[($type274)]; //@line 382 "phonemelist.cpp"
            var $conv275=((($175))&255); //@line 382 "phonemelist.cpp"
            var $cmp276=((($conv275))|0)==2; //@line 382 "phonemelist.cpp"
            var $176=$plist3; //@line 384 "phonemelist.cpp"
            var $synthflags278=(($176+4)&4294967295); //@line 384 "phonemelist.cpp"
            var $177=HEAPU16[(($synthflags278)>>1)]; //@line 384 "phonemelist.cpp"
            var $conv279=((($177))&65535); //@line 384 "phonemelist.cpp"
            if ($cmp276) { __label__ = 86;; } else { __label__ = 88;; } //@line 382 "phonemelist.cpp"
            $if_then277$$if_else288$121: do { 
              if (__label__ == 86) {
  
                var $or280=($conv279) | 4; //@line 384 "phonemelist.cpp"
                var $conv281=((($or280)) & 65535); //@line 384 "phonemelist.cpp"
                HEAP16[(($synthflags278)>>1)]=$conv281; //@line 384 "phonemelist.cpp"
                var $178=$ph2266; //@line 385 "phonemelist.cpp"
                var $type282=(($178+11)&4294967295); //@line 385 "phonemelist.cpp"
                var $179=HEAPU8[($type282)]; //@line 385 "phonemelist.cpp"
                var $conv283=((($179))&255); //@line 385 "phonemelist.cpp"
                var $cmp284=((($conv283))|0)!=2; //@line 385 "phonemelist.cpp"
                if (!($cmp284)) { __label__ = 89;break $if_then277$$if_else288$121; } //@line 385 "phonemelist.cpp"
  
                var $180=$plist3; //@line 386 "phonemelist.cpp"
                var $stresslevel286=(($180+1)&4294967295); //@line 386 "phonemelist.cpp"
                HEAP8[($stresslevel286)]=0; //@line 386 "phonemelist.cpp"
                ; //@line 386 "phonemelist.cpp"
              }
              else if (__label__ == 88) {
  
                var $and291=($conv279) & -5; //@line 389 "phonemelist.cpp"
                var $conv292=((($and291)) & 65535); //@line 389 "phonemelist.cpp"
                HEAP16[(($synthflags278)>>1)]=$conv292; //@line 389 "phonemelist.cpp"
                ;
              }
            } while(0);
  
            var $181=$tr_addr; //@line 393 "phonemelist.cpp"
            var $182=$plist3; //@line 393 "phonemelist.cpp"
            __Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA($181, 256, $182, $phdata); //@line 393 "phonemelist.cpp"
            ; //@line 394 "phonemelist.cpp"
          }
  
          var $183=$ph; //@line 396 "phonemelist.cpp"
          var $type295=(($183+11)&4294967295); //@line 396 "phonemelist.cpp"
          var $184=HEAPU8[($type295)]; //@line 396 "phonemelist.cpp"
          var $conv296=((($184))&255); //@line 396 "phonemelist.cpp"
          var $cmp297=((($conv296))|0)==2; //@line 396 "phonemelist.cpp"
          if ($cmp297) { __label__ = 91;; } else { __label__ = 110;; } //@line 396 "phonemelist.cpp"
          $if_then298$$if_end362$127: do { 
            if (__label__ == 91) {
  
              var $185=$plist3; //@line 402 "phonemelist.cpp"
              var $stresslevel299=(($185+1)&4294967295); //@line 402 "phonemelist.cpp"
              var $186=HEAPU8[($stresslevel299)]; //@line 402 "phonemelist.cpp"
              var $conv300=((($186))&255); //@line 402 "phonemelist.cpp"
              var $cmp301=((($conv300))|0) <= 1; //@line 402 "phonemelist.cpp"
              if ($cmp301) { __label__ = 92;; } else { __label__ = 109;; } //@line 402 "phonemelist.cpp"
              if (__label__ == 92) {
  
                var $187=$unstress_count; //@line 405 "phonemelist.cpp"
                var $inc303=((($187)+1)&4294967295); //@line 405 "phonemelist.cpp"
                $unstress_count=$inc303; //@line 405 "phonemelist.cpp"
                var $188=$tr_addr; //@line 407 "phonemelist.cpp"
                var $langopts304=(($188)&4294967295); //@line 407 "phonemelist.cpp"
                var $stress_flags=(($langopts304+12)&4294967295); //@line 407 "phonemelist.cpp"
                var $189=HEAP32[(($stress_flags)>>2)]; //@line 407 "phonemelist.cpp"
                var $and305=($189) & 8; //@line 407 "phonemelist.cpp"
                var $tobool306=((($and305))|0)!=0; //@line 407 "phonemelist.cpp"
                if ($tobool306) { __label__ = 93;; } else { __label__ = 102;; } //@line 407 "phonemelist.cpp"
                if (__label__ == 93) {
  
                  var $190=$plist3; //@line 410 "phonemelist.cpp"
                  var $add_ptr=(($190+24)&4294967295); //@line 410 "phonemelist.cpp"
                  $p=$add_ptr; //@line 410 "phonemelist.cpp"
                  ; //@line 410 "phonemelist.cpp"
                  while(1) { 
  
                    var $191=$p; //@line 410 "phonemelist.cpp"
                    var $type309=(($191+15)&4294967295); //@line 410 "phonemelist.cpp"
                    var $192=HEAPU8[($type309)]; //@line 410 "phonemelist.cpp"
                    var $conv310=((($192))&255); //@line 410 "phonemelist.cpp"
                    var $cmp311=((($conv310))|0)!=0; //@line 410 "phonemelist.cpp"
                    if (!($cmp311)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 410 "phonemelist.cpp"
  
                    var $193=$p; //@line 412 "phonemelist.cpp"
                    var $type313=(($193+15)&4294967295); //@line 412 "phonemelist.cpp"
                    var $194=HEAPU8[($type313)]; //@line 412 "phonemelist.cpp"
                    var $conv314=((($194))&255); //@line 412 "phonemelist.cpp"
                    var $cmp315=((($conv314))|0)==2; //@line 412 "phonemelist.cpp"
                    var $195=$p; //@line 414 "phonemelist.cpp"
                    if ($cmp315) { __label__ = 96;break ; } //@line 412 "phonemelist.cpp"
  
                    var $incdec_ptr=(($195+24)&4294967295); //@line 410 "phonemelist.cpp"
                    $p=$incdec_ptr; //@line 410 "phonemelist.cpp"
                    __label__ = 94;continue ; //@line 410 "phonemelist.cpp"
                  }
  
                  var $stresslevel317=(($195+1)&4294967295); //@line 414 "phonemelist.cpp"
                  var $196=HEAPU8[($stresslevel317)]; //@line 414 "phonemelist.cpp"
                  var $conv318=((($196))&255); //@line 414 "phonemelist.cpp"
                  var $cmp319=((($conv318))|0) <= 1; //@line 414 "phonemelist.cpp"
                  if (!($cmp319)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 414 "phonemelist.cpp"
  
                  var $197=$plist3; //@line 416 "phonemelist.cpp"
                  var $wordstress321=(($197+2)&4294967295); //@line 416 "phonemelist.cpp"
                  var $198=HEAPU8[($wordstress321)]; //@line 416 "phonemelist.cpp"
                  var $conv322=((($198))&255); //@line 416 "phonemelist.cpp"
                  var $cmp323=((($conv322))|0) < 4; //@line 416 "phonemelist.cpp"
                  if ($cmp323) { __label__ = 98;; } else { __label__ = 99;; } //@line 416 "phonemelist.cpp"
                  if (__label__ == 98) {
  
                    var $199=$plist3; //@line 417 "phonemelist.cpp"
                    var $stresslevel325=(($199+1)&4294967295); //@line 417 "phonemelist.cpp"
                    HEAP8[($stresslevel325)]=0; //@line 417 "phonemelist.cpp"
                    ; //@line 417 "phonemelist.cpp"
                  }
  
                  var $200=$p; //@line 418 "phonemelist.cpp"
                  var $wordstress327=(($200+2)&4294967295); //@line 418 "phonemelist.cpp"
                  var $201=HEAPU8[($wordstress327)]; //@line 418 "phonemelist.cpp"
                  var $conv328=((($201))&255); //@line 418 "phonemelist.cpp"
                  var $cmp329=((($conv328))|0) < 4; //@line 418 "phonemelist.cpp"
                  if (!($cmp329)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 418 "phonemelist.cpp"
  
                  var $202=$p; //@line 419 "phonemelist.cpp"
                  var $stresslevel331=(($202+1)&4294967295); //@line 419 "phonemelist.cpp"
                  HEAP8[($stresslevel331)]=0; //@line 419 "phonemelist.cpp"
                  ; //@line 419 "phonemelist.cpp"
                }
                else if (__label__ == 102) {
  
                  var $203=$unstress_count; //@line 427 "phonemelist.cpp"
                  var $cmp338=((($203))|0) > 1; //@line 427 "phonemelist.cpp"
                  if (!($cmp338)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 427 "phonemelist.cpp"
  
                  var $204=$unstress_count; //@line 427 "phonemelist.cpp"
                  var $and340=($204) & 1; //@line 427 "phonemelist.cpp"
                  var $cmp341=((($and340))|0)==0; //@line 427 "phonemelist.cpp"
                  if (!($cmp341)) { __label__ = 110;break $if_then298$$if_end362$127; } //@line 427 "phonemelist.cpp"
  
                  var $205=$tr_addr; //@line 431 "phonemelist.cpp"
                  var $langopts343=(($205)&4294967295); //@line 431 "phonemelist.cpp"
                  var $stress_flags344=(($langopts343+12)&4294967295); //@line 431 "phonemelist.cpp"
                  var $206=HEAP32[(($stress_flags344)>>2)]; //@line 431 "phonemelist.cpp"
                  var $and345=($206) & 2; //@line 431 "phonemelist.cpp"
                  var $tobool346=((($and345))|0)!=0; //@line 431 "phonemelist.cpp"
                  if ($tobool346) { __label__ = 107;; } else { __label__ = 105;; } //@line 431 "phonemelist.cpp"
                  $if_then354$$lor_lhs_false347$146: do { 
                    if (__label__ == 105) {
  
                      var $207=$word_stress; //@line 431 "phonemelist.cpp"
                      var $cmp348=((($207))|0) > 3; //@line 431 "phonemelist.cpp"
                      if ($cmp348) { __label__ = 106;; } else { __label__ = 108;; } //@line 431 "phonemelist.cpp"
                      if (__label__ == 106) {
  
                        var $208=$plist3; //@line 431 "phonemelist.cpp"
                        var $add_ptr350=(($208+24)&4294967295); //@line 431 "phonemelist.cpp"
                        var $sourceix351=(($add_ptr350+6)&4294967295); //@line 431 "phonemelist.cpp"
                        var $209=HEAPU16[(($sourceix351)>>1)]; //@line 431 "phonemelist.cpp"
                        var $conv352=((($209))&65535); //@line 431 "phonemelist.cpp"
                        var $cmp353=((($conv352))|0)!=0; //@line 431 "phonemelist.cpp"
                        if ($cmp353) { __label__ = 107;break $if_then354$$lor_lhs_false347$146; } //@line 431 "phonemelist.cpp"
                      }
  
                      var $210=$plist3; //@line 438 "phonemelist.cpp"
                      var $stresslevel356=(($210+1)&4294967295); //@line 438 "phonemelist.cpp"
                      HEAP8[($stresslevel356)]=0; //@line 438 "phonemelist.cpp"
                      __label__ = 110;break $if_then298$$if_end362$127;
                    }
                  } while(0);
  
                  $unstress_count=1; //@line 434 "phonemelist.cpp"
                  ; //@line 435 "phonemelist.cpp"
                }
              }
              else if (__label__ == 109) {
  
                $unstress_count=0; //@line 445 "phonemelist.cpp"
                ;
              }
            }
          } while(0);
  
          var $211=$ph; //@line 493 "phonemelist.cpp"
          var $type363=(($211+11)&4294967295); //@line 493 "phonemelist.cpp"
          var $212=HEAPU8[($type363)]; //@line 493 "phonemelist.cpp"
          var $conv364=((($212))&255); //@line 493 "phonemelist.cpp"
          var $cmp365=((($conv364))|0)==2; //@line 493 "phonemelist.cpp"
          if ($cmp365) { __label__ = 111;; } else { __label__ = 112;; } //@line 493 "phonemelist.cpp"
          if (__label__ == 111) {
  
            $first_vowel=0; //@line 494 "phonemelist.cpp"
            ; //@line 494 "phonemelist.cpp"
          }
  
          var $213=$plist3; //@line 496 "phonemelist.cpp"
          var $add_ptr368=(($213+24)&4294967295); //@line 496 "phonemelist.cpp"
          var $synthflags369=(($add_ptr368+4)&4294967295); //@line 496 "phonemelist.cpp"
          var $214=HEAPU16[(($synthflags369)>>1)]; //@line 496 "phonemelist.cpp"
          var $conv370=((($214))&65535); //@line 496 "phonemelist.cpp"
          var $and371=($conv370) & 8; //@line 496 "phonemelist.cpp"
          var $tobool372=((($and371))|0)!=0; //@line 496 "phonemelist.cpp"
          if ($tobool372) { __label__ = 113;; } else { __label__ = 115;; } //@line 496 "phonemelist.cpp"
          $if_then373$$if_end387$157: do { 
            if (__label__ == 113) {
  
              var $215=$next; //@line 499 "phonemelist.cpp"
              var $type374=(($215+11)&4294967295); //@line 499 "phonemelist.cpp"
              var $216=HEAPU8[($type374)]; //@line 499 "phonemelist.cpp"
              var $conv375=((($216))&255); //@line 499 "phonemelist.cpp"
              var $call376=_strchr(((__ZZ15MakePhonemeListP10TranslatoriiE12types_double)&4294967295), $conv375); //@line 499 "phonemelist.cpp"
              var $tobool377=((($call376))|0)!=0; //@line 499 "phonemelist.cpp"
              if (!($tobool377)) { __label__ = 115;break $if_then373$$if_end387$157; } //@line 499 "phonemelist.cpp"
  
              var $217=$next; //@line 502 "phonemelist.cpp"
              var $code379=(($217+10)&4294967295); //@line 502 "phonemelist.cpp"
              var $218=HEAPU8[($code379)]; //@line 502 "phonemelist.cpp"
              var $conv380=((($218))&255); //@line 502 "phonemelist.cpp"
              $insert_ph=$conv380; //@line 502 "phonemelist.cpp"
              var $219=$plist3; //@line 503 "phonemelist.cpp"
              var $add_ptr381=(($219+24)&4294967295); //@line 503 "phonemelist.cpp"
              var $synthflags382=(($add_ptr381+4)&4294967295); //@line 503 "phonemelist.cpp"
              var $220=HEAPU16[(($synthflags382)>>1)]; //@line 503 "phonemelist.cpp"
              var $conv383=((($220))&65535); //@line 503 "phonemelist.cpp"
              var $xor384=($conv383) ^ 8; //@line 503 "phonemelist.cpp"
              var $conv385=((($xor384)) & 65535); //@line 503 "phonemelist.cpp"
              HEAP16[(($synthflags382)>>1)]=$conv385; //@line 503 "phonemelist.cpp"
              ; //@line 504 "phonemelist.cpp"
            }
          } while(0);
  
          var $221=$plist3; //@line 507 "phonemelist.cpp"
          var $add_ptr388=(($221+24)&4294967295); //@line 507 "phonemelist.cpp"
          var $sourceix389=(($add_ptr388+6)&4294967295); //@line 507 "phonemelist.cpp"
          var $222=HEAPU16[(($sourceix389)>>1)]; //@line 507 "phonemelist.cpp"
          var $conv390=((($222))&65535); //@line 507 "phonemelist.cpp"
          var $cmp391=((($conv390))|0)!=0; //@line 507 "phonemelist.cpp"
          if ($cmp391) { __label__ = 116;; } else { __label__ = 141;; } //@line 507 "phonemelist.cpp"
          $if_then392$$if_end471$161: do { 
            if (__label__ == 116) {
  
              var $223=$tr_addr; //@line 511 "phonemelist.cpp"
              var $langopts393=(($223)&4294967295); //@line 511 "phonemelist.cpp"
              var $vowel_pause=(($langopts393+4)&4294967295); //@line 511 "phonemelist.cpp"
              var $224=HEAP32[(($vowel_pause)>>2)]; //@line 511 "phonemelist.cpp"
              var $tobool394=((($224))|0)!=0; //@line 511 "phonemelist.cpp"
              if ($tobool394) { __label__ = 117;; } else { __label__ = 134;; } //@line 511 "phonemelist.cpp"
              $land_lhs_true395$$if_end450$163: do { 
                if (__label__ == 117) {
  
                  var $225=$ph; //@line 511 "phonemelist.cpp"
                  var $type396=(($225+11)&4294967295); //@line 511 "phonemelist.cpp"
                  var $226=HEAPU8[($type396)]; //@line 511 "phonemelist.cpp"
                  var $conv397=((($226))&255); //@line 511 "phonemelist.cpp"
                  var $cmp398=((($conv397))|0)!=0; //@line 511 "phonemelist.cpp"
                  if (!($cmp398)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 511 "phonemelist.cpp"
  
                  var $227=$ph; //@line 514 "phonemelist.cpp"
                  var $type400=(($227+11)&4294967295); //@line 514 "phonemelist.cpp"
                  var $228=HEAPU8[($type400)]; //@line 514 "phonemelist.cpp"
                  var $conv401=((($228))&255); //@line 514 "phonemelist.cpp"
                  var $cmp402=((($conv401))|0)!=2; //@line 514 "phonemelist.cpp"
                  if ($cmp402) { __label__ = 119;; } else { __label__ = 121;; } //@line 514 "phonemelist.cpp"
                  $land_lhs_true403$$if_end409$166: do { 
                    if (__label__ == 119) {
  
                      var $229=$tr_addr; //@line 514 "phonemelist.cpp"
                      var $langopts404=(($229)&4294967295); //@line 514 "phonemelist.cpp"
                      var $vowel_pause405=(($langopts404+4)&4294967295); //@line 514 "phonemelist.cpp"
                      var $230=HEAP32[(($vowel_pause405)>>2)]; //@line 514 "phonemelist.cpp"
                      var $and406=($230) & 512; //@line 514 "phonemelist.cpp"
                      var $tobool407=((($and406))|0)!=0; //@line 514 "phonemelist.cpp"
                      if (!($tobool407)) { __label__ = 121;break $land_lhs_true403$$if_end409$166; } //@line 514 "phonemelist.cpp"
  
                      $insert_ph=11; //@line 517 "phonemelist.cpp"
                      ; //@line 518 "phonemelist.cpp"
                    }
                  } while(0);
  
                  var $231=$next; //@line 520 "phonemelist.cpp"
                  var $type410=(($231+11)&4294967295); //@line 520 "phonemelist.cpp"
                  var $232=HEAPU8[($type410)]; //@line 520 "phonemelist.cpp"
                  var $conv411=((($232))&255); //@line 520 "phonemelist.cpp"
                  var $cmp412=((($conv411))|0)==2; //@line 520 "phonemelist.cpp"
                  if (!($cmp412)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 520 "phonemelist.cpp"
  
                  var $233=$tr_addr; //@line 522 "phonemelist.cpp"
                  var $langopts414=(($233)&4294967295); //@line 522 "phonemelist.cpp"
                  var $vowel_pause415=(($langopts414+4)&4294967295); //@line 522 "phonemelist.cpp"
                  var $234=HEAP32[(($vowel_pause415)>>2)]; //@line 522 "phonemelist.cpp"
                  var $and416=($234) & 12; //@line 522 "phonemelist.cpp"
                  $x=$and416; //@line 522 "phonemelist.cpp"
                  var $cmp417=((($and416))|0)!=0; //@line 522 "phonemelist.cpp"
                  if ($cmp417) { __label__ = 123;; } else { __label__ = 126;; } //@line 522 "phonemelist.cpp"
                  if (__label__ == 123) {
  
                    var $235=$x; //@line 525 "phonemelist.cpp"
                    var $cmp419=((($235))|0)==12; //@line 525 "phonemelist.cpp"
                    if ($cmp419) { __label__ = 124;; } else { __label__ = 125;; } //@line 525 "phonemelist.cpp"
                    if (__label__ == 124) {
  
                      $insert_ph=11; //@line 526 "phonemelist.cpp"
                      ; //@line 526 "phonemelist.cpp"
                    }
                    else if (__label__ == 125) {
  
                      $insert_ph=23; //@line 528 "phonemelist.cpp"
                      ;
                    }
                  }
  
                  var $236=$ph; //@line 531 "phonemelist.cpp"
                  var $type424=(($236+11)&4294967295); //@line 531 "phonemelist.cpp"
                  var $237=HEAPU8[($type424)]; //@line 531 "phonemelist.cpp"
                  var $conv425=((($237))&255); //@line 531 "phonemelist.cpp"
                  var $cmp426=((($conv425))|0)==2; //@line 531 "phonemelist.cpp"
                  if ($cmp426) { __label__ = 127;; } else { __label__ = 131;; } //@line 531 "phonemelist.cpp"
                  $land_lhs_true427$$if_end437$177: do { 
                    if (__label__ == 127) {
  
                      var $238=$tr_addr; //@line 531 "phonemelist.cpp"
                      var $langopts428=(($238)&4294967295); //@line 531 "phonemelist.cpp"
                      var $vowel_pause429=(($langopts428+4)&4294967295); //@line 531 "phonemelist.cpp"
                      var $239=HEAP32[(($vowel_pause429)>>2)]; //@line 531 "phonemelist.cpp"
                      var $and430=($239) & 3; //@line 531 "phonemelist.cpp"
                      $x=$and430; //@line 531 "phonemelist.cpp"
                      var $cmp431=((($and430))|0)!=0; //@line 531 "phonemelist.cpp"
                      if (!($cmp431)) { __label__ = 131;break $land_lhs_true427$$if_end437$177; } //@line 531 "phonemelist.cpp"
  
                      var $240=$x; //@line 534 "phonemelist.cpp"
                      var $cmp433=((($240))|0)==2; //@line 534 "phonemelist.cpp"
                      if ($cmp433) { __label__ = 129;; } else { __label__ = 130;; } //@line 534 "phonemelist.cpp"
                      if (__label__ == 129) {
  
                        $insert_ph=10; //@line 535 "phonemelist.cpp"
                        ; //@line 535 "phonemelist.cpp"
                      }
                      else if (__label__ == 130) {
  
                        $insert_ph=23; //@line 537 "phonemelist.cpp"
                        ;
                      }
                    }
                  } while(0);
  
                  var $241=$plist3; //@line 540 "phonemelist.cpp"
                  var $add_ptr438=(($241+24)&4294967295); //@line 540 "phonemelist.cpp"
                  var $stresslevel439=(($add_ptr438+1)&4294967295); //@line 540 "phonemelist.cpp"
                  var $242=HEAPU8[($stresslevel439)]; //@line 540 "phonemelist.cpp"
                  var $conv440=((($242))&255); //@line 540 "phonemelist.cpp"
                  var $cmp441=((($conv440))|0) >= 4; //@line 540 "phonemelist.cpp"
                  if (!($cmp441)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 540 "phonemelist.cpp"
  
                  var $243=$tr_addr; //@line 540 "phonemelist.cpp"
                  var $langopts443=(($243)&4294967295); //@line 540 "phonemelist.cpp"
                  var $vowel_pause444=(($langopts443+4)&4294967295); //@line 540 "phonemelist.cpp"
                  var $244=HEAP32[(($vowel_pause444)>>2)]; //@line 540 "phonemelist.cpp"
                  var $and445=($244) & 256; //@line 540 "phonemelist.cpp"
                  var $tobool446=((($and445))|0)!=0; //@line 540 "phonemelist.cpp"
                  if (!($tobool446)) { __label__ = 134;break $land_lhs_true395$$if_end450$163; } //@line 540 "phonemelist.cpp"
  
                  $insert_ph=10; //@line 543 "phonemelist.cpp"
                  ; //@line 544 "phonemelist.cpp"
                }
              } while(0);
  
              var $245=$plist3; //@line 548 "phonemelist.cpp"
              var $246=$plist3_inserted; //@line 548 "phonemelist.cpp"
              var $cmp451=((($245))|0)!=((($246))|0); //@line 548 "phonemelist.cpp"
              if (!($cmp451)) { __label__ = 141;break $if_then392$$if_end471$161; } //@line 548 "phonemelist.cpp"
  
              var $247=$tr_addr; //@line 550 "phonemelist.cpp"
              var $langopts453=(($247)&4294967295); //@line 550 "phonemelist.cpp"
              var $word_gap=(($langopts453)&4294967295); //@line 550 "phonemelist.cpp"
              var $248=HEAP32[(($word_gap)>>2)]; //@line 550 "phonemelist.cpp"
              var $and454=($248) & 7; //@line 550 "phonemelist.cpp"
              $x=$and454; //@line 550 "phonemelist.cpp"
              var $cmp455=((($and454))|0)!=0; //@line 550 "phonemelist.cpp"
              if ($cmp455) { __label__ = 136;; } else { __label__ = 139;; } //@line 550 "phonemelist.cpp"
              $if_then456$$if_end466$188: do { 
                if (__label__ == 136) {
  
                  var $249=$x; //@line 552 "phonemelist.cpp"
                  var $cmp457=((($249))|0) > 1; //@line 552 "phonemelist.cpp"
                  if ($cmp457) { __label__ = 138;; } else { __label__ = 137;; } //@line 552 "phonemelist.cpp"
                  if (__label__ == 137) {
  
                    var $250=$insert_ph; //@line 552 "phonemelist.cpp"
                    var $cmp459=((($250))|0)!=10; //@line 552 "phonemelist.cpp"
                    var $251=$insert_ph; //@line 552 "phonemelist.cpp"
                    var $cmp461=((($251))|0)!=11; //@line 552 "phonemelist.cpp"
                    var $or_cond3=($cmp459) & ($cmp461); //@line 552 "phonemelist.cpp"
                    if (!($or_cond3)) { __label__ = 139;break $if_then456$$if_end466$188; } //@line 552 "phonemelist.cpp"
                  }
  
                  var $252=$x; //@line 555 "phonemelist.cpp"
                  var $arrayidx463=((_pause_phonemes+$252)&4294967295); //@line 555 "phonemelist.cpp"
                  var $253=HEAPU8[($arrayidx463)]; //@line 555 "phonemelist.cpp"
                  var $conv464=((($253))&255); //@line 555 "phonemelist.cpp"
                  $insert_ph=$conv464; //@line 555 "phonemelist.cpp"
                  ; //@line 556 "phonemelist.cpp"
                }
              } while(0);
  
              var $254=HEAP32[((_option_wordgap)>>2)]; //@line 558 "phonemelist.cpp"
              var $cmp467=((($254))|0) > 0; //@line 558 "phonemelist.cpp"
              if (!($cmp467)) { __label__ = 141;break $if_then392$$if_end471$161; } //@line 558 "phonemelist.cpp"
  
              $insert_ph=24; //@line 560 "phonemelist.cpp"
              ; //@line 561 "phonemelist.cpp"
            }
          } while(0);
  
          var $255=$plist3; //@line 565 "phonemelist.cpp"
          var $arrayidx472=(($255+48)&4294967295); //@line 565 "phonemelist.cpp"
          var $phcode473=(($arrayidx472)&4294967295); //@line 565 "phonemelist.cpp"
          var $256=HEAPU8[($phcode473)]; //@line 565 "phonemelist.cpp"
          var $idxprom474=((($256))&255); //@line 565 "phonemelist.cpp"
          var $arrayidx475=((_phoneme_tab+$idxprom474*4)&4294967295); //@line 565 "phonemelist.cpp"
          var $257=HEAP32[(($arrayidx475)>>2)]; //@line 565 "phonemelist.cpp"
          $next2=$257; //@line 565 "phonemelist.cpp"
          var $258=$next2; //@line 566 "phonemelist.cpp"
          var $259=$plist3; //@line 566 "phonemelist.cpp"
          var $arrayidx476=(($259+48)&4294967295); //@line 566 "phonemelist.cpp"
          var $ph477=(($arrayidx476+8)&4294967295); //@line 566 "phonemelist.cpp"
          HEAP32[(($ph477)>>2)]=$258; //@line 566 "phonemelist.cpp"
          var $260=$insert_ph; //@line 568 "phonemelist.cpp"
          var $cmp478=((($260))|0)==0; //@line 568 "phonemelist.cpp"
          if ($cmp478) { __label__ = 142;; } else { __label__ = 144;; } //@line 568 "phonemelist.cpp"
          $land_lhs_true479$$if_end486$196: do { 
            if (__label__ == 142) {
  
              var $261=HEAP32[(($arrayidx481)>>2)]; //@line 568 "phonemelist.cpp"
              var $cmp482=((($261))|0)!=0; //@line 568 "phonemelist.cpp"
              if (!($cmp482)) { __label__ = 144;break $land_lhs_true479$$if_end486$196; } //@line 568 "phonemelist.cpp"
  
              var $262=HEAP32[(($arrayidx485)>>2)]; //@line 570 "phonemelist.cpp"
              $insert_ph=$262; //@line 570 "phonemelist.cpp"
              ; //@line 571 "phonemelist.cpp"
            }
          } while(0);
  
          var $263=$ph; //@line 581 "phonemelist.cpp"
          var $264=$ix; //@line 581 "phonemelist.cpp"
          var $265=$phlist; //@line 581 "phonemelist.cpp"
          var $arrayidx491=(($265+24*$264)&4294967295); //@line 581 "phonemelist.cpp"
          var $ph492=(($arrayidx491+8)&4294967295); //@line 581 "phonemelist.cpp"
          HEAP32[(($ph492)>>2)]=$263; //@line 581 "phonemelist.cpp"
          var $266=$ph; //@line 582 "phonemelist.cpp"
          var $type493=(($266+11)&4294967295); //@line 582 "phonemelist.cpp"
          var $267=HEAP8[($type493)]; //@line 582 "phonemelist.cpp"
          var $268=$ix; //@line 582 "phonemelist.cpp"
          var $269=$phlist; //@line 582 "phonemelist.cpp"
          var $arrayidx494=(($269+24*$268)&4294967295); //@line 582 "phonemelist.cpp"
          var $type495=(($arrayidx494+15)&4294967295); //@line 582 "phonemelist.cpp"
          HEAP8[($type495)]=$267; //@line 582 "phonemelist.cpp"
          var $270=$ix; //@line 583 "phonemelist.cpp"
          var $271=$phlist; //@line 583 "phonemelist.cpp"
          var $arrayidx496=(($271+24*$270)&4294967295); //@line 583 "phonemelist.cpp"
          var $env=(($arrayidx496+14)&4294967295); //@line 583 "phonemelist.cpp"
          HEAP8[($env)]=0; //@line 583 "phonemelist.cpp"
          var $272=$plist3; //@line 584 "phonemelist.cpp"
          var $synthflags497=(($272+4)&4294967295); //@line 584 "phonemelist.cpp"
          var $273=HEAPU16[(($synthflags497)>>1)]; //@line 584 "phonemelist.cpp"
          var $conv498=((($273))&65535); //@line 584 "phonemelist.cpp"
          var $274=$switched_language; //@line 584 "phonemelist.cpp"
          var $or499=($conv498) | ($274); //@line 584 "phonemelist.cpp"
          var $conv500=((($or499)) & 65535); //@line 584 "phonemelist.cpp"
          var $275=$ix; //@line 584 "phonemelist.cpp"
          var $276=$phlist; //@line 584 "phonemelist.cpp"
          var $arrayidx501=(($276+24*$275)&4294967295); //@line 584 "phonemelist.cpp"
          var $synthflags502=(($arrayidx501+4)&4294967295); //@line 584 "phonemelist.cpp"
          HEAP16[(($synthflags502)>>1)]=$conv500; //@line 584 "phonemelist.cpp"
          var $277=$plist3; //@line 585 "phonemelist.cpp"
          var $stresslevel503=(($277+1)&4294967295); //@line 585 "phonemelist.cpp"
          var $278=HEAPU8[($stresslevel503)]; //@line 585 "phonemelist.cpp"
          var $conv504=((($278))&255); //@line 585 "phonemelist.cpp"
          var $and505=($conv504) & 15; //@line 585 "phonemelist.cpp"
          var $conv506=((($and505)) & 255); //@line 585 "phonemelist.cpp"
          var $279=$ix; //@line 585 "phonemelist.cpp"
          var $280=$phlist; //@line 585 "phonemelist.cpp"
          var $arrayidx507=(($280+24*$279)&4294967295); //@line 585 "phonemelist.cpp"
          var $stresslevel508=(($arrayidx507+1)&4294967295); //@line 585 "phonemelist.cpp"
          HEAP8[($stresslevel508)]=$conv506; //@line 585 "phonemelist.cpp"
          var $281=$plist3; //@line 586 "phonemelist.cpp"
          var $wordstress509=(($281+2)&4294967295); //@line 586 "phonemelist.cpp"
          var $282=HEAP8[($wordstress509)]; //@line 586 "phonemelist.cpp"
          var $283=$ix; //@line 586 "phonemelist.cpp"
          var $284=$phlist; //@line 586 "phonemelist.cpp"
          var $arrayidx510=(($284+24*$283)&4294967295); //@line 586 "phonemelist.cpp"
          var $wordstress511=(($arrayidx510+2)&4294967295); //@line 586 "phonemelist.cpp"
          HEAP8[($wordstress511)]=$282; //@line 586 "phonemelist.cpp"
          var $285=$plist3; //@line 587 "phonemelist.cpp"
          var $tone_ph512=(($285+3)&4294967295); //@line 587 "phonemelist.cpp"
          var $286=HEAP8[($tone_ph512)]; //@line 587 "phonemelist.cpp"
          var $287=$ix; //@line 587 "phonemelist.cpp"
          var $288=$phlist; //@line 587 "phonemelist.cpp"
          var $arrayidx513=(($288+24*$287)&4294967295); //@line 587 "phonemelist.cpp"
          var $tone_ph514=(($arrayidx513+3)&4294967295); //@line 587 "phonemelist.cpp"
          HEAP8[($tone_ph514)]=$286; //@line 587 "phonemelist.cpp"
          var $289=$ix; //@line 588 "phonemelist.cpp"
          var $290=$phlist; //@line 588 "phonemelist.cpp"
          var $arrayidx515=(($290+24*$289)&4294967295); //@line 588 "phonemelist.cpp"
          var $sourceix516=(($arrayidx515+6)&4294967295); //@line 588 "phonemelist.cpp"
          HEAP16[(($sourceix516)>>1)]=0; //@line 588 "phonemelist.cpp"
          var $291=$ph; //@line 589 "phonemelist.cpp"
          var $code517=(($291+10)&4294967295); //@line 589 "phonemelist.cpp"
          var $292=HEAP8[($code517)]; //@line 589 "phonemelist.cpp"
          var $293=$ix; //@line 589 "phonemelist.cpp"
          var $294=$phlist; //@line 589 "phonemelist.cpp"
          var $arrayidx518=(($294+24*$293)&4294967295); //@line 589 "phonemelist.cpp"
          var $phcode519=(($arrayidx518)&4294967295); //@line 589 "phonemelist.cpp"
          HEAP8[($phcode519)]=$292; //@line 589 "phonemelist.cpp"
          var $295=$plist3; //@line 591 "phonemelist.cpp"
          var $sourceix520=(($295+6)&4294967295); //@line 591 "phonemelist.cpp"
          var $296=HEAPU16[(($sourceix520)>>1)]; //@line 591 "phonemelist.cpp"
          var $conv521=((($296))&65535); //@line 591 "phonemelist.cpp"
          var $cmp522=((($conv521))|0)!=0; //@line 591 "phonemelist.cpp"
          if ($cmp522) { __label__ = 145;; } else { __label__ = 147;; } //@line 591 "phonemelist.cpp"
          $if_then523$$if_else533$200: do { 
            if (__label__ == 145) {
  
              var $297=$plist3; //@line 593 "phonemelist.cpp"
              var $sourceix524=(($297+6)&4294967295); //@line 593 "phonemelist.cpp"
              var $298=HEAP16[(($sourceix524)>>1)]; //@line 593 "phonemelist.cpp"
              var $299=$ix; //@line 593 "phonemelist.cpp"
              var $300=$phlist; //@line 593 "phonemelist.cpp"
              var $arrayidx525=(($300+24*$299)&4294967295); //@line 593 "phonemelist.cpp"
              var $sourceix526=(($arrayidx525+6)&4294967295); //@line 593 "phonemelist.cpp"
              HEAP16[(($sourceix526)>>1)]=$298; //@line 593 "phonemelist.cpp"
              var $301=$ix; //@line 594 "phonemelist.cpp"
              var $302=$phlist; //@line 594 "phonemelist.cpp"
              var $arrayidx527=(($302+24*$301)&4294967295); //@line 594 "phonemelist.cpp"
              var $newword=(($arrayidx527+19)&4294967295); //@line 594 "phonemelist.cpp"
              HEAP8[($newword)]=1; //@line 594 "phonemelist.cpp"
              var $303=$start_sentence_addr; //@line 596 "phonemelist.cpp"
              var $tobool528=((($303))|0)!=0; //@line 596 "phonemelist.cpp"
              if (!($tobool528)) { __label__ = 148;break $if_then523$$if_else533$200; } //@line 596 "phonemelist.cpp"
  
              var $304=$ix; //@line 598 "phonemelist.cpp"
              var $305=$phlist; //@line 598 "phonemelist.cpp"
              var $arrayidx530=(($305+24*$304)&4294967295); //@line 598 "phonemelist.cpp"
              var $newword531=(($arrayidx530+19)&4294967295); //@line 598 "phonemelist.cpp"
              HEAP8[($newword531)]=5; //@line 598 "phonemelist.cpp"
              $start_sentence_addr=0; //@line 599 "phonemelist.cpp"
              ; //@line 600 "phonemelist.cpp"
            }
            else if (__label__ == 147) {
  
              var $306=$ix; //@line 604 "phonemelist.cpp"
              var $307=$phlist; //@line 604 "phonemelist.cpp"
              var $arrayidx534=(($307+24*$306)&4294967295); //@line 604 "phonemelist.cpp"
              var $newword535=(($arrayidx534+19)&4294967295); //@line 604 "phonemelist.cpp"
              HEAP8[($newword535)]=0; //@line 604 "phonemelist.cpp"
              ;
            }
          } while(0);
  
          var $308=HEAP32[(($arrayidx538)>>2)]; //@line 608 "phonemelist.cpp"
          var $mul=((($308)*2)&4294967295); //@line 608 "phonemelist.cpp"
          var $conv539=((($mul)) & 65535); //@line 608 "phonemelist.cpp"
          var $309=$ix; //@line 608 "phonemelist.cpp"
          var $310=$phlist; //@line 608 "phonemelist.cpp"
          var $arrayidx540=(($310+24*$309)&4294967295); //@line 608 "phonemelist.cpp"
          var $length=(($arrayidx540+12)&4294967295); //@line 608 "phonemelist.cpp"
          HEAP16[(($length)>>1)]=$conv539; //@line 608 "phonemelist.cpp"
          var $311=$ph; //@line 609 "phonemelist.cpp"
          var $code541=(($311+10)&4294967295); //@line 609 "phonemelist.cpp"
          var $312=HEAPU8[($code541)]; //@line 609 "phonemelist.cpp"
          var $conv542=((($312))&255); //@line 609 "phonemelist.cpp"
          var $cmp543=((($conv542))|0)==24; //@line 609 "phonemelist.cpp"
          var $313=HEAP32[((_option_wordgap)>>2)]; //@line 609 "phonemelist.cpp"
          var $cmp545=((($313))|0) > 0; //@line 609 "phonemelist.cpp"
          var $or_cond4=($cmp543) & ($cmp545); //@line 609 "phonemelist.cpp"
          if ($or_cond4) { __label__ = 149;; } else { __label__ = 150;; } //@line 609 "phonemelist.cpp"
          if (__label__ == 149) {
  
            var $314=HEAP32[((((_phoneme_tab+40)&4294967295))>>2)]; //@line 611 "phonemelist.cpp"
            var $315=$ix; //@line 611 "phonemelist.cpp"
            var $316=$phlist; //@line 611 "phonemelist.cpp"
            var $arrayidx547=(($316+24*$315)&4294967295); //@line 611 "phonemelist.cpp"
            var $ph548=(($arrayidx547+8)&4294967295); //@line 611 "phonemelist.cpp"
            HEAP32[(($ph548)>>2)]=$314; //@line 611 "phonemelist.cpp"
            var $317=HEAP32[((_option_wordgap)>>2)]; //@line 612 "phonemelist.cpp"
            var $mul549=((($317)*14)&4294967295); //@line 612 "phonemelist.cpp"
            var $conv550=((($mul549)) & 65535); //@line 612 "phonemelist.cpp"
            var $318=$ix; //@line 612 "phonemelist.cpp"
            var $319=$phlist; //@line 612 "phonemelist.cpp"
            var $arrayidx551=(($319+24*$318)&4294967295); //@line 612 "phonemelist.cpp"
            var $length552=(($arrayidx551+12)&4294967295); //@line 612 "phonemelist.cpp"
            HEAP16[(($length552)>>1)]=$conv550; //@line 612 "phonemelist.cpp"
            ; //@line 613 "phonemelist.cpp"
          }
  
          var $320=$ph; //@line 615 "phonemelist.cpp"
          var $type554=(($320+11)&4294967295); //@line 615 "phonemelist.cpp"
          var $321=HEAPU8[($type554)]; //@line 615 "phonemelist.cpp"
          var $conv555=((($321))&255); //@line 615 "phonemelist.cpp"
          var $cmp556=((($conv555))|0)==2; //@line 615 "phonemelist.cpp"
          if ($cmp556) { __label__ = 155;; } else { __label__ = 151;; } //@line 615 "phonemelist.cpp"
          $if_then573$$lor_lhs_false557$208: do { 
            if (__label__ == 151) {
  
              var $322=$ph; //@line 615 "phonemelist.cpp"
              var $type558=(($322+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $323=HEAPU8[($type558)]; //@line 615 "phonemelist.cpp"
              var $conv559=((($323))&255); //@line 615 "phonemelist.cpp"
              var $cmp560=((($conv559))|0)==3; //@line 615 "phonemelist.cpp"
              if ($cmp560) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
  
              var $324=$ph; //@line 615 "phonemelist.cpp"
              var $type562=(($324+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $325=HEAPU8[($type562)]; //@line 615 "phonemelist.cpp"
              var $conv563=((($325))&255); //@line 615 "phonemelist.cpp"
              var $cmp564=((($conv563))|0)==8; //@line 615 "phonemelist.cpp"
              if ($cmp564) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
  
              var $326=$ph; //@line 615 "phonemelist.cpp"
              var $type566=(($326+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $327=HEAPU8[($type566)]; //@line 615 "phonemelist.cpp"
              var $conv567=((($327))&255); //@line 615 "phonemelist.cpp"
              var $cmp568=((($conv567))|0)==5; //@line 615 "phonemelist.cpp"
              if ($cmp568) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
  
              var $328=$ph; //@line 615 "phonemelist.cpp"
              var $type570=(($328+11)&4294967295); //@line 615 "phonemelist.cpp"
              var $329=HEAPU8[($type570)]; //@line 615 "phonemelist.cpp"
              var $conv571=((($329))&255); //@line 615 "phonemelist.cpp"
              var $cmp572=((($conv571))|0)==7; //@line 615 "phonemelist.cpp"
              if ($cmp572) { __label__ = 155;break $if_then573$$lor_lhs_false557$208; } else { __label__ = 156;break $if_then573$$lor_lhs_false557$208; } //@line 615 "phonemelist.cpp"
            }
          } while(0);
          if (__label__ == 155) {
  
            var $330=$ix; //@line 617 "phonemelist.cpp"
            var $331=$phlist; //@line 617 "phonemelist.cpp"
            var $arrayidx574=(($331+24*$330)&4294967295); //@line 617 "phonemelist.cpp"
            var $length575=(($arrayidx574+12)&4294967295); //@line 617 "phonemelist.cpp"
            HEAP16[(($length575)>>1)]=128; //@line 617 "phonemelist.cpp"
            var $332=$ix; //@line 618 "phonemelist.cpp"
            var $333=$phlist; //@line 618 "phonemelist.cpp"
            var $arrayidx576=(($333+24*$332)&4294967295); //@line 618 "phonemelist.cpp"
            var $env577=(($arrayidx576+14)&4294967295); //@line 618 "phonemelist.cpp"
            HEAP8[($env577)]=0; //@line 618 "phonemelist.cpp"
            ; //@line 619 "phonemelist.cpp"
          }
  
          var $334=$ix; //@line 621 "phonemelist.cpp"
          var $335=$phlist; //@line 621 "phonemelist.cpp"
          var $arrayidx579=(($335+24*$334)&4294967295); //@line 621 "phonemelist.cpp"
          var $prepause=(($arrayidx579+16)&4294967295); //@line 621 "phonemelist.cpp"
          HEAP8[($prepause)]=0; //@line 621 "phonemelist.cpp"
          var $336=$ix; //@line 622 "phonemelist.cpp"
          var $337=$phlist; //@line 622 "phonemelist.cpp"
          var $arrayidx580=(($337+24*$336)&4294967295); //@line 622 "phonemelist.cpp"
          var $amp=(($arrayidx580+18)&4294967295); //@line 622 "phonemelist.cpp"
          HEAP8[($amp)]=20; //@line 622 "phonemelist.cpp"
          var $338=$ix; //@line 623 "phonemelist.cpp"
          var $339=$phlist; //@line 623 "phonemelist.cpp"
          var $arrayidx581=(($339+24*$338)&4294967295); //@line 623 "phonemelist.cpp"
          var $pitch1=(($arrayidx581+20)&4294967295); //@line 623 "phonemelist.cpp"
          HEAP8[($pitch1)]=-1; //@line 623 "phonemelist.cpp"
          var $340=$ix; //@line 624 "phonemelist.cpp"
          var $341=$phlist; //@line 624 "phonemelist.cpp"
          var $arrayidx582=(($341+24*$340)&4294967295); //@line 624 "phonemelist.cpp"
          var $pitch2=(($arrayidx582+21)&4294967295); //@line 624 "phonemelist.cpp"
          HEAP8[($pitch2)]=-1; //@line 624 "phonemelist.cpp"
          var $342=$ix; //@line 625 "phonemelist.cpp"
          var $inc583=((($342)+1)&4294967295); //@line 625 "phonemelist.cpp"
          $ix=$inc583; //@line 625 "phonemelist.cpp"
          ; //@line 626 "phonemelist.cpp"
        }
      } while(0);
  
      var $343=$j; //@line 301 "phonemelist.cpp"
      var $inc585=((($343)+1)&4294967295); //@line 301 "phonemelist.cpp"
      $j=$inc585; //@line 301 "phonemelist.cpp"
      __label__ = 65;continue $for_cond185$91; //@line 301 "phonemelist.cpp"
    }
  
    var $344=$ix; //@line 627 "phonemelist.cpp"
    var $345=$phlist; //@line 627 "phonemelist.cpp"
    var $arrayidx587=(($345+24*$344)&4294967295); //@line 627 "phonemelist.cpp"
    var $newword588=(($arrayidx587+19)&4294967295); //@line 627 "phonemelist.cpp"
    HEAP8[($newword588)]=2; //@line 627 "phonemelist.cpp"
    var $346=$ix; //@line 629 "phonemelist.cpp"
    var $347=$phlist; //@line 629 "phonemelist.cpp"
    var $arrayidx589=(($347+24*$346)&4294967295); //@line 629 "phonemelist.cpp"
    var $phcode590=(($arrayidx589)&4294967295); //@line 629 "phonemelist.cpp"
    HEAP8[($phcode590)]=9; //@line 629 "phonemelist.cpp"
    var $348=$ix; //@line 630 "phonemelist.cpp"
    var $349=$phlist; //@line 630 "phonemelist.cpp"
    var $arrayidx591=(($349+24*$348)&4294967295); //@line 630 "phonemelist.cpp"
    var $type592=(($arrayidx591+15)&4294967295); //@line 630 "phonemelist.cpp"
    HEAP8[($type592)]=0; //@line 630 "phonemelist.cpp"
    var $350=$post_pause_addr; //@line 631 "phonemelist.cpp"
    var $conv593=((($350)) & 65535); //@line 631 "phonemelist.cpp"
    var $351=$ix; //@line 631 "phonemelist.cpp"
    var $352=$phlist; //@line 631 "phonemelist.cpp"
    var $arrayidx594=(($352+24*$351)&4294967295); //@line 631 "phonemelist.cpp"
    var $length595=(($arrayidx594+12)&4294967295); //@line 631 "phonemelist.cpp"
    HEAP16[(($length595)>>1)]=$conv593; //@line 631 "phonemelist.cpp"
    var $353=$end_sourceix; //@line 632 "phonemelist.cpp"
    var $conv596=((($353)) & 65535); //@line 632 "phonemelist.cpp"
    var $354=$ix; //@line 632 "phonemelist.cpp"
    var $355=$phlist; //@line 632 "phonemelist.cpp"
    var $arrayidx597=(($355+24*$354)&4294967295); //@line 632 "phonemelist.cpp"
    var $sourceix598=(($arrayidx597+6)&4294967295); //@line 632 "phonemelist.cpp"
    HEAP16[(($sourceix598)>>1)]=$conv596; //@line 632 "phonemelist.cpp"
    var $356=$ix; //@line 633 "phonemelist.cpp"
    var $357=$phlist; //@line 633 "phonemelist.cpp"
    var $arrayidx599=(($357+24*$356)&4294967295); //@line 633 "phonemelist.cpp"
    var $synthflags600=(($arrayidx599+4)&4294967295); //@line 633 "phonemelist.cpp"
    HEAP16[(($synthflags600)>>1)]=0; //@line 633 "phonemelist.cpp"
    var $358=HEAP32[((((_phoneme_tab+36)&4294967295))>>2)]; //@line 634 "phonemelist.cpp"
    var $359=$ix; //@line 634 "phonemelist.cpp"
    var $inc601=((($359)+1)&4294967295); //@line 634 "phonemelist.cpp"
    $ix=$inc601; //@line 634 "phonemelist.cpp"
    var $360=$phlist; //@line 634 "phonemelist.cpp"
    var $arrayidx602=(($360+24*$359)&4294967295); //@line 634 "phonemelist.cpp"
    var $ph603=(($arrayidx602+8)&4294967295); //@line 634 "phonemelist.cpp"
    HEAP32[(($ph603)>>2)]=$358; //@line 634 "phonemelist.cpp"
    var $361=$ix; //@line 636 "phonemelist.cpp"
    var $362=$phlist; //@line 636 "phonemelist.cpp"
    var $arrayidx604=(($362+24*$361)&4294967295); //@line 636 "phonemelist.cpp"
    var $phcode605=(($arrayidx604)&4294967295); //@line 636 "phonemelist.cpp"
    HEAP8[($phcode605)]=9; //@line 636 "phonemelist.cpp"
    var $363=$ix; //@line 637 "phonemelist.cpp"
    var $364=$phlist; //@line 637 "phonemelist.cpp"
    var $arrayidx606=(($364+24*$363)&4294967295); //@line 637 "phonemelist.cpp"
    var $type607=(($arrayidx606+15)&4294967295); //@line 637 "phonemelist.cpp"
    HEAP8[($type607)]=0; //@line 637 "phonemelist.cpp"
    var $365=$ix; //@line 638 "phonemelist.cpp"
    var $366=$phlist; //@line 638 "phonemelist.cpp"
    var $arrayidx608=(($366+24*$365)&4294967295); //@line 638 "phonemelist.cpp"
    var $length609=(($arrayidx608+12)&4294967295); //@line 638 "phonemelist.cpp"
    HEAP16[(($length609)>>1)]=0; //@line 638 "phonemelist.cpp"
    var $367=$ix; //@line 639 "phonemelist.cpp"
    var $368=$phlist; //@line 639 "phonemelist.cpp"
    var $arrayidx610=(($368+24*$367)&4294967295); //@line 639 "phonemelist.cpp"
    var $sourceix611=(($arrayidx610+6)&4294967295); //@line 639 "phonemelist.cpp"
    HEAP16[(($sourceix611)>>1)]=0; //@line 639 "phonemelist.cpp"
    var $369=$ix; //@line 640 "phonemelist.cpp"
    var $370=$phlist; //@line 640 "phonemelist.cpp"
    var $arrayidx612=(($370+24*$369)&4294967295); //@line 640 "phonemelist.cpp"
    var $synthflags613=(($arrayidx612+4)&4294967295); //@line 640 "phonemelist.cpp"
    HEAP16[(($synthflags613)>>1)]=0; //@line 640 "phonemelist.cpp"
    var $371=HEAP32[((((_phoneme_tab+40)&4294967295))>>2)]; //@line 641 "phonemelist.cpp"
    var $372=$ix; //@line 641 "phonemelist.cpp"
    var $inc614=((($372)+1)&4294967295); //@line 641 "phonemelist.cpp"
    $ix=$inc614; //@line 641 "phonemelist.cpp"
    var $373=$phlist; //@line 641 "phonemelist.cpp"
    var $arrayidx615=(($373+24*$372)&4294967295); //@line 641 "phonemelist.cpp"
    var $ph616=(($arrayidx615+8)&4294967295); //@line 641 "phonemelist.cpp"
    HEAP32[(($ph616)>>2)]=$371; //@line 641 "phonemelist.cpp"
    var $374=$ix; //@line 643 "phonemelist.cpp"
    HEAP32[((_n_phoneme_list)>>2)]=$374; //@line 643 "phonemelist.cpp"
    STACKTOP = __stackBase__;
    return; //@line 644 "phonemelist.cpp"
    return;
  }
  

  function __ZL18SubstitutePhonemesP10TranslatorP12PHONEME_LIST($tr, $plist_out) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $tr_addr;
    var $plist_out_addr;
    var $ix;
    var $k;
    var $replace_flags;
    var $n_plist_out;
    var $word_end;
    var $switched_language;
    var $plist2;
    var $next;
    $tr_addr=$tr;
    $plist_out_addr=$plist_out;
    $n_plist_out=0; //@line 48 "phonemelist.cpp"
    $switched_language=0; //@line 50 "phonemelist.cpp"
    $next=0; //@line 52 "phonemelist.cpp"
    $ix=0; //@line 54 "phonemelist.cpp"
    ; //@line 54 "phonemelist.cpp"
    $for_cond$2: while(1) { 
  
      var $0=$ix; //@line 54 "phonemelist.cpp"
      var $1=HEAP32[((_n_ph_list2)>>2)]; //@line 54 "phonemelist.cpp"
      var $cmp=((($0))|0) < ((($1))|0); //@line 54 "phonemelist.cpp"
      if (!($cmp)) { __label__ = 26;break $for_cond$2; } //@line 54 "phonemelist.cpp"
  
      var $2=$n_plist_out; //@line 54 "phonemelist.cpp"
      var $cmp1=((($2))|0) < 1000; //@line 54 "phonemelist.cpp"
      if (!($cmp1)) { __label__ = 26;break $for_cond$2; }
  
      var $3=$ix; //@line 56 "phonemelist.cpp"
      var $arrayidx=((_ph_list2+$3*8)&4294967295); //@line 56 "phonemelist.cpp"
      $plist2=$arrayidx; //@line 56 "phonemelist.cpp"
      var $4=$plist2; //@line 58 "phonemelist.cpp"
      var $phcode=(($4)&4294967295); //@line 58 "phonemelist.cpp"
      var $5=HEAPU8[($phcode)]; //@line 58 "phonemelist.cpp"
      var $conv=((($5))&255); //@line 58 "phonemelist.cpp"
      var $cmp2=((($conv))|0)==21; //@line 58 "phonemelist.cpp"
      var $6=$switched_language; //@line 59 "phonemelist.cpp"
      if ($cmp2) { __lastLabel__ = 3; __label__ = 4;; } else { __lastLabel__ = 3; __label__ = 5;; } //@line 58 "phonemelist.cpp"
      if (__label__ == 4) {
  
        var $xor=($6) ^ 1; //@line 59 "phonemelist.cpp"
        $switched_language=$xor; //@line 59 "phonemelist.cpp"
        __lastLabel__ = 4; ; //@line 59 "phonemelist.cpp"
      }
  
      var $7=__lastLabel__ == 4 ? $xor : ($6); //@line 62 "phonemelist.cpp"
      var $cmp3=((($7))|0)==0; //@line 62 "phonemelist.cpp"
      if ($cmp3) { __label__ = 6;; } else { __label__ = 24;; } //@line 62 "phonemelist.cpp"
      $if_then4$$if_end61$9: do { 
        if (__label__ == 6) {
  
          var $8=$ix; //@line 64 "phonemelist.cpp"
          var $9=HEAP32[((_n_ph_list2)>>2)]; //@line 64 "phonemelist.cpp"
          var $sub=((($9)-1)&4294967295); //@line 64 "phonemelist.cpp"
          var $cmp5=((($8))|0) < ((($sub))|0); //@line 64 "phonemelist.cpp"
          if ($cmp5) { __label__ = 7;; } else { __label__ = 8;; } //@line 64 "phonemelist.cpp"
          if (__label__ == 7) {
  
            var $10=$ix; //@line 65 "phonemelist.cpp"
            var $add=((($10)+1)&4294967295); //@line 65 "phonemelist.cpp"
            var $arrayidx7=((_ph_list2+$add*8)&4294967295); //@line 65 "phonemelist.cpp"
            var $phcode8=(($arrayidx7)&4294967295); //@line 65 "phonemelist.cpp"
            var $11=HEAPU8[($phcode8)]; //@line 65 "phonemelist.cpp"
            var $idxprom=((($11))&255); //@line 65 "phonemelist.cpp"
            var $arrayidx9=((_phoneme_tab+$idxprom*4)&4294967295); //@line 65 "phonemelist.cpp"
            var $12=HEAP32[(($arrayidx9)>>2)]; //@line 65 "phonemelist.cpp"
            $next=$12; //@line 65 "phonemelist.cpp"
            ; //@line 65 "phonemelist.cpp"
          }
  
          $word_end=0; //@line 67 "phonemelist.cpp"
          var $13=$plist2; //@line 68 "phonemelist.cpp"
          var $add_ptr=(($13+8)&4294967295); //@line 68 "phonemelist.cpp"
          var $sourceix=(($add_ptr+6)&4294967295); //@line 68 "phonemelist.cpp"
          var $14=HEAP16[(($sourceix)>>1)]; //@line 68 "phonemelist.cpp"
          var $tobool=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt))!=0; //@line 68 "phonemelist.cpp"
          if ($tobool) { __label__ = 11;; } else { __label__ = 9;; } //@line 68 "phonemelist.cpp"
          $if_then14$$lor_lhs_false$14: do { 
            if (__label__ == 9) {
  
              var $15=$next; //@line 68 "phonemelist.cpp"
              var $cmp11=((($15))|0)!=0; //@line 68 "phonemelist.cpp"
              if (!($cmp11)) { __label__ = 12;break $if_then14$$lor_lhs_false$14; } //@line 68 "phonemelist.cpp"
  
              var $16=$next; //@line 68 "phonemelist.cpp"
              var $type=(($16+11)&4294967295); //@line 68 "phonemelist.cpp"
              var $17=HEAPU8[($type)]; //@line 68 "phonemelist.cpp"
              var $conv12=((($17))&255); //@line 68 "phonemelist.cpp"
              var $cmp13=((($conv12))|0)==0; //@line 68 "phonemelist.cpp"
              if ($cmp13) { __label__ = 11;break $if_then14$$lor_lhs_false$14; } else { __label__ = 12;break $if_then14$$lor_lhs_false$14; } //@line 68 "phonemelist.cpp"
            }
          } while(0);
          if (__label__ == 11) {
  
            $word_end=1; //@line 69 "phonemelist.cpp"
            ; //@line 69 "phonemelist.cpp"
          }
  
          $k=0; //@line 72 "phonemelist.cpp"
          ; //@line 72 "phonemelist.cpp"
          $for_cond16$20: while(1) { 
  
            var $18=$k; //@line 72 "phonemelist.cpp"
            var $19=HEAP32[((_n_replace_phonemes)>>2)]; //@line 72 "phonemelist.cpp"
            var $cmp17=((($18))|0) < ((($19))|0); //@line 72 "phonemelist.cpp"
            if (!($cmp17)) { __label__ = 23;break $for_cond16$20; } //@line 72 "phonemelist.cpp"
  
            var $20=$plist2; //@line 74 "phonemelist.cpp"
            var $phcode19=(($20)&4294967295); //@line 74 "phonemelist.cpp"
            var $21=HEAPU8[($phcode19)]; //@line 74 "phonemelist.cpp"
            var $conv20=((($21))&255); //@line 74 "phonemelist.cpp"
            var $22=$k; //@line 74 "phonemelist.cpp"
            var $arrayidx21=((_replace_phonemes+$22*3)&4294967295); //@line 74 "phonemelist.cpp"
            var $old_ph=(($arrayidx21)&4294967295); //@line 74 "phonemelist.cpp"
            var $23=HEAPU8[($old_ph)]; //@line 74 "phonemelist.cpp"
            var $conv22=((($23))&255); //@line 74 "phonemelist.cpp"
            var $cmp23=((($conv20))|0)==((($conv22))|0); //@line 74 "phonemelist.cpp"
            if ($cmp23) { __label__ = 15;; } else { __label__ = 22;; } //@line 74 "phonemelist.cpp"
            $if_then24$$for_inc$23: do { 
              if (__label__ == 15) {
  
                var $24=$k; //@line 76 "phonemelist.cpp"
                var $arrayidx25=((_replace_phonemes+$24*3)&4294967295); //@line 76 "phonemelist.cpp"
                var $type26=(($arrayidx25+2)&4294967295); //@line 76 "phonemelist.cpp"
                var $25=HEAP8[($type26)]; //@line 76 "phonemelist.cpp"
                var $conv27=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 76 "phonemelist.cpp"
                $replace_flags=$conv27; //@line 76 "phonemelist.cpp"
                var $26=$replace_flags; //@line 78 "phonemelist.cpp"
                var $and=($26) & 1; //@line 78 "phonemelist.cpp"
                var $tobool28=((($and))|0)!=0; //@line 78 "phonemelist.cpp"
                if ($tobool28) { __label__ = 16;; } else { __label__ = 17;; } //@line 78 "phonemelist.cpp"
                if (__label__ == 16) {
  
                  var $27=$word_end; //@line 78 "phonemelist.cpp"
                  var $cmp30=((($27))|0)==0; //@line 78 "phonemelist.cpp"
                  if ($cmp30) { __label__ = 22;break $if_then24$$for_inc$23; } //@line 78 "phonemelist.cpp"
                }
  
                var $28=$replace_flags; //@line 81 "phonemelist.cpp"
                var $and33=($28) & 2; //@line 81 "phonemelist.cpp"
                var $tobool34=((($and33))|0)!=0; //@line 81 "phonemelist.cpp"
                if (!($tobool34)) { __label__ = 19;break $for_cond16$20; } //@line 81 "phonemelist.cpp"
  
                var $29=$plist2; //@line 81 "phonemelist.cpp"
                var $stresslevel=(($29+1)&4294967295); //@line 81 "phonemelist.cpp"
                var $30=HEAPU8[($stresslevel)]; //@line 81 "phonemelist.cpp"
                var $conv36=((($30))&255); //@line 81 "phonemelist.cpp"
                var $and37=($conv36) & 7; //@line 81 "phonemelist.cpp"
                var $cmp38=((($and37))|0) > 3; //@line 81 "phonemelist.cpp"
                if (!($cmp38)) { __label__ = 19;break $for_cond16$20; } //@line 81 "phonemelist.cpp"
              }
            } while(0);
  
            var $41=$k; //@line 72 "phonemelist.cpp"
            var $inc=((($41)+1)&4294967295); //@line 72 "phonemelist.cpp"
            $k=$inc; //@line 72 "phonemelist.cpp"
            __label__ = 13;continue $for_cond16$20; //@line 72 "phonemelist.cpp"
          }
          $for_end$$if_end40$30: do { 
            if (__label__ == 19) {
  
              var $31=$k; //@line 85 "phonemelist.cpp"
              var $arrayidx41=((_replace_phonemes+$31*3)&4294967295); //@line 85 "phonemelist.cpp"
              var $new_ph=(($arrayidx41+1)&4294967295); //@line 85 "phonemelist.cpp"
              var $32=HEAP8[($new_ph)]; //@line 85 "phonemelist.cpp"
              var $33=$plist2; //@line 85 "phonemelist.cpp"
              var $phcode42=(($33)&4294967295); //@line 85 "phonemelist.cpp"
              HEAP8[($phcode42)]=$32; //@line 85 "phonemelist.cpp"
              var $34=$plist2; //@line 86 "phonemelist.cpp"
              var $stresslevel43=(($34+1)&4294967295); //@line 86 "phonemelist.cpp"
              var $35=HEAPU8[($stresslevel43)]; //@line 86 "phonemelist.cpp"
              var $conv44=((($35))&255); //@line 86 "phonemelist.cpp"
              var $cmp45=((($conv44))|0) > 1; //@line 86 "phonemelist.cpp"
              if (!($cmp45)) { __label__ = 23;break $for_end$$if_end40$30; } //@line 86 "phonemelist.cpp"
  
              var $36=$plist2; //@line 86 "phonemelist.cpp"
              var $phcode47=(($36)&4294967295); //@line 86 "phonemelist.cpp"
              var $37=HEAPU8[($phcode47)]; //@line 86 "phonemelist.cpp"
              var $idxprom48=((($37))&255); //@line 86 "phonemelist.cpp"
              var $arrayidx49=((_phoneme_tab+$idxprom48*4)&4294967295); //@line 86 "phonemelist.cpp"
              var $38=HEAP32[(($arrayidx49)>>2)]; //@line 86 "phonemelist.cpp"
              var $phflags=(($38+4)&4294967295); //@line 86 "phonemelist.cpp"
              var $39=HEAP32[(($phflags)>>2)]; //@line 86 "phonemelist.cpp"
              var $and50=($39) & 2; //@line 86 "phonemelist.cpp"
              var $tobool51=((($and50))|0)!=0; //@line 86 "phonemelist.cpp"
              if (!($tobool51)) { __label__ = 23;break $for_end$$if_end40$30; } //@line 86 "phonemelist.cpp"
  
              var $40=$plist2; //@line 87 "phonemelist.cpp"
              var $stresslevel53=(($40+1)&4294967295); //@line 87 "phonemelist.cpp"
              HEAP8[($stresslevel53)]=0; //@line 87 "phonemelist.cpp"
              ; //@line 87 "phonemelist.cpp"
            }
          } while(0);
  
          var $42=$plist2; //@line 92 "phonemelist.cpp"
          var $phcode56=(($42)&4294967295); //@line 92 "phonemelist.cpp"
          var $43=HEAPU8[($phcode56)]; //@line 92 "phonemelist.cpp"
          var $conv57=((($43))&255); //@line 92 "phonemelist.cpp"
          var $cmp58=((($conv57))|0)==0; //@line 92 "phonemelist.cpp"
          if ($cmp58) { __label__ = 25;break $if_then4$$if_end61$9; } else { __label__ = 24;break $if_then4$$if_end61$9; } //@line 92 "phonemelist.cpp"
        }
      } while(0);
      if (__label__ == 24) {
  
        var $44=$n_plist_out; //@line 99 "phonemelist.cpp"
        var $45=$plist_out_addr; //@line 99 "phonemelist.cpp"
        var $arrayidx62=(($45+24*$44)&4294967295); //@line 99 "phonemelist.cpp"
        var $46=$arrayidx62; //@line 99 "phonemelist.cpp"
        var $47=$plist2; //@line 99 "phonemelist.cpp"
        var $48=$47; //@line 99 "phonemelist.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $48;
        $dest$ = $46;
        $stop$ = $src$ + 8;
        if (($dest$%4) == ($src$%4) && 8 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 99 "phonemelist.cpp"
        var $49=$plist2; //@line 100 "phonemelist.cpp"
        var $phcode63=(($49)&4294967295); //@line 100 "phonemelist.cpp"
        var $50=HEAPU8[($phcode63)]; //@line 100 "phonemelist.cpp"
        var $idxprom64=((($50))&255); //@line 100 "phonemelist.cpp"
        var $arrayidx65=((_phoneme_tab+$idxprom64*4)&4294967295); //@line 100 "phonemelist.cpp"
        var $51=HEAP32[(($arrayidx65)>>2)]; //@line 100 "phonemelist.cpp"
        var $52=$n_plist_out; //@line 100 "phonemelist.cpp"
        var $53=$plist_out_addr; //@line 100 "phonemelist.cpp"
        var $arrayidx66=(($53+24*$52)&4294967295); //@line 100 "phonemelist.cpp"
        var $ph=(($arrayidx66+8)&4294967295); //@line 100 "phonemelist.cpp"
        HEAP32[(($ph)>>2)]=$51; //@line 100 "phonemelist.cpp"
        var $54=$n_plist_out; //@line 101 "phonemelist.cpp"
        var $55=$plist_out_addr; //@line 101 "phonemelist.cpp"
        var $arrayidx67=(($55+24*$54)&4294967295); //@line 101 "phonemelist.cpp"
        var $ph68=(($arrayidx67+8)&4294967295); //@line 101 "phonemelist.cpp"
        var $56=HEAP32[(($ph68)>>2)]; //@line 101 "phonemelist.cpp"
        var $type69=(($56+11)&4294967295); //@line 101 "phonemelist.cpp"
        var $57=HEAP8[($type69)]; //@line 101 "phonemelist.cpp"
        var $58=$n_plist_out; //@line 101 "phonemelist.cpp"
        var $59=$plist_out_addr; //@line 101 "phonemelist.cpp"
        var $arrayidx70=(($59+24*$58)&4294967295); //@line 101 "phonemelist.cpp"
        var $type71=(($arrayidx70+15)&4294967295); //@line 101 "phonemelist.cpp"
        HEAP8[($type71)]=$57; //@line 101 "phonemelist.cpp"
        var $60=$n_plist_out; //@line 102 "phonemelist.cpp"
        var $inc72=((($60)+1)&4294967295); //@line 102 "phonemelist.cpp"
        $n_plist_out=$inc72; //@line 102 "phonemelist.cpp"
        ; //@line 103 "phonemelist.cpp"
      }
  
      var $61=$ix; //@line 54 "phonemelist.cpp"
      var $inc74=((($61)+1)&4294967295); //@line 54 "phonemelist.cpp"
      $ix=$inc74; //@line 54 "phonemelist.cpp"
      __label__ = 1;continue $for_cond$2; //@line 54 "phonemelist.cpp"
    }
  
    var $62=$n_plist_out; //@line 104 "phonemelist.cpp"
    ;
    return $62; //@line 104 "phonemelist.cpp"
    return null;
  }
  

  function __Z10KlattReseti($control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $control_addr;
    var $r_ix;
    $control_addr=$control;
    var $0=$control_addr; //@line 499 "klatt.cpp"
    var $cmp=((($0))|0)==2; //@line 499 "klatt.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 1;; } else { __lastLabel__ = 0; __label__ = 2;; } //@line 499 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 502 "klatt.cpp"
      var $mul=((($1)*950)&4294967295); //@line 502 "klatt.cpp"
      var $div=((((($mul))|0)/10000)|0); //@line 502 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+12)&4294967295))>>2)]=$div; //@line 502 "klatt.cpp"
      var $2=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 503 "klatt.cpp"
      var $mul1=((($2)*630)&4294967295); //@line 503 "klatt.cpp"
      var $div2=((((($mul1))|0)/10000)|0); //@line 503 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+16)&4294967295))>>2)]=$div2; //@line 503 "klatt.cpp"
      var $3=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 504 "klatt.cpp"
      var $conv=((($3))|0); //@line 504 "klatt.cpp"
      var $div3=-3.1415927/($conv); //@line 504 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]=$div3; //@line 504 "klatt.cpp"
      var $4=HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]; //@line 505 "klatt.cpp"
      var $mul4=-2*($4); //@line 505 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+80)&4294967295))>>2)]=$mul4; //@line 505 "klatt.cpp"
      var $5=HEAP32[((((__ZL10kt_globals+12)&4294967295))>>2)]; //@line 506 "klatt.cpp"
      var $6=HEAP32[((((__ZL10kt_globals+16)&4294967295))>>2)]; //@line 506 "klatt.cpp"
      __ZL6setabcllP11resonator_t($5, $6, ((__ZL10kt_globals+188+1152)&4294967295)); //@line 506 "klatt.cpp"
      var $_pr=$control_addr; //@line 510 "klatt.cpp"
      __lastLabel__ = 1; ; //@line 508 "klatt.cpp"
    }
  
    var $7=__lastLabel__ == 1 ? $_pr : ($0); //@line 510 "klatt.cpp"
    var $cmp5=((($7))|0) > 0; //@line 510 "klatt.cpp"
    if ($cmp5) { __label__ = 3;; } else { __label__ = 5;; } //@line 510 "klatt.cpp"
    $if_then6$$if_end9$5: do { 
      if (__label__ == 3) {
  
        HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]=0; //@line 512 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=0; //@line 513 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=0; //@line 514 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=0; //@line 515 "klatt.cpp"
        $r_ix=17; //@line 517 "klatt.cpp"
        ; //@line 517 "klatt.cpp"
        while(1) { 
  
          var $8=$r_ix; //@line 519 "klatt.cpp"
          var $arrayidx=((((__ZL10kt_globals+188)&4294967295)+$8*64)&4294967295); //@line 519 "klatt.cpp"
          var $p1=(($arrayidx+24)&4294967295); //@line 519 "klatt.cpp"
          HEAPF32[(($p1)>>2)]=0; //@line 519 "klatt.cpp"
          var $9=$r_ix; //@line 520 "klatt.cpp"
          var $arrayidx8=((((__ZL10kt_globals+188)&4294967295)+$9*64)&4294967295); //@line 520 "klatt.cpp"
          var $p2=(($arrayidx8+32)&4294967295); //@line 520 "klatt.cpp"
          HEAPF32[(($p2)>>2)]=0; //@line 520 "klatt.cpp"
          var $10=$r_ix; //@line 517 "klatt.cpp"
          var $inc=((($10)+1)&4294967295); //@line 517 "klatt.cpp"
          $r_ix=$inc; //@line 517 "klatt.cpp"
          var $cmp7=((($inc))|0) < 20; //@line 517 "klatt.cpp"
          if ($cmp7) { __label__ = 4;continue ; } else { __label__ = 5;break $if_then6$$if_end9$5; } //@line 517 "klatt.cpp"
        }
      }
    } while(0);
  
    $r_ix=0; //@line 525 "klatt.cpp"
    ; //@line 525 "klatt.cpp"
    while(1) { 
  
      var $11=$r_ix; //@line 527 "klatt.cpp"
      var $arrayidx13=((((__ZL10kt_globals+188)&4294967295)+$11*64)&4294967295); //@line 527 "klatt.cpp"
      var $p114=(($arrayidx13+24)&4294967295); //@line 527 "klatt.cpp"
      HEAPF32[(($p114)>>2)]=0; //@line 527 "klatt.cpp"
      var $12=$r_ix; //@line 528 "klatt.cpp"
      var $arrayidx15=((((__ZL10kt_globals+188)&4294967295)+$12*64)&4294967295); //@line 528 "klatt.cpp"
      var $p216=(($arrayidx15+32)&4294967295); //@line 528 "klatt.cpp"
      HEAPF32[(($p216)>>2)]=0; //@line 528 "klatt.cpp"
      var $13=$r_ix; //@line 525 "klatt.cpp"
      var $inc18=((($13)+1)&4294967295); //@line 525 "klatt.cpp"
      $r_ix=$inc18; //@line 525 "klatt.cpp"
      var $cmp11=((($inc18))|0) <= 16; //@line 525 "klatt.cpp"
      if ($cmp11) { __label__ = 6;continue ; } else { __label__ = 7;break ; } //@line 525 "klatt.cpp"
    }
  
    ;
    return; //@line 530 "klatt.cpp"
    return;
  }
  

  function __ZL6setabcllP11resonator_t($f, $bw, $rp) {
    ;
    var __label__;
  
    var $f_addr;
    var $bw_addr;
    var $rp_addr;
    var $r;
    var $arg;
    $f_addr=$f;
    $bw_addr=$bw;
    $rp_addr=$rp;
    var $0=HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]; //@line 858 "klatt.cpp"
    var $1=$bw_addr; //@line 858 "klatt.cpp"
    var $conv=((($1))|0); //@line 858 "klatt.cpp"
    var $mul=($0)*($conv); //@line 858 "klatt.cpp"
    $arg=$mul; //@line 858 "klatt.cpp"
    var $2=$arg; //@line 859 "klatt.cpp"
    var $call=_exp($2); //@line 859 "klatt.cpp"
    $r=$call; //@line 859 "klatt.cpp"
    var $3=$r; //@line 862 "klatt.cpp"
    var $4=$r; //@line 862 "klatt.cpp"
    var $mul1=($3)*($4); //@line 862 "klatt.cpp"
    var $sub=(-($mul1)); //@line 862 "klatt.cpp"
    var $5=$rp_addr; //@line 862 "klatt.cpp"
    var $c=(($5+16)&4294967295); //@line 862 "klatt.cpp"
    HEAPF32[(($c)>>2)]=$sub; //@line 862 "klatt.cpp"
    var $6=HEAPF32[((((__ZL10kt_globals+80)&4294967295))>>2)]; //@line 865 "klatt.cpp"
    var $7=$f_addr; //@line 865 "klatt.cpp"
    var $conv2=((($7))|0); //@line 865 "klatt.cpp"
    var $mul3=($6)*($conv2); //@line 865 "klatt.cpp"
    $arg=$mul3; //@line 865 "klatt.cpp"
    var $8=$r; //@line 866 "klatt.cpp"
    var $9=$arg; //@line 866 "klatt.cpp"
    var $call4=_cos($9); //@line 866 "klatt.cpp"
    var $mul5=($8)*($call4); //@line 866 "klatt.cpp"
    var $mul6=($mul5)*2; //@line 866 "klatt.cpp"
    var $10=$rp_addr; //@line 866 "klatt.cpp"
    var $b=(($10+8)&4294967295); //@line 866 "klatt.cpp"
    HEAPF32[(($b)>>2)]=$mul6; //@line 866 "klatt.cpp"
    var $11=$rp_addr; //@line 869 "klatt.cpp"
    var $b7=(($11+8)&4294967295); //@line 869 "klatt.cpp"
    var $12=HEAPF32[(($b7)>>2)]; //@line 869 "klatt.cpp"
    var $sub8=1-($12); //@line 869 "klatt.cpp"
    var $13=$rp_addr; //@line 869 "klatt.cpp"
    var $c9=(($13+16)&4294967295); //@line 869 "klatt.cpp"
    var $14=HEAPF32[(($c9)>>2)]; //@line 869 "klatt.cpp"
    var $sub10=($sub8)-($14); //@line 869 "klatt.cpp"
    var $15=$rp_addr; //@line 869 "klatt.cpp"
    var $a=(($15)&4294967295); //@line 869 "klatt.cpp"
    HEAPF32[(($a)>>2)]=$sub10; //@line 869 "klatt.cpp"
    ;
    return; //@line 870 "klatt.cpp"
    return;
  }
  

  function __Z13Wavegen_Klatti($resume) {
    ;
    var __label__;
  
    var $retval;
    var $resume_addr;
    var $pk;
    var $x;
    var $ix;
    var $fade;
    $resume_addr=$resume;
    var $0=$resume_addr; //@line 1001 "klatt.cpp"
    var $cmp=((($0))|0)==0; //@line 1001 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1001 "klatt.cpp"
    if (__label__ == 1) {
  
      HEAP32[((__ZL12sample_count)>>2)]=0; //@line 1003 "klatt.cpp"
      ; //@line 1004 "klatt.cpp"
    }
    $while_cond$4: while(1) { 
  
      var $1=HEAP32[((__ZL12sample_count)>>2)]; //@line 1006 "klatt.cpp"
      var $2=HEAP32[((__ZL8nsamples802)>>2)]; //@line 1006 "klatt.cpp"
      var $cmp1=((($1))|0) < ((($2))|0); //@line 1006 "klatt.cpp"
      if (!($cmp1)) { __label__ = 23;break $while_cond$4; } //@line 1006 "klatt.cpp"
  
      var $3=HEAP32[((((_wdata+4)&4294967295))>>2)]; //@line 1008 "klatt.cpp"
      var $mul=((($3)*10)&4294967295); //@line 1008 "klatt.cpp"
      var $div=((((($mul))|0)/4096)|0); //@line 1008 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame)&4294967295))>>2)]=$div; //@line 1008 "klatt.cpp"
      $ix=0; //@line 1013 "klatt.cpp"
      ; //@line 1013 "klatt.cpp"
      $for_body$7: while(1) { 
  
        var $4=$ix; //@line 1015 "klatt.cpp"
        var $arrayidx=((__ZL5peaks801+$4*80)&4294967295); //@line 1015 "klatt.cpp"
        var $freq=(($arrayidx)&4294967295); //@line 1015 "klatt.cpp"
        var $5=HEAP32[(($freq)>>2)]; //@line 1015 "klatt.cpp"
        var $6=$ix; //@line 1015 "klatt.cpp"
        var $arrayidx3=((((__ZL8kt_frame+8)&4294967295)+$6*4)&4294967295); //@line 1015 "klatt.cpp"
        HEAP32[(($arrayidx3)>>2)]=$5; //@line 1015 "klatt.cpp"
        var $7=$ix; //@line 1016 "klatt.cpp"
        var $cmp4=((($7))|0) < 4; //@line 1016 "klatt.cpp"
        if ($cmp4) { __label__ = 5;; } else { __label__ = 6;; } //@line 1016 "klatt.cpp"
        if (__label__ == 5) {
  
          var $8=$ix; //@line 1018 "klatt.cpp"
          var $arrayidx6=((__ZL5peaks801+$8*80)&4294967295); //@line 1018 "klatt.cpp"
          var $bw=(($arrayidx6+4)&4294967295); //@line 1018 "klatt.cpp"
          var $9=HEAP32[(($bw)>>2)]; //@line 1018 "klatt.cpp"
          var $10=$ix; //@line 1018 "klatt.cpp"
          var $arrayidx7=((((__ZL8kt_frame+48)&4294967295)+$10*4)&4294967295); //@line 1018 "klatt.cpp"
          HEAP32[(($arrayidx7)>>2)]=$9; //@line 1018 "klatt.cpp"
          ; //@line 1019 "klatt.cpp"
        }
  
        var $11=$ix; //@line 1013 "klatt.cpp"
        var $inc=((($11)+1)&4294967295); //@line 1013 "klatt.cpp"
        $ix=$inc; //@line 1013 "klatt.cpp"
        var $cmp2=((($inc))|0) < 6; //@line 1013 "klatt.cpp"
        if ($cmp2) { __label__ = 4;continue $for_body$7; } else { __label__ = 7;break $for_body$7; } //@line 1013 "klatt.cpp"
      }
  
      $ix=1; //@line 1021 "klatt.cpp"
      ; //@line 1021 "klatt.cpp"
      $for_body11$13: while(1) { 
  
        var $12=$ix; //@line 1023 "klatt.cpp"
        var $arrayidx12=((((__ZL8kt_frame+88)&4294967295)+$12*4)&4294967295); //@line 1023 "klatt.cpp"
        HEAP32[(($arrayidx12)>>2)]=0; //@line 1023 "klatt.cpp"
        var $13=$ix; //@line 1021 "klatt.cpp"
        var $inc14=((($13)+1)&4294967295); //@line 1021 "klatt.cpp"
        $ix=$inc14; //@line 1021 "klatt.cpp"
        var $cmp10=((($inc14))|0) < 7; //@line 1021 "klatt.cpp"
        if ($cmp10) { __label__ = 8;continue $for_body11$13; } else { __label__ = 9;break $for_body11$13; } //@line 1021 "klatt.cpp"
      }
  
      var $14=HEAP32[((((__ZL6klattp)&4294967295))>>2)]; //@line 1026 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+4)&4294967295))>>2)]=$14; //@line 1026 "klatt.cpp"
      var $15=HEAP32[((((__ZL6klattp+24)&4294967295))>>2)]; //@line 1027 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+196)&4294967295))>>2)]=$15; //@line 1027 "klatt.cpp"
      var $16=HEAP32[((((__ZL6klattp+28)&4294967295))>>2)]; //@line 1028 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+184)&4294967295))>>2)]=$16; //@line 1028 "klatt.cpp"
      var $17=HEAP32[((((__ZL6klattp+32)&4294967295))>>2)]; //@line 1029 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+192)&4294967295))>>2)]=$17; //@line 1029 "klatt.cpp"
      var $18=HEAP32[((((__ZL6klattp+12)&4294967295))>>2)]; //@line 1030 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+168)&4294967295))>>2)]=$18; //@line 1030 "klatt.cpp"
      var $19=HEAP32[((((__ZL6klattp+36)&4294967295))>>2)]; //@line 1031 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+176)&4294967295))>>2)]=$19; //@line 1031 "klatt.cpp"
      var $20=HEAP32[((((__ZL6klattp+16)&4294967295))>>2)]; //@line 1032 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+188)&4294967295))>>2)]=$20; //@line 1032 "klatt.cpp"
      var $21=HEAP32[((((__ZL6klattp+8)&4294967295))>>2)]; //@line 1033 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+180)&4294967295))>>2)]=$21; //@line 1033 "klatt.cpp"
      var $22=HEAP32[((((__ZL6klattp+20)&4294967295))>>2)]; //@line 1034 "klatt.cpp"
      HEAP32[((((__ZL8kt_frame+172)&4294967295))>>2)]=$22; //@line 1034 "klatt.cpp"
      $pk=0; //@line 1037 "klatt.cpp"
      ; //@line 1037 "klatt.cpp"
      $for_body18$16: while(1) { 
  
        var $23=$pk; //@line 1039 "klatt.cpp"
        var $arrayidx19=((__ZL5peaks801+$23*80)&4294967295); //@line 1039 "klatt.cpp"
        var $freq_inc=(($arrayidx19+48)&4294967295); //@line 1039 "klatt.cpp"
        var $24=HEAPF32[(($freq_inc)>>2)]; //@line 1039 "klatt.cpp"
        var $25=$pk; //@line 1039 "klatt.cpp"
        var $arrayidx20=((__ZL5peaks801+$25*80)&4294967295); //@line 1039 "klatt.cpp"
        var $freq1=(($arrayidx20+16)&4294967295); //@line 1039 "klatt.cpp"
        var $26=HEAPF32[(($freq1)>>2)]; //@line 1039 "klatt.cpp"
        var $add=($26)+($24); //@line 1039 "klatt.cpp"
        HEAPF32[(($freq1)>>2)]=$add; //@line 1039 "klatt.cpp"
        var $27=$pk; //@line 1040 "klatt.cpp"
        var $arrayidx21=((__ZL5peaks801+$27*80)&4294967295); //@line 1040 "klatt.cpp"
        var $freq122=(($arrayidx21+16)&4294967295); //@line 1040 "klatt.cpp"
        var $28=HEAPF32[(($freq122)>>2)]; //@line 1040 "klatt.cpp"
        var $conv=((($28))|0); //@line 1040 "klatt.cpp"
        var $29=$pk; //@line 1040 "klatt.cpp"
        var $arrayidx23=((__ZL5peaks801+$29*80)&4294967295); //@line 1040 "klatt.cpp"
        var $freq24=(($arrayidx23)&4294967295); //@line 1040 "klatt.cpp"
        HEAP32[(($freq24)>>2)]=$conv; //@line 1040 "klatt.cpp"
        var $30=$pk; //@line 1041 "klatt.cpp"
        var $arrayidx25=((__ZL5peaks801+$30*80)&4294967295); //@line 1041 "klatt.cpp"
        var $bw_inc=(($arrayidx25+56)&4294967295); //@line 1041 "klatt.cpp"
        var $31=HEAPF32[(($bw_inc)>>2)]; //@line 1041 "klatt.cpp"
        var $32=$pk; //@line 1041 "klatt.cpp"
        var $arrayidx26=((__ZL5peaks801+$32*80)&4294967295); //@line 1041 "klatt.cpp"
        var $bw1=(($arrayidx26+24)&4294967295); //@line 1041 "klatt.cpp"
        var $33=HEAPF32[(($bw1)>>2)]; //@line 1041 "klatt.cpp"
        var $add27=($33)+($31); //@line 1041 "klatt.cpp"
        HEAPF32[(($bw1)>>2)]=$add27; //@line 1041 "klatt.cpp"
        var $34=$pk; //@line 1042 "klatt.cpp"
        var $arrayidx28=((__ZL5peaks801+$34*80)&4294967295); //@line 1042 "klatt.cpp"
        var $bw129=(($arrayidx28+24)&4294967295); //@line 1042 "klatt.cpp"
        var $35=HEAPF32[(($bw129)>>2)]; //@line 1042 "klatt.cpp"
        var $conv30=((($35))|0); //@line 1042 "klatt.cpp"
        var $36=$pk; //@line 1042 "klatt.cpp"
        var $arrayidx31=((__ZL5peaks801+$36*80)&4294967295); //@line 1042 "klatt.cpp"
        var $bw32=(($arrayidx31+4)&4294967295); //@line 1042 "klatt.cpp"
        HEAP32[(($bw32)>>2)]=$conv30; //@line 1042 "klatt.cpp"
        var $37=$pk; //@line 1043 "klatt.cpp"
        var $arrayidx33=((__ZL5peaks801+$37*80)&4294967295); //@line 1043 "klatt.cpp"
        var $bp_inc=(($arrayidx33+72)&4294967295); //@line 1043 "klatt.cpp"
        var $38=HEAPF32[(($bp_inc)>>2)]; //@line 1043 "klatt.cpp"
        var $39=$pk; //@line 1043 "klatt.cpp"
        var $arrayidx34=((__ZL5peaks801+$39*80)&4294967295); //@line 1043 "klatt.cpp"
        var $bp1=(($arrayidx34+40)&4294967295); //@line 1043 "klatt.cpp"
        var $40=HEAPF32[(($bp1)>>2)]; //@line 1043 "klatt.cpp"
        var $add35=($40)+($38); //@line 1043 "klatt.cpp"
        HEAPF32[(($bp1)>>2)]=$add35; //@line 1043 "klatt.cpp"
        var $41=$pk; //@line 1044 "klatt.cpp"
        var $arrayidx36=((__ZL5peaks801+$41*80)&4294967295); //@line 1044 "klatt.cpp"
        var $bp137=(($arrayidx36+40)&4294967295); //@line 1044 "klatt.cpp"
        var $42=HEAPF32[(($bp137)>>2)]; //@line 1044 "klatt.cpp"
        var $conv38=((($42))|0); //@line 1044 "klatt.cpp"
        var $43=$pk; //@line 1044 "klatt.cpp"
        var $arrayidx39=((__ZL5peaks801+$43*80)&4294967295); //@line 1044 "klatt.cpp"
        var $bp=(($arrayidx39+12)&4294967295); //@line 1044 "klatt.cpp"
        HEAP32[(($bp)>>2)]=$conv38; //@line 1044 "klatt.cpp"
        var $44=$pk; //@line 1045 "klatt.cpp"
        var $arrayidx40=((__ZL5peaks801+$44*80)&4294967295); //@line 1045 "klatt.cpp"
        var $ap_inc=(($arrayidx40+64)&4294967295); //@line 1045 "klatt.cpp"
        var $45=HEAPF32[(($ap_inc)>>2)]; //@line 1045 "klatt.cpp"
        var $46=$pk; //@line 1045 "klatt.cpp"
        var $arrayidx41=((__ZL5peaks801+$46*80)&4294967295); //@line 1045 "klatt.cpp"
        var $ap1=(($arrayidx41+32)&4294967295); //@line 1045 "klatt.cpp"
        var $47=HEAPF32[(($ap1)>>2)]; //@line 1045 "klatt.cpp"
        var $add42=($47)+($45); //@line 1045 "klatt.cpp"
        HEAPF32[(($ap1)>>2)]=$add42; //@line 1045 "klatt.cpp"
        var $48=$pk; //@line 1046 "klatt.cpp"
        var $arrayidx43=((__ZL5peaks801+$48*80)&4294967295); //@line 1046 "klatt.cpp"
        var $ap144=(($arrayidx43+32)&4294967295); //@line 1046 "klatt.cpp"
        var $49=HEAPF32[(($ap144)>>2)]; //@line 1046 "klatt.cpp"
        var $conv45=((($49))|0); //@line 1046 "klatt.cpp"
        var $50=$pk; //@line 1046 "klatt.cpp"
        var $arrayidx46=((__ZL5peaks801+$50*80)&4294967295); //@line 1046 "klatt.cpp"
        var $ap=(($arrayidx46+8)&4294967295); //@line 1046 "klatt.cpp"
        HEAP32[(($ap)>>2)]=$conv45; //@line 1046 "klatt.cpp"
        var $51=$pk; //@line 1037 "klatt.cpp"
        var $inc48=((($51)+1)&4294967295); //@line 1037 "klatt.cpp"
        $pk=$inc48; //@line 1037 "klatt.cpp"
        var $cmp17=((($inc48))|0) < 9; //@line 1037 "klatt.cpp"
        if ($cmp17) { __label__ = 10;continue $for_body18$16; } else { __label__ = 11;break $for_body18$16; } //@line 1037 "klatt.cpp"
      }
  
      $ix=0; //@line 1050 "klatt.cpp"
      ; //@line 1050 "klatt.cpp"
      $for_body52$19: while(1) { 
  
        var $52=$ix; //@line 1052 "klatt.cpp"
        var $arrayidx53=((__ZL10klattp_inc+$52*8)&4294967295); //@line 1052 "klatt.cpp"
        var $53=HEAPF32[(($arrayidx53)>>2)]; //@line 1052 "klatt.cpp"
        var $54=$ix; //@line 1052 "klatt.cpp"
        var $arrayidx54=((__ZL7klattp1+$54*8)&4294967295); //@line 1052 "klatt.cpp"
        var $55=HEAPF32[(($arrayidx54)>>2)]; //@line 1052 "klatt.cpp"
        var $add55=($55)+($53); //@line 1052 "klatt.cpp"
        HEAPF32[(($arrayidx54)>>2)]=$add55; //@line 1052 "klatt.cpp"
        var $56=$ix; //@line 1053 "klatt.cpp"
        var $arrayidx56=((__ZL7klattp1+$56*8)&4294967295); //@line 1053 "klatt.cpp"
        var $57=HEAPF32[(($arrayidx56)>>2)]; //@line 1053 "klatt.cpp"
        var $conv57=((($57))|0); //@line 1053 "klatt.cpp"
        var $58=$ix; //@line 1053 "klatt.cpp"
        var $arrayidx58=((__ZL6klattp+$58*4)&4294967295); //@line 1053 "klatt.cpp"
        HEAP32[(($arrayidx58)>>2)]=$conv57; //@line 1053 "klatt.cpp"
        var $59=$ix; //@line 1050 "klatt.cpp"
        var $inc60=((($59)+1)&4294967295); //@line 1050 "klatt.cpp"
        $ix=$inc60; //@line 1050 "klatt.cpp"
        var $cmp51=((($inc60))|0) < 10; //@line 1050 "klatt.cpp"
        if ($cmp51) { __label__ = 12;continue $for_body52$19; } else { __label__ = 13;break $for_body52$19; } //@line 1050 "klatt.cpp"
      }
  
      $ix=0; //@line 1056 "klatt.cpp"
      ; //@line 1056 "klatt.cpp"
      while(1) { 
  
        var $60=$ix; //@line 1058 "klatt.cpp"
        var $arrayidx65=((__ZL5peaks801+$60*80)&4294967295); //@line 1058 "klatt.cpp"
        var $freq66=(($arrayidx65)&4294967295); //@line 1058 "klatt.cpp"
        var $61=HEAP32[(($freq66)>>2)]; //@line 1058 "klatt.cpp"
        var $62=$ix; //@line 1058 "klatt.cpp"
        var $arrayidx67=((((__ZL8kt_frame+208)&4294967295)+$62*4)&4294967295); //@line 1058 "klatt.cpp"
        HEAP32[(($arrayidx67)>>2)]=$61; //@line 1058 "klatt.cpp"
        var $63=$ix; //@line 1059 "klatt.cpp"
        var $cmp68=((($63))|0) < 4; //@line 1059 "klatt.cpp"
        if ($cmp68) { __label__ = 15;; } else { __label__ = 16;; } //@line 1059 "klatt.cpp"
        if (__label__ == 15) {
  
          var $64=$ix; //@line 1061 "klatt.cpp"
          var $arrayidx70=((__ZL5peaks801+$64*80)&4294967295); //@line 1061 "klatt.cpp"
          var $bw71=(($arrayidx70+4)&4294967295); //@line 1061 "klatt.cpp"
          var $65=HEAP32[(($bw71)>>2)]; //@line 1061 "klatt.cpp"
          var $66=$ix; //@line 1061 "klatt.cpp"
          var $arrayidx72=((((__ZL8kt_frame+248)&4294967295)+$66*4)&4294967295); //@line 1061 "klatt.cpp"
          HEAP32[(($arrayidx72)>>2)]=$65; //@line 1061 "klatt.cpp"
          ; //@line 1062 "klatt.cpp"
        }
  
        var $67=$ix; //@line 1056 "klatt.cpp"
        var $inc75=((($67)+1)&4294967295); //@line 1056 "klatt.cpp"
        $ix=$inc75; //@line 1056 "klatt.cpp"
        var $cmp63=((($inc75))|0) <= 6; //@line 1056 "klatt.cpp"
        if ($cmp63) { __label__ = 14;continue ; } else { __label__ = 17;break ; } //@line 1056 "klatt.cpp"
      }
  
      var $68=HEAP32[((((_wdata+12)&4294967295))>>2)]; //@line 1066 "klatt.cpp"
      var $69=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 1066 "klatt.cpp"
      var $add77=((($69)+($68))&4294967295); //@line 1066 "klatt.cpp"
      HEAP32[((((_wdata+8)&4294967295))>>2)]=$add77; //@line 1066 "klatt.cpp"
      var $70=HEAP32[((((_wdata+8)&4294967295))>>2)]; //@line 1067 "klatt.cpp"
      var $shr=($70) >> 8; //@line 1067 "klatt.cpp"
      $ix=$shr; //@line 1067 "klatt.cpp"
      var $cmp78=((($shr))|0) > 127; //@line 1067 "klatt.cpp"
      if ($cmp78) { __label__ = 18;; } else { __label__ = 19;; } //@line 1067 "klatt.cpp"
      if (__label__ == 18) {
  
        $ix=127; //@line 1067 "klatt.cpp"
        ; //@line 1067 "klatt.cpp"
      }
  
      var $71=$ix; //@line 1068 "klatt.cpp"
      var $72=HEAP32[((((_wdata)&4294967295))>>2)]; //@line 1068 "klatt.cpp"
      var $arrayidx81=(($72+$71)&4294967295); //@line 1068 "klatt.cpp"
      var $73=HEAPU8[($arrayidx81)]; //@line 1068 "klatt.cpp"
      var $conv82=((($73))&255); //@line 1068 "klatt.cpp"
      var $74=HEAP32[((((_wdata+20)&4294967295))>>2)]; //@line 1068 "klatt.cpp"
      var $mul83=((($conv82)*($74))&4294967295); //@line 1068 "klatt.cpp"
      $x=$mul83; //@line 1068 "klatt.cpp"
      var $75=$x; //@line 1069 "klatt.cpp"
      var $shr84=($75) >> 8; //@line 1069 "klatt.cpp"
      var $76=HEAP32[((((_wdata+16)&4294967295))>>2)]; //@line 1069 "klatt.cpp"
      var $add85=((($shr84)+($76))&4294967295); //@line 1069 "klatt.cpp"
      HEAP32[((((_wdata+4)&4294967295))>>2)]=$add85; //@line 1069 "klatt.cpp"
      var $77=HEAP32[((__ZL8nsamples802)>>2)]; //@line 1071 "klatt.cpp"
      var $78=HEAP32[((__ZL12sample_count)>>2)]; //@line 1071 "klatt.cpp"
      var $sub=((($77)-($78))&4294967295); //@line 1071 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=$sub; //@line 1071 "klatt.cpp"
      var $cmp86=((($sub))|0) > 64; //@line 1072 "klatt.cpp"
      if ($cmp86) { __label__ = 20;; } else { __label__ = 21;; } //@line 1072 "klatt.cpp"
      if (__label__ == 20) {
  
        HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=64; //@line 1073 "klatt.cpp"
        ; //@line 1073 "klatt.cpp"
      }
  
      __ZL10frame_initP13klatt_frame_t(); //@line 1075 "klatt.cpp"
      var $call=__ZL7parwaveP13klatt_frame_t(); //@line 1077 "klatt.cpp"
      var $cmp89=((($call))|0)==1; //@line 1077 "klatt.cpp"
      if ($cmp89) { __label__ = 22;break $while_cond$4; } else { __label__ = 2;continue $while_cond$4; } //@line 1077 "klatt.cpp"
    }
    $while_end$$if_then90$34: do { 
      if (__label__ == 23) {
  
        var $79=HEAP32[((__ZL8end_wave803)>>2)]; //@line 1083 "klatt.cpp"
        var $cmp92=((($79))|0) > 0; //@line 1083 "klatt.cpp"
        if ($cmp92) { __label__ = 24;; } else { __label__ = 26;; } //@line 1083 "klatt.cpp"
        $if_then93$$if_end99$36: do { 
          if (__label__ == 24) {
  
            $fade=64; //@line 1095 "klatt.cpp"
            var $80=$fade; //@line 1099 "klatt.cpp"
            HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]=$80; //@line 1099 "klatt.cpp"
            HEAP32[((__ZL8end_wave803)>>2)]=0; //@line 1100 "klatt.cpp"
            var $81=$fade; //@line 1101 "klatt.cpp"
            var $82=HEAP32[((__ZL12sample_count)>>2)]; //@line 1101 "klatt.cpp"
            var $sub94=((($82)-($81))&4294967295); //@line 1101 "klatt.cpp"
            HEAP32[((__ZL12sample_count)>>2)]=$sub94; //@line 1101 "klatt.cpp"
            var $83=$fade; //@line 1102 "klatt.cpp"
            HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=$83; //@line 1102 "klatt.cpp"
            var $call95=__ZL7parwaveP13klatt_frame_t(); //@line 1103 "klatt.cpp"
            var $cmp96=((($call95))|0)==1; //@line 1103 "klatt.cpp"
            if (!($cmp96)) { __label__ = 26;break $if_then93$$if_end99$36; } //@line 1103 "klatt.cpp"
  
            $retval=1; //@line 1105 "klatt.cpp"
            __label__ = 27;break $while_end$$if_then90$34; //@line 1105 "klatt.cpp"
          }
        } while(0);
  
        $retval=0; //@line 1109 "klatt.cpp"
        ; //@line 1109 "klatt.cpp"
      }
      else if (__label__ == 22) {
  
        $retval=1; //@line 1079 "klatt.cpp"
        ; //@line 1079 "klatt.cpp"
      }
    } while(0);
  
    var $84=$retval; //@line 1110 "klatt.cpp"
    ;
    return $84; //@line 1110 "klatt.cpp"
    return null;
  }
  

  function __ZL10frame_initP13klatt_frame_t() {
    var __stackBase__  = STACKTOP; STACKTOP += 56; _memset(__stackBase__, 0, 56);
    var __label__;
  
    var $frame_addr;
    var $amp_par=__stackBase__;
    var $Gain0_tmp;
    var $ix;
    $frame_addr=__ZL8kt_frame;
    var $0=$frame_addr; //@line 546 "klatt.cpp"
    var $F0hz10=(($0)&4294967295); //@line 546 "klatt.cpp"
    var $1=HEAP32[(($F0hz10)>>2)]; //@line 546 "klatt.cpp"
    var $div=((((($1))|0)/10)|0); //@line 546 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+176)&4294967295))>>2)]=$div; //@line 546 "klatt.cpp"
    var $2=$frame_addr; //@line 548 "klatt.cpp"
    var $AVdb=(($2+4)&4294967295); //@line 548 "klatt.cpp"
    var $3=HEAP32[(($AVdb)>>2)]; //@line 548 "klatt.cpp"
    var $sub=((($3)-7)&4294967295); //@line 548 "klatt.cpp"
    var $4=$frame_addr; //@line 548 "klatt.cpp"
    var $AVdb_tmp=(($4+204)&4294967295); //@line 548 "klatt.cpp"
    HEAP32[(($AVdb_tmp)>>2)]=$sub; //@line 548 "klatt.cpp"
    var $5=$frame_addr; //@line 549 "klatt.cpp"
    var $AVdb_tmp1=(($5+204)&4294967295); //@line 549 "klatt.cpp"
    var $6=HEAP32[(($AVdb_tmp1)>>2)]; //@line 549 "klatt.cpp"
    var $cmp=((($6))|0) < 0; //@line 549 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 549 "klatt.cpp"
    if (__label__ == 1) {
  
      var $7=$frame_addr; //@line 551 "klatt.cpp"
      var $AVdb_tmp2=(($7+204)&4294967295); //@line 551 "klatt.cpp"
      HEAP32[(($AVdb_tmp2)>>2)]=0; //@line 551 "klatt.cpp"
      ; //@line 552 "klatt.cpp"
    }
  
    var $8=$frame_addr; //@line 554 "klatt.cpp"
    var $ASP=(($8+168)&4294967295); //@line 554 "klatt.cpp"
    var $9=HEAP32[(($ASP)>>2)]; //@line 554 "klatt.cpp"
    var $call=__ZL7DBtoLINl($9); //@line 554 "klatt.cpp"
    var $mul=($call)*0.05; //@line 554 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+128)&4294967295))>>2)]=$mul; //@line 554 "klatt.cpp"
    var $10=$frame_addr; //@line 555 "klatt.cpp"
    var $AF=(($10+184)&4294967295); //@line 555 "klatt.cpp"
    var $11=HEAP32[(($AF)>>2)]; //@line 555 "klatt.cpp"
    var $call3=__ZL7DBtoLINl($11); //@line 555 "klatt.cpp"
    var $mul4=($call3)*0.25; //@line 555 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+136)&4294967295))>>2)]=$mul4; //@line 555 "klatt.cpp"
    var $12=$frame_addr; //@line 556 "klatt.cpp"
    var $AVpdb=(($12+196)&4294967295); //@line 556 "klatt.cpp"
    var $13=HEAP32[(($AVpdb)>>2)]; //@line 556 "klatt.cpp"
    var $call5=__ZL7DBtoLINl($13); //@line 556 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+120)&4294967295))>>2)]=$call5; //@line 556 "klatt.cpp"
    var $14=$frame_addr; //@line 557 "klatt.cpp"
    var $AB=(($14+192)&4294967295); //@line 557 "klatt.cpp"
    var $15=HEAP32[(($AB)>>2)]; //@line 557 "klatt.cpp"
    var $call6=__ZL7DBtoLINl($15); //@line 557 "klatt.cpp"
    var $mul7=($call6)*0.05; //@line 557 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+104)&4294967295))>>2)]=$mul7; //@line 557 "klatt.cpp"
    $ix=0; //@line 559 "klatt.cpp"
    ; //@line 559 "klatt.cpp"
    $for_body$5: while(1) { 
  
      var $16=$ix; //@line 562 "klatt.cpp"
      var $17=$frame_addr; //@line 562 "klatt.cpp"
      var $Ap=(($17+88)&4294967295); //@line 562 "klatt.cpp"
      var $arrayidx=(($Ap+$16*4)&4294967295); //@line 562 "klatt.cpp"
      var $18=HEAP32[(($arrayidx)>>2)]; //@line 562 "klatt.cpp"
      var $call9=__ZL7DBtoLINl($18); //@line 562 "klatt.cpp"
      var $19=$ix; //@line 562 "klatt.cpp"
      var $arrayidx10=((__ZZL10frame_initP13klatt_frame_tE14amp_par_factor+$19*8)&4294967295); //@line 562 "klatt.cpp"
      var $20=HEAPF32[(($arrayidx10)>>2)]; //@line 562 "klatt.cpp"
      var $mul11=($call9)*($20); //@line 562 "klatt.cpp"
      var $21=$ix; //@line 562 "klatt.cpp"
      var $arrayidx12=(($amp_par+$21*8)&4294967295); //@line 562 "klatt.cpp"
      HEAPF32[(($arrayidx12)>>2)]=$mul11; //@line 562 "klatt.cpp"
      var $22=$ix; //@line 559 "klatt.cpp"
      var $inc=((($22)+1)&4294967295); //@line 559 "klatt.cpp"
      $ix=$inc; //@line 559 "klatt.cpp"
      var $cmp8=((($inc))|0) <= 6; //@line 559 "klatt.cpp"
      if ($cmp8) { __label__ = 3;continue $for_body$5; } else { __label__ = 4;break $for_body$5; } //@line 559 "klatt.cpp"
    }
  
    var $23=$frame_addr; //@line 565 "klatt.cpp"
    var $Gain0=(($23+200)&4294967295); //@line 565 "klatt.cpp"
    var $24=HEAP32[(($Gain0)>>2)]; //@line 565 "klatt.cpp"
    var $sub13=((($24)-3)&4294967295); //@line 565 "klatt.cpp"
    $Gain0_tmp=$sub13; //@line 565 "klatt.cpp"
    var $25=$Gain0_tmp; //@line 566 "klatt.cpp"
    var $cmp14=((($25))|0) <= 0; //@line 566 "klatt.cpp"
    if ($cmp14) { __label__ = 5;; } else { __label__ = 6;; } //@line 566 "klatt.cpp"
    if (__label__ == 5) {
  
      $Gain0_tmp=57; //@line 568 "klatt.cpp"
      ; //@line 569 "klatt.cpp"
    }
  
    var $26=$Gain0_tmp; //@line 570 "klatt.cpp"
    var $call17=__ZL7DBtoLINl($26); //@line 570 "klatt.cpp"
    var $27=HEAP32[((((__ZL10kt_globals+184)&4294967295))>>2)]; //@line 570 "klatt.cpp"
    var $conv=((($27))|0); //@line 570 "klatt.cpp"
    var $div18=($call17)/($conv); //@line 570 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+152)&4294967295))>>2)]=$div18; //@line 570 "klatt.cpp"
    $ix=1; //@line 573 "klatt.cpp"
    ; //@line 573 "klatt.cpp"
    $for_body21$11: while(1) { 
  
      var $28=$ix; //@line 576 "klatt.cpp"
      var $29=$frame_addr; //@line 576 "klatt.cpp"
      var $Fhz=(($29+8)&4294967295); //@line 576 "klatt.cpp"
      var $arrayidx22=(($Fhz+$28*4)&4294967295); //@line 576 "klatt.cpp"
      var $30=HEAP32[(($arrayidx22)>>2)]; //@line 576 "klatt.cpp"
      var $31=$ix; //@line 576 "klatt.cpp"
      var $32=$frame_addr; //@line 576 "klatt.cpp"
      var $Bhz=(($32+48)&4294967295); //@line 576 "klatt.cpp"
      var $arrayidx23=(($Bhz+$31*4)&4294967295); //@line 576 "klatt.cpp"
      var $33=HEAP32[(($arrayidx23)>>2)]; //@line 576 "klatt.cpp"
      var $34=$ix; //@line 576 "klatt.cpp"
      var $arrayidx24=((((__ZL10kt_globals+188)&4294967295)+$34*64)&4294967295); //@line 576 "klatt.cpp"
      __ZL6setabcllP11resonator_t($30, $33, $arrayidx24); //@line 576 "klatt.cpp"
      var $35=$ix; //@line 578 "klatt.cpp"
      var $cmp25=((($35))|0) <= 5; //@line 578 "klatt.cpp"
      if ($cmp25) { __label__ = 8;; } else { __label__ = 9;; } //@line 578 "klatt.cpp"
      if (__label__ == 8) {
  
        var $36=$ix; //@line 580 "klatt.cpp"
        var $37=$frame_addr; //@line 580 "klatt.cpp"
        var $Fhz_next=(($37+208)&4294967295); //@line 580 "klatt.cpp"
        var $arrayidx27=(($Fhz_next+$36*4)&4294967295); //@line 580 "klatt.cpp"
        var $38=HEAP32[(($arrayidx27)>>2)]; //@line 580 "klatt.cpp"
        var $39=$ix; //@line 580 "klatt.cpp"
        var $40=$frame_addr; //@line 580 "klatt.cpp"
        var $Bhz_next=(($40+248)&4294967295); //@line 580 "klatt.cpp"
        var $arrayidx28=(($Bhz_next+$39*4)&4294967295); //@line 580 "klatt.cpp"
        var $41=HEAP32[(($arrayidx28)>>2)]; //@line 580 "klatt.cpp"
        var $42=$ix; //@line 580 "klatt.cpp"
        var $arrayidx29=((((__ZL10kt_globals+1468)&4294967295)+$42*64)&4294967295); //@line 580 "klatt.cpp"
        __ZL6setabcllP11resonator_t($38, $41, $arrayidx29); //@line 580 "klatt.cpp"
        var $43=$ix; //@line 582 "klatt.cpp"
        var $arrayidx30=((((__ZL10kt_globals+1468)&4294967295)+$43*64)&4294967295); //@line 582 "klatt.cpp"
        var $a=(($arrayidx30)&4294967295); //@line 582 "klatt.cpp"
        var $44=HEAPF32[(($a)>>2)]; //@line 582 "klatt.cpp"
        var $45=$ix; //@line 582 "klatt.cpp"
        var $arrayidx31=((((__ZL10kt_globals+188)&4294967295)+$45*64)&4294967295); //@line 582 "klatt.cpp"
        var $a32=(($arrayidx31)&4294967295); //@line 582 "klatt.cpp"
        var $46=HEAPF32[(($a32)>>2)]; //@line 582 "klatt.cpp"
        var $sub33=($44)-($46); //@line 582 "klatt.cpp"
        var $div34=($sub33)/64; //@line 582 "klatt.cpp"
        var $47=$ix; //@line 582 "klatt.cpp"
        var $arrayidx35=((((__ZL10kt_globals+188)&4294967295)+$47*64)&4294967295); //@line 582 "klatt.cpp"
        var $a_inc=(($arrayidx35+40)&4294967295); //@line 582 "klatt.cpp"
        HEAPF32[(($a_inc)>>2)]=$div34; //@line 582 "klatt.cpp"
        var $48=$ix; //@line 583 "klatt.cpp"
        var $arrayidx36=((((__ZL10kt_globals+1468)&4294967295)+$48*64)&4294967295); //@line 583 "klatt.cpp"
        var $b=(($arrayidx36+8)&4294967295); //@line 583 "klatt.cpp"
        var $49=HEAPF32[(($b)>>2)]; //@line 583 "klatt.cpp"
        var $50=$ix; //@line 583 "klatt.cpp"
        var $arrayidx37=((((__ZL10kt_globals+188)&4294967295)+$50*64)&4294967295); //@line 583 "klatt.cpp"
        var $b38=(($arrayidx37+8)&4294967295); //@line 583 "klatt.cpp"
        var $51=HEAPF32[(($b38)>>2)]; //@line 583 "klatt.cpp"
        var $sub39=($49)-($51); //@line 583 "klatt.cpp"
        var $div40=($sub39)/64; //@line 583 "klatt.cpp"
        var $52=$ix; //@line 583 "klatt.cpp"
        var $arrayidx41=((((__ZL10kt_globals+188)&4294967295)+$52*64)&4294967295); //@line 583 "klatt.cpp"
        var $b_inc=(($arrayidx41+48)&4294967295); //@line 583 "klatt.cpp"
        HEAPF32[(($b_inc)>>2)]=$div40; //@line 583 "klatt.cpp"
        var $53=$ix; //@line 584 "klatt.cpp"
        var $arrayidx42=((((__ZL10kt_globals+1468)&4294967295)+$53*64)&4294967295); //@line 584 "klatt.cpp"
        var $c=(($arrayidx42+16)&4294967295); //@line 584 "klatt.cpp"
        var $54=HEAPF32[(($c)>>2)]; //@line 584 "klatt.cpp"
        var $55=$ix; //@line 584 "klatt.cpp"
        var $arrayidx43=((((__ZL10kt_globals+188)&4294967295)+$55*64)&4294967295); //@line 584 "klatt.cpp"
        var $c44=(($arrayidx43+16)&4294967295); //@line 584 "klatt.cpp"
        var $56=HEAPF32[(($c44)>>2)]; //@line 584 "klatt.cpp"
        var $sub45=($54)-($56); //@line 584 "klatt.cpp"
        var $div46=($sub45)/64; //@line 584 "klatt.cpp"
        var $57=$ix; //@line 584 "klatt.cpp"
        var $arrayidx47=((((__ZL10kt_globals+188)&4294967295)+$57*64)&4294967295); //@line 584 "klatt.cpp"
        var $c_inc=(($arrayidx47+56)&4294967295); //@line 584 "klatt.cpp"
        HEAPF32[(($c_inc)>>2)]=$div46; //@line 584 "klatt.cpp"
        ; //@line 585 "klatt.cpp"
      }
  
      var $58=$ix; //@line 573 "klatt.cpp"
      var $inc50=((($58)+1)&4294967295); //@line 573 "klatt.cpp"
      $ix=$inc50; //@line 573 "klatt.cpp"
      var $cmp20=((($inc50))|0) <= 9; //@line 573 "klatt.cpp"
      if ($cmp20) { __label__ = 7;continue $for_body21$11; } else { __label__ = 10;break $for_body21$11; } //@line 573 "klatt.cpp"
    }
  
    var $59=$frame_addr; //@line 589 "klatt.cpp"
    var $Fhz52=(($59+8)&4294967295); //@line 589 "klatt.cpp"
    var $arrayidx53=(($Fhz52)&4294967295); //@line 589 "klatt.cpp"
    var $60=HEAP32[(($arrayidx53)>>2)]; //@line 589 "klatt.cpp"
    var $61=$frame_addr; //@line 589 "klatt.cpp"
    var $Bhz54=(($61+48)&4294967295); //@line 589 "klatt.cpp"
    var $arrayidx55=(($Bhz54)&4294967295); //@line 589 "klatt.cpp"
    var $62=HEAP32[(($arrayidx55)>>2)]; //@line 589 "klatt.cpp"
    __ZL10setzeroabcllP11resonator_t($60, $62, ((__ZL10kt_globals+188)&4294967295)); //@line 589 "klatt.cpp"
    var $63=$frame_addr; //@line 590 "klatt.cpp"
    var $Fhz_next56=(($63+208)&4294967295); //@line 590 "klatt.cpp"
    var $arrayidx57=(($Fhz_next56)&4294967295); //@line 590 "klatt.cpp"
    var $64=HEAP32[(($arrayidx57)>>2)]; //@line 590 "klatt.cpp"
    var $65=$frame_addr; //@line 590 "klatt.cpp"
    var $Bhz_next58=(($65+248)&4294967295); //@line 590 "klatt.cpp"
    var $arrayidx59=(($Bhz_next58)&4294967295); //@line 590 "klatt.cpp"
    var $66=HEAP32[(($arrayidx59)>>2)]; //@line 590 "klatt.cpp"
    __ZL10setzeroabcllP11resonator_t($64, $66, ((__ZL10kt_globals+1468)&4294967295)); //@line 590 "klatt.cpp"
    var $67=HEAPF32[((((__ZL10kt_globals+1468)&4294967295))>>2)]; //@line 591 "klatt.cpp"
    var $68=HEAPF32[((((__ZL10kt_globals+188)&4294967295))>>2)]; //@line 591 "klatt.cpp"
    var $sub60=($67)-($68); //@line 591 "klatt.cpp"
    var $div61=($sub60)/64; //@line 591 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+188+40)&4294967295))>>2)]=$div61; //@line 591 "klatt.cpp"
    var $69=HEAPF32[((((__ZL10kt_globals+1468+8)&4294967295))>>2)]; //@line 592 "klatt.cpp"
    var $70=HEAPF32[((((__ZL10kt_globals+188+8)&4294967295))>>2)]; //@line 592 "klatt.cpp"
    var $sub62=($69)-($70); //@line 592 "klatt.cpp"
    var $div63=($sub62)/64; //@line 592 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+188+48)&4294967295))>>2)]=$div63; //@line 592 "klatt.cpp"
    var $71=HEAPF32[((((__ZL10kt_globals+1468+16)&4294967295))>>2)]; //@line 593 "klatt.cpp"
    var $72=HEAPF32[((((__ZL10kt_globals+188+16)&4294967295))>>2)]; //@line 593 "klatt.cpp"
    var $sub64=($71)-($72); //@line 593 "klatt.cpp"
    var $div65=($sub64)/64; //@line 593 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+188+56)&4294967295))>>2)]=$div65; //@line 593 "klatt.cpp"
    $ix=0; //@line 598 "klatt.cpp"
    ; //@line 598 "klatt.cpp"
    while(1) { 
  
      var $73=$ix; //@line 600 "klatt.cpp"
      var $74=$frame_addr; //@line 600 "klatt.cpp"
      var $Fhz69=(($74+8)&4294967295); //@line 600 "klatt.cpp"
      var $arrayidx70=(($Fhz69+$73*4)&4294967295); //@line 600 "klatt.cpp"
      var $75=HEAP32[(($arrayidx70)>>2)]; //@line 600 "klatt.cpp"
      var $76=$ix; //@line 600 "klatt.cpp"
      var $77=$frame_addr; //@line 600 "klatt.cpp"
      var $Bphz=(($77+128)&4294967295); //@line 600 "klatt.cpp"
      var $arrayidx71=(($Bphz+$76*4)&4294967295); //@line 600 "klatt.cpp"
      var $78=HEAP32[(($arrayidx71)>>2)]; //@line 600 "klatt.cpp"
      var $79=$ix; //@line 600 "klatt.cpp"
      var $add=((($79)+10)&4294967295); //@line 600 "klatt.cpp"
      var $arrayidx72=((((__ZL10kt_globals+188)&4294967295)+$add*64)&4294967295); //@line 600 "klatt.cpp"
      __ZL6setabcllP11resonator_t($75, $78, $arrayidx72); //@line 600 "klatt.cpp"
      var $80=$ix; //@line 601 "klatt.cpp"
      var $arrayidx73=(($amp_par+$80*8)&4294967295); //@line 601 "klatt.cpp"
      var $81=HEAPF32[(($arrayidx73)>>2)]; //@line 601 "klatt.cpp"
      var $82=$ix; //@line 601 "klatt.cpp"
      var $add74=((($82)+10)&4294967295); //@line 601 "klatt.cpp"
      var $arrayidx75=((((__ZL10kt_globals+188)&4294967295)+$add74*64)&4294967295); //@line 601 "klatt.cpp"
      var $a76=(($arrayidx75)&4294967295); //@line 601 "klatt.cpp"
      var $83=HEAPF32[(($a76)>>2)]; //@line 601 "klatt.cpp"
      var $mul77=($83)*($81); //@line 601 "klatt.cpp"
      HEAPF32[(($a76)>>2)]=$mul77; //@line 601 "klatt.cpp"
      var $84=$ix; //@line 598 "klatt.cpp"
      var $inc79=((($84)+1)&4294967295); //@line 598 "klatt.cpp"
      $ix=$inc79; //@line 598 "klatt.cpp"
      var $cmp67=((($inc79))|0) <= 6; //@line 598 "klatt.cpp"
      if ($cmp67) { __label__ = 11;continue ; } else { __label__ = 12;break ; } //@line 598 "klatt.cpp"
    }
  
    var $85=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 606 "klatt.cpp"
    var $div81=((((($85))|0)/2)|0); //@line 606 "klatt.cpp"
    __ZL6setabcllP11resonator_t(0, $div81, ((__ZL10kt_globals+188+1216)&4294967295)); //@line 606 "klatt.cpp"
    STACKTOP = __stackBase__;
    return; //@line 608 "klatt.cpp"
    return;
  }
  

  function __ZL7parwaveP13klatt_frame_t() {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $frame_addr;
    var $temp;
    var $value;
    var $outbypas;
    var $out;
    var $n4;
    var $frics;
    var $glotout;
    var $aspiration;
    var $casc_next_in;
    var $par_glotout;
    var $ix;
    var $z2;
    var $c;
    var $sample;
    $frame_addr=__ZL8kt_frame;
    var $0=$frame_addr; //@line 245 "klatt.cpp"
    __ZL7flutterP13klatt_frame_t($0); //@line 245 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]=0; //@line 260 "klatt.cpp"
    ; //@line 260 "klatt.cpp"
    $for_cond$2: while(1) { 
  
      var $1=HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]; //@line 260 "klatt.cpp"
      var $2=HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]; //@line 260 "klatt.cpp"
      var $cmp=((($1))|0) < ((($2))|0); //@line 260 "klatt.cpp"
      if (!($cmp)) { __label__ = 36;break $for_cond$2; } //@line 260 "klatt.cpp"
  
      var $3=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 263 "klatt.cpp"
      var $call=__ZL9gen_noised($3); //@line 263 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]=$call; //@line 263 "klatt.cpp"
      var $4=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 270 "klatt.cpp"
      var $5=HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]; //@line 270 "klatt.cpp"
      var $cmp1=((($4))|0) > ((($5))|0); //@line 270 "klatt.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 270 "klatt.cpp"
      if (__label__ == 3) {
  
        var $6=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 272 "klatt.cpp"
        var $mul=($6)*0.5; //@line 272 "klatt.cpp"
        HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]=$mul; //@line 272 "klatt.cpp"
        ; //@line 273 "klatt.cpp"
      }
  
      var $7=HEAPF32[((((__ZL10kt_globals+136)&4294967295))>>2)]; //@line 276 "klatt.cpp"
      var $8=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 276 "klatt.cpp"
      var $mul2=($7)*($8); //@line 276 "klatt.cpp"
      $frics=$mul2; //@line 276 "klatt.cpp"
      $n4=0; //@line 284 "klatt.cpp"
      ; //@line 284 "klatt.cpp"
      $for_body5$8: while(1) { 
  
        var $9=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 286 "klatt.cpp"
        if ($9 == 1) {
          __label__ = 6;;
        }
        else if ($9 == 2) {
          __label__ = 7;;
        }
        else if ($9 == 3) {
          __label__ = 8;;
        }
        else {
        __label__ = 9;;
        }
        
        if (__label__ == 6) {
  
          var $call6=__ZL16impulsive_sourcev(); //@line 289 "klatt.cpp"
          HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call6; //@line 289 "klatt.cpp"
          ; //@line 290 "klatt.cpp"
        }
        else if (__label__ == 7) {
  
          var $call8=__ZL14natural_sourcev(); //@line 292 "klatt.cpp"
          HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call8; //@line 292 "klatt.cpp"
          ; //@line 293 "klatt.cpp"
        }
        else if (__label__ == 8) {
  
          var $call10=__ZL14sampled_sourcev(); //@line 295 "klatt.cpp"
          HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call10; //@line 295 "klatt.cpp"
          ; //@line 296 "klatt.cpp"
        }
  
        var $10=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 300 "klatt.cpp"
        var $11=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 300 "klatt.cpp"
        var $cmp11=((($10))|0) >= ((($11))|0); //@line 300 "klatt.cpp"
        if ($cmp11) { __label__ = 10;; } else { __label__ = 11;; } //@line 300 "klatt.cpp"
        if (__label__ == 10) {
  
          HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]=0; //@line 302 "klatt.cpp"
          var $12=$frame_addr; //@line 303 "klatt.cpp"
          __ZL21pitch_synch_par_resetP13klatt_frame_t($12); //@line 303 "klatt.cpp"
          ; //@line 304 "klatt.cpp"
        }
  
        var $13=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 311 "klatt.cpp"
        var $call14=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+1152)&4294967295), $13); //@line 311 "klatt.cpp"
        HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$call14; //@line 311 "klatt.cpp"
        var $14=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 314 "klatt.cpp"
        var $inc=((($14)+1)&4294967295); //@line 314 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]=$inc; //@line 314 "klatt.cpp"
        var $15=$n4; //@line 284 "klatt.cpp"
        var $inc15=((($15)+1)&4294967295); //@line 284 "klatt.cpp"
        $n4=$inc15; //@line 284 "klatt.cpp"
        var $cmp4=((($inc15))|0) < 4; //@line 284 "klatt.cpp"
        if ($cmp4) { __label__ = 5;continue $for_body5$8; } else { __label__ = 12;break $for_body5$8; } //@line 284 "klatt.cpp"
      }
  
      var $16=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 322 "klatt.cpp"
      var $17=HEAPF32[((((__ZL10kt_globals+88)&4294967295))>>2)]; //@line 322 "klatt.cpp"
      var $mul16=($16)*($17); //@line 322 "klatt.cpp"
      var $18=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5vlast)>>2)]; //@line 322 "klatt.cpp"
      var $19=HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]; //@line 322 "klatt.cpp"
      var $mul17=($18)*($19); //@line 322 "klatt.cpp"
      var $add=($mul16)+($mul17); //@line 322 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$add; //@line 322 "klatt.cpp"
      var $20=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 323 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5vlast)>>2)]=$20; //@line 323 "klatt.cpp"
      var $21=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 332 "klatt.cpp"
      var $22=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 332 "klatt.cpp"
      var $cmp18=((($21))|0) < ((($22))|0); //@line 332 "klatt.cpp"
      if ($cmp18) { __label__ = 13;; } else { __label__ = 14;; } //@line 332 "klatt.cpp"
      if (__label__ == 13) {
  
        var $23=HEAPF32[((((__ZL10kt_globals+144)&4294967295))>>2)]; //@line 334 "klatt.cpp"
        var $24=HEAP32[((((__ZL10kt_globals+52)&4294967295))>>2)]; //@line 334 "klatt.cpp"
        var $conv=((($24))|0); //@line 334 "klatt.cpp"
        var $mul20=($23)*($conv); //@line 334 "klatt.cpp"
        var $25=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 334 "klatt.cpp"
        var $add21=($25)+($mul20); //@line 334 "klatt.cpp"
        HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]=$add21; //@line 334 "klatt.cpp"
        ; //@line 335 "klatt.cpp"
      }
  
      var $26=HEAPF32[((((__ZL10kt_globals+112)&4294967295))>>2)]; //@line 338 "klatt.cpp"
      var $27=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 338 "klatt.cpp"
      var $mul23=($26)*($27); //@line 338 "klatt.cpp"
      $glotout=$mul23; //@line 338 "klatt.cpp"
      var $28=HEAPF32[((((__ZL10kt_globals+120)&4294967295))>>2)]; //@line 339 "klatt.cpp"
      var $29=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5voice)>>2)]; //@line 339 "klatt.cpp"
      var $mul24=($28)*($29); //@line 339 "klatt.cpp"
      $par_glotout=$mul24; //@line 339 "klatt.cpp"
      var $30=HEAPF32[((((__ZL10kt_globals+128)&4294967295))>>2)]; //@line 342 "klatt.cpp"
      var $31=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5noise)>>2)]; //@line 342 "klatt.cpp"
      var $mul25=($30)*($31); //@line 342 "klatt.cpp"
      $aspiration=$mul25; //@line 342 "klatt.cpp"
      var $32=$aspiration; //@line 343 "klatt.cpp"
      var $33=$glotout; //@line 343 "klatt.cpp"
      var $add26=($33)+($32); //@line 343 "klatt.cpp"
      $glotout=$add26; //@line 343 "klatt.cpp"
      var $34=$aspiration; //@line 345 "klatt.cpp"
      var $35=$par_glotout; //@line 345 "klatt.cpp"
      var $add27=($35)+($34); //@line 345 "klatt.cpp"
      $par_glotout=$add27; //@line 345 "klatt.cpp"
      $out=0; //@line 352 "klatt.cpp"
      var $36=HEAP32[((((__ZL10kt_globals)&4294967295))>>2)]; //@line 353 "klatt.cpp"
      var $cmp28=((($36))|0)!=2; //@line 353 "klatt.cpp"
      if ($cmp28) { __label__ = 15;; } else { __label__ = 16;; } //@line 353 "klatt.cpp"
      if (__label__ == 15) {
  
        var $37=$glotout; //@line 355 "klatt.cpp"
        var $call30=__ZL14antiresonator2P11resonator_td($37); //@line 355 "klatt.cpp"
        $casc_next_in=$call30; //@line 355 "klatt.cpp"
        var $38=$casc_next_in; //@line 356 "klatt.cpp"
        var $call31=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+576)&4294967295), $38); //@line 356 "klatt.cpp"
        $casc_next_in=$call31; //@line 356 "klatt.cpp"
        var $39=$casc_next_in; //@line 357 "klatt.cpp"
        var $call32=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+512)&4294967295), $39); //@line 357 "klatt.cpp"
        $casc_next_in=$call32; //@line 357 "klatt.cpp"
        var $40=$casc_next_in; //@line 358 "klatt.cpp"
        var $call33=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+448)&4294967295), $40); //@line 358 "klatt.cpp"
        $casc_next_in=$call33; //@line 358 "klatt.cpp"
        var $41=$casc_next_in; //@line 359 "klatt.cpp"
        var $call34=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+384)&4294967295), $41); //@line 359 "klatt.cpp"
        $casc_next_in=$call34; //@line 359 "klatt.cpp"
        var $42=$casc_next_in; //@line 360 "klatt.cpp"
        var $call35=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+320)&4294967295), $42); //@line 360 "klatt.cpp"
        $casc_next_in=$call35; //@line 360 "klatt.cpp"
        var $43=$casc_next_in; //@line 361 "klatt.cpp"
        var $call36=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+256)&4294967295), $43); //@line 361 "klatt.cpp"
        $casc_next_in=$call36; //@line 361 "klatt.cpp"
        var $44=$casc_next_in; //@line 362 "klatt.cpp"
        var $call37=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+192)&4294967295), $44); //@line 362 "klatt.cpp"
        $casc_next_in=$call37; //@line 362 "klatt.cpp"
        var $45=$casc_next_in; //@line 363 "klatt.cpp"
        var $call38=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+128)&4294967295), $45); //@line 363 "klatt.cpp"
        $casc_next_in=$call38; //@line 363 "klatt.cpp"
        var $46=$casc_next_in; //@line 364 "klatt.cpp"
        var $call39=__ZL10resonator2P11resonator_td(((__ZL10kt_globals+188+64)&4294967295), $46); //@line 364 "klatt.cpp"
        $out=$call39; //@line 364 "klatt.cpp"
        ; //@line 365 "klatt.cpp"
      }
  
      var $47=$par_glotout; //@line 368 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]=$47; //@line 368 "klatt.cpp"
      var $48=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 377 "klatt.cpp"
      var $call41=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+704)&4294967295), $48); //@line 377 "klatt.cpp"
      var $49=$out; //@line 377 "klatt.cpp"
      var $add42=($49)+($call41); //@line 377 "klatt.cpp"
      $out=$add42; //@line 377 "klatt.cpp"
      var $50=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 378 "klatt.cpp"
      var $call43=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+640)&4294967295), $50); //@line 378 "klatt.cpp"
      var $51=$out; //@line 378 "klatt.cpp"
      var $add44=($51)+($call43); //@line 378 "klatt.cpp"
      $out=$add44; //@line 378 "klatt.cpp"
      var $52=$frics; //@line 380 "klatt.cpp"
      var $53=$par_glotout; //@line 380 "klatt.cpp"
      var $add45=($52)+($53); //@line 380 "klatt.cpp"
      var $54=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE8glotlast)>>2)]; //@line 380 "klatt.cpp"
      var $sub=($add45)-($54); //@line 380 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]=$sub; //@line 380 "klatt.cpp"
      var $55=$par_glotout; //@line 381 "klatt.cpp"
      HEAPF32[((__ZZL7parwaveP13klatt_frame_tE8glotlast)>>2)]=$55; //@line 381 "klatt.cpp"
      $ix=12; //@line 383 "klatt.cpp"
      ; //@line 383 "klatt.cpp"
      $for_body48$25: while(1) { 
  
        var $56=$ix; //@line 385 "klatt.cpp"
        var $arrayidx=((((__ZL10kt_globals+188)&4294967295)+$56*64)&4294967295); //@line 385 "klatt.cpp"
        var $57=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 385 "klatt.cpp"
        var $call49=__ZL9resonatorP11resonator_td($arrayidx, $57); //@line 385 "klatt.cpp"
        var $58=$out; //@line 385 "klatt.cpp"
        var $sub50=($call49)-($58); //@line 385 "klatt.cpp"
        $out=$sub50; //@line 385 "klatt.cpp"
        var $59=$ix; //@line 383 "klatt.cpp"
        var $inc52=((($59)+1)&4294967295); //@line 383 "klatt.cpp"
        $ix=$inc52; //@line 383 "klatt.cpp"
        var $cmp47=((($inc52))|0) <= 16; //@line 383 "klatt.cpp"
        if ($cmp47) { __label__ = 17;continue $for_body48$25; } else { __label__ = 18;break $for_body48$25; } //@line 383 "klatt.cpp"
      }
  
      var $60=HEAPF32[((((__ZL10kt_globals+104)&4294967295))>>2)]; //@line 388 "klatt.cpp"
      var $61=HEAPF32[((__ZZL7parwaveP13klatt_frame_tE5sourc)>>2)]; //@line 388 "klatt.cpp"
      var $mul54=($60)*($61); //@line 388 "klatt.cpp"
      $outbypas=$mul54; //@line 388 "klatt.cpp"
      var $62=$outbypas; //@line 390 "klatt.cpp"
      var $63=$out; //@line 390 "klatt.cpp"
      var $sub55=($62)-($63); //@line 390 "klatt.cpp"
      $out=$sub55; //@line 390 "klatt.cpp"
      var $64=$out; //@line 423 "klatt.cpp"
      var $call56=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+1216)&4294967295), $64); //@line 423 "klatt.cpp"
      $out=$call56; //@line 423 "klatt.cpp"
      var $65=$out; //@line 424 "klatt.cpp"
      var $66=HEAP32[((((_wdata+52)&4294967295))>>2)]; //@line 424 "klatt.cpp"
      var $conv57=((($66))|0); //@line 424 "klatt.cpp"
      var $mul58=($65)*($conv57); //@line 424 "klatt.cpp"
      var $67=HEAPF32[((((__ZL10kt_globals+152)&4294967295))>>2)]; //@line 424 "klatt.cpp"
      var $mul59=($mul58)*($67); //@line 424 "klatt.cpp"
      var $conv60=((($mul59))|0); //@line 424 "klatt.cpp"
      var $conv61=((($conv60))|0); //@line 424 "klatt.cpp"
      $temp=$conv61; //@line 424 "klatt.cpp"
      $z2=0; //@line 433 "klatt.cpp"
      var $68=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 434 "klatt.cpp"
      var $69=HEAP32[((((_wdata+28)&4294967295))>>2)]; //@line 434 "klatt.cpp"
      var $cmp62=((($68))|0) < ((($69))|0); //@line 434 "klatt.cpp"
      if ($cmp62) { __label__ = 19;; } else { __label__ = 23;; } //@line 434 "klatt.cpp"
      if (__label__ == 19) {
  
        var $70=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 436 "klatt.cpp"
        var $cmp64=((($70))|0)==0; //@line 436 "klatt.cpp"
        var $71=HEAPU32[((((_wdata+40)&4294967295))>>2)]; //@line 439 "klatt.cpp"
        var $add66=((($71)+1)&4294967295); //@line 439 "klatt.cpp"
        if ($cmp64) { __label__ = 20;; } else { __label__ = 21;; } //@line 436 "klatt.cpp"
        if (__label__ == 20) {
  
          var $72=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 439 "klatt.cpp"
          var $arrayidx67=(($72+$add66)&4294967295); //@line 439 "klatt.cpp"
          var $73=HEAP8[($arrayidx67)]; //@line 439 "klatt.cpp"
          $c=$73; //@line 439 "klatt.cpp"
          var $74=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 440 "klatt.cpp"
          var $75=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 440 "klatt.cpp"
          var $arrayidx68=(($75+$74)&4294967295); //@line 440 "klatt.cpp"
          var $76=HEAPU8[($arrayidx68)]; //@line 440 "klatt.cpp"
          var $conv69=((($76))&255); //@line 440 "klatt.cpp"
          var $77=$c; //@line 440 "klatt.cpp"
          var $conv70=(tempInt=(($77)),(tempInt>=128?tempInt-256:tempInt)); //@line 440 "klatt.cpp"
          var $mul71=((($conv70)*256)&4294967295); //@line 440 "klatt.cpp"
          var $add72=((($mul71)+($conv69))&4294967295); //@line 440 "klatt.cpp"
          $sample=$add72; //@line 440 "klatt.cpp"
          var $78=HEAP32[((((_wdata+40)&4294967295))>>2)]; //@line 441 "klatt.cpp"
          var $add73=((($78)+2)&4294967295); //@line 441 "klatt.cpp"
          HEAP32[((((_wdata+40)&4294967295))>>2)]=$add73; //@line 441 "klatt.cpp"
          ; //@line 442 "klatt.cpp"
        }
        else if (__label__ == 21) {
  
          HEAP32[((((_wdata+40)&4294967295))>>2)]=$add66; //@line 446 "klatt.cpp"
          var $79=HEAP32[((((_wdata+24)&4294967295))>>2)]; //@line 446 "klatt.cpp"
          var $arrayidx75=(($79+$71)&4294967295); //@line 446 "klatt.cpp"
          var $80=HEAP8[($arrayidx75)]; //@line 446 "klatt.cpp"
          var $conv76=(tempInt=(($80)),(tempInt>=128?tempInt-256:tempInt)); //@line 446 "klatt.cpp"
          var $81=HEAP32[((((_wdata+32)&4294967295))>>2)]; //@line 446 "klatt.cpp"
          var $mul77=((($conv76)*($81))&4294967295); //@line 446 "klatt.cpp"
          $sample=$mul77; //@line 446 "klatt.cpp"
          ;
        }
  
        var $82=$sample; //@line 448 "klatt.cpp"
        var $83=HEAP32[((((_wdata+56)&4294967295))>>2)]; //@line 448 "klatt.cpp"
        var $mul79=((($83)*($82))&4294967295); //@line 448 "klatt.cpp"
        var $div=((((($mul79))|0)/1024)|0); //@line 448 "klatt.cpp"
        $z2=$div; //@line 448 "klatt.cpp"
        var $84=$z2; //@line 449 "klatt.cpp"
        var $85=HEAP32[((((_wdata+36)&4294967295))>>2)]; //@line 449 "klatt.cpp"
        var $mul80=((($85)*($84))&4294967295); //@line 449 "klatt.cpp"
        var $div81=((((($mul80))|0)/40)|0); //@line 449 "klatt.cpp"
        $z2=$div81; //@line 449 "klatt.cpp"
        var $86=$z2; //@line 450 "klatt.cpp"
        var $conv82=((($86))|0); //@line 450 "klatt.cpp"
        var $87=$temp; //@line 450 "klatt.cpp"
        var $add83=($87)+($conv82); //@line 450 "klatt.cpp"
        $temp=$add83; //@line 450 "klatt.cpp"
        ; //@line 451 "klatt.cpp"
      }
  
      var $88=HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]; //@line 455 "klatt.cpp"
      var $cmp85=((($88))|0) > 0; //@line 455 "klatt.cpp"
      if ($cmp85) { __label__ = 24;; } else { __label__ = 25;; } //@line 455 "klatt.cpp"
      if (__label__ == 24) {
  
        var $89=HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]; //@line 457 "klatt.cpp"
        var $dec=((($89)-1)&4294967295); //@line 457 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]=$dec; //@line 457 "klatt.cpp"
        var $90=$temp; //@line 458 "klatt.cpp"
        var $91=HEAP32[((((__ZL10kt_globals+180)&4294967295))>>2)]; //@line 458 "klatt.cpp"
        var $conv87=((($91))|0); //@line 458 "klatt.cpp"
        var $mul88=($90)*($conv87); //@line 458 "klatt.cpp"
        var $div89=($mul88)/64; //@line 458 "klatt.cpp"
        $temp=$div89; //@line 458 "klatt.cpp"
        ; //@line 459 "klatt.cpp"
      }
  
      var $92=$temp; //@line 461 "klatt.cpp"
      var $conv91=((($92))|0); //@line 461 "klatt.cpp"
      var $93=HEAP32[((_echo_tail)>>2)]; //@line 461 "klatt.cpp"
      var $inc92=((($93)+1)&4294967295); //@line 461 "klatt.cpp"
      HEAP32[((_echo_tail)>>2)]=$inc92; //@line 461 "klatt.cpp"
      var $arrayidx93=((_echo_buf+$93*2)&4294967295); //@line 461 "klatt.cpp"
      var $94=HEAP16[(($arrayidx93)>>1)]; //@line 461 "klatt.cpp"
      var $conv94=(tempInt=(($94)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 461 "klatt.cpp"
      var $95=HEAP32[((_echo_amp)>>2)]; //@line 461 "klatt.cpp"
      var $mul95=((($conv94)*($95))&4294967295); //@line 461 "klatt.cpp"
      var $shr=($mul95) >> 8; //@line 461 "klatt.cpp"
      var $add96=((($shr)+($conv91))&4294967295); //@line 461 "klatt.cpp"
      $value=$add96; //@line 461 "klatt.cpp"
      var $96=HEAP32[((_echo_tail)>>2)]; //@line 462 "klatt.cpp"
      var $cmp97=((($96))|0) >= 5500; //@line 462 "klatt.cpp"
      if ($cmp97) { __lastLabel__ = 25; __label__ = 26;; } else { __lastLabel__ = 25; __label__ = 27;; } //@line 462 "klatt.cpp"
      if (__label__ == 26) {
  
        HEAP32[((_echo_tail)>>2)]=0; //@line 463 "klatt.cpp"
        var $_pr=$value; //@line 465 "klatt.cpp"
        __lastLabel__ = 26; ; //@line 463 "klatt.cpp"
      }
  
      var $97=__lastLabel__ == 26 ? $_pr : ($add96); //@line 465 "klatt.cpp"
      var $cmp100=((($97))|0) < -32768; //@line 465 "klatt.cpp"
      if ($cmp100) { __label__ = 28;; } else { __label__ = 29;; } //@line 465 "klatt.cpp"
      $if_end102_thread$$if_end102$41: do { 
        if (__label__ == 28) {
  
          $value=-32768; //@line 467 "klatt.cpp"
          ; //@line 470 "klatt.cpp"
        }
        else if (__label__ == 29) {
  
          var $_pr1=$value; //@line 470 "klatt.cpp"
          var $cmp103=((($_pr1))|0) > 32767; //@line 470 "klatt.cpp"
          if (!($cmp103)) { __label__ = 31;break $if_end102_thread$$if_end102$41; } //@line 470 "klatt.cpp"
  
          $value=32767; //@line 472 "klatt.cpp"
          ; //@line 473 "klatt.cpp"
        }
      } while(0);
  
      var $98=$value; //@line 475 "klatt.cpp"
      var $conv106=((($98)) & 255); //@line 475 "klatt.cpp"
      var $99=HEAP32[((_out_ptr)>>2)]; //@line 475 "klatt.cpp"
      var $incdec_ptr=(($99+1)&4294967295); //@line 475 "klatt.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr; //@line 475 "klatt.cpp"
      HEAP8[($99)]=$conv106; //@line 475 "klatt.cpp"
      var $100=$value; //@line 476 "klatt.cpp"
      var $shr107=($100) >> 8; //@line 476 "klatt.cpp"
      var $conv108=((($shr107)) & 255); //@line 476 "klatt.cpp"
      var $101=HEAP32[((_out_ptr)>>2)]; //@line 476 "klatt.cpp"
      var $incdec_ptr109=(($101+1)&4294967295); //@line 476 "klatt.cpp"
      HEAP32[((_out_ptr)>>2)]=$incdec_ptr109; //@line 476 "klatt.cpp"
      HEAP8[($101)]=$conv108; //@line 476 "klatt.cpp"
      var $102=$value; //@line 478 "klatt.cpp"
      var $conv110=((($102)) & 65535); //@line 478 "klatt.cpp"
      var $103=HEAP32[((_echo_head)>>2)]; //@line 478 "klatt.cpp"
      var $inc111=((($103)+1)&4294967295); //@line 478 "klatt.cpp"
      HEAP32[((_echo_head)>>2)]=$inc111; //@line 478 "klatt.cpp"
      var $arrayidx112=((_echo_buf+$103*2)&4294967295); //@line 478 "klatt.cpp"
      HEAP16[(($arrayidx112)>>1)]=$conv110; //@line 478 "klatt.cpp"
      var $104=HEAP32[((_echo_head)>>2)]; //@line 479 "klatt.cpp"
      var $cmp113=((($104))|0) >= 5500; //@line 479 "klatt.cpp"
      if ($cmp113) { __label__ = 32;; } else { __label__ = 33;; } //@line 479 "klatt.cpp"
      if (__label__ == 32) {
  
        HEAP32[((_echo_head)>>2)]=0; //@line 480 "klatt.cpp"
        ; //@line 480 "klatt.cpp"
      }
  
      var $105=HEAP32[((__ZL12sample_count)>>2)]; //@line 482 "klatt.cpp"
      var $inc116=((($105)+1)&4294967295); //@line 482 "klatt.cpp"
      HEAP32[((__ZL12sample_count)>>2)]=$inc116; //@line 482 "klatt.cpp"
      var $106=HEAPU32[((_out_ptr)>>2)]; //@line 483 "klatt.cpp"
      var $107=HEAPU32[((_out_end)>>2)]; //@line 483 "klatt.cpp"
      var $cmp117=((($106))>>>0) >= ((($107))>>>0); //@line 483 "klatt.cpp"
      if ($cmp117) { __label__ = 34;break $for_cond$2; } //@line 483 "klatt.cpp"
  
      var $108=HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]; //@line 260 "klatt.cpp"
      var $inc121=((($108)+1)&4294967295); //@line 260 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]=$inc121; //@line 260 "klatt.cpp"
      __label__ = 1;continue $for_cond$2; //@line 260 "klatt.cpp"
    }
    if (__label__ == 36) {
  
      $retval=0; //@line 488 "klatt.cpp"
      ; //@line 488 "klatt.cpp"
    }
    else if (__label__ == 34) {
  
      $retval=1; //@line 485 "klatt.cpp"
      ; //@line 485 "klatt.cpp"
    }
  
    var $109=$retval; //@line 489 "klatt.cpp"
    ;
    return $109; //@line 489 "klatt.cpp"
    return null;
  }
  

  function __Z14SetSynth_KlattiiP7frame_tS0_P7voice_ti($length, $modn, $fr1, $fr2, $v, $control) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $length_addr;
    var $modn_addr;
    var $fr1_addr;
    var $fr2_addr;
    var $v_addr;
    var $control_addr;
    var $ix;
    var $next;
    var $qix;
    var $cmd;
    var $fr3;
    $length_addr=$length;
    $modn_addr=$modn;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    $v_addr=$v;
    $control_addr=$control;
    var $0=HEAP32[((_wvoice)>>2)]; //@line 1122 "klatt.cpp"
    var $cmp=((($0))|0)!=0; //@line 1122 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 5;; } //@line 1122 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((_wvoice)>>2)]; //@line 1124 "klatt.cpp"
      var $klattv=(($1+112)&4294967295); //@line 1124 "klatt.cpp"
      var $arrayidx=(($klattv)&4294967295); //@line 1124 "klatt.cpp"
      var $2=HEAP32[(($arrayidx)>>2)]; //@line 1124 "klatt.cpp"
      var $cmp1=((($2))|0) > 0; //@line 1124 "klatt.cpp"
      if ($cmp1) { __label__ = 2;; } else { __label__ = 4;; } //@line 1124 "klatt.cpp"
      $land_lhs_true$$if_end$4: do { 
        if (__label__ == 2) {
  
          var $3=HEAP32[((_wvoice)>>2)]; //@line 1124 "klatt.cpp"
          var $klattv2=(($3+112)&4294967295); //@line 1124 "klatt.cpp"
          var $arrayidx3=(($klattv2)&4294967295); //@line 1124 "klatt.cpp"
          var $4=HEAP32[(($arrayidx3)>>2)]; //@line 1124 "klatt.cpp"
          var $cmp4=((($4))|0) <= 3; //@line 1124 "klatt.cpp"
          if (!($cmp4)) { __label__ = 4;break $land_lhs_true$$if_end$4; } //@line 1124 "klatt.cpp"
  
          var $5=HEAP32[((_wvoice)>>2)]; //@line 1126 "klatt.cpp"
          var $klattv6=(($5+112)&4294967295); //@line 1126 "klatt.cpp"
          var $arrayidx7=(($klattv6)&4294967295); //@line 1126 "klatt.cpp"
          var $6=HEAP32[(($arrayidx7)>>2)]; //@line 1126 "klatt.cpp"
          HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]=$6; //@line 1126 "klatt.cpp"
          var $7=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 1127 "klatt.cpp"
          var $arrayidx8=((__ZL13scale_wav_tab+$7*4)&4294967295); //@line 1127 "klatt.cpp"
          var $8=HEAP32[(($arrayidx8)>>2)]; //@line 1127 "klatt.cpp"
          HEAP32[((((__ZL10kt_globals+184)&4294967295))>>2)]=$8; //@line 1127 "klatt.cpp"
          ; //@line 1128 "klatt.cpp"
        }
      } while(0);
  
      var $9=HEAP32[((_wvoice)>>2)]; //@line 1129 "klatt.cpp"
      var $flutter=(($9+68)&4294967295); //@line 1129 "klatt.cpp"
      var $10=HEAP32[(($flutter)>>2)]; //@line 1129 "klatt.cpp"
      var $div=((((($10))|0)/32)|0); //@line 1129 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+24)&4294967295))>>2)]=$div; //@line 1129 "klatt.cpp"
      ; //@line 1130 "klatt.cpp"
    }
  
    HEAP32[((__ZL8end_wave803)>>2)]=0; //@line 1132 "klatt.cpp"
    var $11=$control_addr; //@line 1133 "klatt.cpp"
    var $and=($11) & 2; //@line 1133 "klatt.cpp"
    var $tobool=((($and))|0)!=0; //@line 1133 "klatt.cpp"
    if ($tobool) { __label__ = 6;; } else { __label__ = 7;; } //@line 1133 "klatt.cpp"
    if (__label__ == 6) {
  
      HEAP32[((__ZL8end_wave803)>>2)]=1; //@line 1135 "klatt.cpp"
      ; //@line 1136 "klatt.cpp"
    }
  
    var $12=$control_addr; //@line 1137 "klatt.cpp"
    var $and12=($12) & 1; //@line 1137 "klatt.cpp"
    var $tobool13=((($and12))|0)!=0; //@line 1137 "klatt.cpp"
    if ($tobool13) { __label__ = 8;; } else { __label__ = 20;; } //@line 1137 "klatt.cpp"
    $if_then14$$if_end44$12: do { 
      if (__label__ == 8) {
  
        HEAP32[((__ZL8end_wave803)>>2)]=1; //@line 1139 "klatt.cpp"
        var $13=HEAP32[((_wcmdq_head)>>2)]; //@line 1140 "klatt.cpp"
        var $add=((($13)+1)&4294967295); //@line 1140 "klatt.cpp"
        $qix=$add; //@line 1140 "klatt.cpp"
        __lastLabel__ = 8; ; //@line 1140 "klatt.cpp"
        $for_cond$14: while(1) { 
  
          var $14=__lastLabel__ == 19 ? $inc42 : ($add); //@line 1142 "klatt.cpp"
          var $cmp15=((($14))|0) >= 160; //@line 1142 "klatt.cpp"
          if ($cmp15) { __label__ = 10;; } else { __label__ = 11;; } //@line 1142 "klatt.cpp"
          if (__label__ == 10) {
  
            $qix=0; //@line 1142 "klatt.cpp"
            ; //@line 1142 "klatt.cpp"
          }
  
          var $15=$qix; //@line 1143 "klatt.cpp"
          var $16=HEAP32[((_wcmdq_tail)>>2)]; //@line 1143 "klatt.cpp"
          var $cmp18=((($15))|0)==((($16))|0); //@line 1143 "klatt.cpp"
          if ($cmp18) { __label__ = 20;break $if_then14$$if_end44$12; } //@line 1143 "klatt.cpp"
  
          var $17=$qix; //@line 1145 "klatt.cpp"
          var $arrayidx21=((_wcmdq+$17*16)&4294967295); //@line 1145 "klatt.cpp"
          var $arrayidx22=(($arrayidx21)&4294967295); //@line 1145 "klatt.cpp"
          var $18=HEAP32[(($arrayidx22)>>2)]; //@line 1145 "klatt.cpp"
          $cmd=$18; //@line 1145 "klatt.cpp"
          var $19=$cmd; //@line 1146 "klatt.cpp"
          var $cmp23=((($19))|0)==1; //@line 1146 "klatt.cpp"
          if ($cmp23) { __label__ = 13;break $for_cond$14; } //@line 1146 "klatt.cpp"
  
          var $31=$cmd; //@line 1162 "klatt.cpp"
          var $cmp37=((($31))|0)==6; //@line 1162 "klatt.cpp"
          var $32=$cmd; //@line 1162 "klatt.cpp"
          var $cmp38=((($32))|0)==5; //@line 1162 "klatt.cpp"
          var $or_cond=($cmp37) | ($cmp38); //@line 1162 "klatt.cpp"
          if ($or_cond) { __label__ = 20;break $if_then14$$if_end44$12; } //@line 1162 "klatt.cpp"
  
          var $33=$qix; //@line 1140 "klatt.cpp"
          var $inc42=((($33)+1)&4294967295); //@line 1140 "klatt.cpp"
          $qix=$inc42; //@line 1140 "klatt.cpp"
          __lastLabel__ = 19; __label__ = 9;continue $for_cond$14; //@line 1140 "klatt.cpp"
        }
  
        HEAP32[((__ZL8end_wave803)>>2)]=0; //@line 1148 "klatt.cpp"
        var $20=$qix; //@line 1150 "klatt.cpp"
        var $arrayidx25=((_wcmdq+$20*16)&4294967295); //@line 1150 "klatt.cpp"
        var $arrayidx26=(($arrayidx25+8)&4294967295); //@line 1150 "klatt.cpp"
        var $21=HEAP32[(($arrayidx26)>>2)]; //@line 1150 "klatt.cpp"
        var $22=($21); //@line 1150 "klatt.cpp"
        $fr3=$22; //@line 1150 "klatt.cpp"
        $ix=1; //@line 1151 "klatt.cpp"
        __lastLabel__ = 13; ; //@line 1151 "klatt.cpp"
        while(1) { 
  
          var $23=__lastLabel__ == 17 ? $inc : (1); //@line 1151 "klatt.cpp"
          var $cmp28=((($23))|0) < 6; //@line 1151 "klatt.cpp"
          if (!($cmp28)) { __label__ = 20;break $if_then14$$if_end44$12; } //@line 1151 "klatt.cpp"
  
          var $24=$ix; //@line 1153 "klatt.cpp"
          var $25=$fr3; //@line 1153 "klatt.cpp"
          var $ffreq=(($25+2)&4294967295); //@line 1153 "klatt.cpp"
          var $arrayidx29=(($ffreq+$24*2)&4294967295); //@line 1153 "klatt.cpp"
          var $26=HEAP16[(($arrayidx29)>>1)]; //@line 1153 "klatt.cpp"
          var $conv=(tempInt=(($26)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1153 "klatt.cpp"
          var $27=$ix; //@line 1153 "klatt.cpp"
          var $28=$fr2_addr; //@line 1153 "klatt.cpp"
          var $ffreq30=(($28+2)&4294967295); //@line 1153 "klatt.cpp"
          var $arrayidx31=(($ffreq30+$27*2)&4294967295); //@line 1153 "klatt.cpp"
          var $29=HEAP16[(($arrayidx31)>>1)]; //@line 1153 "klatt.cpp"
          var $conv32=(tempInt=(($29)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1153 "klatt.cpp"
          var $cmp33=((($conv))|0)!=((($conv32))|0); //@line 1153 "klatt.cpp"
          if ($cmp33) { __label__ = 16;break ; } //@line 1153 "klatt.cpp"
  
          var $30=$ix; //@line 1151 "klatt.cpp"
          var $inc=((($30)+1)&4294967295); //@line 1151 "klatt.cpp"
          $ix=$inc; //@line 1151 "klatt.cpp"
          __lastLabel__ = 17; __label__ = 14;continue ; //@line 1151 "klatt.cpp"
        }
  
        HEAP32[((__ZL8end_wave803)>>2)]=2; //@line 1156 "klatt.cpp"
        ; //@line 1157 "klatt.cpp"
      }
    } while(0);
  
    var $34=$control_addr; //@line 1191 "klatt.cpp"
    var $and45=($34) & 1; //@line 1191 "klatt.cpp"
    var $tobool46=((($and45))|0)!=0; //@line 1191 "klatt.cpp"
    if ($tobool46) { __label__ = 21;; } else { __label__ = 27;; } //@line 1191 "klatt.cpp"
    if (__label__ == 21) {
  
      $ix=1; //@line 1193 "klatt.cpp"
      __lastLabel__ = 21; ; //@line 1193 "klatt.cpp"
      while(1) { 
  
        var $35=__lastLabel__ == 25 ? $inc60 : (1); //@line 1193 "klatt.cpp"
        var $cmp49=((($35))|0) < 6; //@line 1193 "klatt.cpp"
        if (!($cmp49)) { __label__ = 26;break ; } //@line 1193 "klatt.cpp"
  
        var $36=$ix; //@line 1195 "klatt.cpp"
        var $arrayidx51=((((__ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr+2)&4294967295)+$36*2)&4294967295); //@line 1195 "klatt.cpp"
        var $37=HEAP16[(($arrayidx51)>>1)]; //@line 1195 "klatt.cpp"
        var $conv52=(tempInt=(($37)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1195 "klatt.cpp"
        var $38=$ix; //@line 1195 "klatt.cpp"
        var $39=$fr1_addr; //@line 1195 "klatt.cpp"
        var $ffreq53=(($39+2)&4294967295); //@line 1195 "klatt.cpp"
        var $arrayidx54=(($ffreq53+$38*2)&4294967295); //@line 1195 "klatt.cpp"
        var $40=HEAP16[(($arrayidx54)>>1)]; //@line 1195 "klatt.cpp"
        var $conv55=(tempInt=(($40)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1195 "klatt.cpp"
        var $cmp56=((($conv52))|0)!=((($conv55))|0); //@line 1195 "klatt.cpp"
        if ($cmp56) { __label__ = 24;break ; } //@line 1195 "klatt.cpp"
  
        var $41=$ix; //@line 1193 "klatt.cpp"
        var $inc60=((($41)+1)&4294967295); //@line 1193 "klatt.cpp"
        $ix=$inc60; //@line 1193 "klatt.cpp"
        __lastLabel__ = 25; __label__ = 22;continue ; //@line 1193 "klatt.cpp"
      }
      if (__label__ == 24) {
  
        __Z10KlattReseti(0); //@line 1199 "klatt.cpp"
        ; //@line 1200 "klatt.cpp"
      }
  
      var $42=$fr2_addr; //@line 1203 "klatt.cpp"
      var $43=$42; //@line 1203 "klatt.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $43;
      $dest$ = __ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr;
      $stop$ = $src$ + 64;
      if (($dest$%4) == ($src$%4) && 64 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 1203 "klatt.cpp"
      ; //@line 1204 "klatt.cpp"
    }
  
    $ix=0; //@line 1206 "klatt.cpp"
    __lastLabel__ = 27; ; //@line 1206 "klatt.cpp"
    $for_body65$39: while(1) { 
  
      var $44=__lastLabel__ == 27 ? 0 : ($inc90); //@line 1208 "klatt.cpp"
      var $cmp66=((($44))|0) >= 5; //@line 1208 "klatt.cpp"
      if ($cmp66) { __label__ = 29;; } else { __label__ = 31;; } //@line 1208 "klatt.cpp"
      $land_lhs_true67$$if_else$41: do { 
        if (__label__ == 29) {
  
          var $45=$fr1_addr; //@line 1208 "klatt.cpp"
          var $frflags=(($45)&4294967295); //@line 1208 "klatt.cpp"
          var $46=HEAP16[(($frflags)>>1)]; //@line 1208 "klatt.cpp"
          var $conv68=(tempInt=(($46)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1208 "klatt.cpp"
          var $and69=($conv68) & 1; //@line 1208 "klatt.cpp"
          var $cmp70=((($and69))|0)==0; //@line 1208 "klatt.cpp"
          if (!($cmp70)) { __label__ = 31;break $land_lhs_true67$$if_else$41; } //@line 1208 "klatt.cpp"
  
          var $47=$ix; //@line 1210 "klatt.cpp"
          var $arrayidx72=((__ZL6klattp+$47*4)&4294967295); //@line 1210 "klatt.cpp"
          HEAP32[(($arrayidx72)>>2)]=0; //@line 1210 "klatt.cpp"
          var $48=$ix; //@line 1210 "klatt.cpp"
          var $arrayidx73=((__ZL7klattp1+$48*8)&4294967295); //@line 1210 "klatt.cpp"
          HEAPF32[(($arrayidx73)>>2)]=0; //@line 1210 "klatt.cpp"
          var $49=$ix; //@line 1211 "klatt.cpp"
          var $arrayidx74=((__ZL10klattp_inc+$49*8)&4294967295); //@line 1211 "klatt.cpp"
          HEAPF32[(($arrayidx74)>>2)]=0; //@line 1211 "klatt.cpp"
          __label__ = 32;break $land_lhs_true67$$if_else$41; //@line 1212 "klatt.cpp"
        }
      } while(0);
      if (__label__ == 31) {
  
        var $50=$ix; //@line 1215 "klatt.cpp"
        var $51=$fr1_addr; //@line 1215 "klatt.cpp"
        var $klattp=(($51+39)&4294967295); //@line 1215 "klatt.cpp"
        var $arrayidx75=(($klattp+$50)&4294967295); //@line 1215 "klatt.cpp"
        var $52=HEAPU8[($arrayidx75)]; //@line 1215 "klatt.cpp"
        var $conv76=((($52))&255); //@line 1215 "klatt.cpp"
        var $53=$ix; //@line 1215 "klatt.cpp"
        var $arrayidx77=((__ZL6klattp+$53*4)&4294967295); //@line 1215 "klatt.cpp"
        HEAP32[(($arrayidx77)>>2)]=$conv76; //@line 1215 "klatt.cpp"
        var $conv78=((($conv76))|0); //@line 1215 "klatt.cpp"
        var $54=$ix; //@line 1215 "klatt.cpp"
        var $arrayidx79=((__ZL7klattp1+$54*8)&4294967295); //@line 1215 "klatt.cpp"
        HEAPF32[(($arrayidx79)>>2)]=$conv78; //@line 1215 "klatt.cpp"
        var $55=$ix; //@line 1216 "klatt.cpp"
        var $56=$fr2_addr; //@line 1216 "klatt.cpp"
        var $klattp80=(($56+39)&4294967295); //@line 1216 "klatt.cpp"
        var $arrayidx81=(($klattp80+$55)&4294967295); //@line 1216 "klatt.cpp"
        var $57=HEAPU8[($arrayidx81)]; //@line 1216 "klatt.cpp"
        var $conv82=((($57))&255); //@line 1216 "klatt.cpp"
        var $58=$ix; //@line 1216 "klatt.cpp"
        var $arrayidx83=((__ZL6klattp+$58*4)&4294967295); //@line 1216 "klatt.cpp"
        var $59=HEAP32[(($arrayidx83)>>2)]; //@line 1216 "klatt.cpp"
        var $sub=((($conv82)-($59))&4294967295); //@line 1216 "klatt.cpp"
        var $mul=((($sub)*64)&4294967295); //@line 1216 "klatt.cpp"
        var $conv84=((($mul))|0); //@line 1216 "klatt.cpp"
        var $60=$length_addr; //@line 1216 "klatt.cpp"
        var $conv85=((($60))|0); //@line 1216 "klatt.cpp"
        var $div86=($conv84)/($conv85); //@line 1216 "klatt.cpp"
        var $61=$ix; //@line 1216 "klatt.cpp"
        var $arrayidx87=((__ZL10klattp_inc+$61*8)&4294967295); //@line 1216 "klatt.cpp"
        HEAPF32[(($arrayidx87)>>2)]=$div86; //@line 1216 "klatt.cpp"
        ;
      }
  
      var $62=$ix; //@line 1206 "klatt.cpp"
      var $inc90=((($62)+1)&4294967295); //@line 1206 "klatt.cpp"
      $ix=$inc90; //@line 1206 "klatt.cpp"
      var $cmp64=((($inc90))|0) < 10; //@line 1206 "klatt.cpp"
      if ($cmp64) { __lastLabel__ = 32; __label__ = 28;continue $for_body65$39; } else { __lastLabel__ = 32; __label__ = 33;break $for_body65$39; } //@line 1206 "klatt.cpp"
    }
  
    var $63=$length_addr; //@line 1224 "klatt.cpp"
    HEAP32[((__ZL8nsamples802)>>2)]=$63; //@line 1224 "klatt.cpp"
    $ix=1; //@line 1226 "klatt.cpp"
    ; //@line 1226 "klatt.cpp"
    $for_body94$48: while(1) { 
  
      var $64=$ix; //@line 1228 "klatt.cpp"
      var $65=$fr1_addr; //@line 1228 "klatt.cpp"
      var $ffreq95=(($65+2)&4294967295); //@line 1228 "klatt.cpp"
      var $arrayidx96=(($ffreq95+$64*2)&4294967295); //@line 1228 "klatt.cpp"
      var $66=HEAP16[(($arrayidx96)>>1)]; //@line 1228 "klatt.cpp"
      var $conv97=(tempInt=(($66)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1228 "klatt.cpp"
      var $67=$ix; //@line 1228 "klatt.cpp"
      var $68=$v_addr; //@line 1228 "klatt.cpp"
      var $freq=(($68+144)&4294967295); //@line 1228 "klatt.cpp"
      var $arrayidx98=(($freq+$67*2)&4294967295); //@line 1228 "klatt.cpp"
      var $69=HEAP16[(($arrayidx98)>>1)]; //@line 1228 "klatt.cpp"
      var $conv99=(tempInt=(($69)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1228 "klatt.cpp"
      var $mul100=((($conv99)*($conv97))&4294967295); //@line 1228 "klatt.cpp"
      var $conv101=((($mul100))|0); //@line 1228 "klatt.cpp"
      var $div102=($conv101)/256; //@line 1228 "klatt.cpp"
      var $70=$ix; //@line 1228 "klatt.cpp"
      var $71=$v_addr; //@line 1228 "klatt.cpp"
      var $freqadd=(($71+198)&4294967295); //@line 1228 "klatt.cpp"
      var $arrayidx103=(($freqadd+$70*2)&4294967295); //@line 1228 "klatt.cpp"
      var $72=HEAP16[(($arrayidx103)>>1)]; //@line 1228 "klatt.cpp"
      var $conv104=(tempInt=(($72)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1228 "klatt.cpp"
      var $conv105=((($conv104))|0); //@line 1228 "klatt.cpp"
      var $add106=($div102)+($conv105); //@line 1228 "klatt.cpp"
      var $73=$ix; //@line 1228 "klatt.cpp"
      var $arrayidx107=((__ZL5peaks801+$73*80)&4294967295); //@line 1228 "klatt.cpp"
      var $freq1=(($arrayidx107+16)&4294967295); //@line 1228 "klatt.cpp"
      HEAPF32[(($freq1)>>2)]=$add106; //@line 1228 "klatt.cpp"
      var $74=$ix; //@line 1229 "klatt.cpp"
      var $arrayidx108=((__ZL5peaks801+$74*80)&4294967295); //@line 1229 "klatt.cpp"
      var $freq1109=(($arrayidx108+16)&4294967295); //@line 1229 "klatt.cpp"
      var $75=HEAPF32[(($freq1109)>>2)]; //@line 1229 "klatt.cpp"
      var $conv110=((($75))|0); //@line 1229 "klatt.cpp"
      var $76=$ix; //@line 1229 "klatt.cpp"
      var $arrayidx111=((__ZL5peaks801+$76*80)&4294967295); //@line 1229 "klatt.cpp"
      var $freq112=(($arrayidx111)&4294967295); //@line 1229 "klatt.cpp"
      HEAP32[(($freq112)>>2)]=$conv110; //@line 1229 "klatt.cpp"
      var $77=$ix; //@line 1230 "klatt.cpp"
      var $78=$fr2_addr; //@line 1230 "klatt.cpp"
      var $ffreq113=(($78+2)&4294967295); //@line 1230 "klatt.cpp"
      var $arrayidx114=(($ffreq113+$77*2)&4294967295); //@line 1230 "klatt.cpp"
      var $79=HEAP16[(($arrayidx114)>>1)]; //@line 1230 "klatt.cpp"
      var $conv115=(tempInt=(($79)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1230 "klatt.cpp"
      var $80=$ix; //@line 1230 "klatt.cpp"
      var $81=$v_addr; //@line 1230 "klatt.cpp"
      var $freq116=(($81+144)&4294967295); //@line 1230 "klatt.cpp"
      var $arrayidx117=(($freq116+$80*2)&4294967295); //@line 1230 "klatt.cpp"
      var $82=HEAP16[(($arrayidx117)>>1)]; //@line 1230 "klatt.cpp"
      var $conv118=(tempInt=(($82)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1230 "klatt.cpp"
      var $mul119=((($conv118)*($conv115))&4294967295); //@line 1230 "klatt.cpp"
      var $conv120=((($mul119))|0); //@line 1230 "klatt.cpp"
      var $div121=($conv120)/256; //@line 1230 "klatt.cpp"
      var $83=$ix; //@line 1230 "klatt.cpp"
      var $84=$v_addr; //@line 1230 "klatt.cpp"
      var $freqadd122=(($84+198)&4294967295); //@line 1230 "klatt.cpp"
      var $arrayidx123=(($freqadd122+$83*2)&4294967295); //@line 1230 "klatt.cpp"
      var $85=HEAP16[(($arrayidx123)>>1)]; //@line 1230 "klatt.cpp"
      var $conv124=(tempInt=(($85)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1230 "klatt.cpp"
      var $conv125=((($conv124))|0); //@line 1230 "klatt.cpp"
      var $add126=($div121)+($conv125); //@line 1230 "klatt.cpp"
      $next=$add126; //@line 1230 "klatt.cpp"
      var $86=$next; //@line 1231 "klatt.cpp"
      var $87=$ix; //@line 1231 "klatt.cpp"
      var $arrayidx127=((__ZL5peaks801+$87*80)&4294967295); //@line 1231 "klatt.cpp"
      var $freq1128=(($arrayidx127+16)&4294967295); //@line 1231 "klatt.cpp"
      var $88=HEAPF32[(($freq1128)>>2)]; //@line 1231 "klatt.cpp"
      var $sub129=($86)-($88); //@line 1231 "klatt.cpp"
      var $mul130=($sub129)*64; //@line 1231 "klatt.cpp"
      var $89=$length_addr; //@line 1231 "klatt.cpp"
      var $conv131=((($89))|0); //@line 1231 "klatt.cpp"
      var $div132=($mul130)/($conv131); //@line 1231 "klatt.cpp"
      var $90=$ix; //@line 1231 "klatt.cpp"
      var $arrayidx133=((__ZL5peaks801+$90*80)&4294967295); //@line 1231 "klatt.cpp"
      var $freq_inc=(($arrayidx133+48)&4294967295); //@line 1231 "klatt.cpp"
      HEAPF32[(($freq_inc)>>2)]=$div132; //@line 1231 "klatt.cpp"
      var $91=$ix; //@line 1233 "klatt.cpp"
      var $cmp134=((($91))|0) < 4; //@line 1233 "klatt.cpp"
      if ($cmp134) { __label__ = 35;; } else { __label__ = 36;; } //@line 1233 "klatt.cpp"
      if (__label__ == 35) {
  
        var $92=$ix; //@line 1236 "klatt.cpp"
        var $93=$fr1_addr; //@line 1236 "klatt.cpp"
        var $bw=(($93+35)&4294967295); //@line 1236 "klatt.cpp"
        var $arrayidx136=(($bw+$92)&4294967295); //@line 1236 "klatt.cpp"
        var $94=HEAPU8[($arrayidx136)]; //@line 1236 "klatt.cpp"
        var $conv137=((($94))&255); //@line 1236 "klatt.cpp"
        var $mul138=((($conv137)*2)&4294967295); //@line 1236 "klatt.cpp"
        var $conv139=((($mul138))|0); //@line 1236 "klatt.cpp"
        var $95=$ix; //@line 1236 "klatt.cpp"
        var $arrayidx140=((__ZL5peaks801+$95*80)&4294967295); //@line 1236 "klatt.cpp"
        var $bw1=(($arrayidx140+24)&4294967295); //@line 1236 "klatt.cpp"
        HEAPF32[(($bw1)>>2)]=$conv139; //@line 1236 "klatt.cpp"
        var $96=$ix; //@line 1237 "klatt.cpp"
        var $arrayidx141=((__ZL5peaks801+$96*80)&4294967295); //@line 1237 "klatt.cpp"
        var $bw1142=(($arrayidx141+24)&4294967295); //@line 1237 "klatt.cpp"
        var $97=HEAPF32[(($bw1142)>>2)]; //@line 1237 "klatt.cpp"
        var $conv143=((($97))|0); //@line 1237 "klatt.cpp"
        var $98=$ix; //@line 1237 "klatt.cpp"
        var $arrayidx144=((__ZL5peaks801+$98*80)&4294967295); //@line 1237 "klatt.cpp"
        var $bw145=(($arrayidx144+4)&4294967295); //@line 1237 "klatt.cpp"
        HEAP32[(($bw145)>>2)]=$conv143; //@line 1237 "klatt.cpp"
        var $99=$ix; //@line 1238 "klatt.cpp"
        var $100=$fr2_addr; //@line 1238 "klatt.cpp"
        var $bw146=(($100+35)&4294967295); //@line 1238 "klatt.cpp"
        var $arrayidx147=(($bw146+$99)&4294967295); //@line 1238 "klatt.cpp"
        var $101=HEAPU8[($arrayidx147)]; //@line 1238 "klatt.cpp"
        var $conv148=((($101))&255); //@line 1238 "klatt.cpp"
        var $mul149=((($conv148)*2)&4294967295); //@line 1238 "klatt.cpp"
        var $conv150=((($mul149))|0); //@line 1238 "klatt.cpp"
        $next=$conv150; //@line 1238 "klatt.cpp"
        var $102=$next; //@line 1239 "klatt.cpp"
        var $103=$ix; //@line 1239 "klatt.cpp"
        var $arrayidx151=((__ZL5peaks801+$103*80)&4294967295); //@line 1239 "klatt.cpp"
        var $bw1152=(($arrayidx151+24)&4294967295); //@line 1239 "klatt.cpp"
        var $104=HEAPF32[(($bw1152)>>2)]; //@line 1239 "klatt.cpp"
        var $sub153=($102)-($104); //@line 1239 "klatt.cpp"
        var $mul154=($sub153)*64; //@line 1239 "klatt.cpp"
        var $105=$length_addr; //@line 1239 "klatt.cpp"
        var $conv155=((($105))|0); //@line 1239 "klatt.cpp"
        var $div156=($mul154)/($conv155); //@line 1239 "klatt.cpp"
        var $106=$ix; //@line 1239 "klatt.cpp"
        var $arrayidx157=((__ZL5peaks801+$106*80)&4294967295); //@line 1239 "klatt.cpp"
        var $bw_inc=(($arrayidx157+56)&4294967295); //@line 1239 "klatt.cpp"
        HEAPF32[(($bw_inc)>>2)]=$div156; //@line 1239 "klatt.cpp"
        ; //@line 1240 "klatt.cpp"
      }
  
      var $107=$ix; //@line 1226 "klatt.cpp"
      var $inc160=((($107)+1)&4294967295); //@line 1226 "klatt.cpp"
      $ix=$inc160; //@line 1226 "klatt.cpp"
      var $cmp93=((($inc160))|0) < 6; //@line 1226 "klatt.cpp"
      if ($cmp93) { __label__ = 34;continue $for_body94$48; } else { __label__ = 37;break $for_body94$48; } //@line 1226 "klatt.cpp"
    }
  
    var $108=$fr1_addr; //@line 1244 "klatt.cpp"
    var $klattp162=(($108+39)&4294967295); //@line 1244 "klatt.cpp"
    var $arrayidx163=(($klattp162+1)&4294967295); //@line 1244 "klatt.cpp"
    var $109=HEAPU8[($arrayidx163)]; //@line 1244 "klatt.cpp"
    var $conv164=((($109))&255); //@line 1244 "klatt.cpp"
    var $mul165=((($conv164)*2)&4294967295); //@line 1244 "klatt.cpp"
    var $conv166=((($mul165))|0); //@line 1244 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]=$conv166; //@line 1244 "klatt.cpp"
    var $110=HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]; //@line 1245 "klatt.cpp"
    var $cmp167=($110) == 0; //@line 1245 "klatt.cpp"
    if ($cmp167) { __label__ = 38;; } else { __label__ = 39;; } //@line 1245 "klatt.cpp"
    if (__label__ == 38) {
  
      var $111=HEAP32[((((__ZL8kt_frame+8+36)&4294967295))>>2)]; //@line 1246 "klatt.cpp"
      var $conv169=((($111))|0); //@line 1246 "klatt.cpp"
      HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]=$conv169; //@line 1246 "klatt.cpp"
      ; //@line 1246 "klatt.cpp"
    }
  
    var $112=HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]; //@line 1248 "klatt.cpp"
    var $conv171=((($112))|0); //@line 1248 "klatt.cpp"
    HEAP32[((((__ZL5peaks801)&4294967295))>>2)]=$conv171; //@line 1248 "klatt.cpp"
    var $113=$fr2_addr; //@line 1249 "klatt.cpp"
    var $klattp172=(($113+39)&4294967295); //@line 1249 "klatt.cpp"
    var $arrayidx173=(($klattp172+1)&4294967295); //@line 1249 "klatt.cpp"
    var $114=HEAPU8[($arrayidx173)]; //@line 1249 "klatt.cpp"
    var $conv174=((($114))&255); //@line 1249 "klatt.cpp"
    var $mul175=((($conv174)*2)&4294967295); //@line 1249 "klatt.cpp"
    var $conv176=((($mul175))|0); //@line 1249 "klatt.cpp"
    $next=$conv176; //@line 1249 "klatt.cpp"
    var $cmp177=($conv176) == 0; //@line 1250 "klatt.cpp"
    if ($cmp177) { __label__ = 40;; } else { __label__ = 41;; } //@line 1250 "klatt.cpp"
    if (__label__ == 40) {
  
      var $115=HEAP32[((((__ZL8kt_frame+8+36)&4294967295))>>2)]; //@line 1251 "klatt.cpp"
      var $conv179=((($115))|0); //@line 1251 "klatt.cpp"
      $next=$conv179; //@line 1251 "klatt.cpp"
      ; //@line 1251 "klatt.cpp"
    }
  
    var $116=$next; //@line 1253 "klatt.cpp"
    var $117=HEAPF32[((((__ZL5peaks801+16)&4294967295))>>2)]; //@line 1253 "klatt.cpp"
    var $sub181=($116)-($117); //@line 1253 "klatt.cpp"
    var $mul182=($sub181)*64; //@line 1253 "klatt.cpp"
    var $118=$length_addr; //@line 1253 "klatt.cpp"
    var $conv183=((($118))|0); //@line 1253 "klatt.cpp"
    var $div184=($mul182)/($conv183); //@line 1253 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+48)&4294967295))>>2)]=$div184; //@line 1253 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+24)&4294967295))>>2)]=89; //@line 1255 "klatt.cpp"
    HEAP32[((((__ZL5peaks801+4)&4294967295))>>2)]=89; //@line 1256 "klatt.cpp"
    HEAPF32[((((__ZL5peaks801+56)&4294967295))>>2)]=0; //@line 1257 "klatt.cpp"
    var $119=$fr1_addr; //@line 1259 "klatt.cpp"
    var $frflags185=(($119)&4294967295); //@line 1259 "klatt.cpp"
    var $120=HEAP16[(($frflags185)>>1)]; //@line 1259 "klatt.cpp"
    var $conv186=(tempInt=(($120)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1259 "klatt.cpp"
    var $and187=($conv186) & 1; //@line 1259 "klatt.cpp"
    var $tobool188=((($and187))|0)!=0; //@line 1259 "klatt.cpp"
    if ($tobool188) { __label__ = 42;; } else { __label__ = 44;; } //@line 1259 "klatt.cpp"
    $if_then189$$if_end236$60: do { 
      if (__label__ == 42) {
  
        $ix=1; //@line 1262 "klatt.cpp"
        ; //@line 1262 "klatt.cpp"
        while(1) { 
  
          var $121=$ix; //@line 1264 "klatt.cpp"
          var $122=$fr1_addr; //@line 1264 "klatt.cpp"
          var $klatt_bp=(($122+56)&4294967295); //@line 1264 "klatt.cpp"
          var $arrayidx193=(($klatt_bp+$121)&4294967295); //@line 1264 "klatt.cpp"
          var $123=HEAPU8[($arrayidx193)]; //@line 1264 "klatt.cpp"
          var $conv194=((($123))&255); //@line 1264 "klatt.cpp"
          var $mul195=((($conv194)*4)&4294967295); //@line 1264 "klatt.cpp"
          var $conv196=((($mul195))|0); //@line 1264 "klatt.cpp"
          var $124=$ix; //@line 1264 "klatt.cpp"
          var $arrayidx197=((__ZL5peaks801+$124*80)&4294967295); //@line 1264 "klatt.cpp"
          var $bp1=(($arrayidx197+40)&4294967295); //@line 1264 "klatt.cpp"
          HEAPF32[(($bp1)>>2)]=$conv196; //@line 1264 "klatt.cpp"
          var $125=$ix; //@line 1265 "klatt.cpp"
          var $arrayidx198=((__ZL5peaks801+$125*80)&4294967295); //@line 1265 "klatt.cpp"
          var $bp1199=(($arrayidx198+40)&4294967295); //@line 1265 "klatt.cpp"
          var $126=HEAPF32[(($bp1199)>>2)]; //@line 1265 "klatt.cpp"
          var $conv200=((($126))|0); //@line 1265 "klatt.cpp"
          var $127=$ix; //@line 1265 "klatt.cpp"
          var $arrayidx201=((__ZL5peaks801+$127*80)&4294967295); //@line 1265 "klatt.cpp"
          var $bp=(($arrayidx201+12)&4294967295); //@line 1265 "klatt.cpp"
          HEAP32[(($bp)>>2)]=$conv200; //@line 1265 "klatt.cpp"
          var $128=$ix; //@line 1266 "klatt.cpp"
          var $129=$fr2_addr; //@line 1266 "klatt.cpp"
          var $klatt_bp202=(($129+56)&4294967295); //@line 1266 "klatt.cpp"
          var $arrayidx203=(($klatt_bp202+$128)&4294967295); //@line 1266 "klatt.cpp"
          var $130=HEAPU8[($arrayidx203)]; //@line 1266 "klatt.cpp"
          var $conv204=((($130))&255); //@line 1266 "klatt.cpp"
          var $mul205=((($conv204)*2)&4294967295); //@line 1266 "klatt.cpp"
          var $conv206=((($mul205))|0); //@line 1266 "klatt.cpp"
          $next=$conv206; //@line 1266 "klatt.cpp"
          var $131=$next; //@line 1267 "klatt.cpp"
          var $132=$ix; //@line 1267 "klatt.cpp"
          var $arrayidx207=((__ZL5peaks801+$132*80)&4294967295); //@line 1267 "klatt.cpp"
          var $bp1208=(($arrayidx207+40)&4294967295); //@line 1267 "klatt.cpp"
          var $133=HEAPF32[(($bp1208)>>2)]; //@line 1267 "klatt.cpp"
          var $sub209=($131)-($133); //@line 1267 "klatt.cpp"
          var $mul210=($sub209)*64; //@line 1267 "klatt.cpp"
          var $134=$length_addr; //@line 1267 "klatt.cpp"
          var $conv211=((($134))|0); //@line 1267 "klatt.cpp"
          var $div212=($mul210)/($conv211); //@line 1267 "klatt.cpp"
          var $135=$ix; //@line 1267 "klatt.cpp"
          var $arrayidx213=((__ZL5peaks801+$135*80)&4294967295); //@line 1267 "klatt.cpp"
          var $bp_inc=(($arrayidx213+72)&4294967295); //@line 1267 "klatt.cpp"
          HEAPF32[(($bp_inc)>>2)]=$div212; //@line 1267 "klatt.cpp"
          var $136=$ix; //@line 1269 "klatt.cpp"
          var $137=$fr1_addr; //@line 1269 "klatt.cpp"
          var $klatt_ap=(($137+49)&4294967295); //@line 1269 "klatt.cpp"
          var $arrayidx214=(($klatt_ap+$136)&4294967295); //@line 1269 "klatt.cpp"
          var $138=HEAPU8[($arrayidx214)]; //@line 1269 "klatt.cpp"
          var $conv215=((($138))&255); //@line 1269 "klatt.cpp"
          var $139=$ix; //@line 1269 "klatt.cpp"
          var $arrayidx216=((__ZL5peaks801+$139*80)&4294967295); //@line 1269 "klatt.cpp"
          var $ap1=(($arrayidx216+32)&4294967295); //@line 1269 "klatt.cpp"
          HEAPF32[(($ap1)>>2)]=$conv215; //@line 1269 "klatt.cpp"
          var $140=$ix; //@line 1270 "klatt.cpp"
          var $arrayidx217=((__ZL5peaks801+$140*80)&4294967295); //@line 1270 "klatt.cpp"
          var $ap1218=(($arrayidx217+32)&4294967295); //@line 1270 "klatt.cpp"
          var $141=HEAPF32[(($ap1218)>>2)]; //@line 1270 "klatt.cpp"
          var $conv219=((($141))|0); //@line 1270 "klatt.cpp"
          var $142=$ix; //@line 1270 "klatt.cpp"
          var $arrayidx220=((__ZL5peaks801+$142*80)&4294967295); //@line 1270 "klatt.cpp"
          var $ap=(($arrayidx220+8)&4294967295); //@line 1270 "klatt.cpp"
          HEAP32[(($ap)>>2)]=$conv219; //@line 1270 "klatt.cpp"
          var $143=$ix; //@line 1271 "klatt.cpp"
          var $144=$fr2_addr; //@line 1271 "klatt.cpp"
          var $klatt_ap221=(($144+49)&4294967295); //@line 1271 "klatt.cpp"
          var $arrayidx222=(($klatt_ap221+$143)&4294967295); //@line 1271 "klatt.cpp"
          var $145=HEAPU8[($arrayidx222)]; //@line 1271 "klatt.cpp"
          var $conv223=((($145))&255); //@line 1271 "klatt.cpp"
          var $mul224=((($conv223)*2)&4294967295); //@line 1271 "klatt.cpp"
          var $conv225=((($mul224))|0); //@line 1271 "klatt.cpp"
          $next=$conv225; //@line 1271 "klatt.cpp"
          var $146=$next; //@line 1272 "klatt.cpp"
          var $147=$ix; //@line 1272 "klatt.cpp"
          var $arrayidx226=((__ZL5peaks801+$147*80)&4294967295); //@line 1272 "klatt.cpp"
          var $ap1227=(($arrayidx226+32)&4294967295); //@line 1272 "klatt.cpp"
          var $148=HEAPF32[(($ap1227)>>2)]; //@line 1272 "klatt.cpp"
          var $sub228=($146)-($148); //@line 1272 "klatt.cpp"
          var $mul229=($sub228)*64; //@line 1272 "klatt.cpp"
          var $149=$length_addr; //@line 1272 "klatt.cpp"
          var $conv230=((($149))|0); //@line 1272 "klatt.cpp"
          var $div231=($mul229)/($conv230); //@line 1272 "klatt.cpp"
          var $150=$ix; //@line 1272 "klatt.cpp"
          var $arrayidx232=((__ZL5peaks801+$150*80)&4294967295); //@line 1272 "klatt.cpp"
          var $ap_inc=(($arrayidx232+64)&4294967295); //@line 1272 "klatt.cpp"
          HEAPF32[(($ap_inc)>>2)]=$div231; //@line 1272 "klatt.cpp"
          var $151=$ix; //@line 1262 "klatt.cpp"
          var $inc234=((($151)+1)&4294967295); //@line 1262 "klatt.cpp"
          $ix=$inc234; //@line 1262 "klatt.cpp"
          var $cmp191=((($inc234))|0) < 7; //@line 1262 "klatt.cpp"
          if ($cmp191) { __label__ = 43;continue ; } else { __label__ = 44;break $if_then189$$if_end236$60; } //@line 1262 "klatt.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 1275 "klatt.cpp"
    return;
  }
  

  function __Z14Wavegen_Klatt2iiiP7frame_tS0_($length, $modulation, $resume, $fr1, $fr2) {
    ;
    var __label__;
  
    var $length_addr;
    var $modulation_addr;
    var $resume_addr;
    var $fr1_addr;
    var $fr2_addr;
    $length_addr=$length;
    $modulation_addr=$modulation;
    $resume_addr=$resume;
    $fr1_addr=$fr1;
    $fr2_addr=$fr2;
    var $0=$resume_addr; //@line 1280 "klatt.cpp"
    var $cmp=((($0))|0)==0; //@line 1280 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 1280 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=$length_addr; //@line 1281 "klatt.cpp"
      var $2=$modulation_addr; //@line 1281 "klatt.cpp"
      var $3=$fr1_addr; //@line 1281 "klatt.cpp"
      var $4=$fr2_addr; //@line 1281 "klatt.cpp"
      var $5=HEAP32[((_wvoice)>>2)]; //@line 1281 "klatt.cpp"
      __Z14SetSynth_KlattiiP7frame_tS0_P7voice_ti($1, $2, $3, $4, $5, 1); //@line 1281 "klatt.cpp"
      ; //@line 1281 "klatt.cpp"
    }
  
    var $6=$resume_addr; //@line 1283 "klatt.cpp"
    var $call=__Z13Wavegen_Klatti($6); //@line 1283 "klatt.cpp"
    ;
    return $call; //@line 1283 "klatt.cpp"
    return null;
  }
  

  function __Z9KlattInitv() {
    ;
    var __label__;
  
    var $ix;
    HEAP32[((__ZL12sample_count)>>2)]=0; //@line 1309 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals)&4294967295))>>2)]=1; //@line 1311 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]=22050; //@line 1312 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]=1; //@line 1314 "klatt.cpp"
    var $0=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 1315 "klatt.cpp"
    var $arrayidx=((__ZL13scale_wav_tab+$0*4)&4294967295); //@line 1315 "klatt.cpp"
    var $1=HEAP32[(($arrayidx)>>2)]; //@line 1315 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+184)&4294967295))>>2)]=$1; //@line 1315 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]=((__ZZ9KlattInitvE15natural_samples)&4294967295); //@line 1316 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+160)&4294967295))>>2)]=100; //@line 1317 "klatt.cpp"
    HEAPF32[((((__ZL10kt_globals+164)&4294967295))>>2)]=3; //@line 1318 "klatt.cpp"
    var $2=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 1319 "klatt.cpp"
    var $mul=((($2)*10)&4294967295); //@line 1319 "klatt.cpp"
    var $div=((((($mul))|0)/1000)|0); //@line 1319 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+28)&4294967295))>>2)]=$div; //@line 1319 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+4)&4294967295))>>2)]=0; //@line 1320 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+24)&4294967295))>>2)]=20; //@line 1321 "klatt.cpp"
    __Z10KlattReseti(2); //@line 1323 "klatt.cpp"
    $ix=0; //@line 1326 "klatt.cpp"
    ; //@line 1326 "klatt.cpp"
    while(1) { 
  
      var $3=$ix; //@line 1328 "klatt.cpp"
      var $arrayidx1=((__ZZ9KlattInitvE10formant_hz+$3*2)&4294967295); //@line 1328 "klatt.cpp"
      var $4=HEAP16[(($arrayidx1)>>1)]; //@line 1328 "klatt.cpp"
      var $conv=(tempInt=(($4)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1328 "klatt.cpp"
      var $5=$ix; //@line 1328 "klatt.cpp"
      var $arrayidx2=((((__ZL8kt_frame+8)&4294967295)+$5*4)&4294967295); //@line 1328 "klatt.cpp"
      HEAP32[(($arrayidx2)>>2)]=$conv; //@line 1328 "klatt.cpp"
      var $6=$ix; //@line 1329 "klatt.cpp"
      var $arrayidx3=((__ZZ9KlattInitvE9bandwidth+$6*2)&4294967295); //@line 1329 "klatt.cpp"
      var $7=HEAP16[(($arrayidx3)>>1)]; //@line 1329 "klatt.cpp"
      var $conv4=(tempInt=(($7)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1329 "klatt.cpp"
      var $8=$ix; //@line 1329 "klatt.cpp"
      var $arrayidx5=((((__ZL8kt_frame+48)&4294967295)+$8*4)&4294967295); //@line 1329 "klatt.cpp"
      HEAP32[(($arrayidx5)>>2)]=$conv4; //@line 1329 "klatt.cpp"
      var $9=$ix; //@line 1330 "klatt.cpp"
      var $arrayidx6=((__ZZ9KlattInitvE12parallel_amp+$9*2)&4294967295); //@line 1330 "klatt.cpp"
      var $10=HEAP16[(($arrayidx6)>>1)]; //@line 1330 "klatt.cpp"
      var $conv7=(tempInt=(($10)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1330 "klatt.cpp"
      var $11=$ix; //@line 1330 "klatt.cpp"
      var $arrayidx8=((((__ZL8kt_frame+88)&4294967295)+$11*4)&4294967295); //@line 1330 "klatt.cpp"
      HEAP32[(($arrayidx8)>>2)]=$conv7; //@line 1330 "klatt.cpp"
      var $12=$ix; //@line 1331 "klatt.cpp"
      var $arrayidx9=((__ZZ9KlattInitvE11parallel_bw+$12*2)&4294967295); //@line 1331 "klatt.cpp"
      var $13=HEAP16[(($arrayidx9)>>1)]; //@line 1331 "klatt.cpp"
      var $conv10=(tempInt=(($13)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 1331 "klatt.cpp"
      var $14=$ix; //@line 1331 "klatt.cpp"
      var $arrayidx11=((((__ZL8kt_frame+128)&4294967295)+$14*4)&4294967295); //@line 1331 "klatt.cpp"
      HEAP32[(($arrayidx11)>>2)]=$conv10; //@line 1331 "klatt.cpp"
      var $15=$ix; //@line 1326 "klatt.cpp"
      var $inc=((($15)+1)&4294967295); //@line 1326 "klatt.cpp"
      $ix=$inc; //@line 1326 "klatt.cpp"
      var $cmp=((($inc))|0) <= 9; //@line 1326 "klatt.cpp"
      if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break ; } //@line 1326 "klatt.cpp"
    }
  
    HEAP32[((((__ZL8kt_frame+248)&4294967295))>>2)]=89; //@line 1333 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame)&4294967295))>>2)]=1000; //@line 1335 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+4)&4294967295))>>2)]=59; //@line 1336 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+168)&4294967295))>>2)]=0; //@line 1337 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+172)&4294967295))>>2)]=40; //@line 1338 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+176)&4294967295))>>2)]=0; //@line 1339 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+180)&4294967295))>>2)]=0; //@line 1340 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+184)&4294967295))>>2)]=50; //@line 1341 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+188)&4294967295))>>2)]=0; //@line 1342 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+192)&4294967295))>>2)]=0; //@line 1343 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+196)&4294967295))>>2)]=0; //@line 1344 "klatt.cpp"
    HEAP32[((((__ZL8kt_frame+200)&4294967295))>>2)]=62; //@line 1345 "klatt.cpp"
    ;
    return; //@line 1346 "klatt.cpp"
    return;
  }
  

  function __ZL7flutterP13klatt_frame_t($frame) {
    ;
    var __label__;
  
    var $frame_addr;
    var $delta_f0;
    var $fla;
    var $flb;
    var $flc;
    var $fld;
    var $fle;
    $frame_addr=$frame;
    var $0=HEAP32[((((__ZL10kt_globals+24)&4294967295))>>2)]; //@line 159 "klatt.cpp"
    var $conv=((($0))|0); //@line 159 "klatt.cpp"
    var $div=($conv)/50; //@line 159 "klatt.cpp"
    $fla=$div; //@line 159 "klatt.cpp"
    var $1=HEAP32[((((__ZL10kt_globals+176)&4294967295))>>2)]; //@line 160 "klatt.cpp"
    var $conv1=((($1))|0); //@line 160 "klatt.cpp"
    var $div2=($conv1)/100; //@line 160 "klatt.cpp"
    $flb=$div2; //@line 160 "klatt.cpp"
    var $2=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 164 "klatt.cpp"
    var $conv3=((($2))|0); //@line 164 "klatt.cpp"
    var $mul=39.898227289999994*($conv3); //@line 164 "klatt.cpp"
    var $call=_sin($mul); //@line 164 "klatt.cpp"
    $flc=$call; //@line 164 "klatt.cpp"
    var $3=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 165 "klatt.cpp"
    var $conv4=((($3))|0); //@line 165 "klatt.cpp"
    var $mul5=22.305308169999996*($conv4); //@line 165 "klatt.cpp"
    var $call6=_sin($mul5); //@line 165 "klatt.cpp"
    $fld=$call6; //@line 165 "klatt.cpp"
    var $4=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 166 "klatt.cpp"
    var $conv7=((($4))|0); //@line 166 "klatt.cpp"
    var $mul8=14.76548569*($conv7); //@line 166 "klatt.cpp"
    var $call9=_sin($mul8); //@line 166 "klatt.cpp"
    $fle=$call9; //@line 166 "klatt.cpp"
    var $5=$fla; //@line 167 "klatt.cpp"
    var $6=$flb; //@line 167 "klatt.cpp"
    var $mul10=($5)*($6); //@line 167 "klatt.cpp"
    var $7=$flc; //@line 167 "klatt.cpp"
    var $8=$fld; //@line 167 "klatt.cpp"
    var $add=($7)+($8); //@line 167 "klatt.cpp"
    var $9=$fle; //@line 167 "klatt.cpp"
    var $add11=($add)+($9); //@line 167 "klatt.cpp"
    var $mul12=($mul10)*($add11); //@line 167 "klatt.cpp"
    var $mul13=($mul12)*10; //@line 167 "klatt.cpp"
    $delta_f0=$mul13; //@line 167 "klatt.cpp"
    var $10=$frame_addr; //@line 168 "klatt.cpp"
    var $F0hz10=(($10)&4294967295); //@line 168 "klatt.cpp"
    var $11=HEAP32[(($F0hz10)>>2)]; //@line 168 "klatt.cpp"
    var $12=$delta_f0; //@line 168 "klatt.cpp"
    var $conv14=((($12))|0); //@line 168 "klatt.cpp"
    var $add15=((($conv14)+($11))&4294967295); //@line 168 "klatt.cpp"
    var $13=$frame_addr; //@line 168 "klatt.cpp"
    var $F0hz1016=(($13)&4294967295); //@line 168 "klatt.cpp"
    HEAP32[(($F0hz1016)>>2)]=$add15; //@line 168 "klatt.cpp"
    var $14=HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]; //@line 169 "klatt.cpp"
    var $inc=((($14)+1)&4294967295); //@line 169 "klatt.cpp"
    HEAP32[((__ZZL7flutterP13klatt_frame_tE10time_count)>>2)]=$inc; //@line 169 "klatt.cpp"
    ;
    return; //@line 170 "klatt.cpp"
    return;
  }
  

  function __ZL9gen_noised($noise) {
    ;
    var __label__;
  
    var $noise_addr;
    var $temp;
    $noise_addr=$noise;
    var $call=_rand(); //@line 928 "klatt.cpp"
    var $rem=((($call))|0)%16383; //@line 928 "klatt.cpp"
    var $add=((($rem)-8191)&4294967295); //@line 928 "klatt.cpp"
    $temp=$add; //@line 928 "klatt.cpp"
    var $0=$temp; //@line 929 "klatt.cpp"
    HEAP32[((((__ZL10kt_globals+52)&4294967295))>>2)]=$0; //@line 929 "klatt.cpp"
    var $1=HEAP32[((((__ZL10kt_globals+52)&4294967295))>>2)]; //@line 931 "klatt.cpp"
    var $conv=((($1))|0); //@line 931 "klatt.cpp"
    var $2=HEAPF32[((__ZZL9gen_noisedE5nlast)>>2)]; //@line 931 "klatt.cpp"
    var $mul=0.75*($2); //@line 931 "klatt.cpp"
    var $add1=($conv)+($mul); //@line 931 "klatt.cpp"
    $noise_addr=$add1; //@line 931 "klatt.cpp"
    var $3=$noise_addr; //@line 932 "klatt.cpp"
    HEAPF32[((__ZZL9gen_noisedE5nlast)>>2)]=$3; //@line 932 "klatt.cpp"
    var $4=$noise_addr; //@line 934 "klatt.cpp"
    ;
    return $4; //@line 934 "klatt.cpp"
    return null;
  }
  

  function __ZL16impulsive_sourcev() {
    ;
    var __label__;
  
    var $0=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 627 "klatt.cpp"
    var $cmp=((($0))|0) < 3; //@line 627 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 627 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 629 "klatt.cpp"
      var $arrayidx=((__ZZL16impulsive_sourcevE7doublet+$1*8)&4294967295); //@line 629 "klatt.cpp"
      var $2=HEAPF32[(($arrayidx)>>2)]; //@line 629 "klatt.cpp"
      HEAPF32[((__ZZL16impulsive_sourcevE5vwave)>>2)]=$2; //@line 629 "klatt.cpp"
      ; //@line 630 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      HEAPF32[((__ZZL16impulsive_sourcevE5vwave)>>2)]=0; //@line 633 "klatt.cpp"
      ;
    }
  
    var $3=HEAPF32[((__ZZL16impulsive_sourcevE5vwave)>>2)]; //@line 636 "klatt.cpp"
    var $call=__ZL9resonatorP11resonator_td(((__ZL10kt_globals+188+1088)&4294967295), $3); //@line 636 "klatt.cpp"
    ;
    return $call; //@line 636 "klatt.cpp"
    return null;
  }
  

  function __ZL14natural_sourcev() {
    ;
    var __label__;
  
    var $retval;
    var $lgtemp;
    var $0=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 653 "klatt.cpp"
    var $1=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 653 "klatt.cpp"
    var $cmp=((($0))|0) < ((($1))|0); //@line 653 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 653 "klatt.cpp"
    if (__label__ == 1) {
  
      var $2=HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]; //@line 655 "klatt.cpp"
      var $3=HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]; //@line 655 "klatt.cpp"
      var $sub=($3)-($2); //@line 655 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]=$sub; //@line 655 "klatt.cpp"
      var $4=HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]; //@line 656 "klatt.cpp"
      var $5=HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]; //@line 656 "klatt.cpp"
      var $add=($5)+($4); //@line 656 "klatt.cpp"
      HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]=$add; //@line 656 "klatt.cpp"
      var $6=HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]; //@line 657 "klatt.cpp"
      var $mul=($6)*0.028; //@line 657 "klatt.cpp"
      $lgtemp=$mul; //@line 657 "klatt.cpp"
      var $7=$lgtemp; //@line 659 "klatt.cpp"
      $retval=$7; //@line 659 "klatt.cpp"
      ; //@line 659 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      HEAPF32[((__ZZL14natural_sourcevE5vwave)>>2)]=0; //@line 663 "klatt.cpp"
      $retval=0; //@line 664 "klatt.cpp"
      ; //@line 664 "klatt.cpp"
    }
  
    var $8=$retval; //@line 666 "klatt.cpp"
    ;
    return $8; //@line 666 "klatt.cpp"
    return null;
  }
  

  function __ZL14sampled_sourcev() {
    ;
    var __label__;
  
    var $itemp;
    var $ftemp;
    var $result;
    var $diff_value;
    var $current_value;
    var $next_value;
    var $temp_diff;
    var $0=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 191 "klatt.cpp"
    var $cmp=((($0))|0)!=0; //@line 191 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 191 "klatt.cpp"
    if (__label__ == 1) {
  
      var $1=HEAP32[((((__ZL10kt_globals+32)&4294967295))>>2)]; //@line 193 "klatt.cpp"
      var $conv=((($1))|0); //@line 193 "klatt.cpp"
      $ftemp=$conv; //@line 193 "klatt.cpp"
      var $2=$ftemp; //@line 194 "klatt.cpp"
      var $3=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 194 "klatt.cpp"
      var $conv1=((($3))|0); //@line 194 "klatt.cpp"
      var $div=($2)/($conv1); //@line 194 "klatt.cpp"
      $ftemp=$div; //@line 194 "klatt.cpp"
      var $4=$ftemp; //@line 195 "klatt.cpp"
      var $5=HEAP32[((((__ZL10kt_globals+160)&4294967295))>>2)]; //@line 195 "klatt.cpp"
      var $conv2=((($5))|0); //@line 195 "klatt.cpp"
      var $mul=($4)*($conv2); //@line 195 "klatt.cpp"
      $ftemp=$mul; //@line 195 "klatt.cpp"
      var $6=$ftemp; //@line 196 "klatt.cpp"
      var $conv3=((($6))|0); //@line 196 "klatt.cpp"
      $itemp=$conv3; //@line 196 "klatt.cpp"
      var $7=$ftemp; //@line 198 "klatt.cpp"
      var $8=$itemp; //@line 198 "klatt.cpp"
      var $conv4=((($8))|0); //@line 198 "klatt.cpp"
      var $sub=($7)-($conv4); //@line 198 "klatt.cpp"
      $temp_diff=$sub; //@line 198 "klatt.cpp"
      var $9=$itemp; //@line 200 "klatt.cpp"
      var $10=HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]; //@line 200 "klatt.cpp"
      var $arrayidx=(($10+2*$9)&4294967295); //@line 200 "klatt.cpp"
      var $11=HEAP16[(($arrayidx)>>1)]; //@line 200 "klatt.cpp"
      var $conv5=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 200 "klatt.cpp"
      $current_value=$conv5; //@line 200 "klatt.cpp"
      var $12=$itemp; //@line 201 "klatt.cpp"
      var $add=((($12)+1)&4294967295); //@line 201 "klatt.cpp"
      var $13=HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]; //@line 201 "klatt.cpp"
      var $arrayidx6=(($13+2*$add)&4294967295); //@line 201 "klatt.cpp"
      var $14=HEAP16[(($arrayidx6)>>1)]; //@line 201 "klatt.cpp"
      var $conv7=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 201 "klatt.cpp"
      $next_value=$conv7; //@line 201 "klatt.cpp"
      var $15=$next_value; //@line 203 "klatt.cpp"
      var $conv8=((($15))|0); //@line 203 "klatt.cpp"
      var $16=$current_value; //@line 203 "klatt.cpp"
      var $conv9=((($16))|0); //@line 203 "klatt.cpp"
      var $sub10=($conv8)-($conv9); //@line 203 "klatt.cpp"
      $diff_value=$sub10; //@line 203 "klatt.cpp"
      var $17=$diff_value; //@line 204 "klatt.cpp"
      var $18=$temp_diff; //@line 204 "klatt.cpp"
      var $mul11=($17)*($18); //@line 204 "klatt.cpp"
      $diff_value=$mul11; //@line 204 "klatt.cpp"
      var $19=$itemp; //@line 206 "klatt.cpp"
      var $20=HEAP32[((((__ZL10kt_globals+172)&4294967295))>>2)]; //@line 206 "klatt.cpp"
      var $arrayidx12=(($20+2*$19)&4294967295); //@line 206 "klatt.cpp"
      var $21=HEAP16[(($arrayidx12)>>1)]; //@line 206 "klatt.cpp"
      var $conv13=(tempInt=(($21)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 206 "klatt.cpp"
      var $conv14=((($conv13))|0); //@line 206 "klatt.cpp"
      var $22=$diff_value; //@line 206 "klatt.cpp"
      var $add15=($conv14)+($22); //@line 206 "klatt.cpp"
      $result=$add15; //@line 206 "klatt.cpp"
      var $23=$result; //@line 207 "klatt.cpp"
      var $24=HEAPF32[((((__ZL10kt_globals+164)&4294967295))>>2)]; //@line 207 "klatt.cpp"
      var $mul16=($23)*($24); //@line 207 "klatt.cpp"
      $result=$mul16; //@line 207 "klatt.cpp"
      ; //@line 208 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      $result=0; //@line 211 "klatt.cpp"
      ;
    }
  
    var $25=$result; //@line 213 "klatt.cpp"
    ;
    return $25; //@line 213 "klatt.cpp"
    return null;
  }
  

  function __ZL21pitch_synch_par_resetP13klatt_frame_t($frame) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $frame_addr;
    var $temp;
    var $temp1;
    $frame_addr=$frame;
    var $0=$frame_addr; //@line 727 "klatt.cpp"
    var $F0hz10=(($0)&4294967295); //@line 727 "klatt.cpp"
    var $1=HEAP32[(($F0hz10)>>2)]; //@line 727 "klatt.cpp"
    var $cmp=((($1))|0) > 0; //@line 727 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 15;; } //@line 727 "klatt.cpp"
    if (__label__ == 1) {
  
      var $2=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 731 "klatt.cpp"
      var $mul=((($2)*40)&4294967295); //@line 731 "klatt.cpp"
      var $3=$frame_addr; //@line 731 "klatt.cpp"
      var $F0hz101=(($3)&4294967295); //@line 731 "klatt.cpp"
      var $4=HEAP32[(($F0hz101)>>2)]; //@line 731 "klatt.cpp"
      var $div=((((($mul))|0)/((($4))|0))|0); //@line 731 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=$div; //@line 731 "klatt.cpp"
      var $5=$frame_addr; //@line 734 "klatt.cpp"
      var $AVdb_tmp=(($5+204)&4294967295); //@line 734 "klatt.cpp"
      var $6=HEAP32[(($AVdb_tmp)>>2)]; //@line 734 "klatt.cpp"
      var $call=__ZL7DBtoLINl($6); //@line 734 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+112)&4294967295))>>2)]=$call; //@line 734 "klatt.cpp"
      var $7=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 738 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=$7; //@line 738 "klatt.cpp"
      var $8=$frame_addr; //@line 739 "klatt.cpp"
      var $AVdb_tmp2=(($8+204)&4294967295); //@line 739 "klatt.cpp"
      var $9=HEAP32[(($AVdb_tmp2)>>2)]; //@line 739 "klatt.cpp"
      var $cmp3=((($9))|0) > 0; //@line 739 "klatt.cpp"
      if ($cmp3) { __label__ = 2;; } else { __label__ = 3;; } //@line 739 "klatt.cpp"
      if (__label__ == 2) {
  
        var $10=HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]; //@line 741 "klatt.cpp"
        var $shr=($10) >> 1; //@line 741 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=$shr; //@line 741 "klatt.cpp"
        ; //@line 742 "klatt.cpp"
      }
  
      var $11=$frame_addr; //@line 746 "klatt.cpp"
      var $Aturb=(($11+176)&4294967295); //@line 746 "klatt.cpp"
      var $12=HEAP32[(($Aturb)>>2)]; //@line 746 "klatt.cpp"
      var $call5=__ZL7DBtoLINl($12); //@line 746 "klatt.cpp"
      var $mul6=($call5)*0.1; //@line 746 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+144)&4294967295))>>2)]=$mul6; //@line 746 "klatt.cpp"
      var $13=$frame_addr; //@line 750 "klatt.cpp"
      var $Kopen=(($13+172)&4294967295); //@line 750 "klatt.cpp"
      var $14=HEAP32[(($Kopen)>>2)]; //@line 750 "klatt.cpp"
      var $mul7=((($14)*4)&4294967295); //@line 750 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=$mul7; //@line 750 "klatt.cpp"
      var $15=HEAP32[((((__ZL10kt_globals+20)&4294967295))>>2)]; //@line 752 "klatt.cpp"
      var $cmp8=((($15))|0)==1; //@line 752 "klatt.cpp"
      var $16=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 752 "klatt.cpp"
      var $cmp9=((($16))|0) > 263; //@line 752 "klatt.cpp"
      var $or_cond=($cmp8) & ($cmp9); //@line 752 "klatt.cpp"
      if ($or_cond) { __label__ = 4;; } else { __label__ = 5;; } //@line 752 "klatt.cpp"
      if (__label__ == 4) {
  
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=263; //@line 754 "klatt.cpp"
        ; //@line 755 "klatt.cpp"
      }
  
      var $17=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 757 "klatt.cpp"
      var $18=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 757 "klatt.cpp"
      var $sub=((($18)-1)&4294967295); //@line 757 "klatt.cpp"
      var $cmp12=((($17))|0) >= ((($sub))|0); //@line 757 "klatt.cpp"
      if ($cmp12) { __lastLabel__ = 5; __label__ = 6;; } else { __lastLabel__ = 5; __label__ = 7;; } //@line 757 "klatt.cpp"
      if (__label__ == 6) {
  
        var $19=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 760 "klatt.cpp"
        var $sub14=((($19)-2)&4294967295); //@line 760 "klatt.cpp"
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=$sub14; //@line 760 "klatt.cpp"
        __lastLabel__ = 6; ; //@line 761 "klatt.cpp"
      }
  
      var $20=__lastLabel__ == 6 ? $sub14 : ($17); //@line 763 "klatt.cpp"
      var $cmp16=((($20))|0) < 40; //@line 763 "klatt.cpp"
      if ($cmp16) { __label__ = 8;; } else { __label__ = 9;; } //@line 763 "klatt.cpp"
      if (__label__ == 8) {
  
        HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]=40; //@line 768 "klatt.cpp"
        ; //@line 769 "klatt.cpp"
      }
  
      var $21=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 774 "klatt.cpp"
      var $sub19=((($21)-40)&4294967295); //@line 774 "klatt.cpp"
      var $arrayidx=((__ZZL21pitch_synch_par_resetP13klatt_frame_tE2B0+$sub19*2)&4294967295); //@line 774 "klatt.cpp"
      var $22=HEAP16[(($arrayidx)>>1)]; //@line 774 "klatt.cpp"
      var $conv=(tempInt=(($22)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 774 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]=$conv; //@line 774 "klatt.cpp"
      var $23=HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]; //@line 775 "klatt.cpp"
      var $24=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 775 "klatt.cpp"
      var $conv20=((($24))|0); //@line 775 "klatt.cpp"
      var $mul21=($23)*($conv20); //@line 775 "klatt.cpp"
      var $mul22=($mul21)*0.333; //@line 775 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]=$mul22; //@line 775 "klatt.cpp"
      var $25=HEAP32[((((__ZL10kt_globals+8)&4294967295))>>2)]; //@line 779 "klatt.cpp"
      var $26=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 779 "klatt.cpp"
      var $div23=((((($25))|0)/((($26))|0))|0); //@line 779 "klatt.cpp"
      $temp=$div23; //@line 779 "klatt.cpp"
      var $27=$temp; //@line 781 "klatt.cpp"
      __ZL6setabcllP11resonator_t(0, $27, ((__ZL10kt_globals+188+1088)&4294967295)); //@line 781 "klatt.cpp"
      var $28=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 785 "klatt.cpp"
      var $conv24=((($28))|0); //@line 785 "klatt.cpp"
      var $mul25=($conv24)*0.00833; //@line 785 "klatt.cpp"
      $temp1=$mul25; //@line 785 "klatt.cpp"
      var $29=$temp1; //@line 786 "klatt.cpp"
      var $30=$temp1; //@line 786 "klatt.cpp"
      var $mul26=($29)*($30); //@line 786 "klatt.cpp"
      var $31=HEAPF32[((((__ZL10kt_globals+188+1088)&4294967295))>>2)]; //@line 786 "klatt.cpp"
      var $mul27=($31)*($mul26); //@line 786 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+188+1088)&4294967295))>>2)]=$mul27; //@line 786 "klatt.cpp"
      var $32=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 794 "klatt.cpp"
      var $33=HEAP32[((((__ZL10kt_globals+44)&4294967295))>>2)]; //@line 794 "klatt.cpp"
      var $sub28=((($32)-($33))&4294967295); //@line 794 "klatt.cpp"
      $temp=$sub28; //@line 794 "klatt.cpp"
      var $34=$frame_addr; //@line 795 "klatt.cpp"
      var $Kskew=(($34+188)&4294967295); //@line 795 "klatt.cpp"
      var $35=HEAP32[(($Kskew)>>2)]; //@line 795 "klatt.cpp"
      var $36=$temp; //@line 795 "klatt.cpp"
      var $cmp29=((($35))|0) > ((($36))|0); //@line 795 "klatt.cpp"
      if ($cmp29) { __label__ = 10;; } else { __label__ = 11;; } //@line 795 "klatt.cpp"
      if (__label__ == 10) {
  
        var $37=$temp; //@line 798 "klatt.cpp"
        var $38=$frame_addr; //@line 798 "klatt.cpp"
        var $Kskew31=(($38+188)&4294967295); //@line 798 "klatt.cpp"
        HEAP32[(($Kskew31)>>2)]=$37; //@line 798 "klatt.cpp"
        ; //@line 799 "klatt.cpp"
      }
  
      var $39=HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]; //@line 800 "klatt.cpp"
      var $cmp33=((($39))|0) >= 0; //@line 800 "klatt.cpp"
      var $40=$frame_addr; //@line 802 "klatt.cpp"
      var $Kskew35=(($40+188)&4294967295); //@line 802 "klatt.cpp"
      var $41=HEAP32[(($Kskew35)>>2)]; //@line 802 "klatt.cpp"
      if ($cmp33) { __label__ = 12;; } else { __label__ = 13;; } //@line 800 "klatt.cpp"
      if (__label__ == 12) {
  
        HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]=$41; //@line 802 "klatt.cpp"
        ; //@line 803 "klatt.cpp"
      }
      else if (__label__ == 13) {
  
        var $sub37=(((-($41)))&4294967295); //@line 806 "klatt.cpp"
        HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]=$sub37; //@line 806 "klatt.cpp"
        ;
      }
  
      var $42=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 810 "klatt.cpp"
      var $43=HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]; //@line 810 "klatt.cpp"
      var $add=((($43)+($42))&4294967295); //@line 810 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=$add; //@line 810 "klatt.cpp"
      var $44=HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]; //@line 811 "klatt.cpp"
      var $sub39=(((-($44)))&4294967295); //@line 811 "klatt.cpp"
      HEAP32[((__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew)>>2)]=$sub39; //@line 811 "klatt.cpp"
      ; //@line 812 "klatt.cpp"
    }
    else if (__label__ == 15) {
  
      HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]=4; //@line 815 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+112)&4294967295))>>2)]=0; //@line 816 "klatt.cpp"
      var $45=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 817 "klatt.cpp"
      HEAP32[((((__ZL10kt_globals+48)&4294967295))>>2)]=$45; //@line 817 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+144)&4294967295))>>2)]=0; //@line 818 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+56)&4294967295))>>2)]=0; //@line 819 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+64)&4294967295))>>2)]=0; //@line 820 "klatt.cpp"
      ;
    }
  
    var $46=HEAP32[((((__ZL10kt_globals+40)&4294967295))>>2)]; //@line 825 "klatt.cpp"
    var $cmp42=((($46))|0)!=4; //@line 825 "klatt.cpp"
    var $47=HEAP32[((((__ZL10kt_globals+36)&4294967295))>>2)]; //@line 825 "klatt.cpp"
    var $cmp43=((($47))|0)==0; //@line 825 "klatt.cpp"
    var $or_cond1=($cmp42) | ($cmp43); //@line 825 "klatt.cpp"
    if ($or_cond1) { __label__ = 17;; } else { __label__ = 20;; } //@line 825 "klatt.cpp"
    if (__label__ == 17) {
  
      var $48=$frame_addr; //@line 829 "klatt.cpp"
      var $TLTdb=(($48+180)&4294967295); //@line 829 "klatt.cpp"
      var $49=HEAP32[(($TLTdb)>>2)]; //@line 829 "klatt.cpp"
      var $conv45=((($49))|0); //@line 829 "klatt.cpp"
      var $mul46=0.033*($conv45); //@line 829 "klatt.cpp"
      HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]=$mul46; //@line 829 "klatt.cpp"
      var $50=HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]; //@line 831 "klatt.cpp"
      var $cmp47=($50) > 0; //@line 831 "klatt.cpp"
      if ($cmp47) { __label__ = 18;; } else { __label__ = 19;; } //@line 831 "klatt.cpp"
      if (__label__ == 18) {
  
        var $51=HEAPF32[((((__ZL10kt_globals+96)&4294967295))>>2)]; //@line 833 "klatt.cpp"
        var $sub49=1-($51); //@line 833 "klatt.cpp"
        HEAPF32[((((__ZL10kt_globals+88)&4294967295))>>2)]=$sub49; //@line 833 "klatt.cpp"
        ; //@line 834 "klatt.cpp"
      }
      else if (__label__ == 19) {
  
        HEAPF32[((((__ZL10kt_globals+88)&4294967295))>>2)]=1; //@line 837 "klatt.cpp"
        ;
      }
    }
  
    ;
    return; //@line 840 "klatt.cpp"
    return;
  }
  

  function __ZL9resonatorP11resonator_td($r, $input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=$r;
    $input_addr=$input;
    var $0=$r_addr; //@line 85 "klatt.cpp"
    var $a=(($0)&4294967295); //@line 85 "klatt.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 85 "klatt.cpp"
    var $2=$input_addr; //@line 85 "klatt.cpp"
    var $mul=($1)*($2); //@line 85 "klatt.cpp"
    var $3=$r_addr; //@line 85 "klatt.cpp"
    var $b=(($3+8)&4294967295); //@line 85 "klatt.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 85 "klatt.cpp"
    var $5=$r_addr; //@line 85 "klatt.cpp"
    var $p1=(($5+24)&4294967295); //@line 85 "klatt.cpp"
    var $6=HEAPF32[(($p1)>>2)]; //@line 85 "klatt.cpp"
    var $mul1=($4)*($6); //@line 85 "klatt.cpp"
    var $add=($mul)+($mul1); //@line 85 "klatt.cpp"
    var $7=$r_addr; //@line 85 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 85 "klatt.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 85 "klatt.cpp"
    var $9=$r_addr; //@line 85 "klatt.cpp"
    var $p2=(($9+32)&4294967295); //@line 85 "klatt.cpp"
    var $10=HEAPF32[(($p2)>>2)]; //@line 85 "klatt.cpp"
    var $mul2=($8)*($10); //@line 85 "klatt.cpp"
    var $add3=($add)+($mul2); //@line 85 "klatt.cpp"
    $x=$add3; //@line 85 "klatt.cpp"
    var $11=$r_addr; //@line 86 "klatt.cpp"
    var $p14=(($11+24)&4294967295); //@line 86 "klatt.cpp"
    var $12=HEAPF32[(($p14)>>2)]; //@line 86 "klatt.cpp"
    var $13=$r_addr; //@line 86 "klatt.cpp"
    var $p25=(($13+32)&4294967295); //@line 86 "klatt.cpp"
    HEAPF32[(($p25)>>2)]=$12; //@line 86 "klatt.cpp"
    var $14=$x; //@line 87 "klatt.cpp"
    var $15=$r_addr; //@line 87 "klatt.cpp"
    var $p16=(($15+24)&4294967295); //@line 87 "klatt.cpp"
    HEAPF32[(($p16)>>2)]=$14; //@line 87 "klatt.cpp"
    var $16=$x; //@line 89 "klatt.cpp"
    ;
    return $16; //@line 89 "klatt.cpp"
    return null;
  }
  

  function __ZL14antiresonator2P11resonator_td($input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=((__ZL10kt_globals+188)&4294967295);
    $input_addr=$input;
    var $0=$r_addr; //@line 129 "klatt.cpp"
    var $a=(($0)&4294967295); //@line 129 "klatt.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 129 "klatt.cpp"
    var $2=$input_addr; //@line 129 "klatt.cpp"
    var $mul=($1)*($2); //@line 129 "klatt.cpp"
    var $3=$r_addr; //@line 129 "klatt.cpp"
    var $b=(($3+8)&4294967295); //@line 129 "klatt.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 129 "klatt.cpp"
    var $5=$r_addr; //@line 129 "klatt.cpp"
    var $p1=(($5+24)&4294967295); //@line 129 "klatt.cpp"
    var $6=HEAPF32[(($p1)>>2)]; //@line 129 "klatt.cpp"
    var $mul1=($4)*($6); //@line 129 "klatt.cpp"
    var $add=($mul)+($mul1); //@line 129 "klatt.cpp"
    var $7=$r_addr; //@line 129 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 129 "klatt.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 129 "klatt.cpp"
    var $9=$r_addr; //@line 129 "klatt.cpp"
    var $p2=(($9+32)&4294967295); //@line 129 "klatt.cpp"
    var $10=HEAPF32[(($p2)>>2)]; //@line 129 "klatt.cpp"
    var $mul2=($8)*($10); //@line 129 "klatt.cpp"
    var $add3=($add)+($mul2); //@line 129 "klatt.cpp"
    $x=$add3; //@line 129 "klatt.cpp"
    var $11=$r_addr; //@line 130 "klatt.cpp"
    var $p14=(($11+24)&4294967295); //@line 130 "klatt.cpp"
    var $12=HEAPF32[(($p14)>>2)]; //@line 130 "klatt.cpp"
    var $13=$r_addr; //@line 130 "klatt.cpp"
    var $p25=(($13+32)&4294967295); //@line 130 "klatt.cpp"
    HEAPF32[(($p25)>>2)]=$12; //@line 130 "klatt.cpp"
    var $14=$input_addr; //@line 131 "klatt.cpp"
    var $15=$r_addr; //@line 131 "klatt.cpp"
    var $p16=(($15+24)&4294967295); //@line 131 "klatt.cpp"
    HEAPF32[(($p16)>>2)]=$14; //@line 131 "klatt.cpp"
    var $16=$r_addr; //@line 133 "klatt.cpp"
    var $a_inc=(($16+40)&4294967295); //@line 133 "klatt.cpp"
    var $17=HEAPF32[(($a_inc)>>2)]; //@line 133 "klatt.cpp"
    var $18=$r_addr; //@line 133 "klatt.cpp"
    var $a7=(($18)&4294967295); //@line 133 "klatt.cpp"
    var $19=HEAPF32[(($a7)>>2)]; //@line 133 "klatt.cpp"
    var $add8=($19)+($17); //@line 133 "klatt.cpp"
    HEAPF32[(($a7)>>2)]=$add8; //@line 133 "klatt.cpp"
    var $20=$r_addr; //@line 134 "klatt.cpp"
    var $b_inc=(($20+48)&4294967295); //@line 134 "klatt.cpp"
    var $21=HEAPF32[(($b_inc)>>2)]; //@line 134 "klatt.cpp"
    var $22=$r_addr; //@line 134 "klatt.cpp"
    var $b9=(($22+8)&4294967295); //@line 134 "klatt.cpp"
    var $23=HEAPF32[(($b9)>>2)]; //@line 134 "klatt.cpp"
    var $add10=($23)+($21); //@line 134 "klatt.cpp"
    HEAPF32[(($b9)>>2)]=$add10; //@line 134 "klatt.cpp"
    var $24=$r_addr; //@line 135 "klatt.cpp"
    var $c_inc=(($24+56)&4294967295); //@line 135 "klatt.cpp"
    var $25=HEAPF32[(($c_inc)>>2)]; //@line 135 "klatt.cpp"
    var $26=$r_addr; //@line 135 "klatt.cpp"
    var $c11=(($26+16)&4294967295); //@line 135 "klatt.cpp"
    var $27=HEAPF32[(($c11)>>2)]; //@line 135 "klatt.cpp"
    var $add12=($27)+($25); //@line 135 "klatt.cpp"
    HEAPF32[(($c11)>>2)]=$add12; //@line 135 "klatt.cpp"
    var $28=$x; //@line 136 "klatt.cpp"
    ;
    return $28; //@line 136 "klatt.cpp"
    return null;
  }
  

  function __ZL10resonator2P11resonator_td($r, $input) {
    ;
    var __label__;
  
    var $r_addr;
    var $input_addr;
    var $x;
    $r_addr=$r;
    $input_addr=$input;
    var $0=$r_addr; //@line 96 "klatt.cpp"
    var $a=(($0)&4294967295); //@line 96 "klatt.cpp"
    var $1=HEAPF32[(($a)>>2)]; //@line 96 "klatt.cpp"
    var $2=$input_addr; //@line 96 "klatt.cpp"
    var $mul=($1)*($2); //@line 96 "klatt.cpp"
    var $3=$r_addr; //@line 96 "klatt.cpp"
    var $b=(($3+8)&4294967295); //@line 96 "klatt.cpp"
    var $4=HEAPF32[(($b)>>2)]; //@line 96 "klatt.cpp"
    var $5=$r_addr; //@line 96 "klatt.cpp"
    var $p1=(($5+24)&4294967295); //@line 96 "klatt.cpp"
    var $6=HEAPF32[(($p1)>>2)]; //@line 96 "klatt.cpp"
    var $mul1=($4)*($6); //@line 96 "klatt.cpp"
    var $add=($mul)+($mul1); //@line 96 "klatt.cpp"
    var $7=$r_addr; //@line 96 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 96 "klatt.cpp"
    var $8=HEAPF32[(($c)>>2)]; //@line 96 "klatt.cpp"
    var $9=$r_addr; //@line 96 "klatt.cpp"
    var $p2=(($9+32)&4294967295); //@line 96 "klatt.cpp"
    var $10=HEAPF32[(($p2)>>2)]; //@line 96 "klatt.cpp"
    var $mul2=($8)*($10); //@line 96 "klatt.cpp"
    var $add3=($add)+($mul2); //@line 96 "klatt.cpp"
    $x=$add3; //@line 96 "klatt.cpp"
    var $11=$r_addr; //@line 97 "klatt.cpp"
    var $p14=(($11+24)&4294967295); //@line 97 "klatt.cpp"
    var $12=HEAPF32[(($p14)>>2)]; //@line 97 "klatt.cpp"
    var $13=$r_addr; //@line 97 "klatt.cpp"
    var $p25=(($13+32)&4294967295); //@line 97 "klatt.cpp"
    HEAPF32[(($p25)>>2)]=$12; //@line 97 "klatt.cpp"
    var $14=$x; //@line 98 "klatt.cpp"
    var $15=$r_addr; //@line 98 "klatt.cpp"
    var $p16=(($15+24)&4294967295); //@line 98 "klatt.cpp"
    HEAPF32[(($p16)>>2)]=$14; //@line 98 "klatt.cpp"
    var $16=$r_addr; //@line 100 "klatt.cpp"
    var $a_inc=(($16+40)&4294967295); //@line 100 "klatt.cpp"
    var $17=HEAPF32[(($a_inc)>>2)]; //@line 100 "klatt.cpp"
    var $18=$r_addr; //@line 100 "klatt.cpp"
    var $a7=(($18)&4294967295); //@line 100 "klatt.cpp"
    var $19=HEAPF32[(($a7)>>2)]; //@line 100 "klatt.cpp"
    var $add8=($19)+($17); //@line 100 "klatt.cpp"
    HEAPF32[(($a7)>>2)]=$add8; //@line 100 "klatt.cpp"
    var $20=$r_addr; //@line 101 "klatt.cpp"
    var $b_inc=(($20+48)&4294967295); //@line 101 "klatt.cpp"
    var $21=HEAPF32[(($b_inc)>>2)]; //@line 101 "klatt.cpp"
    var $22=$r_addr; //@line 101 "klatt.cpp"
    var $b9=(($22+8)&4294967295); //@line 101 "klatt.cpp"
    var $23=HEAPF32[(($b9)>>2)]; //@line 101 "klatt.cpp"
    var $add10=($23)+($21); //@line 101 "klatt.cpp"
    HEAPF32[(($b9)>>2)]=$add10; //@line 101 "klatt.cpp"
    var $24=$r_addr; //@line 102 "klatt.cpp"
    var $c_inc=(($24+56)&4294967295); //@line 102 "klatt.cpp"
    var $25=HEAPF32[(($c_inc)>>2)]; //@line 102 "klatt.cpp"
    var $26=$r_addr; //@line 102 "klatt.cpp"
    var $c11=(($26+16)&4294967295); //@line 102 "klatt.cpp"
    var $27=HEAPF32[(($c11)>>2)]; //@line 102 "klatt.cpp"
    var $add12=($27)+($25); //@line 102 "klatt.cpp"
    HEAPF32[(($c11)>>2)]=$add12; //@line 102 "klatt.cpp"
    var $28=$x; //@line 103 "klatt.cpp"
    ;
    return $28; //@line 103 "klatt.cpp"
    return null;
  }
  

  function __ZL7DBtoLINl($dB) {
    ;
    var __label__;
  
    var $retval;
    var $dB_addr;
    $dB_addr=$dB;
    var $0=$dB_addr; //@line 971 "klatt.cpp"
    var $cmp=((($0))|0) < 0; //@line 971 "klatt.cpp"
    var $1=$dB_addr; //@line 971 "klatt.cpp"
    var $cmp1=((($1))|0) > 87; //@line 971 "klatt.cpp"
    var $or_cond=($cmp) | ($cmp1); //@line 971 "klatt.cpp"
    if ($or_cond) { __label__ = 1;; } else { __label__ = 2;; } //@line 971 "klatt.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 973 "klatt.cpp"
      ; //@line 973 "klatt.cpp"
    }
    else if (__label__ == 2) {
  
      var $2=$dB_addr; //@line 976 "klatt.cpp"
      var $arrayidx=((__ZZL7DBtoLINlE8amptable+$2*2)&4294967295); //@line 976 "klatt.cpp"
      var $3=HEAP16[(($arrayidx)>>1)]; //@line 976 "klatt.cpp"
      var $conv=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 976 "klatt.cpp"
      var $mul=($conv)*0.001; //@line 976 "klatt.cpp"
      $retval=$mul; //@line 976 "klatt.cpp"
      ; //@line 976 "klatt.cpp"
    }
  
    var $4=$retval; //@line 977 "klatt.cpp"
    ;
    return $4; //@line 977 "klatt.cpp"
    return null;
  }
  

  function __ZL10setzeroabcllP11resonator_t($f, $bw, $rp) {
    ;
    var __label__;
  
    var $f_addr;
    var $bw_addr;
    var $rp_addr;
    var $r;
    var $arg;
    $f_addr=$f;
    $bw_addr=$bw;
    $rp_addr=$rp;
    var $0=$f_addr; //@line 885 "klatt.cpp"
    var $sub=(((-($0)))&4294967295); //@line 885 "klatt.cpp"
    $f_addr=$sub; //@line 885 "klatt.cpp"
    var $1=$f_addr; //@line 887 "klatt.cpp"
    var $cmp=((($1))|0) >= 0; //@line 887 "klatt.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 887 "klatt.cpp"
    if (__label__ == 1) {
  
      $f_addr=-1; //@line 889 "klatt.cpp"
      ; //@line 890 "klatt.cpp"
    }
  
    var $2=HEAPF32[((((__ZL10kt_globals+72)&4294967295))>>2)]; //@line 894 "klatt.cpp"
    var $3=$bw_addr; //@line 894 "klatt.cpp"
    var $conv=((($3))|0); //@line 894 "klatt.cpp"
    var $mul=($2)*($conv); //@line 894 "klatt.cpp"
    $arg=$mul; //@line 894 "klatt.cpp"
    var $4=$arg; //@line 895 "klatt.cpp"
    var $call=_exp($4); //@line 895 "klatt.cpp"
    $r=$call; //@line 895 "klatt.cpp"
    var $5=$r; //@line 898 "klatt.cpp"
    var $6=$r; //@line 898 "klatt.cpp"
    var $mul1=($5)*($6); //@line 898 "klatt.cpp"
    var $sub2=(-($mul1)); //@line 898 "klatt.cpp"
    var $7=$rp_addr; //@line 898 "klatt.cpp"
    var $c=(($7+16)&4294967295); //@line 898 "klatt.cpp"
    HEAPF32[(($c)>>2)]=$sub2; //@line 898 "klatt.cpp"
    var $8=HEAPF32[((((__ZL10kt_globals+80)&4294967295))>>2)]; //@line 901 "klatt.cpp"
    var $9=$f_addr; //@line 901 "klatt.cpp"
    var $conv3=((($9))|0); //@line 901 "klatt.cpp"
    var $mul4=($8)*($conv3); //@line 901 "klatt.cpp"
    $arg=$mul4; //@line 901 "klatt.cpp"
    var $10=$r; //@line 902 "klatt.cpp"
    var $11=$arg; //@line 902 "klatt.cpp"
    var $call5=_cos($11); //@line 902 "klatt.cpp"
    var $mul6=($10)*($call5); //@line 902 "klatt.cpp"
    var $mul7=($mul6)*2; //@line 902 "klatt.cpp"
    var $12=$rp_addr; //@line 902 "klatt.cpp"
    var $b=(($12+8)&4294967295); //@line 902 "klatt.cpp"
    HEAPF32[(($b)>>2)]=$mul7; //@line 902 "klatt.cpp"
    var $13=$rp_addr; //@line 905 "klatt.cpp"
    var $b8=(($13+8)&4294967295); //@line 905 "klatt.cpp"
    var $14=HEAPF32[(($b8)>>2)]; //@line 905 "klatt.cpp"
    var $sub9=1-($14); //@line 905 "klatt.cpp"
    var $15=$rp_addr; //@line 905 "klatt.cpp"
    var $c10=(($15+16)&4294967295); //@line 905 "klatt.cpp"
    var $16=HEAPF32[(($c10)>>2)]; //@line 905 "klatt.cpp"
    var $sub11=($sub9)-($16); //@line 905 "klatt.cpp"
    var $17=$rp_addr; //@line 905 "klatt.cpp"
    var $a=(($17)&4294967295); //@line 905 "klatt.cpp"
    HEAPF32[(($a)>>2)]=$sub11; //@line 905 "klatt.cpp"
    var $18=$rp_addr; //@line 908 "klatt.cpp"
    var $a12=(($18)&4294967295); //@line 908 "klatt.cpp"
    var $19=HEAPF32[(($a12)>>2)]; //@line 908 "klatt.cpp"
    var $div=1/($19); //@line 908 "klatt.cpp"
    var $20=$rp_addr; //@line 908 "klatt.cpp"
    var $a13=(($20)&4294967295); //@line 908 "klatt.cpp"
    HEAPF32[(($a13)>>2)]=$div; //@line 908 "klatt.cpp"
    var $21=$rp_addr; //@line 909 "klatt.cpp"
    var $a14=(($21)&4294967295); //@line 909 "klatt.cpp"
    var $22=HEAPF32[(($a14)>>2)]; //@line 909 "klatt.cpp"
    var $sub15=(-($22)); //@line 909 "klatt.cpp"
    var $23=$rp_addr; //@line 909 "klatt.cpp"
    var $c16=(($23+16)&4294967295); //@line 909 "klatt.cpp"
    var $24=HEAPF32[(($c16)>>2)]; //@line 909 "klatt.cpp"
    var $mul17=($24)*($sub15); //@line 909 "klatt.cpp"
    HEAPF32[(($c16)>>2)]=$mul17; //@line 909 "klatt.cpp"
    var $25=$rp_addr; //@line 910 "klatt.cpp"
    var $a18=(($25)&4294967295); //@line 910 "klatt.cpp"
    var $26=HEAPF32[(($a18)>>2)]; //@line 910 "klatt.cpp"
    var $sub19=(-($26)); //@line 910 "klatt.cpp"
    var $27=$rp_addr; //@line 910 "klatt.cpp"
    var $b20=(($27+8)&4294967295); //@line 910 "klatt.cpp"
    var $28=HEAPF32[(($b20)>>2)]; //@line 910 "klatt.cpp"
    var $mul21=($28)*($sub19); //@line 910 "klatt.cpp"
    HEAPF32[(($b20)>>2)]=$mul21; //@line 910 "klatt.cpp"
    ;
    return; //@line 911 "klatt.cpp"
    return;
  }
  

  function __Z8sonicMSGPcz($format) {
    var __stackBase__  = STACKTOP; STACKTOP += 4100; _memset(__stackBase__, 0, 4100);
    var __label__;
  
    var $format_addr;
    var $buffer=__stackBase__;
    var $ap=__stackBase__+4096;
    var $file;
    $format_addr=$format;
    var $ap1=$ap; //@line 61 "sonic.cpp"
    HEAP32[(($ap1)>>2)]=arguments[__Z8sonicMSGPcz.length];; //@line 61 "sonic.cpp"
    var $arraydecay=(($buffer)&4294967295); //@line 62 "sonic.cpp"
    var $0=$format_addr; //@line 62 "sonic.cpp"
    var $1=HEAP32[(($ap)>>2)]; //@line 62 "sonic.cpp"
    var $call=_vsprintf($arraydecay, $0, $1); //@line 62 "sonic.cpp"
    var $ap2=$ap; //@line 63 "sonic.cpp"
    ; //@line 63 "sonic.cpp"
    var $call3=_fopen(((__str810)&4294967295), ((__str1811)&4294967295)); //@line 64 "sonic.cpp"
    $file=$call3; //@line 64 "sonic.cpp"
    var $2=$file; //@line 65 "sonic.cpp"
    var $arraydecay4=(($buffer)&4294967295); //@line 65 "sonic.cpp"
    var $fputs=_fputs($arraydecay4, $2); //@line 65 "sonic.cpp"
    var $3=$file; //@line 66 "sonic.cpp"
    var $call6=_fclose($3); //@line 66 "sonic.cpp"
    STACKTOP = __stackBase__;
    return; //@line 67 "sonic.cpp"
    return;
  }
  

  function _sonicGetSpeed($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 93 "sonic.cpp"
    var $speed=(($0+16)&4294967295); //@line 93 "sonic.cpp"
    var $1=HEAPF32[(($speed)>>2)]; //@line 93 "sonic.cpp"
    ;
    return $1; //@line 93 "sonic.cpp"
    return null;
  }
  

  function _sonicSetSpeed($stream, $speed) {
    ;
    var __label__;
  
    var $stream_addr;
    var $speed_addr;
    $stream_addr=$stream;
    $speed_addr=$speed;
    var $0=$speed_addr; //@line 101 "sonic.cpp"
    var $1=$stream_addr; //@line 101 "sonic.cpp"
    var $speed1=(($1+16)&4294967295); //@line 101 "sonic.cpp"
    HEAPF32[(($speed1)>>2)]=$0; //@line 101 "sonic.cpp"
    ;
    return; //@line 102 "sonic.cpp"
    return;
  }
  

  function _sonicGetPitch($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 108 "sonic.cpp"
    var $pitch=(($0+24)&4294967295); //@line 108 "sonic.cpp"
    var $1=HEAPF32[(($pitch)>>2)]; //@line 108 "sonic.cpp"
    ;
    return $1; //@line 108 "sonic.cpp"
    return null;
  }
  

  function _sonicSetPitch($stream, $pitch) {
    ;
    var __label__;
  
    var $stream_addr;
    var $pitch_addr;
    $stream_addr=$stream;
    $pitch_addr=$pitch;
    var $0=$pitch_addr; //@line 116 "sonic.cpp"
    var $1=$stream_addr; //@line 116 "sonic.cpp"
    var $pitch1=(($1+24)&4294967295); //@line 116 "sonic.cpp"
    HEAPF32[(($pitch1)>>2)]=$0; //@line 116 "sonic.cpp"
    ;
    return; //@line 117 "sonic.cpp"
    return;
  }
  

  function _sonicGetVolume($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 123 "sonic.cpp"
    var $volume=(($0+20)&4294967295); //@line 123 "sonic.cpp"
    var $1=HEAPF32[(($volume)>>2)]; //@line 123 "sonic.cpp"
    ;
    return $1; //@line 123 "sonic.cpp"
    return null;
  }
  

  function _sonicSetVolume($stream, $volume) {
    ;
    var __label__;
  
    var $stream_addr;
    var $volume_addr;
    $stream_addr=$stream;
    $volume_addr=$volume;
    var $0=$volume_addr; //@line 131 "sonic.cpp"
    var $1=$stream_addr; //@line 131 "sonic.cpp"
    var $volume1=(($1+20)&4294967295); //@line 131 "sonic.cpp"
    HEAPF32[(($volume1)>>2)]=$0; //@line 131 "sonic.cpp"
    ;
    return; //@line 132 "sonic.cpp"
    return;
  }
  

  function _sonicGetSampleRate($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 138 "sonic.cpp"
    var $sampleRate=(($0+72)&4294967295); //@line 138 "sonic.cpp"
    var $1=HEAP32[(($sampleRate)>>2)]; //@line 138 "sonic.cpp"
    ;
    return $1; //@line 138 "sonic.cpp"
    return null;
  }
  

  function _sonicGetNumChannels($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 145 "sonic.cpp"
    var $numChannels=(($0+28)&4294967295); //@line 145 "sonic.cpp"
    var $1=HEAP32[(($numChannels)>>2)]; //@line 145 "sonic.cpp"
    ;
    return $1; //@line 145 "sonic.cpp"
    return null;
  }
  

  function _sonicDestroyStream($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 152 "sonic.cpp"
    var $inputBuffer=(($0)&4294967295); //@line 152 "sonic.cpp"
    var $1=HEAP32[(($inputBuffer)>>2)]; //@line 152 "sonic.cpp"
    var $cmp=((($1))|0)!=0; //@line 152 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 152 "sonic.cpp"
    if (__label__ == 1) {
  
      var $2=$stream_addr; //@line 153 "sonic.cpp"
      var $inputBuffer1=(($2)&4294967295); //@line 153 "sonic.cpp"
      var $3=HEAP32[(($inputBuffer1)>>2)]; //@line 153 "sonic.cpp"
      var $4=$3; //@line 153 "sonic.cpp"
      ; //@line 153 "sonic.cpp"
      ; //@line 154 "sonic.cpp"
    }
  
    var $5=$stream_addr; //@line 155 "sonic.cpp"
    var $outputBuffer=(($5+4)&4294967295); //@line 155 "sonic.cpp"
    var $6=HEAP32[(($outputBuffer)>>2)]; //@line 155 "sonic.cpp"
    var $cmp2=((($6))|0)!=0; //@line 155 "sonic.cpp"
    if ($cmp2) { __label__ = 3;; } else { __label__ = 4;; } //@line 155 "sonic.cpp"
    if (__label__ == 3) {
  
      var $7=$stream_addr; //@line 156 "sonic.cpp"
      var $outputBuffer4=(($7+4)&4294967295); //@line 156 "sonic.cpp"
      var $8=HEAP32[(($outputBuffer4)>>2)]; //@line 156 "sonic.cpp"
      var $9=$8; //@line 156 "sonic.cpp"
      ; //@line 156 "sonic.cpp"
      ; //@line 157 "sonic.cpp"
    }
  
    var $10=$stream_addr; //@line 158 "sonic.cpp"
    var $pitchBuffer=(($10+8)&4294967295); //@line 158 "sonic.cpp"
    var $11=HEAP32[(($pitchBuffer)>>2)]; //@line 158 "sonic.cpp"
    var $cmp6=((($11))|0)!=0; //@line 158 "sonic.cpp"
    if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 158 "sonic.cpp"
    if (__label__ == 5) {
  
      var $12=$stream_addr; //@line 159 "sonic.cpp"
      var $pitchBuffer8=(($12+8)&4294967295); //@line 159 "sonic.cpp"
      var $13=HEAP32[(($pitchBuffer8)>>2)]; //@line 159 "sonic.cpp"
      var $14=$13; //@line 159 "sonic.cpp"
      ; //@line 159 "sonic.cpp"
      ; //@line 160 "sonic.cpp"
    }
  
    var $15=$stream_addr; //@line 161 "sonic.cpp"
    var $downSampleBuffer=(($15+12)&4294967295); //@line 161 "sonic.cpp"
    var $16=HEAP32[(($downSampleBuffer)>>2)]; //@line 161 "sonic.cpp"
    var $cmp10=((($16))|0)!=0; //@line 161 "sonic.cpp"
    if ($cmp10) { __label__ = 7;; } else { __label__ = 8;; } //@line 161 "sonic.cpp"
    if (__label__ == 7) {
  
      var $17=$stream_addr; //@line 162 "sonic.cpp"
      var $downSampleBuffer12=(($17+12)&4294967295); //@line 162 "sonic.cpp"
      var $18=HEAP32[(($downSampleBuffer12)>>2)]; //@line 162 "sonic.cpp"
      var $19=$18; //@line 162 "sonic.cpp"
      ; //@line 162 "sonic.cpp"
      ; //@line 163 "sonic.cpp"
    }
  
    var $20=$stream_addr; //@line 164 "sonic.cpp"
    var $21=$20; //@line 164 "sonic.cpp"
    ; //@line 164 "sonic.cpp"
    ;
    return; //@line 165 "sonic.cpp"
    return;
  }
  

  function _sonicCreateStream($sampleRate, $numChannels) {
    ;
    var __label__;
  
    var $retval;
    var $sampleRate_addr;
    var $numChannels_addr;
    var $stream;
    var $minPeriod;
    var $maxPeriod;
    var $maxRequired;
    $sampleRate_addr=$sampleRate;
    $numChannels_addr=$numChannels;
    var $call=_calloc(1, 88); //@line 173 "sonic.cpp"
    var $0=$call; //@line 173 "sonic.cpp"
    $stream=$0; //@line 173 "sonic.cpp"
    var $1=$sampleRate_addr; //@line 174 "sonic.cpp"
    var $div=((((($1))|0)/400)|0); //@line 174 "sonic.cpp"
    $minPeriod=$div; //@line 174 "sonic.cpp"
    var $2=$sampleRate_addr; //@line 175 "sonic.cpp"
    var $div1=((((($2))|0)/65)|0); //@line 175 "sonic.cpp"
    $maxPeriod=$div1; //@line 175 "sonic.cpp"
    var $3=$maxPeriod; //@line 176 "sonic.cpp"
    var $mul=((($3)*2)&4294967295); //@line 176 "sonic.cpp"
    $maxRequired=$mul; //@line 176 "sonic.cpp"
    var $4=$stream; //@line 178 "sonic.cpp"
    var $cmp=((($4))|0)==0; //@line 178 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 178 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 179 "sonic.cpp"
      ; //@line 179 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $5=$maxRequired; //@line 181 "sonic.cpp"
      var $6=$stream; //@line 181 "sonic.cpp"
      var $inputBufferSize=(($6+32)&4294967295); //@line 181 "sonic.cpp"
      HEAP32[(($inputBufferSize)>>2)]=$5; //@line 181 "sonic.cpp"
      var $7=$maxRequired; //@line 182 "sonic.cpp"
      var $8=$numChannels_addr; //@line 182 "sonic.cpp"
      var $mul2=((($8)*2)&4294967295); //@line 182 "sonic.cpp"
      var $call3=_calloc($7, $mul2); //@line 182 "sonic.cpp"
      var $9=$call3; //@line 182 "sonic.cpp"
      var $10=$stream; //@line 182 "sonic.cpp"
      var $inputBuffer=(($10)&4294967295); //@line 182 "sonic.cpp"
      HEAP32[(($inputBuffer)>>2)]=$9; //@line 182 "sonic.cpp"
      var $11=$stream; //@line 183 "sonic.cpp"
      var $inputBuffer4=(($11)&4294967295); //@line 183 "sonic.cpp"
      var $12=HEAP32[(($inputBuffer4)>>2)]; //@line 183 "sonic.cpp"
      var $cmp5=((($12))|0)==0; //@line 183 "sonic.cpp"
      if ($cmp5) { __label__ = 3;; } else { __label__ = 4;; } //@line 183 "sonic.cpp"
      if (__label__ == 3) {
  
        var $13=$stream; //@line 184 "sonic.cpp"
        _sonicDestroyStream($13); //@line 184 "sonic.cpp"
        $retval=0; //@line 185 "sonic.cpp"
        ; //@line 185 "sonic.cpp"
      }
      else if (__label__ == 4) {
  
        var $14=$maxRequired; //@line 187 "sonic.cpp"
        var $15=$stream; //@line 187 "sonic.cpp"
        var $outputBufferSize=(($15+40)&4294967295); //@line 187 "sonic.cpp"
        HEAP32[(($outputBufferSize)>>2)]=$14; //@line 187 "sonic.cpp"
        var $16=$maxRequired; //@line 188 "sonic.cpp"
        var $17=$numChannels_addr; //@line 188 "sonic.cpp"
        var $mul8=((($17)*2)&4294967295); //@line 188 "sonic.cpp"
        var $call9=_calloc($16, $mul8); //@line 188 "sonic.cpp"
        var $18=$call9; //@line 188 "sonic.cpp"
        var $19=$stream; //@line 188 "sonic.cpp"
        var $outputBuffer=(($19+4)&4294967295); //@line 188 "sonic.cpp"
        HEAP32[(($outputBuffer)>>2)]=$18; //@line 188 "sonic.cpp"
        var $20=$stream; //@line 189 "sonic.cpp"
        var $outputBuffer10=(($20+4)&4294967295); //@line 189 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer10)>>2)]; //@line 189 "sonic.cpp"
        var $cmp11=((($21))|0)==0; //@line 189 "sonic.cpp"
        if ($cmp11) { __label__ = 5;; } else { __label__ = 6;; } //@line 189 "sonic.cpp"
        if (__label__ == 5) {
  
          var $22=$stream; //@line 190 "sonic.cpp"
          _sonicDestroyStream($22); //@line 190 "sonic.cpp"
          $retval=0; //@line 191 "sonic.cpp"
          ; //@line 191 "sonic.cpp"
        }
        else if (__label__ == 6) {
  
          var $23=$maxRequired; //@line 193 "sonic.cpp"
          var $24=$stream; //@line 193 "sonic.cpp"
          var $pitchBufferSize=(($24+36)&4294967295); //@line 193 "sonic.cpp"
          HEAP32[(($pitchBufferSize)>>2)]=$23; //@line 193 "sonic.cpp"
          var $25=$maxRequired; //@line 194 "sonic.cpp"
          var $26=$numChannels_addr; //@line 194 "sonic.cpp"
          var $mul14=((($26)*2)&4294967295); //@line 194 "sonic.cpp"
          var $call15=_calloc($25, $mul14); //@line 194 "sonic.cpp"
          var $27=$call15; //@line 194 "sonic.cpp"
          var $28=$stream; //@line 194 "sonic.cpp"
          var $pitchBuffer=(($28+8)&4294967295); //@line 194 "sonic.cpp"
          HEAP32[(($pitchBuffer)>>2)]=$27; //@line 194 "sonic.cpp"
          var $29=$stream; //@line 195 "sonic.cpp"
          var $pitchBuffer16=(($29+8)&4294967295); //@line 195 "sonic.cpp"
          var $30=HEAP32[(($pitchBuffer16)>>2)]; //@line 195 "sonic.cpp"
          var $cmp17=((($30))|0)==0; //@line 195 "sonic.cpp"
          if ($cmp17) { __label__ = 7;; } else { __label__ = 8;; } //@line 195 "sonic.cpp"
          if (__label__ == 7) {
  
            var $31=$stream; //@line 196 "sonic.cpp"
            _sonicDestroyStream($31); //@line 196 "sonic.cpp"
            $retval=0; //@line 197 "sonic.cpp"
            ; //@line 197 "sonic.cpp"
          }
          else if (__label__ == 8) {
  
            var $32=$maxRequired; //@line 199 "sonic.cpp"
            var $call20=_calloc($32, 2); //@line 199 "sonic.cpp"
            var $33=$call20; //@line 199 "sonic.cpp"
            var $34=$stream; //@line 199 "sonic.cpp"
            var $downSampleBuffer=(($34+12)&4294967295); //@line 199 "sonic.cpp"
            HEAP32[(($downSampleBuffer)>>2)]=$33; //@line 199 "sonic.cpp"
            var $35=$stream; //@line 200 "sonic.cpp"
            var $speed=(($35+16)&4294967295); //@line 200 "sonic.cpp"
            HEAPF32[(($speed)>>2)]=1; //@line 200 "sonic.cpp"
            var $36=$stream; //@line 201 "sonic.cpp"
            var $pitch=(($36+24)&4294967295); //@line 201 "sonic.cpp"
            HEAPF32[(($pitch)>>2)]=1; //@line 201 "sonic.cpp"
            var $37=$stream; //@line 202 "sonic.cpp"
            var $volume=(($37+20)&4294967295); //@line 202 "sonic.cpp"
            HEAPF32[(($volume)>>2)]=1; //@line 202 "sonic.cpp"
            var $38=$sampleRate_addr; //@line 203 "sonic.cpp"
            var $39=$stream; //@line 203 "sonic.cpp"
            var $sampleRate21=(($39+72)&4294967295); //@line 203 "sonic.cpp"
            HEAP32[(($sampleRate21)>>2)]=$38; //@line 203 "sonic.cpp"
            var $40=$numChannels_addr; //@line 204 "sonic.cpp"
            var $41=$stream; //@line 204 "sonic.cpp"
            var $numChannels22=(($41+28)&4294967295); //@line 204 "sonic.cpp"
            HEAP32[(($numChannels22)>>2)]=$40; //@line 204 "sonic.cpp"
            var $42=$minPeriod; //@line 205 "sonic.cpp"
            var $43=$stream; //@line 205 "sonic.cpp"
            var $minPeriod23=(($43+56)&4294967295); //@line 205 "sonic.cpp"
            HEAP32[(($minPeriod23)>>2)]=$42; //@line 205 "sonic.cpp"
            var $44=$maxPeriod; //@line 206 "sonic.cpp"
            var $45=$stream; //@line 206 "sonic.cpp"
            var $maxPeriod24=(($45+60)&4294967295); //@line 206 "sonic.cpp"
            HEAP32[(($maxPeriod24)>>2)]=$44; //@line 206 "sonic.cpp"
            var $46=$maxRequired; //@line 207 "sonic.cpp"
            var $47=$stream; //@line 207 "sonic.cpp"
            var $maxRequired25=(($47+64)&4294967295); //@line 207 "sonic.cpp"
            HEAP32[(($maxRequired25)>>2)]=$46; //@line 207 "sonic.cpp"
            var $48=$stream; //@line 208 "sonic.cpp"
            $retval=$48; //@line 208 "sonic.cpp"
            ; //@line 208 "sonic.cpp"
          }
        }
      }
    }
  
    var $49=$retval; //@line 209 "sonic.cpp"
    ;
    return $49; //@line 209 "sonic.cpp"
    return null;
  }
  

  function _sonicReadFloatFromStream($stream, $samples, $maxSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $maxSamples_addr;
    var $numSamples;
    var $remainingSamples;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $maxSamples_addr=$maxSamples;
    var $0=$stream_addr; //@line 362 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 362 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 362 "sonic.cpp"
    $numSamples=$1; //@line 362 "sonic.cpp"
    $remainingSamples=0; //@line 363 "sonic.cpp"
    var $2=$numSamples; //@line 367 "sonic.cpp"
    var $cmp=((($2))|0)==0; //@line 367 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 367 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 368 "sonic.cpp"
      ; //@line 368 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$numSamples; //@line 370 "sonic.cpp"
      var $4=$maxSamples_addr; //@line 370 "sonic.cpp"
      var $cmp1=((($3))|0) > ((($4))|0); //@line 370 "sonic.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 370 "sonic.cpp"
      if (__label__ == 3) {
  
        var $5=$numSamples; //@line 371 "sonic.cpp"
        var $6=$maxSamples_addr; //@line 371 "sonic.cpp"
        var $sub=((($5)-($6))&4294967295); //@line 371 "sonic.cpp"
        $remainingSamples=$sub; //@line 371 "sonic.cpp"
        var $7=$maxSamples_addr; //@line 372 "sonic.cpp"
        $numSamples=$7; //@line 372 "sonic.cpp"
        ; //@line 373 "sonic.cpp"
      }
  
      var $8=$stream_addr; //@line 374 "sonic.cpp"
      var $outputBuffer=(($8+4)&4294967295); //@line 374 "sonic.cpp"
      var $9=HEAP32[(($outputBuffer)>>2)]; //@line 374 "sonic.cpp"
      $buffer=$9; //@line 374 "sonic.cpp"
      var $10=$numSamples; //@line 375 "sonic.cpp"
      var $11=$stream_addr; //@line 375 "sonic.cpp"
      var $numChannels=(($11+28)&4294967295); //@line 375 "sonic.cpp"
      var $12=HEAP32[(($numChannels)>>2)]; //@line 375 "sonic.cpp"
      var $mul=((($12)*($10))&4294967295); //@line 375 "sonic.cpp"
      var $dec1=((($mul)-1)&4294967295); //@line 376 "sonic.cpp"
      $count=$dec1; //@line 376 "sonic.cpp"
      var $tobool2=((($mul))|0)!=0; //@line 376 "sonic.cpp"
      if ($tobool2) { __label__ = 5;; } else { __label__ = 6;; } //@line 376 "sonic.cpp"
      $while_body$$while_end$8: do { 
        if (__label__ == 5) {
          while(1) { 
  
            var $13=$buffer; //@line 377 "sonic.cpp"
            var $incdec_ptr=(($13+2)&4294967295); //@line 377 "sonic.cpp"
            $buffer=$incdec_ptr; //@line 377 "sonic.cpp"
            var $14=HEAP16[(($13)>>1)]; //@line 377 "sonic.cpp"
            var $conv=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 377 "sonic.cpp"
            var $conv4=((($conv))|0); //@line 377 "sonic.cpp"
            var $div=($conv4)/32767; //@line 377 "sonic.cpp"
            var $15=$samples_addr; //@line 377 "sonic.cpp"
            var $incdec_ptr5=(($15+4)&4294967295); //@line 377 "sonic.cpp"
            $samples_addr=$incdec_ptr5; //@line 377 "sonic.cpp"
            HEAPF32[(($15)>>2)]=$div; //@line 377 "sonic.cpp"
            var $_pr=$count; //@line 376 "sonic.cpp"
            var $dec=((($_pr)-1)&4294967295); //@line 376 "sonic.cpp"
            $count=$dec; //@line 376 "sonic.cpp"
            var $tobool=((($_pr))|0)!=0; //@line 376 "sonic.cpp"
            if ($tobool) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$8; } //@line 376 "sonic.cpp"
          }
        }
      } while(0);
  
      var $16=$remainingSamples; //@line 379 "sonic.cpp"
      var $cmp6=((($16))|0) > 0; //@line 379 "sonic.cpp"
      if ($cmp6) { __label__ = 7;; } else { __label__ = 8;; } //@line 379 "sonic.cpp"
      if (__label__ == 7) {
  
        var $17=$stream_addr; //@line 380 "sonic.cpp"
        var $outputBuffer8=(($17+4)&4294967295); //@line 380 "sonic.cpp"
        var $18=HEAP32[(($outputBuffer8)>>2)]; //@line 380 "sonic.cpp"
        var $19=$18; //@line 380 "sonic.cpp"
        var $20=$stream_addr; //@line 380 "sonic.cpp"
        var $outputBuffer9=(($20+4)&4294967295); //@line 380 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer9)>>2)]; //@line 380 "sonic.cpp"
        var $22=$numSamples; //@line 380 "sonic.cpp"
        var $23=$stream_addr; //@line 380 "sonic.cpp"
        var $numChannels10=(($23+28)&4294967295); //@line 380 "sonic.cpp"
        var $24=HEAP32[(($numChannels10)>>2)]; //@line 380 "sonic.cpp"
        var $mul11=((($24)*($22))&4294967295); //@line 380 "sonic.cpp"
        var $add_ptr=(($21+2*$mul11)&4294967295); //@line 380 "sonic.cpp"
        var $25=$add_ptr; //@line 380 "sonic.cpp"
        var $26=$remainingSamples; //@line 380 "sonic.cpp"
        var $27=$stream_addr; //@line 380 "sonic.cpp"
        var $numChannels13=(($27+28)&4294967295); //@line 380 "sonic.cpp"
        var $28=HEAP32[(($numChannels13)>>2)]; //@line 380 "sonic.cpp"
        var $mul12=((($26)*2)&4294967295); //@line 380 "sonic.cpp"
        var $mul14=((($mul12)*($28))&4294967295); //@line 380 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($19, $25, $mul14, 1, 0); //@line 380 "sonic.cpp"
        ; //@line 382 "sonic.cpp"
      }
  
      var $29=$remainingSamples; //@line 383 "sonic.cpp"
      var $30=$stream_addr; //@line 383 "sonic.cpp"
      var $numOutputSamples16=(($30+48)&4294967295); //@line 383 "sonic.cpp"
      HEAP32[(($numOutputSamples16)>>2)]=$29; //@line 383 "sonic.cpp"
      var $31=$numSamples; //@line 384 "sonic.cpp"
      $retval=$31; //@line 384 "sonic.cpp"
      ; //@line 384 "sonic.cpp"
    }
  
    var $32=$retval; //@line 385 "sonic.cpp"
    ;
    return $32; //@line 385 "sonic.cpp"
    return null;
  }
  

  function _sonicReadShortFromStream($stream, $samples, $maxSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $maxSamples_addr;
    var $numSamples;
    var $remainingSamples;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $maxSamples_addr=$maxSamples;
    var $0=$stream_addr; //@line 394 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 394 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 394 "sonic.cpp"
    $numSamples=$1; //@line 394 "sonic.cpp"
    $remainingSamples=0; //@line 395 "sonic.cpp"
    var $2=$numSamples; //@line 397 "sonic.cpp"
    var $cmp=((($2))|0)==0; //@line 397 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 397 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 398 "sonic.cpp"
      ; //@line 398 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$numSamples; //@line 400 "sonic.cpp"
      var $4=$maxSamples_addr; //@line 400 "sonic.cpp"
      var $cmp1=((($3))|0) > ((($4))|0); //@line 400 "sonic.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 400 "sonic.cpp"
      if (__label__ == 3) {
  
        var $5=$numSamples; //@line 401 "sonic.cpp"
        var $6=$maxSamples_addr; //@line 401 "sonic.cpp"
        var $sub=((($5)-($6))&4294967295); //@line 401 "sonic.cpp"
        $remainingSamples=$sub; //@line 401 "sonic.cpp"
        var $7=$maxSamples_addr; //@line 402 "sonic.cpp"
        $numSamples=$7; //@line 402 "sonic.cpp"
        ; //@line 403 "sonic.cpp"
      }
  
      var $8=$samples_addr; //@line 404 "sonic.cpp"
      var $9=$8; //@line 404 "sonic.cpp"
      var $10=$stream_addr; //@line 404 "sonic.cpp"
      var $outputBuffer=(($10+4)&4294967295); //@line 404 "sonic.cpp"
      var $11=HEAP32[(($outputBuffer)>>2)]; //@line 404 "sonic.cpp"
      var $12=$11; //@line 404 "sonic.cpp"
      var $13=$numSamples; //@line 404 "sonic.cpp"
      var $14=$stream_addr; //@line 404 "sonic.cpp"
      var $numChannels=(($14+28)&4294967295); //@line 404 "sonic.cpp"
      var $15=HEAP32[(($numChannels)>>2)]; //@line 404 "sonic.cpp"
      var $mul=((($13)*2)&4294967295); //@line 404 "sonic.cpp"
      var $mul4=((($mul)*($15))&4294967295); //@line 404 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $12;
      $dest$ = $9;
      $stop$ = $src$ + $mul4;
      if (($dest$%4) == ($src$%4) && $mul4 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 404 "sonic.cpp"
      var $16=$remainingSamples; //@line 405 "sonic.cpp"
      var $cmp5=((($16))|0) > 0; //@line 405 "sonic.cpp"
      if ($cmp5) { __label__ = 5;; } else { __label__ = 6;; } //@line 405 "sonic.cpp"
      if (__label__ == 5) {
  
        var $17=$stream_addr; //@line 406 "sonic.cpp"
        var $outputBuffer7=(($17+4)&4294967295); //@line 406 "sonic.cpp"
        var $18=HEAP32[(($outputBuffer7)>>2)]; //@line 406 "sonic.cpp"
        var $19=$18; //@line 406 "sonic.cpp"
        var $20=$stream_addr; //@line 406 "sonic.cpp"
        var $outputBuffer8=(($20+4)&4294967295); //@line 406 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer8)>>2)]; //@line 406 "sonic.cpp"
        var $22=$numSamples; //@line 406 "sonic.cpp"
        var $23=$stream_addr; //@line 406 "sonic.cpp"
        var $numChannels9=(($23+28)&4294967295); //@line 406 "sonic.cpp"
        var $24=HEAP32[(($numChannels9)>>2)]; //@line 406 "sonic.cpp"
        var $mul10=((($24)*($22))&4294967295); //@line 406 "sonic.cpp"
        var $add_ptr=(($21+2*$mul10)&4294967295); //@line 406 "sonic.cpp"
        var $25=$add_ptr; //@line 406 "sonic.cpp"
        var $26=$remainingSamples; //@line 406 "sonic.cpp"
        var $27=$stream_addr; //@line 406 "sonic.cpp"
        var $numChannels12=(($27+28)&4294967295); //@line 406 "sonic.cpp"
        var $28=HEAP32[(($numChannels12)>>2)]; //@line 406 "sonic.cpp"
        var $mul11=((($26)*2)&4294967295); //@line 406 "sonic.cpp"
        var $mul13=((($mul11)*($28))&4294967295); //@line 406 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($19, $25, $mul13, 1, 0); //@line 406 "sonic.cpp"
        ; //@line 408 "sonic.cpp"
      }
  
      var $29=$remainingSamples; //@line 409 "sonic.cpp"
      var $30=$stream_addr; //@line 409 "sonic.cpp"
      var $numOutputSamples15=(($30+48)&4294967295); //@line 409 "sonic.cpp"
      HEAP32[(($numOutputSamples15)>>2)]=$29; //@line 409 "sonic.cpp"
      var $31=$numSamples; //@line 410 "sonic.cpp"
      $retval=$31; //@line 410 "sonic.cpp"
      ; //@line 410 "sonic.cpp"
    }
  
    var $32=$retval; //@line 411 "sonic.cpp"
    ;
    return $32; //@line 411 "sonic.cpp"
    return null;
  }
  

  function _sonicReadUnsignedCharFromStream($stream, $samples, $maxSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $maxSamples_addr;
    var $numSamples;
    var $remainingSamples;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $maxSamples_addr=$maxSamples;
    var $0=$stream_addr; //@line 420 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 420 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 420 "sonic.cpp"
    $numSamples=$1; //@line 420 "sonic.cpp"
    $remainingSamples=0; //@line 421 "sonic.cpp"
    var $2=$numSamples; //@line 425 "sonic.cpp"
    var $cmp=((($2))|0)==0; //@line 425 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 425 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=0; //@line 426 "sonic.cpp"
      ; //@line 426 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $3=$numSamples; //@line 428 "sonic.cpp"
      var $4=$maxSamples_addr; //@line 428 "sonic.cpp"
      var $cmp1=((($3))|0) > ((($4))|0); //@line 428 "sonic.cpp"
      if ($cmp1) { __label__ = 3;; } else { __label__ = 4;; } //@line 428 "sonic.cpp"
      if (__label__ == 3) {
  
        var $5=$numSamples; //@line 429 "sonic.cpp"
        var $6=$maxSamples_addr; //@line 429 "sonic.cpp"
        var $sub=((($5)-($6))&4294967295); //@line 429 "sonic.cpp"
        $remainingSamples=$sub; //@line 429 "sonic.cpp"
        var $7=$maxSamples_addr; //@line 430 "sonic.cpp"
        $numSamples=$7; //@line 430 "sonic.cpp"
        ; //@line 431 "sonic.cpp"
      }
  
      var $8=$stream_addr; //@line 432 "sonic.cpp"
      var $outputBuffer=(($8+4)&4294967295); //@line 432 "sonic.cpp"
      var $9=HEAP32[(($outputBuffer)>>2)]; //@line 432 "sonic.cpp"
      $buffer=$9; //@line 432 "sonic.cpp"
      var $10=$numSamples; //@line 433 "sonic.cpp"
      var $11=$stream_addr; //@line 433 "sonic.cpp"
      var $numChannels=(($11+28)&4294967295); //@line 433 "sonic.cpp"
      var $12=HEAP32[(($numChannels)>>2)]; //@line 433 "sonic.cpp"
      var $mul=((($12)*($10))&4294967295); //@line 433 "sonic.cpp"
      var $dec1=((($mul)-1)&4294967295); //@line 434 "sonic.cpp"
      $count=$dec1; //@line 434 "sonic.cpp"
      var $tobool2=((($mul))|0)!=0; //@line 434 "sonic.cpp"
      if ($tobool2) { __label__ = 5;; } else { __label__ = 6;; } //@line 434 "sonic.cpp"
      $while_body$$while_end$8: do { 
        if (__label__ == 5) {
          while(1) { 
  
            var $13=$buffer; //@line 435 "sonic.cpp"
            var $incdec_ptr=(($13+2)&4294967295); //@line 435 "sonic.cpp"
            $buffer=$incdec_ptr; //@line 435 "sonic.cpp"
            var $14=HEAP16[(($13)>>1)]; //@line 435 "sonic.cpp"
            var $conv=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 435 "sonic.cpp"
            var $shr=($conv) >> 8; //@line 435 "sonic.cpp"
            var $conv4=((($shr)) & 255); //@line 435 "sonic.cpp"
            var $conv5=(tempInt=(($conv4)),(tempInt>=128?tempInt-256:tempInt)); //@line 435 "sonic.cpp"
            var $add=((($conv5)+128)&4294967295); //@line 435 "sonic.cpp"
            var $conv6=((($add)) & 255); //@line 435 "sonic.cpp"
            var $15=$samples_addr; //@line 435 "sonic.cpp"
            var $incdec_ptr7=(($15+1)&4294967295); //@line 435 "sonic.cpp"
            $samples_addr=$incdec_ptr7; //@line 435 "sonic.cpp"
            HEAP8[($15)]=$conv6; //@line 435 "sonic.cpp"
            var $_pr=$count; //@line 434 "sonic.cpp"
            var $dec=((($_pr)-1)&4294967295); //@line 434 "sonic.cpp"
            $count=$dec; //@line 434 "sonic.cpp"
            var $tobool=((($_pr))|0)!=0; //@line 434 "sonic.cpp"
            if ($tobool) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$8; } //@line 434 "sonic.cpp"
          }
        }
      } while(0);
  
      var $16=$remainingSamples; //@line 437 "sonic.cpp"
      var $cmp8=((($16))|0) > 0; //@line 437 "sonic.cpp"
      if ($cmp8) { __label__ = 7;; } else { __label__ = 8;; } //@line 437 "sonic.cpp"
      if (__label__ == 7) {
  
        var $17=$stream_addr; //@line 438 "sonic.cpp"
        var $outputBuffer10=(($17+4)&4294967295); //@line 438 "sonic.cpp"
        var $18=HEAP32[(($outputBuffer10)>>2)]; //@line 438 "sonic.cpp"
        var $19=$18; //@line 438 "sonic.cpp"
        var $20=$stream_addr; //@line 438 "sonic.cpp"
        var $outputBuffer11=(($20+4)&4294967295); //@line 438 "sonic.cpp"
        var $21=HEAP32[(($outputBuffer11)>>2)]; //@line 438 "sonic.cpp"
        var $22=$numSamples; //@line 438 "sonic.cpp"
        var $23=$stream_addr; //@line 438 "sonic.cpp"
        var $numChannels12=(($23+28)&4294967295); //@line 438 "sonic.cpp"
        var $24=HEAP32[(($numChannels12)>>2)]; //@line 438 "sonic.cpp"
        var $mul13=((($24)*($22))&4294967295); //@line 438 "sonic.cpp"
        var $add_ptr=(($21+2*$mul13)&4294967295); //@line 438 "sonic.cpp"
        var $25=$add_ptr; //@line 438 "sonic.cpp"
        var $26=$remainingSamples; //@line 438 "sonic.cpp"
        var $27=$stream_addr; //@line 438 "sonic.cpp"
        var $numChannels15=(($27+28)&4294967295); //@line 438 "sonic.cpp"
        var $28=HEAP32[(($numChannels15)>>2)]; //@line 438 "sonic.cpp"
        var $mul14=((($26)*2)&4294967295); //@line 438 "sonic.cpp"
        var $mul16=((($mul14)*($28))&4294967295); //@line 438 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($19, $25, $mul16, 1, 0); //@line 438 "sonic.cpp"
        ; //@line 440 "sonic.cpp"
      }
  
      var $29=$remainingSamples; //@line 441 "sonic.cpp"
      var $30=$stream_addr; //@line 441 "sonic.cpp"
      var $numOutputSamples18=(($30+48)&4294967295); //@line 441 "sonic.cpp"
      HEAP32[(($numOutputSamples18)>>2)]=$29; //@line 441 "sonic.cpp"
      var $31=$numSamples; //@line 442 "sonic.cpp"
      $retval=$31; //@line 442 "sonic.cpp"
      ; //@line 442 "sonic.cpp"
    }
  
    var $32=$retval; //@line 443 "sonic.cpp"
    ;
    return $32; //@line 443 "sonic.cpp"
    return null;
  }
  

  function _sonicFlushStream($stream) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $maxRequired;
    var $numSamples;
    var $remainingSpace;
    var $numOutputSamples;
    var $expectedSamples;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 451 "sonic.cpp"
    var $maxRequired1=(($0+64)&4294967295); //@line 451 "sonic.cpp"
    var $1=HEAP32[(($maxRequired1)>>2)]; //@line 451 "sonic.cpp"
    $maxRequired=$1; //@line 451 "sonic.cpp"
    var $2=$stream_addr; //@line 452 "sonic.cpp"
    var $numInputSamples=(($2+44)&4294967295); //@line 452 "sonic.cpp"
    var $3=HEAP32[(($numInputSamples)>>2)]; //@line 452 "sonic.cpp"
    $numSamples=$3; //@line 452 "sonic.cpp"
    var $4=$numSamples; //@line 455 "sonic.cpp"
    var $cmp=((($4))|0)==0; //@line 455 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 455 "sonic.cpp"
    $if_then$$if_end$2: do { 
      if (__label__ == 1) {
  
        $retval=1; //@line 456 "sonic.cpp"
        ; //@line 456 "sonic.cpp"
      }
      else if (__label__ == 2) {
  
        var $5=$numSamples; //@line 458 "sonic.cpp"
        var $6=$maxRequired; //@line 458 "sonic.cpp"
        var $cmp2=((($5))|0) >= ((($6))|0); //@line 458 "sonic.cpp"
        if ($cmp2) { __label__ = 3;; } else { __label__ = 5;; } //@line 458 "sonic.cpp"
        $land_lhs_true$$if_end4$5: do { 
          if (__label__ == 3) {
  
            var $7=$stream_addr; //@line 458 "sonic.cpp"
            var $call=_sonicWriteShortToStream($7, 0, 0); //@line 458 "sonic.cpp"
            var $tobool=((($call))|0)!=0; //@line 458 "sonic.cpp"
            if ($tobool) { __label__ = 5;break $land_lhs_true$$if_end4$5; } //@line 458 "sonic.cpp"
  
            $retval=0; //@line 459 "sonic.cpp"
            __label__ = 12;break $if_then$$if_end$2; //@line 459 "sonic.cpp"
          }
        } while(0);
  
        var $8=$stream_addr; //@line 461 "sonic.cpp"
        var $numInputSamples5=(($8+44)&4294967295); //@line 461 "sonic.cpp"
        var $9=HEAP32[(($numInputSamples5)>>2)]; //@line 461 "sonic.cpp"
        $numSamples=$9; //@line 461 "sonic.cpp"
        var $cmp6=((($9))|0)==0; //@line 462 "sonic.cpp"
        if ($cmp6) { __label__ = 6;; } else { __label__ = 7;; } //@line 462 "sonic.cpp"
        if (__label__ == 6) {
  
          $retval=1; //@line 463 "sonic.cpp"
          ; //@line 463 "sonic.cpp"
        }
        else if (__label__ == 7) {
  
          var $10=$maxRequired; //@line 465 "sonic.cpp"
          var $11=$numSamples; //@line 465 "sonic.cpp"
          var $sub=((($10)-($11))&4294967295); //@line 465 "sonic.cpp"
          $remainingSpace=$sub; //@line 465 "sonic.cpp"
          var $12=$stream_addr; //@line 466 "sonic.cpp"
          var $inputBuffer=(($12)&4294967295); //@line 466 "sonic.cpp"
          var $13=HEAP32[(($inputBuffer)>>2)]; //@line 466 "sonic.cpp"
          var $14=$numSamples; //@line 466 "sonic.cpp"
          var $15=$stream_addr; //@line 466 "sonic.cpp"
          var $numChannels=(($15+28)&4294967295); //@line 466 "sonic.cpp"
          var $16=HEAP32[(($numChannels)>>2)]; //@line 466 "sonic.cpp"
          var $mul=((($16)*($14))&4294967295); //@line 466 "sonic.cpp"
          var $add_ptr=(($13+2*$mul)&4294967295); //@line 466 "sonic.cpp"
          var $17=$add_ptr; //@line 466 "sonic.cpp"
          var $18=$remainingSpace; //@line 466 "sonic.cpp"
          var $19=$stream_addr; //@line 466 "sonic.cpp"
          var $numChannels10=(($19+28)&4294967295); //@line 466 "sonic.cpp"
          var $20=HEAP32[(($numChannels10)>>2)]; //@line 466 "sonic.cpp"
          var $mul9=((($18)*2)&4294967295); //@line 466 "sonic.cpp"
          var $mul11=((($mul9)*($20))&4294967295); //@line 466 "sonic.cpp"
          var $dest$, $stop$, $stop4$, $fast$, $value4$;
          $dest$ = $17;
          $stop$ = $dest$ + $mul11;
          $value4$ = 0;
          if ($value4$ < 0) $value4$ += 256;
          $value4$ = $value4$ + ($value4$<<8) + ($value4$<<16) + ($value4$*16777216);
          while ($dest$%4 !== 0 && $dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($dest$ < $stop4$) {
          ;;;;;;;  HEAP32[$dest$++] = $value4$;
          }
          $dest$ <<= 2;
          while ($dest$ < $stop$) {
            ;; HEAP8[$dest$++] = 0;
          }; //@line 466 "sonic.cpp"
          var $21=$maxRequired; //@line 468 "sonic.cpp"
          var $22=$stream_addr; //@line 468 "sonic.cpp"
          var $numInputSamples12=(($22+44)&4294967295); //@line 468 "sonic.cpp"
          HEAP32[(($numInputSamples12)>>2)]=$21; //@line 468 "sonic.cpp"
          var $23=$stream_addr; //@line 469 "sonic.cpp"
          var $numOutputSamples13=(($23+48)&4294967295); //@line 469 "sonic.cpp"
          var $24=HEAP32[(($numOutputSamples13)>>2)]; //@line 469 "sonic.cpp"
          $numOutputSamples=$24; //@line 469 "sonic.cpp"
          var $25=$stream_addr; //@line 470 "sonic.cpp"
          var $call14=_sonicWriteShortToStream($25, 0, 0); //@line 470 "sonic.cpp"
          var $tobool15=((($call14))|0)!=0; //@line 470 "sonic.cpp"
          if ($tobool15) { __label__ = 9;; } else { __label__ = 8;; } //@line 470 "sonic.cpp"
          if (__label__ == 9) {
  
            var $26=$numSamples; //@line 474 "sonic.cpp"
            var $conv=((($26))|0); //@line 474 "sonic.cpp"
            var $27=$stream_addr; //@line 474 "sonic.cpp"
            var $speed=(($27+16)&4294967295); //@line 474 "sonic.cpp"
            var $28=HEAPF32[(($speed)>>2)]; //@line 474 "sonic.cpp"
            var $mul18=($conv)*($28); //@line 474 "sonic.cpp"
            var $conv19=($mul18); //@line 474 "sonic.cpp"
            var $add=($conv19)+0.5; //@line 474 "sonic.cpp"
            var $conv20=((($add))|0); //@line 474 "sonic.cpp"
            $expectedSamples=$conv20; //@line 474 "sonic.cpp"
            var $29=$stream_addr; //@line 475 "sonic.cpp"
            var $numOutputSamples21=(($29+48)&4294967295); //@line 475 "sonic.cpp"
            var $30=HEAP32[(($numOutputSamples21)>>2)]; //@line 475 "sonic.cpp"
            var $31=$numOutputSamples; //@line 475 "sonic.cpp"
            var $32=$expectedSamples; //@line 475 "sonic.cpp"
            var $add22=((($32)+($31))&4294967295); //@line 475 "sonic.cpp"
            var $cmp23=((($30))|0) > ((($add22))|0); //@line 475 "sonic.cpp"
            if ($cmp23) { __label__ = 10;; } else { __label__ = 11;; } //@line 475 "sonic.cpp"
            if (__label__ == 10) {
  
              var $33=$numOutputSamples; //@line 476 "sonic.cpp"
              var $34=$expectedSamples; //@line 476 "sonic.cpp"
              var $add25=((($34)+($33))&4294967295); //@line 476 "sonic.cpp"
              var $35=$stream_addr; //@line 476 "sonic.cpp"
              var $numOutputSamples26=(($35+48)&4294967295); //@line 476 "sonic.cpp"
              HEAP32[(($numOutputSamples26)>>2)]=$add25; //@line 476 "sonic.cpp"
              ; //@line 477 "sonic.cpp"
            }
  
            $retval=1; //@line 478 "sonic.cpp"
            ; //@line 478 "sonic.cpp"
          }
          else if (__label__ == 8) {
  
            $retval=0; //@line 471 "sonic.cpp"
            ; //@line 471 "sonic.cpp"
          }
        }
      }
    } while(0);
  
    var $36=$retval; //@line 479 "sonic.cpp"
    ;
    return $36; //@line 479 "sonic.cpp"
    return null;
  }
  

  function _sonicWriteShortToStream($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 904 "sonic.cpp"
    var $1=$samples_addr; //@line 904 "sonic.cpp"
    var $2=$numSamples_addr; //@line 904 "sonic.cpp"
    var $call=__ZL28addShortSamplesToInputBufferP17sonicStreamStructPsi($0, $1, $2); //@line 904 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 904 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 904 "sonic.cpp"
    if (__label__ == 2) {
  
      var $3=$stream_addr; //@line 907 "sonic.cpp"
      var $call1=__ZL18processStreamInputP17sonicStreamStruct($3); //@line 907 "sonic.cpp"
      $retval=$call1; //@line 907 "sonic.cpp"
      ; //@line 907 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 905 "sonic.cpp"
      ; //@line 905 "sonic.cpp"
    }
  
    var $4=$retval; //@line 908 "sonic.cpp"
    ;
    return $4; //@line 908 "sonic.cpp"
    return null;
  }
  

  function _sonicSamplesAvailable($stream) {
    ;
    var __label__;
  
    var $stream_addr;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 485 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 485 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 485 "sonic.cpp"
    ;
    return $1; //@line 485 "sonic.cpp"
    return null;
  }
  

  function _sonicWriteFloatToStream($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 891 "sonic.cpp"
    var $1=$samples_addr; //@line 891 "sonic.cpp"
    var $2=$numSamples_addr; //@line 891 "sonic.cpp"
    var $call=__ZL28addFloatSamplesToInputBufferP17sonicStreamStructPfi($0, $1, $2); //@line 891 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 891 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 891 "sonic.cpp"
    if (__label__ == 2) {
  
      var $3=$stream_addr; //@line 894 "sonic.cpp"
      var $call1=__ZL18processStreamInputP17sonicStreamStruct($3); //@line 894 "sonic.cpp"
      $retval=$call1; //@line 894 "sonic.cpp"
      ; //@line 894 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 892 "sonic.cpp"
      ; //@line 892 "sonic.cpp"
    }
  
    var $4=$retval; //@line 895 "sonic.cpp"
    ;
    return $4; //@line 895 "sonic.cpp"
    return null;
  }
  

  function __ZL28addFloatSamplesToInputBufferP17sonicStreamStructPfi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$numSamples_addr; //@line 250 "sonic.cpp"
    var $1=$stream_addr; //@line 250 "sonic.cpp"
    var $numChannels=(($1+28)&4294967295); //@line 250 "sonic.cpp"
    var $2=HEAP32[(($numChannels)>>2)]; //@line 250 "sonic.cpp"
    var $mul=((($2)*($0))&4294967295); //@line 250 "sonic.cpp"
    $count=$mul; //@line 250 "sonic.cpp"
    var $3=$numSamples_addr; //@line 252 "sonic.cpp"
    var $cmp=((($3))|0)==0; //@line 252 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 252 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 253 "sonic.cpp"
      ; //@line 253 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $4=$stream_addr; //@line 255 "sonic.cpp"
      var $5=$numSamples_addr; //@line 255 "sonic.cpp"
      var $call=__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($4, $5); //@line 255 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 255 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 255 "sonic.cpp"
      if (__label__ == 4) {
  
        var $6=$stream_addr; //@line 258 "sonic.cpp"
        var $inputBuffer=(($6)&4294967295); //@line 258 "sonic.cpp"
        var $7=HEAP32[(($inputBuffer)>>2)]; //@line 258 "sonic.cpp"
        var $8=$stream_addr; //@line 258 "sonic.cpp"
        var $numInputSamples=(($8+44)&4294967295); //@line 258 "sonic.cpp"
        var $9=HEAP32[(($numInputSamples)>>2)]; //@line 258 "sonic.cpp"
        var $10=$stream_addr; //@line 258 "sonic.cpp"
        var $numChannels3=(($10+28)&4294967295); //@line 258 "sonic.cpp"
        var $11=HEAP32[(($numChannels3)>>2)]; //@line 258 "sonic.cpp"
        var $mul4=((($11)*($9))&4294967295); //@line 258 "sonic.cpp"
        var $add_ptr=(($7+2*$mul4)&4294967295); //@line 258 "sonic.cpp"
        $buffer=$add_ptr; //@line 258 "sonic.cpp"
        var $12=$count; //@line 259 "sonic.cpp"
        var $dec1=((($12)-1)&4294967295); //@line 259 "sonic.cpp"
        $count=$dec1; //@line 259 "sonic.cpp"
        var $tobool52=((($12))|0)!=0; //@line 259 "sonic.cpp"
        if ($tobool52) { __label__ = 5;; } else { __label__ = 6;; } //@line 259 "sonic.cpp"
        $while_body$$while_end$7: do { 
          if (__label__ == 5) {
            while(1) { 
  
              var $13=$samples_addr; //@line 260 "sonic.cpp"
              var $incdec_ptr=(($13+4)&4294967295); //@line 260 "sonic.cpp"
              $samples_addr=$incdec_ptr; //@line 260 "sonic.cpp"
              var $14=HEAPF32[(($13)>>2)]; //@line 260 "sonic.cpp"
              var $mul6=($14)*32767; //@line 260 "sonic.cpp"
              var $conv=((($mul6))|0); //@line 260 "sonic.cpp"
              var $15=$buffer; //@line 260 "sonic.cpp"
              var $incdec_ptr7=(($15+2)&4294967295); //@line 260 "sonic.cpp"
              $buffer=$incdec_ptr7; //@line 260 "sonic.cpp"
              HEAP16[(($15)>>1)]=$conv; //@line 260 "sonic.cpp"
              var $16=$count; //@line 259 "sonic.cpp"
              var $dec=((($16)-1)&4294967295); //@line 259 "sonic.cpp"
              $count=$dec; //@line 259 "sonic.cpp"
              var $tobool5=((($16))|0)!=0; //@line 259 "sonic.cpp"
              if ($tobool5) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$7; } //@line 259 "sonic.cpp"
            }
          }
        } while(0);
  
        var $17=$numSamples_addr; //@line 262 "sonic.cpp"
        var $18=$stream_addr; //@line 262 "sonic.cpp"
        var $numInputSamples8=(($18+44)&4294967295); //@line 262 "sonic.cpp"
        var $19=HEAP32[(($numInputSamples8)>>2)]; //@line 262 "sonic.cpp"
        var $add=((($19)+($17))&4294967295); //@line 262 "sonic.cpp"
        HEAP32[(($numInputSamples8)>>2)]=$add; //@line 262 "sonic.cpp"
        $retval=1; //@line 263 "sonic.cpp"
        ; //@line 263 "sonic.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 256 "sonic.cpp"
        ; //@line 256 "sonic.cpp"
      }
    }
  
    var $20=$retval; //@line 264 "sonic.cpp"
    ;
    return $20; //@line 264 "sonic.cpp"
    return null;
  }
  

  function __ZL18processStreamInputP17sonicStreamStruct($stream) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $originalNumOutputSamples;
    var $speed;
    $stream_addr=$stream;
    var $0=$stream_addr; //@line 860 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 860 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 860 "sonic.cpp"
    $originalNumOutputSamples=$1; //@line 860 "sonic.cpp"
    var $2=$stream_addr; //@line 861 "sonic.cpp"
    var $speed1=(($2+16)&4294967295); //@line 861 "sonic.cpp"
    var $3=HEAPF32[(($speed1)>>2)]; //@line 861 "sonic.cpp"
    var $4=$stream_addr; //@line 861 "sonic.cpp"
    var $pitch=(($4+24)&4294967295); //@line 861 "sonic.cpp"
    var $5=HEAPF32[(($pitch)>>2)]; //@line 861 "sonic.cpp"
    var $div=($3)/($5); //@line 861 "sonic.cpp"
    $speed=$div; //@line 861 "sonic.cpp"
    var $6=$speed; //@line 863 "sonic.cpp"
    var $conv=($6); //@line 863 "sonic.cpp"
    var $cmp=($conv) > 1.00001; //@line 863 "sonic.cpp"
    if ($cmp) { __label__ = 2;; } else { __label__ = 1;; } //@line 863 "sonic.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $7=$speed; //@line 863 "sonic.cpp"
        var $conv2=($7); //@line 863 "sonic.cpp"
        var $cmp3=($conv2) < 0.99999; //@line 863 "sonic.cpp"
        if ($cmp3) { __label__ = 2;break $if_then$$lor_lhs_false$2; } //@line 863 "sonic.cpp"
  
        var $10=$stream_addr; //@line 866 "sonic.cpp"
        var $11=$stream_addr; //@line 866 "sonic.cpp"
        var $inputBuffer=(($11)&4294967295); //@line 866 "sonic.cpp"
        var $12=HEAP32[(($inputBuffer)>>2)]; //@line 866 "sonic.cpp"
        var $13=$stream_addr; //@line 866 "sonic.cpp"
        var $numInputSamples=(($13+44)&4294967295); //@line 866 "sonic.cpp"
        var $14=HEAP32[(($numInputSamples)>>2)]; //@line 866 "sonic.cpp"
        var $call4=__ZL12copyToOutputP17sonicStreamStructPsi($10, $12, $14); //@line 866 "sonic.cpp"
        var $tobool=((($call4))|0)!=0; //@line 866 "sonic.cpp"
        if ($tobool) { __label__ = 5;; } else { __label__ = 4;; } //@line 866 "sonic.cpp"
        if (__label__ == 5) {
  
          var $15=$stream_addr; //@line 869 "sonic.cpp"
          var $numInputSamples6=(($15+44)&4294967295); //@line 869 "sonic.cpp"
          HEAP32[(($numInputSamples6)>>2)]=0; //@line 869 "sonic.cpp"
          __label__ = 6;break $if_then$$lor_lhs_false$2;
        }
        else if (__label__ == 4) {
  
          $retval=0; //@line 867 "sonic.cpp"
          __label__ = 12;break $if_then$$lor_lhs_false$2; //@line 867 "sonic.cpp"
        }
      }
    } while(0);
    $if_then$$if_end7$$return$8: do { 
      if (__label__ == 2) {
  
        var $8=$stream_addr; //@line 864 "sonic.cpp"
        var $9=$speed; //@line 864 "sonic.cpp"
        __ZL11changeSpeedP17sonicStreamStructf($8, $9); //@line 864 "sonic.cpp"
        __label__ = 6;break $if_then$$if_end7$$return$8; //@line 865 "sonic.cpp"
      }
    } while(0);
    $if_end7$$return$10: do { 
      if (__label__ == 6) {
  
        var $16=$stream_addr; //@line 871 "sonic.cpp"
        var $pitch8=(($16+24)&4294967295); //@line 871 "sonic.cpp"
        var $17=HEAPF32[(($pitch8)>>2)]; //@line 871 "sonic.cpp"
        var $cmp9=($17) != 1; //@line 871 "sonic.cpp"
        if ($cmp9) { __label__ = 7;; } else { __label__ = 9;; } //@line 871 "sonic.cpp"
        $if_then10$$if_end15$12: do { 
          if (__label__ == 7) {
  
            var $18=$stream_addr; //@line 872 "sonic.cpp"
            var $19=$originalNumOutputSamples; //@line 872 "sonic.cpp"
            var $call11=__ZL11adjustPitchP17sonicStreamStructi($18, $19); //@line 872 "sonic.cpp"
            var $tobool12=((($call11))|0)!=0; //@line 872 "sonic.cpp"
            if ($tobool12) { __label__ = 9;break $if_then10$$if_end15$12; } //@line 872 "sonic.cpp"
  
            $retval=0; //@line 873 "sonic.cpp"
            __label__ = 12;break $if_end7$$return$10; //@line 873 "sonic.cpp"
          }
        } while(0);
  
        var $20=$stream_addr; //@line 876 "sonic.cpp"
        var $volume=(($20+20)&4294967295); //@line 876 "sonic.cpp"
        var $21=HEAPF32[(($volume)>>2)]; //@line 876 "sonic.cpp"
        var $cmp16=($21) != 1; //@line 876 "sonic.cpp"
        if ($cmp16) { __label__ = 10;; } else { __label__ = 11;; } //@line 876 "sonic.cpp"
        if (__label__ == 10) {
  
          var $22=$stream_addr; //@line 878 "sonic.cpp"
          var $outputBuffer=(($22+4)&4294967295); //@line 878 "sonic.cpp"
          var $23=HEAP32[(($outputBuffer)>>2)]; //@line 878 "sonic.cpp"
          var $24=$originalNumOutputSamples; //@line 878 "sonic.cpp"
          var $25=$stream_addr; //@line 878 "sonic.cpp"
          var $numChannels=(($25+28)&4294967295); //@line 878 "sonic.cpp"
          var $26=HEAP32[(($numChannels)>>2)]; //@line 878 "sonic.cpp"
          var $mul=((($26)*($24))&4294967295); //@line 878 "sonic.cpp"
          var $add_ptr=(($23+2*$mul)&4294967295); //@line 878 "sonic.cpp"
          var $27=$stream_addr; //@line 878 "sonic.cpp"
          var $numOutputSamples18=(($27+48)&4294967295); //@line 878 "sonic.cpp"
          var $28=HEAP32[(($numOutputSamples18)>>2)]; //@line 878 "sonic.cpp"
          var $29=$originalNumOutputSamples; //@line 878 "sonic.cpp"
          var $sub=((($28)-($29))&4294967295); //@line 878 "sonic.cpp"
          var $30=$stream_addr; //@line 878 "sonic.cpp"
          var $numChannels19=(($30+28)&4294967295); //@line 878 "sonic.cpp"
          var $31=HEAP32[(($numChannels19)>>2)]; //@line 878 "sonic.cpp"
          var $mul20=((($31)*($sub))&4294967295); //@line 878 "sonic.cpp"
          var $32=$stream_addr; //@line 878 "sonic.cpp"
          var $volume21=(($32+20)&4294967295); //@line 878 "sonic.cpp"
          var $33=HEAPF32[(($volume21)>>2)]; //@line 878 "sonic.cpp"
          __ZL12scaleSamplesPsif($add_ptr, $mul20, $33); //@line 878 "sonic.cpp"
          ; //@line 881 "sonic.cpp"
        }
  
        $retval=1; //@line 882 "sonic.cpp"
        ; //@line 882 "sonic.cpp"
      }
    } while(0);
  
    var $34=$retval; //@line 883 "sonic.cpp"
    ;
    return $34; //@line 883 "sonic.cpp"
    return null;
  }
  

  function __ZL28addShortSamplesToInputBufferP17sonicStreamStructPsi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$numSamples_addr; //@line 272 "sonic.cpp"
    var $cmp=((($0))|0)==0; //@line 272 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 272 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 273 "sonic.cpp"
      ; //@line 273 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $1=$stream_addr; //@line 275 "sonic.cpp"
      var $2=$numSamples_addr; //@line 275 "sonic.cpp"
      var $call=__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($1, $2); //@line 275 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 275 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 275 "sonic.cpp"
      if (__label__ == 4) {
  
        var $3=$stream_addr; //@line 278 "sonic.cpp"
        var $inputBuffer=(($3)&4294967295); //@line 278 "sonic.cpp"
        var $4=HEAP32[(($inputBuffer)>>2)]; //@line 278 "sonic.cpp"
        var $5=$stream_addr; //@line 278 "sonic.cpp"
        var $numInputSamples=(($5+44)&4294967295); //@line 278 "sonic.cpp"
        var $6=HEAP32[(($numInputSamples)>>2)]; //@line 278 "sonic.cpp"
        var $7=$stream_addr; //@line 278 "sonic.cpp"
        var $numChannels=(($7+28)&4294967295); //@line 278 "sonic.cpp"
        var $8=HEAP32[(($numChannels)>>2)]; //@line 278 "sonic.cpp"
        var $mul=((($8)*($6))&4294967295); //@line 278 "sonic.cpp"
        var $add_ptr=(($4+2*$mul)&4294967295); //@line 278 "sonic.cpp"
        var $9=$add_ptr; //@line 278 "sonic.cpp"
        var $10=$samples_addr; //@line 278 "sonic.cpp"
        var $11=$10; //@line 278 "sonic.cpp"
        var $12=$numSamples_addr; //@line 278 "sonic.cpp"
        var $13=$stream_addr; //@line 278 "sonic.cpp"
        var $numChannels4=(($13+28)&4294967295); //@line 278 "sonic.cpp"
        var $14=HEAP32[(($numChannels4)>>2)]; //@line 278 "sonic.cpp"
        var $mul3=((($12)*2)&4294967295); //@line 278 "sonic.cpp"
        var $mul5=((($mul3)*($14))&4294967295); //@line 278 "sonic.cpp"
        var $src$, $dest$, $stop$, $stop4$, $fast$;
        $src$ = $11;
        $dest$ = $9;
        $stop$ = $src$ + $mul5;
        if (($dest$%4) == ($src$%4) && $mul5 > 8) {
          while ($src$%4 !== 0 && $src$ < $stop$) {
            ; HEAP8[$dest$++] = HEAP8[$src$++];
          }
          $src$ >>= 2;
          $dest$ >>= 2;
          $stop4$ = $stop$ >> 2;
          while ($src$ < $stop4$) {
        ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
          }
          $src$ <<= 2;
          $dest$ <<= 2;
        }while ($src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }; //@line 278 "sonic.cpp"
        var $15=$numSamples_addr; //@line 280 "sonic.cpp"
        var $16=$stream_addr; //@line 280 "sonic.cpp"
        var $numInputSamples6=(($16+44)&4294967295); //@line 280 "sonic.cpp"
        var $17=HEAP32[(($numInputSamples6)>>2)]; //@line 280 "sonic.cpp"
        var $add=((($17)+($15))&4294967295); //@line 280 "sonic.cpp"
        HEAP32[(($numInputSamples6)>>2)]=$add; //@line 280 "sonic.cpp"
        $retval=1; //@line 281 "sonic.cpp"
        ; //@line 281 "sonic.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 276 "sonic.cpp"
        ; //@line 276 "sonic.cpp"
      }
    }
  
    var $18=$retval; //@line 282 "sonic.cpp"
    ;
    return $18; //@line 282 "sonic.cpp"
    return null;
  }
  

  function _sonicWriteUnsignedCharToStream($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 917 "sonic.cpp"
    var $1=$samples_addr; //@line 917 "sonic.cpp"
    var $2=$numSamples_addr; //@line 917 "sonic.cpp"
    var $call=__ZL35addUnsignedCharSamplesToInputBufferP17sonicStreamStructPhi($0, $1, $2); //@line 917 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 917 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 917 "sonic.cpp"
    if (__label__ == 2) {
  
      var $3=$stream_addr; //@line 920 "sonic.cpp"
      var $call1=__ZL18processStreamInputP17sonicStreamStruct($3); //@line 920 "sonic.cpp"
      $retval=$call1; //@line 920 "sonic.cpp"
      ; //@line 920 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 918 "sonic.cpp"
      ; //@line 918 "sonic.cpp"
    }
  
    var $4=$retval; //@line 921 "sonic.cpp"
    ;
    return $4; //@line 921 "sonic.cpp"
    return null;
  }
  

  function __ZL35addUnsignedCharSamplesToInputBufferP17sonicStreamStructPhi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    var $buffer;
    var $count;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$numSamples_addr; //@line 291 "sonic.cpp"
    var $1=$stream_addr; //@line 291 "sonic.cpp"
    var $numChannels=(($1+28)&4294967295); //@line 291 "sonic.cpp"
    var $2=HEAP32[(($numChannels)>>2)]; //@line 291 "sonic.cpp"
    var $mul=((($2)*($0))&4294967295); //@line 291 "sonic.cpp"
    $count=$mul; //@line 291 "sonic.cpp"
    var $3=$numSamples_addr; //@line 293 "sonic.cpp"
    var $cmp=((($3))|0)==0; //@line 293 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 293 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 294 "sonic.cpp"
      ; //@line 294 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $4=$stream_addr; //@line 296 "sonic.cpp"
      var $5=$numSamples_addr; //@line 296 "sonic.cpp"
      var $call=__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($4, $5); //@line 296 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 296 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 296 "sonic.cpp"
      if (__label__ == 4) {
  
        var $6=$stream_addr; //@line 299 "sonic.cpp"
        var $inputBuffer=(($6)&4294967295); //@line 299 "sonic.cpp"
        var $7=HEAP32[(($inputBuffer)>>2)]; //@line 299 "sonic.cpp"
        var $8=$stream_addr; //@line 299 "sonic.cpp"
        var $numInputSamples=(($8+44)&4294967295); //@line 299 "sonic.cpp"
        var $9=HEAP32[(($numInputSamples)>>2)]; //@line 299 "sonic.cpp"
        var $10=$stream_addr; //@line 299 "sonic.cpp"
        var $numChannels3=(($10+28)&4294967295); //@line 299 "sonic.cpp"
        var $11=HEAP32[(($numChannels3)>>2)]; //@line 299 "sonic.cpp"
        var $mul4=((($11)*($9))&4294967295); //@line 299 "sonic.cpp"
        var $add_ptr=(($7+2*$mul4)&4294967295); //@line 299 "sonic.cpp"
        $buffer=$add_ptr; //@line 299 "sonic.cpp"
        var $12=$count; //@line 300 "sonic.cpp"
        var $dec1=((($12)-1)&4294967295); //@line 300 "sonic.cpp"
        $count=$dec1; //@line 300 "sonic.cpp"
        var $tobool52=((($12))|0)!=0; //@line 300 "sonic.cpp"
        if ($tobool52) { __label__ = 5;; } else { __label__ = 6;; } //@line 300 "sonic.cpp"
        $while_body$$while_end$7: do { 
          if (__label__ == 5) {
            while(1) { 
  
              var $13=$samples_addr; //@line 301 "sonic.cpp"
              var $incdec_ptr=(($13+1)&4294967295); //@line 301 "sonic.cpp"
              $samples_addr=$incdec_ptr; //@line 301 "sonic.cpp"
              var $14=HEAPU8[($13)]; //@line 301 "sonic.cpp"
              var $conv=((($14))&255); //@line 301 "sonic.cpp"
              var $sub=((($conv)-128)&4294967295); //@line 301 "sonic.cpp"
              var $shl=($sub) << 8; //@line 301 "sonic.cpp"
              var $conv6=((($shl)) & 65535); //@line 301 "sonic.cpp"
              var $15=$buffer; //@line 301 "sonic.cpp"
              var $incdec_ptr7=(($15+2)&4294967295); //@line 301 "sonic.cpp"
              $buffer=$incdec_ptr7; //@line 301 "sonic.cpp"
              HEAP16[(($15)>>1)]=$conv6; //@line 301 "sonic.cpp"
              var $16=$count; //@line 300 "sonic.cpp"
              var $dec=((($16)-1)&4294967295); //@line 300 "sonic.cpp"
              $count=$dec; //@line 300 "sonic.cpp"
              var $tobool5=((($16))|0)!=0; //@line 300 "sonic.cpp"
              if ($tobool5) { __label__ = 5;continue ; } else { __label__ = 6;break $while_body$$while_end$7; } //@line 300 "sonic.cpp"
            }
          }
        } while(0);
  
        var $17=$numSamples_addr; //@line 303 "sonic.cpp"
        var $18=$stream_addr; //@line 303 "sonic.cpp"
        var $numInputSamples8=(($18+44)&4294967295); //@line 303 "sonic.cpp"
        var $19=HEAP32[(($numInputSamples8)>>2)]; //@line 303 "sonic.cpp"
        var $add=((($19)+($17))&4294967295); //@line 303 "sonic.cpp"
        HEAP32[(($numInputSamples8)>>2)]=$add; //@line 303 "sonic.cpp"
        $retval=1; //@line 304 "sonic.cpp"
        ; //@line 304 "sonic.cpp"
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 297 "sonic.cpp"
        ; //@line 297 "sonic.cpp"
      }
    }
  
    var $20=$retval; //@line 305 "sonic.cpp"
    ;
    return $20; //@line 305 "sonic.cpp"
    return null;
  }
  

  function _sonicChangeFloatSpeed($samples, $numSamples, $speed, $pitch, $volume, $sampleRate, $numChannels) {
    ;
    var __label__;
  
    var $samples_addr;
    var $numSamples_addr;
    var $speed_addr;
    var $pitch_addr;
    var $volume_addr;
    var $sampleRate_addr;
    var $numChannels_addr;
    var $stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    $speed_addr=$speed;
    $pitch_addr=$pitch;
    $volume_addr=$volume;
    $sampleRate_addr=$sampleRate;
    $numChannels_addr=$numChannels;
    var $0=$sampleRate_addr; //@line 933 "sonic.cpp"
    var $1=$numChannels_addr; //@line 933 "sonic.cpp"
    var $call=_sonicCreateStream($0, $1); //@line 933 "sonic.cpp"
    $stream=$call; //@line 933 "sonic.cpp"
    var $2=$stream; //@line 935 "sonic.cpp"
    var $3=$speed_addr; //@line 935 "sonic.cpp"
    _sonicSetSpeed($2, $3); //@line 935 "sonic.cpp"
    var $4=$stream; //@line 936 "sonic.cpp"
    var $5=$pitch_addr; //@line 936 "sonic.cpp"
    _sonicSetPitch($4, $5); //@line 936 "sonic.cpp"
    var $6=$stream; //@line 937 "sonic.cpp"
    var $7=$volume_addr; //@line 937 "sonic.cpp"
    _sonicSetVolume($6, $7); //@line 937 "sonic.cpp"
    var $8=$stream; //@line 938 "sonic.cpp"
    var $9=$samples_addr; //@line 938 "sonic.cpp"
    var $10=$numSamples_addr; //@line 938 "sonic.cpp"
    var $call1=_sonicWriteFloatToStream($8, $9, $10); //@line 938 "sonic.cpp"
    var $11=$stream; //@line 939 "sonic.cpp"
    var $call2=_sonicFlushStream($11); //@line 939 "sonic.cpp"
    var $12=$stream; //@line 940 "sonic.cpp"
    var $call3=_sonicSamplesAvailable($12); //@line 940 "sonic.cpp"
    $numSamples_addr=$call3; //@line 940 "sonic.cpp"
    var $13=$stream; //@line 941 "sonic.cpp"
    var $14=$samples_addr; //@line 941 "sonic.cpp"
    var $15=$numSamples_addr; //@line 941 "sonic.cpp"
    var $call4=_sonicReadFloatFromStream($13, $14, $15); //@line 941 "sonic.cpp"
    var $16=$stream; //@line 942 "sonic.cpp"
    _sonicDestroyStream($16); //@line 942 "sonic.cpp"
    var $17=$numSamples_addr; //@line 943 "sonic.cpp"
    ;
    return $17; //@line 943 "sonic.cpp"
    return null;
  }
  

  function _sonicChangeShortSpeed($samples, $numSamples, $speed, $pitch, $volume, $sampleRate, $numChannels) {
    ;
    var __label__;
  
    var $samples_addr;
    var $numSamples_addr;
    var $speed_addr;
    var $pitch_addr;
    var $volume_addr;
    var $sampleRate_addr;
    var $numChannels_addr;
    var $stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    $speed_addr=$speed;
    $pitch_addr=$pitch;
    $volume_addr=$volume;
    $sampleRate_addr=$sampleRate;
    $numChannels_addr=$numChannels;
    var $0=$sampleRate_addr; //@line 956 "sonic.cpp"
    var $1=$numChannels_addr; //@line 956 "sonic.cpp"
    var $call=_sonicCreateStream($0, $1); //@line 956 "sonic.cpp"
    $stream=$call; //@line 956 "sonic.cpp"
    var $2=$stream; //@line 958 "sonic.cpp"
    var $3=$speed_addr; //@line 958 "sonic.cpp"
    _sonicSetSpeed($2, $3); //@line 958 "sonic.cpp"
    var $4=$stream; //@line 959 "sonic.cpp"
    var $5=$pitch_addr; //@line 959 "sonic.cpp"
    _sonicSetPitch($4, $5); //@line 959 "sonic.cpp"
    var $6=$stream; //@line 960 "sonic.cpp"
    var $7=$volume_addr; //@line 960 "sonic.cpp"
    _sonicSetVolume($6, $7); //@line 960 "sonic.cpp"
    var $8=$stream; //@line 961 "sonic.cpp"
    var $9=$samples_addr; //@line 961 "sonic.cpp"
    var $10=$numSamples_addr; //@line 961 "sonic.cpp"
    var $call1=_sonicWriteShortToStream($8, $9, $10); //@line 961 "sonic.cpp"
    var $11=$stream; //@line 962 "sonic.cpp"
    var $call2=_sonicFlushStream($11); //@line 962 "sonic.cpp"
    var $12=$stream; //@line 963 "sonic.cpp"
    var $call3=_sonicSamplesAvailable($12); //@line 963 "sonic.cpp"
    $numSamples_addr=$call3; //@line 963 "sonic.cpp"
    var $13=$stream; //@line 964 "sonic.cpp"
    var $14=$samples_addr; //@line 964 "sonic.cpp"
    var $15=$numSamples_addr; //@line 964 "sonic.cpp"
    var $call4=_sonicReadShortFromStream($13, $14, $15); //@line 964 "sonic.cpp"
    var $16=$stream; //@line 965 "sonic.cpp"
    _sonicDestroyStream($16); //@line 965 "sonic.cpp"
    var $17=$numSamples_addr; //@line 966 "sonic.cpp"
    ;
    return $17; //@line 966 "sonic.cpp"
    return null;
  }
  

  function __ZL26enlargeInputBufferIfNeededP17sonicStreamStructi($stream, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 232 "sonic.cpp"
    var $numInputSamples=(($0+44)&4294967295); //@line 232 "sonic.cpp"
    var $1=HEAP32[(($numInputSamples)>>2)]; //@line 232 "sonic.cpp"
    var $2=$numSamples_addr; //@line 232 "sonic.cpp"
    var $add=((($2)+($1))&4294967295); //@line 232 "sonic.cpp"
    var $3=$stream_addr; //@line 232 "sonic.cpp"
    var $inputBufferSize=(($3+32)&4294967295); //@line 232 "sonic.cpp"
    var $4=HEAP32[(($inputBufferSize)>>2)]; //@line 232 "sonic.cpp"
    var $cmp=((($add))|0) > ((($4))|0); //@line 232 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 232 "sonic.cpp"
    $if_then$$if_end11$2: do { 
      if (__label__ == 1) {
  
        var $5=$stream_addr; //@line 233 "sonic.cpp"
        var $inputBufferSize1=(($5+32)&4294967295); //@line 233 "sonic.cpp"
        var $6=HEAP32[(($inputBufferSize1)>>2)]; //@line 233 "sonic.cpp"
        var $shr=($6) >> 1; //@line 233 "sonic.cpp"
        var $7=$numSamples_addr; //@line 233 "sonic.cpp"
        var $8=$stream_addr; //@line 233 "sonic.cpp"
        var $inputBufferSize3=(($8+32)&4294967295); //@line 233 "sonic.cpp"
        var $9=HEAP32[(($inputBufferSize3)>>2)]; //@line 233 "sonic.cpp"
        var $add2=((($shr)+($7))&4294967295); //@line 233 "sonic.cpp"
        var $add4=((($add2)+($9))&4294967295); //@line 233 "sonic.cpp"
        HEAP32[(($inputBufferSize3)>>2)]=$add4; //@line 233 "sonic.cpp"
        var $10=$stream_addr; //@line 234 "sonic.cpp"
        var $inputBuffer=(($10)&4294967295); //@line 234 "sonic.cpp"
        var $11=HEAP32[(($inputBuffer)>>2)]; //@line 234 "sonic.cpp"
        var $12=$11; //@line 234 "sonic.cpp"
        var $13=$stream_addr; //@line 234 "sonic.cpp"
        var $inputBufferSize5=(($13+32)&4294967295); //@line 234 "sonic.cpp"
        var $14=HEAP32[(($inputBufferSize5)>>2)]; //@line 234 "sonic.cpp"
        var $15=$stream_addr; //@line 234 "sonic.cpp"
        var $numChannels=(($15+28)&4294967295); //@line 234 "sonic.cpp"
        var $16=HEAP32[(($numChannels)>>2)]; //@line 234 "sonic.cpp"
        var $mul=((($14)*2)&4294967295); //@line 234 "sonic.cpp"
        var $mul6=((($mul)*($16))&4294967295); //@line 234 "sonic.cpp"
        var $call=_realloc($12, $mul6); //@line 234 "sonic.cpp"
        var $17=$call; //@line 234 "sonic.cpp"
        var $18=$stream_addr; //@line 234 "sonic.cpp"
        var $inputBuffer7=(($18)&4294967295); //@line 234 "sonic.cpp"
        HEAP32[(($inputBuffer7)>>2)]=$17; //@line 234 "sonic.cpp"
        var $19=$stream_addr; //@line 236 "sonic.cpp"
        var $inputBuffer8=(($19)&4294967295); //@line 236 "sonic.cpp"
        var $20=HEAP32[(($inputBuffer8)>>2)]; //@line 236 "sonic.cpp"
        var $cmp9=((($20))|0)==0; //@line 236 "sonic.cpp"
        if (!($cmp9)) { __label__ = 3;break $if_then$$if_end11$2; } //@line 236 "sonic.cpp"
  
        $retval=0; //@line 237 "sonic.cpp"
        __label__ = 4;break $if_then$$if_end11$2; //@line 237 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=1; //@line 240 "sonic.cpp"
      ; //@line 240 "sonic.cpp"
    }
  
    var $21=$retval; //@line 241 "sonic.cpp"
    ;
    return $21; //@line 241 "sonic.cpp"
    return null;
  }
  

  function __ZL11changeSpeedP17sonicStreamStructf($stream, $speed) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $stream_addr;
    var $speed_addr;
    var $samples;
    var $numSamples;
    var $position;
    var $period;
    var $newSamples;
    var $maxRequired;
    $stream_addr=$stream;
    $speed_addr=$speed;
    var $0=$stream_addr; //@line 825 "sonic.cpp"
    var $numInputSamples=(($0+44)&4294967295); //@line 825 "sonic.cpp"
    var $1=HEAP32[(($numInputSamples)>>2)]; //@line 825 "sonic.cpp"
    $numSamples=$1; //@line 825 "sonic.cpp"
    $position=0; //@line 826 "sonic.cpp"
    var $2=$stream_addr; //@line 827 "sonic.cpp"
    var $maxRequired1=(($2+64)&4294967295); //@line 827 "sonic.cpp"
    var $3=HEAP32[(($maxRequired1)>>2)]; //@line 827 "sonic.cpp"
    $maxRequired=$3; //@line 827 "sonic.cpp"
    var $4=$stream_addr; //@line 829 "sonic.cpp"
    var $numInputSamples2=(($4+44)&4294967295); //@line 829 "sonic.cpp"
    var $5=HEAP32[(($numInputSamples2)>>2)]; //@line 829 "sonic.cpp"
    var $6=$maxRequired; //@line 829 "sonic.cpp"
    var $cmp=((($5))|0) < ((($6))|0); //@line 829 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 829 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 830 "sonic.cpp"
      ; //@line 830 "sonic.cpp"
    }
    else if (__label__ == 2) {
      while(1) { 
  
        var $7=$stream_addr; //@line 833 "sonic.cpp"
        var $remainingInputToCopy=(($7+68)&4294967295); //@line 833 "sonic.cpp"
        var $8=HEAP32[(($remainingInputToCopy)>>2)]; //@line 833 "sonic.cpp"
        var $cmp3=((($8))|0) > 0; //@line 833 "sonic.cpp"
        var $9=$stream_addr; //@line 834 "sonic.cpp"
        if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 833 "sonic.cpp"
        if (__label__ == 3) {
  
          var $10=$position; //@line 834 "sonic.cpp"
          var $call=__ZL17copyInputToOutputP17sonicStreamStructi($9, $10); //@line 834 "sonic.cpp"
          $newSamples=$call; //@line 834 "sonic.cpp"
          var $11=$newSamples; //@line 835 "sonic.cpp"
          var $12=$position; //@line 835 "sonic.cpp"
          var $add=((($12)+($11))&4294967295); //@line 835 "sonic.cpp"
          $position=$add; //@line 835 "sonic.cpp"
          __lastLabel__ = 3; ; //@line 836 "sonic.cpp"
        }
        else if (__label__ == 4) {
  
          var $inputBuffer=(($9)&4294967295); //@line 837 "sonic.cpp"
          var $13=HEAP32[(($inputBuffer)>>2)]; //@line 837 "sonic.cpp"
          var $14=$position; //@line 837 "sonic.cpp"
          var $15=$stream_addr; //@line 837 "sonic.cpp"
          var $numChannels=(($15+28)&4294967295); //@line 837 "sonic.cpp"
          var $16=HEAP32[(($numChannels)>>2)]; //@line 837 "sonic.cpp"
          var $mul=((($16)*($14))&4294967295); //@line 837 "sonic.cpp"
          var $add_ptr=(($13+2*$mul)&4294967295); //@line 837 "sonic.cpp"
          $samples=$add_ptr; //@line 837 "sonic.cpp"
          var $17=$stream_addr; //@line 838 "sonic.cpp"
          var $18=$samples; //@line 838 "sonic.cpp"
          var $call5=__ZL15findPitchPeriodP17sonicStreamStructPs($17, $18); //@line 838 "sonic.cpp"
          $period=$call5; //@line 838 "sonic.cpp"
          var $19=$speed_addr; //@line 839 "sonic.cpp"
          var $conv=($19); //@line 839 "sonic.cpp"
          var $cmp6=($conv) > 1; //@line 839 "sonic.cpp"
          var $20=$stream_addr; //@line 840 "sonic.cpp"
          var $21=$samples; //@line 840 "sonic.cpp"
          var $22=$speed_addr; //@line 840 "sonic.cpp"
          var $23=$period; //@line 840 "sonic.cpp"
          if ($cmp6) { __label__ = 5;; } else { __label__ = 6;; } //@line 839 "sonic.cpp"
          if (__label__ == 5) {
  
            var $call8=__ZL15skipPitchPeriodP17sonicStreamStructPsfi($20, $21, $22, $23); //@line 840 "sonic.cpp"
            $newSamples=$call8; //@line 840 "sonic.cpp"
            var $24=$period; //@line 841 "sonic.cpp"
            var $25=$newSamples; //@line 841 "sonic.cpp"
            var $26=$position; //@line 841 "sonic.cpp"
            var $add9=((($25)+($24))&4294967295); //@line 841 "sonic.cpp"
            var $add10=((($add9)+($26))&4294967295); //@line 841 "sonic.cpp"
            $position=$add10; //@line 841 "sonic.cpp"
            __lastLabel__ = 5; ; //@line 842 "sonic.cpp"
          }
          else if (__label__ == 6) {
  
            var $call12=__ZL17insertPitchPeriodP17sonicStreamStructPsfi($20, $21, $22, $23); //@line 843 "sonic.cpp"
            $newSamples=$call12; //@line 843 "sonic.cpp"
            var $27=$newSamples; //@line 844 "sonic.cpp"
            var $28=$position; //@line 844 "sonic.cpp"
            var $add13=((($28)+($27))&4294967295); //@line 844 "sonic.cpp"
            $position=$add13; //@line 844 "sonic.cpp"
            __lastLabel__ = 6; ;
          }
        }
  
        var $29=__lastLabel__ == 5 ? $25 : (__lastLabel__ == 6 ? $27 : ($11)); //@line 847 "sonic.cpp"
        var $cmp16=((($29))|0)==0; //@line 847 "sonic.cpp"
        if ($cmp16) { __label__ = 8;break ; } //@line 847 "sonic.cpp"
  
        var $30=$position; //@line 850 "sonic.cpp"
        var $31=$maxRequired; //@line 850 "sonic.cpp"
        var $add19=((($31)+($30))&4294967295); //@line 850 "sonic.cpp"
        var $32=$numSamples; //@line 850 "sonic.cpp"
        var $cmp20=((($add19))|0) <= ((($32))|0); //@line 850 "sonic.cpp"
        if ($cmp20) { __label__ = 2;continue ; } else { __label__ = 10;break ; } //@line 850 "sonic.cpp"
      }
      if (__label__ == 8) {
  
        $retval=0; //@line 848 "sonic.cpp"
        ; //@line 848 "sonic.cpp"
      }
      else if (__label__ == 10) {
  
        var $33=$stream_addr; //@line 851 "sonic.cpp"
        var $34=$position; //@line 851 "sonic.cpp"
        __ZL18removeInputSamplesP17sonicStreamStructi($33, $34); //@line 851 "sonic.cpp"
        $retval=1; //@line 852 "sonic.cpp"
        ; //@line 852 "sonic.cpp"
      }
    }
  
    ;
    return;
    return;
  }
  

  function __ZL12copyToOutputP17sonicStreamStructPsi($stream, $samples, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 327 "sonic.cpp"
    var $1=$numSamples_addr; //@line 327 "sonic.cpp"
    var $call=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($0, $1); //@line 327 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 327 "sonic.cpp"
    if ($tobool) { __label__ = 2;; } else { __label__ = 1;; } //@line 327 "sonic.cpp"
    if (__label__ == 2) {
  
      var $2=$stream_addr; //@line 330 "sonic.cpp"
      var $outputBuffer=(($2+4)&4294967295); //@line 330 "sonic.cpp"
      var $3=HEAP32[(($outputBuffer)>>2)]; //@line 330 "sonic.cpp"
      var $4=$stream_addr; //@line 330 "sonic.cpp"
      var $numOutputSamples=(($4+48)&4294967295); //@line 330 "sonic.cpp"
      var $5=HEAP32[(($numOutputSamples)>>2)]; //@line 330 "sonic.cpp"
      var $6=$stream_addr; //@line 330 "sonic.cpp"
      var $numChannels=(($6+28)&4294967295); //@line 330 "sonic.cpp"
      var $7=HEAP32[(($numChannels)>>2)]; //@line 330 "sonic.cpp"
      var $mul=((($7)*($5))&4294967295); //@line 330 "sonic.cpp"
      var $add_ptr=(($3+2*$mul)&4294967295); //@line 330 "sonic.cpp"
      var $8=$add_ptr; //@line 330 "sonic.cpp"
      var $9=$samples_addr; //@line 330 "sonic.cpp"
      var $10=$9; //@line 330 "sonic.cpp"
      var $11=$numSamples_addr; //@line 330 "sonic.cpp"
      var $12=$stream_addr; //@line 330 "sonic.cpp"
      var $numChannels2=(($12+28)&4294967295); //@line 330 "sonic.cpp"
      var $13=HEAP32[(($numChannels2)>>2)]; //@line 330 "sonic.cpp"
      var $mul1=((($11)*2)&4294967295); //@line 330 "sonic.cpp"
      var $mul3=((($mul1)*($13))&4294967295); //@line 330 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $10;
      $dest$ = $8;
      $stop$ = $src$ + $mul3;
      if (($dest$%4) == ($src$%4) && $mul3 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 330 "sonic.cpp"
      var $14=$numSamples_addr; //@line 332 "sonic.cpp"
      var $15=$stream_addr; //@line 332 "sonic.cpp"
      var $numOutputSamples4=(($15+48)&4294967295); //@line 332 "sonic.cpp"
      var $16=HEAP32[(($numOutputSamples4)>>2)]; //@line 332 "sonic.cpp"
      var $add=((($16)+($14))&4294967295); //@line 332 "sonic.cpp"
      HEAP32[(($numOutputSamples4)>>2)]=$add; //@line 332 "sonic.cpp"
      var $17=$numSamples_addr; //@line 333 "sonic.cpp"
      $retval=$17; //@line 333 "sonic.cpp"
      ; //@line 333 "sonic.cpp"
    }
    else if (__label__ == 1) {
  
      $retval=0; //@line 328 "sonic.cpp"
      ; //@line 328 "sonic.cpp"
    }
  
    var $18=$retval; //@line 334 "sonic.cpp"
    ;
    return $18; //@line 334 "sonic.cpp"
    return null;
  }
  

  function __ZL11adjustPitchP17sonicStreamStructi($stream, $originalNumOutputSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $originalNumOutputSamples_addr;
    var $pitch;
    var $numChannels;
    var $period;
    var $newPeriod;
    var $separation;
    var $position;
    var $out;
    var $rampDown;
    var $rampUp;
    $stream_addr=$stream;
    $originalNumOutputSamples_addr=$originalNumOutputSamples;
    var $0=$stream_addr; //@line 729 "sonic.cpp"
    var $pitch1=(($0+24)&4294967295); //@line 729 "sonic.cpp"
    var $1=HEAPF32[(($pitch1)>>2)]; //@line 729 "sonic.cpp"
    $pitch=$1; //@line 729 "sonic.cpp"
    var $2=$stream_addr; //@line 730 "sonic.cpp"
    var $numChannels2=(($2+28)&4294967295); //@line 730 "sonic.cpp"
    var $3=HEAP32[(($numChannels2)>>2)]; //@line 730 "sonic.cpp"
    $numChannels=$3; //@line 730 "sonic.cpp"
    $position=0; //@line 732 "sonic.cpp"
    var $4=$stream_addr; //@line 735 "sonic.cpp"
    var $numOutputSamples=(($4+48)&4294967295); //@line 735 "sonic.cpp"
    var $5=HEAP32[(($numOutputSamples)>>2)]; //@line 735 "sonic.cpp"
    var $6=$originalNumOutputSamples_addr; //@line 735 "sonic.cpp"
    var $cmp=((($5))|0)==((($6))|0); //@line 735 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 735 "sonic.cpp"
    if (__label__ == 1) {
  
      $retval=1; //@line 736 "sonic.cpp"
      ; //@line 736 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      var $7=$stream_addr; //@line 738 "sonic.cpp"
      var $8=$originalNumOutputSamples_addr; //@line 738 "sonic.cpp"
      var $call=__ZL27moveNewSamplesToPitchBufferP17sonicStreamStructi($7, $8); //@line 738 "sonic.cpp"
      var $tobool=((($call))|0)!=0; //@line 738 "sonic.cpp"
      if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 738 "sonic.cpp"
      if (__label__ == 4) {
        while(1) { 
  
          var $9=$stream_addr; //@line 741 "sonic.cpp"
          var $numPitchSamples=(($9+52)&4294967295); //@line 741 "sonic.cpp"
          var $10=HEAP32[(($numPitchSamples)>>2)]; //@line 741 "sonic.cpp"
          var $11=$position; //@line 741 "sonic.cpp"
          var $sub=((($10)-($11))&4294967295); //@line 741 "sonic.cpp"
          var $12=$stream_addr; //@line 741 "sonic.cpp"
          var $maxRequired=(($12+64)&4294967295); //@line 741 "sonic.cpp"
          var $13=HEAP32[(($maxRequired)>>2)]; //@line 741 "sonic.cpp"
          var $cmp5=((($sub))|0) >= ((($13))|0); //@line 741 "sonic.cpp"
          var $14=$stream_addr; //@line 742 "sonic.cpp"
          if (!($cmp5)) { __label__ = 11;break ; } //@line 741 "sonic.cpp"
  
          var $15=$stream_addr; //@line 742 "sonic.cpp"
          var $pitchBuffer=(($15+8)&4294967295); //@line 742 "sonic.cpp"
          var $16=HEAP32[(($pitchBuffer)>>2)]; //@line 742 "sonic.cpp"
          var $17=$position; //@line 742 "sonic.cpp"
          var $18=$numChannels; //@line 742 "sonic.cpp"
          var $mul=((($18)*($17))&4294967295); //@line 742 "sonic.cpp"
          var $add_ptr=(($16+2*$mul)&4294967295); //@line 742 "sonic.cpp"
          var $call6=__ZL15findPitchPeriodP17sonicStreamStructPs($14, $add_ptr); //@line 742 "sonic.cpp"
          $period=$call6; //@line 742 "sonic.cpp"
          var $19=$period; //@line 743 "sonic.cpp"
          var $conv=((($19))|0); //@line 743 "sonic.cpp"
          var $20=$pitch; //@line 743 "sonic.cpp"
          var $div=($conv)/($20); //@line 743 "sonic.cpp"
          var $conv7=((($div))|0); //@line 743 "sonic.cpp"
          $newPeriod=$conv7; //@line 743 "sonic.cpp"
          var $21=$stream_addr; //@line 744 "sonic.cpp"
          var $22=$newPeriod; //@line 744 "sonic.cpp"
          var $call8=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($21, $22); //@line 744 "sonic.cpp"
          var $tobool9=((($call8))|0)!=0; //@line 744 "sonic.cpp"
          if (!($tobool9)) { __label__ = 6;break ; } //@line 744 "sonic.cpp"
  
          var $23=$stream_addr; //@line 747 "sonic.cpp"
          var $outputBuffer=(($23+4)&4294967295); //@line 747 "sonic.cpp"
          var $24=HEAP32[(($outputBuffer)>>2)]; //@line 747 "sonic.cpp"
          var $25=$stream_addr; //@line 747 "sonic.cpp"
          var $numOutputSamples12=(($25+48)&4294967295); //@line 747 "sonic.cpp"
          var $26=HEAP32[(($numOutputSamples12)>>2)]; //@line 747 "sonic.cpp"
          var $27=$numChannels; //@line 747 "sonic.cpp"
          var $mul13=((($27)*($26))&4294967295); //@line 747 "sonic.cpp"
          var $add_ptr14=(($24+2*$mul13)&4294967295); //@line 747 "sonic.cpp"
          $out=$add_ptr14; //@line 747 "sonic.cpp"
          var $28=$pitch; //@line 748 "sonic.cpp"
          var $cmp15=($28) >= 1; //@line 748 "sonic.cpp"
          var $29=$stream_addr; //@line 749 "sonic.cpp"
          var $pitchBuffer17=(($29+8)&4294967295); //@line 749 "sonic.cpp"
          var $30=HEAP32[(($pitchBuffer17)>>2)]; //@line 749 "sonic.cpp"
          var $31=$position; //@line 749 "sonic.cpp"
          var $32=$numChannels; //@line 749 "sonic.cpp"
          var $mul18=((($32)*($31))&4294967295); //@line 749 "sonic.cpp"
          var $add_ptr19=(($30+2*$mul18)&4294967295); //@line 749 "sonic.cpp"
          $rampDown=$add_ptr19; //@line 749 "sonic.cpp"
          var $33=$stream_addr; //@line 750 "sonic.cpp"
          var $pitchBuffer20=(($33+8)&4294967295); //@line 750 "sonic.cpp"
          var $34=HEAP32[(($pitchBuffer20)>>2)]; //@line 750 "sonic.cpp"
          var $35=$position; //@line 750 "sonic.cpp"
          if ($cmp15) { __label__ = 8;; } else { __label__ = 9;; } //@line 748 "sonic.cpp"
          if (__label__ == 8) {
  
            var $36=$period; //@line 750 "sonic.cpp"
            var $37=$newPeriod; //@line 750 "sonic.cpp"
            var $_neg=(((-($37)))&4294967295);
            var $add=((($36)+($35))&4294967295); //@line 750 "sonic.cpp"
            var $sub21=((($add)+($_neg))&4294967295); //@line 750 "sonic.cpp"
            var $38=$numChannels; //@line 750 "sonic.cpp"
            var $mul22=((($sub21)*($38))&4294967295); //@line 750 "sonic.cpp"
            var $add_ptr23=(($34+2*$mul22)&4294967295); //@line 750 "sonic.cpp"
            $rampUp=$add_ptr23; //@line 750 "sonic.cpp"
            var $39=$newPeriod; //@line 751 "sonic.cpp"
            var $40=$numChannels; //@line 751 "sonic.cpp"
            var $41=$out; //@line 751 "sonic.cpp"
            var $42=$rampDown; //@line 751 "sonic.cpp"
            var $43=$rampUp; //@line 751 "sonic.cpp"
            __ZL10overlapAddiiPsS_S_($39, $40, $41, $42, $43); //@line 751 "sonic.cpp"
            ; //@line 752 "sonic.cpp"
          }
          else if (__label__ == 9) {
  
            var $44=$numChannels; //@line 754 "sonic.cpp"
            var $mul28=((($44)*($35))&4294967295); //@line 754 "sonic.cpp"
            var $add_ptr29=(($34+2*$mul28)&4294967295); //@line 754 "sonic.cpp"
            $rampUp=$add_ptr29; //@line 754 "sonic.cpp"
            var $45=$newPeriod; //@line 755 "sonic.cpp"
            var $46=$period; //@line 755 "sonic.cpp"
            var $sub30=((($45)-($46))&4294967295); //@line 755 "sonic.cpp"
            $separation=$sub30; //@line 755 "sonic.cpp"
            var $47=$period; //@line 756 "sonic.cpp"
            var $48=$numChannels; //@line 756 "sonic.cpp"
            var $49=$separation; //@line 756 "sonic.cpp"
            var $50=$out; //@line 756 "sonic.cpp"
            var $51=$rampDown; //@line 756 "sonic.cpp"
            var $52=$rampUp; //@line 756 "sonic.cpp"
            __ZL24overlapAddWithSeparationiiiPsS_S_($47, $48, $49, $50, $51, $52); //@line 756 "sonic.cpp"
            ;
          }
  
          var $53=$newPeriod; //@line 758 "sonic.cpp"
          var $54=$stream_addr; //@line 758 "sonic.cpp"
          var $numOutputSamples32=(($54+48)&4294967295); //@line 758 "sonic.cpp"
          var $55=HEAP32[(($numOutputSamples32)>>2)]; //@line 758 "sonic.cpp"
          var $add33=((($55)+($53))&4294967295); //@line 758 "sonic.cpp"
          HEAP32[(($numOutputSamples32)>>2)]=$add33; //@line 758 "sonic.cpp"
          var $56=$period; //@line 759 "sonic.cpp"
          var $57=$position; //@line 759 "sonic.cpp"
          var $add34=((($57)+($56))&4294967295); //@line 759 "sonic.cpp"
          $position=$add34; //@line 759 "sonic.cpp"
          __label__ = 4;continue ; //@line 760 "sonic.cpp"
        }
        if (__label__ == 11) {
  
          var $58=$position; //@line 761 "sonic.cpp"
          __ZL18removePitchSamplesP17sonicStreamStructi($14, $58); //@line 761 "sonic.cpp"
          $retval=1; //@line 762 "sonic.cpp"
          ; //@line 762 "sonic.cpp"
        }
        else if (__label__ == 6) {
  
          $retval=0; //@line 745 "sonic.cpp"
          ; //@line 745 "sonic.cpp"
        }
      }
      else if (__label__ == 3) {
  
        $retval=0; //@line 739 "sonic.cpp"
        ; //@line 739 "sonic.cpp"
      }
    }
  
    var $59=$retval; //@line 763 "sonic.cpp"
    ;
    return $59; //@line 763 "sonic.cpp"
    return null;
  }
  

  function __ZL12scaleSamplesPsif($samples, $numSamples, $volume) {
    ;
    var __label__;
  
    var $samples_addr;
    var $numSamples_addr;
    var $volume_addr;
    var $fixedPointVolume;
    var $value;
    $samples_addr=$samples;
    $numSamples_addr=$numSamples;
    $volume_addr=$volume;
    var $0=$volume_addr; //@line 75 "sonic.cpp"
    var $mul=($0)*4096; //@line 75 "sonic.cpp"
    var $conv=((($mul))|0); //@line 75 "sonic.cpp"
    $fixedPointVolume=$conv; //@line 75 "sonic.cpp"
    var $1=$numSamples_addr; //@line 78 "sonic.cpp"
    var $dec1=((($1)-1)&4294967295); //@line 78 "sonic.cpp"
    $numSamples_addr=$dec1; //@line 78 "sonic.cpp"
    var $tobool2=((($1))|0)!=0; //@line 78 "sonic.cpp"
    if ($tobool2) { __label__ = 1;; } else { __label__ = 6;; } //@line 78 "sonic.cpp"
    $while_body$$while_end$2: do { 
      if (__label__ == 1) {
        $while_body$3: while(1) { 
  
          var $2=$samples_addr; //@line 79 "sonic.cpp"
          var $3=HEAP16[(($2)>>1)]; //@line 79 "sonic.cpp"
          var $conv1=(tempInt=(($3)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 79 "sonic.cpp"
          var $4=$fixedPointVolume; //@line 79 "sonic.cpp"
          var $mul2=((($conv1)*($4))&4294967295); //@line 79 "sonic.cpp"
          var $shr=($mul2) >> 12; //@line 79 "sonic.cpp"
          $value=$shr; //@line 79 "sonic.cpp"
          var $cmp=((($shr))|0) > 32767; //@line 80 "sonic.cpp"
          if ($cmp) { __label__ = 2;; } else { __label__ = 3;; } //@line 80 "sonic.cpp"
          $if_then$$if_else$5: do { 
            if (__label__ == 2) {
  
              $value=32767; //@line 81 "sonic.cpp"
              ; //@line 82 "sonic.cpp"
            }
            else if (__label__ == 3) {
  
              var $5=$value; //@line 82 "sonic.cpp"
              var $cmp3=((($5))|0) < -32767; //@line 82 "sonic.cpp"
              if (!($cmp3)) { __label__ = 5;break $if_then$$if_else$5; } //@line 82 "sonic.cpp"
  
              $value=-32767; //@line 83 "sonic.cpp"
              ; //@line 84 "sonic.cpp"
            }
          } while(0);
  
          var $6=$value; //@line 85 "sonic.cpp"
          var $conv6=((($6)) & 65535); //@line 85 "sonic.cpp"
          var $7=$samples_addr; //@line 85 "sonic.cpp"
          var $incdec_ptr=(($7+2)&4294967295); //@line 85 "sonic.cpp"
          $samples_addr=$incdec_ptr; //@line 85 "sonic.cpp"
          HEAP16[(($7)>>1)]=$conv6; //@line 85 "sonic.cpp"
          var $8=$numSamples_addr; //@line 78 "sonic.cpp"
          var $dec=((($8)-1)&4294967295); //@line 78 "sonic.cpp"
          $numSamples_addr=$dec; //@line 78 "sonic.cpp"
          var $tobool=((($8))|0)!=0; //@line 78 "sonic.cpp"
          if ($tobool) { __label__ = 1;continue $while_body$3; } else { __label__ = 6;break $while_body$$while_end$2; } //@line 78 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 87 "sonic.cpp"
    return;
  }
  

  function __ZL27moveNewSamplesToPitchBufferP17sonicStreamStructi($stream, $originalNumOutputSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $originalNumOutputSamples_addr;
    var $numSamples;
    var $numChannels;
    $stream_addr=$stream;
    $originalNumOutputSamples_addr=$originalNumOutputSamples;
    var $0=$stream_addr; //@line 686 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 686 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 686 "sonic.cpp"
    var $2=$originalNumOutputSamples_addr; //@line 686 "sonic.cpp"
    var $sub=((($1)-($2))&4294967295); //@line 686 "sonic.cpp"
    $numSamples=$sub; //@line 686 "sonic.cpp"
    var $3=$stream_addr; //@line 687 "sonic.cpp"
    var $numChannels1=(($3+28)&4294967295); //@line 687 "sonic.cpp"
    var $4=HEAP32[(($numChannels1)>>2)]; //@line 687 "sonic.cpp"
    $numChannels=$4; //@line 687 "sonic.cpp"
    var $5=$stream_addr; //@line 689 "sonic.cpp"
    var $numPitchSamples=(($5+52)&4294967295); //@line 689 "sonic.cpp"
    var $6=HEAP32[(($numPitchSamples)>>2)]; //@line 689 "sonic.cpp"
    var $7=$numSamples; //@line 689 "sonic.cpp"
    var $add=((($7)+($6))&4294967295); //@line 689 "sonic.cpp"
    var $8=$stream_addr; //@line 689 "sonic.cpp"
    var $pitchBufferSize=(($8+36)&4294967295); //@line 689 "sonic.cpp"
    var $9=HEAP32[(($pitchBufferSize)>>2)]; //@line 689 "sonic.cpp"
    var $cmp=((($add))|0) > ((($9))|0); //@line 689 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 689 "sonic.cpp"
    $if_then$$if_end12$2: do { 
      if (__label__ == 1) {
  
        var $10=$stream_addr; //@line 690 "sonic.cpp"
        var $pitchBufferSize2=(($10+36)&4294967295); //@line 690 "sonic.cpp"
        var $11=HEAP32[(($pitchBufferSize2)>>2)]; //@line 690 "sonic.cpp"
        var $shr=($11) >> 1; //@line 690 "sonic.cpp"
        var $12=$numSamples; //@line 690 "sonic.cpp"
        var $13=$stream_addr; //@line 690 "sonic.cpp"
        var $pitchBufferSize4=(($13+36)&4294967295); //@line 690 "sonic.cpp"
        var $14=HEAP32[(($pitchBufferSize4)>>2)]; //@line 690 "sonic.cpp"
        var $add3=((($shr)+($12))&4294967295); //@line 690 "sonic.cpp"
        var $add5=((($add3)+($14))&4294967295); //@line 690 "sonic.cpp"
        HEAP32[(($pitchBufferSize4)>>2)]=$add5; //@line 690 "sonic.cpp"
        var $15=$stream_addr; //@line 691 "sonic.cpp"
        var $pitchBuffer=(($15+8)&4294967295); //@line 691 "sonic.cpp"
        var $16=HEAP32[(($pitchBuffer)>>2)]; //@line 691 "sonic.cpp"
        var $17=$16; //@line 691 "sonic.cpp"
        var $18=$stream_addr; //@line 691 "sonic.cpp"
        var $pitchBufferSize6=(($18+36)&4294967295); //@line 691 "sonic.cpp"
        var $19=HEAP32[(($pitchBufferSize6)>>2)]; //@line 691 "sonic.cpp"
        var $20=$numChannels; //@line 691 "sonic.cpp"
        var $mul=((($19)*2)&4294967295); //@line 691 "sonic.cpp"
        var $mul7=((($mul)*($20))&4294967295); //@line 691 "sonic.cpp"
        var $call=_realloc($17, $mul7); //@line 691 "sonic.cpp"
        var $21=$call; //@line 691 "sonic.cpp"
        var $22=$stream_addr; //@line 691 "sonic.cpp"
        var $pitchBuffer8=(($22+8)&4294967295); //@line 691 "sonic.cpp"
        HEAP32[(($pitchBuffer8)>>2)]=$21; //@line 691 "sonic.cpp"
        var $23=$stream_addr; //@line 693 "sonic.cpp"
        var $pitchBuffer9=(($23+8)&4294967295); //@line 693 "sonic.cpp"
        var $24=HEAP32[(($pitchBuffer9)>>2)]; //@line 693 "sonic.cpp"
        var $cmp10=((($24))|0)==0; //@line 693 "sonic.cpp"
        if (!($cmp10)) { __label__ = 3;break $if_then$$if_end12$2; } //@line 693 "sonic.cpp"
  
        $retval=0; //@line 694 "sonic.cpp"
        __label__ = 4;break $if_then$$if_end12$2; //@line 694 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      var $25=$stream_addr; //@line 697 "sonic.cpp"
      var $pitchBuffer13=(($25+8)&4294967295); //@line 697 "sonic.cpp"
      var $26=HEAP32[(($pitchBuffer13)>>2)]; //@line 697 "sonic.cpp"
      var $27=$stream_addr; //@line 697 "sonic.cpp"
      var $numPitchSamples14=(($27+52)&4294967295); //@line 697 "sonic.cpp"
      var $28=HEAP32[(($numPitchSamples14)>>2)]; //@line 697 "sonic.cpp"
      var $29=$numChannels; //@line 697 "sonic.cpp"
      var $mul15=((($29)*($28))&4294967295); //@line 697 "sonic.cpp"
      var $add_ptr=(($26+2*$mul15)&4294967295); //@line 697 "sonic.cpp"
      var $30=$add_ptr; //@line 697 "sonic.cpp"
      var $31=$stream_addr; //@line 697 "sonic.cpp"
      var $outputBuffer=(($31+4)&4294967295); //@line 697 "sonic.cpp"
      var $32=HEAP32[(($outputBuffer)>>2)]; //@line 697 "sonic.cpp"
      var $33=$originalNumOutputSamples_addr; //@line 697 "sonic.cpp"
      var $34=$numChannels; //@line 697 "sonic.cpp"
      var $mul16=((($34)*($33))&4294967295); //@line 697 "sonic.cpp"
      var $add_ptr17=(($32+2*$mul16)&4294967295); //@line 697 "sonic.cpp"
      var $35=$add_ptr17; //@line 697 "sonic.cpp"
      var $36=$numSamples; //@line 697 "sonic.cpp"
      var $37=$numChannels; //@line 697 "sonic.cpp"
      var $mul18=((($36)*2)&4294967295); //@line 697 "sonic.cpp"
      var $mul19=((($mul18)*($37))&4294967295); //@line 697 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $35;
      $dest$ = $30;
      $stop$ = $src$ + $mul19;
      if (($dest$%4) == ($src$%4) && $mul19 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 697 "sonic.cpp"
      var $38=$originalNumOutputSamples_addr; //@line 700 "sonic.cpp"
      var $39=$stream_addr; //@line 700 "sonic.cpp"
      var $numOutputSamples20=(($39+48)&4294967295); //@line 700 "sonic.cpp"
      HEAP32[(($numOutputSamples20)>>2)]=$38; //@line 700 "sonic.cpp"
      var $40=$numSamples; //@line 701 "sonic.cpp"
      var $41=$stream_addr; //@line 701 "sonic.cpp"
      var $numPitchSamples21=(($41+52)&4294967295); //@line 701 "sonic.cpp"
      var $42=HEAP32[(($numPitchSamples21)>>2)]; //@line 701 "sonic.cpp"
      var $add22=((($42)+($40))&4294967295); //@line 701 "sonic.cpp"
      HEAP32[(($numPitchSamples21)>>2)]=$add22; //@line 701 "sonic.cpp"
      $retval=1; //@line 702 "sonic.cpp"
      ; //@line 702 "sonic.cpp"
    }
  
    var $43=$retval; //@line 703 "sonic.cpp"
    ;
    return $43; //@line 703 "sonic.cpp"
    return null;
  }
  

  function __ZL15findPitchPeriodP17sonicStreamStructPs($stream, $samples) {
    var __stackBase__  = STACKTOP; STACKTOP += 8; _memset(__stackBase__, 0, 8);
    var __label__;
  
    var $stream_addr;
    var $samples_addr;
    var $minPeriod;
    var $maxPeriod;
    var $sampleRate;
    var $minDiff=__stackBase__;
    var $maxDiff=__stackBase__+4;
    var $retPeriod;
    var $skip;
    var $period;
    $stream_addr=$stream;
    $samples_addr=$samples;
    var $0=$stream_addr; //@line 575 "sonic.cpp"
    var $minPeriod1=(($0+56)&4294967295); //@line 575 "sonic.cpp"
    var $1=HEAP32[(($minPeriod1)>>2)]; //@line 575 "sonic.cpp"
    $minPeriod=$1; //@line 575 "sonic.cpp"
    var $2=$stream_addr; //@line 576 "sonic.cpp"
    var $maxPeriod2=(($2+60)&4294967295); //@line 576 "sonic.cpp"
    var $3=HEAP32[(($maxPeriod2)>>2)]; //@line 576 "sonic.cpp"
    $maxPeriod=$3; //@line 576 "sonic.cpp"
    var $4=$stream_addr; //@line 577 "sonic.cpp"
    var $sampleRate3=(($4+72)&4294967295); //@line 577 "sonic.cpp"
    var $5=HEAP32[(($sampleRate3)>>2)]; //@line 577 "sonic.cpp"
    $sampleRate=$5; //@line 577 "sonic.cpp"
    $skip=1; //@line 579 "sonic.cpp"
    var $6=$sampleRate; //@line 582 "sonic.cpp"
    var $cmp=((($6))|0) > 4000; //@line 582 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 582 "sonic.cpp"
    if (__label__ == 1) {
  
      var $7=$sampleRate; //@line 583 "sonic.cpp"
      var $div=((((($7))|0)/4000)|0); //@line 583 "sonic.cpp"
      $skip=$div; //@line 583 "sonic.cpp"
      ; //@line 584 "sonic.cpp"
    }
  
    var $8=$stream_addr; //@line 585 "sonic.cpp"
    var $numChannels=(($8+28)&4294967295); //@line 585 "sonic.cpp"
    var $9=HEAP32[(($numChannels)>>2)]; //@line 585 "sonic.cpp"
    var $cmp4=((($9))|0)==1; //@line 585 "sonic.cpp"
    if ($cmp4) { __label__ = 3;; } else { __label__ = 5;; } //@line 585 "sonic.cpp"
    $land_lhs_true$$if_else$5: do { 
      if (__label__ == 3) {
  
        var $10=$skip; //@line 585 "sonic.cpp"
        var $cmp5=((($10))|0)==1; //@line 585 "sonic.cpp"
        if (!($cmp5)) { __label__ = 5;break $land_lhs_true$$if_else$5; } //@line 585 "sonic.cpp"
  
        var $11=$samples_addr; //@line 586 "sonic.cpp"
        var $12=$minPeriod; //@line 586 "sonic.cpp"
        var $13=$maxPeriod; //@line 586 "sonic.cpp"
        var $call=__ZL22findPitchPeriodInRangePsiiPiS0_($11, $12, $13, $minDiff, $maxDiff); //@line 586 "sonic.cpp"
        $period=$call; //@line 586 "sonic.cpp"
        __label__ = 13;break $land_lhs_true$$if_else$5; //@line 587 "sonic.cpp"
      }
    } while(0);
    $if_end32$$if_else$8: do { 
      if (__label__ == 5) {
  
        var $14=$stream_addr; //@line 588 "sonic.cpp"
        var $15=$samples_addr; //@line 588 "sonic.cpp"
        var $16=$skip; //@line 588 "sonic.cpp"
        __ZL15downSampleInputP17sonicStreamStructPsi($14, $15, $16); //@line 588 "sonic.cpp"
        var $17=$stream_addr; //@line 589 "sonic.cpp"
        var $downSampleBuffer=(($17+12)&4294967295); //@line 589 "sonic.cpp"
        var $18=HEAP32[(($downSampleBuffer)>>2)]; //@line 589 "sonic.cpp"
        var $19=$minPeriod; //@line 589 "sonic.cpp"
        var $20=$skip; //@line 589 "sonic.cpp"
        var $div7=((((($19))|0)/((($20))|0))|0); //@line 589 "sonic.cpp"
        var $21=$maxPeriod; //@line 589 "sonic.cpp"
        var $22=$skip; //@line 589 "sonic.cpp"
        var $div8=((((($21))|0)/((($22))|0))|0); //@line 589 "sonic.cpp"
        var $call9=__ZL22findPitchPeriodInRangePsiiPiS0_($18, $div7, $div8, $minDiff, $maxDiff); //@line 589 "sonic.cpp"
        $period=$call9; //@line 589 "sonic.cpp"
        var $23=$skip; //@line 591 "sonic.cpp"
        var $cmp10=((($23))|0)!=1; //@line 591 "sonic.cpp"
        if (!($cmp10)) { __label__ = 13;break $if_end32$$if_else$8; } //@line 591 "sonic.cpp"
  
        var $24=$skip; //@line 592 "sonic.cpp"
        var $25=$period; //@line 592 "sonic.cpp"
        var $mul=((($25)*($24))&4294967295); //@line 592 "sonic.cpp"
        $period=$mul; //@line 592 "sonic.cpp"
        var $26=$period; //@line 593 "sonic.cpp"
        var $27=$skip; //@line 593 "sonic.cpp"
        var $shl=($27) << 2; //@line 593 "sonic.cpp"
        var $sub=((($26)-($shl))&4294967295); //@line 593 "sonic.cpp"
        $minPeriod=$sub; //@line 593 "sonic.cpp"
        var $28=$period; //@line 594 "sonic.cpp"
        var $29=$skip; //@line 594 "sonic.cpp"
        var $shl12=((($29)*4)&4294967295); //@line 594 "sonic.cpp"
        var $add=((($shl12)+($28))&4294967295); //@line 594 "sonic.cpp"
        $maxPeriod=$add; //@line 594 "sonic.cpp"
        var $30=$minPeriod; //@line 595 "sonic.cpp"
        var $31=$stream_addr; //@line 595 "sonic.cpp"
        var $minPeriod13=(($31+56)&4294967295); //@line 595 "sonic.cpp"
        var $32=HEAP32[(($minPeriod13)>>2)]; //@line 595 "sonic.cpp"
        var $cmp14=((($30))|0) < ((($32))|0); //@line 595 "sonic.cpp"
        if ($cmp14) { __label__ = 7;; } else { __label__ = 8;; } //@line 595 "sonic.cpp"
        if (__label__ == 7) {
  
          var $33=$stream_addr; //@line 596 "sonic.cpp"
          var $minPeriod16=(($33+56)&4294967295); //@line 596 "sonic.cpp"
          var $34=HEAP32[(($minPeriod16)>>2)]; //@line 596 "sonic.cpp"
          $minPeriod=$34; //@line 596 "sonic.cpp"
          ; //@line 597 "sonic.cpp"
        }
  
        var $35=$maxPeriod; //@line 598 "sonic.cpp"
        var $36=$stream_addr; //@line 598 "sonic.cpp"
        var $maxPeriod18=(($36+60)&4294967295); //@line 598 "sonic.cpp"
        var $37=HEAP32[(($maxPeriod18)>>2)]; //@line 598 "sonic.cpp"
        var $cmp19=((($35))|0) > ((($37))|0); //@line 598 "sonic.cpp"
        if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 598 "sonic.cpp"
        if (__label__ == 9) {
  
          var $38=$stream_addr; //@line 599 "sonic.cpp"
          var $maxPeriod21=(($38+60)&4294967295); //@line 599 "sonic.cpp"
          var $39=HEAP32[(($maxPeriod21)>>2)]; //@line 599 "sonic.cpp"
          $maxPeriod=$39; //@line 599 "sonic.cpp"
          ; //@line 600 "sonic.cpp"
        }
  
        var $40=$stream_addr; //@line 601 "sonic.cpp"
        var $numChannels23=(($40+28)&4294967295); //@line 601 "sonic.cpp"
        var $41=HEAP32[(($numChannels23)>>2)]; //@line 601 "sonic.cpp"
        var $cmp24=((($41))|0)==1; //@line 601 "sonic.cpp"
        if ($cmp24) { __label__ = 11;; } else { __label__ = 12;; } //@line 601 "sonic.cpp"
        if (__label__ == 11) {
  
          var $42=$samples_addr; //@line 602 "sonic.cpp"
          var $43=$minPeriod; //@line 602 "sonic.cpp"
          var $44=$maxPeriod; //@line 602 "sonic.cpp"
          var $call26=__ZL22findPitchPeriodInRangePsiiPiS0_($42, $43, $44, $minDiff, $maxDiff); //@line 602 "sonic.cpp"
          $period=$call26; //@line 602 "sonic.cpp"
          ; //@line 604 "sonic.cpp"
        }
        else if (__label__ == 12) {
  
          var $45=$stream_addr; //@line 605 "sonic.cpp"
          var $46=$samples_addr; //@line 605 "sonic.cpp"
          __ZL15downSampleInputP17sonicStreamStructPsi($45, $46, 1); //@line 605 "sonic.cpp"
          var $47=$stream_addr; //@line 606 "sonic.cpp"
          var $downSampleBuffer28=(($47+12)&4294967295); //@line 606 "sonic.cpp"
          var $48=HEAP32[(($downSampleBuffer28)>>2)]; //@line 606 "sonic.cpp"
          var $49=$minPeriod; //@line 606 "sonic.cpp"
          var $50=$maxPeriod; //@line 606 "sonic.cpp"
          var $call29=__ZL22findPitchPeriodInRangePsiiPiS0_($48, $49, $50, $minDiff, $maxDiff); //@line 606 "sonic.cpp"
          $period=$call29; //@line 606 "sonic.cpp"
          ;
        }
      }
    } while(0);
  
    var $51=$stream_addr; //@line 611 "sonic.cpp"
    var $52=$period; //@line 611 "sonic.cpp"
    var $53=HEAP32[(($minDiff)>>2)]; //@line 611 "sonic.cpp"
    var $54=HEAP32[(($maxDiff)>>2)]; //@line 611 "sonic.cpp"
    var $call33=__ZL16prevPeriodBetterP17sonicStreamStructiii($51, $52, $53, $54); //@line 611 "sonic.cpp"
    var $tobool=((($call33))|0)!=0; //@line 611 "sonic.cpp"
    if ($tobool) { __label__ = 14;; } else { __label__ = 15;; } //@line 611 "sonic.cpp"
    if (__label__ == 14) {
  
      var $55=$stream_addr; //@line 612 "sonic.cpp"
      var $prevPeriod=(($55+76)&4294967295); //@line 612 "sonic.cpp"
      var $56=HEAP32[(($prevPeriod)>>2)]; //@line 612 "sonic.cpp"
      $retPeriod=$56; //@line 612 "sonic.cpp"
      ; //@line 613 "sonic.cpp"
    }
    else if (__label__ == 15) {
  
      var $57=$period; //@line 614 "sonic.cpp"
      $retPeriod=$57; //@line 614 "sonic.cpp"
      ;
    }
  
    var $58=HEAP32[(($minDiff)>>2)]; //@line 616 "sonic.cpp"
    var $59=$stream_addr; //@line 616 "sonic.cpp"
    var $prevMinDiff=(($59+84)&4294967295); //@line 616 "sonic.cpp"
    HEAP32[(($prevMinDiff)>>2)]=$58; //@line 616 "sonic.cpp"
    var $60=HEAP32[(($maxDiff)>>2)]; //@line 617 "sonic.cpp"
    var $61=$stream_addr; //@line 617 "sonic.cpp"
    var $prevMaxDiff=(($61+80)&4294967295); //@line 617 "sonic.cpp"
    HEAP32[(($prevMaxDiff)>>2)]=$60; //@line 617 "sonic.cpp"
    var $62=$period; //@line 618 "sonic.cpp"
    var $63=$stream_addr; //@line 618 "sonic.cpp"
    var $prevPeriod37=(($63+76)&4294967295); //@line 618 "sonic.cpp"
    HEAP32[(($prevPeriod37)>>2)]=$62; //@line 618 "sonic.cpp"
    var $64=$retPeriod; //@line 619 "sonic.cpp"
    STACKTOP = __stackBase__;
    return $64; //@line 619 "sonic.cpp"
    return null;
  }
  

  function __ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($stream, $numSamples) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $numSamples_addr;
    $stream_addr=$stream;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 216 "sonic.cpp"
    var $numOutputSamples=(($0+48)&4294967295); //@line 216 "sonic.cpp"
    var $1=HEAP32[(($numOutputSamples)>>2)]; //@line 216 "sonic.cpp"
    var $2=$numSamples_addr; //@line 216 "sonic.cpp"
    var $add=((($2)+($1))&4294967295); //@line 216 "sonic.cpp"
    var $3=$stream_addr; //@line 216 "sonic.cpp"
    var $outputBufferSize=(($3+40)&4294967295); //@line 216 "sonic.cpp"
    var $4=HEAP32[(($outputBufferSize)>>2)]; //@line 216 "sonic.cpp"
    var $cmp=((($add))|0) > ((($4))|0); //@line 216 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 216 "sonic.cpp"
    $if_then$$if_end11$2: do { 
      if (__label__ == 1) {
  
        var $5=$stream_addr; //@line 217 "sonic.cpp"
        var $outputBufferSize1=(($5+40)&4294967295); //@line 217 "sonic.cpp"
        var $6=HEAP32[(($outputBufferSize1)>>2)]; //@line 217 "sonic.cpp"
        var $shr=($6) >> 1; //@line 217 "sonic.cpp"
        var $7=$numSamples_addr; //@line 217 "sonic.cpp"
        var $8=$stream_addr; //@line 217 "sonic.cpp"
        var $outputBufferSize3=(($8+40)&4294967295); //@line 217 "sonic.cpp"
        var $9=HEAP32[(($outputBufferSize3)>>2)]; //@line 217 "sonic.cpp"
        var $add2=((($shr)+($7))&4294967295); //@line 217 "sonic.cpp"
        var $add4=((($add2)+($9))&4294967295); //@line 217 "sonic.cpp"
        HEAP32[(($outputBufferSize3)>>2)]=$add4; //@line 217 "sonic.cpp"
        var $10=$stream_addr; //@line 218 "sonic.cpp"
        var $outputBuffer=(($10+4)&4294967295); //@line 218 "sonic.cpp"
        var $11=HEAP32[(($outputBuffer)>>2)]; //@line 218 "sonic.cpp"
        var $12=$11; //@line 218 "sonic.cpp"
        var $13=$stream_addr; //@line 218 "sonic.cpp"
        var $outputBufferSize5=(($13+40)&4294967295); //@line 218 "sonic.cpp"
        var $14=HEAP32[(($outputBufferSize5)>>2)]; //@line 218 "sonic.cpp"
        var $15=$stream_addr; //@line 218 "sonic.cpp"
        var $numChannels=(($15+28)&4294967295); //@line 218 "sonic.cpp"
        var $16=HEAP32[(($numChannels)>>2)]; //@line 218 "sonic.cpp"
        var $mul=((($14)*2)&4294967295); //@line 218 "sonic.cpp"
        var $mul6=((($mul)*($16))&4294967295); //@line 218 "sonic.cpp"
        var $call=_realloc($12, $mul6); //@line 218 "sonic.cpp"
        var $17=$call; //@line 218 "sonic.cpp"
        var $18=$stream_addr; //@line 218 "sonic.cpp"
        var $outputBuffer7=(($18+4)&4294967295); //@line 218 "sonic.cpp"
        HEAP32[(($outputBuffer7)>>2)]=$17; //@line 218 "sonic.cpp"
        var $19=$stream_addr; //@line 220 "sonic.cpp"
        var $outputBuffer8=(($19+4)&4294967295); //@line 220 "sonic.cpp"
        var $20=HEAP32[(($outputBuffer8)>>2)]; //@line 220 "sonic.cpp"
        var $cmp9=((($20))|0)==0; //@line 220 "sonic.cpp"
        if (!($cmp9)) { __label__ = 3;break $if_then$$if_end11$2; } //@line 220 "sonic.cpp"
  
        $retval=0; //@line 221 "sonic.cpp"
        __label__ = 4;break $if_then$$if_end11$2; //@line 221 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=1; //@line 224 "sonic.cpp"
      ; //@line 224 "sonic.cpp"
    }
  
    var $21=$retval; //@line 225 "sonic.cpp"
    ;
    return $21; //@line 225 "sonic.cpp"
    return null;
  }
  

  function __ZL10overlapAddiiPsS_S_($numSamples, $numChannels, $out, $rampDown, $rampUp) {
    ;
    var __label__;
  
    var $numSamples_addr;
    var $numChannels_addr;
    var $out_addr;
    var $rampDown_addr;
    var $rampUp_addr;
    var $o;
    var $u;
    var $d;
    var $i;
    var $t;
    $numSamples_addr=$numSamples;
    $numChannels_addr=$numChannels;
    $out_addr=$out;
    $rampDown_addr=$rampDown;
    $rampUp_addr=$rampUp;
    $i=0; //@line 634 "sonic.cpp"
    var $0=$i; //@line 634 "sonic.cpp"
    var $1=$numChannels_addr; //@line 634 "sonic.cpp"
    var $cmp2=((($0))|0) < ((($1))|0); //@line 634 "sonic.cpp"
    if ($cmp2) { __label__ = 1;; } else { __label__ = 4;; } //@line 634 "sonic.cpp"
    $for_body$$for_end14$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $2=$out_addr; //@line 635 "sonic.cpp"
          var $3=$i; //@line 635 "sonic.cpp"
          var $add_ptr=(($2+2*$3)&4294967295); //@line 635 "sonic.cpp"
          $o=$add_ptr; //@line 635 "sonic.cpp"
          var $4=$rampUp_addr; //@line 636 "sonic.cpp"
          var $5=$i; //@line 636 "sonic.cpp"
          var $add_ptr1=(($4+2*$5)&4294967295); //@line 636 "sonic.cpp"
          $u=$add_ptr1; //@line 636 "sonic.cpp"
          var $6=$rampDown_addr; //@line 637 "sonic.cpp"
          var $7=$i; //@line 637 "sonic.cpp"
          var $add_ptr2=(($6+2*$7)&4294967295); //@line 637 "sonic.cpp"
          $d=$add_ptr2; //@line 637 "sonic.cpp"
          $t=0; //@line 638 "sonic.cpp"
          var $8=$t; //@line 638 "sonic.cpp"
          var $9=$numSamples_addr; //@line 638 "sonic.cpp"
          var $cmp41=((($8))|0) < ((($9))|0); //@line 638 "sonic.cpp"
          if ($cmp41) { __label__ = 2;; } else { __label__ = 3;; } //@line 638 "sonic.cpp"
          $for_body5$$for_inc12$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $10=$d; //@line 639 "sonic.cpp"
                var $11=HEAP16[(($10)>>1)]; //@line 639 "sonic.cpp"
                var $conv=(tempInt=(($11)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 639 "sonic.cpp"
                var $12=$numSamples_addr; //@line 639 "sonic.cpp"
                var $13=$t; //@line 639 "sonic.cpp"
                var $sub=((($12)-($13))&4294967295); //@line 639 "sonic.cpp"
                var $mul=((($sub)*($conv))&4294967295); //@line 639 "sonic.cpp"
                var $14=$u; //@line 639 "sonic.cpp"
                var $15=HEAP16[(($14)>>1)]; //@line 639 "sonic.cpp"
                var $conv6=(tempInt=(($15)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 639 "sonic.cpp"
                var $16=$t; //@line 639 "sonic.cpp"
                var $mul7=((($conv6)*($16))&4294967295); //@line 639 "sonic.cpp"
                var $add=((($mul7)+($mul))&4294967295); //@line 639 "sonic.cpp"
                var $17=$numSamples_addr; //@line 639 "sonic.cpp"
                var $div=((((($add))|0)/((($17))|0))|0); //@line 639 "sonic.cpp"
                var $conv8=((($div)) & 65535); //@line 639 "sonic.cpp"
                var $18=$o; //@line 639 "sonic.cpp"
                HEAP16[(($18)>>1)]=$conv8; //@line 639 "sonic.cpp"
                var $19=$numChannels_addr; //@line 640 "sonic.cpp"
                var $20=$o; //@line 640 "sonic.cpp"
                var $add_ptr9=(($20+2*$19)&4294967295); //@line 640 "sonic.cpp"
                $o=$add_ptr9; //@line 640 "sonic.cpp"
                var $21=$numChannels_addr; //@line 641 "sonic.cpp"
                var $22=$d; //@line 641 "sonic.cpp"
                var $add_ptr10=(($22+2*$21)&4294967295); //@line 641 "sonic.cpp"
                $d=$add_ptr10; //@line 641 "sonic.cpp"
                var $23=$numChannels_addr; //@line 642 "sonic.cpp"
                var $24=$u; //@line 642 "sonic.cpp"
                var $add_ptr11=(($24+2*$23)&4294967295); //@line 642 "sonic.cpp"
                $u=$add_ptr11; //@line 642 "sonic.cpp"
                var $25=$t; //@line 638 "sonic.cpp"
                var $inc=((($25)+1)&4294967295); //@line 638 "sonic.cpp"
                $t=$inc; //@line 638 "sonic.cpp"
                var $26=$t; //@line 638 "sonic.cpp"
                var $27=$numSamples_addr; //@line 638 "sonic.cpp"
                var $cmp4=((($26))|0) < ((($27))|0); //@line 638 "sonic.cpp"
                if ($cmp4) { __label__ = 2;continue ; } else { __label__ = 3;break $for_body5$$for_inc12$5; } //@line 638 "sonic.cpp"
              }
            }
          } while(0);
  
          var $28=$i; //@line 634 "sonic.cpp"
          var $inc13=((($28)+1)&4294967295); //@line 634 "sonic.cpp"
          $i=$inc13; //@line 634 "sonic.cpp"
          var $29=$i; //@line 634 "sonic.cpp"
          var $30=$numChannels_addr; //@line 634 "sonic.cpp"
          var $cmp=((($29))|0) < ((($30))|0); //@line 634 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 4;break $for_body$$for_end14$2; } //@line 634 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 645 "sonic.cpp"
    return;
  }
  

  function __ZL24overlapAddWithSeparationiiiPsS_S_($numSamples, $numChannels, $separation, $out, $rampDown, $rampUp) {
    ;
    var __label__;
  
    var $numSamples_addr;
    var $numChannels_addr;
    var $separation_addr;
    var $out_addr;
    var $rampDown_addr;
    var $rampUp_addr;
    var $o;
    var $u;
    var $d;
    var $i;
    var $t;
    $numSamples_addr=$numSamples;
    $numChannels_addr=$numChannels;
    $separation_addr=$separation;
    $out_addr=$out;
    $rampDown_addr=$rampDown;
    $rampUp_addr=$rampUp;
    $i=0; //@line 660 "sonic.cpp"
    var $0=$i; //@line 660 "sonic.cpp"
    var $1=$numChannels_addr; //@line 660 "sonic.cpp"
    var $cmp3=((($0))|0) < ((($1))|0); //@line 660 "sonic.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 9;; } //@line 660 "sonic.cpp"
    $for_body$$for_end33$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          var $2=$out_addr; //@line 661 "sonic.cpp"
          var $3=$i; //@line 661 "sonic.cpp"
          var $add_ptr=(($2+2*$3)&4294967295); //@line 661 "sonic.cpp"
          $o=$add_ptr; //@line 661 "sonic.cpp"
          var $4=$rampUp_addr; //@line 662 "sonic.cpp"
          var $5=$i; //@line 662 "sonic.cpp"
          var $add_ptr1=(($4+2*$5)&4294967295); //@line 662 "sonic.cpp"
          $u=$add_ptr1; //@line 662 "sonic.cpp"
          var $6=$rampDown_addr; //@line 663 "sonic.cpp"
          var $7=$i; //@line 663 "sonic.cpp"
          var $add_ptr2=(($6+2*$7)&4294967295); //@line 663 "sonic.cpp"
          $d=$add_ptr2; //@line 663 "sonic.cpp"
          $t=0; //@line 664 "sonic.cpp"
          var $8=$t; //@line 664 "sonic.cpp"
          var $9=$numSamples_addr; //@line 664 "sonic.cpp"
          var $10=$separation_addr; //@line 664 "sonic.cpp"
          var $add1=((($10)+($9))&4294967295); //@line 664 "sonic.cpp"
          var $cmp42=((($8))|0) < ((($add1))|0); //@line 664 "sonic.cpp"
          if ($cmp42) { __label__ = 2;; } else { __label__ = 8;; } //@line 664 "sonic.cpp"
          $for_body5$$for_inc31$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $11=$t; //@line 665 "sonic.cpp"
                var $12=$separation_addr; //@line 665 "sonic.cpp"
                var $cmp6=((($11))|0) < ((($12))|0); //@line 665 "sonic.cpp"
                if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 665 "sonic.cpp"
                if (__label__ == 3) {
  
                  var $13=$d; //@line 666 "sonic.cpp"
                  var $14=HEAP16[(($13)>>1)]; //@line 666 "sonic.cpp"
                  var $conv=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 666 "sonic.cpp"
                  var $15=$numSamples_addr; //@line 666 "sonic.cpp"
                  var $16=$t; //@line 666 "sonic.cpp"
                  var $sub=((($15)-($16))&4294967295); //@line 666 "sonic.cpp"
                  var $mul=((($sub)*($conv))&4294967295); //@line 666 "sonic.cpp"
                  var $17=$numSamples_addr; //@line 666 "sonic.cpp"
                  var $div=((((($mul))|0)/((($17))|0))|0); //@line 666 "sonic.cpp"
                  var $conv7=((($div)) & 65535); //@line 666 "sonic.cpp"
                  var $18=$o; //@line 666 "sonic.cpp"
                  HEAP16[(($18)>>1)]=$conv7; //@line 666 "sonic.cpp"
                  var $19=$numChannels_addr; //@line 667 "sonic.cpp"
                  var $20=$d; //@line 667 "sonic.cpp"
                  var $add_ptr8=(($20+2*$19)&4294967295); //@line 667 "sonic.cpp"
                  $d=$add_ptr8; //@line 667 "sonic.cpp"
                  ; //@line 668 "sonic.cpp"
                }
                else if (__label__ == 4) {
  
                  var $21=$t; //@line 668 "sonic.cpp"
                  var $22=$numSamples_addr; //@line 668 "sonic.cpp"
                  var $cmp9=((($21))|0) < ((($22))|0); //@line 668 "sonic.cpp"
                  if ($cmp9) { __label__ = 5;; } else { __label__ = 6;; } //@line 668 "sonic.cpp"
                  if (__label__ == 5) {
  
                    var $23=$d; //@line 669 "sonic.cpp"
                    var $24=HEAP16[(($23)>>1)]; //@line 669 "sonic.cpp"
                    var $conv11=(tempInt=(($24)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 669 "sonic.cpp"
                    var $25=$numSamples_addr; //@line 669 "sonic.cpp"
                    var $26=$t; //@line 669 "sonic.cpp"
                    var $sub12=((($25)-($26))&4294967295); //@line 669 "sonic.cpp"
                    var $mul13=((($sub12)*($conv11))&4294967295); //@line 669 "sonic.cpp"
                    var $27=$u; //@line 669 "sonic.cpp"
                    var $28=HEAP16[(($27)>>1)]; //@line 669 "sonic.cpp"
                    var $conv14=(tempInt=(($28)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 669 "sonic.cpp"
                    var $29=$t; //@line 669 "sonic.cpp"
                    var $30=$separation_addr; //@line 669 "sonic.cpp"
                    var $sub15=((($29)-($30))&4294967295); //@line 669 "sonic.cpp"
                    var $mul16=((($sub15)*($conv14))&4294967295); //@line 669 "sonic.cpp"
                    var $add17=((($mul16)+($mul13))&4294967295); //@line 669 "sonic.cpp"
                    var $31=$numSamples_addr; //@line 669 "sonic.cpp"
                    var $div18=((((($add17))|0)/((($31))|0))|0); //@line 669 "sonic.cpp"
                    var $conv19=((($div18)) & 65535); //@line 669 "sonic.cpp"
                    var $32=$o; //@line 669 "sonic.cpp"
                    HEAP16[(($32)>>1)]=$conv19; //@line 669 "sonic.cpp"
                    var $33=$numChannels_addr; //@line 670 "sonic.cpp"
                    var $34=$d; //@line 670 "sonic.cpp"
                    var $add_ptr20=(($34+2*$33)&4294967295); //@line 670 "sonic.cpp"
                    $d=$add_ptr20; //@line 670 "sonic.cpp"
                    var $35=$numChannels_addr; //@line 671 "sonic.cpp"
                    var $36=$u; //@line 671 "sonic.cpp"
                    var $add_ptr21=(($36+2*$35)&4294967295); //@line 671 "sonic.cpp"
                    $u=$add_ptr21; //@line 671 "sonic.cpp"
                    ; //@line 672 "sonic.cpp"
                  }
                  else if (__label__ == 6) {
  
                    var $37=$u; //@line 673 "sonic.cpp"
                    var $38=HEAP16[(($37)>>1)]; //@line 673 "sonic.cpp"
                    var $conv23=(tempInt=(($38)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 673 "sonic.cpp"
                    var $39=$t; //@line 673 "sonic.cpp"
                    var $40=$separation_addr; //@line 673 "sonic.cpp"
                    var $sub24=((($39)-($40))&4294967295); //@line 673 "sonic.cpp"
                    var $mul25=((($sub24)*($conv23))&4294967295); //@line 673 "sonic.cpp"
                    var $41=$numSamples_addr; //@line 673 "sonic.cpp"
                    var $div26=((((($mul25))|0)/((($41))|0))|0); //@line 673 "sonic.cpp"
                    var $conv27=((($div26)) & 65535); //@line 673 "sonic.cpp"
                    var $42=$o; //@line 673 "sonic.cpp"
                    HEAP16[(($42)>>1)]=$conv27; //@line 673 "sonic.cpp"
                    var $43=$numChannels_addr; //@line 674 "sonic.cpp"
                    var $44=$u; //@line 674 "sonic.cpp"
                    var $add_ptr28=(($44+2*$43)&4294967295); //@line 674 "sonic.cpp"
                    $u=$add_ptr28; //@line 674 "sonic.cpp"
                    ;
                  }
                }
  
                var $45=$numChannels_addr; //@line 676 "sonic.cpp"
                var $46=$o; //@line 676 "sonic.cpp"
                var $add_ptr30=(($46+2*$45)&4294967295); //@line 676 "sonic.cpp"
                $o=$add_ptr30; //@line 676 "sonic.cpp"
                var $47=$t; //@line 664 "sonic.cpp"
                var $inc=((($47)+1)&4294967295); //@line 664 "sonic.cpp"
                $t=$inc; //@line 664 "sonic.cpp"
                var $48=$t; //@line 664 "sonic.cpp"
                var $49=$numSamples_addr; //@line 664 "sonic.cpp"
                var $50=$separation_addr; //@line 664 "sonic.cpp"
                var $add=((($50)+($49))&4294967295); //@line 664 "sonic.cpp"
                var $cmp4=((($48))|0) < ((($add))|0); //@line 664 "sonic.cpp"
                if ($cmp4) { __label__ = 2;continue ; } else { __label__ = 8;break $for_body5$$for_inc31$5; } //@line 664 "sonic.cpp"
              }
            }
          } while(0);
  
          var $51=$i; //@line 660 "sonic.cpp"
          var $inc32=((($51)+1)&4294967295); //@line 660 "sonic.cpp"
          $i=$inc32; //@line 660 "sonic.cpp"
          var $52=$i; //@line 660 "sonic.cpp"
          var $53=$numChannels_addr; //@line 660 "sonic.cpp"
          var $cmp=((($52))|0) < ((($53))|0); //@line 660 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 9;break $for_body$$for_end33$2; } //@line 660 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 679 "sonic.cpp"
    return;
  }
  

  function __ZL18removePitchSamplesP17sonicStreamStructi($stream, $numSamples) {
    ;
    var __label__;
  
    var $stream_addr;
    var $numSamples_addr;
    var $numChannels;
    var $source;
    $stream_addr=$stream;
    $numSamples_addr=$numSamples;
    var $0=$stream_addr; //@line 710 "sonic.cpp"
    var $numChannels1=(($0+28)&4294967295); //@line 710 "sonic.cpp"
    var $1=HEAP32[(($numChannels1)>>2)]; //@line 710 "sonic.cpp"
    $numChannels=$1; //@line 710 "sonic.cpp"
    var $2=$stream_addr; //@line 711 "sonic.cpp"
    var $pitchBuffer=(($2+8)&4294967295); //@line 711 "sonic.cpp"
    var $3=HEAP32[(($pitchBuffer)>>2)]; //@line 711 "sonic.cpp"
    var $4=$numSamples_addr; //@line 711 "sonic.cpp"
    var $5=$numChannels; //@line 711 "sonic.cpp"
    var $mul=((($5)*($4))&4294967295); //@line 711 "sonic.cpp"
    var $add_ptr=(($3+2*$mul)&4294967295); //@line 711 "sonic.cpp"
    $source=$add_ptr; //@line 711 "sonic.cpp"
    var $6=$numSamples_addr; //@line 713 "sonic.cpp"
    var $cmp=((($6))|0)==0; //@line 713 "sonic.cpp"
    if ($cmp) { __label__ = 4;; } else { __label__ = 1;; } //@line 713 "sonic.cpp"
    if (__label__ == 1) {
  
      var $7=$numSamples_addr; //@line 716 "sonic.cpp"
      var $8=$stream_addr; //@line 716 "sonic.cpp"
      var $numPitchSamples=(($8+52)&4294967295); //@line 716 "sonic.cpp"
      var $9=HEAP32[(($numPitchSamples)>>2)]; //@line 716 "sonic.cpp"
      var $cmp2=((($7))|0)!=((($9))|0); //@line 716 "sonic.cpp"
      if ($cmp2) { __label__ = 2;; } else { __label__ = 3;; } //@line 716 "sonic.cpp"
      if (__label__ == 2) {
  
        var $10=$stream_addr; //@line 717 "sonic.cpp"
        var $pitchBuffer4=(($10+8)&4294967295); //@line 717 "sonic.cpp"
        var $11=HEAP32[(($pitchBuffer4)>>2)]; //@line 717 "sonic.cpp"
        var $12=$11; //@line 717 "sonic.cpp"
        var $13=$source; //@line 717 "sonic.cpp"
        var $14=$13; //@line 717 "sonic.cpp"
        var $15=$stream_addr; //@line 717 "sonic.cpp"
        var $numPitchSamples5=(($15+52)&4294967295); //@line 717 "sonic.cpp"
        var $16=HEAP32[(($numPitchSamples5)>>2)]; //@line 717 "sonic.cpp"
        var $17=$numSamples_addr; //@line 717 "sonic.cpp"
        var $sub=((($16)-($17))&4294967295); //@line 717 "sonic.cpp"
        var $18=$numChannels; //@line 717 "sonic.cpp"
        var $mul6=((($18)*2)&4294967295); //@line 717 "sonic.cpp"
        var $mul7=((($mul6)*($sub))&4294967295); //@line 717 "sonic.cpp"
        _llvm_memmove_p0i8_p0i8_i32($12, $14, $mul7, 1, 0); //@line 717 "sonic.cpp"
        ; //@line 719 "sonic.cpp"
      }
  
      var $19=$numSamples_addr; //@line 720 "sonic.cpp"
      var $20=$stream_addr; //@line 720 "sonic.cpp"
      var $numPitchSamples9=(($20+52)&4294967295); //@line 720 "sonic.cpp"
      var $21=HEAP32[(($numPitchSamples9)>>2)]; //@line 720 "sonic.cpp"
      var $sub10=((($21)-($19))&4294967295); //@line 720 "sonic.cpp"
      HEAP32[(($numPitchSamples9)>>2)]=$sub10; //@line 720 "sonic.cpp"
      ; //@line 721 "sonic.cpp"
    }
  
    ;
    return; //@line 721 "sonic.cpp"
    return;
  }
  

  function __ZL22findPitchPeriodInRangePsiiPiS0_($samples, $minPeriod, $maxPeriod, $retMinDiff, $retMaxDiff) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $samples_addr;
    var $minPeriod_addr;
    var $maxPeriod_addr;
    var $retMinDiff_addr;
    var $retMaxDiff_addr;
    var $period;
    var $bestPeriod;
    var $s;
    var $p;
    var $sVal;
    var $pVal;
    var $diff;
    var $minDiff;
    var $maxDiff;
    var $i;
    $samples_addr=$samples;
    $minPeriod_addr=$minPeriod;
    $maxPeriod_addr=$maxPeriod;
    $retMinDiff_addr=$retMinDiff;
    $retMaxDiff_addr=$retMaxDiff;
    $bestPeriod=0; //@line 521 "sonic.cpp"
    $minDiff=1; //@line 523 "sonic.cpp"
    $maxDiff=0; //@line 523 "sonic.cpp"
    var $0=$minPeriod_addr; //@line 526 "sonic.cpp"
    $period=$0; //@line 526 "sonic.cpp"
    var $1=$period; //@line 526 "sonic.cpp"
    var $2=$maxPeriod_addr; //@line 526 "sonic.cpp"
    var $cmp3=((($1))|0) <= ((($2))|0); //@line 526 "sonic.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 11;; } //@line 526 "sonic.cpp"
    $for_body$$for_end24$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          $diff=0; //@line 527 "sonic.cpp"
          var $3=$samples_addr; //@line 528 "sonic.cpp"
          $s=$3; //@line 528 "sonic.cpp"
          var $4=$samples_addr; //@line 529 "sonic.cpp"
          var $5=$period; //@line 529 "sonic.cpp"
          var $add_ptr=(($4+2*$5)&4294967295); //@line 529 "sonic.cpp"
          $p=$add_ptr; //@line 529 "sonic.cpp"
          $i=0; //@line 530 "sonic.cpp"
          var $6=$i; //@line 530 "sonic.cpp"
          var $7=$period; //@line 530 "sonic.cpp"
          var $cmp21=((($6))|0) < ((($7))|0); //@line 530 "sonic.cpp"
          if ($cmp21) { __label__ = 2;; } else { __label__ = 6;; } //@line 530 "sonic.cpp"
          $for_body3$$for_end$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $8=$s; //@line 531 "sonic.cpp"
                var $incdec_ptr=(($8+2)&4294967295); //@line 531 "sonic.cpp"
                $s=$incdec_ptr; //@line 531 "sonic.cpp"
                var $9=HEAP16[(($8)>>1)]; //@line 531 "sonic.cpp"
                $sVal=$9; //@line 531 "sonic.cpp"
                var $10=$p; //@line 532 "sonic.cpp"
                var $incdec_ptr4=(($10+2)&4294967295); //@line 532 "sonic.cpp"
                $p=$incdec_ptr4; //@line 532 "sonic.cpp"
                var $11=HEAP16[(($10)>>1)]; //@line 532 "sonic.cpp"
                $pVal=$11; //@line 532 "sonic.cpp"
                var $12=$sVal; //@line 533 "sonic.cpp"
                var $conv=(tempInt=(($12)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                var $13=$pVal; //@line 533 "sonic.cpp"
                var $conv5=(tempInt=(($13)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                var $cmp6=((($conv))|0) >= ((($conv5))|0); //@line 533 "sonic.cpp"
                if ($cmp6) { __label__ = 3;; } else { __label__ = 4;; } //@line 533 "sonic.cpp"
                if (__label__ == 3) {
  
                  var $14=$sVal; //@line 533 "sonic.cpp"
                  var $conv7=(tempInt=(($14)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $15=$pVal; //@line 533 "sonic.cpp"
                  var $conv8=(tempInt=(($15)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $sub=((($conv7)-($conv8))&4294967295); //@line 533 "sonic.cpp"
                  var $conv9=((($sub)) & 65535); //@line 533 "sonic.cpp"
                  __lastLabel__ = 3; ; //@line 533 "sonic.cpp"
                }
                else if (__label__ == 4) {
  
                  var $16=$pVal; //@line 533 "sonic.cpp"
                  var $conv10=(tempInt=(($16)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $17=$sVal; //@line 533 "sonic.cpp"
                  var $conv11=(tempInt=(($17)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 533 "sonic.cpp"
                  var $sub12=((($conv10)-($conv11))&4294967295); //@line 533 "sonic.cpp"
                  var $conv13=((($sub12)) & 65535); //@line 533 "sonic.cpp"
                  __lastLabel__ = 4; ; //@line 533 "sonic.cpp"
                }
  
                var $cond=__lastLabel__ == 3 ? $conv9 : ($conv13); //@line 533 "sonic.cpp"
                var $conv14=((($cond))&65535); //@line 533 "sonic.cpp"
                var $18=$diff; //@line 533 "sonic.cpp"
                var $add=((($18)+($conv14))&4294967295); //@line 533 "sonic.cpp"
                $diff=$add; //@line 533 "sonic.cpp"
                var $19=$i; //@line 530 "sonic.cpp"
                var $inc=((($19)+1)&4294967295); //@line 530 "sonic.cpp"
                $i=$inc; //@line 530 "sonic.cpp"
                var $20=$i; //@line 530 "sonic.cpp"
                var $21=$period; //@line 530 "sonic.cpp"
                var $cmp2=((($20))|0) < ((($21))|0); //@line 530 "sonic.cpp"
                if ($cmp2) { __label__ = 2;continue ; } else { __label__ = 6;break $for_body3$$for_end$5; } //@line 530 "sonic.cpp"
              }
            }
          } while(0);
  
          var $22=$diff; //@line 539 "sonic.cpp"
          var $23=$bestPeriod; //@line 539 "sonic.cpp"
          var $mul=((($23)*($22))&4294967295); //@line 539 "sonic.cpp"
          var $24=$minDiff; //@line 539 "sonic.cpp"
          var $25=$period; //@line 539 "sonic.cpp"
          var $mul15=((($25)*($24))&4294967295); //@line 539 "sonic.cpp"
          var $cmp16=((($mul))>>>0) < ((($mul15))>>>0); //@line 539 "sonic.cpp"
          if ($cmp16) { __label__ = 7;; } else { __label__ = 8;; } //@line 539 "sonic.cpp"
          if (__label__ == 7) {
  
            var $26=$diff; //@line 540 "sonic.cpp"
            $minDiff=$26; //@line 540 "sonic.cpp"
            var $27=$period; //@line 541 "sonic.cpp"
            $bestPeriod=$27; //@line 541 "sonic.cpp"
            ; //@line 542 "sonic.cpp"
          }
  
          var $28=$diff; //@line 543 "sonic.cpp"
          var $29=$bestPeriod; //@line 543 "sonic.cpp"
          var $mul17=((($29)*($28))&4294967295); //@line 543 "sonic.cpp"
          var $30=$maxDiff; //@line 543 "sonic.cpp"
          var $31=$period; //@line 543 "sonic.cpp"
          var $mul18=((($31)*($30))&4294967295); //@line 543 "sonic.cpp"
          var $cmp19=((($mul17))>>>0) > ((($mul18))>>>0); //@line 543 "sonic.cpp"
          if ($cmp19) { __label__ = 9;; } else { __label__ = 10;; } //@line 543 "sonic.cpp"
          if (__label__ == 9) {
  
            var $32=$diff; //@line 544 "sonic.cpp"
            $maxDiff=$32; //@line 544 "sonic.cpp"
            ; //@line 545 "sonic.cpp"
          }
  
          var $33=$period; //@line 526 "sonic.cpp"
          var $inc23=((($33)+1)&4294967295); //@line 526 "sonic.cpp"
          $period=$inc23; //@line 526 "sonic.cpp"
          var $34=$period; //@line 526 "sonic.cpp"
          var $35=$maxPeriod_addr; //@line 526 "sonic.cpp"
          var $cmp=((($34))|0) <= ((($35))|0); //@line 526 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 11;break $for_body$$for_end24$2; } //@line 526 "sonic.cpp"
        }
      }
    } while(0);
  
    var $36=$minDiff; //@line 547 "sonic.cpp"
    var $37=$retMinDiff_addr; //@line 547 "sonic.cpp"
    HEAP32[(($37)>>2)]=$36; //@line 547 "sonic.cpp"
    var $38=$maxDiff; //@line 548 "sonic.cpp"
    var $39=$retMaxDiff_addr; //@line 548 "sonic.cpp"
    HEAP32[(($39)>>2)]=$38; //@line 548 "sonic.cpp"
    var $40=$bestPeriod; //@line 549 "sonic.cpp"
    ;
    return $40; //@line 549 "sonic.cpp"
    return null;
  }
  

  function __ZL15downSampleInputP17sonicStreamStructPsi($stream, $samples, $skip) {
    ;
    var __label__;
  
    var $stream_addr;
    var $samples_addr;
    var $skip_addr;
    var $numSamples;
    var $samplesPerValue;
    var $i;
    var $j;
    var $value;
    var $downSamples;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $skip_addr=$skip;
    var $0=$stream_addr; //@line 496 "sonic.cpp"
    var $maxRequired=(($0+64)&4294967295); //@line 496 "sonic.cpp"
    var $1=HEAP32[(($maxRequired)>>2)]; //@line 496 "sonic.cpp"
    var $2=$skip_addr; //@line 496 "sonic.cpp"
    var $div=((((($1))|0)/((($2))|0))|0); //@line 496 "sonic.cpp"
    $numSamples=$div; //@line 496 "sonic.cpp"
    var $3=$stream_addr; //@line 497 "sonic.cpp"
    var $numChannels=(($3+28)&4294967295); //@line 497 "sonic.cpp"
    var $4=HEAP32[(($numChannels)>>2)]; //@line 497 "sonic.cpp"
    var $5=$skip_addr; //@line 497 "sonic.cpp"
    var $mul=((($5)*($4))&4294967295); //@line 497 "sonic.cpp"
    $samplesPerValue=$mul; //@line 497 "sonic.cpp"
    var $6=$stream_addr; //@line 500 "sonic.cpp"
    var $downSampleBuffer=(($6+12)&4294967295); //@line 500 "sonic.cpp"
    var $7=HEAP32[(($downSampleBuffer)>>2)]; //@line 500 "sonic.cpp"
    $downSamples=$7; //@line 500 "sonic.cpp"
    $i=0; //@line 502 "sonic.cpp"
    var $8=$i; //@line 502 "sonic.cpp"
    var $9=$numSamples; //@line 502 "sonic.cpp"
    var $cmp3=((($8))|0) < ((($9))|0); //@line 502 "sonic.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 4;; } //@line 502 "sonic.cpp"
    $for_body$$for_end9$2: do { 
      if (__label__ == 1) {
        $for_body$3: while(1) { 
  
          $value=0; //@line 503 "sonic.cpp"
          $j=0; //@line 504 "sonic.cpp"
          var $10=$j; //@line 504 "sonic.cpp"
          var $11=$samplesPerValue; //@line 504 "sonic.cpp"
          var $cmp21=((($10))|0) < ((($11))|0); //@line 504 "sonic.cpp"
          if ($cmp21) { __label__ = 2;; } else { __label__ = 3;; } //@line 504 "sonic.cpp"
          $for_body3$$for_end$5: do { 
            if (__label__ == 2) {
              while(1) { 
  
                var $12=$samples_addr; //@line 505 "sonic.cpp"
                var $incdec_ptr=(($12+2)&4294967295); //@line 505 "sonic.cpp"
                $samples_addr=$incdec_ptr; //@line 505 "sonic.cpp"
                var $13=HEAP16[(($12)>>1)]; //@line 505 "sonic.cpp"
                var $conv=(tempInt=(($13)),(tempInt>=32768?tempInt-65536:tempInt)); //@line 505 "sonic.cpp"
                var $14=$value; //@line 505 "sonic.cpp"
                var $add=((($14)+($conv))&4294967295); //@line 505 "sonic.cpp"
                $value=$add; //@line 505 "sonic.cpp"
                var $15=$j; //@line 504 "sonic.cpp"
                var $inc=((($15)+1)&4294967295); //@line 504 "sonic.cpp"
                $j=$inc; //@line 504 "sonic.cpp"
                var $16=$j; //@line 504 "sonic.cpp"
                var $17=$samplesPerValue; //@line 504 "sonic.cpp"
                var $cmp2=((($16))|0) < ((($17))|0); //@line 504 "sonic.cpp"
                if ($cmp2) { __label__ = 2;continue ; } else { __label__ = 3;break $for_body3$$for_end$5; } //@line 504 "sonic.cpp"
              }
            }
          } while(0);
  
          var $18=$samplesPerValue; //@line 507 "sonic.cpp"
          var $19=$value; //@line 507 "sonic.cpp"
          var $div4=((((($19))|0)/((($18))|0))|0); //@line 507 "sonic.cpp"
          $value=$div4; //@line 507 "sonic.cpp"
          var $20=$value; //@line 508 "sonic.cpp"
          var $conv5=((($20)) & 65535); //@line 508 "sonic.cpp"
          var $21=$downSamples; //@line 508 "sonic.cpp"
          var $incdec_ptr6=(($21+2)&4294967295); //@line 508 "sonic.cpp"
          $downSamples=$incdec_ptr6; //@line 508 "sonic.cpp"
          HEAP16[(($21)>>1)]=$conv5; //@line 508 "sonic.cpp"
          var $22=$i; //@line 502 "sonic.cpp"
          var $inc8=((($22)+1)&4294967295); //@line 502 "sonic.cpp"
          $i=$inc8; //@line 502 "sonic.cpp"
          var $23=$i; //@line 502 "sonic.cpp"
          var $24=$numSamples; //@line 502 "sonic.cpp"
          var $cmp=((($23))|0) < ((($24))|0); //@line 502 "sonic.cpp"
          if ($cmp) { __label__ = 1;continue $for_body$3; } else { __label__ = 4;break $for_body$$for_end9$2; } //@line 502 "sonic.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 510 "sonic.cpp"
    return;
  }
  

  function __ZL16prevPeriodBetterP17sonicStreamStructiii($stream, $period, $minDiff, $maxDiff) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $period_addr;
    var $minDiff_addr;
    var $maxDiff_addr;
    $stream_addr=$stream;
    $period_addr=$period;
    $minDiff_addr=$minDiff;
    $maxDiff_addr=$maxDiff;
    var $0=$maxDiff_addr; //@line 560 "sonic.cpp"
    var $mul=((($0)*3)&4294967295); //@line 560 "sonic.cpp"
    var $div=((((($mul))|0)/2)|0); //@line 560 "sonic.cpp"
    var $1=$stream_addr; //@line 560 "sonic.cpp"
    var $prevMaxDiff=(($1+80)&4294967295); //@line 560 "sonic.cpp"
    var $2=HEAP32[(($prevMaxDiff)>>2)]; //@line 560 "sonic.cpp"
    var $cmp=((($div))|0) < ((($2))|0); //@line 560 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 560 "sonic.cpp"
    $land_lhs_true$$if_end$2: do { 
      if (__label__ == 1) {
  
        var $3=$maxDiff_addr; //@line 560 "sonic.cpp"
        var $conv=((($3))|0); //@line 560 "sonic.cpp"
        var $mul1=($conv)*3; //@line 560 "sonic.cpp"
        var $4=$stream_addr; //@line 560 "sonic.cpp"
        var $prevMinDiff=(($4+84)&4294967295); //@line 560 "sonic.cpp"
        var $5=HEAP32[(($prevMinDiff)>>2)]; //@line 560 "sonic.cpp"
        var $conv2=((($5))|0); //@line 560 "sonic.cpp"
        var $mul3=($mul1)*($conv2); //@line 560 "sonic.cpp"
        var $6=$stream_addr; //@line 560 "sonic.cpp"
        var $prevMaxDiff4=(($6+80)&4294967295); //@line 560 "sonic.cpp"
        var $7=HEAP32[(($prevMaxDiff4)>>2)]; //@line 560 "sonic.cpp"
        var $conv5=((($7))|0); //@line 560 "sonic.cpp"
        var $8=$minDiff_addr; //@line 560 "sonic.cpp"
        var $conv6=((($8))|0); //@line 560 "sonic.cpp"
        var $mul7=($conv5)*($conv6); //@line 560 "sonic.cpp"
        var $mul8=($mul7)*2; //@line 560 "sonic.cpp"
        var $cmp9=($mul3) < ($mul8); //@line 560 "sonic.cpp"
        if (!($cmp9)) { __label__ = 3;break $land_lhs_true$$if_end$2; } //@line 560 "sonic.cpp"
  
        $retval=1; //@line 562 "sonic.cpp"
        __label__ = 4;break $land_lhs_true$$if_end$2; //@line 562 "sonic.cpp"
      }
    } while(0);
    if (__label__ == 3) {
  
      $retval=0; //@line 564 "sonic.cpp"
      ; //@line 564 "sonic.cpp"
    }
  
    var $9=$retval; //@line 565 "sonic.cpp"
    ;
    return $9; //@line 565 "sonic.cpp"
    return null;
  }
  

  function __ZL17copyInputToOutputP17sonicStreamStructi($stream, $position) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $position_addr;
    var $numSamples;
    $stream_addr=$stream;
    $position_addr=$position;
    var $0=$stream_addr; //@line 342 "sonic.cpp"
    var $remainingInputToCopy=(($0+68)&4294967295); //@line 342 "sonic.cpp"
    var $1=HEAP32[(($remainingInputToCopy)>>2)]; //@line 342 "sonic.cpp"
    $numSamples=$1; //@line 342 "sonic.cpp"
    var $2=$numSamples; //@line 344 "sonic.cpp"
    var $3=$stream_addr; //@line 344 "sonic.cpp"
    var $maxRequired=(($3+64)&4294967295); //@line 344 "sonic.cpp"
    var $4=HEAP32[(($maxRequired)>>2)]; //@line 344 "sonic.cpp"
    var $cmp=((($2))|0) > ((($4))|0); //@line 344 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 344 "sonic.cpp"
    if (__label__ == 1) {
  
      var $5=$stream_addr; //@line 345 "sonic.cpp"
      var $maxRequired1=(($5+64)&4294967295); //@line 345 "sonic.cpp"
      var $6=HEAP32[(($maxRequired1)>>2)]; //@line 345 "sonic.cpp"
      $numSamples=$6; //@line 345 "sonic.cpp"
      ; //@line 346 "sonic.cpp"
    }
  
    var $7=$stream_addr; //@line 347 "sonic.cpp"
    var $8=$stream_addr; //@line 347 "sonic.cpp"
    var $inputBuffer=(($8)&4294967295); //@line 347 "sonic.cpp"
    var $9=HEAP32[(($inputBuffer)>>2)]; //@line 347 "sonic.cpp"
    var $10=$position_addr; //@line 347 "sonic.cpp"
    var $11=$stream_addr; //@line 347 "sonic.cpp"
    var $numChannels=(($11+28)&4294967295); //@line 347 "sonic.cpp"
    var $12=HEAP32[(($numChannels)>>2)]; //@line 347 "sonic.cpp"
    var $mul=((($12)*($10))&4294967295); //@line 347 "sonic.cpp"
    var $add_ptr=(($9+2*$mul)&4294967295); //@line 347 "sonic.cpp"
    var $13=$numSamples; //@line 347 "sonic.cpp"
    var $call=__ZL12copyToOutputP17sonicStreamStructPsi($7, $add_ptr, $13); //@line 347 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 347 "sonic.cpp"
    if ($tobool) { __label__ = 4;; } else { __label__ = 3;; } //@line 347 "sonic.cpp"
    if (__label__ == 4) {
  
      var $14=$numSamples; //@line 351 "sonic.cpp"
      var $15=$stream_addr; //@line 351 "sonic.cpp"
      var $remainingInputToCopy4=(($15+68)&4294967295); //@line 351 "sonic.cpp"
      var $16=HEAP32[(($remainingInputToCopy4)>>2)]; //@line 351 "sonic.cpp"
      var $sub=((($16)-($14))&4294967295); //@line 351 "sonic.cpp"
      HEAP32[(($remainingInputToCopy4)>>2)]=$sub; //@line 351 "sonic.cpp"
      var $17=$numSamples; //@line 352 "sonic.cpp"
      $retval=$17; //@line 352 "sonic.cpp"
      ; //@line 352 "sonic.cpp"
    }
    else if (__label__ == 3) {
  
      $retval=0; //@line 349 "sonic.cpp"
      ; //@line 349 "sonic.cpp"
    }
  
    var $18=$retval; //@line 353 "sonic.cpp"
    ;
    return $18; //@line 353 "sonic.cpp"
    return null;
  }
  

  function __ZL15skipPitchPeriodP17sonicStreamStructPsfi($stream, $samples, $speed, $period) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $speed_addr;
    var $period_addr;
    var $newSamples;
    var $numChannels;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $speed_addr=$speed;
    $period_addr=$period;
    var $0=$stream_addr; //@line 773 "sonic.cpp"
    var $numChannels1=(($0+28)&4294967295); //@line 773 "sonic.cpp"
    var $1=HEAP32[(($numChannels1)>>2)]; //@line 773 "sonic.cpp"
    $numChannels=$1; //@line 773 "sonic.cpp"
    var $2=$speed_addr; //@line 775 "sonic.cpp"
    var $cmp=($2) >= 2; //@line 775 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 775 "sonic.cpp"
    $if_then$$if_else$2: do { 
      if (__label__ == 1) {
  
        var $3=$period_addr; //@line 776 "sonic.cpp"
        var $conv=((($3))|0); //@line 776 "sonic.cpp"
        var $4=$speed_addr; //@line 776 "sonic.cpp"
        var $sub=($4)-1; //@line 776 "sonic.cpp"
        var $div=($conv)/($sub); //@line 776 "sonic.cpp"
        var $conv2=((($div))|0); //@line 776 "sonic.cpp"
        $newSamples=$conv2; //@line 776 "sonic.cpp"
        ; //@line 777 "sonic.cpp"
      }
      else if (__label__ == 2) {
  
        var $5=$speed_addr; //@line 777 "sonic.cpp"
        var $cmp3=($5) > 1; //@line 777 "sonic.cpp"
        if (!($cmp3)) { __label__ = 4;break $if_then$$if_else$2; } //@line 777 "sonic.cpp"
  
        var $6=$period_addr; //@line 778 "sonic.cpp"
        $newSamples=$6; //@line 778 "sonic.cpp"
        var $7=$period_addr; //@line 779 "sonic.cpp"
        var $conv5=((($7))|0); //@line 779 "sonic.cpp"
        var $8=$speed_addr; //@line 779 "sonic.cpp"
        var $sub6=2-($8); //@line 779 "sonic.cpp"
        var $mul=($conv5)*($sub6); //@line 779 "sonic.cpp"
        var $9=$speed_addr; //@line 779 "sonic.cpp"
        var $sub7=($9)-1; //@line 779 "sonic.cpp"
        var $div8=($mul)/($sub7); //@line 779 "sonic.cpp"
        var $conv9=((($div8))|0); //@line 779 "sonic.cpp"
        var $10=$stream_addr; //@line 779 "sonic.cpp"
        var $remainingInputToCopy=(($10+68)&4294967295); //@line 779 "sonic.cpp"
        HEAP32[(($remainingInputToCopy)>>2)]=$conv9; //@line 779 "sonic.cpp"
        ; //@line 780 "sonic.cpp"
      }
    } while(0);
  
    var $11=$stream_addr; //@line 781 "sonic.cpp"
    var $12=$newSamples; //@line 781 "sonic.cpp"
    var $call=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($11, $12); //@line 781 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 781 "sonic.cpp"
    if ($tobool) { __label__ = 6;; } else { __label__ = 5;; } //@line 781 "sonic.cpp"
    if (__label__ == 6) {
  
      var $13=$newSamples; //@line 784 "sonic.cpp"
      var $14=$numChannels; //@line 784 "sonic.cpp"
      var $15=$stream_addr; //@line 784 "sonic.cpp"
      var $outputBuffer=(($15+4)&4294967295); //@line 784 "sonic.cpp"
      var $16=HEAP32[(($outputBuffer)>>2)]; //@line 784 "sonic.cpp"
      var $17=$stream_addr; //@line 784 "sonic.cpp"
      var $numOutputSamples=(($17+48)&4294967295); //@line 784 "sonic.cpp"
      var $18=HEAP32[(($numOutputSamples)>>2)]; //@line 784 "sonic.cpp"
      var $19=$numChannels; //@line 784 "sonic.cpp"
      var $mul13=((($19)*($18))&4294967295); //@line 784 "sonic.cpp"
      var $add_ptr=(($16+2*$mul13)&4294967295); //@line 784 "sonic.cpp"
      var $20=$samples_addr; //@line 784 "sonic.cpp"
      var $21=$samples_addr; //@line 784 "sonic.cpp"
      var $22=$period_addr; //@line 784 "sonic.cpp"
      var $23=$numChannels; //@line 784 "sonic.cpp"
      var $mul14=((($23)*($22))&4294967295); //@line 784 "sonic.cpp"
      var $add_ptr15=(($21+2*$mul14)&4294967295); //@line 784 "sonic.cpp"
      __ZL10overlapAddiiPsS_S_($13, $14, $add_ptr, $20, $add_ptr15); //@line 784 "sonic.cpp"
      var $24=$newSamples; //@line 786 "sonic.cpp"
      var $25=$stream_addr; //@line 786 "sonic.cpp"
      var $numOutputSamples16=(($25+48)&4294967295); //@line 786 "sonic.cpp"
      var $26=HEAP32[(($numOutputSamples16)>>2)]; //@line 786 "sonic.cpp"
      var $add=((($26)+($24))&4294967295); //@line 786 "sonic.cpp"
      HEAP32[(($numOutputSamples16)>>2)]=$add; //@line 786 "sonic.cpp"
      var $27=$newSamples; //@line 787 "sonic.cpp"
      $retval=$27; //@line 787 "sonic.cpp"
      ; //@line 787 "sonic.cpp"
    }
    else if (__label__ == 5) {
  
      $retval=0; //@line 782 "sonic.cpp"
      ; //@line 782 "sonic.cpp"
    }
  
    var $28=$retval; //@line 788 "sonic.cpp"
    ;
    return $28; //@line 788 "sonic.cpp"
    return null;
  }
  

  function __ZL17insertPitchPeriodP17sonicStreamStructPsfi($stream, $samples, $speed, $period) {
    ;
    var __label__;
  
    var $retval;
    var $stream_addr;
    var $samples_addr;
    var $speed_addr;
    var $period_addr;
    var $newSamples;
    var $out;
    var $numChannels;
    $stream_addr=$stream;
    $samples_addr=$samples;
    $speed_addr=$speed;
    $period_addr=$period;
    var $0=$stream_addr; //@line 799 "sonic.cpp"
    var $numChannels1=(($0+28)&4294967295); //@line 799 "sonic.cpp"
    var $1=HEAP32[(($numChannels1)>>2)]; //@line 799 "sonic.cpp"
    $numChannels=$1; //@line 799 "sonic.cpp"
    var $2=$speed_addr; //@line 801 "sonic.cpp"
    var $cmp=($2) < 0.5; //@line 801 "sonic.cpp"
    var $3=$period_addr; //@line 802 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 801 "sonic.cpp"
    if (__label__ == 1) {
  
      var $conv=((($3))|0); //@line 802 "sonic.cpp"
      var $4=$speed_addr; //@line 802 "sonic.cpp"
      var $mul=($conv)*($4); //@line 802 "sonic.cpp"
      var $5=$speed_addr; //@line 802 "sonic.cpp"
      var $sub=1-($5); //@line 802 "sonic.cpp"
      var $div=($mul)/($sub); //@line 802 "sonic.cpp"
      var $conv2=((($div))|0); //@line 802 "sonic.cpp"
      $newSamples=$conv2; //@line 802 "sonic.cpp"
      ; //@line 803 "sonic.cpp"
    }
    else if (__label__ == 2) {
  
      $newSamples=$3; //@line 804 "sonic.cpp"
      var $6=$period_addr; //@line 805 "sonic.cpp"
      var $conv3=((($6))|0); //@line 805 "sonic.cpp"
      var $7=$speed_addr; //@line 805 "sonic.cpp"
      var $mul4=2*($7); //@line 805 "sonic.cpp"
      var $sub5=($mul4)-1; //@line 805 "sonic.cpp"
      var $mul6=($conv3)*($sub5); //@line 805 "sonic.cpp"
      var $8=$speed_addr; //@line 805 "sonic.cpp"
      var $sub7=1-($8); //@line 805 "sonic.cpp"
      var $div8=($mul6)/($sub7); //@line 805 "sonic.cpp"
      var $conv9=((($div8))|0); //@line 805 "sonic.cpp"
      var $9=$stream_addr; //@line 805 "sonic.cpp"
      var $remainingInputToCopy=(($9+68)&4294967295); //@line 805 "sonic.cpp"
      HEAP32[(($remainingInputToCopy)>>2)]=$conv9; //@line 805 "sonic.cpp"
      ;
    }
  
    var $10=$stream_addr; //@line 807 "sonic.cpp"
    var $11=$period_addr; //@line 807 "sonic.cpp"
    var $12=$newSamples; //@line 807 "sonic.cpp"
    var $add=((($12)+($11))&4294967295); //@line 807 "sonic.cpp"
    var $call=__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi($10, $add); //@line 807 "sonic.cpp"
    var $tobool=((($call))|0)!=0; //@line 807 "sonic.cpp"
    if ($tobool) { __label__ = 5;; } else { __label__ = 4;; } //@line 807 "sonic.cpp"
    if (__label__ == 5) {
  
      var $13=$stream_addr; //@line 810 "sonic.cpp"
      var $outputBuffer=(($13+4)&4294967295); //@line 810 "sonic.cpp"
      var $14=HEAP32[(($outputBuffer)>>2)]; //@line 810 "sonic.cpp"
      var $15=$stream_addr; //@line 810 "sonic.cpp"
      var $numOutputSamples=(($15+48)&4294967295); //@line 810 "sonic.cpp"
      var $16=HEAP32[(($numOutputSamples)>>2)]; //@line 810 "sonic.cpp"
      var $17=$numChannels; //@line 810 "sonic.cpp"
      var $mul12=((($17)*($16))&4294967295); //@line 810 "sonic.cpp"
      var $add_ptr=(($14+2*$mul12)&4294967295); //@line 810 "sonic.cpp"
      $out=$add_ptr; //@line 810 "sonic.cpp"
      var $18=$out; //@line 811 "sonic.cpp"
      var $19=$18; //@line 811 "sonic.cpp"
      var $20=$samples_addr; //@line 811 "sonic.cpp"
      var $21=$20; //@line 811 "sonic.cpp"
      var $22=$period_addr; //@line 811 "sonic.cpp"
      var $23=$numChannels; //@line 811 "sonic.cpp"
      var $mul13=((($22)*2)&4294967295); //@line 811 "sonic.cpp"
      var $mul14=((($mul13)*($23))&4294967295); //@line 811 "sonic.cpp"
      var $src$, $dest$, $stop$, $stop4$, $fast$;
      $src$ = $21;
      $dest$ = $19;
      $stop$ = $src$ + $mul14;
      if (($dest$%4) == ($src$%4) && $mul14 > 8) {
        while ($src$%4 !== 0 && $src$ < $stop$) {
          ; HEAP8[$dest$++] = HEAP8[$src$++];
        }
        $src$ >>= 2;
        $dest$ >>= 2;
        $stop4$ = $stop$ >> 2;
        while ($src$ < $stop4$) {
      ;;;    HEAP32[$dest$++] = HEAP32[$src$++];
        }
        $src$ <<= 2;
        $dest$ <<= 2;
      }while ($src$ < $stop$) {
        ; HEAP8[$dest$++] = HEAP8[$src$++];
      }; //@line 811 "sonic.cpp"
      var $24=$stream_addr; //@line 812 "sonic.cpp"
      var $outputBuffer15=(($24+4)&4294967295); //@line 812 "sonic.cpp"
      var $25=HEAP32[(($outputBuffer15)>>2)]; //@line 812 "sonic.cpp"
      var $26=$stream_addr; //@line 812 "sonic.cpp"
      var $numOutputSamples16=(($26+48)&4294967295); //@line 812 "sonic.cpp"
      var $27=HEAP32[(($numOutputSamples16)>>2)]; //@line 812 "sonic.cpp"
      var $28=$period_addr; //@line 812 "sonic.cpp"
      var $add17=((($28)+($27))&4294967295); //@line 812 "sonic.cpp"
      var $29=$numChannels; //@line 812 "sonic.cpp"
      var $mul18=((($add17)*($29))&4294967295); //@line 812 "sonic.cpp"
      var $add_ptr19=(($25+2*$mul18)&4294967295); //@line 812 "sonic.cpp"
      $out=$add_ptr19; //@line 812 "sonic.cpp"
      var $30=$newSamples; //@line 813 "sonic.cpp"
      var $31=$numChannels; //@line 813 "sonic.cpp"
      var $32=$out; //@line 813 "sonic.cpp"
      var $33=$samples_addr; //@line 813 "sonic.cpp"
      var $34=$period_addr; //@line 813 "sonic.cpp"
      var $35=$numChannels; //@line 813 "sonic.cpp"
      var $mul20=((($35)*($34))&4294967295); //@line 813 "sonic.cpp"
      var $add_ptr21=(($33+2*$mul20)&4294967295); //@line 813 "sonic.cpp"
      var $36=$samples_addr; //@line 813 "sonic.cpp"
      __ZL10overlapAddiiPsS_S_($30, $31, $32, $add_ptr21, $36); //@line 813 "sonic.cpp"
      var $37=$period_addr; //@line 814 "sonic.cpp"
      var $38=$newSamples; //@line 814 "sonic.cpp"
      var $39=$stream_addr; //@line 814 "sonic.cpp"
      var $numOutputSamples23=(($39+48)&4294967295); //@line 814 "sonic.cpp"
      var $40=HEAP32[(($numOutputSamples23)>>2)]; //@line 814 "sonic.cpp"
      var $add22=((($38)+($37))&4294967295); //@line 814 "sonic.cpp"
      var $add24=((($add22)+($40))&4294967295); //@line 814 "sonic.cpp"
      HEAP32[(($numOutputSamples23)>>2)]=$add24; //@line 814 "sonic.cpp"
      var $41=$newSamples; //@line 815 "sonic.cpp"
      $retval=$41; //@line 815 "sonic.cpp"
      ; //@line 815 "sonic.cpp"
    }
    else if (__label__ == 4) {
  
      $retval=0; //@line 808 "sonic.cpp"
      ; //@line 808 "sonic.cpp"
    }
  
    var $42=$retval; //@line 816 "sonic.cpp"
    ;
    return $42; //@line 816 "sonic.cpp"
    return null;
  }
  

  function __ZL18removeInputSamplesP17sonicStreamStructi($stream, $position) {
    ;
    var __label__;
  
    var $stream_addr;
    var $position_addr;
    var $remainingSamples;
    $stream_addr=$stream;
    $position_addr=$position;
    var $0=$stream_addr; //@line 312 "sonic.cpp"
    var $numInputSamples=(($0+44)&4294967295); //@line 312 "sonic.cpp"
    var $1=HEAP32[(($numInputSamples)>>2)]; //@line 312 "sonic.cpp"
    var $2=$position_addr; //@line 312 "sonic.cpp"
    var $sub=((($1)-($2))&4294967295); //@line 312 "sonic.cpp"
    $remainingSamples=$sub; //@line 312 "sonic.cpp"
    var $3=$remainingSamples; //@line 314 "sonic.cpp"
    var $cmp=((($3))|0) > 0; //@line 314 "sonic.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 2;; } //@line 314 "sonic.cpp"
    if (__label__ == 1) {
  
      var $4=$stream_addr; //@line 315 "sonic.cpp"
      var $inputBuffer=(($4)&4294967295); //@line 315 "sonic.cpp"
      var $5=HEAP32[(($inputBuffer)>>2)]; //@line 315 "sonic.cpp"
      var $6=$5; //@line 315 "sonic.cpp"
      var $7=$stream_addr; //@line 315 "sonic.cpp"
      var $inputBuffer1=(($7)&4294967295); //@line 315 "sonic.cpp"
      var $8=HEAP32[(($inputBuffer1)>>2)]; //@line 315 "sonic.cpp"
      var $9=$position_addr; //@line 315 "sonic.cpp"
      var $10=$stream_addr; //@line 315 "sonic.cpp"
      var $numChannels=(($10+28)&4294967295); //@line 315 "sonic.cpp"
      var $11=HEAP32[(($numChannels)>>2)]; //@line 315 "sonic.cpp"
      var $mul=((($11)*($9))&4294967295); //@line 315 "sonic.cpp"
      var $add_ptr=(($8+2*$mul)&4294967295); //@line 315 "sonic.cpp"
      var $12=$add_ptr; //@line 315 "sonic.cpp"
      var $13=$remainingSamples; //@line 315 "sonic.cpp"
      var $14=$stream_addr; //@line 315 "sonic.cpp"
      var $numChannels3=(($14+28)&4294967295); //@line 315 "sonic.cpp"
      var $15=HEAP32[(($numChannels3)>>2)]; //@line 315 "sonic.cpp"
      var $mul2=((($13)*2)&4294967295); //@line 315 "sonic.cpp"
      var $mul4=((($mul2)*($15))&4294967295); //@line 315 "sonic.cpp"
      _llvm_memmove_p0i8_p0i8_i32($6, $12, $mul4, 1, 0); //@line 315 "sonic.cpp"
      ; //@line 317 "sonic.cpp"
    }
  
    var $16=$remainingSamples; //@line 318 "sonic.cpp"
    var $17=$stream_addr; //@line 318 "sonic.cpp"
    var $numInputSamples5=(($17+44)&4294967295); //@line 318 "sonic.cpp"
    HEAP32[(($numInputSamples5)>>2)]=$16; //@line 318 "sonic.cpp"
    ;
    return; //@line 319 "sonic.cpp"
    return;
  }
  

  function _getopt($argc, $argv, $optstring) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $optstring_addr;
    var $data=__stackBase__;
    var $r;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $optstring_addr=$optstring;
    __ZL12read_globalsP11getopt_data($data); //@line 423 "getopt.cpp"
    var $0=$argc_addr; //@line 424 "getopt.cpp"
    var $1=$argv_addr; //@line 424 "getopt.cpp"
    var $2=$optstring_addr; //@line 424 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, 0, 0, 0, $data); //@line 424 "getopt.cpp"
    $r=$call; //@line 424 "getopt.cpp"
    __ZL13write_globalsP11getopt_data($data); //@line 425 "getopt.cpp"
    var $3=$r; //@line 426 "getopt.cpp"
    STACKTOP = __stackBase__;
    return $3; //@line 426 "getopt.cpp"
    return null;
  }
  

  function __ZL12read_globalsP11getopt_data($data) {
    ;
    var __label__;
  
    var $data_addr;
    $data_addr=$data;
    var $0=HEAP32[((_optarg)>>2)]; //@line 154 "getopt.cpp"
    var $1=$data_addr; //@line 154 "getopt.cpp"
    var $optarg=(($1)&4294967295); //@line 154 "getopt.cpp"
    HEAP32[(($optarg)>>2)]=$0; //@line 154 "getopt.cpp"
    var $2=HEAP32[((_optind)>>2)]; //@line 155 "getopt.cpp"
    var $3=$data_addr; //@line 155 "getopt.cpp"
    var $optind=(($3+4)&4294967295); //@line 155 "getopt.cpp"
    HEAP32[(($optind)>>2)]=$2; //@line 155 "getopt.cpp"
    var $4=HEAP32[((_opterr)>>2)]; //@line 156 "getopt.cpp"
    var $5=$data_addr; //@line 156 "getopt.cpp"
    var $opterr=(($5+8)&4294967295); //@line 156 "getopt.cpp"
    HEAP32[(($opterr)>>2)]=$4; //@line 156 "getopt.cpp"
    var $6=HEAP32[((_optopt)>>2)]; //@line 157 "getopt.cpp"
    var $7=$data_addr; //@line 157 "getopt.cpp"
    var $optopt=(($7+12)&4294967295); //@line 157 "getopt.cpp"
    HEAP32[(($optopt)>>2)]=$6; //@line 157 "getopt.cpp"
    var $8=HEAP32[((__ZL8optwhere)>>2)]; //@line 158 "getopt.cpp"
    var $9=$data_addr; //@line 158 "getopt.cpp"
    var $optwhere=(($9+16)&4294967295); //@line 158 "getopt.cpp"
    HEAP32[(($optwhere)>>2)]=$8; //@line 158 "getopt.cpp"
    ;
    return; //@line 159 "getopt.cpp"
    return;
  }
  

  function __ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($argc, $argv, $shortopts, $longopts, $longind, $only, $data) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $retval;
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $only_addr;
    var $data_addr;
    var $ordering;
    var $permute_from;
    var $num_nonopts;
    var $optindex;
    var $match_chars;
    var $possible_arg;
    var $longopt_match;
    var $has_arg;
    var $cp;
    var $arg_next;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    $only_addr=$only;
    $data_addr=$data;
    $ordering=0; //@line 179 "getopt.cpp"
    $permute_from=0; //@line 180 "getopt.cpp"
    $num_nonopts=0; //@line 181 "getopt.cpp"
    $optindex=0; //@line 182 "getopt.cpp"
    $match_chars=0; //@line 183 "getopt.cpp"
    $possible_arg=0; //@line 184 "getopt.cpp"
    $longopt_match=-1; //@line 185 "getopt.cpp"
    $has_arg=-1; //@line 186 "getopt.cpp"
    $cp=0; //@line 187 "getopt.cpp"
    $arg_next=0; //@line 188 "getopt.cpp"
    var $0=$argc_addr; //@line 191 "getopt.cpp"
    var $cmp=((($0))|0)==0; //@line 191 "getopt.cpp"
    if ($cmp) { __label__ = 6;; } else { __label__ = 1;; } //@line 191 "getopt.cpp"
    $if_then$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$argv_addr; //@line 191 "getopt.cpp"
        var $cmp1=((($1))|0)==0; //@line 191 "getopt.cpp"
        if ($cmp1) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
  
        var $2=$shortopts_addr; //@line 191 "getopt.cpp"
        var $cmp3=((($2))|0)==0; //@line 191 "getopt.cpp"
        if ($cmp3) { __label__ = 3;; } else { __label__ = 4;; } //@line 191 "getopt.cpp"
        if (__label__ == 3) {
  
          var $3=$longopts_addr; //@line 191 "getopt.cpp"
          var $cmp4=((($3))|0)==0; //@line 191 "getopt.cpp"
          if ($cmp4) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
        }
  
        var $4=$data_addr; //@line 191 "getopt.cpp"
        var $optind=(($4+4)&4294967295); //@line 191 "getopt.cpp"
        var $5=HEAP32[(($optind)>>2)]; //@line 191 "getopt.cpp"
        var $6=$argc_addr; //@line 191 "getopt.cpp"
        var $cmp6=((($5))|0) >= ((($6))|0); //@line 191 "getopt.cpp"
        if ($cmp6) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
  
        var $7=$data_addr; //@line 191 "getopt.cpp"
        var $optind8=(($7+4)&4294967295); //@line 191 "getopt.cpp"
        var $8=HEAP32[(($optind8)>>2)]; //@line 191 "getopt.cpp"
        var $9=$argv_addr; //@line 191 "getopt.cpp"
        var $arrayidx=(($9+4*$8)&4294967295); //@line 191 "getopt.cpp"
        var $10=HEAP32[(($arrayidx)>>2)]; //@line 191 "getopt.cpp"
        var $cmp9=((($10))|0)==0; //@line 191 "getopt.cpp"
        if ($cmp9) { __label__ = 6;break $if_then$$lor_lhs_false$2; } //@line 191 "getopt.cpp"
  
        var $11=$data_addr; //@line 194 "getopt.cpp"
        var $optind10=(($11+4)&4294967295); //@line 194 "getopt.cpp"
        var $12=HEAP32[(($optind10)>>2)]; //@line 194 "getopt.cpp"
        var $13=$argv_addr; //@line 194 "getopt.cpp"
        var $arrayidx11=(($13+4*$12)&4294967295); //@line 194 "getopt.cpp"
        var $14=HEAP32[(($arrayidx11)>>2)]; //@line 194 "getopt.cpp"
        var $call=_strcmp($14, ((__str831)&4294967295)); //@line 194 "getopt.cpp"
        var $cmp12=((($call))|0)==0; //@line 194 "getopt.cpp"
        var $15=$data_addr; //@line 196 "getopt.cpp"
        var $optind14=(($15+4)&4294967295); //@line 196 "getopt.cpp"
        var $16=HEAP32[(($optind14)>>2)]; //@line 196 "getopt.cpp"
        if ($cmp12) { __label__ = 8;; } else { __label__ = 9;; } //@line 194 "getopt.cpp"
        if (__label__ == 8) {
  
          var $inc=((($16)+1)&4294967295); //@line 196 "getopt.cpp"
          HEAP32[(($optind14)>>2)]=$inc; //@line 196 "getopt.cpp"
          $retval=-1; //@line 197 "getopt.cpp"
          __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 197 "getopt.cpp"
        }
        else if (__label__ == 9) {
  
          var $cmp17=((($16))|0)==0; //@line 201 "getopt.cpp"
          if ($cmp17) { __label__ = 10;; } else { __label__ = 11;; } //@line 201 "getopt.cpp"
          if (__label__ == 10) {
  
            var $17=$data_addr; //@line 202 "getopt.cpp"
            var $optwhere=(($17+16)&4294967295); //@line 202 "getopt.cpp"
            HEAP32[(($optwhere)>>2)]=1; //@line 202 "getopt.cpp"
            var $18=$data_addr; //@line 202 "getopt.cpp"
            var $optind19=(($18+4)&4294967295); //@line 202 "getopt.cpp"
            HEAP32[(($optind19)>>2)]=1; //@line 202 "getopt.cpp"
            ; //@line 202 "getopt.cpp"
          }
  
          var $19=$shortopts_addr; //@line 205 "getopt.cpp"
          var $cmp21=((($19))|0)!=0; //@line 205 "getopt.cpp"
          if ($cmp21) { __label__ = 12;; } else { __label__ = 15;; } //@line 205 "getopt.cpp"
          $land_lhs_true22$$if_else$16: do { 
            if (__label__ == 12) {
  
              var $20=$shortopts_addr; //@line 205 "getopt.cpp"
              var $21=HEAP8[($20)]; //@line 205 "getopt.cpp"
              var $conv=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 205 "getopt.cpp"
              var $cmp23=((($conv))|0)==45; //@line 205 "getopt.cpp"
              if ($cmp23) { __label__ = 14;; } else { __label__ = 13;; } //@line 205 "getopt.cpp"
              if (__label__ == 13) {
  
                var $22=$shortopts_addr; //@line 205 "getopt.cpp"
                var $23=HEAP8[($22)]; //@line 205 "getopt.cpp"
                var $conv25=(tempInt=(($23)),(tempInt>=128?tempInt-256:tempInt)); //@line 205 "getopt.cpp"
                var $cmp26=((($conv25))|0)==43; //@line 205 "getopt.cpp"
                if (!($cmp26)) { __label__ = 15;break $land_lhs_true22$$if_else$16; } //@line 205 "getopt.cpp"
              }
  
              var $24=$shortopts_addr; //@line 207 "getopt.cpp"
              var $25=HEAP8[($24)]; //@line 207 "getopt.cpp"
              var $conv28=(tempInt=(($25)),(tempInt>=128?tempInt-256:tempInt)); //@line 207 "getopt.cpp"
              var $cmp29=((($conv28))|0)==45; //@line 207 "getopt.cpp"
              var $cond=($cmp29) ? 1 : 2; //@line 207 "getopt.cpp"
              $ordering=$cond; //@line 207 "getopt.cpp"
              var $26=$shortopts_addr; //@line 208 "getopt.cpp"
              var $incdec_ptr=(($26+1)&4294967295); //@line 208 "getopt.cpp"
              $shortopts_addr=$incdec_ptr; //@line 208 "getopt.cpp"
              __label__ = 16;break $land_lhs_true22$$if_else$16; //@line 209 "getopt.cpp"
            }
          } while(0);
          if (__label__ == 15) {
  
            var $call30=_getenv(((__str1832)&4294967295)); //@line 211 "getopt.cpp"
            var $cmp31=((($call30))|0)!=0; //@line 211 "getopt.cpp"
            var $cond32=($cmp31) ? 2 : 0; //@line 211 "getopt.cpp"
            $ordering=$cond32; //@line 211 "getopt.cpp"
            ;
          }
  
          var $27=$data_addr; //@line 217 "getopt.cpp"
          var $optwhere34=(($27+16)&4294967295); //@line 217 "getopt.cpp"
          var $28=HEAP32[(($optwhere34)>>2)]; //@line 217 "getopt.cpp"
          var $cmp35=((($28))|0)==1; //@line 217 "getopt.cpp"
          if ($cmp35) { __label__ = 17;; } else { __label__ = 28;; } //@line 217 "getopt.cpp"
          $if_then36$$if_end75$24: do { 
            if (__label__ == 17) {
  
              var $29=$ordering; //@line 219 "getopt.cpp"
              if ($29 == 2) {
                __label__ = 26;;
              }
              else if ($29 == 1) {
                __label__ = 24;;
              }
              else {
              __label__ = 18;;
              }
              
              if (__label__ == 18) {
  
                var $30=$data_addr; //@line 223 "getopt.cpp"
                var $optind37=(($30+4)&4294967295); //@line 223 "getopt.cpp"
                var $31=HEAP32[(($optind37)>>2)]; //@line 223 "getopt.cpp"
                $permute_from=$31; //@line 223 "getopt.cpp"
                $num_nonopts=0; //@line 224 "getopt.cpp"
                var $32=$data_addr; //@line 225 "getopt.cpp"
                var $optind381=(($32+4)&4294967295); //@line 225 "getopt.cpp"
                var $33=HEAP32[(($optind381)>>2)]; //@line 225 "getopt.cpp"
                var $34=$argv_addr; //@line 225 "getopt.cpp"
                var $arrayidx392=(($34+4*$33)&4294967295); //@line 225 "getopt.cpp"
                var $35=HEAP32[(($arrayidx392)>>2)]; //@line 225 "getopt.cpp"
                var $36=$only_addr; //@line 225 "getopt.cpp"
                var $call403=__ZL9is_optionPci($35, $36); //@line 225 "getopt.cpp"
                var $tobool4=((($call403))|0)!=0; //@line 225 "getopt.cpp"
                var $lnot5=($tobool4) ^ 1; //@line 225 "getopt.cpp"
                var $37=$data_addr; //@line 227 "getopt.cpp"
                var $optind416=(($37+4)&4294967295); //@line 227 "getopt.cpp"
                var $38=HEAP32[(($optind416)>>2)]; //@line 227 "getopt.cpp"
                if ($lnot5) { __lastLabel__ = 18; __label__ = 19;; } else { __lastLabel__ = 18; __label__ = 20;; } //@line 225 "getopt.cpp"
                $while_body$$while_end$28: do { 
                  if (__label__ == 19) {
                    while(1) { 
  
                      var $39=__lastLabel__ == 19 ? $47 : ($38);
                      var $optind417=__lastLabel__ == 19 ? $optind41 : ($optind416);
                      var $inc42=((($39)+1)&4294967295); //@line 227 "getopt.cpp"
                      HEAP32[(($optind417)>>2)]=$inc42; //@line 227 "getopt.cpp"
                      var $40=$num_nonopts; //@line 228 "getopt.cpp"
                      var $inc43=((($40)+1)&4294967295); //@line 228 "getopt.cpp"
                      $num_nonopts=$inc43; //@line 228 "getopt.cpp"
                      var $41=$data_addr; //@line 225 "getopt.cpp"
                      var $optind38=(($41+4)&4294967295); //@line 225 "getopt.cpp"
                      var $42=HEAP32[(($optind38)>>2)]; //@line 225 "getopt.cpp"
                      var $43=$argv_addr; //@line 225 "getopt.cpp"
                      var $arrayidx39=(($43+4*$42)&4294967295); //@line 225 "getopt.cpp"
                      var $44=HEAP32[(($arrayidx39)>>2)]; //@line 225 "getopt.cpp"
                      var $45=$only_addr; //@line 225 "getopt.cpp"
                      var $call40=__ZL9is_optionPci($44, $45); //@line 225 "getopt.cpp"
                      var $tobool=((($call40))|0)!=0; //@line 225 "getopt.cpp"
                      var $lnot=($tobool) ^ 1; //@line 225 "getopt.cpp"
                      var $46=$data_addr; //@line 227 "getopt.cpp"
                      var $optind41=(($46+4)&4294967295); //@line 227 "getopt.cpp"
                      var $47=HEAP32[(($optind41)>>2)]; //@line 227 "getopt.cpp"
                      if ($lnot) { __lastLabel__ = 19; __label__ = 19;continue ; } else { __lastLabel__ = 19; __label__ = 20;break $while_body$$while_end$28; } //@line 225 "getopt.cpp"
                    }
                  }
                } while(0);
  
                var $_lcssa=__lastLabel__ == 18 ? $38 : ($47);
                var $48=$argv_addr; //@line 230 "getopt.cpp"
                var $arrayidx45=(($48+4*$_lcssa)&4294967295); //@line 230 "getopt.cpp"
                var $49=HEAP32[(($arrayidx45)>>2)]; //@line 230 "getopt.cpp"
                var $cmp46=((($49))|0)==0; //@line 230 "getopt.cpp"
                if ($cmp46) { __label__ = 21;; } else { __label__ = 22;; } //@line 230 "getopt.cpp"
                if (__label__ == 21) {
  
                  var $50=$permute_from; //@line 233 "getopt.cpp"
                  var $51=$data_addr; //@line 233 "getopt.cpp"
                  var $optind48=(($51+4)&4294967295); //@line 233 "getopt.cpp"
                  HEAP32[(($optind48)>>2)]=$50; //@line 233 "getopt.cpp"
                  $retval=-1; //@line 234 "getopt.cpp"
                  __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 234 "getopt.cpp"
                }
                else if (__label__ == 22) {
  
                  var $52=$data_addr; //@line 236 "getopt.cpp"
                  var $optind50=(($52+4)&4294967295); //@line 236 "getopt.cpp"
                  var $53=HEAP32[(($optind50)>>2)]; //@line 236 "getopt.cpp"
                  var $54=$argv_addr; //@line 236 "getopt.cpp"
                  var $arrayidx51=(($54+4*$53)&4294967295); //@line 236 "getopt.cpp"
                  var $55=HEAP32[(($arrayidx51)>>2)]; //@line 236 "getopt.cpp"
                  var $call52=_strcmp($55, ((__str831)&4294967295)); //@line 236 "getopt.cpp"
                  var $cmp53=((($call52))|0)==0; //@line 236 "getopt.cpp"
                  if (!($cmp53)) { __label__ = 28;break $if_then36$$if_end75$24; } //@line 236 "getopt.cpp"
  
                  var $56=$argv_addr; //@line 239 "getopt.cpp"
                  var $57=$permute_from; //@line 239 "getopt.cpp"
                  var $add_ptr=(($56+4*$57)&4294967295); //@line 239 "getopt.cpp"
                  var $58=$num_nonopts; //@line 239 "getopt.cpp"
                  __ZL7permutePKPcii($add_ptr, $58, 1); //@line 239 "getopt.cpp"
                  var $59=$permute_from; //@line 240 "getopt.cpp"
                  var $add=((($59)+1)&4294967295); //@line 240 "getopt.cpp"
                  var $60=$data_addr; //@line 240 "getopt.cpp"
                  var $optind55=(($60+4)&4294967295); //@line 240 "getopt.cpp"
                  HEAP32[(($optind55)>>2)]=$add; //@line 240 "getopt.cpp"
                  $retval=-1; //@line 241 "getopt.cpp"
                  __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 241 "getopt.cpp"
                }
              }
              else if (__label__ == 26) {
  
                var $72=$data_addr; //@line 252 "getopt.cpp"
                var $optind69=(($72+4)&4294967295); //@line 252 "getopt.cpp"
                var $73=HEAP32[(($optind69)>>2)]; //@line 252 "getopt.cpp"
                var $74=$argv_addr; //@line 252 "getopt.cpp"
                var $arrayidx70=(($74+4*$73)&4294967295); //@line 252 "getopt.cpp"
                var $75=HEAP32[(($arrayidx70)>>2)]; //@line 252 "getopt.cpp"
                var $76=$only_addr; //@line 252 "getopt.cpp"
                var $call71=__ZL9is_optionPci($75, $76); //@line 252 "getopt.cpp"
                var $tobool72=((($call71))|0)!=0; //@line 252 "getopt.cpp"
                if ($tobool72) { __label__ = 28;break $if_then36$$if_end75$24; } //@line 252 "getopt.cpp"
  
                $retval=-1; //@line 253 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 253 "getopt.cpp"
              }
              else if (__label__ == 24) {
  
                var $61=$data_addr; //@line 245 "getopt.cpp"
                var $optind59=(($61+4)&4294967295); //@line 245 "getopt.cpp"
                var $62=HEAP32[(($optind59)>>2)]; //@line 245 "getopt.cpp"
                var $63=$argv_addr; //@line 245 "getopt.cpp"
                var $arrayidx60=(($63+4*$62)&4294967295); //@line 245 "getopt.cpp"
                var $64=HEAP32[(($arrayidx60)>>2)]; //@line 245 "getopt.cpp"
                var $65=$only_addr; //@line 245 "getopt.cpp"
                var $call61=__ZL9is_optionPci($64, $65); //@line 245 "getopt.cpp"
                var $tobool62=((($call61))|0)!=0; //@line 245 "getopt.cpp"
                if ($tobool62) { __label__ = 28;break $if_then36$$if_end75$24; } //@line 245 "getopt.cpp"
  
                var $66=$data_addr; //@line 247 "getopt.cpp"
                var $optind64=(($66+4)&4294967295); //@line 247 "getopt.cpp"
                var $67=HEAP32[(($optind64)>>2)]; //@line 247 "getopt.cpp"
                var $inc65=((($67)+1)&4294967295); //@line 247 "getopt.cpp"
                HEAP32[(($optind64)>>2)]=$inc65; //@line 247 "getopt.cpp"
                var $68=$argv_addr; //@line 247 "getopt.cpp"
                var $arrayidx66=(($68+4*$67)&4294967295); //@line 247 "getopt.cpp"
                var $69=HEAP32[(($arrayidx66)>>2)]; //@line 247 "getopt.cpp"
                var $70=$data_addr; //@line 247 "getopt.cpp"
                var $optarg=(($70)&4294967295); //@line 247 "getopt.cpp"
                HEAP32[(($optarg)>>2)]=$69; //@line 247 "getopt.cpp"
                var $71=$data_addr; //@line 248 "getopt.cpp"
                var $optopt=(($71+12)&4294967295); //@line 248 "getopt.cpp"
                HEAP32[(($optopt)>>2)]=1; //@line 248 "getopt.cpp"
                $retval=1; //@line 248 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 248 "getopt.cpp"
              }
            }
          } while(0);
  
          var $77=$longopts_addr; //@line 260 "getopt.cpp"
          var $cmp76=((($77))|0)!=0; //@line 260 "getopt.cpp"
          if ($cmp76) { __label__ = 29;; } else { __label__ = 52;; } //@line 260 "getopt.cpp"
          $land_lhs_true77$$if_end162$41: do { 
            if (__label__ == 29) {
  
              var $78=$data_addr; //@line 261 "getopt.cpp"
              var $optind78=(($78+4)&4294967295); //@line 261 "getopt.cpp"
              var $79=HEAP32[(($optind78)>>2)]; //@line 261 "getopt.cpp"
              var $80=$argv_addr; //@line 261 "getopt.cpp"
              var $arrayidx79=(($80+4*$79)&4294967295); //@line 261 "getopt.cpp"
              var $81=HEAP32[(($arrayidx79)>>2)]; //@line 261 "getopt.cpp"
              var $call80=_memcmp($81, ((__str831)&4294967295), 2); //@line 261 "getopt.cpp"
              var $cmp81=((($call80))|0)==0; //@line 261 "getopt.cpp"
              if ($cmp81) { __label__ = 32;; } else { __label__ = 30;; } //@line 261 "getopt.cpp"
              if (__label__ == 30) {
  
                var $82=$only_addr; //@line 261 "getopt.cpp"
                var $tobool83=((($82))|0)!=0; //@line 261 "getopt.cpp"
                if (!($tobool83)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 261 "getopt.cpp"
  
                var $83=$data_addr; //@line 261 "getopt.cpp"
                var $optind85=(($83+4)&4294967295); //@line 261 "getopt.cpp"
                var $84=HEAP32[(($optind85)>>2)]; //@line 261 "getopt.cpp"
                var $85=$argv_addr; //@line 261 "getopt.cpp"
                var $arrayidx86=(($85+4*$84)&4294967295); //@line 261 "getopt.cpp"
                var $86=HEAP32[(($arrayidx86)>>2)]; //@line 261 "getopt.cpp"
                var $arrayidx87=(($86)&4294967295); //@line 261 "getopt.cpp"
                var $87=HEAP8[($arrayidx87)]; //@line 261 "getopt.cpp"
                var $conv88=(tempInt=(($87)),(tempInt>=128?tempInt-256:tempInt)); //@line 261 "getopt.cpp"
                var $cmp89=((($conv88))|0)==43; //@line 261 "getopt.cpp"
                if (!($cmp89)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 261 "getopt.cpp"
              }
  
              var $88=$data_addr; //@line 261 "getopt.cpp"
              var $optwhere91=(($88+16)&4294967295); //@line 261 "getopt.cpp"
              var $89=HEAP32[(($optwhere91)>>2)]; //@line 261 "getopt.cpp"
              var $cmp92=((($89))|0)==1; //@line 261 "getopt.cpp"
              if (!($cmp92)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 261 "getopt.cpp"
  
              var $90=$data_addr; //@line 265 "getopt.cpp"
              var $optind94=(($90+4)&4294967295); //@line 265 "getopt.cpp"
              var $91=HEAP32[(($optind94)>>2)]; //@line 265 "getopt.cpp"
              var $92=$argv_addr; //@line 265 "getopt.cpp"
              var $arrayidx95=(($92+4*$91)&4294967295); //@line 265 "getopt.cpp"
              var $93=HEAP32[(($arrayidx95)>>2)]; //@line 265 "getopt.cpp"
              var $call96=_memcmp($93, ((__str831)&4294967295), 2); //@line 265 "getopt.cpp"
              var $cmp97=((($call96))|0)==0; //@line 265 "getopt.cpp"
              if ($cmp97) { __label__ = 34;; } else { __label__ = 35;; } //@line 265 "getopt.cpp"
              if (__label__ == 34) {
  
                var $94=$data_addr; //@line 266 "getopt.cpp"
                var $optwhere99=(($94+16)&4294967295); //@line 266 "getopt.cpp"
                HEAP32[(($optwhere99)>>2)]=2; //@line 266 "getopt.cpp"
                ; //@line 266 "getopt.cpp"
              }
  
              $longopt_match=-1; //@line 267 "getopt.cpp"
              var $95=$data_addr; //@line 268 "getopt.cpp"
              var $optind101=(($95+4)&4294967295); //@line 268 "getopt.cpp"
              var $96=HEAP32[(($optind101)>>2)]; //@line 268 "getopt.cpp"
              var $97=$argv_addr; //@line 268 "getopt.cpp"
              var $arrayidx102=(($97+4*$96)&4294967295); //@line 268 "getopt.cpp"
              var $98=HEAP32[(($arrayidx102)>>2)]; //@line 268 "getopt.cpp"
              var $99=$data_addr; //@line 268 "getopt.cpp"
              var $optwhere103=(($99+16)&4294967295); //@line 268 "getopt.cpp"
              var $100=HEAP32[(($optwhere103)>>2)]; //@line 268 "getopt.cpp"
              var $add_ptr104=(($98+$100)&4294967295); //@line 268 "getopt.cpp"
              var $call105=_strchr($add_ptr104, 61); //@line 268 "getopt.cpp"
              $possible_arg=$call105; //@line 268 "getopt.cpp"
              var $cmp106=((($call105))|0)==0; //@line 269 "getopt.cpp"
              if ($cmp106) { __label__ = 36;; } else { __label__ = 37;; } //@line 269 "getopt.cpp"
              if (__label__ == 36) {
  
                var $101=$data_addr; //@line 272 "getopt.cpp"
                var $optind108=(($101+4)&4294967295); //@line 272 "getopt.cpp"
                var $102=HEAP32[(($optind108)>>2)]; //@line 272 "getopt.cpp"
                var $103=$argv_addr; //@line 272 "getopt.cpp"
                var $arrayidx109=(($103+4*$102)&4294967295); //@line 272 "getopt.cpp"
                var $104=HEAP32[(($arrayidx109)>>2)]; //@line 272 "getopt.cpp"
                var $call110=_strlen($104); //@line 272 "getopt.cpp"
                $match_chars=$call110; //@line 272 "getopt.cpp"
                var $105=$data_addr; //@line 273 "getopt.cpp"
                var $optind111=(($105+4)&4294967295); //@line 273 "getopt.cpp"
                var $106=HEAP32[(($optind111)>>2)]; //@line 273 "getopt.cpp"
                var $107=$argv_addr; //@line 273 "getopt.cpp"
                var $arrayidx112=(($107+4*$106)&4294967295); //@line 273 "getopt.cpp"
                var $108=HEAP32[(($arrayidx112)>>2)]; //@line 273 "getopt.cpp"
                var $109=$match_chars; //@line 273 "getopt.cpp"
                var $add_ptr113=(($108+$109)&4294967295); //@line 273 "getopt.cpp"
                $possible_arg=$add_ptr113; //@line 273 "getopt.cpp"
                var $110=$match_chars; //@line 274 "getopt.cpp"
                var $111=$data_addr; //@line 274 "getopt.cpp"
                var $optwhere114=(($111+16)&4294967295); //@line 274 "getopt.cpp"
                var $112=HEAP32[(($optwhere114)>>2)]; //@line 274 "getopt.cpp"
                var $sub=((($110)-($112))&4294967295); //@line 274 "getopt.cpp"
                $match_chars=$sub; //@line 274 "getopt.cpp"
                ; //@line 275 "getopt.cpp"
              }
              else if (__label__ == 37) {
  
                var $113=$possible_arg; //@line 277 "getopt.cpp"
                var $114=$data_addr; //@line 277 "getopt.cpp"
                var $optind116=(($114+4)&4294967295); //@line 277 "getopt.cpp"
                var $115=HEAP32[(($optind116)>>2)]; //@line 277 "getopt.cpp"
                var $116=$argv_addr; //@line 277 "getopt.cpp"
                var $arrayidx117=(($116+4*$115)&4294967295); //@line 277 "getopt.cpp"
                var $117=HEAP32[(($arrayidx117)>>2)]; //@line 277 "getopt.cpp"
                var $sub_ptr_lhs_cast=($113); //@line 277 "getopt.cpp"
                var $sub_ptr_rhs_cast=($117); //@line 277 "getopt.cpp"
                var $sub_ptr_rhs_cast_neg=(((-($sub_ptr_rhs_cast)))&4294967295);
                var $118=$data_addr; //@line 277 "getopt.cpp"
                var $optwhere118=(($118+16)&4294967295); //@line 277 "getopt.cpp"
                var $119=HEAP32[(($optwhere118)>>2)]; //@line 277 "getopt.cpp"
                var $_neg=(((-($119)))&4294967295);
                var $sub_ptr_sub=((($sub_ptr_rhs_cast_neg)+($sub_ptr_lhs_cast))&4294967295); //@line 277 "getopt.cpp"
                var $sub119=((($sub_ptr_sub)+($_neg))&4294967295); //@line 277 "getopt.cpp"
                $match_chars=$sub119; //@line 277 "getopt.cpp"
                ;
              }
  
              $optindex=0; //@line 278 "getopt.cpp"
              ; //@line 278 "getopt.cpp"
              while(1) { 
  
                var $120=$optindex; //@line 278 "getopt.cpp"
                var $121=$longopts_addr; //@line 278 "getopt.cpp"
                var $arrayidx121=(($121+16*$120)&4294967295); //@line 278 "getopt.cpp"
                var $name=(($arrayidx121)&4294967295); //@line 278 "getopt.cpp"
                var $122=HEAP32[(($name)>>2)]; //@line 278 "getopt.cpp"
                var $cmp122=((($122))|0)!=0; //@line 278 "getopt.cpp"
                if (!($cmp122)) { __label__ = 49;break ; } //@line 278 "getopt.cpp"
  
                var $123=$data_addr; //@line 280 "getopt.cpp"
                var $optind123=(($123+4)&4294967295); //@line 280 "getopt.cpp"
                var $124=HEAP32[(($optind123)>>2)]; //@line 280 "getopt.cpp"
                var $125=$argv_addr; //@line 280 "getopt.cpp"
                var $arrayidx124=(($125+4*$124)&4294967295); //@line 280 "getopt.cpp"
                var $126=HEAP32[(($arrayidx124)>>2)]; //@line 280 "getopt.cpp"
                var $127=$data_addr; //@line 280 "getopt.cpp"
                var $optwhere125=(($127+16)&4294967295); //@line 280 "getopt.cpp"
                var $128=HEAP32[(($optwhere125)>>2)]; //@line 280 "getopt.cpp"
                var $add_ptr126=(($126+$128)&4294967295); //@line 280 "getopt.cpp"
                var $129=$optindex; //@line 280 "getopt.cpp"
                var $130=$longopts_addr; //@line 280 "getopt.cpp"
                var $arrayidx127=(($130+16*$129)&4294967295); //@line 280 "getopt.cpp"
                var $name128=(($arrayidx127)&4294967295); //@line 280 "getopt.cpp"
                var $131=HEAP32[(($name128)>>2)]; //@line 280 "getopt.cpp"
                var $132=$match_chars; //@line 280 "getopt.cpp"
                var $call129=_memcmp($add_ptr126, $131, $132); //@line 280 "getopt.cpp"
                var $cmp130=((($call129))|0)==0; //@line 280 "getopt.cpp"
                if ($cmp130) { __label__ = 41;; } else { __label__ = 48;; } //@line 280 "getopt.cpp"
                if (__label__ == 41) {
  
                  var $133=$match_chars; //@line 285 "getopt.cpp"
                  var $134=$optindex; //@line 285 "getopt.cpp"
                  var $135=$longopts_addr; //@line 285 "getopt.cpp"
                  var $arrayidx132=(($135+16*$134)&4294967295); //@line 285 "getopt.cpp"
                  var $name133=(($arrayidx132)&4294967295); //@line 285 "getopt.cpp"
                  var $136=HEAP32[(($name133)>>2)]; //@line 285 "getopt.cpp"
                  var $call134=_strlen($136); //@line 285 "getopt.cpp"
                  var $cmp135=((($133))|0)==((($call134))|0); //@line 285 "getopt.cpp"
                  if ($cmp135) { __label__ = 42;break ; } //@line 285 "getopt.cpp"
  
                  var $138=$longopt_match; //@line 293 "getopt.cpp"
                  var $cmp138=((($138))|0) < 0; //@line 293 "getopt.cpp"
                  if (!($cmp138)) { __label__ = 45;break ; } //@line 293 "getopt.cpp"
  
                  var $139=$optindex; //@line 294 "getopt.cpp"
                  $longopt_match=$139; //@line 294 "getopt.cpp"
                  ; //@line 308 "getopt.cpp"
                }
  
                var $157=$optindex; //@line 278 "getopt.cpp"
                var $inc156=((($157)+1)&4294967295); //@line 278 "getopt.cpp"
                $optindex=$inc156; //@line 278 "getopt.cpp"
                __label__ = 39;continue ; //@line 278 "getopt.cpp"
              }
              if (__label__ == 49) {
  
                var $_pr=$longopt_match; //@line 310 "getopt.cpp"
                __lastLabel__ = 49; ;
              }
              else if (__label__ == 42) {
  
                var $137=$optindex; //@line 287 "getopt.cpp"
                $longopt_match=$137; //@line 287 "getopt.cpp"
                __lastLabel__ = 42; ; //@line 288 "getopt.cpp"
              }
              else if (__label__ == 45) {
  
                var $140=$data_addr; //@line 298 "getopt.cpp"
                var $opterr=(($140+8)&4294967295); //@line 298 "getopt.cpp"
                var $141=HEAP32[(($opterr)>>2)]; //@line 298 "getopt.cpp"
                var $tobool141=((($141))|0)!=0; //@line 298 "getopt.cpp"
                if ($tobool141) { __label__ = 46;; } else { __label__ = 47;; } //@line 298 "getopt.cpp"
                if (__label__ == 46) {
  
                  var $142=HEAP32[((__impure_ptr)>>2)]; //@line 299 "getopt.cpp"
                  var $_stderr=(($142+12)&4294967295); //@line 299 "getopt.cpp"
                  var $143=HEAP32[(($_stderr)>>2)]; //@line 299 "getopt.cpp"
                  var $144=$argv_addr; //@line 299 "getopt.cpp"
                  var $arrayidx143=(($144)&4294967295); //@line 299 "getopt.cpp"
                  var $145=HEAP32[(($arrayidx143)>>2)]; //@line 299 "getopt.cpp"
                  var $146=$data_addr; //@line 299 "getopt.cpp"
                  var $optind144=(($146+4)&4294967295); //@line 299 "getopt.cpp"
                  var $147=HEAP32[(($optind144)>>2)]; //@line 299 "getopt.cpp"
                  var $148=$argv_addr; //@line 299 "getopt.cpp"
                  var $arrayidx145=(($148+4*$147)&4294967295); //@line 299 "getopt.cpp"
                  var $149=HEAP32[(($arrayidx145)>>2)]; //@line 299 "getopt.cpp"
                  var $150=$longopt_match; //@line 299 "getopt.cpp"
                  var $151=$longopts_addr; //@line 299 "getopt.cpp"
                  var $arrayidx146=(($151+16*$150)&4294967295); //@line 299 "getopt.cpp"
                  var $name147=(($arrayidx146)&4294967295); //@line 299 "getopt.cpp"
                  var $152=HEAP32[(($name147)>>2)]; //@line 299 "getopt.cpp"
                  var $153=$optindex; //@line 299 "getopt.cpp"
                  var $154=$longopts_addr; //@line 299 "getopt.cpp"
                  var $arrayidx148=(($154+16*$153)&4294967295); //@line 299 "getopt.cpp"
                  var $name149=(($arrayidx148)&4294967295); //@line 299 "getopt.cpp"
                  var $155=HEAP32[(($name149)>>2)]; //@line 299 "getopt.cpp"
                  var $call150=_fprintf($143, ((__str2833)&4294967295), allocate([$145,0,0,0,$149,0,0,0,$152,0,0,0,$155,0,0,0], ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STACK)); //@line 299 "getopt.cpp"
                  ; //@line 299 "getopt.cpp"
                }
  
                var $156=$data_addr; //@line 305 "getopt.cpp"
                var $optopt152=(($156+12)&4294967295); //@line 305 "getopt.cpp"
                HEAP32[(($optopt152)>>2)]=63; //@line 305 "getopt.cpp"
                $retval=63; //@line 305 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 305 "getopt.cpp"
              }
  
              var $158=__lastLabel__ == 49 ? $_pr : ($137); //@line 310 "getopt.cpp"
              var $cmp157=((($158))|0) >= 0; //@line 310 "getopt.cpp"
              if (!($cmp157)) { __label__ = 52;break $land_lhs_true77$$if_end162$41; } //@line 310 "getopt.cpp"
  
              var $159=$longopt_match; //@line 311 "getopt.cpp"
              var $160=$longopts_addr; //@line 311 "getopt.cpp"
              var $arrayidx159=(($160+16*$159)&4294967295); //@line 311 "getopt.cpp"
              var $has_arg160=(($arrayidx159+4)&4294967295); //@line 311 "getopt.cpp"
              var $161=HEAP32[(($has_arg160)>>2)]; //@line 311 "getopt.cpp"
              $has_arg=$161; //@line 311 "getopt.cpp"
              ; //@line 311 "getopt.cpp"
            }
          } while(0);
  
          var $162=$longopt_match; //@line 315 "getopt.cpp"
          var $cmp163=((($162))|0) < 0; //@line 315 "getopt.cpp"
          if ($cmp163) { __label__ = 53;; } else { __label__ = 63;; } //@line 315 "getopt.cpp"
          $land_lhs_true164$$if_end217$73: do { 
            if (__label__ == 53) {
  
              var $163=$shortopts_addr; //@line 315 "getopt.cpp"
              var $cmp165=((($163))|0)!=0; //@line 315 "getopt.cpp"
              if (!($cmp165)) { __label__ = 63;break $land_lhs_true164$$if_end217$73; } //@line 315 "getopt.cpp"
  
              var $164=$shortopts_addr; //@line 317 "getopt.cpp"
              var $165=$data_addr; //@line 317 "getopt.cpp"
              var $optwhere167=(($165+16)&4294967295); //@line 317 "getopt.cpp"
              var $166=HEAP32[(($optwhere167)>>2)]; //@line 317 "getopt.cpp"
              var $167=$data_addr; //@line 317 "getopt.cpp"
              var $optind168=(($167+4)&4294967295); //@line 317 "getopt.cpp"
              var $168=HEAP32[(($optind168)>>2)]; //@line 317 "getopt.cpp"
              var $169=$argv_addr; //@line 317 "getopt.cpp"
              var $arrayidx169=(($169+4*$168)&4294967295); //@line 317 "getopt.cpp"
              var $170=HEAP32[(($arrayidx169)>>2)]; //@line 317 "getopt.cpp"
              var $arrayidx170=(($170+$166)&4294967295); //@line 317 "getopt.cpp"
              var $171=HEAP8[($arrayidx170)]; //@line 317 "getopt.cpp"
              var $conv171=(tempInt=(($171)),(tempInt>=128?tempInt-256:tempInt)); //@line 317 "getopt.cpp"
              var $call172=_strchr($164, $conv171); //@line 317 "getopt.cpp"
              $cp=$call172; //@line 317 "getopt.cpp"
              var $172=$cp; //@line 318 "getopt.cpp"
              var $cmp173=((($172))|0)==0; //@line 318 "getopt.cpp"
              if ($cmp173) { __label__ = 55;; } else { __label__ = 60;; } //@line 318 "getopt.cpp"
              if (__label__ == 55) {
  
                var $173=$data_addr; //@line 321 "getopt.cpp"
                var $opterr175=(($173+8)&4294967295); //@line 321 "getopt.cpp"
                var $174=HEAP32[(($opterr175)>>2)]; //@line 321 "getopt.cpp"
                var $tobool176=((($174))|0)!=0; //@line 321 "getopt.cpp"
                if ($tobool176) { __label__ = 56;; } else { __label__ = 57;; } //@line 321 "getopt.cpp"
                if (__label__ == 56) {
  
                  var $175=HEAP32[((__impure_ptr)>>2)]; //@line 322 "getopt.cpp"
                  var $_stderr178=(($175+12)&4294967295); //@line 322 "getopt.cpp"
                  var $176=HEAP32[(($_stderr178)>>2)]; //@line 322 "getopt.cpp"
                  var $177=$argv_addr; //@line 322 "getopt.cpp"
                  var $arrayidx179=(($177)&4294967295); //@line 322 "getopt.cpp"
                  var $178=HEAP32[(($arrayidx179)>>2)]; //@line 322 "getopt.cpp"
                  var $179=$data_addr; //@line 322 "getopt.cpp"
                  var $optwhere180=(($179+16)&4294967295); //@line 322 "getopt.cpp"
                  var $180=HEAP32[(($optwhere180)>>2)]; //@line 322 "getopt.cpp"
                  var $181=$data_addr; //@line 322 "getopt.cpp"
                  var $optind181=(($181+4)&4294967295); //@line 322 "getopt.cpp"
                  var $182=HEAP32[(($optind181)>>2)]; //@line 322 "getopt.cpp"
                  var $183=$argv_addr; //@line 322 "getopt.cpp"
                  var $arrayidx182=(($183+4*$182)&4294967295); //@line 322 "getopt.cpp"
                  var $184=HEAP32[(($arrayidx182)>>2)]; //@line 322 "getopt.cpp"
                  var $arrayidx183=(($184+$180)&4294967295); //@line 322 "getopt.cpp"
                  var $185=HEAP8[($arrayidx183)]; //@line 322 "getopt.cpp"
                  var $conv184=(tempInt=(($185)),(tempInt>=128?tempInt-256:tempInt)); //@line 322 "getopt.cpp"
                  var $call185=_fprintf($176, ((__str3834)&4294967295), allocate([$178,0,0,0,$conv184,0,0,0], ["i8*",0,0,0,"i32",0,0,0], ALLOC_STACK)); //@line 322 "getopt.cpp"
                  ; //@line 322 "getopt.cpp"
                }
  
                var $186=$data_addr; //@line 325 "getopt.cpp"
                var $optwhere187=(($186+16)&4294967295); //@line 325 "getopt.cpp"
                var $187=HEAP32[(($optwhere187)>>2)]; //@line 325 "getopt.cpp"
                var $inc188=((($187)+1)&4294967295); //@line 325 "getopt.cpp"
                HEAP32[(($optwhere187)>>2)]=$inc188; //@line 325 "getopt.cpp"
                var $188=$data_addr; //@line 326 "getopt.cpp"
                var $optwhere189=(($188+16)&4294967295); //@line 326 "getopt.cpp"
                var $189=HEAP32[(($optwhere189)>>2)]; //@line 326 "getopt.cpp"
                var $190=$data_addr; //@line 326 "getopt.cpp"
                var $optind190=(($190+4)&4294967295); //@line 326 "getopt.cpp"
                var $191=HEAP32[(($optind190)>>2)]; //@line 326 "getopt.cpp"
                var $192=$argv_addr; //@line 326 "getopt.cpp"
                var $arrayidx191=(($192+4*$191)&4294967295); //@line 326 "getopt.cpp"
                var $193=HEAP32[(($arrayidx191)>>2)]; //@line 326 "getopt.cpp"
                var $arrayidx192=(($193+$189)&4294967295); //@line 326 "getopt.cpp"
                var $194=HEAP8[($arrayidx192)]; //@line 326 "getopt.cpp"
                var $conv193=(tempInt=(($194)),(tempInt>=128?tempInt-256:tempInt)); //@line 326 "getopt.cpp"
                var $cmp194=((($conv193))|0)==0; //@line 326 "getopt.cpp"
                if ($cmp194) { __label__ = 58;; } else { __label__ = 59;; } //@line 326 "getopt.cpp"
                if (__label__ == 58) {
  
                  var $195=$data_addr; //@line 328 "getopt.cpp"
                  var $optind196=(($195+4)&4294967295); //@line 328 "getopt.cpp"
                  var $196=HEAP32[(($optind196)>>2)]; //@line 328 "getopt.cpp"
                  var $inc197=((($196)+1)&4294967295); //@line 328 "getopt.cpp"
                  HEAP32[(($optind196)>>2)]=$inc197; //@line 328 "getopt.cpp"
                  var $197=$data_addr; //@line 329 "getopt.cpp"
                  var $optwhere198=(($197+16)&4294967295); //@line 329 "getopt.cpp"
                  HEAP32[(($optwhere198)>>2)]=1; //@line 329 "getopt.cpp"
                  ; //@line 330 "getopt.cpp"
                }
  
                var $198=$data_addr; //@line 331 "getopt.cpp"
                var $optopt200=(($198+12)&4294967295); //@line 331 "getopt.cpp"
                HEAP32[(($optopt200)>>2)]=63; //@line 331 "getopt.cpp"
                $retval=63; //@line 331 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 331 "getopt.cpp"
              }
              else if (__label__ == 60) {
  
                var $199=$cp; //@line 333 "getopt.cpp"
                var $arrayidx202=(($199+1)&4294967295); //@line 333 "getopt.cpp"
                var $200=HEAP8[($arrayidx202)]; //@line 333 "getopt.cpp"
                var $conv203=(tempInt=(($200)),(tempInt>=128?tempInt-256:tempInt)); //@line 333 "getopt.cpp"
                var $cmp204=((($conv203))|0)==58; //@line 333 "getopt.cpp"
                if ($cmp204) { __lastLabel__ = 60; __label__ = 61;; } else { __lastLabel__ = 60; __label__ = 62;; } //@line 333 "getopt.cpp"
                if (__label__ == 61) {
  
                  var $201=$cp; //@line 333 "getopt.cpp"
                  var $arrayidx205=(($201+2)&4294967295); //@line 333 "getopt.cpp"
                  var $202=HEAP8[($arrayidx205)]; //@line 333 "getopt.cpp"
                  var $conv206=(tempInt=(($202)),(tempInt>=128?tempInt-256:tempInt)); //@line 333 "getopt.cpp"
                  var $cmp207=((($conv206))|0)==58; //@line 333 "getopt.cpp"
                  var $cond208=($cmp207) ? 2 : 1; //@line 333 "getopt.cpp"
                  __lastLabel__ = 61; ; //@line 333 "getopt.cpp"
                }
  
                var $cond209=__lastLabel__ == 61 ? $cond208 : (0); //@line 333 "getopt.cpp"
                $has_arg=$cond209; //@line 333 "getopt.cpp"
                var $203=$data_addr; //@line 335 "getopt.cpp"
                var $optind210=(($203+4)&4294967295); //@line 335 "getopt.cpp"
                var $204=HEAP32[(($optind210)>>2)]; //@line 335 "getopt.cpp"
                var $205=$argv_addr; //@line 335 "getopt.cpp"
                var $arrayidx211=(($205+4*$204)&4294967295); //@line 335 "getopt.cpp"
                var $206=HEAP32[(($arrayidx211)>>2)]; //@line 335 "getopt.cpp"
                var $207=$data_addr; //@line 335 "getopt.cpp"
                var $optwhere212=(($207+16)&4294967295); //@line 335 "getopt.cpp"
                var $208=HEAP32[(($optwhere212)>>2)]; //@line 335 "getopt.cpp"
                var $add_ptr213=(($206+$208)&4294967295); //@line 335 "getopt.cpp"
                var $add_ptr214=(($add_ptr213+1)&4294967295); //@line 335 "getopt.cpp"
                $possible_arg=$add_ptr214; //@line 335 "getopt.cpp"
                var $209=$cp; //@line 336 "getopt.cpp"
                var $210=HEAP8[($209)]; //@line 336 "getopt.cpp"
                var $conv215=(tempInt=(($210)),(tempInt>=128?tempInt-256:tempInt)); //@line 336 "getopt.cpp"
                var $211=$data_addr; //@line 336 "getopt.cpp"
                var $optopt216=(($211+12)&4294967295); //@line 336 "getopt.cpp"
                HEAP32[(($optopt216)>>2)]=$conv215; //@line 336 "getopt.cpp"
                ; //@line 337 "getopt.cpp"
              }
            }
          } while(0);
  
          $arg_next=0; //@line 340 "getopt.cpp"
          var $212=$has_arg; //@line 341 "getopt.cpp"
          if ($212 == 2) {
            __label__ = 64;;
          }
          else if ($212 == 1) {
            __label__ = 67;;
          }
          else {
          __label__ = 78;;
          }
          
          if (__label__ == 78) {
  
            var $254=$longopt_match; //@line 379 "getopt.cpp"
            var $cmp279=((($254))|0) < 0; //@line 379 "getopt.cpp"
            var $255=$data_addr; //@line 381 "getopt.cpp"
            var $optwhere281=(($255+16)&4294967295); //@line 381 "getopt.cpp"
            if ($cmp279) { __label__ = 79;; } else { __label__ = 81;; } //@line 379 "getopt.cpp"
            $if_then280$$if_else292$91: do { 
              if (__label__ == 79) {
  
                var $256=HEAP32[(($optwhere281)>>2)]; //@line 381 "getopt.cpp"
                var $inc282=((($256)+1)&4294967295); //@line 381 "getopt.cpp"
                HEAP32[(($optwhere281)>>2)]=$inc282; //@line 381 "getopt.cpp"
                var $257=$data_addr; //@line 382 "getopt.cpp"
                var $optwhere283=(($257+16)&4294967295); //@line 382 "getopt.cpp"
                var $258=HEAP32[(($optwhere283)>>2)]; //@line 382 "getopt.cpp"
                var $259=$data_addr; //@line 382 "getopt.cpp"
                var $optind284=(($259+4)&4294967295); //@line 382 "getopt.cpp"
                var $260=HEAP32[(($optind284)>>2)]; //@line 382 "getopt.cpp"
                var $261=$argv_addr; //@line 382 "getopt.cpp"
                var $arrayidx285=(($261+4*$260)&4294967295); //@line 382 "getopt.cpp"
                var $262=HEAP32[(($arrayidx285)>>2)]; //@line 382 "getopt.cpp"
                var $arrayidx286=(($262+$258)&4294967295); //@line 382 "getopt.cpp"
                var $263=HEAP8[($arrayidx286)]; //@line 382 "getopt.cpp"
                var $conv287=(tempInt=(($263)),(tempInt>=128?tempInt-256:tempInt)); //@line 382 "getopt.cpp"
                var $cmp288=((($conv287))|0)==0; //@line 382 "getopt.cpp"
                if (!($cmp288)) { __label__ = 82;break $if_then280$$if_else292$91; } //@line 382 "getopt.cpp"
  
                var $264=$data_addr; //@line 383 "getopt.cpp"
                var $optwhere290=(($264+16)&4294967295); //@line 383 "getopt.cpp"
                HEAP32[(($optwhere290)>>2)]=1; //@line 383 "getopt.cpp"
                ; //@line 383 "getopt.cpp"
              }
              else if (__label__ == 81) {
  
                HEAP32[(($optwhere281)>>2)]=1; //@line 386 "getopt.cpp"
                ;
              }
            } while(0);
  
            var $265=$data_addr; //@line 387 "getopt.cpp"
            var $optarg295=(($265)&4294967295); //@line 387 "getopt.cpp"
            HEAP32[(($optarg295)>>2)]=0; //@line 387 "getopt.cpp"
            ; //@line 388 "getopt.cpp"
          }
          else if (__label__ == 64) {
  
            var $213=$possible_arg; //@line 344 "getopt.cpp"
            var $214=HEAP8[($213)]; //@line 344 "getopt.cpp"
            var $conv219=(tempInt=(($214)),(tempInt>=128?tempInt-256:tempInt)); //@line 344 "getopt.cpp"
            var $cmp220=((($conv219))|0)==61; //@line 344 "getopt.cpp"
            if ($cmp220) { __label__ = 65;; } else { __label__ = 66;; } //@line 344 "getopt.cpp"
            if (__label__ == 65) {
  
              var $215=$possible_arg; //@line 345 "getopt.cpp"
              var $incdec_ptr222=(($215+1)&4294967295); //@line 345 "getopt.cpp"
              $possible_arg=$incdec_ptr222; //@line 345 "getopt.cpp"
              ; //@line 345 "getopt.cpp"
            }
  
            var $216=$possible_arg; //@line 346 "getopt.cpp"
            var $217=HEAP8[($216)]; //@line 346 "getopt.cpp"
            var $conv224=(tempInt=(($217)),(tempInt>=128?tempInt-256:tempInt)); //@line 346 "getopt.cpp"
            var $cmp225=((($conv224))|0)!=0; //@line 346 "getopt.cpp"
            var $218=$possible_arg; //@line 346 "getopt.cpp"
            var $cond229=($cmp225) ? ($218) : 0; //@line 346 "getopt.cpp"
            var $219=$data_addr; //@line 346 "getopt.cpp"
            var $optarg230=(($219)&4294967295); //@line 346 "getopt.cpp"
            HEAP32[(($optarg230)>>2)]=$cond229; //@line 346 "getopt.cpp"
            var $220=$data_addr; //@line 347 "getopt.cpp"
            var $optwhere231=(($220+16)&4294967295); //@line 347 "getopt.cpp"
            HEAP32[(($optwhere231)>>2)]=1; //@line 347 "getopt.cpp"
            ; //@line 348 "getopt.cpp"
          }
          else if (__label__ == 67) {
  
            var $221=$possible_arg; //@line 350 "getopt.cpp"
            var $222=HEAP8[($221)]; //@line 350 "getopt.cpp"
            var $conv233=(tempInt=(($222)),(tempInt>=128?tempInt-256:tempInt)); //@line 350 "getopt.cpp"
            var $cmp234=((($conv233))|0)==61; //@line 350 "getopt.cpp"
            if ($cmp234) { __label__ = 68;; } else { __label__ = 69;; } //@line 350 "getopt.cpp"
            if (__label__ == 68) {
  
              var $223=$possible_arg; //@line 351 "getopt.cpp"
              var $incdec_ptr236=(($223+1)&4294967295); //@line 351 "getopt.cpp"
              $possible_arg=$incdec_ptr236; //@line 351 "getopt.cpp"
              ; //@line 351 "getopt.cpp"
            }
  
            var $224=$possible_arg; //@line 352 "getopt.cpp"
            var $225=HEAP8[($224)]; //@line 352 "getopt.cpp"
            var $conv238=(tempInt=(($225)),(tempInt>=128?tempInt-256:tempInt)); //@line 352 "getopt.cpp"
            var $cmp239=((($conv238))|0)!=0; //@line 352 "getopt.cpp"
            if ($cmp239) { __label__ = 70;; } else { __label__ = 71;; } //@line 352 "getopt.cpp"
            if (__label__ == 70) {
  
              var $226=$possible_arg; //@line 354 "getopt.cpp"
              var $227=$data_addr; //@line 354 "getopt.cpp"
              var $optarg241=(($227)&4294967295); //@line 354 "getopt.cpp"
              HEAP32[(($optarg241)>>2)]=$226; //@line 354 "getopt.cpp"
              var $228=$data_addr; //@line 355 "getopt.cpp"
              var $optwhere242=(($228+16)&4294967295); //@line 355 "getopt.cpp"
              HEAP32[(($optwhere242)>>2)]=1; //@line 355 "getopt.cpp"
              ; //@line 356 "getopt.cpp"
            }
            else if (__label__ == 71) {
  
              var $229=$data_addr; //@line 357 "getopt.cpp"
              var $optind244=(($229+4)&4294967295); //@line 357 "getopt.cpp"
              var $230=HEAP32[(($optind244)>>2)]; //@line 357 "getopt.cpp"
              var $add245=((($230)+1)&4294967295); //@line 357 "getopt.cpp"
              var $231=$argc_addr; //@line 357 "getopt.cpp"
              var $cmp246=((($add245))|0) >= ((($231))|0); //@line 357 "getopt.cpp"
              var $232=$data_addr; //@line 359 "getopt.cpp"
              if ($cmp246) { __label__ = 72;; } else { __label__ = 77;; } //@line 357 "getopt.cpp"
              if (__label__ == 72) {
  
                var $opterr248=(($232+8)&4294967295); //@line 359 "getopt.cpp"
                var $233=HEAP32[(($opterr248)>>2)]; //@line 359 "getopt.cpp"
                var $tobool249=((($233))|0)!=0; //@line 359 "getopt.cpp"
                if ($tobool249) { __label__ = 73;; } else { __label__ = 76;; } //@line 359 "getopt.cpp"
                if (__label__ == 73) {
  
                  var $234=HEAP32[((__impure_ptr)>>2)]; //@line 361 "getopt.cpp"
                  var $_stderr251=(($234+12)&4294967295); //@line 361 "getopt.cpp"
                  var $235=HEAP32[(($_stderr251)>>2)]; //@line 361 "getopt.cpp"
                  var $236=$argv_addr; //@line 361 "getopt.cpp"
                  var $arrayidx252=(($236)&4294967295); //@line 361 "getopt.cpp"
                  var $237=HEAP32[(($arrayidx252)>>2)]; //@line 361 "getopt.cpp"
                  var $call253=_fprintf($235, ((__str4835)&4294967295), allocate([$237,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 361 "getopt.cpp"
                  var $238=$longopt_match; //@line 362 "getopt.cpp"
                  var $cmp254=((($238))|0) >= 0; //@line 362 "getopt.cpp"
                  var $239=HEAP32[((__impure_ptr)>>2)]; //@line 363 "getopt.cpp"
                  var $_stderr256=(($239+12)&4294967295); //@line 363 "getopt.cpp"
                  var $240=HEAP32[(($_stderr256)>>2)]; //@line 363 "getopt.cpp"
                  if ($cmp254) { __label__ = 74;; } else { __label__ = 75;; } //@line 362 "getopt.cpp"
                  if (__label__ == 74) {
  
                    var $241=$longopt_match; //@line 363 "getopt.cpp"
                    var $242=$longopts_addr; //@line 363 "getopt.cpp"
                    var $arrayidx257=(($242+16*$241)&4294967295); //@line 363 "getopt.cpp"
                    var $name258=(($arrayidx257)&4294967295); //@line 363 "getopt.cpp"
                    var $243=HEAP32[(($name258)>>2)]; //@line 363 "getopt.cpp"
                    var $call259=_fprintf($240, ((__str5836)&4294967295), allocate([$243,0,0,0], ["i8*",0,0,0], ALLOC_STACK)); //@line 363 "getopt.cpp"
                    ; //@line 363 "getopt.cpp"
                  }
                  else if (__label__ == 75) {
  
                    var $244=$cp; //@line 365 "getopt.cpp"
                    var $245=HEAP8[($244)]; //@line 365 "getopt.cpp"
                    var $conv262=(tempInt=(($245)),(tempInt>=128?tempInt-256:tempInt)); //@line 365 "getopt.cpp"
                    var $call263=_fprintf($240, ((__str6837)&4294967295), allocate([$conv262,0,0,0], ["i32",0,0,0], ALLOC_STACK)); //@line 365 "getopt.cpp"
                    ;
                  }
                }
  
                var $246=$data_addr; //@line 367 "getopt.cpp"
                var $optind266=(($246+4)&4294967295); //@line 367 "getopt.cpp"
                var $247=HEAP32[(($optind266)>>2)]; //@line 367 "getopt.cpp"
                var $inc267=((($247)+1)&4294967295); //@line 367 "getopt.cpp"
                HEAP32[(($optind266)>>2)]=$inc267; //@line 367 "getopt.cpp"
                var $248=$data_addr; //@line 368 "getopt.cpp"
                var $optopt268=(($248+12)&4294967295); //@line 368 "getopt.cpp"
                HEAP32[(($optopt268)>>2)]=58; //@line 368 "getopt.cpp"
                $retval=58; //@line 368 "getopt.cpp"
                __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 368 "getopt.cpp"
              }
              else if (__label__ == 77) {
  
                var $optind270=(($232+4)&4294967295); //@line 372 "getopt.cpp"
                var $249=HEAP32[(($optind270)>>2)]; //@line 372 "getopt.cpp"
                var $add271=((($249)+1)&4294967295); //@line 372 "getopt.cpp"
                var $250=$argv_addr; //@line 372 "getopt.cpp"
                var $arrayidx272=(($250+4*$add271)&4294967295); //@line 372 "getopt.cpp"
                var $251=HEAP32[(($arrayidx272)>>2)]; //@line 372 "getopt.cpp"
                var $252=$data_addr; //@line 372 "getopt.cpp"
                var $optarg273=(($252)&4294967295); //@line 372 "getopt.cpp"
                HEAP32[(($optarg273)>>2)]=$251; //@line 372 "getopt.cpp"
                $arg_next=1; //@line 373 "getopt.cpp"
                var $253=$data_addr; //@line 374 "getopt.cpp"
                var $optwhere274=(($253+16)&4294967295); //@line 374 "getopt.cpp"
                HEAP32[(($optwhere274)>>2)]=1; //@line 374 "getopt.cpp"
                ;
              }
            }
          }
  
          var $266=$ordering; //@line 392 "getopt.cpp"
          var $cmp297=((($266))|0)==0; //@line 392 "getopt.cpp"
          if ($cmp297) { __label__ = 84;; } else { __label__ = 87;; } //@line 392 "getopt.cpp"
          $land_lhs_true298$$if_else309$117: do { 
            if (__label__ == 84) {
  
              var $267=$data_addr; //@line 392 "getopt.cpp"
              var $optwhere299=(($267+16)&4294967295); //@line 392 "getopt.cpp"
              var $268=HEAP32[(($optwhere299)>>2)]; //@line 392 "getopt.cpp"
              var $cmp300=((($268))|0)==1; //@line 392 "getopt.cpp"
              if (!($cmp300)) { __label__ = 87;break $land_lhs_true298$$if_else309$117; } //@line 392 "getopt.cpp"
  
              var $269=$num_nonopts; //@line 392 "getopt.cpp"
              var $cmp302=((($269))|0)!=0; //@line 392 "getopt.cpp"
              if (!($cmp302)) { __label__ = 87;break $land_lhs_true298$$if_else309$117; } //@line 392 "getopt.cpp"
  
              var $270=$argv_addr; //@line 394 "getopt.cpp"
              var $271=$permute_from; //@line 394 "getopt.cpp"
              var $add_ptr304=(($270+4*$271)&4294967295); //@line 394 "getopt.cpp"
              var $272=$num_nonopts; //@line 394 "getopt.cpp"
              var $273=$arg_next; //@line 394 "getopt.cpp"
              var $add305=((($273)+1)&4294967295); //@line 394 "getopt.cpp"
              __ZL7permutePKPcii($add_ptr304, $272, $add305); //@line 394 "getopt.cpp"
              var $274=$permute_from; //@line 395 "getopt.cpp"
              var $275=$arg_next; //@line 395 "getopt.cpp"
              var $add306=((($274)+1)&4294967295); //@line 395 "getopt.cpp"
              var $add307=((($add306)+($275))&4294967295); //@line 395 "getopt.cpp"
              var $276=$data_addr; //@line 395 "getopt.cpp"
              var $optind308=(($276+4)&4294967295); //@line 395 "getopt.cpp"
              HEAP32[(($optind308)>>2)]=$add307; //@line 395 "getopt.cpp"
              __label__ = 89;break $land_lhs_true298$$if_else309$117; //@line 396 "getopt.cpp"
            }
          } while(0);
          $if_end318$$if_else309$121: do { 
            if (__label__ == 87) {
  
              var $277=$data_addr; //@line 397 "getopt.cpp"
              var $optwhere310=(($277+16)&4294967295); //@line 397 "getopt.cpp"
              var $278=HEAP32[(($optwhere310)>>2)]; //@line 397 "getopt.cpp"
              var $cmp311=((($278))|0)==1; //@line 397 "getopt.cpp"
              if (!($cmp311)) { __label__ = 89;break $if_end318$$if_else309$121; } //@line 397 "getopt.cpp"
  
              var $279=$data_addr; //@line 398 "getopt.cpp"
              var $optind313=(($279+4)&4294967295); //@line 398 "getopt.cpp"
              var $280=HEAP32[(($optind313)>>2)]; //@line 398 "getopt.cpp"
              var $281=$arg_next; //@line 398 "getopt.cpp"
              var $add314=((($280)+1)&4294967295); //@line 398 "getopt.cpp"
              var $add315=((($add314)+($281))&4294967295); //@line 398 "getopt.cpp"
              var $282=$data_addr; //@line 398 "getopt.cpp"
              var $optind316=(($282+4)&4294967295); //@line 398 "getopt.cpp"
              HEAP32[(($optind316)>>2)]=$add315; //@line 398 "getopt.cpp"
              ; //@line 398 "getopt.cpp"
            }
          } while(0);
  
          var $283=$longopt_match; //@line 401 "getopt.cpp"
          var $cmp319=((($283))|0) >= 0; //@line 401 "getopt.cpp"
          if ($cmp319) { __label__ = 90;; } else { __label__ = 95;; } //@line 401 "getopt.cpp"
          if (__label__ == 90) {
  
            var $284=$longind_addr; //@line 403 "getopt.cpp"
            var $cmp321=((($284))|0)!=0; //@line 403 "getopt.cpp"
            if ($cmp321) { __label__ = 91;; } else { __label__ = 92;; } //@line 403 "getopt.cpp"
            if (__label__ == 91) {
  
              var $285=$longopt_match; //@line 404 "getopt.cpp"
              var $286=$longind_addr; //@line 404 "getopt.cpp"
              HEAP32[(($286)>>2)]=$285; //@line 404 "getopt.cpp"
              ; //@line 404 "getopt.cpp"
            }
  
            var $287=$longopt_match; //@line 405 "getopt.cpp"
            var $288=$longopts_addr; //@line 405 "getopt.cpp"
            var $arrayidx324=(($288+16*$287)&4294967295); //@line 405 "getopt.cpp"
            var $flag=(($arrayidx324+8)&4294967295); //@line 405 "getopt.cpp"
            var $289=HEAP32[(($flag)>>2)]; //@line 405 "getopt.cpp"
            var $cmp325=((($289))|0)!=0; //@line 405 "getopt.cpp"
            var $290=$longopt_match; //@line 407 "getopt.cpp"
            var $291=$longopts_addr; //@line 407 "getopt.cpp"
            var $arrayidx327=(($291+16*$290)&4294967295); //@line 407 "getopt.cpp"
            var $val=(($arrayidx327+12)&4294967295); //@line 407 "getopt.cpp"
            var $292=HEAP32[(($val)>>2)]; //@line 407 "getopt.cpp"
            if ($cmp325) { __label__ = 93;; } else { __label__ = 94;; } //@line 405 "getopt.cpp"
            if (__label__ == 93) {
  
              var $293=$longopt_match; //@line 407 "getopt.cpp"
              var $294=$longopts_addr; //@line 407 "getopt.cpp"
              var $arrayidx328=(($294+16*$293)&4294967295); //@line 407 "getopt.cpp"
              var $flag329=(($arrayidx328+8)&4294967295); //@line 407 "getopt.cpp"
              var $295=HEAP32[(($flag329)>>2)]; //@line 407 "getopt.cpp"
              HEAP32[(($295)>>2)]=$292; //@line 407 "getopt.cpp"
              $retval=0; //@line 408 "getopt.cpp"
              __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 408 "getopt.cpp"
            }
            else if (__label__ == 94) {
  
              $retval=$292; //@line 411 "getopt.cpp"
              __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 411 "getopt.cpp"
            }
          }
          else if (__label__ == 95) {
  
            var $296=$data_addr; //@line 414 "getopt.cpp"
            var $optopt334=(($296+12)&4294967295); //@line 414 "getopt.cpp"
            var $297=HEAP32[(($optopt334)>>2)]; //@line 414 "getopt.cpp"
            $retval=$297; //@line 414 "getopt.cpp"
            __label__ = 96;break $if_then$$lor_lhs_false$2; //@line 414 "getopt.cpp"
          }
        }
      }
    } while(0);
    if (__label__ == 6) {
  
      $retval=-1; //@line 193 "getopt.cpp"
      ; //@line 193 "getopt.cpp"
    }
  
    var $298=$retval; //@line 415 "getopt.cpp"
    ;
    return $298; //@line 415 "getopt.cpp"
    return null;
  }
  

  function __ZL13write_globalsP11getopt_data($data) {
    ;
    var __label__;
  
    var $data_addr;
    $data_addr=$data;
    var $0=$data_addr; //@line 166 "getopt.cpp"
    var $optarg=(($0)&4294967295); //@line 166 "getopt.cpp"
    var $1=HEAP32[(($optarg)>>2)]; //@line 166 "getopt.cpp"
    HEAP32[((_optarg)>>2)]=$1; //@line 166 "getopt.cpp"
    var $2=$data_addr; //@line 167 "getopt.cpp"
    var $optind=(($2+4)&4294967295); //@line 167 "getopt.cpp"
    var $3=HEAP32[(($optind)>>2)]; //@line 167 "getopt.cpp"
    HEAP32[((_optind)>>2)]=$3; //@line 167 "getopt.cpp"
    var $4=$data_addr; //@line 168 "getopt.cpp"
    var $opterr=(($4+8)&4294967295); //@line 168 "getopt.cpp"
    var $5=HEAP32[(($opterr)>>2)]; //@line 168 "getopt.cpp"
    HEAP32[((_opterr)>>2)]=$5; //@line 168 "getopt.cpp"
    var $6=$data_addr; //@line 169 "getopt.cpp"
    var $optopt=(($6+12)&4294967295); //@line 169 "getopt.cpp"
    var $7=HEAP32[(($optopt)>>2)]; //@line 169 "getopt.cpp"
    HEAP32[((_optopt)>>2)]=$7; //@line 169 "getopt.cpp"
    var $8=$data_addr; //@line 170 "getopt.cpp"
    var $optwhere=(($8+16)&4294967295); //@line 170 "getopt.cpp"
    var $9=HEAP32[(($optwhere)>>2)]; //@line 170 "getopt.cpp"
    HEAP32[((__ZL8optwhere)>>2)]=$9; //@line 170 "getopt.cpp"
    ;
    return; //@line 171 "getopt.cpp"
    return;
  }
  

  function _getopt_long($argc, $argv, $shortopts, $longopts, $longind) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data=__stackBase__;
    var $r;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    __ZL12read_globalsP11getopt_data($data); //@line 436 "getopt.cpp"
    var $0=$argc_addr; //@line 437 "getopt.cpp"
    var $1=$argv_addr; //@line 437 "getopt.cpp"
    var $2=$shortopts_addr; //@line 437 "getopt.cpp"
    var $3=$longopts_addr; //@line 437 "getopt.cpp"
    var $4=$longind_addr; //@line 437 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 0, $data); //@line 437 "getopt.cpp"
    $r=$call; //@line 437 "getopt.cpp"
    __ZL13write_globalsP11getopt_data($data); //@line 438 "getopt.cpp"
    var $5=$r; //@line 439 "getopt.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 439 "getopt.cpp"
    return null;
  }
  

  function _getopt_long_only($argc, $argv, $shortopts, $longopts, $longind) {
    var __stackBase__  = STACKTOP; STACKTOP += 20; _memset(__stackBase__, 0, 20);
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data=__stackBase__;
    var $r;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    __ZL12read_globalsP11getopt_data($data); //@line 449 "getopt.cpp"
    var $0=$argc_addr; //@line 450 "getopt.cpp"
    var $1=$argv_addr; //@line 450 "getopt.cpp"
    var $2=$shortopts_addr; //@line 450 "getopt.cpp"
    var $3=$longopts_addr; //@line 450 "getopt.cpp"
    var $4=$longind_addr; //@line 450 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 1, $data); //@line 450 "getopt.cpp"
    $r=$call; //@line 450 "getopt.cpp"
    __ZL13write_globalsP11getopt_data($data); //@line 451 "getopt.cpp"
    var $5=$r; //@line 452 "getopt.cpp"
    STACKTOP = __stackBase__;
    return $5; //@line 452 "getopt.cpp"
    return null;
  }
  

  function ___getopt_r($argc, $argv, $optstring, $data) {
    ;
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $optstring_addr;
    var $data_addr;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $optstring_addr=$optstring;
    $data_addr=$data;
    var $0=$argc_addr; //@line 459 "getopt.cpp"
    var $1=$argv_addr; //@line 459 "getopt.cpp"
    var $2=$optstring_addr; //@line 459 "getopt.cpp"
    var $3=$data_addr; //@line 459 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, 0, 0, 0, $3); //@line 459 "getopt.cpp"
    ;
    return $call; //@line 459 "getopt.cpp"
    return null;
  }
  

  function ___getopt_long_r($argc, $argv, $shortopts, $longopts, $longind, $data) {
    ;
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data_addr;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    $data_addr=$data;
    var $0=$argc_addr; //@line 467 "getopt.cpp"
    var $1=$argv_addr; //@line 467 "getopt.cpp"
    var $2=$shortopts_addr; //@line 467 "getopt.cpp"
    var $3=$longopts_addr; //@line 467 "getopt.cpp"
    var $4=$longind_addr; //@line 467 "getopt.cpp"
    var $5=$data_addr; //@line 467 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 0, $5); //@line 467 "getopt.cpp"
    ;
    return $call; //@line 467 "getopt.cpp"
    return null;
  }
  

  function ___getopt_long_only_r($argc, $argv, $shortopts, $longopts, $longind, $data) {
    ;
    var __label__;
  
    var $argc_addr;
    var $argv_addr;
    var $shortopts_addr;
    var $longopts_addr;
    var $longind_addr;
    var $data_addr;
    $argc_addr=$argc;
    $argv_addr=$argv;
    $shortopts_addr=$shortopts;
    $longopts_addr=$longopts;
    $longind_addr=$longind;
    $data_addr=$data;
    var $0=$argc_addr; //@line 475 "getopt.cpp"
    var $1=$argv_addr; //@line 475 "getopt.cpp"
    var $2=$shortopts_addr; //@line 475 "getopt.cpp"
    var $3=$longopts_addr; //@line 475 "getopt.cpp"
    var $4=$longind_addr; //@line 475 "getopt.cpp"
    var $5=$data_addr; //@line 475 "getopt.cpp"
    var $call=__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data($0, $1, $2, $3, $4, 1, $5); //@line 475 "getopt.cpp"
    ;
    return $call; //@line 475 "getopt.cpp"
    return null;
  }
  

  function __ZL9is_optionPci($argv_element, $only) {
    ;
    var __label__;
    var __lastLabel__ = null;
  
    var $argv_element_addr;
    var $only_addr;
    $argv_element_addr=$argv_element;
    $only_addr=$only;
    var $0=$argv_element_addr; //@line 145 "getopt.cpp"
    var $cmp=((($0))|0)==0; //@line 145 "getopt.cpp"
    if ($cmp) { __lastLabel__ = 0; __label__ = 4;; } else { __lastLabel__ = 0; __label__ = 1;; } //@line 145 "getopt.cpp"
    $lor_end$$lor_lhs_false$2: do { 
      if (__label__ == 1) {
  
        var $1=$argv_element_addr; //@line 145 "getopt.cpp"
        var $arrayidx=(($1)&4294967295); //@line 145 "getopt.cpp"
        var $2=HEAP8[($arrayidx)]; //@line 145 "getopt.cpp"
        var $conv=(tempInt=(($2)),(tempInt>=128?tempInt-256:tempInt)); //@line 145 "getopt.cpp"
        var $cmp1=((($conv))|0)==45; //@line 145 "getopt.cpp"
        if ($cmp1) { __lastLabel__ = 1; __label__ = 4;break $lor_end$$lor_lhs_false$2; } else { __lastLabel__ = 1; ; } //@line 145 "getopt.cpp"
  
        var $3=$only_addr; //@line 145 "getopt.cpp"
        var $tobool=((($3))|0)!=0; //@line 145 "getopt.cpp"
        if ($tobool) { __lastLabel__ = 2; ; } else { __lastLabel__ = 2; __label__ = 4;break $lor_end$$lor_lhs_false$2; } //@line 145 "getopt.cpp"
  
        var $4=$argv_element_addr; //@line 145 "getopt.cpp"
        var $arrayidx2=(($4)&4294967295); //@line 145 "getopt.cpp"
        var $5=HEAP8[($arrayidx2)]; //@line 145 "getopt.cpp"
        var $conv3=(tempInt=(($5)),(tempInt>=128?tempInt-256:tempInt)); //@line 145 "getopt.cpp"
        var $cmp4=((($conv3))|0)==43; //@line 145 "getopt.cpp"
        __lastLabel__ = 3; ;
      }
    } while(0);
  
    var $6=__lastLabel__ == 1 ? 1 : (__lastLabel__ == 0 ? 1 : (__lastLabel__ == 2 ? 0 : ($cmp4)));
    var $conv5=((($6))&1);
    ;
    return $conv5; //@line 147 "getopt.cpp"
    return null;
  }
  

  function __ZL7permutePKPcii($argv, $len1, $len2) {
    ;
    var __label__;
  
    var $argv_addr;
    var $len1_addr;
    var $len2_addr;
    $argv_addr=$argv;
    $len1_addr=$len1;
    $len2_addr=$len2;
    var $0=$argv_addr; //@line 136 "getopt.cpp"
    var $1=$len1_addr; //@line 136 "getopt.cpp"
    __ZL21reverse_argv_elementsPPci($0, $1); //@line 136 "getopt.cpp"
    var $2=$argv_addr; //@line 137 "getopt.cpp"
    var $3=$len1_addr; //@line 137 "getopt.cpp"
    var $4=$len2_addr; //@line 137 "getopt.cpp"
    var $add=((($4)+($3))&4294967295); //@line 137 "getopt.cpp"
    __ZL21reverse_argv_elementsPPci($2, $add); //@line 137 "getopt.cpp"
    var $5=$argv_addr; //@line 138 "getopt.cpp"
    var $6=$len2_addr; //@line 138 "getopt.cpp"
    __ZL21reverse_argv_elementsPPci($5, $6); //@line 138 "getopt.cpp"
    ;
    return; //@line 139 "getopt.cpp"
    return;
  }
  

  function __ZL21reverse_argv_elementsPPci($argv, $num) {
    ;
    var __label__;
  
    var $argv_addr;
    var $num_addr;
    var $i;
    var $tmp;
    $argv_addr=$argv;
    $num_addr=$num;
    $i=0; //@line 124 "getopt.cpp"
    var $0=$i; //@line 124 "getopt.cpp"
    var $1=$num_addr; //@line 124 "getopt.cpp"
    var $shr2=($1) >> 1; //@line 124 "getopt.cpp"
    var $cmp3=((($0))|0) < ((($shr2))|0); //@line 124 "getopt.cpp"
    if ($cmp3) { __label__ = 1;; } else { __label__ = 2;; } //@line 124 "getopt.cpp"
    $for_body$$for_end$2: do { 
      if (__label__ == 1) {
        while(1) { 
  
          var $2=$i; //@line 126 "getopt.cpp"
          var $3=$argv_addr; //@line 126 "getopt.cpp"
          var $arrayidx=(($3+4*$2)&4294967295); //@line 126 "getopt.cpp"
          var $4=HEAP32[(($arrayidx)>>2)]; //@line 126 "getopt.cpp"
          $tmp=$4; //@line 126 "getopt.cpp"
          var $5=$num_addr; //@line 127 "getopt.cpp"
          var $6=$i; //@line 127 "getopt.cpp"
          var $_neg=(((-($6)))&4294967295);
          var $sub=((($5)-1)&4294967295); //@line 127 "getopt.cpp"
          var $sub1=((($sub)+($_neg))&4294967295); //@line 127 "getopt.cpp"
          var $7=$argv_addr; //@line 127 "getopt.cpp"
          var $arrayidx2=(($7+4*$sub1)&4294967295); //@line 127 "getopt.cpp"
          var $8=HEAP32[(($arrayidx2)>>2)]; //@line 127 "getopt.cpp"
          var $9=$i; //@line 127 "getopt.cpp"
          var $10=$argv_addr; //@line 127 "getopt.cpp"
          var $arrayidx3=(($10+4*$9)&4294967295); //@line 127 "getopt.cpp"
          HEAP32[(($arrayidx3)>>2)]=$8; //@line 127 "getopt.cpp"
          var $11=$tmp; //@line 128 "getopt.cpp"
          var $12=$num_addr; //@line 128 "getopt.cpp"
          var $13=$i; //@line 128 "getopt.cpp"
          var $_neg1=(((-($13)))&4294967295);
          var $sub4=((($12)-1)&4294967295); //@line 128 "getopt.cpp"
          var $sub5=((($sub4)+($_neg1))&4294967295); //@line 128 "getopt.cpp"
          var $14=$argv_addr; //@line 128 "getopt.cpp"
          var $arrayidx6=(($14+4*$sub5)&4294967295); //@line 128 "getopt.cpp"
          HEAP32[(($arrayidx6)>>2)]=$11; //@line 128 "getopt.cpp"
          var $15=$i; //@line 124 "getopt.cpp"
          var $inc=((($15)+1)&4294967295); //@line 124 "getopt.cpp"
          $i=$inc; //@line 124 "getopt.cpp"
          var $16=$i; //@line 124 "getopt.cpp"
          var $17=$num_addr; //@line 124 "getopt.cpp"
          var $shr=($17) >> 1; //@line 124 "getopt.cpp"
          var $cmp=((($16))|0) < ((($shr))|0); //@line 124 "getopt.cpp"
          if ($cmp) { __label__ = 1;continue ; } else { __label__ = 2;break $for_body$$for_end$2; } //@line 124 "getopt.cpp"
        }
      }
    } while(0);
  
    ;
    return; //@line 130 "getopt.cpp"
    return;
  }
  

  function ___strtok_r($s, $delim, $lasts, $skip_leading_delim) {
    ;
    var __label__;
  
    var $retval;
    var $s_addr;
    var $delim_addr;
    var $lasts_addr;
    var $skip_leading_delim_addr;
    var $spanp;
    var $c;
    var $sc;
    var $tok;
    $s_addr=$s;
    $delim_addr=$delim;
    $lasts_addr=$lasts;
    $skip_leading_delim_addr=$skip_leading_delim;
    var $0=$s_addr; //@line 48 "strtok.cpp"
    var $cmp=((($0))|0)==0; //@line 48 "strtok.cpp"
    if ($cmp) { __label__ = 1;; } else { __label__ = 3;; } //@line 48 "strtok.cpp"
    $land_lhs_true$$cont$2: do { 
      if (__label__ == 1) {
  
        var $1=$lasts_addr; //@line 48 "strtok.cpp"
        var $2=HEAP32[(($1)>>2)]; //@line 48 "strtok.cpp"
        $s_addr=$2; //@line 48 "strtok.cpp"
        var $cmp1=((($2))|0)==0; //@line 48 "strtok.cpp"
        if (!($cmp1)) { __label__ = 3;break $land_lhs_true$$cont$2; } //@line 48 "strtok.cpp"
  
        $retval=0; //@line 49 "strtok.cpp"
        __label__ = 18;break $land_lhs_true$$cont$2; //@line 49 "strtok.cpp"
      }
    } while(0);
    if (__label__ == 3) {
      $cont$6: while(1) { 
  
        var $3=$s_addr; //@line 55 "strtok.cpp"
        var $incdec_ptr=(($3+1)&4294967295); //@line 55 "strtok.cpp"
        $s_addr=$incdec_ptr; //@line 55 "strtok.cpp"
        var $4=HEAP8[($3)]; //@line 55 "strtok.cpp"
        var $conv=(tempInt=(($4)),(tempInt>=128?tempInt-256:tempInt)); //@line 55 "strtok.cpp"
        $c=$conv; //@line 55 "strtok.cpp"
        var $5=$delim_addr; //@line 56 "strtok.cpp"
        $spanp=$5; //@line 56 "strtok.cpp"
        ; //@line 56 "strtok.cpp"
        while(1) { 
  
          var $6=$spanp; //@line 56 "strtok.cpp"
          var $incdec_ptr2=(($6+1)&4294967295); //@line 56 "strtok.cpp"
          $spanp=$incdec_ptr2; //@line 56 "strtok.cpp"
          var $7=HEAP8[($6)]; //@line 56 "strtok.cpp"
          var $conv3=(tempInt=(($7)),(tempInt>=128?tempInt-256:tempInt)); //@line 56 "strtok.cpp"
          $sc=$conv3; //@line 56 "strtok.cpp"
          var $cmp4=((($conv3))|0)!=0; //@line 56 "strtok.cpp"
          var $8=$c; //@line 57 "strtok.cpp"
          if (!($cmp4)) { __label__ = 8;break $cont$6; } //@line 56 "strtok.cpp"
  
          var $9=$sc; //@line 57 "strtok.cpp"
          var $cmp5=((($8))|0)==((($9))|0); //@line 57 "strtok.cpp"
          if ($cmp5) { __label__ = 6;break ; } else { __label__ = 4;continue ; } //@line 57 "strtok.cpp"
        }
  
        var $10=$skip_leading_delim_addr; //@line 58 "strtok.cpp"
        var $tobool=((($10))|0)!=0; //@line 58 "strtok.cpp"
        if ($tobool) { __label__ = 3;continue $cont$6; } else { __label__ = 7;break $cont$6; } //@line 58 "strtok.cpp"
      }
      if (__label__ == 8) {
  
        var $cmp9=((($8))|0)==0; //@line 69 "strtok.cpp"
        if ($cmp9) { __label__ = 9;; } else { __label__ = 10;; } //@line 69 "strtok.cpp"
        if (__label__ == 9) {
  
          var $15=$lasts_addr; //@line 70 "strtok.cpp"
          HEAP32[(($15)>>2)]=0; //@line 70 "strtok.cpp"
          $retval=0; //@line 71 "strtok.cpp"
          ; //@line 71 "strtok.cpp"
        }
        else if (__label__ == 10) {
  
          var $16=$s_addr; //@line 73 "strtok.cpp"
          var $add_ptr12=(($16+-1)&4294967295); //@line 73 "strtok.cpp"
          $tok=$add_ptr12; //@line 73 "strtok.cpp"
          ; //@line 79 "strtok.cpp"
          $for_cond13$17: while(1) { 
  
            var $17=$s_addr; //@line 80 "strtok.cpp"
            var $incdec_ptr14=(($17+1)&4294967295); //@line 80 "strtok.cpp"
            $s_addr=$incdec_ptr14; //@line 80 "strtok.cpp"
            var $18=HEAP8[($17)]; //@line 80 "strtok.cpp"
            var $conv15=(tempInt=(($18)),(tempInt>=128?tempInt-256:tempInt)); //@line 80 "strtok.cpp"
            $c=$conv15; //@line 80 "strtok.cpp"
            var $19=$delim_addr; //@line 81 "strtok.cpp"
            $spanp=$19; //@line 81 "strtok.cpp"
            ; //@line 82 "strtok.cpp"
            while(1) { 
  
              var $20=$spanp; //@line 83 "strtok.cpp"
              var $incdec_ptr16=(($20+1)&4294967295); //@line 83 "strtok.cpp"
              $spanp=$incdec_ptr16; //@line 83 "strtok.cpp"
              var $21=HEAP8[($20)]; //@line 83 "strtok.cpp"
              var $conv17=(tempInt=(($21)),(tempInt>=128?tempInt-256:tempInt)); //@line 83 "strtok.cpp"
              $sc=$conv17; //@line 83 "strtok.cpp"
              var $22=$c; //@line 83 "strtok.cpp"
              var $cmp18=((($conv17))|0)==((($22))|0); //@line 83 "strtok.cpp"
              if ($cmp18) { __label__ = 13;break $for_cond13$17; } //@line 83 "strtok.cpp"
  
              var $28=$sc; //@line 91 "strtok.cpp"
              var $cmp26=((($28))|0)!=0; //@line 91 "strtok.cpp"
              if ($cmp26) { __label__ = 12;continue ; } else { __label__ = 11;continue $for_cond13$17; } //@line 91 "strtok.cpp"
            }
          }
  
          var $23=$c; //@line 84 "strtok.cpp"
          var $cmp20=((($23))|0)==0; //@line 84 "strtok.cpp"
          if ($cmp20) { __label__ = 14;; } else { __label__ = 15;; } //@line 84 "strtok.cpp"
          if (__label__ == 14) {
  
            $s_addr=0; //@line 85 "strtok.cpp"
            ; //@line 85 "strtok.cpp"
          }
          else if (__label__ == 15) {
  
            var $24=$s_addr; //@line 87 "strtok.cpp"
            var $arrayidx23=(($24+-1)&4294967295); //@line 87 "strtok.cpp"
            HEAP8[($arrayidx23)]=0; //@line 87 "strtok.cpp"
            ;
          }
  
          var $25=$s_addr; //@line 88 "strtok.cpp"
          var $26=$lasts_addr; //@line 88 "strtok.cpp"
          HEAP32[(($26)>>2)]=$25; //@line 88 "strtok.cpp"
          var $27=$tok; //@line 89 "strtok.cpp"
          $retval=$27; //@line 89 "strtok.cpp"
          ; //@line 89 "strtok.cpp"
        }
      }
      else if (__label__ == 7) {
  
        var $11=$s_addr; //@line 62 "strtok.cpp"
        var $12=$lasts_addr; //@line 62 "strtok.cpp"
        HEAP32[(($12)>>2)]=$11; //@line 62 "strtok.cpp"
        var $13=$s_addr; //@line 63 "strtok.cpp"
        var $arrayidx=(($13+-1)&4294967295); //@line 63 "strtok.cpp"
        HEAP8[($arrayidx)]=0; //@line 63 "strtok.cpp"
        var $14=$s_addr; //@line 64 "strtok.cpp"
        var $add_ptr=(($14+-1)&4294967295); //@line 64 "strtok.cpp"
        $retval=$add_ptr; //@line 64 "strtok.cpp"
        ; //@line 64 "strtok.cpp"
      }
    }
  
    var $29=$retval; //@line 94 "strtok.cpp"
    ;
    return $29; //@line 94 "strtok.cpp"
    return null;
  }
  

  function _strtok_r($s, $delim, $lasts) {
    ;
    var __label__;
  
    var $s_addr;
    var $delim_addr;
    var $lasts_addr;
    $s_addr=$s;
    $delim_addr=$delim;
    $lasts_addr=$lasts;
    var $0=$s_addr; //@line 101 "strtok.cpp"
    var $1=$delim_addr; //@line 101 "strtok.cpp"
    var $2=$lasts_addr; //@line 101 "strtok.cpp"
    var $call=___strtok_r($0, $1, $2, 1); //@line 101 "strtok.cpp"
    ;
    return $call; //@line 101 "strtok.cpp"
    return null;
  }
  

  function _strtok($s, $delim) {
    var __stackBase__  = STACKTOP; STACKTOP += 4; _memset(__stackBase__, 0, 4);
    var __label__;
  
    var $s_addr;
    var $delim_addr;
    var $chr=__stackBase__;
    $s_addr=$s;
    $delim_addr=$delim;
    var $0=$s_addr; //@line 197 "strtok.cpp"
    var $1=$delim_addr; //@line 197 "strtok.cpp"
    var $call=___strtok_r($0, $1, $chr, 1); //@line 197 "strtok.cpp"
    STACKTOP = __stackBase__;
    return $call; //@line 197 "strtok.cpp"
    return null;
  }
  

// === Auto-generated postamble setup entry stuff ===

Module.callMain = function callMain(args) {
  var argc = args.length+1;
  function pad() {
    for (var i = 0; i < 4-1; i++) {
      argv.push(0);
    }
  }
  var argv = [allocate(intArrayFromString("/bin/this.program"), 'i8', ALLOC_STATIC) ];
  pad();
  for (var i = 0; i < argc-1; i = i + 1) {
    argv.push(allocate(intArrayFromString(args[i]), 'i8', ALLOC_STATIC));
    pad();
  }
  argv.push(0);
  argv = allocate(argv, 'i32', ALLOC_STATIC);

  return _main(argc, argv, 0);
}

function run(args) {
  args = args || Module.arguments;


_path_home=allocate(150, "i8", ALLOC_STATIC);
_filetype=allocate(5, "i8", ALLOC_STATIC);
_wavefile=allocate(200, "i8", ALLOC_STATIC);
_uri_callback=allocate(1, "i32 (i32, i8*, i8*)*", ALLOC_STATIC);
_phoneme_callback=allocate(1, "i32 (i8*)*", ALLOC_STATIC);
_f_wave=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_quiet=allocate(1, "i32", ALLOC_STATIC);
_samples_total=allocate(1, "i32", ALLOC_STATIC);
_samples_split=allocate(1, "i32", ALLOC_STATIC);
_wavefile_count=allocate(1, "i32", ALLOC_STATIC);
_end_of_sentence=allocate(1, "i32", ALLOC_STATIC);
_voice_pcnt=allocate(60, "i16", ALLOC_STATIC);
__ZZ13DisplayVoicesP7__sFILEPcE7genders=allocate([32,77,70,32] /*  MF  */, "i8", ALLOC_STATIC);
__str1=allocate([80,116,121,32,76,97,110,103,117,97,103,101,32,65,103,101,47,71,101,110,100,101,114,32,86,111,105,99,101,78,97,109,101,32,32,32,32,32,32,32,70,105,108,101,32,32,32,32,32,32,32,32,79,116,104,101,114,32,76,97,110,103,115,10,0] /* Pty Language Age/Gen */, "i8", ALLOC_STATIC);
__str3=allocate([37,51,100,0] /* %3d\00 */, "i8", ALLOC_STATIC);
__str4=allocate([37,50,100,32,32,37,45,49,50,115,37,115,37,99,32,32,37,45,49,55,115,32,37,45,49,49,115,32,0] /* %2d  %-12s%s%c  %-17 */, "i8", ALLOC_STATIC);
__str5=allocate([40,37,115,32,37,100,41,0] /* (%s %d)\00 */, "i8", ALLOC_STATIC);
__ZZ4mainE12long_options=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 104, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 256, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 257, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 260, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 261, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 262, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 263, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 264, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 266, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str6=allocate([104,101,108,112,0] /* help\00 */, "i8", ALLOC_STATIC);
__str7=allocate([115,116,100,105,110,0] /* stdin\00 */, "i8", ALLOC_STATIC);
__str8=allocate([99,111,109,112,105,108,101,45,100,101,98,117,103,0] /* compile-debug\00 */, "i8", ALLOC_STATIC);
__str9=allocate([99,111,109,112,105,108,101,0] /* compile\00 */, "i8", ALLOC_STATIC);
__str10=allocate([112,117,110,99,116,0] /* punct\00 */, "i8", ALLOC_STATIC);
__str11=allocate([118,111,105,99,101,115,0] /* voices\00 */, "i8", ALLOC_STATIC);
__str12=allocate([115,116,100,111,117,116,0] /* stdout\00 */, "i8", ALLOC_STATIC);
__str13=allocate([115,112,108,105,116,0] /* split\00 */, "i8", ALLOC_STATIC);
__str14=allocate([112,97,116,104,0] /* path\00 */, "i8", ALLOC_STATIC);
__str15=allocate([112,104,111,110,111,117,116,0] /* phonout\00 */, "i8", ALLOC_STATIC);
__str16=allocate([112,104,111,0] /* pho\00 */, "i8", ALLOC_STATIC);
__str17=allocate([105,112,97,0] /* ipa\00 */, "i8", ALLOC_STATIC);
__str18=allocate([70,97,105,108,101,100,32,116,111,32,114,101,97,100,32,0] /* Failed to read \00 */, "i8", ALLOC_STATIC);
__str19=allocate([97,58,98,58,102,58,103,58,104,107,58,108,58,112,58,113,115,58,118,58,119,58,120,88,109,122,0] /* a:b:f:g:hk:l:p:qs:v: */, "i8", ALLOC_STATIC);
__str21=allocate([10,115,112,101,97,107,32,116,101,120,116,45,116,111,45,115,112,101,101,99,104,58,32,37,115,32,32,32,68,97,116,97,32,97,116,58,32,37,115,10,37,115,0] /* \0Aspeak text-to-spe */, "i8", ALLOC_STATIC);
__str23=allocate([67,97,110,39,116,32,119,114,105,116,101,32,116,111,58,32,37,115,10,0] /* Can't write to: %s\0 */, "i8", ALLOC_STATIC);
__str25=allocate([37,115,118,111,105,99,101,32,39,37,115,39,10,0] /* %svoice '%s'\0A\00 */, "i8", ALLOC_STATIC);
__str27=allocate([37,115,102,105,108,101,32,39,37,115,39,10,0] /* %sfile '%s'\0A\00 */, "i8", ALLOC_STATIC);
__str28=allocate([67,97,110,39,116,32,119,114,105,116,101,32,116,111,32,111,117,116,112,117,116,32,102,105,108,101,32,39,37,115,39,10,39,0] /* Can't write to outpu */, "i8", ALLOC_STATIC);
__str29=allocate([45,119,32,111,112,116,105,111,110,32,109,117,115,116,32,98,101,32,117,115,101,100,32,98,101,99,97,117,115,101,32,116,104,101,32,112,114,111,103,114,97,109,32,119,97,115,32,98,117,105,108,116,32,119,105,116,104,111,117,116,32,97,32,115,111,117,110,100,32,105,110,116,101,114,102,97,99,101,10,0] /* -w option must be us */, "i8", ALLOC_STATIC);
__str30=allocate([37,115,95,37,46,50,100,37,115,0] /* %s_%.2d%s\00 */, "i8", ALLOC_STATIC);
__ZZL12OpenWaveFilePKciE8wave_hdr=allocate([82,73,70,70,36,240,255,127,87,65,86,69,102,109,116,32,16,0,0,0,1,0,1,0,9,61,0,0,18,122,0,0,2,0,16,0,100,97,116,97,0,240,255,127] /* RIFF$\F0\FF\7FWAVEfm */, "i8", ALLOC_STATIC);
__str32=allocate([101,110,95,85,83,46,85,84,70,45,56,0] /* en_US.UTF-8\00 */, "i8", ALLOC_STATIC);
__str33=allocate([85,84,70,45,56,0] /* UTF-8\00 */, "i8", ALLOC_STATIC);
__str35=allocate([70,97,105,108,101,100,32,116,111,32,108,111,97,100,32,101,115,112,101,97,107,45,100,97,116,97,10,0] /* Failed to load espea */, "i8", ALLOC_STATIC);
__str36=allocate([87,114,111,110,103,32,118,101,114,115,105,111,110,32,111,102,32,101,115,112,101,97,107,45,100,97,116,97,32,48,120,37,120,32,40,101,120,112,101,99,116,115,32,48,120,37,120,41,32,97,116,32,37,115,10,0] /* Wrong version of esp */, "i8", ALLOC_STATIC);
__str37=allocate([10,115,112,101,97,107,32,91,111,112,116,105,111,110,115,93,32,91,34,60,119,111,114,100,115,62,34,93,10,10,45,102,32,60,116,101,120,116,32,102,105,108,101,62,32,32,32,84,101,120,116,32,102,105,108,101,32,116,111,32,115,112,101,97,107,10,45,45,115,116,100,105,110,32,32,32,32,82,101,97,100,32,116,101,120,116,32,105,110,112,117,116,32,102,114,111,109,32,115,116,100,105,110,32,105,110,115,116,101,97,100,32,111,102,32,97,32,102,105,108,101,10,10,73,102,32,110,101,105,116,104,101,114,32,45,102,32,110,111,114,32,45,45,115,116,100,105,110,44,32,116,104,101,110,32,60,119,111,114,100,115,62,32,97,114,101,32,115,112,111,107,101,110,44,32,111,114,32,105,102,32,110,111,110,101,32,116,104,101,110,32,116,101,120,116,10,105,115,32,115,112,111,107,101,110,32,102,114,111,109,32,115,116,100,105,110,44,32,101,97,99,104,32,108,105,110,101,32,115,101,112,97,114,97,116,101,108,121,46,10,10,45,97,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,65,109,112,108,105,116,117,100,101,44,32,48,32,116,111,32,50,48,48,44,32,100,101,102,97,117,108,116,32,105,115,32,49,48,48,10,45,103,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,87,111,114,100,32,103,97,112,46,32,80,97,117,115,101,32,98,101,116,119,101,101,110,32,119,111,114,100,115,44,32,117,110,105,116,115,32,111,102,32,49,48,109,83,32,97,116,32,116,104,101,32,100,101,102,97,117,108,116,32,115,112,101,101,100,10,45,107,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,73,110,100,105,99,97,116,101,32,99,97,112,105,116,97,108,32,108,101,116,116,101,114,115,32,119,105,116,104,58,32,49,61,115,111,117,110,100,44,32,50,61,116,104,101,32,119,111,114,100,32,34,99,97,112,105,116,97,108,115,34,44,10,9,32,32,32,104,105,103,104,101,114,32,118,97,108,117,101,115,32,105,110,100,105,99,97,116,101,32,97,32,112,105,116,99,104,32,105,110,99,114,101,97,115,101,32,40,116,114,121,32,45,107,50,48,41,46,10,45,108,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,76,105,110,101,32,108,101,110,103,116,104,46,32,73,102,32,110,111,116,32,122,101,114,111,32,40,119,104,105,99,104,32,105,115,32,116,104,101,32,100,101,102,97,117,108,116,41,44,32,99,111,110,115,105,100,101,114,10,9,32,32,32,108,105,110,101,115,32,108,101,115,115,32,116,104,97,110,32,116,104,105,115,32,108,101,110,103,116,104,32,97,115,32,101,110,100,45,111,102,45,99,108,97,117,115,101,10,45,112,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,80,105,116,99,104,32,97,100,106,117,115,116,109,101,110,116,44,32,48,32,116,111,32,57,57,44,32,100,101,102,97,117,108,116,32,105,115,32,53,48,10,45,115,32,60,105,110,116,101,103,101,114,62,10,9,32,32,32,83,112,101,101,100,32,105,110,32,119,111,114,100,115,32,112,101,114,32,109,105,110,117,116,101,44,32,56,48,32,116,111,32,52,53,48,44,32,100,101,102,97,117,108,116,32,105,115,32,49,55,53,10,45,118,32,60,118,111,105,99,101,32,110,97,109,101,62,10,9,32,32,32,85,115,101,32,118,111,105,99,101,32,102,105,108,101,32,111,102,32,116,104,105,115,32,110,97,109,101,32,102,114,111,109,32,101,115,112,101,97,107,45,100,97,116,97,47,118,111,105,99,101,115,10,45,119,32,60,119,97,118,101,32,102,105,108,101,32,110,97,109,101,62,10,9,32,32,32,87,114,105,116,101,32,115,112,101,101,99,104,32,116,111,32,116,104,105,115,32,87,65,86,32,102,105,108,101,44,32,114,97,116,104,101,114,32,116,104,97,110,32,115,112,101,97,107,105,110,103,32,105,116,32,100,105,114,101,99,116,108,121,10,45,98,9,32,32,32,73,110,112,117,116,32,116,101,120,116,32,101,110,99,111,100,105,110,103,44,32,49,61,85,84,70,56,44,32,50,61,56,32,98,105,116,44,32,52,61,49,54,32,98,105,116,32,10,45,109,9,32,32,32,73,110,116,101,114,112,114,101,116,32,83,83,77,76,32,109,97,114,107,117,112,44,32,97,110,100,32,105,103,110,111,114,101,32,111,116,104,101,114,32,60,32,62,32,116,97,103,115,10,45,113,9,32,32,32,81,117,105,101,116,44,32,100,111,110,39,116,32,112,114,111,100,117,99,101,32,97,110,121,32,115,112,101,101,99,104,32,40,109,97,121,32,98,101,32,117,115,101,102,117,108,32,119,105,116,104,32,45,120,41,10,45,120,9,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,32,109,110,101,109,111,110,105,99,115,32,116,111,32,115,116,100,111,117,116,10,45,88,9,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,115,32,109,110,101,109,111,110,105,99,115,32,97,110,100,32,116,114,97,110,115,108,97,116,105,111,110,32,116,114,97,99,101,32,116,111,32,115,116,100,111,117,116,10,45,122,9,32,32,32,78,111,32,102,105,110,97,108,32,115,101,110,116,101,110,99,101,32,112,97,117,115,101,32,97,116,32,116,104,101,32,101,110,100,32,111,102,32,116,104,101,32,116,101,120,116,10,45,45,99,111,109,112,105,108,101,61,60,118,111,105,99,101,32,110,97,109,101,62,10,9,32,32,32,67,111,109,112,105,108,101,32,112,114,111,110,117,110,99,105,97,116,105,111,110,32,114,117,108,101,115,32,97,110,100,32,100,105,99,116,105,111,110,97,114,121,32,102,114,111,109,32,116,104,101,32,99,117,114,114,101,110,116,10,9,32,32,32,100,105,114,101,99,116,111,114,121,46,32,60,118,111,105,99,101,32,110,97,109,101,62,32,115,112,101,99,105,102,105,101,115,32,116,104,101,32,108,97,110,103,117,97,103,101,10,45,45,105,112,97,32,32,32,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,115,32,116,111,32,115,116,100,111,117,116,32,117,115,105,110,103,32,73,110,116,101,114,110,97,116,105,111,110,97,108,32,80,104,111,110,101,116,105,99,32,65,108,112,104,97,98,101,116,10,45,45,112,97,116,104,61,34,60,112,97,116,104,62,34,10,9,32,32,32,83,112,101,99,105,102,105,101,115,32,116,104,101,32,100,105,114,101,99,116,111,114,121,32,99,111,110,116,97,105,110,105,110,103,32,116,104,101,32,101,115,112,101,97,107,45,100,97,116,97,32,100,105,114,101,99,116,111,114,121,10,45,45,112,104,111,32,32,32,32,32,32,87,114,105,116,101,32,109,98,114,111,108,97,32,112,104,111,110,101,109,101,32,100,97,116,97,32,40,46,112,104,111,41,32,116,111,32,115,116,100,111,117,116,32,111,114,32,116,111,32,116,104,101,32,102,105,108,101,32,105,110,32,45,45,112,104,111,110,111,117,116,10,45,45,112,104,111,110,111,117,116,61,34,60,102,105,108,101,110,97,109,101,62,34,10,9,32,32,32,87,114,105,116,101,32,112,104,111,110,101,109,101,32,111,117,116,112,117,116,32,102,114,111,109,32,45,120,32,45,88,32,45,45,105,112,97,32,97,110,100,32,45,45,112,104,111,32,116,111,32,116,104,105,115,32,102,105,108,101,10,45,45,112,117,110,99,116,61,34,60,99,104,97,114,97,99,116,101,114,115,62,34,10,9,32,32,32,83,112,101,97,107,32,116,104,101,32,110,97,109,101,115,32,111,102,32,112,117,110,99,116,117,97,116,105,111,110,32,99,104,97,114,97,99,116,101,114,115,32,100,117,114,105,110,103,32,115,112,101,97,107,105,110,103,46,32,32,73,102,10,9,32,32,32,61,60,99,104,97,114,97,99,116,101,114,115,62,32,105,115,32,111,109,105,116,116,101,100,44,32,97,108,108,32,112,117,110,99,116,117,97,116,105,111,110,32,105,115,32,115,112,111,107,101,110,46,10,45,45,115,112,108,105,116,61,34,60,109,105,110,117,116,101,115,62,34,10,9,32,32,32,83,116,97,114,116,115,32,97,32,110,101,119,32,87,65,86,32,102,105,108,101,32,101,118,101,114,121,32,60,109,105,110,117,116,101,115,62,46,32,32,85,115,101,100,32,119,105,116,104,32,45,119,10,45,45,115,116,100,111,117,116,32,32,32,87,114,105,116,101,32,115,112,101,101,99,104,32,111,117,116,112,117,116,32,116,111,32,115,116,100,111,117,116,10,45,45,118,111,105,99,101,115,61,60,108,97,110,103,117,97,103,101,62,10,9,32,32,32,76,105,115,116,32,116,104,101,32,97,118,97,105,108,97,98,108,101,32,118,111,105,99,101,115,32,102,111,114,32,116,104,101,32,115,112,101,99,105,102,105,101,100,32,108,97,110,103,117,97,103,101,46,10,9,32,32,32,73,102,32,60,108,97,110,103,117,97,103,101,62,32,105,115,32,111,109,105,116,116,101,100,44,32,116,104,101,110,32,108,105,115,116,32,97,108,108,32,118,111,105,99,101,115,46,10,0] /* \0Aspeak [options] [ */, "i8", ALLOC_STATIC);
__str38=allocate([37,115,47,101,115,112,101,97,107,45,100,97,116,97,0] /* %s/espeak-data\00 */, "i8", ALLOC_STATIC);
__str39=allocate([69,83,80,69,65,75,95,68,65,84,65,95,80,65,84,72,0] /* ESPEAK_DATA_PATH\00 */, "i8", ALLOC_STATIC);
__str40=allocate([72,79,77,69,0] /* HOME\00 */, "i8", ALLOC_STATIC);
__str41=allocate([47,117,115,114,47,115,104,97,114,101,47,101,115,112,101,97,107,45,100,97,116,97,0] /* /usr/share/espeak-da */, "i8", ALLOC_STATIC);
__ZL5f_log=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
__str42=allocate([117,110,112,114,0] /* unpr\00 */, "i8", ALLOC_STATIC);
__str143=allocate([119,95,97,108,116,50,0] /* w_alt2\00 */, "i8", ALLOC_STATIC);
__str244=allocate([119,95,97,108,116,51,0] /* w_alt3\00 */, "i8", ALLOC_STATIC);
__str345=allocate([119,95,97,108,116,0] /* w_alt\00 */, "i8", ALLOC_STATIC);
__str446=allocate([112,95,97,108,116,50,0] /* p_alt2\00 */, "i8", ALLOC_STATIC);
__str547=allocate([112,95,97,108,116,51,0] /* p_alt3\00 */, "i8", ALLOC_STATIC);
__str648=allocate([112,95,97,108,116,0] /* p_alt\00 */, "i8", ALLOC_STATIC);
_mnem_rules=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 35, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str749=allocate([36,49,0] /* $1\00 */, "i8", ALLOC_STATIC);
__str850=allocate([36,50,0] /* $2\00 */, "i8", ALLOC_STATIC);
__str951=allocate([36,51,0] /* $3\00 */, "i8", ALLOC_STATIC);
__str1052=allocate([36,52,0] /* $4\00 */, "i8", ALLOC_STATIC);
__str1153=allocate([36,53,0] /* $5\00 */, "i8", ALLOC_STATIC);
__str1254=allocate([36,54,0] /* $6\00 */, "i8", ALLOC_STATIC);
__str1355=allocate([36,55,0] /* $7\00 */, "i8", ALLOC_STATIC);
__str1456=allocate([36,117,0] /* $u\00 */, "i8", ALLOC_STATIC);
__str1557=allocate([36,117,49,0] /* $u1\00 */, "i8", ALLOC_STATIC);
__str1658=allocate([36,117,50,0] /* $u2\00 */, "i8", ALLOC_STATIC);
__str1759=allocate([36,117,51,0] /* $u3\00 */, "i8", ALLOC_STATIC);
__str1860=allocate([36,117,43,0] /* $u+\00 */, "i8", ALLOC_STATIC);
__str1961=allocate([36,117,49,43,0] /* $u1+\00 */, "i8", ALLOC_STATIC);
__str2062=allocate([36,117,50,43,0] /* $u2+\00 */, "i8", ALLOC_STATIC);
__str2163=allocate([36,117,51,43,0] /* $u3+\00 */, "i8", ALLOC_STATIC);
__str2264=allocate([36,112,97,117,115,101,0] /* $pause\00 */, "i8", ALLOC_STATIC);
__str2365=allocate([36,111,110,108,121,0] /* $only\00 */, "i8", ALLOC_STATIC);
__str2466=allocate([36,111,110,108,121,115,0] /* $onlys\00 */, "i8", ALLOC_STATIC);
__str2567=allocate([36,115,116,114,101,110,100,0] /* $strend\00 */, "i8", ALLOC_STATIC);
__str2668=allocate([36,115,116,114,101,110,100,50,0] /* $strend2\00 */, "i8", ALLOC_STATIC);
__str2769=allocate([36,117,110,115,116,114,101,115,115,101,110,100,0] /* $unstressend\00 */, "i8", ALLOC_STATIC);
__str2870=allocate([36,97,116,101,110,100,0] /* $atend\00 */, "i8", ALLOC_STATIC);
__str2971=allocate([36,97,116,115,116,97,114,116,0] /* $atstart\00 */, "i8", ALLOC_STATIC);
__str3072=allocate([36,97,98,98,114,101,118,0] /* $abbrev\00 */, "i8", ALLOC_STATIC);
__str3173=allocate([36,115,116,101,109,0] /* $stem\00 */, "i8", ALLOC_STATIC);
__str3274=allocate([36,100,111,117,98,108,101,0] /* $double\00 */, "i8", ALLOC_STATIC);
__str3375=allocate([36,97,108,116,0] /* $alt\00 */, "i8", ALLOC_STATIC);
__str3476=allocate([36,97,108,116,49,0] /* $alt1\00 */, "i8", ALLOC_STATIC);
__str3577=allocate([36,97,108,116,50,0] /* $alt2\00 */, "i8", ALLOC_STATIC);
__str3678=allocate([36,97,108,116,51,0] /* $alt3\00 */, "i8", ALLOC_STATIC);
__str3779=allocate([36,99,111,109,98,105,110,101,0] /* $combine\00 */, "i8", ALLOC_STATIC);
__str3880=allocate([36,100,111,116,0] /* $dot\00 */, "i8", ALLOC_STATIC);
__str3981=allocate([36,104,97,115,100,111,116,0] /* $hasdot\00 */, "i8", ALLOC_STATIC);
__str4082=allocate([36,109,97,120,51,0] /* $max3\00 */, "i8", ALLOC_STATIC);
__str4183=allocate([36,98,114,107,0] /* $brk\00 */, "i8", ALLOC_STATIC);
__str4284=allocate([36,116,101,120,116,0] /* $text\00 */, "i8", ALLOC_STATIC);
__str43=allocate([36,118,101,114,98,102,0] /* $verbf\00 */, "i8", ALLOC_STATIC);
__str44=allocate([36,118,101,114,98,115,102,0] /* $verbsf\00 */, "i8", ALLOC_STATIC);
__str45=allocate([36,110,111,117,110,102,0] /* $nounf\00 */, "i8", ALLOC_STATIC);
__str46=allocate([36,112,97,115,116,102,0] /* $pastf\00 */, "i8", ALLOC_STATIC);
__str47=allocate([36,118,101,114,98,0] /* $verb\00 */, "i8", ALLOC_STATIC);
__str48=allocate([36,110,111,117,110,0] /* $noun\00 */, "i8", ALLOC_STATIC);
__str49=allocate([36,112,97,115,116,0] /* $past\00 */, "i8", ALLOC_STATIC);
__str50=allocate([36,118,101,114,98,101,120,116,101,110,100,0] /* $verbextend\00 */, "i8", ALLOC_STATIC);
__str51=allocate([36,99,97,112,105,116,97,108,0] /* $capital\00 */, "i8", ALLOC_STATIC);
__str52=allocate([36,97,108,108,99,97,112,115,0] /* $allcaps\00 */, "i8", ALLOC_STATIC);
__str53=allocate([36,97,99,99,101,110,116,0] /* $accent\00 */, "i8", ALLOC_STATIC);
__str54=allocate([36,115,101,110,116,101,110,99,101,0] /* $sentence\00 */, "i8", ALLOC_STATIC);
__str55=allocate([36,63,0] /* $?\00 */, "i8", ALLOC_STATIC);
__str56=allocate([36,116,101,120,116,109,111,100,101,0] /* $textmode\00 */, "i8", ALLOC_STATIC);
__str57=allocate([36,112,104,111,110,101,109,101,109,111,100,101,0] /* $phonememode\00 */, "i8", ALLOC_STATIC);
_mnem_flags=allocate([0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 66, 0, 0, 0, 0, 0, 0, 0, 67, 0, 0, 0, 0, 0, 0, 0, 68, 0, 0, 0, 0, 0, 0, 0, 69, 0, 0, 0, 0, 0, 0, 0, 70, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 73, 0, 0, 0, 0, 0, 0, 0, 74, 0, 0, 0, 0, 0, 0, 0, 75, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0, 0, 0, 0, 0, 0, 77, 0, 0, 0, 0, 0, 0, 0, 78, 0, 0, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 25, 0, 0, 0, 0, 0, 0, 0, 27, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 35, 0, 0, 0, 0, 0, 0, 0, 36, 0, 0, 0, 0, 0, 0, 0, 37, 0, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0, 0, 0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 42, 0, 0, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0, 0, 0, 0, 45, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 200, 0, 0, 0, 0, 0, 0, 0, 201, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ22print_dictionary_flagsPjE3buf=allocate(20, "i8", ALLOC_STATIC);
__str59=allocate([37,115,32,32,48,120,37,120,47,37,120,0] /* %s  0x%x/%x\00 */, "i8", ALLOC_STATIC);
__ZZ10DecodeRulePKciPciE6output=allocate(60, "i8", ALLOC_STATIC);
__ZZ10DecodeRulePKciPciE7symbols=allocate([32,32,32,32,32,32,32,32,32,32,38,37,43,35,83,68,90,65,76,33,32,64,63,74,78,75,86,63,84,88,63,87] /*           &%+#SDZAL! */, "i8", ALLOC_STATIC);
__ZZ10DecodeRulePKciPciE10symbols_lg=allocate([65,66,67,72,70,71,89] /* ABCHFGY */, "i8", ALLOC_STATIC);
__str60=allocate([32,40,0] /*  (\00 */, "i8", ALLOC_STATIC);
__str61=allocate([101,105,112,118,100,102,113,32,116,98,97,32,0] /* eipvdfq tba \00 */, "i8", ALLOC_STATIC);
__str62=allocate([37,99,37,100,0] /* %c%d\00 */, "i8", ALLOC_STATIC);
__str64=allocate([37,53,100,58,9,0] /* %5d:\09\00 */, "i8", ALLOC_STATIC);
__str65=allocate([63,37,100,32,0] /* ?%d \00 */, "i8", ALLOC_STATIC);
__ZL11error_count=allocate(1, "i32", ALLOC_STATIC);
__ZL21error_need_dictionary=allocate(1, "i32", ALLOC_STATIC);
__ZL19letterGroupsDefined=allocate(26, "i8", ALLOC_STATIC);
__ZL10debug_flag=allocate(1, "i32", ALLOC_STATIC);
__str66=allocate([37,115,37,115,95,0] /* %s%s_\00 */, "i8", ALLOC_STATIC);
__str67=allocate([37,115,114,117,108,101,115,46,116,120,116,0] /* %srules.txt\00 */, "i8", ALLOC_STATIC);
__str69=allocate([37,115,114,117,108,101,115,0] /* %srules\00 */, "i8", ALLOC_STATIC);
__str71=allocate([119,98,43,0] /* wb+\00 */, "i8", ALLOC_STATIC);
__str72=allocate([37,115,37,99,116,101,109,112,0] /* %s%ctemp\00 */, "i8", ALLOC_STATIC);
__str73=allocate([85,115,105,110,103,32,112,104,111,110,101,109,101,116,97,98,108,101,58,32,39,37,115,39,10,0] /* Using phonemetable:  */, "i8", ALLOC_STATIC);
__str74=allocate([114,111,111,116,115,0] /* roots\00 */, "i8", ALLOC_STATIC);
__str75=allocate([108,105,115,116,0] /* list\00 */, "i8", ALLOC_STATIC);
__str76=allocate([108,105,115,116,120,0] /* listx\00 */, "i8", ALLOC_STATIC);
__str77=allocate([101,120,116,114,97,0] /* extra\00 */, "i8", ALLOC_STATIC);
__str78=allocate([67,111,109,112,105,108,105,110,103,58,32,39,37,115,39,10,0] /* Compiling: '%s'\0A\0 */, "i8", ALLOC_STATIC);
__ZL7linenum=allocate(1, "i32", ALLOC_STATIC);
__ZL10group_name=allocate(13, "i8", ALLOC_STATIC);
__str79=allocate([119,98,0] /* wb\00 */, "i8", ALLOC_STATIC);
__ZL9group3_ix=allocate(1, "i32", ALLOC_STATIC);
__str81=allocate([46,76,0] /* .L\00 */, "i8", ALLOC_STATIC);
__str82=allocate([46,114,101,112,108,97,99,101,0] /* .replace\00 */, "i8", ALLOC_STATIC);
__str83=allocate([46,103,114,111,117,112,0] /* .group\00 */, "i8", ALLOC_STATIC);
__str84=allocate([48,120,37,120,0] /* 0x%x\00 */, "i8", ALLOC_STATIC);
__str85=allocate([37,53,100,58,32,71,114,111,117,112,32,110,97,109,101,32,108,111,110,103,101,114,32,116,104,97,110,32,50,32,98,121,116,101,115,32,40,85,84,70,56,41,0] /* %5d: Group name long */, "i8", ALLOC_STATIC);
__str89=allocate([9,37,100,32,114,117,108,101,115,44,32,37,100,32,103,114,111,117,112,115,32,40,37,100,41,10,10,0] /* \09%d rules, %d grou */, "i8", ALLOC_STATIC);
__ZL9rule_cond=allocate(80, "i8", ALLOC_STATIC);
__ZL8rule_pre=allocate(80, "i8", ALLOC_STATIC);
__ZL9rule_post=allocate(80, "i8", ALLOC_STATIC);
__ZL10rule_match=allocate(80, "i8", ALLOC_STATIC);
__ZL13rule_phonemes=allocate(80, "i8", ALLOC_STATIC);
__str90=allocate([37,53,100,58,32,83,121,110,116,97,120,32,101,114,114,111,114,46,32,83,112,97,99,101,32,97,102,116,101,114,32,40,10,0] /* %5d: Syntax error. S */, "i8", ALLOC_STATIC);
__str91=allocate([36,103,114,111,117,112,0] /* $group\00 */, "i8", ALLOC_STATIC);
__str92=allocate([37,53,100,58,32,83,121,110,116,97,120,32,101,114,114,111,114,10,0] /* %5d: Syntax error\0A */, "i8", ALLOC_STATIC);
__str93=allocate([37,53,100,58,32,66,97,100,32,112,104,111,110,101,109,101,32,91,37,99,93,32,105,110,32,37,115,10,0] /* %5d: Bad phoneme [%c */, "i8", ALLOC_STATIC);
__str94=allocate([37,53,100,58,32,87,114,111,110,103,32,105,110,105,116,105,97,108,32,108,101,116,116,101,114,115,32,39,37,115,39,32,102,111,114,32,103,114,111,117,112,32,39,37,115,39,10,0] /* %5d: Wrong initial l */, "i8", ALLOC_STATIC);
__str95=allocate([37,53,100,58,32,98,97,100,32,99,111,110,100,105,116,105,111,110,32,110,117,109,98,101,114,32,63,37,100,10,0] /* %5d: bad condition n */, "i8", ALLOC_STATIC);
__ZZL16copy_rule_stringPcRiE6outbuf=allocate(20, "i8*", ALLOC_STATIC);
__ZZL16copy_rule_stringPcRiE10next_state=allocate([2, 0, 0, 0, 2, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0, 4, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL16copy_rule_stringPcRiE16lettergp_letters=allocate([0,1,2,0,0,4,5,3,6] /* \00\01\02\00\00\04\0 */, "i8", ALLOC_STATIC);
__str97=allocate([37,53,100,58,32,69,120,112,101,99,116,101,100,32,50,32,100,105,103,105,116,115,32,97,102,116,101,114,32,39,76,39,10,0] /* %5d: Expected 2 digi */, "i8", ALLOC_STATIC);
__str98=allocate([37,53,100,58,32,76,101,116,116,101,114,32,103,114,111,117,112,32,76,37,46,50,100,32,110,111,116,32,100,101,102,105,110,101,100,10,0] /* %5d: Letter group L% */, "i8", ALLOC_STATIC);
__str99=allocate([37,53,100,58,32,36,32,99,111,109,109,97,110,100,32,110,111,116,32,114,101,99,111,103,110,105,122,101,100,10,0] /* %5d: $ command not r */, "i8", ALLOC_STATIC);
__str100=allocate([37,53,100,58,32,69,120,112,101,99,116,101,100,32,50,32,100,105,103,105,116,115,32,97,102,116,101,114,32,39,46,76,39,10,0] /* %5d: Expected 2 digi */, "i8", ALLOC_STATIC);
__str101=allocate([37,53,100,58,32,108,101,116,116,101,114,103,114,111,117,112,32,111,117,116,32,111,102,32,114,97,110,103,101,32,40,48,49,45,37,46,50,100,41,10,0] /* %5d: lettergroup out */, "i8", ALLOC_STATIC);
__str102=allocate([37,53,100,58,32,108,101,116,116,101,114,103,114,111,117,112,32,76,37,46,50,100,32,105,115,32,97,108,114,101,97,100,121,32,100,101,102,105,110,101,100,10,0] /* %5d: lettergroup L%. */, "i8", ALLOC_STATIC);
__str103=allocate([57,0] /* 9\00 */, "i8", ALLOC_STATIC);
__ZL11hash_chains=allocate(4096, "i8*", ALLOC_STATIC);
__ZL11hash_counts=allocate(4096, "i32", ALLOC_STATIC);
__ZL9text_mode_b=allocate(1, "i1", ALLOC_STATIC);
__str104=allocate([37,115,37,115,46,116,120,116,0] /* %s%s.txt\00 */, "i8", ALLOC_STATIC);
__str106=allocate([67,97,110,39,116,32,97,108,108,111,99,97,116,101,32,109,101,109,111,114,121,10,0] /* Can't allocate memor */, "i8", ALLOC_STATIC);
__str107=allocate([9,37,100,32,101,110,116,114,105,101,115,10,0] /* \09%d entries\0A\00 */, "i8", ALLOC_STATIC);
__ZZL12compile_linePcS_PiE10nullstring=allocate(1, "i8", ALLOC_STATIC);
__str108=allocate([95,45,0] /* _-\00 */, "i8", ALLOC_STATIC);
__str109=allocate([37,53,100,58,32,85,110,107,110,111,119,110,32,107,101,121,119,111,114,100,58,32,37,115,10,0] /* %5d: Unknown keyword */, "i8", ALLOC_STATIC);
__str110=allocate([32,0] /*  \00 */, "i8", ALLOC_STATIC);
__str111=allocate([37,53,100,58,32,78,101,101,100,32,116,111,32,99,111,109,112,105,108,101,32,100,105,99,116,105,111,110,97,114,121,32,97,103,97,105,110,10,0] /* %5d: Need to compile */, "i8", ALLOC_STATIC);
__str112=allocate([37,53,100,58,32,66,97,100,32,112,104,111,110,101,109,101,32,91,37,99,93,32,40,48,120,37,120,41,32,105,110,58,32,37,115,32,32,37,115,10,0] /* %5d: Bad phoneme [%c */, "i8", ALLOC_STATIC);
__str113=allocate([85,43,37,120,0] /* U+%x\00 */, "i8", ALLOC_STATIC);
__str114=allocate([37,53,100,58,32,84,119,111,32,109,97,110,121,32,112,97,114,116,115,32,105,110,32,97,32,109,117,108,116,105,45,119,111,114,100,32,101,110,116,114,121,58,32,37,100,10,0] /* %5d: Two many parts  */, "i8", ALLOC_STATIC);
__str115=allocate([67,97,110,39,116,32,97,99,99,101,115,115,32,40,37,115,41,32,102,105,108,101,32,39,37,115,39,10,0] /* Can't access (%s) fi */, "i8", ALLOC_STATIC);
_dictionary_skipwords=allocate(1, "i32", ALLOC_STATIC);
_dictionary_name=allocate(40, "i8", ALLOC_STATIC);
__ZL13remove_accent=allocate([97,97,97,97,97,97,97,99,101,101,101,101,105,105,105,105,100,110,111,111,111,111,111,0,111,117,117,117,117,121,116,115,97,97,97,97,97,97,97,99,101,101,101,101,105,105,105,105,100,110,111,111,111,111,111,0,111,117,117,117,117,121,116,121,97,97,97,97,97,97,99,99,99,99,99,99,99,99,100,100,100,100,101,101,101,101,101,101,101,101,101,101,103,103,103,103,103,103,103,103,104,104,104,104,105,105,105,105,105,105,105,105,105,105,105,105,106,106,107,107,107,108,108,108,108,108,108,108,108,108,108,110,110,110,110,110,110,110,110,110,111,111,111,111,111,111,111,111,114,114,114,114,114,114,115,115,115,115,115,115,115,115,116,116,116,116,116,116,117,117,117,117,117,117,117,117,117,117,117,117,119,119,121,121,121,122,122,122,122,122,122,115,98,98,98,98,0,0,111,99,99,100,100,100,100,100,101,101,101,102,102,103,103,104,105,105,107,107,108,108,109,110,110,111,111,111,111,111,112,112,121,0,0,115,115,116,116,116,116,117,117,117,118,121,121,122,122,122,122,122,122,122,0,0,0,119,116,116,116,107,100,100,100,108,108,108,110,110,110,97,97,105,105,111,111,117,117,117,117,117,117,117,117,117,117,101,97,97,97,97,97,97,103,103,103,103,107,107,111,111,111,111,122,122,106,100,100,100,103,103,119,119,110,110,97,97,97,97,111,111,97,97,97,97,101,101,101,101,105,105,105,105,111,111,111,111,114,114,114,114,117,117,117,117,115,115,116,116,121,121,104,104,110,100,111,111,122,122,97,97,101,101,111,111,111,111,111,111,111,111,121,121,108,110,116,106,100,113,97,99,99,108,116,115,122,0,0,98,117,118,101,101,106,106,113,113,114,114,121,121,97,97,97,98,111,99,100,100,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] /* aaaaaaaceeeeiiiidnoo */, "i8", ALLOC_STATIC);
__str116=allocate([37,115,37,99,37,115,95,100,105,99,116,0] /* %s%c%s_dict\00 */, "i8", ALLOC_STATIC);
__str2118=allocate([67,97,110,39,116,32,114,101,97,100,32,100,105,99,116,105,111,110,97,114,121,32,102,105,108,101,58,32,39,37,115,39,10,0] /* Can't read dictionar */, "i8", ALLOC_STATIC);
__str3119=allocate([69,109,112,116,121,32,95,100,105,99,116,32,102,105,108,101,58,32,39,37,115,10,0] /* Empty _dict file: '% */, "i8", ALLOC_STATIC);
__str4120=allocate([66,97,100,32,100,97,116,97,58,32,39,37,115,39,32,40,37,120,32,108,101,110,103,116,104,61,37,120,41,10,0] /* Bad data: '%s' (%x l */, "i8", ALLOC_STATIC);
__str5121=allocate([69,114,114,111,114,32,105,110,32,37,115,95,114,117,108,101,115,44,32,110,111,32,100,101,102,97,117,108,116,32,114,117,108,101,32,103,114,111,117,112,10,0] /* Error in %s_rules, n */, "i8", ALLOC_STATIC);
__str7123=allocate([61,61,44,44,39,42,32,32,0] /* ==,,'_  \00 */, "i8", ALLOC_STATIC);
_ipa1=allocate([32, 0, 33, 0, 34, 0, 688, 0, 36, 0, 37, 0, 230, 0, 712, 0, 40, 0, 638, 0, 42, 0, 43, 0, 716, 0, 45, 0, 46, 0, 47, 0, 594, 0, 49, 0, 50, 0, 604, 0, 52, 0, 53, 0, 54, 0, 55, 0, 629, 0, 57, 0, 720, 0, 690, 0, 60, 0, 61, 0, 62, 0, 660, 0, 601, 0, 593, 0, 946, 0, 231, 0, 240, 0, 603, 0, 70, 0, 610, 0, 295, 0, 618, 0, 607, 0, 75, 0, 76, 0, 625, 0, 331, 0, 596, 0, 934, 0, 611, 0, 640, 0, 643, 0, 952, 0, 650, 0, 652, 0, 339, 0, 967, 0, 248, 0, 658, 0, 810, 0, 92, 0, 93, 0, 94, 0, 95, 0, 96, 0, 97, 0, 98, 0, 99, 0, 100, 0, 101, 0, 102, 0, 609, 0, 104, 0, 105, 0, 106, 0, 107, 0, 108, 0, 109, 0, 110, 0, 111, 0, 112, 0, 113, 0, 114, 0, 115, 0, 116, 0, 117, 0, 118, 0, 119, 0, 120, 0, 121, 0, 122, 0, 123, 0, 124, 0, 125, 0, 771, 0, 127, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str8124=allocate([61,61,44,44,39,39,0] /* ==,,''\00 */, "i8", ALLOC_STATIC);
__str9125=allocate([40,37,115,41,0] /* (%s)\00 */, "i8", ALLOC_STATIC);
__ZL15stress_phonemes=allocate([3,2,4,5,6,7,26] /* \03\02\04\05\06\07\1 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE15consonant_types=allocate([0,0,0,1,1,1,1,1,1,1,0,0,0,0,0,0] /* \00\00\00\01\01\01\0 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE8guess_ru=allocate([0,0,1,1,2,3,3,4,5,6,7,7,8,9,10,11] /* \00\00\01\01\02\03\0 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_v=allocate([0,0,1,1,2,2,3,3,4,5,6,7,7,8,9,10] /* \00\00\01\01\02\02\0 */, "i8", ALLOC_STATIC);
__ZZ13SetWordStressP10TranslatorPcPjiiE10guess_ru_t=allocate([0,0,1,2,3,3,3,4,5,6,7,7,7,8,9,10] /* \00\00\01\02\03\03\0 */, "i8", ALLOC_STATIC);
__ZZ14TranslateRulesP10TranslatorPcS1_iS1_iPjE9str_pause=allocate([11,0] /* \0B\00 */, "i8", ALLOC_STATIC);
__str10126=allocate([85,110,112,114,111,110,111,117,110,99,97,98,108,101,63,32,39,37,115,39,10,0] /* Unpronouncable? '%s' */, "i8", ALLOC_STATIC);
__str11127=allocate([84,114,97,110,115,108,97,116,101,32,39,37,115,39,10,0] /* Translate '%s'\0A\00 */, "i8", ALLOC_STATIC);
__ZL13diereses_list=allocate([228, 0, 235, 0, 239, 0, 246, 0, 252, 0, 255, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TABE16word_replacement=allocate(160, "i8", ALLOC_STATIC);
__str15131=allocate([37,115,32,0] /* %s \00 */, "i8", ALLOC_STATIC);
__str16132=allocate([82,101,112,108,97,99,101,58,32,37,115,32,32,37,115,10,0] /* Replace: %s  %s\0A\0 */, "i8", ALLOC_STATIC);
__ZZ11LookupFlagsP10TranslatorPKcE5flags=allocate(8, "i32", ALLOC_STATIC);
__ZZ12RemoveEndingP10TranslatorPciS1_E6ending=allocate(12, "i8", ALLOC_STATIC);
__ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions=allocate(8, "i8*", ALLOC_STATIC);
__str17133=allocate([105,111,110,0] /* ion\00 */, "i8", ALLOC_STATIC);
__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions=allocate(32, "i8*", ALLOC_STATIC);
__str18134=allocate([99,0] /* c\00 */, "i8", ALLOC_STATIC);
__str19135=allocate([114,115,0] /* rs\00 */, "i8", ALLOC_STATIC);
__str20136=allocate([105,114,0] /* ir\00 */, "i8", ALLOC_STATIC);
__str21137=allocate([117,114,0] /* ur\00 */, "i8", ALLOC_STATIC);
__str22138=allocate([97,116,104,0] /* ath\00 */, "i8", ALLOC_STATIC);
__str23139=allocate([110,115,0] /* ns\00 */, "i8", ALLOC_STATIC);
__str24140=allocate([117,0] /* u\00 */, "i8", ALLOC_STATIC);
__str25141=allocate([97,100,100,32,101,10,0] /* add e\0A\00 */, "i8", ALLOC_STATIC);
__str27143=allocate([101,115,0] /* es\00 */, "i8", ALLOC_STATIC);
__str28144=allocate([70,108,97,103,115,58,32,32,37,115,32,32,37,115,10,0] /* Flags:  %s  %s\0A\00 */, "i8", ALLOC_STATIC);
__str29145=allocate([70,111,117,110,100,58,32,39,37,115,32,37,115,0] /* Found: '%s %s\00 */, "i8", ALLOC_STATIC);
__str30146=allocate([70,111,117,110,100,58,32,39,37,115,0] /* Found: '%s\00 */, "i8", ALLOC_STATIC);
__str31147=allocate([39,32,91,37,115,93,32,32,37,115,10,0] /* ' [%s]  %s\0A\00 */, "i8", ALLOC_STATIC);
__ZZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordiiE4best=allocate(16, ["i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__str32148=allocate([37,51,100,9,37,115,32,91,37,115,93,10,0] /* %3d\09%s [%s]\0A\00 */, "i8", ALLOC_STATIC);
__str34150=allocate([66,97,100,32,114,117,108,101,115,32,100,97,116,97,32,105,110,32,39,37,115,95,100,105,99,116,39,32,97,116,32,48,120,37,120,10,0] /* Bad rules data in '% */, "i8", ALLOC_STATIC);
_env_fall=allocate([255,253,250,248,246,244,242,240,238,236,234,232,230,228,226,224,222,220,218,216,214,212,210,208,206,204,202,200,198,196,194,192,190,188,186,184,182,180,178,176,174,172,170,168,166,164,162,160,158,156,154,152,150,148,146,144,142,140,138,136,134,132,130,128,126,124,122,120,118,116,114,112,110,108,106,104,102,100,98,96,94,92,90,88,86,84,82,80,78,76,74,72,70,68,66,64,62,60,58,56,54,52,50,48,46,44,42,40,38,36,34,32,30,28,26,24,22,20,18,16,14,12,10,8,6,4,2,0] /* \FF\FD\FA\F8\F6\F4\F */, "i8", ALLOC_STATIC);
_env_rise=allocate([0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,206,208,210,212,214,216,218,220,222,224,226,228,230,232,234,236,238,240,242,244,246,248,250,253,255] /* \00\02\04\06\08\0A\0 */, "i8", ALLOC_STATIC);
_env_frise=allocate([255,244,234,224,214,204,195,186,177,168,159,151,143,135,127,120,113,106,99,92,86,80,74,68,63,57,52,47,43,38,34,30,26,23,19,16,13,11,8,6,4,2,1,0,0,0,0,0,0,0,1,2,3,4,5,7,8,10,12,14,16,19,21,23,26,29,31,34,37,40,44,46,48,50,52,54,57,59,61,64,66,69,71,74,76,79,81,84,87,90,93,95,98,101,104,107,110,113,116,120,123,126,129,133,136,139,143,146,150,153,157,160,164,168,172,175,179,183,187,191,195,199,203,207,211,215,219,224] /* \FF\F4\EA\E0\D6\CC\C */, "i8", ALLOC_STATIC);
__ZL11env_r_frise=allocate([207,204,201,198,195,192,189,185,180,176,171,167,162,156,151,146,140,134,129,123,117,111,105,99,93,87,80,74,68,62,56,51,45,39,34,28,23,18,13,8,4,2,2,1,0,0,0,0,0,1,1,2,3,4,5,7,8,10,12,13,15,18,20,22,25,27,30,33,36,39,42,45,48,52,54,56,58,60,63,65,67,70,72,75,77,80,82,85,88,90,93,96,99,102,105,108,111,114,117,120,123,126,129,133,136,139,143,146,150,153,157,160,164,168,172,175,179,183,187,191,195,199,203,207,211,215,219,224] /* \CF\CC\C9\C6\C3\C0\B */, "i8", ALLOC_STATIC);
__ZL10env_frise2=allocate([255,249,244,238,233,228,223,218,213,208,203,198,193,189,184,179,175,170,166,161,157,153,149,144,140,136,132,128,125,121,117,113,110,106,103,99,96,93,89,86,83,80,77,74,71,68,65,62,60,57,55,52,50,47,45,43,40,38,36,34,32,30,28,26,25,23,21,20,18,17,15,14,13,12,10,9,8,7,6,5,5,4,3,2,2,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,2,2,3,4,4,5,6,7,8,9,10,11,12,14,15,16,18,19,21,23,24,26,28,30,32] /* \FF\F9\F4\EE\E9\E4\D */, "i8", ALLOC_STATIC);
__ZL12env_r_frise2=allocate([208,206,205,204,202,200,199,197,195,193,192,189,187,184,181,179,176,173,170,167,163,160,157,153,150,146,143,139,135,132,128,124,120,116,112,109,105,101,97,93,89,85,81,77,74,70,66,62,59,55,52,49,47,45,42,40,38,36,34,32,30,28,26,25,23,21,20,18,17,15,14,13,12,10,9,8,7,6,5,5,4,3,2,2,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,2,2,3,4,4,5,6,7,8,9,10,11,12,14,15,16,18,19,21,23,24,26,28,30,32] /* \D0\CE\CD\CC\CA\C8\C */, "i8", ALLOC_STATIC);
__ZL12env_risefall=allocate([152,153,153,154,156,157,159,161,164,167,169,172,176,179,182,186,190,193,197,201,205,209,212,216,220,223,227,230,234,237,240,242,245,247,249,251,252,253,254,254,255,255,255,255,255,255,254,253,251,250,248,246,243,241,238,236,233,230,228,224,221,218,215,211,208,204,200,196,192,188,184,180,176,172,167,163,159,154,150,145,141,136,132,127,123,118,114,109,105,101,96,92,88,84,80,76,72,68,64,60,57,53,50,47,43,40,38,35,32,29,26,23,21,18,15,13,10,8,7,5,3,2,1,0,0,0,0,0] /* \98\99\99\9A\9C\9D\9 */, "i8", ALLOC_STATIC);
__ZL13env_fallrise3=allocate([254,255,255,255,255,255,254,253,252,250,248,246,244,241,238,235,232,229,225,222,218,214,210,205,201,196,191,186,182,176,171,166,161,156,150,145,139,134,128,123,117,111,106,100,95,89,84,79,73,68,63,58,53,48,43,38,34,29,25,21,17,13,10,7,4,3,1,0,0,0,0,0,0,0,0,1,1,2,4,5,7,9,11,13,16,18,21,24,27,30,34,37,41,45,49,53,58,62,67,72,76,81,87,91,94,98,101,104,107,110,113,116,118,120,123,124,126,128,129,130,131,131,132,132,131,131,130,129] /* \FE\FF\FF\FF\FF\FF\F */, "i8", ALLOC_STATIC);
__ZL13env_fallrise4=allocate([114,114,113,113,112,111,109,108,106,104,102,100,97,95,92,90,87,84,81,78,75,72,69,66,63,59,56,53,50,47,44,41,38,35,32,29,27,24,22,20,18,16,14,12,11,10,9,8,7,7,7,7,7,6,5,5,5,5,5,5,5,5,5,6,7,7,8,9,10,12,13,15,16,18,20,22,24,27,29,32,35,38,41,44,47,51,55,59,63,67,71,76,81,86,91,96,101,106,111,116,121,127,132,137,143,149,155,161,167,173,179,186,192,199,206,213,220,227,234,241,245,247,250,252,253,254,255,255] /* rrqqpomljhfda_\5CZWT */, "i8", ALLOC_STATIC);
__ZL9env_fall2=allocate([254,254,253,253,252,251,251,250,250,249,248,248,247,247,246,246,245,244,244,243,243,242,242,241,240,240,239,238,238,237,236,235,234,234,233,232,231,230,229,228,227,226,225,224,222,221,220,219,217,216,214,213,211,210,208,206,204,203,201,199,197,195,192,190,188,185,183,181,178,175,173,170,167,164,161,158,154,151,148,144,141,137,133,129,125,121,117,113,109,104,100,97,94,91,87,84,81,77,74,70,67,64,60,57,53,50,46,42,39,35,31,28,24,20,17,13,11,9,7,5,4,3,2,1,0,0,0,0] /* \FE\FE\FD\FD\FC\FB\F */, "i8", ALLOC_STATIC);
__ZL9env_rise2=allocate([0,0,0,0,1,1,1,2,2,3,3,4,4,5,6,6,7,8,8,9,10,11,12,12,13,14,15,16,17,18,19,20,22,23,24,25,27,28,29,31,32,34,35,37,38,40,41,43,45,47,48,50,52,54,56,58,60,62,64,66,68,71,73,75,78,80,82,85,87,90,93,95,98,101,103,106,109,112,115,118,121,124,127,130,134,137,140,144,147,150,154,157,160,163,166,169,172,175,178,181,184,187,190,193,196,199,202,205,208,211,214,217,220,223,226,228,231,233,236,238,240,242,244,246,248,250,251,253] /* \00\00\00\00\01\01\0 */, "i8", ALLOC_STATIC);
__ZL16env_risefallrise=allocate([127,127,127,128,129,131,132,135,137,140,143,146,150,153,157,161,165,170,174,178,183,187,192,197,201,205,210,214,218,222,226,230,234,237,240,243,245,248,250,251,252,253,254,254,253,252,251,249,247,244,240,236,231,226,220,213,206,198,189,180,169,158,146,136,130,125,119,114,108,102,96,90,84,78,73,66,60,55,50,45,40,36,31,27,24,20,17,14,12,9,7,6,5,4,4,4,4,5,6,8,10,13,16,20,24,29,35,41,47,55,62,71,80,90,100,112,124,131,133,136,138,140,142,143,145,146,147,147] /* \7F\7F\7F\80\81\83\8 */, "i8", ALLOC_STATIC);
_envelope_data=allocate(80, "i8*", ALLOC_STATIC);
__ZL18tone_nucleus_table=allocate([0, 64, 8, 0, 70, 18, 0, 0, 0, 0, 0, 0, 24, 12, 0, undef, 4, 80, 18, 6, 78, 22, 0, 0, 0, 0, 0, 0, 34, 52, 0, undef, 4, 88, 22, 6, 82, 22, 0, 0, 0, 0, 0, 0, 34, 64, 0, undef, 0, 92, 8, 0, 92, 80, 0, 0, 0, 0, 0, 0, 76, 8, 1, undef, 0, 86, 4, 0, 94, 66, 0, 0, 0, 0, 0, 0, 34, 10, 0, undef, 0, 62, 10, 0, 62, 20, 0, 0, 0, 0, 0, 0, 28, 16, 0, undef, 4, 68, 18, 6, 68, 22, 0, 0, 0, 0, 0, 0, 30, 44, 0, undef, 6, 64, 16, 0, 66, 32, 0, 0, 0, 0, 0, 0, 32, 18, 0, undef, 2, 68, 46, 0, 42, 32, 0, 0, 0, 0, 0, 0, 46, 58, 0, undef, 4, 78, 24, 6, 72, 22, 0, 0, 0, 0, 0, 0, 42, 52, 0, undef, 4, 88, 34, 0, 64, 32, 0, 0, 0, 0, 0, 0, 46, 82, 0, undef, 0, 56, 12, 0, 56, 20, 0, 0, 0, 0, 0, 0, 24, 12, 0, undef, 0, 70, 18, 0, 70, 24, 0, 0, 0, 0, 0, 0, 32, 20, 0, undef], ["i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i16*",0,0,0,"i8","i8","i8","i8"], ALLOC_STATIC);
_punctuation_to_tone=allocate([0, 1, 2, 3, 0, 4, 0, 1, 2, 3, 0, 4, 5, 6, 2, 3, 0, 4, 5, 7, 1, 3, 0, 4, 8, 9, 10, 3, 0, 0, 8, 8, 10, 3, 0, 0, 11, 11, 11, 11, 0, 0, 12, 12, 12, 12, 0, 0], "i8", ALLOC_STATIC);
_n_tunes=allocate(1, "i32", ALLOC_STATIC);
_tunes=allocate(1, "%struct.TUNE*", ALLOC_STATIC);
__ZL12syllable_tab=allocate(1, "%struct.SYLLABLE*", ALLOC_STATIC);
__ZL8no_tonic_b=allocate(1, "i1", ALLOC_STATIC);
__ZL15tone_head_table=allocate([46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 46, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 46, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 90, 50, 0, 0, 0, 0, 3, 9, 5, 0, 0, 0, 0, 0, 46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 74, 55, 0, 0, 0, 0, 4, 7, 5, 0, 0, 0, 0, 0, 46, 57, 74, 55, 0, 0, 0, 0, 4, 7, 5, 0, 0, 0, 0, 0, 46, 57, 74, 55, 0, 0, 0, 0, 4, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 46, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 78, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 34, 41, 41, 32, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0, 46, 57, 55, 50, 0, 0, 0, 0, 3, 7, 5, 0, 0, 0, 0, 0], ["i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0,"i8","i8","i8","i8","i32*",0,0,0,"i8","i8","i8",0,"i8*",0,0,0], ALLOC_STATIC);
__ZL10number_pre=allocate(1, "i32", ALLOC_STATIC);
__ZL10tone_posn2=allocate(1, "i32", ALLOC_STATIC);
__ZL9tone_posn=allocate(1, "i32", ALLOC_STATIC);
__ZL11number_tail=allocate(1, "i32", ALLOC_STATIC);
__ZL14tone_pitch_env=allocate(1, "i32", ALLOC_STATIC);
__ZZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSiiE12continue_tab=allocate([230,32,20,8,0] /* \E6 \14\08\00 */, "i8", ALLOC_STATIC);
__ZL8min_drop=allocate([6, 0, 0, 0, 7, 0, 0, 0, 9, 0, 0, 0, 9, 0, 0, 0, 20, 0, 0, 0, 20, 0, 0, 0, 20, 0, 0, 0, 25, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL7drops_0=allocate([9, 0, 0, 0, 9, 0, 0, 0, 16, 0, 0, 0, 16, 0, 0, 0, 16, 0, 0, 0, 23, 0, 0, 0, 55, 0, 0, 0, 32, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL5oflow=allocate([0,40,24,8,0] /* \00(\18\08\00 */, "i8", ALLOC_STATIC);
__ZL9oflow_emf=allocate([10,52,32,20,10] /* \0A4 \14\0A */, "i8", ALLOC_STATIC);
__ZL10oflow_less=allocate([6,38,24,14,4] /* \06&\18\0E\04 */, "i8", ALLOC_STATIC);
__ZL12last_primary=allocate(1, "i32", ALLOC_STATIC);
_namedata=allocate(1, "i8*", ALLOC_STATIC);
__ZL7f_input=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_p_textinput=allocate(1, "i8*", ALLOC_STATIC);
_p_wchar_input=allocate(1, "i32*", ALLOC_STATIC);
__ZL10ungot_word=allocate(1, "i8*", ALLOC_STATIC);
_count_characters=allocate(1, "i32", ALLOC_STATIC);
__ZL10ssml_stack=allocate(1520, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
__ZL16current_voice_id=allocate(40, "i8", ALLOC_STATIC);
_param_stack=allocate(1280, "i32", ALLOC_STATIC);
_param_defaults=allocate([0, 0, 0, 0, 175, 0, 0, 0, 100, 0, 0, 0, 50, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_walpha_tab=allocate([1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,254,255,1,255,1,255,1,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,1,255,1,255,1,255,255,255,210,1,255,1,255,206,1,255,205,205,1,255,255,79,202,203,1,255,205,207,255,211,209,1,255,255,255,211,213,255,214,1,255,1,255,1,255,218,1,255,218,255,255,1,255,218,1,255,217,217,1,255,1,255,219,1,255,255,255,1,255,255,255,255,255,255,255,2,1,255,2,1,255,2,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,2,1,255,1,255,255,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,255,0,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255,1,255] /* \01\FF\01\FF\01\FF\0 */, "i8", ALLOC_STATIC);
__ZL10ungot_char=allocate(1, "i32", ALLOC_STATIC);
__ZL12end_of_input_b=allocate(1, "i1", ALLOC_STATIC);
__str167=allocate([115,112,101,97,107,0] /* speak\00 */, "i8", ALLOC_STATIC);
__str1168=allocate([118,111,105,99,101,0] /* voice\00 */, "i8", ALLOC_STATIC);
__str2169=allocate([112,114,111,115,111,100,121,0] /* prosody\00 */, "i8", ALLOC_STATIC);
__str3170=allocate([115,97,121,45,97,115,0] /* say-as\00 */, "i8", ALLOC_STATIC);
__str4171=allocate([109,97,114,107,0] /* mark\00 */, "i8", ALLOC_STATIC);
__str5172=allocate([115,0] /* s\00 */, "i8", ALLOC_STATIC);
__str6173=allocate([112,0] /* p\00 */, "i8", ALLOC_STATIC);
__str7174=allocate([112,104,111,110,101,109,101,0] /* phoneme\00 */, "i8", ALLOC_STATIC);
__str8175=allocate([115,117,98,0] /* sub\00 */, "i8", ALLOC_STATIC);
__str9176=allocate([116,116,115,58,115,116,121,108,101,0] /* tts:style\00 */, "i8", ALLOC_STATIC);
__str10177=allocate([97,117,100,105,111,0] /* audio\00 */, "i8", ALLOC_STATIC);
__str11178=allocate([101,109,112,104,97,115,105,115,0] /* emphasis\00 */, "i8", ALLOC_STATIC);
__str12179=allocate([98,114,101,97,107,0] /* break\00 */, "i8", ALLOC_STATIC);
__str13180=allocate([109,101,116,97,100,97,116,97,0] /* metadata\00 */, "i8", ALLOC_STATIC);
__str14181=allocate([98,114,0] /* br\00 */, "i8", ALLOC_STATIC);
__str15182=allocate([108,105,0] /* li\00 */, "i8", ALLOC_STATIC);
__str16183=allocate([100,100,0] /* dd\00 */, "i8", ALLOC_STATIC);
__str17184=allocate([105,109,103,0] /* img\00 */, "i8", ALLOC_STATIC);
__str18185=allocate([116,100,0] /* td\00 */, "i8", ALLOC_STATIC);
__str19186=allocate([104,49,0] /* h1\00 */, "i8", ALLOC_STATIC);
__str20187=allocate([104,50,0] /* h2\00 */, "i8", ALLOC_STATIC);
__str21188=allocate([104,51,0] /* h3\00 */, "i8", ALLOC_STATIC);
__str22189=allocate([104,52,0] /* h4\00 */, "i8", ALLOC_STATIC);
__str23190=allocate([104,114,0] /* hr\00 */, "i8", ALLOC_STATIC);
__str24191=allocate([115,99,114,105,112,116,0] /* script\00 */, "i8", ALLOC_STATIC);
__str25192=allocate([115,116,121,108,101,0] /* style\00 */, "i8", ALLOC_STATIC);
__str26193=allocate([102,111,110,116,0] /* font\00 */, "i8", ALLOC_STATIC);
__str27194=allocate([98,0] /* b\00 */, "i8", ALLOC_STATIC);
__str28195=allocate([105,0] /* i\00 */, "i8", ALLOC_STATIC);
__str29196=allocate([115,116,114,111,110,103,0] /* strong\00 */, "i8", ALLOC_STATIC);
__str30197=allocate([101,109,0] /* em\00 */, "i8", ALLOC_STATIC);
__str31198=allocate([99,111,100,101,0] /* code\00 */, "i8", ALLOC_STATIC);
__ZL8ssmltags=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL10n_namedata=allocate(1, "i32", ALLOC_STATIC);
__ZL11namedata_ix=allocate(1, "i32", ALLOC_STATIC);
__str32199=allocate([103,116,0] /* gt\00 */, "i8", ALLOC_STATIC);
__str33200=allocate([108,116,0] /* lt\00 */, "i8", ALLOC_STATIC);
__str34201=allocate([97,109,112,0] /* amp\00 */, "i8", ALLOC_STATIC);
__str35202=allocate([113,117,111,116,0] /* quot\00 */, "i8", ALLOC_STATIC);
__str36203=allocate([110,98,115,112,0] /* nbsp\00 */, "i8", ALLOC_STATIC);
__str37204=allocate([97,112,111,115,0] /* apos\00 */, "i8", ALLOC_STATIC);
__ZL18xml_char_mnemonics=allocate([0, 0, 0, 0, 62, 0, 0, 0, 0, 0, 0, 0, 57404, 0, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 39, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E12ungot_string=allocate(24, "i8", ALLOC_STATIC);
__ZZ10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_E15ungot_string_ix=allocate([-1], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL19clear_skipping_text_b=allocate(1, "i1", ALLOC_STATIC);
__ZL11ungot_char2=allocate(1, "i32", ALLOC_STATIC);
__ZL19ssml_ignore_l_angle=allocate(1, "i32", ALLOC_STATIC);
__str38205=allocate([37,115,37,99,37,99,0] /* %s%c%c\00 */, "i8", ALLOC_STATIC);
__ZL10sayas_mode=allocate(1, "i32", ALLOC_STATIC);
__ZL11ignore_text_b=allocate(1, "i1", ALLOC_STATIC);
__ZL11punct_chars=allocate([44, 0, 46, 0, 63, 0, 33, 0, 58, 0, 59, 0, 8211, 0, 8212, 0, 8230, 0, 894, 0, 903, 0, 2404, 0, 1417, 0, 1373, 0, 1372, 0, 1374, 0, 1371, 0, 2843, 0, 1567, 0, 4962, 0, 4963, 0, 4964, 0, 4965, 0, 4966, 0, 4967, 0, 4968, 0, 4347, 0, 12289, 0, 12290, 0, -255, 0, -244, 0, -242, 0, -230, 0, -229, 0, -225, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL16punct_attributes=allocate([0, 0, 0, 0, 266260, 0, 0, 0, 524328, 0, 0, 0, 532520, 0, 0, 0, 536621, 0, 0, 0, 262174, 0, 0, 0, 266270, 0, 0, 0, 266270, 0, 0, 0, 266270, 0, 0, 0, 2396190, 0, 0, 0, 532520, 0, 0, 0, 266270, 0, 0, 0, 557096, 0, 0, 0, 557096, 0, 0, 0, 266260, 0, 0, 0, 1585197, 0, 0, 0, 1581096, 0, 0, 0, 1572904, 0, 0, 0, 266270, 0, 0, 0, 532520, 0, 0, 0, 524328, 0, 0, 0, 266260, 0, 0, 0, 266270, 0, 0, 0, 262174, 0, 0, 0, 262174, 0, 0, 0, 532520, 0, 0, 0, 524358, 0, 0, 0, 524358, 0, 0, 0, 299028, 0, 0, 0, 557096, 0, 0, 0, 569389, 0, 0, 0, 299028, 0, 0, 0, 557096, 0, 0, 0, 294942, 0, 0, 0, 299038, 0, 0, 0, 565288, 0, 0, 0, 266270, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str41208=allocate([32,32,32,0] /*    \00 */, "i8", ALLOC_STATIC);
__ZL12chars_ignore=allocate([8204, 0, 8205, 0, 0, 0], ["i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str42209=allocate([105,32,0] /* i \00 */, "i8", ALLOC_STATIC);
__ZL10audio_text_b=allocate(1, "i1", ALLOC_STATIC);
__ZL17speech_parameters=allocate(60, "i32", ALLOC_STATIC);
__ZL12n_ssml_stack=allocate(1, "i32", ALLOC_STATIC);
__ZL13n_param_stack=allocate(1, "i32", ALLOC_STATIC);
__ZL7xmlbase=allocate(1, "i8*", ALLOC_STATIC);
__ZZL14LookupCharNameP10TranslatoriiE3buf=allocate(60, "i8", ALLOC_STATIC);
__str47214=allocate([91,2,95,94,95,37,115,32,37,115,32,95,94,95,37,115,93,93,0] /* [\02_^_%s %s _^_%s]] */, "i8", ALLOC_STATIC);
__str48215=allocate([91,2,37,115,93,93,32,0] /* [\02%s]] \00 */, "i8", ALLOC_STATIC);
__str49216=allocate([91,2,40,88,49,41,40,88,49,41,40,88,49,41,93,93,0] /* [\02(X1)(X1)(X1)]]\0 */, "i8", ALLOC_STATIC);
__ZZL13WordToString2jE3buf=allocate(5, "i8", ALLOC_STATIC);
__str50217=allocate([1,37,100,73,32,0] /* \01%dI \00 */, "i8", ALLOC_STATIC);
__str51218=allocate([32,37,115,0] /*  %s\00 */, "i8", ALLOC_STATIC);
__str52219=allocate([1,43,49,48,83,0] /* \01+10S\00 */, "i8", ALLOC_STATIC);
__str53220=allocate([32,1,45,49,48,83,0] /*  \01-10S\00 */, "i8", ALLOC_STATIC);
__str54221=allocate([32,37,115,32,37,100,32,37,115,0] /*  %s %d %s\00 */, "i8", ALLOC_STATIC);
__str55222=allocate([37,115,37,99,115,111,117,110,100,105,99,111,110,115,37,99,37,115,0] /* %s%csoundicons%c%s\0 */, "i8", ALLOC_STATIC);
__str57224=allocate([112,111,108,121,112,104,97,115,101,0] /* polyphase\00 */, "i8", ALLOC_STATIC);
__str58225=allocate([47,116,109,112,47,101,115,112,101,97,107,88,88,88,88,88,88,0] /* /tmp/espeakXXXXXX\00 */, "i8", ALLOC_STATIC);
__str59226=allocate([115,111,120,32,34,37,115,34,32,45,114,32,37,100,32,45,119,32,45,115,32,45,99,49,32,37,115,32,37,115,10,0] /* sox \22%s\22 -r %d - */, "i8", ALLOC_STATIC);
__str60227=allocate([91,2,37,115,93,93,0] /* [\02%s]]\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str61228=allocate([110,111,110,101,0] /* none\00 */, "i8", ALLOC_STATIC);
__str62229=allocate([97,108,108,0] /* all\00 */, "i8", ALLOC_STATIC);
__str63230=allocate([115,111,109,101,0] /* some\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str64231=allocate([110,111,0] /* no\00 */, "i8", ALLOC_STATIC);
__str65232=allocate([115,112,101,108,108,105,110,103,0] /* spelling\00 */, "i8", ALLOC_STATIC);
__str66233=allocate([105,99,111,110,0] /* icon\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as=allocate([0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 36, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0, 0, 0, 0, 0, 193, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str68235=allocate([99,104,97,114,97,99,116,101,114,115,0] /* characters\00 */, "i8", ALLOC_STATIC);
__str69236=allocate([116,116,115,58,99,104,97,114,0] /* tts:char\00 */, "i8", ALLOC_STATIC);
__str70237=allocate([116,116,115,58,107,101,121,0] /* tts:key\00 */, "i8", ALLOC_STATIC);
__str71238=allocate([116,116,115,58,100,105,103,105,116,115,0] /* tts:digits\00 */, "i8", ALLOC_STATIC);
__str72239=allocate([116,101,108,101,112,104,111,110,101,0] /* telephone\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str73240=allocate([103,108,121,112,104,115,0] /* glyphs\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str74241=allocate([120,45,119,101,97,107,0] /* x-weak\00 */, "i8", ALLOC_STATIC);
__str75242=allocate([119,101,97,107,0] /* weak\00 */, "i8", ALLOC_STATIC);
__str76243=allocate([109,101,100,105,117,109,0] /* medium\00 */, "i8", ALLOC_STATIC);
__str77244=allocate([120,45,115,116,114,111,110,103,0] /* x-strong\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str78245=allocate([114,101,100,117,99,101,100,0] /* reduced\00 */, "i8", ALLOC_STATIC);
__str79246=allocate([109,111,100,101,114,97,116,101,0] /* moderate\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr=allocate(20, "i8*", ALLOC_STATIC);
__str80247=allocate([114,97,116,101,0] /* rate\00 */, "i8", ALLOC_STATIC);
__str81248=allocate([118,111,108,117,109,101,0] /* volume\00 */, "i8", ALLOC_STATIC);
__str82249=allocate([114,97,110,103,101,0] /* range\00 */, "i8", ALLOC_STATIC);
__ZL22ignore_if_self_closing=allocate([0,1,1,1,1,0,0,0,0,1,1,0,1,0,1,0,0,0,0] /* \00\01\01\01\01\00\0 */, "i8", ALLOC_STATIC);
__str83250=allocate([102,105,101,108,100,0] /* field\00 */, "i8", ALLOC_STATIC);
__str84251=allocate([109,111,100,101,0] /* mode\00 */, "i8", ALLOC_STATIC);
__str85252=allocate([112,117,110,99,116,117,97,116,105,111,110,0] /* punctuation\00 */, "i8", ALLOC_STATIC);
__str86253=allocate([99,97,112,105,116,97,108,95,108,101,116,116,101,114,115,0] /* capital_letters\00 */, "i8", ALLOC_STATIC);
__str87254=allocate([108,101,118,101,108,0] /* level\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE23emphasis_to_pitch_range=allocate([50,50,40,70,90,90] /* 22(FZZ */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE18emphasis_to_volume=allocate([100,100,70,110,140,140] /* ddFn\8C\8C */, "i8", ALLOC_STATIC);
__str88255=allocate([105,110,116,101,114,112,114,101,116,45,97,115,0] /* interpret-as\00 */, "i8", ALLOC_STATIC);
__str89256=allocate([102,111,114,109,97,116,0] /* format\00 */, "i8", ALLOC_STATIC);
__str90257=allocate([100,101,116,97,105,108,0] /* detail\00 */, "i8", ALLOC_STATIC);
__str91258=allocate([37,99,37,100,89,0] /* %c%dY\00 */, "i8", ALLOC_STATIC);
__ZL11sayas_start=allocate(1, "i32", ALLOC_STATIC);
__str92259=allocate([97,108,105,97,115,0] /* alias\00 */, "i8", ALLOC_STATIC);
__str94261=allocate([37,99,37,100,77,0] /* %c%dM\00 */, "i8", ALLOC_STATIC);
__str95262=allocate([115,114,99,0] /* src\00 */, "i8", ALLOC_STATIC);
__str96263=allocate([37,115,47,37,115,0] /* %s/%s\00 */, "i8", ALLOC_STATIC);
__str97264=allocate([37,99,37,100,73,0] /* %c%dI\00 */, "i8", ALLOC_STATIC);
__str98265=allocate([37,99,37,100,85,0] /* %c%dU\00 */, "i8", ALLOC_STATIC);
__str99266=allocate([115,116,114,101,110,103,116,104,0] /* strength\00 */, "i8", ALLOC_STATIC);
__ZZL14ProcessSsmlTagPwPcRiiiE11break_value=allocate([0, 0, 0, 0, 7, 0, 0, 0, 14, 0, 0, 0, 21, 0, 0, 0, 40, 0, 0, 0, 80, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str100267=allocate([37,99,37,100,66,0] /* %c%dB\00 */, "i8", ALLOC_STATIC);
__str101268=allocate([116,105,109,101,0] /* time\00 */, "i8", ALLOC_STATIC);
__str102269=allocate([120,109,108,58,98,97,115,101,0] /* xml:base\00 */, "i8", ALLOC_STATIC);
__ZZL18GetVoiceAttributesPwiE11mnem_gender=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str105272=allocate([110,101,117,116,114,97,108,0] /* neutral\00 */, "i8", ALLOC_STATIC);
__str106273=allocate([120,109,108,58,108,97,110,103,0] /* xml:lang\00 */, "i8", ALLOC_STATIC);
__str108275=allocate([97,103,101,0] /* age\00 */, "i8", ALLOC_STATIC);
__ZZL14LoadSoundFile2PKcE4slot=allocate([-1], ["i32",0,0,0,0], ALLOC_STATIC);
__str111278=allocate([115,112,97,99,101,32,0] /* space \00 */, "i8", ALLOC_STATIC);
__str112279=allocate([116,97,98,32,0] /* tab \00 */, "i8", ALLOC_STATIC);
__str113280=allocate([117,110,100,101,114,115,99,111,114,101,32,0] /* underscore \00 */, "i8", ALLOC_STATIC);
__str114281=allocate([100,111,117,98,108,101,45,113,117,111,116,101,32,0] /* double-quote \00 */, "i8", ALLOC_STATIC);
__ZZL14ReplaceKeyNamePciRiE8keynames=allocate([0, 0, 0, 0, 57376, 0, 0, 0, 0, 0, 0, 0, 57353, 0, 0, 0, 0, 0, 0, 0, 57439, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 0, 0, 0, 0, 0, 0, 0, 65, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 150, 0, 0, 0, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str115282=allocate([115,105,108,101,110,116,0] /* silent\00 */, "i8", ALLOC_STATIC);
__str116283=allocate([120,45,115,111,102,116,0] /* x-soft\00 */, "i8", ALLOC_STATIC);
__str117=allocate([115,111,102,116,0] /* soft\00 */, "i8", ALLOC_STATIC);
__str118=allocate([108,111,117,100,0] /* loud\00 */, "i8", ALLOC_STATIC);
__str119=allocate([120,45,108,111,117,100,0] /* x-loud\00 */, "i8", ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 60, 0, 0, 0, 0, 0, 0, 0, 80, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 125, 0, 0, 0, 0, 0, 0, 0, 160, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str120=allocate([120,45,115,108,111,119,0] /* x-slow\00 */, "i8", ALLOC_STATIC);
__str121=allocate([115,108,111,119,0] /* slow\00 */, "i8", ALLOC_STATIC);
__str122=allocate([102,97,115,116,0] /* fast\00 */, "i8", ALLOC_STATIC);
__str123=allocate([120,45,102,97,115,116,0] /* x-fast\00 */, "i8", ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 70, 0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 110, 0, 0, 0, 0, 0, 0, 0, 120, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str124=allocate([120,45,108,111,119,0] /* x-low\00 */, "i8", ALLOC_STATIC);
__str125=allocate([108,111,119,0] /* low\00 */, "i8", ALLOC_STATIC);
__str126=allocate([104,105,103,104,0] /* high\00 */, "i8", ALLOC_STATIC);
__str127=allocate([120,45,104,105,103,104,0] /* x-high\00 */, "i8", ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range=allocate([0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0, 0, 0, 0, 180, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs=allocate(20, "%struct.MNEM_TAB*", ALLOC_STATIC);
__ZZL17ProcessParamStackPcRiE10cmd_letter=allocate([0,83,65,80,82,0,67,0,0,0,0,0,70,0,0] /* \00SAPR\00C\00\00\00 */, "i8", ALLOC_STATIC);
__str128=allocate([37,99,37,100,37,99,0] /* %c%d%c\00 */, "i8", ALLOC_STATIC);
__ZZL16GetSsmlAttributePwPKcE5empty=allocate(4, "i32", ALLOC_STATIC);
__ZZL4GetCvE6ungot2=allocate(1, "i32", ALLOC_STATIC);
__ZZL4GetCvE5mask2=allocate([0,128,32,48] /* \00\80 0 */, "i8", ALLOC_STATIC);
__ZL6speed1=allocate([130], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL6speed2=allocate([121], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL6speed3=allocate([118], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL12speed_lookup=allocate([255,255,255,255,255,253,249,245,242,238,235,232,228,225,222,218,216,213,210,207,204,201,198,196,193,191,188,186,183,181,179,176,174,172,169,168,165,163,161,159,158,155,153,152,150,148,146,145,143,141,139,137,136,135,133,131,130,129,127,126,124,123,122,120,119,118,117,115,114,113,112,111,110,109,107,106,105,104,103,102,101,100,99,98,97,96,95,94,93,92,91,90,89,89,88,87,86,85,84,83,82,82,81,80,80,79,78,77,76,76,75,75,74,73,72,71,71,70,69,69,68,67,67,66,66,65,64,64,63,62,62,61,61,60,59,59,58,58,57,57,56,56,55,54,54,53,53,52,52,52,51,50,50,49,49,48,48,47,47,46,46,46,45,45,44,44,44,43,43,42,41,40,40,40,39,39,39,38,38,38,37,37,37,36,36,35,35,35,35,34,34,34,33,33,33,32,32,31,31,31,30,30,30,29,29,29,29,28,28,27,27,27,27,26,26,26,26,25,25,25,24,24,24,24,23,23,23,23,22,22,22,21,21,21,21,20,20,20,20,19,19,19,18,18,17,17,17,16,16,16,16,16,16,15,15,15,15,14,14,14,13,13,13,12,12,12,12,11,11,11,11,10,10,10,9,9,9,8,8,8] /* \FF\FF\FF\FF\FF\FD\F */, "i8", ALLOC_STATIC);
__ZL14wav_factor_350=allocate([120,121,120,119,119,118,118,117,116,116,115,114,113,112,112,111,111,110,109,108,107,106,106,104,103,103,102,102,102,101,101,99,98,98,97,96,96,95,94,93,91,90,91,90,89,88,86,85,86,85,85,84,82,81,80,79,77,78,78,76,77,75,75,74,73,71,72,70,69,69,69,67,65,64,63,63,63,61,61,59,59,59,58,56,57,58,56,54,53,52,52,53,52,52,50,48,47,47,45,46,45] /* xyxwwvvuttsrqppoonml */, "i8", ALLOC_STATIC);
__ZL16pause_factor_350=allocate([22,22,22,22,22,22,22,21,21,21,21,20,20,19,19,18,17,16,15,15,15,15,15,15,15] /* \16\16\16\16\16\16\1 */, "i8", ALLOC_STATIC);
__ZZ11CalcLengthsP10TranslatorE14more_syllables=allocate(1, "i32", ALLOC_STATIC);
__str294=allocate([101,115,112,101,97,107,58,32,66,97,100,32,105,110,116,111,110,97,116,105,111,110,32,100,97,116,97,10,0] /* espeak: Bad intonati */, "i8", ALLOC_STATIC);
__ZL18letter_accents_0e0=allocate([870, 0, 358, 0, 614, 0, 1190, 0, 678, 0, 1062, 0, -30042, 0, 552, 0, 874, 0, 362, 0, 618, 0, 682, 0, 878, 0, 366, 0, 622, 0, 686, 0, 41, 0, 1203, 0, 884, 0, 372, 0, 628, 0, 1204, 0, 692, 0, 0, 0, 1140, 0, 890, 0, 378, 0, 634, 0, 698, 0, 382, 0, 57, 0, 702, 0, 0, 0, 934, 0, 0, 0, 422, 0, 0, 0, 998, 0, 0, 0, 360, 0, 0, 0, 616, 0, 0, 0, 808, 0, 0, 0, 488, 0, 0, 0, 489, 0, 0, 0, 1129, 0, 0, 0, 938, 0, 0, 0, 426, 0, 0, 0, 810, 0, 0, 0, 1002, 0, 0, 0, 490, 0, 0, 0, 620, 0, 0, 0, 428, 0, 0, 0, 812, 0, 0, 0, 556, 0, 0, 0, 621, 0, 0, 0, 1133, 0, 0, 0, 1198, 0, 0, 0, 942, 0, 0, 0, 430, 0, 0, 0, 1006, 0, 0, 0, 46, 0, 0, 0, -29714, 0, 0, 0, 623, 0, 0, 0, 560, 0, 48, 0, 0, 0, 369, 0, 0, 0, 561, 0, 0, 0, 497, 0, 0, 0, 817, 0, 0, 0, 1137, 0, 0, 0, 371, 0, 0, 0, 563, 0, 0, 0, 499, 0, 51, 0, 0, 0, 51, 0, 0, 0, 948, 0, 0, 0, 436, 0, 0, 0, 756, 0, 0, 0, -30028, 0, 0, 0, 375, 0, 0, 0, 567, 0, 0, 0, 503, 0, 0, 0, 376, 0, 0, 0, 632, 0, 0, 0, 568, 0, 0, 0, 504, 0, 0, 0, 569, 0, 0, 0, 505, 0, 0, 0, 1145, 0, 0, 0, 1210, 0, 0, 0, 954, 0, 0, 0, 442, 0, 0, 0, 1082, 0, 0, 0, 762, 0, 0, 0, 1018, 0, 0, 0, 636, 0, 0, 0, 638, 0, 0, 0, 0, 0, 383, 0, 0, 0, 831, 0, 0, 0, 511, 0, 56, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL18letter_accents_250=allocate([166, 0, 1, 0, 129, 0, 1383, 0, 0, 0, 296, 0, 1321, 0, 1385, 0, 234, 0, 0, 0, 1346, 0, 0, 0, 195, 0, 7491, 0, 0, 0, 1263, 0, 1388, 0, 44, 0, 108, 0, 4, 0, 0, 0, 173, 0, 1389, 0, 0, 0, 1262, 0, 5, 0, 110, 0, 1201, 0, 1265, 0, 1329, 0, -28687, 0, 178, 0, 0, 0, 1394, 0, 0, 0, 1331, 0, 115, 0, 1268, 0, -25932, 0, 0, 0, 8, 0, 183, 0, 0, 0, 5431, 0, 0, 0, 1335, 0, 0, 0, 205, 0, 119, 0, 2231, 0, 1336, 0, 0, 0, 0, 0, 201, 0, 265, 0, 185, 0, 1337, 0, 1274, 0, 10, 0, 1403, 0, 187, 0, 188, 0, 190, 0, 126, 0, 1343, 0, 319, 0, 0, 0, 267, 0, 0, 0, 204, 0, 140, 0, 0, 0, 0, 0, 103, 0, 0, 0, 3436, 0, 109, 0, 303, 0, 176, 0, 113, 0, 1398, 0, 1100, 0, 7244, 0, -28695, 0, 0, 0, -12311, 0, -29127, 0, 0, 0, -12743, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL13non_ascii_tab=allocate([0, 0, 945, 0, 601, 0, 603, 0, 947, 0, 953, 0, 339, 0, 969, 0, 966, 0, 643, 0, 965, 0, 658, 0, 660, 0, 638, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL11accents_tab=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str297=allocate([37,115,37,99,37,115,37,99,37,115,37,115,0] /* %s%c%s%c%s%s\00 */, "i8", ALLOC_STATIC);
__str1298=allocate([37,115,37,99,37,99,37,115,0] /* %s%c%c%s\00 */, "i8", ALLOC_STATIC);
__str2299=allocate([37,99,37,115,37,99,37,115,37,99,0] /* %c%s%c%s%c\00 */, "i8", ALLOC_STATIC);
__ZZ12LookupLetterP10TranslatorjiPciE13single_letter=allocate(10, "i8", ALLOC_STATIC);
__str5302=allocate([95,35,37,100,32,0] /* _#%d \00 */, "i8", ALLOC_STATIC);
__str6303=allocate([95,99,97,112,0] /* _cap\00 */, "i8", ALLOC_STATIC);
__str7304=allocate([37,99,101,110,0] /* %cen\00 */, "i8", ALLOC_STATIC);
__str8305=allocate([95,63,65,0] /* _?A\00 */, "i8", ALLOC_STATIC);
__str9306=allocate([95,63,63,0] /* _??\00 */, "i8", ALLOC_STATIC);
__str10307=allocate([37,120,0] /* %x\00 */, "i8", ALLOC_STATIC);
__str11308=allocate([37,99,37,115,37,115,0] /* %c%s%s\00 */, "i8", ALLOC_STATIC);
__str12309=allocate([105,120,99,109,118,108,100,0] /* ixcmvld\00 */, "i8", ALLOC_STATIC);
__ZZ14TranslateRomanP10TranslatorPcS1_P8WORD_TABE12roman_values=allocate([1, 0, 0, 0, 10, 0, 0, 0, 100, 0, 0, 0, 1000, 0, 0, 0, 5, 0, 0, 0, 50, 0, 0, 0, 500, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str13310=allocate([95,114,111,109,97,110,0] /* _roman\00 */, "i8", ALLOC_STATIC);
__str14311=allocate([32,32,37,100,32,32,32,32,0] /*   %d    \00 */, "i8", ALLOC_STATIC);
__ZZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABiE9str_pause=allocate([11,0] /* \0B\00 */, "i8", ALLOC_STATIC);
__ZL14n_digit_lookup=allocate(1, "i32", ALLOC_STATIC);
__ZL12digit_lookup=allocate(1, "i8*", ALLOC_STATIC);
__ZL14number_control=allocate(1, "i32", ALLOC_STATIC);
__ZL23speak_missing_thousands=allocate(1, "i32", ALLOC_STATIC);
__ZL11ph_ordinal2=allocate(12, "i8", ALLOC_STATIC);
__str15312=allocate([95,35,37,115,0] /* _#%s\00 */, "i8", ALLOC_STATIC);
__str16313=allocate([95,48,0] /* _0\00 */, "i8", ALLOC_STATIC);
__str17314=allocate([95,100,112,116,0] /* _dpt\00 */, "i8", ALLOC_STATIC);
__str18315=allocate([95,48,77,37,100,0] /* _0M%d\00 */, "i8", ALLOC_STATIC);
__str19316=allocate([95,46,0] /* _.\00 */, "i8", ALLOC_STATIC);
__str20317=allocate([37,115,37,115,37,115,37,115,0] /* %s%s%s%s\00 */, "i8", ALLOC_STATIC);
__str21318=allocate([95,48,90,37,100,0] /* _0Z%d\00 */, "i8", ALLOC_STATIC);
__str22319=allocate([95,100,112,116,50,0] /* _dpt2\00 */, "i8", ALLOC_STATIC);
__str23320=allocate([95,37,100,102,0] /* _%df\00 */, "i8", ALLOC_STATIC);
__str24321=allocate([95,37,100,37,99,120,0] /* _%d%cx\00 */, "i8", ALLOC_STATIC);
__str25322=allocate([95,37,100,37,99,0] /* _%d%c\00 */, "i8", ALLOC_STATIC);
__str26323=allocate([95,37,100,101,0] /* _%de\00 */, "i8", ALLOC_STATIC);
__str27324=allocate([95,37,100,97,0] /* _%da\00 */, "i8", ALLOC_STATIC);
__str28325=allocate([95,37,100,0] /* _%d\00 */, "i8", ALLOC_STATIC);
__str29326=allocate([95,37,100,88,37,99,0] /* _%dX%c\00 */, "i8", ALLOC_STATIC);
__str30327=allocate([95,37,100,88,0] /* _%dX\00 */, "i8", ALLOC_STATIC);
__str31328=allocate([95,111,114,100,50,48,0] /* _ord20\00 */, "i8", ALLOC_STATIC);
__str32329=allocate([95,111,114,100,0] /* _ord\00 */, "i8", ALLOC_STATIC);
__str33330=allocate([95,48,97,110,100,0] /* _0and\00 */, "i8", ALLOC_STATIC);
__str35332=allocate([95,48,67,111,0] /* _0Co\00 */, "i8", ALLOC_STATIC);
__str36333=allocate([95,48,67,48,0] /* _0C0\00 */, "i8", ALLOC_STATIC);
__str37334=allocate([95,48,67,0] /* _0C\00 */, "i8", ALLOC_STATIC);
__str39336=allocate([95,37,100,67,111,0] /* _%dCo\00 */, "i8", ALLOC_STATIC);
__str40337=allocate([95,37,100,67,48,0] /* _%dC0\00 */, "i8", ALLOC_STATIC);
__str41338=allocate([95,37,100,67,0] /* _%dC\00 */, "i8", ALLOC_STATIC);
__str42339=allocate([95,37,100,77,37,100,111,0] /* _%dM%do\00 */, "i8", ALLOC_STATIC);
__str43340=allocate([95,37,100,77,37,100,101,0] /* _%dM%de\00 */, "i8", ALLOC_STATIC);
__str44341=allocate([95,37,100,77,37,100,120,0] /* _%dM%dx\00 */, "i8", ALLOC_STATIC);
__str45342=allocate([95,37,100,77,37,100,0] /* _%dM%d\00 */, "i8", ALLOC_STATIC);
__str46343=allocate([95,48,111,102,0] /* _0of\00 */, "i8", ALLOC_STATIC);
__str47344=allocate([95,37,115,37,100,111,0] /* _%s%do\00 */, "i8", ALLOC_STATIC);
__str48345=allocate([95,37,115,37,100,101,0] /* _%s%de\00 */, "i8", ALLOC_STATIC);
__str49346=allocate([95,37,115,37,100,120,0] /* _%s%dx\00 */, "i8", ALLOC_STATIC);
__str50347=allocate([95,37,115,37,100,0] /* _%s%d\00 */, "i8", ALLOC_STATIC);
__str51348=allocate([95,48,77,50,0] /* _0M2\00 */, "i8", ALLOC_STATIC);
__str52349=allocate([95,37,100,77,49,0] /* _%dM1\00 */, "i8", ALLOC_STATIC);
__str53350=allocate([95,48,77,49,0] /* _0M1\00 */, "i8", ALLOC_STATIC);
__str54351=allocate([48,77,65,0] /* 0MA\00 */, "i8", ALLOC_STATIC);
__str55352=allocate([49,77,65,0] /* 1MA\00 */, "i8", ALLOC_STATIC);
__str56353=allocate([48,77,0] /* 0M\00 */, "i8", ALLOC_STATIC);
__str57354=allocate([95,108,105,103,0] /* _lig\00 */, "i8", ALLOC_STATIC);
__str58355=allocate([95,115,109,99,0] /* _smc\00 */, "i8", ALLOC_STATIC);
__str59356=allocate([95,116,117,114,0] /* _tur\00 */, "i8", ALLOC_STATIC);
__str60357=allocate([95,114,101,118,0] /* _rev\00 */, "i8", ALLOC_STATIC);
__str61358=allocate([95,99,114,108,0] /* _crl\00 */, "i8", ALLOC_STATIC);
__str62359=allocate([95,97,99,117,0] /* _acu\00 */, "i8", ALLOC_STATIC);
__str63360=allocate([95,98,114,118,0] /* _brv\00 */, "i8", ALLOC_STATIC);
__str64361=allocate([95,104,97,99,0] /* _hac\00 */, "i8", ALLOC_STATIC);
__str65362=allocate([95,99,101,100,0] /* _ced\00 */, "i8", ALLOC_STATIC);
__str66363=allocate([95,99,105,114,0] /* _cir\00 */, "i8", ALLOC_STATIC);
__str67364=allocate([95,100,105,97,0] /* _dia\00 */, "i8", ALLOC_STATIC);
__str68365=allocate([95,97,99,50,0] /* _ac2\00 */, "i8", ALLOC_STATIC);
__str69366=allocate([95,100,111,116,0] /* _dot\00 */, "i8", ALLOC_STATIC);
__str70367=allocate([95,103,114,118,0] /* _grv\00 */, "i8", ALLOC_STATIC);
__str71368=allocate([95,109,99,110,0] /* _mcn\00 */, "i8", ALLOC_STATIC);
__str72369=allocate([95,111,103,111,0] /* _ogo\00 */, "i8", ALLOC_STATIC);
__str73370=allocate([95,114,110,103,0] /* _rng\00 */, "i8", ALLOC_STATIC);
__str74371=allocate([95,115,116,107,0] /* _stk\00 */, "i8", ALLOC_STATIC);
__str75372=allocate([95,116,108,100,0] /* _tld\00 */, "i8", ALLOC_STATIC);
__str76373=allocate([95,98,97,114,0] /* _bar\00 */, "i8", ALLOC_STATIC);
__str77374=allocate([95,114,102,120,0] /* _rfx\00 */, "i8", ALLOC_STATIC);
__str78375=allocate([95,104,111,107,0] /* _hok\00 */, "i8", ALLOC_STATIC);
_option_mbrola_phonemes=allocate(1, "i32", ALLOC_STATIC);
__ZL10mbrola_tab=allocate(1, "%struct.MBROLA_TAB*", ALLOC_STATIC);
__ZL15mbr_name_prefix=allocate(1, "i32", ALLOC_STATIC);
__str382=allocate([37,115,47,109,98,114,111,108,97,47,37,115,0] /* %s/mbrola/%s\00 */, "i8", ALLOC_STATIC);
__str1383=allocate([47,117,115,114,47,115,104,97,114,101,47,109,98,114,111,108,97,47,37,115,0] /* /usr/share/mbrola/%s */, "i8", ALLOC_STATIC);
__str2384=allocate([47,117,115,114,47,115,104,97,114,101,47,109,98,114,111,108,97,47,37,115,47,37,115,0] /* /usr/share/mbrola/%s */, "i8", ALLOC_STATIC);
__str3385=allocate([47,117,115,114,47,115,104,97,114,101,47,109,98,114,111,108,97,47,118,111,105,99,101,115,47,37,115,0] /* /usr/share/mbrola/vo */, "i8", ALLOC_STATIC);
__str4386=allocate([37,115,47,109,98,114,111,108,97,95,112,104,47,37,115,0] /* %s/mbrola_ph/%s\00 */, "i8", ALLOC_STATIC);
__ZL14mbrola_control=allocate(1, "i32", ALLOC_STATIC);
__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE4phix=allocate(1, "i32", ALLOC_STATIC);
__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE11embedded_ix=allocate(1, "i32", ALLOC_STATIC);
__ZZ15MbrolaTranslateP12PHONEME_LISTiiP7__sFILEE10word_count=allocate(1, "i32", ALLOC_STATIC);
__str6388=allocate([37,115,9,0] /* %s\09\00 */, "i8", ALLOC_STATIC);
__str8390=allocate([37,100,9,37,115,0] /* %d\09%s\00 */, "i8", ALLOC_STATIC);
__str9391=allocate([37,115,9,37,100,9,37,115,0] /* %s\09%d\09%s\00 */, "i8", ALLOC_STATIC);
__str10392=allocate([37,100,10,37,115,9,0] /* %d\0A%s\09\00 */, "i8", ALLOC_STATIC);
__str11393=allocate([37,100,37,115,10,0] /* %d%s\0A\00 */, "i8", ALLOC_STATIC);
__str12394=allocate([95,32,9,37,100,10,0] /* _ \09%d\0A\00 */, "i8", ALLOC_STATIC);
__ZZ10MbrolaFilliiE9n_samples=allocate(1, "i32", ALLOC_STATIC);
__ZZL10WritePitchiiiiiE6output=allocate(50, "i8", ALLOC_STATIC);
__str13395=allocate([32,48,32,37,100,0] /*  0 %d\00 */, "i8", ALLOC_STATIC);
__str14396=allocate([32,37,100,32,37,100,0] /*  %d %d\00 */, "i8", ALLOC_STATIC);
__str15397=allocate([10,0] /* \0A\00 */, "i8", ALLOC_STATIC);
__str16398=allocate([9,49,48,48,32,37,100,10,0] /* \09100 %d\0A\00 */, "i8", ALLOC_STATIC);
__ZZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_E4mnem=allocate(1, "i32", ALLOC_STATIC);
__str399=allocate([49,46,52,53,46,48,52,32,32,50,53,46,65,112,114,46,49,49,0] /* 1.45.04  25.Apr.11\0 */, "i8", ALLOC_STATIC);
_version_string=allocate(1, "i8*", ALLOC_STATIC);
_version_phdata=allocate([83200], ["i32",0,0,0,0], ALLOC_STATIC);
_option_device_number=allocate([-1], ["i32",0,0,0,0], ALLOC_STATIC);
_f_logespeak=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_logging_type=allocate(1, "i32", ALLOC_STATIC);
_n_phoneme_tab=allocate(1, "i32", ALLOC_STATIC);
_current_phoneme_table=allocate(1, "i32", ALLOC_STATIC);
_phoneme_tab=allocate(1024, "%struct.PHONEME_TAB*", ALLOC_STATIC);
_phoneme_tab_flags=allocate(256, "i8", ALLOC_STATIC);
_phoneme_index=allocate(1, "i16*", ALLOC_STATIC);
_phondata_ptr=allocate(1, "i8*", ALLOC_STATIC);
_wavefile_data=allocate(1, "i8*", ALLOC_STATIC);
__ZL16phoneme_tab_data=allocate(1, "i8*", ALLOC_STATIC);
_n_phoneme_tables=allocate(1, "i32", ALLOC_STATIC);
_phoneme_tab_list=allocate(4800, ["i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","%struct.PHONEME_TAB*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_phoneme_tab_number=allocate(1, "i32", ALLOC_STATIC);
_wavefile_ix=allocate(1, "i32", ALLOC_STATIC);
_wavefile_amp=allocate(1, "i32", ALLOC_STATIC);
_wavefile_ix2=allocate(1, "i32", ALLOC_STATIC);
_wavefile_amp2=allocate(1, "i32", ALLOC_STATIC);
_seq_len_adjust=allocate(1, "i32", ALLOC_STATIC);
_vowel_transition=allocate(16, "i32", ALLOC_STATIC);
_vowel_transition0=allocate(1, "i32", ALLOC_STATIC);
_vowel_transition1=allocate(1, "i32", ALLOC_STATIC);
__str1412=allocate([112,104,111,110,116,97,98,0] /* phontab\00 */, "i8", ALLOC_STATIC);
__str2413=allocate([112,104,111,110,105,110,100,101,120,0] /* phonindex\00 */, "i8", ALLOC_STATIC);
__str3414=allocate([112,104,111,110,100,97,116,97,0] /* phondata\00 */, "i8", ALLOC_STATIC);
__str4415=allocate([105,110,116,111,110,97,116,105,111,110,115,0] /* intonations\00 */, "i8", ALLOC_STATIC);
__ZZ11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LISTE10frames_buf=allocate(200, ["i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0,"i16",0,"i16",0,"%struct.frame_t*",0,0,0], ALLOC_STATIC);
__str5416=allocate([101,115,112,101,97,107,58,32,78,111,32,101,110,118,101,108,111,112,101,10,0] /* espeak: No envelope\ */, "i8", ALLOC_STATIC);
__str7418=allocate([99,111,110,102,105,103,0] /* config\00 */, "i8", ALLOC_STATIC);
__str9420=allocate([108,111,103,0] /* log\00 */, "i8", ALLOC_STATIC);
__str10421=allocate([37,100,32,37,115,0] /* %d %s\00 */, "i8", ALLOC_STATIC);
__str11422=allocate([119,0] /* w\00 */, "i8", ALLOC_STATIC);
__str13424=allocate([112,97,95,100,101,118,105,99,101,0] /* pa_device\00 */, "i8", ALLOC_STATIC);
__str15426=allocate([115,111,117,110,100,105,99,111,110,0] /* soundicon\00 */, "i8", ALLOC_STATIC);
__str16427=allocate([95,37,99,32,37,115,0] /* _%c %s\00 */, "i8", ALLOC_STATIC);
_this_ph_data=allocate(152, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8",0,0], ALLOC_STATIC);
__ZZL13NumInstnWordsPtE7n_words=allocate([1,1,1,1,1,1,1,1,1,2,4] /* \01\01\01\01\01\01\0 */, "i8", ALLOC_STATIC);
__ZZL18InterpretConditionP10TranslatoriP12PHONEME_LISTiE11ph_position=allocate([0, 0, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 3, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 3, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL15StressConditionP10TranslatorP12PHONEME_LISTiiE15condition_level=allocate([1, 0, 0, 0, 2, 0, 0, 0, 4, 0, 0, 0, 15, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str17428=allocate([73,110,118,97,108,105,100,32,105,110,115,116,114,117,99,116,105,111,110,32,37,46,52,120,32,102,111,114,32,112,104,111,110,101,109,101,32,39,37,115,39,10,0] /* Invalid instruction  */, "i8", ALLOC_STATIC);
__str18429=allocate([114,98,0] /* rb\00 */, "i8", ALLOC_STATIC);
__str19430=allocate([67,97,110,39,116,32,114,101,97,100,32,100,97,116,97,32,102,105,108,101,58,32,39,37,115,39,10,0] /* Can't read data file */, "i8", ALLOC_STATIC);
_n_phoneme_list=allocate(1, "i32", ALLOC_STATIC);
_phoneme_list=allocate(24000, ["i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0,"i8","i8","i8","i8","i16",0,"i16",0,"%struct.PHONEME_TAB*",0,0,0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8",0,0], ALLOC_STATIC);
_mbrola_delay=allocate(1, "i32", ALLOC_STATIC);
_mbrola_name=allocate(20, "i8", ALLOC_STATIC);
_speed=allocate(64, "i32", ALLOC_STATIC);
__ZL9new_voice=allocate(1, "%struct.voice_t*", ALLOC_STATIC);
_n_soundicon_tab=allocate([4], ["i32",0,0,0,0], ALLOC_STATIC);
_soundicon_tab=allocate(1280, ["i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__ZZ12WordToStringjE3buf=allocate(5, "i8", ALLOC_STATIC);
__ZL14last_pitch_cmd=allocate(1, "i32", ALLOC_STATIC);
__ZL12last_amp_cmd=allocate(1, "i32", ALLOC_STATIC);
__ZL10last_frame=allocate(1, "%struct.frame_t*", ALLOC_STATIC);
__ZL15syllable_centre=allocate(1, "i32", ALLOC_STATIC);
__ZZ18FormantTransition2P10frameref_tRijjP11PHONEME_TABiE10vcolouring=allocate([243, 0, 272, 0, 256, 0, 256, 0, 256, 0, 256, 0, 256, 0, 240, 0, 240, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10modn_flags=allocate(1, "i32", ALLOC_STATIC);
__ZZ8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTiE9wave_flag_b=allocate(1, "i1", ALLOC_STATIC);
__ZL13fmt_amplitude=allocate(1, "i32", ALLOC_STATIC);
__ZL10last_wcmdq=allocate(1, "i32", ALLOC_STATIC);
__ZL12pitch_length=allocate(1, "i32", ALLOC_STATIC);
__ZL10amp_length=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE2ix=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE11embedded_ix=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE10word_count=allocate(1, "i32", ALLOC_STATIC);
__ZZ8GenerateP12PHONEME_LISTPiiE8sourceix=allocate(1, "i32", ALLOC_STATIC);
__ZL14syllable_start=allocate(1, "i32", ALLOC_STATIC);
__ZL12syllable_end=allocate(1, "i32", ALLOC_STATIC);
__ZL8timer_on_b=allocate(1, "i1", ALLOC_STATIC);
__ZL6paused_b=allocate(1, "i1", ALLOC_STATIC);
__ZZ15SpeakNextClauseP7__sFILEPKviE6f_text=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
__ZZ15SpeakNextClauseP7__sFILEPKviE6p_text=allocate(1, "i8*", ALLOC_STATIC);
__str459=allocate([37,115,10,0] /* %s\0A\00 */, "i8", ALLOC_STATIC);
__str1460=allocate([87,97,114,110,105,110,103,58,32,65,99,99,101,110,116,101,100,32,108,101,116,116,101,114,115,32,97,114,101,32,110,111,116,32,114,101,99,111,103,110,105,122,101,100,44,32,101,103,58,32,85,43,48,49,48,68,10,83,101,116,32,76,67,95,67,84,89,80,69,32,116,111,32,97,32,85,84,70,45,56,32,108,111,99,97,108,101,10,0] /* Warning: Accented le */, "i8", ALLOC_STATIC);
__ZZL13set_frame_rmsP7frame_tiE8sqrt_tab=allocate([0, 0, 64, 0, 90, 0, 110, 0, 128, 0, 143, 0, 156, 0, 169, 0, 181, 0, 192, 0, 202, 0, 212, 0, 221, 0, 230, 0, 239, 0, 247, 0, 256, 0, 263, 0, 271, 0, 278, 0, 286, 0, 293, 0, 300, 0, 306, 0, 313, 0, 320, 0, 326, 0, 332, 0, 338, 0, 344, 0, 350, 0, 356, 0, 362, 0, 367, 0, 373, 0, 378, 0, 384, 0, 389, 0, 394, 0, 399, 0, 404, 0, 409, 0, 414, 0, 419, 0, 424, 0, 429, 0, 434, 0, 438, 0, 443, 0, 448, 0, 452, 0, 457, 0, 461, 0, 465, 0, 470, 0, 474, 0, 478, 0, 483, 0, 487, 0, 491, 0, 495, 0, 499, 0, 503, 0, 507, 0, 512, 0, 515, 0, 519, 0, 523, 0, 527, 0, 531, 0, 535, 0, 539, 0, 543, 0, 546, 0, 550, 0, 554, 0, 557, 0, 561, 0, 565, 0, 568, 0, 572, 0, 576, 0, 579, 0, 583, 0, 586, 0, 590, 0, 593, 0, 596, 0, 600, 0, 603, 0, 607, 0, 610, 0, 613, 0, 617, 0, 620, 0, 623, 0, 627, 0, 630, 0, 633, 0, 636, 0, 640, 0, 643, 0, 646, 0, 649, 0, 652, 0, 655, 0, 658, 0, 662, 0, 665, 0, 668, 0, 671, 0, 674, 0, 677, 0, 680, 0, 683, 0, 686, 0, 689, 0, 692, 0, 695, 0, 698, 0, 701, 0, 704, 0, 706, 0, 709, 0, 712, 0, 715, 0, 718, 0, 721, 0, 724, 0, 726, 0, 729, 0, 732, 0, 735, 0, 738, 0, 740, 0, 743, 0, 746, 0, 749, 0, 751, 0, 754, 0, 757, 0, 759, 0, 762, 0, 765, 0, 768, 0, 770, 0, 773, 0, 775, 0, 778, 0, 781, 0, 783, 0, 786, 0, 789, 0, 791, 0, 794, 0, 796, 0, 799, 0, 801, 0, 804, 0, 807, 0, 809, 0, 812, 0, 814, 0, 817, 0, 819, 0, 822, 0, 824, 0, 827, 0, 829, 0, 832, 0, 834, 0, 836, 0, 839, 0, 841, 0, 844, 0, 846, 0, 849, 0, 851, 0, 853, 0, 856, 0, 858, 0, 861, 0, 863, 0, 865, 0, 868, 0, 870, 0, 872, 0, 875, 0, 877, 0, 879, 0, 882, 0, 884, 0, 886, 0, 889, 0, 891, 0, 893, 0, 896, 0, 898, 0, 900, 0, 902, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL10AllocFramevE2ix=allocate(1, "i32", ALLOC_STATIC);
__ZZL10AllocFramevE10frame_pool=allocate(10240, ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
_translator=allocate(1, "%struct.Translator*", ALLOC_STATIC);
_translator2=allocate(1, "%struct.Translator*", ALLOC_STATIC);
__ZL20translator2_language=allocate(20, "i8", ALLOC_STATIC);
_f_trans=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_option_tone2=allocate(1, "i32", ALLOC_STATIC);
_option_tone_flags=allocate(1, "i32", ALLOC_STATIC);
_option_phonemes=allocate(1, "i32", ALLOC_STATIC);
_option_phoneme_events=allocate(1, "i32", ALLOC_STATIC);
_option_quiet=allocate(1, "i32", ALLOC_STATIC);
_option_endpause=allocate(1, "i32", ALLOC_STATIC);
_option_capitals=allocate(1, "i32", ALLOC_STATIC);
_option_punctuation=allocate(1, "i32", ALLOC_STATIC);
_option_sayas=allocate(1, "i32", ALLOC_STATIC);
_option_ssml=allocate(1, "i32", ALLOC_STATIC);
_option_phoneme_input=allocate(1, "i32", ALLOC_STATIC);
_option_phoneme_variants=allocate(1, "i32", ALLOC_STATIC);
_option_wordgap=allocate(1, "i32", ALLOC_STATIC);
_skip_sentences=allocate(1, "i32", ALLOC_STATIC);
_skip_words=allocate(1, "i32", ALLOC_STATIC);
_skip_characters=allocate(1, "i32", ALLOC_STATIC);
_skip_marker=allocate(50, "i8", ALLOC_STATIC);
_skipping_text=allocate(1, "i32", ALLOC_STATIC);
_end_character_position=allocate(1, "i32", ALLOC_STATIC);
_count_sentences=allocate(1, "i32", ALLOC_STATIC);
_count_words=allocate(1, "i32", ALLOC_STATIC);
_clause_start_char=allocate(1, "i32", ALLOC_STATIC);
_clause_start_word=allocate(1, "i32", ALLOC_STATIC);
_new_sentence=allocate(1, "i32", ALLOC_STATIC);
_pre_pause=allocate(1, "i32", ALLOC_STATIC);
_word_phonemes=allocate(160, "i8", ALLOC_STATIC);
_n_ph_list2=allocate(1, "i32", ALLOC_STATIC);
_ph_list2=allocate(8000, ["i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0,"i8","i8","i8","i8","i16",0,"i16",0], ALLOC_STATIC);
_option_punctlist=allocate(240, "i32", ALLOC_STATIC);
_ctrl_embedded=allocate([1], ["i8",0,0,0,0], ALLOC_STATIC);
_option_multibyte=allocate(1, "i32", ALLOC_STATIC);
_option_linelength=allocate(1, "i32", ALLOC_STATIC);
_embedded_list=allocate(1000, "i32", ALLOC_STATIC);
_n_replace_phonemes=allocate(1, "i32", ALLOC_STATIC);
_replace_phonemes=allocate(180, "i8", ALLOC_STATIC);
__ZL10ISO_8859_1=allocate([160, 0, 161, 0, 162, 0, 163, 0, 164, 0, 165, 0, 166, 0, 167, 0, 168, 0, 169, 0, 170, 0, 171, 0, 172, 0, 173, 0, 174, 0, 175, 0, 176, 0, 177, 0, 178, 0, 179, 0, 180, 0, 181, 0, 182, 0, 183, 0, 184, 0, 185, 0, 186, 0, 187, 0, 188, 0, 189, 0, 190, 0, 191, 0, 192, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 208, 0, 209, 0, 210, 0, 211, 0, 212, 0, 213, 0, 214, 0, 215, 0, 216, 0, 217, 0, 218, 0, 219, 0, 220, 0, 221, 0, 222, 0, 223, 0, 224, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 240, 0, 241, 0, 242, 0, 243, 0, 244, 0, 245, 0, 246, 0, 247, 0, 248, 0, 249, 0, 250, 0, 251, 0, 252, 0, 253, 0, 254, 0, 255, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_2=allocate([160, 0, 260, 0, 728, 0, 321, 0, 164, 0, 317, 0, 346, 0, 167, 0, 168, 0, 352, 0, 350, 0, 356, 0, 377, 0, 173, 0, 381, 0, 379, 0, 176, 0, 261, 0, 731, 0, 322, 0, 180, 0, 318, 0, 347, 0, 711, 0, 184, 0, 353, 0, 351, 0, 357, 0, 378, 0, 733, 0, 382, 0, 380, 0, 340, 0, 193, 0, 194, 0, 258, 0, 196, 0, 313, 0, 262, 0, 199, 0, 268, 0, 201, 0, 280, 0, 203, 0, 282, 0, 205, 0, 206, 0, 270, 0, 272, 0, 323, 0, 327, 0, 211, 0, 212, 0, 336, 0, 214, 0, 215, 0, 344, 0, 366, 0, 218, 0, 368, 0, 220, 0, 221, 0, 354, 0, 223, 0, 341, 0, 225, 0, 226, 0, 259, 0, 228, 0, 314, 0, 263, 0, 231, 0, 269, 0, 233, 0, 281, 0, 235, 0, 283, 0, 237, 0, 238, 0, 271, 0, 273, 0, 324, 0, 328, 0, 243, 0, 244, 0, 337, 0, 246, 0, 247, 0, 345, 0, 367, 0, 250, 0, 369, 0, 252, 0, 253, 0, 355, 0, 729, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_3=allocate([160, 0, 294, 0, 728, 0, 163, 0, 164, 0, 0, 0, 292, 0, 167, 0, 168, 0, 304, 0, 350, 0, 286, 0, 308, 0, 173, 0, 0, 0, 379, 0, 176, 0, 295, 0, 178, 0, 179, 0, 180, 0, 181, 0, 293, 0, 183, 0, 184, 0, 305, 0, 351, 0, 287, 0, 309, 0, 189, 0, 0, 0, 380, 0, 192, 0, 193, 0, 194, 0, 0, 0, 196, 0, 266, 0, 264, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 0, 0, 209, 0, 210, 0, 211, 0, 212, 0, 288, 0, 214, 0, 215, 0, 284, 0, 217, 0, 218, 0, 219, 0, 220, 0, 364, 0, 348, 0, 223, 0, 224, 0, 225, 0, 226, 0, 0, 0, 228, 0, 267, 0, 265, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 0, 0, 241, 0, 242, 0, 243, 0, 244, 0, 289, 0, 246, 0, 247, 0, 285, 0, 249, 0, 250, 0, 251, 0, 252, 0, 365, 0, 349, 0, 729, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_4=allocate([160, 0, 260, 0, 312, 0, 342, 0, 164, 0, 296, 0, 315, 0, 167, 0, 168, 0, 352, 0, 274, 0, 290, 0, 358, 0, 173, 0, 381, 0, 175, 0, 176, 0, 261, 0, 731, 0, 343, 0, 180, 0, 297, 0, 316, 0, 711, 0, 184, 0, 353, 0, 275, 0, 291, 0, 359, 0, 330, 0, 382, 0, 331, 0, 256, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 302, 0, 268, 0, 201, 0, 280, 0, 203, 0, 278, 0, 205, 0, 206, 0, 298, 0, 272, 0, 325, 0, 332, 0, 310, 0, 212, 0, 213, 0, 214, 0, 215, 0, 216, 0, 370, 0, 218, 0, 219, 0, 220, 0, 360, 0, 362, 0, 223, 0, 257, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 303, 0, 269, 0, 233, 0, 281, 0, 235, 0, 279, 0, 237, 0, 238, 0, 299, 0, 273, 0, 326, 0, 333, 0, 311, 0, 244, 0, 245, 0, 246, 0, 247, 0, 248, 0, 371, 0, 250, 0, 251, 0, 252, 0, 361, 0, 363, 0, 729, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_5=allocate([160, 0, 1025, 0, 1026, 0, 1027, 0, 1028, 0, 1029, 0, 1030, 0, 1031, 0, 1032, 0, 1033, 0, 1034, 0, 1035, 0, 1036, 0, 173, 0, 1038, 0, 1039, 0, 1040, 0, 1041, 0, 1042, 0, 1043, 0, 1044, 0, 1045, 0, 1046, 0, 1047, 0, 1048, 0, 1049, 0, 1050, 0, 1051, 0, 1052, 0, 1053, 0, 1054, 0, 1055, 0, 1056, 0, 1057, 0, 1058, 0, 1059, 0, 1060, 0, 1061, 0, 1062, 0, 1063, 0, 1064, 0, 1065, 0, 1066, 0, 1067, 0, 1068, 0, 1069, 0, 1070, 0, 1071, 0, 1072, 0, 1073, 0, 1074, 0, 1075, 0, 1076, 0, 1077, 0, 1078, 0, 1079, 0, 1080, 0, 1081, 0, 1082, 0, 1083, 0, 1084, 0, 1085, 0, 1086, 0, 1087, 0, 1088, 0, 1089, 0, 1090, 0, 1091, 0, 1092, 0, 1093, 0, 1094, 0, 1095, 0, 1096, 0, 1097, 0, 1098, 0, 1099, 0, 1100, 0, 1101, 0, 1102, 0, 1103, 0, 8470, 0, 1105, 0, 1106, 0, 1107, 0, 1108, 0, 1109, 0, 1110, 0, 1111, 0, 1112, 0, 1113, 0, 1114, 0, 1115, 0, 1116, 0, 167, 0, 1118, 0, 1119, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_7=allocate([160, 0, 8216, 0, 8217, 0, 163, 0, 8364, 0, 8367, 0, 166, 0, 167, 0, 168, 0, 169, 0, 890, 0, 171, 0, 172, 0, 173, 0, 0, 0, 8213, 0, 176, 0, 177, 0, 178, 0, 179, 0, 900, 0, 901, 0, 902, 0, 183, 0, 904, 0, 905, 0, 906, 0, 187, 0, 908, 0, 189, 0, 910, 0, 911, 0, 912, 0, 913, 0, 914, 0, 915, 0, 916, 0, 917, 0, 918, 0, 919, 0, 920, 0, 921, 0, 922, 0, 923, 0, 924, 0, 925, 0, 926, 0, 927, 0, 928, 0, 929, 0, 0, 0, 931, 0, 932, 0, 933, 0, 934, 0, 935, 0, 936, 0, 937, 0, 938, 0, 939, 0, 940, 0, 941, 0, 942, 0, 943, 0, 944, 0, 945, 0, 946, 0, 947, 0, 948, 0, 949, 0, 950, 0, 951, 0, 952, 0, 953, 0, 954, 0, 955, 0, 956, 0, 957, 0, 958, 0, 959, 0, 960, 0, 961, 0, 962, 0, 963, 0, 964, 0, 965, 0, 966, 0, 967, 0, 968, 0, 969, 0, 970, 0, 971, 0, 972, 0, 973, 0, 974, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL10ISO_8859_9=allocate([160, 0, 161, 0, 162, 0, 163, 0, 164, 0, 165, 0, 166, 0, 167, 0, 168, 0, 169, 0, 170, 0, 171, 0, 172, 0, 173, 0, 174, 0, 175, 0, 176, 0, 177, 0, 178, 0, 179, 0, 180, 0, 181, 0, 182, 0, 183, 0, 184, 0, 185, 0, 186, 0, 187, 0, 188, 0, 189, 0, 190, 0, 191, 0, 192, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 286, 0, 209, 0, 210, 0, 211, 0, 212, 0, 213, 0, 214, 0, 215, 0, 216, 0, 217, 0, 218, 0, 219, 0, 220, 0, 304, 0, 350, 0, 223, 0, 224, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 287, 0, 241, 0, 242, 0, 243, 0, 244, 0, 245, 0, 246, 0, 247, 0, 248, 0, 249, 0, 250, 0, 251, 0, 252, 0, 305, 0, 351, 0, 255, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL11ISO_8859_14=allocate([160, 0, 7682, 0, 7683, 0, 163, 0, 266, 0, 267, 0, 7690, 0, 167, 0, 7808, 0, 169, 0, 7810, 0, 7691, 0, 7922, 0, 173, 0, 174, 0, 376, 0, 7710, 0, 7711, 0, 288, 0, 289, 0, 7744, 0, 7745, 0, 182, 0, 7766, 0, 7809, 0, 7767, 0, 7811, 0, 7776, 0, 7923, 0, 7812, 0, 7813, 0, 7777, 0, 192, 0, 193, 0, 194, 0, 195, 0, 196, 0, 197, 0, 198, 0, 199, 0, 200, 0, 201, 0, 202, 0, 203, 0, 204, 0, 205, 0, 206, 0, 207, 0, 372, 0, 209, 0, 210, 0, 211, 0, 212, 0, 213, 0, 214, 0, 7786, 0, 216, 0, 217, 0, 218, 0, 219, 0, 220, 0, 221, 0, 374, 0, 223, 0, 224, 0, 225, 0, 226, 0, 227, 0, 228, 0, 229, 0, 230, 0, 231, 0, 232, 0, 233, 0, 234, 0, 235, 0, 236, 0, 237, 0, 238, 0, 239, 0, 373, 0, 241, 0, 242, 0, 243, 0, 244, 0, 245, 0, 246, 0, 7787, 0, 248, 0, 249, 0, 250, 0, 251, 0, 252, 0, 253, 0, 375, 0, 255, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL6KOI8_R=allocate([9552, 0, 9553, 0, 9554, 0, 1105, 0, 9555, 0, 9556, 0, 9557, 0, 9558, 0, 9559, 0, 9560, 0, 9561, 0, 9562, 0, 9563, 0, 9564, 0, 9565, 0, 9566, 0, 9567, 0, 9568, 0, 9569, 0, 1025, 0, 9570, 0, 9571, 0, 9572, 0, 9573, 0, 9574, 0, 9575, 0, 9576, 0, 9577, 0, 9578, 0, 9579, 0, 9580, 0, 169, 0, 1102, 0, 1072, 0, 1073, 0, 1094, 0, 1076, 0, 1077, 0, 1092, 0, 1075, 0, 1093, 0, 1080, 0, 1081, 0, 1082, 0, 1083, 0, 1084, 0, 1085, 0, 1086, 0, 1087, 0, 1103, 0, 1088, 0, 1089, 0, 1090, 0, 1091, 0, 1078, 0, 1074, 0, 1100, 0, 1099, 0, 1079, 0, 1096, 0, 1101, 0, 1097, 0, 1095, 0, 1098, 0, 1070, 0, 1040, 0, 1041, 0, 1062, 0, 1044, 0, 1045, 0, 1060, 0, 1043, 0, 1061, 0, 1048, 0, 1049, 0, 1050, 0, 1051, 0, 1052, 0, 1053, 0, 1054, 0, 1055, 0, 1071, 0, 1056, 0, 1057, 0, 1058, 0, 1059, 0, 1046, 0, 1042, 0, 1068, 0, 1067, 0, 1047, 0, 1064, 0, 1069, 0, 1065, 0, 1063, 0, 1066, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL5ISCII=allocate([32, 0, 2305, 0, 2306, 0, 2307, 0, 2309, 0, 2310, 0, 2311, 0, 2312, 0, 2313, 0, 2314, 0, 2315, 0, 2318, 0, 2319, 0, 2320, 0, 2317, 0, 2322, 0, 2323, 0, 2324, 0, 2321, 0, 2325, 0, 2326, 0, 2327, 0, 2328, 0, 2329, 0, 2330, 0, 2331, 0, 2332, 0, 2333, 0, 2334, 0, 2335, 0, 2336, 0, 2337, 0, 2338, 0, 2339, 0, 2340, 0, 2341, 0, 2342, 0, 2343, 0, 2344, 0, 2345, 0, 2346, 0, 2347, 0, 2348, 0, 2349, 0, 2350, 0, 2351, 0, 2399, 0, 2352, 0, 2353, 0, 2354, 0, 2355, 0, 2356, 0, 2357, 0, 2358, 0, 2359, 0, 2360, 0, 2361, 0, 32, 0, 2366, 0, 2367, 0, 2368, 0, 2369, 0, 2370, 0, 2371, 0, 2374, 0, 2375, 0, 2376, 0, 2373, 0, 2378, 0, 2379, 0, 2380, 0, 2377, 0, 2381, 0, 2364, 0, 2404, 0, 32, 0, 32, 0, 32, 0, 32, 0, 32, 0, 32, 0, 48, 0, 49, 0, 50, 0, 51, 0, 52, 0, 53, 0, 54, 0, 55, 0, 56, 0, 57, 0, 32, 0, 32, 0, 32, 0, 32, 0, 32, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
_charsets=allocate(80, "i16*", ALLOC_STATIC);
__ZL15length_mod_tabs=allocate(24, "i8*", ALLOC_STATIC);
__ZZ7IsAlphajE18extra_indic_alphas=allocate([2672, 0, 2673, 0, 0, 0], ["i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL8brackets=allocate([40, 0, 41, 0, 91, 0, 93, 0, 123, 0, 125, 0, 60, 0, 62, 0, 34, 0, 39, 0, 96, 0, 171, 0, 187, 0, 12298, 0, 12299, 0, -8132, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ8utf8_outjPcE4code=allocate([0,192,224,240] /* \00\C0\E0\F0 */, "i8", ALLOC_STATIC);
__ZZ8utf8_in2PiPKciE4mask=allocate([255,31,15,7] /* \FF\1F\0F\07 */, "i8", ALLOC_STATIC);
__str543=allocate([40,37,115,41,32,37,115,32,32,45,62,32,40,37,115,41,32,0] /* (%s) %s  -> (%s) \00 */, "i8", ALLOC_STATIC);
__str1544=allocate([37,115,10,10,0] /* %s\0A\0A\00 */, "i8", ALLOC_STATIC);
__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_zz=allocate([0,122,122,0] /* \00zz\00 */, "i8", ALLOC_STATIC);
__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_iz=allocate([0,105,122,0] /* \00iz\00 */, "i8", ALLOC_STATIC);
__ZZ13TranslateWordP10TranslatorPciP8WORD_TABE7word_ss=allocate([0,115,115,0] /* \00ss\00 */, "i8", ALLOC_STATIC);
__str2545=allocate([95,48,108,97,110,103,0] /* _0lang\00 */, "i8", ALLOC_STATIC);
__str4547=allocate([32,32,115,117,102,102,105,120,32,91,37,115,93,10,10,0] /*   suffix [%s]\0A\0A\ */, "i8", ALLOC_STATIC);
__str5548=allocate([104,115,120,0] /* hsx\00 */, "i8", ALLOC_STATIC);
__str6549=allocate([37,115,37,115,37,115,0] /* %s%s%s\00 */, "i8", ALLOC_STATIC);
__ZL18any_stressed_words_b=allocate(1, "i1", ALLOC_STATIC);
__ZZ15TranslateClauseP10TranslatorP7__sFILEPKvPiPPcE17voice_change_name=allocate(40, "i8", ALLOC_STATIC);
__ZL11embedded_ix=allocate(1, "i32", ALLOC_STATIC);
__ZL13embedded_read=allocate(1, "i32", ALLOC_STATIC);
__ZL6source=allocate(740, "i8", ALLOC_STATIC);
__str7550=allocate([67,76,65,85,83,69,32,37,120,58,10,0] /* CLAUSE %x:\0A\00 */, "i8", ALLOC_STATIC);
__str8551=allocate([69,78,68,67,76,65,85,83,69,10,0] /* ENDCLAUSE\0A\00 */, "i8", ALLOC_STATIC);
__ZL16max_clause_pause=allocate(1, "i32", ALLOC_STATIC);
__ZL13option_sayas2=allocate(1, "i32", ALLOC_STATIC);
__ZL18count_sayas_digits=allocate(1, "i32", ALLOC_STATIC);
__ZL6breaks=allocate([95, 0, 0, 0], ["i16",0,"i16",0], ALLOC_STATIC);
__ZL13word_emphasis_b=allocate(1, "i1", ALLOC_STATIC);
__ZL15option_emphasis=allocate(1, "i32", ALLOC_STATIC);
__ZL13embedded_flag_b=allocate(1, "i1", ALLOC_STATIC);
__str9552=allocate([87,79,82,68,58,32,102,108,103,61,37,46,53,120,32,108,101,110,61,37,100,32,32,39,0] /* WORD: flg=%.5x len=% */, "i8", ALLOC_STATIC);
__str10553=allocate([39,10,0] /* '\0A\00 */, "i8", ALLOC_STATIC);
__str11554=allocate([95,94,95,0] /* _^_\00 */, "i8", ALLOC_STATIC);
__ZZL13TranslateCharP10TranslatorPcijjPiE20hangul_compatibility=allocate([0,0,1,170,2,172,173,3,4,5,176,177,178,179,180,180,182,6,7,8,185,9,10,188,12,13,14,15,16,17,18,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117] /* \00\00\01\AA\02\AC\A */, "i8", ALLOC_STATIC);
__ZZL14SubstituteCharP10TranslatorjjPiE11ignore_next_b=allocate(1, "i1", ALLOC_STATIC);
__str12555=allocate([80,83,65,82,72,84,73,86,89,77,85,66,70,0] /* PSARHTIVYMUBF\00 */, "i8", ALLOC_STATIC);
__ZL14length_mods_en=allocate([100,120,100,105,100,110,110,100,95,100,105,120,105,110,125,130,135,115,125,100,105,120,75,100,75,105,120,85,75,100,105,120,85,105,95,115,120,100,95,100,110,120,95,105,100,115,120,100,100,100,105,120,100,105,95,115,120,110,95,100,105,120,100,105,105,122,125,110,105,100,105,120,100,105,105,122,125,110,105,100,105,120,95,105,100,115,120,110,100,100,100,120,100,100,100,100,100,100,100,100] /* dxdidnnd_dixin}\82\8 */, "i8", ALLOC_STATIC);
__ZL15length_mods_en0=allocate([100,150,100,105,110,115,110,110,110,100,105,150,105,110,125,135,140,115,135,100,105,150,90,105,90,122,135,100,90,100,105,150,100,105,100,122,135,100,100,100,105,150,100,105,105,115,135,110,105,100,105,150,100,105,105,122,130,120,125,100,105,150,100,105,110,122,125,115,110,100,105,150,100,105,105,122,135,120,105,100,105,150,100,105,105,115,135,110,105,100,100,100,100,100,100,100,100,100,100,100] /* d\96dinsnnndi\96in}\ */, "i8", ALLOC_STATIC);
__ZL17length_mods_equal=allocate([110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110,110] /* nnnnnnnnnnnnnnnnnnnn */, "i8", ALLOC_STATIC);
__str580=allocate([35,10,0] /* #\0A\00 */, "i8", ALLOC_STATIC);
__str1581=allocate([117,110,97,98,108,101,32,116,111,32,103,101,116,32,46,119,97,118,32,104,101,97,100,101,114,32,102,114,111,109,32,109,98,114,111,108,97,0] /* unable to get .wav h */, "i8", ALLOC_STATIC);
__str2582=allocate([82,73,70,70,0] /* RIFF\00 */, "i8", ALLOC_STATIC);
__str3583=allocate([87,65,86,69,102,109,116,32,0] /* WAVEfmt \00 */, "i8", ALLOC_STATIC);
__str4584=allocate([109,98,114,111,108,97,32,100,105,100,32,110,111,116,32,114,101,116,117,114,110,32,97,32,46,119,97,118,32,104,101,97,100,101,114,0] /* mbrola did not retur */, "i8", ALLOC_STATIC);
__ZL14mbr_samplerate=allocate(1, "i32", ALLOC_STATIC);
__ZL14mbr_voice_path=allocate(1, "i8*", ALLOC_STATIC);
__ZL10mbr_volume=allocate([1], ["float",0,0,0,0], ALLOC_STATIC);
__ZL9mbr_state=allocate(1, "i32", ALLOC_STATIC);
__ZL7mbr_pid=allocate(1, "i32", ALLOC_STATIC);
__ZL10mbr_cmd_fd=allocate(1, "i32", ALLOC_STATIC);
__str5585=allocate([10,35,10,0] /* \0A#\0A\00 */, "i8", ALLOC_STATIC);
__ZL12mbr_audio_fd=allocate(1, "i32", ALLOC_STATIC);
__ZL12mbr_errorbuf=allocate(160, "i8", ALLOC_STATIC);
__ZL12mbr_error_fd=allocate(1, "i32", ALLOC_STATIC);
__str7587=allocate([114,101,97,100,40,101,114,114,111,114,41,58,32,37,115,0] /* read(error): %s\00 */, "i8", ALLOC_STATIC);
__str8588=allocate([71,111,116,32,97,32,114,101,115,101,116,32,115,105,103,110,97,108,0] /* Got a reset signal\0 */, "i8", ALLOC_STATIC);
__str9589=allocate([73,110,112,117,116,32,70,108,117,115,104,32,83,105,103,110,97,108,0] /* Input Flush Signal\0 */, "i8", ALLOC_STATIC);
__str10590=allocate([109,98,114,111,108,97,58,32,37,115,0] /* mbrola: %s\00 */, "i8", ALLOC_STATIC);
__str11591=allocate([109,98,114,111,108,97,32,99,108,111,115,101,100,32,115,116,100,101,114,114,32,97,110,100,32,100,105,100,32,110,111,116,32,101,120,105,116,0] /* mbrola closed stderr */, "i8", ALLOC_STATIC);
__str12592=allocate([119,97,105,116,112,105,100,40,41,32,105,115,32,99,111,110,102,117,115,101,100,0] /* waitpid() is confuse */, "i8", ALLOC_STATIC);
__str13593=allocate([109,98,114,111,108,97,32,100,105,101,100,32,98,121,32,115,105,103,110,97,108,32,37,100,0] /* mbrola died by signa */, "i8", ALLOC_STATIC);
__str14594=allocate([109,98,114,111,108,97,32,101,120,105,116,101,100,32,119,105,116,104,32,115,116,97,116,117,115,32,37,100,0] /* mbrola exited with s */, "i8", ALLOC_STATIC);
__str15595=allocate([109,98,114,111,108,97,32,100,105,101,100,32,97,110,100,32,119,97,105,116,32,115,116,97,116,117,115,32,105,115,32,119,101,105,114,100,0] /* mbrola died and wait */, "i8", ALLOC_STATIC);
__str16596=allocate([109,98,114,111,119,114,97,112,32,101,114,114,111,114,58,32,37,115,0] /* mbrowrap error: %s\0 */, "i8", ALLOC_STATIC);
__str17597=allocate([44,32,40,37,115,41,0] /* , (%s)\00 */, "i8", ALLOC_STATIC);
__ZL21mbr_pending_data_head=allocate(1, "%struct.datablock*", ALLOC_STATIC);
__ZL21mbr_pending_data_tail=allocate(1, "%struct.datablock*", ALLOC_STATIC);
__str18598=allocate([112,111,108,108,40,41,58,32,37,115,0] /* poll(): %s\00 */, "i8", ALLOC_STATIC);
__str19599=allocate([109,98,114,111,108,97,32,112,114,111,99,101,115,115,32,105,115,32,115,116,97,108,108,101,100,0] /* mbrola process is st */, "i8", ALLOC_STATIC);
__str20600=allocate([119,114,105,116,101,40,41,58,32,37,115,0] /* write(): %s\00 */, "i8", ALLOC_STATIC);
__str21601=allocate([114,101,97,100,40,41,58,32,37,115,0] /* read(): %s\00 */, "i8", ALLOC_STATIC);
__ZL13mbr_proc_stat=allocate(1, "i32", ALLOC_STATIC);
__str22602=allocate([109,98,114,111,108,97,32,105,110,105,116,32,114,101,113,117,101,115,116,32,119,104,101,110,32,97,108,114,101,97,100,121,32,105,110,105,116,105,97,108,105,122,101,100,0] /* mbrola init request  */, "i8", ALLOC_STATIC);
__str23603=allocate([102,111,114,107,40,41,58,32,37,115,0] /* fork(): %s\00 */, "i8", ALLOC_STATIC);
__str24604=allocate([100,117,112,50,40,41,58,32,37,115,10,0] /* dup2(): %s\0A\00 */, "i8", ALLOC_STATIC);
__str25605=allocate([37,103,0] /* %g\00 */, "i8", ALLOC_STATIC);
__str27607=allocate([45,101,0] /* -e\00 */, "i8", ALLOC_STATIC);
__str28608=allocate([45,118,0] /* -v\00 */, "i8", ALLOC_STATIC);
__str30610=allocate([45,46,119,97,118,0] /* -.wav\00 */, "i8", ALLOC_STATIC);
__str31611=allocate([109,98,114,111,108,97,58,32,37,115,10,0] /* mbrola: %s\0A\00 */, "i8", ALLOC_STATIC);
__str32612=allocate([47,112,114,111,99,47,37,100,47,115,116,97,116,0] /* /proc/%d/stat\00 */, "i8", ALLOC_STATIC);
__str33613=allocate([47,112,114,111,99,32,105,115,32,117,110,97,99,99,101,115,115,105,98,108,101,58,32,37,115,0] /* /proc is unaccessibl */, "i8", ALLOC_STATIC);
__str34614=allocate([102,99,110,116,108,40,41,58,32,37,115,0] /* fcntl(): %s\00 */, "i8", ALLOC_STATIC);
__str35615=allocate([112,105,112,101,40,41,58,32,37,115,0] /* pipe(): %s\00 */, "i8", ALLOC_STATIC);
__ZZ15SetIndicLettersP10TranslatorE15dev_consonants2=allocate([2,3,88,89,90,91,92,93,94,95] /* \02\03XYZ[\5C]^_ */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_fr=allocate([190, 0, 170, 0, 190, 0, 200, 0, 0, 0, 0, 0, 190, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_fr=allocate([18,16,18,18,18,18,18,18] /* \12\10\12\12\12\12\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sk=allocate([17,17,20,20,20,22,22,21] /* \11\11\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sk=allocate([190, 0, 190, 0, 210, 0, 210, 0, 0, 0, 0, 0, 210, 0, 210, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_ta=allocate([200, 0, 200, 0, 210, 0, 210, 0, 0, 0, 0, 0, 230, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_ta=allocate([18,18,18,18,20,20,22,22] /* \12\12\12\12\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_af=allocate([170, 0, 140, 0, 220, 0, 220, 0, 0, 0, 0, 0, 250, 0, 270, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_bn=allocate([180, 0, 180, 0, 210, 0, 210, 0, 0, 0, 0, 0, 230, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_bn=allocate([18,18,18,18,20,20,22,22] /* \12\12\12\12\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_cy=allocate([170, 0, 220, 0, 180, 0, 180, 0, 0, 0, 0, 0, 250, 0, 270, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_cy=allocate([17,15,18,18,0,0,22,20] /* \11\0F\12\12\00\00\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_da=allocate([160, 0, 140, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_de=allocate([150, 0, 130, 0, 200, 0, 200, 0, 0, 0, 0, 0, 270, 0, 270, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_de=allocate([20,20,20,20,20,22,22,20] /* \14\14\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_en=allocate([182, 0, 140, 0, 220, 0, 220, 0, 0, 0, 0, 0, 248, 0, 275, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str630=allocate([97,101,105,111,117,121,0] /* aeiouy\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_el=allocate([155, 0, 180, 0, 210, 0, 210, 0, 0, 0, 0, 0, 270, 0, 300, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_el=allocate([15,12,20,20,20,22,22,21] /* \0F\0C\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9el_vowels=allocate([16,44,45,46,47,48,49,53,55,57,63,69,73,74,75,76,77,78,79,0] /* \10,-./01579?EIJKLMN */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE10el_fvowels=allocate([45,46,47,53,55,57,69,77,0] /* -./579EM\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE12el_voiceless=allocate([56,58,62,64,66,67,68,70,71,0] /* 8:>@BCDFG\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE13el_consonants=allocate([50,51,52,54,56,58,59,60,61,62,64,65,66,67,68,70,71,72,0] /* 23468:;<=>@ABCDFGH\0 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE18el_char_apostrophe=allocate([963, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_eo=allocate([150, 0, 150, 0, 230, 0, 180, 0, 0, 0, 0, 0, 300, 0, 320, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_eo=allocate([16,14,20,20,20,22,22,21] /* \10\0E\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE18eo_char_apostrophe=allocate([108, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_es=allocate([180, 0, 210, 0, 190, 0, 190, 0, 0, 0, 0, 0, 230, 0, 260, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_es=allocate([16,12,18,18,20,20,20,20] /* \10\0C\12\12\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE20ca_punct_within_word=allocate([39, 0, 0, 0, 183, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_eu=allocate([200, 0, 200, 0, 200, 0, 200, 0, 0, 0, 0, 0, 210, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_eu=allocate([16,16,18,18,18,18,18,18] /* \10\10\12\12\12\12\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_fi=allocate([18,16,22,22,20,22,22,22] /* \12\10\16\16\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_fi=allocate([150, 0, 180, 0, 200, 0, 200, 0, 0, 0, 0, 0, 210, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hi=allocate([190, 0, 190, 0, 210, 0, 210, 0, 0, 0, 0, 0, 230, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_hi=allocate([17,14,20,19,20,22,22,21] /* \11\0E\14\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_hr=allocate([17,17,20,20,20,22,22,21] /* \11\11\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hr=allocate([180, 0, 160, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sr=allocate([160, 0, 150, 0, 200, 0, 200, 0, 0, 0, 0, 0, 250, 0, 260, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZL22replace_cyrillic_latin=allocate([1072, 0, 0, 0, 97, 0, 0, 0, 1073, 0, 0, 0, 98, 0, 0, 0, 1094, 0, 0, 0, 99, 0, 0, 0, 1115, 0, 0, 0, 263, 0, 0, 0, 1095, 0, 0, 0, 269, 0, 0, 0, 1119, 0, 0, 0, 25034852, 0, 0, 0, 1109, 0, 0, 0, 7995492, 0, 0, 0, 1076, 0, 0, 0, 100, 0, 0, 0, 1106, 0, 0, 0, 273, 0, 0, 0, 1077, 0, 0, 0, 101, 0, 0, 0, 1092, 0, 0, 0, 102, 0, 0, 0, 1075, 0, 0, 0, 103, 0, 0, 0, 1093, 0, 0, 0, 104, 0, 0, 0, 1080, 0, 0, 0, 105, 0, 0, 0, 1112, 0, 0, 0, 106, 0, 0, 0, 1082, 0, 0, 0, 107, 0, 0, 0, 1113, 0, 0, 0, 6946924, 0, 0, 0, 1083, 0, 0, 0, 108, 0, 0, 0, 1084, 0, 0, 0, 109, 0, 0, 0, 1114, 0, 0, 0, 6946926, 0, 0, 0, 1085, 0, 0, 0, 110, 0, 0, 0, 1086, 0, 0, 0, 111, 0, 0, 0, 1087, 0, 0, 0, 112, 0, 0, 0, 1088, 0, 0, 0, 114, 0, 0, 0, 1089, 0, 0, 0, 115, 0, 0, 0, 1096, 0, 0, 0, 353, 0, 0, 0, 1090, 0, 0, 0, 116, 0, 0, 0, 1091, 0, 0, 0, 117, 0, 0, 0, 1074, 0, 0, 0, 118, 0, 0, 0, 1079, 0, 0, 0, 122, 0, 0, 0, 1078, 0, 0, 0, 382, 0, 0, 0, 1107, 0, 0, 0, 273, 0, 0, 0, 1116, 0, 0, 0, 263, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_hu=allocate([17,17,19,19,20,22,22,21] /* \11\11\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hu=allocate([185, 0, 195, 0, 195, 0, 190, 0, 0, 0, 0, 0, 210, 0, 220, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_hy=allocate([250, 0, 200, 0, 250, 0, 250, 0, 0, 0, 0, 0, 250, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9hy_vowels=allocate([49,53,55,56,59,72,85,0] /* 1578;HU\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE13hy_consonants=allocate([50,51,52,54,57,58,60,61,62,63,64,65,66,67,68,69,70,71,73,74,75,76,77,78,79,80,81,82,83,84,86,0] /* 23469:<=>?@ABCDEFGIJ */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_id=allocate([160, 0, 200, 0, 180, 0, 180, 0, 0, 0, 0, 0, 220, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_id=allocate([16,18,18,18,20,22,22,21] /* \10\12\12\12\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_is=allocate([180, 0, 160, 0, 200, 0, 200, 0, 0, 0, 0, 0, 240, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE16is_lettergroup_B=allocate([99, 0, 0, 0, 102, 0, 0, 0, 104, 0, 0, 0, 107, 0, 0, 0, 112, 0, 0, 0, 116, 0, 0, 0, 120, 0, 0, 0, 254, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str1631=allocate([107,112,115,116,0] /* kpst\00 */, "i8", ALLOC_STATIC);
__str2632=allocate([106,118,114,0] /* jvr\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_it=allocate([150, 0, 140, 0, 170, 0, 170, 0, 0, 0, 0, 0, 300, 0, 330, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_it=allocate([15,14,19,19,20,22,22,20] /* \0F\0E\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE18stress_lengths_jbo=allocate([145, 0, 145, 0, 170, 0, 160, 0, 0, 0, 0, 0, 330, 0, 350, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE21jbo_punct_within_word=allocate([46, 0, 0, 0, 44, 0, 0, 0, 39, 0, 0, 0, 712, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9ka_vowels=allocate([80,84,88,93,99,117,119,0] /* PTX]cuw\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE13ka_consonants=allocate([81,82,83,85,86,87,89,90,91,92,94,95,96,97,98,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,118,0] /* QRSUVWYZ[\5C^_`abdef */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE10ko_ivowels=allocate([99,100,103,104,109,114,116,117,0] /* cdghmrtu\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9ko_voiced=allocate([2,5,6,171,175,183,188,0] /* \02\05\06\AB\AF\B7\B */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_ku=allocate([18,18,20,20,20,22,22,21] /* \12\12\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_ku=allocate([180, 0, 180, 0, 190, 0, 180, 0, 0, 0, 0, 0, 230, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_lv=allocate([17,13,20,20,20,22,22,21] /* \11\0D\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_lv=allocate([180, 0, 130, 0, 210, 0, 210, 0, 0, 0, 0, 0, 210, 0, 210, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE15vowels_cyrillic=allocate([1088, 0, 0, 0, 1072, 0, 0, 0, 1077, 0, 0, 0, 1080, 0, 0, 0, 1081, 0, 0, 0, 1086, 0, 0, 0, 1091, 0, 0, 0, 1099, 0, 0, 0, 1101, 0, 0, 0, 1102, 0, 0, 0, 1103, 0, 0, 0, 1104, 0, 0, 0, 1105, 0, 0, 0, 1110, 0, 0, 0, 1111, 0, 0, 0, 1117, 0, 0, 0, 1118, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_mk=allocate([17,17,20,20,20,22,22,21] /* \11\11\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_mk=allocate([180, 0, 160, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_nl=allocate([160, 0, 135, 0, 210, 0, 210, 0, 0, 0, 0, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__str3633=allocate([101,0] /* e\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_no=allocate([160, 0, 140, 0, 200, 0, 200, 0, 0, 0, 0, 0, 220, 0, 230, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_om=allocate([18,15,20,20,20,22,22,22] /* \12\0F\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_om=allocate([200, 0, 200, 0, 200, 0, 200, 0, 0, 0, 0, 0, 200, 0, 200, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_pl=allocate([160, 0, 190, 0, 175, 0, 175, 0, 0, 0, 0, 0, 200, 0, 210, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_pl=allocate([17,13,19,19,20,22,22,21] /* \11\0D\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_pt=allocate([170, 0, 115, 0, 210, 0, 240, 0, 0, 0, 0, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_pt=allocate([16,11,19,21,20,22,22,21] /* \10\0B\13\15\14\16\1 */, "i8", ALLOC_STATIC);
__str4634=allocate([98,99,100,102,103,106,107,109,110,112,113,115,116,118,120,122,0] /* bcdfgjkmnpqstvxz\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_ro=allocate([170, 0, 170, 0, 180, 0, 180, 0, 0, 0, 0, 0, 240, 0, 260, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_ro=allocate([15,13,18,18,20,22,22,21] /* \0F\0D\12\12\14\16\1 */, "i8", ALLOC_STATIC);
__str5635=allocate([98,100,103,106,108,109,110,114,118,119,122,97,101,105,111,117,121,0] /* bdgjlmnrvwzaeiouy\00 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sq=allocate([150, 0, 150, 0, 180, 0, 180, 0, 0, 0, 0, 0, 300, 0, 300, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sq=allocate([16,12,16,16,20,20,21,19] /* \10\0C\10\10\14\14\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sv=allocate([16,16,20,20,20,22,22,21] /* \10\10\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sv=allocate([160, 0, 135, 0, 220, 0, 220, 0, 0, 0, 0, 0, 250, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_sw=allocate([160, 0, 170, 0, 200, 0, 200, 0, 0, 0, 0, 0, 320, 0, 340, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_sw=allocate([16,12,19,19,20,22,22,21] /* \10\0C\13\13\14\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_tr=allocate([18,16,20,21,20,21,21,20] /* \12\10\14\15\14\15\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_tr=allocate([190, 0, 180, 0, 200, 0, 230, 0, 0, 0, 0, 0, 240, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_vi=allocate([150, 0, 150, 0, 180, 0, 180, 0, 210, 0, 230, 0, 230, 0, 240, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_vi=allocate([16,16,16,16,22,22,22,22] /* \10\10\10\10\16\16\1 */, "i8", ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE9vowels_vi=allocate([97, 0, 0, 0, 224, 0, 0, 0, 225, 0, 0, 0, 7843, 0, 0, 0, 227, 0, 0, 0, 7841, 0, 0, 0, 259, 0, 0, 0, 7857, 0, 0, 0, 7855, 0, 0, 0, 7859, 0, 0, 0, 7861, 0, 0, 0, 7863, 0, 0, 0, 226, 0, 0, 0, 7847, 0, 0, 0, 7845, 0, 0, 0, 7849, 0, 0, 0, 7851, 0, 0, 0, 7853, 0, 0, 0, 101, 0, 0, 0, 232, 0, 0, 0, 233, 0, 0, 0, 7867, 0, 0, 0, 7869, 0, 0, 0, 7865, 0, 0, 0, 234, 0, 0, 0, 7873, 0, 0, 0, 7871, 0, 0, 0, 7875, 0, 0, 0, 7877, 0, 0, 0, 7879, 0, 0, 0, 105, 0, 0, 0, 236, 0, 0, 0, 237, 0, 0, 0, 7881, 0, 0, 0, 297, 0, 0, 0, 7883, 0, 0, 0, 111, 0, 0, 0, 242, 0, 0, 0, 243, 0, 0, 0, 7887, 0, 0, 0, 245, 0, 0, 0, 7885, 0, 0, 0, 244, 0, 0, 0, 7891, 0, 0, 0, 7889, 0, 0, 0, 7893, 0, 0, 0, 7895, 0, 0, 0, 7897, 0, 0, 0, 417, 0, 0, 0, 7901, 0, 0, 0, 7899, 0, 0, 0, 7903, 0, 0, 0, 7905, 0, 0, 0, 7907, 0, 0, 0, 117, 0, 0, 0, 249, 0, 0, 0, 250, 0, 0, 0, 7911, 0, 0, 0, 361, 0, 0, 0, 7909, 0, 0, 0, 432, 0, 0, 0, 7915, 0, 0, 0, 7913, 0, 0, 0, 7917, 0, 0, 0, 7919, 0, 0, 0, 7921, 0, 0, 0, 121, 0, 0, 0, 7923, 0, 0, 0, 253, 0, 0, 0, 7927, 0, 0, 0, 7929, 0, 0, 0, 30, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE17stress_lengths_zh=allocate([230, 0, 150, 0, 230, 0, 230, 0, 230, 0, 0, 0, 240, 0, 250, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ16SelectTranslatorPKcE14stress_amps_zh=allocate([22,16,22,22,22,22,22,22] /* \16\10\16\16\16\16\1 */, "i8", ALLOC_STATIC);
__ZZL18Translator_RussianP10TranslatorE14stress_amps_ru=allocate([16,16,18,18,20,24,24,22] /* \10\10\12\12\14\18\1 */, "i8", ALLOC_STATIC);
__ZZL18Translator_RussianP10TranslatorE17stress_lengths_ru=allocate([150, 0, 140, 0, 220, 0, 220, 0, 0, 0, 0, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL18Translator_RussianP10TranslatorE11ru_ivowels2=allocate([44,21,24,46,47,0] /* ,\15\18./\00 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE9ru_vowels=allocate([16,21,49,24,30,35,43,45,46,47,0] /* \10\151\18\1E#+-./\0 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE13ru_consonants=allocate([17,18,19,20,22,23,25,26,27,28,29,31,32,33,34,36,37,38,39,40,41,42,44,0] /* \11\12\13\14\16\17\1 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE7ru_soft=allocate([44,25,39,41,0] /* ,\19')\00 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE7ru_hard=allocate([42,22,38,40,0] /* _\16&(\00 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE10ru_nothard=allocate([17,18,19,20,23,25,26,27,28,29,31,32,33,34,36,37,39,41,44,0] /* \11\12\13\14\17\19\1 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE9ru_voiced=allocate([17,18,19,20,22,23,0] /* \11\12\13\14\16\17\0 */, "i8", ALLOC_STATIC);
__ZZL18SetCyrillicLettersP10TranslatorE10ru_ivowels=allocate([44,46,47,49,0] /* ,./1\00 */, "i8", ALLOC_STATIC);
__ZL8pairs_ru=allocate([268, 0, 270, 0, 275, 0, 769, 0, 783, 0, 1550, 0, 1553, 0, 2307, 0, 2817, 0, 2831, 0, 3073, 0, 3081, 0, 3585, 0, 3590, 0, 3593, 0, 3598, 0, 3599, 0, 3612, 0, 3843, 0, 3857, 0, 3858, 0, 4111, 0, 4113, 0, 4353, 0, 4358, 0, 4361, 0, 4367, 0, 4627, 0, 4640, 0, 32767, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL13NewTranslatorvE12stress_amps2=allocate([18,18,20,20,20,22,22,20] /* \12\12\14\14\14\16\1 */, "i8", ALLOC_STATIC);
__ZZL13NewTranslatorvE15stress_lengths2=allocate([182, 0, 140, 0, 220, 0, 220, 0, 220, 0, 240, 0, 260, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL13NewTranslatorvE13empty_wstring=allocate(4, "i32", ALLOC_STATIC);
__ZZL13NewTranslatorvE13punct_in_word=allocate([39, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZL13NewTranslatorvE13default_tunes=allocate([0,1,2,3,0,0] /* \00\01\02\03\00\00 */, "i8", ALLOC_STATIC);
__str6636=allocate([97,101,105,111,117,0] /* aeiou\00 */, "i8", ALLOC_STATIC);
__str7637=allocate([98,99,100,102,103,106,107,108,109,110,112,113,115,116,118,120,122,0] /* bcdfgjklmnpqstvxz\00 */, "i8", ALLOC_STATIC);
__str8638=allocate([98,99,100,102,103,104,106,107,108,109,110,112,113,114,115,116,118,119,120,122,0] /* bcdfghjklmnpqrstvwxz */, "i8", ALLOC_STATIC);
__str9639=allocate([104,108,109,110,114,0] /* hlmnr\00 */, "i8", ALLOC_STATIC);
__str10640=allocate([99,102,104,107,112,113,115,116,120,0] /* cfhkpqstx\00 */, "i8", ALLOC_STATIC);
__str11641=allocate([98,100,103,106,108,109,110,114,118,119,121,122,0] /* bdgjlmnrvwyz\00 */, "i8", ALLOC_STATIC);
__str12642=allocate([101,105,121,0] /* eiy\00 */, "i8", ALLOC_STATIC);
__str13643=allocate(1, "i8", ALLOC_STATIC);
__str646=allocate([117,110,107,110,111,119,110,0] /* unknown\00 */, "i8", ALLOC_STATIC);
__str1647=allocate([109,97,108,101,0] /* male\00 */, "i8", ALLOC_STATIC);
__str2648=allocate([102,101,109,97,108,101,0] /* female\00 */, "i8", ALLOC_STATIC);
_genders=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_tone_points=allocate([600, 0, 0, 0, 170, 0, 0, 0, 1200, 0, 0, 0, 135, 0, 0, 0, 2000, 0, 0, 0, 110, 0, 0, 0, 3000, 0, 0, 0, 110, 0, 0, 0, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_formant_rate=allocate(36, "i32", ALLOC_STATIC);
_voice_selected=allocate(24, ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__str3653=allocate([114,101,100,117,99,101,95,116,0] /* reduce_t\00 */, "i8", ALLOC_STATIC);
__str4654=allocate([98,114,97,99,107,101,116,0] /* bracket\00 */, "i8", ALLOC_STATIC);
__ZL11options_tab=allocate([0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, -1, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__str5655=allocate([110,97,109,101,0] /* name\00 */, "i8", ALLOC_STATIC);
__str6656=allocate([108,97,110,103,117,97,103,101,0] /* language\00 */, "i8", ALLOC_STATIC);
__str7657=allocate([103,101,110,100,101,114,0] /* gender\00 */, "i8", ALLOC_STATIC);
__str8658=allocate([102,111,114,109,97,110,116,0] /* formant\00 */, "i8", ALLOC_STATIC);
__str9659=allocate([112,105,116,99,104,0] /* pitch\00 */, "i8", ALLOC_STATIC);
__str10660=allocate([112,104,111,110,101,109,101,115,0] /* phonemes\00 */, "i8", ALLOC_STATIC);
__str11661=allocate([116,114,97,110,115,108,97,116,111,114,0] /* translator\00 */, "i8", ALLOC_STATIC);
__str12662=allocate([100,105,99,116,105,111,110,97,114,121,0] /* dictionary\00 */, "i8", ALLOC_STATIC);
__str13663=allocate([115,116,114,101,115,115,76,101,110,103,116,104,0] /* stressLength\00 */, "i8", ALLOC_STATIC);
__str14664=allocate([115,116,114,101,115,115,65,109,112,0] /* stressAmp\00 */, "i8", ALLOC_STATIC);
__str15665=allocate([115,116,114,101,115,115,65,100,100,0] /* stressAdd\00 */, "i8", ALLOC_STATIC);
__str16666=allocate([105,110,116,111,110,97,116,105,111,110,0] /* intonation\00 */, "i8", ALLOC_STATIC);
__str17667=allocate([116,117,110,101,115,0] /* tunes\00 */, "i8", ALLOC_STATIC);
__str18668=allocate([100,105,99,116,114,117,108,101,115,0] /* dictrules\00 */, "i8", ALLOC_STATIC);
__str19669=allocate([115,116,114,101,115,115,114,117,108,101,0] /* stressrule\00 */, "i8", ALLOC_STATIC);
__str20670=allocate([99,104,97,114,115,101,116,0] /* charset\00 */, "i8", ALLOC_STATIC);
__str21671=allocate([114,101,112,108,97,99,101,0] /* replace\00 */, "i8", ALLOC_STATIC);
__str22672=allocate([119,111,114,100,115,0] /* words\00 */, "i8", ALLOC_STATIC);
__str23673=allocate([101,99,104,111,0] /* echo\00 */, "i8", ALLOC_STATIC);
__str24674=allocate([102,108,117,116,116,101,114,0] /* flutter\00 */, "i8", ALLOC_STATIC);
__str25675=allocate([114,111,117,103,104,110,101,115,115,0] /* roughness\00 */, "i8", ALLOC_STATIC);
__str26676=allocate([99,108,97,114,105,116,121,0] /* clarity\00 */, "i8", ALLOC_STATIC);
__str27677=allocate([116,111,110,101,0] /* tone\00 */, "i8", ALLOC_STATIC);
__str28678=allocate([118,111,105,99,105,110,103,0] /* voicing\00 */, "i8", ALLOC_STATIC);
__str29679=allocate([98,114,101,97,116,104,0] /* breath\00 */, "i8", ALLOC_STATIC);
__str30680=allocate([98,114,101,97,116,104,119,0] /* breathw\00 */, "i8", ALLOC_STATIC);
__str31681=allocate([110,117,109,98,101,114,115,0] /* numbers\00 */, "i8", ALLOC_STATIC);
__str32682=allocate([111,112,116,105,111,110,0] /* option\00 */, "i8", ALLOC_STATIC);
__str33683=allocate([109,98,114,111,108,97,0] /* mbrola\00 */, "i8", ALLOC_STATIC);
__str34684=allocate([99,111,110,115,111,110,97,110,116,115,0] /* consonants\00 */, "i8", ALLOC_STATIC);
__str35685=allocate([107,108,97,116,116,0] /* klatt\00 */, "i8", ALLOC_STATIC);
__str36686=allocate([102,97,115,116,95,116,101,115,116,50,0] /* fast_test2\00 */, "i8", ALLOC_STATIC);
__str37687=allocate([115,112,101,101,100,0] /* speed\00 */, "i8", ALLOC_STATIC);
__str38688=allocate([108,95,100,105,101,114,101,115,105,115,0] /* l_dieresis\00 */, "i8", ALLOC_STATIC);
__str39689=allocate([108,95,112,114,101,102,105,120,0] /* l_prefix\00 */, "i8", ALLOC_STATIC);
__str40690=allocate([108,95,114,101,103,114,101,115,115,105,118,101,95,118,0] /* l_regressive_v\00 */, "i8", ALLOC_STATIC);
__str41691=allocate([108,95,117,110,112,114,111,110,111,117,110,99,97,98,108,101,0] /* l_unpronouncable\00 */, "i8", ALLOC_STATIC);
__str42692=allocate([108,95,115,111,110,111,114,97,110,116,95,109,105,110,0] /* l_sonorant_min\00 */, "i8", ALLOC_STATIC);
__str43693=allocate([108,95,108,101,110,103,116,104,95,109,111,100,115,0] /* l_length_mods\00 */, "i8", ALLOC_STATIC);
__ZL11keyword_tab=allocate([0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 19, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 25, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 11, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 0, 0, 0, 13, 0, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0, 0, 0, 0, 0, 27, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 30, 0, 0, 0, 0, 0, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 257, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 260, 0, 0, 0, 0, 0, 0, 0, 261, 0, 0, 0, 0, 0, 0, 0, 263, 0, 0, 0, 0, 0, 0, 0, 262, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL15variants_either=allocate([1,2,12,3,13,4,14,5,11,0,0,0] /* \01\02\0C\03\0D\04\0 */, "i8", ALLOC_STATIC);
__ZL13variants_male=allocate([1,2,3,4,5,0,0,0,0,0,0,0] /* \01\02\03\04\05\00\0 */, "i8", ALLOC_STATIC);
__ZL15variants_female=allocate([11,12,13,14,0,0,0,0,0,0,0,0] /* \0B\0C\0D\0E\00\00\0 */, "i8", ALLOC_STATIC);
_variant_lists=allocate(12, "i8*", ALLOC_STATIC);
__ZL9voicedata=allocate(1344, ["i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
_voice=allocate(1, "%struct.voice_t*", ALLOC_STATIC);
__str44696=allocate([37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d %d %d %d */, "i8", ALLOC_STATIC);
__ZZ10VoiceResetiE15default_heights=allocate([128,128,120,120,110,110,128,128,128] /* \80\80xxnn\80\80\80 */, "i8", ALLOC_STATIC);
__ZZ10VoiceResetiE14default_widths=allocate([128,128,128,160,171,171,128,128,128] /* \80\80\80\A0\AB\AB\8 */, "i8", ALLOC_STATIC);
__ZZ10VoiceResetiE13breath_widths=allocate([0, 0, 0, 0, 200, 0, 0, 0, 200, 0, 0, 0, 400, 0, 0, 0, 400, 0, 0, 0, 400, 0, 0, 0, 600, 0, 0, 0, 600, 0, 0, 0, 600, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL18formant_rate_22050=allocate([240, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0, 170, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ9LoadVoicePKciE16voice_identifier=allocate(40, "i8", ALLOC_STATIC);
__ZZ9LoadVoicePKciE10voice_name=allocate(40, "i8", ALLOC_STATIC);
__ZZ9LoadVoicePKciE15voice_languages=allocate(100, "i8", ALLOC_STATIC);
__str45697=allocate([100,101,102,97,117,108,116,0] /* default\00 */, "i8", ALLOC_STATIC);
__str46698=allocate([37,115,37,99,118,111,105,99,101,115,37,99,0] /* %s%cvoices%c\00 */, "i8", ALLOC_STATIC);
__str47699=allocate([37,115,37,115,0] /* %s%s\00 */, "i8", ALLOC_STATIC);
__str48700=allocate([37,115,37,115,37,99,37,115,0] /* %s%s%c%s\00 */, "i8", ALLOC_STATIC);
__str49701=allocate([37,115,101,120,116,114,97,37,99,37,115,0] /* %sextra%c%s\00 */, "i8", ALLOC_STATIC);
__str50702=allocate([37,115,116,101,115,116,37,99,37,115,0] /* %stest%c%s\00 */, "i8", ALLOC_STATIC);
__str51703=allocate([114,0] /* r\00 */, "i8", ALLOC_STATIC);
__str52704=allocate([101,110,0] /* en\00 */, "i8", ALLOC_STATIC);
__str53705=allocate([43,37,115,0] /* +%s\00 */, "i8", ALLOC_STATIC);
__str54706=allocate([37,115,32,37,100,0] /* %s %d\00 */, "i8", ALLOC_STATIC);
__str55707=allocate([118,97,114,105,97,110,116,0] /* variant\00 */, "i8", ALLOC_STATIC);
__str56708=allocate([45,0] /* -\00 */, "i8", ALLOC_STATIC);
__str57709=allocate([37,115,0] /* %s\00 */, "i8", ALLOC_STATIC);
__str58710=allocate([37,100,32,37,100,0] /* %d %d\00 */, "i8", ALLOC_STATIC);
__str59711=allocate([37,115,32,37,115,32,37,115,32,37,115,32,37,115,32,37,115,0] /* %s %s %s %s %s %s\00 */, "i8", ALLOC_STATIC);
__str60712=allocate([78,85,76,76,0] /* NULL\00 */, "i8", ALLOC_STATIC);
__str61713=allocate([85,110,107,110,111,119,110,32,116,117,110,101,32,39,37,115,39,10,0] /* Unknown tune '%s'\0A */, "i8", ALLOC_STATIC);
__str62714=allocate([37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d\00 */, "i8", ALLOC_STATIC);
__str63715=allocate([37,100,0] /* %d\00 */, "i8", ALLOC_STATIC);
__str64716=allocate([37,115,32,37,100,32,37,100,0] /* %s %d %d\00 */, "i8", ALLOC_STATIC);
__str65717=allocate([66,97,100,32,118,111,105,99,101,32,111,112,116,105,111,110,58,32,37,115,32,37,115,10,0] /* Bad voice option: %s */, "i8", ALLOC_STATIC);
__str66718=allocate([37,115,32,37,115,32,37,100,0] /* %s %s %d\00 */, "i8", ALLOC_STATIC);
__str67719=allocate([109,98,114,111,108,97,32,118,111,105,99,101,32,110,111,116,32,102,111,117,110,100,10,0] /* mbrola voice not fou */, "i8", ALLOC_STATIC);
__str68720=allocate([66,97,100,32,118,111,105,99,101,32,97,116,116,114,105,98,117,116,101,58,32,37,115,10,0] /* Bad voice attribute: */, "i8", ALLOC_STATIC);
__str69721=allocate([85,110,107,110,111,119,110,32,112,104,111,110,101,109,101,32,116,97,98,108,101,58,32,39,37,115,39,10,0] /* Unknown phoneme tabl */, "i8", ALLOC_STATIC);
__ZL13n_voices_list=allocate(1, "i32", ALLOC_STATIC);
__ZL11voices_list=allocate(600, "%struct.espeak_VOICE*", ALLOC_STATIC);
__str70722=allocate([37,99,37,115,0] /* %c%s\00 */, "i8", ALLOC_STATIC);
__ZZ11SelectVoiceP12espeak_VOICEPiE14voice_variants=allocate(288, ["i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8*",0,0,0,"i8","i8","i8","i8","i32",0,0,0,"i8*",0,0,0], ALLOC_STATIC);
__ZZ11SelectVoiceP12espeak_VOICEPiE8voice_id=allocate(50, "i8", ALLOC_STATIC);
__ZZ11SelectVoiceP12espeak_VOICEPiE3buf=allocate(60, "i8", ALLOC_STATIC);
__str71723=allocate([37,115,43,37,115,0] /* %s+%s\00 */, "i8", ALLOC_STATIC);
__ZZ14SetVoiceByNamePKcE3buf=allocate(60, "i8", ALLOC_STATIC);
__ZZ17espeak_ListVoicesE6voices=allocate(600, "%struct.espeak_VOICE*", ALLOC_STATIC);
__str72724=allocate([37,115,37,99,118,111,105,99,101,115,0] /* %s%cvoices\00 */, "i8", ALLOC_STATIC);
__ZL15len_path_voices=allocate(1, "i32", ALLOC_STATIC);
__str73725=allocate([109,98,47,0] /* mb/\00 */, "i8", ALLOC_STATIC);
__str74726=allocate([37,115,37,99,37,115,0] /* %s%c%s\00 */, "i8", ALLOC_STATIC);
__str75727=allocate([118,97,114,105,97,110,116,115,0] /* variants\00 */, "i8", ALLOC_STATIC);
__ZZL23ExtractVoiceVariantNamePciE12variant_name=allocate(20, "i8", ALLOC_STATIC);
__str76728=allocate([33,118,37,99,0] /* !v%c\00 */, "i8", ALLOC_STATIC);
__str77729=allocate([37,115,109,37,100,0] /* %sm%d\00 */, "i8", ALLOC_STATIC);
__str78730=allocate([37,115,102,37,100,0] /* %sf%d\00 */, "i8", ALLOC_STATIC);
__str79731=allocate([37,100,32,37,115,32,37,115,0] /* %d %s %s\00 */, "i8", ALLOC_STATIC);
__str80732=allocate([37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d %d %d %d */, "i8", ALLOC_STATIC);
__str81733=allocate([37,100,32,37,100,32,37,100,32,37,100,32,37,100,0] /* %d %d %d %d %d\00 */, "i8", ALLOC_STATIC);
__str82734=allocate([47,47,0] /* //\00 */, "i8", ALLOC_STATIC);
_sin_tab=allocate([0, 0, -25, 0, -50, 0, -75, 0, -100, 0, -125, 0, -150, 0, -175, 0, -201, 0, -226, 0, -251, 0, -276, 0, -301, 0, -326, 0, -351, 0, -376, 0, -401, 0, -427, 0, -452, 0, -477, 0, -502, 0, -527, 0, -552, 0, -577, 0, -602, 0, -627, 0, -652, 0, -677, 0, -702, 0, -727, 0, -752, 0, -777, 0, -802, 0, -827, 0, -852, 0, -877, 0, -902, 0, -927, 0, -952, 0, -977, 0, -1002, 0, -1027, 0, -1052, 0, -1077, 0, -1102, 0, -1127, 0, -1152, 0, -1177, 0, -1201, 0, -1226, 0, -1251, 0, -1276, 0, -1301, 0, -1326, 0, -1350, 0, -1375, 0, -1400, 0, -1425, 0, -1449, 0, -1474, 0, -1499, 0, -1523, 0, -1548, 0, -1573, 0, -1597, 0, -1622, 0, -1647, 0, -1671, 0, -1696, 0, -1721, 0, -1745, 0, -1770, 0, -1794, 0, -1819, 0, -1843, 0, -1868, 0, -1892, 0, -1917, 0, -1941, 0, -1965, 0, -1990, 0, -2014, 0, -2038, 0, -2063, 0, -2087, 0, -2111, 0, -2136, 0, -2160, 0, -2184, 0, -2208, 0, -2233, 0, -2257, 0, -2281, 0, -2305, 0, -2329, 0, -2353, 0, -2377, 0, -2401, 0, -2425, 0, -2449, 0, -2473, 0, -2497, 0, -2521, 0, -2545, 0, -2569, 0, -2593, 0, -2617, 0, -2640, 0, -2664, 0, -2688, 0, -2712, 0, -2735, 0, -2759, 0, -2783, 0, -2806, 0, -2830, 0, -2853, 0, -2877, 0, -2900, 0, -2924, 0, -2947, 0, -2971, 0, -2994, 0, -3018, 0, -3041, 0, -3064, 0, -3088, 0, -3111, 0, -3134, 0, -3157, 0, -3180, 0, -3204, 0, -3227, 0, -3250, 0, -3273, 0, -3296, 0, -3319, 0, -3342, 0, -3365, 0, -3388, 0, -3410, 0, -3433, 0, -3456, 0, -3479, 0, -3502, 0, -3524, 0, -3547, 0, -3570, 0, -3592, 0, -3615, 0, -3637, 0, -3660, 0, -3682, 0, -3705, 0, -3727, 0, -3749, 0, -3772, 0, -3794, 0, -3816, 0, -3839, 0, -3861, 0, -3883, 0, -3905, 0, -3927, 0, -3949, 0, -3971, 0, -3993, 0, -4015, 0, -4037, 0, -4059, 0, -4080, 0, -4102, 0, -4124, 0, -4146, 0, -4167, 0, -4189, 0, -4211, 0, -4232, 0, -4254, 0, -4275, 0, -4296, 0, -4318, 0, -4339, 0, -4360, 0, -4382, 0, -4403, 0, -4424, 0, -4445, 0, -4466, 0, -4487, 0, -4508, 0, -4529, 0, -4550, 0, -4571, 0, -4592, 0, -4613, 0, -4633, 0, -4654, 0, -4675, 0, -4695, 0, -4716, 0, -4736, 0, -4757, 0, -4777, 0, -4798, 0, -4818, 0, -4838, 0, -4859, 0, -4879, 0, -4899, 0, -4919, 0, -4939, 0, -4959, 0, -4979, 0, -4999, 0, -5019, 0, -5039, 0, -5059, 0, -5078, 0, -5098, 0, -5118, 0, -5137, 0, -5157, 0, -5176, 0, -5196, 0, -5215, 0, -5235, 0, -5254, 0, -5273, 0, -5292, 0, -5311, 0, -5331, 0, -5350, 0, -5369, 0, -5388, 0, -5406, 0, -5425, 0, -5444, 0, -5463, 0, -5482, 0, -5500, 0, -5519, 0, -5537, 0, -5556, 0, -5574, 0, -5593, 0, -5611, 0, -5629, 0, -5648, 0, -5666, 0, -5684, 0, -5702, 0, -5720, 0, -5738, 0, -5756, 0, -5774, 0, -5791, 0, -5809, 0, -5827, 0, -5844, 0, -5862, 0, -5880, 0, -5897, 0, -5914, 0, -5932, 0, -5949, 0, -5966, 0, -5984, 0, -6001, 0, -6018, 0, -6035, 0, -6052, 0, -6069, 0, -6085, 0, -6102, 0, -6119, 0, -6136, 0, -6152, 0, -6169, 0, -6185, 0, -6202, 0, -6218, 0, -6235, 0, -6251, 0, -6267, 0, -6283, 0, -6299, 0, -6315, 0, -6331, 0, -6347, 0, -6363, 0, -6379, 0, -6395, 0, -6410, 0, -6426, 0, -6441, 0, -6457, 0, -6472, 0, -6488, 0, -6503, 0, -6518, 0, -6533, 0, -6549, 0, -6564, 0, -6579, 0, -6594, 0, -6608, 0, -6623, 0, -6638, 0, -6653, 0, -6667, 0, -6682, 0, -6696, 0, -6711, 0, -6725, 0, -6739, 0, -6754, 0, -6768, 0, -6782, 0, -6796, 0, -6810, 0, -6824, 0, -6838, 0, -6852, 0, -6865, 0, -6879, 0, -6893, 0, -6906, 0, -6920, 0, -6933, 0, -6946, 0, -6960, 0, -6973, 0, -6986, 0, -6999, 0, -7012, 0, -7025, 0, -7038, 0, -7051, 0, -7064, 0, -7076, 0, -7089, 0, -7101, 0, -7114, 0, -7126, 0, -7139, 0, -7151, 0, -7163, 0, -7175, 0, -7187, 0, -7199, 0, -7211, 0, -7223, 0, -7235, 0, -7247, 0, -7259, 0, -7270, 0, -7282, 0, -7293, 0, -7305, 0, -7316, 0, -7327, 0, -7338, 0, -7349, 0, -7361, 0, -7372, 0, -7382, 0, -7393, 0, -7404, 0, -7415, 0, -7425, 0, -7436, 0, -7446, 0, -7457, 0, -7467, 0, -7478, 0, -7488, 0, -7498, 0, -7508, 0, -7518, 0, -7528, 0, -7538, 0, -7548, 0, -7557, 0, -7567, 0, -7577, 0, -7586, 0, -7596, 0, -7605, 0, -7614, 0, -7623, 0, -7633, 0, -7642, 0, -7651, 0, -7660, 0, -7668, 0, -7677, 0, -7686, 0, -7695, 0, -7703, 0, -7712, 0, -7720, 0, -7728, 0, -7737, 0, -7745, 0, -7753, 0, -7761, 0, -7769, 0, -7777, 0, -7785, 0, -7793, 0, -7800, 0, -7808, 0, -7816, 0, -7823, 0, -7830, 0, -7838, 0, -7845, 0, -7852, 0, -7859, 0, -7866, 0, -7873, 0, -7880, 0, -7887, 0, -7894, 0, -7900, 0, -7907, 0, -7914, 0, -7920, 0, -7926, 0, -7933, 0, -7939, 0, -7945, 0, -7951, 0, -7957, 0, -7963, 0, -7969, 0, -7975, 0, -7980, 0, -7986, 0, -7991, 0, -7997, 0, -8002, 0, -8008, 0, -8013, 0, -8018, 0, -8023, 0, -8028, 0, -8033, 0, -8038, 0, -8043, 0, -8047, 0, -8052, 0, -8057, 0, -8061, 0, -8066, 0, -8070, 0, -8074, 0, -8078, 0, -8082, 0, -8086, 0, -8090, 0, -8094, 0, -8098, 0, -8102, 0, -8105, 0, -8109, 0, -8113, 0, -8116, 0, -8119, 0, -8123, 0, -8126, 0, -8129, 0, -8132, 0, -8135, 0, -8138, 0, -8141, 0, -8143, 0, -8146, 0, -8149, 0, -8151, 0, -8153, 0, -8156, 0, -8158, 0, -8160, 0, -8162, 0, -8164, 0, -8166, 0, -8168, 0, -8170, 0, -8172, 0, -8174, 0, -8175, 0, -8177, 0, -8178, 0, -8179, 0, -8181, 0, -8182, 0, -8183, 0, -8184, 0, -8185, 0, -8186, 0, -8187, 0, -8187, 0, -8188, 0, -8189, 0, -8189, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8191, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8190, 0, -8189, 0, -8189, 0, -8188, 0, -8187, 0, -8187, 0, -8186, 0, -8185, 0, -8184, 0, -8183, 0, -8182, 0, -8181, 0, -8179, 0, -8178, 0, -8177, 0, -8175, 0, -8174, 0, -8172, 0, -8170, 0, -8168, 0, -8166, 0, -8164, 0, -8162, 0, -8160, 0, -8158, 0, -8156, 0, -8153, 0, -8151, 0, -8149, 0, -8146, 0, -8143, 0, -8141, 0, -8138, 0, -8135, 0, -8132, 0, -8129, 0, -8126, 0, -8123, 0, -8119, 0, -8116, 0, -8113, 0, -8109, 0, -8105, 0, -8102, 0, -8098, 0, -8094, 0, -8090, 0, -8086, 0, -8082, 0, -8078, 0, -8074, 0, -8070, 0, -8066, 0, -8061, 0, -8057, 0, -8052, 0, -8047, 0, -8043, 0, -8038, 0, -8033, 0, -8028, 0, -8023, 0, -8018, 0, -8013, 0, -8008, 0, -8002, 0, -7997, 0, -7991, 0, -7986, 0, -7980, 0, -7975, 0, -7969, 0, -7963, 0, -7957, 0, -7951, 0, -7945, 0, -7939, 0, -7933, 0, -7926, 0, -7920, 0, -7914, 0, -7907, 0, -7900, 0, -7894, 0, -7887, 0, -7880, 0, -7873, 0, -7866, 0, -7859, 0, -7852, 0, -7845, 0, -7838, 0, -7830, 0, -7823, 0, -7816, 0, -7808, 0, -7800, 0, -7793, 0, -7785, 0, -7777, 0, -7769, 0, -7761, 0, -7753, 0, -7745, 0, -7737, 0, -7728, 0, -7720, 0, -7712, 0, -7703, 0, -7695, 0, -7686, 0, -7677, 0, -7668, 0, -7660, 0, -7651, 0, -7642, 0, -7633, 0, -7623, 0, -7614, 0, -7605, 0, -7596, 0, -7586, 0, -7577, 0, -7567, 0, -7557, 0, -7548, 0, -7538, 0, -7528, 0, -7518, 0, -7508, 0, -7498, 0, -7488, 0, -7478, 0, -7467, 0, -7457, 0, -7446, 0, -7436, 0, -7425, 0, -7415, 0, -7404, 0, -7393, 0, -7382, 0, -7372, 0, -7361, 0, -7349, 0, -7338, 0, -7327, 0, -7316, 0, -7305, 0, -7293, 0, -7282, 0, -7270, 0, -7259, 0, -7247, 0, -7235, 0, -7223, 0, -7211, 0, -7199, 0, -7187, 0, -7175, 0, -7163, 0, -7151, 0, -7139, 0, -7126, 0, -7114, 0, -7101, 0, -7089, 0, -7076, 0, -7064, 0, -7051, 0, -7038, 0, -7025, 0, -7012, 0, -6999, 0, -6986, 0, -6973, 0, -6960, 0, -6946, 0, -6933, 0, -6920, 0, -6906, 0, -6893, 0, -6879, 0, -6865, 0, -6852, 0, -6838, 0, -6824, 0, -6810, 0, -6796, 0, -6782, 0, -6768, 0, -6754, 0, -6739, 0, -6725, 0, -6711, 0, -6696, 0, -6682, 0, -6667, 0, -6653, 0, -6638, 0, -6623, 0, -6608, 0, -6594, 0, -6579, 0, -6564, 0, -6549, 0, -6533, 0, -6518, 0, -6503, 0, -6488, 0, -6472, 0, -6457, 0, -6441, 0, -6426, 0, -6410, 0, -6395, 0, -6379, 0, -6363, 0, -6347, 0, -6331, 0, -6315, 0, -6299, 0, -6283, 0, -6267, 0, -6251, 0, -6235, 0, -6218, 0, -6202, 0, -6185, 0, -6169, 0, -6152, 0, -6136, 0, -6119, 0, -6102, 0, -6085, 0, -6069, 0, -6052, 0, -6035, 0, -6018, 0, -6001, 0, -5984, 0, -5966, 0, -5949, 0, -5932, 0, -5914, 0, -5897, 0, -5880, 0, -5862, 0, -5844, 0, -5827, 0, -5809, 0, -5791, 0, -5774, 0, -5756, 0, -5738, 0, -5720, 0, -5702, 0, -5684, 0, -5666, 0, -5648, 0, -5629, 0, -5611, 0, -5593, 0, -5574, 0, -5556, 0, -5537, 0, -5519, 0, -5500, 0, -5482, 0, -5463, 0, -5444, 0, -5425, 0, -5406, 0, -5388, 0, -5369, 0, -5350, 0, -5331, 0, -5311, 0, -5292, 0, -5273, 0, -5254, 0, -5235, 0, -5215, 0, -5196, 0, -5176, 0, -5157, 0, -5137, 0, -5118, 0, -5098, 0, -5078, 0, -5059, 0, -5039, 0, -5019, 0, -4999, 0, -4979, 0, -4959, 0, -4939, 0, -4919, 0, -4899, 0, -4879, 0, -4859, 0, -4838, 0, -4818, 0, -4798, 0, -4777, 0, -4757, 0, -4736, 0, -4716, 0, -4695, 0, -4675, 0, -4654, 0, -4633, 0, -4613, 0, -4592, 0, -4571, 0, -4550, 0, -4529, 0, -4508, 0, -4487, 0, -4466, 0, -4445, 0, -4424, 0, -4403, 0, -4382, 0, -4360, 0, -4339, 0, -4318, 0, -4296, 0, -4275, 0, -4254, 0, -4232, 0, -4211, 0, -4189, 0, -4167, 0, -4146, 0, -4124, 0, -4102, 0, -4080, 0, -4059, 0, -4037, 0, -4015, 0, -3993, 0, -3971, 0, -3949, 0, -3927, 0, -3905, 0, -3883, 0, -3861, 0, -3839, 0, -3816, 0, -3794, 0, -3772, 0, -3749, 0, -3727, 0, -3705, 0, -3682, 0, -3660, 0, -3637, 0, -3615, 0, -3592, 0, -3570, 0, -3547, 0, -3524, 0, -3502, 0, -3479, 0, -3456, 0, -3433, 0, -3410, 0, -3388, 0, -3365, 0, -3342, 0, -3319, 0, -3296, 0, -3273, 0, -3250, 0, -3227, 0, -3204, 0, -3180, 0, -3157, 0, -3134, 0, -3111, 0, -3088, 0, -3064, 0, -3041, 0, -3018, 0, -2994, 0, -2971, 0, -2947, 0, -2924, 0, -2900, 0, -2877, 0, -2853, 0, -2830, 0, -2806, 0, -2783, 0, -2759, 0, -2735, 0, -2712, 0, -2688, 0, -2664, 0, -2640, 0, -2617, 0, -2593, 0, -2569, 0, -2545, 0, -2521, 0, -2497, 0, -2473, 0, -2449, 0, -2425, 0, -2401, 0, -2377, 0, -2353, 0, -2329, 0, -2305, 0, -2281, 0, -2257, 0, -2233, 0, -2208, 0, -2184, 0, -2160, 0, -2136, 0, -2111, 0, -2087, 0, -2063, 0, -2038, 0, -2014, 0, -1990, 0, -1965, 0, -1941, 0, -1917, 0, -1892, 0, -1868, 0, -1843, 0, -1819, 0, -1794, 0, -1770, 0, -1745, 0, -1721, 0, -1696, 0, -1671, 0, -1647, 0, -1622, 0, -1597, 0, -1573, 0, -1548, 0, -1523, 0, -1499, 0, -1474, 0, -1449, 0, -1425, 0, -1400, 0, -1375, 0, -1350, 0, -1326, 0, -1301, 0, -1276, 0, -1251, 0, -1226, 0, -1201, 0, -1177, 0, -1152, 0, -1127, 0, -1102, 0, -1077, 0, -1052, 0, -1027, 0, -1002, 0, -977, 0, -952, 0, -927, 0, -902, 0, -877, 0, -852, 0, -827, 0, -802, 0, -777, 0, -752, 0, -727, 0, -702, 0, -677, 0, -652, 0, -627, 0, -602, 0, -577, 0, -552, 0, -527, 0, -502, 0, -477, 0, -452, 0, -427, 0, -401, 0, -376, 0, -351, 0, -326, 0, -301, 0, -276, 0, -251, 0, -226, 0, -201, 0, -175, 0, -150, 0, -125, 0, -100, 0, -75, 0, -50, 0, -25, 0, 0, 0, 25, 0, 50, 0, 75, 0, 100, 0, 125, 0, 150, 0, 175, 0, 201, 0, 226, 0, 251, 0, 276, 0, 301, 0, 326, 0, 351, 0, 376, 0, 401, 0, 427, 0, 452, 0, 477, 0, 502, 0, 527, 0, 552, 0, 577, 0, 602, 0, 627, 0, 652, 0, 677, 0, 702, 0, 727, 0, 752, 0, 777, 0, 802, 0, 827, 0, 852, 0, 877, 0, 902, 0, 927, 0, 952, 0, 977, 0, 1002, 0, 1027, 0, 1052, 0, 1077, 0, 1102, 0, 1127, 0, 1152, 0, 1177, 0, 1201, 0, 1226, 0, 1251, 0, 1276, 0, 1301, 0, 1326, 0, 1350, 0, 1375, 0, 1400, 0, 1425, 0, 1449, 0, 1474, 0, 1499, 0, 1523, 0, 1548, 0, 1573, 0, 1597, 0, 1622, 0, 1647, 0, 1671, 0, 1696, 0, 1721, 0, 1745, 0, 1770, 0, 1794, 0, 1819, 0, 1843, 0, 1868, 0, 1892, 0, 1917, 0, 1941, 0, 1965, 0, 1990, 0, 2014, 0, 2038, 0, 2063, 0, 2087, 0, 2111, 0, 2136, 0, 2160, 0, 2184, 0, 2208, 0, 2233, 0, 2257, 0, 2281, 0, 2305, 0, 2329, 0, 2353, 0, 2377, 0, 2401, 0, 2425, 0, 2449, 0, 2473, 0, 2497, 0, 2521, 0, 2545, 0, 2569, 0, 2593, 0, 2617, 0, 2640, 0, 2664, 0, 2688, 0, 2712, 0, 2735, 0, 2759, 0, 2783, 0, 2806, 0, 2830, 0, 2853, 0, 2877, 0, 2900, 0, 2924, 0, 2947, 0, 2971, 0, 2994, 0, 3018, 0, 3041, 0, 3064, 0, 3088, 0, 3111, 0, 3134, 0, 3157, 0, 3180, 0, 3204, 0, 3227, 0, 3250, 0, 3273, 0, 3296, 0, 3319, 0, 3342, 0, 3365, 0, 3388, 0, 3410, 0, 3433, 0, 3456, 0, 3479, 0, 3502, 0, 3524, 0, 3547, 0, 3570, 0, 3592, 0, 3615, 0, 3637, 0, 3660, 0, 3682, 0, 3705, 0, 3727, 0, 3749, 0, 3772, 0, 3794, 0, 3816, 0, 3839, 0, 3861, 0, 3883, 0, 3905, 0, 3927, 0, 3949, 0, 3971, 0, 3993, 0, 4015, 0, 4037, 0, 4059, 0, 4080, 0, 4102, 0, 4124, 0, 4146, 0, 4167, 0, 4189, 0, 4211, 0, 4232, 0, 4254, 0, 4275, 0, 4296, 0, 4318, 0, 4339, 0, 4360, 0, 4382, 0, 4403, 0, 4424, 0, 4445, 0, 4466, 0, 4487, 0, 4508, 0, 4529, 0, 4550, 0, 4571, 0, 4592, 0, 4613, 0, 4633, 0, 4654, 0, 4675, 0, 4695, 0, 4716, 0, 4736, 0, 4757, 0, 4777, 0, 4798, 0, 4818, 0, 4838, 0, 4859, 0, 4879, 0, 4899, 0, 4919, 0, 4939, 0, 4959, 0, 4979, 0, 4999, 0, 5019, 0, 5039, 0, 5059, 0, 5078, 0, 5098, 0, 5118, 0, 5137, 0, 5157, 0, 5176, 0, 5196, 0, 5215, 0, 5235, 0, 5254, 0, 5273, 0, 5292, 0, 5311, 0, 5331, 0, 5350, 0, 5369, 0, 5388, 0, 5406, 0, 5425, 0, 5444, 0, 5463, 0, 5482, 0, 5500, 0, 5519, 0, 5537, 0, 5556, 0, 5574, 0, 5593, 0, 5611, 0, 5629, 0, 5648, 0, 5666, 0, 5684, 0, 5702, 0, 5720, 0, 5738, 0, 5756, 0, 5774, 0, 5791, 0, 5809, 0, 5827, 0, 5844, 0, 5862, 0, 5880, 0, 5897, 0, 5914, 0, 5932, 0, 5949, 0, 5966, 0, 5984, 0, 6001, 0, 6018, 0, 6035, 0, 6052, 0, 6069, 0, 6085, 0, 6102, 0, 6119, 0, 6136, 0, 6152, 0, 6169, 0, 6185, 0, 6202, 0, 6218, 0, 6235, 0, 6251, 0, 6267, 0, 6283, 0, 6299, 0, 6315, 0, 6331, 0, 6347, 0, 6363, 0, 6379, 0, 6395, 0, 6410, 0, 6426, 0, 6441, 0, 6457, 0, 6472, 0, 6488, 0, 6503, 0, 6518, 0, 6533, 0, 6549, 0, 6564, 0, 6579, 0, 6594, 0, 6608, 0, 6623, 0, 6638, 0, 6653, 0, 6667, 0, 6682, 0, 6696, 0, 6711, 0, 6725, 0, 6739, 0, 6754, 0, 6768, 0, 6782, 0, 6796, 0, 6810, 0, 6824, 0, 6838, 0, 6852, 0, 6865, 0, 6879, 0, 6893, 0, 6906, 0, 6920, 0, 6933, 0, 6946, 0, 6960, 0, 6973, 0, 6986, 0, 6999, 0, 7012, 0, 7025, 0, 7038, 0, 7051, 0, 7064, 0, 7076, 0, 7089, 0, 7101, 0, 7114, 0, 7126, 0, 7139, 0, 7151, 0, 7163, 0, 7175, 0, 7187, 0, 7199, 0, 7211, 0, 7223, 0, 7235, 0, 7247, 0, 7259, 0, 7270, 0, 7282, 0, 7293, 0, 7305, 0, 7316, 0, 7327, 0, 7338, 0, 7349, 0, 7361, 0, 7372, 0, 7382, 0, 7393, 0, 7404, 0, 7415, 0, 7425, 0, 7436, 0, 7446, 0, 7457, 0, 7467, 0, 7478, 0, 7488, 0, 7498, 0, 7508, 0, 7518, 0, 7528, 0, 7538, 0, 7548, 0, 7557, 0, 7567, 0, 7577, 0, 7586, 0, 7596, 0, 7605, 0, 7614, 0, 7623, 0, 7633, 0, 7642, 0, 7651, 0, 7660, 0, 7668, 0, 7677, 0, 7686, 0, 7695, 0, 7703, 0, 7712, 0, 7720, 0, 7728, 0, 7737, 0, 7745, 0, 7753, 0, 7761, 0, 7769, 0, 7777, 0, 7785, 0, 7793, 0, 7800, 0, 7808, 0, 7816, 0, 7823, 0, 7830, 0, 7838, 0, 7845, 0, 7852, 0, 7859, 0, 7866, 0, 7873, 0, 7880, 0, 7887, 0, 7894, 0, 7900, 0, 7907, 0, 7914, 0, 7920, 0, 7926, 0, 7933, 0, 7939, 0, 7945, 0, 7951, 0, 7957, 0, 7963, 0, 7969, 0, 7975, 0, 7980, 0, 7986, 0, 7991, 0, 7997, 0, 8002, 0, 8008, 0, 8013, 0, 8018, 0, 8023, 0, 8028, 0, 8033, 0, 8038, 0, 8043, 0, 8047, 0, 8052, 0, 8057, 0, 8061, 0, 8066, 0, 8070, 0, 8074, 0, 8078, 0, 8082, 0, 8086, 0, 8090, 0, 8094, 0, 8098, 0, 8102, 0, 8105, 0, 8109, 0, 8113, 0, 8116, 0, 8119, 0, 8123, 0, 8126, 0, 8129, 0, 8132, 0, 8135, 0, 8138, 0, 8141, 0, 8143, 0, 8146, 0, 8149, 0, 8151, 0, 8153, 0, 8156, 0, 8158, 0, 8160, 0, 8162, 0, 8164, 0, 8166, 0, 8168, 0, 8170, 0, 8172, 0, 8174, 0, 8175, 0, 8177, 0, 8178, 0, 8179, 0, 8181, 0, 8182, 0, 8183, 0, 8184, 0, 8185, 0, 8186, 0, 8187, 0, 8187, 0, 8188, 0, 8189, 0, 8189, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8191, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8190, 0, 8189, 0, 8189, 0, 8188, 0, 8187, 0, 8187, 0, 8186, 0, 8185, 0, 8184, 0, 8183, 0, 8182, 0, 8181, 0, 8179, 0, 8178, 0, 8177, 0, 8175, 0, 8174, 0, 8172, 0, 8170, 0, 8168, 0, 8166, 0, 8164, 0, 8162, 0, 8160, 0, 8158, 0, 8156, 0, 8153, 0, 8151, 0, 8149, 0, 8146, 0, 8143, 0, 8141, 0, 8138, 0, 8135, 0, 8132, 0, 8129, 0, 8126, 0, 8123, 0, 8119, 0, 8116, 0, 8113, 0, 8109, 0, 8105, 0, 8102, 0, 8098, 0, 8094, 0, 8090, 0, 8086, 0, 8082, 0, 8078, 0, 8074, 0, 8070, 0, 8066, 0, 8061, 0, 8057, 0, 8052, 0, 8047, 0, 8043, 0, 8038, 0, 8033, 0, 8028, 0, 8023, 0, 8018, 0, 8013, 0, 8008, 0, 8002, 0, 7997, 0, 7991, 0, 7986, 0, 7980, 0, 7975, 0, 7969, 0, 7963, 0, 7957, 0, 7951, 0, 7945, 0, 7939, 0, 7933, 0, 7926, 0, 7920, 0, 7914, 0, 7907, 0, 7900, 0, 7894, 0, 7887, 0, 7880, 0, 7873, 0, 7866, 0, 7859, 0, 7852, 0, 7845, 0, 7838, 0, 7830, 0, 7823, 0, 7816, 0, 7808, 0, 7800, 0, 7793, 0, 7785, 0, 7777, 0, 7769, 0, 7761, 0, 7753, 0, 7745, 0, 7737, 0, 7728, 0, 7720, 0, 7712, 0, 7703, 0, 7695, 0, 7686, 0, 7677, 0, 7668, 0, 7660, 0, 7651, 0, 7642, 0, 7633, 0, 7623, 0, 7614, 0, 7605, 0, 7596, 0, 7586, 0, 7577, 0, 7567, 0, 7557, 0, 7548, 0, 7538, 0, 7528, 0, 7518, 0, 7508, 0, 7498, 0, 7488, 0, 7478, 0, 7467, 0, 7457, 0, 7446, 0, 7436, 0, 7425, 0, 7415, 0, 7404, 0, 7393, 0, 7382, 0, 7372, 0, 7361, 0, 7349, 0, 7338, 0, 7327, 0, 7316, 0, 7305, 0, 7293, 0, 7282, 0, 7270, 0, 7259, 0, 7247, 0, 7235, 0, 7223, 0, 7211, 0, 7199, 0, 7187, 0, 7175, 0, 7163, 0, 7151, 0, 7139, 0, 7126, 0, 7114, 0, 7101, 0, 7089, 0, 7076, 0, 7064, 0, 7051, 0, 7038, 0, 7025, 0, 7012, 0, 6999, 0, 6986, 0, 6973, 0, 6960, 0, 6946, 0, 6933, 0, 6920, 0, 6906, 0, 6893, 0, 6879, 0, 6865, 0, 6852, 0, 6838, 0, 6824, 0, 6810, 0, 6796, 0, 6782, 0, 6768, 0, 6754, 0, 6739, 0, 6725, 0, 6711, 0, 6696, 0, 6682, 0, 6667, 0, 6653, 0, 6638, 0, 6623, 0, 6608, 0, 6594, 0, 6579, 0, 6564, 0, 6549, 0, 6533, 0, 6518, 0, 6503, 0, 6488, 0, 6472, 0, 6457, 0, 6441, 0, 6426, 0, 6410, 0, 6395, 0, 6379, 0, 6363, 0, 6347, 0, 6331, 0, 6315, 0, 6299, 0, 6283, 0, 6267, 0, 6251, 0, 6235, 0, 6218, 0, 6202, 0, 6185, 0, 6169, 0, 6152, 0, 6136, 0, 6119, 0, 6102, 0, 6085, 0, 6069, 0, 6052, 0, 6035, 0, 6018, 0, 6001, 0, 5984, 0, 5966, 0, 5949, 0, 5932, 0, 5914, 0, 5897, 0, 5880, 0, 5862, 0, 5844, 0, 5827, 0, 5809, 0, 5791, 0, 5774, 0, 5756, 0, 5738, 0, 5720, 0, 5702, 0, 5684, 0, 5666, 0, 5648, 0, 5629, 0, 5611, 0, 5593, 0, 5574, 0, 5556, 0, 5537, 0, 5519, 0, 5500, 0, 5482, 0, 5463, 0, 5444, 0, 5425, 0, 5406, 0, 5388, 0, 5369, 0, 5350, 0, 5331, 0, 5311, 0, 5292, 0, 5273, 0, 5254, 0, 5235, 0, 5215, 0, 5196, 0, 5176, 0, 5157, 0, 5137, 0, 5118, 0, 5098, 0, 5078, 0, 5059, 0, 5039, 0, 5019, 0, 4999, 0, 4979, 0, 4959, 0, 4939, 0, 4919, 0, 4899, 0, 4879, 0, 4859, 0, 4838, 0, 4818, 0, 4798, 0, 4777, 0, 4757, 0, 4736, 0, 4716, 0, 4695, 0, 4675, 0, 4654, 0, 4633, 0, 4613, 0, 4592, 0, 4571, 0, 4550, 0, 4529, 0, 4508, 0, 4487, 0, 4466, 0, 4445, 0, 4424, 0, 4403, 0, 4382, 0, 4360, 0, 4339, 0, 4318, 0, 4296, 0, 4275, 0, 4254, 0, 4232, 0, 4211, 0, 4189, 0, 4167, 0, 4146, 0, 4124, 0, 4102, 0, 4080, 0, 4059, 0, 4037, 0, 4015, 0, 3993, 0, 3971, 0, 3949, 0, 3927, 0, 3905, 0, 3883, 0, 3861, 0, 3839, 0, 3816, 0, 3794, 0, 3772, 0, 3749, 0, 3727, 0, 3705, 0, 3682, 0, 3660, 0, 3637, 0, 3615, 0, 3592, 0, 3570, 0, 3547, 0, 3524, 0, 3502, 0, 3479, 0, 3456, 0, 3433, 0, 3410, 0, 3388, 0, 3365, 0, 3342, 0, 3319, 0, 3296, 0, 3273, 0, 3250, 0, 3227, 0, 3204, 0, 3180, 0, 3157, 0, 3134, 0, 3111, 0, 3088, 0, 3064, 0, 3041, 0, 3018, 0, 2994, 0, 2971, 0, 2947, 0, 2924, 0, 2900, 0, 2877, 0, 2853, 0, 2830, 0, 2806, 0, 2783, 0, 2759, 0, 2735, 0, 2712, 0, 2688, 0, 2664, 0, 2640, 0, 2617, 0, 2593, 0, 2569, 0, 2545, 0, 2521, 0, 2497, 0, 2473, 0, 2449, 0, 2425, 0, 2401, 0, 2377, 0, 2353, 0, 2329, 0, 2305, 0, 2281, 0, 2257, 0, 2233, 0, 2208, 0, 2184, 0, 2160, 0, 2136, 0, 2111, 0, 2087, 0, 2063, 0, 2038, 0, 2014, 0, 1990, 0, 1965, 0, 1941, 0, 1917, 0, 1892, 0, 1868, 0, 1843, 0, 1819, 0, 1794, 0, 1770, 0, 1745, 0, 1721, 0, 1696, 0, 1671, 0, 1647, 0, 1622, 0, 1597, 0, 1573, 0, 1548, 0, 1523, 0, 1499, 0, 1474, 0, 1449, 0, 1425, 0, 1400, 0, 1375, 0, 1350, 0, 1326, 0, 1301, 0, 1276, 0, 1251, 0, 1226, 0, 1201, 0, 1177, 0, 1152, 0, 1127, 0, 1102, 0, 1077, 0, 1052, 0, 1027, 0, 1002, 0, 977, 0, 952, 0, 927, 0, 902, 0, 877, 0, 852, 0, 827, 0, 802, 0, 777, 0, 752, 0, 727, 0, 702, 0, 677, 0, 652, 0, 627, 0, 602, 0, 577, 0, 552, 0, 527, 0, 502, 0, 477, 0, 452, 0, 427, 0, 401, 0, 376, 0, 351, 0, 326, 0, 301, 0, 276, 0, 251, 0, 226, 0, 201, 0, 175, 0, 150, 0, 125, 0, 100, 0, 75, 0, 50, 0, 25, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
_wvoice=allocate(1, "%struct.voice_t*", ALLOC_STATIC);
_f_log=allocate(1, "%struct.__sFILE*", ALLOC_STATIC);
_option_waveout=allocate(1, "i32", ALLOC_STATIC);
_option_log_frames=allocate(1, "i32", ALLOC_STATIC);
_embedded_value=allocate(60, "i32", ALLOC_STATIC);
_samplerate=allocate(1, "i32", ALLOC_STATIC);
_samplerate_native=allocate(1, "i32", ALLOC_STATIC);
__ZL5peaks=allocate(720, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
_echo_head=allocate(1, "i32", ALLOC_STATIC);
_echo_tail=allocate(1, "i32", ALLOC_STATIC);
_echo_amp=allocate(1, "i32", ALLOC_STATIC);
_echo_buf=allocate(11000, "i16", ALLOC_STATIC);
__ZL7rbreath=allocate(360, "double", ALLOC_STATIC);
_wdata=allocate(64, ["i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL13amplitude_env=allocate(1, "i8*", ALLOC_STATIC);
_out_ptr=allocate(1, "i8*", ALLOC_STATIC);
_out_start=allocate(1, "i8*", ALLOC_STATIC);
_out_end=allocate(1, "i8*", ALLOC_STATIC);
_outbuf_size=allocate(1, "i32", ALLOC_STATIC);
_wcmdq=allocate(2560, "i32", ALLOC_STATIC);
_wcmdq_head=allocate(1, "i32", ALLOC_STATIC);
_wcmdq_tail=allocate(1, "i32", ALLOC_STATIC);
_embedded_default=allocate([0, 0, 0, 0, 50, 0, 0, 0, 175, 0, 0, 0, 100, 0, 0, 0, 50, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 175, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
_current_source_index=allocate(1, "i32", ALLOC_STATIC);
__ZL18sonicSpeedupStream=allocate(1, "%struct.sonicStreamStruct*", ALLOC_STATIC);
_sonicSpeed=allocate([1], ["double",0,0,0,0,0,0,0,0], ALLOC_STATIC);
_pitch_adjust_tab=allocate([64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,86,87,88,89,91,92,93,94,96,97,98,100,101,103,104,105,107,108,110,111,113,115,116,118,119,121,123,124,126,128,130,132,133,135,137,139,141,143,145,147,149,151,153,155,158,160,162,164,167,169,171,174,176,179,181,184,186,189,191,194,197,199,202,205,208,211,214,217,220,223,226,229,232,236,239,242,246,249,252,254,255] /* @ABCDEFGHIJKLMNOPQRS */, "i8", ALLOC_STATIC);
_pk_shape1=allocate([255,254,254,254,254,254,253,253,252,251,251,250,249,248,247,246,245,244,242,241,239,238,236,234,233,231,229,227,225,223,220,218,216,213,211,209,207,205,203,201,199,197,195,193,191,189,187,185,183,180,178,176,173,171,169,166,164,161,159,156,154,151,148,146,143,140,138,135,132,129,126,123,120,118,115,112,108,105,102,99,96,95,93,91,90,88,86,85,83,82,80,79,77,76,74,73,72,70,69,68,67,66,64,63,62,61,60,59,58,57,56,55,55,54,53,52,52,51,50,50,49,48,48,47,47,46,46,46,45,45,45,44,44,44,44,44,44,44,43,43,43,43,44,43,42,42,41,40,40,39,38,38,37,36,36,35,35,34,33,33,32,32,31,30,30,29,29,28,28,27,26,26,25,25,24,24,23,23,22,22,21,21,20,20,19,19,18,18,18,17,17,16,16,15,15,15,14,14,13,13,13,12,12,11,11,11,10,10,10,9,9,9,8,8,8,7,7,7,7,6,6,6,5,5,5,5,4,4,4,4,4,3,3,3,3,2,2,2,2,2,2,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0] /* \FF\FE\FE\FE\FE\FE\F */, "i8", ALLOC_STATIC);
__ZL16PHASE_INC_FACTOR=allocate(1, "i32", ALLOC_STATIC);
__ZL11Flutter_inc=allocate(1, "i32", ALLOC_STATIC);
__ZL11samplecount=allocate(1, "i32", ALLOC_STATIC);
__ZL8nsamples=allocate(1, "i32", ALLOC_STATIC);
__ZL9wavephase=allocate(1, "i32", ALLOC_STATIC);
__ZL12wavemult_max=allocate(1, "i32", ALLOC_STATIC);
__ZL15wavemult_offset=allocate(1, "i32", ALLOC_STATIC);
__ZL8wavemult=allocate([0,0,0,2,3,5,8,11,14,18,22,27,32,37,43,49,55,62,69,76,83,90,98,105,113,121,128,136,144,152,159,166,174,181,188,194,201,207,213,218,224,228,233,237,240,244,246,249,251,252,253,253,253,253,252,251,249,246,244,240,237,233,228,224,218,213,207,201,194,188,181,174,166,159,152,144,136,128,121,113,105,98,90,83,76,69,62,55,49,43,37,32,27,22,18,14,11,8,5,3,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] /* \00\00\00\02\03\05\0 */, "i8", ALLOC_STATIC);
__ZL9pk_shape2=allocate([255,254,254,254,254,254,254,254,254,254,253,253,253,253,252,252,252,251,251,251,250,250,249,249,248,248,247,247,246,245,245,244,243,243,242,241,239,237,235,233,231,229,227,225,223,221,218,216,213,211,208,205,203,200,197,194,191,187,184,181,178,174,171,167,163,160,156,152,148,144,140,136,132,127,123,119,114,110,105,100,96,94,91,88,86,83,81,78,76,74,71,69,66,64,62,60,57,55,53,51,49,47,44,42,40,38,36,34,32,30,29,27,25,23,21,19,18,16,14,12,11,9,7,6,4,3,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0] /* \FF\FE\FE\FE\FE\FE\F */, "i8", ALLOC_STATIC);
__ZL8pk_shape=allocate(1, "i8*", ALLOC_STATIC);
__ZZ12GetAmplitudevE12amp_emphasis=allocate([16,16,10,16,22] /* \10\10\0A\10\16 */, "i8", ALLOC_STATIC);
__ZL17general_amplitude=allocate([60], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL11peak_height=allocate(36, "i32", ALLOC_STATIC);
__ZL13peak_harmonic=allocate(36, "i32", ALLOC_STATIC);
__ZL16option_harmonic1_b=allocate(1, "i1", ALLOC_STATIC);
__ZL9harmspect=allocate(1, "i32*", ALLOC_STATIC);
__ZL8harm_inc=allocate(120, "i32", ALLOC_STATIC);
__ZL10minus_pi_t=allocate(1, "double", ALLOC_STATIC);
__ZL8two_pi_t=allocate(1, "double", ALLOC_STATIC);
__ZZ7WavegenvE4maxh=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE5maxh2=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE3agc=allocate([256], ["i32",0,0,0,0], ALLOC_STATIC);
__ZZ7WavegenvE13h_switch_sign=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE11cycle_count=allocate(1, "i32", ALLOC_STATIC);
__ZZ7WavegenvE10amplitude2=allocate(1, "i32", ALLOC_STATIC);
__ZL8end_wave_b=allocate(1, "i1", ALLOC_STATIC);
__ZL7hswitch=allocate(1, "i32", ALLOC_STATIC);
__ZL6hspect=allocate(3200, "i32", ALLOC_STATIC);
__ZL8phaseinc=allocate(1, "i32", ALLOC_STATIC);
__ZL13cycle_samples=allocate(1, "i32", ALLOC_STATIC);
__ZL9hf_factor=allocate(1, "i32", ALLOC_STATIC);
__ZL6cbytes=allocate(1, "i32", ALLOC_STATIC);
__ZL12glottal_flag=allocate(1, "i32", ALLOC_STATIC);
__ZL14glottal_reduce=allocate(1, "i32", ALLOC_STATIC);
__ZL6amp_ix=allocate(1, "i32", ALLOC_STATIC);
__ZL15modulation_type=allocate(1, "i32", ALLOC_STATIC);
__ZL14modulation_tab=allocate([0, 0, 0, 0, 0, 70, 242, 41, 0, 47, 0, 47, 0, 69, 242, 41, 0, 47, 0, 46, 0, 69, 242, 40, 0, 46, 0, 45, 0, 52, 242, 40, 0, 45, 45, 44, 0, 52, 242, 40, 0, 43, 43, 43, 0, 52, 242, 40, 0, 42, 42, 42, 0, 52, 242, 40, 0, 41, 41, 41, 0, 52, 242, 40], "i8", ALLOC_STATIC);
__ZL7voicing=allocate(1, "i32", ALLOC_STATIC);
__ZL12embedded_max=allocate([0, 0, 0, 0, 32767, 0, 0, 0, 750, 0, 0, 0, 300, 0, 0, 0, 99, 0, 0, 0, 99, 0, 0, 0, 99, 0, 0, 0, 0, 0, 0, 0, 750, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ15WavegenSetVoiceP7voice_tE2v2=allocate(1344, ["i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
__ZL13consonant_amp=allocate([26], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL11flutter_amp=allocate([64], ["i32",0,0,0,0], ALLOC_STATIC);
__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab1=allocate([48, 0, 0, 0, 48, 0, 0, 0, 64, 0, 0, 0, 80, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ8SetSynthiiP7frame_tS0_P7voice_tE19glottal_reduce_tab2=allocate([144, 0, 0, 0, 160, 0, 0, 0, 176, 0, 0, 0, 192, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZL17samplecount_start=allocate(1, "i32", ALLOC_STATIC);
__ZZ12WavegenFill2iE6resume=allocate(1, "i32", ALLOC_STATIC);
__ZZ12WavegenFill2iE13echo_complete=allocate(1, "i32", ALLOC_STATIC);
__ZL11echo_length=allocate(1, "i32", ALLOC_STATIC);
__ZL7amp_inc=allocate(1, "i32", ALLOC_STATIC);
__ZZL8PlayWaveiiPhiiE9n_samples=allocate(1, "i32", ALLOC_STATIC);
__ZZL8PlayWaveiiPhiiE2ix=allocate(1, "i32", ALLOC_STATIC);
__ZZL11PlaySilenceiiE9n_samples=allocate(1, "i32", ALLOC_STATIC);
__ZZL17AdvanceParametersvE10Flutter_ix=allocate(1, "i32", ALLOC_STATIC);
__ZL11Flutter_tab=allocate([128,155,181,203,220,232,237,236,230,220,206,191,176,163,152,144,140,139,140,143,146,148,149,146,140,131,120,105,89,73,60,49,42,41,45,54,68,86,105,125,143,159,170,177,178,173,164,150,135,120,105,92,83,79,79,85,94,107,122,136,150,162,171,176,177,174,168,160,152,145,139,136,137,141,148,157,168,178,187,192,193,189,180,165,146,124,99,74,50,30,14,5,2,5,15,30,48,68,89,109,127,140,150,156,159,159,157,155,153,153,156,161,169,179,191,202,213,220,224,222,216,204,187,166,143,119,96,75,58,46,40,41,47,58,72,89,106,122,134,144,148,149,145,137,128,117,107,98,92,90,92,97,105,116,128,138,148,154,158,157,152,144,134,124,113,104,98,96,99,107,120,136,155,175,194,210,223,230,231,226,215,198,178,156,132,111,91,75,64,57,55,56,61,67,74,80,84,86,85,82,77,72,66,63,62,65,73,86,103,124,147,171,195,217,234,246,252,251,244,231,213,192,170,148,128,113,100,93,90,92,97,104,112,119,125,127,127,123,116,107,97,87,78,72,70,72,78,89,102,117,132,147,159,167,171,170,164,153,139,123,106,91,78,70,67,69,77,90,107,127,146,166,184,197,207,211,210,205,196,185,173,161,150,142,137,135,135,138,141,145,146,145,140,132,120,104,85,65,46,28,14,5,1,5,15,31,52,77,104,129,154,176,193,205,211,211,208,200,191,181,171,164,159,156,157,160,165,170,174,177,176,171,163,150,135,118,99,81,66,54,47,45,49,58,72,89,107,126,142,156,166,170,169,163,152,138,123,108,93,82,74,72,74,80,90,103,117,130] /* \80\9B\B5\CB\DC\E8\E */, "i8", ALLOC_STATIC);
_pause_phonemes=allocate([0,23,10,9,24,19,24,24] /* \00\17\0A\09\18\13\1 */, "i8", ALLOC_STATIC);
__ZZ15MakePhonemeListP10TranslatoriiE12types_double=allocate([6,7,8,3,0] /* \06\07\08\03\00 */, "i8", ALLOC_STATIC);
__ZL8kt_frame=allocate(288, "i32", ALLOC_STATIC);
__ZL10kt_globals=allocate(2748, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"i16*",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__ZL5peaks801=allocate(720, ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__ZL12sample_count=allocate(1, "i32", ALLOC_STATIC);
__ZL8nsamples802=allocate(1, "i32", ALLOC_STATIC);
__ZL6klattp=allocate(40, "i32", ALLOC_STATIC);
__ZL10klattp_inc=allocate(80, "double", ALLOC_STATIC);
__ZL7klattp1=allocate(80, "double", ALLOC_STATIC);
__ZL8end_wave803=allocate(1, "i32", ALLOC_STATIC);
__ZZ14SetSynth_KlattiiP7frame_tS0_P7voice_tiE7prev_fr=allocate(64, ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8","i8"], ALLOC_STATIC);
__ZL13scale_wav_tab=allocate([45, 0, 0, 0, 38, 0, 0, 0, 45, 0, 0, 0, 45, 0, 0, 0], ["i32",0,0,0,"i32",0,0,0,"i32",0,0,0,"i32",0,0,0], ALLOC_STATIC);
__ZZ9KlattInitvE15natural_samples=allocate([-310, 0, -400, 0, 530, 0, 356, 0, 224, 0, 89, 0, 23, 0, -10, 0, -58, 0, -16, 0, 461, 0, 599, 0, 536, 0, 701, 0, 770, 0, 605, 0, 497, 0, 461, 0, 560, 0, 404, 0, 110, 0, 224, 0, 131, 0, 104, 0, -97, 0, 155, 0, 278, 0, -154, 0, -1165, 0, -598, 0, 737, 0, 125, 0, -592, 0, 41, 0, 11, 0, -247, 0, -10, 0, 65, 0, 92, 0, 80, 0, -304, 0, 71, 0, 167, 0, -1, 0, 122, 0, 233, 0, 161, 0, -43, 0, 278, 0, 479, 0, 485, 0, 407, 0, 266, 0, 650, 0, 134, 0, 80, 0, 236, 0, 68, 0, 260, 0, 269, 0, 179, 0, 53, 0, 140, 0, 275, 0, 293, 0, 296, 0, 104, 0, 257, 0, 152, 0, 311, 0, 182, 0, 263, 0, 245, 0, 125, 0, 314, 0, 140, 0, 44, 0, 203, 0, 230, 0, -235, 0, -286, 0, 23, 0, 107, 0, 92, 0, -91, 0, 38, 0, 464, 0, 443, 0, 176, 0, 98, 0, -784, 0, -2449, 0, -1891, 0, -1045, 0, -1600, 0, -1462, 0, -1384, 0, -1261, 0, -949, 0, -730, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE10formant_hz=allocate([280, 0, 688, 0, 1064, 0, 2806, 0, 3260, 0, 3700, 0, 6500, 0, 7000, 0, 8000, 0, 280, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE9bandwidth=allocate([89, 0, 160, 0, 70, 0, 160, 0, 200, 0, 200, 0, 500, 0, 500, 0, 500, 0, 89, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE12parallel_amp=allocate([0, 0, 59, 0, 59, 0, 59, 0, 59, 0, 59, 0, 59, 0, 0, 0, 0, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZ9KlattInitvE11parallel_bw=allocate([59, 0, 59, 0, 89, 0, 149, 0, 200, 0, 200, 0, 500, 0, 0, 0, 0, 0, 0, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5noise=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5voice=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5vlast=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE8glotlast=allocate(1, "double", ALLOC_STATIC);
__ZZL7parwaveP13klatt_frame_tE5sourc=allocate(1, "double", ALLOC_STATIC);
__ZZL21pitch_synch_par_resetP13klatt_frame_tE4skew=allocate(1, "i32", ALLOC_STATIC);
__ZZL21pitch_synch_par_resetP13klatt_frame_tE2B0=allocate([1200, 0, 1142, 0, 1088, 0, 1038, 0, 991, 0, 948, 0, 907, 0, 869, 0, 833, 0, 799, 0, 768, 0, 738, 0, 710, 0, 683, 0, 658, 0, 634, 0, 612, 0, 590, 0, 570, 0, 551, 0, 533, 0, 515, 0, 499, 0, 483, 0, 468, 0, 454, 0, 440, 0, 427, 0, 415, 0, 403, 0, 391, 0, 380, 0, 370, 0, 360, 0, 350, 0, 341, 0, 332, 0, 323, 0, 315, 0, 307, 0, 300, 0, 292, 0, 285, 0, 278, 0, 272, 0, 265, 0, 259, 0, 253, 0, 247, 0, 242, 0, 237, 0, 231, 0, 226, 0, 221, 0, 217, 0, 212, 0, 208, 0, 204, 0, 199, 0, 195, 0, 192, 0, 188, 0, 184, 0, 180, 0, 177, 0, 174, 0, 170, 0, 167, 0, 164, 0, 161, 0, 158, 0, 155, 0, 153, 0, 150, 0, 147, 0, 145, 0, 142, 0, 140, 0, 137, 0, 135, 0, 133, 0, 131, 0, 128, 0, 126, 0, 124, 0, 122, 0, 120, 0, 119, 0, 117, 0, 115, 0, 113, 0, 111, 0, 110, 0, 108, 0, 106, 0, 105, 0, 103, 0, 102, 0, 100, 0, 99, 0, 97, 0, 96, 0, 95, 0, 93, 0, 92, 0, 91, 0, 90, 0, 88, 0, 87, 0, 86, 0, 85, 0, 84, 0, 83, 0, 82, 0, 80, 0, 79, 0, 78, 0, 77, 0, 76, 0, 75, 0, 75, 0, 74, 0, 73, 0, 72, 0, 71, 0, 70, 0, 69, 0, 68, 0, 68, 0, 67, 0, 66, 0, 65, 0, 64, 0, 64, 0, 63, 0, 62, 0, 61, 0, 61, 0, 60, 0, 59, 0, 59, 0, 58, 0, 57, 0, 57, 0, 56, 0, 56, 0, 55, 0, 55, 0, 54, 0, 54, 0, 53, 0, 53, 0, 52, 0, 52, 0, 51, 0, 51, 0, 50, 0, 50, 0, 49, 0, 49, 0, 48, 0, 48, 0, 47, 0, 47, 0, 46, 0, 46, 0, 45, 0, 45, 0, 44, 0, 44, 0, 43, 0, 43, 0, 42, 0, 42, 0, 41, 0, 41, 0, 41, 0, 41, 0, 40, 0, 40, 0, 39, 0, 39, 0, 38, 0, 38, 0, 38, 0, 38, 0, 37, 0, 37, 0, 36, 0, 36, 0, 36, 0, 36, 0, 35, 0, 35, 0, 35, 0, 35, 0, 34, 0, 34, 0, 33, 0, 33, 0, 33, 0, 33, 0, 32, 0, 32, 0, 32, 0, 32, 0, 31, 0, 31, 0, 31, 0, 31, 0, 30, 0, 30, 0, 30, 0, 30, 0, 29, 0, 29, 0, 29, 0, 29, 0, 28, 0, 28, 0, 28, 0, 28, 0, 27, 0, 27, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL7DBtoLINlE8amptable=allocate([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 7, 0, 8, 0, 9, 0, 10, 0, 11, 0, 13, 0, 14, 0, 16, 0, 18, 0, 20, 0, 22, 0, 25, 0, 28, 0, 32, 0, 35, 0, 40, 0, 45, 0, 51, 0, 57, 0, 64, 0, 71, 0, 80, 0, 90, 0, 101, 0, 114, 0, 128, 0, 142, 0, 159, 0, 179, 0, 202, 0, 227, 0, 256, 0, 284, 0, 318, 0, 359, 0, 405, 0, 455, 0, 512, 0, 568, 0, 638, 0, 719, 0, 881, 0, 911, 0, 1024, 0, 1137, 0, 1276, 0, 1438, 0, 1622, 0, 1823, 0, 2048, 0, 2273, 0, 2552, 0, 2875, 0, 3244, 0, 3645, 0, 4096, 0, 4547, 0, 5104, 0, 5751, 0, 6488, 0, 7291, 0, 8192, 0, 9093, 0, 10207, 0, 11502, 0, 12976, 0, 14582, 0, 16384, 0, 18350, 0, 20644, 0, 23429, 0, 26214, 0, 29491, 0, 32767, 0], ["i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0,"i16",0], ALLOC_STATIC);
__ZZL14natural_sourcevE5vwave=allocate(1, "double", ALLOC_STATIC);
__ZZL16impulsive_sourcevE7doublet=allocate([0, 0, 0, 0, 0, 0, 0, 0, 13000000, 0, 0, 0, 0, 0, 0, 0, -13000000, 0, 0, 0, 0, 0, 0, 0], ["double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__ZZL16impulsive_sourcevE5vwave=allocate(1, "double", ALLOC_STATIC);
__ZZL9gen_noisedE5nlast=allocate(1, "double", ALLOC_STATIC);
__ZZL7flutterP13klatt_frame_tE10time_count=allocate(1, "i32", ALLOC_STATIC);
__ZZL10frame_initP13klatt_frame_tE14amp_par_factor=allocate([0.6, 0, 0, 0, 0, 0, 0, 0, 0.4, 0, 0, 0, 0, 0, 0, 0, 0.15, 0, 0, 0, 0, 0, 0, 0, 0.06, 0, 0, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0, 0, 0.022, 0, 0, 0, 0, 0, 0, 0, 0.03, 0, 0, 0, 0, 0, 0, 0], ["double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0,"double",0,0,0,0,0,0,0], ALLOC_STATIC);
__str810=allocate([47,116,109,112,47,115,111,110,105,99,46,108,111,103,0] /* /tmp/sonic.log\00 */, "i8", ALLOC_STATIC);
__str1811=allocate([97,0] /* a\00 */, "i8", ALLOC_STATIC);
_optarg=allocate(1, "i8*", ALLOC_STATIC);
_optind=allocate(1, "i32", ALLOC_STATIC);
_opterr=allocate([1], ["i32",0,0,0,0], ALLOC_STATIC);
_optopt=allocate([63], ["i32",0,0,0,0], ALLOC_STATIC);
__ZL8optwhere=allocate(1, "i32", ALLOC_STATIC);
__str831=allocate([45,45,0] /* --\00 */, "i8", ALLOC_STATIC);
__str1832=allocate([80,79,83,73,88,76,89,95,67,79,82,82,69,67,84,0] /* POSIXLY_CORRECT\00 */, "i8", ALLOC_STATIC);
__str2833=allocate([37,115,58,32,111,112,116,105,111,110,32,96,37,115,39,32,105,115,32,97,109,98,105,103,117,111,117,115,32,40,99,111,117,108,100,32,98,101,32,96,45,45,37,115,39,32,111,114,32,96,45,45,37,115,39,41,10,0] /* %s: option `%s' is a */, "i8", ALLOC_STATIC);
__str3834=allocate([37,115,58,32,105,110,118,97,108,105,100,32,111,112,116,105,111,110,32,45,45,32,96,45,37,99,39,10,0] /* %s: invalid option - */, "i8", ALLOC_STATIC);
__str4835=allocate([37,115,58,32,97,114,103,117,109,101,110,116,32,114,101,113,117,105,114,101,100,32,102,111,114,32,111,112,116,105,111,110,32,96,0] /* %s: argument require */, "i8", ALLOC_STATIC);
__str5836=allocate([45,45,37,115,39,10,0] /* --%s'\0A\00 */, "i8", ALLOC_STATIC);
__str6837=allocate([45,37,99,39,10,0] /* -%c'\0A\00 */, "i8", ALLOC_STATIC);
HEAP32[((__ZZ4mainE12long_options)>>2)]=((__str6)&4294967295);
HEAP32[((__ZZ4mainE12long_options+16)>>2)]=((__str7)&4294967295);
HEAP32[((__ZZ4mainE12long_options+32)>>2)]=((__str8)&4294967295);
HEAP32[((__ZZ4mainE12long_options+48)>>2)]=((__str9)&4294967295);
HEAP32[((__ZZ4mainE12long_options+64)>>2)]=((__str10)&4294967295);
HEAP32[((__ZZ4mainE12long_options+80)>>2)]=((__str11)&4294967295);
HEAP32[((__ZZ4mainE12long_options+96)>>2)]=((__str12)&4294967295);
HEAP32[((__ZZ4mainE12long_options+112)>>2)]=((__str13)&4294967295);
HEAP32[((__ZZ4mainE12long_options+128)>>2)]=((__str14)&4294967295);
HEAP32[((__ZZ4mainE12long_options+144)>>2)]=((__str15)&4294967295);
HEAP32[((__ZZ4mainE12long_options+160)>>2)]=((__str16)&4294967295);
HEAP32[((__ZZ4mainE12long_options+176)>>2)]=((__str17)&4294967295);
HEAP32[((_mnem_rules)>>2)]=((__str42)&4294967295);
HEAP32[((_mnem_rules+8)>>2)]=((__str143)&4294967295);
HEAP32[((_mnem_rules+16)>>2)]=((__str244)&4294967295);
HEAP32[((_mnem_rules+24)>>2)]=((__str345)&4294967295);
HEAP32[((_mnem_rules+32)>>2)]=((__str446)&4294967295);
HEAP32[((_mnem_rules+40)>>2)]=((__str547)&4294967295);
HEAP32[((_mnem_rules+48)>>2)]=((__str648)&4294967295);
HEAP32[((_mnem_flags)>>2)]=((__str749)&4294967295);
HEAP32[((_mnem_flags+8)>>2)]=((__str850)&4294967295);
HEAP32[((_mnem_flags+16)>>2)]=((__str951)&4294967295);
HEAP32[((_mnem_flags+24)>>2)]=((__str1052)&4294967295);
HEAP32[((_mnem_flags+32)>>2)]=((__str1153)&4294967295);
HEAP32[((_mnem_flags+40)>>2)]=((__str1254)&4294967295);
HEAP32[((_mnem_flags+48)>>2)]=((__str1355)&4294967295);
HEAP32[((_mnem_flags+56)>>2)]=((__str1456)&4294967295);
HEAP32[((_mnem_flags+64)>>2)]=((__str1557)&4294967295);
HEAP32[((_mnem_flags+72)>>2)]=((__str1658)&4294967295);
HEAP32[((_mnem_flags+80)>>2)]=((__str1759)&4294967295);
HEAP32[((_mnem_flags+88)>>2)]=((__str1860)&4294967295);
HEAP32[((_mnem_flags+96)>>2)]=((__str1961)&4294967295);
HEAP32[((_mnem_flags+104)>>2)]=((__str2062)&4294967295);
HEAP32[((_mnem_flags+112)>>2)]=((__str2163)&4294967295);
HEAP32[((_mnem_flags+120)>>2)]=((__str2264)&4294967295);
HEAP32[((_mnem_flags+128)>>2)]=((__str2365)&4294967295);
HEAP32[((_mnem_flags+136)>>2)]=((__str2466)&4294967295);
HEAP32[((_mnem_flags+144)>>2)]=((__str2567)&4294967295);
HEAP32[((_mnem_flags+152)>>2)]=((__str2668)&4294967295);
HEAP32[((_mnem_flags+160)>>2)]=((__str2769)&4294967295);
HEAP32[((_mnem_flags+168)>>2)]=((__str2870)&4294967295);
HEAP32[((_mnem_flags+176)>>2)]=((__str2971)&4294967295);
HEAP32[((_mnem_flags+184)>>2)]=((__str3072)&4294967295);
HEAP32[((_mnem_flags+192)>>2)]=((__str3173)&4294967295);
HEAP32[((_mnem_flags+200)>>2)]=((__str3274)&4294967295);
HEAP32[((_mnem_flags+208)>>2)]=((__str3375)&4294967295);
HEAP32[((_mnem_flags+216)>>2)]=((__str3476)&4294967295);
HEAP32[((_mnem_flags+224)>>2)]=((__str3577)&4294967295);
HEAP32[((_mnem_flags+232)>>2)]=((__str3678)&4294967295);
HEAP32[((_mnem_flags+240)>>2)]=((__str3779)&4294967295);
HEAP32[((_mnem_flags+248)>>2)]=((__str3880)&4294967295);
HEAP32[((_mnem_flags+256)>>2)]=((__str3981)&4294967295);
HEAP32[((_mnem_flags+264)>>2)]=((__str4082)&4294967295);
HEAP32[((_mnem_flags+272)>>2)]=((__str4183)&4294967295);
HEAP32[((_mnem_flags+280)>>2)]=((__str4284)&4294967295);
HEAP32[((_mnem_flags+288)>>2)]=((__str43)&4294967295);
HEAP32[((_mnem_flags+296)>>2)]=((__str44)&4294967295);
HEAP32[((_mnem_flags+304)>>2)]=((__str45)&4294967295);
HEAP32[((_mnem_flags+312)>>2)]=((__str46)&4294967295);
HEAP32[((_mnem_flags+320)>>2)]=((__str47)&4294967295);
HEAP32[((_mnem_flags+328)>>2)]=((__str48)&4294967295);
HEAP32[((_mnem_flags+336)>>2)]=((__str49)&4294967295);
HEAP32[((_mnem_flags+344)>>2)]=((__str50)&4294967295);
HEAP32[((_mnem_flags+352)>>2)]=((__str51)&4294967295);
HEAP32[((_mnem_flags+360)>>2)]=((__str52)&4294967295);
HEAP32[((_mnem_flags+368)>>2)]=((__str53)&4294967295);
HEAP32[((_mnem_flags+376)>>2)]=((__str54)&4294967295);
HEAP32[((_mnem_flags+384)>>2)]=((__str55)&4294967295);
HEAP32[((_mnem_flags+392)>>2)]=((__str56)&4294967295);
HEAP32[((_mnem_flags+400)>>2)]=((__str57)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf)>>2)]=((__ZL9rule_cond)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+4)>>2)]=((__ZL8rule_pre)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+8)>>2)]=((__ZL10rule_match)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+12)>>2)]=((__ZL9rule_post)&4294967295);
HEAP32[((__ZZL16copy_rule_stringPcRiE6outbuf+16)>>2)]=((__ZL13rule_phonemes)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E16add_e_exceptions)>>2)]=((__str17133)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions)>>2)]=((__str18134)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+4)>>2)]=((__str19135)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+8)>>2)]=((__str20136)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+12)>>2)]=((__str21137)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+16)>>2)]=((__str22138)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+20)>>2)]=((__str23139)&4294967295);
HEAP32[((__ZZ12RemoveEndingP10TranslatorPciS1_E15add_e_additions+24)>>2)]=((__str24140)&4294967295);
HEAP32[((_envelope_data)>>2)]=((_env_fall)&4294967295);
HEAP32[((_envelope_data+4)>>2)]=((_env_fall)&4294967295);
HEAP32[((_envelope_data+8)>>2)]=((_env_rise)&4294967295);
HEAP32[((_envelope_data+12)>>2)]=((_env_rise)&4294967295);
HEAP32[((_envelope_data+16)>>2)]=((_env_frise)&4294967295);
HEAP32[((_envelope_data+20)>>2)]=((__ZL11env_r_frise)&4294967295);
HEAP32[((_envelope_data+24)>>2)]=((__ZL10env_frise2)&4294967295);
HEAP32[((_envelope_data+28)>>2)]=((__ZL12env_r_frise2)&4294967295);
HEAP32[((_envelope_data+32)>>2)]=((__ZL12env_risefall)&4294967295);
HEAP32[((_envelope_data+36)>>2)]=((__ZL12env_risefall)&4294967295);
HEAP32[((_envelope_data+40)>>2)]=((__ZL13env_fallrise3)&4294967295);
HEAP32[((_envelope_data+44)>>2)]=((__ZL13env_fallrise3)&4294967295);
HEAP32[((_envelope_data+48)>>2)]=((__ZL13env_fallrise4)&4294967295);
HEAP32[((_envelope_data+52)>>2)]=((__ZL13env_fallrise4)&4294967295);
HEAP32[((_envelope_data+56)>>2)]=((__ZL9env_fall2)&4294967295);
HEAP32[((_envelope_data+60)>>2)]=((__ZL9env_fall2)&4294967295);
HEAP32[((_envelope_data+64)>>2)]=((__ZL9env_rise2)&4294967295);
HEAP32[((_envelope_data+68)>>2)]=((__ZL9env_rise2)&4294967295);
HEAP32[((_envelope_data+72)>>2)]=((__ZL16env_risefallrise)&4294967295);
HEAP32[((_envelope_data+76)>>2)]=((__ZL16env_risefallrise)&4294967295);
HEAP32[((__ZL15tone_head_table+4)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+12)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+20)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+28)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+36)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+44)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+52)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+60)>>2)]=((__ZL9oflow_emf)&4294967295);
HEAP32[((__ZL15tone_head_table+68)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+76)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+84)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+92)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+100)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+108)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+116)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+124)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+132)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+140)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+148)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+156)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+164)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+172)>>2)]=((__ZL5oflow)&4294967295);
HEAP32[((__ZL15tone_head_table+180)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+188)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL15tone_head_table+196)>>2)]=((__ZL7drops_0)&4294967295);
HEAP32[((__ZL15tone_head_table+204)>>2)]=((__ZL10oflow_less)&4294967295);
HEAP32[((__ZL8ssmltags)>>2)]=((__str167)&4294967295);
HEAP32[((__ZL8ssmltags+8)>>2)]=((__str1168)&4294967295);
HEAP32[((__ZL8ssmltags+16)>>2)]=((__str2169)&4294967295);
HEAP32[((__ZL8ssmltags+24)>>2)]=((__str3170)&4294967295);
HEAP32[((__ZL8ssmltags+32)>>2)]=((__str4171)&4294967295);
HEAP32[((__ZL8ssmltags+40)>>2)]=((__str5172)&4294967295);
HEAP32[((__ZL8ssmltags+48)>>2)]=((__str6173)&4294967295);
HEAP32[((__ZL8ssmltags+56)>>2)]=((__str7174)&4294967295);
HEAP32[((__ZL8ssmltags+64)>>2)]=((__str8175)&4294967295);
HEAP32[((__ZL8ssmltags+72)>>2)]=((__str9176)&4294967295);
HEAP32[((__ZL8ssmltags+80)>>2)]=((__str10177)&4294967295);
HEAP32[((__ZL8ssmltags+88)>>2)]=((__str11178)&4294967295);
HEAP32[((__ZL8ssmltags+96)>>2)]=((__str12179)&4294967295);
HEAP32[((__ZL8ssmltags+104)>>2)]=((__str13180)&4294967295);
HEAP32[((__ZL8ssmltags+112)>>2)]=((__str14181)&4294967295);
HEAP32[((__ZL8ssmltags+120)>>2)]=((__str15182)&4294967295);
HEAP32[((__ZL8ssmltags+128)>>2)]=((__str16183)&4294967295);
HEAP32[((__ZL8ssmltags+136)>>2)]=((__str17184)&4294967295);
HEAP32[((__ZL8ssmltags+144)>>2)]=((__str18185)&4294967295);
HEAP32[((__ZL8ssmltags+152)>>2)]=((__str19186)&4294967295);
HEAP32[((__ZL8ssmltags+160)>>2)]=((__str20187)&4294967295);
HEAP32[((__ZL8ssmltags+168)>>2)]=((__str21188)&4294967295);
HEAP32[((__ZL8ssmltags+176)>>2)]=((__str22189)&4294967295);
HEAP32[((__ZL8ssmltags+184)>>2)]=((__str23190)&4294967295);
HEAP32[((__ZL8ssmltags+192)>>2)]=((__str24191)&4294967295);
HEAP32[((__ZL8ssmltags+200)>>2)]=((__str25192)&4294967295);
HEAP32[((__ZL8ssmltags+208)>>2)]=((__str26193)&4294967295);
HEAP32[((__ZL8ssmltags+216)>>2)]=((__str27194)&4294967295);
HEAP32[((__ZL8ssmltags+224)>>2)]=((__str28195)&4294967295);
HEAP32[((__ZL8ssmltags+232)>>2)]=((__str29196)&4294967295);
HEAP32[((__ZL8ssmltags+240)>>2)]=((__str30197)&4294967295);
HEAP32[((__ZL8ssmltags+248)>>2)]=((__str31198)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics)>>2)]=((__str32199)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+8)>>2)]=((__str33200)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+16)>>2)]=((__str34201)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+24)>>2)]=((__str35202)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+32)>>2)]=((__str36203)&4294967295);
HEAP32[((__ZL18xml_char_mnemonics+40)>>2)]=((__str37204)&4294967295);
HEAP32[((__ZL7xmlbase)>>2)]=((__str13643)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct)>>2)]=((__str61228)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct+8)>>2)]=((__str62229)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_punct+16)>>2)]=((__str63230)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals)>>2)]=((__str64231)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals+8)>>2)]=((__str65232)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals+16)>>2)]=((__str66233)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_capitals+24)>>2)]=((__str9659)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as)>>2)]=((__str68235)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+8)>>2)]=((__str69236)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+16)>>2)]=((__str70237)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+24)>>2)]=((__str71238)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_interpret_as+32)>>2)]=((__str72239)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE17mnem_sayas_format)>>2)]=((__str73240)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break)>>2)]=((__str61228)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+8)>>2)]=((__str74241)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+16)>>2)]=((__str75242)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+32)>>2)]=((__str29196)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE10mnem_break+40)>>2)]=((__str77244)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis)>>2)]=((__str61228)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis+8)>>2)]=((__str78245)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis+16)>>2)]=((__str79246)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE13mnem_emphasis+24)>>2)]=((__str29196)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+4)>>2)]=((__str80247)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+8)>>2)]=((__str81248)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+12)>>2)]=((__str9659)&4294967295);
HEAP32[((__ZZL14ProcessSsmlTagPwPcRiiiE12prosody_attr+16)>>2)]=((__str82249)&4294967295);
HEAP32[((__ZZL18GetVoiceAttributesPwiE11mnem_gender)>>2)]=((__str1647)&4294967295);
HEAP32[((__ZZL18GetVoiceAttributesPwiE11mnem_gender+8)>>2)]=((__str2648)&4294967295);
HEAP32[((__ZZL18GetVoiceAttributesPwiE11mnem_gender+16)>>2)]=((__str105272)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames)>>2)]=((__str111278)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames+8)>>2)]=((__str112279)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames+16)>>2)]=((__str113280)&4294967295);
HEAP32[((__ZZL14ReplaceKeyNamePciRiE8keynames+24)>>2)]=((__str114281)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+8)>>2)]=((__str115282)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+16)>>2)]=((__str116283)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+24)>>2)]=((__str117)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+32)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+40)>>2)]=((__str118)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume+48)>>2)]=((__str119)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+8)>>2)]=((__str120)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+16)>>2)]=((__str121)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+32)>>2)]=((__str122)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate+40)>>2)]=((__str123)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+8)>>2)]=((__str124)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+16)>>2)]=((__str125)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+32)>>2)]=((__str126)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch+40)>>2)]=((__str127)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range)>>2)]=((__str45697)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+8)>>2)]=((__str124)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+16)>>2)]=((__str125)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+24)>>2)]=((__str76243)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+32)>>2)]=((__str126)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range+40)>>2)]=((__str127)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+4)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_rate)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+8)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE11mnem_volume)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+12)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_pitch)&4294967295);
HEAP32[((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE9mnem_tabs+16)>>2)]=((__ZZL19SetProsodyParameteriPwP11PARAM_STACKE10mnem_range)&4294967295);
HEAP32[((__ZL11accents_tab)>>2)]=((__str57354)&4294967295);
HEAP32[((__ZL11accents_tab+8)>>2)]=((__str58355)&4294967295);
HEAP32[((__ZL11accents_tab+16)>>2)]=((__str59356)&4294967295);
HEAP32[((__ZL11accents_tab+24)>>2)]=((__str60357)&4294967295);
HEAP32[((__ZL11accents_tab+32)>>2)]=((__str61358)&4294967295);
HEAP32[((__ZL11accents_tab+40)>>2)]=((__str62359)&4294967295);
HEAP32[((__ZL11accents_tab+48)>>2)]=((__str63360)&4294967295);
HEAP32[((__ZL11accents_tab+56)>>2)]=((__str64361)&4294967295);
HEAP32[((__ZL11accents_tab+64)>>2)]=((__str65362)&4294967295);
HEAP32[((__ZL11accents_tab+72)>>2)]=((__str66363)&4294967295);
HEAP32[((__ZL11accents_tab+80)>>2)]=((__str67364)&4294967295);
HEAP32[((__ZL11accents_tab+88)>>2)]=((__str68365)&4294967295);
HEAP32[((__ZL11accents_tab+96)>>2)]=((__str69366)&4294967295);
HEAP32[((__ZL11accents_tab+104)>>2)]=((__str70367)&4294967295);
HEAP32[((__ZL11accents_tab+112)>>2)]=((__str71368)&4294967295);
HEAP32[((__ZL11accents_tab+120)>>2)]=((__str72369)&4294967295);
HEAP32[((__ZL11accents_tab+128)>>2)]=((__str73370)&4294967295);
HEAP32[((__ZL11accents_tab+136)>>2)]=((__str74371)&4294967295);
HEAP32[((__ZL11accents_tab+144)>>2)]=((__str75372)&4294967295);
HEAP32[((__ZL11accents_tab+152)>>2)]=((__str76373)&4294967295);
HEAP32[((__ZL11accents_tab+160)>>2)]=((__str77374)&4294967295);
HEAP32[((__ZL11accents_tab+168)>>2)]=((__str78375)&4294967295);
HEAP32[((_version_string)>>2)]=((__str399)&4294967295);
HEAP32[((_charsets)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+4)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+8)>>2)]=((__ZL10ISO_8859_2)&4294967295);
HEAP32[((_charsets+12)>>2)]=((__ZL10ISO_8859_3)&4294967295);
HEAP32[((_charsets+16)>>2)]=((__ZL10ISO_8859_4)&4294967295);
HEAP32[((_charsets+20)>>2)]=((__ZL10ISO_8859_5)&4294967295);
HEAP32[((_charsets+24)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+28)>>2)]=((__ZL10ISO_8859_7)&4294967295);
HEAP32[((_charsets+32)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+36)>>2)]=((__ZL10ISO_8859_9)&4294967295);
HEAP32[((_charsets+40)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+44)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+48)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+52)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+56)>>2)]=((__ZL11ISO_8859_14)&4294967295);
HEAP32[((_charsets+60)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+64)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+68)>>2)]=((__ZL10ISO_8859_1)&4294967295);
HEAP32[((_charsets+72)>>2)]=((__ZL6KOI8_R)&4294967295);
HEAP32[((_charsets+76)>>2)]=((__ZL5ISCII)&4294967295);
HEAP32[((__ZL15length_mod_tabs)>>2)]=((__ZL14length_mods_en)&4294967295);
HEAP32[((__ZL15length_mod_tabs+4)>>2)]=((__ZL14length_mods_en)&4294967295);
HEAP32[((__ZL15length_mod_tabs+8)>>2)]=((__ZL15length_mods_en0)&4294967295);
HEAP32[((__ZL15length_mod_tabs+12)>>2)]=((__ZL17length_mods_equal)&4294967295);
HEAP32[((__ZL15length_mod_tabs+16)>>2)]=((__ZL17length_mods_equal)&4294967295);
HEAP32[((__ZL15length_mod_tabs+20)>>2)]=((__ZL17length_mods_equal)&4294967295);
HEAP32[((_genders)>>2)]=((__str646)&4294967295);
HEAP32[((_genders+8)>>2)]=((__str1647)&4294967295);
HEAP32[((_genders+16)>>2)]=((__str2648)&4294967295);
HEAP32[((__ZL11options_tab)>>2)]=((__str3653)&4294967295);
HEAP32[((__ZL11options_tab+8)>>2)]=((__str4654)&4294967295);
HEAP32[((__ZL11keyword_tab)>>2)]=((__str5655)&4294967295);
HEAP32[((__ZL11keyword_tab+8)>>2)]=((__str6656)&4294967295);
HEAP32[((__ZL11keyword_tab+16)>>2)]=((__str7657)&4294967295);
HEAP32[((__ZL11keyword_tab+24)>>2)]=((__str8658)&4294967295);
HEAP32[((__ZL11keyword_tab+32)>>2)]=((__str9659)&4294967295);
HEAP32[((__ZL11keyword_tab+40)>>2)]=((__str10660)&4294967295);
HEAP32[((__ZL11keyword_tab+48)>>2)]=((__str11661)&4294967295);
HEAP32[((__ZL11keyword_tab+56)>>2)]=((__str12662)&4294967295);
HEAP32[((__ZL11keyword_tab+64)>>2)]=((__str13663)&4294967295);
HEAP32[((__ZL11keyword_tab+72)>>2)]=((__str14664)&4294967295);
HEAP32[((__ZL11keyword_tab+80)>>2)]=((__str15665)&4294967295);
HEAP32[((__ZL11keyword_tab+88)>>2)]=((__str16666)&4294967295);
HEAP32[((__ZL11keyword_tab+96)>>2)]=((__str17667)&4294967295);
HEAP32[((__ZL11keyword_tab+104)>>2)]=((__str18668)&4294967295);
HEAP32[((__ZL11keyword_tab+112)>>2)]=((__str19669)&4294967295);
HEAP32[((__ZL11keyword_tab+120)>>2)]=((__str20670)&4294967295);
HEAP32[((__ZL11keyword_tab+128)>>2)]=((__str21671)&4294967295);
HEAP32[((__ZL11keyword_tab+136)>>2)]=((__str22672)&4294967295);
HEAP32[((__ZL11keyword_tab+144)>>2)]=((__str23673)&4294967295);
HEAP32[((__ZL11keyword_tab+152)>>2)]=((__str24674)&4294967295);
HEAP32[((__ZL11keyword_tab+160)>>2)]=((__str25675)&4294967295);
HEAP32[((__ZL11keyword_tab+168)>>2)]=((__str26676)&4294967295);
HEAP32[((__ZL11keyword_tab+176)>>2)]=((__str27677)&4294967295);
HEAP32[((__ZL11keyword_tab+184)>>2)]=((__str28678)&4294967295);
HEAP32[((__ZL11keyword_tab+192)>>2)]=((__str29679)&4294967295);
HEAP32[((__ZL11keyword_tab+200)>>2)]=((__str30680)&4294967295);
HEAP32[((__ZL11keyword_tab+208)>>2)]=((__str31681)&4294967295);
HEAP32[((__ZL11keyword_tab+216)>>2)]=((__str32682)&4294967295);
HEAP32[((__ZL11keyword_tab+224)>>2)]=((__str33683)&4294967295);
HEAP32[((__ZL11keyword_tab+232)>>2)]=((__str34684)&4294967295);
HEAP32[((__ZL11keyword_tab+240)>>2)]=((__str35685)&4294967295);
HEAP32[((__ZL11keyword_tab+248)>>2)]=((__str36686)&4294967295);
HEAP32[((__ZL11keyword_tab+256)>>2)]=((__str37687)&4294967295);
HEAP32[((__ZL11keyword_tab+264)>>2)]=((__str38688)&4294967295);
HEAP32[((__ZL11keyword_tab+272)>>2)]=((__str39689)&4294967295);
HEAP32[((__ZL11keyword_tab+280)>>2)]=((__str40690)&4294967295);
HEAP32[((__ZL11keyword_tab+288)>>2)]=((__str41691)&4294967295);
HEAP32[((__ZL11keyword_tab+296)>>2)]=((__str42692)&4294967295);
HEAP32[((__ZL11keyword_tab+304)>>2)]=((__str43693)&4294967295);
HEAP32[((_variant_lists)>>2)]=((__ZL15variants_either)&4294967295);
HEAP32[((_variant_lists+4)>>2)]=((__ZL13variants_male)&4294967295);
HEAP32[((_variant_lists+8)>>2)]=((__ZL15variants_female)&4294967295);
HEAP32[((_voice)>>2)]=__ZL9voicedata;
FS.init(); __ATEXIT__.push({ func: function() { FS.quit() } });
___setErrNo(0);
_fputc.ret = allocate([0], "i8", ALLOC_STATIC);
___buildEnvironment(ENV);
_fgetc.ret = allocate([0], "i8", ALLOC_STATIC);
FUNCTION_TABLE = [0,0,__ZL13rgroup_sorterP6RGROUPS0_,0,__Z13string_sorterPPcS0_,0,__ZL15VoiceNameSorterPKvS0_,0,__ZL16VoiceScoreSorterPKvS0_,0]; Module["FUNCTION_TABLE"] = FUNCTION_TABLE;


  __globalConstructor__();

  var ret = null;
  if (Module._main) {
    ret = Module.callMain(args);
    __shutdownRuntime__();
  }
  return ret;
}
Module.run = run;

// {{PRE_RUN_ADDITIONS}}


if (!Module.noInitialRun) {
  run();
}

// {{POST_RUN_ADDITIONS}}





  // {{MODULE_ADDITIONS}}

/*
  return Module;
}).call(this, {}, arguments); // Replace parameters as needed
*/


// EMSCRIPTEN_GENERATED_FUNCTIONS: ["__Z13GetFileLengthPKc","__Z5Alloci","__Z4FreePv","__Z13DisplayVoicesP7__sFILEPc","__Z13WVoiceChangedP7voice_t","__Z11MarkerEventijiPh","_main","__ZL9init_pathPcS_","__ZL10initialisev","__ZL12OpenWaveFilePKci","__ZL11WavegenFilev","__ZL13CloseWaveFilev","__Z8isspace2j","__Z14LookupMnemNameP8MNEM_TABi","__Z22print_dictionary_flagsPj","__Z10DecodeRulePKciPci","__Z13string_sorterPPcS0_","__Z17CompileDictionaryPKcS0_P7__sFILEPci","__ZL9fopen_logPKcS0_","__ZL22compile_dictlist_startv","__ZL21compile_dictlist_filePKcS0_","__ZL20compile_dictlist_endP7__sFILE","__ZL17compile_dictrulesP7__sFILES0_Pc","__ZL17output_rule_groupP7__sFILEiPPcS1_","__ZL19compile_lettergroupPcP7__sFILE","__ZL12compile_rulePc","__ZL13rgroup_sorterP6RGROUPS0_","__ZL16copy_rule_stringPcRi","__ZL12compile_linePcS_Pi","__Z8strncpy0PcPKci","__Z13Reverse4Bytesi","__Z10LookupMnemP8MNEM_TABPKc","__Z14LoadDictionaryP10TranslatorPKci","__ZL10InitGroupsP10Translator","__Z14HashDictionaryPKc","__Z14EncodePhonemesPcS_Ph","__Z14DecodePhonemesPKcPc","__Z26GetTranslatedPhonemeStringPci","__ZL15WritePhMnemonicPcPiP11PHONEME_TABP12PHONEME_LIST","__Z7IsVowelP10Translatori","__ZL8IsLetterP10Translatorii","__Z14UnpronouncableP10TranslatorPci","__ZL15Unpronouncable2P10TranslatorPc","__Z16ChangeWordStressP10TranslatorPci","__ZL14GetVowelStressP10TranslatorPhPaRiS3_i","__Z13SetWordStressP10TranslatorPcPjii","__Z14AppendPhonemesP10TranslatorPciPKc","__Z14TranslateRulesP10TranslatorPcS1_iS1_iPj","__Z6LookupP10TranslatorPKcPc","__ZL9MatchRuleP10TranslatorPPcS1_iS1_P11MatchRecordii","__Z21ApplySpecialAttributeP10TranslatorPci","__Z22ApplySpecialAttribute2P10TranslatorPci","__Z17TransposeAlphabetP10TranslatorPc","__Z14LookupDictListP10TranslatorPPcS1_PjiP8WORD_TAB","__ZL11LookupDict2P10TranslatorPKcS2_PcPjiP8WORD_TAB","__Z11LookupFlagsP10TranslatorPKc","__Z12RemoveEndingP10TranslatorPciS1_","__ZL13IsLetterGroupP10TranslatorPcii","__Z11CalcPitchesP10Translatori","__ZL16CalcPitches_ToneP10Translatori","__ZL18count_pitch_vowelsiii","__ZL12calc_pitchesiiii","__ZL13calc_pitches2iii","__ZL16SetPitchGradientiiii","__ZL18calc_pitch_segmentiiP9TONE_HEADP12TONE_NUCLEUSii","__ZL9set_pitchP8SYLLABLEii","__ZL16count_incrementsiii","__ZL17SetHeadIntonationP4TUNEiii","__ZL15CountUnstressediii","_iswalpha","_iswdigit","_iswalnum","_towlower","_towupper","_iswupper","_iswlower","_iswspace","_iswpunct","_wcschr","_wcslen","_wcstod","__Z9towlower2j","__Z3Eofv","__Z10Read4BytesP7__sFILE","__Z11AddNameDataPKci","__Z13SetVoiceStackP12espeak_VOICE","__Z10ReadClauseP10TranslatorP7__sFILEPcPsPiiS5_S3_","__ZL4GetCv","__ZL6UngetCi","__ZL14ProcessSsmlTagPwPcRiii","__ZL13LookupSpecialP10TranslatorPKcPc","__ZL10RemoveCharPc","__ZL19AnnouncePunctuationP10TranslatoriPiPcS1_i","__ZL14LookupCharNameP10Translatorii","__ZL8IsRomanUj","__Z12InitNamedatav","__Z9InitText2v","__ZL13WordToString2j","__ZL15LookupSoundiconi","__ZL13LoadSoundFilePKci","__ZL14PushParamStacki","__ZL16GetSsmlAttributePwPKc","__ZL7attrcmpPKwPKc","__ZL10attrlookupPKwPK8MNEM_TAB","__ZL17ProcessParamStackPcRi","__ZL19SetProsodyParameteriPwP11PARAM_STACK","__ZL13PopParamStackiPcRi","__ZL10attrnumberPKwii","__ZL14ReplaceKeyNamePciRi","__ZL13attrcopy_utf8PcPKwi","__ZL14LoadSoundFile2PKc","__ZL18GetVoiceAttributesPwi","__ZL14VoiceFromStackv","__ZL18attr_prosody_valueiPKwPi","__ZL8GetC_getv","__ZL10GetC_ungeti","__Z8SetSpeedi","__Z12SetParameteriii","__Z11CalcLengthsP10Translator","__ZL11DoEmbedded2Pi","__Z20LookupAccentedLetterP10TranslatorjPc","__ZL13LookupLetter2P10TranslatorjPc","__Z12LookupLetterP10TranslatorjiPci","__Z15TranslateLetterP10TranslatorPcS1_i","__Z17SetSpellingStressP10TranslatorPcii","__Z14TranslateRomanP10TranslatorPcS1_P8WORD_TAB","__ZL15CheckDotOrdinalP10TranslatorPcS1_P8WORD_TABi","__ZL11hu_number_ePKcii","__Z15TranslateNumberP10TranslatorPcS1_PjP8WORD_TABi","__ZL17TranslateNumber_1P10TranslatorPcS1_PjP8WORD_TABi","__ZL15LookupThousandsP10TranslatoriiiPc","__ZL10LookupNum3P10TranslatoriPciii","__ZL10LookupNum2P10TranslatoriiPc","__ZL9M_Varianti","__Z15LoadMbrolaTablePKcS0_i","_setNoError_MBR","__Z15MbrolaTranslateP12PHONEME_LISTiiP7__sFILE","__ZL10GetMbrNameP12PHONEME_LISTP11PHONEME_TABS2_S2_PiS3_S3_","__ZL10WritePitchiiiii","__Z14MbrolaGenerateP12PHONEME_LISTPii","__Z10MbrolaFillii","__Z11MbrolaResetv","__Z10LoadPhDatav","__ZL10ReadPhFilePvPKcPi","__Z10FreePhDatav","__Z11PhonemeCodej","__Z19LookupPhonemeStringPKc","__Z11LookupSpectP11PHONEME_TABiP10FMT_PARAMSPiP12PHONEME_LIST","__Z11GetEnvelopei","__Z18SelectPhonemeTablei","__ZL17SetUpPhonemeTableii","__Z18LookupPhonemeTablePKc","__Z22SelectPhonemeTableNamePKc","__Z10LoadConfigv","__Z16InterpretPhonemeP10TranslatoriP12PHONEME_LISTP12PHONEME_DATA","__ZL12InvalidInstnP11PHONEME_TABi","__ZL15StressConditionP10TranslatorP12PHONEME_LISTii","__ZL18InterpretConditionP10TranslatoriP12PHONEME_LISTi","__ZL13NumInstnWordsPt","__ZL15SwitchVowelTypeP12PHONEME_LISTP12PHONEME_DATAPPti","__Z17InterpretPhoneme2iP12PHONEME_DATA","__Z12WordToStringj","__Z14SynthesizeInitv","__Z11PauseLengthii","__Z9DoSample3P12PHONEME_DATAii","__ZL8EndPitchi","__ZL9DoSample2iiiiii","__Z18FormantTransition2P10frameref_tRijjP11PHONEME_TABi","__ZL9CopyFrameP7frame_ti","__ZL13set_frame_rmsP7frame_ti","__ZL14AdjustFormantsP7frame_tiiiiiii","__ZL14VowelClosenessP7frame_t","__ZL18DuplicateLastFrameP10frameref_tii","__ZL7DoPauseii","__Z8DoSpect2P11PHONEME_TABiP10FMT_PARAMSP12PHONEME_LISTi","__ZL11SmoothSpectv","__Z8DoMarkeriiii","__Z12DoSonicSpeedi","__Z13DoVoiceChangeP7voice_t","__Z10DoEmbeddedPii","__Z8GenerateP12PHONEME_LISTPii","__ZL12EndAmplitudev","__ZL11DoAmplitudeiPh","__ZL7DoPitchPhii","__ZL13StartSyllablev","__Z12SynthOnTimerv","__Z15SpeakNextClauseP7__sFILEPKvi","__Z11SynthStatusv","__ZL18formants_reduce_hfP7frame_ti","__ZL10AllocFramev","__Z13SetLengthModsP10Translatori","__Z7IsAlphaj","__Z11lookupwcharPKti","__Z7IsDigitj","__Z7IsSpacej","__Z16DeleteTranslatorP10Translator","__Z9IsBracketi","__Z8utf8_outjPc","__Z11utf8_nbytesPKc","__Z8utf8_in2PiPKci","__Z7utf8_inPiPKc","__Z8strchr_wPKci","__Z10IsAllUpperPKc","__Z24ChangeEquivalentPhonemesP10TranslatoriPc","__Z13TranslateWordP10TranslatorPciP8WORD_TAB","__ZL17CheckDottedAbbrevPcP8WORD_TAB","__ZL22SpeakIndividualLettersP10TranslatorPcS1_i","__Z14SetTranslator2PKc","__Z15TranslateClauseP10TranslatorP7__sFILEPKvPiPPc","__ZL9IsDigit09j","__ZL15EmbeddedCommandRj","__ZL13TranslateCharP10TranslatorPcijjPi","__ZL14TranslateWord2P10TranslatorPcP8WORD_TABii","__Z8InitTexti","__ZL14CountSyllablesPh","__ZL9SetPlist2P13PHONEME_LIST2h","__ZL14SubstituteCharP10TranslatorjjPi","_init_MBR","__ZL12start_mbrolaPKc","__ZL14send_to_mbrolaPKc","__ZL11stop_mbrolav","__ZL19receive_from_mbrolaPvj","__ZL3errPKcz","_close_MBR","__ZL17free_pending_datav","_reset_MBR","__ZL17mbrola_has_errorsv","_read_MBR","_write_MBR","_flush_MBR","_getFreq_MBR","_setVolumeRatio_MBR","_lastErrorStr_MBR","_resetError_MBR","__ZL11mbrola_diedv","__ZL3logPKcz","__ZL14mbrola_is_idlev","__ZL12create_pipesPiS_S_","__ZL11close_pipesPiS_S_","__Z15SetIndicLettersP10Translator","__ZL18SetLetterBitsRangeP10Translatoriii","__ZL13SetLetterBitsP10TranslatoriPKc","__Z15SetupTranslatorP10TranslatorPKsPKh","__Z16SelectTranslatorPKc","__ZL13NewTranslatorv","__ZL14SetLetterVowelP10Translatori","__ZL18SetCyrillicLettersP10Translator","__ZL15ResetLetterBitsP10Translatori","__ZL18Translator_RussianP10Translator","__Z14ReadTonePointsPcPi","__Z10VoiceReseti","__ZL13SetToneAdjustP7voice_tPi","__Z9LoadVoicePKci","__ZL11fgets_stripPciP7__sFILE","__ZL12VoiceFormantPc","__ZL12Read8NumbersPcPi","__ZL10LookupTunePKc","__ZL18PhonemeReplacementiPc","__Z16LoadVoiceVariantPKci","__ZL23ExtractVoiceVariantNamePci","__Z17SelectVoiceByNamePP12espeak_VOICEPKc","_espeak_ListVoices","__Z11SelectVoiceP12espeak_VOICEPi","__ZL14SetVoiceScoresP12espeak_VOICEPS0_i","__Z14SetVoiceByNamePKc","__Z20SetVoiceByPropertiesP12espeak_VOICE","__ZL9GetVoicesPKc","__ZL15VoiceNameSorterPKvS0_","_espeak_GetCurrentVoice","__ZL13ReadVoiceFileP7__sFILEPKcS2_","__ZL10ScoreVoiceP12espeak_VOICEPKciiS0_","__ZL16VoiceScoreSorterPKvS0_","__Z9WcmdqStopv","__Z9WcmdqFreev","__Z9WcmdqUsedv","__Z8WcmdqIncv","__Z16WavegenOpenSoundv","__Z17WavegenCloseSoundv","__Z16WavegenInitSoundv","__Z11WavegenInitii","__ZL17WavegenInitPkDatai","__Z12GetAmplitudev","__Z16PeaksToHarmspectP15wavegen_peaks_tiPii","__Z10InitBreathv","__ZL12setresonatorP9RESONATORiii","__Z7Wavegenv","__ZL17AdvanceParametersv","__ZL9SetBreathv","__ZL11ApplyBreathv","__Z11SetEmbeddedii","__ZL13SetWithRange0ii","__ZL14WavegenSetEchov","__ZL16SetPitchFormantsv","__Z15WavegenSetVoiceP7voice_t","__Z9SetPitch2P7voice_tiiPiS1_","__Z8SetPitchiPhii","__Z8SetSynthiiP7frame_tS0_P7voice_t","__Z11Write4BytesP7__sFILEi","__Z12WavegenFill2i","__ZL11PlaySilenceii","__ZL8PlayWaveiiPhii","__ZL8Wavegen2iiiP7frame_tS0_","__ZL12SetAmplitudeiPhi","__ZL12WcmdqIncHeadv","__Z11WavegenFilli","__ZL7SpeedUpPsiii","__ZL9resonatorP9RESONATORd","__Z15MakePhonemeListP10Translatorii","__ZL18SubstitutePhonemesP10TranslatorP12PHONEME_LIST","__Z10KlattReseti","__ZL6setabcllP11resonator_t","__Z13Wavegen_Klatti","__ZL10frame_initP13klatt_frame_t","__ZL7parwaveP13klatt_frame_t","__Z14SetSynth_KlattiiP7frame_tS0_P7voice_ti","__Z14Wavegen_Klatt2iiiP7frame_tS0_","__Z9KlattInitv","__ZL7flutterP13klatt_frame_t","__ZL9gen_noised","__ZL16impulsive_sourcev","__ZL14natural_sourcev","__ZL14sampled_sourcev","__ZL21pitch_synch_par_resetP13klatt_frame_t","__ZL9resonatorP11resonator_td","__ZL14antiresonator2P11resonator_td","__ZL10resonator2P11resonator_td","__ZL7DBtoLINl","__ZL10setzeroabcllP11resonator_t","__Z8sonicMSGPcz","_sonicGetSpeed","_sonicSetSpeed","_sonicGetPitch","_sonicSetPitch","_sonicGetVolume","_sonicSetVolume","_sonicGetSampleRate","_sonicGetNumChannels","_sonicDestroyStream","_sonicCreateStream","_sonicReadFloatFromStream","_sonicReadShortFromStream","_sonicReadUnsignedCharFromStream","_sonicFlushStream","_sonicWriteShortToStream","_sonicSamplesAvailable","_sonicWriteFloatToStream","__ZL28addFloatSamplesToInputBufferP17sonicStreamStructPfi","__ZL18processStreamInputP17sonicStreamStruct","__ZL28addShortSamplesToInputBufferP17sonicStreamStructPsi","_sonicWriteUnsignedCharToStream","__ZL35addUnsignedCharSamplesToInputBufferP17sonicStreamStructPhi","_sonicChangeFloatSpeed","_sonicChangeShortSpeed","__ZL26enlargeInputBufferIfNeededP17sonicStreamStructi","__ZL11changeSpeedP17sonicStreamStructf","__ZL12copyToOutputP17sonicStreamStructPsi","__ZL11adjustPitchP17sonicStreamStructi","__ZL12scaleSamplesPsif","__ZL27moveNewSamplesToPitchBufferP17sonicStreamStructi","__ZL15findPitchPeriodP17sonicStreamStructPs","__ZL27enlargeOutputBufferIfNeededP17sonicStreamStructi","__ZL10overlapAddiiPsS_S_","__ZL24overlapAddWithSeparationiiiPsS_S_","__ZL18removePitchSamplesP17sonicStreamStructi","__ZL22findPitchPeriodInRangePsiiPiS0_","__ZL15downSampleInputP17sonicStreamStructPsi","__ZL16prevPeriodBetterP17sonicStreamStructiii","__ZL17copyInputToOutputP17sonicStreamStructi","__ZL15skipPitchPeriodP17sonicStreamStructPsfi","__ZL17insertPitchPeriodP17sonicStreamStructPsfi","__ZL18removeInputSamplesP17sonicStreamStructi","_getopt","__ZL12read_globalsP11getopt_data","__ZL15getopt_internaliPKPcPKcPK6optionPiiP11getopt_data","__ZL13write_globalsP11getopt_data","_getopt_long","_getopt_long_only","___getopt_r","___getopt_long_r","___getopt_long_only_r","__ZL9is_optionPci","__ZL7permutePKPcii","__ZL21reverse_argv_elementsPPci","___strtok_r","_strtok_r","_strtok"]


return {
	Module: Module,
	FS: FS,
	run: run
};
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(0));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

function Context(indented, column, type, info, align, prev) {
  this.indented = indented;
  this.column = column;
  this.type = type;
  this.info = info;
  this.align = align;
  this.prev = prev;
}
function pushContext(state, col, type, info) {
  var indent = state.indented;
  if (state.context && state.context.type == "statement" && type != "statement")
    indent = state.context.indented;
  return state.context = new Context(indent, col, type, info, null, state.context);
}
function popContext(state) {
  var t = state.context.type;
  if (t == ")" || t == "]" || t == "}")
    state.indented = state.context.indented;
  return state.context = state.context.prev;
}

function typeBefore(stream, state, pos) {
  if (state.prevToken == "variable" || state.prevToken == "type") return true;
  if (/\S(?:[^- ]>|[*\]])\s*$|\*$/.test(stream.string.slice(0, pos))) return true;
  if (state.typeAtEndOfLine && stream.column() == stream.indentation()) return true;
}

function isTopScope(context) {
  for (;;) {
    if (!context || context.type == "top") return true;
    if (context.type == "}" && context.prev.info != "namespace") return false;
    context = context.prev;
  }
}

CodeMirror.defineMode("clike", function(config, parserConfig) {
  var indentUnit = config.indentUnit,
      statementIndentUnit = parserConfig.statementIndentUnit || indentUnit,
      dontAlignCalls = parserConfig.dontAlignCalls,
      keywords = parserConfig.keywords || {},
      types = parserConfig.types || {},
      builtin = parserConfig.builtin || {},
      blockKeywords = parserConfig.blockKeywords || {},
      defKeywords = parserConfig.defKeywords || {},
      atoms = parserConfig.atoms || {},
      hooks = parserConfig.hooks || {},
      multiLineStrings = parserConfig.multiLineStrings,
      indentStatements = parserConfig.indentStatements !== false,
      indentSwitch = parserConfig.indentSwitch !== false,
      namespaceSeparator = parserConfig.namespaceSeparator,
      isPunctuationChar = parserConfig.isPunctuationChar || /[\[\]{}\(\),;\:\.]/,
      numberStart = parserConfig.numberStart || /[\d\.]/,
      number = parserConfig.number || /^(?:0x[a-f\d]+|0b[01]+|(?:\d+\.?\d*|\.\d+)(?:e[-+]?\d+)?)(u|ll?|l|f)?/i,
      isOperatorChar = parserConfig.isOperatorChar || /[+\-*&%=<>!?|\/]/,
      isIdentifierChar = parserConfig.isIdentifierChar || /[\w\$_\xa1-\uffff]/;

  var curPunc, isDefKeyword;

  function tokenBase(stream, state) {
    var ch = stream.next();
    if (hooks[ch]) {
      var result = hooks[ch](stream, state);
      if (result !== false) return result;
    }
    if (ch == '"' || ch == "'") {
      state.tokenize = tokenString(ch);
      return state.tokenize(stream, state);
    }
    if (isPunctuationChar.test(ch)) {
      curPunc = ch;
      return null;
    }
    if (numberStart.test(ch)) {
      stream.backUp(1)
      if (stream.match(number)) return "number"
      stream.next()
    }
    if (ch == "/") {
      if (stream.eat("*")) {
        state.tokenize = tokenComment;
        return tokenComment(stream, state);
      }
      if (stream.eat("/")) {
        stream.skipToEnd();
        return "comment";
      }
    }
    if (isOperatorChar.test(ch)) {
      while (!stream.match(/^\/[\/*]/, false) && stream.eat(isOperatorChar)) {}
      return "operator";
    }
    stream.eatWhile(isIdentifierChar);
    if (namespaceSeparator) while (stream.match(namespaceSeparator))
      stream.eatWhile(isIdentifierChar);

    var cur = stream.current();
    if (contains(keywords, cur)) {
      if (contains(blockKeywords, cur)) curPunc = "newstatement";
      if (contains(defKeywords, cur)) isDefKeyword = true;
      return "keyword";
    }
    if (contains(types, cur)) return "type";
    if (contains(builtin, cur)) {
      if (contains(blockKeywords, cur)) curPunc = "newstatement";
      return "builtin";
    }
    if (contains(atoms, cur)) return "atom";
    return "variable";
  }

  function tokenString(quote) {
    return function(stream, state) {
      var escaped = false, next, end = false;
      while ((next = stream.next()) != null) {
        if (next == quote && !escaped) {end = true; break;}
        escaped = !escaped && next == "\\";
      }
      if (end || !(escaped || multiLineStrings))
        state.tokenize = null;
      return "string";
    };
  }

  function tokenComment(stream, state) {
    var maybeEnd = false, ch;
    while (ch = stream.next()) {
      if (ch == "/" && maybeEnd) {
        state.tokenize = null;
        break;
      }
      maybeEnd = (ch == "*");
    }
    return "comment";
  }

  function maybeEOL(stream, state) {
    if (parserConfig.typeFirstDefinitions && stream.eol() && isTopScope(state.context))
      state.typeAtEndOfLine = typeBefore(stream, state, stream.pos)
  }

  // Interface

  return {
    startState: function(basecolumn) {
      return {
        tokenize: null,
        context: new Context((basecolumn || 0) - indentUnit, 0, "top", null, false),
        indented: 0,
        startOfLine: true,
        prevToken: null
      };
    },

    token: function(stream, state) {
      var ctx = state.context;
      if (stream.sol()) {
        if (ctx.align == null) ctx.align = false;
        state.indented = stream.indentation();
        state.startOfLine = true;
      }
      if (stream.eatSpace()) { maybeEOL(stream, state); return null; }
      curPunc = isDefKeyword = null;
      var style = (state.tokenize || tokenBase)(stream, state);
      if (style == "comment" || style == "meta") return style;
      if (ctx.align == null) ctx.align = true;

      if (curPunc == ";" || curPunc == ":" || (curPunc == "," && stream.match(/^\s*(?:\/\/.*)?$/, false)))
        while (state.context.type == "statement") popContext(state);
      else if (curPunc == "{") pushContext(state, stream.column(), "}");
      else if (curPunc == "[") pushContext(state, stream.column(), "]");
      else if (curPunc == "(") pushContext(state, stream.column(), ")");
      else if (curPunc == "}") {
        while (ctx.type == "statement") ctx = popContext(state);
        if (ctx.type == "}") ctx = popContext(state);
        while (ctx.type == "statement") ctx = popContext(state);
      }
      else if (curPunc == ctx.type) popContext(state);
      else if (indentStatements &&
               (((ctx.type == "}" || ctx.type == "top") && curPunc != ";") ||
                (ctx.type == "statement" && curPunc == "newstatement"))) {
        pushContext(state, stream.column(), "statement", stream.current());
      }

      if (style == "variable" &&
          ((state.prevToken == "def" ||
            (parserConfig.typeFirstDefinitions && typeBefore(stream, state, stream.start) &&
             isTopScope(state.context) && stream.match(/^\s*\(/, false)))))
        style = "def";

      if (hooks.token) {
        var result = hooks.token(stream, state, style);
        if (result !== undefined) style = result;
      }

      if (style == "def" && parserConfig.styleDefs === false) style = "variable";

      state.startOfLine = false;
      state.prevToken = isDefKeyword ? "def" : style || curPunc;
      maybeEOL(stream, state);
      return style;
    },

    indent: function(state, textAfter) {
      if (state.tokenize != tokenBase && state.tokenize != null || state.typeAtEndOfLine) return CodeMirror.Pass;
      var ctx = state.context, firstChar = textAfter && textAfter.charAt(0);
      if (ctx.type == "statement" && firstChar == "}") ctx = ctx.prev;
      if (parserConfig.dontIndentStatements)
        while (ctx.type == "statement" && parserConfig.dontIndentStatements.test(ctx.info))
          ctx = ctx.prev
      if (hooks.indent) {
        var hook = hooks.indent(state, ctx, textAfter);
        if (typeof hook == "number") return hook
      }
      var closing = firstChar == ctx.type;
      var switchBlock = ctx.prev && ctx.prev.info == "switch";
      if (parserConfig.allmanIndentation && /[{(]/.test(firstChar)) {
        while (ctx.type != "top" && ctx.type != "}") ctx = ctx.prev
        return ctx.indented
      }
      if (ctx.type == "statement")
        return ctx.indented + (firstChar == "{" ? 0 : statementIndentUnit);
      if (ctx.align && (!dontAlignCalls || ctx.type != ")"))
        return ctx.column + (closing ? 0 : 1);
      if (ctx.type == ")" && !closing)
        return ctx.indented + statementIndentUnit;

      return ctx.indented + (closing ? 0 : indentUnit) +
        (!closing && switchBlock && !/^(?:case|default)\b/.test(textAfter) ? indentUnit : 0);
    },

    electricInput: indentSwitch ? /^\s*(?:case .*?:|default:|\{\}?|\})$/ : /^\s*[{}]$/,
    blockCommentStart: "/*",
    blockCommentEnd: "*/",
    blockCommentContinue: " * ",
    lineComment: "//",
    fold: "brace"
  };
});

  function words(str) {
    var obj = {}, words = str.split(" ");
    for (var i = 0; i < words.length; ++i) obj[words[i]] = true;
    return obj;
  }
  function contains(words, word) {
    if (typeof words === "function") {
      return words(word);
    } else {
      return words.propertyIsEnumerable(word);
    }
  }
  var cKeywords = "auto if break case register continue return default do sizeof " +
    "static else struct switch extern typedef union for goto while enum const volatile";
  var cTypes = "int long char short double float unsigned signed void size_t ptrdiff_t";

  function cppHook(stream, state) {
    if (!state.startOfLine) return false
    for (var ch, next = null; ch = stream.peek();) {
      if (ch == "\\" && stream.match(/^.$/)) {
        next = cppHook
        break
      } else if (ch == "/" && stream.match(/^\/[\/\*]/, false)) {
        break
      }
      stream.next()
    }
    state.tokenize = next
    return "meta"
  }

  function pointerHook(_stream, state) {
    if (state.prevToken == "type") return "type";
    return false;
  }

  function cpp14Literal(stream) {
    stream.eatWhile(/[\w\.']/);
    return "number";
  }

  function cpp11StringHook(stream, state) {
    stream.backUp(1);
    // Raw strings.
    if (stream.match(/(R|u8R|uR|UR|LR)/)) {
      var match = stream.match(/"([^\s\\()]{0,16})\(/);
      if (!match) {
        return false;
      }
      state.cpp11RawStringDelim = match[1];
      state.tokenize = tokenRawString;
      return tokenRawString(stream, state);
    }
    // Unicode strings/chars.
    if (stream.match(/(u8|u|U|L)/)) {
      if (stream.match(/["']/, /* eat */ false)) {
        return "string";
      }
      return false;
    }
    // Ignore this hook.
    stream.next();
    return false;
  }

  function cppLooksLikeConstructor(word) {
    var lastTwo = /(\w+)::~?(\w+)$/.exec(word);
    return lastTwo && lastTwo[1] == lastTwo[2];
  }

  // C#-style strings where "" escapes a quote.
  function tokenAtString(stream, state) {
    var next;
    while ((next = stream.next()) != null) {
      if (next == '"' && !stream.eat('"')) {
        state.tokenize = null;
        break;
      }
    }
    return "string";
  }

  // C++11 raw string literal is <prefix>"<delim>( anything )<delim>", where
  // <delim> can be a string up to 16 characters long.
  function tokenRawString(stream, state) {
    // Escape characters that have special regex meanings.
    var delim = state.cpp11RawStringDelim.replace(/[^\w\s]/g, '\\$&');
    var match = stream.match(new RegExp(".*?\\)" + delim + '"'));
    if (match)
      state.tokenize = null;
    else
      stream.skipToEnd();
    return "string";
  }

  function def(mimes, mode) {
    if (typeof mimes == "string") mimes = [mimes];
    var words = [];
    function add(obj) {
      if (obj) for (var prop in obj) if (obj.hasOwnProperty(prop))
        words.push(prop);
    }
    add(mode.keywords);
    add(mode.types);
    add(mode.builtin);
    add(mode.atoms);
    if (words.length) {
      mode.helperType = mimes[0];
      CodeMirror.registerHelper("hintWords", mimes[0], words);
    }

    for (var i = 0; i < mimes.length; ++i)
      CodeMirror.defineMIME(mimes[i], mode);
  }

  def(["text/x-csrc", "text/x-c", "text/x-chdr"], {
    name: "clike",
    keywords: words(cKeywords),
    types: words(cTypes + " bool _Complex _Bool float_t double_t intptr_t intmax_t " +
                 "int8_t int16_t int32_t int64_t uintptr_t uintmax_t uint8_t uint16_t " +
                 "uint32_t uint64_t"),
    blockKeywords: words("case do else for if switch while struct"),
    defKeywords: words("struct"),
    typeFirstDefinitions: true,
    atoms: words("NULL true false"),
    hooks: {"#": cppHook, "*": pointerHook},
    modeProps: {fold: ["brace", "include"]}
  });

  def(["text/x-c++src", "text/x-c++hdr"], {
    name: "clike",
    keywords: words(cKeywords + " asm dynamic_cast namespace reinterpret_cast try explicit new " +
                    "static_cast typeid catch operator template typename class friend private " +
                    "this using const_cast inline public throw virtual delete mutable protected " +
                    "alignas alignof constexpr decltype nullptr noexcept thread_local final " +
                    "static_assert override"),
    types: words(cTypes + " bool wchar_t"),
    blockKeywords: words("catch class do else finally for if struct switch try while"),
    defKeywords: words("class namespace struct enum union"),
    typeFirstDefinitions: true,
    atoms: words("true false NULL"),
    dontIndentStatements: /^template$/,
    isIdentifierChar: /[\w\$_~\xa1-\uffff]/,
    hooks: {
      "#": cppHook,
      "*": pointerHook,
      "u": cpp11StringHook,
      "U": cpp11StringHook,
      "L": cpp11StringHook,
      "R": cpp11StringHook,
      "0": cpp14Literal,
      "1": cpp14Literal,
      "2": cpp14Literal,
      "3": cpp14Literal,
      "4": cpp14Literal,
      "5": cpp14Literal,
      "6": cpp14Literal,
      "7": cpp14Literal,
      "8": cpp14Literal,
      "9": cpp14Literal,
      token: function(stream, state, style) {
        if (style == "variable" && stream.peek() == "(" &&
            (state.prevToken == ";" || state.prevToken == null ||
             state.prevToken == "}") &&
            cppLooksLikeConstructor(stream.current()))
          return "def";
      }
    },
    namespaceSeparator: "::",
    modeProps: {fold: ["brace", "include"]}
  });

  def("text/x-java", {
    name: "clike",
    keywords: words("abstract assert break case catch class const continue default " +
                    "do else enum extends final finally float for goto if implements import " +
                    "instanceof interface native new package private protected public " +
                    "return static strictfp super switch synchronized this throw throws transient " +
                    "try volatile while @interface"),
    types: words("byte short int long float double boolean char void Boolean Byte Character Double Float " +
                 "Integer Long Number Object Short String StringBuffer StringBuilder Void"),
    blockKeywords: words("catch class do else finally for if switch try while"),
    defKeywords: words("class interface enum @interface"),
    typeFirstDefinitions: true,
    atoms: words("true false null"),
    number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+\.?\d*|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
    hooks: {
      "@": function(stream) {
        // Don't match the @interface keyword.
        if (stream.match('interface', false)) return false;

        stream.eatWhile(/[\w\$_]/);
        return "meta";
      }
    },
    modeProps: {fold: ["brace", "import"]}
  });

  def("text/x-csharp", {
    name: "clike",
    keywords: words("abstract as async await base break case catch checked class const continue" +
                    " default delegate do else enum event explicit extern finally fixed for" +
                    " foreach goto if implicit in interface internal is lock namespace new" +
                    " operator out override params private protected public readonly ref return sealed" +
                    " sizeof stackalloc static struct switch this throw try typeof unchecked" +
                    " unsafe using virtual void volatile while add alias ascending descending dynamic from get" +
                    " global group into join let orderby partial remove select set value var yield"),
    types: words("Action Boolean Byte Char DateTime DateTimeOffset Decimal Double Func" +
                 " Guid Int16 Int32 Int64 Object SByte Single String Task TimeSpan UInt16 UInt32" +
                 " UInt64 bool byte char decimal double short int long object"  +
                 " sbyte float string ushort uint ulong"),
    blockKeywords: words("catch class do else finally for foreach if struct switch try while"),
    defKeywords: words("class interface namespace struct var"),
    typeFirstDefinitions: true,
    atoms: words("true false null"),
    hooks: {
      "@": function(stream, state) {
        if (stream.eat('"')) {
          state.tokenize = tokenAtString;
          return tokenAtString(stream, state);
        }
        stream.eatWhile(/[\w\$_]/);
        return "meta";
      }
    }
  });

  function tokenTripleString(stream, state) {
    var escaped = false;
    while (!stream.eol()) {
      if (!escaped && stream.match('"""')) {
        state.tokenize = null;
        break;
      }
      escaped = stream.next() == "\\" && !escaped;
    }
    return "string";
  }

  function tokenNestedComment(depth) {
    return function (stream, state) {
      var ch
      while (ch = stream.next()) {
        if (ch == "*" && stream.eat("/")) {
          if (depth == 1) {
            state.tokenize = null
            break
          } else {
            state.tokenize = tokenNestedComment(depth - 1)
            return state.tokenize(stream, state)
          }
        } else if (ch == "/" && stream.eat("*")) {
          state.tokenize = tokenNestedComment(depth + 1)
          return state.tokenize(stream, state)
        }
      }
      return "comment"
    }
  }

  def("text/x-scala", {
    name: "clike",
    keywords: words(

      /* scala */
      "abstract case catch class def do else extends final finally for forSome if " +
      "implicit import lazy match new null object override package private protected return " +
      "sealed super this throw trait try type val var while with yield _ " +

      /* package scala */
      "assert assume require print println printf readLine readBoolean readByte readShort " +
      "readChar readInt readLong readFloat readDouble"
    ),
    types: words(
      "AnyVal App Application Array BufferedIterator BigDecimal BigInt Char Console Either " +
      "Enumeration Equiv Error Exception Fractional Function IndexedSeq Int Integral Iterable " +
      "Iterator List Map Numeric Nil NotNull Option Ordered Ordering PartialFunction PartialOrdering " +
      "Product Proxy Range Responder Seq Serializable Set Specializable Stream StringBuilder " +
      "StringContext Symbol Throwable Traversable TraversableOnce Tuple Unit Vector " +

      /* package java.lang */
      "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " +
      "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " +
      "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " +
      "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void"
    ),
    multiLineStrings: true,
    blockKeywords: words("catch class enum do else finally for forSome if match switch try while"),
    defKeywords: words("class enum def object package trait type val var"),
    atoms: words("true false null"),
    indentStatements: false,
    indentSwitch: false,
    isOperatorChar: /[+\-*&%=<>!?|\/#:@]/,
    hooks: {
      "@": function(stream) {
        stream.eatWhile(/[\w\$_]/);
        return "meta";
      },
      '"': function(stream, state) {
        if (!stream.match('""')) return false;
        state.tokenize = tokenTripleString;
        return state.tokenize(stream, state);
      },
      "'": function(stream) {
        stream.eatWhile(/[\w\$_\xa1-\uffff]/);
        return "atom";
      },
      "=": function(stream, state) {
        var cx = state.context
        if (cx.type == "}" && cx.align && stream.eat(">")) {
          state.context = new Context(cx.indented, cx.column, cx.type, cx.info, null, cx.prev)
          return "operator"
        } else {
          return false
        }
      },

      "/": function(stream, state) {
        if (!stream.eat("*")) return false
        state.tokenize = tokenNestedComment(1)
        return state.tokenize(stream, state)
      }
    },
    modeProps: {closeBrackets: {triples: '"'}}
  });

  function tokenKotlinString(tripleString){
    return function (stream, state) {
      var escaped = false, next, end = false;
      while (!stream.eol()) {
        if (!tripleString && !escaped && stream.match('"') ) {end = true; break;}
        if (tripleString && stream.match('"""')) {end = true; break;}
        next = stream.next();
        if(!escaped && next == "$" && stream.match('{'))
          stream.skipTo("}");
        escaped = !escaped && next == "\\" && !tripleString;
      }
      if (end || !tripleString)
        state.tokenize = null;
      return "string";
    }
  }

  def("text/x-kotlin", {
    name: "clike",
    keywords: words(
      /*keywords*/
      "package as typealias class interface this super val operator " +
      "var fun for is in This throw return annotation " +
      "break continue object if else while do try when !in !is as? " +

      /*soft keywords*/
      "file import where by get set abstract enum open inner override private public internal " +
      "protected catch finally out final vararg reified dynamic companion constructor init " +
      "sealed field property receiver param sparam lateinit data inline noinline tailrec " +
      "external annotation crossinline const operator infix suspend actual expect setparam"
    ),
    types: words(
      /* package java.lang */
      "Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable " +
      "Compiler Double Exception Float Integer Long Math Number Object Package Pair Process " +
      "Runtime Runnable SecurityManager Short StackTraceElement StrictMath String " +
      "StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void Annotation Any BooleanArray " +
      "ByteArray Char CharArray DeprecationLevel DoubleArray Enum FloatArray Function Int IntArray Lazy " +
      "LazyThreadSafetyMode LongArray Nothing ShortArray Unit"
    ),
    intendSwitch: false,
    indentStatements: false,
    multiLineStrings: true,
    number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+(\.\d+)?|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
    blockKeywords: words("catch class do else finally for if where try while enum"),
    defKeywords: words("class val var object interface fun"),
    atoms: words("true false null this"),
    hooks: {
      "@": function(stream) {
        stream.eatWhile(/[\w\$_]/);
        return "meta";
      },
      '"': function(stream, state) {
        state.tokenize = tokenKotlinString(stream.match('""'));
        return state.tokenize(stream, state);
      }
    },
    modeProps: {closeBrackets: {triples: '"'}}
  });

  def(["x-shader/x-vertex", "x-shader/x-fragment"], {
    name: "clike",
    keywords: words("sampler1D sampler2D sampler3D samplerCube " +
                    "sampler1DShadow sampler2DShadow " +
                    "const attribute uniform varying " +
                    "break continue discard return " +
                    "for while do if else struct " +
                    "in out inout"),
    types: words("float int bool void " +
                 "vec2 vec3 vec4 ivec2 ivec3 ivec4 bvec2 bvec3 bvec4 " +
                 "mat2 mat3 mat4"),
    blockKeywords: words("for while do if else struct"),
    builtin: words("radians degrees sin cos tan asin acos atan " +
                    "pow exp log exp2 sqrt inversesqrt " +
                    "abs sign floor ceil fract mod min max clamp mix step smoothstep " +
                    "length distance dot cross normalize ftransform faceforward " +
                    "reflect refract matrixCompMult " +
                    "lessThan lessThanEqual greaterThan greaterThanEqual " +
                    "equal notEqual any all not " +
                    "texture1D texture1DProj texture1DLod texture1DProjLod " +
                    "texture2D texture2DProj texture2DLod texture2DProjLod " +
                    "texture3D texture3DProj texture3DLod texture3DProjLod " +
                    "textureCube textureCubeLod " +
                    "shadow1D shadow2D shadow1DProj shadow2DProj " +
                    "shadow1DLod shadow2DLod shadow1DProjLod shadow2DProjLod " +
                    "dFdx dFdy fwidth " +
                    "noise1 noise2 noise3 noise4"),
    atoms: words("true false " +
                "gl_FragColor gl_SecondaryColor gl_Normal gl_Vertex " +
                "gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 " +
                "gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 " +
                "gl_FogCoord gl_PointCoord " +
                "gl_Position gl_PointSize gl_ClipVertex " +
                "gl_FrontColor gl_BackColor gl_FrontSecondaryColor gl_BackSecondaryColor " +
                "gl_TexCoord gl_FogFragCoord " +
                "gl_FragCoord gl_FrontFacing " +
                "gl_FragData gl_FragDepth " +
                "gl_ModelViewMatrix gl_ProjectionMatrix gl_ModelViewProjectionMatrix " +
                "gl_TextureMatrix gl_NormalMatrix gl_ModelViewMatrixInverse " +
                "gl_ProjectionMatrixInverse gl_ModelViewProjectionMatrixInverse " +
                "gl_TexureMatrixTranspose gl_ModelViewMatrixInverseTranspose " +
                "gl_ProjectionMatrixInverseTranspose " +
                "gl_ModelViewProjectionMatrixInverseTranspose " +
                "gl_TextureMatrixInverseTranspose " +
                "gl_NormalScale gl_DepthRange gl_ClipPlane " +
                "gl_Point gl_FrontMaterial gl_BackMaterial gl_LightSource gl_LightModel " +
                "gl_FrontLightModelProduct gl_BackLightModelProduct " +
                "gl_TextureColor gl_EyePlaneS gl_EyePlaneT gl_EyePlaneR gl_EyePlaneQ " +
                "gl_FogParameters " +
                "gl_MaxLights gl_MaxClipPlanes gl_MaxTextureUnits gl_MaxTextureCoords " +
                "gl_MaxVertexAttribs gl_MaxVertexUniformComponents gl_MaxVaryingFloats " +
                "gl_MaxVertexTextureImageUnits gl_MaxTextureImageUnits " +
                "gl_MaxFragmentUniformComponents gl_MaxCombineTextureImageUnits " +
                "gl_MaxDrawBuffers"),
    indentSwitch: false,
    hooks: {"#": cppHook},
    modeProps: {fold: ["brace", "include"]}
  });

  def("text/x-nesc", {
    name: "clike",
    keywords: words(cKeywords + "as atomic async call command component components configuration event generic " +
                    "implementation includes interface module new norace nx_struct nx_union post provides " +
                    "signal task uses abstract extends"),
    types: words(cTypes),
    blockKeywords: words("case do else for if switch while struct"),
    atoms: words("null true false"),
    hooks: {"#": cppHook},
    modeProps: {fold: ["brace", "include"]}
  });

  def("text/x-objectivec", {
    name: "clike",
    keywords: words(cKeywords + "inline restrict _Bool _Complex _Imaginary BOOL Class bycopy byref id IMP in " +
                    "inout nil oneway out Protocol SEL self super atomic nonatomic retain copy readwrite readonly"),
    types: words(cTypes),
    atoms: words("YES NO NULL NILL ON OFF true false"),
    hooks: {
      "@": function(stream) {
        stream.eatWhile(/[\w\$]/);
        return "keyword";
      },
      "#": cppHook,
      indent: function(_state, ctx, textAfter) {
        if (ctx.type == "statement" && /^@\w/.test(textAfter)) return ctx.indented
      }
    },
    modeProps: {fold: "brace"}
  });

  def("text/x-squirrel", {
    name: "clike",
    keywords: words("base break clone continue const default delete enum extends function in class" +
                    " foreach local resume return this throw typeof yield constructor instanceof static"),
    types: words(cTypes),
    blockKeywords: words("case catch class else for foreach if switch try while"),
    defKeywords: words("function local class"),
    typeFirstDefinitions: true,
    atoms: words("true false null"),
    hooks: {"#": cppHook},
    modeProps: {fold: ["brace", "include"]}
  });

  // Ceylon Strings need to deal with interpolation
  var stringTokenizer = null;
  function tokenCeylonString(type) {
    return function(stream, state) {
      var escaped = false, next, end = false;
      while (!stream.eol()) {
        if (!escaped && stream.match('"') &&
              (type == "single" || stream.match('""'))) {
          end = true;
          break;
        }
        if (!escaped && stream.match('``')) {
          stringTokenizer = tokenCeylonString(type);
          end = true;
          break;
        }
        next = stream.next();
        escaped = type == "single" && !escaped && next == "\\";
      }
      if (end)
          state.tokenize = null;
      return "string";
    }
  }

  def("text/x-ceylon", {
    name: "clike",
    keywords: words("abstracts alias assembly assert assign break case catch class continue dynamic else" +
                    " exists extends finally for function given if import in interface is let module new" +
                    " nonempty object of out outer package return satisfies super switch then this throw" +
                    " try value void while"),
    types: function(word) {
        // In Ceylon all identifiers that start with an uppercase are types
        var first = word.charAt(0);
        return (first === first.toUpperCase() && first !== first.toLowerCase());
    },
    blockKeywords: words("case catch class dynamic else finally for function if interface module new object switch try while"),
    defKeywords: words("class dynamic function interface module object package value"),
    builtin: words("abstract actual aliased annotation by default deprecated doc final formal late license" +
                   " native optional sealed see serializable shared suppressWarnings tagged throws variable"),
    isPunctuationChar: /[\[\]{}\(\),;\:\.`]/,
    isOperatorChar: /[+\-*&%=<>!?|^~:\/]/,
    numberStart: /[\d#$]/,
    number: /^(?:#[\da-fA-F_]+|\$[01_]+|[\d_]+[kMGTPmunpf]?|[\d_]+\.[\d_]+(?:[eE][-+]?\d+|[kMGTPmunpf]|)|)/i,
    multiLineStrings: true,
    typeFirstDefinitions: true,
    atoms: words("true false null larger smaller equal empty finished"),
    indentSwitch: false,
    styleDefs: false,
    hooks: {
      "@": function(stream) {
        stream.eatWhile(/[\w\$_]/);
        return "meta";
      },
      '"': function(stream, state) {
          state.tokenize = tokenCeylonString(stream.match('""') ? "triple" : "single");
          return state.tokenize(stream, state);
        },
      '`': function(stream, state) {
          if (!stringTokenizer || !stream.match('`')) return false;
          state.tokenize = stringTokenizer;
          stringTokenizer = null;
          return state.tokenize(stream, state);
        },
      "'": function(stream) {
        stream.eatWhile(/[\w\$_\xa1-\uffff]/);
        return "atom";
      },
      token: function(_stream, state, style) {
          if ((style == "variable" || style == "type") &&
              state.prevToken == ".") {
            return "variable-2";
          }
        }
    },
    modeProps: {
        fold: ["brace", "import"],
        closeBrackets: {triples: '"'}
    }
  });

});


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

// A rough approximation of Sublime Text's keybindings
// Depends on addon/search/searchcursor.js and optionally addon/dialog/dialogs.js

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(0), __webpack_require__(13), __webpack_require__(14));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../lib/codemirror", "../addon/search/searchcursor", "../addon/edit/matchbrackets"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  "use strict";

  var cmds = CodeMirror.commands;
  var Pos = CodeMirror.Pos;

  // This is not exactly Sublime's algorithm. I couldn't make heads or tails of that.
  function findPosSubword(doc, start, dir) {
    if (dir < 0 && start.ch == 0) return doc.clipPos(Pos(start.line - 1));
    var line = doc.getLine(start.line);
    if (dir > 0 && start.ch >= line.length) return doc.clipPos(Pos(start.line + 1, 0));
    var state = "start", type;
    for (var pos = start.ch, e = dir < 0 ? 0 : line.length, i = 0; pos != e; pos += dir, i++) {
      var next = line.charAt(dir < 0 ? pos - 1 : pos);
      var cat = next != "_" && CodeMirror.isWordChar(next) ? "w" : "o";
      if (cat == "w" && next.toUpperCase() == next) cat = "W";
      if (state == "start") {
        if (cat != "o") { state = "in"; type = cat; }
      } else if (state == "in") {
        if (type != cat) {
          if (type == "w" && cat == "W" && dir < 0) pos--;
          if (type == "W" && cat == "w" && dir > 0) { type = "w"; continue; }
          break;
        }
      }
    }
    return Pos(start.line, pos);
  }

  function moveSubword(cm, dir) {
    cm.extendSelectionsBy(function(range) {
      if (cm.display.shift || cm.doc.extend || range.empty())
        return findPosSubword(cm.doc, range.head, dir);
      else
        return dir < 0 ? range.from() : range.to();
    });
  }

  cmds.goSubwordLeft = function(cm) { moveSubword(cm, -1); };
  cmds.goSubwordRight = function(cm) { moveSubword(cm, 1); };

  cmds.scrollLineUp = function(cm) {
    var info = cm.getScrollInfo();
    if (!cm.somethingSelected()) {
      var visibleBottomLine = cm.lineAtHeight(info.top + info.clientHeight, "local");
      if (cm.getCursor().line >= visibleBottomLine)
        cm.execCommand("goLineUp");
    }
    cm.scrollTo(null, info.top - cm.defaultTextHeight());
  };
  cmds.scrollLineDown = function(cm) {
    var info = cm.getScrollInfo();
    if (!cm.somethingSelected()) {
      var visibleTopLine = cm.lineAtHeight(info.top, "local")+1;
      if (cm.getCursor().line <= visibleTopLine)
        cm.execCommand("goLineDown");
    }
    cm.scrollTo(null, info.top + cm.defaultTextHeight());
  };

  cmds.splitSelectionByLine = function(cm) {
    var ranges = cm.listSelections(), lineRanges = [];
    for (var i = 0; i < ranges.length; i++) {
      var from = ranges[i].from(), to = ranges[i].to();
      for (var line = from.line; line <= to.line; ++line)
        if (!(to.line > from.line && line == to.line && to.ch == 0))
          lineRanges.push({anchor: line == from.line ? from : Pos(line, 0),
                           head: line == to.line ? to : Pos(line)});
    }
    cm.setSelections(lineRanges, 0);
  };

  cmds.singleSelectionTop = function(cm) {
    var range = cm.listSelections()[0];
    cm.setSelection(range.anchor, range.head, {scroll: false});
  };

  cmds.selectLine = function(cm) {
    var ranges = cm.listSelections(), extended = [];
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      extended.push({anchor: Pos(range.from().line, 0),
                     head: Pos(range.to().line + 1, 0)});
    }
    cm.setSelections(extended);
  };

  function insertLine(cm, above) {
    if (cm.isReadOnly()) return CodeMirror.Pass
    cm.operation(function() {
      var len = cm.listSelections().length, newSelection = [], last = -1;
      for (var i = 0; i < len; i++) {
        var head = cm.listSelections()[i].head;
        if (head.line <= last) continue;
        var at = Pos(head.line + (above ? 0 : 1), 0);
        cm.replaceRange("\n", at, null, "+insertLine");
        cm.indentLine(at.line, null, true);
        newSelection.push({head: at, anchor: at});
        last = head.line + 1;
      }
      cm.setSelections(newSelection);
    });
    cm.execCommand("indentAuto");
  }

  cmds.insertLineAfter = function(cm) { return insertLine(cm, false); };

  cmds.insertLineBefore = function(cm) { return insertLine(cm, true); };

  function wordAt(cm, pos) {
    var start = pos.ch, end = start, line = cm.getLine(pos.line);
    while (start && CodeMirror.isWordChar(line.charAt(start - 1))) --start;
    while (end < line.length && CodeMirror.isWordChar(line.charAt(end))) ++end;
    return {from: Pos(pos.line, start), to: Pos(pos.line, end), word: line.slice(start, end)};
  }

  cmds.selectNextOccurrence = function(cm) {
    var from = cm.getCursor("from"), to = cm.getCursor("to");
    var fullWord = cm.state.sublimeFindFullWord == cm.doc.sel;
    if (CodeMirror.cmpPos(from, to) == 0) {
      var word = wordAt(cm, from);
      if (!word.word) return;
      cm.setSelection(word.from, word.to);
      fullWord = true;
    } else {
      var text = cm.getRange(from, to);
      var query = fullWord ? new RegExp("\\b" + text + "\\b") : text;
      var cur = cm.getSearchCursor(query, to);
      var found = cur.findNext();
      if (!found) {
        cur = cm.getSearchCursor(query, Pos(cm.firstLine(), 0));
        found = cur.findNext();
      }
      if (!found || isSelectedRange(cm.listSelections(), cur.from(), cur.to()))
        return CodeMirror.Pass
      cm.addSelection(cur.from(), cur.to());
    }
    if (fullWord)
      cm.state.sublimeFindFullWord = cm.doc.sel;
  };

  function addCursorToSelection(cm, dir) {
    var ranges = cm.listSelections(), newRanges = [];
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      var newAnchor = cm.findPosV(
          range.anchor, dir, "line", range.anchor.goalColumn);
      var newHead = cm.findPosV(
          range.head, dir, "line", range.head.goalColumn);
      newAnchor.goalColumn = range.anchor.goalColumn != null ?
          range.anchor.goalColumn : cm.cursorCoords(range.anchor, "div").left;
      newHead.goalColumn = range.head.goalColumn != null ?
          range.head.goalColumn : cm.cursorCoords(range.head, "div").left;
      var newRange = {anchor: newAnchor, head: newHead};
      newRanges.push(range);
      newRanges.push(newRange);
    }
    cm.setSelections(newRanges);
  }
  cmds.addCursorToPrevLine = function(cm) { addCursorToSelection(cm, -1); };
  cmds.addCursorToNextLine = function(cm) { addCursorToSelection(cm, 1); };

  function isSelectedRange(ranges, from, to) {
    for (var i = 0; i < ranges.length; i++)
      if (ranges[i].from() == from && ranges[i].to() == to) return true
    return false
  }

  var mirror = "(){}[]";
  function selectBetweenBrackets(cm) {
    var ranges = cm.listSelections(), newRanges = []
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i], pos = range.head, opening = cm.scanForBracket(pos, -1);
      if (!opening) return false;
      for (;;) {
        var closing = cm.scanForBracket(pos, 1);
        if (!closing) return false;
        if (closing.ch == mirror.charAt(mirror.indexOf(opening.ch) + 1)) {
          var startPos = Pos(opening.pos.line, opening.pos.ch + 1);
          if (CodeMirror.cmpPos(startPos, range.from()) == 0 &&
              CodeMirror.cmpPos(closing.pos, range.to()) == 0) {
            opening = cm.scanForBracket(opening.pos, -1);
            if (!opening) return false;
          } else {
            newRanges.push({anchor: startPos, head: closing.pos});
            break;
          }
        }
        pos = Pos(closing.pos.line, closing.pos.ch + 1);
      }
    }
    cm.setSelections(newRanges);
    return true;
  }

  cmds.selectScope = function(cm) {
    selectBetweenBrackets(cm) || cm.execCommand("selectAll");
  };
  cmds.selectBetweenBrackets = function(cm) {
    if (!selectBetweenBrackets(cm)) return CodeMirror.Pass;
  };

  cmds.goToBracket = function(cm) {
    cm.extendSelectionsBy(function(range) {
      var next = cm.scanForBracket(range.head, 1);
      if (next && CodeMirror.cmpPos(next.pos, range.head) != 0) return next.pos;
      var prev = cm.scanForBracket(range.head, -1);
      return prev && Pos(prev.pos.line, prev.pos.ch + 1) || range.head;
    });
  };

  cmds.swapLineUp = function(cm) {
    if (cm.isReadOnly()) return CodeMirror.Pass
    var ranges = cm.listSelections(), linesToMove = [], at = cm.firstLine() - 1, newSels = [];
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i], from = range.from().line - 1, to = range.to().line;
      newSels.push({anchor: Pos(range.anchor.line - 1, range.anchor.ch),
                    head: Pos(range.head.line - 1, range.head.ch)});
      if (range.to().ch == 0 && !range.empty()) --to;
      if (from > at) linesToMove.push(from, to);
      else if (linesToMove.length) linesToMove[linesToMove.length - 1] = to;
      at = to;
    }
    cm.operation(function() {
      for (var i = 0; i < linesToMove.length; i += 2) {
        var from = linesToMove[i], to = linesToMove[i + 1];
        var line = cm.getLine(from);
        cm.replaceRange("", Pos(from, 0), Pos(from + 1, 0), "+swapLine");
        if (to > cm.lastLine())
          cm.replaceRange("\n" + line, Pos(cm.lastLine()), null, "+swapLine");
        else
          cm.replaceRange(line + "\n", Pos(to, 0), null, "+swapLine");
      }
      cm.setSelections(newSels);
      cm.scrollIntoView();
    });
  };

  cmds.swapLineDown = function(cm) {
    if (cm.isReadOnly()) return CodeMirror.Pass
    var ranges = cm.listSelections(), linesToMove = [], at = cm.lastLine() + 1;
    for (var i = ranges.length - 1; i >= 0; i--) {
      var range = ranges[i], from = range.to().line + 1, to = range.from().line;
      if (range.to().ch == 0 && !range.empty()) from--;
      if (from < at) linesToMove.push(from, to);
      else if (linesToMove.length) linesToMove[linesToMove.length - 1] = to;
      at = to;
    }
    cm.operation(function() {
      for (var i = linesToMove.length - 2; i >= 0; i -= 2) {
        var from = linesToMove[i], to = linesToMove[i + 1];
        var line = cm.getLine(from);
        if (from == cm.lastLine())
          cm.replaceRange("", Pos(from - 1), Pos(from), "+swapLine");
        else
          cm.replaceRange("", Pos(from, 0), Pos(from + 1, 0), "+swapLine");
        cm.replaceRange(line + "\n", Pos(to, 0), null, "+swapLine");
      }
      cm.scrollIntoView();
    });
  };

  cmds.toggleCommentIndented = function(cm) {
    cm.toggleComment({ indent: true });
  }

  cmds.joinLines = function(cm) {
    var ranges = cm.listSelections(), joined = [];
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i], from = range.from();
      var start = from.line, end = range.to().line;
      while (i < ranges.length - 1 && ranges[i + 1].from().line == end)
        end = ranges[++i].to().line;
      joined.push({start: start, end: end, anchor: !range.empty() && from});
    }
    cm.operation(function() {
      var offset = 0, ranges = [];
      for (var i = 0; i < joined.length; i++) {
        var obj = joined[i];
        var anchor = obj.anchor && Pos(obj.anchor.line - offset, obj.anchor.ch), head;
        for (var line = obj.start; line <= obj.end; line++) {
          var actual = line - offset;
          if (line == obj.end) head = Pos(actual, cm.getLine(actual).length + 1);
          if (actual < cm.lastLine()) {
            cm.replaceRange(" ", Pos(actual), Pos(actual + 1, /^\s*/.exec(cm.getLine(actual + 1))[0].length));
            ++offset;
          }
        }
        ranges.push({anchor: anchor || head, head: head});
      }
      cm.setSelections(ranges, 0);
    });
  };

  cmds.duplicateLine = function(cm) {
    cm.operation(function() {
      var rangeCount = cm.listSelections().length;
      for (var i = 0; i < rangeCount; i++) {
        var range = cm.listSelections()[i];
        if (range.empty())
          cm.replaceRange(cm.getLine(range.head.line) + "\n", Pos(range.head.line, 0));
        else
          cm.replaceRange(cm.getRange(range.from(), range.to()), range.from());
      }
      cm.scrollIntoView();
    });
  };


  function sortLines(cm, caseSensitive) {
    if (cm.isReadOnly()) return CodeMirror.Pass
    var ranges = cm.listSelections(), toSort = [], selected;
    for (var i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      if (range.empty()) continue;
      var from = range.from().line, to = range.to().line;
      while (i < ranges.length - 1 && ranges[i + 1].from().line == to)
        to = ranges[++i].to().line;
      if (!ranges[i].to().ch) to--;
      toSort.push(from, to);
    }
    if (toSort.length) selected = true;
    else toSort.push(cm.firstLine(), cm.lastLine());

    cm.operation(function() {
      var ranges = [];
      for (var i = 0; i < toSort.length; i += 2) {
        var from = toSort[i], to = toSort[i + 1];
        var start = Pos(from, 0), end = Pos(to);
        var lines = cm.getRange(start, end, false);
        if (caseSensitive)
          lines.sort();
        else
          lines.sort(function(a, b) {
            var au = a.toUpperCase(), bu = b.toUpperCase();
            if (au != bu) { a = au; b = bu; }
            return a < b ? -1 : a == b ? 0 : 1;
          });
        cm.replaceRange(lines, start, end);
        if (selected) ranges.push({anchor: start, head: Pos(to + 1, 0)});
      }
      if (selected) cm.setSelections(ranges, 0);
    });
  }

  cmds.sortLines = function(cm) { sortLines(cm, true); };
  cmds.sortLinesInsensitive = function(cm) { sortLines(cm, false); };

  cmds.nextBookmark = function(cm) {
    var marks = cm.state.sublimeBookmarks;
    if (marks) while (marks.length) {
      var current = marks.shift();
      var found = current.find();
      if (found) {
        marks.push(current);
        return cm.setSelection(found.from, found.to);
      }
    }
  };

  cmds.prevBookmark = function(cm) {
    var marks = cm.state.sublimeBookmarks;
    if (marks) while (marks.length) {
      marks.unshift(marks.pop());
      var found = marks[marks.length - 1].find();
      if (!found)
        marks.pop();
      else
        return cm.setSelection(found.from, found.to);
    }
  };

  cmds.toggleBookmark = function(cm) {
    var ranges = cm.listSelections();
    var marks = cm.state.sublimeBookmarks || (cm.state.sublimeBookmarks = []);
    for (var i = 0; i < ranges.length; i++) {
      var from = ranges[i].from(), to = ranges[i].to();
      var found = ranges[i].empty() ? cm.findMarksAt(from) : cm.findMarks(from, to);
      for (var j = 0; j < found.length; j++) {
        if (found[j].sublimeBookmark) {
          found[j].clear();
          for (var k = 0; k < marks.length; k++)
            if (marks[k] == found[j])
              marks.splice(k--, 1);
          break;
        }
      }
      if (j == found.length)
        marks.push(cm.markText(from, to, {sublimeBookmark: true, clearWhenEmpty: false}));
    }
  };

  cmds.clearBookmarks = function(cm) {
    var marks = cm.state.sublimeBookmarks;
    if (marks) for (var i = 0; i < marks.length; i++) marks[i].clear();
    marks.length = 0;
  };

  cmds.selectBookmarks = function(cm) {
    var marks = cm.state.sublimeBookmarks, ranges = [];
    if (marks) for (var i = 0; i < marks.length; i++) {
      var found = marks[i].find();
      if (!found)
        marks.splice(i--, 0);
      else
        ranges.push({anchor: found.from, head: found.to});
    }
    if (ranges.length)
      cm.setSelections(ranges, 0);
  };

  function modifyWordOrSelection(cm, mod) {
    cm.operation(function() {
      var ranges = cm.listSelections(), indices = [], replacements = [];
      for (var i = 0; i < ranges.length; i++) {
        var range = ranges[i];
        if (range.empty()) { indices.push(i); replacements.push(""); }
        else replacements.push(mod(cm.getRange(range.from(), range.to())));
      }
      cm.replaceSelections(replacements, "around", "case");
      for (var i = indices.length - 1, at; i >= 0; i--) {
        var range = ranges[indices[i]];
        if (at && CodeMirror.cmpPos(range.head, at) > 0) continue;
        var word = wordAt(cm, range.head);
        at = word.from;
        cm.replaceRange(mod(word.word), word.from, word.to);
      }
    });
  }

  cmds.smartBackspace = function(cm) {
    if (cm.somethingSelected()) return CodeMirror.Pass;

    cm.operation(function() {
      var cursors = cm.listSelections();
      var indentUnit = cm.getOption("indentUnit");

      for (var i = cursors.length - 1; i >= 0; i--) {
        var cursor = cursors[i].head;
        var toStartOfLine = cm.getRange({line: cursor.line, ch: 0}, cursor);
        var column = CodeMirror.countColumn(toStartOfLine, null, cm.getOption("tabSize"));

        // Delete by one character by default
        var deletePos = cm.findPosH(cursor, -1, "char", false);

        if (toStartOfLine && !/\S/.test(toStartOfLine) && column % indentUnit == 0) {
          var prevIndent = new Pos(cursor.line,
            CodeMirror.findColumn(toStartOfLine, column - indentUnit, indentUnit));

          // Smart delete only if we found a valid prevIndent location
          if (prevIndent.ch != cursor.ch) deletePos = prevIndent;
        }

        cm.replaceRange("", deletePos, cursor, "+delete");
      }
    });
  };

  cmds.delLineRight = function(cm) {
    cm.operation(function() {
      var ranges = cm.listSelections();
      for (var i = ranges.length - 1; i >= 0; i--)
        cm.replaceRange("", ranges[i].anchor, Pos(ranges[i].to().line), "+delete");
      cm.scrollIntoView();
    });
  };

  cmds.upcaseAtCursor = function(cm) {
    modifyWordOrSelection(cm, function(str) { return str.toUpperCase(); });
  };
  cmds.downcaseAtCursor = function(cm) {
    modifyWordOrSelection(cm, function(str) { return str.toLowerCase(); });
  };

  cmds.setSublimeMark = function(cm) {
    if (cm.state.sublimeMark) cm.state.sublimeMark.clear();
    cm.state.sublimeMark = cm.setBookmark(cm.getCursor());
  };
  cmds.selectToSublimeMark = function(cm) {
    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
    if (found) cm.setSelection(cm.getCursor(), found);
  };
  cmds.deleteToSublimeMark = function(cm) {
    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
    if (found) {
      var from = cm.getCursor(), to = found;
      if (CodeMirror.cmpPos(from, to) > 0) { var tmp = to; to = from; from = tmp; }
      cm.state.sublimeKilled = cm.getRange(from, to);
      cm.replaceRange("", from, to);
    }
  };
  cmds.swapWithSublimeMark = function(cm) {
    var found = cm.state.sublimeMark && cm.state.sublimeMark.find();
    if (found) {
      cm.state.sublimeMark.clear();
      cm.state.sublimeMark = cm.setBookmark(cm.getCursor());
      cm.setCursor(found);
    }
  };
  cmds.sublimeYank = function(cm) {
    if (cm.state.sublimeKilled != null)
      cm.replaceSelection(cm.state.sublimeKilled, null, "paste");
  };

  cmds.showInCenter = function(cm) {
    var pos = cm.cursorCoords(null, "local");
    cm.scrollTo(null, (pos.top + pos.bottom) / 2 - cm.getScrollInfo().clientHeight / 2);
  };

  function getTarget(cm) {
    var from = cm.getCursor("from"), to = cm.getCursor("to");
    if (CodeMirror.cmpPos(from, to) == 0) {
      var word = wordAt(cm, from);
      if (!word.word) return;
      from = word.from;
      to = word.to;
    }
    return {from: from, to: to, query: cm.getRange(from, to), word: word};
  }

  function findAndGoTo(cm, forward) {
    var target = getTarget(cm);
    if (!target) return;
    var query = target.query;
    var cur = cm.getSearchCursor(query, forward ? target.to : target.from);

    if (forward ? cur.findNext() : cur.findPrevious()) {
      cm.setSelection(cur.from(), cur.to());
    } else {
      cur = cm.getSearchCursor(query, forward ? Pos(cm.firstLine(), 0)
                                              : cm.clipPos(Pos(cm.lastLine())));
      if (forward ? cur.findNext() : cur.findPrevious())
        cm.setSelection(cur.from(), cur.to());
      else if (target.word)
        cm.setSelection(target.from, target.to);
    }
  };
  cmds.findUnder = function(cm) { findAndGoTo(cm, true); };
  cmds.findUnderPrevious = function(cm) { findAndGoTo(cm,false); };
  cmds.findAllUnder = function(cm) {
    var target = getTarget(cm);
    if (!target) return;
    var cur = cm.getSearchCursor(target.query);
    var matches = [];
    var primaryIndex = -1;
    while (cur.findNext()) {
      matches.push({anchor: cur.from(), head: cur.to()});
      if (cur.from().line <= target.from.line && cur.from().ch <= target.from.ch)
        primaryIndex++;
    }
    cm.setSelections(matches, primaryIndex);
  };


  var keyMap = CodeMirror.keyMap;
  keyMap.macSublime = {
    "Cmd-Left": "goLineStartSmart",
    "Shift-Tab": "indentLess",
    "Shift-Ctrl-K": "deleteLine",
    "Alt-Q": "wrapLines",
    "Ctrl-Left": "goSubwordLeft",
    "Ctrl-Right": "goSubwordRight",
    "Ctrl-Alt-Up": "scrollLineUp",
    "Ctrl-Alt-Down": "scrollLineDown",
    "Cmd-L": "selectLine",
    "Shift-Cmd-L": "splitSelectionByLine",
    "Esc": "singleSelectionTop",
    "Cmd-Enter": "insertLineAfter",
    "Shift-Cmd-Enter": "insertLineBefore",
    "Cmd-D": "selectNextOccurrence",
    "Shift-Cmd-Space": "selectScope",
    "Shift-Cmd-M": "selectBetweenBrackets",
    "Cmd-M": "goToBracket",
    "Cmd-Ctrl-Up": "swapLineUp",
    "Cmd-Ctrl-Down": "swapLineDown",
    "Cmd-/": "toggleCommentIndented",
    "Cmd-J": "joinLines",
    "Shift-Cmd-D": "duplicateLine",
    "F9": "sortLines",
    "Cmd-F9": "sortLinesInsensitive",
    "F2": "nextBookmark",
    "Shift-F2": "prevBookmark",
    "Cmd-F2": "toggleBookmark",
    "Shift-Cmd-F2": "clearBookmarks",
    "Alt-F2": "selectBookmarks",
    "Backspace": "smartBackspace",
    "Cmd-K Cmd-K": "delLineRight",
    "Cmd-K Cmd-U": "upcaseAtCursor",
    "Cmd-K Cmd-L": "downcaseAtCursor",
    "Cmd-K Cmd-Space": "setSublimeMark",
    "Cmd-K Cmd-A": "selectToSublimeMark",
    "Cmd-K Cmd-W": "deleteToSublimeMark",
    "Cmd-K Cmd-X": "swapWithSublimeMark",
    "Cmd-K Cmd-Y": "sublimeYank",
    "Cmd-K Cmd-C": "showInCenter",
    "Cmd-K Cmd-G": "clearBookmarks",
    "Cmd-K Cmd-Backspace": "delLineLeft",
    "Cmd-K Cmd-0": "unfoldAll",
    "Cmd-K Cmd-J": "unfoldAll",
    "Ctrl-Shift-Up": "addCursorToPrevLine",
    "Ctrl-Shift-Down": "addCursorToNextLine",
    "Cmd-F3": "findUnder",
    "Shift-Cmd-F3": "findUnderPrevious",
    "Alt-F3": "findAllUnder",
    "Shift-Cmd-[": "fold",
    "Shift-Cmd-]": "unfold",
    "Cmd-I": "findIncremental",
    "Shift-Cmd-I": "findIncrementalReverse",
    "Cmd-H": "replace",
    "F3": "findNext",
    "Shift-F3": "findPrev",
    "fallthrough": "macDefault"
  };
  CodeMirror.normalizeKeyMap(keyMap.macSublime);

  keyMap.pcSublime = {
    "Shift-Tab": "indentLess",
    "Shift-Ctrl-K": "deleteLine",
    "Alt-Q": "wrapLines",
    "Ctrl-T": "transposeChars",
    "Alt-Left": "goSubwordLeft",
    "Alt-Right": "goSubwordRight",
    "Ctrl-Up": "scrollLineUp",
    "Ctrl-Down": "scrollLineDown",
    "Ctrl-L": "selectLine",
    "Shift-Ctrl-L": "splitSelectionByLine",
    "Esc": "singleSelectionTop",
    "Ctrl-Enter": "insertLineAfter",
    "Shift-Ctrl-Enter": "insertLineBefore",
    "Ctrl-D": "selectNextOccurrence",
    "Shift-Ctrl-Space": "selectScope",
    "Shift-Ctrl-M": "selectBetweenBrackets",
    "Ctrl-M": "goToBracket",
    "Shift-Ctrl-Up": "swapLineUp",
    "Shift-Ctrl-Down": "swapLineDown",
    "Ctrl-/": "toggleCommentIndented",
    "Ctrl-J": "joinLines",
    "Shift-Ctrl-D": "duplicateLine",
    "F9": "sortLines",
    "Ctrl-F9": "sortLinesInsensitive",
    "F2": "nextBookmark",
    "Shift-F2": "prevBookmark",
    "Ctrl-F2": "toggleBookmark",
    "Shift-Ctrl-F2": "clearBookmarks",
    "Alt-F2": "selectBookmarks",
    "Backspace": "smartBackspace",
    "Ctrl-K Ctrl-K": "delLineRight",
    "Ctrl-K Ctrl-U": "upcaseAtCursor",
    "Ctrl-K Ctrl-L": "downcaseAtCursor",
    "Ctrl-K Ctrl-Space": "setSublimeMark",
    "Ctrl-K Ctrl-A": "selectToSublimeMark",
    "Ctrl-K Ctrl-W": "deleteToSublimeMark",
    "Ctrl-K Ctrl-X": "swapWithSublimeMark",
    "Ctrl-K Ctrl-Y": "sublimeYank",
    "Ctrl-K Ctrl-C": "showInCenter",
    "Ctrl-K Ctrl-G": "clearBookmarks",
    "Ctrl-K Ctrl-Backspace": "delLineLeft",
    "Ctrl-K Ctrl-0": "unfoldAll",
    "Ctrl-K Ctrl-J": "unfoldAll",
    "Ctrl-Alt-Up": "addCursorToPrevLine",
    "Ctrl-Alt-Down": "addCursorToNextLine",
    "Ctrl-F3": "findUnder",
    "Shift-Ctrl-F3": "findUnderPrevious",
    "Alt-F3": "findAllUnder",
    "Shift-Ctrl-[": "fold",
    "Shift-Ctrl-]": "unfold",
    "Ctrl-I": "findIncremental",
    "Shift-Ctrl-I": "findIncrementalReverse",
    "Ctrl-H": "replace",
    "F3": "findNext",
    "Shift-F3": "findPrev",
    "fallthrough": "pcDefault"
  };
  CodeMirror.normalizeKeyMap(keyMap.pcSublime);

  var mac = keyMap.default == keyMap.macDefault;
  keyMap.sublime = mac ? keyMap.macSublime : keyMap.pcSublime;
});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(0))
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod)
  else // Plain browser env
    mod(CodeMirror)
})(function(CodeMirror) {
  "use strict"
  var Pos = CodeMirror.Pos

  function regexpFlags(regexp) {
    var flags = regexp.flags
    return flags != null ? flags : (regexp.ignoreCase ? "i" : "")
      + (regexp.global ? "g" : "")
      + (regexp.multiline ? "m" : "")
  }

  function ensureFlags(regexp, flags) {
    var current = regexpFlags(regexp), target = current
    for (var i = 0; i < flags.length; i++) if (target.indexOf(flags.charAt(i)) == -1)
      target += flags.charAt(i)
    return current == target ? regexp : new RegExp(regexp.source, target)
  }

  function maybeMultiline(regexp) {
    return /\\s|\\n|\n|\\W|\\D|\[\^/.test(regexp.source)
  }

  function searchRegexpForward(doc, regexp, start) {
    regexp = ensureFlags(regexp, "g")
    for (var line = start.line, ch = start.ch, last = doc.lastLine(); line <= last; line++, ch = 0) {
      regexp.lastIndex = ch
      var string = doc.getLine(line), match = regexp.exec(string)
      if (match)
        return {from: Pos(line, match.index),
                to: Pos(line, match.index + match[0].length),
                match: match}
    }
  }

  function searchRegexpForwardMultiline(doc, regexp, start) {
    if (!maybeMultiline(regexp)) return searchRegexpForward(doc, regexp, start)

    regexp = ensureFlags(regexp, "gm")
    var string, chunk = 1
    for (var line = start.line, last = doc.lastLine(); line <= last;) {
      // This grows the search buffer in exponentially-sized chunks
      // between matches, so that nearby matches are fast and don't
      // require concatenating the whole document (in case we're
      // searching for something that has tons of matches), but at the
      // same time, the amount of retries is limited.
      for (var i = 0; i < chunk; i++) {
        if (line > last) break
        var curLine = doc.getLine(line++)
        string = string == null ? curLine : string + "\n" + curLine
      }
      chunk = chunk * 2
      regexp.lastIndex = start.ch
      var match = regexp.exec(string)
      if (match) {
        var before = string.slice(0, match.index).split("\n"), inside = match[0].split("\n")
        var startLine = start.line + before.length - 1, startCh = before[before.length - 1].length
        return {from: Pos(startLine, startCh),
                to: Pos(startLine + inside.length - 1,
                        inside.length == 1 ? startCh + inside[0].length : inside[inside.length - 1].length),
                match: match}
      }
    }
  }

  function lastMatchIn(string, regexp) {
    var cutOff = 0, match
    for (;;) {
      regexp.lastIndex = cutOff
      var newMatch = regexp.exec(string)
      if (!newMatch) return match
      match = newMatch
      cutOff = match.index + (match[0].length || 1)
      if (cutOff == string.length) return match
    }
  }

  function searchRegexpBackward(doc, regexp, start) {
    regexp = ensureFlags(regexp, "g")
    for (var line = start.line, ch = start.ch, first = doc.firstLine(); line >= first; line--, ch = -1) {
      var string = doc.getLine(line)
      if (ch > -1) string = string.slice(0, ch)
      var match = lastMatchIn(string, regexp)
      if (match)
        return {from: Pos(line, match.index),
                to: Pos(line, match.index + match[0].length),
                match: match}
    }
  }

  function searchRegexpBackwardMultiline(doc, regexp, start) {
    regexp = ensureFlags(regexp, "gm")
    var string, chunk = 1
    for (var line = start.line, first = doc.firstLine(); line >= first;) {
      for (var i = 0; i < chunk; i++) {
        var curLine = doc.getLine(line--)
        string = string == null ? curLine.slice(0, start.ch) : curLine + "\n" + string
      }
      chunk *= 2

      var match = lastMatchIn(string, regexp)
      if (match) {
        var before = string.slice(0, match.index).split("\n"), inside = match[0].split("\n")
        var startLine = line + before.length, startCh = before[before.length - 1].length
        return {from: Pos(startLine, startCh),
                to: Pos(startLine + inside.length - 1,
                        inside.length == 1 ? startCh + inside[0].length : inside[inside.length - 1].length),
                match: match}
      }
    }
  }

  var doFold, noFold
  if (String.prototype.normalize) {
    doFold = function(str) { return str.normalize("NFD").toLowerCase() }
    noFold = function(str) { return str.normalize("NFD") }
  } else {
    doFold = function(str) { return str.toLowerCase() }
    noFold = function(str) { return str }
  }

  // Maps a position in a case-folded line back to a position in the original line
  // (compensating for codepoints increasing in number during folding)
  function adjustPos(orig, folded, pos, foldFunc) {
    if (orig.length == folded.length) return pos
    for (var min = 0, max = pos + Math.max(0, orig.length - folded.length);;) {
      if (min == max) return min
      var mid = (min + max) >> 1
      var len = foldFunc(orig.slice(0, mid)).length
      if (len == pos) return mid
      else if (len > pos) max = mid
      else min = mid + 1
    }
  }

  function searchStringForward(doc, query, start, caseFold) {
    // Empty string would match anything and never progress, so we
    // define it to match nothing instead.
    if (!query.length) return null
    var fold = caseFold ? doFold : noFold
    var lines = fold(query).split(/\r|\n\r?/)

    search: for (var line = start.line, ch = start.ch, last = doc.lastLine() + 1 - lines.length; line <= last; line++, ch = 0) {
      var orig = doc.getLine(line).slice(ch), string = fold(orig)
      if (lines.length == 1) {
        var found = string.indexOf(lines[0])
        if (found == -1) continue search
        var start = adjustPos(orig, string, found, fold) + ch
        return {from: Pos(line, adjustPos(orig, string, found, fold) + ch),
                to: Pos(line, adjustPos(orig, string, found + lines[0].length, fold) + ch)}
      } else {
        var cutFrom = string.length - lines[0].length
        if (string.slice(cutFrom) != lines[0]) continue search
        for (var i = 1; i < lines.length - 1; i++)
          if (fold(doc.getLine(line + i)) != lines[i]) continue search
        var end = doc.getLine(line + lines.length - 1), endString = fold(end), lastLine = lines[lines.length - 1]
        if (endString.slice(0, lastLine.length) != lastLine) continue search
        return {from: Pos(line, adjustPos(orig, string, cutFrom, fold) + ch),
                to: Pos(line + lines.length - 1, adjustPos(end, endString, lastLine.length, fold))}
      }
    }
  }

  function searchStringBackward(doc, query, start, caseFold) {
    if (!query.length) return null
    var fold = caseFold ? doFold : noFold
    var lines = fold(query).split(/\r|\n\r?/)

    search: for (var line = start.line, ch = start.ch, first = doc.firstLine() - 1 + lines.length; line >= first; line--, ch = -1) {
      var orig = doc.getLine(line)
      if (ch > -1) orig = orig.slice(0, ch)
      var string = fold(orig)
      if (lines.length == 1) {
        var found = string.lastIndexOf(lines[0])
        if (found == -1) continue search
        return {from: Pos(line, adjustPos(orig, string, found, fold)),
                to: Pos(line, adjustPos(orig, string, found + lines[0].length, fold))}
      } else {
        var lastLine = lines[lines.length - 1]
        if (string.slice(0, lastLine.length) != lastLine) continue search
        for (var i = 1, start = line - lines.length + 1; i < lines.length - 1; i++)
          if (fold(doc.getLine(start + i)) != lines[i]) continue search
        var top = doc.getLine(line + 1 - lines.length), topString = fold(top)
        if (topString.slice(topString.length - lines[0].length) != lines[0]) continue search
        return {from: Pos(line + 1 - lines.length, adjustPos(top, topString, top.length - lines[0].length, fold)),
                to: Pos(line, adjustPos(orig, string, lastLine.length, fold))}
      }
    }
  }

  function SearchCursor(doc, query, pos, options) {
    this.atOccurrence = false
    this.doc = doc
    pos = pos ? doc.clipPos(pos) : Pos(0, 0)
    this.pos = {from: pos, to: pos}

    var caseFold
    if (typeof options == "object") {
      caseFold = options.caseFold
    } else { // Backwards compat for when caseFold was the 4th argument
      caseFold = options
      options = null
    }

    if (typeof query == "string") {
      if (caseFold == null) caseFold = false
      this.matches = function(reverse, pos) {
        return (reverse ? searchStringBackward : searchStringForward)(doc, query, pos, caseFold)
      }
    } else {
      query = ensureFlags(query, "gm")
      if (!options || options.multiline !== false)
        this.matches = function(reverse, pos) {
          return (reverse ? searchRegexpBackwardMultiline : searchRegexpForwardMultiline)(doc, query, pos)
        }
      else
        this.matches = function(reverse, pos) {
          return (reverse ? searchRegexpBackward : searchRegexpForward)(doc, query, pos)
        }
    }
  }

  SearchCursor.prototype = {
    findNext: function() {return this.find(false)},
    findPrevious: function() {return this.find(true)},

    find: function(reverse) {
      var result = this.matches(reverse, this.doc.clipPos(reverse ? this.pos.from : this.pos.to))

      // Implements weird auto-growing behavior on null-matches for
      // backwards-compatiblity with the vim code (unfortunately)
      while (result && CodeMirror.cmpPos(result.from, result.to) == 0) {
        if (reverse) {
          if (result.from.ch) result.from = Pos(result.from.line, result.from.ch - 1)
          else if (result.from.line == this.doc.firstLine()) result = null
          else result = this.matches(reverse, this.doc.clipPos(Pos(result.from.line - 1)))
        } else {
          if (result.to.ch < this.doc.getLine(result.to.line).length) result.to = Pos(result.to.line, result.to.ch + 1)
          else if (result.to.line == this.doc.lastLine()) result = null
          else result = this.matches(reverse, Pos(result.to.line + 1, 0))
        }
      }

      if (result) {
        this.pos = result
        this.atOccurrence = true
        return this.pos.match || true
      } else {
        var end = Pos(reverse ? this.doc.firstLine() : this.doc.lastLine() + 1, 0)
        this.pos = {from: end, to: end}
        return this.atOccurrence = false
      }
    },

    from: function() {if (this.atOccurrence) return this.pos.from},
    to: function() {if (this.atOccurrence) return this.pos.to},

    replace: function(newText, origin) {
      if (!this.atOccurrence) return
      var lines = CodeMirror.splitLines(newText)
      this.doc.replaceRange(lines, this.pos.from, this.pos.to, origin)
      this.pos.to = Pos(this.pos.from.line + lines.length - 1,
                        lines[lines.length - 1].length + (lines.length == 1 ? this.pos.from.ch : 0))
    }
  }

  CodeMirror.defineExtension("getSearchCursor", function(query, pos, caseFold) {
    return new SearchCursor(this.doc, query, pos, caseFold)
  })
  CodeMirror.defineDocExtension("getSearchCursor", function(query, pos, caseFold) {
    return new SearchCursor(this, query, pos, caseFold)
  })

  CodeMirror.defineExtension("selectMatches", function(query, caseFold) {
    var ranges = []
    var cur = this.getSearchCursor(query, this.getCursor("from"), caseFold)
    while (cur.findNext()) {
      if (CodeMirror.cmpPos(cur.to(), this.getCursor("to")) > 0) break
      ranges.push({anchor: cur.from(), head: cur.to()})
    }
    if (ranges.length)
      this.setSelections(ranges, 0)
  })
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
  if (true) // CommonJS
    mod(__webpack_require__(0));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
  var ie_lt8 = /MSIE \d/.test(navigator.userAgent) &&
    (document.documentMode == null || document.documentMode < 8);

  var Pos = CodeMirror.Pos;

  var matching = {"(": ")>", ")": "(<", "[": "]>", "]": "[<", "{": "}>", "}": "{<"};

  function findMatchingBracket(cm, where, config) {
    var line = cm.getLineHandle(where.line), pos = where.ch - 1;
    var afterCursor = config && config.afterCursor
    if (afterCursor == null)
      afterCursor = /(^| )cm-fat-cursor($| )/.test(cm.getWrapperElement().className)

    // A cursor is defined as between two characters, but in in vim command mode
    // (i.e. not insert mode), the cursor is visually represented as a
    // highlighted box on top of the 2nd character. Otherwise, we allow matches
    // from before or after the cursor.
    var match = (!afterCursor && pos >= 0 && matching[line.text.charAt(pos)]) ||
        matching[line.text.charAt(++pos)];
    if (!match) return null;
    var dir = match.charAt(1) == ">" ? 1 : -1;
    if (config && config.strict && (dir > 0) != (pos == where.ch)) return null;
    var style = cm.getTokenTypeAt(Pos(where.line, pos + 1));

    var found = scanForBracket(cm, Pos(where.line, pos + (dir > 0 ? 1 : 0)), dir, style || null, config);
    if (found == null) return null;
    return {from: Pos(where.line, pos), to: found && found.pos,
            match: found && found.ch == match.charAt(0), forward: dir > 0};
  }

  // bracketRegex is used to specify which type of bracket to scan
  // should be a regexp, e.g. /[[\]]/
  //
  // Note: If "where" is on an open bracket, then this bracket is ignored.
  //
  // Returns false when no bracket was found, null when it reached
  // maxScanLines and gave up
  function scanForBracket(cm, where, dir, style, config) {
    var maxScanLen = (config && config.maxScanLineLength) || 10000;
    var maxScanLines = (config && config.maxScanLines) || 1000;

    var stack = [];
    var re = config && config.bracketRegex ? config.bracketRegex : /[(){}[\]]/;
    var lineEnd = dir > 0 ? Math.min(where.line + maxScanLines, cm.lastLine() + 1)
                          : Math.max(cm.firstLine() - 1, where.line - maxScanLines);
    for (var lineNo = where.line; lineNo != lineEnd; lineNo += dir) {
      var line = cm.getLine(lineNo);
      if (!line) continue;
      var pos = dir > 0 ? 0 : line.length - 1, end = dir > 0 ? line.length : -1;
      if (line.length > maxScanLen) continue;
      if (lineNo == where.line) pos = where.ch - (dir < 0 ? 1 : 0);
      for (; pos != end; pos += dir) {
        var ch = line.charAt(pos);
        if (re.test(ch) && (style === undefined || cm.getTokenTypeAt(Pos(lineNo, pos + 1)) == style)) {
          var match = matching[ch];
          if ((match.charAt(1) == ">") == (dir > 0)) stack.push(ch);
          else if (!stack.length) return {pos: Pos(lineNo, pos), ch: ch};
          else stack.pop();
        }
      }
    }
    return lineNo - dir == (dir > 0 ? cm.lastLine() : cm.firstLine()) ? false : null;
  }

  function matchBrackets(cm, autoclear, config) {
    // Disable brace matching in long lines, since it'll cause hugely slow updates
    var maxHighlightLen = cm.state.matchBrackets.maxHighlightLineLength || 1000;
    var marks = [], ranges = cm.listSelections();
    for (var i = 0; i < ranges.length; i++) {
      var match = ranges[i].empty() && findMatchingBracket(cm, ranges[i].head, config);
      if (match && cm.getLine(match.from.line).length <= maxHighlightLen) {
        var style = match.match ? "CodeMirror-matchingbracket" : "CodeMirror-nonmatchingbracket";
        marks.push(cm.markText(match.from, Pos(match.from.line, match.from.ch + 1), {className: style}));
        if (match.to && cm.getLine(match.to.line).length <= maxHighlightLen)
          marks.push(cm.markText(match.to, Pos(match.to.line, match.to.ch + 1), {className: style}));
      }
    }

    if (marks.length) {
      // Kludge to work around the IE bug from issue #1193, where text
      // input stops going to the textare whever this fires.
      if (ie_lt8 && cm.state.focused) cm.focus();

      var clear = function() {
        cm.operation(function() {
          for (var i = 0; i < marks.length; i++) marks[i].clear();
        });
      };
      if (autoclear) setTimeout(clear, 800);
      else return clear;
    }
  }

  function doMatchBrackets(cm) {
    cm.operation(function() {
      if (cm.state.matchBrackets.currentlyHighlighted) {
        cm.state.matchBrackets.currentlyHighlighted();
        cm.state.matchBrackets.currentlyHighlighted = null;
      }
      cm.state.matchBrackets.currentlyHighlighted = matchBrackets(cm, false, cm.state.matchBrackets);
    });
  }

  CodeMirror.defineOption("matchBrackets", false, function(cm, val, old) {
    if (old && old != CodeMirror.Init) {
      cm.off("cursorActivity", doMatchBrackets);
      if (cm.state.matchBrackets && cm.state.matchBrackets.currentlyHighlighted) {
        cm.state.matchBrackets.currentlyHighlighted();
        cm.state.matchBrackets.currentlyHighlighted = null;
      }
    }
    if (val) {
      cm.state.matchBrackets = typeof val == "object" ? val : {};
      cm.on("cursorActivity", doMatchBrackets);
    }
  });

  CodeMirror.defineExtension("matchBrackets", function() {matchBrackets(this, true);});
  CodeMirror.defineExtension("findMatchingBracket", function(pos, config, oldConfig){
    // Backwards-compatibility kludge
    if (oldConfig || typeof config == "boolean") {
      if (!oldConfig) {
        config = config ? {strict: true} : null
      } else {
        oldConfig.strict = config
        config = oldConfig
      }
    }
    return findMatchingBracket(this, pos, config)
  });
  CodeMirror.defineExtension("scanForBracket", function(pos, dir, style, config){
    return scanForBracket(this, pos, dir, style, config);
  });
});


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {"config":"Ly9wYV9kZXZpY2UgNwoKLy8gcGxheSBhIHNvdW5kIGZvciBwdW5jdHVhdGlvbiwgcmF0aGVyIHRoYW4gc3BlYWsgaXRzIG5hbWUKLy9zb3VuZGljb24gXyggL3Vzci9zaGFyZS9zb3VuZHMvc291bmQtaWNvbnMvbGVmdC1yb3VuZC1icmFja2V0Ci8vc291bmRpY29uIF8pIC91c3Ivc2hhcmUvc291bmRzL3NvdW5kLWljb25zL3JpZ2h0LXJvdW5kLWJyYWNrZXQKLy9zb3VuZGljb24gX1sgL3Vzci9zaGFyZS9zb3VuZHMvc291bmQtaWNvbnMvbGVmdC1zcXVhcmUtYnJhY2tldAovL3NvdW5kaWNvbiBfXSAvdXNyL3NoYXJlL3NvdW5kcy9zb3VuZC1pY29ucy9yaWdodC1zcXVhcmUtYnJhY2tldAovL3NvdW5kaWNvbiBfeyAvdXNyL3NoYXJlL3NvdW5kcy9zb3VuZC1pY29ucy9sZWZ0LWJyYWNlCi8vc291bmRpY29uIF99IC91c3Ivc2hhcmUvc291bmRzL3NvdW5kLWljb25zL3JpZ2h0LWJyYWNlCg==","phontab":"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","phonindex":"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","phondata":"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","intonations":"czEAAAAAAAAAAAAAAAAAAAAoGAgAAAAALjkAEAAA/1Ay/wQF+Pj4+/v7AEAIAEYSGAwARhIYDAAAAAAAAAAAAAAAAABjMQAAAAAAAAAAAAAAAAAAACgYCAAAAAAuOQAQAAD/UC7/BAX4+Pj7+/sEUBIGThYiNAZOFiI0AAAAAAAAAAAAAAAAAHExAAAAAAAAAAAAAAAAAAAQKBgIAAAAAC45ABAAAP9LK/8EBfn5+QAAAARYFgZSFiJCBlIWIkIAAAAAAAAAAAAAAAAAZTEAAAAAAAAAAAAAAAAAAAo0IBQKAAAALjkAEAAA/1oy/wMF9/f3AAAAAFwIAFxQTAgAXFBMCAAAAAAAAAAAAAAAAABzMgAAAAAAAAAAAAAAAAAAACEYCAAAAAAuOQAQAABLQTz/BAX7+Pj7+/sALBwAMioiHAAyKiIcAAAAAAAAAAAAAAAAAGMyAAAAAAAAAAAAAAAAAAAAKBgIAAAAAC45ABAAAP9BMv8EBfn4+Pn7+wI8KgI3KiI0AjcqIjQAAAAAAAAAAAAAAAAAcTIAAAAAAAAAAAAAAAAAABAoGAgAAAAAKEsAEAAA/0sr/wQF+fn5+QAAAkYyAiMtPEYCIy08RgAAAAAAAAAAAAAAAABlMgAAAAAAAAAAAAAAAAAACjQgFAoAAAAuOQAQAAD/WjL/AwX59/f5AAAAXAgAXFBMCABcUEwIAAAAAAAAAAAAAAAAAHMzAAAAAAAAAAAAAAAAAAAAKBgIAAAAAC45ABAAAP9QMv8EBfn4+Pn7+wBACABGEhgMAEYSGAwAAAAAAAAAAAAAAAAAYzMAAAAAAAAAAAAAAAAAAAAoGAgAAAAALjkAEAAA/0Ye/wQF+fj4+fv7BEsyAEYSGAwARhIYDAAAAAAAAAAAAAAAAABxMwAAAAAAAAAAAAAAAAAAECgYCAAAAAAuOQAQAAD/Syv/BAX5+fn5AAAEWBYGUhYiQgZSFiJCAAAAAAAAAAAAAAAAAGUzAAAAAAAAAAAAAAAAAAAKNCAUCgAAAC45ABAAAP9aMv8DBfn39/kAAABcCABcUEwIAFxQTAgAAAAAAAAAAAAAAAAA"}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {"voice_id":"en/en-us","dict_id":"en_dict","dict":"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","voice":"Ly8gbW92aW5nIHRvd2FyZHMgVVMgRW5nbGlzaApuYW1lIGVuZ2xpc2gtdXMKbGFuZ3VhZ2UgZW4tdXMgMgpsYW5ndWFnZSBlbi1yCmxhbmd1YWdlIGVuIDMKZ2VuZGVyIG1hbGUKCnBob25lbWVzIGVuLXVzCmRpY3RydWxlcyAzIDYKb3B0aW9uIHJlZHVjZV90IDEKCnN0cmVzc0xlbmd0aCAxNDUgMTI1IDE5MCAxNzAgMCAwIDI2MCAyOTAKc3RyZXNzQW1wICAxNyAxNiAgMTkgMTkgIDE5IDE5ICAyMSAxOQoKcmVwbGFjZSAwMyBJICBpCnJlcGxhY2UgMDMgSTIgaQpyZXBsYWNlIDAzIEAgIEAvCg=="}

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.js